var I8 = Object.defineProperty;
var m8 = (o, g, c) => g in o ? I8(o, g, { enumerable: !0, configurable: !0, writable: !0, value: c }) : o[g] = c;
var Vi = (o, g, c) => m8(o, typeof g != "symbol" ? g + "" : g, c);
import { p as process$1, W as WalletError, E as ERROR_CODES, N as Network, i as isAccountChangeEvent, o as okxLogo, M as MONOCHROME_MARK_BACKGROUND, g as getAppKitState, r as registerManualAppKitConfig, f as failInitialization, a as NETWORK_CHANGE_EVENT, A as APPKIT_OPEN_EVENT, b as isUserRejectionMessage, c as APPKIT_BTC_CONNECTOR_ID, t as trackProviderIdentityChanges, D as DISCONNECT_EVENT, d as removeProviderListener, O as ONEKEY_BRAND_GREEN, m as metadata$h, v as validateAppKitInitialization, e as createAppKitCapabilities, h as createETHWagmiAdapter, s as setAppKitState, j as assertAppKitCapabilities, u as useChainConnector, k as createExternalWallet, l as createAccountStorage, n as ONE_HOUR, q as useAppKitOpenListener, L as LifeCycleHooksProvider, C as ChainProvider, w as WalletDialog, x as useWalletConnect, y as ACCOUNT_CHANGE_EVENTS, z as useVisibilityCheck } from "./ETHWalletProvider-CP5ssaJi.js";
import { J as T3, P as R3, S as x3, K as D3, U as N3, V as P3, Q as q3, G as O3, H as Q3, R as U3, I as M3, T as F3, F as L3, B as H3 } from "./ETHWalletProvider-CP5ssaJi.js";
import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import { Text } from "@babylonlabs-io/core-ui";
import * as pA from "bitcoinjs-lib";
import { Psbt, networks as networks$2, address as address$2, Transaction as Transaction$1, initEccLib, payments as payments$1, crypto as crypto$8 } from "bitcoinjs-lib";
import Y, { SupportedResult, ReadStatus, PlayStatus, viewSdk } from "@keystonehq/sdk";
import { SigningStargateClient } from "@cosmjs/stargate";
import kt, { createContext, useMemo, useReducer, useEffect, useDebugValue, useCallback, useContext, useState, useRef, createElement, Suspense, memo } from "react";
import { createPortal } from "react-dom";
import { twJoin } from "tailwind-merge";
import { bitcoinSignet, bitcoin as bitcoin$2 } from "@reown/appkit/networks";
import { connectDmkSession, disconnectDmkSession, createDmkApduSender, createDmkRawApduSender, refreshSessionApp, getXOnlyPublicKeyHex, getMasterFingerprintHex, getExtendedPublicKey, deriveReceiveXOnlyHex, buildDefaultTaprootPolicy, deriveContextHash, assertDepositTermsDeviceCompatible, getVaultState, intentFingerprint, DepositTermsRejectedError, approveVaultIntent, classifyRefundPsbt, assertRefundPsbtSignable, classifyReclaimPsbt, augmentPsbtForRefund, augmentPsbtForReclaim, classifyDelegatedClaimPsbt, augmentPsbtForDelegatedClaim, prepareSignPsbt, augmentPsbtForWalletPolicy, signPreparedVaultPsbt, isLedgerDeviceLockedError, isLedgerSignPsbtAbortedError, isSessionAlive, buildPopPsbtHex, encodeIntentScalars, encodeKeyBatches, encodeIntentGroup, isLedgerDeviceError, SW_BAD_STATE, SW_CAP_EXCEEDED, isLedgerYieldMismatchError, isLedgerSignPsbtIncompleteError, isLedgerSignPsbtProtocolError, isLedgerUserRefusedError, SW_CLA_NOT_SUPPORTED, SW_INS_NOT_SUPPORTED } from "@babylonlabs-io/ledger-vault-signer";
import { BitcoinAdapter } from "@reown/appkit-adapter-bitcoin";
import { modal, createAppKit, useAppKitAccount } from "@reown/appkit/react";
import { useQuery } from "@tanstack/react-query";
var buffer$3 = {}, base64Js$1 = {};
base64Js$1.byteLength = byteLength;
base64Js$1.toByteArray = toByteArray;
base64Js$1.fromByteArray = fromByteArray;
var lookup = [], revLookup = [], Arr = typeof Uint8Array < "u" ? Uint8Array : Array, code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for (var i$2 = 0, len = code.length; i$2 < len; ++i$2)
  lookup[i$2] = code[i$2], revLookup[code.charCodeAt(i$2)] = i$2;
revLookup[45] = 62;
revLookup[95] = 63;
function getLens(o) {
  var g = o.length;
  if (g % 4 > 0)
    throw new Error("Invalid string. Length must be a multiple of 4");
  var c = o.indexOf("=");
  c === -1 && (c = g);
  var y = c === g ? 0 : 4 - c % 4;
  return [c, y];
}
function byteLength(o) {
  var g = getLens(o), c = g[0], y = g[1];
  return (c + y) * 3 / 4 - y;
}
function _byteLength(o, g, c) {
  return (g + c) * 3 / 4 - c;
}
function toByteArray(o) {
  var g, c = getLens(o), y = c[0], t = c[1], d = new Arr(_byteLength(o, y, t)), E = 0, B = t > 0 ? y - 4 : y, D;
  for (D = 0; D < B; D += 4)
    g = revLookup[o.charCodeAt(D)] << 18 | revLookup[o.charCodeAt(D + 1)] << 12 | revLookup[o.charCodeAt(D + 2)] << 6 | revLookup[o.charCodeAt(D + 3)], d[E++] = g >> 16 & 255, d[E++] = g >> 8 & 255, d[E++] = g & 255;
  return t === 2 && (g = revLookup[o.charCodeAt(D)] << 2 | revLookup[o.charCodeAt(D + 1)] >> 4, d[E++] = g & 255), t === 1 && (g = revLookup[o.charCodeAt(D)] << 10 | revLookup[o.charCodeAt(D + 1)] << 4 | revLookup[o.charCodeAt(D + 2)] >> 2, d[E++] = g >> 8 & 255, d[E++] = g & 255), d;
}
function tripletToBase64(o) {
  return lookup[o >> 18 & 63] + lookup[o >> 12 & 63] + lookup[o >> 6 & 63] + lookup[o & 63];
}
function encodeChunk(o, g, c) {
  for (var y, t = [], d = g; d < c; d += 3)
    y = (o[d] << 16 & 16711680) + (o[d + 1] << 8 & 65280) + (o[d + 2] & 255), t.push(tripletToBase64(y));
  return t.join("");
}
function fromByteArray(o) {
  for (var g, c = o.length, y = c % 3, t = [], d = 16383, E = 0, B = c - y; E < B; E += d)
    t.push(encodeChunk(o, E, E + d > B ? B : E + d));
  return y === 1 ? (g = o[c - 1], t.push(
    lookup[g >> 2] + lookup[g << 4 & 63] + "=="
  )) : y === 2 && (g = (o[c - 2] << 8) + o[c - 1], t.push(
    lookup[g >> 10] + lookup[g >> 4 & 63] + lookup[g << 2 & 63] + "="
  )), t.join("");
}
var ieee754$1 = {};
ieee754$1.read = function(o, g, c, y, t) {
  var d, E, B = t * 8 - y - 1, D = (1 << B) - 1, x = D >> 1, v = -7, F = c ? t - 1 : 0, M = c ? -1 : 1, U = o[g + F];
  for (F += M, d = U & (1 << -v) - 1, U >>= -v, v += B; v > 0; d = d * 256 + o[g + F], F += M, v -= 8)
    ;
  for (E = d & (1 << -v) - 1, d >>= -v, v += y; v > 0; E = E * 256 + o[g + F], F += M, v -= 8)
    ;
  if (d === 0)
    d = 1 - x;
  else {
    if (d === D)
      return E ? NaN : (U ? -1 : 1) * (1 / 0);
    E = E + Math.pow(2, y), d = d - x;
  }
  return (U ? -1 : 1) * E * Math.pow(2, d - y);
};
ieee754$1.write = function(o, g, c, y, t, d) {
  var E, B, D, x = d * 8 - t - 1, v = (1 << x) - 1, F = v >> 1, M = t === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, U = y ? 0 : d - 1, L = y ? 1 : -1, H = g < 0 || g === 0 && 1 / g < 0 ? 1 : 0;
  for (g = Math.abs(g), isNaN(g) || g === 1 / 0 ? (B = isNaN(g) ? 1 : 0, E = v) : (E = Math.floor(Math.log(g) / Math.LN2), g * (D = Math.pow(2, -E)) < 1 && (E--, D *= 2), E + F >= 1 ? g += M / D : g += M * Math.pow(2, 1 - F), g * D >= 2 && (E++, D /= 2), E + F >= v ? (B = 0, E = v) : E + F >= 1 ? (B = (g * D - 1) * Math.pow(2, t), E = E + F) : (B = g * Math.pow(2, F - 1) * Math.pow(2, t), E = 0)); t >= 8; o[c + U] = B & 255, U += L, B /= 256, t -= 8)
    ;
  for (E = E << t | B, x += t; x > 0; o[c + U] = E & 255, U += L, E /= 256, x -= 8)
    ;
  o[c + U - L] |= H * 128;
};
(function(o) {
  const g = base64Js$1, c = ieee754$1, y = typeof Symbol == "function" && typeof Symbol.for == "function" ? Symbol.for("nodejs.util.inspect.custom") : null;
  o.Buffer = v, o.SlowBuffer = ze, o.INSPECT_MAX_BYTES = 50;
  const t = 2147483647;
  o.kMaxLength = t;
  const { Uint8Array: d, ArrayBuffer: E, SharedArrayBuffer: B } = globalThis;
  v.TYPED_ARRAY_SUPPORT = D(), !v.TYPED_ARRAY_SUPPORT && typeof console < "u" && typeof console.error == "function" && console.error(
    "This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."
  );
  function D() {
    try {
      const Cr = new d(1), Er = { foo: function() {
        return 42;
      } };
      return Object.setPrototypeOf(Er, d.prototype), Object.setPrototypeOf(Cr, Er), Cr.foo() === 42;
    } catch {
      return !1;
    }
  }
  Object.defineProperty(v.prototype, "parent", {
    enumerable: !0,
    get: function() {
      if (v.isBuffer(this))
        return this.buffer;
    }
  }), Object.defineProperty(v.prototype, "offset", {
    enumerable: !0,
    get: function() {
      if (v.isBuffer(this))
        return this.byteOffset;
    }
  });
  function x(Cr) {
    if (Cr > t)
      throw new RangeError('The value "' + Cr + '" is invalid for option "size"');
    const Er = new d(Cr);
    return Object.setPrototypeOf(Er, v.prototype), Er;
  }
  function v(Cr, Er, xr) {
    if (typeof Cr == "number") {
      if (typeof Er == "string")
        throw new TypeError(
          'The "string" argument must be of type string. Received type number'
        );
      return L(Cr);
    }
    return F(Cr, Er, xr);
  }
  v.poolSize = 8192;
  function F(Cr, Er, xr) {
    if (typeof Cr == "string")
      return H(Cr, Er);
    if (E.isView(Cr))
      return ge(Cr);
    if (Cr == null)
      throw new TypeError(
        "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof Cr
      );
    if (ti(Cr, E) || Cr && ti(Cr.buffer, E) || typeof B < "u" && (ti(Cr, B) || Cr && ti(Cr.buffer, B)))
      return Ie(Cr, Er, xr);
    if (typeof Cr == "number")
      throw new TypeError(
        'The "value" argument must not be of type number. Received type number'
      );
    const si = Cr.valueOf && Cr.valueOf();
    if (si != null && si !== Cr)
      return v.from(si, Er, xr);
    const Ci = Ee(Cr);
    if (Ci) return Ci;
    if (typeof Symbol < "u" && Symbol.toPrimitive != null && typeof Cr[Symbol.toPrimitive] == "function")
      return v.from(Cr[Symbol.toPrimitive]("string"), Er, xr);
    throw new TypeError(
      "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof Cr
    );
  }
  v.from = function(Cr, Er, xr) {
    return F(Cr, Er, xr);
  }, Object.setPrototypeOf(v.prototype, d.prototype), Object.setPrototypeOf(v, d);
  function M(Cr) {
    if (typeof Cr != "number")
      throw new TypeError('"size" argument must be of type number');
    if (Cr < 0)
      throw new RangeError('The value "' + Cr + '" is invalid for option "size"');
  }
  function U(Cr, Er, xr) {
    return M(Cr), Cr <= 0 ? x(Cr) : Er !== void 0 ? typeof xr == "string" ? x(Cr).fill(Er, xr) : x(Cr).fill(Er) : x(Cr);
  }
  v.alloc = function(Cr, Er, xr) {
    return U(Cr, Er, xr);
  };
  function L(Cr) {
    return M(Cr), x(Cr < 0 ? 0 : Se(Cr) | 0);
  }
  v.allocUnsafe = function(Cr) {
    return L(Cr);
  }, v.allocUnsafeSlow = function(Cr) {
    return L(Cr);
  };
  function H(Cr, Er) {
    if ((typeof Er != "string" || Er === "") && (Er = "utf8"), !v.isEncoding(Er))
      throw new TypeError("Unknown encoding: " + Er);
    const xr = He(Cr, Er) | 0;
    let si = x(xr);
    const Ci = si.write(Cr, Er);
    return Ci !== xr && (si = si.slice(0, Ci)), si;
  }
  function fe(Cr) {
    const Er = Cr.length < 0 ? 0 : Se(Cr.length) | 0, xr = x(Er);
    for (let si = 0; si < Er; si += 1)
      xr[si] = Cr[si] & 255;
    return xr;
  }
  function ge(Cr) {
    if (ti(Cr, d)) {
      const Er = new d(Cr);
      return Ie(Er.buffer, Er.byteOffset, Er.byteLength);
    }
    return fe(Cr);
  }
  function Ie(Cr, Er, xr) {
    if (Er < 0 || Cr.byteLength < Er)
      throw new RangeError('"offset" is outside of buffer bounds');
    if (Cr.byteLength < Er + (xr || 0))
      throw new RangeError('"length" is outside of buffer bounds');
    let si;
    return Er === void 0 && xr === void 0 ? si = new d(Cr) : xr === void 0 ? si = new d(Cr, Er) : si = new d(Cr, Er, xr), Object.setPrototypeOf(si, v.prototype), si;
  }
  function Ee(Cr) {
    if (v.isBuffer(Cr)) {
      const Er = Se(Cr.length) | 0, xr = x(Er);
      return xr.length === 0 || Cr.copy(xr, 0, 0, Er), xr;
    }
    if (Cr.length !== void 0)
      return typeof Cr.length != "number" || Lr(Cr.length) ? x(0) : fe(Cr);
    if (Cr.type === "Buffer" && Array.isArray(Cr.data))
      return fe(Cr.data);
  }
  function Se(Cr) {
    if (Cr >= t)
      throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + t.toString(16) + " bytes");
    return Cr | 0;
  }
  function ze(Cr) {
    return +Cr != Cr && (Cr = 0), v.alloc(+Cr);
  }
  v.isBuffer = function(Er) {
    return Er != null && Er._isBuffer === !0 && Er !== v.prototype;
  }, v.compare = function(Er, xr) {
    if (ti(Er, d) && (Er = v.from(Er, Er.offset, Er.byteLength)), ti(xr, d) && (xr = v.from(xr, xr.offset, xr.byteLength)), !v.isBuffer(Er) || !v.isBuffer(xr))
      throw new TypeError(
        'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
      );
    if (Er === xr) return 0;
    let si = Er.length, Ci = xr.length;
    for (let bi = 0, Ri = Math.min(si, Ci); bi < Ri; ++bi)
      if (Er[bi] !== xr[bi]) {
        si = Er[bi], Ci = xr[bi];
        break;
      }
    return si < Ci ? -1 : Ci < si ? 1 : 0;
  }, v.isEncoding = function(Er) {
    switch (String(Er).toLowerCase()) {
      case "hex":
      case "utf8":
      case "utf-8":
      case "ascii":
      case "latin1":
      case "binary":
      case "base64":
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return !0;
      default:
        return !1;
    }
  }, v.concat = function(Er, xr) {
    if (!Array.isArray(Er))
      throw new TypeError('"list" argument must be an Array of Buffers');
    if (Er.length === 0)
      return v.alloc(0);
    let si;
    if (xr === void 0)
      for (xr = 0, si = 0; si < Er.length; ++si)
        xr += Er[si].length;
    const Ci = v.allocUnsafe(xr);
    let bi = 0;
    for (si = 0; si < Er.length; ++si) {
      let Ri = Er[si];
      if (ti(Ri, d))
        bi + Ri.length > Ci.length ? (v.isBuffer(Ri) || (Ri = v.from(Ri)), Ri.copy(Ci, bi)) : d.prototype.set.call(
          Ci,
          Ri,
          bi
        );
      else if (v.isBuffer(Ri))
        Ri.copy(Ci, bi);
      else
        throw new TypeError('"list" argument must be an Array of Buffers');
      bi += Ri.length;
    }
    return Ci;
  };
  function He(Cr, Er) {
    if (v.isBuffer(Cr))
      return Cr.length;
    if (E.isView(Cr) || ti(Cr, E))
      return Cr.byteLength;
    if (typeof Cr != "string")
      throw new TypeError(
        'The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof Cr
      );
    const xr = Cr.length, si = arguments.length > 2 && arguments[2] === !0;
    if (!si && xr === 0) return 0;
    let Ci = !1;
    for (; ; )
      switch (Er) {
        case "ascii":
        case "latin1":
        case "binary":
          return xr;
        case "utf8":
        case "utf-8":
          return fi(Cr).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return xr * 2;
        case "hex":
          return xr >>> 1;
        case "base64":
          return oi(Cr).length;
        default:
          if (Ci)
            return si ? -1 : fi(Cr).length;
          Er = ("" + Er).toLowerCase(), Ci = !0;
      }
  }
  v.byteLength = He;
  function Pe(Cr, Er, xr) {
    let si = !1;
    if ((Er === void 0 || Er < 0) && (Er = 0), Er > this.length || ((xr === void 0 || xr > this.length) && (xr = this.length), xr <= 0) || (xr >>>= 0, Er >>>= 0, xr <= Er))
      return "";
    for (Cr || (Cr = "utf8"); ; )
      switch (Cr) {
        case "hex":
          return sr(this, Er, xr);
        case "utf8":
        case "utf-8":
          return st(this, Er, xr);
        case "ascii":
          return xt(this, Er, xr);
        case "latin1":
        case "binary":
          return ir(this, Er, xr);
        case "base64":
          return Et(this, Er, xr);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return yr(this, Er, xr);
        default:
          if (si) throw new TypeError("Unknown encoding: " + Cr);
          Cr = (Cr + "").toLowerCase(), si = !0;
      }
  }
  v.prototype._isBuffer = !0;
  function De(Cr, Er, xr) {
    const si = Cr[Er];
    Cr[Er] = Cr[xr], Cr[xr] = si;
  }
  v.prototype.swap16 = function() {
    const Er = this.length;
    if (Er % 2 !== 0)
      throw new RangeError("Buffer size must be a multiple of 16-bits");
    for (let xr = 0; xr < Er; xr += 2)
      De(this, xr, xr + 1);
    return this;
  }, v.prototype.swap32 = function() {
    const Er = this.length;
    if (Er % 4 !== 0)
      throw new RangeError("Buffer size must be a multiple of 32-bits");
    for (let xr = 0; xr < Er; xr += 4)
      De(this, xr, xr + 3), De(this, xr + 1, xr + 2);
    return this;
  }, v.prototype.swap64 = function() {
    const Er = this.length;
    if (Er % 8 !== 0)
      throw new RangeError("Buffer size must be a multiple of 64-bits");
    for (let xr = 0; xr < Er; xr += 8)
      De(this, xr, xr + 7), De(this, xr + 1, xr + 6), De(this, xr + 2, xr + 5), De(this, xr + 3, xr + 4);
    return this;
  }, v.prototype.toString = function() {
    const Er = this.length;
    return Er === 0 ? "" : arguments.length === 0 ? st(this, 0, Er) : Pe.apply(this, arguments);
  }, v.prototype.toLocaleString = v.prototype.toString, v.prototype.equals = function(Er) {
    if (!v.isBuffer(Er)) throw new TypeError("Argument must be a Buffer");
    return this === Er ? !0 : v.compare(this, Er) === 0;
  }, v.prototype.inspect = function() {
    let Er = "";
    const xr = o.INSPECT_MAX_BYTES;
    return Er = this.toString("hex", 0, xr).replace(/(.{2})/g, "$1 ").trim(), this.length > xr && (Er += " ... "), "<Buffer " + Er + ">";
  }, y && (v.prototype[y] = v.prototype.inspect), v.prototype.compare = function(Er, xr, si, Ci, bi) {
    if (ti(Er, d) && (Er = v.from(Er, Er.offset, Er.byteLength)), !v.isBuffer(Er))
      throw new TypeError(
        'The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof Er
      );
    if (xr === void 0 && (xr = 0), si === void 0 && (si = Er ? Er.length : 0), Ci === void 0 && (Ci = 0), bi === void 0 && (bi = this.length), xr < 0 || si > Er.length || Ci < 0 || bi > this.length)
      throw new RangeError("out of range index");
    if (Ci >= bi && xr >= si)
      return 0;
    if (Ci >= bi)
      return -1;
    if (xr >= si)
      return 1;
    if (xr >>>= 0, si >>>= 0, Ci >>>= 0, bi >>>= 0, this === Er) return 0;
    let Ri = bi - Ci, li = si - xr;
    const zi = Math.min(Ri, li), Kn = this.slice(Ci, bi), Hn = Er.slice(xr, si);
    for (let os = 0; os < zi; ++os)
      if (Kn[os] !== Hn[os]) {
        Ri = Kn[os], li = Hn[os];
        break;
      }
    return Ri < li ? -1 : li < Ri ? 1 : 0;
  };
  function ve(Cr, Er, xr, si, Ci) {
    if (Cr.length === 0) return -1;
    if (typeof xr == "string" ? (si = xr, xr = 0) : xr > 2147483647 ? xr = 2147483647 : xr < -2147483648 && (xr = -2147483648), xr = +xr, Lr(xr) && (xr = Ci ? 0 : Cr.length - 1), xr < 0 && (xr = Cr.length + xr), xr >= Cr.length) {
      if (Ci) return -1;
      xr = Cr.length - 1;
    } else if (xr < 0)
      if (Ci) xr = 0;
      else return -1;
    if (typeof Er == "string" && (Er = v.from(Er, si)), v.isBuffer(Er))
      return Er.length === 0 ? -1 : Fe(Cr, Er, xr, si, Ci);
    if (typeof Er == "number")
      return Er = Er & 255, typeof d.prototype.indexOf == "function" ? Ci ? d.prototype.indexOf.call(Cr, Er, xr) : d.prototype.lastIndexOf.call(Cr, Er, xr) : Fe(Cr, [Er], xr, si, Ci);
    throw new TypeError("val must be string, number or Buffer");
  }
  function Fe(Cr, Er, xr, si, Ci) {
    let bi = 1, Ri = Cr.length, li = Er.length;
    if (si !== void 0 && (si = String(si).toLowerCase(), si === "ucs2" || si === "ucs-2" || si === "utf16le" || si === "utf-16le")) {
      if (Cr.length < 2 || Er.length < 2)
        return -1;
      bi = 2, Ri /= 2, li /= 2, xr /= 2;
    }
    function zi(Hn, os) {
      return bi === 1 ? Hn[os] : Hn.readUInt16BE(os * bi);
    }
    let Kn;
    if (Ci) {
      let Hn = -1;
      for (Kn = xr; Kn < Ri; Kn++)
        if (zi(Cr, Kn) === zi(Er, Hn === -1 ? 0 : Kn - Hn)) {
          if (Hn === -1 && (Hn = Kn), Kn - Hn + 1 === li) return Hn * bi;
        } else
          Hn !== -1 && (Kn -= Kn - Hn), Hn = -1;
    } else
      for (xr + li > Ri && (xr = Ri - li), Kn = xr; Kn >= 0; Kn--) {
        let Hn = !0;
        for (let os = 0; os < li; os++)
          if (zi(Cr, Kn + os) !== zi(Er, os)) {
            Hn = !1;
            break;
          }
        if (Hn) return Kn;
      }
    return -1;
  }
  v.prototype.includes = function(Er, xr, si) {
    return this.indexOf(Er, xr, si) !== -1;
  }, v.prototype.indexOf = function(Er, xr, si) {
    return ve(this, Er, xr, si, !0);
  }, v.prototype.lastIndexOf = function(Er, xr, si) {
    return ve(this, Er, xr, si, !1);
  };
  function be(Cr, Er, xr, si) {
    xr = Number(xr) || 0;
    const Ci = Cr.length - xr;
    si ? (si = Number(si), si > Ci && (si = Ci)) : si = Ci;
    const bi = Er.length;
    si > bi / 2 && (si = bi / 2);
    let Ri;
    for (Ri = 0; Ri < si; ++Ri) {
      const li = parseInt(Er.substr(Ri * 2, 2), 16);
      if (Lr(li)) return Ri;
      Cr[xr + Ri] = li;
    }
    return Ri;
  }
  function Be(Cr, Er, xr, si) {
    return zr(fi(Er, Cr.length - xr), Cr, xr, si);
  }
  function ke(Cr, Er, xr, si) {
    return zr(Bi(Er), Cr, xr, si);
  }
  function xe(Cr, Er, xr, si) {
    return zr(oi(Er), Cr, xr, si);
  }
  function Ne(Cr, Er, xr, si) {
    return zr($r(Er, Cr.length - xr), Cr, xr, si);
  }
  v.prototype.write = function(Er, xr, si, Ci) {
    if (xr === void 0)
      Ci = "utf8", si = this.length, xr = 0;
    else if (si === void 0 && typeof xr == "string")
      Ci = xr, si = this.length, xr = 0;
    else if (isFinite(xr))
      xr = xr >>> 0, isFinite(si) ? (si = si >>> 0, Ci === void 0 && (Ci = "utf8")) : (Ci = si, si = void 0);
    else
      throw new Error(
        "Buffer.write(string, encoding, offset[, length]) is no longer supported"
      );
    const bi = this.length - xr;
    if ((si === void 0 || si > bi) && (si = bi), Er.length > 0 && (si < 0 || xr < 0) || xr > this.length)
      throw new RangeError("Attempt to write outside buffer bounds");
    Ci || (Ci = "utf8");
    let Ri = !1;
    for (; ; )
      switch (Ci) {
        case "hex":
          return be(this, Er, xr, si);
        case "utf8":
        case "utf-8":
          return Be(this, Er, xr, si);
        case "ascii":
        case "latin1":
        case "binary":
          return ke(this, Er, xr, si);
        case "base64":
          return xe(this, Er, xr, si);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return Ne(this, Er, xr, si);
        default:
          if (Ri) throw new TypeError("Unknown encoding: " + Ci);
          Ci = ("" + Ci).toLowerCase(), Ri = !0;
      }
  }, v.prototype.toJSON = function() {
    return {
      type: "Buffer",
      data: Array.prototype.slice.call(this._arr || this, 0)
    };
  };
  function Et(Cr, Er, xr) {
    return Er === 0 && xr === Cr.length ? g.fromByteArray(Cr) : g.fromByteArray(Cr.slice(Er, xr));
  }
  function st(Cr, Er, xr) {
    xr = Math.min(Cr.length, xr);
    const si = [];
    let Ci = Er;
    for (; Ci < xr; ) {
      const bi = Cr[Ci];
      let Ri = null, li = bi > 239 ? 4 : bi > 223 ? 3 : bi > 191 ? 2 : 1;
      if (Ci + li <= xr) {
        let zi, Kn, Hn, os;
        switch (li) {
          case 1:
            bi < 128 && (Ri = bi);
            break;
          case 2:
            zi = Cr[Ci + 1], (zi & 192) === 128 && (os = (bi & 31) << 6 | zi & 63, os > 127 && (Ri = os));
            break;
          case 3:
            zi = Cr[Ci + 1], Kn = Cr[Ci + 2], (zi & 192) === 128 && (Kn & 192) === 128 && (os = (bi & 15) << 12 | (zi & 63) << 6 | Kn & 63, os > 2047 && (os < 55296 || os > 57343) && (Ri = os));
            break;
          case 4:
            zi = Cr[Ci + 1], Kn = Cr[Ci + 2], Hn = Cr[Ci + 3], (zi & 192) === 128 && (Kn & 192) === 128 && (Hn & 192) === 128 && (os = (bi & 15) << 18 | (zi & 63) << 12 | (Kn & 63) << 6 | Hn & 63, os > 65535 && os < 1114112 && (Ri = os));
        }
      }
      Ri === null ? (Ri = 65533, li = 1) : Ri > 65535 && (Ri -= 65536, si.push(Ri >>> 10 & 1023 | 55296), Ri = 56320 | Ri & 1023), si.push(Ri), Ci += li;
    }
    return er(si);
  }
  const Dt = 4096;
  function er(Cr) {
    const Er = Cr.length;
    if (Er <= Dt)
      return String.fromCharCode.apply(String, Cr);
    let xr = "", si = 0;
    for (; si < Er; )
      xr += String.fromCharCode.apply(
        String,
        Cr.slice(si, si += Dt)
      );
    return xr;
  }
  function xt(Cr, Er, xr) {
    let si = "";
    xr = Math.min(Cr.length, xr);
    for (let Ci = Er; Ci < xr; ++Ci)
      si += String.fromCharCode(Cr[Ci] & 127);
    return si;
  }
  function ir(Cr, Er, xr) {
    let si = "";
    xr = Math.min(Cr.length, xr);
    for (let Ci = Er; Ci < xr; ++Ci)
      si += String.fromCharCode(Cr[Ci]);
    return si;
  }
  function sr(Cr, Er, xr) {
    const si = Cr.length;
    (!Er || Er < 0) && (Er = 0), (!xr || xr < 0 || xr > si) && (xr = si);
    let Ci = "";
    for (let bi = Er; bi < xr; ++bi)
      Ci += Rr[Cr[bi]];
    return Ci;
  }
  function yr(Cr, Er, xr) {
    const si = Cr.slice(Er, xr);
    let Ci = "";
    for (let bi = 0; bi < si.length - 1; bi += 2)
      Ci += String.fromCharCode(si[bi] + si[bi + 1] * 256);
    return Ci;
  }
  v.prototype.slice = function(Er, xr) {
    const si = this.length;
    Er = ~~Er, xr = xr === void 0 ? si : ~~xr, Er < 0 ? (Er += si, Er < 0 && (Er = 0)) : Er > si && (Er = si), xr < 0 ? (xr += si, xr < 0 && (xr = 0)) : xr > si && (xr = si), xr < Er && (xr = Er);
    const Ci = this.subarray(Er, xr);
    return Object.setPrototypeOf(Ci, v.prototype), Ci;
  };
  function wr(Cr, Er, xr) {
    if (Cr % 1 !== 0 || Cr < 0) throw new RangeError("offset is not uint");
    if (Cr + Er > xr) throw new RangeError("Trying to access beyond buffer length");
  }
  v.prototype.readUintLE = v.prototype.readUIntLE = function(Er, xr, si) {
    Er = Er >>> 0, xr = xr >>> 0, si || wr(Er, xr, this.length);
    let Ci = this[Er], bi = 1, Ri = 0;
    for (; ++Ri < xr && (bi *= 256); )
      Ci += this[Er + Ri] * bi;
    return Ci;
  }, v.prototype.readUintBE = v.prototype.readUIntBE = function(Er, xr, si) {
    Er = Er >>> 0, xr = xr >>> 0, si || wr(Er, xr, this.length);
    let Ci = this[Er + --xr], bi = 1;
    for (; xr > 0 && (bi *= 256); )
      Ci += this[Er + --xr] * bi;
    return Ci;
  }, v.prototype.readUint8 = v.prototype.readUInt8 = function(Er, xr) {
    return Er = Er >>> 0, xr || wr(Er, 1, this.length), this[Er];
  }, v.prototype.readUint16LE = v.prototype.readUInt16LE = function(Er, xr) {
    return Er = Er >>> 0, xr || wr(Er, 2, this.length), this[Er] | this[Er + 1] << 8;
  }, v.prototype.readUint16BE = v.prototype.readUInt16BE = function(Er, xr) {
    return Er = Er >>> 0, xr || wr(Er, 2, this.length), this[Er] << 8 | this[Er + 1];
  }, v.prototype.readUint32LE = v.prototype.readUInt32LE = function(Er, xr) {
    return Er = Er >>> 0, xr || wr(Er, 4, this.length), (this[Er] | this[Er + 1] << 8 | this[Er + 2] << 16) + this[Er + 3] * 16777216;
  }, v.prototype.readUint32BE = v.prototype.readUInt32BE = function(Er, xr) {
    return Er = Er >>> 0, xr || wr(Er, 4, this.length), this[Er] * 16777216 + (this[Er + 1] << 16 | this[Er + 2] << 8 | this[Er + 3]);
  }, v.prototype.readBigUInt64LE = Ir(function(Er) {
    Er = Er >>> 0, Ar(Er, "offset");
    const xr = this[Er], si = this[Er + 7];
    (xr === void 0 || si === void 0) && cr(Er, this.length - 8);
    const Ci = xr + this[++Er] * 2 ** 8 + this[++Er] * 2 ** 16 + this[++Er] * 2 ** 24, bi = this[++Er] + this[++Er] * 2 ** 8 + this[++Er] * 2 ** 16 + si * 2 ** 24;
    return BigInt(Ci) + (BigInt(bi) << BigInt(32));
  }), v.prototype.readBigUInt64BE = Ir(function(Er) {
    Er = Er >>> 0, Ar(Er, "offset");
    const xr = this[Er], si = this[Er + 7];
    (xr === void 0 || si === void 0) && cr(Er, this.length - 8);
    const Ci = xr * 2 ** 24 + this[++Er] * 2 ** 16 + this[++Er] * 2 ** 8 + this[++Er], bi = this[++Er] * 2 ** 24 + this[++Er] * 2 ** 16 + this[++Er] * 2 ** 8 + si;
    return (BigInt(Ci) << BigInt(32)) + BigInt(bi);
  }), v.prototype.readIntLE = function(Er, xr, si) {
    Er = Er >>> 0, xr = xr >>> 0, si || wr(Er, xr, this.length);
    let Ci = this[Er], bi = 1, Ri = 0;
    for (; ++Ri < xr && (bi *= 256); )
      Ci += this[Er + Ri] * bi;
    return bi *= 128, Ci >= bi && (Ci -= Math.pow(2, 8 * xr)), Ci;
  }, v.prototype.readIntBE = function(Er, xr, si) {
    Er = Er >>> 0, xr = xr >>> 0, si || wr(Er, xr, this.length);
    let Ci = xr, bi = 1, Ri = this[Er + --Ci];
    for (; Ci > 0 && (bi *= 256); )
      Ri += this[Er + --Ci] * bi;
    return bi *= 128, Ri >= bi && (Ri -= Math.pow(2, 8 * xr)), Ri;
  }, v.prototype.readInt8 = function(Er, xr) {
    return Er = Er >>> 0, xr || wr(Er, 1, this.length), this[Er] & 128 ? (255 - this[Er] + 1) * -1 : this[Er];
  }, v.prototype.readInt16LE = function(Er, xr) {
    Er = Er >>> 0, xr || wr(Er, 2, this.length);
    const si = this[Er] | this[Er + 1] << 8;
    return si & 32768 ? si | 4294901760 : si;
  }, v.prototype.readInt16BE = function(Er, xr) {
    Er = Er >>> 0, xr || wr(Er, 2, this.length);
    const si = this[Er + 1] | this[Er] << 8;
    return si & 32768 ? si | 4294901760 : si;
  }, v.prototype.readInt32LE = function(Er, xr) {
    return Er = Er >>> 0, xr || wr(Er, 4, this.length), this[Er] | this[Er + 1] << 8 | this[Er + 2] << 16 | this[Er + 3] << 24;
  }, v.prototype.readInt32BE = function(Er, xr) {
    return Er = Er >>> 0, xr || wr(Er, 4, this.length), this[Er] << 24 | this[Er + 1] << 16 | this[Er + 2] << 8 | this[Er + 3];
  }, v.prototype.readBigInt64LE = Ir(function(Er) {
    Er = Er >>> 0, Ar(Er, "offset");
    const xr = this[Er], si = this[Er + 7];
    (xr === void 0 || si === void 0) && cr(Er, this.length - 8);
    const Ci = this[Er + 4] + this[Er + 5] * 2 ** 8 + this[Er + 6] * 2 ** 16 + (si << 24);
    return (BigInt(Ci) << BigInt(32)) + BigInt(xr + this[++Er] * 2 ** 8 + this[++Er] * 2 ** 16 + this[++Er] * 2 ** 24);
  }), v.prototype.readBigInt64BE = Ir(function(Er) {
    Er = Er >>> 0, Ar(Er, "offset");
    const xr = this[Er], si = this[Er + 7];
    (xr === void 0 || si === void 0) && cr(Er, this.length - 8);
    const Ci = (xr << 24) + // Overflow
    this[++Er] * 2 ** 16 + this[++Er] * 2 ** 8 + this[++Er];
    return (BigInt(Ci) << BigInt(32)) + BigInt(this[++Er] * 2 ** 24 + this[++Er] * 2 ** 16 + this[++Er] * 2 ** 8 + si);
  }), v.prototype.readFloatLE = function(Er, xr) {
    return Er = Er >>> 0, xr || wr(Er, 4, this.length), c.read(this, Er, !0, 23, 4);
  }, v.prototype.readFloatBE = function(Er, xr) {
    return Er = Er >>> 0, xr || wr(Er, 4, this.length), c.read(this, Er, !1, 23, 4);
  }, v.prototype.readDoubleLE = function(Er, xr) {
    return Er = Er >>> 0, xr || wr(Er, 8, this.length), c.read(this, Er, !0, 52, 8);
  }, v.prototype.readDoubleBE = function(Er, xr) {
    return Er = Er >>> 0, xr || wr(Er, 8, this.length), c.read(this, Er, !1, 52, 8);
  };
  function qr(Cr, Er, xr, si, Ci, bi) {
    if (!v.isBuffer(Cr)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (Er > Ci || Er < bi) throw new RangeError('"value" argument is out of bounds');
    if (xr + si > Cr.length) throw new RangeError("Index out of range");
  }
  v.prototype.writeUintLE = v.prototype.writeUIntLE = function(Er, xr, si, Ci) {
    if (Er = +Er, xr = xr >>> 0, si = si >>> 0, !Ci) {
      const li = Math.pow(2, 8 * si) - 1;
      qr(this, Er, xr, si, li, 0);
    }
    let bi = 1, Ri = 0;
    for (this[xr] = Er & 255; ++Ri < si && (bi *= 256); )
      this[xr + Ri] = Er / bi & 255;
    return xr + si;
  }, v.prototype.writeUintBE = v.prototype.writeUIntBE = function(Er, xr, si, Ci) {
    if (Er = +Er, xr = xr >>> 0, si = si >>> 0, !Ci) {
      const li = Math.pow(2, 8 * si) - 1;
      qr(this, Er, xr, si, li, 0);
    }
    let bi = si - 1, Ri = 1;
    for (this[xr + bi] = Er & 255; --bi >= 0 && (Ri *= 256); )
      this[xr + bi] = Er / Ri & 255;
    return xr + si;
  }, v.prototype.writeUint8 = v.prototype.writeUInt8 = function(Er, xr, si) {
    return Er = +Er, xr = xr >>> 0, si || qr(this, Er, xr, 1, 255, 0), this[xr] = Er & 255, xr + 1;
  }, v.prototype.writeUint16LE = v.prototype.writeUInt16LE = function(Er, xr, si) {
    return Er = +Er, xr = xr >>> 0, si || qr(this, Er, xr, 2, 65535, 0), this[xr] = Er & 255, this[xr + 1] = Er >>> 8, xr + 2;
  }, v.prototype.writeUint16BE = v.prototype.writeUInt16BE = function(Er, xr, si) {
    return Er = +Er, xr = xr >>> 0, si || qr(this, Er, xr, 2, 65535, 0), this[xr] = Er >>> 8, this[xr + 1] = Er & 255, xr + 2;
  }, v.prototype.writeUint32LE = v.prototype.writeUInt32LE = function(Er, xr, si) {
    return Er = +Er, xr = xr >>> 0, si || qr(this, Er, xr, 4, 4294967295, 0), this[xr + 3] = Er >>> 24, this[xr + 2] = Er >>> 16, this[xr + 1] = Er >>> 8, this[xr] = Er & 255, xr + 4;
  }, v.prototype.writeUint32BE = v.prototype.writeUInt32BE = function(Er, xr, si) {
    return Er = +Er, xr = xr >>> 0, si || qr(this, Er, xr, 4, 4294967295, 0), this[xr] = Er >>> 24, this[xr + 1] = Er >>> 16, this[xr + 2] = Er >>> 8, this[xr + 3] = Er & 255, xr + 4;
  };
  function Mr(Cr, Er, xr, si, Ci) {
    br(Er, si, Ci, Cr, xr, 7);
    let bi = Number(Er & BigInt(4294967295));
    Cr[xr++] = bi, bi = bi >> 8, Cr[xr++] = bi, bi = bi >> 8, Cr[xr++] = bi, bi = bi >> 8, Cr[xr++] = bi;
    let Ri = Number(Er >> BigInt(32) & BigInt(4294967295));
    return Cr[xr++] = Ri, Ri = Ri >> 8, Cr[xr++] = Ri, Ri = Ri >> 8, Cr[xr++] = Ri, Ri = Ri >> 8, Cr[xr++] = Ri, xr;
  }
  function Dr(Cr, Er, xr, si, Ci) {
    br(Er, si, Ci, Cr, xr, 7);
    let bi = Number(Er & BigInt(4294967295));
    Cr[xr + 7] = bi, bi = bi >> 8, Cr[xr + 6] = bi, bi = bi >> 8, Cr[xr + 5] = bi, bi = bi >> 8, Cr[xr + 4] = bi;
    let Ri = Number(Er >> BigInt(32) & BigInt(4294967295));
    return Cr[xr + 3] = Ri, Ri = Ri >> 8, Cr[xr + 2] = Ri, Ri = Ri >> 8, Cr[xr + 1] = Ri, Ri = Ri >> 8, Cr[xr] = Ri, xr + 8;
  }
  v.prototype.writeBigUInt64LE = Ir(function(Er, xr = 0) {
    return Mr(this, Er, xr, BigInt(0), BigInt("0xffffffffffffffff"));
  }), v.prototype.writeBigUInt64BE = Ir(function(Er, xr = 0) {
    return Dr(this, Er, xr, BigInt(0), BigInt("0xffffffffffffffff"));
  }), v.prototype.writeIntLE = function(Er, xr, si, Ci) {
    if (Er = +Er, xr = xr >>> 0, !Ci) {
      const zi = Math.pow(2, 8 * si - 1);
      qr(this, Er, xr, si, zi - 1, -zi);
    }
    let bi = 0, Ri = 1, li = 0;
    for (this[xr] = Er & 255; ++bi < si && (Ri *= 256); )
      Er < 0 && li === 0 && this[xr + bi - 1] !== 0 && (li = 1), this[xr + bi] = (Er / Ri >> 0) - li & 255;
    return xr + si;
  }, v.prototype.writeIntBE = function(Er, xr, si, Ci) {
    if (Er = +Er, xr = xr >>> 0, !Ci) {
      const zi = Math.pow(2, 8 * si - 1);
      qr(this, Er, xr, si, zi - 1, -zi);
    }
    let bi = si - 1, Ri = 1, li = 0;
    for (this[xr + bi] = Er & 255; --bi >= 0 && (Ri *= 256); )
      Er < 0 && li === 0 && this[xr + bi + 1] !== 0 && (li = 1), this[xr + bi] = (Er / Ri >> 0) - li & 255;
    return xr + si;
  }, v.prototype.writeInt8 = function(Er, xr, si) {
    return Er = +Er, xr = xr >>> 0, si || qr(this, Er, xr, 1, 127, -128), Er < 0 && (Er = 255 + Er + 1), this[xr] = Er & 255, xr + 1;
  }, v.prototype.writeInt16LE = function(Er, xr, si) {
    return Er = +Er, xr = xr >>> 0, si || qr(this, Er, xr, 2, 32767, -32768), this[xr] = Er & 255, this[xr + 1] = Er >>> 8, xr + 2;
  }, v.prototype.writeInt16BE = function(Er, xr, si) {
    return Er = +Er, xr = xr >>> 0, si || qr(this, Er, xr, 2, 32767, -32768), this[xr] = Er >>> 8, this[xr + 1] = Er & 255, xr + 2;
  }, v.prototype.writeInt32LE = function(Er, xr, si) {
    return Er = +Er, xr = xr >>> 0, si || qr(this, Er, xr, 4, 2147483647, -2147483648), this[xr] = Er & 255, this[xr + 1] = Er >>> 8, this[xr + 2] = Er >>> 16, this[xr + 3] = Er >>> 24, xr + 4;
  }, v.prototype.writeInt32BE = function(Er, xr, si) {
    return Er = +Er, xr = xr >>> 0, si || qr(this, Er, xr, 4, 2147483647, -2147483648), Er < 0 && (Er = 4294967295 + Er + 1), this[xr] = Er >>> 24, this[xr + 1] = Er >>> 16, this[xr + 2] = Er >>> 8, this[xr + 3] = Er & 255, xr + 4;
  }, v.prototype.writeBigInt64LE = Ir(function(Er, xr = 0) {
    return Mr(this, Er, xr, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
  }), v.prototype.writeBigInt64BE = Ir(function(Er, xr = 0) {
    return Dr(this, Er, xr, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
  });
  function Qr(Cr, Er, xr, si, Ci, bi) {
    if (xr + si > Cr.length) throw new RangeError("Index out of range");
    if (xr < 0) throw new RangeError("Index out of range");
  }
  function Xr(Cr, Er, xr, si, Ci) {
    return Er = +Er, xr = xr >>> 0, Ci || Qr(Cr, Er, xr, 4), c.write(Cr, Er, xr, si, 23, 4), xr + 4;
  }
  v.prototype.writeFloatLE = function(Er, xr, si) {
    return Xr(this, Er, xr, !0, si);
  }, v.prototype.writeFloatBE = function(Er, xr, si) {
    return Xr(this, Er, xr, !1, si);
  };
  function Vr(Cr, Er, xr, si, Ci) {
    return Er = +Er, xr = xr >>> 0, Ci || Qr(Cr, Er, xr, 8), c.write(Cr, Er, xr, si, 52, 8), xr + 8;
  }
  v.prototype.writeDoubleLE = function(Er, xr, si) {
    return Vr(this, Er, xr, !0, si);
  }, v.prototype.writeDoubleBE = function(Er, xr, si) {
    return Vr(this, Er, xr, !1, si);
  }, v.prototype.copy = function(Er, xr, si, Ci) {
    if (!v.isBuffer(Er)) throw new TypeError("argument should be a Buffer");
    if (si || (si = 0), !Ci && Ci !== 0 && (Ci = this.length), xr >= Er.length && (xr = Er.length), xr || (xr = 0), Ci > 0 && Ci < si && (Ci = si), Ci === si || Er.length === 0 || this.length === 0) return 0;
    if (xr < 0)
      throw new RangeError("targetStart out of bounds");
    if (si < 0 || si >= this.length) throw new RangeError("Index out of range");
    if (Ci < 0) throw new RangeError("sourceEnd out of bounds");
    Ci > this.length && (Ci = this.length), Er.length - xr < Ci - si && (Ci = Er.length - xr + si);
    const bi = Ci - si;
    return this === Er && typeof d.prototype.copyWithin == "function" ? this.copyWithin(xr, si, Ci) : d.prototype.set.call(
      Er,
      this.subarray(si, Ci),
      xr
    ), bi;
  }, v.prototype.fill = function(Er, xr, si, Ci) {
    if (typeof Er == "string") {
      if (typeof xr == "string" ? (Ci = xr, xr = 0, si = this.length) : typeof si == "string" && (Ci = si, si = this.length), Ci !== void 0 && typeof Ci != "string")
        throw new TypeError("encoding must be a string");
      if (typeof Ci == "string" && !v.isEncoding(Ci))
        throw new TypeError("Unknown encoding: " + Ci);
      if (Er.length === 1) {
        const Ri = Er.charCodeAt(0);
        (Ci === "utf8" && Ri < 128 || Ci === "latin1") && (Er = Ri);
      }
    } else typeof Er == "number" ? Er = Er & 255 : typeof Er == "boolean" && (Er = Number(Er));
    if (xr < 0 || this.length < xr || this.length < si)
      throw new RangeError("Out of range index");
    if (si <= xr)
      return this;
    xr = xr >>> 0, si = si === void 0 ? this.length : si >>> 0, Er || (Er = 0);
    let bi;
    if (typeof Er == "number")
      for (bi = xr; bi < si; ++bi)
        this[bi] = Er;
    else {
      const Ri = v.isBuffer(Er) ? Er : v.from(Er, Ci), li = Ri.length;
      if (li === 0)
        throw new TypeError('The value "' + Er + '" is invalid for argument "value"');
      for (bi = 0; bi < si - xr; ++bi)
        this[bi + xr] = Ri[bi % li];
    }
    return this;
  };
  const Ur = {};
  function Sr(Cr, Er, xr) {
    Ur[Cr] = class extends xr {
      constructor() {
        super(), Object.defineProperty(this, "message", {
          value: Er.apply(this, arguments),
          writable: !0,
          configurable: !0
        }), this.name = `${this.name} [${Cr}]`, this.stack, delete this.name;
      }
      get code() {
        return Cr;
      }
      set code(Ci) {
        Object.defineProperty(this, "code", {
          configurable: !0,
          enumerable: !0,
          value: Ci,
          writable: !0
        });
      }
      toString() {
        return `${this.name} [${Cr}]: ${this.message}`;
      }
    };
  }
  Sr(
    "ERR_BUFFER_OUT_OF_BOUNDS",
    function(Cr) {
      return Cr ? `${Cr} is outside of buffer bounds` : "Attempt to access memory outside buffer bounds";
    },
    RangeError
  ), Sr(
    "ERR_INVALID_ARG_TYPE",
    function(Cr, Er) {
      return `The "${Cr}" argument must be of type number. Received type ${typeof Er}`;
    },
    TypeError
  ), Sr(
    "ERR_OUT_OF_RANGE",
    function(Cr, Er, xr) {
      let si = `The value of "${Cr}" is out of range.`, Ci = xr;
      return Number.isInteger(xr) && Math.abs(xr) > 2 ** 32 ? Ci = Gr(String(xr)) : typeof xr == "bigint" && (Ci = String(xr), (xr > BigInt(2) ** BigInt(32) || xr < -(BigInt(2) ** BigInt(32))) && (Ci = Gr(Ci)), Ci += "n"), si += ` It must be ${Er}. Received ${Ci}`, si;
    },
    RangeError
  );
  function Gr(Cr) {
    let Er = "", xr = Cr.length;
    const si = Cr[0] === "-" ? 1 : 0;
    for (; xr >= si + 4; xr -= 3)
      Er = `_${Cr.slice(xr - 3, xr)}${Er}`;
    return `${Cr.slice(0, xr)}${Er}`;
  }
  function Fr(Cr, Er, xr) {
    Ar(Er, "offset"), (Cr[Er] === void 0 || Cr[Er + xr] === void 0) && cr(Er, Cr.length - (xr + 1));
  }
  function br(Cr, Er, xr, si, Ci, bi) {
    if (Cr > xr || Cr < Er) {
      const Ri = typeof Er == "bigint" ? "n" : "";
      let li;
      throw Er === 0 || Er === BigInt(0) ? li = `>= 0${Ri} and < 2${Ri} ** ${(bi + 1) * 8}${Ri}` : li = `>= -(2${Ri} ** ${(bi + 1) * 8 - 1}${Ri}) and < 2 ** ${(bi + 1) * 8 - 1}${Ri}`, new Ur.ERR_OUT_OF_RANGE("value", li, Cr);
    }
    Fr(si, Ci, bi);
  }
  function Ar(Cr, Er) {
    if (typeof Cr != "number")
      throw new Ur.ERR_INVALID_ARG_TYPE(Er, "number", Cr);
  }
  function cr(Cr, Er, xr) {
    throw Math.floor(Cr) !== Cr ? (Ar(Cr, xr), new Ur.ERR_OUT_OF_RANGE("offset", "an integer", Cr)) : Er < 0 ? new Ur.ERR_BUFFER_OUT_OF_BOUNDS() : new Ur.ERR_OUT_OF_RANGE(
      "offset",
      `>= 0 and <= ${Er}`,
      Cr
    );
  }
  const hr = /[^+/0-9A-Za-z-_]/g;
  function Wr(Cr) {
    if (Cr = Cr.split("=")[0], Cr = Cr.trim().replace(hr, ""), Cr.length < 2) return "";
    for (; Cr.length % 4 !== 0; )
      Cr = Cr + "=";
    return Cr;
  }
  function fi(Cr, Er) {
    Er = Er || 1 / 0;
    let xr;
    const si = Cr.length;
    let Ci = null;
    const bi = [];
    for (let Ri = 0; Ri < si; ++Ri) {
      if (xr = Cr.charCodeAt(Ri), xr > 55295 && xr < 57344) {
        if (!Ci) {
          if (xr > 56319) {
            (Er -= 3) > -1 && bi.push(239, 191, 189);
            continue;
          } else if (Ri + 1 === si) {
            (Er -= 3) > -1 && bi.push(239, 191, 189);
            continue;
          }
          Ci = xr;
          continue;
        }
        if (xr < 56320) {
          (Er -= 3) > -1 && bi.push(239, 191, 189), Ci = xr;
          continue;
        }
        xr = (Ci - 55296 << 10 | xr - 56320) + 65536;
      } else Ci && (Er -= 3) > -1 && bi.push(239, 191, 189);
      if (Ci = null, xr < 128) {
        if ((Er -= 1) < 0) break;
        bi.push(xr);
      } else if (xr < 2048) {
        if ((Er -= 2) < 0) break;
        bi.push(
          xr >> 6 | 192,
          xr & 63 | 128
        );
      } else if (xr < 65536) {
        if ((Er -= 3) < 0) break;
        bi.push(
          xr >> 12 | 224,
          xr >> 6 & 63 | 128,
          xr & 63 | 128
        );
      } else if (xr < 1114112) {
        if ((Er -= 4) < 0) break;
        bi.push(
          xr >> 18 | 240,
          xr >> 12 & 63 | 128,
          xr >> 6 & 63 | 128,
          xr & 63 | 128
        );
      } else
        throw new Error("Invalid code point");
    }
    return bi;
  }
  function Bi(Cr) {
    const Er = [];
    for (let xr = 0; xr < Cr.length; ++xr)
      Er.push(Cr.charCodeAt(xr) & 255);
    return Er;
  }
  function $r(Cr, Er) {
    let xr, si, Ci;
    const bi = [];
    for (let Ri = 0; Ri < Cr.length && !((Er -= 2) < 0); ++Ri)
      xr = Cr.charCodeAt(Ri), si = xr >> 8, Ci = xr % 256, bi.push(Ci), bi.push(si);
    return bi;
  }
  function oi(Cr) {
    return g.toByteArray(Wr(Cr));
  }
  function zr(Cr, Er, xr, si) {
    let Ci;
    for (Ci = 0; Ci < si && !(Ci + xr >= Er.length || Ci >= Cr.length); ++Ci)
      Er[Ci + xr] = Cr[Ci];
    return Ci;
  }
  function ti(Cr, Er) {
    return Cr instanceof Er || Cr != null && Cr.constructor != null && Cr.constructor.name != null && Cr.constructor.name === Er.name;
  }
  function Lr(Cr) {
    return Cr !== Cr;
  }
  const Rr = function() {
    const Cr = "0123456789abcdef", Er = new Array(256);
    for (let xr = 0; xr < 16; ++xr) {
      const si = xr * 16;
      for (let Ci = 0; Ci < 16; ++Ci)
        Er[si + Ci] = Cr[xr] + Cr[Ci];
    }
    return Er;
  }();
  function Ir(Cr) {
    return typeof BigInt > "u" ? pr : Cr;
  }
  function pr() {
    throw new Error("BigInt not supported");
  }
})(buffer$3);
const Buffer = buffer$3.Buffer;
var commonjsGlobal = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function getDefaultExportFromCjs(o) {
  return o && o.__esModule && Object.prototype.hasOwnProperty.call(o, "default") ? o.default : o;
}
function getAugmentedNamespace(o) {
  if (Object.prototype.hasOwnProperty.call(o, "__esModule")) return o;
  var g = o.default;
  if (typeof g == "function") {
    var c = function y() {
      return this instanceof y ? Reflect.construct(g, arguments, this.constructor) : g.apply(this, arguments);
    };
    c.prototype = g.prototype;
  } else c = {};
  return Object.defineProperty(c, "__esModule", { value: !0 }), Object.keys(o).forEach(function(y) {
    var t = Object.getOwnPropertyDescriptor(o, y);
    Object.defineProperty(c, y, t.get ? t : {
      enumerable: !0,
      get: function() {
        return o[y];
      }
    });
  }), c;
}
var dist$q = {}, secp256k1$7 = {}, sha2 = {}, _md$1 = {}, utils$l = {}, crypto$7 = {}, hasRequiredCrypto$4;
function requireCrypto$4() {
  return hasRequiredCrypto$4 || (hasRequiredCrypto$4 = 1, Object.defineProperty(crypto$7, "__esModule", { value: !0 }), crypto$7.crypto = void 0, crypto$7.crypto = typeof globalThis == "object" && "crypto" in globalThis ? globalThis.crypto : void 0), crypto$7;
}
var hasRequiredUtils$j;
function requireUtils$j() {
  return hasRequiredUtils$j || (hasRequiredUtils$j = 1, function(o) {
    Object.defineProperty(o, "__esModule", { value: !0 }), o.wrapXOFConstructorWithOpts = o.wrapConstructorWithOpts = o.wrapConstructor = o.Hash = o.nextTick = o.swap32IfBE = o.byteSwapIfBE = o.swap8IfBE = o.isLE = void 0, o.isBytes = c, o.anumber = y, o.abytes = t, o.ahash = d, o.aexists = E, o.aoutput = B, o.u8 = D, o.u32 = x, o.clean = v, o.createView = F, o.rotr = M, o.rotl = U, o.byteSwap = L, o.byteSwap32 = H, o.bytesToHex = Ie, o.hexToBytes = ze, o.asyncLoop = Pe, o.utf8ToBytes = De, o.bytesToUtf8 = ve, o.toBytes = Fe, o.kdfInputToBytes = be, o.concatBytes = Be, o.checkOpts = ke, o.createHasher = Ne, o.createOptHasher = Et, o.createXOFer = st, o.randomBytes = Dt;
    const g = /* @__PURE__ */ requireCrypto$4();
    function c(er) {
      return er instanceof Uint8Array || ArrayBuffer.isView(er) && er.constructor.name === "Uint8Array";
    }
    function y(er) {
      if (!Number.isSafeInteger(er) || er < 0)
        throw new Error("positive integer expected, got " + er);
    }
    function t(er, ...xt) {
      if (!c(er))
        throw new Error("Uint8Array expected");
      if (xt.length > 0 && !xt.includes(er.length))
        throw new Error("Uint8Array expected of length " + xt + ", got length=" + er.length);
    }
    function d(er) {
      if (typeof er != "function" || typeof er.create != "function")
        throw new Error("Hash should be wrapped by utils.createHasher");
      y(er.outputLen), y(er.blockLen);
    }
    function E(er, xt = !0) {
      if (er.destroyed)
        throw new Error("Hash instance has been destroyed");
      if (xt && er.finished)
        throw new Error("Hash#digest() has already been called");
    }
    function B(er, xt) {
      t(er);
      const ir = xt.outputLen;
      if (er.length < ir)
        throw new Error("digestInto() expects output buffer of length at least " + ir);
    }
    function D(er) {
      return new Uint8Array(er.buffer, er.byteOffset, er.byteLength);
    }
    function x(er) {
      return new Uint32Array(er.buffer, er.byteOffset, Math.floor(er.byteLength / 4));
    }
    function v(...er) {
      for (let xt = 0; xt < er.length; xt++)
        er[xt].fill(0);
    }
    function F(er) {
      return new DataView(er.buffer, er.byteOffset, er.byteLength);
    }
    function M(er, xt) {
      return er << 32 - xt | er >>> xt;
    }
    function U(er, xt) {
      return er << xt | er >>> 32 - xt >>> 0;
    }
    o.isLE = new Uint8Array(new Uint32Array([287454020]).buffer)[0] === 68;
    function L(er) {
      return er << 24 & 4278190080 | er << 8 & 16711680 | er >>> 8 & 65280 | er >>> 24 & 255;
    }
    o.swap8IfBE = o.isLE ? (er) => er : (er) => L(er), o.byteSwapIfBE = o.swap8IfBE;
    function H(er) {
      for (let xt = 0; xt < er.length; xt++)
        er[xt] = L(er[xt]);
      return er;
    }
    o.swap32IfBE = o.isLE ? (er) => er : H;
    const fe = /* @ts-ignore */ typeof Uint8Array.from([]).toHex == "function" && typeof Uint8Array.fromHex == "function", ge = /* @__PURE__ */ Array.from({ length: 256 }, (er, xt) => xt.toString(16).padStart(2, "0"));
    function Ie(er) {
      if (t(er), fe)
        return er.toHex();
      let xt = "";
      for (let ir = 0; ir < er.length; ir++)
        xt += ge[er[ir]];
      return xt;
    }
    const Ee = { _0: 48, _9: 57, A: 65, F: 70, a: 97, f: 102 };
    function Se(er) {
      if (er >= Ee._0 && er <= Ee._9)
        return er - Ee._0;
      if (er >= Ee.A && er <= Ee.F)
        return er - (Ee.A - 10);
      if (er >= Ee.a && er <= Ee.f)
        return er - (Ee.a - 10);
    }
    function ze(er) {
      if (typeof er != "string")
        throw new Error("hex string expected, got " + typeof er);
      if (fe)
        return Uint8Array.fromHex(er);
      const xt = er.length, ir = xt / 2;
      if (xt % 2)
        throw new Error("hex string expected, got unpadded hex of length " + xt);
      const sr = new Uint8Array(ir);
      for (let yr = 0, wr = 0; yr < ir; yr++, wr += 2) {
        const qr = Se(er.charCodeAt(wr)), Mr = Se(er.charCodeAt(wr + 1));
        if (qr === void 0 || Mr === void 0) {
          const Dr = er[wr] + er[wr + 1];
          throw new Error('hex string expected, got non-hex character "' + Dr + '" at index ' + wr);
        }
        sr[yr] = qr * 16 + Mr;
      }
      return sr;
    }
    const He = async () => {
    };
    o.nextTick = He;
    async function Pe(er, xt, ir) {
      let sr = Date.now();
      for (let yr = 0; yr < er; yr++) {
        ir(yr);
        const wr = Date.now() - sr;
        wr >= 0 && wr < xt || (await (0, o.nextTick)(), sr += wr);
      }
    }
    function De(er) {
      if (typeof er != "string")
        throw new Error("string expected");
      return new Uint8Array(new TextEncoder().encode(er));
    }
    function ve(er) {
      return new TextDecoder().decode(er);
    }
    function Fe(er) {
      return typeof er == "string" && (er = De(er)), t(er), er;
    }
    function be(er) {
      return typeof er == "string" && (er = De(er)), t(er), er;
    }
    function Be(...er) {
      let xt = 0;
      for (let sr = 0; sr < er.length; sr++) {
        const yr = er[sr];
        t(yr), xt += yr.length;
      }
      const ir = new Uint8Array(xt);
      for (let sr = 0, yr = 0; sr < er.length; sr++) {
        const wr = er[sr];
        ir.set(wr, yr), yr += wr.length;
      }
      return ir;
    }
    function ke(er, xt) {
      if (xt !== void 0 && {}.toString.call(xt) !== "[object Object]")
        throw new Error("options should be object or undefined");
      return Object.assign(er, xt);
    }
    class xe {
    }
    o.Hash = xe;
    function Ne(er) {
      const xt = (sr) => er().update(Fe(sr)).digest(), ir = er();
      return xt.outputLen = ir.outputLen, xt.blockLen = ir.blockLen, xt.create = () => er(), xt;
    }
    function Et(er) {
      const xt = (sr, yr) => er(yr).update(Fe(sr)).digest(), ir = er({});
      return xt.outputLen = ir.outputLen, xt.blockLen = ir.blockLen, xt.create = (sr) => er(sr), xt;
    }
    function st(er) {
      const xt = (sr, yr) => er(yr).update(Fe(sr)).digest(), ir = er({});
      return xt.outputLen = ir.outputLen, xt.blockLen = ir.blockLen, xt.create = (sr) => er(sr), xt;
    }
    o.wrapConstructor = Ne, o.wrapConstructorWithOpts = Et, o.wrapXOFConstructorWithOpts = st;
    function Dt(er = 32) {
      if (g.crypto && typeof g.crypto.getRandomValues == "function")
        return g.crypto.getRandomValues(new Uint8Array(er));
      if (g.crypto && typeof g.crypto.randomBytes == "function")
        return Uint8Array.from(g.crypto.randomBytes(er));
      throw new Error("crypto.getRandomValues must be defined");
    }
  }(utils$l)), utils$l;
}
var hasRequired_md$1;
function require_md$1() {
  if (hasRequired_md$1) return _md$1;
  hasRequired_md$1 = 1, Object.defineProperty(_md$1, "__esModule", { value: !0 }), _md$1.SHA512_IV = _md$1.SHA384_IV = _md$1.SHA224_IV = _md$1.SHA256_IV = _md$1.HashMD = void 0, _md$1.setBigUint64 = g, _md$1.Chi = c, _md$1.Maj = y;
  const o = /* @__PURE__ */ requireUtils$j();
  function g(d, E, B, D) {
    if (typeof d.setBigUint64 == "function")
      return d.setBigUint64(E, B, D);
    const x = BigInt(32), v = BigInt(4294967295), F = Number(B >> x & v), M = Number(B & v), U = D ? 4 : 0, L = D ? 0 : 4;
    d.setUint32(E + U, F, D), d.setUint32(E + L, M, D);
  }
  function c(d, E, B) {
    return d & E ^ ~d & B;
  }
  function y(d, E, B) {
    return d & E ^ d & B ^ E & B;
  }
  class t extends o.Hash {
    constructor(E, B, D, x) {
      super(), this.finished = !1, this.length = 0, this.pos = 0, this.destroyed = !1, this.blockLen = E, this.outputLen = B, this.padOffset = D, this.isLE = x, this.buffer = new Uint8Array(E), this.view = (0, o.createView)(this.buffer);
    }
    update(E) {
      (0, o.aexists)(this), E = (0, o.toBytes)(E), (0, o.abytes)(E);
      const { view: B, buffer: D, blockLen: x } = this, v = E.length;
      for (let F = 0; F < v; ) {
        const M = Math.min(x - this.pos, v - F);
        if (M === x) {
          const U = (0, o.createView)(E);
          for (; x <= v - F; F += x)
            this.process(U, F);
          continue;
        }
        D.set(E.subarray(F, F + M), this.pos), this.pos += M, F += M, this.pos === x && (this.process(B, 0), this.pos = 0);
      }
      return this.length += E.length, this.roundClean(), this;
    }
    digestInto(E) {
      (0, o.aexists)(this), (0, o.aoutput)(E, this), this.finished = !0;
      const { buffer: B, view: D, blockLen: x, isLE: v } = this;
      let { pos: F } = this;
      B[F++] = 128, (0, o.clean)(this.buffer.subarray(F)), this.padOffset > x - F && (this.process(D, 0), F = 0);
      for (let fe = F; fe < x; fe++)
        B[fe] = 0;
      g(D, x - 8, BigInt(this.length * 8), v), this.process(D, 0);
      const M = (0, o.createView)(E), U = this.outputLen;
      if (U % 4)
        throw new Error("_sha2: outputLen should be aligned to 32bit");
      const L = U / 4, H = this.get();
      if (L > H.length)
        throw new Error("_sha2: outputLen bigger than state");
      for (let fe = 0; fe < L; fe++)
        M.setUint32(4 * fe, H[fe], v);
    }
    digest() {
      const { buffer: E, outputLen: B } = this;
      this.digestInto(E);
      const D = E.slice(0, B);
      return this.destroy(), D;
    }
    _cloneInto(E) {
      E || (E = new this.constructor()), E.set(...this.get());
      const { blockLen: B, buffer: D, length: x, finished: v, destroyed: F, pos: M } = this;
      return E.destroyed = F, E.finished = v, E.length = x, E.pos = M, x % B && E.buffer.set(D), E;
    }
    clone() {
      return this._cloneInto();
    }
  }
  return _md$1.HashMD = t, _md$1.SHA256_IV = Uint32Array.from([
    1779033703,
    3144134277,
    1013904242,
    2773480762,
    1359893119,
    2600822924,
    528734635,
    1541459225
  ]), _md$1.SHA224_IV = Uint32Array.from([
    3238371032,
    914150663,
    812702999,
    4144912697,
    4290775857,
    1750603025,
    1694076839,
    3204075428
  ]), _md$1.SHA384_IV = Uint32Array.from([
    3418070365,
    3238371032,
    1654270250,
    914150663,
    2438529370,
    812702999,
    355462360,
    4144912697,
    1731405415,
    4290775857,
    2394180231,
    1750603025,
    3675008525,
    1694076839,
    1203062813,
    3204075428
  ]), _md$1.SHA512_IV = Uint32Array.from([
    1779033703,
    4089235720,
    3144134277,
    2227873595,
    1013904242,
    4271175723,
    2773480762,
    1595750129,
    1359893119,
    2917565137,
    2600822924,
    725511199,
    528734635,
    4215389547,
    1541459225,
    327033209
  ]), _md$1;
}
var _u64$1 = {}, hasRequired_u64$1;
function require_u64$1() {
  if (hasRequired_u64$1) return _u64$1;
  hasRequired_u64$1 = 1, Object.defineProperty(_u64$1, "__esModule", { value: !0 }), _u64$1.toBig = _u64$1.shrSL = _u64$1.shrSH = _u64$1.rotrSL = _u64$1.rotrSH = _u64$1.rotrBL = _u64$1.rotrBH = _u64$1.rotr32L = _u64$1.rotr32H = _u64$1.rotlSL = _u64$1.rotlSH = _u64$1.rotlBL = _u64$1.rotlBH = _u64$1.add5L = _u64$1.add5H = _u64$1.add4L = _u64$1.add4H = _u64$1.add3L = _u64$1.add3H = void 0, _u64$1.add = ge, _u64$1.fromBig = c, _u64$1.split = y;
  const o = /* @__PURE__ */ BigInt(2 ** 32 - 1), g = /* @__PURE__ */ BigInt(32);
  function c(ve, Fe = !1) {
    return Fe ? { h: Number(ve & o), l: Number(ve >> g & o) } : { h: Number(ve >> g & o) | 0, l: Number(ve & o) | 0 };
  }
  function y(ve, Fe = !1) {
    const be = ve.length;
    let Be = new Uint32Array(be), ke = new Uint32Array(be);
    for (let xe = 0; xe < be; xe++) {
      const { h: Ne, l: Et } = c(ve[xe], Fe);
      [Be[xe], ke[xe]] = [Ne, Et];
    }
    return [Be, ke];
  }
  const t = (ve, Fe) => BigInt(ve >>> 0) << g | BigInt(Fe >>> 0);
  _u64$1.toBig = t;
  const d = (ve, Fe, be) => ve >>> be;
  _u64$1.shrSH = d;
  const E = (ve, Fe, be) => ve << 32 - be | Fe >>> be;
  _u64$1.shrSL = E;
  const B = (ve, Fe, be) => ve >>> be | Fe << 32 - be;
  _u64$1.rotrSH = B;
  const D = (ve, Fe, be) => ve << 32 - be | Fe >>> be;
  _u64$1.rotrSL = D;
  const x = (ve, Fe, be) => ve << 64 - be | Fe >>> be - 32;
  _u64$1.rotrBH = x;
  const v = (ve, Fe, be) => ve >>> be - 32 | Fe << 64 - be;
  _u64$1.rotrBL = v;
  const F = (ve, Fe) => Fe;
  _u64$1.rotr32H = F;
  const M = (ve, Fe) => ve;
  _u64$1.rotr32L = M;
  const U = (ve, Fe, be) => ve << be | Fe >>> 32 - be;
  _u64$1.rotlSH = U;
  const L = (ve, Fe, be) => Fe << be | ve >>> 32 - be;
  _u64$1.rotlSL = L;
  const H = (ve, Fe, be) => Fe << be - 32 | ve >>> 64 - be;
  _u64$1.rotlBH = H;
  const fe = (ve, Fe, be) => ve << be - 32 | Fe >>> 64 - be;
  _u64$1.rotlBL = fe;
  function ge(ve, Fe, be, Be) {
    const ke = (Fe >>> 0) + (Be >>> 0);
    return { h: ve + be + (ke / 2 ** 32 | 0) | 0, l: ke | 0 };
  }
  const Ie = (ve, Fe, be) => (ve >>> 0) + (Fe >>> 0) + (be >>> 0);
  _u64$1.add3L = Ie;
  const Ee = (ve, Fe, be, Be) => Fe + be + Be + (ve / 2 ** 32 | 0) | 0;
  _u64$1.add3H = Ee;
  const Se = (ve, Fe, be, Be) => (ve >>> 0) + (Fe >>> 0) + (be >>> 0) + (Be >>> 0);
  _u64$1.add4L = Se;
  const ze = (ve, Fe, be, Be, ke) => Fe + be + Be + ke + (ve / 2 ** 32 | 0) | 0;
  _u64$1.add4H = ze;
  const He = (ve, Fe, be, Be, ke) => (ve >>> 0) + (Fe >>> 0) + (be >>> 0) + (Be >>> 0) + (ke >>> 0);
  _u64$1.add5L = He;
  const Pe = (ve, Fe, be, Be, ke, xe) => Fe + be + Be + ke + xe + (ve / 2 ** 32 | 0) | 0;
  _u64$1.add5H = Pe;
  const De = {
    fromBig: c,
    split: y,
    toBig: t,
    shrSH: d,
    shrSL: E,
    rotrSH: B,
    rotrSL: D,
    rotrBH: x,
    rotrBL: v,
    rotr32H: F,
    rotr32L: M,
    rotlSH: U,
    rotlSL: L,
    rotlBH: H,
    rotlBL: fe,
    add: ge,
    add3L: Ie,
    add3H: Ee,
    add4L: Se,
    add4H: ze,
    add5H: Pe,
    add5L: He
  };
  return _u64$1.default = De, _u64$1;
}
var hasRequiredSha2;
function requireSha2() {
  if (hasRequiredSha2) return sha2;
  hasRequiredSha2 = 1, Object.defineProperty(sha2, "__esModule", { value: !0 }), sha2.sha512_224 = sha2.sha512_256 = sha2.sha384 = sha2.sha512 = sha2.sha224 = sha2.sha256 = sha2.SHA512_256 = sha2.SHA512_224 = sha2.SHA384 = sha2.SHA512 = sha2.SHA224 = sha2.SHA256 = void 0;
  const o = /* @__PURE__ */ require_md$1(), g = /* @__PURE__ */ require_u64$1(), c = /* @__PURE__ */ requireUtils$j(), y = /* @__PURE__ */ Uint32Array.from([
    1116352408,
    1899447441,
    3049323471,
    3921009573,
    961987163,
    1508970993,
    2453635748,
    2870763221,
    3624381080,
    310598401,
    607225278,
    1426881987,
    1925078388,
    2162078206,
    2614888103,
    3248222580,
    3835390401,
    4022224774,
    264347078,
    604807628,
    770255983,
    1249150122,
    1555081692,
    1996064986,
    2554220882,
    2821834349,
    2952996808,
    3210313671,
    3336571891,
    3584528711,
    113926993,
    338241895,
    666307205,
    773529912,
    1294757372,
    1396182291,
    1695183700,
    1986661051,
    2177026350,
    2456956037,
    2730485921,
    2820302411,
    3259730800,
    3345764771,
    3516065817,
    3600352804,
    4094571909,
    275423344,
    430227734,
    506948616,
    659060556,
    883997877,
    958139571,
    1322822218,
    1537002063,
    1747873779,
    1955562222,
    2024104815,
    2227730452,
    2361852424,
    2428436474,
    2756734187,
    3204031479,
    3329325298
  ]), t = /* @__PURE__ */ new Uint32Array(64);
  class d extends o.HashMD {
    constructor(Ee = 32) {
      super(64, Ee, 8, !1), this.A = o.SHA256_IV[0] | 0, this.B = o.SHA256_IV[1] | 0, this.C = o.SHA256_IV[2] | 0, this.D = o.SHA256_IV[3] | 0, this.E = o.SHA256_IV[4] | 0, this.F = o.SHA256_IV[5] | 0, this.G = o.SHA256_IV[6] | 0, this.H = o.SHA256_IV[7] | 0;
    }
    get() {
      const { A: Ee, B: Se, C: ze, D: He, E: Pe, F: De, G: ve, H: Fe } = this;
      return [Ee, Se, ze, He, Pe, De, ve, Fe];
    }
    // prettier-ignore
    set(Ee, Se, ze, He, Pe, De, ve, Fe) {
      this.A = Ee | 0, this.B = Se | 0, this.C = ze | 0, this.D = He | 0, this.E = Pe | 0, this.F = De | 0, this.G = ve | 0, this.H = Fe | 0;
    }
    process(Ee, Se) {
      for (let ke = 0; ke < 16; ke++, Se += 4)
        t[ke] = Ee.getUint32(Se, !1);
      for (let ke = 16; ke < 64; ke++) {
        const xe = t[ke - 15], Ne = t[ke - 2], Et = (0, c.rotr)(xe, 7) ^ (0, c.rotr)(xe, 18) ^ xe >>> 3, st = (0, c.rotr)(Ne, 17) ^ (0, c.rotr)(Ne, 19) ^ Ne >>> 10;
        t[ke] = st + t[ke - 7] + Et + t[ke - 16] | 0;
      }
      let { A: ze, B: He, C: Pe, D: De, E: ve, F: Fe, G: be, H: Be } = this;
      for (let ke = 0; ke < 64; ke++) {
        const xe = (0, c.rotr)(ve, 6) ^ (0, c.rotr)(ve, 11) ^ (0, c.rotr)(ve, 25), Ne = Be + xe + (0, o.Chi)(ve, Fe, be) + y[ke] + t[ke] | 0, st = ((0, c.rotr)(ze, 2) ^ (0, c.rotr)(ze, 13) ^ (0, c.rotr)(ze, 22)) + (0, o.Maj)(ze, He, Pe) | 0;
        Be = be, be = Fe, Fe = ve, ve = De + Ne | 0, De = Pe, Pe = He, He = ze, ze = Ne + st | 0;
      }
      ze = ze + this.A | 0, He = He + this.B | 0, Pe = Pe + this.C | 0, De = De + this.D | 0, ve = ve + this.E | 0, Fe = Fe + this.F | 0, be = be + this.G | 0, Be = Be + this.H | 0, this.set(ze, He, Pe, De, ve, Fe, be, Be);
    }
    roundClean() {
      (0, c.clean)(t);
    }
    destroy() {
      this.set(0, 0, 0, 0, 0, 0, 0, 0), (0, c.clean)(this.buffer);
    }
  }
  sha2.SHA256 = d;
  class E extends d {
    constructor() {
      super(28), this.A = o.SHA224_IV[0] | 0, this.B = o.SHA224_IV[1] | 0, this.C = o.SHA224_IV[2] | 0, this.D = o.SHA224_IV[3] | 0, this.E = o.SHA224_IV[4] | 0, this.F = o.SHA224_IV[5] | 0, this.G = o.SHA224_IV[6] | 0, this.H = o.SHA224_IV[7] | 0;
    }
  }
  sha2.SHA224 = E;
  const B = g.split([
    "0x428a2f98d728ae22",
    "0x7137449123ef65cd",
    "0xb5c0fbcfec4d3b2f",
    "0xe9b5dba58189dbbc",
    "0x3956c25bf348b538",
    "0x59f111f1b605d019",
    "0x923f82a4af194f9b",
    "0xab1c5ed5da6d8118",
    "0xd807aa98a3030242",
    "0x12835b0145706fbe",
    "0x243185be4ee4b28c",
    "0x550c7dc3d5ffb4e2",
    "0x72be5d74f27b896f",
    "0x80deb1fe3b1696b1",
    "0x9bdc06a725c71235",
    "0xc19bf174cf692694",
    "0xe49b69c19ef14ad2",
    "0xefbe4786384f25e3",
    "0x0fc19dc68b8cd5b5",
    "0x240ca1cc77ac9c65",
    "0x2de92c6f592b0275",
    "0x4a7484aa6ea6e483",
    "0x5cb0a9dcbd41fbd4",
    "0x76f988da831153b5",
    "0x983e5152ee66dfab",
    "0xa831c66d2db43210",
    "0xb00327c898fb213f",
    "0xbf597fc7beef0ee4",
    "0xc6e00bf33da88fc2",
    "0xd5a79147930aa725",
    "0x06ca6351e003826f",
    "0x142929670a0e6e70",
    "0x27b70a8546d22ffc",
    "0x2e1b21385c26c926",
    "0x4d2c6dfc5ac42aed",
    "0x53380d139d95b3df",
    "0x650a73548baf63de",
    "0x766a0abb3c77b2a8",
    "0x81c2c92e47edaee6",
    "0x92722c851482353b",
    "0xa2bfe8a14cf10364",
    "0xa81a664bbc423001",
    "0xc24b8b70d0f89791",
    "0xc76c51a30654be30",
    "0xd192e819d6ef5218",
    "0xd69906245565a910",
    "0xf40e35855771202a",
    "0x106aa07032bbd1b8",
    "0x19a4c116b8d2d0c8",
    "0x1e376c085141ab53",
    "0x2748774cdf8eeb99",
    "0x34b0bcb5e19b48a8",
    "0x391c0cb3c5c95a63",
    "0x4ed8aa4ae3418acb",
    "0x5b9cca4f7763e373",
    "0x682e6ff3d6b2b8a3",
    "0x748f82ee5defb2fc",
    "0x78a5636f43172f60",
    "0x84c87814a1f0ab72",
    "0x8cc702081a6439ec",
    "0x90befffa23631e28",
    "0xa4506cebde82bde9",
    "0xbef9a3f7b2c67915",
    "0xc67178f2e372532b",
    "0xca273eceea26619c",
    "0xd186b8c721c0c207",
    "0xeada7dd6cde0eb1e",
    "0xf57d4f7fee6ed178",
    "0x06f067aa72176fba",
    "0x0a637dc5a2c898a6",
    "0x113f9804bef90dae",
    "0x1b710b35131c471b",
    "0x28db77f523047d84",
    "0x32caab7b40c72493",
    "0x3c9ebe0a15c9bebc",
    "0x431d67c49c100d4c",
    "0x4cc5d4becb3e42b6",
    "0x597f299cfc657e2a",
    "0x5fcb6fab3ad6faec",
    "0x6c44198c4a475817"
  ].map((Ie) => BigInt(Ie))), D = B[0], x = B[1], v = /* @__PURE__ */ new Uint32Array(80), F = /* @__PURE__ */ new Uint32Array(80);
  class M extends o.HashMD {
    constructor(Ee = 64) {
      super(128, Ee, 16, !1), this.Ah = o.SHA512_IV[0] | 0, this.Al = o.SHA512_IV[1] | 0, this.Bh = o.SHA512_IV[2] | 0, this.Bl = o.SHA512_IV[3] | 0, this.Ch = o.SHA512_IV[4] | 0, this.Cl = o.SHA512_IV[5] | 0, this.Dh = o.SHA512_IV[6] | 0, this.Dl = o.SHA512_IV[7] | 0, this.Eh = o.SHA512_IV[8] | 0, this.El = o.SHA512_IV[9] | 0, this.Fh = o.SHA512_IV[10] | 0, this.Fl = o.SHA512_IV[11] | 0, this.Gh = o.SHA512_IV[12] | 0, this.Gl = o.SHA512_IV[13] | 0, this.Hh = o.SHA512_IV[14] | 0, this.Hl = o.SHA512_IV[15] | 0;
    }
    // prettier-ignore
    get() {
      const { Ah: Ee, Al: Se, Bh: ze, Bl: He, Ch: Pe, Cl: De, Dh: ve, Dl: Fe, Eh: be, El: Be, Fh: ke, Fl: xe, Gh: Ne, Gl: Et, Hh: st, Hl: Dt } = this;
      return [Ee, Se, ze, He, Pe, De, ve, Fe, be, Be, ke, xe, Ne, Et, st, Dt];
    }
    // prettier-ignore
    set(Ee, Se, ze, He, Pe, De, ve, Fe, be, Be, ke, xe, Ne, Et, st, Dt) {
      this.Ah = Ee | 0, this.Al = Se | 0, this.Bh = ze | 0, this.Bl = He | 0, this.Ch = Pe | 0, this.Cl = De | 0, this.Dh = ve | 0, this.Dl = Fe | 0, this.Eh = be | 0, this.El = Be | 0, this.Fh = ke | 0, this.Fl = xe | 0, this.Gh = Ne | 0, this.Gl = Et | 0, this.Hh = st | 0, this.Hl = Dt | 0;
    }
    process(Ee, Se) {
      for (let ir = 0; ir < 16; ir++, Se += 4)
        v[ir] = Ee.getUint32(Se), F[ir] = Ee.getUint32(Se += 4);
      for (let ir = 16; ir < 80; ir++) {
        const sr = v[ir - 15] | 0, yr = F[ir - 15] | 0, wr = g.rotrSH(sr, yr, 1) ^ g.rotrSH(sr, yr, 8) ^ g.shrSH(sr, yr, 7), qr = g.rotrSL(sr, yr, 1) ^ g.rotrSL(sr, yr, 8) ^ g.shrSL(sr, yr, 7), Mr = v[ir - 2] | 0, Dr = F[ir - 2] | 0, Qr = g.rotrSH(Mr, Dr, 19) ^ g.rotrBH(Mr, Dr, 61) ^ g.shrSH(Mr, Dr, 6), Xr = g.rotrSL(Mr, Dr, 19) ^ g.rotrBL(Mr, Dr, 61) ^ g.shrSL(Mr, Dr, 6), Vr = g.add4L(qr, Xr, F[ir - 7], F[ir - 16]), Ur = g.add4H(Vr, wr, Qr, v[ir - 7], v[ir - 16]);
        v[ir] = Ur | 0, F[ir] = Vr | 0;
      }
      let { Ah: ze, Al: He, Bh: Pe, Bl: De, Ch: ve, Cl: Fe, Dh: be, Dl: Be, Eh: ke, El: xe, Fh: Ne, Fl: Et, Gh: st, Gl: Dt, Hh: er, Hl: xt } = this;
      for (let ir = 0; ir < 80; ir++) {
        const sr = g.rotrSH(ke, xe, 14) ^ g.rotrSH(ke, xe, 18) ^ g.rotrBH(ke, xe, 41), yr = g.rotrSL(ke, xe, 14) ^ g.rotrSL(ke, xe, 18) ^ g.rotrBL(ke, xe, 41), wr = ke & Ne ^ ~ke & st, qr = xe & Et ^ ~xe & Dt, Mr = g.add5L(xt, yr, qr, x[ir], F[ir]), Dr = g.add5H(Mr, er, sr, wr, D[ir], v[ir]), Qr = Mr | 0, Xr = g.rotrSH(ze, He, 28) ^ g.rotrBH(ze, He, 34) ^ g.rotrBH(ze, He, 39), Vr = g.rotrSL(ze, He, 28) ^ g.rotrBL(ze, He, 34) ^ g.rotrBL(ze, He, 39), Ur = ze & Pe ^ ze & ve ^ Pe & ve, Sr = He & De ^ He & Fe ^ De & Fe;
        er = st | 0, xt = Dt | 0, st = Ne | 0, Dt = Et | 0, Ne = ke | 0, Et = xe | 0, { h: ke, l: xe } = g.add(be | 0, Be | 0, Dr | 0, Qr | 0), be = ve | 0, Be = Fe | 0, ve = Pe | 0, Fe = De | 0, Pe = ze | 0, De = He | 0;
        const Gr = g.add3L(Qr, Vr, Sr);
        ze = g.add3H(Gr, Dr, Xr, Ur), He = Gr | 0;
      }
      ({ h: ze, l: He } = g.add(this.Ah | 0, this.Al | 0, ze | 0, He | 0)), { h: Pe, l: De } = g.add(this.Bh | 0, this.Bl | 0, Pe | 0, De | 0), { h: ve, l: Fe } = g.add(this.Ch | 0, this.Cl | 0, ve | 0, Fe | 0), { h: be, l: Be } = g.add(this.Dh | 0, this.Dl | 0, be | 0, Be | 0), { h: ke, l: xe } = g.add(this.Eh | 0, this.El | 0, ke | 0, xe | 0), { h: Ne, l: Et } = g.add(this.Fh | 0, this.Fl | 0, Ne | 0, Et | 0), { h: st, l: Dt } = g.add(this.Gh | 0, this.Gl | 0, st | 0, Dt | 0), { h: er, l: xt } = g.add(this.Hh | 0, this.Hl | 0, er | 0, xt | 0), this.set(ze, He, Pe, De, ve, Fe, be, Be, ke, xe, Ne, Et, st, Dt, er, xt);
    }
    roundClean() {
      (0, c.clean)(v, F);
    }
    destroy() {
      (0, c.clean)(this.buffer), this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
    }
  }
  sha2.SHA512 = M;
  class U extends M {
    constructor() {
      super(48), this.Ah = o.SHA384_IV[0] | 0, this.Al = o.SHA384_IV[1] | 0, this.Bh = o.SHA384_IV[2] | 0, this.Bl = o.SHA384_IV[3] | 0, this.Ch = o.SHA384_IV[4] | 0, this.Cl = o.SHA384_IV[5] | 0, this.Dh = o.SHA384_IV[6] | 0, this.Dl = o.SHA384_IV[7] | 0, this.Eh = o.SHA384_IV[8] | 0, this.El = o.SHA384_IV[9] | 0, this.Fh = o.SHA384_IV[10] | 0, this.Fl = o.SHA384_IV[11] | 0, this.Gh = o.SHA384_IV[12] | 0, this.Gl = o.SHA384_IV[13] | 0, this.Hh = o.SHA384_IV[14] | 0, this.Hl = o.SHA384_IV[15] | 0;
    }
  }
  sha2.SHA384 = U;
  const L = /* @__PURE__ */ Uint32Array.from([
    2352822216,
    424955298,
    1944164710,
    2312950998,
    502970286,
    855612546,
    1738396948,
    1479516111,
    258812777,
    2077511080,
    2011393907,
    79989058,
    1067287976,
    1780299464,
    286451373,
    2446758561
  ]), H = /* @__PURE__ */ Uint32Array.from([
    573645204,
    4230739756,
    2673172387,
    3360449730,
    596883563,
    1867755857,
    2520282905,
    1497426621,
    2519219938,
    2827943907,
    3193839141,
    1401305490,
    721525244,
    746961066,
    246885852,
    2177182882
  ]);
  class fe extends M {
    constructor() {
      super(28), this.Ah = L[0] | 0, this.Al = L[1] | 0, this.Bh = L[2] | 0, this.Bl = L[3] | 0, this.Ch = L[4] | 0, this.Cl = L[5] | 0, this.Dh = L[6] | 0, this.Dl = L[7] | 0, this.Eh = L[8] | 0, this.El = L[9] | 0, this.Fh = L[10] | 0, this.Fl = L[11] | 0, this.Gh = L[12] | 0, this.Gl = L[13] | 0, this.Hh = L[14] | 0, this.Hl = L[15] | 0;
    }
  }
  sha2.SHA512_224 = fe;
  class ge extends M {
    constructor() {
      super(32), this.Ah = H[0] | 0, this.Al = H[1] | 0, this.Bh = H[2] | 0, this.Bl = H[3] | 0, this.Ch = H[4] | 0, this.Cl = H[5] | 0, this.Dh = H[6] | 0, this.Dl = H[7] | 0, this.Eh = H[8] | 0, this.El = H[9] | 0, this.Fh = H[10] | 0, this.Fl = H[11] | 0, this.Gh = H[12] | 0, this.Gl = H[13] | 0, this.Hh = H[14] | 0, this.Hl = H[15] | 0;
    }
  }
  return sha2.SHA512_256 = ge, sha2.sha256 = (0, c.createHasher)(() => new d()), sha2.sha224 = (0, c.createHasher)(() => new E()), sha2.sha512 = (0, c.createHasher)(() => new M()), sha2.sha384 = (0, c.createHasher)(() => new U()), sha2.sha512_256 = (0, c.createHasher)(() => new ge()), sha2.sha512_224 = (0, c.createHasher)(() => new fe()), sha2;
}
var _shortw_utils$1 = {}, weierstrass$3 = {}, hmac$5 = {}, hasRequiredHmac$3;
function requireHmac$3() {
  return hasRequiredHmac$3 || (hasRequiredHmac$3 = 1, function(o) {
    Object.defineProperty(o, "__esModule", { value: !0 }), o.hmac = o.HMAC = void 0;
    const g = /* @__PURE__ */ requireUtils$j();
    class c extends g.Hash {
      constructor(d, E) {
        super(), this.finished = !1, this.destroyed = !1, (0, g.ahash)(d);
        const B = (0, g.toBytes)(E);
        if (this.iHash = d.create(), typeof this.iHash.update != "function")
          throw new Error("Expected instance of class which extends utils.Hash");
        this.blockLen = this.iHash.blockLen, this.outputLen = this.iHash.outputLen;
        const D = this.blockLen, x = new Uint8Array(D);
        x.set(B.length > D ? d.create().update(B).digest() : B);
        for (let v = 0; v < x.length; v++)
          x[v] ^= 54;
        this.iHash.update(x), this.oHash = d.create();
        for (let v = 0; v < x.length; v++)
          x[v] ^= 106;
        this.oHash.update(x), (0, g.clean)(x);
      }
      update(d) {
        return (0, g.aexists)(this), this.iHash.update(d), this;
      }
      digestInto(d) {
        (0, g.aexists)(this), (0, g.abytes)(d, this.outputLen), this.finished = !0, this.iHash.digestInto(d), this.oHash.update(d), this.oHash.digestInto(d), this.destroy();
      }
      digest() {
        const d = new Uint8Array(this.oHash.outputLen);
        return this.digestInto(d), d;
      }
      _cloneInto(d) {
        d || (d = Object.create(Object.getPrototypeOf(this), {}));
        const { oHash: E, iHash: B, finished: D, destroyed: x, blockLen: v, outputLen: F } = this;
        return d = d, d.finished = D, d.destroyed = x, d.blockLen = v, d.outputLen = F, d.oHash = E._cloneInto(d.oHash), d.iHash = B._cloneInto(d.iHash), d;
      }
      clone() {
        return this._cloneInto();
      }
      destroy() {
        this.destroyed = !0, this.oHash.destroy(), this.iHash.destroy();
      }
    }
    o.HMAC = c;
    const y = (t, d, E) => new c(t, d).update(E).digest();
    o.hmac = y, o.hmac.create = (t, d) => new c(t, d);
  }(hmac$5)), hmac$5;
}
var utils$k = {}, hasRequiredUtils$i;
function requireUtils$i() {
  return hasRequiredUtils$i || (hasRequiredUtils$i = 1, function(o) {
    Object.defineProperty(o, "__esModule", { value: !0 }), o.notImplemented = o.bitMask = o.utf8ToBytes = o.randomBytes = o.isBytes = o.hexToBytes = o.concatBytes = o.bytesToUtf8 = o.bytesToHex = o.anumber = o.abytes = void 0, o.abool = d, o._abool2 = E, o._abytes2 = B, o.numberToHexUnpadded = D, o.hexToNumber = x, o.bytesToNumberBE = v, o.bytesToNumberLE = F, o.numberToBytesBE = M, o.numberToBytesLE = U, o.numberToVarBytesBE = L, o.ensureBytes = H, o.equalBytes = fe, o.copyBytes = ge, o.asciiToBytes = Ie, o.inRange = Se, o.aInRange = ze, o.bitLen = He, o.bitGet = Pe, o.bitSet = De, o.createHmacDrbg = Fe, o.validateObject = Be, o.isHash = ke, o._validateObject = xe, o.memoized = Et;
    const g = /* @__PURE__ */ requireUtils$j();
    var c = /* @__PURE__ */ requireUtils$j();
    Object.defineProperty(o, "abytes", { enumerable: !0, get: function() {
      return c.abytes;
    } }), Object.defineProperty(o, "anumber", { enumerable: !0, get: function() {
      return c.anumber;
    } }), Object.defineProperty(o, "bytesToHex", { enumerable: !0, get: function() {
      return c.bytesToHex;
    } }), Object.defineProperty(o, "bytesToUtf8", { enumerable: !0, get: function() {
      return c.bytesToUtf8;
    } }), Object.defineProperty(o, "concatBytes", { enumerable: !0, get: function() {
      return c.concatBytes;
    } }), Object.defineProperty(o, "hexToBytes", { enumerable: !0, get: function() {
      return c.hexToBytes;
    } }), Object.defineProperty(o, "isBytes", { enumerable: !0, get: function() {
      return c.isBytes;
    } }), Object.defineProperty(o, "randomBytes", { enumerable: !0, get: function() {
      return c.randomBytes;
    } }), Object.defineProperty(o, "utf8ToBytes", { enumerable: !0, get: function() {
      return c.utf8ToBytes;
    } });
    const y = /* @__PURE__ */ BigInt(0), t = /* @__PURE__ */ BigInt(1);
    function d(st, Dt) {
      if (typeof Dt != "boolean")
        throw new Error(st + " boolean expected, got " + Dt);
    }
    function E(st, Dt = "") {
      if (typeof st != "boolean") {
        const er = Dt && `"${Dt}"`;
        throw new Error(er + "expected boolean, got type=" + typeof st);
      }
      return st;
    }
    function B(st, Dt, er = "") {
      const xt = (0, g.isBytes)(st), ir = st == null ? void 0 : st.length, sr = Dt !== void 0;
      if (!xt || sr && ir !== Dt) {
        const yr = er && `"${er}" `, wr = sr ? ` of length ${Dt}` : "", qr = xt ? `length=${ir}` : `type=${typeof st}`;
        throw new Error(yr + "expected Uint8Array" + wr + ", got " + qr);
      }
      return st;
    }
    function D(st) {
      const Dt = st.toString(16);
      return Dt.length & 1 ? "0" + Dt : Dt;
    }
    function x(st) {
      if (typeof st != "string")
        throw new Error("hex string expected, got " + typeof st);
      return st === "" ? y : BigInt("0x" + st);
    }
    function v(st) {
      return x((0, g.bytesToHex)(st));
    }
    function F(st) {
      return (0, g.abytes)(st), x((0, g.bytesToHex)(Uint8Array.from(st).reverse()));
    }
    function M(st, Dt) {
      return (0, g.hexToBytes)(st.toString(16).padStart(Dt * 2, "0"));
    }
    function U(st, Dt) {
      return M(st, Dt).reverse();
    }
    function L(st) {
      return (0, g.hexToBytes)(D(st));
    }
    function H(st, Dt, er) {
      let xt;
      if (typeof Dt == "string")
        try {
          xt = (0, g.hexToBytes)(Dt);
        } catch (sr) {
          throw new Error(st + " must be hex string or Uint8Array, cause: " + sr);
        }
      else if ((0, g.isBytes)(Dt))
        xt = Uint8Array.from(Dt);
      else
        throw new Error(st + " must be hex string or Uint8Array");
      const ir = xt.length;
      if (typeof er == "number" && ir !== er)
        throw new Error(st + " of length " + er + " expected, got " + ir);
      return xt;
    }
    function fe(st, Dt) {
      if (st.length !== Dt.length)
        return !1;
      let er = 0;
      for (let xt = 0; xt < st.length; xt++)
        er |= st[xt] ^ Dt[xt];
      return er === 0;
    }
    function ge(st) {
      return Uint8Array.from(st);
    }
    function Ie(st) {
      return Uint8Array.from(st, (Dt, er) => {
        const xt = Dt.charCodeAt(0);
        if (Dt.length !== 1 || xt > 127)
          throw new Error(`string contains non-ASCII character "${st[er]}" with code ${xt} at position ${er}`);
        return xt;
      });
    }
    const Ee = (st) => typeof st == "bigint" && y <= st;
    function Se(st, Dt, er) {
      return Ee(st) && Ee(Dt) && Ee(er) && Dt <= st && st < er;
    }
    function ze(st, Dt, er, xt) {
      if (!Se(Dt, er, xt))
        throw new Error("expected valid " + st + ": " + er + " <= n < " + xt + ", got " + Dt);
    }
    function He(st) {
      let Dt;
      for (Dt = 0; st > y; st >>= t, Dt += 1)
        ;
      return Dt;
    }
    function Pe(st, Dt) {
      return st >> BigInt(Dt) & t;
    }
    function De(st, Dt, er) {
      return st | (er ? t : y) << BigInt(Dt);
    }
    const ve = (st) => (t << BigInt(st)) - t;
    o.bitMask = ve;
    function Fe(st, Dt, er) {
      if (typeof st != "number" || st < 2)
        throw new Error("hashLen must be a number");
      if (typeof Dt != "number" || Dt < 2)
        throw new Error("qByteLen must be a number");
      if (typeof er != "function")
        throw new Error("hmacFn must be a function");
      const xt = (Vr) => new Uint8Array(Vr), ir = (Vr) => Uint8Array.of(Vr);
      let sr = xt(st), yr = xt(st), wr = 0;
      const qr = () => {
        sr.fill(1), yr.fill(0), wr = 0;
      }, Mr = (...Vr) => er(yr, sr, ...Vr), Dr = (Vr = xt(0)) => {
        yr = Mr(ir(0), Vr), sr = Mr(), Vr.length !== 0 && (yr = Mr(ir(1), Vr), sr = Mr());
      }, Qr = () => {
        if (wr++ >= 1e3)
          throw new Error("drbg: tried 1000 values");
        let Vr = 0;
        const Ur = [];
        for (; Vr < Dt; ) {
          sr = Mr();
          const Sr = sr.slice();
          Ur.push(Sr), Vr += sr.length;
        }
        return (0, g.concatBytes)(...Ur);
      };
      return (Vr, Ur) => {
        qr(), Dr(Vr);
        let Sr;
        for (; !(Sr = Ur(Qr())); )
          Dr();
        return qr(), Sr;
      };
    }
    const be = {
      bigint: (st) => typeof st == "bigint",
      function: (st) => typeof st == "function",
      boolean: (st) => typeof st == "boolean",
      string: (st) => typeof st == "string",
      stringOrUint8Array: (st) => typeof st == "string" || (0, g.isBytes)(st),
      isSafeInteger: (st) => Number.isSafeInteger(st),
      array: (st) => Array.isArray(st),
      field: (st, Dt) => Dt.Fp.isValid(st),
      hash: (st) => typeof st == "function" && Number.isSafeInteger(st.outputLen)
    };
    function Be(st, Dt, er = {}) {
      const xt = (ir, sr, yr) => {
        const wr = be[sr];
        if (typeof wr != "function")
          throw new Error("invalid validator function");
        const qr = st[ir];
        if (!(yr && qr === void 0) && !wr(qr, st))
          throw new Error("param " + String(ir) + " is invalid. Expected " + sr + ", got " + qr);
      };
      for (const [ir, sr] of Object.entries(Dt))
        xt(ir, sr, !1);
      for (const [ir, sr] of Object.entries(er))
        xt(ir, sr, !0);
      return st;
    }
    function ke(st) {
      return typeof st == "function" && Number.isSafeInteger(st.outputLen);
    }
    function xe(st, Dt, er = {}) {
      if (!st || typeof st != "object")
        throw new Error("expected valid options object");
      function xt(ir, sr, yr) {
        const wr = st[ir];
        if (yr && wr === void 0)
          return;
        const qr = typeof wr;
        if (qr !== sr || wr === null)
          throw new Error(`param "${ir}" is invalid: expected ${sr}, got ${qr}`);
      }
      Object.entries(Dt).forEach(([ir, sr]) => xt(ir, sr, !1)), Object.entries(er).forEach(([ir, sr]) => xt(ir, sr, !0));
    }
    const Ne = () => {
      throw new Error("not implemented");
    };
    o.notImplemented = Ne;
    function Et(st) {
      const Dt = /* @__PURE__ */ new WeakMap();
      return (er, ...xt) => {
        const ir = Dt.get(er);
        if (ir !== void 0)
          return ir;
        const sr = st(er, ...xt);
        return Dt.set(er, sr), sr;
      };
    }
  }(utils$k)), utils$k;
}
var curve$2 = {}, modular$1 = {}, hasRequiredModular$1;
function requireModular$1() {
  if (hasRequiredModular$1) return modular$1;
  hasRequiredModular$1 = 1, Object.defineProperty(modular$1, "__esModule", { value: !0 }), modular$1.isNegativeLE = void 0, modular$1.mod = F, modular$1.pow = M, modular$1.pow2 = U, modular$1.invert = L, modular$1.tonelliShanks = Ee, modular$1.FpSqrt = Se, modular$1.validateField = Pe, modular$1.FpPow = De, modular$1.FpInvertBatch = ve, modular$1.FpDiv = Fe, modular$1.FpLegendre = be, modular$1.FpIsSquare = Be, modular$1.nLength = ke, modular$1.Field = xe, modular$1.FpSqrtOdd = Ne, modular$1.FpSqrtEven = Et, modular$1.hashToPrivateScalar = st, modular$1.getFieldBytesLength = Dt, modular$1.getMinHashLength = er, modular$1.mapHashToField = xt;
  const o = /* @__PURE__ */ requireUtils$i(), g = BigInt(0), c = BigInt(1), y = /* @__PURE__ */ BigInt(2), t = /* @__PURE__ */ BigInt(3), d = /* @__PURE__ */ BigInt(4), E = /* @__PURE__ */ BigInt(5), B = /* @__PURE__ */ BigInt(7), D = /* @__PURE__ */ BigInt(8), x = /* @__PURE__ */ BigInt(9), v = /* @__PURE__ */ BigInt(16);
  function F(ir, sr) {
    const yr = ir % sr;
    return yr >= g ? yr : sr + yr;
  }
  function M(ir, sr, yr) {
    return De(xe(yr), ir, sr);
  }
  function U(ir, sr, yr) {
    let wr = ir;
    for (; sr-- > g; )
      wr *= wr, wr %= yr;
    return wr;
  }
  function L(ir, sr) {
    if (ir === g)
      throw new Error("invert: expected non-zero number");
    if (sr <= g)
      throw new Error("invert: expected positive modulus, got " + sr);
    let yr = F(ir, sr), wr = sr, qr = g, Mr = c;
    for (; yr !== g; ) {
      const Qr = wr / yr, Xr = wr % yr, Vr = qr - Mr * Qr;
      wr = yr, yr = Xr, qr = Mr, Mr = Vr;
    }
    if (wr !== c)
      throw new Error("invert: does not exist");
    return F(qr, sr);
  }
  function H(ir, sr, yr) {
    if (!ir.eql(ir.sqr(sr), yr))
      throw new Error("Cannot find square root");
  }
  function fe(ir, sr) {
    const yr = (ir.ORDER + c) / d, wr = ir.pow(sr, yr);
    return H(ir, wr, sr), wr;
  }
  function ge(ir, sr) {
    const yr = (ir.ORDER - E) / D, wr = ir.mul(sr, y), qr = ir.pow(wr, yr), Mr = ir.mul(sr, qr), Dr = ir.mul(ir.mul(Mr, y), qr), Qr = ir.mul(Mr, ir.sub(Dr, ir.ONE));
    return H(ir, Qr, sr), Qr;
  }
  function Ie(ir) {
    const sr = xe(ir), yr = Ee(ir), wr = yr(sr, sr.neg(sr.ONE)), qr = yr(sr, wr), Mr = yr(sr, sr.neg(wr)), Dr = (ir + B) / v;
    return (Qr, Xr) => {
      let Vr = Qr.pow(Xr, Dr), Ur = Qr.mul(Vr, wr);
      const Sr = Qr.mul(Vr, qr), Gr = Qr.mul(Vr, Mr), Fr = Qr.eql(Qr.sqr(Ur), Xr), br = Qr.eql(Qr.sqr(Sr), Xr);
      Vr = Qr.cmov(Vr, Ur, Fr), Ur = Qr.cmov(Gr, Sr, br);
      const Ar = Qr.eql(Qr.sqr(Ur), Xr), cr = Qr.cmov(Vr, Ur, Ar);
      return H(Qr, cr, Xr), cr;
    };
  }
  function Ee(ir) {
    if (ir < t)
      throw new Error("sqrt is not defined for small field");
    let sr = ir - c, yr = 0;
    for (; sr % y === g; )
      sr /= y, yr++;
    let wr = y;
    const qr = xe(ir);
    for (; be(qr, wr) === 1; )
      if (wr++ > 1e3)
        throw new Error("Cannot find square root: probably non-prime P");
    if (yr === 1)
      return fe;
    let Mr = qr.pow(wr, sr);
    const Dr = (sr + c) / y;
    return function(Xr, Vr) {
      if (Xr.is0(Vr))
        return Vr;
      if (be(Xr, Vr) !== 1)
        throw new Error("Cannot find square root");
      let Ur = yr, Sr = Xr.mul(Xr.ONE, Mr), Gr = Xr.pow(Vr, sr), Fr = Xr.pow(Vr, Dr);
      for (; !Xr.eql(Gr, Xr.ONE); ) {
        if (Xr.is0(Gr))
          return Xr.ZERO;
        let br = 1, Ar = Xr.sqr(Gr);
        for (; !Xr.eql(Ar, Xr.ONE); )
          if (br++, Ar = Xr.sqr(Ar), br === Ur)
            throw new Error("Cannot find square root");
        const cr = c << BigInt(Ur - br - 1), hr = Xr.pow(Sr, cr);
        Ur = br, Sr = Xr.sqr(hr), Gr = Xr.mul(Gr, Sr), Fr = Xr.mul(Fr, hr);
      }
      return Fr;
    };
  }
  function Se(ir) {
    return ir % d === t ? fe : ir % D === E ? ge : ir % v === x ? Ie(ir) : Ee(ir);
  }
  const ze = (ir, sr) => (F(ir, sr) & c) === c;
  modular$1.isNegativeLE = ze;
  const He = [
    "create",
    "isValid",
    "is0",
    "neg",
    "inv",
    "sqrt",
    "sqr",
    "eql",
    "add",
    "sub",
    "mul",
    "pow",
    "div",
    "addN",
    "subN",
    "mulN",
    "sqrN"
  ];
  function Pe(ir) {
    const sr = {
      ORDER: "bigint",
      MASK: "bigint",
      BYTES: "number",
      BITS: "number"
    }, yr = He.reduce((wr, qr) => (wr[qr] = "function", wr), sr);
    return (0, o._validateObject)(ir, yr), ir;
  }
  function De(ir, sr, yr) {
    if (yr < g)
      throw new Error("invalid exponent, negatives unsupported");
    if (yr === g)
      return ir.ONE;
    if (yr === c)
      return sr;
    let wr = ir.ONE, qr = sr;
    for (; yr > g; )
      yr & c && (wr = ir.mul(wr, qr)), qr = ir.sqr(qr), yr >>= c;
    return wr;
  }
  function ve(ir, sr, yr = !1) {
    const wr = new Array(sr.length).fill(yr ? ir.ZERO : void 0), qr = sr.reduce((Dr, Qr, Xr) => ir.is0(Qr) ? Dr : (wr[Xr] = Dr, ir.mul(Dr, Qr)), ir.ONE), Mr = ir.inv(qr);
    return sr.reduceRight((Dr, Qr, Xr) => ir.is0(Qr) ? Dr : (wr[Xr] = ir.mul(Dr, wr[Xr]), ir.mul(Dr, Qr)), Mr), wr;
  }
  function Fe(ir, sr, yr) {
    return ir.mul(sr, typeof yr == "bigint" ? L(yr, ir.ORDER) : ir.inv(yr));
  }
  function be(ir, sr) {
    const yr = (ir.ORDER - c) / y, wr = ir.pow(sr, yr), qr = ir.eql(wr, ir.ONE), Mr = ir.eql(wr, ir.ZERO), Dr = ir.eql(wr, ir.neg(ir.ONE));
    if (!qr && !Mr && !Dr)
      throw new Error("invalid Legendre symbol result");
    return qr ? 1 : Mr ? 0 : -1;
  }
  function Be(ir, sr) {
    return be(ir, sr) === 1;
  }
  function ke(ir, sr) {
    sr !== void 0 && (0, o.anumber)(sr);
    const yr = sr !== void 0 ? sr : ir.toString(2).length, wr = Math.ceil(yr / 8);
    return { nBitLength: yr, nByteLength: wr };
  }
  function xe(ir, sr, yr = !1, wr = {}) {
    if (ir <= g)
      throw new Error("invalid field: expected ORDER > 0, got " + ir);
    let qr, Mr, Dr = !1, Qr;
    if (typeof sr == "object" && sr != null) {
      if (wr.sqrt || yr)
        throw new Error("cannot specify opts in two arguments");
      const Gr = sr;
      Gr.BITS && (qr = Gr.BITS), Gr.sqrt && (Mr = Gr.sqrt), typeof Gr.isLE == "boolean" && (yr = Gr.isLE), typeof Gr.modFromBytes == "boolean" && (Dr = Gr.modFromBytes), Qr = Gr.allowedLengths;
    } else
      typeof sr == "number" && (qr = sr), wr.sqrt && (Mr = wr.sqrt);
    const { nBitLength: Xr, nByteLength: Vr } = ke(ir, qr);
    if (Vr > 2048)
      throw new Error("invalid field: expected ORDER of <= 2048 bytes");
    let Ur;
    const Sr = Object.freeze({
      ORDER: ir,
      isLE: yr,
      BITS: Xr,
      BYTES: Vr,
      MASK: (0, o.bitMask)(Xr),
      ZERO: g,
      ONE: c,
      allowedLengths: Qr,
      create: (Gr) => F(Gr, ir),
      isValid: (Gr) => {
        if (typeof Gr != "bigint")
          throw new Error("invalid field element: expected bigint, got " + typeof Gr);
        return g <= Gr && Gr < ir;
      },
      is0: (Gr) => Gr === g,
      // is valid and invertible
      isValidNot0: (Gr) => !Sr.is0(Gr) && Sr.isValid(Gr),
      isOdd: (Gr) => (Gr & c) === c,
      neg: (Gr) => F(-Gr, ir),
      eql: (Gr, Fr) => Gr === Fr,
      sqr: (Gr) => F(Gr * Gr, ir),
      add: (Gr, Fr) => F(Gr + Fr, ir),
      sub: (Gr, Fr) => F(Gr - Fr, ir),
      mul: (Gr, Fr) => F(Gr * Fr, ir),
      pow: (Gr, Fr) => De(Sr, Gr, Fr),
      div: (Gr, Fr) => F(Gr * L(Fr, ir), ir),
      // Same as above, but doesn't normalize
      sqrN: (Gr) => Gr * Gr,
      addN: (Gr, Fr) => Gr + Fr,
      subN: (Gr, Fr) => Gr - Fr,
      mulN: (Gr, Fr) => Gr * Fr,
      inv: (Gr) => L(Gr, ir),
      sqrt: Mr || ((Gr) => (Ur || (Ur = Se(ir)), Ur(Sr, Gr))),
      toBytes: (Gr) => yr ? (0, o.numberToBytesLE)(Gr, Vr) : (0, o.numberToBytesBE)(Gr, Vr),
      fromBytes: (Gr, Fr = !0) => {
        if (Qr) {
          if (!Qr.includes(Gr.length) || Gr.length > Vr)
            throw new Error("Field.fromBytes: expected " + Qr + " bytes, got " + Gr.length);
          const Ar = new Uint8Array(Vr);
          Ar.set(Gr, yr ? 0 : Ar.length - Gr.length), Gr = Ar;
        }
        if (Gr.length !== Vr)
          throw new Error("Field.fromBytes: expected " + Vr + " bytes, got " + Gr.length);
        let br = yr ? (0, o.bytesToNumberLE)(Gr) : (0, o.bytesToNumberBE)(Gr);
        if (Dr && (br = F(br, ir)), !Fr && !Sr.isValid(br))
          throw new Error("invalid field element: outside of range 0..ORDER");
        return br;
      },
      // TODO: we don't need it here, move out to separate fn
      invertBatch: (Gr) => ve(Sr, Gr),
      // We can't move this out because Fp6, Fp12 implement it
      // and it's unclear what to return in there.
      cmov: (Gr, Fr, br) => br ? Fr : Gr
    });
    return Object.freeze(Sr);
  }
  function Ne(ir, sr) {
    if (!ir.isOdd)
      throw new Error("Field doesn't have isOdd");
    const yr = ir.sqrt(sr);
    return ir.isOdd(yr) ? yr : ir.neg(yr);
  }
  function Et(ir, sr) {
    if (!ir.isOdd)
      throw new Error("Field doesn't have isOdd");
    const yr = ir.sqrt(sr);
    return ir.isOdd(yr) ? ir.neg(yr) : yr;
  }
  function st(ir, sr, yr = !1) {
    ir = (0, o.ensureBytes)("privateHash", ir);
    const wr = ir.length, qr = ke(sr).nByteLength + 8;
    if (qr < 24 || wr < qr || wr > 1024)
      throw new Error("hashToPrivateScalar: expected " + qr + "-1024 bytes of input, got " + wr);
    const Mr = yr ? (0, o.bytesToNumberLE)(ir) : (0, o.bytesToNumberBE)(ir);
    return F(Mr, sr - c) + c;
  }
  function Dt(ir) {
    if (typeof ir != "bigint")
      throw new Error("field order must be bigint");
    const sr = ir.toString(2).length;
    return Math.ceil(sr / 8);
  }
  function er(ir) {
    const sr = Dt(ir);
    return sr + Math.ceil(sr / 2);
  }
  function xt(ir, sr, yr = !1) {
    const wr = ir.length, qr = Dt(sr), Mr = er(sr);
    if (wr < 16 || wr < Mr || wr > 1024)
      throw new Error("expected " + Mr + "-1024 bytes of input, got " + wr);
    const Dr = yr ? (0, o.bytesToNumberLE)(ir) : (0, o.bytesToNumberBE)(ir), Qr = F(Dr, sr - c) + c;
    return yr ? (0, o.numberToBytesLE)(Qr, qr) : (0, o.numberToBytesBE)(Qr, qr);
  }
  return modular$1;
}
var hasRequiredCurve$2;
function requireCurve$2() {
  if (hasRequiredCurve$2) return curve$2;
  hasRequiredCurve$2 = 1, Object.defineProperty(curve$2, "__esModule", { value: !0 }), curve$2.wNAF = void 0, curve$2.negateCt = t, curve$2.normalizeZ = d, curve$2.mulEndoUnsafe = fe, curve$2.pippenger = ge, curve$2.precomputeMSMUnsafe = Ie, curve$2.validateBasic = Ee, curve$2._createCurveFields = ze;
  const o = /* @__PURE__ */ requireUtils$i(), g = /* @__PURE__ */ requireModular$1(), c = BigInt(0), y = BigInt(1);
  function t(He, Pe) {
    const De = Pe.negate();
    return He ? De : Pe;
  }
  function d(He, Pe) {
    const De = (0, g.FpInvertBatch)(He.Fp, Pe.map((ve) => ve.Z));
    return Pe.map((ve, Fe) => He.fromAffine(ve.toAffine(De[Fe])));
  }
  function E(He, Pe) {
    if (!Number.isSafeInteger(He) || He <= 0 || He > Pe)
      throw new Error("invalid window size, expected [1.." + Pe + "], got W=" + He);
  }
  function B(He, Pe) {
    E(He, Pe);
    const De = Math.ceil(Pe / He) + 1, ve = 2 ** (He - 1), Fe = 2 ** He, be = (0, o.bitMask)(He), Be = BigInt(He);
    return { windows: De, windowSize: ve, mask: be, maxNumber: Fe, shiftBy: Be };
  }
  function D(He, Pe, De) {
    const { windowSize: ve, mask: Fe, maxNumber: be, shiftBy: Be } = De;
    let ke = Number(He & Fe), xe = He >> Be;
    ke > ve && (ke -= be, xe += y);
    const Ne = Pe * ve, Et = Ne + Math.abs(ke) - 1, st = ke === 0, Dt = ke < 0, er = Pe % 2 !== 0;
    return { nextN: xe, offset: Et, isZero: st, isNeg: Dt, isNegF: er, offsetF: Ne };
  }
  function x(He, Pe) {
    if (!Array.isArray(He))
      throw new Error("array expected");
    He.forEach((De, ve) => {
      if (!(De instanceof Pe))
        throw new Error("invalid point at index " + ve);
    });
  }
  function v(He, Pe) {
    if (!Array.isArray(He))
      throw new Error("array of scalars expected");
    He.forEach((De, ve) => {
      if (!Pe.isValid(De))
        throw new Error("invalid scalar at index " + ve);
    });
  }
  const F = /* @__PURE__ */ new WeakMap(), M = /* @__PURE__ */ new WeakMap();
  function U(He) {
    return M.get(He) || 1;
  }
  function L(He) {
    if (He !== c)
      throw new Error("invalid wNAF");
  }
  class H {
    // Parametrized with a given Point class (not individual point)
    constructor(Pe, De) {
      this.BASE = Pe.BASE, this.ZERO = Pe.ZERO, this.Fn = Pe.Fn, this.bits = De;
    }
    // non-const time multiplication ladder
    _unsafeLadder(Pe, De, ve = this.ZERO) {
      let Fe = Pe;
      for (; De > c; )
        De & y && (ve = ve.add(Fe)), Fe = Fe.double(), De >>= y;
      return ve;
    }
    /**
     * Creates a wNAF precomputation window. Used for caching.
     * Default window size is set by `utils.precompute()` and is equal to 8.
     * Number of precomputed points depends on the curve size:
     * 2^(𝑊−1) * (Math.ceil(𝑛 / 𝑊) + 1), where:
     * - 𝑊 is the window size
     * - 𝑛 is the bitlength of the curve order.
     * For a 256-bit curve and window size 8, the number of precomputed points is 128 * 33 = 4224.
     * @param point Point instance
     * @param W window size
     * @returns precomputed point tables flattened to a single array
     */
    precomputeWindow(Pe, De) {
      const { windows: ve, windowSize: Fe } = B(De, this.bits), be = [];
      let Be = Pe, ke = Be;
      for (let xe = 0; xe < ve; xe++) {
        ke = Be, be.push(ke);
        for (let Ne = 1; Ne < Fe; Ne++)
          ke = ke.add(Be), be.push(ke);
        Be = ke.double();
      }
      return be;
    }
    /**
     * Implements ec multiplication using precomputed tables and w-ary non-adjacent form.
     * More compact implementation:
     * https://github.com/paulmillr/noble-secp256k1/blob/47cb1669b6e506ad66b35fe7d76132ae97465da2/index.ts#L502-L541
     * @returns real and fake (for const-time) points
     */
    wNAF(Pe, De, ve) {
      if (!this.Fn.isValid(ve))
        throw new Error("invalid scalar");
      let Fe = this.ZERO, be = this.BASE;
      const Be = B(Pe, this.bits);
      for (let ke = 0; ke < Be.windows; ke++) {
        const { nextN: xe, offset: Ne, isZero: Et, isNeg: st, isNegF: Dt, offsetF: er } = D(ve, ke, Be);
        ve = xe, Et ? be = be.add(t(Dt, De[er])) : Fe = Fe.add(t(st, De[Ne]));
      }
      return L(ve), { p: Fe, f: be };
    }
    /**
     * Implements ec unsafe (non const-time) multiplication using precomputed tables and w-ary non-adjacent form.
     * @param acc accumulator point to add result of multiplication
     * @returns point
     */
    wNAFUnsafe(Pe, De, ve, Fe = this.ZERO) {
      const be = B(Pe, this.bits);
      for (let Be = 0; Be < be.windows && ve !== c; Be++) {
        const { nextN: ke, offset: xe, isZero: Ne, isNeg: Et } = D(ve, Be, be);
        if (ve = ke, !Ne) {
          const st = De[xe];
          Fe = Fe.add(Et ? st.negate() : st);
        }
      }
      return L(ve), Fe;
    }
    getPrecomputes(Pe, De, ve) {
      let Fe = F.get(De);
      return Fe || (Fe = this.precomputeWindow(De, Pe), Pe !== 1 && (typeof ve == "function" && (Fe = ve(Fe)), F.set(De, Fe))), Fe;
    }
    cached(Pe, De, ve) {
      const Fe = U(Pe);
      return this.wNAF(Fe, this.getPrecomputes(Fe, Pe, ve), De);
    }
    unsafe(Pe, De, ve, Fe) {
      const be = U(Pe);
      return be === 1 ? this._unsafeLadder(Pe, De, Fe) : this.wNAFUnsafe(be, this.getPrecomputes(be, Pe, ve), De, Fe);
    }
    // We calculate precomputes for elliptic curve point multiplication
    // using windowed method. This specifies window size and
    // stores precomputed values. Usually only base point would be precomputed.
    createCache(Pe, De) {
      E(De, this.bits), M.set(Pe, De), F.delete(Pe);
    }
    hasCache(Pe) {
      return U(Pe) !== 1;
    }
  }
  curve$2.wNAF = H;
  function fe(He, Pe, De, ve) {
    let Fe = Pe, be = He.ZERO, Be = He.ZERO;
    for (; De > c || ve > c; )
      De & y && (be = be.add(Fe)), ve & y && (Be = Be.add(Fe)), Fe = Fe.double(), De >>= y, ve >>= y;
    return { p1: be, p2: Be };
  }
  function ge(He, Pe, De, ve) {
    x(De, He), v(ve, Pe);
    const Fe = De.length, be = ve.length;
    if (Fe !== be)
      throw new Error("arrays of points and scalars must have equal length");
    const Be = He.ZERO, ke = (0, o.bitLen)(BigInt(Fe));
    let xe = 1;
    ke > 12 ? xe = ke - 3 : ke > 4 ? xe = ke - 2 : ke > 0 && (xe = 2);
    const Ne = (0, o.bitMask)(xe), Et = new Array(Number(Ne) + 1).fill(Be), st = Math.floor((Pe.BITS - 1) / xe) * xe;
    let Dt = Be;
    for (let er = st; er >= 0; er -= xe) {
      Et.fill(Be);
      for (let ir = 0; ir < be; ir++) {
        const sr = ve[ir], yr = Number(sr >> BigInt(er) & Ne);
        Et[yr] = Et[yr].add(De[ir]);
      }
      let xt = Be;
      for (let ir = Et.length - 1, sr = Be; ir > 0; ir--)
        sr = sr.add(Et[ir]), xt = xt.add(sr);
      if (Dt = Dt.add(xt), er !== 0)
        for (let ir = 0; ir < xe; ir++)
          Dt = Dt.double();
    }
    return Dt;
  }
  function Ie(He, Pe, De, ve) {
    E(ve, Pe.BITS), x(De, He);
    const Fe = He.ZERO, be = 2 ** ve - 1, Be = Math.ceil(Pe.BITS / ve), ke = (0, o.bitMask)(ve), xe = De.map((Ne) => {
      const Et = [];
      for (let st = 0, Dt = Ne; st < be; st++)
        Et.push(Dt), Dt = Dt.add(Ne);
      return Et;
    });
    return (Ne) => {
      if (v(Ne, Pe), Ne.length > De.length)
        throw new Error("array of scalars must be smaller than array of points");
      let Et = Fe;
      for (let st = 0; st < Be; st++) {
        if (Et !== Fe)
          for (let er = 0; er < ve; er++)
            Et = Et.double();
        const Dt = BigInt(Be * ve - (st + 1) * ve);
        for (let er = 0; er < Ne.length; er++) {
          const xt = Ne[er], ir = Number(xt >> Dt & ke);
          ir && (Et = Et.add(xe[er][ir - 1]));
        }
      }
      return Et;
    };
  }
  function Ee(He) {
    return (0, g.validateField)(He.Fp), (0, o.validateObject)(He, {
      n: "bigint",
      h: "bigint",
      Gx: "field",
      Gy: "field"
    }, {
      nBitLength: "isSafeInteger",
      nByteLength: "isSafeInteger"
    }), Object.freeze({
      ...(0, g.nLength)(He.n, He.nBitLength),
      ...He,
      p: He.Fp.ORDER
    });
  }
  function Se(He, Pe, De) {
    if (Pe) {
      if (Pe.ORDER !== He)
        throw new Error("Field.ORDER must match order: Fp == p, Fn == n");
      return (0, g.validateField)(Pe), Pe;
    } else
      return (0, g.Field)(He, { isLE: De });
  }
  function ze(He, Pe, De = {}, ve) {
    if (ve === void 0 && (ve = He === "edwards"), !Pe || typeof Pe != "object")
      throw new Error(`expected valid ${He} CURVE object`);
    for (const xe of ["p", "n", "h"]) {
      const Ne = Pe[xe];
      if (!(typeof Ne == "bigint" && Ne > c))
        throw new Error(`CURVE.${xe} must be positive bigint`);
    }
    const Fe = Se(Pe.p, De.Fp, ve), be = Se(Pe.n, De.Fn, ve), ke = ["Gx", "Gy", "a", He === "weierstrass" ? "b" : "d"];
    for (const xe of ke)
      if (!Fe.isValid(Pe[xe]))
        throw new Error(`CURVE.${xe} must be valid field element of CURVE.Fp`);
    return Pe = Object.freeze(Object.assign({}, Pe)), { CURVE: Pe, Fp: Fe, Fn: be };
  }
  return curve$2;
}
var hasRequiredWeierstrass$1;
function requireWeierstrass$1() {
  return hasRequiredWeierstrass$1 || (hasRequiredWeierstrass$1 = 1, function(o) {
    Object.defineProperty(o, "__esModule", { value: !0 }), o.DER = o.DERErr = void 0, o._splitEndoScalar = B, o._normFnElement = fe, o.weierstrassN = ge, o.SWUFpSqrtRatio = Ee, o.mapToCurveSimpleSWU = Se, o.ecdh = He, o.ecdsa = Pe, o.weierstrassPoints = De, o._legacyHelperEquat = be, o.weierstrass = xe;
    const g = /* @__PURE__ */ requireHmac$3(), c = /* @__PURE__ */ requireUtils$j(), y = /* @__PURE__ */ requireUtils$i(), t = /* @__PURE__ */ requireCurve$2(), d = /* @__PURE__ */ requireModular$1(), E = (Ne, Et) => (Ne + (Ne >= 0 ? Et : -Et) / U) / Et;
    function B(Ne, Et, st) {
      const [[Dt, er], [xt, ir]] = Et, sr = E(ir * Ne, st), yr = E(-er * Ne, st);
      let wr = Ne - sr * Dt - yr * xt, qr = -sr * er - yr * ir;
      const Mr = wr < F, Dr = qr < F;
      Mr && (wr = -wr), Dr && (qr = -qr);
      const Qr = (0, y.bitMask)(Math.ceil((0, y.bitLen)(st) / 2)) + M;
      if (wr < F || wr >= Qr || qr < F || qr >= Qr)
        throw new Error("splitScalar (endomorphism): failed, k=" + Ne);
      return { k1neg: Mr, k1: wr, k2neg: Dr, k2: qr };
    }
    function D(Ne) {
      if (!["compact", "recovered", "der"].includes(Ne))
        throw new Error('Signature format must be "compact", "recovered", or "der"');
      return Ne;
    }
    function x(Ne, Et) {
      const st = {};
      for (let Dt of Object.keys(Et))
        st[Dt] = Ne[Dt] === void 0 ? Et[Dt] : Ne[Dt];
      return (0, y._abool2)(st.lowS, "lowS"), (0, y._abool2)(st.prehash, "prehash"), st.format !== void 0 && D(st.format), st;
    }
    class v extends Error {
      constructor(Et = "") {
        super(Et);
      }
    }
    o.DERErr = v, o.DER = {
      // asn.1 DER encoding utils
      Err: v,
      // Basic building block is TLV (Tag-Length-Value)
      _tlv: {
        encode: (Ne, Et) => {
          const { Err: st } = o.DER;
          if (Ne < 0 || Ne > 256)
            throw new st("tlv.encode: wrong tag");
          if (Et.length & 1)
            throw new st("tlv.encode: unpadded data");
          const Dt = Et.length / 2, er = (0, y.numberToHexUnpadded)(Dt);
          if (er.length / 2 & 128)
            throw new st("tlv.encode: long form length too big");
          const xt = Dt > 127 ? (0, y.numberToHexUnpadded)(er.length / 2 | 128) : "";
          return (0, y.numberToHexUnpadded)(Ne) + xt + er + Et;
        },
        // v - value, l - left bytes (unparsed)
        decode(Ne, Et) {
          const { Err: st } = o.DER;
          let Dt = 0;
          if (Ne < 0 || Ne > 256)
            throw new st("tlv.encode: wrong tag");
          if (Et.length < 2 || Et[Dt++] !== Ne)
            throw new st("tlv.decode: wrong tlv");
          const er = Et[Dt++], xt = !!(er & 128);
          let ir = 0;
          if (!xt)
            ir = er;
          else {
            const yr = er & 127;
            if (!yr)
              throw new st("tlv.decode(long): indefinite length not supported");
            if (yr > 4)
              throw new st("tlv.decode(long): byte length is too big");
            const wr = Et.subarray(Dt, Dt + yr);
            if (wr.length !== yr)
              throw new st("tlv.decode: length bytes not complete");
            if (wr[0] === 0)
              throw new st("tlv.decode(long): zero leftmost byte");
            for (const qr of wr)
              ir = ir << 8 | qr;
            if (Dt += yr, ir < 128)
              throw new st("tlv.decode(long): not minimal encoding");
          }
          const sr = Et.subarray(Dt, Dt + ir);
          if (sr.length !== ir)
            throw new st("tlv.decode: wrong value length");
          return { v: sr, l: Et.subarray(Dt + ir) };
        }
      },
      // https://crypto.stackexchange.com/a/57734 Leftmost bit of first byte is 'negative' flag,
      // since we always use positive integers here. It must always be empty:
      // - add zero byte if exists
      // - if next byte doesn't have a flag, leading zero is not allowed (minimal encoding)
      _int: {
        encode(Ne) {
          const { Err: Et } = o.DER;
          if (Ne < F)
            throw new Et("integer: negative integers are not allowed");
          let st = (0, y.numberToHexUnpadded)(Ne);
          if (Number.parseInt(st[0], 16) & 8 && (st = "00" + st), st.length & 1)
            throw new Et("unexpected DER parsing assertion: unpadded hex");
          return st;
        },
        decode(Ne) {
          const { Err: Et } = o.DER;
          if (Ne[0] & 128)
            throw new Et("invalid signature integer: negative");
          if (Ne[0] === 0 && !(Ne[1] & 128))
            throw new Et("invalid signature integer: unnecessary leading zero");
          return (0, y.bytesToNumberBE)(Ne);
        }
      },
      toSig(Ne) {
        const { Err: Et, _int: st, _tlv: Dt } = o.DER, er = (0, y.ensureBytes)("signature", Ne), { v: xt, l: ir } = Dt.decode(48, er);
        if (ir.length)
          throw new Et("invalid signature: left bytes after parsing");
        const { v: sr, l: yr } = Dt.decode(2, xt), { v: wr, l: qr } = Dt.decode(2, yr);
        if (qr.length)
          throw new Et("invalid signature: left bytes after parsing");
        return { r: st.decode(sr), s: st.decode(wr) };
      },
      hexFromSig(Ne) {
        const { _tlv: Et, _int: st } = o.DER, Dt = Et.encode(2, st.encode(Ne.r)), er = Et.encode(2, st.encode(Ne.s)), xt = Dt + er;
        return Et.encode(48, xt);
      }
    };
    const F = BigInt(0), M = BigInt(1), U = BigInt(2), L = BigInt(3), H = BigInt(4);
    function fe(Ne, Et) {
      const { BYTES: st } = Ne;
      let Dt;
      if (typeof Et == "bigint")
        Dt = Et;
      else {
        let er = (0, y.ensureBytes)("private key", Et);
        try {
          Dt = Ne.fromBytes(er);
        } catch {
          throw new Error(`invalid private key: expected ui8a of size ${st}, got ${typeof Et}`);
        }
      }
      if (!Ne.isValidNot0(Dt))
        throw new Error("invalid private key: out of range [1..N-1]");
      return Dt;
    }
    function ge(Ne, Et = {}) {
      const st = (0, t._createCurveFields)("weierstrass", Ne, Et), { Fp: Dt, Fn: er } = st;
      let xt = st.CURVE;
      const { h: ir, n: sr } = xt;
      (0, y._validateObject)(Et, {}, {
        allowInfinityPoint: "boolean",
        clearCofactor: "function",
        isTorsionFree: "function",
        fromBytes: "function",
        toBytes: "function",
        endo: "object",
        wrapPrivateKey: "boolean"
      });
      const { endo: yr } = Et;
      if (yr && (!Dt.is0(xt.a) || typeof yr.beta != "bigint" || !Array.isArray(yr.basises)))
        throw new Error('invalid endo: expected "beta": bigint and "basises": array');
      const wr = ze(Dt, er);
      function qr() {
        if (!Dt.isOdd)
          throw new Error("compression is not supported: Field does not have .isOdd()");
      }
      function Mr(oi, zr, ti) {
        const { x: Lr, y: Rr } = zr.toAffine(), Ir = Dt.toBytes(Lr);
        if ((0, y._abool2)(ti, "isCompressed"), ti) {
          qr();
          const pr = !Dt.isOdd(Rr);
          return (0, y.concatBytes)(Ie(pr), Ir);
        } else
          return (0, y.concatBytes)(Uint8Array.of(4), Ir, Dt.toBytes(Rr));
      }
      function Dr(oi) {
        (0, y._abytes2)(oi, void 0, "Point");
        const { publicKey: zr, publicKeyUncompressed: ti } = wr, Lr = oi.length, Rr = oi[0], Ir = oi.subarray(1);
        if (Lr === zr && (Rr === 2 || Rr === 3)) {
          const pr = Dt.fromBytes(Ir);
          if (!Dt.isValid(pr))
            throw new Error("bad point: is not on curve, wrong x");
          const Cr = Vr(pr);
          let Er;
          try {
            Er = Dt.sqrt(Cr);
          } catch (Ci) {
            const bi = Ci instanceof Error ? ": " + Ci.message : "";
            throw new Error("bad point: is not on curve, sqrt error" + bi);
          }
          qr();
          const xr = Dt.isOdd(Er);
          return (Rr & 1) === 1 !== xr && (Er = Dt.neg(Er)), { x: pr, y: Er };
        } else if (Lr === ti && Rr === 4) {
          const pr = Dt.BYTES, Cr = Dt.fromBytes(Ir.subarray(0, pr)), Er = Dt.fromBytes(Ir.subarray(pr, pr * 2));
          if (!Ur(Cr, Er))
            throw new Error("bad point: is not on curve");
          return { x: Cr, y: Er };
        } else
          throw new Error(`bad point: got length ${Lr}, expected compressed=${zr} or uncompressed=${ti}`);
      }
      const Qr = Et.toBytes || Mr, Xr = Et.fromBytes || Dr;
      function Vr(oi) {
        const zr = Dt.sqr(oi), ti = Dt.mul(zr, oi);
        return Dt.add(Dt.add(ti, Dt.mul(oi, xt.a)), xt.b);
      }
      function Ur(oi, zr) {
        const ti = Dt.sqr(zr), Lr = Vr(oi);
        return Dt.eql(ti, Lr);
      }
      if (!Ur(xt.Gx, xt.Gy))
        throw new Error("bad curve params: generator point");
      const Sr = Dt.mul(Dt.pow(xt.a, L), H), Gr = Dt.mul(Dt.sqr(xt.b), BigInt(27));
      if (Dt.is0(Dt.add(Sr, Gr)))
        throw new Error("bad curve params: a or b");
      function Fr(oi, zr, ti = !1) {
        if (!Dt.isValid(zr) || ti && Dt.is0(zr))
          throw new Error(`bad point coordinate ${oi}`);
        return zr;
      }
      function br(oi) {
        if (!(oi instanceof fi))
          throw new Error("ProjectivePoint expected");
      }
      function Ar(oi) {
        if (!yr || !yr.basises)
          throw new Error("no endo");
        return B(oi, yr.basises, er.ORDER);
      }
      const cr = (0, y.memoized)((oi, zr) => {
        const { X: ti, Y: Lr, Z: Rr } = oi;
        if (Dt.eql(Rr, Dt.ONE))
          return { x: ti, y: Lr };
        const Ir = oi.is0();
        zr == null && (zr = Ir ? Dt.ONE : Dt.inv(Rr));
        const pr = Dt.mul(ti, zr), Cr = Dt.mul(Lr, zr), Er = Dt.mul(Rr, zr);
        if (Ir)
          return { x: Dt.ZERO, y: Dt.ZERO };
        if (!Dt.eql(Er, Dt.ONE))
          throw new Error("invZ was invalid");
        return { x: pr, y: Cr };
      }), hr = (0, y.memoized)((oi) => {
        if (oi.is0()) {
          if (Et.allowInfinityPoint && !Dt.is0(oi.Y))
            return;
          throw new Error("bad point: ZERO");
        }
        const { x: zr, y: ti } = oi.toAffine();
        if (!Dt.isValid(zr) || !Dt.isValid(ti))
          throw new Error("bad point: x or y not field elements");
        if (!Ur(zr, ti))
          throw new Error("bad point: equation left != right");
        if (!oi.isTorsionFree())
          throw new Error("bad point: not in prime-order subgroup");
        return !0;
      });
      function Wr(oi, zr, ti, Lr, Rr) {
        return ti = new fi(Dt.mul(ti.X, oi), ti.Y, ti.Z), zr = (0, t.negateCt)(Lr, zr), ti = (0, t.negateCt)(Rr, ti), zr.add(ti);
      }
      class fi {
        /** Does NOT validate if the point is valid. Use `.assertValidity()`. */
        constructor(zr, ti, Lr) {
          this.X = Fr("x", zr), this.Y = Fr("y", ti, !0), this.Z = Fr("z", Lr), Object.freeze(this);
        }
        static CURVE() {
          return xt;
        }
        /** Does NOT validate if the point is valid. Use `.assertValidity()`. */
        static fromAffine(zr) {
          const { x: ti, y: Lr } = zr || {};
          if (!zr || !Dt.isValid(ti) || !Dt.isValid(Lr))
            throw new Error("invalid affine point");
          if (zr instanceof fi)
            throw new Error("projective point not allowed");
          return Dt.is0(ti) && Dt.is0(Lr) ? fi.ZERO : new fi(ti, Lr, Dt.ONE);
        }
        static fromBytes(zr) {
          const ti = fi.fromAffine(Xr((0, y._abytes2)(zr, void 0, "point")));
          return ti.assertValidity(), ti;
        }
        static fromHex(zr) {
          return fi.fromBytes((0, y.ensureBytes)("pointHex", zr));
        }
        get x() {
          return this.toAffine().x;
        }
        get y() {
          return this.toAffine().y;
        }
        /**
         *
         * @param windowSize
         * @param isLazy true will defer table computation until the first multiplication
         * @returns
         */
        precompute(zr = 8, ti = !0) {
          return $r.createCache(this, zr), ti || this.multiply(L), this;
        }
        // TODO: return `this`
        /** A point on curve is valid if it conforms to equation. */
        assertValidity() {
          hr(this);
        }
        hasEvenY() {
          const { y: zr } = this.toAffine();
          if (!Dt.isOdd)
            throw new Error("Field doesn't support isOdd");
          return !Dt.isOdd(zr);
        }
        /** Compare one point to another. */
        equals(zr) {
          br(zr);
          const { X: ti, Y: Lr, Z: Rr } = this, { X: Ir, Y: pr, Z: Cr } = zr, Er = Dt.eql(Dt.mul(ti, Cr), Dt.mul(Ir, Rr)), xr = Dt.eql(Dt.mul(Lr, Cr), Dt.mul(pr, Rr));
          return Er && xr;
        }
        /** Flips point to one corresponding to (x, -y) in Affine coordinates. */
        negate() {
          return new fi(this.X, Dt.neg(this.Y), this.Z);
        }
        // Renes-Costello-Batina exception-free doubling formula.
        // There is 30% faster Jacobian formula, but it is not complete.
        // https://eprint.iacr.org/2015/1060, algorithm 3
        // Cost: 8M + 3S + 3*a + 2*b3 + 15add.
        double() {
          const { a: zr, b: ti } = xt, Lr = Dt.mul(ti, L), { X: Rr, Y: Ir, Z: pr } = this;
          let Cr = Dt.ZERO, Er = Dt.ZERO, xr = Dt.ZERO, si = Dt.mul(Rr, Rr), Ci = Dt.mul(Ir, Ir), bi = Dt.mul(pr, pr), Ri = Dt.mul(Rr, Ir);
          return Ri = Dt.add(Ri, Ri), xr = Dt.mul(Rr, pr), xr = Dt.add(xr, xr), Cr = Dt.mul(zr, xr), Er = Dt.mul(Lr, bi), Er = Dt.add(Cr, Er), Cr = Dt.sub(Ci, Er), Er = Dt.add(Ci, Er), Er = Dt.mul(Cr, Er), Cr = Dt.mul(Ri, Cr), xr = Dt.mul(Lr, xr), bi = Dt.mul(zr, bi), Ri = Dt.sub(si, bi), Ri = Dt.mul(zr, Ri), Ri = Dt.add(Ri, xr), xr = Dt.add(si, si), si = Dt.add(xr, si), si = Dt.add(si, bi), si = Dt.mul(si, Ri), Er = Dt.add(Er, si), bi = Dt.mul(Ir, pr), bi = Dt.add(bi, bi), si = Dt.mul(bi, Ri), Cr = Dt.sub(Cr, si), xr = Dt.mul(bi, Ci), xr = Dt.add(xr, xr), xr = Dt.add(xr, xr), new fi(Cr, Er, xr);
        }
        // Renes-Costello-Batina exception-free addition formula.
        // There is 30% faster Jacobian formula, but it is not complete.
        // https://eprint.iacr.org/2015/1060, algorithm 1
        // Cost: 12M + 0S + 3*a + 3*b3 + 23add.
        add(zr) {
          br(zr);
          const { X: ti, Y: Lr, Z: Rr } = this, { X: Ir, Y: pr, Z: Cr } = zr;
          let Er = Dt.ZERO, xr = Dt.ZERO, si = Dt.ZERO;
          const Ci = xt.a, bi = Dt.mul(xt.b, L);
          let Ri = Dt.mul(ti, Ir), li = Dt.mul(Lr, pr), zi = Dt.mul(Rr, Cr), Kn = Dt.add(ti, Lr), Hn = Dt.add(Ir, pr);
          Kn = Dt.mul(Kn, Hn), Hn = Dt.add(Ri, li), Kn = Dt.sub(Kn, Hn), Hn = Dt.add(ti, Rr);
          let os = Dt.add(Ir, Cr);
          return Hn = Dt.mul(Hn, os), os = Dt.add(Ri, zi), Hn = Dt.sub(Hn, os), os = Dt.add(Lr, Rr), Er = Dt.add(pr, Cr), os = Dt.mul(os, Er), Er = Dt.add(li, zi), os = Dt.sub(os, Er), si = Dt.mul(Ci, Hn), Er = Dt.mul(bi, zi), si = Dt.add(Er, si), Er = Dt.sub(li, si), si = Dt.add(li, si), xr = Dt.mul(Er, si), li = Dt.add(Ri, Ri), li = Dt.add(li, Ri), zi = Dt.mul(Ci, zi), Hn = Dt.mul(bi, Hn), li = Dt.add(li, zi), zi = Dt.sub(Ri, zi), zi = Dt.mul(Ci, zi), Hn = Dt.add(Hn, zi), Ri = Dt.mul(li, Hn), xr = Dt.add(xr, Ri), Ri = Dt.mul(os, Hn), Er = Dt.mul(Kn, Er), Er = Dt.sub(Er, Ri), Ri = Dt.mul(Kn, li), si = Dt.mul(os, si), si = Dt.add(si, Ri), new fi(Er, xr, si);
        }
        subtract(zr) {
          return this.add(zr.negate());
        }
        is0() {
          return this.equals(fi.ZERO);
        }
        /**
         * Constant time multiplication.
         * Uses wNAF method. Windowed method may be 10% faster,
         * but takes 2x longer to generate and consumes 2x memory.
         * Uses precomputes when available.
         * Uses endomorphism for Koblitz curves.
         * @param scalar by which the point would be multiplied
         * @returns New point
         */
        multiply(zr) {
          const { endo: ti } = Et;
          if (!er.isValidNot0(zr))
            throw new Error("invalid scalar: out of range");
          let Lr, Rr;
          const Ir = (pr) => $r.cached(this, pr, (Cr) => (0, t.normalizeZ)(fi, Cr));
          if (ti) {
            const { k1neg: pr, k1: Cr, k2neg: Er, k2: xr } = Ar(zr), { p: si, f: Ci } = Ir(Cr), { p: bi, f: Ri } = Ir(xr);
            Rr = Ci.add(Ri), Lr = Wr(ti.beta, si, bi, pr, Er);
          } else {
            const { p: pr, f: Cr } = Ir(zr);
            Lr = pr, Rr = Cr;
          }
          return (0, t.normalizeZ)(fi, [Lr, Rr])[0];
        }
        /**
         * Non-constant-time multiplication. Uses double-and-add algorithm.
         * It's faster, but should only be used when you don't care about
         * an exposed secret key e.g. sig verification, which works over *public* keys.
         */
        multiplyUnsafe(zr) {
          const { endo: ti } = Et, Lr = this;
          if (!er.isValid(zr))
            throw new Error("invalid scalar: out of range");
          if (zr === F || Lr.is0())
            return fi.ZERO;
          if (zr === M)
            return Lr;
          if ($r.hasCache(this))
            return this.multiply(zr);
          if (ti) {
            const { k1neg: Rr, k1: Ir, k2neg: pr, k2: Cr } = Ar(zr), { p1: Er, p2: xr } = (0, t.mulEndoUnsafe)(fi, Lr, Ir, Cr);
            return Wr(ti.beta, Er, xr, Rr, pr);
          } else
            return $r.unsafe(Lr, zr);
        }
        multiplyAndAddUnsafe(zr, ti, Lr) {
          const Rr = this.multiplyUnsafe(ti).add(zr.multiplyUnsafe(Lr));
          return Rr.is0() ? void 0 : Rr;
        }
        /**
         * Converts Projective point to affine (x, y) coordinates.
         * @param invertedZ Z^-1 (inverted zero) - optional, precomputation is useful for invertBatch
         */
        toAffine(zr) {
          return cr(this, zr);
        }
        /**
         * Checks whether Point is free of torsion elements (is in prime subgroup).
         * Always torsion-free for cofactor=1 curves.
         */
        isTorsionFree() {
          const { isTorsionFree: zr } = Et;
          return ir === M ? !0 : zr ? zr(fi, this) : $r.unsafe(this, sr).is0();
        }
        clearCofactor() {
          const { clearCofactor: zr } = Et;
          return ir === M ? this : zr ? zr(fi, this) : this.multiplyUnsafe(ir);
        }
        isSmallOrder() {
          return this.multiplyUnsafe(ir).is0();
        }
        toBytes(zr = !0) {
          return (0, y._abool2)(zr, "isCompressed"), this.assertValidity(), Qr(fi, this, zr);
        }
        toHex(zr = !0) {
          return (0, y.bytesToHex)(this.toBytes(zr));
        }
        toString() {
          return `<Point ${this.is0() ? "ZERO" : this.toHex()}>`;
        }
        // TODO: remove
        get px() {
          return this.X;
        }
        get py() {
          return this.X;
        }
        get pz() {
          return this.Z;
        }
        toRawBytes(zr = !0) {
          return this.toBytes(zr);
        }
        _setWindowSize(zr) {
          this.precompute(zr);
        }
        static normalizeZ(zr) {
          return (0, t.normalizeZ)(fi, zr);
        }
        static msm(zr, ti) {
          return (0, t.pippenger)(fi, er, zr, ti);
        }
        static fromPrivateKey(zr) {
          return fi.BASE.multiply(fe(er, zr));
        }
      }
      fi.BASE = new fi(xt.Gx, xt.Gy, Dt.ONE), fi.ZERO = new fi(Dt.ZERO, Dt.ONE, Dt.ZERO), fi.Fp = Dt, fi.Fn = er;
      const Bi = er.BITS, $r = new t.wNAF(fi, Et.endo ? Math.ceil(Bi / 2) : Bi);
      return fi.BASE.precompute(8), fi;
    }
    function Ie(Ne) {
      return Uint8Array.of(Ne ? 2 : 3);
    }
    function Ee(Ne, Et) {
      const st = Ne.ORDER;
      let Dt = F;
      for (let Xr = st - M; Xr % U === F; Xr /= U)
        Dt += M;
      const er = Dt, xt = U << er - M - M, ir = xt * U, sr = (st - M) / ir, yr = (sr - M) / U, wr = ir - M, qr = xt, Mr = Ne.pow(Et, sr), Dr = Ne.pow(Et, (sr + M) / U);
      let Qr = (Xr, Vr) => {
        let Ur = Mr, Sr = Ne.pow(Vr, wr), Gr = Ne.sqr(Sr);
        Gr = Ne.mul(Gr, Vr);
        let Fr = Ne.mul(Xr, Gr);
        Fr = Ne.pow(Fr, yr), Fr = Ne.mul(Fr, Sr), Sr = Ne.mul(Fr, Vr), Gr = Ne.mul(Fr, Xr);
        let br = Ne.mul(Gr, Sr);
        Fr = Ne.pow(br, qr);
        let Ar = Ne.eql(Fr, Ne.ONE);
        Sr = Ne.mul(Gr, Dr), Fr = Ne.mul(br, Ur), Gr = Ne.cmov(Sr, Gr, Ar), br = Ne.cmov(Fr, br, Ar);
        for (let cr = er; cr > M; cr--) {
          let hr = cr - U;
          hr = U << hr - M;
          let Wr = Ne.pow(br, hr);
          const fi = Ne.eql(Wr, Ne.ONE);
          Sr = Ne.mul(Gr, Ur), Ur = Ne.mul(Ur, Ur), Wr = Ne.mul(br, Ur), Gr = Ne.cmov(Sr, Gr, fi), br = Ne.cmov(Wr, br, fi);
        }
        return { isValid: Ar, value: Gr };
      };
      if (Ne.ORDER % H === L) {
        const Xr = (Ne.ORDER - L) / H, Vr = Ne.sqrt(Ne.neg(Et));
        Qr = (Ur, Sr) => {
          let Gr = Ne.sqr(Sr);
          const Fr = Ne.mul(Ur, Sr);
          Gr = Ne.mul(Gr, Fr);
          let br = Ne.pow(Gr, Xr);
          br = Ne.mul(br, Fr);
          const Ar = Ne.mul(br, Vr), cr = Ne.mul(Ne.sqr(br), Sr), hr = Ne.eql(cr, Ur);
          let Wr = Ne.cmov(Ar, br, hr);
          return { isValid: hr, value: Wr };
        };
      }
      return Qr;
    }
    function Se(Ne, Et) {
      (0, d.validateField)(Ne);
      const { A: st, B: Dt, Z: er } = Et;
      if (!Ne.isValid(st) || !Ne.isValid(Dt) || !Ne.isValid(er))
        throw new Error("mapToCurveSimpleSWU: invalid opts");
      const xt = Ee(Ne, er);
      if (!Ne.isOdd)
        throw new Error("Field does not have .isOdd()");
      return (ir) => {
        let sr, yr, wr, qr, Mr, Dr, Qr, Xr;
        sr = Ne.sqr(ir), sr = Ne.mul(sr, er), yr = Ne.sqr(sr), yr = Ne.add(yr, sr), wr = Ne.add(yr, Ne.ONE), wr = Ne.mul(wr, Dt), qr = Ne.cmov(er, Ne.neg(yr), !Ne.eql(yr, Ne.ZERO)), qr = Ne.mul(qr, st), yr = Ne.sqr(wr), Dr = Ne.sqr(qr), Mr = Ne.mul(Dr, st), yr = Ne.add(yr, Mr), yr = Ne.mul(yr, wr), Dr = Ne.mul(Dr, qr), Mr = Ne.mul(Dr, Dt), yr = Ne.add(yr, Mr), Qr = Ne.mul(sr, wr);
        const { isValid: Vr, value: Ur } = xt(yr, Dr);
        Xr = Ne.mul(sr, ir), Xr = Ne.mul(Xr, Ur), Qr = Ne.cmov(Qr, wr, Vr), Xr = Ne.cmov(Xr, Ur, Vr);
        const Sr = Ne.isOdd(ir) === Ne.isOdd(Xr);
        Xr = Ne.cmov(Ne.neg(Xr), Xr, Sr);
        const Gr = (0, d.FpInvertBatch)(Ne, [qr], !0)[0];
        return Qr = Ne.mul(Qr, Gr), { x: Qr, y: Xr };
      };
    }
    function ze(Ne, Et) {
      return {
        secretKey: Et.BYTES,
        publicKey: 1 + Ne.BYTES,
        publicKeyUncompressed: 1 + 2 * Ne.BYTES,
        publicKeyHasPrefix: !0,
        signature: 2 * Et.BYTES
      };
    }
    function He(Ne, Et = {}) {
      const { Fn: st } = Ne, Dt = Et.randomBytes || y.randomBytes, er = Object.assign(ze(Ne.Fp, st), { seed: (0, d.getMinHashLength)(st.ORDER) });
      function xt(Qr) {
        try {
          return !!fe(st, Qr);
        } catch {
          return !1;
        }
      }
      function ir(Qr, Xr) {
        const { publicKey: Vr, publicKeyUncompressed: Ur } = er;
        try {
          const Sr = Qr.length;
          return Xr === !0 && Sr !== Vr || Xr === !1 && Sr !== Ur ? !1 : !!Ne.fromBytes(Qr);
        } catch {
          return !1;
        }
      }
      function sr(Qr = Dt(er.seed)) {
        return (0, d.mapHashToField)((0, y._abytes2)(Qr, er.seed, "seed"), st.ORDER);
      }
      function yr(Qr, Xr = !0) {
        return Ne.BASE.multiply(fe(st, Qr)).toBytes(Xr);
      }
      function wr(Qr) {
        const Xr = sr(Qr);
        return { secretKey: Xr, publicKey: yr(Xr) };
      }
      function qr(Qr) {
        if (typeof Qr == "bigint")
          return !1;
        if (Qr instanceof Ne)
          return !0;
        const { secretKey: Xr, publicKey: Vr, publicKeyUncompressed: Ur } = er;
        if (st.allowedLengths || Xr === Vr)
          return;
        const Sr = (0, y.ensureBytes)("key", Qr).length;
        return Sr === Vr || Sr === Ur;
      }
      function Mr(Qr, Xr, Vr = !0) {
        if (qr(Qr) === !0)
          throw new Error("first arg must be private key");
        if (qr(Xr) === !1)
          throw new Error("second arg must be public key");
        const Ur = fe(st, Qr);
        return Ne.fromHex(Xr).multiply(Ur).toBytes(Vr);
      }
      return Object.freeze({ getPublicKey: yr, getSharedSecret: Mr, keygen: wr, Point: Ne, utils: {
        isValidSecretKey: xt,
        isValidPublicKey: ir,
        randomSecretKey: sr,
        // TODO: remove
        isValidPrivateKey: xt,
        randomPrivateKey: sr,
        normPrivateKeyToScalar: (Qr) => fe(st, Qr),
        precompute(Qr = 8, Xr = Ne.BASE) {
          return Xr.precompute(Qr, !1);
        }
      }, lengths: er });
    }
    function Pe(Ne, Et, st = {}) {
      (0, c.ahash)(Et), (0, y._validateObject)(st, {}, {
        hmac: "function",
        lowS: "boolean",
        randomBytes: "function",
        bits2int: "function",
        bits2int_modN: "function"
      });
      const Dt = st.randomBytes || y.randomBytes, er = st.hmac || ((ti, ...Lr) => (0, g.hmac)(Et, ti, (0, y.concatBytes)(...Lr))), { Fp: xt, Fn: ir } = Ne, { ORDER: sr, BITS: yr } = ir, { keygen: wr, getPublicKey: qr, getSharedSecret: Mr, utils: Dr, lengths: Qr } = He(Ne, st), Xr = {
        prehash: !1,
        lowS: typeof st.lowS == "boolean" ? st.lowS : !1,
        format: void 0,
        //'compact' as ECDSASigFormat,
        extraEntropy: !1
      }, Vr = "compact";
      function Ur(ti) {
        const Lr = sr >> M;
        return ti > Lr;
      }
      function Sr(ti, Lr) {
        if (!ir.isValidNot0(Lr))
          throw new Error(`invalid signature ${ti}: out of range 1..Point.Fn.ORDER`);
        return Lr;
      }
      function Gr(ti, Lr) {
        D(Lr);
        const Rr = Qr.signature, Ir = Lr === "compact" ? Rr : Lr === "recovered" ? Rr + 1 : void 0;
        return (0, y._abytes2)(ti, Ir, `${Lr} signature`);
      }
      class Fr {
        constructor(Lr, Rr, Ir) {
          this.r = Sr("r", Lr), this.s = Sr("s", Rr), Ir != null && (this.recovery = Ir), Object.freeze(this);
        }
        static fromBytes(Lr, Rr = Vr) {
          Gr(Lr, Rr);
          let Ir;
          if (Rr === "der") {
            const { r: xr, s: si } = o.DER.toSig((0, y._abytes2)(Lr));
            return new Fr(xr, si);
          }
          Rr === "recovered" && (Ir = Lr[0], Rr = "compact", Lr = Lr.subarray(1));
          const pr = ir.BYTES, Cr = Lr.subarray(0, pr), Er = Lr.subarray(pr, pr * 2);
          return new Fr(ir.fromBytes(Cr), ir.fromBytes(Er), Ir);
        }
        static fromHex(Lr, Rr) {
          return this.fromBytes((0, y.hexToBytes)(Lr), Rr);
        }
        addRecoveryBit(Lr) {
          return new Fr(this.r, this.s, Lr);
        }
        recoverPublicKey(Lr) {
          const Rr = xt.ORDER, { r: Ir, s: pr, recovery: Cr } = this;
          if (Cr == null || ![0, 1, 2, 3].includes(Cr))
            throw new Error("recovery id invalid");
          if (sr * U < Rr && Cr > 1)
            throw new Error("recovery id is ambiguous for h>1 curve");
          const xr = Cr === 2 || Cr === 3 ? Ir + sr : Ir;
          if (!xt.isValid(xr))
            throw new Error("recovery id 2 or 3 invalid");
          const si = xt.toBytes(xr), Ci = Ne.fromBytes((0, y.concatBytes)(Ie((Cr & 1) === 0), si)), bi = ir.inv(xr), Ri = Ar((0, y.ensureBytes)("msgHash", Lr)), li = ir.create(-Ri * bi), zi = ir.create(pr * bi), Kn = Ne.BASE.multiplyUnsafe(li).add(Ci.multiplyUnsafe(zi));
          if (Kn.is0())
            throw new Error("point at infinify");
          return Kn.assertValidity(), Kn;
        }
        // Signatures should be low-s, to prevent malleability.
        hasHighS() {
          return Ur(this.s);
        }
        toBytes(Lr = Vr) {
          if (D(Lr), Lr === "der")
            return (0, y.hexToBytes)(o.DER.hexFromSig(this));
          const Rr = ir.toBytes(this.r), Ir = ir.toBytes(this.s);
          if (Lr === "recovered") {
            if (this.recovery == null)
              throw new Error("recovery bit must be present");
            return (0, y.concatBytes)(Uint8Array.of(this.recovery), Rr, Ir);
          }
          return (0, y.concatBytes)(Rr, Ir);
        }
        toHex(Lr) {
          return (0, y.bytesToHex)(this.toBytes(Lr));
        }
        // TODO: remove
        assertValidity() {
        }
        static fromCompact(Lr) {
          return Fr.fromBytes((0, y.ensureBytes)("sig", Lr), "compact");
        }
        static fromDER(Lr) {
          return Fr.fromBytes((0, y.ensureBytes)("sig", Lr), "der");
        }
        normalizeS() {
          return this.hasHighS() ? new Fr(this.r, ir.neg(this.s), this.recovery) : this;
        }
        toDERRawBytes() {
          return this.toBytes("der");
        }
        toDERHex() {
          return (0, y.bytesToHex)(this.toBytes("der"));
        }
        toCompactRawBytes() {
          return this.toBytes("compact");
        }
        toCompactHex() {
          return (0, y.bytesToHex)(this.toBytes("compact"));
        }
      }
      const br = st.bits2int || function(Lr) {
        if (Lr.length > 8192)
          throw new Error("input is too large");
        const Rr = (0, y.bytesToNumberBE)(Lr), Ir = Lr.length * 8 - yr;
        return Ir > 0 ? Rr >> BigInt(Ir) : Rr;
      }, Ar = st.bits2int_modN || function(Lr) {
        return ir.create(br(Lr));
      }, cr = (0, y.bitMask)(yr);
      function hr(ti) {
        return (0, y.aInRange)("num < 2^" + yr, ti, F, cr), ir.toBytes(ti);
      }
      function Wr(ti, Lr) {
        return (0, y._abytes2)(ti, void 0, "message"), Lr ? (0, y._abytes2)(Et(ti), void 0, "prehashed message") : ti;
      }
      function fi(ti, Lr, Rr) {
        if (["recovered", "canonical"].some((li) => li in Rr))
          throw new Error("sign() legacy options not supported");
        const { lowS: Ir, prehash: pr, extraEntropy: Cr } = x(Rr, Xr);
        ti = Wr(ti, pr);
        const Er = Ar(ti), xr = fe(ir, Lr), si = [hr(xr), hr(Er)];
        if (Cr != null && Cr !== !1) {
          const li = Cr === !0 ? Dt(Qr.secretKey) : Cr;
          si.push((0, y.ensureBytes)("extraEntropy", li));
        }
        const Ci = (0, y.concatBytes)(...si), bi = Er;
        function Ri(li) {
          const zi = br(li);
          if (!ir.isValidNot0(zi))
            return;
          const Kn = ir.inv(zi), Hn = Ne.BASE.multiply(zi).toAffine(), os = ir.create(Hn.x);
          if (os === F)
            return;
          const ts = ir.create(Kn * ir.create(bi + os * xr));
          if (ts === F)
            return;
          let Gs = (Hn.x === os ? 0 : 2) | Number(Hn.y & M), Wn = ts;
          return Ir && Ur(ts) && (Wn = ir.neg(ts), Gs ^= 1), new Fr(os, Wn, Gs);
        }
        return { seed: Ci, k2sig: Ri };
      }
      function Bi(ti, Lr, Rr = {}) {
        ti = (0, y.ensureBytes)("message", ti);
        const { seed: Ir, k2sig: pr } = fi(ti, Lr, Rr);
        return (0, y.createHmacDrbg)(Et.outputLen, ir.BYTES, er)(Ir, pr);
      }
      function $r(ti) {
        let Lr;
        const Rr = typeof ti == "string" || (0, y.isBytes)(ti), Ir = !Rr && ti !== null && typeof ti == "object" && typeof ti.r == "bigint" && typeof ti.s == "bigint";
        if (!Rr && !Ir)
          throw new Error("invalid signature, expected Uint8Array, hex string or Signature instance");
        if (Ir)
          Lr = new Fr(ti.r, ti.s);
        else if (Rr) {
          try {
            Lr = Fr.fromBytes((0, y.ensureBytes)("sig", ti), "der");
          } catch (pr) {
            if (!(pr instanceof o.DER.Err))
              throw pr;
          }
          if (!Lr)
            try {
              Lr = Fr.fromBytes((0, y.ensureBytes)("sig", ti), "compact");
            } catch {
              return !1;
            }
        }
        return Lr || !1;
      }
      function oi(ti, Lr, Rr, Ir = {}) {
        const { lowS: pr, prehash: Cr, format: Er } = x(Ir, Xr);
        if (Rr = (0, y.ensureBytes)("publicKey", Rr), Lr = Wr((0, y.ensureBytes)("message", Lr), Cr), "strict" in Ir)
          throw new Error("options.strict was renamed to lowS");
        const xr = Er === void 0 ? $r(ti) : Fr.fromBytes((0, y.ensureBytes)("sig", ti), Er);
        if (xr === !1)
          return !1;
        try {
          const si = Ne.fromBytes(Rr);
          if (pr && xr.hasHighS())
            return !1;
          const { r: Ci, s: bi } = xr, Ri = Ar(Lr), li = ir.inv(bi), zi = ir.create(Ri * li), Kn = ir.create(Ci * li), Hn = Ne.BASE.multiplyUnsafe(zi).add(si.multiplyUnsafe(Kn));
          return Hn.is0() ? !1 : ir.create(Hn.x) === Ci;
        } catch {
          return !1;
        }
      }
      function zr(ti, Lr, Rr = {}) {
        const { prehash: Ir } = x(Rr, Xr);
        return Lr = Wr(Lr, Ir), Fr.fromBytes(ti, "recovered").recoverPublicKey(Lr).toBytes();
      }
      return Object.freeze({
        keygen: wr,
        getPublicKey: qr,
        getSharedSecret: Mr,
        utils: Dr,
        lengths: Qr,
        Point: Ne,
        sign: Bi,
        verify: oi,
        recoverPublicKey: zr,
        Signature: Fr,
        hash: Et
      });
    }
    function De(Ne) {
      const { CURVE: Et, curveOpts: st } = ve(Ne), Dt = ge(Et, st);
      return Be(Ne, Dt);
    }
    function ve(Ne) {
      const Et = {
        a: Ne.a,
        b: Ne.b,
        p: Ne.Fp.ORDER,
        n: Ne.n,
        h: Ne.h,
        Gx: Ne.Gx,
        Gy: Ne.Gy
      }, st = Ne.Fp;
      let Dt = Ne.allowedPrivateKeyLengths ? Array.from(new Set(Ne.allowedPrivateKeyLengths.map((ir) => Math.ceil(ir / 2)))) : void 0;
      const er = (0, d.Field)(Et.n, {
        BITS: Ne.nBitLength,
        allowedLengths: Dt,
        modFromBytes: Ne.wrapPrivateKey
      }), xt = {
        Fp: st,
        Fn: er,
        allowInfinityPoint: Ne.allowInfinityPoint,
        endo: Ne.endo,
        isTorsionFree: Ne.isTorsionFree,
        clearCofactor: Ne.clearCofactor,
        fromBytes: Ne.fromBytes,
        toBytes: Ne.toBytes
      };
      return { CURVE: Et, curveOpts: xt };
    }
    function Fe(Ne) {
      const { CURVE: Et, curveOpts: st } = ve(Ne), Dt = {
        hmac: Ne.hmac,
        randomBytes: Ne.randomBytes,
        lowS: Ne.lowS,
        bits2int: Ne.bits2int,
        bits2int_modN: Ne.bits2int_modN
      };
      return { CURVE: Et, curveOpts: st, hash: Ne.hash, ecdsaOpts: Dt };
    }
    function be(Ne, Et, st) {
      function Dt(er) {
        const xt = Ne.sqr(er), ir = Ne.mul(xt, er);
        return Ne.add(Ne.add(ir, Ne.mul(er, Et)), st);
      }
      return Dt;
    }
    function Be(Ne, Et) {
      const { Fp: st, Fn: Dt } = Et;
      function er(ir) {
        return (0, y.inRange)(ir, M, Dt.ORDER);
      }
      const xt = be(st, Ne.a, Ne.b);
      return Object.assign({}, {
        CURVE: Ne,
        Point: Et,
        ProjectivePoint: Et,
        normPrivateKeyToScalar: (ir) => fe(Dt, ir),
        weierstrassEquation: xt,
        isWithinCurveOrder: er
      });
    }
    function ke(Ne, Et) {
      const st = Et.Point;
      return Object.assign({}, Et, {
        ProjectivePoint: st,
        CURVE: Object.assign({}, Ne, (0, d.nLength)(st.Fn.ORDER, st.Fn.BITS))
      });
    }
    function xe(Ne) {
      const { CURVE: Et, curveOpts: st, hash: Dt, ecdsaOpts: er } = Fe(Ne), xt = ge(Et, st), ir = Pe(xt, Dt, er);
      return ke(Ne, ir);
    }
  }(weierstrass$3)), weierstrass$3;
}
var hasRequired_shortw_utils$1;
function require_shortw_utils$1() {
  if (hasRequired_shortw_utils$1) return _shortw_utils$1;
  hasRequired_shortw_utils$1 = 1, Object.defineProperty(_shortw_utils$1, "__esModule", { value: !0 }), _shortw_utils$1.getHash = g, _shortw_utils$1.createCurve = c;
  const o = /* @__PURE__ */ requireWeierstrass$1();
  function g(y) {
    return { hash: y };
  }
  function c(y, t) {
    const d = (E) => (0, o.weierstrass)({ ...y, hash: E });
    return { ...d(t), create: d };
  }
  return _shortw_utils$1;
}
var hashToCurve$1 = {}, hasRequiredHashToCurve$1;
function requireHashToCurve$1() {
  return hasRequiredHashToCurve$1 || (hasRequiredHashToCurve$1 = 1, function(o) {
    Object.defineProperty(o, "__esModule", { value: !0 }), o._DST_scalar = void 0, o.expand_message_xmd = D, o.expand_message_xof = x, o.hash_to_field = v, o.isogenyMap = F, o.createHasher = M;
    const g = /* @__PURE__ */ requireUtils$i(), c = /* @__PURE__ */ requireModular$1(), y = g.bytesToNumberBE;
    function t(U, L) {
      if (E(U), E(L), U < 0 || U >= 1 << 8 * L)
        throw new Error("invalid I2OSP input: " + U);
      const H = Array.from({ length: L }).fill(0);
      for (let fe = L - 1; fe >= 0; fe--)
        H[fe] = U & 255, U >>>= 8;
      return new Uint8Array(H);
    }
    function d(U, L) {
      const H = new Uint8Array(U.length);
      for (let fe = 0; fe < U.length; fe++)
        H[fe] = U[fe] ^ L[fe];
      return H;
    }
    function E(U) {
      if (!Number.isSafeInteger(U))
        throw new Error("number expected");
    }
    function B(U) {
      if (!(0, g.isBytes)(U) && typeof U != "string")
        throw new Error("DST must be Uint8Array or string");
      return typeof U == "string" ? (0, g.utf8ToBytes)(U) : U;
    }
    function D(U, L, H, fe) {
      (0, g.abytes)(U), E(H), L = B(L), L.length > 255 && (L = fe((0, g.concatBytes)((0, g.utf8ToBytes)("H2C-OVERSIZE-DST-"), L)));
      const { outputLen: ge, blockLen: Ie } = fe, Ee = Math.ceil(H / ge);
      if (H > 65535 || Ee > 255)
        throw new Error("expand_message_xmd: invalid lenInBytes");
      const Se = (0, g.concatBytes)(L, t(L.length, 1)), ze = t(0, Ie), He = t(H, 2), Pe = new Array(Ee), De = fe((0, g.concatBytes)(ze, U, He, t(0, 1), Se));
      Pe[0] = fe((0, g.concatBytes)(De, t(1, 1), Se));
      for (let Fe = 1; Fe <= Ee; Fe++) {
        const be = [d(De, Pe[Fe - 1]), t(Fe + 1, 1), Se];
        Pe[Fe] = fe((0, g.concatBytes)(...be));
      }
      return (0, g.concatBytes)(...Pe).slice(0, H);
    }
    function x(U, L, H, fe, ge) {
      if ((0, g.abytes)(U), E(H), L = B(L), L.length > 255) {
        const Ie = Math.ceil(2 * fe / 8);
        L = ge.create({ dkLen: Ie }).update((0, g.utf8ToBytes)("H2C-OVERSIZE-DST-")).update(L).digest();
      }
      if (H > 65535 || L.length > 255)
        throw new Error("expand_message_xof: invalid lenInBytes");
      return ge.create({ dkLen: H }).update(U).update(t(H, 2)).update(L).update(t(L.length, 1)).digest();
    }
    function v(U, L, H) {
      (0, g._validateObject)(H, {
        p: "bigint",
        m: "number",
        k: "number",
        hash: "function"
      });
      const { p: fe, k: ge, m: Ie, hash: Ee, expand: Se, DST: ze } = H;
      if (!(0, g.isHash)(H.hash))
        throw new Error("expected valid hash");
      (0, g.abytes)(U), E(L);
      const He = fe.toString(2).length, Pe = Math.ceil((He + ge) / 8), De = L * Ie * Pe;
      let ve;
      if (Se === "xmd")
        ve = D(U, ze, De, Ee);
      else if (Se === "xof")
        ve = x(U, ze, De, ge, Ee);
      else if (Se === "_internal_pass")
        ve = U;
      else
        throw new Error('expand must be "xmd" or "xof"');
      const Fe = new Array(L);
      for (let be = 0; be < L; be++) {
        const Be = new Array(Ie);
        for (let ke = 0; ke < Ie; ke++) {
          const xe = Pe * (ke + be * Ie), Ne = ve.subarray(xe, xe + Pe);
          Be[ke] = (0, c.mod)(y(Ne), fe);
        }
        Fe[be] = Be;
      }
      return Fe;
    }
    function F(U, L) {
      const H = L.map((fe) => Array.from(fe).reverse());
      return (fe, ge) => {
        const [Ie, Ee, Se, ze] = H.map((De) => De.reduce((ve, Fe) => U.add(U.mul(ve, fe), Fe))), [He, Pe] = (0, c.FpInvertBatch)(U, [Ee, ze], !0);
        return fe = U.mul(Ie, He), ge = U.mul(ge, U.mul(Se, Pe)), { x: fe, y: ge };
      };
    }
    o._DST_scalar = (0, g.utf8ToBytes)("HashToScalar-");
    function M(U, L, H) {
      if (typeof L != "function")
        throw new Error("mapToCurve() must be defined");
      function fe(Ie) {
        return U.fromAffine(L(Ie));
      }
      function ge(Ie) {
        const Ee = Ie.clearCofactor();
        return Ee.equals(U.ZERO) ? U.ZERO : (Ee.assertValidity(), Ee);
      }
      return {
        defaults: H,
        hashToCurve(Ie, Ee) {
          const Se = Object.assign({}, H, Ee), ze = v(Ie, 2, Se), He = fe(ze[0]), Pe = fe(ze[1]);
          return ge(He.add(Pe));
        },
        encodeToCurve(Ie, Ee) {
          const Se = H.encodeDST ? { DST: H.encodeDST } : {}, ze = Object.assign({}, H, Se, Ee), He = v(Ie, 1, ze), Pe = fe(He[0]);
          return ge(Pe);
        },
        /** See {@link H2CHasher} */
        mapToCurve(Ie) {
          if (!Array.isArray(Ie))
            throw new Error("expected array of bigints");
          for (const Ee of Ie)
            if (typeof Ee != "bigint")
              throw new Error("expected array of bigints");
          return ge(fe(Ie));
        },
        // hash_to_scalar can produce 0: https://www.rfc-editor.org/errata/eid8393
        // RFC 9380, draft-irtf-cfrg-bbs-signatures-08
        hashToScalar(Ie, Ee) {
          const Se = U.Fn.ORDER, ze = Object.assign({}, H, { p: Se, m: 1, DST: o._DST_scalar }, Ee);
          return v(Ie, 1, ze)[0][0];
        }
      };
    }
  }(hashToCurve$1)), hashToCurve$1;
}
var hasRequiredSecp256k1$5;
function requireSecp256k1$5() {
  return hasRequiredSecp256k1$5 || (hasRequiredSecp256k1$5 = 1, function(o) {
    Object.defineProperty(o, "__esModule", { value: !0 }), o.encodeToCurve = o.hashToCurve = o.secp256k1_hasher = o.schnorr = o.secp256k1 = void 0;
    const g = /* @__PURE__ */ requireSha2(), c = /* @__PURE__ */ requireUtils$j(), y = /* @__PURE__ */ require_shortw_utils$1(), t = /* @__PURE__ */ requireHashToCurve$1(), d = /* @__PURE__ */ requireModular$1(), E = /* @__PURE__ */ requireWeierstrass$1(), B = /* @__PURE__ */ requireUtils$i(), D = {
      p: BigInt("0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f"),
      n: BigInt("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141"),
      h: BigInt(1),
      a: BigInt(0),
      b: BigInt(7),
      Gx: BigInt("0x79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798"),
      Gy: BigInt("0x483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8")
    }, x = {
      beta: BigInt("0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee"),
      basises: [
        [BigInt("0x3086d221a7d46bcde86c90e49284eb15"), -BigInt("0xe4437ed6010e88286f547fa90abfe4c3")],
        [BigInt("0x114ca50f7a8e2f3f657c1108d9d44cfd8"), BigInt("0x3086d221a7d46bcde86c90e49284eb15")]
      ]
    }, v = /* @__PURE__ */ BigInt(0), F = /* @__PURE__ */ BigInt(1), M = /* @__PURE__ */ BigInt(2);
    function U(ke) {
      const xe = D.p, Ne = BigInt(3), Et = BigInt(6), st = BigInt(11), Dt = BigInt(22), er = BigInt(23), xt = BigInt(44), ir = BigInt(88), sr = ke * ke * ke % xe, yr = sr * sr * ke % xe, wr = (0, d.pow2)(yr, Ne, xe) * yr % xe, qr = (0, d.pow2)(wr, Ne, xe) * yr % xe, Mr = (0, d.pow2)(qr, M, xe) * sr % xe, Dr = (0, d.pow2)(Mr, st, xe) * Mr % xe, Qr = (0, d.pow2)(Dr, Dt, xe) * Dr % xe, Xr = (0, d.pow2)(Qr, xt, xe) * Qr % xe, Vr = (0, d.pow2)(Xr, ir, xe) * Xr % xe, Ur = (0, d.pow2)(Vr, xt, xe) * Qr % xe, Sr = (0, d.pow2)(Ur, Ne, xe) * yr % xe, Gr = (0, d.pow2)(Sr, er, xe) * Dr % xe, Fr = (0, d.pow2)(Gr, Et, xe) * sr % xe, br = (0, d.pow2)(Fr, M, xe);
      if (!L.eql(L.sqr(br), ke))
        throw new Error("Cannot find square root");
      return br;
    }
    const L = (0, d.Field)(D.p, { sqrt: U });
    o.secp256k1 = (0, y.createCurve)({ ...D, Fp: L, lowS: !0, endo: x }, g.sha256);
    const H = {};
    function fe(ke, ...xe) {
      let Ne = H[ke];
      if (Ne === void 0) {
        const Et = (0, g.sha256)((0, B.utf8ToBytes)(ke));
        Ne = (0, B.concatBytes)(Et, Et), H[ke] = Ne;
      }
      return (0, g.sha256)((0, B.concatBytes)(Ne, ...xe));
    }
    const ge = (ke) => ke.toBytes(!0).slice(1), Ie = o.secp256k1.Point, Ee = (ke) => ke % M === v;
    function Se(ke) {
      const { Fn: xe, BASE: Ne } = Ie, Et = (0, E._normFnElement)(xe, ke), st = Ne.multiply(Et);
      return { scalar: Ee(st.y) ? Et : xe.neg(Et), bytes: ge(st) };
    }
    function ze(ke) {
      const xe = L;
      if (!xe.isValidNot0(ke))
        throw new Error("invalid x: Fail if x ≥ p");
      const Ne = xe.create(ke * ke), Et = xe.create(Ne * ke + BigInt(7));
      let st = xe.sqrt(Et);
      Ee(st) || (st = xe.neg(st));
      const Dt = Ie.fromAffine({ x: ke, y: st });
      return Dt.assertValidity(), Dt;
    }
    const He = B.bytesToNumberBE;
    function Pe(...ke) {
      return Ie.Fn.create(He(fe("BIP0340/challenge", ...ke)));
    }
    function De(ke) {
      return Se(ke).bytes;
    }
    function ve(ke, xe, Ne = (0, c.randomBytes)(32)) {
      const { Fn: Et } = Ie, st = (0, B.ensureBytes)("message", ke), { bytes: Dt, scalar: er } = Se(xe), xt = (0, B.ensureBytes)("auxRand", Ne, 32), ir = Et.toBytes(er ^ He(fe("BIP0340/aux", xt))), sr = fe("BIP0340/nonce", ir, Dt, st), { bytes: yr, scalar: wr } = Se(sr), qr = Pe(yr, Dt, st), Mr = new Uint8Array(64);
      if (Mr.set(yr, 0), Mr.set(Et.toBytes(Et.create(wr + qr * er)), 32), !Fe(Mr, st, Dt))
        throw new Error("sign: Invalid signature produced");
      return Mr;
    }
    function Fe(ke, xe, Ne) {
      const { Fn: Et, BASE: st } = Ie, Dt = (0, B.ensureBytes)("signature", ke, 64), er = (0, B.ensureBytes)("message", xe), xt = (0, B.ensureBytes)("publicKey", Ne, 32);
      try {
        const ir = ze(He(xt)), sr = He(Dt.subarray(0, 32));
        if (!(0, B.inRange)(sr, F, D.p))
          return !1;
        const yr = He(Dt.subarray(32, 64));
        if (!(0, B.inRange)(yr, F, D.n))
          return !1;
        const wr = Pe(Et.toBytes(sr), ge(ir), er), qr = st.multiplyUnsafe(yr).add(ir.multiplyUnsafe(Et.neg(wr))), { x: Mr, y: Dr } = qr.toAffine();
        return !(qr.is0() || !Ee(Dr) || Mr !== sr);
      } catch {
        return !1;
      }
    }
    o.schnorr = (() => {
      const Ne = (st = (0, c.randomBytes)(48)) => (0, d.mapHashToField)(st, D.n);
      o.secp256k1.utils.randomSecretKey;
      function Et(st) {
        const Dt = Ne(st);
        return { secretKey: Dt, publicKey: De(Dt) };
      }
      return {
        keygen: Et,
        getPublicKey: De,
        sign: ve,
        verify: Fe,
        Point: Ie,
        utils: {
          randomSecretKey: Ne,
          randomPrivateKey: Ne,
          taggedHash: fe,
          // TODO: remove
          lift_x: ze,
          pointToBytes: ge,
          numberToBytesBE: B.numberToBytesBE,
          bytesToNumberBE: B.bytesToNumberBE,
          mod: d.mod
        },
        lengths: {
          secretKey: 32,
          publicKey: 32,
          publicKeyHasPrefix: !1,
          signature: 64,
          seed: 48
        }
      };
    })();
    const be = (0, t.isogenyMap)(L, [
      // xNum
      [
        "0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa8c7",
        "0x7d3d4c80bc321d5b9f315cea7fd44c5d595d2fc0bf63b92dfff1044f17c6581",
        "0x534c328d23f234e6e2a413deca25caece4506144037c40314ecbd0b53d9dd262",
        "0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa88c"
      ],
      // xDen
      [
        "0xd35771193d94918a9ca34ccbb7b640dd86cd409542f8487d9fe6b745781eb49b",
        "0xedadc6f64383dc1df7c4b2d51b54225406d36b641f5e41bbc52a56612a8c6d14",
        "0x0000000000000000000000000000000000000000000000000000000000000001"
        // LAST 1
      ],
      // yNum
      [
        "0x4bda12f684bda12f684bda12f684bda12f684bda12f684bda12f684b8e38e23c",
        "0xc75e0c32d5cb7c0fa9d0a54b12a0a6d5647ab046d686da6fdffc90fc201d71a3",
        "0x29a6194691f91a73715209ef6512e576722830a201be2018a765e85a9ecee931",
        "0x2f684bda12f684bda12f684bda12f684bda12f684bda12f684bda12f38e38d84"
      ],
      // yDen
      [
        "0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffff93b",
        "0x7a06534bb8bdb49fd5e9e6632722c2989467c1bfc8e8d978dfb425d2685c2573",
        "0x6484aa716545ca2cf3a70c3fa8fe337e0a3d21162f0d6299a7bf8192bfd2a76f",
        "0x0000000000000000000000000000000000000000000000000000000000000001"
        // LAST 1
      ]
    ].map((ke) => ke.map((xe) => BigInt(xe)))), Be = (0, E.mapToCurveSimpleSWU)(L, {
      A: BigInt("0x3f8731abdd661adca08a5558f0f5d272e953d363cb6f0e5d405447c01a444533"),
      B: BigInt("1771"),
      Z: L.create(BigInt("-11"))
    });
    o.secp256k1_hasher = (0, t.createHasher)(o.secp256k1.Point, (ke) => {
      const { x: xe, y: Ne } = Be(L.create(ke[0]));
      return be(xe, Ne);
    }, {
      DST: "secp256k1_XMD:SHA-256_SSWU_RO_",
      encodeDST: "secp256k1_XMD:SHA-256_SSWU_NU_",
      p: L.ORDER,
      m: 1,
      k: 128,
      expand: "xmd",
      hash: g.sha256
    }), o.hashToCurve = o.secp256k1_hasher.hashToCurve, o.encodeToCurve = o.secp256k1_hasher.encodeToCurve;
  }(secp256k1$7)), secp256k1$7;
}
var utils$j = {}, hasRequiredUtils$h;
function requireUtils$h() {
  if (hasRequiredUtils$h) return utils$j;
  hasRequiredUtils$h = 1, Object.defineProperty(utils$j, "__esModule", { value: !0 }), utils$j.isHash = utils$j.validateObject = utils$j.memoized = utils$j.notImplemented = utils$j.createHmacDrbg = utils$j.bitMask = utils$j.bitSet = utils$j.bitGet = utils$j.bitLen = utils$j.aInRange = utils$j.inRange = utils$j.asciiToBytes = utils$j.copyBytes = utils$j.equalBytes = utils$j.ensureBytes = utils$j.numberToVarBytesBE = utils$j.numberToBytesLE = utils$j.numberToBytesBE = utils$j.bytesToNumberLE = utils$j.bytesToNumberBE = utils$j.hexToNumber = utils$j.numberToHexUnpadded = utils$j.abool = utils$j.utf8ToBytes = utils$j.randomBytes = utils$j.isBytes = utils$j.hexToBytes = utils$j.concatBytes = utils$j.bytesToUtf8 = utils$j.bytesToHex = utils$j.anumber = utils$j.abytes = void 0;
  const o = /* @__PURE__ */ requireUtils$i();
  return utils$j.abytes = o.abytes, utils$j.anumber = o.anumber, utils$j.bytesToHex = o.bytesToHex, utils$j.bytesToUtf8 = o.bytesToUtf8, utils$j.concatBytes = o.concatBytes, utils$j.hexToBytes = o.hexToBytes, utils$j.isBytes = o.isBytes, utils$j.randomBytes = o.randomBytes, utils$j.utf8ToBytes = o.utf8ToBytes, utils$j.abool = o.abool, utils$j.numberToHexUnpadded = o.numberToHexUnpadded, utils$j.hexToNumber = o.hexToNumber, utils$j.bytesToNumberBE = o.bytesToNumberBE, utils$j.bytesToNumberLE = o.bytesToNumberLE, utils$j.numberToBytesBE = o.numberToBytesBE, utils$j.numberToBytesLE = o.numberToBytesLE, utils$j.numberToVarBytesBE = o.numberToVarBytesBE, utils$j.ensureBytes = o.ensureBytes, utils$j.equalBytes = o.equalBytes, utils$j.copyBytes = o.copyBytes, utils$j.asciiToBytes = o.asciiToBytes, utils$j.inRange = o.inRange, utils$j.aInRange = o.aInRange, utils$j.bitLen = o.bitLen, utils$j.bitGet = o.bitGet, utils$j.bitSet = o.bitSet, utils$j.bitMask = o.bitMask, utils$j.createHmacDrbg = o.createHmacDrbg, utils$j.notImplemented = o.notImplemented, utils$j.memoized = o.memoized, utils$j.validateObject = o.validateObject, utils$j.isHash = o.isHash, utils$j;
}
var hasRequiredDist$q;
function requireDist$q() {
  if (hasRequiredDist$q) return dist$q;
  hasRequiredDist$q = 1;
  var o = /* @__PURE__ */ requireSecp256k1$5(), g = /* @__PURE__ */ requireModular$1(), c = /* @__PURE__ */ requireUtils$h();
  function y(Ir) {
    var pr = /* @__PURE__ */ Object.create(null);
    return Ir && Object.keys(Ir).forEach(function(Cr) {
      if (Cr !== "default") {
        var Er = Object.getOwnPropertyDescriptor(Ir, Cr);
        Object.defineProperty(pr, Cr, Er.get ? Er : {
          enumerable: !0,
          get: function() {
            return Ir[Cr];
          }
        });
      }
    }), pr.default = Ir, Object.freeze(pr);
  }
  var t = /* @__PURE__ */ y(g), d = /* @__PURE__ */ y(c);
  const E = o.secp256k1.ProjectivePoint, B = "Expected Private", D = "Expected Point", x = "Expected Tweak", v = "Expected Hash", F = "Expected Signature", M = "Expected Extra Data (32 bytes)", U = "Expected Scalar", L = "Bad Recovery Id", H = 32, fe = 32, ge = new Uint8Array([
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    254,
    186,
    174,
    220,
    230,
    175,
    72,
    160,
    59,
    191,
    210,
    94,
    140,
    208,
    54,
    65,
    65
  ]), Ie = 32, Ee = new Uint8Array(32), Se = new Uint8Array([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    69,
    81,
    35,
    25,
    80,
    183,
    95,
    196,
    64,
    45,
    161,
    114,
    47,
    201,
    186,
    238
  ]), ze = BigInt(1);
  function He(Ir) {
    return Ir instanceof Uint8Array;
  }
  function Pe(Ir, pr) {
    for (let Cr = 0; Cr < 32; ++Cr)
      if (Ir[Cr] !== pr[Cr])
        return Ir[Cr] < pr[Cr] ? -1 : 1;
    return 0;
  }
  function De(Ir) {
    return Pe(Ir, Ee) === 0;
  }
  function ve(Ir) {
    return !(!(Ir instanceof Uint8Array) || Ir.length !== fe || Pe(Ir, ge) >= 0);
  }
  function Fe(Ir) {
    return Ir instanceof Uint8Array && Ir.length === 64 && Pe(Ir.subarray(0, 32), ge) < 0 && Pe(Ir.subarray(32, 64), ge) < 0;
  }
  function be(Ir) {
    return He(Ir) && Ir.length === 64 && Pe(Ir.subarray(0, 32), Se) < 0;
  }
  function Be(Ir) {
    return !(De(Ir.subarray(0, 32)) || De(Ir.subarray(32, 64)));
  }
  function ke(Ir) {
    return Ir instanceof Uint8Array && Ir.length === H;
  }
  function xe(Ir) {
    return Ir === void 0 || Ir instanceof Uint8Array && Ir.length === Ie;
  }
  function Ne(Ir) {
    let pr;
    if (typeof Ir == "bigint")
      pr = Ir;
    else if (typeof Ir == "number" && Number.isSafeInteger(Ir) && Ir >= 0)
      pr = BigInt(Ir);
    else if (typeof Ir == "string") {
      if (Ir.length !== 64)
        throw new Error("Expected 32 bytes of private scalar");
      pr = d.hexToNumber(Ir);
    } else if (Ir instanceof Uint8Array) {
      if (Ir.length !== 32)
        throw new Error("Expected 32 bytes of private scalar");
      pr = d.bytesToNumberBE(Ir);
    } else
      throw new TypeError("Expected valid private scalar");
    if (pr < 0) throw new Error("Expected private scalar >= 0");
    return pr;
  }
  function Et(Ir) {
    return o.secp256k1.utils.normPrivateKeyToScalar(Ir);
  }
  function st(Ir, pr) {
    const Cr = Et(Ir), Er = Ne(pr), xr = d.numberToBytesBE(t.mod(Cr + Er, o.secp256k1.CURVE.n), 32);
    return o.secp256k1.utils.isValidPrivateKey(xr) ? xr : null;
  }
  function Dt(Ir, pr) {
    const Cr = Et(Ir), Er = Ne(pr), xr = d.numberToBytesBE(t.mod(Cr - Er, o.secp256k1.CURVE.n), 32);
    return o.secp256k1.utils.isValidPrivateKey(xr) ? xr : null;
  }
  function er(Ir) {
    const pr = Et(Ir), Cr = d.numberToBytesBE(o.secp256k1.CURVE.n - pr, 32);
    return o.secp256k1.utils.isValidPrivateKey(Cr) ? Cr : null;
  }
  function xt(Ir, pr, Cr) {
    const Er = qr(Ir), xr = Ne(pr), si = E.BASE.multiplyAndAddUnsafe(Er, xr, ze);
    if (!si) throw new Error("Tweaked point at infinity");
    return si.toRawBytes(Cr);
  }
  function ir(Ir, pr, Cr) {
    const Er = qr(Ir), xr = typeof pr == "string" ? pr : d.bytesToHex(pr), si = d.hexToNumber(xr);
    return Er.multiply(si).toRawBytes(Cr);
  }
  function sr(Ir, pr) {
    return Ir === void 0 ? pr !== void 0 ? Qr(pr) : !0 : !!Ir;
  }
  function yr(Ir) {
    try {
      return Ir();
    } catch {
      return null;
    }
  }
  function wr(Ir) {
    return o.schnorr.utils.lift_x(d.bytesToNumberBE(Ir));
  }
  function qr(Ir) {
    return Ir.length === 32 ? wr(Ir) : E.fromHex(Ir);
  }
  function Mr(Ir, pr) {
    if (Ir.length === 32 !== pr) return !1;
    try {
      return pr ? !!wr(Ir) : !!E.fromHex(Ir);
    } catch {
      return !1;
    }
  }
  function Dr(Ir) {
    return Mr(Ir, !1);
  }
  function Qr(Ir) {
    return Mr(Ir, !1) && Ir.length === 33;
  }
  function Xr(Ir) {
    return o.secp256k1.utils.isValidPrivateKey(Ir);
  }
  function Vr(Ir) {
    return Mr(Ir, !0);
  }
  function Ur(Ir, pr) {
    if (!Vr(Ir))
      throw new Error(D);
    if (!ve(pr))
      throw new Error(x);
    return yr(() => {
      const Cr = xt(Ir, pr, !0);
      return { parity: Cr[0] % 2 === 1 ? 1 : 0, xOnlyPubkey: Cr.slice(1) };
    });
  }
  function Sr(Ir) {
    if (!Dr(Ir))
      throw new Error(D);
    return Ir.slice(1, 33);
  }
  function Gr(Ir, pr) {
    if (!Xr(Ir))
      throw new Error(B);
    return yr(
      () => o.secp256k1.getPublicKey(Ir, sr(pr))
    );
  }
  function Fr(Ir) {
    if (!Xr(Ir))
      throw new Error(B);
    return Sr(Gr(Ir));
  }
  function br(Ir, pr) {
    if (!Dr(Ir))
      throw new Error(D);
    return qr(Ir).toRawBytes(sr(pr, Ir));
  }
  function Ar(Ir, pr, Cr) {
    if (!Dr(Ir))
      throw new Error(D);
    if (!ve(pr))
      throw new Error(x);
    return yr(
      () => ir(Ir, pr, sr(Cr, Ir))
    );
  }
  function cr(Ir, pr, Cr) {
    if (!Dr(Ir) || !Dr(pr))
      throw new Error(D);
    return yr(() => {
      const Er = qr(Ir), xr = qr(pr);
      return Er.equals(xr.negate()) ? null : Er.add(xr).toRawBytes(sr(Cr, Ir));
    });
  }
  function hr(Ir, pr, Cr) {
    if (!Dr(Ir))
      throw new Error(D);
    if (!ve(pr))
      throw new Error(x);
    return yr(
      () => xt(Ir, pr, sr(Cr, Ir))
    );
  }
  function Wr(Ir, pr) {
    if (!Xr(Ir))
      throw new Error(B);
    if (!ve(pr))
      throw new Error(x);
    return yr(() => st(Ir, pr));
  }
  function fi(Ir, pr) {
    if (!Xr(Ir))
      throw new Error(B);
    if (!ve(pr))
      throw new Error(x);
    return yr(() => Dt(Ir, pr));
  }
  function Bi(Ir) {
    if (!Xr(Ir))
      throw new Error(B);
    return er(Ir);
  }
  function $r(Ir, pr, Cr) {
    if (!Xr(pr))
      throw new Error(B);
    if (!ke(Ir))
      throw new Error(U);
    if (!xe(Cr))
      throw new Error(M);
    return o.secp256k1.sign(Ir, pr, { extraEntropy: Cr }).toCompactRawBytes();
  }
  function oi(Ir, pr, Cr) {
    if (!Xr(pr))
      throw new Error(B);
    if (!ke(Ir))
      throw new Error(U);
    if (!xe(Cr))
      throw new Error(M);
    const Er = o.secp256k1.sign(Ir, pr, { extraEntropy: Cr });
    return {
      signature: Er.toCompactRawBytes(),
      recoveryId: Er.recovery
    };
  }
  function zr(Ir, pr, Cr) {
    if (!Xr(pr))
      throw new Error(B);
    if (!ke(Ir))
      throw new Error(U);
    if (!xe(Cr))
      throw new Error(M);
    return o.schnorr.sign(Ir, pr, Cr);
  }
  function ti(Ir, pr, Cr, Er) {
    if (!ke(Ir))
      throw new Error(v);
    if (!Fe(pr) || !Be(pr))
      throw new Error(F);
    if (Cr & 2 && !be(pr))
      throw new Error(L);
    if (!Vr(pr.subarray(0, 32)))
      throw new Error(F);
    const si = o.secp256k1.Signature.fromCompact(pr).addRecoveryBit(Cr).recoverPublicKey(Ir);
    if (!si) throw new Error(F);
    return si.toRawBytes(sr(Er));
  }
  function Lr(Ir, pr, Cr, Er) {
    if (!Dr(pr))
      throw new Error(D);
    if (!Fe(Cr))
      throw new Error(F);
    if (!ke(Ir))
      throw new Error(U);
    return o.secp256k1.verify(Cr, Ir, pr, { lowS: Er });
  }
  function Rr(Ir, pr, Cr) {
    if (!Vr(pr))
      throw new Error(D);
    if (!Fe(Cr))
      throw new Error(F);
    if (!ke(Ir))
      throw new Error(U);
    return o.schnorr.verify(Cr, Ir, pr);
  }
  return dist$q.isPoint = Dr, dist$q.isPointCompressed = Qr, dist$q.isPrivate = Xr, dist$q.isXOnlyPoint = Vr, dist$q.pointAdd = cr, dist$q.pointAddScalar = hr, dist$q.pointCompress = br, dist$q.pointFromScalar = Gr, dist$q.pointMultiply = Ar, dist$q.privateAdd = Wr, dist$q.privateNegate = Bi, dist$q.privateSub = fi, dist$q.recover = ti, dist$q.sign = $r, dist$q.signRecoverable = oi, dist$q.signSchnorr = zr, dist$q.verify = Lr, dist$q.verifySchnorr = Rr, dist$q.xOnlyPointAddTweak = Ur, dist$q.xOnlyPointFromPoint = Sr, dist$q.xOnlyPointFromScalar = Fr, dist$q;
}
var distExports$1 = requireDist$q();
const ye = /* @__PURE__ */ getDefaultExportFromCjs(distExports$1);
var dist$p = {}, utils$i = {}, stringHelper = {}, commonjsBrowser = {}, v1$2 = {}, rng$3 = {}, hasRequiredRng$1;
function requireRng$1() {
  if (hasRequiredRng$1) return rng$3;
  hasRequiredRng$1 = 1, Object.defineProperty(rng$3, "__esModule", {
    value: !0
  }), rng$3.default = c;
  let o;
  const g = new Uint8Array(16);
  function c() {
    if (!o && (o = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !o))
      throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    return o(g);
  }
  return rng$3;
}
var stringify$2 = {}, validate$3 = {}, regex$1 = {}, hasRequiredRegex$1;
function requireRegex$1() {
  if (hasRequiredRegex$1) return regex$1;
  hasRequiredRegex$1 = 1, Object.defineProperty(regex$1, "__esModule", {
    value: !0
  }), regex$1.default = void 0;
  var o = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
  return regex$1.default = o, regex$1;
}
var hasRequiredValidate$1;
function requireValidate$1() {
  if (hasRequiredValidate$1) return validate$3;
  hasRequiredValidate$1 = 1, Object.defineProperty(validate$3, "__esModule", {
    value: !0
  }), validate$3.default = void 0;
  var o = g(/* @__PURE__ */ requireRegex$1());
  function g(t) {
    return t && t.__esModule ? t : { default: t };
  }
  function c(t) {
    return typeof t == "string" && o.default.test(t);
  }
  var y = c;
  return validate$3.default = y, validate$3;
}
var hasRequiredStringify$1;
function requireStringify$1() {
  if (hasRequiredStringify$1) return stringify$2;
  hasRequiredStringify$1 = 1, Object.defineProperty(stringify$2, "__esModule", {
    value: !0
  }), stringify$2.default = void 0, stringify$2.unsafeStringify = y;
  var o = g(/* @__PURE__ */ requireValidate$1());
  function g(E) {
    return E && E.__esModule ? E : { default: E };
  }
  const c = [];
  for (let E = 0; E < 256; ++E)
    c.push((E + 256).toString(16).slice(1));
  function y(E, B = 0) {
    return c[E[B + 0]] + c[E[B + 1]] + c[E[B + 2]] + c[E[B + 3]] + "-" + c[E[B + 4]] + c[E[B + 5]] + "-" + c[E[B + 6]] + c[E[B + 7]] + "-" + c[E[B + 8]] + c[E[B + 9]] + "-" + c[E[B + 10]] + c[E[B + 11]] + c[E[B + 12]] + c[E[B + 13]] + c[E[B + 14]] + c[E[B + 15]];
  }
  function t(E, B = 0) {
    const D = y(E, B);
    if (!(0, o.default)(D))
      throw TypeError("Stringified UUID is invalid");
    return D;
  }
  var d = t;
  return stringify$2.default = d, stringify$2;
}
var hasRequiredV1$1;
function requireV1$1() {
  if (hasRequiredV1$1) return v1$2;
  hasRequiredV1$1 = 1, Object.defineProperty(v1$2, "__esModule", {
    value: !0
  }), v1$2.default = void 0;
  var o = c(/* @__PURE__ */ requireRng$1()), g = /* @__PURE__ */ requireStringify$1();
  function c(x) {
    return x && x.__esModule ? x : { default: x };
  }
  let y, t, d = 0, E = 0;
  function B(x, v, F) {
    let M = v && F || 0;
    const U = v || new Array(16);
    x = x || {};
    let L = x.node || y, H = x.clockseq !== void 0 ? x.clockseq : t;
    if (L == null || H == null) {
      const ze = x.random || (x.rng || o.default)();
      L == null && (L = y = [ze[0] | 1, ze[1], ze[2], ze[3], ze[4], ze[5]]), H == null && (H = t = (ze[6] << 8 | ze[7]) & 16383);
    }
    let fe = x.msecs !== void 0 ? x.msecs : Date.now(), ge = x.nsecs !== void 0 ? x.nsecs : E + 1;
    const Ie = fe - d + (ge - E) / 1e4;
    if (Ie < 0 && x.clockseq === void 0 && (H = H + 1 & 16383), (Ie < 0 || fe > d) && x.nsecs === void 0 && (ge = 0), ge >= 1e4)
      throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
    d = fe, E = ge, t = H, fe += 122192928e5;
    const Ee = ((fe & 268435455) * 1e4 + ge) % 4294967296;
    U[M++] = Ee >>> 24 & 255, U[M++] = Ee >>> 16 & 255, U[M++] = Ee >>> 8 & 255, U[M++] = Ee & 255;
    const Se = fe / 4294967296 * 1e4 & 268435455;
    U[M++] = Se >>> 8 & 255, U[M++] = Se & 255, U[M++] = Se >>> 24 & 15 | 16, U[M++] = Se >>> 16 & 255, U[M++] = H >>> 8 | 128, U[M++] = H & 255;
    for (let ze = 0; ze < 6; ++ze)
      U[M + ze] = L[ze];
    return v || (0, g.unsafeStringify)(U);
  }
  var D = B;
  return v1$2.default = D, v1$2;
}
var v3$2 = {}, v35$2 = {}, parse$2 = {}, hasRequiredParse$2;
function requireParse$2() {
  if (hasRequiredParse$2) return parse$2;
  hasRequiredParse$2 = 1, Object.defineProperty(parse$2, "__esModule", {
    value: !0
  }), parse$2.default = void 0;
  var o = g(/* @__PURE__ */ requireValidate$1());
  function g(t) {
    return t && t.__esModule ? t : { default: t };
  }
  function c(t) {
    if (!(0, o.default)(t))
      throw TypeError("Invalid UUID");
    let d;
    const E = new Uint8Array(16);
    return E[0] = (d = parseInt(t.slice(0, 8), 16)) >>> 24, E[1] = d >>> 16 & 255, E[2] = d >>> 8 & 255, E[3] = d & 255, E[4] = (d = parseInt(t.slice(9, 13), 16)) >>> 8, E[5] = d & 255, E[6] = (d = parseInt(t.slice(14, 18), 16)) >>> 8, E[7] = d & 255, E[8] = (d = parseInt(t.slice(19, 23), 16)) >>> 8, E[9] = d & 255, E[10] = (d = parseInt(t.slice(24, 36), 16)) / 1099511627776 & 255, E[11] = d / 4294967296 & 255, E[12] = d >>> 24 & 255, E[13] = d >>> 16 & 255, E[14] = d >>> 8 & 255, E[15] = d & 255, E;
  }
  var y = c;
  return parse$2.default = y, parse$2;
}
var hasRequiredV35$1;
function requireV35$1() {
  if (hasRequiredV35$1) return v35$2;
  hasRequiredV35$1 = 1, Object.defineProperty(v35$2, "__esModule", {
    value: !0
  }), v35$2.URL = v35$2.DNS = void 0, v35$2.default = E;
  var o = /* @__PURE__ */ requireStringify$1(), g = c(/* @__PURE__ */ requireParse$2());
  function c(B) {
    return B && B.__esModule ? B : { default: B };
  }
  function y(B) {
    B = unescape(encodeURIComponent(B));
    const D = [];
    for (let x = 0; x < B.length; ++x)
      D.push(B.charCodeAt(x));
    return D;
  }
  const t = "6ba7b810-9dad-11d1-80b4-00c04fd430c8";
  v35$2.DNS = t;
  const d = "6ba7b811-9dad-11d1-80b4-00c04fd430c8";
  v35$2.URL = d;
  function E(B, D, x) {
    function v(F, M, U, L) {
      var H;
      if (typeof F == "string" && (F = y(F)), typeof M == "string" && (M = (0, g.default)(M)), ((H = M) === null || H === void 0 ? void 0 : H.length) !== 16)
        throw TypeError("Namespace must be array-like (16 iterable integer values, 0-255)");
      let fe = new Uint8Array(16 + F.length);
      if (fe.set(M), fe.set(F, M.length), fe = x(fe), fe[6] = fe[6] & 15 | D, fe[8] = fe[8] & 63 | 128, U) {
        L = L || 0;
        for (let ge = 0; ge < 16; ++ge)
          U[L + ge] = fe[ge];
        return U;
      }
      return (0, o.unsafeStringify)(fe);
    }
    try {
      v.name = B;
    } catch {
    }
    return v.DNS = t, v.URL = d, v;
  }
  return v35$2;
}
var md5$5 = {}, hasRequiredMd5$3;
function requireMd5$3() {
  if (hasRequiredMd5$3) return md5$5;
  hasRequiredMd5$3 = 1, Object.defineProperty(md5$5, "__esModule", {
    value: !0
  }), md5$5.default = void 0;
  function o(U) {
    if (typeof U == "string") {
      const L = unescape(encodeURIComponent(U));
      U = new Uint8Array(L.length);
      for (let H = 0; H < L.length; ++H)
        U[H] = L.charCodeAt(H);
    }
    return g(y(t(U), U.length * 8));
  }
  function g(U) {
    const L = [], H = U.length * 32, fe = "0123456789abcdef";
    for (let ge = 0; ge < H; ge += 8) {
      const Ie = U[ge >> 5] >>> ge % 32 & 255, Ee = parseInt(fe.charAt(Ie >>> 4 & 15) + fe.charAt(Ie & 15), 16);
      L.push(Ee);
    }
    return L;
  }
  function c(U) {
    return (U + 64 >>> 9 << 4) + 14 + 1;
  }
  function y(U, L) {
    U[L >> 5] |= 128 << L % 32, U[c(L) - 1] = L;
    let H = 1732584193, fe = -271733879, ge = -1732584194, Ie = 271733878;
    for (let Ee = 0; Ee < U.length; Ee += 16) {
      const Se = H, ze = fe, He = ge, Pe = Ie;
      H = D(H, fe, ge, Ie, U[Ee], 7, -680876936), Ie = D(Ie, H, fe, ge, U[Ee + 1], 12, -389564586), ge = D(ge, Ie, H, fe, U[Ee + 2], 17, 606105819), fe = D(fe, ge, Ie, H, U[Ee + 3], 22, -1044525330), H = D(H, fe, ge, Ie, U[Ee + 4], 7, -176418897), Ie = D(Ie, H, fe, ge, U[Ee + 5], 12, 1200080426), ge = D(ge, Ie, H, fe, U[Ee + 6], 17, -1473231341), fe = D(fe, ge, Ie, H, U[Ee + 7], 22, -45705983), H = D(H, fe, ge, Ie, U[Ee + 8], 7, 1770035416), Ie = D(Ie, H, fe, ge, U[Ee + 9], 12, -1958414417), ge = D(ge, Ie, H, fe, U[Ee + 10], 17, -42063), fe = D(fe, ge, Ie, H, U[Ee + 11], 22, -1990404162), H = D(H, fe, ge, Ie, U[Ee + 12], 7, 1804603682), Ie = D(Ie, H, fe, ge, U[Ee + 13], 12, -40341101), ge = D(ge, Ie, H, fe, U[Ee + 14], 17, -1502002290), fe = D(fe, ge, Ie, H, U[Ee + 15], 22, 1236535329), H = x(H, fe, ge, Ie, U[Ee + 1], 5, -165796510), Ie = x(Ie, H, fe, ge, U[Ee + 6], 9, -1069501632), ge = x(ge, Ie, H, fe, U[Ee + 11], 14, 643717713), fe = x(fe, ge, Ie, H, U[Ee], 20, -373897302), H = x(H, fe, ge, Ie, U[Ee + 5], 5, -701558691), Ie = x(Ie, H, fe, ge, U[Ee + 10], 9, 38016083), ge = x(ge, Ie, H, fe, U[Ee + 15], 14, -660478335), fe = x(fe, ge, Ie, H, U[Ee + 4], 20, -405537848), H = x(H, fe, ge, Ie, U[Ee + 9], 5, 568446438), Ie = x(Ie, H, fe, ge, U[Ee + 14], 9, -1019803690), ge = x(ge, Ie, H, fe, U[Ee + 3], 14, -187363961), fe = x(fe, ge, Ie, H, U[Ee + 8], 20, 1163531501), H = x(H, fe, ge, Ie, U[Ee + 13], 5, -1444681467), Ie = x(Ie, H, fe, ge, U[Ee + 2], 9, -51403784), ge = x(ge, Ie, H, fe, U[Ee + 7], 14, 1735328473), fe = x(fe, ge, Ie, H, U[Ee + 12], 20, -1926607734), H = v(H, fe, ge, Ie, U[Ee + 5], 4, -378558), Ie = v(Ie, H, fe, ge, U[Ee + 8], 11, -2022574463), ge = v(ge, Ie, H, fe, U[Ee + 11], 16, 1839030562), fe = v(fe, ge, Ie, H, U[Ee + 14], 23, -35309556), H = v(H, fe, ge, Ie, U[Ee + 1], 4, -1530992060), Ie = v(Ie, H, fe, ge, U[Ee + 4], 11, 1272893353), ge = v(ge, Ie, H, fe, U[Ee + 7], 16, -155497632), fe = v(fe, ge, Ie, H, U[Ee + 10], 23, -1094730640), H = v(H, fe, ge, Ie, U[Ee + 13], 4, 681279174), Ie = v(Ie, H, fe, ge, U[Ee], 11, -358537222), ge = v(ge, Ie, H, fe, U[Ee + 3], 16, -722521979), fe = v(fe, ge, Ie, H, U[Ee + 6], 23, 76029189), H = v(H, fe, ge, Ie, U[Ee + 9], 4, -640364487), Ie = v(Ie, H, fe, ge, U[Ee + 12], 11, -421815835), ge = v(ge, Ie, H, fe, U[Ee + 15], 16, 530742520), fe = v(fe, ge, Ie, H, U[Ee + 2], 23, -995338651), H = F(H, fe, ge, Ie, U[Ee], 6, -198630844), Ie = F(Ie, H, fe, ge, U[Ee + 7], 10, 1126891415), ge = F(ge, Ie, H, fe, U[Ee + 14], 15, -1416354905), fe = F(fe, ge, Ie, H, U[Ee + 5], 21, -57434055), H = F(H, fe, ge, Ie, U[Ee + 12], 6, 1700485571), Ie = F(Ie, H, fe, ge, U[Ee + 3], 10, -1894986606), ge = F(ge, Ie, H, fe, U[Ee + 10], 15, -1051523), fe = F(fe, ge, Ie, H, U[Ee + 1], 21, -2054922799), H = F(H, fe, ge, Ie, U[Ee + 8], 6, 1873313359), Ie = F(Ie, H, fe, ge, U[Ee + 15], 10, -30611744), ge = F(ge, Ie, H, fe, U[Ee + 6], 15, -1560198380), fe = F(fe, ge, Ie, H, U[Ee + 13], 21, 1309151649), H = F(H, fe, ge, Ie, U[Ee + 4], 6, -145523070), Ie = F(Ie, H, fe, ge, U[Ee + 11], 10, -1120210379), ge = F(ge, Ie, H, fe, U[Ee + 2], 15, 718787259), fe = F(fe, ge, Ie, H, U[Ee + 9], 21, -343485551), H = d(H, Se), fe = d(fe, ze), ge = d(ge, He), Ie = d(Ie, Pe);
    }
    return [H, fe, ge, Ie];
  }
  function t(U) {
    if (U.length === 0)
      return [];
    const L = U.length * 8, H = new Uint32Array(c(L));
    for (let fe = 0; fe < L; fe += 8)
      H[fe >> 5] |= (U[fe / 8] & 255) << fe % 32;
    return H;
  }
  function d(U, L) {
    const H = (U & 65535) + (L & 65535);
    return (U >> 16) + (L >> 16) + (H >> 16) << 16 | H & 65535;
  }
  function E(U, L) {
    return U << L | U >>> 32 - L;
  }
  function B(U, L, H, fe, ge, Ie) {
    return d(E(d(d(L, U), d(fe, Ie)), ge), H);
  }
  function D(U, L, H, fe, ge, Ie, Ee) {
    return B(L & H | ~L & fe, U, L, ge, Ie, Ee);
  }
  function x(U, L, H, fe, ge, Ie, Ee) {
    return B(L & fe | H & ~fe, U, L, ge, Ie, Ee);
  }
  function v(U, L, H, fe, ge, Ie, Ee) {
    return B(L ^ H ^ fe, U, L, ge, Ie, Ee);
  }
  function F(U, L, H, fe, ge, Ie, Ee) {
    return B(H ^ (L | ~fe), U, L, ge, Ie, Ee);
  }
  var M = o;
  return md5$5.default = M, md5$5;
}
var hasRequiredV3$1;
function requireV3$1() {
  if (hasRequiredV3$1) return v3$2;
  hasRequiredV3$1 = 1, Object.defineProperty(v3$2, "__esModule", {
    value: !0
  }), v3$2.default = void 0;
  var o = c(/* @__PURE__ */ requireV35$1()), g = c(/* @__PURE__ */ requireMd5$3());
  function c(d) {
    return d && d.__esModule ? d : { default: d };
  }
  var t = (0, o.default)("v3", 48, g.default);
  return v3$2.default = t, v3$2;
}
var v4$3 = {}, native$3 = {}, hasRequiredNative$2;
function requireNative$2() {
  if (hasRequiredNative$2) return native$3;
  hasRequiredNative$2 = 1, Object.defineProperty(native$3, "__esModule", {
    value: !0
  }), native$3.default = void 0;
  var g = {
    randomUUID: typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto)
  };
  return native$3.default = g, native$3;
}
var hasRequiredV4$1;
function requireV4$1() {
  if (hasRequiredV4$1) return v4$3;
  hasRequiredV4$1 = 1, Object.defineProperty(v4$3, "__esModule", {
    value: !0
  }), v4$3.default = void 0;
  var o = y(/* @__PURE__ */ requireNative$2()), g = y(/* @__PURE__ */ requireRng$1()), c = /* @__PURE__ */ requireStringify$1();
  function y(E) {
    return E && E.__esModule ? E : { default: E };
  }
  function t(E, B, D) {
    if (o.default.randomUUID && !B && !E)
      return o.default.randomUUID();
    E = E || {};
    const x = E.random || (E.rng || g.default)();
    if (x[6] = x[6] & 15 | 64, x[8] = x[8] & 63 | 128, B) {
      D = D || 0;
      for (let v = 0; v < 16; ++v)
        B[D + v] = x[v];
      return B;
    }
    return (0, c.unsafeStringify)(x);
  }
  var d = t;
  return v4$3.default = d, v4$3;
}
var v5$2 = {}, sha1$5 = {}, hasRequiredSha1$3;
function requireSha1$3() {
  if (hasRequiredSha1$3) return sha1$5;
  hasRequiredSha1$3 = 1, Object.defineProperty(sha1$5, "__esModule", {
    value: !0
  }), sha1$5.default = void 0;
  function o(t, d, E, B) {
    switch (t) {
      case 0:
        return d & E ^ ~d & B;
      case 1:
        return d ^ E ^ B;
      case 2:
        return d & E ^ d & B ^ E & B;
      case 3:
        return d ^ E ^ B;
    }
  }
  function g(t, d) {
    return t << d | t >>> 32 - d;
  }
  function c(t) {
    const d = [1518500249, 1859775393, 2400959708, 3395469782], E = [1732584193, 4023233417, 2562383102, 271733878, 3285377520];
    if (typeof t == "string") {
      const v = unescape(encodeURIComponent(t));
      t = [];
      for (let F = 0; F < v.length; ++F)
        t.push(v.charCodeAt(F));
    } else Array.isArray(t) || (t = Array.prototype.slice.call(t));
    t.push(128);
    const B = t.length / 4 + 2, D = Math.ceil(B / 16), x = new Array(D);
    for (let v = 0; v < D; ++v) {
      const F = new Uint32Array(16);
      for (let M = 0; M < 16; ++M)
        F[M] = t[v * 64 + M * 4] << 24 | t[v * 64 + M * 4 + 1] << 16 | t[v * 64 + M * 4 + 2] << 8 | t[v * 64 + M * 4 + 3];
      x[v] = F;
    }
    x[D - 1][14] = (t.length - 1) * 8 / Math.pow(2, 32), x[D - 1][14] = Math.floor(x[D - 1][14]), x[D - 1][15] = (t.length - 1) * 8 & 4294967295;
    for (let v = 0; v < D; ++v) {
      const F = new Uint32Array(80);
      for (let ge = 0; ge < 16; ++ge)
        F[ge] = x[v][ge];
      for (let ge = 16; ge < 80; ++ge)
        F[ge] = g(F[ge - 3] ^ F[ge - 8] ^ F[ge - 14] ^ F[ge - 16], 1);
      let M = E[0], U = E[1], L = E[2], H = E[3], fe = E[4];
      for (let ge = 0; ge < 80; ++ge) {
        const Ie = Math.floor(ge / 20), Ee = g(M, 5) + o(Ie, U, L, H) + fe + d[Ie] + F[ge] >>> 0;
        fe = H, H = L, L = g(U, 30) >>> 0, U = M, M = Ee;
      }
      E[0] = E[0] + M >>> 0, E[1] = E[1] + U >>> 0, E[2] = E[2] + L >>> 0, E[3] = E[3] + H >>> 0, E[4] = E[4] + fe >>> 0;
    }
    return [E[0] >> 24 & 255, E[0] >> 16 & 255, E[0] >> 8 & 255, E[0] & 255, E[1] >> 24 & 255, E[1] >> 16 & 255, E[1] >> 8 & 255, E[1] & 255, E[2] >> 24 & 255, E[2] >> 16 & 255, E[2] >> 8 & 255, E[2] & 255, E[3] >> 24 & 255, E[3] >> 16 & 255, E[3] >> 8 & 255, E[3] & 255, E[4] >> 24 & 255, E[4] >> 16 & 255, E[4] >> 8 & 255, E[4] & 255];
  }
  var y = c;
  return sha1$5.default = y, sha1$5;
}
var hasRequiredV5$1;
function requireV5$1() {
  if (hasRequiredV5$1) return v5$2;
  hasRequiredV5$1 = 1, Object.defineProperty(v5$2, "__esModule", {
    value: !0
  }), v5$2.default = void 0;
  var o = c(/* @__PURE__ */ requireV35$1()), g = c(/* @__PURE__ */ requireSha1$3());
  function c(d) {
    return d && d.__esModule ? d : { default: d };
  }
  var t = (0, o.default)("v5", 80, g.default);
  return v5$2.default = t, v5$2;
}
var nil$2 = {}, hasRequiredNil$1;
function requireNil$1() {
  if (hasRequiredNil$1) return nil$2;
  hasRequiredNil$1 = 1, Object.defineProperty(nil$2, "__esModule", {
    value: !0
  }), nil$2.default = void 0;
  var o = "00000000-0000-0000-0000-000000000000";
  return nil$2.default = o, nil$2;
}
var version$4 = {}, hasRequiredVersion$2;
function requireVersion$2() {
  if (hasRequiredVersion$2) return version$4;
  hasRequiredVersion$2 = 1, Object.defineProperty(version$4, "__esModule", {
    value: !0
  }), version$4.default = void 0;
  var o = g(/* @__PURE__ */ requireValidate$1());
  function g(t) {
    return t && t.__esModule ? t : { default: t };
  }
  function c(t) {
    if (!(0, o.default)(t))
      throw TypeError("Invalid UUID");
    return parseInt(t.slice(14, 15), 16);
  }
  var y = c;
  return version$4.default = y, version$4;
}
var hasRequiredCommonjsBrowser;
function requireCommonjsBrowser() {
  return hasRequiredCommonjsBrowser || (hasRequiredCommonjsBrowser = 1, function(o) {
    Object.defineProperty(o, "__esModule", {
      value: !0
    }), Object.defineProperty(o, "NIL", {
      enumerable: !0,
      get: function() {
        return d.default;
      }
    }), Object.defineProperty(o, "parse", {
      enumerable: !0,
      get: function() {
        return x.default;
      }
    }), Object.defineProperty(o, "stringify", {
      enumerable: !0,
      get: function() {
        return D.default;
      }
    }), Object.defineProperty(o, "v1", {
      enumerable: !0,
      get: function() {
        return g.default;
      }
    }), Object.defineProperty(o, "v3", {
      enumerable: !0,
      get: function() {
        return c.default;
      }
    }), Object.defineProperty(o, "v4", {
      enumerable: !0,
      get: function() {
        return y.default;
      }
    }), Object.defineProperty(o, "v5", {
      enumerable: !0,
      get: function() {
        return t.default;
      }
    }), Object.defineProperty(o, "validate", {
      enumerable: !0,
      get: function() {
        return B.default;
      }
    }), Object.defineProperty(o, "version", {
      enumerable: !0,
      get: function() {
        return E.default;
      }
    });
    var g = v(/* @__PURE__ */ requireV1$1()), c = v(/* @__PURE__ */ requireV3$1()), y = v(/* @__PURE__ */ requireV4$1()), t = v(/* @__PURE__ */ requireV5$1()), d = v(/* @__PURE__ */ requireNil$1()), E = v(/* @__PURE__ */ requireVersion$2()), B = v(/* @__PURE__ */ requireValidate$1()), D = v(/* @__PURE__ */ requireStringify$1()), x = v(/* @__PURE__ */ requireParse$2());
    function v(F) {
      return F && F.__esModule ? F : { default: F };
    }
  }(commonjsBrowser)), commonjsBrowser;
}
var buffer$2 = {}, base64Js = {}, hasRequiredBase64Js;
function requireBase64Js() {
  if (hasRequiredBase64Js) return base64Js;
  hasRequiredBase64Js = 1, base64Js.byteLength = B, base64Js.toByteArray = x, base64Js.fromByteArray = M;
  for (var o = [], g = [], c = typeof Uint8Array < "u" ? Uint8Array : Array, y = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", t = 0, d = y.length; t < d; ++t)
    o[t] = y[t], g[y.charCodeAt(t)] = t;
  g[45] = 62, g[95] = 63;
  function E(U) {
    var L = U.length;
    if (L % 4 > 0)
      throw new Error("Invalid string. Length must be a multiple of 4");
    var H = U.indexOf("=");
    H === -1 && (H = L);
    var fe = H === L ? 0 : 4 - H % 4;
    return [H, fe];
  }
  function B(U) {
    var L = E(U), H = L[0], fe = L[1];
    return (H + fe) * 3 / 4 - fe;
  }
  function D(U, L, H) {
    return (L + H) * 3 / 4 - H;
  }
  function x(U) {
    var L, H = E(U), fe = H[0], ge = H[1], Ie = new c(D(U, fe, ge)), Ee = 0, Se = ge > 0 ? fe - 4 : fe, ze;
    for (ze = 0; ze < Se; ze += 4)
      L = g[U.charCodeAt(ze)] << 18 | g[U.charCodeAt(ze + 1)] << 12 | g[U.charCodeAt(ze + 2)] << 6 | g[U.charCodeAt(ze + 3)], Ie[Ee++] = L >> 16 & 255, Ie[Ee++] = L >> 8 & 255, Ie[Ee++] = L & 255;
    return ge === 2 && (L = g[U.charCodeAt(ze)] << 2 | g[U.charCodeAt(ze + 1)] >> 4, Ie[Ee++] = L & 255), ge === 1 && (L = g[U.charCodeAt(ze)] << 10 | g[U.charCodeAt(ze + 1)] << 4 | g[U.charCodeAt(ze + 2)] >> 2, Ie[Ee++] = L >> 8 & 255, Ie[Ee++] = L & 255), Ie;
  }
  function v(U) {
    return o[U >> 18 & 63] + o[U >> 12 & 63] + o[U >> 6 & 63] + o[U & 63];
  }
  function F(U, L, H) {
    for (var fe, ge = [], Ie = L; Ie < H; Ie += 3)
      fe = (U[Ie] << 16 & 16711680) + (U[Ie + 1] << 8 & 65280) + (U[Ie + 2] & 255), ge.push(v(fe));
    return ge.join("");
  }
  function M(U) {
    for (var L, H = U.length, fe = H % 3, ge = [], Ie = 16383, Ee = 0, Se = H - fe; Ee < Se; Ee += Ie)
      ge.push(F(U, Ee, Ee + Ie > Se ? Se : Ee + Ie));
    return fe === 1 ? (L = U[H - 1], ge.push(
      o[L >> 2] + o[L << 4 & 63] + "=="
    )) : fe === 2 && (L = (U[H - 2] << 8) + U[H - 1], ge.push(
      o[L >> 10] + o[L >> 4 & 63] + o[L << 2 & 63] + "="
    )), ge.join("");
  }
  return base64Js;
}
var ieee754 = {};
var hasRequiredIeee754;
function requireIeee754() {
  return hasRequiredIeee754 || (hasRequiredIeee754 = 1, ieee754.read = function(o, g, c, y, t) {
    var d, E, B = t * 8 - y - 1, D = (1 << B) - 1, x = D >> 1, v = -7, F = c ? t - 1 : 0, M = c ? -1 : 1, U = o[g + F];
    for (F += M, d = U & (1 << -v) - 1, U >>= -v, v += B; v > 0; d = d * 256 + o[g + F], F += M, v -= 8)
      ;
    for (E = d & (1 << -v) - 1, d >>= -v, v += y; v > 0; E = E * 256 + o[g + F], F += M, v -= 8)
      ;
    if (d === 0)
      d = 1 - x;
    else {
      if (d === D)
        return E ? NaN : (U ? -1 : 1) * (1 / 0);
      E = E + Math.pow(2, y), d = d - x;
    }
    return (U ? -1 : 1) * E * Math.pow(2, d - y);
  }, ieee754.write = function(o, g, c, y, t, d) {
    var E, B, D, x = d * 8 - t - 1, v = (1 << x) - 1, F = v >> 1, M = t === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, U = y ? 0 : d - 1, L = y ? 1 : -1, H = g < 0 || g === 0 && 1 / g < 0 ? 1 : 0;
    for (g = Math.abs(g), isNaN(g) || g === 1 / 0 ? (B = isNaN(g) ? 1 : 0, E = v) : (E = Math.floor(Math.log(g) / Math.LN2), g * (D = Math.pow(2, -E)) < 1 && (E--, D *= 2), E + F >= 1 ? g += M / D : g += M * Math.pow(2, 1 - F), g * D >= 2 && (E++, D /= 2), E + F >= v ? (B = 0, E = v) : E + F >= 1 ? (B = (g * D - 1) * Math.pow(2, t), E = E + F) : (B = g * Math.pow(2, F - 1) * Math.pow(2, t), E = 0)); t >= 8; o[c + U] = B & 255, U += L, B /= 256, t -= 8)
      ;
    for (E = E << t | B, x += t; x > 0; o[c + U] = E & 255, U += L, E /= 256, x -= 8)
      ;
    o[c + U - L] |= H * 128;
  }), ieee754;
}
var hasRequiredBuffer$2;
function requireBuffer$2() {
  return hasRequiredBuffer$2 || (hasRequiredBuffer$2 = 1, function(o) {
    const g = requireBase64Js(), c = requireIeee754(), y = typeof Symbol == "function" && typeof Symbol.for == "function" ? Symbol.for("nodejs.util.inspect.custom") : null;
    o.Buffer = B, o.SlowBuffer = Ie, o.INSPECT_MAX_BYTES = 50;
    const t = 2147483647;
    o.kMaxLength = t, B.TYPED_ARRAY_SUPPORT = d(), !B.TYPED_ARRAY_SUPPORT && typeof console < "u" && typeof console.error == "function" && console.error(
      "This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."
    );
    function d() {
      try {
        const Rr = new Uint8Array(1), Ir = { foo: function() {
          return 42;
        } };
        return Object.setPrototypeOf(Ir, Uint8Array.prototype), Object.setPrototypeOf(Rr, Ir), Rr.foo() === 42;
      } catch {
        return !1;
      }
    }
    Object.defineProperty(B.prototype, "parent", {
      enumerable: !0,
      get: function() {
        if (B.isBuffer(this))
          return this.buffer;
      }
    }), Object.defineProperty(B.prototype, "offset", {
      enumerable: !0,
      get: function() {
        if (B.isBuffer(this))
          return this.byteOffset;
      }
    });
    function E(Rr) {
      if (Rr > t)
        throw new RangeError('The value "' + Rr + '" is invalid for option "size"');
      const Ir = new Uint8Array(Rr);
      return Object.setPrototypeOf(Ir, B.prototype), Ir;
    }
    function B(Rr, Ir, pr) {
      if (typeof Rr == "number") {
        if (typeof Ir == "string")
          throw new TypeError(
            'The "string" argument must be of type string. Received type number'
          );
        return F(Rr);
      }
      return D(Rr, Ir, pr);
    }
    B.poolSize = 8192;
    function D(Rr, Ir, pr) {
      if (typeof Rr == "string")
        return M(Rr, Ir);
      if (ArrayBuffer.isView(Rr))
        return L(Rr);
      if (Rr == null)
        throw new TypeError(
          "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof Rr
        );
      if ($r(Rr, ArrayBuffer) || Rr && $r(Rr.buffer, ArrayBuffer) || typeof SharedArrayBuffer < "u" && ($r(Rr, SharedArrayBuffer) || Rr && $r(Rr.buffer, SharedArrayBuffer)))
        return H(Rr, Ir, pr);
      if (typeof Rr == "number")
        throw new TypeError(
          'The "value" argument must not be of type number. Received type number'
        );
      const Cr = Rr.valueOf && Rr.valueOf();
      if (Cr != null && Cr !== Rr)
        return B.from(Cr, Ir, pr);
      const Er = fe(Rr);
      if (Er) return Er;
      if (typeof Symbol < "u" && Symbol.toPrimitive != null && typeof Rr[Symbol.toPrimitive] == "function")
        return B.from(Rr[Symbol.toPrimitive]("string"), Ir, pr);
      throw new TypeError(
        "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof Rr
      );
    }
    B.from = function(Rr, Ir, pr) {
      return D(Rr, Ir, pr);
    }, Object.setPrototypeOf(B.prototype, Uint8Array.prototype), Object.setPrototypeOf(B, Uint8Array);
    function x(Rr) {
      if (typeof Rr != "number")
        throw new TypeError('"size" argument must be of type number');
      if (Rr < 0)
        throw new RangeError('The value "' + Rr + '" is invalid for option "size"');
    }
    function v(Rr, Ir, pr) {
      return x(Rr), Rr <= 0 ? E(Rr) : Ir !== void 0 ? typeof pr == "string" ? E(Rr).fill(Ir, pr) : E(Rr).fill(Ir) : E(Rr);
    }
    B.alloc = function(Rr, Ir, pr) {
      return v(Rr, Ir, pr);
    };
    function F(Rr) {
      return x(Rr), E(Rr < 0 ? 0 : ge(Rr) | 0);
    }
    B.allocUnsafe = function(Rr) {
      return F(Rr);
    }, B.allocUnsafeSlow = function(Rr) {
      return F(Rr);
    };
    function M(Rr, Ir) {
      if ((typeof Ir != "string" || Ir === "") && (Ir = "utf8"), !B.isEncoding(Ir))
        throw new TypeError("Unknown encoding: " + Ir);
      const pr = Ee(Rr, Ir) | 0;
      let Cr = E(pr);
      const Er = Cr.write(Rr, Ir);
      return Er !== pr && (Cr = Cr.slice(0, Er)), Cr;
    }
    function U(Rr) {
      const Ir = Rr.length < 0 ? 0 : ge(Rr.length) | 0, pr = E(Ir);
      for (let Cr = 0; Cr < Ir; Cr += 1)
        pr[Cr] = Rr[Cr] & 255;
      return pr;
    }
    function L(Rr) {
      if ($r(Rr, Uint8Array)) {
        const Ir = new Uint8Array(Rr);
        return H(Ir.buffer, Ir.byteOffset, Ir.byteLength);
      }
      return U(Rr);
    }
    function H(Rr, Ir, pr) {
      if (Ir < 0 || Rr.byteLength < Ir)
        throw new RangeError('"offset" is outside of buffer bounds');
      if (Rr.byteLength < Ir + (pr || 0))
        throw new RangeError('"length" is outside of buffer bounds');
      let Cr;
      return Ir === void 0 && pr === void 0 ? Cr = new Uint8Array(Rr) : pr === void 0 ? Cr = new Uint8Array(Rr, Ir) : Cr = new Uint8Array(Rr, Ir, pr), Object.setPrototypeOf(Cr, B.prototype), Cr;
    }
    function fe(Rr) {
      if (B.isBuffer(Rr)) {
        const Ir = ge(Rr.length) | 0, pr = E(Ir);
        return pr.length === 0 || Rr.copy(pr, 0, 0, Ir), pr;
      }
      if (Rr.length !== void 0)
        return typeof Rr.length != "number" || oi(Rr.length) ? E(0) : U(Rr);
      if (Rr.type === "Buffer" && Array.isArray(Rr.data))
        return U(Rr.data);
    }
    function ge(Rr) {
      if (Rr >= t)
        throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + t.toString(16) + " bytes");
      return Rr | 0;
    }
    function Ie(Rr) {
      return +Rr != Rr && (Rr = 0), B.alloc(+Rr);
    }
    B.isBuffer = function(Ir) {
      return Ir != null && Ir._isBuffer === !0 && Ir !== B.prototype;
    }, B.compare = function(Ir, pr) {
      if ($r(Ir, Uint8Array) && (Ir = B.from(Ir, Ir.offset, Ir.byteLength)), $r(pr, Uint8Array) && (pr = B.from(pr, pr.offset, pr.byteLength)), !B.isBuffer(Ir) || !B.isBuffer(pr))
        throw new TypeError(
          'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
        );
      if (Ir === pr) return 0;
      let Cr = Ir.length, Er = pr.length;
      for (let xr = 0, si = Math.min(Cr, Er); xr < si; ++xr)
        if (Ir[xr] !== pr[xr]) {
          Cr = Ir[xr], Er = pr[xr];
          break;
        }
      return Cr < Er ? -1 : Er < Cr ? 1 : 0;
    }, B.isEncoding = function(Ir) {
      switch (String(Ir).toLowerCase()) {
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return !0;
        default:
          return !1;
      }
    }, B.concat = function(Ir, pr) {
      if (!Array.isArray(Ir))
        throw new TypeError('"list" argument must be an Array of Buffers');
      if (Ir.length === 0)
        return B.alloc(0);
      let Cr;
      if (pr === void 0)
        for (pr = 0, Cr = 0; Cr < Ir.length; ++Cr)
          pr += Ir[Cr].length;
      const Er = B.allocUnsafe(pr);
      let xr = 0;
      for (Cr = 0; Cr < Ir.length; ++Cr) {
        let si = Ir[Cr];
        if ($r(si, Uint8Array))
          xr + si.length > Er.length ? (B.isBuffer(si) || (si = B.from(si)), si.copy(Er, xr)) : Uint8Array.prototype.set.call(
            Er,
            si,
            xr
          );
        else if (B.isBuffer(si))
          si.copy(Er, xr);
        else
          throw new TypeError('"list" argument must be an Array of Buffers');
        xr += si.length;
      }
      return Er;
    };
    function Ee(Rr, Ir) {
      if (B.isBuffer(Rr))
        return Rr.length;
      if (ArrayBuffer.isView(Rr) || $r(Rr, ArrayBuffer))
        return Rr.byteLength;
      if (typeof Rr != "string")
        throw new TypeError(
          'The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof Rr
        );
      const pr = Rr.length, Cr = arguments.length > 2 && arguments[2] === !0;
      if (!Cr && pr === 0) return 0;
      let Er = !1;
      for (; ; )
        switch (Ir) {
          case "ascii":
          case "latin1":
          case "binary":
            return pr;
          case "utf8":
          case "utf-8":
            return cr(Rr).length;
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return pr * 2;
          case "hex":
            return pr >>> 1;
          case "base64":
            return fi(Rr).length;
          default:
            if (Er)
              return Cr ? -1 : cr(Rr).length;
            Ir = ("" + Ir).toLowerCase(), Er = !0;
        }
    }
    B.byteLength = Ee;
    function Se(Rr, Ir, pr) {
      let Cr = !1;
      if ((Ir === void 0 || Ir < 0) && (Ir = 0), Ir > this.length || ((pr === void 0 || pr > this.length) && (pr = this.length), pr <= 0) || (pr >>>= 0, Ir >>>= 0, pr <= Ir))
        return "";
      for (Rr || (Rr = "utf8"); ; )
        switch (Rr) {
          case "hex":
            return er(this, Ir, pr);
          case "utf8":
          case "utf-8":
            return xe(this, Ir, pr);
          case "ascii":
            return st(this, Ir, pr);
          case "latin1":
          case "binary":
            return Dt(this, Ir, pr);
          case "base64":
            return ke(this, Ir, pr);
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return xt(this, Ir, pr);
          default:
            if (Cr) throw new TypeError("Unknown encoding: " + Rr);
            Rr = (Rr + "").toLowerCase(), Cr = !0;
        }
    }
    B.prototype._isBuffer = !0;
    function ze(Rr, Ir, pr) {
      const Cr = Rr[Ir];
      Rr[Ir] = Rr[pr], Rr[pr] = Cr;
    }
    B.prototype.swap16 = function() {
      const Ir = this.length;
      if (Ir % 2 !== 0)
        throw new RangeError("Buffer size must be a multiple of 16-bits");
      for (let pr = 0; pr < Ir; pr += 2)
        ze(this, pr, pr + 1);
      return this;
    }, B.prototype.swap32 = function() {
      const Ir = this.length;
      if (Ir % 4 !== 0)
        throw new RangeError("Buffer size must be a multiple of 32-bits");
      for (let pr = 0; pr < Ir; pr += 4)
        ze(this, pr, pr + 3), ze(this, pr + 1, pr + 2);
      return this;
    }, B.prototype.swap64 = function() {
      const Ir = this.length;
      if (Ir % 8 !== 0)
        throw new RangeError("Buffer size must be a multiple of 64-bits");
      for (let pr = 0; pr < Ir; pr += 8)
        ze(this, pr, pr + 7), ze(this, pr + 1, pr + 6), ze(this, pr + 2, pr + 5), ze(this, pr + 3, pr + 4);
      return this;
    }, B.prototype.toString = function() {
      const Ir = this.length;
      return Ir === 0 ? "" : arguments.length === 0 ? xe(this, 0, Ir) : Se.apply(this, arguments);
    }, B.prototype.toLocaleString = B.prototype.toString, B.prototype.equals = function(Ir) {
      if (!B.isBuffer(Ir)) throw new TypeError("Argument must be a Buffer");
      return this === Ir ? !0 : B.compare(this, Ir) === 0;
    }, B.prototype.inspect = function() {
      let Ir = "";
      const pr = o.INSPECT_MAX_BYTES;
      return Ir = this.toString("hex", 0, pr).replace(/(.{2})/g, "$1 ").trim(), this.length > pr && (Ir += " ... "), "<Buffer " + Ir + ">";
    }, y && (B.prototype[y] = B.prototype.inspect), B.prototype.compare = function(Ir, pr, Cr, Er, xr) {
      if ($r(Ir, Uint8Array) && (Ir = B.from(Ir, Ir.offset, Ir.byteLength)), !B.isBuffer(Ir))
        throw new TypeError(
          'The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof Ir
        );
      if (pr === void 0 && (pr = 0), Cr === void 0 && (Cr = Ir ? Ir.length : 0), Er === void 0 && (Er = 0), xr === void 0 && (xr = this.length), pr < 0 || Cr > Ir.length || Er < 0 || xr > this.length)
        throw new RangeError("out of range index");
      if (Er >= xr && pr >= Cr)
        return 0;
      if (Er >= xr)
        return -1;
      if (pr >= Cr)
        return 1;
      if (pr >>>= 0, Cr >>>= 0, Er >>>= 0, xr >>>= 0, this === Ir) return 0;
      let si = xr - Er, Ci = Cr - pr;
      const bi = Math.min(si, Ci), Ri = this.slice(Er, xr), li = Ir.slice(pr, Cr);
      for (let zi = 0; zi < bi; ++zi)
        if (Ri[zi] !== li[zi]) {
          si = Ri[zi], Ci = li[zi];
          break;
        }
      return si < Ci ? -1 : Ci < si ? 1 : 0;
    };
    function He(Rr, Ir, pr, Cr, Er) {
      if (Rr.length === 0) return -1;
      if (typeof pr == "string" ? (Cr = pr, pr = 0) : pr > 2147483647 ? pr = 2147483647 : pr < -2147483648 && (pr = -2147483648), pr = +pr, oi(pr) && (pr = Er ? 0 : Rr.length - 1), pr < 0 && (pr = Rr.length + pr), pr >= Rr.length) {
        if (Er) return -1;
        pr = Rr.length - 1;
      } else if (pr < 0)
        if (Er) pr = 0;
        else return -1;
      if (typeof Ir == "string" && (Ir = B.from(Ir, Cr)), B.isBuffer(Ir))
        return Ir.length === 0 ? -1 : Pe(Rr, Ir, pr, Cr, Er);
      if (typeof Ir == "number")
        return Ir = Ir & 255, typeof Uint8Array.prototype.indexOf == "function" ? Er ? Uint8Array.prototype.indexOf.call(Rr, Ir, pr) : Uint8Array.prototype.lastIndexOf.call(Rr, Ir, pr) : Pe(Rr, [Ir], pr, Cr, Er);
      throw new TypeError("val must be string, number or Buffer");
    }
    function Pe(Rr, Ir, pr, Cr, Er) {
      let xr = 1, si = Rr.length, Ci = Ir.length;
      if (Cr !== void 0 && (Cr = String(Cr).toLowerCase(), Cr === "ucs2" || Cr === "ucs-2" || Cr === "utf16le" || Cr === "utf-16le")) {
        if (Rr.length < 2 || Ir.length < 2)
          return -1;
        xr = 2, si /= 2, Ci /= 2, pr /= 2;
      }
      function bi(li, zi) {
        return xr === 1 ? li[zi] : li.readUInt16BE(zi * xr);
      }
      let Ri;
      if (Er) {
        let li = -1;
        for (Ri = pr; Ri < si; Ri++)
          if (bi(Rr, Ri) === bi(Ir, li === -1 ? 0 : Ri - li)) {
            if (li === -1 && (li = Ri), Ri - li + 1 === Ci) return li * xr;
          } else
            li !== -1 && (Ri -= Ri - li), li = -1;
      } else
        for (pr + Ci > si && (pr = si - Ci), Ri = pr; Ri >= 0; Ri--) {
          let li = !0;
          for (let zi = 0; zi < Ci; zi++)
            if (bi(Rr, Ri + zi) !== bi(Ir, zi)) {
              li = !1;
              break;
            }
          if (li) return Ri;
        }
      return -1;
    }
    B.prototype.includes = function(Ir, pr, Cr) {
      return this.indexOf(Ir, pr, Cr) !== -1;
    }, B.prototype.indexOf = function(Ir, pr, Cr) {
      return He(this, Ir, pr, Cr, !0);
    }, B.prototype.lastIndexOf = function(Ir, pr, Cr) {
      return He(this, Ir, pr, Cr, !1);
    };
    function De(Rr, Ir, pr, Cr) {
      pr = Number(pr) || 0;
      const Er = Rr.length - pr;
      Cr ? (Cr = Number(Cr), Cr > Er && (Cr = Er)) : Cr = Er;
      const xr = Ir.length;
      Cr > xr / 2 && (Cr = xr / 2);
      let si;
      for (si = 0; si < Cr; ++si) {
        const Ci = parseInt(Ir.substr(si * 2, 2), 16);
        if (oi(Ci)) return si;
        Rr[pr + si] = Ci;
      }
      return si;
    }
    function ve(Rr, Ir, pr, Cr) {
      return Bi(cr(Ir, Rr.length - pr), Rr, pr, Cr);
    }
    function Fe(Rr, Ir, pr, Cr) {
      return Bi(hr(Ir), Rr, pr, Cr);
    }
    function be(Rr, Ir, pr, Cr) {
      return Bi(fi(Ir), Rr, pr, Cr);
    }
    function Be(Rr, Ir, pr, Cr) {
      return Bi(Wr(Ir, Rr.length - pr), Rr, pr, Cr);
    }
    B.prototype.write = function(Ir, pr, Cr, Er) {
      if (pr === void 0)
        Er = "utf8", Cr = this.length, pr = 0;
      else if (Cr === void 0 && typeof pr == "string")
        Er = pr, Cr = this.length, pr = 0;
      else if (isFinite(pr))
        pr = pr >>> 0, isFinite(Cr) ? (Cr = Cr >>> 0, Er === void 0 && (Er = "utf8")) : (Er = Cr, Cr = void 0);
      else
        throw new Error(
          "Buffer.write(string, encoding, offset[, length]) is no longer supported"
        );
      const xr = this.length - pr;
      if ((Cr === void 0 || Cr > xr) && (Cr = xr), Ir.length > 0 && (Cr < 0 || pr < 0) || pr > this.length)
        throw new RangeError("Attempt to write outside buffer bounds");
      Er || (Er = "utf8");
      let si = !1;
      for (; ; )
        switch (Er) {
          case "hex":
            return De(this, Ir, pr, Cr);
          case "utf8":
          case "utf-8":
            return ve(this, Ir, pr, Cr);
          case "ascii":
          case "latin1":
          case "binary":
            return Fe(this, Ir, pr, Cr);
          case "base64":
            return be(this, Ir, pr, Cr);
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return Be(this, Ir, pr, Cr);
          default:
            if (si) throw new TypeError("Unknown encoding: " + Er);
            Er = ("" + Er).toLowerCase(), si = !0;
        }
    }, B.prototype.toJSON = function() {
      return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
      };
    };
    function ke(Rr, Ir, pr) {
      return Ir === 0 && pr === Rr.length ? g.fromByteArray(Rr) : g.fromByteArray(Rr.slice(Ir, pr));
    }
    function xe(Rr, Ir, pr) {
      pr = Math.min(Rr.length, pr);
      const Cr = [];
      let Er = Ir;
      for (; Er < pr; ) {
        const xr = Rr[Er];
        let si = null, Ci = xr > 239 ? 4 : xr > 223 ? 3 : xr > 191 ? 2 : 1;
        if (Er + Ci <= pr) {
          let bi, Ri, li, zi;
          switch (Ci) {
            case 1:
              xr < 128 && (si = xr);
              break;
            case 2:
              bi = Rr[Er + 1], (bi & 192) === 128 && (zi = (xr & 31) << 6 | bi & 63, zi > 127 && (si = zi));
              break;
            case 3:
              bi = Rr[Er + 1], Ri = Rr[Er + 2], (bi & 192) === 128 && (Ri & 192) === 128 && (zi = (xr & 15) << 12 | (bi & 63) << 6 | Ri & 63, zi > 2047 && (zi < 55296 || zi > 57343) && (si = zi));
              break;
            case 4:
              bi = Rr[Er + 1], Ri = Rr[Er + 2], li = Rr[Er + 3], (bi & 192) === 128 && (Ri & 192) === 128 && (li & 192) === 128 && (zi = (xr & 15) << 18 | (bi & 63) << 12 | (Ri & 63) << 6 | li & 63, zi > 65535 && zi < 1114112 && (si = zi));
          }
        }
        si === null ? (si = 65533, Ci = 1) : si > 65535 && (si -= 65536, Cr.push(si >>> 10 & 1023 | 55296), si = 56320 | si & 1023), Cr.push(si), Er += Ci;
      }
      return Et(Cr);
    }
    const Ne = 4096;
    function Et(Rr) {
      const Ir = Rr.length;
      if (Ir <= Ne)
        return String.fromCharCode.apply(String, Rr);
      let pr = "", Cr = 0;
      for (; Cr < Ir; )
        pr += String.fromCharCode.apply(
          String,
          Rr.slice(Cr, Cr += Ne)
        );
      return pr;
    }
    function st(Rr, Ir, pr) {
      let Cr = "";
      pr = Math.min(Rr.length, pr);
      for (let Er = Ir; Er < pr; ++Er)
        Cr += String.fromCharCode(Rr[Er] & 127);
      return Cr;
    }
    function Dt(Rr, Ir, pr) {
      let Cr = "";
      pr = Math.min(Rr.length, pr);
      for (let Er = Ir; Er < pr; ++Er)
        Cr += String.fromCharCode(Rr[Er]);
      return Cr;
    }
    function er(Rr, Ir, pr) {
      const Cr = Rr.length;
      (!Ir || Ir < 0) && (Ir = 0), (!pr || pr < 0 || pr > Cr) && (pr = Cr);
      let Er = "";
      for (let xr = Ir; xr < pr; ++xr)
        Er += zr[Rr[xr]];
      return Er;
    }
    function xt(Rr, Ir, pr) {
      const Cr = Rr.slice(Ir, pr);
      let Er = "";
      for (let xr = 0; xr < Cr.length - 1; xr += 2)
        Er += String.fromCharCode(Cr[xr] + Cr[xr + 1] * 256);
      return Er;
    }
    B.prototype.slice = function(Ir, pr) {
      const Cr = this.length;
      Ir = ~~Ir, pr = pr === void 0 ? Cr : ~~pr, Ir < 0 ? (Ir += Cr, Ir < 0 && (Ir = 0)) : Ir > Cr && (Ir = Cr), pr < 0 ? (pr += Cr, pr < 0 && (pr = 0)) : pr > Cr && (pr = Cr), pr < Ir && (pr = Ir);
      const Er = this.subarray(Ir, pr);
      return Object.setPrototypeOf(Er, B.prototype), Er;
    };
    function ir(Rr, Ir, pr) {
      if (Rr % 1 !== 0 || Rr < 0) throw new RangeError("offset is not uint");
      if (Rr + Ir > pr) throw new RangeError("Trying to access beyond buffer length");
    }
    B.prototype.readUintLE = B.prototype.readUIntLE = function(Ir, pr, Cr) {
      Ir = Ir >>> 0, pr = pr >>> 0, Cr || ir(Ir, pr, this.length);
      let Er = this[Ir], xr = 1, si = 0;
      for (; ++si < pr && (xr *= 256); )
        Er += this[Ir + si] * xr;
      return Er;
    }, B.prototype.readUintBE = B.prototype.readUIntBE = function(Ir, pr, Cr) {
      Ir = Ir >>> 0, pr = pr >>> 0, Cr || ir(Ir, pr, this.length);
      let Er = this[Ir + --pr], xr = 1;
      for (; pr > 0 && (xr *= 256); )
        Er += this[Ir + --pr] * xr;
      return Er;
    }, B.prototype.readUint8 = B.prototype.readUInt8 = function(Ir, pr) {
      return Ir = Ir >>> 0, pr || ir(Ir, 1, this.length), this[Ir];
    }, B.prototype.readUint16LE = B.prototype.readUInt16LE = function(Ir, pr) {
      return Ir = Ir >>> 0, pr || ir(Ir, 2, this.length), this[Ir] | this[Ir + 1] << 8;
    }, B.prototype.readUint16BE = B.prototype.readUInt16BE = function(Ir, pr) {
      return Ir = Ir >>> 0, pr || ir(Ir, 2, this.length), this[Ir] << 8 | this[Ir + 1];
    }, B.prototype.readUint32LE = B.prototype.readUInt32LE = function(Ir, pr) {
      return Ir = Ir >>> 0, pr || ir(Ir, 4, this.length), (this[Ir] | this[Ir + 1] << 8 | this[Ir + 2] << 16) + this[Ir + 3] * 16777216;
    }, B.prototype.readUint32BE = B.prototype.readUInt32BE = function(Ir, pr) {
      return Ir = Ir >>> 0, pr || ir(Ir, 4, this.length), this[Ir] * 16777216 + (this[Ir + 1] << 16 | this[Ir + 2] << 8 | this[Ir + 3]);
    }, B.prototype.readBigUInt64LE = ti(function(Ir) {
      Ir = Ir >>> 0, Gr(Ir, "offset");
      const pr = this[Ir], Cr = this[Ir + 7];
      (pr === void 0 || Cr === void 0) && Fr(Ir, this.length - 8);
      const Er = pr + this[++Ir] * 2 ** 8 + this[++Ir] * 2 ** 16 + this[++Ir] * 2 ** 24, xr = this[++Ir] + this[++Ir] * 2 ** 8 + this[++Ir] * 2 ** 16 + Cr * 2 ** 24;
      return BigInt(Er) + (BigInt(xr) << BigInt(32));
    }), B.prototype.readBigUInt64BE = ti(function(Ir) {
      Ir = Ir >>> 0, Gr(Ir, "offset");
      const pr = this[Ir], Cr = this[Ir + 7];
      (pr === void 0 || Cr === void 0) && Fr(Ir, this.length - 8);
      const Er = pr * 2 ** 24 + this[++Ir] * 2 ** 16 + this[++Ir] * 2 ** 8 + this[++Ir], xr = this[++Ir] * 2 ** 24 + this[++Ir] * 2 ** 16 + this[++Ir] * 2 ** 8 + Cr;
      return (BigInt(Er) << BigInt(32)) + BigInt(xr);
    }), B.prototype.readIntLE = function(Ir, pr, Cr) {
      Ir = Ir >>> 0, pr = pr >>> 0, Cr || ir(Ir, pr, this.length);
      let Er = this[Ir], xr = 1, si = 0;
      for (; ++si < pr && (xr *= 256); )
        Er += this[Ir + si] * xr;
      return xr *= 128, Er >= xr && (Er -= Math.pow(2, 8 * pr)), Er;
    }, B.prototype.readIntBE = function(Ir, pr, Cr) {
      Ir = Ir >>> 0, pr = pr >>> 0, Cr || ir(Ir, pr, this.length);
      let Er = pr, xr = 1, si = this[Ir + --Er];
      for (; Er > 0 && (xr *= 256); )
        si += this[Ir + --Er] * xr;
      return xr *= 128, si >= xr && (si -= Math.pow(2, 8 * pr)), si;
    }, B.prototype.readInt8 = function(Ir, pr) {
      return Ir = Ir >>> 0, pr || ir(Ir, 1, this.length), this[Ir] & 128 ? (255 - this[Ir] + 1) * -1 : this[Ir];
    }, B.prototype.readInt16LE = function(Ir, pr) {
      Ir = Ir >>> 0, pr || ir(Ir, 2, this.length);
      const Cr = this[Ir] | this[Ir + 1] << 8;
      return Cr & 32768 ? Cr | 4294901760 : Cr;
    }, B.prototype.readInt16BE = function(Ir, pr) {
      Ir = Ir >>> 0, pr || ir(Ir, 2, this.length);
      const Cr = this[Ir + 1] | this[Ir] << 8;
      return Cr & 32768 ? Cr | 4294901760 : Cr;
    }, B.prototype.readInt32LE = function(Ir, pr) {
      return Ir = Ir >>> 0, pr || ir(Ir, 4, this.length), this[Ir] | this[Ir + 1] << 8 | this[Ir + 2] << 16 | this[Ir + 3] << 24;
    }, B.prototype.readInt32BE = function(Ir, pr) {
      return Ir = Ir >>> 0, pr || ir(Ir, 4, this.length), this[Ir] << 24 | this[Ir + 1] << 16 | this[Ir + 2] << 8 | this[Ir + 3];
    }, B.prototype.readBigInt64LE = ti(function(Ir) {
      Ir = Ir >>> 0, Gr(Ir, "offset");
      const pr = this[Ir], Cr = this[Ir + 7];
      (pr === void 0 || Cr === void 0) && Fr(Ir, this.length - 8);
      const Er = this[Ir + 4] + this[Ir + 5] * 2 ** 8 + this[Ir + 6] * 2 ** 16 + (Cr << 24);
      return (BigInt(Er) << BigInt(32)) + BigInt(pr + this[++Ir] * 2 ** 8 + this[++Ir] * 2 ** 16 + this[++Ir] * 2 ** 24);
    }), B.prototype.readBigInt64BE = ti(function(Ir) {
      Ir = Ir >>> 0, Gr(Ir, "offset");
      const pr = this[Ir], Cr = this[Ir + 7];
      (pr === void 0 || Cr === void 0) && Fr(Ir, this.length - 8);
      const Er = (pr << 24) + // Overflow
      this[++Ir] * 2 ** 16 + this[++Ir] * 2 ** 8 + this[++Ir];
      return (BigInt(Er) << BigInt(32)) + BigInt(this[++Ir] * 2 ** 24 + this[++Ir] * 2 ** 16 + this[++Ir] * 2 ** 8 + Cr);
    }), B.prototype.readFloatLE = function(Ir, pr) {
      return Ir = Ir >>> 0, pr || ir(Ir, 4, this.length), c.read(this, Ir, !0, 23, 4);
    }, B.prototype.readFloatBE = function(Ir, pr) {
      return Ir = Ir >>> 0, pr || ir(Ir, 4, this.length), c.read(this, Ir, !1, 23, 4);
    }, B.prototype.readDoubleLE = function(Ir, pr) {
      return Ir = Ir >>> 0, pr || ir(Ir, 8, this.length), c.read(this, Ir, !0, 52, 8);
    }, B.prototype.readDoubleBE = function(Ir, pr) {
      return Ir = Ir >>> 0, pr || ir(Ir, 8, this.length), c.read(this, Ir, !1, 52, 8);
    };
    function sr(Rr, Ir, pr, Cr, Er, xr) {
      if (!B.isBuffer(Rr)) throw new TypeError('"buffer" argument must be a Buffer instance');
      if (Ir > Er || Ir < xr) throw new RangeError('"value" argument is out of bounds');
      if (pr + Cr > Rr.length) throw new RangeError("Index out of range");
    }
    B.prototype.writeUintLE = B.prototype.writeUIntLE = function(Ir, pr, Cr, Er) {
      if (Ir = +Ir, pr = pr >>> 0, Cr = Cr >>> 0, !Er) {
        const Ci = Math.pow(2, 8 * Cr) - 1;
        sr(this, Ir, pr, Cr, Ci, 0);
      }
      let xr = 1, si = 0;
      for (this[pr] = Ir & 255; ++si < Cr && (xr *= 256); )
        this[pr + si] = Ir / xr & 255;
      return pr + Cr;
    }, B.prototype.writeUintBE = B.prototype.writeUIntBE = function(Ir, pr, Cr, Er) {
      if (Ir = +Ir, pr = pr >>> 0, Cr = Cr >>> 0, !Er) {
        const Ci = Math.pow(2, 8 * Cr) - 1;
        sr(this, Ir, pr, Cr, Ci, 0);
      }
      let xr = Cr - 1, si = 1;
      for (this[pr + xr] = Ir & 255; --xr >= 0 && (si *= 256); )
        this[pr + xr] = Ir / si & 255;
      return pr + Cr;
    }, B.prototype.writeUint8 = B.prototype.writeUInt8 = function(Ir, pr, Cr) {
      return Ir = +Ir, pr = pr >>> 0, Cr || sr(this, Ir, pr, 1, 255, 0), this[pr] = Ir & 255, pr + 1;
    }, B.prototype.writeUint16LE = B.prototype.writeUInt16LE = function(Ir, pr, Cr) {
      return Ir = +Ir, pr = pr >>> 0, Cr || sr(this, Ir, pr, 2, 65535, 0), this[pr] = Ir & 255, this[pr + 1] = Ir >>> 8, pr + 2;
    }, B.prototype.writeUint16BE = B.prototype.writeUInt16BE = function(Ir, pr, Cr) {
      return Ir = +Ir, pr = pr >>> 0, Cr || sr(this, Ir, pr, 2, 65535, 0), this[pr] = Ir >>> 8, this[pr + 1] = Ir & 255, pr + 2;
    }, B.prototype.writeUint32LE = B.prototype.writeUInt32LE = function(Ir, pr, Cr) {
      return Ir = +Ir, pr = pr >>> 0, Cr || sr(this, Ir, pr, 4, 4294967295, 0), this[pr + 3] = Ir >>> 24, this[pr + 2] = Ir >>> 16, this[pr + 1] = Ir >>> 8, this[pr] = Ir & 255, pr + 4;
    }, B.prototype.writeUint32BE = B.prototype.writeUInt32BE = function(Ir, pr, Cr) {
      return Ir = +Ir, pr = pr >>> 0, Cr || sr(this, Ir, pr, 4, 4294967295, 0), this[pr] = Ir >>> 24, this[pr + 1] = Ir >>> 16, this[pr + 2] = Ir >>> 8, this[pr + 3] = Ir & 255, pr + 4;
    };
    function yr(Rr, Ir, pr, Cr, Er) {
      Sr(Ir, Cr, Er, Rr, pr, 7);
      let xr = Number(Ir & BigInt(4294967295));
      Rr[pr++] = xr, xr = xr >> 8, Rr[pr++] = xr, xr = xr >> 8, Rr[pr++] = xr, xr = xr >> 8, Rr[pr++] = xr;
      let si = Number(Ir >> BigInt(32) & BigInt(4294967295));
      return Rr[pr++] = si, si = si >> 8, Rr[pr++] = si, si = si >> 8, Rr[pr++] = si, si = si >> 8, Rr[pr++] = si, pr;
    }
    function wr(Rr, Ir, pr, Cr, Er) {
      Sr(Ir, Cr, Er, Rr, pr, 7);
      let xr = Number(Ir & BigInt(4294967295));
      Rr[pr + 7] = xr, xr = xr >> 8, Rr[pr + 6] = xr, xr = xr >> 8, Rr[pr + 5] = xr, xr = xr >> 8, Rr[pr + 4] = xr;
      let si = Number(Ir >> BigInt(32) & BigInt(4294967295));
      return Rr[pr + 3] = si, si = si >> 8, Rr[pr + 2] = si, si = si >> 8, Rr[pr + 1] = si, si = si >> 8, Rr[pr] = si, pr + 8;
    }
    B.prototype.writeBigUInt64LE = ti(function(Ir, pr = 0) {
      return yr(this, Ir, pr, BigInt(0), BigInt("0xffffffffffffffff"));
    }), B.prototype.writeBigUInt64BE = ti(function(Ir, pr = 0) {
      return wr(this, Ir, pr, BigInt(0), BigInt("0xffffffffffffffff"));
    }), B.prototype.writeIntLE = function(Ir, pr, Cr, Er) {
      if (Ir = +Ir, pr = pr >>> 0, !Er) {
        const bi = Math.pow(2, 8 * Cr - 1);
        sr(this, Ir, pr, Cr, bi - 1, -bi);
      }
      let xr = 0, si = 1, Ci = 0;
      for (this[pr] = Ir & 255; ++xr < Cr && (si *= 256); )
        Ir < 0 && Ci === 0 && this[pr + xr - 1] !== 0 && (Ci = 1), this[pr + xr] = (Ir / si >> 0) - Ci & 255;
      return pr + Cr;
    }, B.prototype.writeIntBE = function(Ir, pr, Cr, Er) {
      if (Ir = +Ir, pr = pr >>> 0, !Er) {
        const bi = Math.pow(2, 8 * Cr - 1);
        sr(this, Ir, pr, Cr, bi - 1, -bi);
      }
      let xr = Cr - 1, si = 1, Ci = 0;
      for (this[pr + xr] = Ir & 255; --xr >= 0 && (si *= 256); )
        Ir < 0 && Ci === 0 && this[pr + xr + 1] !== 0 && (Ci = 1), this[pr + xr] = (Ir / si >> 0) - Ci & 255;
      return pr + Cr;
    }, B.prototype.writeInt8 = function(Ir, pr, Cr) {
      return Ir = +Ir, pr = pr >>> 0, Cr || sr(this, Ir, pr, 1, 127, -128), Ir < 0 && (Ir = 255 + Ir + 1), this[pr] = Ir & 255, pr + 1;
    }, B.prototype.writeInt16LE = function(Ir, pr, Cr) {
      return Ir = +Ir, pr = pr >>> 0, Cr || sr(this, Ir, pr, 2, 32767, -32768), this[pr] = Ir & 255, this[pr + 1] = Ir >>> 8, pr + 2;
    }, B.prototype.writeInt16BE = function(Ir, pr, Cr) {
      return Ir = +Ir, pr = pr >>> 0, Cr || sr(this, Ir, pr, 2, 32767, -32768), this[pr] = Ir >>> 8, this[pr + 1] = Ir & 255, pr + 2;
    }, B.prototype.writeInt32LE = function(Ir, pr, Cr) {
      return Ir = +Ir, pr = pr >>> 0, Cr || sr(this, Ir, pr, 4, 2147483647, -2147483648), this[pr] = Ir & 255, this[pr + 1] = Ir >>> 8, this[pr + 2] = Ir >>> 16, this[pr + 3] = Ir >>> 24, pr + 4;
    }, B.prototype.writeInt32BE = function(Ir, pr, Cr) {
      return Ir = +Ir, pr = pr >>> 0, Cr || sr(this, Ir, pr, 4, 2147483647, -2147483648), Ir < 0 && (Ir = 4294967295 + Ir + 1), this[pr] = Ir >>> 24, this[pr + 1] = Ir >>> 16, this[pr + 2] = Ir >>> 8, this[pr + 3] = Ir & 255, pr + 4;
    }, B.prototype.writeBigInt64LE = ti(function(Ir, pr = 0) {
      return yr(this, Ir, pr, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
    }), B.prototype.writeBigInt64BE = ti(function(Ir, pr = 0) {
      return wr(this, Ir, pr, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
    });
    function qr(Rr, Ir, pr, Cr, Er, xr) {
      if (pr + Cr > Rr.length) throw new RangeError("Index out of range");
      if (pr < 0) throw new RangeError("Index out of range");
    }
    function Mr(Rr, Ir, pr, Cr, Er) {
      return Ir = +Ir, pr = pr >>> 0, Er || qr(Rr, Ir, pr, 4), c.write(Rr, Ir, pr, Cr, 23, 4), pr + 4;
    }
    B.prototype.writeFloatLE = function(Ir, pr, Cr) {
      return Mr(this, Ir, pr, !0, Cr);
    }, B.prototype.writeFloatBE = function(Ir, pr, Cr) {
      return Mr(this, Ir, pr, !1, Cr);
    };
    function Dr(Rr, Ir, pr, Cr, Er) {
      return Ir = +Ir, pr = pr >>> 0, Er || qr(Rr, Ir, pr, 8), c.write(Rr, Ir, pr, Cr, 52, 8), pr + 8;
    }
    B.prototype.writeDoubleLE = function(Ir, pr, Cr) {
      return Dr(this, Ir, pr, !0, Cr);
    }, B.prototype.writeDoubleBE = function(Ir, pr, Cr) {
      return Dr(this, Ir, pr, !1, Cr);
    }, B.prototype.copy = function(Ir, pr, Cr, Er) {
      if (!B.isBuffer(Ir)) throw new TypeError("argument should be a Buffer");
      if (Cr || (Cr = 0), !Er && Er !== 0 && (Er = this.length), pr >= Ir.length && (pr = Ir.length), pr || (pr = 0), Er > 0 && Er < Cr && (Er = Cr), Er === Cr || Ir.length === 0 || this.length === 0) return 0;
      if (pr < 0)
        throw new RangeError("targetStart out of bounds");
      if (Cr < 0 || Cr >= this.length) throw new RangeError("Index out of range");
      if (Er < 0) throw new RangeError("sourceEnd out of bounds");
      Er > this.length && (Er = this.length), Ir.length - pr < Er - Cr && (Er = Ir.length - pr + Cr);
      const xr = Er - Cr;
      return this === Ir && typeof Uint8Array.prototype.copyWithin == "function" ? this.copyWithin(pr, Cr, Er) : Uint8Array.prototype.set.call(
        Ir,
        this.subarray(Cr, Er),
        pr
      ), xr;
    }, B.prototype.fill = function(Ir, pr, Cr, Er) {
      if (typeof Ir == "string") {
        if (typeof pr == "string" ? (Er = pr, pr = 0, Cr = this.length) : typeof Cr == "string" && (Er = Cr, Cr = this.length), Er !== void 0 && typeof Er != "string")
          throw new TypeError("encoding must be a string");
        if (typeof Er == "string" && !B.isEncoding(Er))
          throw new TypeError("Unknown encoding: " + Er);
        if (Ir.length === 1) {
          const si = Ir.charCodeAt(0);
          (Er === "utf8" && si < 128 || Er === "latin1") && (Ir = si);
        }
      } else typeof Ir == "number" ? Ir = Ir & 255 : typeof Ir == "boolean" && (Ir = Number(Ir));
      if (pr < 0 || this.length < pr || this.length < Cr)
        throw new RangeError("Out of range index");
      if (Cr <= pr)
        return this;
      pr = pr >>> 0, Cr = Cr === void 0 ? this.length : Cr >>> 0, Ir || (Ir = 0);
      let xr;
      if (typeof Ir == "number")
        for (xr = pr; xr < Cr; ++xr)
          this[xr] = Ir;
      else {
        const si = B.isBuffer(Ir) ? Ir : B.from(Ir, Er), Ci = si.length;
        if (Ci === 0)
          throw new TypeError('The value "' + Ir + '" is invalid for argument "value"');
        for (xr = 0; xr < Cr - pr; ++xr)
          this[xr + pr] = si[xr % Ci];
      }
      return this;
    };
    const Qr = {};
    function Xr(Rr, Ir, pr) {
      Qr[Rr] = class extends pr {
        constructor() {
          super(), Object.defineProperty(this, "message", {
            value: Ir.apply(this, arguments),
            writable: !0,
            configurable: !0
          }), this.name = `${this.name} [${Rr}]`, this.stack, delete this.name;
        }
        get code() {
          return Rr;
        }
        set code(Er) {
          Object.defineProperty(this, "code", {
            configurable: !0,
            enumerable: !0,
            value: Er,
            writable: !0
          });
        }
        toString() {
          return `${this.name} [${Rr}]: ${this.message}`;
        }
      };
    }
    Xr(
      "ERR_BUFFER_OUT_OF_BOUNDS",
      function(Rr) {
        return Rr ? `${Rr} is outside of buffer bounds` : "Attempt to access memory outside buffer bounds";
      },
      RangeError
    ), Xr(
      "ERR_INVALID_ARG_TYPE",
      function(Rr, Ir) {
        return `The "${Rr}" argument must be of type number. Received type ${typeof Ir}`;
      },
      TypeError
    ), Xr(
      "ERR_OUT_OF_RANGE",
      function(Rr, Ir, pr) {
        let Cr = `The value of "${Rr}" is out of range.`, Er = pr;
        return Number.isInteger(pr) && Math.abs(pr) > 2 ** 32 ? Er = Vr(String(pr)) : typeof pr == "bigint" && (Er = String(pr), (pr > BigInt(2) ** BigInt(32) || pr < -(BigInt(2) ** BigInt(32))) && (Er = Vr(Er)), Er += "n"), Cr += ` It must be ${Ir}. Received ${Er}`, Cr;
      },
      RangeError
    );
    function Vr(Rr) {
      let Ir = "", pr = Rr.length;
      const Cr = Rr[0] === "-" ? 1 : 0;
      for (; pr >= Cr + 4; pr -= 3)
        Ir = `_${Rr.slice(pr - 3, pr)}${Ir}`;
      return `${Rr.slice(0, pr)}${Ir}`;
    }
    function Ur(Rr, Ir, pr) {
      Gr(Ir, "offset"), (Rr[Ir] === void 0 || Rr[Ir + pr] === void 0) && Fr(Ir, Rr.length - (pr + 1));
    }
    function Sr(Rr, Ir, pr, Cr, Er, xr) {
      if (Rr > pr || Rr < Ir) {
        const si = typeof Ir == "bigint" ? "n" : "";
        let Ci;
        throw Ir === 0 || Ir === BigInt(0) ? Ci = `>= 0${si} and < 2${si} ** ${(xr + 1) * 8}${si}` : Ci = `>= -(2${si} ** ${(xr + 1) * 8 - 1}${si}) and < 2 ** ${(xr + 1) * 8 - 1}${si}`, new Qr.ERR_OUT_OF_RANGE("value", Ci, Rr);
      }
      Ur(Cr, Er, xr);
    }
    function Gr(Rr, Ir) {
      if (typeof Rr != "number")
        throw new Qr.ERR_INVALID_ARG_TYPE(Ir, "number", Rr);
    }
    function Fr(Rr, Ir, pr) {
      throw Math.floor(Rr) !== Rr ? (Gr(Rr, pr), new Qr.ERR_OUT_OF_RANGE("offset", "an integer", Rr)) : Ir < 0 ? new Qr.ERR_BUFFER_OUT_OF_BOUNDS() : new Qr.ERR_OUT_OF_RANGE(
        "offset",
        `>= 0 and <= ${Ir}`,
        Rr
      );
    }
    const br = /[^+/0-9A-Za-z-_]/g;
    function Ar(Rr) {
      if (Rr = Rr.split("=")[0], Rr = Rr.trim().replace(br, ""), Rr.length < 2) return "";
      for (; Rr.length % 4 !== 0; )
        Rr = Rr + "=";
      return Rr;
    }
    function cr(Rr, Ir) {
      Ir = Ir || 1 / 0;
      let pr;
      const Cr = Rr.length;
      let Er = null;
      const xr = [];
      for (let si = 0; si < Cr; ++si) {
        if (pr = Rr.charCodeAt(si), pr > 55295 && pr < 57344) {
          if (!Er) {
            if (pr > 56319) {
              (Ir -= 3) > -1 && xr.push(239, 191, 189);
              continue;
            } else if (si + 1 === Cr) {
              (Ir -= 3) > -1 && xr.push(239, 191, 189);
              continue;
            }
            Er = pr;
            continue;
          }
          if (pr < 56320) {
            (Ir -= 3) > -1 && xr.push(239, 191, 189), Er = pr;
            continue;
          }
          pr = (Er - 55296 << 10 | pr - 56320) + 65536;
        } else Er && (Ir -= 3) > -1 && xr.push(239, 191, 189);
        if (Er = null, pr < 128) {
          if ((Ir -= 1) < 0) break;
          xr.push(pr);
        } else if (pr < 2048) {
          if ((Ir -= 2) < 0) break;
          xr.push(
            pr >> 6 | 192,
            pr & 63 | 128
          );
        } else if (pr < 65536) {
          if ((Ir -= 3) < 0) break;
          xr.push(
            pr >> 12 | 224,
            pr >> 6 & 63 | 128,
            pr & 63 | 128
          );
        } else if (pr < 1114112) {
          if ((Ir -= 4) < 0) break;
          xr.push(
            pr >> 18 | 240,
            pr >> 12 & 63 | 128,
            pr >> 6 & 63 | 128,
            pr & 63 | 128
          );
        } else
          throw new Error("Invalid code point");
      }
      return xr;
    }
    function hr(Rr) {
      const Ir = [];
      for (let pr = 0; pr < Rr.length; ++pr)
        Ir.push(Rr.charCodeAt(pr) & 255);
      return Ir;
    }
    function Wr(Rr, Ir) {
      let pr, Cr, Er;
      const xr = [];
      for (let si = 0; si < Rr.length && !((Ir -= 2) < 0); ++si)
        pr = Rr.charCodeAt(si), Cr = pr >> 8, Er = pr % 256, xr.push(Er), xr.push(Cr);
      return xr;
    }
    function fi(Rr) {
      return g.toByteArray(Ar(Rr));
    }
    function Bi(Rr, Ir, pr, Cr) {
      let Er;
      for (Er = 0; Er < Cr && !(Er + pr >= Ir.length || Er >= Rr.length); ++Er)
        Ir[Er + pr] = Rr[Er];
      return Er;
    }
    function $r(Rr, Ir) {
      return Rr instanceof Ir || Rr != null && Rr.constructor != null && Rr.constructor.name != null && Rr.constructor.name === Ir.name;
    }
    function oi(Rr) {
      return Rr !== Rr;
    }
    const zr = function() {
      const Rr = "0123456789abcdef", Ir = new Array(256);
      for (let pr = 0; pr < 16; ++pr) {
        const Cr = pr * 16;
        for (let Er = 0; Er < 16; ++Er)
          Ir[Cr + Er] = Rr[pr] + Rr[Er];
      }
      return Ir;
    }();
    function ti(Rr) {
      return typeof BigInt > "u" ? Lr : Rr;
    }
    function Lr() {
      throw new Error("BigInt not supported");
    }
  }(buffer$2)), buffer$2;
}
var coin$1 = {}, hasRequiredCoin$1;
function requireCoin$1() {
  if (hasRequiredCoin$1) return coin$1;
  hasRequiredCoin$1 = 1, Object.defineProperty(coin$1, "__esModule", { value: !0 }), coin$1.getCoinSymbol = o;
  function o(g) {
    var c;
    return (c = {
      0: "BTC",
      2: "LTC",
      3: "DOGE",
      4: "RDD",
      5: "DASH",
      6: "PPC",
      7: "NMC",
      8: "FTC",
      9: "XCP",
      10: "BLK",
      11: "NSR",
      12: "NBT",
      13: "MZC",
      14: "VIA",
      15: "XCH",
      16: "RBY",
      17: "GRS",
      18: "DGC",
      19: "CCN",
      20: "DGB",
      22: "MONA",
      23: "CLAM",
      24: "XPM",
      25: "NEOS",
      26: "JBS",
      27: "ZRC",
      28: "VTC",
      29: "NXT",
      30: "BURST",
      31: "MUE",
      32: "ZOOM",
      33: "VASH",
      34: "CDN",
      35: "SDC",
      36: "PKB",
      37: "PND",
      38: "START",
      39: "MOIN",
      40: "EXP",
      41: "EMC2",
      42: "DCR",
      43: "XEM",
      44: "PART",
      45: "ARG",
      48: "SHR",
      49: "GCR",
      50: "NVC",
      51: "AC",
      52: "BTCD",
      53: "DOPE",
      54: "TPC",
      55: "AIB",
      56: "EDRC",
      57: "SYS",
      58: "SLR",
      59: "SMLY",
      60: "ETH",
      61: "ETC",
      62: "PSB",
      63: "LDCN",
      65: "XBC",
      66: "IOP",
      67: "NXS",
      68: "INSN",
      69: "OK",
      70: "BRIT",
      71: "CMP",
      72: "CRW",
      73: "BELA",
      74: "ICX",
      75: "FJC",
      76: "MIX",
      77: "XVG",
      78: "EFL",
      79: "CLUB",
      80: "RICHX",
      81: "POT",
      82: "QRK",
      83: "TRC",
      84: "GRC",
      85: "AUR",
      86: "IXC",
      87: "NLG",
      88: "BITB",
      89: "BTA",
      90: "XMY",
      91: "BSD",
      92: "UNO",
      93: "MTR",
      94: "GB",
      95: "SHM",
      96: "CRX",
      97: "BIQ",
      98: "EVO",
      99: "STO",
      100: "BIGUP",
      101: "GAME",
      102: "DLC",
      103: "ZYD",
      104: "DBIC",
      105: "STRAT",
      106: "SH",
      107: "MARS",
      108: "UBQ",
      109: "PTC",
      110: "NRO",
      111: "ARK",
      112: "USC",
      113: "THC",
      114: "LINX",
      115: "ECN",
      116: "DNR",
      117: "PINK",
      118: "ATOM",
      119: "PIVX",
      120: "FLASH",
      121: "ZEN",
      122: "PUT",
      123: "ZNY",
      124: "UNIFY",
      125: "XST",
      126: "BRK",
      127: "VC",
      128: "XMR",
      129: "VOX",
      130: "NAV",
      131: "FCT",
      132: "EC",
      133: "ZEC",
      134: "LSK",
      135: "STEEM",
      136: "XZC",
      137: "RBTC",
      139: "RPT",
      140: "LBC",
      141: "KMD",
      142: "BSQ",
      143: "RIC",
      144: "XRP",
      145: "BCH",
      146: "NEBL",
      147: "ZCL",
      148: "XLM",
      149: "NLC2",
      150: "WHL",
      151: "ERC",
      152: "DMD",
      153: "BTM",
      154: "BIO",
      155: "XWCC",
      156: "BTG",
      157: "BTC2X",
      158: "SSN",
      159: "TOA",
      160: "BTX",
      161: "ACC",
      162: "BCO",
      163: "ELLA",
      164: "PIRL",
      165: "XNO",
      166: "VIVO",
      167: "FRST",
      168: "HNC",
      169: "BUZZ",
      170: "MBRS",
      171: "HC",
      172: "HTML",
      173: "ODN",
      174: "ONX",
      175: "RVN",
      176: "GBX",
      177: "BTCZ",
      178: "POA",
      179: "NYC",
      180: "MXT",
      181: "WC",
      182: "MNX",
      183: "BTCP",
      184: "MUSIC",
      185: "BCA",
      186: "CRAVE",
      187: "STAK",
      188: "WBTC",
      189: "LCH",
      190: "EXCL",
      192: "LCC",
      193: "XFE",
      194: "EOS",
      195: "TRX",
      196: "KOBO",
      197: "HUSH",
      198: "BAN",
      199: "ETF",
      200: "OMNI",
      201: "BIFI",
      202: "UFO",
      203: "CNMC",
      204: "BCN",
      205: "RIN",
      206: "ATP",
      207: "EVT",
      208: "ATN",
      209: "BIS",
      210: "NEET",
      211: "BOPO",
      212: "OOT",
      213: "ALIAS",
      214: "MONK",
      215: "BOXY",
      216: "FLO",
      217: "MEC",
      218: "BTDX",
      219: "XAX",
      220: "ANON",
      221: "LTZ",
      222: "BITG",
      223: "ICP",
      224: "SMART",
      225: "XUEZ",
      226: "HLM",
      227: "WEB",
      228: "ACM",
      229: "NOS",
      230: "BITC",
      231: "HTH",
      232: "TZC",
      233: "VAR",
      234: "IOV",
      235: "FIO",
      236: "BSV",
      237: "DXN",
      238: "QRL",
      239: "PCX",
      240: "LOKI",
      242: "NIM",
      243: "SOV",
      244: "JCT",
      245: "SLP",
      246: "EWT",
      247: "UC",
      248: "EXOS",
      249: "ECA",
      250: "SOOM",
      251: "XRD",
      252: "FREE",
      253: "NPW",
      254: "BST",
      256: "NANO",
      257: "BTCC",
      259: "ZEST",
      260: "ABT",
      261: "PION",
      262: "DT3",
      263: "ZBUX",
      264: "KPL",
      265: "TPAY",
      266: "ZILLA",
      267: "ANK",
      268: "BCC",
      269: "HPB",
      270: "ONE",
      271: "SBC",
      272: "IPC",
      273: "DMTC",
      274: "OGC",
      275: "SHIT",
      276: "ANDES",
      277: "AREPA",
      278: "BOLI",
      279: "RIL",
      280: "HTR",
      281: "FCTID",
      282: "BRAVO",
      283: "ALGO",
      284: "BZX",
      285: "GXX",
      286: "HEAT",
      287: "XDN",
      288: "FSN",
      289: "CPC",
      290: "BOLD",
      291: "IOST",
      292: "TKEY",
      293: "USE",
      294: "BCZ",
      295: "IOC",
      296: "ASF",
      297: "MASS",
      298: "FAIR",
      299: "NUKO",
      300: "GNX",
      301: "DIVI",
      302: "CMT",
      303: "EUNO",
      304: "IOTX",
      305: "ONION",
      306: "8BIT",
      307: "ATC",
      308: "BTS",
      309: "CKB",
      310: "UGAS",
      311: "ADS",
      312: "ARA",
      313: "ZIL",
      314: "MOAC",
      315: "SWTC",
      316: "VNSC",
      317: "PLUG",
      318: "MAN",
      319: "ECC",
      320: "RPD",
      321: "RAP",
      322: "GARD",
      323: "ZER",
      324: "EBST",
      325: "SHARD",
      326: "MRX",
      327: "CMM",
      328: "BLOCK",
      329: "AUDAX",
      330: "LUNA",
      331: "ZPM",
      332: "KUVA",
      333: "MEM",
      334: "CS",
      335: "SWIFT",
      336: "FIX",
      337: "CPC",
      338: "VGO",
      339: "DVT",
      340: "N8V",
      341: "MTNS",
      342: "BLAST",
      343: "DCT",
      344: "AUX",
      345: "USDP",
      346: "HTDF",
      347: "YEC",
      348: "QLC",
      349: "TEA",
      350: "ARW",
      351: "MDM",
      352: "CYB",
      353: "LTO",
      354: "DOT",
      355: "AEON",
      356: "RES",
      357: "AYA",
      358: "DAPS",
      359: "CSC",
      360: "VSYS",
      361: "NOLLAR",
      362: "XNOS",
      363: "CPU",
      364: "LAMB",
      365: "VCT",
      366: "CZR",
      367: "ABBC",
      368: "HET",
      369: "XAS",
      370: "VDL",
      371: "MED",
      372: "ZVC",
      373: "VESTX",
      374: "DBT",
      375: "SEOS",
      376: "MXW",
      377: "ZNZ",
      378: "XCX",
      379: "SOX",
      380: "NYZO",
      381: "ULC",
      382: "RYO",
      383: "KAL",
      384: "XSN",
      385: "DOGEC",
      386: "BMV",
      387: "QBC",
      388: "IMG",
      389: "QOS",
      390: "PKT",
      391: "LHD",
      392: "CENNZ",
      393: "HSN",
      394: "CRO",
      395: "UMBRU",
      396: "EVER",
      397: "NEAR",
      398: "XPC",
      399: "ZOC",
      400: "NIX",
      401: "UC",
      402: "GALI",
      403: "OLT",
      404: "XBI",
      405: "DONU",
      406: "EARTHS",
      407: "HDD",
      408: "SUGAR",
      409: "AILE",
      410: "TENT",
      411: "TAN",
      412: "AIN",
      413: "MSR",
      414: "SUMO",
      415: "ETN",
      416: "BYTZ",
      417: "WOW",
      418: "XTNC",
      419: "LTHN",
      420: "NODE",
      421: "AGM",
      422: "CCX",
      423: "TNET",
      424: "TELOS",
      425: "AION",
      426: "BC",
      427: "KTV",
      428: "ZCR",
      429: "ERG",
      430: "PESO",
      431: "BTC2",
      432: "XRPHD",
      433: "WE",
      434: "KSM",
      435: "PCN",
      436: "NCH",
      437: "ICU",
      438: "LN",
      439: "DTP",
      440: "BTCR",
      441: "AERGO",
      442: "XTH",
      443: "LV",
      444: "PHR",
      445: "VITAE",
      446: "COCOS",
      447: "DIN",
      448: "SPL",
      449: "YCE",
      450: "XLR",
      451: "KTS",
      452: "DGLD",
      453: "XNS",
      454: "EM",
      455: "SHN",
      456: "SEELE",
      457: "AE",
      458: "ODX",
      459: "KAVA",
      460: "GLEEC",
      461: "FIL",
      462: "RUTA",
      463: "CSDT",
      464: "ETI",
      465: "ZSLP",
      466: "ERE",
      467: "DX",
      468: "CPS",
      469: "BTH",
      470: "MESG",
      471: "FIMK",
      472: "AR",
      473: "OGO",
      474: "ROSE",
      475: "BARE",
      476: "GLEEC",
      477: "CLR",
      478: "RNG",
      479: "OLO",
      480: "PEXA",
      481: "MOON",
      482: "OCEAN",
      483: "BNT",
      484: "AMO",
      485: "FCH",
      486: "LAT",
      487: "COIN",
      488: "VEO",
      489: "CCA",
      490: "GFN",
      491: "BIP",
      492: "KPG",
      493: "FIN",
      494: "BAND",
      495: "DROP",
      496: "BHT",
      497: "LYRA",
      498: "CS",
      499: "RUPX",
      500: "THETA",
      501: "SOL",
      502: "THT",
      503: "CFX",
      504: "KUMA",
      505: "HASH",
      506: "CSPR",
      507: "EARTH",
      508: "EGLD",
      509: "CHI",
      510: "KOTO",
      511: "OTC",
      512: "XRD",
      513: "SEELEN",
      514: "AETH",
      515: "DNA",
      516: "VEE",
      517: "SIERRA",
      518: "LET",
      519: "BSC",
      520: "BTCV",
      521: "ABA",
      522: "SCC",
      523: "EDG",
      524: "AMS",
      525: "GOSS",
      526: "BU",
      527: "GRAM",
      528: "YAP",
      529: "SCRT",
      530: "NOVO",
      531: "GHOST",
      532: "HST",
      533: "PRJ",
      534: "YOU",
      535: "XHV",
      536: "BYND",
      537: "JOYS",
      538: "VAL",
      539: "FLOW",
      540: "SMESH",
      541: "SCDO",
      542: "IQS",
      543: "BIND",
      544: "COINEVO",
      545: "SCRIBE",
      546: "HYN",
      547: "BHP",
      548: "BBC",
      549: "MKF",
      550: "XDC",
      551: "STR",
      552: "SUM",
      553: "HBC",
      555: "BCS",
      556: "KTS",
      557: "LKR",
      558: "TAO",
      559: "XWC",
      560: "DEAL",
      561: "NTY",
      562: "TOP",
      564: "AG",
      565: "CICO",
      566: "IRIS",
      567: "NCG",
      568: "LRG",
      569: "SERO",
      570: "BDX",
      571: "CCXX",
      572: "SLS",
      573: "SRM",
      575: "VIVT",
      576: "BPS",
      577: "NKN",
      578: "ICL",
      579: "BONO",
      580: "PLC",
      581: "DUN",
      582: "DMCH",
      583: "CTC",
      584: "KELP",
      585: "GBCR",
      586: "XDAG",
      587: "PRV",
      588: "SCAP",
      589: "TFUEL",
      590: "GTM",
      591: "RNL",
      592: "GRIN",
      593: "MWC",
      594: "DOCK",
      595: "POLYX",
      596: "DIVER",
      597: "XEP",
      598: "APN",
      599: "TFC",
      600: "UTE",
      601: "MTC",
      602: "NC",
      603: "XINY",
      604: "DYN",
      605: "BUFS",
      606: "STOS",
      607: "TON",
      608: "TAFT",
      609: "HYDRA",
      610: "NOR",
      613: "WCN",
      614: "OPT",
      615: "PSWAP",
      616: "VAL",
      617: "XOR",
      618: "SSP",
      619: "DEI",
      621: "ZERO",
      622: "ALPHA",
      623: "BDECO",
      624: "NOBL",
      625: "EAST",
      626: "KDA",
      627: "SOUL",
      628: "LORE",
      629: "FNR",
      630: "NEXUS",
      631: "QTZ",
      632: "XMA",
      633: "CALL",
      634: "VAL",
      635: "POKT",
      636: "EMIT",
      637: "APTOS",
      638: "ADON",
      639: "BTSG",
      640: "LFC",
      641: "KCS",
      642: "KCC",
      643: "AZERO",
      644: "TREE",
      645: "LX",
      646: "XLN",
      647: "CIC",
      648: "ZRB",
      650: "UCO",
      651: "SFX",
      652: "SFT",
      653: "WSFX",
      654: "USDG",
      655: "WMP",
      659: "KOIN",
      660: "PIRATE",
      663: "SFRX",
      666: "ACT",
      667: "PRKL",
      668: "SSC",
      669: "GC",
      670: "PLGR",
      671: "MPLGR",
      672: "KNOX",
      673: "ZED",
      674: "CNDL",
      675: "WLKR",
      676: "WLKRR",
      677: "YUNGE",
      678: "Voken",
      679: "APL",
      680: "Evrynet",
      681: "NENG",
      682: "CHTA",
      685: "OAS",
      686: "KAR",
      688: "CET",
      690: "KLV",
      694: "VTBC",
      698: "VEIL",
      699: "GTB",
      700: "XDAI",
      701: "COM",
      702: "CCC",
      707: "MCOIN",
      711: "CHC",
      712: "SERF",
      713: "XTL",
      714: "BNB",
      715: "SIN",
      716: "DLN",
      717: "BONTE",
      718: "PEER",
      725: "MCX",
      730: "HEALIOS",
      731: "BMK",
      734: "DENTX",
      737: "ATOP",
      747: "CFG",
      750: "XPRT",
      757: "HONEY",
      768: "BALLZ",
      770: "COSA",
      771: "BR",
      775: "PLSR",
      776: "KEY",
      777: "BTW",
      780: "PLCUC",
      781: "PLCUX",
      782: "PLCU",
      784: "SUI",
      786: "UIDD",
      787: "ACA",
      788: "BNC",
      789: "TAU",
      799: "PDEX",
      800: "BEET",
      801: "DST",
      804: "ZKS",
      808: "QVT",
      809: "SDN",
      810: "ASTR",
      813: "MEER",
      818: "VET",
      819: "REEF",
      820: "CLO",
      822: "BDB",
      827: "ACE",
      828: "CCN",
      831: "CRUZ",
      832: "SAPP",
      833: "777",
      834: "KYAN",
      835: "AZR",
      836: "CFL",
      837: "DASHD",
      838: "TRTT",
      839: "UCR",
      840: "PNY",
      841: "BECN",
      842: "MONK",
      843: "SAGA",
      844: "SUV",
      845: "ESK",
      846: "OWO",
      847: "PEPS",
      848: "BIR",
      849: "MOBIC",
      850: "FLS",
      852: "DSM",
      853: "PRCY",
      858: "HVH",
      866: "MOB",
      868: "IF",
      877: "NAM",
      880: "LUM",
      883: "ZBC",
      886: "ADF",
      888: "NEO",
      889: "TOMO",
      890: "XSEL",
      896: "LKSC",
      898: "AS",
      899: "XEC",
      900: "LMO",
      901: "NXT",
      904: "HNT",
      907: "FIS",
      909: "SGE",
      911: "GERT",
      916: "META",
      917: "FRA",
      919: "CCD",
      921: "AVN",
      925: "DIP",
      928: "GHM",
      931: "RUNE",
      945: "UNLOCK",
      955: "LTP",
      960: "VKAX",
      966: "MATIC",
      968: "UNW",
      970: "TWINS",
      977: "TLOS",
      981: "TAFECO",
      985: "AU",
      987: "VCG",
      988: "XAZAB",
      989: "AIOZ",
      990: "CORE",
      991: "PEC",
      992: "UNT",
      993: "XRB",
      994: "QUAI",
      995: "CAPS",
      996: "OKT",
      997: "SUM",
      998: "LBTC",
      999: "BCD",
      1e3: "BTN",
      1001: "TT",
      1002: "BKT",
      1003: "NODL",
      1004: "PCOIN",
      1005: "TAO",
      1006: "HSK",
      1007: "FTM",
      1008: "RPG",
      1010: "HT",
      1011: "ELV",
      1013: "BIC",
      1020: "EVC",
      1022: "XRD",
      1023: "ONE",
      1024: "ONT",
      1025: "CZZ",
      1026: "KEX",
      1027: "MCM",
      1032: "BTCR",
      1042: "MFID",
      1111: "BBC",
      1120: "RISE",
      1122: "CMT",
      1128: "ETSC",
      1129: "DFI",
      1130: "DFI",
      1137: "$DAG",
      1145: "CDY",
      1155: "EFI",
      1170: "HOO",
      1234: "ALPH",
      1284: "GLMR",
      1285: "MOVR",
      1298: "WPC",
      1308: "WEI",
      1337: "DFC",
      1397: "HYC",
      1410: "TENTSLP",
      1510: "XSC",
      1512: "AAC",
      1533: "BEAM",
      1555: "APC",
      1616: "ELF",
      1618: "AUDL",
      1620: "ATH",
      1627: "LUME",
      1642: "NEW",
      1657: "BTA",
      1668: "NEOX",
      1669: "MEWC",
      1688: "BCX",
      1729: "XTZ",
      1776: "LBTC",
      1777: "BBP",
      1784: "JPYS",
      1789: "VEGA",
      1815: "ADA",
      1818: "CUBE",
      1856: "TES",
      1888: "ZTX",
      1899: "XEC",
      1901: "CLC",
      1919: "VIPS",
      1926: "CITY",
      1955: "XX",
      1977: "XMX",
      1984: "TRTL",
      1985: "SLRT",
      1986: "QTH",
      1987: "EGEM",
      1988: "MIRA",
      1989: "HODL",
      1990: "PHL",
      1991: "SC",
      1996: "MYT",
      1997: "POLIS",
      1998: "XMCC",
      1999: "COLX",
      2e3: "GIN",
      2001: "MNP",
      2002: "MLN",
      2017: "KIN",
      2018: "EOSC",
      2019: "GBT",
      2020: "PKC",
      2021: "SKT",
      2022: "XHT",
      2048: "MCASH",
      2049: "TRUE",
      2086: "KILT",
      2109: "SAMA",
      2112: "IoTE",
      2137: "XRG",
      2182: "CHZ",
      2221: "ASK",
      2301: "QTUM",
      2302: "ETP",
      2303: "GXC",
      2304: "CRP",
      2305: "ELA",
      2338: "SNOW",
      2365: "XIN",
      2570: "AOA",
      2718: "NAS",
      2894: "REOSC",
      2941: "BND",
      3003: "LUX",
      3030: "HBAR",
      3077: "COS",
      3276: "CCC",
      3333: "SXP",
      3377: "ROI",
      3381: "DYN",
      3383: "SEQ",
      3552: "DEO",
      3564: "DST",
      3601: "CY",
      4040: "FC8",
      4096: "YEE",
      4218: "IOTA",
      4219: "SMR",
      4242: "AXE",
      4343: "XYM",
      4444: "C4E",
      4919: "XVM",
      5006: "SBC",
      5248: "FIC",
      5353: "HNS",
      5404: "ISK",
      5467: "ALTME",
      5555: "FUND",
      5757: "STX",
      5895: "VOW",
      5920: "SLU",
      6060: "GO",
      6174: "MOI",
      6599: "RSC",
      6666: "BPA",
      6688: "SAFE",
      6779: "COTI",
      6969: "ROGER",
      7091: "TOPL",
      7331: "KLY",
      7341: "SHFT",
      7777: "BTV",
      8e3: "SKY",
      8192: "PAC",
      8217: "KLAY",
      8339: "BTQ",
      8444: "XCH",
      8680: "PLMNT",
      8888: "SBTC",
      8964: "NULS",
      8997: "BBC",
      8998: "JGC",
      8999: "BTP",
      9e3: "AVAX",
      9001: "ARB1",
      9002: "BOBA",
      9003: "LOOP",
      9004: "STRK",
      9005: "AVAXC",
      9006: "BSC",
      9797: "NRG",
      9888: "BTF",
      9999: "GOD",
      1e4: "FO",
      10226: "RTM",
      10291: "XRC",
      10605: "XPI",
      11111: "ESS",
      12345: "IPOS",
      12586: "MINA",
      13107: "BTY",
      13108: "YCC",
      14001: "WAX",
      15845: "SDGO",
      16181: "XTX",
      16754: "ARDR",
      18e3: "MTR",
      19165: "SAFE",
      19167: "FLUX",
      19169: "RITO",
      20036: "XND",
      21004: "C4EI",
      21888: "PCT",
      22504: "PWR",
      25252: "BELL",
      25718: "CHX",
      29223: "NEXA",
      31102: "ESN",
      33416: "TEO",
      33878: "BTCS",
      34952: "BTT",
      37992: "FXTC",
      39321: "AMA",
      42069: "FACT",
      43028: "AXIV",
      49262: "EVE",
      49344: "STASH",
      52752: "CELO",
      61616: "TH",
      65536: "KETH",
      69420: "GRLC",
      70007: "GWL",
      77777: "ZYN",
      88888: "RYO",
      99999: "WICC",
      100500: "HOME",
      101010: "STC",
      105105: "STRAX",
      111111: "KAS",
      161803: "APTA",
      200625: "AKA",
      200665: "GENOM",
      246529: "ATS",
      261131: "ZAMA",
      314159: "PI",
      333332: "VALUE",
      333333: "3333",
      424242: "X42",
      534352: "SCR",
      666666: "VITE",
      888888: "SEA",
      1048576: "AMAX",
      1171337: "ILT",
      1313114: "ETHO",
      1313500: "XERO",
      1712144: "LAX",
      3924011: "EPK",
      4741444: "HYD",
      5249353: "BCO",
      5249354: "BHD",
      5264462: "PTN",
      5655640: "VLX",
      5718350: "WAN",
      5741564: "WAVES",
      5741565: "WEST",
      6382179: "ABC",
      6517357: "CRM",
      7562605: "SEM",
      7567736: "ION",
      7777777: "FCT",
      7825266: "WGR",
      7825267: "OBSR",
      8163271: "AFS",
      15118976: "XDS",
      61717561: "AQUA",
      88888888: "HATCH",
      91927009: "kUSD",
      99999996: "GENS",
      99999997: "EQ",
      99999998: "FLUID",
      99999999: "QKC",
      608589380: "FVDC"
    }[g]) !== null && c !== void 0 ? c : "";
  }
  return coin$1;
}
var hasRequiredStringHelper;
function requireStringHelper() {
  return hasRequiredStringHelper || (hasRequiredStringHelper = 1, function(o) {
    var g = stringHelper && stringHelper.__createBinding || (Object.create ? function(M, U, L, H) {
      H === void 0 && (H = L);
      var fe = Object.getOwnPropertyDescriptor(U, L);
      (!fe || ("get" in fe ? !U.__esModule : fe.writable || fe.configurable)) && (fe = { enumerable: !0, get: function() {
        return U[L];
      } }), Object.defineProperty(M, H, fe);
    } : function(M, U, L, H) {
      H === void 0 && (H = L), M[H] = U[L];
    }), c = stringHelper && stringHelper.__setModuleDefault || (Object.create ? function(M, U) {
      Object.defineProperty(M, "default", { enumerable: !0, value: U });
    } : function(M, U) {
      M.default = U;
    }), y = stringHelper && stringHelper.__importStar || /* @__PURE__ */ function() {
      var M = function(U) {
        return M = Object.getOwnPropertyNames || function(L) {
          var H = [];
          for (var fe in L) Object.prototype.hasOwnProperty.call(L, fe) && (H[H.length] = fe);
          return H;
        }, M(U);
      };
      return function(U) {
        if (U && U.__esModule) return U;
        var L = {};
        if (U != null) for (var H = M(U), fe = 0; fe < H.length; fe++) H[fe] !== "default" && g(L, U, H[fe]);
        return c(L, U), L;
      };
    }(), t = stringHelper && stringHelper.__exportStar || function(M, U) {
      for (var L in M) L !== "default" && !Object.prototype.hasOwnProperty.call(U, L) && g(U, M, L);
    };
    Object.defineProperty(o, "__esModule", { value: !0 }), o.uuid = void 0, o.toHex = B, o.toBuffer = D, o.uuidParse = x, o.uuidStringify = v, o.parsePath = F;
    const d = y(/* @__PURE__ */ requireCommonjsBrowser());
    o.uuid = d;
    const E = requireBuffer$2();
    t(requireCoin$1(), o);
    function B(M) {
      return M === void 0 ? "" : E.Buffer.from(M).toString("hex");
    }
    function D(M) {
      return E.Buffer.from(M ?? "", "hex");
    }
    function x(M) {
      return E.Buffer.from(d.parse(M));
    }
    function v(M) {
      return d.stringify(M);
    }
    function F(M) {
      return M.replace(/^m\//i, "").split("/").map((L) => {
        const H = L.endsWith("'");
        return {
          index: Number(H ? L.substring(0, L.length - 1) : L),
          hardened: H
        };
      });
    }
  }(stringHelper)), stringHelper;
}
var crypto$6 = {}, dist$o = {}, extendStatics = function(o, g) {
  return extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(c, y) {
    c.__proto__ = y;
  } || function(c, y) {
    for (var t in y) Object.prototype.hasOwnProperty.call(y, t) && (c[t] = y[t]);
  }, extendStatics(o, g);
};
function __extends(o, g) {
  if (typeof g != "function" && g !== null)
    throw new TypeError("Class extends value " + String(g) + " is not a constructor or null");
  extendStatics(o, g);
  function c() {
    this.constructor = o;
  }
  o.prototype = g === null ? Object.create(g) : (c.prototype = g.prototype, new c());
}
var __assign = function() {
  return __assign = Object.assign || function(g) {
    for (var c, y = 1, t = arguments.length; y < t; y++) {
      c = arguments[y];
      for (var d in c) Object.prototype.hasOwnProperty.call(c, d) && (g[d] = c[d]);
    }
    return g;
  }, __assign.apply(this, arguments);
};
function __rest(o, g) {
  var c = {};
  for (var y in o) Object.prototype.hasOwnProperty.call(o, y) && g.indexOf(y) < 0 && (c[y] = o[y]);
  if (o != null && typeof Object.getOwnPropertySymbols == "function")
    for (var t = 0, y = Object.getOwnPropertySymbols(o); t < y.length; t++)
      g.indexOf(y[t]) < 0 && Object.prototype.propertyIsEnumerable.call(o, y[t]) && (c[y[t]] = o[y[t]]);
  return c;
}
function __decorate(o, g, c, y) {
  var t = arguments.length, d = t < 3 ? g : y === null ? y = Object.getOwnPropertyDescriptor(g, c) : y, E;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") d = Reflect.decorate(o, g, c, y);
  else for (var B = o.length - 1; B >= 0; B--) (E = o[B]) && (d = (t < 3 ? E(d) : t > 3 ? E(g, c, d) : E(g, c)) || d);
  return t > 3 && d && Object.defineProperty(g, c, d), d;
}
function __param(o, g) {
  return function(c, y) {
    g(c, y, o);
  };
}
function __esDecorate(o, g, c, y, t, d) {
  function E(ge) {
    if (ge !== void 0 && typeof ge != "function") throw new TypeError("Function expected");
    return ge;
  }
  for (var B = y.kind, D = B === "getter" ? "get" : B === "setter" ? "set" : "value", x = !g && o ? y.static ? o : o.prototype : null, v = g || (x ? Object.getOwnPropertyDescriptor(x, y.name) : {}), F, M = !1, U = c.length - 1; U >= 0; U--) {
    var L = {};
    for (var H in y) L[H] = H === "access" ? {} : y[H];
    for (var H in y.access) L.access[H] = y.access[H];
    L.addInitializer = function(ge) {
      if (M) throw new TypeError("Cannot add initializers after decoration has completed");
      d.push(E(ge || null));
    };
    var fe = (0, c[U])(B === "accessor" ? { get: v.get, set: v.set } : v[D], L);
    if (B === "accessor") {
      if (fe === void 0) continue;
      if (fe === null || typeof fe != "object") throw new TypeError("Object expected");
      (F = E(fe.get)) && (v.get = F), (F = E(fe.set)) && (v.set = F), (F = E(fe.init)) && t.unshift(F);
    } else (F = E(fe)) && (B === "field" ? t.unshift(F) : v[D] = F);
  }
  x && Object.defineProperty(x, y.name, v), M = !0;
}
function __runInitializers(o, g, c) {
  for (var y = arguments.length > 2, t = 0; t < g.length; t++)
    c = y ? g[t].call(o, c) : g[t].call(o);
  return y ? c : void 0;
}
function __propKey(o) {
  return typeof o == "symbol" ? o : "".concat(o);
}
function __setFunctionName(o, g, c) {
  return typeof g == "symbol" && (g = g.description ? "[".concat(g.description, "]") : ""), Object.defineProperty(o, "name", { configurable: !0, value: c ? "".concat(c, " ", g) : g });
}
function __metadata(o, g) {
  if (typeof Reflect == "object" && typeof Reflect.metadata == "function") return Reflect.metadata(o, g);
}
function __awaiter$1(o, g, c, y) {
  function t(d) {
    return d instanceof c ? d : new c(function(E) {
      E(d);
    });
  }
  return new (c || (c = Promise))(function(d, E) {
    function B(v) {
      try {
        x(y.next(v));
      } catch (F) {
        E(F);
      }
    }
    function D(v) {
      try {
        x(y.throw(v));
      } catch (F) {
        E(F);
      }
    }
    function x(v) {
      v.done ? d(v.value) : t(v.value).then(B, D);
    }
    x((y = y.apply(o, g || [])).next());
  });
}
function __generator(o, g) {
  var c = { label: 0, sent: function() {
    if (d[0] & 1) throw d[1];
    return d[1];
  }, trys: [], ops: [] }, y, t, d, E = Object.create((typeof Iterator == "function" ? Iterator : Object).prototype);
  return E.next = B(0), E.throw = B(1), E.return = B(2), typeof Symbol == "function" && (E[Symbol.iterator] = function() {
    return this;
  }), E;
  function B(x) {
    return function(v) {
      return D([x, v]);
    };
  }
  function D(x) {
    if (y) throw new TypeError("Generator is already executing.");
    for (; E && (E = 0, x[0] && (c = 0)), c; ) try {
      if (y = 1, t && (d = x[0] & 2 ? t.return : x[0] ? t.throw || ((d = t.return) && d.call(t), 0) : t.next) && !(d = d.call(t, x[1])).done) return d;
      switch (t = 0, d && (x = [x[0] & 2, d.value]), x[0]) {
        case 0:
        case 1:
          d = x;
          break;
        case 4:
          return c.label++, { value: x[1], done: !1 };
        case 5:
          c.label++, t = x[1], x = [0];
          continue;
        case 7:
          x = c.ops.pop(), c.trys.pop();
          continue;
        default:
          if (d = c.trys, !(d = d.length > 0 && d[d.length - 1]) && (x[0] === 6 || x[0] === 2)) {
            c = 0;
            continue;
          }
          if (x[0] === 3 && (!d || x[1] > d[0] && x[1] < d[3])) {
            c.label = x[1];
            break;
          }
          if (x[0] === 6 && c.label < d[1]) {
            c.label = d[1], d = x;
            break;
          }
          if (d && c.label < d[2]) {
            c.label = d[2], c.ops.push(x);
            break;
          }
          d[2] && c.ops.pop(), c.trys.pop();
          continue;
      }
      x = g.call(o, c);
    } catch (v) {
      x = [6, v], t = 0;
    } finally {
      y = d = 0;
    }
    if (x[0] & 5) throw x[1];
    return { value: x[0] ? x[1] : void 0, done: !0 };
  }
}
var __createBinding = Object.create ? function(o, g, c, y) {
  y === void 0 && (y = c);
  var t = Object.getOwnPropertyDescriptor(g, c);
  (!t || ("get" in t ? !g.__esModule : t.writable || t.configurable)) && (t = { enumerable: !0, get: function() {
    return g[c];
  } }), Object.defineProperty(o, y, t);
} : function(o, g, c, y) {
  y === void 0 && (y = c), o[y] = g[c];
};
function __exportStar(o, g) {
  for (var c in o) c !== "default" && !Object.prototype.hasOwnProperty.call(g, c) && __createBinding(g, o, c);
}
function __values$1(o) {
  var g = typeof Symbol == "function" && Symbol.iterator, c = g && o[g], y = 0;
  if (c) return c.call(o);
  if (o && typeof o.length == "number") return {
    next: function() {
      return o && y >= o.length && (o = void 0), { value: o && o[y++], done: !o };
    }
  };
  throw new TypeError(g ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, g) {
  var c = typeof Symbol == "function" && o[Symbol.iterator];
  if (!c) return o;
  var y = c.call(o), t, d = [], E;
  try {
    for (; (g === void 0 || g-- > 0) && !(t = y.next()).done; ) d.push(t.value);
  } catch (B) {
    E = { error: B };
  } finally {
    try {
      t && !t.done && (c = y.return) && c.call(y);
    } finally {
      if (E) throw E.error;
    }
  }
  return d;
}
function __spread() {
  for (var o = [], g = 0; g < arguments.length; g++)
    o = o.concat(__read(arguments[g]));
  return o;
}
function __spreadArrays() {
  for (var o = 0, g = 0, c = arguments.length; g < c; g++) o += arguments[g].length;
  for (var y = Array(o), t = 0, g = 0; g < c; g++)
    for (var d = arguments[g], E = 0, B = d.length; E < B; E++, t++)
      y[t] = d[E];
  return y;
}
function __spreadArray(o, g, c) {
  if (c || arguments.length === 2) for (var y = 0, t = g.length, d; y < t; y++)
    (d || !(y in g)) && (d || (d = Array.prototype.slice.call(g, 0, y)), d[y] = g[y]);
  return o.concat(d || Array.prototype.slice.call(g));
}
function __await(o) {
  return this instanceof __await ? (this.v = o, this) : new __await(o);
}
function __asyncGenerator(o, g, c) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var y = c.apply(o, g || []), t, d = [];
  return t = Object.create((typeof AsyncIterator == "function" ? AsyncIterator : Object).prototype), B("next"), B("throw"), B("return", E), t[Symbol.asyncIterator] = function() {
    return this;
  }, t;
  function E(U) {
    return function(L) {
      return Promise.resolve(L).then(U, F);
    };
  }
  function B(U, L) {
    y[U] && (t[U] = function(H) {
      return new Promise(function(fe, ge) {
        d.push([U, H, fe, ge]) > 1 || D(U, H);
      });
    }, L && (t[U] = L(t[U])));
  }
  function D(U, L) {
    try {
      x(y[U](L));
    } catch (H) {
      M(d[0][3], H);
    }
  }
  function x(U) {
    U.value instanceof __await ? Promise.resolve(U.value.v).then(v, F) : M(d[0][2], U);
  }
  function v(U) {
    D("next", U);
  }
  function F(U) {
    D("throw", U);
  }
  function M(U, L) {
    U(L), d.shift(), d.length && D(d[0][0], d[0][1]);
  }
}
function __asyncDelegator(o) {
  var g, c;
  return g = {}, y("next"), y("throw", function(t) {
    throw t;
  }), y("return"), g[Symbol.iterator] = function() {
    return this;
  }, g;
  function y(t, d) {
    g[t] = o[t] ? function(E) {
      return (c = !c) ? { value: __await(o[t](E)), done: !1 } : d ? d(E) : E;
    } : d;
  }
}
function __asyncValues(o) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var g = o[Symbol.asyncIterator], c;
  return g ? g.call(o) : (o = typeof __values$1 == "function" ? __values$1(o) : o[Symbol.iterator](), c = {}, y("next"), y("throw"), y("return"), c[Symbol.asyncIterator] = function() {
    return this;
  }, c);
  function y(d) {
    c[d] = o[d] && function(E) {
      return new Promise(function(B, D) {
        E = o[d](E), t(B, D, E.done, E.value);
      });
    };
  }
  function t(d, E, B, D) {
    Promise.resolve(D).then(function(x) {
      d({ value: x, done: B });
    }, E);
  }
}
function __makeTemplateObject(o, g) {
  return Object.defineProperty ? Object.defineProperty(o, "raw", { value: g }) : o.raw = g, o;
}
var __setModuleDefault = Object.create ? function(o, g) {
  Object.defineProperty(o, "default", { enumerable: !0, value: g });
} : function(o, g) {
  o.default = g;
}, ownKeys = function(o) {
  return ownKeys = Object.getOwnPropertyNames || function(g) {
    var c = [];
    for (var y in g) Object.prototype.hasOwnProperty.call(g, y) && (c[c.length] = y);
    return c;
  }, ownKeys(o);
};
function __importStar(o) {
  if (o && o.__esModule) return o;
  var g = {};
  if (o != null) for (var c = ownKeys(o), y = 0; y < c.length; y++) c[y] !== "default" && __createBinding(g, o, c[y]);
  return __setModuleDefault(g, o), g;
}
function __importDefault(o) {
  return o && o.__esModule ? o : { default: o };
}
function __classPrivateFieldGet(o, g, c, y) {
  if (c === "a" && !y) throw new TypeError("Private accessor was defined without a getter");
  if (typeof g == "function" ? o !== g || !y : !g.has(o)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return c === "m" ? y : c === "a" ? y.call(o) : y ? y.value : g.get(o);
}
function __classPrivateFieldSet(o, g, c, y, t) {
  if (y === "m") throw new TypeError("Private method is not writable");
  if (y === "a" && !t) throw new TypeError("Private accessor was defined without a setter");
  if (typeof g == "function" ? o !== g || !t : !g.has(o)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return y === "a" ? t.call(o, c) : t ? t.value = c : g.set(o, c), c;
}
function __classPrivateFieldIn(o, g) {
  if (g === null || typeof g != "object" && typeof g != "function") throw new TypeError("Cannot use 'in' operator on non-object");
  return typeof o == "function" ? g === o : o.has(g);
}
function __addDisposableResource(o, g, c) {
  if (g != null) {
    if (typeof g != "object" && typeof g != "function") throw new TypeError("Object expected.");
    var y, t;
    if (c) {
      if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
      y = g[Symbol.asyncDispose];
    }
    if (y === void 0) {
      if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
      y = g[Symbol.dispose], c && (t = y);
    }
    if (typeof y != "function") throw new TypeError("Object not disposable.");
    t && (y = function() {
      try {
        t.call(this);
      } catch (d) {
        return Promise.reject(d);
      }
    }), o.stack.push({ value: g, dispose: y, async: c });
  } else c && o.stack.push({ async: !0 });
  return g;
}
var _SuppressedError = typeof SuppressedError == "function" ? SuppressedError : function(o, g, c) {
  var y = new Error(c);
  return y.name = "SuppressedError", y.error = o, y.suppressed = g, y;
};
function __disposeResources(o) {
  function g(d) {
    o.error = o.hasError ? new _SuppressedError(d, o.error, "An error was suppressed during disposal.") : d, o.hasError = !0;
  }
  var c, y = 0;
  function t() {
    for (; c = o.stack.pop(); )
      try {
        if (!c.async && y === 1) return y = 0, o.stack.push(c), Promise.resolve().then(t);
        if (c.dispose) {
          var d = c.dispose.call(c.value);
          if (c.async) return y |= 2, Promise.resolve(d).then(t, function(E) {
            return g(E), t();
          });
        } else y |= 1;
      } catch (E) {
        g(E);
      }
    if (y === 1) return o.hasError ? Promise.reject(o.error) : Promise.resolve();
    if (o.hasError) throw o.error;
  }
  return t();
}
function __rewriteRelativeImportExtension(o, g) {
  return typeof o == "string" && /^\.\.?\//.test(o) ? o.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(c, y, t, d, E) {
    return y ? g ? ".jsx" : ".js" : t && (!d || !E) ? c : t + d + "." + E.toLowerCase() + "js";
  }) : o;
}
const tslib_es6 = {
  __extends,
  __assign,
  __rest,
  __decorate,
  __param,
  __esDecorate,
  __runInitializers,
  __propKey,
  __setFunctionName,
  __metadata,
  __awaiter: __awaiter$1,
  __generator,
  __createBinding,
  __exportStar,
  __values: __values$1,
  __read,
  __spread,
  __spreadArrays,
  __spreadArray,
  __await,
  __asyncGenerator,
  __asyncDelegator,
  __asyncValues,
  __makeTemplateObject,
  __importStar,
  __importDefault,
  __classPrivateFieldGet,
  __classPrivateFieldSet,
  __classPrivateFieldIn,
  __addDisposableResource,
  __disposeResources,
  __rewriteRelativeImportExtension
}, tslib_es6$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  __addDisposableResource,
  get __assign() {
    return __assign;
  },
  __asyncDelegator,
  __asyncGenerator,
  __asyncValues,
  __await,
  __awaiter: __awaiter$1,
  __classPrivateFieldGet,
  __classPrivateFieldIn,
  __classPrivateFieldSet,
  __createBinding,
  __decorate,
  __disposeResources,
  __esDecorate,
  __exportStar,
  __extends,
  __generator,
  __importDefault,
  __importStar,
  __makeTemplateObject,
  __metadata,
  __param,
  __propKey,
  __read,
  __rest,
  __rewriteRelativeImportExtension,
  __runInitializers,
  __setFunctionName,
  __spread,
  __spreadArray,
  __spreadArrays,
  __values: __values$1,
  default: tslib_es6
}, Symbol.toStringTag, { value: "Module" })), require$$0$2 = /* @__PURE__ */ getAugmentedNamespace(tslib_es6$1);
var patchCBOR$2 = {}, utils$h = {}, lib$8 = {}, cborSync$5 = { exports: {} }, DataItem$2 = {}, hasRequiredDataItem$2;
function requireDataItem$2() {
  if (hasRequiredDataItem$2) return DataItem$2;
  hasRequiredDataItem$2 = 1, Object.defineProperty(DataItem$2, "__esModule", { value: !0 }), DataItem$2.DataItem = void 0;
  class o {
    constructor(c, y) {
      this.setTag = (t) => {
        this.tag = t;
      }, this.clearTag = () => {
        this.tag = void 0;
      }, this.getTag = () => this.tag, this.getData = () => this.data, this.data = c, this.tag = y;
    }
  }
  return DataItem$2.DataItem = o, DataItem$2;
}
var cborSync$4 = cborSync$5.exports, hasRequiredCborSync$2;
function requireCborSync$2() {
  return hasRequiredCborSync$2 || (hasRequiredCborSync$2 = 1, function(o) {
    (function(g, c) {
      o.exports ? o.exports = c() : g.CBOR = c();
    })(cborSync$4, function() {
      const { DataItem: g } = requireDataItem$2();
      var c = function() {
        function y(Pe) {
          this.$hex = Pe;
        }
        y.prototype = {
          length: function() {
            return this.$hex.length / 2;
          },
          toString: function(Pe) {
            if (!Pe || Pe === "hex" || Pe === 16)
              return this.$hex;
            if (Pe === "utf-8") {
              for (var De = "", ve = 0; ve < this.$hex.length; ve += 2)
                De += "%" + this.$hex.substring(ve, ve + 2);
              return decodeURIComponent(De);
            }
            if (Pe === "latin") {
              for (var De = [], ve = 0; ve < this.$hex.length; ve += 2)
                De.push(parseInt(this.$hex.substring(ve, ve + 2), 16));
              return String.fromCharCode.apply(String, De);
            }
            throw new Error("Unrecognised format: " + Pe);
          }
        }, y.fromLatinString = function(Pe) {
          for (var De = "", ve = 0; ve < Pe.length; ve++) {
            var Fe = Pe.charCodeAt(ve).toString(16);
            Fe.length === 1 && (Fe = "0" + Fe), De += Fe;
          }
          return new y(De);
        }, y.fromUtf8String = function(Pe) {
          for (var De = encodeURIComponent(Pe), ve = "", Fe = 0; Fe < De.length; Fe++)
            if (De.charAt(Fe) === "%")
              ve += De.substring(Fe + 1, Fe + 3), Fe += 2;
            else {
              var be = De.charCodeAt(Fe).toString(16);
              be.length < 2 && (be = "0" + be), ve += be;
            }
          return new y(ve);
        };
        var t = [], d = {}, E = function(Pe) {
          return function() {
            throw new Error(Pe + " not implemented");
          };
        };
        function B() {
        }
        B.prototype = {
          peekByte: E("peekByte"),
          readByte: E("readByte"),
          readChunk: E("readChunk"),
          readFloat16: function() {
            var Pe = this.readUint16(), De = (Pe & 32767) >> 10, ve = Pe & 1023, Fe = Pe & 32768;
            if (De === 31)
              return ve === 0 ? Fe ? -1 / 0 : 1 / 0 : NaN;
            var be = De ? Math.pow(2, De - 25) * (1024 + ve) : Math.pow(2, -24) * ve;
            return Fe ? -be : be;
          },
          readFloat32: function() {
            var Pe = this.readUint32(), De = (Pe & 2147483647) >> 23, ve = Pe & 8388607, Fe = Pe & 2147483648;
            if (De === 255)
              return ve === 0 ? Fe ? -1 / 0 : 1 / 0 : NaN;
            var be = De ? Math.pow(2, De - 23 - 127) * (8388608 + ve) : Math.pow(2, -149) * ve;
            return Fe ? -be : be;
          },
          readFloat64: function() {
            var Pe = this.readUint32(), De = this.readUint32(), ve = Pe >> 20 & 2047, Fe = (Pe & 1048575) * 4294967296 + De, be = Pe & 2147483648;
            if (ve === 2047)
              return Fe === 0 ? be ? -1 / 0 : 1 / 0 : NaN;
            var Be = ve ? Math.pow(2, ve - 52 - 1023) * (4503599627370496 + Fe) : Math.pow(2, -1074) * Fe;
            return be ? -Be : Be;
          },
          readUint16: function() {
            return this.readByte() * 256 + this.readByte();
          },
          readUint32: function() {
            return this.readUint16() * 65536 + this.readUint16();
          },
          readUint64: function() {
            return this.readUint32() * 4294967296 + this.readUint32();
          }
        };
        function D() {
        }
        D.prototype = {
          writeByte: E("writeByte"),
          result: E("result"),
          writeFloat16: E("writeFloat16"),
          writeFloat32: E("writeFloat32"),
          writeFloat64: E("writeFloat64"),
          writeUint16: function(Pe) {
            this.writeByte(Pe >> 8 & 255), this.writeByte(Pe & 255);
          },
          writeUint32: function(Pe) {
            this.writeUint16(Pe >> 16 & 65535), this.writeUint16(Pe & 65535);
          },
          writeUint64: function(Pe) {
            if (Pe >= 9007199254740992 || Pe <= -9007199254740992)
              throw new Error("Cannot encode Uint64 of: " + Pe + " magnitude to big (floating point errors)");
            this.writeUint32(Math.floor(Pe / 4294967296)), this.writeUint32(Pe % 4294967296);
          },
          writeString: E("writeString"),
          canWriteBinary: function(Pe) {
            return !1;
          },
          writeBinary: E("writeChunk")
        };
        function x(Pe) {
          var De = Pe.readByte(), ve = De >> 5, Fe = De & 31;
          return { type: ve, value: Fe };
        }
        function v(Pe, De) {
          var ve = Pe.value;
          if (ve < 24)
            return ve;
          if (ve == 24)
            return De.readByte();
          if (ve == 25)
            return De.readUint16();
          if (ve == 26)
            return De.readUint32();
          if (ve == 27)
            return De.readUint64();
          if (ve == 31)
            return null;
          E("Additional info: " + ve)();
        }
        function F(Pe, De, ve) {
          ve.writeByte(Pe << 5 | De);
        }
        function M(Pe, De, ve) {
          var Fe = Pe << 5;
          De < 24 ? ve.writeByte(Fe | De) : De < 256 ? (ve.writeByte(Fe | 24), ve.writeByte(De)) : De < 65536 ? (ve.writeByte(Fe | 25), ve.writeUint16(De)) : De < 4294967296 ? (ve.writeByte(Fe | 26), ve.writeUint32(De)) : (ve.writeByte(Fe | 27), ve.writeUint64(De));
        }
        var U = new Error();
        function L(Pe) {
          var De = x(Pe);
          switch (De.type) {
            case 0:
              return v(De, Pe);
            case 1:
              return -1 - v(De, Pe);
            case 2:
              return Pe.readChunk(v(De, Pe));
            case 3:
              var ve = Pe.readChunk(v(De, Pe));
              return ve.toString("utf-8");
            case 4:
            case 5:
              var Fe = v(De, Pe), Et = [];
              if (Fe !== null) {
                De.type === 5 && (Fe *= 2);
                for (var be = 0; be < Fe; be++)
                  Et[be] = L(Pe);
              } else
                for (var Be; (Be = L(Pe)) !== U; )
                  Et.push(Be);
              if (De.type === 5) {
                for (var ke = {}, be = 0; be < Et.length; be += 2)
                  ke[Et[be]] = Et[be + 1];
                return ke;
              } else
                return Et;
            case 6:
              var xe = v(De, Pe), Ne = d[xe], Et = L(Pe);
              return Ne ? Ne(Et) : Et;
            case 7:
              if (De.value === 25)
                return Pe.readFloat16();
              if (De.value === 26)
                return Pe.readFloat32();
              if (De.value === 27)
                return Pe.readFloat64();
              switch (v(De, Pe)) {
                case 20:
                  return !1;
                case 21:
                  return !0;
                case 22:
                  return null;
                case 23:
                  return;
                case null:
                  return U;
                default:
                  throw new Error("Unknown fixed value: " + De.value);
              }
            default:
              throw new Error("Unsupported header: " + JSON.stringify(De));
          }
          throw new Error("not implemented yet");
        }
        function H(Pe, De) {
          for (var ve = 0; ve < t.length; ve++) {
            var Fe = t[ve].fn(Pe);
            if (Fe !== void 0)
              return M(6, t[ve].tag, De), H(Fe, De);
          }
          if (Pe && typeof Pe.toCBOR == "function" && (Pe = Pe.toCBOR()), Pe === !1)
            M(7, 20, De);
          else if (Pe === !0)
            M(7, 21, De);
          else if (Pe === null)
            M(7, 22, De);
          else if (Pe === void 0)
            M(7, 23, De);
          else if (typeof Pe == "number")
            Math.floor(Pe) === Pe && Pe < 9007199254740992 && Pe > -9007199254740992 ? Pe < 0 ? M(1, -1 - Pe, De) : M(0, Pe, De) : (F(7, 27, De), De.writeFloat64(Pe));
          else if (typeof Pe == "string")
            De.writeString(Pe, function(Be) {
              M(3, Be, De);
            });
          else if (De.canWriteBinary(Pe))
            De.writeBinary(Pe, function(Be) {
              M(2, Be, De);
            });
          else if (typeof Pe == "object")
            if (Ie.config.useToJSON && typeof Pe.toJSON == "function" && (Pe = Pe.toJSON()), Array.isArray(Pe)) {
              M(4, Pe.length, De);
              for (var ve = 0; ve < Pe.length; ve++)
                H(Pe[ve], De);
            } else {
              var be = Object.keys(Pe);
              M(5, be.length, De);
              for (var ve = 0; ve < be.length; ve++) {
                const ke = parseInt(be[ve]);
                isNaN(ke) ? (H(be[ve], De), H(Pe[be[ve]], De)) : (H(ke, De), H(Pe[be[ve]], De));
              }
            }
          else
            throw new Error("CBOR encoding not supported: " + Pe);
        }
        var fe = [], ge = [], Ie = {
          config: {
            useToJSON: !0
          },
          addWriter: function(Pe, De) {
            typeof Pe == "string" ? ge.push(function(ve) {
              if (Pe === ve)
                return De(ve);
            }) : ge.push(Pe);
          },
          addReader: function(Pe, De) {
            typeof Pe == "string" ? fe.push(function(ve, Fe) {
              if (Pe === Fe)
                return De(ve, Fe);
            }) : fe.push(Pe);
          },
          encode: function(Pe, De) {
            for (var ve = 0; ve < ge.length; ve++) {
              var Fe = ge[ve], be = Fe(De);
              if (be)
                return H(Pe, be), be.result();
            }
            throw new Error("Unsupported output format: " + De);
          },
          encodeDataItem: function(Pe, De) {
            for (var ve = 0; ve < ge.length; ve++) {
              var Fe = ge[ve], be = Fe(De);
              if (be)
                return Pe.getTag() !== void 0 ? (H(Pe, be), be.result()) : (H(Pe.getData(), be), be.result());
            }
            throw new Error("Unsupported output format: " + De);
          },
          decode: function(Pe, De) {
            for (var ve = 0; ve < fe.length; ve++) {
              var Fe = fe[ve], be = Fe(Pe, De);
              if (be)
                return L(be);
            }
            throw new Error("Unsupported input format: " + De);
          },
          decodeToDataItem: function(Pe, De) {
            for (var ve = 0; ve < fe.length; ve++) {
              var Fe = fe[ve], be = Fe(Pe, De);
              if (be) {
                const Be = L(be);
                return Be instanceof g ? Be : new g(Be);
              }
            }
            throw new Error("Unsupported input format: " + De);
          },
          addSemanticEncode: function(Pe, De) {
            if (typeof Pe != "number" || Pe % 1 !== 0 || Pe < 0)
              throw new Error("Tag must be a positive integer");
            return t.push({ tag: Pe, fn: De }), this;
          },
          addSemanticDecode: function(Pe, De) {
            if (typeof Pe != "number" || Pe % 1 !== 0 || Pe < 0)
              throw new Error("Tag must be a positive integer");
            return d[Pe] = De, this;
          }
        };
        function Ee(Pe) {
          this.buffer = Pe, this.pos = 0;
        }
        Ee.prototype = Object.create(B.prototype), Ee.prototype.peekByte = function() {
          return this.buffer[this.pos];
        }, Ee.prototype.readByte = function() {
          return this.buffer[this.pos++];
        }, Ee.prototype.readUint16 = function() {
          var Pe = this.buffer.readUInt16BE(this.pos);
          return this.pos += 2, Pe;
        }, Ee.prototype.readUint32 = function() {
          var Pe = this.buffer.readUInt32BE(this.pos);
          return this.pos += 4, Pe;
        }, Ee.prototype.readFloat32 = function() {
          var Pe = this.buffer.readFloatBE(this.pos);
          return this.pos += 4, Pe;
        }, Ee.prototype.readFloat64 = function() {
          var Pe = this.buffer.readDoubleBE(this.pos);
          return this.pos += 8, Pe;
        }, Ee.prototype.readChunk = function(Pe) {
          var De = Buffer.alloc(Pe);
          return this.buffer.copy(De, 0, this.pos, this.pos += Pe), De;
        };
        function Se(Pe) {
          this.byteLength = 0, this.defaultBufferLength = 16384, this.latestBuffer = Buffer.alloc(this.defaultBufferLength), this.latestBufferOffset = 0, this.completeBuffers = [], this.stringFormat = Pe;
        }
        Se.prototype = Object.create(D.prototype), Se.prototype.writeByte = function(Pe) {
          this.latestBuffer[this.latestBufferOffset++] = Pe, this.latestBufferOffset >= this.latestBuffer.length && (this.completeBuffers.push(this.latestBuffer), this.latestBuffer = Buffer.alloc(this.defaultBufferLength), this.latestBufferOffset = 0), this.byteLength++;
        }, Se.prototype.writeFloat32 = function(Pe) {
          var De = Buffer.alloc(4);
          De.writeFloatBE(Pe, 0), this.writeBuffer(De);
        }, Se.prototype.writeFloat64 = function(Pe) {
          var De = Buffer.alloc(8);
          De.writeDoubleBE(Pe, 0), this.writeBuffer(De);
        }, Se.prototype.writeString = function(Pe, De) {
          var ve = Buffer.from(Pe, "utf-8");
          De(ve.length), this.writeBuffer(ve);
        }, Se.prototype.canWriteBinary = function(Pe) {
          return Pe instanceof Buffer;
        }, Se.prototype.writeBinary = function(Pe, De) {
          De(Pe.length), this.writeBuffer(Pe);
        }, Se.prototype.writeBuffer = function(Pe) {
          if (!(Pe instanceof Buffer))
            throw new TypeError("BufferWriter only accepts Buffers");
          this.latestBufferOffset ? this.latestBuffer.length - this.latestBufferOffset >= Pe.length ? (Pe.copy(this.latestBuffer, this.latestBufferOffset), this.latestBufferOffset += Pe.length, this.latestBufferOffset >= this.latestBuffer.length && (this.completeBuffers.push(this.latestBuffer), this.latestBuffer = Buffer.alloc(this.defaultBufferLength), this.latestBufferOffset = 0)) : (this.completeBuffers.push(this.latestBuffer.slice(0, this.latestBufferOffset)), this.completeBuffers.push(Pe), this.latestBuffer = Buffer.alloc(this.defaultBufferLength), this.latestBufferOffset = 0) : this.completeBuffers.push(Pe), this.byteLength += Pe.length;
        }, Se.prototype.result = function() {
          for (var Pe = Buffer.alloc(this.byteLength), De = 0, ve = 0; ve < this.completeBuffers.length; ve++) {
            var Fe = this.completeBuffers[ve];
            Fe.copy(Pe, De, 0, Fe.length), De += Fe.length;
          }
          return this.latestBufferOffset && this.latestBuffer.copy(Pe, De, 0, this.latestBufferOffset), this.stringFormat ? Pe.toString(this.stringFormat) : Pe;
        }, typeof Buffer == "function" && (Ie.addReader(function(Pe, De) {
          if (Buffer.isBuffer(Pe))
            return new Ee(Pe);
          if (De === "hex" || De === "base64") {
            var ve = Buffer.from(Pe, De);
            return new Ee(ve);
          }
        }), Ie.addWriter(function(Pe) {
          if (!Pe || Pe === "buffer")
            return new Se();
          if (Pe === "hex" || Pe === "base64")
            return new Se(Pe);
        }));
        function ze(Pe) {
          this.hex = Pe, this.pos = 0;
        }
        ze.prototype = Object.create(B.prototype), ze.prototype.peekByte = function() {
          var Pe = this.hex.substring(this.pos, 2);
          return parseInt(Pe, 16);
        }, ze.prototype.readByte = function() {
          var Pe = this.hex.substring(this.pos, this.pos + 2);
          return this.pos += 2, parseInt(Pe, 16);
        }, ze.prototype.readChunk = function(Pe) {
          var De = this.hex.substring(this.pos, this.pos + Pe * 2);
          return this.pos += Pe * 2, typeof Buffer == "function" ? Buffer.from(De, "hex") : new y(De);
        };
        function He(Pe) {
          this.$hex = "", this.finalFormat = Pe || "hex";
        }
        return He.prototype = Object.create(D.prototype), He.prototype.writeByte = function(Pe) {
          if (Pe < 0 || Pe > 255)
            throw new Error("Byte value out of range: " + Pe);
          var De = Pe.toString(16);
          De.length == 1 && (De = "0" + De), this.$hex += De;
        }, He.prototype.canWriteBinary = function(Pe) {
          return Pe instanceof y || typeof Buffer == "function" && Pe instanceof Buffer;
        }, He.prototype.writeBinary = function(Pe, De) {
          if (Pe instanceof y)
            De(Pe.length()), this.$hex += Pe.$hex;
          else if (typeof Buffer == "function" && Pe instanceof Buffer)
            De(Pe.length), this.$hex += Pe.toString("hex");
          else
            throw new TypeError("HexWriter only accepts BinaryHex or Buffers");
        }, He.prototype.result = function() {
          return this.finalFormat === "buffer" && typeof Buffer == "function" ? Buffer.from(this.$hex, "hex") : new y(this.$hex).toString(this.finalFormat);
        }, He.prototype.writeString = function(Pe, De) {
          var ve = y.fromUtf8String(Pe);
          De(ve.length()), this.$hex += ve.$hex;
        }, Ie.addReader(function(Pe, De) {
          if (Pe instanceof y || Pe.$hex)
            return new ze(Pe.$hex);
          if (De === "hex")
            return new ze(Pe);
        }), Ie.addWriter(function(Pe) {
          if (Pe === "hex")
            return new He();
        }), Ie;
      }();
      return c.addSemanticEncode(0, function(y) {
        if (y instanceof Date)
          return y.toISOString();
      }).addSemanticDecode(0, function(y) {
        return new Date(y);
      }).addSemanticDecode(1, function(y) {
        return new Date(y);
      }), c;
    });
  }(cborSync$5)), cborSync$5.exports;
}
var hasRequiredLib$8;
function requireLib$8() {
  return hasRequiredLib$8 || (hasRequiredLib$8 = 1, function(o) {
    Object.defineProperty(o, "__esModule", { value: !0 }), o.DataItem = o.addWriter = o.addReader = o.addSemanticEncode = o.addSemanticDecode = o.decodeToDataItem = o.encodeDataItem = void 0;
    var g = requireCborSync$2();
    Object.defineProperty(o, "encodeDataItem", { enumerable: !0, get: function() {
      return g.encodeDataItem;
    } }), Object.defineProperty(o, "decodeToDataItem", { enumerable: !0, get: function() {
      return g.decodeToDataItem;
    } }), Object.defineProperty(o, "addSemanticDecode", { enumerable: !0, get: function() {
      return g.addSemanticDecode;
    } }), Object.defineProperty(o, "addSemanticEncode", { enumerable: !0, get: function() {
      return g.addSemanticEncode;
    } }), Object.defineProperty(o, "addReader", { enumerable: !0, get: function() {
      return g.addReader;
    } }), Object.defineProperty(o, "addWriter", { enumerable: !0, get: function() {
      return g.addWriter;
    } });
    var c = requireDataItem$2();
    Object.defineProperty(o, "DataItem", { enumerable: !0, get: function() {
      return c.DataItem;
    } });
  }(lib$8)), lib$8;
}
var hasRequiredUtils$g;
function requireUtils$g() {
  if (hasRequiredUtils$g) return utils$h;
  hasRequiredUtils$g = 1, Object.defineProperty(utils$h, "__esModule", { value: !0 }), utils$h.patchTags = void 0;
  const o = requireLib$8(), g = [], c = (y) => {
    y.forEach((t) => {
      g.find((d) => d === t) || ((0, o.addSemanticEncode)(t, (d) => {
        if (d instanceof o.DataItem && d.getTag() === t)
          return d.getData();
      }), (0, o.addSemanticDecode)(t, (d) => new o.DataItem(d, t)), g.push(t));
    });
  };
  return utils$h.patchTags = c, utils$h;
}
var RegistryType$3 = {}, hasRequiredRegistryType$3;
function requireRegistryType$3() {
  if (hasRequiredRegistryType$3) return RegistryType$3;
  hasRequiredRegistryType$3 = 1, Object.defineProperty(RegistryType$3, "__esModule", { value: !0 }), RegistryType$3.RegistryTypes = RegistryType$3.RegistryType = void 0;
  class o {
    constructor(c, y) {
      this.type = c, this.tag = y, this.getTag = () => this.tag, this.getType = () => this.type;
    }
  }
  return RegistryType$3.RegistryType = o, RegistryType$3.RegistryTypes = {
    UUID: new o("uuid", 37),
    BYTES: new o("bytes", void 0),
    CRYPTO_HDKEY: new o("crypto-hdkey", 303),
    CRYPTO_KEYPATH: new o("crypto-keypath", 304),
    CRYPTO_COIN_INFO: new o("crypto-coin-info", 305),
    CRYPTO_ECKEY: new o("crypto-eckey", 306),
    CRYPTO_OUTPUT: new o("crypto-output", 308),
    CRYPTO_PSBT: new o("crypto-psbt", 310),
    CRYPTO_PSBT_EXTEND: new o("crypto-psbt-extend", 312),
    CRYPTO_ACCOUNT: new o("crypto-account", 311),
    CRYPTO_MULTI_ACCOUNTS: new o("crypto-multi-accounts", 1103),
    QR_HARDWARE_CALL: new o("qr-hardware-call", 1201),
    KEY_DERIVATION_CALL: new o("key-derivation-call", 1301),
    KEY_DERIVATION_SCHEMA: new o("key-derivation-schema", 1302),
    DERIVE_CONTEXT_HASH_CALL: new o("derive-context-hash-call", 1303)
  }, RegistryType$3;
}
var ScriptExpression$2 = {}, hasRequiredScriptExpression$2;
function requireScriptExpression$2() {
  return hasRequiredScriptExpression$2 || (hasRequiredScriptExpression$2 = 1, function(o) {
    Object.defineProperty(o, "__esModule", { value: !0 }), o.ScriptExpressions = o.ScriptExpression = void 0;
    class g {
      constructor(y, t) {
        this.tag = y, this.expression = t, this.getTag = () => this.tag, this.getExpression = () => this.expression;
      }
    }
    o.ScriptExpression = g, g.fromTag = (c) => Object.values(o.ScriptExpressions).find((t) => t.getTag() === c), o.ScriptExpressions = {
      SCRIPT_HASH: new g(400, "sh"),
      WITNESS_SCRIPT_HASH: new g(401, "wsh"),
      PUBLIC_KEY: new g(402, "pk"),
      PUBLIC_KEY_HASH: new g(403, "pkh"),
      WITNESS_PUBLIC_KEY_HASH: new g(404, "wpkh"),
      COMBO: new g(405, "combo"),
      MULTISIG: new g(406, "multi"),
      SORTED_MULTISIG: new g(407, "sortedmulti"),
      ADDRESS: new g(307, "addr"),
      RAW_SCRIPT: new g(408, "raw")
    };
  }(ScriptExpression$2)), ScriptExpression$2;
}
var hasRequiredPatchCBOR$2;
function requirePatchCBOR$2() {
  if (hasRequiredPatchCBOR$2) return patchCBOR$2;
  hasRequiredPatchCBOR$2 = 1, Object.defineProperty(patchCBOR$2, "__esModule", { value: !0 });
  const o = requireUtils$g(), g = requireRegistryType$3(), c = requireScriptExpression$2(), y = Object.values(g.RegistryTypes).filter((d) => !!d.getTag()).map((d) => d.getTag()), t = Object.values(c.ScriptExpressions).map((d) => d.getTag());
  return (0, o.patchTags)(y.concat(t)), patchCBOR$2;
}
var CryptoHDKey$2 = {}, inherits_browser = { exports: {} }, hasRequiredInherits_browser;
function requireInherits_browser() {
  return hasRequiredInherits_browser || (hasRequiredInherits_browser = 1, typeof Object.create == "function" ? inherits_browser.exports = function(g, c) {
    c && (g.super_ = c, g.prototype = Object.create(c.prototype, {
      constructor: {
        value: g,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }));
  } : inherits_browser.exports = function(g, c) {
    if (c) {
      g.super_ = c;
      var y = function() {
      };
      y.prototype = c.prototype, g.prototype = new y(), g.prototype.constructor = g;
    }
  }), inherits_browser.exports;
}
var safeBuffer$1 = { exports: {} };
var hasRequiredSafeBuffer$1;
function requireSafeBuffer$1() {
  return hasRequiredSafeBuffer$1 || (hasRequiredSafeBuffer$1 = 1, function(o, g) {
    var c = requireBuffer$2(), y = c.Buffer;
    function t(E, B) {
      for (var D in E)
        B[D] = E[D];
    }
    y.from && y.alloc && y.allocUnsafe && y.allocUnsafeSlow ? o.exports = c : (t(c, g), g.Buffer = d);
    function d(E, B, D) {
      return y(E, B, D);
    }
    d.prototype = Object.create(y.prototype), t(y, d), d.from = function(E, B, D) {
      if (typeof E == "number")
        throw new TypeError("Argument must not be a number");
      return y(E, B, D);
    }, d.alloc = function(E, B, D) {
      if (typeof E != "number")
        throw new TypeError("Argument must be a number");
      var x = y(E);
      return B !== void 0 ? typeof D == "string" ? x.fill(B, D) : x.fill(B) : x.fill(0), x;
    }, d.allocUnsafe = function(E) {
      if (typeof E != "number")
        throw new TypeError("Argument must be a number");
      return y(E);
    }, d.allocUnsafeSlow = function(E) {
      if (typeof E != "number")
        throw new TypeError("Argument must be a number");
      return c.SlowBuffer(E);
    };
  }(safeBuffer$1, safeBuffer$1.exports)), safeBuffer$1.exports;
}
var readableBrowser$1 = { exports: {} }, events = { exports: {} }, hasRequiredEvents;
function requireEvents() {
  if (hasRequiredEvents) return events.exports;
  hasRequiredEvents = 1;
  var o = typeof Reflect == "object" ? Reflect : null, g = o && typeof o.apply == "function" ? o.apply : function(ze, He, Pe) {
    return Function.prototype.apply.call(ze, He, Pe);
  }, c;
  o && typeof o.ownKeys == "function" ? c = o.ownKeys : Object.getOwnPropertySymbols ? c = function(ze) {
    return Object.getOwnPropertyNames(ze).concat(Object.getOwnPropertySymbols(ze));
  } : c = function(ze) {
    return Object.getOwnPropertyNames(ze);
  };
  function y(Se) {
    console && console.warn && console.warn(Se);
  }
  var t = Number.isNaN || function(ze) {
    return ze !== ze;
  };
  function d() {
    d.init.call(this);
  }
  events.exports = d, events.exports.once = ge, d.EventEmitter = d, d.prototype._events = void 0, d.prototype._eventsCount = 0, d.prototype._maxListeners = void 0;
  var E = 10;
  function B(Se) {
    if (typeof Se != "function")
      throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof Se);
  }
  Object.defineProperty(d, "defaultMaxListeners", {
    enumerable: !0,
    get: function() {
      return E;
    },
    set: function(Se) {
      if (typeof Se != "number" || Se < 0 || t(Se))
        throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + Se + ".");
      E = Se;
    }
  }), d.init = function() {
    (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
  }, d.prototype.setMaxListeners = function(ze) {
    if (typeof ze != "number" || ze < 0 || t(ze))
      throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + ze + ".");
    return this._maxListeners = ze, this;
  };
  function D(Se) {
    return Se._maxListeners === void 0 ? d.defaultMaxListeners : Se._maxListeners;
  }
  d.prototype.getMaxListeners = function() {
    return D(this);
  }, d.prototype.emit = function(ze) {
    for (var He = [], Pe = 1; Pe < arguments.length; Pe++) He.push(arguments[Pe]);
    var De = ze === "error", ve = this._events;
    if (ve !== void 0)
      De = De && ve.error === void 0;
    else if (!De)
      return !1;
    if (De) {
      var Fe;
      if (He.length > 0 && (Fe = He[0]), Fe instanceof Error)
        throw Fe;
      var be = new Error("Unhandled error." + (Fe ? " (" + Fe.message + ")" : ""));
      throw be.context = Fe, be;
    }
    var Be = ve[ze];
    if (Be === void 0)
      return !1;
    if (typeof Be == "function")
      g(Be, this, He);
    else
      for (var ke = Be.length, xe = L(Be, ke), Pe = 0; Pe < ke; ++Pe)
        g(xe[Pe], this, He);
    return !0;
  };
  function x(Se, ze, He, Pe) {
    var De, ve, Fe;
    if (B(He), ve = Se._events, ve === void 0 ? (ve = Se._events = /* @__PURE__ */ Object.create(null), Se._eventsCount = 0) : (ve.newListener !== void 0 && (Se.emit(
      "newListener",
      ze,
      He.listener ? He.listener : He
    ), ve = Se._events), Fe = ve[ze]), Fe === void 0)
      Fe = ve[ze] = He, ++Se._eventsCount;
    else if (typeof Fe == "function" ? Fe = ve[ze] = Pe ? [He, Fe] : [Fe, He] : Pe ? Fe.unshift(He) : Fe.push(He), De = D(Se), De > 0 && Fe.length > De && !Fe.warned) {
      Fe.warned = !0;
      var be = new Error("Possible EventEmitter memory leak detected. " + Fe.length + " " + String(ze) + " listeners added. Use emitter.setMaxListeners() to increase limit");
      be.name = "MaxListenersExceededWarning", be.emitter = Se, be.type = ze, be.count = Fe.length, y(be);
    }
    return Se;
  }
  d.prototype.addListener = function(ze, He) {
    return x(this, ze, He, !1);
  }, d.prototype.on = d.prototype.addListener, d.prototype.prependListener = function(ze, He) {
    return x(this, ze, He, !0);
  };
  function v() {
    if (!this.fired)
      return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
  }
  function F(Se, ze, He) {
    var Pe = { fired: !1, wrapFn: void 0, target: Se, type: ze, listener: He }, De = v.bind(Pe);
    return De.listener = He, Pe.wrapFn = De, De;
  }
  d.prototype.once = function(ze, He) {
    return B(He), this.on(ze, F(this, ze, He)), this;
  }, d.prototype.prependOnceListener = function(ze, He) {
    return B(He), this.prependListener(ze, F(this, ze, He)), this;
  }, d.prototype.removeListener = function(ze, He) {
    var Pe, De, ve, Fe, be;
    if (B(He), De = this._events, De === void 0)
      return this;
    if (Pe = De[ze], Pe === void 0)
      return this;
    if (Pe === He || Pe.listener === He)
      --this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete De[ze], De.removeListener && this.emit("removeListener", ze, Pe.listener || He));
    else if (typeof Pe != "function") {
      for (ve = -1, Fe = Pe.length - 1; Fe >= 0; Fe--)
        if (Pe[Fe] === He || Pe[Fe].listener === He) {
          be = Pe[Fe].listener, ve = Fe;
          break;
        }
      if (ve < 0)
        return this;
      ve === 0 ? Pe.shift() : H(Pe, ve), Pe.length === 1 && (De[ze] = Pe[0]), De.removeListener !== void 0 && this.emit("removeListener", ze, be || He);
    }
    return this;
  }, d.prototype.off = d.prototype.removeListener, d.prototype.removeAllListeners = function(ze) {
    var He, Pe, De;
    if (Pe = this._events, Pe === void 0)
      return this;
    if (Pe.removeListener === void 0)
      return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : Pe[ze] !== void 0 && (--this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete Pe[ze]), this;
    if (arguments.length === 0) {
      var ve = Object.keys(Pe), Fe;
      for (De = 0; De < ve.length; ++De)
        Fe = ve[De], Fe !== "removeListener" && this.removeAllListeners(Fe);
      return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
    }
    if (He = Pe[ze], typeof He == "function")
      this.removeListener(ze, He);
    else if (He !== void 0)
      for (De = He.length - 1; De >= 0; De--)
        this.removeListener(ze, He[De]);
    return this;
  };
  function M(Se, ze, He) {
    var Pe = Se._events;
    if (Pe === void 0)
      return [];
    var De = Pe[ze];
    return De === void 0 ? [] : typeof De == "function" ? He ? [De.listener || De] : [De] : He ? fe(De) : L(De, De.length);
  }
  d.prototype.listeners = function(ze) {
    return M(this, ze, !0);
  }, d.prototype.rawListeners = function(ze) {
    return M(this, ze, !1);
  }, d.listenerCount = function(Se, ze) {
    return typeof Se.listenerCount == "function" ? Se.listenerCount(ze) : U.call(Se, ze);
  }, d.prototype.listenerCount = U;
  function U(Se) {
    var ze = this._events;
    if (ze !== void 0) {
      var He = ze[Se];
      if (typeof He == "function")
        return 1;
      if (He !== void 0)
        return He.length;
    }
    return 0;
  }
  d.prototype.eventNames = function() {
    return this._eventsCount > 0 ? c(this._events) : [];
  };
  function L(Se, ze) {
    for (var He = new Array(ze), Pe = 0; Pe < ze; ++Pe)
      He[Pe] = Se[Pe];
    return He;
  }
  function H(Se, ze) {
    for (; ze + 1 < Se.length; ze++)
      Se[ze] = Se[ze + 1];
    Se.pop();
  }
  function fe(Se) {
    for (var ze = new Array(Se.length), He = 0; He < ze.length; ++He)
      ze[He] = Se[He].listener || Se[He];
    return ze;
  }
  function ge(Se, ze) {
    return new Promise(function(He, Pe) {
      function De(Fe) {
        Se.removeListener(ze, ve), Pe(Fe);
      }
      function ve() {
        typeof Se.removeListener == "function" && Se.removeListener("error", De), He([].slice.call(arguments));
      }
      Ee(Se, ze, ve, { once: !0 }), ze !== "error" && Ie(Se, De, { once: !0 });
    });
  }
  function Ie(Se, ze, He) {
    typeof Se.on == "function" && Ee(Se, "error", ze, He);
  }
  function Ee(Se, ze, He, Pe) {
    if (typeof Se.on == "function")
      Pe.once ? Se.once(ze, He) : Se.on(ze, He);
    else if (typeof Se.addEventListener == "function")
      Se.addEventListener(ze, function De(ve) {
        Pe.once && Se.removeEventListener(ze, De), He(ve);
      });
    else
      throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof Se);
  }
  return events.exports;
}
var streamBrowser$1, hasRequiredStreamBrowser$1;
function requireStreamBrowser$1() {
  return hasRequiredStreamBrowser$1 || (hasRequiredStreamBrowser$1 = 1, streamBrowser$1 = requireEvents().EventEmitter), streamBrowser$1;
}
const __viteBrowserExternal = {}, __viteBrowserExternal$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: __viteBrowserExternal
}, Symbol.toStringTag, { value: "Module" })), require$$2$2 = /* @__PURE__ */ getAugmentedNamespace(__viteBrowserExternal$1);
var buffer_list, hasRequiredBuffer_list;
function requireBuffer_list() {
  if (hasRequiredBuffer_list) return buffer_list;
  hasRequiredBuffer_list = 1;
  function o(L, H) {
    var fe = Object.keys(L);
    if (Object.getOwnPropertySymbols) {
      var ge = Object.getOwnPropertySymbols(L);
      H && (ge = ge.filter(function(Ie) {
        return Object.getOwnPropertyDescriptor(L, Ie).enumerable;
      })), fe.push.apply(fe, ge);
    }
    return fe;
  }
  function g(L) {
    for (var H = 1; H < arguments.length; H++) {
      var fe = arguments[H] != null ? arguments[H] : {};
      H % 2 ? o(Object(fe), !0).forEach(function(ge) {
        c(L, ge, fe[ge]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(L, Object.getOwnPropertyDescriptors(fe)) : o(Object(fe)).forEach(function(ge) {
        Object.defineProperty(L, ge, Object.getOwnPropertyDescriptor(fe, ge));
      });
    }
    return L;
  }
  function c(L, H, fe) {
    return H = E(H), H in L ? Object.defineProperty(L, H, { value: fe, enumerable: !0, configurable: !0, writable: !0 }) : L[H] = fe, L;
  }
  function y(L, H) {
    if (!(L instanceof H))
      throw new TypeError("Cannot call a class as a function");
  }
  function t(L, H) {
    for (var fe = 0; fe < H.length; fe++) {
      var ge = H[fe];
      ge.enumerable = ge.enumerable || !1, ge.configurable = !0, "value" in ge && (ge.writable = !0), Object.defineProperty(L, E(ge.key), ge);
    }
  }
  function d(L, H, fe) {
    return H && t(L.prototype, H), Object.defineProperty(L, "prototype", { writable: !1 }), L;
  }
  function E(L) {
    var H = B(L, "string");
    return typeof H == "symbol" ? H : String(H);
  }
  function B(L, H) {
    if (typeof L != "object" || L === null) return L;
    var fe = L[Symbol.toPrimitive];
    if (fe !== void 0) {
      var ge = fe.call(L, H);
      if (typeof ge != "object") return ge;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return String(L);
  }
  var D = requireBuffer$2(), x = D.Buffer, v = require$$2$2, F = v.inspect, M = F && F.custom || "inspect";
  function U(L, H, fe) {
    x.prototype.copy.call(L, H, fe);
  }
  return buffer_list = /* @__PURE__ */ function() {
    function L() {
      y(this, L), this.head = null, this.tail = null, this.length = 0;
    }
    return d(L, [{
      key: "push",
      value: function(fe) {
        var ge = {
          data: fe,
          next: null
        };
        this.length > 0 ? this.tail.next = ge : this.head = ge, this.tail = ge, ++this.length;
      }
    }, {
      key: "unshift",
      value: function(fe) {
        var ge = {
          data: fe,
          next: this.head
        };
        this.length === 0 && (this.tail = ge), this.head = ge, ++this.length;
      }
    }, {
      key: "shift",
      value: function() {
        if (this.length !== 0) {
          var fe = this.head.data;
          return this.length === 1 ? this.head = this.tail = null : this.head = this.head.next, --this.length, fe;
        }
      }
    }, {
      key: "clear",
      value: function() {
        this.head = this.tail = null, this.length = 0;
      }
    }, {
      key: "join",
      value: function(fe) {
        if (this.length === 0) return "";
        for (var ge = this.head, Ie = "" + ge.data; ge = ge.next; ) Ie += fe + ge.data;
        return Ie;
      }
    }, {
      key: "concat",
      value: function(fe) {
        if (this.length === 0) return x.alloc(0);
        for (var ge = x.allocUnsafe(fe >>> 0), Ie = this.head, Ee = 0; Ie; )
          U(Ie.data, ge, Ee), Ee += Ie.data.length, Ie = Ie.next;
        return ge;
      }
      // Consumes a specified amount of bytes or characters from the buffered data.
    }, {
      key: "consume",
      value: function(fe, ge) {
        var Ie;
        return fe < this.head.data.length ? (Ie = this.head.data.slice(0, fe), this.head.data = this.head.data.slice(fe)) : fe === this.head.data.length ? Ie = this.shift() : Ie = ge ? this._getString(fe) : this._getBuffer(fe), Ie;
      }
    }, {
      key: "first",
      value: function() {
        return this.head.data;
      }
      // Consumes a specified amount of characters from the buffered data.
    }, {
      key: "_getString",
      value: function(fe) {
        var ge = this.head, Ie = 1, Ee = ge.data;
        for (fe -= Ee.length; ge = ge.next; ) {
          var Se = ge.data, ze = fe > Se.length ? Se.length : fe;
          if (ze === Se.length ? Ee += Se : Ee += Se.slice(0, fe), fe -= ze, fe === 0) {
            ze === Se.length ? (++Ie, ge.next ? this.head = ge.next : this.head = this.tail = null) : (this.head = ge, ge.data = Se.slice(ze));
            break;
          }
          ++Ie;
        }
        return this.length -= Ie, Ee;
      }
      // Consumes a specified amount of bytes from the buffered data.
    }, {
      key: "_getBuffer",
      value: function(fe) {
        var ge = x.allocUnsafe(fe), Ie = this.head, Ee = 1;
        for (Ie.data.copy(ge), fe -= Ie.data.length; Ie = Ie.next; ) {
          var Se = Ie.data, ze = fe > Se.length ? Se.length : fe;
          if (Se.copy(ge, ge.length - fe, 0, ze), fe -= ze, fe === 0) {
            ze === Se.length ? (++Ee, Ie.next ? this.head = Ie.next : this.head = this.tail = null) : (this.head = Ie, Ie.data = Se.slice(ze));
            break;
          }
          ++Ee;
        }
        return this.length -= Ee, ge;
      }
      // Make sure the linked list only shows the minimal necessary information.
    }, {
      key: M,
      value: function(fe, ge) {
        return F(this, g(g({}, ge), {}, {
          // Only inspect one level.
          depth: 0,
          // It should not recurse.
          customInspect: !1
        }));
      }
    }]), L;
  }(), buffer_list;
}
var destroy_1$1, hasRequiredDestroy$1;
function requireDestroy$1() {
  if (hasRequiredDestroy$1) return destroy_1$1;
  hasRequiredDestroy$1 = 1;
  function o(E, B) {
    var D = this, x = this._readableState && this._readableState.destroyed, v = this._writableState && this._writableState.destroyed;
    return x || v ? (B ? B(E) : E && (this._writableState ? this._writableState.errorEmitted || (this._writableState.errorEmitted = !0, process$1.nextTick(t, this, E)) : process$1.nextTick(t, this, E)), this) : (this._readableState && (this._readableState.destroyed = !0), this._writableState && (this._writableState.destroyed = !0), this._destroy(E || null, function(F) {
      !B && F ? D._writableState ? D._writableState.errorEmitted ? process$1.nextTick(c, D) : (D._writableState.errorEmitted = !0, process$1.nextTick(g, D, F)) : process$1.nextTick(g, D, F) : B ? (process$1.nextTick(c, D), B(F)) : process$1.nextTick(c, D);
    }), this);
  }
  function g(E, B) {
    t(E, B), c(E);
  }
  function c(E) {
    E._writableState && !E._writableState.emitClose || E._readableState && !E._readableState.emitClose || E.emit("close");
  }
  function y() {
    this._readableState && (this._readableState.destroyed = !1, this._readableState.reading = !1, this._readableState.ended = !1, this._readableState.endEmitted = !1), this._writableState && (this._writableState.destroyed = !1, this._writableState.ended = !1, this._writableState.ending = !1, this._writableState.finalCalled = !1, this._writableState.prefinished = !1, this._writableState.finished = !1, this._writableState.errorEmitted = !1);
  }
  function t(E, B) {
    E.emit("error", B);
  }
  function d(E, B) {
    var D = E._readableState, x = E._writableState;
    D && D.autoDestroy || x && x.autoDestroy ? E.destroy(B) : E.emit("error", B);
  }
  return destroy_1$1 = {
    destroy: o,
    undestroy: y,
    errorOrDestroy: d
  }, destroy_1$1;
}
var errorsBrowser = {}, hasRequiredErrorsBrowser;
function requireErrorsBrowser() {
  if (hasRequiredErrorsBrowser) return errorsBrowser;
  hasRequiredErrorsBrowser = 1;
  function o(B, D) {
    B.prototype = Object.create(D.prototype), B.prototype.constructor = B, B.__proto__ = D;
  }
  var g = {};
  function c(B, D, x) {
    x || (x = Error);
    function v(M, U, L) {
      return typeof D == "string" ? D : D(M, U, L);
    }
    var F = /* @__PURE__ */ function(M) {
      o(U, M);
      function U(L, H, fe) {
        return M.call(this, v(L, H, fe)) || this;
      }
      return U;
    }(x);
    F.prototype.name = x.name, F.prototype.code = B, g[B] = F;
  }
  function y(B, D) {
    if (Array.isArray(B)) {
      var x = B.length;
      return B = B.map(function(v) {
        return String(v);
      }), x > 2 ? "one of ".concat(D, " ").concat(B.slice(0, x - 1).join(", "), ", or ") + B[x - 1] : x === 2 ? "one of ".concat(D, " ").concat(B[0], " or ").concat(B[1]) : "of ".concat(D, " ").concat(B[0]);
    } else
      return "of ".concat(D, " ").concat(String(B));
  }
  function t(B, D, x) {
    return B.substr(0, D.length) === D;
  }
  function d(B, D, x) {
    return (x === void 0 || x > B.length) && (x = B.length), B.substring(x - D.length, x) === D;
  }
  function E(B, D, x) {
    return typeof x != "number" && (x = 0), x + D.length > B.length ? !1 : B.indexOf(D, x) !== -1;
  }
  return c("ERR_INVALID_OPT_VALUE", function(B, D) {
    return 'The value "' + D + '" is invalid for option "' + B + '"';
  }, TypeError), c("ERR_INVALID_ARG_TYPE", function(B, D, x) {
    var v;
    typeof D == "string" && t(D, "not ") ? (v = "must not be", D = D.replace(/^not /, "")) : v = "must be";
    var F;
    if (d(B, " argument"))
      F = "The ".concat(B, " ").concat(v, " ").concat(y(D, "type"));
    else {
      var M = E(B, ".") ? "property" : "argument";
      F = 'The "'.concat(B, '" ').concat(M, " ").concat(v, " ").concat(y(D, "type"));
    }
    return F += ". Received type ".concat(typeof x), F;
  }, TypeError), c("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF"), c("ERR_METHOD_NOT_IMPLEMENTED", function(B) {
    return "The " + B + " method is not implemented";
  }), c("ERR_STREAM_PREMATURE_CLOSE", "Premature close"), c("ERR_STREAM_DESTROYED", function(B) {
    return "Cannot call " + B + " after a stream was destroyed";
  }), c("ERR_MULTIPLE_CALLBACK", "Callback called multiple times"), c("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable"), c("ERR_STREAM_WRITE_AFTER_END", "write after end"), c("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError), c("ERR_UNKNOWN_ENCODING", function(B) {
    return "Unknown encoding: " + B;
  }, TypeError), c("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event"), errorsBrowser.codes = g, errorsBrowser;
}
var state, hasRequiredState;
function requireState() {
  if (hasRequiredState) return state;
  hasRequiredState = 1;
  var o = requireErrorsBrowser().codes.ERR_INVALID_OPT_VALUE;
  function g(y, t, d) {
    return y.highWaterMark != null ? y.highWaterMark : t ? y[d] : null;
  }
  function c(y, t, d, E) {
    var B = g(t, E, d);
    if (B != null) {
      if (!(isFinite(B) && Math.floor(B) === B) || B < 0) {
        var D = E ? d : "highWaterMark";
        throw new o(D, B);
      }
      return Math.floor(B);
    }
    return y.objectMode ? 16 : 16 * 1024;
  }
  return state = {
    getHighWaterMark: c
  }, state;
}
var browser$b, hasRequiredBrowser$b;
function requireBrowser$b() {
  if (hasRequiredBrowser$b) return browser$b;
  hasRequiredBrowser$b = 1, browser$b = o;
  function o(c, y) {
    if (g("noDeprecation"))
      return c;
    var t = !1;
    function d() {
      if (!t) {
        if (g("throwDeprecation"))
          throw new Error(y);
        g("traceDeprecation") ? console.trace(y) : console.warn(y), t = !0;
      }
      return c.apply(this, arguments);
    }
    return d;
  }
  function g(c) {
    try {
      if (!commonjsGlobal.localStorage) return !1;
    } catch {
      return !1;
    }
    var y = commonjsGlobal.localStorage[c];
    return y == null ? !1 : String(y).toLowerCase() === "true";
  }
  return browser$b;
}
var _stream_writable$1, hasRequired_stream_writable$1;
function require_stream_writable$1() {
  if (hasRequired_stream_writable$1) return _stream_writable$1;
  hasRequired_stream_writable$1 = 1, _stream_writable$1 = De;
  function o(Mr) {
    var Dr = this;
    this.next = null, this.entry = null, this.finish = function() {
      qr(Dr, Mr);
    };
  }
  var g;
  De.WritableState = He;
  var c = {
    deprecate: requireBrowser$b()
  }, y = requireStreamBrowser$1(), t = requireBuffer$2().Buffer, d = (typeof commonjsGlobal < "u" ? commonjsGlobal : typeof window < "u" ? window : typeof self < "u" ? self : {}).Uint8Array || function() {
  };
  function E(Mr) {
    return t.from(Mr);
  }
  function B(Mr) {
    return t.isBuffer(Mr) || Mr instanceof d;
  }
  var D = requireDestroy$1(), x = requireState(), v = x.getHighWaterMark, F = requireErrorsBrowser().codes, M = F.ERR_INVALID_ARG_TYPE, U = F.ERR_METHOD_NOT_IMPLEMENTED, L = F.ERR_MULTIPLE_CALLBACK, H = F.ERR_STREAM_CANNOT_PIPE, fe = F.ERR_STREAM_DESTROYED, ge = F.ERR_STREAM_NULL_VALUES, Ie = F.ERR_STREAM_WRITE_AFTER_END, Ee = F.ERR_UNKNOWN_ENCODING, Se = D.errorOrDestroy;
  requireInherits_browser()(De, y);
  function ze() {
  }
  function He(Mr, Dr, Qr) {
    g = g || require_stream_duplex$1(), Mr = Mr || {}, typeof Qr != "boolean" && (Qr = Dr instanceof g), this.objectMode = !!Mr.objectMode, Qr && (this.objectMode = this.objectMode || !!Mr.writableObjectMode), this.highWaterMark = v(this, Mr, "writableHighWaterMark", Qr), this.finalCalled = !1, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1, this.destroyed = !1;
    var Xr = Mr.decodeStrings === !1;
    this.decodeStrings = !Xr, this.defaultEncoding = Mr.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function(Vr) {
      Et(Dr, Vr);
    }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = !1, this.errorEmitted = !1, this.emitClose = Mr.emitClose !== !1, this.autoDestroy = !!Mr.autoDestroy, this.bufferedRequestCount = 0, this.corkedRequestsFree = new o(this);
  }
  He.prototype.getBuffer = function() {
    for (var Dr = this.bufferedRequest, Qr = []; Dr; )
      Qr.push(Dr), Dr = Dr.next;
    return Qr;
  }, function() {
    try {
      Object.defineProperty(He.prototype, "buffer", {
        get: c.deprecate(function() {
          return this.getBuffer();
        }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
      });
    } catch {
    }
  }();
  var Pe;
  typeof Symbol == "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] == "function" ? (Pe = Function.prototype[Symbol.hasInstance], Object.defineProperty(De, Symbol.hasInstance, {
    value: function(Dr) {
      return Pe.call(this, Dr) ? !0 : this !== De ? !1 : Dr && Dr._writableState instanceof He;
    }
  })) : Pe = function(Dr) {
    return Dr instanceof this;
  };
  function De(Mr) {
    g = g || require_stream_duplex$1();
    var Dr = this instanceof g;
    if (!Dr && !Pe.call(De, this)) return new De(Mr);
    this._writableState = new He(Mr, this, Dr), this.writable = !0, Mr && (typeof Mr.write == "function" && (this._write = Mr.write), typeof Mr.writev == "function" && (this._writev = Mr.writev), typeof Mr.destroy == "function" && (this._destroy = Mr.destroy), typeof Mr.final == "function" && (this._final = Mr.final)), y.call(this);
  }
  De.prototype.pipe = function() {
    Se(this, new H());
  };
  function ve(Mr, Dr) {
    var Qr = new Ie();
    Se(Mr, Qr), process$1.nextTick(Dr, Qr);
  }
  function Fe(Mr, Dr, Qr, Xr) {
    var Vr;
    return Qr === null ? Vr = new ge() : typeof Qr != "string" && !Dr.objectMode && (Vr = new M("chunk", ["string", "Buffer"], Qr)), Vr ? (Se(Mr, Vr), process$1.nextTick(Xr, Vr), !1) : !0;
  }
  De.prototype.write = function(Mr, Dr, Qr) {
    var Xr = this._writableState, Vr = !1, Ur = !Xr.objectMode && B(Mr);
    return Ur && !t.isBuffer(Mr) && (Mr = E(Mr)), typeof Dr == "function" && (Qr = Dr, Dr = null), Ur ? Dr = "buffer" : Dr || (Dr = Xr.defaultEncoding), typeof Qr != "function" && (Qr = ze), Xr.ending ? ve(this, Qr) : (Ur || Fe(this, Xr, Mr, Qr)) && (Xr.pendingcb++, Vr = Be(this, Xr, Ur, Mr, Dr, Qr)), Vr;
  }, De.prototype.cork = function() {
    this._writableState.corked++;
  }, De.prototype.uncork = function() {
    var Mr = this._writableState;
    Mr.corked && (Mr.corked--, !Mr.writing && !Mr.corked && !Mr.bufferProcessing && Mr.bufferedRequest && er(this, Mr));
  }, De.prototype.setDefaultEncoding = function(Dr) {
    if (typeof Dr == "string" && (Dr = Dr.toLowerCase()), !(["hex", "utf8", "utf-8", "ascii", "binary", "base64", "ucs2", "ucs-2", "utf16le", "utf-16le", "raw"].indexOf((Dr + "").toLowerCase()) > -1)) throw new Ee(Dr);
    return this._writableState.defaultEncoding = Dr, this;
  }, Object.defineProperty(De.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState && this._writableState.getBuffer();
    }
  });
  function be(Mr, Dr, Qr) {
    return !Mr.objectMode && Mr.decodeStrings !== !1 && typeof Dr == "string" && (Dr = t.from(Dr, Qr)), Dr;
  }
  Object.defineProperty(De.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.highWaterMark;
    }
  });
  function Be(Mr, Dr, Qr, Xr, Vr, Ur) {
    if (!Qr) {
      var Sr = be(Dr, Xr, Vr);
      Xr !== Sr && (Qr = !0, Vr = "buffer", Xr = Sr);
    }
    var Gr = Dr.objectMode ? 1 : Xr.length;
    Dr.length += Gr;
    var Fr = Dr.length < Dr.highWaterMark;
    if (Fr || (Dr.needDrain = !0), Dr.writing || Dr.corked) {
      var br = Dr.lastBufferedRequest;
      Dr.lastBufferedRequest = {
        chunk: Xr,
        encoding: Vr,
        isBuf: Qr,
        callback: Ur,
        next: null
      }, br ? br.next = Dr.lastBufferedRequest : Dr.bufferedRequest = Dr.lastBufferedRequest, Dr.bufferedRequestCount += 1;
    } else
      ke(Mr, Dr, !1, Gr, Xr, Vr, Ur);
    return Fr;
  }
  function ke(Mr, Dr, Qr, Xr, Vr, Ur, Sr) {
    Dr.writelen = Xr, Dr.writecb = Sr, Dr.writing = !0, Dr.sync = !0, Dr.destroyed ? Dr.onwrite(new fe("write")) : Qr ? Mr._writev(Vr, Dr.onwrite) : Mr._write(Vr, Ur, Dr.onwrite), Dr.sync = !1;
  }
  function xe(Mr, Dr, Qr, Xr, Vr) {
    --Dr.pendingcb, Qr ? (process$1.nextTick(Vr, Xr), process$1.nextTick(yr, Mr, Dr), Mr._writableState.errorEmitted = !0, Se(Mr, Xr)) : (Vr(Xr), Mr._writableState.errorEmitted = !0, Se(Mr, Xr), yr(Mr, Dr));
  }
  function Ne(Mr) {
    Mr.writing = !1, Mr.writecb = null, Mr.length -= Mr.writelen, Mr.writelen = 0;
  }
  function Et(Mr, Dr) {
    var Qr = Mr._writableState, Xr = Qr.sync, Vr = Qr.writecb;
    if (typeof Vr != "function") throw new L();
    if (Ne(Qr), Dr) xe(Mr, Qr, Xr, Dr, Vr);
    else {
      var Ur = xt(Qr) || Mr.destroyed;
      !Ur && !Qr.corked && !Qr.bufferProcessing && Qr.bufferedRequest && er(Mr, Qr), Xr ? process$1.nextTick(st, Mr, Qr, Ur, Vr) : st(Mr, Qr, Ur, Vr);
    }
  }
  function st(Mr, Dr, Qr, Xr) {
    Qr || Dt(Mr, Dr), Dr.pendingcb--, Xr(), yr(Mr, Dr);
  }
  function Dt(Mr, Dr) {
    Dr.length === 0 && Dr.needDrain && (Dr.needDrain = !1, Mr.emit("drain"));
  }
  function er(Mr, Dr) {
    Dr.bufferProcessing = !0;
    var Qr = Dr.bufferedRequest;
    if (Mr._writev && Qr && Qr.next) {
      var Xr = Dr.bufferedRequestCount, Vr = new Array(Xr), Ur = Dr.corkedRequestsFree;
      Ur.entry = Qr;
      for (var Sr = 0, Gr = !0; Qr; )
        Vr[Sr] = Qr, Qr.isBuf || (Gr = !1), Qr = Qr.next, Sr += 1;
      Vr.allBuffers = Gr, ke(Mr, Dr, !0, Dr.length, Vr, "", Ur.finish), Dr.pendingcb++, Dr.lastBufferedRequest = null, Ur.next ? (Dr.corkedRequestsFree = Ur.next, Ur.next = null) : Dr.corkedRequestsFree = new o(Dr), Dr.bufferedRequestCount = 0;
    } else {
      for (; Qr; ) {
        var Fr = Qr.chunk, br = Qr.encoding, Ar = Qr.callback, cr = Dr.objectMode ? 1 : Fr.length;
        if (ke(Mr, Dr, !1, cr, Fr, br, Ar), Qr = Qr.next, Dr.bufferedRequestCount--, Dr.writing)
          break;
      }
      Qr === null && (Dr.lastBufferedRequest = null);
    }
    Dr.bufferedRequest = Qr, Dr.bufferProcessing = !1;
  }
  De.prototype._write = function(Mr, Dr, Qr) {
    Qr(new U("_write()"));
  }, De.prototype._writev = null, De.prototype.end = function(Mr, Dr, Qr) {
    var Xr = this._writableState;
    return typeof Mr == "function" ? (Qr = Mr, Mr = null, Dr = null) : typeof Dr == "function" && (Qr = Dr, Dr = null), Mr != null && this.write(Mr, Dr), Xr.corked && (Xr.corked = 1, this.uncork()), Xr.ending || wr(this, Xr, Qr), this;
  }, Object.defineProperty(De.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.length;
    }
  });
  function xt(Mr) {
    return Mr.ending && Mr.length === 0 && Mr.bufferedRequest === null && !Mr.finished && !Mr.writing;
  }
  function ir(Mr, Dr) {
    Mr._final(function(Qr) {
      Dr.pendingcb--, Qr && Se(Mr, Qr), Dr.prefinished = !0, Mr.emit("prefinish"), yr(Mr, Dr);
    });
  }
  function sr(Mr, Dr) {
    !Dr.prefinished && !Dr.finalCalled && (typeof Mr._final == "function" && !Dr.destroyed ? (Dr.pendingcb++, Dr.finalCalled = !0, process$1.nextTick(ir, Mr, Dr)) : (Dr.prefinished = !0, Mr.emit("prefinish")));
  }
  function yr(Mr, Dr) {
    var Qr = xt(Dr);
    if (Qr && (sr(Mr, Dr), Dr.pendingcb === 0 && (Dr.finished = !0, Mr.emit("finish"), Dr.autoDestroy))) {
      var Xr = Mr._readableState;
      (!Xr || Xr.autoDestroy && Xr.endEmitted) && Mr.destroy();
    }
    return Qr;
  }
  function wr(Mr, Dr, Qr) {
    Dr.ending = !0, yr(Mr, Dr), Qr && (Dr.finished ? process$1.nextTick(Qr) : Mr.once("finish", Qr)), Dr.ended = !0, Mr.writable = !1;
  }
  function qr(Mr, Dr, Qr) {
    var Xr = Mr.entry;
    for (Mr.entry = null; Xr; ) {
      var Vr = Xr.callback;
      Dr.pendingcb--, Vr(Qr), Xr = Xr.next;
    }
    Dr.corkedRequestsFree.next = Mr;
  }
  return Object.defineProperty(De.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState === void 0 ? !1 : this._writableState.destroyed;
    },
    set: function(Dr) {
      this._writableState && (this._writableState.destroyed = Dr);
    }
  }), De.prototype.destroy = D.destroy, De.prototype._undestroy = D.undestroy, De.prototype._destroy = function(Mr, Dr) {
    Dr(Mr);
  }, _stream_writable$1;
}
var _stream_duplex$1, hasRequired_stream_duplex$1;
function require_stream_duplex$1() {
  if (hasRequired_stream_duplex$1) return _stream_duplex$1;
  hasRequired_stream_duplex$1 = 1;
  var o = Object.keys || function(x) {
    var v = [];
    for (var F in x) v.push(F);
    return v;
  };
  _stream_duplex$1 = E;
  var g = require_stream_readable$1(), c = require_stream_writable$1();
  requireInherits_browser()(E, g);
  for (var y = o(c.prototype), t = 0; t < y.length; t++) {
    var d = y[t];
    E.prototype[d] || (E.prototype[d] = c.prototype[d]);
  }
  function E(x) {
    if (!(this instanceof E)) return new E(x);
    g.call(this, x), c.call(this, x), this.allowHalfOpen = !0, x && (x.readable === !1 && (this.readable = !1), x.writable === !1 && (this.writable = !1), x.allowHalfOpen === !1 && (this.allowHalfOpen = !1, this.once("end", B)));
  }
  Object.defineProperty(E.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.highWaterMark;
    }
  }), Object.defineProperty(E.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState && this._writableState.getBuffer();
    }
  }), Object.defineProperty(E.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.length;
    }
  });
  function B() {
    this._writableState.ended || process$1.nextTick(D, this);
  }
  function D(x) {
    x.end();
  }
  return Object.defineProperty(E.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState === void 0 || this._writableState === void 0 ? !1 : this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function(v) {
      this._readableState === void 0 || this._writableState === void 0 || (this._readableState.destroyed = v, this._writableState.destroyed = v);
    }
  }), _stream_duplex$1;
}
var string_decoder$1 = {}, hasRequiredString_decoder$1;
function requireString_decoder$1() {
  if (hasRequiredString_decoder$1) return string_decoder$1;
  hasRequiredString_decoder$1 = 1;
  var o = requireSafeBuffer$1().Buffer, g = o.isEncoding || function(ge) {
    switch (ge = "" + ge, ge && ge.toLowerCase()) {
      case "hex":
      case "utf8":
      case "utf-8":
      case "ascii":
      case "binary":
      case "base64":
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
      case "raw":
        return !0;
      default:
        return !1;
    }
  };
  function c(ge) {
    if (!ge) return "utf8";
    for (var Ie; ; )
      switch (ge) {
        case "utf8":
        case "utf-8":
          return "utf8";
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return "utf16le";
        case "latin1":
        case "binary":
          return "latin1";
        case "base64":
        case "ascii":
        case "hex":
          return ge;
        default:
          if (Ie) return;
          ge = ("" + ge).toLowerCase(), Ie = !0;
      }
  }
  function y(ge) {
    var Ie = c(ge);
    if (typeof Ie != "string" && (o.isEncoding === g || !g(ge))) throw new Error("Unknown encoding: " + ge);
    return Ie || ge;
  }
  string_decoder$1.StringDecoder = t;
  function t(ge) {
    this.encoding = y(ge);
    var Ie;
    switch (this.encoding) {
      case "utf16le":
        this.text = F, this.end = M, Ie = 4;
        break;
      case "utf8":
        this.fillLast = D, Ie = 4;
        break;
      case "base64":
        this.text = U, this.end = L, Ie = 3;
        break;
      default:
        this.write = H, this.end = fe;
        return;
    }
    this.lastNeed = 0, this.lastTotal = 0, this.lastChar = o.allocUnsafe(Ie);
  }
  t.prototype.write = function(ge) {
    if (ge.length === 0) return "";
    var Ie, Ee;
    if (this.lastNeed) {
      if (Ie = this.fillLast(ge), Ie === void 0) return "";
      Ee = this.lastNeed, this.lastNeed = 0;
    } else
      Ee = 0;
    return Ee < ge.length ? Ie ? Ie + this.text(ge, Ee) : this.text(ge, Ee) : Ie || "";
  }, t.prototype.end = v, t.prototype.text = x, t.prototype.fillLast = function(ge) {
    if (this.lastNeed <= ge.length)
      return ge.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
    ge.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, ge.length), this.lastNeed -= ge.length;
  };
  function d(ge) {
    return ge <= 127 ? 0 : ge >> 5 === 6 ? 2 : ge >> 4 === 14 ? 3 : ge >> 3 === 30 ? 4 : ge >> 6 === 2 ? -1 : -2;
  }
  function E(ge, Ie, Ee) {
    var Se = Ie.length - 1;
    if (Se < Ee) return 0;
    var ze = d(Ie[Se]);
    return ze >= 0 ? (ze > 0 && (ge.lastNeed = ze - 1), ze) : --Se < Ee || ze === -2 ? 0 : (ze = d(Ie[Se]), ze >= 0 ? (ze > 0 && (ge.lastNeed = ze - 2), ze) : --Se < Ee || ze === -2 ? 0 : (ze = d(Ie[Se]), ze >= 0 ? (ze > 0 && (ze === 2 ? ze = 0 : ge.lastNeed = ze - 3), ze) : 0));
  }
  function B(ge, Ie, Ee) {
    if ((Ie[0] & 192) !== 128)
      return ge.lastNeed = 0, "�";
    if (ge.lastNeed > 1 && Ie.length > 1) {
      if ((Ie[1] & 192) !== 128)
        return ge.lastNeed = 1, "�";
      if (ge.lastNeed > 2 && Ie.length > 2 && (Ie[2] & 192) !== 128)
        return ge.lastNeed = 2, "�";
    }
  }
  function D(ge) {
    var Ie = this.lastTotal - this.lastNeed, Ee = B(this, ge);
    if (Ee !== void 0) return Ee;
    if (this.lastNeed <= ge.length)
      return ge.copy(this.lastChar, Ie, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
    ge.copy(this.lastChar, Ie, 0, ge.length), this.lastNeed -= ge.length;
  }
  function x(ge, Ie) {
    var Ee = E(this, ge, Ie);
    if (!this.lastNeed) return ge.toString("utf8", Ie);
    this.lastTotal = Ee;
    var Se = ge.length - (Ee - this.lastNeed);
    return ge.copy(this.lastChar, 0, Se), ge.toString("utf8", Ie, Se);
  }
  function v(ge) {
    var Ie = ge && ge.length ? this.write(ge) : "";
    return this.lastNeed ? Ie + "�" : Ie;
  }
  function F(ge, Ie) {
    if ((ge.length - Ie) % 2 === 0) {
      var Ee = ge.toString("utf16le", Ie);
      if (Ee) {
        var Se = Ee.charCodeAt(Ee.length - 1);
        if (Se >= 55296 && Se <= 56319)
          return this.lastNeed = 2, this.lastTotal = 4, this.lastChar[0] = ge[ge.length - 2], this.lastChar[1] = ge[ge.length - 1], Ee.slice(0, -1);
      }
      return Ee;
    }
    return this.lastNeed = 1, this.lastTotal = 2, this.lastChar[0] = ge[ge.length - 1], ge.toString("utf16le", Ie, ge.length - 1);
  }
  function M(ge) {
    var Ie = ge && ge.length ? this.write(ge) : "";
    if (this.lastNeed) {
      var Ee = this.lastTotal - this.lastNeed;
      return Ie + this.lastChar.toString("utf16le", 0, Ee);
    }
    return Ie;
  }
  function U(ge, Ie) {
    var Ee = (ge.length - Ie) % 3;
    return Ee === 0 ? ge.toString("base64", Ie) : (this.lastNeed = 3 - Ee, this.lastTotal = 3, Ee === 1 ? this.lastChar[0] = ge[ge.length - 1] : (this.lastChar[0] = ge[ge.length - 2], this.lastChar[1] = ge[ge.length - 1]), ge.toString("base64", Ie, ge.length - Ee));
  }
  function L(ge) {
    var Ie = ge && ge.length ? this.write(ge) : "";
    return this.lastNeed ? Ie + this.lastChar.toString("base64", 0, 3 - this.lastNeed) : Ie;
  }
  function H(ge) {
    return ge.toString(this.encoding);
  }
  function fe(ge) {
    return ge && ge.length ? this.write(ge) : "";
  }
  return string_decoder$1;
}
var endOfStream, hasRequiredEndOfStream;
function requireEndOfStream() {
  if (hasRequiredEndOfStream) return endOfStream;
  hasRequiredEndOfStream = 1;
  var o = requireErrorsBrowser().codes.ERR_STREAM_PREMATURE_CLOSE;
  function g(d) {
    var E = !1;
    return function() {
      if (!E) {
        E = !0;
        for (var B = arguments.length, D = new Array(B), x = 0; x < B; x++)
          D[x] = arguments[x];
        d.apply(this, D);
      }
    };
  }
  function c() {
  }
  function y(d) {
    return d.setHeader && typeof d.abort == "function";
  }
  function t(d, E, B) {
    if (typeof E == "function") return t(d, null, E);
    E || (E = {}), B = g(B || c);
    var D = E.readable || E.readable !== !1 && d.readable, x = E.writable || E.writable !== !1 && d.writable, v = function() {
      d.writable || M();
    }, F = d._writableState && d._writableState.finished, M = function() {
      x = !1, F = !0, D || B.call(d);
    }, U = d._readableState && d._readableState.endEmitted, L = function() {
      D = !1, U = !0, x || B.call(d);
    }, H = function(Ee) {
      B.call(d, Ee);
    }, fe = function() {
      var Ee;
      if (D && !U)
        return (!d._readableState || !d._readableState.ended) && (Ee = new o()), B.call(d, Ee);
      if (x && !F)
        return (!d._writableState || !d._writableState.ended) && (Ee = new o()), B.call(d, Ee);
    }, ge = function() {
      d.req.on("finish", M);
    };
    return y(d) ? (d.on("complete", M), d.on("abort", fe), d.req ? ge() : d.on("request", ge)) : x && !d._writableState && (d.on("end", v), d.on("close", v)), d.on("end", L), d.on("finish", M), E.error !== !1 && d.on("error", H), d.on("close", fe), function() {
      d.removeListener("complete", M), d.removeListener("abort", fe), d.removeListener("request", ge), d.req && d.req.removeListener("finish", M), d.removeListener("end", v), d.removeListener("close", v), d.removeListener("finish", M), d.removeListener("end", L), d.removeListener("error", H), d.removeListener("close", fe);
    };
  }
  return endOfStream = t, endOfStream;
}
var async_iterator, hasRequiredAsync_iterator;
function requireAsync_iterator() {
  if (hasRequiredAsync_iterator) return async_iterator;
  hasRequiredAsync_iterator = 1;
  var o;
  function g(Ee, Se, ze) {
    return Se = c(Se), Se in Ee ? Object.defineProperty(Ee, Se, { value: ze, enumerable: !0, configurable: !0, writable: !0 }) : Ee[Se] = ze, Ee;
  }
  function c(Ee) {
    var Se = y(Ee, "string");
    return typeof Se == "symbol" ? Se : String(Se);
  }
  function y(Ee, Se) {
    if (typeof Ee != "object" || Ee === null) return Ee;
    var ze = Ee[Symbol.toPrimitive];
    if (ze !== void 0) {
      var He = ze.call(Ee, Se);
      if (typeof He != "object") return He;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (Se === "string" ? String : Number)(Ee);
  }
  var t = requireEndOfStream(), d = Symbol("lastResolve"), E = Symbol("lastReject"), B = Symbol("error"), D = Symbol("ended"), x = Symbol("lastPromise"), v = Symbol("handlePromise"), F = Symbol("stream");
  function M(Ee, Se) {
    return {
      value: Ee,
      done: Se
    };
  }
  function U(Ee) {
    var Se = Ee[d];
    if (Se !== null) {
      var ze = Ee[F].read();
      ze !== null && (Ee[x] = null, Ee[d] = null, Ee[E] = null, Se(M(ze, !1)));
    }
  }
  function L(Ee) {
    process$1.nextTick(U, Ee);
  }
  function H(Ee, Se) {
    return function(ze, He) {
      Ee.then(function() {
        if (Se[D]) {
          ze(M(void 0, !0));
          return;
        }
        Se[v](ze, He);
      }, He);
    };
  }
  var fe = Object.getPrototypeOf(function() {
  }), ge = Object.setPrototypeOf((o = {
    get stream() {
      return this[F];
    },
    next: function() {
      var Se = this, ze = this[B];
      if (ze !== null)
        return Promise.reject(ze);
      if (this[D])
        return Promise.resolve(M(void 0, !0));
      if (this[F].destroyed)
        return new Promise(function(ve, Fe) {
          process$1.nextTick(function() {
            Se[B] ? Fe(Se[B]) : ve(M(void 0, !0));
          });
        });
      var He = this[x], Pe;
      if (He)
        Pe = new Promise(H(He, this));
      else {
        var De = this[F].read();
        if (De !== null)
          return Promise.resolve(M(De, !1));
        Pe = new Promise(this[v]);
      }
      return this[x] = Pe, Pe;
    }
  }, g(o, Symbol.asyncIterator, function() {
    return this;
  }), g(o, "return", function() {
    var Se = this;
    return new Promise(function(ze, He) {
      Se[F].destroy(null, function(Pe) {
        if (Pe) {
          He(Pe);
          return;
        }
        ze(M(void 0, !0));
      });
    });
  }), o), fe), Ie = function(Se) {
    var ze, He = Object.create(ge, (ze = {}, g(ze, F, {
      value: Se,
      writable: !0
    }), g(ze, d, {
      value: null,
      writable: !0
    }), g(ze, E, {
      value: null,
      writable: !0
    }), g(ze, B, {
      value: null,
      writable: !0
    }), g(ze, D, {
      value: Se._readableState.endEmitted,
      writable: !0
    }), g(ze, v, {
      value: function(De, ve) {
        var Fe = He[F].read();
        Fe ? (He[x] = null, He[d] = null, He[E] = null, De(M(Fe, !1))) : (He[d] = De, He[E] = ve);
      },
      writable: !0
    }), ze));
    return He[x] = null, t(Se, function(Pe) {
      if (Pe && Pe.code !== "ERR_STREAM_PREMATURE_CLOSE") {
        var De = He[E];
        De !== null && (He[x] = null, He[d] = null, He[E] = null, De(Pe)), He[B] = Pe;
        return;
      }
      var ve = He[d];
      ve !== null && (He[x] = null, He[d] = null, He[E] = null, ve(M(void 0, !0))), He[D] = !0;
    }), Se.on("readable", L.bind(null, He)), He;
  };
  return async_iterator = Ie, async_iterator;
}
var fromBrowser, hasRequiredFromBrowser;
function requireFromBrowser() {
  return hasRequiredFromBrowser || (hasRequiredFromBrowser = 1, fromBrowser = function() {
    throw new Error("Readable.from is not available in the browser");
  }), fromBrowser;
}
var _stream_readable$1, hasRequired_stream_readable$1;
function require_stream_readable$1() {
  if (hasRequired_stream_readable$1) return _stream_readable$1;
  hasRequired_stream_readable$1 = 1, _stream_readable$1 = ve;
  var o;
  ve.ReadableState = De, requireEvents().EventEmitter;
  var g = function(Sr, Gr) {
    return Sr.listeners(Gr).length;
  }, c = requireStreamBrowser$1(), y = requireBuffer$2().Buffer, t = (typeof commonjsGlobal < "u" ? commonjsGlobal : typeof window < "u" ? window : typeof self < "u" ? self : {}).Uint8Array || function() {
  };
  function d(Ur) {
    return y.from(Ur);
  }
  function E(Ur) {
    return y.isBuffer(Ur) || Ur instanceof t;
  }
  var B = require$$2$2, D;
  B && B.debuglog ? D = B.debuglog("stream") : D = function() {
  };
  var x = requireBuffer_list(), v = requireDestroy$1(), F = requireState(), M = F.getHighWaterMark, U = requireErrorsBrowser().codes, L = U.ERR_INVALID_ARG_TYPE, H = U.ERR_STREAM_PUSH_AFTER_EOF, fe = U.ERR_METHOD_NOT_IMPLEMENTED, ge = U.ERR_STREAM_UNSHIFT_AFTER_END_EVENT, Ie, Ee, Se;
  requireInherits_browser()(ve, c);
  var ze = v.errorOrDestroy, He = ["error", "close", "destroy", "pause", "resume"];
  function Pe(Ur, Sr, Gr) {
    if (typeof Ur.prependListener == "function") return Ur.prependListener(Sr, Gr);
    !Ur._events || !Ur._events[Sr] ? Ur.on(Sr, Gr) : Array.isArray(Ur._events[Sr]) ? Ur._events[Sr].unshift(Gr) : Ur._events[Sr] = [Gr, Ur._events[Sr]];
  }
  function De(Ur, Sr, Gr) {
    o = o || require_stream_duplex$1(), Ur = Ur || {}, typeof Gr != "boolean" && (Gr = Sr instanceof o), this.objectMode = !!Ur.objectMode, Gr && (this.objectMode = this.objectMode || !!Ur.readableObjectMode), this.highWaterMark = M(this, Ur, "readableHighWaterMark", Gr), this.buffer = new x(), this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.resumeScheduled = !1, this.paused = !0, this.emitClose = Ur.emitClose !== !1, this.autoDestroy = !!Ur.autoDestroy, this.destroyed = !1, this.defaultEncoding = Ur.defaultEncoding || "utf8", this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, Ur.encoding && (Ie || (Ie = requireString_decoder$1().StringDecoder), this.decoder = new Ie(Ur.encoding), this.encoding = Ur.encoding);
  }
  function ve(Ur) {
    if (o = o || require_stream_duplex$1(), !(this instanceof ve)) return new ve(Ur);
    var Sr = this instanceof o;
    this._readableState = new De(Ur, this, Sr), this.readable = !0, Ur && (typeof Ur.read == "function" && (this._read = Ur.read), typeof Ur.destroy == "function" && (this._destroy = Ur.destroy)), c.call(this);
  }
  Object.defineProperty(ve.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState === void 0 ? !1 : this._readableState.destroyed;
    },
    set: function(Sr) {
      this._readableState && (this._readableState.destroyed = Sr);
    }
  }), ve.prototype.destroy = v.destroy, ve.prototype._undestroy = v.undestroy, ve.prototype._destroy = function(Ur, Sr) {
    Sr(Ur);
  }, ve.prototype.push = function(Ur, Sr) {
    var Gr = this._readableState, Fr;
    return Gr.objectMode ? Fr = !0 : typeof Ur == "string" && (Sr = Sr || Gr.defaultEncoding, Sr !== Gr.encoding && (Ur = y.from(Ur, Sr), Sr = ""), Fr = !0), Fe(this, Ur, Sr, !1, Fr);
  }, ve.prototype.unshift = function(Ur) {
    return Fe(this, Ur, null, !0, !1);
  };
  function Fe(Ur, Sr, Gr, Fr, br) {
    D("readableAddChunk", Sr);
    var Ar = Ur._readableState;
    if (Sr === null)
      Ar.reading = !1, Et(Ur, Ar);
    else {
      var cr;
      if (br || (cr = Be(Ar, Sr)), cr)
        ze(Ur, cr);
      else if (Ar.objectMode || Sr && Sr.length > 0)
        if (typeof Sr != "string" && !Ar.objectMode && Object.getPrototypeOf(Sr) !== y.prototype && (Sr = d(Sr)), Fr)
          Ar.endEmitted ? ze(Ur, new ge()) : be(Ur, Ar, Sr, !0);
        else if (Ar.ended)
          ze(Ur, new H());
        else {
          if (Ar.destroyed)
            return !1;
          Ar.reading = !1, Ar.decoder && !Gr ? (Sr = Ar.decoder.write(Sr), Ar.objectMode || Sr.length !== 0 ? be(Ur, Ar, Sr, !1) : er(Ur, Ar)) : be(Ur, Ar, Sr, !1);
        }
      else Fr || (Ar.reading = !1, er(Ur, Ar));
    }
    return !Ar.ended && (Ar.length < Ar.highWaterMark || Ar.length === 0);
  }
  function be(Ur, Sr, Gr, Fr) {
    Sr.flowing && Sr.length === 0 && !Sr.sync ? (Sr.awaitDrain = 0, Ur.emit("data", Gr)) : (Sr.length += Sr.objectMode ? 1 : Gr.length, Fr ? Sr.buffer.unshift(Gr) : Sr.buffer.push(Gr), Sr.needReadable && st(Ur)), er(Ur, Sr);
  }
  function Be(Ur, Sr) {
    var Gr;
    return !E(Sr) && typeof Sr != "string" && Sr !== void 0 && !Ur.objectMode && (Gr = new L("chunk", ["string", "Buffer", "Uint8Array"], Sr)), Gr;
  }
  ve.prototype.isPaused = function() {
    return this._readableState.flowing === !1;
  }, ve.prototype.setEncoding = function(Ur) {
    Ie || (Ie = requireString_decoder$1().StringDecoder);
    var Sr = new Ie(Ur);
    this._readableState.decoder = Sr, this._readableState.encoding = this._readableState.decoder.encoding;
    for (var Gr = this._readableState.buffer.head, Fr = ""; Gr !== null; )
      Fr += Sr.write(Gr.data), Gr = Gr.next;
    return this._readableState.buffer.clear(), Fr !== "" && this._readableState.buffer.push(Fr), this._readableState.length = Fr.length, this;
  };
  var ke = 1073741824;
  function xe(Ur) {
    return Ur >= ke ? Ur = ke : (Ur--, Ur |= Ur >>> 1, Ur |= Ur >>> 2, Ur |= Ur >>> 4, Ur |= Ur >>> 8, Ur |= Ur >>> 16, Ur++), Ur;
  }
  function Ne(Ur, Sr) {
    return Ur <= 0 || Sr.length === 0 && Sr.ended ? 0 : Sr.objectMode ? 1 : Ur !== Ur ? Sr.flowing && Sr.length ? Sr.buffer.head.data.length : Sr.length : (Ur > Sr.highWaterMark && (Sr.highWaterMark = xe(Ur)), Ur <= Sr.length ? Ur : Sr.ended ? Sr.length : (Sr.needReadable = !0, 0));
  }
  ve.prototype.read = function(Ur) {
    D("read", Ur), Ur = parseInt(Ur, 10);
    var Sr = this._readableState, Gr = Ur;
    if (Ur !== 0 && (Sr.emittedReadable = !1), Ur === 0 && Sr.needReadable && ((Sr.highWaterMark !== 0 ? Sr.length >= Sr.highWaterMark : Sr.length > 0) || Sr.ended))
      return D("read: emitReadable", Sr.length, Sr.ended), Sr.length === 0 && Sr.ended ? Qr(this) : st(this), null;
    if (Ur = Ne(Ur, Sr), Ur === 0 && Sr.ended)
      return Sr.length === 0 && Qr(this), null;
    var Fr = Sr.needReadable;
    D("need readable", Fr), (Sr.length === 0 || Sr.length - Ur < Sr.highWaterMark) && (Fr = !0, D("length less than watermark", Fr)), Sr.ended || Sr.reading ? (Fr = !1, D("reading or ended", Fr)) : Fr && (D("do read"), Sr.reading = !0, Sr.sync = !0, Sr.length === 0 && (Sr.needReadable = !0), this._read(Sr.highWaterMark), Sr.sync = !1, Sr.reading || (Ur = Ne(Gr, Sr)));
    var br;
    return Ur > 0 ? br = Dr(Ur, Sr) : br = null, br === null ? (Sr.needReadable = Sr.length <= Sr.highWaterMark, Ur = 0) : (Sr.length -= Ur, Sr.awaitDrain = 0), Sr.length === 0 && (Sr.ended || (Sr.needReadable = !0), Gr !== Ur && Sr.ended && Qr(this)), br !== null && this.emit("data", br), br;
  };
  function Et(Ur, Sr) {
    if (D("onEofChunk"), !Sr.ended) {
      if (Sr.decoder) {
        var Gr = Sr.decoder.end();
        Gr && Gr.length && (Sr.buffer.push(Gr), Sr.length += Sr.objectMode ? 1 : Gr.length);
      }
      Sr.ended = !0, Sr.sync ? st(Ur) : (Sr.needReadable = !1, Sr.emittedReadable || (Sr.emittedReadable = !0, Dt(Ur)));
    }
  }
  function st(Ur) {
    var Sr = Ur._readableState;
    D("emitReadable", Sr.needReadable, Sr.emittedReadable), Sr.needReadable = !1, Sr.emittedReadable || (D("emitReadable", Sr.flowing), Sr.emittedReadable = !0, process$1.nextTick(Dt, Ur));
  }
  function Dt(Ur) {
    var Sr = Ur._readableState;
    D("emitReadable_", Sr.destroyed, Sr.length, Sr.ended), !Sr.destroyed && (Sr.length || Sr.ended) && (Ur.emit("readable"), Sr.emittedReadable = !1), Sr.needReadable = !Sr.flowing && !Sr.ended && Sr.length <= Sr.highWaterMark, Mr(Ur);
  }
  function er(Ur, Sr) {
    Sr.readingMore || (Sr.readingMore = !0, process$1.nextTick(xt, Ur, Sr));
  }
  function xt(Ur, Sr) {
    for (; !Sr.reading && !Sr.ended && (Sr.length < Sr.highWaterMark || Sr.flowing && Sr.length === 0); ) {
      var Gr = Sr.length;
      if (D("maybeReadMore read 0"), Ur.read(0), Gr === Sr.length)
        break;
    }
    Sr.readingMore = !1;
  }
  ve.prototype._read = function(Ur) {
    ze(this, new fe("_read()"));
  }, ve.prototype.pipe = function(Ur, Sr) {
    var Gr = this, Fr = this._readableState;
    switch (Fr.pipesCount) {
      case 0:
        Fr.pipes = Ur;
        break;
      case 1:
        Fr.pipes = [Fr.pipes, Ur];
        break;
      default:
        Fr.pipes.push(Ur);
        break;
    }
    Fr.pipesCount += 1, D("pipe count=%d opts=%j", Fr.pipesCount, Sr);
    var br = (!Sr || Sr.end !== !1) && Ur !== process$1.stdout && Ur !== process$1.stderr, Ar = br ? hr : Lr;
    Fr.endEmitted ? process$1.nextTick(Ar) : Gr.once("end", Ar), Ur.on("unpipe", cr);
    function cr(Rr, Ir) {
      D("onunpipe"), Rr === Gr && Ir && Ir.hasUnpiped === !1 && (Ir.hasUnpiped = !0, Bi());
    }
    function hr() {
      D("onend"), Ur.end();
    }
    var Wr = ir(Gr);
    Ur.on("drain", Wr);
    var fi = !1;
    function Bi() {
      D("cleanup"), Ur.removeListener("close", zr), Ur.removeListener("finish", ti), Ur.removeListener("drain", Wr), Ur.removeListener("error", oi), Ur.removeListener("unpipe", cr), Gr.removeListener("end", hr), Gr.removeListener("end", Lr), Gr.removeListener("data", $r), fi = !0, Fr.awaitDrain && (!Ur._writableState || Ur._writableState.needDrain) && Wr();
    }
    Gr.on("data", $r);
    function $r(Rr) {
      D("ondata");
      var Ir = Ur.write(Rr);
      D("dest.write", Ir), Ir === !1 && ((Fr.pipesCount === 1 && Fr.pipes === Ur || Fr.pipesCount > 1 && Vr(Fr.pipes, Ur) !== -1) && !fi && (D("false write response, pause", Fr.awaitDrain), Fr.awaitDrain++), Gr.pause());
    }
    function oi(Rr) {
      D("onerror", Rr), Lr(), Ur.removeListener("error", oi), g(Ur, "error") === 0 && ze(Ur, Rr);
    }
    Pe(Ur, "error", oi);
    function zr() {
      Ur.removeListener("finish", ti), Lr();
    }
    Ur.once("close", zr);
    function ti() {
      D("onfinish"), Ur.removeListener("close", zr), Lr();
    }
    Ur.once("finish", ti);
    function Lr() {
      D("unpipe"), Gr.unpipe(Ur);
    }
    return Ur.emit("pipe", Gr), Fr.flowing || (D("pipe resume"), Gr.resume()), Ur;
  };
  function ir(Ur) {
    return function() {
      var Gr = Ur._readableState;
      D("pipeOnDrain", Gr.awaitDrain), Gr.awaitDrain && Gr.awaitDrain--, Gr.awaitDrain === 0 && g(Ur, "data") && (Gr.flowing = !0, Mr(Ur));
    };
  }
  ve.prototype.unpipe = function(Ur) {
    var Sr = this._readableState, Gr = {
      hasUnpiped: !1
    };
    if (Sr.pipesCount === 0) return this;
    if (Sr.pipesCount === 1)
      return Ur && Ur !== Sr.pipes ? this : (Ur || (Ur = Sr.pipes), Sr.pipes = null, Sr.pipesCount = 0, Sr.flowing = !1, Ur && Ur.emit("unpipe", this, Gr), this);
    if (!Ur) {
      var Fr = Sr.pipes, br = Sr.pipesCount;
      Sr.pipes = null, Sr.pipesCount = 0, Sr.flowing = !1;
      for (var Ar = 0; Ar < br; Ar++) Fr[Ar].emit("unpipe", this, {
        hasUnpiped: !1
      });
      return this;
    }
    var cr = Vr(Sr.pipes, Ur);
    return cr === -1 ? this : (Sr.pipes.splice(cr, 1), Sr.pipesCount -= 1, Sr.pipesCount === 1 && (Sr.pipes = Sr.pipes[0]), Ur.emit("unpipe", this, Gr), this);
  }, ve.prototype.on = function(Ur, Sr) {
    var Gr = c.prototype.on.call(this, Ur, Sr), Fr = this._readableState;
    return Ur === "data" ? (Fr.readableListening = this.listenerCount("readable") > 0, Fr.flowing !== !1 && this.resume()) : Ur === "readable" && !Fr.endEmitted && !Fr.readableListening && (Fr.readableListening = Fr.needReadable = !0, Fr.flowing = !1, Fr.emittedReadable = !1, D("on readable", Fr.length, Fr.reading), Fr.length ? st(this) : Fr.reading || process$1.nextTick(yr, this)), Gr;
  }, ve.prototype.addListener = ve.prototype.on, ve.prototype.removeListener = function(Ur, Sr) {
    var Gr = c.prototype.removeListener.call(this, Ur, Sr);
    return Ur === "readable" && process$1.nextTick(sr, this), Gr;
  }, ve.prototype.removeAllListeners = function(Ur) {
    var Sr = c.prototype.removeAllListeners.apply(this, arguments);
    return (Ur === "readable" || Ur === void 0) && process$1.nextTick(sr, this), Sr;
  };
  function sr(Ur) {
    var Sr = Ur._readableState;
    Sr.readableListening = Ur.listenerCount("readable") > 0, Sr.resumeScheduled && !Sr.paused ? Sr.flowing = !0 : Ur.listenerCount("data") > 0 && Ur.resume();
  }
  function yr(Ur) {
    D("readable nexttick read 0"), Ur.read(0);
  }
  ve.prototype.resume = function() {
    var Ur = this._readableState;
    return Ur.flowing || (D("resume"), Ur.flowing = !Ur.readableListening, wr(this, Ur)), Ur.paused = !1, this;
  };
  function wr(Ur, Sr) {
    Sr.resumeScheduled || (Sr.resumeScheduled = !0, process$1.nextTick(qr, Ur, Sr));
  }
  function qr(Ur, Sr) {
    D("resume", Sr.reading), Sr.reading || Ur.read(0), Sr.resumeScheduled = !1, Ur.emit("resume"), Mr(Ur), Sr.flowing && !Sr.reading && Ur.read(0);
  }
  ve.prototype.pause = function() {
    return D("call pause flowing=%j", this._readableState.flowing), this._readableState.flowing !== !1 && (D("pause"), this._readableState.flowing = !1, this.emit("pause")), this._readableState.paused = !0, this;
  };
  function Mr(Ur) {
    var Sr = Ur._readableState;
    for (D("flow", Sr.flowing); Sr.flowing && Ur.read() !== null; ) ;
  }
  ve.prototype.wrap = function(Ur) {
    var Sr = this, Gr = this._readableState, Fr = !1;
    Ur.on("end", function() {
      if (D("wrapped end"), Gr.decoder && !Gr.ended) {
        var cr = Gr.decoder.end();
        cr && cr.length && Sr.push(cr);
      }
      Sr.push(null);
    }), Ur.on("data", function(cr) {
      if (D("wrapped data"), Gr.decoder && (cr = Gr.decoder.write(cr)), !(Gr.objectMode && cr == null) && !(!Gr.objectMode && (!cr || !cr.length))) {
        var hr = Sr.push(cr);
        hr || (Fr = !0, Ur.pause());
      }
    });
    for (var br in Ur)
      this[br] === void 0 && typeof Ur[br] == "function" && (this[br] = /* @__PURE__ */ function(hr) {
        return function() {
          return Ur[hr].apply(Ur, arguments);
        };
      }(br));
    for (var Ar = 0; Ar < He.length; Ar++)
      Ur.on(He[Ar], this.emit.bind(this, He[Ar]));
    return this._read = function(cr) {
      D("wrapped _read", cr), Fr && (Fr = !1, Ur.resume());
    }, this;
  }, typeof Symbol == "function" && (ve.prototype[Symbol.asyncIterator] = function() {
    return Ee === void 0 && (Ee = requireAsync_iterator()), Ee(this);
  }), Object.defineProperty(ve.prototype, "readableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState.highWaterMark;
    }
  }), Object.defineProperty(ve.prototype, "readableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState && this._readableState.buffer;
    }
  }), Object.defineProperty(ve.prototype, "readableFlowing", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState.flowing;
    },
    set: function(Sr) {
      this._readableState && (this._readableState.flowing = Sr);
    }
  }), ve._fromList = Dr, Object.defineProperty(ve.prototype, "readableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState.length;
    }
  });
  function Dr(Ur, Sr) {
    if (Sr.length === 0) return null;
    var Gr;
    return Sr.objectMode ? Gr = Sr.buffer.shift() : !Ur || Ur >= Sr.length ? (Sr.decoder ? Gr = Sr.buffer.join("") : Sr.buffer.length === 1 ? Gr = Sr.buffer.first() : Gr = Sr.buffer.concat(Sr.length), Sr.buffer.clear()) : Gr = Sr.buffer.consume(Ur, Sr.decoder), Gr;
  }
  function Qr(Ur) {
    var Sr = Ur._readableState;
    D("endReadable", Sr.endEmitted), Sr.endEmitted || (Sr.ended = !0, process$1.nextTick(Xr, Sr, Ur));
  }
  function Xr(Ur, Sr) {
    if (D("endReadableNT", Ur.endEmitted, Ur.length), !Ur.endEmitted && Ur.length === 0 && (Ur.endEmitted = !0, Sr.readable = !1, Sr.emit("end"), Ur.autoDestroy)) {
      var Gr = Sr._writableState;
      (!Gr || Gr.autoDestroy && Gr.finished) && Sr.destroy();
    }
  }
  typeof Symbol == "function" && (ve.from = function(Ur, Sr) {
    return Se === void 0 && (Se = requireFromBrowser()), Se(ve, Ur, Sr);
  });
  function Vr(Ur, Sr) {
    for (var Gr = 0, Fr = Ur.length; Gr < Fr; Gr++)
      if (Ur[Gr] === Sr) return Gr;
    return -1;
  }
  return _stream_readable$1;
}
var _stream_transform$1, hasRequired_stream_transform$1;
function require_stream_transform$1() {
  if (hasRequired_stream_transform$1) return _stream_transform$1;
  hasRequired_stream_transform$1 = 1, _stream_transform$1 = B;
  var o = requireErrorsBrowser().codes, g = o.ERR_METHOD_NOT_IMPLEMENTED, c = o.ERR_MULTIPLE_CALLBACK, y = o.ERR_TRANSFORM_ALREADY_TRANSFORMING, t = o.ERR_TRANSFORM_WITH_LENGTH_0, d = require_stream_duplex$1();
  requireInherits_browser()(B, d);
  function E(v, F) {
    var M = this._transformState;
    M.transforming = !1;
    var U = M.writecb;
    if (U === null)
      return this.emit("error", new c());
    M.writechunk = null, M.writecb = null, F != null && this.push(F), U(v);
    var L = this._readableState;
    L.reading = !1, (L.needReadable || L.length < L.highWaterMark) && this._read(L.highWaterMark);
  }
  function B(v) {
    if (!(this instanceof B)) return new B(v);
    d.call(this, v), this._transformState = {
      afterTransform: E.bind(this),
      needTransform: !1,
      transforming: !1,
      writecb: null,
      writechunk: null,
      writeencoding: null
    }, this._readableState.needReadable = !0, this._readableState.sync = !1, v && (typeof v.transform == "function" && (this._transform = v.transform), typeof v.flush == "function" && (this._flush = v.flush)), this.on("prefinish", D);
  }
  function D() {
    var v = this;
    typeof this._flush == "function" && !this._readableState.destroyed ? this._flush(function(F, M) {
      x(v, F, M);
    }) : x(this, null, null);
  }
  B.prototype.push = function(v, F) {
    return this._transformState.needTransform = !1, d.prototype.push.call(this, v, F);
  }, B.prototype._transform = function(v, F, M) {
    M(new g("_transform()"));
  }, B.prototype._write = function(v, F, M) {
    var U = this._transformState;
    if (U.writecb = M, U.writechunk = v, U.writeencoding = F, !U.transforming) {
      var L = this._readableState;
      (U.needTransform || L.needReadable || L.length < L.highWaterMark) && this._read(L.highWaterMark);
    }
  }, B.prototype._read = function(v) {
    var F = this._transformState;
    F.writechunk !== null && !F.transforming ? (F.transforming = !0, this._transform(F.writechunk, F.writeencoding, F.afterTransform)) : F.needTransform = !0;
  }, B.prototype._destroy = function(v, F) {
    d.prototype._destroy.call(this, v, function(M) {
      F(M);
    });
  };
  function x(v, F, M) {
    if (F) return v.emit("error", F);
    if (M != null && v.push(M), v._writableState.length) throw new t();
    if (v._transformState.transforming) throw new y();
    return v.push(null);
  }
  return _stream_transform$1;
}
var _stream_passthrough$1, hasRequired_stream_passthrough$1;
function require_stream_passthrough$1() {
  if (hasRequired_stream_passthrough$1) return _stream_passthrough$1;
  hasRequired_stream_passthrough$1 = 1, _stream_passthrough$1 = g;
  var o = require_stream_transform$1();
  requireInherits_browser()(g, o);
  function g(c) {
    if (!(this instanceof g)) return new g(c);
    o.call(this, c);
  }
  return g.prototype._transform = function(c, y, t) {
    t(null, c);
  }, _stream_passthrough$1;
}
var pipeline_1, hasRequiredPipeline;
function requirePipeline() {
  if (hasRequiredPipeline) return pipeline_1;
  hasRequiredPipeline = 1;
  var o;
  function g(M) {
    var U = !1;
    return function() {
      U || (U = !0, M.apply(void 0, arguments));
    };
  }
  var c = requireErrorsBrowser().codes, y = c.ERR_MISSING_ARGS, t = c.ERR_STREAM_DESTROYED;
  function d(M) {
    if (M) throw M;
  }
  function E(M) {
    return M.setHeader && typeof M.abort == "function";
  }
  function B(M, U, L, H) {
    H = g(H);
    var fe = !1;
    M.on("close", function() {
      fe = !0;
    }), o === void 0 && (o = requireEndOfStream()), o(M, {
      readable: U,
      writable: L
    }, function(Ie) {
      if (Ie) return H(Ie);
      fe = !0, H();
    });
    var ge = !1;
    return function(Ie) {
      if (!fe && !ge) {
        if (ge = !0, E(M)) return M.abort();
        if (typeof M.destroy == "function") return M.destroy();
        H(Ie || new t("pipe"));
      }
    };
  }
  function D(M) {
    M();
  }
  function x(M, U) {
    return M.pipe(U);
  }
  function v(M) {
    return !M.length || typeof M[M.length - 1] != "function" ? d : M.pop();
  }
  function F() {
    for (var M = arguments.length, U = new Array(M), L = 0; L < M; L++)
      U[L] = arguments[L];
    var H = v(U);
    if (Array.isArray(U[0]) && (U = U[0]), U.length < 2)
      throw new y("streams");
    var fe, ge = U.map(function(Ie, Ee) {
      var Se = Ee < U.length - 1, ze = Ee > 0;
      return B(Ie, Se, ze, function(He) {
        fe || (fe = He), He && ge.forEach(D), !Se && (ge.forEach(D), H(fe));
      });
    });
    return U.reduce(x);
  }
  return pipeline_1 = F, pipeline_1;
}
var hasRequiredReadableBrowser$1;
function requireReadableBrowser$1() {
  return hasRequiredReadableBrowser$1 || (hasRequiredReadableBrowser$1 = 1, function(o, g) {
    g = o.exports = require_stream_readable$1(), g.Stream = g, g.Readable = g, g.Writable = require_stream_writable$1(), g.Duplex = require_stream_duplex$1(), g.Transform = require_stream_transform$1(), g.PassThrough = require_stream_passthrough$1(), g.finished = requireEndOfStream(), g.pipeline = requirePipeline();
  }(readableBrowser$1, readableBrowser$1.exports)), readableBrowser$1.exports;
}
var hashBase$1, hasRequiredHashBase$1;
function requireHashBase$1() {
  if (hasRequiredHashBase$1) return hashBase$1;
  hasRequiredHashBase$1 = 1;
  var o = requireSafeBuffer$1().Buffer, g = requireReadableBrowser$1().Transform, c = requireInherits_browser();
  function y(d, E) {
    if (!o.isBuffer(d) && typeof d != "string")
      throw new TypeError(E + " must be a string or a buffer");
  }
  function t(d) {
    g.call(this), this._block = o.allocUnsafe(d), this._blockSize = d, this._blockOffset = 0, this._length = [0, 0, 0, 0], this._finalized = !1;
  }
  return c(t, g), t.prototype._transform = function(d, E, B) {
    var D = null;
    try {
      this.update(d, E);
    } catch (x) {
      D = x;
    }
    B(D);
  }, t.prototype._flush = function(d) {
    var E = null;
    try {
      this.push(this.digest());
    } catch (B) {
      E = B;
    }
    d(E);
  }, t.prototype.update = function(d, E) {
    if (y(d, "Data"), this._finalized) throw new Error("Digest already called");
    o.isBuffer(d) || (d = o.from(d, E));
    for (var B = this._block, D = 0; this._blockOffset + d.length - D >= this._blockSize; ) {
      for (var x = this._blockOffset; x < this._blockSize; ) B[x++] = d[D++];
      this._update(), this._blockOffset = 0;
    }
    for (; D < d.length; ) B[this._blockOffset++] = d[D++];
    for (var v = 0, F = d.length * 8; F > 0; ++v)
      this._length[v] += F, F = this._length[v] / 4294967296 | 0, F > 0 && (this._length[v] -= 4294967296 * F);
    return this;
  }, t.prototype._update = function() {
    throw new Error("_update is not implemented");
  }, t.prototype.digest = function(d) {
    if (this._finalized) throw new Error("Digest already called");
    this._finalized = !0;
    var E = this._digest();
    d !== void 0 && (E = E.toString(d)), this._block.fill(0), this._blockOffset = 0;
    for (var B = 0; B < 4; ++B) this._length[B] = 0;
    return E;
  }, t.prototype._digest = function() {
    throw new Error("_digest is not implemented");
  }, hashBase$1 = t, hashBase$1;
}
var md5_js, hasRequiredMd5_js;
function requireMd5_js() {
  if (hasRequiredMd5_js) return md5_js;
  hasRequiredMd5_js = 1;
  var o = requireInherits_browser(), g = requireHashBase$1(), c = requireSafeBuffer$1().Buffer, y = new Array(16);
  function t() {
    g.call(this, 64), this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878;
  }
  o(t, g), t.prototype._update = function() {
    for (var v = y, F = 0; F < 16; ++F) v[F] = this._block.readInt32LE(F * 4);
    var M = this._a, U = this._b, L = this._c, H = this._d;
    M = E(M, U, L, H, v[0], 3614090360, 7), H = E(H, M, U, L, v[1], 3905402710, 12), L = E(L, H, M, U, v[2], 606105819, 17), U = E(U, L, H, M, v[3], 3250441966, 22), M = E(M, U, L, H, v[4], 4118548399, 7), H = E(H, M, U, L, v[5], 1200080426, 12), L = E(L, H, M, U, v[6], 2821735955, 17), U = E(U, L, H, M, v[7], 4249261313, 22), M = E(M, U, L, H, v[8], 1770035416, 7), H = E(H, M, U, L, v[9], 2336552879, 12), L = E(L, H, M, U, v[10], 4294925233, 17), U = E(U, L, H, M, v[11], 2304563134, 22), M = E(M, U, L, H, v[12], 1804603682, 7), H = E(H, M, U, L, v[13], 4254626195, 12), L = E(L, H, M, U, v[14], 2792965006, 17), U = E(U, L, H, M, v[15], 1236535329, 22), M = B(M, U, L, H, v[1], 4129170786, 5), H = B(H, M, U, L, v[6], 3225465664, 9), L = B(L, H, M, U, v[11], 643717713, 14), U = B(U, L, H, M, v[0], 3921069994, 20), M = B(M, U, L, H, v[5], 3593408605, 5), H = B(H, M, U, L, v[10], 38016083, 9), L = B(L, H, M, U, v[15], 3634488961, 14), U = B(U, L, H, M, v[4], 3889429448, 20), M = B(M, U, L, H, v[9], 568446438, 5), H = B(H, M, U, L, v[14], 3275163606, 9), L = B(L, H, M, U, v[3], 4107603335, 14), U = B(U, L, H, M, v[8], 1163531501, 20), M = B(M, U, L, H, v[13], 2850285829, 5), H = B(H, M, U, L, v[2], 4243563512, 9), L = B(L, H, M, U, v[7], 1735328473, 14), U = B(U, L, H, M, v[12], 2368359562, 20), M = D(M, U, L, H, v[5], 4294588738, 4), H = D(H, M, U, L, v[8], 2272392833, 11), L = D(L, H, M, U, v[11], 1839030562, 16), U = D(U, L, H, M, v[14], 4259657740, 23), M = D(M, U, L, H, v[1], 2763975236, 4), H = D(H, M, U, L, v[4], 1272893353, 11), L = D(L, H, M, U, v[7], 4139469664, 16), U = D(U, L, H, M, v[10], 3200236656, 23), M = D(M, U, L, H, v[13], 681279174, 4), H = D(H, M, U, L, v[0], 3936430074, 11), L = D(L, H, M, U, v[3], 3572445317, 16), U = D(U, L, H, M, v[6], 76029189, 23), M = D(M, U, L, H, v[9], 3654602809, 4), H = D(H, M, U, L, v[12], 3873151461, 11), L = D(L, H, M, U, v[15], 530742520, 16), U = D(U, L, H, M, v[2], 3299628645, 23), M = x(M, U, L, H, v[0], 4096336452, 6), H = x(H, M, U, L, v[7], 1126891415, 10), L = x(L, H, M, U, v[14], 2878612391, 15), U = x(U, L, H, M, v[5], 4237533241, 21), M = x(M, U, L, H, v[12], 1700485571, 6), H = x(H, M, U, L, v[3], 2399980690, 10), L = x(L, H, M, U, v[10], 4293915773, 15), U = x(U, L, H, M, v[1], 2240044497, 21), M = x(M, U, L, H, v[8], 1873313359, 6), H = x(H, M, U, L, v[15], 4264355552, 10), L = x(L, H, M, U, v[6], 2734768916, 15), U = x(U, L, H, M, v[13], 1309151649, 21), M = x(M, U, L, H, v[4], 4149444226, 6), H = x(H, M, U, L, v[11], 3174756917, 10), L = x(L, H, M, U, v[2], 718787259, 15), U = x(U, L, H, M, v[9], 3951481745, 21), this._a = this._a + M | 0, this._b = this._b + U | 0, this._c = this._c + L | 0, this._d = this._d + H | 0;
  }, t.prototype._digest = function() {
    this._block[this._blockOffset++] = 128, this._blockOffset > 56 && (this._block.fill(0, this._blockOffset, 64), this._update(), this._blockOffset = 0), this._block.fill(0, this._blockOffset, 56), this._block.writeUInt32LE(this._length[0], 56), this._block.writeUInt32LE(this._length[1], 60), this._update();
    var v = c.allocUnsafe(16);
    return v.writeInt32LE(this._a, 0), v.writeInt32LE(this._b, 4), v.writeInt32LE(this._c, 8), v.writeInt32LE(this._d, 12), v;
  };
  function d(v, F) {
    return v << F | v >>> 32 - F;
  }
  function E(v, F, M, U, L, H, fe) {
    return d(v + (F & M | ~F & U) + L + H | 0, fe) + F | 0;
  }
  function B(v, F, M, U, L, H, fe) {
    return d(v + (F & U | M & ~U) + L + H | 0, fe) + F | 0;
  }
  function D(v, F, M, U, L, H, fe) {
    return d(v + (F ^ M ^ U) + L + H | 0, fe) + F | 0;
  }
  function x(v, F, M, U, L, H, fe) {
    return d(v + (M ^ (F | ~U)) + L + H | 0, fe) + F | 0;
  }
  return md5_js = t, md5_js;
}
var ripemd160$5, hasRequiredRipemd160$2;
function requireRipemd160$2() {
  if (hasRequiredRipemd160$2) return ripemd160$5;
  hasRequiredRipemd160$2 = 1;
  var o = requireBuffer$2().Buffer, g = requireInherits_browser(), c = requireHashBase$1(), y = new Array(16), t = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
  ], d = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
  ], E = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
  ], B = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
  ], D = [0, 1518500249, 1859775393, 2400959708, 2840853838], x = [1352829926, 1548603684, 1836072691, 2053994217, 0];
  function v() {
    c.call(this, 64), this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520;
  }
  g(v, c), v.prototype._update = function() {
    for (var ge = y, Ie = 0; Ie < 16; ++Ie) ge[Ie] = this._block.readInt32LE(Ie * 4);
    for (var Ee = this._a | 0, Se = this._b | 0, ze = this._c | 0, He = this._d | 0, Pe = this._e | 0, De = this._a | 0, ve = this._b | 0, Fe = this._c | 0, be = this._d | 0, Be = this._e | 0, ke = 0; ke < 80; ke += 1) {
      var xe, Ne;
      ke < 16 ? (xe = M(Ee, Se, ze, He, Pe, ge[t[ke]], D[0], E[ke]), Ne = fe(De, ve, Fe, be, Be, ge[d[ke]], x[0], B[ke])) : ke < 32 ? (xe = U(Ee, Se, ze, He, Pe, ge[t[ke]], D[1], E[ke]), Ne = H(De, ve, Fe, be, Be, ge[d[ke]], x[1], B[ke])) : ke < 48 ? (xe = L(Ee, Se, ze, He, Pe, ge[t[ke]], D[2], E[ke]), Ne = L(De, ve, Fe, be, Be, ge[d[ke]], x[2], B[ke])) : ke < 64 ? (xe = H(Ee, Se, ze, He, Pe, ge[t[ke]], D[3], E[ke]), Ne = U(De, ve, Fe, be, Be, ge[d[ke]], x[3], B[ke])) : (xe = fe(Ee, Se, ze, He, Pe, ge[t[ke]], D[4], E[ke]), Ne = M(De, ve, Fe, be, Be, ge[d[ke]], x[4], B[ke])), Ee = Pe, Pe = He, He = F(ze, 10), ze = Se, Se = xe, De = Be, Be = be, be = F(Fe, 10), Fe = ve, ve = Ne;
    }
    var Et = this._b + ze + be | 0;
    this._b = this._c + He + Be | 0, this._c = this._d + Pe + De | 0, this._d = this._e + Ee + ve | 0, this._e = this._a + Se + Fe | 0, this._a = Et;
  }, v.prototype._digest = function() {
    this._block[this._blockOffset++] = 128, this._blockOffset > 56 && (this._block.fill(0, this._blockOffset, 64), this._update(), this._blockOffset = 0), this._block.fill(0, this._blockOffset, 56), this._block.writeUInt32LE(this._length[0], 56), this._block.writeUInt32LE(this._length[1], 60), this._update();
    var ge = o.alloc ? o.alloc(20) : new o(20);
    return ge.writeInt32LE(this._a, 0), ge.writeInt32LE(this._b, 4), ge.writeInt32LE(this._c, 8), ge.writeInt32LE(this._d, 12), ge.writeInt32LE(this._e, 16), ge;
  };
  function F(ge, Ie) {
    return ge << Ie | ge >>> 32 - Ie;
  }
  function M(ge, Ie, Ee, Se, ze, He, Pe, De) {
    return F(ge + (Ie ^ Ee ^ Se) + He + Pe | 0, De) + ze | 0;
  }
  function U(ge, Ie, Ee, Se, ze, He, Pe, De) {
    return F(ge + (Ie & Ee | ~Ie & Se) + He + Pe | 0, De) + ze | 0;
  }
  function L(ge, Ie, Ee, Se, ze, He, Pe, De) {
    return F(ge + ((Ie | ~Ee) ^ Se) + He + Pe | 0, De) + ze | 0;
  }
  function H(ge, Ie, Ee, Se, ze, He, Pe, De) {
    return F(ge + (Ie & Se | Ee & ~Se) + He + Pe | 0, De) + ze | 0;
  }
  function fe(ge, Ie, Ee, Se, ze, He, Pe, De) {
    return F(ge + (Ie ^ (Ee | ~Se)) + He + Pe | 0, De) + ze | 0;
  }
  return ripemd160$5 = v, ripemd160$5;
}
var sha_js = { exports: {} }, isarray$1, hasRequiredIsarray$1;
function requireIsarray$1() {
  if (hasRequiredIsarray$1) return isarray$1;
  hasRequiredIsarray$1 = 1;
  var o = {}.toString;
  return isarray$1 = Array.isArray || function(g) {
    return o.call(g) == "[object Array]";
  }, isarray$1;
}
var type, hasRequiredType;
function requireType() {
  return hasRequiredType || (hasRequiredType = 1, type = TypeError), type;
}
var esObjectAtoms, hasRequiredEsObjectAtoms;
function requireEsObjectAtoms() {
  return hasRequiredEsObjectAtoms || (hasRequiredEsObjectAtoms = 1, esObjectAtoms = Object), esObjectAtoms;
}
var esErrors, hasRequiredEsErrors;
function requireEsErrors() {
  return hasRequiredEsErrors || (hasRequiredEsErrors = 1, esErrors = Error), esErrors;
}
var _eval, hasRequired_eval;
function require_eval() {
  return hasRequired_eval || (hasRequired_eval = 1, _eval = EvalError), _eval;
}
var range$1, hasRequiredRange$1;
function requireRange$1() {
  return hasRequiredRange$1 || (hasRequiredRange$1 = 1, range$1 = RangeError), range$1;
}
var ref, hasRequiredRef;
function requireRef() {
  return hasRequiredRef || (hasRequiredRef = 1, ref = ReferenceError), ref;
}
var syntax, hasRequiredSyntax;
function requireSyntax() {
  return hasRequiredSyntax || (hasRequiredSyntax = 1, syntax = SyntaxError), syntax;
}
var uri, hasRequiredUri;
function requireUri() {
  return hasRequiredUri || (hasRequiredUri = 1, uri = URIError), uri;
}
var abs, hasRequiredAbs;
function requireAbs() {
  return hasRequiredAbs || (hasRequiredAbs = 1, abs = Math.abs), abs;
}
var floor, hasRequiredFloor;
function requireFloor() {
  return hasRequiredFloor || (hasRequiredFloor = 1, floor = Math.floor), floor;
}
var max$1, hasRequiredMax$1;
function requireMax$1() {
  return hasRequiredMax$1 || (hasRequiredMax$1 = 1, max$1 = Math.max), max$1;
}
var min, hasRequiredMin;
function requireMin() {
  return hasRequiredMin || (hasRequiredMin = 1, min = Math.min), min;
}
var pow$1, hasRequiredPow;
function requirePow() {
  return hasRequiredPow || (hasRequiredPow = 1, pow$1 = Math.pow), pow$1;
}
var round, hasRequiredRound;
function requireRound() {
  return hasRequiredRound || (hasRequiredRound = 1, round = Math.round), round;
}
var _isNaN, hasRequired_isNaN;
function require_isNaN() {
  return hasRequired_isNaN || (hasRequired_isNaN = 1, _isNaN = Number.isNaN || function(g) {
    return g !== g;
  }), _isNaN;
}
var sign$3, hasRequiredSign$1;
function requireSign$1() {
  if (hasRequiredSign$1) return sign$3;
  hasRequiredSign$1 = 1;
  var o = /* @__PURE__ */ require_isNaN();
  return sign$3 = function(c) {
    return o(c) || c === 0 ? c : c < 0 ? -1 : 1;
  }, sign$3;
}
var gOPD, hasRequiredGOPD;
function requireGOPD() {
  return hasRequiredGOPD || (hasRequiredGOPD = 1, gOPD = Object.getOwnPropertyDescriptor), gOPD;
}
var gopd, hasRequiredGopd;
function requireGopd() {
  if (hasRequiredGopd) return gopd;
  hasRequiredGopd = 1;
  var o = /* @__PURE__ */ requireGOPD();
  if (o)
    try {
      o([], "length");
    } catch {
      o = null;
    }
  return gopd = o, gopd;
}
var esDefineProperty, hasRequiredEsDefineProperty;
function requireEsDefineProperty() {
  if (hasRequiredEsDefineProperty) return esDefineProperty;
  hasRequiredEsDefineProperty = 1;
  var o = Object.defineProperty || !1;
  if (o)
    try {
      o({}, "a", { value: 1 });
    } catch {
      o = !1;
    }
  return esDefineProperty = o, esDefineProperty;
}
var shams$1, hasRequiredShams$1;
function requireShams$1() {
  return hasRequiredShams$1 || (hasRequiredShams$1 = 1, shams$1 = function() {
    if (typeof Symbol != "function" || typeof Object.getOwnPropertySymbols != "function")
      return !1;
    if (typeof Symbol.iterator == "symbol")
      return !0;
    var g = {}, c = Symbol("test"), y = Object(c);
    if (typeof c == "string" || Object.prototype.toString.call(c) !== "[object Symbol]" || Object.prototype.toString.call(y) !== "[object Symbol]")
      return !1;
    var t = 42;
    g[c] = t;
    for (var d in g)
      return !1;
    if (typeof Object.keys == "function" && Object.keys(g).length !== 0 || typeof Object.getOwnPropertyNames == "function" && Object.getOwnPropertyNames(g).length !== 0)
      return !1;
    var E = Object.getOwnPropertySymbols(g);
    if (E.length !== 1 || E[0] !== c || !Object.prototype.propertyIsEnumerable.call(g, c))
      return !1;
    if (typeof Object.getOwnPropertyDescriptor == "function") {
      var B = (
        /** @type {PropertyDescriptor} */
        Object.getOwnPropertyDescriptor(g, c)
      );
      if (B.value !== t || B.enumerable !== !0)
        return !1;
    }
    return !0;
  }), shams$1;
}
var hasSymbols, hasRequiredHasSymbols;
function requireHasSymbols() {
  if (hasRequiredHasSymbols) return hasSymbols;
  hasRequiredHasSymbols = 1;
  var o = typeof Symbol < "u" && Symbol, g = requireShams$1();
  return hasSymbols = function() {
    return typeof o != "function" || typeof Symbol != "function" || typeof o("foo") != "symbol" || typeof Symbol("bar") != "symbol" ? !1 : g();
  }, hasSymbols;
}
var Reflect_getPrototypeOf, hasRequiredReflect_getPrototypeOf;
function requireReflect_getPrototypeOf() {
  return hasRequiredReflect_getPrototypeOf || (hasRequiredReflect_getPrototypeOf = 1, Reflect_getPrototypeOf = typeof Reflect < "u" && Reflect.getPrototypeOf || null), Reflect_getPrototypeOf;
}
var Object_getPrototypeOf, hasRequiredObject_getPrototypeOf;
function requireObject_getPrototypeOf() {
  if (hasRequiredObject_getPrototypeOf) return Object_getPrototypeOf;
  hasRequiredObject_getPrototypeOf = 1;
  var o = /* @__PURE__ */ requireEsObjectAtoms();
  return Object_getPrototypeOf = o.getPrototypeOf || null, Object_getPrototypeOf;
}
var implementation$4, hasRequiredImplementation$4;
function requireImplementation$4() {
  if (hasRequiredImplementation$4) return implementation$4;
  hasRequiredImplementation$4 = 1;
  var o = "Function.prototype.bind called on incompatible ", g = Object.prototype.toString, c = Math.max, y = "[object Function]", t = function(D, x) {
    for (var v = [], F = 0; F < D.length; F += 1)
      v[F] = D[F];
    for (var M = 0; M < x.length; M += 1)
      v[M + D.length] = x[M];
    return v;
  }, d = function(D, x) {
    for (var v = [], F = x, M = 0; F < D.length; F += 1, M += 1)
      v[M] = D[F];
    return v;
  }, E = function(B, D) {
    for (var x = "", v = 0; v < B.length; v += 1)
      x += B[v], v + 1 < B.length && (x += D);
    return x;
  };
  return implementation$4 = function(D) {
    var x = this;
    if (typeof x != "function" || g.apply(x) !== y)
      throw new TypeError(o + x);
    for (var v = d(arguments, 1), F, M = function() {
      if (this instanceof F) {
        var ge = x.apply(
          this,
          t(v, arguments)
        );
        return Object(ge) === ge ? ge : this;
      }
      return x.apply(
        D,
        t(v, arguments)
      );
    }, U = c(0, x.length - v.length), L = [], H = 0; H < U; H++)
      L[H] = "$" + H;
    if (F = Function("binder", "return function (" + E(L, ",") + "){ return binder.apply(this,arguments); }")(M), x.prototype) {
      var fe = function() {
      };
      fe.prototype = x.prototype, F.prototype = new fe(), fe.prototype = null;
    }
    return F;
  }, implementation$4;
}
var functionBind, hasRequiredFunctionBind;
function requireFunctionBind() {
  if (hasRequiredFunctionBind) return functionBind;
  hasRequiredFunctionBind = 1;
  var o = requireImplementation$4();
  return functionBind = Function.prototype.bind || o, functionBind;
}
var functionCall, hasRequiredFunctionCall;
function requireFunctionCall() {
  return hasRequiredFunctionCall || (hasRequiredFunctionCall = 1, functionCall = Function.prototype.call), functionCall;
}
var functionApply, hasRequiredFunctionApply;
function requireFunctionApply() {
  return hasRequiredFunctionApply || (hasRequiredFunctionApply = 1, functionApply = Function.prototype.apply), functionApply;
}
var reflectApply, hasRequiredReflectApply;
function requireReflectApply() {
  return hasRequiredReflectApply || (hasRequiredReflectApply = 1, reflectApply = typeof Reflect < "u" && Reflect && Reflect.apply), reflectApply;
}
var actualApply, hasRequiredActualApply;
function requireActualApply() {
  if (hasRequiredActualApply) return actualApply;
  hasRequiredActualApply = 1;
  var o = requireFunctionBind(), g = requireFunctionApply(), c = requireFunctionCall(), y = requireReflectApply();
  return actualApply = y || o.call(c, g), actualApply;
}
var callBindApplyHelpers, hasRequiredCallBindApplyHelpers;
function requireCallBindApplyHelpers() {
  if (hasRequiredCallBindApplyHelpers) return callBindApplyHelpers;
  hasRequiredCallBindApplyHelpers = 1;
  var o = requireFunctionBind(), g = /* @__PURE__ */ requireType(), c = requireFunctionCall(), y = requireActualApply();
  return callBindApplyHelpers = function(d) {
    if (d.length < 1 || typeof d[0] != "function")
      throw new g("a function is required");
    return y(o, c, d);
  }, callBindApplyHelpers;
}
var get, hasRequiredGet;
function requireGet() {
  if (hasRequiredGet) return get;
  hasRequiredGet = 1;
  var o = requireCallBindApplyHelpers(), g = /* @__PURE__ */ requireGopd(), c;
  try {
    c = /** @type {{ __proto__?: typeof Array.prototype }} */
    [].__proto__ === Array.prototype;
  } catch (E) {
    if (!E || typeof E != "object" || !("code" in E) || E.code !== "ERR_PROTO_ACCESS")
      throw E;
  }
  var y = !!c && g && g(
    Object.prototype,
    /** @type {keyof typeof Object.prototype} */
    "__proto__"
  ), t = Object, d = t.getPrototypeOf;
  return get = y && typeof y.get == "function" ? o([y.get]) : typeof d == "function" ? (
    /** @type {import('./get')} */
    function(B) {
      return d(B == null ? B : t(B));
    }
  ) : !1, get;
}
var getProto, hasRequiredGetProto;
function requireGetProto() {
  if (hasRequiredGetProto) return getProto;
  hasRequiredGetProto = 1;
  var o = requireReflect_getPrototypeOf(), g = requireObject_getPrototypeOf(), c = /* @__PURE__ */ requireGet();
  return getProto = o ? function(t) {
    return o(t);
  } : g ? function(t) {
    if (!t || typeof t != "object" && typeof t != "function")
      throw new TypeError("getProto: not an object");
    return g(t);
  } : c ? function(t) {
    return c(t);
  } : null, getProto;
}
var hasown, hasRequiredHasown;
function requireHasown() {
  if (hasRequiredHasown) return hasown;
  hasRequiredHasown = 1;
  var o = Function.prototype.call, g = Object.prototype.hasOwnProperty, c = requireFunctionBind();
  return hasown = c.call(o, g), hasown;
}
var getIntrinsic, hasRequiredGetIntrinsic;
function requireGetIntrinsic() {
  if (hasRequiredGetIntrinsic) return getIntrinsic;
  hasRequiredGetIntrinsic = 1;
  var o, g = /* @__PURE__ */ requireEsObjectAtoms(), c = /* @__PURE__ */ requireEsErrors(), y = /* @__PURE__ */ require_eval(), t = /* @__PURE__ */ requireRange$1(), d = /* @__PURE__ */ requireRef(), E = /* @__PURE__ */ requireSyntax(), B = /* @__PURE__ */ requireType(), D = /* @__PURE__ */ requireUri(), x = /* @__PURE__ */ requireAbs(), v = /* @__PURE__ */ requireFloor(), F = /* @__PURE__ */ requireMax$1(), M = /* @__PURE__ */ requireMin(), U = /* @__PURE__ */ requirePow(), L = /* @__PURE__ */ requireRound(), H = /* @__PURE__ */ requireSign$1(), fe = Function, ge = function(Xr) {
    try {
      return fe('"use strict"; return (' + Xr + ").constructor;")();
    } catch {
    }
  }, Ie = /* @__PURE__ */ requireGopd(), Ee = /* @__PURE__ */ requireEsDefineProperty(), Se = function() {
    throw new B();
  }, ze = Ie ? function() {
    try {
      return arguments.callee, Se;
    } catch {
      try {
        return Ie(arguments, "callee").get;
      } catch {
        return Se;
      }
    }
  }() : Se, He = requireHasSymbols()(), Pe = requireGetProto(), De = requireObject_getPrototypeOf(), ve = requireReflect_getPrototypeOf(), Fe = requireFunctionApply(), be = requireFunctionCall(), Be = {}, ke = typeof Uint8Array > "u" || !Pe ? o : Pe(Uint8Array), xe = {
    __proto__: null,
    "%AggregateError%": typeof AggregateError > "u" ? o : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer > "u" ? o : ArrayBuffer,
    "%ArrayIteratorPrototype%": He && Pe ? Pe([][Symbol.iterator]()) : o,
    "%AsyncFromSyncIteratorPrototype%": o,
    "%AsyncFunction%": Be,
    "%AsyncGenerator%": Be,
    "%AsyncGeneratorFunction%": Be,
    "%AsyncIteratorPrototype%": Be,
    "%Atomics%": typeof Atomics > "u" ? o : Atomics,
    "%BigInt%": typeof BigInt > "u" ? o : BigInt,
    "%BigInt64Array%": typeof BigInt64Array > "u" ? o : BigInt64Array,
    "%BigUint64Array%": typeof BigUint64Array > "u" ? o : BigUint64Array,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView > "u" ? o : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": c,
    "%eval%": eval,
    // eslint-disable-line no-eval
    "%EvalError%": y,
    "%Float16Array%": typeof Float16Array > "u" ? o : Float16Array,
    "%Float32Array%": typeof Float32Array > "u" ? o : Float32Array,
    "%Float64Array%": typeof Float64Array > "u" ? o : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry > "u" ? o : FinalizationRegistry,
    "%Function%": fe,
    "%GeneratorFunction%": Be,
    "%Int8Array%": typeof Int8Array > "u" ? o : Int8Array,
    "%Int16Array%": typeof Int16Array > "u" ? o : Int16Array,
    "%Int32Array%": typeof Int32Array > "u" ? o : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": He && Pe ? Pe(Pe([][Symbol.iterator]())) : o,
    "%JSON%": typeof JSON == "object" ? JSON : o,
    "%Map%": typeof Map > "u" ? o : Map,
    "%MapIteratorPrototype%": typeof Map > "u" || !He || !Pe ? o : Pe((/* @__PURE__ */ new Map())[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": g,
    "%Object.getOwnPropertyDescriptor%": Ie,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise > "u" ? o : Promise,
    "%Proxy%": typeof Proxy > "u" ? o : Proxy,
    "%RangeError%": t,
    "%ReferenceError%": d,
    "%Reflect%": typeof Reflect > "u" ? o : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set > "u" ? o : Set,
    "%SetIteratorPrototype%": typeof Set > "u" || !He || !Pe ? o : Pe((/* @__PURE__ */ new Set())[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer > "u" ? o : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": He && Pe ? Pe(""[Symbol.iterator]()) : o,
    "%Symbol%": He ? Symbol : o,
    "%SyntaxError%": E,
    "%ThrowTypeError%": ze,
    "%TypedArray%": ke,
    "%TypeError%": B,
    "%Uint8Array%": typeof Uint8Array > "u" ? o : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray > "u" ? o : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array > "u" ? o : Uint16Array,
    "%Uint32Array%": typeof Uint32Array > "u" ? o : Uint32Array,
    "%URIError%": D,
    "%WeakMap%": typeof WeakMap > "u" ? o : WeakMap,
    "%WeakRef%": typeof WeakRef > "u" ? o : WeakRef,
    "%WeakSet%": typeof WeakSet > "u" ? o : WeakSet,
    "%Function.prototype.call%": be,
    "%Function.prototype.apply%": Fe,
    "%Object.defineProperty%": Ee,
    "%Object.getPrototypeOf%": De,
    "%Math.abs%": x,
    "%Math.floor%": v,
    "%Math.max%": F,
    "%Math.min%": M,
    "%Math.pow%": U,
    "%Math.round%": L,
    "%Math.sign%": H,
    "%Reflect.getPrototypeOf%": ve
  };
  if (Pe)
    try {
      null.error;
    } catch (Xr) {
      var Ne = Pe(Pe(Xr));
      xe["%Error.prototype%"] = Ne;
    }
  var Et = function Xr(Vr) {
    var Ur;
    if (Vr === "%AsyncFunction%")
      Ur = ge("async function () {}");
    else if (Vr === "%GeneratorFunction%")
      Ur = ge("function* () {}");
    else if (Vr === "%AsyncGeneratorFunction%")
      Ur = ge("async function* () {}");
    else if (Vr === "%AsyncGenerator%") {
      var Sr = Xr("%AsyncGeneratorFunction%");
      Sr && (Ur = Sr.prototype);
    } else if (Vr === "%AsyncIteratorPrototype%") {
      var Gr = Xr("%AsyncGenerator%");
      Gr && Pe && (Ur = Pe(Gr.prototype));
    }
    return xe[Vr] = Ur, Ur;
  }, st = {
    __proto__: null,
    "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
    "%ArrayPrototype%": ["Array", "prototype"],
    "%ArrayProto_entries%": ["Array", "prototype", "entries"],
    "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
    "%ArrayProto_keys%": ["Array", "prototype", "keys"],
    "%ArrayProto_values%": ["Array", "prototype", "values"],
    "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
    "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
    "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
    "%BooleanPrototype%": ["Boolean", "prototype"],
    "%DataViewPrototype%": ["DataView", "prototype"],
    "%DatePrototype%": ["Date", "prototype"],
    "%ErrorPrototype%": ["Error", "prototype"],
    "%EvalErrorPrototype%": ["EvalError", "prototype"],
    "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
    "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
    "%FunctionPrototype%": ["Function", "prototype"],
    "%Generator%": ["GeneratorFunction", "prototype"],
    "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
    "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
    "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
    "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
    "%JSONParse%": ["JSON", "parse"],
    "%JSONStringify%": ["JSON", "stringify"],
    "%MapPrototype%": ["Map", "prototype"],
    "%NumberPrototype%": ["Number", "prototype"],
    "%ObjectPrototype%": ["Object", "prototype"],
    "%ObjProto_toString%": ["Object", "prototype", "toString"],
    "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
    "%PromisePrototype%": ["Promise", "prototype"],
    "%PromiseProto_then%": ["Promise", "prototype", "then"],
    "%Promise_all%": ["Promise", "all"],
    "%Promise_reject%": ["Promise", "reject"],
    "%Promise_resolve%": ["Promise", "resolve"],
    "%RangeErrorPrototype%": ["RangeError", "prototype"],
    "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
    "%RegExpPrototype%": ["RegExp", "prototype"],
    "%SetPrototype%": ["Set", "prototype"],
    "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
    "%StringPrototype%": ["String", "prototype"],
    "%SymbolPrototype%": ["Symbol", "prototype"],
    "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
    "%TypedArrayPrototype%": ["TypedArray", "prototype"],
    "%TypeErrorPrototype%": ["TypeError", "prototype"],
    "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
    "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
    "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
    "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
    "%URIErrorPrototype%": ["URIError", "prototype"],
    "%WeakMapPrototype%": ["WeakMap", "prototype"],
    "%WeakSetPrototype%": ["WeakSet", "prototype"]
  }, Dt = requireFunctionBind(), er = /* @__PURE__ */ requireHasown(), xt = Dt.call(be, Array.prototype.concat), ir = Dt.call(Fe, Array.prototype.splice), sr = Dt.call(be, String.prototype.replace), yr = Dt.call(be, String.prototype.slice), wr = Dt.call(be, RegExp.prototype.exec), qr = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, Mr = /\\(\\)?/g, Dr = function(Vr) {
    var Ur = yr(Vr, 0, 1), Sr = yr(Vr, -1);
    if (Ur === "%" && Sr !== "%")
      throw new E("invalid intrinsic syntax, expected closing `%`");
    if (Sr === "%" && Ur !== "%")
      throw new E("invalid intrinsic syntax, expected opening `%`");
    var Gr = [];
    return sr(Vr, qr, function(Fr, br, Ar, cr) {
      Gr[Gr.length] = Ar ? sr(cr, Mr, "$1") : br || Fr;
    }), Gr;
  }, Qr = function(Vr, Ur) {
    var Sr = Vr, Gr;
    if (er(st, Sr) && (Gr = st[Sr], Sr = "%" + Gr[0] + "%"), er(xe, Sr)) {
      var Fr = xe[Sr];
      if (Fr === Be && (Fr = Et(Sr)), typeof Fr > "u" && !Ur)
        throw new B("intrinsic " + Vr + " exists, but is not available. Please file an issue!");
      return {
        alias: Gr,
        name: Sr,
        value: Fr
      };
    }
    throw new E("intrinsic " + Vr + " does not exist!");
  };
  return getIntrinsic = function(Vr, Ur) {
    if (typeof Vr != "string" || Vr.length === 0)
      throw new B("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof Ur != "boolean")
      throw new B('"allowMissing" argument must be a boolean');
    if (wr(/^%?[^%]*%?$/, Vr) === null)
      throw new E("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    var Sr = Dr(Vr), Gr = Sr.length > 0 ? Sr[0] : "", Fr = Qr("%" + Gr + "%", Ur), br = Fr.name, Ar = Fr.value, cr = !1, hr = Fr.alias;
    hr && (Gr = hr[0], ir(Sr, xt([0, 1], hr)));
    for (var Wr = 1, fi = !0; Wr < Sr.length; Wr += 1) {
      var Bi = Sr[Wr], $r = yr(Bi, 0, 1), oi = yr(Bi, -1);
      if (($r === '"' || $r === "'" || $r === "`" || oi === '"' || oi === "'" || oi === "`") && $r !== oi)
        throw new E("property names with quotes must have matching quotes");
      if ((Bi === "constructor" || !fi) && (cr = !0), Gr += "." + Bi, br = "%" + Gr + "%", er(xe, br))
        Ar = xe[br];
      else if (Ar != null) {
        if (!(Bi in Ar)) {
          if (!Ur)
            throw new B("base intrinsic for " + Vr + " exists, but the property is not available.");
          return;
        }
        if (Ie && Wr + 1 >= Sr.length) {
          var zr = Ie(Ar, Bi);
          fi = !!zr, fi && "get" in zr && !("originalValue" in zr.get) ? Ar = zr.get : Ar = Ar[Bi];
        } else
          fi = er(Ar, Bi), Ar = Ar[Bi];
        fi && !cr && (xe[br] = Ar);
      }
    }
    return Ar;
  }, getIntrinsic;
}
var callBound$1, hasRequiredCallBound$1;
function requireCallBound$1() {
  if (hasRequiredCallBound$1) return callBound$1;
  hasRequiredCallBound$1 = 1;
  var o = /* @__PURE__ */ requireGetIntrinsic(), g = requireCallBindApplyHelpers(), c = g([o("%String.prototype.indexOf%")]);
  return callBound$1 = function(t, d) {
    var E = (
      /** @type {(this: unknown, ...args: unknown[]) => unknown} */
      o(t, !!d)
    );
    return typeof E == "function" && c(t, ".prototype.") > -1 ? g(
      /** @type {const} */
      [E]
    ) : E;
  }, callBound$1;
}
var isCallable, hasRequiredIsCallable;
function requireIsCallable() {
  if (hasRequiredIsCallable) return isCallable;
  hasRequiredIsCallable = 1;
  var o = Function.prototype.toString, g = typeof Reflect == "object" && Reflect !== null && Reflect.apply, c, y;
  if (typeof g == "function" && typeof Object.defineProperty == "function")
    try {
      c = Object.defineProperty({}, "length", {
        get: function() {
          throw y;
        }
      }), y = {}, g(function() {
        throw 42;
      }, null, c);
    } catch (Ie) {
      Ie !== y && (g = null);
    }
  else
    g = null;
  var t = /^\s*class\b/, d = function(Ee) {
    try {
      var Se = o.call(Ee);
      return t.test(Se);
    } catch {
      return !1;
    }
  }, E = function(Ee) {
    try {
      return d(Ee) ? !1 : (o.call(Ee), !0);
    } catch {
      return !1;
    }
  }, B = Object.prototype.toString, D = "[object Object]", x = "[object Function]", v = "[object GeneratorFunction]", F = "[object HTMLAllCollection]", M = "[object HTML document.all class]", U = "[object HTMLCollection]", L = typeof Symbol == "function" && !!Symbol.toStringTag, H = !(0 in [,]), fe = function() {
    return !1;
  };
  if (typeof document == "object") {
    var ge = document.all;
    B.call(ge) === B.call(document.all) && (fe = function(Ee) {
      if ((H || !Ee) && (typeof Ee > "u" || typeof Ee == "object"))
        try {
          var Se = B.call(Ee);
          return (Se === F || Se === M || Se === U || Se === D) && Ee("") == null;
        } catch {
        }
      return !1;
    });
  }
  return isCallable = g ? function(Ee) {
    if (fe(Ee))
      return !0;
    if (!Ee || typeof Ee != "function" && typeof Ee != "object")
      return !1;
    try {
      g(Ee, null, c);
    } catch (Se) {
      if (Se !== y)
        return !1;
    }
    return !d(Ee) && E(Ee);
  } : function(Ee) {
    if (fe(Ee))
      return !0;
    if (!Ee || typeof Ee != "function" && typeof Ee != "object")
      return !1;
    if (L)
      return E(Ee);
    if (d(Ee))
      return !1;
    var Se = B.call(Ee);
    return Se !== x && Se !== v && !/^\[object HTML/.test(Se) ? !1 : E(Ee);
  }, isCallable;
}
var forEach, hasRequiredForEach;
function requireForEach() {
  if (hasRequiredForEach) return forEach;
  hasRequiredForEach = 1;
  var o = requireIsCallable(), g = Object.prototype.toString, c = Object.prototype.hasOwnProperty, y = function(D, x, v) {
    for (var F = 0, M = D.length; F < M; F++)
      c.call(D, F) && (v == null ? x(D[F], F, D) : x.call(v, D[F], F, D));
  }, t = function(D, x, v) {
    for (var F = 0, M = D.length; F < M; F++)
      v == null ? x(D.charAt(F), F, D) : x.call(v, D.charAt(F), F, D);
  }, d = function(D, x, v) {
    for (var F in D)
      c.call(D, F) && (v == null ? x(D[F], F, D) : x.call(v, D[F], F, D));
  };
  function E(B) {
    return g.call(B) === "[object Array]";
  }
  return forEach = function(D, x, v) {
    if (!o(x))
      throw new TypeError("iterator must be a function");
    var F;
    arguments.length >= 3 && (F = v), E(D) ? y(D, x, F) : typeof D == "string" ? t(D, x, F) : d(D, x, F);
  }, forEach;
}
var possibleTypedArrayNames, hasRequiredPossibleTypedArrayNames;
function requirePossibleTypedArrayNames() {
  return hasRequiredPossibleTypedArrayNames || (hasRequiredPossibleTypedArrayNames = 1, possibleTypedArrayNames = [
    "Float16Array",
    "Float32Array",
    "Float64Array",
    "Int8Array",
    "Int16Array",
    "Int32Array",
    "Uint8Array",
    "Uint8ClampedArray",
    "Uint16Array",
    "Uint32Array",
    "BigInt64Array",
    "BigUint64Array"
  ]), possibleTypedArrayNames;
}
var availableTypedArrays, hasRequiredAvailableTypedArrays;
function requireAvailableTypedArrays() {
  if (hasRequiredAvailableTypedArrays) return availableTypedArrays;
  hasRequiredAvailableTypedArrays = 1;
  var o = /* @__PURE__ */ requirePossibleTypedArrayNames(), g = typeof globalThis > "u" ? commonjsGlobal : globalThis;
  return availableTypedArrays = function() {
    for (var y = [], t = 0; t < o.length; t++)
      typeof g[o[t]] == "function" && (y[y.length] = o[t]);
    return y;
  }, availableTypedArrays;
}
var callBind = { exports: {} }, defineDataProperty, hasRequiredDefineDataProperty;
function requireDefineDataProperty() {
  if (hasRequiredDefineDataProperty) return defineDataProperty;
  hasRequiredDefineDataProperty = 1;
  var o = /* @__PURE__ */ requireEsDefineProperty(), g = /* @__PURE__ */ requireSyntax(), c = /* @__PURE__ */ requireType(), y = /* @__PURE__ */ requireGopd();
  return defineDataProperty = function(d, E, B) {
    if (!d || typeof d != "object" && typeof d != "function")
      throw new c("`obj` must be an object or a function`");
    if (typeof E != "string" && typeof E != "symbol")
      throw new c("`property` must be a string or a symbol`");
    if (arguments.length > 3 && typeof arguments[3] != "boolean" && arguments[3] !== null)
      throw new c("`nonEnumerable`, if provided, must be a boolean or null");
    if (arguments.length > 4 && typeof arguments[4] != "boolean" && arguments[4] !== null)
      throw new c("`nonWritable`, if provided, must be a boolean or null");
    if (arguments.length > 5 && typeof arguments[5] != "boolean" && arguments[5] !== null)
      throw new c("`nonConfigurable`, if provided, must be a boolean or null");
    if (arguments.length > 6 && typeof arguments[6] != "boolean")
      throw new c("`loose`, if provided, must be a boolean");
    var D = arguments.length > 3 ? arguments[3] : null, x = arguments.length > 4 ? arguments[4] : null, v = arguments.length > 5 ? arguments[5] : null, F = arguments.length > 6 ? arguments[6] : !1, M = !!y && y(d, E);
    if (o)
      o(d, E, {
        configurable: v === null && M ? M.configurable : !v,
        enumerable: D === null && M ? M.enumerable : !D,
        value: B,
        writable: x === null && M ? M.writable : !x
      });
    else if (F || !D && !x && !v)
      d[E] = B;
    else
      throw new g("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
  }, defineDataProperty;
}
var hasPropertyDescriptors_1, hasRequiredHasPropertyDescriptors;
function requireHasPropertyDescriptors() {
  if (hasRequiredHasPropertyDescriptors) return hasPropertyDescriptors_1;
  hasRequiredHasPropertyDescriptors = 1;
  var o = /* @__PURE__ */ requireEsDefineProperty(), g = function() {
    return !!o;
  };
  return g.hasArrayLengthDefineBug = function() {
    if (!o)
      return null;
    try {
      return o([], "length", { value: 1 }).length !== 1;
    } catch {
      return !0;
    }
  }, hasPropertyDescriptors_1 = g, hasPropertyDescriptors_1;
}
var setFunctionLength, hasRequiredSetFunctionLength;
function requireSetFunctionLength() {
  if (hasRequiredSetFunctionLength) return setFunctionLength;
  hasRequiredSetFunctionLength = 1;
  var o = /* @__PURE__ */ requireGetIntrinsic(), g = /* @__PURE__ */ requireDefineDataProperty(), c = /* @__PURE__ */ requireHasPropertyDescriptors()(), y = /* @__PURE__ */ requireGopd(), t = /* @__PURE__ */ requireType(), d = o("%Math.floor%");
  return setFunctionLength = function(B, D) {
    if (typeof B != "function")
      throw new t("`fn` is not a function");
    if (typeof D != "number" || D < 0 || D > 4294967295 || d(D) !== D)
      throw new t("`length` must be a positive 32-bit integer");
    var x = arguments.length > 2 && !!arguments[2], v = !0, F = !0;
    if ("length" in B && y) {
      var M = y(B, "length");
      M && !M.configurable && (v = !1), M && !M.writable && (F = !1);
    }
    return (v || F || !x) && (c ? g(
      /** @type {Parameters<define>[0]} */
      B,
      "length",
      D,
      !0,
      !0
    ) : g(
      /** @type {Parameters<define>[0]} */
      B,
      "length",
      D
    )), B;
  }, setFunctionLength;
}
var applyBind, hasRequiredApplyBind;
function requireApplyBind() {
  if (hasRequiredApplyBind) return applyBind;
  hasRequiredApplyBind = 1;
  var o = requireFunctionBind(), g = requireFunctionApply(), c = requireActualApply();
  return applyBind = function() {
    return c(o, g, arguments);
  }, applyBind;
}
var hasRequiredCallBind;
function requireCallBind() {
  return hasRequiredCallBind || (hasRequiredCallBind = 1, function(o) {
    var g = /* @__PURE__ */ requireSetFunctionLength(), c = /* @__PURE__ */ requireEsDefineProperty(), y = requireCallBindApplyHelpers(), t = requireApplyBind();
    o.exports = function(E) {
      var B = y(arguments), D = E.length - (arguments.length - 1);
      return g(
        B,
        1 + (D > 0 ? D : 0),
        !0
      );
    }, c ? c(o.exports, "apply", { value: t }) : o.exports.apply = t;
  }(callBind)), callBind.exports;
}
var shams, hasRequiredShams;
function requireShams() {
  if (hasRequiredShams) return shams;
  hasRequiredShams = 1;
  var o = requireShams$1();
  return shams = function() {
    return o() && !!Symbol.toStringTag;
  }, shams;
}
var whichTypedArray, hasRequiredWhichTypedArray;
function requireWhichTypedArray() {
  if (hasRequiredWhichTypedArray) return whichTypedArray;
  hasRequiredWhichTypedArray = 1;
  var o = requireForEach(), g = /* @__PURE__ */ requireAvailableTypedArrays(), c = requireCallBind(), y = /* @__PURE__ */ requireCallBound$1(), t = /* @__PURE__ */ requireGopd(), d = requireGetProto(), E = y("Object.prototype.toString"), B = requireShams()(), D = typeof globalThis > "u" ? commonjsGlobal : globalThis, x = g(), v = y("String.prototype.slice"), F = y("Array.prototype.indexOf", !0) || function(fe, ge) {
    for (var Ie = 0; Ie < fe.length; Ie += 1)
      if (fe[Ie] === ge)
        return Ie;
    return -1;
  }, M = { __proto__: null };
  B && t && d ? o(x, function(H) {
    var fe = new D[H]();
    if (Symbol.toStringTag in fe && d) {
      var ge = d(fe), Ie = t(ge, Symbol.toStringTag);
      if (!Ie && ge) {
        var Ee = d(ge);
        Ie = t(Ee, Symbol.toStringTag);
      }
      M["$" + H] = c(Ie.get);
    }
  }) : o(x, function(H) {
    var fe = new D[H](), ge = fe.slice || fe.set;
    ge && (M[
      /** @type {`$${import('.').TypedArrayName}`} */
      "$" + H
    ] = /** @type {import('./types').BoundSlice | import('./types').BoundSet} */
    // @ts-expect-error TODO FIXME
    c(ge));
  });
  var U = function(fe) {
    var ge = !1;
    return o(
      /** @type {Record<`\$${import('.').TypedArrayName}`, Getter>} */
      M,
      /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */
      function(Ie, Ee) {
        if (!ge)
          try {
            "$" + Ie(fe) === Ee && (ge = /** @type {import('.').TypedArrayName} */
            v(Ee, 1));
          } catch {
          }
      }
    ), ge;
  }, L = function(fe) {
    var ge = !1;
    return o(
      /** @type {Record<`\$${import('.').TypedArrayName}`, Getter>} */
      M,
      /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */
      function(Ie, Ee) {
        if (!ge)
          try {
            Ie(fe), ge = /** @type {import('.').TypedArrayName} */
            v(Ee, 1);
          } catch {
          }
      }
    ), ge;
  };
  return whichTypedArray = function(fe) {
    if (!fe || typeof fe != "object")
      return !1;
    if (!B) {
      var ge = v(E(fe), 8, -1);
      return F(x, ge) > -1 ? ge : ge !== "Object" ? !1 : L(fe);
    }
    return t ? U(fe) : null;
  }, whichTypedArray;
}
var isTypedArray, hasRequiredIsTypedArray;
function requireIsTypedArray() {
  if (hasRequiredIsTypedArray) return isTypedArray;
  hasRequiredIsTypedArray = 1;
  var o = /* @__PURE__ */ requireWhichTypedArray();
  return isTypedArray = function(c) {
    return !!o(c);
  }, isTypedArray;
}
var typedArrayBuffer, hasRequiredTypedArrayBuffer;
function requireTypedArrayBuffer() {
  if (hasRequiredTypedArrayBuffer) return typedArrayBuffer;
  hasRequiredTypedArrayBuffer = 1;
  var o = /* @__PURE__ */ requireType(), g = /* @__PURE__ */ requireCallBound$1(), c = g("TypedArray.prototype.buffer", !0), y = /* @__PURE__ */ requireIsTypedArray();
  return typedArrayBuffer = c || function(d) {
    if (!y(d))
      throw new o("Not a Typed Array");
    return d.buffer;
  }, typedArrayBuffer;
}
var toBuffer, hasRequiredToBuffer$1;
function requireToBuffer$1() {
  if (hasRequiredToBuffer$1) return toBuffer;
  hasRequiredToBuffer$1 = 1;
  var o = requireSafeBuffer$1().Buffer, g = requireIsarray$1(), c = /* @__PURE__ */ requireTypedArrayBuffer(), y = ArrayBuffer.isView || function(D) {
    try {
      return c(D), !0;
    } catch {
      return !1;
    }
  }, t = typeof Uint8Array < "u", d = typeof ArrayBuffer < "u" && typeof Uint8Array < "u", E = d && (o.prototype instanceof Uint8Array || o.TYPED_ARRAY_SUPPORT);
  return toBuffer = function(D, x) {
    if (D instanceof o)
      return D;
    if (typeof D == "string")
      return o.from(D, x);
    if (d && y(D)) {
      if (D.byteLength === 0)
        return o.alloc(0);
      if (E) {
        var v = o.from(D.buffer, D.byteOffset, D.byteLength);
        if (v.byteLength === D.byteLength)
          return v;
      }
      var F = D instanceof Uint8Array ? D : new Uint8Array(D.buffer, D.byteOffset, D.byteLength), M = o.from(F);
      if (M.length === D.byteLength)
        return M;
    }
    if (t && D instanceof Uint8Array)
      return o.from(D);
    var U = g(D);
    if (U)
      for (var L = 0; L < D.length; L += 1) {
        var H = D[L];
        if (typeof H != "number" || H < 0 || H > 255 || ~~H !== H)
          throw new RangeError("Array items must be numbers in the range 0-255.");
      }
    if (U || o.isBuffer(D) && D.constructor && typeof D.constructor.isBuffer == "function" && D.constructor.isBuffer(D))
      return o.from(D);
    throw new TypeError('The "data" argument must be a string, an Array, a Buffer, a Uint8Array, or a DataView.');
  }, toBuffer;
}
var hash$p, hasRequiredHash$2;
function requireHash$2() {
  if (hasRequiredHash$2) return hash$p;
  hasRequiredHash$2 = 1;
  var o = requireSafeBuffer$1().Buffer, g = /* @__PURE__ */ requireToBuffer$1();
  function c(y, t) {
    this._block = o.alloc(y), this._finalSize = t, this._blockSize = y, this._len = 0;
  }
  return c.prototype.update = function(y, t) {
    y = g(y, t || "utf8");
    for (var d = this._block, E = this._blockSize, B = y.length, D = this._len, x = 0; x < B; ) {
      for (var v = D % E, F = Math.min(B - x, E - v), M = 0; M < F; M++)
        d[v + M] = y[x + M];
      D += F, x += F, D % E === 0 && this._update(d);
    }
    return this._len += B, this;
  }, c.prototype.digest = function(y) {
    var t = this._len % this._blockSize;
    this._block[t] = 128, this._block.fill(0, t + 1), t >= this._finalSize && (this._update(this._block), this._block.fill(0));
    var d = this._len * 8;
    if (d <= 4294967295)
      this._block.writeUInt32BE(d, this._blockSize - 4);
    else {
      var E = (d & 4294967295) >>> 0, B = (d - E) / 4294967296;
      this._block.writeUInt32BE(B, this._blockSize - 8), this._block.writeUInt32BE(E, this._blockSize - 4);
    }
    this._update(this._block);
    var D = this._hash();
    return y ? D.toString(y) : D;
  }, c.prototype._update = function() {
    throw new Error("_update must be implemented by subclass");
  }, hash$p = c, hash$p;
}
var sha$2, hasRequiredSha$2;
function requireSha$2() {
  if (hasRequiredSha$2) return sha$2;
  hasRequiredSha$2 = 1;
  var o = requireInherits_browser(), g = requireHash$2(), c = requireSafeBuffer$1().Buffer, y = [
    1518500249,
    1859775393,
    -1894007588,
    -899497514
  ], t = new Array(80);
  function d() {
    this.init(), this._w = t, g.call(this, 64, 56);
  }
  o(d, g), d.prototype.init = function() {
    return this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520, this;
  };
  function E(x) {
    return x << 5 | x >>> 27;
  }
  function B(x) {
    return x << 30 | x >>> 2;
  }
  function D(x, v, F, M) {
    return x === 0 ? v & F | ~v & M : x === 2 ? v & F | v & M | F & M : v ^ F ^ M;
  }
  return d.prototype._update = function(x) {
    for (var v = this._w, F = this._a | 0, M = this._b | 0, U = this._c | 0, L = this._d | 0, H = this._e | 0, fe = 0; fe < 16; ++fe)
      v[fe] = x.readInt32BE(fe * 4);
    for (; fe < 80; ++fe)
      v[fe] = v[fe - 3] ^ v[fe - 8] ^ v[fe - 14] ^ v[fe - 16];
    for (var ge = 0; ge < 80; ++ge) {
      var Ie = ~~(ge / 20), Ee = E(F) + D(Ie, M, U, L) + H + v[ge] + y[Ie] | 0;
      H = L, L = U, U = B(M), M = F, F = Ee;
    }
    this._a = F + this._a | 0, this._b = M + this._b | 0, this._c = U + this._c | 0, this._d = L + this._d | 0, this._e = H + this._e | 0;
  }, d.prototype._hash = function() {
    var x = c.allocUnsafe(20);
    return x.writeInt32BE(this._a | 0, 0), x.writeInt32BE(this._b | 0, 4), x.writeInt32BE(this._c | 0, 8), x.writeInt32BE(this._d | 0, 12), x.writeInt32BE(this._e | 0, 16), x;
  }, sha$2 = d, sha$2;
}
var sha1$4, hasRequiredSha1$2;
function requireSha1$2() {
  if (hasRequiredSha1$2) return sha1$4;
  hasRequiredSha1$2 = 1;
  var o = requireInherits_browser(), g = requireHash$2(), c = requireSafeBuffer$1().Buffer, y = [
    1518500249,
    1859775393,
    -1894007588,
    -899497514
  ], t = new Array(80);
  function d() {
    this.init(), this._w = t, g.call(this, 64, 56);
  }
  o(d, g), d.prototype.init = function() {
    return this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520, this;
  };
  function E(v) {
    return v << 1 | v >>> 31;
  }
  function B(v) {
    return v << 5 | v >>> 27;
  }
  function D(v) {
    return v << 30 | v >>> 2;
  }
  function x(v, F, M, U) {
    return v === 0 ? F & M | ~F & U : v === 2 ? F & M | F & U | M & U : F ^ M ^ U;
  }
  return d.prototype._update = function(v) {
    for (var F = this._w, M = this._a | 0, U = this._b | 0, L = this._c | 0, H = this._d | 0, fe = this._e | 0, ge = 0; ge < 16; ++ge)
      F[ge] = v.readInt32BE(ge * 4);
    for (; ge < 80; ++ge)
      F[ge] = E(F[ge - 3] ^ F[ge - 8] ^ F[ge - 14] ^ F[ge - 16]);
    for (var Ie = 0; Ie < 80; ++Ie) {
      var Ee = ~~(Ie / 20), Se = B(M) + x(Ee, U, L, H) + fe + F[Ie] + y[Ee] | 0;
      fe = H, H = L, L = D(U), U = M, M = Se;
    }
    this._a = M + this._a | 0, this._b = U + this._b | 0, this._c = L + this._c | 0, this._d = H + this._d | 0, this._e = fe + this._e | 0;
  }, d.prototype._hash = function() {
    var v = c.allocUnsafe(20);
    return v.writeInt32BE(this._a | 0, 0), v.writeInt32BE(this._b | 0, 4), v.writeInt32BE(this._c | 0, 8), v.writeInt32BE(this._d | 0, 12), v.writeInt32BE(this._e | 0, 16), v;
  }, sha1$4 = d, sha1$4;
}
var sha256$8, hasRequiredSha256$4;
function requireSha256$4() {
  if (hasRequiredSha256$4) return sha256$8;
  hasRequiredSha256$4 = 1;
  var o = requireInherits_browser(), g = requireHash$2(), c = requireSafeBuffer$1().Buffer, y = [
    1116352408,
    1899447441,
    3049323471,
    3921009573,
    961987163,
    1508970993,
    2453635748,
    2870763221,
    3624381080,
    310598401,
    607225278,
    1426881987,
    1925078388,
    2162078206,
    2614888103,
    3248222580,
    3835390401,
    4022224774,
    264347078,
    604807628,
    770255983,
    1249150122,
    1555081692,
    1996064986,
    2554220882,
    2821834349,
    2952996808,
    3210313671,
    3336571891,
    3584528711,
    113926993,
    338241895,
    666307205,
    773529912,
    1294757372,
    1396182291,
    1695183700,
    1986661051,
    2177026350,
    2456956037,
    2730485921,
    2820302411,
    3259730800,
    3345764771,
    3516065817,
    3600352804,
    4094571909,
    275423344,
    430227734,
    506948616,
    659060556,
    883997877,
    958139571,
    1322822218,
    1537002063,
    1747873779,
    1955562222,
    2024104815,
    2227730452,
    2361852424,
    2428436474,
    2756734187,
    3204031479,
    3329325298
  ], t = new Array(64);
  function d() {
    this.init(), this._w = t, g.call(this, 64, 56);
  }
  o(d, g), d.prototype.init = function() {
    return this._a = 1779033703, this._b = 3144134277, this._c = 1013904242, this._d = 2773480762, this._e = 1359893119, this._f = 2600822924, this._g = 528734635, this._h = 1541459225, this;
  };
  function E(M, U, L) {
    return L ^ M & (U ^ L);
  }
  function B(M, U, L) {
    return M & U | L & (M | U);
  }
  function D(M) {
    return (M >>> 2 | M << 30) ^ (M >>> 13 | M << 19) ^ (M >>> 22 | M << 10);
  }
  function x(M) {
    return (M >>> 6 | M << 26) ^ (M >>> 11 | M << 21) ^ (M >>> 25 | M << 7);
  }
  function v(M) {
    return (M >>> 7 | M << 25) ^ (M >>> 18 | M << 14) ^ M >>> 3;
  }
  function F(M) {
    return (M >>> 17 | M << 15) ^ (M >>> 19 | M << 13) ^ M >>> 10;
  }
  return d.prototype._update = function(M) {
    for (var U = this._w, L = this._a | 0, H = this._b | 0, fe = this._c | 0, ge = this._d | 0, Ie = this._e | 0, Ee = this._f | 0, Se = this._g | 0, ze = this._h | 0, He = 0; He < 16; ++He)
      U[He] = M.readInt32BE(He * 4);
    for (; He < 64; ++He)
      U[He] = F(U[He - 2]) + U[He - 7] + v(U[He - 15]) + U[He - 16] | 0;
    for (var Pe = 0; Pe < 64; ++Pe) {
      var De = ze + x(Ie) + E(Ie, Ee, Se) + y[Pe] + U[Pe] | 0, ve = D(L) + B(L, H, fe) | 0;
      ze = Se, Se = Ee, Ee = Ie, Ie = ge + De | 0, ge = fe, fe = H, H = L, L = De + ve | 0;
    }
    this._a = L + this._a | 0, this._b = H + this._b | 0, this._c = fe + this._c | 0, this._d = ge + this._d | 0, this._e = Ie + this._e | 0, this._f = Ee + this._f | 0, this._g = Se + this._g | 0, this._h = ze + this._h | 0;
  }, d.prototype._hash = function() {
    var M = c.allocUnsafe(32);
    return M.writeInt32BE(this._a, 0), M.writeInt32BE(this._b, 4), M.writeInt32BE(this._c, 8), M.writeInt32BE(this._d, 12), M.writeInt32BE(this._e, 16), M.writeInt32BE(this._f, 20), M.writeInt32BE(this._g, 24), M.writeInt32BE(this._h, 28), M;
  }, sha256$8 = d, sha256$8;
}
var sha224$2, hasRequiredSha224;
function requireSha224() {
  if (hasRequiredSha224) return sha224$2;
  hasRequiredSha224 = 1;
  var o = requireInherits_browser(), g = requireSha256$4(), c = requireHash$2(), y = requireSafeBuffer$1().Buffer, t = new Array(64);
  function d() {
    this.init(), this._w = t, c.call(this, 64, 56);
  }
  return o(d, g), d.prototype.init = function() {
    return this._a = 3238371032, this._b = 914150663, this._c = 812702999, this._d = 4144912697, this._e = 4290775857, this._f = 1750603025, this._g = 1694076839, this._h = 3204075428, this;
  }, d.prototype._hash = function() {
    var E = y.allocUnsafe(28);
    return E.writeInt32BE(this._a, 0), E.writeInt32BE(this._b, 4), E.writeInt32BE(this._c, 8), E.writeInt32BE(this._d, 12), E.writeInt32BE(this._e, 16), E.writeInt32BE(this._f, 20), E.writeInt32BE(this._g, 24), E;
  }, sha224$2 = d, sha224$2;
}
var sha512$4, hasRequiredSha512$1;
function requireSha512$1() {
  if (hasRequiredSha512$1) return sha512$4;
  hasRequiredSha512$1 = 1;
  var o = requireInherits_browser(), g = requireHash$2(), c = requireSafeBuffer$1().Buffer, y = [
    1116352408,
    3609767458,
    1899447441,
    602891725,
    3049323471,
    3964484399,
    3921009573,
    2173295548,
    961987163,
    4081628472,
    1508970993,
    3053834265,
    2453635748,
    2937671579,
    2870763221,
    3664609560,
    3624381080,
    2734883394,
    310598401,
    1164996542,
    607225278,
    1323610764,
    1426881987,
    3590304994,
    1925078388,
    4068182383,
    2162078206,
    991336113,
    2614888103,
    633803317,
    3248222580,
    3479774868,
    3835390401,
    2666613458,
    4022224774,
    944711139,
    264347078,
    2341262773,
    604807628,
    2007800933,
    770255983,
    1495990901,
    1249150122,
    1856431235,
    1555081692,
    3175218132,
    1996064986,
    2198950837,
    2554220882,
    3999719339,
    2821834349,
    766784016,
    2952996808,
    2566594879,
    3210313671,
    3203337956,
    3336571891,
    1034457026,
    3584528711,
    2466948901,
    113926993,
    3758326383,
    338241895,
    168717936,
    666307205,
    1188179964,
    773529912,
    1546045734,
    1294757372,
    1522805485,
    1396182291,
    2643833823,
    1695183700,
    2343527390,
    1986661051,
    1014477480,
    2177026350,
    1206759142,
    2456956037,
    344077627,
    2730485921,
    1290863460,
    2820302411,
    3158454273,
    3259730800,
    3505952657,
    3345764771,
    106217008,
    3516065817,
    3606008344,
    3600352804,
    1432725776,
    4094571909,
    1467031594,
    275423344,
    851169720,
    430227734,
    3100823752,
    506948616,
    1363258195,
    659060556,
    3750685593,
    883997877,
    3785050280,
    958139571,
    3318307427,
    1322822218,
    3812723403,
    1537002063,
    2003034995,
    1747873779,
    3602036899,
    1955562222,
    1575990012,
    2024104815,
    1125592928,
    2227730452,
    2716904306,
    2361852424,
    442776044,
    2428436474,
    593698344,
    2756734187,
    3733110249,
    3204031479,
    2999351573,
    3329325298,
    3815920427,
    3391569614,
    3928383900,
    3515267271,
    566280711,
    3940187606,
    3454069534,
    4118630271,
    4000239992,
    116418474,
    1914138554,
    174292421,
    2731055270,
    289380356,
    3203993006,
    460393269,
    320620315,
    685471733,
    587496836,
    852142971,
    1086792851,
    1017036298,
    365543100,
    1126000580,
    2618297676,
    1288033470,
    3409855158,
    1501505948,
    4234509866,
    1607167915,
    987167468,
    1816402316,
    1246189591
  ], t = new Array(160);
  function d() {
    this.init(), this._w = t, g.call(this, 128, 112);
  }
  o(d, g), d.prototype.init = function() {
    return this._ah = 1779033703, this._bh = 3144134277, this._ch = 1013904242, this._dh = 2773480762, this._eh = 1359893119, this._fh = 2600822924, this._gh = 528734635, this._hh = 1541459225, this._al = 4089235720, this._bl = 2227873595, this._cl = 4271175723, this._dl = 1595750129, this._el = 2917565137, this._fl = 725511199, this._gl = 4215389547, this._hl = 327033209, this;
  };
  function E(H, fe, ge) {
    return ge ^ H & (fe ^ ge);
  }
  function B(H, fe, ge) {
    return H & fe | ge & (H | fe);
  }
  function D(H, fe) {
    return (H >>> 28 | fe << 4) ^ (fe >>> 2 | H << 30) ^ (fe >>> 7 | H << 25);
  }
  function x(H, fe) {
    return (H >>> 14 | fe << 18) ^ (H >>> 18 | fe << 14) ^ (fe >>> 9 | H << 23);
  }
  function v(H, fe) {
    return (H >>> 1 | fe << 31) ^ (H >>> 8 | fe << 24) ^ H >>> 7;
  }
  function F(H, fe) {
    return (H >>> 1 | fe << 31) ^ (H >>> 8 | fe << 24) ^ (H >>> 7 | fe << 25);
  }
  function M(H, fe) {
    return (H >>> 19 | fe << 13) ^ (fe >>> 29 | H << 3) ^ H >>> 6;
  }
  function U(H, fe) {
    return (H >>> 19 | fe << 13) ^ (fe >>> 29 | H << 3) ^ (H >>> 6 | fe << 26);
  }
  function L(H, fe) {
    return H >>> 0 < fe >>> 0 ? 1 : 0;
  }
  return d.prototype._update = function(H) {
    for (var fe = this._w, ge = this._ah | 0, Ie = this._bh | 0, Ee = this._ch | 0, Se = this._dh | 0, ze = this._eh | 0, He = this._fh | 0, Pe = this._gh | 0, De = this._hh | 0, ve = this._al | 0, Fe = this._bl | 0, be = this._cl | 0, Be = this._dl | 0, ke = this._el | 0, xe = this._fl | 0, Ne = this._gl | 0, Et = this._hl | 0, st = 0; st < 32; st += 2)
      fe[st] = H.readInt32BE(st * 4), fe[st + 1] = H.readInt32BE(st * 4 + 4);
    for (; st < 160; st += 2) {
      var Dt = fe[st - 30], er = fe[st - 30 + 1], xt = v(Dt, er), ir = F(er, Dt);
      Dt = fe[st - 4], er = fe[st - 4 + 1];
      var sr = M(Dt, er), yr = U(er, Dt), wr = fe[st - 14], qr = fe[st - 14 + 1], Mr = fe[st - 32], Dr = fe[st - 32 + 1], Qr = ir + qr | 0, Xr = xt + wr + L(Qr, ir) | 0;
      Qr = Qr + yr | 0, Xr = Xr + sr + L(Qr, yr) | 0, Qr = Qr + Dr | 0, Xr = Xr + Mr + L(Qr, Dr) | 0, fe[st] = Xr, fe[st + 1] = Qr;
    }
    for (var Vr = 0; Vr < 160; Vr += 2) {
      Xr = fe[Vr], Qr = fe[Vr + 1];
      var Ur = B(ge, Ie, Ee), Sr = B(ve, Fe, be), Gr = D(ge, ve), Fr = D(ve, ge), br = x(ze, ke), Ar = x(ke, ze), cr = y[Vr], hr = y[Vr + 1], Wr = E(ze, He, Pe), fi = E(ke, xe, Ne), Bi = Et + Ar | 0, $r = De + br + L(Bi, Et) | 0;
      Bi = Bi + fi | 0, $r = $r + Wr + L(Bi, fi) | 0, Bi = Bi + hr | 0, $r = $r + cr + L(Bi, hr) | 0, Bi = Bi + Qr | 0, $r = $r + Xr + L(Bi, Qr) | 0;
      var oi = Fr + Sr | 0, zr = Gr + Ur + L(oi, Fr) | 0;
      De = Pe, Et = Ne, Pe = He, Ne = xe, He = ze, xe = ke, ke = Be + Bi | 0, ze = Se + $r + L(ke, Be) | 0, Se = Ee, Be = be, Ee = Ie, be = Fe, Ie = ge, Fe = ve, ve = Bi + oi | 0, ge = $r + zr + L(ve, Bi) | 0;
    }
    this._al = this._al + ve | 0, this._bl = this._bl + Fe | 0, this._cl = this._cl + be | 0, this._dl = this._dl + Be | 0, this._el = this._el + ke | 0, this._fl = this._fl + xe | 0, this._gl = this._gl + Ne | 0, this._hl = this._hl + Et | 0, this._ah = this._ah + ge + L(this._al, ve) | 0, this._bh = this._bh + Ie + L(this._bl, Fe) | 0, this._ch = this._ch + Ee + L(this._cl, be) | 0, this._dh = this._dh + Se + L(this._dl, Be) | 0, this._eh = this._eh + ze + L(this._el, ke) | 0, this._fh = this._fh + He + L(this._fl, xe) | 0, this._gh = this._gh + Pe + L(this._gl, Ne) | 0, this._hh = this._hh + De + L(this._hl, Et) | 0;
  }, d.prototype._hash = function() {
    var H = c.allocUnsafe(64);
    function fe(ge, Ie, Ee) {
      H.writeInt32BE(ge, Ee), H.writeInt32BE(Ie, Ee + 4);
    }
    return fe(this._ah, this._al, 0), fe(this._bh, this._bl, 8), fe(this._ch, this._cl, 16), fe(this._dh, this._dl, 24), fe(this._eh, this._el, 32), fe(this._fh, this._fl, 40), fe(this._gh, this._gl, 48), fe(this._hh, this._hl, 56), H;
  }, sha512$4 = d, sha512$4;
}
var sha384$2, hasRequiredSha384;
function requireSha384() {
  if (hasRequiredSha384) return sha384$2;
  hasRequiredSha384 = 1;
  var o = requireInherits_browser(), g = requireSha512$1(), c = requireHash$2(), y = requireSafeBuffer$1().Buffer, t = new Array(160);
  function d() {
    this.init(), this._w = t, c.call(this, 128, 112);
  }
  return o(d, g), d.prototype.init = function() {
    return this._ah = 3418070365, this._bh = 1654270250, this._ch = 2438529370, this._dh = 355462360, this._eh = 1731405415, this._fh = 2394180231, this._gh = 3675008525, this._hh = 1203062813, this._al = 3238371032, this._bl = 914150663, this._cl = 812702999, this._dl = 4144912697, this._el = 4290775857, this._fl = 1750603025, this._gl = 1694076839, this._hl = 3204075428, this;
  }, d.prototype._hash = function() {
    var E = y.allocUnsafe(48);
    function B(D, x, v) {
      E.writeInt32BE(D, v), E.writeInt32BE(x, v + 4);
    }
    return B(this._ah, this._al, 0), B(this._bh, this._bl, 8), B(this._ch, this._cl, 16), B(this._dh, this._dl, 24), B(this._eh, this._el, 32), B(this._fh, this._fl, 40), E;
  }, sha384$2 = d, sha384$2;
}
var hasRequiredSha_js;
function requireSha_js() {
  return hasRequiredSha_js || (hasRequiredSha_js = 1, function(o) {
    o.exports = function(c) {
      var y = c.toLowerCase(), t = o.exports[y];
      if (!t)
        throw new Error(y + " is not supported (we accept pull requests)");
      return new t();
    }, o.exports.sha = requireSha$2(), o.exports.sha1 = requireSha1$2(), o.exports.sha224 = requireSha224(), o.exports.sha256 = requireSha256$4(), o.exports.sha384 = requireSha384(), o.exports.sha512 = requireSha512$1();
  }(sha_js)), sha_js.exports;
}
var cipherBase, hasRequiredCipherBase;
function requireCipherBase() {
  if (hasRequiredCipherBase) return cipherBase;
  hasRequiredCipherBase = 1;
  var o = requireSafeBuffer$1().Buffer, g = require$$2$2.Transform, c = requireString_decoder$1().StringDecoder, y = requireInherits_browser();
  function t(D) {
    g.call(this), this.hashMode = typeof D == "string", this.hashMode ? this[D] = this._finalOrDigest : this.final = this._finalOrDigest, this._final && (this.__final = this._final, this._final = null), this._decoder = null, this._encoding = null;
  }
  y(t, g);
  var d = typeof Uint8Array < "u", E = typeof ArrayBuffer < "u" && typeof Uint8Array < "u" && ArrayBuffer.isView && (o.prototype instanceof Uint8Array || o.TYPED_ARRAY_SUPPORT);
  function B(D, x) {
    if (D instanceof o)
      return D;
    if (typeof D == "string")
      return o.from(D, x);
    if (E && ArrayBuffer.isView(D)) {
      if (D.byteLength === 0)
        return o.alloc(0);
      var v = o.from(D.buffer, D.byteOffset, D.byteLength);
      if (v.byteLength === D.byteLength)
        return v;
    }
    if (d && D instanceof Uint8Array || o.isBuffer(D) && D.constructor && typeof D.constructor.isBuffer == "function" && D.constructor.isBuffer(D))
      return o.from(D);
    throw new TypeError('The "data" argument must be of type string or an instance of Buffer, TypedArray, or DataView.');
  }
  return t.prototype.update = function(D, x, v) {
    var F = B(D, x), M = this._update(F);
    return this.hashMode ? this : (v && (M = this._toString(M, v)), M);
  }, t.prototype.setAutoPadding = function() {
  }, t.prototype.getAuthTag = function() {
    throw new Error("trying to get auth tag in unsupported state");
  }, t.prototype.setAuthTag = function() {
    throw new Error("trying to set auth tag in unsupported state");
  }, t.prototype.setAAD = function() {
    throw new Error("trying to set aad in unsupported state");
  }, t.prototype._transform = function(D, x, v) {
    var F;
    try {
      this.hashMode ? this._update(D) : this.push(this._update(D));
    } catch (M) {
      F = M;
    } finally {
      v(F);
    }
  }, t.prototype._flush = function(D) {
    var x;
    try {
      this.push(this.__final());
    } catch (v) {
      x = v;
    }
    D(x);
  }, t.prototype._finalOrDigest = function(D) {
    var x = this.__final() || o.alloc(0);
    return D && (x = this._toString(x, D, !0)), x;
  }, t.prototype._toString = function(D, x, v) {
    if (this._decoder || (this._decoder = new c(x), this._encoding = x), this._encoding !== x)
      throw new Error("can’t switch encodings");
    var F = this._decoder.write(D);
    return v && (F += this._decoder.end()), F;
  }, cipherBase = t, cipherBase;
}
var browser$a, hasRequiredBrowser$a;
function requireBrowser$a() {
  if (hasRequiredBrowser$a) return browser$a;
  hasRequiredBrowser$a = 1;
  var o = requireInherits_browser(), g = requireMd5_js(), c = requireRipemd160$2(), y = requireSha_js(), t = requireCipherBase();
  function d(E) {
    t.call(this, "digest"), this._hash = E;
  }
  return o(d, t), d.prototype._update = function(E) {
    this._hash.update(E);
  }, d.prototype._final = function() {
    return this._hash.digest();
  }, browser$a = function(B) {
    return B = B.toLowerCase(), B === "md5" ? new g() : B === "rmd160" || B === "ripemd160" ? new c() : new d(y(B));
  }, browser$a;
}
var src$3, hasRequiredSrc$3;
function requireSrc$3() {
  if (hasRequiredSrc$3) return src$3;
  hasRequiredSrc$3 = 1;
  var o = requireSafeBuffer$1().Buffer;
  function g(c) {
    if (c.length >= 255)
      throw new TypeError("Alphabet too long");
    for (var y = new Uint8Array(256), t = 0; t < y.length; t++)
      y[t] = 255;
    for (var d = 0; d < c.length; d++) {
      var E = c.charAt(d), B = E.charCodeAt(0);
      if (y[B] !== 255)
        throw new TypeError(E + " is ambiguous");
      y[B] = d;
    }
    var D = c.length, x = c.charAt(0), v = Math.log(D) / Math.log(256), F = Math.log(256) / Math.log(D);
    function M(H) {
      if ((Array.isArray(H) || H instanceof Uint8Array) && (H = o.from(H)), !o.isBuffer(H))
        throw new TypeError("Expected Buffer");
      if (H.length === 0)
        return "";
      for (var fe = 0, ge = 0, Ie = 0, Ee = H.length; Ie !== Ee && H[Ie] === 0; )
        Ie++, fe++;
      for (var Se = (Ee - Ie) * F + 1 >>> 0, ze = new Uint8Array(Se); Ie !== Ee; ) {
        for (var He = H[Ie], Pe = 0, De = Se - 1; (He !== 0 || Pe < ge) && De !== -1; De--, Pe++)
          He += 256 * ze[De] >>> 0, ze[De] = He % D >>> 0, He = He / D >>> 0;
        if (He !== 0)
          throw new Error("Non-zero carry");
        ge = Pe, Ie++;
      }
      for (var ve = Se - ge; ve !== Se && ze[ve] === 0; )
        ve++;
      for (var Fe = x.repeat(fe); ve < Se; ++ve)
        Fe += c.charAt(ze[ve]);
      return Fe;
    }
    function U(H) {
      if (typeof H != "string")
        throw new TypeError("Expected String");
      if (H.length === 0)
        return o.alloc(0);
      for (var fe = 0, ge = 0, Ie = 0; H[fe] === x; )
        ge++, fe++;
      for (var Ee = (H.length - fe) * v + 1 >>> 0, Se = new Uint8Array(Ee); fe < H.length; ) {
        var ze = H.charCodeAt(fe);
        if (ze > 255)
          return;
        var He = y[ze];
        if (He === 255)
          return;
        for (var Pe = 0, De = Ee - 1; (He !== 0 || Pe < Ie) && De !== -1; De--, Pe++)
          He += D * Se[De] >>> 0, Se[De] = He % 256 >>> 0, He = He / 256 >>> 0;
        if (He !== 0)
          throw new Error("Non-zero carry");
        Ie = Pe, fe++;
      }
      for (var ve = Ee - Ie; ve !== Ee && Se[ve] === 0; )
        ve++;
      var Fe = o.allocUnsafe(ge + (Ee - ve));
      Fe.fill(0, 0, ge);
      for (var be = ge; ve !== Ee; )
        Fe[be++] = Se[ve++];
      return Fe;
    }
    function L(H) {
      var fe = U(H);
      if (fe)
        return fe;
      throw new Error("Non-base" + D + " character");
    }
    return {
      encode: M,
      decodeUnsafe: U,
      decode: L
    };
  }
  return src$3 = g, src$3;
}
var bs58$1, hasRequiredBs58$1;
function requireBs58$1() {
  if (hasRequiredBs58$1) return bs58$1;
  hasRequiredBs58$1 = 1;
  var o = requireSrc$3(), g = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
  return bs58$1 = o(g), bs58$1;
}
var base$3, hasRequiredBase$3;
function requireBase$3() {
  if (hasRequiredBase$3) return base$3;
  hasRequiredBase$3 = 1;
  var o = requireBs58$1(), g = requireSafeBuffer$1().Buffer;
  return base$3 = function(c) {
    function y(B) {
      var D = c(B);
      return o.encode(g.concat([
        B,
        D
      ], B.length + 4));
    }
    function t(B) {
      var D = B.slice(0, -4), x = B.slice(-4), v = c(D);
      if (!(x[0] ^ v[0] | x[1] ^ v[1] | x[2] ^ v[2] | x[3] ^ v[3]))
        return D;
    }
    function d(B) {
      var D = o.decodeUnsafe(B);
      if (D)
        return t(D);
    }
    function E(B) {
      var D = o.decode(B), x = t(D);
      if (!x) throw new Error("Invalid checksum");
      return x;
    }
    return {
      encode: y,
      decode: E,
      decodeUnsafe: d
    };
  }, base$3;
}
var bs58check$1, hasRequiredBs58check$1;
function requireBs58check$1() {
  if (hasRequiredBs58check$1) return bs58check$1;
  hasRequiredBs58check$1 = 1;
  var o = requireBrowser$a(), g = requireBase$3();
  function c(y) {
    var t = o("sha256").update(y).digest();
    return o("sha256").update(t).digest();
  }
  return bs58check$1 = g(c), bs58check$1;
}
var CryptoCoinInfo$2 = {}, RegistryItem$2 = {}, dist$n = {}, ur$1 = {}, errors$6 = {}, hasRequiredErrors$6;
function requireErrors$6() {
  if (hasRequiredErrors$6) return errors$6;
  hasRequiredErrors$6 = 1, Object.defineProperty(errors$6, "__esModule", { value: !0 }), errors$6.InvalidChecksumError = errors$6.InvalidSequenceComponentError = errors$6.InvalidTypeError = errors$6.InvalidPathLengthError = errors$6.InvalidSchemeError = void 0;
  class o extends Error {
    constructor() {
      super("Invalid Scheme"), this.name = "InvalidSchemeError";
    }
  }
  errors$6.InvalidSchemeError = o;
  class g extends Error {
    constructor() {
      super("Invalid Path"), this.name = "InvalidPathLengthError";
    }
  }
  errors$6.InvalidPathLengthError = g;
  class c extends Error {
    constructor() {
      super("Invalid Type"), this.name = "InvalidTypeError";
    }
  }
  errors$6.InvalidTypeError = c;
  class y extends Error {
    constructor() {
      super("Invalid Sequence Component"), this.name = "InvalidSequenceComponentError";
    }
  }
  errors$6.InvalidSequenceComponentError = y;
  class t extends Error {
    constructor() {
      super("Invalid Checksum"), this.name = "InvalidChecksumError";
    }
  }
  return errors$6.InvalidChecksumError = t, errors$6;
}
var utils$g = {}, buffer$1 = {};
var hasRequiredBuffer$1;
function requireBuffer$1() {
  return hasRequiredBuffer$1 || (hasRequiredBuffer$1 = 1, function(o) {
    var g = requireBase64Js(), c = requireIeee754(), y = typeof Symbol == "function" && typeof Symbol.for == "function" ? Symbol.for("nodejs.util.inspect.custom") : null;
    o.Buffer = B, o.SlowBuffer = Ie, o.INSPECT_MAX_BYTES = 50;
    var t = 2147483647;
    o.kMaxLength = t, B.TYPED_ARRAY_SUPPORT = d(), !B.TYPED_ARRAY_SUPPORT && typeof console < "u" && typeof console.error == "function" && console.error(
      "This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."
    );
    function d() {
      try {
        var Ar = new Uint8Array(1), cr = { foo: function() {
          return 42;
        } };
        return Object.setPrototypeOf(cr, Uint8Array.prototype), Object.setPrototypeOf(Ar, cr), Ar.foo() === 42;
      } catch {
        return !1;
      }
    }
    Object.defineProperty(B.prototype, "parent", {
      enumerable: !0,
      get: function() {
        if (B.isBuffer(this))
          return this.buffer;
      }
    }), Object.defineProperty(B.prototype, "offset", {
      enumerable: !0,
      get: function() {
        if (B.isBuffer(this))
          return this.byteOffset;
      }
    });
    function E(Ar) {
      if (Ar > t)
        throw new RangeError('The value "' + Ar + '" is invalid for option "size"');
      var cr = new Uint8Array(Ar);
      return Object.setPrototypeOf(cr, B.prototype), cr;
    }
    function B(Ar, cr, hr) {
      if (typeof Ar == "number") {
        if (typeof cr == "string")
          throw new TypeError(
            'The "string" argument must be of type string. Received type number'
          );
        return F(Ar);
      }
      return D(Ar, cr, hr);
    }
    B.poolSize = 8192;
    function D(Ar, cr, hr) {
      if (typeof Ar == "string")
        return M(Ar, cr);
      if (ArrayBuffer.isView(Ar))
        return L(Ar);
      if (Ar == null)
        throw new TypeError(
          "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof Ar
        );
      if (Gr(Ar, ArrayBuffer) || Ar && Gr(Ar.buffer, ArrayBuffer) || typeof SharedArrayBuffer < "u" && (Gr(Ar, SharedArrayBuffer) || Ar && Gr(Ar.buffer, SharedArrayBuffer)))
        return H(Ar, cr, hr);
      if (typeof Ar == "number")
        throw new TypeError(
          'The "value" argument must not be of type number. Received type number'
        );
      var Wr = Ar.valueOf && Ar.valueOf();
      if (Wr != null && Wr !== Ar)
        return B.from(Wr, cr, hr);
      var fi = fe(Ar);
      if (fi) return fi;
      if (typeof Symbol < "u" && Symbol.toPrimitive != null && typeof Ar[Symbol.toPrimitive] == "function")
        return B.from(
          Ar[Symbol.toPrimitive]("string"),
          cr,
          hr
        );
      throw new TypeError(
        "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof Ar
      );
    }
    B.from = function(Ar, cr, hr) {
      return D(Ar, cr, hr);
    }, Object.setPrototypeOf(B.prototype, Uint8Array.prototype), Object.setPrototypeOf(B, Uint8Array);
    function x(Ar) {
      if (typeof Ar != "number")
        throw new TypeError('"size" argument must be of type number');
      if (Ar < 0)
        throw new RangeError('The value "' + Ar + '" is invalid for option "size"');
    }
    function v(Ar, cr, hr) {
      return x(Ar), Ar <= 0 ? E(Ar) : cr !== void 0 ? typeof hr == "string" ? E(Ar).fill(cr, hr) : E(Ar).fill(cr) : E(Ar);
    }
    B.alloc = function(Ar, cr, hr) {
      return v(Ar, cr, hr);
    };
    function F(Ar) {
      return x(Ar), E(Ar < 0 ? 0 : ge(Ar) | 0);
    }
    B.allocUnsafe = function(Ar) {
      return F(Ar);
    }, B.allocUnsafeSlow = function(Ar) {
      return F(Ar);
    };
    function M(Ar, cr) {
      if ((typeof cr != "string" || cr === "") && (cr = "utf8"), !B.isEncoding(cr))
        throw new TypeError("Unknown encoding: " + cr);
      var hr = Ee(Ar, cr) | 0, Wr = E(hr), fi = Wr.write(Ar, cr);
      return fi !== hr && (Wr = Wr.slice(0, fi)), Wr;
    }
    function U(Ar) {
      for (var cr = Ar.length < 0 ? 0 : ge(Ar.length) | 0, hr = E(cr), Wr = 0; Wr < cr; Wr += 1)
        hr[Wr] = Ar[Wr] & 255;
      return hr;
    }
    function L(Ar) {
      if (Gr(Ar, Uint8Array)) {
        var cr = new Uint8Array(Ar);
        return H(cr.buffer, cr.byteOffset, cr.byteLength);
      }
      return U(Ar);
    }
    function H(Ar, cr, hr) {
      if (cr < 0 || Ar.byteLength < cr)
        throw new RangeError('"offset" is outside of buffer bounds');
      if (Ar.byteLength < cr + (hr || 0))
        throw new RangeError('"length" is outside of buffer bounds');
      var Wr;
      return cr === void 0 && hr === void 0 ? Wr = new Uint8Array(Ar) : hr === void 0 ? Wr = new Uint8Array(Ar, cr) : Wr = new Uint8Array(Ar, cr, hr), Object.setPrototypeOf(Wr, B.prototype), Wr;
    }
    function fe(Ar) {
      if (B.isBuffer(Ar)) {
        var cr = ge(Ar.length) | 0, hr = E(cr);
        return hr.length === 0 || Ar.copy(hr, 0, 0, cr), hr;
      }
      if (Ar.length !== void 0)
        return typeof Ar.length != "number" || Fr(Ar.length) ? E(0) : U(Ar);
      if (Ar.type === "Buffer" && Array.isArray(Ar.data))
        return U(Ar.data);
    }
    function ge(Ar) {
      if (Ar >= t)
        throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + t.toString(16) + " bytes");
      return Ar | 0;
    }
    function Ie(Ar) {
      return +Ar != Ar && (Ar = 0), B.alloc(+Ar);
    }
    B.isBuffer = function(cr) {
      return cr != null && cr._isBuffer === !0 && cr !== B.prototype;
    }, B.compare = function(cr, hr) {
      if (Gr(cr, Uint8Array) && (cr = B.from(cr, cr.offset, cr.byteLength)), Gr(hr, Uint8Array) && (hr = B.from(hr, hr.offset, hr.byteLength)), !B.isBuffer(cr) || !B.isBuffer(hr))
        throw new TypeError(
          'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
        );
      if (cr === hr) return 0;
      for (var Wr = cr.length, fi = hr.length, Bi = 0, $r = Math.min(Wr, fi); Bi < $r; ++Bi)
        if (cr[Bi] !== hr[Bi]) {
          Wr = cr[Bi], fi = hr[Bi];
          break;
        }
      return Wr < fi ? -1 : fi < Wr ? 1 : 0;
    }, B.isEncoding = function(cr) {
      switch (String(cr).toLowerCase()) {
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return !0;
        default:
          return !1;
      }
    }, B.concat = function(cr, hr) {
      if (!Array.isArray(cr))
        throw new TypeError('"list" argument must be an Array of Buffers');
      if (cr.length === 0)
        return B.alloc(0);
      var Wr;
      if (hr === void 0)
        for (hr = 0, Wr = 0; Wr < cr.length; ++Wr)
          hr += cr[Wr].length;
      var fi = B.allocUnsafe(hr), Bi = 0;
      for (Wr = 0; Wr < cr.length; ++Wr) {
        var $r = cr[Wr];
        if (Gr($r, Uint8Array))
          Bi + $r.length > fi.length ? B.from($r).copy(fi, Bi) : Uint8Array.prototype.set.call(
            fi,
            $r,
            Bi
          );
        else if (B.isBuffer($r))
          $r.copy(fi, Bi);
        else
          throw new TypeError('"list" argument must be an Array of Buffers');
        Bi += $r.length;
      }
      return fi;
    };
    function Ee(Ar, cr) {
      if (B.isBuffer(Ar))
        return Ar.length;
      if (ArrayBuffer.isView(Ar) || Gr(Ar, ArrayBuffer))
        return Ar.byteLength;
      if (typeof Ar != "string")
        throw new TypeError(
          'The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof Ar
        );
      var hr = Ar.length, Wr = arguments.length > 2 && arguments[2] === !0;
      if (!Wr && hr === 0) return 0;
      for (var fi = !1; ; )
        switch (cr) {
          case "ascii":
          case "latin1":
          case "binary":
            return hr;
          case "utf8":
          case "utf-8":
            return Qr(Ar).length;
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return hr * 2;
          case "hex":
            return hr >>> 1;
          case "base64":
            return Ur(Ar).length;
          default:
            if (fi)
              return Wr ? -1 : Qr(Ar).length;
            cr = ("" + cr).toLowerCase(), fi = !0;
        }
    }
    B.byteLength = Ee;
    function Se(Ar, cr, hr) {
      var Wr = !1;
      if ((cr === void 0 || cr < 0) && (cr = 0), cr > this.length || ((hr === void 0 || hr > this.length) && (hr = this.length), hr <= 0) || (hr >>>= 0, cr >>>= 0, hr <= cr))
        return "";
      for (Ar || (Ar = "utf8"); ; )
        switch (Ar) {
          case "hex":
            return er(this, cr, hr);
          case "utf8":
          case "utf-8":
            return xe(this, cr, hr);
          case "ascii":
            return st(this, cr, hr);
          case "latin1":
          case "binary":
            return Dt(this, cr, hr);
          case "base64":
            return ke(this, cr, hr);
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return xt(this, cr, hr);
          default:
            if (Wr) throw new TypeError("Unknown encoding: " + Ar);
            Ar = (Ar + "").toLowerCase(), Wr = !0;
        }
    }
    B.prototype._isBuffer = !0;
    function ze(Ar, cr, hr) {
      var Wr = Ar[cr];
      Ar[cr] = Ar[hr], Ar[hr] = Wr;
    }
    B.prototype.swap16 = function() {
      var cr = this.length;
      if (cr % 2 !== 0)
        throw new RangeError("Buffer size must be a multiple of 16-bits");
      for (var hr = 0; hr < cr; hr += 2)
        ze(this, hr, hr + 1);
      return this;
    }, B.prototype.swap32 = function() {
      var cr = this.length;
      if (cr % 4 !== 0)
        throw new RangeError("Buffer size must be a multiple of 32-bits");
      for (var hr = 0; hr < cr; hr += 4)
        ze(this, hr, hr + 3), ze(this, hr + 1, hr + 2);
      return this;
    }, B.prototype.swap64 = function() {
      var cr = this.length;
      if (cr % 8 !== 0)
        throw new RangeError("Buffer size must be a multiple of 64-bits");
      for (var hr = 0; hr < cr; hr += 8)
        ze(this, hr, hr + 7), ze(this, hr + 1, hr + 6), ze(this, hr + 2, hr + 5), ze(this, hr + 3, hr + 4);
      return this;
    }, B.prototype.toString = function() {
      var cr = this.length;
      return cr === 0 ? "" : arguments.length === 0 ? xe(this, 0, cr) : Se.apply(this, arguments);
    }, B.prototype.toLocaleString = B.prototype.toString, B.prototype.equals = function(cr) {
      if (!B.isBuffer(cr)) throw new TypeError("Argument must be a Buffer");
      return this === cr ? !0 : B.compare(this, cr) === 0;
    }, B.prototype.inspect = function() {
      var cr = "", hr = o.INSPECT_MAX_BYTES;
      return cr = this.toString("hex", 0, hr).replace(/(.{2})/g, "$1 ").trim(), this.length > hr && (cr += " ... "), "<Buffer " + cr + ">";
    }, y && (B.prototype[y] = B.prototype.inspect), B.prototype.compare = function(cr, hr, Wr, fi, Bi) {
      if (Gr(cr, Uint8Array) && (cr = B.from(cr, cr.offset, cr.byteLength)), !B.isBuffer(cr))
        throw new TypeError(
          'The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof cr
        );
      if (hr === void 0 && (hr = 0), Wr === void 0 && (Wr = cr ? cr.length : 0), fi === void 0 && (fi = 0), Bi === void 0 && (Bi = this.length), hr < 0 || Wr > cr.length || fi < 0 || Bi > this.length)
        throw new RangeError("out of range index");
      if (fi >= Bi && hr >= Wr)
        return 0;
      if (fi >= Bi)
        return -1;
      if (hr >= Wr)
        return 1;
      if (hr >>>= 0, Wr >>>= 0, fi >>>= 0, Bi >>>= 0, this === cr) return 0;
      for (var $r = Bi - fi, oi = Wr - hr, zr = Math.min($r, oi), ti = this.slice(fi, Bi), Lr = cr.slice(hr, Wr), Rr = 0; Rr < zr; ++Rr)
        if (ti[Rr] !== Lr[Rr]) {
          $r = ti[Rr], oi = Lr[Rr];
          break;
        }
      return $r < oi ? -1 : oi < $r ? 1 : 0;
    };
    function He(Ar, cr, hr, Wr, fi) {
      if (Ar.length === 0) return -1;
      if (typeof hr == "string" ? (Wr = hr, hr = 0) : hr > 2147483647 ? hr = 2147483647 : hr < -2147483648 && (hr = -2147483648), hr = +hr, Fr(hr) && (hr = fi ? 0 : Ar.length - 1), hr < 0 && (hr = Ar.length + hr), hr >= Ar.length) {
        if (fi) return -1;
        hr = Ar.length - 1;
      } else if (hr < 0)
        if (fi) hr = 0;
        else return -1;
      if (typeof cr == "string" && (cr = B.from(cr, Wr)), B.isBuffer(cr))
        return cr.length === 0 ? -1 : Pe(Ar, cr, hr, Wr, fi);
      if (typeof cr == "number")
        return cr = cr & 255, typeof Uint8Array.prototype.indexOf == "function" ? fi ? Uint8Array.prototype.indexOf.call(Ar, cr, hr) : Uint8Array.prototype.lastIndexOf.call(Ar, cr, hr) : Pe(Ar, [cr], hr, Wr, fi);
      throw new TypeError("val must be string, number or Buffer");
    }
    function Pe(Ar, cr, hr, Wr, fi) {
      var Bi = 1, $r = Ar.length, oi = cr.length;
      if (Wr !== void 0 && (Wr = String(Wr).toLowerCase(), Wr === "ucs2" || Wr === "ucs-2" || Wr === "utf16le" || Wr === "utf-16le")) {
        if (Ar.length < 2 || cr.length < 2)
          return -1;
        Bi = 2, $r /= 2, oi /= 2, hr /= 2;
      }
      function zr(pr, Cr) {
        return Bi === 1 ? pr[Cr] : pr.readUInt16BE(Cr * Bi);
      }
      var ti;
      if (fi) {
        var Lr = -1;
        for (ti = hr; ti < $r; ti++)
          if (zr(Ar, ti) === zr(cr, Lr === -1 ? 0 : ti - Lr)) {
            if (Lr === -1 && (Lr = ti), ti - Lr + 1 === oi) return Lr * Bi;
          } else
            Lr !== -1 && (ti -= ti - Lr), Lr = -1;
      } else
        for (hr + oi > $r && (hr = $r - oi), ti = hr; ti >= 0; ti--) {
          for (var Rr = !0, Ir = 0; Ir < oi; Ir++)
            if (zr(Ar, ti + Ir) !== zr(cr, Ir)) {
              Rr = !1;
              break;
            }
          if (Rr) return ti;
        }
      return -1;
    }
    B.prototype.includes = function(cr, hr, Wr) {
      return this.indexOf(cr, hr, Wr) !== -1;
    }, B.prototype.indexOf = function(cr, hr, Wr) {
      return He(this, cr, hr, Wr, !0);
    }, B.prototype.lastIndexOf = function(cr, hr, Wr) {
      return He(this, cr, hr, Wr, !1);
    };
    function De(Ar, cr, hr, Wr) {
      hr = Number(hr) || 0;
      var fi = Ar.length - hr;
      Wr ? (Wr = Number(Wr), Wr > fi && (Wr = fi)) : Wr = fi;
      var Bi = cr.length;
      Wr > Bi / 2 && (Wr = Bi / 2);
      for (var $r = 0; $r < Wr; ++$r) {
        var oi = parseInt(cr.substr($r * 2, 2), 16);
        if (Fr(oi)) return $r;
        Ar[hr + $r] = oi;
      }
      return $r;
    }
    function ve(Ar, cr, hr, Wr) {
      return Sr(Qr(cr, Ar.length - hr), Ar, hr, Wr);
    }
    function Fe(Ar, cr, hr, Wr) {
      return Sr(Xr(cr), Ar, hr, Wr);
    }
    function be(Ar, cr, hr, Wr) {
      return Sr(Ur(cr), Ar, hr, Wr);
    }
    function Be(Ar, cr, hr, Wr) {
      return Sr(Vr(cr, Ar.length - hr), Ar, hr, Wr);
    }
    B.prototype.write = function(cr, hr, Wr, fi) {
      if (hr === void 0)
        fi = "utf8", Wr = this.length, hr = 0;
      else if (Wr === void 0 && typeof hr == "string")
        fi = hr, Wr = this.length, hr = 0;
      else if (isFinite(hr))
        hr = hr >>> 0, isFinite(Wr) ? (Wr = Wr >>> 0, fi === void 0 && (fi = "utf8")) : (fi = Wr, Wr = void 0);
      else
        throw new Error(
          "Buffer.write(string, encoding, offset[, length]) is no longer supported"
        );
      var Bi = this.length - hr;
      if ((Wr === void 0 || Wr > Bi) && (Wr = Bi), cr.length > 0 && (Wr < 0 || hr < 0) || hr > this.length)
        throw new RangeError("Attempt to write outside buffer bounds");
      fi || (fi = "utf8");
      for (var $r = !1; ; )
        switch (fi) {
          case "hex":
            return De(this, cr, hr, Wr);
          case "utf8":
          case "utf-8":
            return ve(this, cr, hr, Wr);
          case "ascii":
          case "latin1":
          case "binary":
            return Fe(this, cr, hr, Wr);
          case "base64":
            return be(this, cr, hr, Wr);
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return Be(this, cr, hr, Wr);
          default:
            if ($r) throw new TypeError("Unknown encoding: " + fi);
            fi = ("" + fi).toLowerCase(), $r = !0;
        }
    }, B.prototype.toJSON = function() {
      return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
      };
    };
    function ke(Ar, cr, hr) {
      return cr === 0 && hr === Ar.length ? g.fromByteArray(Ar) : g.fromByteArray(Ar.slice(cr, hr));
    }
    function xe(Ar, cr, hr) {
      hr = Math.min(Ar.length, hr);
      for (var Wr = [], fi = cr; fi < hr; ) {
        var Bi = Ar[fi], $r = null, oi = Bi > 239 ? 4 : Bi > 223 ? 3 : Bi > 191 ? 2 : 1;
        if (fi + oi <= hr) {
          var zr, ti, Lr, Rr;
          switch (oi) {
            case 1:
              Bi < 128 && ($r = Bi);
              break;
            case 2:
              zr = Ar[fi + 1], (zr & 192) === 128 && (Rr = (Bi & 31) << 6 | zr & 63, Rr > 127 && ($r = Rr));
              break;
            case 3:
              zr = Ar[fi + 1], ti = Ar[fi + 2], (zr & 192) === 128 && (ti & 192) === 128 && (Rr = (Bi & 15) << 12 | (zr & 63) << 6 | ti & 63, Rr > 2047 && (Rr < 55296 || Rr > 57343) && ($r = Rr));
              break;
            case 4:
              zr = Ar[fi + 1], ti = Ar[fi + 2], Lr = Ar[fi + 3], (zr & 192) === 128 && (ti & 192) === 128 && (Lr & 192) === 128 && (Rr = (Bi & 15) << 18 | (zr & 63) << 12 | (ti & 63) << 6 | Lr & 63, Rr > 65535 && Rr < 1114112 && ($r = Rr));
          }
        }
        $r === null ? ($r = 65533, oi = 1) : $r > 65535 && ($r -= 65536, Wr.push($r >>> 10 & 1023 | 55296), $r = 56320 | $r & 1023), Wr.push($r), fi += oi;
      }
      return Et(Wr);
    }
    var Ne = 4096;
    function Et(Ar) {
      var cr = Ar.length;
      if (cr <= Ne)
        return String.fromCharCode.apply(String, Ar);
      for (var hr = "", Wr = 0; Wr < cr; )
        hr += String.fromCharCode.apply(
          String,
          Ar.slice(Wr, Wr += Ne)
        );
      return hr;
    }
    function st(Ar, cr, hr) {
      var Wr = "";
      hr = Math.min(Ar.length, hr);
      for (var fi = cr; fi < hr; ++fi)
        Wr += String.fromCharCode(Ar[fi] & 127);
      return Wr;
    }
    function Dt(Ar, cr, hr) {
      var Wr = "";
      hr = Math.min(Ar.length, hr);
      for (var fi = cr; fi < hr; ++fi)
        Wr += String.fromCharCode(Ar[fi]);
      return Wr;
    }
    function er(Ar, cr, hr) {
      var Wr = Ar.length;
      (!cr || cr < 0) && (cr = 0), (!hr || hr < 0 || hr > Wr) && (hr = Wr);
      for (var fi = "", Bi = cr; Bi < hr; ++Bi)
        fi += br[Ar[Bi]];
      return fi;
    }
    function xt(Ar, cr, hr) {
      for (var Wr = Ar.slice(cr, hr), fi = "", Bi = 0; Bi < Wr.length - 1; Bi += 2)
        fi += String.fromCharCode(Wr[Bi] + Wr[Bi + 1] * 256);
      return fi;
    }
    B.prototype.slice = function(cr, hr) {
      var Wr = this.length;
      cr = ~~cr, hr = hr === void 0 ? Wr : ~~hr, cr < 0 ? (cr += Wr, cr < 0 && (cr = 0)) : cr > Wr && (cr = Wr), hr < 0 ? (hr += Wr, hr < 0 && (hr = 0)) : hr > Wr && (hr = Wr), hr < cr && (hr = cr);
      var fi = this.subarray(cr, hr);
      return Object.setPrototypeOf(fi, B.prototype), fi;
    };
    function ir(Ar, cr, hr) {
      if (Ar % 1 !== 0 || Ar < 0) throw new RangeError("offset is not uint");
      if (Ar + cr > hr) throw new RangeError("Trying to access beyond buffer length");
    }
    B.prototype.readUintLE = B.prototype.readUIntLE = function(cr, hr, Wr) {
      cr = cr >>> 0, hr = hr >>> 0, Wr || ir(cr, hr, this.length);
      for (var fi = this[cr], Bi = 1, $r = 0; ++$r < hr && (Bi *= 256); )
        fi += this[cr + $r] * Bi;
      return fi;
    }, B.prototype.readUintBE = B.prototype.readUIntBE = function(cr, hr, Wr) {
      cr = cr >>> 0, hr = hr >>> 0, Wr || ir(cr, hr, this.length);
      for (var fi = this[cr + --hr], Bi = 1; hr > 0 && (Bi *= 256); )
        fi += this[cr + --hr] * Bi;
      return fi;
    }, B.prototype.readUint8 = B.prototype.readUInt8 = function(cr, hr) {
      return cr = cr >>> 0, hr || ir(cr, 1, this.length), this[cr];
    }, B.prototype.readUint16LE = B.prototype.readUInt16LE = function(cr, hr) {
      return cr = cr >>> 0, hr || ir(cr, 2, this.length), this[cr] | this[cr + 1] << 8;
    }, B.prototype.readUint16BE = B.prototype.readUInt16BE = function(cr, hr) {
      return cr = cr >>> 0, hr || ir(cr, 2, this.length), this[cr] << 8 | this[cr + 1];
    }, B.prototype.readUint32LE = B.prototype.readUInt32LE = function(cr, hr) {
      return cr = cr >>> 0, hr || ir(cr, 4, this.length), (this[cr] | this[cr + 1] << 8 | this[cr + 2] << 16) + this[cr + 3] * 16777216;
    }, B.prototype.readUint32BE = B.prototype.readUInt32BE = function(cr, hr) {
      return cr = cr >>> 0, hr || ir(cr, 4, this.length), this[cr] * 16777216 + (this[cr + 1] << 16 | this[cr + 2] << 8 | this[cr + 3]);
    }, B.prototype.readIntLE = function(cr, hr, Wr) {
      cr = cr >>> 0, hr = hr >>> 0, Wr || ir(cr, hr, this.length);
      for (var fi = this[cr], Bi = 1, $r = 0; ++$r < hr && (Bi *= 256); )
        fi += this[cr + $r] * Bi;
      return Bi *= 128, fi >= Bi && (fi -= Math.pow(2, 8 * hr)), fi;
    }, B.prototype.readIntBE = function(cr, hr, Wr) {
      cr = cr >>> 0, hr = hr >>> 0, Wr || ir(cr, hr, this.length);
      for (var fi = hr, Bi = 1, $r = this[cr + --fi]; fi > 0 && (Bi *= 256); )
        $r += this[cr + --fi] * Bi;
      return Bi *= 128, $r >= Bi && ($r -= Math.pow(2, 8 * hr)), $r;
    }, B.prototype.readInt8 = function(cr, hr) {
      return cr = cr >>> 0, hr || ir(cr, 1, this.length), this[cr] & 128 ? (255 - this[cr] + 1) * -1 : this[cr];
    }, B.prototype.readInt16LE = function(cr, hr) {
      cr = cr >>> 0, hr || ir(cr, 2, this.length);
      var Wr = this[cr] | this[cr + 1] << 8;
      return Wr & 32768 ? Wr | 4294901760 : Wr;
    }, B.prototype.readInt16BE = function(cr, hr) {
      cr = cr >>> 0, hr || ir(cr, 2, this.length);
      var Wr = this[cr + 1] | this[cr] << 8;
      return Wr & 32768 ? Wr | 4294901760 : Wr;
    }, B.prototype.readInt32LE = function(cr, hr) {
      return cr = cr >>> 0, hr || ir(cr, 4, this.length), this[cr] | this[cr + 1] << 8 | this[cr + 2] << 16 | this[cr + 3] << 24;
    }, B.prototype.readInt32BE = function(cr, hr) {
      return cr = cr >>> 0, hr || ir(cr, 4, this.length), this[cr] << 24 | this[cr + 1] << 16 | this[cr + 2] << 8 | this[cr + 3];
    }, B.prototype.readFloatLE = function(cr, hr) {
      return cr = cr >>> 0, hr || ir(cr, 4, this.length), c.read(this, cr, !0, 23, 4);
    }, B.prototype.readFloatBE = function(cr, hr) {
      return cr = cr >>> 0, hr || ir(cr, 4, this.length), c.read(this, cr, !1, 23, 4);
    }, B.prototype.readDoubleLE = function(cr, hr) {
      return cr = cr >>> 0, hr || ir(cr, 8, this.length), c.read(this, cr, !0, 52, 8);
    }, B.prototype.readDoubleBE = function(cr, hr) {
      return cr = cr >>> 0, hr || ir(cr, 8, this.length), c.read(this, cr, !1, 52, 8);
    };
    function sr(Ar, cr, hr, Wr, fi, Bi) {
      if (!B.isBuffer(Ar)) throw new TypeError('"buffer" argument must be a Buffer instance');
      if (cr > fi || cr < Bi) throw new RangeError('"value" argument is out of bounds');
      if (hr + Wr > Ar.length) throw new RangeError("Index out of range");
    }
    B.prototype.writeUintLE = B.prototype.writeUIntLE = function(cr, hr, Wr, fi) {
      if (cr = +cr, hr = hr >>> 0, Wr = Wr >>> 0, !fi) {
        var Bi = Math.pow(2, 8 * Wr) - 1;
        sr(this, cr, hr, Wr, Bi, 0);
      }
      var $r = 1, oi = 0;
      for (this[hr] = cr & 255; ++oi < Wr && ($r *= 256); )
        this[hr + oi] = cr / $r & 255;
      return hr + Wr;
    }, B.prototype.writeUintBE = B.prototype.writeUIntBE = function(cr, hr, Wr, fi) {
      if (cr = +cr, hr = hr >>> 0, Wr = Wr >>> 0, !fi) {
        var Bi = Math.pow(2, 8 * Wr) - 1;
        sr(this, cr, hr, Wr, Bi, 0);
      }
      var $r = Wr - 1, oi = 1;
      for (this[hr + $r] = cr & 255; --$r >= 0 && (oi *= 256); )
        this[hr + $r] = cr / oi & 255;
      return hr + Wr;
    }, B.prototype.writeUint8 = B.prototype.writeUInt8 = function(cr, hr, Wr) {
      return cr = +cr, hr = hr >>> 0, Wr || sr(this, cr, hr, 1, 255, 0), this[hr] = cr & 255, hr + 1;
    }, B.prototype.writeUint16LE = B.prototype.writeUInt16LE = function(cr, hr, Wr) {
      return cr = +cr, hr = hr >>> 0, Wr || sr(this, cr, hr, 2, 65535, 0), this[hr] = cr & 255, this[hr + 1] = cr >>> 8, hr + 2;
    }, B.prototype.writeUint16BE = B.prototype.writeUInt16BE = function(cr, hr, Wr) {
      return cr = +cr, hr = hr >>> 0, Wr || sr(this, cr, hr, 2, 65535, 0), this[hr] = cr >>> 8, this[hr + 1] = cr & 255, hr + 2;
    }, B.prototype.writeUint32LE = B.prototype.writeUInt32LE = function(cr, hr, Wr) {
      return cr = +cr, hr = hr >>> 0, Wr || sr(this, cr, hr, 4, 4294967295, 0), this[hr + 3] = cr >>> 24, this[hr + 2] = cr >>> 16, this[hr + 1] = cr >>> 8, this[hr] = cr & 255, hr + 4;
    }, B.prototype.writeUint32BE = B.prototype.writeUInt32BE = function(cr, hr, Wr) {
      return cr = +cr, hr = hr >>> 0, Wr || sr(this, cr, hr, 4, 4294967295, 0), this[hr] = cr >>> 24, this[hr + 1] = cr >>> 16, this[hr + 2] = cr >>> 8, this[hr + 3] = cr & 255, hr + 4;
    }, B.prototype.writeIntLE = function(cr, hr, Wr, fi) {
      if (cr = +cr, hr = hr >>> 0, !fi) {
        var Bi = Math.pow(2, 8 * Wr - 1);
        sr(this, cr, hr, Wr, Bi - 1, -Bi);
      }
      var $r = 0, oi = 1, zr = 0;
      for (this[hr] = cr & 255; ++$r < Wr && (oi *= 256); )
        cr < 0 && zr === 0 && this[hr + $r - 1] !== 0 && (zr = 1), this[hr + $r] = (cr / oi >> 0) - zr & 255;
      return hr + Wr;
    }, B.prototype.writeIntBE = function(cr, hr, Wr, fi) {
      if (cr = +cr, hr = hr >>> 0, !fi) {
        var Bi = Math.pow(2, 8 * Wr - 1);
        sr(this, cr, hr, Wr, Bi - 1, -Bi);
      }
      var $r = Wr - 1, oi = 1, zr = 0;
      for (this[hr + $r] = cr & 255; --$r >= 0 && (oi *= 256); )
        cr < 0 && zr === 0 && this[hr + $r + 1] !== 0 && (zr = 1), this[hr + $r] = (cr / oi >> 0) - zr & 255;
      return hr + Wr;
    }, B.prototype.writeInt8 = function(cr, hr, Wr) {
      return cr = +cr, hr = hr >>> 0, Wr || sr(this, cr, hr, 1, 127, -128), cr < 0 && (cr = 255 + cr + 1), this[hr] = cr & 255, hr + 1;
    }, B.prototype.writeInt16LE = function(cr, hr, Wr) {
      return cr = +cr, hr = hr >>> 0, Wr || sr(this, cr, hr, 2, 32767, -32768), this[hr] = cr & 255, this[hr + 1] = cr >>> 8, hr + 2;
    }, B.prototype.writeInt16BE = function(cr, hr, Wr) {
      return cr = +cr, hr = hr >>> 0, Wr || sr(this, cr, hr, 2, 32767, -32768), this[hr] = cr >>> 8, this[hr + 1] = cr & 255, hr + 2;
    }, B.prototype.writeInt32LE = function(cr, hr, Wr) {
      return cr = +cr, hr = hr >>> 0, Wr || sr(this, cr, hr, 4, 2147483647, -2147483648), this[hr] = cr & 255, this[hr + 1] = cr >>> 8, this[hr + 2] = cr >>> 16, this[hr + 3] = cr >>> 24, hr + 4;
    }, B.prototype.writeInt32BE = function(cr, hr, Wr) {
      return cr = +cr, hr = hr >>> 0, Wr || sr(this, cr, hr, 4, 2147483647, -2147483648), cr < 0 && (cr = 4294967295 + cr + 1), this[hr] = cr >>> 24, this[hr + 1] = cr >>> 16, this[hr + 2] = cr >>> 8, this[hr + 3] = cr & 255, hr + 4;
    };
    function yr(Ar, cr, hr, Wr, fi, Bi) {
      if (hr + Wr > Ar.length) throw new RangeError("Index out of range");
      if (hr < 0) throw new RangeError("Index out of range");
    }
    function wr(Ar, cr, hr, Wr, fi) {
      return cr = +cr, hr = hr >>> 0, fi || yr(Ar, cr, hr, 4), c.write(Ar, cr, hr, Wr, 23, 4), hr + 4;
    }
    B.prototype.writeFloatLE = function(cr, hr, Wr) {
      return wr(this, cr, hr, !0, Wr);
    }, B.prototype.writeFloatBE = function(cr, hr, Wr) {
      return wr(this, cr, hr, !1, Wr);
    };
    function qr(Ar, cr, hr, Wr, fi) {
      return cr = +cr, hr = hr >>> 0, fi || yr(Ar, cr, hr, 8), c.write(Ar, cr, hr, Wr, 52, 8), hr + 8;
    }
    B.prototype.writeDoubleLE = function(cr, hr, Wr) {
      return qr(this, cr, hr, !0, Wr);
    }, B.prototype.writeDoubleBE = function(cr, hr, Wr) {
      return qr(this, cr, hr, !1, Wr);
    }, B.prototype.copy = function(cr, hr, Wr, fi) {
      if (!B.isBuffer(cr)) throw new TypeError("argument should be a Buffer");
      if (Wr || (Wr = 0), !fi && fi !== 0 && (fi = this.length), hr >= cr.length && (hr = cr.length), hr || (hr = 0), fi > 0 && fi < Wr && (fi = Wr), fi === Wr || cr.length === 0 || this.length === 0) return 0;
      if (hr < 0)
        throw new RangeError("targetStart out of bounds");
      if (Wr < 0 || Wr >= this.length) throw new RangeError("Index out of range");
      if (fi < 0) throw new RangeError("sourceEnd out of bounds");
      fi > this.length && (fi = this.length), cr.length - hr < fi - Wr && (fi = cr.length - hr + Wr);
      var Bi = fi - Wr;
      return this === cr && typeof Uint8Array.prototype.copyWithin == "function" ? this.copyWithin(hr, Wr, fi) : Uint8Array.prototype.set.call(
        cr,
        this.subarray(Wr, fi),
        hr
      ), Bi;
    }, B.prototype.fill = function(cr, hr, Wr, fi) {
      if (typeof cr == "string") {
        if (typeof hr == "string" ? (fi = hr, hr = 0, Wr = this.length) : typeof Wr == "string" && (fi = Wr, Wr = this.length), fi !== void 0 && typeof fi != "string")
          throw new TypeError("encoding must be a string");
        if (typeof fi == "string" && !B.isEncoding(fi))
          throw new TypeError("Unknown encoding: " + fi);
        if (cr.length === 1) {
          var Bi = cr.charCodeAt(0);
          (fi === "utf8" && Bi < 128 || fi === "latin1") && (cr = Bi);
        }
      } else typeof cr == "number" ? cr = cr & 255 : typeof cr == "boolean" && (cr = Number(cr));
      if (hr < 0 || this.length < hr || this.length < Wr)
        throw new RangeError("Out of range index");
      if (Wr <= hr)
        return this;
      hr = hr >>> 0, Wr = Wr === void 0 ? this.length : Wr >>> 0, cr || (cr = 0);
      var $r;
      if (typeof cr == "number")
        for ($r = hr; $r < Wr; ++$r)
          this[$r] = cr;
      else {
        var oi = B.isBuffer(cr) ? cr : B.from(cr, fi), zr = oi.length;
        if (zr === 0)
          throw new TypeError('The value "' + cr + '" is invalid for argument "value"');
        for ($r = 0; $r < Wr - hr; ++$r)
          this[$r + hr] = oi[$r % zr];
      }
      return this;
    };
    var Mr = /[^+/0-9A-Za-z-_]/g;
    function Dr(Ar) {
      if (Ar = Ar.split("=")[0], Ar = Ar.trim().replace(Mr, ""), Ar.length < 2) return "";
      for (; Ar.length % 4 !== 0; )
        Ar = Ar + "=";
      return Ar;
    }
    function Qr(Ar, cr) {
      cr = cr || 1 / 0;
      for (var hr, Wr = Ar.length, fi = null, Bi = [], $r = 0; $r < Wr; ++$r) {
        if (hr = Ar.charCodeAt($r), hr > 55295 && hr < 57344) {
          if (!fi) {
            if (hr > 56319) {
              (cr -= 3) > -1 && Bi.push(239, 191, 189);
              continue;
            } else if ($r + 1 === Wr) {
              (cr -= 3) > -1 && Bi.push(239, 191, 189);
              continue;
            }
            fi = hr;
            continue;
          }
          if (hr < 56320) {
            (cr -= 3) > -1 && Bi.push(239, 191, 189), fi = hr;
            continue;
          }
          hr = (fi - 55296 << 10 | hr - 56320) + 65536;
        } else fi && (cr -= 3) > -1 && Bi.push(239, 191, 189);
        if (fi = null, hr < 128) {
          if ((cr -= 1) < 0) break;
          Bi.push(hr);
        } else if (hr < 2048) {
          if ((cr -= 2) < 0) break;
          Bi.push(
            hr >> 6 | 192,
            hr & 63 | 128
          );
        } else if (hr < 65536) {
          if ((cr -= 3) < 0) break;
          Bi.push(
            hr >> 12 | 224,
            hr >> 6 & 63 | 128,
            hr & 63 | 128
          );
        } else if (hr < 1114112) {
          if ((cr -= 4) < 0) break;
          Bi.push(
            hr >> 18 | 240,
            hr >> 12 & 63 | 128,
            hr >> 6 & 63 | 128,
            hr & 63 | 128
          );
        } else
          throw new Error("Invalid code point");
      }
      return Bi;
    }
    function Xr(Ar) {
      for (var cr = [], hr = 0; hr < Ar.length; ++hr)
        cr.push(Ar.charCodeAt(hr) & 255);
      return cr;
    }
    function Vr(Ar, cr) {
      for (var hr, Wr, fi, Bi = [], $r = 0; $r < Ar.length && !((cr -= 2) < 0); ++$r)
        hr = Ar.charCodeAt($r), Wr = hr >> 8, fi = hr % 256, Bi.push(fi), Bi.push(Wr);
      return Bi;
    }
    function Ur(Ar) {
      return g.toByteArray(Dr(Ar));
    }
    function Sr(Ar, cr, hr, Wr) {
      for (var fi = 0; fi < Wr && !(fi + hr >= cr.length || fi >= Ar.length); ++fi)
        cr[fi + hr] = Ar[fi];
      return fi;
    }
    function Gr(Ar, cr) {
      return Ar instanceof cr || Ar != null && Ar.constructor != null && Ar.constructor.name != null && Ar.constructor.name === cr.name;
    }
    function Fr(Ar) {
      return Ar !== Ar;
    }
    var br = function() {
      for (var Ar = "0123456789abcdef", cr = new Array(256), hr = 0; hr < 16; ++hr)
        for (var Wr = hr * 16, fi = 0; fi < 16; ++fi)
          cr[Wr + fi] = Ar[hr] + Ar[fi];
      return cr;
    }();
  }(buffer$1)), buffer$1;
}
var bufferExports$1 = requireBuffer$1();
const createBuffer = bufferExports$1.Buffer.from && bufferExports$1.Buffer.alloc && bufferExports$1.Buffer.allocUnsafe && bufferExports$1.Buffer.allocUnsafeSlow ? bufferExports$1.Buffer.from : (
  // support for Node < 5.10
  (o) => new bufferExports$1.Buffer(o)
);
function defineCrc(o, g) {
  const c = (y, t) => g(y, t) >>> 0;
  return c.signed = g, c.unsigned = c, c.model = o, c;
}
const crc1 = defineCrc("crc1", function(o, g) {
  bufferExports$1.Buffer.isBuffer(o) || (o = createBuffer(o));
  let c = ~~g, y = 0;
  for (let t = 0; t < o.length; t++) {
    const d = o[t];
    y += d;
  }
  return c += y % 256, c % 256;
});
let TABLE$8 = [
  0,
  7,
  14,
  9,
  28,
  27,
  18,
  21,
  56,
  63,
  54,
  49,
  36,
  35,
  42,
  45,
  112,
  119,
  126,
  121,
  108,
  107,
  98,
  101,
  72,
  79,
  70,
  65,
  84,
  83,
  90,
  93,
  224,
  231,
  238,
  233,
  252,
  251,
  242,
  245,
  216,
  223,
  214,
  209,
  196,
  195,
  202,
  205,
  144,
  151,
  158,
  153,
  140,
  139,
  130,
  133,
  168,
  175,
  166,
  161,
  180,
  179,
  186,
  189,
  199,
  192,
  201,
  206,
  219,
  220,
  213,
  210,
  255,
  248,
  241,
  246,
  227,
  228,
  237,
  234,
  183,
  176,
  185,
  190,
  171,
  172,
  165,
  162,
  143,
  136,
  129,
  134,
  147,
  148,
  157,
  154,
  39,
  32,
  41,
  46,
  59,
  60,
  53,
  50,
  31,
  24,
  17,
  22,
  3,
  4,
  13,
  10,
  87,
  80,
  89,
  94,
  75,
  76,
  69,
  66,
  111,
  104,
  97,
  102,
  115,
  116,
  125,
  122,
  137,
  142,
  135,
  128,
  149,
  146,
  155,
  156,
  177,
  182,
  191,
  184,
  173,
  170,
  163,
  164,
  249,
  254,
  247,
  240,
  229,
  226,
  235,
  236,
  193,
  198,
  207,
  200,
  221,
  218,
  211,
  212,
  105,
  110,
  103,
  96,
  117,
  114,
  123,
  124,
  81,
  86,
  95,
  88,
  77,
  74,
  67,
  68,
  25,
  30,
  23,
  16,
  5,
  2,
  11,
  12,
  33,
  38,
  47,
  40,
  61,
  58,
  51,
  52,
  78,
  73,
  64,
  71,
  82,
  85,
  92,
  91,
  118,
  113,
  120,
  127,
  106,
  109,
  100,
  99,
  62,
  57,
  48,
  55,
  34,
  37,
  44,
  43,
  6,
  1,
  8,
  15,
  26,
  29,
  20,
  19,
  174,
  169,
  160,
  167,
  178,
  181,
  188,
  187,
  150,
  145,
  152,
  159,
  138,
  141,
  132,
  131,
  222,
  217,
  208,
  215,
  194,
  197,
  204,
  203,
  230,
  225,
  232,
  239,
  250,
  253,
  244,
  243
];
typeof Int32Array < "u" && (TABLE$8 = new Int32Array(TABLE$8));
const crc8 = defineCrc("crc-8", function(o, g) {
  bufferExports$1.Buffer.isBuffer(o) || (o = createBuffer(o));
  let c = ~~g;
  for (let y = 0; y < o.length; y++) {
    const t = o[y];
    c = TABLE$8[(c ^ t) & 255] & 255;
  }
  return c;
});
let TABLE$7 = [
  0,
  94,
  188,
  226,
  97,
  63,
  221,
  131,
  194,
  156,
  126,
  32,
  163,
  253,
  31,
  65,
  157,
  195,
  33,
  127,
  252,
  162,
  64,
  30,
  95,
  1,
  227,
  189,
  62,
  96,
  130,
  220,
  35,
  125,
  159,
  193,
  66,
  28,
  254,
  160,
  225,
  191,
  93,
  3,
  128,
  222,
  60,
  98,
  190,
  224,
  2,
  92,
  223,
  129,
  99,
  61,
  124,
  34,
  192,
  158,
  29,
  67,
  161,
  255,
  70,
  24,
  250,
  164,
  39,
  121,
  155,
  197,
  132,
  218,
  56,
  102,
  229,
  187,
  89,
  7,
  219,
  133,
  103,
  57,
  186,
  228,
  6,
  88,
  25,
  71,
  165,
  251,
  120,
  38,
  196,
  154,
  101,
  59,
  217,
  135,
  4,
  90,
  184,
  230,
  167,
  249,
  27,
  69,
  198,
  152,
  122,
  36,
  248,
  166,
  68,
  26,
  153,
  199,
  37,
  123,
  58,
  100,
  134,
  216,
  91,
  5,
  231,
  185,
  140,
  210,
  48,
  110,
  237,
  179,
  81,
  15,
  78,
  16,
  242,
  172,
  47,
  113,
  147,
  205,
  17,
  79,
  173,
  243,
  112,
  46,
  204,
  146,
  211,
  141,
  111,
  49,
  178,
  236,
  14,
  80,
  175,
  241,
  19,
  77,
  206,
  144,
  114,
  44,
  109,
  51,
  209,
  143,
  12,
  82,
  176,
  238,
  50,
  108,
  142,
  208,
  83,
  13,
  239,
  177,
  240,
  174,
  76,
  18,
  145,
  207,
  45,
  115,
  202,
  148,
  118,
  40,
  171,
  245,
  23,
  73,
  8,
  86,
  180,
  234,
  105,
  55,
  213,
  139,
  87,
  9,
  235,
  181,
  54,
  104,
  138,
  212,
  149,
  203,
  41,
  119,
  244,
  170,
  72,
  22,
  233,
  183,
  85,
  11,
  136,
  214,
  52,
  106,
  43,
  117,
  151,
  201,
  74,
  20,
  246,
  168,
  116,
  42,
  200,
  150,
  21,
  75,
  169,
  247,
  182,
  232,
  10,
  84,
  215,
  137,
  107,
  53
];
typeof Int32Array < "u" && (TABLE$7 = new Int32Array(TABLE$7));
const crc81wire = defineCrc("dallas-1-wire", function(o, g) {
  bufferExports$1.Buffer.isBuffer(o) || (o = createBuffer(o));
  let c = ~~g;
  for (let y = 0; y < o.length; y++) {
    const t = o[y];
    c = TABLE$7[(c ^ t) & 255] & 255;
  }
  return c;
});
let TABLE$6 = [
  0,
  49345,
  49537,
  320,
  49921,
  960,
  640,
  49729,
  50689,
  1728,
  1920,
  51009,
  1280,
  50625,
  50305,
  1088,
  52225,
  3264,
  3456,
  52545,
  3840,
  53185,
  52865,
  3648,
  2560,
  51905,
  52097,
  2880,
  51457,
  2496,
  2176,
  51265,
  55297,
  6336,
  6528,
  55617,
  6912,
  56257,
  55937,
  6720,
  7680,
  57025,
  57217,
  8e3,
  56577,
  7616,
  7296,
  56385,
  5120,
  54465,
  54657,
  5440,
  55041,
  6080,
  5760,
  54849,
  53761,
  4800,
  4992,
  54081,
  4352,
  53697,
  53377,
  4160,
  61441,
  12480,
  12672,
  61761,
  13056,
  62401,
  62081,
  12864,
  13824,
  63169,
  63361,
  14144,
  62721,
  13760,
  13440,
  62529,
  15360,
  64705,
  64897,
  15680,
  65281,
  16320,
  16e3,
  65089,
  64001,
  15040,
  15232,
  64321,
  14592,
  63937,
  63617,
  14400,
  10240,
  59585,
  59777,
  10560,
  60161,
  11200,
  10880,
  59969,
  60929,
  11968,
  12160,
  61249,
  11520,
  60865,
  60545,
  11328,
  58369,
  9408,
  9600,
  58689,
  9984,
  59329,
  59009,
  9792,
  8704,
  58049,
  58241,
  9024,
  57601,
  8640,
  8320,
  57409,
  40961,
  24768,
  24960,
  41281,
  25344,
  41921,
  41601,
  25152,
  26112,
  42689,
  42881,
  26432,
  42241,
  26048,
  25728,
  42049,
  27648,
  44225,
  44417,
  27968,
  44801,
  28608,
  28288,
  44609,
  43521,
  27328,
  27520,
  43841,
  26880,
  43457,
  43137,
  26688,
  30720,
  47297,
  47489,
  31040,
  47873,
  31680,
  31360,
  47681,
  48641,
  32448,
  32640,
  48961,
  32e3,
  48577,
  48257,
  31808,
  46081,
  29888,
  30080,
  46401,
  30464,
  47041,
  46721,
  30272,
  29184,
  45761,
  45953,
  29504,
  45313,
  29120,
  28800,
  45121,
  20480,
  37057,
  37249,
  20800,
  37633,
  21440,
  21120,
  37441,
  38401,
  22208,
  22400,
  38721,
  21760,
  38337,
  38017,
  21568,
  39937,
  23744,
  23936,
  40257,
  24320,
  40897,
  40577,
  24128,
  23040,
  39617,
  39809,
  23360,
  39169,
  22976,
  22656,
  38977,
  34817,
  18624,
  18816,
  35137,
  19200,
  35777,
  35457,
  19008,
  19968,
  36545,
  36737,
  20288,
  36097,
  19904,
  19584,
  35905,
  17408,
  33985,
  34177,
  17728,
  34561,
  18368,
  18048,
  34369,
  33281,
  17088,
  17280,
  33601,
  16640,
  33217,
  32897,
  16448
];
typeof Int32Array < "u" && (TABLE$6 = new Int32Array(TABLE$6));
const crc16 = defineCrc("crc-16", function(o, g) {
  bufferExports$1.Buffer.isBuffer(o) || (o = createBuffer(o));
  let c = ~~g;
  for (let y = 0; y < o.length; y++) {
    const t = o[y];
    c = (TABLE$6[(c ^ t) & 255] ^ c >> 8) & 65535;
  }
  return c;
});
let TABLE$5 = [
  0,
  4129,
  8258,
  12387,
  16516,
  20645,
  24774,
  28903,
  33032,
  37161,
  41290,
  45419,
  49548,
  53677,
  57806,
  61935,
  4657,
  528,
  12915,
  8786,
  21173,
  17044,
  29431,
  25302,
  37689,
  33560,
  45947,
  41818,
  54205,
  50076,
  62463,
  58334,
  9314,
  13379,
  1056,
  5121,
  25830,
  29895,
  17572,
  21637,
  42346,
  46411,
  34088,
  38153,
  58862,
  62927,
  50604,
  54669,
  13907,
  9842,
  5649,
  1584,
  30423,
  26358,
  22165,
  18100,
  46939,
  42874,
  38681,
  34616,
  63455,
  59390,
  55197,
  51132,
  18628,
  22757,
  26758,
  30887,
  2112,
  6241,
  10242,
  14371,
  51660,
  55789,
  59790,
  63919,
  35144,
  39273,
  43274,
  47403,
  23285,
  19156,
  31415,
  27286,
  6769,
  2640,
  14899,
  10770,
  56317,
  52188,
  64447,
  60318,
  39801,
  35672,
  47931,
  43802,
  27814,
  31879,
  19684,
  23749,
  11298,
  15363,
  3168,
  7233,
  60846,
  64911,
  52716,
  56781,
  44330,
  48395,
  36200,
  40265,
  32407,
  28342,
  24277,
  20212,
  15891,
  11826,
  7761,
  3696,
  65439,
  61374,
  57309,
  53244,
  48923,
  44858,
  40793,
  36728,
  37256,
  33193,
  45514,
  41451,
  53516,
  49453,
  61774,
  57711,
  4224,
  161,
  12482,
  8419,
  20484,
  16421,
  28742,
  24679,
  33721,
  37784,
  41979,
  46042,
  49981,
  54044,
  58239,
  62302,
  689,
  4752,
  8947,
  13010,
  16949,
  21012,
  25207,
  29270,
  46570,
  42443,
  38312,
  34185,
  62830,
  58703,
  54572,
  50445,
  13538,
  9411,
  5280,
  1153,
  29798,
  25671,
  21540,
  17413,
  42971,
  47098,
  34713,
  38840,
  59231,
  63358,
  50973,
  55100,
  9939,
  14066,
  1681,
  5808,
  26199,
  30326,
  17941,
  22068,
  55628,
  51565,
  63758,
  59695,
  39368,
  35305,
  47498,
  43435,
  22596,
  18533,
  30726,
  26663,
  6336,
  2273,
  14466,
  10403,
  52093,
  56156,
  60223,
  64286,
  35833,
  39896,
  43963,
  48026,
  19061,
  23124,
  27191,
  31254,
  2801,
  6864,
  10931,
  14994,
  64814,
  60687,
  56684,
  52557,
  48554,
  44427,
  40424,
  36297,
  31782,
  27655,
  23652,
  19525,
  15522,
  11395,
  7392,
  3265,
  61215,
  65342,
  53085,
  57212,
  44955,
  49082,
  36825,
  40952,
  28183,
  32310,
  20053,
  24180,
  11923,
  16050,
  3793,
  7920
];
typeof Int32Array < "u" && (TABLE$5 = new Int32Array(TABLE$5));
const crc16ccitt = defineCrc("ccitt", function(o, g) {
  bufferExports$1.Buffer.isBuffer(o) || (o = createBuffer(o));
  let c = typeof g < "u" ? ~~g : 65535;
  for (let y = 0; y < o.length; y++) {
    const t = o[y];
    c = (TABLE$5[(c >> 8 ^ t) & 255] ^ c << 8) & 65535;
  }
  return c;
});
let TABLE$4 = [
  0,
  49345,
  49537,
  320,
  49921,
  960,
  640,
  49729,
  50689,
  1728,
  1920,
  51009,
  1280,
  50625,
  50305,
  1088,
  52225,
  3264,
  3456,
  52545,
  3840,
  53185,
  52865,
  3648,
  2560,
  51905,
  52097,
  2880,
  51457,
  2496,
  2176,
  51265,
  55297,
  6336,
  6528,
  55617,
  6912,
  56257,
  55937,
  6720,
  7680,
  57025,
  57217,
  8e3,
  56577,
  7616,
  7296,
  56385,
  5120,
  54465,
  54657,
  5440,
  55041,
  6080,
  5760,
  54849,
  53761,
  4800,
  4992,
  54081,
  4352,
  53697,
  53377,
  4160,
  61441,
  12480,
  12672,
  61761,
  13056,
  62401,
  62081,
  12864,
  13824,
  63169,
  63361,
  14144,
  62721,
  13760,
  13440,
  62529,
  15360,
  64705,
  64897,
  15680,
  65281,
  16320,
  16e3,
  65089,
  64001,
  15040,
  15232,
  64321,
  14592,
  63937,
  63617,
  14400,
  10240,
  59585,
  59777,
  10560,
  60161,
  11200,
  10880,
  59969,
  60929,
  11968,
  12160,
  61249,
  11520,
  60865,
  60545,
  11328,
  58369,
  9408,
  9600,
  58689,
  9984,
  59329,
  59009,
  9792,
  8704,
  58049,
  58241,
  9024,
  57601,
  8640,
  8320,
  57409,
  40961,
  24768,
  24960,
  41281,
  25344,
  41921,
  41601,
  25152,
  26112,
  42689,
  42881,
  26432,
  42241,
  26048,
  25728,
  42049,
  27648,
  44225,
  44417,
  27968,
  44801,
  28608,
  28288,
  44609,
  43521,
  27328,
  27520,
  43841,
  26880,
  43457,
  43137,
  26688,
  30720,
  47297,
  47489,
  31040,
  47873,
  31680,
  31360,
  47681,
  48641,
  32448,
  32640,
  48961,
  32e3,
  48577,
  48257,
  31808,
  46081,
  29888,
  30080,
  46401,
  30464,
  47041,
  46721,
  30272,
  29184,
  45761,
  45953,
  29504,
  45313,
  29120,
  28800,
  45121,
  20480,
  37057,
  37249,
  20800,
  37633,
  21440,
  21120,
  37441,
  38401,
  22208,
  22400,
  38721,
  21760,
  38337,
  38017,
  21568,
  39937,
  23744,
  23936,
  40257,
  24320,
  40897,
  40577,
  24128,
  23040,
  39617,
  39809,
  23360,
  39169,
  22976,
  22656,
  38977,
  34817,
  18624,
  18816,
  35137,
  19200,
  35777,
  35457,
  19008,
  19968,
  36545,
  36737,
  20288,
  36097,
  19904,
  19584,
  35905,
  17408,
  33985,
  34177,
  17728,
  34561,
  18368,
  18048,
  34369,
  33281,
  17088,
  17280,
  33601,
  16640,
  33217,
  32897,
  16448
];
typeof Int32Array < "u" && (TABLE$4 = new Int32Array(TABLE$4));
const crc16modbus = defineCrc("crc-16-modbus", function(o, g) {
  bufferExports$1.Buffer.isBuffer(o) || (o = createBuffer(o));
  let c = typeof g < "u" ? ~~g : 65535;
  for (let y = 0; y < o.length; y++) {
    const t = o[y];
    c = (TABLE$4[(c ^ t) & 255] ^ c >> 8) & 65535;
  }
  return c;
}), crc16xmodem = defineCrc("xmodem", function(o, g) {
  bufferExports$1.Buffer.isBuffer(o) || (o = createBuffer(o));
  let c = typeof g < "u" ? ~~g : 0;
  for (let y = 0; y < o.length; y++) {
    const t = o[y];
    let d = c >>> 8 & 255;
    d ^= t & 255, d ^= d >>> 4, c = c << 8 & 65535, c ^= d, d = d << 5 & 65535, c ^= d, d = d << 7 & 65535, c ^= d;
  }
  return c;
});
let TABLE$3 = [
  0,
  4489,
  8978,
  12955,
  17956,
  22445,
  25910,
  29887,
  35912,
  40385,
  44890,
  48851,
  51820,
  56293,
  59774,
  63735,
  4225,
  264,
  13203,
  8730,
  22181,
  18220,
  30135,
  25662,
  40137,
  36160,
  49115,
  44626,
  56045,
  52068,
  63999,
  59510,
  8450,
  12427,
  528,
  5017,
  26406,
  30383,
  17460,
  21949,
  44362,
  48323,
  36440,
  40913,
  60270,
  64231,
  51324,
  55797,
  12675,
  8202,
  4753,
  792,
  30631,
  26158,
  21685,
  17724,
  48587,
  44098,
  40665,
  36688,
  64495,
  60006,
  55549,
  51572,
  16900,
  21389,
  24854,
  28831,
  1056,
  5545,
  10034,
  14011,
  52812,
  57285,
  60766,
  64727,
  34920,
  39393,
  43898,
  47859,
  21125,
  17164,
  29079,
  24606,
  5281,
  1320,
  14259,
  9786,
  57037,
  53060,
  64991,
  60502,
  39145,
  35168,
  48123,
  43634,
  25350,
  29327,
  16404,
  20893,
  9506,
  13483,
  1584,
  6073,
  61262,
  65223,
  52316,
  56789,
  43370,
  47331,
  35448,
  39921,
  29575,
  25102,
  20629,
  16668,
  13731,
  9258,
  5809,
  1848,
  65487,
  60998,
  56541,
  52564,
  47595,
  43106,
  39673,
  35696,
  33800,
  38273,
  42778,
  46739,
  49708,
  54181,
  57662,
  61623,
  2112,
  6601,
  11090,
  15067,
  20068,
  24557,
  28022,
  31999,
  38025,
  34048,
  47003,
  42514,
  53933,
  49956,
  61887,
  57398,
  6337,
  2376,
  15315,
  10842,
  24293,
  20332,
  32247,
  27774,
  42250,
  46211,
  34328,
  38801,
  58158,
  62119,
  49212,
  53685,
  10562,
  14539,
  2640,
  7129,
  28518,
  32495,
  19572,
  24061,
  46475,
  41986,
  38553,
  34576,
  62383,
  57894,
  53437,
  49460,
  14787,
  10314,
  6865,
  2904,
  32743,
  28270,
  23797,
  19836,
  50700,
  55173,
  58654,
  62615,
  32808,
  37281,
  41786,
  45747,
  19012,
  23501,
  26966,
  30943,
  3168,
  7657,
  12146,
  16123,
  54925,
  50948,
  62879,
  58390,
  37033,
  33056,
  46011,
  41522,
  23237,
  19276,
  31191,
  26718,
  7393,
  3432,
  16371,
  11898,
  59150,
  63111,
  50204,
  54677,
  41258,
  45219,
  33336,
  37809,
  27462,
  31439,
  18516,
  23005,
  11618,
  15595,
  3696,
  8185,
  63375,
  58886,
  54429,
  50452,
  45483,
  40994,
  37561,
  33584,
  31687,
  27214,
  22741,
  18780,
  15843,
  11370,
  7921,
  3960
];
typeof Int32Array < "u" && (TABLE$3 = new Int32Array(TABLE$3));
const crc16kermit = defineCrc("kermit", function(o, g) {
  bufferExports$1.Buffer.isBuffer(o) || (o = createBuffer(o));
  let c = typeof g < "u" ? ~~g : 0;
  for (let y = 0; y < o.length; y++) {
    const t = o[y];
    c = (TABLE$3[(c ^ t) & 255] ^ c >> 8) & 65535;
  }
  return c;
});
let TABLE$2 = [
  0,
  8801531,
  9098509,
  825846,
  9692897,
  1419802,
  1651692,
  10452759,
  10584377,
  2608578,
  2839604,
  11344079,
  3303384,
  11807523,
  12104405,
  4128302,
  12930697,
  4391538,
  5217156,
  13227903,
  5679208,
  13690003,
  14450021,
  5910942,
  6606768,
  14844747,
  15604413,
  6837830,
  16197969,
  7431594,
  8256604,
  16494759,
  840169,
  9084178,
  8783076,
  18463,
  10434312,
  1670131,
  1434117,
  9678590,
  11358416,
  2825259,
  2590173,
  10602790,
  4109873,
  12122826,
  11821884,
  3289031,
  13213536,
  5231515,
  4409965,
  12912278,
  5929345,
  14431610,
  13675660,
  5693559,
  6823513,
  15618722,
  14863188,
  6588335,
  16513208,
  8238147,
  7417269,
  16212302,
  1680338,
  10481449,
  9664223,
  1391140,
  9061683,
  788936,
  36926,
  8838341,
  12067563,
  4091408,
  3340262,
  11844381,
  2868234,
  11372785,
  10555655,
  2579964,
  14478683,
  5939616,
  5650518,
  13661357,
  5180346,
  13190977,
  12967607,
  4428364,
  8219746,
  16457881,
  16234863,
  7468436,
  15633027,
  6866552,
  6578062,
  14816117,
  1405499,
  9649856,
  10463030,
  1698765,
  8819930,
  55329,
  803287,
  9047340,
  11858690,
  3325945,
  4072975,
  12086004,
  2561507,
  10574104,
  11387118,
  2853909,
  13647026,
  5664841,
  5958079,
  14460228,
  4446803,
  12949160,
  13176670,
  5194661,
  7454091,
  16249200,
  16476294,
  8201341,
  14834538,
  6559633,
  6852199,
  15647388,
  3360676,
  11864927,
  12161705,
  4185682,
  10527045,
  2551230,
  2782280,
  11286707,
  9619101,
  1346150,
  1577872,
  10379115,
  73852,
  8875143,
  9172337,
  899466,
  16124205,
  7357910,
  8182816,
  16421083,
  6680524,
  14918455,
  15678145,
  6911546,
  5736468,
  13747439,
  14507289,
  5968354,
  12873461,
  4334094,
  5159928,
  13170435,
  4167245,
  12180150,
  11879232,
  3346363,
  11301036,
  2767959,
  2532769,
  10545498,
  10360692,
  1596303,
  1360505,
  9604738,
  913813,
  9157998,
  8856728,
  92259,
  16439492,
  8164415,
  7343561,
  16138546,
  6897189,
  15692510,
  14936872,
  6662099,
  5986813,
  14488838,
  13733104,
  5750795,
  13156124,
  5174247,
  4352529,
  12855018,
  2810998,
  11315341,
  10498427,
  2522496,
  12124823,
  4148844,
  3397530,
  11901793,
  9135439,
  862644,
  110658,
  8912057,
  1606574,
  10407765,
  9590435,
  1317464,
  15706879,
  6940164,
  6651890,
  14889737,
  8145950,
  16384229,
  16161043,
  7394792,
  5123014,
  13133629,
  12910283,
  4370992,
  14535975,
  5997020,
  5707818,
  13718737,
  2504095,
  10516836,
  11329682,
  2796649,
  11916158,
  3383173,
  4130419,
  12143240,
  8893606,
  129117,
  876971,
  9121104,
  1331783,
  9576124,
  10389322,
  1625009,
  14908182,
  6633453,
  6925851,
  15721184,
  7380471,
  16175372,
  16402682,
  8127489,
  4389423,
  12891860,
  13119266,
  5137369,
  13704398,
  5722165,
  6015427,
  14517560
];
typeof Int32Array < "u" && (TABLE$2 = new Int32Array(TABLE$2));
const crc24 = defineCrc("crc-24", function(o, g) {
  bufferExports$1.Buffer.isBuffer(o) || (o = createBuffer(o));
  let c = typeof g < "u" ? ~~g : 11994318;
  for (let y = 0; y < o.length; y++) {
    const t = o[y];
    c = (TABLE$2[(c >> 16 ^ t) & 255] ^ c << 8) & 16777215;
  }
  return c;
});
let TABLE$1 = [
  0,
  1996959894,
  3993919788,
  2567524794,
  124634137,
  1886057615,
  3915621685,
  2657392035,
  249268274,
  2044508324,
  3772115230,
  2547177864,
  162941995,
  2125561021,
  3887607047,
  2428444049,
  498536548,
  1789927666,
  4089016648,
  2227061214,
  450548861,
  1843258603,
  4107580753,
  2211677639,
  325883990,
  1684777152,
  4251122042,
  2321926636,
  335633487,
  1661365465,
  4195302755,
  2366115317,
  997073096,
  1281953886,
  3579855332,
  2724688242,
  1006888145,
  1258607687,
  3524101629,
  2768942443,
  901097722,
  1119000684,
  3686517206,
  2898065728,
  853044451,
  1172266101,
  3705015759,
  2882616665,
  651767980,
  1373503546,
  3369554304,
  3218104598,
  565507253,
  1454621731,
  3485111705,
  3099436303,
  671266974,
  1594198024,
  3322730930,
  2970347812,
  795835527,
  1483230225,
  3244367275,
  3060149565,
  1994146192,
  31158534,
  2563907772,
  4023717930,
  1907459465,
  112637215,
  2680153253,
  3904427059,
  2013776290,
  251722036,
  2517215374,
  3775830040,
  2137656763,
  141376813,
  2439277719,
  3865271297,
  1802195444,
  476864866,
  2238001368,
  4066508878,
  1812370925,
  453092731,
  2181625025,
  4111451223,
  1706088902,
  314042704,
  2344532202,
  4240017532,
  1658658271,
  366619977,
  2362670323,
  4224994405,
  1303535960,
  984961486,
  2747007092,
  3569037538,
  1256170817,
  1037604311,
  2765210733,
  3554079995,
  1131014506,
  879679996,
  2909243462,
  3663771856,
  1141124467,
  855842277,
  2852801631,
  3708648649,
  1342533948,
  654459306,
  3188396048,
  3373015174,
  1466479909,
  544179635,
  3110523913,
  3462522015,
  1591671054,
  702138776,
  2966460450,
  3352799412,
  1504918807,
  783551873,
  3082640443,
  3233442989,
  3988292384,
  2596254646,
  62317068,
  1957810842,
  3939845945,
  2647816111,
  81470997,
  1943803523,
  3814918930,
  2489596804,
  225274430,
  2053790376,
  3826175755,
  2466906013,
  167816743,
  2097651377,
  4027552580,
  2265490386,
  503444072,
  1762050814,
  4150417245,
  2154129355,
  426522225,
  1852507879,
  4275313526,
  2312317920,
  282753626,
  1742555852,
  4189708143,
  2394877945,
  397917763,
  1622183637,
  3604390888,
  2714866558,
  953729732,
  1340076626,
  3518719985,
  2797360999,
  1068828381,
  1219638859,
  3624741850,
  2936675148,
  906185462,
  1090812512,
  3747672003,
  2825379669,
  829329135,
  1181335161,
  3412177804,
  3160834842,
  628085408,
  1382605366,
  3423369109,
  3138078467,
  570562233,
  1426400815,
  3317316542,
  2998733608,
  733239954,
  1555261956,
  3268935591,
  3050360625,
  752459403,
  1541320221,
  2607071920,
  3965973030,
  1969922972,
  40735498,
  2617837225,
  3943577151,
  1913087877,
  83908371,
  2512341634,
  3803740692,
  2075208622,
  213261112,
  2463272603,
  3855990285,
  2094854071,
  198958881,
  2262029012,
  4057260610,
  1759359992,
  534414190,
  2176718541,
  4139329115,
  1873836001,
  414664567,
  2282248934,
  4279200368,
  1711684554,
  285281116,
  2405801727,
  4167216745,
  1634467795,
  376229701,
  2685067896,
  3608007406,
  1308918612,
  956543938,
  2808555105,
  3495958263,
  1231636301,
  1047427035,
  2932959818,
  3654703836,
  1088359270,
  936918e3,
  2847714899,
  3736837829,
  1202900863,
  817233897,
  3183342108,
  3401237130,
  1404277552,
  615818150,
  3134207493,
  3453421203,
  1423857449,
  601450431,
  3009837614,
  3294710456,
  1567103746,
  711928724,
  3020668471,
  3272380065,
  1510334235,
  755167117
];
typeof Int32Array < "u" && (TABLE$1 = new Int32Array(TABLE$1));
const crc32$1 = defineCrc("crc-32", function(o, g) {
  bufferExports$1.Buffer.isBuffer(o) || (o = createBuffer(o));
  let c = g === 0 ? 0 : ~~g ^ -1;
  for (let y = 0; y < o.length; y++) {
    const t = o[y];
    c = TABLE$1[(c ^ t) & 255] ^ c >>> 8;
  }
  return c ^ -1;
});
let TABLE = [
  0,
  1996959894,
  3993919788,
  2567524794,
  124634137,
  1886057615,
  3915621685,
  2657392035,
  249268274,
  2044508324,
  3772115230,
  2547177864,
  162941995,
  2125561021,
  3887607047,
  2428444049,
  498536548,
  1789927666,
  4089016648,
  2227061214,
  450548861,
  1843258603,
  4107580753,
  2211677639,
  325883990,
  1684777152,
  4251122042,
  2321926636,
  335633487,
  1661365465,
  4195302755,
  2366115317,
  997073096,
  1281953886,
  3579855332,
  2724688242,
  1006888145,
  1258607687,
  3524101629,
  2768942443,
  901097722,
  1119000684,
  3686517206,
  2898065728,
  853044451,
  1172266101,
  3705015759,
  2882616665,
  651767980,
  1373503546,
  3369554304,
  3218104598,
  565507253,
  1454621731,
  3485111705,
  3099436303,
  671266974,
  1594198024,
  3322730930,
  2970347812,
  795835527,
  1483230225,
  3244367275,
  3060149565,
  1994146192,
  31158534,
  2563907772,
  4023717930,
  1907459465,
  112637215,
  2680153253,
  3904427059,
  2013776290,
  251722036,
  2517215374,
  3775830040,
  2137656763,
  141376813,
  2439277719,
  3865271297,
  1802195444,
  476864866,
  2238001368,
  4066508878,
  1812370925,
  453092731,
  2181625025,
  4111451223,
  1706088902,
  314042704,
  2344532202,
  4240017532,
  1658658271,
  366619977,
  2362670323,
  4224994405,
  1303535960,
  984961486,
  2747007092,
  3569037538,
  1256170817,
  1037604311,
  2765210733,
  3554079995,
  1131014506,
  879679996,
  2909243462,
  3663771856,
  1141124467,
  855842277,
  2852801631,
  3708648649,
  1342533948,
  654459306,
  3188396048,
  3373015174,
  1466479909,
  544179635,
  3110523913,
  3462522015,
  1591671054,
  702138776,
  2966460450,
  3352799412,
  1504918807,
  783551873,
  3082640443,
  3233442989,
  3988292384,
  2596254646,
  62317068,
  1957810842,
  3939845945,
  2647816111,
  81470997,
  1943803523,
  3814918930,
  2489596804,
  225274430,
  2053790376,
  3826175755,
  2466906013,
  167816743,
  2097651377,
  4027552580,
  2265490386,
  503444072,
  1762050814,
  4150417245,
  2154129355,
  426522225,
  1852507879,
  4275313526,
  2312317920,
  282753626,
  1742555852,
  4189708143,
  2394877945,
  397917763,
  1622183637,
  3604390888,
  2714866558,
  953729732,
  1340076626,
  3518719985,
  2797360999,
  1068828381,
  1219638859,
  3624741850,
  2936675148,
  906185462,
  1090812512,
  3747672003,
  2825379669,
  829329135,
  1181335161,
  3412177804,
  3160834842,
  628085408,
  1382605366,
  3423369109,
  3138078467,
  570562233,
  1426400815,
  3317316542,
  2998733608,
  733239954,
  1555261956,
  3268935591,
  3050360625,
  752459403,
  1541320221,
  2607071920,
  3965973030,
  1969922972,
  40735498,
  2617837225,
  3943577151,
  1913087877,
  83908371,
  2512341634,
  3803740692,
  2075208622,
  213261112,
  2463272603,
  3855990285,
  2094854071,
  198958881,
  2262029012,
  4057260610,
  1759359992,
  534414190,
  2176718541,
  4139329115,
  1873836001,
  414664567,
  2282248934,
  4279200368,
  1711684554,
  285281116,
  2405801727,
  4167216745,
  1634467795,
  376229701,
  2685067896,
  3608007406,
  1308918612,
  956543938,
  2808555105,
  3495958263,
  1231636301,
  1047427035,
  2932959818,
  3654703836,
  1088359270,
  936918e3,
  2847714899,
  3736837829,
  1202900863,
  817233897,
  3183342108,
  3401237130,
  1404277552,
  615818150,
  3134207493,
  3453421203,
  1423857449,
  601450431,
  3009837614,
  3294710456,
  1567103746,
  711928724,
  3020668471,
  3272380065,
  1510334235,
  755167117
];
typeof Int32Array < "u" && (TABLE = new Int32Array(TABLE));
const crcjam = defineCrc("jam", function(o, g = -1) {
  bufferExports$1.Buffer.isBuffer(o) || (o = createBuffer(o));
  let c = g === 0 ? 0 : ~~g;
  for (let y = 0; y < o.length; y++) {
    const t = o[y];
    c = TABLE[(c ^ t) & 255] ^ c >>> 8;
  }
  return c;
}), index = {
  crc1,
  crc8,
  crc81wire,
  crc16,
  crc16ccitt,
  crc16modbus,
  crc16xmodem,
  crc16kermit,
  crc24,
  crc32: crc32$1,
  crcjam
}, crc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  crc1,
  crc16,
  crc16ccitt,
  crc16kermit,
  crc16modbus,
  crc16xmodem,
  crc24,
  crc32: crc32$1,
  crc8,
  crc81wire,
  crcjam,
  default: index
}, Symbol.toStringTag, { value: "Module" })), require$$1$4 = /* @__PURE__ */ getAugmentedNamespace(crc);
var hasRequiredUtils$f;
function requireUtils$f() {
  if (hasRequiredUtils$f) return utils$g;
  hasRequiredUtils$f = 1;
  var o = utils$g && utils$g.__importDefault || function(fe) {
    return fe && fe.__esModule ? fe : { default: fe };
  };
  Object.defineProperty(utils$g, "__esModule", { value: !0 }), utils$g.bufferXOR = utils$g.setDifference = utils$g.arrayContains = utils$g.arraysEqual = utils$g.hasPrefix = utils$g.isURType = utils$g.intToBytes = utils$g.toUint32 = utils$g.getCRCHex = utils$g.getCRC = utils$g.split = utils$g.partition = utils$g.sha256Hash = void 0;
  const g = o(requireSha_js()), c = require$$1$4, y = (fe) => g.default("sha256").update(fe).digest();
  utils$g.sha256Hash = y;
  const t = (fe, ge) => fe.match(new RegExp(".{1," + ge + "}", "g")) || [fe];
  utils$g.partition = t;
  const d = (fe, ge) => [fe.slice(0, -ge), fe.slice(-ge)];
  utils$g.split = d;
  const E = (fe) => c.crc32(fe);
  utils$g.getCRC = E;
  const B = (fe) => c.crc32(fe).toString(16).padStart(8, "0");
  utils$g.getCRCHex = B;
  const D = (fe) => fe >>> 0;
  utils$g.toUint32 = D;
  const x = (fe) => {
    const ge = new ArrayBuffer(4);
    return new DataView(ge).setUint32(0, fe, !1), Buffer.from(ge);
  };
  utils$g.intToBytes = x;
  const v = (fe) => fe.split("").every((ge, Ie) => {
    let Ee = fe.charCodeAt(Ie);
    return 97 <= Ee && Ee <= 122 || 48 <= Ee && Ee <= 57 || Ee === 45;
  });
  utils$g.isURType = v;
  const F = (fe, ge) => fe.indexOf(ge) === 0;
  utils$g.hasPrefix = F;
  const M = (fe, ge) => fe.length !== ge.length ? !1 : fe.every((Ie) => ge.includes(Ie));
  utils$g.arraysEqual = M;
  const U = (fe, ge) => ge.every((Ie) => fe.includes(Ie));
  utils$g.arrayContains = U;
  const L = (fe, ge) => fe.filter((Ie) => ge.indexOf(Ie) < 0);
  utils$g.setDifference = L;
  const H = (fe, ge) => {
    const Ie = Math.max(fe.length, ge.length), Ee = Buffer.allocUnsafe(Ie);
    for (let Se = 0; Se < Ie; ++Se)
      Ee[Se] = fe[Se] ^ ge[Se];
    return Ee;
  };
  return utils$g.bufferXOR = H, utils$g;
}
var cbor = {}, main$5 = { exports: {} }, main$4 = main$5.exports, hasRequiredMain$4;
function requireMain$4() {
  return hasRequiredMain$4 || (hasRequiredMain$4 = 1, function(o) {
    (function(g, c) {
      o.exports ? o.exports = c() : g.CBOR = c();
    })(main$4, function() {
      var g = function() {
        function c(He) {
          this.$hex = He;
        }
        c.prototype = {
          length: function() {
            return this.$hex.length / 2;
          },
          toString: function(He) {
            if (!He || He === "hex" || He === 16) return this.$hex;
            if (He === "utf-8") {
              for (var Pe = "", De = 0; De < this.$hex.length; De += 2)
                Pe += "%" + this.$hex.substring(De, De + 2);
              return decodeURIComponent(Pe);
            }
            if (He === "latin") {
              for (var Pe = [], De = 0; De < this.$hex.length; De += 2)
                Pe.push(parseInt(this.$hex.substring(De, De + 2), 16));
              return String.fromCharCode.apply(String, Pe);
            }
            throw new Error("Unrecognised format: " + He);
          }
        }, c.fromLatinString = function(He) {
          for (var Pe = "", De = 0; De < He.length; De++) {
            var ve = He.charCodeAt(De).toString(16);
            ve.length === 1 && (ve = "0" + ve), Pe += ve;
          }
          return new c(Pe);
        }, c.fromUtf8String = function(He) {
          for (var Pe = encodeURIComponent(He), De = "", ve = 0; ve < Pe.length; ve++)
            if (Pe.charAt(ve) === "%")
              De += Pe.substring(ve + 1, ve + 3), ve += 2;
            else {
              var Fe = Pe.charCodeAt(ve).toString(16);
              Fe.length < 2 && (Fe = "0" + Fe), De += Fe;
            }
          return new c(De);
        };
        var y = [], t = {}, d = function(He) {
          return function() {
            throw new Error(He + " not implemented");
          };
        };
        function E() {
        }
        E.prototype = {
          peekByte: d("peekByte"),
          readByte: d("readByte"),
          readChunk: d("readChunk"),
          readFloat16: function() {
            var He = this.readUint16(), Pe = (He & 32767) >> 10, De = He & 1023, ve = He & 32768;
            if (Pe === 31)
              return De === 0 ? ve ? -1 / 0 : 1 / 0 : NaN;
            var Fe = Pe ? Math.pow(2, Pe - 25) * (1024 + De) : Math.pow(2, -24) * De;
            return ve ? -Fe : Fe;
          },
          readFloat32: function() {
            var He = this.readUint32(), Pe = (He & 2147483647) >> 23, De = He & 8388607, ve = He & 2147483648;
            if (Pe === 255)
              return De === 0 ? ve ? -1 / 0 : 1 / 0 : NaN;
            var Fe = Pe ? Math.pow(2, Pe - 23 - 127) * (8388608 + De) : Math.pow(2, -149) * De;
            return ve ? -Fe : Fe;
          },
          readFloat64: function() {
            var He = this.readUint32(), Pe = this.readUint32(), De = He >> 20 & 2047, ve = (He & 1048575) * 4294967296 + Pe, Fe = He & 2147483648;
            if (De === 2047)
              return ve === 0 ? Fe ? -1 / 0 : 1 / 0 : NaN;
            var be = De ? Math.pow(2, De - 52 - 1023) * (4503599627370496 + ve) : Math.pow(2, -1074) * ve;
            return Fe ? -be : be;
          },
          readUint16: function() {
            return this.readByte() * 256 + this.readByte();
          },
          readUint32: function() {
            return this.readUint16() * 65536 + this.readUint16();
          },
          readUint64: function() {
            return this.readUint32() * 4294967296 + this.readUint32();
          }
        };
        function B() {
        }
        B.prototype = {
          writeByte: d("writeByte"),
          result: d("result"),
          writeFloat16: d("writeFloat16"),
          writeFloat32: d("writeFloat32"),
          writeFloat64: d("writeFloat64"),
          writeUint16: function(He) {
            this.writeByte(He >> 8 & 255), this.writeByte(He & 255);
          },
          writeUint32: function(He) {
            this.writeUint16(He >> 16 & 65535), this.writeUint16(He & 65535);
          },
          writeUint64: function(He) {
            if (He >= 9007199254740992 || He <= -9007199254740992)
              throw new Error("Cannot encode Uint64 of: " + He + " magnitude to big (floating point errors)");
            this.writeUint32(Math.floor(He / 4294967296)), this.writeUint32(He % 4294967296);
          },
          writeString: d("writeString"),
          canWriteBinary: function(He) {
            return !1;
          },
          writeBinary: d("writeChunk")
        };
        function D(He) {
          var Pe = He.readByte(), De = Pe >> 5, ve = Pe & 31;
          return { type: De, value: ve };
        }
        function x(He, Pe) {
          var De = He.value;
          if (De < 24)
            return De;
          if (De == 24)
            return Pe.readByte();
          if (De == 25)
            return Pe.readUint16();
          if (De == 26)
            return Pe.readUint32();
          if (De == 27)
            return Pe.readUint64();
          if (De == 31)
            return null;
          d("Additional info: " + De)();
        }
        function v(He, Pe, De) {
          De.writeByte(He << 5 | Pe);
        }
        function F(He, Pe, De) {
          var ve = He << 5;
          Pe < 24 ? De.writeByte(ve | Pe) : Pe < 256 ? (De.writeByte(ve | 24), De.writeByte(Pe)) : Pe < 65536 ? (De.writeByte(ve | 25), De.writeUint16(Pe)) : Pe < 4294967296 ? (De.writeByte(ve | 26), De.writeUint32(Pe)) : (De.writeByte(ve | 27), De.writeUint64(Pe));
        }
        var M = new Error();
        function U(He) {
          var Pe = D(He);
          switch (Pe.type) {
            case 0:
              return x(Pe, He);
            case 1:
              return -1 - x(Pe, He);
            case 2:
              return He.readChunk(x(Pe, He));
            case 3:
              var De = He.readChunk(x(Pe, He));
              return De.toString("utf-8");
            case 4:
            case 5:
              var ve = x(Pe, He), Ne = [];
              if (ve !== null) {
                Pe.type === 5 && (ve *= 2);
                for (var Fe = 0; Fe < ve; Fe++)
                  Ne[Fe] = U(He);
              } else
                for (var be; (be = U(He)) !== M; )
                  Ne.push(be);
              if (Pe.type === 5) {
                for (var Be = {}, Fe = 0; Fe < Ne.length; Fe += 2)
                  Be[Ne[Fe]] = Ne[Fe + 1];
                return Be;
              } else
                return Ne;
            case 6:
              var ke = x(Pe, He), xe = t[ke], Ne = U(He);
              return xe ? xe(Ne) : Ne;
            case 7:
              if (Pe.value === 25)
                return He.readFloat16();
              if (Pe.value === 26)
                return He.readFloat32();
              if (Pe.value === 27)
                return He.readFloat64();
              switch (x(Pe, He)) {
                case 20:
                  return !1;
                case 21:
                  return !0;
                case 22:
                  return null;
                case 23:
                  return;
                case null:
                  return M;
                default:
                  throw new Error("Unknown fixed value: " + Pe.value);
              }
            default:
              throw new Error("Unsupported header: " + JSON.stringify(Pe));
          }
          throw new Error("not implemented yet");
        }
        function L(He, Pe) {
          for (var De = 0; De < y.length; De++) {
            var ve = y[De].fn(He);
            if (ve !== void 0)
              return F(6, y[De].tag, Pe), L(ve, Pe);
          }
          if (He && typeof He.toCBOR == "function" && (He = He.toCBOR()), He === !1)
            F(7, 20, Pe);
          else if (He === !0)
            F(7, 21, Pe);
          else if (He === null)
            F(7, 22, Pe);
          else if (He === void 0)
            F(7, 23, Pe);
          else if (typeof He == "number")
            Math.floor(He) === He && He < 9007199254740992 && He > -9007199254740992 ? He < 0 ? F(1, -1 - He, Pe) : F(0, He, Pe) : (v(7, 27, Pe), Pe.writeFloat64(He));
          else if (typeof He == "string")
            Pe.writeString(He, function(be) {
              F(3, be, Pe);
            });
          else if (Pe.canWriteBinary(He))
            Pe.writeBinary(He, function(be) {
              F(2, be, Pe);
            });
          else if (typeof He == "object")
            if (ge.config.useToJSON && typeof He.toJSON == "function" && (He = He.toJSON()), Array.isArray(He)) {
              F(4, He.length, Pe);
              for (var De = 0; De < He.length; De++)
                L(He[De], Pe);
            } else {
              var Fe = Object.keys(He);
              F(5, Fe.length, Pe);
              for (var De = 0; De < Fe.length; De++)
                L(Fe[De], Pe), L(He[Fe[De]], Pe);
            }
          else
            throw new Error("CBOR encoding not supported: " + He);
        }
        var H = [], fe = [], ge = {
          config: {
            useToJSON: !0
          },
          addWriter: function(He, Pe) {
            typeof He == "string" ? fe.push(function(De) {
              if (He === De) return Pe(De);
            }) : fe.push(He);
          },
          addReader: function(He, Pe) {
            typeof He == "string" ? H.push(function(De, ve) {
              if (He === ve) return Pe(De, ve);
            }) : H.push(He);
          },
          encode: function(He, Pe) {
            for (var De = 0; De < fe.length; De++) {
              var ve = fe[De], Fe = ve(Pe);
              if (Fe)
                return L(He, Fe), Fe.result();
            }
            throw new Error("Unsupported output format: " + Pe);
          },
          decode: function(He, Pe) {
            for (var De = 0; De < H.length; De++) {
              var ve = H[De], Fe = ve(He, Pe);
              if (Fe)
                return U(Fe);
            }
            throw new Error("Unsupported input format: " + Pe);
          },
          addSemanticEncode: function(He, Pe) {
            if (typeof He != "number" || He % 1 !== 0 || He < 0)
              throw new Error("Tag must be a positive integer");
            return y.push({ tag: He, fn: Pe }), this;
          },
          addSemanticDecode: function(He, Pe) {
            if (typeof He != "number" || He % 1 !== 0 || He < 0)
              throw new Error("Tag must be a positive integer");
            return t[He] = Pe, this;
          },
          Reader: E,
          Writer: B
        };
        function Ie(He) {
          this.buffer = He, this.pos = 0;
        }
        Ie.prototype = Object.create(E.prototype), Ie.prototype.peekByte = function() {
          return this.buffer[this.pos];
        }, Ie.prototype.readByte = function() {
          return this.buffer[this.pos++];
        }, Ie.prototype.readUint16 = function() {
          var He = this.buffer.readUInt16BE(this.pos);
          return this.pos += 2, He;
        }, Ie.prototype.readUint32 = function() {
          var He = this.buffer.readUInt32BE(this.pos);
          return this.pos += 4, He;
        }, Ie.prototype.readFloat32 = function() {
          var He = this.buffer.readFloatBE(this.pos);
          return this.pos += 4, He;
        }, Ie.prototype.readFloat64 = function() {
          var He = this.buffer.readDoubleBE(this.pos);
          return this.pos += 8, He;
        }, Ie.prototype.readChunk = function(He) {
          var Pe = Buffer.alloc(He);
          return this.buffer.copy(Pe, 0, this.pos, this.pos += He), Pe;
        };
        function Ee(He) {
          this.byteLength = 0, this.defaultBufferLength = 16384, this.latestBuffer = Buffer.alloc(this.defaultBufferLength), this.latestBufferOffset = 0, this.completeBuffers = [], this.stringFormat = He;
        }
        Ee.prototype = Object.create(B.prototype), Ee.prototype.writeByte = function(He) {
          this.latestBuffer[this.latestBufferOffset++] = He, this.latestBufferOffset >= this.latestBuffer.length && (this.completeBuffers.push(this.latestBuffer), this.latestBuffer = Buffer.alloc(this.defaultBufferLength), this.latestBufferOffset = 0), this.byteLength++;
        }, Ee.prototype.writeFloat32 = function(He) {
          var Pe = Buffer.alloc(4);
          Pe.writeFloatBE(He, 0), this.writeBuffer(Pe);
        }, Ee.prototype.writeFloat64 = function(He) {
          var Pe = Buffer.alloc(8);
          Pe.writeDoubleBE(He, 0), this.writeBuffer(Pe);
        }, Ee.prototype.writeString = function(He, Pe) {
          var De = Buffer.from(He, "utf-8");
          Pe(De.length), this.writeBuffer(De);
        }, Ee.prototype.canWriteBinary = function(He) {
          return He instanceof Buffer;
        }, Ee.prototype.writeBinary = function(He, Pe) {
          Pe(He.length), this.writeBuffer(He);
        }, Ee.prototype.writeBuffer = function(He) {
          if (!(He instanceof Buffer)) throw new TypeError("BufferWriter only accepts Buffers");
          this.latestBufferOffset ? this.latestBuffer.length - this.latestBufferOffset >= He.length ? (He.copy(this.latestBuffer, this.latestBufferOffset), this.latestBufferOffset += He.length, this.latestBufferOffset >= this.latestBuffer.length && (this.completeBuffers.push(this.latestBuffer), this.latestBuffer = Buffer.alloc(this.defaultBufferLength), this.latestBufferOffset = 0)) : (this.completeBuffers.push(this.latestBuffer.slice(0, this.latestBufferOffset)), this.completeBuffers.push(He), this.latestBuffer = Buffer.alloc(this.defaultBufferLength), this.latestBufferOffset = 0) : this.completeBuffers.push(He), this.byteLength += He.length;
        }, Ee.prototype.result = function() {
          for (var He = Buffer.alloc(this.byteLength), Pe = 0, De = 0; De < this.completeBuffers.length; De++) {
            var ve = this.completeBuffers[De];
            ve.copy(He, Pe, 0, ve.length), Pe += ve.length;
          }
          return this.latestBufferOffset && this.latestBuffer.copy(He, Pe, 0, this.latestBufferOffset), this.stringFormat ? He.toString(this.stringFormat) : He;
        }, typeof Buffer == "function" && (ge.addReader(function(He, Pe) {
          if (He instanceof Buffer)
            return new Ie(He);
          if (Pe === "hex" || Pe === "base64") {
            var De = Buffer.from(He, Pe);
            return new Ie(De);
          }
        }), ge.addWriter(function(He) {
          if (!He || He === "buffer")
            return new Ee();
          if (He === "hex" || He === "base64")
            return new Ee(He);
        }));
        function Se(He) {
          this.hex = He, this.pos = 0;
        }
        Se.prototype = Object.create(E.prototype), Se.prototype.peekByte = function() {
          var He = this.hex.substring(this.pos, 2);
          return parseInt(He, 16);
        }, Se.prototype.readByte = function() {
          var He = this.hex.substring(this.pos, this.pos + 2);
          return this.pos += 2, parseInt(He, 16);
        }, Se.prototype.readChunk = function(He) {
          var Pe = this.hex.substring(this.pos, this.pos + He * 2);
          return this.pos += He * 2, typeof Buffer == "function" ? Buffer.from(Pe, "hex") : new c(Pe);
        };
        function ze(He) {
          this.$hex = "", this.finalFormat = He || "hex";
        }
        return ze.prototype = Object.create(B.prototype), ze.prototype.writeByte = function(He) {
          if (He < 0 || He > 255) throw new Error("Byte value out of range: " + He);
          var Pe = He.toString(16);
          Pe.length == 1 && (Pe = "0" + Pe), this.$hex += Pe;
        }, ze.prototype.canWriteBinary = function(He) {
          return He instanceof c || typeof Buffer == "function" && He instanceof Buffer;
        }, ze.prototype.writeBinary = function(He, Pe) {
          if (He instanceof c)
            Pe(He.length()), this.$hex += He.$hex;
          else if (typeof Buffer == "function" && He instanceof Buffer)
            Pe(He.length), this.$hex += He.toString("hex");
          else
            throw new TypeError("HexWriter only accepts BinaryHex or Buffers");
        }, ze.prototype.result = function() {
          return this.finalFormat === "buffer" && typeof Buffer == "function" ? Buffer.from(this.$hex, "hex") : new c(this.$hex).toString(this.finalFormat);
        }, ze.prototype.writeString = function(He, Pe) {
          var De = c.fromUtf8String(He);
          Pe(De.length()), this.$hex += De.$hex;
        }, ge.addReader(function(He, Pe) {
          if (He instanceof c || He.$hex)
            return new Se(He.$hex);
          if (Pe === "hex")
            return new Se(He);
        }), ge.addWriter(function(He) {
          if (He === "hex")
            return new ze();
        }), ge;
      }();
      return g.addSemanticEncode(0, function(c) {
        if (c instanceof Date)
          return c.toISOString();
      }).addSemanticDecode(0, function(c) {
        return new Date(c);
      }).addSemanticDecode(1, function(c) {
        return new Date(c);
      }), g;
    });
  }(main$5)), main$5.exports;
}
var hasRequiredCbor;
function requireCbor() {
  if (hasRequiredCbor) return cbor;
  hasRequiredCbor = 1, Object.defineProperty(cbor, "__esModule", { value: !0 }), cbor.cborDecode = cbor.cborEncode = void 0;
  const o = requireMain$4(), g = (y) => o.encode(y);
  cbor.cborEncode = g;
  const c = (y) => o.decode(Buffer.isBuffer(y) ? y : Buffer.from(y, "hex"));
  return cbor.cborDecode = c, cbor;
}
var hasRequiredUr$1;
function requireUr$1() {
  if (hasRequiredUr$1) return ur$1;
  hasRequiredUr$1 = 1, Object.defineProperty(ur$1, "__esModule", { value: !0 });
  const o = requireErrors$6(), g = requireUtils$f(), c = requireCbor();
  class y {
    constructor(d, E = "bytes") {
      if (this._cborPayload = d, this._type = E, !g.isURType(this._type))
        throw new o.InvalidTypeError();
    }
    static fromBuffer(d) {
      return new y(c.cborEncode(d));
    }
    static from(d, E) {
      return y.fromBuffer(Buffer.from(d, E));
    }
    decodeCBOR() {
      return c.cborDecode(this._cborPayload);
    }
    get type() {
      return this._type;
    }
    get cbor() {
      return this._cborPayload;
    }
    equals(d) {
      return this.type === d.type && this.cbor.equals(d.cbor);
    }
  }
  return ur$1.default = y, ur$1;
}
var urEncoder = {}, fountainEncoder = {}, assert$2 = { exports: {} }, errors$5 = {}, util$1 = {}, types$a = {}, isArguments$1, hasRequiredIsArguments$1;
function requireIsArguments$1() {
  if (hasRequiredIsArguments$1) return isArguments$1;
  hasRequiredIsArguments$1 = 1;
  var o = requireShams()(), g = /* @__PURE__ */ requireCallBound$1(), c = g("Object.prototype.toString"), y = function(B) {
    return o && B && typeof B == "object" && Symbol.toStringTag in B ? !1 : c(B) === "[object Arguments]";
  }, t = function(B) {
    return y(B) ? !0 : B !== null && typeof B == "object" && "length" in B && typeof B.length == "number" && B.length >= 0 && c(B) !== "[object Array]" && "callee" in B && c(B.callee) === "[object Function]";
  }, d = function() {
    return y(arguments);
  }();
  return y.isLegacyArguments = t, isArguments$1 = d ? y : t, isArguments$1;
}
var isRegex, hasRequiredIsRegex;
function requireIsRegex() {
  if (hasRequiredIsRegex) return isRegex;
  hasRequiredIsRegex = 1;
  var o = /* @__PURE__ */ requireCallBound$1(), g = requireShams()(), c = /* @__PURE__ */ requireHasown(), y = /* @__PURE__ */ requireGopd(), t;
  if (g) {
    var d = o("RegExp.prototype.exec"), E = {}, B = function() {
      throw E;
    }, D = {
      toString: B,
      valueOf: B
    };
    typeof Symbol.toPrimitive == "symbol" && (D[Symbol.toPrimitive] = B), t = function(M) {
      if (!M || typeof M != "object")
        return !1;
      var U = (
        /** @type {NonNullable<typeof gOPD>} */
        y(
          /** @type {{ lastIndex?: unknown }} */
          M,
          "lastIndex"
        )
      ), L = U && c(U, "value");
      if (!L)
        return !1;
      try {
        d(
          M,
          /** @type {string} */
          /** @type {unknown} */
          D
        );
      } catch (H) {
        return H === E;
      }
    };
  } else {
    var x = o("Object.prototype.toString"), v = "[object RegExp]";
    t = function(M) {
      return !M || typeof M != "object" && typeof M != "function" ? !1 : x(M) === v;
    };
  }
  return isRegex = t, isRegex;
}
var safeRegexTest, hasRequiredSafeRegexTest;
function requireSafeRegexTest() {
  if (hasRequiredSafeRegexTest) return safeRegexTest;
  hasRequiredSafeRegexTest = 1;
  var o = /* @__PURE__ */ requireCallBound$1(), g = requireIsRegex(), c = o("RegExp.prototype.exec"), y = /* @__PURE__ */ requireType();
  return safeRegexTest = function(d) {
    if (!g(d))
      throw new y("`regex` must be a RegExp");
    return function(B) {
      return c(d, B) !== null;
    };
  }, safeRegexTest;
}
var isGeneratorFunction, hasRequiredIsGeneratorFunction;
function requireIsGeneratorFunction() {
  if (hasRequiredIsGeneratorFunction) return isGeneratorFunction;
  hasRequiredIsGeneratorFunction = 1;
  var o = /* @__PURE__ */ requireCallBound$1(), g = /* @__PURE__ */ requireSafeRegexTest(), c = g(/^\s*(?:function)?\*/), y = requireShams()(), t = requireGetProto(), d = o("Object.prototype.toString"), E = o("Function.prototype.toString"), B = function() {
    if (!y)
      return !1;
    try {
      return Function("return function*() {}")();
    } catch {
    }
  }, D;
  return isGeneratorFunction = function(v) {
    if (typeof v != "function")
      return !1;
    if (c(E(v)))
      return !0;
    if (!y) {
      var F = d(v);
      return F === "[object GeneratorFunction]";
    }
    if (!t)
      return !1;
    if (typeof D > "u") {
      var M = B();
      D = M ? (
        /** @type {GeneratorFunctionConstructor} */
        t(M)
      ) : !1;
    }
    return t(v) === D;
  }, isGeneratorFunction;
}
var hasRequiredTypes$a;
function requireTypes$a() {
  return hasRequiredTypes$a || (hasRequiredTypes$a = 1, function(o) {
    var g = /* @__PURE__ */ requireIsArguments$1(), c = requireIsGeneratorFunction(), y = /* @__PURE__ */ requireWhichTypedArray(), t = /* @__PURE__ */ requireIsTypedArray();
    function d(Wr) {
      return Wr.call.bind(Wr);
    }
    var E = typeof BigInt < "u", B = typeof Symbol < "u", D = d(Object.prototype.toString), x = d(Number.prototype.valueOf), v = d(String.prototype.valueOf), F = d(Boolean.prototype.valueOf);
    if (E)
      var M = d(BigInt.prototype.valueOf);
    if (B)
      var U = d(Symbol.prototype.valueOf);
    function L(Wr, fi) {
      if (typeof Wr != "object")
        return !1;
      try {
        return fi(Wr), !0;
      } catch {
        return !1;
      }
    }
    o.isArgumentsObject = g, o.isGeneratorFunction = c, o.isTypedArray = t;
    function H(Wr) {
      return typeof Promise < "u" && Wr instanceof Promise || Wr !== null && typeof Wr == "object" && typeof Wr.then == "function" && typeof Wr.catch == "function";
    }
    o.isPromise = H;
    function fe(Wr) {
      return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? ArrayBuffer.isView(Wr) : t(Wr) || yr(Wr);
    }
    o.isArrayBufferView = fe;
    function ge(Wr) {
      return y(Wr) === "Uint8Array";
    }
    o.isUint8Array = ge;
    function Ie(Wr) {
      return y(Wr) === "Uint8ClampedArray";
    }
    o.isUint8ClampedArray = Ie;
    function Ee(Wr) {
      return y(Wr) === "Uint16Array";
    }
    o.isUint16Array = Ee;
    function Se(Wr) {
      return y(Wr) === "Uint32Array";
    }
    o.isUint32Array = Se;
    function ze(Wr) {
      return y(Wr) === "Int8Array";
    }
    o.isInt8Array = ze;
    function He(Wr) {
      return y(Wr) === "Int16Array";
    }
    o.isInt16Array = He;
    function Pe(Wr) {
      return y(Wr) === "Int32Array";
    }
    o.isInt32Array = Pe;
    function De(Wr) {
      return y(Wr) === "Float32Array";
    }
    o.isFloat32Array = De;
    function ve(Wr) {
      return y(Wr) === "Float64Array";
    }
    o.isFloat64Array = ve;
    function Fe(Wr) {
      return y(Wr) === "BigInt64Array";
    }
    o.isBigInt64Array = Fe;
    function be(Wr) {
      return y(Wr) === "BigUint64Array";
    }
    o.isBigUint64Array = be;
    function Be(Wr) {
      return D(Wr) === "[object Map]";
    }
    Be.working = typeof Map < "u" && Be(/* @__PURE__ */ new Map());
    function ke(Wr) {
      return typeof Map > "u" ? !1 : Be.working ? Be(Wr) : Wr instanceof Map;
    }
    o.isMap = ke;
    function xe(Wr) {
      return D(Wr) === "[object Set]";
    }
    xe.working = typeof Set < "u" && xe(/* @__PURE__ */ new Set());
    function Ne(Wr) {
      return typeof Set > "u" ? !1 : xe.working ? xe(Wr) : Wr instanceof Set;
    }
    o.isSet = Ne;
    function Et(Wr) {
      return D(Wr) === "[object WeakMap]";
    }
    Et.working = typeof WeakMap < "u" && Et(/* @__PURE__ */ new WeakMap());
    function st(Wr) {
      return typeof WeakMap > "u" ? !1 : Et.working ? Et(Wr) : Wr instanceof WeakMap;
    }
    o.isWeakMap = st;
    function Dt(Wr) {
      return D(Wr) === "[object WeakSet]";
    }
    Dt.working = typeof WeakSet < "u" && Dt(/* @__PURE__ */ new WeakSet());
    function er(Wr) {
      return Dt(Wr);
    }
    o.isWeakSet = er;
    function xt(Wr) {
      return D(Wr) === "[object ArrayBuffer]";
    }
    xt.working = typeof ArrayBuffer < "u" && xt(new ArrayBuffer());
    function ir(Wr) {
      return typeof ArrayBuffer > "u" ? !1 : xt.working ? xt(Wr) : Wr instanceof ArrayBuffer;
    }
    o.isArrayBuffer = ir;
    function sr(Wr) {
      return D(Wr) === "[object DataView]";
    }
    sr.working = typeof ArrayBuffer < "u" && typeof DataView < "u" && sr(new DataView(new ArrayBuffer(1), 0, 1));
    function yr(Wr) {
      return typeof DataView > "u" ? !1 : sr.working ? sr(Wr) : Wr instanceof DataView;
    }
    o.isDataView = yr;
    var wr = typeof SharedArrayBuffer < "u" ? SharedArrayBuffer : void 0;
    function qr(Wr) {
      return D(Wr) === "[object SharedArrayBuffer]";
    }
    function Mr(Wr) {
      return typeof wr > "u" ? !1 : (typeof qr.working > "u" && (qr.working = qr(new wr())), qr.working ? qr(Wr) : Wr instanceof wr);
    }
    o.isSharedArrayBuffer = Mr;
    function Dr(Wr) {
      return D(Wr) === "[object AsyncFunction]";
    }
    o.isAsyncFunction = Dr;
    function Qr(Wr) {
      return D(Wr) === "[object Map Iterator]";
    }
    o.isMapIterator = Qr;
    function Xr(Wr) {
      return D(Wr) === "[object Set Iterator]";
    }
    o.isSetIterator = Xr;
    function Vr(Wr) {
      return D(Wr) === "[object Generator]";
    }
    o.isGeneratorObject = Vr;
    function Ur(Wr) {
      return D(Wr) === "[object WebAssembly.Module]";
    }
    o.isWebAssemblyCompiledModule = Ur;
    function Sr(Wr) {
      return L(Wr, x);
    }
    o.isNumberObject = Sr;
    function Gr(Wr) {
      return L(Wr, v);
    }
    o.isStringObject = Gr;
    function Fr(Wr) {
      return L(Wr, F);
    }
    o.isBooleanObject = Fr;
    function br(Wr) {
      return E && L(Wr, M);
    }
    o.isBigIntObject = br;
    function Ar(Wr) {
      return B && L(Wr, U);
    }
    o.isSymbolObject = Ar;
    function cr(Wr) {
      return Sr(Wr) || Gr(Wr) || Fr(Wr) || br(Wr) || Ar(Wr);
    }
    o.isBoxedPrimitive = cr;
    function hr(Wr) {
      return typeof Uint8Array < "u" && (ir(Wr) || Mr(Wr));
    }
    o.isAnyArrayBuffer = hr, ["isProxy", "isExternal", "isModuleNamespaceObject"].forEach(function(Wr) {
      Object.defineProperty(o, Wr, {
        enumerable: !1,
        value: function() {
          throw new Error(Wr + " is not supported in userland");
        }
      });
    });
  }(types$a)), types$a;
}
var isBufferBrowser, hasRequiredIsBufferBrowser;
function requireIsBufferBrowser() {
  return hasRequiredIsBufferBrowser || (hasRequiredIsBufferBrowser = 1, isBufferBrowser = function(g) {
    return g && typeof g == "object" && typeof g.copy == "function" && typeof g.fill == "function" && typeof g.readUInt8 == "function";
  }), isBufferBrowser;
}
var hasRequiredUtil$1;
function requireUtil$1() {
  return hasRequiredUtil$1 || (hasRequiredUtil$1 = 1, function(o) {
    var g = Object.getOwnPropertyDescriptors || function(yr) {
      for (var wr = Object.keys(yr), qr = {}, Mr = 0; Mr < wr.length; Mr++)
        qr[wr[Mr]] = Object.getOwnPropertyDescriptor(yr, wr[Mr]);
      return qr;
    }, c = /%[sdj%]/g;
    o.format = function(sr) {
      if (!ze(sr)) {
        for (var yr = [], wr = 0; wr < arguments.length; wr++)
          yr.push(E(arguments[wr]));
        return yr.join(" ");
      }
      for (var wr = 1, qr = arguments, Mr = qr.length, Dr = String(sr).replace(c, function(Xr) {
        if (Xr === "%%") return "%";
        if (wr >= Mr) return Xr;
        switch (Xr) {
          case "%s":
            return String(qr[wr++]);
          case "%d":
            return Number(qr[wr++]);
          case "%j":
            try {
              return JSON.stringify(qr[wr++]);
            } catch {
              return "[Circular]";
            }
          default:
            return Xr;
        }
      }), Qr = qr[wr]; wr < Mr; Qr = qr[++wr])
        Ie(Qr) || !ve(Qr) ? Dr += " " + Qr : Dr += " " + E(Qr);
      return Dr;
    }, o.deprecate = function(sr, yr) {
      if (typeof process$1 < "u" && process$1.noDeprecation === !0)
        return sr;
      if (typeof process$1 > "u")
        return function() {
          return o.deprecate(sr, yr).apply(this, arguments);
        };
      var wr = !1;
      function qr() {
        if (!wr) {
          if (process$1.throwDeprecation)
            throw new Error(yr);
          process$1.traceDeprecation ? console.trace(yr) : console.error(yr), wr = !0;
        }
        return sr.apply(this, arguments);
      }
      return qr;
    };
    var y = {}, t = /^$/;
    if (process$1.env.NODE_DEBUG) {
      var d = process$1.env.NODE_DEBUG;
      d = d.replace(/[|\\{}()[\]^$+?.]/g, "\\$&").replace(/\*/g, ".*").replace(/,/g, "$|^").toUpperCase(), t = new RegExp("^" + d + "$", "i");
    }
    o.debuglog = function(sr) {
      if (sr = sr.toUpperCase(), !y[sr])
        if (t.test(sr)) {
          var yr = process$1.pid;
          y[sr] = function() {
            var wr = o.format.apply(o, arguments);
            console.error("%s %d: %s", sr, yr, wr);
          };
        } else
          y[sr] = function() {
          };
      return y[sr];
    };
    function E(sr, yr) {
      var wr = {
        seen: [],
        stylize: D
      };
      return arguments.length >= 3 && (wr.depth = arguments[2]), arguments.length >= 4 && (wr.colors = arguments[3]), ge(yr) ? wr.showHidden = yr : yr && o._extend(wr, yr), Pe(wr.showHidden) && (wr.showHidden = !1), Pe(wr.depth) && (wr.depth = 2), Pe(wr.colors) && (wr.colors = !1), Pe(wr.customInspect) && (wr.customInspect = !0), wr.colors && (wr.stylize = B), v(wr, sr, wr.depth);
    }
    o.inspect = E, E.colors = {
      bold: [1, 22],
      italic: [3, 23],
      underline: [4, 24],
      inverse: [7, 27],
      white: [37, 39],
      grey: [90, 39],
      black: [30, 39],
      blue: [34, 39],
      cyan: [36, 39],
      green: [32, 39],
      magenta: [35, 39],
      red: [31, 39],
      yellow: [33, 39]
    }, E.styles = {
      special: "cyan",
      number: "yellow",
      boolean: "yellow",
      undefined: "grey",
      null: "bold",
      string: "green",
      date: "magenta",
      // "name": intentionally not styling
      regexp: "red"
    };
    function B(sr, yr) {
      var wr = E.styles[yr];
      return wr ? "\x1B[" + E.colors[wr][0] + "m" + sr + "\x1B[" + E.colors[wr][1] + "m" : sr;
    }
    function D(sr, yr) {
      return sr;
    }
    function x(sr) {
      var yr = {};
      return sr.forEach(function(wr, qr) {
        yr[wr] = !0;
      }), yr;
    }
    function v(sr, yr, wr) {
      if (sr.customInspect && yr && Be(yr.inspect) && // Filter out the util module, it's inspect function is special
      yr.inspect !== o.inspect && // Also filter out any prototype objects using the circular check.
      !(yr.constructor && yr.constructor.prototype === yr)) {
        var qr = yr.inspect(wr, sr);
        return ze(qr) || (qr = v(sr, qr, wr)), qr;
      }
      var Mr = F(sr, yr);
      if (Mr)
        return Mr;
      var Dr = Object.keys(yr), Qr = x(Dr);
      if (sr.showHidden && (Dr = Object.getOwnPropertyNames(yr)), be(yr) && (Dr.indexOf("message") >= 0 || Dr.indexOf("description") >= 0))
        return M(yr);
      if (Dr.length === 0) {
        if (Be(yr)) {
          var Xr = yr.name ? ": " + yr.name : "";
          return sr.stylize("[Function" + Xr + "]", "special");
        }
        if (De(yr))
          return sr.stylize(RegExp.prototype.toString.call(yr), "regexp");
        if (Fe(yr))
          return sr.stylize(Date.prototype.toString.call(yr), "date");
        if (be(yr))
          return M(yr);
      }
      var Vr = "", Ur = !1, Sr = ["{", "}"];
      if (fe(yr) && (Ur = !0, Sr = ["[", "]"]), Be(yr)) {
        var Gr = yr.name ? ": " + yr.name : "";
        Vr = " [Function" + Gr + "]";
      }
      if (De(yr) && (Vr = " " + RegExp.prototype.toString.call(yr)), Fe(yr) && (Vr = " " + Date.prototype.toUTCString.call(yr)), be(yr) && (Vr = " " + M(yr)), Dr.length === 0 && (!Ur || yr.length == 0))
        return Sr[0] + Vr + Sr[1];
      if (wr < 0)
        return De(yr) ? sr.stylize(RegExp.prototype.toString.call(yr), "regexp") : sr.stylize("[Object]", "special");
      sr.seen.push(yr);
      var Fr;
      return Ur ? Fr = U(sr, yr, wr, Qr, Dr) : Fr = Dr.map(function(br) {
        return L(sr, yr, wr, Qr, br, Ur);
      }), sr.seen.pop(), H(Fr, Vr, Sr);
    }
    function F(sr, yr) {
      if (Pe(yr))
        return sr.stylize("undefined", "undefined");
      if (ze(yr)) {
        var wr = "'" + JSON.stringify(yr).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
        return sr.stylize(wr, "string");
      }
      if (Se(yr))
        return sr.stylize("" + yr, "number");
      if (ge(yr))
        return sr.stylize("" + yr, "boolean");
      if (Ie(yr))
        return sr.stylize("null", "null");
    }
    function M(sr) {
      return "[" + Error.prototype.toString.call(sr) + "]";
    }
    function U(sr, yr, wr, qr, Mr) {
      for (var Dr = [], Qr = 0, Xr = yr.length; Qr < Xr; ++Qr)
        Dt(yr, String(Qr)) ? Dr.push(L(
          sr,
          yr,
          wr,
          qr,
          String(Qr),
          !0
        )) : Dr.push("");
      return Mr.forEach(function(Vr) {
        Vr.match(/^\d+$/) || Dr.push(L(
          sr,
          yr,
          wr,
          qr,
          Vr,
          !0
        ));
      }), Dr;
    }
    function L(sr, yr, wr, qr, Mr, Dr) {
      var Qr, Xr, Vr;
      if (Vr = Object.getOwnPropertyDescriptor(yr, Mr) || { value: yr[Mr] }, Vr.get ? Vr.set ? Xr = sr.stylize("[Getter/Setter]", "special") : Xr = sr.stylize("[Getter]", "special") : Vr.set && (Xr = sr.stylize("[Setter]", "special")), Dt(qr, Mr) || (Qr = "[" + Mr + "]"), Xr || (sr.seen.indexOf(Vr.value) < 0 ? (Ie(wr) ? Xr = v(sr, Vr.value, null) : Xr = v(sr, Vr.value, wr - 1), Xr.indexOf(`
`) > -1 && (Dr ? Xr = Xr.split(`
`).map(function(Ur) {
        return "  " + Ur;
      }).join(`
`).slice(2) : Xr = `
` + Xr.split(`
`).map(function(Ur) {
        return "   " + Ur;
      }).join(`
`))) : Xr = sr.stylize("[Circular]", "special")), Pe(Qr)) {
        if (Dr && Mr.match(/^\d+$/))
          return Xr;
        Qr = JSON.stringify("" + Mr), Qr.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/) ? (Qr = Qr.slice(1, -1), Qr = sr.stylize(Qr, "name")) : (Qr = Qr.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'"), Qr = sr.stylize(Qr, "string"));
      }
      return Qr + ": " + Xr;
    }
    function H(sr, yr, wr) {
      var qr = sr.reduce(function(Mr, Dr) {
        return Dr.indexOf(`
`) >= 0, Mr + Dr.replace(/\u001b\[\d\d?m/g, "").length + 1;
      }, 0);
      return qr > 60 ? wr[0] + (yr === "" ? "" : yr + `
 `) + " " + sr.join(`,
  `) + " " + wr[1] : wr[0] + yr + " " + sr.join(", ") + " " + wr[1];
    }
    o.types = requireTypes$a();
    function fe(sr) {
      return Array.isArray(sr);
    }
    o.isArray = fe;
    function ge(sr) {
      return typeof sr == "boolean";
    }
    o.isBoolean = ge;
    function Ie(sr) {
      return sr === null;
    }
    o.isNull = Ie;
    function Ee(sr) {
      return sr == null;
    }
    o.isNullOrUndefined = Ee;
    function Se(sr) {
      return typeof sr == "number";
    }
    o.isNumber = Se;
    function ze(sr) {
      return typeof sr == "string";
    }
    o.isString = ze;
    function He(sr) {
      return typeof sr == "symbol";
    }
    o.isSymbol = He;
    function Pe(sr) {
      return sr === void 0;
    }
    o.isUndefined = Pe;
    function De(sr) {
      return ve(sr) && xe(sr) === "[object RegExp]";
    }
    o.isRegExp = De, o.types.isRegExp = De;
    function ve(sr) {
      return typeof sr == "object" && sr !== null;
    }
    o.isObject = ve;
    function Fe(sr) {
      return ve(sr) && xe(sr) === "[object Date]";
    }
    o.isDate = Fe, o.types.isDate = Fe;
    function be(sr) {
      return ve(sr) && (xe(sr) === "[object Error]" || sr instanceof Error);
    }
    o.isError = be, o.types.isNativeError = be;
    function Be(sr) {
      return typeof sr == "function";
    }
    o.isFunction = Be;
    function ke(sr) {
      return sr === null || typeof sr == "boolean" || typeof sr == "number" || typeof sr == "string" || typeof sr == "symbol" || // ES6 symbol
      typeof sr > "u";
    }
    o.isPrimitive = ke, o.isBuffer = requireIsBufferBrowser();
    function xe(sr) {
      return Object.prototype.toString.call(sr);
    }
    function Ne(sr) {
      return sr < 10 ? "0" + sr.toString(10) : sr.toString(10);
    }
    var Et = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec"
    ];
    function st() {
      var sr = /* @__PURE__ */ new Date(), yr = [
        Ne(sr.getHours()),
        Ne(sr.getMinutes()),
        Ne(sr.getSeconds())
      ].join(":");
      return [sr.getDate(), Et[sr.getMonth()], yr].join(" ");
    }
    o.log = function() {
      console.log("%s - %s", st(), o.format.apply(o, arguments));
    }, o.inherits = requireInherits_browser(), o._extend = function(sr, yr) {
      if (!yr || !ve(yr)) return sr;
      for (var wr = Object.keys(yr), qr = wr.length; qr--; )
        sr[wr[qr]] = yr[wr[qr]];
      return sr;
    };
    function Dt(sr, yr) {
      return Object.prototype.hasOwnProperty.call(sr, yr);
    }
    var er = typeof Symbol < "u" ? Symbol("util.promisify.custom") : void 0;
    o.promisify = function(yr) {
      if (typeof yr != "function")
        throw new TypeError('The "original" argument must be of type Function');
      if (er && yr[er]) {
        var wr = yr[er];
        if (typeof wr != "function")
          throw new TypeError('The "util.promisify.custom" argument must be of type Function');
        return Object.defineProperty(wr, er, {
          value: wr,
          enumerable: !1,
          writable: !1,
          configurable: !0
        }), wr;
      }
      function wr() {
        for (var qr, Mr, Dr = new Promise(function(Vr, Ur) {
          qr = Vr, Mr = Ur;
        }), Qr = [], Xr = 0; Xr < arguments.length; Xr++)
          Qr.push(arguments[Xr]);
        Qr.push(function(Vr, Ur) {
          Vr ? Mr(Vr) : qr(Ur);
        });
        try {
          yr.apply(this, Qr);
        } catch (Vr) {
          Mr(Vr);
        }
        return Dr;
      }
      return Object.setPrototypeOf(wr, Object.getPrototypeOf(yr)), er && Object.defineProperty(wr, er, {
        value: wr,
        enumerable: !1,
        writable: !1,
        configurable: !0
      }), Object.defineProperties(
        wr,
        g(yr)
      );
    }, o.promisify.custom = er;
    function xt(sr, yr) {
      if (!sr) {
        var wr = new Error("Promise was rejected with a falsy value");
        wr.reason = sr, sr = wr;
      }
      return yr(sr);
    }
    function ir(sr) {
      if (typeof sr != "function")
        throw new TypeError('The "original" argument must be of type Function');
      function yr() {
        for (var wr = [], qr = 0; qr < arguments.length; qr++)
          wr.push(arguments[qr]);
        var Mr = wr.pop();
        if (typeof Mr != "function")
          throw new TypeError("The last argument must be of type Function");
        var Dr = this, Qr = function() {
          return Mr.apply(Dr, arguments);
        };
        sr.apply(this, wr).then(
          function(Xr) {
            process$1.nextTick(Qr.bind(null, null, Xr));
          },
          function(Xr) {
            process$1.nextTick(xt.bind(null, Xr, Qr));
          }
        );
      }
      return Object.setPrototypeOf(yr, Object.getPrototypeOf(sr)), Object.defineProperties(
        yr,
        g(sr)
      ), yr;
    }
    o.callbackify = ir;
  }(util$1)), util$1;
}
var hasRequiredErrors$5;
function requireErrors$5() {
  if (hasRequiredErrors$5) return errors$5;
  hasRequiredErrors$5 = 1;
  function o(Ie) {
    "@babel/helpers - typeof";
    return o = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(Ee) {
      return typeof Ee;
    } : function(Ee) {
      return Ee && typeof Symbol == "function" && Ee.constructor === Symbol && Ee !== Symbol.prototype ? "symbol" : typeof Ee;
    }, o(Ie);
  }
  function g(Ie, Ee, Se) {
    return Object.defineProperty(Ie, "prototype", { writable: !1 }), Ie;
  }
  function c(Ie, Ee) {
    if (!(Ie instanceof Ee))
      throw new TypeError("Cannot call a class as a function");
  }
  function y(Ie, Ee) {
    if (typeof Ee != "function" && Ee !== null)
      throw new TypeError("Super expression must either be null or a function");
    Ie.prototype = Object.create(Ee && Ee.prototype, { constructor: { value: Ie, writable: !0, configurable: !0 } }), Object.defineProperty(Ie, "prototype", { writable: !1 }), Ee && t(Ie, Ee);
  }
  function t(Ie, Ee) {
    return t = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(ze, He) {
      return ze.__proto__ = He, ze;
    }, t(Ie, Ee);
  }
  function d(Ie) {
    var Ee = D();
    return function() {
      var ze = x(Ie), He;
      if (Ee) {
        var Pe = x(this).constructor;
        He = Reflect.construct(ze, arguments, Pe);
      } else
        He = ze.apply(this, arguments);
      return E(this, He);
    };
  }
  function E(Ie, Ee) {
    if (Ee && (o(Ee) === "object" || typeof Ee == "function"))
      return Ee;
    if (Ee !== void 0)
      throw new TypeError("Derived constructors may only return object or undefined");
    return B(Ie);
  }
  function B(Ie) {
    if (Ie === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return Ie;
  }
  function D() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }
  function x(Ie) {
    return x = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(Se) {
      return Se.__proto__ || Object.getPrototypeOf(Se);
    }, x(Ie);
  }
  var v = {}, F, M;
  function U(Ie, Ee, Se) {
    Se || (Se = Error);
    function ze(Pe, De, ve) {
      return typeof Ee == "string" ? Ee : Ee(Pe, De, ve);
    }
    var He = /* @__PURE__ */ function(Pe) {
      y(ve, Pe);
      var De = d(ve);
      function ve(Fe, be, Be) {
        var ke;
        return c(this, ve), ke = De.call(this, ze(Fe, be, Be)), ke.code = Ie, ke;
      }
      return g(ve);
    }(Se);
    v[Ie] = He;
  }
  function L(Ie, Ee) {
    if (Array.isArray(Ie)) {
      var Se = Ie.length;
      return Ie = Ie.map(function(ze) {
        return String(ze);
      }), Se > 2 ? "one of ".concat(Ee, " ").concat(Ie.slice(0, Se - 1).join(", "), ", or ") + Ie[Se - 1] : Se === 2 ? "one of ".concat(Ee, " ").concat(Ie[0], " or ").concat(Ie[1]) : "of ".concat(Ee, " ").concat(Ie[0]);
    } else
      return "of ".concat(Ee, " ").concat(String(Ie));
  }
  function H(Ie, Ee, Se) {
    return Ie.substr(0, Ee.length) === Ee;
  }
  function fe(Ie, Ee, Se) {
    return (Se === void 0 || Se > Ie.length) && (Se = Ie.length), Ie.substring(Se - Ee.length, Se) === Ee;
  }
  function ge(Ie, Ee, Se) {
    return typeof Se != "number" && (Se = 0), Se + Ee.length > Ie.length ? !1 : Ie.indexOf(Ee, Se) !== -1;
  }
  return U("ERR_AMBIGUOUS_ARGUMENT", 'The "%s" argument is ambiguous. %s', TypeError), U("ERR_INVALID_ARG_TYPE", function(Ie, Ee, Se) {
    F === void 0 && (F = requireAssert$2()), F(typeof Ie == "string", "'name' must be a string");
    var ze;
    typeof Ee == "string" && H(Ee, "not ") ? (ze = "must not be", Ee = Ee.replace(/^not /, "")) : ze = "must be";
    var He;
    if (fe(Ie, " argument"))
      He = "The ".concat(Ie, " ").concat(ze, " ").concat(L(Ee, "type"));
    else {
      var Pe = ge(Ie, ".") ? "property" : "argument";
      He = 'The "'.concat(Ie, '" ').concat(Pe, " ").concat(ze, " ").concat(L(Ee, "type"));
    }
    return He += ". Received type ".concat(o(Se)), He;
  }, TypeError), U("ERR_INVALID_ARG_VALUE", function(Ie, Ee) {
    var Se = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "is invalid";
    M === void 0 && (M = requireUtil$1());
    var ze = M.inspect(Ee);
    return ze.length > 128 && (ze = "".concat(ze.slice(0, 128), "...")), "The argument '".concat(Ie, "' ").concat(Se, ". Received ").concat(ze);
  }, TypeError), U("ERR_INVALID_RETURN_VALUE", function(Ie, Ee, Se) {
    var ze;
    return Se && Se.constructor && Se.constructor.name ? ze = "instance of ".concat(Se.constructor.name) : ze = "type ".concat(o(Se)), "Expected ".concat(Ie, ' to be returned from the "').concat(Ee, '"') + " function but got ".concat(ze, ".");
  }, TypeError), U("ERR_MISSING_ARGS", function() {
    for (var Ie = arguments.length, Ee = new Array(Ie), Se = 0; Se < Ie; Se++)
      Ee[Se] = arguments[Se];
    F === void 0 && (F = requireAssert$2()), F(Ee.length > 0, "At least one arg needs to be specified");
    var ze = "The ", He = Ee.length;
    switch (Ee = Ee.map(function(Pe) {
      return '"'.concat(Pe, '"');
    }), He) {
      case 1:
        ze += "".concat(Ee[0], " argument");
        break;
      case 2:
        ze += "".concat(Ee[0], " and ").concat(Ee[1], " arguments");
        break;
      default:
        ze += Ee.slice(0, He - 1).join(", "), ze += ", and ".concat(Ee[He - 1], " arguments");
        break;
    }
    return "".concat(ze, " must be specified");
  }, TypeError), errors$5.codes = v, errors$5;
}
var assertion_error, hasRequiredAssertion_error;
function requireAssertion_error() {
  if (hasRequiredAssertion_error) return assertion_error;
  hasRequiredAssertion_error = 1;
  function o(er, xt) {
    var ir = Object.keys(er);
    if (Object.getOwnPropertySymbols) {
      var sr = Object.getOwnPropertySymbols(er);
      xt && (sr = sr.filter(function(yr) {
        return Object.getOwnPropertyDescriptor(er, yr).enumerable;
      })), ir.push.apply(ir, sr);
    }
    return ir;
  }
  function g(er) {
    for (var xt = 1; xt < arguments.length; xt++) {
      var ir = arguments[xt] != null ? arguments[xt] : {};
      xt % 2 ? o(Object(ir), !0).forEach(function(sr) {
        c(er, sr, ir[sr]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(er, Object.getOwnPropertyDescriptors(ir)) : o(Object(ir)).forEach(function(sr) {
        Object.defineProperty(er, sr, Object.getOwnPropertyDescriptor(ir, sr));
      });
    }
    return er;
  }
  function c(er, xt, ir) {
    return xt = E(xt), xt in er ? Object.defineProperty(er, xt, { value: ir, enumerable: !0, configurable: !0, writable: !0 }) : er[xt] = ir, er;
  }
  function y(er, xt) {
    if (!(er instanceof xt))
      throw new TypeError("Cannot call a class as a function");
  }
  function t(er, xt) {
    for (var ir = 0; ir < xt.length; ir++) {
      var sr = xt[ir];
      sr.enumerable = sr.enumerable || !1, sr.configurable = !0, "value" in sr && (sr.writable = !0), Object.defineProperty(er, E(sr.key), sr);
    }
  }
  function d(er, xt, ir) {
    return xt && t(er.prototype, xt), Object.defineProperty(er, "prototype", { writable: !1 }), er;
  }
  function E(er) {
    var xt = B(er, "string");
    return Ie(xt) === "symbol" ? xt : String(xt);
  }
  function B(er, xt) {
    if (Ie(er) !== "object" || er === null) return er;
    var ir = er[Symbol.toPrimitive];
    if (ir !== void 0) {
      var sr = ir.call(er, xt);
      if (Ie(sr) !== "object") return sr;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return String(er);
  }
  function D(er, xt) {
    if (typeof xt != "function" && xt !== null)
      throw new TypeError("Super expression must either be null or a function");
    er.prototype = Object.create(xt && xt.prototype, { constructor: { value: er, writable: !0, configurable: !0 } }), Object.defineProperty(er, "prototype", { writable: !1 }), xt && fe(er, xt);
  }
  function x(er) {
    var xt = L();
    return function() {
      var sr = ge(er), yr;
      if (xt) {
        var wr = ge(this).constructor;
        yr = Reflect.construct(sr, arguments, wr);
      } else
        yr = sr.apply(this, arguments);
      return v(this, yr);
    };
  }
  function v(er, xt) {
    if (xt && (Ie(xt) === "object" || typeof xt == "function"))
      return xt;
    if (xt !== void 0)
      throw new TypeError("Derived constructors may only return object or undefined");
    return F(er);
  }
  function F(er) {
    if (er === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return er;
  }
  function M(er) {
    var xt = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
    return M = function(sr) {
      if (sr === null || !H(sr)) return sr;
      if (typeof sr != "function")
        throw new TypeError("Super expression must either be null or a function");
      if (typeof xt < "u") {
        if (xt.has(sr)) return xt.get(sr);
        xt.set(sr, yr);
      }
      function yr() {
        return U(sr, arguments, ge(this).constructor);
      }
      return yr.prototype = Object.create(sr.prototype, { constructor: { value: yr, enumerable: !1, writable: !0, configurable: !0 } }), fe(yr, sr);
    }, M(er);
  }
  function U(er, xt, ir) {
    return L() ? U = Reflect.construct.bind() : U = function(yr, wr, qr) {
      var Mr = [null];
      Mr.push.apply(Mr, wr);
      var Dr = Function.bind.apply(yr, Mr), Qr = new Dr();
      return qr && fe(Qr, qr.prototype), Qr;
    }, U.apply(null, arguments);
  }
  function L() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }
  function H(er) {
    return Function.toString.call(er).indexOf("[native code]") !== -1;
  }
  function fe(er, xt) {
    return fe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(sr, yr) {
      return sr.__proto__ = yr, sr;
    }, fe(er, xt);
  }
  function ge(er) {
    return ge = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(ir) {
      return ir.__proto__ || Object.getPrototypeOf(ir);
    }, ge(er);
  }
  function Ie(er) {
    "@babel/helpers - typeof";
    return Ie = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(xt) {
      return typeof xt;
    } : function(xt) {
      return xt && typeof Symbol == "function" && xt.constructor === Symbol && xt !== Symbol.prototype ? "symbol" : typeof xt;
    }, Ie(er);
  }
  var Ee = requireUtil$1(), Se = Ee.inspect, ze = requireErrors$5(), He = ze.codes.ERR_INVALID_ARG_TYPE;
  function Pe(er, xt, ir) {
    return (ir === void 0 || ir > er.length) && (ir = er.length), er.substring(ir - xt.length, ir) === xt;
  }
  function De(er, xt) {
    if (xt = Math.floor(xt), er.length == 0 || xt == 0) return "";
    var ir = er.length * xt;
    for (xt = Math.floor(Math.log(xt) / Math.log(2)); xt; )
      er += er, xt--;
    return er += er.substring(0, ir - er.length), er;
  }
  var ve = "", Fe = "", be = "", Be = "", ke = {
    deepStrictEqual: "Expected values to be strictly deep-equal:",
    strictEqual: "Expected values to be strictly equal:",
    strictEqualObject: 'Expected "actual" to be reference-equal to "expected":',
    deepEqual: "Expected values to be loosely deep-equal:",
    equal: "Expected values to be loosely equal:",
    notDeepStrictEqual: 'Expected "actual" not to be strictly deep-equal to:',
    notStrictEqual: 'Expected "actual" to be strictly unequal to:',
    notStrictEqualObject: 'Expected "actual" not to be reference-equal to "expected":',
    notDeepEqual: 'Expected "actual" not to be loosely deep-equal to:',
    notEqual: 'Expected "actual" to be loosely unequal to:',
    notIdentical: "Values identical but not reference-equal:"
  }, xe = 10;
  function Ne(er) {
    var xt = Object.keys(er), ir = Object.create(Object.getPrototypeOf(er));
    return xt.forEach(function(sr) {
      ir[sr] = er[sr];
    }), Object.defineProperty(ir, "message", {
      value: er.message
    }), ir;
  }
  function Et(er) {
    return Se(er, {
      compact: !1,
      customInspect: !1,
      depth: 1e3,
      maxArrayLength: 1 / 0,
      // Assert compares only enumerable properties (with a few exceptions).
      showHidden: !1,
      // Having a long line as error is better than wrapping the line for
      // comparison for now.
      // TODO(BridgeAR): `breakLength` should be limited as soon as soon as we
      // have meta information about the inspected properties (i.e., know where
      // in what line the property starts and ends).
      breakLength: 1 / 0,
      // Assert does not detect proxies currently.
      showProxy: !1,
      sorted: !0,
      // Inspect getters as we also check them when comparing entries.
      getters: !0
    });
  }
  function st(er, xt, ir) {
    var sr = "", yr = "", wr = 0, qr = "", Mr = !1, Dr = Et(er), Qr = Dr.split(`
`), Xr = Et(xt).split(`
`), Vr = 0, Ur = "";
    if (ir === "strictEqual" && Ie(er) === "object" && Ie(xt) === "object" && er !== null && xt !== null && (ir = "strictEqualObject"), Qr.length === 1 && Xr.length === 1 && Qr[0] !== Xr[0]) {
      var Sr = Qr[0].length + Xr[0].length;
      if (Sr <= xe) {
        if ((Ie(er) !== "object" || er === null) && (Ie(xt) !== "object" || xt === null) && (er !== 0 || xt !== 0))
          return "".concat(ke[ir], `

`) + "".concat(Qr[0], " !== ").concat(Xr[0], `
`);
      } else if (ir !== "strictEqualObject") {
        var Gr = process$1.stderr && process$1.stderr.isTTY ? process$1.stderr.columns : 80;
        if (Sr < Gr) {
          for (; Qr[0][Vr] === Xr[0][Vr]; )
            Vr++;
          Vr > 2 && (Ur = `
  `.concat(De(" ", Vr), "^"), Vr = 0);
        }
      }
    }
    for (var Fr = Qr[Qr.length - 1], br = Xr[Xr.length - 1]; Fr === br && (Vr++ < 2 ? qr = `
  `.concat(Fr).concat(qr) : sr = Fr, Qr.pop(), Xr.pop(), !(Qr.length === 0 || Xr.length === 0)); )
      Fr = Qr[Qr.length - 1], br = Xr[Xr.length - 1];
    var Ar = Math.max(Qr.length, Xr.length);
    if (Ar === 0) {
      var cr = Dr.split(`
`);
      if (cr.length > 30)
        for (cr[26] = "".concat(ve, "...").concat(Be); cr.length > 27; )
          cr.pop();
      return "".concat(ke.notIdentical, `

`).concat(cr.join(`
`), `
`);
    }
    Vr > 3 && (qr = `
`.concat(ve, "...").concat(Be).concat(qr), Mr = !0), sr !== "" && (qr = `
  `.concat(sr).concat(qr), sr = "");
    var hr = 0, Wr = ke[ir] + `
`.concat(Fe, "+ actual").concat(Be, " ").concat(be, "- expected").concat(Be), fi = " ".concat(ve, "...").concat(Be, " Lines skipped");
    for (Vr = 0; Vr < Ar; Vr++) {
      var Bi = Vr - wr;
      if (Qr.length < Vr + 1)
        Bi > 1 && Vr > 2 && (Bi > 4 ? (yr += `
`.concat(ve, "...").concat(Be), Mr = !0) : Bi > 3 && (yr += `
  `.concat(Xr[Vr - 2]), hr++), yr += `
  `.concat(Xr[Vr - 1]), hr++), wr = Vr, sr += `
`.concat(be, "-").concat(Be, " ").concat(Xr[Vr]), hr++;
      else if (Xr.length < Vr + 1)
        Bi > 1 && Vr > 2 && (Bi > 4 ? (yr += `
`.concat(ve, "...").concat(Be), Mr = !0) : Bi > 3 && (yr += `
  `.concat(Qr[Vr - 2]), hr++), yr += `
  `.concat(Qr[Vr - 1]), hr++), wr = Vr, yr += `
`.concat(Fe, "+").concat(Be, " ").concat(Qr[Vr]), hr++;
      else {
        var $r = Xr[Vr], oi = Qr[Vr], zr = oi !== $r && (!Pe(oi, ",") || oi.slice(0, -1) !== $r);
        zr && Pe($r, ",") && $r.slice(0, -1) === oi && (zr = !1, oi += ","), zr ? (Bi > 1 && Vr > 2 && (Bi > 4 ? (yr += `
`.concat(ve, "...").concat(Be), Mr = !0) : Bi > 3 && (yr += `
  `.concat(Qr[Vr - 2]), hr++), yr += `
  `.concat(Qr[Vr - 1]), hr++), wr = Vr, yr += `
`.concat(Fe, "+").concat(Be, " ").concat(oi), sr += `
`.concat(be, "-").concat(Be, " ").concat($r), hr += 2) : (yr += sr, sr = "", (Bi === 1 || Vr === 0) && (yr += `
  `.concat(oi), hr++));
      }
      if (hr > 20 && Vr < Ar - 2)
        return "".concat(Wr).concat(fi, `
`).concat(yr, `
`).concat(ve, "...").concat(Be).concat(sr, `
`) + "".concat(ve, "...").concat(Be);
    }
    return "".concat(Wr).concat(Mr ? fi : "", `
`).concat(yr).concat(sr).concat(qr).concat(Ur);
  }
  var Dt = /* @__PURE__ */ function(er, xt) {
    D(sr, er);
    var ir = x(sr);
    function sr(yr) {
      var wr;
      if (y(this, sr), Ie(yr) !== "object" || yr === null)
        throw new He("options", "Object", yr);
      var qr = yr.message, Mr = yr.operator, Dr = yr.stackStartFn, Qr = yr.actual, Xr = yr.expected, Vr = Error.stackTraceLimit;
      if (Error.stackTraceLimit = 0, qr != null)
        wr = ir.call(this, String(qr));
      else if (process$1.stderr && process$1.stderr.isTTY && (process$1.stderr && process$1.stderr.getColorDepth && process$1.stderr.getColorDepth() !== 1 ? (ve = "\x1B[34m", Fe = "\x1B[32m", Be = "\x1B[39m", be = "\x1B[31m") : (ve = "", Fe = "", Be = "", be = "")), Ie(Qr) === "object" && Qr !== null && Ie(Xr) === "object" && Xr !== null && "stack" in Qr && Qr instanceof Error && "stack" in Xr && Xr instanceof Error && (Qr = Ne(Qr), Xr = Ne(Xr)), Mr === "deepStrictEqual" || Mr === "strictEqual")
        wr = ir.call(this, st(Qr, Xr, Mr));
      else if (Mr === "notDeepStrictEqual" || Mr === "notStrictEqual") {
        var Ur = ke[Mr], Sr = Et(Qr).split(`
`);
        if (Mr === "notStrictEqual" && Ie(Qr) === "object" && Qr !== null && (Ur = ke.notStrictEqualObject), Sr.length > 30)
          for (Sr[26] = "".concat(ve, "...").concat(Be); Sr.length > 27; )
            Sr.pop();
        Sr.length === 1 ? wr = ir.call(this, "".concat(Ur, " ").concat(Sr[0])) : wr = ir.call(this, "".concat(Ur, `

`).concat(Sr.join(`
`), `
`));
      } else {
        var Gr = Et(Qr), Fr = "", br = ke[Mr];
        Mr === "notDeepEqual" || Mr === "notEqual" ? (Gr = "".concat(ke[Mr], `

`).concat(Gr), Gr.length > 1024 && (Gr = "".concat(Gr.slice(0, 1021), "..."))) : (Fr = "".concat(Et(Xr)), Gr.length > 512 && (Gr = "".concat(Gr.slice(0, 509), "...")), Fr.length > 512 && (Fr = "".concat(Fr.slice(0, 509), "...")), Mr === "deepEqual" || Mr === "equal" ? Gr = "".concat(br, `

`).concat(Gr, `

should equal

`) : Fr = " ".concat(Mr, " ").concat(Fr)), wr = ir.call(this, "".concat(Gr).concat(Fr));
      }
      return Error.stackTraceLimit = Vr, wr.generatedMessage = !qr, Object.defineProperty(F(wr), "name", {
        value: "AssertionError [ERR_ASSERTION]",
        enumerable: !1,
        writable: !0,
        configurable: !0
      }), wr.code = "ERR_ASSERTION", wr.actual = Qr, wr.expected = Xr, wr.operator = Mr, Error.captureStackTrace && Error.captureStackTrace(F(wr), Dr), wr.stack, wr.name = "AssertionError", v(wr);
    }
    return d(sr, [{
      key: "toString",
      value: function() {
        return "".concat(this.name, " [").concat(this.code, "]: ").concat(this.message);
      }
    }, {
      key: xt,
      value: function(wr, qr) {
        return Se(this, g(g({}, qr), {}, {
          customInspect: !1,
          depth: 0
        }));
      }
    }]), sr;
  }(/* @__PURE__ */ M(Error), Se.custom);
  return assertion_error = Dt, assertion_error;
}
var isArguments, hasRequiredIsArguments;
function requireIsArguments() {
  if (hasRequiredIsArguments) return isArguments;
  hasRequiredIsArguments = 1;
  var o = Object.prototype.toString;
  return isArguments = function(c) {
    var y = o.call(c), t = y === "[object Arguments]";
    return t || (t = y !== "[object Array]" && c !== null && typeof c == "object" && typeof c.length == "number" && c.length >= 0 && o.call(c.callee) === "[object Function]"), t;
  }, isArguments;
}
var implementation$3, hasRequiredImplementation$3;
function requireImplementation$3() {
  if (hasRequiredImplementation$3) return implementation$3;
  hasRequiredImplementation$3 = 1;
  var o;
  if (!Object.keys) {
    var g = Object.prototype.hasOwnProperty, c = Object.prototype.toString, y = requireIsArguments(), t = Object.prototype.propertyIsEnumerable, d = !t.call({ toString: null }, "toString"), E = t.call(function() {
    }, "prototype"), B = [
      "toString",
      "toLocaleString",
      "valueOf",
      "hasOwnProperty",
      "isPrototypeOf",
      "propertyIsEnumerable",
      "constructor"
    ], D = function(M) {
      var U = M.constructor;
      return U && U.prototype === M;
    }, x = {
      $applicationCache: !0,
      $console: !0,
      $external: !0,
      $frame: !0,
      $frameElement: !0,
      $frames: !0,
      $innerHeight: !0,
      $innerWidth: !0,
      $onmozfullscreenchange: !0,
      $onmozfullscreenerror: !0,
      $outerHeight: !0,
      $outerWidth: !0,
      $pageXOffset: !0,
      $pageYOffset: !0,
      $parent: !0,
      $scrollLeft: !0,
      $scrollTop: !0,
      $scrollX: !0,
      $scrollY: !0,
      $self: !0,
      $webkitIndexedDB: !0,
      $webkitStorageInfo: !0,
      $window: !0
    }, v = function() {
      if (typeof window > "u")
        return !1;
      for (var M in window)
        try {
          if (!x["$" + M] && g.call(window, M) && window[M] !== null && typeof window[M] == "object")
            try {
              D(window[M]);
            } catch {
              return !0;
            }
        } catch {
          return !0;
        }
      return !1;
    }(), F = function(M) {
      if (typeof window > "u" || !v)
        return D(M);
      try {
        return D(M);
      } catch {
        return !1;
      }
    };
    o = function(U) {
      var L = U !== null && typeof U == "object", H = c.call(U) === "[object Function]", fe = y(U), ge = L && c.call(U) === "[object String]", Ie = [];
      if (!L && !H && !fe)
        throw new TypeError("Object.keys called on a non-object");
      var Ee = E && H;
      if (ge && U.length > 0 && !g.call(U, 0))
        for (var Se = 0; Se < U.length; ++Se)
          Ie.push(String(Se));
      if (fe && U.length > 0)
        for (var ze = 0; ze < U.length; ++ze)
          Ie.push(String(ze));
      else
        for (var He in U)
          !(Ee && He === "prototype") && g.call(U, He) && Ie.push(String(He));
      if (d)
        for (var Pe = F(U), De = 0; De < B.length; ++De)
          !(Pe && B[De] === "constructor") && g.call(U, B[De]) && Ie.push(B[De]);
      return Ie;
    };
  }
  return implementation$3 = o, implementation$3;
}
var objectKeys, hasRequiredObjectKeys;
function requireObjectKeys() {
  if (hasRequiredObjectKeys) return objectKeys;
  hasRequiredObjectKeys = 1;
  var o = Array.prototype.slice, g = requireIsArguments(), c = Object.keys, y = c ? function(E) {
    return c(E);
  } : requireImplementation$3(), t = Object.keys;
  return y.shim = function() {
    if (Object.keys) {
      var E = function() {
        var B = Object.keys(arguments);
        return B && B.length === arguments.length;
      }(1, 2);
      E || (Object.keys = function(D) {
        return g(D) ? t(o.call(D)) : t(D);
      });
    } else
      Object.keys = y;
    return Object.keys || y;
  }, objectKeys = y, objectKeys;
}
var implementation$2, hasRequiredImplementation$2;
function requireImplementation$2() {
  if (hasRequiredImplementation$2) return implementation$2;
  hasRequiredImplementation$2 = 1;
  var o = requireObjectKeys(), g = requireShams$1()(), c = /* @__PURE__ */ requireCallBound$1(), y = /* @__PURE__ */ requireEsObjectAtoms(), t = c("Array.prototype.push"), d = c("Object.prototype.propertyIsEnumerable"), E = g ? y.getOwnPropertySymbols : null;
  return implementation$2 = function(D, x) {
    if (D == null)
      throw new TypeError("target must be an object");
    var v = y(D);
    if (arguments.length === 1)
      return v;
    for (var F = 1; F < arguments.length; ++F) {
      var M = y(arguments[F]), U = o(M), L = g && (y.getOwnPropertySymbols || E);
      if (L)
        for (var H = L(M), fe = 0; fe < H.length; ++fe) {
          var ge = H[fe];
          d(M, ge) && t(U, ge);
        }
      for (var Ie = 0; Ie < U.length; ++Ie) {
        var Ee = U[Ie];
        if (d(M, Ee)) {
          var Se = M[Ee];
          v[Ee] = Se;
        }
      }
    }
    return v;
  }, implementation$2;
}
var polyfill$2, hasRequiredPolyfill$2;
function requirePolyfill$2() {
  if (hasRequiredPolyfill$2) return polyfill$2;
  hasRequiredPolyfill$2 = 1;
  var o = requireImplementation$2(), g = function() {
    if (!Object.assign)
      return !1;
    for (var y = "abcdefghijklmnopqrst", t = y.split(""), d = {}, E = 0; E < t.length; ++E)
      d[t[E]] = t[E];
    var B = Object.assign({}, d), D = "";
    for (var x in B)
      D += x;
    return y !== D;
  }, c = function() {
    if (!Object.assign || !Object.preventExtensions)
      return !1;
    var y = Object.preventExtensions({ 1: 2 });
    try {
      Object.assign(y, "xy");
    } catch {
      return y[1] === "y";
    }
    return !1;
  };
  return polyfill$2 = function() {
    return !Object.assign || g() || c() ? o : Object.assign;
  }, polyfill$2;
}
var implementation$1, hasRequiredImplementation$1;
function requireImplementation$1() {
  if (hasRequiredImplementation$1) return implementation$1;
  hasRequiredImplementation$1 = 1;
  var o = function(g) {
    return g !== g;
  };
  return implementation$1 = function(c, y) {
    return c === 0 && y === 0 ? 1 / c === 1 / y : !!(c === y || o(c) && o(y));
  }, implementation$1;
}
var polyfill$1, hasRequiredPolyfill$1;
function requirePolyfill$1() {
  if (hasRequiredPolyfill$1) return polyfill$1;
  hasRequiredPolyfill$1 = 1;
  var o = requireImplementation$1();
  return polyfill$1 = function() {
    return typeof Object.is == "function" ? Object.is : o;
  }, polyfill$1;
}
var callBound, hasRequiredCallBound;
function requireCallBound() {
  if (hasRequiredCallBound) return callBound;
  hasRequiredCallBound = 1;
  var o = /* @__PURE__ */ requireGetIntrinsic(), g = requireCallBind(), c = g(o("String.prototype.indexOf"));
  return callBound = function(t, d) {
    var E = o(t, !!d);
    return typeof E == "function" && c(t, ".prototype.") > -1 ? g(E) : E;
  }, callBound;
}
var defineProperties_1, hasRequiredDefineProperties;
function requireDefineProperties() {
  if (hasRequiredDefineProperties) return defineProperties_1;
  hasRequiredDefineProperties = 1;
  var o = requireObjectKeys(), g = typeof Symbol == "function" && typeof Symbol("foo") == "symbol", c = Object.prototype.toString, y = Array.prototype.concat, t = /* @__PURE__ */ requireDefineDataProperty(), d = function(x) {
    return typeof x == "function" && c.call(x) === "[object Function]";
  }, E = /* @__PURE__ */ requireHasPropertyDescriptors()(), B = function(x, v, F, M) {
    if (v in x) {
      if (M === !0) {
        if (x[v] === F)
          return;
      } else if (!d(M) || !M())
        return;
    }
    E ? t(x, v, F, !0) : t(x, v, F);
  }, D = function(x, v) {
    var F = arguments.length > 2 ? arguments[2] : {}, M = o(v);
    g && (M = y.call(M, Object.getOwnPropertySymbols(v)));
    for (var U = 0; U < M.length; U += 1)
      B(x, M[U], v[M[U]], F[M[U]]);
  };
  return D.supportsDescriptors = !!E, defineProperties_1 = D, defineProperties_1;
}
var shim$1, hasRequiredShim$1;
function requireShim$1() {
  if (hasRequiredShim$1) return shim$1;
  hasRequiredShim$1 = 1;
  var o = requirePolyfill$1(), g = requireDefineProperties();
  return shim$1 = function() {
    var y = o();
    return g(Object, { is: y }, {
      is: function() {
        return Object.is !== y;
      }
    }), y;
  }, shim$1;
}
var objectIs, hasRequiredObjectIs;
function requireObjectIs() {
  if (hasRequiredObjectIs) return objectIs;
  hasRequiredObjectIs = 1;
  var o = requireDefineProperties(), g = requireCallBind(), c = requireImplementation$1(), y = requirePolyfill$1(), t = requireShim$1(), d = g(y(), Object);
  return o(d, {
    getPolyfill: y,
    implementation: c,
    shim: t
  }), objectIs = d, objectIs;
}
var implementation, hasRequiredImplementation;
function requireImplementation() {
  return hasRequiredImplementation || (hasRequiredImplementation = 1, implementation = function(g) {
    return g !== g;
  }), implementation;
}
var polyfill, hasRequiredPolyfill;
function requirePolyfill() {
  if (hasRequiredPolyfill) return polyfill;
  hasRequiredPolyfill = 1;
  var o = requireImplementation();
  return polyfill = function() {
    return Number.isNaN && Number.isNaN(NaN) && !Number.isNaN("a") ? Number.isNaN : o;
  }, polyfill;
}
var shim, hasRequiredShim;
function requireShim() {
  if (hasRequiredShim) return shim;
  hasRequiredShim = 1;
  var o = requireDefineProperties(), g = requirePolyfill();
  return shim = function() {
    var y = g();
    return o(Number, { isNaN: y }, {
      isNaN: function() {
        return Number.isNaN !== y;
      }
    }), y;
  }, shim;
}
var isNan, hasRequiredIsNan;
function requireIsNan() {
  if (hasRequiredIsNan) return isNan;
  hasRequiredIsNan = 1;
  var o = requireCallBind(), g = requireDefineProperties(), c = requireImplementation(), y = requirePolyfill(), t = requireShim(), d = o(y(), Number);
  return g(d, {
    getPolyfill: y,
    implementation: c,
    shim: t
  }), isNan = d, isNan;
}
var comparisons, hasRequiredComparisons;
function requireComparisons() {
  if (hasRequiredComparisons) return comparisons;
  hasRequiredComparisons = 1;
  function o(zr, ti) {
    return d(zr) || t(zr, ti) || c(zr, ti) || g();
  }
  function g() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function c(zr, ti) {
    if (zr) {
      if (typeof zr == "string") return y(zr, ti);
      var Lr = Object.prototype.toString.call(zr).slice(8, -1);
      if (Lr === "Object" && zr.constructor && (Lr = zr.constructor.name), Lr === "Map" || Lr === "Set") return Array.from(zr);
      if (Lr === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(Lr)) return y(zr, ti);
    }
  }
  function y(zr, ti) {
    (ti == null || ti > zr.length) && (ti = zr.length);
    for (var Lr = 0, Rr = new Array(ti); Lr < ti; Lr++) Rr[Lr] = zr[Lr];
    return Rr;
  }
  function t(zr, ti) {
    var Lr = zr == null ? null : typeof Symbol < "u" && zr[Symbol.iterator] || zr["@@iterator"];
    if (Lr != null) {
      var Rr, Ir, pr, Cr, Er = [], xr = !0, si = !1;
      try {
        if (pr = (Lr = Lr.call(zr)).next, ti !== 0) for (; !(xr = (Rr = pr.call(Lr)).done) && (Er.push(Rr.value), Er.length !== ti); xr = !0) ;
      } catch (Ci) {
        si = !0, Ir = Ci;
      } finally {
        try {
          if (!xr && Lr.return != null && (Cr = Lr.return(), Object(Cr) !== Cr)) return;
        } finally {
          if (si) throw Ir;
        }
      }
      return Er;
    }
  }
  function d(zr) {
    if (Array.isArray(zr)) return zr;
  }
  function E(zr) {
    "@babel/helpers - typeof";
    return E = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(ti) {
      return typeof ti;
    } : function(ti) {
      return ti && typeof Symbol == "function" && ti.constructor === Symbol && ti !== Symbol.prototype ? "symbol" : typeof ti;
    }, E(zr);
  }
  var B = /a/g.flags !== void 0, D = function(ti) {
    var Lr = [];
    return ti.forEach(function(Rr) {
      return Lr.push(Rr);
    }), Lr;
  }, x = function(ti) {
    var Lr = [];
    return ti.forEach(function(Rr, Ir) {
      return Lr.push([Ir, Rr]);
    }), Lr;
  }, v = Object.is ? Object.is : requireObjectIs(), F = Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols : function() {
    return [];
  }, M = Number.isNaN ? Number.isNaN : requireIsNan();
  function U(zr) {
    return zr.call.bind(zr);
  }
  var L = U(Object.prototype.hasOwnProperty), H = U(Object.prototype.propertyIsEnumerable), fe = U(Object.prototype.toString), ge = requireUtil$1().types, Ie = ge.isAnyArrayBuffer, Ee = ge.isArrayBufferView, Se = ge.isDate, ze = ge.isMap, He = ge.isRegExp, Pe = ge.isSet, De = ge.isNativeError, ve = ge.isBoxedPrimitive, Fe = ge.isNumberObject, be = ge.isStringObject, Be = ge.isBooleanObject, ke = ge.isBigIntObject, xe = ge.isSymbolObject, Ne = ge.isFloat32Array, Et = ge.isFloat64Array;
  function st(zr) {
    if (zr.length === 0 || zr.length > 10) return !0;
    for (var ti = 0; ti < zr.length; ti++) {
      var Lr = zr.charCodeAt(ti);
      if (Lr < 48 || Lr > 57) return !0;
    }
    return zr.length === 10 && zr >= Math.pow(2, 32);
  }
  function Dt(zr) {
    return Object.keys(zr).filter(st).concat(F(zr).filter(Object.prototype.propertyIsEnumerable.bind(zr)));
  }
  function er(zr, ti) {
    if (zr === ti)
      return 0;
    for (var Lr = zr.length, Rr = ti.length, Ir = 0, pr = Math.min(Lr, Rr); Ir < pr; ++Ir)
      if (zr[Ir] !== ti[Ir]) {
        Lr = zr[Ir], Rr = ti[Ir];
        break;
      }
    return Lr < Rr ? -1 : Rr < Lr ? 1 : 0;
  }
  var xt = !0, ir = !1, sr = 0, yr = 1, wr = 2, qr = 3;
  function Mr(zr, ti) {
    return B ? zr.source === ti.source && zr.flags === ti.flags : RegExp.prototype.toString.call(zr) === RegExp.prototype.toString.call(ti);
  }
  function Dr(zr, ti) {
    if (zr.byteLength !== ti.byteLength)
      return !1;
    for (var Lr = 0; Lr < zr.byteLength; Lr++)
      if (zr[Lr] !== ti[Lr])
        return !1;
    return !0;
  }
  function Qr(zr, ti) {
    return zr.byteLength !== ti.byteLength ? !1 : er(new Uint8Array(zr.buffer, zr.byteOffset, zr.byteLength), new Uint8Array(ti.buffer, ti.byteOffset, ti.byteLength)) === 0;
  }
  function Xr(zr, ti) {
    return zr.byteLength === ti.byteLength && er(new Uint8Array(zr), new Uint8Array(ti)) === 0;
  }
  function Vr(zr, ti) {
    return Fe(zr) ? Fe(ti) && v(Number.prototype.valueOf.call(zr), Number.prototype.valueOf.call(ti)) : be(zr) ? be(ti) && String.prototype.valueOf.call(zr) === String.prototype.valueOf.call(ti) : Be(zr) ? Be(ti) && Boolean.prototype.valueOf.call(zr) === Boolean.prototype.valueOf.call(ti) : ke(zr) ? ke(ti) && BigInt.prototype.valueOf.call(zr) === BigInt.prototype.valueOf.call(ti) : xe(ti) && Symbol.prototype.valueOf.call(zr) === Symbol.prototype.valueOf.call(ti);
  }
  function Ur(zr, ti, Lr, Rr) {
    if (zr === ti)
      return zr !== 0 ? !0 : Lr ? v(zr, ti) : !0;
    if (Lr) {
      if (E(zr) !== "object")
        return typeof zr == "number" && M(zr) && M(ti);
      if (E(ti) !== "object" || zr === null || ti === null || Object.getPrototypeOf(zr) !== Object.getPrototypeOf(ti))
        return !1;
    } else {
      if (zr === null || E(zr) !== "object")
        return ti === null || E(ti) !== "object" ? zr == ti : !1;
      if (ti === null || E(ti) !== "object")
        return !1;
    }
    var Ir = fe(zr), pr = fe(ti);
    if (Ir !== pr)
      return !1;
    if (Array.isArray(zr)) {
      if (zr.length !== ti.length)
        return !1;
      var Cr = Dt(zr), Er = Dt(ti);
      return Cr.length !== Er.length ? !1 : Gr(zr, ti, Lr, Rr, yr, Cr);
    }
    if (Ir === "[object Object]" && (!ze(zr) && ze(ti) || !Pe(zr) && Pe(ti)))
      return !1;
    if (Se(zr)) {
      if (!Se(ti) || Date.prototype.getTime.call(zr) !== Date.prototype.getTime.call(ti))
        return !1;
    } else if (He(zr)) {
      if (!He(ti) || !Mr(zr, ti))
        return !1;
    } else if (De(zr) || zr instanceof Error) {
      if (zr.message !== ti.message || zr.name !== ti.name)
        return !1;
    } else if (Ee(zr)) {
      if (!Lr && (Ne(zr) || Et(zr))) {
        if (!Dr(zr, ti))
          return !1;
      } else if (!Qr(zr, ti))
        return !1;
      var xr = Dt(zr), si = Dt(ti);
      return xr.length !== si.length ? !1 : Gr(zr, ti, Lr, Rr, sr, xr);
    } else {
      if (Pe(zr))
        return !Pe(ti) || zr.size !== ti.size ? !1 : Gr(zr, ti, Lr, Rr, wr);
      if (ze(zr))
        return !ze(ti) || zr.size !== ti.size ? !1 : Gr(zr, ti, Lr, Rr, qr);
      if (Ie(zr)) {
        if (!Xr(zr, ti))
          return !1;
      } else if (ve(zr) && !Vr(zr, ti))
        return !1;
    }
    return Gr(zr, ti, Lr, Rr, sr);
  }
  function Sr(zr, ti) {
    return ti.filter(function(Lr) {
      return H(zr, Lr);
    });
  }
  function Gr(zr, ti, Lr, Rr, Ir, pr) {
    if (arguments.length === 5) {
      pr = Object.keys(zr);
      var Cr = Object.keys(ti);
      if (pr.length !== Cr.length)
        return !1;
    }
    for (var Er = 0; Er < pr.length; Er++)
      if (!L(ti, pr[Er]))
        return !1;
    if (Lr && arguments.length === 5) {
      var xr = F(zr);
      if (xr.length !== 0) {
        var si = 0;
        for (Er = 0; Er < xr.length; Er++) {
          var Ci = xr[Er];
          if (H(zr, Ci)) {
            if (!H(ti, Ci))
              return !1;
            pr.push(Ci), si++;
          } else if (H(ti, Ci))
            return !1;
        }
        var bi = F(ti);
        if (xr.length !== bi.length && Sr(ti, bi).length !== si)
          return !1;
      } else {
        var Ri = F(ti);
        if (Ri.length !== 0 && Sr(ti, Ri).length !== 0)
          return !1;
      }
    }
    if (pr.length === 0 && (Ir === sr || Ir === yr && zr.length === 0 || zr.size === 0))
      return !0;
    if (Rr === void 0)
      Rr = {
        val1: /* @__PURE__ */ new Map(),
        val2: /* @__PURE__ */ new Map(),
        position: 0
      };
    else {
      var li = Rr.val1.get(zr);
      if (li !== void 0) {
        var zi = Rr.val2.get(ti);
        if (zi !== void 0)
          return li === zi;
      }
      Rr.position++;
    }
    Rr.val1.set(zr, Rr.position), Rr.val2.set(ti, Rr.position);
    var Kn = Bi(zr, ti, Lr, pr, Rr, Ir);
    return Rr.val1.delete(zr), Rr.val2.delete(ti), Kn;
  }
  function Fr(zr, ti, Lr, Rr) {
    for (var Ir = D(zr), pr = 0; pr < Ir.length; pr++) {
      var Cr = Ir[pr];
      if (Ur(ti, Cr, Lr, Rr))
        return zr.delete(Cr), !0;
    }
    return !1;
  }
  function br(zr) {
    switch (E(zr)) {
      case "undefined":
        return null;
      case "object":
        return;
      case "symbol":
        return !1;
      case "string":
        zr = +zr;
      // Loose equal entries exist only if the string is possible to convert to
      // a regular number and not NaN.
      // Fall through
      case "number":
        if (M(zr))
          return !1;
    }
    return !0;
  }
  function Ar(zr, ti, Lr) {
    var Rr = br(Lr);
    return Rr ?? (ti.has(Rr) && !zr.has(Rr));
  }
  function cr(zr, ti, Lr, Rr, Ir) {
    var pr = br(Lr);
    if (pr != null)
      return pr;
    var Cr = ti.get(pr);
    return Cr === void 0 && !ti.has(pr) || !Ur(Rr, Cr, !1, Ir) ? !1 : !zr.has(pr) && Ur(Rr, Cr, !1, Ir);
  }
  function hr(zr, ti, Lr, Rr) {
    for (var Ir = null, pr = D(zr), Cr = 0; Cr < pr.length; Cr++) {
      var Er = pr[Cr];
      if (E(Er) === "object" && Er !== null)
        Ir === null && (Ir = /* @__PURE__ */ new Set()), Ir.add(Er);
      else if (!ti.has(Er)) {
        if (Lr || !Ar(zr, ti, Er))
          return !1;
        Ir === null && (Ir = /* @__PURE__ */ new Set()), Ir.add(Er);
      }
    }
    if (Ir !== null) {
      for (var xr = D(ti), si = 0; si < xr.length; si++) {
        var Ci = xr[si];
        if (E(Ci) === "object" && Ci !== null) {
          if (!Fr(Ir, Ci, Lr, Rr)) return !1;
        } else if (!Lr && !zr.has(Ci) && !Fr(Ir, Ci, Lr, Rr))
          return !1;
      }
      return Ir.size === 0;
    }
    return !0;
  }
  function Wr(zr, ti, Lr, Rr, Ir, pr) {
    for (var Cr = D(zr), Er = 0; Er < Cr.length; Er++) {
      var xr = Cr[Er];
      if (Ur(Lr, xr, Ir, pr) && Ur(Rr, ti.get(xr), Ir, pr))
        return zr.delete(xr), !0;
    }
    return !1;
  }
  function fi(zr, ti, Lr, Rr) {
    for (var Ir = null, pr = x(zr), Cr = 0; Cr < pr.length; Cr++) {
      var Er = o(pr[Cr], 2), xr = Er[0], si = Er[1];
      if (E(xr) === "object" && xr !== null)
        Ir === null && (Ir = /* @__PURE__ */ new Set()), Ir.add(xr);
      else {
        var Ci = ti.get(xr);
        if (Ci === void 0 && !ti.has(xr) || !Ur(si, Ci, Lr, Rr)) {
          if (Lr || !cr(zr, ti, xr, si, Rr)) return !1;
          Ir === null && (Ir = /* @__PURE__ */ new Set()), Ir.add(xr);
        }
      }
    }
    if (Ir !== null) {
      for (var bi = x(ti), Ri = 0; Ri < bi.length; Ri++) {
        var li = o(bi[Ri], 2), zi = li[0], Kn = li[1];
        if (E(zi) === "object" && zi !== null) {
          if (!Wr(Ir, zr, zi, Kn, Lr, Rr)) return !1;
        } else if (!Lr && (!zr.has(zi) || !Ur(zr.get(zi), Kn, !1, Rr)) && !Wr(Ir, zr, zi, Kn, !1, Rr))
          return !1;
      }
      return Ir.size === 0;
    }
    return !0;
  }
  function Bi(zr, ti, Lr, Rr, Ir, pr) {
    var Cr = 0;
    if (pr === wr) {
      if (!hr(zr, ti, Lr, Ir))
        return !1;
    } else if (pr === qr) {
      if (!fi(zr, ti, Lr, Ir))
        return !1;
    } else if (pr === yr)
      for (; Cr < zr.length; Cr++)
        if (L(zr, Cr)) {
          if (!L(ti, Cr) || !Ur(zr[Cr], ti[Cr], Lr, Ir))
            return !1;
        } else {
          if (L(ti, Cr))
            return !1;
          for (var Er = Object.keys(zr); Cr < Er.length; Cr++) {
            var xr = Er[Cr];
            if (!L(ti, xr) || !Ur(zr[xr], ti[xr], Lr, Ir))
              return !1;
          }
          return Er.length === Object.keys(ti).length;
        }
    for (Cr = 0; Cr < Rr.length; Cr++) {
      var si = Rr[Cr];
      if (!Ur(zr[si], ti[si], Lr, Ir))
        return !1;
    }
    return !0;
  }
  function $r(zr, ti) {
    return Ur(zr, ti, ir);
  }
  function oi(zr, ti) {
    return Ur(zr, ti, xt);
  }
  return comparisons = {
    isDeepEqual: $r,
    isDeepStrictEqual: oi
  }, comparisons;
}
var hasRequiredAssert$2;
function requireAssert$2() {
  if (hasRequiredAssert$2) return assert$2.exports;
  hasRequiredAssert$2 = 1;
  function o(wr) {
    "@babel/helpers - typeof";
    return o = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(qr) {
      return typeof qr;
    } : function(qr) {
      return qr && typeof Symbol == "function" && qr.constructor === Symbol && qr !== Symbol.prototype ? "symbol" : typeof qr;
    }, o(wr);
  }
  function g(wr, qr, Mr) {
    return Object.defineProperty(wr, "prototype", { writable: !1 }), wr;
  }
  function c(wr, qr) {
    if (!(wr instanceof qr))
      throw new TypeError("Cannot call a class as a function");
  }
  var y = requireErrors$5(), t = y.codes, d = t.ERR_AMBIGUOUS_ARGUMENT, E = t.ERR_INVALID_ARG_TYPE, B = t.ERR_INVALID_ARG_VALUE, D = t.ERR_INVALID_RETURN_VALUE, x = t.ERR_MISSING_ARGS, v = requireAssertion_error(), F = requireUtil$1(), M = F.inspect, U = requireUtil$1().types, L = U.isPromise, H = U.isRegExp, fe = requirePolyfill$2()(), ge = requirePolyfill$1()(), Ie = requireCallBound()("RegExp.prototype.test"), Ee, Se;
  function ze() {
    var wr = requireComparisons();
    Ee = wr.isDeepEqual, Se = wr.isDeepStrictEqual;
  }
  var He = !1, Pe = assert$2.exports = Be, De = {};
  function ve(wr) {
    throw wr.message instanceof Error ? wr.message : new v(wr);
  }
  function Fe(wr, qr, Mr, Dr, Qr) {
    var Xr = arguments.length, Vr;
    if (Xr === 0)
      Vr = "Failed";
    else if (Xr === 1)
      Mr = wr, wr = void 0;
    else {
      if (He === !1) {
        He = !0;
        var Ur = process$1.emitWarning ? process$1.emitWarning : console.warn.bind(console);
        Ur("assert.fail() with more than one argument is deprecated. Please use assert.strictEqual() instead or only pass a message.", "DeprecationWarning", "DEP0094");
      }
      Xr === 2 && (Dr = "!=");
    }
    if (Mr instanceof Error) throw Mr;
    var Sr = {
      actual: wr,
      expected: qr,
      operator: Dr === void 0 ? "fail" : Dr,
      stackStartFn: Qr || Fe
    };
    Mr !== void 0 && (Sr.message = Mr);
    var Gr = new v(Sr);
    throw Vr && (Gr.message = Vr, Gr.generatedMessage = !0), Gr;
  }
  Pe.fail = Fe, Pe.AssertionError = v;
  function be(wr, qr, Mr, Dr) {
    if (!Mr) {
      var Qr = !1;
      if (qr === 0)
        Qr = !0, Dr = "No value argument passed to `assert.ok()`";
      else if (Dr instanceof Error)
        throw Dr;
      var Xr = new v({
        actual: Mr,
        expected: !0,
        message: Dr,
        operator: "==",
        stackStartFn: wr
      });
      throw Xr.generatedMessage = Qr, Xr;
    }
  }
  function Be() {
    for (var wr = arguments.length, qr = new Array(wr), Mr = 0; Mr < wr; Mr++)
      qr[Mr] = arguments[Mr];
    be.apply(void 0, [Be, qr.length].concat(qr));
  }
  Pe.ok = Be, Pe.equal = function wr(qr, Mr, Dr) {
    if (arguments.length < 2)
      throw new x("actual", "expected");
    qr != Mr && ve({
      actual: qr,
      expected: Mr,
      message: Dr,
      operator: "==",
      stackStartFn: wr
    });
  }, Pe.notEqual = function wr(qr, Mr, Dr) {
    if (arguments.length < 2)
      throw new x("actual", "expected");
    qr == Mr && ve({
      actual: qr,
      expected: Mr,
      message: Dr,
      operator: "!=",
      stackStartFn: wr
    });
  }, Pe.deepEqual = function wr(qr, Mr, Dr) {
    if (arguments.length < 2)
      throw new x("actual", "expected");
    Ee === void 0 && ze(), Ee(qr, Mr) || ve({
      actual: qr,
      expected: Mr,
      message: Dr,
      operator: "deepEqual",
      stackStartFn: wr
    });
  }, Pe.notDeepEqual = function wr(qr, Mr, Dr) {
    if (arguments.length < 2)
      throw new x("actual", "expected");
    Ee === void 0 && ze(), Ee(qr, Mr) && ve({
      actual: qr,
      expected: Mr,
      message: Dr,
      operator: "notDeepEqual",
      stackStartFn: wr
    });
  }, Pe.deepStrictEqual = function wr(qr, Mr, Dr) {
    if (arguments.length < 2)
      throw new x("actual", "expected");
    Ee === void 0 && ze(), Se(qr, Mr) || ve({
      actual: qr,
      expected: Mr,
      message: Dr,
      operator: "deepStrictEqual",
      stackStartFn: wr
    });
  }, Pe.notDeepStrictEqual = ke;
  function ke(wr, qr, Mr) {
    if (arguments.length < 2)
      throw new x("actual", "expected");
    Ee === void 0 && ze(), Se(wr, qr) && ve({
      actual: wr,
      expected: qr,
      message: Mr,
      operator: "notDeepStrictEqual",
      stackStartFn: ke
    });
  }
  Pe.strictEqual = function wr(qr, Mr, Dr) {
    if (arguments.length < 2)
      throw new x("actual", "expected");
    ge(qr, Mr) || ve({
      actual: qr,
      expected: Mr,
      message: Dr,
      operator: "strictEqual",
      stackStartFn: wr
    });
  }, Pe.notStrictEqual = function wr(qr, Mr, Dr) {
    if (arguments.length < 2)
      throw new x("actual", "expected");
    ge(qr, Mr) && ve({
      actual: qr,
      expected: Mr,
      message: Dr,
      operator: "notStrictEqual",
      stackStartFn: wr
    });
  };
  var xe = /* @__PURE__ */ g(function wr(qr, Mr, Dr) {
    var Qr = this;
    c(this, wr), Mr.forEach(function(Xr) {
      Xr in qr && (Dr !== void 0 && typeof Dr[Xr] == "string" && H(qr[Xr]) && Ie(qr[Xr], Dr[Xr]) ? Qr[Xr] = Dr[Xr] : Qr[Xr] = qr[Xr]);
    });
  });
  function Ne(wr, qr, Mr, Dr, Qr, Xr) {
    if (!(Mr in wr) || !Se(wr[Mr], qr[Mr])) {
      if (!Dr) {
        var Vr = new xe(wr, Qr), Ur = new xe(qr, Qr, wr), Sr = new v({
          actual: Vr,
          expected: Ur,
          operator: "deepStrictEqual",
          stackStartFn: Xr
        });
        throw Sr.actual = wr, Sr.expected = qr, Sr.operator = Xr.name, Sr;
      }
      ve({
        actual: wr,
        expected: qr,
        message: Dr,
        operator: Xr.name,
        stackStartFn: Xr
      });
    }
  }
  function Et(wr, qr, Mr, Dr) {
    if (typeof qr != "function") {
      if (H(qr)) return Ie(qr, wr);
      if (arguments.length === 2)
        throw new E("expected", ["Function", "RegExp"], qr);
      if (o(wr) !== "object" || wr === null) {
        var Qr = new v({
          actual: wr,
          expected: qr,
          message: Mr,
          operator: "deepStrictEqual",
          stackStartFn: Dr
        });
        throw Qr.operator = Dr.name, Qr;
      }
      var Xr = Object.keys(qr);
      if (qr instanceof Error)
        Xr.push("name", "message");
      else if (Xr.length === 0)
        throw new B("error", qr, "may not be an empty object");
      return Ee === void 0 && ze(), Xr.forEach(function(Vr) {
        typeof wr[Vr] == "string" && H(qr[Vr]) && Ie(qr[Vr], wr[Vr]) || Ne(wr, qr, Vr, Mr, Xr, Dr);
      }), !0;
    }
    return qr.prototype !== void 0 && wr instanceof qr ? !0 : Error.isPrototypeOf(qr) ? !1 : qr.call({}, wr) === !0;
  }
  function st(wr) {
    if (typeof wr != "function")
      throw new E("fn", "Function", wr);
    try {
      wr();
    } catch (qr) {
      return qr;
    }
    return De;
  }
  function Dt(wr) {
    return L(wr) || wr !== null && o(wr) === "object" && typeof wr.then == "function" && typeof wr.catch == "function";
  }
  function er(wr) {
    return Promise.resolve().then(function() {
      var qr;
      if (typeof wr == "function") {
        if (qr = wr(), !Dt(qr))
          throw new D("instance of Promise", "promiseFn", qr);
      } else if (Dt(wr))
        qr = wr;
      else
        throw new E("promiseFn", ["Function", "Promise"], wr);
      return Promise.resolve().then(function() {
        return qr;
      }).then(function() {
        return De;
      }).catch(function(Mr) {
        return Mr;
      });
    });
  }
  function xt(wr, qr, Mr, Dr) {
    if (typeof Mr == "string") {
      if (arguments.length === 4)
        throw new E("error", ["Object", "Error", "Function", "RegExp"], Mr);
      if (o(qr) === "object" && qr !== null) {
        if (qr.message === Mr)
          throw new d("error/message", 'The error message "'.concat(qr.message, '" is identical to the message.'));
      } else if (qr === Mr)
        throw new d("error/message", 'The error "'.concat(qr, '" is identical to the message.'));
      Dr = Mr, Mr = void 0;
    } else if (Mr != null && o(Mr) !== "object" && typeof Mr != "function")
      throw new E("error", ["Object", "Error", "Function", "RegExp"], Mr);
    if (qr === De) {
      var Qr = "";
      Mr && Mr.name && (Qr += " (".concat(Mr.name, ")")), Qr += Dr ? ": ".concat(Dr) : ".";
      var Xr = wr.name === "rejects" ? "rejection" : "exception";
      ve({
        actual: void 0,
        expected: Mr,
        operator: wr.name,
        message: "Missing expected ".concat(Xr).concat(Qr),
        stackStartFn: wr
      });
    }
    if (Mr && !Et(qr, Mr, Dr, wr))
      throw qr;
  }
  function ir(wr, qr, Mr, Dr) {
    if (qr !== De) {
      if (typeof Mr == "string" && (Dr = Mr, Mr = void 0), !Mr || Et(qr, Mr)) {
        var Qr = Dr ? ": ".concat(Dr) : ".", Xr = wr.name === "doesNotReject" ? "rejection" : "exception";
        ve({
          actual: qr,
          expected: Mr,
          operator: wr.name,
          message: "Got unwanted ".concat(Xr).concat(Qr, `
`) + 'Actual message: "'.concat(qr && qr.message, '"'),
          stackStartFn: wr
        });
      }
      throw qr;
    }
  }
  Pe.throws = function wr(qr) {
    for (var Mr = arguments.length, Dr = new Array(Mr > 1 ? Mr - 1 : 0), Qr = 1; Qr < Mr; Qr++)
      Dr[Qr - 1] = arguments[Qr];
    xt.apply(void 0, [wr, st(qr)].concat(Dr));
  }, Pe.rejects = function wr(qr) {
    for (var Mr = arguments.length, Dr = new Array(Mr > 1 ? Mr - 1 : 0), Qr = 1; Qr < Mr; Qr++)
      Dr[Qr - 1] = arguments[Qr];
    return er(qr).then(function(Xr) {
      return xt.apply(void 0, [wr, Xr].concat(Dr));
    });
  }, Pe.doesNotThrow = function wr(qr) {
    for (var Mr = arguments.length, Dr = new Array(Mr > 1 ? Mr - 1 : 0), Qr = 1; Qr < Mr; Qr++)
      Dr[Qr - 1] = arguments[Qr];
    ir.apply(void 0, [wr, st(qr)].concat(Dr));
  }, Pe.doesNotReject = function wr(qr) {
    for (var Mr = arguments.length, Dr = new Array(Mr > 1 ? Mr - 1 : 0), Qr = 1; Qr < Mr; Qr++)
      Dr[Qr - 1] = arguments[Qr];
    return er(qr).then(function(Xr) {
      return ir.apply(void 0, [wr, Xr].concat(Dr));
    });
  }, Pe.ifError = function wr(qr) {
    if (qr != null) {
      var Mr = "ifError got unwanted exception: ";
      o(qr) === "object" && typeof qr.message == "string" ? qr.message.length === 0 && qr.constructor ? Mr += qr.constructor.name : Mr += qr.message : Mr += M(qr);
      var Dr = new v({
        actual: qr,
        expected: null,
        operator: "ifError",
        message: Mr,
        stackStartFn: wr
      }), Qr = qr.stack;
      if (typeof Qr == "string") {
        var Xr = Qr.split(`
`);
        Xr.shift();
        for (var Vr = Dr.stack.split(`
`), Ur = 0; Ur < Xr.length; Ur++) {
          var Sr = Vr.indexOf(Xr[Ur]);
          if (Sr !== -1) {
            Vr = Vr.slice(0, Sr);
            break;
          }
        }
        Dr.stack = "".concat(Vr.join(`
`), `
`).concat(Xr.join(`
`));
      }
      throw Dr;
    }
  };
  function sr(wr, qr, Mr, Dr, Qr) {
    if (!H(qr))
      throw new E("regexp", "RegExp", qr);
    var Xr = Qr === "match";
    if (typeof wr != "string" || Ie(qr, wr) !== Xr) {
      if (Mr instanceof Error)
        throw Mr;
      var Vr = !Mr;
      Mr = Mr || (typeof wr != "string" ? 'The "string" argument must be of type string. Received type ' + "".concat(o(wr), " (").concat(M(wr), ")") : (Xr ? "The input did not match the regular expression " : "The input was expected to not match the regular expression ") + "".concat(M(qr), `. Input:

`).concat(M(wr), `
`));
      var Ur = new v({
        actual: wr,
        expected: qr,
        message: Mr,
        operator: Qr,
        stackStartFn: Dr
      });
      throw Ur.generatedMessage = Vr, Ur;
    }
  }
  Pe.match = function wr(qr, Mr, Dr) {
    sr(qr, Mr, Dr, wr, "match");
  }, Pe.doesNotMatch = function wr(qr, Mr, Dr) {
    sr(qr, Mr, Dr, wr, "doesNotMatch");
  };
  function yr() {
    for (var wr = arguments.length, qr = new Array(wr), Mr = 0; Mr < wr; Mr++)
      qr[Mr] = arguments[Mr];
    be.apply(void 0, [yr, qr.length].concat(qr));
  }
  return Pe.strict = fe(yr, Pe, {
    equal: Pe.strictEqual,
    deepEqual: Pe.deepStrictEqual,
    notEqual: Pe.notStrictEqual,
    notDeepEqual: Pe.notDeepStrictEqual
  }), Pe.strict.strict = Pe.strict, assert$2.exports;
}
var fountainUtils = {}, xoshiro = {}, bignumber$1 = { exports: {} }, bignumber = bignumber$1.exports, hasRequiredBignumber;
function requireBignumber() {
  return hasRequiredBignumber || (hasRequiredBignumber = 1, function(o) {
    (function(g) {
      var c, y = /^-?(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?$/i, t = Math.ceil, d = Math.floor, E = "[BigNumber Error] ", B = E + "Number primitive has more than 15 significant digits: ", D = 1e14, x = 14, v = 9007199254740991, F = [1, 10, 100, 1e3, 1e4, 1e5, 1e6, 1e7, 1e8, 1e9, 1e10, 1e11, 1e12, 1e13], M = 1e7, U = 1e9;
      function L(He) {
        var Pe, De, ve, Fe = wr.prototype = { constructor: wr, toString: null, valueOf: null }, be = new wr(1), Be = 20, ke = 4, xe = -7, Ne = 21, Et = -1e7, st = 1e7, Dt = !1, er = 1, xt = 0, ir = {
          prefix: "",
          groupSize: 3,
          secondaryGroupSize: 0,
          groupSeparator: ",",
          decimalSeparator: ".",
          fractionGroupSize: 0,
          fractionGroupSeparator: " ",
          // non-breaking space
          suffix: ""
        }, sr = "0123456789abcdefghijklmnopqrstuvwxyz", yr = !0;
        function wr(Vr, Ur) {
          var Sr, Gr, Fr, br, Ar, cr, hr, Wr, fi = this;
          if (!(fi instanceof wr)) return new wr(Vr, Ur);
          if (Ur == null) {
            if (Vr && Vr._isBigNumber === !0) {
              fi.s = Vr.s, !Vr.c || Vr.e > st ? fi.c = fi.e = null : Vr.e < Et ? fi.c = [fi.e = 0] : (fi.e = Vr.e, fi.c = Vr.c.slice());
              return;
            }
            if ((cr = typeof Vr == "number") && Vr * 0 == 0) {
              if (fi.s = 1 / Vr < 0 ? (Vr = -Vr, -1) : 1, Vr === ~~Vr) {
                for (br = 0, Ar = Vr; Ar >= 10; Ar /= 10, br++) ;
                br > st ? fi.c = fi.e = null : (fi.e = br, fi.c = [Vr]);
                return;
              }
              Wr = String(Vr);
            } else {
              if (!y.test(Wr = String(Vr))) return ve(fi, Wr, cr);
              fi.s = Wr.charCodeAt(0) == 45 ? (Wr = Wr.slice(1), -1) : 1;
            }
            (br = Wr.indexOf(".")) > -1 && (Wr = Wr.replace(".", "")), (Ar = Wr.search(/e/i)) > 0 ? (br < 0 && (br = Ar), br += +Wr.slice(Ar + 1), Wr = Wr.substring(0, Ar)) : br < 0 && (br = Wr.length);
          } else {
            if (Ie(Ur, 2, sr.length, "Base"), Ur == 10 && yr)
              return fi = new wr(Vr), Qr(fi, Be + fi.e + 1, ke);
            if (Wr = String(Vr), cr = typeof Vr == "number") {
              if (Vr * 0 != 0) return ve(fi, Wr, cr, Ur);
              if (fi.s = 1 / Vr < 0 ? (Wr = Wr.slice(1), -1) : 1, wr.DEBUG && Wr.replace(/^0\.0*|\./, "").length > 15)
                throw Error(B + Vr);
            } else
              fi.s = Wr.charCodeAt(0) === 45 ? (Wr = Wr.slice(1), -1) : 1;
            for (Sr = sr.slice(0, Ur), br = Ar = 0, hr = Wr.length; Ar < hr; Ar++)
              if (Sr.indexOf(Gr = Wr.charAt(Ar)) < 0) {
                if (Gr == ".") {
                  if (Ar > br) {
                    br = hr;
                    continue;
                  }
                } else if (!Fr && (Wr == Wr.toUpperCase() && (Wr = Wr.toLowerCase()) || Wr == Wr.toLowerCase() && (Wr = Wr.toUpperCase()))) {
                  Fr = !0, Ar = -1, br = 0;
                  continue;
                }
                return ve(fi, String(Vr), cr, Ur);
              }
            cr = !1, Wr = De(Wr, Ur, 10, fi.s), (br = Wr.indexOf(".")) > -1 ? Wr = Wr.replace(".", "") : br = Wr.length;
          }
          for (Ar = 0; Wr.charCodeAt(Ar) === 48; Ar++) ;
          for (hr = Wr.length; Wr.charCodeAt(--hr) === 48; ) ;
          if (Wr = Wr.slice(Ar, ++hr)) {
            if (hr -= Ar, cr && wr.DEBUG && hr > 15 && (Vr > v || Vr !== d(Vr)))
              throw Error(B + fi.s * Vr);
            if ((br = br - Ar - 1) > st)
              fi.c = fi.e = null;
            else if (br < Et)
              fi.c = [fi.e = 0];
            else {
              if (fi.e = br, fi.c = [], Ar = (br + 1) % x, br < 0 && (Ar += x), Ar < hr) {
                for (Ar && fi.c.push(+Wr.slice(0, Ar)), hr -= x; Ar < hr; )
                  fi.c.push(+Wr.slice(Ar, Ar += x));
                Ar = x - (Wr = Wr.slice(Ar)).length;
              } else
                Ar -= hr;
              for (; Ar--; Wr += "0") ;
              fi.c.push(+Wr);
            }
          } else
            fi.c = [fi.e = 0];
        }
        wr.clone = L, wr.ROUND_UP = 0, wr.ROUND_DOWN = 1, wr.ROUND_CEIL = 2, wr.ROUND_FLOOR = 3, wr.ROUND_HALF_UP = 4, wr.ROUND_HALF_DOWN = 5, wr.ROUND_HALF_EVEN = 6, wr.ROUND_HALF_CEIL = 7, wr.ROUND_HALF_FLOOR = 8, wr.EUCLID = 9, wr.config = wr.set = function(Vr) {
          var Ur, Sr;
          if (Vr != null)
            if (typeof Vr == "object") {
              if (Vr.hasOwnProperty(Ur = "DECIMAL_PLACES") && (Sr = Vr[Ur], Ie(Sr, 0, U, Ur), Be = Sr), Vr.hasOwnProperty(Ur = "ROUNDING_MODE") && (Sr = Vr[Ur], Ie(Sr, 0, 8, Ur), ke = Sr), Vr.hasOwnProperty(Ur = "EXPONENTIAL_AT") && (Sr = Vr[Ur], Sr && Sr.pop ? (Ie(Sr[0], -U, 0, Ur), Ie(Sr[1], 0, U, Ur), xe = Sr[0], Ne = Sr[1]) : (Ie(Sr, -U, U, Ur), xe = -(Ne = Sr < 0 ? -Sr : Sr))), Vr.hasOwnProperty(Ur = "RANGE"))
                if (Sr = Vr[Ur], Sr && Sr.pop)
                  Ie(Sr[0], -U, -1, Ur), Ie(Sr[1], 1, U, Ur), Et = Sr[0], st = Sr[1];
                else if (Ie(Sr, -U, U, Ur), Sr)
                  Et = -(st = Sr < 0 ? -Sr : Sr);
                else
                  throw Error(E + Ur + " cannot be zero: " + Sr);
              if (Vr.hasOwnProperty(Ur = "CRYPTO"))
                if (Sr = Vr[Ur], Sr === !!Sr)
                  if (Sr)
                    if (typeof crypto < "u" && crypto && (crypto.getRandomValues || crypto.randomBytes))
                      Dt = Sr;
                    else
                      throw Dt = !Sr, Error(E + "crypto unavailable");
                  else
                    Dt = Sr;
                else
                  throw Error(E + Ur + " not true or false: " + Sr);
              if (Vr.hasOwnProperty(Ur = "MODULO_MODE") && (Sr = Vr[Ur], Ie(Sr, 0, 9, Ur), er = Sr), Vr.hasOwnProperty(Ur = "POW_PRECISION") && (Sr = Vr[Ur], Ie(Sr, 0, U, Ur), xt = Sr), Vr.hasOwnProperty(Ur = "FORMAT"))
                if (Sr = Vr[Ur], typeof Sr == "object") ir = Sr;
                else throw Error(E + Ur + " not an object: " + Sr);
              if (Vr.hasOwnProperty(Ur = "ALPHABET"))
                if (Sr = Vr[Ur], typeof Sr == "string" && !/^.?$|[+\-.\s]|(.).*\1/.test(Sr))
                  yr = Sr.slice(0, 10) == "0123456789", sr = Sr;
                else
                  throw Error(E + Ur + " invalid: " + Sr);
            } else
              throw Error(E + "Object expected: " + Vr);
          return {
            DECIMAL_PLACES: Be,
            ROUNDING_MODE: ke,
            EXPONENTIAL_AT: [xe, Ne],
            RANGE: [Et, st],
            CRYPTO: Dt,
            MODULO_MODE: er,
            POW_PRECISION: xt,
            FORMAT: ir,
            ALPHABET: sr
          };
        }, wr.isBigNumber = function(Vr) {
          if (!Vr || Vr._isBigNumber !== !0) return !1;
          if (!wr.DEBUG) return !0;
          var Ur, Sr, Gr = Vr.c, Fr = Vr.e, br = Vr.s;
          e: if ({}.toString.call(Gr) == "[object Array]") {
            if ((br === 1 || br === -1) && Fr >= -U && Fr <= U && Fr === d(Fr)) {
              if (Gr[0] === 0) {
                if (Fr === 0 && Gr.length === 1) return !0;
                break e;
              }
              if (Ur = (Fr + 1) % x, Ur < 1 && (Ur += x), String(Gr[0]).length == Ur) {
                for (Ur = 0; Ur < Gr.length; Ur++)
                  if (Sr = Gr[Ur], Sr < 0 || Sr >= D || Sr !== d(Sr)) break e;
                if (Sr !== 0) return !0;
              }
            }
          } else if (Gr === null && Fr === null && (br === null || br === 1 || br === -1))
            return !0;
          throw Error(E + "Invalid BigNumber: " + Vr);
        }, wr.maximum = wr.max = function() {
          return Mr(arguments, -1);
        }, wr.minimum = wr.min = function() {
          return Mr(arguments, 1);
        }, wr.random = function() {
          var Vr = 9007199254740992, Ur = Math.random() * Vr & 2097151 ? function() {
            return d(Math.random() * Vr);
          } : function() {
            return (Math.random() * 1073741824 | 0) * 8388608 + (Math.random() * 8388608 | 0);
          };
          return function(Sr) {
            var Gr, Fr, br, Ar, cr, hr = 0, Wr = [], fi = new wr(be);
            if (Sr == null ? Sr = Be : Ie(Sr, 0, U), Ar = t(Sr / x), Dt)
              if (crypto.getRandomValues) {
                for (Gr = crypto.getRandomValues(new Uint32Array(Ar *= 2)); hr < Ar; )
                  cr = Gr[hr] * 131072 + (Gr[hr + 1] >>> 11), cr >= 9e15 ? (Fr = crypto.getRandomValues(new Uint32Array(2)), Gr[hr] = Fr[0], Gr[hr + 1] = Fr[1]) : (Wr.push(cr % 1e14), hr += 2);
                hr = Ar / 2;
              } else if (crypto.randomBytes) {
                for (Gr = crypto.randomBytes(Ar *= 7); hr < Ar; )
                  cr = (Gr[hr] & 31) * 281474976710656 + Gr[hr + 1] * 1099511627776 + Gr[hr + 2] * 4294967296 + Gr[hr + 3] * 16777216 + (Gr[hr + 4] << 16) + (Gr[hr + 5] << 8) + Gr[hr + 6], cr >= 9e15 ? crypto.randomBytes(7).copy(Gr, hr) : (Wr.push(cr % 1e14), hr += 7);
                hr = Ar / 7;
              } else
                throw Dt = !1, Error(E + "crypto unavailable");
            if (!Dt)
              for (; hr < Ar; )
                cr = Ur(), cr < 9e15 && (Wr[hr++] = cr % 1e14);
            for (Ar = Wr[--hr], Sr %= x, Ar && Sr && (cr = F[x - Sr], Wr[hr] = d(Ar / cr) * cr); Wr[hr] === 0; Wr.pop(), hr--) ;
            if (hr < 0)
              Wr = [br = 0];
            else {
              for (br = -1; Wr[0] === 0; Wr.splice(0, 1), br -= x) ;
              for (hr = 1, cr = Wr[0]; cr >= 10; cr /= 10, hr++) ;
              hr < x && (br -= x - hr);
            }
            return fi.e = br, fi.c = Wr, fi;
          };
        }(), wr.sum = function() {
          for (var Vr = 1, Ur = arguments, Sr = new wr(Ur[0]); Vr < Ur.length; ) Sr = Sr.plus(Ur[Vr++]);
          return Sr;
        }, De = /* @__PURE__ */ function() {
          var Vr = "0123456789";
          function Ur(Sr, Gr, Fr, br) {
            for (var Ar, cr = [0], hr, Wr = 0, fi = Sr.length; Wr < fi; ) {
              for (hr = cr.length; hr--; cr[hr] *= Gr) ;
              for (cr[0] += br.indexOf(Sr.charAt(Wr++)), Ar = 0; Ar < cr.length; Ar++)
                cr[Ar] > Fr - 1 && (cr[Ar + 1] == null && (cr[Ar + 1] = 0), cr[Ar + 1] += cr[Ar] / Fr | 0, cr[Ar] %= Fr);
            }
            return cr.reverse();
          }
          return function(Sr, Gr, Fr, br, Ar) {
            var cr, hr, Wr, fi, Bi, $r, oi, zr, ti = Sr.indexOf("."), Lr = Be, Rr = ke;
            for (ti >= 0 && (fi = xt, xt = 0, Sr = Sr.replace(".", ""), zr = new wr(Gr), $r = zr.pow(Sr.length - ti), xt = fi, zr.c = Ur(
              ze(fe($r.c), $r.e, "0"),
              10,
              Fr,
              Vr
            ), zr.e = zr.c.length), oi = Ur(Sr, Gr, Fr, Ar ? (cr = sr, Vr) : (cr = Vr, sr)), Wr = fi = oi.length; oi[--fi] == 0; oi.pop()) ;
            if (!oi[0]) return cr.charAt(0);
            if (ti < 0 ? --Wr : ($r.c = oi, $r.e = Wr, $r.s = br, $r = Pe($r, zr, Lr, Rr, Fr), oi = $r.c, Bi = $r.r, Wr = $r.e), hr = Wr + Lr + 1, ti = oi[hr], fi = Fr / 2, Bi = Bi || hr < 0 || oi[hr + 1] != null, Bi = Rr < 4 ? (ti != null || Bi) && (Rr == 0 || Rr == ($r.s < 0 ? 3 : 2)) : ti > fi || ti == fi && (Rr == 4 || Bi || Rr == 6 && oi[hr - 1] & 1 || Rr == ($r.s < 0 ? 8 : 7)), hr < 1 || !oi[0])
              Sr = Bi ? ze(cr.charAt(1), -Lr, cr.charAt(0)) : cr.charAt(0);
            else {
              if (oi.length = hr, Bi)
                for (--Fr; ++oi[--hr] > Fr; )
                  oi[hr] = 0, hr || (++Wr, oi = [1].concat(oi));
              for (fi = oi.length; !oi[--fi]; ) ;
              for (ti = 0, Sr = ""; ti <= fi; Sr += cr.charAt(oi[ti++])) ;
              Sr = ze(Sr, Wr, cr.charAt(0));
            }
            return Sr;
          };
        }(), Pe = /* @__PURE__ */ function() {
          function Vr(Gr, Fr, br) {
            var Ar, cr, hr, Wr, fi = 0, Bi = Gr.length, $r = Fr % M, oi = Fr / M | 0;
            for (Gr = Gr.slice(); Bi--; )
              hr = Gr[Bi] % M, Wr = Gr[Bi] / M | 0, Ar = oi * hr + Wr * $r, cr = $r * hr + Ar % M * M + fi, fi = (cr / br | 0) + (Ar / M | 0) + oi * Wr, Gr[Bi] = cr % br;
            return fi && (Gr = [fi].concat(Gr)), Gr;
          }
          function Ur(Gr, Fr, br, Ar) {
            var cr, hr;
            if (br != Ar)
              hr = br > Ar ? 1 : -1;
            else
              for (cr = hr = 0; cr < br; cr++)
                if (Gr[cr] != Fr[cr]) {
                  hr = Gr[cr] > Fr[cr] ? 1 : -1;
                  break;
                }
            return hr;
          }
          function Sr(Gr, Fr, br, Ar) {
            for (var cr = 0; br--; )
              Gr[br] -= cr, cr = Gr[br] < Fr[br] ? 1 : 0, Gr[br] = cr * Ar + Gr[br] - Fr[br];
            for (; !Gr[0] && Gr.length > 1; Gr.splice(0, 1)) ;
          }
          return function(Gr, Fr, br, Ar, cr) {
            var hr, Wr, fi, Bi, $r, oi, zr, ti, Lr, Rr, Ir, pr, Cr, Er, xr, si, Ci, bi = Gr.s == Fr.s ? 1 : -1, Ri = Gr.c, li = Fr.c;
            if (!Ri || !Ri[0] || !li || !li[0])
              return new wr(
                // Return NaN if either NaN, or both Infinity or 0.
                !Gr.s || !Fr.s || (Ri ? li && Ri[0] == li[0] : !li) ? NaN : (
                  // Return ±0 if x is ±0 or y is ±Infinity, or return ±Infinity as y is ±0.
                  Ri && Ri[0] == 0 || !li ? bi * 0 : bi / 0
                )
              );
            for (ti = new wr(bi), Lr = ti.c = [], Wr = Gr.e - Fr.e, bi = br + Wr + 1, cr || (cr = D, Wr = H(Gr.e / x) - H(Fr.e / x), bi = bi / x | 0), fi = 0; li[fi] == (Ri[fi] || 0); fi++) ;
            if (li[fi] > (Ri[fi] || 0) && Wr--, bi < 0)
              Lr.push(1), Bi = !0;
            else {
              for (Er = Ri.length, si = li.length, fi = 0, bi += 2, $r = d(cr / (li[0] + 1)), $r > 1 && (li = Vr(li, $r, cr), Ri = Vr(Ri, $r, cr), si = li.length, Er = Ri.length), Cr = si, Rr = Ri.slice(0, si), Ir = Rr.length; Ir < si; Rr[Ir++] = 0) ;
              Ci = li.slice(), Ci = [0].concat(Ci), xr = li[0], li[1] >= cr / 2 && xr++;
              do {
                if ($r = 0, hr = Ur(li, Rr, si, Ir), hr < 0) {
                  if (pr = Rr[0], si != Ir && (pr = pr * cr + (Rr[1] || 0)), $r = d(pr / xr), $r > 1)
                    for ($r >= cr && ($r = cr - 1), oi = Vr(li, $r, cr), zr = oi.length, Ir = Rr.length; Ur(oi, Rr, zr, Ir) == 1; )
                      $r--, Sr(oi, si < zr ? Ci : li, zr, cr), zr = oi.length, hr = 1;
                  else
                    $r == 0 && (hr = $r = 1), oi = li.slice(), zr = oi.length;
                  if (zr < Ir && (oi = [0].concat(oi)), Sr(Rr, oi, Ir, cr), Ir = Rr.length, hr == -1)
                    for (; Ur(li, Rr, si, Ir) < 1; )
                      $r++, Sr(Rr, si < Ir ? Ci : li, Ir, cr), Ir = Rr.length;
                } else hr === 0 && ($r++, Rr = [0]);
                Lr[fi++] = $r, Rr[0] ? Rr[Ir++] = Ri[Cr] || 0 : (Rr = [Ri[Cr]], Ir = 1);
              } while ((Cr++ < Er || Rr[0] != null) && bi--);
              Bi = Rr[0] != null, Lr[0] || Lr.splice(0, 1);
            }
            if (cr == D) {
              for (fi = 1, bi = Lr[0]; bi >= 10; bi /= 10, fi++) ;
              Qr(ti, br + (ti.e = fi + Wr * x - 1) + 1, Ar, Bi);
            } else
              ti.e = Wr, ti.r = +Bi;
            return ti;
          };
        }();
        function qr(Vr, Ur, Sr, Gr) {
          var Fr, br, Ar, cr, hr;
          if (Sr == null ? Sr = ke : Ie(Sr, 0, 8), !Vr.c) return Vr.toString();
          if (Fr = Vr.c[0], Ar = Vr.e, Ur == null)
            hr = fe(Vr.c), hr = Gr == 1 || Gr == 2 && (Ar <= xe || Ar >= Ne) ? Se(hr, Ar) : ze(hr, Ar, "0");
          else if (Vr = Qr(new wr(Vr), Ur, Sr), br = Vr.e, hr = fe(Vr.c), cr = hr.length, Gr == 1 || Gr == 2 && (Ur <= br || br <= xe)) {
            for (; cr < Ur; hr += "0", cr++) ;
            hr = Se(hr, br);
          } else if (Ur -= Ar + (Gr === 2 && br > Ar), hr = ze(hr, br, "0"), br + 1 > cr) {
            if (--Ur > 0) for (hr += "."; Ur--; hr += "0") ;
          } else if (Ur += br - cr, Ur > 0)
            for (br + 1 == cr && (hr += "."); Ur--; hr += "0") ;
          return Vr.s < 0 && Fr ? "-" + hr : hr;
        }
        function Mr(Vr, Ur) {
          for (var Sr, Gr, Fr = 1, br = new wr(Vr[0]); Fr < Vr.length; Fr++)
            Gr = new wr(Vr[Fr]), (!Gr.s || (Sr = ge(br, Gr)) === Ur || Sr === 0 && br.s === Ur) && (br = Gr);
          return br;
        }
        function Dr(Vr, Ur, Sr) {
          for (var Gr = 1, Fr = Ur.length; !Ur[--Fr]; Ur.pop()) ;
          for (Fr = Ur[0]; Fr >= 10; Fr /= 10, Gr++) ;
          return (Sr = Gr + Sr * x - 1) > st ? Vr.c = Vr.e = null : Sr < Et ? Vr.c = [Vr.e = 0] : (Vr.e = Sr, Vr.c = Ur), Vr;
        }
        ve = /* @__PURE__ */ function() {
          var Vr = /^(-?)0([xbo])(?=\w[\w.]*$)/i, Ur = /^([^.]+)\.$/, Sr = /^\.([^.]+)$/, Gr = /^-?(Infinity|NaN)$/, Fr = /^\s*\+(?=[\w.])|^\s+|\s+$/g;
          return function(br, Ar, cr, hr) {
            var Wr, fi = cr ? Ar : Ar.replace(Fr, "");
            if (Gr.test(fi))
              br.s = isNaN(fi) ? null : fi < 0 ? -1 : 1;
            else {
              if (!cr && (fi = fi.replace(Vr, function(Bi, $r, oi) {
                return Wr = (oi = oi.toLowerCase()) == "x" ? 16 : oi == "b" ? 2 : 8, !hr || hr == Wr ? $r : Bi;
              }), hr && (Wr = hr, fi = fi.replace(Ur, "$1").replace(Sr, "0.$1")), Ar != fi))
                return new wr(fi, Wr);
              if (wr.DEBUG)
                throw Error(E + "Not a" + (hr ? " base " + hr : "") + " number: " + Ar);
              br.s = null;
            }
            br.c = br.e = null;
          };
        }();
        function Qr(Vr, Ur, Sr, Gr) {
          var Fr, br, Ar, cr, hr, Wr, fi, Bi = Vr.c, $r = F;
          if (Bi) {
            e: {
              for (Fr = 1, cr = Bi[0]; cr >= 10; cr /= 10, Fr++) ;
              if (br = Ur - Fr, br < 0)
                br += x, Ar = Ur, hr = Bi[Wr = 0], fi = d(hr / $r[Fr - Ar - 1] % 10);
              else if (Wr = t((br + 1) / x), Wr >= Bi.length)
                if (Gr) {
                  for (; Bi.length <= Wr; Bi.push(0)) ;
                  hr = fi = 0, Fr = 1, br %= x, Ar = br - x + 1;
                } else
                  break e;
              else {
                for (hr = cr = Bi[Wr], Fr = 1; cr >= 10; cr /= 10, Fr++) ;
                br %= x, Ar = br - x + Fr, fi = Ar < 0 ? 0 : d(hr / $r[Fr - Ar - 1] % 10);
              }
              if (Gr = Gr || Ur < 0 || // Are there any non-zero digits after the rounding digit?
              // The expression  n % pows10[d - j - 1]  returns all digits of n to the right
              // of the digit at j, e.g. if n is 908714 and j is 2, the expression gives 714.
              Bi[Wr + 1] != null || (Ar < 0 ? hr : hr % $r[Fr - Ar - 1]), Gr = Sr < 4 ? (fi || Gr) && (Sr == 0 || Sr == (Vr.s < 0 ? 3 : 2)) : fi > 5 || fi == 5 && (Sr == 4 || Gr || Sr == 6 && // Check whether the digit to the left of the rounding digit is odd.
              (br > 0 ? Ar > 0 ? hr / $r[Fr - Ar] : 0 : Bi[Wr - 1]) % 10 & 1 || Sr == (Vr.s < 0 ? 8 : 7)), Ur < 1 || !Bi[0])
                return Bi.length = 0, Gr ? (Ur -= Vr.e + 1, Bi[0] = $r[(x - Ur % x) % x], Vr.e = -Ur || 0) : Bi[0] = Vr.e = 0, Vr;
              if (br == 0 ? (Bi.length = Wr, cr = 1, Wr--) : (Bi.length = Wr + 1, cr = $r[x - br], Bi[Wr] = Ar > 0 ? d(hr / $r[Fr - Ar] % $r[Ar]) * cr : 0), Gr)
                for (; ; )
                  if (Wr == 0) {
                    for (br = 1, Ar = Bi[0]; Ar >= 10; Ar /= 10, br++) ;
                    for (Ar = Bi[0] += cr, cr = 1; Ar >= 10; Ar /= 10, cr++) ;
                    br != cr && (Vr.e++, Bi[0] == D && (Bi[0] = 1));
                    break;
                  } else {
                    if (Bi[Wr] += cr, Bi[Wr] != D) break;
                    Bi[Wr--] = 0, cr = 1;
                  }
              for (br = Bi.length; Bi[--br] === 0; Bi.pop()) ;
            }
            Vr.e > st ? Vr.c = Vr.e = null : Vr.e < Et && (Vr.c = [Vr.e = 0]);
          }
          return Vr;
        }
        function Xr(Vr) {
          var Ur, Sr = Vr.e;
          return Sr === null ? Vr.toString() : (Ur = fe(Vr.c), Ur = Sr <= xe || Sr >= Ne ? Se(Ur, Sr) : ze(Ur, Sr, "0"), Vr.s < 0 ? "-" + Ur : Ur);
        }
        return Fe.absoluteValue = Fe.abs = function() {
          var Vr = new wr(this);
          return Vr.s < 0 && (Vr.s = 1), Vr;
        }, Fe.comparedTo = function(Vr, Ur) {
          return ge(this, new wr(Vr, Ur));
        }, Fe.decimalPlaces = Fe.dp = function(Vr, Ur) {
          var Sr, Gr, Fr, br = this;
          if (Vr != null)
            return Ie(Vr, 0, U), Ur == null ? Ur = ke : Ie(Ur, 0, 8), Qr(new wr(br), Vr + br.e + 1, Ur);
          if (!(Sr = br.c)) return null;
          if (Gr = ((Fr = Sr.length - 1) - H(this.e / x)) * x, Fr = Sr[Fr]) for (; Fr % 10 == 0; Fr /= 10, Gr--) ;
          return Gr < 0 && (Gr = 0), Gr;
        }, Fe.dividedBy = Fe.div = function(Vr, Ur) {
          return Pe(this, new wr(Vr, Ur), Be, ke);
        }, Fe.dividedToIntegerBy = Fe.idiv = function(Vr, Ur) {
          return Pe(this, new wr(Vr, Ur), 0, 1);
        }, Fe.exponentiatedBy = Fe.pow = function(Vr, Ur) {
          var Sr, Gr, Fr, br, Ar, cr, hr, Wr, fi, Bi = this;
          if (Vr = new wr(Vr), Vr.c && !Vr.isInteger())
            throw Error(E + "Exponent not an integer: " + Xr(Vr));
          if (Ur != null && (Ur = new wr(Ur)), cr = Vr.e > 14, !Bi.c || !Bi.c[0] || Bi.c[0] == 1 && !Bi.e && Bi.c.length == 1 || !Vr.c || !Vr.c[0])
            return fi = new wr(Math.pow(+Xr(Bi), cr ? Vr.s * (2 - Ee(Vr)) : +Xr(Vr))), Ur ? fi.mod(Ur) : fi;
          if (hr = Vr.s < 0, Ur) {
            if (Ur.c ? !Ur.c[0] : !Ur.s) return new wr(NaN);
            Gr = !hr && Bi.isInteger() && Ur.isInteger(), Gr && (Bi = Bi.mod(Ur));
          } else {
            if (Vr.e > 9 && (Bi.e > 0 || Bi.e < -1 || (Bi.e == 0 ? Bi.c[0] > 1 || cr && Bi.c[1] >= 24e7 : Bi.c[0] < 8e13 || cr && Bi.c[0] <= 9999975e7)))
              return br = Bi.s < 0 && Ee(Vr) ? -0 : 0, Bi.e > -1 && (br = 1 / br), new wr(hr ? 1 / br : br);
            xt && (br = t(xt / x + 2));
          }
          for (cr ? (Sr = new wr(0.5), hr && (Vr.s = 1), Wr = Ee(Vr)) : (Fr = Math.abs(+Xr(Vr)), Wr = Fr % 2), fi = new wr(be); ; ) {
            if (Wr) {
              if (fi = fi.times(Bi), !fi.c) break;
              br ? fi.c.length > br && (fi.c.length = br) : Gr && (fi = fi.mod(Ur));
            }
            if (Fr) {
              if (Fr = d(Fr / 2), Fr === 0) break;
              Wr = Fr % 2;
            } else if (Vr = Vr.times(Sr), Qr(Vr, Vr.e + 1, 1), Vr.e > 14)
              Wr = Ee(Vr);
            else {
              if (Fr = +Xr(Vr), Fr === 0) break;
              Wr = Fr % 2;
            }
            Bi = Bi.times(Bi), br ? Bi.c && Bi.c.length > br && (Bi.c.length = br) : Gr && (Bi = Bi.mod(Ur));
          }
          return Gr ? fi : (hr && (fi = be.div(fi)), Ur ? fi.mod(Ur) : br ? Qr(fi, xt, ke, Ar) : fi);
        }, Fe.integerValue = function(Vr) {
          var Ur = new wr(this);
          return Vr == null ? Vr = ke : Ie(Vr, 0, 8), Qr(Ur, Ur.e + 1, Vr);
        }, Fe.isEqualTo = Fe.eq = function(Vr, Ur) {
          return ge(this, new wr(Vr, Ur)) === 0;
        }, Fe.isFinite = function() {
          return !!this.c;
        }, Fe.isGreaterThan = Fe.gt = function(Vr, Ur) {
          return ge(this, new wr(Vr, Ur)) > 0;
        }, Fe.isGreaterThanOrEqualTo = Fe.gte = function(Vr, Ur) {
          return (Ur = ge(this, new wr(Vr, Ur))) === 1 || Ur === 0;
        }, Fe.isInteger = function() {
          return !!this.c && H(this.e / x) > this.c.length - 2;
        }, Fe.isLessThan = Fe.lt = function(Vr, Ur) {
          return ge(this, new wr(Vr, Ur)) < 0;
        }, Fe.isLessThanOrEqualTo = Fe.lte = function(Vr, Ur) {
          return (Ur = ge(this, new wr(Vr, Ur))) === -1 || Ur === 0;
        }, Fe.isNaN = function() {
          return !this.s;
        }, Fe.isNegative = function() {
          return this.s < 0;
        }, Fe.isPositive = function() {
          return this.s > 0;
        }, Fe.isZero = function() {
          return !!this.c && this.c[0] == 0;
        }, Fe.minus = function(Vr, Ur) {
          var Sr, Gr, Fr, br, Ar = this, cr = Ar.s;
          if (Vr = new wr(Vr, Ur), Ur = Vr.s, !cr || !Ur) return new wr(NaN);
          if (cr != Ur)
            return Vr.s = -Ur, Ar.plus(Vr);
          var hr = Ar.e / x, Wr = Vr.e / x, fi = Ar.c, Bi = Vr.c;
          if (!hr || !Wr) {
            if (!fi || !Bi) return fi ? (Vr.s = -Ur, Vr) : new wr(Bi ? Ar : NaN);
            if (!fi[0] || !Bi[0])
              return Bi[0] ? (Vr.s = -Ur, Vr) : new wr(fi[0] ? Ar : (
                // IEEE 754 (2008) 6.3: n - n = -0 when rounding to -Infinity
                ke == 3 ? -0 : 0
              ));
          }
          if (hr = H(hr), Wr = H(Wr), fi = fi.slice(), cr = hr - Wr) {
            for ((br = cr < 0) ? (cr = -cr, Fr = fi) : (Wr = hr, Fr = Bi), Fr.reverse(), Ur = cr; Ur--; Fr.push(0)) ;
            Fr.reverse();
          } else
            for (Gr = (br = (cr = fi.length) < (Ur = Bi.length)) ? cr : Ur, cr = Ur = 0; Ur < Gr; Ur++)
              if (fi[Ur] != Bi[Ur]) {
                br = fi[Ur] < Bi[Ur];
                break;
              }
          if (br && (Fr = fi, fi = Bi, Bi = Fr, Vr.s = -Vr.s), Ur = (Gr = Bi.length) - (Sr = fi.length), Ur > 0) for (; Ur--; fi[Sr++] = 0) ;
          for (Ur = D - 1; Gr > cr; ) {
            if (fi[--Gr] < Bi[Gr]) {
              for (Sr = Gr; Sr && !fi[--Sr]; fi[Sr] = Ur) ;
              --fi[Sr], fi[Gr] += D;
            }
            fi[Gr] -= Bi[Gr];
          }
          for (; fi[0] == 0; fi.splice(0, 1), --Wr) ;
          return fi[0] ? Dr(Vr, fi, Wr) : (Vr.s = ke == 3 ? -1 : 1, Vr.c = [Vr.e = 0], Vr);
        }, Fe.modulo = Fe.mod = function(Vr, Ur) {
          var Sr, Gr, Fr = this;
          return Vr = new wr(Vr, Ur), !Fr.c || !Vr.s || Vr.c && !Vr.c[0] ? new wr(NaN) : !Vr.c || Fr.c && !Fr.c[0] ? new wr(Fr) : (er == 9 ? (Gr = Vr.s, Vr.s = 1, Sr = Pe(Fr, Vr, 0, 3), Vr.s = Gr, Sr.s *= Gr) : Sr = Pe(Fr, Vr, 0, er), Vr = Fr.minus(Sr.times(Vr)), !Vr.c[0] && er == 1 && (Vr.s = Fr.s), Vr);
        }, Fe.multipliedBy = Fe.times = function(Vr, Ur) {
          var Sr, Gr, Fr, br, Ar, cr, hr, Wr, fi, Bi, $r, oi, zr, ti, Lr, Rr = this, Ir = Rr.c, pr = (Vr = new wr(Vr, Ur)).c;
          if (!Ir || !pr || !Ir[0] || !pr[0])
            return !Rr.s || !Vr.s || Ir && !Ir[0] && !pr || pr && !pr[0] && !Ir ? Vr.c = Vr.e = Vr.s = null : (Vr.s *= Rr.s, !Ir || !pr ? Vr.c = Vr.e = null : (Vr.c = [0], Vr.e = 0)), Vr;
          for (Gr = H(Rr.e / x) + H(Vr.e / x), Vr.s *= Rr.s, hr = Ir.length, Bi = pr.length, hr < Bi && (zr = Ir, Ir = pr, pr = zr, Fr = hr, hr = Bi, Bi = Fr), Fr = hr + Bi, zr = []; Fr--; zr.push(0)) ;
          for (ti = D, Lr = M, Fr = Bi; --Fr >= 0; ) {
            for (Sr = 0, $r = pr[Fr] % Lr, oi = pr[Fr] / Lr | 0, Ar = hr, br = Fr + Ar; br > Fr; )
              Wr = Ir[--Ar] % Lr, fi = Ir[Ar] / Lr | 0, cr = oi * Wr + fi * $r, Wr = $r * Wr + cr % Lr * Lr + zr[br] + Sr, Sr = (Wr / ti | 0) + (cr / Lr | 0) + oi * fi, zr[br--] = Wr % ti;
            zr[br] = Sr;
          }
          return Sr ? ++Gr : zr.splice(0, 1), Dr(Vr, zr, Gr);
        }, Fe.negated = function() {
          var Vr = new wr(this);
          return Vr.s = -Vr.s || null, Vr;
        }, Fe.plus = function(Vr, Ur) {
          var Sr, Gr = this, Fr = Gr.s;
          if (Vr = new wr(Vr, Ur), Ur = Vr.s, !Fr || !Ur) return new wr(NaN);
          if (Fr != Ur)
            return Vr.s = -Ur, Gr.minus(Vr);
          var br = Gr.e / x, Ar = Vr.e / x, cr = Gr.c, hr = Vr.c;
          if (!br || !Ar) {
            if (!cr || !hr) return new wr(Fr / 0);
            if (!cr[0] || !hr[0]) return hr[0] ? Vr : new wr(cr[0] ? Gr : Fr * 0);
          }
          if (br = H(br), Ar = H(Ar), cr = cr.slice(), Fr = br - Ar) {
            for (Fr > 0 ? (Ar = br, Sr = hr) : (Fr = -Fr, Sr = cr), Sr.reverse(); Fr--; Sr.push(0)) ;
            Sr.reverse();
          }
          for (Fr = cr.length, Ur = hr.length, Fr - Ur < 0 && (Sr = hr, hr = cr, cr = Sr, Ur = Fr), Fr = 0; Ur; )
            Fr = (cr[--Ur] = cr[Ur] + hr[Ur] + Fr) / D | 0, cr[Ur] = D === cr[Ur] ? 0 : cr[Ur] % D;
          return Fr && (cr = [Fr].concat(cr), ++Ar), Dr(Vr, cr, Ar);
        }, Fe.precision = Fe.sd = function(Vr, Ur) {
          var Sr, Gr, Fr, br = this;
          if (Vr != null && Vr !== !!Vr)
            return Ie(Vr, 1, U), Ur == null ? Ur = ke : Ie(Ur, 0, 8), Qr(new wr(br), Vr, Ur);
          if (!(Sr = br.c)) return null;
          if (Fr = Sr.length - 1, Gr = Fr * x + 1, Fr = Sr[Fr]) {
            for (; Fr % 10 == 0; Fr /= 10, Gr--) ;
            for (Fr = Sr[0]; Fr >= 10; Fr /= 10, Gr++) ;
          }
          return Vr && br.e + 1 > Gr && (Gr = br.e + 1), Gr;
        }, Fe.shiftedBy = function(Vr) {
          return Ie(Vr, -v, v), this.times("1e" + Vr);
        }, Fe.squareRoot = Fe.sqrt = function() {
          var Vr, Ur, Sr, Gr, Fr, br = this, Ar = br.c, cr = br.s, hr = br.e, Wr = Be + 4, fi = new wr("0.5");
          if (cr !== 1 || !Ar || !Ar[0])
            return new wr(!cr || cr < 0 && (!Ar || Ar[0]) ? NaN : Ar ? br : 1 / 0);
          if (cr = Math.sqrt(+Xr(br)), cr == 0 || cr == 1 / 0 ? (Ur = fe(Ar), (Ur.length + hr) % 2 == 0 && (Ur += "0"), cr = Math.sqrt(+Ur), hr = H((hr + 1) / 2) - (hr < 0 || hr % 2), cr == 1 / 0 ? Ur = "5e" + hr : (Ur = cr.toExponential(), Ur = Ur.slice(0, Ur.indexOf("e") + 1) + hr), Sr = new wr(Ur)) : Sr = new wr(cr + ""), Sr.c[0]) {
            for (hr = Sr.e, cr = hr + Wr, cr < 3 && (cr = 0); ; )
              if (Fr = Sr, Sr = fi.times(Fr.plus(Pe(br, Fr, Wr, 1))), fe(Fr.c).slice(0, cr) === (Ur = fe(Sr.c)).slice(0, cr))
                if (Sr.e < hr && --cr, Ur = Ur.slice(cr - 3, cr + 1), Ur == "9999" || !Gr && Ur == "4999") {
                  if (!Gr && (Qr(Fr, Fr.e + Be + 2, 0), Fr.times(Fr).eq(br))) {
                    Sr = Fr;
                    break;
                  }
                  Wr += 4, cr += 4, Gr = 1;
                } else {
                  (!+Ur || !+Ur.slice(1) && Ur.charAt(0) == "5") && (Qr(Sr, Sr.e + Be + 2, 1), Vr = !Sr.times(Sr).eq(br));
                  break;
                }
          }
          return Qr(Sr, Sr.e + Be + 1, ke, Vr);
        }, Fe.toExponential = function(Vr, Ur) {
          return Vr != null && (Ie(Vr, 0, U), Vr++), qr(this, Vr, Ur, 1);
        }, Fe.toFixed = function(Vr, Ur) {
          return Vr != null && (Ie(Vr, 0, U), Vr = Vr + this.e + 1), qr(this, Vr, Ur);
        }, Fe.toFormat = function(Vr, Ur, Sr) {
          var Gr, Fr = this;
          if (Sr == null)
            Vr != null && Ur && typeof Ur == "object" ? (Sr = Ur, Ur = null) : Vr && typeof Vr == "object" ? (Sr = Vr, Vr = Ur = null) : Sr = ir;
          else if (typeof Sr != "object")
            throw Error(E + "Argument not an object: " + Sr);
          if (Gr = Fr.toFixed(Vr, Ur), Fr.c) {
            var br, Ar = Gr.split("."), cr = +Sr.groupSize, hr = +Sr.secondaryGroupSize, Wr = Sr.groupSeparator || "", fi = Ar[0], Bi = Ar[1], $r = Fr.s < 0, oi = $r ? fi.slice(1) : fi, zr = oi.length;
            if (hr && (br = cr, cr = hr, hr = br, zr -= br), cr > 0 && zr > 0) {
              for (br = zr % cr || cr, fi = oi.substr(0, br); br < zr; br += cr) fi += Wr + oi.substr(br, cr);
              hr > 0 && (fi += Wr + oi.slice(br)), $r && (fi = "-" + fi);
            }
            Gr = Bi ? fi + (Sr.decimalSeparator || "") + ((hr = +Sr.fractionGroupSize) ? Bi.replace(
              new RegExp("\\d{" + hr + "}\\B", "g"),
              "$&" + (Sr.fractionGroupSeparator || "")
            ) : Bi) : fi;
          }
          return (Sr.prefix || "") + Gr + (Sr.suffix || "");
        }, Fe.toFraction = function(Vr) {
          var Ur, Sr, Gr, Fr, br, Ar, cr, hr, Wr, fi, Bi, $r, oi = this, zr = oi.c;
          if (Vr != null && (cr = new wr(Vr), !cr.isInteger() && (cr.c || cr.s !== 1) || cr.lt(be)))
            throw Error(E + "Argument " + (cr.isInteger() ? "out of range: " : "not an integer: ") + Xr(cr));
          if (!zr) return new wr(oi);
          for (Ur = new wr(be), Wr = Sr = new wr(be), Gr = hr = new wr(be), $r = fe(zr), br = Ur.e = $r.length - oi.e - 1, Ur.c[0] = F[(Ar = br % x) < 0 ? x + Ar : Ar], Vr = !Vr || cr.comparedTo(Ur) > 0 ? br > 0 ? Ur : Wr : cr, Ar = st, st = 1 / 0, cr = new wr($r), hr.c[0] = 0; fi = Pe(cr, Ur, 0, 1), Fr = Sr.plus(fi.times(Gr)), Fr.comparedTo(Vr) != 1; )
            Sr = Gr, Gr = Fr, Wr = hr.plus(fi.times(Fr = Wr)), hr = Fr, Ur = cr.minus(fi.times(Fr = Ur)), cr = Fr;
          return Fr = Pe(Vr.minus(Sr), Gr, 0, 1), hr = hr.plus(Fr.times(Wr)), Sr = Sr.plus(Fr.times(Gr)), hr.s = Wr.s = oi.s, br = br * 2, Bi = Pe(Wr, Gr, br, ke).minus(oi).abs().comparedTo(
            Pe(hr, Sr, br, ke).minus(oi).abs()
          ) < 1 ? [Wr, Gr] : [hr, Sr], st = Ar, Bi;
        }, Fe.toNumber = function() {
          return +Xr(this);
        }, Fe.toPrecision = function(Vr, Ur) {
          return Vr != null && Ie(Vr, 1, U), qr(this, Vr, Ur, 2);
        }, Fe.toString = function(Vr) {
          var Ur, Sr = this, Gr = Sr.s, Fr = Sr.e;
          return Fr === null ? Gr ? (Ur = "Infinity", Gr < 0 && (Ur = "-" + Ur)) : Ur = "NaN" : (Vr == null ? Ur = Fr <= xe || Fr >= Ne ? Se(fe(Sr.c), Fr) : ze(fe(Sr.c), Fr, "0") : Vr === 10 && yr ? (Sr = Qr(new wr(Sr), Be + Fr + 1, ke), Ur = ze(fe(Sr.c), Sr.e, "0")) : (Ie(Vr, 2, sr.length, "Base"), Ur = De(ze(fe(Sr.c), Fr, "0"), 10, Vr, Gr, !0)), Gr < 0 && Sr.c[0] && (Ur = "-" + Ur)), Ur;
        }, Fe.valueOf = Fe.toJSON = function() {
          return Xr(this);
        }, Fe._isBigNumber = !0, He != null && wr.set(He), wr;
      }
      function H(He) {
        var Pe = He | 0;
        return He > 0 || He === Pe ? Pe : Pe - 1;
      }
      function fe(He) {
        for (var Pe, De, ve = 1, Fe = He.length, be = He[0] + ""; ve < Fe; ) {
          for (Pe = He[ve++] + "", De = x - Pe.length; De--; Pe = "0" + Pe) ;
          be += Pe;
        }
        for (Fe = be.length; be.charCodeAt(--Fe) === 48; ) ;
        return be.slice(0, Fe + 1 || 1);
      }
      function ge(He, Pe) {
        var De, ve, Fe = He.c, be = Pe.c, Be = He.s, ke = Pe.s, xe = He.e, Ne = Pe.e;
        if (!Be || !ke) return null;
        if (De = Fe && !Fe[0], ve = be && !be[0], De || ve) return De ? ve ? 0 : -ke : Be;
        if (Be != ke) return Be;
        if (De = Be < 0, ve = xe == Ne, !Fe || !be) return ve ? 0 : !Fe ^ De ? 1 : -1;
        if (!ve) return xe > Ne ^ De ? 1 : -1;
        for (ke = (xe = Fe.length) < (Ne = be.length) ? xe : Ne, Be = 0; Be < ke; Be++) if (Fe[Be] != be[Be]) return Fe[Be] > be[Be] ^ De ? 1 : -1;
        return xe == Ne ? 0 : xe > Ne ^ De ? 1 : -1;
      }
      function Ie(He, Pe, De, ve) {
        if (He < Pe || He > De || He !== d(He))
          throw Error(E + (ve || "Argument") + (typeof He == "number" ? He < Pe || He > De ? " out of range: " : " not an integer: " : " not a primitive number: ") + String(He));
      }
      function Ee(He) {
        var Pe = He.c.length - 1;
        return H(He.e / x) == Pe && He.c[Pe] % 2 != 0;
      }
      function Se(He, Pe) {
        return (He.length > 1 ? He.charAt(0) + "." + He.slice(1) : He) + (Pe < 0 ? "e" : "e+") + Pe;
      }
      function ze(He, Pe, De) {
        var ve, Fe;
        if (Pe < 0) {
          for (Fe = De + "."; ++Pe; Fe += De) ;
          He = Fe + He;
        } else if (ve = He.length, ++Pe > ve) {
          for (Fe = De, Pe -= ve; --Pe; Fe += De) ;
          He += Fe;
        } else Pe < ve && (He = He.slice(0, Pe) + "." + He.slice(Pe));
        return He;
      }
      c = L(), c.default = c.BigNumber = c, o.exports ? o.exports = c : (g || (g = typeof self < "u" && self ? self : window), g.BigNumber = c);
    })(bignumber);
  }(bignumber$1)), bignumber$1.exports;
}
var jsbiUmd$1 = { exports: {} }, jsbiUmd = jsbiUmd$1.exports, hasRequiredJsbiUmd;
function requireJsbiUmd() {
  return hasRequiredJsbiUmd || (hasRequiredJsbiUmd = 1, function(o, g) {
    (function(c, y) {
      o.exports = y();
    })(jsbiUmd, function() {
      var c = Math.imul, y = Math.clz32, t = Math.abs, d = Math.max, E = Math.floor;
      class B extends Array {
        constructor(x, v) {
          if (super(x), this.sign = v, x > B.__kMaxLength) throw new RangeError("Maximum BigInt size exceeded");
        }
        static BigInt(x) {
          var v = Number.isFinite;
          if (typeof x == "number") {
            if (x === 0) return B.__zero();
            if (B.__isOneDigitInt(x)) return 0 > x ? B.__oneDigit(-x, !0) : B.__oneDigit(x, !1);
            if (!v(x) || E(x) !== x) throw new RangeError("The number " + x + " cannot be converted to BigInt because it is not an integer");
            return B.__fromDouble(x);
          }
          if (typeof x == "string") {
            const F = B.__fromString(x);
            if (F === null) throw new SyntaxError("Cannot convert " + x + " to a BigInt");
            return F;
          }
          if (typeof x == "boolean") return x === !0 ? B.__oneDigit(1, !1) : B.__zero();
          if (typeof x == "object") {
            if (x.constructor === B) return x;
            const F = B.__toPrimitive(x);
            return B.BigInt(F);
          }
          throw new TypeError("Cannot convert " + x + " to a BigInt");
        }
        toDebugString() {
          const x = ["BigInt["];
          for (const v of this) x.push((v && (v >>> 0).toString(16)) + ", ");
          return x.push("]"), x.join("");
        }
        toString(x = 10) {
          if (2 > x || 36 < x) throw new RangeError("toString() radix argument must be between 2 and 36");
          return this.length === 0 ? "0" : (x & x - 1) == 0 ? B.__toStringBasePowerOfTwo(this, x) : B.__toStringGeneric(this, x, !1);
        }
        static toNumber(x) {
          const v = x.length;
          if (v === 0) return 0;
          if (v === 1) {
            const De = x.__unsignedDigit(0);
            return x.sign ? -De : De;
          }
          const F = x.__digit(v - 1), M = B.__clz30(F), U = 30 * v - M;
          if (1024 < U) return x.sign ? -1 / 0 : 1 / 0;
          let L = U - 1, H = F, fe = v - 1;
          const ge = M + 3;
          let Ie = ge === 32 ? 0 : H << ge;
          Ie >>>= 12;
          const Ee = ge - 12;
          let Se = 12 <= ge ? 0 : H << 20 + ge, ze = 20 + ge;
          for (0 < Ee && 0 < fe && (fe--, H = x.__digit(fe), Ie |= H >>> 30 - Ee, Se = H << Ee + 2, ze = Ee + 2); 0 < ze && 0 < fe; ) fe--, H = x.__digit(fe), Se |= 30 <= ze ? H << ze - 30 : H >>> 30 - ze, ze -= 30;
          const He = B.__decideRounding(x, ze, fe, H);
          if ((He === 1 || He === 0 && (1 & Se) == 1) && (Se = Se + 1 >>> 0, Se === 0 && (Ie++, Ie >>> 20 != 0 && (Ie = 0, L++, 1023 < L)))) return x.sign ? -1 / 0 : 1 / 0;
          const Pe = x.sign ? -2147483648 : 0;
          return L = L + 1023 << 20, B.__kBitConversionInts[1] = Pe | L | Ie, B.__kBitConversionInts[0] = Se, B.__kBitConversionDouble[0];
        }
        static unaryMinus(x) {
          if (x.length === 0) return x;
          const v = x.__copy();
          return v.sign = !x.sign, v;
        }
        static bitwiseNot(x) {
          return x.sign ? B.__absoluteSubOne(x).__trim() : B.__absoluteAddOne(x, !0);
        }
        static exponentiate(x, v) {
          if (v.sign) throw new RangeError("Exponent must be positive");
          if (v.length === 0) return B.__oneDigit(1, !1);
          if (x.length === 0) return x;
          if (x.length === 1 && x.__digit(0) === 1) return x.sign && (1 & v.__digit(0)) == 0 ? B.unaryMinus(x) : x;
          if (1 < v.length) throw new RangeError("BigInt too big");
          let F = v.__unsignedDigit(0);
          if (F === 1) return x;
          if (F >= B.__kMaxLengthBits) throw new RangeError("BigInt too big");
          if (x.length === 1 && x.__digit(0) === 2) {
            const L = 1 + (0 | F / 30), H = x.sign && (1 & F) != 0, fe = new B(L, H);
            fe.__initializeDigits();
            const ge = 1 << F % 30;
            return fe.__setDigit(L - 1, ge), fe;
          }
          let M = null, U = x;
          for ((1 & F) != 0 && (M = x), F >>= 1; F !== 0; F >>= 1) U = B.multiply(U, U), (1 & F) != 0 && (M === null ? M = U : M = B.multiply(M, U));
          return M;
        }
        static multiply(x, v) {
          if (x.length === 0) return x;
          if (v.length === 0) return v;
          let F = x.length + v.length;
          30 <= x.__clzmsd() + v.__clzmsd() && F--;
          const M = new B(F, x.sign !== v.sign);
          M.__initializeDigits();
          for (let U = 0; U < x.length; U++) B.__multiplyAccumulate(v, x.__digit(U), M, U);
          return M.__trim();
        }
        static divide(x, v) {
          if (v.length === 0) throw new RangeError("Division by zero");
          if (0 > B.__absoluteCompare(x, v)) return B.__zero();
          const F = x.sign !== v.sign, M = v.__unsignedDigit(0);
          let U;
          if (v.length === 1 && 32767 >= M) {
            if (M === 1) return F === x.sign ? x : B.unaryMinus(x);
            U = B.__absoluteDivSmall(x, M, null);
          } else U = B.__absoluteDivLarge(x, v, !0, !1);
          return U.sign = F, U.__trim();
        }
        static remainder(x, v) {
          if (v.length === 0) throw new RangeError("Division by zero");
          if (0 > B.__absoluteCompare(x, v)) return x;
          const F = v.__unsignedDigit(0);
          if (v.length === 1 && 32767 >= F) {
            if (F === 1) return B.__zero();
            const U = B.__absoluteModSmall(x, F);
            return U === 0 ? B.__zero() : B.__oneDigit(U, x.sign);
          }
          const M = B.__absoluteDivLarge(x, v, !1, !0);
          return M.sign = x.sign, M.__trim();
        }
        static add(x, v) {
          const F = x.sign;
          return F === v.sign ? B.__absoluteAdd(x, v, F) : 0 <= B.__absoluteCompare(x, v) ? B.__absoluteSub(x, v, F) : B.__absoluteSub(v, x, !F);
        }
        static subtract(x, v) {
          const F = x.sign;
          return F === v.sign ? 0 <= B.__absoluteCompare(x, v) ? B.__absoluteSub(x, v, F) : B.__absoluteSub(v, x, !F) : B.__absoluteAdd(x, v, F);
        }
        static leftShift(x, v) {
          return v.length === 0 || x.length === 0 ? x : v.sign ? B.__rightShiftByAbsolute(x, v) : B.__leftShiftByAbsolute(x, v);
        }
        static signedRightShift(x, v) {
          return v.length === 0 || x.length === 0 ? x : v.sign ? B.__leftShiftByAbsolute(x, v) : B.__rightShiftByAbsolute(x, v);
        }
        static unsignedRightShift() {
          throw new TypeError("BigInts have no unsigned right shift; use >> instead");
        }
        static lessThan(x, v) {
          return 0 > B.__compareToBigInt(x, v);
        }
        static lessThanOrEqual(x, v) {
          return 0 >= B.__compareToBigInt(x, v);
        }
        static greaterThan(x, v) {
          return 0 < B.__compareToBigInt(x, v);
        }
        static greaterThanOrEqual(x, v) {
          return 0 <= B.__compareToBigInt(x, v);
        }
        static equal(x, v) {
          if (x.sign !== v.sign || x.length !== v.length) return !1;
          for (let F = 0; F < x.length; F++) if (x.__digit(F) !== v.__digit(F)) return !1;
          return !0;
        }
        static notEqual(x, v) {
          return !B.equal(x, v);
        }
        static bitwiseAnd(x, v) {
          if (!x.sign && !v.sign) return B.__absoluteAnd(x, v).__trim();
          if (x.sign && v.sign) {
            const F = d(x.length, v.length) + 1;
            let M = B.__absoluteSubOne(x, F);
            const U = B.__absoluteSubOne(v);
            return M = B.__absoluteOr(M, U, M), B.__absoluteAddOne(M, !0, M).__trim();
          }
          return x.sign && ([x, v] = [v, x]), B.__absoluteAndNot(x, B.__absoluteSubOne(v)).__trim();
        }
        static bitwiseXor(x, v) {
          if (!x.sign && !v.sign) return B.__absoluteXor(x, v).__trim();
          if (x.sign && v.sign) {
            const U = d(x.length, v.length), L = B.__absoluteSubOne(x, U), H = B.__absoluteSubOne(v);
            return B.__absoluteXor(L, H, L).__trim();
          }
          const F = d(x.length, v.length) + 1;
          x.sign && ([x, v] = [v, x]);
          let M = B.__absoluteSubOne(v, F);
          return M = B.__absoluteXor(M, x, M), B.__absoluteAddOne(M, !0, M).__trim();
        }
        static bitwiseOr(x, v) {
          const F = d(x.length, v.length);
          if (!x.sign && !v.sign) return B.__absoluteOr(x, v).__trim();
          if (x.sign && v.sign) {
            let U = B.__absoluteSubOne(x, F);
            const L = B.__absoluteSubOne(v);
            return U = B.__absoluteAnd(U, L, U), B.__absoluteAddOne(U, !0, U).__trim();
          }
          x.sign && ([x, v] = [v, x]);
          let M = B.__absoluteSubOne(v, F);
          return M = B.__absoluteAndNot(M, x, M), B.__absoluteAddOne(M, !0, M).__trim();
        }
        static asIntN(x, v) {
          if (v.length === 0) return v;
          if (x = E(x), 0 > x) throw new RangeError("Invalid value: not (convertible to) a safe integer");
          if (x === 0) return B.__zero();
          if (x >= B.__kMaxLengthBits) return v;
          const F = 0 | (x + 29) / 30;
          if (v.length < F) return v;
          const M = v.__unsignedDigit(F - 1), U = 1 << (x - 1) % 30;
          if (v.length === F && M < U) return v;
          if ((M & U) !== U) return B.__truncateToNBits(x, v);
          if (!v.sign) return B.__truncateAndSubFromPowerOfTwo(x, v, !0);
          if ((M & U - 1) == 0) {
            for (let L = F - 2; 0 <= L; L--) if (v.__digit(L) !== 0) return B.__truncateAndSubFromPowerOfTwo(x, v, !1);
            return v.length === F && M === U ? v : B.__truncateToNBits(x, v);
          }
          return B.__truncateAndSubFromPowerOfTwo(x, v, !1);
        }
        static asUintN(x, v) {
          if (v.length === 0) return v;
          if (x = E(x), 0 > x) throw new RangeError("Invalid value: not (convertible to) a safe integer");
          if (x === 0) return B.__zero();
          if (v.sign) {
            if (x > B.__kMaxLengthBits) throw new RangeError("BigInt too big");
            return B.__truncateAndSubFromPowerOfTwo(x, v, !1);
          }
          if (x >= B.__kMaxLengthBits) return v;
          const F = 0 | (x + 29) / 30;
          if (v.length < F) return v;
          const M = x % 30;
          return v.length == F && (M === 0 || !(v.__digit(F - 1) >>> M)) ? v : B.__truncateToNBits(x, v);
        }
        static ADD(x, v) {
          if (x = B.__toPrimitive(x), v = B.__toPrimitive(v), typeof x == "string") return typeof v != "string" && (v = v.toString()), x + v;
          if (typeof v == "string") return x.toString() + v;
          if (x = B.__toNumeric(x), v = B.__toNumeric(v), B.__isBigInt(x) && B.__isBigInt(v)) return B.add(x, v);
          if (typeof x == "number" && typeof v == "number") return x + v;
          throw new TypeError("Cannot mix BigInt and other types, use explicit conversions");
        }
        static LT(x, v) {
          return B.__compare(x, v, 0);
        }
        static LE(x, v) {
          return B.__compare(x, v, 1);
        }
        static GT(x, v) {
          return B.__compare(x, v, 2);
        }
        static GE(x, v) {
          return B.__compare(x, v, 3);
        }
        static EQ(x, v) {
          for (; ; ) {
            if (B.__isBigInt(x)) return B.__isBigInt(v) ? B.equal(x, v) : B.EQ(v, x);
            if (typeof x == "number") {
              if (B.__isBigInt(v)) return B.__equalToNumber(v, x);
              if (typeof v != "object") return x == v;
              v = B.__toPrimitive(v);
            } else if (typeof x == "string") {
              if (B.__isBigInt(v)) return x = B.__fromString(x), x !== null && B.equal(x, v);
              if (typeof v != "object") return x == v;
              v = B.__toPrimitive(v);
            } else if (typeof x == "boolean") {
              if (B.__isBigInt(v)) return B.__equalToNumber(v, +x);
              if (typeof v != "object") return x == v;
              v = B.__toPrimitive(v);
            } else if (typeof x == "symbol") {
              if (B.__isBigInt(v)) return !1;
              if (typeof v != "object") return x == v;
              v = B.__toPrimitive(v);
            } else if (typeof x == "object") {
              if (typeof v == "object" && v.constructor !== B) return x == v;
              x = B.__toPrimitive(x);
            } else return x == v;
          }
        }
        static NE(x, v) {
          return !B.EQ(x, v);
        }
        static __zero() {
          return new B(0, !1);
        }
        static __oneDigit(x, v) {
          const F = new B(1, v);
          return F.__setDigit(0, x), F;
        }
        __copy() {
          const x = new B(this.length, this.sign);
          for (let v = 0; v < this.length; v++) x[v] = this[v];
          return x;
        }
        __trim() {
          let x = this.length, v = this[x - 1];
          for (; v === 0; ) x--, v = this[x - 1], this.pop();
          return x === 0 && (this.sign = !1), this;
        }
        __initializeDigits() {
          for (let x = 0; x < this.length; x++) this[x] = 0;
        }
        static __decideRounding(x, v, F, M) {
          if (0 < v) return -1;
          let U;
          if (0 > v) U = -v - 1;
          else {
            if (F === 0) return -1;
            F--, M = x.__digit(F), U = 29;
          }
          let L = 1 << U;
          if ((M & L) == 0) return -1;
          if (L -= 1, (M & L) != 0) return 1;
          for (; 0 < F; ) if (F--, x.__digit(F) !== 0) return 1;
          return 0;
        }
        static __fromDouble(x) {
          B.__kBitConversionDouble[0] = x;
          const v = 2047 & B.__kBitConversionInts[1] >>> 20, F = v - 1023, M = (0 | F / 30) + 1, U = new B(M, 0 > x);
          let L = 1048575 & B.__kBitConversionInts[1] | 1048576, H = B.__kBitConversionInts[0];
          const fe = 20, ge = F % 30;
          let Ie, Ee = 0;
          if (20 > ge) {
            const Se = fe - ge;
            Ee = Se + 32, Ie = L >>> Se, L = L << 32 - Se | H >>> Se, H <<= 32 - Se;
          } else if (ge === 20) Ee = 32, Ie = L, L = H, H = 0;
          else {
            const Se = ge - fe;
            Ee = 32 - Se, Ie = L << Se | H >>> 32 - Se, L = H << Se, H = 0;
          }
          U.__setDigit(M - 1, Ie);
          for (let Se = M - 2; 0 <= Se; Se--) 0 < Ee ? (Ee -= 30, Ie = L >>> 2, L = L << 30 | H >>> 2, H <<= 30) : Ie = 0, U.__setDigit(Se, Ie);
          return U.__trim();
        }
        static __isWhitespace(x) {
          return 13 >= x && 9 <= x || (159 >= x ? x == 32 : 131071 >= x ? x == 160 || x == 5760 : 196607 >= x ? (x &= 131071, 10 >= x || x == 40 || x == 41 || x == 47 || x == 95 || x == 4096) : x == 65279);
        }
        static __fromString(x, v = 0) {
          let F = 0;
          const M = x.length;
          let U = 0;
          if (U === M) return B.__zero();
          let L = x.charCodeAt(U);
          for (; B.__isWhitespace(L); ) {
            if (++U === M) return B.__zero();
            L = x.charCodeAt(U);
          }
          if (L === 43) {
            if (++U === M) return null;
            L = x.charCodeAt(U), F = 1;
          } else if (L === 45) {
            if (++U === M) return null;
            L = x.charCodeAt(U), F = -1;
          }
          if (v === 0) {
            if (v = 10, L === 48) {
              if (++U === M) return B.__zero();
              if (L = x.charCodeAt(U), L === 88 || L === 120) {
                if (v = 16, ++U === M) return null;
                L = x.charCodeAt(U);
              } else if (L === 79 || L === 111) {
                if (v = 8, ++U === M) return null;
                L = x.charCodeAt(U);
              } else if (L === 66 || L === 98) {
                if (v = 2, ++U === M) return null;
                L = x.charCodeAt(U);
              }
            }
          } else if (v === 16 && L === 48) {
            if (++U === M) return B.__zero();
            if (L = x.charCodeAt(U), L === 88 || L === 120) {
              if (++U === M) return null;
              L = x.charCodeAt(U);
            }
          }
          if (F != 0 && v !== 10) return null;
          for (; L === 48; ) {
            if (++U === M) return B.__zero();
            L = x.charCodeAt(U);
          }
          const H = M - U;
          let fe = B.__kMaxBitsPerChar[v], ge = B.__kBitsPerCharTableMultiplier - 1;
          if (H > 1073741824 / fe) return null;
          const Ie = fe * H + ge >>> B.__kBitsPerCharTableShift, Ee = new B(0 | (Ie + 29) / 30, !1), Se = 10 > v ? v : 10, ze = 10 < v ? v - 10 : 0;
          if ((v & v - 1) == 0) {
            fe >>= B.__kBitsPerCharTableShift;
            const He = [], Pe = [];
            let De = !1;
            do {
              let ve = 0, Fe = 0;
              for (; ; ) {
                let be;
                if (L - 48 >>> 0 < Se) be = L - 48;
                else if ((32 | L) - 97 >>> 0 < ze) be = (32 | L) - 87;
                else {
                  De = !0;
                  break;
                }
                if (Fe += fe, ve = ve << fe | be, ++U === M) {
                  De = !0;
                  break;
                }
                if (L = x.charCodeAt(U), 30 < Fe + fe) break;
              }
              He.push(ve), Pe.push(Fe);
            } while (!De);
            B.__fillFromParts(Ee, He, Pe);
          } else {
            Ee.__initializeDigits();
            let He = !1, Pe = 0;
            do {
              let De = 0, ve = 1;
              for (; ; ) {
                let be;
                if (L - 48 >>> 0 < Se) be = L - 48;
                else if ((32 | L) - 97 >>> 0 < ze) be = (32 | L) - 87;
                else {
                  He = !0;
                  break;
                }
                const Be = ve * v;
                if (1073741823 < Be) break;
                if (ve = Be, De = De * v + be, Pe++, ++U === M) {
                  He = !0;
                  break;
                }
                L = x.charCodeAt(U);
              }
              ge = 30 * B.__kBitsPerCharTableMultiplier - 1;
              const Fe = 0 | (fe * Pe + ge >>> B.__kBitsPerCharTableShift) / 30;
              Ee.__inplaceMultiplyAdd(ve, De, Fe);
            } while (!He);
          }
          if (U !== M) {
            if (!B.__isWhitespace(L)) return null;
            for (U++; U < M; U++) if (L = x.charCodeAt(U), !B.__isWhitespace(L)) return null;
          }
          return Ee.sign = F == -1, Ee.__trim();
        }
        static __fillFromParts(x, v, F) {
          let M = 0, U = 0, L = 0;
          for (let H = v.length - 1; 0 <= H; H--) {
            const fe = v[H], ge = F[H];
            U |= fe << L, L += ge, L === 30 ? (x.__setDigit(M++, U), L = 0, U = 0) : 30 < L && (x.__setDigit(M++, 1073741823 & U), L -= 30, U = fe >>> ge - L);
          }
          if (U !== 0) {
            if (M >= x.length) throw new Error("implementation bug");
            x.__setDigit(M++, U);
          }
          for (; M < x.length; M++) x.__setDigit(M, 0);
        }
        static __toStringBasePowerOfTwo(x, v) {
          const F = x.length;
          let M = v - 1;
          M = (85 & M >>> 1) + (85 & M), M = (51 & M >>> 2) + (51 & M), M = (15 & M >>> 4) + (15 & M);
          const U = M, L = v - 1, H = x.__digit(F - 1), fe = B.__clz30(H);
          let ge = 0 | (30 * F - fe + U - 1) / U;
          if (x.sign && ge++, 268435456 < ge) throw new Error("string too long");
          const Ie = Array(ge);
          let Ee = ge - 1, Se = 0, ze = 0;
          for (let Pe = 0; Pe < F - 1; Pe++) {
            const De = x.__digit(Pe), ve = (Se | De << ze) & L;
            Ie[Ee--] = B.__kConversionChars[ve];
            const Fe = U - ze;
            for (Se = De >>> Fe, ze = 30 - Fe; ze >= U; ) Ie[Ee--] = B.__kConversionChars[Se & L], Se >>>= U, ze -= U;
          }
          const He = (Se | H << ze) & L;
          for (Ie[Ee--] = B.__kConversionChars[He], Se = H >>> U - ze; Se !== 0; ) Ie[Ee--] = B.__kConversionChars[Se & L], Se >>>= U;
          if (x.sign && (Ie[Ee--] = "-"), Ee != -1) throw new Error("implementation bug");
          return Ie.join("");
        }
        static __toStringGeneric(x, v, F) {
          const M = x.length;
          if (M === 0) return "";
          if (M === 1) {
            let Pe = x.__unsignedDigit(0).toString(v);
            return F === !1 && x.sign && (Pe = "-" + Pe), Pe;
          }
          const U = 30 * M - B.__clz30(x.__digit(M - 1)), L = B.__kMaxBitsPerChar[v], H = L - 1;
          let fe = U * B.__kBitsPerCharTableMultiplier;
          fe += H - 1, fe = 0 | fe / H;
          const ge = fe + 1 >> 1, Ie = B.exponentiate(B.__oneDigit(v, !1), B.__oneDigit(ge, !1));
          let Ee, Se;
          const ze = Ie.__unsignedDigit(0);
          if (Ie.length === 1 && 32767 >= ze) {
            Ee = new B(x.length, !1), Ee.__initializeDigits();
            let Pe = 0;
            for (let De = 2 * x.length - 1; 0 <= De; De--) {
              const ve = Pe << 15 | x.__halfDigit(De);
              Ee.__setHalfDigit(De, 0 | ve / ze), Pe = 0 | ve % ze;
            }
            Se = Pe.toString(v);
          } else {
            const Pe = B.__absoluteDivLarge(x, Ie, !0, !0);
            Ee = Pe.quotient;
            const De = Pe.remainder.__trim();
            Se = B.__toStringGeneric(De, v, !0);
          }
          Ee.__trim();
          let He = B.__toStringGeneric(Ee, v, !0);
          for (; Se.length < ge; ) Se = "0" + Se;
          return F === !1 && x.sign && (He = "-" + He), He + Se;
        }
        static __unequalSign(x) {
          return x ? -1 : 1;
        }
        static __absoluteGreater(x) {
          return x ? -1 : 1;
        }
        static __absoluteLess(x) {
          return x ? 1 : -1;
        }
        static __compareToBigInt(x, v) {
          const F = x.sign;
          if (F !== v.sign) return B.__unequalSign(F);
          const M = B.__absoluteCompare(x, v);
          return 0 < M ? B.__absoluteGreater(F) : 0 > M ? B.__absoluteLess(F) : 0;
        }
        static __compareToNumber(x, v) {
          if (B.__isOneDigitInt(v)) {
            const F = x.sign, M = 0 > v;
            if (F !== M) return B.__unequalSign(F);
            if (x.length === 0) {
              if (M) throw new Error("implementation bug");
              return v === 0 ? 0 : -1;
            }
            if (1 < x.length) return B.__absoluteGreater(F);
            const U = t(v), L = x.__unsignedDigit(0);
            return L > U ? B.__absoluteGreater(F) : L < U ? B.__absoluteLess(F) : 0;
          }
          return B.__compareToDouble(x, v);
        }
        static __compareToDouble(x, v) {
          if (v !== v) return v;
          if (v === 1 / 0) return -1;
          if (v === -1 / 0) return 1;
          const F = x.sign;
          if (F !== 0 > v) return B.__unequalSign(F);
          if (v === 0) throw new Error("implementation bug: should be handled elsewhere");
          if (x.length === 0) return -1;
          B.__kBitConversionDouble[0] = v;
          const M = 2047 & B.__kBitConversionInts[1] >>> 20;
          if (M == 2047) throw new Error("implementation bug: handled elsewhere");
          const U = M - 1023;
          if (0 > U) return B.__absoluteGreater(F);
          const L = x.length;
          let H = x.__digit(L - 1);
          const fe = B.__clz30(H), ge = 30 * L - fe, Ie = U + 1;
          if (ge < Ie) return B.__absoluteLess(F);
          if (ge > Ie) return B.__absoluteGreater(F);
          let Ee = 1048576 | 1048575 & B.__kBitConversionInts[1], Se = B.__kBitConversionInts[0];
          const ze = 20, He = 29 - fe;
          if (He !== (0 | (ge - 1) % 30)) throw new Error("implementation bug");
          let Pe, De = 0;
          if (20 > He) {
            const ve = ze - He;
            De = ve + 32, Pe = Ee >>> ve, Ee = Ee << 32 - ve | Se >>> ve, Se <<= 32 - ve;
          } else if (He === 20) De = 32, Pe = Ee, Ee = Se, Se = 0;
          else {
            const ve = He - ze;
            De = 32 - ve, Pe = Ee << ve | Se >>> 32 - ve, Ee = Se << ve, Se = 0;
          }
          if (H >>>= 0, Pe >>>= 0, H > Pe) return B.__absoluteGreater(F);
          if (H < Pe) return B.__absoluteLess(F);
          for (let ve = L - 2; 0 <= ve; ve--) {
            0 < De ? (De -= 30, Pe = Ee >>> 2, Ee = Ee << 30 | Se >>> 2, Se <<= 30) : Pe = 0;
            const Fe = x.__unsignedDigit(ve);
            if (Fe > Pe) return B.__absoluteGreater(F);
            if (Fe < Pe) return B.__absoluteLess(F);
          }
          if (Ee !== 0 || Se !== 0) {
            if (De === 0) throw new Error("implementation bug");
            return B.__absoluteLess(F);
          }
          return 0;
        }
        static __equalToNumber(x, v) {
          return B.__isOneDigitInt(v) ? v === 0 ? x.length === 0 : x.length === 1 && x.sign === 0 > v && x.__unsignedDigit(0) === t(v) : B.__compareToDouble(x, v) === 0;
        }
        static __comparisonResultToBool(x, v) {
          return v === 0 ? 0 > x : v === 1 ? 0 >= x : v === 2 ? 0 < x : v === 3 ? 0 <= x : void 0;
        }
        static __compare(x, v, F) {
          if (x = B.__toPrimitive(x), v = B.__toPrimitive(v), typeof x == "string" && typeof v == "string") switch (F) {
            case 0:
              return x < v;
            case 1:
              return x <= v;
            case 2:
              return x > v;
            case 3:
              return x >= v;
          }
          if (B.__isBigInt(x) && typeof v == "string") return v = B.__fromString(v), v !== null && B.__comparisonResultToBool(B.__compareToBigInt(x, v), F);
          if (typeof x == "string" && B.__isBigInt(v)) return x = B.__fromString(x), x !== null && B.__comparisonResultToBool(B.__compareToBigInt(x, v), F);
          if (x = B.__toNumeric(x), v = B.__toNumeric(v), B.__isBigInt(x)) {
            if (B.__isBigInt(v)) return B.__comparisonResultToBool(B.__compareToBigInt(x, v), F);
            if (typeof v != "number") throw new Error("implementation bug");
            return B.__comparisonResultToBool(B.__compareToNumber(x, v), F);
          }
          if (typeof x != "number") throw new Error("implementation bug");
          if (B.__isBigInt(v)) return B.__comparisonResultToBool(B.__compareToNumber(v, x), 2 ^ F);
          if (typeof v != "number") throw new Error("implementation bug");
          return F === 0 ? x < v : F === 1 ? x <= v : F === 2 ? x > v : F === 3 ? x >= v : void 0;
        }
        __clzmsd() {
          return B.__clz30(this.__digit(this.length - 1));
        }
        static __absoluteAdd(x, v, F) {
          if (x.length < v.length) return B.__absoluteAdd(v, x, F);
          if (x.length === 0) return x;
          if (v.length === 0) return x.sign === F ? x : B.unaryMinus(x);
          let M = x.length;
          (x.__clzmsd() === 0 || v.length === x.length && v.__clzmsd() === 0) && M++;
          const U = new B(M, F);
          let L = 0, H = 0;
          for (; H < v.length; H++) {
            const fe = x.__digit(H) + v.__digit(H) + L;
            L = fe >>> 30, U.__setDigit(H, 1073741823 & fe);
          }
          for (; H < x.length; H++) {
            const fe = x.__digit(H) + L;
            L = fe >>> 30, U.__setDigit(H, 1073741823 & fe);
          }
          return H < U.length && U.__setDigit(H, L), U.__trim();
        }
        static __absoluteSub(x, v, F) {
          if (x.length === 0) return x;
          if (v.length === 0) return x.sign === F ? x : B.unaryMinus(x);
          const M = new B(x.length, F);
          let U = 0, L = 0;
          for (; L < v.length; L++) {
            const H = x.__digit(L) - v.__digit(L) - U;
            U = 1 & H >>> 30, M.__setDigit(L, 1073741823 & H);
          }
          for (; L < x.length; L++) {
            const H = x.__digit(L) - U;
            U = 1 & H >>> 30, M.__setDigit(L, 1073741823 & H);
          }
          return M.__trim();
        }
        static __absoluteAddOne(x, v, F = null) {
          const M = x.length;
          F === null ? F = new B(M, v) : F.sign = v;
          let U = 1;
          for (let L = 0; L < M; L++) {
            const H = x.__digit(L) + U;
            U = H >>> 30, F.__setDigit(L, 1073741823 & H);
          }
          return U != 0 && F.__setDigitGrow(M, 1), F;
        }
        static __absoluteSubOne(x, v) {
          const F = x.length;
          v = v || F;
          const M = new B(v, !1);
          let U = 1;
          for (let L = 0; L < F; L++) {
            const H = x.__digit(L) - U;
            U = 1 & H >>> 30, M.__setDigit(L, 1073741823 & H);
          }
          if (U != 0) throw new Error("implementation bug");
          for (let L = F; L < v; L++) M.__setDigit(L, 0);
          return M;
        }
        static __absoluteAnd(x, v, F = null) {
          let M = x.length, U = v.length, L = U;
          if (M < U) {
            L = M;
            const ge = x, Ie = M;
            x = v, M = U, v = ge, U = Ie;
          }
          let H = L;
          F === null ? F = new B(H, !1) : H = F.length;
          let fe = 0;
          for (; fe < L; fe++) F.__setDigit(fe, x.__digit(fe) & v.__digit(fe));
          for (; fe < H; fe++) F.__setDigit(fe, 0);
          return F;
        }
        static __absoluteAndNot(x, v, F = null) {
          const M = x.length, U = v.length;
          let L = U;
          M < U && (L = M);
          let H = M;
          F === null ? F = new B(H, !1) : H = F.length;
          let fe = 0;
          for (; fe < L; fe++) F.__setDigit(fe, x.__digit(fe) & ~v.__digit(fe));
          for (; fe < M; fe++) F.__setDigit(fe, x.__digit(fe));
          for (; fe < H; fe++) F.__setDigit(fe, 0);
          return F;
        }
        static __absoluteOr(x, v, F = null) {
          let M = x.length, U = v.length, L = U;
          if (M < U) {
            L = M;
            const ge = x, Ie = M;
            x = v, M = U, v = ge, U = Ie;
          }
          let H = M;
          F === null ? F = new B(H, !1) : H = F.length;
          let fe = 0;
          for (; fe < L; fe++) F.__setDigit(fe, x.__digit(fe) | v.__digit(fe));
          for (; fe < M; fe++) F.__setDigit(fe, x.__digit(fe));
          for (; fe < H; fe++) F.__setDigit(fe, 0);
          return F;
        }
        static __absoluteXor(x, v, F = null) {
          let M = x.length, U = v.length, L = U;
          if (M < U) {
            L = M;
            const ge = x, Ie = M;
            x = v, M = U, v = ge, U = Ie;
          }
          let H = M;
          F === null ? F = new B(H, !1) : H = F.length;
          let fe = 0;
          for (; fe < L; fe++) F.__setDigit(fe, x.__digit(fe) ^ v.__digit(fe));
          for (; fe < M; fe++) F.__setDigit(fe, x.__digit(fe));
          for (; fe < H; fe++) F.__setDigit(fe, 0);
          return F;
        }
        static __absoluteCompare(x, v) {
          const F = x.length - v.length;
          if (F != 0) return F;
          let M = x.length - 1;
          for (; 0 <= M && x.__digit(M) === v.__digit(M); ) M--;
          return 0 > M ? 0 : x.__unsignedDigit(M) > v.__unsignedDigit(M) ? 1 : -1;
        }
        static __multiplyAccumulate(x, v, F, M) {
          if (v === 0) return;
          const U = 32767 & v, L = v >>> 15;
          let H = 0, fe = 0;
          for (let ge, Ie = 0; Ie < x.length; Ie++, M++) {
            ge = F.__digit(M);
            const Ee = x.__digit(Ie), Se = 32767 & Ee, ze = Ee >>> 15, He = B.__imul(Se, U), Pe = B.__imul(Se, L), De = B.__imul(ze, U), ve = B.__imul(ze, L);
            ge += fe + He + H, H = ge >>> 30, ge &= 1073741823, ge += ((32767 & Pe) << 15) + ((32767 & De) << 15), H += ge >>> 30, fe = ve + (Pe >>> 15) + (De >>> 15), F.__setDigit(M, 1073741823 & ge);
          }
          for (; H != 0 || fe !== 0; M++) {
            let ge = F.__digit(M);
            ge += H + fe, fe = 0, H = ge >>> 30, F.__setDigit(M, 1073741823 & ge);
          }
        }
        static __internalMultiplyAdd(x, v, F, M, U) {
          let L = F, H = 0;
          for (let fe = 0; fe < M; fe++) {
            const ge = x.__digit(fe), Ie = B.__imul(32767 & ge, v), Ee = B.__imul(ge >>> 15, v), Se = Ie + ((32767 & Ee) << 15) + H + L;
            L = Se >>> 30, H = Ee >>> 15, U.__setDigit(fe, 1073741823 & Se);
          }
          if (U.length > M) for (U.__setDigit(M++, L + H); M < U.length; ) U.__setDigit(M++, 0);
          else if (L + H !== 0) throw new Error("implementation bug");
        }
        __inplaceMultiplyAdd(x, v, F) {
          F > this.length && (F = this.length);
          const M = 32767 & x, U = x >>> 15;
          let L = 0, H = v;
          for (let fe = 0; fe < F; fe++) {
            const ge = this.__digit(fe), Ie = 32767 & ge, Ee = ge >>> 15, Se = B.__imul(Ie, M), ze = B.__imul(Ie, U), He = B.__imul(Ee, M), Pe = B.__imul(Ee, U);
            let De = H + Se + L;
            L = De >>> 30, De &= 1073741823, De += ((32767 & ze) << 15) + ((32767 & He) << 15), L += De >>> 30, H = Pe + (ze >>> 15) + (He >>> 15), this.__setDigit(fe, 1073741823 & De);
          }
          if (L != 0 || H !== 0) throw new Error("implementation bug");
        }
        static __absoluteDivSmall(x, v, F = null) {
          F === null && (F = new B(x.length, !1));
          let M = 0;
          for (let U, L = 2 * x.length - 1; 0 <= L; L -= 2) {
            U = (M << 15 | x.__halfDigit(L)) >>> 0;
            const H = 0 | U / v;
            M = 0 | U % v, U = (M << 15 | x.__halfDigit(L - 1)) >>> 0;
            const fe = 0 | U / v;
            M = 0 | U % v, F.__setDigit(L >>> 1, H << 15 | fe);
          }
          return F;
        }
        static __absoluteModSmall(x, v) {
          let F = 0;
          for (let M = 2 * x.length - 1; 0 <= M; M--)
            F = 0 | ((F << 15 | x.__halfDigit(M)) >>> 0) % v;
          return F;
        }
        static __absoluteDivLarge(x, v, F, M) {
          const U = v.__halfDigitLength(), L = v.length, H = x.__halfDigitLength() - U;
          let fe = null;
          F && (fe = new B(H + 2 >>> 1, !1), fe.__initializeDigits());
          const ge = new B(U + 2 >>> 1, !1);
          ge.__initializeDigits();
          const Ie = B.__clz15(v.__halfDigit(U - 1));
          0 < Ie && (v = B.__specialLeftShift(v, Ie, 0));
          const Ee = B.__specialLeftShift(x, Ie, 1), Se = v.__halfDigit(U - 1);
          let ze = 0;
          for (let He, Pe = H; 0 <= Pe; Pe--) {
            He = 32767;
            const De = Ee.__halfDigit(Pe + U);
            if (De !== Se) {
              const Fe = (De << 15 | Ee.__halfDigit(Pe + U - 1)) >>> 0;
              He = 0 | Fe / Se;
              let be = 0 | Fe % Se;
              const Be = v.__halfDigit(U - 2), ke = Ee.__halfDigit(Pe + U - 2);
              for (; B.__imul(He, Be) >>> 0 > (be << 16 | ke) >>> 0 && (He--, be += Se, !(32767 < be)); ) ;
            }
            B.__internalMultiplyAdd(v, He, 0, L, ge);
            let ve = Ee.__inplaceSub(ge, Pe, U + 1);
            ve !== 0 && (ve = Ee.__inplaceAdd(v, Pe, U), Ee.__setHalfDigit(Pe + U, 32767 & Ee.__halfDigit(Pe + U) + ve), He--), F && (1 & Pe ? ze = He << 15 : fe.__setDigit(Pe >>> 1, ze | He));
          }
          if (M) return Ee.__inplaceRightShift(Ie), F ? { quotient: fe, remainder: Ee } : Ee;
          if (F) return fe;
          throw new Error("unreachable");
        }
        static __clz15(x) {
          return B.__clz30(x) - 15;
        }
        __inplaceAdd(x, v, F) {
          let M = 0;
          for (let U = 0; U < F; U++) {
            const L = this.__halfDigit(v + U) + x.__halfDigit(U) + M;
            M = L >>> 15, this.__setHalfDigit(v + U, 32767 & L);
          }
          return M;
        }
        __inplaceSub(x, v, F) {
          let M = 0;
          if (1 & v) {
            v >>= 1;
            let U = this.__digit(v), L = 32767 & U, H = 0;
            for (; H < F - 1 >>> 1; H++) {
              const Ie = x.__digit(H), Ee = (U >>> 15) - (32767 & Ie) - M;
              M = 1 & Ee >>> 15, this.__setDigit(v + H, (32767 & Ee) << 15 | 32767 & L), U = this.__digit(v + H + 1), L = (32767 & U) - (Ie >>> 15) - M, M = 1 & L >>> 15;
            }
            const fe = x.__digit(H), ge = (U >>> 15) - (32767 & fe) - M;
            if (M = 1 & ge >>> 15, this.__setDigit(v + H, (32767 & ge) << 15 | 32767 & L), v + H + 1 >= this.length) throw new RangeError("out of bounds");
            (1 & F) == 0 && (U = this.__digit(v + H + 1), L = (32767 & U) - (fe >>> 15) - M, M = 1 & L >>> 15, this.__setDigit(v + x.length, 1073709056 & U | 32767 & L));
          } else {
            v >>= 1;
            let U = 0;
            for (; U < x.length - 1; U++) {
              const Ie = this.__digit(v + U), Ee = x.__digit(U), Se = (32767 & Ie) - (32767 & Ee) - M;
              M = 1 & Se >>> 15;
              const ze = (Ie >>> 15) - (Ee >>> 15) - M;
              M = 1 & ze >>> 15, this.__setDigit(v + U, (32767 & ze) << 15 | 32767 & Se);
            }
            const L = this.__digit(v + U), H = x.__digit(U), fe = (32767 & L) - (32767 & H) - M;
            M = 1 & fe >>> 15;
            let ge = 0;
            (1 & F) == 0 && (ge = (L >>> 15) - (H >>> 15) - M, M = 1 & ge >>> 15), this.__setDigit(v + U, (32767 & ge) << 15 | 32767 & fe);
          }
          return M;
        }
        __inplaceRightShift(x) {
          if (x === 0) return;
          let v = this.__digit(0) >>> x;
          const F = this.length - 1;
          for (let M = 0; M < F; M++) {
            const U = this.__digit(M + 1);
            this.__setDigit(M, 1073741823 & U << 30 - x | v), v = U >>> x;
          }
          this.__setDigit(F, v);
        }
        static __specialLeftShift(x, v, F) {
          const M = x.length, U = new B(M + F, !1);
          if (v === 0) {
            for (let H = 0; H < M; H++) U.__setDigit(H, x.__digit(H));
            return 0 < F && U.__setDigit(M, 0), U;
          }
          let L = 0;
          for (let H = 0; H < M; H++) {
            const fe = x.__digit(H);
            U.__setDigit(H, 1073741823 & fe << v | L), L = fe >>> 30 - v;
          }
          return 0 < F && U.__setDigit(M, L), U;
        }
        static __leftShiftByAbsolute(x, v) {
          const F = B.__toShiftAmount(v);
          if (0 > F) throw new RangeError("BigInt too big");
          const M = 0 | F / 30, U = F % 30, L = x.length, H = U !== 0 && x.__digit(L - 1) >>> 30 - U != 0, fe = L + M + (H ? 1 : 0), ge = new B(fe, x.sign);
          if (U === 0) {
            let Ie = 0;
            for (; Ie < M; Ie++) ge.__setDigit(Ie, 0);
            for (; Ie < fe; Ie++) ge.__setDigit(Ie, x.__digit(Ie - M));
          } else {
            let Ie = 0;
            for (let Ee = 0; Ee < M; Ee++) ge.__setDigit(Ee, 0);
            for (let Ee = 0; Ee < L; Ee++) {
              const Se = x.__digit(Ee);
              ge.__setDigit(Ee + M, 1073741823 & Se << U | Ie), Ie = Se >>> 30 - U;
            }
            if (H) ge.__setDigit(L + M, Ie);
            else if (Ie !== 0) throw new Error("implementation bug");
          }
          return ge.__trim();
        }
        static __rightShiftByAbsolute(x, v) {
          const F = x.length, M = x.sign, U = B.__toShiftAmount(v);
          if (0 > U) return B.__rightShiftByMaximum(M);
          const L = 0 | U / 30, H = U % 30;
          let fe = F - L;
          if (0 >= fe) return B.__rightShiftByMaximum(M);
          let ge = !1;
          if (M) {
            if ((x.__digit(L) & (1 << H) - 1) != 0) ge = !0;
            else for (let Ee = 0; Ee < L; Ee++) if (x.__digit(Ee) !== 0) {
              ge = !0;
              break;
            }
          }
          ge && H === 0 && ~x.__digit(F - 1) == 0 && fe++;
          let Ie = new B(fe, M);
          if (H === 0) {
            Ie.__setDigit(fe - 1, 0);
            for (let Ee = L; Ee < F; Ee++) Ie.__setDigit(Ee - L, x.__digit(Ee));
          } else {
            let Ee = x.__digit(L) >>> H;
            const Se = F - L - 1;
            for (let ze = 0; ze < Se; ze++) {
              const He = x.__digit(ze + L + 1);
              Ie.__setDigit(ze, 1073741823 & He << 30 - H | Ee), Ee = He >>> H;
            }
            Ie.__setDigit(Se, Ee);
          }
          return ge && (Ie = B.__absoluteAddOne(Ie, !0, Ie)), Ie.__trim();
        }
        static __rightShiftByMaximum(x) {
          return x ? B.__oneDigit(1, !0) : B.__zero();
        }
        static __toShiftAmount(x) {
          if (1 < x.length) return -1;
          const v = x.__unsignedDigit(0);
          return v > B.__kMaxLengthBits ? -1 : v;
        }
        static __toPrimitive(x, v = "default") {
          if (typeof x != "object" || x.constructor === B) return x;
          if (typeof Symbol < "u" && typeof Symbol.toPrimitive == "symbol") {
            const U = x[Symbol.toPrimitive];
            if (U) {
              const L = U(v);
              if (typeof L != "object") return L;
              throw new TypeError("Cannot convert object to primitive value");
            }
          }
          const F = x.valueOf;
          if (F) {
            const U = F.call(x);
            if (typeof U != "object") return U;
          }
          const M = x.toString;
          if (M) {
            const U = M.call(x);
            if (typeof U != "object") return U;
          }
          throw new TypeError("Cannot convert object to primitive value");
        }
        static __toNumeric(x) {
          return B.__isBigInt(x) ? x : +x;
        }
        static __isBigInt(x) {
          return typeof x == "object" && x !== null && x.constructor === B;
        }
        static __truncateToNBits(x, v) {
          const F = 0 | (x + 29) / 30, M = new B(F, v.sign), U = F - 1;
          for (let H = 0; H < U; H++) M.__setDigit(H, v.__digit(H));
          let L = v.__digit(U);
          if (x % 30 != 0) {
            const H = 32 - x % 30;
            L = L << H >>> H;
          }
          return M.__setDigit(U, L), M.__trim();
        }
        static __truncateAndSubFromPowerOfTwo(x, v, F) {
          var M = Math.min;
          const U = 0 | (x + 29) / 30, L = new B(U, F);
          let H = 0;
          const fe = U - 1;
          let ge = 0;
          for (const ze = M(fe, v.length); H < ze; H++) {
            const He = 0 - v.__digit(H) - ge;
            ge = 1 & He >>> 30, L.__setDigit(H, 1073741823 & He);
          }
          for (; H < fe; H++) L.__setDigit(H, 0 | 1073741823 & -ge);
          let Ie = fe < v.length ? v.__digit(fe) : 0;
          const Ee = x % 30;
          let Se;
          if (Ee == 0) Se = 0 - Ie - ge, Se &= 1073741823;
          else {
            const ze = 32 - Ee;
            Ie = Ie << ze >>> ze;
            const He = 1 << 32 - ze;
            Se = He - Ie - ge, Se &= He - 1;
          }
          return L.__setDigit(fe, Se), L.__trim();
        }
        __digit(x) {
          return this[x];
        }
        __unsignedDigit(x) {
          return this[x] >>> 0;
        }
        __setDigit(x, v) {
          this[x] = 0 | v;
        }
        __setDigitGrow(x, v) {
          this[x] = 0 | v;
        }
        __halfDigitLength() {
          const x = this.length;
          return 32767 >= this.__unsignedDigit(x - 1) ? 2 * x - 1 : 2 * x;
        }
        __halfDigit(x) {
          return 32767 & this[x >>> 1] >>> 15 * (1 & x);
        }
        __setHalfDigit(x, v) {
          const F = x >>> 1, M = this.__digit(F), U = 1 & x ? 32767 & M | v << 15 : 1073709056 & M | 32767 & v;
          this.__setDigit(F, U);
        }
        static __digitPow(x, v) {
          let F = 1;
          for (; 0 < v; ) 1 & v && (F *= x), v >>>= 1, x *= x;
          return F;
        }
        static __isOneDigitInt(x) {
          return (1073741823 & x) === x;
        }
      }
      return B.__kMaxLength = 33554432, B.__kMaxLengthBits = B.__kMaxLength << 5, B.__kMaxBitsPerChar = [0, 0, 32, 51, 64, 75, 83, 90, 96, 102, 107, 111, 115, 119, 122, 126, 128, 131, 134, 136, 139, 141, 143, 145, 147, 149, 151, 153, 154, 156, 158, 159, 160, 162, 163, 165, 166], B.__kBitsPerCharTableShift = 5, B.__kBitsPerCharTableMultiplier = 1 << B.__kBitsPerCharTableShift, B.__kConversionChars = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z"], B.__kBitConversionBuffer = new ArrayBuffer(8), B.__kBitConversionDouble = new Float64Array(B.__kBitConversionBuffer), B.__kBitConversionInts = new Int32Array(B.__kBitConversionBuffer), B.__clz30 = y ? function(D) {
        return y(D) - 2;
      } : function(D) {
        var x = Math.LN2, v = Math.log;
        return D === 0 ? 30 : 0 | 29 - (0 | v(D >>> 0) / x);
      }, B.__imul = c || function(D, x) {
        return 0 | D * x;
      }, B;
    });
  }(jsbiUmd$1)), jsbiUmd$1.exports;
}
var hasRequiredXoshiro;
function requireXoshiro() {
  if (hasRequiredXoshiro) return xoshiro;
  hasRequiredXoshiro = 1;
  var o = xoshiro && xoshiro.__importDefault || function(B) {
    return B && B.__esModule ? B : { default: B };
  };
  Object.defineProperty(xoshiro, "__esModule", { value: !0 });
  const g = requireUtils$f(), c = o(requireBignumber()), y = o(requireJsbiUmd()), t = 18446744073709552e3, d = (B, D) => y.default.bitwiseXor(y.default.asUintN(64, y.default.leftShift(B, y.default.BigInt(D))), y.default.BigInt(y.default.asUintN(64, y.default.signedRightShift(B, y.default.subtract(y.default.BigInt(64), y.default.BigInt(D))))));
  class E {
    constructor(D) {
      this.next = () => new c.default(this.roll().toString()), this.nextDouble = () => new c.default(this.roll().toString()).div(t + 1), this.nextInt = (v, F) => Math.floor(this.nextDouble().toNumber() * (F - v + 1) + v), this.nextByte = () => this.nextInt(0, 255), this.nextData = (v) => [...new Array(v)].map(() => this.nextByte());
      const x = g.sha256Hash(D);
      this.s = [y.default.BigInt(0), y.default.BigInt(0), y.default.BigInt(0), y.default.BigInt(0)], this.setS(x);
    }
    setS(D) {
      for (let x = 0; x < 4; x++) {
        let v = x * 8, F = y.default.BigInt(0);
        for (let M = 0; M < 8; M++)
          F = y.default.asUintN(64, y.default.leftShift(F, y.default.BigInt(8))), F = y.default.asUintN(64, y.default.bitwiseOr(F, y.default.BigInt(D[v + M])));
        this.s[x] = y.default.asUintN(64, F);
      }
    }
    roll() {
      const D = y.default.asUintN(64, y.default.multiply(d(y.default.asUintN(64, y.default.multiply(this.s[1], y.default.BigInt(5))), 7), y.default.BigInt(9))), x = y.default.asUintN(64, y.default.leftShift(this.s[1], y.default.BigInt(17)));
      return this.s[2] = y.default.asUintN(64, y.default.bitwiseXor(this.s[2], y.default.BigInt(this.s[0]))), this.s[3] = y.default.asUintN(64, y.default.bitwiseXor(this.s[3], y.default.BigInt(this.s[1]))), this.s[1] = y.default.asUintN(64, y.default.bitwiseXor(this.s[1], y.default.BigInt(this.s[2]))), this.s[0] = y.default.asUintN(64, y.default.bitwiseXor(this.s[0], y.default.BigInt(this.s[3]))), this.s[2] = y.default.asUintN(64, y.default.bitwiseXor(this.s[2], y.default.BigInt(x))), this.s[3] = y.default.asUintN(64, d(this.s[3], 45)), D;
    }
  }
  return xoshiro.default = E, xoshiro;
}
var precomputeAlias = function(o, g) {
  var c = o.reduce(function(v, F) {
    if (F < 0)
      throw new Error("Probability must be a positive: p[" + o.indexOf(F) + "]=" + F);
    return v + F;
  }, 0);
  if (c === 0)
    throw new Error("Probability sum must be greater than zero.");
  for (var y = o.map(function(v) {
    return v * g / c;
  }), t = { prob: new Array(g), alias: new Array(g) }, d = [], E = [], B = g - 1; B >= 0; B--)
    y[B] < 1 ? d.push(B) : E.push(B);
  for (; d.length > 0 && E.length > 0; ) {
    var D = d.pop(), x = E.pop();
    t.prob[D] = y[D], t.alias[D] = x, y[x] = y[x] + y[D] - 1, y[x] < 1 ? d.push(x) : E.push(x);
  }
  for (; E.length > 0; )
    t.prob[E.pop()] = 1;
  for (; d.length > 0; )
    t.prob[d.pop()] = 1;
  return t;
}, draw = function(o, g, c) {
  var y = Math.floor(c() * o.prob.length);
  return g[c() < o.prob[y] ? y : o.alias[y]];
}, next = function(o, g, c, y) {
  if (y === void 0 && (y = 1), y === 1)
    return draw(o, g, c);
  for (var t = [], d = 0; d < y; d++)
    t.push(draw(o, g, c));
  return t;
}, sample = function(o, g, c) {
  if (c === void 0 && (c = Math.random), !Array.isArray(o))
    throw new Error("Probabilities must be an array.");
  if (o.length === 0)
    throw new Error("Probabilities array must not be empty.");
  var y = o.length, t = g ?? Array.from({ length: y }, function(E, B) {
    return B;
  }), d = precomputeAlias(o, y);
  return {
    next: function(E) {
      return E === void 0 && (E = 1), next(d, t, c, E);
    }
  };
};
const esm = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: sample
}, Symbol.toStringTag, { value: "Module" })), require$$2$1 = /* @__PURE__ */ getAugmentedNamespace(esm);
var hasRequiredFountainUtils;
function requireFountainUtils() {
  return hasRequiredFountainUtils || (hasRequiredFountainUtils = 1, function(o) {
    var g = fountainUtils && fountainUtils.__importDefault || function(D) {
      return D && D.__esModule ? D : { default: D };
    };
    Object.defineProperty(o, "__esModule", { value: !0 }), o.chooseFragments = o.shuffle = o.chooseDegree = void 0;
    const c = requireUtils$f(), y = g(requireXoshiro()), t = g(require$$2$1), d = (D, x) => {
      const v = [...new Array(D)].map((M, U) => 1 / (U + 1));
      return t.default(v, void 0, x.nextDouble).next() + 1;
    };
    o.chooseDegree = d;
    const E = (D, x) => {
      let v = [...D], F = [];
      for (; v.length > 0; ) {
        let M = x.nextInt(0, v.length - 1), U = v[M];
        v.splice(M, 1), F.push(U);
      }
      return F;
    };
    o.shuffle = E;
    const B = (D, x, v) => {
      if (D <= x)
        return [D - 1];
      {
        const F = Buffer.concat([c.intToBytes(D), c.intToBytes(v)]), M = new y.default(F), U = o.chooseDegree(x, M), L = [...new Array(x)].map((fe, ge) => ge);
        return o.shuffle(L, M).slice(0, U);
      }
    };
    o.chooseFragments = B;
  }(fountainUtils)), fountainUtils;
}
var hasRequiredFountainEncoder;
function requireFountainEncoder() {
  if (hasRequiredFountainEncoder) return fountainEncoder;
  hasRequiredFountainEncoder = 1;
  var o = fountainEncoder && fountainEncoder.__importDefault || function(B) {
    return B && B.__esModule ? B : { default: B };
  };
  Object.defineProperty(fountainEncoder, "__esModule", { value: !0 }), fountainEncoder.FountainEncoderPart = void 0;
  const g = o(requireAssert$2()), c = requireUtils$f(), y = requireFountainUtils(), t = requireCbor();
  class d {
    constructor(D, x, v, F, M) {
      this._seqNum = D, this._seqLength = x, this._messageLength = v, this._checksum = F, this._fragment = M;
    }
    get messageLength() {
      return this._messageLength;
    }
    get fragment() {
      return this._fragment;
    }
    get seqNum() {
      return this._seqNum;
    }
    get seqLength() {
      return this._seqLength;
    }
    get checksum() {
      return this._checksum;
    }
    cbor() {
      const D = t.cborEncode([
        this._seqNum,
        this._seqLength,
        this._messageLength,
        this._checksum,
        this._fragment
      ]);
      return Buffer.from(D);
    }
    description() {
      return `seqNum:${this._seqNum}, seqLen:${this._seqLength}, messageLen:${this._messageLength}, checksum:${this._checksum}, data:${this._fragment.toString("hex")}`;
    }
    static fromCBOR(D) {
      const [x, v, F, M, U] = t.cborDecode(D);
      return g.default(typeof x == "number"), g.default(typeof v == "number"), g.default(typeof F == "number"), g.default(typeof M == "number"), g.default(Buffer.isBuffer(U) && U.length > 0), new d(x, v, F, M, Buffer.from(U));
    }
  }
  fountainEncoder.FountainEncoderPart = d;
  class E {
    constructor(D, x = 100, v = 0, F = 10) {
      const M = E.findNominalFragmentLength(D.length, F, x);
      this._messageLength = D.length, this._fragments = E.partitionMessage(D, M), this.fragmentLength = M, this.seqNum = c.toUint32(v), this.checksum = c.getCRC(D);
    }
    get fragmentsLength() {
      return this._fragments.length;
    }
    get fragments() {
      return this._fragments;
    }
    get messageLength() {
      return this._messageLength;
    }
    isComplete() {
      return this.seqNum >= this._fragments.length;
    }
    isSinglePart() {
      return this._fragments.length === 1;
    }
    seqLength() {
      return this._fragments.length;
    }
    mix(D) {
      return D.reduce((x, v) => c.bufferXOR(this._fragments[v], x), Buffer.alloc(this.fragmentLength, 0));
    }
    nextPart() {
      this.seqNum = c.toUint32(this.seqNum + 1);
      const D = y.chooseFragments(this.seqNum, this._fragments.length, this.checksum), x = this.mix(D);
      return new d(this.seqNum, this._fragments.length, this._messageLength, this.checksum, x);
    }
    static findNominalFragmentLength(D, x, v) {
      g.default(D > 0), g.default(x > 0), g.default(v >= x);
      const F = Math.ceil(D / x);
      let M = 0;
      for (let U = 1; U <= F && (M = Math.ceil(D / U), !(M <= v)); U++)
        ;
      return M;
    }
    static partitionMessage(D, x) {
      let v = Buffer.from(D), F, M = [];
      for (; v.length > 0; )
        [F, v] = c.split(v, -x), F = Buffer.alloc(x, 0).fill(F, 0, F.length), M.push(F);
      return M;
    }
  }
  return fountainEncoder.default = E, fountainEncoder;
}
var bytewords = {}, hasRequiredBytewords;
function requireBytewords() {
  if (hasRequiredBytewords) return bytewords;
  hasRequiredBytewords = 1;
  var o = bytewords && bytewords.__importDefault || function(Ie) {
    return Ie && Ie.__esModule ? Ie : { default: Ie };
  };
  Object.defineProperty(bytewords, "__esModule", { value: !0 });
  const g = o(requireAssert$2()), c = requireUtils$f(), y = "ableacidalsoapexaquaarchatomauntawayaxisbackbaldbarnbeltbetabiasbluebodybragbrewbulbbuzzcalmcashcatschefcityclawcodecolacookcostcruxcurlcuspcyandarkdatadaysdelidicedietdoordowndrawdropdrumdulldutyeacheasyechoedgeepicevenexamexiteyesfactfairfernfigsfilmfishfizzflapflewfluxfoxyfreefrogfuelfundgalagamegeargemsgiftgirlglowgoodgraygrimgurugushgyrohalfhanghardhawkheathelphighhillholyhopehornhutsicedideaidleinchinkyintoirisironitemjadejazzjoinjoltjowljudojugsjumpjunkjurykeepkenokeptkeyskickkilnkingkitekiwiknoblamblavalazyleaflegsliarlimplionlistlogoloudloveluaulucklungmainmanymathmazememomenumeowmildmintmissmonknailnavyneednewsnextnoonnotenumbobeyoboeomitonyxopenovalowlspaidpartpeckplaypluspoempoolposepuffpumapurrquadquizraceramprealredorichroadrockroofrubyruinrunsrustsafesagascarsetssilkskewslotsoapsolosongstubsurfswantacotasktaxitenttiedtimetinytoiltombtoystriptunatwinuglyundouniturgeuservastveryvetovialvibeviewvisavoidvowswallwandwarmwaspwavewaxywebswhatwhenwhizwolfworkyankyawnyellyogayurtzapszerozestzinczonezoom";
  let t = [];
  const d = 256, E = 4, B = 2;
  var D;
  (function(Ie) {
    Ie.STANDARD = "standard", Ie.URI = "uri", Ie.MINIMAL = "minimal";
  })(D || (D = {}));
  const x = (Ie) => y.slice(Ie * E, Ie * E + E), v = (Ie) => {
    const Ee = x(Ie);
    return `${Ee[0]}${Ee[E - 1]}`;
  }, F = (Ie) => {
    const Ee = c.getCRCHex(Buffer.from(Ie, "hex"));
    return `${Ie}${Ee}`;
  }, M = (Ie, Ee) => {
    const Se = F(Ie);
    return Buffer.from(Se, "hex").reduce((Pe, De) => [...Pe, x(De)], []).join(Ee);
  }, U = (Ie) => {
    const Ee = F(Ie);
    return Buffer.from(Ee, "hex").reduce((He, Pe) => He + v(Pe), "");
  }, L = (Ie, Ee) => {
    g.default(Ie.length === Ee, "Invalid Bytewords: word.length does not match wordLength provided");
    const Se = 26;
    if (t.length === 0) {
      const ve = Se * Se;
      t = [...new Array(ve)].map(() => -1);
      for (let Fe = 0; Fe < d; Fe++) {
        const be = x(Fe);
        let Be = be[0].charCodeAt(0) - 97, xe = (be[3].charCodeAt(0) - 97) * Se + Be;
        t[xe] = Fe;
      }
    }
    let ze = Ie[0].toLowerCase().charCodeAt(0) - 97, He = Ie[Ee == 4 ? 3 : 1].toLowerCase().charCodeAt(0) - 97;
    g.default(0 <= ze && ze < Se && 0 <= He && He < Se, "Invalid Bytewords: invalid word");
    let Pe = He * Se + ze, De = t[Pe];
    if (g.default(De !== -1, "Invalid Bytewords: value not in lookup table"), Ee == E) {
      const ve = x(De);
      let Fe = Ie[1].toLowerCase(), be = Ie[2].toLowerCase();
      g.default(Fe === ve[1] && be === ve[2], "Invalid Bytewords: invalid middle letters of word");
    }
    return Buffer.from([De]).toString("hex");
  }, H = (Ie, Ee, Se) => {
    const He = (Se == E ? Ie.split(Ee) : c.partition(Ie, 2)).map((Fe) => L(Fe, Se)).join("");
    g.default(He.length >= 5, "Invalid Bytewords: invalid decoded string length");
    const [Pe, De] = c.split(Buffer.from(He, "hex"), 4), ve = c.getCRCHex(Pe);
    return g.default(ve === De.toString("hex"), "Invalid Checksum"), Pe.toString("hex");
  }, fe = (Ie, Ee = D.MINIMAL) => {
    switch (Ee) {
      case D.STANDARD:
        return H(Ie, " ", E);
      case D.URI:
        return H(Ie, "-", E);
      case D.MINIMAL:
        return H(Ie, "", B);
      default:
        throw new Error(`Invalid style ${Ee}`);
    }
  }, ge = (Ie, Ee = D.MINIMAL) => {
    switch (Ee) {
      case D.STANDARD:
        return M(Ie, " ");
      case D.URI:
        return M(Ie, "-");
      case D.MINIMAL:
        return U(Ie);
      default:
        throw new Error(`Invalid style ${Ee}`);
    }
  };
  return bytewords.default = {
    decode: fe,
    encode: ge,
    STYLES: D
  }, bytewords;
}
var hasRequiredUrEncoder;
function requireUrEncoder() {
  if (hasRequiredUrEncoder) return urEncoder;
  hasRequiredUrEncoder = 1;
  var o = urEncoder && urEncoder.__importDefault || function(t) {
    return t && t.__esModule ? t : { default: t };
  };
  Object.defineProperty(urEncoder, "__esModule", { value: !0 });
  const g = o(requireFountainEncoder()), c = o(requireBytewords());
  class y {
    constructor(d, E, B, D) {
      this.ur = d, this.fountainEncoder = new g.default(d.cbor, E, B, D);
    }
    get fragmentsLength() {
      return this.fountainEncoder.fragmentsLength;
    }
    get fragments() {
      return this.fountainEncoder.fragments;
    }
    get messageLength() {
      return this.fountainEncoder.messageLength;
    }
    get cbor() {
      return this.ur.cbor;
    }
    encodeWhole() {
      return [...new Array(this.fragmentsLength)].map(() => this.nextPart());
    }
    nextPart() {
      const d = this.fountainEncoder.nextPart();
      return this.fountainEncoder.isSinglePart() ? y.encodeSinglePart(this.ur) : y.encodePart(this.ur.type, d);
    }
    static encodeUri(d, E) {
      const B = E.join("/");
      return [d, B].join(":");
    }
    static encodeUR(d) {
      return y.encodeUri("ur", d);
    }
    static encodePart(d, E) {
      const B = `${E.seqNum}-${E.seqLength}`, D = c.default.encode(E.cbor().toString("hex"), c.default.STYLES.MINIMAL);
      return y.encodeUR([d, B, D]);
    }
    static encodeSinglePart(d) {
      const E = c.default.encode(d.cbor.toString("hex"), c.default.STYLES.MINIMAL);
      return y.encodeUR([d.type, E]);
    }
  }
  return urEncoder.default = y, urEncoder;
}
var urDecoder = {}, fountainDecoder = {}, hasRequiredFountainDecoder;
function requireFountainDecoder() {
  if (hasRequiredFountainDecoder) return fountainDecoder;
  hasRequiredFountainDecoder = 1, Object.defineProperty(fountainDecoder, "__esModule", { value: !0 }), fountainDecoder.FountainDecoderPart = void 0;
  const o = requireUtils$f(), g = requireFountainUtils(), c = requireErrors$6();
  class y {
    constructor(E, B) {
      this._indexes = E, this._fragment = B;
    }
    get indexes() {
      return this._indexes;
    }
    get fragment() {
      return this._fragment;
    }
    static fromEncoderPart(E) {
      const B = g.chooseFragments(E.seqNum, E.seqLength, E.checksum), D = E.fragment;
      return new y(B, D);
    }
    isSimple() {
      return this.indexes.length === 1;
    }
  }
  fountainDecoder.FountainDecoderPart = y;
  class t {
    constructor() {
      this.result = void 0, this.expectedMessageLength = 0, this.expectedChecksum = 0, this.expectedFragmentLength = 0, this.processedPartsCount = 0, this.expectedPartIndexes = [], this.lastPartIndexes = [], this.queuedParts = [], this.receivedPartIndexes = [], this.mixedParts = [], this.simpleParts = [];
    }
    validatePart(E) {
      if (this.expectedPartIndexes.length === 0)
        [...new Array(E.seqLength)].forEach((B, D) => this.expectedPartIndexes.push(D)), this.expectedMessageLength = E.messageLength, this.expectedChecksum = E.checksum, this.expectedFragmentLength = E.fragment.length;
      else if (this.expectedPartIndexes.length !== E.seqLength || this.expectedMessageLength !== E.messageLength || this.expectedChecksum !== E.checksum || this.expectedFragmentLength !== E.fragment.length)
        return !1;
      return !0;
    }
    reducePartByPart(E, B) {
      if (o.arrayContains(E.indexes, B.indexes)) {
        const D = o.setDifference(E.indexes, B.indexes), x = o.bufferXOR(E.fragment, B.fragment);
        return new y(D, x);
      } else
        return E;
    }
    reduceMixedBy(E) {
      const B = [];
      this.mixedParts.map(({ value: D }) => this.reducePartByPart(D, E)).forEach((D) => {
        D.isSimple() ? this.queuedParts.push(D) : B.push({ key: D.indexes, value: D });
      }), this.mixedParts = B;
    }
    processSimplePart(E) {
      const B = E.indexes[0];
      if (!this.receivedPartIndexes.includes(B))
        if (this.simpleParts.push({ key: E.indexes, value: E }), this.receivedPartIndexes.push(B), o.arraysEqual(this.receivedPartIndexes, this.expectedPartIndexes)) {
          const D = this.simpleParts.map(({ value: F }) => F).sort((F, M) => F.indexes[0] - M.indexes[0]), x = t.joinFragments(D.map((F) => F.fragment), this.expectedMessageLength);
          o.getCRC(x) === this.expectedChecksum ? this.result = x : this.error = new c.InvalidChecksumError();
        } else
          this.reduceMixedBy(E);
    }
    processMixedPart(E) {
      if (this.mixedParts.some(({ key: D }) => o.arraysEqual(D, E.indexes)))
        return;
      let B = this.simpleParts.reduce((D, { value: x }) => this.reducePartByPart(D, x), E);
      B = this.mixedParts.reduce((D, { value: x }) => this.reducePartByPart(D, x), B), B.isSimple() ? this.queuedParts.push(B) : (this.reduceMixedBy(B), this.mixedParts.push({ key: B.indexes, value: B }));
    }
    processQueuedItem() {
      if (this.queuedParts.length === 0)
        return;
      const E = this.queuedParts.shift();
      E.isSimple() ? this.processSimplePart(E) : this.processMixedPart(E);
    }
    receivePart(E) {
      if (this.isComplete() || !this.validatePart(E))
        return !1;
      const B = y.fromEncoderPart(E);
      for (this.lastPartIndexes = B.indexes, this.queuedParts.push(B); !this.isComplete() && this.queuedParts.length > 0; )
        this.processQueuedItem();
      return this.processedPartsCount += 1, !0;
    }
    isComplete() {
      return this.result !== void 0 && this.result.length > 0;
    }
    isSuccess() {
      return !!(this.error === void 0 && this.isComplete());
    }
    resultMessage() {
      return this.isSuccess() ? this.result : Buffer.from([]);
    }
    isFailure() {
      return this.error !== void 0;
    }
    resultError() {
      return this.error ? this.error.message : "";
    }
    expectedPartCount() {
      return this.expectedPartIndexes.length;
    }
    getExpectedPartIndexes() {
      return [...this.expectedPartIndexes];
    }
    getReceivedPartIndexes() {
      return [...this.receivedPartIndexes];
    }
    getLastPartIndexes() {
      return [...this.lastPartIndexes];
    }
    estimatedPercentComplete() {
      if (this.isComplete())
        return 1;
      const E = this.expectedPartCount();
      return E === 0 ? 0 : Math.min(0.99, this.processedPartsCount / (E * 1.75));
    }
    getProgress() {
      if (this.isComplete())
        return 1;
      const E = this.expectedPartCount();
      return E === 0 ? 0 : this.receivedPartIndexes.length / E;
    }
  }
  return fountainDecoder.default = t, t.joinFragments = (d, E) => Buffer.concat(d).slice(0, E), fountainDecoder;
}
var hasRequiredUrDecoder;
function requireUrDecoder() {
  if (hasRequiredUrDecoder) return urDecoder;
  hasRequiredUrDecoder = 1;
  var o = urDecoder && urDecoder.__importDefault || function(x) {
    return x && x.__esModule ? x : { default: x };
  };
  Object.defineProperty(urDecoder, "__esModule", { value: !0 });
  const g = o(requireFountainDecoder()), c = o(requireBytewords()), y = o(requireAssert$2()), t = requireUtils$f(), d = requireErrors$6(), E = o(requireUr$1()), B = requireFountainEncoder();
  class D {
    constructor(v = new g.default(), F = "bytes") {
      this.fountainDecoder = v, this.type = F, y.default(t.isURType(F), "Invalid UR type"), this.expected_type = "";
    }
    static decodeBody(v, F) {
      const M = c.default.decode(F, c.default.STYLES.MINIMAL);
      return new E.default(Buffer.from(M, "hex"), v);
    }
    validatePart(v) {
      return this.expected_type ? this.expected_type === v : t.isURType(v) ? (this.expected_type = v, !0) : !1;
    }
    static decode(v) {
      const [F, M] = this.parse(v);
      if (M.length === 0)
        throw new d.InvalidPathLengthError();
      const U = M[0];
      return D.decodeBody(F, U);
    }
    static parse(v) {
      const F = v.toLowerCase();
      if (F.slice(0, 3) !== "ur:")
        throw new d.InvalidSchemeError();
      const U = F.slice(3).split("/"), L = U[0];
      if (U.length < 2)
        throw new d.InvalidPathLengthError();
      if (!t.isURType(L))
        throw new d.InvalidTypeError();
      return [L, U.slice(1)];
    }
    static parseSequenceComponent(v) {
      const F = v.split("-");
      if (F.length !== 2)
        throw new d.InvalidSequenceComponentError();
      const M = t.toUint32(Number(F[0])), U = Number(F[1]);
      if (M < 1 || U < 1)
        throw new d.InvalidSequenceComponentError();
      return [M, U];
    }
    receivePart(v) {
      if (this.result !== void 0)
        return !1;
      const [F, M] = D.parse(v);
      if (!this.validatePart(F))
        return !1;
      if (M.length === 1)
        return this.result = D.decodeBody(F, M[0]), !0;
      if (M.length !== 2)
        throw new d.InvalidPathLengthError();
      const [U, L] = M, [H, fe] = D.parseSequenceComponent(U), ge = c.default.decode(L, c.default.STYLES.MINIMAL), Ie = B.FountainEncoderPart.fromCBOR(ge);
      return H !== Ie.seqNum || fe !== Ie.seqLength || !this.fountainDecoder.receivePart(Ie) ? !1 : (this.fountainDecoder.isSuccess() ? this.result = new E.default(this.fountainDecoder.resultMessage(), F) : this.fountainDecoder.isFailure() && (this.error = new d.InvalidSchemeError()), !0);
    }
    resultUR() {
      return this.result ? this.result : new E.default(Buffer.from([]));
    }
    isComplete() {
      return this.result && this.result.cbor.length > 0;
    }
    isSuccess() {
      return !this.error && this.isComplete();
    }
    isError() {
      return this.error !== void 0;
    }
    resultError() {
      return this.error ? this.error.message : "";
    }
    expectedPartCount() {
      return this.fountainDecoder.expectedPartCount();
    }
    expectedPartIndexes() {
      return this.fountainDecoder.getExpectedPartIndexes();
    }
    receivedPartIndexes() {
      return this.fountainDecoder.getReceivedPartIndexes();
    }
    lastPartIndexes() {
      return this.fountainDecoder.getLastPartIndexes();
    }
    estimatedPercentComplete() {
      return this.fountainDecoder.estimatedPercentComplete();
    }
    getProgress() {
      return this.fountainDecoder.getProgress();
    }
  }
  return urDecoder.default = D, urDecoder;
}
var hasRequiredDist$p;
function requireDist$p() {
  if (hasRequiredDist$p) return dist$n;
  hasRequiredDist$p = 1;
  var o = dist$n && dist$n.__importDefault || function(t) {
    return t && t.__esModule ? t : { default: t };
  };
  Object.defineProperty(dist$n, "__esModule", { value: !0 }), dist$n.URDecoder = dist$n.UREncoder = dist$n.UR = void 0;
  const g = o(requireUr$1());
  dist$n.UR = g.default;
  const c = o(requireUrEncoder());
  dist$n.UREncoder = c.default;
  const y = o(requireUrDecoder());
  return dist$n.URDecoder = y.default, dist$n;
}
var hasRequiredRegistryItem$2;
function requireRegistryItem$2() {
  if (hasRequiredRegistryItem$2) return RegistryItem$2;
  hasRequiredRegistryItem$2 = 1, Object.defineProperty(RegistryItem$2, "__esModule", { value: !0 }), RegistryItem$2.RegistryItem = void 0;
  const o = requireDist$p(), g = requireLib$8();
  class c {
    constructor() {
      this.toCBOR = () => {
        if (this.toDataItem() === void 0)
          throw new Error(`#[ur-registry][RegistryItem][fn.toCBOR]: registry ${this.getRegistryType()}'s method toDataItem returns undefined`);
        return (0, g.encodeDataItem)(this.toDataItem());
      }, this.toUR = () => new o.UR(this.toCBOR(), this.getRegistryType().getType()), this.toUREncoder = (t, d, E) => {
        const B = this.toUR();
        return new o.UREncoder(B, t, d, E);
      };
    }
  }
  return RegistryItem$2.RegistryItem = c, RegistryItem$2;
}
var hasRequiredCryptoCoinInfo$2;
function requireCryptoCoinInfo$2() {
  return hasRequiredCryptoCoinInfo$2 || (hasRequiredCryptoCoinInfo$2 = 1, function(o) {
    Object.defineProperty(o, "__esModule", { value: !0 }), o.CryptoCoinInfo = o.Network = o.Type = void 0;
    const g = requireLib$8(), c = requireRegistryItem$2(), y = requireRegistryType$3();
    var t;
    (function(D) {
      D.type = "1", D.network = "2";
    })(t || (t = {}));
    var d;
    (function(D) {
      D[D.bitcoin = 0] = "bitcoin";
    })(d = o.Type || (o.Type = {}));
    var E;
    (function(D) {
      D[D.mainnet = 0] = "mainnet", D[D.testnet = 1] = "testnet";
    })(E = o.Network || (o.Network = {}));
    class B extends c.RegistryItem {
      constructor(x, v) {
        super(), this.type = x, this.network = v, this.getRegistryType = () => y.RegistryTypes.CRYPTO_COIN_INFO, this.getType = () => this.type || d.bitcoin, this.getNetwork = () => this.network || E.mainnet, this.toDataItem = () => {
          const F = {};
          return this.type && (F[t.type] = this.type), this.network && (F[t.network] = this.network), new g.DataItem(F);
        };
      }
    }
    o.CryptoCoinInfo = B, B.fromDataItem = (D) => {
      const x = D.getData(), v = x[t.type], F = x[t.network];
      return new B(v, F);
    }, B.fromCBOR = (D) => {
      const x = (0, g.decodeToDataItem)(D);
      return B.fromDataItem(x);
    };
  }(CryptoCoinInfo$2)), CryptoCoinInfo$2;
}
var CryptoKeypath$2 = {}, PathComponent$2 = {}, hasRequiredPathComponent$2;
function requirePathComponent$2() {
  if (hasRequiredPathComponent$2) return PathComponent$2;
  hasRequiredPathComponent$2 = 1, Object.defineProperty(PathComponent$2, "__esModule", { value: !0 }), PathComponent$2.PathComponent = void 0;
  class o {
    constructor(c) {
      if (this.getIndex = () => this.index, this.isWildcard = () => this.wildcard, this.isHardened = () => this.hardened, this.index = c.index, this.hardened = c.hardened, this.index !== void 0 ? this.wildcard = !1 : this.wildcard = !0, this.index && (this.index & o.HARDENED_BIT) !== 0)
        throw new Error(`#[ur-registry][PathComponent][fn.constructor]: Invalid index ${this.index} - most significant bit cannot be set`);
    }
  }
  return PathComponent$2.PathComponent = o, o.HARDENED_BIT = 2147483648, PathComponent$2;
}
var hasRequiredCryptoKeypath$2;
function requireCryptoKeypath$2() {
  if (hasRequiredCryptoKeypath$2) return CryptoKeypath$2;
  hasRequiredCryptoKeypath$2 = 1, Object.defineProperty(CryptoKeypath$2, "__esModule", { value: !0 }), CryptoKeypath$2.CryptoKeypath = void 0;
  const o = requireLib$8(), g = requirePathComponent$2(), c = requireRegistryItem$2(), y = requireRegistryType$3();
  var t;
  (function(E) {
    E[E.components = 1] = "components", E[E.source_fingerprint = 2] = "source_fingerprint", E[E.depth = 3] = "depth";
  })(t || (t = {}));
  class d extends c.RegistryItem {
    constructor(B = [], D, x) {
      super(), this.components = B, this.sourceFingerprint = D, this.depth = x, this.getRegistryType = () => y.RegistryTypes.CRYPTO_KEYPATH, this.getPath = () => this.components.length === 0 ? void 0 : this.components.map((F) => `${F.isWildcard() ? "*" : F.getIndex()}${F.isHardened() ? "'" : ""}`).join("/"), this.getComponents = () => this.components, this.getSourceFingerprint = () => this.sourceFingerprint, this.getDepth = () => this.depth, this.toDataItem = () => {
        const v = {}, F = [];
        return this.components && this.components.forEach((M) => {
          M.isWildcard() ? F.push([]) : F.push(M.getIndex()), F.push(M.isHardened());
        }), v[t.components] = F, this.sourceFingerprint && (v[t.source_fingerprint] = this.sourceFingerprint.readUInt32BE(0)), this.depth !== void 0 && (v[t.depth] = this.depth), new o.DataItem(v);
      };
    }
  }
  return CryptoKeypath$2.CryptoKeypath = d, d.fromDataItem = (E) => {
    const B = E.getData(), D = [], x = B[t.components];
    if (x)
      for (let U = 0; U < x.length; U += 2) {
        const L = x[U + 1], H = x[U];
        typeof H == "number" ? D.push(new g.PathComponent({ index: H, hardened: L })) : D.push(new g.PathComponent({ hardened: L }));
      }
    const v = B[t.source_fingerprint];
    let F;
    v && (F = Buffer.alloc(4), F.writeUInt32BE(v, 0));
    const M = B[t.depth];
    return new d(D, F, M);
  }, d.fromCBOR = (E) => {
    const B = (0, o.decodeToDataItem)(E);
    return d.fromDataItem(B);
  }, CryptoKeypath$2;
}
var hasRequiredCryptoHDKey$2;
function requireCryptoHDKey$2() {
  if (hasRequiredCryptoHDKey$2) return CryptoHDKey$2;
  hasRequiredCryptoHDKey$2 = 1, Object.defineProperty(CryptoHDKey$2, "__esModule", { value: !0 }), CryptoHDKey$2.CryptoHDKey = void 0;
  const o = requireBs58check$1(), g = requireCryptoCoinInfo$2(), c = requireCryptoKeypath$2(), y = requireLib$8(), t = requireRegistryItem$2(), d = requireRegistryType$3();
  var E;
  (function(D) {
    D[D.is_master = 1] = "is_master", D[D.is_private = 2] = "is_private", D[D.key_data = 3] = "key_data", D[D.chain_code = 4] = "chain_code", D[D.use_info = 5] = "use_info", D[D.origin = 6] = "origin", D[D.children = 7] = "children", D[D.parent_fingerprint = 8] = "parent_fingerprint", D[D.name = 9] = "name", D[D.note = 10] = "note";
  })(E || (E = {}));
  class B extends t.RegistryItem {
    constructor(x) {
      super(), this.isECKey = () => !1, this.getKey = () => this.key, this.getChainCode = () => this.chainCode, this.isMaster = () => this.master, this.isPrivateKey = () => !!this.privateKey, this.getUseInfo = () => this.useInfo, this.getOrigin = () => this.origin, this.getChildren = () => this.children, this.getParentFingerprint = () => this.parentFingerprint, this.getName = () => this.name, this.getNote = () => this.note, this.getBip32Key = () => {
        var v, F, M;
        let U, L, H = 0, fe = Buffer.alloc(4).fill(0);
        if (this.isMaster())
          U = Buffer.from("0488ADE4", "hex"), L = 0, H = 0;
        else {
          L = ((v = this.getOrigin()) === null || v === void 0 ? void 0 : v.getComponents().length) || ((F = this.getOrigin()) === null || F === void 0 ? void 0 : F.getDepth());
          const ze = (M = this.getOrigin()) === null || M === void 0 ? void 0 : M.getComponents(), He = ze[ze.length - 1];
          He && (H = He.isHardened() ? He.getIndex() + 2147483648 : He.getIndex(), this.getParentFingerprint() && (fe = this.getParentFingerprint())), this.isPrivateKey() ? U = Buffer.from("0488ADE4", "hex") : U = Buffer.from("0488B21E", "hex");
        }
        const ge = Buffer.alloc(1);
        ge.writeUInt8(L, 0);
        const Ie = Buffer.alloc(4);
        Ie.writeUInt32BE(H, 0);
        const Ee = this.getChainCode(), Se = this.getKey();
        return (0, o.encode)(Buffer.concat([U, ge, fe, Ie, Ee, Se]));
      }, this.getRegistryType = () => d.RegistryTypes.CRYPTO_HDKEY, this.getOutputDescriptorContent = () => {
        var v, F, M, U, L, H, fe;
        let ge = "";
        return this.getOrigin() && !((v = this.getOrigin()) === null || v === void 0) && v.getSourceFingerprint() && !((F = this.getOrigin()) === null || F === void 0) && F.getPath() && (ge += `${(U = (M = this.getOrigin()) === null || M === void 0 ? void 0 : M.getSourceFingerprint()) === null || U === void 0 ? void 0 : U.toString("hex")}/${(L = this.getOrigin()) === null || L === void 0 ? void 0 : L.getPath()}`), ge += this.getBip32Key(), this.getChildren() && !((H = this.getChildren()) === null || H === void 0) && H.getPath() && (ge += `/${(fe = this.getChildren()) === null || fe === void 0 ? void 0 : fe.getPath()}`), ge;
      }, this.setupMasterKey = (v) => {
        this.master = !0, this.key = v.key, this.chainCode = v.chainCode;
      }, this.setupDeriveKey = (v) => {
        this.master = !1, this.privateKey = v.isPrivateKey, this.key = v.key, this.chainCode = v.chainCode, this.useInfo = v.useInfo, this.origin = v.origin, this.children = v.children, this.parentFingerprint = v.parentFingerprint, this.name = v.name, this.note = v.note;
      }, this.toDataItem = () => {
        const v = {};
        if (this.master)
          v[E.is_master] = !0, v[E.key_data] = this.key, v[E.chain_code] = this.chainCode;
        else {
          if (this.privateKey !== void 0 && (v[E.is_private] = this.privateKey), v[E.key_data] = this.key, this.chainCode && (v[E.chain_code] = this.chainCode), this.useInfo) {
            const F = this.useInfo.toDataItem();
            F.setTag(this.useInfo.getRegistryType().getTag()), v[E.use_info] = F;
          }
          if (this.origin) {
            const F = this.origin.toDataItem();
            F.setTag(this.origin.getRegistryType().getTag()), v[E.origin] = F;
          }
          if (this.children) {
            const F = this.children.toDataItem();
            F.setTag(this.children.getRegistryType().getTag()), v[E.children] = F;
          }
          this.parentFingerprint && (v[E.parent_fingerprint] = this.parentFingerprint.readUInt32BE(0)), this.name !== void 0 && (v[E.name] = this.name), this.note !== void 0 && (v[E.note] = this.note);
        }
        return new y.DataItem(v);
      }, x.isMaster ? this.setupMasterKey(x) : this.setupDeriveKey(x);
    }
  }
  return CryptoHDKey$2.CryptoHDKey = B, B.fromDataItem = (D) => {
    const x = D.getData(), v = !!x[E.is_master], F = x[E.is_private], M = x[E.key_data], U = x[E.chain_code], L = x[E.use_info] ? g.CryptoCoinInfo.fromDataItem(x[E.use_info]) : void 0, H = x[E.origin] ? c.CryptoKeypath.fromDataItem(x[E.origin]) : void 0, fe = x[E.children] ? c.CryptoKeypath.fromDataItem(x[E.children]) : void 0, ge = x[E.parent_fingerprint];
    let Ie;
    ge && (Ie = Buffer.alloc(4), Ie.writeUInt32BE(ge, 0));
    const Ee = x[E.name], Se = x[E.note];
    return new B({
      isMaster: v,
      isPrivateKey: F,
      key: M,
      chainCode: U,
      useInfo: L,
      origin: H,
      children: fe,
      parentFingerprint: Ie,
      name: Ee,
      note: Se
    });
  }, B.fromCBOR = (D) => {
    const x = (0, y.decodeToDataItem)(D);
    return B.fromDataItem(x);
  }, CryptoHDKey$2;
}
var CryptoECKey$2 = {}, hasRequiredCryptoECKey$2;
function requireCryptoECKey$2() {
  if (hasRequiredCryptoECKey$2) return CryptoECKey$2;
  hasRequiredCryptoECKey$2 = 1, Object.defineProperty(CryptoECKey$2, "__esModule", { value: !0 }), CryptoECKey$2.CryptoECKey = void 0;
  const o = requireLib$8(), g = requireRegistryItem$2(), c = requireRegistryType$3();
  var y;
  (function(d) {
    d[d.curve = 1] = "curve", d[d.private = 2] = "private", d[d.data = 3] = "data";
  })(y || (y = {}));
  class t extends g.RegistryItem {
    constructor(E) {
      super(), this.isECKey = () => !0, this.getCurve = () => this.curve || 0, this.isPrivateKey = () => this.privateKey || !1, this.getData = () => this.data, this.getRegistryType = () => c.RegistryTypes.CRYPTO_ECKEY, this.toDataItem = () => {
        const B = {};
        return this.curve && (B[y.curve] = this.curve), this.privateKey !== void 0 && (B[y.private] = this.privateKey), B[y.data] = this.data, new o.DataItem(B);
      }, this.getOutputDescriptorContent = () => this.data.toString("hex"), this.data = E.data, this.curve = E.curve, this.privateKey = E.privateKey || void 0;
    }
  }
  return CryptoECKey$2.CryptoECKey = t, t.fromDataItem = (d) => {
    const E = d.getData(), B = E[y.curve], D = E[y.private], x = E[y.data];
    if (!x)
      throw new Error(`#[ur-registry][CryptoECKey][fn.fromDataItem]: decoded [dataItem][#data.data] is undefined: ${d}`);
    return new t({ data: x, curve: B, privateKey: D });
  }, t.fromCBOR = (d) => {
    const E = (0, o.decodeToDataItem)(d);
    return t.fromDataItem(E);
  }, CryptoECKey$2;
}
var Bytes$2 = {}, hasRequiredBytes$4;
function requireBytes$4() {
  if (hasRequiredBytes$4) return Bytes$2;
  hasRequiredBytes$4 = 1, Object.defineProperty(Bytes$2, "__esModule", { value: !0 }), Bytes$2.Bytes = void 0;
  const o = requireLib$8(), g = requireRegistryItem$2(), c = requireRegistryType$3();
  class y extends g.RegistryItem {
    constructor(d) {
      super(), this.bytes = d, this.getRegistryType = () => c.RegistryTypes.BYTES, this.getData = () => this.bytes, this.toDataItem = () => new o.DataItem(this.bytes);
    }
  }
  return Bytes$2.Bytes = y, y.fromDataItem = (t) => {
    const d = t.getData();
    if (!d)
      throw new Error(`#[ur-registry][Bytes][fn.fromDataItem]: decoded [dataItem][#data] is undefined: ${t}`);
    return new y(d);
  }, y.fromCBOR = (t) => {
    const d = (0, o.decodeToDataItem)(t);
    return y.fromDataItem(d);
  }, Bytes$2;
}
var CryptoOutput$2 = {}, MultiKey$2 = {}, hasRequiredMultiKey$2;
function requireMultiKey$2() {
  if (hasRequiredMultiKey$2) return MultiKey$2;
  hasRequiredMultiKey$2 = 1, Object.defineProperty(MultiKey$2, "__esModule", { value: !0 }), MultiKey$2.MultiKey = void 0;
  const o = requireCryptoECKey$2(), g = requireCryptoHDKey$2(), c = requireDataItem$2(), y = requireRegistryItem$2(), t = requireRegistryType$3();
  var d;
  (function(B) {
    B[B.threshold = 1] = "threshold", B[B.keys = 2] = "keys";
  })(d || (d = {}));
  class E extends y.RegistryItem {
    constructor(D, x) {
      super(), this.threshold = D, this.keys = x, this.getThreshold = () => this.threshold, this.getKeys = () => this.keys, this.toDataItem = () => {
        const v = {};
        v[d.threshold] = this.threshold;
        const F = this.keys.map((M) => {
          const U = M.toDataItem();
          return U.setTag(M.getRegistryType().getTag()), U;
        });
        return v[d.keys] = F, new c.DataItem(v);
      }, this.getOutputDescriptorContent = () => [
        this.getThreshold(),
        this.keys.map((v) => v.getOutputDescriptorContent()).join(",")
      ].join(",");
    }
  }
  return MultiKey$2.MultiKey = E, E.fromDataItem = (B) => {
    const D = B.getData(), x = D[d.threshold], v = D[d.keys], F = [];
    return v.forEach((M) => {
      M.getTag() === t.RegistryTypes.CRYPTO_HDKEY.getTag() ? F.push(g.CryptoHDKey.fromDataItem(M)) : M.getTag() === t.RegistryTypes.CRYPTO_ECKEY.getTag() && F.push(o.CryptoECKey.fromDataItem(M));
    }), new E(x, F);
  }, MultiKey$2;
}
var hasRequiredCryptoOutput$2;
function requireCryptoOutput$2() {
  if (hasRequiredCryptoOutput$2) return CryptoOutput$2;
  hasRequiredCryptoOutput$2 = 1, Object.defineProperty(CryptoOutput$2, "__esModule", { value: !0 }), CryptoOutput$2.CryptoOutput = void 0;
  const o = requireCryptoECKey$2(), g = requireCryptoHDKey$2(), c = requireLib$8(), y = requireMultiKey$2(), t = requireRegistryItem$2(), d = requireRegistryType$3(), E = requireScriptExpression$2();
  class B extends t.RegistryItem {
    constructor(x, v) {
      super(), this.scriptExpressions = x, this.cryptoKey = v, this.getRegistryType = () => d.RegistryTypes.CRYPTO_OUTPUT, this.getCryptoKey = () => this.cryptoKey, this.getHDKey = () => {
        if (this.cryptoKey instanceof g.CryptoHDKey)
          return this.cryptoKey;
      }, this.getECKey = () => {
        if (this.cryptoKey instanceof o.CryptoECKey)
          return this.cryptoKey;
      }, this.getMultiKey = () => {
        if (this.cryptoKey instanceof y.MultiKey)
          return this.cryptoKey;
      }, this.getScriptExpressions = () => this.scriptExpressions, this._toOutputDescriptor = (F) => F >= this.scriptExpressions.length ? this.cryptoKey.getOutputDescriptorContent() : `${this.scriptExpressions[F].getExpression()}(${this._toOutputDescriptor(F + 1)})`, this.toString = () => this._toOutputDescriptor(0), this.toDataItem = () => {
        let F = this.cryptoKey.toDataItem();
        return (this.cryptoKey instanceof o.CryptoECKey || this.cryptoKey instanceof g.CryptoHDKey) && F.setTag(this.cryptoKey.getRegistryType().getTag()), [...this.scriptExpressions].reverse().forEach((U) => {
          const L = U.getTag();
          F.getTag() === void 0 ? F.setTag(L) : F = new c.DataItem(F, L);
        }), F;
      };
    }
  }
  return CryptoOutput$2.CryptoOutput = B, B.fromDataItem = (D) => {
    const x = [];
    let v = D;
    for (; ; ) {
      let U = v.getTag();
      const L = E.ScriptExpression.fromTag(U);
      if (L)
        if (x.push(L), v.getData() instanceof c.DataItem)
          v = v.getData(), U = v.getTag();
        else
          break;
      else
        break;
    }
    const F = x.length;
    if (F > 0 && (x[F - 1].getExpression() === E.ScriptExpressions.MULTISIG.getExpression() || x[F - 1].getExpression() === E.ScriptExpressions.SORTED_MULTISIG.getExpression())) {
      const U = y.MultiKey.fromDataItem(v);
      return new B(x, U);
    }
    if (v.getTag() === d.RegistryTypes.CRYPTO_HDKEY.getTag()) {
      const U = g.CryptoHDKey.fromDataItem(v);
      return new B(x, U);
    } else {
      const U = o.CryptoECKey.fromDataItem(v);
      return new B(x, U);
    }
  }, B.fromCBOR = (D) => {
    const x = (0, c.decodeToDataItem)(D);
    return B.fromDataItem(x);
  }, CryptoOutput$2;
}
var CryptoPSBT$2 = {}, hasRequiredCryptoPSBT$2;
function requireCryptoPSBT$2() {
  if (hasRequiredCryptoPSBT$2) return CryptoPSBT$2;
  hasRequiredCryptoPSBT$2 = 1, Object.defineProperty(CryptoPSBT$2, "__esModule", { value: !0 }), CryptoPSBT$2.CryptoPSBT = void 0;
  const o = requireLib$8(), g = requireRegistryItem$2(), c = requireRegistryType$3();
  class y extends g.RegistryItem {
    constructor(d) {
      super(), this.psbt = d, this.getRegistryType = () => c.RegistryTypes.CRYPTO_PSBT, this.getPSBT = () => this.psbt, this.toDataItem = () => new o.DataItem(this.psbt);
    }
  }
  return CryptoPSBT$2.CryptoPSBT = y, y.fromDataItem = (t) => {
    const d = t.getData();
    if (!d)
      throw new Error(`#[ur-registry][CryptoPSBT][fn.fromDataItem]: decoded [dataItem][#data] is undefined: ${t}`);
    return new y(d);
  }, y.fromCBOR = (t) => {
    const d = (0, o.decodeToDataItem)(t);
    return y.fromDataItem(d);
  }, CryptoPSBT$2;
}
var CryptoPSBTExtend = {}, hasRequiredCryptoPSBTExtend;
function requireCryptoPSBTExtend() {
  return hasRequiredCryptoPSBTExtend || (hasRequiredCryptoPSBTExtend = 1, function(o) {
    Object.defineProperty(o, "__esModule", { value: !0 }), o.CryptoPSBTExtend = o.CoinIds = void 0;
    const g = requireLib$8(), c = requireRegistryItem$2(), y = requireRegistryType$3();
    var t;
    (function(E) {
      E[E.psbt = 1] = "psbt", E[E.coinId = 2] = "coinId";
    })(t || (t = {})), function(E) {
      E[E.Litecoin = 2] = "Litecoin", E[E.Dogecoin = 3] = "Dogecoin", E[E.Dash = 4] = "Dash", E[E.BitcoinCash = 145] = "BitcoinCash";
    }(o.CoinIds || (o.CoinIds = {}));
    class d extends c.RegistryItem {
      constructor(B, D) {
        super(), this.psbt = B, this.coinId = D, this.getRegistryType = () => y.RegistryTypes.CRYPTO_PSBT_EXTEND, this.getPSBT = () => this.psbt, this.getCoinId = () => this.coinId, this.toDataItem = () => {
          const x = {};
          return x[t.psbt] = this.psbt, x[t.coinId] = this.coinId, new g.DataItem(x);
        };
      }
    }
    o.CryptoPSBTExtend = d, d.fromDataItem = (E) => {
      const B = E.getData(), D = B[t.psbt], x = B[t.coinId];
      if (!x)
        throw new Error(`#[ur-registry][CryptoPSBTExtend][fn.fromDataItem]: decoded [dataItem][#data][coinId] is undefined: ${E}`);
      if (!D)
        throw new Error(`#[ur-registry][CryptoPSBTExtend][fn.fromDataItem]: decoded [dataItem][#data] is undefined: ${E}`);
      return new d(D, x);
    }, d.fromCBOR = (E) => {
      const B = (0, g.decodeToDataItem)(E);
      return d.fromDataItem(B);
    };
  }(CryptoPSBTExtend)), CryptoPSBTExtend;
}
var CryptoAccount$2 = {}, hasRequiredCryptoAccount$2;
function requireCryptoAccount$2() {
  if (hasRequiredCryptoAccount$2) return CryptoAccount$2;
  hasRequiredCryptoAccount$2 = 1, Object.defineProperty(CryptoAccount$2, "__esModule", { value: !0 }), CryptoAccount$2.CryptoAccount = void 0;
  const o = requireDist$o(), g = requireLib$8(), c = requireRegistryItem$2(), y = requireRegistryType$3();
  var t;
  (function(E) {
    E[E.masterFingerprint = 1] = "masterFingerprint", E[E.outputDescriptors = 2] = "outputDescriptors";
  })(t || (t = {}));
  class d extends c.RegistryItem {
    constructor(B, D) {
      super(), this.masterFingerprint = B, this.outputDescriptors = D, this.getRegistryType = () => y.RegistryTypes.CRYPTO_ACCOUNT, this.getMasterFingerprint = () => this.masterFingerprint, this.getOutputDescriptors = () => this.outputDescriptors, this.toDataItem = () => {
        const x = {};
        return this.masterFingerprint && (x[t.masterFingerprint] = this.masterFingerprint.readUInt32BE(0)), this.outputDescriptors && (x[t.outputDescriptors] = this.outputDescriptors.map((v) => v.toDataItem())), new g.DataItem(x);
      };
    }
  }
  return CryptoAccount$2.CryptoAccount = d, d.fromDataItem = (E) => {
    const B = E.getData(), D = Buffer.alloc(4), x = B[t.masterFingerprint];
    x && D.writeUInt32BE(x, 0);
    const F = B[t.outputDescriptors].map((M) => o.CryptoOutput.fromDataItem(M));
    return new d(D, F);
  }, d.fromCBOR = (E) => {
    const B = (0, g.decodeToDataItem)(E);
    return d.fromDataItem(B);
  }, CryptoAccount$2;
}
var Decoder$2 = {}, errors$4 = {}, hasRequiredErrors$4;
function requireErrors$4() {
  if (hasRequiredErrors$4) return errors$4;
  hasRequiredErrors$4 = 1, Object.defineProperty(errors$4, "__esModule", { value: !0 }), errors$4.UnknownURTypeError = void 0;
  class o extends Error {
    constructor(c) {
      super(c);
    }
  }
  return errors$4.UnknownURTypeError = o, errors$4;
}
var hasRequiredDecoder$2;
function requireDecoder$2() {
  if (hasRequiredDecoder$2) return Decoder$2;
  hasRequiredDecoder$2 = 1, Object.defineProperty(Decoder$2, "__esModule", { value: !0 }), Decoder$2.URRegistryDecoder = void 0;
  const o = requireDist$p(), g = requireDist$o(), c = requireRegistryType$3(), y = requireErrors$4();
  class t extends o.URDecoder {
    constructor() {
      super(...arguments), this.resultRegistryType = () => {
        const E = this.resultUR();
        switch (E.type) {
          case c.RegistryTypes.BYTES.getType():
            return g.Bytes.fromCBOR(E.cbor);
          case c.RegistryTypes.CRYPTO_HDKEY.getType():
            return g.CryptoHDKey.fromCBOR(E.cbor);
          case c.RegistryTypes.CRYPTO_KEYPATH.getType():
            return g.CryptoKeypath.fromCBOR(E.cbor);
          case c.RegistryTypes.CRYPTO_COIN_INFO.getType():
            return g.CryptoCoinInfo.fromCBOR(E.cbor);
          case c.RegistryTypes.CRYPTO_ECKEY.getType():
            return g.CryptoECKey.fromCBOR(E.cbor);
          case c.RegistryTypes.CRYPTO_OUTPUT.getType():
            return g.CryptoOutput.fromCBOR(E.cbor);
          case c.RegistryTypes.CRYPTO_PSBT.getType():
            return g.CryptoPSBT.fromCBOR(E.cbor);
          case c.RegistryTypes.CRYPTO_PSBT_EXTEND.getType():
            return g.CryptoPSBTExtend.fromCBOR(E.cbor);
          case c.RegistryTypes.CRYPTO_ACCOUNT.getType():
            return g.CryptoAccount.fromCBOR(E.cbor);
          default:
            throw new y.UnknownURTypeError(`#[ur-registry][Decoder][fn.resultRegistryType]: registry type ${E.type} is not supported now`);
        }
      };
    }
  }
  return Decoder$2.URRegistryDecoder = t, Decoder$2;
}
var CryptoMultiAccounts$2 = {}, hasRequiredCryptoMultiAccounts$2;
function requireCryptoMultiAccounts$2() {
  if (hasRequiredCryptoMultiAccounts$2) return CryptoMultiAccounts$2;
  hasRequiredCryptoMultiAccounts$2 = 1, Object.defineProperty(CryptoMultiAccounts$2, "__esModule", { value: !0 }), CryptoMultiAccounts$2.CryptoMultiAccounts = void 0;
  const o = requireRegistryType$3(), g = requireCryptoHDKey$2(), c = requireRegistryItem$2(), y = requireLib$8();
  var t;
  (function(E) {
    E[E.masterFingerprint = 1] = "masterFingerprint", E[E.keys = 2] = "keys", E[E.device = 3] = "device", E[E.deviceId = 4] = "deviceId", E[E.version = 5] = "version";
  })(t || (t = {}));
  class d extends c.RegistryItem {
    constructor(B, D, x, v, F) {
      super(), this.masterFingerprint = B, this.keys = D, this.device = x, this.deviceId = v, this.version = F, this.getRegistryType = () => o.RegistryTypes.CRYPTO_MULTI_ACCOUNTS, this.getMasterFingerprint = () => this.masterFingerprint, this.getKeys = () => this.keys, this.getDevice = () => this.device, this.getDeviceId = () => this.deviceId, this.getVersion = () => this.version, this.toDataItem = () => {
        const M = {};
        return this.masterFingerprint && (M[t.masterFingerprint] = this.masterFingerprint.readUInt32BE(0)), this.keys && (M[t.keys] = this.keys.map((U) => {
          const L = U.toDataItem();
          return L.setTag(U.getRegistryType().getTag()), L;
        })), this.device && (M[t.device] = this.device), this.deviceId && (M[t.deviceId] = this.deviceId), this.version && (M[t.version] = this.version), new y.DataItem(M);
      };
    }
  }
  return CryptoMultiAccounts$2.CryptoMultiAccounts = d, d.fromDataItem = (E) => {
    const B = E.getData(), D = Buffer.alloc(4), x = B[t.masterFingerprint];
    x && D.writeUInt32BE(x, 0);
    const F = B[t.keys].map((H) => g.CryptoHDKey.fromDataItem(H)), M = B[t.device], U = B[t.deviceId], L = B[t.version];
    return new d(D, F, M, U, L);
  }, d.fromCBOR = (E) => {
    const B = (0, y.decodeToDataItem)(E);
    return d.fromDataItem(B);
  }, CryptoMultiAccounts$2;
}
var QRHardwareCall$2 = {}, KeyDerivation$2 = {}, DerivationSchema$2 = {}, hasRequiredDerivationSchema$2;
function requireDerivationSchema$2() {
  return hasRequiredDerivationSchema$2 || (hasRequiredDerivationSchema$2 = 1, function(o) {
    Object.defineProperty(o, "__esModule", { value: !0 }), o.KeyDerivationSchema = o.DerivationAlgorithm = o.Curve = void 0;
    const g = requireRegistryType$3(), c = requireRegistryItem$2(), y = requireLib$8(), t = requireCryptoKeypath$2();
    var d;
    (function(x) {
      x[x.keyPath = 1] = "keyPath", x[x.curve = 2] = "curve", x[x.algo = 3] = "algo", x[x.chainType = 4] = "chainType";
    })(d || (d = {}));
    var E;
    (function(x) {
      x[x.secp256k1 = 0] = "secp256k1", x[x.ed25519 = 1] = "ed25519";
    })(E = o.Curve || (o.Curve = {}));
    var B;
    (function(x) {
      x[x.slip10 = 0] = "slip10", x[x.bip32ed25519 = 1] = "bip32ed25519";
    })(B = o.DerivationAlgorithm || (o.DerivationAlgorithm = {}));
    class D extends c.RegistryItem {
      constructor(v, F = E.secp256k1, M = B.slip10, U) {
        super(), this.keypath = v, this.curve = F, this.algo = M, this.chainType = U, this.getRegistryType = () => g.RegistryTypes.KEY_DERIVATION_SCHEMA, this.getKeypath = () => this.keypath, this.getCurve = () => this.curve, this.getAlgo = () => this.algo, this.getChainType = () => this.chainType, this.toDataItem = () => {
          const L = {}, H = this.getKeypath().toDataItem();
          return H.setTag(this.getKeypath().getRegistryType().getTag()), L[d.keyPath] = H, L[d.curve] = this.curve, L[d.algo] = this.algo, this.chainType && (L[d.chainType] = this.chainType), new y.DataItem(L);
        };
      }
    }
    o.KeyDerivationSchema = D, D.fromDataItem = (x) => {
      const v = x.getData(), F = t.CryptoKeypath.fromDataItem(v[d.keyPath]), M = v[d.curve], U = v[d.algo], L = v[d.chainType];
      return new D(F, M, U, L);
    }, D.fromCBOR = (x) => {
      const v = (0, y.decodeToDataItem)(x);
      return D.fromDataItem(v);
    };
  }(DerivationSchema$2)), DerivationSchema$2;
}
var hasRequiredKeyDerivation$2;
function requireKeyDerivation$2() {
  if (hasRequiredKeyDerivation$2) return KeyDerivation$2;
  hasRequiredKeyDerivation$2 = 1, Object.defineProperty(KeyDerivation$2, "__esModule", { value: !0 }), KeyDerivation$2.KeyDerivation = void 0;
  const o = requireRegistryType$3(), g = requireRegistryItem$2(), c = requireLib$8(), y = requireDerivationSchema$2();
  var t;
  (function(E) {
    E[E.schemas = 1] = "schemas";
  })(t || (t = {}));
  class d extends g.RegistryItem {
    constructor(B) {
      super(), this.schemas = B, this.getRegistryType = () => o.RegistryTypes.KEY_DERIVATION_CALL, this.getSchemas = () => this.schemas, this.toDataItem = () => {
        const D = {};
        return D[t.schemas] = this.schemas.map((x) => {
          const v = x.toDataItem();
          return v.setTag(x.getRegistryType().getTag()), v;
        }), new c.DataItem(D);
      };
    }
  }
  return KeyDerivation$2.KeyDerivation = d, d.fromDataItem = (E) => {
    const D = E.getData()[t.schemas].map((x) => y.KeyDerivationSchema.fromDataItem(x));
    return new d(D);
  }, d.fromCBOR = (E) => {
    const B = (0, c.decodeToDataItem)(E);
    return d.fromDataItem(B);
  }, KeyDerivation$2;
}
var DeriveContextHashCall = {}, hasRequiredDeriveContextHashCall;
function requireDeriveContextHashCall() {
  if (hasRequiredDeriveContextHashCall) return DeriveContextHashCall;
  hasRequiredDeriveContextHashCall = 1, Object.defineProperty(DeriveContextHashCall, "__esModule", { value: !0 }), DeriveContextHashCall.DeriveContextHashCall = void 0;
  const o = requireRegistryType$3(), g = requireRegistryItem$2(), c = requireLib$8(), y = requireCryptoKeypath$2();
  var t;
  (function(E) {
    E[E.appName = 1] = "appName", E[E.network = 2] = "network", E[E.keyPath = 3] = "keyPath", E[E.context = 4] = "context";
  })(t || (t = {}));
  let d = class extends g.RegistryItem {
    constructor(B, D, x, v) {
      super(), this.appName = B, this.network = D, this.keypath = x, this.context = v, this.getRegistryType = () => o.RegistryTypes.DERIVE_CONTEXT_HASH_CALL, this.getAppName = () => this.appName, this.getNetwork = () => this.network, this.getKeypath = () => this.keypath, this.getContext = () => this.context, this.toDataItem = () => {
        const F = {};
        F[t.appName] = this.appName, F[t.network] = this.network;
        const M = this.getKeypath().toDataItem();
        return M.setTag(this.getKeypath().getRegistryType().getTag()), F[t.keyPath] = M, F[t.context] = this.context, new c.DataItem(F);
      };
    }
  };
  return DeriveContextHashCall.DeriveContextHashCall = d, d.fromDataItem = (E) => {
    const B = E.getData(), D = B[t.appName], x = B[t.network], v = y.CryptoKeypath.fromDataItem(B[t.keyPath]), F = B[t.context];
    return new d(D, x, v, F);
  }, d.fromCBOR = (E) => {
    const B = (0, c.decodeToDataItem)(E);
    return d.fromDataItem(B);
  }, DeriveContextHashCall;
}
var hasRequiredQRHardwareCall$2;
function requireQRHardwareCall$2() {
  return hasRequiredQRHardwareCall$2 || (hasRequiredQRHardwareCall$2 = 1, function(o) {
    Object.defineProperty(o, "__esModule", { value: !0 }), o.QRHardwareCall = o.QRHardwareCallVersion = o.QRHardwareCallType = void 0;
    const g = requireRegistryType$3(), c = requireRegistryItem$2(), y = requireLib$8(), t = requireKeyDerivation$2(), d = requireDeriveContextHashCall();
    var E;
    (function(x) {
      x[x.type = 1] = "type", x[x.params = 2] = "params", x[x.origin = 3] = "origin", x[x.version = 4] = "version";
    })(E || (E = {}));
    var B;
    (function(x) {
      x[x.KeyDerivation = 0] = "KeyDerivation", x[x.DeriveContextHash = 1] = "DeriveContextHash";
    })(B = o.QRHardwareCallType || (o.QRHardwareCallType = {})), function(x) {
      x[x.V0 = 0] = "V0", x[x.V1 = 1] = "V1";
    }(o.QRHardwareCallVersion || (o.QRHardwareCallVersion = {}));
    class D extends c.RegistryItem {
      constructor(v, F, M, U) {
        super(), this.type = v, this.params = F, this.origin = M, this.version = U, this.getRegistryType = () => g.RegistryTypes.QR_HARDWARE_CALL, this.getType = () => this.type, this.getParams = () => this.params, this.getOrigin = () => this.origin, this.getVersion = () => this.version, this.toDataItem = () => {
          const L = {};
          L[E.type] = this.type;
          const H = this.params.toDataItem();
          return H.setTag(this.params.getRegistryType().getTag()), L[E.params] = H, this.origin && (L[E.origin] = this.origin), this.version && (L[E.version] = this.version), new y.DataItem(L);
        };
      }
    }
    o.QRHardwareCall = D, D.fromDataItem = (x) => {
      const v = x.getData(), F = v[E.type] || B.KeyDerivation;
      let M;
      switch (F) {
        case B.KeyDerivation:
          M = t.KeyDerivation.fromDataItem(v[E.params]);
          break;
        case B.DeriveContextHash:
          M = d.DeriveContextHashCall.fromDataItem(v[E.params]);
          break;
      }
      const U = v[E.origin], L = v[E.version];
      return new D(F, M, U, L);
    }, D.fromCBOR = (x) => {
      const v = (0, y.decodeToDataItem)(x);
      return D.fromDataItem(v);
    };
  }(QRHardwareCall$2)), QRHardwareCall$2;
}
var types$9 = {}, hasRequiredTypes$9;
function requireTypes$9() {
  return hasRequiredTypes$9 || (hasRequiredTypes$9 = 1, Object.defineProperty(types$9, "__esModule", { value: !0 })), types$9;
}
var hasRequiredDist$o;
function requireDist$o() {
  return hasRequiredDist$o || (hasRequiredDist$o = 1, function(o) {
    Object.defineProperty(o, "__esModule", { value: !0 }), o.Buffer = o.extend = o.PathComponent = o.ScriptExpressions = o.MultiKey = o.CryptoPSBTExtend = o.CryptoPSBT = o.CryptoOutput = o.CryptoECKey = o.CryptoCoinInfoNetwork = o.CryptoCoinInfoType = o.CryptoCoinInfo = o.CryptoKeypath = o.CryptoMultiAccounts = o.CryptoHDKey = o.CryptoAccount = o.Bytes = o.URRegistryDecoder = o.DataItem = void 0;
    const g = require$$0$2;
    requirePatchCBOR$2();
    const c = requireBuffer$2();
    Object.defineProperty(o, "Buffer", { enumerable: !0, get: function() {
      return c.Buffer;
    } });
    const y = requireCryptoHDKey$2();
    Object.defineProperty(o, "CryptoHDKey", { enumerable: !0, get: function() {
      return y.CryptoHDKey;
    } });
    const t = requireCryptoKeypath$2();
    Object.defineProperty(o, "CryptoKeypath", { enumerable: !0, get: function() {
      return t.CryptoKeypath;
    } });
    const d = requireCryptoCoinInfo$2();
    Object.defineProperty(o, "CryptoCoinInfo", { enumerable: !0, get: function() {
      return d.CryptoCoinInfo;
    } }), Object.defineProperty(o, "CryptoCoinInfoType", { enumerable: !0, get: function() {
      return d.Type;
    } }), Object.defineProperty(o, "CryptoCoinInfoNetwork", { enumerable: !0, get: function() {
      return d.Network;
    } });
    const E = requireCryptoECKey$2();
    Object.defineProperty(o, "CryptoECKey", { enumerable: !0, get: function() {
      return E.CryptoECKey;
    } });
    const B = requireBytes$4();
    Object.defineProperty(o, "Bytes", { enumerable: !0, get: function() {
      return B.Bytes;
    } });
    const D = requireCryptoOutput$2();
    Object.defineProperty(o, "CryptoOutput", { enumerable: !0, get: function() {
      return D.CryptoOutput;
    } });
    const x = requireCryptoPSBT$2();
    Object.defineProperty(o, "CryptoPSBT", { enumerable: !0, get: function() {
      return x.CryptoPSBT;
    } });
    const v = requireCryptoPSBTExtend();
    Object.defineProperty(o, "CryptoPSBTExtend", { enumerable: !0, get: function() {
      return v.CryptoPSBTExtend;
    } });
    const F = requireCryptoAccount$2();
    Object.defineProperty(o, "CryptoAccount", { enumerable: !0, get: function() {
      return F.CryptoAccount;
    } });
    const M = requireDecoder$2();
    Object.defineProperty(o, "URRegistryDecoder", { enumerable: !0, get: function() {
      return M.URRegistryDecoder;
    } });
    const U = requireMultiKey$2();
    Object.defineProperty(o, "MultiKey", { enumerable: !0, get: function() {
      return U.MultiKey;
    } });
    const L = requireScriptExpression$2();
    Object.defineProperty(o, "ScriptExpressions", { enumerable: !0, get: function() {
      return L.ScriptExpressions;
    } });
    const H = requirePathComponent$2();
    Object.defineProperty(o, "PathComponent", { enumerable: !0, get: function() {
      return H.PathComponent;
    } });
    const fe = requireRegistryItem$2(), ge = requireRegistryType$3(), Ie = requireLib$8();
    var Ee = requireLib$8();
    Object.defineProperty(o, "DataItem", { enumerable: !0, get: function() {
      return Ee.DataItem;
    } });
    const Se = requireUtils$g(), ze = requireCryptoMultiAccounts$2();
    Object.defineProperty(o, "CryptoMultiAccounts", { enumerable: !0, get: function() {
      return ze.CryptoMultiAccounts;
    } });
    const He = {
      URRegistryDecoder: M.URRegistryDecoder,
      Bytes: B.Bytes,
      CryptoAccount: F.CryptoAccount,
      CryptoHDKey: y.CryptoHDKey,
      CryptoMultiAccounts: ze.CryptoMultiAccounts,
      CryptoKeypath: t.CryptoKeypath,
      CryptoCoinInfo: d.CryptoCoinInfo,
      CryptoCoinInfoType: d.Type,
      CryptoCoinInfoNetwork: d.Network,
      CryptoECKey: E.CryptoECKey,
      CryptoOutput: D.CryptoOutput,
      CryptoPSBT: x.CryptoPSBT,
      CryptoPSBTExtend: v.CryptoPSBTExtend,
      MultiKey: U.MultiKey,
      ScriptExpressions: L.ScriptExpressions,
      PathComponent: H.PathComponent
    }, Pe = {
      addReader: Ie.addReader,
      addSemanticDecode: Ie.addSemanticDecode,
      addSemanticEncode: Ie.addSemanticEncode,
      addWriter: Ie.addWriter,
      patchTags: Se.patchTags
    }, De = {
      RegistryTypes: ge.RegistryTypes,
      RegistryItem: fe.RegistryItem,
      RegistryType: ge.RegistryType,
      decodeToDataItem: Ie.decodeToDataItem,
      encodeDataItem: Ie.encodeDataItem,
      cbor: Pe
    };
    o.extend = De, g.__exportStar(requireErrors$4(), o), g.__exportStar(requireDecoder$2(), o), g.__exportStar(requireLib$8(), o), g.__exportStar(requireCryptoAccount$2(), o), g.__exportStar(requireCryptoPSBT$2(), o), g.__exportStar(requireCryptoPSBTExtend(), o), g.__exportStar(requireCryptoHDKey$2(), o), g.__exportStar(requireCryptoMultiAccounts$2(), o), g.__exportStar(requireQRHardwareCall$2(), o), g.__exportStar(requireKeyDerivation$2(), o), g.__exportStar(requireDerivationSchema$2(), o), g.__exportStar(requireDeriveContextHashCall(), o), g.__exportStar(requireCryptoOutput$2(), o), g.__exportStar(requireCryptoCoinInfo$2(), o), g.__exportStar(requireCryptoECKey$2(), o), g.__exportStar(requireMultiKey$2(), o), g.__exportStar(requireCryptoKeypath$2(), o), g.__exportStar(requirePatchCBOR$2(), o), g.__exportStar(requirePathComponent$2(), o), g.__exportStar(requireRegistryItem$2(), o), g.__exportStar(requireRegistryType$3(), o), g.__exportStar(requireTypes$9(), o), g.__exportStar(requireUtils$g(), o), o.default = He;
  }(dist$o)), dist$o;
}
var hasRequiredCrypto$3;
function requireCrypto$3() {
  if (hasRequiredCrypto$3) return crypto$6;
  hasRequiredCrypto$3 = 1, Object.defineProperty(crypto$6, "__esModule", { value: !0 }), crypto$6.pathToKeypath = void 0;
  const o = requireDist$o(), g = (c) => {
    const t = c.replace(/[m|M]\//, "").split("/").map((d) => {
      const E = parseInt(d.replace("'", ""), 10), B = d.endsWith("'");
      return new o.PathComponent({ index: E, hardened: B });
    });
    return new o.CryptoKeypath(t);
  };
  return crypto$6.pathToKeypath = g, crypto$6;
}
var hasRequiredUtils$e;
function requireUtils$e() {
  return hasRequiredUtils$e || (hasRequiredUtils$e = 1, function(o) {
    var g = utils$i && utils$i.__createBinding || (Object.create ? function(y, t, d, E) {
      E === void 0 && (E = d);
      var B = Object.getOwnPropertyDescriptor(t, d);
      (!B || ("get" in B ? !t.__esModule : B.writable || B.configurable)) && (B = { enumerable: !0, get: function() {
        return t[d];
      } }), Object.defineProperty(y, E, B);
    } : function(y, t, d, E) {
      E === void 0 && (E = d), y[E] = t[d];
    }), c = utils$i && utils$i.__exportStar || function(y, t) {
      for (var d in y) d !== "default" && !Object.prototype.hasOwnProperty.call(t, d) && g(t, y, d);
    };
    Object.defineProperty(o, "__esModule", { value: !0 }), c(requireStringHelper(), o), c(requireCrypto$3(), o), c(requireCoin$1(), o);
  }(utils$i)), utils$i;
}
var sdk = {}, chains = {}, bitcoin$1 = {}, dist$m = { exports: {} }, bcUrRegistryBtc_cjs_production_min = {}, dist$l = {}, patchCBOR$1 = {}, utils$f = {}, lib$7 = {}, cborSync$3 = { exports: {} }, DataItem$1 = {}, hasRequiredDataItem$1;
function requireDataItem$1() {
  if (hasRequiredDataItem$1) return DataItem$1;
  hasRequiredDataItem$1 = 1, Object.defineProperty(DataItem$1, "__esModule", { value: !0 }), DataItem$1.DataItem = void 0;
  class o {
    constructor(c, y) {
      this.setTag = (t) => {
        this.tag = t;
      }, this.clearTag = () => {
        this.tag = void 0;
      }, this.getTag = () => this.tag, this.getData = () => this.data, this.data = c, this.tag = y;
    }
  }
  return DataItem$1.DataItem = o, DataItem$1;
}
var cborSync$2 = cborSync$3.exports, hasRequiredCborSync$1;
function requireCborSync$1() {
  return hasRequiredCborSync$1 || (hasRequiredCborSync$1 = 1, function(o) {
    (function(g, c) {
      o.exports ? o.exports = c() : g.CBOR = c();
    })(cborSync$2, function() {
      const { DataItem: g } = requireDataItem$1();
      var c = function() {
        function y(Pe) {
          this.$hex = Pe;
        }
        y.prototype = {
          length: function() {
            return this.$hex.length / 2;
          },
          toString: function(Pe) {
            if (!Pe || Pe === "hex" || Pe === 16)
              return this.$hex;
            if (Pe === "utf-8") {
              for (var De = "", ve = 0; ve < this.$hex.length; ve += 2)
                De += "%" + this.$hex.substring(ve, ve + 2);
              return decodeURIComponent(De);
            }
            if (Pe === "latin") {
              for (var De = [], ve = 0; ve < this.$hex.length; ve += 2)
                De.push(parseInt(this.$hex.substring(ve, ve + 2), 16));
              return String.fromCharCode.apply(String, De);
            }
            throw new Error("Unrecognised format: " + Pe);
          }
        }, y.fromLatinString = function(Pe) {
          for (var De = "", ve = 0; ve < Pe.length; ve++) {
            var Fe = Pe.charCodeAt(ve).toString(16);
            Fe.length === 1 && (Fe = "0" + Fe), De += Fe;
          }
          return new y(De);
        }, y.fromUtf8String = function(Pe) {
          for (var De = encodeURIComponent(Pe), ve = "", Fe = 0; Fe < De.length; Fe++)
            if (De.charAt(Fe) === "%")
              ve += De.substring(Fe + 1, Fe + 3), Fe += 2;
            else {
              var be = De.charCodeAt(Fe).toString(16);
              be.length < 2 && (be = "0" + be), ve += be;
            }
          return new y(ve);
        };
        var t = [], d = {}, E = function(Pe) {
          return function() {
            throw new Error(Pe + " not implemented");
          };
        };
        function B() {
        }
        B.prototype = {
          peekByte: E("peekByte"),
          readByte: E("readByte"),
          readChunk: E("readChunk"),
          readFloat16: function() {
            var Pe = this.readUint16(), De = (Pe & 32767) >> 10, ve = Pe & 1023, Fe = Pe & 32768;
            if (De === 31)
              return ve === 0 ? Fe ? -1 / 0 : 1 / 0 : NaN;
            var be = De ? Math.pow(2, De - 25) * (1024 + ve) : Math.pow(2, -24) * ve;
            return Fe ? -be : be;
          },
          readFloat32: function() {
            var Pe = this.readUint32(), De = (Pe & 2147483647) >> 23, ve = Pe & 8388607, Fe = Pe & 2147483648;
            if (De === 255)
              return ve === 0 ? Fe ? -1 / 0 : 1 / 0 : NaN;
            var be = De ? Math.pow(2, De - 23 - 127) * (8388608 + ve) : Math.pow(2, -149) * ve;
            return Fe ? -be : be;
          },
          readFloat64: function() {
            var Pe = this.readUint32(), De = this.readUint32(), ve = Pe >> 20 & 2047, Fe = (Pe & 1048575) * 4294967296 + De, be = Pe & 2147483648;
            if (ve === 2047)
              return Fe === 0 ? be ? -1 / 0 : 1 / 0 : NaN;
            var Be = ve ? Math.pow(2, ve - 52 - 1023) * (4503599627370496 + Fe) : Math.pow(2, -1074) * Fe;
            return be ? -Be : Be;
          },
          readUint16: function() {
            return this.readByte() * 256 + this.readByte();
          },
          readUint32: function() {
            return this.readUint16() * 65536 + this.readUint16();
          },
          readUint64: function() {
            return this.readUint32() * 4294967296 + this.readUint32();
          }
        };
        function D() {
        }
        D.prototype = {
          writeByte: E("writeByte"),
          result: E("result"),
          writeFloat16: E("writeFloat16"),
          writeFloat32: E("writeFloat32"),
          writeFloat64: E("writeFloat64"),
          writeUint16: function(Pe) {
            this.writeByte(Pe >> 8 & 255), this.writeByte(Pe & 255);
          },
          writeUint32: function(Pe) {
            this.writeUint16(Pe >> 16 & 65535), this.writeUint16(Pe & 65535);
          },
          writeUint64: function(Pe) {
            if (Pe >= 9007199254740992 || Pe <= -9007199254740992)
              throw new Error("Cannot encode Uint64 of: " + Pe + " magnitude to big (floating point errors)");
            this.writeUint32(Math.floor(Pe / 4294967296)), this.writeUint32(Pe % 4294967296);
          },
          writeString: E("writeString"),
          canWriteBinary: function(Pe) {
            return !1;
          },
          writeBinary: E("writeChunk")
        };
        function x(Pe) {
          var De = Pe.readByte(), ve = De >> 5, Fe = De & 31;
          return { type: ve, value: Fe };
        }
        function v(Pe, De) {
          var ve = Pe.value;
          if (ve < 24)
            return ve;
          if (ve == 24)
            return De.readByte();
          if (ve == 25)
            return De.readUint16();
          if (ve == 26)
            return De.readUint32();
          if (ve == 27)
            return De.readUint64();
          if (ve == 31)
            return null;
          E("Additional info: " + ve)();
        }
        function F(Pe, De, ve) {
          ve.writeByte(Pe << 5 | De);
        }
        function M(Pe, De, ve) {
          var Fe = Pe << 5;
          De < 24 ? ve.writeByte(Fe | De) : De < 256 ? (ve.writeByte(Fe | 24), ve.writeByte(De)) : De < 65536 ? (ve.writeByte(Fe | 25), ve.writeUint16(De)) : De < 4294967296 ? (ve.writeByte(Fe | 26), ve.writeUint32(De)) : (ve.writeByte(Fe | 27), ve.writeUint64(De));
        }
        var U = new Error();
        function L(Pe) {
          var De = x(Pe);
          switch (De.type) {
            case 0:
              return v(De, Pe);
            case 1:
              return -1 - v(De, Pe);
            case 2:
              return Pe.readChunk(v(De, Pe));
            case 3:
              var ve = Pe.readChunk(v(De, Pe));
              return ve.toString("utf-8");
            case 4:
            case 5:
              var Fe = v(De, Pe), Et = [];
              if (Fe !== null) {
                De.type === 5 && (Fe *= 2);
                for (var be = 0; be < Fe; be++)
                  Et[be] = L(Pe);
              } else
                for (var Be; (Be = L(Pe)) !== U; )
                  Et.push(Be);
              if (De.type === 5) {
                for (var ke = {}, be = 0; be < Et.length; be += 2)
                  ke[Et[be]] = Et[be + 1];
                return ke;
              } else
                return Et;
            case 6:
              var xe = v(De, Pe), Ne = d[xe], Et = L(Pe);
              return Ne ? Ne(Et) : Et;
            case 7:
              if (De.value === 25)
                return Pe.readFloat16();
              if (De.value === 26)
                return Pe.readFloat32();
              if (De.value === 27)
                return Pe.readFloat64();
              switch (v(De, Pe)) {
                case 20:
                  return !1;
                case 21:
                  return !0;
                case 22:
                  return null;
                case 23:
                  return;
                case null:
                  return U;
                default:
                  throw new Error("Unknown fixed value: " + De.value);
              }
            default:
              throw new Error("Unsupported header: " + JSON.stringify(De));
          }
          throw new Error("not implemented yet");
        }
        function H(Pe, De) {
          for (var ve = 0; ve < t.length; ve++) {
            var Fe = t[ve].fn(Pe);
            if (Fe !== void 0)
              return M(6, t[ve].tag, De), H(Fe, De);
          }
          if (Pe && typeof Pe.toCBOR == "function" && (Pe = Pe.toCBOR()), Pe === !1)
            M(7, 20, De);
          else if (Pe === !0)
            M(7, 21, De);
          else if (Pe === null)
            M(7, 22, De);
          else if (Pe === void 0)
            M(7, 23, De);
          else if (typeof Pe == "number")
            Math.floor(Pe) === Pe && Pe < 9007199254740992 && Pe > -9007199254740992 ? Pe < 0 ? M(1, -1 - Pe, De) : M(0, Pe, De) : (F(7, 27, De), De.writeFloat64(Pe));
          else if (typeof Pe == "string")
            De.writeString(Pe, function(Be) {
              M(3, Be, De);
            });
          else if (De.canWriteBinary(Pe))
            De.writeBinary(Pe, function(Be) {
              M(2, Be, De);
            });
          else if (typeof Pe == "object")
            if (Ie.config.useToJSON && typeof Pe.toJSON == "function" && (Pe = Pe.toJSON()), Array.isArray(Pe)) {
              M(4, Pe.length, De);
              for (var ve = 0; ve < Pe.length; ve++)
                H(Pe[ve], De);
            } else {
              var be = Object.keys(Pe);
              M(5, be.length, De);
              for (var ve = 0; ve < be.length; ve++) {
                const ke = parseInt(be[ve]);
                isNaN(ke) ? (H(be[ve], De), H(Pe[be[ve]], De)) : (H(ke, De), H(Pe[be[ve]], De));
              }
            }
          else
            throw new Error("CBOR encoding not supported: " + Pe);
        }
        var fe = [], ge = [], Ie = {
          config: {
            useToJSON: !0
          },
          addWriter: function(Pe, De) {
            typeof Pe == "string" ? ge.push(function(ve) {
              if (Pe === ve)
                return De(ve);
            }) : ge.push(Pe);
          },
          addReader: function(Pe, De) {
            typeof Pe == "string" ? fe.push(function(ve, Fe) {
              if (Pe === Fe)
                return De(ve, Fe);
            }) : fe.push(Pe);
          },
          encode: function(Pe, De) {
            for (var ve = 0; ve < ge.length; ve++) {
              var Fe = ge[ve], be = Fe(De);
              if (be)
                return H(Pe, be), be.result();
            }
            throw new Error("Unsupported output format: " + De);
          },
          encodeDataItem: function(Pe, De) {
            for (var ve = 0; ve < ge.length; ve++) {
              var Fe = ge[ve], be = Fe(De);
              if (be)
                return Pe.getTag() !== void 0 ? (H(Pe, be), be.result()) : (H(Pe.getData(), be), be.result());
            }
            throw new Error("Unsupported output format: " + De);
          },
          decode: function(Pe, De) {
            for (var ve = 0; ve < fe.length; ve++) {
              var Fe = fe[ve], be = Fe(Pe, De);
              if (be)
                return L(be);
            }
            throw new Error("Unsupported input format: " + De);
          },
          decodeToDataItem: function(Pe, De) {
            for (var ve = 0; ve < fe.length; ve++) {
              var Fe = fe[ve], be = Fe(Pe, De);
              if (be) {
                const Be = L(be);
                return Be instanceof g ? Be : new g(Be);
              }
            }
            throw new Error("Unsupported input format: " + De);
          },
          addSemanticEncode: function(Pe, De) {
            if (typeof Pe != "number" || Pe % 1 !== 0 || Pe < 0)
              throw new Error("Tag must be a positive integer");
            return t.push({ tag: Pe, fn: De }), this;
          },
          addSemanticDecode: function(Pe, De) {
            if (typeof Pe != "number" || Pe % 1 !== 0 || Pe < 0)
              throw new Error("Tag must be a positive integer");
            return d[Pe] = De, this;
          }
        };
        function Ee(Pe) {
          this.buffer = Pe, this.pos = 0;
        }
        Ee.prototype = Object.create(B.prototype), Ee.prototype.peekByte = function() {
          return this.buffer[this.pos];
        }, Ee.prototype.readByte = function() {
          return this.buffer[this.pos++];
        }, Ee.prototype.readUint16 = function() {
          var Pe = this.buffer.readUInt16BE(this.pos);
          return this.pos += 2, Pe;
        }, Ee.prototype.readUint32 = function() {
          var Pe = this.buffer.readUInt32BE(this.pos);
          return this.pos += 4, Pe;
        }, Ee.prototype.readFloat32 = function() {
          var Pe = this.buffer.readFloatBE(this.pos);
          return this.pos += 4, Pe;
        }, Ee.prototype.readFloat64 = function() {
          var Pe = this.buffer.readDoubleBE(this.pos);
          return this.pos += 8, Pe;
        }, Ee.prototype.readChunk = function(Pe) {
          var De = Buffer.alloc(Pe);
          return this.buffer.copy(De, 0, this.pos, this.pos += Pe), De;
        };
        function Se(Pe) {
          this.byteLength = 0, this.defaultBufferLength = 16384, this.latestBuffer = Buffer.alloc(this.defaultBufferLength), this.latestBufferOffset = 0, this.completeBuffers = [], this.stringFormat = Pe;
        }
        Se.prototype = Object.create(D.prototype), Se.prototype.writeByte = function(Pe) {
          this.latestBuffer[this.latestBufferOffset++] = Pe, this.latestBufferOffset >= this.latestBuffer.length && (this.completeBuffers.push(this.latestBuffer), this.latestBuffer = Buffer.alloc(this.defaultBufferLength), this.latestBufferOffset = 0), this.byteLength++;
        }, Se.prototype.writeFloat32 = function(Pe) {
          var De = Buffer.alloc(4);
          De.writeFloatBE(Pe, 0), this.writeBuffer(De);
        }, Se.prototype.writeFloat64 = function(Pe) {
          var De = Buffer.alloc(8);
          De.writeDoubleBE(Pe, 0), this.writeBuffer(De);
        }, Se.prototype.writeString = function(Pe, De) {
          var ve = Buffer.from(Pe, "utf-8");
          De(ve.length), this.writeBuffer(ve);
        }, Se.prototype.canWriteBinary = function(Pe) {
          return Pe instanceof Buffer;
        }, Se.prototype.writeBinary = function(Pe, De) {
          De(Pe.length), this.writeBuffer(Pe);
        }, Se.prototype.writeBuffer = function(Pe) {
          if (!(Pe instanceof Buffer))
            throw new TypeError("BufferWriter only accepts Buffers");
          this.latestBufferOffset ? this.latestBuffer.length - this.latestBufferOffset >= Pe.length ? (Pe.copy(this.latestBuffer, this.latestBufferOffset), this.latestBufferOffset += Pe.length, this.latestBufferOffset >= this.latestBuffer.length && (this.completeBuffers.push(this.latestBuffer), this.latestBuffer = Buffer.alloc(this.defaultBufferLength), this.latestBufferOffset = 0)) : (this.completeBuffers.push(this.latestBuffer.slice(0, this.latestBufferOffset)), this.completeBuffers.push(Pe), this.latestBuffer = Buffer.alloc(this.defaultBufferLength), this.latestBufferOffset = 0) : this.completeBuffers.push(Pe), this.byteLength += Pe.length;
        }, Se.prototype.result = function() {
          for (var Pe = Buffer.alloc(this.byteLength), De = 0, ve = 0; ve < this.completeBuffers.length; ve++) {
            var Fe = this.completeBuffers[ve];
            Fe.copy(Pe, De, 0, Fe.length), De += Fe.length;
          }
          return this.latestBufferOffset && this.latestBuffer.copy(Pe, De, 0, this.latestBufferOffset), this.stringFormat ? Pe.toString(this.stringFormat) : Pe;
        }, typeof Buffer == "function" && (Ie.addReader(function(Pe, De) {
          if (Buffer.isBuffer(Pe))
            return new Ee(Pe);
          if (De === "hex" || De === "base64") {
            var ve = Buffer.from(Pe, De);
            return new Ee(ve);
          }
        }), Ie.addWriter(function(Pe) {
          if (!Pe || Pe === "buffer")
            return new Se();
          if (Pe === "hex" || Pe === "base64")
            return new Se(Pe);
        }));
        function ze(Pe) {
          this.hex = Pe, this.pos = 0;
        }
        ze.prototype = Object.create(B.prototype), ze.prototype.peekByte = function() {
          var Pe = this.hex.substring(this.pos, 2);
          return parseInt(Pe, 16);
        }, ze.prototype.readByte = function() {
          var Pe = this.hex.substring(this.pos, this.pos + 2);
          return this.pos += 2, parseInt(Pe, 16);
        }, ze.prototype.readChunk = function(Pe) {
          var De = this.hex.substring(this.pos, this.pos + Pe * 2);
          return this.pos += Pe * 2, typeof Buffer == "function" ? Buffer.from(De, "hex") : new y(De);
        };
        function He(Pe) {
          this.$hex = "", this.finalFormat = Pe || "hex";
        }
        return He.prototype = Object.create(D.prototype), He.prototype.writeByte = function(Pe) {
          if (Pe < 0 || Pe > 255)
            throw new Error("Byte value out of range: " + Pe);
          var De = Pe.toString(16);
          De.length == 1 && (De = "0" + De), this.$hex += De;
        }, He.prototype.canWriteBinary = function(Pe) {
          return Pe instanceof y || typeof Buffer == "function" && Pe instanceof Buffer;
        }, He.prototype.writeBinary = function(Pe, De) {
          if (Pe instanceof y)
            De(Pe.length()), this.$hex += Pe.$hex;
          else if (typeof Buffer == "function" && Pe instanceof Buffer)
            De(Pe.length), this.$hex += Pe.toString("hex");
          else
            throw new TypeError("HexWriter only accepts BinaryHex or Buffers");
        }, He.prototype.result = function() {
          return this.finalFormat === "buffer" && typeof Buffer == "function" ? Buffer.from(this.$hex, "hex") : new y(this.$hex).toString(this.finalFormat);
        }, He.prototype.writeString = function(Pe, De) {
          var ve = y.fromUtf8String(Pe);
          De(ve.length()), this.$hex += ve.$hex;
        }, Ie.addReader(function(Pe, De) {
          if (Pe instanceof y || Pe.$hex)
            return new ze(Pe.$hex);
          if (De === "hex")
            return new ze(Pe);
        }), Ie.addWriter(function(Pe) {
          if (Pe === "hex")
            return new He();
        }), Ie;
      }();
      return c.addSemanticEncode(0, function(y) {
        if (y instanceof Date)
          return y.toISOString();
      }).addSemanticDecode(0, function(y) {
        return new Date(y);
      }).addSemanticDecode(1, function(y) {
        return new Date(y);
      }), c;
    });
  }(cborSync$3)), cborSync$3.exports;
}
var hasRequiredLib$7;
function requireLib$7() {
  return hasRequiredLib$7 || (hasRequiredLib$7 = 1, function(o) {
    Object.defineProperty(o, "__esModule", { value: !0 }), o.DataItem = o.addWriter = o.addReader = o.addSemanticEncode = o.addSemanticDecode = o.decodeToDataItem = o.encodeDataItem = void 0;
    var g = requireCborSync$1();
    Object.defineProperty(o, "encodeDataItem", { enumerable: !0, get: function() {
      return g.encodeDataItem;
    } }), Object.defineProperty(o, "decodeToDataItem", { enumerable: !0, get: function() {
      return g.decodeToDataItem;
    } }), Object.defineProperty(o, "addSemanticDecode", { enumerable: !0, get: function() {
      return g.addSemanticDecode;
    } }), Object.defineProperty(o, "addSemanticEncode", { enumerable: !0, get: function() {
      return g.addSemanticEncode;
    } }), Object.defineProperty(o, "addReader", { enumerable: !0, get: function() {
      return g.addReader;
    } }), Object.defineProperty(o, "addWriter", { enumerable: !0, get: function() {
      return g.addWriter;
    } });
    var c = requireDataItem$1();
    Object.defineProperty(o, "DataItem", { enumerable: !0, get: function() {
      return c.DataItem;
    } });
  }(lib$7)), lib$7;
}
var hasRequiredUtils$d;
function requireUtils$d() {
  if (hasRequiredUtils$d) return utils$f;
  hasRequiredUtils$d = 1, Object.defineProperty(utils$f, "__esModule", { value: !0 }), utils$f.patchTags = void 0;
  const o = requireLib$7(), g = [], c = (y) => {
    y.forEach((t) => {
      g.find((d) => d === t) || ((0, o.addSemanticEncode)(t, (d) => {
        if (d instanceof o.DataItem && d.getTag() === t)
          return d.getData();
      }), (0, o.addSemanticDecode)(t, (d) => new o.DataItem(d, t)), g.push(t));
    });
  };
  return utils$f.patchTags = c, utils$f;
}
var RegistryType$2 = {}, hasRequiredRegistryType$2;
function requireRegistryType$2() {
  if (hasRequiredRegistryType$2) return RegistryType$2;
  hasRequiredRegistryType$2 = 1, Object.defineProperty(RegistryType$2, "__esModule", { value: !0 }), RegistryType$2.RegistryTypes = RegistryType$2.RegistryType = void 0;
  class o {
    constructor(c, y) {
      this.type = c, this.tag = y, this.getTag = () => this.tag, this.getType = () => this.type;
    }
  }
  return RegistryType$2.RegistryType = o, RegistryType$2.RegistryTypes = {
    UUID: new o("uuid", 37),
    BYTES: new o("bytes", void 0),
    CRYPTO_HDKEY: new o("crypto-hdkey", 303),
    CRYPTO_KEYPATH: new o("crypto-keypath", 304),
    CRYPTO_COIN_INFO: new o("crypto-coin-info", 305),
    CRYPTO_ECKEY: new o("crypto-eckey", 306),
    CRYPTO_OUTPUT: new o("crypto-output", 308),
    CRYPTO_PSBT: new o("crypto-psbt", 310),
    CRYPTO_ACCOUNT: new o("crypto-account", 311),
    CRYPTO_MULTI_ACCOUNTS: new o("crypto-multi-accounts", 1103),
    QR_HARDWARE_CALL: new o("qr-hardware-call", 1201),
    KEY_DERIVATION_CALL: new o("key-derivation-call", 1301),
    KEY_DERIVATION_SCHEMA: new o("key-derivation-schema", 1302)
  }, RegistryType$2;
}
var ScriptExpression$1 = {}, hasRequiredScriptExpression$1;
function requireScriptExpression$1() {
  return hasRequiredScriptExpression$1 || (hasRequiredScriptExpression$1 = 1, function(o) {
    Object.defineProperty(o, "__esModule", { value: !0 }), o.ScriptExpressions = o.ScriptExpression = void 0;
    class g {
      constructor(y, t) {
        this.tag = y, this.expression = t, this.getTag = () => this.tag, this.getExpression = () => this.expression;
      }
    }
    o.ScriptExpression = g, g.fromTag = (c) => Object.values(o.ScriptExpressions).find((t) => t.getTag() === c), o.ScriptExpressions = {
      SCRIPT_HASH: new g(400, "sh"),
      WITNESS_SCRIPT_HASH: new g(401, "wsh"),
      PUBLIC_KEY: new g(402, "pk"),
      PUBLIC_KEY_HASH: new g(403, "pkh"),
      WITNESS_PUBLIC_KEY_HASH: new g(404, "wpkh"),
      COMBO: new g(405, "combo"),
      MULTISIG: new g(406, "multi"),
      SORTED_MULTISIG: new g(407, "sortedmulti"),
      ADDRESS: new g(307, "addr"),
      RAW_SCRIPT: new g(408, "raw")
    };
  }(ScriptExpression$1)), ScriptExpression$1;
}
var hasRequiredPatchCBOR$1;
function requirePatchCBOR$1() {
  if (hasRequiredPatchCBOR$1) return patchCBOR$1;
  hasRequiredPatchCBOR$1 = 1, Object.defineProperty(patchCBOR$1, "__esModule", { value: !0 });
  const o = requireUtils$d(), g = requireRegistryType$2(), c = requireScriptExpression$1(), y = Object.values(g.RegistryTypes).filter((d) => !!d.getTag()).map((d) => d.getTag()), t = Object.values(c.ScriptExpressions).map((d) => d.getTag());
  return (0, o.patchTags)(y.concat(t)), patchCBOR$1;
}
var CryptoHDKey$1 = {}, CryptoCoinInfo$1 = {}, RegistryItem$1 = {}, hasRequiredRegistryItem$1;
function requireRegistryItem$1() {
  if (hasRequiredRegistryItem$1) return RegistryItem$1;
  hasRequiredRegistryItem$1 = 1, Object.defineProperty(RegistryItem$1, "__esModule", { value: !0 }), RegistryItem$1.RegistryItem = void 0;
  const o = requireDist$p(), g = requireLib$7();
  class c {
    constructor() {
      this.toCBOR = () => {
        if (this.toDataItem() === void 0)
          throw new Error(`#[ur-registry][RegistryItem][fn.toCBOR]: registry ${this.getRegistryType()}'s method toDataItem returns undefined`);
        return (0, g.encodeDataItem)(this.toDataItem());
      }, this.toUR = () => new o.UR(this.toCBOR(), this.getRegistryType().getType()), this.toUREncoder = (t, d, E) => {
        const B = this.toUR();
        return new o.UREncoder(B, t, d, E);
      };
    }
  }
  return RegistryItem$1.RegistryItem = c, RegistryItem$1;
}
var hasRequiredCryptoCoinInfo$1;
function requireCryptoCoinInfo$1() {
  return hasRequiredCryptoCoinInfo$1 || (hasRequiredCryptoCoinInfo$1 = 1, function(o) {
    Object.defineProperty(o, "__esModule", { value: !0 }), o.CryptoCoinInfo = o.Network = o.Type = void 0;
    const g = requireLib$7(), c = requireRegistryItem$1(), y = requireRegistryType$2();
    var t;
    (function(D) {
      D.type = "1", D.network = "2";
    })(t || (t = {}));
    var d;
    (function(D) {
      D[D.bitcoin = 0] = "bitcoin";
    })(d = o.Type || (o.Type = {}));
    var E;
    (function(D) {
      D[D.mainnet = 0] = "mainnet", D[D.testnet = 1] = "testnet";
    })(E = o.Network || (o.Network = {}));
    class B extends c.RegistryItem {
      constructor(x, v) {
        super(), this.type = x, this.network = v, this.getRegistryType = () => y.RegistryTypes.CRYPTO_COIN_INFO, this.getType = () => this.type || d.bitcoin, this.getNetwork = () => this.network || E.mainnet, this.toDataItem = () => {
          const F = {};
          return this.type && (F[t.type] = this.type), this.network && (F[t.network] = this.network), new g.DataItem(F);
        };
      }
    }
    o.CryptoCoinInfo = B, B.fromDataItem = (D) => {
      const x = D.getData(), v = x[t.type], F = x[t.network];
      return new B(v, F);
    }, B.fromCBOR = (D) => {
      const x = (0, g.decodeToDataItem)(D);
      return B.fromDataItem(x);
    };
  }(CryptoCoinInfo$1)), CryptoCoinInfo$1;
}
var CryptoKeypath$1 = {}, PathComponent$1 = {}, hasRequiredPathComponent$1;
function requirePathComponent$1() {
  if (hasRequiredPathComponent$1) return PathComponent$1;
  hasRequiredPathComponent$1 = 1, Object.defineProperty(PathComponent$1, "__esModule", { value: !0 }), PathComponent$1.PathComponent = void 0;
  class o {
    constructor(c) {
      if (this.getIndex = () => this.index, this.isWildcard = () => this.wildcard, this.isHardened = () => this.hardened, this.index = c.index, this.hardened = c.hardened, this.index !== void 0 ? this.wildcard = !1 : this.wildcard = !0, this.index && (this.index & o.HARDENED_BIT) !== 0)
        throw new Error(`#[ur-registry][PathComponent][fn.constructor]: Invalid index ${this.index} - most significant bit cannot be set`);
    }
  }
  return PathComponent$1.PathComponent = o, o.HARDENED_BIT = 2147483648, PathComponent$1;
}
var hasRequiredCryptoKeypath$1;
function requireCryptoKeypath$1() {
  if (hasRequiredCryptoKeypath$1) return CryptoKeypath$1;
  hasRequiredCryptoKeypath$1 = 1, Object.defineProperty(CryptoKeypath$1, "__esModule", { value: !0 }), CryptoKeypath$1.CryptoKeypath = void 0;
  const o = requireLib$7(), g = requirePathComponent$1(), c = requireRegistryItem$1(), y = requireRegistryType$2();
  var t;
  (function(E) {
    E[E.components = 1] = "components", E[E.source_fingerprint = 2] = "source_fingerprint", E[E.depth = 3] = "depth";
  })(t || (t = {}));
  class d extends c.RegistryItem {
    constructor(B = [], D, x) {
      super(), this.components = B, this.sourceFingerprint = D, this.depth = x, this.getRegistryType = () => y.RegistryTypes.CRYPTO_KEYPATH, this.getPath = () => this.components.length === 0 ? void 0 : this.components.map((F) => `${F.isWildcard() ? "*" : F.getIndex()}${F.isHardened() ? "'" : ""}`).join("/"), this.getComponents = () => this.components, this.getSourceFingerprint = () => this.sourceFingerprint, this.getDepth = () => this.depth, this.toDataItem = () => {
        const v = {}, F = [];
        return this.components && this.components.forEach((M) => {
          M.isWildcard() ? F.push([]) : F.push(M.getIndex()), F.push(M.isHardened());
        }), v[t.components] = F, this.sourceFingerprint && (v[t.source_fingerprint] = this.sourceFingerprint.readUInt32BE(0)), this.depth !== void 0 && (v[t.depth] = this.depth), new o.DataItem(v);
      };
    }
  }
  return CryptoKeypath$1.CryptoKeypath = d, d.fromDataItem = (E) => {
    const B = E.getData(), D = [], x = B[t.components];
    if (x)
      for (let U = 0; U < x.length; U += 2) {
        const L = x[U + 1], H = x[U];
        typeof H == "number" ? D.push(new g.PathComponent({ index: H, hardened: L })) : D.push(new g.PathComponent({ hardened: L }));
      }
    const v = B[t.source_fingerprint];
    let F;
    v && (F = Buffer.alloc(4), F.writeUInt32BE(v, 0));
    const M = B[t.depth];
    return new d(D, F, M);
  }, d.fromCBOR = (E) => {
    const B = (0, o.decodeToDataItem)(E);
    return d.fromDataItem(B);
  }, CryptoKeypath$1;
}
var hasRequiredCryptoHDKey$1;
function requireCryptoHDKey$1() {
  if (hasRequiredCryptoHDKey$1) return CryptoHDKey$1;
  hasRequiredCryptoHDKey$1 = 1, Object.defineProperty(CryptoHDKey$1, "__esModule", { value: !0 }), CryptoHDKey$1.CryptoHDKey = void 0;
  const o = requireBs58check$1(), g = requireCryptoCoinInfo$1(), c = requireCryptoKeypath$1(), y = requireLib$7(), t = requireRegistryItem$1(), d = requireRegistryType$2();
  var E;
  (function(D) {
    D[D.is_master = 1] = "is_master", D[D.is_private = 2] = "is_private", D[D.key_data = 3] = "key_data", D[D.chain_code = 4] = "chain_code", D[D.use_info = 5] = "use_info", D[D.origin = 6] = "origin", D[D.children = 7] = "children", D[D.parent_fingerprint = 8] = "parent_fingerprint", D[D.name = 9] = "name", D[D.note = 10] = "note";
  })(E || (E = {}));
  class B extends t.RegistryItem {
    constructor(x) {
      super(), this.isECKey = () => !1, this.getKey = () => this.key, this.getChainCode = () => this.chainCode, this.isMaster = () => this.master, this.isPrivateKey = () => !!this.privateKey, this.getUseInfo = () => this.useInfo, this.getOrigin = () => this.origin, this.getChildren = () => this.children, this.getParentFingerprint = () => this.parentFingerprint, this.getName = () => this.name, this.getNote = () => this.note, this.getBip32Key = () => {
        var v, F, M;
        let U, L, H = 0, fe = Buffer.alloc(4).fill(0);
        if (this.isMaster())
          U = Buffer.from("0488ADE4", "hex"), L = 0, H = 0;
        else {
          L = ((v = this.getOrigin()) === null || v === void 0 ? void 0 : v.getComponents().length) || ((F = this.getOrigin()) === null || F === void 0 ? void 0 : F.getDepth());
          const ze = (M = this.getOrigin()) === null || M === void 0 ? void 0 : M.getComponents(), He = ze[ze.length - 1];
          He && (H = He.isHardened() ? He.getIndex() + 2147483648 : He.getIndex(), this.getParentFingerprint() && (fe = this.getParentFingerprint())), this.isPrivateKey() ? U = Buffer.from("0488ADE4", "hex") : U = Buffer.from("0488B21E", "hex");
        }
        const ge = Buffer.alloc(1);
        ge.writeUInt8(L, 0);
        const Ie = Buffer.alloc(4);
        Ie.writeUInt32BE(H, 0);
        const Ee = this.getChainCode(), Se = this.getKey();
        return (0, o.encode)(Buffer.concat([U, ge, fe, Ie, Ee, Se]));
      }, this.getRegistryType = () => d.RegistryTypes.CRYPTO_HDKEY, this.getOutputDescriptorContent = () => {
        var v, F, M, U, L, H, fe;
        let ge = "";
        return this.getOrigin() && !((v = this.getOrigin()) === null || v === void 0) && v.getSourceFingerprint() && !((F = this.getOrigin()) === null || F === void 0) && F.getPath() && (ge += `${(U = (M = this.getOrigin()) === null || M === void 0 ? void 0 : M.getSourceFingerprint()) === null || U === void 0 ? void 0 : U.toString("hex")}/${(L = this.getOrigin()) === null || L === void 0 ? void 0 : L.getPath()}`), ge += this.getBip32Key(), this.getChildren() && !((H = this.getChildren()) === null || H === void 0) && H.getPath() && (ge += `/${(fe = this.getChildren()) === null || fe === void 0 ? void 0 : fe.getPath()}`), ge;
      }, this.setupMasterKey = (v) => {
        this.master = !0, this.key = v.key, this.chainCode = v.chainCode;
      }, this.setupDeriveKey = (v) => {
        this.master = !1, this.privateKey = v.isPrivateKey, this.key = v.key, this.chainCode = v.chainCode, this.useInfo = v.useInfo, this.origin = v.origin, this.children = v.children, this.parentFingerprint = v.parentFingerprint, this.name = v.name, this.note = v.note;
      }, this.toDataItem = () => {
        const v = {};
        if (this.master)
          v[E.is_master] = !0, v[E.key_data] = this.key, v[E.chain_code] = this.chainCode;
        else {
          if (this.privateKey !== void 0 && (v[E.is_private] = this.privateKey), v[E.key_data] = this.key, this.chainCode && (v[E.chain_code] = this.chainCode), this.useInfo) {
            const F = this.useInfo.toDataItem();
            F.setTag(this.useInfo.getRegistryType().getTag()), v[E.use_info] = F;
          }
          if (this.origin) {
            const F = this.origin.toDataItem();
            F.setTag(this.origin.getRegistryType().getTag()), v[E.origin] = F;
          }
          if (this.children) {
            const F = this.children.toDataItem();
            F.setTag(this.children.getRegistryType().getTag()), v[E.children] = F;
          }
          this.parentFingerprint && (v[E.parent_fingerprint] = this.parentFingerprint.readUInt32BE(0)), this.name !== void 0 && (v[E.name] = this.name), this.note !== void 0 && (v[E.note] = this.note);
        }
        return new y.DataItem(v);
      }, x.isMaster ? this.setupMasterKey(x) : this.setupDeriveKey(x);
    }
  }
  return CryptoHDKey$1.CryptoHDKey = B, B.fromDataItem = (D) => {
    const x = D.getData(), v = !!x[E.is_master], F = x[E.is_private], M = x[E.key_data], U = x[E.chain_code], L = x[E.use_info] ? g.CryptoCoinInfo.fromDataItem(x[E.use_info]) : void 0, H = x[E.origin] ? c.CryptoKeypath.fromDataItem(x[E.origin]) : void 0, fe = x[E.children] ? c.CryptoKeypath.fromDataItem(x[E.children]) : void 0, ge = x[E.parent_fingerprint];
    let Ie;
    ge && (Ie = Buffer.alloc(4), Ie.writeUInt32BE(ge, 0));
    const Ee = x[E.name], Se = x[E.note];
    return new B({
      isMaster: v,
      isPrivateKey: F,
      key: M,
      chainCode: U,
      useInfo: L,
      origin: H,
      children: fe,
      parentFingerprint: Ie,
      name: Ee,
      note: Se
    });
  }, B.fromCBOR = (D) => {
    const x = (0, y.decodeToDataItem)(D);
    return B.fromDataItem(x);
  }, CryptoHDKey$1;
}
var CryptoECKey$1 = {}, hasRequiredCryptoECKey$1;
function requireCryptoECKey$1() {
  if (hasRequiredCryptoECKey$1) return CryptoECKey$1;
  hasRequiredCryptoECKey$1 = 1, Object.defineProperty(CryptoECKey$1, "__esModule", { value: !0 }), CryptoECKey$1.CryptoECKey = void 0;
  const o = requireLib$7(), g = requireRegistryItem$1(), c = requireRegistryType$2();
  var y;
  (function(d) {
    d[d.curve = 1] = "curve", d[d.private = 2] = "private", d[d.data = 3] = "data";
  })(y || (y = {}));
  class t extends g.RegistryItem {
    constructor(E) {
      super(), this.isECKey = () => !0, this.getCurve = () => this.curve || 0, this.isPrivateKey = () => this.privateKey || !1, this.getData = () => this.data, this.getRegistryType = () => c.RegistryTypes.CRYPTO_ECKEY, this.toDataItem = () => {
        const B = {};
        return this.curve && (B[y.curve] = this.curve), this.privateKey !== void 0 && (B[y.private] = this.privateKey), B[y.data] = this.data, new o.DataItem(B);
      }, this.getOutputDescriptorContent = () => this.data.toString("hex"), this.data = E.data, this.curve = E.curve, this.privateKey = E.privateKey || void 0;
    }
  }
  return CryptoECKey$1.CryptoECKey = t, t.fromDataItem = (d) => {
    const E = d.getData(), B = E[y.curve], D = E[y.private], x = E[y.data];
    if (!x)
      throw new Error(`#[ur-registry][CryptoECKey][fn.fromDataItem]: decoded [dataItem][#data.data] is undefined: ${d}`);
    return new t({ data: x, curve: B, privateKey: D });
  }, t.fromCBOR = (d) => {
    const E = (0, o.decodeToDataItem)(d);
    return t.fromDataItem(E);
  }, CryptoECKey$1;
}
var Bytes$1 = {}, hasRequiredBytes$3;
function requireBytes$3() {
  if (hasRequiredBytes$3) return Bytes$1;
  hasRequiredBytes$3 = 1, Object.defineProperty(Bytes$1, "__esModule", { value: !0 }), Bytes$1.Bytes = void 0;
  const o = requireLib$7(), g = requireRegistryItem$1(), c = requireRegistryType$2();
  class y extends g.RegistryItem {
    constructor(d) {
      super(), this.bytes = d, this.getRegistryType = () => c.RegistryTypes.BYTES, this.getData = () => this.bytes, this.toDataItem = () => new o.DataItem(this.bytes);
    }
  }
  return Bytes$1.Bytes = y, y.fromDataItem = (t) => {
    const d = t.getData();
    if (!d)
      throw new Error(`#[ur-registry][Bytes][fn.fromDataItem]: decoded [dataItem][#data] is undefined: ${t}`);
    return new y(d);
  }, y.fromCBOR = (t) => {
    const d = (0, o.decodeToDataItem)(t);
    return y.fromDataItem(d);
  }, Bytes$1;
}
var CryptoOutput$1 = {}, MultiKey$1 = {}, hasRequiredMultiKey$1;
function requireMultiKey$1() {
  if (hasRequiredMultiKey$1) return MultiKey$1;
  hasRequiredMultiKey$1 = 1, Object.defineProperty(MultiKey$1, "__esModule", { value: !0 }), MultiKey$1.MultiKey = void 0;
  const o = requireCryptoECKey$1(), g = requireCryptoHDKey$1(), c = requireDataItem$1(), y = requireRegistryItem$1(), t = requireRegistryType$2();
  var d;
  (function(B) {
    B[B.threshold = 1] = "threshold", B[B.keys = 2] = "keys";
  })(d || (d = {}));
  class E extends y.RegistryItem {
    constructor(D, x) {
      super(), this.threshold = D, this.keys = x, this.getThreshold = () => this.threshold, this.getKeys = () => this.keys, this.toDataItem = () => {
        const v = {};
        v[d.threshold] = this.threshold;
        const F = this.keys.map((M) => {
          const U = M.toDataItem();
          return U.setTag(M.getRegistryType().getTag()), U;
        });
        return v[d.keys] = F, new c.DataItem(v);
      }, this.getOutputDescriptorContent = () => [
        this.getThreshold(),
        this.keys.map((v) => v.getOutputDescriptorContent()).join(",")
      ].join(",");
    }
  }
  return MultiKey$1.MultiKey = E, E.fromDataItem = (B) => {
    const D = B.getData(), x = D[d.threshold], v = D[d.keys], F = [];
    return v.forEach((M) => {
      M.getTag() === t.RegistryTypes.CRYPTO_HDKEY.getTag() ? F.push(g.CryptoHDKey.fromDataItem(M)) : M.getTag() === t.RegistryTypes.CRYPTO_ECKEY.getTag() && F.push(o.CryptoECKey.fromDataItem(M));
    }), new E(x, F);
  }, MultiKey$1;
}
var hasRequiredCryptoOutput$1;
function requireCryptoOutput$1() {
  if (hasRequiredCryptoOutput$1) return CryptoOutput$1;
  hasRequiredCryptoOutput$1 = 1, Object.defineProperty(CryptoOutput$1, "__esModule", { value: !0 }), CryptoOutput$1.CryptoOutput = void 0;
  const o = requireCryptoECKey$1(), g = requireCryptoHDKey$1(), c = requireLib$7(), y = requireMultiKey$1(), t = requireRegistryItem$1(), d = requireRegistryType$2(), E = requireScriptExpression$1();
  class B extends t.RegistryItem {
    constructor(x, v) {
      super(), this.scriptExpressions = x, this.cryptoKey = v, this.getRegistryType = () => d.RegistryTypes.CRYPTO_OUTPUT, this.getCryptoKey = () => this.cryptoKey, this.getHDKey = () => {
        if (this.cryptoKey instanceof g.CryptoHDKey)
          return this.cryptoKey;
      }, this.getECKey = () => {
        if (this.cryptoKey instanceof o.CryptoECKey)
          return this.cryptoKey;
      }, this.getMultiKey = () => {
        if (this.cryptoKey instanceof y.MultiKey)
          return this.cryptoKey;
      }, this.getScriptExpressions = () => this.scriptExpressions, this._toOutputDescriptor = (F) => F >= this.scriptExpressions.length ? this.cryptoKey.getOutputDescriptorContent() : `${this.scriptExpressions[F].getExpression()}(${this._toOutputDescriptor(F + 1)})`, this.toString = () => this._toOutputDescriptor(0), this.toDataItem = () => {
        let F = this.cryptoKey.toDataItem();
        return (this.cryptoKey instanceof o.CryptoECKey || this.cryptoKey instanceof g.CryptoHDKey) && F.setTag(this.cryptoKey.getRegistryType().getTag()), [...this.scriptExpressions].reverse().forEach((U) => {
          const L = U.getTag();
          F.getTag() === void 0 ? F.setTag(L) : F = new c.DataItem(F, L);
        }), F;
      };
    }
  }
  return CryptoOutput$1.CryptoOutput = B, B.fromDataItem = (D) => {
    const x = [];
    let v = D;
    for (; ; ) {
      let U = v.getTag();
      const L = E.ScriptExpression.fromTag(U);
      if (L)
        if (x.push(L), v.getData() instanceof c.DataItem)
          v = v.getData(), U = v.getTag();
        else
          break;
      else
        break;
    }
    const F = x.length;
    if (F > 0 && (x[F - 1].getExpression() === E.ScriptExpressions.MULTISIG.getExpression() || x[F - 1].getExpression() === E.ScriptExpressions.SORTED_MULTISIG.getExpression())) {
      const U = y.MultiKey.fromDataItem(v);
      return new B(x, U);
    }
    if (v.getTag() === d.RegistryTypes.CRYPTO_HDKEY.getTag()) {
      const U = g.CryptoHDKey.fromDataItem(v);
      return new B(x, U);
    } else {
      const U = o.CryptoECKey.fromDataItem(v);
      return new B(x, U);
    }
  }, B.fromCBOR = (D) => {
    const x = (0, c.decodeToDataItem)(D);
    return B.fromDataItem(x);
  }, CryptoOutput$1;
}
var CryptoPSBT$1 = {}, hasRequiredCryptoPSBT$1;
function requireCryptoPSBT$1() {
  if (hasRequiredCryptoPSBT$1) return CryptoPSBT$1;
  hasRequiredCryptoPSBT$1 = 1, Object.defineProperty(CryptoPSBT$1, "__esModule", { value: !0 }), CryptoPSBT$1.CryptoPSBT = void 0;
  const o = requireLib$7(), g = requireRegistryItem$1(), c = requireRegistryType$2();
  class y extends g.RegistryItem {
    constructor(d) {
      super(), this.psbt = d, this.getRegistryType = () => c.RegistryTypes.CRYPTO_PSBT, this.getPSBT = () => this.psbt, this.toDataItem = () => new o.DataItem(this.psbt);
    }
  }
  return CryptoPSBT$1.CryptoPSBT = y, y.fromDataItem = (t) => {
    const d = t.getData();
    if (!d)
      throw new Error(`#[ur-registry][CryptoPSBT][fn.fromDataItem]: decoded [dataItem][#data] is undefined: ${t}`);
    return new y(d);
  }, y.fromCBOR = (t) => {
    const d = (0, o.decodeToDataItem)(t);
    return y.fromDataItem(d);
  }, CryptoPSBT$1;
}
var CryptoAccount$1 = {}, hasRequiredCryptoAccount$1;
function requireCryptoAccount$1() {
  if (hasRequiredCryptoAccount$1) return CryptoAccount$1;
  hasRequiredCryptoAccount$1 = 1, Object.defineProperty(CryptoAccount$1, "__esModule", { value: !0 }), CryptoAccount$1.CryptoAccount = void 0;
  const o = requireDist$n(), g = requireLib$7(), c = requireRegistryItem$1(), y = requireRegistryType$2();
  var t;
  (function(E) {
    E[E.masterFingerprint = 1] = "masterFingerprint", E[E.outputDescriptors = 2] = "outputDescriptors";
  })(t || (t = {}));
  class d extends c.RegistryItem {
    constructor(B, D) {
      super(), this.masterFingerprint = B, this.outputDescriptors = D, this.getRegistryType = () => y.RegistryTypes.CRYPTO_ACCOUNT, this.getMasterFingerprint = () => this.masterFingerprint, this.getOutputDescriptors = () => this.outputDescriptors, this.toDataItem = () => {
        const x = {};
        return this.masterFingerprint && (x[t.masterFingerprint] = this.masterFingerprint.readUInt32BE(0)), this.outputDescriptors && (x[t.outputDescriptors] = this.outputDescriptors.map((v) => v.toDataItem())), new g.DataItem(x);
      };
    }
  }
  return CryptoAccount$1.CryptoAccount = d, d.fromDataItem = (E) => {
    const B = E.getData(), D = Buffer.alloc(4), x = B[t.masterFingerprint];
    x && D.writeUInt32BE(x, 0);
    const F = B[t.outputDescriptors].map((M) => o.CryptoOutput.fromDataItem(M));
    return new d(D, F);
  }, d.fromCBOR = (E) => {
    const B = (0, g.decodeToDataItem)(E);
    return d.fromDataItem(B);
  }, CryptoAccount$1;
}
var Decoder$1 = {}, errors$3 = {}, hasRequiredErrors$3;
function requireErrors$3() {
  if (hasRequiredErrors$3) return errors$3;
  hasRequiredErrors$3 = 1, Object.defineProperty(errors$3, "__esModule", { value: !0 }), errors$3.UnknownURTypeError = void 0;
  class o extends Error {
    constructor(c) {
      super(c);
    }
  }
  return errors$3.UnknownURTypeError = o, errors$3;
}
var hasRequiredDecoder$1;
function requireDecoder$1() {
  if (hasRequiredDecoder$1) return Decoder$1;
  hasRequiredDecoder$1 = 1, Object.defineProperty(Decoder$1, "__esModule", { value: !0 }), Decoder$1.URRegistryDecoder = void 0;
  const o = requireDist$p(), g = requireDist$n(), c = requireRegistryType$2(), y = requireErrors$3();
  class t extends o.URDecoder {
    constructor() {
      super(...arguments), this.resultRegistryType = () => {
        const E = this.resultUR();
        switch (E.type) {
          case c.RegistryTypes.BYTES.getType():
            return g.Bytes.fromCBOR(E.cbor);
          case c.RegistryTypes.CRYPTO_HDKEY.getType():
            return g.CryptoHDKey.fromCBOR(E.cbor);
          case c.RegistryTypes.CRYPTO_KEYPATH.getType():
            return g.CryptoKeypath.fromCBOR(E.cbor);
          case c.RegistryTypes.CRYPTO_COIN_INFO.getType():
            return g.CryptoCoinInfo.fromCBOR(E.cbor);
          case c.RegistryTypes.CRYPTO_ECKEY.getType():
            return g.CryptoECKey.fromCBOR(E.cbor);
          case c.RegistryTypes.CRYPTO_OUTPUT.getType():
            return g.CryptoOutput.fromCBOR(E.cbor);
          case c.RegistryTypes.CRYPTO_PSBT.getType():
            return g.CryptoPSBT.fromCBOR(E.cbor);
          case c.RegistryTypes.CRYPTO_ACCOUNT.getType():
            return g.CryptoAccount.fromCBOR(E.cbor);
          default:
            throw new y.UnknownURTypeError(`#[ur-registry][Decoder][fn.resultRegistryType]: registry type ${E.type} is not supported now`);
        }
      };
    }
  }
  return Decoder$1.URRegistryDecoder = t, Decoder$1;
}
var CryptoMultiAccounts$1 = {}, hasRequiredCryptoMultiAccounts$1;
function requireCryptoMultiAccounts$1() {
  if (hasRequiredCryptoMultiAccounts$1) return CryptoMultiAccounts$1;
  hasRequiredCryptoMultiAccounts$1 = 1, Object.defineProperty(CryptoMultiAccounts$1, "__esModule", { value: !0 }), CryptoMultiAccounts$1.CryptoMultiAccounts = void 0;
  const o = requireRegistryType$2(), g = requireCryptoHDKey$1(), c = requireRegistryItem$1(), y = requireLib$7();
  var t;
  (function(E) {
    E[E.masterFingerprint = 1] = "masterFingerprint", E[E.keys = 2] = "keys", E[E.device = 3] = "device", E[E.deviceId = 4] = "deviceId", E[E.version = 5] = "version";
  })(t || (t = {}));
  class d extends c.RegistryItem {
    constructor(B, D, x, v, F) {
      super(), this.masterFingerprint = B, this.keys = D, this.device = x, this.deviceId = v, this.version = F, this.getRegistryType = () => o.RegistryTypes.CRYPTO_MULTI_ACCOUNTS, this.getMasterFingerprint = () => this.masterFingerprint, this.getKeys = () => this.keys, this.getDevice = () => this.device, this.getDeviceId = () => this.deviceId, this.getVersion = () => this.version, this.toDataItem = () => {
        const M = {};
        return this.masterFingerprint && (M[t.masterFingerprint] = this.masterFingerprint.readUInt32BE(0)), this.keys && (M[t.keys] = this.keys.map((U) => {
          const L = U.toDataItem();
          return L.setTag(U.getRegistryType().getTag()), L;
        })), this.device && (M[t.device] = this.device), this.deviceId && (M[t.deviceId] = this.deviceId), this.version && (M[t.version] = this.version), new y.DataItem(M);
      };
    }
  }
  return CryptoMultiAccounts$1.CryptoMultiAccounts = d, d.fromDataItem = (E) => {
    const B = E.getData(), D = Buffer.alloc(4), x = B[t.masterFingerprint];
    x && D.writeUInt32BE(x, 0);
    const F = B[t.keys].map((H) => g.CryptoHDKey.fromDataItem(H)), M = B[t.device], U = B[t.deviceId], L = B[t.version];
    return new d(D, F, M, U, L);
  }, d.fromCBOR = (E) => {
    const B = (0, y.decodeToDataItem)(E);
    return d.fromDataItem(B);
  }, CryptoMultiAccounts$1;
}
var QRHardwareCall$1 = {}, KeyDerivation$1 = {}, DerivationSchema$1 = {}, hasRequiredDerivationSchema$1;
function requireDerivationSchema$1() {
  return hasRequiredDerivationSchema$1 || (hasRequiredDerivationSchema$1 = 1, function(o) {
    Object.defineProperty(o, "__esModule", { value: !0 }), o.KeyDerivationSchema = o.DerivationAlgorithm = o.Curve = void 0;
    const g = requireRegistryType$2(), c = requireRegistryItem$1(), y = requireLib$7(), t = requireCryptoKeypath$1();
    var d;
    (function(x) {
      x[x.keyPath = 1] = "keyPath", x[x.curve = 2] = "curve", x[x.algo = 3] = "algo";
    })(d || (d = {}));
    var E;
    (function(x) {
      x[x.secp256k1 = 0] = "secp256k1", x[x.ed25519 = 1] = "ed25519";
    })(E = o.Curve || (o.Curve = {}));
    var B;
    (function(x) {
      x[x.slip10 = 0] = "slip10", x[x.bip32ed25519 = 1] = "bip32ed25519";
    })(B = o.DerivationAlgorithm || (o.DerivationAlgorithm = {}));
    class D extends c.RegistryItem {
      constructor(v, F = E.secp256k1, M = B.slip10) {
        super(), this.keypath = v, this.curve = F, this.algo = M, this.getRegistryType = () => g.RegistryTypes.KEY_DERIVATION_SCHEMA, this.getKeypath = () => this.keypath, this.getCurve = () => this.curve, this.getAlgo = () => this.algo, this.toDataItem = () => {
          const U = {}, L = this.getKeypath().toDataItem();
          return L.setTag(this.getKeypath().getRegistryType().getTag()), U[d.keyPath] = L, U[d.curve] = this.curve, U[d.algo] = this.algo, new y.DataItem(U);
        };
      }
    }
    o.KeyDerivationSchema = D, D.fromDataItem = (x) => {
      const v = x.getData(), F = t.CryptoKeypath.fromDataItem(v[d.keyPath]), M = v[d.curve], U = v[d.algo];
      return new D(F, M, U);
    }, D.fromCBOR = (x) => {
      const v = (0, y.decodeToDataItem)(x);
      return D.fromDataItem(v);
    };
  }(DerivationSchema$1)), DerivationSchema$1;
}
var hasRequiredKeyDerivation$1;
function requireKeyDerivation$1() {
  if (hasRequiredKeyDerivation$1) return KeyDerivation$1;
  hasRequiredKeyDerivation$1 = 1, Object.defineProperty(KeyDerivation$1, "__esModule", { value: !0 }), KeyDerivation$1.KeyDerivation = void 0;
  const o = requireRegistryType$2(), g = requireRegistryItem$1(), c = requireLib$7(), y = requireDerivationSchema$1();
  var t;
  (function(E) {
    E[E.schemas = 1] = "schemas";
  })(t || (t = {}));
  class d extends g.RegistryItem {
    constructor(B) {
      super(), this.schemas = B, this.getRegistryType = () => o.RegistryTypes.KEY_DERIVATION_CALL, this.getSchemas = () => this.schemas, this.toDataItem = () => {
        const D = {};
        return D[t.schemas] = this.schemas.map((x) => {
          const v = x.toDataItem();
          return v.setTag(x.getRegistryType().getTag()), v;
        }), new c.DataItem(D);
      };
    }
  }
  return KeyDerivation$1.KeyDerivation = d, d.fromDataItem = (E) => {
    const D = E.getData()[t.schemas].map((x) => y.KeyDerivationSchema.fromDataItem(x));
    return new d(D);
  }, d.fromCBOR = (E) => {
    const B = (0, c.decodeToDataItem)(E);
    return d.fromDataItem(B);
  }, KeyDerivation$1;
}
var hasRequiredQRHardwareCall$1;
function requireQRHardwareCall$1() {
  return hasRequiredQRHardwareCall$1 || (hasRequiredQRHardwareCall$1 = 1, function(o) {
    Object.defineProperty(o, "__esModule", { value: !0 }), o.QRHardwareCall = o.QRHardwareCallType = void 0;
    const g = requireRegistryType$2(), c = requireRegistryItem$1(), y = requireLib$7(), t = requireKeyDerivation$1();
    var d;
    (function(D) {
      D[D.type = 1] = "type", D[D.params = 2] = "params", D[D.origin = 3] = "origin";
    })(d || (d = {}));
    var E;
    (function(D) {
      D[D.KeyDerivation = 0] = "KeyDerivation";
    })(E = o.QRHardwareCallType || (o.QRHardwareCallType = {}));
    class B extends c.RegistryItem {
      constructor(x, v, F) {
        super(), this.type = x, this.params = v, this.origin = F, this.getRegistryType = () => g.RegistryTypes.QR_HARDWARE_CALL, this.getType = () => this.type, this.getParams = () => this.params, this.getOrigin = () => this.origin, this.toDataItem = () => {
          const M = {};
          M[d.type] = this.type;
          const U = this.params.toDataItem();
          return U.setTag(this.params.getRegistryType().getTag()), M[d.params] = U, this.origin && (M[d.origin] = this.origin), new y.DataItem(M);
        };
      }
    }
    o.QRHardwareCall = B, B.fromDataItem = (D) => {
      const x = D.getData(), v = x[d.type] || E.KeyDerivation;
      let F;
      switch (v) {
        case E.KeyDerivation:
          F = t.KeyDerivation.fromDataItem(x[d.params]);
      }
      const M = x[d.origin];
      return new B(v, F, M);
    }, B.fromCBOR = (D) => {
      const x = (0, y.decodeToDataItem)(D);
      return B.fromDataItem(x);
    };
  }(QRHardwareCall$1)), QRHardwareCall$1;
}
var types$8 = {}, hasRequiredTypes$8;
function requireTypes$8() {
  return hasRequiredTypes$8 || (hasRequiredTypes$8 = 1, Object.defineProperty(types$8, "__esModule", { value: !0 })), types$8;
}
var hasRequiredDist$n;
function requireDist$n() {
  return hasRequiredDist$n || (hasRequiredDist$n = 1, function(o) {
    Object.defineProperty(o, "__esModule", { value: !0 }), o.Buffer = o.extend = o.PathComponent = o.ScriptExpressions = o.MultiKey = o.CryptoPSBT = o.CryptoOutput = o.CryptoECKey = o.CryptoCoinInfoNetwork = o.CryptoCoinInfoType = o.CryptoCoinInfo = o.CryptoKeypath = o.CryptoMultiAccounts = o.CryptoHDKey = o.CryptoAccount = o.Bytes = o.URRegistryDecoder = o.DataItem = void 0;
    const g = require$$0$2;
    requirePatchCBOR$1();
    const c = requireBuffer$2();
    Object.defineProperty(o, "Buffer", { enumerable: !0, get: function() {
      return c.Buffer;
    } });
    const y = requireCryptoHDKey$1();
    Object.defineProperty(o, "CryptoHDKey", { enumerable: !0, get: function() {
      return y.CryptoHDKey;
    } });
    const t = requireCryptoKeypath$1();
    Object.defineProperty(o, "CryptoKeypath", { enumerable: !0, get: function() {
      return t.CryptoKeypath;
    } });
    const d = requireCryptoCoinInfo$1();
    Object.defineProperty(o, "CryptoCoinInfo", { enumerable: !0, get: function() {
      return d.CryptoCoinInfo;
    } }), Object.defineProperty(o, "CryptoCoinInfoType", { enumerable: !0, get: function() {
      return d.Type;
    } }), Object.defineProperty(o, "CryptoCoinInfoNetwork", { enumerable: !0, get: function() {
      return d.Network;
    } });
    const E = requireCryptoECKey$1();
    Object.defineProperty(o, "CryptoECKey", { enumerable: !0, get: function() {
      return E.CryptoECKey;
    } });
    const B = requireBytes$3();
    Object.defineProperty(o, "Bytes", { enumerable: !0, get: function() {
      return B.Bytes;
    } });
    const D = requireCryptoOutput$1();
    Object.defineProperty(o, "CryptoOutput", { enumerable: !0, get: function() {
      return D.CryptoOutput;
    } });
    const x = requireCryptoPSBT$1();
    Object.defineProperty(o, "CryptoPSBT", { enumerable: !0, get: function() {
      return x.CryptoPSBT;
    } });
    const v = requireCryptoAccount$1();
    Object.defineProperty(o, "CryptoAccount", { enumerable: !0, get: function() {
      return v.CryptoAccount;
    } });
    const F = requireDecoder$1();
    Object.defineProperty(o, "URRegistryDecoder", { enumerable: !0, get: function() {
      return F.URRegistryDecoder;
    } });
    const M = requireMultiKey$1();
    Object.defineProperty(o, "MultiKey", { enumerable: !0, get: function() {
      return M.MultiKey;
    } });
    const U = requireScriptExpression$1();
    Object.defineProperty(o, "ScriptExpressions", { enumerable: !0, get: function() {
      return U.ScriptExpressions;
    } });
    const L = requirePathComponent$1();
    Object.defineProperty(o, "PathComponent", { enumerable: !0, get: function() {
      return L.PathComponent;
    } });
    const H = requireRegistryItem$1(), fe = requireRegistryType$2(), ge = requireLib$7();
    var Ie = requireLib$7();
    Object.defineProperty(o, "DataItem", { enumerable: !0, get: function() {
      return Ie.DataItem;
    } });
    const Ee = requireUtils$d(), Se = requireCryptoMultiAccounts$1();
    Object.defineProperty(o, "CryptoMultiAccounts", { enumerable: !0, get: function() {
      return Se.CryptoMultiAccounts;
    } });
    const ze = {
      URRegistryDecoder: F.URRegistryDecoder,
      Bytes: B.Bytes,
      CryptoAccount: v.CryptoAccount,
      CryptoHDKey: y.CryptoHDKey,
      CryptoMultiAccounts: Se.CryptoMultiAccounts,
      CryptoKeypath: t.CryptoKeypath,
      CryptoCoinInfo: d.CryptoCoinInfo,
      CryptoCoinInfoType: d.Type,
      CryptoCoinInfoNetwork: d.Network,
      CryptoECKey: E.CryptoECKey,
      CryptoOutput: D.CryptoOutput,
      CryptoPSBT: x.CryptoPSBT,
      MultiKey: M.MultiKey,
      ScriptExpressions: U.ScriptExpressions,
      PathComponent: L.PathComponent
    }, He = {
      addReader: ge.addReader,
      addSemanticDecode: ge.addSemanticDecode,
      addSemanticEncode: ge.addSemanticEncode,
      addWriter: ge.addWriter,
      patchTags: Ee.patchTags
    }, Pe = {
      RegistryTypes: fe.RegistryTypes,
      RegistryItem: H.RegistryItem,
      RegistryType: fe.RegistryType,
      decodeToDataItem: ge.decodeToDataItem,
      encodeDataItem: ge.encodeDataItem,
      cbor: He
    };
    o.extend = Pe, (0, g.__exportStar)(requireErrors$3(), o), (0, g.__exportStar)(requireDecoder$1(), o), (0, g.__exportStar)(requireLib$7(), o), (0, g.__exportStar)(requireCryptoAccount$1(), o), (0, g.__exportStar)(requireCryptoPSBT$1(), o), (0, g.__exportStar)(requireCryptoHDKey$1(), o), (0, g.__exportStar)(requireCryptoMultiAccounts$1(), o), (0, g.__exportStar)(requireQRHardwareCall$1(), o), (0, g.__exportStar)(requireKeyDerivation$1(), o), (0, g.__exportStar)(requireDerivationSchema$1(), o), (0, g.__exportStar)(requireCryptoOutput$1(), o), (0, g.__exportStar)(requireCryptoCoinInfo$1(), o), (0, g.__exportStar)(requireCryptoECKey$1(), o), (0, g.__exportStar)(requireMultiKey$1(), o), (0, g.__exportStar)(requireCryptoKeypath$1(), o), (0, g.__exportStar)(requirePatchCBOR$1(), o), (0, g.__exportStar)(requirePathComponent$1(), o), (0, g.__exportStar)(requireRegistryItem$1(), o), (0, g.__exportStar)(requireRegistryType$2(), o), (0, g.__exportStar)(requireTypes$8(), o), (0, g.__exportStar)(requireUtils$d(), o), o.default = ze;
  }(dist$l)), dist$l;
}
var getRandomValues$1, rnds8$1 = new Uint8Array(16);
function rng$2() {
  if (!getRandomValues$1 && (getRandomValues$1 = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto < "u" && typeof msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto), !getRandomValues$1))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return getRandomValues$1(rnds8$1);
}
const REGEX = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
function validate$2(o) {
  return typeof o == "string" && REGEX.test(o);
}
var byteToHex$1 = [];
for (var i$1 = 0; i$1 < 256; ++i$1)
  byteToHex$1.push((i$1 + 256).toString(16).substr(1));
function stringify$1(o) {
  var g = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, c = (byteToHex$1[o[g + 0]] + byteToHex$1[o[g + 1]] + byteToHex$1[o[g + 2]] + byteToHex$1[o[g + 3]] + "-" + byteToHex$1[o[g + 4]] + byteToHex$1[o[g + 5]] + "-" + byteToHex$1[o[g + 6]] + byteToHex$1[o[g + 7]] + "-" + byteToHex$1[o[g + 8]] + byteToHex$1[o[g + 9]] + "-" + byteToHex$1[o[g + 10]] + byteToHex$1[o[g + 11]] + byteToHex$1[o[g + 12]] + byteToHex$1[o[g + 13]] + byteToHex$1[o[g + 14]] + byteToHex$1[o[g + 15]]).toLowerCase();
  if (!validate$2(c))
    throw TypeError("Stringified UUID is invalid");
  return c;
}
var _nodeId, _clockseq, _lastMSecs = 0, _lastNSecs = 0;
function v1$1(o, g, c) {
  var y = g && c || 0, t = g || new Array(16);
  o = o || {};
  var d = o.node || _nodeId, E = o.clockseq !== void 0 ? o.clockseq : _clockseq;
  if (d == null || E == null) {
    var B = o.random || (o.rng || rng$2)();
    d == null && (d = _nodeId = [B[0] | 1, B[1], B[2], B[3], B[4], B[5]]), E == null && (E = _clockseq = (B[6] << 8 | B[7]) & 16383);
  }
  var D = o.msecs !== void 0 ? o.msecs : Date.now(), x = o.nsecs !== void 0 ? o.nsecs : _lastNSecs + 1, v = D - _lastMSecs + (x - _lastNSecs) / 1e4;
  if (v < 0 && o.clockseq === void 0 && (E = E + 1 & 16383), (v < 0 || D > _lastMSecs) && o.nsecs === void 0 && (x = 0), x >= 1e4)
    throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
  _lastMSecs = D, _lastNSecs = x, _clockseq = E, D += 122192928e5;
  var F = ((D & 268435455) * 1e4 + x) % 4294967296;
  t[y++] = F >>> 24 & 255, t[y++] = F >>> 16 & 255, t[y++] = F >>> 8 & 255, t[y++] = F & 255;
  var M = D / 4294967296 * 1e4 & 268435455;
  t[y++] = M >>> 8 & 255, t[y++] = M & 255, t[y++] = M >>> 24 & 15 | 16, t[y++] = M >>> 16 & 255, t[y++] = E >>> 8 | 128, t[y++] = E & 255;
  for (var U = 0; U < 6; ++U)
    t[y + U] = d[U];
  return g || stringify$1(t);
}
function parse$1(o) {
  if (!validate$2(o))
    throw TypeError("Invalid UUID");
  var g, c = new Uint8Array(16);
  return c[0] = (g = parseInt(o.slice(0, 8), 16)) >>> 24, c[1] = g >>> 16 & 255, c[2] = g >>> 8 & 255, c[3] = g & 255, c[4] = (g = parseInt(o.slice(9, 13), 16)) >>> 8, c[5] = g & 255, c[6] = (g = parseInt(o.slice(14, 18), 16)) >>> 8, c[7] = g & 255, c[8] = (g = parseInt(o.slice(19, 23), 16)) >>> 8, c[9] = g & 255, c[10] = (g = parseInt(o.slice(24, 36), 16)) / 1099511627776 & 255, c[11] = g / 4294967296 & 255, c[12] = g >>> 24 & 255, c[13] = g >>> 16 & 255, c[14] = g >>> 8 & 255, c[15] = g & 255, c;
}
function stringToBytes(o) {
  o = unescape(encodeURIComponent(o));
  for (var g = [], c = 0; c < o.length; ++c)
    g.push(o.charCodeAt(c));
  return g;
}
var DNS = "6ba7b810-9dad-11d1-80b4-00c04fd430c8", URL$1 = "6ba7b811-9dad-11d1-80b4-00c04fd430c8";
function v35$1(o, g, c) {
  function y(t, d, E, B) {
    if (typeof t == "string" && (t = stringToBytes(t)), typeof d == "string" && (d = parse$1(d)), d.length !== 16)
      throw TypeError("Namespace must be array-like (16 iterable integer values, 0-255)");
    var D = new Uint8Array(16 + t.length);
    if (D.set(d), D.set(t, d.length), D = c(D), D[6] = D[6] & 15 | g, D[8] = D[8] & 63 | 128, E) {
      B = B || 0;
      for (var x = 0; x < 16; ++x)
        E[B + x] = D[x];
      return E;
    }
    return stringify$1(D);
  }
  try {
    y.name = o;
  } catch {
  }
  return y.DNS = DNS, y.URL = URL$1, y;
}
function md5$4(o) {
  if (typeof o == "string") {
    var g = unescape(encodeURIComponent(o));
    o = new Uint8Array(g.length);
    for (var c = 0; c < g.length; ++c)
      o[c] = g.charCodeAt(c);
  }
  return md5ToHexEncodedArray(wordsToMd5(bytesToWords(o), o.length * 8));
}
function md5ToHexEncodedArray(o) {
  for (var g = [], c = o.length * 32, y = "0123456789abcdef", t = 0; t < c; t += 8) {
    var d = o[t >> 5] >>> t % 32 & 255, E = parseInt(y.charAt(d >>> 4 & 15) + y.charAt(d & 15), 16);
    g.push(E);
  }
  return g;
}
function getOutputLength(o) {
  return (o + 64 >>> 9 << 4) + 14 + 1;
}
function wordsToMd5(o, g) {
  o[g >> 5] |= 128 << g % 32, o[getOutputLength(g) - 1] = g;
  for (var c = 1732584193, y = -271733879, t = -1732584194, d = 271733878, E = 0; E < o.length; E += 16) {
    var B = c, D = y, x = t, v = d;
    c = md5ff(c, y, t, d, o[E], 7, -680876936), d = md5ff(d, c, y, t, o[E + 1], 12, -389564586), t = md5ff(t, d, c, y, o[E + 2], 17, 606105819), y = md5ff(y, t, d, c, o[E + 3], 22, -1044525330), c = md5ff(c, y, t, d, o[E + 4], 7, -176418897), d = md5ff(d, c, y, t, o[E + 5], 12, 1200080426), t = md5ff(t, d, c, y, o[E + 6], 17, -1473231341), y = md5ff(y, t, d, c, o[E + 7], 22, -45705983), c = md5ff(c, y, t, d, o[E + 8], 7, 1770035416), d = md5ff(d, c, y, t, o[E + 9], 12, -1958414417), t = md5ff(t, d, c, y, o[E + 10], 17, -42063), y = md5ff(y, t, d, c, o[E + 11], 22, -1990404162), c = md5ff(c, y, t, d, o[E + 12], 7, 1804603682), d = md5ff(d, c, y, t, o[E + 13], 12, -40341101), t = md5ff(t, d, c, y, o[E + 14], 17, -1502002290), y = md5ff(y, t, d, c, o[E + 15], 22, 1236535329), c = md5gg(c, y, t, d, o[E + 1], 5, -165796510), d = md5gg(d, c, y, t, o[E + 6], 9, -1069501632), t = md5gg(t, d, c, y, o[E + 11], 14, 643717713), y = md5gg(y, t, d, c, o[E], 20, -373897302), c = md5gg(c, y, t, d, o[E + 5], 5, -701558691), d = md5gg(d, c, y, t, o[E + 10], 9, 38016083), t = md5gg(t, d, c, y, o[E + 15], 14, -660478335), y = md5gg(y, t, d, c, o[E + 4], 20, -405537848), c = md5gg(c, y, t, d, o[E + 9], 5, 568446438), d = md5gg(d, c, y, t, o[E + 14], 9, -1019803690), t = md5gg(t, d, c, y, o[E + 3], 14, -187363961), y = md5gg(y, t, d, c, o[E + 8], 20, 1163531501), c = md5gg(c, y, t, d, o[E + 13], 5, -1444681467), d = md5gg(d, c, y, t, o[E + 2], 9, -51403784), t = md5gg(t, d, c, y, o[E + 7], 14, 1735328473), y = md5gg(y, t, d, c, o[E + 12], 20, -1926607734), c = md5hh(c, y, t, d, o[E + 5], 4, -378558), d = md5hh(d, c, y, t, o[E + 8], 11, -2022574463), t = md5hh(t, d, c, y, o[E + 11], 16, 1839030562), y = md5hh(y, t, d, c, o[E + 14], 23, -35309556), c = md5hh(c, y, t, d, o[E + 1], 4, -1530992060), d = md5hh(d, c, y, t, o[E + 4], 11, 1272893353), t = md5hh(t, d, c, y, o[E + 7], 16, -155497632), y = md5hh(y, t, d, c, o[E + 10], 23, -1094730640), c = md5hh(c, y, t, d, o[E + 13], 4, 681279174), d = md5hh(d, c, y, t, o[E], 11, -358537222), t = md5hh(t, d, c, y, o[E + 3], 16, -722521979), y = md5hh(y, t, d, c, o[E + 6], 23, 76029189), c = md5hh(c, y, t, d, o[E + 9], 4, -640364487), d = md5hh(d, c, y, t, o[E + 12], 11, -421815835), t = md5hh(t, d, c, y, o[E + 15], 16, 530742520), y = md5hh(y, t, d, c, o[E + 2], 23, -995338651), c = md5ii(c, y, t, d, o[E], 6, -198630844), d = md5ii(d, c, y, t, o[E + 7], 10, 1126891415), t = md5ii(t, d, c, y, o[E + 14], 15, -1416354905), y = md5ii(y, t, d, c, o[E + 5], 21, -57434055), c = md5ii(c, y, t, d, o[E + 12], 6, 1700485571), d = md5ii(d, c, y, t, o[E + 3], 10, -1894986606), t = md5ii(t, d, c, y, o[E + 10], 15, -1051523), y = md5ii(y, t, d, c, o[E + 1], 21, -2054922799), c = md5ii(c, y, t, d, o[E + 8], 6, 1873313359), d = md5ii(d, c, y, t, o[E + 15], 10, -30611744), t = md5ii(t, d, c, y, o[E + 6], 15, -1560198380), y = md5ii(y, t, d, c, o[E + 13], 21, 1309151649), c = md5ii(c, y, t, d, o[E + 4], 6, -145523070), d = md5ii(d, c, y, t, o[E + 11], 10, -1120210379), t = md5ii(t, d, c, y, o[E + 2], 15, 718787259), y = md5ii(y, t, d, c, o[E + 9], 21, -343485551), c = safeAdd(c, B), y = safeAdd(y, D), t = safeAdd(t, x), d = safeAdd(d, v);
  }
  return [c, y, t, d];
}
function bytesToWords(o) {
  if (o.length === 0)
    return [];
  for (var g = o.length * 8, c = new Uint32Array(getOutputLength(g)), y = 0; y < g; y += 8)
    c[y >> 5] |= (o[y / 8] & 255) << y % 32;
  return c;
}
function safeAdd(o, g) {
  var c = (o & 65535) + (g & 65535), y = (o >> 16) + (g >> 16) + (c >> 16);
  return y << 16 | c & 65535;
}
function bitRotateLeft(o, g) {
  return o << g | o >>> 32 - g;
}
function md5cmn(o, g, c, y, t, d) {
  return safeAdd(bitRotateLeft(safeAdd(safeAdd(g, o), safeAdd(y, d)), t), c);
}
function md5ff(o, g, c, y, t, d, E) {
  return md5cmn(g & c | ~g & y, o, g, t, d, E);
}
function md5gg(o, g, c, y, t, d, E) {
  return md5cmn(g & y | c & ~y, o, g, t, d, E);
}
function md5hh(o, g, c, y, t, d, E) {
  return md5cmn(g ^ c ^ y, o, g, t, d, E);
}
function md5ii(o, g, c, y, t, d, E) {
  return md5cmn(c ^ (g | ~y), o, g, t, d, E);
}
var v3$1 = v35$1("v3", 48, md5$4);
function v4$2(o, g, c) {
  o = o || {};
  var y = o.random || (o.rng || rng$2)();
  if (y[6] = y[6] & 15 | 64, y[8] = y[8] & 63 | 128, g) {
    c = c || 0;
    for (var t = 0; t < 16; ++t)
      g[c + t] = y[t];
    return g;
  }
  return stringify$1(y);
}
function f$1(o, g, c, y) {
  switch (o) {
    case 0:
      return g & c ^ ~g & y;
    case 1:
      return g ^ c ^ y;
    case 2:
      return g & c ^ g & y ^ c & y;
    case 3:
      return g ^ c ^ y;
  }
}
function ROTL(o, g) {
  return o << g | o >>> 32 - g;
}
function sha1$3(o) {
  var g = [1518500249, 1859775393, 2400959708, 3395469782], c = [1732584193, 4023233417, 2562383102, 271733878, 3285377520];
  if (typeof o == "string") {
    var y = unescape(encodeURIComponent(o));
    o = [];
    for (var t = 0; t < y.length; ++t)
      o.push(y.charCodeAt(t));
  } else Array.isArray(o) || (o = Array.prototype.slice.call(o));
  o.push(128);
  for (var d = o.length / 4 + 2, E = Math.ceil(d / 16), B = new Array(E), D = 0; D < E; ++D) {
    for (var x = new Uint32Array(16), v = 0; v < 16; ++v)
      x[v] = o[D * 64 + v * 4] << 24 | o[D * 64 + v * 4 + 1] << 16 | o[D * 64 + v * 4 + 2] << 8 | o[D * 64 + v * 4 + 3];
    B[D] = x;
  }
  B[E - 1][14] = (o.length - 1) * 8 / Math.pow(2, 32), B[E - 1][14] = Math.floor(B[E - 1][14]), B[E - 1][15] = (o.length - 1) * 8 & 4294967295;
  for (var F = 0; F < E; ++F) {
    for (var M = new Uint32Array(80), U = 0; U < 16; ++U)
      M[U] = B[F][U];
    for (var L = 16; L < 80; ++L)
      M[L] = ROTL(M[L - 3] ^ M[L - 8] ^ M[L - 14] ^ M[L - 16], 1);
    for (var H = c[0], fe = c[1], ge = c[2], Ie = c[3], Ee = c[4], Se = 0; Se < 80; ++Se) {
      var ze = Math.floor(Se / 20), He = ROTL(H, 5) + f$1(ze, fe, ge, Ie) + Ee + g[ze] + M[Se] >>> 0;
      Ee = Ie, Ie = ge, ge = ROTL(fe, 30) >>> 0, fe = H, H = He;
    }
    c[0] = c[0] + H >>> 0, c[1] = c[1] + fe >>> 0, c[2] = c[2] + ge >>> 0, c[3] = c[3] + Ie >>> 0, c[4] = c[4] + Ee >>> 0;
  }
  return [c[0] >> 24 & 255, c[0] >> 16 & 255, c[0] >> 8 & 255, c[0] & 255, c[1] >> 24 & 255, c[1] >> 16 & 255, c[1] >> 8 & 255, c[1] & 255, c[2] >> 24 & 255, c[2] >> 16 & 255, c[2] >> 8 & 255, c[2] & 255, c[3] >> 24 & 255, c[3] >> 16 & 255, c[3] >> 8 & 255, c[3] & 255, c[4] >> 24 & 255, c[4] >> 16 & 255, c[4] >> 8 & 255, c[4] & 255];
}
var v5$1 = v35$1("v5", 80, sha1$3);
const nil$1 = "00000000-0000-0000-0000-000000000000";
function version$3(o) {
  if (!validate$2(o))
    throw TypeError("Invalid UUID");
  return parseInt(o.substr(14, 1), 16);
}
const esmBrowser = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  NIL: nil$1,
  parse: parse$1,
  stringify: stringify$1,
  v1: v1$1,
  v3: v3$1,
  v4: v4$2,
  v5: v5$1,
  validate: validate$2,
  version: version$3
}, Symbol.toStringTag, { value: "Module" })), require$$1$3 = /* @__PURE__ */ getAugmentedNamespace(esmBrowser);
var hasRequiredBcUrRegistryBtc_cjs_production_min;
function requireBcUrRegistryBtc_cjs_production_min() {
  return hasRequiredBcUrRegistryBtc_cjs_production_min || (hasRequiredBcUrRegistryBtc_cjs_production_min = 1, function(o) {
    Object.defineProperty(o, "__esModule", { value: !0 });
    var g = requireDist$n(), c = require$$1$3;
    const y = { BTC_SIGN_REQUEST: new g.RegistryType("btc-sign-request", 8101), BTC_SIGNATURE: new g.RegistryType("btc-signature", 8102) }, { decodeToDataItem: t, RegistryTypes: d } = g.extend;
    var E, B;
    (E = o.DataType || (o.DataType = {}))[E.message = 1] = "message", function(U) {
      U[U.requestId = 1] = "requestId", U[U.signData = 2] = "signData", U[U.dataType = 3] = "dataType", U[U.derivationPaths = 4] = "derivationPaths", U[U.addresses = 5] = "addresses", U[U.origin = 6] = "origin";
    }(B || (B = {}));
    class D extends g.RegistryItem {
      constructor(L) {
        super(), this.getRegistryType = () => y.BTC_SIGN_REQUEST, this.getRequestId = () => this.requestId, this.getSignData = () => this.signData, this.getDataype = () => this.dataType, this.getDerivationPaths = () => this.derivationPaths.map((H) => H.getPath()), this.getAddress = () => this.addresses, this.getOrigin = () => this.origin, this.toDataItem = () => {
          const H = {};
          return H[B.requestId] = new g.DataItem(this.requestId, d.UUID.getTag()), H[B.signData] = this.signData, H[B.dataType] = this.dataType, H[B.derivationPaths] = this.derivationPaths.map((fe) => {
            const ge = fe.toDataItem();
            return ge.setTag(fe.getRegistryType().getTag()), ge;
          }), this.addresses && (H[B.addresses] = this.addresses), this.origin && (H[B.origin] = this.origin), new g.DataItem(H);
        }, this.requestId = L.requestId, this.signData = L.signData, this.dataType = L.dataType, this.derivationPaths = L.derivationPaths, this.addresses = L.addresses, this.origin = L.origin;
      }
      static constructBtcRequest(L, H, fe, ge, Ie, Ee, Se) {
        const ze = Ie.map((He, Pe) => {
          const De = He.replace(/[m|M]\//, "").split("/").map((ve) => {
            const Fe = parseInt(ve.replace("'", ""));
            let be = !1;
            return ve.endsWith("'") && (be = !0), new g.PathComponent({ index: Fe, hardened: be });
          });
          return new g.CryptoKeypath(De, Buffer.from(H[Pe], "hex"));
        });
        return new D({ requestId: Buffer.from(c.parse(L)), signData: fe, dataType: ge || o.DataType.message, derivationPaths: ze, addresses: Ee || void 0, origin: Se || void 0 });
      }
    }
    D.fromDataItem = (U) => {
      const L = U.getData(), H = L[B.requestId] ? L[B.requestId].getData() : void 0, fe = L[B.signData], ge = L[B.dataType], Ie = L[B.derivationPaths].map((Ee) => g.CryptoKeypath.fromDataItem(Ee));
      return new D({ requestId: H, signData: fe, dataType: ge, derivationPaths: Ie, addresses: L[B.addresses] ? L[B.addresses] : void 0, origin: L[B.origin] ? L[B.origin] : void 0 });
    }, D.fromCBOR = (U) => {
      const L = t(U);
      return D.fromDataItem(L);
    };
    const { RegistryTypes: x, decodeToDataItem: v } = g.extend;
    var F;
    (function(U) {
      U[U.requestId = 1] = "requestId", U[U.signature = 2] = "signature", U[U.publicKey = 3] = "publicKey";
    })(F || (F = {}));
    class M extends g.RegistryItem {
      constructor(L, H, fe) {
        super(), this.getRegistryType = () => y.BTC_SIGNATURE, this.getRequestId = () => this.requestId, this.getSignature = () => this.signature, this.getPublicKey = () => this.publicKey, this.toDataItem = () => {
          const ge = {};
          return ge[F.requestId] = new g.DataItem(this.requestId, x.UUID.getTag()), ge[F.signature] = this.signature, ge[F.publicKey] = this.publicKey, new g.DataItem(ge);
        }, this.signature = L, this.requestId = H, this.publicKey = fe;
      }
    }
    M.fromDataItem = (U) => {
      const L = U.getData(), H = L[F.signature], fe = L[F.requestId].getData();
      return new M(H, fe, L[F.publicKey]);
    }, M.fromCBOR = (U) => {
      const L = v(U);
      return M.fromDataItem(L);
    }, g.patchTags(Object.values(y).filter((U) => !!U.getTag()).map((U) => U.getTag())), Object.keys(g).forEach(function(U) {
      U !== "default" && Object.defineProperty(o, U, { enumerable: !0, get: function() {
        return g[U];
      } });
    }), o.BtcSignRequest = D, o.BtcSignature = M;
  }(bcUrRegistryBtc_cjs_production_min)), bcUrRegistryBtc_cjs_production_min;
}
var bcUrRegistryBtc_cjs_development = {}, hasRequiredBcUrRegistryBtc_cjs_development;
function requireBcUrRegistryBtc_cjs_development() {
  return hasRequiredBcUrRegistryBtc_cjs_development || (hasRequiredBcUrRegistryBtc_cjs_development = 1, function(o) {
    Object.defineProperty(o, "__esModule", { value: !0 });
    var g = requireDist$n(), c = require$$1$3;
    const y = {
      BTC_SIGN_REQUEST: /* @__PURE__ */ new g.RegistryType("btc-sign-request", 8101),
      BTC_SIGNATURE: /* @__PURE__ */ new g.RegistryType("btc-signature", 8102)
    }, {
      decodeToDataItem: t,
      RegistryTypes: d
    } = g.extend;
    (function(M) {
      M[M.message = 1] = "message";
    })(o.DataType || (o.DataType = {}));
    var E;
    (function(M) {
      M[M.requestId = 1] = "requestId", M[M.signData = 2] = "signData", M[M.dataType = 3] = "dataType", M[M.derivationPaths = 4] = "derivationPaths", M[M.addresses = 5] = "addresses", M[M.origin = 6] = "origin";
    })(E || (E = {}));
    class B extends g.RegistryItem {
      constructor(U) {
        super(), this.getRegistryType = () => y.BTC_SIGN_REQUEST, this.getRequestId = () => this.requestId, this.getSignData = () => this.signData, this.getDataype = () => this.dataType, this.getDerivationPaths = () => this.derivationPaths.map((L) => L.getPath()), this.getAddress = () => this.addresses, this.getOrigin = () => this.origin, this.toDataItem = () => {
          const L = {};
          return L[E.requestId] = new g.DataItem(this.requestId, d.UUID.getTag()), L[E.signData] = this.signData, L[E.dataType] = this.dataType, L[E.derivationPaths] = this.derivationPaths.map((H) => {
            const fe = H.toDataItem();
            return fe.setTag(H.getRegistryType().getTag()), fe;
          }), this.addresses && (L[E.addresses] = this.addresses), this.origin && (L[E.origin] = this.origin), new g.DataItem(L);
        }, this.requestId = U.requestId, this.signData = U.signData, this.dataType = U.dataType, this.derivationPaths = U.derivationPaths, this.addresses = U.addresses, this.origin = U.origin;
      }
      static constructBtcRequest(U, L, H, fe, ge, Ie, Ee) {
        const Se = ge.map((ze, He) => {
          const De = ze.replace(/[m|M]\//, "").split("/").map((ve) => {
            const Fe = parseInt(ve.replace("'", ""));
            let be = !1;
            return ve.endsWith("'") && (be = !0), new g.PathComponent({
              index: Fe,
              hardened: be
            });
          });
          return new g.CryptoKeypath(De, Buffer.from(L[He], "hex"));
        });
        return new B({
          requestId: Buffer.from(c.parse(U)),
          signData: H,
          dataType: fe || o.DataType.message,
          derivationPaths: Se,
          addresses: Ie || void 0,
          origin: Ee || void 0
        });
      }
    }
    B.fromDataItem = (M) => {
      const U = M.getData(), L = U[E.requestId] ? U[E.requestId].getData() : void 0, H = U[E.signData], fe = U[E.dataType], ge = U[E.derivationPaths].map((Se) => g.CryptoKeypath.fromDataItem(Se)), Ie = U[E.addresses] ? U[E.addresses] : void 0, Ee = U[E.origin] ? U[E.origin] : void 0;
      return new B({
        requestId: L,
        signData: H,
        dataType: fe,
        derivationPaths: ge,
        addresses: Ie,
        origin: Ee
      });
    }, B.fromCBOR = (M) => {
      const U = t(M);
      return B.fromDataItem(U);
    };
    const {
      RegistryTypes: D,
      decodeToDataItem: x
    } = g.extend;
    var v;
    (function(M) {
      M[M.requestId = 1] = "requestId", M[M.signature = 2] = "signature", M[M.publicKey = 3] = "publicKey";
    })(v || (v = {}));
    class F extends g.RegistryItem {
      constructor(U, L, H) {
        super(), this.getRegistryType = () => y.BTC_SIGNATURE, this.getRequestId = () => this.requestId, this.getSignature = () => this.signature, this.getPublicKey = () => this.publicKey, this.toDataItem = () => {
          const fe = {};
          return fe[v.requestId] = new g.DataItem(this.requestId, D.UUID.getTag()), fe[v.signature] = this.signature, fe[v.publicKey] = this.publicKey, new g.DataItem(fe);
        }, this.signature = U, this.requestId = L, this.publicKey = H;
      }
    }
    F.fromDataItem = (M) => {
      const U = M.getData(), L = U[v.signature], H = U[v.requestId].getData(), fe = U[v.publicKey];
      return new F(L, H, fe);
    }, F.fromCBOR = (M) => {
      const U = x(M);
      return F.fromDataItem(U);
    }, g.patchTags(Object.values(y).filter((M) => !!M.getTag()).map((M) => M.getTag())), Object.keys(g).forEach(function(M) {
      M !== "default" && Object.defineProperty(o, M, {
        enumerable: !0,
        get: function() {
          return g[M];
        }
      });
    }), o.BtcSignRequest = B, o.BtcSignature = F;
  }(bcUrRegistryBtc_cjs_development)), bcUrRegistryBtc_cjs_development;
}
var hasRequiredDist$m;
function requireDist$m() {
  return hasRequiredDist$m || (hasRequiredDist$m = 1, process$1.env.NODE_ENV === "production" ? dist$m.exports = requireBcUrRegistryBtc_cjs_production_min() : dist$m.exports = requireBcUrRegistryBtc_cjs_development()), dist$m.exports;
}
var ur = {}, hasRequiredUr;
function requireUr() {
  return hasRequiredUr || (hasRequiredUr = 1, function(o) {
    Object.defineProperty(o, "__esModule", { value: !0 }), o.URType = o.UR = void 0;
    var g = requireDist$p();
    Object.defineProperty(o, "UR", { enumerable: !0, get: function() {
      return g.UR;
    } });
    var c;
    (function(y) {
      y.CryptoPSBT = "crypto-psbt", y.CryptoPSBTExtend = "crypto-psbt-extend", y.CryptoMultiAccounts = "crypto-multi-accounts", y.CryptoHDKey = "crypto-hdkey", y.CryptoAccount = "crypto-account", y.BtcSignature = "btc-signature", y.ArweaveCryptoAccount = "arweave-crypto-account", y.EthSignature = "eth-signature", y.EthBatchSignature = "eth-batch-signature", y.SolSignature = "sol-signature", y.StellarSignature = "stellar-signature", y.CosmosSignature = "cosmos-signature", y.EvmSignature = "evm-signature", y.AptosSignature = "aptos-signature", y.CardanoSignature = "cardano-signature", y.CardanoSignDataSignature = "cardano-sign-data-signature", y.CardanoSignCip8DataSignature = "cardano-sign-cip8-data-signature", y.CardanoCatalystSignature = "cardano-catalyst-voting-registration-signature", y.TronSignature = "keystone-sign-result", y.KeystoneSignResult = "keystone-sign-result", y.NearSignature = "near-signature", y.ArweaveSignature = "arweave-signature", y.SuiSignature = "sui-signature", y.IotaSignature = "iota-signature", y.XrpAccount = "bytes", y.XrpSignRequest = "bytes", y.XrpSignature = "bytes", y.TonSignature = "ton-signature", y.ZcashPCZT = "zcash-pczt";
    })(c || (o.URType = c = {}));
  }(ur)), ur;
}
var hasRequiredBitcoin$1;
function requireBitcoin$1() {
  if (hasRequiredBitcoin$1) return bitcoin$1;
  hasRequiredBitcoin$1 = 1, Object.defineProperty(bitcoin$1, "__esModule", { value: !0 }), bitcoin$1.KeystoneBitcoinSDK = void 0;
  const o = requireDist$o(), g = requireDist$m(), c = requireUtils$e(), y = requireUr();
  class t {
    constructor(E) {
      this.config = E;
    }
    parsePSBT(E) {
      if (E.type !== y.URType.CryptoPSBT)
        throw new Error("type not match");
      return (0, c.toHex)(o.CryptoPSBT.fromCBOR(E.cbor).getPSBT());
    }
    generatePSBT(E) {
      return new o.CryptoPSBT(E).toUR();
    }
    generateSignRequest({ requestId: E, signData: B, dataType: D, accounts: x, origin: v }) {
      var F;
      const M = [], U = [];
      return x.forEach((L) => {
        var H;
        M.push(new g.CryptoKeypath((0, c.parsePath)(L.path).map((fe) => new g.PathComponent(fe)), (0, c.toBuffer)(L.xfp))), U.push((H = L.address) !== null && H !== void 0 ? H : "");
      }), new g.BtcSignRequest({
        signData: (0, c.toBuffer)(B),
        dataType: D,
        derivationPaths: M,
        requestId: (0, c.uuidParse)(E),
        addresses: U,
        origin: v ?? ((F = this.config) === null || F === void 0 ? void 0 : F.origin)
      }).toUR();
    }
    parseSignature(E) {
      if (E.type !== y.URType.BtcSignature)
        throw new Error("type not match");
      const B = g.BtcSignature.fromCBOR(E.cbor);
      return {
        requestId: (0, c.uuidStringify)(B.getRequestId()),
        signature: (0, c.toHex)(B.getSignature()),
        publicKey: (0, c.toHex)(B.getPublicKey())
      };
    }
  }
  return bitcoin$1.KeystoneBitcoinSDK = t, t.DataType = g.DataType, bitcoin$1;
}
var cosmos = {}, dist$k = { exports: {} }, bcUrRegistryCosmos_cjs_production_min = {}, hasRequiredBcUrRegistryCosmos_cjs_production_min;
function requireBcUrRegistryCosmos_cjs_production_min() {
  return hasRequiredBcUrRegistryCosmos_cjs_production_min || (hasRequiredBcUrRegistryCosmos_cjs_production_min = 1, function(o) {
    Object.defineProperty(o, "__esModule", { value: !0 });
    var g = requireDist$n(), c = require$$1$3;
    const y = { COSMOS_SIGN_REQUEST: new g.RegistryType("cosmos-sign-request", 4101), COSMOS_SIGNATURE: new g.RegistryType("cosmos-signature", 4102) }, { decodeToDataItem: t, RegistryTypes: d } = g.extend;
    var E, B;
    (E = o.SignDataType || (o.SignDataType = {}))[E.amino = 1] = "amino", E[E.direct = 2] = "direct", E[E.textual = 3] = "textual", E[E.message = 4] = "message", function(U) {
      U[U.requestId = 1] = "requestId", U[U.signData = 2] = "signData", U[U.dataType = 3] = "dataType", U[U.derivationPaths = 4] = "derivationPaths", U[U.addresses = 5] = "addresses", U[U.origin = 6] = "origin";
    }(B || (B = {}));
    class D extends g.RegistryItem {
      constructor(L) {
        super(), this.getRegistryType = () => y.COSMOS_SIGN_REQUEST, this.getRequestId = () => this.requestId, this.getSignData = () => this.signData, this.getDataype = () => this.dataType, this.getDerivationPaths = () => this.derivationPaths.map((H) => H.getPath()), this.getAddress = () => this.addresses, this.getOrigin = () => this.origin, this.toDataItem = () => {
          const H = {};
          return H[B.requestId] = new g.DataItem(this.requestId, d.UUID.getTag()), H[B.signData] = this.signData, H[B.dataType] = this.dataType, H[B.derivationPaths] = this.derivationPaths.map((fe) => {
            const ge = fe.toDataItem();
            return ge.setTag(fe.getRegistryType().getTag()), ge;
          }), this.addresses && (H[B.addresses] = this.addresses), this.origin && (H[B.origin] = this.origin), new g.DataItem(H);
        }, this.requestId = L.requestId, this.signData = L.signData, this.dataType = L.dataType, this.derivationPaths = L.derivationPaths, this.addresses = L.addresses, this.origin = L.origin;
      }
      static constructCosmosRequest(L, H, fe, ge, Ie, Ee, Se) {
        const ze = Ie.map((He, Pe) => {
          const De = He.replace(/[m|M]\//, "").split("/").map((ve) => {
            const Fe = parseInt(ve.replace("'", ""));
            let be = !1;
            return ve.endsWith("'") && (be = !0), new g.PathComponent({ index: Fe, hardened: be });
          });
          return new g.CryptoKeypath(De, Buffer.from(H[Pe], "hex"));
        });
        return new D({ requestId: Buffer.from(c.parse(L)), signData: fe, dataType: ge || o.SignDataType.amino, derivationPaths: ze, addresses: Ee || void 0, origin: Se || void 0 });
      }
    }
    D.fromDataItem = (U) => {
      const L = U.getData(), H = L[B.requestId] ? L[B.requestId].getData() : void 0, fe = L[B.signData], ge = L[B.dataType], Ie = L[B.derivationPaths].map((Ee) => g.CryptoKeypath.fromDataItem(Ee));
      return new D({ requestId: H, signData: fe, dataType: ge, derivationPaths: Ie, addresses: L[B.addresses] ? L[B.addresses] : void 0, origin: L[B.origin] ? L[B.origin] : void 0 });
    }, D.fromCBOR = (U) => {
      const L = t(U);
      return D.fromDataItem(L);
    };
    const { RegistryTypes: x, decodeToDataItem: v } = g.extend;
    var F;
    (function(U) {
      U[U.requestId = 1] = "requestId", U[U.signature = 2] = "signature", U[U.publicKey = 3] = "publicKey";
    })(F || (F = {}));
    class M extends g.RegistryItem {
      constructor(L, H, fe) {
        super(), this.getRegistryType = () => y.COSMOS_SIGNATURE, this.getRequestId = () => this.requestId, this.getSignature = () => this.signature, this.getPublicKey = () => this.publicKey, this.toDataItem = () => {
          const ge = {};
          return ge[F.requestId] = new g.DataItem(this.requestId, x.UUID.getTag()), ge[F.signature] = this.signature, ge[F.publicKey] = this.publicKey, new g.DataItem(ge);
        }, this.signature = L, this.requestId = H, this.publicKey = fe;
      }
    }
    M.fromDataItem = (U) => {
      const L = U.getData(), H = L[F.signature], fe = L[F.requestId].getData();
      return new M(H, fe, L[F.publicKey]);
    }, M.fromCBOR = (U) => {
      const L = v(U);
      return M.fromDataItem(L);
    }, g.patchTags(Object.values(y).filter((U) => !!U.getTag()).map((U) => U.getTag())), Object.keys(g).forEach(function(U) {
      U !== "default" && Object.defineProperty(o, U, { enumerable: !0, get: function() {
        return g[U];
      } });
    }), o.CosmosSignRequest = D, o.CosmosSignature = M;
  }(bcUrRegistryCosmos_cjs_production_min)), bcUrRegistryCosmos_cjs_production_min;
}
var bcUrRegistryCosmos_cjs_development = {}, hasRequiredBcUrRegistryCosmos_cjs_development;
function requireBcUrRegistryCosmos_cjs_development() {
  return hasRequiredBcUrRegistryCosmos_cjs_development || (hasRequiredBcUrRegistryCosmos_cjs_development = 1, function(o) {
    Object.defineProperty(o, "__esModule", { value: !0 });
    var g = requireDist$n(), c = require$$1$3;
    const y = {
      COSMOS_SIGN_REQUEST: /* @__PURE__ */ new g.RegistryType("cosmos-sign-request", 4101),
      COSMOS_SIGNATURE: /* @__PURE__ */ new g.RegistryType("cosmos-signature", 4102)
    }, {
      decodeToDataItem: t,
      RegistryTypes: d
    } = g.extend;
    (function(M) {
      M[M.amino = 1] = "amino", M[M.direct = 2] = "direct", M[M.textual = 3] = "textual", M[M.message = 4] = "message";
    })(o.SignDataType || (o.SignDataType = {}));
    var E;
    (function(M) {
      M[M.requestId = 1] = "requestId", M[M.signData = 2] = "signData", M[M.dataType = 3] = "dataType", M[M.derivationPaths = 4] = "derivationPaths", M[M.addresses = 5] = "addresses", M[M.origin = 6] = "origin";
    })(E || (E = {}));
    class B extends g.RegistryItem {
      constructor(U) {
        super(), this.getRegistryType = () => y.COSMOS_SIGN_REQUEST, this.getRequestId = () => this.requestId, this.getSignData = () => this.signData, this.getDataype = () => this.dataType, this.getDerivationPaths = () => this.derivationPaths.map((L) => L.getPath()), this.getAddress = () => this.addresses, this.getOrigin = () => this.origin, this.toDataItem = () => {
          const L = {};
          return L[E.requestId] = new g.DataItem(this.requestId, d.UUID.getTag()), L[E.signData] = this.signData, L[E.dataType] = this.dataType, L[E.derivationPaths] = this.derivationPaths.map((H) => {
            const fe = H.toDataItem();
            return fe.setTag(H.getRegistryType().getTag()), fe;
          }), this.addresses && (L[E.addresses] = this.addresses), this.origin && (L[E.origin] = this.origin), new g.DataItem(L);
        }, this.requestId = U.requestId, this.signData = U.signData, this.dataType = U.dataType, this.derivationPaths = U.derivationPaths, this.addresses = U.addresses, this.origin = U.origin;
      }
      static constructCosmosRequest(U, L, H, fe, ge, Ie, Ee) {
        const Se = ge.map((ze, He) => {
          const De = ze.replace(/[m|M]\//, "").split("/").map((ve) => {
            const Fe = parseInt(ve.replace("'", ""));
            let be = !1;
            return ve.endsWith("'") && (be = !0), new g.PathComponent({
              index: Fe,
              hardened: be
            });
          });
          return new g.CryptoKeypath(De, Buffer.from(L[He], "hex"));
        });
        return new B({
          requestId: Buffer.from(c.parse(U)),
          signData: H,
          dataType: fe || o.SignDataType.amino,
          derivationPaths: Se,
          addresses: Ie || void 0,
          origin: Ee || void 0
        });
      }
    }
    B.fromDataItem = (M) => {
      const U = M.getData(), L = U[E.requestId] ? U[E.requestId].getData() : void 0, H = U[E.signData], fe = U[E.dataType], ge = U[E.derivationPaths].map((Se) => g.CryptoKeypath.fromDataItem(Se)), Ie = U[E.addresses] ? U[E.addresses] : void 0, Ee = U[E.origin] ? U[E.origin] : void 0;
      return new B({
        requestId: L,
        signData: H,
        dataType: fe,
        derivationPaths: ge,
        addresses: Ie,
        origin: Ee
      });
    }, B.fromCBOR = (M) => {
      const U = t(M);
      return B.fromDataItem(U);
    };
    const {
      RegistryTypes: D,
      decodeToDataItem: x
    } = g.extend;
    var v;
    (function(M) {
      M[M.requestId = 1] = "requestId", M[M.signature = 2] = "signature", M[M.publicKey = 3] = "publicKey";
    })(v || (v = {}));
    class F extends g.RegistryItem {
      constructor(U, L, H) {
        super(), this.getRegistryType = () => y.COSMOS_SIGNATURE, this.getRequestId = () => this.requestId, this.getSignature = () => this.signature, this.getPublicKey = () => this.publicKey, this.toDataItem = () => {
          const fe = {};
          return fe[v.requestId] = new g.DataItem(this.requestId, D.UUID.getTag()), fe[v.signature] = this.signature, fe[v.publicKey] = this.publicKey, new g.DataItem(fe);
        }, this.signature = U, this.requestId = L, this.publicKey = H;
      }
    }
    F.fromDataItem = (M) => {
      const U = M.getData(), L = U[v.signature], H = U[v.requestId].getData(), fe = U[v.publicKey];
      return new F(L, H, fe);
    }, F.fromCBOR = (M) => {
      const U = x(M);
      return F.fromDataItem(U);
    }, g.patchTags(Object.values(y).filter((M) => !!M.getTag()).map((M) => M.getTag())), Object.keys(g).forEach(function(M) {
      M !== "default" && Object.defineProperty(o, M, {
        enumerable: !0,
        get: function() {
          return g[M];
        }
      });
    }), o.CosmosSignRequest = B, o.CosmosSignature = F;
  }(bcUrRegistryCosmos_cjs_development)), bcUrRegistryCosmos_cjs_development;
}
var hasRequiredDist$l;
function requireDist$l() {
  return hasRequiredDist$l || (hasRequiredDist$l = 1, process$1.env.NODE_ENV === "production" ? dist$k.exports = requireBcUrRegistryCosmos_cjs_production_min() : dist$k.exports = requireBcUrRegistryCosmos_cjs_development()), dist$k.exports;
}
var hasRequiredCosmos;
function requireCosmos() {
  if (hasRequiredCosmos) return cosmos;
  hasRequiredCosmos = 1, Object.defineProperty(cosmos, "__esModule", { value: !0 }), cosmos.KeystoneCosmosSDK = void 0;
  const o = requireUtils$e(), g = requireUr(), c = requireDist$l();
  class y {
    constructor(d) {
      this.config = d;
    }
    parseSignature(d) {
      if (d.type !== g.URType.CosmosSignature)
        throw new Error("type not match");
      const E = c.CosmosSignature.fromCBOR(d.cbor);
      return {
        requestId: (0, o.uuidStringify)(E.getRequestId()),
        signature: (0, o.toHex)(E.getSignature()),
        publicKey: (0, o.toHex)(E.getPublicKey())
      };
    }
    generateSignRequest({ requestId: d, signData: E, dataType: B, accounts: D, origin: x }) {
      var v;
      const F = [], M = [];
      return D.forEach((U) => {
        F.push(new c.CryptoKeypath((0, o.parsePath)(U.path).map((L) => new c.PathComponent(L)), (0, o.toBuffer)(U.xfp))), M.push(U.address);
      }), new c.CosmosSignRequest({
        signData: (0, o.toBuffer)(E),
        dataType: B,
        derivationPaths: F,
        requestId: (0, o.uuidParse)(d),
        addresses: M,
        origin: x ?? ((v = this.config) === null || v === void 0 ? void 0 : v.origin)
      }).toUR();
    }
  }
  return cosmos.KeystoneCosmosSDK = y, y.DataType = c.SignDataType, cosmos;
}
var evm = {}, dist$j = { exports: {} }, bcUrRegistryEvm_cjs_production_min = {}, hasRequiredBcUrRegistryEvm_cjs_production_min;
function requireBcUrRegistryEvm_cjs_production_min() {
  return hasRequiredBcUrRegistryEvm_cjs_production_min || (hasRequiredBcUrRegistryEvm_cjs_production_min = 1, function(o) {
    Object.defineProperty(o, "__esModule", { value: !0 });
    var g = requireDist$n(), c = /* @__PURE__ */ requireCommonjsBrowser();
    const y = { EVM_SIGN_REQUEST: new g.RegistryType("evm-sign-request", 4101), EVM_SIGNATURE: new g.RegistryType("evm-signature", 4102) }, { decodeToDataItem: t, RegistryTypes: d } = g.extend;
    var E, B;
    (E = o.SignDataType || (o.SignDataType = {}))[E.arbitrary = 1] = "arbitrary", E[E.cosmosAmino = 2] = "cosmosAmino", E[E.cosmosDirect = 3] = "cosmosDirect", function(U) {
      U[U.requestId = 1] = "requestId", U[U.signData = 2] = "signData", U[U.dataType = 3] = "dataType", U[U.customChainIdentifier = 4] = "customChainIdentifier", U[U.derivationPath = 5] = "derivationPath", U[U.address = 6] = "address", U[U.origin = 7] = "origin";
    }(B || (B = {}));
    class D extends g.RegistryItem {
      constructor(L) {
        super(), this.getRegistryType = () => y.EVM_SIGN_REQUEST, this.getRequestId = () => this.requestId, this.getSignData = () => this.signData, this.getDataype = () => this.dataType, this.getCustomChainIdentifier = () => this.customChainIdentifier, this.getDerivationPath = () => this.derivationPath.getPath(), this.getAddress = () => this.address, this.getOrigin = () => this.origin, this.toDataItem = () => {
          const H = {};
          H[B.requestId] = new g.DataItem(this.requestId, d.UUID.getTag()), H[B.signData] = this.signData, H[B.dataType] = this.dataType, H[B.customChainIdentifier] = this.customChainIdentifier;
          const fe = this.derivationPath.toDataItem();
          return fe.setTag(this.derivationPath.getRegistryType().getTag()), H[B.derivationPath] = fe, this.address && (H[B.address] = this.address), this.origin && (H[B.origin] = this.origin), new g.DataItem(H);
        }, this.requestId = L.requestId, this.signData = L.signData, this.dataType = L.dataType, this.customChainIdentifier = L.customChainIdentifier, this.derivationPath = L.derivationPath, this.address = L.address, this.origin = L.origin;
      }
      static parsePath(L, H) {
        const fe = L.replace(/[m|M]\//, "").split("/").map((ge) => {
          const Ie = parseInt(ge.replace("'", ""));
          let Ee = !1;
          return ge.endsWith("'") && (Ee = !0), new g.PathComponent({ index: Ie, hardened: Ee });
        });
        return new g.CryptoKeypath(fe, Buffer.from(H, "hex"));
      }
      static constructEvmRequest(L, H, fe, ge, Ie, Ee, Se, ze) {
        return new D({ requestId: Buffer.from(c.parse(L)), signData: fe, dataType: ge || o.SignDataType.arbitrary, customChainIdentifier: Ie, derivationPath: D.parsePath(Ee, H), address: Se, origin: ze });
      }
    }
    D.fromDataItem = (U) => {
      const L = U.getData(), H = L[B.requestId] ? L[B.requestId].getData() : void 0;
      return new D({ requestId: H, signData: L[B.signData], dataType: L[B.dataType], customChainIdentifier: L[B.customChainIdentifier], derivationPath: g.CryptoKeypath.fromDataItem(L[B.derivationPath]), address: L[B.address], origin: L[B.origin] });
    }, D.fromCBOR = (U) => {
      const L = t(U);
      return D.fromDataItem(L);
    };
    const { RegistryTypes: x, decodeToDataItem: v } = g.extend;
    var F;
    (function(U) {
      U[U.requestId = 1] = "requestId", U[U.signature = 2] = "signature";
    })(F || (F = {}));
    class M extends g.RegistryItem {
      constructor(L, H) {
        super(), this.getRegistryType = () => y.EVM_SIGNATURE, this.getRequestId = () => this.requestId, this.getSignature = () => this.signature, this.toDataItem = () => {
          const fe = {};
          return fe[F.requestId] = new g.DataItem(this.requestId, x.UUID.getTag()), fe[F.signature] = this.signature, new g.DataItem(fe);
        }, this.signature = L, this.requestId = H;
      }
    }
    M.fromDataItem = (U) => {
      const L = U.getData(), H = L[F.signature], fe = L[F.requestId].getData();
      return new M(H, fe);
    }, M.fromCBOR = (U) => {
      const L = v(U);
      return M.fromDataItem(L);
    }, g.patchTags(Object.values(y).filter((U) => !!U.getTag()).map((U) => U.getTag())), Object.keys(g).forEach(function(U) {
      U !== "default" && Object.defineProperty(o, U, { enumerable: !0, get: function() {
        return g[U];
      } });
    }), o.EvmSignRequest = D, o.EvmSignature = M;
  }(bcUrRegistryEvm_cjs_production_min)), bcUrRegistryEvm_cjs_production_min;
}
var bcUrRegistryEvm_cjs_development = {}, hasRequiredBcUrRegistryEvm_cjs_development;
function requireBcUrRegistryEvm_cjs_development() {
  return hasRequiredBcUrRegistryEvm_cjs_development || (hasRequiredBcUrRegistryEvm_cjs_development = 1, function(o) {
    Object.defineProperty(o, "__esModule", { value: !0 });
    var g = requireDist$n(), c = /* @__PURE__ */ requireCommonjsBrowser();
    const y = {
      EVM_SIGN_REQUEST: /* @__PURE__ */ new g.RegistryType("evm-sign-request", 4101),
      EVM_SIGNATURE: /* @__PURE__ */ new g.RegistryType("evm-signature", 4102)
    }, {
      decodeToDataItem: t,
      RegistryTypes: d
    } = g.extend;
    (function(M) {
      M[M.arbitrary = 1] = "arbitrary", M[M.cosmosAmino = 2] = "cosmosAmino", M[M.cosmosDirect = 3] = "cosmosDirect";
    })(o.SignDataType || (o.SignDataType = {}));
    var E;
    (function(M) {
      M[M.requestId = 1] = "requestId", M[M.signData = 2] = "signData", M[M.dataType = 3] = "dataType", M[M.customChainIdentifier = 4] = "customChainIdentifier", M[M.derivationPath = 5] = "derivationPath", M[M.address = 6] = "address", M[M.origin = 7] = "origin";
    })(E || (E = {}));
    class B extends g.RegistryItem {
      constructor(U) {
        super(), this.getRegistryType = () => y.EVM_SIGN_REQUEST, this.getRequestId = () => this.requestId, this.getSignData = () => this.signData, this.getDataype = () => this.dataType, this.getCustomChainIdentifier = () => this.customChainIdentifier, this.getDerivationPath = () => this.derivationPath.getPath(), this.getAddress = () => this.address, this.getOrigin = () => this.origin, this.toDataItem = () => {
          const L = {};
          L[E.requestId] = new g.DataItem(this.requestId, d.UUID.getTag()), L[E.signData] = this.signData, L[E.dataType] = this.dataType, L[E.customChainIdentifier] = this.customChainIdentifier;
          const H = this.derivationPath.toDataItem();
          return H.setTag(this.derivationPath.getRegistryType().getTag()), L[E.derivationPath] = H, this.address && (L[E.address] = this.address), this.origin && (L[E.origin] = this.origin), new g.DataItem(L);
        }, this.requestId = U.requestId, this.signData = U.signData, this.dataType = U.dataType, this.customChainIdentifier = U.customChainIdentifier, this.derivationPath = U.derivationPath, this.address = U.address, this.origin = U.origin;
      }
      static parsePath(U, L) {
        const fe = U.replace(/[m|M]\//, "").split("/").map((ge) => {
          const Ie = parseInt(ge.replace("'", ""));
          let Ee = !1;
          return ge.endsWith("'") && (Ee = !0), new g.PathComponent({
            index: Ie,
            hardened: Ee
          });
        });
        return new g.CryptoKeypath(fe, Buffer.from(L, "hex"));
      }
      static constructEvmRequest(U, L, H, fe, ge, Ie, Ee, Se) {
        return new B({
          requestId: Buffer.from(c.parse(U)),
          signData: H,
          dataType: fe || o.SignDataType.arbitrary,
          customChainIdentifier: ge,
          derivationPath: B.parsePath(Ie, L),
          address: Ee,
          origin: Se
        });
      }
    }
    B.fromDataItem = (M) => {
      const U = M.getData(), L = U[E.requestId] ? U[E.requestId].getData() : void 0;
      return new B({
        requestId: L,
        signData: U[E.signData],
        dataType: U[E.dataType],
        customChainIdentifier: U[E.customChainIdentifier],
        derivationPath: g.CryptoKeypath.fromDataItem(U[E.derivationPath]),
        address: U[E.address],
        origin: U[E.origin]
      });
    }, B.fromCBOR = (M) => {
      const U = t(M);
      return B.fromDataItem(U);
    };
    const {
      RegistryTypes: D,
      decodeToDataItem: x
    } = g.extend;
    var v;
    (function(M) {
      M[M.requestId = 1] = "requestId", M[M.signature = 2] = "signature";
    })(v || (v = {}));
    class F extends g.RegistryItem {
      constructor(U, L) {
        super(), this.getRegistryType = () => y.EVM_SIGNATURE, this.getRequestId = () => this.requestId, this.getSignature = () => this.signature, this.toDataItem = () => {
          const H = {};
          return H[v.requestId] = new g.DataItem(this.requestId, D.UUID.getTag()), H[v.signature] = this.signature, new g.DataItem(H);
        }, this.signature = U, this.requestId = L;
      }
    }
    F.fromDataItem = (M) => {
      const U = M.getData(), L = U[v.signature], H = U[v.requestId].getData();
      return new F(L, H);
    }, F.fromCBOR = (M) => {
      const U = x(M);
      return F.fromDataItem(U);
    }, g.patchTags(Object.values(y).filter((M) => !!M.getTag()).map((M) => M.getTag())), Object.keys(g).forEach(function(M) {
      M !== "default" && Object.defineProperty(o, M, {
        enumerable: !0,
        get: function() {
          return g[M];
        }
      });
    }), o.EvmSignRequest = B, o.EvmSignature = F;
  }(bcUrRegistryEvm_cjs_development)), bcUrRegistryEvm_cjs_development;
}
var hasRequiredDist$k;
function requireDist$k() {
  return hasRequiredDist$k || (hasRequiredDist$k = 1, process$1.env.NODE_ENV === "production" ? dist$j.exports = requireBcUrRegistryEvm_cjs_production_min() : dist$j.exports = requireBcUrRegistryEvm_cjs_development()), dist$j.exports;
}
var hasRequiredEvm;
function requireEvm() {
  if (hasRequiredEvm) return evm;
  hasRequiredEvm = 1, Object.defineProperty(evm, "__esModule", { value: !0 }), evm.KeystoneEvmSDK = void 0;
  const o = requireUtils$e(), g = requireUr(), c = requireDist$k();
  class y {
    constructor(d) {
      this.config = d;
    }
    parseSignature(d) {
      if (d.type !== g.URType.EvmSignature)
        throw new Error("type not match");
      const E = c.EvmSignature.fromCBOR(d.cbor);
      return {
        requestId: (0, o.uuidStringify)(E.getRequestId()),
        signature: (0, o.toHex)(E.getSignature())
      };
    }
    generateSignRequest({ requestId: d, signData: E, dataType: B, customChainIdentifier: D, account: x, origin: v }) {
      var F;
      const M = new c.CryptoKeypath((0, o.parsePath)(x.path).map((U) => new c.PathComponent(U)), (0, o.toBuffer)(x.xfp));
      return new c.EvmSignRequest({
        signData: (0, o.toBuffer)(E),
        dataType: B,
        customChainIdentifier: D,
        derivationPath: M,
        requestId: (0, o.uuidParse)(d),
        address: x.address !== void 0 ? (0, o.toBuffer)(x.address.substring(x.address.startsWith("0x") ? 2 : 0)) : void 0,
        origin: v ?? ((F = this.config) === null || F === void 0 ? void 0 : F.origin)
      }).toUR();
    }
  }
  return evm.KeystoneEvmSDK = y, y.DataType = c.SignDataType, evm;
}
var ethereum$2 = {}, dist$i = { exports: {} }, bcUrRegistryEth_cjs_production_min = {}, dist$h = {}, patchCBOR = {}, utils$e = {}, lib$6 = {}, cborSync$1 = { exports: {} }, DataItem = {}, hasRequiredDataItem;
function requireDataItem() {
  if (hasRequiredDataItem) return DataItem;
  hasRequiredDataItem = 1, Object.defineProperty(DataItem, "__esModule", { value: !0 }), DataItem.DataItem = void 0;
  let o = class {
    constructor(c, y) {
      this.setTag = (t) => {
        this.tag = t;
      }, this.clearTag = () => {
        this.tag = void 0;
      }, this.getTag = () => this.tag, this.getData = () => this.data, this.data = c, this.tag = y;
    }
  };
  return DataItem.DataItem = o, DataItem;
}
var cborSync = cborSync$1.exports, hasRequiredCborSync;
function requireCborSync() {
  return hasRequiredCborSync || (hasRequiredCborSync = 1, function(o) {
    (function(g, c) {
      o.exports ? o.exports = c() : g.CBOR = c();
    })(cborSync, function() {
      const { DataItem: g } = requireDataItem();
      var c = function() {
        function y(Pe) {
          this.$hex = Pe;
        }
        y.prototype = {
          length: function() {
            return this.$hex.length / 2;
          },
          toString: function(Pe) {
            if (!Pe || Pe === "hex" || Pe === 16)
              return this.$hex;
            if (Pe === "utf-8") {
              for (var De = "", ve = 0; ve < this.$hex.length; ve += 2)
                De += "%" + this.$hex.substring(ve, ve + 2);
              return decodeURIComponent(De);
            }
            if (Pe === "latin") {
              for (var De = [], ve = 0; ve < this.$hex.length; ve += 2)
                De.push(parseInt(this.$hex.substring(ve, ve + 2), 16));
              return String.fromCharCode.apply(String, De);
            }
            throw new Error("Unrecognised format: " + Pe);
          }
        }, y.fromLatinString = function(Pe) {
          for (var De = "", ve = 0; ve < Pe.length; ve++) {
            var Fe = Pe.charCodeAt(ve).toString(16);
            Fe.length === 1 && (Fe = "0" + Fe), De += Fe;
          }
          return new y(De);
        }, y.fromUtf8String = function(Pe) {
          for (var De = encodeURIComponent(Pe), ve = "", Fe = 0; Fe < De.length; Fe++)
            if (De.charAt(Fe) === "%")
              ve += De.substring(Fe + 1, Fe + 3), Fe += 2;
            else {
              var be = De.charCodeAt(Fe).toString(16);
              be.length < 2 && (be = "0" + be), ve += be;
            }
          return new y(ve);
        };
        var t = [], d = {}, E = function(Pe) {
          return function() {
            throw new Error(Pe + " not implemented");
          };
        };
        function B() {
        }
        B.prototype = {
          peekByte: E("peekByte"),
          readByte: E("readByte"),
          readChunk: E("readChunk"),
          readFloat16: function() {
            var Pe = this.readUint16(), De = (Pe & 32767) >> 10, ve = Pe & 1023, Fe = Pe & 32768;
            if (De === 31)
              return ve === 0 ? Fe ? -1 / 0 : 1 / 0 : NaN;
            var be = De ? Math.pow(2, De - 25) * (1024 + ve) : Math.pow(2, -24) * ve;
            return Fe ? -be : be;
          },
          readFloat32: function() {
            var Pe = this.readUint32(), De = (Pe & 2147483647) >> 23, ve = Pe & 8388607, Fe = Pe & 2147483648;
            if (De === 255)
              return ve === 0 ? Fe ? -1 / 0 : 1 / 0 : NaN;
            var be = De ? Math.pow(2, De - 23 - 127) * (8388608 + ve) : Math.pow(2, -149) * ve;
            return Fe ? -be : be;
          },
          readFloat64: function() {
            var Pe = this.readUint32(), De = this.readUint32(), ve = Pe >> 20 & 2047, Fe = (Pe & 1048575) * 4294967296 + De, be = Pe & 2147483648;
            if (ve === 2047)
              return Fe === 0 ? be ? -1 / 0 : 1 / 0 : NaN;
            var Be = ve ? Math.pow(2, ve - 52 - 1023) * (4503599627370496 + Fe) : Math.pow(2, -1074) * Fe;
            return be ? -Be : Be;
          },
          readUint16: function() {
            return this.readByte() * 256 + this.readByte();
          },
          readUint32: function() {
            return this.readUint16() * 65536 + this.readUint16();
          },
          readUint64: function() {
            return this.readUint32() * 4294967296 + this.readUint32();
          }
        };
        function D() {
        }
        D.prototype = {
          writeByte: E("writeByte"),
          result: E("result"),
          writeFloat16: E("writeFloat16"),
          writeFloat32: E("writeFloat32"),
          writeFloat64: E("writeFloat64"),
          writeUint16: function(Pe) {
            this.writeByte(Pe >> 8 & 255), this.writeByte(Pe & 255);
          },
          writeUint32: function(Pe) {
            this.writeUint16(Pe >> 16 & 65535), this.writeUint16(Pe & 65535);
          },
          writeUint64: function(Pe) {
            if (Pe >= 9007199254740992 || Pe <= -9007199254740992)
              throw new Error("Cannot encode Uint64 of: " + Pe + " magnitude to big (floating point errors)");
            this.writeUint32(Math.floor(Pe / 4294967296)), this.writeUint32(Pe % 4294967296);
          },
          writeString: E("writeString"),
          canWriteBinary: function(Pe) {
            return !1;
          },
          writeBinary: E("writeChunk")
        };
        function x(Pe) {
          var De = Pe.readByte(), ve = De >> 5, Fe = De & 31;
          return { type: ve, value: Fe };
        }
        function v(Pe, De) {
          var ve = Pe.value;
          if (ve < 24)
            return ve;
          if (ve == 24)
            return De.readByte();
          if (ve == 25)
            return De.readUint16();
          if (ve == 26)
            return De.readUint32();
          if (ve == 27)
            return De.readUint64();
          if (ve == 31)
            return null;
          E("Additional info: " + ve)();
        }
        function F(Pe, De, ve) {
          ve.writeByte(Pe << 5 | De);
        }
        function M(Pe, De, ve) {
          var Fe = Pe << 5;
          De < 24 ? ve.writeByte(Fe | De) : De < 256 ? (ve.writeByte(Fe | 24), ve.writeByte(De)) : De < 65536 ? (ve.writeByte(Fe | 25), ve.writeUint16(De)) : De < 4294967296 ? (ve.writeByte(Fe | 26), ve.writeUint32(De)) : (ve.writeByte(Fe | 27), ve.writeUint64(De));
        }
        var U = new Error();
        function L(Pe) {
          var De = x(Pe);
          switch (De.type) {
            case 0:
              return v(De, Pe);
            case 1:
              return -1 - v(De, Pe);
            case 2:
              return Pe.readChunk(v(De, Pe));
            case 3:
              var ve = Pe.readChunk(v(De, Pe));
              return ve.toString("utf-8");
            case 4:
            case 5:
              var Fe = v(De, Pe), Et = [];
              if (Fe !== null) {
                De.type === 5 && (Fe *= 2);
                for (var be = 0; be < Fe; be++)
                  Et[be] = L(Pe);
              } else
                for (var Be; (Be = L(Pe)) !== U; )
                  Et.push(Be);
              if (De.type === 5) {
                for (var ke = {}, be = 0; be < Et.length; be += 2)
                  ke[Et[be]] = Et[be + 1];
                return ke;
              } else
                return Et;
            case 6:
              var xe = v(De, Pe), Ne = d[xe], Et = L(Pe);
              return Ne ? Ne(Et) : Et;
            case 7:
              if (De.value === 25)
                return Pe.readFloat16();
              if (De.value === 26)
                return Pe.readFloat32();
              if (De.value === 27)
                return Pe.readFloat64();
              switch (v(De, Pe)) {
                case 20:
                  return !1;
                case 21:
                  return !0;
                case 22:
                  return null;
                case 23:
                  return;
                case null:
                  return U;
                default:
                  throw new Error("Unknown fixed value: " + De.value);
              }
            default:
              throw new Error("Unsupported header: " + JSON.stringify(De));
          }
          throw new Error("not implemented yet");
        }
        function H(Pe, De) {
          for (var ve = 0; ve < t.length; ve++) {
            var Fe = t[ve].fn(Pe);
            if (Fe !== void 0)
              return M(6, t[ve].tag, De), H(Fe, De);
          }
          if (Pe && typeof Pe.toCBOR == "function" && (Pe = Pe.toCBOR()), Pe === !1)
            M(7, 20, De);
          else if (Pe === !0)
            M(7, 21, De);
          else if (Pe === null)
            M(7, 22, De);
          else if (Pe === void 0)
            M(7, 23, De);
          else if (typeof Pe == "number")
            Math.floor(Pe) === Pe && Pe < 9007199254740992 && Pe > -9007199254740992 ? Pe < 0 ? M(1, -1 - Pe, De) : M(0, Pe, De) : (F(7, 27, De), De.writeFloat64(Pe));
          else if (typeof Pe == "string")
            De.writeString(Pe, function(Be) {
              M(3, Be, De);
            });
          else if (De.canWriteBinary(Pe))
            De.writeBinary(Pe, function(Be) {
              M(2, Be, De);
            });
          else if (typeof Pe == "object")
            if (Ie.config.useToJSON && typeof Pe.toJSON == "function" && (Pe = Pe.toJSON()), Array.isArray(Pe)) {
              M(4, Pe.length, De);
              for (var ve = 0; ve < Pe.length; ve++)
                H(Pe[ve], De);
            } else {
              var be = Object.keys(Pe);
              M(5, be.length, De);
              for (var ve = 0; ve < be.length; ve++) {
                const ke = parseInt(be[ve]);
                isNaN(ke) ? (H(be[ve], De), H(Pe[be[ve]], De)) : (H(ke, De), H(Pe[be[ve]], De));
              }
            }
          else
            throw new Error("CBOR encoding not supported: " + Pe);
        }
        var fe = [], ge = [], Ie = {
          config: {
            useToJSON: !0
          },
          addWriter: function(Pe, De) {
            typeof Pe == "string" ? ge.push(function(ve) {
              if (Pe === ve)
                return De(ve);
            }) : ge.push(Pe);
          },
          addReader: function(Pe, De) {
            typeof Pe == "string" ? fe.push(function(ve, Fe) {
              if (Pe === Fe)
                return De(ve, Fe);
            }) : fe.push(Pe);
          },
          encode: function(Pe, De) {
            for (var ve = 0; ve < ge.length; ve++) {
              var Fe = ge[ve], be = Fe(De);
              if (be)
                return H(Pe, be), be.result();
            }
            throw new Error("Unsupported output format: " + De);
          },
          encodeDataItem: function(Pe, De) {
            for (var ve = 0; ve < ge.length; ve++) {
              var Fe = ge[ve], be = Fe(De);
              if (be)
                return Pe.getTag() !== void 0 ? (H(Pe, be), be.result()) : (H(Pe.getData(), be), be.result());
            }
            throw new Error("Unsupported output format: " + De);
          },
          decode: function(Pe, De) {
            for (var ve = 0; ve < fe.length; ve++) {
              var Fe = fe[ve], be = Fe(Pe, De);
              if (be)
                return L(be);
            }
            throw new Error("Unsupported input format: " + De);
          },
          decodeToDataItem: function(Pe, De) {
            for (var ve = 0; ve < fe.length; ve++) {
              var Fe = fe[ve], be = Fe(Pe, De);
              if (be) {
                const Be = L(be);
                return Be instanceof g ? Be : new g(Be);
              }
            }
            throw new Error("Unsupported input format: " + De);
          },
          addSemanticEncode: function(Pe, De) {
            if (typeof Pe != "number" || Pe % 1 !== 0 || Pe < 0)
              throw new Error("Tag must be a positive integer");
            return t.push({ tag: Pe, fn: De }), this;
          },
          addSemanticDecode: function(Pe, De) {
            if (typeof Pe != "number" || Pe % 1 !== 0 || Pe < 0)
              throw new Error("Tag must be a positive integer");
            return d[Pe] = De, this;
          }
        };
        function Ee(Pe) {
          this.buffer = Pe, this.pos = 0;
        }
        Ee.prototype = Object.create(B.prototype), Ee.prototype.peekByte = function() {
          return this.buffer[this.pos];
        }, Ee.prototype.readByte = function() {
          return this.buffer[this.pos++];
        }, Ee.prototype.readUint16 = function() {
          var Pe = this.buffer.readUInt16BE(this.pos);
          return this.pos += 2, Pe;
        }, Ee.prototype.readUint32 = function() {
          var Pe = this.buffer.readUInt32BE(this.pos);
          return this.pos += 4, Pe;
        }, Ee.prototype.readFloat32 = function() {
          var Pe = this.buffer.readFloatBE(this.pos);
          return this.pos += 4, Pe;
        }, Ee.prototype.readFloat64 = function() {
          var Pe = this.buffer.readDoubleBE(this.pos);
          return this.pos += 8, Pe;
        }, Ee.prototype.readChunk = function(Pe) {
          var De = Buffer.alloc(Pe);
          return this.buffer.copy(De, 0, this.pos, this.pos += Pe), De;
        };
        function Se(Pe) {
          this.byteLength = 0, this.defaultBufferLength = 16384, this.latestBuffer = Buffer.alloc(this.defaultBufferLength), this.latestBufferOffset = 0, this.completeBuffers = [], this.stringFormat = Pe;
        }
        Se.prototype = Object.create(D.prototype), Se.prototype.writeByte = function(Pe) {
          this.latestBuffer[this.latestBufferOffset++] = Pe, this.latestBufferOffset >= this.latestBuffer.length && (this.completeBuffers.push(this.latestBuffer), this.latestBuffer = Buffer.alloc(this.defaultBufferLength), this.latestBufferOffset = 0), this.byteLength++;
        }, Se.prototype.writeFloat32 = function(Pe) {
          var De = Buffer.alloc(4);
          De.writeFloatBE(Pe, 0), this.writeBuffer(De);
        }, Se.prototype.writeFloat64 = function(Pe) {
          var De = Buffer.alloc(8);
          De.writeDoubleBE(Pe, 0), this.writeBuffer(De);
        }, Se.prototype.writeString = function(Pe, De) {
          var ve = Buffer.from(Pe, "utf-8");
          De(ve.length), this.writeBuffer(ve);
        }, Se.prototype.canWriteBinary = function(Pe) {
          return Pe instanceof Buffer;
        }, Se.prototype.writeBinary = function(Pe, De) {
          De(Pe.length), this.writeBuffer(Pe);
        }, Se.prototype.writeBuffer = function(Pe) {
          if (!(Pe instanceof Buffer))
            throw new TypeError("BufferWriter only accepts Buffers");
          this.latestBufferOffset ? this.latestBuffer.length - this.latestBufferOffset >= Pe.length ? (Pe.copy(this.latestBuffer, this.latestBufferOffset), this.latestBufferOffset += Pe.length, this.latestBufferOffset >= this.latestBuffer.length && (this.completeBuffers.push(this.latestBuffer), this.latestBuffer = Buffer.alloc(this.defaultBufferLength), this.latestBufferOffset = 0)) : (this.completeBuffers.push(this.latestBuffer.slice(0, this.latestBufferOffset)), this.completeBuffers.push(Pe), this.latestBuffer = Buffer.alloc(this.defaultBufferLength), this.latestBufferOffset = 0) : this.completeBuffers.push(Pe), this.byteLength += Pe.length;
        }, Se.prototype.result = function() {
          for (var Pe = Buffer.alloc(this.byteLength), De = 0, ve = 0; ve < this.completeBuffers.length; ve++) {
            var Fe = this.completeBuffers[ve];
            Fe.copy(Pe, De, 0, Fe.length), De += Fe.length;
          }
          return this.latestBufferOffset && this.latestBuffer.copy(Pe, De, 0, this.latestBufferOffset), this.stringFormat ? Pe.toString(this.stringFormat) : Pe;
        }, typeof Buffer == "function" && (Ie.addReader(function(Pe, De) {
          if (Buffer.isBuffer(Pe))
            return new Ee(Pe);
          if (De === "hex" || De === "base64") {
            var ve = Buffer.from(Pe, De);
            return new Ee(ve);
          }
        }), Ie.addWriter(function(Pe) {
          if (!Pe || Pe === "buffer")
            return new Se();
          if (Pe === "hex" || Pe === "base64")
            return new Se(Pe);
        }));
        function ze(Pe) {
          this.hex = Pe, this.pos = 0;
        }
        ze.prototype = Object.create(B.prototype), ze.prototype.peekByte = function() {
          var Pe = this.hex.substring(this.pos, 2);
          return parseInt(Pe, 16);
        }, ze.prototype.readByte = function() {
          var Pe = this.hex.substring(this.pos, this.pos + 2);
          return this.pos += 2, parseInt(Pe, 16);
        }, ze.prototype.readChunk = function(Pe) {
          var De = this.hex.substring(this.pos, this.pos + Pe * 2);
          return this.pos += Pe * 2, typeof Buffer == "function" ? Buffer.from(De, "hex") : new y(De);
        };
        function He(Pe) {
          this.$hex = "", this.finalFormat = Pe || "hex";
        }
        return He.prototype = Object.create(D.prototype), He.prototype.writeByte = function(Pe) {
          if (Pe < 0 || Pe > 255)
            throw new Error("Byte value out of range: " + Pe);
          var De = Pe.toString(16);
          De.length == 1 && (De = "0" + De), this.$hex += De;
        }, He.prototype.canWriteBinary = function(Pe) {
          return Pe instanceof y || typeof Buffer == "function" && Pe instanceof Buffer;
        }, He.prototype.writeBinary = function(Pe, De) {
          if (Pe instanceof y)
            De(Pe.length()), this.$hex += Pe.$hex;
          else if (typeof Buffer == "function" && Pe instanceof Buffer)
            De(Pe.length), this.$hex += Pe.toString("hex");
          else
            throw new TypeError("HexWriter only accepts BinaryHex or Buffers");
        }, He.prototype.result = function() {
          return this.finalFormat === "buffer" && typeof Buffer == "function" ? Buffer.from(this.$hex, "hex") : new y(this.$hex).toString(this.finalFormat);
        }, He.prototype.writeString = function(Pe, De) {
          var ve = y.fromUtf8String(Pe);
          De(ve.length()), this.$hex += ve.$hex;
        }, Ie.addReader(function(Pe, De) {
          if (Pe instanceof y || Pe.$hex)
            return new ze(Pe.$hex);
          if (De === "hex")
            return new ze(Pe);
        }), Ie.addWriter(function(Pe) {
          if (Pe === "hex")
            return new He();
        }), Ie;
      }();
      return c.addSemanticEncode(0, function(y) {
        if (y instanceof Date)
          return y.toISOString();
      }).addSemanticDecode(0, function(y) {
        return new Date(y);
      }).addSemanticDecode(1, function(y) {
        return new Date(y);
      }), c;
    });
  }(cborSync$1)), cborSync$1.exports;
}
var hasRequiredLib$6;
function requireLib$6() {
  return hasRequiredLib$6 || (hasRequiredLib$6 = 1, function(o) {
    Object.defineProperty(o, "__esModule", { value: !0 }), o.DataItem = o.addWriter = o.addReader = o.addSemanticEncode = o.addSemanticDecode = o.decodeToDataItem = o.encodeDataItem = void 0;
    var g = requireCborSync();
    Object.defineProperty(o, "encodeDataItem", { enumerable: !0, get: function() {
      return g.encodeDataItem;
    } }), Object.defineProperty(o, "decodeToDataItem", { enumerable: !0, get: function() {
      return g.decodeToDataItem;
    } }), Object.defineProperty(o, "addSemanticDecode", { enumerable: !0, get: function() {
      return g.addSemanticDecode;
    } }), Object.defineProperty(o, "addSemanticEncode", { enumerable: !0, get: function() {
      return g.addSemanticEncode;
    } }), Object.defineProperty(o, "addReader", { enumerable: !0, get: function() {
      return g.addReader;
    } }), Object.defineProperty(o, "addWriter", { enumerable: !0, get: function() {
      return g.addWriter;
    } });
    var c = requireDataItem();
    Object.defineProperty(o, "DataItem", { enumerable: !0, get: function() {
      return c.DataItem;
    } });
  }(lib$6)), lib$6;
}
var hasRequiredUtils$c;
function requireUtils$c() {
  if (hasRequiredUtils$c) return utils$e;
  hasRequiredUtils$c = 1, Object.defineProperty(utils$e, "__esModule", { value: !0 }), utils$e.patchTags = void 0;
  const o = requireLib$6(), g = [], c = (y) => {
    y.forEach((t) => {
      g.find((d) => d === t) || ((0, o.addSemanticEncode)(t, (d) => {
        if (d instanceof o.DataItem && d.getTag() === t)
          return d.getData();
      }), (0, o.addSemanticDecode)(t, (d) => new o.DataItem(d, t)), g.push(t));
    });
  };
  return utils$e.patchTags = c, utils$e;
}
var RegistryType$1 = {}, hasRequiredRegistryType$1;
function requireRegistryType$1() {
  if (hasRequiredRegistryType$1) return RegistryType$1;
  hasRequiredRegistryType$1 = 1, Object.defineProperty(RegistryType$1, "__esModule", { value: !0 }), RegistryType$1.RegistryTypes = RegistryType$1.RegistryType = void 0;
  class o {
    constructor(c, y) {
      this.type = c, this.tag = y, this.getTag = () => this.tag, this.getType = () => this.type;
    }
  }
  return RegistryType$1.RegistryType = o, RegistryType$1.RegistryTypes = {
    UUID: new o("uuid", 37),
    BYTES: new o("bytes", void 0),
    CRYPTO_HDKEY: new o("crypto-hdkey", 303),
    CRYPTO_KEYPATH: new o("crypto-keypath", 304),
    CRYPTO_COIN_INFO: new o("crypto-coin-info", 305),
    CRYPTO_ECKEY: new o("crypto-eckey", 306),
    CRYPTO_OUTPUT: new o("crypto-output", 308),
    CRYPTO_PSBT: new o("crypto-psbt", 310),
    CRYPTO_ACCOUNT: new o("crypto-account", 311),
    CRYPTO_MULTI_ACCOUNTS: new o("crypto-multi-accounts", 1103),
    QR_HARDWARE_CALL: new o("qr-hardware-call", 1201),
    KEY_DERIVATION_CALL: new o("key-derivation-call", 1301),
    KEY_DERIVATION_SCHEMA: new o("key-derivation-schema", 1302)
  }, RegistryType$1;
}
var ScriptExpression = {}, hasRequiredScriptExpression;
function requireScriptExpression() {
  return hasRequiredScriptExpression || (hasRequiredScriptExpression = 1, function(o) {
    Object.defineProperty(o, "__esModule", { value: !0 }), o.ScriptExpressions = o.ScriptExpression = void 0;
    class g {
      constructor(y, t) {
        this.tag = y, this.expression = t, this.getTag = () => this.tag, this.getExpression = () => this.expression;
      }
    }
    o.ScriptExpression = g, g.fromTag = (c) => Object.values(o.ScriptExpressions).find((t) => t.getTag() === c), o.ScriptExpressions = {
      SCRIPT_HASH: new g(400, "sh"),
      WITNESS_SCRIPT_HASH: new g(401, "wsh"),
      PUBLIC_KEY: new g(402, "pk"),
      PUBLIC_KEY_HASH: new g(403, "pkh"),
      WITNESS_PUBLIC_KEY_HASH: new g(404, "wpkh"),
      COMBO: new g(405, "combo"),
      MULTISIG: new g(406, "multi"),
      SORTED_MULTISIG: new g(407, "sortedmulti"),
      ADDRESS: new g(307, "addr"),
      RAW_SCRIPT: new g(408, "raw")
    };
  }(ScriptExpression)), ScriptExpression;
}
var hasRequiredPatchCBOR;
function requirePatchCBOR() {
  if (hasRequiredPatchCBOR) return patchCBOR;
  hasRequiredPatchCBOR = 1, Object.defineProperty(patchCBOR, "__esModule", { value: !0 });
  const o = requireUtils$c(), g = requireRegistryType$1(), c = requireScriptExpression(), y = Object.values(g.RegistryTypes).filter((d) => !!d.getTag()).map((d) => d.getTag()), t = Object.values(c.ScriptExpressions).map((d) => d.getTag());
  return (0, o.patchTags)(y.concat(t)), patchCBOR;
}
var CryptoHDKey = {}, CryptoCoinInfo = {}, RegistryItem = {}, hasRequiredRegistryItem;
function requireRegistryItem() {
  if (hasRequiredRegistryItem) return RegistryItem;
  hasRequiredRegistryItem = 1, Object.defineProperty(RegistryItem, "__esModule", { value: !0 }), RegistryItem.RegistryItem = void 0;
  const o = requireDist$p(), g = requireLib$6();
  let c = class {
    constructor() {
      this.toCBOR = () => {
        if (this.toDataItem() === void 0)
          throw new Error(`#[ur-registry][RegistryItem][fn.toCBOR]: registry ${this.getRegistryType()}'s method toDataItem returns undefined`);
        return (0, g.encodeDataItem)(this.toDataItem());
      }, this.toUR = () => new o.UR(this.toCBOR(), this.getRegistryType().getType()), this.toUREncoder = (t, d, E) => {
        const B = this.toUR();
        return new o.UREncoder(B, t, d, E);
      };
    }
  };
  return RegistryItem.RegistryItem = c, RegistryItem;
}
var hasRequiredCryptoCoinInfo;
function requireCryptoCoinInfo() {
  return hasRequiredCryptoCoinInfo || (hasRequiredCryptoCoinInfo = 1, function(o) {
    Object.defineProperty(o, "__esModule", { value: !0 }), o.CryptoCoinInfo = o.Network = o.Type = void 0;
    const g = requireLib$6(), c = requireRegistryItem(), y = requireRegistryType$1();
    var t;
    (function(D) {
      D.type = "1", D.network = "2";
    })(t || (t = {}));
    var d;
    (function(D) {
      D[D.bitcoin = 0] = "bitcoin";
    })(d = o.Type || (o.Type = {}));
    var E;
    (function(D) {
      D[D.mainnet = 0] = "mainnet", D[D.testnet = 1] = "testnet";
    })(E = o.Network || (o.Network = {}));
    class B extends c.RegistryItem {
      constructor(x, v) {
        super(), this.type = x, this.network = v, this.getRegistryType = () => y.RegistryTypes.CRYPTO_COIN_INFO, this.getType = () => this.type || d.bitcoin, this.getNetwork = () => this.network || E.mainnet, this.toDataItem = () => {
          const F = {};
          return this.type && (F[t.type] = this.type), this.network && (F[t.network] = this.network), new g.DataItem(F);
        };
      }
    }
    o.CryptoCoinInfo = B, B.fromDataItem = (D) => {
      const x = D.getData(), v = x[t.type], F = x[t.network];
      return new B(v, F);
    }, B.fromCBOR = (D) => {
      const x = (0, g.decodeToDataItem)(D);
      return B.fromDataItem(x);
    };
  }(CryptoCoinInfo)), CryptoCoinInfo;
}
var CryptoKeypath = {}, PathComponent = {}, hasRequiredPathComponent;
function requirePathComponent() {
  if (hasRequiredPathComponent) return PathComponent;
  hasRequiredPathComponent = 1, Object.defineProperty(PathComponent, "__esModule", { value: !0 }), PathComponent.PathComponent = void 0;
  let o = class x6 {
    constructor(c) {
      if (this.getIndex = () => this.index, this.isWildcard = () => this.wildcard, this.isHardened = () => this.hardened, this.index = c.index, this.hardened = c.hardened, this.index !== void 0 ? this.wildcard = !1 : this.wildcard = !0, this.index && (this.index & x6.HARDENED_BIT) !== 0)
        throw new Error(`#[ur-registry][PathComponent][fn.constructor]: Invalid index ${this.index} - most significant bit cannot be set`);
    }
  };
  return PathComponent.PathComponent = o, o.HARDENED_BIT = 2147483648, PathComponent;
}
var hasRequiredCryptoKeypath;
function requireCryptoKeypath() {
  if (hasRequiredCryptoKeypath) return CryptoKeypath;
  hasRequiredCryptoKeypath = 1, Object.defineProperty(CryptoKeypath, "__esModule", { value: !0 }), CryptoKeypath.CryptoKeypath = void 0;
  const o = requireLib$6(), g = requirePathComponent(), c = requireRegistryItem(), y = requireRegistryType$1();
  var t;
  (function(E) {
    E[E.components = 1] = "components", E[E.source_fingerprint = 2] = "source_fingerprint", E[E.depth = 3] = "depth";
  })(t || (t = {}));
  let d = class extends c.RegistryItem {
    constructor(B = [], D, x) {
      super(), this.components = B, this.sourceFingerprint = D, this.depth = x, this.getRegistryType = () => y.RegistryTypes.CRYPTO_KEYPATH, this.getPath = () => this.components.length === 0 ? void 0 : this.components.map((F) => `${F.isWildcard() ? "*" : F.getIndex()}${F.isHardened() ? "'" : ""}`).join("/"), this.getComponents = () => this.components, this.getSourceFingerprint = () => this.sourceFingerprint, this.getDepth = () => this.depth, this.toDataItem = () => {
        const v = {}, F = [];
        return this.components && this.components.forEach((M) => {
          M.isWildcard() ? F.push([]) : F.push(M.getIndex()), F.push(M.isHardened());
        }), v[t.components] = F, this.sourceFingerprint && (v[t.source_fingerprint] = this.sourceFingerprint.readUInt32BE(0)), this.depth !== void 0 && (v[t.depth] = this.depth), new o.DataItem(v);
      };
    }
  };
  return CryptoKeypath.CryptoKeypath = d, d.fromDataItem = (E) => {
    const B = E.getData(), D = [], x = B[t.components];
    if (x)
      for (let U = 0; U < x.length; U += 2) {
        const L = x[U + 1], H = x[U];
        typeof H == "number" ? D.push(new g.PathComponent({ index: H, hardened: L })) : D.push(new g.PathComponent({ hardened: L }));
      }
    const v = B[t.source_fingerprint];
    let F;
    v && (F = Buffer.alloc(4), F.writeUInt32BE(v, 0));
    const M = B[t.depth];
    return new d(D, F, M);
  }, d.fromCBOR = (E) => {
    const B = (0, o.decodeToDataItem)(E);
    return d.fromDataItem(B);
  }, CryptoKeypath;
}
var hasRequiredCryptoHDKey;
function requireCryptoHDKey() {
  if (hasRequiredCryptoHDKey) return CryptoHDKey;
  hasRequiredCryptoHDKey = 1, Object.defineProperty(CryptoHDKey, "__esModule", { value: !0 }), CryptoHDKey.CryptoHDKey = void 0;
  const o = requireBs58check$1(), g = requireCryptoCoinInfo(), c = requireCryptoKeypath(), y = requireLib$6(), t = requireRegistryItem(), d = requireRegistryType$1();
  var E;
  (function(D) {
    D[D.is_master = 1] = "is_master", D[D.is_private = 2] = "is_private", D[D.key_data = 3] = "key_data", D[D.chain_code = 4] = "chain_code", D[D.use_info = 5] = "use_info", D[D.origin = 6] = "origin", D[D.children = 7] = "children", D[D.parent_fingerprint = 8] = "parent_fingerprint", D[D.name = 9] = "name", D[D.note = 10] = "note";
  })(E || (E = {}));
  let B = class extends t.RegistryItem {
    constructor(x) {
      super(), this.isECKey = () => !1, this.getKey = () => this.key, this.getChainCode = () => this.chainCode, this.isMaster = () => this.master, this.isPrivateKey = () => !!this.privateKey, this.getUseInfo = () => this.useInfo, this.getOrigin = () => this.origin, this.getChildren = () => this.children, this.getParentFingerprint = () => this.parentFingerprint, this.getName = () => this.name, this.getNote = () => this.note, this.getBip32Key = () => {
        var v, F, M;
        let U, L, H = 0, fe = Buffer.alloc(4).fill(0);
        if (this.isMaster())
          U = Buffer.from("0488ADE4", "hex"), L = 0, H = 0;
        else {
          L = ((v = this.getOrigin()) === null || v === void 0 ? void 0 : v.getComponents().length) || ((F = this.getOrigin()) === null || F === void 0 ? void 0 : F.getDepth());
          const ze = (M = this.getOrigin()) === null || M === void 0 ? void 0 : M.getComponents(), He = ze[ze.length - 1];
          He && (H = He.isHardened() ? He.getIndex() + 2147483648 : He.getIndex(), this.getParentFingerprint() && (fe = this.getParentFingerprint())), this.isPrivateKey() ? U = Buffer.from("0488ADE4", "hex") : U = Buffer.from("0488B21E", "hex");
        }
        const ge = Buffer.alloc(1);
        ge.writeUInt8(L, 0);
        const Ie = Buffer.alloc(4);
        Ie.writeUInt32BE(H, 0);
        const Ee = this.getChainCode(), Se = this.getKey();
        return (0, o.encode)(Buffer.concat([U, ge, fe, Ie, Ee, Se]));
      }, this.getRegistryType = () => d.RegistryTypes.CRYPTO_HDKEY, this.getOutputDescriptorContent = () => {
        var v, F, M, U, L, H, fe;
        let ge = "";
        return this.getOrigin() && !((v = this.getOrigin()) === null || v === void 0) && v.getSourceFingerprint() && !((F = this.getOrigin()) === null || F === void 0) && F.getPath() && (ge += `${(U = (M = this.getOrigin()) === null || M === void 0 ? void 0 : M.getSourceFingerprint()) === null || U === void 0 ? void 0 : U.toString("hex")}/${(L = this.getOrigin()) === null || L === void 0 ? void 0 : L.getPath()}`), ge += this.getBip32Key(), this.getChildren() && !((H = this.getChildren()) === null || H === void 0) && H.getPath() && (ge += `/${(fe = this.getChildren()) === null || fe === void 0 ? void 0 : fe.getPath()}`), ge;
      }, this.setupMasterKey = (v) => {
        this.master = !0, this.key = v.key, this.chainCode = v.chainCode;
      }, this.setupDeriveKey = (v) => {
        this.master = !1, this.privateKey = v.isPrivateKey, this.key = v.key, this.chainCode = v.chainCode, this.useInfo = v.useInfo, this.origin = v.origin, this.children = v.children, this.parentFingerprint = v.parentFingerprint, this.name = v.name, this.note = v.note;
      }, this.toDataItem = () => {
        const v = {};
        if (this.master)
          v[E.is_master] = !0, v[E.key_data] = this.key, v[E.chain_code] = this.chainCode;
        else {
          if (this.privateKey !== void 0 && (v[E.is_private] = this.privateKey), v[E.key_data] = this.key, this.chainCode && (v[E.chain_code] = this.chainCode), this.useInfo) {
            const F = this.useInfo.toDataItem();
            F.setTag(this.useInfo.getRegistryType().getTag()), v[E.use_info] = F;
          }
          if (this.origin) {
            const F = this.origin.toDataItem();
            F.setTag(this.origin.getRegistryType().getTag()), v[E.origin] = F;
          }
          if (this.children) {
            const F = this.children.toDataItem();
            F.setTag(this.children.getRegistryType().getTag()), v[E.children] = F;
          }
          this.parentFingerprint && (v[E.parent_fingerprint] = this.parentFingerprint.readUInt32BE(0)), this.name !== void 0 && (v[E.name] = this.name), this.note !== void 0 && (v[E.note] = this.note);
        }
        return new y.DataItem(v);
      }, x.isMaster ? this.setupMasterKey(x) : this.setupDeriveKey(x);
    }
  };
  return CryptoHDKey.CryptoHDKey = B, B.fromDataItem = (D) => {
    const x = D.getData(), v = !!x[E.is_master], F = x[E.is_private], M = x[E.key_data], U = x[E.chain_code], L = x[E.use_info] ? g.CryptoCoinInfo.fromDataItem(x[E.use_info]) : void 0, H = x[E.origin] ? c.CryptoKeypath.fromDataItem(x[E.origin]) : void 0, fe = x[E.children] ? c.CryptoKeypath.fromDataItem(x[E.children]) : void 0, ge = x[E.parent_fingerprint];
    let Ie;
    ge && (Ie = Buffer.alloc(4), Ie.writeUInt32BE(ge, 0));
    const Ee = x[E.name], Se = x[E.note];
    return new B({
      isMaster: v,
      isPrivateKey: F,
      key: M,
      chainCode: U,
      useInfo: L,
      origin: H,
      children: fe,
      parentFingerprint: Ie,
      name: Ee,
      note: Se
    });
  }, B.fromCBOR = (D) => {
    const x = (0, y.decodeToDataItem)(D);
    return B.fromDataItem(x);
  }, CryptoHDKey;
}
var CryptoECKey = {}, hasRequiredCryptoECKey;
function requireCryptoECKey() {
  if (hasRequiredCryptoECKey) return CryptoECKey;
  hasRequiredCryptoECKey = 1, Object.defineProperty(CryptoECKey, "__esModule", { value: !0 }), CryptoECKey.CryptoECKey = void 0;
  const o = requireLib$6(), g = requireRegistryItem(), c = requireRegistryType$1();
  var y;
  (function(d) {
    d[d.curve = 1] = "curve", d[d.private = 2] = "private", d[d.data = 3] = "data";
  })(y || (y = {}));
  let t = class extends g.RegistryItem {
    constructor(E) {
      super(), this.isECKey = () => !0, this.getCurve = () => this.curve || 0, this.isPrivateKey = () => this.privateKey || !1, this.getData = () => this.data, this.getRegistryType = () => c.RegistryTypes.CRYPTO_ECKEY, this.toDataItem = () => {
        const B = {};
        return this.curve && (B[y.curve] = this.curve), this.privateKey !== void 0 && (B[y.private] = this.privateKey), B[y.data] = this.data, new o.DataItem(B);
      }, this.getOutputDescriptorContent = () => this.data.toString("hex"), this.data = E.data, this.curve = E.curve, this.privateKey = E.privateKey || void 0;
    }
  };
  return CryptoECKey.CryptoECKey = t, t.fromDataItem = (d) => {
    const E = d.getData(), B = E[y.curve], D = E[y.private], x = E[y.data];
    if (!x)
      throw new Error(`#[ur-registry][CryptoECKey][fn.fromDataItem]: decoded [dataItem][#data.data] is undefined: ${d}`);
    return new t({ data: x, curve: B, privateKey: D });
  }, t.fromCBOR = (d) => {
    const E = (0, o.decodeToDataItem)(d);
    return t.fromDataItem(E);
  }, CryptoECKey;
}
var Bytes = {}, hasRequiredBytes$2;
function requireBytes$2() {
  if (hasRequiredBytes$2) return Bytes;
  hasRequiredBytes$2 = 1, Object.defineProperty(Bytes, "__esModule", { value: !0 }), Bytes.Bytes = void 0;
  const o = requireLib$6(), g = requireRegistryItem(), c = requireRegistryType$1();
  let y = class extends g.RegistryItem {
    constructor(d) {
      super(), this.bytes = d, this.getRegistryType = () => c.RegistryTypes.BYTES, this.getData = () => this.bytes, this.toDataItem = () => new o.DataItem(this.bytes);
    }
  };
  return Bytes.Bytes = y, y.fromDataItem = (t) => {
    const d = t.getData();
    if (!d)
      throw new Error(`#[ur-registry][Bytes][fn.fromDataItem]: decoded [dataItem][#data] is undefined: ${t}`);
    return new y(d);
  }, y.fromCBOR = (t) => {
    const d = (0, o.decodeToDataItem)(t);
    return y.fromDataItem(d);
  }, Bytes;
}
var CryptoOutput = {}, MultiKey = {}, hasRequiredMultiKey;
function requireMultiKey() {
  if (hasRequiredMultiKey) return MultiKey;
  hasRequiredMultiKey = 1, Object.defineProperty(MultiKey, "__esModule", { value: !0 }), MultiKey.MultiKey = void 0;
  const o = requireCryptoECKey(), g = requireCryptoHDKey(), c = requireDataItem(), y = requireRegistryItem(), t = requireRegistryType$1();
  var d;
  (function(B) {
    B[B.threshold = 1] = "threshold", B[B.keys = 2] = "keys";
  })(d || (d = {}));
  let E = class extends y.RegistryItem {
    constructor(D, x) {
      super(), this.threshold = D, this.keys = x, this.getThreshold = () => this.threshold, this.getKeys = () => this.keys, this.toDataItem = () => {
        const v = {};
        v[d.threshold] = this.threshold;
        const F = this.keys.map((M) => {
          const U = M.toDataItem();
          return U.setTag(M.getRegistryType().getTag()), U;
        });
        return v[d.keys] = F, new c.DataItem(v);
      }, this.getOutputDescriptorContent = () => [
        this.getThreshold(),
        this.keys.map((v) => v.getOutputDescriptorContent()).join(",")
      ].join(",");
    }
  };
  return MultiKey.MultiKey = E, E.fromDataItem = (B) => {
    const D = B.getData(), x = D[d.threshold], v = D[d.keys], F = [];
    return v.forEach((M) => {
      M.getTag() === t.RegistryTypes.CRYPTO_HDKEY.getTag() ? F.push(g.CryptoHDKey.fromDataItem(M)) : M.getTag() === t.RegistryTypes.CRYPTO_ECKEY.getTag() && F.push(o.CryptoECKey.fromDataItem(M));
    }), new E(x, F);
  }, MultiKey;
}
var hasRequiredCryptoOutput;
function requireCryptoOutput() {
  if (hasRequiredCryptoOutput) return CryptoOutput;
  hasRequiredCryptoOutput = 1, Object.defineProperty(CryptoOutput, "__esModule", { value: !0 }), CryptoOutput.CryptoOutput = void 0;
  const o = requireCryptoECKey(), g = requireCryptoHDKey(), c = requireLib$6(), y = requireMultiKey(), t = requireRegistryItem(), d = requireRegistryType$1(), E = requireScriptExpression();
  let B = class extends t.RegistryItem {
    constructor(x, v) {
      super(), this.scriptExpressions = x, this.cryptoKey = v, this.getRegistryType = () => d.RegistryTypes.CRYPTO_OUTPUT, this.getCryptoKey = () => this.cryptoKey, this.getHDKey = () => {
        if (this.cryptoKey instanceof g.CryptoHDKey)
          return this.cryptoKey;
      }, this.getECKey = () => {
        if (this.cryptoKey instanceof o.CryptoECKey)
          return this.cryptoKey;
      }, this.getMultiKey = () => {
        if (this.cryptoKey instanceof y.MultiKey)
          return this.cryptoKey;
      }, this.getScriptExpressions = () => this.scriptExpressions, this._toOutputDescriptor = (F) => F >= this.scriptExpressions.length ? this.cryptoKey.getOutputDescriptorContent() : `${this.scriptExpressions[F].getExpression()}(${this._toOutputDescriptor(F + 1)})`, this.toString = () => this._toOutputDescriptor(0), this.toDataItem = () => {
        let F = this.cryptoKey.toDataItem();
        return (this.cryptoKey instanceof o.CryptoECKey || this.cryptoKey instanceof g.CryptoHDKey) && F.setTag(this.cryptoKey.getRegistryType().getTag()), [...this.scriptExpressions].reverse().forEach((U) => {
          const L = U.getTag();
          F.getTag() === void 0 ? F.setTag(L) : F = new c.DataItem(F, L);
        }), F;
      };
    }
  };
  return CryptoOutput.CryptoOutput = B, B.fromDataItem = (D) => {
    const x = [];
    let v = D;
    for (; ; ) {
      let U = v.getTag();
      const L = E.ScriptExpression.fromTag(U);
      if (L)
        if (x.push(L), v.getData() instanceof c.DataItem)
          v = v.getData(), U = v.getTag();
        else
          break;
      else
        break;
    }
    const F = x.length;
    if (F > 0 && (x[F - 1].getExpression() === E.ScriptExpressions.MULTISIG.getExpression() || x[F - 1].getExpression() === E.ScriptExpressions.SORTED_MULTISIG.getExpression())) {
      const U = y.MultiKey.fromDataItem(v);
      return new B(x, U);
    }
    if (v.getTag() === d.RegistryTypes.CRYPTO_HDKEY.getTag()) {
      const U = g.CryptoHDKey.fromDataItem(v);
      return new B(x, U);
    } else {
      const U = o.CryptoECKey.fromDataItem(v);
      return new B(x, U);
    }
  }, B.fromCBOR = (D) => {
    const x = (0, c.decodeToDataItem)(D);
    return B.fromDataItem(x);
  }, CryptoOutput;
}
var CryptoPSBT = {}, hasRequiredCryptoPSBT;
function requireCryptoPSBT() {
  if (hasRequiredCryptoPSBT) return CryptoPSBT;
  hasRequiredCryptoPSBT = 1, Object.defineProperty(CryptoPSBT, "__esModule", { value: !0 }), CryptoPSBT.CryptoPSBT = void 0;
  const o = requireLib$6(), g = requireRegistryItem(), c = requireRegistryType$1();
  let y = class extends g.RegistryItem {
    constructor(d) {
      super(), this.psbt = d, this.getRegistryType = () => c.RegistryTypes.CRYPTO_PSBT, this.getPSBT = () => this.psbt, this.toDataItem = () => new o.DataItem(this.psbt);
    }
  };
  return CryptoPSBT.CryptoPSBT = y, y.fromDataItem = (t) => {
    const d = t.getData();
    if (!d)
      throw new Error(`#[ur-registry][CryptoPSBT][fn.fromDataItem]: decoded [dataItem][#data] is undefined: ${t}`);
    return new y(d);
  }, y.fromCBOR = (t) => {
    const d = (0, o.decodeToDataItem)(t);
    return y.fromDataItem(d);
  }, CryptoPSBT;
}
var CryptoAccount = {}, hasRequiredCryptoAccount;
function requireCryptoAccount() {
  if (hasRequiredCryptoAccount) return CryptoAccount;
  hasRequiredCryptoAccount = 1, Object.defineProperty(CryptoAccount, "__esModule", { value: !0 }), CryptoAccount.CryptoAccount = void 0;
  const o = requireDist$j(), g = requireLib$6(), c = requireRegistryItem(), y = requireRegistryType$1();
  var t;
  (function(E) {
    E[E.masterFingerprint = 1] = "masterFingerprint", E[E.outputDescriptors = 2] = "outputDescriptors";
  })(t || (t = {}));
  let d = class extends c.RegistryItem {
    constructor(B, D) {
      super(), this.masterFingerprint = B, this.outputDescriptors = D, this.getRegistryType = () => y.RegistryTypes.CRYPTO_ACCOUNT, this.getMasterFingerprint = () => this.masterFingerprint, this.getOutputDescriptors = () => this.outputDescriptors, this.toDataItem = () => {
        const x = {};
        return this.masterFingerprint && (x[t.masterFingerprint] = this.masterFingerprint.readUInt32BE(0)), this.outputDescriptors && (x[t.outputDescriptors] = this.outputDescriptors.map((v) => v.toDataItem())), new g.DataItem(x);
      };
    }
  };
  return CryptoAccount.CryptoAccount = d, d.fromDataItem = (E) => {
    const B = E.getData(), D = Buffer.alloc(4), x = B[t.masterFingerprint];
    x && D.writeUInt32BE(x, 0);
    const F = B[t.outputDescriptors].map((M) => o.CryptoOutput.fromDataItem(M));
    return new d(D, F);
  }, d.fromCBOR = (E) => {
    const B = (0, g.decodeToDataItem)(E);
    return d.fromDataItem(B);
  }, CryptoAccount;
}
var Decoder = {}, errors$2 = {}, hasRequiredErrors$2;
function requireErrors$2() {
  if (hasRequiredErrors$2) return errors$2;
  hasRequiredErrors$2 = 1, Object.defineProperty(errors$2, "__esModule", { value: !0 }), errors$2.UnknownURTypeError = void 0;
  class o extends Error {
    constructor(c) {
      super(c);
    }
  }
  return errors$2.UnknownURTypeError = o, errors$2;
}
var hasRequiredDecoder;
function requireDecoder() {
  if (hasRequiredDecoder) return Decoder;
  hasRequiredDecoder = 1, Object.defineProperty(Decoder, "__esModule", { value: !0 }), Decoder.URRegistryDecoder = void 0;
  const o = requireDist$p(), g = requireDist$j(), c = requireRegistryType$1(), y = requireErrors$2();
  class t extends o.URDecoder {
    constructor() {
      super(...arguments), this.resultRegistryType = () => {
        const E = this.resultUR();
        switch (E.type) {
          case c.RegistryTypes.BYTES.getType():
            return g.Bytes.fromCBOR(E.cbor);
          case c.RegistryTypes.CRYPTO_HDKEY.getType():
            return g.CryptoHDKey.fromCBOR(E.cbor);
          case c.RegistryTypes.CRYPTO_KEYPATH.getType():
            return g.CryptoKeypath.fromCBOR(E.cbor);
          case c.RegistryTypes.CRYPTO_COIN_INFO.getType():
            return g.CryptoCoinInfo.fromCBOR(E.cbor);
          case c.RegistryTypes.CRYPTO_ECKEY.getType():
            return g.CryptoECKey.fromCBOR(E.cbor);
          case c.RegistryTypes.CRYPTO_OUTPUT.getType():
            return g.CryptoOutput.fromCBOR(E.cbor);
          case c.RegistryTypes.CRYPTO_PSBT.getType():
            return g.CryptoPSBT.fromCBOR(E.cbor);
          case c.RegistryTypes.CRYPTO_ACCOUNT.getType():
            return g.CryptoAccount.fromCBOR(E.cbor);
          default:
            throw new y.UnknownURTypeError(`#[ur-registry][Decoder][fn.resultRegistryType]: registry type ${E.type} is not supported now`);
        }
      };
    }
  }
  return Decoder.URRegistryDecoder = t, Decoder;
}
var CryptoMultiAccounts = {}, hasRequiredCryptoMultiAccounts;
function requireCryptoMultiAccounts() {
  if (hasRequiredCryptoMultiAccounts) return CryptoMultiAccounts;
  hasRequiredCryptoMultiAccounts = 1, Object.defineProperty(CryptoMultiAccounts, "__esModule", { value: !0 }), CryptoMultiAccounts.CryptoMultiAccounts = void 0;
  const o = requireRegistryType$1(), g = requireCryptoHDKey(), c = requireRegistryItem(), y = requireLib$6();
  var t;
  (function(E) {
    E[E.masterFingerprint = 1] = "masterFingerprint", E[E.keys = 2] = "keys", E[E.device = 3] = "device", E[E.deviceId = 4] = "deviceId", E[E.version = 5] = "version";
  })(t || (t = {}));
  let d = class extends c.RegistryItem {
    constructor(B, D, x, v, F) {
      super(), this.masterFingerprint = B, this.keys = D, this.device = x, this.deviceId = v, this.version = F, this.getRegistryType = () => o.RegistryTypes.CRYPTO_MULTI_ACCOUNTS, this.getMasterFingerprint = () => this.masterFingerprint, this.getKeys = () => this.keys, this.getDevice = () => this.device, this.getDeviceId = () => this.deviceId, this.getVersion = () => this.version, this.toDataItem = () => {
        const M = {};
        return this.masterFingerprint && (M[t.masterFingerprint] = this.masterFingerprint.readUInt32BE(0)), this.keys && (M[t.keys] = this.keys.map((U) => {
          const L = U.toDataItem();
          return L.setTag(U.getRegistryType().getTag()), L;
        })), this.device && (M[t.device] = this.device), this.deviceId && (M[t.deviceId] = this.deviceId), this.version && (M[t.version] = this.version), new y.DataItem(M);
      };
    }
  };
  return CryptoMultiAccounts.CryptoMultiAccounts = d, d.fromDataItem = (E) => {
    const B = E.getData(), D = Buffer.alloc(4), x = B[t.masterFingerprint];
    x && D.writeUInt32BE(x, 0);
    const F = B[t.keys].map((H) => g.CryptoHDKey.fromDataItem(H)), M = B[t.device], U = B[t.deviceId], L = B[t.version];
    return new d(D, F, M, U, L);
  }, d.fromCBOR = (E) => {
    const B = (0, y.decodeToDataItem)(E);
    return d.fromDataItem(B);
  }, CryptoMultiAccounts;
}
var QRHardwareCall = {}, KeyDerivation = {}, DerivationSchema = {}, hasRequiredDerivationSchema;
function requireDerivationSchema() {
  return hasRequiredDerivationSchema || (hasRequiredDerivationSchema = 1, function(o) {
    Object.defineProperty(o, "__esModule", { value: !0 }), o.KeyDerivationSchema = o.DerivationAlgorithm = o.Curve = void 0;
    const g = requireRegistryType$1(), c = requireRegistryItem(), y = requireLib$6(), t = requireCryptoKeypath();
    var d;
    (function(x) {
      x[x.keyPath = 1] = "keyPath", x[x.curve = 2] = "curve", x[x.algo = 3] = "algo", x[x.chainType = 4] = "chainType";
    })(d || (d = {}));
    var E;
    (function(x) {
      x[x.secp256k1 = 0] = "secp256k1", x[x.ed25519 = 1] = "ed25519";
    })(E = o.Curve || (o.Curve = {}));
    var B;
    (function(x) {
      x[x.slip10 = 0] = "slip10", x[x.bip32ed25519 = 1] = "bip32ed25519";
    })(B = o.DerivationAlgorithm || (o.DerivationAlgorithm = {}));
    class D extends c.RegistryItem {
      constructor(v, F = E.secp256k1, M = B.slip10, U) {
        super(), this.keypath = v, this.curve = F, this.algo = M, this.chainType = U, this.getRegistryType = () => g.RegistryTypes.KEY_DERIVATION_SCHEMA, this.getKeypath = () => this.keypath, this.getCurve = () => this.curve, this.getAlgo = () => this.algo, this.getChainType = () => this.chainType, this.toDataItem = () => {
          const L = {}, H = this.getKeypath().toDataItem();
          return H.setTag(this.getKeypath().getRegistryType().getTag()), L[d.keyPath] = H, L[d.curve] = this.curve, L[d.algo] = this.algo, this.chainType && (L[d.chainType] = this.chainType), new y.DataItem(L);
        };
      }
    }
    o.KeyDerivationSchema = D, D.fromDataItem = (x) => {
      const v = x.getData(), F = t.CryptoKeypath.fromDataItem(v[d.keyPath]), M = v[d.curve], U = v[d.algo], L = v[d.chainType];
      return new D(F, M, U, L);
    }, D.fromCBOR = (x) => {
      const v = (0, y.decodeToDataItem)(x);
      return D.fromDataItem(v);
    };
  }(DerivationSchema)), DerivationSchema;
}
var hasRequiredKeyDerivation;
function requireKeyDerivation() {
  if (hasRequiredKeyDerivation) return KeyDerivation;
  hasRequiredKeyDerivation = 1, Object.defineProperty(KeyDerivation, "__esModule", { value: !0 }), KeyDerivation.KeyDerivation = void 0;
  const o = requireRegistryType$1(), g = requireRegistryItem(), c = requireLib$6(), y = requireDerivationSchema();
  var t;
  (function(E) {
    E[E.schemas = 1] = "schemas";
  })(t || (t = {}));
  let d = class extends g.RegistryItem {
    constructor(B) {
      super(), this.schemas = B, this.getRegistryType = () => o.RegistryTypes.KEY_DERIVATION_CALL, this.getSchemas = () => this.schemas, this.toDataItem = () => {
        const D = {};
        return D[t.schemas] = this.schemas.map((x) => {
          const v = x.toDataItem();
          return v.setTag(x.getRegistryType().getTag()), v;
        }), new c.DataItem(D);
      };
    }
  };
  return KeyDerivation.KeyDerivation = d, d.fromDataItem = (E) => {
    const D = E.getData()[t.schemas].map((x) => y.KeyDerivationSchema.fromDataItem(x));
    return new d(D);
  }, d.fromCBOR = (E) => {
    const B = (0, c.decodeToDataItem)(E);
    return d.fromDataItem(B);
  }, KeyDerivation;
}
var hasRequiredQRHardwareCall;
function requireQRHardwareCall() {
  return hasRequiredQRHardwareCall || (hasRequiredQRHardwareCall = 1, function(o) {
    Object.defineProperty(o, "__esModule", { value: !0 }), o.QRHardwareCall = o.QRHardwareCallVersion = o.QRHardwareCallType = void 0;
    const g = requireRegistryType$1(), c = requireRegistryItem(), y = requireLib$6(), t = requireKeyDerivation();
    var d;
    (function(D) {
      D[D.type = 1] = "type", D[D.params = 2] = "params", D[D.origin = 3] = "origin", D[D.version = 4] = "version";
    })(d || (d = {}));
    var E;
    (function(D) {
      D[D.KeyDerivation = 0] = "KeyDerivation";
    })(E = o.QRHardwareCallType || (o.QRHardwareCallType = {})), function(D) {
      D[D.V0 = 0] = "V0", D[D.V1 = 1] = "V1";
    }(o.QRHardwareCallVersion || (o.QRHardwareCallVersion = {}));
    class B extends c.RegistryItem {
      constructor(x, v, F, M) {
        super(), this.type = x, this.params = v, this.origin = F, this.version = M, this.getRegistryType = () => g.RegistryTypes.QR_HARDWARE_CALL, this.getType = () => this.type, this.getParams = () => this.params, this.getOrigin = () => this.origin, this.getVersion = () => this.version, this.toDataItem = () => {
          const U = {};
          U[d.type] = this.type;
          const L = this.params.toDataItem();
          return L.setTag(this.params.getRegistryType().getTag()), U[d.params] = L, this.origin && (U[d.origin] = this.origin), this.version && (U[d.version] = this.version), new y.DataItem(U);
        };
      }
    }
    o.QRHardwareCall = B, B.fromDataItem = (D) => {
      const x = D.getData(), v = x[d.type] || E.KeyDerivation;
      let F;
      switch (v) {
        case E.KeyDerivation:
          F = t.KeyDerivation.fromDataItem(x[d.params]);
      }
      const M = x[d.origin], U = x[d.version];
      return new B(v, F, M, U);
    }, B.fromCBOR = (D) => {
      const x = (0, y.decodeToDataItem)(D);
      return B.fromDataItem(x);
    };
  }(QRHardwareCall)), QRHardwareCall;
}
var types$7 = {}, hasRequiredTypes$7;
function requireTypes$7() {
  return hasRequiredTypes$7 || (hasRequiredTypes$7 = 1, Object.defineProperty(types$7, "__esModule", { value: !0 })), types$7;
}
var hasRequiredDist$j;
function requireDist$j() {
  return hasRequiredDist$j || (hasRequiredDist$j = 1, function(o) {
    Object.defineProperty(o, "__esModule", { value: !0 }), o.Buffer = o.extend = o.PathComponent = o.ScriptExpressions = o.MultiKey = o.CryptoPSBT = o.CryptoOutput = o.CryptoECKey = o.CryptoCoinInfoNetwork = o.CryptoCoinInfoType = o.CryptoCoinInfo = o.CryptoKeypath = o.CryptoMultiAccounts = o.CryptoHDKey = o.CryptoAccount = o.Bytes = o.URRegistryDecoder = o.DataItem = void 0;
    const g = require$$0$2;
    requirePatchCBOR();
    const c = requireBuffer$2();
    Object.defineProperty(o, "Buffer", { enumerable: !0, get: function() {
      return c.Buffer;
    } });
    const y = requireCryptoHDKey();
    Object.defineProperty(o, "CryptoHDKey", { enumerable: !0, get: function() {
      return y.CryptoHDKey;
    } });
    const t = requireCryptoKeypath();
    Object.defineProperty(o, "CryptoKeypath", { enumerable: !0, get: function() {
      return t.CryptoKeypath;
    } });
    const d = requireCryptoCoinInfo();
    Object.defineProperty(o, "CryptoCoinInfo", { enumerable: !0, get: function() {
      return d.CryptoCoinInfo;
    } }), Object.defineProperty(o, "CryptoCoinInfoType", { enumerable: !0, get: function() {
      return d.Type;
    } }), Object.defineProperty(o, "CryptoCoinInfoNetwork", { enumerable: !0, get: function() {
      return d.Network;
    } });
    const E = requireCryptoECKey();
    Object.defineProperty(o, "CryptoECKey", { enumerable: !0, get: function() {
      return E.CryptoECKey;
    } });
    const B = requireBytes$2();
    Object.defineProperty(o, "Bytes", { enumerable: !0, get: function() {
      return B.Bytes;
    } });
    const D = requireCryptoOutput();
    Object.defineProperty(o, "CryptoOutput", { enumerable: !0, get: function() {
      return D.CryptoOutput;
    } });
    const x = requireCryptoPSBT();
    Object.defineProperty(o, "CryptoPSBT", { enumerable: !0, get: function() {
      return x.CryptoPSBT;
    } });
    const v = requireCryptoAccount();
    Object.defineProperty(o, "CryptoAccount", { enumerable: !0, get: function() {
      return v.CryptoAccount;
    } });
    const F = requireDecoder();
    Object.defineProperty(o, "URRegistryDecoder", { enumerable: !0, get: function() {
      return F.URRegistryDecoder;
    } });
    const M = requireMultiKey();
    Object.defineProperty(o, "MultiKey", { enumerable: !0, get: function() {
      return M.MultiKey;
    } });
    const U = requireScriptExpression();
    Object.defineProperty(o, "ScriptExpressions", { enumerable: !0, get: function() {
      return U.ScriptExpressions;
    } });
    const L = requirePathComponent();
    Object.defineProperty(o, "PathComponent", { enumerable: !0, get: function() {
      return L.PathComponent;
    } });
    const H = requireRegistryItem(), fe = requireRegistryType$1(), ge = requireLib$6();
    var Ie = requireLib$6();
    Object.defineProperty(o, "DataItem", { enumerable: !0, get: function() {
      return Ie.DataItem;
    } });
    const Ee = requireUtils$c(), Se = requireCryptoMultiAccounts();
    Object.defineProperty(o, "CryptoMultiAccounts", { enumerable: !0, get: function() {
      return Se.CryptoMultiAccounts;
    } });
    const ze = {
      URRegistryDecoder: F.URRegistryDecoder,
      Bytes: B.Bytes,
      CryptoAccount: v.CryptoAccount,
      CryptoHDKey: y.CryptoHDKey,
      CryptoMultiAccounts: Se.CryptoMultiAccounts,
      CryptoKeypath: t.CryptoKeypath,
      CryptoCoinInfo: d.CryptoCoinInfo,
      CryptoCoinInfoType: d.Type,
      CryptoCoinInfoNetwork: d.Network,
      CryptoECKey: E.CryptoECKey,
      CryptoOutput: D.CryptoOutput,
      CryptoPSBT: x.CryptoPSBT,
      MultiKey: M.MultiKey,
      ScriptExpressions: U.ScriptExpressions,
      PathComponent: L.PathComponent
    }, He = {
      addReader: ge.addReader,
      addSemanticDecode: ge.addSemanticDecode,
      addSemanticEncode: ge.addSemanticEncode,
      addWriter: ge.addWriter,
      patchTags: Ee.patchTags
    }, Pe = {
      RegistryTypes: fe.RegistryTypes,
      RegistryItem: H.RegistryItem,
      RegistryType: fe.RegistryType,
      decodeToDataItem: ge.decodeToDataItem,
      encodeDataItem: ge.encodeDataItem,
      cbor: He
    };
    o.extend = Pe, (0, g.__exportStar)(requireErrors$2(), o), (0, g.__exportStar)(requireDecoder(), o), (0, g.__exportStar)(requireLib$6(), o), (0, g.__exportStar)(requireCryptoAccount(), o), (0, g.__exportStar)(requireCryptoPSBT(), o), (0, g.__exportStar)(requireCryptoHDKey(), o), (0, g.__exportStar)(requireCryptoMultiAccounts(), o), (0, g.__exportStar)(requireQRHardwareCall(), o), (0, g.__exportStar)(requireKeyDerivation(), o), (0, g.__exportStar)(requireDerivationSchema(), o), (0, g.__exportStar)(requireCryptoOutput(), o), (0, g.__exportStar)(requireCryptoCoinInfo(), o), (0, g.__exportStar)(requireCryptoECKey(), o), (0, g.__exportStar)(requireMultiKey(), o), (0, g.__exportStar)(requireCryptoKeypath(), o), (0, g.__exportStar)(requirePatchCBOR(), o), (0, g.__exportStar)(requirePathComponent(), o), (0, g.__exportStar)(requireRegistryItem(), o), (0, g.__exportStar)(requireRegistryType$1(), o), (0, g.__exportStar)(requireTypes$7(), o), (0, g.__exportStar)(requireUtils$c(), o), o.default = ze;
  }(dist$h)), dist$h;
}
var cryptoBrowserify = {}, browser$9 = { exports: {} }, hasRequiredBrowser$9;
function requireBrowser$9() {
  if (hasRequiredBrowser$9) return browser$9.exports;
  hasRequiredBrowser$9 = 1;
  var o = 65536, g = 4294967295;
  function c() {
    throw new Error(`Secure random number generation is not supported by this browser.
Use Chrome, Firefox or Internet Explorer 11`);
  }
  var y = requireSafeBuffer$1().Buffer, t = commonjsGlobal.crypto || commonjsGlobal.msCrypto;
  t && t.getRandomValues ? browser$9.exports = d : browser$9.exports = c;
  function d(E, B) {
    if (E > g) throw new RangeError("requested too many random bytes");
    var D = y.allocUnsafe(E);
    if (E > 0)
      if (E > o)
        for (var x = 0; x < E; x += o)
          t.getRandomValues(D.slice(x, x + o));
      else
        t.getRandomValues(D);
    return typeof B == "function" ? process$1.nextTick(function() {
      B(null, D);
    }) : D;
  }
  return browser$9.exports;
}
var legacy$1, hasRequiredLegacy$1;
function requireLegacy$1() {
  if (hasRequiredLegacy$1) return legacy$1;
  hasRequiredLegacy$1 = 1;
  var o = requireInherits_browser(), g = requireSafeBuffer$1().Buffer, c = requireCipherBase(), y = g.alloc(128), t = 64;
  function d(E, B) {
    c.call(this, "digest"), typeof B == "string" && (B = g.from(B)), this._alg = E, this._key = B, B.length > t ? B = E(B) : B.length < t && (B = g.concat([B, y], t));
    for (var D = this._ipad = g.allocUnsafe(t), x = this._opad = g.allocUnsafe(t), v = 0; v < t; v++)
      D[v] = B[v] ^ 54, x[v] = B[v] ^ 92;
    this._hash = [D];
  }
  return o(d, c), d.prototype._update = function(E) {
    this._hash.push(E);
  }, d.prototype._final = function() {
    var E = this._alg(g.concat(this._hash));
    return this._alg(g.concat([this._opad, E]));
  }, legacy$1 = d, legacy$1;
}
var md5$3, hasRequiredMd5$2;
function requireMd5$2() {
  if (hasRequiredMd5$2) return md5$3;
  hasRequiredMd5$2 = 1;
  var o = requireMd5_js();
  return md5$3 = function(g) {
    return new o().update(g).digest();
  }, md5$3;
}
var browser$8, hasRequiredBrowser$8;
function requireBrowser$8() {
  if (hasRequiredBrowser$8) return browser$8;
  hasRequiredBrowser$8 = 1;
  var o = requireInherits_browser(), g = requireLegacy$1(), c = requireCipherBase(), y = requireSafeBuffer$1().Buffer, t = requireMd5$2(), d = requireRipemd160$2(), E = requireSha_js(), B = y.alloc(128);
  function D(x, v) {
    c.call(this, "digest"), typeof v == "string" && (v = y.from(v));
    var F = x === "sha512" || x === "sha384" ? 128 : 64;
    if (this._alg = x, this._key = v, v.length > F) {
      var M = x === "rmd160" ? new d() : E(x);
      v = M.update(v).digest();
    } else v.length < F && (v = y.concat([v, B], F));
    for (var U = this._ipad = y.allocUnsafe(F), L = this._opad = y.allocUnsafe(F), H = 0; H < F; H++)
      U[H] = v[H] ^ 54, L[H] = v[H] ^ 92;
    this._hash = x === "rmd160" ? new d() : E(x), this._hash.update(U);
  }
  return o(D, c), D.prototype._update = function(x) {
    this._hash.update(x);
  }, D.prototype._final = function() {
    var x = this._hash.digest(), v = this._alg === "rmd160" ? new d() : E(this._alg);
    return v.update(this._opad).update(x).digest();
  }, browser$8 = function(v, F) {
    return v = v.toLowerCase(), v === "rmd160" || v === "ripemd160" ? new D("rmd160", F) : v === "md5" ? new g(t, F) : new D(v, F);
  }, browser$8;
}
const sha224WithRSAEncryption = { sign: "rsa", hash: "sha224", id: "302d300d06096086480165030402040500041c" }, sha256WithRSAEncryption = { sign: "rsa", hash: "sha256", id: "3031300d060960864801650304020105000420" }, sha384WithRSAEncryption = { sign: "rsa", hash: "sha384", id: "3041300d060960864801650304020205000430" }, sha512WithRSAEncryption = { sign: "rsa", hash: "sha512", id: "3051300d060960864801650304020305000440" }, sha256$7 = { sign: "ecdsa", hash: "sha256", id: "" }, sha224$1 = { sign: "ecdsa", hash: "sha224", id: "" }, sha384$1 = { sign: "ecdsa", hash: "sha384", id: "" }, sha512$3 = { sign: "ecdsa", hash: "sha512", id: "" }, DSA = { sign: "dsa", hash: "sha1", id: "" }, ripemd160WithRSA = { sign: "rsa", hash: "rmd160", id: "3021300906052b2403020105000414" }, md5WithRSAEncryption = { sign: "rsa", hash: "md5", id: "3020300c06082a864886f70d020505000410" }, require$$6 = {
  sha224WithRSAEncryption,
  "RSA-SHA224": { sign: "ecdsa/rsa", hash: "sha224", id: "302d300d06096086480165030402040500041c" },
  sha256WithRSAEncryption,
  "RSA-SHA256": { sign: "ecdsa/rsa", hash: "sha256", id: "3031300d060960864801650304020105000420" },
  sha384WithRSAEncryption,
  "RSA-SHA384": { sign: "ecdsa/rsa", hash: "sha384", id: "3041300d060960864801650304020205000430" },
  sha512WithRSAEncryption,
  "RSA-SHA512": { sign: "ecdsa/rsa", hash: "sha512", id: "3051300d060960864801650304020305000440" },
  "RSA-SHA1": { sign: "rsa", hash: "sha1", id: "3021300906052b0e03021a05000414" },
  "ecdsa-with-SHA1": { sign: "ecdsa", hash: "sha1", id: "" },
  sha256: sha256$7,
  sha224: sha224$1,
  sha384: sha384$1,
  sha512: sha512$3,
  "DSA-SHA": { sign: "dsa", hash: "sha1", id: "" },
  "DSA-SHA1": { sign: "dsa", hash: "sha1", id: "" },
  DSA,
  "DSA-WITH-SHA224": { sign: "dsa", hash: "sha224", id: "" },
  "DSA-SHA224": { sign: "dsa", hash: "sha224", id: "" },
  "DSA-WITH-SHA256": { sign: "dsa", hash: "sha256", id: "" },
  "DSA-SHA256": { sign: "dsa", hash: "sha256", id: "" },
  "DSA-WITH-SHA384": { sign: "dsa", hash: "sha384", id: "" },
  "DSA-SHA384": { sign: "dsa", hash: "sha384", id: "" },
  "DSA-WITH-SHA512": { sign: "dsa", hash: "sha512", id: "" },
  "DSA-SHA512": { sign: "dsa", hash: "sha512", id: "" },
  "DSA-RIPEMD160": { sign: "dsa", hash: "rmd160", id: "" },
  ripemd160WithRSA,
  "RSA-RIPEMD160": { sign: "rsa", hash: "rmd160", id: "3021300906052b2403020105000414" },
  md5WithRSAEncryption,
  "RSA-MD5": { sign: "rsa", hash: "md5", id: "3020300c06082a864886f70d020505000410" }
};
var algos, hasRequiredAlgos;
function requireAlgos() {
  return hasRequiredAlgos || (hasRequiredAlgos = 1, algos = require$$6), algos;
}
var browser$7 = {}, precondition, hasRequiredPrecondition;
function requirePrecondition() {
  if (hasRequiredPrecondition) return precondition;
  hasRequiredPrecondition = 1;
  var o = Math.pow(2, 30) - 1;
  return precondition = function(g, c) {
    if (typeof g != "number")
      throw new TypeError("Iterations not a number");
    if (g < 0)
      throw new TypeError("Bad iterations");
    if (typeof c != "number")
      throw new TypeError("Key length not a number");
    if (c < 0 || c > o || c !== c)
      throw new TypeError("Bad key length");
  }, precondition;
}
var defaultEncoding_1, hasRequiredDefaultEncoding;
function requireDefaultEncoding() {
  if (hasRequiredDefaultEncoding) return defaultEncoding_1;
  hasRequiredDefaultEncoding = 1;
  var o;
  if (commonjsGlobal.process && commonjsGlobal.process.browser)
    o = "utf-8";
  else if (commonjsGlobal.process && commonjsGlobal.process.version) {
    var g = parseInt(process$1.version.split(".")[0].slice(1), 10);
    o = g >= 6 ? "utf-8" : "binary";
  } else
    o = "utf-8";
  return defaultEncoding_1 = o, defaultEncoding_1;
}
var makeHash, hasRequiredMakeHash;
function requireMakeHash() {
  if (hasRequiredMakeHash) return makeHash;
  hasRequiredMakeHash = 1;
  var o = 4, g = new Buffer(o);
  g.fill(0);
  var c = 8, y = 16;
  function t(d) {
    if (d.length % o !== 0) {
      var E = d.length + (o - d.length % o);
      d = Buffer.concat([d, g], E);
    }
    for (var B = new Array(d.length >>> 2), D = 0, x = 0; D < d.length; D += o, x++)
      B[x] = d.readInt32LE(D);
    return B;
  }
  return makeHash = function(E, B) {
    var D = B(t(E), E.length * c);
    E = new Buffer(y);
    for (var x = 0; x < D.length; x++)
      E.writeInt32LE(D[x], x << 2, !0);
    return E;
  }, makeHash;
}
var md5$2, hasRequiredMd5$1;
function requireMd5$1() {
  if (hasRequiredMd5$1) return md5$2;
  hasRequiredMd5$1 = 1;
  var o = requireMakeHash();
  function g(x, v) {
    x[v >> 5] |= 128 << v % 32, x[(v + 64 >>> 9 << 4) + 14] = v;
    for (var F = 1732584193, M = -271733879, U = -1732584194, L = 271733878, H = 0; H < x.length; H += 16) {
      var fe = F, ge = M, Ie = U, Ee = L;
      F = y(F, M, U, L, x[H + 0], 7, -680876936), L = y(L, F, M, U, x[H + 1], 12, -389564586), U = y(U, L, F, M, x[H + 2], 17, 606105819), M = y(M, U, L, F, x[H + 3], 22, -1044525330), F = y(F, M, U, L, x[H + 4], 7, -176418897), L = y(L, F, M, U, x[H + 5], 12, 1200080426), U = y(U, L, F, M, x[H + 6], 17, -1473231341), M = y(M, U, L, F, x[H + 7], 22, -45705983), F = y(F, M, U, L, x[H + 8], 7, 1770035416), L = y(L, F, M, U, x[H + 9], 12, -1958414417), U = y(U, L, F, M, x[H + 10], 17, -42063), M = y(M, U, L, F, x[H + 11], 22, -1990404162), F = y(F, M, U, L, x[H + 12], 7, 1804603682), L = y(L, F, M, U, x[H + 13], 12, -40341101), U = y(U, L, F, M, x[H + 14], 17, -1502002290), M = y(M, U, L, F, x[H + 15], 22, 1236535329), F = t(F, M, U, L, x[H + 1], 5, -165796510), L = t(L, F, M, U, x[H + 6], 9, -1069501632), U = t(U, L, F, M, x[H + 11], 14, 643717713), M = t(M, U, L, F, x[H + 0], 20, -373897302), F = t(F, M, U, L, x[H + 5], 5, -701558691), L = t(L, F, M, U, x[H + 10], 9, 38016083), U = t(U, L, F, M, x[H + 15], 14, -660478335), M = t(M, U, L, F, x[H + 4], 20, -405537848), F = t(F, M, U, L, x[H + 9], 5, 568446438), L = t(L, F, M, U, x[H + 14], 9, -1019803690), U = t(U, L, F, M, x[H + 3], 14, -187363961), M = t(M, U, L, F, x[H + 8], 20, 1163531501), F = t(F, M, U, L, x[H + 13], 5, -1444681467), L = t(L, F, M, U, x[H + 2], 9, -51403784), U = t(U, L, F, M, x[H + 7], 14, 1735328473), M = t(M, U, L, F, x[H + 12], 20, -1926607734), F = d(F, M, U, L, x[H + 5], 4, -378558), L = d(L, F, M, U, x[H + 8], 11, -2022574463), U = d(U, L, F, M, x[H + 11], 16, 1839030562), M = d(M, U, L, F, x[H + 14], 23, -35309556), F = d(F, M, U, L, x[H + 1], 4, -1530992060), L = d(L, F, M, U, x[H + 4], 11, 1272893353), U = d(U, L, F, M, x[H + 7], 16, -155497632), M = d(M, U, L, F, x[H + 10], 23, -1094730640), F = d(F, M, U, L, x[H + 13], 4, 681279174), L = d(L, F, M, U, x[H + 0], 11, -358537222), U = d(U, L, F, M, x[H + 3], 16, -722521979), M = d(M, U, L, F, x[H + 6], 23, 76029189), F = d(F, M, U, L, x[H + 9], 4, -640364487), L = d(L, F, M, U, x[H + 12], 11, -421815835), U = d(U, L, F, M, x[H + 15], 16, 530742520), M = d(M, U, L, F, x[H + 2], 23, -995338651), F = E(F, M, U, L, x[H + 0], 6, -198630844), L = E(L, F, M, U, x[H + 7], 10, 1126891415), U = E(U, L, F, M, x[H + 14], 15, -1416354905), M = E(M, U, L, F, x[H + 5], 21, -57434055), F = E(F, M, U, L, x[H + 12], 6, 1700485571), L = E(L, F, M, U, x[H + 3], 10, -1894986606), U = E(U, L, F, M, x[H + 10], 15, -1051523), M = E(M, U, L, F, x[H + 1], 21, -2054922799), F = E(F, M, U, L, x[H + 8], 6, 1873313359), L = E(L, F, M, U, x[H + 15], 10, -30611744), U = E(U, L, F, M, x[H + 6], 15, -1560198380), M = E(M, U, L, F, x[H + 13], 21, 1309151649), F = E(F, M, U, L, x[H + 4], 6, -145523070), L = E(L, F, M, U, x[H + 11], 10, -1120210379), U = E(U, L, F, M, x[H + 2], 15, 718787259), M = E(M, U, L, F, x[H + 9], 21, -343485551), F = B(F, fe), M = B(M, ge), U = B(U, Ie), L = B(L, Ee);
    }
    return [F, M, U, L];
  }
  function c(x, v, F, M, U, L) {
    return B(D(B(B(v, x), B(M, L)), U), F);
  }
  function y(x, v, F, M, U, L, H) {
    return c(v & F | ~v & M, x, v, U, L, H);
  }
  function t(x, v, F, M, U, L, H) {
    return c(v & M | F & ~M, x, v, U, L, H);
  }
  function d(x, v, F, M, U, L, H) {
    return c(v ^ F ^ M, x, v, U, L, H);
  }
  function E(x, v, F, M, U, L, H) {
    return c(F ^ (v | ~M), x, v, U, L, H);
  }
  function B(x, v) {
    var F = (x & 65535) + (v & 65535), M = (x >> 16) + (v >> 16) + (F >> 16);
    return M << 16 | F & 65535;
  }
  function D(x, v) {
    return x << v | x >>> 32 - v;
  }
  return md5$2 = function(v) {
    return o(v, g);
  }, md5$2;
}
var hashBase, hasRequiredHashBase;
function requireHashBase() {
  if (hasRequiredHashBase) return hashBase;
  hasRequiredHashBase = 1;
  var o = require$$2$2.Transform, g = requireInherits_browser();
  function c(y) {
    o.call(this), this._block = new Buffer(y), this._blockSize = y, this._blockOffset = 0, this._length = [0, 0, 0, 0], this._finalized = !1;
  }
  return g(c, o), c.prototype._transform = function(y, t, d) {
    var E = null;
    try {
      t !== "buffer" && (y = new Buffer(y, t)), this.update(y);
    } catch (B) {
      E = B;
    }
    d(E);
  }, c.prototype._flush = function(y) {
    var t = null;
    try {
      this.push(this._digest());
    } catch (d) {
      t = d;
    }
    y(t);
  }, c.prototype.update = function(y, t) {
    if (!Buffer.isBuffer(y) && typeof y != "string") throw new TypeError("Data must be a string or a buffer");
    if (this._finalized) throw new Error("Digest already called");
    Buffer.isBuffer(y) || (y = new Buffer(y, t || "binary"));
    for (var d = this._block, E = 0; this._blockOffset + y.length - E >= this._blockSize; ) {
      for (var B = this._blockOffset; B < this._blockSize; ) d[B++] = y[E++];
      this._update(), this._blockOffset = 0;
    }
    for (; E < y.length; ) d[this._blockOffset++] = y[E++];
    for (var D = 0, x = y.length * 8; x > 0; ++D)
      this._length[D] += x, x = this._length[D] / 4294967296 | 0, x > 0 && (this._length[D] -= 4294967296 * x);
    return this;
  }, c.prototype._update = function(y) {
    throw new Error("_update is not implemented");
  }, c.prototype.digest = function(y) {
    if (this._finalized) throw new Error("Digest already called");
    this._finalized = !0;
    var t = this._digest();
    return y !== void 0 && (t = t.toString(y)), t;
  }, c.prototype._digest = function() {
    throw new Error("_digest is not implemented");
  }, hashBase = c, hashBase;
}
var ripemd160$4, hasRequiredRipemd160$1;
function requireRipemd160$1() {
  if (hasRequiredRipemd160$1) return ripemd160$4;
  hasRequiredRipemd160$1 = 1;
  var o = requireInherits_browser(), g = requireHashBase();
  function c() {
    g.call(this, 64), this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520;
  }
  o(c, g), c.prototype._update = function() {
    for (var x = new Array(16), v = 0; v < 16; ++v) x[v] = this._block.readInt32LE(v * 4);
    var F = this._a, M = this._b, U = this._c, L = this._d, H = this._e;
    F = t(F, M, U, L, H, x[0], 0, 11), U = y(U, 10), H = t(H, F, M, U, L, x[1], 0, 14), M = y(M, 10), L = t(L, H, F, M, U, x[2], 0, 15), F = y(F, 10), U = t(U, L, H, F, M, x[3], 0, 12), H = y(H, 10), M = t(M, U, L, H, F, x[4], 0, 5), L = y(L, 10), F = t(F, M, U, L, H, x[5], 0, 8), U = y(U, 10), H = t(H, F, M, U, L, x[6], 0, 7), M = y(M, 10), L = t(L, H, F, M, U, x[7], 0, 9), F = y(F, 10), U = t(U, L, H, F, M, x[8], 0, 11), H = y(H, 10), M = t(M, U, L, H, F, x[9], 0, 13), L = y(L, 10), F = t(F, M, U, L, H, x[10], 0, 14), U = y(U, 10), H = t(H, F, M, U, L, x[11], 0, 15), M = y(M, 10), L = t(L, H, F, M, U, x[12], 0, 6), F = y(F, 10), U = t(U, L, H, F, M, x[13], 0, 7), H = y(H, 10), M = t(M, U, L, H, F, x[14], 0, 9), L = y(L, 10), F = t(F, M, U, L, H, x[15], 0, 8), U = y(U, 10), H = d(H, F, M, U, L, x[7], 1518500249, 7), M = y(M, 10), L = d(L, H, F, M, U, x[4], 1518500249, 6), F = y(F, 10), U = d(U, L, H, F, M, x[13], 1518500249, 8), H = y(H, 10), M = d(M, U, L, H, F, x[1], 1518500249, 13), L = y(L, 10), F = d(F, M, U, L, H, x[10], 1518500249, 11), U = y(U, 10), H = d(H, F, M, U, L, x[6], 1518500249, 9), M = y(M, 10), L = d(L, H, F, M, U, x[15], 1518500249, 7), F = y(F, 10), U = d(U, L, H, F, M, x[3], 1518500249, 15), H = y(H, 10), M = d(M, U, L, H, F, x[12], 1518500249, 7), L = y(L, 10), F = d(F, M, U, L, H, x[0], 1518500249, 12), U = y(U, 10), H = d(H, F, M, U, L, x[9], 1518500249, 15), M = y(M, 10), L = d(L, H, F, M, U, x[5], 1518500249, 9), F = y(F, 10), U = d(U, L, H, F, M, x[2], 1518500249, 11), H = y(H, 10), M = d(M, U, L, H, F, x[14], 1518500249, 7), L = y(L, 10), F = d(F, M, U, L, H, x[11], 1518500249, 13), U = y(U, 10), H = d(H, F, M, U, L, x[8], 1518500249, 12), M = y(M, 10), L = E(L, H, F, M, U, x[3], 1859775393, 11), F = y(F, 10), U = E(U, L, H, F, M, x[10], 1859775393, 13), H = y(H, 10), M = E(M, U, L, H, F, x[14], 1859775393, 6), L = y(L, 10), F = E(F, M, U, L, H, x[4], 1859775393, 7), U = y(U, 10), H = E(H, F, M, U, L, x[9], 1859775393, 14), M = y(M, 10), L = E(L, H, F, M, U, x[15], 1859775393, 9), F = y(F, 10), U = E(U, L, H, F, M, x[8], 1859775393, 13), H = y(H, 10), M = E(M, U, L, H, F, x[1], 1859775393, 15), L = y(L, 10), F = E(F, M, U, L, H, x[2], 1859775393, 14), U = y(U, 10), H = E(H, F, M, U, L, x[7], 1859775393, 8), M = y(M, 10), L = E(L, H, F, M, U, x[0], 1859775393, 13), F = y(F, 10), U = E(U, L, H, F, M, x[6], 1859775393, 6), H = y(H, 10), M = E(M, U, L, H, F, x[13], 1859775393, 5), L = y(L, 10), F = E(F, M, U, L, H, x[11], 1859775393, 12), U = y(U, 10), H = E(H, F, M, U, L, x[5], 1859775393, 7), M = y(M, 10), L = E(L, H, F, M, U, x[12], 1859775393, 5), F = y(F, 10), U = B(U, L, H, F, M, x[1], 2400959708, 11), H = y(H, 10), M = B(M, U, L, H, F, x[9], 2400959708, 12), L = y(L, 10), F = B(F, M, U, L, H, x[11], 2400959708, 14), U = y(U, 10), H = B(H, F, M, U, L, x[10], 2400959708, 15), M = y(M, 10), L = B(L, H, F, M, U, x[0], 2400959708, 14), F = y(F, 10), U = B(U, L, H, F, M, x[8], 2400959708, 15), H = y(H, 10), M = B(M, U, L, H, F, x[12], 2400959708, 9), L = y(L, 10), F = B(F, M, U, L, H, x[4], 2400959708, 8), U = y(U, 10), H = B(H, F, M, U, L, x[13], 2400959708, 9), M = y(M, 10), L = B(L, H, F, M, U, x[3], 2400959708, 14), F = y(F, 10), U = B(U, L, H, F, M, x[7], 2400959708, 5), H = y(H, 10), M = B(M, U, L, H, F, x[15], 2400959708, 6), L = y(L, 10), F = B(F, M, U, L, H, x[14], 2400959708, 8), U = y(U, 10), H = B(H, F, M, U, L, x[5], 2400959708, 6), M = y(M, 10), L = B(L, H, F, M, U, x[6], 2400959708, 5), F = y(F, 10), U = B(U, L, H, F, M, x[2], 2400959708, 12), H = y(H, 10), M = D(M, U, L, H, F, x[4], 2840853838, 9), L = y(L, 10), F = D(F, M, U, L, H, x[0], 2840853838, 15), U = y(U, 10), H = D(H, F, M, U, L, x[5], 2840853838, 5), M = y(M, 10), L = D(L, H, F, M, U, x[9], 2840853838, 11), F = y(F, 10), U = D(U, L, H, F, M, x[7], 2840853838, 6), H = y(H, 10), M = D(M, U, L, H, F, x[12], 2840853838, 8), L = y(L, 10), F = D(F, M, U, L, H, x[2], 2840853838, 13), U = y(U, 10), H = D(H, F, M, U, L, x[10], 2840853838, 12), M = y(M, 10), L = D(L, H, F, M, U, x[14], 2840853838, 5), F = y(F, 10), U = D(U, L, H, F, M, x[1], 2840853838, 12), H = y(H, 10), M = D(M, U, L, H, F, x[3], 2840853838, 13), L = y(L, 10), F = D(F, M, U, L, H, x[8], 2840853838, 14), U = y(U, 10), H = D(H, F, M, U, L, x[11], 2840853838, 11), M = y(M, 10), L = D(L, H, F, M, U, x[6], 2840853838, 8), F = y(F, 10), U = D(U, L, H, F, M, x[15], 2840853838, 5), H = y(H, 10), M = D(M, U, L, H, F, x[13], 2840853838, 6), L = y(L, 10);
    var fe = this._a, ge = this._b, Ie = this._c, Ee = this._d, Se = this._e;
    fe = D(fe, ge, Ie, Ee, Se, x[5], 1352829926, 8), Ie = y(Ie, 10), Se = D(Se, fe, ge, Ie, Ee, x[14], 1352829926, 9), ge = y(ge, 10), Ee = D(Ee, Se, fe, ge, Ie, x[7], 1352829926, 9), fe = y(fe, 10), Ie = D(Ie, Ee, Se, fe, ge, x[0], 1352829926, 11), Se = y(Se, 10), ge = D(ge, Ie, Ee, Se, fe, x[9], 1352829926, 13), Ee = y(Ee, 10), fe = D(fe, ge, Ie, Ee, Se, x[2], 1352829926, 15), Ie = y(Ie, 10), Se = D(Se, fe, ge, Ie, Ee, x[11], 1352829926, 15), ge = y(ge, 10), Ee = D(Ee, Se, fe, ge, Ie, x[4], 1352829926, 5), fe = y(fe, 10), Ie = D(Ie, Ee, Se, fe, ge, x[13], 1352829926, 7), Se = y(Se, 10), ge = D(ge, Ie, Ee, Se, fe, x[6], 1352829926, 7), Ee = y(Ee, 10), fe = D(fe, ge, Ie, Ee, Se, x[15], 1352829926, 8), Ie = y(Ie, 10), Se = D(Se, fe, ge, Ie, Ee, x[8], 1352829926, 11), ge = y(ge, 10), Ee = D(Ee, Se, fe, ge, Ie, x[1], 1352829926, 14), fe = y(fe, 10), Ie = D(Ie, Ee, Se, fe, ge, x[10], 1352829926, 14), Se = y(Se, 10), ge = D(ge, Ie, Ee, Se, fe, x[3], 1352829926, 12), Ee = y(Ee, 10), fe = D(fe, ge, Ie, Ee, Se, x[12], 1352829926, 6), Ie = y(Ie, 10), Se = B(Se, fe, ge, Ie, Ee, x[6], 1548603684, 9), ge = y(ge, 10), Ee = B(Ee, Se, fe, ge, Ie, x[11], 1548603684, 13), fe = y(fe, 10), Ie = B(Ie, Ee, Se, fe, ge, x[3], 1548603684, 15), Se = y(Se, 10), ge = B(ge, Ie, Ee, Se, fe, x[7], 1548603684, 7), Ee = y(Ee, 10), fe = B(fe, ge, Ie, Ee, Se, x[0], 1548603684, 12), Ie = y(Ie, 10), Se = B(Se, fe, ge, Ie, Ee, x[13], 1548603684, 8), ge = y(ge, 10), Ee = B(Ee, Se, fe, ge, Ie, x[5], 1548603684, 9), fe = y(fe, 10), Ie = B(Ie, Ee, Se, fe, ge, x[10], 1548603684, 11), Se = y(Se, 10), ge = B(ge, Ie, Ee, Se, fe, x[14], 1548603684, 7), Ee = y(Ee, 10), fe = B(fe, ge, Ie, Ee, Se, x[15], 1548603684, 7), Ie = y(Ie, 10), Se = B(Se, fe, ge, Ie, Ee, x[8], 1548603684, 12), ge = y(ge, 10), Ee = B(Ee, Se, fe, ge, Ie, x[12], 1548603684, 7), fe = y(fe, 10), Ie = B(Ie, Ee, Se, fe, ge, x[4], 1548603684, 6), Se = y(Se, 10), ge = B(ge, Ie, Ee, Se, fe, x[9], 1548603684, 15), Ee = y(Ee, 10), fe = B(fe, ge, Ie, Ee, Se, x[1], 1548603684, 13), Ie = y(Ie, 10), Se = B(Se, fe, ge, Ie, Ee, x[2], 1548603684, 11), ge = y(ge, 10), Ee = E(Ee, Se, fe, ge, Ie, x[15], 1836072691, 9), fe = y(fe, 10), Ie = E(Ie, Ee, Se, fe, ge, x[5], 1836072691, 7), Se = y(Se, 10), ge = E(ge, Ie, Ee, Se, fe, x[1], 1836072691, 15), Ee = y(Ee, 10), fe = E(fe, ge, Ie, Ee, Se, x[3], 1836072691, 11), Ie = y(Ie, 10), Se = E(Se, fe, ge, Ie, Ee, x[7], 1836072691, 8), ge = y(ge, 10), Ee = E(Ee, Se, fe, ge, Ie, x[14], 1836072691, 6), fe = y(fe, 10), Ie = E(Ie, Ee, Se, fe, ge, x[6], 1836072691, 6), Se = y(Se, 10), ge = E(ge, Ie, Ee, Se, fe, x[9], 1836072691, 14), Ee = y(Ee, 10), fe = E(fe, ge, Ie, Ee, Se, x[11], 1836072691, 12), Ie = y(Ie, 10), Se = E(Se, fe, ge, Ie, Ee, x[8], 1836072691, 13), ge = y(ge, 10), Ee = E(Ee, Se, fe, ge, Ie, x[12], 1836072691, 5), fe = y(fe, 10), Ie = E(Ie, Ee, Se, fe, ge, x[2], 1836072691, 14), Se = y(Se, 10), ge = E(ge, Ie, Ee, Se, fe, x[10], 1836072691, 13), Ee = y(Ee, 10), fe = E(fe, ge, Ie, Ee, Se, x[0], 1836072691, 13), Ie = y(Ie, 10), Se = E(Se, fe, ge, Ie, Ee, x[4], 1836072691, 7), ge = y(ge, 10), Ee = E(Ee, Se, fe, ge, Ie, x[13], 1836072691, 5), fe = y(fe, 10), Ie = d(Ie, Ee, Se, fe, ge, x[8], 2053994217, 15), Se = y(Se, 10), ge = d(ge, Ie, Ee, Se, fe, x[6], 2053994217, 5), Ee = y(Ee, 10), fe = d(fe, ge, Ie, Ee, Se, x[4], 2053994217, 8), Ie = y(Ie, 10), Se = d(Se, fe, ge, Ie, Ee, x[1], 2053994217, 11), ge = y(ge, 10), Ee = d(Ee, Se, fe, ge, Ie, x[3], 2053994217, 14), fe = y(fe, 10), Ie = d(Ie, Ee, Se, fe, ge, x[11], 2053994217, 14), Se = y(Se, 10), ge = d(ge, Ie, Ee, Se, fe, x[15], 2053994217, 6), Ee = y(Ee, 10), fe = d(fe, ge, Ie, Ee, Se, x[0], 2053994217, 14), Ie = y(Ie, 10), Se = d(Se, fe, ge, Ie, Ee, x[5], 2053994217, 6), ge = y(ge, 10), Ee = d(Ee, Se, fe, ge, Ie, x[12], 2053994217, 9), fe = y(fe, 10), Ie = d(Ie, Ee, Se, fe, ge, x[2], 2053994217, 12), Se = y(Se, 10), ge = d(ge, Ie, Ee, Se, fe, x[13], 2053994217, 9), Ee = y(Ee, 10), fe = d(fe, ge, Ie, Ee, Se, x[9], 2053994217, 12), Ie = y(Ie, 10), Se = d(Se, fe, ge, Ie, Ee, x[7], 2053994217, 5), ge = y(ge, 10), Ee = d(Ee, Se, fe, ge, Ie, x[10], 2053994217, 15), fe = y(fe, 10), Ie = d(Ie, Ee, Se, fe, ge, x[14], 2053994217, 8), Se = y(Se, 10), ge = t(ge, Ie, Ee, Se, fe, x[12], 0, 8), Ee = y(Ee, 10), fe = t(fe, ge, Ie, Ee, Se, x[15], 0, 5), Ie = y(Ie, 10), Se = t(Se, fe, ge, Ie, Ee, x[10], 0, 12), ge = y(ge, 10), Ee = t(Ee, Se, fe, ge, Ie, x[4], 0, 9), fe = y(fe, 10), Ie = t(Ie, Ee, Se, fe, ge, x[1], 0, 12), Se = y(Se, 10), ge = t(ge, Ie, Ee, Se, fe, x[5], 0, 5), Ee = y(Ee, 10), fe = t(fe, ge, Ie, Ee, Se, x[8], 0, 14), Ie = y(Ie, 10), Se = t(Se, fe, ge, Ie, Ee, x[7], 0, 6), ge = y(ge, 10), Ee = t(Ee, Se, fe, ge, Ie, x[6], 0, 8), fe = y(fe, 10), Ie = t(Ie, Ee, Se, fe, ge, x[2], 0, 13), Se = y(Se, 10), ge = t(ge, Ie, Ee, Se, fe, x[13], 0, 6), Ee = y(Ee, 10), fe = t(fe, ge, Ie, Ee, Se, x[14], 0, 5), Ie = y(Ie, 10), Se = t(Se, fe, ge, Ie, Ee, x[0], 0, 15), ge = y(ge, 10), Ee = t(Ee, Se, fe, ge, Ie, x[3], 0, 13), fe = y(fe, 10), Ie = t(Ie, Ee, Se, fe, ge, x[9], 0, 11), Se = y(Se, 10), ge = t(ge, Ie, Ee, Se, fe, x[11], 0, 11), Ee = y(Ee, 10);
    var ze = this._b + U + Ee | 0;
    this._b = this._c + L + Se | 0, this._c = this._d + H + fe | 0, this._d = this._e + F + ge | 0, this._e = this._a + M + Ie | 0, this._a = ze;
  }, c.prototype._digest = function() {
    this._block[this._blockOffset++] = 128, this._blockOffset > 56 && (this._block.fill(0, this._blockOffset, 64), this._update(), this._blockOffset = 0), this._block.fill(0, this._blockOffset, 56), this._block.writeUInt32LE(this._length[0], 56), this._block.writeUInt32LE(this._length[1], 60), this._update();
    var x = new Buffer(20);
    return x.writeInt32LE(this._a, 0), x.writeInt32LE(this._b, 4), x.writeInt32LE(this._c, 8), x.writeInt32LE(this._d, 12), x.writeInt32LE(this._e, 16), x;
  };
  function y(x, v) {
    return x << v | x >>> 32 - v;
  }
  function t(x, v, F, M, U, L, H, fe) {
    return y(x + (v ^ F ^ M) + L + H | 0, fe) + U | 0;
  }
  function d(x, v, F, M, U, L, H, fe) {
    return y(x + (v & F | ~v & M) + L + H | 0, fe) + U | 0;
  }
  function E(x, v, F, M, U, L, H, fe) {
    return y(x + ((v | ~F) ^ M) + L + H | 0, fe) + U | 0;
  }
  function B(x, v, F, M, U, L, H, fe) {
    return y(x + (v & M | F & ~M) + L + H | 0, fe) + U | 0;
  }
  function D(x, v, F, M, U, L, H, fe) {
    return y(x + (v ^ (F | ~M)) + L + H | 0, fe) + U | 0;
  }
  return ripemd160$4 = c, ripemd160$4;
}
var toBuffer_1, hasRequiredToBuffer;
function requireToBuffer() {
  if (hasRequiredToBuffer) return toBuffer_1;
  hasRequiredToBuffer = 1;
  var o = requireSafeBuffer$1().Buffer, g = /* @__PURE__ */ requireToBuffer$1(), c = typeof Uint8Array < "u", y = c && typeof ArrayBuffer < "u", t = y && ArrayBuffer.isView;
  return toBuffer_1 = function(d, E, B) {
    if (typeof d == "string" || o.isBuffer(d) || c && d instanceof Uint8Array || t && t(d))
      return g(d, E);
    throw new TypeError(B + " must be a string, a Buffer, a Uint8Array, or a DataView");
  }, toBuffer_1;
}
var syncBrowser, hasRequiredSyncBrowser;
function requireSyncBrowser() {
  if (hasRequiredSyncBrowser) return syncBrowser;
  hasRequiredSyncBrowser = 1;
  var o = requireMd5$1(), g = requireRipemd160$1(), c = requireSha_js(), y = requireSafeBuffer$1().Buffer, t = requirePrecondition(), d = requireDefaultEncoding(), E = requireToBuffer(), B = y.alloc(128), D = {
    __proto__: null,
    md5: 16,
    sha1: 20,
    sha224: 28,
    sha256: 32,
    sha384: 48,
    sha512: 64,
    "sha512-256": 32,
    ripemd160: 20,
    rmd160: 20
  }, x = {
    __proto__: null,
    "sha-1": "sha1",
    "sha-224": "sha224",
    "sha-256": "sha256",
    "sha-384": "sha384",
    "sha-512": "sha512",
    "ripemd-160": "ripemd160"
  };
  function v(L) {
    return new g().update(L).digest();
  }
  function F(L) {
    function H(fe) {
      return c(L).update(fe).digest();
    }
    return L === "rmd160" || L === "ripemd160" ? v : L === "md5" ? o : H;
  }
  function M(L, H, fe) {
    var ge = F(L), Ie = L === "sha512" || L === "sha384" ? 128 : 64;
    H.length > Ie ? H = ge(H) : H.length < Ie && (H = y.concat([H, B], Ie));
    for (var Ee = y.allocUnsafe(Ie + D[L]), Se = y.allocUnsafe(Ie + D[L]), ze = 0; ze < Ie; ze++)
      Ee[ze] = H[ze] ^ 54, Se[ze] = H[ze] ^ 92;
    var He = y.allocUnsafe(Ie + fe + 4);
    Ee.copy(He, 0, 0, Ie), this.ipad1 = He, this.ipad2 = Ee, this.opad = Se, this.alg = L, this.blocksize = Ie, this.hash = ge, this.size = D[L];
  }
  M.prototype.run = function(L, H) {
    L.copy(H, this.blocksize);
    var fe = this.hash(H);
    return fe.copy(this.opad, this.blocksize), this.hash(this.opad);
  };
  function U(L, H, fe, ge, Ie) {
    t(fe, ge), L = E(L, d, "Password"), H = E(H, d, "Salt");
    var Ee = (Ie || "sha1").toLowerCase(), Se = x[Ee] || Ee, ze = D[Se];
    if (typeof ze != "number" || !ze)
      throw new TypeError("Digest algorithm not supported: " + Ie);
    var He = new M(Se, L, H.length), Pe = y.allocUnsafe(ge), De = y.allocUnsafe(H.length + 4);
    H.copy(De, 0, 0, H.length);
    for (var ve = 0, Fe = ze, be = Math.ceil(ge / Fe), Be = 1; Be <= be; Be++) {
      De.writeUInt32BE(Be, H.length);
      for (var ke = He.run(De, He.ipad1), xe = ke, Ne = 1; Ne < fe; Ne++) {
        xe = He.run(xe, He.ipad2);
        for (var Et = 0; Et < Fe; Et++)
          ke[Et] ^= xe[Et];
      }
      ke.copy(Pe, ve), ve += Fe;
    }
    return Pe;
  }
  return syncBrowser = U, syncBrowser;
}
var async, hasRequiredAsync;
function requireAsync() {
  if (hasRequiredAsync) return async;
  hasRequiredAsync = 1;
  var o = requireSafeBuffer$1().Buffer, g = requirePrecondition(), c = requireDefaultEncoding(), y = requireSyncBrowser(), t = requireToBuffer(), d, E = commonjsGlobal.crypto && commonjsGlobal.crypto.subtle, B = {
    sha: "SHA-1",
    "sha-1": "SHA-1",
    sha1: "SHA-1",
    sha256: "SHA-256",
    "sha-256": "SHA-256",
    sha384: "SHA-384",
    "sha-384": "SHA-384",
    "sha-512": "SHA-512",
    sha512: "SHA-512"
  }, D = [], x;
  function v() {
    return x || (commonjsGlobal.process && commonjsGlobal.process.nextTick ? x = commonjsGlobal.process.nextTick : commonjsGlobal.queueMicrotask ? x = commonjsGlobal.queueMicrotask : commonjsGlobal.setImmediate ? x = commonjsGlobal.setImmediate : x = commonjsGlobal.setTimeout, x);
  }
  function F(L, H, fe, ge, Ie) {
    return E.importKey("raw", L, { name: "PBKDF2" }, !1, ["deriveBits"]).then(function(Ee) {
      return E.deriveBits({
        name: "PBKDF2",
        salt: H,
        iterations: fe,
        hash: {
          name: Ie
        }
      }, Ee, ge << 3);
    }).then(function(Ee) {
      return o.from(Ee);
    });
  }
  function M(L) {
    if (commonjsGlobal.process && !commonjsGlobal.process.browser || !E || !E.importKey || !E.deriveBits)
      return Promise.resolve(!1);
    if (D[L] !== void 0)
      return D[L];
    d = d || o.alloc(8);
    var H = F(d, d, 10, 128, L).then(
      function() {
        return !0;
      },
      function() {
        return !1;
      }
    );
    return D[L] = H, H;
  }
  function U(L, H) {
    L.then(function(fe) {
      v()(function() {
        H(null, fe);
      });
    }, function(fe) {
      v()(function() {
        H(fe);
      });
    });
  }
  return async = function(L, H, fe, ge, Ie, Ee) {
    typeof Ie == "function" && (Ee = Ie, Ie = void 0), Ie = Ie || "sha1";
    var Se = B[Ie.toLowerCase()];
    if (!Se || typeof commonjsGlobal.Promise != "function") {
      v()(function() {
        var ze;
        try {
          ze = y(L, H, fe, ge, Ie);
        } catch (He) {
          Ee(He);
          return;
        }
        Ee(null, ze);
      });
      return;
    }
    if (g(fe, ge), L = t(L, c, "Password"), H = t(H, c, "Salt"), typeof Ee != "function")
      throw new Error("No callback provided to pbkdf2");
    U(M(Se).then(function(ze) {
      return ze ? F(L, H, fe, ge, Se) : y(L, H, fe, ge, Ie);
    }), Ee);
  }, async;
}
var hasRequiredBrowser$7;
function requireBrowser$7() {
  return hasRequiredBrowser$7 || (hasRequiredBrowser$7 = 1, browser$7.pbkdf2 = requireAsync(), browser$7.pbkdf2Sync = requireSyncBrowser()), browser$7;
}
var browser$6 = {}, des$1 = {}, utils$d = {}, hasRequiredUtils$b;
function requireUtils$b() {
  if (hasRequiredUtils$b) return utils$d;
  hasRequiredUtils$b = 1, utils$d.readUInt32BE = function(t, d) {
    var E = t[0 + d] << 24 | t[1 + d] << 16 | t[2 + d] << 8 | t[3 + d];
    return E >>> 0;
  }, utils$d.writeUInt32BE = function(t, d, E) {
    t[0 + E] = d >>> 24, t[1 + E] = d >>> 16 & 255, t[2 + E] = d >>> 8 & 255, t[3 + E] = d & 255;
  }, utils$d.ip = function(t, d, E, B) {
    for (var D = 0, x = 0, v = 6; v >= 0; v -= 2) {
      for (var F = 0; F <= 24; F += 8)
        D <<= 1, D |= d >>> F + v & 1;
      for (var F = 0; F <= 24; F += 8)
        D <<= 1, D |= t >>> F + v & 1;
    }
    for (var v = 6; v >= 0; v -= 2) {
      for (var F = 1; F <= 25; F += 8)
        x <<= 1, x |= d >>> F + v & 1;
      for (var F = 1; F <= 25; F += 8)
        x <<= 1, x |= t >>> F + v & 1;
    }
    E[B + 0] = D >>> 0, E[B + 1] = x >>> 0;
  }, utils$d.rip = function(t, d, E, B) {
    for (var D = 0, x = 0, v = 0; v < 4; v++)
      for (var F = 24; F >= 0; F -= 8)
        D <<= 1, D |= d >>> F + v & 1, D <<= 1, D |= t >>> F + v & 1;
    for (var v = 4; v < 8; v++)
      for (var F = 24; F >= 0; F -= 8)
        x <<= 1, x |= d >>> F + v & 1, x <<= 1, x |= t >>> F + v & 1;
    E[B + 0] = D >>> 0, E[B + 1] = x >>> 0;
  }, utils$d.pc1 = function(t, d, E, B) {
    for (var D = 0, x = 0, v = 7; v >= 5; v--) {
      for (var F = 0; F <= 24; F += 8)
        D <<= 1, D |= d >> F + v & 1;
      for (var F = 0; F <= 24; F += 8)
        D <<= 1, D |= t >> F + v & 1;
    }
    for (var F = 0; F <= 24; F += 8)
      D <<= 1, D |= d >> F + v & 1;
    for (var v = 1; v <= 3; v++) {
      for (var F = 0; F <= 24; F += 8)
        x <<= 1, x |= d >> F + v & 1;
      for (var F = 0; F <= 24; F += 8)
        x <<= 1, x |= t >> F + v & 1;
    }
    for (var F = 0; F <= 24; F += 8)
      x <<= 1, x |= t >> F + v & 1;
    E[B + 0] = D >>> 0, E[B + 1] = x >>> 0;
  }, utils$d.r28shl = function(t, d) {
    return t << d & 268435455 | t >>> 28 - d;
  };
  var o = [
    // inL => outL
    14,
    11,
    17,
    4,
    27,
    23,
    25,
    0,
    13,
    22,
    7,
    18,
    5,
    9,
    16,
    24,
    2,
    20,
    12,
    21,
    1,
    8,
    15,
    26,
    // inR => outR
    15,
    4,
    25,
    19,
    9,
    1,
    26,
    16,
    5,
    11,
    23,
    8,
    12,
    7,
    17,
    0,
    22,
    3,
    10,
    14,
    6,
    20,
    27,
    24
  ];
  utils$d.pc2 = function(t, d, E, B) {
    for (var D = 0, x = 0, v = o.length >>> 1, F = 0; F < v; F++)
      D <<= 1, D |= t >>> o[F] & 1;
    for (var F = v; F < o.length; F++)
      x <<= 1, x |= d >>> o[F] & 1;
    E[B + 0] = D >>> 0, E[B + 1] = x >>> 0;
  }, utils$d.expand = function(t, d, E) {
    var B = 0, D = 0;
    B = (t & 1) << 5 | t >>> 27;
    for (var x = 23; x >= 15; x -= 4)
      B <<= 6, B |= t >>> x & 63;
    for (var x = 11; x >= 3; x -= 4)
      D |= t >>> x & 63, D <<= 6;
    D |= (t & 31) << 1 | t >>> 31, d[E + 0] = B >>> 0, d[E + 1] = D >>> 0;
  };
  var g = [
    14,
    0,
    4,
    15,
    13,
    7,
    1,
    4,
    2,
    14,
    15,
    2,
    11,
    13,
    8,
    1,
    3,
    10,
    10,
    6,
    6,
    12,
    12,
    11,
    5,
    9,
    9,
    5,
    0,
    3,
    7,
    8,
    4,
    15,
    1,
    12,
    14,
    8,
    8,
    2,
    13,
    4,
    6,
    9,
    2,
    1,
    11,
    7,
    15,
    5,
    12,
    11,
    9,
    3,
    7,
    14,
    3,
    10,
    10,
    0,
    5,
    6,
    0,
    13,
    15,
    3,
    1,
    13,
    8,
    4,
    14,
    7,
    6,
    15,
    11,
    2,
    3,
    8,
    4,
    14,
    9,
    12,
    7,
    0,
    2,
    1,
    13,
    10,
    12,
    6,
    0,
    9,
    5,
    11,
    10,
    5,
    0,
    13,
    14,
    8,
    7,
    10,
    11,
    1,
    10,
    3,
    4,
    15,
    13,
    4,
    1,
    2,
    5,
    11,
    8,
    6,
    12,
    7,
    6,
    12,
    9,
    0,
    3,
    5,
    2,
    14,
    15,
    9,
    10,
    13,
    0,
    7,
    9,
    0,
    14,
    9,
    6,
    3,
    3,
    4,
    15,
    6,
    5,
    10,
    1,
    2,
    13,
    8,
    12,
    5,
    7,
    14,
    11,
    12,
    4,
    11,
    2,
    15,
    8,
    1,
    13,
    1,
    6,
    10,
    4,
    13,
    9,
    0,
    8,
    6,
    15,
    9,
    3,
    8,
    0,
    7,
    11,
    4,
    1,
    15,
    2,
    14,
    12,
    3,
    5,
    11,
    10,
    5,
    14,
    2,
    7,
    12,
    7,
    13,
    13,
    8,
    14,
    11,
    3,
    5,
    0,
    6,
    6,
    15,
    9,
    0,
    10,
    3,
    1,
    4,
    2,
    7,
    8,
    2,
    5,
    12,
    11,
    1,
    12,
    10,
    4,
    14,
    15,
    9,
    10,
    3,
    6,
    15,
    9,
    0,
    0,
    6,
    12,
    10,
    11,
    1,
    7,
    13,
    13,
    8,
    15,
    9,
    1,
    4,
    3,
    5,
    14,
    11,
    5,
    12,
    2,
    7,
    8,
    2,
    4,
    14,
    2,
    14,
    12,
    11,
    4,
    2,
    1,
    12,
    7,
    4,
    10,
    7,
    11,
    13,
    6,
    1,
    8,
    5,
    5,
    0,
    3,
    15,
    15,
    10,
    13,
    3,
    0,
    9,
    14,
    8,
    9,
    6,
    4,
    11,
    2,
    8,
    1,
    12,
    11,
    7,
    10,
    1,
    13,
    14,
    7,
    2,
    8,
    13,
    15,
    6,
    9,
    15,
    12,
    0,
    5,
    9,
    6,
    10,
    3,
    4,
    0,
    5,
    14,
    3,
    12,
    10,
    1,
    15,
    10,
    4,
    15,
    2,
    9,
    7,
    2,
    12,
    6,
    9,
    8,
    5,
    0,
    6,
    13,
    1,
    3,
    13,
    4,
    14,
    14,
    0,
    7,
    11,
    5,
    3,
    11,
    8,
    9,
    4,
    14,
    3,
    15,
    2,
    5,
    12,
    2,
    9,
    8,
    5,
    12,
    15,
    3,
    10,
    7,
    11,
    0,
    14,
    4,
    1,
    10,
    7,
    1,
    6,
    13,
    0,
    11,
    8,
    6,
    13,
    4,
    13,
    11,
    0,
    2,
    11,
    14,
    7,
    15,
    4,
    0,
    9,
    8,
    1,
    13,
    10,
    3,
    14,
    12,
    3,
    9,
    5,
    7,
    12,
    5,
    2,
    10,
    15,
    6,
    8,
    1,
    6,
    1,
    6,
    4,
    11,
    11,
    13,
    13,
    8,
    12,
    1,
    3,
    4,
    7,
    10,
    14,
    7,
    10,
    9,
    15,
    5,
    6,
    0,
    8,
    15,
    0,
    14,
    5,
    2,
    9,
    3,
    2,
    12,
    13,
    1,
    2,
    15,
    8,
    13,
    4,
    8,
    6,
    10,
    15,
    3,
    11,
    7,
    1,
    4,
    10,
    12,
    9,
    5,
    3,
    6,
    14,
    11,
    5,
    0,
    0,
    14,
    12,
    9,
    7,
    2,
    7,
    2,
    11,
    1,
    4,
    14,
    1,
    7,
    9,
    4,
    12,
    10,
    14,
    8,
    2,
    13,
    0,
    15,
    6,
    12,
    10,
    9,
    13,
    0,
    15,
    3,
    3,
    5,
    5,
    6,
    8,
    11
  ];
  utils$d.substitute = function(t, d) {
    for (var E = 0, B = 0; B < 4; B++) {
      var D = t >>> 18 - B * 6 & 63, x = g[B * 64 + D];
      E <<= 4, E |= x;
    }
    for (var B = 0; B < 4; B++) {
      var D = d >>> 18 - B * 6 & 63, x = g[256 + B * 64 + D];
      E <<= 4, E |= x;
    }
    return E >>> 0;
  };
  var c = [
    16,
    25,
    12,
    11,
    3,
    20,
    4,
    15,
    31,
    17,
    9,
    6,
    27,
    14,
    1,
    22,
    30,
    24,
    8,
    18,
    0,
    5,
    29,
    23,
    13,
    19,
    2,
    26,
    10,
    21,
    28,
    7
  ];
  return utils$d.permute = function(t) {
    for (var d = 0, E = 0; E < c.length; E++)
      d <<= 1, d |= t >>> c[E] & 1;
    return d >>> 0;
  }, utils$d.padSplit = function(t, d, E) {
    for (var B = t.toString(2); B.length < d; )
      B = "0" + B;
    for (var D = [], x = 0; x < d; x += E)
      D.push(B.slice(x, x + E));
    return D.join(" ");
  }, utils$d;
}
var minimalisticAssert, hasRequiredMinimalisticAssert;
function requireMinimalisticAssert() {
  if (hasRequiredMinimalisticAssert) return minimalisticAssert;
  hasRequiredMinimalisticAssert = 1, minimalisticAssert = o;
  function o(g, c) {
    if (!g)
      throw new Error(c || "Assertion failed");
  }
  return o.equal = function(c, y, t) {
    if (c != y)
      throw new Error(t || "Assertion failed: " + c + " != " + y);
  }, minimalisticAssert;
}
var cipher, hasRequiredCipher;
function requireCipher() {
  if (hasRequiredCipher) return cipher;
  hasRequiredCipher = 1;
  var o = requireMinimalisticAssert();
  function g(c) {
    this.options = c, this.type = this.options.type, this.blockSize = 8, this._init(), this.buffer = new Array(this.blockSize), this.bufferOff = 0, this.padding = c.padding !== !1;
  }
  return cipher = g, g.prototype._init = function() {
  }, g.prototype.update = function(y) {
    return y.length === 0 ? [] : this.type === "decrypt" ? this._updateDecrypt(y) : this._updateEncrypt(y);
  }, g.prototype._buffer = function(y, t) {
    for (var d = Math.min(this.buffer.length - this.bufferOff, y.length - t), E = 0; E < d; E++)
      this.buffer[this.bufferOff + E] = y[t + E];
    return this.bufferOff += d, d;
  }, g.prototype._flushBuffer = function(y, t) {
    return this._update(this.buffer, 0, y, t), this.bufferOff = 0, this.blockSize;
  }, g.prototype._updateEncrypt = function(y) {
    var t = 0, d = 0, E = (this.bufferOff + y.length) / this.blockSize | 0, B = new Array(E * this.blockSize);
    this.bufferOff !== 0 && (t += this._buffer(y, t), this.bufferOff === this.buffer.length && (d += this._flushBuffer(B, d)));
    for (var D = y.length - (y.length - t) % this.blockSize; t < D; t += this.blockSize)
      this._update(y, t, B, d), d += this.blockSize;
    for (; t < y.length; t++, this.bufferOff++)
      this.buffer[this.bufferOff] = y[t];
    return B;
  }, g.prototype._updateDecrypt = function(y) {
    for (var t = 0, d = 0, E = Math.ceil((this.bufferOff + y.length) / this.blockSize) - 1, B = new Array(E * this.blockSize); E > 0; E--)
      t += this._buffer(y, t), d += this._flushBuffer(B, d);
    return t += this._buffer(y, t), B;
  }, g.prototype.final = function(y) {
    var t;
    y && (t = this.update(y));
    var d;
    return this.type === "encrypt" ? d = this._finalEncrypt() : d = this._finalDecrypt(), t ? t.concat(d) : d;
  }, g.prototype._pad = function(y, t) {
    if (t === 0)
      return !1;
    for (; t < y.length; )
      y[t++] = 0;
    return !0;
  }, g.prototype._finalEncrypt = function() {
    if (!this._pad(this.buffer, this.bufferOff))
      return [];
    var y = new Array(this.blockSize);
    return this._update(this.buffer, 0, y, 0), y;
  }, g.prototype._unpad = function(y) {
    return y;
  }, g.prototype._finalDecrypt = function() {
    o.equal(this.bufferOff, this.blockSize, "Not enough data to decrypt");
    var y = new Array(this.blockSize);
    return this._flushBuffer(y, 0), this._unpad(y);
  }, cipher;
}
var des, hasRequiredDes$1;
function requireDes$1() {
  if (hasRequiredDes$1) return des;
  hasRequiredDes$1 = 1;
  var o = requireMinimalisticAssert(), g = requireInherits_browser(), c = requireUtils$b(), y = requireCipher();
  function t() {
    this.tmp = new Array(2), this.keys = null;
  }
  function d(B) {
    y.call(this, B);
    var D = new t();
    this._desState = D, this.deriveKeys(D, B.key);
  }
  g(d, y), des = d, d.create = function(D) {
    return new d(D);
  };
  var E = [
    1,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1
  ];
  return d.prototype.deriveKeys = function(D, x) {
    D.keys = new Array(32), o.equal(x.length, this.blockSize, "Invalid key length");
    var v = c.readUInt32BE(x, 0), F = c.readUInt32BE(x, 4);
    c.pc1(v, F, D.tmp, 0), v = D.tmp[0], F = D.tmp[1];
    for (var M = 0; M < D.keys.length; M += 2) {
      var U = E[M >>> 1];
      v = c.r28shl(v, U), F = c.r28shl(F, U), c.pc2(v, F, D.keys, M);
    }
  }, d.prototype._update = function(D, x, v, F) {
    var M = this._desState, U = c.readUInt32BE(D, x), L = c.readUInt32BE(D, x + 4);
    c.ip(U, L, M.tmp, 0), U = M.tmp[0], L = M.tmp[1], this.type === "encrypt" ? this._encrypt(M, U, L, M.tmp, 0) : this._decrypt(M, U, L, M.tmp, 0), U = M.tmp[0], L = M.tmp[1], c.writeUInt32BE(v, U, F), c.writeUInt32BE(v, L, F + 4);
  }, d.prototype._pad = function(D, x) {
    if (this.padding === !1)
      return !1;
    for (var v = D.length - x, F = x; F < D.length; F++)
      D[F] = v;
    return !0;
  }, d.prototype._unpad = function(D) {
    if (this.padding === !1)
      return D;
    for (var x = D[D.length - 1], v = D.length - x; v < D.length; v++)
      o.equal(D[v], x);
    return D.slice(0, D.length - x);
  }, d.prototype._encrypt = function(D, x, v, F, M) {
    for (var U = x, L = v, H = 0; H < D.keys.length; H += 2) {
      var fe = D.keys[H], ge = D.keys[H + 1];
      c.expand(L, D.tmp, 0), fe ^= D.tmp[0], ge ^= D.tmp[1];
      var Ie = c.substitute(fe, ge), Ee = c.permute(Ie), Se = L;
      L = (U ^ Ee) >>> 0, U = Se;
    }
    c.rip(L, U, F, M);
  }, d.prototype._decrypt = function(D, x, v, F, M) {
    for (var U = v, L = x, H = D.keys.length - 2; H >= 0; H -= 2) {
      var fe = D.keys[H], ge = D.keys[H + 1];
      c.expand(U, D.tmp, 0), fe ^= D.tmp[0], ge ^= D.tmp[1];
      var Ie = c.substitute(fe, ge), Ee = c.permute(Ie), Se = U;
      U = (L ^ Ee) >>> 0, L = Se;
    }
    c.rip(U, L, F, M);
  }, des;
}
var cbc$1 = {}, hasRequiredCbc$1;
function requireCbc$1() {
  if (hasRequiredCbc$1) return cbc$1;
  hasRequiredCbc$1 = 1;
  var o = requireMinimalisticAssert(), g = requireInherits_browser(), c = {};
  function y(d) {
    o.equal(d.length, 8, "Invalid IV length"), this.iv = new Array(8);
    for (var E = 0; E < this.iv.length; E++)
      this.iv[E] = d[E];
  }
  function t(d) {
    function E(v) {
      d.call(this, v), this._cbcInit();
    }
    g(E, d);
    for (var B = Object.keys(c), D = 0; D < B.length; D++) {
      var x = B[D];
      E.prototype[x] = c[x];
    }
    return E.create = function(F) {
      return new E(F);
    }, E;
  }
  return cbc$1.instantiate = t, c._cbcInit = function() {
    var E = new y(this.options.iv);
    this._cbcState = E;
  }, c._update = function(E, B, D, x) {
    var v = this._cbcState, F = this.constructor.super_.prototype, M = v.iv;
    if (this.type === "encrypt") {
      for (var U = 0; U < this.blockSize; U++)
        M[U] ^= E[B + U];
      F._update.call(this, M, 0, D, x);
      for (var U = 0; U < this.blockSize; U++)
        M[U] = D[x + U];
    } else {
      F._update.call(this, E, B, D, x);
      for (var U = 0; U < this.blockSize; U++)
        D[x + U] ^= M[U];
      for (var U = 0; U < this.blockSize; U++)
        M[U] = E[B + U];
    }
  }, cbc$1;
}
var ede, hasRequiredEde;
function requireEde() {
  if (hasRequiredEde) return ede;
  hasRequiredEde = 1;
  var o = requireMinimalisticAssert(), g = requireInherits_browser(), c = requireCipher(), y = requireDes$1();
  function t(E, B) {
    o.equal(B.length, 24, "Invalid key length");
    var D = B.slice(0, 8), x = B.slice(8, 16), v = B.slice(16, 24);
    E === "encrypt" ? this.ciphers = [
      y.create({ type: "encrypt", key: D }),
      y.create({ type: "decrypt", key: x }),
      y.create({ type: "encrypt", key: v })
    ] : this.ciphers = [
      y.create({ type: "decrypt", key: v }),
      y.create({ type: "encrypt", key: x }),
      y.create({ type: "decrypt", key: D })
    ];
  }
  function d(E) {
    c.call(this, E);
    var B = new t(this.type, this.options.key);
    this._edeState = B;
  }
  return g(d, c), ede = d, d.create = function(B) {
    return new d(B);
  }, d.prototype._update = function(B, D, x, v) {
    var F = this._edeState;
    F.ciphers[0]._update(B, D, x, v), F.ciphers[1]._update(x, v, x, v), F.ciphers[2]._update(x, v, x, v);
  }, d.prototype._pad = y.prototype._pad, d.prototype._unpad = y.prototype._unpad, ede;
}
var hasRequiredDes;
function requireDes() {
  return hasRequiredDes || (hasRequiredDes = 1, des$1.utils = requireUtils$b(), des$1.Cipher = requireCipher(), des$1.DES = requireDes$1(), des$1.CBC = requireCbc$1(), des$1.EDE = requireEde()), des$1;
}
var browserifyDes, hasRequiredBrowserifyDes;
function requireBrowserifyDes() {
  if (hasRequiredBrowserifyDes) return browserifyDes;
  hasRequiredBrowserifyDes = 1;
  var o = requireCipherBase(), g = requireDes(), c = requireInherits_browser(), y = requireSafeBuffer$1().Buffer, t = {
    "des-ede3-cbc": g.CBC.instantiate(g.EDE),
    "des-ede3": g.EDE,
    "des-ede-cbc": g.CBC.instantiate(g.EDE),
    "des-ede": g.EDE,
    "des-cbc": g.CBC.instantiate(g.DES),
    "des-ecb": g.DES
  };
  t.des = t["des-cbc"], t.des3 = t["des-ede3-cbc"], browserifyDes = d, c(d, o);
  function d(E) {
    o.call(this);
    var B = E.mode.toLowerCase(), D = t[B], x;
    E.decrypt ? x = "decrypt" : x = "encrypt";
    var v = E.key;
    y.isBuffer(v) || (v = y.from(v)), (B === "des-ede" || B === "des-ede-cbc") && (v = y.concat([v, v.slice(0, 8)]));
    var F = E.iv;
    y.isBuffer(F) || (F = y.from(F)), this._des = D.create({
      key: v,
      iv: F,
      type: x
    });
  }
  return d.prototype._update = function(E) {
    return y.from(this._des.update(E));
  }, d.prototype._final = function() {
    return y.from(this._des.final());
  }, browserifyDes;
}
var browser$5 = {}, encrypter = {}, ecb = {}, hasRequiredEcb;
function requireEcb() {
  return hasRequiredEcb || (hasRequiredEcb = 1, ecb.encrypt = function(o, g) {
    return o._cipher.encryptBlock(g);
  }, ecb.decrypt = function(o, g) {
    return o._cipher.decryptBlock(g);
  }), ecb;
}
var cbc = {}, bufferXor, hasRequiredBufferXor;
function requireBufferXor() {
  return hasRequiredBufferXor || (hasRequiredBufferXor = 1, bufferXor = function(g, c) {
    for (var y = Math.min(g.length, c.length), t = new Buffer(y), d = 0; d < y; ++d)
      t[d] = g[d] ^ c[d];
    return t;
  }), bufferXor;
}
var hasRequiredCbc;
function requireCbc() {
  if (hasRequiredCbc) return cbc;
  hasRequiredCbc = 1;
  var o = requireBufferXor();
  return cbc.encrypt = function(g, c) {
    var y = o(c, g._prev);
    return g._prev = g._cipher.encryptBlock(y), g._prev;
  }, cbc.decrypt = function(g, c) {
    var y = g._prev;
    g._prev = c;
    var t = g._cipher.decryptBlock(c);
    return o(t, y);
  }, cbc;
}
var cfb = {}, hasRequiredCfb;
function requireCfb() {
  if (hasRequiredCfb) return cfb;
  hasRequiredCfb = 1;
  var o = requireSafeBuffer$1().Buffer, g = requireBufferXor();
  function c(y, t, d) {
    var E = t.length, B = g(t, y._cache);
    return y._cache = y._cache.slice(E), y._prev = o.concat([y._prev, d ? t : B]), B;
  }
  return cfb.encrypt = function(y, t, d) {
    for (var E = o.allocUnsafe(0), B; t.length; )
      if (y._cache.length === 0 && (y._cache = y._cipher.encryptBlock(y._prev), y._prev = o.allocUnsafe(0)), y._cache.length <= t.length)
        B = y._cache.length, E = o.concat([E, c(y, t.slice(0, B), d)]), t = t.slice(B);
      else {
        E = o.concat([E, c(y, t, d)]);
        break;
      }
    return E;
  }, cfb;
}
var cfb8 = {}, hasRequiredCfb8;
function requireCfb8() {
  if (hasRequiredCfb8) return cfb8;
  hasRequiredCfb8 = 1;
  var o = requireSafeBuffer$1().Buffer;
  function g(c, y, t) {
    var d = c._cipher.encryptBlock(c._prev), E = d[0] ^ y;
    return c._prev = o.concat([
      c._prev.slice(1),
      o.from([t ? y : E])
    ]), E;
  }
  return cfb8.encrypt = function(c, y, t) {
    for (var d = y.length, E = o.allocUnsafe(d), B = -1; ++B < d; )
      E[B] = g(c, y[B], t);
    return E;
  }, cfb8;
}
var cfb1 = {}, hasRequiredCfb1;
function requireCfb1() {
  if (hasRequiredCfb1) return cfb1;
  hasRequiredCfb1 = 1;
  var o = requireSafeBuffer$1().Buffer;
  function g(y, t, d) {
    for (var E, B = -1, D = 8, x = 0, v, F; ++B < D; )
      E = y._cipher.encryptBlock(y._prev), v = t & 1 << 7 - B ? 128 : 0, F = E[0] ^ v, x += (F & 128) >> B % 8, y._prev = c(y._prev, d ? v : F);
    return x;
  }
  function c(y, t) {
    var d = y.length, E = -1, B = o.allocUnsafe(y.length);
    for (y = o.concat([y, o.from([t])]); ++E < d; )
      B[E] = y[E] << 1 | y[E + 1] >> 7;
    return B;
  }
  return cfb1.encrypt = function(y, t, d) {
    for (var E = t.length, B = o.allocUnsafe(E), D = -1; ++D < E; )
      B[D] = g(y, t[D], d);
    return B;
  }, cfb1;
}
var ofb = {}, hasRequiredOfb;
function requireOfb() {
  if (hasRequiredOfb) return ofb;
  hasRequiredOfb = 1;
  var o = requireBufferXor();
  function g(c) {
    return c._prev = c._cipher.encryptBlock(c._prev), c._prev;
  }
  return ofb.encrypt = function(c, y) {
    for (; c._cache.length < y.length; )
      c._cache = Buffer.concat([c._cache, g(c)]);
    var t = c._cache.slice(0, y.length);
    return c._cache = c._cache.slice(y.length), o(y, t);
  }, ofb;
}
var ctr = {}, incr32_1, hasRequiredIncr32;
function requireIncr32() {
  if (hasRequiredIncr32) return incr32_1;
  hasRequiredIncr32 = 1;
  function o(g) {
    for (var c = g.length, y; c--; )
      if (y = g.readUInt8(c), y === 255)
        g.writeUInt8(0, c);
      else {
        y++, g.writeUInt8(y, c);
        break;
      }
  }
  return incr32_1 = o, incr32_1;
}
var hasRequiredCtr;
function requireCtr() {
  if (hasRequiredCtr) return ctr;
  hasRequiredCtr = 1;
  var o = requireBufferXor(), g = requireSafeBuffer$1().Buffer, c = requireIncr32();
  function y(d) {
    var E = d._cipher.encryptBlockRaw(d._prev);
    return c(d._prev), E;
  }
  var t = 16;
  return ctr.encrypt = function(d, E) {
    var B = Math.ceil(E.length / t), D = d._cache.length;
    d._cache = g.concat([
      d._cache,
      g.allocUnsafe(B * t)
    ]);
    for (var x = 0; x < B; x++) {
      var v = y(d), F = D + x * t;
      d._cache.writeUInt32BE(v[0], F + 0), d._cache.writeUInt32BE(v[1], F + 4), d._cache.writeUInt32BE(v[2], F + 8), d._cache.writeUInt32BE(v[3], F + 12);
    }
    var M = d._cache.slice(0, E.length);
    return d._cache = d._cache.slice(E.length), o(E, M);
  }, ctr;
}
const aes128 = { cipher: "AES", key: 128, iv: 16, mode: "CBC", type: "block" }, aes192 = { cipher: "AES", key: 192, iv: 16, mode: "CBC", type: "block" }, aes256 = { cipher: "AES", key: 256, iv: 16, mode: "CBC", type: "block" }, require$$2 = {
  "aes-128-ecb": { cipher: "AES", key: 128, iv: 0, mode: "ECB", type: "block" },
  "aes-192-ecb": { cipher: "AES", key: 192, iv: 0, mode: "ECB", type: "block" },
  "aes-256-ecb": { cipher: "AES", key: 256, iv: 0, mode: "ECB", type: "block" },
  "aes-128-cbc": { cipher: "AES", key: 128, iv: 16, mode: "CBC", type: "block" },
  "aes-192-cbc": { cipher: "AES", key: 192, iv: 16, mode: "CBC", type: "block" },
  "aes-256-cbc": { cipher: "AES", key: 256, iv: 16, mode: "CBC", type: "block" },
  aes128,
  aes192,
  aes256,
  "aes-128-cfb": { cipher: "AES", key: 128, iv: 16, mode: "CFB", type: "stream" },
  "aes-192-cfb": { cipher: "AES", key: 192, iv: 16, mode: "CFB", type: "stream" },
  "aes-256-cfb": { cipher: "AES", key: 256, iv: 16, mode: "CFB", type: "stream" },
  "aes-128-cfb8": { cipher: "AES", key: 128, iv: 16, mode: "CFB8", type: "stream" },
  "aes-192-cfb8": { cipher: "AES", key: 192, iv: 16, mode: "CFB8", type: "stream" },
  "aes-256-cfb8": { cipher: "AES", key: 256, iv: 16, mode: "CFB8", type: "stream" },
  "aes-128-cfb1": { cipher: "AES", key: 128, iv: 16, mode: "CFB1", type: "stream" },
  "aes-192-cfb1": { cipher: "AES", key: 192, iv: 16, mode: "CFB1", type: "stream" },
  "aes-256-cfb1": { cipher: "AES", key: 256, iv: 16, mode: "CFB1", type: "stream" },
  "aes-128-ofb": { cipher: "AES", key: 128, iv: 16, mode: "OFB", type: "stream" },
  "aes-192-ofb": { cipher: "AES", key: 192, iv: 16, mode: "OFB", type: "stream" },
  "aes-256-ofb": { cipher: "AES", key: 256, iv: 16, mode: "OFB", type: "stream" },
  "aes-128-ctr": { cipher: "AES", key: 128, iv: 16, mode: "CTR", type: "stream" },
  "aes-192-ctr": { cipher: "AES", key: 192, iv: 16, mode: "CTR", type: "stream" },
  "aes-256-ctr": { cipher: "AES", key: 256, iv: 16, mode: "CTR", type: "stream" },
  "aes-128-gcm": { cipher: "AES", key: 128, iv: 12, mode: "GCM", type: "auth" },
  "aes-192-gcm": { cipher: "AES", key: 192, iv: 12, mode: "GCM", type: "auth" },
  "aes-256-gcm": { cipher: "AES", key: 256, iv: 12, mode: "GCM", type: "auth" }
};
var modes_1, hasRequiredModes$1;
function requireModes$1() {
  if (hasRequiredModes$1) return modes_1;
  hasRequiredModes$1 = 1;
  var o = {
    ECB: requireEcb(),
    CBC: requireCbc(),
    CFB: requireCfb(),
    CFB8: requireCfb8(),
    CFB1: requireCfb1(),
    OFB: requireOfb(),
    CTR: requireCtr(),
    GCM: requireCtr()
  }, g = require$$2;
  for (var c in g)
    g[c].module = o[g[c].mode];
  return modes_1 = g, modes_1;
}
var aes = {}, hasRequiredAes;
function requireAes() {
  if (hasRequiredAes) return aes;
  hasRequiredAes = 1;
  var o = requireSafeBuffer$1().Buffer;
  function g(B) {
    o.isBuffer(B) || (B = o.from(B));
    for (var D = B.length / 4 | 0, x = new Array(D), v = 0; v < D; v++)
      x[v] = B.readUInt32BE(v * 4);
    return x;
  }
  function c(B) {
    for (var D = 0; D < B.length; B++)
      B[D] = 0;
  }
  function y(B, D, x, v, F) {
    for (var M = x[0], U = x[1], L = x[2], H = x[3], fe = B[0] ^ D[0], ge = B[1] ^ D[1], Ie = B[2] ^ D[2], Ee = B[3] ^ D[3], Se, ze, He, Pe, De = 4, ve = 1; ve < F; ve++)
      Se = M[fe >>> 24] ^ U[ge >>> 16 & 255] ^ L[Ie >>> 8 & 255] ^ H[Ee & 255] ^ D[De++], ze = M[ge >>> 24] ^ U[Ie >>> 16 & 255] ^ L[Ee >>> 8 & 255] ^ H[fe & 255] ^ D[De++], He = M[Ie >>> 24] ^ U[Ee >>> 16 & 255] ^ L[fe >>> 8 & 255] ^ H[ge & 255] ^ D[De++], Pe = M[Ee >>> 24] ^ U[fe >>> 16 & 255] ^ L[ge >>> 8 & 255] ^ H[Ie & 255] ^ D[De++], fe = Se, ge = ze, Ie = He, Ee = Pe;
    return Se = (v[fe >>> 24] << 24 | v[ge >>> 16 & 255] << 16 | v[Ie >>> 8 & 255] << 8 | v[Ee & 255]) ^ D[De++], ze = (v[ge >>> 24] << 24 | v[Ie >>> 16 & 255] << 16 | v[Ee >>> 8 & 255] << 8 | v[fe & 255]) ^ D[De++], He = (v[Ie >>> 24] << 24 | v[Ee >>> 16 & 255] << 16 | v[fe >>> 8 & 255] << 8 | v[ge & 255]) ^ D[De++], Pe = (v[Ee >>> 24] << 24 | v[fe >>> 16 & 255] << 16 | v[ge >>> 8 & 255] << 8 | v[Ie & 255]) ^ D[De++], Se = Se >>> 0, ze = ze >>> 0, He = He >>> 0, Pe = Pe >>> 0, [Se, ze, He, Pe];
  }
  var t = [0, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54], d = function() {
    for (var B = new Array(256), D = 0; D < 256; D++)
      D < 128 ? B[D] = D << 1 : B[D] = D << 1 ^ 283;
    for (var x = [], v = [], F = [[], [], [], []], M = [[], [], [], []], U = 0, L = 0, H = 0; H < 256; ++H) {
      var fe = L ^ L << 1 ^ L << 2 ^ L << 3 ^ L << 4;
      fe = fe >>> 8 ^ fe & 255 ^ 99, x[U] = fe, v[fe] = U;
      var ge = B[U], Ie = B[ge], Ee = B[Ie], Se = B[fe] * 257 ^ fe * 16843008;
      F[0][U] = Se << 24 | Se >>> 8, F[1][U] = Se << 16 | Se >>> 16, F[2][U] = Se << 8 | Se >>> 24, F[3][U] = Se, Se = Ee * 16843009 ^ Ie * 65537 ^ ge * 257 ^ U * 16843008, M[0][fe] = Se << 24 | Se >>> 8, M[1][fe] = Se << 16 | Se >>> 16, M[2][fe] = Se << 8 | Se >>> 24, M[3][fe] = Se, U === 0 ? U = L = 1 : (U = ge ^ B[B[B[Ee ^ ge]]], L ^= B[B[L]]);
    }
    return {
      SBOX: x,
      INV_SBOX: v,
      SUB_MIX: F,
      INV_SUB_MIX: M
    };
  }();
  function E(B) {
    this._key = g(B), this._reset();
  }
  return E.blockSize = 16, E.keySize = 256 / 8, E.prototype.blockSize = E.blockSize, E.prototype.keySize = E.keySize, E.prototype._reset = function() {
    for (var B = this._key, D = B.length, x = D + 6, v = (x + 1) * 4, F = [], M = 0; M < D; M++)
      F[M] = B[M];
    for (M = D; M < v; M++) {
      var U = F[M - 1];
      M % D === 0 ? (U = U << 8 | U >>> 24, U = d.SBOX[U >>> 24] << 24 | d.SBOX[U >>> 16 & 255] << 16 | d.SBOX[U >>> 8 & 255] << 8 | d.SBOX[U & 255], U ^= t[M / D | 0] << 24) : D > 6 && M % D === 4 && (U = d.SBOX[U >>> 24] << 24 | d.SBOX[U >>> 16 & 255] << 16 | d.SBOX[U >>> 8 & 255] << 8 | d.SBOX[U & 255]), F[M] = F[M - D] ^ U;
    }
    for (var L = [], H = 0; H < v; H++) {
      var fe = v - H, ge = F[fe - (H % 4 ? 0 : 4)];
      H < 4 || fe <= 4 ? L[H] = ge : L[H] = d.INV_SUB_MIX[0][d.SBOX[ge >>> 24]] ^ d.INV_SUB_MIX[1][d.SBOX[ge >>> 16 & 255]] ^ d.INV_SUB_MIX[2][d.SBOX[ge >>> 8 & 255]] ^ d.INV_SUB_MIX[3][d.SBOX[ge & 255]];
    }
    this._nRounds = x, this._keySchedule = F, this._invKeySchedule = L;
  }, E.prototype.encryptBlockRaw = function(B) {
    return B = g(B), y(B, this._keySchedule, d.SUB_MIX, d.SBOX, this._nRounds);
  }, E.prototype.encryptBlock = function(B) {
    var D = this.encryptBlockRaw(B), x = o.allocUnsafe(16);
    return x.writeUInt32BE(D[0], 0), x.writeUInt32BE(D[1], 4), x.writeUInt32BE(D[2], 8), x.writeUInt32BE(D[3], 12), x;
  }, E.prototype.decryptBlock = function(B) {
    B = g(B);
    var D = B[1];
    B[1] = B[3], B[3] = D;
    var x = y(B, this._invKeySchedule, d.INV_SUB_MIX, d.INV_SBOX, this._nRounds), v = o.allocUnsafe(16);
    return v.writeUInt32BE(x[0], 0), v.writeUInt32BE(x[3], 4), v.writeUInt32BE(x[2], 8), v.writeUInt32BE(x[1], 12), v;
  }, E.prototype.scrub = function() {
    c(this._keySchedule), c(this._invKeySchedule), c(this._key);
  }, aes.AES = E, aes;
}
var ghash, hasRequiredGhash;
function requireGhash() {
  if (hasRequiredGhash) return ghash;
  hasRequiredGhash = 1;
  var o = requireSafeBuffer$1().Buffer, g = o.alloc(16, 0);
  function c(d) {
    return [
      d.readUInt32BE(0),
      d.readUInt32BE(4),
      d.readUInt32BE(8),
      d.readUInt32BE(12)
    ];
  }
  function y(d) {
    var E = o.allocUnsafe(16);
    return E.writeUInt32BE(d[0] >>> 0, 0), E.writeUInt32BE(d[1] >>> 0, 4), E.writeUInt32BE(d[2] >>> 0, 8), E.writeUInt32BE(d[3] >>> 0, 12), E;
  }
  function t(d) {
    this.h = d, this.state = o.alloc(16, 0), this.cache = o.allocUnsafe(0);
  }
  return t.prototype.ghash = function(d) {
    for (var E = -1; ++E < d.length; )
      this.state[E] ^= d[E];
    this._multiply();
  }, t.prototype._multiply = function() {
    for (var d = c(this.h), E = [0, 0, 0, 0], B, D, x, v = -1; ++v < 128; ) {
      for (D = (this.state[~~(v / 8)] & 1 << 7 - v % 8) !== 0, D && (E[0] ^= d[0], E[1] ^= d[1], E[2] ^= d[2], E[3] ^= d[3]), x = (d[3] & 1) !== 0, B = 3; B > 0; B--)
        d[B] = d[B] >>> 1 | (d[B - 1] & 1) << 31;
      d[0] = d[0] >>> 1, x && (d[0] = d[0] ^ 225 << 24);
    }
    this.state = y(E);
  }, t.prototype.update = function(d) {
    this.cache = o.concat([this.cache, d]);
    for (var E; this.cache.length >= 16; )
      E = this.cache.slice(0, 16), this.cache = this.cache.slice(16), this.ghash(E);
  }, t.prototype.final = function(d, E) {
    return this.cache.length && this.ghash(o.concat([this.cache, g], 16)), this.ghash(y([0, d, 0, E])), this.state;
  }, ghash = t, ghash;
}
var authCipher, hasRequiredAuthCipher;
function requireAuthCipher() {
  if (hasRequiredAuthCipher) return authCipher;
  hasRequiredAuthCipher = 1;
  var o = requireAes(), g = requireSafeBuffer$1().Buffer, c = requireCipherBase(), y = requireInherits_browser(), t = requireGhash(), d = requireBufferXor(), E = requireIncr32();
  function B(v, F) {
    var M = 0;
    v.length !== F.length && M++;
    for (var U = Math.min(v.length, F.length), L = 0; L < U; ++L)
      M += v[L] ^ F[L];
    return M;
  }
  function D(v, F, M) {
    if (F.length === 12)
      return v._finID = g.concat([F, g.from([0, 0, 0, 1])]), g.concat([F, g.from([0, 0, 0, 2])]);
    var U = new t(M), L = F.length, H = L % 16;
    U.update(F), H && (H = 16 - H, U.update(g.alloc(H, 0))), U.update(g.alloc(8, 0));
    var fe = L * 8, ge = g.alloc(8);
    ge.writeUIntBE(fe, 0, 8), U.update(ge), v._finID = U.state;
    var Ie = g.from(v._finID);
    return E(Ie), Ie;
  }
  function x(v, F, M, U) {
    c.call(this);
    var L = g.alloc(4, 0);
    this._cipher = new o.AES(F);
    var H = this._cipher.encryptBlock(L);
    this._ghash = new t(H), M = D(this, M, H), this._prev = g.from(M), this._cache = g.allocUnsafe(0), this._secCache = g.allocUnsafe(0), this._decrypt = U, this._alen = 0, this._len = 0, this._mode = v, this._authTag = null, this._called = !1;
  }
  return y(x, c), x.prototype._update = function(v) {
    if (!this._called && this._alen) {
      var F = 16 - this._alen % 16;
      F < 16 && (F = g.alloc(F, 0), this._ghash.update(F));
    }
    this._called = !0;
    var M = this._mode.encrypt(this, v);
    return this._decrypt ? this._ghash.update(v) : this._ghash.update(M), this._len += v.length, M;
  }, x.prototype._final = function() {
    if (this._decrypt && !this._authTag) throw new Error("Unsupported state or unable to authenticate data");
    var v = d(this._ghash.final(this._alen * 8, this._len * 8), this._cipher.encryptBlock(this._finID));
    if (this._decrypt && B(v, this._authTag)) throw new Error("Unsupported state or unable to authenticate data");
    this._authTag = v, this._cipher.scrub();
  }, x.prototype.getAuthTag = function() {
    if (this._decrypt || !g.isBuffer(this._authTag)) throw new Error("Attempting to get auth tag in unsupported state");
    return this._authTag;
  }, x.prototype.setAuthTag = function(F) {
    if (!this._decrypt) throw new Error("Attempting to set auth tag in unsupported state");
    this._authTag = F;
  }, x.prototype.setAAD = function(F) {
    if (this._called) throw new Error("Attempting to set AAD in unsupported state");
    this._ghash.update(F), this._alen += F.length;
  }, authCipher = x, authCipher;
}
var streamCipher, hasRequiredStreamCipher;
function requireStreamCipher() {
  if (hasRequiredStreamCipher) return streamCipher;
  hasRequiredStreamCipher = 1;
  var o = requireAes(), g = requireSafeBuffer$1().Buffer, c = requireCipherBase(), y = requireInherits_browser();
  function t(d, E, B, D) {
    c.call(this), this._cipher = new o.AES(E), this._prev = g.from(B), this._cache = g.allocUnsafe(0), this._secCache = g.allocUnsafe(0), this._decrypt = D, this._mode = d;
  }
  return y(t, c), t.prototype._update = function(d) {
    return this._mode.encrypt(this, d, this._decrypt);
  }, t.prototype._final = function() {
    this._cipher.scrub();
  }, streamCipher = t, streamCipher;
}
var evp_bytestokey, hasRequiredEvp_bytestokey;
function requireEvp_bytestokey() {
  if (hasRequiredEvp_bytestokey) return evp_bytestokey;
  hasRequiredEvp_bytestokey = 1;
  var o = requireSafeBuffer$1().Buffer, g = requireMd5_js();
  function c(y, t, d, E) {
    if (o.isBuffer(y) || (y = o.from(y, "binary")), t && (o.isBuffer(t) || (t = o.from(t, "binary")), t.length !== 8))
      throw new RangeError("salt should be Buffer with 8 byte length");
    for (var B = d / 8, D = o.alloc(B), x = o.alloc(E || 0), v = o.alloc(0); B > 0 || E > 0; ) {
      var F = new g();
      F.update(v), F.update(y), t && F.update(t), v = F.digest();
      var M = 0;
      if (B > 0) {
        var U = D.length - B;
        M = Math.min(B, v.length), v.copy(D, U, 0, M), B -= M;
      }
      if (M < v.length && E > 0) {
        var L = x.length - E, H = Math.min(E, v.length - M);
        v.copy(x, L, M, M + H), E -= H;
      }
    }
    return v.fill(0), { key: D, iv: x };
  }
  return evp_bytestokey = c, evp_bytestokey;
}
var hasRequiredEncrypter;
function requireEncrypter() {
  if (hasRequiredEncrypter) return encrypter;
  hasRequiredEncrypter = 1;
  var o = requireModes$1(), g = requireAuthCipher(), c = requireSafeBuffer$1().Buffer, y = requireStreamCipher(), t = requireCipherBase(), d = requireAes(), E = requireEvp_bytestokey(), B = requireInherits_browser();
  function D(U, L, H) {
    t.call(this), this._cache = new v(), this._cipher = new d.AES(L), this._prev = c.from(H), this._mode = U, this._autopadding = !0;
  }
  B(D, t), D.prototype._update = function(U) {
    this._cache.add(U);
    for (var L, H, fe = []; L = this._cache.get(); )
      H = this._mode.encrypt(this, L), fe.push(H);
    return c.concat(fe);
  };
  var x = c.alloc(16, 16);
  D.prototype._final = function() {
    var U = this._cache.flush();
    if (this._autopadding)
      return U = this._mode.encrypt(this, U), this._cipher.scrub(), U;
    if (!U.equals(x))
      throw this._cipher.scrub(), new Error("data not multiple of block length");
  }, D.prototype.setAutoPadding = function(U) {
    return this._autopadding = !!U, this;
  };
  function v() {
    this.cache = c.allocUnsafe(0);
  }
  v.prototype.add = function(U) {
    this.cache = c.concat([this.cache, U]);
  }, v.prototype.get = function() {
    if (this.cache.length > 15) {
      var U = this.cache.slice(0, 16);
      return this.cache = this.cache.slice(16), U;
    }
    return null;
  }, v.prototype.flush = function() {
    for (var U = 16 - this.cache.length, L = c.allocUnsafe(U), H = -1; ++H < U; )
      L.writeUInt8(U, H);
    return c.concat([this.cache, L]);
  };
  function F(U, L, H) {
    var fe = o[U.toLowerCase()];
    if (!fe) throw new TypeError("invalid suite type");
    if (typeof L == "string" && (L = c.from(L)), L.length !== fe.key / 8) throw new TypeError("invalid key length " + L.length);
    if (typeof H == "string" && (H = c.from(H)), fe.mode !== "GCM" && H.length !== fe.iv) throw new TypeError("invalid iv length " + H.length);
    return fe.type === "stream" ? new y(fe.module, L, H) : fe.type === "auth" ? new g(fe.module, L, H) : new D(fe.module, L, H);
  }
  function M(U, L) {
    var H = o[U.toLowerCase()];
    if (!H) throw new TypeError("invalid suite type");
    var fe = E(L, !1, H.key, H.iv);
    return F(U, fe.key, fe.iv);
  }
  return encrypter.createCipheriv = F, encrypter.createCipher = M, encrypter;
}
var decrypter = {}, hasRequiredDecrypter;
function requireDecrypter() {
  if (hasRequiredDecrypter) return decrypter;
  hasRequiredDecrypter = 1;
  var o = requireAuthCipher(), g = requireSafeBuffer$1().Buffer, c = requireModes$1(), y = requireStreamCipher(), t = requireCipherBase(), d = requireAes(), E = requireEvp_bytestokey(), B = requireInherits_browser();
  function D(U, L, H) {
    t.call(this), this._cache = new x(), this._last = void 0, this._cipher = new d.AES(L), this._prev = g.from(H), this._mode = U, this._autopadding = !0;
  }
  B(D, t), D.prototype._update = function(U) {
    this._cache.add(U);
    for (var L, H, fe = []; L = this._cache.get(this._autopadding); )
      H = this._mode.decrypt(this, L), fe.push(H);
    return g.concat(fe);
  }, D.prototype._final = function() {
    var U = this._cache.flush();
    if (this._autopadding)
      return v(this._mode.decrypt(this, U));
    if (U)
      throw new Error("data not multiple of block length");
  }, D.prototype.setAutoPadding = function(U) {
    return this._autopadding = !!U, this;
  };
  function x() {
    this.cache = g.allocUnsafe(0);
  }
  x.prototype.add = function(U) {
    this.cache = g.concat([this.cache, U]);
  }, x.prototype.get = function(U) {
    var L;
    if (U) {
      if (this.cache.length > 16)
        return L = this.cache.slice(0, 16), this.cache = this.cache.slice(16), L;
    } else if (this.cache.length >= 16)
      return L = this.cache.slice(0, 16), this.cache = this.cache.slice(16), L;
    return null;
  }, x.prototype.flush = function() {
    if (this.cache.length) return this.cache;
  };
  function v(U) {
    var L = U[15];
    if (L < 1 || L > 16)
      throw new Error("unable to decrypt data");
    for (var H = -1; ++H < L; )
      if (U[H + (16 - L)] !== L)
        throw new Error("unable to decrypt data");
    if (L !== 16)
      return U.slice(0, 16 - L);
  }
  function F(U, L, H) {
    var fe = c[U.toLowerCase()];
    if (!fe) throw new TypeError("invalid suite type");
    if (typeof H == "string" && (H = g.from(H)), fe.mode !== "GCM" && H.length !== fe.iv) throw new TypeError("invalid iv length " + H.length);
    if (typeof L == "string" && (L = g.from(L)), L.length !== fe.key / 8) throw new TypeError("invalid key length " + L.length);
    return fe.type === "stream" ? new y(fe.module, L, H, !0) : fe.type === "auth" ? new o(fe.module, L, H, !0) : new D(fe.module, L, H);
  }
  function M(U, L) {
    var H = c[U.toLowerCase()];
    if (!H) throw new TypeError("invalid suite type");
    var fe = E(L, !1, H.key, H.iv);
    return F(U, fe.key, fe.iv);
  }
  return decrypter.createDecipher = M, decrypter.createDecipheriv = F, decrypter;
}
var hasRequiredBrowser$6;
function requireBrowser$6() {
  if (hasRequiredBrowser$6) return browser$5;
  hasRequiredBrowser$6 = 1;
  var o = requireEncrypter(), g = requireDecrypter(), c = require$$2;
  function y() {
    return Object.keys(c);
  }
  return browser$5.createCipher = browser$5.Cipher = o.createCipher, browser$5.createCipheriv = browser$5.Cipheriv = o.createCipheriv, browser$5.createDecipher = browser$5.Decipher = g.createDecipher, browser$5.createDecipheriv = browser$5.Decipheriv = g.createDecipheriv, browser$5.listCiphers = browser$5.getCiphers = y, browser$5;
}
var modes = {}, hasRequiredModes;
function requireModes() {
  return hasRequiredModes || (hasRequiredModes = 1, function(o) {
    o["des-ecb"] = {
      key: 8,
      iv: 0
    }, o["des-cbc"] = o.des = {
      key: 8,
      iv: 8
    }, o["des-ede3-cbc"] = o.des3 = {
      key: 24,
      iv: 8
    }, o["des-ede3"] = {
      key: 24,
      iv: 0
    }, o["des-ede-cbc"] = {
      key: 16,
      iv: 8
    }, o["des-ede"] = {
      key: 16,
      iv: 0
    };
  }(modes)), modes;
}
var hasRequiredBrowser$5;
function requireBrowser$5() {
  if (hasRequiredBrowser$5) return browser$6;
  hasRequiredBrowser$5 = 1;
  var o = requireBrowserifyDes(), g = requireBrowser$6(), c = requireModes$1(), y = requireModes(), t = requireEvp_bytestokey();
  function d(v, F) {
    v = v.toLowerCase();
    var M, U;
    if (c[v])
      M = c[v].key, U = c[v].iv;
    else if (y[v])
      M = y[v].key * 8, U = y[v].iv;
    else
      throw new TypeError("invalid suite type");
    var L = t(F, !1, M, U);
    return B(v, L.key, L.iv);
  }
  function E(v, F) {
    v = v.toLowerCase();
    var M, U;
    if (c[v])
      M = c[v].key, U = c[v].iv;
    else if (y[v])
      M = y[v].key * 8, U = y[v].iv;
    else
      throw new TypeError("invalid suite type");
    var L = t(F, !1, M, U);
    return D(v, L.key, L.iv);
  }
  function B(v, F, M) {
    if (v = v.toLowerCase(), c[v]) return g.createCipheriv(v, F, M);
    if (y[v]) return new o({ key: F, iv: M, mode: v });
    throw new TypeError("invalid suite type");
  }
  function D(v, F, M) {
    if (v = v.toLowerCase(), c[v]) return g.createDecipheriv(v, F, M);
    if (y[v]) return new o({ key: F, iv: M, mode: v, decrypt: !0 });
    throw new TypeError("invalid suite type");
  }
  function x() {
    return Object.keys(y).concat(g.getCiphers());
  }
  return browser$6.createCipher = browser$6.Cipher = d, browser$6.createCipheriv = browser$6.Cipheriv = B, browser$6.createDecipher = browser$6.Decipher = E, browser$6.createDecipheriv = browser$6.Decipheriv = D, browser$6.listCiphers = browser$6.getCiphers = x, browser$6;
}
var browser$4 = {}, bn$4 = { exports: {} }, bn$3 = bn$4.exports, hasRequiredBn$1;
function requireBn$1() {
  return hasRequiredBn$1 || (hasRequiredBn$1 = 1, function(o) {
    (function(g, c) {
      function y(be, Be) {
        if (!be) throw new Error(Be || "Assertion failed");
      }
      function t(be, Be) {
        be.super_ = Be;
        var ke = function() {
        };
        ke.prototype = Be.prototype, be.prototype = new ke(), be.prototype.constructor = be;
      }
      function d(be, Be, ke) {
        if (d.isBN(be))
          return be;
        this.negative = 0, this.words = null, this.length = 0, this.red = null, be !== null && ((Be === "le" || Be === "be") && (ke = Be, Be = 10), this._init(be || 0, Be || 10, ke || "be"));
      }
      typeof g == "object" ? g.exports = d : c.BN = d, d.BN = d, d.wordSize = 26;
      var E;
      try {
        typeof window < "u" && typeof window.Buffer < "u" ? E = window.Buffer : E = require$$2$2.Buffer;
      } catch {
      }
      d.isBN = function(Be) {
        return Be instanceof d ? !0 : Be !== null && typeof Be == "object" && Be.constructor.wordSize === d.wordSize && Array.isArray(Be.words);
      }, d.max = function(Be, ke) {
        return Be.cmp(ke) > 0 ? Be : ke;
      }, d.min = function(Be, ke) {
        return Be.cmp(ke) < 0 ? Be : ke;
      }, d.prototype._init = function(Be, ke, xe) {
        if (typeof Be == "number")
          return this._initNumber(Be, ke, xe);
        if (typeof Be == "object")
          return this._initArray(Be, ke, xe);
        ke === "hex" && (ke = 16), y(ke === (ke | 0) && ke >= 2 && ke <= 36), Be = Be.toString().replace(/\s+/g, "");
        var Ne = 0;
        Be[0] === "-" && (Ne++, this.negative = 1), Ne < Be.length && (ke === 16 ? this._parseHex(Be, Ne, xe) : (this._parseBase(Be, ke, Ne), xe === "le" && this._initArray(this.toArray(), ke, xe)));
      }, d.prototype._initNumber = function(Be, ke, xe) {
        Be < 0 && (this.negative = 1, Be = -Be), Be < 67108864 ? (this.words = [Be & 67108863], this.length = 1) : Be < 4503599627370496 ? (this.words = [
          Be & 67108863,
          Be / 67108864 & 67108863
        ], this.length = 2) : (y(Be < 9007199254740992), this.words = [
          Be & 67108863,
          Be / 67108864 & 67108863,
          1
        ], this.length = 3), xe === "le" && this._initArray(this.toArray(), ke, xe);
      }, d.prototype._initArray = function(Be, ke, xe) {
        if (y(typeof Be.length == "number"), Be.length <= 0)
          return this.words = [0], this.length = 1, this;
        this.length = Math.ceil(Be.length / 3), this.words = new Array(this.length);
        for (var Ne = 0; Ne < this.length; Ne++)
          this.words[Ne] = 0;
        var Et, st, Dt = 0;
        if (xe === "be")
          for (Ne = Be.length - 1, Et = 0; Ne >= 0; Ne -= 3)
            st = Be[Ne] | Be[Ne - 1] << 8 | Be[Ne - 2] << 16, this.words[Et] |= st << Dt & 67108863, this.words[Et + 1] = st >>> 26 - Dt & 67108863, Dt += 24, Dt >= 26 && (Dt -= 26, Et++);
        else if (xe === "le")
          for (Ne = 0, Et = 0; Ne < Be.length; Ne += 3)
            st = Be[Ne] | Be[Ne + 1] << 8 | Be[Ne + 2] << 16, this.words[Et] |= st << Dt & 67108863, this.words[Et + 1] = st >>> 26 - Dt & 67108863, Dt += 24, Dt >= 26 && (Dt -= 26, Et++);
        return this.strip();
      };
      function B(be, Be) {
        var ke = be.charCodeAt(Be);
        return ke >= 65 && ke <= 70 ? ke - 55 : ke >= 97 && ke <= 102 ? ke - 87 : ke - 48 & 15;
      }
      function D(be, Be, ke) {
        var xe = B(be, ke);
        return ke - 1 >= Be && (xe |= B(be, ke - 1) << 4), xe;
      }
      d.prototype._parseHex = function(Be, ke, xe) {
        this.length = Math.ceil((Be.length - ke) / 6), this.words = new Array(this.length);
        for (var Ne = 0; Ne < this.length; Ne++)
          this.words[Ne] = 0;
        var Et = 0, st = 0, Dt;
        if (xe === "be")
          for (Ne = Be.length - 1; Ne >= ke; Ne -= 2)
            Dt = D(Be, ke, Ne) << Et, this.words[st] |= Dt & 67108863, Et >= 18 ? (Et -= 18, st += 1, this.words[st] |= Dt >>> 26) : Et += 8;
        else {
          var er = Be.length - ke;
          for (Ne = er % 2 === 0 ? ke + 1 : ke; Ne < Be.length; Ne += 2)
            Dt = D(Be, ke, Ne) << Et, this.words[st] |= Dt & 67108863, Et >= 18 ? (Et -= 18, st += 1, this.words[st] |= Dt >>> 26) : Et += 8;
        }
        this.strip();
      };
      function x(be, Be, ke, xe) {
        for (var Ne = 0, Et = Math.min(be.length, ke), st = Be; st < Et; st++) {
          var Dt = be.charCodeAt(st) - 48;
          Ne *= xe, Dt >= 49 ? Ne += Dt - 49 + 10 : Dt >= 17 ? Ne += Dt - 17 + 10 : Ne += Dt;
        }
        return Ne;
      }
      d.prototype._parseBase = function(Be, ke, xe) {
        this.words = [0], this.length = 1;
        for (var Ne = 0, Et = 1; Et <= 67108863; Et *= ke)
          Ne++;
        Ne--, Et = Et / ke | 0;
        for (var st = Be.length - xe, Dt = st % Ne, er = Math.min(st, st - Dt) + xe, xt = 0, ir = xe; ir < er; ir += Ne)
          xt = x(Be, ir, ir + Ne, ke), this.imuln(Et), this.words[0] + xt < 67108864 ? this.words[0] += xt : this._iaddn(xt);
        if (Dt !== 0) {
          var sr = 1;
          for (xt = x(Be, ir, Be.length, ke), ir = 0; ir < Dt; ir++)
            sr *= ke;
          this.imuln(sr), this.words[0] + xt < 67108864 ? this.words[0] += xt : this._iaddn(xt);
        }
        this.strip();
      }, d.prototype.copy = function(Be) {
        Be.words = new Array(this.length);
        for (var ke = 0; ke < this.length; ke++)
          Be.words[ke] = this.words[ke];
        Be.length = this.length, Be.negative = this.negative, Be.red = this.red;
      }, d.prototype.clone = function() {
        var Be = new d(null);
        return this.copy(Be), Be;
      }, d.prototype._expand = function(Be) {
        for (; this.length < Be; )
          this.words[this.length++] = 0;
        return this;
      }, d.prototype.strip = function() {
        for (; this.length > 1 && this.words[this.length - 1] === 0; )
          this.length--;
        return this._normSign();
      }, d.prototype._normSign = function() {
        return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
      }, d.prototype.inspect = function() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
      };
      var v = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
      ], F = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
      ], M = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        1e7,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64e6,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        243e5,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
      ];
      d.prototype.toString = function(Be, ke) {
        Be = Be || 10, ke = ke | 0 || 1;
        var xe;
        if (Be === 16 || Be === "hex") {
          xe = "";
          for (var Ne = 0, Et = 0, st = 0; st < this.length; st++) {
            var Dt = this.words[st], er = ((Dt << Ne | Et) & 16777215).toString(16);
            Et = Dt >>> 24 - Ne & 16777215, Ne += 2, Ne >= 26 && (Ne -= 26, st--), Et !== 0 || st !== this.length - 1 ? xe = v[6 - er.length] + er + xe : xe = er + xe;
          }
          for (Et !== 0 && (xe = Et.toString(16) + xe); xe.length % ke !== 0; )
            xe = "0" + xe;
          return this.negative !== 0 && (xe = "-" + xe), xe;
        }
        if (Be === (Be | 0) && Be >= 2 && Be <= 36) {
          var xt = F[Be], ir = M[Be];
          xe = "";
          var sr = this.clone();
          for (sr.negative = 0; !sr.isZero(); ) {
            var yr = sr.modn(ir).toString(Be);
            sr = sr.idivn(ir), sr.isZero() ? xe = yr + xe : xe = v[xt - yr.length] + yr + xe;
          }
          for (this.isZero() && (xe = "0" + xe); xe.length % ke !== 0; )
            xe = "0" + xe;
          return this.negative !== 0 && (xe = "-" + xe), xe;
        }
        y(!1, "Base should be between 2 and 36");
      }, d.prototype.toNumber = function() {
        var Be = this.words[0];
        return this.length === 2 ? Be += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? Be += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && y(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -Be : Be;
      }, d.prototype.toJSON = function() {
        return this.toString(16);
      }, d.prototype.toBuffer = function(Be, ke) {
        return y(typeof E < "u"), this.toArrayLike(E, Be, ke);
      }, d.prototype.toArray = function(Be, ke) {
        return this.toArrayLike(Array, Be, ke);
      }, d.prototype.toArrayLike = function(Be, ke, xe) {
        var Ne = this.byteLength(), Et = xe || Math.max(1, Ne);
        y(Ne <= Et, "byte array longer than desired length"), y(Et > 0, "Requested array length <= 0"), this.strip();
        var st = ke === "le", Dt = new Be(Et), er, xt, ir = this.clone();
        if (st) {
          for (xt = 0; !ir.isZero(); xt++)
            er = ir.andln(255), ir.iushrn(8), Dt[xt] = er;
          for (; xt < Et; xt++)
            Dt[xt] = 0;
        } else {
          for (xt = 0; xt < Et - Ne; xt++)
            Dt[xt] = 0;
          for (xt = 0; !ir.isZero(); xt++)
            er = ir.andln(255), ir.iushrn(8), Dt[Et - xt - 1] = er;
        }
        return Dt;
      }, Math.clz32 ? d.prototype._countBits = function(Be) {
        return 32 - Math.clz32(Be);
      } : d.prototype._countBits = function(Be) {
        var ke = Be, xe = 0;
        return ke >= 4096 && (xe += 13, ke >>>= 13), ke >= 64 && (xe += 7, ke >>>= 7), ke >= 8 && (xe += 4, ke >>>= 4), ke >= 2 && (xe += 2, ke >>>= 2), xe + ke;
      }, d.prototype._zeroBits = function(Be) {
        if (Be === 0) return 26;
        var ke = Be, xe = 0;
        return (ke & 8191) === 0 && (xe += 13, ke >>>= 13), (ke & 127) === 0 && (xe += 7, ke >>>= 7), (ke & 15) === 0 && (xe += 4, ke >>>= 4), (ke & 3) === 0 && (xe += 2, ke >>>= 2), (ke & 1) === 0 && xe++, xe;
      }, d.prototype.bitLength = function() {
        var Be = this.words[this.length - 1], ke = this._countBits(Be);
        return (this.length - 1) * 26 + ke;
      };
      function U(be) {
        for (var Be = new Array(be.bitLength()), ke = 0; ke < Be.length; ke++) {
          var xe = ke / 26 | 0, Ne = ke % 26;
          Be[ke] = (be.words[xe] & 1 << Ne) >>> Ne;
        }
        return Be;
      }
      d.prototype.zeroBits = function() {
        if (this.isZero()) return 0;
        for (var Be = 0, ke = 0; ke < this.length; ke++) {
          var xe = this._zeroBits(this.words[ke]);
          if (Be += xe, xe !== 26) break;
        }
        return Be;
      }, d.prototype.byteLength = function() {
        return Math.ceil(this.bitLength() / 8);
      }, d.prototype.toTwos = function(Be) {
        return this.negative !== 0 ? this.abs().inotn(Be).iaddn(1) : this.clone();
      }, d.prototype.fromTwos = function(Be) {
        return this.testn(Be - 1) ? this.notn(Be).iaddn(1).ineg() : this.clone();
      }, d.prototype.isNeg = function() {
        return this.negative !== 0;
      }, d.prototype.neg = function() {
        return this.clone().ineg();
      }, d.prototype.ineg = function() {
        return this.isZero() || (this.negative ^= 1), this;
      }, d.prototype.iuor = function(Be) {
        for (; this.length < Be.length; )
          this.words[this.length++] = 0;
        for (var ke = 0; ke < Be.length; ke++)
          this.words[ke] = this.words[ke] | Be.words[ke];
        return this.strip();
      }, d.prototype.ior = function(Be) {
        return y((this.negative | Be.negative) === 0), this.iuor(Be);
      }, d.prototype.or = function(Be) {
        return this.length > Be.length ? this.clone().ior(Be) : Be.clone().ior(this);
      }, d.prototype.uor = function(Be) {
        return this.length > Be.length ? this.clone().iuor(Be) : Be.clone().iuor(this);
      }, d.prototype.iuand = function(Be) {
        var ke;
        this.length > Be.length ? ke = Be : ke = this;
        for (var xe = 0; xe < ke.length; xe++)
          this.words[xe] = this.words[xe] & Be.words[xe];
        return this.length = ke.length, this.strip();
      }, d.prototype.iand = function(Be) {
        return y((this.negative | Be.negative) === 0), this.iuand(Be);
      }, d.prototype.and = function(Be) {
        return this.length > Be.length ? this.clone().iand(Be) : Be.clone().iand(this);
      }, d.prototype.uand = function(Be) {
        return this.length > Be.length ? this.clone().iuand(Be) : Be.clone().iuand(this);
      }, d.prototype.iuxor = function(Be) {
        var ke, xe;
        this.length > Be.length ? (ke = this, xe = Be) : (ke = Be, xe = this);
        for (var Ne = 0; Ne < xe.length; Ne++)
          this.words[Ne] = ke.words[Ne] ^ xe.words[Ne];
        if (this !== ke)
          for (; Ne < ke.length; Ne++)
            this.words[Ne] = ke.words[Ne];
        return this.length = ke.length, this.strip();
      }, d.prototype.ixor = function(Be) {
        return y((this.negative | Be.negative) === 0), this.iuxor(Be);
      }, d.prototype.xor = function(Be) {
        return this.length > Be.length ? this.clone().ixor(Be) : Be.clone().ixor(this);
      }, d.prototype.uxor = function(Be) {
        return this.length > Be.length ? this.clone().iuxor(Be) : Be.clone().iuxor(this);
      }, d.prototype.inotn = function(Be) {
        y(typeof Be == "number" && Be >= 0);
        var ke = Math.ceil(Be / 26) | 0, xe = Be % 26;
        this._expand(ke), xe > 0 && ke--;
        for (var Ne = 0; Ne < ke; Ne++)
          this.words[Ne] = ~this.words[Ne] & 67108863;
        return xe > 0 && (this.words[Ne] = ~this.words[Ne] & 67108863 >> 26 - xe), this.strip();
      }, d.prototype.notn = function(Be) {
        return this.clone().inotn(Be);
      }, d.prototype.setn = function(Be, ke) {
        y(typeof Be == "number" && Be >= 0);
        var xe = Be / 26 | 0, Ne = Be % 26;
        return this._expand(xe + 1), ke ? this.words[xe] = this.words[xe] | 1 << Ne : this.words[xe] = this.words[xe] & ~(1 << Ne), this.strip();
      }, d.prototype.iadd = function(Be) {
        var ke;
        if (this.negative !== 0 && Be.negative === 0)
          return this.negative = 0, ke = this.isub(Be), this.negative ^= 1, this._normSign();
        if (this.negative === 0 && Be.negative !== 0)
          return Be.negative = 0, ke = this.isub(Be), Be.negative = 1, ke._normSign();
        var xe, Ne;
        this.length > Be.length ? (xe = this, Ne = Be) : (xe = Be, Ne = this);
        for (var Et = 0, st = 0; st < Ne.length; st++)
          ke = (xe.words[st] | 0) + (Ne.words[st] | 0) + Et, this.words[st] = ke & 67108863, Et = ke >>> 26;
        for (; Et !== 0 && st < xe.length; st++)
          ke = (xe.words[st] | 0) + Et, this.words[st] = ke & 67108863, Et = ke >>> 26;
        if (this.length = xe.length, Et !== 0)
          this.words[this.length] = Et, this.length++;
        else if (xe !== this)
          for (; st < xe.length; st++)
            this.words[st] = xe.words[st];
        return this;
      }, d.prototype.add = function(Be) {
        var ke;
        return Be.negative !== 0 && this.negative === 0 ? (Be.negative = 0, ke = this.sub(Be), Be.negative ^= 1, ke) : Be.negative === 0 && this.negative !== 0 ? (this.negative = 0, ke = Be.sub(this), this.negative = 1, ke) : this.length > Be.length ? this.clone().iadd(Be) : Be.clone().iadd(this);
      }, d.prototype.isub = function(Be) {
        if (Be.negative !== 0) {
          Be.negative = 0;
          var ke = this.iadd(Be);
          return Be.negative = 1, ke._normSign();
        } else if (this.negative !== 0)
          return this.negative = 0, this.iadd(Be), this.negative = 1, this._normSign();
        var xe = this.cmp(Be);
        if (xe === 0)
          return this.negative = 0, this.length = 1, this.words[0] = 0, this;
        var Ne, Et;
        xe > 0 ? (Ne = this, Et = Be) : (Ne = Be, Et = this);
        for (var st = 0, Dt = 0; Dt < Et.length; Dt++)
          ke = (Ne.words[Dt] | 0) - (Et.words[Dt] | 0) + st, st = ke >> 26, this.words[Dt] = ke & 67108863;
        for (; st !== 0 && Dt < Ne.length; Dt++)
          ke = (Ne.words[Dt] | 0) + st, st = ke >> 26, this.words[Dt] = ke & 67108863;
        if (st === 0 && Dt < Ne.length && Ne !== this)
          for (; Dt < Ne.length; Dt++)
            this.words[Dt] = Ne.words[Dt];
        return this.length = Math.max(this.length, Dt), Ne !== this && (this.negative = 1), this.strip();
      }, d.prototype.sub = function(Be) {
        return this.clone().isub(Be);
      };
      function L(be, Be, ke) {
        ke.negative = Be.negative ^ be.negative;
        var xe = be.length + Be.length | 0;
        ke.length = xe, xe = xe - 1 | 0;
        var Ne = be.words[0] | 0, Et = Be.words[0] | 0, st = Ne * Et, Dt = st & 67108863, er = st / 67108864 | 0;
        ke.words[0] = Dt;
        for (var xt = 1; xt < xe; xt++) {
          for (var ir = er >>> 26, sr = er & 67108863, yr = Math.min(xt, Be.length - 1), wr = Math.max(0, xt - be.length + 1); wr <= yr; wr++) {
            var qr = xt - wr | 0;
            Ne = be.words[qr] | 0, Et = Be.words[wr] | 0, st = Ne * Et + sr, ir += st / 67108864 | 0, sr = st & 67108863;
          }
          ke.words[xt] = sr | 0, er = ir | 0;
        }
        return er !== 0 ? ke.words[xt] = er | 0 : ke.length--, ke.strip();
      }
      var H = function(Be, ke, xe) {
        var Ne = Be.words, Et = ke.words, st = xe.words, Dt = 0, er, xt, ir, sr = Ne[0] | 0, yr = sr & 8191, wr = sr >>> 13, qr = Ne[1] | 0, Mr = qr & 8191, Dr = qr >>> 13, Qr = Ne[2] | 0, Xr = Qr & 8191, Vr = Qr >>> 13, Ur = Ne[3] | 0, Sr = Ur & 8191, Gr = Ur >>> 13, Fr = Ne[4] | 0, br = Fr & 8191, Ar = Fr >>> 13, cr = Ne[5] | 0, hr = cr & 8191, Wr = cr >>> 13, fi = Ne[6] | 0, Bi = fi & 8191, $r = fi >>> 13, oi = Ne[7] | 0, zr = oi & 8191, ti = oi >>> 13, Lr = Ne[8] | 0, Rr = Lr & 8191, Ir = Lr >>> 13, pr = Ne[9] | 0, Cr = pr & 8191, Er = pr >>> 13, xr = Et[0] | 0, si = xr & 8191, Ci = xr >>> 13, bi = Et[1] | 0, Ri = bi & 8191, li = bi >>> 13, zi = Et[2] | 0, Kn = zi & 8191, Hn = zi >>> 13, os = Et[3] | 0, ts = os & 8191, Gs = os >>> 13, Wn = Et[4] | 0, Gn = Wn & 8191, ro = Wn >>> 13, Fs = Et[5] | 0, ii = Fs & 8191, Ai = Fs >>> 13, ci = Et[6] | 0, Si = ci & 8191, Ui = ci >>> 13, _i = Et[7] | 0, Tn = _i & 8191, Fn = _i >>> 13, ss = Et[8] | 0, rs = ss & 8191, is = ss >>> 13, Pr = Et[9] | 0, as = Pr & 8191, Rs = Pr >>> 13;
        xe.negative = Be.negative ^ ke.negative, xe.length = 19, er = Math.imul(yr, si), xt = Math.imul(yr, Ci), xt = xt + Math.imul(wr, si) | 0, ir = Math.imul(wr, Ci);
        var ri = (Dt + er | 0) + ((xt & 8191) << 13) | 0;
        Dt = (ir + (xt >>> 13) | 0) + (ri >>> 26) | 0, ri &= 67108863, er = Math.imul(Mr, si), xt = Math.imul(Mr, Ci), xt = xt + Math.imul(Dr, si) | 0, ir = Math.imul(Dr, Ci), er = er + Math.imul(yr, Ri) | 0, xt = xt + Math.imul(yr, li) | 0, xt = xt + Math.imul(wr, Ri) | 0, ir = ir + Math.imul(wr, li) | 0;
        var Tr = (Dt + er | 0) + ((xt & 8191) << 13) | 0;
        Dt = (ir + (xt >>> 13) | 0) + (Tr >>> 26) | 0, Tr &= 67108863, er = Math.imul(Xr, si), xt = Math.imul(Xr, Ci), xt = xt + Math.imul(Vr, si) | 0, ir = Math.imul(Vr, Ci), er = er + Math.imul(Mr, Ri) | 0, xt = xt + Math.imul(Mr, li) | 0, xt = xt + Math.imul(Dr, Ri) | 0, ir = ir + Math.imul(Dr, li) | 0, er = er + Math.imul(yr, Kn) | 0, xt = xt + Math.imul(yr, Hn) | 0, xt = xt + Math.imul(wr, Kn) | 0, ir = ir + Math.imul(wr, Hn) | 0;
        var yi = (Dt + er | 0) + ((xt & 8191) << 13) | 0;
        Dt = (ir + (xt >>> 13) | 0) + (yi >>> 26) | 0, yi &= 67108863, er = Math.imul(Sr, si), xt = Math.imul(Sr, Ci), xt = xt + Math.imul(Gr, si) | 0, ir = Math.imul(Gr, Ci), er = er + Math.imul(Xr, Ri) | 0, xt = xt + Math.imul(Xr, li) | 0, xt = xt + Math.imul(Vr, Ri) | 0, ir = ir + Math.imul(Vr, li) | 0, er = er + Math.imul(Mr, Kn) | 0, xt = xt + Math.imul(Mr, Hn) | 0, xt = xt + Math.imul(Dr, Kn) | 0, ir = ir + Math.imul(Dr, Hn) | 0, er = er + Math.imul(yr, ts) | 0, xt = xt + Math.imul(yr, Gs) | 0, xt = xt + Math.imul(wr, ts) | 0, ir = ir + Math.imul(wr, Gs) | 0;
        var ki = (Dt + er | 0) + ((xt & 8191) << 13) | 0;
        Dt = (ir + (xt >>> 13) | 0) + (ki >>> 26) | 0, ki &= 67108863, er = Math.imul(br, si), xt = Math.imul(br, Ci), xt = xt + Math.imul(Ar, si) | 0, ir = Math.imul(Ar, Ci), er = er + Math.imul(Sr, Ri) | 0, xt = xt + Math.imul(Sr, li) | 0, xt = xt + Math.imul(Gr, Ri) | 0, ir = ir + Math.imul(Gr, li) | 0, er = er + Math.imul(Xr, Kn) | 0, xt = xt + Math.imul(Xr, Hn) | 0, xt = xt + Math.imul(Vr, Kn) | 0, ir = ir + Math.imul(Vr, Hn) | 0, er = er + Math.imul(Mr, ts) | 0, xt = xt + Math.imul(Mr, Gs) | 0, xt = xt + Math.imul(Dr, ts) | 0, ir = ir + Math.imul(Dr, Gs) | 0, er = er + Math.imul(yr, Gn) | 0, xt = xt + Math.imul(yr, ro) | 0, xt = xt + Math.imul(wr, Gn) | 0, ir = ir + Math.imul(wr, ro) | 0;
        var qi = (Dt + er | 0) + ((xt & 8191) << 13) | 0;
        Dt = (ir + (xt >>> 13) | 0) + (qi >>> 26) | 0, qi &= 67108863, er = Math.imul(hr, si), xt = Math.imul(hr, Ci), xt = xt + Math.imul(Wr, si) | 0, ir = Math.imul(Wr, Ci), er = er + Math.imul(br, Ri) | 0, xt = xt + Math.imul(br, li) | 0, xt = xt + Math.imul(Ar, Ri) | 0, ir = ir + Math.imul(Ar, li) | 0, er = er + Math.imul(Sr, Kn) | 0, xt = xt + Math.imul(Sr, Hn) | 0, xt = xt + Math.imul(Gr, Kn) | 0, ir = ir + Math.imul(Gr, Hn) | 0, er = er + Math.imul(Xr, ts) | 0, xt = xt + Math.imul(Xr, Gs) | 0, xt = xt + Math.imul(Vr, ts) | 0, ir = ir + Math.imul(Vr, Gs) | 0, er = er + Math.imul(Mr, Gn) | 0, xt = xt + Math.imul(Mr, ro) | 0, xt = xt + Math.imul(Dr, Gn) | 0, ir = ir + Math.imul(Dr, ro) | 0, er = er + Math.imul(yr, ii) | 0, xt = xt + Math.imul(yr, Ai) | 0, xt = xt + Math.imul(wr, ii) | 0, ir = ir + Math.imul(wr, Ai) | 0;
        var C = (Dt + er | 0) + ((xt & 8191) << 13) | 0;
        Dt = (ir + (xt >>> 13) | 0) + (C >>> 26) | 0, C &= 67108863, er = Math.imul(Bi, si), xt = Math.imul(Bi, Ci), xt = xt + Math.imul($r, si) | 0, ir = Math.imul($r, Ci), er = er + Math.imul(hr, Ri) | 0, xt = xt + Math.imul(hr, li) | 0, xt = xt + Math.imul(Wr, Ri) | 0, ir = ir + Math.imul(Wr, li) | 0, er = er + Math.imul(br, Kn) | 0, xt = xt + Math.imul(br, Hn) | 0, xt = xt + Math.imul(Ar, Kn) | 0, ir = ir + Math.imul(Ar, Hn) | 0, er = er + Math.imul(Sr, ts) | 0, xt = xt + Math.imul(Sr, Gs) | 0, xt = xt + Math.imul(Gr, ts) | 0, ir = ir + Math.imul(Gr, Gs) | 0, er = er + Math.imul(Xr, Gn) | 0, xt = xt + Math.imul(Xr, ro) | 0, xt = xt + Math.imul(Vr, Gn) | 0, ir = ir + Math.imul(Vr, ro) | 0, er = er + Math.imul(Mr, ii) | 0, xt = xt + Math.imul(Mr, Ai) | 0, xt = xt + Math.imul(Dr, ii) | 0, ir = ir + Math.imul(Dr, Ai) | 0, er = er + Math.imul(yr, Si) | 0, xt = xt + Math.imul(yr, Ui) | 0, xt = xt + Math.imul(wr, Si) | 0, ir = ir + Math.imul(wr, Ui) | 0;
        var l = (Dt + er | 0) + ((xt & 8191) << 13) | 0;
        Dt = (ir + (xt >>> 13) | 0) + (l >>> 26) | 0, l &= 67108863, er = Math.imul(zr, si), xt = Math.imul(zr, Ci), xt = xt + Math.imul(ti, si) | 0, ir = Math.imul(ti, Ci), er = er + Math.imul(Bi, Ri) | 0, xt = xt + Math.imul(Bi, li) | 0, xt = xt + Math.imul($r, Ri) | 0, ir = ir + Math.imul($r, li) | 0, er = er + Math.imul(hr, Kn) | 0, xt = xt + Math.imul(hr, Hn) | 0, xt = xt + Math.imul(Wr, Kn) | 0, ir = ir + Math.imul(Wr, Hn) | 0, er = er + Math.imul(br, ts) | 0, xt = xt + Math.imul(br, Gs) | 0, xt = xt + Math.imul(Ar, ts) | 0, ir = ir + Math.imul(Ar, Gs) | 0, er = er + Math.imul(Sr, Gn) | 0, xt = xt + Math.imul(Sr, ro) | 0, xt = xt + Math.imul(Gr, Gn) | 0, ir = ir + Math.imul(Gr, ro) | 0, er = er + Math.imul(Xr, ii) | 0, xt = xt + Math.imul(Xr, Ai) | 0, xt = xt + Math.imul(Vr, ii) | 0, ir = ir + Math.imul(Vr, Ai) | 0, er = er + Math.imul(Mr, Si) | 0, xt = xt + Math.imul(Mr, Ui) | 0, xt = xt + Math.imul(Dr, Si) | 0, ir = ir + Math.imul(Dr, Ui) | 0, er = er + Math.imul(yr, Tn) | 0, xt = xt + Math.imul(yr, Fn) | 0, xt = xt + Math.imul(wr, Tn) | 0, ir = ir + Math.imul(wr, Fn) | 0;
        var w = (Dt + er | 0) + ((xt & 8191) << 13) | 0;
        Dt = (ir + (xt >>> 13) | 0) + (w >>> 26) | 0, w &= 67108863, er = Math.imul(Rr, si), xt = Math.imul(Rr, Ci), xt = xt + Math.imul(Ir, si) | 0, ir = Math.imul(Ir, Ci), er = er + Math.imul(zr, Ri) | 0, xt = xt + Math.imul(zr, li) | 0, xt = xt + Math.imul(ti, Ri) | 0, ir = ir + Math.imul(ti, li) | 0, er = er + Math.imul(Bi, Kn) | 0, xt = xt + Math.imul(Bi, Hn) | 0, xt = xt + Math.imul($r, Kn) | 0, ir = ir + Math.imul($r, Hn) | 0, er = er + Math.imul(hr, ts) | 0, xt = xt + Math.imul(hr, Gs) | 0, xt = xt + Math.imul(Wr, ts) | 0, ir = ir + Math.imul(Wr, Gs) | 0, er = er + Math.imul(br, Gn) | 0, xt = xt + Math.imul(br, ro) | 0, xt = xt + Math.imul(Ar, Gn) | 0, ir = ir + Math.imul(Ar, ro) | 0, er = er + Math.imul(Sr, ii) | 0, xt = xt + Math.imul(Sr, Ai) | 0, xt = xt + Math.imul(Gr, ii) | 0, ir = ir + Math.imul(Gr, Ai) | 0, er = er + Math.imul(Xr, Si) | 0, xt = xt + Math.imul(Xr, Ui) | 0, xt = xt + Math.imul(Vr, Si) | 0, ir = ir + Math.imul(Vr, Ui) | 0, er = er + Math.imul(Mr, Tn) | 0, xt = xt + Math.imul(Mr, Fn) | 0, xt = xt + Math.imul(Dr, Tn) | 0, ir = ir + Math.imul(Dr, Fn) | 0, er = er + Math.imul(yr, rs) | 0, xt = xt + Math.imul(yr, is) | 0, xt = xt + Math.imul(wr, rs) | 0, ir = ir + Math.imul(wr, is) | 0;
        var n = (Dt + er | 0) + ((xt & 8191) << 13) | 0;
        Dt = (ir + (xt >>> 13) | 0) + (n >>> 26) | 0, n &= 67108863, er = Math.imul(Cr, si), xt = Math.imul(Cr, Ci), xt = xt + Math.imul(Er, si) | 0, ir = Math.imul(Er, Ci), er = er + Math.imul(Rr, Ri) | 0, xt = xt + Math.imul(Rr, li) | 0, xt = xt + Math.imul(Ir, Ri) | 0, ir = ir + Math.imul(Ir, li) | 0, er = er + Math.imul(zr, Kn) | 0, xt = xt + Math.imul(zr, Hn) | 0, xt = xt + Math.imul(ti, Kn) | 0, ir = ir + Math.imul(ti, Hn) | 0, er = er + Math.imul(Bi, ts) | 0, xt = xt + Math.imul(Bi, Gs) | 0, xt = xt + Math.imul($r, ts) | 0, ir = ir + Math.imul($r, Gs) | 0, er = er + Math.imul(hr, Gn) | 0, xt = xt + Math.imul(hr, ro) | 0, xt = xt + Math.imul(Wr, Gn) | 0, ir = ir + Math.imul(Wr, ro) | 0, er = er + Math.imul(br, ii) | 0, xt = xt + Math.imul(br, Ai) | 0, xt = xt + Math.imul(Ar, ii) | 0, ir = ir + Math.imul(Ar, Ai) | 0, er = er + Math.imul(Sr, Si) | 0, xt = xt + Math.imul(Sr, Ui) | 0, xt = xt + Math.imul(Gr, Si) | 0, ir = ir + Math.imul(Gr, Ui) | 0, er = er + Math.imul(Xr, Tn) | 0, xt = xt + Math.imul(Xr, Fn) | 0, xt = xt + Math.imul(Vr, Tn) | 0, ir = ir + Math.imul(Vr, Fn) | 0, er = er + Math.imul(Mr, rs) | 0, xt = xt + Math.imul(Mr, is) | 0, xt = xt + Math.imul(Dr, rs) | 0, ir = ir + Math.imul(Dr, is) | 0, er = er + Math.imul(yr, as) | 0, xt = xt + Math.imul(yr, Rs) | 0, xt = xt + Math.imul(wr, as) | 0, ir = ir + Math.imul(wr, Rs) | 0;
        var a = (Dt + er | 0) + ((xt & 8191) << 13) | 0;
        Dt = (ir + (xt >>> 13) | 0) + (a >>> 26) | 0, a &= 67108863, er = Math.imul(Cr, Ri), xt = Math.imul(Cr, li), xt = xt + Math.imul(Er, Ri) | 0, ir = Math.imul(Er, li), er = er + Math.imul(Rr, Kn) | 0, xt = xt + Math.imul(Rr, Hn) | 0, xt = xt + Math.imul(Ir, Kn) | 0, ir = ir + Math.imul(Ir, Hn) | 0, er = er + Math.imul(zr, ts) | 0, xt = xt + Math.imul(zr, Gs) | 0, xt = xt + Math.imul(ti, ts) | 0, ir = ir + Math.imul(ti, Gs) | 0, er = er + Math.imul(Bi, Gn) | 0, xt = xt + Math.imul(Bi, ro) | 0, xt = xt + Math.imul($r, Gn) | 0, ir = ir + Math.imul($r, ro) | 0, er = er + Math.imul(hr, ii) | 0, xt = xt + Math.imul(hr, Ai) | 0, xt = xt + Math.imul(Wr, ii) | 0, ir = ir + Math.imul(Wr, Ai) | 0, er = er + Math.imul(br, Si) | 0, xt = xt + Math.imul(br, Ui) | 0, xt = xt + Math.imul(Ar, Si) | 0, ir = ir + Math.imul(Ar, Ui) | 0, er = er + Math.imul(Sr, Tn) | 0, xt = xt + Math.imul(Sr, Fn) | 0, xt = xt + Math.imul(Gr, Tn) | 0, ir = ir + Math.imul(Gr, Fn) | 0, er = er + Math.imul(Xr, rs) | 0, xt = xt + Math.imul(Xr, is) | 0, xt = xt + Math.imul(Vr, rs) | 0, ir = ir + Math.imul(Vr, is) | 0, er = er + Math.imul(Mr, as) | 0, xt = xt + Math.imul(Mr, Rs) | 0, xt = xt + Math.imul(Dr, as) | 0, ir = ir + Math.imul(Dr, Rs) | 0;
        var b = (Dt + er | 0) + ((xt & 8191) << 13) | 0;
        Dt = (ir + (xt >>> 13) | 0) + (b >>> 26) | 0, b &= 67108863, er = Math.imul(Cr, Kn), xt = Math.imul(Cr, Hn), xt = xt + Math.imul(Er, Kn) | 0, ir = Math.imul(Er, Hn), er = er + Math.imul(Rr, ts) | 0, xt = xt + Math.imul(Rr, Gs) | 0, xt = xt + Math.imul(Ir, ts) | 0, ir = ir + Math.imul(Ir, Gs) | 0, er = er + Math.imul(zr, Gn) | 0, xt = xt + Math.imul(zr, ro) | 0, xt = xt + Math.imul(ti, Gn) | 0, ir = ir + Math.imul(ti, ro) | 0, er = er + Math.imul(Bi, ii) | 0, xt = xt + Math.imul(Bi, Ai) | 0, xt = xt + Math.imul($r, ii) | 0, ir = ir + Math.imul($r, Ai) | 0, er = er + Math.imul(hr, Si) | 0, xt = xt + Math.imul(hr, Ui) | 0, xt = xt + Math.imul(Wr, Si) | 0, ir = ir + Math.imul(Wr, Ui) | 0, er = er + Math.imul(br, Tn) | 0, xt = xt + Math.imul(br, Fn) | 0, xt = xt + Math.imul(Ar, Tn) | 0, ir = ir + Math.imul(Ar, Fn) | 0, er = er + Math.imul(Sr, rs) | 0, xt = xt + Math.imul(Sr, is) | 0, xt = xt + Math.imul(Gr, rs) | 0, ir = ir + Math.imul(Gr, is) | 0, er = er + Math.imul(Xr, as) | 0, xt = xt + Math.imul(Xr, Rs) | 0, xt = xt + Math.imul(Vr, as) | 0, ir = ir + Math.imul(Vr, Rs) | 0;
        var P = (Dt + er | 0) + ((xt & 8191) << 13) | 0;
        Dt = (ir + (xt >>> 13) | 0) + (P >>> 26) | 0, P &= 67108863, er = Math.imul(Cr, ts), xt = Math.imul(Cr, Gs), xt = xt + Math.imul(Er, ts) | 0, ir = Math.imul(Er, Gs), er = er + Math.imul(Rr, Gn) | 0, xt = xt + Math.imul(Rr, ro) | 0, xt = xt + Math.imul(Ir, Gn) | 0, ir = ir + Math.imul(Ir, ro) | 0, er = er + Math.imul(zr, ii) | 0, xt = xt + Math.imul(zr, Ai) | 0, xt = xt + Math.imul(ti, ii) | 0, ir = ir + Math.imul(ti, Ai) | 0, er = er + Math.imul(Bi, Si) | 0, xt = xt + Math.imul(Bi, Ui) | 0, xt = xt + Math.imul($r, Si) | 0, ir = ir + Math.imul($r, Ui) | 0, er = er + Math.imul(hr, Tn) | 0, xt = xt + Math.imul(hr, Fn) | 0, xt = xt + Math.imul(Wr, Tn) | 0, ir = ir + Math.imul(Wr, Fn) | 0, er = er + Math.imul(br, rs) | 0, xt = xt + Math.imul(br, is) | 0, xt = xt + Math.imul(Ar, rs) | 0, ir = ir + Math.imul(Ar, is) | 0, er = er + Math.imul(Sr, as) | 0, xt = xt + Math.imul(Sr, Rs) | 0, xt = xt + Math.imul(Gr, as) | 0, ir = ir + Math.imul(Gr, Rs) | 0;
        var K = (Dt + er | 0) + ((xt & 8191) << 13) | 0;
        Dt = (ir + (xt >>> 13) | 0) + (K >>> 26) | 0, K &= 67108863, er = Math.imul(Cr, Gn), xt = Math.imul(Cr, ro), xt = xt + Math.imul(Er, Gn) | 0, ir = Math.imul(Er, ro), er = er + Math.imul(Rr, ii) | 0, xt = xt + Math.imul(Rr, Ai) | 0, xt = xt + Math.imul(Ir, ii) | 0, ir = ir + Math.imul(Ir, Ai) | 0, er = er + Math.imul(zr, Si) | 0, xt = xt + Math.imul(zr, Ui) | 0, xt = xt + Math.imul(ti, Si) | 0, ir = ir + Math.imul(ti, Ui) | 0, er = er + Math.imul(Bi, Tn) | 0, xt = xt + Math.imul(Bi, Fn) | 0, xt = xt + Math.imul($r, Tn) | 0, ir = ir + Math.imul($r, Fn) | 0, er = er + Math.imul(hr, rs) | 0, xt = xt + Math.imul(hr, is) | 0, xt = xt + Math.imul(Wr, rs) | 0, ir = ir + Math.imul(Wr, is) | 0, er = er + Math.imul(br, as) | 0, xt = xt + Math.imul(br, Rs) | 0, xt = xt + Math.imul(Ar, as) | 0, ir = ir + Math.imul(Ar, Rs) | 0;
        var pe = (Dt + er | 0) + ((xt & 8191) << 13) | 0;
        Dt = (ir + (xt >>> 13) | 0) + (pe >>> 26) | 0, pe &= 67108863, er = Math.imul(Cr, ii), xt = Math.imul(Cr, Ai), xt = xt + Math.imul(Er, ii) | 0, ir = Math.imul(Er, Ai), er = er + Math.imul(Rr, Si) | 0, xt = xt + Math.imul(Rr, Ui) | 0, xt = xt + Math.imul(Ir, Si) | 0, ir = ir + Math.imul(Ir, Ui) | 0, er = er + Math.imul(zr, Tn) | 0, xt = xt + Math.imul(zr, Fn) | 0, xt = xt + Math.imul(ti, Tn) | 0, ir = ir + Math.imul(ti, Fn) | 0, er = er + Math.imul(Bi, rs) | 0, xt = xt + Math.imul(Bi, is) | 0, xt = xt + Math.imul($r, rs) | 0, ir = ir + Math.imul($r, is) | 0, er = er + Math.imul(hr, as) | 0, xt = xt + Math.imul(hr, Rs) | 0, xt = xt + Math.imul(Wr, as) | 0, ir = ir + Math.imul(Wr, Rs) | 0;
        var Ce = (Dt + er | 0) + ((xt & 8191) << 13) | 0;
        Dt = (ir + (xt >>> 13) | 0) + (Ce >>> 26) | 0, Ce &= 67108863, er = Math.imul(Cr, Si), xt = Math.imul(Cr, Ui), xt = xt + Math.imul(Er, Si) | 0, ir = Math.imul(Er, Ui), er = er + Math.imul(Rr, Tn) | 0, xt = xt + Math.imul(Rr, Fn) | 0, xt = xt + Math.imul(Ir, Tn) | 0, ir = ir + Math.imul(Ir, Fn) | 0, er = er + Math.imul(zr, rs) | 0, xt = xt + Math.imul(zr, is) | 0, xt = xt + Math.imul(ti, rs) | 0, ir = ir + Math.imul(ti, is) | 0, er = er + Math.imul(Bi, as) | 0, xt = xt + Math.imul(Bi, Rs) | 0, xt = xt + Math.imul($r, as) | 0, ir = ir + Math.imul($r, Rs) | 0;
        var Me = (Dt + er | 0) + ((xt & 8191) << 13) | 0;
        Dt = (ir + (xt >>> 13) | 0) + (Me >>> 26) | 0, Me &= 67108863, er = Math.imul(Cr, Tn), xt = Math.imul(Cr, Fn), xt = xt + Math.imul(Er, Tn) | 0, ir = Math.imul(Er, Fn), er = er + Math.imul(Rr, rs) | 0, xt = xt + Math.imul(Rr, is) | 0, xt = xt + Math.imul(Ir, rs) | 0, ir = ir + Math.imul(Ir, is) | 0, er = er + Math.imul(zr, as) | 0, xt = xt + Math.imul(zr, Rs) | 0, xt = xt + Math.imul(ti, as) | 0, ir = ir + Math.imul(ti, Rs) | 0;
        var Tt = (Dt + er | 0) + ((xt & 8191) << 13) | 0;
        Dt = (ir + (xt >>> 13) | 0) + (Tt >>> 26) | 0, Tt &= 67108863, er = Math.imul(Cr, rs), xt = Math.imul(Cr, is), xt = xt + Math.imul(Er, rs) | 0, ir = Math.imul(Er, is), er = er + Math.imul(Rr, as) | 0, xt = xt + Math.imul(Rr, Rs) | 0, xt = xt + Math.imul(Ir, as) | 0, ir = ir + Math.imul(Ir, Rs) | 0;
        var tr = (Dt + er | 0) + ((xt & 8191) << 13) | 0;
        Dt = (ir + (xt >>> 13) | 0) + (tr >>> 26) | 0, tr &= 67108863, er = Math.imul(Cr, as), xt = Math.imul(Cr, Rs), xt = xt + Math.imul(Er, as) | 0, ir = Math.imul(Er, Rs);
        var nr = (Dt + er | 0) + ((xt & 8191) << 13) | 0;
        return Dt = (ir + (xt >>> 13) | 0) + (nr >>> 26) | 0, nr &= 67108863, st[0] = ri, st[1] = Tr, st[2] = yi, st[3] = ki, st[4] = qi, st[5] = C, st[6] = l, st[7] = w, st[8] = n, st[9] = a, st[10] = b, st[11] = P, st[12] = K, st[13] = pe, st[14] = Ce, st[15] = Me, st[16] = Tt, st[17] = tr, st[18] = nr, Dt !== 0 && (st[19] = Dt, xe.length++), xe;
      };
      Math.imul || (H = L);
      function fe(be, Be, ke) {
        ke.negative = Be.negative ^ be.negative, ke.length = be.length + Be.length;
        for (var xe = 0, Ne = 0, Et = 0; Et < ke.length - 1; Et++) {
          var st = Ne;
          Ne = 0;
          for (var Dt = xe & 67108863, er = Math.min(Et, Be.length - 1), xt = Math.max(0, Et - be.length + 1); xt <= er; xt++) {
            var ir = Et - xt, sr = be.words[ir] | 0, yr = Be.words[xt] | 0, wr = sr * yr, qr = wr & 67108863;
            st = st + (wr / 67108864 | 0) | 0, qr = qr + Dt | 0, Dt = qr & 67108863, st = st + (qr >>> 26) | 0, Ne += st >>> 26, st &= 67108863;
          }
          ke.words[Et] = Dt, xe = st, st = Ne;
        }
        return xe !== 0 ? ke.words[Et] = xe : ke.length--, ke.strip();
      }
      function ge(be, Be, ke) {
        var xe = new Ie();
        return xe.mulp(be, Be, ke);
      }
      d.prototype.mulTo = function(Be, ke) {
        var xe, Ne = this.length + Be.length;
        return this.length === 10 && Be.length === 10 ? xe = H(this, Be, ke) : Ne < 63 ? xe = L(this, Be, ke) : Ne < 1024 ? xe = fe(this, Be, ke) : xe = ge(this, Be, ke), xe;
      };
      function Ie(be, Be) {
        this.x = be, this.y = Be;
      }
      Ie.prototype.makeRBT = function(Be) {
        for (var ke = new Array(Be), xe = d.prototype._countBits(Be) - 1, Ne = 0; Ne < Be; Ne++)
          ke[Ne] = this.revBin(Ne, xe, Be);
        return ke;
      }, Ie.prototype.revBin = function(Be, ke, xe) {
        if (Be === 0 || Be === xe - 1) return Be;
        for (var Ne = 0, Et = 0; Et < ke; Et++)
          Ne |= (Be & 1) << ke - Et - 1, Be >>= 1;
        return Ne;
      }, Ie.prototype.permute = function(Be, ke, xe, Ne, Et, st) {
        for (var Dt = 0; Dt < st; Dt++)
          Ne[Dt] = ke[Be[Dt]], Et[Dt] = xe[Be[Dt]];
      }, Ie.prototype.transform = function(Be, ke, xe, Ne, Et, st) {
        this.permute(st, Be, ke, xe, Ne, Et);
        for (var Dt = 1; Dt < Et; Dt <<= 1)
          for (var er = Dt << 1, xt = Math.cos(2 * Math.PI / er), ir = Math.sin(2 * Math.PI / er), sr = 0; sr < Et; sr += er)
            for (var yr = xt, wr = ir, qr = 0; qr < Dt; qr++) {
              var Mr = xe[sr + qr], Dr = Ne[sr + qr], Qr = xe[sr + qr + Dt], Xr = Ne[sr + qr + Dt], Vr = yr * Qr - wr * Xr;
              Xr = yr * Xr + wr * Qr, Qr = Vr, xe[sr + qr] = Mr + Qr, Ne[sr + qr] = Dr + Xr, xe[sr + qr + Dt] = Mr - Qr, Ne[sr + qr + Dt] = Dr - Xr, qr !== er && (Vr = xt * yr - ir * wr, wr = xt * wr + ir * yr, yr = Vr);
            }
      }, Ie.prototype.guessLen13b = function(Be, ke) {
        var xe = Math.max(ke, Be) | 1, Ne = xe & 1, Et = 0;
        for (xe = xe / 2 | 0; xe; xe = xe >>> 1)
          Et++;
        return 1 << Et + 1 + Ne;
      }, Ie.prototype.conjugate = function(Be, ke, xe) {
        if (!(xe <= 1))
          for (var Ne = 0; Ne < xe / 2; Ne++) {
            var Et = Be[Ne];
            Be[Ne] = Be[xe - Ne - 1], Be[xe - Ne - 1] = Et, Et = ke[Ne], ke[Ne] = -ke[xe - Ne - 1], ke[xe - Ne - 1] = -Et;
          }
      }, Ie.prototype.normalize13b = function(Be, ke) {
        for (var xe = 0, Ne = 0; Ne < ke / 2; Ne++) {
          var Et = Math.round(Be[2 * Ne + 1] / ke) * 8192 + Math.round(Be[2 * Ne] / ke) + xe;
          Be[Ne] = Et & 67108863, Et < 67108864 ? xe = 0 : xe = Et / 67108864 | 0;
        }
        return Be;
      }, Ie.prototype.convert13b = function(Be, ke, xe, Ne) {
        for (var Et = 0, st = 0; st < ke; st++)
          Et = Et + (Be[st] | 0), xe[2 * st] = Et & 8191, Et = Et >>> 13, xe[2 * st + 1] = Et & 8191, Et = Et >>> 13;
        for (st = 2 * ke; st < Ne; ++st)
          xe[st] = 0;
        y(Et === 0), y((Et & -8192) === 0);
      }, Ie.prototype.stub = function(Be) {
        for (var ke = new Array(Be), xe = 0; xe < Be; xe++)
          ke[xe] = 0;
        return ke;
      }, Ie.prototype.mulp = function(Be, ke, xe) {
        var Ne = 2 * this.guessLen13b(Be.length, ke.length), Et = this.makeRBT(Ne), st = this.stub(Ne), Dt = new Array(Ne), er = new Array(Ne), xt = new Array(Ne), ir = new Array(Ne), sr = new Array(Ne), yr = new Array(Ne), wr = xe.words;
        wr.length = Ne, this.convert13b(Be.words, Be.length, Dt, Ne), this.convert13b(ke.words, ke.length, ir, Ne), this.transform(Dt, st, er, xt, Ne, Et), this.transform(ir, st, sr, yr, Ne, Et);
        for (var qr = 0; qr < Ne; qr++) {
          var Mr = er[qr] * sr[qr] - xt[qr] * yr[qr];
          xt[qr] = er[qr] * yr[qr] + xt[qr] * sr[qr], er[qr] = Mr;
        }
        return this.conjugate(er, xt, Ne), this.transform(er, xt, wr, st, Ne, Et), this.conjugate(wr, st, Ne), this.normalize13b(wr, Ne), xe.negative = Be.negative ^ ke.negative, xe.length = Be.length + ke.length, xe.strip();
      }, d.prototype.mul = function(Be) {
        var ke = new d(null);
        return ke.words = new Array(this.length + Be.length), this.mulTo(Be, ke);
      }, d.prototype.mulf = function(Be) {
        var ke = new d(null);
        return ke.words = new Array(this.length + Be.length), ge(this, Be, ke);
      }, d.prototype.imul = function(Be) {
        return this.clone().mulTo(Be, this);
      }, d.prototype.imuln = function(Be) {
        y(typeof Be == "number"), y(Be < 67108864);
        for (var ke = 0, xe = 0; xe < this.length; xe++) {
          var Ne = (this.words[xe] | 0) * Be, Et = (Ne & 67108863) + (ke & 67108863);
          ke >>= 26, ke += Ne / 67108864 | 0, ke += Et >>> 26, this.words[xe] = Et & 67108863;
        }
        return ke !== 0 && (this.words[xe] = ke, this.length++), this.length = Be === 0 ? 1 : this.length, this;
      }, d.prototype.muln = function(Be) {
        return this.clone().imuln(Be);
      }, d.prototype.sqr = function() {
        return this.mul(this);
      }, d.prototype.isqr = function() {
        return this.imul(this.clone());
      }, d.prototype.pow = function(Be) {
        var ke = U(Be);
        if (ke.length === 0) return new d(1);
        for (var xe = this, Ne = 0; Ne < ke.length && ke[Ne] === 0; Ne++, xe = xe.sqr())
          ;
        if (++Ne < ke.length)
          for (var Et = xe.sqr(); Ne < ke.length; Ne++, Et = Et.sqr())
            ke[Ne] !== 0 && (xe = xe.mul(Et));
        return xe;
      }, d.prototype.iushln = function(Be) {
        y(typeof Be == "number" && Be >= 0);
        var ke = Be % 26, xe = (Be - ke) / 26, Ne = 67108863 >>> 26 - ke << 26 - ke, Et;
        if (ke !== 0) {
          var st = 0;
          for (Et = 0; Et < this.length; Et++) {
            var Dt = this.words[Et] & Ne, er = (this.words[Et] | 0) - Dt << ke;
            this.words[Et] = er | st, st = Dt >>> 26 - ke;
          }
          st && (this.words[Et] = st, this.length++);
        }
        if (xe !== 0) {
          for (Et = this.length - 1; Et >= 0; Et--)
            this.words[Et + xe] = this.words[Et];
          for (Et = 0; Et < xe; Et++)
            this.words[Et] = 0;
          this.length += xe;
        }
        return this.strip();
      }, d.prototype.ishln = function(Be) {
        return y(this.negative === 0), this.iushln(Be);
      }, d.prototype.iushrn = function(Be, ke, xe) {
        y(typeof Be == "number" && Be >= 0);
        var Ne;
        ke ? Ne = (ke - ke % 26) / 26 : Ne = 0;
        var Et = Be % 26, st = Math.min((Be - Et) / 26, this.length), Dt = 67108863 ^ 67108863 >>> Et << Et, er = xe;
        if (Ne -= st, Ne = Math.max(0, Ne), er) {
          for (var xt = 0; xt < st; xt++)
            er.words[xt] = this.words[xt];
          er.length = st;
        }
        if (st !== 0) if (this.length > st)
          for (this.length -= st, xt = 0; xt < this.length; xt++)
            this.words[xt] = this.words[xt + st];
        else
          this.words[0] = 0, this.length = 1;
        var ir = 0;
        for (xt = this.length - 1; xt >= 0 && (ir !== 0 || xt >= Ne); xt--) {
          var sr = this.words[xt] | 0;
          this.words[xt] = ir << 26 - Et | sr >>> Et, ir = sr & Dt;
        }
        return er && ir !== 0 && (er.words[er.length++] = ir), this.length === 0 && (this.words[0] = 0, this.length = 1), this.strip();
      }, d.prototype.ishrn = function(Be, ke, xe) {
        return y(this.negative === 0), this.iushrn(Be, ke, xe);
      }, d.prototype.shln = function(Be) {
        return this.clone().ishln(Be);
      }, d.prototype.ushln = function(Be) {
        return this.clone().iushln(Be);
      }, d.prototype.shrn = function(Be) {
        return this.clone().ishrn(Be);
      }, d.prototype.ushrn = function(Be) {
        return this.clone().iushrn(Be);
      }, d.prototype.testn = function(Be) {
        y(typeof Be == "number" && Be >= 0);
        var ke = Be % 26, xe = (Be - ke) / 26, Ne = 1 << ke;
        if (this.length <= xe) return !1;
        var Et = this.words[xe];
        return !!(Et & Ne);
      }, d.prototype.imaskn = function(Be) {
        y(typeof Be == "number" && Be >= 0);
        var ke = Be % 26, xe = (Be - ke) / 26;
        if (y(this.negative === 0, "imaskn works only with positive numbers"), this.length <= xe)
          return this;
        if (ke !== 0 && xe++, this.length = Math.min(xe, this.length), ke !== 0) {
          var Ne = 67108863 ^ 67108863 >>> ke << ke;
          this.words[this.length - 1] &= Ne;
        }
        return this.strip();
      }, d.prototype.maskn = function(Be) {
        return this.clone().imaskn(Be);
      }, d.prototype.iaddn = function(Be) {
        return y(typeof Be == "number"), y(Be < 67108864), Be < 0 ? this.isubn(-Be) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) < Be ? (this.words[0] = Be - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(Be), this.negative = 1, this) : this._iaddn(Be);
      }, d.prototype._iaddn = function(Be) {
        this.words[0] += Be;
        for (var ke = 0; ke < this.length && this.words[ke] >= 67108864; ke++)
          this.words[ke] -= 67108864, ke === this.length - 1 ? this.words[ke + 1] = 1 : this.words[ke + 1]++;
        return this.length = Math.max(this.length, ke + 1), this;
      }, d.prototype.isubn = function(Be) {
        if (y(typeof Be == "number"), y(Be < 67108864), Be < 0) return this.iaddn(-Be);
        if (this.negative !== 0)
          return this.negative = 0, this.iaddn(Be), this.negative = 1, this;
        if (this.words[0] -= Be, this.length === 1 && this.words[0] < 0)
          this.words[0] = -this.words[0], this.negative = 1;
        else
          for (var ke = 0; ke < this.length && this.words[ke] < 0; ke++)
            this.words[ke] += 67108864, this.words[ke + 1] -= 1;
        return this.strip();
      }, d.prototype.addn = function(Be) {
        return this.clone().iaddn(Be);
      }, d.prototype.subn = function(Be) {
        return this.clone().isubn(Be);
      }, d.prototype.iabs = function() {
        return this.negative = 0, this;
      }, d.prototype.abs = function() {
        return this.clone().iabs();
      }, d.prototype._ishlnsubmul = function(Be, ke, xe) {
        var Ne = Be.length + xe, Et;
        this._expand(Ne);
        var st, Dt = 0;
        for (Et = 0; Et < Be.length; Et++) {
          st = (this.words[Et + xe] | 0) + Dt;
          var er = (Be.words[Et] | 0) * ke;
          st -= er & 67108863, Dt = (st >> 26) - (er / 67108864 | 0), this.words[Et + xe] = st & 67108863;
        }
        for (; Et < this.length - xe; Et++)
          st = (this.words[Et + xe] | 0) + Dt, Dt = st >> 26, this.words[Et + xe] = st & 67108863;
        if (Dt === 0) return this.strip();
        for (y(Dt === -1), Dt = 0, Et = 0; Et < this.length; Et++)
          st = -(this.words[Et] | 0) + Dt, Dt = st >> 26, this.words[Et] = st & 67108863;
        return this.negative = 1, this.strip();
      }, d.prototype._wordDiv = function(Be, ke) {
        var xe = this.length - Be.length, Ne = this.clone(), Et = Be, st = Et.words[Et.length - 1] | 0, Dt = this._countBits(st);
        xe = 26 - Dt, xe !== 0 && (Et = Et.ushln(xe), Ne.iushln(xe), st = Et.words[Et.length - 1] | 0);
        var er = Ne.length - Et.length, xt;
        if (ke !== "mod") {
          xt = new d(null), xt.length = er + 1, xt.words = new Array(xt.length);
          for (var ir = 0; ir < xt.length; ir++)
            xt.words[ir] = 0;
        }
        var sr = Ne.clone()._ishlnsubmul(Et, 1, er);
        sr.negative === 0 && (Ne = sr, xt && (xt.words[er] = 1));
        for (var yr = er - 1; yr >= 0; yr--) {
          var wr = (Ne.words[Et.length + yr] | 0) * 67108864 + (Ne.words[Et.length + yr - 1] | 0);
          for (wr = Math.min(wr / st | 0, 67108863), Ne._ishlnsubmul(Et, wr, yr); Ne.negative !== 0; )
            wr--, Ne.negative = 0, Ne._ishlnsubmul(Et, 1, yr), Ne.isZero() || (Ne.negative ^= 1);
          xt && (xt.words[yr] = wr);
        }
        return xt && xt.strip(), Ne.strip(), ke !== "div" && xe !== 0 && Ne.iushrn(xe), {
          div: xt || null,
          mod: Ne
        };
      }, d.prototype.divmod = function(Be, ke, xe) {
        if (y(!Be.isZero()), this.isZero())
          return {
            div: new d(0),
            mod: new d(0)
          };
        var Ne, Et, st;
        return this.negative !== 0 && Be.negative === 0 ? (st = this.neg().divmod(Be, ke), ke !== "mod" && (Ne = st.div.neg()), ke !== "div" && (Et = st.mod.neg(), xe && Et.negative !== 0 && Et.iadd(Be)), {
          div: Ne,
          mod: Et
        }) : this.negative === 0 && Be.negative !== 0 ? (st = this.divmod(Be.neg(), ke), ke !== "mod" && (Ne = st.div.neg()), {
          div: Ne,
          mod: st.mod
        }) : (this.negative & Be.negative) !== 0 ? (st = this.neg().divmod(Be.neg(), ke), ke !== "div" && (Et = st.mod.neg(), xe && Et.negative !== 0 && Et.isub(Be)), {
          div: st.div,
          mod: Et
        }) : Be.length > this.length || this.cmp(Be) < 0 ? {
          div: new d(0),
          mod: this
        } : Be.length === 1 ? ke === "div" ? {
          div: this.divn(Be.words[0]),
          mod: null
        } : ke === "mod" ? {
          div: null,
          mod: new d(this.modn(Be.words[0]))
        } : {
          div: this.divn(Be.words[0]),
          mod: new d(this.modn(Be.words[0]))
        } : this._wordDiv(Be, ke);
      }, d.prototype.div = function(Be) {
        return this.divmod(Be, "div", !1).div;
      }, d.prototype.mod = function(Be) {
        return this.divmod(Be, "mod", !1).mod;
      }, d.prototype.umod = function(Be) {
        return this.divmod(Be, "mod", !0).mod;
      }, d.prototype.divRound = function(Be) {
        var ke = this.divmod(Be);
        if (ke.mod.isZero()) return ke.div;
        var xe = ke.div.negative !== 0 ? ke.mod.isub(Be) : ke.mod, Ne = Be.ushrn(1), Et = Be.andln(1), st = xe.cmp(Ne);
        return st < 0 || Et === 1 && st === 0 ? ke.div : ke.div.negative !== 0 ? ke.div.isubn(1) : ke.div.iaddn(1);
      }, d.prototype.modn = function(Be) {
        y(Be <= 67108863);
        for (var ke = (1 << 26) % Be, xe = 0, Ne = this.length - 1; Ne >= 0; Ne--)
          xe = (ke * xe + (this.words[Ne] | 0)) % Be;
        return xe;
      }, d.prototype.idivn = function(Be) {
        y(Be <= 67108863);
        for (var ke = 0, xe = this.length - 1; xe >= 0; xe--) {
          var Ne = (this.words[xe] | 0) + ke * 67108864;
          this.words[xe] = Ne / Be | 0, ke = Ne % Be;
        }
        return this.strip();
      }, d.prototype.divn = function(Be) {
        return this.clone().idivn(Be);
      }, d.prototype.egcd = function(Be) {
        y(Be.negative === 0), y(!Be.isZero());
        var ke = this, xe = Be.clone();
        ke.negative !== 0 ? ke = ke.umod(Be) : ke = ke.clone();
        for (var Ne = new d(1), Et = new d(0), st = new d(0), Dt = new d(1), er = 0; ke.isEven() && xe.isEven(); )
          ke.iushrn(1), xe.iushrn(1), ++er;
        for (var xt = xe.clone(), ir = ke.clone(); !ke.isZero(); ) {
          for (var sr = 0, yr = 1; (ke.words[0] & yr) === 0 && sr < 26; ++sr, yr <<= 1) ;
          if (sr > 0)
            for (ke.iushrn(sr); sr-- > 0; )
              (Ne.isOdd() || Et.isOdd()) && (Ne.iadd(xt), Et.isub(ir)), Ne.iushrn(1), Et.iushrn(1);
          for (var wr = 0, qr = 1; (xe.words[0] & qr) === 0 && wr < 26; ++wr, qr <<= 1) ;
          if (wr > 0)
            for (xe.iushrn(wr); wr-- > 0; )
              (st.isOdd() || Dt.isOdd()) && (st.iadd(xt), Dt.isub(ir)), st.iushrn(1), Dt.iushrn(1);
          ke.cmp(xe) >= 0 ? (ke.isub(xe), Ne.isub(st), Et.isub(Dt)) : (xe.isub(ke), st.isub(Ne), Dt.isub(Et));
        }
        return {
          a: st,
          b: Dt,
          gcd: xe.iushln(er)
        };
      }, d.prototype._invmp = function(Be) {
        y(Be.negative === 0), y(!Be.isZero());
        var ke = this, xe = Be.clone();
        ke.negative !== 0 ? ke = ke.umod(Be) : ke = ke.clone();
        for (var Ne = new d(1), Et = new d(0), st = xe.clone(); ke.cmpn(1) > 0 && xe.cmpn(1) > 0; ) {
          for (var Dt = 0, er = 1; (ke.words[0] & er) === 0 && Dt < 26; ++Dt, er <<= 1) ;
          if (Dt > 0)
            for (ke.iushrn(Dt); Dt-- > 0; )
              Ne.isOdd() && Ne.iadd(st), Ne.iushrn(1);
          for (var xt = 0, ir = 1; (xe.words[0] & ir) === 0 && xt < 26; ++xt, ir <<= 1) ;
          if (xt > 0)
            for (xe.iushrn(xt); xt-- > 0; )
              Et.isOdd() && Et.iadd(st), Et.iushrn(1);
          ke.cmp(xe) >= 0 ? (ke.isub(xe), Ne.isub(Et)) : (xe.isub(ke), Et.isub(Ne));
        }
        var sr;
        return ke.cmpn(1) === 0 ? sr = Ne : sr = Et, sr.cmpn(0) < 0 && sr.iadd(Be), sr;
      }, d.prototype.gcd = function(Be) {
        if (this.isZero()) return Be.abs();
        if (Be.isZero()) return this.abs();
        var ke = this.clone(), xe = Be.clone();
        ke.negative = 0, xe.negative = 0;
        for (var Ne = 0; ke.isEven() && xe.isEven(); Ne++)
          ke.iushrn(1), xe.iushrn(1);
        do {
          for (; ke.isEven(); )
            ke.iushrn(1);
          for (; xe.isEven(); )
            xe.iushrn(1);
          var Et = ke.cmp(xe);
          if (Et < 0) {
            var st = ke;
            ke = xe, xe = st;
          } else if (Et === 0 || xe.cmpn(1) === 0)
            break;
          ke.isub(xe);
        } while (!0);
        return xe.iushln(Ne);
      }, d.prototype.invm = function(Be) {
        return this.egcd(Be).a.umod(Be);
      }, d.prototype.isEven = function() {
        return (this.words[0] & 1) === 0;
      }, d.prototype.isOdd = function() {
        return (this.words[0] & 1) === 1;
      }, d.prototype.andln = function(Be) {
        return this.words[0] & Be;
      }, d.prototype.bincn = function(Be) {
        y(typeof Be == "number");
        var ke = Be % 26, xe = (Be - ke) / 26, Ne = 1 << ke;
        if (this.length <= xe)
          return this._expand(xe + 1), this.words[xe] |= Ne, this;
        for (var Et = Ne, st = xe; Et !== 0 && st < this.length; st++) {
          var Dt = this.words[st] | 0;
          Dt += Et, Et = Dt >>> 26, Dt &= 67108863, this.words[st] = Dt;
        }
        return Et !== 0 && (this.words[st] = Et, this.length++), this;
      }, d.prototype.isZero = function() {
        return this.length === 1 && this.words[0] === 0;
      }, d.prototype.cmpn = function(Be) {
        var ke = Be < 0;
        if (this.negative !== 0 && !ke) return -1;
        if (this.negative === 0 && ke) return 1;
        this.strip();
        var xe;
        if (this.length > 1)
          xe = 1;
        else {
          ke && (Be = -Be), y(Be <= 67108863, "Number is too big");
          var Ne = this.words[0] | 0;
          xe = Ne === Be ? 0 : Ne < Be ? -1 : 1;
        }
        return this.negative !== 0 ? -xe | 0 : xe;
      }, d.prototype.cmp = function(Be) {
        if (this.negative !== 0 && Be.negative === 0) return -1;
        if (this.negative === 0 && Be.negative !== 0) return 1;
        var ke = this.ucmp(Be);
        return this.negative !== 0 ? -ke | 0 : ke;
      }, d.prototype.ucmp = function(Be) {
        if (this.length > Be.length) return 1;
        if (this.length < Be.length) return -1;
        for (var ke = 0, xe = this.length - 1; xe >= 0; xe--) {
          var Ne = this.words[xe] | 0, Et = Be.words[xe] | 0;
          if (Ne !== Et) {
            Ne < Et ? ke = -1 : Ne > Et && (ke = 1);
            break;
          }
        }
        return ke;
      }, d.prototype.gtn = function(Be) {
        return this.cmpn(Be) === 1;
      }, d.prototype.gt = function(Be) {
        return this.cmp(Be) === 1;
      }, d.prototype.gten = function(Be) {
        return this.cmpn(Be) >= 0;
      }, d.prototype.gte = function(Be) {
        return this.cmp(Be) >= 0;
      }, d.prototype.ltn = function(Be) {
        return this.cmpn(Be) === -1;
      }, d.prototype.lt = function(Be) {
        return this.cmp(Be) === -1;
      }, d.prototype.lten = function(Be) {
        return this.cmpn(Be) <= 0;
      }, d.prototype.lte = function(Be) {
        return this.cmp(Be) <= 0;
      }, d.prototype.eqn = function(Be) {
        return this.cmpn(Be) === 0;
      }, d.prototype.eq = function(Be) {
        return this.cmp(Be) === 0;
      }, d.red = function(Be) {
        return new ve(Be);
      }, d.prototype.toRed = function(Be) {
        return y(!this.red, "Already a number in reduction context"), y(this.negative === 0, "red works only with positives"), Be.convertTo(this)._forceRed(Be);
      }, d.prototype.fromRed = function() {
        return y(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
      }, d.prototype._forceRed = function(Be) {
        return this.red = Be, this;
      }, d.prototype.forceRed = function(Be) {
        return y(!this.red, "Already a number in reduction context"), this._forceRed(Be);
      }, d.prototype.redAdd = function(Be) {
        return y(this.red, "redAdd works only with red numbers"), this.red.add(this, Be);
      }, d.prototype.redIAdd = function(Be) {
        return y(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, Be);
      }, d.prototype.redSub = function(Be) {
        return y(this.red, "redSub works only with red numbers"), this.red.sub(this, Be);
      }, d.prototype.redISub = function(Be) {
        return y(this.red, "redISub works only with red numbers"), this.red.isub(this, Be);
      }, d.prototype.redShl = function(Be) {
        return y(this.red, "redShl works only with red numbers"), this.red.shl(this, Be);
      }, d.prototype.redMul = function(Be) {
        return y(this.red, "redMul works only with red numbers"), this.red._verify2(this, Be), this.red.mul(this, Be);
      }, d.prototype.redIMul = function(Be) {
        return y(this.red, "redMul works only with red numbers"), this.red._verify2(this, Be), this.red.imul(this, Be);
      }, d.prototype.redSqr = function() {
        return y(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
      }, d.prototype.redISqr = function() {
        return y(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
      }, d.prototype.redSqrt = function() {
        return y(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
      }, d.prototype.redInvm = function() {
        return y(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
      }, d.prototype.redNeg = function() {
        return y(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
      }, d.prototype.redPow = function(Be) {
        return y(this.red && !Be.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, Be);
      };
      var Ee = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
      };
      function Se(be, Be) {
        this.name = be, this.p = new d(Be, 16), this.n = this.p.bitLength(), this.k = new d(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
      }
      Se.prototype._tmp = function() {
        var Be = new d(null);
        return Be.words = new Array(Math.ceil(this.n / 13)), Be;
      }, Se.prototype.ireduce = function(Be) {
        var ke = Be, xe;
        do
          this.split(ke, this.tmp), ke = this.imulK(ke), ke = ke.iadd(this.tmp), xe = ke.bitLength();
        while (xe > this.n);
        var Ne = xe < this.n ? -1 : ke.ucmp(this.p);
        return Ne === 0 ? (ke.words[0] = 0, ke.length = 1) : Ne > 0 ? ke.isub(this.p) : ke.strip !== void 0 ? ke.strip() : ke._strip(), ke;
      }, Se.prototype.split = function(Be, ke) {
        Be.iushrn(this.n, 0, ke);
      }, Se.prototype.imulK = function(Be) {
        return Be.imul(this.k);
      };
      function ze() {
        Se.call(
          this,
          "k256",
          "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
        );
      }
      t(ze, Se), ze.prototype.split = function(Be, ke) {
        for (var xe = 4194303, Ne = Math.min(Be.length, 9), Et = 0; Et < Ne; Et++)
          ke.words[Et] = Be.words[Et];
        if (ke.length = Ne, Be.length <= 9) {
          Be.words[0] = 0, Be.length = 1;
          return;
        }
        var st = Be.words[9];
        for (ke.words[ke.length++] = st & xe, Et = 10; Et < Be.length; Et++) {
          var Dt = Be.words[Et] | 0;
          Be.words[Et - 10] = (Dt & xe) << 4 | st >>> 22, st = Dt;
        }
        st >>>= 22, Be.words[Et - 10] = st, st === 0 && Be.length > 10 ? Be.length -= 10 : Be.length -= 9;
      }, ze.prototype.imulK = function(Be) {
        Be.words[Be.length] = 0, Be.words[Be.length + 1] = 0, Be.length += 2;
        for (var ke = 0, xe = 0; xe < Be.length; xe++) {
          var Ne = Be.words[xe] | 0;
          ke += Ne * 977, Be.words[xe] = ke & 67108863, ke = Ne * 64 + (ke / 67108864 | 0);
        }
        return Be.words[Be.length - 1] === 0 && (Be.length--, Be.words[Be.length - 1] === 0 && Be.length--), Be;
      };
      function He() {
        Se.call(
          this,
          "p224",
          "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001"
        );
      }
      t(He, Se);
      function Pe() {
        Se.call(
          this,
          "p192",
          "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff"
        );
      }
      t(Pe, Se);
      function De() {
        Se.call(
          this,
          "25519",
          "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
        );
      }
      t(De, Se), De.prototype.imulK = function(Be) {
        for (var ke = 0, xe = 0; xe < Be.length; xe++) {
          var Ne = (Be.words[xe] | 0) * 19 + ke, Et = Ne & 67108863;
          Ne >>>= 26, Be.words[xe] = Et, ke = Ne;
        }
        return ke !== 0 && (Be.words[Be.length++] = ke), Be;
      }, d._prime = function(Be) {
        if (Ee[Be]) return Ee[Be];
        var ke;
        if (Be === "k256")
          ke = new ze();
        else if (Be === "p224")
          ke = new He();
        else if (Be === "p192")
          ke = new Pe();
        else if (Be === "p25519")
          ke = new De();
        else
          throw new Error("Unknown prime " + Be);
        return Ee[Be] = ke, ke;
      };
      function ve(be) {
        if (typeof be == "string") {
          var Be = d._prime(be);
          this.m = Be.p, this.prime = Be;
        } else
          y(be.gtn(1), "modulus must be greater than 1"), this.m = be, this.prime = null;
      }
      ve.prototype._verify1 = function(Be) {
        y(Be.negative === 0, "red works only with positives"), y(Be.red, "red works only with red numbers");
      }, ve.prototype._verify2 = function(Be, ke) {
        y((Be.negative | ke.negative) === 0, "red works only with positives"), y(
          Be.red && Be.red === ke.red,
          "red works only with red numbers"
        );
      }, ve.prototype.imod = function(Be) {
        return this.prime ? this.prime.ireduce(Be)._forceRed(this) : Be.umod(this.m)._forceRed(this);
      }, ve.prototype.neg = function(Be) {
        return Be.isZero() ? Be.clone() : this.m.sub(Be)._forceRed(this);
      }, ve.prototype.add = function(Be, ke) {
        this._verify2(Be, ke);
        var xe = Be.add(ke);
        return xe.cmp(this.m) >= 0 && xe.isub(this.m), xe._forceRed(this);
      }, ve.prototype.iadd = function(Be, ke) {
        this._verify2(Be, ke);
        var xe = Be.iadd(ke);
        return xe.cmp(this.m) >= 0 && xe.isub(this.m), xe;
      }, ve.prototype.sub = function(Be, ke) {
        this._verify2(Be, ke);
        var xe = Be.sub(ke);
        return xe.cmpn(0) < 0 && xe.iadd(this.m), xe._forceRed(this);
      }, ve.prototype.isub = function(Be, ke) {
        this._verify2(Be, ke);
        var xe = Be.isub(ke);
        return xe.cmpn(0) < 0 && xe.iadd(this.m), xe;
      }, ve.prototype.shl = function(Be, ke) {
        return this._verify1(Be), this.imod(Be.ushln(ke));
      }, ve.prototype.imul = function(Be, ke) {
        return this._verify2(Be, ke), this.imod(Be.imul(ke));
      }, ve.prototype.mul = function(Be, ke) {
        return this._verify2(Be, ke), this.imod(Be.mul(ke));
      }, ve.prototype.isqr = function(Be) {
        return this.imul(Be, Be.clone());
      }, ve.prototype.sqr = function(Be) {
        return this.mul(Be, Be);
      }, ve.prototype.sqrt = function(Be) {
        if (Be.isZero()) return Be.clone();
        var ke = this.m.andln(3);
        if (y(ke % 2 === 1), ke === 3) {
          var xe = this.m.add(new d(1)).iushrn(2);
          return this.pow(Be, xe);
        }
        for (var Ne = this.m.subn(1), Et = 0; !Ne.isZero() && Ne.andln(1) === 0; )
          Et++, Ne.iushrn(1);
        y(!Ne.isZero());
        var st = new d(1).toRed(this), Dt = st.redNeg(), er = this.m.subn(1).iushrn(1), xt = this.m.bitLength();
        for (xt = new d(2 * xt * xt).toRed(this); this.pow(xt, er).cmp(Dt) !== 0; )
          xt.redIAdd(Dt);
        for (var ir = this.pow(xt, Ne), sr = this.pow(Be, Ne.addn(1).iushrn(1)), yr = this.pow(Be, Ne), wr = Et; yr.cmp(st) !== 0; ) {
          for (var qr = yr, Mr = 0; qr.cmp(st) !== 0; Mr++)
            qr = qr.redSqr();
          y(Mr < wr);
          var Dr = this.pow(ir, new d(1).iushln(wr - Mr - 1));
          sr = sr.redMul(Dr), ir = Dr.redSqr(), yr = yr.redMul(ir), wr = Mr;
        }
        return sr;
      }, ve.prototype.invm = function(Be) {
        var ke = Be._invmp(this.m);
        return ke.negative !== 0 ? (ke.negative = 0, this.imod(ke).redNeg()) : this.imod(ke);
      }, ve.prototype.pow = function(Be, ke) {
        if (ke.isZero()) return new d(1).toRed(this);
        if (ke.cmpn(1) === 0) return Be.clone();
        var xe = 4, Ne = new Array(1 << xe);
        Ne[0] = new d(1).toRed(this), Ne[1] = Be;
        for (var Et = 2; Et < Ne.length; Et++)
          Ne[Et] = this.mul(Ne[Et - 1], Be);
        var st = Ne[0], Dt = 0, er = 0, xt = ke.bitLength() % 26;
        for (xt === 0 && (xt = 26), Et = ke.length - 1; Et >= 0; Et--) {
          for (var ir = ke.words[Et], sr = xt - 1; sr >= 0; sr--) {
            var yr = ir >> sr & 1;
            if (st !== Ne[0] && (st = this.sqr(st)), yr === 0 && Dt === 0) {
              er = 0;
              continue;
            }
            Dt <<= 1, Dt |= yr, er++, !(er !== xe && (Et !== 0 || sr !== 0)) && (st = this.mul(st, Ne[Dt]), er = 0, Dt = 0);
          }
          xt = 26;
        }
        return st;
      }, ve.prototype.convertTo = function(Be) {
        var ke = Be.umod(this.m);
        return ke === Be ? ke.clone() : ke;
      }, ve.prototype.convertFrom = function(Be) {
        var ke = Be.clone();
        return ke.red = null, ke;
      }, d.mont = function(Be) {
        return new Fe(Be);
      };
      function Fe(be) {
        ve.call(this, be), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new d(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
      }
      t(Fe, ve), Fe.prototype.convertTo = function(Be) {
        return this.imod(Be.ushln(this.shift));
      }, Fe.prototype.convertFrom = function(Be) {
        var ke = this.imod(Be.mul(this.rinv));
        return ke.red = null, ke;
      }, Fe.prototype.imul = function(Be, ke) {
        if (Be.isZero() || ke.isZero())
          return Be.words[0] = 0, Be.length = 1, Be;
        var xe = Be.imul(ke), Ne = xe.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), Et = xe.isub(Ne).iushrn(this.shift), st = Et;
        return Et.cmp(this.m) >= 0 ? st = Et.isub(this.m) : Et.cmpn(0) < 0 && (st = Et.iadd(this.m)), st._forceRed(this);
      }, Fe.prototype.mul = function(Be, ke) {
        if (Be.isZero() || ke.isZero()) return new d(0)._forceRed(this);
        var xe = Be.mul(ke), Ne = xe.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), Et = xe.isub(Ne).iushrn(this.shift), st = Et;
        return Et.cmp(this.m) >= 0 ? st = Et.isub(this.m) : Et.cmpn(0) < 0 && (st = Et.iadd(this.m)), st._forceRed(this);
      }, Fe.prototype.invm = function(Be) {
        var ke = this.imod(Be._invmp(this.m).mul(this.r2));
        return ke._forceRed(this);
      };
    })(o, bn$3);
  }(bn$4)), bn$4.exports;
}
var brorand = { exports: {} }, hasRequiredBrorand;
function requireBrorand() {
  if (hasRequiredBrorand) return brorand.exports;
  hasRequiredBrorand = 1;
  var o;
  brorand.exports = function(t) {
    return o || (o = new g(null)), o.generate(t);
  };
  function g(y) {
    this.rand = y;
  }
  if (brorand.exports.Rand = g, g.prototype.generate = function(t) {
    return this._rand(t);
  }, g.prototype._rand = function(t) {
    if (this.rand.getBytes)
      return this.rand.getBytes(t);
    for (var d = new Uint8Array(t), E = 0; E < d.length; E++)
      d[E] = this.rand.getByte();
    return d;
  }, typeof self == "object")
    self.crypto && self.crypto.getRandomValues ? g.prototype._rand = function(t) {
      var d = new Uint8Array(t);
      return self.crypto.getRandomValues(d), d;
    } : self.msCrypto && self.msCrypto.getRandomValues ? g.prototype._rand = function(t) {
      var d = new Uint8Array(t);
      return self.msCrypto.getRandomValues(d), d;
    } : typeof window == "object" && (g.prototype._rand = function() {
      throw new Error("Not implemented yet");
    });
  else
    try {
      var c = requireCryptoBrowserify();
      if (typeof c.randomBytes != "function")
        throw new Error("Not supported");
      g.prototype._rand = function(t) {
        return c.randomBytes(t);
      };
    } catch {
    }
  return brorand.exports;
}
var mr, hasRequiredMr;
function requireMr() {
  if (hasRequiredMr) return mr;
  hasRequiredMr = 1;
  var o = requireBn$1(), g = requireBrorand();
  function c(y) {
    this.rand = y || new g.Rand();
  }
  return mr = c, c.create = function(t) {
    return new c(t);
  }, c.prototype._randbelow = function(t) {
    var d = t.bitLength(), E = Math.ceil(d / 8);
    do
      var B = new o(this.rand.generate(E));
    while (B.cmp(t) >= 0);
    return B;
  }, c.prototype._randrange = function(t, d) {
    var E = d.sub(t);
    return t.add(this._randbelow(E));
  }, c.prototype.test = function(t, d, E) {
    var B = t.bitLength(), D = o.mont(t), x = new o(1).toRed(D);
    d || (d = Math.max(1, B / 48 | 0));
    for (var v = t.subn(1), F = 0; !v.testn(F); F++)
      ;
    for (var M = t.shrn(F), U = v.toRed(D), L = !0; d > 0; d--) {
      var H = this._randrange(new o(2), v);
      E && E(H);
      var fe = H.toRed(D).redPow(M);
      if (!(fe.cmp(x) === 0 || fe.cmp(U) === 0)) {
        for (var ge = 1; ge < F; ge++) {
          if (fe = fe.redSqr(), fe.cmp(x) === 0)
            return !1;
          if (fe.cmp(U) === 0)
            break;
        }
        if (ge === F)
          return !1;
      }
    }
    return L;
  }, c.prototype.getDivisor = function(t, d) {
    var E = t.bitLength(), B = o.mont(t), D = new o(1).toRed(B);
    d || (d = Math.max(1, E / 48 | 0));
    for (var x = t.subn(1), v = 0; !x.testn(v); v++)
      ;
    for (var F = t.shrn(v), M = x.toRed(B); d > 0; d--) {
      var U = this._randrange(new o(2), x), L = t.gcd(U);
      if (L.cmpn(1) !== 0)
        return L;
      var H = U.toRed(B).redPow(F);
      if (!(H.cmp(D) === 0 || H.cmp(M) === 0)) {
        for (var fe = 1; fe < v; fe++) {
          if (H = H.redSqr(), H.cmp(D) === 0)
            return H.fromRed().subn(1).gcd(t);
          if (H.cmp(M) === 0)
            break;
        }
        if (fe === v)
          return H = H.redSqr(), H.fromRed().subn(1).gcd(t);
      }
    }
    return !1;
  }, mr;
}
var generatePrime, hasRequiredGeneratePrime;
function requireGeneratePrime() {
  if (hasRequiredGeneratePrime) return generatePrime;
  hasRequiredGeneratePrime = 1;
  var o = requireBrowser$9();
  generatePrime = fe, fe.simpleSieve = L, fe.fermatTest = H;
  var g = requireBn$1(), c = new g(24), y = requireMr(), t = new y(), d = new g(1), E = new g(2), B = new g(5);
  new g(16), new g(8);
  var D = new g(10), x = new g(3);
  new g(7);
  var v = new g(11), F = new g(4);
  new g(12);
  var M = null;
  function U() {
    if (M !== null)
      return M;
    var ge = 1048576, Ie = [];
    Ie[0] = 2;
    for (var Ee = 1, Se = 3; Se < ge; Se += 2) {
      for (var ze = Math.ceil(Math.sqrt(Se)), He = 0; He < Ee && Ie[He] <= ze && Se % Ie[He] !== 0; He++)
        ;
      Ee !== He && Ie[He] <= ze || (Ie[Ee++] = Se);
    }
    return M = Ie, Ie;
  }
  function L(ge) {
    for (var Ie = U(), Ee = 0; Ee < Ie.length; Ee++)
      if (ge.modn(Ie[Ee]) === 0)
        return ge.cmpn(Ie[Ee]) === 0;
    return !0;
  }
  function H(ge) {
    var Ie = g.mont(ge);
    return E.toRed(Ie).redPow(ge.subn(1)).fromRed().cmpn(1) === 0;
  }
  function fe(ge, Ie) {
    if (ge < 16)
      return Ie === 2 || Ie === 5 ? new g([140, 123]) : new g([140, 39]);
    Ie = new g(Ie);
    for (var Ee, Se; ; ) {
      for (Ee = new g(o(Math.ceil(ge / 8))); Ee.bitLength() > ge; )
        Ee.ishrn(1);
      if (Ee.isEven() && Ee.iadd(d), Ee.testn(1) || Ee.iadd(E), Ie.cmp(E)) {
        if (!Ie.cmp(B))
          for (; Ee.mod(D).cmp(x); )
            Ee.iadd(F);
      } else for (; Ee.mod(c).cmp(v); )
        Ee.iadd(F);
      if (Se = Ee.shrn(1), L(Se) && L(Ee) && H(Se) && H(Ee) && t.test(Se) && t.test(Ee))
        return Ee;
    }
  }
  return generatePrime;
}
const modp1 = { gen: "02", prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff" }, modp2 = { gen: "02", prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff" }, modp5 = { gen: "02", prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff" }, modp14 = { gen: "02", prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff" }, modp15 = { gen: "02", prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff" }, modp16 = { gen: "02", prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff" }, modp17 = { gen: "02", prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff" }, modp18 = { gen: "02", prime: "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" }, require$$1$2 = {
  modp1,
  modp2,
  modp5,
  modp14,
  modp15,
  modp16,
  modp17,
  modp18
};
var dh, hasRequiredDh;
function requireDh() {
  if (hasRequiredDh) return dh;
  hasRequiredDh = 1;
  var o = requireBn$1(), g = requireMr(), c = new g(), y = new o(24), t = new o(11), d = new o(10), E = new o(3), B = new o(7), D = requireGeneratePrime(), x = requireBrowser$9();
  dh = L;
  function v(fe, ge) {
    return ge = ge || "utf8", Buffer.isBuffer(fe) || (fe = new Buffer(fe, ge)), this._pub = new o(fe), this;
  }
  function F(fe, ge) {
    return ge = ge || "utf8", Buffer.isBuffer(fe) || (fe = new Buffer(fe, ge)), this._priv = new o(fe), this;
  }
  var M = {};
  function U(fe, ge) {
    var Ie = ge.toString("hex"), Ee = [Ie, fe.toString(16)].join("_");
    if (Ee in M)
      return M[Ee];
    var Se = 0;
    if (fe.isEven() || !D.simpleSieve || !D.fermatTest(fe) || !c.test(fe))
      return Se += 1, Ie === "02" || Ie === "05" ? Se += 8 : Se += 4, M[Ee] = Se, Se;
    c.test(fe.shrn(1)) || (Se += 2);
    var ze;
    switch (Ie) {
      case "02":
        fe.mod(y).cmp(t) && (Se += 8);
        break;
      case "05":
        ze = fe.mod(d), ze.cmp(E) && ze.cmp(B) && (Se += 8);
        break;
      default:
        Se += 4;
    }
    return M[Ee] = Se, Se;
  }
  function L(fe, ge, Ie) {
    this.setGenerator(ge), this.__prime = new o(fe), this._prime = o.mont(this.__prime), this._primeLen = fe.length, this._pub = void 0, this._priv = void 0, this._primeCode = void 0, Ie ? (this.setPublicKey = v, this.setPrivateKey = F) : this._primeCode = 8;
  }
  Object.defineProperty(L.prototype, "verifyError", {
    enumerable: !0,
    get: function() {
      return typeof this._primeCode != "number" && (this._primeCode = U(this.__prime, this.__gen)), this._primeCode;
    }
  }), L.prototype.generateKeys = function() {
    return this._priv || (this._priv = new o(x(this._primeLen))), this._pub = this._gen.toRed(this._prime).redPow(this._priv).fromRed(), this.getPublicKey();
  }, L.prototype.computeSecret = function(fe) {
    fe = new o(fe), fe = fe.toRed(this._prime);
    var ge = fe.redPow(this._priv).fromRed(), Ie = new Buffer(ge.toArray()), Ee = this.getPrime();
    if (Ie.length < Ee.length) {
      var Se = new Buffer(Ee.length - Ie.length);
      Se.fill(0), Ie = Buffer.concat([Se, Ie]);
    }
    return Ie;
  }, L.prototype.getPublicKey = function(ge) {
    return H(this._pub, ge);
  }, L.prototype.getPrivateKey = function(ge) {
    return H(this._priv, ge);
  }, L.prototype.getPrime = function(fe) {
    return H(this.__prime, fe);
  }, L.prototype.getGenerator = function(fe) {
    return H(this._gen, fe);
  }, L.prototype.setGenerator = function(fe, ge) {
    return ge = ge || "utf8", Buffer.isBuffer(fe) || (fe = new Buffer(fe, ge)), this.__gen = fe, this._gen = new o(fe), this;
  };
  function H(fe, ge) {
    var Ie = new Buffer(fe.toArray());
    return ge ? Ie.toString(ge) : Ie;
  }
  return dh;
}
var hasRequiredBrowser$4;
function requireBrowser$4() {
  if (hasRequiredBrowser$4) return browser$4;
  hasRequiredBrowser$4 = 1;
  var o = requireGeneratePrime(), g = require$$1$2, c = requireDh();
  function y(E) {
    var B = new Buffer(g[E].prime, "hex"), D = new Buffer(g[E].gen, "hex");
    return new c(B, D);
  }
  var t = {
    binary: !0,
    hex: !0,
    base64: !0
  };
  function d(E, B, D, x) {
    return Buffer.isBuffer(B) || t[B] === void 0 ? d(E, "binary", B, D) : (B = B || "binary", x = x || "binary", D = D || new Buffer([2]), Buffer.isBuffer(D) || (D = new Buffer(D, x)), typeof E == "number" ? new c(o(E, D), D, !0) : (Buffer.isBuffer(E) || (E = new Buffer(E, B)), new c(E, D, !0)));
  }
  return browser$4.DiffieHellmanGroup = browser$4.createDiffieHellmanGroup = browser$4.getDiffieHellman = y, browser$4.createDiffieHellman = browser$4.DiffieHellman = d, browser$4;
}
var readableBrowser = { exports: {} }, processNextickArgs = { exports: {} }, hasRequiredProcessNextickArgs;
function requireProcessNextickArgs() {
  if (hasRequiredProcessNextickArgs) return processNextickArgs.exports;
  hasRequiredProcessNextickArgs = 1, typeof process$1 > "u" || !process$1.version || process$1.version.indexOf("v0.") === 0 || process$1.version.indexOf("v1.") === 0 && process$1.version.indexOf("v1.8.") !== 0 ? processNextickArgs.exports = { nextTick: o } : processNextickArgs.exports = process$1;
  function o(g, c, y, t) {
    if (typeof g != "function")
      throw new TypeError('"callback" argument must be a function');
    var d = arguments.length, E, B;
    switch (d) {
      case 0:
      case 1:
        return process$1.nextTick(g);
      case 2:
        return process$1.nextTick(function() {
          g.call(null, c);
        });
      case 3:
        return process$1.nextTick(function() {
          g.call(null, c, y);
        });
      case 4:
        return process$1.nextTick(function() {
          g.call(null, c, y, t);
        });
      default:
        for (E = new Array(d - 1), B = 0; B < E.length; )
          E[B++] = arguments[B];
        return process$1.nextTick(function() {
          g.apply(null, E);
        });
    }
  }
  return processNextickArgs.exports;
}
var isarray, hasRequiredIsarray;
function requireIsarray() {
  if (hasRequiredIsarray) return isarray;
  hasRequiredIsarray = 1;
  var o = {}.toString;
  return isarray = Array.isArray || function(g) {
    return o.call(g) == "[object Array]";
  }, isarray;
}
var streamBrowser, hasRequiredStreamBrowser;
function requireStreamBrowser() {
  return hasRequiredStreamBrowser || (hasRequiredStreamBrowser = 1, streamBrowser = requireEvents().EventEmitter), streamBrowser;
}
var safeBuffer = { exports: {} }, hasRequiredSafeBuffer;
function requireSafeBuffer() {
  return hasRequiredSafeBuffer || (hasRequiredSafeBuffer = 1, function(o, g) {
    var c = requireBuffer$2(), y = c.Buffer;
    function t(E, B) {
      for (var D in E)
        B[D] = E[D];
    }
    y.from && y.alloc && y.allocUnsafe && y.allocUnsafeSlow ? o.exports = c : (t(c, g), g.Buffer = d);
    function d(E, B, D) {
      return y(E, B, D);
    }
    t(y, d), d.from = function(E, B, D) {
      if (typeof E == "number")
        throw new TypeError("Argument must not be a number");
      return y(E, B, D);
    }, d.alloc = function(E, B, D) {
      if (typeof E != "number")
        throw new TypeError("Argument must be a number");
      var x = y(E);
      return B !== void 0 ? typeof D == "string" ? x.fill(B, D) : x.fill(B) : x.fill(0), x;
    }, d.allocUnsafe = function(E) {
      if (typeof E != "number")
        throw new TypeError("Argument must be a number");
      return y(E);
    }, d.allocUnsafeSlow = function(E) {
      if (typeof E != "number")
        throw new TypeError("Argument must be a number");
      return c.SlowBuffer(E);
    };
  }(safeBuffer, safeBuffer.exports)), safeBuffer.exports;
}
var util = {}, hasRequiredUtil;
function requireUtil() {
  if (hasRequiredUtil) return util;
  hasRequiredUtil = 1;
  function o(H) {
    return Array.isArray ? Array.isArray(H) : L(H) === "[object Array]";
  }
  util.isArray = o;
  function g(H) {
    return typeof H == "boolean";
  }
  util.isBoolean = g;
  function c(H) {
    return H === null;
  }
  util.isNull = c;
  function y(H) {
    return H == null;
  }
  util.isNullOrUndefined = y;
  function t(H) {
    return typeof H == "number";
  }
  util.isNumber = t;
  function d(H) {
    return typeof H == "string";
  }
  util.isString = d;
  function E(H) {
    return typeof H == "symbol";
  }
  util.isSymbol = E;
  function B(H) {
    return H === void 0;
  }
  util.isUndefined = B;
  function D(H) {
    return L(H) === "[object RegExp]";
  }
  util.isRegExp = D;
  function x(H) {
    return typeof H == "object" && H !== null;
  }
  util.isObject = x;
  function v(H) {
    return L(H) === "[object Date]";
  }
  util.isDate = v;
  function F(H) {
    return L(H) === "[object Error]" || H instanceof Error;
  }
  util.isError = F;
  function M(H) {
    return typeof H == "function";
  }
  util.isFunction = M;
  function U(H) {
    return H === null || typeof H == "boolean" || typeof H == "number" || typeof H == "string" || typeof H == "symbol" || // ES6 symbol
    typeof H > "u";
  }
  util.isPrimitive = U, util.isBuffer = requireBuffer$2().Buffer.isBuffer;
  function L(H) {
    return Object.prototype.toString.call(H);
  }
  return util;
}
var BufferList = { exports: {} }, hasRequiredBufferList;
function requireBufferList() {
  return hasRequiredBufferList || (hasRequiredBufferList = 1, function(o) {
    function g(d, E) {
      if (!(d instanceof E))
        throw new TypeError("Cannot call a class as a function");
    }
    var c = requireSafeBuffer().Buffer, y = require$$2$2;
    function t(d, E, B) {
      d.copy(E, B);
    }
    o.exports = function() {
      function d() {
        g(this, d), this.head = null, this.tail = null, this.length = 0;
      }
      return d.prototype.push = function(B) {
        var D = { data: B, next: null };
        this.length > 0 ? this.tail.next = D : this.head = D, this.tail = D, ++this.length;
      }, d.prototype.unshift = function(B) {
        var D = { data: B, next: this.head };
        this.length === 0 && (this.tail = D), this.head = D, ++this.length;
      }, d.prototype.shift = function() {
        if (this.length !== 0) {
          var B = this.head.data;
          return this.length === 1 ? this.head = this.tail = null : this.head = this.head.next, --this.length, B;
        }
      }, d.prototype.clear = function() {
        this.head = this.tail = null, this.length = 0;
      }, d.prototype.join = function(B) {
        if (this.length === 0) return "";
        for (var D = this.head, x = "" + D.data; D = D.next; )
          x += B + D.data;
        return x;
      }, d.prototype.concat = function(B) {
        if (this.length === 0) return c.alloc(0);
        for (var D = c.allocUnsafe(B >>> 0), x = this.head, v = 0; x; )
          t(x.data, D, v), v += x.data.length, x = x.next;
        return D;
      }, d;
    }(), y && y.inspect && y.inspect.custom && (o.exports.prototype[y.inspect.custom] = function() {
      var d = y.inspect({ length: this.length });
      return this.constructor.name + " " + d;
    });
  }(BufferList)), BufferList.exports;
}
var destroy_1, hasRequiredDestroy;
function requireDestroy() {
  if (hasRequiredDestroy) return destroy_1;
  hasRequiredDestroy = 1;
  var o = requireProcessNextickArgs();
  function g(t, d) {
    var E = this, B = this._readableState && this._readableState.destroyed, D = this._writableState && this._writableState.destroyed;
    return B || D ? (d ? d(t) : t && (this._writableState ? this._writableState.errorEmitted || (this._writableState.errorEmitted = !0, o.nextTick(y, this, t)) : o.nextTick(y, this, t)), this) : (this._readableState && (this._readableState.destroyed = !0), this._writableState && (this._writableState.destroyed = !0), this._destroy(t || null, function(x) {
      !d && x ? E._writableState ? E._writableState.errorEmitted || (E._writableState.errorEmitted = !0, o.nextTick(y, E, x)) : o.nextTick(y, E, x) : d && d(x);
    }), this);
  }
  function c() {
    this._readableState && (this._readableState.destroyed = !1, this._readableState.reading = !1, this._readableState.ended = !1, this._readableState.endEmitted = !1), this._writableState && (this._writableState.destroyed = !1, this._writableState.ended = !1, this._writableState.ending = !1, this._writableState.finalCalled = !1, this._writableState.prefinished = !1, this._writableState.finished = !1, this._writableState.errorEmitted = !1);
  }
  function y(t, d) {
    t.emit("error", d);
  }
  return destroy_1 = {
    destroy: g,
    undestroy: c
  }, destroy_1;
}
var _stream_writable, hasRequired_stream_writable;
function require_stream_writable() {
  if (hasRequired_stream_writable) return _stream_writable;
  hasRequired_stream_writable = 1;
  var o = requireProcessNextickArgs();
  _stream_writable = H;
  function g(st) {
    var Dt = this;
    this.next = null, this.entry = null, this.finish = function() {
      Et(Dt, st);
    };
  }
  var c = !process$1.browser && ["v0.10", "v0.9."].indexOf(process$1.version.slice(0, 5)) > -1 ? setImmediate : o.nextTick, y;
  H.WritableState = U;
  var t = Object.create(requireUtil());
  t.inherits = requireInherits_browser();
  var d = {
    deprecate: requireBrowser$b()
  }, E = requireStreamBrowser(), B = requireSafeBuffer().Buffer, D = (typeof commonjsGlobal < "u" ? commonjsGlobal : typeof window < "u" ? window : typeof self < "u" ? self : {}).Uint8Array || function() {
  };
  function x(st) {
    return B.from(st);
  }
  function v(st) {
    return B.isBuffer(st) || st instanceof D;
  }
  var F = requireDestroy();
  t.inherits(H, E);
  function M() {
  }
  function U(st, Dt) {
    y = y || require_stream_duplex(), st = st || {};
    var er = Dt instanceof y;
    this.objectMode = !!st.objectMode, er && (this.objectMode = this.objectMode || !!st.writableObjectMode);
    var xt = st.highWaterMark, ir = st.writableHighWaterMark, sr = this.objectMode ? 16 : 16 * 1024;
    xt || xt === 0 ? this.highWaterMark = xt : er && (ir || ir === 0) ? this.highWaterMark = ir : this.highWaterMark = sr, this.highWaterMark = Math.floor(this.highWaterMark), this.finalCalled = !1, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1, this.destroyed = !1;
    var yr = st.decodeStrings === !1;
    this.decodeStrings = !yr, this.defaultEncoding = st.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function(wr) {
      Pe(Dt, wr);
    }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = !1, this.errorEmitted = !1, this.bufferedRequestCount = 0, this.corkedRequestsFree = new g(this);
  }
  U.prototype.getBuffer = function() {
    for (var Dt = this.bufferedRequest, er = []; Dt; )
      er.push(Dt), Dt = Dt.next;
    return er;
  }, function() {
    try {
      Object.defineProperty(U.prototype, "buffer", {
        get: d.deprecate(function() {
          return this.getBuffer();
        }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
      });
    } catch {
    }
  }();
  var L;
  typeof Symbol == "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] == "function" ? (L = Function.prototype[Symbol.hasInstance], Object.defineProperty(H, Symbol.hasInstance, {
    value: function(st) {
      return L.call(this, st) ? !0 : this !== H ? !1 : st && st._writableState instanceof U;
    }
  })) : L = function(st) {
    return st instanceof this;
  };
  function H(st) {
    if (y = y || require_stream_duplex(), !L.call(H, this) && !(this instanceof y))
      return new H(st);
    this._writableState = new U(st, this), this.writable = !0, st && (typeof st.write == "function" && (this._write = st.write), typeof st.writev == "function" && (this._writev = st.writev), typeof st.destroy == "function" && (this._destroy = st.destroy), typeof st.final == "function" && (this._final = st.final)), E.call(this);
  }
  H.prototype.pipe = function() {
    this.emit("error", new Error("Cannot pipe, not readable"));
  };
  function fe(st, Dt) {
    var er = new Error("write after end");
    st.emit("error", er), o.nextTick(Dt, er);
  }
  function ge(st, Dt, er, xt) {
    var ir = !0, sr = !1;
    return er === null ? sr = new TypeError("May not write null values to stream") : typeof er != "string" && er !== void 0 && !Dt.objectMode && (sr = new TypeError("Invalid non-string/buffer chunk")), sr && (st.emit("error", sr), o.nextTick(xt, sr), ir = !1), ir;
  }
  H.prototype.write = function(st, Dt, er) {
    var xt = this._writableState, ir = !1, sr = !xt.objectMode && v(st);
    return sr && !B.isBuffer(st) && (st = x(st)), typeof Dt == "function" && (er = Dt, Dt = null), sr ? Dt = "buffer" : Dt || (Dt = xt.defaultEncoding), typeof er != "function" && (er = M), xt.ended ? fe(this, er) : (sr || ge(this, xt, st, er)) && (xt.pendingcb++, ir = Ee(this, xt, sr, st, Dt, er)), ir;
  }, H.prototype.cork = function() {
    var st = this._writableState;
    st.corked++;
  }, H.prototype.uncork = function() {
    var st = this._writableState;
    st.corked && (st.corked--, !st.writing && !st.corked && !st.bufferProcessing && st.bufferedRequest && Fe(this, st));
  }, H.prototype.setDefaultEncoding = function(Dt) {
    if (typeof Dt == "string" && (Dt = Dt.toLowerCase()), !(["hex", "utf8", "utf-8", "ascii", "binary", "base64", "ucs2", "ucs-2", "utf16le", "utf-16le", "raw"].indexOf((Dt + "").toLowerCase()) > -1)) throw new TypeError("Unknown encoding: " + Dt);
    return this._writableState.defaultEncoding = Dt, this;
  };
  function Ie(st, Dt, er) {
    return !st.objectMode && st.decodeStrings !== !1 && typeof Dt == "string" && (Dt = B.from(Dt, er)), Dt;
  }
  Object.defineProperty(H.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.highWaterMark;
    }
  });
  function Ee(st, Dt, er, xt, ir, sr) {
    if (!er) {
      var yr = Ie(Dt, xt, ir);
      xt !== yr && (er = !0, ir = "buffer", xt = yr);
    }
    var wr = Dt.objectMode ? 1 : xt.length;
    Dt.length += wr;
    var qr = Dt.length < Dt.highWaterMark;
    if (qr || (Dt.needDrain = !0), Dt.writing || Dt.corked) {
      var Mr = Dt.lastBufferedRequest;
      Dt.lastBufferedRequest = {
        chunk: xt,
        encoding: ir,
        isBuf: er,
        callback: sr,
        next: null
      }, Mr ? Mr.next = Dt.lastBufferedRequest : Dt.bufferedRequest = Dt.lastBufferedRequest, Dt.bufferedRequestCount += 1;
    } else
      Se(st, Dt, !1, wr, xt, ir, sr);
    return qr;
  }
  function Se(st, Dt, er, xt, ir, sr, yr) {
    Dt.writelen = xt, Dt.writecb = yr, Dt.writing = !0, Dt.sync = !0, er ? st._writev(ir, Dt.onwrite) : st._write(ir, sr, Dt.onwrite), Dt.sync = !1;
  }
  function ze(st, Dt, er, xt, ir) {
    --Dt.pendingcb, er ? (o.nextTick(ir, xt), o.nextTick(xe, st, Dt), st._writableState.errorEmitted = !0, st.emit("error", xt)) : (ir(xt), st._writableState.errorEmitted = !0, st.emit("error", xt), xe(st, Dt));
  }
  function He(st) {
    st.writing = !1, st.writecb = null, st.length -= st.writelen, st.writelen = 0;
  }
  function Pe(st, Dt) {
    var er = st._writableState, xt = er.sync, ir = er.writecb;
    if (He(er), Dt) ze(st, er, xt, Dt, ir);
    else {
      var sr = be(er);
      !sr && !er.corked && !er.bufferProcessing && er.bufferedRequest && Fe(st, er), xt ? c(De, st, er, sr, ir) : De(st, er, sr, ir);
    }
  }
  function De(st, Dt, er, xt) {
    er || ve(st, Dt), Dt.pendingcb--, xt(), xe(st, Dt);
  }
  function ve(st, Dt) {
    Dt.length === 0 && Dt.needDrain && (Dt.needDrain = !1, st.emit("drain"));
  }
  function Fe(st, Dt) {
    Dt.bufferProcessing = !0;
    var er = Dt.bufferedRequest;
    if (st._writev && er && er.next) {
      var xt = Dt.bufferedRequestCount, ir = new Array(xt), sr = Dt.corkedRequestsFree;
      sr.entry = er;
      for (var yr = 0, wr = !0; er; )
        ir[yr] = er, er.isBuf || (wr = !1), er = er.next, yr += 1;
      ir.allBuffers = wr, Se(st, Dt, !0, Dt.length, ir, "", sr.finish), Dt.pendingcb++, Dt.lastBufferedRequest = null, sr.next ? (Dt.corkedRequestsFree = sr.next, sr.next = null) : Dt.corkedRequestsFree = new g(Dt), Dt.bufferedRequestCount = 0;
    } else {
      for (; er; ) {
        var qr = er.chunk, Mr = er.encoding, Dr = er.callback, Qr = Dt.objectMode ? 1 : qr.length;
        if (Se(st, Dt, !1, Qr, qr, Mr, Dr), er = er.next, Dt.bufferedRequestCount--, Dt.writing)
          break;
      }
      er === null && (Dt.lastBufferedRequest = null);
    }
    Dt.bufferedRequest = er, Dt.bufferProcessing = !1;
  }
  H.prototype._write = function(st, Dt, er) {
    er(new Error("_write() is not implemented"));
  }, H.prototype._writev = null, H.prototype.end = function(st, Dt, er) {
    var xt = this._writableState;
    typeof st == "function" ? (er = st, st = null, Dt = null) : typeof Dt == "function" && (er = Dt, Dt = null), st != null && this.write(st, Dt), xt.corked && (xt.corked = 1, this.uncork()), xt.ending || Ne(this, xt, er);
  };
  function be(st) {
    return st.ending && st.length === 0 && st.bufferedRequest === null && !st.finished && !st.writing;
  }
  function Be(st, Dt) {
    st._final(function(er) {
      Dt.pendingcb--, er && st.emit("error", er), Dt.prefinished = !0, st.emit("prefinish"), xe(st, Dt);
    });
  }
  function ke(st, Dt) {
    !Dt.prefinished && !Dt.finalCalled && (typeof st._final == "function" ? (Dt.pendingcb++, Dt.finalCalled = !0, o.nextTick(Be, st, Dt)) : (Dt.prefinished = !0, st.emit("prefinish")));
  }
  function xe(st, Dt) {
    var er = be(Dt);
    return er && (ke(st, Dt), Dt.pendingcb === 0 && (Dt.finished = !0, st.emit("finish"))), er;
  }
  function Ne(st, Dt, er) {
    Dt.ending = !0, xe(st, Dt), er && (Dt.finished ? o.nextTick(er) : st.once("finish", er)), Dt.ended = !0, st.writable = !1;
  }
  function Et(st, Dt, er) {
    var xt = st.entry;
    for (st.entry = null; xt; ) {
      var ir = xt.callback;
      Dt.pendingcb--, ir(er), xt = xt.next;
    }
    Dt.corkedRequestsFree.next = st;
  }
  return Object.defineProperty(H.prototype, "destroyed", {
    get: function() {
      return this._writableState === void 0 ? !1 : this._writableState.destroyed;
    },
    set: function(st) {
      this._writableState && (this._writableState.destroyed = st);
    }
  }), H.prototype.destroy = F.destroy, H.prototype._undestroy = F.undestroy, H.prototype._destroy = function(st, Dt) {
    this.end(), Dt(st);
  }, _stream_writable;
}
var _stream_duplex, hasRequired_stream_duplex;
function require_stream_duplex() {
  if (hasRequired_stream_duplex) return _stream_duplex;
  hasRequired_stream_duplex = 1;
  var o = requireProcessNextickArgs(), g = Object.keys || function(F) {
    var M = [];
    for (var U in F)
      M.push(U);
    return M;
  };
  _stream_duplex = D;
  var c = Object.create(requireUtil());
  c.inherits = requireInherits_browser();
  var y = require_stream_readable(), t = require_stream_writable();
  c.inherits(D, y);
  for (var d = g(t.prototype), E = 0; E < d.length; E++) {
    var B = d[E];
    D.prototype[B] || (D.prototype[B] = t.prototype[B]);
  }
  function D(F) {
    if (!(this instanceof D)) return new D(F);
    y.call(this, F), t.call(this, F), F && F.readable === !1 && (this.readable = !1), F && F.writable === !1 && (this.writable = !1), this.allowHalfOpen = !0, F && F.allowHalfOpen === !1 && (this.allowHalfOpen = !1), this.once("end", x);
  }
  Object.defineProperty(D.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.highWaterMark;
    }
  });
  function x() {
    this.allowHalfOpen || this._writableState.ended || o.nextTick(v, this);
  }
  function v(F) {
    F.end();
  }
  return Object.defineProperty(D.prototype, "destroyed", {
    get: function() {
      return this._readableState === void 0 || this._writableState === void 0 ? !1 : this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function(F) {
      this._readableState === void 0 || this._writableState === void 0 || (this._readableState.destroyed = F, this._writableState.destroyed = F);
    }
  }), D.prototype._destroy = function(F, M) {
    this.push(null), this.end(), o.nextTick(M, F);
  }, _stream_duplex;
}
var string_decoder = {}, hasRequiredString_decoder;
function requireString_decoder() {
  if (hasRequiredString_decoder) return string_decoder;
  hasRequiredString_decoder = 1;
  var o = requireSafeBuffer().Buffer, g = o.isEncoding || function(ge) {
    switch (ge = "" + ge, ge && ge.toLowerCase()) {
      case "hex":
      case "utf8":
      case "utf-8":
      case "ascii":
      case "binary":
      case "base64":
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
      case "raw":
        return !0;
      default:
        return !1;
    }
  };
  function c(ge) {
    if (!ge) return "utf8";
    for (var Ie; ; )
      switch (ge) {
        case "utf8":
        case "utf-8":
          return "utf8";
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return "utf16le";
        case "latin1":
        case "binary":
          return "latin1";
        case "base64":
        case "ascii":
        case "hex":
          return ge;
        default:
          if (Ie) return;
          ge = ("" + ge).toLowerCase(), Ie = !0;
      }
  }
  function y(ge) {
    var Ie = c(ge);
    if (typeof Ie != "string" && (o.isEncoding === g || !g(ge))) throw new Error("Unknown encoding: " + ge);
    return Ie || ge;
  }
  string_decoder.StringDecoder = t;
  function t(ge) {
    this.encoding = y(ge);
    var Ie;
    switch (this.encoding) {
      case "utf16le":
        this.text = F, this.end = M, Ie = 4;
        break;
      case "utf8":
        this.fillLast = D, Ie = 4;
        break;
      case "base64":
        this.text = U, this.end = L, Ie = 3;
        break;
      default:
        this.write = H, this.end = fe;
        return;
    }
    this.lastNeed = 0, this.lastTotal = 0, this.lastChar = o.allocUnsafe(Ie);
  }
  t.prototype.write = function(ge) {
    if (ge.length === 0) return "";
    var Ie, Ee;
    if (this.lastNeed) {
      if (Ie = this.fillLast(ge), Ie === void 0) return "";
      Ee = this.lastNeed, this.lastNeed = 0;
    } else
      Ee = 0;
    return Ee < ge.length ? Ie ? Ie + this.text(ge, Ee) : this.text(ge, Ee) : Ie || "";
  }, t.prototype.end = v, t.prototype.text = x, t.prototype.fillLast = function(ge) {
    if (this.lastNeed <= ge.length)
      return ge.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
    ge.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, ge.length), this.lastNeed -= ge.length;
  };
  function d(ge) {
    return ge <= 127 ? 0 : ge >> 5 === 6 ? 2 : ge >> 4 === 14 ? 3 : ge >> 3 === 30 ? 4 : ge >> 6 === 2 ? -1 : -2;
  }
  function E(ge, Ie, Ee) {
    var Se = Ie.length - 1;
    if (Se < Ee) return 0;
    var ze = d(Ie[Se]);
    return ze >= 0 ? (ze > 0 && (ge.lastNeed = ze - 1), ze) : --Se < Ee || ze === -2 ? 0 : (ze = d(Ie[Se]), ze >= 0 ? (ze > 0 && (ge.lastNeed = ze - 2), ze) : --Se < Ee || ze === -2 ? 0 : (ze = d(Ie[Se]), ze >= 0 ? (ze > 0 && (ze === 2 ? ze = 0 : ge.lastNeed = ze - 3), ze) : 0));
  }
  function B(ge, Ie, Ee) {
    if ((Ie[0] & 192) !== 128)
      return ge.lastNeed = 0, "�";
    if (ge.lastNeed > 1 && Ie.length > 1) {
      if ((Ie[1] & 192) !== 128)
        return ge.lastNeed = 1, "�";
      if (ge.lastNeed > 2 && Ie.length > 2 && (Ie[2] & 192) !== 128)
        return ge.lastNeed = 2, "�";
    }
  }
  function D(ge) {
    var Ie = this.lastTotal - this.lastNeed, Ee = B(this, ge);
    if (Ee !== void 0) return Ee;
    if (this.lastNeed <= ge.length)
      return ge.copy(this.lastChar, Ie, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
    ge.copy(this.lastChar, Ie, 0, ge.length), this.lastNeed -= ge.length;
  }
  function x(ge, Ie) {
    var Ee = E(this, ge, Ie);
    if (!this.lastNeed) return ge.toString("utf8", Ie);
    this.lastTotal = Ee;
    var Se = ge.length - (Ee - this.lastNeed);
    return ge.copy(this.lastChar, 0, Se), ge.toString("utf8", Ie, Se);
  }
  function v(ge) {
    var Ie = ge && ge.length ? this.write(ge) : "";
    return this.lastNeed ? Ie + "�" : Ie;
  }
  function F(ge, Ie) {
    if ((ge.length - Ie) % 2 === 0) {
      var Ee = ge.toString("utf16le", Ie);
      if (Ee) {
        var Se = Ee.charCodeAt(Ee.length - 1);
        if (Se >= 55296 && Se <= 56319)
          return this.lastNeed = 2, this.lastTotal = 4, this.lastChar[0] = ge[ge.length - 2], this.lastChar[1] = ge[ge.length - 1], Ee.slice(0, -1);
      }
      return Ee;
    }
    return this.lastNeed = 1, this.lastTotal = 2, this.lastChar[0] = ge[ge.length - 1], ge.toString("utf16le", Ie, ge.length - 1);
  }
  function M(ge) {
    var Ie = ge && ge.length ? this.write(ge) : "";
    if (this.lastNeed) {
      var Ee = this.lastTotal - this.lastNeed;
      return Ie + this.lastChar.toString("utf16le", 0, Ee);
    }
    return Ie;
  }
  function U(ge, Ie) {
    var Ee = (ge.length - Ie) % 3;
    return Ee === 0 ? ge.toString("base64", Ie) : (this.lastNeed = 3 - Ee, this.lastTotal = 3, Ee === 1 ? this.lastChar[0] = ge[ge.length - 1] : (this.lastChar[0] = ge[ge.length - 2], this.lastChar[1] = ge[ge.length - 1]), ge.toString("base64", Ie, ge.length - Ee));
  }
  function L(ge) {
    var Ie = ge && ge.length ? this.write(ge) : "";
    return this.lastNeed ? Ie + this.lastChar.toString("base64", 0, 3 - this.lastNeed) : Ie;
  }
  function H(ge) {
    return ge.toString(this.encoding);
  }
  function fe(ge) {
    return ge && ge.length ? this.write(ge) : "";
  }
  return string_decoder;
}
var _stream_readable, hasRequired_stream_readable;
function require_stream_readable() {
  if (hasRequired_stream_readable) return _stream_readable;
  hasRequired_stream_readable = 1;
  var o = requireProcessNextickArgs();
  _stream_readable = Ie;
  var g = requireIsarray(), c;
  Ie.ReadableState = ge, requireEvents().EventEmitter;
  var y = function(Dr, Qr) {
    return Dr.listeners(Qr).length;
  }, t = requireStreamBrowser(), d = requireSafeBuffer().Buffer, E = (typeof commonjsGlobal < "u" ? commonjsGlobal : typeof window < "u" ? window : typeof self < "u" ? self : {}).Uint8Array || function() {
  };
  function B(Dr) {
    return d.from(Dr);
  }
  function D(Dr) {
    return d.isBuffer(Dr) || Dr instanceof E;
  }
  var x = Object.create(requireUtil());
  x.inherits = requireInherits_browser();
  var v = require$$2$2, F = void 0;
  v && v.debuglog ? F = v.debuglog("stream") : F = function() {
  };
  var M = requireBufferList(), U = requireDestroy(), L;
  x.inherits(Ie, t);
  var H = ["error", "close", "destroy", "pause", "resume"];
  function fe(Dr, Qr, Xr) {
    if (typeof Dr.prependListener == "function") return Dr.prependListener(Qr, Xr);
    !Dr._events || !Dr._events[Qr] ? Dr.on(Qr, Xr) : g(Dr._events[Qr]) ? Dr._events[Qr].unshift(Xr) : Dr._events[Qr] = [Xr, Dr._events[Qr]];
  }
  function ge(Dr, Qr) {
    c = c || require_stream_duplex(), Dr = Dr || {};
    var Xr = Qr instanceof c;
    this.objectMode = !!Dr.objectMode, Xr && (this.objectMode = this.objectMode || !!Dr.readableObjectMode);
    var Vr = Dr.highWaterMark, Ur = Dr.readableHighWaterMark, Sr = this.objectMode ? 16 : 16 * 1024;
    Vr || Vr === 0 ? this.highWaterMark = Vr : Xr && (Ur || Ur === 0) ? this.highWaterMark = Ur : this.highWaterMark = Sr, this.highWaterMark = Math.floor(this.highWaterMark), this.buffer = new M(), this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.resumeScheduled = !1, this.destroyed = !1, this.defaultEncoding = Dr.defaultEncoding || "utf8", this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, Dr.encoding && (L || (L = requireString_decoder().StringDecoder), this.decoder = new L(Dr.encoding), this.encoding = Dr.encoding);
  }
  function Ie(Dr) {
    if (c = c || require_stream_duplex(), !(this instanceof Ie)) return new Ie(Dr);
    this._readableState = new ge(Dr, this), this.readable = !0, Dr && (typeof Dr.read == "function" && (this._read = Dr.read), typeof Dr.destroy == "function" && (this._destroy = Dr.destroy)), t.call(this);
  }
  Object.defineProperty(Ie.prototype, "destroyed", {
    get: function() {
      return this._readableState === void 0 ? !1 : this._readableState.destroyed;
    },
    set: function(Dr) {
      this._readableState && (this._readableState.destroyed = Dr);
    }
  }), Ie.prototype.destroy = U.destroy, Ie.prototype._undestroy = U.undestroy, Ie.prototype._destroy = function(Dr, Qr) {
    this.push(null), Qr(Dr);
  }, Ie.prototype.push = function(Dr, Qr) {
    var Xr = this._readableState, Vr;
    return Xr.objectMode ? Vr = !0 : typeof Dr == "string" && (Qr = Qr || Xr.defaultEncoding, Qr !== Xr.encoding && (Dr = d.from(Dr, Qr), Qr = ""), Vr = !0), Ee(this, Dr, Qr, !1, Vr);
  }, Ie.prototype.unshift = function(Dr) {
    return Ee(this, Dr, null, !0, !1);
  };
  function Ee(Dr, Qr, Xr, Vr, Ur) {
    var Sr = Dr._readableState;
    if (Qr === null)
      Sr.reading = !1, Fe(Dr, Sr);
    else {
      var Gr;
      Ur || (Gr = ze(Sr, Qr)), Gr ? Dr.emit("error", Gr) : Sr.objectMode || Qr && Qr.length > 0 ? (typeof Qr != "string" && !Sr.objectMode && Object.getPrototypeOf(Qr) !== d.prototype && (Qr = B(Qr)), Vr ? Sr.endEmitted ? Dr.emit("error", new Error("stream.unshift() after end event")) : Se(Dr, Sr, Qr, !0) : Sr.ended ? Dr.emit("error", new Error("stream.push() after EOF")) : (Sr.reading = !1, Sr.decoder && !Xr ? (Qr = Sr.decoder.write(Qr), Sr.objectMode || Qr.length !== 0 ? Se(Dr, Sr, Qr, !1) : ke(Dr, Sr)) : Se(Dr, Sr, Qr, !1))) : Vr || (Sr.reading = !1);
    }
    return He(Sr);
  }
  function Se(Dr, Qr, Xr, Vr) {
    Qr.flowing && Qr.length === 0 && !Qr.sync ? (Dr.emit("data", Xr), Dr.read(0)) : (Qr.length += Qr.objectMode ? 1 : Xr.length, Vr ? Qr.buffer.unshift(Xr) : Qr.buffer.push(Xr), Qr.needReadable && be(Dr)), ke(Dr, Qr);
  }
  function ze(Dr, Qr) {
    var Xr;
    return !D(Qr) && typeof Qr != "string" && Qr !== void 0 && !Dr.objectMode && (Xr = new TypeError("Invalid non-string/buffer chunk")), Xr;
  }
  function He(Dr) {
    return !Dr.ended && (Dr.needReadable || Dr.length < Dr.highWaterMark || Dr.length === 0);
  }
  Ie.prototype.isPaused = function() {
    return this._readableState.flowing === !1;
  }, Ie.prototype.setEncoding = function(Dr) {
    return L || (L = requireString_decoder().StringDecoder), this._readableState.decoder = new L(Dr), this._readableState.encoding = Dr, this;
  };
  var Pe = 8388608;
  function De(Dr) {
    return Dr >= Pe ? Dr = Pe : (Dr--, Dr |= Dr >>> 1, Dr |= Dr >>> 2, Dr |= Dr >>> 4, Dr |= Dr >>> 8, Dr |= Dr >>> 16, Dr++), Dr;
  }
  function ve(Dr, Qr) {
    return Dr <= 0 || Qr.length === 0 && Qr.ended ? 0 : Qr.objectMode ? 1 : Dr !== Dr ? Qr.flowing && Qr.length ? Qr.buffer.head.data.length : Qr.length : (Dr > Qr.highWaterMark && (Qr.highWaterMark = De(Dr)), Dr <= Qr.length ? Dr : Qr.ended ? Qr.length : (Qr.needReadable = !0, 0));
  }
  Ie.prototype.read = function(Dr) {
    F("read", Dr), Dr = parseInt(Dr, 10);
    var Qr = this._readableState, Xr = Dr;
    if (Dr !== 0 && (Qr.emittedReadable = !1), Dr === 0 && Qr.needReadable && (Qr.length >= Qr.highWaterMark || Qr.ended))
      return F("read: emitReadable", Qr.length, Qr.ended), Qr.length === 0 && Qr.ended ? wr(this) : be(this), null;
    if (Dr = ve(Dr, Qr), Dr === 0 && Qr.ended)
      return Qr.length === 0 && wr(this), null;
    var Vr = Qr.needReadable;
    F("need readable", Vr), (Qr.length === 0 || Qr.length - Dr < Qr.highWaterMark) && (Vr = !0, F("length less than watermark", Vr)), Qr.ended || Qr.reading ? (Vr = !1, F("reading or ended", Vr)) : Vr && (F("do read"), Qr.reading = !0, Qr.sync = !0, Qr.length === 0 && (Qr.needReadable = !0), this._read(Qr.highWaterMark), Qr.sync = !1, Qr.reading || (Dr = ve(Xr, Qr)));
    var Ur;
    return Dr > 0 ? Ur = xt(Dr, Qr) : Ur = null, Ur === null ? (Qr.needReadable = !0, Dr = 0) : Qr.length -= Dr, Qr.length === 0 && (Qr.ended || (Qr.needReadable = !0), Xr !== Dr && Qr.ended && wr(this)), Ur !== null && this.emit("data", Ur), Ur;
  };
  function Fe(Dr, Qr) {
    if (!Qr.ended) {
      if (Qr.decoder) {
        var Xr = Qr.decoder.end();
        Xr && Xr.length && (Qr.buffer.push(Xr), Qr.length += Qr.objectMode ? 1 : Xr.length);
      }
      Qr.ended = !0, be(Dr);
    }
  }
  function be(Dr) {
    var Qr = Dr._readableState;
    Qr.needReadable = !1, Qr.emittedReadable || (F("emitReadable", Qr.flowing), Qr.emittedReadable = !0, Qr.sync ? o.nextTick(Be, Dr) : Be(Dr));
  }
  function Be(Dr) {
    F("emit readable"), Dr.emit("readable"), er(Dr);
  }
  function ke(Dr, Qr) {
    Qr.readingMore || (Qr.readingMore = !0, o.nextTick(xe, Dr, Qr));
  }
  function xe(Dr, Qr) {
    for (var Xr = Qr.length; !Qr.reading && !Qr.flowing && !Qr.ended && Qr.length < Qr.highWaterMark && (F("maybeReadMore read 0"), Dr.read(0), Xr !== Qr.length); )
      Xr = Qr.length;
    Qr.readingMore = !1;
  }
  Ie.prototype._read = function(Dr) {
    this.emit("error", new Error("_read() is not implemented"));
  }, Ie.prototype.pipe = function(Dr, Qr) {
    var Xr = this, Vr = this._readableState;
    switch (Vr.pipesCount) {
      case 0:
        Vr.pipes = Dr;
        break;
      case 1:
        Vr.pipes = [Vr.pipes, Dr];
        break;
      default:
        Vr.pipes.push(Dr);
        break;
    }
    Vr.pipesCount += 1, F("pipe count=%d opts=%j", Vr.pipesCount, Qr);
    var Ur = (!Qr || Qr.end !== !1) && Dr !== process$1.stdout && Dr !== process$1.stderr, Sr = Ur ? Fr : oi;
    Vr.endEmitted ? o.nextTick(Sr) : Xr.once("end", Sr), Dr.on("unpipe", Gr);
    function Gr(zr, ti) {
      F("onunpipe"), zr === Xr && ti && ti.hasUnpiped === !1 && (ti.hasUnpiped = !0, cr());
    }
    function Fr() {
      F("onend"), Dr.end();
    }
    var br = Ne(Xr);
    Dr.on("drain", br);
    var Ar = !1;
    function cr() {
      F("cleanup"), Dr.removeListener("close", Bi), Dr.removeListener("finish", $r), Dr.removeListener("drain", br), Dr.removeListener("error", fi), Dr.removeListener("unpipe", Gr), Xr.removeListener("end", Fr), Xr.removeListener("end", oi), Xr.removeListener("data", Wr), Ar = !0, Vr.awaitDrain && (!Dr._writableState || Dr._writableState.needDrain) && br();
    }
    var hr = !1;
    Xr.on("data", Wr);
    function Wr(zr) {
      F("ondata"), hr = !1;
      var ti = Dr.write(zr);
      ti === !1 && !hr && ((Vr.pipesCount === 1 && Vr.pipes === Dr || Vr.pipesCount > 1 && Mr(Vr.pipes, Dr) !== -1) && !Ar && (F("false write response, pause", Vr.awaitDrain), Vr.awaitDrain++, hr = !0), Xr.pause());
    }
    function fi(zr) {
      F("onerror", zr), oi(), Dr.removeListener("error", fi), y(Dr, "error") === 0 && Dr.emit("error", zr);
    }
    fe(Dr, "error", fi);
    function Bi() {
      Dr.removeListener("finish", $r), oi();
    }
    Dr.once("close", Bi);
    function $r() {
      F("onfinish"), Dr.removeListener("close", Bi), oi();
    }
    Dr.once("finish", $r);
    function oi() {
      F("unpipe"), Xr.unpipe(Dr);
    }
    return Dr.emit("pipe", Xr), Vr.flowing || (F("pipe resume"), Xr.resume()), Dr;
  };
  function Ne(Dr) {
    return function() {
      var Qr = Dr._readableState;
      F("pipeOnDrain", Qr.awaitDrain), Qr.awaitDrain && Qr.awaitDrain--, Qr.awaitDrain === 0 && y(Dr, "data") && (Qr.flowing = !0, er(Dr));
    };
  }
  Ie.prototype.unpipe = function(Dr) {
    var Qr = this._readableState, Xr = { hasUnpiped: !1 };
    if (Qr.pipesCount === 0) return this;
    if (Qr.pipesCount === 1)
      return Dr && Dr !== Qr.pipes ? this : (Dr || (Dr = Qr.pipes), Qr.pipes = null, Qr.pipesCount = 0, Qr.flowing = !1, Dr && Dr.emit("unpipe", this, Xr), this);
    if (!Dr) {
      var Vr = Qr.pipes, Ur = Qr.pipesCount;
      Qr.pipes = null, Qr.pipesCount = 0, Qr.flowing = !1;
      for (var Sr = 0; Sr < Ur; Sr++)
        Vr[Sr].emit("unpipe", this, { hasUnpiped: !1 });
      return this;
    }
    var Gr = Mr(Qr.pipes, Dr);
    return Gr === -1 ? this : (Qr.pipes.splice(Gr, 1), Qr.pipesCount -= 1, Qr.pipesCount === 1 && (Qr.pipes = Qr.pipes[0]), Dr.emit("unpipe", this, Xr), this);
  }, Ie.prototype.on = function(Dr, Qr) {
    var Xr = t.prototype.on.call(this, Dr, Qr);
    if (Dr === "data")
      this._readableState.flowing !== !1 && this.resume();
    else if (Dr === "readable") {
      var Vr = this._readableState;
      !Vr.endEmitted && !Vr.readableListening && (Vr.readableListening = Vr.needReadable = !0, Vr.emittedReadable = !1, Vr.reading ? Vr.length && be(this) : o.nextTick(Et, this));
    }
    return Xr;
  }, Ie.prototype.addListener = Ie.prototype.on;
  function Et(Dr) {
    F("readable nexttick read 0"), Dr.read(0);
  }
  Ie.prototype.resume = function() {
    var Dr = this._readableState;
    return Dr.flowing || (F("resume"), Dr.flowing = !0, st(this, Dr)), this;
  };
  function st(Dr, Qr) {
    Qr.resumeScheduled || (Qr.resumeScheduled = !0, o.nextTick(Dt, Dr, Qr));
  }
  function Dt(Dr, Qr) {
    Qr.reading || (F("resume read 0"), Dr.read(0)), Qr.resumeScheduled = !1, Qr.awaitDrain = 0, Dr.emit("resume"), er(Dr), Qr.flowing && !Qr.reading && Dr.read(0);
  }
  Ie.prototype.pause = function() {
    return F("call pause flowing=%j", this._readableState.flowing), this._readableState.flowing !== !1 && (F("pause"), this._readableState.flowing = !1, this.emit("pause")), this;
  };
  function er(Dr) {
    var Qr = Dr._readableState;
    for (F("flow", Qr.flowing); Qr.flowing && Dr.read() !== null; )
      ;
  }
  Ie.prototype.wrap = function(Dr) {
    var Qr = this, Xr = this._readableState, Vr = !1;
    Dr.on("end", function() {
      if (F("wrapped end"), Xr.decoder && !Xr.ended) {
        var Gr = Xr.decoder.end();
        Gr && Gr.length && Qr.push(Gr);
      }
      Qr.push(null);
    }), Dr.on("data", function(Gr) {
      if (F("wrapped data"), Xr.decoder && (Gr = Xr.decoder.write(Gr)), !(Xr.objectMode && Gr == null) && !(!Xr.objectMode && (!Gr || !Gr.length))) {
        var Fr = Qr.push(Gr);
        Fr || (Vr = !0, Dr.pause());
      }
    });
    for (var Ur in Dr)
      this[Ur] === void 0 && typeof Dr[Ur] == "function" && (this[Ur] = /* @__PURE__ */ function(Gr) {
        return function() {
          return Dr[Gr].apply(Dr, arguments);
        };
      }(Ur));
    for (var Sr = 0; Sr < H.length; Sr++)
      Dr.on(H[Sr], this.emit.bind(this, H[Sr]));
    return this._read = function(Gr) {
      F("wrapped _read", Gr), Vr && (Vr = !1, Dr.resume());
    }, this;
  }, Object.defineProperty(Ie.prototype, "readableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState.highWaterMark;
    }
  }), Ie._fromList = xt;
  function xt(Dr, Qr) {
    if (Qr.length === 0) return null;
    var Xr;
    return Qr.objectMode ? Xr = Qr.buffer.shift() : !Dr || Dr >= Qr.length ? (Qr.decoder ? Xr = Qr.buffer.join("") : Qr.buffer.length === 1 ? Xr = Qr.buffer.head.data : Xr = Qr.buffer.concat(Qr.length), Qr.buffer.clear()) : Xr = ir(Dr, Qr.buffer, Qr.decoder), Xr;
  }
  function ir(Dr, Qr, Xr) {
    var Vr;
    return Dr < Qr.head.data.length ? (Vr = Qr.head.data.slice(0, Dr), Qr.head.data = Qr.head.data.slice(Dr)) : Dr === Qr.head.data.length ? Vr = Qr.shift() : Vr = Xr ? sr(Dr, Qr) : yr(Dr, Qr), Vr;
  }
  function sr(Dr, Qr) {
    var Xr = Qr.head, Vr = 1, Ur = Xr.data;
    for (Dr -= Ur.length; Xr = Xr.next; ) {
      var Sr = Xr.data, Gr = Dr > Sr.length ? Sr.length : Dr;
      if (Gr === Sr.length ? Ur += Sr : Ur += Sr.slice(0, Dr), Dr -= Gr, Dr === 0) {
        Gr === Sr.length ? (++Vr, Xr.next ? Qr.head = Xr.next : Qr.head = Qr.tail = null) : (Qr.head = Xr, Xr.data = Sr.slice(Gr));
        break;
      }
      ++Vr;
    }
    return Qr.length -= Vr, Ur;
  }
  function yr(Dr, Qr) {
    var Xr = d.allocUnsafe(Dr), Vr = Qr.head, Ur = 1;
    for (Vr.data.copy(Xr), Dr -= Vr.data.length; Vr = Vr.next; ) {
      var Sr = Vr.data, Gr = Dr > Sr.length ? Sr.length : Dr;
      if (Sr.copy(Xr, Xr.length - Dr, 0, Gr), Dr -= Gr, Dr === 0) {
        Gr === Sr.length ? (++Ur, Vr.next ? Qr.head = Vr.next : Qr.head = Qr.tail = null) : (Qr.head = Vr, Vr.data = Sr.slice(Gr));
        break;
      }
      ++Ur;
    }
    return Qr.length -= Ur, Xr;
  }
  function wr(Dr) {
    var Qr = Dr._readableState;
    if (Qr.length > 0) throw new Error('"endReadable()" called on non-empty stream');
    Qr.endEmitted || (Qr.ended = !0, o.nextTick(qr, Qr, Dr));
  }
  function qr(Dr, Qr) {
    !Dr.endEmitted && Dr.length === 0 && (Dr.endEmitted = !0, Qr.readable = !1, Qr.emit("end"));
  }
  function Mr(Dr, Qr) {
    for (var Xr = 0, Vr = Dr.length; Xr < Vr; Xr++)
      if (Dr[Xr] === Qr) return Xr;
    return -1;
  }
  return _stream_readable;
}
var _stream_transform, hasRequired_stream_transform;
function require_stream_transform() {
  if (hasRequired_stream_transform) return _stream_transform;
  hasRequired_stream_transform = 1, _stream_transform = y;
  var o = require_stream_duplex(), g = Object.create(requireUtil());
  g.inherits = requireInherits_browser(), g.inherits(y, o);
  function c(E, B) {
    var D = this._transformState;
    D.transforming = !1;
    var x = D.writecb;
    if (!x)
      return this.emit("error", new Error("write callback called multiple times"));
    D.writechunk = null, D.writecb = null, B != null && this.push(B), x(E);
    var v = this._readableState;
    v.reading = !1, (v.needReadable || v.length < v.highWaterMark) && this._read(v.highWaterMark);
  }
  function y(E) {
    if (!(this instanceof y)) return new y(E);
    o.call(this, E), this._transformState = {
      afterTransform: c.bind(this),
      needTransform: !1,
      transforming: !1,
      writecb: null,
      writechunk: null,
      writeencoding: null
    }, this._readableState.needReadable = !0, this._readableState.sync = !1, E && (typeof E.transform == "function" && (this._transform = E.transform), typeof E.flush == "function" && (this._flush = E.flush)), this.on("prefinish", t);
  }
  function t() {
    var E = this;
    typeof this._flush == "function" ? this._flush(function(B, D) {
      d(E, B, D);
    }) : d(this, null, null);
  }
  y.prototype.push = function(E, B) {
    return this._transformState.needTransform = !1, o.prototype.push.call(this, E, B);
  }, y.prototype._transform = function(E, B, D) {
    throw new Error("_transform() is not implemented");
  }, y.prototype._write = function(E, B, D) {
    var x = this._transformState;
    if (x.writecb = D, x.writechunk = E, x.writeencoding = B, !x.transforming) {
      var v = this._readableState;
      (x.needTransform || v.needReadable || v.length < v.highWaterMark) && this._read(v.highWaterMark);
    }
  }, y.prototype._read = function(E) {
    var B = this._transformState;
    B.writechunk !== null && B.writecb && !B.transforming ? (B.transforming = !0, this._transform(B.writechunk, B.writeencoding, B.afterTransform)) : B.needTransform = !0;
  }, y.prototype._destroy = function(E, B) {
    var D = this;
    o.prototype._destroy.call(this, E, function(x) {
      B(x), D.emit("close");
    });
  };
  function d(E, B, D) {
    if (B) return E.emit("error", B);
    if (D != null && E.push(D), E._writableState.length) throw new Error("Calling transform done when ws.length != 0");
    if (E._transformState.transforming) throw new Error("Calling transform done when still transforming");
    return E.push(null);
  }
  return _stream_transform;
}
var _stream_passthrough, hasRequired_stream_passthrough;
function require_stream_passthrough() {
  if (hasRequired_stream_passthrough) return _stream_passthrough;
  hasRequired_stream_passthrough = 1, _stream_passthrough = c;
  var o = require_stream_transform(), g = Object.create(requireUtil());
  g.inherits = requireInherits_browser(), g.inherits(c, o);
  function c(y) {
    if (!(this instanceof c)) return new c(y);
    o.call(this, y);
  }
  return c.prototype._transform = function(y, t, d) {
    d(null, y);
  }, _stream_passthrough;
}
var hasRequiredReadableBrowser;
function requireReadableBrowser() {
  return hasRequiredReadableBrowser || (hasRequiredReadableBrowser = 1, function(o, g) {
    g = o.exports = require_stream_readable(), g.Stream = g, g.Readable = g, g.Writable = require_stream_writable(), g.Duplex = require_stream_duplex(), g.Transform = require_stream_transform(), g.PassThrough = require_stream_passthrough();
  }(readableBrowser, readableBrowser.exports)), readableBrowser.exports;
}
var sign$2 = { exports: {} }, bn$2 = { exports: {} }, bn$1 = bn$2.exports, hasRequiredBn;
function requireBn() {
  return hasRequiredBn || (hasRequiredBn = 1, function(o) {
    (function(g, c) {
      function y(ke, xe) {
        if (!ke) throw new Error(xe || "Assertion failed");
      }
      function t(ke, xe) {
        ke.super_ = xe;
        var Ne = function() {
        };
        Ne.prototype = xe.prototype, ke.prototype = new Ne(), ke.prototype.constructor = ke;
      }
      function d(ke, xe, Ne) {
        if (d.isBN(ke))
          return ke;
        this.negative = 0, this.words = null, this.length = 0, this.red = null, ke !== null && ((xe === "le" || xe === "be") && (Ne = xe, xe = 10), this._init(ke || 0, xe || 10, Ne || "be"));
      }
      typeof g == "object" ? g.exports = d : c.BN = d, d.BN = d, d.wordSize = 26;
      var E;
      try {
        typeof window < "u" && typeof window.Buffer < "u" ? E = window.Buffer : E = require$$2$2.Buffer;
      } catch {
      }
      d.isBN = function(xe) {
        return xe instanceof d ? !0 : xe !== null && typeof xe == "object" && xe.constructor.wordSize === d.wordSize && Array.isArray(xe.words);
      }, d.max = function(xe, Ne) {
        return xe.cmp(Ne) > 0 ? xe : Ne;
      }, d.min = function(xe, Ne) {
        return xe.cmp(Ne) < 0 ? xe : Ne;
      }, d.prototype._init = function(xe, Ne, Et) {
        if (typeof xe == "number")
          return this._initNumber(xe, Ne, Et);
        if (typeof xe == "object")
          return this._initArray(xe, Ne, Et);
        Ne === "hex" && (Ne = 16), y(Ne === (Ne | 0) && Ne >= 2 && Ne <= 36), xe = xe.toString().replace(/\s+/g, "");
        var st = 0;
        xe[0] === "-" && (st++, this.negative = 1), st < xe.length && (Ne === 16 ? this._parseHex(xe, st, Et) : (this._parseBase(xe, Ne, st), Et === "le" && this._initArray(this.toArray(), Ne, Et)));
      }, d.prototype._initNumber = function(xe, Ne, Et) {
        xe < 0 && (this.negative = 1, xe = -xe), xe < 67108864 ? (this.words = [xe & 67108863], this.length = 1) : xe < 4503599627370496 ? (this.words = [
          xe & 67108863,
          xe / 67108864 & 67108863
        ], this.length = 2) : (y(xe < 9007199254740992), this.words = [
          xe & 67108863,
          xe / 67108864 & 67108863,
          1
        ], this.length = 3), Et === "le" && this._initArray(this.toArray(), Ne, Et);
      }, d.prototype._initArray = function(xe, Ne, Et) {
        if (y(typeof xe.length == "number"), xe.length <= 0)
          return this.words = [0], this.length = 1, this;
        this.length = Math.ceil(xe.length / 3), this.words = new Array(this.length);
        for (var st = 0; st < this.length; st++)
          this.words[st] = 0;
        var Dt, er, xt = 0;
        if (Et === "be")
          for (st = xe.length - 1, Dt = 0; st >= 0; st -= 3)
            er = xe[st] | xe[st - 1] << 8 | xe[st - 2] << 16, this.words[Dt] |= er << xt & 67108863, this.words[Dt + 1] = er >>> 26 - xt & 67108863, xt += 24, xt >= 26 && (xt -= 26, Dt++);
        else if (Et === "le")
          for (st = 0, Dt = 0; st < xe.length; st += 3)
            er = xe[st] | xe[st + 1] << 8 | xe[st + 2] << 16, this.words[Dt] |= er << xt & 67108863, this.words[Dt + 1] = er >>> 26 - xt & 67108863, xt += 24, xt >= 26 && (xt -= 26, Dt++);
        return this._strip();
      };
      function B(ke, xe) {
        var Ne = ke.charCodeAt(xe);
        if (Ne >= 48 && Ne <= 57)
          return Ne - 48;
        if (Ne >= 65 && Ne <= 70)
          return Ne - 55;
        if (Ne >= 97 && Ne <= 102)
          return Ne - 87;
        y(!1, "Invalid character in " + ke);
      }
      function D(ke, xe, Ne) {
        var Et = B(ke, Ne);
        return Ne - 1 >= xe && (Et |= B(ke, Ne - 1) << 4), Et;
      }
      d.prototype._parseHex = function(xe, Ne, Et) {
        this.length = Math.ceil((xe.length - Ne) / 6), this.words = new Array(this.length);
        for (var st = 0; st < this.length; st++)
          this.words[st] = 0;
        var Dt = 0, er = 0, xt;
        if (Et === "be")
          for (st = xe.length - 1; st >= Ne; st -= 2)
            xt = D(xe, Ne, st) << Dt, this.words[er] |= xt & 67108863, Dt >= 18 ? (Dt -= 18, er += 1, this.words[er] |= xt >>> 26) : Dt += 8;
        else {
          var ir = xe.length - Ne;
          for (st = ir % 2 === 0 ? Ne + 1 : Ne; st < xe.length; st += 2)
            xt = D(xe, Ne, st) << Dt, this.words[er] |= xt & 67108863, Dt >= 18 ? (Dt -= 18, er += 1, this.words[er] |= xt >>> 26) : Dt += 8;
        }
        this._strip();
      };
      function x(ke, xe, Ne, Et) {
        for (var st = 0, Dt = 0, er = Math.min(ke.length, Ne), xt = xe; xt < er; xt++) {
          var ir = ke.charCodeAt(xt) - 48;
          st *= Et, ir >= 49 ? Dt = ir - 49 + 10 : ir >= 17 ? Dt = ir - 17 + 10 : Dt = ir, y(ir >= 0 && Dt < Et, "Invalid character"), st += Dt;
        }
        return st;
      }
      d.prototype._parseBase = function(xe, Ne, Et) {
        this.words = [0], this.length = 1;
        for (var st = 0, Dt = 1; Dt <= 67108863; Dt *= Ne)
          st++;
        st--, Dt = Dt / Ne | 0;
        for (var er = xe.length - Et, xt = er % st, ir = Math.min(er, er - xt) + Et, sr = 0, yr = Et; yr < ir; yr += st)
          sr = x(xe, yr, yr + st, Ne), this.imuln(Dt), this.words[0] + sr < 67108864 ? this.words[0] += sr : this._iaddn(sr);
        if (xt !== 0) {
          var wr = 1;
          for (sr = x(xe, yr, xe.length, Ne), yr = 0; yr < xt; yr++)
            wr *= Ne;
          this.imuln(wr), this.words[0] + sr < 67108864 ? this.words[0] += sr : this._iaddn(sr);
        }
        this._strip();
      }, d.prototype.copy = function(xe) {
        xe.words = new Array(this.length);
        for (var Ne = 0; Ne < this.length; Ne++)
          xe.words[Ne] = this.words[Ne];
        xe.length = this.length, xe.negative = this.negative, xe.red = this.red;
      };
      function v(ke, xe) {
        ke.words = xe.words, ke.length = xe.length, ke.negative = xe.negative, ke.red = xe.red;
      }
      if (d.prototype._move = function(xe) {
        v(xe, this);
      }, d.prototype.clone = function() {
        var xe = new d(null);
        return this.copy(xe), xe;
      }, d.prototype._expand = function(xe) {
        for (; this.length < xe; )
          this.words[this.length++] = 0;
        return this;
      }, d.prototype._strip = function() {
        for (; this.length > 1 && this.words[this.length - 1] === 0; )
          this.length--;
        return this._normSign();
      }, d.prototype._normSign = function() {
        return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
      }, typeof Symbol < "u" && typeof Symbol.for == "function")
        try {
          d.prototype[Symbol.for("nodejs.util.inspect.custom")] = F;
        } catch {
          d.prototype.inspect = F;
        }
      else
        d.prototype.inspect = F;
      function F() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
      }
      var M = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
      ], U = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
      ], L = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        1e7,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64e6,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        243e5,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
      ];
      d.prototype.toString = function(xe, Ne) {
        xe = xe || 10, Ne = Ne | 0 || 1;
        var Et;
        if (xe === 16 || xe === "hex") {
          Et = "";
          for (var st = 0, Dt = 0, er = 0; er < this.length; er++) {
            var xt = this.words[er], ir = ((xt << st | Dt) & 16777215).toString(16);
            Dt = xt >>> 24 - st & 16777215, st += 2, st >= 26 && (st -= 26, er--), Dt !== 0 || er !== this.length - 1 ? Et = M[6 - ir.length] + ir + Et : Et = ir + Et;
          }
          for (Dt !== 0 && (Et = Dt.toString(16) + Et); Et.length % Ne !== 0; )
            Et = "0" + Et;
          return this.negative !== 0 && (Et = "-" + Et), Et;
        }
        if (xe === (xe | 0) && xe >= 2 && xe <= 36) {
          var sr = U[xe], yr = L[xe];
          Et = "";
          var wr = this.clone();
          for (wr.negative = 0; !wr.isZero(); ) {
            var qr = wr.modrn(yr).toString(xe);
            wr = wr.idivn(yr), wr.isZero() ? Et = qr + Et : Et = M[sr - qr.length] + qr + Et;
          }
          for (this.isZero() && (Et = "0" + Et); Et.length % Ne !== 0; )
            Et = "0" + Et;
          return this.negative !== 0 && (Et = "-" + Et), Et;
        }
        y(!1, "Base should be between 2 and 36");
      }, d.prototype.toNumber = function() {
        var xe = this.words[0];
        return this.length === 2 ? xe += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? xe += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && y(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -xe : xe;
      }, d.prototype.toJSON = function() {
        return this.toString(16, 2);
      }, E && (d.prototype.toBuffer = function(xe, Ne) {
        return this.toArrayLike(E, xe, Ne);
      }), d.prototype.toArray = function(xe, Ne) {
        return this.toArrayLike(Array, xe, Ne);
      };
      var H = function(xe, Ne) {
        return xe.allocUnsafe ? xe.allocUnsafe(Ne) : new xe(Ne);
      };
      d.prototype.toArrayLike = function(xe, Ne, Et) {
        this._strip();
        var st = this.byteLength(), Dt = Et || Math.max(1, st);
        y(st <= Dt, "byte array longer than desired length"), y(Dt > 0, "Requested array length <= 0");
        var er = H(xe, Dt), xt = Ne === "le" ? "LE" : "BE";
        return this["_toArrayLike" + xt](er, st), er;
      }, d.prototype._toArrayLikeLE = function(xe, Ne) {
        for (var Et = 0, st = 0, Dt = 0, er = 0; Dt < this.length; Dt++) {
          var xt = this.words[Dt] << er | st;
          xe[Et++] = xt & 255, Et < xe.length && (xe[Et++] = xt >> 8 & 255), Et < xe.length && (xe[Et++] = xt >> 16 & 255), er === 6 ? (Et < xe.length && (xe[Et++] = xt >> 24 & 255), st = 0, er = 0) : (st = xt >>> 24, er += 2);
        }
        if (Et < xe.length)
          for (xe[Et++] = st; Et < xe.length; )
            xe[Et++] = 0;
      }, d.prototype._toArrayLikeBE = function(xe, Ne) {
        for (var Et = xe.length - 1, st = 0, Dt = 0, er = 0; Dt < this.length; Dt++) {
          var xt = this.words[Dt] << er | st;
          xe[Et--] = xt & 255, Et >= 0 && (xe[Et--] = xt >> 8 & 255), Et >= 0 && (xe[Et--] = xt >> 16 & 255), er === 6 ? (Et >= 0 && (xe[Et--] = xt >> 24 & 255), st = 0, er = 0) : (st = xt >>> 24, er += 2);
        }
        if (Et >= 0)
          for (xe[Et--] = st; Et >= 0; )
            xe[Et--] = 0;
      }, Math.clz32 ? d.prototype._countBits = function(xe) {
        return 32 - Math.clz32(xe);
      } : d.prototype._countBits = function(xe) {
        var Ne = xe, Et = 0;
        return Ne >= 4096 && (Et += 13, Ne >>>= 13), Ne >= 64 && (Et += 7, Ne >>>= 7), Ne >= 8 && (Et += 4, Ne >>>= 4), Ne >= 2 && (Et += 2, Ne >>>= 2), Et + Ne;
      }, d.prototype._zeroBits = function(xe) {
        if (xe === 0) return 26;
        var Ne = xe, Et = 0;
        return (Ne & 8191) === 0 && (Et += 13, Ne >>>= 13), (Ne & 127) === 0 && (Et += 7, Ne >>>= 7), (Ne & 15) === 0 && (Et += 4, Ne >>>= 4), (Ne & 3) === 0 && (Et += 2, Ne >>>= 2), (Ne & 1) === 0 && Et++, Et;
      }, d.prototype.bitLength = function() {
        var xe = this.words[this.length - 1], Ne = this._countBits(xe);
        return (this.length - 1) * 26 + Ne;
      };
      function fe(ke) {
        for (var xe = new Array(ke.bitLength()), Ne = 0; Ne < xe.length; Ne++) {
          var Et = Ne / 26 | 0, st = Ne % 26;
          xe[Ne] = ke.words[Et] >>> st & 1;
        }
        return xe;
      }
      d.prototype.zeroBits = function() {
        if (this.isZero()) return 0;
        for (var xe = 0, Ne = 0; Ne < this.length; Ne++) {
          var Et = this._zeroBits(this.words[Ne]);
          if (xe += Et, Et !== 26) break;
        }
        return xe;
      }, d.prototype.byteLength = function() {
        return Math.ceil(this.bitLength() / 8);
      }, d.prototype.toTwos = function(xe) {
        return this.negative !== 0 ? this.abs().inotn(xe).iaddn(1) : this.clone();
      }, d.prototype.fromTwos = function(xe) {
        return this.testn(xe - 1) ? this.notn(xe).iaddn(1).ineg() : this.clone();
      }, d.prototype.isNeg = function() {
        return this.negative !== 0;
      }, d.prototype.neg = function() {
        return this.clone().ineg();
      }, d.prototype.ineg = function() {
        return this.isZero() || (this.negative ^= 1), this;
      }, d.prototype.iuor = function(xe) {
        for (; this.length < xe.length; )
          this.words[this.length++] = 0;
        for (var Ne = 0; Ne < xe.length; Ne++)
          this.words[Ne] = this.words[Ne] | xe.words[Ne];
        return this._strip();
      }, d.prototype.ior = function(xe) {
        return y((this.negative | xe.negative) === 0), this.iuor(xe);
      }, d.prototype.or = function(xe) {
        return this.length > xe.length ? this.clone().ior(xe) : xe.clone().ior(this);
      }, d.prototype.uor = function(xe) {
        return this.length > xe.length ? this.clone().iuor(xe) : xe.clone().iuor(this);
      }, d.prototype.iuand = function(xe) {
        var Ne;
        this.length > xe.length ? Ne = xe : Ne = this;
        for (var Et = 0; Et < Ne.length; Et++)
          this.words[Et] = this.words[Et] & xe.words[Et];
        return this.length = Ne.length, this._strip();
      }, d.prototype.iand = function(xe) {
        return y((this.negative | xe.negative) === 0), this.iuand(xe);
      }, d.prototype.and = function(xe) {
        return this.length > xe.length ? this.clone().iand(xe) : xe.clone().iand(this);
      }, d.prototype.uand = function(xe) {
        return this.length > xe.length ? this.clone().iuand(xe) : xe.clone().iuand(this);
      }, d.prototype.iuxor = function(xe) {
        var Ne, Et;
        this.length > xe.length ? (Ne = this, Et = xe) : (Ne = xe, Et = this);
        for (var st = 0; st < Et.length; st++)
          this.words[st] = Ne.words[st] ^ Et.words[st];
        if (this !== Ne)
          for (; st < Ne.length; st++)
            this.words[st] = Ne.words[st];
        return this.length = Ne.length, this._strip();
      }, d.prototype.ixor = function(xe) {
        return y((this.negative | xe.negative) === 0), this.iuxor(xe);
      }, d.prototype.xor = function(xe) {
        return this.length > xe.length ? this.clone().ixor(xe) : xe.clone().ixor(this);
      }, d.prototype.uxor = function(xe) {
        return this.length > xe.length ? this.clone().iuxor(xe) : xe.clone().iuxor(this);
      }, d.prototype.inotn = function(xe) {
        y(typeof xe == "number" && xe >= 0);
        var Ne = Math.ceil(xe / 26) | 0, Et = xe % 26;
        this._expand(Ne), Et > 0 && Ne--;
        for (var st = 0; st < Ne; st++)
          this.words[st] = ~this.words[st] & 67108863;
        return Et > 0 && (this.words[st] = ~this.words[st] & 67108863 >> 26 - Et), this._strip();
      }, d.prototype.notn = function(xe) {
        return this.clone().inotn(xe);
      }, d.prototype.setn = function(xe, Ne) {
        y(typeof xe == "number" && xe >= 0);
        var Et = xe / 26 | 0, st = xe % 26;
        return this._expand(Et + 1), Ne ? this.words[Et] = this.words[Et] | 1 << st : this.words[Et] = this.words[Et] & ~(1 << st), this._strip();
      }, d.prototype.iadd = function(xe) {
        var Ne;
        if (this.negative !== 0 && xe.negative === 0)
          return this.negative = 0, Ne = this.isub(xe), this.negative ^= 1, this._normSign();
        if (this.negative === 0 && xe.negative !== 0)
          return xe.negative = 0, Ne = this.isub(xe), xe.negative = 1, Ne._normSign();
        var Et, st;
        this.length > xe.length ? (Et = this, st = xe) : (Et = xe, st = this);
        for (var Dt = 0, er = 0; er < st.length; er++)
          Ne = (Et.words[er] | 0) + (st.words[er] | 0) + Dt, this.words[er] = Ne & 67108863, Dt = Ne >>> 26;
        for (; Dt !== 0 && er < Et.length; er++)
          Ne = (Et.words[er] | 0) + Dt, this.words[er] = Ne & 67108863, Dt = Ne >>> 26;
        if (this.length = Et.length, Dt !== 0)
          this.words[this.length] = Dt, this.length++;
        else if (Et !== this)
          for (; er < Et.length; er++)
            this.words[er] = Et.words[er];
        return this;
      }, d.prototype.add = function(xe) {
        var Ne;
        return xe.negative !== 0 && this.negative === 0 ? (xe.negative = 0, Ne = this.sub(xe), xe.negative ^= 1, Ne) : xe.negative === 0 && this.negative !== 0 ? (this.negative = 0, Ne = xe.sub(this), this.negative = 1, Ne) : this.length > xe.length ? this.clone().iadd(xe) : xe.clone().iadd(this);
      }, d.prototype.isub = function(xe) {
        if (xe.negative !== 0) {
          xe.negative = 0;
          var Ne = this.iadd(xe);
          return xe.negative = 1, Ne._normSign();
        } else if (this.negative !== 0)
          return this.negative = 0, this.iadd(xe), this.negative = 1, this._normSign();
        var Et = this.cmp(xe);
        if (Et === 0)
          return this.negative = 0, this.length = 1, this.words[0] = 0, this;
        var st, Dt;
        Et > 0 ? (st = this, Dt = xe) : (st = xe, Dt = this);
        for (var er = 0, xt = 0; xt < Dt.length; xt++)
          Ne = (st.words[xt] | 0) - (Dt.words[xt] | 0) + er, er = Ne >> 26, this.words[xt] = Ne & 67108863;
        for (; er !== 0 && xt < st.length; xt++)
          Ne = (st.words[xt] | 0) + er, er = Ne >> 26, this.words[xt] = Ne & 67108863;
        if (er === 0 && xt < st.length && st !== this)
          for (; xt < st.length; xt++)
            this.words[xt] = st.words[xt];
        return this.length = Math.max(this.length, xt), st !== this && (this.negative = 1), this._strip();
      }, d.prototype.sub = function(xe) {
        return this.clone().isub(xe);
      };
      function ge(ke, xe, Ne) {
        Ne.negative = xe.negative ^ ke.negative;
        var Et = ke.length + xe.length | 0;
        Ne.length = Et, Et = Et - 1 | 0;
        var st = ke.words[0] | 0, Dt = xe.words[0] | 0, er = st * Dt, xt = er & 67108863, ir = er / 67108864 | 0;
        Ne.words[0] = xt;
        for (var sr = 1; sr < Et; sr++) {
          for (var yr = ir >>> 26, wr = ir & 67108863, qr = Math.min(sr, xe.length - 1), Mr = Math.max(0, sr - ke.length + 1); Mr <= qr; Mr++) {
            var Dr = sr - Mr | 0;
            st = ke.words[Dr] | 0, Dt = xe.words[Mr] | 0, er = st * Dt + wr, yr += er / 67108864 | 0, wr = er & 67108863;
          }
          Ne.words[sr] = wr | 0, ir = yr | 0;
        }
        return ir !== 0 ? Ne.words[sr] = ir | 0 : Ne.length--, Ne._strip();
      }
      var Ie = function(xe, Ne, Et) {
        var st = xe.words, Dt = Ne.words, er = Et.words, xt = 0, ir, sr, yr, wr = st[0] | 0, qr = wr & 8191, Mr = wr >>> 13, Dr = st[1] | 0, Qr = Dr & 8191, Xr = Dr >>> 13, Vr = st[2] | 0, Ur = Vr & 8191, Sr = Vr >>> 13, Gr = st[3] | 0, Fr = Gr & 8191, br = Gr >>> 13, Ar = st[4] | 0, cr = Ar & 8191, hr = Ar >>> 13, Wr = st[5] | 0, fi = Wr & 8191, Bi = Wr >>> 13, $r = st[6] | 0, oi = $r & 8191, zr = $r >>> 13, ti = st[7] | 0, Lr = ti & 8191, Rr = ti >>> 13, Ir = st[8] | 0, pr = Ir & 8191, Cr = Ir >>> 13, Er = st[9] | 0, xr = Er & 8191, si = Er >>> 13, Ci = Dt[0] | 0, bi = Ci & 8191, Ri = Ci >>> 13, li = Dt[1] | 0, zi = li & 8191, Kn = li >>> 13, Hn = Dt[2] | 0, os = Hn & 8191, ts = Hn >>> 13, Gs = Dt[3] | 0, Wn = Gs & 8191, Gn = Gs >>> 13, ro = Dt[4] | 0, Fs = ro & 8191, ii = ro >>> 13, Ai = Dt[5] | 0, ci = Ai & 8191, Si = Ai >>> 13, Ui = Dt[6] | 0, _i = Ui & 8191, Tn = Ui >>> 13, Fn = Dt[7] | 0, ss = Fn & 8191, rs = Fn >>> 13, is = Dt[8] | 0, Pr = is & 8191, as = is >>> 13, Rs = Dt[9] | 0, ri = Rs & 8191, Tr = Rs >>> 13;
        Et.negative = xe.negative ^ Ne.negative, Et.length = 19, ir = Math.imul(qr, bi), sr = Math.imul(qr, Ri), sr = sr + Math.imul(Mr, bi) | 0, yr = Math.imul(Mr, Ri);
        var yi = (xt + ir | 0) + ((sr & 8191) << 13) | 0;
        xt = (yr + (sr >>> 13) | 0) + (yi >>> 26) | 0, yi &= 67108863, ir = Math.imul(Qr, bi), sr = Math.imul(Qr, Ri), sr = sr + Math.imul(Xr, bi) | 0, yr = Math.imul(Xr, Ri), ir = ir + Math.imul(qr, zi) | 0, sr = sr + Math.imul(qr, Kn) | 0, sr = sr + Math.imul(Mr, zi) | 0, yr = yr + Math.imul(Mr, Kn) | 0;
        var ki = (xt + ir | 0) + ((sr & 8191) << 13) | 0;
        xt = (yr + (sr >>> 13) | 0) + (ki >>> 26) | 0, ki &= 67108863, ir = Math.imul(Ur, bi), sr = Math.imul(Ur, Ri), sr = sr + Math.imul(Sr, bi) | 0, yr = Math.imul(Sr, Ri), ir = ir + Math.imul(Qr, zi) | 0, sr = sr + Math.imul(Qr, Kn) | 0, sr = sr + Math.imul(Xr, zi) | 0, yr = yr + Math.imul(Xr, Kn) | 0, ir = ir + Math.imul(qr, os) | 0, sr = sr + Math.imul(qr, ts) | 0, sr = sr + Math.imul(Mr, os) | 0, yr = yr + Math.imul(Mr, ts) | 0;
        var qi = (xt + ir | 0) + ((sr & 8191) << 13) | 0;
        xt = (yr + (sr >>> 13) | 0) + (qi >>> 26) | 0, qi &= 67108863, ir = Math.imul(Fr, bi), sr = Math.imul(Fr, Ri), sr = sr + Math.imul(br, bi) | 0, yr = Math.imul(br, Ri), ir = ir + Math.imul(Ur, zi) | 0, sr = sr + Math.imul(Ur, Kn) | 0, sr = sr + Math.imul(Sr, zi) | 0, yr = yr + Math.imul(Sr, Kn) | 0, ir = ir + Math.imul(Qr, os) | 0, sr = sr + Math.imul(Qr, ts) | 0, sr = sr + Math.imul(Xr, os) | 0, yr = yr + Math.imul(Xr, ts) | 0, ir = ir + Math.imul(qr, Wn) | 0, sr = sr + Math.imul(qr, Gn) | 0, sr = sr + Math.imul(Mr, Wn) | 0, yr = yr + Math.imul(Mr, Gn) | 0;
        var C = (xt + ir | 0) + ((sr & 8191) << 13) | 0;
        xt = (yr + (sr >>> 13) | 0) + (C >>> 26) | 0, C &= 67108863, ir = Math.imul(cr, bi), sr = Math.imul(cr, Ri), sr = sr + Math.imul(hr, bi) | 0, yr = Math.imul(hr, Ri), ir = ir + Math.imul(Fr, zi) | 0, sr = sr + Math.imul(Fr, Kn) | 0, sr = sr + Math.imul(br, zi) | 0, yr = yr + Math.imul(br, Kn) | 0, ir = ir + Math.imul(Ur, os) | 0, sr = sr + Math.imul(Ur, ts) | 0, sr = sr + Math.imul(Sr, os) | 0, yr = yr + Math.imul(Sr, ts) | 0, ir = ir + Math.imul(Qr, Wn) | 0, sr = sr + Math.imul(Qr, Gn) | 0, sr = sr + Math.imul(Xr, Wn) | 0, yr = yr + Math.imul(Xr, Gn) | 0, ir = ir + Math.imul(qr, Fs) | 0, sr = sr + Math.imul(qr, ii) | 0, sr = sr + Math.imul(Mr, Fs) | 0, yr = yr + Math.imul(Mr, ii) | 0;
        var l = (xt + ir | 0) + ((sr & 8191) << 13) | 0;
        xt = (yr + (sr >>> 13) | 0) + (l >>> 26) | 0, l &= 67108863, ir = Math.imul(fi, bi), sr = Math.imul(fi, Ri), sr = sr + Math.imul(Bi, bi) | 0, yr = Math.imul(Bi, Ri), ir = ir + Math.imul(cr, zi) | 0, sr = sr + Math.imul(cr, Kn) | 0, sr = sr + Math.imul(hr, zi) | 0, yr = yr + Math.imul(hr, Kn) | 0, ir = ir + Math.imul(Fr, os) | 0, sr = sr + Math.imul(Fr, ts) | 0, sr = sr + Math.imul(br, os) | 0, yr = yr + Math.imul(br, ts) | 0, ir = ir + Math.imul(Ur, Wn) | 0, sr = sr + Math.imul(Ur, Gn) | 0, sr = sr + Math.imul(Sr, Wn) | 0, yr = yr + Math.imul(Sr, Gn) | 0, ir = ir + Math.imul(Qr, Fs) | 0, sr = sr + Math.imul(Qr, ii) | 0, sr = sr + Math.imul(Xr, Fs) | 0, yr = yr + Math.imul(Xr, ii) | 0, ir = ir + Math.imul(qr, ci) | 0, sr = sr + Math.imul(qr, Si) | 0, sr = sr + Math.imul(Mr, ci) | 0, yr = yr + Math.imul(Mr, Si) | 0;
        var w = (xt + ir | 0) + ((sr & 8191) << 13) | 0;
        xt = (yr + (sr >>> 13) | 0) + (w >>> 26) | 0, w &= 67108863, ir = Math.imul(oi, bi), sr = Math.imul(oi, Ri), sr = sr + Math.imul(zr, bi) | 0, yr = Math.imul(zr, Ri), ir = ir + Math.imul(fi, zi) | 0, sr = sr + Math.imul(fi, Kn) | 0, sr = sr + Math.imul(Bi, zi) | 0, yr = yr + Math.imul(Bi, Kn) | 0, ir = ir + Math.imul(cr, os) | 0, sr = sr + Math.imul(cr, ts) | 0, sr = sr + Math.imul(hr, os) | 0, yr = yr + Math.imul(hr, ts) | 0, ir = ir + Math.imul(Fr, Wn) | 0, sr = sr + Math.imul(Fr, Gn) | 0, sr = sr + Math.imul(br, Wn) | 0, yr = yr + Math.imul(br, Gn) | 0, ir = ir + Math.imul(Ur, Fs) | 0, sr = sr + Math.imul(Ur, ii) | 0, sr = sr + Math.imul(Sr, Fs) | 0, yr = yr + Math.imul(Sr, ii) | 0, ir = ir + Math.imul(Qr, ci) | 0, sr = sr + Math.imul(Qr, Si) | 0, sr = sr + Math.imul(Xr, ci) | 0, yr = yr + Math.imul(Xr, Si) | 0, ir = ir + Math.imul(qr, _i) | 0, sr = sr + Math.imul(qr, Tn) | 0, sr = sr + Math.imul(Mr, _i) | 0, yr = yr + Math.imul(Mr, Tn) | 0;
        var n = (xt + ir | 0) + ((sr & 8191) << 13) | 0;
        xt = (yr + (sr >>> 13) | 0) + (n >>> 26) | 0, n &= 67108863, ir = Math.imul(Lr, bi), sr = Math.imul(Lr, Ri), sr = sr + Math.imul(Rr, bi) | 0, yr = Math.imul(Rr, Ri), ir = ir + Math.imul(oi, zi) | 0, sr = sr + Math.imul(oi, Kn) | 0, sr = sr + Math.imul(zr, zi) | 0, yr = yr + Math.imul(zr, Kn) | 0, ir = ir + Math.imul(fi, os) | 0, sr = sr + Math.imul(fi, ts) | 0, sr = sr + Math.imul(Bi, os) | 0, yr = yr + Math.imul(Bi, ts) | 0, ir = ir + Math.imul(cr, Wn) | 0, sr = sr + Math.imul(cr, Gn) | 0, sr = sr + Math.imul(hr, Wn) | 0, yr = yr + Math.imul(hr, Gn) | 0, ir = ir + Math.imul(Fr, Fs) | 0, sr = sr + Math.imul(Fr, ii) | 0, sr = sr + Math.imul(br, Fs) | 0, yr = yr + Math.imul(br, ii) | 0, ir = ir + Math.imul(Ur, ci) | 0, sr = sr + Math.imul(Ur, Si) | 0, sr = sr + Math.imul(Sr, ci) | 0, yr = yr + Math.imul(Sr, Si) | 0, ir = ir + Math.imul(Qr, _i) | 0, sr = sr + Math.imul(Qr, Tn) | 0, sr = sr + Math.imul(Xr, _i) | 0, yr = yr + Math.imul(Xr, Tn) | 0, ir = ir + Math.imul(qr, ss) | 0, sr = sr + Math.imul(qr, rs) | 0, sr = sr + Math.imul(Mr, ss) | 0, yr = yr + Math.imul(Mr, rs) | 0;
        var a = (xt + ir | 0) + ((sr & 8191) << 13) | 0;
        xt = (yr + (sr >>> 13) | 0) + (a >>> 26) | 0, a &= 67108863, ir = Math.imul(pr, bi), sr = Math.imul(pr, Ri), sr = sr + Math.imul(Cr, bi) | 0, yr = Math.imul(Cr, Ri), ir = ir + Math.imul(Lr, zi) | 0, sr = sr + Math.imul(Lr, Kn) | 0, sr = sr + Math.imul(Rr, zi) | 0, yr = yr + Math.imul(Rr, Kn) | 0, ir = ir + Math.imul(oi, os) | 0, sr = sr + Math.imul(oi, ts) | 0, sr = sr + Math.imul(zr, os) | 0, yr = yr + Math.imul(zr, ts) | 0, ir = ir + Math.imul(fi, Wn) | 0, sr = sr + Math.imul(fi, Gn) | 0, sr = sr + Math.imul(Bi, Wn) | 0, yr = yr + Math.imul(Bi, Gn) | 0, ir = ir + Math.imul(cr, Fs) | 0, sr = sr + Math.imul(cr, ii) | 0, sr = sr + Math.imul(hr, Fs) | 0, yr = yr + Math.imul(hr, ii) | 0, ir = ir + Math.imul(Fr, ci) | 0, sr = sr + Math.imul(Fr, Si) | 0, sr = sr + Math.imul(br, ci) | 0, yr = yr + Math.imul(br, Si) | 0, ir = ir + Math.imul(Ur, _i) | 0, sr = sr + Math.imul(Ur, Tn) | 0, sr = sr + Math.imul(Sr, _i) | 0, yr = yr + Math.imul(Sr, Tn) | 0, ir = ir + Math.imul(Qr, ss) | 0, sr = sr + Math.imul(Qr, rs) | 0, sr = sr + Math.imul(Xr, ss) | 0, yr = yr + Math.imul(Xr, rs) | 0, ir = ir + Math.imul(qr, Pr) | 0, sr = sr + Math.imul(qr, as) | 0, sr = sr + Math.imul(Mr, Pr) | 0, yr = yr + Math.imul(Mr, as) | 0;
        var b = (xt + ir | 0) + ((sr & 8191) << 13) | 0;
        xt = (yr + (sr >>> 13) | 0) + (b >>> 26) | 0, b &= 67108863, ir = Math.imul(xr, bi), sr = Math.imul(xr, Ri), sr = sr + Math.imul(si, bi) | 0, yr = Math.imul(si, Ri), ir = ir + Math.imul(pr, zi) | 0, sr = sr + Math.imul(pr, Kn) | 0, sr = sr + Math.imul(Cr, zi) | 0, yr = yr + Math.imul(Cr, Kn) | 0, ir = ir + Math.imul(Lr, os) | 0, sr = sr + Math.imul(Lr, ts) | 0, sr = sr + Math.imul(Rr, os) | 0, yr = yr + Math.imul(Rr, ts) | 0, ir = ir + Math.imul(oi, Wn) | 0, sr = sr + Math.imul(oi, Gn) | 0, sr = sr + Math.imul(zr, Wn) | 0, yr = yr + Math.imul(zr, Gn) | 0, ir = ir + Math.imul(fi, Fs) | 0, sr = sr + Math.imul(fi, ii) | 0, sr = sr + Math.imul(Bi, Fs) | 0, yr = yr + Math.imul(Bi, ii) | 0, ir = ir + Math.imul(cr, ci) | 0, sr = sr + Math.imul(cr, Si) | 0, sr = sr + Math.imul(hr, ci) | 0, yr = yr + Math.imul(hr, Si) | 0, ir = ir + Math.imul(Fr, _i) | 0, sr = sr + Math.imul(Fr, Tn) | 0, sr = sr + Math.imul(br, _i) | 0, yr = yr + Math.imul(br, Tn) | 0, ir = ir + Math.imul(Ur, ss) | 0, sr = sr + Math.imul(Ur, rs) | 0, sr = sr + Math.imul(Sr, ss) | 0, yr = yr + Math.imul(Sr, rs) | 0, ir = ir + Math.imul(Qr, Pr) | 0, sr = sr + Math.imul(Qr, as) | 0, sr = sr + Math.imul(Xr, Pr) | 0, yr = yr + Math.imul(Xr, as) | 0, ir = ir + Math.imul(qr, ri) | 0, sr = sr + Math.imul(qr, Tr) | 0, sr = sr + Math.imul(Mr, ri) | 0, yr = yr + Math.imul(Mr, Tr) | 0;
        var P = (xt + ir | 0) + ((sr & 8191) << 13) | 0;
        xt = (yr + (sr >>> 13) | 0) + (P >>> 26) | 0, P &= 67108863, ir = Math.imul(xr, zi), sr = Math.imul(xr, Kn), sr = sr + Math.imul(si, zi) | 0, yr = Math.imul(si, Kn), ir = ir + Math.imul(pr, os) | 0, sr = sr + Math.imul(pr, ts) | 0, sr = sr + Math.imul(Cr, os) | 0, yr = yr + Math.imul(Cr, ts) | 0, ir = ir + Math.imul(Lr, Wn) | 0, sr = sr + Math.imul(Lr, Gn) | 0, sr = sr + Math.imul(Rr, Wn) | 0, yr = yr + Math.imul(Rr, Gn) | 0, ir = ir + Math.imul(oi, Fs) | 0, sr = sr + Math.imul(oi, ii) | 0, sr = sr + Math.imul(zr, Fs) | 0, yr = yr + Math.imul(zr, ii) | 0, ir = ir + Math.imul(fi, ci) | 0, sr = sr + Math.imul(fi, Si) | 0, sr = sr + Math.imul(Bi, ci) | 0, yr = yr + Math.imul(Bi, Si) | 0, ir = ir + Math.imul(cr, _i) | 0, sr = sr + Math.imul(cr, Tn) | 0, sr = sr + Math.imul(hr, _i) | 0, yr = yr + Math.imul(hr, Tn) | 0, ir = ir + Math.imul(Fr, ss) | 0, sr = sr + Math.imul(Fr, rs) | 0, sr = sr + Math.imul(br, ss) | 0, yr = yr + Math.imul(br, rs) | 0, ir = ir + Math.imul(Ur, Pr) | 0, sr = sr + Math.imul(Ur, as) | 0, sr = sr + Math.imul(Sr, Pr) | 0, yr = yr + Math.imul(Sr, as) | 0, ir = ir + Math.imul(Qr, ri) | 0, sr = sr + Math.imul(Qr, Tr) | 0, sr = sr + Math.imul(Xr, ri) | 0, yr = yr + Math.imul(Xr, Tr) | 0;
        var K = (xt + ir | 0) + ((sr & 8191) << 13) | 0;
        xt = (yr + (sr >>> 13) | 0) + (K >>> 26) | 0, K &= 67108863, ir = Math.imul(xr, os), sr = Math.imul(xr, ts), sr = sr + Math.imul(si, os) | 0, yr = Math.imul(si, ts), ir = ir + Math.imul(pr, Wn) | 0, sr = sr + Math.imul(pr, Gn) | 0, sr = sr + Math.imul(Cr, Wn) | 0, yr = yr + Math.imul(Cr, Gn) | 0, ir = ir + Math.imul(Lr, Fs) | 0, sr = sr + Math.imul(Lr, ii) | 0, sr = sr + Math.imul(Rr, Fs) | 0, yr = yr + Math.imul(Rr, ii) | 0, ir = ir + Math.imul(oi, ci) | 0, sr = sr + Math.imul(oi, Si) | 0, sr = sr + Math.imul(zr, ci) | 0, yr = yr + Math.imul(zr, Si) | 0, ir = ir + Math.imul(fi, _i) | 0, sr = sr + Math.imul(fi, Tn) | 0, sr = sr + Math.imul(Bi, _i) | 0, yr = yr + Math.imul(Bi, Tn) | 0, ir = ir + Math.imul(cr, ss) | 0, sr = sr + Math.imul(cr, rs) | 0, sr = sr + Math.imul(hr, ss) | 0, yr = yr + Math.imul(hr, rs) | 0, ir = ir + Math.imul(Fr, Pr) | 0, sr = sr + Math.imul(Fr, as) | 0, sr = sr + Math.imul(br, Pr) | 0, yr = yr + Math.imul(br, as) | 0, ir = ir + Math.imul(Ur, ri) | 0, sr = sr + Math.imul(Ur, Tr) | 0, sr = sr + Math.imul(Sr, ri) | 0, yr = yr + Math.imul(Sr, Tr) | 0;
        var pe = (xt + ir | 0) + ((sr & 8191) << 13) | 0;
        xt = (yr + (sr >>> 13) | 0) + (pe >>> 26) | 0, pe &= 67108863, ir = Math.imul(xr, Wn), sr = Math.imul(xr, Gn), sr = sr + Math.imul(si, Wn) | 0, yr = Math.imul(si, Gn), ir = ir + Math.imul(pr, Fs) | 0, sr = sr + Math.imul(pr, ii) | 0, sr = sr + Math.imul(Cr, Fs) | 0, yr = yr + Math.imul(Cr, ii) | 0, ir = ir + Math.imul(Lr, ci) | 0, sr = sr + Math.imul(Lr, Si) | 0, sr = sr + Math.imul(Rr, ci) | 0, yr = yr + Math.imul(Rr, Si) | 0, ir = ir + Math.imul(oi, _i) | 0, sr = sr + Math.imul(oi, Tn) | 0, sr = sr + Math.imul(zr, _i) | 0, yr = yr + Math.imul(zr, Tn) | 0, ir = ir + Math.imul(fi, ss) | 0, sr = sr + Math.imul(fi, rs) | 0, sr = sr + Math.imul(Bi, ss) | 0, yr = yr + Math.imul(Bi, rs) | 0, ir = ir + Math.imul(cr, Pr) | 0, sr = sr + Math.imul(cr, as) | 0, sr = sr + Math.imul(hr, Pr) | 0, yr = yr + Math.imul(hr, as) | 0, ir = ir + Math.imul(Fr, ri) | 0, sr = sr + Math.imul(Fr, Tr) | 0, sr = sr + Math.imul(br, ri) | 0, yr = yr + Math.imul(br, Tr) | 0;
        var Ce = (xt + ir | 0) + ((sr & 8191) << 13) | 0;
        xt = (yr + (sr >>> 13) | 0) + (Ce >>> 26) | 0, Ce &= 67108863, ir = Math.imul(xr, Fs), sr = Math.imul(xr, ii), sr = sr + Math.imul(si, Fs) | 0, yr = Math.imul(si, ii), ir = ir + Math.imul(pr, ci) | 0, sr = sr + Math.imul(pr, Si) | 0, sr = sr + Math.imul(Cr, ci) | 0, yr = yr + Math.imul(Cr, Si) | 0, ir = ir + Math.imul(Lr, _i) | 0, sr = sr + Math.imul(Lr, Tn) | 0, sr = sr + Math.imul(Rr, _i) | 0, yr = yr + Math.imul(Rr, Tn) | 0, ir = ir + Math.imul(oi, ss) | 0, sr = sr + Math.imul(oi, rs) | 0, sr = sr + Math.imul(zr, ss) | 0, yr = yr + Math.imul(zr, rs) | 0, ir = ir + Math.imul(fi, Pr) | 0, sr = sr + Math.imul(fi, as) | 0, sr = sr + Math.imul(Bi, Pr) | 0, yr = yr + Math.imul(Bi, as) | 0, ir = ir + Math.imul(cr, ri) | 0, sr = sr + Math.imul(cr, Tr) | 0, sr = sr + Math.imul(hr, ri) | 0, yr = yr + Math.imul(hr, Tr) | 0;
        var Me = (xt + ir | 0) + ((sr & 8191) << 13) | 0;
        xt = (yr + (sr >>> 13) | 0) + (Me >>> 26) | 0, Me &= 67108863, ir = Math.imul(xr, ci), sr = Math.imul(xr, Si), sr = sr + Math.imul(si, ci) | 0, yr = Math.imul(si, Si), ir = ir + Math.imul(pr, _i) | 0, sr = sr + Math.imul(pr, Tn) | 0, sr = sr + Math.imul(Cr, _i) | 0, yr = yr + Math.imul(Cr, Tn) | 0, ir = ir + Math.imul(Lr, ss) | 0, sr = sr + Math.imul(Lr, rs) | 0, sr = sr + Math.imul(Rr, ss) | 0, yr = yr + Math.imul(Rr, rs) | 0, ir = ir + Math.imul(oi, Pr) | 0, sr = sr + Math.imul(oi, as) | 0, sr = sr + Math.imul(zr, Pr) | 0, yr = yr + Math.imul(zr, as) | 0, ir = ir + Math.imul(fi, ri) | 0, sr = sr + Math.imul(fi, Tr) | 0, sr = sr + Math.imul(Bi, ri) | 0, yr = yr + Math.imul(Bi, Tr) | 0;
        var Tt = (xt + ir | 0) + ((sr & 8191) << 13) | 0;
        xt = (yr + (sr >>> 13) | 0) + (Tt >>> 26) | 0, Tt &= 67108863, ir = Math.imul(xr, _i), sr = Math.imul(xr, Tn), sr = sr + Math.imul(si, _i) | 0, yr = Math.imul(si, Tn), ir = ir + Math.imul(pr, ss) | 0, sr = sr + Math.imul(pr, rs) | 0, sr = sr + Math.imul(Cr, ss) | 0, yr = yr + Math.imul(Cr, rs) | 0, ir = ir + Math.imul(Lr, Pr) | 0, sr = sr + Math.imul(Lr, as) | 0, sr = sr + Math.imul(Rr, Pr) | 0, yr = yr + Math.imul(Rr, as) | 0, ir = ir + Math.imul(oi, ri) | 0, sr = sr + Math.imul(oi, Tr) | 0, sr = sr + Math.imul(zr, ri) | 0, yr = yr + Math.imul(zr, Tr) | 0;
        var tr = (xt + ir | 0) + ((sr & 8191) << 13) | 0;
        xt = (yr + (sr >>> 13) | 0) + (tr >>> 26) | 0, tr &= 67108863, ir = Math.imul(xr, ss), sr = Math.imul(xr, rs), sr = sr + Math.imul(si, ss) | 0, yr = Math.imul(si, rs), ir = ir + Math.imul(pr, Pr) | 0, sr = sr + Math.imul(pr, as) | 0, sr = sr + Math.imul(Cr, Pr) | 0, yr = yr + Math.imul(Cr, as) | 0, ir = ir + Math.imul(Lr, ri) | 0, sr = sr + Math.imul(Lr, Tr) | 0, sr = sr + Math.imul(Rr, ri) | 0, yr = yr + Math.imul(Rr, Tr) | 0;
        var nr = (xt + ir | 0) + ((sr & 8191) << 13) | 0;
        xt = (yr + (sr >>> 13) | 0) + (nr >>> 26) | 0, nr &= 67108863, ir = Math.imul(xr, Pr), sr = Math.imul(xr, as), sr = sr + Math.imul(si, Pr) | 0, yr = Math.imul(si, as), ir = ir + Math.imul(pr, ri) | 0, sr = sr + Math.imul(pr, Tr) | 0, sr = sr + Math.imul(Cr, ri) | 0, yr = yr + Math.imul(Cr, Tr) | 0;
        var or = (xt + ir | 0) + ((sr & 8191) << 13) | 0;
        xt = (yr + (sr >>> 13) | 0) + (or >>> 26) | 0, or &= 67108863, ir = Math.imul(xr, ri), sr = Math.imul(xr, Tr), sr = sr + Math.imul(si, ri) | 0, yr = Math.imul(si, Tr);
        var lr = (xt + ir | 0) + ((sr & 8191) << 13) | 0;
        return xt = (yr + (sr >>> 13) | 0) + (lr >>> 26) | 0, lr &= 67108863, er[0] = yi, er[1] = ki, er[2] = qi, er[3] = C, er[4] = l, er[5] = w, er[6] = n, er[7] = a, er[8] = b, er[9] = P, er[10] = K, er[11] = pe, er[12] = Ce, er[13] = Me, er[14] = Tt, er[15] = tr, er[16] = nr, er[17] = or, er[18] = lr, xt !== 0 && (er[19] = xt, Et.length++), Et;
      };
      Math.imul || (Ie = ge);
      function Ee(ke, xe, Ne) {
        Ne.negative = xe.negative ^ ke.negative, Ne.length = ke.length + xe.length;
        for (var Et = 0, st = 0, Dt = 0; Dt < Ne.length - 1; Dt++) {
          var er = st;
          st = 0;
          for (var xt = Et & 67108863, ir = Math.min(Dt, xe.length - 1), sr = Math.max(0, Dt - ke.length + 1); sr <= ir; sr++) {
            var yr = Dt - sr, wr = ke.words[yr] | 0, qr = xe.words[sr] | 0, Mr = wr * qr, Dr = Mr & 67108863;
            er = er + (Mr / 67108864 | 0) | 0, Dr = Dr + xt | 0, xt = Dr & 67108863, er = er + (Dr >>> 26) | 0, st += er >>> 26, er &= 67108863;
          }
          Ne.words[Dt] = xt, Et = er, er = st;
        }
        return Et !== 0 ? Ne.words[Dt] = Et : Ne.length--, Ne._strip();
      }
      function Se(ke, xe, Ne) {
        return Ee(ke, xe, Ne);
      }
      d.prototype.mulTo = function(xe, Ne) {
        var Et, st = this.length + xe.length;
        return this.length === 10 && xe.length === 10 ? Et = Ie(this, xe, Ne) : st < 63 ? Et = ge(this, xe, Ne) : st < 1024 ? Et = Ee(this, xe, Ne) : Et = Se(this, xe, Ne), Et;
      }, d.prototype.mul = function(xe) {
        var Ne = new d(null);
        return Ne.words = new Array(this.length + xe.length), this.mulTo(xe, Ne);
      }, d.prototype.mulf = function(xe) {
        var Ne = new d(null);
        return Ne.words = new Array(this.length + xe.length), Se(this, xe, Ne);
      }, d.prototype.imul = function(xe) {
        return this.clone().mulTo(xe, this);
      }, d.prototype.imuln = function(xe) {
        var Ne = xe < 0;
        Ne && (xe = -xe), y(typeof xe == "number"), y(xe < 67108864);
        for (var Et = 0, st = 0; st < this.length; st++) {
          var Dt = (this.words[st] | 0) * xe, er = (Dt & 67108863) + (Et & 67108863);
          Et >>= 26, Et += Dt / 67108864 | 0, Et += er >>> 26, this.words[st] = er & 67108863;
        }
        return Et !== 0 && (this.words[st] = Et, this.length++), this.length = xe === 0 ? 1 : this.length, Ne ? this.ineg() : this;
      }, d.prototype.muln = function(xe) {
        return this.clone().imuln(xe);
      }, d.prototype.sqr = function() {
        return this.mul(this);
      }, d.prototype.isqr = function() {
        return this.imul(this.clone());
      }, d.prototype.pow = function(xe) {
        var Ne = fe(xe);
        if (Ne.length === 0) return new d(1);
        for (var Et = this, st = 0; st < Ne.length && Ne[st] === 0; st++, Et = Et.sqr())
          ;
        if (++st < Ne.length)
          for (var Dt = Et.sqr(); st < Ne.length; st++, Dt = Dt.sqr())
            Ne[st] !== 0 && (Et = Et.mul(Dt));
        return Et;
      }, d.prototype.iushln = function(xe) {
        y(typeof xe == "number" && xe >= 0);
        var Ne = xe % 26, Et = (xe - Ne) / 26, st = 67108863 >>> 26 - Ne << 26 - Ne, Dt;
        if (Ne !== 0) {
          var er = 0;
          for (Dt = 0; Dt < this.length; Dt++) {
            var xt = this.words[Dt] & st, ir = (this.words[Dt] | 0) - xt << Ne;
            this.words[Dt] = ir | er, er = xt >>> 26 - Ne;
          }
          er && (this.words[Dt] = er, this.length++);
        }
        if (Et !== 0) {
          for (Dt = this.length - 1; Dt >= 0; Dt--)
            this.words[Dt + Et] = this.words[Dt];
          for (Dt = 0; Dt < Et; Dt++)
            this.words[Dt] = 0;
          this.length += Et;
        }
        return this._strip();
      }, d.prototype.ishln = function(xe) {
        return y(this.negative === 0), this.iushln(xe);
      }, d.prototype.iushrn = function(xe, Ne, Et) {
        y(typeof xe == "number" && xe >= 0);
        var st;
        Ne ? st = (Ne - Ne % 26) / 26 : st = 0;
        var Dt = xe % 26, er = Math.min((xe - Dt) / 26, this.length), xt = 67108863 ^ 67108863 >>> Dt << Dt, ir = Et;
        if (st -= er, st = Math.max(0, st), ir) {
          for (var sr = 0; sr < er; sr++)
            ir.words[sr] = this.words[sr];
          ir.length = er;
        }
        if (er !== 0) if (this.length > er)
          for (this.length -= er, sr = 0; sr < this.length; sr++)
            this.words[sr] = this.words[sr + er];
        else
          this.words[0] = 0, this.length = 1;
        var yr = 0;
        for (sr = this.length - 1; sr >= 0 && (yr !== 0 || sr >= st); sr--) {
          var wr = this.words[sr] | 0;
          this.words[sr] = yr << 26 - Dt | wr >>> Dt, yr = wr & xt;
        }
        return ir && yr !== 0 && (ir.words[ir.length++] = yr), this.length === 0 && (this.words[0] = 0, this.length = 1), this._strip();
      }, d.prototype.ishrn = function(xe, Ne, Et) {
        return y(this.negative === 0), this.iushrn(xe, Ne, Et);
      }, d.prototype.shln = function(xe) {
        return this.clone().ishln(xe);
      }, d.prototype.ushln = function(xe) {
        return this.clone().iushln(xe);
      }, d.prototype.shrn = function(xe) {
        return this.clone().ishrn(xe);
      }, d.prototype.ushrn = function(xe) {
        return this.clone().iushrn(xe);
      }, d.prototype.testn = function(xe) {
        y(typeof xe == "number" && xe >= 0);
        var Ne = xe % 26, Et = (xe - Ne) / 26, st = 1 << Ne;
        if (this.length <= Et) return !1;
        var Dt = this.words[Et];
        return !!(Dt & st);
      }, d.prototype.imaskn = function(xe) {
        y(typeof xe == "number" && xe >= 0);
        var Ne = xe % 26, Et = (xe - Ne) / 26;
        if (y(this.negative === 0, "imaskn works only with positive numbers"), this.length <= Et)
          return this;
        if (Ne !== 0 && Et++, this.length = Math.min(Et, this.length), Ne !== 0) {
          var st = 67108863 ^ 67108863 >>> Ne << Ne;
          this.words[this.length - 1] &= st;
        }
        return this._strip();
      }, d.prototype.maskn = function(xe) {
        return this.clone().imaskn(xe);
      }, d.prototype.iaddn = function(xe) {
        return y(typeof xe == "number"), y(xe < 67108864), xe < 0 ? this.isubn(-xe) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) <= xe ? (this.words[0] = xe - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(xe), this.negative = 1, this) : this._iaddn(xe);
      }, d.prototype._iaddn = function(xe) {
        this.words[0] += xe;
        for (var Ne = 0; Ne < this.length && this.words[Ne] >= 67108864; Ne++)
          this.words[Ne] -= 67108864, Ne === this.length - 1 ? this.words[Ne + 1] = 1 : this.words[Ne + 1]++;
        return this.length = Math.max(this.length, Ne + 1), this;
      }, d.prototype.isubn = function(xe) {
        if (y(typeof xe == "number"), y(xe < 67108864), xe < 0) return this.iaddn(-xe);
        if (this.negative !== 0)
          return this.negative = 0, this.iaddn(xe), this.negative = 1, this;
        if (this.words[0] -= xe, this.length === 1 && this.words[0] < 0)
          this.words[0] = -this.words[0], this.negative = 1;
        else
          for (var Ne = 0; Ne < this.length && this.words[Ne] < 0; Ne++)
            this.words[Ne] += 67108864, this.words[Ne + 1] -= 1;
        return this._strip();
      }, d.prototype.addn = function(xe) {
        return this.clone().iaddn(xe);
      }, d.prototype.subn = function(xe) {
        return this.clone().isubn(xe);
      }, d.prototype.iabs = function() {
        return this.negative = 0, this;
      }, d.prototype.abs = function() {
        return this.clone().iabs();
      }, d.prototype._ishlnsubmul = function(xe, Ne, Et) {
        var st = xe.length + Et, Dt;
        this._expand(st);
        var er, xt = 0;
        for (Dt = 0; Dt < xe.length; Dt++) {
          er = (this.words[Dt + Et] | 0) + xt;
          var ir = (xe.words[Dt] | 0) * Ne;
          er -= ir & 67108863, xt = (er >> 26) - (ir / 67108864 | 0), this.words[Dt + Et] = er & 67108863;
        }
        for (; Dt < this.length - Et; Dt++)
          er = (this.words[Dt + Et] | 0) + xt, xt = er >> 26, this.words[Dt + Et] = er & 67108863;
        if (xt === 0) return this._strip();
        for (y(xt === -1), xt = 0, Dt = 0; Dt < this.length; Dt++)
          er = -(this.words[Dt] | 0) + xt, xt = er >> 26, this.words[Dt] = er & 67108863;
        return this.negative = 1, this._strip();
      }, d.prototype._wordDiv = function(xe, Ne) {
        var Et = this.length - xe.length, st = this.clone(), Dt = xe, er = Dt.words[Dt.length - 1] | 0, xt = this._countBits(er);
        Et = 26 - xt, Et !== 0 && (Dt = Dt.ushln(Et), st.iushln(Et), er = Dt.words[Dt.length - 1] | 0);
        var ir = st.length - Dt.length, sr;
        if (Ne !== "mod") {
          sr = new d(null), sr.length = ir + 1, sr.words = new Array(sr.length);
          for (var yr = 0; yr < sr.length; yr++)
            sr.words[yr] = 0;
        }
        var wr = st.clone()._ishlnsubmul(Dt, 1, ir);
        wr.negative === 0 && (st = wr, sr && (sr.words[ir] = 1));
        for (var qr = ir - 1; qr >= 0; qr--) {
          var Mr = (st.words[Dt.length + qr] | 0) * 67108864 + (st.words[Dt.length + qr - 1] | 0);
          for (Mr = Math.min(Mr / er | 0, 67108863), st._ishlnsubmul(Dt, Mr, qr); st.negative !== 0; )
            Mr--, st.negative = 0, st._ishlnsubmul(Dt, 1, qr), st.isZero() || (st.negative ^= 1);
          sr && (sr.words[qr] = Mr);
        }
        return sr && sr._strip(), st._strip(), Ne !== "div" && Et !== 0 && st.iushrn(Et), {
          div: sr || null,
          mod: st
        };
      }, d.prototype.divmod = function(xe, Ne, Et) {
        if (y(!xe.isZero()), this.isZero())
          return {
            div: new d(0),
            mod: new d(0)
          };
        var st, Dt, er;
        return this.negative !== 0 && xe.negative === 0 ? (er = this.neg().divmod(xe, Ne), Ne !== "mod" && (st = er.div.neg()), Ne !== "div" && (Dt = er.mod.neg(), Et && Dt.negative !== 0 && Dt.iadd(xe)), {
          div: st,
          mod: Dt
        }) : this.negative === 0 && xe.negative !== 0 ? (er = this.divmod(xe.neg(), Ne), Ne !== "mod" && (st = er.div.neg()), {
          div: st,
          mod: er.mod
        }) : (this.negative & xe.negative) !== 0 ? (er = this.neg().divmod(xe.neg(), Ne), Ne !== "div" && (Dt = er.mod.neg(), Et && Dt.negative !== 0 && Dt.isub(xe)), {
          div: er.div,
          mod: Dt
        }) : xe.length > this.length || this.cmp(xe) < 0 ? {
          div: new d(0),
          mod: this
        } : xe.length === 1 ? Ne === "div" ? {
          div: this.divn(xe.words[0]),
          mod: null
        } : Ne === "mod" ? {
          div: null,
          mod: new d(this.modrn(xe.words[0]))
        } : {
          div: this.divn(xe.words[0]),
          mod: new d(this.modrn(xe.words[0]))
        } : this._wordDiv(xe, Ne);
      }, d.prototype.div = function(xe) {
        return this.divmod(xe, "div", !1).div;
      }, d.prototype.mod = function(xe) {
        return this.divmod(xe, "mod", !1).mod;
      }, d.prototype.umod = function(xe) {
        return this.divmod(xe, "mod", !0).mod;
      }, d.prototype.divRound = function(xe) {
        var Ne = this.divmod(xe);
        if (Ne.mod.isZero()) return Ne.div;
        var Et = Ne.div.negative !== 0 ? Ne.mod.isub(xe) : Ne.mod, st = xe.ushrn(1), Dt = xe.andln(1), er = Et.cmp(st);
        return er < 0 || Dt === 1 && er === 0 ? Ne.div : Ne.div.negative !== 0 ? Ne.div.isubn(1) : Ne.div.iaddn(1);
      }, d.prototype.modrn = function(xe) {
        var Ne = xe < 0;
        Ne && (xe = -xe), y(xe <= 67108863);
        for (var Et = (1 << 26) % xe, st = 0, Dt = this.length - 1; Dt >= 0; Dt--)
          st = (Et * st + (this.words[Dt] | 0)) % xe;
        return Ne ? -st : st;
      }, d.prototype.modn = function(xe) {
        return this.modrn(xe);
      }, d.prototype.idivn = function(xe) {
        var Ne = xe < 0;
        Ne && (xe = -xe), y(xe <= 67108863);
        for (var Et = 0, st = this.length - 1; st >= 0; st--) {
          var Dt = (this.words[st] | 0) + Et * 67108864;
          this.words[st] = Dt / xe | 0, Et = Dt % xe;
        }
        return this._strip(), Ne ? this.ineg() : this;
      }, d.prototype.divn = function(xe) {
        return this.clone().idivn(xe);
      }, d.prototype.egcd = function(xe) {
        y(xe.negative === 0), y(!xe.isZero());
        var Ne = this, Et = xe.clone();
        Ne.negative !== 0 ? Ne = Ne.umod(xe) : Ne = Ne.clone();
        for (var st = new d(1), Dt = new d(0), er = new d(0), xt = new d(1), ir = 0; Ne.isEven() && Et.isEven(); )
          Ne.iushrn(1), Et.iushrn(1), ++ir;
        for (var sr = Et.clone(), yr = Ne.clone(); !Ne.isZero(); ) {
          for (var wr = 0, qr = 1; (Ne.words[0] & qr) === 0 && wr < 26; ++wr, qr <<= 1) ;
          if (wr > 0)
            for (Ne.iushrn(wr); wr-- > 0; )
              (st.isOdd() || Dt.isOdd()) && (st.iadd(sr), Dt.isub(yr)), st.iushrn(1), Dt.iushrn(1);
          for (var Mr = 0, Dr = 1; (Et.words[0] & Dr) === 0 && Mr < 26; ++Mr, Dr <<= 1) ;
          if (Mr > 0)
            for (Et.iushrn(Mr); Mr-- > 0; )
              (er.isOdd() || xt.isOdd()) && (er.iadd(sr), xt.isub(yr)), er.iushrn(1), xt.iushrn(1);
          Ne.cmp(Et) >= 0 ? (Ne.isub(Et), st.isub(er), Dt.isub(xt)) : (Et.isub(Ne), er.isub(st), xt.isub(Dt));
        }
        return {
          a: er,
          b: xt,
          gcd: Et.iushln(ir)
        };
      }, d.prototype._invmp = function(xe) {
        y(xe.negative === 0), y(!xe.isZero());
        var Ne = this, Et = xe.clone();
        Ne.negative !== 0 ? Ne = Ne.umod(xe) : Ne = Ne.clone();
        for (var st = new d(1), Dt = new d(0), er = Et.clone(); Ne.cmpn(1) > 0 && Et.cmpn(1) > 0; ) {
          for (var xt = 0, ir = 1; (Ne.words[0] & ir) === 0 && xt < 26; ++xt, ir <<= 1) ;
          if (xt > 0)
            for (Ne.iushrn(xt); xt-- > 0; )
              st.isOdd() && st.iadd(er), st.iushrn(1);
          for (var sr = 0, yr = 1; (Et.words[0] & yr) === 0 && sr < 26; ++sr, yr <<= 1) ;
          if (sr > 0)
            for (Et.iushrn(sr); sr-- > 0; )
              Dt.isOdd() && Dt.iadd(er), Dt.iushrn(1);
          Ne.cmp(Et) >= 0 ? (Ne.isub(Et), st.isub(Dt)) : (Et.isub(Ne), Dt.isub(st));
        }
        var wr;
        return Ne.cmpn(1) === 0 ? wr = st : wr = Dt, wr.cmpn(0) < 0 && wr.iadd(xe), wr;
      }, d.prototype.gcd = function(xe) {
        if (this.isZero()) return xe.abs();
        if (xe.isZero()) return this.abs();
        var Ne = this.clone(), Et = xe.clone();
        Ne.negative = 0, Et.negative = 0;
        for (var st = 0; Ne.isEven() && Et.isEven(); st++)
          Ne.iushrn(1), Et.iushrn(1);
        do {
          for (; Ne.isEven(); )
            Ne.iushrn(1);
          for (; Et.isEven(); )
            Et.iushrn(1);
          var Dt = Ne.cmp(Et);
          if (Dt < 0) {
            var er = Ne;
            Ne = Et, Et = er;
          } else if (Dt === 0 || Et.cmpn(1) === 0)
            break;
          Ne.isub(Et);
        } while (!0);
        return Et.iushln(st);
      }, d.prototype.invm = function(xe) {
        return this.egcd(xe).a.umod(xe);
      }, d.prototype.isEven = function() {
        return (this.words[0] & 1) === 0;
      }, d.prototype.isOdd = function() {
        return (this.words[0] & 1) === 1;
      }, d.prototype.andln = function(xe) {
        return this.words[0] & xe;
      }, d.prototype.bincn = function(xe) {
        y(typeof xe == "number");
        var Ne = xe % 26, Et = (xe - Ne) / 26, st = 1 << Ne;
        if (this.length <= Et)
          return this._expand(Et + 1), this.words[Et] |= st, this;
        for (var Dt = st, er = Et; Dt !== 0 && er < this.length; er++) {
          var xt = this.words[er] | 0;
          xt += Dt, Dt = xt >>> 26, xt &= 67108863, this.words[er] = xt;
        }
        return Dt !== 0 && (this.words[er] = Dt, this.length++), this;
      }, d.prototype.isZero = function() {
        return this.length === 1 && this.words[0] === 0;
      }, d.prototype.cmpn = function(xe) {
        var Ne = xe < 0;
        if (this.negative !== 0 && !Ne) return -1;
        if (this.negative === 0 && Ne) return 1;
        this._strip();
        var Et;
        if (this.length > 1)
          Et = 1;
        else {
          Ne && (xe = -xe), y(xe <= 67108863, "Number is too big");
          var st = this.words[0] | 0;
          Et = st === xe ? 0 : st < xe ? -1 : 1;
        }
        return this.negative !== 0 ? -Et | 0 : Et;
      }, d.prototype.cmp = function(xe) {
        if (this.negative !== 0 && xe.negative === 0) return -1;
        if (this.negative === 0 && xe.negative !== 0) return 1;
        var Ne = this.ucmp(xe);
        return this.negative !== 0 ? -Ne | 0 : Ne;
      }, d.prototype.ucmp = function(xe) {
        if (this.length > xe.length) return 1;
        if (this.length < xe.length) return -1;
        for (var Ne = 0, Et = this.length - 1; Et >= 0; Et--) {
          var st = this.words[Et] | 0, Dt = xe.words[Et] | 0;
          if (st !== Dt) {
            st < Dt ? Ne = -1 : st > Dt && (Ne = 1);
            break;
          }
        }
        return Ne;
      }, d.prototype.gtn = function(xe) {
        return this.cmpn(xe) === 1;
      }, d.prototype.gt = function(xe) {
        return this.cmp(xe) === 1;
      }, d.prototype.gten = function(xe) {
        return this.cmpn(xe) >= 0;
      }, d.prototype.gte = function(xe) {
        return this.cmp(xe) >= 0;
      }, d.prototype.ltn = function(xe) {
        return this.cmpn(xe) === -1;
      }, d.prototype.lt = function(xe) {
        return this.cmp(xe) === -1;
      }, d.prototype.lten = function(xe) {
        return this.cmpn(xe) <= 0;
      }, d.prototype.lte = function(xe) {
        return this.cmp(xe) <= 0;
      }, d.prototype.eqn = function(xe) {
        return this.cmpn(xe) === 0;
      }, d.prototype.eq = function(xe) {
        return this.cmp(xe) === 0;
      }, d.red = function(xe) {
        return new be(xe);
      }, d.prototype.toRed = function(xe) {
        return y(!this.red, "Already a number in reduction context"), y(this.negative === 0, "red works only with positives"), xe.convertTo(this)._forceRed(xe);
      }, d.prototype.fromRed = function() {
        return y(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
      }, d.prototype._forceRed = function(xe) {
        return this.red = xe, this;
      }, d.prototype.forceRed = function(xe) {
        return y(!this.red, "Already a number in reduction context"), this._forceRed(xe);
      }, d.prototype.redAdd = function(xe) {
        return y(this.red, "redAdd works only with red numbers"), this.red.add(this, xe);
      }, d.prototype.redIAdd = function(xe) {
        return y(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, xe);
      }, d.prototype.redSub = function(xe) {
        return y(this.red, "redSub works only with red numbers"), this.red.sub(this, xe);
      }, d.prototype.redISub = function(xe) {
        return y(this.red, "redISub works only with red numbers"), this.red.isub(this, xe);
      }, d.prototype.redShl = function(xe) {
        return y(this.red, "redShl works only with red numbers"), this.red.shl(this, xe);
      }, d.prototype.redMul = function(xe) {
        return y(this.red, "redMul works only with red numbers"), this.red._verify2(this, xe), this.red.mul(this, xe);
      }, d.prototype.redIMul = function(xe) {
        return y(this.red, "redMul works only with red numbers"), this.red._verify2(this, xe), this.red.imul(this, xe);
      }, d.prototype.redSqr = function() {
        return y(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
      }, d.prototype.redISqr = function() {
        return y(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
      }, d.prototype.redSqrt = function() {
        return y(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
      }, d.prototype.redInvm = function() {
        return y(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
      }, d.prototype.redNeg = function() {
        return y(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
      }, d.prototype.redPow = function(xe) {
        return y(this.red && !xe.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, xe);
      };
      var ze = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
      };
      function He(ke, xe) {
        this.name = ke, this.p = new d(xe, 16), this.n = this.p.bitLength(), this.k = new d(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
      }
      He.prototype._tmp = function() {
        var xe = new d(null);
        return xe.words = new Array(Math.ceil(this.n / 13)), xe;
      }, He.prototype.ireduce = function(xe) {
        var Ne = xe, Et;
        do
          this.split(Ne, this.tmp), Ne = this.imulK(Ne), Ne = Ne.iadd(this.tmp), Et = Ne.bitLength();
        while (Et > this.n);
        var st = Et < this.n ? -1 : Ne.ucmp(this.p);
        return st === 0 ? (Ne.words[0] = 0, Ne.length = 1) : st > 0 ? Ne.isub(this.p) : Ne.strip !== void 0 ? Ne.strip() : Ne._strip(), Ne;
      }, He.prototype.split = function(xe, Ne) {
        xe.iushrn(this.n, 0, Ne);
      }, He.prototype.imulK = function(xe) {
        return xe.imul(this.k);
      };
      function Pe() {
        He.call(
          this,
          "k256",
          "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
        );
      }
      t(Pe, He), Pe.prototype.split = function(xe, Ne) {
        for (var Et = 4194303, st = Math.min(xe.length, 9), Dt = 0; Dt < st; Dt++)
          Ne.words[Dt] = xe.words[Dt];
        if (Ne.length = st, xe.length <= 9) {
          xe.words[0] = 0, xe.length = 1;
          return;
        }
        var er = xe.words[9];
        for (Ne.words[Ne.length++] = er & Et, Dt = 10; Dt < xe.length; Dt++) {
          var xt = xe.words[Dt] | 0;
          xe.words[Dt - 10] = (xt & Et) << 4 | er >>> 22, er = xt;
        }
        er >>>= 22, xe.words[Dt - 10] = er, er === 0 && xe.length > 10 ? xe.length -= 10 : xe.length -= 9;
      }, Pe.prototype.imulK = function(xe) {
        xe.words[xe.length] = 0, xe.words[xe.length + 1] = 0, xe.length += 2;
        for (var Ne = 0, Et = 0; Et < xe.length; Et++) {
          var st = xe.words[Et] | 0;
          Ne += st * 977, xe.words[Et] = Ne & 67108863, Ne = st * 64 + (Ne / 67108864 | 0);
        }
        return xe.words[xe.length - 1] === 0 && (xe.length--, xe.words[xe.length - 1] === 0 && xe.length--), xe;
      };
      function De() {
        He.call(
          this,
          "p224",
          "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001"
        );
      }
      t(De, He);
      function ve() {
        He.call(
          this,
          "p192",
          "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff"
        );
      }
      t(ve, He);
      function Fe() {
        He.call(
          this,
          "25519",
          "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
        );
      }
      t(Fe, He), Fe.prototype.imulK = function(xe) {
        for (var Ne = 0, Et = 0; Et < xe.length; Et++) {
          var st = (xe.words[Et] | 0) * 19 + Ne, Dt = st & 67108863;
          st >>>= 26, xe.words[Et] = Dt, Ne = st;
        }
        return Ne !== 0 && (xe.words[xe.length++] = Ne), xe;
      }, d._prime = function(xe) {
        if (ze[xe]) return ze[xe];
        var Ne;
        if (xe === "k256")
          Ne = new Pe();
        else if (xe === "p224")
          Ne = new De();
        else if (xe === "p192")
          Ne = new ve();
        else if (xe === "p25519")
          Ne = new Fe();
        else
          throw new Error("Unknown prime " + xe);
        return ze[xe] = Ne, Ne;
      };
      function be(ke) {
        if (typeof ke == "string") {
          var xe = d._prime(ke);
          this.m = xe.p, this.prime = xe;
        } else
          y(ke.gtn(1), "modulus must be greater than 1"), this.m = ke, this.prime = null;
      }
      be.prototype._verify1 = function(xe) {
        y(xe.negative === 0, "red works only with positives"), y(xe.red, "red works only with red numbers");
      }, be.prototype._verify2 = function(xe, Ne) {
        y((xe.negative | Ne.negative) === 0, "red works only with positives"), y(
          xe.red && xe.red === Ne.red,
          "red works only with red numbers"
        );
      }, be.prototype.imod = function(xe) {
        return this.prime ? this.prime.ireduce(xe)._forceRed(this) : (v(xe, xe.umod(this.m)._forceRed(this)), xe);
      }, be.prototype.neg = function(xe) {
        return xe.isZero() ? xe.clone() : this.m.sub(xe)._forceRed(this);
      }, be.prototype.add = function(xe, Ne) {
        this._verify2(xe, Ne);
        var Et = xe.add(Ne);
        return Et.cmp(this.m) >= 0 && Et.isub(this.m), Et._forceRed(this);
      }, be.prototype.iadd = function(xe, Ne) {
        this._verify2(xe, Ne);
        var Et = xe.iadd(Ne);
        return Et.cmp(this.m) >= 0 && Et.isub(this.m), Et;
      }, be.prototype.sub = function(xe, Ne) {
        this._verify2(xe, Ne);
        var Et = xe.sub(Ne);
        return Et.cmpn(0) < 0 && Et.iadd(this.m), Et._forceRed(this);
      }, be.prototype.isub = function(xe, Ne) {
        this._verify2(xe, Ne);
        var Et = xe.isub(Ne);
        return Et.cmpn(0) < 0 && Et.iadd(this.m), Et;
      }, be.prototype.shl = function(xe, Ne) {
        return this._verify1(xe), this.imod(xe.ushln(Ne));
      }, be.prototype.imul = function(xe, Ne) {
        return this._verify2(xe, Ne), this.imod(xe.imul(Ne));
      }, be.prototype.mul = function(xe, Ne) {
        return this._verify2(xe, Ne), this.imod(xe.mul(Ne));
      }, be.prototype.isqr = function(xe) {
        return this.imul(xe, xe.clone());
      }, be.prototype.sqr = function(xe) {
        return this.mul(xe, xe);
      }, be.prototype.sqrt = function(xe) {
        if (xe.isZero()) return xe.clone();
        var Ne = this.m.andln(3);
        if (y(Ne % 2 === 1), Ne === 3) {
          var Et = this.m.add(new d(1)).iushrn(2);
          return this.pow(xe, Et);
        }
        for (var st = this.m.subn(1), Dt = 0; !st.isZero() && st.andln(1) === 0; )
          Dt++, st.iushrn(1);
        y(!st.isZero());
        var er = new d(1).toRed(this), xt = er.redNeg(), ir = this.m.subn(1).iushrn(1), sr = this.m.bitLength();
        for (sr = new d(2 * sr * sr).toRed(this); this.pow(sr, ir).cmp(xt) !== 0; )
          sr.redIAdd(xt);
        for (var yr = this.pow(sr, st), wr = this.pow(xe, st.addn(1).iushrn(1)), qr = this.pow(xe, st), Mr = Dt; qr.cmp(er) !== 0; ) {
          for (var Dr = qr, Qr = 0; Dr.cmp(er) !== 0; Qr++)
            Dr = Dr.redSqr();
          y(Qr < Mr);
          var Xr = this.pow(yr, new d(1).iushln(Mr - Qr - 1));
          wr = wr.redMul(Xr), yr = Xr.redSqr(), qr = qr.redMul(yr), Mr = Qr;
        }
        return wr;
      }, be.prototype.invm = function(xe) {
        var Ne = xe._invmp(this.m);
        return Ne.negative !== 0 ? (Ne.negative = 0, this.imod(Ne).redNeg()) : this.imod(Ne);
      }, be.prototype.pow = function(xe, Ne) {
        if (Ne.isZero()) return new d(1).toRed(this);
        if (Ne.cmpn(1) === 0) return xe.clone();
        var Et = 4, st = new Array(1 << Et);
        st[0] = new d(1).toRed(this), st[1] = xe;
        for (var Dt = 2; Dt < st.length; Dt++)
          st[Dt] = this.mul(st[Dt - 1], xe);
        var er = st[0], xt = 0, ir = 0, sr = Ne.bitLength() % 26;
        for (sr === 0 && (sr = 26), Dt = Ne.length - 1; Dt >= 0; Dt--) {
          for (var yr = Ne.words[Dt], wr = sr - 1; wr >= 0; wr--) {
            var qr = yr >> wr & 1;
            if (er !== st[0] && (er = this.sqr(er)), qr === 0 && xt === 0) {
              ir = 0;
              continue;
            }
            xt <<= 1, xt |= qr, ir++, !(ir !== Et && (Dt !== 0 || wr !== 0)) && (er = this.mul(er, st[xt]), ir = 0, xt = 0);
          }
          sr = 26;
        }
        return er;
      }, be.prototype.convertTo = function(xe) {
        var Ne = xe.umod(this.m);
        return Ne === xe ? Ne.clone() : Ne;
      }, be.prototype.convertFrom = function(xe) {
        var Ne = xe.clone();
        return Ne.red = null, Ne;
      }, d.mont = function(xe) {
        return new Be(xe);
      };
      function Be(ke) {
        be.call(this, ke), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new d(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
      }
      t(Be, be), Be.prototype.convertTo = function(xe) {
        return this.imod(xe.ushln(this.shift));
      }, Be.prototype.convertFrom = function(xe) {
        var Ne = this.imod(xe.mul(this.rinv));
        return Ne.red = null, Ne;
      }, Be.prototype.imul = function(xe, Ne) {
        if (xe.isZero() || Ne.isZero())
          return xe.words[0] = 0, xe.length = 1, xe;
        var Et = xe.imul(Ne), st = Et.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), Dt = Et.isub(st).iushrn(this.shift), er = Dt;
        return Dt.cmp(this.m) >= 0 ? er = Dt.isub(this.m) : Dt.cmpn(0) < 0 && (er = Dt.iadd(this.m)), er._forceRed(this);
      }, Be.prototype.mul = function(xe, Ne) {
        if (xe.isZero() || Ne.isZero()) return new d(0)._forceRed(this);
        var Et = xe.mul(Ne), st = Et.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), Dt = Et.isub(st).iushrn(this.shift), er = Dt;
        return Dt.cmp(this.m) >= 0 ? er = Dt.isub(this.m) : Dt.cmpn(0) < 0 && (er = Dt.iadd(this.m)), er._forceRed(this);
      }, Be.prototype.invm = function(xe) {
        var Ne = this.imod(xe._invmp(this.m).mul(this.r2));
        return Ne._forceRed(this);
      };
    })(o, bn$1);
  }(bn$2)), bn$2.exports;
}
var browserifyRsa, hasRequiredBrowserifyRsa;
function requireBrowserifyRsa() {
  if (hasRequiredBrowserifyRsa) return browserifyRsa;
  hasRequiredBrowserifyRsa = 1;
  var o = requireBn(), g = requireBrowser$9(), c = requireSafeBuffer$1().Buffer;
  function y(E) {
    var B = E.modulus.byteLength(), D;
    do
      D = new o(g(B));
    while (D.cmp(E.modulus) >= 0 || !D.umod(E.prime1) || !D.umod(E.prime2));
    return D;
  }
  function t(E) {
    var B = y(E), D = B.toRed(o.mont(E.modulus)).redPow(new o(E.publicExponent)).fromRed();
    return { blinder: D, unblinder: B.invm(E.modulus) };
  }
  function d(E, B) {
    var D = t(B), x = B.modulus.byteLength(), v = new o(E).mul(D.blinder).umod(B.modulus), F = v.toRed(o.mont(B.prime1)), M = v.toRed(o.mont(B.prime2)), U = B.coefficient, L = B.prime1, H = B.prime2, fe = F.redPow(B.exponent1).fromRed(), ge = M.redPow(B.exponent2).fromRed(), Ie = fe.isub(ge).imul(U).umod(L).imul(H);
    return ge.iadd(Ie).imul(D.unblinder).umod(B.modulus).toArrayLike(c, "be", x);
  }
  return d.getr = y, browserifyRsa = d, browserifyRsa;
}
var elliptic$2 = {};
const version$2 = "6.6.1", require$$0$1 = {
  version: version$2
};
var utils$c = {}, utils$b = {}, hasRequiredUtils$a;
function requireUtils$a() {
  return hasRequiredUtils$a || (hasRequiredUtils$a = 1, function(o) {
    var g = o;
    function c(d, E) {
      if (Array.isArray(d))
        return d.slice();
      if (!d)
        return [];
      var B = [];
      if (typeof d != "string") {
        for (var D = 0; D < d.length; D++)
          B[D] = d[D] | 0;
        return B;
      }
      if (E === "hex") {
        d = d.replace(/[^a-z0-9]+/ig, ""), d.length % 2 !== 0 && (d = "0" + d);
        for (var D = 0; D < d.length; D += 2)
          B.push(parseInt(d[D] + d[D + 1], 16));
      } else
        for (var D = 0; D < d.length; D++) {
          var x = d.charCodeAt(D), v = x >> 8, F = x & 255;
          v ? B.push(v, F) : B.push(F);
        }
      return B;
    }
    g.toArray = c;
    function y(d) {
      return d.length === 1 ? "0" + d : d;
    }
    g.zero2 = y;
    function t(d) {
      for (var E = "", B = 0; B < d.length; B++)
        E += y(d[B].toString(16));
      return E;
    }
    g.toHex = t, g.encode = function(E, B) {
      return B === "hex" ? t(E) : E;
    };
  }(utils$b)), utils$b;
}
var hasRequiredUtils$9;
function requireUtils$9() {
  return hasRequiredUtils$9 || (hasRequiredUtils$9 = 1, function(o) {
    var g = o, c = requireBn$1(), y = requireMinimalisticAssert(), t = requireUtils$a();
    g.assert = y, g.toArray = t.toArray, g.zero2 = t.zero2, g.toHex = t.toHex, g.encode = t.encode;
    function d(v, F, M) {
      var U = new Array(Math.max(v.bitLength(), M) + 1), L;
      for (L = 0; L < U.length; L += 1)
        U[L] = 0;
      var H = 1 << F + 1, fe = v.clone();
      for (L = 0; L < U.length; L++) {
        var ge, Ie = fe.andln(H - 1);
        fe.isOdd() ? (Ie > (H >> 1) - 1 ? ge = (H >> 1) - Ie : ge = Ie, fe.isubn(ge)) : ge = 0, U[L] = ge, fe.iushrn(1);
      }
      return U;
    }
    g.getNAF = d;
    function E(v, F) {
      var M = [
        [],
        []
      ];
      v = v.clone(), F = F.clone();
      for (var U = 0, L = 0, H; v.cmpn(-U) > 0 || F.cmpn(-L) > 0; ) {
        var fe = v.andln(3) + U & 3, ge = F.andln(3) + L & 3;
        fe === 3 && (fe = -1), ge === 3 && (ge = -1);
        var Ie;
        (fe & 1) === 0 ? Ie = 0 : (H = v.andln(7) + U & 7, (H === 3 || H === 5) && ge === 2 ? Ie = -fe : Ie = fe), M[0].push(Ie);
        var Ee;
        (ge & 1) === 0 ? Ee = 0 : (H = F.andln(7) + L & 7, (H === 3 || H === 5) && fe === 2 ? Ee = -ge : Ee = ge), M[1].push(Ee), 2 * U === Ie + 1 && (U = 1 - U), 2 * L === Ee + 1 && (L = 1 - L), v.iushrn(1), F.iushrn(1);
      }
      return M;
    }
    g.getJSF = E;
    function B(v, F, M) {
      var U = "_" + F;
      v.prototype[F] = function() {
        return this[U] !== void 0 ? this[U] : this[U] = M.call(this);
      };
    }
    g.cachedProperty = B;
    function D(v) {
      return typeof v == "string" ? g.toArray(v, "hex") : v;
    }
    g.parseBytes = D;
    function x(v) {
      return new c(v, "hex", "le");
    }
    g.intFromLE = x;
  }(utils$c)), utils$c;
}
var curve$1 = {}, base$2, hasRequiredBase$2;
function requireBase$2() {
  if (hasRequiredBase$2) return base$2;
  hasRequiredBase$2 = 1;
  var o = requireBn$1(), g = requireUtils$9(), c = g.getNAF, y = g.getJSF, t = g.assert;
  function d(B, D) {
    this.type = B, this.p = new o(D.p, 16), this.red = D.prime ? o.red(D.prime) : o.mont(this.p), this.zero = new o(0).toRed(this.red), this.one = new o(1).toRed(this.red), this.two = new o(2).toRed(this.red), this.n = D.n && new o(D.n, 16), this.g = D.g && this.pointFromJSON(D.g, D.gRed), this._wnafT1 = new Array(4), this._wnafT2 = new Array(4), this._wnafT3 = new Array(4), this._wnafT4 = new Array(4), this._bitLength = this.n ? this.n.bitLength() : 0;
    var x = this.n && this.p.div(this.n);
    !x || x.cmpn(100) > 0 ? this.redN = null : (this._maxwellTrick = !0, this.redN = this.n.toRed(this.red));
  }
  base$2 = d, d.prototype.point = function() {
    throw new Error("Not implemented");
  }, d.prototype.validate = function() {
    throw new Error("Not implemented");
  }, d.prototype._fixedNafMul = function(D, x) {
    t(D.precomputed);
    var v = D._getDoubles(), F = c(x, 1, this._bitLength), M = (1 << v.step + 1) - (v.step % 2 === 0 ? 2 : 1);
    M /= 3;
    var U = [], L, H;
    for (L = 0; L < F.length; L += v.step) {
      H = 0;
      for (var fe = L + v.step - 1; fe >= L; fe--)
        H = (H << 1) + F[fe];
      U.push(H);
    }
    for (var ge = this.jpoint(null, null, null), Ie = this.jpoint(null, null, null), Ee = M; Ee > 0; Ee--) {
      for (L = 0; L < U.length; L++)
        H = U[L], H === Ee ? Ie = Ie.mixedAdd(v.points[L]) : H === -Ee && (Ie = Ie.mixedAdd(v.points[L].neg()));
      ge = ge.add(Ie);
    }
    return ge.toP();
  }, d.prototype._wnafMul = function(D, x) {
    var v = 4, F = D._getNAFPoints(v);
    v = F.wnd;
    for (var M = F.points, U = c(x, v, this._bitLength), L = this.jpoint(null, null, null), H = U.length - 1; H >= 0; H--) {
      for (var fe = 0; H >= 0 && U[H] === 0; H--)
        fe++;
      if (H >= 0 && fe++, L = L.dblp(fe), H < 0)
        break;
      var ge = U[H];
      t(ge !== 0), D.type === "affine" ? ge > 0 ? L = L.mixedAdd(M[ge - 1 >> 1]) : L = L.mixedAdd(M[-ge - 1 >> 1].neg()) : ge > 0 ? L = L.add(M[ge - 1 >> 1]) : L = L.add(M[-ge - 1 >> 1].neg());
    }
    return D.type === "affine" ? L.toP() : L;
  }, d.prototype._wnafMulAdd = function(D, x, v, F, M) {
    var U = this._wnafT1, L = this._wnafT2, H = this._wnafT3, fe = 0, ge, Ie, Ee;
    for (ge = 0; ge < F; ge++) {
      Ee = x[ge];
      var Se = Ee._getNAFPoints(D);
      U[ge] = Se.wnd, L[ge] = Se.points;
    }
    for (ge = F - 1; ge >= 1; ge -= 2) {
      var ze = ge - 1, He = ge;
      if (U[ze] !== 1 || U[He] !== 1) {
        H[ze] = c(v[ze], U[ze], this._bitLength), H[He] = c(v[He], U[He], this._bitLength), fe = Math.max(H[ze].length, fe), fe = Math.max(H[He].length, fe);
        continue;
      }
      var Pe = [
        x[ze],
        /* 1 */
        null,
        /* 3 */
        null,
        /* 5 */
        x[He]
        /* 7 */
      ];
      x[ze].y.cmp(x[He].y) === 0 ? (Pe[1] = x[ze].add(x[He]), Pe[2] = x[ze].toJ().mixedAdd(x[He].neg())) : x[ze].y.cmp(x[He].y.redNeg()) === 0 ? (Pe[1] = x[ze].toJ().mixedAdd(x[He]), Pe[2] = x[ze].add(x[He].neg())) : (Pe[1] = x[ze].toJ().mixedAdd(x[He]), Pe[2] = x[ze].toJ().mixedAdd(x[He].neg()));
      var De = [
        -3,
        /* -1 -1 */
        -1,
        /* -1 0 */
        -5,
        /* -1 1 */
        -7,
        /* 0 -1 */
        0,
        /* 0 0 */
        7,
        /* 0 1 */
        5,
        /* 1 -1 */
        1,
        /* 1 0 */
        3
        /* 1 1 */
      ], ve = y(v[ze], v[He]);
      for (fe = Math.max(ve[0].length, fe), H[ze] = new Array(fe), H[He] = new Array(fe), Ie = 0; Ie < fe; Ie++) {
        var Fe = ve[0][Ie] | 0, be = ve[1][Ie] | 0;
        H[ze][Ie] = De[(Fe + 1) * 3 + (be + 1)], H[He][Ie] = 0, L[ze] = Pe;
      }
    }
    var Be = this.jpoint(null, null, null), ke = this._wnafT4;
    for (ge = fe; ge >= 0; ge--) {
      for (var xe = 0; ge >= 0; ) {
        var Ne = !0;
        for (Ie = 0; Ie < F; Ie++)
          ke[Ie] = H[Ie][ge] | 0, ke[Ie] !== 0 && (Ne = !1);
        if (!Ne)
          break;
        xe++, ge--;
      }
      if (ge >= 0 && xe++, Be = Be.dblp(xe), ge < 0)
        break;
      for (Ie = 0; Ie < F; Ie++) {
        var Et = ke[Ie];
        Et !== 0 && (Et > 0 ? Ee = L[Ie][Et - 1 >> 1] : Et < 0 && (Ee = L[Ie][-Et - 1 >> 1].neg()), Ee.type === "affine" ? Be = Be.mixedAdd(Ee) : Be = Be.add(Ee));
      }
    }
    for (ge = 0; ge < F; ge++)
      L[ge] = null;
    return M ? Be : Be.toP();
  };
  function E(B, D) {
    this.curve = B, this.type = D, this.precomputed = null;
  }
  return d.BasePoint = E, E.prototype.eq = function() {
    throw new Error("Not implemented");
  }, E.prototype.validate = function() {
    return this.curve.validate(this);
  }, d.prototype.decodePoint = function(D, x) {
    D = g.toArray(D, x);
    var v = this.p.byteLength();
    if ((D[0] === 4 || D[0] === 6 || D[0] === 7) && D.length - 1 === 2 * v) {
      D[0] === 6 ? t(D[D.length - 1] % 2 === 0) : D[0] === 7 && t(D[D.length - 1] % 2 === 1);
      var F = this.point(
        D.slice(1, 1 + v),
        D.slice(1 + v, 1 + 2 * v)
      );
      return F;
    } else if ((D[0] === 2 || D[0] === 3) && D.length - 1 === v)
      return this.pointFromX(D.slice(1, 1 + v), D[0] === 3);
    throw new Error("Unknown point format");
  }, E.prototype.encodeCompressed = function(D) {
    return this.encode(D, !0);
  }, E.prototype._encode = function(D) {
    var x = this.curve.p.byteLength(), v = this.getX().toArray("be", x);
    return D ? [this.getY().isEven() ? 2 : 3].concat(v) : [4].concat(v, this.getY().toArray("be", x));
  }, E.prototype.encode = function(D, x) {
    return g.encode(this._encode(x), D);
  }, E.prototype.precompute = function(D) {
    if (this.precomputed)
      return this;
    var x = {
      doubles: null,
      naf: null,
      beta: null
    };
    return x.naf = this._getNAFPoints(8), x.doubles = this._getDoubles(4, D), x.beta = this._getBeta(), this.precomputed = x, this;
  }, E.prototype._hasDoubles = function(D) {
    if (!this.precomputed)
      return !1;
    var x = this.precomputed.doubles;
    return x ? x.points.length >= Math.ceil((D.bitLength() + 1) / x.step) : !1;
  }, E.prototype._getDoubles = function(D, x) {
    if (this.precomputed && this.precomputed.doubles)
      return this.precomputed.doubles;
    for (var v = [this], F = this, M = 0; M < x; M += D) {
      for (var U = 0; U < D; U++)
        F = F.dbl();
      v.push(F);
    }
    return {
      step: D,
      points: v
    };
  }, E.prototype._getNAFPoints = function(D) {
    if (this.precomputed && this.precomputed.naf)
      return this.precomputed.naf;
    for (var x = [this], v = (1 << D) - 1, F = v === 1 ? null : this.dbl(), M = 1; M < v; M++)
      x[M] = x[M - 1].add(F);
    return {
      wnd: D,
      points: x
    };
  }, E.prototype._getBeta = function() {
    return null;
  }, E.prototype.dblp = function(D) {
    for (var x = this, v = 0; v < D; v++)
      x = x.dbl();
    return x;
  }, base$2;
}
var short, hasRequiredShort;
function requireShort() {
  if (hasRequiredShort) return short;
  hasRequiredShort = 1;
  var o = requireUtils$9(), g = requireBn$1(), c = requireInherits_browser(), y = requireBase$2(), t = o.assert;
  function d(D) {
    y.call(this, "short", D), this.a = new g(D.a, 16).toRed(this.red), this.b = new g(D.b, 16).toRed(this.red), this.tinv = this.two.redInvm(), this.zeroA = this.a.fromRed().cmpn(0) === 0, this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0, this.endo = this._getEndomorphism(D), this._endoWnafT1 = new Array(4), this._endoWnafT2 = new Array(4);
  }
  c(d, y), short = d, d.prototype._getEndomorphism = function(x) {
    if (!(!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1)) {
      var v, F;
      if (x.beta)
        v = new g(x.beta, 16).toRed(this.red);
      else {
        var M = this._getEndoRoots(this.p);
        v = M[0].cmp(M[1]) < 0 ? M[0] : M[1], v = v.toRed(this.red);
      }
      if (x.lambda)
        F = new g(x.lambda, 16);
      else {
        var U = this._getEndoRoots(this.n);
        this.g.mul(U[0]).x.cmp(this.g.x.redMul(v)) === 0 ? F = U[0] : (F = U[1], t(this.g.mul(F).x.cmp(this.g.x.redMul(v)) === 0));
      }
      var L;
      return x.basis ? L = x.basis.map(function(H) {
        return {
          a: new g(H.a, 16),
          b: new g(H.b, 16)
        };
      }) : L = this._getEndoBasis(F), {
        beta: v,
        lambda: F,
        basis: L
      };
    }
  }, d.prototype._getEndoRoots = function(x) {
    var v = x === this.p ? this.red : g.mont(x), F = new g(2).toRed(v).redInvm(), M = F.redNeg(), U = new g(3).toRed(v).redNeg().redSqrt().redMul(F), L = M.redAdd(U).fromRed(), H = M.redSub(U).fromRed();
    return [L, H];
  }, d.prototype._getEndoBasis = function(x) {
    for (var v = this.n.ushrn(Math.floor(this.n.bitLength() / 2)), F = x, M = this.n.clone(), U = new g(1), L = new g(0), H = new g(0), fe = new g(1), ge, Ie, Ee, Se, ze, He, Pe, De = 0, ve, Fe; F.cmpn(0) !== 0; ) {
      var be = M.div(F);
      ve = M.sub(be.mul(F)), Fe = H.sub(be.mul(U));
      var Be = fe.sub(be.mul(L));
      if (!Ee && ve.cmp(v) < 0)
        ge = Pe.neg(), Ie = U, Ee = ve.neg(), Se = Fe;
      else if (Ee && ++De === 2)
        break;
      Pe = ve, M = F, F = ve, H = U, U = Fe, fe = L, L = Be;
    }
    ze = ve.neg(), He = Fe;
    var ke = Ee.sqr().add(Se.sqr()), xe = ze.sqr().add(He.sqr());
    return xe.cmp(ke) >= 0 && (ze = ge, He = Ie), Ee.negative && (Ee = Ee.neg(), Se = Se.neg()), ze.negative && (ze = ze.neg(), He = He.neg()), [
      { a: Ee, b: Se },
      { a: ze, b: He }
    ];
  }, d.prototype._endoSplit = function(x) {
    var v = this.endo.basis, F = v[0], M = v[1], U = M.b.mul(x).divRound(this.n), L = F.b.neg().mul(x).divRound(this.n), H = U.mul(F.a), fe = L.mul(M.a), ge = U.mul(F.b), Ie = L.mul(M.b), Ee = x.sub(H).sub(fe), Se = ge.add(Ie).neg();
    return { k1: Ee, k2: Se };
  }, d.prototype.pointFromX = function(x, v) {
    x = new g(x, 16), x.red || (x = x.toRed(this.red));
    var F = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b), M = F.redSqrt();
    if (M.redSqr().redSub(F).cmp(this.zero) !== 0)
      throw new Error("invalid point");
    var U = M.fromRed().isOdd();
    return (v && !U || !v && U) && (M = M.redNeg()), this.point(x, M);
  }, d.prototype.validate = function(x) {
    if (x.inf)
      return !0;
    var v = x.x, F = x.y, M = this.a.redMul(v), U = v.redSqr().redMul(v).redIAdd(M).redIAdd(this.b);
    return F.redSqr().redISub(U).cmpn(0) === 0;
  }, d.prototype._endoWnafMulAdd = function(x, v, F) {
    for (var M = this._endoWnafT1, U = this._endoWnafT2, L = 0; L < x.length; L++) {
      var H = this._endoSplit(v[L]), fe = x[L], ge = fe._getBeta();
      H.k1.negative && (H.k1.ineg(), fe = fe.neg(!0)), H.k2.negative && (H.k2.ineg(), ge = ge.neg(!0)), M[L * 2] = fe, M[L * 2 + 1] = ge, U[L * 2] = H.k1, U[L * 2 + 1] = H.k2;
    }
    for (var Ie = this._wnafMulAdd(1, M, U, L * 2, F), Ee = 0; Ee < L * 2; Ee++)
      M[Ee] = null, U[Ee] = null;
    return Ie;
  };
  function E(D, x, v, F) {
    y.BasePoint.call(this, D, "affine"), x === null && v === null ? (this.x = null, this.y = null, this.inf = !0) : (this.x = new g(x, 16), this.y = new g(v, 16), F && (this.x.forceRed(this.curve.red), this.y.forceRed(this.curve.red)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.inf = !1);
  }
  c(E, y.BasePoint), d.prototype.point = function(x, v, F) {
    return new E(this, x, v, F);
  }, d.prototype.pointFromJSON = function(x, v) {
    return E.fromJSON(this, x, v);
  }, E.prototype._getBeta = function() {
    if (this.curve.endo) {
      var x = this.precomputed;
      if (x && x.beta)
        return x.beta;
      var v = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
      if (x) {
        var F = this.curve, M = function(U) {
          return F.point(U.x.redMul(F.endo.beta), U.y);
        };
        x.beta = v, v.precomputed = {
          beta: null,
          naf: x.naf && {
            wnd: x.naf.wnd,
            points: x.naf.points.map(M)
          },
          doubles: x.doubles && {
            step: x.doubles.step,
            points: x.doubles.points.map(M)
          }
        };
      }
      return v;
    }
  }, E.prototype.toJSON = function() {
    return this.precomputed ? [this.x, this.y, this.precomputed && {
      doubles: this.precomputed.doubles && {
        step: this.precomputed.doubles.step,
        points: this.precomputed.doubles.points.slice(1)
      },
      naf: this.precomputed.naf && {
        wnd: this.precomputed.naf.wnd,
        points: this.precomputed.naf.points.slice(1)
      }
    }] : [this.x, this.y];
  }, E.fromJSON = function(x, v, F) {
    typeof v == "string" && (v = JSON.parse(v));
    var M = x.point(v[0], v[1], F);
    if (!v[2])
      return M;
    function U(H) {
      return x.point(H[0], H[1], F);
    }
    var L = v[2];
    return M.precomputed = {
      beta: null,
      doubles: L.doubles && {
        step: L.doubles.step,
        points: [M].concat(L.doubles.points.map(U))
      },
      naf: L.naf && {
        wnd: L.naf.wnd,
        points: [M].concat(L.naf.points.map(U))
      }
    }, M;
  }, E.prototype.inspect = function() {
    return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + ">";
  }, E.prototype.isInfinity = function() {
    return this.inf;
  }, E.prototype.add = function(x) {
    if (this.inf)
      return x;
    if (x.inf)
      return this;
    if (this.eq(x))
      return this.dbl();
    if (this.neg().eq(x))
      return this.curve.point(null, null);
    if (this.x.cmp(x.x) === 0)
      return this.curve.point(null, null);
    var v = this.y.redSub(x.y);
    v.cmpn(0) !== 0 && (v = v.redMul(this.x.redSub(x.x).redInvm()));
    var F = v.redSqr().redISub(this.x).redISub(x.x), M = v.redMul(this.x.redSub(F)).redISub(this.y);
    return this.curve.point(F, M);
  }, E.prototype.dbl = function() {
    if (this.inf)
      return this;
    var x = this.y.redAdd(this.y);
    if (x.cmpn(0) === 0)
      return this.curve.point(null, null);
    var v = this.curve.a, F = this.x.redSqr(), M = x.redInvm(), U = F.redAdd(F).redIAdd(F).redIAdd(v).redMul(M), L = U.redSqr().redISub(this.x.redAdd(this.x)), H = U.redMul(this.x.redSub(L)).redISub(this.y);
    return this.curve.point(L, H);
  }, E.prototype.getX = function() {
    return this.x.fromRed();
  }, E.prototype.getY = function() {
    return this.y.fromRed();
  }, E.prototype.mul = function(x) {
    return x = new g(x, 16), this.isInfinity() ? this : this._hasDoubles(x) ? this.curve._fixedNafMul(this, x) : this.curve.endo ? this.curve._endoWnafMulAdd([this], [x]) : this.curve._wnafMul(this, x);
  }, E.prototype.mulAdd = function(x, v, F) {
    var M = [this, v], U = [x, F];
    return this.curve.endo ? this.curve._endoWnafMulAdd(M, U) : this.curve._wnafMulAdd(1, M, U, 2);
  }, E.prototype.jmulAdd = function(x, v, F) {
    var M = [this, v], U = [x, F];
    return this.curve.endo ? this.curve._endoWnafMulAdd(M, U, !0) : this.curve._wnafMulAdd(1, M, U, 2, !0);
  }, E.prototype.eq = function(x) {
    return this === x || this.inf === x.inf && (this.inf || this.x.cmp(x.x) === 0 && this.y.cmp(x.y) === 0);
  }, E.prototype.neg = function(x) {
    if (this.inf)
      return this;
    var v = this.curve.point(this.x, this.y.redNeg());
    if (x && this.precomputed) {
      var F = this.precomputed, M = function(U) {
        return U.neg();
      };
      v.precomputed = {
        naf: F.naf && {
          wnd: F.naf.wnd,
          points: F.naf.points.map(M)
        },
        doubles: F.doubles && {
          step: F.doubles.step,
          points: F.doubles.points.map(M)
        }
      };
    }
    return v;
  }, E.prototype.toJ = function() {
    if (this.inf)
      return this.curve.jpoint(null, null, null);
    var x = this.curve.jpoint(this.x, this.y, this.curve.one);
    return x;
  };
  function B(D, x, v, F) {
    y.BasePoint.call(this, D, "jacobian"), x === null && v === null && F === null ? (this.x = this.curve.one, this.y = this.curve.one, this.z = new g(0)) : (this.x = new g(x, 16), this.y = new g(v, 16), this.z = new g(F, 16)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)), this.zOne = this.z === this.curve.one;
  }
  return c(B, y.BasePoint), d.prototype.jpoint = function(x, v, F) {
    return new B(this, x, v, F);
  }, B.prototype.toP = function() {
    if (this.isInfinity())
      return this.curve.point(null, null);
    var x = this.z.redInvm(), v = x.redSqr(), F = this.x.redMul(v), M = this.y.redMul(v).redMul(x);
    return this.curve.point(F, M);
  }, B.prototype.neg = function() {
    return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
  }, B.prototype.add = function(x) {
    if (this.isInfinity())
      return x;
    if (x.isInfinity())
      return this;
    var v = x.z.redSqr(), F = this.z.redSqr(), M = this.x.redMul(v), U = x.x.redMul(F), L = this.y.redMul(v.redMul(x.z)), H = x.y.redMul(F.redMul(this.z)), fe = M.redSub(U), ge = L.redSub(H);
    if (fe.cmpn(0) === 0)
      return ge.cmpn(0) !== 0 ? this.curve.jpoint(null, null, null) : this.dbl();
    var Ie = fe.redSqr(), Ee = Ie.redMul(fe), Se = M.redMul(Ie), ze = ge.redSqr().redIAdd(Ee).redISub(Se).redISub(Se), He = ge.redMul(Se.redISub(ze)).redISub(L.redMul(Ee)), Pe = this.z.redMul(x.z).redMul(fe);
    return this.curve.jpoint(ze, He, Pe);
  }, B.prototype.mixedAdd = function(x) {
    if (this.isInfinity())
      return x.toJ();
    if (x.isInfinity())
      return this;
    var v = this.z.redSqr(), F = this.x, M = x.x.redMul(v), U = this.y, L = x.y.redMul(v).redMul(this.z), H = F.redSub(M), fe = U.redSub(L);
    if (H.cmpn(0) === 0)
      return fe.cmpn(0) !== 0 ? this.curve.jpoint(null, null, null) : this.dbl();
    var ge = H.redSqr(), Ie = ge.redMul(H), Ee = F.redMul(ge), Se = fe.redSqr().redIAdd(Ie).redISub(Ee).redISub(Ee), ze = fe.redMul(Ee.redISub(Se)).redISub(U.redMul(Ie)), He = this.z.redMul(H);
    return this.curve.jpoint(Se, ze, He);
  }, B.prototype.dblp = function(x) {
    if (x === 0)
      return this;
    if (this.isInfinity())
      return this;
    if (!x)
      return this.dbl();
    var v;
    if (this.curve.zeroA || this.curve.threeA) {
      var F = this;
      for (v = 0; v < x; v++)
        F = F.dbl();
      return F;
    }
    var M = this.curve.a, U = this.curve.tinv, L = this.x, H = this.y, fe = this.z, ge = fe.redSqr().redSqr(), Ie = H.redAdd(H);
    for (v = 0; v < x; v++) {
      var Ee = L.redSqr(), Se = Ie.redSqr(), ze = Se.redSqr(), He = Ee.redAdd(Ee).redIAdd(Ee).redIAdd(M.redMul(ge)), Pe = L.redMul(Se), De = He.redSqr().redISub(Pe.redAdd(Pe)), ve = Pe.redISub(De), Fe = He.redMul(ve);
      Fe = Fe.redIAdd(Fe).redISub(ze);
      var be = Ie.redMul(fe);
      v + 1 < x && (ge = ge.redMul(ze)), L = De, fe = be, Ie = Fe;
    }
    return this.curve.jpoint(L, Ie.redMul(U), fe);
  }, B.prototype.dbl = function() {
    return this.isInfinity() ? this : this.curve.zeroA ? this._zeroDbl() : this.curve.threeA ? this._threeDbl() : this._dbl();
  }, B.prototype._zeroDbl = function() {
    var x, v, F;
    if (this.zOne) {
      var M = this.x.redSqr(), U = this.y.redSqr(), L = U.redSqr(), H = this.x.redAdd(U).redSqr().redISub(M).redISub(L);
      H = H.redIAdd(H);
      var fe = M.redAdd(M).redIAdd(M), ge = fe.redSqr().redISub(H).redISub(H), Ie = L.redIAdd(L);
      Ie = Ie.redIAdd(Ie), Ie = Ie.redIAdd(Ie), x = ge, v = fe.redMul(H.redISub(ge)).redISub(Ie), F = this.y.redAdd(this.y);
    } else {
      var Ee = this.x.redSqr(), Se = this.y.redSqr(), ze = Se.redSqr(), He = this.x.redAdd(Se).redSqr().redISub(Ee).redISub(ze);
      He = He.redIAdd(He);
      var Pe = Ee.redAdd(Ee).redIAdd(Ee), De = Pe.redSqr(), ve = ze.redIAdd(ze);
      ve = ve.redIAdd(ve), ve = ve.redIAdd(ve), x = De.redISub(He).redISub(He), v = Pe.redMul(He.redISub(x)).redISub(ve), F = this.y.redMul(this.z), F = F.redIAdd(F);
    }
    return this.curve.jpoint(x, v, F);
  }, B.prototype._threeDbl = function() {
    var x, v, F;
    if (this.zOne) {
      var M = this.x.redSqr(), U = this.y.redSqr(), L = U.redSqr(), H = this.x.redAdd(U).redSqr().redISub(M).redISub(L);
      H = H.redIAdd(H);
      var fe = M.redAdd(M).redIAdd(M).redIAdd(this.curve.a), ge = fe.redSqr().redISub(H).redISub(H);
      x = ge;
      var Ie = L.redIAdd(L);
      Ie = Ie.redIAdd(Ie), Ie = Ie.redIAdd(Ie), v = fe.redMul(H.redISub(ge)).redISub(Ie), F = this.y.redAdd(this.y);
    } else {
      var Ee = this.z.redSqr(), Se = this.y.redSqr(), ze = this.x.redMul(Se), He = this.x.redSub(Ee).redMul(this.x.redAdd(Ee));
      He = He.redAdd(He).redIAdd(He);
      var Pe = ze.redIAdd(ze);
      Pe = Pe.redIAdd(Pe);
      var De = Pe.redAdd(Pe);
      x = He.redSqr().redISub(De), F = this.y.redAdd(this.z).redSqr().redISub(Se).redISub(Ee);
      var ve = Se.redSqr();
      ve = ve.redIAdd(ve), ve = ve.redIAdd(ve), ve = ve.redIAdd(ve), v = He.redMul(Pe.redISub(x)).redISub(ve);
    }
    return this.curve.jpoint(x, v, F);
  }, B.prototype._dbl = function() {
    var x = this.curve.a, v = this.x, F = this.y, M = this.z, U = M.redSqr().redSqr(), L = v.redSqr(), H = F.redSqr(), fe = L.redAdd(L).redIAdd(L).redIAdd(x.redMul(U)), ge = v.redAdd(v);
    ge = ge.redIAdd(ge);
    var Ie = ge.redMul(H), Ee = fe.redSqr().redISub(Ie.redAdd(Ie)), Se = Ie.redISub(Ee), ze = H.redSqr();
    ze = ze.redIAdd(ze), ze = ze.redIAdd(ze), ze = ze.redIAdd(ze);
    var He = fe.redMul(Se).redISub(ze), Pe = F.redAdd(F).redMul(M);
    return this.curve.jpoint(Ee, He, Pe);
  }, B.prototype.trpl = function() {
    if (!this.curve.zeroA)
      return this.dbl().add(this);
    var x = this.x.redSqr(), v = this.y.redSqr(), F = this.z.redSqr(), M = v.redSqr(), U = x.redAdd(x).redIAdd(x), L = U.redSqr(), H = this.x.redAdd(v).redSqr().redISub(x).redISub(M);
    H = H.redIAdd(H), H = H.redAdd(H).redIAdd(H), H = H.redISub(L);
    var fe = H.redSqr(), ge = M.redIAdd(M);
    ge = ge.redIAdd(ge), ge = ge.redIAdd(ge), ge = ge.redIAdd(ge);
    var Ie = U.redIAdd(H).redSqr().redISub(L).redISub(fe).redISub(ge), Ee = v.redMul(Ie);
    Ee = Ee.redIAdd(Ee), Ee = Ee.redIAdd(Ee);
    var Se = this.x.redMul(fe).redISub(Ee);
    Se = Se.redIAdd(Se), Se = Se.redIAdd(Se);
    var ze = this.y.redMul(Ie.redMul(ge.redISub(Ie)).redISub(H.redMul(fe)));
    ze = ze.redIAdd(ze), ze = ze.redIAdd(ze), ze = ze.redIAdd(ze);
    var He = this.z.redAdd(H).redSqr().redISub(F).redISub(fe);
    return this.curve.jpoint(Se, ze, He);
  }, B.prototype.mul = function(x, v) {
    return x = new g(x, v), this.curve._wnafMul(this, x);
  }, B.prototype.eq = function(x) {
    if (x.type === "affine")
      return this.eq(x.toJ());
    if (this === x)
      return !0;
    var v = this.z.redSqr(), F = x.z.redSqr();
    if (this.x.redMul(F).redISub(x.x.redMul(v)).cmpn(0) !== 0)
      return !1;
    var M = v.redMul(this.z), U = F.redMul(x.z);
    return this.y.redMul(U).redISub(x.y.redMul(M)).cmpn(0) === 0;
  }, B.prototype.eqXToP = function(x) {
    var v = this.z.redSqr(), F = x.toRed(this.curve.red).redMul(v);
    if (this.x.cmp(F) === 0)
      return !0;
    for (var M = x.clone(), U = this.curve.redN.redMul(v); ; ) {
      if (M.iadd(this.curve.n), M.cmp(this.curve.p) >= 0)
        return !1;
      if (F.redIAdd(U), this.x.cmp(F) === 0)
        return !0;
    }
  }, B.prototype.inspect = function() {
    return this.isInfinity() ? "<EC JPoint Infinity>" : "<EC JPoint x: " + this.x.toString(16, 2) + " y: " + this.y.toString(16, 2) + " z: " + this.z.toString(16, 2) + ">";
  }, B.prototype.isInfinity = function() {
    return this.z.cmpn(0) === 0;
  }, short;
}
var mont, hasRequiredMont;
function requireMont() {
  if (hasRequiredMont) return mont;
  hasRequiredMont = 1;
  var o = requireBn$1(), g = requireInherits_browser(), c = requireBase$2(), y = requireUtils$9();
  function t(E) {
    c.call(this, "mont", E), this.a = new o(E.a, 16).toRed(this.red), this.b = new o(E.b, 16).toRed(this.red), this.i4 = new o(4).toRed(this.red).redInvm(), this.two = new o(2).toRed(this.red), this.a24 = this.i4.redMul(this.a.redAdd(this.two));
  }
  g(t, c), mont = t, t.prototype.validate = function(B) {
    var D = B.normalize().x, x = D.redSqr(), v = x.redMul(D).redAdd(x.redMul(this.a)).redAdd(D), F = v.redSqrt();
    return F.redSqr().cmp(v) === 0;
  };
  function d(E, B, D) {
    c.BasePoint.call(this, E, "projective"), B === null && D === null ? (this.x = this.curve.one, this.z = this.curve.zero) : (this.x = new o(B, 16), this.z = new o(D, 16), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)));
  }
  return g(d, c.BasePoint), t.prototype.decodePoint = function(B, D) {
    return this.point(y.toArray(B, D), 1);
  }, t.prototype.point = function(B, D) {
    return new d(this, B, D);
  }, t.prototype.pointFromJSON = function(B) {
    return d.fromJSON(this, B);
  }, d.prototype.precompute = function() {
  }, d.prototype._encode = function() {
    return this.getX().toArray("be", this.curve.p.byteLength());
  }, d.fromJSON = function(B, D) {
    return new d(B, D[0], D[1] || B.one);
  }, d.prototype.inspect = function() {
    return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
  }, d.prototype.isInfinity = function() {
    return this.z.cmpn(0) === 0;
  }, d.prototype.dbl = function() {
    var B = this.x.redAdd(this.z), D = B.redSqr(), x = this.x.redSub(this.z), v = x.redSqr(), F = D.redSub(v), M = D.redMul(v), U = F.redMul(v.redAdd(this.curve.a24.redMul(F)));
    return this.curve.point(M, U);
  }, d.prototype.add = function() {
    throw new Error("Not supported on Montgomery curve");
  }, d.prototype.diffAdd = function(B, D) {
    var x = this.x.redAdd(this.z), v = this.x.redSub(this.z), F = B.x.redAdd(B.z), M = B.x.redSub(B.z), U = M.redMul(x), L = F.redMul(v), H = D.z.redMul(U.redAdd(L).redSqr()), fe = D.x.redMul(U.redISub(L).redSqr());
    return this.curve.point(H, fe);
  }, d.prototype.mul = function(B) {
    for (var D = B.clone(), x = this, v = this.curve.point(null, null), F = this, M = []; D.cmpn(0) !== 0; D.iushrn(1))
      M.push(D.andln(1));
    for (var U = M.length - 1; U >= 0; U--)
      M[U] === 0 ? (x = x.diffAdd(v, F), v = v.dbl()) : (v = x.diffAdd(v, F), x = x.dbl());
    return v;
  }, d.prototype.mulAdd = function() {
    throw new Error("Not supported on Montgomery curve");
  }, d.prototype.jumlAdd = function() {
    throw new Error("Not supported on Montgomery curve");
  }, d.prototype.eq = function(B) {
    return this.getX().cmp(B.getX()) === 0;
  }, d.prototype.normalize = function() {
    return this.x = this.x.redMul(this.z.redInvm()), this.z = this.curve.one, this;
  }, d.prototype.getX = function() {
    return this.normalize(), this.x.fromRed();
  }, mont;
}
var edwards$1, hasRequiredEdwards$1;
function requireEdwards$1() {
  if (hasRequiredEdwards$1) return edwards$1;
  hasRequiredEdwards$1 = 1;
  var o = requireUtils$9(), g = requireBn$1(), c = requireInherits_browser(), y = requireBase$2(), t = o.assert;
  function d(B) {
    this.twisted = (B.a | 0) !== 1, this.mOneA = this.twisted && (B.a | 0) === -1, this.extended = this.mOneA, y.call(this, "edwards", B), this.a = new g(B.a, 16).umod(this.red.m), this.a = this.a.toRed(this.red), this.c = new g(B.c, 16).toRed(this.red), this.c2 = this.c.redSqr(), this.d = new g(B.d, 16).toRed(this.red), this.dd = this.d.redAdd(this.d), t(!this.twisted || this.c.fromRed().cmpn(1) === 0), this.oneC = (B.c | 0) === 1;
  }
  c(d, y), edwards$1 = d, d.prototype._mulA = function(D) {
    return this.mOneA ? D.redNeg() : this.a.redMul(D);
  }, d.prototype._mulC = function(D) {
    return this.oneC ? D : this.c.redMul(D);
  }, d.prototype.jpoint = function(D, x, v, F) {
    return this.point(D, x, v, F);
  }, d.prototype.pointFromX = function(D, x) {
    D = new g(D, 16), D.red || (D = D.toRed(this.red));
    var v = D.redSqr(), F = this.c2.redSub(this.a.redMul(v)), M = this.one.redSub(this.c2.redMul(this.d).redMul(v)), U = F.redMul(M.redInvm()), L = U.redSqrt();
    if (L.redSqr().redSub(U).cmp(this.zero) !== 0)
      throw new Error("invalid point");
    var H = L.fromRed().isOdd();
    return (x && !H || !x && H) && (L = L.redNeg()), this.point(D, L);
  }, d.prototype.pointFromY = function(D, x) {
    D = new g(D, 16), D.red || (D = D.toRed(this.red));
    var v = D.redSqr(), F = v.redSub(this.c2), M = v.redMul(this.d).redMul(this.c2).redSub(this.a), U = F.redMul(M.redInvm());
    if (U.cmp(this.zero) === 0) {
      if (x)
        throw new Error("invalid point");
      return this.point(this.zero, D);
    }
    var L = U.redSqrt();
    if (L.redSqr().redSub(U).cmp(this.zero) !== 0)
      throw new Error("invalid point");
    return L.fromRed().isOdd() !== x && (L = L.redNeg()), this.point(L, D);
  }, d.prototype.validate = function(D) {
    if (D.isInfinity())
      return !0;
    D.normalize();
    var x = D.x.redSqr(), v = D.y.redSqr(), F = x.redMul(this.a).redAdd(v), M = this.c2.redMul(this.one.redAdd(this.d.redMul(x).redMul(v)));
    return F.cmp(M) === 0;
  };
  function E(B, D, x, v, F) {
    y.BasePoint.call(this, B, "projective"), D === null && x === null && v === null ? (this.x = this.curve.zero, this.y = this.curve.one, this.z = this.curve.one, this.t = this.curve.zero, this.zOne = !0) : (this.x = new g(D, 16), this.y = new g(x, 16), this.z = v ? new g(v, 16) : this.curve.one, this.t = F && new g(F, 16), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)), this.t && !this.t.red && (this.t = this.t.toRed(this.curve.red)), this.zOne = this.z === this.curve.one, this.curve.extended && !this.t && (this.t = this.x.redMul(this.y), this.zOne || (this.t = this.t.redMul(this.z.redInvm()))));
  }
  return c(E, y.BasePoint), d.prototype.pointFromJSON = function(D) {
    return E.fromJSON(this, D);
  }, d.prototype.point = function(D, x, v, F) {
    return new E(this, D, x, v, F);
  }, E.fromJSON = function(D, x) {
    return new E(D, x[0], x[1], x[2]);
  }, E.prototype.inspect = function() {
    return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
  }, E.prototype.isInfinity = function() {
    return this.x.cmpn(0) === 0 && (this.y.cmp(this.z) === 0 || this.zOne && this.y.cmp(this.curve.c) === 0);
  }, E.prototype._extDbl = function() {
    var D = this.x.redSqr(), x = this.y.redSqr(), v = this.z.redSqr();
    v = v.redIAdd(v);
    var F = this.curve._mulA(D), M = this.x.redAdd(this.y).redSqr().redISub(D).redISub(x), U = F.redAdd(x), L = U.redSub(v), H = F.redSub(x), fe = M.redMul(L), ge = U.redMul(H), Ie = M.redMul(H), Ee = L.redMul(U);
    return this.curve.point(fe, ge, Ee, Ie);
  }, E.prototype._projDbl = function() {
    var D = this.x.redAdd(this.y).redSqr(), x = this.x.redSqr(), v = this.y.redSqr(), F, M, U, L, H, fe;
    if (this.curve.twisted) {
      L = this.curve._mulA(x);
      var ge = L.redAdd(v);
      this.zOne ? (F = D.redSub(x).redSub(v).redMul(ge.redSub(this.curve.two)), M = ge.redMul(L.redSub(v)), U = ge.redSqr().redSub(ge).redSub(ge)) : (H = this.z.redSqr(), fe = ge.redSub(H).redISub(H), F = D.redSub(x).redISub(v).redMul(fe), M = ge.redMul(L.redSub(v)), U = ge.redMul(fe));
    } else
      L = x.redAdd(v), H = this.curve._mulC(this.z).redSqr(), fe = L.redSub(H).redSub(H), F = this.curve._mulC(D.redISub(L)).redMul(fe), M = this.curve._mulC(L).redMul(x.redISub(v)), U = L.redMul(fe);
    return this.curve.point(F, M, U);
  }, E.prototype.dbl = function() {
    return this.isInfinity() ? this : this.curve.extended ? this._extDbl() : this._projDbl();
  }, E.prototype._extAdd = function(D) {
    var x = this.y.redSub(this.x).redMul(D.y.redSub(D.x)), v = this.y.redAdd(this.x).redMul(D.y.redAdd(D.x)), F = this.t.redMul(this.curve.dd).redMul(D.t), M = this.z.redMul(D.z.redAdd(D.z)), U = v.redSub(x), L = M.redSub(F), H = M.redAdd(F), fe = v.redAdd(x), ge = U.redMul(L), Ie = H.redMul(fe), Ee = U.redMul(fe), Se = L.redMul(H);
    return this.curve.point(ge, Ie, Se, Ee);
  }, E.prototype._projAdd = function(D) {
    var x = this.z.redMul(D.z), v = x.redSqr(), F = this.x.redMul(D.x), M = this.y.redMul(D.y), U = this.curve.d.redMul(F).redMul(M), L = v.redSub(U), H = v.redAdd(U), fe = this.x.redAdd(this.y).redMul(D.x.redAdd(D.y)).redISub(F).redISub(M), ge = x.redMul(L).redMul(fe), Ie, Ee;
    return this.curve.twisted ? (Ie = x.redMul(H).redMul(M.redSub(this.curve._mulA(F))), Ee = L.redMul(H)) : (Ie = x.redMul(H).redMul(M.redSub(F)), Ee = this.curve._mulC(L).redMul(H)), this.curve.point(ge, Ie, Ee);
  }, E.prototype.add = function(D) {
    return this.isInfinity() ? D : D.isInfinity() ? this : this.curve.extended ? this._extAdd(D) : this._projAdd(D);
  }, E.prototype.mul = function(D) {
    return this._hasDoubles(D) ? this.curve._fixedNafMul(this, D) : this.curve._wnafMul(this, D);
  }, E.prototype.mulAdd = function(D, x, v) {
    return this.curve._wnafMulAdd(1, [this, x], [D, v], 2, !1);
  }, E.prototype.jmulAdd = function(D, x, v) {
    return this.curve._wnafMulAdd(1, [this, x], [D, v], 2, !0);
  }, E.prototype.normalize = function() {
    if (this.zOne)
      return this;
    var D = this.z.redInvm();
    return this.x = this.x.redMul(D), this.y = this.y.redMul(D), this.t && (this.t = this.t.redMul(D)), this.z = this.curve.one, this.zOne = !0, this;
  }, E.prototype.neg = function() {
    return this.curve.point(
      this.x.redNeg(),
      this.y,
      this.z,
      this.t && this.t.redNeg()
    );
  }, E.prototype.getX = function() {
    return this.normalize(), this.x.fromRed();
  }, E.prototype.getY = function() {
    return this.normalize(), this.y.fromRed();
  }, E.prototype.eq = function(D) {
    return this === D || this.getX().cmp(D.getX()) === 0 && this.getY().cmp(D.getY()) === 0;
  }, E.prototype.eqXToP = function(D) {
    var x = D.toRed(this.curve.red).redMul(this.z);
    if (this.x.cmp(x) === 0)
      return !0;
    for (var v = D.clone(), F = this.curve.redN.redMul(this.z); ; ) {
      if (v.iadd(this.curve.n), v.cmp(this.curve.p) >= 0)
        return !1;
      if (x.redIAdd(F), this.x.cmp(x) === 0)
        return !0;
    }
  }, E.prototype.toP = E.prototype.normalize, E.prototype.mixedAdd = E.prototype.add, edwards$1;
}
var hasRequiredCurve$1;
function requireCurve$1() {
  return hasRequiredCurve$1 || (hasRequiredCurve$1 = 1, function(o) {
    var g = o;
    g.base = requireBase$2(), g.short = requireShort(), g.mont = requireMont(), g.edwards = requireEdwards$1();
  }(curve$1)), curve$1;
}
var curves = {}, hash$o = {}, utils$a = {}, hasRequiredUtils$8;
function requireUtils$8() {
  if (hasRequiredUtils$8) return utils$a;
  hasRequiredUtils$8 = 1;
  var o = requireMinimalisticAssert(), g = requireInherits_browser();
  utils$a.inherits = g;
  function c(Be, ke) {
    return (Be.charCodeAt(ke) & 64512) !== 55296 || ke < 0 || ke + 1 >= Be.length ? !1 : (Be.charCodeAt(ke + 1) & 64512) === 56320;
  }
  function y(Be, ke) {
    if (Array.isArray(Be))
      return Be.slice();
    if (!Be)
      return [];
    var xe = [];
    if (typeof Be == "string")
      if (ke) {
        if (ke === "hex")
          for (Be = Be.replace(/[^a-z0-9]+/ig, ""), Be.length % 2 !== 0 && (Be = "0" + Be), Et = 0; Et < Be.length; Et += 2)
            xe.push(parseInt(Be[Et] + Be[Et + 1], 16));
      } else for (var Ne = 0, Et = 0; Et < Be.length; Et++) {
        var st = Be.charCodeAt(Et);
        st < 128 ? xe[Ne++] = st : st < 2048 ? (xe[Ne++] = st >> 6 | 192, xe[Ne++] = st & 63 | 128) : c(Be, Et) ? (st = 65536 + ((st & 1023) << 10) + (Be.charCodeAt(++Et) & 1023), xe[Ne++] = st >> 18 | 240, xe[Ne++] = st >> 12 & 63 | 128, xe[Ne++] = st >> 6 & 63 | 128, xe[Ne++] = st & 63 | 128) : (xe[Ne++] = st >> 12 | 224, xe[Ne++] = st >> 6 & 63 | 128, xe[Ne++] = st & 63 | 128);
      }
    else
      for (Et = 0; Et < Be.length; Et++)
        xe[Et] = Be[Et] | 0;
    return xe;
  }
  utils$a.toArray = y;
  function t(Be) {
    for (var ke = "", xe = 0; xe < Be.length; xe++)
      ke += B(Be[xe].toString(16));
    return ke;
  }
  utils$a.toHex = t;
  function d(Be) {
    var ke = Be >>> 24 | Be >>> 8 & 65280 | Be << 8 & 16711680 | (Be & 255) << 24;
    return ke >>> 0;
  }
  utils$a.htonl = d;
  function E(Be, ke) {
    for (var xe = "", Ne = 0; Ne < Be.length; Ne++) {
      var Et = Be[Ne];
      ke === "little" && (Et = d(Et)), xe += D(Et.toString(16));
    }
    return xe;
  }
  utils$a.toHex32 = E;
  function B(Be) {
    return Be.length === 1 ? "0" + Be : Be;
  }
  utils$a.zero2 = B;
  function D(Be) {
    return Be.length === 7 ? "0" + Be : Be.length === 6 ? "00" + Be : Be.length === 5 ? "000" + Be : Be.length === 4 ? "0000" + Be : Be.length === 3 ? "00000" + Be : Be.length === 2 ? "000000" + Be : Be.length === 1 ? "0000000" + Be : Be;
  }
  utils$a.zero8 = D;
  function x(Be, ke, xe, Ne) {
    var Et = xe - ke;
    o(Et % 4 === 0);
    for (var st = new Array(Et / 4), Dt = 0, er = ke; Dt < st.length; Dt++, er += 4) {
      var xt;
      Ne === "big" ? xt = Be[er] << 24 | Be[er + 1] << 16 | Be[er + 2] << 8 | Be[er + 3] : xt = Be[er + 3] << 24 | Be[er + 2] << 16 | Be[er + 1] << 8 | Be[er], st[Dt] = xt >>> 0;
    }
    return st;
  }
  utils$a.join32 = x;
  function v(Be, ke) {
    for (var xe = new Array(Be.length * 4), Ne = 0, Et = 0; Ne < Be.length; Ne++, Et += 4) {
      var st = Be[Ne];
      ke === "big" ? (xe[Et] = st >>> 24, xe[Et + 1] = st >>> 16 & 255, xe[Et + 2] = st >>> 8 & 255, xe[Et + 3] = st & 255) : (xe[Et + 3] = st >>> 24, xe[Et + 2] = st >>> 16 & 255, xe[Et + 1] = st >>> 8 & 255, xe[Et] = st & 255);
    }
    return xe;
  }
  utils$a.split32 = v;
  function F(Be, ke) {
    return Be >>> ke | Be << 32 - ke;
  }
  utils$a.rotr32 = F;
  function M(Be, ke) {
    return Be << ke | Be >>> 32 - ke;
  }
  utils$a.rotl32 = M;
  function U(Be, ke) {
    return Be + ke >>> 0;
  }
  utils$a.sum32 = U;
  function L(Be, ke, xe) {
    return Be + ke + xe >>> 0;
  }
  utils$a.sum32_3 = L;
  function H(Be, ke, xe, Ne) {
    return Be + ke + xe + Ne >>> 0;
  }
  utils$a.sum32_4 = H;
  function fe(Be, ke, xe, Ne, Et) {
    return Be + ke + xe + Ne + Et >>> 0;
  }
  utils$a.sum32_5 = fe;
  function ge(Be, ke, xe, Ne) {
    var Et = Be[ke], st = Be[ke + 1], Dt = Ne + st >>> 0, er = (Dt < Ne ? 1 : 0) + xe + Et;
    Be[ke] = er >>> 0, Be[ke + 1] = Dt;
  }
  utils$a.sum64 = ge;
  function Ie(Be, ke, xe, Ne) {
    var Et = ke + Ne >>> 0, st = (Et < ke ? 1 : 0) + Be + xe;
    return st >>> 0;
  }
  utils$a.sum64_hi = Ie;
  function Ee(Be, ke, xe, Ne) {
    var Et = ke + Ne;
    return Et >>> 0;
  }
  utils$a.sum64_lo = Ee;
  function Se(Be, ke, xe, Ne, Et, st, Dt, er) {
    var xt = 0, ir = ke;
    ir = ir + Ne >>> 0, xt += ir < ke ? 1 : 0, ir = ir + st >>> 0, xt += ir < st ? 1 : 0, ir = ir + er >>> 0, xt += ir < er ? 1 : 0;
    var sr = Be + xe + Et + Dt + xt;
    return sr >>> 0;
  }
  utils$a.sum64_4_hi = Se;
  function ze(Be, ke, xe, Ne, Et, st, Dt, er) {
    var xt = ke + Ne + st + er;
    return xt >>> 0;
  }
  utils$a.sum64_4_lo = ze;
  function He(Be, ke, xe, Ne, Et, st, Dt, er, xt, ir) {
    var sr = 0, yr = ke;
    yr = yr + Ne >>> 0, sr += yr < ke ? 1 : 0, yr = yr + st >>> 0, sr += yr < st ? 1 : 0, yr = yr + er >>> 0, sr += yr < er ? 1 : 0, yr = yr + ir >>> 0, sr += yr < ir ? 1 : 0;
    var wr = Be + xe + Et + Dt + xt + sr;
    return wr >>> 0;
  }
  utils$a.sum64_5_hi = He;
  function Pe(Be, ke, xe, Ne, Et, st, Dt, er, xt, ir) {
    var sr = ke + Ne + st + er + ir;
    return sr >>> 0;
  }
  utils$a.sum64_5_lo = Pe;
  function De(Be, ke, xe) {
    var Ne = ke << 32 - xe | Be >>> xe;
    return Ne >>> 0;
  }
  utils$a.rotr64_hi = De;
  function ve(Be, ke, xe) {
    var Ne = Be << 32 - xe | ke >>> xe;
    return Ne >>> 0;
  }
  utils$a.rotr64_lo = ve;
  function Fe(Be, ke, xe) {
    return Be >>> xe;
  }
  utils$a.shr64_hi = Fe;
  function be(Be, ke, xe) {
    var Ne = Be << 32 - xe | ke >>> xe;
    return Ne >>> 0;
  }
  return utils$a.shr64_lo = be, utils$a;
}
var common$2 = {}, hasRequiredCommon$2;
function requireCommon$2() {
  if (hasRequiredCommon$2) return common$2;
  hasRequiredCommon$2 = 1;
  var o = requireUtils$8(), g = requireMinimalisticAssert();
  function c() {
    this.pending = null, this.pendingTotal = 0, this.blockSize = this.constructor.blockSize, this.outSize = this.constructor.outSize, this.hmacStrength = this.constructor.hmacStrength, this.padLength = this.constructor.padLength / 8, this.endian = "big", this._delta8 = this.blockSize / 8, this._delta32 = this.blockSize / 32;
  }
  return common$2.BlockHash = c, c.prototype.update = function(t, d) {
    if (t = o.toArray(t, d), this.pending ? this.pending = this.pending.concat(t) : this.pending = t, this.pendingTotal += t.length, this.pending.length >= this._delta8) {
      t = this.pending;
      var E = t.length % this._delta8;
      this.pending = t.slice(t.length - E, t.length), this.pending.length === 0 && (this.pending = null), t = o.join32(t, 0, t.length - E, this.endian);
      for (var B = 0; B < t.length; B += this._delta32)
        this._update(t, B, B + this._delta32);
    }
    return this;
  }, c.prototype.digest = function(t) {
    return this.update(this._pad()), g(this.pending === null), this._digest(t);
  }, c.prototype._pad = function() {
    var t = this.pendingTotal, d = this._delta8, E = d - (t + this.padLength) % d, B = new Array(E + this.padLength);
    B[0] = 128;
    for (var D = 1; D < E; D++)
      B[D] = 0;
    if (t <<= 3, this.endian === "big") {
      for (var x = 8; x < this.padLength; x++)
        B[D++] = 0;
      B[D++] = 0, B[D++] = 0, B[D++] = 0, B[D++] = 0, B[D++] = t >>> 24 & 255, B[D++] = t >>> 16 & 255, B[D++] = t >>> 8 & 255, B[D++] = t & 255;
    } else
      for (B[D++] = t & 255, B[D++] = t >>> 8 & 255, B[D++] = t >>> 16 & 255, B[D++] = t >>> 24 & 255, B[D++] = 0, B[D++] = 0, B[D++] = 0, B[D++] = 0, x = 8; x < this.padLength; x++)
        B[D++] = 0;
    return B;
  }, common$2;
}
var sha$1 = {}, common$1 = {}, hasRequiredCommon$1;
function requireCommon$1() {
  if (hasRequiredCommon$1) return common$1;
  hasRequiredCommon$1 = 1;
  var o = requireUtils$8(), g = o.rotr32;
  function c(v, F, M, U) {
    if (v === 0)
      return y(F, M, U);
    if (v === 1 || v === 3)
      return d(F, M, U);
    if (v === 2)
      return t(F, M, U);
  }
  common$1.ft_1 = c;
  function y(v, F, M) {
    return v & F ^ ~v & M;
  }
  common$1.ch32 = y;
  function t(v, F, M) {
    return v & F ^ v & M ^ F & M;
  }
  common$1.maj32 = t;
  function d(v, F, M) {
    return v ^ F ^ M;
  }
  common$1.p32 = d;
  function E(v) {
    return g(v, 2) ^ g(v, 13) ^ g(v, 22);
  }
  common$1.s0_256 = E;
  function B(v) {
    return g(v, 6) ^ g(v, 11) ^ g(v, 25);
  }
  common$1.s1_256 = B;
  function D(v) {
    return g(v, 7) ^ g(v, 18) ^ v >>> 3;
  }
  common$1.g0_256 = D;
  function x(v) {
    return g(v, 17) ^ g(v, 19) ^ v >>> 10;
  }
  return common$1.g1_256 = x, common$1;
}
var _1, hasRequired_1;
function require_1() {
  if (hasRequired_1) return _1;
  hasRequired_1 = 1;
  var o = requireUtils$8(), g = requireCommon$2(), c = requireCommon$1(), y = o.rotl32, t = o.sum32, d = o.sum32_5, E = c.ft_1, B = g.BlockHash, D = [
    1518500249,
    1859775393,
    2400959708,
    3395469782
  ];
  function x() {
    if (!(this instanceof x))
      return new x();
    B.call(this), this.h = [
      1732584193,
      4023233417,
      2562383102,
      271733878,
      3285377520
    ], this.W = new Array(80);
  }
  return o.inherits(x, B), _1 = x, x.blockSize = 512, x.outSize = 160, x.hmacStrength = 80, x.padLength = 64, x.prototype._update = function(F, M) {
    for (var U = this.W, L = 0; L < 16; L++)
      U[L] = F[M + L];
    for (; L < U.length; L++)
      U[L] = y(U[L - 3] ^ U[L - 8] ^ U[L - 14] ^ U[L - 16], 1);
    var H = this.h[0], fe = this.h[1], ge = this.h[2], Ie = this.h[3], Ee = this.h[4];
    for (L = 0; L < U.length; L++) {
      var Se = ~~(L / 20), ze = d(y(H, 5), E(Se, fe, ge, Ie), Ee, U[L], D[Se]);
      Ee = Ie, Ie = ge, ge = y(fe, 30), fe = H, H = ze;
    }
    this.h[0] = t(this.h[0], H), this.h[1] = t(this.h[1], fe), this.h[2] = t(this.h[2], ge), this.h[3] = t(this.h[3], Ie), this.h[4] = t(this.h[4], Ee);
  }, x.prototype._digest = function(F) {
    return F === "hex" ? o.toHex32(this.h, "big") : o.split32(this.h, "big");
  }, _1;
}
var _256, hasRequired_256;
function require_256() {
  if (hasRequired_256) return _256;
  hasRequired_256 = 1;
  var o = requireUtils$8(), g = requireCommon$2(), c = requireCommon$1(), y = requireMinimalisticAssert(), t = o.sum32, d = o.sum32_4, E = o.sum32_5, B = c.ch32, D = c.maj32, x = c.s0_256, v = c.s1_256, F = c.g0_256, M = c.g1_256, U = g.BlockHash, L = [
    1116352408,
    1899447441,
    3049323471,
    3921009573,
    961987163,
    1508970993,
    2453635748,
    2870763221,
    3624381080,
    310598401,
    607225278,
    1426881987,
    1925078388,
    2162078206,
    2614888103,
    3248222580,
    3835390401,
    4022224774,
    264347078,
    604807628,
    770255983,
    1249150122,
    1555081692,
    1996064986,
    2554220882,
    2821834349,
    2952996808,
    3210313671,
    3336571891,
    3584528711,
    113926993,
    338241895,
    666307205,
    773529912,
    1294757372,
    1396182291,
    1695183700,
    1986661051,
    2177026350,
    2456956037,
    2730485921,
    2820302411,
    3259730800,
    3345764771,
    3516065817,
    3600352804,
    4094571909,
    275423344,
    430227734,
    506948616,
    659060556,
    883997877,
    958139571,
    1322822218,
    1537002063,
    1747873779,
    1955562222,
    2024104815,
    2227730452,
    2361852424,
    2428436474,
    2756734187,
    3204031479,
    3329325298
  ];
  function H() {
    if (!(this instanceof H))
      return new H();
    U.call(this), this.h = [
      1779033703,
      3144134277,
      1013904242,
      2773480762,
      1359893119,
      2600822924,
      528734635,
      1541459225
    ], this.k = L, this.W = new Array(64);
  }
  return o.inherits(H, U), _256 = H, H.blockSize = 512, H.outSize = 256, H.hmacStrength = 192, H.padLength = 64, H.prototype._update = function(ge, Ie) {
    for (var Ee = this.W, Se = 0; Se < 16; Se++)
      Ee[Se] = ge[Ie + Se];
    for (; Se < Ee.length; Se++)
      Ee[Se] = d(M(Ee[Se - 2]), Ee[Se - 7], F(Ee[Se - 15]), Ee[Se - 16]);
    var ze = this.h[0], He = this.h[1], Pe = this.h[2], De = this.h[3], ve = this.h[4], Fe = this.h[5], be = this.h[6], Be = this.h[7];
    for (y(this.k.length === Ee.length), Se = 0; Se < Ee.length; Se++) {
      var ke = E(Be, v(ve), B(ve, Fe, be), this.k[Se], Ee[Se]), xe = t(x(ze), D(ze, He, Pe));
      Be = be, be = Fe, Fe = ve, ve = t(De, ke), De = Pe, Pe = He, He = ze, ze = t(ke, xe);
    }
    this.h[0] = t(this.h[0], ze), this.h[1] = t(this.h[1], He), this.h[2] = t(this.h[2], Pe), this.h[3] = t(this.h[3], De), this.h[4] = t(this.h[4], ve), this.h[5] = t(this.h[5], Fe), this.h[6] = t(this.h[6], be), this.h[7] = t(this.h[7], Be);
  }, H.prototype._digest = function(ge) {
    return ge === "hex" ? o.toHex32(this.h, "big") : o.split32(this.h, "big");
  }, _256;
}
var _224, hasRequired_224;
function require_224() {
  if (hasRequired_224) return _224;
  hasRequired_224 = 1;
  var o = requireUtils$8(), g = require_256();
  function c() {
    if (!(this instanceof c))
      return new c();
    g.call(this), this.h = [
      3238371032,
      914150663,
      812702999,
      4144912697,
      4290775857,
      1750603025,
      1694076839,
      3204075428
    ];
  }
  return o.inherits(c, g), _224 = c, c.blockSize = 512, c.outSize = 224, c.hmacStrength = 192, c.padLength = 64, c.prototype._digest = function(t) {
    return t === "hex" ? o.toHex32(this.h.slice(0, 7), "big") : o.split32(this.h.slice(0, 7), "big");
  }, _224;
}
var _512, hasRequired_512;
function require_512() {
  if (hasRequired_512) return _512;
  hasRequired_512 = 1;
  var o = requireUtils$8(), g = requireCommon$2(), c = requireMinimalisticAssert(), y = o.rotr64_hi, t = o.rotr64_lo, d = o.shr64_hi, E = o.shr64_lo, B = o.sum64, D = o.sum64_hi, x = o.sum64_lo, v = o.sum64_4_hi, F = o.sum64_4_lo, M = o.sum64_5_hi, U = o.sum64_5_lo, L = g.BlockHash, H = [
    1116352408,
    3609767458,
    1899447441,
    602891725,
    3049323471,
    3964484399,
    3921009573,
    2173295548,
    961987163,
    4081628472,
    1508970993,
    3053834265,
    2453635748,
    2937671579,
    2870763221,
    3664609560,
    3624381080,
    2734883394,
    310598401,
    1164996542,
    607225278,
    1323610764,
    1426881987,
    3590304994,
    1925078388,
    4068182383,
    2162078206,
    991336113,
    2614888103,
    633803317,
    3248222580,
    3479774868,
    3835390401,
    2666613458,
    4022224774,
    944711139,
    264347078,
    2341262773,
    604807628,
    2007800933,
    770255983,
    1495990901,
    1249150122,
    1856431235,
    1555081692,
    3175218132,
    1996064986,
    2198950837,
    2554220882,
    3999719339,
    2821834349,
    766784016,
    2952996808,
    2566594879,
    3210313671,
    3203337956,
    3336571891,
    1034457026,
    3584528711,
    2466948901,
    113926993,
    3758326383,
    338241895,
    168717936,
    666307205,
    1188179964,
    773529912,
    1546045734,
    1294757372,
    1522805485,
    1396182291,
    2643833823,
    1695183700,
    2343527390,
    1986661051,
    1014477480,
    2177026350,
    1206759142,
    2456956037,
    344077627,
    2730485921,
    1290863460,
    2820302411,
    3158454273,
    3259730800,
    3505952657,
    3345764771,
    106217008,
    3516065817,
    3606008344,
    3600352804,
    1432725776,
    4094571909,
    1467031594,
    275423344,
    851169720,
    430227734,
    3100823752,
    506948616,
    1363258195,
    659060556,
    3750685593,
    883997877,
    3785050280,
    958139571,
    3318307427,
    1322822218,
    3812723403,
    1537002063,
    2003034995,
    1747873779,
    3602036899,
    1955562222,
    1575990012,
    2024104815,
    1125592928,
    2227730452,
    2716904306,
    2361852424,
    442776044,
    2428436474,
    593698344,
    2756734187,
    3733110249,
    3204031479,
    2999351573,
    3329325298,
    3815920427,
    3391569614,
    3928383900,
    3515267271,
    566280711,
    3940187606,
    3454069534,
    4118630271,
    4000239992,
    116418474,
    1914138554,
    174292421,
    2731055270,
    289380356,
    3203993006,
    460393269,
    320620315,
    685471733,
    587496836,
    852142971,
    1086792851,
    1017036298,
    365543100,
    1126000580,
    2618297676,
    1288033470,
    3409855158,
    1501505948,
    4234509866,
    1607167915,
    987167468,
    1816402316,
    1246189591
  ];
  function fe() {
    if (!(this instanceof fe))
      return new fe();
    L.call(this), this.h = [
      1779033703,
      4089235720,
      3144134277,
      2227873595,
      1013904242,
      4271175723,
      2773480762,
      1595750129,
      1359893119,
      2917565137,
      2600822924,
      725511199,
      528734635,
      4215389547,
      1541459225,
      327033209
    ], this.k = H, this.W = new Array(160);
  }
  o.inherits(fe, L), _512 = fe, fe.blockSize = 1024, fe.outSize = 512, fe.hmacStrength = 192, fe.padLength = 128, fe.prototype._prepareBlock = function(xe, Ne) {
    for (var Et = this.W, st = 0; st < 32; st++)
      Et[st] = xe[Ne + st];
    for (; st < Et.length; st += 2) {
      var Dt = be(Et[st - 4], Et[st - 3]), er = Be(Et[st - 4], Et[st - 3]), xt = Et[st - 14], ir = Et[st - 13], sr = ve(Et[st - 30], Et[st - 29]), yr = Fe(Et[st - 30], Et[st - 29]), wr = Et[st - 32], qr = Et[st - 31];
      Et[st] = v(
        Dt,
        er,
        xt,
        ir,
        sr,
        yr,
        wr,
        qr
      ), Et[st + 1] = F(
        Dt,
        er,
        xt,
        ir,
        sr,
        yr,
        wr,
        qr
      );
    }
  }, fe.prototype._update = function(xe, Ne) {
    this._prepareBlock(xe, Ne);
    var Et = this.W, st = this.h[0], Dt = this.h[1], er = this.h[2], xt = this.h[3], ir = this.h[4], sr = this.h[5], yr = this.h[6], wr = this.h[7], qr = this.h[8], Mr = this.h[9], Dr = this.h[10], Qr = this.h[11], Xr = this.h[12], Vr = this.h[13], Ur = this.h[14], Sr = this.h[15];
    c(this.k.length === Et.length);
    for (var Gr = 0; Gr < Et.length; Gr += 2) {
      var Fr = Ur, br = Sr, Ar = Pe(qr, Mr), cr = De(qr, Mr), hr = ge(qr, Mr, Dr, Qr, Xr), Wr = Ie(qr, Mr, Dr, Qr, Xr, Vr), fi = this.k[Gr], Bi = this.k[Gr + 1], $r = Et[Gr], oi = Et[Gr + 1], zr = M(
        Fr,
        br,
        Ar,
        cr,
        hr,
        Wr,
        fi,
        Bi,
        $r,
        oi
      ), ti = U(
        Fr,
        br,
        Ar,
        cr,
        hr,
        Wr,
        fi,
        Bi,
        $r,
        oi
      );
      Fr = ze(st, Dt), br = He(st, Dt), Ar = Ee(st, Dt, er, xt, ir), cr = Se(st, Dt, er, xt, ir, sr);
      var Lr = D(Fr, br, Ar, cr), Rr = x(Fr, br, Ar, cr);
      Ur = Xr, Sr = Vr, Xr = Dr, Vr = Qr, Dr = qr, Qr = Mr, qr = D(yr, wr, zr, ti), Mr = x(wr, wr, zr, ti), yr = ir, wr = sr, ir = er, sr = xt, er = st, xt = Dt, st = D(zr, ti, Lr, Rr), Dt = x(zr, ti, Lr, Rr);
    }
    B(this.h, 0, st, Dt), B(this.h, 2, er, xt), B(this.h, 4, ir, sr), B(this.h, 6, yr, wr), B(this.h, 8, qr, Mr), B(this.h, 10, Dr, Qr), B(this.h, 12, Xr, Vr), B(this.h, 14, Ur, Sr);
  }, fe.prototype._digest = function(xe) {
    return xe === "hex" ? o.toHex32(this.h, "big") : o.split32(this.h, "big");
  };
  function ge(ke, xe, Ne, Et, st) {
    var Dt = ke & Ne ^ ~ke & st;
    return Dt < 0 && (Dt += 4294967296), Dt;
  }
  function Ie(ke, xe, Ne, Et, st, Dt) {
    var er = xe & Et ^ ~xe & Dt;
    return er < 0 && (er += 4294967296), er;
  }
  function Ee(ke, xe, Ne, Et, st) {
    var Dt = ke & Ne ^ ke & st ^ Ne & st;
    return Dt < 0 && (Dt += 4294967296), Dt;
  }
  function Se(ke, xe, Ne, Et, st, Dt) {
    var er = xe & Et ^ xe & Dt ^ Et & Dt;
    return er < 0 && (er += 4294967296), er;
  }
  function ze(ke, xe) {
    var Ne = y(ke, xe, 28), Et = y(xe, ke, 2), st = y(xe, ke, 7), Dt = Ne ^ Et ^ st;
    return Dt < 0 && (Dt += 4294967296), Dt;
  }
  function He(ke, xe) {
    var Ne = t(ke, xe, 28), Et = t(xe, ke, 2), st = t(xe, ke, 7), Dt = Ne ^ Et ^ st;
    return Dt < 0 && (Dt += 4294967296), Dt;
  }
  function Pe(ke, xe) {
    var Ne = y(ke, xe, 14), Et = y(ke, xe, 18), st = y(xe, ke, 9), Dt = Ne ^ Et ^ st;
    return Dt < 0 && (Dt += 4294967296), Dt;
  }
  function De(ke, xe) {
    var Ne = t(ke, xe, 14), Et = t(ke, xe, 18), st = t(xe, ke, 9), Dt = Ne ^ Et ^ st;
    return Dt < 0 && (Dt += 4294967296), Dt;
  }
  function ve(ke, xe) {
    var Ne = y(ke, xe, 1), Et = y(ke, xe, 8), st = d(ke, xe, 7), Dt = Ne ^ Et ^ st;
    return Dt < 0 && (Dt += 4294967296), Dt;
  }
  function Fe(ke, xe) {
    var Ne = t(ke, xe, 1), Et = t(ke, xe, 8), st = E(ke, xe, 7), Dt = Ne ^ Et ^ st;
    return Dt < 0 && (Dt += 4294967296), Dt;
  }
  function be(ke, xe) {
    var Ne = y(ke, xe, 19), Et = y(xe, ke, 29), st = d(ke, xe, 6), Dt = Ne ^ Et ^ st;
    return Dt < 0 && (Dt += 4294967296), Dt;
  }
  function Be(ke, xe) {
    var Ne = t(ke, xe, 19), Et = t(xe, ke, 29), st = E(ke, xe, 6), Dt = Ne ^ Et ^ st;
    return Dt < 0 && (Dt += 4294967296), Dt;
  }
  return _512;
}
var _384, hasRequired_384;
function require_384() {
  if (hasRequired_384) return _384;
  hasRequired_384 = 1;
  var o = requireUtils$8(), g = require_512();
  function c() {
    if (!(this instanceof c))
      return new c();
    g.call(this), this.h = [
      3418070365,
      3238371032,
      1654270250,
      914150663,
      2438529370,
      812702999,
      355462360,
      4144912697,
      1731405415,
      4290775857,
      2394180231,
      1750603025,
      3675008525,
      1694076839,
      1203062813,
      3204075428
    ];
  }
  return o.inherits(c, g), _384 = c, c.blockSize = 1024, c.outSize = 384, c.hmacStrength = 192, c.padLength = 128, c.prototype._digest = function(t) {
    return t === "hex" ? o.toHex32(this.h.slice(0, 12), "big") : o.split32(this.h.slice(0, 12), "big");
  }, _384;
}
var hasRequiredSha$1;
function requireSha$1() {
  return hasRequiredSha$1 || (hasRequiredSha$1 = 1, sha$1.sha1 = require_1(), sha$1.sha224 = require_224(), sha$1.sha256 = require_256(), sha$1.sha384 = require_384(), sha$1.sha512 = require_512()), sha$1;
}
var ripemd$1 = {}, hasRequiredRipemd$1;
function requireRipemd$1() {
  if (hasRequiredRipemd$1) return ripemd$1;
  hasRequiredRipemd$1 = 1;
  var o = requireUtils$8(), g = requireCommon$2(), c = o.rotl32, y = o.sum32, t = o.sum32_3, d = o.sum32_4, E = g.BlockHash;
  function B() {
    if (!(this instanceof B))
      return new B();
    E.call(this), this.h = [1732584193, 4023233417, 2562383102, 271733878, 3285377520], this.endian = "little";
  }
  o.inherits(B, E), ripemd$1.ripemd160 = B, B.blockSize = 512, B.outSize = 160, B.hmacStrength = 192, B.padLength = 64, B.prototype._update = function(fe, ge) {
    for (var Ie = this.h[0], Ee = this.h[1], Se = this.h[2], ze = this.h[3], He = this.h[4], Pe = Ie, De = Ee, ve = Se, Fe = ze, be = He, Be = 0; Be < 80; Be++) {
      var ke = y(
        c(
          d(Ie, D(Be, Ee, Se, ze), fe[F[Be] + ge], x(Be)),
          U[Be]
        ),
        He
      );
      Ie = He, He = ze, ze = c(Se, 10), Se = Ee, Ee = ke, ke = y(
        c(
          d(Pe, D(79 - Be, De, ve, Fe), fe[M[Be] + ge], v(Be)),
          L[Be]
        ),
        be
      ), Pe = be, be = Fe, Fe = c(ve, 10), ve = De, De = ke;
    }
    ke = t(this.h[1], Se, Fe), this.h[1] = t(this.h[2], ze, be), this.h[2] = t(this.h[3], He, Pe), this.h[3] = t(this.h[4], Ie, De), this.h[4] = t(this.h[0], Ee, ve), this.h[0] = ke;
  }, B.prototype._digest = function(fe) {
    return fe === "hex" ? o.toHex32(this.h, "little") : o.split32(this.h, "little");
  };
  function D(H, fe, ge, Ie) {
    return H <= 15 ? fe ^ ge ^ Ie : H <= 31 ? fe & ge | ~fe & Ie : H <= 47 ? (fe | ~ge) ^ Ie : H <= 63 ? fe & Ie | ge & ~Ie : fe ^ (ge | ~Ie);
  }
  function x(H) {
    return H <= 15 ? 0 : H <= 31 ? 1518500249 : H <= 47 ? 1859775393 : H <= 63 ? 2400959708 : 2840853838;
  }
  function v(H) {
    return H <= 15 ? 1352829926 : H <= 31 ? 1548603684 : H <= 47 ? 1836072691 : H <= 63 ? 2053994217 : 0;
  }
  var F = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
  ], M = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
  ], U = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
  ], L = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
  ];
  return ripemd$1;
}
var hmac$4, hasRequiredHmac$2;
function requireHmac$2() {
  if (hasRequiredHmac$2) return hmac$4;
  hasRequiredHmac$2 = 1;
  var o = requireUtils$8(), g = requireMinimalisticAssert();
  function c(y, t, d) {
    if (!(this instanceof c))
      return new c(y, t, d);
    this.Hash = y, this.blockSize = y.blockSize / 8, this.outSize = y.outSize / 8, this.inner = null, this.outer = null, this._init(o.toArray(t, d));
  }
  return hmac$4 = c, c.prototype._init = function(t) {
    t.length > this.blockSize && (t = new this.Hash().update(t).digest()), g(t.length <= this.blockSize);
    for (var d = t.length; d < this.blockSize; d++)
      t.push(0);
    for (d = 0; d < t.length; d++)
      t[d] ^= 54;
    for (this.inner = new this.Hash().update(t), d = 0; d < t.length; d++)
      t[d] ^= 106;
    this.outer = new this.Hash().update(t);
  }, c.prototype.update = function(t, d) {
    return this.inner.update(t, d), this;
  }, c.prototype.digest = function(t) {
    return this.outer.update(this.inner.digest()), this.outer.digest(t);
  }, hmac$4;
}
var hasRequiredHash$1;
function requireHash$1() {
  return hasRequiredHash$1 || (hasRequiredHash$1 = 1, function(o) {
    var g = o;
    g.utils = requireUtils$8(), g.common = requireCommon$2(), g.sha = requireSha$1(), g.ripemd = requireRipemd$1(), g.hmac = requireHmac$2(), g.sha1 = g.sha.sha1, g.sha256 = g.sha.sha256, g.sha224 = g.sha.sha224, g.sha384 = g.sha.sha384, g.sha512 = g.sha.sha512, g.ripemd160 = g.ripemd.ripemd160;
  }(hash$o)), hash$o;
}
var secp256k1$6, hasRequiredSecp256k1$4;
function requireSecp256k1$4() {
  return hasRequiredSecp256k1$4 || (hasRequiredSecp256k1$4 = 1, secp256k1$6 = {
    doubles: {
      step: 4,
      points: [
        [
          "e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a",
          "f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821"
        ],
        [
          "8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508",
          "11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf"
        ],
        [
          "175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739",
          "d3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695"
        ],
        [
          "363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640",
          "4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9"
        ],
        [
          "8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c",
          "4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36"
        ],
        [
          "723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda",
          "96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f"
        ],
        [
          "eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa",
          "5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999"
        ],
        [
          "100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0",
          "cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09"
        ],
        [
          "e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d",
          "9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d"
        ],
        [
          "feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d",
          "e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088"
        ],
        [
          "da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1",
          "9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d"
        ],
        [
          "53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0",
          "5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8"
        ],
        [
          "8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047",
          "10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a"
        ],
        [
          "385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862",
          "283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453"
        ],
        [
          "6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7",
          "7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160"
        ],
        [
          "3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd",
          "56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0"
        ],
        [
          "85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83",
          "7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6"
        ],
        [
          "948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a",
          "53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589"
        ],
        [
          "6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8",
          "bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17"
        ],
        [
          "e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d",
          "4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda"
        ],
        [
          "e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725",
          "7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd"
        ],
        [
          "213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754",
          "4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2"
        ],
        [
          "4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c",
          "17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6"
        ],
        [
          "fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6",
          "6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f"
        ],
        [
          "76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39",
          "c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01"
        ],
        [
          "c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891",
          "893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3"
        ],
        [
          "d895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b",
          "febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f"
        ],
        [
          "b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03",
          "2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7"
        ],
        [
          "e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d",
          "eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78"
        ],
        [
          "a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070",
          "7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1"
        ],
        [
          "90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4",
          "e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150"
        ],
        [
          "8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da",
          "662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82"
        ],
        [
          "e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11",
          "1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc"
        ],
        [
          "8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e",
          "efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b"
        ],
        [
          "e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41",
          "2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51"
        ],
        [
          "b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef",
          "67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45"
        ],
        [
          "d68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8",
          "db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120"
        ],
        [
          "324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d",
          "648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84"
        ],
        [
          "4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96",
          "35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d"
        ],
        [
          "9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd",
          "ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d"
        ],
        [
          "6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5",
          "9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8"
        ],
        [
          "a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266",
          "40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8"
        ],
        [
          "7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71",
          "34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac"
        ],
        [
          "928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac",
          "c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f"
        ],
        [
          "85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751",
          "1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962"
        ],
        [
          "ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e",
          "493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907"
        ],
        [
          "827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241",
          "c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec"
        ],
        [
          "eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3",
          "be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d"
        ],
        [
          "e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f",
          "4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414"
        ],
        [
          "1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19",
          "aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd"
        ],
        [
          "146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be",
          "b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0"
        ],
        [
          "fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9",
          "6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811"
        ],
        [
          "da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2",
          "8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1"
        ],
        [
          "a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13",
          "7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c"
        ],
        [
          "174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c",
          "ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73"
        ],
        [
          "959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba",
          "2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd"
        ],
        [
          "d2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151",
          "e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405"
        ],
        [
          "64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073",
          "d99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589"
        ],
        [
          "8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458",
          "38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e"
        ],
        [
          "13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b",
          "69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27"
        ],
        [
          "bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366",
          "d3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1"
        ],
        [
          "8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa",
          "40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482"
        ],
        [
          "8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0",
          "620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945"
        ],
        [
          "dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787",
          "7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573"
        ],
        [
          "f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e",
          "ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82"
        ]
      ]
    },
    naf: {
      wnd: 7,
      points: [
        [
          "f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9",
          "388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672"
        ],
        [
          "2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4",
          "d8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6"
        ],
        [
          "5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc",
          "6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da"
        ],
        [
          "acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe",
          "cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37"
        ],
        [
          "774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb",
          "d984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b"
        ],
        [
          "f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8",
          "ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81"
        ],
        [
          "d7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e",
          "581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58"
        ],
        [
          "defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34",
          "4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77"
        ],
        [
          "2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c",
          "85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a"
        ],
        [
          "352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5",
          "321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c"
        ],
        [
          "2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f",
          "2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67"
        ],
        [
          "9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714",
          "73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402"
        ],
        [
          "daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729",
          "a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55"
        ],
        [
          "c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db",
          "2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482"
        ],
        [
          "6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4",
          "e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82"
        ],
        [
          "1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5",
          "b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396"
        ],
        [
          "605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479",
          "2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49"
        ],
        [
          "62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d",
          "80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf"
        ],
        [
          "80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f",
          "1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a"
        ],
        [
          "7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb",
          "d0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7"
        ],
        [
          "d528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9",
          "eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933"
        ],
        [
          "49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963",
          "758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a"
        ],
        [
          "77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74",
          "958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6"
        ],
        [
          "f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530",
          "e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37"
        ],
        [
          "463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b",
          "5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e"
        ],
        [
          "f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247",
          "cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6"
        ],
        [
          "caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1",
          "cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476"
        ],
        [
          "2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120",
          "4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40"
        ],
        [
          "7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435",
          "91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61"
        ],
        [
          "754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18",
          "673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683"
        ],
        [
          "e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8",
          "59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5"
        ],
        [
          "186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb",
          "3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b"
        ],
        [
          "df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f",
          "55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417"
        ],
        [
          "5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143",
          "efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868"
        ],
        [
          "290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba",
          "e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a"
        ],
        [
          "af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45",
          "f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6"
        ],
        [
          "766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a",
          "744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996"
        ],
        [
          "59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e",
          "c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e"
        ],
        [
          "f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8",
          "e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d"
        ],
        [
          "7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c",
          "30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2"
        ],
        [
          "948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519",
          "e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e"
        ],
        [
          "7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab",
          "100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437"
        ],
        [
          "3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca",
          "ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311"
        ],
        [
          "d3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf",
          "8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4"
        ],
        [
          "1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610",
          "68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575"
        ],
        [
          "733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4",
          "f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d"
        ],
        [
          "15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c",
          "d56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d"
        ],
        [
          "a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940",
          "edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629"
        ],
        [
          "e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980",
          "a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06"
        ],
        [
          "311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3",
          "66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374"
        ],
        [
          "34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf",
          "9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee"
        ],
        [
          "f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63",
          "4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1"
        ],
        [
          "d7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448",
          "fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b"
        ],
        [
          "32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf",
          "5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661"
        ],
        [
          "7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5",
          "8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6"
        ],
        [
          "ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6",
          "8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e"
        ],
        [
          "16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5",
          "5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d"
        ],
        [
          "eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99",
          "f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc"
        ],
        [
          "78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51",
          "f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4"
        ],
        [
          "494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5",
          "42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c"
        ],
        [
          "a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5",
          "204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b"
        ],
        [
          "c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997",
          "4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913"
        ],
        [
          "841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881",
          "73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154"
        ],
        [
          "5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5",
          "39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865"
        ],
        [
          "36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66",
          "d2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc"
        ],
        [
          "336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726",
          "ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224"
        ],
        [
          "8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede",
          "6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e"
        ],
        [
          "1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94",
          "60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6"
        ],
        [
          "85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31",
          "3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511"
        ],
        [
          "29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51",
          "b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b"
        ],
        [
          "a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252",
          "ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2"
        ],
        [
          "4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5",
          "cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c"
        ],
        [
          "d24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b",
          "6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3"
        ],
        [
          "ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4",
          "322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d"
        ],
        [
          "af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f",
          "6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700"
        ],
        [
          "e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889",
          "2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4"
        ],
        [
          "591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246",
          "b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196"
        ],
        [
          "11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984",
          "998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4"
        ],
        [
          "3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a",
          "b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257"
        ],
        [
          "cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030",
          "bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13"
        ],
        [
          "c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197",
          "6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096"
        ],
        [
          "c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593",
          "c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38"
        ],
        [
          "a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef",
          "21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f"
        ],
        [
          "347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38",
          "60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448"
        ],
        [
          "da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a",
          "49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a"
        ],
        [
          "c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111",
          "5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4"
        ],
        [
          "4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502",
          "7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437"
        ],
        [
          "3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea",
          "be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7"
        ],
        [
          "cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26",
          "8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d"
        ],
        [
          "b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986",
          "39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a"
        ],
        [
          "d4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e",
          "62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54"
        ],
        [
          "48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4",
          "25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77"
        ],
        [
          "dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda",
          "ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517"
        ],
        [
          "6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859",
          "cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10"
        ],
        [
          "e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f",
          "f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125"
        ],
        [
          "eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c",
          "6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e"
        ],
        [
          "13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942",
          "fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1"
        ],
        [
          "ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a",
          "1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2"
        ],
        [
          "b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80",
          "5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423"
        ],
        [
          "ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d",
          "438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8"
        ],
        [
          "8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1",
          "cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758"
        ],
        [
          "52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63",
          "c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375"
        ],
        [
          "e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352",
          "6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d"
        ],
        [
          "7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193",
          "ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec"
        ],
        [
          "5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00",
          "9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0"
        ],
        [
          "32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58",
          "ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c"
        ],
        [
          "e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7",
          "d3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4"
        ],
        [
          "8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8",
          "c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f"
        ],
        [
          "4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e",
          "67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649"
        ],
        [
          "3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d",
          "cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826"
        ],
        [
          "674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b",
          "299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5"
        ],
        [
          "d32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f",
          "f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87"
        ],
        [
          "30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6",
          "462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b"
        ],
        [
          "be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297",
          "62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc"
        ],
        [
          "93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a",
          "7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c"
        ],
        [
          "b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c",
          "ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f"
        ],
        [
          "d5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52",
          "4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a"
        ],
        [
          "d3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb",
          "bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46"
        ],
        [
          "463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065",
          "bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f"
        ],
        [
          "7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917",
          "603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03"
        ],
        [
          "74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9",
          "cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08"
        ],
        [
          "30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3",
          "553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8"
        ],
        [
          "9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57",
          "712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373"
        ],
        [
          "176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66",
          "ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3"
        ],
        [
          "75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8",
          "9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8"
        ],
        [
          "809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721",
          "9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1"
        ],
        [
          "1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180",
          "4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9"
        ]
      ]
    }
  }), secp256k1$6;
}
var hasRequiredCurves;
function requireCurves() {
  return hasRequiredCurves || (hasRequiredCurves = 1, function(o) {
    var g = o, c = requireHash$1(), y = requireCurve$1(), t = requireUtils$9(), d = t.assert;
    function E(x) {
      x.type === "short" ? this.curve = new y.short(x) : x.type === "edwards" ? this.curve = new y.edwards(x) : this.curve = new y.mont(x), this.g = this.curve.g, this.n = this.curve.n, this.hash = x.hash, d(this.g.validate(), "Invalid curve"), d(this.g.mul(this.n).isInfinity(), "Invalid curve, G*N != O");
    }
    g.PresetCurve = E;
    function B(x, v) {
      Object.defineProperty(g, x, {
        configurable: !0,
        enumerable: !0,
        get: function() {
          var F = new E(v);
          return Object.defineProperty(g, x, {
            configurable: !0,
            enumerable: !0,
            value: F
          }), F;
        }
      });
    }
    B("p192", {
      type: "short",
      prime: "p192",
      p: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff",
      a: "ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc",
      b: "64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1",
      n: "ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831",
      hash: c.sha256,
      gRed: !1,
      g: [
        "188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012",
        "07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"
      ]
    }), B("p224", {
      type: "short",
      prime: "p224",
      p: "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001",
      a: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe",
      b: "b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4",
      n: "ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d",
      hash: c.sha256,
      gRed: !1,
      g: [
        "b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21",
        "bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"
      ]
    }), B("p256", {
      type: "short",
      prime: null,
      p: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff",
      a: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc",
      b: "5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b",
      n: "ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551",
      hash: c.sha256,
      gRed: !1,
      g: [
        "6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296",
        "4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"
      ]
    }), B("p384", {
      type: "short",
      prime: null,
      p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
      a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
      b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
      n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
      hash: c.sha384,
      gRed: !1,
      g: [
        "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
        "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
      ]
    }), B("p521", {
      type: "short",
      prime: null,
      p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
      a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
      b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
      n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
      hash: c.sha512,
      gRed: !1,
      g: [
        "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
        "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
      ]
    }), B("curve25519", {
      type: "mont",
      prime: "p25519",
      p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
      a: "76d06",
      b: "1",
      n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
      hash: c.sha256,
      gRed: !1,
      g: [
        "9"
      ]
    }), B("ed25519", {
      type: "edwards",
      prime: "p25519",
      p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
      a: "-1",
      c: "1",
      // -121665 * (121666^(-1)) (mod P)
      d: "52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",
      n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
      hash: c.sha256,
      gRed: !1,
      g: [
        "216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a",
        // 4/5
        "6666666666666666666666666666666666666666666666666666666666666658"
      ]
    });
    var D;
    try {
      D = requireSecp256k1$4();
    } catch {
      D = void 0;
    }
    B("secp256k1", {
      type: "short",
      prime: "k256",
      p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",
      a: "0",
      b: "7",
      n: "ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",
      h: "1",
      hash: c.sha256,
      // Precomputed endomorphism
      beta: "7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",
      lambda: "5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",
      basis: [
        {
          a: "3086d221a7d46bcde86c90e49284eb15",
          b: "-e4437ed6010e88286f547fa90abfe4c3"
        },
        {
          a: "114ca50f7a8e2f3f657c1108d9d44cfd8",
          b: "3086d221a7d46bcde86c90e49284eb15"
        }
      ],
      gRed: !1,
      g: [
        "79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798",
        "483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8",
        D
      ]
    });
  }(curves)), curves;
}
var hmacDrbg, hasRequiredHmacDrbg;
function requireHmacDrbg() {
  if (hasRequiredHmacDrbg) return hmacDrbg;
  hasRequiredHmacDrbg = 1;
  var o = requireHash$1(), g = requireUtils$a(), c = requireMinimalisticAssert();
  function y(t) {
    if (!(this instanceof y))
      return new y(t);
    this.hash = t.hash, this.predResist = !!t.predResist, this.outLen = this.hash.outSize, this.minEntropy = t.minEntropy || this.hash.hmacStrength, this._reseed = null, this.reseedInterval = null, this.K = null, this.V = null;
    var d = g.toArray(t.entropy, t.entropyEnc || "hex"), E = g.toArray(t.nonce, t.nonceEnc || "hex"), B = g.toArray(t.pers, t.persEnc || "hex");
    c(
      d.length >= this.minEntropy / 8,
      "Not enough entropy. Minimum is: " + this.minEntropy + " bits"
    ), this._init(d, E, B);
  }
  return hmacDrbg = y, y.prototype._init = function(d, E, B) {
    var D = d.concat(E).concat(B);
    this.K = new Array(this.outLen / 8), this.V = new Array(this.outLen / 8);
    for (var x = 0; x < this.V.length; x++)
      this.K[x] = 0, this.V[x] = 1;
    this._update(D), this._reseed = 1, this.reseedInterval = 281474976710656;
  }, y.prototype._hmac = function() {
    return new o.hmac(this.hash, this.K);
  }, y.prototype._update = function(d) {
    var E = this._hmac().update(this.V).update([0]);
    d && (E = E.update(d)), this.K = E.digest(), this.V = this._hmac().update(this.V).digest(), d && (this.K = this._hmac().update(this.V).update([1]).update(d).digest(), this.V = this._hmac().update(this.V).digest());
  }, y.prototype.reseed = function(d, E, B, D) {
    typeof E != "string" && (D = B, B = E, E = null), d = g.toArray(d, E), B = g.toArray(B, D), c(
      d.length >= this.minEntropy / 8,
      "Not enough entropy. Minimum is: " + this.minEntropy + " bits"
    ), this._update(d.concat(B || [])), this._reseed = 1;
  }, y.prototype.generate = function(d, E, B, D) {
    if (this._reseed > this.reseedInterval)
      throw new Error("Reseed is required");
    typeof E != "string" && (D = B, B = E, E = null), B && (B = g.toArray(B, D || "hex"), this._update(B));
    for (var x = []; x.length < d; )
      this.V = this._hmac().update(this.V).digest(), x = x.concat(this.V);
    var v = x.slice(0, d);
    return this._update(B), this._reseed++, g.encode(v, E);
  }, hmacDrbg;
}
var key$1, hasRequiredKey$1;
function requireKey$1() {
  if (hasRequiredKey$1) return key$1;
  hasRequiredKey$1 = 1;
  var o = requireBn$1(), g = requireUtils$9(), c = g.assert;
  function y(t, d) {
    this.ec = t, this.priv = null, this.pub = null, d.priv && this._importPrivate(d.priv, d.privEnc), d.pub && this._importPublic(d.pub, d.pubEnc);
  }
  return key$1 = y, y.fromPublic = function(d, E, B) {
    return E instanceof y ? E : new y(d, {
      pub: E,
      pubEnc: B
    });
  }, y.fromPrivate = function(d, E, B) {
    return E instanceof y ? E : new y(d, {
      priv: E,
      privEnc: B
    });
  }, y.prototype.validate = function() {
    var d = this.getPublic();
    return d.isInfinity() ? { result: !1, reason: "Invalid public key" } : d.validate() ? d.mul(this.ec.curve.n).isInfinity() ? { result: !0, reason: null } : { result: !1, reason: "Public key * N != O" } : { result: !1, reason: "Public key is not a point" };
  }, y.prototype.getPublic = function(d, E) {
    return typeof d == "string" && (E = d, d = null), this.pub || (this.pub = this.ec.g.mul(this.priv)), E ? this.pub.encode(E, d) : this.pub;
  }, y.prototype.getPrivate = function(d) {
    return d === "hex" ? this.priv.toString(16, 2) : this.priv;
  }, y.prototype._importPrivate = function(d, E) {
    this.priv = new o(d, E || 16), this.priv = this.priv.umod(this.ec.curve.n);
  }, y.prototype._importPublic = function(d, E) {
    if (d.x || d.y) {
      this.ec.curve.type === "mont" ? c(d.x, "Need x coordinate") : (this.ec.curve.type === "short" || this.ec.curve.type === "edwards") && c(d.x && d.y, "Need both x and y coordinate"), this.pub = this.ec.curve.point(d.x, d.y);
      return;
    }
    this.pub = this.ec.curve.decodePoint(d, E);
  }, y.prototype.derive = function(d) {
    return d.validate() || c(d.validate(), "public point not validated"), d.mul(this.priv).getX();
  }, y.prototype.sign = function(d, E, B) {
    return this.ec.sign(d, this, E, B);
  }, y.prototype.verify = function(d, E, B) {
    return this.ec.verify(d, E, this, void 0, B);
  }, y.prototype.inspect = function() {
    return "<Key priv: " + (this.priv && this.priv.toString(16, 2)) + " pub: " + (this.pub && this.pub.inspect()) + " >";
  }, key$1;
}
var signature$3, hasRequiredSignature$3;
function requireSignature$3() {
  if (hasRequiredSignature$3) return signature$3;
  hasRequiredSignature$3 = 1;
  var o = requireBn$1(), g = requireUtils$9(), c = g.assert;
  function y(D, x) {
    if (D instanceof y)
      return D;
    this._importDER(D, x) || (c(D.r && D.s, "Signature without r or s"), this.r = new o(D.r, 16), this.s = new o(D.s, 16), D.recoveryParam === void 0 ? this.recoveryParam = null : this.recoveryParam = D.recoveryParam);
  }
  signature$3 = y;
  function t() {
    this.place = 0;
  }
  function d(D, x) {
    var v = D[x.place++];
    if (!(v & 128))
      return v;
    var F = v & 15;
    if (F === 0 || F > 4 || D[x.place] === 0)
      return !1;
    for (var M = 0, U = 0, L = x.place; U < F; U++, L++)
      M <<= 8, M |= D[L], M >>>= 0;
    return M <= 127 ? !1 : (x.place = L, M);
  }
  function E(D) {
    for (var x = 0, v = D.length - 1; !D[x] && !(D[x + 1] & 128) && x < v; )
      x++;
    return x === 0 ? D : D.slice(x);
  }
  y.prototype._importDER = function(x, v) {
    x = g.toArray(x, v);
    var F = new t();
    if (x[F.place++] !== 48)
      return !1;
    var M = d(x, F);
    if (M === !1 || M + F.place !== x.length || x[F.place++] !== 2)
      return !1;
    var U = d(x, F);
    if (U === !1 || (x[F.place] & 128) !== 0)
      return !1;
    var L = x.slice(F.place, U + F.place);
    if (F.place += U, x[F.place++] !== 2)
      return !1;
    var H = d(x, F);
    if (H === !1 || x.length !== H + F.place || (x[F.place] & 128) !== 0)
      return !1;
    var fe = x.slice(F.place, H + F.place);
    if (L[0] === 0)
      if (L[1] & 128)
        L = L.slice(1);
      else
        return !1;
    if (fe[0] === 0)
      if (fe[1] & 128)
        fe = fe.slice(1);
      else
        return !1;
    return this.r = new o(L), this.s = new o(fe), this.recoveryParam = null, !0;
  };
  function B(D, x) {
    if (x < 128) {
      D.push(x);
      return;
    }
    var v = 1 + (Math.log(x) / Math.LN2 >>> 3);
    for (D.push(v | 128); --v; )
      D.push(x >>> (v << 3) & 255);
    D.push(x);
  }
  return y.prototype.toDER = function(x) {
    var v = this.r.toArray(), F = this.s.toArray();
    for (v[0] & 128 && (v = [0].concat(v)), F[0] & 128 && (F = [0].concat(F)), v = E(v), F = E(F); !F[0] && !(F[1] & 128); )
      F = F.slice(1);
    var M = [2];
    B(M, v.length), M = M.concat(v), M.push(2), B(M, F.length);
    var U = M.concat(F), L = [48];
    return B(L, U.length), L = L.concat(U), g.encode(L, x);
  }, signature$3;
}
var ec, hasRequiredEc;
function requireEc() {
  if (hasRequiredEc) return ec;
  hasRequiredEc = 1;
  var o = requireBn$1(), g = requireHmacDrbg(), c = requireUtils$9(), y = requireCurves(), t = requireBrorand(), d = c.assert, E = requireKey$1(), B = requireSignature$3();
  function D(x) {
    if (!(this instanceof D))
      return new D(x);
    typeof x == "string" && (d(
      Object.prototype.hasOwnProperty.call(y, x),
      "Unknown curve " + x
    ), x = y[x]), x instanceof y.PresetCurve && (x = { curve: x }), this.curve = x.curve.curve, this.n = this.curve.n, this.nh = this.n.ushrn(1), this.g = this.curve.g, this.g = x.curve.g, this.g.precompute(x.curve.n.bitLength() + 1), this.hash = x.hash || x.curve.hash;
  }
  return ec = D, D.prototype.keyPair = function(v) {
    return new E(this, v);
  }, D.prototype.keyFromPrivate = function(v, F) {
    return E.fromPrivate(this, v, F);
  }, D.prototype.keyFromPublic = function(v, F) {
    return E.fromPublic(this, v, F);
  }, D.prototype.genKeyPair = function(v) {
    v || (v = {});
    for (var F = new g({
      hash: this.hash,
      pers: v.pers,
      persEnc: v.persEnc || "utf8",
      entropy: v.entropy || t(this.hash.hmacStrength),
      entropyEnc: v.entropy && v.entropyEnc || "utf8",
      nonce: this.n.toArray()
    }), M = this.n.byteLength(), U = this.n.sub(new o(2)); ; ) {
      var L = new o(F.generate(M));
      if (!(L.cmp(U) > 0))
        return L.iaddn(1), this.keyFromPrivate(L);
    }
  }, D.prototype._truncateToN = function(v, F, M) {
    var U;
    if (o.isBN(v) || typeof v == "number")
      v = new o(v, 16), U = v.byteLength();
    else if (typeof v == "object")
      U = v.length, v = new o(v, 16);
    else {
      var L = v.toString();
      U = L.length + 1 >>> 1, v = new o(L, 16);
    }
    typeof M != "number" && (M = U * 8);
    var H = M - this.n.bitLength();
    return H > 0 && (v = v.ushrn(H)), !F && v.cmp(this.n) >= 0 ? v.sub(this.n) : v;
  }, D.prototype.sign = function(v, F, M, U) {
    if (typeof M == "object" && (U = M, M = null), U || (U = {}), typeof v != "string" && typeof v != "number" && !o.isBN(v)) {
      d(
        typeof v == "object" && v && typeof v.length == "number",
        "Expected message to be an array-like, a hex string, or a BN instance"
      ), d(v.length >>> 0 === v.length);
      for (var L = 0; L < v.length; L++) d((v[L] & 255) === v[L]);
    }
    F = this.keyFromPrivate(F, M), v = this._truncateToN(v, !1, U.msgBitLength), d(!v.isNeg(), "Can not sign a negative message");
    var H = this.n.byteLength(), fe = F.getPrivate().toArray("be", H), ge = v.toArray("be", H);
    d(new o(ge).eq(v), "Can not sign message");
    for (var Ie = new g({
      hash: this.hash,
      entropy: fe,
      nonce: ge,
      pers: U.pers,
      persEnc: U.persEnc || "utf8"
    }), Ee = this.n.sub(new o(1)), Se = 0; ; Se++) {
      var ze = U.k ? U.k(Se) : new o(Ie.generate(this.n.byteLength()));
      if (ze = this._truncateToN(ze, !0), !(ze.cmpn(1) <= 0 || ze.cmp(Ee) >= 0)) {
        var He = this.g.mul(ze);
        if (!He.isInfinity()) {
          var Pe = He.getX(), De = Pe.umod(this.n);
          if (De.cmpn(0) !== 0) {
            var ve = ze.invm(this.n).mul(De.mul(F.getPrivate()).iadd(v));
            if (ve = ve.umod(this.n), ve.cmpn(0) !== 0) {
              var Fe = (He.getY().isOdd() ? 1 : 0) | (Pe.cmp(De) !== 0 ? 2 : 0);
              return U.canonical && ve.cmp(this.nh) > 0 && (ve = this.n.sub(ve), Fe ^= 1), new B({ r: De, s: ve, recoveryParam: Fe });
            }
          }
        }
      }
    }
  }, D.prototype.verify = function(v, F, M, U, L) {
    L || (L = {}), v = this._truncateToN(v, !1, L.msgBitLength), M = this.keyFromPublic(M, U), F = new B(F, "hex");
    var H = F.r, fe = F.s;
    if (H.cmpn(1) < 0 || H.cmp(this.n) >= 0 || fe.cmpn(1) < 0 || fe.cmp(this.n) >= 0)
      return !1;
    var ge = fe.invm(this.n), Ie = ge.mul(v).umod(this.n), Ee = ge.mul(H).umod(this.n), Se;
    return this.curve._maxwellTrick ? (Se = this.g.jmulAdd(Ie, M.getPublic(), Ee), Se.isInfinity() ? !1 : Se.eqXToP(H)) : (Se = this.g.mulAdd(Ie, M.getPublic(), Ee), Se.isInfinity() ? !1 : Se.getX().umod(this.n).cmp(H) === 0);
  }, D.prototype.recoverPubKey = function(x, v, F, M) {
    d((3 & F) === F, "The recovery param is more than two bits"), v = new B(v, M);
    var U = this.n, L = new o(x), H = v.r, fe = v.s, ge = F & 1, Ie = F >> 1;
    if (H.cmp(this.curve.p.umod(this.curve.n)) >= 0 && Ie)
      throw new Error("Unable to find sencond key candinate");
    Ie ? H = this.curve.pointFromX(H.add(this.curve.n), ge) : H = this.curve.pointFromX(H, ge);
    var Ee = v.r.invm(U), Se = U.sub(L).mul(Ee).umod(U), ze = fe.mul(Ee).umod(U);
    return this.g.mulAdd(Se, H, ze);
  }, D.prototype.getKeyRecoveryParam = function(x, v, F, M) {
    if (v = new B(v, M), v.recoveryParam !== null)
      return v.recoveryParam;
    for (var U = 0; U < 4; U++) {
      var L;
      try {
        L = this.recoverPubKey(x, v, U);
      } catch {
        continue;
      }
      if (L.eq(F))
        return U;
    }
    throw new Error("Unable to find valid recovery factor");
  }, ec;
}
var key, hasRequiredKey;
function requireKey() {
  if (hasRequiredKey) return key;
  hasRequiredKey = 1;
  var o = requireUtils$9(), g = o.assert, c = o.parseBytes, y = o.cachedProperty;
  function t(d, E) {
    this.eddsa = d, this._secret = c(E.secret), d.isPoint(E.pub) ? this._pub = E.pub : this._pubBytes = c(E.pub);
  }
  return t.fromPublic = function(E, B) {
    return B instanceof t ? B : new t(E, { pub: B });
  }, t.fromSecret = function(E, B) {
    return B instanceof t ? B : new t(E, { secret: B });
  }, t.prototype.secret = function() {
    return this._secret;
  }, y(t, "pubBytes", function() {
    return this.eddsa.encodePoint(this.pub());
  }), y(t, "pub", function() {
    return this._pubBytes ? this.eddsa.decodePoint(this._pubBytes) : this.eddsa.g.mul(this.priv());
  }), y(t, "privBytes", function() {
    var E = this.eddsa, B = this.hash(), D = E.encodingLength - 1, x = B.slice(0, E.encodingLength);
    return x[0] &= 248, x[D] &= 127, x[D] |= 64, x;
  }), y(t, "priv", function() {
    return this.eddsa.decodeInt(this.privBytes());
  }), y(t, "hash", function() {
    return this.eddsa.hash().update(this.secret()).digest();
  }), y(t, "messagePrefix", function() {
    return this.hash().slice(this.eddsa.encodingLength);
  }), t.prototype.sign = function(E) {
    return g(this._secret, "KeyPair can only verify"), this.eddsa.sign(E, this);
  }, t.prototype.verify = function(E, B) {
    return this.eddsa.verify(E, B, this);
  }, t.prototype.getSecret = function(E) {
    return g(this._secret, "KeyPair is public only"), o.encode(this.secret(), E);
  }, t.prototype.getPublic = function(E) {
    return o.encode(this.pubBytes(), E);
  }, key = t, key;
}
var signature$2, hasRequiredSignature$2;
function requireSignature$2() {
  if (hasRequiredSignature$2) return signature$2;
  hasRequiredSignature$2 = 1;
  var o = requireBn$1(), g = requireUtils$9(), c = g.assert, y = g.cachedProperty, t = g.parseBytes;
  function d(E, B) {
    this.eddsa = E, typeof B != "object" && (B = t(B)), Array.isArray(B) && (c(B.length === E.encodingLength * 2, "Signature has invalid size"), B = {
      R: B.slice(0, E.encodingLength),
      S: B.slice(E.encodingLength)
    }), c(B.R && B.S, "Signature without R or S"), E.isPoint(B.R) && (this._R = B.R), B.S instanceof o && (this._S = B.S), this._Rencoded = Array.isArray(B.R) ? B.R : B.Rencoded, this._Sencoded = Array.isArray(B.S) ? B.S : B.Sencoded;
  }
  return y(d, "S", function() {
    return this.eddsa.decodeInt(this.Sencoded());
  }), y(d, "R", function() {
    return this.eddsa.decodePoint(this.Rencoded());
  }), y(d, "Rencoded", function() {
    return this.eddsa.encodePoint(this.R());
  }), y(d, "Sencoded", function() {
    return this.eddsa.encodeInt(this.S());
  }), d.prototype.toBytes = function() {
    return this.Rencoded().concat(this.Sencoded());
  }, d.prototype.toHex = function() {
    return g.encode(this.toBytes(), "hex").toUpperCase();
  }, signature$2 = d, signature$2;
}
var eddsa, hasRequiredEddsa;
function requireEddsa() {
  if (hasRequiredEddsa) return eddsa;
  hasRequiredEddsa = 1;
  var o = requireHash$1(), g = requireCurves(), c = requireUtils$9(), y = c.assert, t = c.parseBytes, d = requireKey(), E = requireSignature$2();
  function B(D) {
    if (y(D === "ed25519", "only tested with ed25519 so far"), !(this instanceof B))
      return new B(D);
    D = g[D].curve, this.curve = D, this.g = D.g, this.g.precompute(D.n.bitLength() + 1), this.pointClass = D.point().constructor, this.encodingLength = Math.ceil(D.n.bitLength() / 8), this.hash = o.sha512;
  }
  return eddsa = B, B.prototype.sign = function(x, v) {
    x = t(x);
    var F = this.keyFromSecret(v), M = this.hashInt(F.messagePrefix(), x), U = this.g.mul(M), L = this.encodePoint(U), H = this.hashInt(L, F.pubBytes(), x).mul(F.priv()), fe = M.add(H).umod(this.curve.n);
    return this.makeSignature({ R: U, S: fe, Rencoded: L });
  }, B.prototype.verify = function(x, v, F) {
    if (x = t(x), v = this.makeSignature(v), v.S().gte(v.eddsa.curve.n) || v.S().isNeg())
      return !1;
    var M = this.keyFromPublic(F), U = this.hashInt(v.Rencoded(), M.pubBytes(), x), L = this.g.mul(v.S()), H = v.R().add(M.pub().mul(U));
    return H.eq(L);
  }, B.prototype.hashInt = function() {
    for (var x = this.hash(), v = 0; v < arguments.length; v++)
      x.update(arguments[v]);
    return c.intFromLE(x.digest()).umod(this.curve.n);
  }, B.prototype.keyFromPublic = function(x) {
    return d.fromPublic(this, x);
  }, B.prototype.keyFromSecret = function(x) {
    return d.fromSecret(this, x);
  }, B.prototype.makeSignature = function(x) {
    return x instanceof E ? x : new E(this, x);
  }, B.prototype.encodePoint = function(x) {
    var v = x.getY().toArray("le", this.encodingLength);
    return v[this.encodingLength - 1] |= x.getX().isOdd() ? 128 : 0, v;
  }, B.prototype.decodePoint = function(x) {
    x = c.parseBytes(x);
    var v = x.length - 1, F = x.slice(0, v).concat(x[v] & -129), M = (x[v] & 128) !== 0, U = c.intFromLE(F);
    return this.curve.pointFromY(U, M);
  }, B.prototype.encodeInt = function(x) {
    return x.toArray("le", this.encodingLength);
  }, B.prototype.decodeInt = function(x) {
    return c.intFromLE(x);
  }, B.prototype.isPoint = function(x) {
    return x instanceof this.pointClass;
  }, eddsa;
}
var hasRequiredElliptic$2;
function requireElliptic$2() {
  return hasRequiredElliptic$2 || (hasRequiredElliptic$2 = 1, function(o) {
    var g = o;
    g.version = require$$0$1.version, g.utils = requireUtils$9(), g.rand = requireBrorand(), g.curve = requireCurve$1(), g.curves = requireCurves(), g.ec = requireEc(), g.eddsa = requireEddsa();
  }(elliptic$2)), elliptic$2;
}
var asn1$1 = {}, asn1 = {}, api = {}, hasRequiredApi;
function requireApi() {
  return hasRequiredApi || (hasRequiredApi = 1, function(o) {
    var g = requireAsn1$1(), c = requireInherits_browser(), y = o;
    y.define = function(E, B) {
      return new t(E, B);
    };
    function t(d, E) {
      this.name = d, this.body = E, this.decoders = {}, this.encoders = {};
    }
    t.prototype._createNamed = function(E) {
      var B;
      try {
        B = require$$2$2.runInThisContext(
          "(function " + this.name + `(entity) {
  this._initNamed(entity);
})`
        );
      } catch {
        B = function(x) {
          this._initNamed(x);
        };
      }
      return c(B, E), B.prototype._initNamed = function(x) {
        E.call(this, x);
      }, new B(this);
    }, t.prototype._getDecoder = function(E) {
      return E = E || "der", this.decoders.hasOwnProperty(E) || (this.decoders[E] = this._createNamed(g.decoders[E])), this.decoders[E];
    }, t.prototype.decode = function(E, B, D) {
      return this._getDecoder(B).decode(E, D);
    }, t.prototype._getEncoder = function(E) {
      return E = E || "der", this.encoders.hasOwnProperty(E) || (this.encoders[E] = this._createNamed(g.encoders[E])), this.encoders[E];
    }, t.prototype.encode = function(E, B, D) {
      return this._getEncoder(B).encode(E, D);
    };
  }(api)), api;
}
var base$1 = {}, reporter = {}, hasRequiredReporter;
function requireReporter() {
  if (hasRequiredReporter) return reporter;
  hasRequiredReporter = 1;
  var o = requireInherits_browser();
  function g(y) {
    this._reporterState = {
      obj: null,
      path: [],
      options: y || {},
      errors: []
    };
  }
  reporter.Reporter = g, g.prototype.isError = function(t) {
    return t instanceof c;
  }, g.prototype.save = function() {
    var t = this._reporterState;
    return { obj: t.obj, pathLen: t.path.length };
  }, g.prototype.restore = function(t) {
    var d = this._reporterState;
    d.obj = t.obj, d.path = d.path.slice(0, t.pathLen);
  }, g.prototype.enterKey = function(t) {
    return this._reporterState.path.push(t);
  }, g.prototype.exitKey = function(t) {
    var d = this._reporterState;
    d.path = d.path.slice(0, t - 1);
  }, g.prototype.leaveKey = function(t, d, E) {
    var B = this._reporterState;
    this.exitKey(t), B.obj !== null && (B.obj[d] = E);
  }, g.prototype.path = function() {
    return this._reporterState.path.join("/");
  }, g.prototype.enterObject = function() {
    var t = this._reporterState, d = t.obj;
    return t.obj = {}, d;
  }, g.prototype.leaveObject = function(t) {
    var d = this._reporterState, E = d.obj;
    return d.obj = t, E;
  }, g.prototype.error = function(t) {
    var d, E = this._reporterState, B = t instanceof c;
    if (B ? d = t : d = new c(E.path.map(function(D) {
      return "[" + JSON.stringify(D) + "]";
    }).join(""), t.message || t, t.stack), !E.options.partial)
      throw d;
    return B || E.errors.push(d), d;
  }, g.prototype.wrapResult = function(t) {
    var d = this._reporterState;
    return d.options.partial ? {
      result: this.isError(t) ? null : t,
      errors: d.errors
    } : t;
  };
  function c(y, t) {
    this.path = y, this.rethrow(t);
  }
  return o(c, Error), c.prototype.rethrow = function(t) {
    if (this.message = t + " at: " + (this.path || "(shallow)"), Error.captureStackTrace && Error.captureStackTrace(this, c), !this.stack)
      try {
        throw new Error(this.message);
      } catch (d) {
        this.stack = d.stack;
      }
    return this;
  }, reporter;
}
var buffer = {}, hasRequiredBuffer;
function requireBuffer() {
  if (hasRequiredBuffer) return buffer;
  hasRequiredBuffer = 1;
  var o = requireInherits_browser(), g = requireBase$1().Reporter, c = requireBuffer$2().Buffer;
  function y(d, E) {
    if (g.call(this, E), !c.isBuffer(d)) {
      this.error("Input not Buffer");
      return;
    }
    this.base = d, this.offset = 0, this.length = d.length;
  }
  o(y, g), buffer.DecoderBuffer = y, y.prototype.save = function() {
    return { offset: this.offset, reporter: g.prototype.save.call(this) };
  }, y.prototype.restore = function(E) {
    var B = new y(this.base);
    return B.offset = E.offset, B.length = this.offset, this.offset = E.offset, g.prototype.restore.call(this, E.reporter), B;
  }, y.prototype.isEmpty = function() {
    return this.offset === this.length;
  }, y.prototype.readUInt8 = function(E) {
    return this.offset + 1 <= this.length ? this.base.readUInt8(this.offset++, !0) : this.error(E || "DecoderBuffer overrun");
  }, y.prototype.skip = function(E, B) {
    if (!(this.offset + E <= this.length))
      return this.error(B || "DecoderBuffer overrun");
    var D = new y(this.base);
    return D._reporterState = this._reporterState, D.offset = this.offset, D.length = this.offset + E, this.offset += E, D;
  }, y.prototype.raw = function(E) {
    return this.base.slice(E ? E.offset : this.offset, this.length);
  };
  function t(d, E) {
    if (Array.isArray(d))
      this.length = 0, this.value = d.map(function(B) {
        return B instanceof t || (B = new t(B, E)), this.length += B.length, B;
      }, this);
    else if (typeof d == "number") {
      if (!(0 <= d && d <= 255))
        return E.error("non-byte EncoderBuffer value");
      this.value = d, this.length = 1;
    } else if (typeof d == "string")
      this.value = d, this.length = c.byteLength(d);
    else if (c.isBuffer(d))
      this.value = d, this.length = d.length;
    else
      return E.error("Unsupported type: " + typeof d);
  }
  return buffer.EncoderBuffer = t, t.prototype.join = function(E, B) {
    return E || (E = new c(this.length)), B || (B = 0), this.length === 0 || (Array.isArray(this.value) ? this.value.forEach(function(D) {
      D.join(E, B), B += D.length;
    }) : (typeof this.value == "number" ? E[B] = this.value : typeof this.value == "string" ? E.write(this.value, B) : c.isBuffer(this.value) && this.value.copy(E, B), B += this.length)), E;
  }, buffer;
}
var node, hasRequiredNode;
function requireNode() {
  if (hasRequiredNode) return node;
  hasRequiredNode = 1;
  var o = requireBase$1().Reporter, g = requireBase$1().EncoderBuffer, c = requireBase$1().DecoderBuffer, y = requireMinimalisticAssert(), t = [
    "seq",
    "seqof",
    "set",
    "setof",
    "objid",
    "bool",
    "gentime",
    "utctime",
    "null_",
    "enum",
    "int",
    "objDesc",
    "bitstr",
    "bmpstr",
    "charstr",
    "genstr",
    "graphstr",
    "ia5str",
    "iso646str",
    "numstr",
    "octstr",
    "printstr",
    "t61str",
    "unistr",
    "utf8str",
    "videostr"
  ], d = [
    "key",
    "obj",
    "use",
    "optional",
    "explicit",
    "implicit",
    "def",
    "choice",
    "any",
    "contains"
  ].concat(t), E = [
    "_peekTag",
    "_decodeTag",
    "_use",
    "_decodeStr",
    "_decodeObjid",
    "_decodeTime",
    "_decodeNull",
    "_decodeInt",
    "_decodeBool",
    "_decodeList",
    "_encodeComposite",
    "_encodeStr",
    "_encodeObjid",
    "_encodeTime",
    "_encodeNull",
    "_encodeInt",
    "_encodeBool"
  ];
  function B(x, v) {
    var F = {};
    this._baseState = F, F.enc = x, F.parent = v || null, F.children = null, F.tag = null, F.args = null, F.reverseArgs = null, F.choice = null, F.optional = !1, F.any = !1, F.obj = !1, F.use = null, F.useDecoder = null, F.key = null, F.default = null, F.explicit = null, F.implicit = null, F.contains = null, F.parent || (F.children = [], this._wrap());
  }
  node = B;
  var D = [
    "enc",
    "parent",
    "children",
    "tag",
    "args",
    "reverseArgs",
    "choice",
    "optional",
    "any",
    "obj",
    "use",
    "alteredUse",
    "key",
    "default",
    "explicit",
    "implicit",
    "contains"
  ];
  return B.prototype.clone = function() {
    var v = this._baseState, F = {};
    D.forEach(function(U) {
      F[U] = v[U];
    });
    var M = new this.constructor(F.parent);
    return M._baseState = F, M;
  }, B.prototype._wrap = function() {
    var v = this._baseState;
    d.forEach(function(F) {
      this[F] = function() {
        var U = new this.constructor(this);
        return v.children.push(U), U[F].apply(U, arguments);
      };
    }, this);
  }, B.prototype._init = function(v) {
    var F = this._baseState;
    y(F.parent === null), v.call(this), F.children = F.children.filter(function(M) {
      return M._baseState.parent === this;
    }, this), y.equal(F.children.length, 1, "Root node can have only one child");
  }, B.prototype._useArgs = function(v) {
    var F = this._baseState, M = v.filter(function(U) {
      return U instanceof this.constructor;
    }, this);
    v = v.filter(function(U) {
      return !(U instanceof this.constructor);
    }, this), M.length !== 0 && (y(F.children === null), F.children = M, M.forEach(function(U) {
      U._baseState.parent = this;
    }, this)), v.length !== 0 && (y(F.args === null), F.args = v, F.reverseArgs = v.map(function(U) {
      if (typeof U != "object" || U.constructor !== Object)
        return U;
      var L = {};
      return Object.keys(U).forEach(function(H) {
        H == (H | 0) && (H |= 0);
        var fe = U[H];
        L[fe] = H;
      }), L;
    }));
  }, E.forEach(function(x) {
    B.prototype[x] = function() {
      var F = this._baseState;
      throw new Error(x + " not implemented for encoding: " + F.enc);
    };
  }), t.forEach(function(x) {
    B.prototype[x] = function() {
      var F = this._baseState, M = Array.prototype.slice.call(arguments);
      return y(F.tag === null), F.tag = x, this._useArgs(M), this;
    };
  }), B.prototype.use = function(v) {
    y(v);
    var F = this._baseState;
    return y(F.use === null), F.use = v, this;
  }, B.prototype.optional = function() {
    var v = this._baseState;
    return v.optional = !0, this;
  }, B.prototype.def = function(v) {
    var F = this._baseState;
    return y(F.default === null), F.default = v, F.optional = !0, this;
  }, B.prototype.explicit = function(v) {
    var F = this._baseState;
    return y(F.explicit === null && F.implicit === null), F.explicit = v, this;
  }, B.prototype.implicit = function(v) {
    var F = this._baseState;
    return y(F.explicit === null && F.implicit === null), F.implicit = v, this;
  }, B.prototype.obj = function() {
    var v = this._baseState, F = Array.prototype.slice.call(arguments);
    return v.obj = !0, F.length !== 0 && this._useArgs(F), this;
  }, B.prototype.key = function(v) {
    var F = this._baseState;
    return y(F.key === null), F.key = v, this;
  }, B.prototype.any = function() {
    var v = this._baseState;
    return v.any = !0, this;
  }, B.prototype.choice = function(v) {
    var F = this._baseState;
    return y(F.choice === null), F.choice = v, this._useArgs(Object.keys(v).map(function(M) {
      return v[M];
    })), this;
  }, B.prototype.contains = function(v) {
    var F = this._baseState;
    return y(F.use === null), F.contains = v, this;
  }, B.prototype._decode = function(v, F) {
    var M = this._baseState;
    if (M.parent === null)
      return v.wrapResult(M.children[0]._decode(v, F));
    var U = M.default, L = !0, H = null;
    if (M.key !== null && (H = v.enterKey(M.key)), M.optional) {
      var fe = null;
      if (M.explicit !== null ? fe = M.explicit : M.implicit !== null ? fe = M.implicit : M.tag !== null && (fe = M.tag), fe === null && !M.any) {
        var ge = v.save();
        try {
          M.choice === null ? this._decodeGeneric(M.tag, v, F) : this._decodeChoice(v, F), L = !0;
        } catch {
          L = !1;
        }
        v.restore(ge);
      } else if (L = this._peekTag(v, fe, M.any), v.isError(L))
        return L;
    }
    var Ie;
    if (M.obj && L && (Ie = v.enterObject()), L) {
      if (M.explicit !== null) {
        var Ee = this._decodeTag(v, M.explicit);
        if (v.isError(Ee))
          return Ee;
        v = Ee;
      }
      var Se = v.offset;
      if (M.use === null && M.choice === null) {
        if (M.any)
          var ge = v.save();
        var ze = this._decodeTag(
          v,
          M.implicit !== null ? M.implicit : M.tag,
          M.any
        );
        if (v.isError(ze))
          return ze;
        M.any ? U = v.raw(ge) : v = ze;
      }
      if (F && F.track && M.tag !== null && F.track(v.path(), Se, v.length, "tagged"), F && F.track && M.tag !== null && F.track(v.path(), v.offset, v.length, "content"), M.any ? U = U : M.choice === null ? U = this._decodeGeneric(M.tag, v, F) : U = this._decodeChoice(v, F), v.isError(U))
        return U;
      if (!M.any && M.choice === null && M.children !== null && M.children.forEach(function(De) {
        De._decode(v, F);
      }), M.contains && (M.tag === "octstr" || M.tag === "bitstr")) {
        var He = new c(U);
        U = this._getUse(M.contains, v._reporterState.obj)._decode(He, F);
      }
    }
    return M.obj && L && (U = v.leaveObject(Ie)), M.key !== null && (U !== null || L === !0) ? v.leaveKey(H, M.key, U) : H !== null && v.exitKey(H), U;
  }, B.prototype._decodeGeneric = function(v, F, M) {
    var U = this._baseState;
    return v === "seq" || v === "set" ? null : v === "seqof" || v === "setof" ? this._decodeList(F, v, U.args[0], M) : /str$/.test(v) ? this._decodeStr(F, v, M) : v === "objid" && U.args ? this._decodeObjid(F, U.args[0], U.args[1], M) : v === "objid" ? this._decodeObjid(F, null, null, M) : v === "gentime" || v === "utctime" ? this._decodeTime(F, v, M) : v === "null_" ? this._decodeNull(F, M) : v === "bool" ? this._decodeBool(F, M) : v === "objDesc" ? this._decodeStr(F, v, M) : v === "int" || v === "enum" ? this._decodeInt(F, U.args && U.args[0], M) : U.use !== null ? this._getUse(U.use, F._reporterState.obj)._decode(F, M) : F.error("unknown tag: " + v);
  }, B.prototype._getUse = function(v, F) {
    var M = this._baseState;
    return M.useDecoder = this._use(v, F), y(M.useDecoder._baseState.parent === null), M.useDecoder = M.useDecoder._baseState.children[0], M.implicit !== M.useDecoder._baseState.implicit && (M.useDecoder = M.useDecoder.clone(), M.useDecoder._baseState.implicit = M.implicit), M.useDecoder;
  }, B.prototype._decodeChoice = function(v, F) {
    var M = this._baseState, U = null, L = !1;
    return Object.keys(M.choice).some(function(H) {
      var fe = v.save(), ge = M.choice[H];
      try {
        var Ie = ge._decode(v, F);
        if (v.isError(Ie))
          return !1;
        U = { type: H, value: Ie }, L = !0;
      } catch {
        return v.restore(fe), !1;
      }
      return !0;
    }, this), L ? U : v.error("Choice not matched");
  }, B.prototype._createEncoderBuffer = function(v) {
    return new g(v, this.reporter);
  }, B.prototype._encode = function(v, F, M) {
    var U = this._baseState;
    if (!(U.default !== null && U.default === v)) {
      var L = this._encodeValue(v, F, M);
      if (L !== void 0 && !this._skipDefault(L, F, M))
        return L;
    }
  }, B.prototype._encodeValue = function(v, F, M) {
    var U = this._baseState;
    if (U.parent === null)
      return U.children[0]._encode(v, F || new o());
    var ge = null;
    if (this.reporter = F, U.optional && v === void 0)
      if (U.default !== null)
        v = U.default;
      else
        return;
    var L = null, H = !1;
    if (U.any)
      ge = this._createEncoderBuffer(v);
    else if (U.choice)
      ge = this._encodeChoice(v, F);
    else if (U.contains)
      L = this._getUse(U.contains, M)._encode(v, F), H = !0;
    else if (U.children)
      L = U.children.map(function(Se) {
        if (Se._baseState.tag === "null_")
          return Se._encode(null, F, v);
        if (Se._baseState.key === null)
          return F.error("Child should have a key");
        var ze = F.enterKey(Se._baseState.key);
        if (typeof v != "object")
          return F.error("Child expected, but input is not object");
        var He = Se._encode(v[Se._baseState.key], F, v);
        return F.leaveKey(ze), He;
      }, this).filter(function(Se) {
        return Se;
      }), L = this._createEncoderBuffer(L);
    else if (U.tag === "seqof" || U.tag === "setof") {
      if (!(U.args && U.args.length === 1))
        return F.error("Too many args for : " + U.tag);
      if (!Array.isArray(v))
        return F.error("seqof/setof, but data is not Array");
      var fe = this.clone();
      fe._baseState.implicit = null, L = this._createEncoderBuffer(v.map(function(Se) {
        var ze = this._baseState;
        return this._getUse(ze.args[0], v)._encode(Se, F);
      }, fe));
    } else U.use !== null ? ge = this._getUse(U.use, M)._encode(v, F) : (L = this._encodePrimitive(U.tag, v), H = !0);
    var ge;
    if (!U.any && U.choice === null) {
      var Ie = U.implicit !== null ? U.implicit : U.tag, Ee = U.implicit === null ? "universal" : "context";
      Ie === null ? U.use === null && F.error("Tag could be omitted only for .use()") : U.use === null && (ge = this._encodeComposite(Ie, H, Ee, L));
    }
    return U.explicit !== null && (ge = this._encodeComposite(U.explicit, !1, "context", ge)), ge;
  }, B.prototype._encodeChoice = function(v, F) {
    var M = this._baseState, U = M.choice[v.type];
    return U || y(
      !1,
      v.type + " not found in " + JSON.stringify(Object.keys(M.choice))
    ), U._encode(v.value, F);
  }, B.prototype._encodePrimitive = function(v, F) {
    var M = this._baseState;
    if (/str$/.test(v))
      return this._encodeStr(F, v);
    if (v === "objid" && M.args)
      return this._encodeObjid(F, M.reverseArgs[0], M.args[1]);
    if (v === "objid")
      return this._encodeObjid(F, null, null);
    if (v === "gentime" || v === "utctime")
      return this._encodeTime(F, v);
    if (v === "null_")
      return this._encodeNull();
    if (v === "int" || v === "enum")
      return this._encodeInt(F, M.args && M.reverseArgs[0]);
    if (v === "bool")
      return this._encodeBool(F);
    if (v === "objDesc")
      return this._encodeStr(F, v);
    throw new Error("Unsupported tag: " + v);
  }, B.prototype._isNumstr = function(v) {
    return /^[0-9 ]*$/.test(v);
  }, B.prototype._isPrintstr = function(v) {
    return /^[A-Za-z0-9 '\(\)\+,\-\.\/:=\?]*$/.test(v);
  }, node;
}
var hasRequiredBase$1;
function requireBase$1() {
  return hasRequiredBase$1 || (hasRequiredBase$1 = 1, function(o) {
    var g = o;
    g.Reporter = requireReporter().Reporter, g.DecoderBuffer = requireBuffer().DecoderBuffer, g.EncoderBuffer = requireBuffer().EncoderBuffer, g.Node = requireNode();
  }(base$1)), base$1;
}
var constants$5 = {}, der = {}, hasRequiredDer$2;
function requireDer$2() {
  return hasRequiredDer$2 || (hasRequiredDer$2 = 1, function(o) {
    var g = requireConstants$5();
    o.tagClass = {
      0: "universal",
      1: "application",
      2: "context",
      3: "private"
    }, o.tagClassByName = g._reverse(o.tagClass), o.tag = {
      0: "end",
      1: "bool",
      2: "int",
      3: "bitstr",
      4: "octstr",
      5: "null_",
      6: "objid",
      7: "objDesc",
      8: "external",
      9: "real",
      10: "enum",
      11: "embed",
      12: "utf8str",
      13: "relativeOid",
      16: "seq",
      17: "set",
      18: "numstr",
      19: "printstr",
      20: "t61str",
      21: "videostr",
      22: "ia5str",
      23: "utctime",
      24: "gentime",
      25: "graphstr",
      26: "iso646str",
      27: "genstr",
      28: "unistr",
      29: "charstr",
      30: "bmpstr"
    }, o.tagByName = g._reverse(o.tag);
  }(der)), der;
}
var hasRequiredConstants$5;
function requireConstants$5() {
  return hasRequiredConstants$5 || (hasRequiredConstants$5 = 1, function(o) {
    var g = o;
    g._reverse = function(y) {
      var t = {};
      return Object.keys(y).forEach(function(d) {
        (d | 0) == d && (d = d | 0);
        var E = y[d];
        t[E] = d;
      }), t;
    }, g.der = requireDer$2();
  }(constants$5)), constants$5;
}
var decoders = {}, der_1$1, hasRequiredDer$1;
function requireDer$1() {
  if (hasRequiredDer$1) return der_1$1;
  hasRequiredDer$1 = 1;
  var o = requireInherits_browser(), g = requireAsn1$1(), c = g.base, y = g.bignum, t = g.constants.der;
  function d(x) {
    this.enc = "der", this.name = x.name, this.entity = x, this.tree = new E(), this.tree._init(x.body);
  }
  der_1$1 = d, d.prototype.decode = function(v, F) {
    return v instanceof c.DecoderBuffer || (v = new c.DecoderBuffer(v, F)), this.tree._decode(v, F);
  };
  function E(x) {
    c.Node.call(this, "der", x);
  }
  o(E, c.Node), E.prototype._peekTag = function(v, F, M) {
    if (v.isEmpty())
      return !1;
    var U = v.save(), L = B(v, 'Failed to peek tag: "' + F + '"');
    return v.isError(L) ? L : (v.restore(U), L.tag === F || L.tagStr === F || L.tagStr + "of" === F || M);
  }, E.prototype._decodeTag = function(v, F, M) {
    var U = B(
      v,
      'Failed to decode tag of "' + F + '"'
    );
    if (v.isError(U))
      return U;
    var L = D(
      v,
      U.primitive,
      'Failed to get length of "' + F + '"'
    );
    if (v.isError(L))
      return L;
    if (!M && U.tag !== F && U.tagStr !== F && U.tagStr + "of" !== F)
      return v.error('Failed to match tag: "' + F + '"');
    if (U.primitive || L !== null)
      return v.skip(L, 'Failed to match body of: "' + F + '"');
    var H = v.save(), fe = this._skipUntilEnd(
      v,
      'Failed to skip indefinite length body: "' + this.tag + '"'
    );
    return v.isError(fe) ? fe : (L = v.offset - H.offset, v.restore(H), v.skip(L, 'Failed to match body of: "' + F + '"'));
  }, E.prototype._skipUntilEnd = function(v, F) {
    for (; ; ) {
      var M = B(v, F);
      if (v.isError(M))
        return M;
      var U = D(v, M.primitive, F);
      if (v.isError(U))
        return U;
      var L;
      if (M.primitive || U !== null ? L = v.skip(U) : L = this._skipUntilEnd(v, F), v.isError(L))
        return L;
      if (M.tagStr === "end")
        break;
    }
  }, E.prototype._decodeList = function(v, F, M, U) {
    for (var L = []; !v.isEmpty(); ) {
      var H = this._peekTag(v, "end");
      if (v.isError(H))
        return H;
      var fe = M.decode(v, "der", U);
      if (v.isError(fe) && H)
        break;
      L.push(fe);
    }
    return L;
  }, E.prototype._decodeStr = function(v, F) {
    if (F === "bitstr") {
      var M = v.readUInt8();
      return v.isError(M) ? M : { unused: M, data: v.raw() };
    } else if (F === "bmpstr") {
      var U = v.raw();
      if (U.length % 2 === 1)
        return v.error("Decoding of string type: bmpstr length mismatch");
      for (var L = "", H = 0; H < U.length / 2; H++)
        L += String.fromCharCode(U.readUInt16BE(H * 2));
      return L;
    } else if (F === "numstr") {
      var fe = v.raw().toString("ascii");
      return this._isNumstr(fe) ? fe : v.error("Decoding of string type: numstr unsupported characters");
    } else {
      if (F === "octstr")
        return v.raw();
      if (F === "objDesc")
        return v.raw();
      if (F === "printstr") {
        var ge = v.raw().toString("ascii");
        return this._isPrintstr(ge) ? ge : v.error("Decoding of string type: printstr unsupported characters");
      } else return /str$/.test(F) ? v.raw().toString() : v.error("Decoding of string type: " + F + " unsupported");
    }
  }, E.prototype._decodeObjid = function(v, F, M) {
    for (var U, L = [], H = 0; !v.isEmpty(); ) {
      var fe = v.readUInt8();
      H <<= 7, H |= fe & 127, (fe & 128) === 0 && (L.push(H), H = 0);
    }
    fe & 128 && L.push(H);
    var ge = L[0] / 40 | 0, Ie = L[0] % 40;
    if (M ? U = L : U = [ge, Ie].concat(L.slice(1)), F) {
      var Ee = F[U.join(" ")];
      Ee === void 0 && (Ee = F[U.join(".")]), Ee !== void 0 && (U = Ee);
    }
    return U;
  }, E.prototype._decodeTime = function(v, F) {
    var M = v.raw().toString();
    if (F === "gentime")
      var U = M.slice(0, 4) | 0, L = M.slice(4, 6) | 0, H = M.slice(6, 8) | 0, fe = M.slice(8, 10) | 0, ge = M.slice(10, 12) | 0, Ie = M.slice(12, 14) | 0;
    else if (F === "utctime") {
      var U = M.slice(0, 2) | 0, L = M.slice(2, 4) | 0, H = M.slice(4, 6) | 0, fe = M.slice(6, 8) | 0, ge = M.slice(8, 10) | 0, Ie = M.slice(10, 12) | 0;
      U < 70 ? U = 2e3 + U : U = 1900 + U;
    } else
      return v.error("Decoding " + F + " time is not supported yet");
    return Date.UTC(U, L - 1, H, fe, ge, Ie, 0);
  }, E.prototype._decodeNull = function(v) {
    return null;
  }, E.prototype._decodeBool = function(v) {
    var F = v.readUInt8();
    return v.isError(F) ? F : F !== 0;
  }, E.prototype._decodeInt = function(v, F) {
    var M = v.raw(), U = new y(M);
    return F && (U = F[U.toString(10)] || U), U;
  }, E.prototype._use = function(v, F) {
    return typeof v == "function" && (v = v(F)), v._getDecoder("der").tree;
  };
  function B(x, v) {
    var F = x.readUInt8(v);
    if (x.isError(F))
      return F;
    var M = t.tagClass[F >> 6], U = (F & 32) === 0;
    if ((F & 31) === 31) {
      var L = F;
      for (F = 0; (L & 128) === 128; ) {
        if (L = x.readUInt8(v), x.isError(L))
          return L;
        F <<= 7, F |= L & 127;
      }
    } else
      F &= 31;
    var H = t.tag[F];
    return {
      cls: M,
      primitive: U,
      tag: F,
      tagStr: H
    };
  }
  function D(x, v, F) {
    var M = x.readUInt8(F);
    if (x.isError(M))
      return M;
    if (!v && M === 128)
      return null;
    if ((M & 128) === 0)
      return M;
    var U = M & 127;
    if (U > 4)
      return x.error("length octect is too long");
    M = 0;
    for (var L = 0; L < U; L++) {
      M <<= 8;
      var H = x.readUInt8(F);
      if (x.isError(H))
        return H;
      M |= H;
    }
    return M;
  }
  return der_1$1;
}
var pem$1, hasRequiredPem$1;
function requirePem$1() {
  if (hasRequiredPem$1) return pem$1;
  hasRequiredPem$1 = 1;
  var o = requireInherits_browser(), g = requireBuffer$2().Buffer, c = requireDer$1();
  function y(t) {
    c.call(this, t), this.enc = "pem";
  }
  return o(y, c), pem$1 = y, y.prototype.decode = function(d, E) {
    for (var B = d.toString().split(/[\r\n]+/g), D = E.label.toUpperCase(), x = /^-----(BEGIN|END) ([^-]+)-----$/, v = -1, F = -1, M = 0; M < B.length; M++) {
      var U = B[M].match(x);
      if (U !== null && U[2] === D)
        if (v === -1) {
          if (U[1] !== "BEGIN")
            break;
          v = M;
        } else {
          if (U[1] !== "END")
            break;
          F = M;
          break;
        }
    }
    if (v === -1 || F === -1)
      throw new Error("PEM section not found for: " + D);
    var L = B.slice(v + 1, F).join("");
    L.replace(/[^a-z0-9\+\/=]+/gi, "");
    var H = new g(L, "base64");
    return c.prototype.decode.call(this, H, E);
  }, pem$1;
}
var hasRequiredDecoders;
function requireDecoders() {
  return hasRequiredDecoders || (hasRequiredDecoders = 1, function(o) {
    var g = o;
    g.der = requireDer$1(), g.pem = requirePem$1();
  }(decoders)), decoders;
}
var encoders = {}, der_1, hasRequiredDer;
function requireDer() {
  if (hasRequiredDer) return der_1;
  hasRequiredDer = 1;
  var o = requireInherits_browser(), g = requireBuffer$2().Buffer, c = requireAsn1$1(), y = c.base, t = c.constants.der;
  function d(x) {
    this.enc = "der", this.name = x.name, this.entity = x, this.tree = new E(), this.tree._init(x.body);
  }
  der_1 = d, d.prototype.encode = function(v, F) {
    return this.tree._encode(v, F).join();
  };
  function E(x) {
    y.Node.call(this, "der", x);
  }
  o(E, y.Node), E.prototype._encodeComposite = function(v, F, M, U) {
    var L = D(v, F, M, this.reporter);
    if (U.length < 128) {
      var ge = new g(2);
      return ge[0] = L, ge[1] = U.length, this._createEncoderBuffer([ge, U]);
    }
    for (var H = 1, fe = U.length; fe >= 256; fe >>= 8)
      H++;
    var ge = new g(2 + H);
    ge[0] = L, ge[1] = 128 | H;
    for (var fe = 1 + H, Ie = U.length; Ie > 0; fe--, Ie >>= 8)
      ge[fe] = Ie & 255;
    return this._createEncoderBuffer([ge, U]);
  }, E.prototype._encodeStr = function(v, F) {
    if (F === "bitstr")
      return this._createEncoderBuffer([v.unused | 0, v.data]);
    if (F === "bmpstr") {
      for (var M = new g(v.length * 2), U = 0; U < v.length; U++)
        M.writeUInt16BE(v.charCodeAt(U), U * 2);
      return this._createEncoderBuffer(M);
    } else return F === "numstr" ? this._isNumstr(v) ? this._createEncoderBuffer(v) : this.reporter.error("Encoding of string type: numstr supports only digits and space") : F === "printstr" ? this._isPrintstr(v) ? this._createEncoderBuffer(v) : this.reporter.error("Encoding of string type: printstr supports only latin upper and lower case letters, digits, space, apostrophe, left and rigth parenthesis, plus sign, comma, hyphen, dot, slash, colon, equal sign, question mark") : /str$/.test(F) ? this._createEncoderBuffer(v) : F === "objDesc" ? this._createEncoderBuffer(v) : this.reporter.error("Encoding of string type: " + F + " unsupported");
  }, E.prototype._encodeObjid = function(v, F, M) {
    if (typeof v == "string") {
      if (!F)
        return this.reporter.error("string objid given, but no values map found");
      if (!F.hasOwnProperty(v))
        return this.reporter.error("objid not found in values map");
      v = F[v].split(/[\s\.]+/g);
      for (var U = 0; U < v.length; U++)
        v[U] |= 0;
    } else if (Array.isArray(v)) {
      v = v.slice();
      for (var U = 0; U < v.length; U++)
        v[U] |= 0;
    }
    if (!Array.isArray(v))
      return this.reporter.error("objid() should be either array or string, got: " + JSON.stringify(v));
    if (!M) {
      if (v[1] >= 40)
        return this.reporter.error("Second objid identifier OOB");
      v.splice(0, 2, v[0] * 40 + v[1]);
    }
    for (var L = 0, U = 0; U < v.length; U++) {
      var H = v[U];
      for (L++; H >= 128; H >>= 7)
        L++;
    }
    for (var fe = new g(L), ge = fe.length - 1, U = v.length - 1; U >= 0; U--) {
      var H = v[U];
      for (fe[ge--] = H & 127; (H >>= 7) > 0; )
        fe[ge--] = 128 | H & 127;
    }
    return this._createEncoderBuffer(fe);
  };
  function B(x) {
    return x < 10 ? "0" + x : x;
  }
  E.prototype._encodeTime = function(v, F) {
    var M, U = new Date(v);
    return F === "gentime" ? M = [
      B(U.getFullYear()),
      B(U.getUTCMonth() + 1),
      B(U.getUTCDate()),
      B(U.getUTCHours()),
      B(U.getUTCMinutes()),
      B(U.getUTCSeconds()),
      "Z"
    ].join("") : F === "utctime" ? M = [
      B(U.getFullYear() % 100),
      B(U.getUTCMonth() + 1),
      B(U.getUTCDate()),
      B(U.getUTCHours()),
      B(U.getUTCMinutes()),
      B(U.getUTCSeconds()),
      "Z"
    ].join("") : this.reporter.error("Encoding " + F + " time is not supported yet"), this._encodeStr(M, "octstr");
  }, E.prototype._encodeNull = function() {
    return this._createEncoderBuffer("");
  }, E.prototype._encodeInt = function(v, F) {
    if (typeof v == "string") {
      if (!F)
        return this.reporter.error("String int or enum given, but no values map");
      if (!F.hasOwnProperty(v))
        return this.reporter.error("Values map doesn't contain: " + JSON.stringify(v));
      v = F[v];
    }
    if (typeof v != "number" && !g.isBuffer(v)) {
      var M = v.toArray();
      !v.sign && M[0] & 128 && M.unshift(0), v = new g(M);
    }
    if (g.isBuffer(v)) {
      var U = v.length;
      v.length === 0 && U++;
      var H = new g(U);
      return v.copy(H), v.length === 0 && (H[0] = 0), this._createEncoderBuffer(H);
    }
    if (v < 128)
      return this._createEncoderBuffer(v);
    if (v < 256)
      return this._createEncoderBuffer([0, v]);
    for (var U = 1, L = v; L >= 256; L >>= 8)
      U++;
    for (var H = new Array(U), L = H.length - 1; L >= 0; L--)
      H[L] = v & 255, v >>= 8;
    return H[0] & 128 && H.unshift(0), this._createEncoderBuffer(new g(H));
  }, E.prototype._encodeBool = function(v) {
    return this._createEncoderBuffer(v ? 255 : 0);
  }, E.prototype._use = function(v, F) {
    return typeof v == "function" && (v = v(F)), v._getEncoder("der").tree;
  }, E.prototype._skipDefault = function(v, F, M) {
    var U = this._baseState, L;
    if (U.default === null)
      return !1;
    var H = v.join();
    if (U.defaultBuffer === void 0 && (U.defaultBuffer = this._encodeValue(U.default, F, M).join()), H.length !== U.defaultBuffer.length)
      return !1;
    for (L = 0; L < H.length; L++)
      if (H[L] !== U.defaultBuffer[L])
        return !1;
    return !0;
  };
  function D(x, v, F, M) {
    var U;
    if (x === "seqof" ? x = "seq" : x === "setof" && (x = "set"), t.tagByName.hasOwnProperty(x))
      U = t.tagByName[x];
    else if (typeof x == "number" && (x | 0) === x)
      U = x;
    else
      return M.error("Unknown tag: " + x);
    return U >= 31 ? M.error("Multi-octet tag encoding unsupported") : (v || (U |= 32), U |= t.tagClassByName[F || "universal"] << 6, U);
  }
  return der_1;
}
var pem, hasRequiredPem;
function requirePem() {
  if (hasRequiredPem) return pem;
  hasRequiredPem = 1;
  var o = requireInherits_browser(), g = requireDer();
  function c(y) {
    g.call(this, y), this.enc = "pem";
  }
  return o(c, g), pem = c, c.prototype.encode = function(t, d) {
    for (var E = g.prototype.encode.call(this, t), B = E.toString("base64"), D = ["-----BEGIN " + d.label + "-----"], x = 0; x < B.length; x += 64)
      D.push(B.slice(x, x + 64));
    return D.push("-----END " + d.label + "-----"), D.join(`
`);
  }, pem;
}
var hasRequiredEncoders;
function requireEncoders() {
  return hasRequiredEncoders || (hasRequiredEncoders = 1, function(o) {
    var g = o;
    g.der = requireDer(), g.pem = requirePem();
  }(encoders)), encoders;
}
var hasRequiredAsn1$1;
function requireAsn1$1() {
  return hasRequiredAsn1$1 || (hasRequiredAsn1$1 = 1, function(o) {
    var g = o;
    g.bignum = requireBn$1(), g.define = requireApi().define, g.base = requireBase$1(), g.constants = requireConstants$5(), g.decoders = requireDecoders(), g.encoders = requireEncoders();
  }(asn1)), asn1;
}
var certificate, hasRequiredCertificate;
function requireCertificate() {
  if (hasRequiredCertificate) return certificate;
  hasRequiredCertificate = 1;
  var o = requireAsn1$1(), g = o.define("Time", function() {
    this.choice({
      utcTime: this.utctime(),
      generalTime: this.gentime()
    });
  }), c = o.define("AttributeTypeValue", function() {
    this.seq().obj(
      this.key("type").objid(),
      this.key("value").any()
    );
  }), y = o.define("AlgorithmIdentifier", function() {
    this.seq().obj(
      this.key("algorithm").objid(),
      this.key("parameters").optional(),
      this.key("curve").objid().optional()
    );
  }), t = o.define("SubjectPublicKeyInfo", function() {
    this.seq().obj(
      this.key("algorithm").use(y),
      this.key("subjectPublicKey").bitstr()
    );
  }), d = o.define("RelativeDistinguishedName", function() {
    this.setof(c);
  }), E = o.define("RDNSequence", function() {
    this.seqof(d);
  }), B = o.define("Name", function() {
    this.choice({
      rdnSequence: this.use(E)
    });
  }), D = o.define("Validity", function() {
    this.seq().obj(
      this.key("notBefore").use(g),
      this.key("notAfter").use(g)
    );
  }), x = o.define("Extension", function() {
    this.seq().obj(
      this.key("extnID").objid(),
      this.key("critical").bool().def(!1),
      this.key("extnValue").octstr()
    );
  }), v = o.define("TBSCertificate", function() {
    this.seq().obj(
      this.key("version").explicit(0).int().optional(),
      this.key("serialNumber").int(),
      this.key("signature").use(y),
      this.key("issuer").use(B),
      this.key("validity").use(D),
      this.key("subject").use(B),
      this.key("subjectPublicKeyInfo").use(t),
      this.key("issuerUniqueID").implicit(1).bitstr().optional(),
      this.key("subjectUniqueID").implicit(2).bitstr().optional(),
      this.key("extensions").explicit(3).seqof(x).optional()
    );
  }), F = o.define("X509Certificate", function() {
    this.seq().obj(
      this.key("tbsCertificate").use(v),
      this.key("signatureAlgorithm").use(y),
      this.key("signatureValue").bitstr()
    );
  });
  return certificate = F, certificate;
}
var hasRequiredAsn1;
function requireAsn1() {
  if (hasRequiredAsn1) return asn1$1;
  hasRequiredAsn1 = 1;
  var o = requireAsn1$1();
  asn1$1.certificate = requireCertificate();
  var g = o.define("RSAPrivateKey", function() {
    this.seq().obj(
      this.key("version").int(),
      this.key("modulus").int(),
      this.key("publicExponent").int(),
      this.key("privateExponent").int(),
      this.key("prime1").int(),
      this.key("prime2").int(),
      this.key("exponent1").int(),
      this.key("exponent2").int(),
      this.key("coefficient").int()
    );
  });
  asn1$1.RSAPrivateKey = g;
  var c = o.define("RSAPublicKey", function() {
    this.seq().obj(
      this.key("modulus").int(),
      this.key("publicExponent").int()
    );
  });
  asn1$1.RSAPublicKey = c;
  var y = o.define("AlgorithmIdentifier", function() {
    this.seq().obj(
      this.key("algorithm").objid(),
      this.key("none").null_().optional(),
      this.key("curve").objid().optional(),
      this.key("params").seq().obj(
        this.key("p").int(),
        this.key("q").int(),
        this.key("g").int()
      ).optional()
    );
  }), t = o.define("SubjectPublicKeyInfo", function() {
    this.seq().obj(
      this.key("algorithm").use(y),
      this.key("subjectPublicKey").bitstr()
    );
  });
  asn1$1.PublicKey = t;
  var d = o.define("PrivateKeyInfo", function() {
    this.seq().obj(
      this.key("version").int(),
      this.key("algorithm").use(y),
      this.key("subjectPrivateKey").octstr()
    );
  });
  asn1$1.PrivateKey = d;
  var E = o.define("EncryptedPrivateKeyInfo", function() {
    this.seq().obj(
      this.key("algorithm").seq().obj(
        this.key("id").objid(),
        this.key("decrypt").seq().obj(
          this.key("kde").seq().obj(
            this.key("id").objid(),
            this.key("kdeparams").seq().obj(
              this.key("salt").octstr(),
              this.key("iters").int()
            )
          ),
          this.key("cipher").seq().obj(
            this.key("algo").objid(),
            this.key("iv").octstr()
          )
        )
      ),
      this.key("subjectPrivateKey").octstr()
    );
  });
  asn1$1.EncryptedPrivateKey = E;
  var B = o.define("DSAPrivateKey", function() {
    this.seq().obj(
      this.key("version").int(),
      this.key("p").int(),
      this.key("q").int(),
      this.key("g").int(),
      this.key("pub_key").int(),
      this.key("priv_key").int()
    );
  });
  asn1$1.DSAPrivateKey = B, asn1$1.DSAparam = o.define("DSAparam", function() {
    this.int();
  });
  var D = o.define("ECParameters", function() {
    this.choice({
      namedCurve: this.objid()
    });
  }), x = o.define("ECPrivateKey", function() {
    this.seq().obj(
      this.key("version").int(),
      this.key("privateKey").octstr(),
      this.key("parameters").optional().explicit(0).use(D),
      this.key("publicKey").optional().explicit(1).bitstr()
    );
  });
  return asn1$1.ECPrivateKey = x, asn1$1.signature = o.define("signature", function() {
    this.seq().obj(
      this.key("r").int(),
      this.key("s").int()
    );
  }), asn1$1;
}
const require$$1$1 = {
  "2.16.840.1.101.3.4.1.1": "aes-128-ecb",
  "2.16.840.1.101.3.4.1.2": "aes-128-cbc",
  "2.16.840.1.101.3.4.1.3": "aes-128-ofb",
  "2.16.840.1.101.3.4.1.4": "aes-128-cfb",
  "2.16.840.1.101.3.4.1.21": "aes-192-ecb",
  "2.16.840.1.101.3.4.1.22": "aes-192-cbc",
  "2.16.840.1.101.3.4.1.23": "aes-192-ofb",
  "2.16.840.1.101.3.4.1.24": "aes-192-cfb",
  "2.16.840.1.101.3.4.1.41": "aes-256-ecb",
  "2.16.840.1.101.3.4.1.42": "aes-256-cbc",
  "2.16.840.1.101.3.4.1.43": "aes-256-ofb",
  "2.16.840.1.101.3.4.1.44": "aes-256-cfb"
};
var fixProc, hasRequiredFixProc;
function requireFixProc() {
  if (hasRequiredFixProc) return fixProc;
  hasRequiredFixProc = 1;
  var o = /Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r+/=]+)[\n\r]+/m, g = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----/m, c = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----([0-9A-z\n\r+/=]+)-----END \1-----$/m, y = requireEvp_bytestokey(), t = requireBrowser$6(), d = requireSafeBuffer$1().Buffer;
  return fixProc = function(E, B) {
    var D = E.toString(), x = D.match(o), v;
    if (x) {
      var M = "aes" + x[1], U = d.from(x[2], "hex"), L = d.from(x[3].replace(/[\r\n]/g, ""), "base64"), H = y(B, U.slice(0, 8), parseInt(x[1], 10)).key, fe = [], ge = t.createDecipheriv(M, H, U);
      fe.push(ge.update(L)), fe.push(ge.final()), v = d.concat(fe);
    } else {
      var F = D.match(c);
      v = d.from(F[2].replace(/[\r\n]/g, ""), "base64");
    }
    var Ie = D.match(g)[1];
    return {
      tag: Ie,
      data: v
    };
  }, fixProc;
}
var parseAsn1, hasRequiredParseAsn1;
function requireParseAsn1() {
  if (hasRequiredParseAsn1) return parseAsn1;
  hasRequiredParseAsn1 = 1;
  var o = requireAsn1(), g = require$$1$1, c = requireFixProc(), y = requireBrowser$6(), t = requireBrowser$7(), d = requireSafeBuffer$1().Buffer;
  function E(D, x) {
    var v = D.algorithm.decrypt.kde.kdeparams.salt, F = parseInt(D.algorithm.decrypt.kde.kdeparams.iters.toString(), 10), M = g[D.algorithm.decrypt.cipher.algo.join(".")], U = D.algorithm.decrypt.cipher.iv, L = D.subjectPrivateKey, H = parseInt(M.split("-")[1], 10) / 8, fe = t.pbkdf2Sync(x, v, F, H, "sha1"), ge = y.createDecipheriv(M, fe, U), Ie = [];
    return Ie.push(ge.update(L)), Ie.push(ge.final()), d.concat(Ie);
  }
  function B(D) {
    var x;
    typeof D == "object" && !d.isBuffer(D) && (x = D.passphrase, D = D.key), typeof D == "string" && (D = d.from(D));
    var v = c(D, x), F = v.tag, M = v.data, U, L;
    switch (F) {
      case "CERTIFICATE":
        L = o.certificate.decode(M, "der").tbsCertificate.subjectPublicKeyInfo;
      // falls through
      case "PUBLIC KEY":
        switch (L || (L = o.PublicKey.decode(M, "der")), U = L.algorithm.algorithm.join("."), U) {
          case "1.2.840.113549.1.1.1":
            return o.RSAPublicKey.decode(L.subjectPublicKey.data, "der");
          case "1.2.840.10045.2.1":
            return L.subjectPrivateKey = L.subjectPublicKey, {
              type: "ec",
              data: L
            };
          case "1.2.840.10040.4.1":
            return L.algorithm.params.pub_key = o.DSAparam.decode(L.subjectPublicKey.data, "der"), {
              type: "dsa",
              data: L.algorithm.params
            };
          default:
            throw new Error("unknown key id " + U);
        }
      // throw new Error('unknown key type ' + type)
      case "ENCRYPTED PRIVATE KEY":
        M = o.EncryptedPrivateKey.decode(M, "der"), M = E(M, x);
      // falls through
      case "PRIVATE KEY":
        switch (L = o.PrivateKey.decode(M, "der"), U = L.algorithm.algorithm.join("."), U) {
          case "1.2.840.113549.1.1.1":
            return o.RSAPrivateKey.decode(L.subjectPrivateKey, "der");
          case "1.2.840.10045.2.1":
            return {
              curve: L.algorithm.curve,
              privateKey: o.ECPrivateKey.decode(L.subjectPrivateKey, "der").privateKey
            };
          case "1.2.840.10040.4.1":
            return L.algorithm.params.priv_key = o.DSAparam.decode(L.subjectPrivateKey, "der"), {
              type: "dsa",
              params: L.algorithm.params
            };
          default:
            throw new Error("unknown key id " + U);
        }
      // throw new Error('unknown key type ' + type)
      case "RSA PUBLIC KEY":
        return o.RSAPublicKey.decode(M, "der");
      case "RSA PRIVATE KEY":
        return o.RSAPrivateKey.decode(M, "der");
      case "DSA PRIVATE KEY":
        return {
          type: "dsa",
          params: o.DSAPrivateKey.decode(M, "der")
        };
      case "EC PRIVATE KEY":
        return M = o.ECPrivateKey.decode(M, "der"), {
          curve: M.parameters.value,
          privateKey: M.privateKey
        };
      default:
        throw new Error("unknown key type " + F);
    }
  }
  return B.signature = o.signature, parseAsn1 = B, parseAsn1;
}
const require$$4 = {
  "1.3.132.0.10": "secp256k1",
  "1.3.132.0.33": "p224",
  "1.2.840.10045.3.1.1": "p192",
  "1.2.840.10045.3.1.7": "p256",
  "1.3.132.0.34": "p384",
  "1.3.132.0.35": "p521"
};
var hasRequiredSign;
function requireSign() {
  if (hasRequiredSign) return sign$2.exports;
  hasRequiredSign = 1;
  var o = requireSafeBuffer$1().Buffer, g = requireBrowser$8(), c = /* @__PURE__ */ requireBrowserifyRsa(), y = requireElliptic$2().ec, t = requireBn(), d = requireParseAsn1(), E = require$$4, B = 1;
  function D(ge, Ie, Ee, Se, ze) {
    var He = d(Ie);
    if (He.curve) {
      if (Se !== "ecdsa" && Se !== "ecdsa/rsa")
        throw new Error("wrong private key type");
      return x(ge, He);
    } else if (He.type === "dsa") {
      if (Se !== "dsa")
        throw new Error("wrong private key type");
      return v(ge, He, Ee);
    }
    if (Se !== "rsa" && Se !== "ecdsa/rsa")
      throw new Error("wrong private key type");
    if (Ie.padding !== void 0 && Ie.padding !== B)
      throw new Error("illegal or unsupported padding mode");
    ge = o.concat([ze, ge]);
    for (var Pe = He.modulus.byteLength(), De = [0, 1]; ge.length + De.length + 1 < Pe; )
      De.push(255);
    De.push(0);
    for (var ve = -1; ++ve < ge.length; )
      De.push(ge[ve]);
    var Fe = c(De, He);
    return Fe;
  }
  function x(ge, Ie) {
    var Ee = E[Ie.curve.join(".")];
    if (!Ee)
      throw new Error("unknown curve " + Ie.curve.join("."));
    var Se = new y(Ee), ze = Se.keyFromPrivate(Ie.privateKey), He = ze.sign(ge);
    return o.from(He.toDER());
  }
  function v(ge, Ie, Ee) {
    for (var Se = Ie.params.priv_key, ze = Ie.params.p, He = Ie.params.q, Pe = Ie.params.g, De = new t(0), ve, Fe = U(ge, He).mod(He), be = !1, Be = M(Se, He, ge, Ee); be === !1; )
      ve = H(He, Be, Ee), De = fe(Pe, ve, ze, He), be = ve.invm(He).imul(Fe.add(Se.mul(De))).mod(He), be.cmpn(0) === 0 && (be = !1, De = new t(0));
    return F(De, be);
  }
  function F(ge, Ie) {
    ge = ge.toArray(), Ie = Ie.toArray(), ge[0] & 128 && (ge = [0].concat(ge)), Ie[0] & 128 && (Ie = [0].concat(Ie));
    var Ee = ge.length + Ie.length + 4, Se = [
      48,
      Ee,
      2,
      ge.length
    ];
    return Se = Se.concat(ge, [2, Ie.length], Ie), o.from(Se);
  }
  function M(ge, Ie, Ee, Se) {
    if (ge = o.from(ge.toArray()), ge.length < Ie.byteLength()) {
      var ze = o.alloc(Ie.byteLength() - ge.length);
      ge = o.concat([ze, ge]);
    }
    var He = Ee.length, Pe = L(Ee, Ie), De = o.alloc(He);
    De.fill(1);
    var ve = o.alloc(He);
    return ve = g(Se, ve).update(De).update(o.from([0])).update(ge).update(Pe).digest(), De = g(Se, ve).update(De).digest(), ve = g(Se, ve).update(De).update(o.from([1])).update(ge).update(Pe).digest(), De = g(Se, ve).update(De).digest(), { k: ve, v: De };
  }
  function U(ge, Ie) {
    var Ee = new t(ge), Se = (ge.length << 3) - Ie.bitLength();
    return Se > 0 && Ee.ishrn(Se), Ee;
  }
  function L(ge, Ie) {
    ge = U(ge, Ie), ge = ge.mod(Ie);
    var Ee = o.from(ge.toArray());
    if (Ee.length < Ie.byteLength()) {
      var Se = o.alloc(Ie.byteLength() - Ee.length);
      Ee = o.concat([Se, Ee]);
    }
    return Ee;
  }
  function H(ge, Ie, Ee) {
    var Se, ze;
    do {
      for (Se = o.alloc(0); Se.length * 8 < ge.bitLength(); )
        Ie.v = g(Ee, Ie.k).update(Ie.v).digest(), Se = o.concat([Se, Ie.v]);
      ze = U(Se, ge), Ie.k = g(Ee, Ie.k).update(Ie.v).update(o.from([0])).digest(), Ie.v = g(Ee, Ie.k).update(Ie.v).digest();
    } while (ze.cmp(ge) !== -1);
    return ze;
  }
  function fe(ge, Ie, Ee, Se) {
    return ge.toRed(t.mont(Ee)).redPow(Ie).fromRed().mod(Se);
  }
  return sign$2.exports = D, sign$2.exports.getKey = M, sign$2.exports.makeKey = H, sign$2.exports;
}
var verify_1, hasRequiredVerify;
function requireVerify() {
  if (hasRequiredVerify) return verify_1;
  hasRequiredVerify = 1;
  var o = requireSafeBuffer$1().Buffer, g = requireBn(), c = requireElliptic$2().ec, y = requireParseAsn1(), t = require$$4;
  function d(x, v, F, M, U) {
    var L = y(F);
    if (L.type === "ec") {
      if (M !== "ecdsa" && M !== "ecdsa/rsa")
        throw new Error("wrong public key type");
      return E(x, v, L);
    } else if (L.type === "dsa") {
      if (M !== "dsa")
        throw new Error("wrong public key type");
      return B(x, v, L);
    }
    if (M !== "rsa" && M !== "ecdsa/rsa")
      throw new Error("wrong public key type");
    v = o.concat([U, v]);
    for (var H = L.modulus.byteLength(), fe = [1], ge = 0; v.length + fe.length + 2 < H; )
      fe.push(255), ge += 1;
    fe.push(0);
    for (var Ie = -1; ++Ie < v.length; )
      fe.push(v[Ie]);
    fe = o.from(fe);
    var Ee = g.mont(L.modulus);
    x = new g(x).toRed(Ee), x = x.redPow(new g(L.publicExponent)), x = o.from(x.fromRed().toArray());
    var Se = ge < 8 ? 1 : 0;
    for (H = Math.min(x.length, fe.length), x.length !== fe.length && (Se = 1), Ie = -1; ++Ie < H; )
      Se |= x[Ie] ^ fe[Ie];
    return Se === 0;
  }
  function E(x, v, F) {
    var M = t[F.data.algorithm.curve.join(".")];
    if (!M)
      throw new Error("unknown curve " + F.data.algorithm.curve.join("."));
    var U = new c(M), L = F.data.subjectPrivateKey.data;
    return U.verify(v, x, L);
  }
  function B(x, v, F) {
    var M = F.data.p, U = F.data.q, L = F.data.g, H = F.data.pub_key, fe = y.signature.decode(x, "der"), ge = fe.s, Ie = fe.r;
    D(ge, U), D(Ie, U);
    var Ee = g.mont(M), Se = ge.invm(U), ze = L.toRed(Ee).redPow(new g(v).mul(Se).mod(U)).fromRed().mul(H.toRed(Ee).redPow(Ie.mul(Se).mod(U)).fromRed()).mod(M).mod(U);
    return ze.cmp(Ie) === 0;
  }
  function D(x, v) {
    if (x.cmpn(0) <= 0)
      throw new Error("invalid sig");
    if (x.cmp(v) >= 0)
      throw new Error("invalid sig");
  }
  return verify_1 = d, verify_1;
}
var browser$3, hasRequiredBrowser$3;
function requireBrowser$3() {
  if (hasRequiredBrowser$3) return browser$3;
  hasRequiredBrowser$3 = 1;
  var o = requireSafeBuffer$1().Buffer, g = requireBrowser$a(), c = requireReadableBrowser(), y = requireInherits_browser(), t = requireSign(), d = requireVerify(), E = require$$6;
  Object.keys(E).forEach(function(F) {
    E[F].id = o.from(E[F].id, "hex"), E[F.toLowerCase()] = E[F];
  });
  function B(F) {
    c.Writable.call(this);
    var M = E[F];
    if (!M)
      throw new Error("Unknown message digest");
    this._hashType = M.hash, this._hash = g(M.hash), this._tag = M.id, this._signType = M.sign;
  }
  y(B, c.Writable), B.prototype._write = function(M, U, L) {
    this._hash.update(M), L();
  }, B.prototype.update = function(M, U) {
    return this._hash.update(typeof M == "string" ? o.from(M, U) : M), this;
  }, B.prototype.sign = function(M, U) {
    this.end();
    var L = this._hash.digest(), H = t(L, M, this._hashType, this._signType, this._tag);
    return U ? H.toString(U) : H;
  };
  function D(F) {
    c.Writable.call(this);
    var M = E[F];
    if (!M)
      throw new Error("Unknown message digest");
    this._hash = g(M.hash), this._tag = M.id, this._signType = M.sign;
  }
  y(D, c.Writable), D.prototype._write = function(M, U, L) {
    this._hash.update(M), L();
  }, D.prototype.update = function(M, U) {
    return this._hash.update(typeof M == "string" ? o.from(M, U) : M), this;
  }, D.prototype.verify = function(M, U, L) {
    var H = typeof U == "string" ? o.from(U, L) : U;
    this.end();
    var fe = this._hash.digest();
    return d(H, fe, M, this._signType, this._tag);
  };
  function x(F) {
    return new B(F);
  }
  function v(F) {
    return new D(F);
  }
  return browser$3 = {
    Sign: x,
    Verify: v,
    createSign: x,
    createVerify: v
  }, browser$3;
}
var browser$2, hasRequiredBrowser$2;
function requireBrowser$2() {
  if (hasRequiredBrowser$2) return browser$2;
  hasRequiredBrowser$2 = 1;
  var o = requireElliptic$2(), g = requireBn$1();
  browser$2 = function(E) {
    return new y(E);
  };
  var c = {
    secp256k1: {
      name: "secp256k1",
      byteLength: 32
    },
    secp224r1: {
      name: "p224",
      byteLength: 28
    },
    prime256v1: {
      name: "p256",
      byteLength: 32
    },
    prime192v1: {
      name: "p192",
      byteLength: 24
    },
    ed25519: {
      name: "ed25519",
      byteLength: 32
    },
    secp384r1: {
      name: "p384",
      byteLength: 48
    },
    secp521r1: {
      name: "p521",
      byteLength: 66
    }
  };
  c.p224 = c.secp224r1, c.p256 = c.secp256r1 = c.prime256v1, c.p192 = c.secp192r1 = c.prime192v1, c.p384 = c.secp384r1, c.p521 = c.secp521r1;
  function y(d) {
    this.curveType = c[d], this.curveType || (this.curveType = {
      name: d
    }), this.curve = new o.ec(this.curveType.name), this.keys = void 0;
  }
  y.prototype.generateKeys = function(d, E) {
    return this.keys = this.curve.genKeyPair(), this.getPublicKey(d, E);
  }, y.prototype.computeSecret = function(d, E, B) {
    E = E || "utf8", Buffer.isBuffer(d) || (d = new Buffer(d, E));
    var D = this.curve.keyFromPublic(d).getPublic(), x = D.mul(this.keys.getPrivate()).getX();
    return t(x, B, this.curveType.byteLength);
  }, y.prototype.getPublicKey = function(d, E) {
    var B = this.keys.getPublic(E === "compressed", !0);
    return E === "hybrid" && (B[B.length - 1] % 2 ? B[0] = 7 : B[0] = 6), t(B, d);
  }, y.prototype.getPrivateKey = function(d) {
    return t(this.keys.getPrivate(), d);
  }, y.prototype.setPublicKey = function(d, E) {
    return E = E || "utf8", Buffer.isBuffer(d) || (d = new Buffer(d, E)), this.keys._importPublic(d), this;
  }, y.prototype.setPrivateKey = function(d, E) {
    E = E || "utf8", Buffer.isBuffer(d) || (d = new Buffer(d, E));
    var B = new g(d);
    return B = B.toString(16), this.keys = this.curve.genKeyPair(), this.keys._importPrivate(B), this;
  };
  function t(d, E, B) {
    Array.isArray(d) || (d = d.toArray());
    var D = new Buffer(d);
    if (B && D.length < B) {
      var x = new Buffer(B - D.length);
      x.fill(0), D = Buffer.concat([x, D]);
    }
    return E ? D.toString(E) : D;
  }
  return browser$2;
}
var browser$1 = {}, mgf, hasRequiredMgf;
function requireMgf() {
  if (hasRequiredMgf) return mgf;
  hasRequiredMgf = 1;
  var o = requireBrowser$a(), g = requireSafeBuffer$1().Buffer;
  mgf = function(y, t) {
    for (var d = g.alloc(0), E = 0, B; d.length < t; )
      B = c(E++), d = g.concat([d, o("sha1").update(y).update(B).digest()]);
    return d.slice(0, t);
  };
  function c(y) {
    var t = g.allocUnsafe(4);
    return t.writeUInt32BE(y, 0), t;
  }
  return mgf;
}
var xor, hasRequiredXor;
function requireXor() {
  return hasRequiredXor || (hasRequiredXor = 1, xor = function(g, c) {
    for (var y = g.length, t = -1; ++t < y; )
      g[t] ^= c[t];
    return g;
  }), xor;
}
var withPublic_1, hasRequiredWithPublic;
function requireWithPublic() {
  if (hasRequiredWithPublic) return withPublic_1;
  hasRequiredWithPublic = 1;
  var o = requireBn$1(), g = requireSafeBuffer$1().Buffer;
  function c(y, t) {
    return g.from(y.toRed(o.mont(t.modulus)).redPow(new o(t.publicExponent)).fromRed().toArray());
  }
  return withPublic_1 = c, withPublic_1;
}
var publicEncrypt, hasRequiredPublicEncrypt;
function requirePublicEncrypt() {
  if (hasRequiredPublicEncrypt) return publicEncrypt;
  hasRequiredPublicEncrypt = 1;
  var o = requireParseAsn1(), g = requireBrowser$9(), c = requireBrowser$a(), y = requireMgf(), t = requireXor(), d = requireBn$1(), E = requireWithPublic(), B = /* @__PURE__ */ requireBrowserifyRsa(), D = requireSafeBuffer$1().Buffer;
  publicEncrypt = function(U, L, H) {
    var fe;
    U.padding ? fe = U.padding : H ? fe = 1 : fe = 4;
    var ge = o(U), Ie;
    if (fe === 4)
      Ie = x(ge, L);
    else if (fe === 1)
      Ie = v(ge, L, H);
    else if (fe === 3) {
      if (Ie = new d(L), Ie.cmp(ge.modulus) >= 0)
        throw new Error("data too long for modulus");
    } else
      throw new Error("unknown padding");
    return H ? B(Ie, ge) : E(Ie, ge);
  };
  function x(M, U) {
    var L = M.modulus.byteLength(), H = U.length, fe = c("sha1").update(D.alloc(0)).digest(), ge = fe.length, Ie = 2 * ge;
    if (H > L - Ie - 2)
      throw new Error("message too long");
    var Ee = D.alloc(L - H - Ie - 2), Se = L - ge - 1, ze = g(ge), He = t(D.concat([fe, Ee, D.alloc(1, 1), U], Se), y(ze, Se)), Pe = t(ze, y(He, ge));
    return new d(D.concat([D.alloc(1), Pe, He], L));
  }
  function v(M, U, L) {
    var H = U.length, fe = M.modulus.byteLength();
    if (H > fe - 11)
      throw new Error("message too long");
    var ge;
    return L ? ge = D.alloc(fe - H - 3, 255) : ge = F(fe - H - 3), new d(D.concat([D.from([0, L ? 1 : 2]), ge, D.alloc(1), U], fe));
  }
  function F(M) {
    for (var U = D.allocUnsafe(M), L = 0, H = g(M * 2), fe = 0, ge; L < M; )
      fe === H.length && (H = g(M * 2), fe = 0), ge = H[fe++], ge && (U[L++] = ge);
    return U;
  }
  return publicEncrypt;
}
var privateDecrypt, hasRequiredPrivateDecrypt;
function requirePrivateDecrypt() {
  if (hasRequiredPrivateDecrypt) return privateDecrypt;
  hasRequiredPrivateDecrypt = 1;
  var o = requireParseAsn1(), g = requireMgf(), c = requireXor(), y = requireBn$1(), t = /* @__PURE__ */ requireBrowserifyRsa(), d = requireBrowser$a(), E = requireWithPublic(), B = requireSafeBuffer$1().Buffer;
  privateDecrypt = function(M, U, L) {
    var H;
    M.padding ? H = M.padding : L ? H = 1 : H = 4;
    var fe = o(M), ge = fe.modulus.byteLength();
    if (U.length > ge || new y(U).cmp(fe.modulus) >= 0)
      throw new Error("decryption error");
    var Ie;
    L ? Ie = E(new y(U), fe) : Ie = t(U, fe);
    var Ee = B.alloc(ge - Ie.length);
    if (Ie = B.concat([Ee, Ie], ge), H === 4)
      return D(fe, Ie);
    if (H === 1)
      return x(fe, Ie, L);
    if (H === 3)
      return Ie;
    throw new Error("unknown padding");
  };
  function D(F, M) {
    var U = F.modulus.byteLength(), L = d("sha1").update(B.alloc(0)).digest(), H = L.length;
    if (M[0] !== 0)
      throw new Error("decryption error");
    var fe = M.slice(1, H + 1), ge = M.slice(H + 1), Ie = c(fe, g(ge, H)), Ee = c(ge, g(Ie, U - H - 1));
    if (v(L, Ee.slice(0, H)))
      throw new Error("decryption error");
    for (var Se = H; Ee[Se] === 0; )
      Se++;
    if (Ee[Se++] !== 1)
      throw new Error("decryption error");
    return Ee.slice(Se);
  }
  function x(F, M, U) {
    for (var L = M.slice(0, 2), H = 2, fe = 0; M[H++] !== 0; )
      if (H >= M.length) {
        fe++;
        break;
      }
    var ge = M.slice(2, H - 1);
    if ((L.toString("hex") !== "0002" && !U || L.toString("hex") !== "0001" && U) && fe++, ge.length < 8 && fe++, fe)
      throw new Error("decryption error");
    return M.slice(H);
  }
  function v(F, M) {
    F = B.from(F), M = B.from(M);
    var U = 0, L = F.length;
    F.length !== M.length && (U++, L = Math.min(F.length, M.length));
    for (var H = -1; ++H < L; )
      U += F[H] ^ M[H];
    return U;
  }
  return privateDecrypt;
}
var hasRequiredBrowser$1;
function requireBrowser$1() {
  return hasRequiredBrowser$1 || (hasRequiredBrowser$1 = 1, function(o) {
    o.publicEncrypt = requirePublicEncrypt(), o.privateDecrypt = requirePrivateDecrypt(), o.privateEncrypt = function(c, y) {
      return o.publicEncrypt(c, y, !0);
    }, o.publicDecrypt = function(c, y) {
      return o.privateDecrypt(c, y, !0);
    };
  }(browser$1)), browser$1;
}
var browser = {}, hasRequiredBrowser;
function requireBrowser() {
  if (hasRequiredBrowser) return browser;
  hasRequiredBrowser = 1;
  function o() {
    throw new Error(`secure random number generation not supported by this browser
use chrome, FireFox or Internet Explorer 11`);
  }
  var g = requireSafeBuffer$1(), c = requireBrowser$9(), y = g.Buffer, t = g.kMaxLength, d = commonjsGlobal.crypto || commonjsGlobal.msCrypto, E = Math.pow(2, 32) - 1;
  function B(M, U) {
    if (typeof M != "number" || M !== M)
      throw new TypeError("offset must be a number");
    if (M > E || M < 0)
      throw new TypeError("offset must be a uint32");
    if (M > t || M > U)
      throw new RangeError("offset out of range");
  }
  function D(M, U, L) {
    if (typeof M != "number" || M !== M)
      throw new TypeError("size must be a number");
    if (M > E || M < 0)
      throw new TypeError("size must be a uint32");
    if (M + U > L || M > t)
      throw new RangeError("buffer too small");
  }
  d && d.getRandomValues || !process$1.browser ? (browser.randomFill = x, browser.randomFillSync = F) : (browser.randomFill = o, browser.randomFillSync = o);
  function x(M, U, L, H) {
    if (!y.isBuffer(M) && !(M instanceof commonjsGlobal.Uint8Array))
      throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    if (typeof U == "function")
      H = U, U = 0, L = M.length;
    else if (typeof L == "function")
      H = L, L = M.length - U;
    else if (typeof H != "function")
      throw new TypeError('"cb" argument must be a function');
    return B(U, M.length), D(L, U, M.length), v(M, U, L, H);
  }
  function v(M, U, L, H) {
    if (process$1.browser) {
      var fe = M.buffer, ge = new Uint8Array(fe, U, L);
      if (d.getRandomValues(ge), H) {
        process$1.nextTick(function() {
          H(null, M);
        });
        return;
      }
      return M;
    }
    if (H) {
      c(L, function(Ee, Se) {
        if (Ee)
          return H(Ee);
        Se.copy(M, U), H(null, M);
      });
      return;
    }
    var Ie = c(L);
    return Ie.copy(M, U), M;
  }
  function F(M, U, L) {
    if (typeof U > "u" && (U = 0), !y.isBuffer(M) && !(M instanceof commonjsGlobal.Uint8Array))
      throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    return B(U, M.length), L === void 0 && (L = M.length - U), D(L, U, M.length), v(M, U, L);
  }
  return browser;
}
var hasRequiredCryptoBrowserify;
function requireCryptoBrowserify() {
  if (hasRequiredCryptoBrowserify) return cryptoBrowserify;
  hasRequiredCryptoBrowserify = 1, cryptoBrowserify.randomBytes = cryptoBrowserify.rng = cryptoBrowserify.pseudoRandomBytes = cryptoBrowserify.prng = requireBrowser$9(), cryptoBrowserify.createHash = cryptoBrowserify.Hash = requireBrowser$a(), cryptoBrowserify.createHmac = cryptoBrowserify.Hmac = requireBrowser$8();
  var o = requireAlgos(), g = Object.keys(o), c = [
    "sha1",
    "sha224",
    "sha256",
    "sha384",
    "sha512",
    "md5",
    "rmd160"
  ].concat(g);
  cryptoBrowserify.getHashes = function() {
    return c;
  };
  var y = requireBrowser$7();
  cryptoBrowserify.pbkdf2 = y.pbkdf2, cryptoBrowserify.pbkdf2Sync = y.pbkdf2Sync;
  var t = requireBrowser$5();
  cryptoBrowserify.Cipher = t.Cipher, cryptoBrowserify.createCipher = t.createCipher, cryptoBrowserify.Cipheriv = t.Cipheriv, cryptoBrowserify.createCipheriv = t.createCipheriv, cryptoBrowserify.Decipher = t.Decipher, cryptoBrowserify.createDecipher = t.createDecipher, cryptoBrowserify.Decipheriv = t.Decipheriv, cryptoBrowserify.createDecipheriv = t.createDecipheriv, cryptoBrowserify.getCiphers = t.getCiphers, cryptoBrowserify.listCiphers = t.listCiphers;
  var d = requireBrowser$4();
  cryptoBrowserify.DiffieHellmanGroup = d.DiffieHellmanGroup, cryptoBrowserify.createDiffieHellmanGroup = d.createDiffieHellmanGroup, cryptoBrowserify.getDiffieHellman = d.getDiffieHellman, cryptoBrowserify.createDiffieHellman = d.createDiffieHellman, cryptoBrowserify.DiffieHellman = d.DiffieHellman;
  var E = requireBrowser$3();
  cryptoBrowserify.createSign = E.createSign, cryptoBrowserify.Sign = E.Sign, cryptoBrowserify.createVerify = E.createVerify, cryptoBrowserify.Verify = E.Verify, cryptoBrowserify.createECDH = requireBrowser$2();
  var B = requireBrowser$1();
  cryptoBrowserify.publicEncrypt = B.publicEncrypt, cryptoBrowserify.privateEncrypt = B.privateEncrypt, cryptoBrowserify.publicDecrypt = B.publicDecrypt, cryptoBrowserify.privateDecrypt = B.privateDecrypt;
  var D = requireBrowser();
  return cryptoBrowserify.randomFill = D.randomFill, cryptoBrowserify.randomFillSync = D.randomFillSync, cryptoBrowserify.createCredentials = function() {
    throw new Error(`sorry, createCredentials is not implemented yet
we accept pull requests
https://github.com/browserify/crypto-browserify`);
  }, cryptoBrowserify.constants = {
    DH_CHECK_P_NOT_SAFE_PRIME: 2,
    DH_CHECK_P_NOT_PRIME: 1,
    DH_UNABLE_TO_CHECK_GENERATOR: 4,
    DH_NOT_SUITABLE_GENERATOR: 8,
    NPN_ENABLED: 1,
    ALPN_ENABLED: 1,
    RSA_PKCS1_PADDING: 1,
    RSA_SSLV23_PADDING: 2,
    RSA_NO_PADDING: 3,
    RSA_PKCS1_OAEP_PADDING: 4,
    RSA_X931_PADDING: 5,
    RSA_PKCS1_PSS_PADDING: 6,
    POINT_CONVERSION_COMPRESSED: 2,
    POINT_CONVERSION_UNCOMPRESSED: 4,
    POINT_CONVERSION_HYBRID: 6
  }, cryptoBrowserify;
}
var lib$5, hasRequiredLib$5;
function requireLib$5() {
  if (hasRequiredLib$5) return lib$5;
  hasRequiredLib$5 = 1;
  const o = {
    IMPOSSIBLE_CASE: "Impossible case. Please create issue.",
    TWEAK_ADD: "The tweak was out of range or the resulted private key is invalid",
    TWEAK_MUL: "The tweak was out of range or equal to zero",
    CONTEXT_RANDOMIZE_UNKNOW: "Unknow error on context randomization",
    SECKEY_INVALID: "Private Key is invalid",
    PUBKEY_PARSE: "Public Key could not be parsed",
    PUBKEY_SERIALIZE: "Public Key serialization error",
    PUBKEY_COMBINE: "The sum of the public keys is not valid",
    SIG_PARSE: "Signature could not be parsed",
    SIGN: "The nonce generation function failed, or the private key was invalid",
    RECOVER: "Public key could not be recover",
    ECDH: "Scalar was invalid (zero or overflow)"
  };
  function g(E, B) {
    if (!E) throw new Error(B);
  }
  function c(E, B, D) {
    if (g(B instanceof Uint8Array, `Expected ${E} to be an Uint8Array`), D !== void 0)
      if (Array.isArray(D)) {
        const x = D.join(", "), v = `Expected ${E} to be an Uint8Array with length [${x}]`;
        g(D.includes(B.length), v);
      } else {
        const x = `Expected ${E} to be an Uint8Array with length ${D}`;
        g(B.length === D, x);
      }
  }
  function y(E) {
    g(d(E) === "Boolean", "Expected compressed to be a Boolean");
  }
  function t(E = (D) => new Uint8Array(D), B) {
    return typeof E == "function" && (E = E(B)), c("output", E, B), E;
  }
  function d(E) {
    return Object.prototype.toString.call(E).slice(8, -1);
  }
  return lib$5 = (E) => ({
    contextRandomize(B) {
      switch (g(
        B === null || B instanceof Uint8Array,
        "Expected seed to be an Uint8Array or null"
      ), B !== null && c("seed", B, 32), E.contextRandomize(B)) {
        case 1:
          throw new Error(o.CONTEXT_RANDOMIZE_UNKNOW);
      }
    },
    privateKeyVerify(B) {
      return c("private key", B, 32), E.privateKeyVerify(B) === 0;
    },
    privateKeyNegate(B) {
      switch (c("private key", B, 32), E.privateKeyNegate(B)) {
        case 0:
          return B;
        case 1:
          throw new Error(o.IMPOSSIBLE_CASE);
      }
    },
    privateKeyTweakAdd(B, D) {
      switch (c("private key", B, 32), c("tweak", D, 32), E.privateKeyTweakAdd(B, D)) {
        case 0:
          return B;
        case 1:
          throw new Error(o.TWEAK_ADD);
      }
    },
    privateKeyTweakMul(B, D) {
      switch (c("private key", B, 32), c("tweak", D, 32), E.privateKeyTweakMul(B, D)) {
        case 0:
          return B;
        case 1:
          throw new Error(o.TWEAK_MUL);
      }
    },
    publicKeyVerify(B) {
      return c("public key", B, [33, 65]), E.publicKeyVerify(B) === 0;
    },
    publicKeyCreate(B, D = !0, x) {
      switch (c("private key", B, 32), y(D), x = t(x, D ? 33 : 65), E.publicKeyCreate(x, B)) {
        case 0:
          return x;
        case 1:
          throw new Error(o.SECKEY_INVALID);
        case 2:
          throw new Error(o.PUBKEY_SERIALIZE);
      }
    },
    publicKeyConvert(B, D = !0, x) {
      switch (c("public key", B, [33, 65]), y(D), x = t(x, D ? 33 : 65), E.publicKeyConvert(x, B)) {
        case 0:
          return x;
        case 1:
          throw new Error(o.PUBKEY_PARSE);
        case 2:
          throw new Error(o.PUBKEY_SERIALIZE);
      }
    },
    publicKeyNegate(B, D = !0, x) {
      switch (c("public key", B, [33, 65]), y(D), x = t(x, D ? 33 : 65), E.publicKeyNegate(x, B)) {
        case 0:
          return x;
        case 1:
          throw new Error(o.PUBKEY_PARSE);
        case 2:
          throw new Error(o.IMPOSSIBLE_CASE);
        case 3:
          throw new Error(o.PUBKEY_SERIALIZE);
      }
    },
    publicKeyCombine(B, D = !0, x) {
      g(Array.isArray(B), "Expected public keys to be an Array"), g(B.length > 0, "Expected public keys array will have more than zero items");
      for (const v of B)
        c("public key", v, [33, 65]);
      switch (y(D), x = t(x, D ? 33 : 65), E.publicKeyCombine(x, B)) {
        case 0:
          return x;
        case 1:
          throw new Error(o.PUBKEY_PARSE);
        case 2:
          throw new Error(o.PUBKEY_COMBINE);
        case 3:
          throw new Error(o.PUBKEY_SERIALIZE);
      }
    },
    publicKeyTweakAdd(B, D, x = !0, v) {
      switch (c("public key", B, [33, 65]), c("tweak", D, 32), y(x), v = t(v, x ? 33 : 65), E.publicKeyTweakAdd(v, B, D)) {
        case 0:
          return v;
        case 1:
          throw new Error(o.PUBKEY_PARSE);
        case 2:
          throw new Error(o.TWEAK_ADD);
      }
    },
    publicKeyTweakMul(B, D, x = !0, v) {
      switch (c("public key", B, [33, 65]), c("tweak", D, 32), y(x), v = t(v, x ? 33 : 65), E.publicKeyTweakMul(v, B, D)) {
        case 0:
          return v;
        case 1:
          throw new Error(o.PUBKEY_PARSE);
        case 2:
          throw new Error(o.TWEAK_MUL);
      }
    },
    signatureNormalize(B) {
      switch (c("signature", B, 64), E.signatureNormalize(B)) {
        case 0:
          return B;
        case 1:
          throw new Error(o.SIG_PARSE);
      }
    },
    signatureExport(B, D) {
      c("signature", B, 64), D = t(D, 72);
      const x = { output: D, outputlen: 72 };
      switch (E.signatureExport(x, B)) {
        case 0:
          return D.slice(0, x.outputlen);
        case 1:
          throw new Error(o.SIG_PARSE);
        case 2:
          throw new Error(o.IMPOSSIBLE_CASE);
      }
    },
    signatureImport(B, D) {
      switch (c("signature", B), D = t(D, 64), E.signatureImport(D, B)) {
        case 0:
          return D;
        case 1:
          throw new Error(o.SIG_PARSE);
        case 2:
          throw new Error(o.IMPOSSIBLE_CASE);
      }
    },
    ecdsaSign(B, D, x = {}, v) {
      c("message", B, 32), c("private key", D, 32), g(d(x) === "Object", "Expected options to be an Object"), x.data !== void 0 && c("options.data", x.data), x.noncefn !== void 0 && g(d(x.noncefn) === "Function", "Expected options.noncefn to be a Function"), v = t(v, 64);
      const F = { signature: v, recid: null };
      switch (E.ecdsaSign(F, B, D, x.data, x.noncefn)) {
        case 0:
          return F;
        case 1:
          throw new Error(o.SIGN);
        case 2:
          throw new Error(o.IMPOSSIBLE_CASE);
      }
    },
    ecdsaVerify(B, D, x) {
      switch (c("signature", B, 64), c("message", D, 32), c("public key", x, [33, 65]), E.ecdsaVerify(B, D, x)) {
        case 0:
          return !0;
        case 3:
          return !1;
        case 1:
          throw new Error(o.SIG_PARSE);
        case 2:
          throw new Error(o.PUBKEY_PARSE);
      }
    },
    ecdsaRecover(B, D, x, v = !0, F) {
      switch (c("signature", B, 64), g(
        d(D) === "Number" && D >= 0 && D <= 3,
        "Expected recovery id to be a Number within interval [0, 3]"
      ), c("message", x, 32), y(v), F = t(F, v ? 33 : 65), E.ecdsaRecover(F, B, D, x)) {
        case 0:
          return F;
        case 1:
          throw new Error(o.SIG_PARSE);
        case 2:
          throw new Error(o.RECOVER);
        case 3:
          throw new Error(o.IMPOSSIBLE_CASE);
      }
    },
    ecdh(B, D, x = {}, v) {
      switch (c("public key", B, [33, 65]), c("private key", D, 32), g(d(x) === "Object", "Expected options to be an Object"), x.data !== void 0 && c("options.data", x.data), x.hashfn !== void 0 ? (g(d(x.hashfn) === "Function", "Expected options.hashfn to be a Function"), x.xbuf !== void 0 && c("options.xbuf", x.xbuf, 32), x.ybuf !== void 0 && c("options.ybuf", x.ybuf, 32), c("output", v)) : v = t(v, 32), E.ecdh(v, B, D, x.data, x.hashfn, x.xbuf, x.ybuf)) {
        case 0:
          return v;
        case 1:
          throw new Error(o.PUBKEY_PARSE);
        case 2:
          throw new Error(o.ECDH);
      }
    }
  }), lib$5;
}
var elliptic$1, hasRequiredElliptic$1;
function requireElliptic$1() {
  if (hasRequiredElliptic$1) return elliptic$1;
  hasRequiredElliptic$1 = 1;
  const o = requireElliptic$2().ec, g = new o("secp256k1"), c = g.curve, y = c.n.constructor;
  function t(D, x) {
    let v = new y(x);
    if (v.cmp(c.p) >= 0) return null;
    v = v.toRed(c.red);
    let F = v.redSqr().redIMul(v).redIAdd(c.b).redSqrt();
    D === 3 !== F.isOdd() && (F = F.redNeg());
    const M = v.redSqr().redIMul(v);
    return F.redSqr().redISub(M.redIAdd(c.b)).isZero() ? g.keyPair({ pub: { x: v, y: F } }) : null;
  }
  function d(D, x, v) {
    let F = new y(x), M = new y(v);
    if (F.cmp(c.p) >= 0 || M.cmp(c.p) >= 0 || (F = F.toRed(c.red), M = M.toRed(c.red), (D === 6 || D === 7) && M.isOdd() !== (D === 7))) return null;
    const U = F.redSqr().redIMul(F);
    return M.redSqr().redISub(U.redIAdd(c.b)).isZero() ? g.keyPair({ pub: { x: F, y: M } }) : null;
  }
  function E(D) {
    const x = D[0];
    switch (x) {
      case 2:
      case 3:
        return D.length !== 33 ? null : t(x, D.subarray(1, 33));
      case 4:
      case 6:
      case 7:
        return D.length !== 65 ? null : d(x, D.subarray(1, 33), D.subarray(33, 65));
      default:
        return null;
    }
  }
  function B(D, x) {
    const v = x.encode(null, D.length === 33);
    for (let F = 0; F < D.length; ++F) D[F] = v[F];
  }
  return elliptic$1 = {
    contextRandomize() {
      return 0;
    },
    privateKeyVerify(D) {
      const x = new y(D);
      return x.cmp(c.n) < 0 && !x.isZero() ? 0 : 1;
    },
    privateKeyNegate(D) {
      const x = new y(D), v = c.n.sub(x).umod(c.n).toArrayLike(Uint8Array, "be", 32);
      return D.set(v), 0;
    },
    privateKeyTweakAdd(D, x) {
      const v = new y(x);
      if (v.cmp(c.n) >= 0 || (v.iadd(new y(D)), v.cmp(c.n) >= 0 && v.isub(c.n), v.isZero())) return 1;
      const F = v.toArrayLike(Uint8Array, "be", 32);
      return D.set(F), 0;
    },
    privateKeyTweakMul(D, x) {
      let v = new y(x);
      if (v.cmp(c.n) >= 0 || v.isZero()) return 1;
      v.imul(new y(D)), v.cmp(c.n) >= 0 && (v = v.umod(c.n));
      const F = v.toArrayLike(Uint8Array, "be", 32);
      return D.set(F), 0;
    },
    publicKeyVerify(D) {
      return E(D) === null ? 1 : 0;
    },
    publicKeyCreate(D, x) {
      const v = new y(x);
      if (v.cmp(c.n) >= 0 || v.isZero()) return 1;
      const F = g.keyFromPrivate(x).getPublic();
      return B(D, F), 0;
    },
    publicKeyConvert(D, x) {
      const v = E(x);
      if (v === null) return 1;
      const F = v.getPublic();
      return B(D, F), 0;
    },
    publicKeyNegate(D, x) {
      const v = E(x);
      if (v === null) return 1;
      const F = v.getPublic();
      return F.y = F.y.redNeg(), B(D, F), 0;
    },
    publicKeyCombine(D, x) {
      const v = new Array(x.length);
      for (let M = 0; M < x.length; ++M)
        if (v[M] = E(x[M]), v[M] === null) return 1;
      let F = v[0].getPublic();
      for (let M = 1; M < v.length; ++M) F = F.add(v[M].pub);
      return F.isInfinity() ? 2 : (B(D, F), 0);
    },
    publicKeyTweakAdd(D, x, v) {
      const F = E(x);
      if (F === null) return 1;
      if (v = new y(v), v.cmp(c.n) >= 0) return 2;
      const M = F.getPublic().add(c.g.mul(v));
      return M.isInfinity() ? 2 : (B(D, M), 0);
    },
    publicKeyTweakMul(D, x, v) {
      const F = E(x);
      if (F === null) return 1;
      if (v = new y(v), v.cmp(c.n) >= 0 || v.isZero()) return 2;
      const M = F.getPublic().mul(v);
      return B(D, M), 0;
    },
    signatureNormalize(D) {
      const x = new y(D.subarray(0, 32)), v = new y(D.subarray(32, 64));
      return x.cmp(c.n) >= 0 || v.cmp(c.n) >= 0 ? 1 : (v.cmp(g.nh) === 1 && D.set(c.n.sub(v).toArrayLike(Uint8Array, "be", 32), 32), 0);
    },
    // Copied 1-to-1 from https://github.com/bitcoinjs/bip66/blob/master/index.js
    // Adapted for Uint8Array instead Buffer
    signatureExport(D, x) {
      const v = x.subarray(0, 32), F = x.subarray(32, 64);
      if (new y(v).cmp(c.n) >= 0 || new y(F).cmp(c.n) >= 0) return 1;
      const { output: M } = D;
      let U = M.subarray(4, 37);
      U[0] = 0, U.set(v, 1);
      let L = 33, H = 0;
      for (; L > 1 && U[H] === 0 && !(U[H + 1] & 128); --L, ++H) ;
      if (U = U.subarray(H), U[0] & 128 || L > 1 && U[0] === 0 && !(U[1] & 128)) return 1;
      let fe = M.subarray(39, 72);
      fe[0] = 0, fe.set(F, 1);
      let ge = 33, Ie = 0;
      for (; ge > 1 && fe[Ie] === 0 && !(fe[Ie + 1] & 128); --ge, ++Ie) ;
      return fe = fe.subarray(Ie), fe[0] & 128 || ge > 1 && fe[0] === 0 && !(fe[1] & 128) ? 1 : (D.outputlen = 6 + L + ge, M[0] = 48, M[1] = D.outputlen - 2, M[2] = 2, M[3] = U.length, M.set(U, 4), M[4 + L] = 2, M[5 + L] = fe.length, M.set(fe, 6 + L), 0);
    },
    // Copied 1-to-1 from https://github.com/bitcoinjs/bip66/blob/master/index.js
    // Adapted for Uint8Array instead Buffer
    signatureImport(D, x) {
      if (x.length < 8 || x.length > 72 || x[0] !== 48 || x[1] !== x.length - 2 || x[2] !== 2) return 1;
      const v = x[3];
      if (v === 0 || 5 + v >= x.length || x[4 + v] !== 2) return 1;
      const F = x[5 + v];
      if (F === 0 || 6 + v + F !== x.length || x[4] & 128 || v > 1 && x[4] === 0 && !(x[5] & 128) || x[v + 6] & 128 || F > 1 && x[v + 6] === 0 && !(x[v + 7] & 128)) return 1;
      let M = x.subarray(4, 4 + v);
      if (M.length === 33 && M[0] === 0 && (M = M.subarray(1)), M.length > 32) return 1;
      let U = x.subarray(6 + v);
      if (U.length === 33 && U[0] === 0 && (U = U.slice(1)), U.length > 32) throw new Error("S length is too long");
      let L = new y(M);
      L.cmp(c.n) >= 0 && (L = new y(0));
      let H = new y(x.subarray(6 + v));
      return H.cmp(c.n) >= 0 && (H = new y(0)), D.set(L.toArrayLike(Uint8Array, "be", 32), 0), D.set(H.toArrayLike(Uint8Array, "be", 32), 32), 0;
    },
    ecdsaSign(D, x, v, F, M) {
      if (M) {
        const H = M;
        M = (fe) => {
          const ge = H(x, v, null, F, fe);
          if (!(ge instanceof Uint8Array && ge.length === 32)) throw new Error("This is the way");
          return new y(ge);
        };
      }
      const U = new y(v);
      if (U.cmp(c.n) >= 0 || U.isZero()) return 1;
      let L;
      try {
        L = g.sign(x, v, { canonical: !0, k: M, pers: F });
      } catch {
        return 1;
      }
      return D.signature.set(L.r.toArrayLike(Uint8Array, "be", 32), 0), D.signature.set(L.s.toArrayLike(Uint8Array, "be", 32), 32), D.recid = L.recoveryParam, 0;
    },
    ecdsaVerify(D, x, v) {
      const F = { r: D.subarray(0, 32), s: D.subarray(32, 64) }, M = new y(F.r), U = new y(F.s);
      if (M.cmp(c.n) >= 0 || U.cmp(c.n) >= 0) return 1;
      if (U.cmp(g.nh) === 1 || M.isZero() || U.isZero()) return 3;
      const L = E(v);
      if (L === null) return 2;
      const H = L.getPublic();
      return g.verify(x, F, H) ? 0 : 3;
    },
    ecdsaRecover(D, x, v, F) {
      const M = { r: x.slice(0, 32), s: x.slice(32, 64) }, U = new y(M.r), L = new y(M.s);
      if (U.cmp(c.n) >= 0 || L.cmp(c.n) >= 0) return 1;
      if (U.isZero() || L.isZero()) return 2;
      let H;
      try {
        H = g.recoverPubKey(F, M, v);
      } catch {
        return 2;
      }
      return B(D, H), 0;
    },
    ecdh(D, x, v, F, M, U, L) {
      const H = E(x);
      if (H === null) return 1;
      const fe = new y(v);
      if (fe.cmp(c.n) >= 0 || fe.isZero()) return 2;
      const ge = H.getPublic().mul(fe);
      if (M === void 0) {
        const Ie = ge.encode(null, !0), Ee = g.hash().update(Ie).digest();
        for (let Se = 0; Se < 32; ++Se) D[Se] = Ee[Se];
      } else {
        U || (U = new Uint8Array(32));
        const Ie = ge.getX().toArray("be", 32);
        for (let He = 0; He < 32; ++He) U[He] = Ie[He];
        L || (L = new Uint8Array(32));
        const Ee = ge.getY().toArray("be", 32);
        for (let He = 0; He < 32; ++He) L[He] = Ee[He];
        const Se = M(U, L, F);
        if (!(Se instanceof Uint8Array && Se.length === D.length)) return 2;
        D.set(Se);
      }
      return 0;
    }
  }, elliptic$1;
}
var elliptic, hasRequiredElliptic;
function requireElliptic() {
  return hasRequiredElliptic || (hasRequiredElliptic = 1, elliptic = requireLib$5()(requireElliptic$1())), elliptic;
}
var hdkey, hasRequiredHdkey;
function requireHdkey() {
  if (hasRequiredHdkey) return hdkey;
  hasRequiredHdkey = 1;
  var o = requireAssert$2(), g = requireSafeBuffer$1().Buffer, c = requireCryptoBrowserify(), y = requireBs58check$1(), t = requireRipemd160$2(), d = requireElliptic(), E = g.from("Bitcoin seed", "utf8"), B = 2147483648, D = 78, x = { private: 76066276, public: 76067358 };
  function v(L) {
    this.versions = L || x, this.depth = 0, this.index = 0, this._privateKey = null, this._publicKey = null, this.chainCode = null, this._fingerprint = 0, this.parentFingerprint = 0;
  }
  Object.defineProperty(v.prototype, "fingerprint", { get: function() {
    return this._fingerprint;
  } }), Object.defineProperty(v.prototype, "identifier", { get: function() {
    return this._identifier;
  } }), Object.defineProperty(v.prototype, "pubKeyHash", { get: function() {
    return this.identifier;
  } }), Object.defineProperty(v.prototype, "privateKey", {
    get: function() {
      return this._privateKey;
    },
    set: function(L) {
      o.equal(L.length, 32, "Private key must be 32 bytes."), o(d.privateKeyVerify(L) === !0, "Invalid private key"), this._privateKey = L, this._publicKey = g.from(d.publicKeyCreate(L, !0)), this._identifier = U(this.publicKey), this._fingerprint = this._identifier.slice(0, 4).readUInt32BE(0);
    }
  });
  function F(L, H) {
    L._publicKey = g.from(H), L._identifier = U(H), L._fingerprint = L._identifier.slice(0, 4).readUInt32BE(0), L._privateKey = null;
  }
  Object.defineProperty(v.prototype, "publicKey", {
    get: function() {
      return this._publicKey;
    },
    set: function(L) {
      o(L.length === 33 || L.length === 65, "Public key must be 33 or 65 bytes."), o(d.publicKeyVerify(L) === !0, "Invalid public key");
      const H = L.length === 65 ? d.publicKeyConvert(L, !0) : L;
      F(this, H);
    }
  }), Object.defineProperty(v.prototype, "privateExtendedKey", {
    get: function() {
      return this._privateKey ? y.encode(M(this, this.versions.private, g.concat([g.alloc(1, 0), this.privateKey]))) : null;
    }
  }), Object.defineProperty(v.prototype, "publicExtendedKey", {
    get: function() {
      return y.encode(M(this, this.versions.public, this.publicKey));
    }
  }), v.prototype.derive = function(L) {
    if (L === "m" || L === "M" || L === "m'" || L === "M'")
      return this;
    var H = L.split("/"), fe = this;
    return H.forEach(function(ge, Ie) {
      if (Ie === 0) {
        o(/^[mM]{1}/.test(ge), 'Path must start with "m" or "M"');
        return;
      }
      var Ee = ge.length > 1 && ge[ge.length - 1] === "'", Se = parseInt(ge, 10);
      o(Se < B, "Invalid index"), Ee && (Se += B), fe = fe.deriveChild(Se);
    }), fe;
  }, v.prototype.deriveChild = function(L) {
    var H = L >= B, fe = g.allocUnsafe(4);
    fe.writeUInt32BE(L, 0);
    var ge;
    if (H) {
      o(this.privateKey, "Could not derive hardened child key");
      var Ie = this.privateKey, Ee = g.alloc(1, 0);
      Ie = g.concat([Ee, Ie]), ge = g.concat([Ie, fe]);
    } else
      ge = g.concat([this.publicKey, fe]);
    var Se = c.createHmac("sha512", this.chainCode).update(ge).digest(), ze = Se.slice(0, 32), He = Se.slice(32), Pe = new v(this.versions);
    if (this.privateKey)
      try {
        Pe.privateKey = g.from(d.privateKeyTweakAdd(g.from(this.privateKey), ze));
      } catch {
        return this.deriveChild(L + 1);
      }
    else
      try {
        Pe.publicKey = g.from(d.publicKeyTweakAdd(g.from(this.publicKey), ze, !0));
      } catch {
        return this.deriveChild(L + 1);
      }
    return Pe.chainCode = He, Pe.depth = this.depth + 1, Pe.parentFingerprint = this.fingerprint, Pe.index = L, Pe;
  }, v.prototype.sign = function(L) {
    return g.from(d.ecdsaSign(Uint8Array.from(L), Uint8Array.from(this.privateKey)).signature);
  }, v.prototype.verify = function(L, H) {
    return d.ecdsaVerify(
      Uint8Array.from(H),
      Uint8Array.from(L),
      Uint8Array.from(this.publicKey)
    );
  }, v.prototype.wipePrivateData = function() {
    return this._privateKey && c.randomBytes(this._privateKey.length).copy(this._privateKey), this._privateKey = null, this;
  }, v.prototype.toJSON = function() {
    return {
      xpriv: this.privateExtendedKey,
      xpub: this.publicExtendedKey
    };
  }, v.fromMasterSeed = function(L, H) {
    var fe = c.createHmac("sha512", E).update(L).digest(), ge = fe.slice(0, 32), Ie = fe.slice(32), Ee = new v(H);
    return Ee.chainCode = Ie, Ee.privateKey = ge, Ee;
  }, v.fromExtendedKey = function(L, H, fe) {
    H = H || x, fe = fe || !1;
    var ge = new v(H), Ie = y.decode(L), Ee = Ie.readUInt32BE(0);
    o(Ee === H.private || Ee === H.public, "Version mismatch: does not match private or public"), ge.depth = Ie.readUInt8(4), ge.parentFingerprint = Ie.readUInt32BE(5), ge.index = Ie.readUInt32BE(9), ge.chainCode = Ie.slice(13, 45);
    var Se = Ie.slice(45);
    return Se.readUInt8(0) === 0 ? (o(Ee === H.private, "Version mismatch: version does not match private"), ge.privateKey = Se.slice(1)) : (o(Ee === H.public, "Version mismatch: version does not match public"), fe ? F(ge, Se) : ge.publicKey = Se), ge;
  }, v.fromJSON = function(L) {
    return v.fromExtendedKey(L.xpriv);
  };
  function M(L, H, fe) {
    var ge = g.allocUnsafe(D);
    ge.writeUInt32BE(H, 0), ge.writeUInt8(L.depth, 4);
    var Ie = L.depth ? L.parentFingerprint : 0;
    return ge.writeUInt32BE(Ie, 5), ge.writeUInt32BE(L.index, 9), L.chainCode.copy(ge, 13), fe.copy(ge, 45), ge;
  }
  function U(L) {
    var H = c.createHash("sha256").update(L).digest();
    return new t().update(H).digest();
  }
  return v.HARDENED_OFFSET = B, hdkey = v, hdkey;
}
var cjs$5 = {}, constants$4 = {}, secp256k1$5 = {}, secp256k1$4 = {}, sha256$6 = {}, _md = {}, _assert = {}, hasRequired_assert;
function require_assert() {
  if (hasRequired_assert) return _assert;
  hasRequired_assert = 1, Object.defineProperty(_assert, "__esModule", { value: !0 }), _assert.output = _assert.exists = _assert.hash = _assert.bytes = _assert.bool = _assert.number = _assert.isBytes = void 0;
  function o(D) {
    if (!Number.isSafeInteger(D) || D < 0)
      throw new Error(`positive integer expected, not ${D}`);
  }
  _assert.number = o;
  function g(D) {
    if (typeof D != "boolean")
      throw new Error(`boolean expected, not ${D}`);
  }
  _assert.bool = g;
  function c(D) {
    return D instanceof Uint8Array || D != null && typeof D == "object" && D.constructor.name === "Uint8Array";
  }
  _assert.isBytes = c;
  function y(D, ...x) {
    if (!c(D))
      throw new Error("Uint8Array expected");
    if (x.length > 0 && !x.includes(D.length))
      throw new Error(`Uint8Array expected of length ${x}, not of length=${D.length}`);
  }
  _assert.bytes = y;
  function t(D) {
    if (typeof D != "function" || typeof D.create != "function")
      throw new Error("Hash should be wrapped by utils.wrapConstructor");
    o(D.outputLen), o(D.blockLen);
  }
  _assert.hash = t;
  function d(D, x = !0) {
    if (D.destroyed)
      throw new Error("Hash instance has been destroyed");
    if (x && D.finished)
      throw new Error("Hash#digest() has already been called");
  }
  _assert.exists = d;
  function E(D, x) {
    y(D);
    const v = x.outputLen;
    if (D.length < v)
      throw new Error(`digestInto() expects output buffer of length at least ${v}`);
  }
  _assert.output = E;
  const B = { number: o, bool: g, bytes: y, hash: t, exists: d, output: E };
  return _assert.default = B, _assert;
}
var utils$9 = {}, crypto$5 = {}, hasRequiredCrypto$2;
function requireCrypto$2() {
  return hasRequiredCrypto$2 || (hasRequiredCrypto$2 = 1, Object.defineProperty(crypto$5, "__esModule", { value: !0 }), crypto$5.crypto = void 0, crypto$5.crypto = typeof globalThis == "object" && "crypto" in globalThis ? globalThis.crypto : void 0), crypto$5;
}
var hasRequiredUtils$7;
function requireUtils$7() {
  return hasRequiredUtils$7 || (hasRequiredUtils$7 = 1, function(o) {
    Object.defineProperty(o, "__esModule", { value: !0 }), o.randomBytes = o.wrapXOFConstructorWithOpts = o.wrapConstructorWithOpts = o.wrapConstructor = o.checkOpts = o.Hash = o.concatBytes = o.toBytes = o.utf8ToBytes = o.asyncLoop = o.nextTick = o.hexToBytes = o.bytesToHex = o.byteSwap32 = o.byteSwapIfBE = o.byteSwap = o.isLE = o.rotl = o.rotr = o.createView = o.u32 = o.u8 = o.isBytes = void 0;
    const g = /* @__PURE__ */ requireCrypto$2(), c = /* @__PURE__ */ require_assert();
    function y(Be) {
      return Be instanceof Uint8Array || Be != null && typeof Be == "object" && Be.constructor.name === "Uint8Array";
    }
    o.isBytes = y;
    const t = (Be) => new Uint8Array(Be.buffer, Be.byteOffset, Be.byteLength);
    o.u8 = t;
    const d = (Be) => new Uint32Array(Be.buffer, Be.byteOffset, Math.floor(Be.byteLength / 4));
    o.u32 = d;
    const E = (Be) => new DataView(Be.buffer, Be.byteOffset, Be.byteLength);
    o.createView = E;
    const B = (Be, ke) => Be << 32 - ke | Be >>> ke;
    o.rotr = B;
    const D = (Be, ke) => Be << ke | Be >>> 32 - ke >>> 0;
    o.rotl = D, o.isLE = new Uint8Array(new Uint32Array([287454020]).buffer)[0] === 68;
    const x = (Be) => Be << 24 & 4278190080 | Be << 8 & 16711680 | Be >>> 8 & 65280 | Be >>> 24 & 255;
    o.byteSwap = x, o.byteSwapIfBE = o.isLE ? (Be) => Be : (Be) => (0, o.byteSwap)(Be);
    function v(Be) {
      for (let ke = 0; ke < Be.length; ke++)
        Be[ke] = (0, o.byteSwap)(Be[ke]);
    }
    o.byteSwap32 = v;
    const F = /* @__PURE__ */ Array.from({ length: 256 }, (Be, ke) => ke.toString(16).padStart(2, "0"));
    function M(Be) {
      (0, c.bytes)(Be);
      let ke = "";
      for (let xe = 0; xe < Be.length; xe++)
        ke += F[Be[xe]];
      return ke;
    }
    o.bytesToHex = M;
    const U = { _0: 48, _9: 57, _A: 65, _F: 70, _a: 97, _f: 102 };
    function L(Be) {
      if (Be >= U._0 && Be <= U._9)
        return Be - U._0;
      if (Be >= U._A && Be <= U._F)
        return Be - (U._A - 10);
      if (Be >= U._a && Be <= U._f)
        return Be - (U._a - 10);
    }
    function H(Be) {
      if (typeof Be != "string")
        throw new Error("hex string expected, got " + typeof Be);
      const ke = Be.length, xe = ke / 2;
      if (ke % 2)
        throw new Error("padded hex string expected, got unpadded hex of length " + ke);
      const Ne = new Uint8Array(xe);
      for (let Et = 0, st = 0; Et < xe; Et++, st += 2) {
        const Dt = L(Be.charCodeAt(st)), er = L(Be.charCodeAt(st + 1));
        if (Dt === void 0 || er === void 0) {
          const xt = Be[st] + Be[st + 1];
          throw new Error('hex string expected, got non-hex character "' + xt + '" at index ' + st);
        }
        Ne[Et] = Dt * 16 + er;
      }
      return Ne;
    }
    o.hexToBytes = H;
    const fe = async () => {
    };
    o.nextTick = fe;
    async function ge(Be, ke, xe) {
      let Ne = Date.now();
      for (let Et = 0; Et < Be; Et++) {
        xe(Et);
        const st = Date.now() - Ne;
        st >= 0 && st < ke || (await (0, o.nextTick)(), Ne += st);
      }
    }
    o.asyncLoop = ge;
    function Ie(Be) {
      if (typeof Be != "string")
        throw new Error(`utf8ToBytes expected string, got ${typeof Be}`);
      return new Uint8Array(new TextEncoder().encode(Be));
    }
    o.utf8ToBytes = Ie;
    function Ee(Be) {
      return typeof Be == "string" && (Be = Ie(Be)), (0, c.bytes)(Be), Be;
    }
    o.toBytes = Ee;
    function Se(...Be) {
      let ke = 0;
      for (let Ne = 0; Ne < Be.length; Ne++) {
        const Et = Be[Ne];
        (0, c.bytes)(Et), ke += Et.length;
      }
      const xe = new Uint8Array(ke);
      for (let Ne = 0, Et = 0; Ne < Be.length; Ne++) {
        const st = Be[Ne];
        xe.set(st, Et), Et += st.length;
      }
      return xe;
    }
    o.concatBytes = Se;
    class ze {
      // Safe version that clones internal state
      clone() {
        return this._cloneInto();
      }
    }
    o.Hash = ze;
    const He = {}.toString;
    function Pe(Be, ke) {
      if (ke !== void 0 && He.call(ke) !== "[object Object]")
        throw new Error("Options should be object or undefined");
      return Object.assign(Be, ke);
    }
    o.checkOpts = Pe;
    function De(Be) {
      const ke = (Ne) => Be().update(Ee(Ne)).digest(), xe = Be();
      return ke.outputLen = xe.outputLen, ke.blockLen = xe.blockLen, ke.create = () => Be(), ke;
    }
    o.wrapConstructor = De;
    function ve(Be) {
      const ke = (Ne, Et) => Be(Et).update(Ee(Ne)).digest(), xe = Be({});
      return ke.outputLen = xe.outputLen, ke.blockLen = xe.blockLen, ke.create = (Ne) => Be(Ne), ke;
    }
    o.wrapConstructorWithOpts = ve;
    function Fe(Be) {
      const ke = (Ne, Et) => Be(Et).update(Ee(Ne)).digest(), xe = Be({});
      return ke.outputLen = xe.outputLen, ke.blockLen = xe.blockLen, ke.create = (Ne) => Be(Ne), ke;
    }
    o.wrapXOFConstructorWithOpts = Fe;
    function be(Be = 32) {
      if (g.crypto && typeof g.crypto.getRandomValues == "function")
        return g.crypto.getRandomValues(new Uint8Array(Be));
      throw new Error("crypto.getRandomValues must be defined");
    }
    o.randomBytes = be;
  }(utils$9)), utils$9;
}
var hasRequired_md;
function require_md() {
  if (hasRequired_md) return _md;
  hasRequired_md = 1, Object.defineProperty(_md, "__esModule", { value: !0 }), _md.HashMD = _md.Maj = _md.Chi = void 0;
  const o = /* @__PURE__ */ require_assert(), g = /* @__PURE__ */ requireUtils$7();
  function c(E, B, D, x) {
    if (typeof E.setBigUint64 == "function")
      return E.setBigUint64(B, D, x);
    const v = BigInt(32), F = BigInt(4294967295), M = Number(D >> v & F), U = Number(D & F), L = x ? 4 : 0, H = x ? 0 : 4;
    E.setUint32(B + L, M, x), E.setUint32(B + H, U, x);
  }
  const y = (E, B, D) => E & B ^ ~E & D;
  _md.Chi = y;
  const t = (E, B, D) => E & B ^ E & D ^ B & D;
  _md.Maj = t;
  class d extends g.Hash {
    constructor(B, D, x, v) {
      super(), this.blockLen = B, this.outputLen = D, this.padOffset = x, this.isLE = v, this.finished = !1, this.length = 0, this.pos = 0, this.destroyed = !1, this.buffer = new Uint8Array(B), this.view = (0, g.createView)(this.buffer);
    }
    update(B) {
      (0, o.exists)(this);
      const { view: D, buffer: x, blockLen: v } = this;
      B = (0, g.toBytes)(B);
      const F = B.length;
      for (let M = 0; M < F; ) {
        const U = Math.min(v - this.pos, F - M);
        if (U === v) {
          const L = (0, g.createView)(B);
          for (; v <= F - M; M += v)
            this.process(L, M);
          continue;
        }
        x.set(B.subarray(M, M + U), this.pos), this.pos += U, M += U, this.pos === v && (this.process(D, 0), this.pos = 0);
      }
      return this.length += B.length, this.roundClean(), this;
    }
    digestInto(B) {
      (0, o.exists)(this), (0, o.output)(B, this), this.finished = !0;
      const { buffer: D, view: x, blockLen: v, isLE: F } = this;
      let { pos: M } = this;
      D[M++] = 128, this.buffer.subarray(M).fill(0), this.padOffset > v - M && (this.process(x, 0), M = 0);
      for (let ge = M; ge < v; ge++)
        D[ge] = 0;
      c(x, v - 8, BigInt(this.length * 8), F), this.process(x, 0);
      const U = (0, g.createView)(B), L = this.outputLen;
      if (L % 4)
        throw new Error("_sha2: outputLen should be aligned to 32bit");
      const H = L / 4, fe = this.get();
      if (H > fe.length)
        throw new Error("_sha2: outputLen bigger than state");
      for (let ge = 0; ge < H; ge++)
        U.setUint32(4 * ge, fe[ge], F);
    }
    digest() {
      const { buffer: B, outputLen: D } = this;
      this.digestInto(B);
      const x = B.slice(0, D);
      return this.destroy(), x;
    }
    _cloneInto(B) {
      B || (B = new this.constructor()), B.set(...this.get());
      const { blockLen: D, buffer: x, length: v, finished: F, destroyed: M, pos: U } = this;
      return B.length = v, B.pos = U, B.finished = F, B.destroyed = M, v % D && B.buffer.set(x), B;
    }
  }
  return _md.HashMD = d, _md;
}
var hasRequiredSha256$3;
function requireSha256$3() {
  if (hasRequiredSha256$3) return sha256$6;
  hasRequiredSha256$3 = 1, Object.defineProperty(sha256$6, "__esModule", { value: !0 }), sha256$6.sha224 = sha256$6.sha256 = void 0;
  const o = /* @__PURE__ */ require_md(), g = /* @__PURE__ */ requireUtils$7(), c = /* @__PURE__ */ new Uint32Array([
    1116352408,
    1899447441,
    3049323471,
    3921009573,
    961987163,
    1508970993,
    2453635748,
    2870763221,
    3624381080,
    310598401,
    607225278,
    1426881987,
    1925078388,
    2162078206,
    2614888103,
    3248222580,
    3835390401,
    4022224774,
    264347078,
    604807628,
    770255983,
    1249150122,
    1555081692,
    1996064986,
    2554220882,
    2821834349,
    2952996808,
    3210313671,
    3336571891,
    3584528711,
    113926993,
    338241895,
    666307205,
    773529912,
    1294757372,
    1396182291,
    1695183700,
    1986661051,
    2177026350,
    2456956037,
    2730485921,
    2820302411,
    3259730800,
    3345764771,
    3516065817,
    3600352804,
    4094571909,
    275423344,
    430227734,
    506948616,
    659060556,
    883997877,
    958139571,
    1322822218,
    1537002063,
    1747873779,
    1955562222,
    2024104815,
    2227730452,
    2361852424,
    2428436474,
    2756734187,
    3204031479,
    3329325298
  ]), y = /* @__PURE__ */ new Uint32Array([
    1779033703,
    3144134277,
    1013904242,
    2773480762,
    1359893119,
    2600822924,
    528734635,
    1541459225
  ]), t = /* @__PURE__ */ new Uint32Array(64);
  class d extends o.HashMD {
    constructor() {
      super(64, 32, 8, !1), this.A = y[0] | 0, this.B = y[1] | 0, this.C = y[2] | 0, this.D = y[3] | 0, this.E = y[4] | 0, this.F = y[5] | 0, this.G = y[6] | 0, this.H = y[7] | 0;
    }
    get() {
      const { A: D, B: x, C: v, D: F, E: M, F: U, G: L, H } = this;
      return [D, x, v, F, M, U, L, H];
    }
    // prettier-ignore
    set(D, x, v, F, M, U, L, H) {
      this.A = D | 0, this.B = x | 0, this.C = v | 0, this.D = F | 0, this.E = M | 0, this.F = U | 0, this.G = L | 0, this.H = H | 0;
    }
    process(D, x) {
      for (let Ie = 0; Ie < 16; Ie++, x += 4)
        t[Ie] = D.getUint32(x, !1);
      for (let Ie = 16; Ie < 64; Ie++) {
        const Ee = t[Ie - 15], Se = t[Ie - 2], ze = (0, g.rotr)(Ee, 7) ^ (0, g.rotr)(Ee, 18) ^ Ee >>> 3, He = (0, g.rotr)(Se, 17) ^ (0, g.rotr)(Se, 19) ^ Se >>> 10;
        t[Ie] = He + t[Ie - 7] + ze + t[Ie - 16] | 0;
      }
      let { A: v, B: F, C: M, D: U, E: L, F: H, G: fe, H: ge } = this;
      for (let Ie = 0; Ie < 64; Ie++) {
        const Ee = (0, g.rotr)(L, 6) ^ (0, g.rotr)(L, 11) ^ (0, g.rotr)(L, 25), Se = ge + Ee + (0, o.Chi)(L, H, fe) + c[Ie] + t[Ie] | 0, He = ((0, g.rotr)(v, 2) ^ (0, g.rotr)(v, 13) ^ (0, g.rotr)(v, 22)) + (0, o.Maj)(v, F, M) | 0;
        ge = fe, fe = H, H = L, L = U + Se | 0, U = M, M = F, F = v, v = Se + He | 0;
      }
      v = v + this.A | 0, F = F + this.B | 0, M = M + this.C | 0, U = U + this.D | 0, L = L + this.E | 0, H = H + this.F | 0, fe = fe + this.G | 0, ge = ge + this.H | 0, this.set(v, F, M, U, L, H, fe, ge);
    }
    roundClean() {
      t.fill(0);
    }
    destroy() {
      this.set(0, 0, 0, 0, 0, 0, 0, 0), this.buffer.fill(0);
    }
  }
  class E extends d {
    constructor() {
      super(), this.A = -1056596264, this.B = 914150663, this.C = 812702999, this.D = -150054599, this.E = -4191439, this.F = 1750603025, this.G = 1694076839, this.H = -1090891868, this.outputLen = 28;
    }
  }
  return sha256$6.sha256 = (0, g.wrapConstructor)(() => new d()), sha256$6.sha224 = (0, g.wrapConstructor)(() => new E()), sha256$6;
}
var _shortw_utils = {}, hmac$3 = {}, hasRequiredHmac$1;
function requireHmac$1() {
  return hasRequiredHmac$1 || (hasRequiredHmac$1 = 1, function(o) {
    Object.defineProperty(o, "__esModule", { value: !0 }), o.hmac = o.HMAC = void 0;
    const g = /* @__PURE__ */ require_assert(), c = /* @__PURE__ */ requireUtils$7();
    class y extends c.Hash {
      constructor(E, B) {
        super(), this.finished = !1, this.destroyed = !1, (0, g.hash)(E);
        const D = (0, c.toBytes)(B);
        if (this.iHash = E.create(), typeof this.iHash.update != "function")
          throw new Error("Expected instance of class which extends utils.Hash");
        this.blockLen = this.iHash.blockLen, this.outputLen = this.iHash.outputLen;
        const x = this.blockLen, v = new Uint8Array(x);
        v.set(D.length > x ? E.create().update(D).digest() : D);
        for (let F = 0; F < v.length; F++)
          v[F] ^= 54;
        this.iHash.update(v), this.oHash = E.create();
        for (let F = 0; F < v.length; F++)
          v[F] ^= 106;
        this.oHash.update(v), v.fill(0);
      }
      update(E) {
        return (0, g.exists)(this), this.iHash.update(E), this;
      }
      digestInto(E) {
        (0, g.exists)(this), (0, g.bytes)(E, this.outputLen), this.finished = !0, this.iHash.digestInto(E), this.oHash.update(E), this.oHash.digestInto(E), this.destroy();
      }
      digest() {
        const E = new Uint8Array(this.oHash.outputLen);
        return this.digestInto(E), E;
      }
      _cloneInto(E) {
        E || (E = Object.create(Object.getPrototypeOf(this), {}));
        const { oHash: B, iHash: D, finished: x, destroyed: v, blockLen: F, outputLen: M } = this;
        return E = E, E.finished = x, E.destroyed = v, E.blockLen = F, E.outputLen = M, E.oHash = B._cloneInto(E.oHash), E.iHash = D._cloneInto(E.iHash), E;
      }
      destroy() {
        this.destroyed = !0, this.oHash.destroy(), this.iHash.destroy();
      }
    }
    o.HMAC = y;
    const t = (d, E, B) => new y(d, E).update(B).digest();
    o.hmac = t, o.hmac.create = (d, E) => new y(d, E);
  }(hmac$3)), hmac$3;
}
var weierstrass$2 = {}, curve = {}, modular = {}, utils$8 = {}, hasRequiredUtils$6;
function requireUtils$6() {
  if (hasRequiredUtils$6) return utils$8;
  hasRequiredUtils$6 = 1, Object.defineProperty(utils$8, "__esModule", { value: !0 }), utils$8.bitMask = void 0, utils$8.isBytes = y, utils$8.abytes = t, utils$8.bytesToHex = E, utils$8.numberToHexUnpadded = B, utils$8.hexToNumber = D, utils$8.hexToBytes = F, utils$8.bytesToNumberBE = M, utils$8.bytesToNumberLE = U, utils$8.numberToBytesBE = L, utils$8.numberToBytesLE = H, utils$8.numberToVarBytesBE = fe, utils$8.ensureBytes = ge, utils$8.concatBytes = Ie, utils$8.equalBytes = Ee, utils$8.utf8ToBytes = Se, utils$8.bitLen = ze, utils$8.bitGet = He, utils$8.bitSet = Pe, utils$8.createHmacDrbg = be, utils$8.validateObject = ke;
  const o = /* @__PURE__ */ BigInt(0), g = /* @__PURE__ */ BigInt(1), c = /* @__PURE__ */ BigInt(2);
  function y(xe) {
    return xe instanceof Uint8Array || xe != null && typeof xe == "object" && xe.constructor.name === "Uint8Array";
  }
  function t(xe) {
    if (!y(xe))
      throw new Error("Uint8Array expected");
  }
  const d = /* @__PURE__ */ Array.from({ length: 256 }, (xe, Ne) => Ne.toString(16).padStart(2, "0"));
  function E(xe) {
    t(xe);
    let Ne = "";
    for (let Et = 0; Et < xe.length; Et++)
      Ne += d[xe[Et]];
    return Ne;
  }
  function B(xe) {
    const Ne = xe.toString(16);
    return Ne.length & 1 ? `0${Ne}` : Ne;
  }
  function D(xe) {
    if (typeof xe != "string")
      throw new Error("hex string expected, got " + typeof xe);
    return BigInt(xe === "" ? "0" : `0x${xe}`);
  }
  const x = { _0: 48, _9: 57, _A: 65, _F: 70, _a: 97, _f: 102 };
  function v(xe) {
    if (xe >= x._0 && xe <= x._9)
      return xe - x._0;
    if (xe >= x._A && xe <= x._F)
      return xe - (x._A - 10);
    if (xe >= x._a && xe <= x._f)
      return xe - (x._a - 10);
  }
  function F(xe) {
    if (typeof xe != "string")
      throw new Error("hex string expected, got " + typeof xe);
    const Ne = xe.length, Et = Ne / 2;
    if (Ne % 2)
      throw new Error("padded hex string expected, got unpadded hex of length " + Ne);
    const st = new Uint8Array(Et);
    for (let Dt = 0, er = 0; Dt < Et; Dt++, er += 2) {
      const xt = v(xe.charCodeAt(er)), ir = v(xe.charCodeAt(er + 1));
      if (xt === void 0 || ir === void 0) {
        const sr = xe[er] + xe[er + 1];
        throw new Error('hex string expected, got non-hex character "' + sr + '" at index ' + er);
      }
      st[Dt] = xt * 16 + ir;
    }
    return st;
  }
  function M(xe) {
    return D(E(xe));
  }
  function U(xe) {
    return t(xe), D(E(Uint8Array.from(xe).reverse()));
  }
  function L(xe, Ne) {
    return F(xe.toString(16).padStart(Ne * 2, "0"));
  }
  function H(xe, Ne) {
    return L(xe, Ne).reverse();
  }
  function fe(xe) {
    return F(B(xe));
  }
  function ge(xe, Ne, Et) {
    let st;
    if (typeof Ne == "string")
      try {
        st = F(Ne);
      } catch (er) {
        throw new Error(`${xe} must be valid hex string, got "${Ne}". Cause: ${er}`);
      }
    else if (y(Ne))
      st = Uint8Array.from(Ne);
    else
      throw new Error(`${xe} must be hex string or Uint8Array`);
    const Dt = st.length;
    if (typeof Et == "number" && Dt !== Et)
      throw new Error(`${xe} expected ${Et} bytes, got ${Dt}`);
    return st;
  }
  function Ie(...xe) {
    let Ne = 0;
    for (let st = 0; st < xe.length; st++) {
      const Dt = xe[st];
      t(Dt), Ne += Dt.length;
    }
    const Et = new Uint8Array(Ne);
    for (let st = 0, Dt = 0; st < xe.length; st++) {
      const er = xe[st];
      Et.set(er, Dt), Dt += er.length;
    }
    return Et;
  }
  function Ee(xe, Ne) {
    if (xe.length !== Ne.length)
      return !1;
    let Et = 0;
    for (let st = 0; st < xe.length; st++)
      Et |= xe[st] ^ Ne[st];
    return Et === 0;
  }
  function Se(xe) {
    if (typeof xe != "string")
      throw new Error(`utf8ToBytes expected string, got ${typeof xe}`);
    return new Uint8Array(new TextEncoder().encode(xe));
  }
  function ze(xe) {
    let Ne;
    for (Ne = 0; xe > o; xe >>= g, Ne += 1)
      ;
    return Ne;
  }
  function He(xe, Ne) {
    return xe >> BigInt(Ne) & g;
  }
  function Pe(xe, Ne, Et) {
    return xe | (Et ? g : o) << BigInt(Ne);
  }
  const De = (xe) => (c << BigInt(xe - 1)) - g;
  utils$8.bitMask = De;
  const ve = (xe) => new Uint8Array(xe), Fe = (xe) => Uint8Array.from(xe);
  function be(xe, Ne, Et) {
    if (typeof xe != "number" || xe < 2)
      throw new Error("hashLen must be a number");
    if (typeof Ne != "number" || Ne < 2)
      throw new Error("qByteLen must be a number");
    if (typeof Et != "function")
      throw new Error("hmacFn must be a function");
    let st = ve(xe), Dt = ve(xe), er = 0;
    const xt = () => {
      st.fill(1), Dt.fill(0), er = 0;
    }, ir = (...qr) => Et(Dt, st, ...qr), sr = (qr = ve()) => {
      Dt = ir(Fe([0]), qr), st = ir(), qr.length !== 0 && (Dt = ir(Fe([1]), qr), st = ir());
    }, yr = () => {
      if (er++ >= 1e3)
        throw new Error("drbg: tried 1000 values");
      let qr = 0;
      const Mr = [];
      for (; qr < Ne; ) {
        st = ir();
        const Dr = st.slice();
        Mr.push(Dr), qr += st.length;
      }
      return Ie(...Mr);
    };
    return (qr, Mr) => {
      xt(), sr(qr);
      let Dr;
      for (; !(Dr = Mr(yr())); )
        sr();
      return xt(), Dr;
    };
  }
  const Be = {
    bigint: (xe) => typeof xe == "bigint",
    function: (xe) => typeof xe == "function",
    boolean: (xe) => typeof xe == "boolean",
    string: (xe) => typeof xe == "string",
    stringOrUint8Array: (xe) => typeof xe == "string" || y(xe),
    isSafeInteger: (xe) => Number.isSafeInteger(xe),
    array: (xe) => Array.isArray(xe),
    field: (xe, Ne) => Ne.Fp.isValid(xe),
    hash: (xe) => typeof xe == "function" && Number.isSafeInteger(xe.outputLen)
  };
  function ke(xe, Ne, Et = {}) {
    const st = (Dt, er, xt) => {
      const ir = Be[er];
      if (typeof ir != "function")
        throw new Error(`Invalid validator "${er}", expected function`);
      const sr = xe[Dt];
      if (!(xt && sr === void 0) && !ir(sr, xe))
        throw new Error(`Invalid param ${String(Dt)}=${sr} (${typeof sr}), expected ${er}`);
    };
    for (const [Dt, er] of Object.entries(Ne))
      st(Dt, er, !1);
    for (const [Dt, er] of Object.entries(Et))
      st(Dt, er, !0);
    return xe;
  }
  return utils$8;
}
var hasRequiredModular;
function requireModular() {
  if (hasRequiredModular) return modular;
  hasRequiredModular = 1, Object.defineProperty(modular, "__esModule", { value: !0 }), modular.isNegativeLE = void 0, modular.mod = D, modular.pow = x, modular.pow2 = v, modular.invert = F, modular.tonelliShanks = M, modular.FpSqrt = U, modular.validateField = fe, modular.FpPow = ge, modular.FpInvertBatch = Ie, modular.FpDiv = Ee, modular.FpIsSquare = Se, modular.nLength = ze, modular.Field = He, modular.FpSqrtOdd = Pe, modular.FpSqrtEven = De, modular.hashToPrivateScalar = ve, modular.getFieldBytesLength = Fe, modular.getMinHashLength = be, modular.mapHashToField = Be;
  const o = /* @__PURE__ */ requireUtils$6(), g = BigInt(0), c = BigInt(1), y = BigInt(2), t = BigInt(3), d = BigInt(4), E = BigInt(5), B = BigInt(8);
  BigInt(9), BigInt(16);
  function D(ke, xe) {
    const Ne = ke % xe;
    return Ne >= g ? Ne : xe + Ne;
  }
  function x(ke, xe, Ne) {
    if (Ne <= g || xe < g)
      throw new Error("Expected power/modulo > 0");
    if (Ne === c)
      return g;
    let Et = c;
    for (; xe > g; )
      xe & c && (Et = Et * ke % Ne), ke = ke * ke % Ne, xe >>= c;
    return Et;
  }
  function v(ke, xe, Ne) {
    let Et = ke;
    for (; xe-- > g; )
      Et *= Et, Et %= Ne;
    return Et;
  }
  function F(ke, xe) {
    if (ke === g || xe <= g)
      throw new Error(`invert: expected positive integers, got n=${ke} mod=${xe}`);
    let Ne = D(ke, xe), Et = xe, st = g, Dt = c;
    for (; Ne !== g; ) {
      const xt = Et / Ne, ir = Et % Ne, sr = st - Dt * xt;
      Et = Ne, Ne = ir, st = Dt, Dt = sr;
    }
    if (Et !== c)
      throw new Error("invert: does not exist");
    return D(st, xe);
  }
  function M(ke) {
    const xe = (ke - c) / y;
    let Ne, Et, st;
    for (Ne = ke - c, Et = 0; Ne % y === g; Ne /= y, Et++)
      ;
    for (st = y; st < ke && x(st, xe, ke) !== ke - c; st++)
      ;
    if (Et === 1) {
      const er = (ke + c) / d;
      return function(ir, sr) {
        const yr = ir.pow(sr, er);
        if (!ir.eql(ir.sqr(yr), sr))
          throw new Error("Cannot find square root");
        return yr;
      };
    }
    const Dt = (Ne + c) / y;
    return function(xt, ir) {
      if (xt.pow(ir, xe) === xt.neg(xt.ONE))
        throw new Error("Cannot find square root");
      let sr = Et, yr = xt.pow(xt.mul(xt.ONE, st), Ne), wr = xt.pow(ir, Dt), qr = xt.pow(ir, Ne);
      for (; !xt.eql(qr, xt.ONE); ) {
        if (xt.eql(qr, xt.ZERO))
          return xt.ZERO;
        let Mr = 1;
        for (let Qr = xt.sqr(qr); Mr < sr && !xt.eql(Qr, xt.ONE); Mr++)
          Qr = xt.sqr(Qr);
        const Dr = xt.pow(yr, c << BigInt(sr - Mr - 1));
        yr = xt.sqr(Dr), wr = xt.mul(wr, Dr), qr = xt.mul(qr, yr), sr = Mr;
      }
      return wr;
    };
  }
  function U(ke) {
    if (ke % d === t) {
      const xe = (ke + c) / d;
      return function(Et, st) {
        const Dt = Et.pow(st, xe);
        if (!Et.eql(Et.sqr(Dt), st))
          throw new Error("Cannot find square root");
        return Dt;
      };
    }
    if (ke % B === E) {
      const xe = (ke - E) / B;
      return function(Et, st) {
        const Dt = Et.mul(st, y), er = Et.pow(Dt, xe), xt = Et.mul(st, er), ir = Et.mul(Et.mul(xt, y), er), sr = Et.mul(xt, Et.sub(ir, Et.ONE));
        if (!Et.eql(Et.sqr(sr), st))
          throw new Error("Cannot find square root");
        return sr;
      };
    }
    return M(ke);
  }
  const L = (ke, xe) => (D(ke, xe) & c) === c;
  modular.isNegativeLE = L;
  const H = [
    "create",
    "isValid",
    "is0",
    "neg",
    "inv",
    "sqrt",
    "sqr",
    "eql",
    "add",
    "sub",
    "mul",
    "pow",
    "div",
    "addN",
    "subN",
    "mulN",
    "sqrN"
  ];
  function fe(ke) {
    const xe = {
      ORDER: "bigint",
      MASK: "bigint",
      BYTES: "isSafeInteger",
      BITS: "isSafeInteger"
    }, Ne = H.reduce((Et, st) => (Et[st] = "function", Et), xe);
    return (0, o.validateObject)(ke, Ne);
  }
  function ge(ke, xe, Ne) {
    if (Ne < g)
      throw new Error("Expected power > 0");
    if (Ne === g)
      return ke.ONE;
    if (Ne === c)
      return xe;
    let Et = ke.ONE, st = xe;
    for (; Ne > g; )
      Ne & c && (Et = ke.mul(Et, st)), st = ke.sqr(st), Ne >>= c;
    return Et;
  }
  function Ie(ke, xe) {
    const Ne = new Array(xe.length), Et = xe.reduce((Dt, er, xt) => ke.is0(er) ? Dt : (Ne[xt] = Dt, ke.mul(Dt, er)), ke.ONE), st = ke.inv(Et);
    return xe.reduceRight((Dt, er, xt) => ke.is0(er) ? Dt : (Ne[xt] = ke.mul(Dt, Ne[xt]), ke.mul(Dt, er)), st), Ne;
  }
  function Ee(ke, xe, Ne) {
    return ke.mul(xe, typeof Ne == "bigint" ? F(Ne, ke.ORDER) : ke.inv(Ne));
  }
  function Se(ke) {
    const xe = (ke.ORDER - c) / y;
    return (Ne) => {
      const Et = ke.pow(Ne, xe);
      return ke.eql(Et, ke.ZERO) || ke.eql(Et, ke.ONE);
    };
  }
  function ze(ke, xe) {
    const Ne = xe !== void 0 ? xe : ke.toString(2).length, Et = Math.ceil(Ne / 8);
    return { nBitLength: Ne, nByteLength: Et };
  }
  function He(ke, xe, Ne = !1, Et = {}) {
    if (ke <= g)
      throw new Error(`Expected Field ORDER > 0, got ${ke}`);
    const { nBitLength: st, nByteLength: Dt } = ze(ke, xe);
    if (Dt > 2048)
      throw new Error("Field lengths over 2048 bytes are not supported");
    const er = U(ke), xt = Object.freeze({
      ORDER: ke,
      BITS: st,
      BYTES: Dt,
      MASK: (0, o.bitMask)(st),
      ZERO: g,
      ONE: c,
      create: (ir) => D(ir, ke),
      isValid: (ir) => {
        if (typeof ir != "bigint")
          throw new Error(`Invalid field element: expected bigint, got ${typeof ir}`);
        return g <= ir && ir < ke;
      },
      is0: (ir) => ir === g,
      isOdd: (ir) => (ir & c) === c,
      neg: (ir) => D(-ir, ke),
      eql: (ir, sr) => ir === sr,
      sqr: (ir) => D(ir * ir, ke),
      add: (ir, sr) => D(ir + sr, ke),
      sub: (ir, sr) => D(ir - sr, ke),
      mul: (ir, sr) => D(ir * sr, ke),
      pow: (ir, sr) => ge(xt, ir, sr),
      div: (ir, sr) => D(ir * F(sr, ke), ke),
      // Same as above, but doesn't normalize
      sqrN: (ir) => ir * ir,
      addN: (ir, sr) => ir + sr,
      subN: (ir, sr) => ir - sr,
      mulN: (ir, sr) => ir * sr,
      inv: (ir) => F(ir, ke),
      sqrt: Et.sqrt || ((ir) => er(xt, ir)),
      invertBatch: (ir) => Ie(xt, ir),
      // TODO: do we really need constant cmov?
      // We don't have const-time bigints anyway, so probably will be not very useful
      cmov: (ir, sr, yr) => yr ? sr : ir,
      toBytes: (ir) => Ne ? (0, o.numberToBytesLE)(ir, Dt) : (0, o.numberToBytesBE)(ir, Dt),
      fromBytes: (ir) => {
        if (ir.length !== Dt)
          throw new Error(`Fp.fromBytes: expected ${Dt}, got ${ir.length}`);
        return Ne ? (0, o.bytesToNumberLE)(ir) : (0, o.bytesToNumberBE)(ir);
      }
    });
    return Object.freeze(xt);
  }
  function Pe(ke, xe) {
    if (!ke.isOdd)
      throw new Error("Field doesn't have isOdd");
    const Ne = ke.sqrt(xe);
    return ke.isOdd(Ne) ? Ne : ke.neg(Ne);
  }
  function De(ke, xe) {
    if (!ke.isOdd)
      throw new Error("Field doesn't have isOdd");
    const Ne = ke.sqrt(xe);
    return ke.isOdd(Ne) ? ke.neg(Ne) : Ne;
  }
  function ve(ke, xe, Ne = !1) {
    ke = (0, o.ensureBytes)("privateHash", ke);
    const Et = ke.length, st = ze(xe).nByteLength + 8;
    if (st < 24 || Et < st || Et > 1024)
      throw new Error(`hashToPrivateScalar: expected ${st}-1024 bytes of input, got ${Et}`);
    const Dt = Ne ? (0, o.bytesToNumberLE)(ke) : (0, o.bytesToNumberBE)(ke);
    return D(Dt, xe - c) + c;
  }
  function Fe(ke) {
    if (typeof ke != "bigint")
      throw new Error("field order must be bigint");
    const xe = ke.toString(2).length;
    return Math.ceil(xe / 8);
  }
  function be(ke) {
    const xe = Fe(ke);
    return xe + Math.ceil(xe / 2);
  }
  function Be(ke, xe, Ne = !1) {
    const Et = ke.length, st = Fe(xe), Dt = be(xe);
    if (Et < 16 || Et < Dt || Et > 1024)
      throw new Error(`expected ${Dt}-1024 bytes of input, got ${Et}`);
    const er = Ne ? (0, o.bytesToNumberBE)(ke) : (0, o.bytesToNumberLE)(ke), xt = D(er, xe - c) + c;
    return Ne ? (0, o.numberToBytesLE)(xt, st) : (0, o.numberToBytesBE)(xt, st);
  }
  return modular;
}
var hasRequiredCurve;
function requireCurve() {
  if (hasRequiredCurve) return curve;
  hasRequiredCurve = 1, Object.defineProperty(curve, "__esModule", { value: !0 }), curve.wNAF = t, curve.validateBasic = d;
  const o = /* @__PURE__ */ requireModular(), g = /* @__PURE__ */ requireUtils$6(), c = BigInt(0), y = BigInt(1);
  function t(E, B) {
    const D = (v, F) => {
      const M = F.negate();
      return v ? M : F;
    }, x = (v) => {
      const F = Math.ceil(B / v) + 1, M = 2 ** (v - 1);
      return { windows: F, windowSize: M };
    };
    return {
      constTimeNegate: D,
      // non-const time multiplication ladder
      unsafeLadder(v, F) {
        let M = E.ZERO, U = v;
        for (; F > c; )
          F & y && (M = M.add(U)), U = U.double(), F >>= y;
        return M;
      },
      /**
       * Creates a wNAF precomputation window. Used for caching.
       * Default window size is set by `utils.precompute()` and is equal to 8.
       * Number of precomputed points depends on the curve size:
       * 2^(𝑊−1) * (Math.ceil(𝑛 / 𝑊) + 1), where:
       * - 𝑊 is the window size
       * - 𝑛 is the bitlength of the curve order.
       * For a 256-bit curve and window size 8, the number of precomputed points is 128 * 33 = 4224.
       * @returns precomputed point tables flattened to a single array
       */
      precomputeWindow(v, F) {
        const { windows: M, windowSize: U } = x(F), L = [];
        let H = v, fe = H;
        for (let ge = 0; ge < M; ge++) {
          fe = H, L.push(fe);
          for (let Ie = 1; Ie < U; Ie++)
            fe = fe.add(H), L.push(fe);
          H = fe.double();
        }
        return L;
      },
      /**
       * Implements ec multiplication using precomputed tables and w-ary non-adjacent form.
       * @param W window size
       * @param precomputes precomputed tables
       * @param n scalar (we don't check here, but should be less than curve order)
       * @returns real and fake (for const-time) points
       */
      wNAF(v, F, M) {
        const { windows: U, windowSize: L } = x(v);
        let H = E.ZERO, fe = E.BASE;
        const ge = BigInt(2 ** v - 1), Ie = 2 ** v, Ee = BigInt(v);
        for (let Se = 0; Se < U; Se++) {
          const ze = Se * L;
          let He = Number(M & ge);
          M >>= Ee, He > L && (He -= Ie, M += y);
          const Pe = ze, De = ze + Math.abs(He) - 1, ve = Se % 2 !== 0, Fe = He < 0;
          He === 0 ? fe = fe.add(D(ve, F[Pe])) : H = H.add(D(Fe, F[De]));
        }
        return { p: H, f: fe };
      },
      wNAFCached(v, F, M, U) {
        const L = v._WINDOW_SIZE || 1;
        let H = F.get(v);
        return H || (H = this.precomputeWindow(v, L), L !== 1 && F.set(v, U(H))), this.wNAF(L, H, M);
      }
    };
  }
  function d(E) {
    return (0, o.validateField)(E.Fp), (0, g.validateObject)(E, {
      n: "bigint",
      h: "bigint",
      Gx: "field",
      Gy: "field"
    }, {
      nBitLength: "isSafeInteger",
      nByteLength: "isSafeInteger"
    }), Object.freeze({
      ...(0, o.nLength)(E.n, E.nBitLength),
      ...E,
      p: E.Fp.ORDER
    });
  }
  return curve;
}
var hasRequiredWeierstrass;
function requireWeierstrass() {
  return hasRequiredWeierstrass || (hasRequiredWeierstrass = 1, function(o) {
    Object.defineProperty(o, "__esModule", { value: !0 }), o.DER = void 0, o.weierstrassPoints = U, o.weierstrass = H, o.SWUFpSqrtRatio = fe, o.mapToCurveSimpleSWU = ge;
    const g = /* @__PURE__ */ requireCurve(), c = /* @__PURE__ */ requireModular(), y = /* @__PURE__ */ requireUtils$6(), t = /* @__PURE__ */ requireUtils$6();
    function d(Ie) {
      const Ee = (0, g.validateBasic)(Ie);
      y.validateObject(Ee, {
        a: "field",
        b: "field"
      }, {
        allowedPrivateKeyLengths: "array",
        wrapPrivateKey: "boolean",
        isTorsionFree: "function",
        clearCofactor: "function",
        allowInfinityPoint: "boolean",
        fromBytes: "function",
        toBytes: "function"
      });
      const { endo: Se, Fp: ze, a: He } = Ee;
      if (Se) {
        if (!ze.eql(He, ze.ZERO))
          throw new Error("Endomorphism can only be defined for Koblitz curves that have a=0");
        if (typeof Se != "object" || typeof Se.beta != "bigint" || typeof Se.splitScalar != "function")
          throw new Error("Expected endomorphism with beta: bigint and splitScalar: function");
      }
      return Object.freeze({ ...Ee });
    }
    const { bytesToNumberBE: E, hexToBytes: B } = y;
    o.DER = {
      // asn.1 DER encoding utils
      Err: class extends Error {
        constructor(Ee = "") {
          super(Ee);
        }
      },
      _parseInt(Ie) {
        const { Err: Ee } = o.DER;
        if (Ie.length < 2 || Ie[0] !== 2)
          throw new Ee("Invalid signature integer tag");
        const Se = Ie[1], ze = Ie.subarray(2, Se + 2);
        if (!Se || ze.length !== Se)
          throw new Ee("Invalid signature integer: wrong length");
        if (ze[0] & 128)
          throw new Ee("Invalid signature integer: negative");
        if (ze[0] === 0 && !(ze[1] & 128))
          throw new Ee("Invalid signature integer: unnecessary leading zero");
        return { d: E(ze), l: Ie.subarray(Se + 2) };
      },
      toSig(Ie) {
        const { Err: Ee } = o.DER, Se = typeof Ie == "string" ? B(Ie) : Ie;
        y.abytes(Se);
        let ze = Se.length;
        if (ze < 2 || Se[0] != 48)
          throw new Ee("Invalid signature tag");
        if (Se[1] !== ze - 2)
          throw new Ee("Invalid signature: incorrect length");
        const { d: He, l: Pe } = o.DER._parseInt(Se.subarray(2)), { d: De, l: ve } = o.DER._parseInt(Pe);
        if (ve.length)
          throw new Ee("Invalid signature: left bytes after parsing");
        return { r: He, s: De };
      },
      hexFromSig(Ie) {
        const Ee = (be) => Number.parseInt(be[0], 16) & 8 ? "00" + be : be, Se = (be) => {
          const Be = be.toString(16);
          return Be.length & 1 ? `0${Be}` : Be;
        }, ze = Ee(Se(Ie.s)), He = Ee(Se(Ie.r)), Pe = ze.length / 2, De = He.length / 2, ve = Se(Pe), Fe = Se(De);
        return `30${Se(De + Pe + 4)}02${Fe}${He}02${ve}${ze}`;
      }
    };
    const D = BigInt(0), x = BigInt(1), v = BigInt(2), F = BigInt(3), M = BigInt(4);
    function U(Ie) {
      const Ee = d(Ie), { Fp: Se } = Ee, ze = Ee.toBytes || ((Et, st, Dt) => {
        const er = st.toAffine();
        return y.concatBytes(Uint8Array.from([4]), Se.toBytes(er.x), Se.toBytes(er.y));
      }), He = Ee.fromBytes || ((Et) => {
        const st = Et.subarray(1), Dt = Se.fromBytes(st.subarray(0, Se.BYTES)), er = Se.fromBytes(st.subarray(Se.BYTES, 2 * Se.BYTES));
        return { x: Dt, y: er };
      });
      function Pe(Et) {
        const { a: st, b: Dt } = Ee, er = Se.sqr(Et), xt = Se.mul(er, Et);
        return Se.add(Se.add(xt, Se.mul(Et, st)), Dt);
      }
      if (!Se.eql(Se.sqr(Ee.Gy), Pe(Ee.Gx)))
        throw new Error("bad generator point: equation left != right");
      function De(Et) {
        return typeof Et == "bigint" && D < Et && Et < Ee.n;
      }
      function ve(Et) {
        if (!De(Et))
          throw new Error("Expected valid bigint: 0 < bigint < curve.n");
      }
      function Fe(Et) {
        const { allowedPrivateKeyLengths: st, nByteLength: Dt, wrapPrivateKey: er, n: xt } = Ee;
        if (st && typeof Et != "bigint") {
          if (y.isBytes(Et) && (Et = y.bytesToHex(Et)), typeof Et != "string" || !st.includes(Et.length))
            throw new Error("Invalid key");
          Et = Et.padStart(Dt * 2, "0");
        }
        let ir;
        try {
          ir = typeof Et == "bigint" ? Et : y.bytesToNumberBE((0, t.ensureBytes)("private key", Et, Dt));
        } catch {
          throw new Error(`private key must be ${Dt} bytes, hex or bigint, not ${typeof Et}`);
        }
        return er && (ir = c.mod(ir, xt)), ve(ir), ir;
      }
      const be = /* @__PURE__ */ new Map();
      function Be(Et) {
        if (!(Et instanceof ke))
          throw new Error("ProjectivePoint expected");
      }
      class ke {
        constructor(st, Dt, er) {
          if (this.px = st, this.py = Dt, this.pz = er, st == null || !Se.isValid(st))
            throw new Error("x required");
          if (Dt == null || !Se.isValid(Dt))
            throw new Error("y required");
          if (er == null || !Se.isValid(er))
            throw new Error("z required");
        }
        // Does not validate if the point is on-curve.
        // Use fromHex instead, or call assertValidity() later.
        static fromAffine(st) {
          const { x: Dt, y: er } = st || {};
          if (!st || !Se.isValid(Dt) || !Se.isValid(er))
            throw new Error("invalid affine point");
          if (st instanceof ke)
            throw new Error("projective point not allowed");
          const xt = (ir) => Se.eql(ir, Se.ZERO);
          return xt(Dt) && xt(er) ? ke.ZERO : new ke(Dt, er, Se.ONE);
        }
        get x() {
          return this.toAffine().x;
        }
        get y() {
          return this.toAffine().y;
        }
        /**
         * Takes a bunch of Projective Points but executes only one
         * inversion on all of them. Inversion is very slow operation,
         * so this improves performance massively.
         * Optimization: converts a list of projective points to a list of identical points with Z=1.
         */
        static normalizeZ(st) {
          const Dt = Se.invertBatch(st.map((er) => er.pz));
          return st.map((er, xt) => er.toAffine(Dt[xt])).map(ke.fromAffine);
        }
        /**
         * Converts hash string or Uint8Array to Point.
         * @param hex short/long ECDSA hex
         */
        static fromHex(st) {
          const Dt = ke.fromAffine(He((0, t.ensureBytes)("pointHex", st)));
          return Dt.assertValidity(), Dt;
        }
        // Multiplies generator point by privateKey.
        static fromPrivateKey(st) {
          return ke.BASE.multiply(Fe(st));
        }
        // "Private method", don't use it directly
        _setWindowSize(st) {
          this._WINDOW_SIZE = st, be.delete(this);
        }
        // A point on curve is valid if it conforms to equation.
        assertValidity() {
          if (this.is0()) {
            if (Ee.allowInfinityPoint && !Se.is0(this.py))
              return;
            throw new Error("bad point: ZERO");
          }
          const { x: st, y: Dt } = this.toAffine();
          if (!Se.isValid(st) || !Se.isValid(Dt))
            throw new Error("bad point: x or y not FE");
          const er = Se.sqr(Dt), xt = Pe(st);
          if (!Se.eql(er, xt))
            throw new Error("bad point: equation left != right");
          if (!this.isTorsionFree())
            throw new Error("bad point: not in prime-order subgroup");
        }
        hasEvenY() {
          const { y: st } = this.toAffine();
          if (Se.isOdd)
            return !Se.isOdd(st);
          throw new Error("Field doesn't support isOdd");
        }
        /**
         * Compare one point to another.
         */
        equals(st) {
          Be(st);
          const { px: Dt, py: er, pz: xt } = this, { px: ir, py: sr, pz: yr } = st, wr = Se.eql(Se.mul(Dt, yr), Se.mul(ir, xt)), qr = Se.eql(Se.mul(er, yr), Se.mul(sr, xt));
          return wr && qr;
        }
        /**
         * Flips point to one corresponding to (x, -y) in Affine coordinates.
         */
        negate() {
          return new ke(this.px, Se.neg(this.py), this.pz);
        }
        // Renes-Costello-Batina exception-free doubling formula.
        // There is 30% faster Jacobian formula, but it is not complete.
        // https://eprint.iacr.org/2015/1060, algorithm 3
        // Cost: 8M + 3S + 3*a + 2*b3 + 15add.
        double() {
          const { a: st, b: Dt } = Ee, er = Se.mul(Dt, F), { px: xt, py: ir, pz: sr } = this;
          let yr = Se.ZERO, wr = Se.ZERO, qr = Se.ZERO, Mr = Se.mul(xt, xt), Dr = Se.mul(ir, ir), Qr = Se.mul(sr, sr), Xr = Se.mul(xt, ir);
          return Xr = Se.add(Xr, Xr), qr = Se.mul(xt, sr), qr = Se.add(qr, qr), yr = Se.mul(st, qr), wr = Se.mul(er, Qr), wr = Se.add(yr, wr), yr = Se.sub(Dr, wr), wr = Se.add(Dr, wr), wr = Se.mul(yr, wr), yr = Se.mul(Xr, yr), qr = Se.mul(er, qr), Qr = Se.mul(st, Qr), Xr = Se.sub(Mr, Qr), Xr = Se.mul(st, Xr), Xr = Se.add(Xr, qr), qr = Se.add(Mr, Mr), Mr = Se.add(qr, Mr), Mr = Se.add(Mr, Qr), Mr = Se.mul(Mr, Xr), wr = Se.add(wr, Mr), Qr = Se.mul(ir, sr), Qr = Se.add(Qr, Qr), Mr = Se.mul(Qr, Xr), yr = Se.sub(yr, Mr), qr = Se.mul(Qr, Dr), qr = Se.add(qr, qr), qr = Se.add(qr, qr), new ke(yr, wr, qr);
        }
        // Renes-Costello-Batina exception-free addition formula.
        // There is 30% faster Jacobian formula, but it is not complete.
        // https://eprint.iacr.org/2015/1060, algorithm 1
        // Cost: 12M + 0S + 3*a + 3*b3 + 23add.
        add(st) {
          Be(st);
          const { px: Dt, py: er, pz: xt } = this, { px: ir, py: sr, pz: yr } = st;
          let wr = Se.ZERO, qr = Se.ZERO, Mr = Se.ZERO;
          const Dr = Ee.a, Qr = Se.mul(Ee.b, F);
          let Xr = Se.mul(Dt, ir), Vr = Se.mul(er, sr), Ur = Se.mul(xt, yr), Sr = Se.add(Dt, er), Gr = Se.add(ir, sr);
          Sr = Se.mul(Sr, Gr), Gr = Se.add(Xr, Vr), Sr = Se.sub(Sr, Gr), Gr = Se.add(Dt, xt);
          let Fr = Se.add(ir, yr);
          return Gr = Se.mul(Gr, Fr), Fr = Se.add(Xr, Ur), Gr = Se.sub(Gr, Fr), Fr = Se.add(er, xt), wr = Se.add(sr, yr), Fr = Se.mul(Fr, wr), wr = Se.add(Vr, Ur), Fr = Se.sub(Fr, wr), Mr = Se.mul(Dr, Gr), wr = Se.mul(Qr, Ur), Mr = Se.add(wr, Mr), wr = Se.sub(Vr, Mr), Mr = Se.add(Vr, Mr), qr = Se.mul(wr, Mr), Vr = Se.add(Xr, Xr), Vr = Se.add(Vr, Xr), Ur = Se.mul(Dr, Ur), Gr = Se.mul(Qr, Gr), Vr = Se.add(Vr, Ur), Ur = Se.sub(Xr, Ur), Ur = Se.mul(Dr, Ur), Gr = Se.add(Gr, Ur), Xr = Se.mul(Vr, Gr), qr = Se.add(qr, Xr), Xr = Se.mul(Fr, Gr), wr = Se.mul(Sr, wr), wr = Se.sub(wr, Xr), Xr = Se.mul(Sr, Vr), Mr = Se.mul(Fr, Mr), Mr = Se.add(Mr, Xr), new ke(wr, qr, Mr);
        }
        subtract(st) {
          return this.add(st.negate());
        }
        is0() {
          return this.equals(ke.ZERO);
        }
        wNAF(st) {
          return Ne.wNAFCached(this, be, st, (Dt) => {
            const er = Se.invertBatch(Dt.map((xt) => xt.pz));
            return Dt.map((xt, ir) => xt.toAffine(er[ir])).map(ke.fromAffine);
          });
        }
        /**
         * Non-constant-time multiplication. Uses double-and-add algorithm.
         * It's faster, but should only be used when you don't care about
         * an exposed private key e.g. sig verification, which works over *public* keys.
         */
        multiplyUnsafe(st) {
          const Dt = ke.ZERO;
          if (st === D)
            return Dt;
          if (ve(st), st === x)
            return this;
          const { endo: er } = Ee;
          if (!er)
            return Ne.unsafeLadder(this, st);
          let { k1neg: xt, k1: ir, k2neg: sr, k2: yr } = er.splitScalar(st), wr = Dt, qr = Dt, Mr = this;
          for (; ir > D || yr > D; )
            ir & x && (wr = wr.add(Mr)), yr & x && (qr = qr.add(Mr)), Mr = Mr.double(), ir >>= x, yr >>= x;
          return xt && (wr = wr.negate()), sr && (qr = qr.negate()), qr = new ke(Se.mul(qr.px, er.beta), qr.py, qr.pz), wr.add(qr);
        }
        /**
         * Constant time multiplication.
         * Uses wNAF method. Windowed method may be 10% faster,
         * but takes 2x longer to generate and consumes 2x memory.
         * Uses precomputes when available.
         * Uses endomorphism for Koblitz curves.
         * @param scalar by which the point would be multiplied
         * @returns New point
         */
        multiply(st) {
          ve(st);
          let Dt = st, er, xt;
          const { endo: ir } = Ee;
          if (ir) {
            const { k1neg: sr, k1: yr, k2neg: wr, k2: qr } = ir.splitScalar(Dt);
            let { p: Mr, f: Dr } = this.wNAF(yr), { p: Qr, f: Xr } = this.wNAF(qr);
            Mr = Ne.constTimeNegate(sr, Mr), Qr = Ne.constTimeNegate(wr, Qr), Qr = new ke(Se.mul(Qr.px, ir.beta), Qr.py, Qr.pz), er = Mr.add(Qr), xt = Dr.add(Xr);
          } else {
            const { p: sr, f: yr } = this.wNAF(Dt);
            er = sr, xt = yr;
          }
          return ke.normalizeZ([er, xt])[0];
        }
        /**
         * Efficiently calculate `aP + bQ`. Unsafe, can expose private key, if used incorrectly.
         * Not using Strauss-Shamir trick: precomputation tables are faster.
         * The trick could be useful if both P and Q are not G (not in our case).
         * @returns non-zero affine point
         */
        multiplyAndAddUnsafe(st, Dt, er) {
          const xt = ke.BASE, ir = (yr, wr) => wr === D || wr === x || !yr.equals(xt) ? yr.multiplyUnsafe(wr) : yr.multiply(wr), sr = ir(this, Dt).add(ir(st, er));
          return sr.is0() ? void 0 : sr;
        }
        // Converts Projective point to affine (x, y) coordinates.
        // Can accept precomputed Z^-1 - for example, from invertBatch.
        // (x, y, z) ∋ (x=x/z, y=y/z)
        toAffine(st) {
          const { px: Dt, py: er, pz: xt } = this, ir = this.is0();
          st == null && (st = ir ? Se.ONE : Se.inv(xt));
          const sr = Se.mul(Dt, st), yr = Se.mul(er, st), wr = Se.mul(xt, st);
          if (ir)
            return { x: Se.ZERO, y: Se.ZERO };
          if (!Se.eql(wr, Se.ONE))
            throw new Error("invZ was invalid");
          return { x: sr, y: yr };
        }
        isTorsionFree() {
          const { h: st, isTorsionFree: Dt } = Ee;
          if (st === x)
            return !0;
          if (Dt)
            return Dt(ke, this);
          throw new Error("isTorsionFree() has not been declared for the elliptic curve");
        }
        clearCofactor() {
          const { h: st, clearCofactor: Dt } = Ee;
          return st === x ? this : Dt ? Dt(ke, this) : this.multiplyUnsafe(Ee.h);
        }
        toRawBytes(st = !0) {
          return this.assertValidity(), ze(ke, this, st);
        }
        toHex(st = !0) {
          return y.bytesToHex(this.toRawBytes(st));
        }
      }
      ke.BASE = new ke(Ee.Gx, Ee.Gy, Se.ONE), ke.ZERO = new ke(Se.ZERO, Se.ONE, Se.ZERO);
      const xe = Ee.nBitLength, Ne = (0, g.wNAF)(ke, Ee.endo ? Math.ceil(xe / 2) : xe);
      return {
        CURVE: Ee,
        ProjectivePoint: ke,
        normPrivateKeyToScalar: Fe,
        weierstrassEquation: Pe,
        isWithinCurveOrder: De
      };
    }
    function L(Ie) {
      const Ee = (0, g.validateBasic)(Ie);
      return y.validateObject(Ee, {
        hash: "hash",
        hmac: "function",
        randomBytes: "function"
      }, {
        bits2int: "function",
        bits2int_modN: "function",
        lowS: "boolean"
      }), Object.freeze({ lowS: !0, ...Ee });
    }
    function H(Ie) {
      const Ee = L(Ie), { Fp: Se, n: ze } = Ee, He = Se.BYTES + 1, Pe = 2 * Se.BYTES + 1;
      function De(Gr) {
        return D < Gr && Gr < Se.ORDER;
      }
      function ve(Gr) {
        return c.mod(Gr, ze);
      }
      function Fe(Gr) {
        return c.invert(Gr, ze);
      }
      const { ProjectivePoint: be, normPrivateKeyToScalar: Be, weierstrassEquation: ke, isWithinCurveOrder: xe } = U({
        ...Ee,
        toBytes(Gr, Fr, br) {
          const Ar = Fr.toAffine(), cr = Se.toBytes(Ar.x), hr = y.concatBytes;
          return br ? hr(Uint8Array.from([Fr.hasEvenY() ? 2 : 3]), cr) : hr(Uint8Array.from([4]), cr, Se.toBytes(Ar.y));
        },
        fromBytes(Gr) {
          const Fr = Gr.length, br = Gr[0], Ar = Gr.subarray(1);
          if (Fr === He && (br === 2 || br === 3)) {
            const cr = y.bytesToNumberBE(Ar);
            if (!De(cr))
              throw new Error("Point is not on curve");
            const hr = ke(cr);
            let Wr;
            try {
              Wr = Se.sqrt(hr);
            } catch ($r) {
              const oi = $r instanceof Error ? ": " + $r.message : "";
              throw new Error("Point is not on curve" + oi);
            }
            const fi = (Wr & x) === x;
            return (br & 1) === 1 !== fi && (Wr = Se.neg(Wr)), { x: cr, y: Wr };
          } else if (Fr === Pe && br === 4) {
            const cr = Se.fromBytes(Ar.subarray(0, Se.BYTES)), hr = Se.fromBytes(Ar.subarray(Se.BYTES, 2 * Se.BYTES));
            return { x: cr, y: hr };
          } else
            throw new Error(`Point of length ${Fr} was invalid. Expected ${He} compressed bytes or ${Pe} uncompressed bytes`);
        }
      }), Ne = (Gr) => y.bytesToHex(y.numberToBytesBE(Gr, Ee.nByteLength));
      function Et(Gr) {
        const Fr = ze >> x;
        return Gr > Fr;
      }
      function st(Gr) {
        return Et(Gr) ? ve(-Gr) : Gr;
      }
      const Dt = (Gr, Fr, br) => y.bytesToNumberBE(Gr.slice(Fr, br));
      class er {
        constructor(Fr, br, Ar) {
          this.r = Fr, this.s = br, this.recovery = Ar, this.assertValidity();
        }
        // pair (bytes of r, bytes of s)
        static fromCompact(Fr) {
          const br = Ee.nByteLength;
          return Fr = (0, t.ensureBytes)("compactSignature", Fr, br * 2), new er(Dt(Fr, 0, br), Dt(Fr, br, 2 * br));
        }
        // DER encoded ECDSA signature
        // https://bitcoin.stackexchange.com/questions/57644/what-are-the-parts-of-a-bitcoin-transaction-input-script
        static fromDER(Fr) {
          const { r: br, s: Ar } = o.DER.toSig((0, t.ensureBytes)("DER", Fr));
          return new er(br, Ar);
        }
        assertValidity() {
          if (!xe(this.r))
            throw new Error("r must be 0 < r < CURVE.n");
          if (!xe(this.s))
            throw new Error("s must be 0 < s < CURVE.n");
        }
        addRecoveryBit(Fr) {
          return new er(this.r, this.s, Fr);
        }
        recoverPublicKey(Fr) {
          const { r: br, s: Ar, recovery: cr } = this, hr = qr((0, t.ensureBytes)("msgHash", Fr));
          if (cr == null || ![0, 1, 2, 3].includes(cr))
            throw new Error("recovery id invalid");
          const Wr = cr === 2 || cr === 3 ? br + Ee.n : br;
          if (Wr >= Se.ORDER)
            throw new Error("recovery id 2 or 3 invalid");
          const fi = (cr & 1) === 0 ? "02" : "03", Bi = be.fromHex(fi + Ne(Wr)), $r = Fe(Wr), oi = ve(-hr * $r), zr = ve(Ar * $r), ti = be.BASE.multiplyAndAddUnsafe(Bi, oi, zr);
          if (!ti)
            throw new Error("point at infinify");
          return ti.assertValidity(), ti;
        }
        // Signatures should be low-s, to prevent malleability.
        hasHighS() {
          return Et(this.s);
        }
        normalizeS() {
          return this.hasHighS() ? new er(this.r, ve(-this.s), this.recovery) : this;
        }
        // DER-encoded
        toDERRawBytes() {
          return y.hexToBytes(this.toDERHex());
        }
        toDERHex() {
          return o.DER.hexFromSig({ r: this.r, s: this.s });
        }
        // padded bytes of r, then padded bytes of s
        toCompactRawBytes() {
          return y.hexToBytes(this.toCompactHex());
        }
        toCompactHex() {
          return Ne(this.r) + Ne(this.s);
        }
      }
      const xt = {
        isValidPrivateKey(Gr) {
          try {
            return Be(Gr), !0;
          } catch {
            return !1;
          }
        },
        normPrivateKeyToScalar: Be,
        /**
         * Produces cryptographically secure private key from random of size
         * (groupLen + ceil(groupLen / 2)) with modulo bias being negligible.
         */
        randomPrivateKey: () => {
          const Gr = c.getMinHashLength(Ee.n);
          return c.mapHashToField(Ee.randomBytes(Gr), Ee.n);
        },
        /**
         * Creates precompute table for an arbitrary EC point. Makes point "cached".
         * Allows to massively speed-up `point.multiply(scalar)`.
         * @returns cached point
         * @example
         * const fast = utils.precompute(8, ProjectivePoint.fromHex(someonesPubKey));
         * fast.multiply(privKey); // much faster ECDH now
         */
        precompute(Gr = 8, Fr = be.BASE) {
          return Fr._setWindowSize(Gr), Fr.multiply(BigInt(3)), Fr;
        }
      };
      function ir(Gr, Fr = !0) {
        return be.fromPrivateKey(Gr).toRawBytes(Fr);
      }
      function sr(Gr) {
        const Fr = y.isBytes(Gr), br = typeof Gr == "string", Ar = (Fr || br) && Gr.length;
        return Fr ? Ar === He || Ar === Pe : br ? Ar === 2 * He || Ar === 2 * Pe : Gr instanceof be;
      }
      function yr(Gr, Fr, br = !0) {
        if (sr(Gr))
          throw new Error("first arg must be private key");
        if (!sr(Fr))
          throw new Error("second arg must be public key");
        return be.fromHex(Fr).multiply(Be(Gr)).toRawBytes(br);
      }
      const wr = Ee.bits2int || function(Gr) {
        const Fr = y.bytesToNumberBE(Gr), br = Gr.length * 8 - Ee.nBitLength;
        return br > 0 ? Fr >> BigInt(br) : Fr;
      }, qr = Ee.bits2int_modN || function(Gr) {
        return ve(wr(Gr));
      }, Mr = y.bitMask(Ee.nBitLength);
      function Dr(Gr) {
        if (typeof Gr != "bigint")
          throw new Error("bigint expected");
        if (!(D <= Gr && Gr < Mr))
          throw new Error(`bigint expected < 2^${Ee.nBitLength}`);
        return y.numberToBytesBE(Gr, Ee.nByteLength);
      }
      function Qr(Gr, Fr, br = Xr) {
        if (["recovered", "canonical"].some((Rr) => Rr in br))
          throw new Error("sign() legacy options not supported");
        const { hash: Ar, randomBytes: cr } = Ee;
        let { lowS: hr, prehash: Wr, extraEntropy: fi } = br;
        hr == null && (hr = !0), Gr = (0, t.ensureBytes)("msgHash", Gr), Wr && (Gr = (0, t.ensureBytes)("prehashed msgHash", Ar(Gr)));
        const Bi = qr(Gr), $r = Be(Fr), oi = [Dr($r), Dr(Bi)];
        if (fi != null && fi !== !1) {
          const Rr = fi === !0 ? cr(Se.BYTES) : fi;
          oi.push((0, t.ensureBytes)("extraEntropy", Rr));
        }
        const zr = y.concatBytes(...oi), ti = Bi;
        function Lr(Rr) {
          const Ir = wr(Rr);
          if (!xe(Ir))
            return;
          const pr = Fe(Ir), Cr = be.BASE.multiply(Ir).toAffine(), Er = ve(Cr.x);
          if (Er === D)
            return;
          const xr = ve(pr * ve(ti + Er * $r));
          if (xr === D)
            return;
          let si = (Cr.x === Er ? 0 : 2) | Number(Cr.y & x), Ci = xr;
          return hr && Et(xr) && (Ci = st(xr), si ^= 1), new er(Er, Ci, si);
        }
        return { seed: zr, k2sig: Lr };
      }
      const Xr = { lowS: Ee.lowS, prehash: !1 }, Vr = { lowS: Ee.lowS, prehash: !1 };
      function Ur(Gr, Fr, br = Xr) {
        const { seed: Ar, k2sig: cr } = Qr(Gr, Fr, br), hr = Ee;
        return y.createHmacDrbg(hr.hash.outputLen, hr.nByteLength, hr.hmac)(Ar, cr);
      }
      be.BASE._setWindowSize(8);
      function Sr(Gr, Fr, br, Ar = Vr) {
        var Cr;
        const cr = Gr;
        if (Fr = (0, t.ensureBytes)("msgHash", Fr), br = (0, t.ensureBytes)("publicKey", br), "strict" in Ar)
          throw new Error("options.strict was renamed to lowS");
        const { lowS: hr, prehash: Wr } = Ar;
        let fi, Bi;
        try {
          if (typeof cr == "string" || y.isBytes(cr))
            try {
              fi = er.fromDER(cr);
            } catch (Er) {
              if (!(Er instanceof o.DER.Err))
                throw Er;
              fi = er.fromCompact(cr);
            }
          else if (typeof cr == "object" && typeof cr.r == "bigint" && typeof cr.s == "bigint") {
            const { r: Er, s: xr } = cr;
            fi = new er(Er, xr);
          } else
            throw new Error("PARSE");
          Bi = be.fromHex(br);
        } catch (Er) {
          if (Er.message === "PARSE")
            throw new Error("signature must be Signature instance, Uint8Array or hex string");
          return !1;
        }
        if (hr && fi.hasHighS())
          return !1;
        Wr && (Fr = Ee.hash(Fr));
        const { r: $r, s: oi } = fi, zr = qr(Fr), ti = Fe(oi), Lr = ve(zr * ti), Rr = ve($r * ti), Ir = (Cr = be.BASE.multiplyAndAddUnsafe(Bi, Lr, Rr)) == null ? void 0 : Cr.toAffine();
        return Ir ? ve(Ir.x) === $r : !1;
      }
      return {
        CURVE: Ee,
        getPublicKey: ir,
        getSharedSecret: yr,
        sign: Ur,
        verify: Sr,
        ProjectivePoint: be,
        Signature: er,
        utils: xt
      };
    }
    function fe(Ie, Ee) {
      const Se = Ie.ORDER;
      let ze = D;
      for (let Et = Se - x; Et % v === D; Et /= v)
        ze += x;
      const He = ze, Pe = v << He - x - x, De = Pe * v, ve = (Se - x) / De, Fe = (ve - x) / v, be = De - x, Be = Pe, ke = Ie.pow(Ee, ve), xe = Ie.pow(Ee, (ve + x) / v);
      let Ne = (Et, st) => {
        let Dt = ke, er = Ie.pow(st, be), xt = Ie.sqr(er);
        xt = Ie.mul(xt, st);
        let ir = Ie.mul(Et, xt);
        ir = Ie.pow(ir, Fe), ir = Ie.mul(ir, er), er = Ie.mul(ir, st), xt = Ie.mul(ir, Et);
        let sr = Ie.mul(xt, er);
        ir = Ie.pow(sr, Be);
        let yr = Ie.eql(ir, Ie.ONE);
        er = Ie.mul(xt, xe), ir = Ie.mul(sr, Dt), xt = Ie.cmov(er, xt, yr), sr = Ie.cmov(ir, sr, yr);
        for (let wr = He; wr > x; wr--) {
          let qr = wr - v;
          qr = v << qr - x;
          let Mr = Ie.pow(sr, qr);
          const Dr = Ie.eql(Mr, Ie.ONE);
          er = Ie.mul(xt, Dt), Dt = Ie.mul(Dt, Dt), Mr = Ie.mul(sr, Dt), xt = Ie.cmov(er, xt, Dr), sr = Ie.cmov(Mr, sr, Dr);
        }
        return { isValid: yr, value: xt };
      };
      if (Ie.ORDER % M === F) {
        const Et = (Ie.ORDER - F) / M, st = Ie.sqrt(Ie.neg(Ee));
        Ne = (Dt, er) => {
          let xt = Ie.sqr(er);
          const ir = Ie.mul(Dt, er);
          xt = Ie.mul(xt, ir);
          let sr = Ie.pow(xt, Et);
          sr = Ie.mul(sr, ir);
          const yr = Ie.mul(sr, st), wr = Ie.mul(Ie.sqr(sr), er), qr = Ie.eql(wr, Dt);
          let Mr = Ie.cmov(yr, sr, qr);
          return { isValid: qr, value: Mr };
        };
      }
      return Ne;
    }
    function ge(Ie, Ee) {
      if (c.validateField(Ie), !Ie.isValid(Ee.A) || !Ie.isValid(Ee.B) || !Ie.isValid(Ee.Z))
        throw new Error("mapToCurveSimpleSWU: invalid opts");
      const Se = fe(Ie, Ee.Z);
      if (!Ie.isOdd)
        throw new Error("Fp.isOdd is not implemented!");
      return (ze) => {
        let He, Pe, De, ve, Fe, be, Be, ke;
        He = Ie.sqr(ze), He = Ie.mul(He, Ee.Z), Pe = Ie.sqr(He), Pe = Ie.add(Pe, He), De = Ie.add(Pe, Ie.ONE), De = Ie.mul(De, Ee.B), ve = Ie.cmov(Ee.Z, Ie.neg(Pe), !Ie.eql(Pe, Ie.ZERO)), ve = Ie.mul(ve, Ee.A), Pe = Ie.sqr(De), be = Ie.sqr(ve), Fe = Ie.mul(be, Ee.A), Pe = Ie.add(Pe, Fe), Pe = Ie.mul(Pe, De), be = Ie.mul(be, ve), Fe = Ie.mul(be, Ee.B), Pe = Ie.add(Pe, Fe), Be = Ie.mul(He, De);
        const { isValid: xe, value: Ne } = Se(Pe, be);
        ke = Ie.mul(He, ze), ke = Ie.mul(ke, Ne), Be = Ie.cmov(Be, De, xe), ke = Ie.cmov(ke, Ne, xe);
        const Et = Ie.isOdd(ze) === Ie.isOdd(ke);
        return ke = Ie.cmov(Ie.neg(ke), ke, Et), Be = Ie.div(Be, ve), { x: Be, y: ke };
      };
    }
  }(weierstrass$2)), weierstrass$2;
}
var hasRequired_shortw_utils;
function require_shortw_utils() {
  if (hasRequired_shortw_utils) return _shortw_utils;
  hasRequired_shortw_utils = 1, Object.defineProperty(_shortw_utils, "__esModule", { value: !0 }), _shortw_utils.getHash = y, _shortw_utils.createCurve = t;
  const o = /* @__PURE__ */ requireHmac$1(), g = /* @__PURE__ */ requireUtils$7(), c = /* @__PURE__ */ requireWeierstrass();
  function y(d) {
    return {
      hash: d,
      hmac: (E, ...B) => (0, o.hmac)(d, E, (0, g.concatBytes)(...B)),
      randomBytes: g.randomBytes
    };
  }
  function t(d, E) {
    const B = (D) => (0, c.weierstrass)({ ...d, ...y(D) });
    return Object.freeze({ ...B(E), create: B });
  }
  return _shortw_utils;
}
var hashToCurve = {}, hasRequiredHashToCurve;
function requireHashToCurve() {
  if (hasRequiredHashToCurve) return hashToCurve;
  hasRequiredHashToCurve = 1, Object.defineProperty(hashToCurve, "__esModule", { value: !0 }), hashToCurve.expand_message_xmd = E, hashToCurve.expand_message_xof = B, hashToCurve.hash_to_field = D, hashToCurve.isogenyMap = x, hashToCurve.createHasher = v;
  const o = /* @__PURE__ */ requireModular(), g = /* @__PURE__ */ requireUtils$6(), c = g.bytesToNumberBE;
  function y(F, M) {
    if (F < 0 || F >= 1 << 8 * M)
      throw new Error(`bad I2OSP call: value=${F} length=${M}`);
    const U = Array.from({ length: M }).fill(0);
    for (let L = M - 1; L >= 0; L--)
      U[L] = F & 255, F >>>= 8;
    return new Uint8Array(U);
  }
  function t(F, M) {
    const U = new Uint8Array(F.length);
    for (let L = 0; L < F.length; L++)
      U[L] = F[L] ^ M[L];
    return U;
  }
  function d(F) {
    if (!Number.isSafeInteger(F))
      throw new Error("number expected");
  }
  function E(F, M, U, L) {
    (0, g.abytes)(F), (0, g.abytes)(M), d(U), M.length > 255 && (M = L((0, g.concatBytes)((0, g.utf8ToBytes)("H2C-OVERSIZE-DST-"), M)));
    const { outputLen: H, blockLen: fe } = L, ge = Math.ceil(U / H);
    if (ge > 255)
      throw new Error("Invalid xmd length");
    const Ie = (0, g.concatBytes)(M, y(M.length, 1)), Ee = y(0, fe), Se = y(U, 2), ze = new Array(ge), He = L((0, g.concatBytes)(Ee, F, Se, y(0, 1), Ie));
    ze[0] = L((0, g.concatBytes)(He, y(1, 1), Ie));
    for (let De = 1; De <= ge; De++) {
      const ve = [t(He, ze[De - 1]), y(De + 1, 1), Ie];
      ze[De] = L((0, g.concatBytes)(...ve));
    }
    return (0, g.concatBytes)(...ze).slice(0, U);
  }
  function B(F, M, U, L, H) {
    if ((0, g.abytes)(F), (0, g.abytes)(M), d(U), M.length > 255) {
      const fe = Math.ceil(2 * L / 8);
      M = H.create({ dkLen: fe }).update((0, g.utf8ToBytes)("H2C-OVERSIZE-DST-")).update(M).digest();
    }
    if (U > 65535 || M.length > 255)
      throw new Error("expand_message_xof: invalid lenInBytes");
    return H.create({ dkLen: U }).update(F).update(y(U, 2)).update(M).update(y(M.length, 1)).digest();
  }
  function D(F, M, U) {
    (0, g.validateObject)(U, {
      DST: "stringOrUint8Array",
      p: "bigint",
      m: "isSafeInteger",
      k: "isSafeInteger",
      hash: "hash"
    });
    const { p: L, k: H, m: fe, hash: ge, expand: Ie, DST: Ee } = U;
    (0, g.abytes)(F), d(M);
    const Se = typeof Ee == "string" ? (0, g.utf8ToBytes)(Ee) : Ee, ze = L.toString(2).length, He = Math.ceil((ze + H) / 8), Pe = M * fe * He;
    let De;
    if (Ie === "xmd")
      De = E(F, Se, Pe, ge);
    else if (Ie === "xof")
      De = B(F, Se, Pe, H, ge);
    else if (Ie === "_internal_pass")
      De = F;
    else
      throw new Error('expand must be "xmd" or "xof"');
    const ve = new Array(M);
    for (let Fe = 0; Fe < M; Fe++) {
      const be = new Array(fe);
      for (let Be = 0; Be < fe; Be++) {
        const ke = He * (Be + Fe * fe), xe = De.subarray(ke, ke + He);
        be[Be] = (0, o.mod)(c(xe), L);
      }
      ve[Fe] = be;
    }
    return ve;
  }
  function x(F, M) {
    const U = M.map((L) => Array.from(L).reverse());
    return (L, H) => {
      const [fe, ge, Ie, Ee] = U.map((Se) => Se.reduce((ze, He) => F.add(F.mul(ze, L), He)));
      return L = F.div(fe, ge), H = F.mul(H, F.div(Ie, Ee)), { x: L, y: H };
    };
  }
  function v(F, M, U) {
    if (typeof M != "function")
      throw new Error("mapToCurve() must be defined");
    return {
      // Encodes byte string to elliptic curve.
      // hash_to_curve from https://www.rfc-editor.org/rfc/rfc9380#section-3
      hashToCurve(L, H) {
        const fe = D(L, 2, { ...U, DST: U.DST, ...H }), ge = F.fromAffine(M(fe[0])), Ie = F.fromAffine(M(fe[1])), Ee = ge.add(Ie).clearCofactor();
        return Ee.assertValidity(), Ee;
      },
      // Encodes byte string to elliptic curve.
      // encode_to_curve from https://www.rfc-editor.org/rfc/rfc9380#section-3
      encodeToCurve(L, H) {
        const fe = D(L, 1, { ...U, DST: U.encodeDST, ...H }), ge = F.fromAffine(M(fe[0])).clearCofactor();
        return ge.assertValidity(), ge;
      },
      // Same as encodeToCurve, but without hash
      mapToCurve(L) {
        if (!Array.isArray(L))
          throw new Error("mapToCurve: expected array of bigints");
        for (const fe of L)
          if (typeof fe != "bigint")
            throw new Error(`mapToCurve: expected array of bigints, got ${fe} in array`);
        const H = F.fromAffine(M(L)).clearCofactor();
        return H.assertValidity(), H;
      }
    };
  }
  return hashToCurve;
}
var hasRequiredSecp256k1$3;
function requireSecp256k1$3() {
  return hasRequiredSecp256k1$3 || (hasRequiredSecp256k1$3 = 1, function(o) {
    Object.defineProperty(o, "__esModule", { value: !0 }), o.encodeToCurve = o.hashToCurve = o.schnorr = o.secp256k1 = void 0;
    const g = /* @__PURE__ */ requireSha256$3(), c = /* @__PURE__ */ requireUtils$7(), y = /* @__PURE__ */ require_shortw_utils(), t = /* @__PURE__ */ requireHashToCurve(), d = /* @__PURE__ */ requireModular(), E = /* @__PURE__ */ requireUtils$6(), B = /* @__PURE__ */ requireWeierstrass(), D = BigInt("0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f"), x = BigInt("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141"), v = BigInt(1), F = BigInt(2), M = (er, xt) => (er + xt / F) / xt;
    function U(er) {
      const xt = D, ir = BigInt(3), sr = BigInt(6), yr = BigInt(11), wr = BigInt(22), qr = BigInt(23), Mr = BigInt(44), Dr = BigInt(88), Qr = er * er * er % xt, Xr = Qr * Qr * er % xt, Vr = (0, d.pow2)(Xr, ir, xt) * Xr % xt, Ur = (0, d.pow2)(Vr, ir, xt) * Xr % xt, Sr = (0, d.pow2)(Ur, F, xt) * Qr % xt, Gr = (0, d.pow2)(Sr, yr, xt) * Sr % xt, Fr = (0, d.pow2)(Gr, wr, xt) * Gr % xt, br = (0, d.pow2)(Fr, Mr, xt) * Fr % xt, Ar = (0, d.pow2)(br, Dr, xt) * br % xt, cr = (0, d.pow2)(Ar, Mr, xt) * Fr % xt, hr = (0, d.pow2)(cr, ir, xt) * Xr % xt, Wr = (0, d.pow2)(hr, qr, xt) * Gr % xt, fi = (0, d.pow2)(Wr, sr, xt) * Qr % xt, Bi = (0, d.pow2)(fi, F, xt);
      if (!L.eql(L.sqr(Bi), er))
        throw new Error("Cannot find square root");
      return Bi;
    }
    const L = (0, d.Field)(D, void 0, void 0, { sqrt: U });
    o.secp256k1 = (0, y.createCurve)({
      a: BigInt(0),
      // equation params: a, b
      b: BigInt(7),
      // Seem to be rigid: bitcointalk.org/index.php?topic=289795.msg3183975#msg3183975
      Fp: L,
      // Field's prime: 2n**256n - 2n**32n - 2n**9n - 2n**8n - 2n**7n - 2n**6n - 2n**4n - 1n
      n: x,
      // Curve order, total count of valid points in the field
      // Base point (x, y) aka generator point
      Gx: BigInt("55066263022277343669578718895168534326250603453777594175500187360389116729240"),
      Gy: BigInt("32670510020758816978083085130507043184471273380659243275938904335757337482424"),
      h: BigInt(1),
      // Cofactor
      lowS: !0,
      // Allow only low-S signatures by default in sign() and verify()
      /**
       * secp256k1 belongs to Koblitz curves: it has efficiently computable endomorphism.
       * Endomorphism uses 2x less RAM, speeds up precomputation by 2x and ECDH / key recovery by 20%.
       * For precomputed wNAF it trades off 1/2 init time & 1/3 ram for 20% perf hit.
       * Explanation: https://gist.github.com/paulmillr/eb670806793e84df628a7c434a873066
       */
      endo: {
        beta: BigInt("0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee"),
        splitScalar: (er) => {
          const xt = x, ir = BigInt("0x3086d221a7d46bcde86c90e49284eb15"), sr = -v * BigInt("0xe4437ed6010e88286f547fa90abfe4c3"), yr = BigInt("0x114ca50f7a8e2f3f657c1108d9d44cfd8"), wr = ir, qr = BigInt("0x100000000000000000000000000000000"), Mr = M(wr * er, xt), Dr = M(-sr * er, xt);
          let Qr = (0, d.mod)(er - Mr * ir - Dr * yr, xt), Xr = (0, d.mod)(-Mr * sr - Dr * wr, xt);
          const Vr = Qr > qr, Ur = Xr > qr;
          if (Vr && (Qr = xt - Qr), Ur && (Xr = xt - Xr), Qr > qr || Xr > qr)
            throw new Error("splitScalar: Endomorphism failed, k=" + er);
          return { k1neg: Vr, k1: Qr, k2neg: Ur, k2: Xr };
        }
      }
    }, g.sha256);
    const H = BigInt(0), fe = (er) => typeof er == "bigint" && H < er && er < D, ge = (er) => typeof er == "bigint" && H < er && er < x, Ie = {};
    function Ee(er, ...xt) {
      let ir = Ie[er];
      if (ir === void 0) {
        const sr = (0, g.sha256)(Uint8Array.from(er, (yr) => yr.charCodeAt(0)));
        ir = (0, E.concatBytes)(sr, sr), Ie[er] = ir;
      }
      return (0, g.sha256)((0, E.concatBytes)(ir, ...xt));
    }
    const Se = (er) => er.toRawBytes(!0).slice(1), ze = (er) => (0, E.numberToBytesBE)(er, 32), He = (er) => (0, d.mod)(er, D), Pe = (er) => (0, d.mod)(er, x), De = o.secp256k1.ProjectivePoint, ve = (er, xt, ir) => De.BASE.multiplyAndAddUnsafe(er, xt, ir);
    function Fe(er) {
      let xt = o.secp256k1.utils.normPrivateKeyToScalar(er), ir = De.fromPrivateKey(xt);
      return { scalar: ir.hasEvenY() ? xt : Pe(-xt), bytes: Se(ir) };
    }
    function be(er) {
      if (!fe(er))
        throw new Error("bad x: need 0 < x < p");
      const xt = He(er * er), ir = He(xt * er + BigInt(7));
      let sr = U(ir);
      sr % F !== H && (sr = He(-sr));
      const yr = new De(er, sr, v);
      return yr.assertValidity(), yr;
    }
    function Be(...er) {
      return Pe((0, E.bytesToNumberBE)(Ee("BIP0340/challenge", ...er)));
    }
    function ke(er) {
      return Fe(er).bytes;
    }
    function xe(er, xt, ir = (0, c.randomBytes)(32)) {
      const sr = (0, E.ensureBytes)("message", er), { bytes: yr, scalar: wr } = Fe(xt), qr = (0, E.ensureBytes)("auxRand", ir, 32), Mr = ze(wr ^ (0, E.bytesToNumberBE)(Ee("BIP0340/aux", qr))), Dr = Ee("BIP0340/nonce", Mr, yr, sr), Qr = Pe((0, E.bytesToNumberBE)(Dr));
      if (Qr === H)
        throw new Error("sign failed: k is zero");
      const { bytes: Xr, scalar: Vr } = Fe(Qr), Ur = Be(Xr, yr, sr), Sr = new Uint8Array(64);
      if (Sr.set(Xr, 0), Sr.set(ze(Pe(Vr + Ur * wr)), 32), !Ne(Sr, sr, yr))
        throw new Error("sign: Invalid signature produced");
      return Sr;
    }
    function Ne(er, xt, ir) {
      const sr = (0, E.ensureBytes)("signature", er, 64), yr = (0, E.ensureBytes)("message", xt), wr = (0, E.ensureBytes)("publicKey", ir, 32);
      try {
        const qr = be((0, E.bytesToNumberBE)(wr)), Mr = (0, E.bytesToNumberBE)(sr.subarray(0, 32));
        if (!fe(Mr))
          return !1;
        const Dr = (0, E.bytesToNumberBE)(sr.subarray(32, 64));
        if (!ge(Dr))
          return !1;
        const Qr = Be(ze(Mr), Se(qr), yr), Xr = ve(qr, Dr, Pe(-Qr));
        return !(!Xr || !Xr.hasEvenY() || Xr.toAffine().x !== Mr);
      } catch {
        return !1;
      }
    }
    o.schnorr = {
      getPublicKey: ke,
      sign: xe,
      verify: Ne,
      utils: {
        randomPrivateKey: o.secp256k1.utils.randomPrivateKey,
        lift_x: be,
        pointToBytes: Se,
        numberToBytesBE: E.numberToBytesBE,
        bytesToNumberBE: E.bytesToNumberBE,
        taggedHash: Ee,
        mod: d.mod
      }
    };
    const Et = (0, t.isogenyMap)(L, [
      // xNum
      [
        "0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa8c7",
        "0x7d3d4c80bc321d5b9f315cea7fd44c5d595d2fc0bf63b92dfff1044f17c6581",
        "0x534c328d23f234e6e2a413deca25caece4506144037c40314ecbd0b53d9dd262",
        "0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa88c"
      ],
      // xDen
      [
        "0xd35771193d94918a9ca34ccbb7b640dd86cd409542f8487d9fe6b745781eb49b",
        "0xedadc6f64383dc1df7c4b2d51b54225406d36b641f5e41bbc52a56612a8c6d14",
        "0x0000000000000000000000000000000000000000000000000000000000000001"
        // LAST 1
      ],
      // yNum
      [
        "0x4bda12f684bda12f684bda12f684bda12f684bda12f684bda12f684b8e38e23c",
        "0xc75e0c32d5cb7c0fa9d0a54b12a0a6d5647ab046d686da6fdffc90fc201d71a3",
        "0x29a6194691f91a73715209ef6512e576722830a201be2018a765e85a9ecee931",
        "0x2f684bda12f684bda12f684bda12f684bda12f684bda12f684bda12f38e38d84"
      ],
      // yDen
      [
        "0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffff93b",
        "0x7a06534bb8bdb49fd5e9e6632722c2989467c1bfc8e8d978dfb425d2685c2573",
        "0x6484aa716545ca2cf3a70c3fa8fe337e0a3d21162f0d6299a7bf8192bfd2a76f",
        "0x0000000000000000000000000000000000000000000000000000000000000001"
        // LAST 1
      ]
    ].map((er) => er.map((xt) => BigInt(xt)))), st = (0, B.mapToCurveSimpleSWU)(L, {
      A: BigInt("0x3f8731abdd661adca08a5558f0f5d272e953d363cb6f0e5d405447c01a444533"),
      B: BigInt("1771"),
      Z: L.create(BigInt("-11"))
    }), Dt = (0, t.createHasher)(o.secp256k1.ProjectivePoint, (er) => {
      const { x: xt, y: ir } = st(L.create(er[0]));
      return Et(xt, ir);
    }, {
      DST: "secp256k1_XMD:SHA-256_SSWU_RO_",
      encodeDST: "secp256k1_XMD:SHA-256_SSWU_NU_",
      p: L.ORDER,
      m: 1,
      k: 128,
      expand: "xmd",
      hash: g.sha256
    });
    o.hashToCurve = Dt.hashToCurve, o.encodeToCurve = Dt.encodeToCurve;
  }(secp256k1$4)), secp256k1$4;
}
var hasRequiredSecp256k1$2;
function requireSecp256k1$2() {
  return hasRequiredSecp256k1$2 || (hasRequiredSecp256k1$2 = 1, function(o) {
    Object.defineProperty(o, "__esModule", { value: !0 }), o.secp256k1 = void 0;
    var g = /* @__PURE__ */ requireSecp256k1$3();
    Object.defineProperty(o, "secp256k1", { enumerable: !0, get: function() {
      return g.secp256k1;
    } });
  }(secp256k1$5)), secp256k1$5;
}
var bytes$2 = {}, random$1 = {}, hasRequiredRandom$1;
function requireRandom$1() {
  if (hasRequiredRandom$1) return random$1;
  hasRequiredRandom$1 = 1, Object.defineProperty(random$1, "__esModule", { value: !0 }), random$1.getRandomBytesSync = g, random$1.getRandomBytes = c;
  const o = /* @__PURE__ */ requireUtils$7();
  function g(y) {
    return (0, o.randomBytes)(y);
  }
  async function c(y) {
    return (0, o.randomBytes)(y);
  }
  return random$1;
}
function commonjsRequire(o) {
  throw new Error('Could not dynamically require "' + o + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var utils$7 = { exports: {} }, utils$6 = utils$7.exports, hasRequiredUtils$5;
function requireUtils$5() {
  return hasRequiredUtils$5 || (hasRequiredUtils$5 = 1, function(o, g) {
    var c = utils$6 && utils$6.__importDefault || function(M) {
      return M && M.__esModule ? M : { default: M };
    };
    Object.defineProperty(g, "__esModule", { value: !0 }), g.crypto = g.utf8ToBytes = g.createView = g.concatBytes = g.toHex = g.bytesToHex = g.assertBytes = g.assertBool = void 0, g.bytesToUtf8 = D, g.hexToBytes = x, g.equalsBytes = v, g.wrapHash = F;
    const y = c(/* @__PURE__ */ require_assert()), t = /* @__PURE__ */ requireUtils$7(), d = y.default.bool;
    g.assertBool = d;
    const E = y.default.bytes;
    g.assertBytes = E;
    var B = /* @__PURE__ */ requireUtils$7();
    Object.defineProperty(g, "bytesToHex", { enumerable: !0, get: function() {
      return B.bytesToHex;
    } }), Object.defineProperty(g, "toHex", { enumerable: !0, get: function() {
      return B.bytesToHex;
    } }), Object.defineProperty(g, "concatBytes", { enumerable: !0, get: function() {
      return B.concatBytes;
    } }), Object.defineProperty(g, "createView", { enumerable: !0, get: function() {
      return B.createView;
    } }), Object.defineProperty(g, "utf8ToBytes", { enumerable: !0, get: function() {
      return B.utf8ToBytes;
    } });
    function D(M) {
      if (!(M instanceof Uint8Array))
        throw new TypeError(`bytesToUtf8 expected Uint8Array, got ${typeof M}`);
      return new TextDecoder().decode(M);
    }
    function x(M) {
      const U = M.startsWith("0x") ? M.substring(2) : M;
      return (0, t.hexToBytes)(U);
    }
    function v(M, U) {
      if (M.length !== U.length)
        return !1;
      for (let L = 0; L < M.length; L++)
        if (M[L] !== U[L])
          return !1;
      return !0;
    }
    function F(M) {
      return (U) => (y.default.bytes(U), M(U));
    }
    g.crypto = (() => {
      const M = typeof globalThis == "object" && "crypto" in globalThis ? globalThis.crypto : void 0, U = typeof commonjsRequire == "function" && commonjsRequire.bind(o);
      return {
        node: U && !M ? U("crypto") : void 0,
        web: M
      };
    })();
  }(utils$7, utils$7.exports)), utils$7.exports;
}
var helpers = {}, internal = {}, hasRequiredInternal;
function requireInternal() {
  if (hasRequiredInternal) return internal;
  hasRequiredInternal = 1, Object.defineProperty(internal, "__esModule", { value: !0 }), internal.getKeys = internal.fromAscii = internal.fromUtf8 = internal.toAscii = internal.arrayContainsArray = internal.getBinarySize = internal.padToEven = internal.stripHexPrefix = internal.isHexString = void 0;
  const o = requireBytes$1();
  function g(v, F) {
    return !(typeof v != "string" || !v.match(/^0x[0-9A-Fa-f]*$/) || typeof F < "u" && F > 0 && v.length !== 2 + 2 * F);
  }
  internal.isHexString = g;
  const c = (v) => {
    if (typeof v != "string")
      throw new Error(`[stripHexPrefix] input must be type 'string', received ${typeof v}`);
    return g(v) ? v.slice(2) : v;
  };
  internal.stripHexPrefix = c;
  function y(v) {
    let F = v;
    if (typeof F != "string")
      throw new Error(`[padToEven] value must be type 'string', received ${typeof F}`);
    return F.length % 2 && (F = `0${F}`), F;
  }
  internal.padToEven = y;
  function t(v) {
    if (typeof v != "string")
      throw new Error(`[getBinarySize] method requires input type 'string', received ${typeof v}`);
    return (0, o.utf8ToBytes)(v).byteLength;
  }
  internal.getBinarySize = t;
  function d(v, F, M) {
    if (Array.isArray(v) !== !0)
      throw new Error(`[arrayContainsArray] method requires input 'superset' to be an array, got type '${typeof v}'`);
    if (Array.isArray(F) !== !0)
      throw new Error(`[arrayContainsArray] method requires input 'subset' to be an array, got type '${typeof F}'`);
    return F[M === !0 ? "some" : "every"]((U) => v.indexOf(U) >= 0);
  }
  internal.arrayContainsArray = d;
  function E(v) {
    let F = "", M = 0;
    const U = v.length;
    for (v.substring(0, 2) === "0x" && (M = 2); M < U; M += 2) {
      const L = parseInt(v.substr(M, 2), 16);
      F += String.fromCharCode(L);
    }
    return F;
  }
  internal.toAscii = E;
  function B(v) {
    const F = (0, o.utf8ToBytes)(v);
    return `0x${y((0, o.bytesToUnprefixedHex)(F)).replace(/^0+|0+$/g, "")}`;
  }
  internal.fromUtf8 = B;
  function D(v) {
    let F = "";
    for (let M = 0; M < v.length; M++) {
      const L = v.charCodeAt(M).toString(16);
      F += L.length < 2 ? `0${L}` : L;
    }
    return `0x${F}`;
  }
  internal.fromAscii = D;
  function x(v, F, M) {
    if (!Array.isArray(v))
      throw new Error(`[getKeys] method expects input 'params' to be an array, got ${typeof v}`);
    if (typeof F != "string")
      throw new Error(`[getKeys] method expects input 'key' to be type 'string', got ${typeof v}`);
    const U = [];
    for (let L = 0; L < v.length; L++) {
      let H = v[L][F];
      if (M === !0 && !H)
        H = "";
      else if (typeof H != "string")
        throw new Error(`invalid abi - expected type 'string', received ${typeof H}`);
      U.push(H);
    }
    return U;
  }
  return internal.getKeys = x, internal;
}
var hasRequiredHelpers;
function requireHelpers() {
  if (hasRequiredHelpers) return helpers;
  hasRequiredHelpers = 1, Object.defineProperty(helpers, "__esModule", { value: !0 }), helpers.assertIsString = helpers.assertIsArray = helpers.assertIsBytes = helpers.assertIsHexString = void 0;
  const o = requireInternal(), g = function(d) {
    if (!(0, o.isHexString)(d)) {
      const E = `This method only supports 0x-prefixed hex strings but input was: ${d}`;
      throw new Error(E);
    }
  };
  helpers.assertIsHexString = g;
  const c = function(d) {
    if (!(d instanceof Uint8Array)) {
      const E = `This method only supports Uint8Array but input was: ${d}`;
      throw new Error(E);
    }
  };
  helpers.assertIsBytes = c;
  const y = function(d) {
    if (!Array.isArray(d)) {
      const E = `This method only supports number arrays but input was: ${d}`;
      throw new Error(E);
    }
  };
  helpers.assertIsArray = y;
  const t = function(d) {
    if (typeof d != "string") {
      const E = `This method only supports strings but input was: ${d}`;
      throw new Error(E);
    }
  };
  return helpers.assertIsString = t, helpers;
}
var hasRequiredBytes$1;
function requireBytes$1() {
  return hasRequiredBytes$1 || (hasRequiredBytes$1 = 1, function(o) {
    Object.defineProperty(o, "__esModule", { value: !0 }), o.hexToBigInt = o.utf8ToBytes = o.equalsBytes = o.bytesToUtf8 = o.bigInt64ToBytes = o.int32ToBytes = o.bytesToBigInt64 = o.bytesToInt32 = o.concatBytes = o.randomBytes = o.compareBytes = o.intToUnpaddedBytes = o.bigIntToAddressBytes = o.bigIntToUnpaddedBytes = o.bigIntMin = o.bigIntMax = o.bigIntToHex = o.validateNoLeadingZeroes = o.short = o.addHexPrefix = o.toUnsigned = o.fromSigned = o.toBytes = o.unpadHex = o.unpadArray = o.unpadBytes = o.setLengthRight = o.setLengthLeft = o.zeros = o.bigIntToBytes = o.intToBytes = o.intToHex = o.hexToBytes = o.bytesToInt = o.bytesToBigInt = o.bytesToHex = o.unprefixedHexToBytes = o.bytesToUnprefixedHex = void 0;
    const g = /* @__PURE__ */ requireRandom$1(), c = /* @__PURE__ */ requireUtils$5(), y = requireHelpers(), t = requireInternal(), d = BigInt(0);
    o.bytesToUnprefixedHex = c.bytesToHex;
    const E = {}, B = {};
    for (let Sr = 0; Sr < 16; Sr++) {
      const Gr = Sr, Fr = Sr * 16, br = Sr.toString(16).toLowerCase();
      B[br] = Gr, B[br.toUpperCase()] = Gr, E[br] = Fr, E[br.toUpperCase()] = Fr;
    }
    function D(Sr) {
      const Gr = Sr.length, Fr = new Uint8Array(Gr / 2);
      for (let br = 0; br < Gr; br += 2)
        Fr[br / 2] = E[Sr[br]] + B[Sr[br + 1]];
      return Fr;
    }
    const x = (Sr) => {
      if (Sr.slice(0, 2) === "0x")
        throw new Error("hex string is prefixed with 0x, should be unprefixed");
      return D((0, t.padToEven)(Sr));
    };
    o.unprefixedHexToBytes = x;
    const v = Array.from({ length: 256 }, (Sr, Gr) => Gr.toString(16).padStart(2, "0")), F = (Sr) => {
      let Gr = "0x";
      if (Sr === void 0 || Sr.length === 0)
        return Gr;
      for (const Fr of Sr)
        Gr = `${Gr}${v[Fr]}`;
      return Gr;
    };
    o.bytesToHex = F;
    const M = [];
    for (let Sr = 0; Sr <= 256 * 256 - 1; Sr++)
      M[Sr] = BigInt(Sr);
    const U = (Sr, Gr = !1) => {
      Gr && Sr.reverse();
      const Fr = (0, o.bytesToHex)(Sr);
      return Fr === "0x" ? d : Fr.length === 4 ? M[Sr[0]] : Fr.length === 6 ? M[Sr[0] * 256 + Sr[1]] : BigInt(Fr);
    };
    o.bytesToBigInt = U;
    const L = (Sr) => {
      const Gr = Number((0, o.bytesToBigInt)(Sr));
      if (!Number.isSafeInteger(Gr))
        throw new Error("Number exceeds 53 bits");
      return Gr;
    };
    o.bytesToInt = L;
    const H = (Sr) => {
      if (typeof Sr != "string")
        throw new Error(`hex argument type ${typeof Sr} must be of type string`);
      if (!/^0x[0-9a-fA-F]*$/.test(Sr))
        throw new Error(`Input must be a 0x-prefixed hexadecimal string, got ${Sr}`);
      const Gr = Sr.slice(2);
      return D(Gr.length % 2 === 0 ? Gr : (0, t.padToEven)(Gr));
    };
    o.hexToBytes = H;
    const fe = (Sr) => {
      if (!Number.isSafeInteger(Sr) || Sr < 0)
        throw new Error(`Received an invalid integer type: ${Sr}`);
      return `0x${Sr.toString(16)}`;
    };
    o.intToHex = fe;
    const ge = (Sr) => {
      const Gr = (0, o.intToHex)(Sr);
      return (0, o.hexToBytes)(Gr);
    };
    o.intToBytes = ge;
    const Ie = (Sr, Gr = !1) => {
      const Fr = (0, o.toBytes)(`0x${(0, t.padToEven)(Sr.toString(16))}`);
      return Gr ? Fr.reverse() : Fr;
    };
    o.bigIntToBytes = Ie;
    const Ee = (Sr) => new Uint8Array(Sr);
    o.zeros = Ee;
    const Se = (Sr, Gr, Fr) => Fr ? Sr.length < Gr ? new Uint8Array([...Sr, ...(0, o.zeros)(Gr - Sr.length)]) : Sr.subarray(0, Gr) : Sr.length < Gr ? new Uint8Array([...(0, o.zeros)(Gr - Sr.length), ...Sr]) : Sr.subarray(-Gr), ze = (Sr, Gr) => ((0, y.assertIsBytes)(Sr), Se(Sr, Gr, !1));
    o.setLengthLeft = ze;
    const He = (Sr, Gr) => ((0, y.assertIsBytes)(Sr), Se(Sr, Gr, !0));
    o.setLengthRight = He;
    const Pe = (Sr) => {
      let Gr = Sr[0];
      for (; Sr.length > 0 && Gr.toString() === "0"; )
        Sr = Sr.slice(1), Gr = Sr[0];
      return Sr;
    }, De = (Sr) => ((0, y.assertIsBytes)(Sr), Pe(Sr));
    o.unpadBytes = De;
    const ve = (Sr) => ((0, y.assertIsArray)(Sr), Pe(Sr));
    o.unpadArray = ve;
    const Fe = (Sr) => ((0, y.assertIsHexString)(Sr), `0x${Pe((0, t.stripHexPrefix)(Sr))}`);
    o.unpadHex = Fe;
    const be = (Sr) => {
      if (Sr == null)
        return new Uint8Array();
      if (Array.isArray(Sr) || Sr instanceof Uint8Array)
        return Uint8Array.from(Sr);
      if (typeof Sr == "string") {
        if (!(0, t.isHexString)(Sr))
          throw new Error(`Cannot convert string to Uint8Array. toBytes only supports 0x-prefixed hex strings and this string was given: ${Sr}`);
        return (0, o.hexToBytes)(Sr);
      }
      if (typeof Sr == "number")
        return (0, o.intToBytes)(Sr);
      if (typeof Sr == "bigint") {
        if (Sr < d)
          throw new Error(`Cannot convert negative bigint to Uint8Array. Given: ${Sr}`);
        let Gr = Sr.toString(16);
        return Gr.length % 2 && (Gr = "0" + Gr), (0, o.unprefixedHexToBytes)(Gr);
      }
      if (Sr.toBytes !== void 0)
        return Sr.toBytes();
      throw new Error("invalid type");
    };
    o.toBytes = be;
    const Be = (Sr) => BigInt.asIntN(256, (0, o.bytesToBigInt)(Sr));
    o.fromSigned = Be;
    const ke = (Sr) => (0, o.bigIntToBytes)(BigInt.asUintN(256, Sr));
    o.toUnsigned = ke;
    const xe = (Sr) => typeof Sr != "string" || (0, t.isHexString)(Sr) ? Sr : `0x${Sr}`;
    o.addHexPrefix = xe;
    const Ne = (Sr, Gr = 50) => {
      const Fr = Sr instanceof Uint8Array ? (0, o.bytesToHex)(Sr) : Sr, br = Fr.slice(0, 2) === "0x" ? Gr + 2 : Gr;
      return Fr.length <= br ? Fr : Fr.slice(0, br) + "…";
    };
    o.short = Ne;
    const Et = (Sr) => {
      for (const [Gr, Fr] of Object.entries(Sr))
        if (Fr !== void 0 && Fr.length > 0 && Fr[0] === 0)
          throw new Error(`${Gr} cannot have leading zeroes, received: ${(0, o.bytesToHex)(Fr)}`);
    };
    o.validateNoLeadingZeroes = Et;
    const st = (Sr) => `0x${Sr.toString(16)}`;
    o.bigIntToHex = st;
    const Dt = (...Sr) => Sr.reduce((Gr, Fr) => Fr > Gr ? Fr : Gr);
    o.bigIntMax = Dt;
    const er = (...Sr) => Sr.reduce((Gr, Fr) => Fr < Gr ? Fr : Gr);
    o.bigIntMin = er;
    const xt = (Sr) => (0, o.unpadBytes)((0, o.bigIntToBytes)(Sr));
    o.bigIntToUnpaddedBytes = xt;
    const ir = (Sr, Gr = !0) => {
      const Fr = (0, o.bigIntToBytes)(Sr);
      if (Gr && Fr.length > 20)
        throw Error(`Invalid address bytes length=${Fr.length} strict=${Gr}`);
      return (0, o.setLengthLeft)(Fr, 20);
    };
    o.bigIntToAddressBytes = ir;
    const sr = (Sr) => (0, o.unpadBytes)((0, o.intToBytes)(Sr));
    o.intToUnpaddedBytes = sr;
    const yr = (Sr, Gr) => {
      const Fr = (0, o.bytesToBigInt)(Sr), br = (0, o.bytesToBigInt)(Gr);
      return Fr > br ? 1 : Fr < br ? -1 : 0;
    };
    o.compareBytes = yr;
    const wr = (Sr) => (0, g.getRandomBytesSync)(Sr);
    o.randomBytes = wr;
    const qr = (...Sr) => {
      if (Sr.length === 1)
        return Sr[0];
      const Gr = Sr.reduce((br, Ar) => br + Ar.length, 0), Fr = new Uint8Array(Gr);
      for (let br = 0, Ar = 0; br < Sr.length; br++) {
        const cr = Sr[br];
        Fr.set(cr, Ar), Ar += cr.length;
      }
      return Fr;
    };
    o.concatBytes = qr;
    function Mr(Sr, Gr = !1) {
      return Sr.length < 4 && (Sr = Se(Sr, 4, Gr)), new DataView(Sr.buffer, Sr.byteOffset, Sr.byteLength).getUint32(0, Gr);
    }
    o.bytesToInt32 = Mr;
    function Dr(Sr, Gr = !1) {
      return Sr.length < 8 && (Sr = Se(Sr, 8, Gr)), new DataView(Sr.buffer, Sr.byteOffset, Sr.byteLength).getBigUint64(0, Gr);
    }
    o.bytesToBigInt64 = Dr;
    function Qr(Sr, Gr = !1) {
      const Fr = new ArrayBuffer(4);
      return new DataView(Fr).setUint32(0, Sr, Gr), new Uint8Array(Fr);
    }
    o.int32ToBytes = Qr;
    function Xr(Sr, Gr = !1) {
      const Fr = new ArrayBuffer(8);
      return new DataView(Fr).setBigUint64(0, Sr, Gr), new Uint8Array(Fr);
    }
    o.bigInt64ToBytes = Xr;
    var Vr = /* @__PURE__ */ requireUtils$5();
    Object.defineProperty(o, "bytesToUtf8", { enumerable: !0, get: function() {
      return Vr.bytesToUtf8;
    } }), Object.defineProperty(o, "equalsBytes", { enumerable: !0, get: function() {
      return Vr.equalsBytes;
    } }), Object.defineProperty(o, "utf8ToBytes", { enumerable: !0, get: function() {
      return Vr.utf8ToBytes;
    } });
    function Ur(Sr) {
      return (0, o.bytesToBigInt)((0, o.hexToBytes)((0, t.isHexString)(Sr) ? Sr : `0x${Sr}`));
    }
    o.hexToBigInt = Ur;
  }(bytes$2)), bytes$2;
}
var hasRequiredConstants$4;
function requireConstants$4() {
  return hasRequiredConstants$4 || (hasRequiredConstants$4 = 1, function(o) {
    Object.defineProperty(o, "__esModule", { value: !0 }), o.BIGINT_2EXP256 = o.BIGINT_2EXP224 = o.BIGINT_2EXP160 = o.BIGINT_2EXP96 = o.BIGINT_224 = o.BIGINT_160 = o.BIGINT_100 = o.BIGINT_96 = o.BIGINT_256 = o.BIGINT_255 = o.BIGINT_128 = o.BIGINT_64 = o.BIGINT_32 = o.BIGINT_31 = o.BIGINT_28 = o.BIGINT_27 = o.BIGINT_8 = o.BIGINT_7 = o.BIGINT_3 = o.BIGINT_2 = o.BIGINT_1 = o.BIGINT_0 = o.BIGINT_NEG1 = o.RIPEMD160_ADDRESS_STRING = o.MAX_WITHDRAWALS_PER_PAYLOAD = o.RLP_EMPTY_STRING = o.KECCAK256_RLP = o.KECCAK256_RLP_S = o.KECCAK256_RLP_ARRAY = o.KECCAK256_RLP_ARRAY_S = o.KECCAK256_NULL = o.KECCAK256_NULL_S = o.TWO_POW256 = o.SECP256K1_ORDER_DIV_2 = o.SECP256K1_ORDER = o.MAX_INTEGER_BIGINT = o.MAX_INTEGER = o.MAX_UINT64 = void 0;
    const g = /* @__PURE__ */ requireSecp256k1$2(), c = requireBytes$1();
    o.MAX_UINT64 = BigInt("0xffffffffffffffff"), o.MAX_INTEGER = BigInt("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff"), o.MAX_INTEGER_BIGINT = BigInt("115792089237316195423570985008687907853269984665640564039457584007913129639935"), o.SECP256K1_ORDER = g.secp256k1.CURVE.n, o.SECP256K1_ORDER_DIV_2 = g.secp256k1.CURVE.n / BigInt(2), o.TWO_POW256 = BigInt("0x10000000000000000000000000000000000000000000000000000000000000000"), o.KECCAK256_NULL_S = "0xc5d2460186f7233c927e7db2dcc703c0e500b653ca82273b7bfad8045d85a470", o.KECCAK256_NULL = (0, c.hexToBytes)(o.KECCAK256_NULL_S), o.KECCAK256_RLP_ARRAY_S = "0x1dcc4de8dec75d7aab85b567b6ccd41ad312451b948a7413f0a142fd40d49347", o.KECCAK256_RLP_ARRAY = (0, c.hexToBytes)(o.KECCAK256_RLP_ARRAY_S), o.KECCAK256_RLP_S = "0x56e81f171bcc55a6ff8345e692c0f86e5b48e01b996cadc001622fb5e363b421", o.KECCAK256_RLP = (0, c.hexToBytes)(o.KECCAK256_RLP_S), o.RLP_EMPTY_STRING = Uint8Array.from([128]), o.MAX_WITHDRAWALS_PER_PAYLOAD = 16, o.RIPEMD160_ADDRESS_STRING = "0000000000000000000000000000000000000003", o.BIGINT_NEG1 = BigInt(-1), o.BIGINT_0 = BigInt(0), o.BIGINT_1 = BigInt(1), o.BIGINT_2 = BigInt(2), o.BIGINT_3 = BigInt(3), o.BIGINT_7 = BigInt(7), o.BIGINT_8 = BigInt(8), o.BIGINT_27 = BigInt(27), o.BIGINT_28 = BigInt(28), o.BIGINT_31 = BigInt(31), o.BIGINT_32 = BigInt(32), o.BIGINT_64 = BigInt(64), o.BIGINT_128 = BigInt(128), o.BIGINT_255 = BigInt(255), o.BIGINT_256 = BigInt(256), o.BIGINT_96 = BigInt(96), o.BIGINT_100 = BigInt(100), o.BIGINT_160 = BigInt(160), o.BIGINT_224 = BigInt(224), o.BIGINT_2EXP96 = BigInt(7922816251426434e13), o.BIGINT_2EXP160 = BigInt(1461501637330903e33), o.BIGINT_2EXP224 = BigInt(2695994666715064e52), o.BIGINT_2EXP256 = o.BIGINT_2 ** o.BIGINT_256;
  }(constants$4)), constants$4;
}
var units = {}, hasRequiredUnits;
function requireUnits() {
  if (hasRequiredUnits) return units;
  hasRequiredUnits = 1, Object.defineProperty(units, "__esModule", { value: !0 }), units.formatBigDecimal = units.GWEI_TO_WEI = void 0;
  const o = requireConstants$4();
  units.GWEI_TO_WEI = BigInt(1e9);
  function g(c, y, t) {
    y === o.BIGINT_0 && (y = o.BIGINT_1);
    const d = c / y, E = (c - d * y) * t / y, B = String(t).length - 1 - String(E).length;
    return `${d}.${"0".repeat(B)}${E}`;
  }
  return units.formatBigDecimal = g, units;
}
var account$2 = {}, cjs$4 = {}, hasRequiredCjs$5;
function requireCjs$5() {
  if (hasRequiredCjs$5) return cjs$4;
  hasRequiredCjs$5 = 1, Object.defineProperty(cjs$4, "__esModule", { value: !0 }), cjs$4.RLP = cjs$4.utils = cjs$4.decode = cjs$4.encode = void 0;
  function o(ge) {
    if (Array.isArray(ge)) {
      const Ee = [];
      let Se = 0;
      for (let ze = 0; ze < ge.length; ze++) {
        const He = o(ge[ze]);
        Ee.push(He), Se += He.length;
      }
      return v(y(Se, 192), ...Ee);
    }
    const Ie = fe(ge);
    return Ie.length === 1 && Ie[0] < 128 ? Ie : v(y(Ie.length, 128), Ie);
  }
  cjs$4.encode = o;
  function g(ge, Ie, Ee) {
    if (Ee > ge.length)
      throw new Error("invalid RLP (safeSlice): end slice of Uint8Array out-of-bounds");
    return ge.slice(Ie, Ee);
  }
  function c(ge) {
    if (ge[0] === 0)
      throw new Error("invalid RLP: extra zeros");
    return D(B(ge));
  }
  function y(ge, Ie) {
    if (ge < 56)
      return Uint8Array.from([ge + Ie]);
    const Ee = M(ge), Se = Ee.length / 2, ze = M(Ie + 55 + Se);
    return Uint8Array.from(x(ze + Ee));
  }
  function t(ge, Ie = !1) {
    if (typeof ge > "u" || ge === null || ge.length === 0)
      return Uint8Array.from([]);
    const Ee = fe(ge), Se = d(Ee);
    if (Ie)
      return {
        data: Se.data,
        remainder: Se.remainder.slice()
      };
    if (Se.remainder.length !== 0)
      throw new Error("invalid RLP: remainder must be zero");
    return Se.data;
  }
  cjs$4.decode = t;
  function d(ge) {
    let Ie, Ee, Se, ze, He;
    const Pe = [], De = ge[0];
    if (De <= 127)
      return {
        data: ge.slice(0, 1),
        remainder: ge.subarray(1)
      };
    if (De <= 183) {
      if (Ie = De - 127, De === 128 ? Se = Uint8Array.from([]) : Se = g(ge, 1, Ie), Ie === 2 && Se[0] < 128)
        throw new Error("invalid RLP encoding: invalid prefix, single byte < 0x80 are not prefixed");
      return {
        data: Se,
        remainder: ge.subarray(Ie)
      };
    } else if (De <= 191) {
      if (Ee = De - 182, ge.length - 1 < Ee)
        throw new Error("invalid RLP: not enough bytes for string length");
      if (Ie = c(g(ge, 1, Ee)), Ie <= 55)
        throw new Error("invalid RLP: expected string length to be greater than 55");
      return Se = g(ge, Ee, Ie + Ee), {
        data: Se,
        remainder: ge.subarray(Ie + Ee)
      };
    } else if (De <= 247) {
      for (Ie = De - 191, ze = g(ge, 1, Ie); ze.length; )
        He = d(ze), Pe.push(He.data), ze = He.remainder;
      return {
        data: Pe,
        remainder: ge.subarray(Ie)
      };
    } else {
      if (Ee = De - 246, Ie = c(g(ge, 1, Ee)), Ie < 56)
        throw new Error("invalid RLP: encoded list too short");
      const ve = Ee + Ie;
      if (ve > ge.length)
        throw new Error("invalid RLP: total length is larger than the data");
      for (ze = g(ge, Ee, ve); ze.length; )
        He = d(ze), Pe.push(He.data), ze = He.remainder;
      return {
        data: Pe,
        remainder: ge.subarray(ve)
      };
    }
  }
  const E = Array.from({ length: 256 }, (ge, Ie) => Ie.toString(16).padStart(2, "0"));
  function B(ge) {
    let Ie = "";
    for (let Ee = 0; Ee < ge.length; Ee++)
      Ie += E[ge[Ee]];
    return Ie;
  }
  function D(ge) {
    const Ie = Number.parseInt(ge, 16);
    if (Number.isNaN(Ie))
      throw new Error("Invalid byte sequence");
    return Ie;
  }
  function x(ge) {
    if (typeof ge != "string")
      throw new TypeError("hexToBytes: expected string, got " + typeof ge);
    if (ge.length % 2)
      throw new Error("hexToBytes: received invalid unpadded hex");
    const Ie = new Uint8Array(ge.length / 2);
    for (let Ee = 0; Ee < Ie.length; Ee++) {
      const Se = Ee * 2;
      Ie[Ee] = D(ge.slice(Se, Se + 2));
    }
    return Ie;
  }
  function v(...ge) {
    if (ge.length === 1)
      return ge[0];
    const Ie = ge.reduce((Se, ze) => Se + ze.length, 0), Ee = new Uint8Array(Ie);
    for (let Se = 0, ze = 0; Se < ge.length; Se++) {
      const He = ge[Se];
      Ee.set(He, ze), ze += He.length;
    }
    return Ee;
  }
  function F(ge) {
    return new TextEncoder().encode(ge);
  }
  function M(ge) {
    if (ge < 0)
      throw new Error("Invalid integer as argument, must be unsigned!");
    const Ie = ge.toString(16);
    return Ie.length % 2 ? `0${Ie}` : Ie;
  }
  function U(ge) {
    return ge.length % 2 ? `0${ge}` : ge;
  }
  function L(ge) {
    return ge.length >= 2 && ge[0] === "0" && ge[1] === "x";
  }
  function H(ge) {
    return typeof ge != "string" ? ge : L(ge) ? ge.slice(2) : ge;
  }
  function fe(ge) {
    if (ge instanceof Uint8Array)
      return ge;
    if (typeof ge == "string")
      return L(ge) ? x(U(H(ge))) : F(ge);
    if (typeof ge == "number" || typeof ge == "bigint")
      return ge ? x(M(ge)) : Uint8Array.from([]);
    if (ge == null)
      return Uint8Array.from([]);
    throw new Error("toBytes: received unsupported type " + typeof ge);
  }
  return cjs$4.utils = {
    bytesToHex: B,
    concatBytes: v,
    hexToBytes: x,
    utf8ToBytes: F
  }, cjs$4.RLP = { encode: o, decode: t }, cjs$4;
}
var keccak$2 = {}, sha3$2 = {}, _u64 = {}, hasRequired_u64;
function require_u64() {
  if (hasRequired_u64) return _u64;
  hasRequired_u64 = 1, Object.defineProperty(_u64, "__esModule", { value: !0 }), _u64.add5L = _u64.add5H = _u64.add4H = _u64.add4L = _u64.add3H = _u64.add3L = _u64.add = _u64.rotlBL = _u64.rotlBH = _u64.rotlSL = _u64.rotlSH = _u64.rotr32L = _u64.rotr32H = _u64.rotrBL = _u64.rotrBH = _u64.rotrSL = _u64.rotrSH = _u64.shrSL = _u64.shrSH = _u64.toBig = _u64.split = _u64.fromBig = void 0;
  const o = /* @__PURE__ */ BigInt(2 ** 32 - 1), g = /* @__PURE__ */ BigInt(32);
  function c(ve, Fe = !1) {
    return Fe ? { h: Number(ve & o), l: Number(ve >> g & o) } : { h: Number(ve >> g & o) | 0, l: Number(ve & o) | 0 };
  }
  _u64.fromBig = c;
  function y(ve, Fe = !1) {
    let be = new Uint32Array(ve.length), Be = new Uint32Array(ve.length);
    for (let ke = 0; ke < ve.length; ke++) {
      const { h: xe, l: Ne } = c(ve[ke], Fe);
      [be[ke], Be[ke]] = [xe, Ne];
    }
    return [be, Be];
  }
  _u64.split = y;
  const t = (ve, Fe) => BigInt(ve >>> 0) << g | BigInt(Fe >>> 0);
  _u64.toBig = t;
  const d = (ve, Fe, be) => ve >>> be;
  _u64.shrSH = d;
  const E = (ve, Fe, be) => ve << 32 - be | Fe >>> be;
  _u64.shrSL = E;
  const B = (ve, Fe, be) => ve >>> be | Fe << 32 - be;
  _u64.rotrSH = B;
  const D = (ve, Fe, be) => ve << 32 - be | Fe >>> be;
  _u64.rotrSL = D;
  const x = (ve, Fe, be) => ve << 64 - be | Fe >>> be - 32;
  _u64.rotrBH = x;
  const v = (ve, Fe, be) => ve >>> be - 32 | Fe << 64 - be;
  _u64.rotrBL = v;
  const F = (ve, Fe) => Fe;
  _u64.rotr32H = F;
  const M = (ve, Fe) => ve;
  _u64.rotr32L = M;
  const U = (ve, Fe, be) => ve << be | Fe >>> 32 - be;
  _u64.rotlSH = U;
  const L = (ve, Fe, be) => Fe << be | ve >>> 32 - be;
  _u64.rotlSL = L;
  const H = (ve, Fe, be) => Fe << be - 32 | ve >>> 64 - be;
  _u64.rotlBH = H;
  const fe = (ve, Fe, be) => ve << be - 32 | Fe >>> 64 - be;
  _u64.rotlBL = fe;
  function ge(ve, Fe, be, Be) {
    const ke = (Fe >>> 0) + (Be >>> 0);
    return { h: ve + be + (ke / 2 ** 32 | 0) | 0, l: ke | 0 };
  }
  _u64.add = ge;
  const Ie = (ve, Fe, be) => (ve >>> 0) + (Fe >>> 0) + (be >>> 0);
  _u64.add3L = Ie;
  const Ee = (ve, Fe, be, Be) => Fe + be + Be + (ve / 2 ** 32 | 0) | 0;
  _u64.add3H = Ee;
  const Se = (ve, Fe, be, Be) => (ve >>> 0) + (Fe >>> 0) + (be >>> 0) + (Be >>> 0);
  _u64.add4L = Se;
  const ze = (ve, Fe, be, Be, ke) => Fe + be + Be + ke + (ve / 2 ** 32 | 0) | 0;
  _u64.add4H = ze;
  const He = (ve, Fe, be, Be, ke) => (ve >>> 0) + (Fe >>> 0) + (be >>> 0) + (Be >>> 0) + (ke >>> 0);
  _u64.add5L = He;
  const Pe = (ve, Fe, be, Be, ke, xe) => Fe + be + Be + ke + xe + (ve / 2 ** 32 | 0) | 0;
  _u64.add5H = Pe;
  const De = {
    fromBig: c,
    split: y,
    toBig: t,
    shrSH: d,
    shrSL: E,
    rotrSH: B,
    rotrSL: D,
    rotrBH: x,
    rotrBL: v,
    rotr32H: F,
    rotr32L: M,
    rotlSH: U,
    rotlSL: L,
    rotlBH: H,
    rotlBL: fe,
    add: ge,
    add3L: Ie,
    add3H: Ee,
    add4L: Se,
    add4H: ze,
    add5H: Pe,
    add5L: He
  };
  return _u64.default = De, _u64;
}
var hasRequiredSha3$1;
function requireSha3$1() {
  if (hasRequiredSha3$1) return sha3$2;
  hasRequiredSha3$1 = 1, Object.defineProperty(sha3$2, "__esModule", { value: !0 }), sha3$2.shake256 = sha3$2.shake128 = sha3$2.keccak_512 = sha3$2.keccak_384 = sha3$2.keccak_256 = sha3$2.keccak_224 = sha3$2.sha3_512 = sha3$2.sha3_384 = sha3$2.sha3_256 = sha3$2.sha3_224 = sha3$2.Keccak = sha3$2.keccakP = void 0;
  const o = /* @__PURE__ */ require_assert(), g = /* @__PURE__ */ require_u64(), c = /* @__PURE__ */ requireUtils$7(), y = [], t = [], d = [], E = /* @__PURE__ */ BigInt(0), B = /* @__PURE__ */ BigInt(1), D = /* @__PURE__ */ BigInt(2), x = /* @__PURE__ */ BigInt(7), v = /* @__PURE__ */ BigInt(256), F = /* @__PURE__ */ BigInt(113);
  for (let Se = 0, ze = B, He = 1, Pe = 0; Se < 24; Se++) {
    [He, Pe] = [Pe, (2 * He + 3 * Pe) % 5], y.push(2 * (5 * Pe + He)), t.push((Se + 1) * (Se + 2) / 2 % 64);
    let De = E;
    for (let ve = 0; ve < 7; ve++)
      ze = (ze << B ^ (ze >> x) * F) % v, ze & D && (De ^= B << (B << /* @__PURE__ */ BigInt(ve)) - B);
    d.push(De);
  }
  const [M, U] = /* @__PURE__ */ (0, g.split)(d, !0), L = (Se, ze, He) => He > 32 ? (0, g.rotlBH)(Se, ze, He) : (0, g.rotlSH)(Se, ze, He), H = (Se, ze, He) => He > 32 ? (0, g.rotlBL)(Se, ze, He) : (0, g.rotlSL)(Se, ze, He);
  function fe(Se, ze = 24) {
    const He = new Uint32Array(10);
    for (let Pe = 24 - ze; Pe < 24; Pe++) {
      for (let Fe = 0; Fe < 10; Fe++)
        He[Fe] = Se[Fe] ^ Se[Fe + 10] ^ Se[Fe + 20] ^ Se[Fe + 30] ^ Se[Fe + 40];
      for (let Fe = 0; Fe < 10; Fe += 2) {
        const be = (Fe + 8) % 10, Be = (Fe + 2) % 10, ke = He[Be], xe = He[Be + 1], Ne = L(ke, xe, 1) ^ He[be], Et = H(ke, xe, 1) ^ He[be + 1];
        for (let st = 0; st < 50; st += 10)
          Se[Fe + st] ^= Ne, Se[Fe + st + 1] ^= Et;
      }
      let De = Se[2], ve = Se[3];
      for (let Fe = 0; Fe < 24; Fe++) {
        const be = t[Fe], Be = L(De, ve, be), ke = H(De, ve, be), xe = y[Fe];
        De = Se[xe], ve = Se[xe + 1], Se[xe] = Be, Se[xe + 1] = ke;
      }
      for (let Fe = 0; Fe < 50; Fe += 10) {
        for (let be = 0; be < 10; be++)
          He[be] = Se[Fe + be];
        for (let be = 0; be < 10; be++)
          Se[Fe + be] ^= ~He[(be + 2) % 10] & He[(be + 4) % 10];
      }
      Se[0] ^= M[Pe], Se[1] ^= U[Pe];
    }
    He.fill(0);
  }
  sha3$2.keccakP = fe;
  class ge extends c.Hash {
    // NOTE: we accept arguments in bytes instead of bits here.
    constructor(ze, He, Pe, De = !1, ve = 24) {
      if (super(), this.blockLen = ze, this.suffix = He, this.outputLen = Pe, this.enableXOF = De, this.rounds = ve, this.pos = 0, this.posOut = 0, this.finished = !1, this.destroyed = !1, (0, o.number)(Pe), 0 >= this.blockLen || this.blockLen >= 200)
        throw new Error("Sha3 supports only keccak-f1600 function");
      this.state = new Uint8Array(200), this.state32 = (0, c.u32)(this.state);
    }
    keccak() {
      c.isLE || (0, c.byteSwap32)(this.state32), fe(this.state32, this.rounds), c.isLE || (0, c.byteSwap32)(this.state32), this.posOut = 0, this.pos = 0;
    }
    update(ze) {
      (0, o.exists)(this);
      const { blockLen: He, state: Pe } = this;
      ze = (0, c.toBytes)(ze);
      const De = ze.length;
      for (let ve = 0; ve < De; ) {
        const Fe = Math.min(He - this.pos, De - ve);
        for (let be = 0; be < Fe; be++)
          Pe[this.pos++] ^= ze[ve++];
        this.pos === He && this.keccak();
      }
      return this;
    }
    finish() {
      if (this.finished)
        return;
      this.finished = !0;
      const { state: ze, suffix: He, pos: Pe, blockLen: De } = this;
      ze[Pe] ^= He, (He & 128) !== 0 && Pe === De - 1 && this.keccak(), ze[De - 1] ^= 128, this.keccak();
    }
    writeInto(ze) {
      (0, o.exists)(this, !1), (0, o.bytes)(ze), this.finish();
      const He = this.state, { blockLen: Pe } = this;
      for (let De = 0, ve = ze.length; De < ve; ) {
        this.posOut >= Pe && this.keccak();
        const Fe = Math.min(Pe - this.posOut, ve - De);
        ze.set(He.subarray(this.posOut, this.posOut + Fe), De), this.posOut += Fe, De += Fe;
      }
      return ze;
    }
    xofInto(ze) {
      if (!this.enableXOF)
        throw new Error("XOF is not possible for this instance");
      return this.writeInto(ze);
    }
    xof(ze) {
      return (0, o.number)(ze), this.xofInto(new Uint8Array(ze));
    }
    digestInto(ze) {
      if ((0, o.output)(ze, this), this.finished)
        throw new Error("digest() was already called");
      return this.writeInto(ze), this.destroy(), ze;
    }
    digest() {
      return this.digestInto(new Uint8Array(this.outputLen));
    }
    destroy() {
      this.destroyed = !0, this.state.fill(0);
    }
    _cloneInto(ze) {
      const { blockLen: He, suffix: Pe, outputLen: De, rounds: ve, enableXOF: Fe } = this;
      return ze || (ze = new ge(He, Pe, De, Fe, ve)), ze.state32.set(this.state32), ze.pos = this.pos, ze.posOut = this.posOut, ze.finished = this.finished, ze.rounds = ve, ze.suffix = Pe, ze.outputLen = De, ze.enableXOF = Fe, ze.destroyed = this.destroyed, ze;
    }
  }
  sha3$2.Keccak = ge;
  const Ie = (Se, ze, He) => (0, c.wrapConstructor)(() => new ge(ze, Se, He));
  sha3$2.sha3_224 = Ie(6, 144, 224 / 8), sha3$2.sha3_256 = Ie(6, 136, 256 / 8), sha3$2.sha3_384 = Ie(6, 104, 384 / 8), sha3$2.sha3_512 = Ie(6, 72, 512 / 8), sha3$2.keccak_224 = Ie(1, 144, 224 / 8), sha3$2.keccak_256 = Ie(1, 136, 256 / 8), sha3$2.keccak_384 = Ie(1, 104, 384 / 8), sha3$2.keccak_512 = Ie(1, 72, 512 / 8);
  const Ee = (Se, ze, He) => (0, c.wrapXOFConstructorWithOpts)((Pe = {}) => new ge(ze, Se, Pe.dkLen === void 0 ? He : Pe.dkLen, !0));
  return sha3$2.shake128 = Ee(31, 168, 128 / 8), sha3$2.shake256 = Ee(31, 136, 256 / 8), sha3$2;
}
var hasRequiredKeccak$1;
function requireKeccak$1() {
  if (hasRequiredKeccak$1) return keccak$2;
  hasRequiredKeccak$1 = 1, Object.defineProperty(keccak$2, "__esModule", { value: !0 }), keccak$2.keccak512 = keccak$2.keccak384 = keccak$2.keccak256 = keccak$2.keccak224 = void 0;
  const o = /* @__PURE__ */ requireSha3$1(), g = /* @__PURE__ */ requireUtils$5();
  return keccak$2.keccak224 = (0, g.wrapHash)(o.keccak_224), keccak$2.keccak256 = (() => {
    const c = (0, g.wrapHash)(o.keccak_256);
    return c.create = o.keccak_256.create, c;
  })(), keccak$2.keccak384 = (0, g.wrapHash)(o.keccak_384), keccak$2.keccak512 = (0, g.wrapHash)(o.keccak_512), keccak$2;
}
var hasRequiredAccount$2;
function requireAccount$2() {
  return hasRequiredAccount$2 || (hasRequiredAccount$2 = 1, function(o) {
    Object.defineProperty(o, "__esModule", { value: !0 }), o.accountBodyToRLP = o.accountBodyToSlim = o.accountBodyFromSlim = o.isZeroAddress = o.zeroAddress = o.importPublic = o.privateToAddress = o.privateToPublic = o.publicToAddress = o.pubToAddress = o.isValidPublic = o.isValidPrivate = o.generateAddress2 = o.generateAddress = o.isValidChecksumAddress = o.toChecksumAddress = o.isValidAddress = o.Account = void 0;
    const g = requireCjs$5(), c = /* @__PURE__ */ requireKeccak$1(), y = /* @__PURE__ */ requireSecp256k1$2(), t = requireBytes$1(), d = requireConstants$4(), E = requireHelpers(), B = requireInternal();
    class D {
      /**
       * This constructor assigns and validates the values.
       * Use the static factory methods to assist in creating an Account from varying data types.
       * undefined get assigned with the defaults present, but null args are retained as is
       */
      constructor(be = d.BIGINT_0, Be = d.BIGINT_0, ke = d.KECCAK256_RLP, xe = d.KECCAK256_NULL, Ne = null, Et = 0) {
        this._nonce = null, this._balance = null, this._storageRoot = null, this._codeHash = null, this._codeSize = null, this._version = null, this._nonce = be, this._balance = Be, this._storageRoot = ke, this._codeHash = xe, Ne === null && xe !== null && !this.isContract() && (Ne = 0), this._codeSize = Ne, this._version = Et, this._validate();
      }
      get version() {
        if (this._version !== null)
          return this._version;
        throw Error(`version=${this._version} not loaded`);
      }
      set version(be) {
        this._version = be;
      }
      get nonce() {
        if (this._nonce !== null)
          return this._nonce;
        throw Error(`nonce=${this._nonce} not loaded`);
      }
      set nonce(be) {
        this._nonce = be;
      }
      get balance() {
        if (this._balance !== null)
          return this._balance;
        throw Error(`balance=${this._balance} not loaded`);
      }
      set balance(be) {
        this._balance = be;
      }
      get storageRoot() {
        if (this._storageRoot !== null)
          return this._storageRoot;
        throw Error(`storageRoot=${this._storageRoot} not loaded`);
      }
      set storageRoot(be) {
        this._storageRoot = be;
      }
      get codeHash() {
        if (this._codeHash !== null)
          return this._codeHash;
        throw Error(`codeHash=${this._codeHash} not loaded`);
      }
      set codeHash(be) {
        this._codeHash = be;
      }
      get codeSize() {
        if (this._codeSize !== null)
          return this._codeSize;
        throw Error(`codeHash=${this._codeSize} not loaded`);
      }
      set codeSize(be) {
        this._codeSize = be;
      }
      static fromAccountData(be) {
        const { nonce: Be, balance: ke, storageRoot: xe, codeHash: Ne } = be;
        if (Be === null || ke === null || xe === null || Ne === null)
          throw Error("Partial fields not supported in fromAccountData");
        return new D(Be !== void 0 ? (0, t.bytesToBigInt)((0, t.toBytes)(Be)) : void 0, ke !== void 0 ? (0, t.bytesToBigInt)((0, t.toBytes)(ke)) : void 0, xe !== void 0 ? (0, t.toBytes)(xe) : void 0, Ne !== void 0 ? (0, t.toBytes)(Ne) : void 0);
      }
      static fromPartialAccountData(be) {
        const { nonce: Be, balance: ke, storageRoot: xe, codeHash: Ne, codeSize: Et, version: st } = be;
        if (Be === null && ke === null && xe === null && Ne === null && Et === null && st === null)
          throw Error("All partial fields null");
        return new D(Be != null ? (0, t.bytesToBigInt)((0, t.toBytes)(Be)) : Be, ke != null ? (0, t.bytesToBigInt)((0, t.toBytes)(ke)) : ke, xe != null ? (0, t.toBytes)(xe) : xe, Ne != null ? (0, t.toBytes)(Ne) : Ne, Et != null ? (0, t.bytesToInt)((0, t.toBytes)(Et)) : Et, st != null ? (0, t.bytesToInt)((0, t.toBytes)(st)) : st);
      }
      static fromRlpSerializedAccount(be) {
        const Be = g.RLP.decode(be);
        if (!Array.isArray(Be))
          throw new Error("Invalid serialized account input. Must be array");
        return this.fromValuesArray(Be);
      }
      static fromRlpSerializedPartialAccount(be) {
        const Be = g.RLP.decode(be);
        if (!Array.isArray(Be))
          throw new Error("Invalid serialized account input. Must be array");
        let ke = null;
        if (Array.isArray(Be[0])) {
          const er = (0, t.bytesToInt)(Be[0][0]);
          if (er !== 0 && er !== 1)
            throw new Error(`Invalid isNullIndicator=${er} for nonce`);
          er === 1 && (ke = (0, t.bytesToBigInt)(Be[0][1]));
        } else
          throw new Error("Invalid partial nonce encoding. Must be array");
        let xe = null;
        if (Array.isArray(Be[1])) {
          const er = (0, t.bytesToInt)(Be[1][0]);
          if (er !== 0 && er !== 1)
            throw new Error(`Invalid isNullIndicator=${er} for balance`);
          er === 1 && (xe = (0, t.bytesToBigInt)(Be[1][1]));
        } else
          throw new Error("Invalid partial balance encoding. Must be array");
        let Ne = null;
        if (Array.isArray(Be[2])) {
          const er = (0, t.bytesToInt)(Be[2][0]);
          if (er !== 0 && er !== 1)
            throw new Error(`Invalid isNullIndicator=${er} for storageRoot`);
          er === 1 && (Ne = Be[2][1]);
        } else
          throw new Error("Invalid partial storageRoot encoding. Must be array");
        let Et = null;
        if (Array.isArray(Be[3])) {
          const er = (0, t.bytesToInt)(Be[3][0]);
          if (er !== 0 && er !== 1)
            throw new Error(`Invalid isNullIndicator=${er} for codeHash`);
          er === 1 && (Et = Be[3][1]);
        } else
          throw new Error("Invalid partial codeHash encoding. Must be array");
        let st = null;
        if (Array.isArray(Be[4])) {
          const er = (0, t.bytesToInt)(Be[4][0]);
          if (er !== 0 && er !== 1)
            throw new Error(`Invalid isNullIndicator=${er} for codeSize`);
          er === 1 && (st = (0, t.bytesToInt)(Be[4][1]));
        } else
          throw new Error("Invalid partial codeSize encoding. Must be array");
        let Dt = null;
        if (Array.isArray(Be[5])) {
          const er = (0, t.bytesToInt)(Be[5][0]);
          if (er !== 0 && er !== 1)
            throw new Error(`Invalid isNullIndicator=${er} for version`);
          er === 1 && (Dt = (0, t.bytesToInt)(Be[5][1]));
        } else
          throw new Error("Invalid partial version encoding. Must be array");
        return this.fromPartialAccountData({ balance: xe, nonce: ke, storageRoot: Ne, codeHash: Et, codeSize: st, version: Dt });
      }
      static fromValuesArray(be) {
        const [Be, ke, xe, Ne] = be;
        return new D((0, t.bytesToBigInt)(Be), (0, t.bytesToBigInt)(ke), xe, Ne);
      }
      _validate() {
        if (this._nonce !== null && this._nonce < d.BIGINT_0)
          throw new Error("nonce must be greater than zero");
        if (this._balance !== null && this._balance < d.BIGINT_0)
          throw new Error("balance must be greater than zero");
        if (this._storageRoot !== null && this._storageRoot.length !== 32)
          throw new Error("storageRoot must have a length of 32");
        if (this._codeHash !== null && this._codeHash.length !== 32)
          throw new Error("codeHash must have a length of 32");
        if (this._codeSize !== null && this._codeSize < d.BIGINT_0)
          throw new Error("codeSize must be greater than zero");
      }
      /**
       * Returns an array of Uint8Arrays of the raw bytes for the account, in order.
       */
      raw() {
        return [
          (0, t.bigIntToUnpaddedBytes)(this.nonce),
          (0, t.bigIntToUnpaddedBytes)(this.balance),
          this.storageRoot,
          this.codeHash
        ];
      }
      /**
       * Returns the RLP serialization of the account as a `Uint8Array`.
       */
      serialize() {
        return g.RLP.encode(this.raw());
      }
      serializeWithPartialInfo() {
        const be = [], Be = (0, t.intToUnpaddedBytes)(0), ke = (0, t.intToUnpaddedBytes)(1);
        return this._nonce !== null ? be.push([ke, (0, t.bigIntToUnpaddedBytes)(this._nonce)]) : be.push([Be]), this._balance !== null ? be.push([ke, (0, t.bigIntToUnpaddedBytes)(this._balance)]) : be.push([Be]), this._storageRoot !== null ? be.push([ke, this._storageRoot]) : be.push([Be]), this._codeHash !== null ? be.push([ke, this._codeHash]) : be.push([Be]), this._codeSize !== null ? be.push([ke, (0, t.intToUnpaddedBytes)(this._codeSize)]) : be.push([Be]), this._version !== null ? be.push([ke, (0, t.intToUnpaddedBytes)(this._version)]) : be.push([Be]), g.RLP.encode(be);
      }
      /**
       * Returns a `Boolean` determining if the account is a contract.
       */
      isContract() {
        if (this._codeHash === null && this._codeSize === null)
          throw Error("Insufficient data as codeHash=null and codeSize=null");
        return this._codeHash !== null && !(0, t.equalsBytes)(this._codeHash, d.KECCAK256_NULL) || this._codeSize !== null && this._codeSize !== 0;
      }
      /**
       * Returns a `Boolean` determining if the account is empty complying to the definition of
       * account emptiness in [EIP-161](https://eips.ethereum.org/EIPS/eip-161):
       * "An account is considered empty when it has no code and zero nonce and zero balance."
       */
      isEmpty() {
        return this._balance !== null && this.balance !== d.BIGINT_0 || this._nonce === null && this.nonce !== d.BIGINT_0 || this._codeHash !== null && !(0, t.equalsBytes)(this.codeHash, d.KECCAK256_NULL) ? !1 : this.balance === d.BIGINT_0 && this.nonce === d.BIGINT_0 && (0, t.equalsBytes)(this.codeHash, d.KECCAK256_NULL);
      }
    }
    o.Account = D;
    const x = function(Fe) {
      try {
        (0, E.assertIsString)(Fe);
      } catch {
        return !1;
      }
      return /^0x[0-9a-fA-F]{40}$/.test(Fe);
    };
    o.isValidAddress = x;
    const v = function(Fe, be) {
      (0, E.assertIsHexString)(Fe);
      const Be = (0, B.stripHexPrefix)(Fe).toLowerCase();
      let ke = "";
      be !== void 0 && (ke = (0, t.bytesToBigInt)((0, t.toBytes)(be)).toString() + "0x");
      const xe = (0, t.utf8ToBytes)(ke + Be), Ne = (0, t.bytesToHex)((0, c.keccak256)(xe)).slice(2);
      let Et = "";
      for (let st = 0; st < Be.length; st++)
        parseInt(Ne[st], 16) >= 8 ? Et += Be[st].toUpperCase() : Et += Be[st];
      return `0x${Et}`;
    };
    o.toChecksumAddress = v;
    const F = function(Fe, be) {
      return (0, o.isValidAddress)(Fe) && (0, o.toChecksumAddress)(Fe, be) === Fe;
    };
    o.isValidChecksumAddress = F;
    const M = function(Fe, be) {
      return (0, E.assertIsBytes)(Fe), (0, E.assertIsBytes)(be), (0, t.bytesToBigInt)(be) === d.BIGINT_0 ? (0, c.keccak256)(g.RLP.encode([Fe, Uint8Array.from([])])).subarray(-20) : (0, c.keccak256)(g.RLP.encode([Fe, be])).subarray(-20);
    };
    o.generateAddress = M;
    const U = function(Fe, be, Be) {
      if ((0, E.assertIsBytes)(Fe), (0, E.assertIsBytes)(be), (0, E.assertIsBytes)(Be), Fe.length !== 20)
        throw new Error("Expected from to be of length 20");
      if (be.length !== 32)
        throw new Error("Expected salt to be of length 32");
      return (0, c.keccak256)((0, t.concatBytes)((0, t.hexToBytes)("0xff"), Fe, be, (0, c.keccak256)(Be))).subarray(-20);
    };
    o.generateAddress2 = U;
    const L = function(Fe) {
      return y.secp256k1.utils.isValidPrivateKey(Fe);
    };
    o.isValidPrivate = L;
    const H = function(Fe, be = !1) {
      if ((0, E.assertIsBytes)(Fe), Fe.length === 64)
        try {
          return y.secp256k1.ProjectivePoint.fromHex((0, t.concatBytes)(Uint8Array.from([4]), Fe)), !0;
        } catch {
          return !1;
        }
      if (!be)
        return !1;
      try {
        return y.secp256k1.ProjectivePoint.fromHex(Fe), !0;
      } catch {
        return !1;
      }
    };
    o.isValidPublic = H;
    const fe = function(Fe, be = !1) {
      if ((0, E.assertIsBytes)(Fe), be && Fe.length !== 64 && (Fe = y.secp256k1.ProjectivePoint.fromHex(Fe).toRawBytes(!1).slice(1)), Fe.length !== 64)
        throw new Error("Expected pubKey to be of length 64");
      return (0, c.keccak256)(Fe).subarray(-20);
    };
    o.pubToAddress = fe, o.publicToAddress = o.pubToAddress;
    const ge = function(Fe) {
      return (0, E.assertIsBytes)(Fe), y.secp256k1.ProjectivePoint.fromPrivateKey(Fe).toRawBytes(!1).slice(1);
    };
    o.privateToPublic = ge;
    const Ie = function(Fe) {
      return (0, o.publicToAddress)((0, o.privateToPublic)(Fe));
    };
    o.privateToAddress = Ie;
    const Ee = function(Fe) {
      return (0, E.assertIsBytes)(Fe), Fe.length !== 64 && (Fe = y.secp256k1.ProjectivePoint.fromHex(Fe).toRawBytes(!1).slice(1)), Fe;
    };
    o.importPublic = Ee;
    const Se = function() {
      const be = (0, t.zeros)(20);
      return (0, t.bytesToHex)(be);
    };
    o.zeroAddress = Se;
    const ze = function(Fe) {
      try {
        (0, E.assertIsString)(Fe);
      } catch {
        return !1;
      }
      return (0, o.zeroAddress)() === Fe;
    };
    o.isZeroAddress = ze;
    function He(Fe) {
      const [be, Be, ke, xe] = Fe;
      return [
        be,
        Be,
        ke.length === 0 ? d.KECCAK256_RLP : ke,
        xe.length === 0 ? d.KECCAK256_NULL : xe
      ];
    }
    o.accountBodyFromSlim = He;
    const Pe = new Uint8Array(0);
    function De(Fe) {
      const [be, Be, ke, xe] = Fe;
      return [
        be,
        Be,
        (0, t.equalsBytes)(ke, d.KECCAK256_RLP) ? Pe : ke,
        (0, t.equalsBytes)(xe, d.KECCAK256_NULL) ? Pe : xe
      ];
    }
    o.accountBodyToSlim = De;
    function ve(Fe, be = !0) {
      const Be = be ? He(Fe) : Fe;
      return g.RLP.encode(Be);
    }
    o.accountBodyToRLP = ve;
  }(account$2)), account$2;
}
var address$1 = {}, hasRequiredAddress$1;
function requireAddress$1() {
  if (hasRequiredAddress$1) return address$1;
  hasRequiredAddress$1 = 1, Object.defineProperty(address$1, "__esModule", { value: !0 }), address$1.Address = void 0;
  const o = requireAccount$2(), g = requireBytes$1(), c = requireConstants$4();
  class y {
    constructor(d) {
      if (d.length !== 20)
        throw new Error("Invalid address length");
      this.bytes = d;
    }
    /**
     * Returns the zero address.
     */
    static zero() {
      return new y((0, g.zeros)(20));
    }
    /**
     * Returns an Address object from a hex-encoded string.
     * @param str - Hex-encoded address
     */
    static fromString(d) {
      if (!(0, o.isValidAddress)(d))
        throw new Error(`Invalid address input=${d}`);
      return new y((0, g.hexToBytes)(d));
    }
    /**
     * Returns an address for a given public key.
     * @param pubKey The two points of an uncompressed key
     */
    static fromPublicKey(d) {
      if (!(d instanceof Uint8Array))
        throw new Error("Public key should be Uint8Array");
      const E = (0, o.pubToAddress)(d);
      return new y(E);
    }
    /**
     * Returns an address for a given private key.
     * @param privateKey A private key must be 256 bits wide
     */
    static fromPrivateKey(d) {
      if (!(d instanceof Uint8Array))
        throw new Error("Private key should be Uint8Array");
      const E = (0, o.privateToAddress)(d);
      return new y(E);
    }
    /**
     * Generates an address for a newly created contract.
     * @param from The address which is creating this new address
     * @param nonce The nonce of the from account
     */
    static generate(d, E) {
      if (typeof E != "bigint")
        throw new Error("Expected nonce to be a bigint");
      return new y((0, o.generateAddress)(d.bytes, (0, g.bigIntToBytes)(E)));
    }
    /**
     * Generates an address for a contract created using CREATE2.
     * @param from The address which is creating this new address
     * @param salt A salt
     * @param initCode The init code of the contract being created
     */
    static generate2(d, E, B) {
      if (!(E instanceof Uint8Array))
        throw new Error("Expected salt to be a Uint8Array");
      if (!(B instanceof Uint8Array))
        throw new Error("Expected initCode to be a Uint8Array");
      return new y((0, o.generateAddress2)(d.bytes, E, B));
    }
    /**
     * Is address equal to another.
     */
    equals(d) {
      return (0, g.equalsBytes)(this.bytes, d.bytes);
    }
    /**
     * Is address zero.
     */
    isZero() {
      return this.equals(y.zero());
    }
    /**
     * True if address is in the address range defined
     * by EIP-1352
     */
    isPrecompileOrSystemAddress() {
      const d = (0, g.bytesToBigInt)(this.bytes), E = c.BIGINT_0, B = BigInt("0xffff");
      return d >= E && d <= B;
    }
    /**
     * Returns hex encoding of address.
     */
    toString() {
      return (0, g.bytesToHex)(this.bytes);
    }
    /**
     * Returns a new Uint8Array representation of address.
     */
    toBytes() {
      return new Uint8Array(this.bytes);
    }
  }
  return address$1.Address = y, address$1;
}
var db = {}, hasRequiredDb;
function requireDb() {
  return hasRequiredDb || (hasRequiredDb = 1, function(o) {
    Object.defineProperty(o, "__esModule", { value: !0 }), o.ValueEncoding = o.KeyEncoding = void 0, function(g) {
      g.String = "string", g.Bytes = "view", g.Number = "number";
    }(o.KeyEncoding || (o.KeyEncoding = {})), function(g) {
      g.String = "string", g.Bytes = "view", g.JSON = "json";
    }(o.ValueEncoding || (o.ValueEncoding = {}));
  }(db)), db;
}
var withdrawal = {}, types$6 = {}, hasRequiredTypes$6;
function requireTypes$6() {
  return hasRequiredTypes$6 || (hasRequiredTypes$6 = 1, function(o) {
    Object.defineProperty(o, "__esModule", { value: !0 }), o.toType = o.TypeOutput = o.isNestedUint8Array = void 0;
    const g = requireBytes$1(), c = requireInternal();
    function y(E) {
      if (!Array.isArray(E))
        return !1;
      for (const B of E)
        if (Array.isArray(B)) {
          if (!y(B))
            return !1;
        } else if (!(B instanceof Uint8Array))
          return !1;
      return !0;
    }
    o.isNestedUint8Array = y;
    var t;
    (function(E) {
      E[E.Number = 0] = "Number", E[E.BigInt = 1] = "BigInt", E[E.Uint8Array = 2] = "Uint8Array", E[E.PrefixedHexString = 3] = "PrefixedHexString";
    })(t = o.TypeOutput || (o.TypeOutput = {}));
    function d(E, B) {
      if (E === null)
        return null;
      if (E === void 0)
        return;
      if (typeof E == "string" && !(0, c.isHexString)(E))
        throw new Error(`A string must be provided with a 0x-prefix, given: ${E}`);
      if (typeof E == "number" && !Number.isSafeInteger(E))
        throw new Error("The provided number is greater than MAX_SAFE_INTEGER (please use an alternative input type)");
      const D = (0, g.toBytes)(E);
      switch (B) {
        case t.Uint8Array:
          return D;
        case t.BigInt:
          return (0, g.bytesToBigInt)(D);
        case t.Number: {
          const x = (0, g.bytesToBigInt)(D);
          if (x > BigInt(Number.MAX_SAFE_INTEGER))
            throw new Error("The provided number is greater than MAX_SAFE_INTEGER (please use an alternative output type)");
          return Number(x);
        }
        case t.PrefixedHexString:
          return (0, g.bytesToHex)(D);
        default:
          throw new Error("unknown outputType");
      }
    }
    o.toType = d;
  }(types$6)), types$6;
}
var hasRequiredWithdrawal;
function requireWithdrawal() {
  if (hasRequiredWithdrawal) return withdrawal;
  hasRequiredWithdrawal = 1, Object.defineProperty(withdrawal, "__esModule", { value: !0 }), withdrawal.Withdrawal = void 0;
  const o = requireAddress$1(), g = requireBytes$1(), c = requireConstants$4(), y = requireTypes$6();
  class t {
    /**
     * This constructor assigns and validates the values.
     * Use the static factory methods to assist in creating a Withdrawal object from varying data types.
     * Its amount is in Gwei to match CL representation and for eventual ssz withdrawalsRoot
     */
    constructor(E, B, D, x) {
      this.index = E, this.validatorIndex = B, this.address = D, this.amount = x;
    }
    static fromWithdrawalData(E) {
      const { index: B, validatorIndex: D, address: x, amount: v } = E, F = (0, y.toType)(B, y.TypeOutput.BigInt), M = (0, y.toType)(D, y.TypeOutput.BigInt), U = x instanceof o.Address ? x : new o.Address((0, g.toBytes)(x)), L = (0, y.toType)(v, y.TypeOutput.BigInt);
      return new t(F, M, U, L);
    }
    static fromValuesArray(E) {
      if (E.length !== 4)
        throw Error(`Invalid withdrawalArray length expected=4 actual=${E.length}`);
      const [B, D, x, v] = E;
      return t.fromWithdrawalData({ index: B, validatorIndex: D, address: x, amount: v });
    }
    /**
     * Convert a withdrawal to a buffer array
     * @param withdrawal the withdrawal to convert
     * @returns buffer array of the withdrawal
     */
    static toBytesArray(E) {
      const { index: B, validatorIndex: D, address: x, amount: v } = E, F = (0, y.toType)(B, y.TypeOutput.BigInt) === c.BIGINT_0 ? new Uint8Array() : (0, y.toType)(B, y.TypeOutput.Uint8Array), M = (0, y.toType)(D, y.TypeOutput.BigInt) === c.BIGINT_0 ? new Uint8Array() : (0, y.toType)(D, y.TypeOutput.Uint8Array), U = x instanceof o.Address ? x.bytes : (0, y.toType)(x, y.TypeOutput.Uint8Array), L = (0, y.toType)(v, y.TypeOutput.BigInt) === c.BIGINT_0 ? new Uint8Array() : (0, y.toType)(v, y.TypeOutput.Uint8Array);
      return [F, M, U, L];
    }
    raw() {
      return t.toBytesArray(this);
    }
    toValue() {
      return {
        index: this.index,
        validatorIndex: this.validatorIndex,
        address: this.address.bytes,
        amount: this.amount
      };
    }
    toJSON() {
      return {
        index: (0, g.bigIntToHex)(this.index),
        validatorIndex: (0, g.bigIntToHex)(this.validatorIndex),
        address: (0, g.bytesToHex)(this.address.bytes),
        amount: (0, g.bigIntToHex)(this.amount)
      };
    }
  }
  return withdrawal.Withdrawal = t, withdrawal;
}
var signature$1 = {}, hasRequiredSignature$1;
function requireSignature$1() {
  if (hasRequiredSignature$1) return signature$1;
  hasRequiredSignature$1 = 1, Object.defineProperty(signature$1, "__esModule", { value: !0 }), signature$1.hashPersonalMessage = signature$1.isValidSignature = signature$1.fromRpcSig = signature$1.toCompactSig = signature$1.toRpcSig = signature$1.ecrecover = signature$1.calculateSigRecovery = signature$1.ecsign = void 0;
  const o = /* @__PURE__ */ requireKeccak$1(), g = /* @__PURE__ */ requireSecp256k1$2(), c = requireBytes$1(), y = requireConstants$4(), t = requireHelpers();
  function d(L, H, fe) {
    const ge = g.secp256k1.sign(L, H), Ie = ge.toCompactRawBytes(), Ee = Ie.slice(0, 32), Se = Ie.slice(32, 64), ze = fe === void 0 ? BigInt(ge.recovery + 27) : BigInt(ge.recovery + 35) + BigInt(fe) * y.BIGINT_2;
    return { r: Ee, s: Se, v: ze };
  }
  signature$1.ecsign = d;
  function E(L, H) {
    return L === y.BIGINT_0 || L === y.BIGINT_1 ? L : H === void 0 ? L - y.BIGINT_27 : L - (H * y.BIGINT_2 + BigInt(35));
  }
  signature$1.calculateSigRecovery = E;
  function B(L) {
    return L === y.BIGINT_0 || L === y.BIGINT_1;
  }
  const D = function(L, H, fe, ge, Ie) {
    const Ee = (0, c.concatBytes)((0, c.setLengthLeft)(fe, 32), (0, c.setLengthLeft)(ge, 32)), Se = E(H, Ie);
    if (!B(Se))
      throw new Error("Invalid signature v value");
    return g.secp256k1.Signature.fromCompact(Ee).addRecoveryBit(Number(Se)).recoverPublicKey(L).toRawBytes(!1).slice(1);
  };
  signature$1.ecrecover = D;
  const x = function(L, H, fe, ge) {
    const Ie = E(L, ge);
    if (!B(Ie))
      throw new Error("Invalid signature v value");
    return (0, c.bytesToHex)((0, c.concatBytes)((0, c.setLengthLeft)(H, 32), (0, c.setLengthLeft)(fe, 32), (0, c.toBytes)(L)));
  };
  signature$1.toRpcSig = x;
  const v = function(L, H, fe, ge) {
    const Ie = E(L, ge);
    if (!B(Ie))
      throw new Error("Invalid signature v value");
    const Ee = Uint8Array.from([...fe]);
    return (L > BigInt(28) && L % y.BIGINT_2 === y.BIGINT_1 || L === y.BIGINT_1 || L === BigInt(28)) && (Ee[0] |= 128), (0, c.bytesToHex)((0, c.concatBytes)((0, c.setLengthLeft)(H, 32), (0, c.setLengthLeft)(Ee, 32)));
  };
  signature$1.toCompactSig = v;
  const F = function(L) {
    const H = (0, c.toBytes)(L);
    let fe, ge, Ie;
    if (H.length >= 65)
      fe = H.subarray(0, 32), ge = H.subarray(32, 64), Ie = (0, c.bytesToBigInt)(H.subarray(64));
    else if (H.length === 64)
      fe = H.subarray(0, 32), ge = H.subarray(32, 64), Ie = BigInt((0, c.bytesToInt)(H.subarray(32, 33)) >> 7), ge[0] &= 127;
    else
      throw new Error("Invalid signature length");
    return Ie < 27 && (Ie = Ie + y.BIGINT_27), {
      v: Ie,
      r: fe,
      s: ge
    };
  };
  signature$1.fromRpcSig = F;
  const M = function(L, H, fe, ge = !0, Ie) {
    if (H.length !== 32 || fe.length !== 32 || !B(E(L, Ie)))
      return !1;
    const Ee = (0, c.bytesToBigInt)(H), Se = (0, c.bytesToBigInt)(fe);
    return !(Ee === y.BIGINT_0 || Ee >= y.SECP256K1_ORDER || Se === y.BIGINT_0 || Se >= y.SECP256K1_ORDER || ge && Se >= y.SECP256K1_ORDER_DIV_2);
  };
  signature$1.isValidSignature = M;
  const U = function(L) {
    (0, t.assertIsBytes)(L);
    const H = (0, c.utf8ToBytes)(`Ethereum Signed Message:
${L.length}`);
    return (0, o.keccak256)((0, c.concatBytes)(H, L));
  };
  return signature$1.hashPersonalMessage = U, signature$1;
}
var asyncEventEmitter = {}, hasRequiredAsyncEventEmitter;
function requireAsyncEventEmitter() {
  if (hasRequiredAsyncEventEmitter) return asyncEventEmitter;
  hasRequiredAsyncEventEmitter = 1, Object.defineProperty(asyncEventEmitter, "__esModule", { value: !0 }), asyncEventEmitter.AsyncEventEmitter = void 0;
  const o = requireEvents();
  async function g(y, t, d) {
    let E;
    for await (const B of t)
      try {
        B.length < 2 ? B.call(y, d) : await new Promise((D, x) => {
          B.call(y, d, (v) => {
            v ? x(v) : D();
          });
        });
      } catch (D) {
        E = D;
      }
    if (E)
      throw E;
  }
  class c extends o.EventEmitter {
    emit(t, ...d) {
      let [E, B] = d;
      const D = this;
      let x = D._events[t] ?? [];
      return B === void 0 && typeof E == "function" && (B = E, E = void 0), (t === "newListener" || t === "removeListener") && (E = {
        event: E,
        fn: B
      }, B = void 0), x = Array.isArray(x) ? x : [x], g(D, x.slice(), E).then(B).catch(B), D.listenerCount(t) > 0;
    }
    once(t, d) {
      const E = this;
      let B;
      if (typeof d != "function")
        throw new TypeError("listener must be a function");
      return d.length >= 2 ? B = function(D, x) {
        E.removeListener(t, B), d(D, x);
      } : B = function(D) {
        E.removeListener(t, B), d(D, B);
      }, E.on(t, B), E;
    }
    first(t, d) {
      let E = this._events[t] ?? [];
      if (typeof d != "function")
        throw new TypeError("listener must be a function");
      return Array.isArray(E) || (this._events[t] = E = [E]), E.unshift(d), this;
    }
    before(t, d, E) {
      return this.beforeOrAfter(t, d, E);
    }
    after(t, d, E) {
      return this.beforeOrAfter(t, d, E, "after");
    }
    beforeOrAfter(t, d, E, B) {
      let D = this._events[t] ?? [], x, v;
      const F = B === "after" ? 1 : 0;
      if (typeof E != "function")
        throw new TypeError("listener must be a function");
      if (typeof d != "function")
        throw new TypeError("target must be a function");
      for (Array.isArray(D) || (this._events[t] = D = [D]), v = D.length, x = D.length; x--; )
        if (D[x] === d) {
          v = x + F;
          break;
        }
      return D.splice(v, 0, E), this;
    }
    on(t, d) {
      return super.on(t, d);
    }
    addListener(t, d) {
      return super.addListener(t, d);
    }
    prependListener(t, d) {
      return super.prependListener(t, d);
    }
    prependOnceListener(t, d) {
      return super.prependOnceListener(t, d);
    }
    removeAllListeners(t) {
      return super.removeAllListeners(t);
    }
    removeListener(t, d) {
      return super.removeListener(t, d);
    }
    eventNames() {
      return super.eventNames();
    }
    listeners(t) {
      return super.listeners(t);
    }
    listenerCount(t) {
      return super.listenerCount(t);
    }
    getMaxListeners() {
      return super.getMaxListeners();
    }
    setMaxListeners(t) {
      return super.setMaxListeners(t);
    }
  }
  return asyncEventEmitter.AsyncEventEmitter = c, asyncEventEmitter;
}
var blobs = {}, sha256$5 = {}, hasRequiredSha256$2;
function requireSha256$2() {
  if (hasRequiredSha256$2) return sha256$5;
  hasRequiredSha256$2 = 1, Object.defineProperty(sha256$5, "__esModule", { value: !0 }), sha256$5.sha256 = void 0;
  const o = /* @__PURE__ */ requireSha256$3(), g = /* @__PURE__ */ requireUtils$5();
  return sha256$5.sha256 = (0, g.wrapHash)(o.sha256), sha256$5;
}
var hasRequiredBlobs;
function requireBlobs() {
  return hasRequiredBlobs || (hasRequiredBlobs = 1, function(o) {
    Object.defineProperty(o, "__esModule", { value: !0 }), o.commitmentsToVersionedHashes = o.computeVersionedHash = o.blobsToProofs = o.blobsToCommitments = o.getBlobs = void 0;
    const g = /* @__PURE__ */ requireSha256$2(), c = requireBytes$1(), y = 32, t = 4096, d = 32 * t, B = d * 2 - 1, D = y * t;
    function x(fe, ge) {
      const Ie = new Uint8Array(ge * d).fill(0);
      return Ie.set(fe), Ie[fe.byteLength] = 128, Ie;
    }
    function v(fe) {
      const ge = new Uint8Array(D);
      for (let Ie = 0; Ie < t; Ie++) {
        const Ee = new Uint8Array(32);
        Ee.set(fe.subarray(Ie * 31, (Ie + 1) * 31), 0), ge.set(Ee, Ie * 32);
      }
      return ge;
    }
    const F = (fe) => {
      const ge = (0, c.utf8ToBytes)(fe), Ie = ge.byteLength;
      if (Ie === 0)
        throw Error("invalid blob data");
      if (Ie > B)
        throw Error("blob data is too large");
      const Ee = Math.ceil(Ie / d), Se = x(ge, Ee), ze = [];
      for (let He = 0; He < Ee; He++) {
        const Pe = Se.subarray(He * d, (He + 1) * d), De = v(Pe);
        ze.push(De);
      }
      return ze;
    };
    o.getBlobs = F;
    const M = (fe, ge) => {
      const Ie = [];
      for (const Ee of ge)
        Ie.push(fe.blobToKzgCommitment(Ee));
      return Ie;
    };
    o.blobsToCommitments = M;
    const U = (fe, ge, Ie) => ge.map((Se, ze) => fe.computeBlobKzgProof(Se, Ie[ze]));
    o.blobsToProofs = U;
    const L = (fe, ge) => {
      const Ie = new Uint8Array(32);
      return Ie.set([ge], 0), Ie.set((0, g.sha256)(fe).subarray(1), 1), Ie;
    };
    o.computeVersionedHash = L;
    const H = (fe) => {
      const ge = [];
      for (const Ie of fe)
        ge.push((0, o.computeVersionedHash)(Ie, 1));
      return ge;
    };
    o.commitmentsToVersionedHashes = H;
  }(blobs)), blobs;
}
var genesis = {}, hasRequiredGenesis;
function requireGenesis() {
  if (hasRequiredGenesis) return genesis;
  hasRequiredGenesis = 1, Object.defineProperty(genesis, "__esModule", { value: !0 }), genesis.parseGethGenesisState = void 0;
  const o = requireBytes$1(), g = requireInternal();
  function c(y) {
    const t = {};
    for (const d of Object.keys(y.alloc)) {
      let { balance: E, code: B, storage: D, nonce: x } = y.alloc[d];
      const v = (0, o.addHexPrefix)(d.toLowerCase());
      E = (0, g.isHexString)(E) ? E : (0, o.bigIntToHex)(BigInt(E)), B = B !== void 0 ? (0, o.addHexPrefix)(B) : void 0, D = D !== void 0 ? Object.entries(D) : void 0, x = x !== void 0 ? (0, o.addHexPrefix)(x) : void 0, t[v] = [E, B, D, x];
    }
    return t;
  }
  return genesis.parseGethGenesisState = c, genesis;
}
var kzg = {}, hasRequiredKzg;
function requireKzg() {
  if (hasRequiredKzg) return kzg;
  hasRequiredKzg = 1, Object.defineProperty(kzg, "__esModule", { value: !0 }), kzg.initKZG = void 0;
  function o(g, c) {
    g.loadTrustedSetup();
  }
  return kzg.initKZG = o, kzg;
}
var lock = {}, hasRequiredLock;
function requireLock() {
  if (hasRequiredLock) return lock;
  hasRequiredLock = 1, Object.defineProperty(lock, "__esModule", { value: !0 }), lock.Lock = void 0;
  class o {
    constructor() {
      this.permits = 1, this.promiseResolverQueue = [];
    }
    /**
     * Returns a promise used to wait for a permit to become available. This method should be awaited on.
     * @returns  A promise that gets resolved when execution is allowed to proceed.
     */
    async acquire() {
      return this.permits > 0 ? (this.permits -= 1, Promise.resolve(!0)) : new Promise((c) => this.promiseResolverQueue.push(c));
    }
    /**
     * Increases the number of permits by one. If there are other functions waiting, one of them will
     * continue to execute in a future iteration of the event loop.
     */
    release() {
      if (this.permits += 1, this.permits > 1 && this.promiseResolverQueue.length > 0)
        console.warn("Lock.permits should never be > 0 when there is someone waiting.");
      else if (this.permits === 1 && this.promiseResolverQueue.length > 0) {
        this.permits -= 1;
        const c = this.promiseResolverQueue.shift();
        c && c(!0);
      }
    }
  }
  return lock.Lock = o, lock;
}
var mapDB = {}, hasRequiredMapDB;
function requireMapDB() {
  if (hasRequiredMapDB) return mapDB;
  hasRequiredMapDB = 1, Object.defineProperty(mapDB, "__esModule", { value: !0 }), mapDB.MapDB = void 0;
  const o = requireBytes$1();
  class g {
    constructor(y) {
      this._database = y ?? /* @__PURE__ */ new Map();
    }
    async get(y) {
      const t = y instanceof Uint8Array ? (0, o.bytesToUnprefixedHex)(y) : y.toString();
      return this._database.get(t);
    }
    async put(y, t) {
      const d = y instanceof Uint8Array ? (0, o.bytesToUnprefixedHex)(y) : y.toString();
      this._database.set(d, t);
    }
    async del(y) {
      const t = y instanceof Uint8Array ? (0, o.bytesToUnprefixedHex)(y) : y.toString();
      this._database.delete(t);
    }
    async batch(y) {
      for (const t of y)
        t.type === "del" && await this.del(t.key), t.type === "put" && await this.put(t.key, t.value);
    }
    /**
     * Note that the returned shallow copy will share the underlying database with the original
     *
     * @returns DB
     */
    shallowCopy() {
      return new g(this._database);
    }
    open() {
      return Promise.resolve();
    }
  }
  return mapDB.MapDB = g, mapDB;
}
var provider = {}, hasRequiredProvider;
function requireProvider() {
  if (hasRequiredProvider) return provider;
  hasRequiredProvider = 1, Object.defineProperty(provider, "__esModule", { value: !0 }), provider.getProvider = provider.fetchFromProvider = void 0;
  const o = async (c, y) => {
    const t = JSON.stringify({
      method: y.method,
      params: y.params,
      jsonrpc: "2.0",
      id: 1
    }), d = await fetch(c, {
      headers: {
        "content-type": "application/json"
      },
      method: "POST",
      body: t
    });
    if (!d.ok)
      throw new Error(`JSONRpcError: ${JSON.stringify({
        method: y.method,
        status: d.status,
        message: await d.text().catch(() => "Could not parse error message likely because of a network error")
      }, null, 2)}`);
    return (await d.json()).result;
  };
  provider.fetchFromProvider = o;
  const g = (c) => {
    if (typeof c == "string")
      return c;
    if (typeof c == "object" && c._getConnection !== void 0)
      return c._getConnection().url;
    throw new Error("Must provide valid provider URL or Web3Provider");
  };
  return provider.getProvider = g, provider;
}
var requests = {}, hasRequiredRequests;
function requireRequests() {
  return hasRequiredRequests || (hasRequiredRequests = 1, function(o) {
    Object.defineProperty(o, "__esModule", { value: !0 }), o.CLRequestFactory = o.ConsolidationRequest = o.WithdrawalRequest = o.DepositRequest = o.CLRequest = o.CLRequestType = void 0;
    const g = requireCjs$5(), c = /* @__PURE__ */ requireUtils$5(), y = requireBytes$1(), t = requireConstants$4();
    var d;
    (function(F) {
      F[F.Deposit = 0] = "Deposit", F[F.Withdrawal = 1] = "Withdrawal", F[F.Consolidation = 2] = "Consolidation";
    })(d = o.CLRequestType || (o.CLRequestType = {}));
    class E {
      constructor(M) {
        this.type = M;
      }
    }
    o.CLRequest = E;
    class B extends E {
      constructor(M, U, L, H, fe) {
        super(d.Deposit), this.pubkey = M, this.withdrawalCredentials = U, this.amount = L, this.signature = H, this.index = fe;
      }
      static fromRequestData(M) {
        const { pubkey: U, withdrawalCredentials: L, amount: H, signature: fe, index: ge } = M;
        return new B(U, L, H, fe, ge);
      }
      static fromJSON(M) {
        const { pubkey: U, withdrawalCredentials: L, amount: H, signature: fe, index: ge } = M;
        return this.fromRequestData({
          pubkey: (0, y.hexToBytes)(U),
          withdrawalCredentials: (0, y.hexToBytes)(L),
          amount: (0, y.hexToBigInt)(H),
          signature: (0, y.hexToBytes)(fe),
          index: (0, y.hexToBigInt)(ge)
        });
      }
      serialize() {
        const M = this.index === t.BIGINT_0 ? new Uint8Array() : (0, y.bigIntToBytes)(this.index), U = this.amount === t.BIGINT_0 ? new Uint8Array() : (0, y.bigIntToBytes)(this.amount);
        return (0, c.concatBytes)(Uint8Array.from([this.type]), g.RLP.encode([this.pubkey, this.withdrawalCredentials, U, this.signature, M]));
      }
      toJSON() {
        return {
          pubkey: (0, y.bytesToHex)(this.pubkey),
          withdrawalCredentials: (0, y.bytesToHex)(this.withdrawalCredentials),
          amount: (0, y.bigIntToHex)(this.amount),
          signature: (0, y.bytesToHex)(this.signature),
          index: (0, y.bigIntToHex)(this.index)
        };
      }
      static deserialize(M) {
        const [U, L, H, fe, ge] = g.RLP.decode(M.slice(1));
        return this.fromRequestData({
          pubkey: U,
          withdrawalCredentials: L,
          amount: (0, y.bytesToBigInt)(H),
          signature: fe,
          index: (0, y.bytesToBigInt)(ge)
        });
      }
    }
    o.DepositRequest = B;
    class D extends E {
      constructor(M, U, L) {
        super(d.Withdrawal), this.sourceAddress = M, this.validatorPubkey = U, this.amount = L;
      }
      static fromRequestData(M) {
        const { sourceAddress: U, validatorPubkey: L, amount: H } = M;
        return new D(U, L, H);
      }
      static fromJSON(M) {
        const { sourceAddress: U, validatorPubkey: L, amount: H } = M;
        return this.fromRequestData({
          sourceAddress: (0, y.hexToBytes)(U),
          validatorPubkey: (0, y.hexToBytes)(L),
          amount: (0, y.hexToBigInt)(H)
        });
      }
      serialize() {
        const M = this.amount === t.BIGINT_0 ? new Uint8Array() : (0, y.bigIntToBytes)(this.amount);
        return (0, c.concatBytes)(Uint8Array.from([this.type]), g.RLP.encode([this.sourceAddress, this.validatorPubkey, M]));
      }
      toJSON() {
        return {
          sourceAddress: (0, y.bytesToHex)(this.sourceAddress),
          validatorPubkey: (0, y.bytesToHex)(this.validatorPubkey),
          amount: (0, y.bigIntToHex)(this.amount)
        };
      }
      static deserialize(M) {
        const [U, L, H] = g.RLP.decode(M.slice(1));
        return this.fromRequestData({
          sourceAddress: U,
          validatorPubkey: L,
          amount: (0, y.bytesToBigInt)(H)
        });
      }
    }
    o.WithdrawalRequest = D;
    class x extends E {
      constructor(M, U, L) {
        super(d.Consolidation), this.sourceAddress = M, this.sourcePubkey = U, this.targetPubkey = L;
      }
      static fromRequestData(M) {
        const { sourceAddress: U, sourcePubkey: L, targetPubkey: H } = M;
        return new x(U, L, H);
      }
      static fromJSON(M) {
        const { sourceAddress: U, sourcePubkey: L, targetPubkey: H } = M;
        return this.fromRequestData({
          sourceAddress: (0, y.hexToBytes)(U),
          sourcePubkey: (0, y.hexToBytes)(L),
          targetPubkey: (0, y.hexToBytes)(H)
        });
      }
      serialize() {
        return (0, c.concatBytes)(Uint8Array.from([this.type]), g.RLP.encode([this.sourceAddress, this.sourcePubkey, this.targetPubkey]));
      }
      toJSON() {
        return {
          sourceAddress: (0, y.bytesToHex)(this.sourceAddress),
          sourcePubkey: (0, y.bytesToHex)(this.sourcePubkey),
          targetPubkey: (0, y.bytesToHex)(this.targetPubkey)
        };
      }
      static deserialize(M) {
        const [U, L, H] = g.RLP.decode(M.slice(1));
        return this.fromRequestData({
          sourceAddress: U,
          sourcePubkey: L,
          targetPubkey: H
        });
      }
    }
    o.ConsolidationRequest = x;
    class v {
      static fromSerializedRequest(M) {
        switch (M[0]) {
          case d.Deposit:
            return B.deserialize(M);
          case d.Withdrawal:
            return D.deserialize(M);
          case d.Consolidation:
            return x.deserialize(M);
          default:
            throw Error(`Invalid request type=${M[0]}`);
        }
      }
    }
    o.CLRequestFactory = v;
  }(requests)), requests;
}
var verkle = {}, hasRequiredVerkle;
function requireVerkle() {
  return hasRequiredVerkle || (hasRequiredVerkle = 1, function(o) {
    Object.defineProperty(o, "__esModule", { value: !0 }), o.getVerkleTreeKeyForStorageSlot = o.chunkifyCode = o.getVerkleTreeKeyForCodeChunk = o.getVerkleTreeIndicesForCodeChunk = o.getVerkleTreeIndexesForStorageSlot = o.getVerkleKey = o.VERKLE_MAIN_STORAGE_OFFSET = o.VERKLE_NODE_WIDTH = o.VERKLE_CODE_OFFSET = o.VERKLE_HEADER_STORAGE_OFFSET = o.VERKLE_CODE_SIZE_LEAF_KEY = o.VERKLE_CODE_HASH_LEAF_KEY = o.VERKLE_NONCE_LEAF_KEY = o.VERKLE_BALANCE_LEAF_KEY = o.VERKLE_VERSION_LEAF_KEY = o.VerkleLeafType = o.verifyVerkleProof = o.getVerkleStem = void 0;
    const g = requireBytes$1();
    function c(F, M, U = 0) {
      const L = (0, g.setLengthLeft)(M.toBytes(), 32);
      let H;
      return typeof U == "number" ? H = (0, g.setLengthRight)((0, g.int32ToBytes)(Number(U), !0), 32) : H = (0, g.setLengthRight)((0, g.bigIntToBytes)(BigInt(U), !0).slice(0, 32), 32), F.getTreeKey(L, H, 0).slice(0, 31);
    }
    o.getVerkleStem = c;
    function y(F, M, U) {
      return F.verifyExecutionWitnessPreState((0, g.bytesToHex)(M), JSON.stringify(U));
    }
    o.verifyVerkleProof = y;
    var t;
    (function(F) {
      F[F.Version = 0] = "Version", F[F.Balance = 1] = "Balance", F[F.Nonce = 2] = "Nonce", F[F.CodeHash = 3] = "CodeHash", F[F.CodeSize = 4] = "CodeSize";
    })(t = o.VerkleLeafType || (o.VerkleLeafType = {})), o.VERKLE_VERSION_LEAF_KEY = (0, g.intToBytes)(t.Version), o.VERKLE_BALANCE_LEAF_KEY = (0, g.intToBytes)(t.Balance), o.VERKLE_NONCE_LEAF_KEY = (0, g.intToBytes)(t.Nonce), o.VERKLE_CODE_HASH_LEAF_KEY = (0, g.intToBytes)(t.CodeHash), o.VERKLE_CODE_SIZE_LEAF_KEY = (0, g.intToBytes)(t.CodeSize), o.VERKLE_HEADER_STORAGE_OFFSET = 64, o.VERKLE_CODE_OFFSET = 128, o.VERKLE_NODE_WIDTH = 256, o.VERKLE_MAIN_STORAGE_OFFSET = BigInt(256) ** BigInt(31);
    const d = (F, M) => {
      switch (M) {
        case t.Version:
          return (0, g.concatBytes)(F, o.VERKLE_VERSION_LEAF_KEY);
        case t.Balance:
          return (0, g.concatBytes)(F, o.VERKLE_BALANCE_LEAF_KEY);
        case t.Nonce:
          return (0, g.concatBytes)(F, o.VERKLE_NONCE_LEAF_KEY);
        case t.CodeHash:
          return (0, g.concatBytes)(F, o.VERKLE_CODE_HASH_LEAF_KEY);
        case t.CodeSize:
          return (0, g.concatBytes)(F, o.VERKLE_CODE_SIZE_LEAF_KEY);
        default:
          return (0, g.concatBytes)(F, M);
      }
    };
    o.getVerkleKey = d;
    function E(F) {
      let M;
      F < o.VERKLE_CODE_OFFSET - o.VERKLE_HEADER_STORAGE_OFFSET ? M = BigInt(o.VERKLE_HEADER_STORAGE_OFFSET) + F : M = o.VERKLE_MAIN_STORAGE_OFFSET + F;
      const U = M / BigInt(o.VERKLE_NODE_WIDTH), L = Number(M % BigInt(o.VERKLE_NODE_WIDTH));
      return { treeIndex: U, subIndex: L };
    }
    o.getVerkleTreeIndexesForStorageSlot = E;
    function B(F) {
      const M = Math.floor((o.VERKLE_CODE_OFFSET + F) / o.VERKLE_NODE_WIDTH), U = (o.VERKLE_CODE_OFFSET + F) % o.VERKLE_NODE_WIDTH;
      return { treeIndex: M, subIndex: U };
    }
    o.getVerkleTreeIndicesForCodeChunk = B;
    const D = async (F, M, U) => {
      const { treeIndex: L, subIndex: H } = B(M);
      return (0, g.concatBytes)(c(U, F, L), (0, g.toBytes)(H));
    };
    o.getVerkleTreeKeyForCodeChunk = D;
    const x = (F) => {
      if (F.length % 31 !== 0) {
        const M = 31 - F.length % 31;
        F = (0, g.setLengthRight)(F, F.length + M);
      }
      throw new Error("Not implemented");
    };
    o.chunkifyCode = x;
    const v = async (F, M, U) => {
      const { treeIndex: L, subIndex: H } = E(M);
      return (0, g.concatBytes)(c(U, F, L), (0, g.toBytes)(H));
    };
    o.getVerkleTreeKeyForStorageSlot = v;
  }(verkle)), verkle;
}
var hasRequiredCjs$4;
function requireCjs$4() {
  return hasRequiredCjs$4 || (hasRequiredCjs$4 = 1, function(o) {
    var g = cjs$5 && cjs$5.__createBinding || (Object.create ? function(t, d, E, B) {
      B === void 0 && (B = E);
      var D = Object.getOwnPropertyDescriptor(d, E);
      (!D || ("get" in D ? !d.__esModule : D.writable || D.configurable)) && (D = { enumerable: !0, get: function() {
        return d[E];
      } }), Object.defineProperty(t, B, D);
    } : function(t, d, E, B) {
      B === void 0 && (B = E), t[B] = d[E];
    }), c = cjs$5 && cjs$5.__exportStar || function(t, d) {
      for (var E in t) E !== "default" && !Object.prototype.hasOwnProperty.call(d, E) && g(d, t, E);
    };
    Object.defineProperty(o, "__esModule", { value: !0 }), o.toAscii = o.stripHexPrefix = o.padToEven = o.isHexString = o.getKeys = o.getBinarySize = o.fromUtf8 = o.fromAscii = o.arrayContainsArray = void 0, c(requireConstants$4(), o), c(requireUnits(), o), c(requireAccount$2(), o), c(requireAddress$1(), o), c(requireDb(), o), c(requireWithdrawal(), o), c(requireSignature$1(), o), c(requireBytes$1(), o), c(requireTypes$6(), o), c(requireAsyncEventEmitter(), o), c(requireBlobs(), o), c(requireGenesis(), o);
    var y = requireInternal();
    Object.defineProperty(o, "arrayContainsArray", { enumerable: !0, get: function() {
      return y.arrayContainsArray;
    } }), Object.defineProperty(o, "fromAscii", { enumerable: !0, get: function() {
      return y.fromAscii;
    } }), Object.defineProperty(o, "fromUtf8", { enumerable: !0, get: function() {
      return y.fromUtf8;
    } }), Object.defineProperty(o, "getBinarySize", { enumerable: !0, get: function() {
      return y.getBinarySize;
    } }), Object.defineProperty(o, "getKeys", { enumerable: !0, get: function() {
      return y.getKeys;
    } }), Object.defineProperty(o, "isHexString", { enumerable: !0, get: function() {
      return y.isHexString;
    } }), Object.defineProperty(o, "padToEven", { enumerable: !0, get: function() {
      return y.padToEven;
    } }), Object.defineProperty(o, "stripHexPrefix", { enumerable: !0, get: function() {
      return y.stripHexPrefix;
    } }), Object.defineProperty(o, "toAscii", { enumerable: !0, get: function() {
      return y.toAscii;
    } }), c(requireKzg(), o), c(requireLock(), o), c(requireMapDB(), o), c(requireProvider(), o), c(requireRequests(), o), c(requireVerkle(), o);
  }(cjs$5)), cjs$5;
}
var hasRequiredBcUrRegistryEth_cjs_production_min;
function requireBcUrRegistryEth_cjs_production_min() {
  return hasRequiredBcUrRegistryEth_cjs_production_min || (hasRequiredBcUrRegistryEth_cjs_production_min = 1, function(o) {
    Object.defineProperty(o, "__esModule", { value: !0 });
    var g, c = requireDist$j(), y = require$$1$3, t = (g = requireHdkey()) && typeof g == "object" && "default" in g ? g.default : g, d = requireCjs$4();
    const E = { ETH_SIGN_REQUEST: new c.RegistryType("eth-sign-request", 401), ETH_SIGNATURE: new c.RegistryType("eth-signature", 402), ETH_NFT_ITEM: new c.RegistryType("eth-nft-item", 403), ETH_BATCH_SIGN_REQUEST: new c.RegistryType("eth-batch-sign-request", 40404), ETH_BATCH_SIGNATURE: new c.RegistryType("eth-batch-signature", 40405) }, { decodeToDataItem: B, RegistryTypes: D } = c.extend;
    var x, v;
    (function(Fe) {
      Fe[Fe.requestId = 1] = "requestId", Fe[Fe.signData = 2] = "signData", Fe[Fe.dataType = 3] = "dataType", Fe[Fe.chainId = 4] = "chainId", Fe[Fe.derivationPath = 5] = "derivationPath", Fe[Fe.address = 6] = "address", Fe[Fe.origin = 7] = "origin";
    })(x || (x = {})), (v = o.DataType || (o.DataType = {}))[v.transaction = 1] = "transaction", v[v.typedData = 2] = "typedData", v[v.personalMessage = 3] = "personalMessage", v[v.typedTransaction = 4] = "typedTransaction";
    class F extends c.RegistryItem {
      constructor(be) {
        super(), this.getRegistryType = () => E.ETH_SIGN_REQUEST, this.getRequestId = () => this.requestId, this.getSignData = () => this.signData, this.getDataType = () => this.dataType, this.getChainId = () => this.chainId, this.getDerivationPath = () => this.derivationPath.getPath(), this.getSourceFingerprint = () => this.derivationPath.getSourceFingerprint(), this.getSignRequestAddress = () => this.address, this.getOrigin = () => this.origin, this.toDataItem = () => {
          const Be = {};
          this.requestId && (Be[x.requestId] = new c.DataItem(this.requestId, D.UUID.getTag())), this.address && (Be[x.address] = this.address), this.chainId && (Be[x.chainId] = Number(this.chainId)), this.origin && (Be[x.origin] = this.origin), Be[x.signData] = this.signData, Be[x.dataType] = this.dataType;
          const ke = this.derivationPath.toDataItem();
          return ke.setTag(this.derivationPath.getRegistryType().getTag()), Be[x.derivationPath] = ke, new c.DataItem(Be);
        }, this.requestId = be.requestId, this.signData = be.signData, this.dataType = be.dataType, this.chainId = be.chainId, this.derivationPath = be.derivationPath, this.address = be.address, this.origin = be.origin;
      }
      static constructETHRequest(be, Be, ke, xe, Ne, Et, st, Dt) {
        const er = ke.replace(/[m|M]\//, "").split("/"), xt = new c.CryptoKeypath(er.map((ir) => {
          const sr = parseInt(ir.replace("'", ""));
          let yr = !1;
          return ir.endsWith("'") && (yr = !0), new c.PathComponent({ index: sr, hardened: yr });
        }), Buffer.from(xe, "hex"));
        return new F({ requestId: Ne ? Buffer.from(y.parse(Ne)) : void 0, signData: be, dataType: Be, derivationPath: xt, chainId: Et, address: st ? Buffer.from(st.replace("0x", ""), "hex") : void 0, origin: Dt || void 0 });
      }
    }
    F.fromDataItem = (Fe) => {
      const be = Fe.getData(), Be = be[x.signData], ke = be[x.dataType], xe = c.CryptoKeypath.fromDataItem(be[x.derivationPath]), Ne = be[x.chainId] ? be[x.chainId] : void 0, Et = be[x.address] ? be[x.address] : void 0, st = be[x.requestId] ? be[x.requestId].getData() : void 0;
      return new F({ requestId: st, signData: Be, dataType: ke, chainId: Ne, derivationPath: xe, address: Et, origin: be[x.origin] ? be[x.origin] : void 0 });
    }, F.fromCBOR = (Fe) => {
      const be = B(Fe);
      return F.fromDataItem(be);
    };
    const { RegistryTypes: M, decodeToDataItem: U } = c.extend;
    var L;
    (function(Fe) {
      Fe[Fe.requestId = 1] = "requestId", Fe[Fe.signature = 2] = "signature", Fe[Fe.origin = 3] = "origin";
    })(L || (L = {}));
    class H extends c.RegistryItem {
      constructor(be, Be, ke) {
        super(), this.getRegistryType = () => E.ETH_SIGNATURE, this.getRequestId = () => this.requestId, this.getSignature = () => this.signature, this.getOrigin = () => this.origin, this.toDataItem = () => {
          const xe = {};
          return this.requestId && (xe[L.requestId] = new c.DataItem(this.requestId, M.UUID.getTag())), this.origin && (xe[L.origin] = this.origin), xe[L.signature] = this.signature, new c.DataItem(xe);
        }, this.signature = be, this.requestId = Be, this.origin = ke;
      }
    }
    H.fromDataItem = (Fe) => {
      const be = Fe.getData(), Be = be[L.signature], ke = be[L.requestId] ? be[L.requestId].getData() : void 0;
      return new H(Be, ke, be[L.origin]);
    }, H.fromCBOR = (Fe) => {
      const be = U(Fe);
      return H.fromDataItem(be);
    };
    const { decodeToDataItem: fe } = c.extend;
    var ge;
    (function(Fe) {
      Fe[Fe.chainId = 1] = "chainId", Fe[Fe.contractAddress = 2] = "contractAddress", Fe[Fe.contractName = 3] = "contractName", Fe[Fe.name = 4] = "name", Fe[Fe.mediaData = 5] = "mediaData";
    })(ge || (ge = {}));
    class Ie extends c.RegistryItem {
      constructor(be) {
        super(), this.getRegistryType = () => E.ETH_NFT_ITEM, this.getChainId = () => this.chainId, this.getName = () => this.name, this.getmediaData = () => this.mediaData, this.getContractAddress = () => this.contractAddress, this.getContractName = () => this.contractName, this.toDataItem = () => {
          const Be = {};
          return Be[ge.chainId] = this.chainId, Be[ge.name] = this.name, Be[ge.contractAddress] = this.contractAddress, Be[ge.contractName] = this.contractName, Be[ge.mediaData] = this.mediaData, new c.DataItem(Be);
        }, this.chainId = be.chainId, this.name = be.name, this.contractAddress = be.contractAddress, this.contractName = be.contractName, this.mediaData = be.mediaData;
      }
      static constructETHNFTItem(be, Be, ke, xe, Ne) {
        return new Ie({ chainId: be, contractAddress: Be, contractName: ke, mediaData: Ne, name: xe });
      }
    }
    Ie.fromDataItem = (Fe) => {
      const be = Fe.getData();
      return new Ie({ chainId: be[ge.chainId], name: be[ge.name], contractAddress: be[ge.contractAddress], contractName: be[ge.contractName], mediaData: be[ge.mediaData] });
    }, Ie.fromCBOR = (Fe) => {
      const be = fe(Fe);
      return Ie.fromDataItem(be);
    };
    const { decodeToDataItem: Ee } = c.extend;
    var Se;
    (function(Fe) {
      Fe[Fe.requests = 1] = "requests";
    })(Se || (Se = {}));
    class ze extends c.RegistryItem {
      constructor(be) {
        super(), this.getRegistryType = () => E.ETH_BATCH_SIGN_REQUEST, this.getRequests = () => this.requests, this.toDataItem = () => {
          const Be = {};
          return this.requests && (Be[Se.requests] = this.requests.map((ke) => {
            const xe = ke.toDataItem();
            return xe.setTag(ke.getRegistryType().getTag()), xe;
          })), new c.DataItem(Be);
        }, this.requests = be;
      }
    }
    ze.fromDataItem = (Fe) => {
      const be = Fe.getData()[Se.requests].map((Be) => F.fromDataItem(Be));
      return new ze(be);
    }, ze.fromCBOR = (Fe) => {
      const be = Ee(Fe);
      return ze.fromDataItem(be);
    };
    const { decodeToDataItem: He } = c.extend;
    var Pe;
    (function(Fe) {
      Fe[Fe.signatures = 1] = "signatures";
    })(Pe || (Pe = {}));
    class De extends c.RegistryItem {
      constructor(be) {
        super(), this.getRegistryType = () => E.ETH_BATCH_SIGNATURE, this.getSignatures = () => this.signatures, this.toDataItem = () => {
          const Be = {};
          return this.signatures && (Be[Pe.signatures] = this.signatures.map((ke) => {
            const xe = ke.toDataItem();
            return xe.setTag(ke.getRegistryType().getTag()), xe;
          })), new c.DataItem(Be);
        }, this.signatures = be;
      }
    }
    De.fromDataItem = (Fe) => {
      const be = Fe.getData()[Pe.signatures].map((Be) => H.fromDataItem(Be));
      return new De(be);
    }, De.fromCBOR = (Fe) => {
      const be = He(Fe);
      return De.fromDataItem(be);
    };
    const ve = (Fe, be) => {
      const Be = t.fromExtendedKey(Fe).derive(be), ke = "0x" + Buffer.from(d.publicToAddress(Be.publicKey, !0)).toString("hex");
      return d.toChecksumAddress(ke);
    };
    c.patchTags(Object.values(E).filter((Fe) => !!Fe.getTag()).map((Fe) => Fe.getTag())), Object.keys(c).forEach(function(Fe) {
      Fe !== "default" && Object.defineProperty(o, Fe, { enumerable: !0, get: function() {
        return c[Fe];
      } });
    }), o.ETHBatchSignRequest = ze, o.ETHBatchSignature = De, o.ETHNFTItem = Ie, o.ETHSignature = H, o.EthSignRequest = F, o.findHDPathFromAddress = (Fe, be, Be, ke) => {
      for (let xe = 0; xe < Be; xe++) {
        const Ne = ve(be, "M/0/" + xe);
        if (Fe.toLowerCase() == Ne.toLowerCase()) return `${ke}/0/${xe}`;
      }
      return null;
    }, o.generateAddressFromXpub = ve;
  }(bcUrRegistryEth_cjs_production_min)), bcUrRegistryEth_cjs_production_min;
}
var bcUrRegistryEth_cjs_development = {}, hasRequiredBcUrRegistryEth_cjs_development;
function requireBcUrRegistryEth_cjs_development() {
  return hasRequiredBcUrRegistryEth_cjs_development || (hasRequiredBcUrRegistryEth_cjs_development = 1, function(o) {
    Object.defineProperty(o, "__esModule", { value: !0 });
    function g(Fe) {
      return Fe && typeof Fe == "object" && "default" in Fe ? Fe.default : Fe;
    }
    var c = requireDist$j(), y = require$$1$3, t = g(requireHdkey()), d = requireCjs$4();
    const E = {
      ETH_SIGN_REQUEST: /* @__PURE__ */ new c.RegistryType("eth-sign-request", 401),
      ETH_SIGNATURE: /* @__PURE__ */ new c.RegistryType("eth-signature", 402),
      ETH_NFT_ITEM: /* @__PURE__ */ new c.RegistryType("eth-nft-item", 403),
      ETH_BATCH_SIGN_REQUEST: /* @__PURE__ */ new c.RegistryType("eth-batch-sign-request", 40404),
      ETH_BATCH_SIGNATURE: /* @__PURE__ */ new c.RegistryType("eth-batch-signature", 40405)
    }, {
      decodeToDataItem: B,
      RegistryTypes: D
    } = c.extend;
    var x;
    (function(Fe) {
      Fe[Fe.requestId = 1] = "requestId", Fe[Fe.signData = 2] = "signData", Fe[Fe.dataType = 3] = "dataType", Fe[Fe.chainId = 4] = "chainId", Fe[Fe.derivationPath = 5] = "derivationPath", Fe[Fe.address = 6] = "address", Fe[Fe.origin = 7] = "origin";
    })(x || (x = {})), function(Fe) {
      Fe[Fe.transaction = 1] = "transaction", Fe[Fe.typedData = 2] = "typedData", Fe[Fe.personalMessage = 3] = "personalMessage", Fe[Fe.typedTransaction = 4] = "typedTransaction";
    }(o.DataType || (o.DataType = {}));
    class v extends c.RegistryItem {
      constructor(be) {
        super(), this.getRegistryType = () => E.ETH_SIGN_REQUEST, this.getRequestId = () => this.requestId, this.getSignData = () => this.signData, this.getDataType = () => this.dataType, this.getChainId = () => this.chainId, this.getDerivationPath = () => this.derivationPath.getPath(), this.getSourceFingerprint = () => this.derivationPath.getSourceFingerprint(), this.getSignRequestAddress = () => this.address, this.getOrigin = () => this.origin, this.toDataItem = () => {
          const Be = {};
          this.requestId && (Be[x.requestId] = new c.DataItem(this.requestId, D.UUID.getTag())), this.address && (Be[x.address] = this.address), this.chainId && (Be[x.chainId] = Number(this.chainId)), this.origin && (Be[x.origin] = this.origin), Be[x.signData] = this.signData, Be[x.dataType] = this.dataType;
          const ke = this.derivationPath.toDataItem();
          return ke.setTag(this.derivationPath.getRegistryType().getTag()), Be[x.derivationPath] = ke, new c.DataItem(Be);
        }, this.requestId = be.requestId, this.signData = be.signData, this.dataType = be.dataType, this.chainId = be.chainId, this.derivationPath = be.derivationPath, this.address = be.address, this.origin = be.origin;
      }
      static constructETHRequest(be, Be, ke, xe, Ne, Et, st, Dt) {
        const er = ke.replace(/[m|M]\//, "").split("/"), xt = new c.CryptoKeypath(er.map((ir) => {
          const sr = parseInt(ir.replace("'", ""));
          let yr = !1;
          return ir.endsWith("'") && (yr = !0), new c.PathComponent({
            index: sr,
            hardened: yr
          });
        }), Buffer.from(xe, "hex"));
        return new v({
          requestId: Ne ? Buffer.from(y.parse(Ne)) : void 0,
          signData: be,
          dataType: Be,
          derivationPath: xt,
          chainId: Et,
          address: st ? Buffer.from(st.replace("0x", ""), "hex") : void 0,
          origin: Dt || void 0
        });
      }
    }
    v.fromDataItem = (Fe) => {
      const be = Fe.getData(), Be = be[x.signData], ke = be[x.dataType], xe = c.CryptoKeypath.fromDataItem(be[x.derivationPath]), Ne = be[x.chainId] ? be[x.chainId] : void 0, Et = be[x.address] ? be[x.address] : void 0, st = be[x.requestId] ? be[x.requestId].getData() : void 0, Dt = be[x.origin] ? be[x.origin] : void 0;
      return new v({
        requestId: st,
        signData: Be,
        dataType: ke,
        chainId: Ne,
        derivationPath: xe,
        address: Et,
        origin: Dt
      });
    }, v.fromCBOR = (Fe) => {
      const be = B(Fe);
      return v.fromDataItem(be);
    };
    const {
      RegistryTypes: F,
      decodeToDataItem: M
    } = c.extend;
    var U;
    (function(Fe) {
      Fe[Fe.requestId = 1] = "requestId", Fe[Fe.signature = 2] = "signature", Fe[Fe.origin = 3] = "origin";
    })(U || (U = {}));
    class L extends c.RegistryItem {
      constructor(be, Be, ke) {
        super(), this.getRegistryType = () => E.ETH_SIGNATURE, this.getRequestId = () => this.requestId, this.getSignature = () => this.signature, this.getOrigin = () => this.origin, this.toDataItem = () => {
          const xe = {};
          return this.requestId && (xe[U.requestId] = new c.DataItem(this.requestId, F.UUID.getTag())), this.origin && (xe[U.origin] = this.origin), xe[U.signature] = this.signature, new c.DataItem(xe);
        }, this.signature = be, this.requestId = Be, this.origin = ke;
      }
    }
    L.fromDataItem = (Fe) => {
      const be = Fe.getData(), Be = be[U.signature], ke = be[U.requestId] ? be[U.requestId].getData() : void 0;
      return new L(Be, ke, be[U.origin]);
    }, L.fromCBOR = (Fe) => {
      const be = M(Fe);
      return L.fromDataItem(be);
    };
    const {
      decodeToDataItem: H
    } = c.extend;
    var fe;
    (function(Fe) {
      Fe[Fe.chainId = 1] = "chainId", Fe[Fe.contractAddress = 2] = "contractAddress", Fe[Fe.contractName = 3] = "contractName", Fe[Fe.name = 4] = "name", Fe[Fe.mediaData = 5] = "mediaData";
    })(fe || (fe = {}));
    class ge extends c.RegistryItem {
      constructor(be) {
        super(), this.getRegistryType = () => E.ETH_NFT_ITEM, this.getChainId = () => this.chainId, this.getName = () => this.name, this.getmediaData = () => this.mediaData, this.getContractAddress = () => this.contractAddress, this.getContractName = () => this.contractName, this.toDataItem = () => {
          const Be = {};
          return Be[fe.chainId] = this.chainId, Be[fe.name] = this.name, Be[fe.contractAddress] = this.contractAddress, Be[fe.contractName] = this.contractName, Be[fe.mediaData] = this.mediaData, new c.DataItem(Be);
        }, this.chainId = be.chainId, this.name = be.name, this.contractAddress = be.contractAddress, this.contractName = be.contractName, this.mediaData = be.mediaData;
      }
      static constructETHNFTItem(be, Be, ke, xe, Ne) {
        return new ge({
          chainId: be,
          contractAddress: Be,
          contractName: ke,
          mediaData: Ne,
          name: xe
        });
      }
    }
    ge.fromDataItem = (Fe) => {
      const be = Fe.getData(), Be = be[fe.chainId], ke = be[fe.name], xe = be[fe.mediaData], Ne = be[fe.contractAddress], Et = be[fe.contractName];
      return new ge({
        chainId: Be,
        name: ke,
        contractAddress: Ne,
        contractName: Et,
        mediaData: xe
      });
    }, ge.fromCBOR = (Fe) => {
      const be = H(Fe);
      return ge.fromDataItem(be);
    };
    const {
      decodeToDataItem: Ie
    } = c.extend;
    var Ee;
    (function(Fe) {
      Fe[Fe.requests = 1] = "requests";
    })(Ee || (Ee = {}));
    class Se extends c.RegistryItem {
      constructor(be) {
        super(), this.getRegistryType = () => E.ETH_BATCH_SIGN_REQUEST, this.getRequests = () => this.requests, this.toDataItem = () => {
          const Be = {};
          return this.requests && (Be[Ee.requests] = this.requests.map((ke) => {
            const xe = ke.toDataItem();
            return xe.setTag(ke.getRegistryType().getTag()), xe;
          })), new c.DataItem(Be);
        }, this.requests = be;
      }
    }
    Se.fromDataItem = (Fe) => {
      const Be = Fe.getData()[Ee.requests].map((ke) => v.fromDataItem(ke));
      return new Se(Be);
    }, Se.fromCBOR = (Fe) => {
      const be = Ie(Fe);
      return Se.fromDataItem(be);
    };
    const {
      decodeToDataItem: ze
    } = c.extend;
    var He;
    (function(Fe) {
      Fe[Fe.signatures = 1] = "signatures";
    })(He || (He = {}));
    class Pe extends c.RegistryItem {
      constructor(be) {
        super(), this.getRegistryType = () => E.ETH_BATCH_SIGNATURE, this.getSignatures = () => this.signatures, this.toDataItem = () => {
          const Be = {};
          return this.signatures && (Be[He.signatures] = this.signatures.map((ke) => {
            const xe = ke.toDataItem();
            return xe.setTag(ke.getRegistryType().getTag()), xe;
          })), new c.DataItem(Be);
        }, this.signatures = be;
      }
    }
    Pe.fromDataItem = (Fe) => {
      const Be = Fe.getData()[He.signatures].map((ke) => L.fromDataItem(ke));
      return new Pe(Be);
    }, Pe.fromCBOR = (Fe) => {
      const be = ze(Fe);
      return Pe.fromDataItem(be);
    };
    const De = (Fe, be) => {
      const ke = t.fromExtendedKey(Fe).derive(be), xe = "0x" + Buffer.from(d.publicToAddress(ke.publicKey, !0)).toString("hex");
      return d.toChecksumAddress(xe);
    }, ve = (Fe, be, Be, ke) => {
      for (let xe = 0; xe < Be; xe++) {
        const Ne = `M/0/${xe}`, Et = De(be, Ne);
        if (Fe.toLowerCase() == Et.toLowerCase())
          return `${ke}/0/${xe}`;
      }
      return null;
    };
    c.patchTags(Object.values(E).filter((Fe) => !!Fe.getTag()).map((Fe) => Fe.getTag())), Object.keys(c).forEach(function(Fe) {
      Fe !== "default" && Object.defineProperty(o, Fe, {
        enumerable: !0,
        get: function() {
          return c[Fe];
        }
      });
    }), o.ETHBatchSignRequest = Se, o.ETHBatchSignature = Pe, o.ETHNFTItem = ge, o.ETHSignature = L, o.EthSignRequest = v, o.findHDPathFromAddress = ve, o.generateAddressFromXpub = De;
  }(bcUrRegistryEth_cjs_development)), bcUrRegistryEth_cjs_development;
}
var hasRequiredDist$i;
function requireDist$i() {
  return hasRequiredDist$i || (hasRequiredDist$i = 1, process$1.env.NODE_ENV === "production" ? dist$i.exports = requireBcUrRegistryEth_cjs_production_min() : dist$i.exports = requireBcUrRegistryEth_cjs_development()), dist$i.exports;
}
var hasRequiredEthereum$2;
function requireEthereum$2() {
  if (hasRequiredEthereum$2) return ethereum$2;
  hasRequiredEthereum$2 = 1, Object.defineProperty(ethereum$2, "__esModule", { value: !0 }), ethereum$2.KeystoneEthereumSDK = void 0;
  const o = requireDist$i(), g = requireUtils$e(), c = requireUr();
  class y {
    constructor(d) {
      this.config = d;
    }
    parseSignature(d) {
      if (d.type !== c.URType.EthSignature)
        throw new Error("type not match");
      const E = o.ETHSignature.fromCBOR(d.cbor), B = E.getRequestId();
      return {
        requestId: B === void 0 ? void 0 : (0, g.uuidStringify)(B),
        signature: (0, g.toHex)(E.getSignature()),
        origin: E.getOrigin()
      };
    }
    generateSignRequest({ requestId: d, signData: E, dataType: B, path: D, xfp: x, chainId: v, address: F, origin: M }) {
      var U;
      return new o.EthSignRequest({
        requestId: (0, g.uuidParse)(d),
        signData: (0, g.toBuffer)(E),
        dataType: B,
        derivationPath: new o.CryptoKeypath((0, g.parsePath)(D).map((L) => new o.PathComponent(L)), (0, g.toBuffer)(x)),
        chainId: v,
        address: F !== void 0 ? (0, g.toBuffer)(F) : void 0,
        origin: M ?? ((U = this.config) === null || U === void 0 ? void 0 : U.origin)
      }).toUR();
    }
    generateBatchSignRequest({ requests: d }) {
      return new o.ETHBatchSignRequest(d).toUR();
    }
    parseBatchSignature(d) {
      if (d.type !== c.URType.EthBatchSignature)
        throw new Error("type not match");
      return o.ETHBatchSignature.fromCBOR(d.cbor).getSignatures().map((B) => {
        const D = B.getRequestId();
        return {
          requestId: D === void 0 ? void 0 : (0, g.uuidStringify)(D),
          signature: (0, g.toHex)(B.getSignature()),
          origin: B.getOrigin()
        };
      });
    }
  }
  return ethereum$2.KeystoneEthereumSDK = y, y.DataType = o.DataType, ethereum$2;
}
var solana = {}, dist$g = { exports: {} }, bcUrRegistrySol_cjs_production_min = {}, hasRequiredBcUrRegistrySol_cjs_production_min;
function requireBcUrRegistrySol_cjs_production_min() {
  return hasRequiredBcUrRegistrySol_cjs_production_min || (hasRequiredBcUrRegistrySol_cjs_production_min = 1, function(o) {
    Object.defineProperty(o, "__esModule", { value: !0 });
    var g = requireDist$j(), c = require$$1$3;
    const y = { SOL_SIGN_REQUEST: new g.RegistryType("sol-sign-request", 1101), SOL_SIGNATURE: new g.RegistryType("sol-signature", 1102), SOL_NFT_ITEM: new g.RegistryType("sol-nft-item", 1104) }, { decodeToDataItem: t, RegistryTypes: d } = g.extend;
    var E, B;
    (E = o.SignType || (o.SignType = {}))[E.Transaction = 1] = "Transaction", E[E.Message = 2] = "Message", function(fe) {
      fe[fe.requestId = 1] = "requestId", fe[fe.signData = 2] = "signData", fe[fe.derivationPath = 3] = "derivationPath", fe[fe.address = 4] = "address", fe[fe.origin = 5] = "origin", fe[fe.signType = 6] = "signType";
    }(B || (B = {}));
    class D extends g.RegistryItem {
      constructor(ge) {
        super(), this.getRegistryType = () => y.SOL_SIGN_REQUEST, this.getRequestId = () => this.requestId, this.getSignData = () => this.signData, this.getDerivationPath = () => this.derivationPath.getPath(), this.getSignRequestAddress = () => this.address, this.getOrigin = () => this.origin, this.getSignType = () => this.signType, this.toDataItem = () => {
          const Ie = {};
          this.requestId && (Ie[B.requestId] = new g.DataItem(this.requestId, d.UUID.getTag())), this.address && (Ie[B.address] = this.address), this.origin && (Ie[B.origin] = this.origin), Ie[B.signData] = this.signData, Ie[B.signType] = this.signType;
          const Ee = this.derivationPath.toDataItem();
          return Ee.setTag(this.derivationPath.getRegistryType().getTag()), Ie[B.derivationPath] = Ee, new g.DataItem(Ie);
        }, this.requestId = ge.requestId, this.signData = ge.signData, this.derivationPath = ge.derivationPath, this.address = ge.address, this.origin = ge.origin, this.signType = ge.signType;
      }
      static constructSOLRequest(ge, Ie, Ee, Se, ze, He, Pe) {
        const De = Ie.replace(/[m|M]\//, "").split("/"), ve = new g.CryptoKeypath(De.map((Fe) => {
          const be = parseInt(Fe.replace("'", ""));
          let Be = !1;
          return Fe.endsWith("'") && (Be = !0), new g.PathComponent({ index: be, hardened: Be });
        }), Buffer.from(Ee, "hex"));
        return new D({ requestId: ze ? Buffer.from(c.parse(ze)) : void 0, signData: ge, derivationPath: ve, address: He ? Buffer.from(He.replace("0x", ""), "hex") : void 0, origin: Pe || void 0, signType: Se });
      }
    }
    D.fromDataItem = (fe) => {
      const ge = fe.getData(), Ie = ge[B.signData], Ee = g.CryptoKeypath.fromDataItem(ge[B.derivationPath]), Se = ge[B.address] ? ge[B.address] : void 0, ze = ge[B.requestId] ? ge[B.requestId].getData() : void 0;
      return new D({ requestId: ze, signData: Ie, derivationPath: Ee, address: Se, origin: ge[B.origin] ? ge[B.origin] : void 0, signType: ge[B.signType] });
    }, D.fromCBOR = (fe) => {
      const ge = t(fe);
      return D.fromDataItem(ge);
    };
    const { RegistryTypes: x, decodeToDataItem: v } = g.extend;
    var F;
    (function(fe) {
      fe[fe.requestId = 1] = "requestId", fe[fe.signature = 2] = "signature";
    })(F || (F = {}));
    class M extends g.RegistryItem {
      constructor(ge, Ie) {
        super(), this.getRegistryType = () => y.SOL_SIGNATURE, this.getRequestId = () => this.requestId, this.getSignature = () => this.signature, this.toDataItem = () => {
          const Ee = {};
          return this.requestId && (Ee[F.requestId] = new g.DataItem(this.requestId, x.UUID.getTag())), Ee[F.signature] = this.signature, new g.DataItem(Ee);
        }, this.signature = ge, this.requestId = Ie;
      }
    }
    M.fromDataItem = (fe) => {
      const ge = fe.getData(), Ie = ge[F.signature], Ee = ge[F.requestId] ? ge[F.requestId].getData() : void 0;
      return new M(Ie, Ee);
    }, M.fromCBOR = (fe) => {
      const ge = v(fe);
      return M.fromDataItem(ge);
    };
    const { decodeToDataItem: U } = g.extend;
    var L;
    (function(fe) {
      fe[fe.mintAddress = 1] = "mintAddress", fe[fe.collectionName = 2] = "collectionName", fe[fe.name = 3] = "name", fe[fe.mediaData = 4] = "mediaData";
    })(L || (L = {}));
    class H extends g.RegistryItem {
      constructor(ge) {
        super(), this.getRegistryType = () => y.SOL_NFT_ITEM, this.getName = () => this.name, this.getMediaData = () => this.mediaData, this.getMintAddress = () => this.mintAddress, this.getCollectionName = () => this.collectionName, this.toDataItem = () => {
          const Ie = {};
          return Ie[L.name] = this.name, Ie[L.mintAddress] = this.mintAddress, Ie[L.collectionName] = this.collectionName, Ie[L.mediaData] = this.mediaData, new g.DataItem(Ie);
        }, this.name = ge.name, this.mintAddress = ge.mintAddress, this.collectionName = ge.collectionName, this.mediaData = ge.mediaData;
      }
      static constructETHNFTItem(ge, Ie, Ee, Se) {
        return new H({ mintAddress: ge, collectionName: Ie, mediaData: Se, name: Ee });
      }
    }
    H.fromDataItem = (fe) => {
      const ge = fe.getData();
      return new H({ name: ge[L.name], mintAddress: ge[L.mintAddress], collectionName: ge[L.collectionName], mediaData: ge[L.mediaData] });
    }, H.fromCBOR = (fe) => {
      const ge = U(fe);
      return H.fromDataItem(ge);
    }, g.patchTags(Object.values(y).filter((fe) => !!fe.getTag()).map((fe) => fe.getTag())), Object.keys(g).forEach(function(fe) {
      fe !== "default" && Object.defineProperty(o, fe, { enumerable: !0, get: function() {
        return g[fe];
      } });
    }), o.SOLNFTItem = H, o.SolSignRequest = D, o.SolSignature = M;
  }(bcUrRegistrySol_cjs_production_min)), bcUrRegistrySol_cjs_production_min;
}
var bcUrRegistrySol_cjs_development = {}, hasRequiredBcUrRegistrySol_cjs_development;
function requireBcUrRegistrySol_cjs_development() {
  return hasRequiredBcUrRegistrySol_cjs_development || (hasRequiredBcUrRegistrySol_cjs_development = 1, function(o) {
    Object.defineProperty(o, "__esModule", { value: !0 });
    var g = requireDist$j(), c = require$$1$3;
    const y = {
      SOL_SIGN_REQUEST: /* @__PURE__ */ new g.RegistryType("sol-sign-request", 1101),
      SOL_SIGNATURE: /* @__PURE__ */ new g.RegistryType("sol-signature", 1102),
      SOL_NFT_ITEM: /* @__PURE__ */ new g.RegistryType("sol-nft-item", 1104)
    }, {
      decodeToDataItem: t,
      RegistryTypes: d
    } = g.extend;
    (function(H) {
      H[H.Transaction = 1] = "Transaction", H[H.Message = 2] = "Message";
    })(o.SignType || (o.SignType = {}));
    var E;
    (function(H) {
      H[H.requestId = 1] = "requestId", H[H.signData = 2] = "signData", H[H.derivationPath = 3] = "derivationPath", H[H.address = 4] = "address", H[H.origin = 5] = "origin", H[H.signType = 6] = "signType";
    })(E || (E = {}));
    class B extends g.RegistryItem {
      constructor(fe) {
        super(), this.getRegistryType = () => y.SOL_SIGN_REQUEST, this.getRequestId = () => this.requestId, this.getSignData = () => this.signData, this.getDerivationPath = () => this.derivationPath.getPath(), this.getSignRequestAddress = () => this.address, this.getOrigin = () => this.origin, this.getSignType = () => this.signType, this.toDataItem = () => {
          const ge = {};
          this.requestId && (ge[E.requestId] = new g.DataItem(this.requestId, d.UUID.getTag())), this.address && (ge[E.address] = this.address), this.origin && (ge[E.origin] = this.origin), ge[E.signData] = this.signData, ge[E.signType] = this.signType;
          const Ie = this.derivationPath.toDataItem();
          return Ie.setTag(this.derivationPath.getRegistryType().getTag()), ge[E.derivationPath] = Ie, new g.DataItem(ge);
        }, this.requestId = fe.requestId, this.signData = fe.signData, this.derivationPath = fe.derivationPath, this.address = fe.address, this.origin = fe.origin, this.signType = fe.signType;
      }
      static constructSOLRequest(fe, ge, Ie, Ee, Se, ze, He) {
        const Pe = ge.replace(/[m|M]\//, "").split("/"), De = new g.CryptoKeypath(Pe.map((ve) => {
          const Fe = parseInt(ve.replace("'", ""));
          let be = !1;
          return ve.endsWith("'") && (be = !0), new g.PathComponent({
            index: Fe,
            hardened: be
          });
        }), Buffer.from(Ie, "hex"));
        return new B({
          requestId: Se ? Buffer.from(c.parse(Se)) : void 0,
          signData: fe,
          derivationPath: De,
          address: ze ? Buffer.from(ze.replace("0x", ""), "hex") : void 0,
          origin: He || void 0,
          signType: Ee
        });
      }
    }
    B.fromDataItem = (H) => {
      const fe = H.getData(), ge = fe[E.signData], Ie = g.CryptoKeypath.fromDataItem(fe[E.derivationPath]), Ee = fe[E.address] ? fe[E.address] : void 0, Se = fe[E.requestId] ? fe[E.requestId].getData() : void 0, ze = fe[E.origin] ? fe[E.origin] : void 0, He = fe[E.signType];
      return new B({
        requestId: Se,
        signData: ge,
        derivationPath: Ie,
        address: Ee,
        origin: ze,
        signType: He
      });
    }, B.fromCBOR = (H) => {
      const fe = t(H);
      return B.fromDataItem(fe);
    };
    const {
      RegistryTypes: D,
      decodeToDataItem: x
    } = g.extend;
    var v;
    (function(H) {
      H[H.requestId = 1] = "requestId", H[H.signature = 2] = "signature";
    })(v || (v = {}));
    class F extends g.RegistryItem {
      constructor(fe, ge) {
        super(), this.getRegistryType = () => y.SOL_SIGNATURE, this.getRequestId = () => this.requestId, this.getSignature = () => this.signature, this.toDataItem = () => {
          const Ie = {};
          return this.requestId && (Ie[v.requestId] = new g.DataItem(this.requestId, D.UUID.getTag())), Ie[v.signature] = this.signature, new g.DataItem(Ie);
        }, this.signature = fe, this.requestId = ge;
      }
    }
    F.fromDataItem = (H) => {
      const fe = H.getData(), ge = fe[v.signature], Ie = fe[v.requestId] ? fe[v.requestId].getData() : void 0;
      return new F(ge, Ie);
    }, F.fromCBOR = (H) => {
      const fe = x(H);
      return F.fromDataItem(fe);
    };
    const {
      decodeToDataItem: M
    } = g.extend;
    var U;
    (function(H) {
      H[H.mintAddress = 1] = "mintAddress", H[H.collectionName = 2] = "collectionName", H[H.name = 3] = "name", H[H.mediaData = 4] = "mediaData";
    })(U || (U = {}));
    class L extends g.RegistryItem {
      constructor(fe) {
        super(), this.getRegistryType = () => y.SOL_NFT_ITEM, this.getName = () => this.name, this.getMediaData = () => this.mediaData, this.getMintAddress = () => this.mintAddress, this.getCollectionName = () => this.collectionName, this.toDataItem = () => {
          const ge = {};
          return ge[U.name] = this.name, ge[U.mintAddress] = this.mintAddress, ge[U.collectionName] = this.collectionName, ge[U.mediaData] = this.mediaData, new g.DataItem(ge);
        }, this.name = fe.name, this.mintAddress = fe.mintAddress, this.collectionName = fe.collectionName, this.mediaData = fe.mediaData;
      }
      static constructETHNFTItem(fe, ge, Ie, Ee) {
        return new L({
          mintAddress: fe,
          collectionName: ge,
          mediaData: Ee,
          name: Ie
        });
      }
    }
    L.fromDataItem = (H) => {
      const fe = H.getData(), ge = fe[U.name], Ie = fe[U.mediaData], Ee = fe[U.mintAddress], Se = fe[U.collectionName];
      return new L({
        name: ge,
        mintAddress: Ee,
        collectionName: Se,
        mediaData: Ie
      });
    }, L.fromCBOR = (H) => {
      const fe = M(H);
      return L.fromDataItem(fe);
    }, g.patchTags(Object.values(y).filter((H) => !!H.getTag()).map((H) => H.getTag())), Object.keys(g).forEach(function(H) {
      H !== "default" && Object.defineProperty(o, H, {
        enumerable: !0,
        get: function() {
          return g[H];
        }
      });
    }), o.SOLNFTItem = L, o.SolSignRequest = B, o.SolSignature = F;
  }(bcUrRegistrySol_cjs_development)), bcUrRegistrySol_cjs_development;
}
var hasRequiredDist$h;
function requireDist$h() {
  return hasRequiredDist$h || (hasRequiredDist$h = 1, process$1.env.NODE_ENV === "production" ? dist$g.exports = requireBcUrRegistrySol_cjs_production_min() : dist$g.exports = requireBcUrRegistrySol_cjs_development()), dist$g.exports;
}
var hasRequiredSolana;
function requireSolana() {
  if (hasRequiredSolana) return solana;
  hasRequiredSolana = 1, Object.defineProperty(solana, "__esModule", { value: !0 }), solana.KeystoneSolanaSDK = void 0;
  const o = requireDist$h(), g = requireUtils$e(), c = requireUr();
  class y {
    parseSignature(d) {
      if (d.type !== c.URType.SolSignature)
        throw new Error("type not match");
      const E = o.SolSignature.fromCBOR(d.cbor), B = E.getRequestId();
      return {
        requestId: B === void 0 ? void 0 : (0, g.uuidStringify)(B),
        signature: (0, g.toHex)(E.getSignature())
      };
    }
    generateSignRequest({ requestId: d, signData: E, dataType: B, path: D, xfp: x, address: v, origin: F }) {
      return new o.SolSignRequest({
        requestId: (0, g.uuidParse)(d),
        signData: (0, g.toBuffer)(E),
        signType: B,
        derivationPath: new o.CryptoKeypath((0, g.parsePath)(D).map((M) => new o.PathComponent(M)), (0, g.toBuffer)(x)),
        address: v !== void 0 ? (0, g.toBuffer)(v) : void 0,
        origin: F
      }).toUR();
    }
  }
  return solana.KeystoneSolanaSDK = y, y.DataType = o.SignType, solana;
}
var tron = {}, transfer = {}, sha256$4 = {}, hasRequiredSha256$1;
function requireSha256$1() {
  if (hasRequiredSha256$1) return sha256$4;
  hasRequiredSha256$1 = 1, Object.defineProperty(sha256$4, "__esModule", { value: !0 }), sha256$4.sha224 = sha256$4.SHA224 = sha256$4.sha256 = sha256$4.SHA256 = void 0;
  const o = /* @__PURE__ */ requireSha2();
  return sha256$4.SHA256 = o.SHA256, sha256$4.sha256 = o.sha256, sha256$4.SHA224 = o.SHA224, sha256$4.sha224 = o.sha224, sha256$4;
}
var src$2, hasRequiredSrc$2;
function requireSrc$2() {
  if (hasRequiredSrc$2) return src$2;
  hasRequiredSrc$2 = 1;
  function o(g) {
    if (g.length >= 255)
      throw new TypeError("Alphabet too long");
    for (var c = new Uint8Array(256), y = 0; y < c.length; y++)
      c[y] = 255;
    for (var t = 0; t < g.length; t++) {
      var d = g.charAt(t), E = d.charCodeAt(0);
      if (c[E] !== 255)
        throw new TypeError(d + " is ambiguous");
      c[E] = t;
    }
    var B = g.length, D = g.charAt(0), x = Math.log(B) / Math.log(256), v = Math.log(256) / Math.log(B);
    function F(L) {
      if (L instanceof Uint8Array || (ArrayBuffer.isView(L) ? L = new Uint8Array(L.buffer, L.byteOffset, L.byteLength) : Array.isArray(L) && (L = Uint8Array.from(L))), !(L instanceof Uint8Array))
        throw new TypeError("Expected Uint8Array");
      if (L.length === 0)
        return "";
      for (var H = 0, fe = 0, ge = 0, Ie = L.length; ge !== Ie && L[ge] === 0; )
        ge++, H++;
      for (var Ee = (Ie - ge) * v + 1 >>> 0, Se = new Uint8Array(Ee); ge !== Ie; ) {
        for (var ze = L[ge], He = 0, Pe = Ee - 1; (ze !== 0 || He < fe) && Pe !== -1; Pe--, He++)
          ze += 256 * Se[Pe] >>> 0, Se[Pe] = ze % B >>> 0, ze = ze / B >>> 0;
        if (ze !== 0)
          throw new Error("Non-zero carry");
        fe = He, ge++;
      }
      for (var De = Ee - fe; De !== Ee && Se[De] === 0; )
        De++;
      for (var ve = D.repeat(H); De < Ee; ++De)
        ve += g.charAt(Se[De]);
      return ve;
    }
    function M(L) {
      if (typeof L != "string")
        throw new TypeError("Expected String");
      if (L.length === 0)
        return new Uint8Array();
      for (var H = 0, fe = 0, ge = 0; L[H] === D; )
        fe++, H++;
      for (var Ie = (L.length - H) * x + 1 >>> 0, Ee = new Uint8Array(Ie); L[H]; ) {
        var Se = L.charCodeAt(H);
        if (Se > 255)
          return;
        var ze = c[Se];
        if (ze === 255)
          return;
        for (var He = 0, Pe = Ie - 1; (ze !== 0 || He < ge) && Pe !== -1; Pe--, He++)
          ze += B * Ee[Pe] >>> 0, Ee[Pe] = ze % 256 >>> 0, ze = ze / 256 >>> 0;
        if (ze !== 0)
          throw new Error("Non-zero carry");
        ge = He, H++;
      }
      for (var De = Ie - ge; De !== Ie && Ee[De] === 0; )
        De++;
      for (var ve = new Uint8Array(fe + (Ie - De)), Fe = fe; De !== Ie; )
        ve[Fe++] = Ee[De++];
      return ve;
    }
    function U(L) {
      var H = M(L);
      if (H)
        return H;
      throw new Error("Non-base" + B + " character");
    }
    return {
      encode: F,
      decodeUnsafe: M,
      decode: U
    };
  }
  return src$2 = o, src$2;
}
var bs58, hasRequiredBs58;
function requireBs58() {
  return hasRequiredBs58 || (hasRequiredBs58 = 1, bs58 = requireSrc$2()("123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz")), bs58;
}
var base, hasRequiredBase;
function requireBase() {
  if (hasRequiredBase) return base;
  hasRequiredBase = 1;
  var o = requireBs58();
  return base = function(g) {
    function c(E) {
      var B = Uint8Array.from(E), D = g(B), x = B.length + 4, v = new Uint8Array(x);
      return v.set(B, 0), v.set(D.subarray(0, 4), B.length), o.encode(v, x);
    }
    function y(E) {
      var B = E.slice(0, -4), D = E.slice(-4), x = g(B);
      if (!(D[0] ^ x[0] | D[1] ^ x[1] | D[2] ^ x[2] | D[3] ^ x[3]))
        return B;
    }
    function t(E) {
      var B = o.decodeUnsafe(E);
      if (B)
        return y(B);
    }
    function d(E) {
      var B = o.decode(E), D = y(B);
      if (!D) throw new Error("Invalid checksum");
      return D;
    }
    return {
      encode: c,
      decode: d,
      decodeUnsafe: t
    };
  }, base;
}
var bs58check, hasRequiredBs58check;
function requireBs58check() {
  if (hasRequiredBs58check) return bs58check;
  hasRequiredBs58check = 1;
  var { sha256: o } = /* @__PURE__ */ requireSha256$1(), g = requireBase();
  function c(y) {
    return o(o(y));
  }
  return bs58check = g(c), bs58check;
}
var contract_pb = {}, cjs$3 = {}, proto3 = {}, protoRuntime = {}, _enum = {}, assert$1 = {}, hasRequiredAssert$1;
function requireAssert$1() {
  if (hasRequiredAssert$1) return assert$1;
  hasRequiredAssert$1 = 1, Object.defineProperty(assert$1, "__esModule", { value: !0 }), assert$1.assertFloat32 = assert$1.assertUInt32 = assert$1.assertInt32 = assert$1.assert = void 0;
  function o(x, v) {
    if (!x)
      throw new Error(v);
  }
  assert$1.assert = o;
  const g = 34028234663852886e22, c = -34028234663852886e22, y = 4294967295, t = 2147483647, d = -2147483648;
  function E(x) {
    if (typeof x != "number")
      throw new Error("invalid int 32: " + typeof x);
    if (!Number.isInteger(x) || x > t || x < d)
      throw new Error("invalid int 32: " + x);
  }
  assert$1.assertInt32 = E;
  function B(x) {
    if (typeof x != "number")
      throw new Error("invalid uint 32: " + typeof x);
    if (!Number.isInteger(x) || x > y || x < 0)
      throw new Error("invalid uint 32: " + x);
  }
  assert$1.assertUInt32 = B;
  function D(x) {
    if (typeof x != "number")
      throw new Error("invalid float 32: " + typeof x);
    if (Number.isFinite(x) && (x > g || x < c))
      throw new Error("invalid float 32: " + x);
  }
  return assert$1.assertFloat32 = D, assert$1;
}
var hasRequired_enum;
function require_enum() {
  if (hasRequired_enum) return _enum;
  hasRequired_enum = 1, Object.defineProperty(_enum, "__esModule", { value: !0 }), _enum.makeEnum = _enum.makeEnumType = _enum.setEnumType = _enum.getEnumType = void 0;
  const o = requireAssert$1(), g = Symbol("@bufbuild/protobuf/enum-type");
  function c(B) {
    const D = B[g];
    return (0, o.assert)(D, "missing enum type on enum object"), D;
  }
  _enum.getEnumType = c;
  function y(B, D, x, v) {
    B[g] = t(D, x.map((F) => ({
      no: F.no,
      name: F.name,
      localName: B[F.no]
    })));
  }
  _enum.setEnumType = y;
  function t(B, D, x) {
    const v = /* @__PURE__ */ Object.create(null), F = /* @__PURE__ */ Object.create(null), M = [];
    for (const U of D) {
      const L = E(U);
      M.push(L), v[U.name] = L, F[U.no] = L;
    }
    return {
      typeName: B,
      values: M,
      // We do not surface options at this time
      // options: opt?.options ?? Object.create(null),
      findName(U) {
        return v[U];
      },
      findNumber(U) {
        return F[U];
      }
    };
  }
  _enum.makeEnumType = t;
  function d(B, D, x) {
    const v = {};
    for (const F of D) {
      const M = E(F);
      v[M.localName] = M.no, v[M.no] = M.localName;
    }
    return y(v, B, D), v;
  }
  _enum.makeEnum = d;
  function E(B) {
    return "localName" in B ? B : Object.assign(Object.assign({}, B), { localName: B.name });
  }
  return _enum;
}
var messageType = {}, message = {}, hasRequiredMessage;
function requireMessage() {
  if (hasRequiredMessage) return message;
  hasRequiredMessage = 1, Object.defineProperty(message, "__esModule", { value: !0 }), message.Message = void 0;
  class o {
    /**
     * Compare with a message of the same type.
     * Note that this function disregards extensions and unknown fields.
     */
    equals(c) {
      return this.getType().runtime.util.equals(this.getType(), this, c);
    }
    /**
     * Create a deep copy.
     */
    clone() {
      return this.getType().runtime.util.clone(this);
    }
    /**
     * Parse from binary data, merging fields.
     *
     * Repeated fields are appended. Map entries are added, overwriting
     * existing keys.
     *
     * If a message field is already present, it will be merged with the
     * new data.
     */
    fromBinary(c, y) {
      const t = this.getType(), d = t.runtime.bin, E = d.makeReadOptions(y);
      return d.readMessage(this, E.readerFactory(c), c.byteLength, E), this;
    }
    /**
     * Parse a message from a JSON value.
     */
    fromJson(c, y) {
      const t = this.getType(), d = t.runtime.json, E = d.makeReadOptions(y);
      return d.readMessage(t, c, E, this), this;
    }
    /**
     * Parse a message from a JSON string.
     */
    fromJsonString(c, y) {
      let t;
      try {
        t = JSON.parse(c);
      } catch (d) {
        throw new Error(`cannot decode ${this.getType().typeName} from JSON: ${d instanceof Error ? d.message : String(d)}`);
      }
      return this.fromJson(t, y);
    }
    /**
     * Serialize the message to binary data.
     */
    toBinary(c) {
      const y = this.getType(), t = y.runtime.bin, d = t.makeWriteOptions(c), E = d.writerFactory();
      return t.writeMessage(this, E, d), E.finish();
    }
    /**
     * Serialize the message to a JSON value, a JavaScript value that can be
     * passed to JSON.stringify().
     */
    toJson(c) {
      const y = this.getType(), t = y.runtime.json, d = t.makeWriteOptions(c);
      return t.writeMessage(this, d);
    }
    /**
     * Serialize the message to a JSON string.
     */
    toJsonString(c) {
      var y;
      const t = this.toJson(c);
      return JSON.stringify(t, null, (y = c == null ? void 0 : c.prettySpaces) !== null && y !== void 0 ? y : 0);
    }
    /**
     * Override for serialization behavior. This will be invoked when calling
     * JSON.stringify on this message (i.e. JSON.stringify(msg)).
     *
     * Note that this will not serialize google.protobuf.Any with a packed
     * message because the protobuf JSON format specifies that it needs to be
     * unpacked, and this is only possible with a type registry to look up the
     * message type.  As a result, attempting to serialize a message with this
     * type will throw an Error.
     *
     * This method is protected because you should not need to invoke it
     * directly -- instead use JSON.stringify or toJsonString for
     * stringified JSON.  Alternatively, if actual JSON is desired, you should
     * use toJson.
     */
    toJSON() {
      return this.toJson({
        emitDefaultValues: !0
      });
    }
    /**
     * Retrieve the MessageType of this message - a singleton that represents
     * the protobuf message declaration and provides metadata for reflection-
     * based operations.
     */
    getType() {
      return Object.getPrototypeOf(this).constructor;
    }
  }
  return message.Message = o, message;
}
var hasRequiredMessageType;
function requireMessageType() {
  if (hasRequiredMessageType) return messageType;
  hasRequiredMessageType = 1, Object.defineProperty(messageType, "__esModule", { value: !0 }), messageType.makeMessageType = void 0;
  const o = requireMessage();
  function g(c, y, t, d) {
    var E;
    const B = (E = d == null ? void 0 : d.localName) !== null && E !== void 0 ? E : y.substring(y.lastIndexOf(".") + 1), D = {
      [B]: function(x) {
        c.util.initFields(this), c.util.initPartial(x, this);
      }
    }[B];
    return Object.setPrototypeOf(D.prototype, new o.Message()), Object.assign(D, {
      runtime: c,
      typeName: y,
      fields: c.util.newFieldList(t),
      fromBinary(x, v) {
        return new D().fromBinary(x, v);
      },
      fromJson(x, v) {
        return new D().fromJson(x, v);
      },
      fromJsonString(x, v) {
        return new D().fromJsonString(x, v);
      },
      equals(x, v) {
        return c.util.equals(D, x, v);
      }
    }), D;
  }
  return messageType.makeMessageType = g, messageType;
}
var extensions = {}, scalars = {}, protoInt64 = {}, varint$4 = {}, hasRequiredVarint$4;
function requireVarint$4() {
  if (hasRequiredVarint$4) return varint$4;
  hasRequiredVarint$4 = 1, Object.defineProperty(varint$4, "__esModule", { value: !0 }), varint$4.varint32read = varint$4.varint32write = varint$4.uInt64ToString = varint$4.int64ToString = varint$4.int64FromString = varint$4.varint64write = varint$4.varint64read = void 0;
  function o() {
    let M = 0, U = 0;
    for (let H = 0; H < 28; H += 7) {
      let fe = this.buf[this.pos++];
      if (M |= (fe & 127) << H, (fe & 128) == 0)
        return this.assertBounds(), [M, U];
    }
    let L = this.buf[this.pos++];
    if (M |= (L & 15) << 28, U = (L & 112) >> 4, (L & 128) == 0)
      return this.assertBounds(), [M, U];
    for (let H = 3; H <= 31; H += 7) {
      let fe = this.buf[this.pos++];
      if (U |= (fe & 127) << H, (fe & 128) == 0)
        return this.assertBounds(), [M, U];
    }
    throw new Error("invalid varint");
  }
  varint$4.varint64read = o;
  function g(M, U, L) {
    for (let ge = 0; ge < 28; ge = ge + 7) {
      const Ie = M >>> ge, Ee = !(!(Ie >>> 7) && U == 0), Se = (Ee ? Ie | 128 : Ie) & 255;
      if (L.push(Se), !Ee)
        return;
    }
    const H = M >>> 28 & 15 | (U & 7) << 4, fe = U >> 3 != 0;
    if (L.push((fe ? H | 128 : H) & 255), !!fe) {
      for (let ge = 3; ge < 31; ge = ge + 7) {
        const Ie = U >>> ge, Ee = !!(Ie >>> 7), Se = (Ee ? Ie | 128 : Ie) & 255;
        if (L.push(Se), !Ee)
          return;
      }
      L.push(U >>> 31 & 1);
    }
  }
  varint$4.varint64write = g;
  const c = 4294967296;
  function y(M) {
    const U = M[0] === "-";
    U && (M = M.slice(1));
    const L = 1e6;
    let H = 0, fe = 0;
    function ge(Ie, Ee) {
      const Se = Number(M.slice(Ie, Ee));
      fe *= L, H = H * L + Se, H >= c && (fe = fe + (H / c | 0), H = H % c);
    }
    return ge(-24, -18), ge(-18, -12), ge(-12, -6), ge(-6), U ? D(H, fe) : B(H, fe);
  }
  varint$4.int64FromString = y;
  function t(M, U) {
    let L = B(M, U);
    const H = L.hi & 2147483648;
    H && (L = D(L.lo, L.hi));
    const fe = d(L.lo, L.hi);
    return H ? "-" + fe : fe;
  }
  varint$4.int64ToString = t;
  function d(M, U) {
    if ({ lo: M, hi: U } = E(M, U), U <= 2097151)
      return String(c * U + M);
    const L = M & 16777215, H = (M >>> 24 | U << 8) & 16777215, fe = U >> 16 & 65535;
    let ge = L + H * 6777216 + fe * 6710656, Ie = H + fe * 8147497, Ee = fe * 2;
    const Se = 1e7;
    return ge >= Se && (Ie += Math.floor(ge / Se), ge %= Se), Ie >= Se && (Ee += Math.floor(Ie / Se), Ie %= Se), Ee.toString() + x(Ie) + x(ge);
  }
  varint$4.uInt64ToString = d;
  function E(M, U) {
    return { lo: M >>> 0, hi: U >>> 0 };
  }
  function B(M, U) {
    return { lo: M | 0, hi: U | 0 };
  }
  function D(M, U) {
    return U = ~U, M ? M = ~M + 1 : U += 1, B(M, U);
  }
  const x = (M) => {
    const U = String(M);
    return "0000000".slice(U.length) + U;
  };
  function v(M, U) {
    if (M >= 0) {
      for (; M > 127; )
        U.push(M & 127 | 128), M = M >>> 7;
      U.push(M);
    } else {
      for (let L = 0; L < 9; L++)
        U.push(M & 127 | 128), M = M >> 7;
      U.push(1);
    }
  }
  varint$4.varint32write = v;
  function F() {
    let M = this.buf[this.pos++], U = M & 127;
    if ((M & 128) == 0)
      return this.assertBounds(), U;
    if (M = this.buf[this.pos++], U |= (M & 127) << 7, (M & 128) == 0)
      return this.assertBounds(), U;
    if (M = this.buf[this.pos++], U |= (M & 127) << 14, (M & 128) == 0)
      return this.assertBounds(), U;
    if (M = this.buf[this.pos++], U |= (M & 127) << 21, (M & 128) == 0)
      return this.assertBounds(), U;
    M = this.buf[this.pos++], U |= (M & 15) << 28;
    for (let L = 5; (M & 128) !== 0 && L < 10; L++)
      M = this.buf[this.pos++];
    if ((M & 128) != 0)
      throw new Error("invalid varint");
    return this.assertBounds(), U >>> 0;
  }
  return varint$4.varint32read = F, varint$4;
}
var hasRequiredProtoInt64;
function requireProtoInt64() {
  if (hasRequiredProtoInt64) return protoInt64;
  hasRequiredProtoInt64 = 1, Object.defineProperty(protoInt64, "__esModule", { value: !0 }), protoInt64.protoInt64 = void 0;
  const o = requireAssert$1(), g = requireVarint$4();
  function c() {
    const y = new DataView(new ArrayBuffer(8));
    if (typeof BigInt == "function" && typeof y.getBigInt64 == "function" && typeof y.getBigUint64 == "function" && typeof y.setBigInt64 == "function" && typeof y.setBigUint64 == "function" && (typeof process$1 != "object" || typeof process$1.env != "object" || process$1.env.BUF_BIGINT_DISABLE !== "1")) {
      const B = BigInt("-9223372036854775808"), D = BigInt("9223372036854775807"), x = BigInt("0"), v = BigInt("18446744073709551615");
      return {
        zero: BigInt(0),
        supported: !0,
        parse(F) {
          const M = typeof F == "bigint" ? F : BigInt(F);
          if (M > D || M < B)
            throw new Error(`int64 invalid: ${F}`);
          return M;
        },
        uParse(F) {
          const M = typeof F == "bigint" ? F : BigInt(F);
          if (M > v || M < x)
            throw new Error(`uint64 invalid: ${F}`);
          return M;
        },
        enc(F) {
          return y.setBigInt64(0, this.parse(F), !0), {
            lo: y.getInt32(0, !0),
            hi: y.getInt32(4, !0)
          };
        },
        uEnc(F) {
          return y.setBigInt64(0, this.uParse(F), !0), {
            lo: y.getInt32(0, !0),
            hi: y.getInt32(4, !0)
          };
        },
        dec(F, M) {
          return y.setInt32(0, F, !0), y.setInt32(4, M, !0), y.getBigInt64(0, !0);
        },
        uDec(F, M) {
          return y.setInt32(0, F, !0), y.setInt32(4, M, !0), y.getBigUint64(0, !0);
        }
      };
    }
    const d = (B) => (0, o.assert)(/^-?[0-9]+$/.test(B), `int64 invalid: ${B}`), E = (B) => (0, o.assert)(/^[0-9]+$/.test(B), `uint64 invalid: ${B}`);
    return {
      zero: "0",
      supported: !1,
      parse(B) {
        return typeof B != "string" && (B = B.toString()), d(B), B;
      },
      uParse(B) {
        return typeof B != "string" && (B = B.toString()), E(B), B;
      },
      enc(B) {
        return typeof B != "string" && (B = B.toString()), d(B), (0, g.int64FromString)(B);
      },
      uEnc(B) {
        return typeof B != "string" && (B = B.toString()), E(B), (0, g.int64FromString)(B);
      },
      dec(B, D) {
        return (0, g.int64ToString)(B, D);
      },
      uDec(B, D) {
        return (0, g.uInt64ToString)(B, D);
      }
    };
  }
  return protoInt64.protoInt64 = c(), protoInt64;
}
var scalar = {}, hasRequiredScalar;
function requireScalar() {
  if (hasRequiredScalar) return scalar;
  hasRequiredScalar = 1, Object.defineProperty(scalar, "__esModule", { value: !0 }), scalar.LongType = scalar.ScalarType = void 0;
  var o;
  (function(c) {
    c[c.DOUBLE = 1] = "DOUBLE", c[c.FLOAT = 2] = "FLOAT", c[c.INT64 = 3] = "INT64", c[c.UINT64 = 4] = "UINT64", c[c.INT32 = 5] = "INT32", c[c.FIXED64 = 6] = "FIXED64", c[c.FIXED32 = 7] = "FIXED32", c[c.BOOL = 8] = "BOOL", c[c.STRING = 9] = "STRING", c[c.BYTES = 12] = "BYTES", c[c.UINT32 = 13] = "UINT32", c[c.SFIXED32 = 15] = "SFIXED32", c[c.SFIXED64 = 16] = "SFIXED64", c[c.SINT32 = 17] = "SINT32", c[c.SINT64 = 18] = "SINT64";
  })(o || (scalar.ScalarType = o = {}));
  var g;
  return function(c) {
    c[c.BIGINT = 0] = "BIGINT", c[c.STRING = 1] = "STRING";
  }(g || (scalar.LongType = g = {})), scalar;
}
var hasRequiredScalars;
function requireScalars() {
  if (hasRequiredScalars) return scalars;
  hasRequiredScalars = 1, Object.defineProperty(scalars, "__esModule", { value: !0 }), scalars.isScalarZeroValue = scalars.scalarZeroValue = scalars.scalarEquals = void 0;
  const o = requireProtoInt64(), g = requireScalar();
  function c(d, E, B) {
    if (E === B)
      return !0;
    if (d == g.ScalarType.BYTES) {
      if (!(E instanceof Uint8Array) || !(B instanceof Uint8Array) || E.length !== B.length)
        return !1;
      for (let D = 0; D < E.length; D++)
        if (E[D] !== B[D])
          return !1;
      return !0;
    }
    switch (d) {
      case g.ScalarType.UINT64:
      case g.ScalarType.FIXED64:
      case g.ScalarType.INT64:
      case g.ScalarType.SFIXED64:
      case g.ScalarType.SINT64:
        return E == B;
    }
    return !1;
  }
  scalars.scalarEquals = c;
  function y(d, E) {
    switch (d) {
      case g.ScalarType.BOOL:
        return !1;
      case g.ScalarType.UINT64:
      case g.ScalarType.FIXED64:
      case g.ScalarType.INT64:
      case g.ScalarType.SFIXED64:
      case g.ScalarType.SINT64:
        return E == 0 ? o.protoInt64.zero : "0";
      case g.ScalarType.DOUBLE:
      case g.ScalarType.FLOAT:
        return 0;
      case g.ScalarType.BYTES:
        return new Uint8Array(0);
      case g.ScalarType.STRING:
        return "";
      default:
        return 0;
    }
  }
  scalars.scalarZeroValue = y;
  function t(d, E) {
    switch (d) {
      case g.ScalarType.BOOL:
        return E === !1;
      case g.ScalarType.STRING:
        return E === "";
      case g.ScalarType.BYTES:
        return E instanceof Uint8Array && !E.byteLength;
      default:
        return E == 0;
    }
  }
  return scalars.isScalarZeroValue = t, scalars;
}
var hasRequiredExtensions;
function requireExtensions() {
  if (hasRequiredExtensions) return extensions;
  hasRequiredExtensions = 1, Object.defineProperty(extensions, "__esModule", { value: !0 }), extensions.filterUnknownFields = extensions.createExtensionContainer = extensions.makeExtension = void 0;
  const o = requireScalars();
  function g(d, E, B, D) {
    let x;
    return {
      typeName: E,
      extendee: B,
      get field() {
        if (!x) {
          const v = typeof D == "function" ? D() : D;
          v.name = E.split(".").pop(), v.jsonName = `[${E}]`, x = d.util.newFieldList([v]).list()[0];
        }
        return x;
      },
      runtime: d
    };
  }
  extensions.makeExtension = g;
  function c(d) {
    const E = d.field.localName, B = /* @__PURE__ */ Object.create(null);
    return B[E] = y(d), [B, () => B[E]];
  }
  extensions.createExtensionContainer = c;
  function y(d) {
    const E = d.field;
    if (E.repeated)
      return [];
    if (E.default !== void 0)
      return E.default;
    switch (E.kind) {
      case "enum":
        return E.T.values[0].no;
      case "scalar":
        return (0, o.scalarZeroValue)(E.T, E.L);
      case "message":
        const B = E.T, D = new B();
        return B.fieldWrapper ? B.fieldWrapper.unwrapField(D) : D;
      case "map":
        throw "map fields are not allowed to be extensions";
    }
  }
  function t(d, E) {
    if (!E.repeated && (E.kind == "enum" || E.kind == "scalar")) {
      for (let B = d.length - 1; B >= 0; --B)
        if (d[B].no == E.no)
          return [d[B]];
      return [];
    }
    return d.filter((B) => B.no === E.no);
  }
  return extensions.filterUnknownFields = t, extensions;
}
var jsonFormat = {}, protoBase64 = {}, hasRequiredProtoBase64;
function requireProtoBase64() {
  if (hasRequiredProtoBase64) return protoBase64;
  hasRequiredProtoBase64 = 1, Object.defineProperty(protoBase64, "__esModule", { value: !0 }), protoBase64.protoBase64 = void 0;
  let o = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".split(""), g = [];
  for (let c = 0; c < o.length; c++)
    g[o[c].charCodeAt(0)] = c;
  return g[45] = o.indexOf("+"), g[95] = o.indexOf("/"), protoBase64.protoBase64 = {
    /**
     * Decodes a base64 string to a byte array.
     *
     * - ignores white-space, including line breaks and tabs
     * - allows inner padding (can decode concatenated base64 strings)
     * - does not require padding
     * - understands base64url encoding:
     *   "-" instead of "+",
     *   "_" instead of "/",
     *   no padding
     */
    dec(c) {
      let y = c.length * 3 / 4;
      c[c.length - 2] == "=" ? y -= 2 : c[c.length - 1] == "=" && (y -= 1);
      let t = new Uint8Array(y), d = 0, E = 0, B, D = 0;
      for (let x = 0; x < c.length; x++) {
        if (B = g[c.charCodeAt(x)], B === void 0)
          switch (c[x]) {
            // @ts-ignore TS7029: Fallthrough case in switch
            case "=":
              E = 0;
            // reset state when padding found
            // @ts-ignore TS7029: Fallthrough case in switch
            case `
`:
            case "\r":
            case "	":
            case " ":
              continue;
            // skip white-space, and padding
            default:
              throw Error("invalid base64 string.");
          }
        switch (E) {
          case 0:
            D = B, E = 1;
            break;
          case 1:
            t[d++] = D << 2 | (B & 48) >> 4, D = B, E = 2;
            break;
          case 2:
            t[d++] = (D & 15) << 4 | (B & 60) >> 2, D = B, E = 3;
            break;
          case 3:
            t[d++] = (D & 3) << 6 | B, E = 0;
            break;
        }
      }
      if (E == 1)
        throw Error("invalid base64 string.");
      return t.subarray(0, d);
    },
    /**
     * Encode a byte array to a base64 string.
     */
    enc(c) {
      let y = "", t = 0, d, E = 0;
      for (let B = 0; B < c.length; B++)
        switch (d = c[B], t) {
          case 0:
            y += o[d >> 2], E = (d & 3) << 4, t = 1;
            break;
          case 1:
            y += o[E | d >> 4], E = (d & 15) << 2, t = 2;
            break;
          case 2:
            y += o[E | d >> 6], y += o[d & 63], t = 0;
            break;
        }
      return t && (y += o[E], y += "=", t == 1 && (y += "=")), y;
    }
  }, protoBase64;
}
var extensionAccessor = {}, hasRequiredExtensionAccessor;
function requireExtensionAccessor() {
  if (hasRequiredExtensionAccessor) return extensionAccessor;
  hasRequiredExtensionAccessor = 1, Object.defineProperty(extensionAccessor, "__esModule", { value: !0 }), extensionAccessor.hasExtension = extensionAccessor.clearExtension = extensionAccessor.setExtension = extensionAccessor.getExtension = void 0;
  const o = requireAssert$1(), g = requireExtensions();
  function c(B, D, x) {
    E(D, B);
    const v = D.runtime.bin.makeReadOptions(x), F = (0, g.filterUnknownFields)(B.getType().runtime.bin.listUnknownFields(B), D.field), [M, U] = (0, g.createExtensionContainer)(D);
    for (const L of F)
      D.runtime.bin.readField(M, v.readerFactory(L.data), D.field, L.wireType, v);
    return U();
  }
  extensionAccessor.getExtension = c;
  function y(B, D, x, v) {
    E(D, B);
    const F = D.runtime.bin.makeReadOptions(v), M = D.runtime.bin.makeWriteOptions(v);
    if (d(B, D)) {
      const fe = B.getType().runtime.bin.listUnknownFields(B).filter((ge) => ge.no != D.field.no);
      B.getType().runtime.bin.discardUnknownFields(B);
      for (const ge of fe)
        B.getType().runtime.bin.onUnknownField(B, ge.no, ge.wireType, ge.data);
    }
    const U = M.writerFactory();
    let L = D.field;
    !L.opt && !L.repeated && (L.kind == "enum" || L.kind == "scalar") && (L = Object.assign(Object.assign({}, D.field), { opt: !0 })), D.runtime.bin.writeField(L, x, U, M);
    const H = F.readerFactory(U.finish());
    for (; H.pos < H.len; ) {
      const [fe, ge] = H.tag(), Ie = H.skip(ge, fe);
      B.getType().runtime.bin.onUnknownField(B, fe, ge, Ie);
    }
  }
  extensionAccessor.setExtension = y;
  function t(B, D) {
    if (E(D, B), d(B, D)) {
      const x = B.getType().runtime.bin, v = x.listUnknownFields(B).filter((F) => F.no != D.field.no);
      x.discardUnknownFields(B);
      for (const F of v)
        x.onUnknownField(B, F.no, F.wireType, F.data);
    }
  }
  extensionAccessor.clearExtension = t;
  function d(B, D) {
    const x = B.getType();
    return D.extendee.typeName === x.typeName && !!x.runtime.bin.listUnknownFields(B).find((v) => v.no == D.field.no);
  }
  extensionAccessor.hasExtension = d;
  function E(B, D) {
    (0, o.assert)(B.extendee.typeName == D.getType().typeName, `extension ${B.typeName} can only be applied to message ${B.extendee.typeName}`);
  }
  return extensionAccessor;
}
var reflect = {}, hasRequiredReflect;
function requireReflect() {
  if (hasRequiredReflect) return reflect;
  hasRequiredReflect = 1, Object.defineProperty(reflect, "__esModule", { value: !0 }), reflect.clearField = reflect.isFieldSet = void 0;
  const o = requireScalars();
  function g(y, t) {
    const d = y.localName;
    if (y.repeated)
      return t[d].length > 0;
    if (y.oneof)
      return t[y.oneof.localName].case === d;
    switch (y.kind) {
      case "enum":
      case "scalar":
        return y.opt || y.req ? t[d] !== void 0 : y.kind == "enum" ? t[d] !== y.T.values[0].no : !(0, o.isScalarZeroValue)(y.T, t[d]);
      case "message":
        return t[d] !== void 0;
      case "map":
        return Object.keys(t[d]).length > 0;
    }
  }
  reflect.isFieldSet = g;
  function c(y, t) {
    const d = y.localName, E = !y.opt && !y.req;
    if (y.repeated)
      t[d] = [];
    else if (y.oneof)
      t[y.oneof.localName] = { case: void 0 };
    else
      switch (y.kind) {
        case "map":
          t[d] = {};
          break;
        case "enum":
          t[d] = E ? y.T.values[0].no : void 0;
          break;
        case "scalar":
          t[d] = E ? (0, o.scalarZeroValue)(y.T, y.L) : void 0;
          break;
        case "message":
          t[d] = void 0;
          break;
      }
  }
  return reflect.clearField = c, reflect;
}
var fieldWrapper = {}, isMessage = {}, hasRequiredIsMessage;
function requireIsMessage() {
  if (hasRequiredIsMessage) return isMessage;
  hasRequiredIsMessage = 1, Object.defineProperty(isMessage, "__esModule", { value: !0 }), isMessage.isMessage = void 0;
  const o = requireMessage();
  function g(c, y) {
    if (c === null || typeof c != "object" || !Object.getOwnPropertyNames(o.Message.prototype).every((d) => d in c && typeof c[d] == "function"))
      return !1;
    const t = c.getType();
    return t === null || typeof t != "function" || !("typeName" in t) || typeof t.typeName != "string" ? !1 : y === void 0 ? !0 : t.typeName == y.typeName;
  }
  return isMessage.isMessage = g, isMessage;
}
var hasRequiredFieldWrapper;
function requireFieldWrapper() {
  if (hasRequiredFieldWrapper) return fieldWrapper;
  hasRequiredFieldWrapper = 1, Object.defineProperty(fieldWrapper, "__esModule", { value: !0 }), fieldWrapper.getUnwrappedFieldType = fieldWrapper.wrapField = void 0;
  const o = requireScalar(), g = requireIsMessage();
  function c(d, E) {
    return (0, g.isMessage)(E) || !d.fieldWrapper ? E : d.fieldWrapper.wrapField(E);
  }
  fieldWrapper.wrapField = c;
  function y(d) {
    if (d.fieldKind === "message" && !d.repeated && d.oneof == null)
      return t[d.message.typeName];
  }
  fieldWrapper.getUnwrappedFieldType = y;
  const t = {
    "google.protobuf.DoubleValue": o.ScalarType.DOUBLE,
    "google.protobuf.FloatValue": o.ScalarType.FLOAT,
    "google.protobuf.Int64Value": o.ScalarType.INT64,
    "google.protobuf.UInt64Value": o.ScalarType.UINT64,
    "google.protobuf.Int32Value": o.ScalarType.INT32,
    "google.protobuf.UInt32Value": o.ScalarType.UINT32,
    "google.protobuf.BoolValue": o.ScalarType.BOOL,
    "google.protobuf.StringValue": o.ScalarType.STRING,
    "google.protobuf.BytesValue": o.ScalarType.BYTES
  };
  return fieldWrapper;
}
var hasRequiredJsonFormat;
function requireJsonFormat() {
  if (hasRequiredJsonFormat) return jsonFormat;
  hasRequiredJsonFormat = 1, Object.defineProperty(jsonFormat, "__esModule", { value: !0 }), jsonFormat.makeJsonFormat = void 0;
  const o = requireAssert$1(), g = requireProtoInt64(), c = requireProtoBase64(), y = requireExtensions(), t = requireExtensionAccessor(), d = requireReflect(), E = requireFieldWrapper(), B = requireScalars(), D = requireScalars(), x = requireScalar(), v = requireIsMessage(), F = {
    ignoreUnknownFields: !1
  }, M = {
    emitDefaultValues: !1,
    enumAsInteger: !1,
    useProtoFieldName: !1,
    prettySpaces: 0
  };
  function U(be) {
    return be ? Object.assign(Object.assign({}, F), be) : F;
  }
  function L(be) {
    return be ? Object.assign(Object.assign({}, M), be) : M;
  }
  const H = Symbol(), fe = Symbol();
  function ge() {
    return {
      makeReadOptions: U,
      makeWriteOptions: L,
      readMessage(be, Be, ke, xe) {
        if (Be == null || Array.isArray(Be) || typeof Be != "object")
          throw new Error(`cannot decode message ${be.typeName} from JSON: ${Ie(Be)}`);
        xe = xe ?? new be();
        const Ne = /* @__PURE__ */ new Map(), Et = ke.typeRegistry;
        for (const [st, Dt] of Object.entries(Be)) {
          const er = be.fields.findJsonName(st);
          if (er) {
            if (er.oneof) {
              if (Dt === null && er.kind == "scalar")
                continue;
              const xt = Ne.get(er.oneof);
              if (xt !== void 0)
                throw new Error(`cannot decode message ${be.typeName} from JSON: multiple keys for oneof "${er.oneof.name}" present: "${xt}", "${st}"`);
              Ne.set(er.oneof, st);
            }
            Ee(xe, Dt, er, ke, be);
          } else {
            let xt = !1;
            if (Et != null && Et.findExtension && st.startsWith("[") && st.endsWith("]")) {
              const ir = Et.findExtension(st.substring(1, st.length - 1));
              if (ir && ir.extendee.typeName == be.typeName) {
                xt = !0;
                const [sr, yr] = (0, y.createExtensionContainer)(ir);
                Ee(sr, Dt, ir.field, ke, ir), (0, t.setExtension)(xe, ir, yr(), ke);
              }
            }
            if (!xt && !ke.ignoreUnknownFields)
              throw new Error(`cannot decode message ${be.typeName} from JSON: key "${st}" is unknown`);
          }
        }
        return xe;
      },
      writeMessage(be, Be) {
        const ke = be.getType(), xe = {};
        let Ne;
        try {
          for (Ne of ke.fields.byNumber()) {
            if (!(0, d.isFieldSet)(Ne, be)) {
              if (Ne.req)
                throw "required field not set";
              if (!Be.emitDefaultValues || !Pe(Ne))
                continue;
            }
            const st = Ne.oneof ? be[Ne.oneof.localName].value : be[Ne.localName], Dt = De(Ne, st, Be);
            Dt !== void 0 && (xe[Be.useProtoFieldName ? Ne.name : Ne.jsonName] = Dt);
          }
          const Et = Be.typeRegistry;
          if (Et != null && Et.findExtensionFor)
            for (const st of ke.runtime.bin.listUnknownFields(be)) {
              const Dt = Et.findExtensionFor(ke.typeName, st.no);
              if (Dt && (0, t.hasExtension)(be, Dt)) {
                const er = (0, t.getExtension)(be, Dt, Be), xt = De(Dt.field, er, Be);
                xt !== void 0 && (xe[Dt.field.jsonName] = xt);
              }
            }
        } catch (Et) {
          const st = Ne ? `cannot encode field ${ke.typeName}.${Ne.name} to JSON` : `cannot encode message ${ke.typeName} to JSON`, Dt = Et instanceof Error ? Et.message : String(Et);
          throw new Error(st + (Dt.length > 0 ? `: ${Dt}` : ""));
        }
        return xe;
      },
      readScalar(be, Be, ke) {
        return ze(be, Be, ke ?? x.LongType.BIGINT, !0);
      },
      writeScalar(be, Be, ke) {
        if (Be !== void 0 && (ke || (0, D.isScalarZeroValue)(be, Be)))
          return Fe(be, Be);
      },
      debug: Ie
    };
  }
  jsonFormat.makeJsonFormat = ge;
  function Ie(be) {
    if (be === null)
      return "null";
    switch (typeof be) {
      case "object":
        return Array.isArray(be) ? "array" : "object";
      case "string":
        return be.length > 100 ? "string" : `"${be.split('"').join('\\"')}"`;
      default:
        return String(be);
    }
  }
  function Ee(be, Be, ke, xe, Ne) {
    let Et = ke.localName;
    if (ke.repeated) {
      if ((0, o.assert)(ke.kind != "map"), Be === null)
        return;
      if (!Array.isArray(Be))
        throw new Error(`cannot decode field ${Ne.typeName}.${ke.name} from JSON: ${Ie(Be)}`);
      const st = be[Et];
      for (const Dt of Be) {
        if (Dt === null)
          throw new Error(`cannot decode field ${Ne.typeName}.${ke.name} from JSON: ${Ie(Dt)}`);
        switch (ke.kind) {
          case "message":
            st.push(ke.T.fromJson(Dt, xe));
            break;
          case "enum":
            const er = He(ke.T, Dt, xe.ignoreUnknownFields, !0);
            er !== fe && st.push(er);
            break;
          case "scalar":
            try {
              st.push(ze(ke.T, Dt, ke.L, !0));
            } catch (xt) {
              let ir = `cannot decode field ${Ne.typeName}.${ke.name} from JSON: ${Ie(Dt)}`;
              throw xt instanceof Error && xt.message.length > 0 && (ir += `: ${xt.message}`), new Error(ir);
            }
            break;
        }
      }
    } else if (ke.kind == "map") {
      if (Be === null)
        return;
      if (typeof Be != "object" || Array.isArray(Be))
        throw new Error(`cannot decode field ${Ne.typeName}.${ke.name} from JSON: ${Ie(Be)}`);
      const st = be[Et];
      for (const [Dt, er] of Object.entries(Be)) {
        if (er === null)
          throw new Error(`cannot decode field ${Ne.typeName}.${ke.name} from JSON: map value null`);
        let xt;
        try {
          xt = Se(ke.K, Dt);
        } catch (ir) {
          let sr = `cannot decode map key for field ${Ne.typeName}.${ke.name} from JSON: ${Ie(Be)}`;
          throw ir instanceof Error && ir.message.length > 0 && (sr += `: ${ir.message}`), new Error(sr);
        }
        switch (ke.V.kind) {
          case "message":
            st[xt] = ke.V.T.fromJson(er, xe);
            break;
          case "enum":
            const ir = He(ke.V.T, er, xe.ignoreUnknownFields, !0);
            ir !== fe && (st[xt] = ir);
            break;
          case "scalar":
            try {
              st[xt] = ze(ke.V.T, er, x.LongType.BIGINT, !0);
            } catch (sr) {
              let yr = `cannot decode map value for field ${Ne.typeName}.${ke.name} from JSON: ${Ie(Be)}`;
              throw sr instanceof Error && sr.message.length > 0 && (yr += `: ${sr.message}`), new Error(yr);
            }
            break;
        }
      }
    } else
      switch (ke.oneof && (be = be[ke.oneof.localName] = { case: Et }, Et = "value"), ke.kind) {
        case "message":
          const st = ke.T;
          if (Be === null && st.typeName != "google.protobuf.Value")
            return;
          let Dt = be[Et];
          (0, v.isMessage)(Dt) ? Dt.fromJson(Be, xe) : (be[Et] = Dt = st.fromJson(Be, xe), st.fieldWrapper && !ke.oneof && (be[Et] = st.fieldWrapper.unwrapField(Dt)));
          break;
        case "enum":
          const er = He(ke.T, Be, xe.ignoreUnknownFields, !1);
          switch (er) {
            case H:
              (0, d.clearField)(ke, be);
              break;
            case fe:
              break;
            default:
              be[Et] = er;
              break;
          }
          break;
        case "scalar":
          try {
            const xt = ze(ke.T, Be, ke.L, !1);
            switch (xt) {
              case H:
                (0, d.clearField)(ke, be);
                break;
              default:
                be[Et] = xt;
                break;
            }
          } catch (xt) {
            let ir = `cannot decode field ${Ne.typeName}.${ke.name} from JSON: ${Ie(Be)}`;
            throw xt instanceof Error && xt.message.length > 0 && (ir += `: ${xt.message}`), new Error(ir);
          }
          break;
      }
  }
  function Se(be, Be) {
    if (be === x.ScalarType.BOOL)
      switch (Be) {
        case "true":
          Be = !0;
          break;
        case "false":
          Be = !1;
          break;
      }
    return ze(be, Be, x.LongType.BIGINT, !0).toString();
  }
  function ze(be, Be, ke, xe) {
    if (Be === null)
      return xe ? (0, B.scalarZeroValue)(be, ke) : H;
    switch (be) {
      // float, double: JSON value will be a number or one of the special string values "NaN", "Infinity", and "-Infinity".
      // Either numbers or strings are accepted. Exponent notation is also accepted.
      case x.ScalarType.DOUBLE:
      case x.ScalarType.FLOAT:
        if (Be === "NaN")
          return Number.NaN;
        if (Be === "Infinity")
          return Number.POSITIVE_INFINITY;
        if (Be === "-Infinity")
          return Number.NEGATIVE_INFINITY;
        if (Be === "" || typeof Be == "string" && Be.trim().length !== Be.length || typeof Be != "string" && typeof Be != "number")
          break;
        const Ne = Number(Be);
        if (Number.isNaN(Ne) || !Number.isFinite(Ne))
          break;
        return be == x.ScalarType.FLOAT && (0, o.assertFloat32)(Ne), Ne;
      // int32, fixed32, uint32: JSON value will be a decimal number. Either numbers or strings are accepted.
      case x.ScalarType.INT32:
      case x.ScalarType.FIXED32:
      case x.ScalarType.SFIXED32:
      case x.ScalarType.SINT32:
      case x.ScalarType.UINT32:
        let Et;
        if (typeof Be == "number" ? Et = Be : typeof Be == "string" && Be.length > 0 && Be.trim().length === Be.length && (Et = Number(Be)), Et === void 0)
          break;
        return be == x.ScalarType.UINT32 || be == x.ScalarType.FIXED32 ? (0, o.assertUInt32)(Et) : (0, o.assertInt32)(Et), Et;
      // int64, fixed64, uint64: JSON value will be a decimal string. Either numbers or strings are accepted.
      case x.ScalarType.INT64:
      case x.ScalarType.SFIXED64:
      case x.ScalarType.SINT64:
        if (typeof Be != "number" && typeof Be != "string")
          break;
        const st = g.protoInt64.parse(Be);
        return ke ? st.toString() : st;
      case x.ScalarType.FIXED64:
      case x.ScalarType.UINT64:
        if (typeof Be != "number" && typeof Be != "string")
          break;
        const Dt = g.protoInt64.uParse(Be);
        return ke ? Dt.toString() : Dt;
      // bool:
      case x.ScalarType.BOOL:
        if (typeof Be != "boolean")
          break;
        return Be;
      // string:
      case x.ScalarType.STRING:
        if (typeof Be != "string")
          break;
        try {
          encodeURIComponent(Be);
        } catch {
          throw new Error("invalid UTF8");
        }
        return Be;
      // bytes: JSON value will be the data encoded as a string using standard base64 encoding with paddings.
      // Either standard or URL-safe base64 encoding with/without paddings are accepted.
      case x.ScalarType.BYTES:
        if (Be === "")
          return new Uint8Array(0);
        if (typeof Be != "string")
          break;
        return c.protoBase64.dec(Be);
    }
    throw new Error();
  }
  function He(be, Be, ke, xe) {
    if (Be === null)
      return be.typeName == "google.protobuf.NullValue" ? 0 : xe ? be.values[0].no : H;
    switch (typeof Be) {
      case "number":
        if (Number.isInteger(Be))
          return Be;
        break;
      case "string":
        const Ne = be.findName(Be);
        if (Ne !== void 0)
          return Ne.no;
        if (ke)
          return fe;
        break;
    }
    throw new Error(`cannot decode enum ${be.typeName} from JSON: ${Ie(Be)}`);
  }
  function Pe(be) {
    return be.repeated || be.kind == "map" ? !0 : !(be.oneof || be.kind == "message" || be.opt || be.req);
  }
  function De(be, Be, ke) {
    if (be.kind == "map") {
      (0, o.assert)(typeof Be == "object" && Be != null);
      const xe = {}, Ne = Object.entries(Be);
      switch (be.V.kind) {
        case "scalar":
          for (const [st, Dt] of Ne)
            xe[st.toString()] = Fe(be.V.T, Dt);
          break;
        case "message":
          for (const [st, Dt] of Ne)
            xe[st.toString()] = Dt.toJson(ke);
          break;
        case "enum":
          const Et = be.V.T;
          for (const [st, Dt] of Ne)
            xe[st.toString()] = ve(Et, Dt, ke.enumAsInteger);
          break;
      }
      return ke.emitDefaultValues || Ne.length > 0 ? xe : void 0;
    }
    if (be.repeated) {
      (0, o.assert)(Array.isArray(Be));
      const xe = [];
      switch (be.kind) {
        case "scalar":
          for (let Ne = 0; Ne < Be.length; Ne++)
            xe.push(Fe(be.T, Be[Ne]));
          break;
        case "enum":
          for (let Ne = 0; Ne < Be.length; Ne++)
            xe.push(ve(be.T, Be[Ne], ke.enumAsInteger));
          break;
        case "message":
          for (let Ne = 0; Ne < Be.length; Ne++)
            xe.push(Be[Ne].toJson(ke));
          break;
      }
      return ke.emitDefaultValues || xe.length > 0 ? xe : void 0;
    }
    switch (be.kind) {
      case "scalar":
        return Fe(be.T, Be);
      case "enum":
        return ve(be.T, Be, ke.enumAsInteger);
      case "message":
        return (0, E.wrapField)(be.T, Be).toJson(ke);
    }
  }
  function ve(be, Be, ke) {
    var xe;
    if ((0, o.assert)(typeof Be == "number"), be.typeName == "google.protobuf.NullValue")
      return null;
    if (ke)
      return Be;
    const Ne = be.findNumber(Be);
    return (xe = Ne == null ? void 0 : Ne.name) !== null && xe !== void 0 ? xe : Be;
  }
  function Fe(be, Be) {
    switch (be) {
      // int32, fixed32, uint32: JSON value will be a decimal number. Either numbers or strings are accepted.
      case x.ScalarType.INT32:
      case x.ScalarType.SFIXED32:
      case x.ScalarType.SINT32:
      case x.ScalarType.FIXED32:
      case x.ScalarType.UINT32:
        return (0, o.assert)(typeof Be == "number"), Be;
      // float, double: JSON value will be a number or one of the special string values "NaN", "Infinity", and "-Infinity".
      // Either numbers or strings are accepted. Exponent notation is also accepted.
      case x.ScalarType.FLOAT:
      // assertFloat32(value);
      case x.ScalarType.DOUBLE:
        return (0, o.assert)(typeof Be == "number"), Number.isNaN(Be) ? "NaN" : Be === Number.POSITIVE_INFINITY ? "Infinity" : Be === Number.NEGATIVE_INFINITY ? "-Infinity" : Be;
      // string:
      case x.ScalarType.STRING:
        return (0, o.assert)(typeof Be == "string"), Be;
      // bool:
      case x.ScalarType.BOOL:
        return (0, o.assert)(typeof Be == "boolean"), Be;
      // JSON value will be a decimal string. Either numbers or strings are accepted.
      case x.ScalarType.UINT64:
      case x.ScalarType.FIXED64:
      case x.ScalarType.INT64:
      case x.ScalarType.SFIXED64:
      case x.ScalarType.SINT64:
        return (0, o.assert)(typeof Be == "bigint" || typeof Be == "string" || typeof Be == "number"), Be.toString();
      // bytes: JSON value will be the data encoded as a string using standard base64 encoding with paddings.
      // Either standard or URL-safe base64 encoding with/without paddings are accepted.
      case x.ScalarType.BYTES:
        return (0, o.assert)(Be instanceof Uint8Array), c.protoBase64.enc(Be);
    }
  }
  return jsonFormat;
}
var binaryFormat = {}, binaryEncoding = {}, hasRequiredBinaryEncoding;
function requireBinaryEncoding() {
  if (hasRequiredBinaryEncoding) return binaryEncoding;
  hasRequiredBinaryEncoding = 1, Object.defineProperty(binaryEncoding, "__esModule", { value: !0 }), binaryEncoding.BinaryReader = binaryEncoding.BinaryWriter = binaryEncoding.WireType = void 0;
  const o = requireVarint$4(), g = requireAssert$1(), c = requireProtoInt64();
  var y;
  (function(E) {
    E[E.Varint = 0] = "Varint", E[E.Bit64 = 1] = "Bit64", E[E.LengthDelimited = 2] = "LengthDelimited", E[E.StartGroup = 3] = "StartGroup", E[E.EndGroup = 4] = "EndGroup", E[E.Bit32 = 5] = "Bit32";
  })(y || (binaryEncoding.WireType = y = {}));
  class t {
    constructor(B) {
      this.stack = [], this.textEncoder = B ?? new TextEncoder(), this.chunks = [], this.buf = [];
    }
    /**
     * Return all bytes written and reset this writer.
     */
    finish() {
      this.chunks.push(new Uint8Array(this.buf));
      let B = 0;
      for (let v = 0; v < this.chunks.length; v++)
        B += this.chunks[v].length;
      let D = new Uint8Array(B), x = 0;
      for (let v = 0; v < this.chunks.length; v++)
        D.set(this.chunks[v], x), x += this.chunks[v].length;
      return this.chunks = [], D;
    }
    /**
     * Start a new fork for length-delimited data like a message
     * or a packed repeated field.
     *
     * Must be joined later with `join()`.
     */
    fork() {
      return this.stack.push({ chunks: this.chunks, buf: this.buf }), this.chunks = [], this.buf = [], this;
    }
    /**
     * Join the last fork. Write its length and bytes, then
     * return to the previous state.
     */
    join() {
      let B = this.finish(), D = this.stack.pop();
      if (!D)
        throw new Error("invalid state, fork stack empty");
      return this.chunks = D.chunks, this.buf = D.buf, this.uint32(B.byteLength), this.raw(B);
    }
    /**
     * Writes a tag (field number and wire type).
     *
     * Equivalent to `uint32( (fieldNo << 3 | type) >>> 0 )`.
     *
     * Generated code should compute the tag ahead of time and call `uint32()`.
     */
    tag(B, D) {
      return this.uint32((B << 3 | D) >>> 0);
    }
    /**
     * Write a chunk of raw bytes.
     */
    raw(B) {
      return this.buf.length && (this.chunks.push(new Uint8Array(this.buf)), this.buf = []), this.chunks.push(B), this;
    }
    /**
     * Write a `uint32` value, an unsigned 32 bit varint.
     */
    uint32(B) {
      for ((0, g.assertUInt32)(B); B > 127; )
        this.buf.push(B & 127 | 128), B = B >>> 7;
      return this.buf.push(B), this;
    }
    /**
     * Write a `int32` value, a signed 32 bit varint.
     */
    int32(B) {
      return (0, g.assertInt32)(B), (0, o.varint32write)(B, this.buf), this;
    }
    /**
     * Write a `bool` value, a variant.
     */
    bool(B) {
      return this.buf.push(B ? 1 : 0), this;
    }
    /**
     * Write a `bytes` value, length-delimited arbitrary data.
     */
    bytes(B) {
      return this.uint32(B.byteLength), this.raw(B);
    }
    /**
     * Write a `string` value, length-delimited data converted to UTF-8 text.
     */
    string(B) {
      let D = this.textEncoder.encode(B);
      return this.uint32(D.byteLength), this.raw(D);
    }
    /**
     * Write a `float` value, 32-bit floating point number.
     */
    float(B) {
      (0, g.assertFloat32)(B);
      let D = new Uint8Array(4);
      return new DataView(D.buffer).setFloat32(0, B, !0), this.raw(D);
    }
    /**
     * Write a `double` value, a 64-bit floating point number.
     */
    double(B) {
      let D = new Uint8Array(8);
      return new DataView(D.buffer).setFloat64(0, B, !0), this.raw(D);
    }
    /**
     * Write a `fixed32` value, an unsigned, fixed-length 32-bit integer.
     */
    fixed32(B) {
      (0, g.assertUInt32)(B);
      let D = new Uint8Array(4);
      return new DataView(D.buffer).setUint32(0, B, !0), this.raw(D);
    }
    /**
     * Write a `sfixed32` value, a signed, fixed-length 32-bit integer.
     */
    sfixed32(B) {
      (0, g.assertInt32)(B);
      let D = new Uint8Array(4);
      return new DataView(D.buffer).setInt32(0, B, !0), this.raw(D);
    }
    /**
     * Write a `sint32` value, a signed, zigzag-encoded 32-bit varint.
     */
    sint32(B) {
      return (0, g.assertInt32)(B), B = (B << 1 ^ B >> 31) >>> 0, (0, o.varint32write)(B, this.buf), this;
    }
    /**
     * Write a `fixed64` value, a signed, fixed-length 64-bit integer.
     */
    sfixed64(B) {
      let D = new Uint8Array(8), x = new DataView(D.buffer), v = c.protoInt64.enc(B);
      return x.setInt32(0, v.lo, !0), x.setInt32(4, v.hi, !0), this.raw(D);
    }
    /**
     * Write a `fixed64` value, an unsigned, fixed-length 64 bit integer.
     */
    fixed64(B) {
      let D = new Uint8Array(8), x = new DataView(D.buffer), v = c.protoInt64.uEnc(B);
      return x.setInt32(0, v.lo, !0), x.setInt32(4, v.hi, !0), this.raw(D);
    }
    /**
     * Write a `int64` value, a signed 64-bit varint.
     */
    int64(B) {
      let D = c.protoInt64.enc(B);
      return (0, o.varint64write)(D.lo, D.hi, this.buf), this;
    }
    /**
     * Write a `sint64` value, a signed, zig-zag-encoded 64-bit varint.
     */
    sint64(B) {
      let D = c.protoInt64.enc(B), x = D.hi >> 31, v = D.lo << 1 ^ x, F = (D.hi << 1 | D.lo >>> 31) ^ x;
      return (0, o.varint64write)(v, F, this.buf), this;
    }
    /**
     * Write a `uint64` value, an unsigned 64-bit varint.
     */
    uint64(B) {
      let D = c.protoInt64.uEnc(B);
      return (0, o.varint64write)(D.lo, D.hi, this.buf), this;
    }
  }
  binaryEncoding.BinaryWriter = t;
  class d {
    constructor(B, D) {
      this.varint64 = o.varint64read, this.uint32 = o.varint32read, this.buf = B, this.len = B.length, this.pos = 0, this.view = new DataView(B.buffer, B.byteOffset, B.byteLength), this.textDecoder = D ?? new TextDecoder();
    }
    /**
     * Reads a tag - field number and wire type.
     */
    tag() {
      let B = this.uint32(), D = B >>> 3, x = B & 7;
      if (D <= 0 || x < 0 || x > 5)
        throw new Error("illegal tag: field no " + D + " wire type " + x);
      return [D, x];
    }
    /**
     * Skip one element and return the skipped data.
     *
     * When skipping StartGroup, provide the tags field number to check for
     * matching field number in the EndGroup tag.
     */
    skip(B, D) {
      let x = this.pos;
      switch (B) {
        case y.Varint:
          for (; this.buf[this.pos++] & 128; )
            ;
          break;
        // eslint-disable-next-line
        // @ts-ignore TS7029: Fallthrough case in switch
        case y.Bit64:
          this.pos += 4;
        // eslint-disable-next-line
        // @ts-ignore TS7029: Fallthrough case in switch
        case y.Bit32:
          this.pos += 4;
          break;
        case y.LengthDelimited:
          let v = this.uint32();
          this.pos += v;
          break;
        case y.StartGroup:
          for (; ; ) {
            const [F, M] = this.tag();
            if (M === y.EndGroup) {
              if (D !== void 0 && F !== D)
                throw new Error("invalid end group tag");
              break;
            }
            this.skip(M, F);
          }
          break;
        default:
          throw new Error("cant skip wire type " + B);
      }
      return this.assertBounds(), this.buf.subarray(x, this.pos);
    }
    /**
     * Throws error if position in byte array is out of range.
     */
    assertBounds() {
      if (this.pos > this.len)
        throw new RangeError("premature EOF");
    }
    /**
     * Read a `int32` field, a signed 32 bit varint.
     */
    int32() {
      return this.uint32() | 0;
    }
    /**
     * Read a `sint32` field, a signed, zigzag-encoded 32-bit varint.
     */
    sint32() {
      let B = this.uint32();
      return B >>> 1 ^ -(B & 1);
    }
    /**
     * Read a `int64` field, a signed 64-bit varint.
     */
    int64() {
      return c.protoInt64.dec(...this.varint64());
    }
    /**
     * Read a `uint64` field, an unsigned 64-bit varint.
     */
    uint64() {
      return c.protoInt64.uDec(...this.varint64());
    }
    /**
     * Read a `sint64` field, a signed, zig-zag-encoded 64-bit varint.
     */
    sint64() {
      let [B, D] = this.varint64(), x = -(B & 1);
      return B = (B >>> 1 | (D & 1) << 31) ^ x, D = D >>> 1 ^ x, c.protoInt64.dec(B, D);
    }
    /**
     * Read a `bool` field, a variant.
     */
    bool() {
      let [B, D] = this.varint64();
      return B !== 0 || D !== 0;
    }
    /**
     * Read a `fixed32` field, an unsigned, fixed-length 32-bit integer.
     */
    fixed32() {
      return this.view.getUint32((this.pos += 4) - 4, !0);
    }
    /**
     * Read a `sfixed32` field, a signed, fixed-length 32-bit integer.
     */
    sfixed32() {
      return this.view.getInt32((this.pos += 4) - 4, !0);
    }
    /**
     * Read a `fixed64` field, an unsigned, fixed-length 64 bit integer.
     */
    fixed64() {
      return c.protoInt64.uDec(this.sfixed32(), this.sfixed32());
    }
    /**
     * Read a `fixed64` field, a signed, fixed-length 64-bit integer.
     */
    sfixed64() {
      return c.protoInt64.dec(this.sfixed32(), this.sfixed32());
    }
    /**
     * Read a `float` field, 32-bit floating point number.
     */
    float() {
      return this.view.getFloat32((this.pos += 4) - 4, !0);
    }
    /**
     * Read a `double` field, a 64-bit floating point number.
     */
    double() {
      return this.view.getFloat64((this.pos += 8) - 8, !0);
    }
    /**
     * Read a `bytes` field, length-delimited arbitrary data.
     */
    bytes() {
      let B = this.uint32(), D = this.pos;
      return this.pos += B, this.assertBounds(), this.buf.subarray(D, D + B);
    }
    /**
     * Read a `string` field, length-delimited data converted to UTF-8 text.
     */
    string() {
      return this.textDecoder.decode(this.bytes());
    }
  }
  return binaryEncoding.BinaryReader = d, binaryEncoding;
}
var hasRequiredBinaryFormat;
function requireBinaryFormat() {
  if (hasRequiredBinaryFormat) return binaryFormat;
  hasRequiredBinaryFormat = 1, Object.defineProperty(binaryFormat, "__esModule", { value: !0 }), binaryFormat.writeMapEntry = binaryFormat.makeBinaryFormat = void 0;
  const o = requireBinaryEncoding(), g = requireFieldWrapper(), c = requireScalars(), y = requireAssert$1(), t = requireReflect(), d = requireScalar(), E = requireIsMessage(), B = Symbol("@bufbuild/protobuf/unknown-fields"), D = {
    readUnknownFields: !0,
    readerFactory: (De) => new o.BinaryReader(De)
  }, x = {
    writeUnknownFields: !0,
    writerFactory: () => new o.BinaryWriter()
  };
  function v(De) {
    return De ? Object.assign(Object.assign({}, D), De) : D;
  }
  function F(De) {
    return De ? Object.assign(Object.assign({}, x), De) : x;
  }
  function M() {
    return {
      makeReadOptions: v,
      makeWriteOptions: F,
      listUnknownFields(De) {
        var ve;
        return (ve = De[B]) !== null && ve !== void 0 ? ve : [];
      },
      discardUnknownFields(De) {
        delete De[B];
      },
      writeUnknownFields(De, ve) {
        const be = De[B];
        if (be)
          for (const Be of be)
            ve.tag(Be.no, Be.wireType).raw(Be.data);
      },
      onUnknownField(De, ve, Fe, be) {
        const Be = De;
        Array.isArray(Be[B]) || (Be[B] = []), Be[B].push({ no: ve, wireType: Fe, data: be });
      },
      readMessage(De, ve, Fe, be, Be) {
        const ke = De.getType(), xe = Be ? ve.len : ve.pos + Fe;
        let Ne, Et;
        for (; ve.pos < xe && ([Ne, Et] = ve.tag(), !(Be === !0 && Et == o.WireType.EndGroup)); ) {
          const st = ke.fields.find(Ne);
          if (!st) {
            const Dt = ve.skip(Et, Ne);
            be.readUnknownFields && this.onUnknownField(De, Ne, Et, Dt);
            continue;
          }
          U(De, ve, st, Et, be);
        }
        if (Be && // eslint-disable-line @typescript-eslint/strict-boolean-expressions
        (Et != o.WireType.EndGroup || Ne !== Fe))
          throw new Error("invalid end group tag");
      },
      readField: U,
      writeMessage(De, ve, Fe) {
        const be = De.getType();
        for (const Be of be.fields.byNumber()) {
          if (!(0, t.isFieldSet)(Be, De)) {
            if (Be.req)
              throw new Error(`cannot encode field ${be.typeName}.${Be.name} to binary: required field not set`);
            continue;
          }
          const ke = Be.oneof ? De[Be.oneof.localName].value : De[Be.localName];
          Ie(Be, ke, ve, Fe);
        }
        return Fe.writeUnknownFields && this.writeUnknownFields(De, ve), ve;
      },
      writeField(De, ve, Fe, be) {
        ve !== void 0 && Ie(De, ve, Fe, be);
      }
    };
  }
  binaryFormat.makeBinaryFormat = M;
  function U(De, ve, Fe, be, Be) {
    let { repeated: ke, localName: xe } = Fe;
    switch (Fe.oneof && (De = De[Fe.oneof.localName], De.case != xe && delete De.value, De.case = xe, xe = "value"), Fe.kind) {
      case "scalar":
      case "enum":
        const Ne = Fe.kind == "enum" ? d.ScalarType.INT32 : Fe.T;
        let Et = ge;
        if (Fe.kind == "scalar" && Fe.L > 0 && (Et = fe), ke) {
          let xt = De[xe];
          if (be == o.WireType.LengthDelimited && Ne != d.ScalarType.STRING && Ne != d.ScalarType.BYTES) {
            let sr = ve.uint32() + ve.pos;
            for (; ve.pos < sr; )
              xt.push(Et(ve, Ne));
          } else
            xt.push(Et(ve, Ne));
        } else
          De[xe] = Et(ve, Ne);
        break;
      case "message":
        const st = Fe.T;
        ke ? De[xe].push(L(ve, new st(), Be, Fe)) : (0, E.isMessage)(De[xe]) ? L(ve, De[xe], Be, Fe) : (De[xe] = L(ve, new st(), Be, Fe), st.fieldWrapper && !Fe.oneof && !Fe.repeated && (De[xe] = st.fieldWrapper.unwrapField(De[xe])));
        break;
      case "map":
        let [Dt, er] = H(Fe, ve, Be);
        De[xe][Dt] = er;
        break;
    }
  }
  function L(De, ve, Fe, be) {
    const Be = ve.getType().runtime.bin, ke = be == null ? void 0 : be.delimited;
    return Be.readMessage(
      ve,
      De,
      ke ? be.no : De.uint32(),
      // eslint-disable-line @typescript-eslint/strict-boolean-expressions
      Fe,
      ke
    ), ve;
  }
  function H(De, ve, Fe) {
    const be = ve.uint32(), Be = ve.pos + be;
    let ke, xe;
    for (; ve.pos < Be; ) {
      const [Ne] = ve.tag();
      switch (Ne) {
        case 1:
          ke = ge(ve, De.K);
          break;
        case 2:
          switch (De.V.kind) {
            case "scalar":
              xe = ge(ve, De.V.T);
              break;
            case "enum":
              xe = ve.int32();
              break;
            case "message":
              xe = L(ve, new De.V.T(), Fe, void 0);
              break;
          }
          break;
      }
    }
    if (ke === void 0 && (ke = (0, c.scalarZeroValue)(De.K, d.LongType.BIGINT)), typeof ke != "string" && typeof ke != "number" && (ke = ke.toString()), xe === void 0)
      switch (De.V.kind) {
        case "scalar":
          xe = (0, c.scalarZeroValue)(De.V.T, d.LongType.BIGINT);
          break;
        case "enum":
          xe = De.V.T.values[0].no;
          break;
        case "message":
          xe = new De.V.T();
          break;
      }
    return [ke, xe];
  }
  function fe(De, ve) {
    const Fe = ge(De, ve);
    return typeof Fe == "bigint" ? Fe.toString() : Fe;
  }
  function ge(De, ve) {
    switch (ve) {
      case d.ScalarType.STRING:
        return De.string();
      case d.ScalarType.BOOL:
        return De.bool();
      case d.ScalarType.DOUBLE:
        return De.double();
      case d.ScalarType.FLOAT:
        return De.float();
      case d.ScalarType.INT32:
        return De.int32();
      case d.ScalarType.INT64:
        return De.int64();
      case d.ScalarType.UINT64:
        return De.uint64();
      case d.ScalarType.FIXED64:
        return De.fixed64();
      case d.ScalarType.BYTES:
        return De.bytes();
      case d.ScalarType.FIXED32:
        return De.fixed32();
      case d.ScalarType.SFIXED32:
        return De.sfixed32();
      case d.ScalarType.SFIXED64:
        return De.sfixed64();
      case d.ScalarType.SINT64:
        return De.sint64();
      case d.ScalarType.UINT32:
        return De.uint32();
      case d.ScalarType.SINT32:
        return De.sint32();
    }
  }
  function Ie(De, ve, Fe, be) {
    (0, y.assert)(ve !== void 0);
    const Be = De.repeated;
    switch (De.kind) {
      case "scalar":
      case "enum":
        let ke = De.kind == "enum" ? d.ScalarType.INT32 : De.T;
        if (Be)
          if ((0, y.assert)(Array.isArray(ve)), De.packed)
            He(Fe, ke, De.no, ve);
          else
            for (const xe of ve)
              ze(Fe, ke, De.no, xe);
        else
          ze(Fe, ke, De.no, ve);
        break;
      case "message":
        if (Be) {
          (0, y.assert)(Array.isArray(ve));
          for (const xe of ve)
            Se(Fe, be, De, xe);
        } else
          Se(Fe, be, De, ve);
        break;
      case "map":
        (0, y.assert)(typeof ve == "object" && ve != null);
        for (const [xe, Ne] of Object.entries(ve))
          Ee(Fe, be, De, xe, Ne);
        break;
    }
  }
  function Ee(De, ve, Fe, be, Be) {
    De.tag(Fe.no, o.WireType.LengthDelimited), De.fork();
    let ke = be;
    switch (Fe.K) {
      case d.ScalarType.INT32:
      case d.ScalarType.FIXED32:
      case d.ScalarType.UINT32:
      case d.ScalarType.SFIXED32:
      case d.ScalarType.SINT32:
        ke = Number.parseInt(be);
        break;
      case d.ScalarType.BOOL:
        (0, y.assert)(be == "true" || be == "false"), ke = be == "true";
        break;
    }
    switch (ze(De, Fe.K, 1, ke), Fe.V.kind) {
      case "scalar":
        ze(De, Fe.V.T, 2, Be);
        break;
      case "enum":
        ze(De, d.ScalarType.INT32, 2, Be);
        break;
      case "message":
        (0, y.assert)(Be !== void 0), De.tag(2, o.WireType.LengthDelimited).bytes(Be.toBinary(ve));
        break;
    }
    De.join();
  }
  binaryFormat.writeMapEntry = Ee;
  function Se(De, ve, Fe, be) {
    const Be = (0, g.wrapField)(Fe.T, be);
    Fe.delimited ? De.tag(Fe.no, o.WireType.StartGroup).raw(Be.toBinary(ve)).tag(Fe.no, o.WireType.EndGroup) : De.tag(Fe.no, o.WireType.LengthDelimited).bytes(Be.toBinary(ve));
  }
  function ze(De, ve, Fe, be) {
    (0, y.assert)(be !== void 0);
    let [Be, ke] = Pe(ve);
    De.tag(Fe, Be)[ke](be);
  }
  function He(De, ve, Fe, be) {
    if (!be.length)
      return;
    De.tag(Fe, o.WireType.LengthDelimited).fork();
    let [, Be] = Pe(ve);
    for (let ke = 0; ke < be.length; ke++)
      De[Be](be[ke]);
    De.join();
  }
  function Pe(De) {
    let ve = o.WireType.Varint;
    switch (De) {
      case d.ScalarType.BYTES:
      case d.ScalarType.STRING:
        ve = o.WireType.LengthDelimited;
        break;
      case d.ScalarType.DOUBLE:
      case d.ScalarType.FIXED64:
      case d.ScalarType.SFIXED64:
        ve = o.WireType.Bit64;
        break;
      case d.ScalarType.FIXED32:
      case d.ScalarType.SFIXED32:
      case d.ScalarType.FLOAT:
        ve = o.WireType.Bit32;
        break;
    }
    const Fe = d.ScalarType[De].toLowerCase();
    return [ve, Fe];
  }
  return binaryFormat;
}
var utilCommon = {}, hasRequiredUtilCommon;
function requireUtilCommon() {
  if (hasRequiredUtilCommon) return utilCommon;
  hasRequiredUtilCommon = 1, Object.defineProperty(utilCommon, "__esModule", { value: !0 }), utilCommon.makeUtilCommon = void 0;
  const o = require_enum(), g = requireScalars(), c = requireScalar(), y = requireIsMessage();
  function t() {
    return {
      setEnumType: o.setEnumType,
      initPartial(B, D) {
        if (B === void 0)
          return;
        const x = D.getType();
        for (const v of x.fields.byMember()) {
          const F = v.localName, M = D, U = B;
          if (U[F] != null)
            switch (v.kind) {
              case "oneof":
                const L = U[F].case;
                if (L === void 0)
                  continue;
                const H = v.findField(L);
                let fe = U[F].value;
                H && H.kind == "message" && !(0, y.isMessage)(fe, H.T) ? fe = new H.T(fe) : H && H.kind === "scalar" && H.T === c.ScalarType.BYTES && (fe = E(fe)), M[F] = { case: L, value: fe };
                break;
              case "scalar":
              case "enum":
                let ge = U[F];
                v.T === c.ScalarType.BYTES && (ge = v.repeated ? ge.map(E) : E(ge)), M[F] = ge;
                break;
              case "map":
                switch (v.V.kind) {
                  case "scalar":
                  case "enum":
                    if (v.V.T === c.ScalarType.BYTES)
                      for (const [Se, ze] of Object.entries(U[F]))
                        M[F][Se] = E(ze);
                    else
                      Object.assign(M[F], U[F]);
                    break;
                  case "message":
                    const Ee = v.V.T;
                    for (const Se of Object.keys(U[F])) {
                      let ze = U[F][Se];
                      Ee.fieldWrapper || (ze = new Ee(ze)), M[F][Se] = ze;
                    }
                    break;
                }
                break;
              case "message":
                const Ie = v.T;
                if (v.repeated)
                  M[F] = U[F].map((Ee) => (0, y.isMessage)(Ee, Ie) ? Ee : new Ie(Ee));
                else {
                  const Ee = U[F];
                  Ie.fieldWrapper ? /* We can't use BytesValue.typeName as that will create a circular import */ Ie.typeName === "google.protobuf.BytesValue" ? M[F] = E(Ee) : M[F] = Ee : M[F] = (0, y.isMessage)(Ee, Ie) ? Ee : new Ie(Ee);
                }
                break;
            }
        }
      },
      // TODO use isFieldSet() here to support future field presence
      equals(B, D, x) {
        return D === x ? !0 : !D || !x ? !1 : B.fields.byMember().every((v) => {
          const F = D[v.localName], M = x[v.localName];
          if (v.repeated) {
            if (F.length !== M.length)
              return !1;
            switch (v.kind) {
              case "message":
                return F.every((U, L) => v.T.equals(U, M[L]));
              case "scalar":
                return F.every((U, L) => (0, g.scalarEquals)(v.T, U, M[L]));
              case "enum":
                return F.every((U, L) => (0, g.scalarEquals)(c.ScalarType.INT32, U, M[L]));
            }
            throw new Error(`repeated cannot contain ${v.kind}`);
          }
          switch (v.kind) {
            case "message":
              let U = F, L = M;
              return v.T.fieldWrapper && (U !== void 0 && !(0, y.isMessage)(U) && (U = v.T.fieldWrapper.wrapField(U)), L !== void 0 && !(0, y.isMessage)(L) && (L = v.T.fieldWrapper.wrapField(L))), v.T.equals(U, L);
            case "enum":
              return (0, g.scalarEquals)(c.ScalarType.INT32, F, M);
            case "scalar":
              return (0, g.scalarEquals)(v.T, F, M);
            case "oneof":
              if (F.case !== M.case)
                return !1;
              const H = v.findField(F.case);
              if (H === void 0)
                return !0;
              switch (H.kind) {
                case "message":
                  return H.T.equals(F.value, M.value);
                case "enum":
                  return (0, g.scalarEquals)(c.ScalarType.INT32, F.value, M.value);
                case "scalar":
                  return (0, g.scalarEquals)(H.T, F.value, M.value);
              }
              throw new Error(`oneof cannot contain ${H.kind}`);
            case "map":
              const fe = Object.keys(F).concat(Object.keys(M));
              switch (v.V.kind) {
                case "message":
                  const ge = v.V.T;
                  return fe.every((Ee) => ge.equals(F[Ee], M[Ee]));
                case "enum":
                  return fe.every((Ee) => (0, g.scalarEquals)(c.ScalarType.INT32, F[Ee], M[Ee]));
                case "scalar":
                  const Ie = v.V.T;
                  return fe.every((Ee) => (0, g.scalarEquals)(Ie, F[Ee], M[Ee]));
              }
              break;
          }
        });
      },
      // TODO use isFieldSet() here to support future field presence
      clone(B) {
        const D = B.getType(), x = new D(), v = x;
        for (const F of D.fields.byMember()) {
          const M = B[F.localName];
          let U;
          if (F.repeated)
            U = M.map(d);
          else if (F.kind == "map") {
            U = v[F.localName];
            for (const [L, H] of Object.entries(M))
              U[L] = d(H);
          } else F.kind == "oneof" ? U = F.findField(M.case) ? { case: M.case, value: d(M.value) } : { case: void 0 } : U = d(M);
          v[F.localName] = U;
        }
        for (const F of D.runtime.bin.listUnknownFields(B))
          D.runtime.bin.onUnknownField(v, F.no, F.wireType, F.data);
        return x;
      }
    };
  }
  utilCommon.makeUtilCommon = t;
  function d(B) {
    if (B === void 0)
      return B;
    if ((0, y.isMessage)(B))
      return B.clone();
    if (B instanceof Uint8Array) {
      const D = new Uint8Array(B.byteLength);
      return D.set(B), D;
    }
    return B;
  }
  function E(B) {
    return B instanceof Uint8Array ? B : new Uint8Array(B);
  }
  return utilCommon;
}
var hasRequiredProtoRuntime;
function requireProtoRuntime() {
  if (hasRequiredProtoRuntime) return protoRuntime;
  hasRequiredProtoRuntime = 1, Object.defineProperty(protoRuntime, "__esModule", { value: !0 }), protoRuntime.makeProtoRuntime = void 0;
  const o = require_enum(), g = requireMessageType(), c = requireExtensions(), y = requireJsonFormat(), t = requireBinaryFormat(), d = requireUtilCommon();
  function E(B, D, x) {
    return {
      syntax: B,
      json: (0, y.makeJsonFormat)(),
      bin: (0, t.makeBinaryFormat)(),
      util: Object.assign(Object.assign({}, (0, d.makeUtilCommon)()), {
        newFieldList: D,
        initFields: x
      }),
      makeMessageType(v, F, M) {
        return (0, g.makeMessageType)(this, v, F, M);
      },
      makeEnum: o.makeEnum,
      makeEnumType: o.makeEnumType,
      getEnumType: o.getEnumType,
      makeExtension(v, F, M) {
        return (0, c.makeExtension)(this, v, F, M);
      }
    };
  }
  return protoRuntime.makeProtoRuntime = E, protoRuntime;
}
var fieldList = {}, hasRequiredFieldList;
function requireFieldList() {
  if (hasRequiredFieldList) return fieldList;
  hasRequiredFieldList = 1, Object.defineProperty(fieldList, "__esModule", { value: !0 }), fieldList.InternalFieldList = void 0;
  class o {
    constructor(c, y) {
      this._fields = c, this._normalizer = y;
    }
    findJsonName(c) {
      if (!this.jsonNames) {
        const y = {};
        for (const t of this.list())
          y[t.jsonName] = y[t.name] = t;
        this.jsonNames = y;
      }
      return this.jsonNames[c];
    }
    find(c) {
      if (!this.numbers) {
        const y = {};
        for (const t of this.list())
          y[t.no] = t;
        this.numbers = y;
      }
      return this.numbers[c];
    }
    list() {
      return this.all || (this.all = this._normalizer(this._fields)), this.all;
    }
    byNumber() {
      return this.numbersAsc || (this.numbersAsc = this.list().concat().sort((c, y) => c.no - y.no)), this.numbersAsc;
    }
    byMember() {
      if (!this.members) {
        this.members = [];
        const c = this.members;
        let y;
        for (const t of this.list())
          t.oneof ? t.oneof !== y && (y = t.oneof, c.push(y)) : c.push(t);
      }
      return this.members;
    }
  }
  return fieldList.InternalFieldList = o, fieldList;
}
var fieldNormalize = {}, field$1 = {}, names = {}, hasRequiredNames;
function requireNames() {
  return hasRequiredNames || (hasRequiredNames = 1, function(o) {
    Object.defineProperty(o, "__esModule", { value: !0 }), o.safeIdentifier = o.safeObjectProperty = o.findEnumSharedPrefix = o.fieldJsonName = o.localOneofName = o.localFieldName = o.localName = void 0;
    function g(L) {
      switch (L.kind) {
        case "field":
          return c(L.name, L.oneof !== void 0);
        case "oneof":
          return y(L.name);
        case "enum":
        case "message":
        case "service":
        case "extension": {
          const H = L.file.proto.package, fe = H === void 0 ? 0 : H.length + 1, ge = L.typeName.substring(fe).replace(/\./g, "_");
          return (0, o.safeObjectProperty)((0, o.safeIdentifier)(ge));
        }
        case "enum_value": {
          let H = L.name;
          const fe = L.parent.sharedPrefix;
          return fe !== void 0 && (H = H.substring(fe.length)), (0, o.safeObjectProperty)(H);
        }
        case "rpc": {
          let H = L.name;
          return H.length == 0 ? H : (H = H[0].toLowerCase() + H.substring(1), (0, o.safeObjectProperty)(H));
        }
      }
    }
    o.localName = g;
    function c(L, H) {
      const fe = E(L);
      return H ? fe : (0, o.safeObjectProperty)(F(fe));
    }
    o.localFieldName = c;
    function y(L) {
      return c(L, !1);
    }
    o.localOneofName = y, o.fieldJsonName = E;
    function t(L, H) {
      const fe = d(L) + "_";
      for (const ge of H) {
        if (!ge.toLowerCase().startsWith(fe))
          return;
        const Ie = ge.substring(fe.length);
        if (Ie.length == 0 || /^\d/.test(Ie))
          return;
      }
      return fe;
    }
    o.findEnumSharedPrefix = t;
    function d(L) {
      return (L.substring(0, 1) + L.substring(1).replace(/[A-Z]/g, (H) => "_" + H)).toLowerCase();
    }
    function E(L) {
      let H = !1;
      const fe = [];
      for (let ge = 0; ge < L.length; ge++) {
        let Ie = L.charAt(ge);
        switch (Ie) {
          case "_":
            H = !0;
            break;
          case "0":
          case "1":
          case "2":
          case "3":
          case "4":
          case "5":
          case "6":
          case "7":
          case "8":
          case "9":
            fe.push(Ie), H = !1;
            break;
          default:
            H && (H = !1, Ie = Ie.toUpperCase()), fe.push(Ie);
            break;
        }
      }
      return fe.join("");
    }
    const B = /* @__PURE__ */ new Set([
      // ECMAScript 2015 keywords
      "break",
      "case",
      "catch",
      "class",
      "const",
      "continue",
      "debugger",
      "default",
      "delete",
      "do",
      "else",
      "export",
      "extends",
      "false",
      "finally",
      "for",
      "function",
      "if",
      "import",
      "in",
      "instanceof",
      "new",
      "null",
      "return",
      "super",
      "switch",
      "this",
      "throw",
      "true",
      "try",
      "typeof",
      "var",
      "void",
      "while",
      "with",
      "yield",
      // ECMAScript 2015 future reserved keywords
      "enum",
      "implements",
      "interface",
      "let",
      "package",
      "private",
      "protected",
      "public",
      "static",
      // Class name cannot be 'Object' when targeting ES5 with module CommonJS
      "Object",
      // TypeScript keywords that cannot be used for types (as opposed to variables)
      "bigint",
      "number",
      "boolean",
      "string",
      "object",
      // Identifiers reserved for the runtime, so we can generate legible code
      "globalThis",
      "Uint8Array",
      "Partial"
    ]), D = /* @__PURE__ */ new Set([
      // names reserved by JavaScript
      "constructor",
      "toString",
      "toJSON",
      "valueOf"
    ]), x = /* @__PURE__ */ new Set([
      // names reserved by the runtime
      "getType",
      "clone",
      "equals",
      "fromBinary",
      "fromJson",
      "fromJsonString",
      "toBinary",
      "toJson",
      "toJsonString",
      // names reserved by the runtime for the future
      "toObject"
    ]), v = (L) => `${L}$`, F = (L) => x.has(L) ? v(L) : L, M = (L) => D.has(L) ? v(L) : L;
    o.safeObjectProperty = M;
    const U = (L) => B.has(L) ? v(L) : L;
    o.safeIdentifier = U;
  }(names)), names;
}
var hasRequiredField$1;
function requireField$1() {
  if (hasRequiredField$1) return field$1;
  hasRequiredField$1 = 1, Object.defineProperty(field$1, "__esModule", { value: !0 }), field$1.InternalOneofInfo = void 0;
  const o = requireNames(), g = requireAssert$1();
  class c {
    constructor(t) {
      this.kind = "oneof", this.repeated = !1, this.packed = !1, this.opt = !1, this.req = !1, this.default = void 0, this.fields = [], this.name = t, this.localName = (0, o.localOneofName)(t);
    }
    addField(t) {
      (0, g.assert)(t.oneof === this, `field ${t.name} not one of ${this.name}`), this.fields.push(t);
    }
    findField(t) {
      if (!this._lookup) {
        this._lookup = /* @__PURE__ */ Object.create(null);
        for (let d = 0; d < this.fields.length; d++)
          this._lookup[this.fields[d].localName] = this.fields[d];
      }
      return this._lookup[t];
    }
  }
  return field$1.InternalOneofInfo = c, field$1;
}
var hasRequiredFieldNormalize;
function requireFieldNormalize() {
  if (hasRequiredFieldNormalize) return fieldNormalize;
  hasRequiredFieldNormalize = 1, Object.defineProperty(fieldNormalize, "__esModule", { value: !0 }), fieldNormalize.normalizeFieldInfos = void 0;
  const o = requireField$1(), g = requireNames(), c = requireScalar();
  function y(t, d) {
    var E, B, D, x, v, F;
    const M = [];
    let U;
    for (const L of typeof t == "function" ? t() : t) {
      const H = L;
      if (H.localName = (0, g.localFieldName)(L.name, L.oneof !== void 0), H.jsonName = (E = L.jsonName) !== null && E !== void 0 ? E : (0, g.fieldJsonName)(L.name), H.repeated = (B = L.repeated) !== null && B !== void 0 ? B : !1, L.kind == "scalar" && (H.L = (D = L.L) !== null && D !== void 0 ? D : c.LongType.BIGINT), H.delimited = (x = L.delimited) !== null && x !== void 0 ? x : !1, H.req = (v = L.req) !== null && v !== void 0 ? v : !1, H.opt = (F = L.opt) !== null && F !== void 0 ? F : !1, L.packed === void 0 && (d ? H.packed = L.kind == "enum" || L.kind == "scalar" && L.T != c.ScalarType.BYTES && L.T != c.ScalarType.STRING : H.packed = !1), L.oneof !== void 0) {
        const fe = typeof L.oneof == "string" ? L.oneof : L.oneof.name;
        (!U || U.name != fe) && (U = new o.InternalOneofInfo(fe)), H.oneof = U, U.addField(H);
      }
      M.push(H);
    }
    return M;
  }
  return fieldNormalize.normalizeFieldInfos = y, fieldNormalize;
}
var hasRequiredProto3;
function requireProto3() {
  if (hasRequiredProto3) return proto3;
  hasRequiredProto3 = 1, Object.defineProperty(proto3, "__esModule", { value: !0 }), proto3.proto3 = void 0;
  const o = requireProtoRuntime(), g = requireFieldList(), c = requireScalars(), y = requireFieldNormalize();
  return proto3.proto3 = (0, o.makeProtoRuntime)(
    "proto3",
    (t) => new g.InternalFieldList(t, (d) => (0, y.normalizeFieldInfos)(d, !0)),
    // TODO merge with proto2 and initExtensionField, also see initPartial, equals, clone
    (t) => {
      for (const d of t.getType().fields.byMember()) {
        if (d.opt)
          continue;
        const E = d.localName, B = t;
        if (d.repeated) {
          B[E] = [];
          continue;
        }
        switch (d.kind) {
          case "oneof":
            B[E] = { case: void 0 };
            break;
          case "enum":
            B[E] = 0;
            break;
          case "map":
            B[E] = {};
            break;
          case "scalar":
            B[E] = (0, c.scalarZeroValue)(d.T, d.L);
            break;
        }
      }
    }
  ), proto3;
}
var proto2 = {}, hasRequiredProto2;
function requireProto2() {
  if (hasRequiredProto2) return proto2;
  hasRequiredProto2 = 1, Object.defineProperty(proto2, "__esModule", { value: !0 }), proto2.proto2 = void 0;
  const o = requireProtoRuntime(), g = requireFieldList(), c = requireFieldNormalize();
  return proto2.proto2 = (0, o.makeProtoRuntime)(
    "proto2",
    (y) => new g.InternalFieldList(y, (t) => (0, c.normalizeFieldInfos)(t, !1)),
    // TODO merge with proto3 and initExtensionField, also see initPartial, equals, clone
    (y) => {
      for (const t of y.getType().fields.byMember()) {
        const d = t.localName, E = y;
        if (t.repeated) {
          E[d] = [];
          continue;
        }
        switch (t.kind) {
          case "oneof":
            E[d] = { case: void 0 };
            break;
          case "map":
            E[d] = {};
            break;
        }
      }
    }
  ), proto2;
}
var protoDouble = {}, hasRequiredProtoDouble;
function requireProtoDouble() {
  return hasRequiredProtoDouble || (hasRequiredProtoDouble = 1, Object.defineProperty(protoDouble, "__esModule", { value: !0 }), protoDouble.protoDouble = void 0, protoDouble.protoDouble = {
    NaN: Number.NaN,
    POSITIVE_INFINITY: Number.POSITIVE_INFINITY,
    NEGATIVE_INFINITY: Number.NEGATIVE_INFINITY
  }), protoDouble;
}
var protoDelimited = {}, hasRequiredProtoDelimited;
function requireProtoDelimited() {
  return hasRequiredProtoDelimited || (hasRequiredProtoDelimited = 1, function(o) {
    var g = protoDelimited && protoDelimited.__asyncValues || function(d) {
      if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
      var E = d[Symbol.asyncIterator], B;
      return E ? E.call(d) : (d = typeof __values == "function" ? __values(d) : d[Symbol.iterator](), B = {}, D("next"), D("throw"), D("return"), B[Symbol.asyncIterator] = function() {
        return this;
      }, B);
      function D(v) {
        B[v] = d[v] && function(F) {
          return new Promise(function(M, U) {
            F = d[v](F), x(M, U, F.done, F.value);
          });
        };
      }
      function x(v, F, M, U) {
        Promise.resolve(U).then(function(L) {
          v({ value: L, done: M });
        }, F);
      }
    }, c = protoDelimited && protoDelimited.__await || function(d) {
      return this instanceof c ? (this.v = d, this) : new c(d);
    }, y = protoDelimited && protoDelimited.__asyncGenerator || function(d, E, B) {
      if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
      var D = B.apply(d, E || []), x, v = [];
      return x = {}, M("next"), M("throw"), M("return", F), x[Symbol.asyncIterator] = function() {
        return this;
      }, x;
      function F(Ie) {
        return function(Ee) {
          return Promise.resolve(Ee).then(Ie, fe);
        };
      }
      function M(Ie, Ee) {
        D[Ie] && (x[Ie] = function(Se) {
          return new Promise(function(ze, He) {
            v.push([Ie, Se, ze, He]) > 1 || U(Ie, Se);
          });
        }, Ee && (x[Ie] = Ee(x[Ie])));
      }
      function U(Ie, Ee) {
        try {
          L(D[Ie](Ee));
        } catch (Se) {
          ge(v[0][3], Se);
        }
      }
      function L(Ie) {
        Ie.value instanceof c ? Promise.resolve(Ie.value.v).then(H, fe) : ge(v[0][2], Ie);
      }
      function H(Ie) {
        U("next", Ie);
      }
      function fe(Ie) {
        U("throw", Ie);
      }
      function ge(Ie, Ee) {
        Ie(Ee), v.shift(), v.length && U(v[0][0], v[0][1]);
      }
    };
    Object.defineProperty(o, "__esModule", { value: !0 }), o.protoDelimited = void 0;
    const t = requireBinaryEncoding();
    o.protoDelimited = {
      /**
       * Serialize a message, prefixing it with its size.
       */
      enc(d, E) {
        const B = d.getType().runtime.bin.makeWriteOptions(E);
        return B.writerFactory().bytes(d.toBinary(B)).finish();
      },
      /**
       * Parse a size-delimited message, ignoring extra bytes.
       */
      dec(d, E, B) {
        const D = d.runtime.bin.makeReadOptions(B);
        return d.fromBinary(D.readerFactory(E).bytes(), D);
      },
      /**
       * Parse a stream of size-delimited messages.
       */
      decStream(d, E) {
        return y(this, arguments, function* () {
          var D, x, v, F;
          function M(ge, Ie) {
            const Ee = new Uint8Array(ge.byteLength + Ie.byteLength);
            return Ee.set(ge), Ee.set(Ie, ge.length), Ee;
          }
          let U = new Uint8Array(0);
          try {
            for (var L = !0, H = g(E), fe; fe = yield c(H.next()), D = fe.done, !D; L = !0)
              for (F = fe.value, L = !1, U = M(U, F); ; ) {
                const Ie = o.protoDelimited.peekSize(U);
                if (Ie.eof || Ie.offset + Ie.size > U.byteLength)
                  break;
                yield yield c(o.protoDelimited.dec(d, U)), U = U.subarray(Ie.offset + Ie.size);
              }
          } catch (ge) {
            x = { error: ge };
          } finally {
            try {
              !L && !D && (v = H.return) && (yield c(v.call(H)));
            } finally {
              if (x) throw x.error;
            }
          }
          if (U.byteLength > 0)
            throw new Error("incomplete data");
        });
      },
      /**
       * Decodes the size from the given size-delimited message, which may be
       * incomplete.
       *
       * Returns an object with the following properties:
       * - size: The size of the delimited message in bytes
       * - offset: The offset in the given byte array where the message starts
       * - eof: true
       *
       * If the size-delimited data does not include all bytes of the varint size,
       * the following object is returned:
       * - size: null
       * - offset: null
       * - eof: false
       *
       * This function can be used to implement parsing of size-delimited messages
       * from a stream.
       */
      peekSize(d) {
        const E = { eof: !0, size: null, offset: null };
        for (let B = 0; B < 10; B++) {
          if (B > d.byteLength)
            return E;
          if ((d[B] & 128) == 0) {
            const D = new t.BinaryReader(d);
            let x;
            try {
              x = D.uint32();
            } catch (v) {
              if (v instanceof RangeError)
                return E;
              throw v;
            }
            return {
              eof: !1,
              size: x,
              offset: D.pos
            };
          }
        }
        throw new Error("invalid varint");
      }
    };
  }(protoDelimited)), protoDelimited;
}
var codegenInfo = {}, reifyWkt = {}, hasRequiredReifyWkt;
function requireReifyWkt() {
  if (hasRequiredReifyWkt) return reifyWkt;
  hasRequiredReifyWkt = 1, Object.defineProperty(reifyWkt, "__esModule", { value: !0 }), reifyWkt.reifyWkt = void 0;
  const o = requireScalar();
  function g(c) {
    switch (c.typeName) {
      case "google.protobuf.Any": {
        const y = c.fields.find((d) => d.number == 1 && d.fieldKind == "scalar" && d.scalar === o.ScalarType.STRING), t = c.fields.find((d) => d.number == 2 && d.fieldKind == "scalar" && d.scalar === o.ScalarType.BYTES);
        if (y && t)
          return {
            typeName: c.typeName,
            typeUrl: y,
            value: t
          };
        break;
      }
      case "google.protobuf.Timestamp": {
        const y = c.fields.find((d) => d.number == 1 && d.fieldKind == "scalar" && d.scalar === o.ScalarType.INT64), t = c.fields.find((d) => d.number == 2 && d.fieldKind == "scalar" && d.scalar === o.ScalarType.INT32);
        if (y && t)
          return {
            typeName: c.typeName,
            seconds: y,
            nanos: t
          };
        break;
      }
      case "google.protobuf.Duration": {
        const y = c.fields.find((d) => d.number == 1 && d.fieldKind == "scalar" && d.scalar === o.ScalarType.INT64), t = c.fields.find((d) => d.number == 2 && d.fieldKind == "scalar" && d.scalar === o.ScalarType.INT32);
        if (y && t)
          return {
            typeName: c.typeName,
            seconds: y,
            nanos: t
          };
        break;
      }
      case "google.protobuf.Struct": {
        const y = c.fields.find((t) => t.number == 1 && !t.repeated);
        if ((y == null ? void 0 : y.fieldKind) !== "map" || y.mapValue.kind !== "message" || y.mapValue.message.typeName !== "google.protobuf.Value")
          break;
        return { typeName: c.typeName, fields: y };
      }
      case "google.protobuf.Value": {
        const y = c.oneofs.find((v) => v.name === "kind"), t = c.fields.find((v) => v.number == 1 && v.oneof === y);
        if ((t == null ? void 0 : t.fieldKind) !== "enum" || t.enum.typeName !== "google.protobuf.NullValue")
          return;
        const d = c.fields.find((v) => v.number == 2 && v.fieldKind == "scalar" && v.scalar === o.ScalarType.DOUBLE && v.oneof === y), E = c.fields.find((v) => v.number == 3 && v.fieldKind == "scalar" && v.scalar === o.ScalarType.STRING && v.oneof === y), B = c.fields.find((v) => v.number == 4 && v.fieldKind == "scalar" && v.scalar === o.ScalarType.BOOL && v.oneof === y), D = c.fields.find((v) => v.number == 5 && v.oneof === y);
        if ((D == null ? void 0 : D.fieldKind) !== "message" || D.message.typeName !== "google.protobuf.Struct")
          return;
        const x = c.fields.find((v) => v.number == 6 && v.oneof === y);
        if ((x == null ? void 0 : x.fieldKind) !== "message" || x.message.typeName !== "google.protobuf.ListValue")
          return;
        if (y && d && E && B)
          return {
            typeName: c.typeName,
            kind: y,
            nullValue: t,
            numberValue: d,
            stringValue: E,
            boolValue: B,
            structValue: D,
            listValue: x
          };
        break;
      }
      case "google.protobuf.ListValue": {
        const y = c.fields.find((t) => t.number == 1 && t.repeated);
        if ((y == null ? void 0 : y.fieldKind) != "message" || y.message.typeName !== "google.protobuf.Value")
          break;
        return { typeName: c.typeName, values: y };
      }
      case "google.protobuf.FieldMask": {
        const y = c.fields.find((t) => t.number == 1 && t.fieldKind == "scalar" && t.scalar === o.ScalarType.STRING && t.repeated);
        if (y)
          return { typeName: c.typeName, paths: y };
        break;
      }
      case "google.protobuf.DoubleValue":
      case "google.protobuf.FloatValue":
      case "google.protobuf.Int64Value":
      case "google.protobuf.UInt64Value":
      case "google.protobuf.Int32Value":
      case "google.protobuf.UInt32Value":
      case "google.protobuf.BoolValue":
      case "google.protobuf.StringValue":
      case "google.protobuf.BytesValue": {
        const y = c.fields.find((t) => t.number == 1 && t.name == "value");
        if (!y || y.fieldKind !== "scalar")
          break;
        return { typeName: c.typeName, value: y };
      }
    }
  }
  return reifyWkt.reifyWkt = g, reifyWkt;
}
var hasRequiredCodegenInfo;
function requireCodegenInfo() {
  if (hasRequiredCodegenInfo) return codegenInfo;
  hasRequiredCodegenInfo = 1, Object.defineProperty(codegenInfo, "__esModule", { value: !0 }), codegenInfo.codegenInfo = void 0;
  const o = requireNames(), g = requireFieldWrapper(), c = requireScalars(), y = requireReifyWkt(), t = "@bufbuild/protobuf";
  return codegenInfo.codegenInfo = {
    packageName: "@bufbuild/protobuf",
    localName: o.localName,
    reifyWkt: y.reifyWkt,
    getUnwrappedFieldType: g.getUnwrappedFieldType,
    scalarDefaultValue: c.scalarZeroValue,
    scalarZeroValue: c.scalarZeroValue,
    safeIdentifier: o.safeIdentifier,
    safeObjectProperty: o.safeObjectProperty,
    // prettier-ignore
    symbols: {
      proto2: { typeOnly: !1, privateImportPath: "./proto2.js", publicImportPath: t },
      proto3: { typeOnly: !1, privateImportPath: "./proto3.js", publicImportPath: t },
      Message: { typeOnly: !1, privateImportPath: "./message.js", publicImportPath: t },
      PartialMessage: { typeOnly: !0, privateImportPath: "./message.js", publicImportPath: t },
      PlainMessage: { typeOnly: !0, privateImportPath: "./message.js", publicImportPath: t },
      FieldList: { typeOnly: !0, privateImportPath: "./field-list.js", publicImportPath: t },
      MessageType: { typeOnly: !0, privateImportPath: "./message-type.js", publicImportPath: t },
      Extension: { typeOnly: !0, privateImportPath: "./extension.js", publicImportPath: t },
      BinaryReadOptions: { typeOnly: !0, privateImportPath: "./binary-format.js", publicImportPath: t },
      BinaryWriteOptions: { typeOnly: !0, privateImportPath: "./binary-format.js", publicImportPath: t },
      JsonReadOptions: { typeOnly: !0, privateImportPath: "./json-format.js", publicImportPath: t },
      JsonWriteOptions: { typeOnly: !0, privateImportPath: "./json-format.js", publicImportPath: t },
      JsonValue: { typeOnly: !0, privateImportPath: "./json-format.js", publicImportPath: t },
      JsonObject: { typeOnly: !0, privateImportPath: "./json-format.js", publicImportPath: t },
      protoDouble: { typeOnly: !1, privateImportPath: "./proto-double.js", publicImportPath: t },
      protoInt64: { typeOnly: !1, privateImportPath: "./proto-int64.js", publicImportPath: t },
      ScalarType: { typeOnly: !1, privateImportPath: "./scalar.js", publicImportPath: t },
      LongType: { typeOnly: !1, privateImportPath: "./scalar.js", publicImportPath: t },
      MethodKind: { typeOnly: !1, privateImportPath: "./service-type.js", publicImportPath: t },
      MethodIdempotency: { typeOnly: !1, privateImportPath: "./service-type.js", publicImportPath: t },
      IMessageTypeRegistry: { typeOnly: !0, privateImportPath: "./type-registry.js", publicImportPath: t }
    },
    wktSourceFiles: [
      "google/protobuf/compiler/plugin.proto",
      "google/protobuf/any.proto",
      "google/protobuf/api.proto",
      "google/protobuf/descriptor.proto",
      "google/protobuf/duration.proto",
      "google/protobuf/empty.proto",
      "google/protobuf/field_mask.proto",
      "google/protobuf/source_context.proto",
      "google/protobuf/struct.proto",
      "google/protobuf/timestamp.proto",
      "google/protobuf/type.proto",
      "google/protobuf/wrappers.proto"
    ]
  }, codegenInfo;
}
var serviceType = {}, hasRequiredServiceType;
function requireServiceType() {
  if (hasRequiredServiceType) return serviceType;
  hasRequiredServiceType = 1, Object.defineProperty(serviceType, "__esModule", { value: !0 }), serviceType.MethodIdempotency = serviceType.MethodKind = void 0;
  var o;
  (function(c) {
    c[c.Unary = 0] = "Unary", c[c.ServerStreaming = 1] = "ServerStreaming", c[c.ClientStreaming = 2] = "ClientStreaming", c[c.BiDiStreaming = 3] = "BiDiStreaming";
  })(o || (serviceType.MethodKind = o = {}));
  var g;
  return function(c) {
    c[c.NoSideEffects = 1] = "NoSideEffects", c[c.Idempotent = 2] = "Idempotent";
  }(g || (serviceType.MethodIdempotency = g = {})), serviceType;
}
var createDescriptorSet = {}, descriptor_pb = {}, hasRequiredDescriptor_pb;
function requireDescriptor_pb() {
  if (hasRequiredDescriptor_pb) return descriptor_pb;
  hasRequiredDescriptor_pb = 1, Object.defineProperty(descriptor_pb, "__esModule", { value: !0 }), descriptor_pb.GeneratedCodeInfo_Annotation_Semantic = descriptor_pb.GeneratedCodeInfo_Annotation = descriptor_pb.GeneratedCodeInfo = descriptor_pb.SourceCodeInfo_Location = descriptor_pb.SourceCodeInfo = descriptor_pb.FeatureSetDefaults_FeatureSetEditionDefault = descriptor_pb.FeatureSetDefaults = descriptor_pb.FeatureSet_JsonFormat = descriptor_pb.FeatureSet_MessageEncoding = descriptor_pb.FeatureSet_Utf8Validation = descriptor_pb.FeatureSet_RepeatedFieldEncoding = descriptor_pb.FeatureSet_EnumType = descriptor_pb.FeatureSet_FieldPresence = descriptor_pb.FeatureSet = descriptor_pb.UninterpretedOption_NamePart = descriptor_pb.UninterpretedOption = descriptor_pb.MethodOptions_IdempotencyLevel = descriptor_pb.MethodOptions = descriptor_pb.ServiceOptions = descriptor_pb.EnumValueOptions = descriptor_pb.EnumOptions = descriptor_pb.OneofOptions = descriptor_pb.FieldOptions_FeatureSupport = descriptor_pb.FieldOptions_EditionDefault = descriptor_pb.FieldOptions_OptionTargetType = descriptor_pb.FieldOptions_OptionRetention = descriptor_pb.FieldOptions_JSType = descriptor_pb.FieldOptions_CType = descriptor_pb.FieldOptions = descriptor_pb.MessageOptions = descriptor_pb.FileOptions_OptimizeMode = descriptor_pb.FileOptions = descriptor_pb.MethodDescriptorProto = descriptor_pb.ServiceDescriptorProto = descriptor_pb.EnumValueDescriptorProto = descriptor_pb.EnumDescriptorProto_EnumReservedRange = descriptor_pb.EnumDescriptorProto = descriptor_pb.OneofDescriptorProto = descriptor_pb.FieldDescriptorProto_Label = descriptor_pb.FieldDescriptorProto_Type = descriptor_pb.FieldDescriptorProto = descriptor_pb.ExtensionRangeOptions_Declaration = descriptor_pb.ExtensionRangeOptions_VerificationState = descriptor_pb.ExtensionRangeOptions = descriptor_pb.DescriptorProto_ReservedRange = descriptor_pb.DescriptorProto_ExtensionRange = descriptor_pb.DescriptorProto = descriptor_pb.FileDescriptorProto = descriptor_pb.FileDescriptorSet = descriptor_pb.Edition = void 0;
  const o = requireProto2(), g = requireMessage();
  var c;
  (function(Ar) {
    Ar[Ar.EDITION_UNKNOWN = 0] = "EDITION_UNKNOWN", Ar[Ar.EDITION_LEGACY = 900] = "EDITION_LEGACY", Ar[Ar.EDITION_PROTO2 = 998] = "EDITION_PROTO2", Ar[Ar.EDITION_PROTO3 = 999] = "EDITION_PROTO3", Ar[Ar.EDITION_2023 = 1e3] = "EDITION_2023", Ar[Ar.EDITION_2024 = 1001] = "EDITION_2024", Ar[Ar.EDITION_1_TEST_ONLY = 1] = "EDITION_1_TEST_ONLY", Ar[Ar.EDITION_2_TEST_ONLY = 2] = "EDITION_2_TEST_ONLY", Ar[Ar.EDITION_99997_TEST_ONLY = 99997] = "EDITION_99997_TEST_ONLY", Ar[Ar.EDITION_99998_TEST_ONLY = 99998] = "EDITION_99998_TEST_ONLY", Ar[Ar.EDITION_99999_TEST_ONLY = 99999] = "EDITION_99999_TEST_ONLY", Ar[Ar.EDITION_MAX = 2147483647] = "EDITION_MAX";
  })(c || (descriptor_pb.Edition = c = {})), o.proto2.util.setEnumType(c, "google.protobuf.Edition", [
    { no: 0, name: "EDITION_UNKNOWN" },
    { no: 900, name: "EDITION_LEGACY" },
    { no: 998, name: "EDITION_PROTO2" },
    { no: 999, name: "EDITION_PROTO3" },
    { no: 1e3, name: "EDITION_2023" },
    { no: 1001, name: "EDITION_2024" },
    { no: 1, name: "EDITION_1_TEST_ONLY" },
    { no: 2, name: "EDITION_2_TEST_ONLY" },
    { no: 99997, name: "EDITION_99997_TEST_ONLY" },
    { no: 99998, name: "EDITION_99998_TEST_ONLY" },
    { no: 99999, name: "EDITION_99999_TEST_ONLY" },
    { no: 2147483647, name: "EDITION_MAX" }
  ]);
  class y extends g.Message {
    constructor(cr) {
      super(), this.file = [], o.proto2.util.initPartial(cr, this);
    }
    static fromBinary(cr, hr) {
      return new y().fromBinary(cr, hr);
    }
    static fromJson(cr, hr) {
      return new y().fromJson(cr, hr);
    }
    static fromJsonString(cr, hr) {
      return new y().fromJsonString(cr, hr);
    }
    static equals(cr, hr) {
      return o.proto2.util.equals(y, cr, hr);
    }
  }
  descriptor_pb.FileDescriptorSet = y, y.runtime = o.proto2, y.typeName = "google.protobuf.FileDescriptorSet", y.fields = o.proto2.util.newFieldList(() => [
    { no: 1, name: "file", kind: "message", T: t, repeated: !0 }
  ]);
  class t extends g.Message {
    constructor(cr) {
      super(), this.dependency = [], this.publicDependency = [], this.weakDependency = [], this.messageType = [], this.enumType = [], this.service = [], this.extension = [], o.proto2.util.initPartial(cr, this);
    }
    static fromBinary(cr, hr) {
      return new t().fromBinary(cr, hr);
    }
    static fromJson(cr, hr) {
      return new t().fromJson(cr, hr);
    }
    static fromJsonString(cr, hr) {
      return new t().fromJsonString(cr, hr);
    }
    static equals(cr, hr) {
      return o.proto2.util.equals(t, cr, hr);
    }
  }
  descriptor_pb.FileDescriptorProto = t, t.runtime = o.proto2, t.typeName = "google.protobuf.FileDescriptorProto", t.fields = o.proto2.util.newFieldList(() => [
    { no: 1, name: "name", kind: "scalar", T: 9, opt: !0 },
    { no: 2, name: "package", kind: "scalar", T: 9, opt: !0 },
    { no: 3, name: "dependency", kind: "scalar", T: 9, repeated: !0 },
    { no: 10, name: "public_dependency", kind: "scalar", T: 5, repeated: !0 },
    { no: 11, name: "weak_dependency", kind: "scalar", T: 5, repeated: !0 },
    { no: 4, name: "message_type", kind: "message", T: d, repeated: !0 },
    { no: 5, name: "enum_type", kind: "message", T: H, repeated: !0 },
    { no: 6, name: "service", kind: "message", T: Ie, repeated: !0 },
    { no: 7, name: "extension", kind: "message", T: F, repeated: !0 },
    { no: 8, name: "options", kind: "message", T: Se, opt: !0 },
    { no: 9, name: "source_code_info", kind: "message", T: Ur, opt: !0 },
    { no: 12, name: "syntax", kind: "scalar", T: 9, opt: !0 },
    { no: 14, name: "edition", kind: "enum", T: o.proto2.getEnumType(c), opt: !0 }
  ]);
  class d extends g.Message {
    constructor(cr) {
      super(), this.field = [], this.extension = [], this.nestedType = [], this.enumType = [], this.extensionRange = [], this.oneofDecl = [], this.reservedRange = [], this.reservedName = [], o.proto2.util.initPartial(cr, this);
    }
    static fromBinary(cr, hr) {
      return new d().fromBinary(cr, hr);
    }
    static fromJson(cr, hr) {
      return new d().fromJson(cr, hr);
    }
    static fromJsonString(cr, hr) {
      return new d().fromJsonString(cr, hr);
    }
    static equals(cr, hr) {
      return o.proto2.util.equals(d, cr, hr);
    }
  }
  descriptor_pb.DescriptorProto = d, d.runtime = o.proto2, d.typeName = "google.protobuf.DescriptorProto", d.fields = o.proto2.util.newFieldList(() => [
    { no: 1, name: "name", kind: "scalar", T: 9, opt: !0 },
    { no: 2, name: "field", kind: "message", T: F, repeated: !0 },
    { no: 6, name: "extension", kind: "message", T: F, repeated: !0 },
    { no: 3, name: "nested_type", kind: "message", T: d, repeated: !0 },
    { no: 4, name: "enum_type", kind: "message", T: H, repeated: !0 },
    { no: 5, name: "extension_range", kind: "message", T: E, repeated: !0 },
    { no: 8, name: "oneof_decl", kind: "message", T: L, repeated: !0 },
    { no: 7, name: "options", kind: "message", T: He, opt: !0 },
    { no: 9, name: "reserved_range", kind: "message", T: B, repeated: !0 },
    { no: 10, name: "reserved_name", kind: "scalar", T: 9, repeated: !0 }
  ]);
  class E extends g.Message {
    constructor(cr) {
      super(), o.proto2.util.initPartial(cr, this);
    }
    static fromBinary(cr, hr) {
      return new E().fromBinary(cr, hr);
    }
    static fromJson(cr, hr) {
      return new E().fromJson(cr, hr);
    }
    static fromJsonString(cr, hr) {
      return new E().fromJsonString(cr, hr);
    }
    static equals(cr, hr) {
      return o.proto2.util.equals(E, cr, hr);
    }
  }
  descriptor_pb.DescriptorProto_ExtensionRange = E, E.runtime = o.proto2, E.typeName = "google.protobuf.DescriptorProto.ExtensionRange", E.fields = o.proto2.util.newFieldList(() => [
    { no: 1, name: "start", kind: "scalar", T: 5, opt: !0 },
    { no: 2, name: "end", kind: "scalar", T: 5, opt: !0 },
    { no: 3, name: "options", kind: "message", T: D, opt: !0 }
  ]);
  class B extends g.Message {
    constructor(cr) {
      super(), o.proto2.util.initPartial(cr, this);
    }
    static fromBinary(cr, hr) {
      return new B().fromBinary(cr, hr);
    }
    static fromJson(cr, hr) {
      return new B().fromJson(cr, hr);
    }
    static fromJsonString(cr, hr) {
      return new B().fromJsonString(cr, hr);
    }
    static equals(cr, hr) {
      return o.proto2.util.equals(B, cr, hr);
    }
  }
  descriptor_pb.DescriptorProto_ReservedRange = B, B.runtime = o.proto2, B.typeName = "google.protobuf.DescriptorProto.ReservedRange", B.fields = o.proto2.util.newFieldList(() => [
    { no: 1, name: "start", kind: "scalar", T: 5, opt: !0 },
    { no: 2, name: "end", kind: "scalar", T: 5, opt: !0 }
  ]);
  class D extends g.Message {
    constructor(cr) {
      super(), this.uninterpretedOption = [], this.declaration = [], o.proto2.util.initPartial(cr, this);
    }
    static fromBinary(cr, hr) {
      return new D().fromBinary(cr, hr);
    }
    static fromJson(cr, hr) {
      return new D().fromJson(cr, hr);
    }
    static fromJsonString(cr, hr) {
      return new D().fromJsonString(cr, hr);
    }
    static equals(cr, hr) {
      return o.proto2.util.equals(D, cr, hr);
    }
  }
  descriptor_pb.ExtensionRangeOptions = D, D.runtime = o.proto2, D.typeName = "google.protobuf.ExtensionRangeOptions", D.fields = o.proto2.util.newFieldList(() => [
    { no: 999, name: "uninterpreted_option", kind: "message", T: xt, repeated: !0 },
    { no: 2, name: "declaration", kind: "message", T: v, repeated: !0 },
    { no: 50, name: "features", kind: "message", T: sr, opt: !0 },
    { no: 3, name: "verification", kind: "enum", T: o.proto2.getEnumType(x), opt: !0, default: x.UNVERIFIED }
  ]);
  var x;
  (function(Ar) {
    Ar[Ar.DECLARATION = 0] = "DECLARATION", Ar[Ar.UNVERIFIED = 1] = "UNVERIFIED";
  })(x || (descriptor_pb.ExtensionRangeOptions_VerificationState = x = {})), o.proto2.util.setEnumType(x, "google.protobuf.ExtensionRangeOptions.VerificationState", [
    { no: 0, name: "DECLARATION" },
    { no: 1, name: "UNVERIFIED" }
  ]);
  class v extends g.Message {
    constructor(cr) {
      super(), o.proto2.util.initPartial(cr, this);
    }
    static fromBinary(cr, hr) {
      return new v().fromBinary(cr, hr);
    }
    static fromJson(cr, hr) {
      return new v().fromJson(cr, hr);
    }
    static fromJsonString(cr, hr) {
      return new v().fromJsonString(cr, hr);
    }
    static equals(cr, hr) {
      return o.proto2.util.equals(v, cr, hr);
    }
  }
  descriptor_pb.ExtensionRangeOptions_Declaration = v, v.runtime = o.proto2, v.typeName = "google.protobuf.ExtensionRangeOptions.Declaration", v.fields = o.proto2.util.newFieldList(() => [
    { no: 1, name: "number", kind: "scalar", T: 5, opt: !0 },
    { no: 2, name: "full_name", kind: "scalar", T: 9, opt: !0 },
    { no: 3, name: "type", kind: "scalar", T: 9, opt: !0 },
    { no: 5, name: "reserved", kind: "scalar", T: 8, opt: !0 },
    { no: 6, name: "repeated", kind: "scalar", T: 8, opt: !0 }
  ]);
  class F extends g.Message {
    constructor(cr) {
      super(), o.proto2.util.initPartial(cr, this);
    }
    static fromBinary(cr, hr) {
      return new F().fromBinary(cr, hr);
    }
    static fromJson(cr, hr) {
      return new F().fromJson(cr, hr);
    }
    static fromJsonString(cr, hr) {
      return new F().fromJsonString(cr, hr);
    }
    static equals(cr, hr) {
      return o.proto2.util.equals(F, cr, hr);
    }
  }
  descriptor_pb.FieldDescriptorProto = F, F.runtime = o.proto2, F.typeName = "google.protobuf.FieldDescriptorProto", F.fields = o.proto2.util.newFieldList(() => [
    { no: 1, name: "name", kind: "scalar", T: 9, opt: !0 },
    { no: 3, name: "number", kind: "scalar", T: 5, opt: !0 },
    { no: 4, name: "label", kind: "enum", T: o.proto2.getEnumType(U), opt: !0 },
    { no: 5, name: "type", kind: "enum", T: o.proto2.getEnumType(M), opt: !0 },
    { no: 6, name: "type_name", kind: "scalar", T: 9, opt: !0 },
    { no: 2, name: "extendee", kind: "scalar", T: 9, opt: !0 },
    { no: 7, name: "default_value", kind: "scalar", T: 9, opt: !0 },
    { no: 9, name: "oneof_index", kind: "scalar", T: 5, opt: !0 },
    { no: 10, name: "json_name", kind: "scalar", T: 9, opt: !0 },
    { no: 8, name: "options", kind: "message", T: Pe, opt: !0 },
    { no: 17, name: "proto3_optional", kind: "scalar", T: 8, opt: !0 }
  ]);
  var M;
  (function(Ar) {
    Ar[Ar.DOUBLE = 1] = "DOUBLE", Ar[Ar.FLOAT = 2] = "FLOAT", Ar[Ar.INT64 = 3] = "INT64", Ar[Ar.UINT64 = 4] = "UINT64", Ar[Ar.INT32 = 5] = "INT32", Ar[Ar.FIXED64 = 6] = "FIXED64", Ar[Ar.FIXED32 = 7] = "FIXED32", Ar[Ar.BOOL = 8] = "BOOL", Ar[Ar.STRING = 9] = "STRING", Ar[Ar.GROUP = 10] = "GROUP", Ar[Ar.MESSAGE = 11] = "MESSAGE", Ar[Ar.BYTES = 12] = "BYTES", Ar[Ar.UINT32 = 13] = "UINT32", Ar[Ar.ENUM = 14] = "ENUM", Ar[Ar.SFIXED32 = 15] = "SFIXED32", Ar[Ar.SFIXED64 = 16] = "SFIXED64", Ar[Ar.SINT32 = 17] = "SINT32", Ar[Ar.SINT64 = 18] = "SINT64";
  })(M || (descriptor_pb.FieldDescriptorProto_Type = M = {})), o.proto2.util.setEnumType(M, "google.protobuf.FieldDescriptorProto.Type", [
    { no: 1, name: "TYPE_DOUBLE" },
    { no: 2, name: "TYPE_FLOAT" },
    { no: 3, name: "TYPE_INT64" },
    { no: 4, name: "TYPE_UINT64" },
    { no: 5, name: "TYPE_INT32" },
    { no: 6, name: "TYPE_FIXED64" },
    { no: 7, name: "TYPE_FIXED32" },
    { no: 8, name: "TYPE_BOOL" },
    { no: 9, name: "TYPE_STRING" },
    { no: 10, name: "TYPE_GROUP" },
    { no: 11, name: "TYPE_MESSAGE" },
    { no: 12, name: "TYPE_BYTES" },
    { no: 13, name: "TYPE_UINT32" },
    { no: 14, name: "TYPE_ENUM" },
    { no: 15, name: "TYPE_SFIXED32" },
    { no: 16, name: "TYPE_SFIXED64" },
    { no: 17, name: "TYPE_SINT32" },
    { no: 18, name: "TYPE_SINT64" }
  ]);
  var U;
  (function(Ar) {
    Ar[Ar.OPTIONAL = 1] = "OPTIONAL", Ar[Ar.REPEATED = 3] = "REPEATED", Ar[Ar.REQUIRED = 2] = "REQUIRED";
  })(U || (descriptor_pb.FieldDescriptorProto_Label = U = {})), o.proto2.util.setEnumType(U, "google.protobuf.FieldDescriptorProto.Label", [
    { no: 1, name: "LABEL_OPTIONAL" },
    { no: 3, name: "LABEL_REPEATED" },
    { no: 2, name: "LABEL_REQUIRED" }
  ]);
  class L extends g.Message {
    constructor(cr) {
      super(), o.proto2.util.initPartial(cr, this);
    }
    static fromBinary(cr, hr) {
      return new L().fromBinary(cr, hr);
    }
    static fromJson(cr, hr) {
      return new L().fromJson(cr, hr);
    }
    static fromJsonString(cr, hr) {
      return new L().fromJsonString(cr, hr);
    }
    static equals(cr, hr) {
      return o.proto2.util.equals(L, cr, hr);
    }
  }
  descriptor_pb.OneofDescriptorProto = L, L.runtime = o.proto2, L.typeName = "google.protobuf.OneofDescriptorProto", L.fields = o.proto2.util.newFieldList(() => [
    { no: 1, name: "name", kind: "scalar", T: 9, opt: !0 },
    { no: 2, name: "options", kind: "message", T: xe, opt: !0 }
  ]);
  class H extends g.Message {
    constructor(cr) {
      super(), this.value = [], this.reservedRange = [], this.reservedName = [], o.proto2.util.initPartial(cr, this);
    }
    static fromBinary(cr, hr) {
      return new H().fromBinary(cr, hr);
    }
    static fromJson(cr, hr) {
      return new H().fromJson(cr, hr);
    }
    static fromJsonString(cr, hr) {
      return new H().fromJsonString(cr, hr);
    }
    static equals(cr, hr) {
      return o.proto2.util.equals(H, cr, hr);
    }
  }
  descriptor_pb.EnumDescriptorProto = H, H.runtime = o.proto2, H.typeName = "google.protobuf.EnumDescriptorProto", H.fields = o.proto2.util.newFieldList(() => [
    { no: 1, name: "name", kind: "scalar", T: 9, opt: !0 },
    { no: 2, name: "value", kind: "message", T: ge, repeated: !0 },
    { no: 3, name: "options", kind: "message", T: Ne, opt: !0 },
    { no: 4, name: "reserved_range", kind: "message", T: fe, repeated: !0 },
    { no: 5, name: "reserved_name", kind: "scalar", T: 9, repeated: !0 }
  ]);
  class fe extends g.Message {
    constructor(cr) {
      super(), o.proto2.util.initPartial(cr, this);
    }
    static fromBinary(cr, hr) {
      return new fe().fromBinary(cr, hr);
    }
    static fromJson(cr, hr) {
      return new fe().fromJson(cr, hr);
    }
    static fromJsonString(cr, hr) {
      return new fe().fromJsonString(cr, hr);
    }
    static equals(cr, hr) {
      return o.proto2.util.equals(fe, cr, hr);
    }
  }
  descriptor_pb.EnumDescriptorProto_EnumReservedRange = fe, fe.runtime = o.proto2, fe.typeName = "google.protobuf.EnumDescriptorProto.EnumReservedRange", fe.fields = o.proto2.util.newFieldList(() => [
    { no: 1, name: "start", kind: "scalar", T: 5, opt: !0 },
    { no: 2, name: "end", kind: "scalar", T: 5, opt: !0 }
  ]);
  class ge extends g.Message {
    constructor(cr) {
      super(), o.proto2.util.initPartial(cr, this);
    }
    static fromBinary(cr, hr) {
      return new ge().fromBinary(cr, hr);
    }
    static fromJson(cr, hr) {
      return new ge().fromJson(cr, hr);
    }
    static fromJsonString(cr, hr) {
      return new ge().fromJsonString(cr, hr);
    }
    static equals(cr, hr) {
      return o.proto2.util.equals(ge, cr, hr);
    }
  }
  descriptor_pb.EnumValueDescriptorProto = ge, ge.runtime = o.proto2, ge.typeName = "google.protobuf.EnumValueDescriptorProto", ge.fields = o.proto2.util.newFieldList(() => [
    { no: 1, name: "name", kind: "scalar", T: 9, opt: !0 },
    { no: 2, name: "number", kind: "scalar", T: 5, opt: !0 },
    { no: 3, name: "options", kind: "message", T: Et, opt: !0 }
  ]);
  class Ie extends g.Message {
    constructor(cr) {
      super(), this.method = [], o.proto2.util.initPartial(cr, this);
    }
    static fromBinary(cr, hr) {
      return new Ie().fromBinary(cr, hr);
    }
    static fromJson(cr, hr) {
      return new Ie().fromJson(cr, hr);
    }
    static fromJsonString(cr, hr) {
      return new Ie().fromJsonString(cr, hr);
    }
    static equals(cr, hr) {
      return o.proto2.util.equals(Ie, cr, hr);
    }
  }
  descriptor_pb.ServiceDescriptorProto = Ie, Ie.runtime = o.proto2, Ie.typeName = "google.protobuf.ServiceDescriptorProto", Ie.fields = o.proto2.util.newFieldList(() => [
    { no: 1, name: "name", kind: "scalar", T: 9, opt: !0 },
    { no: 2, name: "method", kind: "message", T: Ee, repeated: !0 },
    { no: 3, name: "options", kind: "message", T: st, opt: !0 }
  ]);
  class Ee extends g.Message {
    constructor(cr) {
      super(), o.proto2.util.initPartial(cr, this);
    }
    static fromBinary(cr, hr) {
      return new Ee().fromBinary(cr, hr);
    }
    static fromJson(cr, hr) {
      return new Ee().fromJson(cr, hr);
    }
    static fromJsonString(cr, hr) {
      return new Ee().fromJsonString(cr, hr);
    }
    static equals(cr, hr) {
      return o.proto2.util.equals(Ee, cr, hr);
    }
  }
  descriptor_pb.MethodDescriptorProto = Ee, Ee.runtime = o.proto2, Ee.typeName = "google.protobuf.MethodDescriptorProto", Ee.fields = o.proto2.util.newFieldList(() => [
    { no: 1, name: "name", kind: "scalar", T: 9, opt: !0 },
    { no: 2, name: "input_type", kind: "scalar", T: 9, opt: !0 },
    { no: 3, name: "output_type", kind: "scalar", T: 9, opt: !0 },
    { no: 4, name: "options", kind: "message", T: Dt, opt: !0 },
    { no: 5, name: "client_streaming", kind: "scalar", T: 8, opt: !0, default: !1 },
    { no: 6, name: "server_streaming", kind: "scalar", T: 8, opt: !0, default: !1 }
  ]);
  class Se extends g.Message {
    constructor(cr) {
      super(), this.uninterpretedOption = [], o.proto2.util.initPartial(cr, this);
    }
    static fromBinary(cr, hr) {
      return new Se().fromBinary(cr, hr);
    }
    static fromJson(cr, hr) {
      return new Se().fromJson(cr, hr);
    }
    static fromJsonString(cr, hr) {
      return new Se().fromJsonString(cr, hr);
    }
    static equals(cr, hr) {
      return o.proto2.util.equals(Se, cr, hr);
    }
  }
  descriptor_pb.FileOptions = Se, Se.runtime = o.proto2, Se.typeName = "google.protobuf.FileOptions", Se.fields = o.proto2.util.newFieldList(() => [
    { no: 1, name: "java_package", kind: "scalar", T: 9, opt: !0 },
    { no: 8, name: "java_outer_classname", kind: "scalar", T: 9, opt: !0 },
    { no: 10, name: "java_multiple_files", kind: "scalar", T: 8, opt: !0, default: !1 },
    { no: 20, name: "java_generate_equals_and_hash", kind: "scalar", T: 8, opt: !0 },
    { no: 27, name: "java_string_check_utf8", kind: "scalar", T: 8, opt: !0, default: !1 },
    { no: 9, name: "optimize_for", kind: "enum", T: o.proto2.getEnumType(ze), opt: !0, default: ze.SPEED },
    { no: 11, name: "go_package", kind: "scalar", T: 9, opt: !0 },
    { no: 16, name: "cc_generic_services", kind: "scalar", T: 8, opt: !0, default: !1 },
    { no: 17, name: "java_generic_services", kind: "scalar", T: 8, opt: !0, default: !1 },
    { no: 18, name: "py_generic_services", kind: "scalar", T: 8, opt: !0, default: !1 },
    { no: 23, name: "deprecated", kind: "scalar", T: 8, opt: !0, default: !1 },
    { no: 31, name: "cc_enable_arenas", kind: "scalar", T: 8, opt: !0, default: !0 },
    { no: 36, name: "objc_class_prefix", kind: "scalar", T: 9, opt: !0 },
    { no: 37, name: "csharp_namespace", kind: "scalar", T: 9, opt: !0 },
    { no: 39, name: "swift_prefix", kind: "scalar", T: 9, opt: !0 },
    { no: 40, name: "php_class_prefix", kind: "scalar", T: 9, opt: !0 },
    { no: 41, name: "php_namespace", kind: "scalar", T: 9, opt: !0 },
    { no: 44, name: "php_metadata_namespace", kind: "scalar", T: 9, opt: !0 },
    { no: 45, name: "ruby_package", kind: "scalar", T: 9, opt: !0 },
    { no: 50, name: "features", kind: "message", T: sr, opt: !0 },
    { no: 999, name: "uninterpreted_option", kind: "message", T: xt, repeated: !0 }
  ]);
  var ze;
  (function(Ar) {
    Ar[Ar.SPEED = 1] = "SPEED", Ar[Ar.CODE_SIZE = 2] = "CODE_SIZE", Ar[Ar.LITE_RUNTIME = 3] = "LITE_RUNTIME";
  })(ze || (descriptor_pb.FileOptions_OptimizeMode = ze = {})), o.proto2.util.setEnumType(ze, "google.protobuf.FileOptions.OptimizeMode", [
    { no: 1, name: "SPEED" },
    { no: 2, name: "CODE_SIZE" },
    { no: 3, name: "LITE_RUNTIME" }
  ]);
  class He extends g.Message {
    constructor(cr) {
      super(), this.uninterpretedOption = [], o.proto2.util.initPartial(cr, this);
    }
    static fromBinary(cr, hr) {
      return new He().fromBinary(cr, hr);
    }
    static fromJson(cr, hr) {
      return new He().fromJson(cr, hr);
    }
    static fromJsonString(cr, hr) {
      return new He().fromJsonString(cr, hr);
    }
    static equals(cr, hr) {
      return o.proto2.util.equals(He, cr, hr);
    }
  }
  descriptor_pb.MessageOptions = He, He.runtime = o.proto2, He.typeName = "google.protobuf.MessageOptions", He.fields = o.proto2.util.newFieldList(() => [
    { no: 1, name: "message_set_wire_format", kind: "scalar", T: 8, opt: !0, default: !1 },
    { no: 2, name: "no_standard_descriptor_accessor", kind: "scalar", T: 8, opt: !0, default: !1 },
    { no: 3, name: "deprecated", kind: "scalar", T: 8, opt: !0, default: !1 },
    { no: 7, name: "map_entry", kind: "scalar", T: 8, opt: !0 },
    { no: 11, name: "deprecated_legacy_json_field_conflicts", kind: "scalar", T: 8, opt: !0 },
    { no: 12, name: "features", kind: "message", T: sr, opt: !0 },
    { no: 999, name: "uninterpreted_option", kind: "message", T: xt, repeated: !0 }
  ]);
  class Pe extends g.Message {
    constructor(cr) {
      super(), this.targets = [], this.editionDefaults = [], this.uninterpretedOption = [], o.proto2.util.initPartial(cr, this);
    }
    static fromBinary(cr, hr) {
      return new Pe().fromBinary(cr, hr);
    }
    static fromJson(cr, hr) {
      return new Pe().fromJson(cr, hr);
    }
    static fromJsonString(cr, hr) {
      return new Pe().fromJsonString(cr, hr);
    }
    static equals(cr, hr) {
      return o.proto2.util.equals(Pe, cr, hr);
    }
  }
  descriptor_pb.FieldOptions = Pe, Pe.runtime = o.proto2, Pe.typeName = "google.protobuf.FieldOptions", Pe.fields = o.proto2.util.newFieldList(() => [
    { no: 1, name: "ctype", kind: "enum", T: o.proto2.getEnumType(De), opt: !0, default: De.STRING },
    { no: 2, name: "packed", kind: "scalar", T: 8, opt: !0 },
    { no: 6, name: "jstype", kind: "enum", T: o.proto2.getEnumType(ve), opt: !0, default: ve.JS_NORMAL },
    { no: 5, name: "lazy", kind: "scalar", T: 8, opt: !0, default: !1 },
    { no: 15, name: "unverified_lazy", kind: "scalar", T: 8, opt: !0, default: !1 },
    { no: 3, name: "deprecated", kind: "scalar", T: 8, opt: !0, default: !1 },
    { no: 10, name: "weak", kind: "scalar", T: 8, opt: !0, default: !1 },
    { no: 16, name: "debug_redact", kind: "scalar", T: 8, opt: !0, default: !1 },
    { no: 17, name: "retention", kind: "enum", T: o.proto2.getEnumType(Fe), opt: !0 },
    { no: 19, name: "targets", kind: "enum", T: o.proto2.getEnumType(be), repeated: !0 },
    { no: 20, name: "edition_defaults", kind: "message", T: Be, repeated: !0 },
    { no: 21, name: "features", kind: "message", T: sr, opt: !0 },
    { no: 22, name: "feature_support", kind: "message", T: ke, opt: !0 },
    { no: 999, name: "uninterpreted_option", kind: "message", T: xt, repeated: !0 }
  ]);
  var De;
  (function(Ar) {
    Ar[Ar.STRING = 0] = "STRING", Ar[Ar.CORD = 1] = "CORD", Ar[Ar.STRING_PIECE = 2] = "STRING_PIECE";
  })(De || (descriptor_pb.FieldOptions_CType = De = {})), o.proto2.util.setEnumType(De, "google.protobuf.FieldOptions.CType", [
    { no: 0, name: "STRING" },
    { no: 1, name: "CORD" },
    { no: 2, name: "STRING_PIECE" }
  ]);
  var ve;
  (function(Ar) {
    Ar[Ar.JS_NORMAL = 0] = "JS_NORMAL", Ar[Ar.JS_STRING = 1] = "JS_STRING", Ar[Ar.JS_NUMBER = 2] = "JS_NUMBER";
  })(ve || (descriptor_pb.FieldOptions_JSType = ve = {})), o.proto2.util.setEnumType(ve, "google.protobuf.FieldOptions.JSType", [
    { no: 0, name: "JS_NORMAL" },
    { no: 1, name: "JS_STRING" },
    { no: 2, name: "JS_NUMBER" }
  ]);
  var Fe;
  (function(Ar) {
    Ar[Ar.RETENTION_UNKNOWN = 0] = "RETENTION_UNKNOWN", Ar[Ar.RETENTION_RUNTIME = 1] = "RETENTION_RUNTIME", Ar[Ar.RETENTION_SOURCE = 2] = "RETENTION_SOURCE";
  })(Fe || (descriptor_pb.FieldOptions_OptionRetention = Fe = {})), o.proto2.util.setEnumType(Fe, "google.protobuf.FieldOptions.OptionRetention", [
    { no: 0, name: "RETENTION_UNKNOWN" },
    { no: 1, name: "RETENTION_RUNTIME" },
    { no: 2, name: "RETENTION_SOURCE" }
  ]);
  var be;
  (function(Ar) {
    Ar[Ar.TARGET_TYPE_UNKNOWN = 0] = "TARGET_TYPE_UNKNOWN", Ar[Ar.TARGET_TYPE_FILE = 1] = "TARGET_TYPE_FILE", Ar[Ar.TARGET_TYPE_EXTENSION_RANGE = 2] = "TARGET_TYPE_EXTENSION_RANGE", Ar[Ar.TARGET_TYPE_MESSAGE = 3] = "TARGET_TYPE_MESSAGE", Ar[Ar.TARGET_TYPE_FIELD = 4] = "TARGET_TYPE_FIELD", Ar[Ar.TARGET_TYPE_ONEOF = 5] = "TARGET_TYPE_ONEOF", Ar[Ar.TARGET_TYPE_ENUM = 6] = "TARGET_TYPE_ENUM", Ar[Ar.TARGET_TYPE_ENUM_ENTRY = 7] = "TARGET_TYPE_ENUM_ENTRY", Ar[Ar.TARGET_TYPE_SERVICE = 8] = "TARGET_TYPE_SERVICE", Ar[Ar.TARGET_TYPE_METHOD = 9] = "TARGET_TYPE_METHOD";
  })(be || (descriptor_pb.FieldOptions_OptionTargetType = be = {})), o.proto2.util.setEnumType(be, "google.protobuf.FieldOptions.OptionTargetType", [
    { no: 0, name: "TARGET_TYPE_UNKNOWN" },
    { no: 1, name: "TARGET_TYPE_FILE" },
    { no: 2, name: "TARGET_TYPE_EXTENSION_RANGE" },
    { no: 3, name: "TARGET_TYPE_MESSAGE" },
    { no: 4, name: "TARGET_TYPE_FIELD" },
    { no: 5, name: "TARGET_TYPE_ONEOF" },
    { no: 6, name: "TARGET_TYPE_ENUM" },
    { no: 7, name: "TARGET_TYPE_ENUM_ENTRY" },
    { no: 8, name: "TARGET_TYPE_SERVICE" },
    { no: 9, name: "TARGET_TYPE_METHOD" }
  ]);
  class Be extends g.Message {
    constructor(cr) {
      super(), o.proto2.util.initPartial(cr, this);
    }
    static fromBinary(cr, hr) {
      return new Be().fromBinary(cr, hr);
    }
    static fromJson(cr, hr) {
      return new Be().fromJson(cr, hr);
    }
    static fromJsonString(cr, hr) {
      return new Be().fromJsonString(cr, hr);
    }
    static equals(cr, hr) {
      return o.proto2.util.equals(Be, cr, hr);
    }
  }
  descriptor_pb.FieldOptions_EditionDefault = Be, Be.runtime = o.proto2, Be.typeName = "google.protobuf.FieldOptions.EditionDefault", Be.fields = o.proto2.util.newFieldList(() => [
    { no: 3, name: "edition", kind: "enum", T: o.proto2.getEnumType(c), opt: !0 },
    { no: 2, name: "value", kind: "scalar", T: 9, opt: !0 }
  ]);
  class ke extends g.Message {
    constructor(cr) {
      super(), o.proto2.util.initPartial(cr, this);
    }
    static fromBinary(cr, hr) {
      return new ke().fromBinary(cr, hr);
    }
    static fromJson(cr, hr) {
      return new ke().fromJson(cr, hr);
    }
    static fromJsonString(cr, hr) {
      return new ke().fromJsonString(cr, hr);
    }
    static equals(cr, hr) {
      return o.proto2.util.equals(ke, cr, hr);
    }
  }
  descriptor_pb.FieldOptions_FeatureSupport = ke, ke.runtime = o.proto2, ke.typeName = "google.protobuf.FieldOptions.FeatureSupport", ke.fields = o.proto2.util.newFieldList(() => [
    { no: 1, name: "edition_introduced", kind: "enum", T: o.proto2.getEnumType(c), opt: !0 },
    { no: 2, name: "edition_deprecated", kind: "enum", T: o.proto2.getEnumType(c), opt: !0 },
    { no: 3, name: "deprecation_warning", kind: "scalar", T: 9, opt: !0 },
    { no: 4, name: "edition_removed", kind: "enum", T: o.proto2.getEnumType(c), opt: !0 }
  ]);
  class xe extends g.Message {
    constructor(cr) {
      super(), this.uninterpretedOption = [], o.proto2.util.initPartial(cr, this);
    }
    static fromBinary(cr, hr) {
      return new xe().fromBinary(cr, hr);
    }
    static fromJson(cr, hr) {
      return new xe().fromJson(cr, hr);
    }
    static fromJsonString(cr, hr) {
      return new xe().fromJsonString(cr, hr);
    }
    static equals(cr, hr) {
      return o.proto2.util.equals(xe, cr, hr);
    }
  }
  descriptor_pb.OneofOptions = xe, xe.runtime = o.proto2, xe.typeName = "google.protobuf.OneofOptions", xe.fields = o.proto2.util.newFieldList(() => [
    { no: 1, name: "features", kind: "message", T: sr, opt: !0 },
    { no: 999, name: "uninterpreted_option", kind: "message", T: xt, repeated: !0 }
  ]);
  class Ne extends g.Message {
    constructor(cr) {
      super(), this.uninterpretedOption = [], o.proto2.util.initPartial(cr, this);
    }
    static fromBinary(cr, hr) {
      return new Ne().fromBinary(cr, hr);
    }
    static fromJson(cr, hr) {
      return new Ne().fromJson(cr, hr);
    }
    static fromJsonString(cr, hr) {
      return new Ne().fromJsonString(cr, hr);
    }
    static equals(cr, hr) {
      return o.proto2.util.equals(Ne, cr, hr);
    }
  }
  descriptor_pb.EnumOptions = Ne, Ne.runtime = o.proto2, Ne.typeName = "google.protobuf.EnumOptions", Ne.fields = o.proto2.util.newFieldList(() => [
    { no: 2, name: "allow_alias", kind: "scalar", T: 8, opt: !0 },
    { no: 3, name: "deprecated", kind: "scalar", T: 8, opt: !0, default: !1 },
    { no: 6, name: "deprecated_legacy_json_field_conflicts", kind: "scalar", T: 8, opt: !0 },
    { no: 7, name: "features", kind: "message", T: sr, opt: !0 },
    { no: 999, name: "uninterpreted_option", kind: "message", T: xt, repeated: !0 }
  ]);
  class Et extends g.Message {
    constructor(cr) {
      super(), this.uninterpretedOption = [], o.proto2.util.initPartial(cr, this);
    }
    static fromBinary(cr, hr) {
      return new Et().fromBinary(cr, hr);
    }
    static fromJson(cr, hr) {
      return new Et().fromJson(cr, hr);
    }
    static fromJsonString(cr, hr) {
      return new Et().fromJsonString(cr, hr);
    }
    static equals(cr, hr) {
      return o.proto2.util.equals(Et, cr, hr);
    }
  }
  descriptor_pb.EnumValueOptions = Et, Et.runtime = o.proto2, Et.typeName = "google.protobuf.EnumValueOptions", Et.fields = o.proto2.util.newFieldList(() => [
    { no: 1, name: "deprecated", kind: "scalar", T: 8, opt: !0, default: !1 },
    { no: 2, name: "features", kind: "message", T: sr, opt: !0 },
    { no: 3, name: "debug_redact", kind: "scalar", T: 8, opt: !0, default: !1 },
    { no: 4, name: "feature_support", kind: "message", T: ke, opt: !0 },
    { no: 999, name: "uninterpreted_option", kind: "message", T: xt, repeated: !0 }
  ]);
  class st extends g.Message {
    constructor(cr) {
      super(), this.uninterpretedOption = [], o.proto2.util.initPartial(cr, this);
    }
    static fromBinary(cr, hr) {
      return new st().fromBinary(cr, hr);
    }
    static fromJson(cr, hr) {
      return new st().fromJson(cr, hr);
    }
    static fromJsonString(cr, hr) {
      return new st().fromJsonString(cr, hr);
    }
    static equals(cr, hr) {
      return o.proto2.util.equals(st, cr, hr);
    }
  }
  descriptor_pb.ServiceOptions = st, st.runtime = o.proto2, st.typeName = "google.protobuf.ServiceOptions", st.fields = o.proto2.util.newFieldList(() => [
    { no: 34, name: "features", kind: "message", T: sr, opt: !0 },
    { no: 33, name: "deprecated", kind: "scalar", T: 8, opt: !0, default: !1 },
    { no: 999, name: "uninterpreted_option", kind: "message", T: xt, repeated: !0 }
  ]);
  class Dt extends g.Message {
    constructor(cr) {
      super(), this.uninterpretedOption = [], o.proto2.util.initPartial(cr, this);
    }
    static fromBinary(cr, hr) {
      return new Dt().fromBinary(cr, hr);
    }
    static fromJson(cr, hr) {
      return new Dt().fromJson(cr, hr);
    }
    static fromJsonString(cr, hr) {
      return new Dt().fromJsonString(cr, hr);
    }
    static equals(cr, hr) {
      return o.proto2.util.equals(Dt, cr, hr);
    }
  }
  descriptor_pb.MethodOptions = Dt, Dt.runtime = o.proto2, Dt.typeName = "google.protobuf.MethodOptions", Dt.fields = o.proto2.util.newFieldList(() => [
    { no: 33, name: "deprecated", kind: "scalar", T: 8, opt: !0, default: !1 },
    { no: 34, name: "idempotency_level", kind: "enum", T: o.proto2.getEnumType(er), opt: !0, default: er.IDEMPOTENCY_UNKNOWN },
    { no: 35, name: "features", kind: "message", T: sr, opt: !0 },
    { no: 999, name: "uninterpreted_option", kind: "message", T: xt, repeated: !0 }
  ]);
  var er;
  (function(Ar) {
    Ar[Ar.IDEMPOTENCY_UNKNOWN = 0] = "IDEMPOTENCY_UNKNOWN", Ar[Ar.NO_SIDE_EFFECTS = 1] = "NO_SIDE_EFFECTS", Ar[Ar.IDEMPOTENT = 2] = "IDEMPOTENT";
  })(er || (descriptor_pb.MethodOptions_IdempotencyLevel = er = {})), o.proto2.util.setEnumType(er, "google.protobuf.MethodOptions.IdempotencyLevel", [
    { no: 0, name: "IDEMPOTENCY_UNKNOWN" },
    { no: 1, name: "NO_SIDE_EFFECTS" },
    { no: 2, name: "IDEMPOTENT" }
  ]);
  class xt extends g.Message {
    constructor(cr) {
      super(), this.name = [], o.proto2.util.initPartial(cr, this);
    }
    static fromBinary(cr, hr) {
      return new xt().fromBinary(cr, hr);
    }
    static fromJson(cr, hr) {
      return new xt().fromJson(cr, hr);
    }
    static fromJsonString(cr, hr) {
      return new xt().fromJsonString(cr, hr);
    }
    static equals(cr, hr) {
      return o.proto2.util.equals(xt, cr, hr);
    }
  }
  descriptor_pb.UninterpretedOption = xt, xt.runtime = o.proto2, xt.typeName = "google.protobuf.UninterpretedOption", xt.fields = o.proto2.util.newFieldList(() => [
    { no: 2, name: "name", kind: "message", T: ir, repeated: !0 },
    { no: 3, name: "identifier_value", kind: "scalar", T: 9, opt: !0 },
    { no: 4, name: "positive_int_value", kind: "scalar", T: 4, opt: !0 },
    { no: 5, name: "negative_int_value", kind: "scalar", T: 3, opt: !0 },
    { no: 6, name: "double_value", kind: "scalar", T: 1, opt: !0 },
    { no: 7, name: "string_value", kind: "scalar", T: 12, opt: !0 },
    { no: 8, name: "aggregate_value", kind: "scalar", T: 9, opt: !0 }
  ]);
  class ir extends g.Message {
    constructor(cr) {
      super(), o.proto2.util.initPartial(cr, this);
    }
    static fromBinary(cr, hr) {
      return new ir().fromBinary(cr, hr);
    }
    static fromJson(cr, hr) {
      return new ir().fromJson(cr, hr);
    }
    static fromJsonString(cr, hr) {
      return new ir().fromJsonString(cr, hr);
    }
    static equals(cr, hr) {
      return o.proto2.util.equals(ir, cr, hr);
    }
  }
  descriptor_pb.UninterpretedOption_NamePart = ir, ir.runtime = o.proto2, ir.typeName = "google.protobuf.UninterpretedOption.NamePart", ir.fields = o.proto2.util.newFieldList(() => [
    { no: 1, name: "name_part", kind: "scalar", T: 9, req: !0 },
    { no: 2, name: "is_extension", kind: "scalar", T: 8, req: !0 }
  ]);
  class sr extends g.Message {
    constructor(cr) {
      super(), o.proto2.util.initPartial(cr, this);
    }
    static fromBinary(cr, hr) {
      return new sr().fromBinary(cr, hr);
    }
    static fromJson(cr, hr) {
      return new sr().fromJson(cr, hr);
    }
    static fromJsonString(cr, hr) {
      return new sr().fromJsonString(cr, hr);
    }
    static equals(cr, hr) {
      return o.proto2.util.equals(sr, cr, hr);
    }
  }
  descriptor_pb.FeatureSet = sr, sr.runtime = o.proto2, sr.typeName = "google.protobuf.FeatureSet", sr.fields = o.proto2.util.newFieldList(() => [
    { no: 1, name: "field_presence", kind: "enum", T: o.proto2.getEnumType(yr), opt: !0 },
    { no: 2, name: "enum_type", kind: "enum", T: o.proto2.getEnumType(wr), opt: !0 },
    { no: 3, name: "repeated_field_encoding", kind: "enum", T: o.proto2.getEnumType(qr), opt: !0 },
    { no: 4, name: "utf8_validation", kind: "enum", T: o.proto2.getEnumType(Mr), opt: !0 },
    { no: 5, name: "message_encoding", kind: "enum", T: o.proto2.getEnumType(Dr), opt: !0 },
    { no: 6, name: "json_format", kind: "enum", T: o.proto2.getEnumType(Qr), opt: !0 }
  ]);
  var yr;
  (function(Ar) {
    Ar[Ar.FIELD_PRESENCE_UNKNOWN = 0] = "FIELD_PRESENCE_UNKNOWN", Ar[Ar.EXPLICIT = 1] = "EXPLICIT", Ar[Ar.IMPLICIT = 2] = "IMPLICIT", Ar[Ar.LEGACY_REQUIRED = 3] = "LEGACY_REQUIRED";
  })(yr || (descriptor_pb.FeatureSet_FieldPresence = yr = {})), o.proto2.util.setEnumType(yr, "google.protobuf.FeatureSet.FieldPresence", [
    { no: 0, name: "FIELD_PRESENCE_UNKNOWN" },
    { no: 1, name: "EXPLICIT" },
    { no: 2, name: "IMPLICIT" },
    { no: 3, name: "LEGACY_REQUIRED" }
  ]);
  var wr;
  (function(Ar) {
    Ar[Ar.ENUM_TYPE_UNKNOWN = 0] = "ENUM_TYPE_UNKNOWN", Ar[Ar.OPEN = 1] = "OPEN", Ar[Ar.CLOSED = 2] = "CLOSED";
  })(wr || (descriptor_pb.FeatureSet_EnumType = wr = {})), o.proto2.util.setEnumType(wr, "google.protobuf.FeatureSet.EnumType", [
    { no: 0, name: "ENUM_TYPE_UNKNOWN" },
    { no: 1, name: "OPEN" },
    { no: 2, name: "CLOSED" }
  ]);
  var qr;
  (function(Ar) {
    Ar[Ar.REPEATED_FIELD_ENCODING_UNKNOWN = 0] = "REPEATED_FIELD_ENCODING_UNKNOWN", Ar[Ar.PACKED = 1] = "PACKED", Ar[Ar.EXPANDED = 2] = "EXPANDED";
  })(qr || (descriptor_pb.FeatureSet_RepeatedFieldEncoding = qr = {})), o.proto2.util.setEnumType(qr, "google.protobuf.FeatureSet.RepeatedFieldEncoding", [
    { no: 0, name: "REPEATED_FIELD_ENCODING_UNKNOWN" },
    { no: 1, name: "PACKED" },
    { no: 2, name: "EXPANDED" }
  ]);
  var Mr;
  (function(Ar) {
    Ar[Ar.UTF8_VALIDATION_UNKNOWN = 0] = "UTF8_VALIDATION_UNKNOWN", Ar[Ar.VERIFY = 2] = "VERIFY", Ar[Ar.NONE = 3] = "NONE";
  })(Mr || (descriptor_pb.FeatureSet_Utf8Validation = Mr = {})), o.proto2.util.setEnumType(Mr, "google.protobuf.FeatureSet.Utf8Validation", [
    { no: 0, name: "UTF8_VALIDATION_UNKNOWN" },
    { no: 2, name: "VERIFY" },
    { no: 3, name: "NONE" }
  ]);
  var Dr;
  (function(Ar) {
    Ar[Ar.MESSAGE_ENCODING_UNKNOWN = 0] = "MESSAGE_ENCODING_UNKNOWN", Ar[Ar.LENGTH_PREFIXED = 1] = "LENGTH_PREFIXED", Ar[Ar.DELIMITED = 2] = "DELIMITED";
  })(Dr || (descriptor_pb.FeatureSet_MessageEncoding = Dr = {})), o.proto2.util.setEnumType(Dr, "google.protobuf.FeatureSet.MessageEncoding", [
    { no: 0, name: "MESSAGE_ENCODING_UNKNOWN" },
    { no: 1, name: "LENGTH_PREFIXED" },
    { no: 2, name: "DELIMITED" }
  ]);
  var Qr;
  (function(Ar) {
    Ar[Ar.JSON_FORMAT_UNKNOWN = 0] = "JSON_FORMAT_UNKNOWN", Ar[Ar.ALLOW = 1] = "ALLOW", Ar[Ar.LEGACY_BEST_EFFORT = 2] = "LEGACY_BEST_EFFORT";
  })(Qr || (descriptor_pb.FeatureSet_JsonFormat = Qr = {})), o.proto2.util.setEnumType(Qr, "google.protobuf.FeatureSet.JsonFormat", [
    { no: 0, name: "JSON_FORMAT_UNKNOWN" },
    { no: 1, name: "ALLOW" },
    { no: 2, name: "LEGACY_BEST_EFFORT" }
  ]);
  class Xr extends g.Message {
    constructor(cr) {
      super(), this.defaults = [], o.proto2.util.initPartial(cr, this);
    }
    static fromBinary(cr, hr) {
      return new Xr().fromBinary(cr, hr);
    }
    static fromJson(cr, hr) {
      return new Xr().fromJson(cr, hr);
    }
    static fromJsonString(cr, hr) {
      return new Xr().fromJsonString(cr, hr);
    }
    static equals(cr, hr) {
      return o.proto2.util.equals(Xr, cr, hr);
    }
  }
  descriptor_pb.FeatureSetDefaults = Xr, Xr.runtime = o.proto2, Xr.typeName = "google.protobuf.FeatureSetDefaults", Xr.fields = o.proto2.util.newFieldList(() => [
    { no: 1, name: "defaults", kind: "message", T: Vr, repeated: !0 },
    { no: 4, name: "minimum_edition", kind: "enum", T: o.proto2.getEnumType(c), opt: !0 },
    { no: 5, name: "maximum_edition", kind: "enum", T: o.proto2.getEnumType(c), opt: !0 }
  ]);
  class Vr extends g.Message {
    constructor(cr) {
      super(), o.proto2.util.initPartial(cr, this);
    }
    static fromBinary(cr, hr) {
      return new Vr().fromBinary(cr, hr);
    }
    static fromJson(cr, hr) {
      return new Vr().fromJson(cr, hr);
    }
    static fromJsonString(cr, hr) {
      return new Vr().fromJsonString(cr, hr);
    }
    static equals(cr, hr) {
      return o.proto2.util.equals(Vr, cr, hr);
    }
  }
  descriptor_pb.FeatureSetDefaults_FeatureSetEditionDefault = Vr, Vr.runtime = o.proto2, Vr.typeName = "google.protobuf.FeatureSetDefaults.FeatureSetEditionDefault", Vr.fields = o.proto2.util.newFieldList(() => [
    { no: 3, name: "edition", kind: "enum", T: o.proto2.getEnumType(c), opt: !0 },
    { no: 4, name: "overridable_features", kind: "message", T: sr, opt: !0 },
    { no: 5, name: "fixed_features", kind: "message", T: sr, opt: !0 }
  ]);
  class Ur extends g.Message {
    constructor(cr) {
      super(), this.location = [], o.proto2.util.initPartial(cr, this);
    }
    static fromBinary(cr, hr) {
      return new Ur().fromBinary(cr, hr);
    }
    static fromJson(cr, hr) {
      return new Ur().fromJson(cr, hr);
    }
    static fromJsonString(cr, hr) {
      return new Ur().fromJsonString(cr, hr);
    }
    static equals(cr, hr) {
      return o.proto2.util.equals(Ur, cr, hr);
    }
  }
  descriptor_pb.SourceCodeInfo = Ur, Ur.runtime = o.proto2, Ur.typeName = "google.protobuf.SourceCodeInfo", Ur.fields = o.proto2.util.newFieldList(() => [
    { no: 1, name: "location", kind: "message", T: Sr, repeated: !0 }
  ]);
  class Sr extends g.Message {
    constructor(cr) {
      super(), this.path = [], this.span = [], this.leadingDetachedComments = [], o.proto2.util.initPartial(cr, this);
    }
    static fromBinary(cr, hr) {
      return new Sr().fromBinary(cr, hr);
    }
    static fromJson(cr, hr) {
      return new Sr().fromJson(cr, hr);
    }
    static fromJsonString(cr, hr) {
      return new Sr().fromJsonString(cr, hr);
    }
    static equals(cr, hr) {
      return o.proto2.util.equals(Sr, cr, hr);
    }
  }
  descriptor_pb.SourceCodeInfo_Location = Sr, Sr.runtime = o.proto2, Sr.typeName = "google.protobuf.SourceCodeInfo.Location", Sr.fields = o.proto2.util.newFieldList(() => [
    { no: 1, name: "path", kind: "scalar", T: 5, repeated: !0, packed: !0 },
    { no: 2, name: "span", kind: "scalar", T: 5, repeated: !0, packed: !0 },
    { no: 3, name: "leading_comments", kind: "scalar", T: 9, opt: !0 },
    { no: 4, name: "trailing_comments", kind: "scalar", T: 9, opt: !0 },
    { no: 6, name: "leading_detached_comments", kind: "scalar", T: 9, repeated: !0 }
  ]);
  class Gr extends g.Message {
    constructor(cr) {
      super(), this.annotation = [], o.proto2.util.initPartial(cr, this);
    }
    static fromBinary(cr, hr) {
      return new Gr().fromBinary(cr, hr);
    }
    static fromJson(cr, hr) {
      return new Gr().fromJson(cr, hr);
    }
    static fromJsonString(cr, hr) {
      return new Gr().fromJsonString(cr, hr);
    }
    static equals(cr, hr) {
      return o.proto2.util.equals(Gr, cr, hr);
    }
  }
  descriptor_pb.GeneratedCodeInfo = Gr, Gr.runtime = o.proto2, Gr.typeName = "google.protobuf.GeneratedCodeInfo", Gr.fields = o.proto2.util.newFieldList(() => [
    { no: 1, name: "annotation", kind: "message", T: Fr, repeated: !0 }
  ]);
  class Fr extends g.Message {
    constructor(cr) {
      super(), this.path = [], o.proto2.util.initPartial(cr, this);
    }
    static fromBinary(cr, hr) {
      return new Fr().fromBinary(cr, hr);
    }
    static fromJson(cr, hr) {
      return new Fr().fromJson(cr, hr);
    }
    static fromJsonString(cr, hr) {
      return new Fr().fromJsonString(cr, hr);
    }
    static equals(cr, hr) {
      return o.proto2.util.equals(Fr, cr, hr);
    }
  }
  descriptor_pb.GeneratedCodeInfo_Annotation = Fr, Fr.runtime = o.proto2, Fr.typeName = "google.protobuf.GeneratedCodeInfo.Annotation", Fr.fields = o.proto2.util.newFieldList(() => [
    { no: 1, name: "path", kind: "scalar", T: 5, repeated: !0, packed: !0 },
    { no: 2, name: "source_file", kind: "scalar", T: 9, opt: !0 },
    { no: 3, name: "begin", kind: "scalar", T: 5, opt: !0 },
    { no: 4, name: "end", kind: "scalar", T: 5, opt: !0 },
    { no: 5, name: "semantic", kind: "enum", T: o.proto2.getEnumType(br), opt: !0 }
  ]);
  var br;
  return function(Ar) {
    Ar[Ar.NONE = 0] = "NONE", Ar[Ar.SET = 1] = "SET", Ar[Ar.ALIAS = 2] = "ALIAS";
  }(br || (descriptor_pb.GeneratedCodeInfo_Annotation_Semantic = br = {})), o.proto2.util.setEnumType(br, "google.protobuf.GeneratedCodeInfo.Annotation.Semantic", [
    { no: 0, name: "NONE" },
    { no: 1, name: "SET" },
    { no: 2, name: "ALIAS" }
  ]), descriptor_pb;
}
var textFormat = {}, hasRequiredTextFormat;
function requireTextFormat() {
  if (hasRequiredTextFormat) return textFormat;
  hasRequiredTextFormat = 1, Object.defineProperty(textFormat, "__esModule", { value: !0 }), textFormat.parseTextFormatScalarValue = textFormat.parseTextFormatEnumValue = void 0;
  const o = requireAssert$1(), g = requireProtoInt64(), c = requireScalar();
  function y(E, B) {
    const D = E.values.find((x) => x.name === B);
    return (0, o.assert)(D, `cannot parse ${E.name} default value: ${B}`), D.number;
  }
  textFormat.parseTextFormatEnumValue = y;
  function t(E, B) {
    switch (E) {
      case c.ScalarType.STRING:
        return B;
      case c.ScalarType.BYTES: {
        const D = d(B);
        if (D === !1)
          throw new Error(`cannot parse ${c.ScalarType[E]} default value: ${B}`);
        return D;
      }
      case c.ScalarType.INT64:
      case c.ScalarType.SFIXED64:
      case c.ScalarType.SINT64:
        return g.protoInt64.parse(B);
      case c.ScalarType.UINT64:
      case c.ScalarType.FIXED64:
        return g.protoInt64.uParse(B);
      case c.ScalarType.DOUBLE:
      case c.ScalarType.FLOAT:
        switch (B) {
          case "inf":
            return Number.POSITIVE_INFINITY;
          case "-inf":
            return Number.NEGATIVE_INFINITY;
          case "nan":
            return Number.NaN;
          default:
            return parseFloat(B);
        }
      case c.ScalarType.BOOL:
        return B === "true";
      case c.ScalarType.INT32:
      case c.ScalarType.UINT32:
      case c.ScalarType.SINT32:
      case c.ScalarType.FIXED32:
      case c.ScalarType.SFIXED32:
        return parseInt(B, 10);
    }
  }
  textFormat.parseTextFormatScalarValue = t;
  function d(E) {
    const B = [], D = {
      tail: E,
      c: "",
      next() {
        return this.tail.length == 0 ? !1 : (this.c = this.tail[0], this.tail = this.tail.substring(1), !0);
      },
      take(x) {
        if (this.tail.length >= x) {
          const v = this.tail.substring(0, x);
          return this.tail = this.tail.substring(x), v;
        }
        return !1;
      }
    };
    for (; D.next(); )
      switch (D.c) {
        case "\\":
          if (D.next())
            switch (D.c) {
              case "\\":
                B.push(D.c.charCodeAt(0));
                break;
              case "b":
                B.push(8);
                break;
              case "f":
                B.push(12);
                break;
              case "n":
                B.push(10);
                break;
              case "r":
                B.push(13);
                break;
              case "t":
                B.push(9);
                break;
              case "v":
                B.push(11);
                break;
              case "0":
              case "1":
              case "2":
              case "3":
              case "4":
              case "5":
              case "6":
              case "7": {
                const x = D.c, v = D.take(2);
                if (v === !1)
                  return !1;
                const F = parseInt(x + v, 8);
                if (isNaN(F))
                  return !1;
                B.push(F);
                break;
              }
              case "x": {
                const x = D.c, v = D.take(2);
                if (v === !1)
                  return !1;
                const F = parseInt(x + v, 16);
                if (isNaN(F))
                  return !1;
                B.push(F);
                break;
              }
              case "u": {
                const x = D.c, v = D.take(4);
                if (v === !1)
                  return !1;
                const F = parseInt(x + v, 16);
                if (isNaN(F))
                  return !1;
                const M = new Uint8Array(4);
                new DataView(M.buffer).setInt32(0, F, !0), B.push(M[0], M[1], M[2], M[3]);
                break;
              }
              case "U": {
                const x = D.c, v = D.take(8);
                if (v === !1)
                  return !1;
                const F = g.protoInt64.uEnc(x + v), M = new Uint8Array(8), U = new DataView(M.buffer);
                U.setInt32(0, F.lo, !0), U.setInt32(4, F.hi, !0), B.push(M[0], M[1], M[2], M[3], M[4], M[5], M[6], M[7]);
                break;
              }
            }
          break;
        default:
          B.push(D.c.charCodeAt(0));
      }
    return new Uint8Array(B);
  }
  return textFormat;
}
var featureSet = {}, hasRequiredFeatureSet;
function requireFeatureSet() {
  if (hasRequiredFeatureSet) return featureSet;
  hasRequiredFeatureSet = 1, Object.defineProperty(featureSet, "__esModule", { value: !0 }), featureSet.createFeatureResolver = void 0;
  const o = requireDescriptor_pb(), g = requireProtoBase64();
  function c(d) {
    return o.FeatureSetDefaults.fromBinary(g.protoBase64.dec(
      /*upstream-inject-feature-defaults-start*/
      "ChMY5gciACoMCAEQAhgCIAMoATACChMY5wciACoMCAIQARgBIAIoATABChMY6AciDAgBEAEYASACKAEwASoAIOYHKOgH"
      /*upstream-inject-feature-defaults-end*/
    ), d);
  }
  function y(d, E, B) {
    var D;
    const x = E ?? c(B), v = x.minimumEdition, F = x.maximumEdition;
    if (v === void 0 || F === void 0 || x.defaults.some((L) => L.edition === void 0))
      throw new Error("Invalid FeatureSetDefaults");
    if (d < v)
      throw new Error(`Edition ${o.Edition[d]} is earlier than the minimum supported edition ${o.Edition[v]}`);
    if (F < d)
      throw new Error(`Edition ${o.Edition[d]} is later than the maximum supported edition ${o.Edition[F]}`);
    let M;
    for (const L of x.defaults) {
      const H = (D = L.edition) !== null && D !== void 0 ? D : 0;
      if (H > d || M !== void 0 && M.e > H)
        continue;
      let fe;
      L.fixedFeatures && L.overridableFeatures ? (fe = L.fixedFeatures, fe.fromBinary(L.overridableFeatures.toBinary())) : L.fixedFeatures ? fe = L.fixedFeatures : L.overridableFeatures ? fe = L.overridableFeatures : fe = new o.FeatureSet(), M = {
        e: H,
        f: fe
      };
    }
    if (M === void 0)
      throw new Error(`No valid default found for edition ${o.Edition[d]}`);
    const U = M.f.toBinary(B);
    return (...L) => {
      const H = o.FeatureSet.fromBinary(U, B);
      for (const fe of L)
        fe !== void 0 && H.fromBinary(fe.toBinary(B), B);
      if (!t(H))
        throw new Error(`Invalid FeatureSet for edition ${o.Edition[d]}`);
      return H;
    };
  }
  featureSet.createFeatureResolver = y;
  function t(d) {
    for (const E of o.FeatureSet.fields.list()) {
      const B = d[E.localName];
      if (B === void 0 || E.kind == "enum" && B === 0)
        return !1;
    }
    return !0;
  }
  return featureSet;
}
var hasRequiredCreateDescriptorSet;
function requireCreateDescriptorSet() {
  if (hasRequiredCreateDescriptorSet) return createDescriptorSet;
  hasRequiredCreateDescriptorSet = 1, Object.defineProperty(createDescriptorSet, "__esModule", { value: !0 }), createDescriptorSet.createDescriptorSet = void 0;
  const o = requireDescriptor_pb(), g = requireAssert$1(), c = requireServiceType(), y = requireNames(), t = requireTextFormat(), d = requireFeatureSet(), E = requireScalar(), B = requireIsMessage();
  function D(st, Dt) {
    var er;
    const xt = {
      files: [],
      enums: /* @__PURE__ */ new Map(),
      messages: /* @__PURE__ */ new Map(),
      services: /* @__PURE__ */ new Map(),
      extensions: /* @__PURE__ */ new Map(),
      mapEntries: /* @__PURE__ */ new Map()
    }, ir = (0, B.isMessage)(st, o.FileDescriptorSet) ? st.file : st instanceof Uint8Array ? o.FileDescriptorSet.fromBinary(st).file : st, sr = /* @__PURE__ */ new Map();
    for (const yr of ir) {
      const wr = (er = yr.edition) !== null && er !== void 0 ? er : Ee(yr.syntax, yr.edition).edition;
      let qr = sr.get(wr);
      qr === void 0 && (qr = (0, d.createFeatureResolver)(wr, Dt == null ? void 0 : Dt.featureSetDefaults, Dt == null ? void 0 : Dt.serializationOptions), sr.set(wr, qr)), x(yr, xt, qr);
    }
    return xt;
  }
  createDescriptorSet.createDescriptorSet = D;
  function x(st, Dt, er) {
    var xt, ir;
    (0, g.assert)(st.name, "invalid FileDescriptorProto: missing name");
    const sr = Object.assign(Object.assign({ kind: "file", proto: st, deprecated: (ir = (xt = st.options) === null || xt === void 0 ? void 0 : xt.deprecated) !== null && ir !== void 0 ? ir : !1 }, Ee(st.syntax, st.edition)), {
      name: st.name.replace(/\.proto/, ""),
      dependencies: Se(st, Dt),
      enums: [],
      messages: [],
      extensions: [],
      services: [],
      toString() {
        return `file ${this.proto.name}`;
      },
      getSyntaxComments() {
        return ke(this.proto.sourceCodeInfo, [
          xe.FileDescriptorProto_Syntax
        ]);
      },
      getPackageComments() {
        return ke(this.proto.sourceCodeInfo, [
          xe.FileDescriptorProto_Package
        ]);
      },
      getFeatures() {
        var yr;
        return er((yr = st.options) === null || yr === void 0 ? void 0 : yr.features);
      }
    });
    Dt.mapEntries.clear();
    for (const yr of st.enumType)
      M(yr, sr, void 0, Dt, er);
    for (const yr of st.messageType)
      U(yr, sr, void 0, Dt, er);
    for (const yr of st.service)
      L(yr, sr, Dt, er);
    v(sr, Dt, er);
    for (const yr of Dt.mapEntries.values())
      F(yr, Dt, er);
    for (const yr of sr.messages)
      F(yr, Dt, er), v(yr, Dt, er);
    Dt.mapEntries.clear(), Dt.files.push(sr);
  }
  function v(st, Dt, er) {
    switch (st.kind) {
      case "file":
        for (const xt of st.proto.extension) {
          const ir = Ie(xt, st, void 0, Dt, er);
          st.extensions.push(ir), Dt.extensions.set(ir.typeName, ir);
        }
        break;
      case "message":
        for (const xt of st.proto.extension) {
          const ir = Ie(xt, st.file, st, Dt, er);
          st.nestedExtensions.push(ir), Dt.extensions.set(ir.typeName, ir);
        }
        for (const xt of st.nestedMessages)
          v(xt, Dt, er);
        break;
    }
  }
  function F(st, Dt, er) {
    const xt = st.proto.oneofDecl.map((sr) => fe(sr, st, er)), ir = /* @__PURE__ */ new Set();
    for (const sr of st.proto.field) {
      const yr = De(sr, xt), wr = ge(sr, st.file, st, yr, Dt, er);
      st.fields.push(wr), yr === void 0 ? st.members.push(wr) : (yr.fields.push(wr), ir.has(yr) || (ir.add(yr), st.members.push(yr)));
    }
    for (const sr of xt.filter((yr) => ir.has(yr)))
      st.oneofs.push(sr);
    for (const sr of st.nestedMessages)
      F(sr, Dt, er);
  }
  function M(st, Dt, er, xt, ir) {
    var sr, yr, wr;
    (0, g.assert)(st.name, "invalid EnumDescriptorProto: missing name");
    const qr = {
      kind: "enum",
      proto: st,
      deprecated: (yr = (sr = st.options) === null || sr === void 0 ? void 0 : sr.deprecated) !== null && yr !== void 0 ? yr : !1,
      file: Dt,
      parent: er,
      name: st.name,
      typeName: ze(st, er, Dt),
      values: [],
      sharedPrefix: (0, y.findEnumSharedPrefix)(st.name, st.value.map((Mr) => {
        var Dr;
        return (Dr = Mr.name) !== null && Dr !== void 0 ? Dr : "";
      })),
      toString() {
        return `enum ${this.typeName}`;
      },
      getComments() {
        const Mr = this.parent ? [
          ...this.parent.getComments().sourcePath,
          xe.DescriptorProto_EnumType,
          this.parent.proto.enumType.indexOf(this.proto)
        ] : [
          xe.FileDescriptorProto_EnumType,
          this.file.proto.enumType.indexOf(this.proto)
        ];
        return ke(Dt.proto.sourceCodeInfo, Mr);
      },
      getFeatures() {
        var Mr, Dr;
        return ir((Mr = er == null ? void 0 : er.getFeatures()) !== null && Mr !== void 0 ? Mr : Dt.getFeatures(), (Dr = st.options) === null || Dr === void 0 ? void 0 : Dr.features);
      }
    };
    xt.enums.set(qr.typeName, qr), st.value.forEach((Mr) => {
      var Dr, Qr;
      (0, g.assert)(Mr.name, "invalid EnumValueDescriptorProto: missing name"), (0, g.assert)(Mr.number !== void 0, "invalid EnumValueDescriptorProto: missing number"), qr.values.push({
        kind: "enum_value",
        proto: Mr,
        deprecated: (Qr = (Dr = Mr.options) === null || Dr === void 0 ? void 0 : Dr.deprecated) !== null && Qr !== void 0 ? Qr : !1,
        parent: qr,
        name: Mr.name,
        number: Mr.number,
        toString() {
          return `enum value ${qr.typeName}.${this.name}`;
        },
        declarationString() {
          var Xr;
          let Vr = `${this.name} = ${this.number}`;
          return ((Xr = this.proto.options) === null || Xr === void 0 ? void 0 : Xr.deprecated) === !0 && (Vr += " [deprecated = true]"), Vr;
        },
        getComments() {
          const Xr = [
            ...this.parent.getComments().sourcePath,
            xe.EnumDescriptorProto_Value,
            this.parent.proto.value.indexOf(this.proto)
          ];
          return ke(Dt.proto.sourceCodeInfo, Xr);
        },
        getFeatures() {
          var Xr;
          return ir(qr.getFeatures(), (Xr = Mr.options) === null || Xr === void 0 ? void 0 : Xr.features);
        }
      });
    }), ((wr = er == null ? void 0 : er.nestedEnums) !== null && wr !== void 0 ? wr : Dt.enums).push(qr);
  }
  function U(st, Dt, er, xt, ir) {
    var sr, yr, wr, qr;
    (0, g.assert)(st.name, "invalid DescriptorProto: missing name");
    const Mr = {
      kind: "message",
      proto: st,
      deprecated: (yr = (sr = st.options) === null || sr === void 0 ? void 0 : sr.deprecated) !== null && yr !== void 0 ? yr : !1,
      file: Dt,
      parent: er,
      name: st.name,
      typeName: ze(st, er, Dt),
      fields: [],
      oneofs: [],
      members: [],
      nestedEnums: [],
      nestedMessages: [],
      nestedExtensions: [],
      toString() {
        return `message ${this.typeName}`;
      },
      getComments() {
        const Dr = this.parent ? [
          ...this.parent.getComments().sourcePath,
          xe.DescriptorProto_NestedType,
          this.parent.proto.nestedType.indexOf(this.proto)
        ] : [
          xe.FileDescriptorProto_MessageType,
          this.file.proto.messageType.indexOf(this.proto)
        ];
        return ke(Dt.proto.sourceCodeInfo, Dr);
      },
      getFeatures() {
        var Dr, Qr;
        return ir((Dr = er == null ? void 0 : er.getFeatures()) !== null && Dr !== void 0 ? Dr : Dt.getFeatures(), (Qr = st.options) === null || Qr === void 0 ? void 0 : Qr.features);
      }
    };
    ((wr = st.options) === null || wr === void 0 ? void 0 : wr.mapEntry) === !0 ? xt.mapEntries.set(Mr.typeName, Mr) : (((qr = er == null ? void 0 : er.nestedMessages) !== null && qr !== void 0 ? qr : Dt.messages).push(Mr), xt.messages.set(Mr.typeName, Mr));
    for (const Dr of st.enumType)
      M(Dr, Dt, Mr, xt, ir);
    for (const Dr of st.nestedType)
      U(Dr, Dt, Mr, xt, ir);
  }
  function L(st, Dt, er, xt) {
    var ir, sr;
    (0, g.assert)(st.name, "invalid ServiceDescriptorProto: missing name");
    const yr = {
      kind: "service",
      proto: st,
      deprecated: (sr = (ir = st.options) === null || ir === void 0 ? void 0 : ir.deprecated) !== null && sr !== void 0 ? sr : !1,
      file: Dt,
      name: st.name,
      typeName: ze(st, void 0, Dt),
      methods: [],
      toString() {
        return `service ${this.typeName}`;
      },
      getComments() {
        const wr = [
          xe.FileDescriptorProto_Service,
          this.file.proto.service.indexOf(this.proto)
        ];
        return ke(Dt.proto.sourceCodeInfo, wr);
      },
      getFeatures() {
        var wr;
        return xt(Dt.getFeatures(), (wr = st.options) === null || wr === void 0 ? void 0 : wr.features);
      }
    };
    Dt.services.push(yr), er.services.set(yr.typeName, yr);
    for (const wr of st.method)
      yr.methods.push(H(wr, yr, er, xt));
  }
  function H(st, Dt, er, xt) {
    var ir, sr, yr;
    (0, g.assert)(st.name, "invalid MethodDescriptorProto: missing name"), (0, g.assert)(st.inputType, "invalid MethodDescriptorProto: missing input_type"), (0, g.assert)(st.outputType, "invalid MethodDescriptorProto: missing output_type");
    let wr;
    st.clientStreaming === !0 && st.serverStreaming === !0 ? wr = c.MethodKind.BiDiStreaming : st.clientStreaming === !0 ? wr = c.MethodKind.ClientStreaming : st.serverStreaming === !0 ? wr = c.MethodKind.ServerStreaming : wr = c.MethodKind.Unary;
    let qr;
    switch ((ir = st.options) === null || ir === void 0 ? void 0 : ir.idempotencyLevel) {
      case o.MethodOptions_IdempotencyLevel.IDEMPOTENT:
        qr = c.MethodIdempotency.Idempotent;
        break;
      case o.MethodOptions_IdempotencyLevel.NO_SIDE_EFFECTS:
        qr = c.MethodIdempotency.NoSideEffects;
        break;
      case o.MethodOptions_IdempotencyLevel.IDEMPOTENCY_UNKNOWN:
      case void 0:
        qr = void 0;
        break;
    }
    const Mr = er.messages.get(He(st.inputType)), Dr = er.messages.get(He(st.outputType));
    (0, g.assert)(Mr, `invalid MethodDescriptorProto: input_type ${st.inputType} not found`), (0, g.assert)(Dr, `invalid MethodDescriptorProto: output_type ${st.inputType} not found`);
    const Qr = st.name;
    return {
      kind: "rpc",
      proto: st,
      deprecated: (yr = (sr = st.options) === null || sr === void 0 ? void 0 : sr.deprecated) !== null && yr !== void 0 ? yr : !1,
      parent: Dt,
      name: Qr,
      methodKind: wr,
      input: Mr,
      output: Dr,
      idempotency: qr,
      toString() {
        return `rpc ${Dt.typeName}.${Qr}`;
      },
      getComments() {
        const Xr = [
          ...this.parent.getComments().sourcePath,
          xe.ServiceDescriptorProto_Method,
          this.parent.proto.method.indexOf(this.proto)
        ];
        return ke(Dt.file.proto.sourceCodeInfo, Xr);
      },
      getFeatures() {
        var Xr;
        return xt(Dt.getFeatures(), (Xr = st.options) === null || Xr === void 0 ? void 0 : Xr.features);
      }
    };
  }
  function fe(st, Dt, er) {
    return (0, g.assert)(st.name, "invalid OneofDescriptorProto: missing name"), {
      kind: "oneof",
      proto: st,
      deprecated: !1,
      parent: Dt,
      fields: [],
      name: st.name,
      toString() {
        return `oneof ${Dt.typeName}.${this.name}`;
      },
      getComments() {
        const xt = [
          ...this.parent.getComments().sourcePath,
          xe.DescriptorProto_OneofDecl,
          this.parent.proto.oneofDecl.indexOf(this.proto)
        ];
        return ke(Dt.file.proto.sourceCodeInfo, xt);
      },
      getFeatures() {
        var xt;
        return er(Dt.getFeatures(), (xt = st.options) === null || xt === void 0 ? void 0 : xt.features);
      }
    };
  }
  function ge(st, Dt, er, xt, ir, sr) {
    var yr, wr, qr;
    (0, g.assert)(st.name, "invalid FieldDescriptorProto: missing name"), (0, g.assert)(st.number, "invalid FieldDescriptorProto: missing number"), (0, g.assert)(st.type, "invalid FieldDescriptorProto: missing type");
    const Mr = {
      proto: st,
      deprecated: (wr = (yr = st.options) === null || yr === void 0 ? void 0 : yr.deprecated) !== null && wr !== void 0 ? wr : !1,
      name: st.name,
      number: st.number,
      parent: er,
      oneof: xt,
      optional: ve(st, Dt.syntax),
      packedByDefault: Fe(st, sr),
      packed: be(Dt, er, st, sr),
      jsonName: st.jsonName === (0, y.fieldJsonName)(st.name) ? void 0 : st.jsonName,
      scalar: void 0,
      longType: void 0,
      message: void 0,
      enum: void 0,
      mapKey: void 0,
      mapValue: void 0,
      declarationString: Ne,
      // toString, getComments, getFeatures are overridden in newExtension
      toString() {
        return `field ${this.parent.typeName}.${this.name}`;
      },
      getComments() {
        const Qr = [
          ...this.parent.getComments().sourcePath,
          xe.DescriptorProto_Field,
          this.parent.proto.field.indexOf(this.proto)
        ];
        return ke(Dt.proto.sourceCodeInfo, Qr);
      },
      getFeatures() {
        var Qr;
        return sr(er.getFeatures(), (Qr = st.options) === null || Qr === void 0 ? void 0 : Qr.features);
      }
    }, Dr = st.label === o.FieldDescriptorProto_Label.REPEATED;
    switch (st.type) {
      case o.FieldDescriptorProto_Type.MESSAGE:
      case o.FieldDescriptorProto_Type.GROUP: {
        (0, g.assert)(st.typeName, "invalid FieldDescriptorProto: missing type_name");
        const Qr = ir.mapEntries.get(He(st.typeName));
        if (Qr !== void 0)
          return (0, g.assert)(Dr, "invalid FieldDescriptorProto: expected map entry to be repeated"), Object.assign(Object.assign(Object.assign({}, Mr), { kind: "field", fieldKind: "map", repeated: !1 }), Pe(Qr));
        const Xr = ir.messages.get(He(st.typeName));
        return (0, g.assert)(Xr !== void 0, `invalid FieldDescriptorProto: type_name ${st.typeName} not found`), Object.assign(Object.assign({}, Mr), {
          kind: "field",
          fieldKind: "message",
          repeated: Dr,
          message: Xr
        });
      }
      case o.FieldDescriptorProto_Type.ENUM: {
        (0, g.assert)(st.typeName, "invalid FieldDescriptorProto: missing type_name");
        const Qr = ir.enums.get(He(st.typeName));
        return (0, g.assert)(Qr !== void 0, `invalid FieldDescriptorProto: type_name ${st.typeName} not found`), Object.assign(Object.assign({}, Mr), {
          kind: "field",
          fieldKind: "enum",
          getDefaultValue: Et,
          repeated: Dr,
          enum: Qr
        });
      }
      default: {
        const Qr = Be[st.type];
        return (0, g.assert)(Qr, `invalid FieldDescriptorProto: unknown type ${st.type}`), Object.assign(Object.assign({}, Mr), {
          kind: "field",
          fieldKind: "scalar",
          getDefaultValue: Et,
          repeated: Dr,
          scalar: Qr,
          longType: ((qr = st.options) === null || qr === void 0 ? void 0 : qr.jstype) == o.FieldOptions_JSType.JS_STRING ? E.LongType.STRING : E.LongType.BIGINT
        });
      }
    }
  }
  function Ie(st, Dt, er, xt, ir) {
    (0, g.assert)(st.extendee, "invalid FieldDescriptorProto: missing extendee");
    const sr = ge(
      st,
      Dt,
      null,
      // to safe us many lines of duplicated code, we trick the type system
      void 0,
      xt,
      ir
    ), yr = xt.messages.get(He(st.extendee));
    return (0, g.assert)(yr, `invalid FieldDescriptorProto: extendee ${st.extendee} not found`), Object.assign(Object.assign({}, sr), {
      kind: "extension",
      typeName: ze(st, er, Dt),
      parent: er,
      file: Dt,
      extendee: yr,
      // Must override toString, getComments, getFeatures from newField, because we
      // call newField with parent undefined.
      toString() {
        return `extension ${this.typeName}`;
      },
      getComments() {
        const wr = this.parent ? [
          ...this.parent.getComments().sourcePath,
          xe.DescriptorProto_Extension,
          this.parent.proto.extension.indexOf(st)
        ] : [
          xe.FileDescriptorProto_Extension,
          this.file.proto.extension.indexOf(st)
        ];
        return ke(Dt.proto.sourceCodeInfo, wr);
      },
      getFeatures() {
        var wr;
        return ir((er ?? Dt).getFeatures(), (wr = st.options) === null || wr === void 0 ? void 0 : wr.features);
      }
    });
  }
  function Ee(st, Dt) {
    let er, xt;
    switch (st) {
      case void 0:
      case "proto2":
        xt = "proto2", er = o.Edition.EDITION_PROTO2;
        break;
      case "proto3":
        xt = "proto3", er = o.Edition.EDITION_PROTO3;
        break;
      case "editions":
        switch (xt = "editions", Dt) {
          case void 0:
          case o.Edition.EDITION_1_TEST_ONLY:
          case o.Edition.EDITION_2_TEST_ONLY:
          case o.Edition.EDITION_99997_TEST_ONLY:
          case o.Edition.EDITION_99998_TEST_ONLY:
          case o.Edition.EDITION_99999_TEST_ONLY:
          case o.Edition.EDITION_UNKNOWN:
            er = o.Edition.EDITION_UNKNOWN;
            break;
          default:
            er = Dt;
            break;
        }
        break;
      default:
        throw new Error(`invalid FileDescriptorProto: unsupported syntax: ${st}`);
    }
    if (st === "editions" && Dt === o.Edition.EDITION_UNKNOWN)
      throw new Error(`invalid FileDescriptorProto: syntax ${st} cannot have edition ${String(Dt)}`);
    return {
      syntax: xt,
      edition: er
    };
  }
  function Se(st, Dt) {
    return st.dependency.map((er) => {
      const xt = Dt.files.find((ir) => ir.proto.name === er);
      return (0, g.assert)(xt), xt;
    });
  }
  function ze(st, Dt, er) {
    (0, g.assert)(st.name, `invalid ${st.getType().typeName}: missing name`);
    let xt;
    return Dt ? xt = `${Dt.typeName}.${st.name}` : er.proto.package !== void 0 ? xt = `${er.proto.package}.${st.name}` : xt = `${st.name}`, xt;
  }
  function He(st) {
    return st.startsWith(".") ? st.substring(1) : st;
  }
  function Pe(st) {
    var Dt, er;
    (0, g.assert)((Dt = st.proto.options) === null || Dt === void 0 ? void 0 : Dt.mapEntry, `invalid DescriptorProto: expected ${st.toString()} to be a map entry`), (0, g.assert)(st.fields.length === 2, `invalid DescriptorProto: map entry ${st.toString()} has ${st.fields.length} fields`);
    const xt = st.fields.find((yr) => yr.proto.number === 1);
    (0, g.assert)(xt, `invalid DescriptorProto: map entry ${st.toString()} is missing key field`);
    const ir = xt.scalar;
    (0, g.assert)(ir !== void 0 && ir !== E.ScalarType.BYTES && ir !== E.ScalarType.FLOAT && ir !== E.ScalarType.DOUBLE, `invalid DescriptorProto: map entry ${st.toString()} has unexpected key type ${(er = xt.proto.type) !== null && er !== void 0 ? er : -1}`);
    const sr = st.fields.find((yr) => yr.proto.number === 2);
    switch ((0, g.assert)(sr, `invalid DescriptorProto: map entry ${st.toString()} is missing value field`), sr.fieldKind) {
      case "scalar":
        return {
          mapKey: ir,
          mapValue: Object.assign(Object.assign({}, sr), { kind: "scalar" })
        };
      case "message":
        return {
          mapKey: ir,
          mapValue: Object.assign(Object.assign({}, sr), { kind: "message" })
        };
      case "enum":
        return {
          mapKey: ir,
          mapValue: Object.assign(Object.assign({}, sr), { kind: "enum" })
        };
      default:
        throw new Error("invalid DescriptorProto: unsupported map entry value field");
    }
  }
  function De(st, Dt) {
    var er;
    const xt = st.oneofIndex;
    if (xt === void 0)
      return;
    let ir;
    return st.proto3Optional !== !0 && (ir = Dt[xt], (0, g.assert)(ir, `invalid FieldDescriptorProto: oneof #${xt} for field #${(er = st.number) !== null && er !== void 0 ? er : -1} not found`)), ir;
  }
  function ve(st, Dt) {
    switch (Dt) {
      case "proto2":
        return st.oneofIndex === void 0 && st.label === o.FieldDescriptorProto_Label.OPTIONAL;
      case "proto3":
        return st.proto3Optional === !0;
      case "editions":
        return !1;
    }
  }
  function Fe(st, Dt) {
    const { repeatedFieldEncoding: er } = Dt();
    if (er != o.FeatureSet_RepeatedFieldEncoding.PACKED)
      return !1;
    switch (st.type) {
      case o.FieldDescriptorProto_Type.STRING:
      case o.FieldDescriptorProto_Type.BYTES:
      case o.FieldDescriptorProto_Type.GROUP:
      case o.FieldDescriptorProto_Type.MESSAGE:
        return !1;
      default:
        return !0;
    }
  }
  function be(st, Dt, er, xt) {
    var ir, sr, yr, wr, qr, Mr;
    switch (er.type) {
      case o.FieldDescriptorProto_Type.STRING:
      case o.FieldDescriptorProto_Type.BYTES:
      case o.FieldDescriptorProto_Type.GROUP:
      case o.FieldDescriptorProto_Type.MESSAGE:
        return !1;
      default:
        switch (st.edition) {
          case o.Edition.EDITION_PROTO2:
            return (sr = (ir = er.options) === null || ir === void 0 ? void 0 : ir.packed) !== null && sr !== void 0 ? sr : !1;
          case o.Edition.EDITION_PROTO3:
            return (wr = (yr = er.options) === null || yr === void 0 ? void 0 : yr.packed) !== null && wr !== void 0 ? wr : !0;
          default: {
            const { repeatedFieldEncoding: Dr } = xt((qr = Dt == null ? void 0 : Dt.getFeatures()) !== null && qr !== void 0 ? qr : st.getFeatures(), (Mr = er.options) === null || Mr === void 0 ? void 0 : Mr.features);
            return Dr == o.FeatureSet_RepeatedFieldEncoding.PACKED;
          }
        }
    }
  }
  const Be = {
    [o.FieldDescriptorProto_Type.DOUBLE]: E.ScalarType.DOUBLE,
    [o.FieldDescriptorProto_Type.FLOAT]: E.ScalarType.FLOAT,
    [o.FieldDescriptorProto_Type.INT64]: E.ScalarType.INT64,
    [o.FieldDescriptorProto_Type.UINT64]: E.ScalarType.UINT64,
    [o.FieldDescriptorProto_Type.INT32]: E.ScalarType.INT32,
    [o.FieldDescriptorProto_Type.FIXED64]: E.ScalarType.FIXED64,
    [o.FieldDescriptorProto_Type.FIXED32]: E.ScalarType.FIXED32,
    [o.FieldDescriptorProto_Type.BOOL]: E.ScalarType.BOOL,
    [o.FieldDescriptorProto_Type.STRING]: E.ScalarType.STRING,
    [o.FieldDescriptorProto_Type.GROUP]: void 0,
    [o.FieldDescriptorProto_Type.MESSAGE]: void 0,
    [o.FieldDescriptorProto_Type.BYTES]: E.ScalarType.BYTES,
    [o.FieldDescriptorProto_Type.UINT32]: E.ScalarType.UINT32,
    [o.FieldDescriptorProto_Type.ENUM]: void 0,
    [o.FieldDescriptorProto_Type.SFIXED32]: E.ScalarType.SFIXED32,
    [o.FieldDescriptorProto_Type.SFIXED64]: E.ScalarType.SFIXED64,
    [o.FieldDescriptorProto_Type.SINT32]: E.ScalarType.SINT32,
    [o.FieldDescriptorProto_Type.SINT64]: E.ScalarType.SINT64
  };
  function ke(st, Dt) {
    if (!st)
      return {
        leadingDetached: [],
        sourcePath: Dt
      };
    for (const er of st.location)
      if (er.path.length === Dt.length && !er.path.some((xt, ir) => Dt[ir] !== xt))
        return {
          leadingDetached: er.leadingDetachedComments,
          leading: er.leadingComments,
          trailing: er.trailingComments,
          sourcePath: Dt
        };
    return {
      leadingDetached: [],
      sourcePath: Dt
    };
  }
  var xe;
  (function(st) {
    st[st.FileDescriptorProto_Package = 2] = "FileDescriptorProto_Package", st[st.FileDescriptorProto_MessageType = 4] = "FileDescriptorProto_MessageType", st[st.FileDescriptorProto_EnumType = 5] = "FileDescriptorProto_EnumType", st[st.FileDescriptorProto_Service = 6] = "FileDescriptorProto_Service", st[st.FileDescriptorProto_Extension = 7] = "FileDescriptorProto_Extension", st[st.FileDescriptorProto_Syntax = 12] = "FileDescriptorProto_Syntax", st[st.DescriptorProto_Field = 2] = "DescriptorProto_Field", st[st.DescriptorProto_NestedType = 3] = "DescriptorProto_NestedType", st[st.DescriptorProto_EnumType = 4] = "DescriptorProto_EnumType", st[st.DescriptorProto_Extension = 6] = "DescriptorProto_Extension", st[st.DescriptorProto_OneofDecl = 8] = "DescriptorProto_OneofDecl", st[st.EnumDescriptorProto_Value = 2] = "EnumDescriptorProto_Value", st[st.ServiceDescriptorProto_Method = 2] = "ServiceDescriptorProto_Method";
  })(xe || (xe = {}));
  function Ne() {
    var st, Dt, er;
    const xt = [];
    this.repeated && xt.push("repeated"), this.optional && xt.push("optional"), (this.kind === "extension" ? this.file : this.parent.file).syntax == "proto2" && this.proto.label === o.FieldDescriptorProto_Label.REQUIRED && xt.push("required");
    let sr;
    switch (this.fieldKind) {
      case "scalar":
        sr = E.ScalarType[this.scalar].toLowerCase();
        break;
      case "enum":
        sr = this.enum.typeName;
        break;
      case "message":
        sr = this.message.typeName;
        break;
      case "map": {
        const qr = E.ScalarType[this.mapKey].toLowerCase();
        let Mr;
        switch (this.mapValue.kind) {
          case "scalar":
            Mr = E.ScalarType[this.mapValue.scalar].toLowerCase();
            break;
          case "enum":
            Mr = this.mapValue.enum.typeName;
            break;
          case "message":
            Mr = this.mapValue.message.typeName;
            break;
        }
        sr = `map<${qr}, ${Mr}>`;
        break;
      }
    }
    xt.push(`${sr} ${this.name} = ${this.number}`);
    const yr = [];
    ((st = this.proto.options) === null || st === void 0 ? void 0 : st.packed) !== void 0 && yr.push(`packed = ${this.proto.options.packed.toString()}`);
    let wr = this.proto.defaultValue;
    return wr !== void 0 && ((this.proto.type == o.FieldDescriptorProto_Type.BYTES || this.proto.type == o.FieldDescriptorProto_Type.STRING) && (wr = '"' + wr.replace('"', '\\"') + '"'), yr.push(`default = ${wr}`)), this.jsonName !== void 0 && yr.push(`json_name = "${this.jsonName}"`), ((Dt = this.proto.options) === null || Dt === void 0 ? void 0 : Dt.jstype) !== void 0 && yr.push(`jstype = ${o.FieldOptions_JSType[this.proto.options.jstype]}`), ((er = this.proto.options) === null || er === void 0 ? void 0 : er.deprecated) === !0 && yr.push("deprecated = true"), yr.length > 0 && xt.push("[" + yr.join(", ") + "]"), xt.join(" ");
  }
  function Et() {
    const st = this.proto.defaultValue;
    if (st !== void 0)
      switch (this.fieldKind) {
        case "enum":
          return (0, t.parseTextFormatEnumValue)(this.enum, st);
        case "scalar":
          return (0, t.parseTextFormatScalarValue)(this.scalar, st);
        default:
          return;
      }
  }
  return createDescriptorSet;
}
var createRegistry = {}, hasRequiredCreateRegistry;
function requireCreateRegistry() {
  if (hasRequiredCreateRegistry) return createRegistry;
  hasRequiredCreateRegistry = 1, Object.defineProperty(createRegistry, "__esModule", { value: !0 }), createRegistry.createMutableRegistry = createRegistry.createRegistry = void 0;
  function o(...c) {
    const y = g(...c);
    return delete y.add, y;
  }
  createRegistry.createRegistry = o;
  function g(...c) {
    const y = {}, t = {}, d = {}, E = /* @__PURE__ */ new Map(), B = /* @__PURE__ */ new Map(), D = {
      findMessage(v) {
        return y[v];
      },
      findEnum(v) {
        return t[v];
      },
      findService(v) {
        return d[v];
      },
      findExtensionFor(v, F) {
        var M, U;
        return (U = (M = B.get(v)) === null || M === void 0 ? void 0 : M.get(F)) !== null && U !== void 0 ? U : void 0;
      },
      findExtension(v) {
        var F;
        return (F = E.get(v)) !== null && F !== void 0 ? F : void 0;
      },
      add(v) {
        var F;
        if ("fields" in v)
          this.findMessage(v.typeName) || (y[v.typeName] = v, v.fields.list().forEach(x));
        else if ("methods" in v) {
          if (!this.findService(v.typeName)) {
            d[v.typeName] = v;
            for (const M of Object.values(v.methods))
              this.add(M.I), this.add(M.O);
          }
        } else if ("extendee" in v) {
          if (!E.has(v.typeName)) {
            E.set(v.typeName, v);
            const M = v.extendee.typeName;
            B.has(M) || B.set(M, /* @__PURE__ */ new Map()), (F = B.get(M)) === null || F === void 0 || F.set(v.field.no, v), this.add(v.extendee), x(v.field);
          }
        } else
          t[v.typeName] = v;
      }
    };
    function x(v) {
      v.kind == "message" ? D.add(v.T) : v.kind == "map" && v.V.kind == "message" ? D.add(v.V.T) : v.kind == "enum" && D.add(v.T);
    }
    for (const v of c)
      D.add(v);
    return D;
  }
  return createRegistry.createMutableRegistry = g, createRegistry;
}
var createRegistryFromDesc = {}, timestamp_pb = {}, hasRequiredTimestamp_pb;
function requireTimestamp_pb() {
  if (hasRequiredTimestamp_pb) return timestamp_pb;
  hasRequiredTimestamp_pb = 1, Object.defineProperty(timestamp_pb, "__esModule", { value: !0 }), timestamp_pb.Timestamp = void 0;
  const o = requireMessage(), g = requireProtoInt64(), c = requireProto3();
  class y extends o.Message {
    constructor(d) {
      super(), this.seconds = g.protoInt64.zero, this.nanos = 0, c.proto3.util.initPartial(d, this);
    }
    fromJson(d, E) {
      if (typeof d != "string")
        throw new Error(`cannot decode google.protobuf.Timestamp from JSON: ${c.proto3.json.debug(d)}`);
      const B = d.match(/^([0-9]{4})-([0-9]{2})-([0-9]{2})T([0-9]{2}):([0-9]{2}):([0-9]{2})(?:Z|\.([0-9]{3,9})Z|([+-][0-9][0-9]:[0-9][0-9]))$/);
      if (!B)
        throw new Error("cannot decode google.protobuf.Timestamp from JSON: invalid RFC 3339 string");
      const D = Date.parse(B[1] + "-" + B[2] + "-" + B[3] + "T" + B[4] + ":" + B[5] + ":" + B[6] + (B[8] ? B[8] : "Z"));
      if (Number.isNaN(D))
        throw new Error("cannot decode google.protobuf.Timestamp from JSON: invalid RFC 3339 string");
      if (D < Date.parse("0001-01-01T00:00:00Z") || D > Date.parse("9999-12-31T23:59:59Z"))
        throw new Error("cannot decode message google.protobuf.Timestamp from JSON: must be from 0001-01-01T00:00:00Z to 9999-12-31T23:59:59Z inclusive");
      return this.seconds = g.protoInt64.parse(D / 1e3), this.nanos = 0, B[7] && (this.nanos = parseInt("1" + B[7] + "0".repeat(9 - B[7].length)) - 1e9), this;
    }
    toJson(d) {
      const E = Number(this.seconds) * 1e3;
      if (E < Date.parse("0001-01-01T00:00:00Z") || E > Date.parse("9999-12-31T23:59:59Z"))
        throw new Error("cannot encode google.protobuf.Timestamp to JSON: must be from 0001-01-01T00:00:00Z to 9999-12-31T23:59:59Z inclusive");
      if (this.nanos < 0)
        throw new Error("cannot encode google.protobuf.Timestamp to JSON: nanos must not be negative");
      let B = "Z";
      if (this.nanos > 0) {
        const D = (this.nanos + 1e9).toString().substring(1);
        D.substring(3) === "000000" ? B = "." + D.substring(0, 3) + "Z" : D.substring(6) === "000" ? B = "." + D.substring(0, 6) + "Z" : B = "." + D + "Z";
      }
      return new Date(E).toISOString().replace(".000Z", B);
    }
    toDate() {
      return new Date(Number(this.seconds) * 1e3 + Math.ceil(this.nanos / 1e6));
    }
    static now() {
      return y.fromDate(/* @__PURE__ */ new Date());
    }
    static fromDate(d) {
      const E = d.getTime();
      return new y({
        seconds: g.protoInt64.parse(Math.floor(E / 1e3)),
        nanos: E % 1e3 * 1e6
      });
    }
    static fromBinary(d, E) {
      return new y().fromBinary(d, E);
    }
    static fromJson(d, E) {
      return new y().fromJson(d, E);
    }
    static fromJsonString(d, E) {
      return new y().fromJsonString(d, E);
    }
    static equals(d, E) {
      return c.proto3.util.equals(y, d, E);
    }
  }
  return timestamp_pb.Timestamp = y, y.runtime = c.proto3, y.typeName = "google.protobuf.Timestamp", y.fields = c.proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "seconds",
      kind: "scalar",
      T: 3
      /* ScalarType.INT64 */
    },
    {
      no: 2,
      name: "nanos",
      kind: "scalar",
      T: 5
      /* ScalarType.INT32 */
    }
  ]), timestamp_pb;
}
var duration_pb = {}, hasRequiredDuration_pb;
function requireDuration_pb() {
  if (hasRequiredDuration_pb) return duration_pb;
  hasRequiredDuration_pb = 1, Object.defineProperty(duration_pb, "__esModule", { value: !0 }), duration_pb.Duration = void 0;
  const o = requireMessage(), g = requireProtoInt64(), c = requireProto3();
  class y extends o.Message {
    constructor(d) {
      super(), this.seconds = g.protoInt64.zero, this.nanos = 0, c.proto3.util.initPartial(d, this);
    }
    fromJson(d, E) {
      if (typeof d != "string")
        throw new Error(`cannot decode google.protobuf.Duration from JSON: ${c.proto3.json.debug(d)}`);
      const B = d.match(/^(-?[0-9]+)(?:\.([0-9]+))?s/);
      if (B === null)
        throw new Error(`cannot decode google.protobuf.Duration from JSON: ${c.proto3.json.debug(d)}`);
      const D = Number(B[1]);
      if (D > 315576e6 || D < -315576e6)
        throw new Error(`cannot decode google.protobuf.Duration from JSON: ${c.proto3.json.debug(d)}`);
      if (this.seconds = g.protoInt64.parse(D), typeof B[2] == "string") {
        const x = B[2] + "0".repeat(9 - B[2].length);
        this.nanos = parseInt(x), (D < 0 || Object.is(D, -0)) && (this.nanos = -this.nanos);
      }
      return this;
    }
    toJson(d) {
      if (Number(this.seconds) > 315576e6 || Number(this.seconds) < -315576e6)
        throw new Error("cannot encode google.protobuf.Duration to JSON: value out of range");
      let E = this.seconds.toString();
      if (this.nanos !== 0) {
        let B = Math.abs(this.nanos).toString();
        B = "0".repeat(9 - B.length) + B, B.substring(3) === "000000" ? B = B.substring(0, 3) : B.substring(6) === "000" && (B = B.substring(0, 6)), E += "." + B, this.nanos < 0 && Number(this.seconds) == 0 && (E = "-" + E);
      }
      return E + "s";
    }
    static fromBinary(d, E) {
      return new y().fromBinary(d, E);
    }
    static fromJson(d, E) {
      return new y().fromJson(d, E);
    }
    static fromJsonString(d, E) {
      return new y().fromJsonString(d, E);
    }
    static equals(d, E) {
      return c.proto3.util.equals(y, d, E);
    }
  }
  return duration_pb.Duration = y, y.runtime = c.proto3, y.typeName = "google.protobuf.Duration", y.fields = c.proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "seconds",
      kind: "scalar",
      T: 3
      /* ScalarType.INT64 */
    },
    {
      no: 2,
      name: "nanos",
      kind: "scalar",
      T: 5
      /* ScalarType.INT32 */
    }
  ]), duration_pb;
}
var any_pb = {}, hasRequiredAny_pb;
function requireAny_pb() {
  if (hasRequiredAny_pb) return any_pb;
  hasRequiredAny_pb = 1, Object.defineProperty(any_pb, "__esModule", { value: !0 }), any_pb.Any = void 0;
  const o = requireMessage(), g = requireProto3();
  class c extends o.Message {
    constructor(t) {
      super(), this.typeUrl = "", this.value = new Uint8Array(0), g.proto3.util.initPartial(t, this);
    }
    toJson(t) {
      var d;
      if (this.typeUrl === "")
        return {};
      const E = this.typeUrlToName(this.typeUrl), B = (d = t == null ? void 0 : t.typeRegistry) === null || d === void 0 ? void 0 : d.findMessage(E);
      if (!B)
        throw new Error(`cannot encode message google.protobuf.Any to JSON: "${this.typeUrl}" is not in the type registry`);
      let x = B.fromBinary(this.value).toJson(t);
      return (E.startsWith("google.protobuf.") || x === null || Array.isArray(x) || typeof x != "object") && (x = { value: x }), x["@type"] = this.typeUrl, x;
    }
    fromJson(t, d) {
      var E;
      if (t === null || Array.isArray(t) || typeof t != "object")
        throw new Error(`cannot decode message google.protobuf.Any from JSON: expected object but got ${t === null ? "null" : Array.isArray(t) ? "array" : typeof t}`);
      if (Object.keys(t).length == 0)
        return this;
      const B = t["@type"];
      if (typeof B != "string" || B == "")
        throw new Error('cannot decode message google.protobuf.Any from JSON: "@type" is empty');
      const D = this.typeUrlToName(B), x = (E = d == null ? void 0 : d.typeRegistry) === null || E === void 0 ? void 0 : E.findMessage(D);
      if (!x)
        throw new Error(`cannot decode message google.protobuf.Any from JSON: ${B} is not in the type registry`);
      let v;
      if (D.startsWith("google.protobuf.") && Object.prototype.hasOwnProperty.call(t, "value"))
        v = x.fromJson(t.value, d);
      else {
        const F = Object.assign({}, t);
        delete F["@type"], v = x.fromJson(F, d);
      }
      return this.packFrom(v), this;
    }
    packFrom(t) {
      this.value = t.toBinary(), this.typeUrl = this.typeNameToUrl(t.getType().typeName);
    }
    unpackTo(t) {
      return this.is(t.getType()) ? (t.fromBinary(this.value), !0) : !1;
    }
    unpack(t) {
      if (this.typeUrl === "")
        return;
      const d = t.findMessage(this.typeUrlToName(this.typeUrl));
      if (d)
        return d.fromBinary(this.value);
    }
    is(t) {
      if (this.typeUrl === "")
        return !1;
      const d = this.typeUrlToName(this.typeUrl);
      let E = "";
      return typeof t == "string" ? E = t : E = t.typeName, d === E;
    }
    typeNameToUrl(t) {
      return `type.googleapis.com/${t}`;
    }
    typeUrlToName(t) {
      if (!t.length)
        throw new Error(`invalid type url: ${t}`);
      const d = t.lastIndexOf("/"), E = d >= 0 ? t.substring(d + 1) : t;
      if (!E.length)
        throw new Error(`invalid type url: ${t}`);
      return E;
    }
    static pack(t) {
      const d = new c();
      return d.packFrom(t), d;
    }
    static fromBinary(t, d) {
      return new c().fromBinary(t, d);
    }
    static fromJson(t, d) {
      return new c().fromJson(t, d);
    }
    static fromJsonString(t, d) {
      return new c().fromJsonString(t, d);
    }
    static equals(t, d) {
      return g.proto3.util.equals(c, t, d);
    }
  }
  return any_pb.Any = c, c.runtime = g.proto3, c.typeName = "google.protobuf.Any", c.fields = g.proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "type_url",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "value",
      kind: "scalar",
      T: 12
      /* ScalarType.BYTES */
    }
  ]), any_pb;
}
var empty_pb = {}, hasRequiredEmpty_pb;
function requireEmpty_pb() {
  if (hasRequiredEmpty_pb) return empty_pb;
  hasRequiredEmpty_pb = 1, Object.defineProperty(empty_pb, "__esModule", { value: !0 }), empty_pb.Empty = void 0;
  const o = requireMessage(), g = requireProto3();
  class c extends o.Message {
    constructor(t) {
      super(), g.proto3.util.initPartial(t, this);
    }
    static fromBinary(t, d) {
      return new c().fromBinary(t, d);
    }
    static fromJson(t, d) {
      return new c().fromJson(t, d);
    }
    static fromJsonString(t, d) {
      return new c().fromJsonString(t, d);
    }
    static equals(t, d) {
      return g.proto3.util.equals(c, t, d);
    }
  }
  return empty_pb.Empty = c, c.runtime = g.proto3, c.typeName = "google.protobuf.Empty", c.fields = g.proto3.util.newFieldList(() => []), empty_pb;
}
var field_mask_pb = {}, hasRequiredField_mask_pb;
function requireField_mask_pb() {
  if (hasRequiredField_mask_pb) return field_mask_pb;
  hasRequiredField_mask_pb = 1, Object.defineProperty(field_mask_pb, "__esModule", { value: !0 }), field_mask_pb.FieldMask = void 0;
  const o = requireMessage(), g = requireProto3();
  class c extends o.Message {
    constructor(t) {
      super(), this.paths = [], g.proto3.util.initPartial(t, this);
    }
    toJson(t) {
      function d(E) {
        let B = !1;
        const D = [];
        for (let x = 0; x < E.length; x++) {
          let v = E.charAt(x);
          switch (v) {
            case "_":
              B = !0;
              break;
            case "0":
            case "1":
            case "2":
            case "3":
            case "4":
            case "5":
            case "6":
            case "7":
            case "8":
            case "9":
              D.push(v), B = !1;
              break;
            default:
              B && (B = !1, v = v.toUpperCase()), D.push(v);
              break;
          }
        }
        return D.join("");
      }
      return this.paths.map((E) => {
        if (E.match(/_[0-9]?_/g) || E.match(/[A-Z]/g))
          throw new Error('cannot encode google.protobuf.FieldMask to JSON: lowerCamelCase of path name "' + E + '" is irreversible');
        return d(E);
      }).join(",");
    }
    fromJson(t, d) {
      if (typeof t != "string")
        throw new Error("cannot decode google.protobuf.FieldMask from JSON: " + g.proto3.json.debug(t));
      if (t === "")
        return this;
      function E(B) {
        if (B.includes("_"))
          throw new Error("cannot decode google.protobuf.FieldMask from JSON: path names must be lowerCamelCase");
        const D = B.replace(/[A-Z]/g, (x) => "_" + x.toLowerCase());
        return D[0] === "_" ? D.substring(1) : D;
      }
      return this.paths = t.split(",").map(E), this;
    }
    static fromBinary(t, d) {
      return new c().fromBinary(t, d);
    }
    static fromJson(t, d) {
      return new c().fromJson(t, d);
    }
    static fromJsonString(t, d) {
      return new c().fromJsonString(t, d);
    }
    static equals(t, d) {
      return g.proto3.util.equals(c, t, d);
    }
  }
  return field_mask_pb.FieldMask = c, c.runtime = g.proto3, c.typeName = "google.protobuf.FieldMask", c.fields = g.proto3.util.newFieldList(() => [
    { no: 1, name: "paths", kind: "scalar", T: 9, repeated: !0 }
  ]), field_mask_pb;
}
var struct_pb = {}, hasRequiredStruct_pb;
function requireStruct_pb() {
  if (hasRequiredStruct_pb) return struct_pb;
  hasRequiredStruct_pb = 1, Object.defineProperty(struct_pb, "__esModule", { value: !0 }), struct_pb.ListValue = struct_pb.Value = struct_pb.Struct = struct_pb.NullValue = void 0;
  const o = requireProto3(), g = requireMessage();
  var c;
  (function(E) {
    E[E.NULL_VALUE = 0] = "NULL_VALUE";
  })(c || (struct_pb.NullValue = c = {})), o.proto3.util.setEnumType(c, "google.protobuf.NullValue", [
    { no: 0, name: "NULL_VALUE" }
  ]);
  class y extends g.Message {
    constructor(B) {
      super(), this.fields = {}, o.proto3.util.initPartial(B, this);
    }
    toJson(B) {
      const D = {};
      for (const [x, v] of Object.entries(this.fields))
        D[x] = v.toJson(B);
      return D;
    }
    fromJson(B, D) {
      if (typeof B != "object" || B == null || Array.isArray(B))
        throw new Error("cannot decode google.protobuf.Struct from JSON " + o.proto3.json.debug(B));
      for (const [x, v] of Object.entries(B))
        this.fields[x] = t.fromJson(v);
      return this;
    }
    static fromBinary(B, D) {
      return new y().fromBinary(B, D);
    }
    static fromJson(B, D) {
      return new y().fromJson(B, D);
    }
    static fromJsonString(B, D) {
      return new y().fromJsonString(B, D);
    }
    static equals(B, D) {
      return o.proto3.util.equals(y, B, D);
    }
  }
  struct_pb.Struct = y, y.runtime = o.proto3, y.typeName = "google.protobuf.Struct", y.fields = o.proto3.util.newFieldList(() => [
    { no: 1, name: "fields", kind: "map", K: 9, V: { kind: "message", T: t } }
  ]);
  class t extends g.Message {
    constructor(B) {
      super(), this.kind = { case: void 0 }, o.proto3.util.initPartial(B, this);
    }
    toJson(B) {
      switch (this.kind.case) {
        case "nullValue":
          return null;
        case "numberValue":
          if (!Number.isFinite(this.kind.value))
            throw new Error("google.protobuf.Value cannot be NaN or Infinity");
          return this.kind.value;
        case "boolValue":
          return this.kind.value;
        case "stringValue":
          return this.kind.value;
        case "structValue":
        case "listValue":
          return this.kind.value.toJson(Object.assign(Object.assign({}, B), { emitDefaultValues: !0 }));
      }
      throw new Error("google.protobuf.Value must have a value");
    }
    fromJson(B, D) {
      switch (typeof B) {
        case "number":
          this.kind = { case: "numberValue", value: B };
          break;
        case "string":
          this.kind = { case: "stringValue", value: B };
          break;
        case "boolean":
          this.kind = { case: "boolValue", value: B };
          break;
        case "object":
          B === null ? this.kind = { case: "nullValue", value: c.NULL_VALUE } : Array.isArray(B) ? this.kind = { case: "listValue", value: d.fromJson(B) } : this.kind = { case: "structValue", value: y.fromJson(B) };
          break;
        default:
          throw new Error("cannot decode google.protobuf.Value from JSON " + o.proto3.json.debug(B));
      }
      return this;
    }
    static fromBinary(B, D) {
      return new t().fromBinary(B, D);
    }
    static fromJson(B, D) {
      return new t().fromJson(B, D);
    }
    static fromJsonString(B, D) {
      return new t().fromJsonString(B, D);
    }
    static equals(B, D) {
      return o.proto3.util.equals(t, B, D);
    }
  }
  struct_pb.Value = t, t.runtime = o.proto3, t.typeName = "google.protobuf.Value", t.fields = o.proto3.util.newFieldList(() => [
    { no: 1, name: "null_value", kind: "enum", T: o.proto3.getEnumType(c), oneof: "kind" },
    { no: 2, name: "number_value", kind: "scalar", T: 1, oneof: "kind" },
    { no: 3, name: "string_value", kind: "scalar", T: 9, oneof: "kind" },
    { no: 4, name: "bool_value", kind: "scalar", T: 8, oneof: "kind" },
    { no: 5, name: "struct_value", kind: "message", T: y, oneof: "kind" },
    { no: 6, name: "list_value", kind: "message", T: d, oneof: "kind" }
  ]);
  class d extends g.Message {
    constructor(B) {
      super(), this.values = [], o.proto3.util.initPartial(B, this);
    }
    toJson(B) {
      return this.values.map((D) => D.toJson());
    }
    fromJson(B, D) {
      if (!Array.isArray(B))
        throw new Error("cannot decode google.protobuf.ListValue from JSON " + o.proto3.json.debug(B));
      for (let x of B)
        this.values.push(t.fromJson(x));
      return this;
    }
    static fromBinary(B, D) {
      return new d().fromBinary(B, D);
    }
    static fromJson(B, D) {
      return new d().fromJson(B, D);
    }
    static fromJsonString(B, D) {
      return new d().fromJsonString(B, D);
    }
    static equals(B, D) {
      return o.proto3.util.equals(d, B, D);
    }
  }
  return struct_pb.ListValue = d, d.runtime = o.proto3, d.typeName = "google.protobuf.ListValue", d.fields = o.proto3.util.newFieldList(() => [
    { no: 1, name: "values", kind: "message", T: t, repeated: !0 }
  ]), struct_pb;
}
var wrappers_pb = {}, hasRequiredWrappers_pb;
function requireWrappers_pb() {
  if (hasRequiredWrappers_pb) return wrappers_pb;
  hasRequiredWrappers_pb = 1, Object.defineProperty(wrappers_pb, "__esModule", { value: !0 }), wrappers_pb.BytesValue = wrappers_pb.StringValue = wrappers_pb.BoolValue = wrappers_pb.UInt32Value = wrappers_pb.Int32Value = wrappers_pb.UInt64Value = wrappers_pb.Int64Value = wrappers_pb.FloatValue = wrappers_pb.DoubleValue = void 0;
  const o = requireMessage(), g = requireProto3(), c = requireScalar(), y = requireProtoInt64();
  class t extends o.Message {
    constructor(L) {
      super(), this.value = 0, g.proto3.util.initPartial(L, this);
    }
    toJson(L) {
      return g.proto3.json.writeScalar(c.ScalarType.DOUBLE, this.value, !0);
    }
    fromJson(L, H) {
      try {
        this.value = g.proto3.json.readScalar(c.ScalarType.DOUBLE, L);
      } catch (fe) {
        let ge = 'cannot decode message google.protobuf.DoubleValue from JSON"';
        throw fe instanceof Error && fe.message.length > 0 && (ge += `: ${fe.message}`), new Error(ge);
      }
      return this;
    }
    static fromBinary(L, H) {
      return new t().fromBinary(L, H);
    }
    static fromJson(L, H) {
      return new t().fromJson(L, H);
    }
    static fromJsonString(L, H) {
      return new t().fromJsonString(L, H);
    }
    static equals(L, H) {
      return g.proto3.util.equals(t, L, H);
    }
  }
  wrappers_pb.DoubleValue = t, t.runtime = g.proto3, t.typeName = "google.protobuf.DoubleValue", t.fields = g.proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "value",
      kind: "scalar",
      T: 1
      /* ScalarType.DOUBLE */
    }
  ]), t.fieldWrapper = {
    wrapField(U) {
      return new t({ value: U });
    },
    unwrapField(U) {
      return U.value;
    }
  };
  class d extends o.Message {
    constructor(L) {
      super(), this.value = 0, g.proto3.util.initPartial(L, this);
    }
    toJson(L) {
      return g.proto3.json.writeScalar(c.ScalarType.FLOAT, this.value, !0);
    }
    fromJson(L, H) {
      try {
        this.value = g.proto3.json.readScalar(c.ScalarType.FLOAT, L);
      } catch (fe) {
        let ge = 'cannot decode message google.protobuf.FloatValue from JSON"';
        throw fe instanceof Error && fe.message.length > 0 && (ge += `: ${fe.message}`), new Error(ge);
      }
      return this;
    }
    static fromBinary(L, H) {
      return new d().fromBinary(L, H);
    }
    static fromJson(L, H) {
      return new d().fromJson(L, H);
    }
    static fromJsonString(L, H) {
      return new d().fromJsonString(L, H);
    }
    static equals(L, H) {
      return g.proto3.util.equals(d, L, H);
    }
  }
  wrappers_pb.FloatValue = d, d.runtime = g.proto3, d.typeName = "google.protobuf.FloatValue", d.fields = g.proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "value",
      kind: "scalar",
      T: 2
      /* ScalarType.FLOAT */
    }
  ]), d.fieldWrapper = {
    wrapField(U) {
      return new d({ value: U });
    },
    unwrapField(U) {
      return U.value;
    }
  };
  class E extends o.Message {
    constructor(L) {
      super(), this.value = y.protoInt64.zero, g.proto3.util.initPartial(L, this);
    }
    toJson(L) {
      return g.proto3.json.writeScalar(c.ScalarType.INT64, this.value, !0);
    }
    fromJson(L, H) {
      try {
        this.value = g.proto3.json.readScalar(c.ScalarType.INT64, L);
      } catch (fe) {
        let ge = 'cannot decode message google.protobuf.Int64Value from JSON"';
        throw fe instanceof Error && fe.message.length > 0 && (ge += `: ${fe.message}`), new Error(ge);
      }
      return this;
    }
    static fromBinary(L, H) {
      return new E().fromBinary(L, H);
    }
    static fromJson(L, H) {
      return new E().fromJson(L, H);
    }
    static fromJsonString(L, H) {
      return new E().fromJsonString(L, H);
    }
    static equals(L, H) {
      return g.proto3.util.equals(E, L, H);
    }
  }
  wrappers_pb.Int64Value = E, E.runtime = g.proto3, E.typeName = "google.protobuf.Int64Value", E.fields = g.proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "value",
      kind: "scalar",
      T: 3
      /* ScalarType.INT64 */
    }
  ]), E.fieldWrapper = {
    wrapField(U) {
      return new E({ value: U });
    },
    unwrapField(U) {
      return U.value;
    }
  };
  class B extends o.Message {
    constructor(L) {
      super(), this.value = y.protoInt64.zero, g.proto3.util.initPartial(L, this);
    }
    toJson(L) {
      return g.proto3.json.writeScalar(c.ScalarType.UINT64, this.value, !0);
    }
    fromJson(L, H) {
      try {
        this.value = g.proto3.json.readScalar(c.ScalarType.UINT64, L);
      } catch (fe) {
        let ge = 'cannot decode message google.protobuf.UInt64Value from JSON"';
        throw fe instanceof Error && fe.message.length > 0 && (ge += `: ${fe.message}`), new Error(ge);
      }
      return this;
    }
    static fromBinary(L, H) {
      return new B().fromBinary(L, H);
    }
    static fromJson(L, H) {
      return new B().fromJson(L, H);
    }
    static fromJsonString(L, H) {
      return new B().fromJsonString(L, H);
    }
    static equals(L, H) {
      return g.proto3.util.equals(B, L, H);
    }
  }
  wrappers_pb.UInt64Value = B, B.runtime = g.proto3, B.typeName = "google.protobuf.UInt64Value", B.fields = g.proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "value",
      kind: "scalar",
      T: 4
      /* ScalarType.UINT64 */
    }
  ]), B.fieldWrapper = {
    wrapField(U) {
      return new B({ value: U });
    },
    unwrapField(U) {
      return U.value;
    }
  };
  class D extends o.Message {
    constructor(L) {
      super(), this.value = 0, g.proto3.util.initPartial(L, this);
    }
    toJson(L) {
      return g.proto3.json.writeScalar(c.ScalarType.INT32, this.value, !0);
    }
    fromJson(L, H) {
      try {
        this.value = g.proto3.json.readScalar(c.ScalarType.INT32, L);
      } catch (fe) {
        let ge = 'cannot decode message google.protobuf.Int32Value from JSON"';
        throw fe instanceof Error && fe.message.length > 0 && (ge += `: ${fe.message}`), new Error(ge);
      }
      return this;
    }
    static fromBinary(L, H) {
      return new D().fromBinary(L, H);
    }
    static fromJson(L, H) {
      return new D().fromJson(L, H);
    }
    static fromJsonString(L, H) {
      return new D().fromJsonString(L, H);
    }
    static equals(L, H) {
      return g.proto3.util.equals(D, L, H);
    }
  }
  wrappers_pb.Int32Value = D, D.runtime = g.proto3, D.typeName = "google.protobuf.Int32Value", D.fields = g.proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "value",
      kind: "scalar",
      T: 5
      /* ScalarType.INT32 */
    }
  ]), D.fieldWrapper = {
    wrapField(U) {
      return new D({ value: U });
    },
    unwrapField(U) {
      return U.value;
    }
  };
  class x extends o.Message {
    constructor(L) {
      super(), this.value = 0, g.proto3.util.initPartial(L, this);
    }
    toJson(L) {
      return g.proto3.json.writeScalar(c.ScalarType.UINT32, this.value, !0);
    }
    fromJson(L, H) {
      try {
        this.value = g.proto3.json.readScalar(c.ScalarType.UINT32, L);
      } catch (fe) {
        let ge = 'cannot decode message google.protobuf.UInt32Value from JSON"';
        throw fe instanceof Error && fe.message.length > 0 && (ge += `: ${fe.message}`), new Error(ge);
      }
      return this;
    }
    static fromBinary(L, H) {
      return new x().fromBinary(L, H);
    }
    static fromJson(L, H) {
      return new x().fromJson(L, H);
    }
    static fromJsonString(L, H) {
      return new x().fromJsonString(L, H);
    }
    static equals(L, H) {
      return g.proto3.util.equals(x, L, H);
    }
  }
  wrappers_pb.UInt32Value = x, x.runtime = g.proto3, x.typeName = "google.protobuf.UInt32Value", x.fields = g.proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "value",
      kind: "scalar",
      T: 13
      /* ScalarType.UINT32 */
    }
  ]), x.fieldWrapper = {
    wrapField(U) {
      return new x({ value: U });
    },
    unwrapField(U) {
      return U.value;
    }
  };
  class v extends o.Message {
    constructor(L) {
      super(), this.value = !1, g.proto3.util.initPartial(L, this);
    }
    toJson(L) {
      return g.proto3.json.writeScalar(c.ScalarType.BOOL, this.value, !0);
    }
    fromJson(L, H) {
      try {
        this.value = g.proto3.json.readScalar(c.ScalarType.BOOL, L);
      } catch (fe) {
        let ge = 'cannot decode message google.protobuf.BoolValue from JSON"';
        throw fe instanceof Error && fe.message.length > 0 && (ge += `: ${fe.message}`), new Error(ge);
      }
      return this;
    }
    static fromBinary(L, H) {
      return new v().fromBinary(L, H);
    }
    static fromJson(L, H) {
      return new v().fromJson(L, H);
    }
    static fromJsonString(L, H) {
      return new v().fromJsonString(L, H);
    }
    static equals(L, H) {
      return g.proto3.util.equals(v, L, H);
    }
  }
  wrappers_pb.BoolValue = v, v.runtime = g.proto3, v.typeName = "google.protobuf.BoolValue", v.fields = g.proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "value",
      kind: "scalar",
      T: 8
      /* ScalarType.BOOL */
    }
  ]), v.fieldWrapper = {
    wrapField(U) {
      return new v({ value: U });
    },
    unwrapField(U) {
      return U.value;
    }
  };
  class F extends o.Message {
    constructor(L) {
      super(), this.value = "", g.proto3.util.initPartial(L, this);
    }
    toJson(L) {
      return g.proto3.json.writeScalar(c.ScalarType.STRING, this.value, !0);
    }
    fromJson(L, H) {
      try {
        this.value = g.proto3.json.readScalar(c.ScalarType.STRING, L);
      } catch (fe) {
        let ge = 'cannot decode message google.protobuf.StringValue from JSON"';
        throw fe instanceof Error && fe.message.length > 0 && (ge += `: ${fe.message}`), new Error(ge);
      }
      return this;
    }
    static fromBinary(L, H) {
      return new F().fromBinary(L, H);
    }
    static fromJson(L, H) {
      return new F().fromJson(L, H);
    }
    static fromJsonString(L, H) {
      return new F().fromJsonString(L, H);
    }
    static equals(L, H) {
      return g.proto3.util.equals(F, L, H);
    }
  }
  wrappers_pb.StringValue = F, F.runtime = g.proto3, F.typeName = "google.protobuf.StringValue", F.fields = g.proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "value",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]), F.fieldWrapper = {
    wrapField(U) {
      return new F({ value: U });
    },
    unwrapField(U) {
      return U.value;
    }
  };
  class M extends o.Message {
    constructor(L) {
      super(), this.value = new Uint8Array(0), g.proto3.util.initPartial(L, this);
    }
    toJson(L) {
      return g.proto3.json.writeScalar(c.ScalarType.BYTES, this.value, !0);
    }
    fromJson(L, H) {
      try {
        this.value = g.proto3.json.readScalar(c.ScalarType.BYTES, L);
      } catch (fe) {
        let ge = 'cannot decode message google.protobuf.BytesValue from JSON"';
        throw fe instanceof Error && fe.message.length > 0 && (ge += `: ${fe.message}`), new Error(ge);
      }
      return this;
    }
    static fromBinary(L, H) {
      return new M().fromBinary(L, H);
    }
    static fromJson(L, H) {
      return new M().fromJson(L, H);
    }
    static fromJsonString(L, H) {
      return new M().fromJsonString(L, H);
    }
    static equals(L, H) {
      return g.proto3.util.equals(M, L, H);
    }
  }
  return wrappers_pb.BytesValue = M, M.runtime = g.proto3, M.typeName = "google.protobuf.BytesValue", M.fields = g.proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "value",
      kind: "scalar",
      T: 12
      /* ScalarType.BYTES */
    }
  ]), M.fieldWrapper = {
    wrapField(U) {
      return new M({ value: U });
    },
    unwrapField(U) {
      return U.value;
    }
  }, wrappers_pb;
}
var hasRequiredCreateRegistryFromDesc;
function requireCreateRegistryFromDesc() {
  if (hasRequiredCreateRegistryFromDesc) return createRegistryFromDesc;
  hasRequiredCreateRegistryFromDesc = 1, Object.defineProperty(createRegistryFromDesc, "__esModule", { value: !0 }), createRegistryFromDesc.createRegistryFromDescriptors = void 0;
  const o = requireAssert$1(), g = requireProto3(), c = requireProto2(), y = requireNames(), t = requireTimestamp_pb(), d = requireDuration_pb(), E = requireAny_pb(), B = requireEmpty_pb(), D = requireField_mask_pb(), x = requireStruct_pb(), v = require_enum(), F = requireWrappers_pb(), M = requireDescriptor_pb(), U = requireCreateDescriptorSet(), L = requireIsMessage(), H = [
    E.Any,
    d.Duration,
    B.Empty,
    D.FieldMask,
    x.Struct,
    x.Value,
    x.ListValue,
    t.Timestamp,
    d.Duration,
    F.DoubleValue,
    F.FloatValue,
    F.Int64Value,
    F.Int32Value,
    F.UInt32Value,
    F.UInt64Value,
    F.BoolValue,
    F.StringValue,
    F.BytesValue
  ], fe = [(0, v.getEnumType)(x.NullValue)];
  function ge(Se, ze = !0) {
    const He = Se instanceof Uint8Array || (0, L.isMessage)(Se, M.FileDescriptorSet) ? (0, U.createDescriptorSet)(Se) : Se, Pe = /* @__PURE__ */ new Map(), De = /* @__PURE__ */ new Map(), ve = /* @__PURE__ */ new Map(), Fe = /* @__PURE__ */ new Map(), be = {};
    if (ze) {
      for (const Be of H)
        De.set(Be.typeName, Be);
      for (const Be of fe)
        Pe.set(Be.typeName, Be);
    }
    return {
      /**
       * May raise an error on invalid descriptors.
       */
      findEnum(Be) {
        const ke = Pe.get(Be);
        if (ke)
          return ke;
        const xe = He.enums.get(Be);
        if (!xe)
          return;
        const Et = (xe.file.syntax == "proto3" ? g.proto3 : c.proto2).makeEnumType(Be, xe.values.map((st) => ({
          no: st.number,
          name: st.name,
          localName: (0, y.localName)(st)
        })), {});
        return Pe.set(Be, Et), Et;
      },
      /**
       * May raise an error on invalid descriptors.
       */
      findMessage(Be) {
        const ke = De.get(Be);
        if (ke)
          return ke;
        const xe = He.messages.get(Be);
        if (!xe)
          return;
        const Ne = xe.file.syntax == "proto3" ? g.proto3 : c.proto2, Et = [], st = Ne.makeMessageType(Be, () => Et, {
          localName: (0, y.localName)(xe)
        });
        De.set(Be, st);
        for (const Dt of xe.fields)
          Et.push(Ie(Dt, this));
        return st;
      },
      /**
       * May raise an error on invalid descriptors.
       */
      findService(Be) {
        const ke = be[Be];
        if (ke)
          return ke;
        const xe = He.services.get(Be);
        if (!xe)
          return;
        const Ne = {};
        for (const Et of xe.methods) {
          const st = Ee(Et.input, this, Et), Dt = Ee(Et.output, this, Et);
          Ne[(0, y.localName)(Et)] = {
            name: Et.name,
            I: st,
            O: Dt,
            kind: Et.methodKind,
            idempotency: Et.idempotency
            // We do not surface options at this time
            // options: {},
          };
        }
        return be[Be] = {
          typeName: xe.typeName,
          methods: Ne
        };
      },
      /**
       * May raise an error on invalid descriptors.
       */
      findExtensionFor(Be, ke) {
        var xe;
        if (!He.messages.has(Be))
          return;
        let Ne = Fe.get(Be);
        if (!Ne) {
          Ne = /* @__PURE__ */ new Map(), Fe.set(Be, Ne);
          for (const st of He.extensions.values())
            st.extendee.typeName == Be && Ne.set(st.number, st);
        }
        const Et = (xe = Fe.get(Be)) === null || xe === void 0 ? void 0 : xe.get(ke);
        return Et ? this.findExtension(Et.typeName) : void 0;
      },
      /**
       * May raise an error on invalid descriptors.
       */
      findExtension(Be) {
        const ke = ve.get(Be);
        if (ke)
          return ke;
        const xe = He.extensions.get(Be);
        if (!xe)
          return;
        const Ne = Ee(xe.extendee, this, xe), st = (xe.file.syntax == "proto3" ? g.proto3 : c.proto2).makeExtension(Be, Ne, Ie(xe, this));
        return ve.set(Be, st), st;
      }
    };
  }
  createRegistryFromDesc.createRegistryFromDescriptors = ge;
  function Ie(Se, ze) {
    var He;
    const Pe = {
      kind: Se.fieldKind,
      no: Se.number,
      name: Se.name,
      jsonName: Se.jsonName,
      delimited: Se.proto.type == M.FieldDescriptorProto_Type.GROUP,
      repeated: Se.repeated,
      packed: Se.packed,
      oneof: (He = Se.oneof) === null || He === void 0 ? void 0 : He.name,
      opt: Se.optional,
      req: Se.proto.label === M.FieldDescriptorProto_Label.REQUIRED
    };
    switch (Se.fieldKind) {
      case "map": {
        (0, o.assert)(Se.kind == "field");
        let De;
        switch (Se.mapValue.kind) {
          case "scalar":
            De = Se.mapValue.scalar;
            break;
          case "enum": {
            De = Ee(Se.mapValue.enum, ze, Se);
            break;
          }
          case "message": {
            De = Ee(Se.mapValue.message, ze, Se);
            break;
          }
        }
        Pe.K = Se.mapKey, Pe.V = {
          kind: Se.mapValue.kind,
          T: De
        };
        break;
      }
      case "message": {
        Pe.T = Ee(Se.message, ze, Se);
        break;
      }
      case "enum": {
        Pe.T = Ee(Se.enum, ze, Se), Pe.default = Se.getDefaultValue();
        break;
      }
      case "scalar": {
        Pe.L = Se.longType, Pe.T = Se.scalar, Pe.default = Se.getDefaultValue();
        break;
      }
    }
    return Pe;
  }
  function Ee(Se, ze, He) {
    const Pe = Se.kind == "message" ? ze.findMessage(Se.typeName) : ze.findEnum(Se.typeName);
    return (0, o.assert)(Pe, `${Se.toString()}" for ${He.toString()} not found`), Pe;
  }
  return createRegistryFromDesc;
}
var toPlainMessage = {}, hasRequiredToPlainMessage;
function requireToPlainMessage() {
  if (hasRequiredToPlainMessage) return toPlainMessage;
  hasRequiredToPlainMessage = 1, Object.defineProperty(toPlainMessage, "__esModule", { value: !0 }), toPlainMessage.toPlainMessage = void 0;
  const o = requireIsMessage();
  function g(y) {
    if (!(0, o.isMessage)(y))
      return y;
    const t = y.getType(), d = {};
    for (const E of t.fields.byMember()) {
      const B = y[E.localName];
      let D;
      if (E.repeated)
        D = B.map((x) => c(x));
      else if (E.kind == "map") {
        D = {};
        for (const [x, v] of Object.entries(B))
          D[x] = c(v);
      } else E.kind == "oneof" ? D = E.findField(B.case) ? { case: B.case, value: c(B.value) } : { case: void 0 } : D = c(B);
      d[E.localName] = D;
    }
    return d;
  }
  toPlainMessage.toPlainMessage = g;
  function c(y) {
    if (y === void 0)
      return y;
    if ((0, o.isMessage)(y))
      return g(y);
    if (y instanceof Uint8Array) {
      const t = new Uint8Array(y.byteLength);
      return t.set(y), t;
    }
    return y;
  }
  return toPlainMessage;
}
var plugin_pb = {}, hasRequiredPlugin_pb;
function requirePlugin_pb() {
  if (hasRequiredPlugin_pb) return plugin_pb;
  hasRequiredPlugin_pb = 1, Object.defineProperty(plugin_pb, "__esModule", { value: !0 }), plugin_pb.CodeGeneratorResponse_File = plugin_pb.CodeGeneratorResponse_Feature = plugin_pb.CodeGeneratorResponse = plugin_pb.CodeGeneratorRequest = plugin_pb.Version = void 0;
  const o = requireMessage(), g = requireProto2(), c = requireDescriptor_pb();
  class y extends o.Message {
    constructor(x) {
      super(), g.proto2.util.initPartial(x, this);
    }
    static fromBinary(x, v) {
      return new y().fromBinary(x, v);
    }
    static fromJson(x, v) {
      return new y().fromJson(x, v);
    }
    static fromJsonString(x, v) {
      return new y().fromJsonString(x, v);
    }
    static equals(x, v) {
      return g.proto2.util.equals(y, x, v);
    }
  }
  plugin_pb.Version = y, y.runtime = g.proto2, y.typeName = "google.protobuf.compiler.Version", y.fields = g.proto2.util.newFieldList(() => [
    { no: 1, name: "major", kind: "scalar", T: 5, opt: !0 },
    { no: 2, name: "minor", kind: "scalar", T: 5, opt: !0 },
    { no: 3, name: "patch", kind: "scalar", T: 5, opt: !0 },
    { no: 4, name: "suffix", kind: "scalar", T: 9, opt: !0 }
  ]);
  class t extends o.Message {
    constructor(x) {
      super(), this.fileToGenerate = [], this.protoFile = [], this.sourceFileDescriptors = [], g.proto2.util.initPartial(x, this);
    }
    static fromBinary(x, v) {
      return new t().fromBinary(x, v);
    }
    static fromJson(x, v) {
      return new t().fromJson(x, v);
    }
    static fromJsonString(x, v) {
      return new t().fromJsonString(x, v);
    }
    static equals(x, v) {
      return g.proto2.util.equals(t, x, v);
    }
  }
  plugin_pb.CodeGeneratorRequest = t, t.runtime = g.proto2, t.typeName = "google.protobuf.compiler.CodeGeneratorRequest", t.fields = g.proto2.util.newFieldList(() => [
    { no: 1, name: "file_to_generate", kind: "scalar", T: 9, repeated: !0 },
    { no: 2, name: "parameter", kind: "scalar", T: 9, opt: !0 },
    { no: 15, name: "proto_file", kind: "message", T: c.FileDescriptorProto, repeated: !0 },
    { no: 17, name: "source_file_descriptors", kind: "message", T: c.FileDescriptorProto, repeated: !0 },
    { no: 3, name: "compiler_version", kind: "message", T: y, opt: !0 }
  ]);
  class d extends o.Message {
    constructor(x) {
      super(), this.file = [], g.proto2.util.initPartial(x, this);
    }
    static fromBinary(x, v) {
      return new d().fromBinary(x, v);
    }
    static fromJson(x, v) {
      return new d().fromJson(x, v);
    }
    static fromJsonString(x, v) {
      return new d().fromJsonString(x, v);
    }
    static equals(x, v) {
      return g.proto2.util.equals(d, x, v);
    }
  }
  plugin_pb.CodeGeneratorResponse = d, d.runtime = g.proto2, d.typeName = "google.protobuf.compiler.CodeGeneratorResponse", d.fields = g.proto2.util.newFieldList(() => [
    { no: 1, name: "error", kind: "scalar", T: 9, opt: !0 },
    { no: 2, name: "supported_features", kind: "scalar", T: 4, opt: !0 },
    { no: 3, name: "minimum_edition", kind: "scalar", T: 5, opt: !0 },
    { no: 4, name: "maximum_edition", kind: "scalar", T: 5, opt: !0 },
    { no: 15, name: "file", kind: "message", T: B, repeated: !0 }
  ]);
  var E;
  (function(D) {
    D[D.NONE = 0] = "NONE", D[D.PROTO3_OPTIONAL = 1] = "PROTO3_OPTIONAL", D[D.SUPPORTS_EDITIONS = 2] = "SUPPORTS_EDITIONS";
  })(E || (plugin_pb.CodeGeneratorResponse_Feature = E = {})), g.proto2.util.setEnumType(E, "google.protobuf.compiler.CodeGeneratorResponse.Feature", [
    { no: 0, name: "FEATURE_NONE" },
    { no: 1, name: "FEATURE_PROTO3_OPTIONAL" },
    { no: 2, name: "FEATURE_SUPPORTS_EDITIONS" }
  ]);
  class B extends o.Message {
    constructor(x) {
      super(), g.proto2.util.initPartial(x, this);
    }
    static fromBinary(x, v) {
      return new B().fromBinary(x, v);
    }
    static fromJson(x, v) {
      return new B().fromJson(x, v);
    }
    static fromJsonString(x, v) {
      return new B().fromJsonString(x, v);
    }
    static equals(x, v) {
      return g.proto2.util.equals(B, x, v);
    }
  }
  return plugin_pb.CodeGeneratorResponse_File = B, B.runtime = g.proto2, B.typeName = "google.protobuf.compiler.CodeGeneratorResponse.File", B.fields = g.proto2.util.newFieldList(() => [
    { no: 1, name: "name", kind: "scalar", T: 9, opt: !0 },
    { no: 2, name: "insertion_point", kind: "scalar", T: 9, opt: !0 },
    { no: 15, name: "content", kind: "scalar", T: 9, opt: !0 },
    { no: 16, name: "generated_code_info", kind: "message", T: c.GeneratedCodeInfo, opt: !0 }
  ]), plugin_pb;
}
var api_pb = {}, type_pb = {}, source_context_pb = {}, hasRequiredSource_context_pb;
function requireSource_context_pb() {
  if (hasRequiredSource_context_pb) return source_context_pb;
  hasRequiredSource_context_pb = 1, Object.defineProperty(source_context_pb, "__esModule", { value: !0 }), source_context_pb.SourceContext = void 0;
  const o = requireMessage(), g = requireProto3();
  class c extends o.Message {
    constructor(t) {
      super(), this.fileName = "", g.proto3.util.initPartial(t, this);
    }
    static fromBinary(t, d) {
      return new c().fromBinary(t, d);
    }
    static fromJson(t, d) {
      return new c().fromJson(t, d);
    }
    static fromJsonString(t, d) {
      return new c().fromJsonString(t, d);
    }
    static equals(t, d) {
      return g.proto3.util.equals(c, t, d);
    }
  }
  return source_context_pb.SourceContext = c, c.runtime = g.proto3, c.typeName = "google.protobuf.SourceContext", c.fields = g.proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "file_name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]), source_context_pb;
}
var hasRequiredType_pb;
function requireType_pb() {
  if (hasRequiredType_pb) return type_pb;
  hasRequiredType_pb = 1, Object.defineProperty(type_pb, "__esModule", { value: !0 }), type_pb.Option = type_pb.EnumValue = type_pb.Enum = type_pb.Field_Cardinality = type_pb.Field_Kind = type_pb.Field = type_pb.Type = type_pb.Syntax = void 0;
  const o = requireProto3(), g = requireMessage(), c = requireSource_context_pb(), y = requireAny_pb();
  var t;
  (function(M) {
    M[M.PROTO2 = 0] = "PROTO2", M[M.PROTO3 = 1] = "PROTO3", M[M.EDITIONS = 2] = "EDITIONS";
  })(t || (type_pb.Syntax = t = {})), o.proto3.util.setEnumType(t, "google.protobuf.Syntax", [
    { no: 0, name: "SYNTAX_PROTO2" },
    { no: 1, name: "SYNTAX_PROTO3" },
    { no: 2, name: "SYNTAX_EDITIONS" }
  ]);
  class d extends g.Message {
    constructor(U) {
      super(), this.name = "", this.fields = [], this.oneofs = [], this.options = [], this.syntax = t.PROTO2, this.edition = "", o.proto3.util.initPartial(U, this);
    }
    static fromBinary(U, L) {
      return new d().fromBinary(U, L);
    }
    static fromJson(U, L) {
      return new d().fromJson(U, L);
    }
    static fromJsonString(U, L) {
      return new d().fromJsonString(U, L);
    }
    static equals(U, L) {
      return o.proto3.util.equals(d, U, L);
    }
  }
  type_pb.Type = d, d.runtime = o.proto3, d.typeName = "google.protobuf.Type", d.fields = o.proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 2, name: "fields", kind: "message", T: E, repeated: !0 },
    { no: 3, name: "oneofs", kind: "scalar", T: 9, repeated: !0 },
    { no: 4, name: "options", kind: "message", T: F, repeated: !0 },
    { no: 5, name: "source_context", kind: "message", T: c.SourceContext },
    { no: 6, name: "syntax", kind: "enum", T: o.proto3.getEnumType(t) },
    {
      no: 7,
      name: "edition",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]);
  class E extends g.Message {
    constructor(U) {
      super(), this.kind = B.TYPE_UNKNOWN, this.cardinality = D.UNKNOWN, this.number = 0, this.name = "", this.typeUrl = "", this.oneofIndex = 0, this.packed = !1, this.options = [], this.jsonName = "", this.defaultValue = "", o.proto3.util.initPartial(U, this);
    }
    static fromBinary(U, L) {
      return new E().fromBinary(U, L);
    }
    static fromJson(U, L) {
      return new E().fromJson(U, L);
    }
    static fromJsonString(U, L) {
      return new E().fromJsonString(U, L);
    }
    static equals(U, L) {
      return o.proto3.util.equals(E, U, L);
    }
  }
  type_pb.Field = E, E.runtime = o.proto3, E.typeName = "google.protobuf.Field", E.fields = o.proto3.util.newFieldList(() => [
    { no: 1, name: "kind", kind: "enum", T: o.proto3.getEnumType(B) },
    { no: 2, name: "cardinality", kind: "enum", T: o.proto3.getEnumType(D) },
    {
      no: 3,
      name: "number",
      kind: "scalar",
      T: 5
      /* ScalarType.INT32 */
    },
    {
      no: 4,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 6,
      name: "type_url",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 7,
      name: "oneof_index",
      kind: "scalar",
      T: 5
      /* ScalarType.INT32 */
    },
    {
      no: 8,
      name: "packed",
      kind: "scalar",
      T: 8
      /* ScalarType.BOOL */
    },
    { no: 9, name: "options", kind: "message", T: F, repeated: !0 },
    {
      no: 10,
      name: "json_name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 11,
      name: "default_value",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]);
  var B;
  (function(M) {
    M[M.TYPE_UNKNOWN = 0] = "TYPE_UNKNOWN", M[M.TYPE_DOUBLE = 1] = "TYPE_DOUBLE", M[M.TYPE_FLOAT = 2] = "TYPE_FLOAT", M[M.TYPE_INT64 = 3] = "TYPE_INT64", M[M.TYPE_UINT64 = 4] = "TYPE_UINT64", M[M.TYPE_INT32 = 5] = "TYPE_INT32", M[M.TYPE_FIXED64 = 6] = "TYPE_FIXED64", M[M.TYPE_FIXED32 = 7] = "TYPE_FIXED32", M[M.TYPE_BOOL = 8] = "TYPE_BOOL", M[M.TYPE_STRING = 9] = "TYPE_STRING", M[M.TYPE_GROUP = 10] = "TYPE_GROUP", M[M.TYPE_MESSAGE = 11] = "TYPE_MESSAGE", M[M.TYPE_BYTES = 12] = "TYPE_BYTES", M[M.TYPE_UINT32 = 13] = "TYPE_UINT32", M[M.TYPE_ENUM = 14] = "TYPE_ENUM", M[M.TYPE_SFIXED32 = 15] = "TYPE_SFIXED32", M[M.TYPE_SFIXED64 = 16] = "TYPE_SFIXED64", M[M.TYPE_SINT32 = 17] = "TYPE_SINT32", M[M.TYPE_SINT64 = 18] = "TYPE_SINT64";
  })(B || (type_pb.Field_Kind = B = {})), o.proto3.util.setEnumType(B, "google.protobuf.Field.Kind", [
    { no: 0, name: "TYPE_UNKNOWN" },
    { no: 1, name: "TYPE_DOUBLE" },
    { no: 2, name: "TYPE_FLOAT" },
    { no: 3, name: "TYPE_INT64" },
    { no: 4, name: "TYPE_UINT64" },
    { no: 5, name: "TYPE_INT32" },
    { no: 6, name: "TYPE_FIXED64" },
    { no: 7, name: "TYPE_FIXED32" },
    { no: 8, name: "TYPE_BOOL" },
    { no: 9, name: "TYPE_STRING" },
    { no: 10, name: "TYPE_GROUP" },
    { no: 11, name: "TYPE_MESSAGE" },
    { no: 12, name: "TYPE_BYTES" },
    { no: 13, name: "TYPE_UINT32" },
    { no: 14, name: "TYPE_ENUM" },
    { no: 15, name: "TYPE_SFIXED32" },
    { no: 16, name: "TYPE_SFIXED64" },
    { no: 17, name: "TYPE_SINT32" },
    { no: 18, name: "TYPE_SINT64" }
  ]);
  var D;
  (function(M) {
    M[M.UNKNOWN = 0] = "UNKNOWN", M[M.OPTIONAL = 1] = "OPTIONAL", M[M.REQUIRED = 2] = "REQUIRED", M[M.REPEATED = 3] = "REPEATED";
  })(D || (type_pb.Field_Cardinality = D = {})), o.proto3.util.setEnumType(D, "google.protobuf.Field.Cardinality", [
    { no: 0, name: "CARDINALITY_UNKNOWN" },
    { no: 1, name: "CARDINALITY_OPTIONAL" },
    { no: 2, name: "CARDINALITY_REQUIRED" },
    { no: 3, name: "CARDINALITY_REPEATED" }
  ]);
  class x extends g.Message {
    constructor(U) {
      super(), this.name = "", this.enumvalue = [], this.options = [], this.syntax = t.PROTO2, this.edition = "", o.proto3.util.initPartial(U, this);
    }
    static fromBinary(U, L) {
      return new x().fromBinary(U, L);
    }
    static fromJson(U, L) {
      return new x().fromJson(U, L);
    }
    static fromJsonString(U, L) {
      return new x().fromJsonString(U, L);
    }
    static equals(U, L) {
      return o.proto3.util.equals(x, U, L);
    }
  }
  type_pb.Enum = x, x.runtime = o.proto3, x.typeName = "google.protobuf.Enum", x.fields = o.proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 2, name: "enumvalue", kind: "message", T: v, repeated: !0 },
    { no: 3, name: "options", kind: "message", T: F, repeated: !0 },
    { no: 4, name: "source_context", kind: "message", T: c.SourceContext },
    { no: 5, name: "syntax", kind: "enum", T: o.proto3.getEnumType(t) },
    {
      no: 6,
      name: "edition",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]);
  class v extends g.Message {
    constructor(U) {
      super(), this.name = "", this.number = 0, this.options = [], o.proto3.util.initPartial(U, this);
    }
    static fromBinary(U, L) {
      return new v().fromBinary(U, L);
    }
    static fromJson(U, L) {
      return new v().fromJson(U, L);
    }
    static fromJsonString(U, L) {
      return new v().fromJsonString(U, L);
    }
    static equals(U, L) {
      return o.proto3.util.equals(v, U, L);
    }
  }
  type_pb.EnumValue = v, v.runtime = o.proto3, v.typeName = "google.protobuf.EnumValue", v.fields = o.proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "number",
      kind: "scalar",
      T: 5
      /* ScalarType.INT32 */
    },
    { no: 3, name: "options", kind: "message", T: F, repeated: !0 }
  ]);
  class F extends g.Message {
    constructor(U) {
      super(), this.name = "", o.proto3.util.initPartial(U, this);
    }
    static fromBinary(U, L) {
      return new F().fromBinary(U, L);
    }
    static fromJson(U, L) {
      return new F().fromJson(U, L);
    }
    static fromJsonString(U, L) {
      return new F().fromJsonString(U, L);
    }
    static equals(U, L) {
      return o.proto3.util.equals(F, U, L);
    }
  }
  return type_pb.Option = F, F.runtime = o.proto3, F.typeName = "google.protobuf.Option", F.fields = o.proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 2, name: "value", kind: "message", T: y.Any }
  ]), type_pb;
}
var hasRequiredApi_pb;
function requireApi_pb() {
  if (hasRequiredApi_pb) return api_pb;
  hasRequiredApi_pb = 1, Object.defineProperty(api_pb, "__esModule", { value: !0 }), api_pb.Mixin = api_pb.Method = api_pb.Api = void 0;
  const o = requireMessage(), g = requireType_pb(), c = requireSource_context_pb(), y = requireProto3();
  class t extends o.Message {
    constructor(D) {
      super(), this.name = "", this.methods = [], this.options = [], this.version = "", this.mixins = [], this.syntax = g.Syntax.PROTO2, y.proto3.util.initPartial(D, this);
    }
    static fromBinary(D, x) {
      return new t().fromBinary(D, x);
    }
    static fromJson(D, x) {
      return new t().fromJson(D, x);
    }
    static fromJsonString(D, x) {
      return new t().fromJsonString(D, x);
    }
    static equals(D, x) {
      return y.proto3.util.equals(t, D, x);
    }
  }
  api_pb.Api = t, t.runtime = y.proto3, t.typeName = "google.protobuf.Api", t.fields = y.proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 2, name: "methods", kind: "message", T: d, repeated: !0 },
    { no: 3, name: "options", kind: "message", T: g.Option, repeated: !0 },
    {
      no: 4,
      name: "version",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 5, name: "source_context", kind: "message", T: c.SourceContext },
    { no: 6, name: "mixins", kind: "message", T: E, repeated: !0 },
    { no: 7, name: "syntax", kind: "enum", T: y.proto3.getEnumType(g.Syntax) }
  ]);
  class d extends o.Message {
    constructor(D) {
      super(), this.name = "", this.requestTypeUrl = "", this.requestStreaming = !1, this.responseTypeUrl = "", this.responseStreaming = !1, this.options = [], this.syntax = g.Syntax.PROTO2, y.proto3.util.initPartial(D, this);
    }
    static fromBinary(D, x) {
      return new d().fromBinary(D, x);
    }
    static fromJson(D, x) {
      return new d().fromJson(D, x);
    }
    static fromJsonString(D, x) {
      return new d().fromJsonString(D, x);
    }
    static equals(D, x) {
      return y.proto3.util.equals(d, D, x);
    }
  }
  api_pb.Method = d, d.runtime = y.proto3, d.typeName = "google.protobuf.Method", d.fields = y.proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "request_type_url",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 3,
      name: "request_streaming",
      kind: "scalar",
      T: 8
      /* ScalarType.BOOL */
    },
    {
      no: 4,
      name: "response_type_url",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 5,
      name: "response_streaming",
      kind: "scalar",
      T: 8
      /* ScalarType.BOOL */
    },
    { no: 6, name: "options", kind: "message", T: g.Option, repeated: !0 },
    { no: 7, name: "syntax", kind: "enum", T: y.proto3.getEnumType(g.Syntax) }
  ]);
  class E extends o.Message {
    constructor(D) {
      super(), this.name = "", this.root = "", y.proto3.util.initPartial(D, this);
    }
    static fromBinary(D, x) {
      return new E().fromBinary(D, x);
    }
    static fromJson(D, x) {
      return new E().fromJson(D, x);
    }
    static fromJsonString(D, x) {
      return new E().fromJsonString(D, x);
    }
    static equals(D, x) {
      return y.proto3.util.equals(E, D, x);
    }
  }
  return api_pb.Mixin = E, E.runtime = y.proto3, E.typeName = "google.protobuf.Mixin", E.fields = y.proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "root",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]), api_pb;
}
var hasRequiredCjs$3;
function requireCjs$3() {
  return hasRequiredCjs$3 || (hasRequiredCjs$3 = 1, function(o) {
    var g = cjs$3 && cjs$3.__createBinding || (Object.create ? function(Se, ze, He, Pe) {
      Pe === void 0 && (Pe = He);
      var De = Object.getOwnPropertyDescriptor(ze, He);
      (!De || ("get" in De ? !ze.__esModule : De.writable || De.configurable)) && (De = { enumerable: !0, get: function() {
        return ze[He];
      } }), Object.defineProperty(Se, Pe, De);
    } : function(Se, ze, He, Pe) {
      Pe === void 0 && (Pe = He), Se[Pe] = ze[He];
    }), c = cjs$3 && cjs$3.__exportStar || function(Se, ze) {
      for (var He in Se) He !== "default" && !Object.prototype.hasOwnProperty.call(ze, He) && g(ze, Se, He);
    };
    Object.defineProperty(o, "__esModule", { value: !0 }), o.toPlainMessage = o.createRegistryFromDescriptors = o.createMutableRegistry = o.createRegistry = o.createDescriptorSet = o.BinaryReader = o.BinaryWriter = o.WireType = o.MethodIdempotency = o.MethodKind = o.clearExtension = o.hasExtension = o.setExtension = o.getExtension = o.ScalarType = o.LongType = o.isMessage = o.Message = o.codegenInfo = o.protoDelimited = o.protoBase64 = o.protoInt64 = o.protoDouble = o.proto2 = o.proto3 = void 0;
    var y = requireProto3();
    Object.defineProperty(o, "proto3", { enumerable: !0, get: function() {
      return y.proto3;
    } });
    var t = requireProto2();
    Object.defineProperty(o, "proto2", { enumerable: !0, get: function() {
      return t.proto2;
    } });
    var d = requireProtoDouble();
    Object.defineProperty(o, "protoDouble", { enumerable: !0, get: function() {
      return d.protoDouble;
    } });
    var E = requireProtoInt64();
    Object.defineProperty(o, "protoInt64", { enumerable: !0, get: function() {
      return E.protoInt64;
    } });
    var B = requireProtoBase64();
    Object.defineProperty(o, "protoBase64", { enumerable: !0, get: function() {
      return B.protoBase64;
    } });
    var D = requireProtoDelimited();
    Object.defineProperty(o, "protoDelimited", { enumerable: !0, get: function() {
      return D.protoDelimited;
    } });
    var x = requireCodegenInfo();
    Object.defineProperty(o, "codegenInfo", { enumerable: !0, get: function() {
      return x.codegenInfo;
    } });
    var v = requireMessage();
    Object.defineProperty(o, "Message", { enumerable: !0, get: function() {
      return v.Message;
    } });
    var F = requireIsMessage();
    Object.defineProperty(o, "isMessage", { enumerable: !0, get: function() {
      return F.isMessage;
    } });
    var M = requireScalar();
    Object.defineProperty(o, "LongType", { enumerable: !0, get: function() {
      return M.LongType;
    } }), Object.defineProperty(o, "ScalarType", { enumerable: !0, get: function() {
      return M.ScalarType;
    } });
    var U = requireExtensionAccessor();
    Object.defineProperty(o, "getExtension", { enumerable: !0, get: function() {
      return U.getExtension;
    } }), Object.defineProperty(o, "setExtension", { enumerable: !0, get: function() {
      return U.setExtension;
    } }), Object.defineProperty(o, "hasExtension", { enumerable: !0, get: function() {
      return U.hasExtension;
    } }), Object.defineProperty(o, "clearExtension", { enumerable: !0, get: function() {
      return U.clearExtension;
    } });
    var L = requireServiceType();
    Object.defineProperty(o, "MethodKind", { enumerable: !0, get: function() {
      return L.MethodKind;
    } }), Object.defineProperty(o, "MethodIdempotency", { enumerable: !0, get: function() {
      return L.MethodIdempotency;
    } });
    var H = requireBinaryEncoding();
    Object.defineProperty(o, "WireType", { enumerable: !0, get: function() {
      return H.WireType;
    } }), Object.defineProperty(o, "BinaryWriter", { enumerable: !0, get: function() {
      return H.BinaryWriter;
    } }), Object.defineProperty(o, "BinaryReader", { enumerable: !0, get: function() {
      return H.BinaryReader;
    } });
    var fe = requireCreateDescriptorSet();
    Object.defineProperty(o, "createDescriptorSet", { enumerable: !0, get: function() {
      return fe.createDescriptorSet;
    } });
    var ge = requireCreateRegistry();
    Object.defineProperty(o, "createRegistry", { enumerable: !0, get: function() {
      return ge.createRegistry;
    } }), Object.defineProperty(o, "createMutableRegistry", { enumerable: !0, get: function() {
      return ge.createMutableRegistry;
    } });
    var Ie = requireCreateRegistryFromDesc();
    Object.defineProperty(o, "createRegistryFromDescriptors", { enumerable: !0, get: function() {
      return Ie.createRegistryFromDescriptors;
    } });
    var Ee = requireToPlainMessage();
    Object.defineProperty(o, "toPlainMessage", { enumerable: !0, get: function() {
      return Ee.toPlainMessage;
    } }), c(requirePlugin_pb(), o), c(requireApi_pb(), o), c(requireAny_pb(), o), c(requireDescriptor_pb(), o), c(requireDuration_pb(), o), c(requireEmpty_pb(), o), c(requireField_mask_pb(), o), c(requireSource_context_pb(), o), c(requireStruct_pb(), o), c(requireTimestamp_pb(), o), c(requireType_pb(), o), c(requireWrappers_pb(), o);
  }(cjs$3)), cjs$3;
}
var hasRequiredContract_pb;
function requireContract_pb() {
  if (hasRequiredContract_pb) return contract_pb;
  hasRequiredContract_pb = 1, Object.defineProperty(contract_pb, "__esModule", { value: !0 }), contract_pb.TriggerSmartContract = contract_pb.TransferAssetContract = contract_pb.TransferContract = void 0;
  const o = /* @__PURE__ */ requireCjs$3();
  class g extends o.Message {
    constructor(d) {
      super(), this.ownerAddress = new Uint8Array(0), this.toAddress = new Uint8Array(0), this.amount = o.protoInt64.zero, o.proto3.util.initPartial(d, this);
    }
    static fromBinary(d, E) {
      return new g().fromBinary(d, E);
    }
    static fromJson(d, E) {
      return new g().fromJson(d, E);
    }
    static fromJsonString(d, E) {
      return new g().fromJsonString(d, E);
    }
    static equals(d, E) {
      return o.proto3.util.equals(g, d, E);
    }
  }
  contract_pb.TransferContract = g, g.runtime = o.proto3, g.typeName = "protocol.TransferContract", g.fields = o.proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "owner_address",
      kind: "scalar",
      T: 12
      /* ScalarType.BYTES */
    },
    {
      no: 2,
      name: "to_address",
      kind: "scalar",
      T: 12
      /* ScalarType.BYTES */
    },
    {
      no: 3,
      name: "amount",
      kind: "scalar",
      T: 3
      /* ScalarType.INT64 */
    }
  ]);
  class c extends o.Message {
    constructor(d) {
      super(), this.assetName = new Uint8Array(0), this.ownerAddress = new Uint8Array(0), this.toAddress = new Uint8Array(0), this.amount = o.protoInt64.zero, o.proto3.util.initPartial(d, this);
    }
    static fromBinary(d, E) {
      return new c().fromBinary(d, E);
    }
    static fromJson(d, E) {
      return new c().fromJson(d, E);
    }
    static fromJsonString(d, E) {
      return new c().fromJsonString(d, E);
    }
    static equals(d, E) {
      return o.proto3.util.equals(c, d, E);
    }
  }
  contract_pb.TransferAssetContract = c, c.runtime = o.proto3, c.typeName = "protocol.TransferAssetContract", c.fields = o.proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "asset_name",
      kind: "scalar",
      T: 12
      /* ScalarType.BYTES */
    },
    {
      no: 2,
      name: "owner_address",
      kind: "scalar",
      T: 12
      /* ScalarType.BYTES */
    },
    {
      no: 3,
      name: "to_address",
      kind: "scalar",
      T: 12
      /* ScalarType.BYTES */
    },
    {
      no: 4,
      name: "amount",
      kind: "scalar",
      T: 3
      /* ScalarType.INT64 */
    }
  ]);
  class y extends o.Message {
    constructor(d) {
      super(), this.ownerAddress = new Uint8Array(0), this.contractAddress = new Uint8Array(0), this.callValue = o.protoInt64.zero, this.data = new Uint8Array(0), this.callTokenValue = o.protoInt64.zero, this.tokenId = o.protoInt64.zero, o.proto3.util.initPartial(d, this);
    }
    static fromBinary(d, E) {
      return new y().fromBinary(d, E);
    }
    static fromJson(d, E) {
      return new y().fromJson(d, E);
    }
    static fromJsonString(d, E) {
      return new y().fromJsonString(d, E);
    }
    static equals(d, E) {
      return o.proto3.util.equals(y, d, E);
    }
  }
  return contract_pb.TriggerSmartContract = y, y.runtime = o.proto3, y.typeName = "protocol.TriggerSmartContract", y.fields = o.proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "owner_address",
      kind: "scalar",
      T: 12
      /* ScalarType.BYTES */
    },
    {
      no: 2,
      name: "contract_address",
      kind: "scalar",
      T: 12
      /* ScalarType.BYTES */
    },
    {
      no: 3,
      name: "call_value",
      kind: "scalar",
      T: 3
      /* ScalarType.INT64 */
    },
    {
      no: 4,
      name: "data",
      kind: "scalar",
      T: 12
      /* ScalarType.BYTES */
    },
    {
      no: 5,
      name: "call_token_value",
      kind: "scalar",
      T: 3
      /* ScalarType.INT64 */
    },
    {
      no: 6,
      name: "token_id",
      kind: "scalar",
      T: 3
      /* ScalarType.INT64 */
    }
  ]), contract_pb;
}
var tron_pb = {}, hasRequiredTron_pb;
function requireTron_pb() {
  if (hasRequiredTron_pb) return tron_pb;
  hasRequiredTron_pb = 1, Object.defineProperty(tron_pb, "__esModule", { value: !0 }), tron_pb.Transaction_raw = tron_pb.Transaction_Contract_ContractType = tron_pb.Transaction_Contract = tron_pb.Transaction = tron_pb.authority = tron_pb.AccountId = void 0;
  const o = /* @__PURE__ */ requireCjs$3();
  class g extends o.Message {
    constructor(D) {
      super(), this.name = new Uint8Array(0), this.address = new Uint8Array(0), o.proto3.util.initPartial(D, this);
    }
    static fromBinary(D, x) {
      return new g().fromBinary(D, x);
    }
    static fromJson(D, x) {
      return new g().fromJson(D, x);
    }
    static fromJsonString(D, x) {
      return new g().fromJsonString(D, x);
    }
    static equals(D, x) {
      return o.proto3.util.equals(g, D, x);
    }
  }
  tron_pb.AccountId = g, g.runtime = o.proto3, g.typeName = "protocol.AccountId", g.fields = o.proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "name",
      kind: "scalar",
      T: 12
      /* ScalarType.BYTES */
    },
    {
      no: 2,
      name: "address",
      kind: "scalar",
      T: 12
      /* ScalarType.BYTES */
    }
  ]);
  class c extends o.Message {
    constructor(D) {
      super(), this.permissionName = new Uint8Array(0), o.proto3.util.initPartial(D, this);
    }
    static fromBinary(D, x) {
      return new c().fromBinary(D, x);
    }
    static fromJson(D, x) {
      return new c().fromJson(D, x);
    }
    static fromJsonString(D, x) {
      return new c().fromJsonString(D, x);
    }
    static equals(D, x) {
      return o.proto3.util.equals(c, D, x);
    }
  }
  tron_pb.authority = c, c.runtime = o.proto3, c.typeName = "protocol.authority", c.fields = o.proto3.util.newFieldList(() => [
    { no: 1, name: "account", kind: "message", T: g },
    {
      no: 2,
      name: "permission_name",
      kind: "scalar",
      T: 12
      /* ScalarType.BYTES */
    }
  ]);
  class y extends o.Message {
    constructor(D) {
      super(), this.signature = [], o.proto3.util.initPartial(D, this);
    }
    static fromBinary(D, x) {
      return new y().fromBinary(D, x);
    }
    static fromJson(D, x) {
      return new y().fromJson(D, x);
    }
    static fromJsonString(D, x) {
      return new y().fromJsonString(D, x);
    }
    static equals(D, x) {
      return o.proto3.util.equals(y, D, x);
    }
  }
  tron_pb.Transaction = y, y.runtime = o.proto3, y.typeName = "protocol.Transaction", y.fields = o.proto3.util.newFieldList(() => [
    { no: 1, name: "raw_data", kind: "message", T: E },
    { no: 2, name: "signature", kind: "scalar", T: 12, repeated: !0 }
  ]);
  class t extends o.Message {
    constructor(D) {
      super(), this.type = d.AccountCreateContract, this.provider = new Uint8Array(0), this.ContractName = new Uint8Array(0), this.PermissionId = 0, o.proto3.util.initPartial(D, this);
    }
    static fromBinary(D, x) {
      return new t().fromBinary(D, x);
    }
    static fromJson(D, x) {
      return new t().fromJson(D, x);
    }
    static fromJsonString(D, x) {
      return new t().fromJsonString(D, x);
    }
    static equals(D, x) {
      return o.proto3.util.equals(t, D, x);
    }
  }
  tron_pb.Transaction_Contract = t, t.runtime = o.proto3, t.typeName = "protocol.Transaction.Contract", t.fields = o.proto3.util.newFieldList(() => [
    { no: 1, name: "type", kind: "enum", T: o.proto3.getEnumType(d) },
    { no: 2, name: "parameter", kind: "message", T: o.Any },
    {
      no: 3,
      name: "provider",
      kind: "scalar",
      T: 12
      /* ScalarType.BYTES */
    },
    {
      no: 4,
      name: "ContractName",
      kind: "scalar",
      T: 12
      /* ScalarType.BYTES */
    },
    {
      no: 5,
      name: "Permission_id",
      kind: "scalar",
      T: 5
      /* ScalarType.INT32 */
    }
  ]);
  var d;
  (function(B) {
    B[B.AccountCreateContract = 0] = "AccountCreateContract", B[B.TransferContract = 1] = "TransferContract", B[B.TransferAssetContract = 2] = "TransferAssetContract", B[B.TriggerSmartContract = 31] = "TriggerSmartContract";
  })(d || (tron_pb.Transaction_Contract_ContractType = d = {})), o.proto3.util.setEnumType(d, "protocol.Transaction.Contract.ContractType", [
    { no: 0, name: "AccountCreateContract" },
    { no: 1, name: "TransferContract" },
    { no: 2, name: "TransferAssetContract" },
    { no: 31, name: "TriggerSmartContract" }
  ]);
  class E extends o.Message {
    constructor(D) {
      super(), this.refBlockBytes = new Uint8Array(0), this.refBlockNum = o.protoInt64.zero, this.refBlockHash = new Uint8Array(0), this.expiration = o.protoInt64.zero, this.auths = [], this.data = new Uint8Array(0), this.contract = [], this.scripts = new Uint8Array(0), this.timestamp = o.protoInt64.zero, this.feeLimit = o.protoInt64.zero, o.proto3.util.initPartial(D, this);
    }
    static fromBinary(D, x) {
      return new E().fromBinary(D, x);
    }
    static fromJson(D, x) {
      return new E().fromJson(D, x);
    }
    static fromJsonString(D, x) {
      return new E().fromJsonString(D, x);
    }
    static equals(D, x) {
      return o.proto3.util.equals(E, D, x);
    }
  }
  return tron_pb.Transaction_raw = E, E.runtime = o.proto3, E.typeName = "protocol.Transaction.raw", E.fields = o.proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "ref_block_bytes",
      kind: "scalar",
      T: 12
      /* ScalarType.BYTES */
    },
    {
      no: 3,
      name: "ref_block_num",
      kind: "scalar",
      T: 3
      /* ScalarType.INT64 */
    },
    {
      no: 4,
      name: "ref_block_hash",
      kind: "scalar",
      T: 12
      /* ScalarType.BYTES */
    },
    {
      no: 8,
      name: "expiration",
      kind: "scalar",
      T: 3
      /* ScalarType.INT64 */
    },
    { no: 9, name: "auths", kind: "message", T: c, repeated: !0 },
    {
      no: 10,
      name: "data",
      kind: "scalar",
      T: 12
      /* ScalarType.BYTES */
    },
    { no: 11, name: "contract", kind: "message", T: t, repeated: !0 },
    {
      no: 12,
      name: "scripts",
      kind: "scalar",
      T: 12
      /* ScalarType.BYTES */
    },
    {
      no: 14,
      name: "timestamp",
      kind: "scalar",
      T: 3
      /* ScalarType.INT64 */
    },
    {
      no: 18,
      name: "fee_limit",
      kind: "scalar",
      T: 3
      /* ScalarType.INT64 */
    }
  ]), tron_pb;
}
var tron_transaction_pb = {}, hasRequiredTron_transaction_pb;
function requireTron_transaction_pb() {
  if (hasRequiredTron_transaction_pb) return tron_transaction_pb;
  hasRequiredTron_transaction_pb = 1, Object.defineProperty(tron_transaction_pb, "__esModule", { value: !0 }), tron_transaction_pb.TronTx = tron_transaction_pb.Override = tron_transaction_pb.LatestBlock = void 0;
  const o = /* @__PURE__ */ requireCjs$3();
  class g extends o.Message {
    constructor(d) {
      super(), this.hash = "", this.number = 0, this.timestamp = o.protoInt64.zero, o.proto3.util.initPartial(d, this);
    }
    static fromBinary(d, E) {
      return new g().fromBinary(d, E);
    }
    static fromJson(d, E) {
      return new g().fromJson(d, E);
    }
    static fromJsonString(d, E) {
      return new g().fromJsonString(d, E);
    }
    static equals(d, E) {
      return o.proto3.util.equals(g, d, E);
    }
  }
  tron_transaction_pb.LatestBlock = g, g.runtime = o.proto3, g.typeName = "protoc.LatestBlock", g.fields = o.proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "hash",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "number",
      kind: "scalar",
      T: 5
      /* ScalarType.INT32 */
    },
    {
      no: 3,
      name: "timestamp",
      kind: "scalar",
      T: 3
      /* ScalarType.INT64 */
    }
  ]);
  class c extends o.Message {
    constructor(d) {
      super(), this.tokenShortName = "", this.tokenFullName = "", this.decimals = 0, o.proto3.util.initPartial(d, this);
    }
    static fromBinary(d, E) {
      return new c().fromBinary(d, E);
    }
    static fromJson(d, E) {
      return new c().fromJson(d, E);
    }
    static fromJsonString(d, E) {
      return new c().fromJsonString(d, E);
    }
    static equals(d, E) {
      return o.proto3.util.equals(c, d, E);
    }
  }
  tron_transaction_pb.Override = c, c.runtime = o.proto3, c.typeName = "protoc.Override", c.fields = o.proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "tokenShortName",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "tokenFullName",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 3,
      name: "decimals",
      kind: "scalar",
      T: 5
      /* ScalarType.INT32 */
    }
  ]);
  class y extends o.Message {
    constructor(d) {
      super(), this.token = "", this.contractAddress = "", this.from = "", this.to = "", this.memo = "", this.value = "", this.fee = 0, o.proto3.util.initPartial(d, this);
    }
    static fromBinary(d, E) {
      return new y().fromBinary(d, E);
    }
    static fromJson(d, E) {
      return new y().fromJson(d, E);
    }
    static fromJsonString(d, E) {
      return new y().fromJsonString(d, E);
    }
    static equals(d, E) {
      return o.proto3.util.equals(y, d, E);
    }
  }
  return tron_transaction_pb.TronTx = y, y.runtime = o.proto3, y.typeName = "protoc.TronTx", y.fields = o.proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "token",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "contractAddress",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 3,
      name: "from",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 4,
      name: "to",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 5,
      name: "memo",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 6,
      name: "value",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 7, name: "latestBlock", kind: "message", T: g },
    { no: 8, name: "override", kind: "message", T: c },
    {
      no: 9,
      name: "fee",
      kind: "scalar",
      T: 5
      /* ScalarType.INT32 */
    }
  ]), tron_transaction_pb;
}
var hasRequiredTransfer;
function requireTransfer() {
  if (hasRequiredTransfer) return transfer;
  hasRequiredTransfer = 1;
  var o = transfer && transfer.__importDefault || function(D) {
    return D && D.__esModule ? D : { default: D };
  };
  Object.defineProperty(transfer, "__esModule", { value: !0 }), transfer.raw2tx = B;
  const g = o(requireBs58check()), c = requireContract_pb(), y = requireTron_pb(), t = requireUtils$e(), d = requireTron_transaction_pb();
  function E(D) {
    return g.default.encode(D);
  }
  function B(D, x) {
    let v;
    try {
      v = y.Transaction_raw.fromBinary(D);
    } catch {
      throw new Error("Sign data is invalid");
    }
    const F = x !== void 0 ? {
      decimals: x.decimals,
      tokenFullName: x.name,
      tokenShortName: x.symbol
    } : null, M = Buffer.from([...new Uint8Array(8).fill(0), ...v.refBlockHash, ...new Uint8Array(16).fill(0)]), U = new d.LatestBlock({
      hash: (0, t.toHex)(M),
      number: +`0x${(0, t.toHex)(v.refBlockBytes.slice(0, 2))}`,
      timestamp: BigInt(Number(v.expiration) - 600 * 5 * 1e3)
    }), L = v.data.length > 0 ? Buffer.from(v.data).toString("utf-8") : "", H = v.contract[0];
    if (H.parameter === void 0)
      throw new Error("contract is invalid");
    let fe;
    switch (H.type) {
      case y.Transaction_Contract_ContractType.TransferContract:
        try {
          fe = c.TransferContract.fromBinary(H.parameter.value);
        } catch {
          throw new Error("sign data is invalid");
        }
        return new d.TronTx({
          fee: Number(v.feeLimit),
          from: E(fe.ownerAddress),
          latestBlock: U,
          to: E(fe.toAddress),
          token: "TRX",
          value: fe.amount.toString(),
          memo: L
        });
      case y.Transaction_Contract_ContractType.TransferAssetContract:
        try {
          fe = c.TransferAssetContract.fromBinary(H.parameter.value);
        } catch {
          throw new Error("sign data is invalid");
        }
        if (F == null)
          throw new Error("token info is invalid");
        return new d.TronTx({
          fee: Number(v.feeLimit),
          from: E(fe.ownerAddress),
          latestBlock: U,
          override: F,
          to: E(fe.toAddress),
          token: Buffer.from(fe.assetName).toString(),
          value: fe.amount.toString(),
          memo: L
        });
      case y.Transaction_Contract_ContractType.TriggerSmartContract:
        try {
          fe = c.TriggerSmartContract.fromBinary(H.parameter.value);
        } catch {
          throw new Error("sign data is invalid");
        }
        if (F == null)
          throw new Error("token info is invalid");
        return new d.TronTx({
          contractAddress: E(fe.contractAddress),
          fee: Number(v.feeLimit),
          from: E(fe.ownerAddress),
          latestBlock: U,
          override: F,
          to: E(Buffer.from([65, ...fe.data.slice(16, 36)])),
          value: BigInt(`0x${Buffer.from(fe.data.slice(36, 68)).toString("hex")}`).toString(),
          memo: L
        });
      default:
        throw new Error("contract is not supported");
    }
  }
  return transfer;
}
var pako = {}, deflate$1 = {}, deflate = {}, trees = {}, hasRequiredTrees;
function requireTrees() {
  if (hasRequiredTrees) return trees;
  hasRequiredTrees = 1;
  const o = 4, g = 0, c = 1, y = 2;
  function t(pr) {
    let Cr = pr.length;
    for (; --Cr >= 0; )
      pr[Cr] = 0;
  }
  const d = 0, E = 1, B = 2, D = 3, x = 258, v = 29, F = 256, M = F + 1 + v, U = 30, L = 19, H = 2 * M + 1, fe = 15, ge = 16, Ie = 7, Ee = 256, Se = 16, ze = 17, He = 18, Pe = (
    /* extra bits for each length code */
    new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0])
  ), De = (
    /* extra bits for each distance code */
    new Uint8Array([0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13])
  ), ve = (
    /* extra bits for each bit length code */
    new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 3, 7])
  ), Fe = new Uint8Array([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]), be = 512, Be = new Array((M + 2) * 2);
  t(Be);
  const ke = new Array(U * 2);
  t(ke);
  const xe = new Array(be);
  t(xe);
  const Ne = new Array(x - D + 1);
  t(Ne);
  const Et = new Array(v);
  t(Et);
  const st = new Array(U);
  t(st);
  function Dt(pr, Cr, Er, xr, si) {
    this.static_tree = pr, this.extra_bits = Cr, this.extra_base = Er, this.elems = xr, this.max_length = si, this.has_stree = pr && pr.length;
  }
  let er, xt, ir;
  function sr(pr, Cr) {
    this.dyn_tree = pr, this.max_code = 0, this.stat_desc = Cr;
  }
  const yr = (pr) => pr < 256 ? xe[pr] : xe[256 + (pr >>> 7)], wr = (pr, Cr) => {
    pr.pending_buf[pr.pending++] = Cr & 255, pr.pending_buf[pr.pending++] = Cr >>> 8 & 255;
  }, qr = (pr, Cr, Er) => {
    pr.bi_valid > ge - Er ? (pr.bi_buf |= Cr << pr.bi_valid & 65535, wr(pr, pr.bi_buf), pr.bi_buf = Cr >> ge - pr.bi_valid, pr.bi_valid += Er - ge) : (pr.bi_buf |= Cr << pr.bi_valid & 65535, pr.bi_valid += Er);
  }, Mr = (pr, Cr, Er) => {
    qr(
      pr,
      Er[Cr * 2],
      Er[Cr * 2 + 1]
      /*.Len*/
    );
  }, Dr = (pr, Cr) => {
    let Er = 0;
    do
      Er |= pr & 1, pr >>>= 1, Er <<= 1;
    while (--Cr > 0);
    return Er >>> 1;
  }, Qr = (pr) => {
    pr.bi_valid === 16 ? (wr(pr, pr.bi_buf), pr.bi_buf = 0, pr.bi_valid = 0) : pr.bi_valid >= 8 && (pr.pending_buf[pr.pending++] = pr.bi_buf & 255, pr.bi_buf >>= 8, pr.bi_valid -= 8);
  }, Xr = (pr, Cr) => {
    const Er = Cr.dyn_tree, xr = Cr.max_code, si = Cr.stat_desc.static_tree, Ci = Cr.stat_desc.has_stree, bi = Cr.stat_desc.extra_bits, Ri = Cr.stat_desc.extra_base, li = Cr.stat_desc.max_length;
    let zi, Kn, Hn, os, ts, Gs, Wn = 0;
    for (os = 0; os <= fe; os++)
      pr.bl_count[os] = 0;
    for (Er[pr.heap[pr.heap_max] * 2 + 1] = 0, zi = pr.heap_max + 1; zi < H; zi++)
      Kn = pr.heap[zi], os = Er[Er[Kn * 2 + 1] * 2 + 1] + 1, os > li && (os = li, Wn++), Er[Kn * 2 + 1] = os, !(Kn > xr) && (pr.bl_count[os]++, ts = 0, Kn >= Ri && (ts = bi[Kn - Ri]), Gs = Er[Kn * 2], pr.opt_len += Gs * (os + ts), Ci && (pr.static_len += Gs * (si[Kn * 2 + 1] + ts)));
    if (Wn !== 0) {
      do {
        for (os = li - 1; pr.bl_count[os] === 0; )
          os--;
        pr.bl_count[os]--, pr.bl_count[os + 1] += 2, pr.bl_count[li]--, Wn -= 2;
      } while (Wn > 0);
      for (os = li; os !== 0; os--)
        for (Kn = pr.bl_count[os]; Kn !== 0; )
          Hn = pr.heap[--zi], !(Hn > xr) && (Er[Hn * 2 + 1] !== os && (pr.opt_len += (os - Er[Hn * 2 + 1]) * Er[Hn * 2], Er[Hn * 2 + 1] = os), Kn--);
    }
  }, Vr = (pr, Cr, Er) => {
    const xr = new Array(fe + 1);
    let si = 0, Ci, bi;
    for (Ci = 1; Ci <= fe; Ci++)
      si = si + Er[Ci - 1] << 1, xr[Ci] = si;
    for (bi = 0; bi <= Cr; bi++) {
      let Ri = pr[bi * 2 + 1];
      Ri !== 0 && (pr[bi * 2] = Dr(xr[Ri]++, Ri));
    }
  }, Ur = () => {
    let pr, Cr, Er, xr, si;
    const Ci = new Array(fe + 1);
    for (Er = 0, xr = 0; xr < v - 1; xr++)
      for (Et[xr] = Er, pr = 0; pr < 1 << Pe[xr]; pr++)
        Ne[Er++] = xr;
    for (Ne[Er - 1] = xr, si = 0, xr = 0; xr < 16; xr++)
      for (st[xr] = si, pr = 0; pr < 1 << De[xr]; pr++)
        xe[si++] = xr;
    for (si >>= 7; xr < U; xr++)
      for (st[xr] = si << 7, pr = 0; pr < 1 << De[xr] - 7; pr++)
        xe[256 + si++] = xr;
    for (Cr = 0; Cr <= fe; Cr++)
      Ci[Cr] = 0;
    for (pr = 0; pr <= 143; )
      Be[pr * 2 + 1] = 8, pr++, Ci[8]++;
    for (; pr <= 255; )
      Be[pr * 2 + 1] = 9, pr++, Ci[9]++;
    for (; pr <= 279; )
      Be[pr * 2 + 1] = 7, pr++, Ci[7]++;
    for (; pr <= 287; )
      Be[pr * 2 + 1] = 8, pr++, Ci[8]++;
    for (Vr(Be, M + 1, Ci), pr = 0; pr < U; pr++)
      ke[pr * 2 + 1] = 5, ke[pr * 2] = Dr(pr, 5);
    er = new Dt(Be, Pe, F + 1, M, fe), xt = new Dt(ke, De, 0, U, fe), ir = new Dt(new Array(0), ve, 0, L, Ie);
  }, Sr = (pr) => {
    let Cr;
    for (Cr = 0; Cr < M; Cr++)
      pr.dyn_ltree[Cr * 2] = 0;
    for (Cr = 0; Cr < U; Cr++)
      pr.dyn_dtree[Cr * 2] = 0;
    for (Cr = 0; Cr < L; Cr++)
      pr.bl_tree[Cr * 2] = 0;
    pr.dyn_ltree[Ee * 2] = 1, pr.opt_len = pr.static_len = 0, pr.sym_next = pr.matches = 0;
  }, Gr = (pr) => {
    pr.bi_valid > 8 ? wr(pr, pr.bi_buf) : pr.bi_valid > 0 && (pr.pending_buf[pr.pending++] = pr.bi_buf), pr.bi_buf = 0, pr.bi_valid = 0;
  }, Fr = (pr, Cr, Er, xr) => {
    const si = Cr * 2, Ci = Er * 2;
    return pr[si] < pr[Ci] || pr[si] === pr[Ci] && xr[Cr] <= xr[Er];
  }, br = (pr, Cr, Er) => {
    const xr = pr.heap[Er];
    let si = Er << 1;
    for (; si <= pr.heap_len && (si < pr.heap_len && Fr(Cr, pr.heap[si + 1], pr.heap[si], pr.depth) && si++, !Fr(Cr, xr, pr.heap[si], pr.depth)); )
      pr.heap[Er] = pr.heap[si], Er = si, si <<= 1;
    pr.heap[Er] = xr;
  }, Ar = (pr, Cr, Er) => {
    let xr, si, Ci = 0, bi, Ri;
    if (pr.sym_next !== 0)
      do
        xr = pr.pending_buf[pr.sym_buf + Ci++] & 255, xr += (pr.pending_buf[pr.sym_buf + Ci++] & 255) << 8, si = pr.pending_buf[pr.sym_buf + Ci++], xr === 0 ? Mr(pr, si, Cr) : (bi = Ne[si], Mr(pr, bi + F + 1, Cr), Ri = Pe[bi], Ri !== 0 && (si -= Et[bi], qr(pr, si, Ri)), xr--, bi = yr(xr), Mr(pr, bi, Er), Ri = De[bi], Ri !== 0 && (xr -= st[bi], qr(pr, xr, Ri)));
      while (Ci < pr.sym_next);
    Mr(pr, Ee, Cr);
  }, cr = (pr, Cr) => {
    const Er = Cr.dyn_tree, xr = Cr.stat_desc.static_tree, si = Cr.stat_desc.has_stree, Ci = Cr.stat_desc.elems;
    let bi, Ri, li = -1, zi;
    for (pr.heap_len = 0, pr.heap_max = H, bi = 0; bi < Ci; bi++)
      Er[bi * 2] !== 0 ? (pr.heap[++pr.heap_len] = li = bi, pr.depth[bi] = 0) : Er[bi * 2 + 1] = 0;
    for (; pr.heap_len < 2; )
      zi = pr.heap[++pr.heap_len] = li < 2 ? ++li : 0, Er[zi * 2] = 1, pr.depth[zi] = 0, pr.opt_len--, si && (pr.static_len -= xr[zi * 2 + 1]);
    for (Cr.max_code = li, bi = pr.heap_len >> 1; bi >= 1; bi--)
      br(pr, Er, bi);
    zi = Ci;
    do
      bi = pr.heap[
        1
        /*SMALLEST*/
      ], pr.heap[
        1
        /*SMALLEST*/
      ] = pr.heap[pr.heap_len--], br(
        pr,
        Er,
        1
        /*SMALLEST*/
      ), Ri = pr.heap[
        1
        /*SMALLEST*/
      ], pr.heap[--pr.heap_max] = bi, pr.heap[--pr.heap_max] = Ri, Er[zi * 2] = Er[bi * 2] + Er[Ri * 2], pr.depth[zi] = (pr.depth[bi] >= pr.depth[Ri] ? pr.depth[bi] : pr.depth[Ri]) + 1, Er[bi * 2 + 1] = Er[Ri * 2 + 1] = zi, pr.heap[
        1
        /*SMALLEST*/
      ] = zi++, br(
        pr,
        Er,
        1
        /*SMALLEST*/
      );
    while (pr.heap_len >= 2);
    pr.heap[--pr.heap_max] = pr.heap[
      1
      /*SMALLEST*/
    ], Xr(pr, Cr), Vr(Er, li, pr.bl_count);
  }, hr = (pr, Cr, Er) => {
    let xr, si = -1, Ci, bi = Cr[1], Ri = 0, li = 7, zi = 4;
    for (bi === 0 && (li = 138, zi = 3), Cr[(Er + 1) * 2 + 1] = 65535, xr = 0; xr <= Er; xr++)
      Ci = bi, bi = Cr[(xr + 1) * 2 + 1], !(++Ri < li && Ci === bi) && (Ri < zi ? pr.bl_tree[Ci * 2] += Ri : Ci !== 0 ? (Ci !== si && pr.bl_tree[Ci * 2]++, pr.bl_tree[Se * 2]++) : Ri <= 10 ? pr.bl_tree[ze * 2]++ : pr.bl_tree[He * 2]++, Ri = 0, si = Ci, bi === 0 ? (li = 138, zi = 3) : Ci === bi ? (li = 6, zi = 3) : (li = 7, zi = 4));
  }, Wr = (pr, Cr, Er) => {
    let xr, si = -1, Ci, bi = Cr[1], Ri = 0, li = 7, zi = 4;
    for (bi === 0 && (li = 138, zi = 3), xr = 0; xr <= Er; xr++)
      if (Ci = bi, bi = Cr[(xr + 1) * 2 + 1], !(++Ri < li && Ci === bi)) {
        if (Ri < zi)
          do
            Mr(pr, Ci, pr.bl_tree);
          while (--Ri !== 0);
        else Ci !== 0 ? (Ci !== si && (Mr(pr, Ci, pr.bl_tree), Ri--), Mr(pr, Se, pr.bl_tree), qr(pr, Ri - 3, 2)) : Ri <= 10 ? (Mr(pr, ze, pr.bl_tree), qr(pr, Ri - 3, 3)) : (Mr(pr, He, pr.bl_tree), qr(pr, Ri - 11, 7));
        Ri = 0, si = Ci, bi === 0 ? (li = 138, zi = 3) : Ci === bi ? (li = 6, zi = 3) : (li = 7, zi = 4);
      }
  }, fi = (pr) => {
    let Cr;
    for (hr(pr, pr.dyn_ltree, pr.l_desc.max_code), hr(pr, pr.dyn_dtree, pr.d_desc.max_code), cr(pr, pr.bl_desc), Cr = L - 1; Cr >= 3 && pr.bl_tree[Fe[Cr] * 2 + 1] === 0; Cr--)
      ;
    return pr.opt_len += 3 * (Cr + 1) + 5 + 5 + 4, Cr;
  }, Bi = (pr, Cr, Er, xr) => {
    let si;
    for (qr(pr, Cr - 257, 5), qr(pr, Er - 1, 5), qr(pr, xr - 4, 4), si = 0; si < xr; si++)
      qr(pr, pr.bl_tree[Fe[si] * 2 + 1], 3);
    Wr(pr, pr.dyn_ltree, Cr - 1), Wr(pr, pr.dyn_dtree, Er - 1);
  }, $r = (pr) => {
    let Cr = 4093624447, Er;
    for (Er = 0; Er <= 31; Er++, Cr >>>= 1)
      if (Cr & 1 && pr.dyn_ltree[Er * 2] !== 0)
        return g;
    if (pr.dyn_ltree[18] !== 0 || pr.dyn_ltree[20] !== 0 || pr.dyn_ltree[26] !== 0)
      return c;
    for (Er = 32; Er < F; Er++)
      if (pr.dyn_ltree[Er * 2] !== 0)
        return c;
    return g;
  };
  let oi = !1;
  const zr = (pr) => {
    oi || (Ur(), oi = !0), pr.l_desc = new sr(pr.dyn_ltree, er), pr.d_desc = new sr(pr.dyn_dtree, xt), pr.bl_desc = new sr(pr.bl_tree, ir), pr.bi_buf = 0, pr.bi_valid = 0, Sr(pr);
  }, ti = (pr, Cr, Er, xr) => {
    qr(pr, (d << 1) + (xr ? 1 : 0), 3), Gr(pr), wr(pr, Er), wr(pr, ~Er), Er && pr.pending_buf.set(pr.window.subarray(Cr, Cr + Er), pr.pending), pr.pending += Er;
  }, Lr = (pr) => {
    qr(pr, E << 1, 3), Mr(pr, Ee, Be), Qr(pr);
  }, Rr = (pr, Cr, Er, xr) => {
    let si, Ci, bi = 0;
    pr.level > 0 ? (pr.strm.data_type === y && (pr.strm.data_type = $r(pr)), cr(pr, pr.l_desc), cr(pr, pr.d_desc), bi = fi(pr), si = pr.opt_len + 3 + 7 >>> 3, Ci = pr.static_len + 3 + 7 >>> 3, Ci <= si && (si = Ci)) : si = Ci = Er + 5, Er + 4 <= si && Cr !== -1 ? ti(pr, Cr, Er, xr) : pr.strategy === o || Ci === si ? (qr(pr, (E << 1) + (xr ? 1 : 0), 3), Ar(pr, Be, ke)) : (qr(pr, (B << 1) + (xr ? 1 : 0), 3), Bi(pr, pr.l_desc.max_code + 1, pr.d_desc.max_code + 1, bi + 1), Ar(pr, pr.dyn_ltree, pr.dyn_dtree)), Sr(pr), xr && Gr(pr);
  }, Ir = (pr, Cr, Er) => (pr.pending_buf[pr.sym_buf + pr.sym_next++] = Cr, pr.pending_buf[pr.sym_buf + pr.sym_next++] = Cr >> 8, pr.pending_buf[pr.sym_buf + pr.sym_next++] = Er, Cr === 0 ? pr.dyn_ltree[Er * 2]++ : (pr.matches++, Cr--, pr.dyn_ltree[(Ne[Er] + F + 1) * 2]++, pr.dyn_dtree[yr(Cr) * 2]++), pr.sym_next === pr.sym_end);
  return trees._tr_init = zr, trees._tr_stored_block = ti, trees._tr_flush_block = Rr, trees._tr_tally = Ir, trees._tr_align = Lr, trees;
}
var adler32_1, hasRequiredAdler32;
function requireAdler32() {
  return hasRequiredAdler32 || (hasRequiredAdler32 = 1, adler32_1 = (g, c, y, t) => {
    let d = g & 65535 | 0, E = g >>> 16 & 65535 | 0, B = 0;
    for (; y !== 0; ) {
      B = y > 2e3 ? 2e3 : y, y -= B;
      do
        d = d + c[t++] | 0, E = E + d | 0;
      while (--B);
      d %= 65521, E %= 65521;
    }
    return d | E << 16 | 0;
  }), adler32_1;
}
var crc32_1, hasRequiredCrc32;
function requireCrc32() {
  if (hasRequiredCrc32) return crc32_1;
  hasRequiredCrc32 = 1;
  const o = () => {
    let y, t = [];
    for (var d = 0; d < 256; d++) {
      y = d;
      for (var E = 0; E < 8; E++)
        y = y & 1 ? 3988292384 ^ y >>> 1 : y >>> 1;
      t[d] = y;
    }
    return t;
  }, g = new Uint32Array(o());
  return crc32_1 = (y, t, d, E) => {
    const B = g, D = E + d;
    y ^= -1;
    for (let x = E; x < D; x++)
      y = y >>> 8 ^ B[(y ^ t[x]) & 255];
    return y ^ -1;
  }, crc32_1;
}
var messages, hasRequiredMessages;
function requireMessages() {
  return hasRequiredMessages || (hasRequiredMessages = 1, messages = {
    2: "need dictionary",
    /* Z_NEED_DICT       2  */
    1: "stream end",
    /* Z_STREAM_END      1  */
    0: "",
    /* Z_OK              0  */
    "-1": "file error",
    /* Z_ERRNO         (-1) */
    "-2": "stream error",
    /* Z_STREAM_ERROR  (-2) */
    "-3": "data error",
    /* Z_DATA_ERROR    (-3) */
    "-4": "insufficient memory",
    /* Z_MEM_ERROR     (-4) */
    "-5": "buffer error",
    /* Z_BUF_ERROR     (-5) */
    "-6": "incompatible version"
    /* Z_VERSION_ERROR (-6) */
  }), messages;
}
var constants$3, hasRequiredConstants$3;
function requireConstants$3() {
  return hasRequiredConstants$3 || (hasRequiredConstants$3 = 1, constants$3 = {
    /* Allowed flush values; see deflate() and inflate() below for details */
    Z_NO_FLUSH: 0,
    Z_PARTIAL_FLUSH: 1,
    Z_SYNC_FLUSH: 2,
    Z_FULL_FLUSH: 3,
    Z_FINISH: 4,
    Z_BLOCK: 5,
    Z_TREES: 6,
    /* Return codes for the compression/decompression functions. Negative values
    * are errors, positive values are used for special but normal events.
    */
    Z_OK: 0,
    Z_STREAM_END: 1,
    Z_NEED_DICT: 2,
    Z_ERRNO: -1,
    Z_STREAM_ERROR: -2,
    Z_DATA_ERROR: -3,
    Z_MEM_ERROR: -4,
    Z_BUF_ERROR: -5,
    //Z_VERSION_ERROR: -6,
    /* compression levels */
    Z_NO_COMPRESSION: 0,
    Z_BEST_SPEED: 1,
    Z_BEST_COMPRESSION: 9,
    Z_DEFAULT_COMPRESSION: -1,
    Z_FILTERED: 1,
    Z_HUFFMAN_ONLY: 2,
    Z_RLE: 3,
    Z_FIXED: 4,
    Z_DEFAULT_STRATEGY: 0,
    /* Possible values of the data_type field (though see inflate()) */
    Z_BINARY: 0,
    Z_TEXT: 1,
    //Z_ASCII:                1, // = Z_TEXT (deprecated)
    Z_UNKNOWN: 2,
    /* The deflate compression method */
    Z_DEFLATED: 8
    //Z_NULL:                 null // Use -1 or null inline, depending on var type
  }), constants$3;
}
var hasRequiredDeflate$1;
function requireDeflate$1() {
  if (hasRequiredDeflate$1) return deflate;
  hasRequiredDeflate$1 = 1;
  const { _tr_init: o, _tr_stored_block: g, _tr_flush_block: c, _tr_tally: y, _tr_align: t } = requireTrees(), d = requireAdler32(), E = requireCrc32(), B = requireMessages(), {
    Z_NO_FLUSH: D,
    Z_PARTIAL_FLUSH: x,
    Z_FULL_FLUSH: v,
    Z_FINISH: F,
    Z_BLOCK: M,
    Z_OK: U,
    Z_STREAM_END: L,
    Z_STREAM_ERROR: H,
    Z_DATA_ERROR: fe,
    Z_BUF_ERROR: ge,
    Z_DEFAULT_COMPRESSION: Ie,
    Z_FILTERED: Ee,
    Z_HUFFMAN_ONLY: Se,
    Z_RLE: ze,
    Z_FIXED: He,
    Z_DEFAULT_STRATEGY: Pe,
    Z_UNKNOWN: De,
    Z_DEFLATED: ve
  } = requireConstants$3(), Fe = 9, be = 15, Be = 8, Ne = 256 + 1 + 29, Et = 30, st = 19, Dt = 2 * Ne + 1, er = 15, xt = 3, ir = 258, sr = ir + xt + 1, yr = 32, wr = 42, qr = 57, Mr = 69, Dr = 73, Qr = 91, Xr = 103, Vr = 113, Ur = 666, Sr = 1, Gr = 2, Fr = 3, br = 4, Ar = 3, cr = (ii, Ai) => (ii.msg = B[Ai], Ai), hr = (ii) => ii * 2 - (ii > 4 ? 9 : 0), Wr = (ii) => {
    let Ai = ii.length;
    for (; --Ai >= 0; )
      ii[Ai] = 0;
  }, fi = (ii) => {
    let Ai, ci, Si, Ui = ii.w_size;
    Ai = ii.hash_size, Si = Ai;
    do
      ci = ii.head[--Si], ii.head[Si] = ci >= Ui ? ci - Ui : 0;
    while (--Ai);
    Ai = Ui, Si = Ai;
    do
      ci = ii.prev[--Si], ii.prev[Si] = ci >= Ui ? ci - Ui : 0;
    while (--Ai);
  };
  let $r = (ii, Ai, ci) => (Ai << ii.hash_shift ^ ci) & ii.hash_mask;
  const oi = (ii) => {
    const Ai = ii.state;
    let ci = Ai.pending;
    ci > ii.avail_out && (ci = ii.avail_out), ci !== 0 && (ii.output.set(Ai.pending_buf.subarray(Ai.pending_out, Ai.pending_out + ci), ii.next_out), ii.next_out += ci, Ai.pending_out += ci, ii.total_out += ci, ii.avail_out -= ci, Ai.pending -= ci, Ai.pending === 0 && (Ai.pending_out = 0));
  }, zr = (ii, Ai) => {
    c(ii, ii.block_start >= 0 ? ii.block_start : -1, ii.strstart - ii.block_start, Ai), ii.block_start = ii.strstart, oi(ii.strm);
  }, ti = (ii, Ai) => {
    ii.pending_buf[ii.pending++] = Ai;
  }, Lr = (ii, Ai) => {
    ii.pending_buf[ii.pending++] = Ai >>> 8 & 255, ii.pending_buf[ii.pending++] = Ai & 255;
  }, Rr = (ii, Ai, ci, Si) => {
    let Ui = ii.avail_in;
    return Ui > Si && (Ui = Si), Ui === 0 ? 0 : (ii.avail_in -= Ui, Ai.set(ii.input.subarray(ii.next_in, ii.next_in + Ui), ci), ii.state.wrap === 1 ? ii.adler = d(ii.adler, Ai, Ui, ci) : ii.state.wrap === 2 && (ii.adler = E(ii.adler, Ai, Ui, ci)), ii.next_in += Ui, ii.total_in += Ui, Ui);
  }, Ir = (ii, Ai) => {
    let ci = ii.max_chain_length, Si = ii.strstart, Ui, _i, Tn = ii.prev_length, Fn = ii.nice_match;
    const ss = ii.strstart > ii.w_size - sr ? ii.strstart - (ii.w_size - sr) : 0, rs = ii.window, is = ii.w_mask, Pr = ii.prev, as = ii.strstart + ir;
    let Rs = rs[Si + Tn - 1], ri = rs[Si + Tn];
    ii.prev_length >= ii.good_match && (ci >>= 2), Fn > ii.lookahead && (Fn = ii.lookahead);
    do
      if (Ui = Ai, !(rs[Ui + Tn] !== ri || rs[Ui + Tn - 1] !== Rs || rs[Ui] !== rs[Si] || rs[++Ui] !== rs[Si + 1])) {
        Si += 2, Ui++;
        do
          ;
        while (rs[++Si] === rs[++Ui] && rs[++Si] === rs[++Ui] && rs[++Si] === rs[++Ui] && rs[++Si] === rs[++Ui] && rs[++Si] === rs[++Ui] && rs[++Si] === rs[++Ui] && rs[++Si] === rs[++Ui] && rs[++Si] === rs[++Ui] && Si < as);
        if (_i = ir - (as - Si), Si = as - ir, _i > Tn) {
          if (ii.match_start = Ai, Tn = _i, _i >= Fn)
            break;
          Rs = rs[Si + Tn - 1], ri = rs[Si + Tn];
        }
      }
    while ((Ai = Pr[Ai & is]) > ss && --ci !== 0);
    return Tn <= ii.lookahead ? Tn : ii.lookahead;
  }, pr = (ii) => {
    const Ai = ii.w_size;
    let ci, Si, Ui;
    do {
      if (Si = ii.window_size - ii.lookahead - ii.strstart, ii.strstart >= Ai + (Ai - sr) && (ii.window.set(ii.window.subarray(Ai, Ai + Ai - Si), 0), ii.match_start -= Ai, ii.strstart -= Ai, ii.block_start -= Ai, ii.insert > ii.strstart && (ii.insert = ii.strstart), fi(ii), Si += Ai), ii.strm.avail_in === 0)
        break;
      if (ci = Rr(ii.strm, ii.window, ii.strstart + ii.lookahead, Si), ii.lookahead += ci, ii.lookahead + ii.insert >= xt)
        for (Ui = ii.strstart - ii.insert, ii.ins_h = ii.window[Ui], ii.ins_h = $r(ii, ii.ins_h, ii.window[Ui + 1]); ii.insert && (ii.ins_h = $r(ii, ii.ins_h, ii.window[Ui + xt - 1]), ii.prev[Ui & ii.w_mask] = ii.head[ii.ins_h], ii.head[ii.ins_h] = Ui, Ui++, ii.insert--, !(ii.lookahead + ii.insert < xt)); )
          ;
    } while (ii.lookahead < sr && ii.strm.avail_in !== 0);
  }, Cr = (ii, Ai) => {
    let ci = ii.pending_buf_size - 5 > ii.w_size ? ii.w_size : ii.pending_buf_size - 5, Si, Ui, _i, Tn = 0, Fn = ii.strm.avail_in;
    do {
      if (Si = 65535, _i = ii.bi_valid + 42 >> 3, ii.strm.avail_out < _i || (_i = ii.strm.avail_out - _i, Ui = ii.strstart - ii.block_start, Si > Ui + ii.strm.avail_in && (Si = Ui + ii.strm.avail_in), Si > _i && (Si = _i), Si < ci && (Si === 0 && Ai !== F || Ai === D || Si !== Ui + ii.strm.avail_in)))
        break;
      Tn = Ai === F && Si === Ui + ii.strm.avail_in ? 1 : 0, g(ii, 0, 0, Tn), ii.pending_buf[ii.pending - 4] = Si, ii.pending_buf[ii.pending - 3] = Si >> 8, ii.pending_buf[ii.pending - 2] = ~Si, ii.pending_buf[ii.pending - 1] = ~Si >> 8, oi(ii.strm), Ui && (Ui > Si && (Ui = Si), ii.strm.output.set(ii.window.subarray(ii.block_start, ii.block_start + Ui), ii.strm.next_out), ii.strm.next_out += Ui, ii.strm.avail_out -= Ui, ii.strm.total_out += Ui, ii.block_start += Ui, Si -= Ui), Si && (Rr(ii.strm, ii.strm.output, ii.strm.next_out, Si), ii.strm.next_out += Si, ii.strm.avail_out -= Si, ii.strm.total_out += Si);
    } while (Tn === 0);
    return Fn -= ii.strm.avail_in, Fn && (Fn >= ii.w_size ? (ii.matches = 2, ii.window.set(ii.strm.input.subarray(ii.strm.next_in - ii.w_size, ii.strm.next_in), 0), ii.strstart = ii.w_size, ii.insert = ii.strstart) : (ii.window_size - ii.strstart <= Fn && (ii.strstart -= ii.w_size, ii.window.set(ii.window.subarray(ii.w_size, ii.w_size + ii.strstart), 0), ii.matches < 2 && ii.matches++, ii.insert > ii.strstart && (ii.insert = ii.strstart)), ii.window.set(ii.strm.input.subarray(ii.strm.next_in - Fn, ii.strm.next_in), ii.strstart), ii.strstart += Fn, ii.insert += Fn > ii.w_size - ii.insert ? ii.w_size - ii.insert : Fn), ii.block_start = ii.strstart), ii.high_water < ii.strstart && (ii.high_water = ii.strstart), Tn ? br : Ai !== D && Ai !== F && ii.strm.avail_in === 0 && ii.strstart === ii.block_start ? Gr : (_i = ii.window_size - ii.strstart, ii.strm.avail_in > _i && ii.block_start >= ii.w_size && (ii.block_start -= ii.w_size, ii.strstart -= ii.w_size, ii.window.set(ii.window.subarray(ii.w_size, ii.w_size + ii.strstart), 0), ii.matches < 2 && ii.matches++, _i += ii.w_size, ii.insert > ii.strstart && (ii.insert = ii.strstart)), _i > ii.strm.avail_in && (_i = ii.strm.avail_in), _i && (Rr(ii.strm, ii.window, ii.strstart, _i), ii.strstart += _i, ii.insert += _i > ii.w_size - ii.insert ? ii.w_size - ii.insert : _i), ii.high_water < ii.strstart && (ii.high_water = ii.strstart), _i = ii.bi_valid + 42 >> 3, _i = ii.pending_buf_size - _i > 65535 ? 65535 : ii.pending_buf_size - _i, ci = _i > ii.w_size ? ii.w_size : _i, Ui = ii.strstart - ii.block_start, (Ui >= ci || (Ui || Ai === F) && Ai !== D && ii.strm.avail_in === 0 && Ui <= _i) && (Si = Ui > _i ? _i : Ui, Tn = Ai === F && ii.strm.avail_in === 0 && Si === Ui ? 1 : 0, g(ii, ii.block_start, Si, Tn), ii.block_start += Si, oi(ii.strm)), Tn ? Fr : Sr);
  }, Er = (ii, Ai) => {
    let ci, Si;
    for (; ; ) {
      if (ii.lookahead < sr) {
        if (pr(ii), ii.lookahead < sr && Ai === D)
          return Sr;
        if (ii.lookahead === 0)
          break;
      }
      if (ci = 0, ii.lookahead >= xt && (ii.ins_h = $r(ii, ii.ins_h, ii.window[ii.strstart + xt - 1]), ci = ii.prev[ii.strstart & ii.w_mask] = ii.head[ii.ins_h], ii.head[ii.ins_h] = ii.strstart), ci !== 0 && ii.strstart - ci <= ii.w_size - sr && (ii.match_length = Ir(ii, ci)), ii.match_length >= xt)
        if (Si = y(ii, ii.strstart - ii.match_start, ii.match_length - xt), ii.lookahead -= ii.match_length, ii.match_length <= ii.max_lazy_match && ii.lookahead >= xt) {
          ii.match_length--;
          do
            ii.strstart++, ii.ins_h = $r(ii, ii.ins_h, ii.window[ii.strstart + xt - 1]), ci = ii.prev[ii.strstart & ii.w_mask] = ii.head[ii.ins_h], ii.head[ii.ins_h] = ii.strstart;
          while (--ii.match_length !== 0);
          ii.strstart++;
        } else
          ii.strstart += ii.match_length, ii.match_length = 0, ii.ins_h = ii.window[ii.strstart], ii.ins_h = $r(ii, ii.ins_h, ii.window[ii.strstart + 1]);
      else
        Si = y(ii, 0, ii.window[ii.strstart]), ii.lookahead--, ii.strstart++;
      if (Si && (zr(ii, !1), ii.strm.avail_out === 0))
        return Sr;
    }
    return ii.insert = ii.strstart < xt - 1 ? ii.strstart : xt - 1, Ai === F ? (zr(ii, !0), ii.strm.avail_out === 0 ? Fr : br) : ii.sym_next && (zr(ii, !1), ii.strm.avail_out === 0) ? Sr : Gr;
  }, xr = (ii, Ai) => {
    let ci, Si, Ui;
    for (; ; ) {
      if (ii.lookahead < sr) {
        if (pr(ii), ii.lookahead < sr && Ai === D)
          return Sr;
        if (ii.lookahead === 0)
          break;
      }
      if (ci = 0, ii.lookahead >= xt && (ii.ins_h = $r(ii, ii.ins_h, ii.window[ii.strstart + xt - 1]), ci = ii.prev[ii.strstart & ii.w_mask] = ii.head[ii.ins_h], ii.head[ii.ins_h] = ii.strstart), ii.prev_length = ii.match_length, ii.prev_match = ii.match_start, ii.match_length = xt - 1, ci !== 0 && ii.prev_length < ii.max_lazy_match && ii.strstart - ci <= ii.w_size - sr && (ii.match_length = Ir(ii, ci), ii.match_length <= 5 && (ii.strategy === Ee || ii.match_length === xt && ii.strstart - ii.match_start > 4096) && (ii.match_length = xt - 1)), ii.prev_length >= xt && ii.match_length <= ii.prev_length) {
        Ui = ii.strstart + ii.lookahead - xt, Si = y(ii, ii.strstart - 1 - ii.prev_match, ii.prev_length - xt), ii.lookahead -= ii.prev_length - 1, ii.prev_length -= 2;
        do
          ++ii.strstart <= Ui && (ii.ins_h = $r(ii, ii.ins_h, ii.window[ii.strstart + xt - 1]), ci = ii.prev[ii.strstart & ii.w_mask] = ii.head[ii.ins_h], ii.head[ii.ins_h] = ii.strstart);
        while (--ii.prev_length !== 0);
        if (ii.match_available = 0, ii.match_length = xt - 1, ii.strstart++, Si && (zr(ii, !1), ii.strm.avail_out === 0))
          return Sr;
      } else if (ii.match_available) {
        if (Si = y(ii, 0, ii.window[ii.strstart - 1]), Si && zr(ii, !1), ii.strstart++, ii.lookahead--, ii.strm.avail_out === 0)
          return Sr;
      } else
        ii.match_available = 1, ii.strstart++, ii.lookahead--;
    }
    return ii.match_available && (Si = y(ii, 0, ii.window[ii.strstart - 1]), ii.match_available = 0), ii.insert = ii.strstart < xt - 1 ? ii.strstart : xt - 1, Ai === F ? (zr(ii, !0), ii.strm.avail_out === 0 ? Fr : br) : ii.sym_next && (zr(ii, !1), ii.strm.avail_out === 0) ? Sr : Gr;
  }, si = (ii, Ai) => {
    let ci, Si, Ui, _i;
    const Tn = ii.window;
    for (; ; ) {
      if (ii.lookahead <= ir) {
        if (pr(ii), ii.lookahead <= ir && Ai === D)
          return Sr;
        if (ii.lookahead === 0)
          break;
      }
      if (ii.match_length = 0, ii.lookahead >= xt && ii.strstart > 0 && (Ui = ii.strstart - 1, Si = Tn[Ui], Si === Tn[++Ui] && Si === Tn[++Ui] && Si === Tn[++Ui])) {
        _i = ii.strstart + ir;
        do
          ;
        while (Si === Tn[++Ui] && Si === Tn[++Ui] && Si === Tn[++Ui] && Si === Tn[++Ui] && Si === Tn[++Ui] && Si === Tn[++Ui] && Si === Tn[++Ui] && Si === Tn[++Ui] && Ui < _i);
        ii.match_length = ir - (_i - Ui), ii.match_length > ii.lookahead && (ii.match_length = ii.lookahead);
      }
      if (ii.match_length >= xt ? (ci = y(ii, 1, ii.match_length - xt), ii.lookahead -= ii.match_length, ii.strstart += ii.match_length, ii.match_length = 0) : (ci = y(ii, 0, ii.window[ii.strstart]), ii.lookahead--, ii.strstart++), ci && (zr(ii, !1), ii.strm.avail_out === 0))
        return Sr;
    }
    return ii.insert = 0, Ai === F ? (zr(ii, !0), ii.strm.avail_out === 0 ? Fr : br) : ii.sym_next && (zr(ii, !1), ii.strm.avail_out === 0) ? Sr : Gr;
  }, Ci = (ii, Ai) => {
    let ci;
    for (; ; ) {
      if (ii.lookahead === 0 && (pr(ii), ii.lookahead === 0)) {
        if (Ai === D)
          return Sr;
        break;
      }
      if (ii.match_length = 0, ci = y(ii, 0, ii.window[ii.strstart]), ii.lookahead--, ii.strstart++, ci && (zr(ii, !1), ii.strm.avail_out === 0))
        return Sr;
    }
    return ii.insert = 0, Ai === F ? (zr(ii, !0), ii.strm.avail_out === 0 ? Fr : br) : ii.sym_next && (zr(ii, !1), ii.strm.avail_out === 0) ? Sr : Gr;
  };
  function bi(ii, Ai, ci, Si, Ui) {
    this.good_length = ii, this.max_lazy = Ai, this.nice_length = ci, this.max_chain = Si, this.func = Ui;
  }
  const Ri = [
    /*      good lazy nice chain */
    new bi(0, 0, 0, 0, Cr),
    /* 0 store only */
    new bi(4, 4, 8, 4, Er),
    /* 1 max speed, no lazy matches */
    new bi(4, 5, 16, 8, Er),
    /* 2 */
    new bi(4, 6, 32, 32, Er),
    /* 3 */
    new bi(4, 4, 16, 16, xr),
    /* 4 lazy matches */
    new bi(8, 16, 32, 32, xr),
    /* 5 */
    new bi(8, 16, 128, 128, xr),
    /* 6 */
    new bi(8, 32, 128, 256, xr),
    /* 7 */
    new bi(32, 128, 258, 1024, xr),
    /* 8 */
    new bi(32, 258, 258, 4096, xr)
    /* 9 max compression */
  ], li = (ii) => {
    ii.window_size = 2 * ii.w_size, Wr(ii.head), ii.max_lazy_match = Ri[ii.level].max_lazy, ii.good_match = Ri[ii.level].good_length, ii.nice_match = Ri[ii.level].nice_length, ii.max_chain_length = Ri[ii.level].max_chain, ii.strstart = 0, ii.block_start = 0, ii.lookahead = 0, ii.insert = 0, ii.match_length = ii.prev_length = xt - 1, ii.match_available = 0, ii.ins_h = 0;
  };
  function zi() {
    this.strm = null, this.status = 0, this.pending_buf = null, this.pending_buf_size = 0, this.pending_out = 0, this.pending = 0, this.wrap = 0, this.gzhead = null, this.gzindex = 0, this.method = ve, this.last_flush = -1, this.w_size = 0, this.w_bits = 0, this.w_mask = 0, this.window = null, this.window_size = 0, this.prev = null, this.head = null, this.ins_h = 0, this.hash_size = 0, this.hash_bits = 0, this.hash_mask = 0, this.hash_shift = 0, this.block_start = 0, this.match_length = 0, this.prev_match = 0, this.match_available = 0, this.strstart = 0, this.match_start = 0, this.lookahead = 0, this.prev_length = 0, this.max_chain_length = 0, this.max_lazy_match = 0, this.level = 0, this.strategy = 0, this.good_match = 0, this.nice_match = 0, this.dyn_ltree = new Uint16Array(Dt * 2), this.dyn_dtree = new Uint16Array((2 * Et + 1) * 2), this.bl_tree = new Uint16Array((2 * st + 1) * 2), Wr(this.dyn_ltree), Wr(this.dyn_dtree), Wr(this.bl_tree), this.l_desc = null, this.d_desc = null, this.bl_desc = null, this.bl_count = new Uint16Array(er + 1), this.heap = new Uint16Array(2 * Ne + 1), Wr(this.heap), this.heap_len = 0, this.heap_max = 0, this.depth = new Uint16Array(2 * Ne + 1), Wr(this.depth), this.sym_buf = 0, this.lit_bufsize = 0, this.sym_next = 0, this.sym_end = 0, this.opt_len = 0, this.static_len = 0, this.matches = 0, this.insert = 0, this.bi_buf = 0, this.bi_valid = 0;
  }
  const Kn = (ii) => {
    if (!ii)
      return 1;
    const Ai = ii.state;
    return !Ai || Ai.strm !== ii || Ai.status !== wr && //#ifdef GZIP
    Ai.status !== qr && //#endif
    Ai.status !== Mr && Ai.status !== Dr && Ai.status !== Qr && Ai.status !== Xr && Ai.status !== Vr && Ai.status !== Ur ? 1 : 0;
  }, Hn = (ii) => {
    if (Kn(ii))
      return cr(ii, H);
    ii.total_in = ii.total_out = 0, ii.data_type = De;
    const Ai = ii.state;
    return Ai.pending = 0, Ai.pending_out = 0, Ai.wrap < 0 && (Ai.wrap = -Ai.wrap), Ai.status = //#ifdef GZIP
    Ai.wrap === 2 ? qr : (
      //#endif
      Ai.wrap ? wr : Vr
    ), ii.adler = Ai.wrap === 2 ? 0 : 1, Ai.last_flush = -2, o(Ai), U;
  }, os = (ii) => {
    const Ai = Hn(ii);
    return Ai === U && li(ii.state), Ai;
  }, ts = (ii, Ai) => Kn(ii) || ii.state.wrap !== 2 ? H : (ii.state.gzhead = Ai, U), Gs = (ii, Ai, ci, Si, Ui, _i) => {
    if (!ii)
      return H;
    let Tn = 1;
    if (Ai === Ie && (Ai = 6), Si < 0 ? (Tn = 0, Si = -Si) : Si > 15 && (Tn = 2, Si -= 16), Ui < 1 || Ui > Fe || ci !== ve || Si < 8 || Si > 15 || Ai < 0 || Ai > 9 || _i < 0 || _i > He || Si === 8 && Tn !== 1)
      return cr(ii, H);
    Si === 8 && (Si = 9);
    const Fn = new zi();
    return ii.state = Fn, Fn.strm = ii, Fn.status = wr, Fn.wrap = Tn, Fn.gzhead = null, Fn.w_bits = Si, Fn.w_size = 1 << Fn.w_bits, Fn.w_mask = Fn.w_size - 1, Fn.hash_bits = Ui + 7, Fn.hash_size = 1 << Fn.hash_bits, Fn.hash_mask = Fn.hash_size - 1, Fn.hash_shift = ~~((Fn.hash_bits + xt - 1) / xt), Fn.window = new Uint8Array(Fn.w_size * 2), Fn.head = new Uint16Array(Fn.hash_size), Fn.prev = new Uint16Array(Fn.w_size), Fn.lit_bufsize = 1 << Ui + 6, Fn.pending_buf_size = Fn.lit_bufsize * 4, Fn.pending_buf = new Uint8Array(Fn.pending_buf_size), Fn.sym_buf = Fn.lit_bufsize, Fn.sym_end = (Fn.lit_bufsize - 1) * 3, Fn.level = Ai, Fn.strategy = _i, Fn.method = ci, os(ii);
  }, Wn = (ii, Ai) => Gs(ii, Ai, ve, be, Be, Pe), Gn = (ii, Ai) => {
    if (Kn(ii) || Ai > M || Ai < 0)
      return ii ? cr(ii, H) : H;
    const ci = ii.state;
    if (!ii.output || ii.avail_in !== 0 && !ii.input || ci.status === Ur && Ai !== F)
      return cr(ii, ii.avail_out === 0 ? ge : H);
    const Si = ci.last_flush;
    if (ci.last_flush = Ai, ci.pending !== 0) {
      if (oi(ii), ii.avail_out === 0)
        return ci.last_flush = -1, U;
    } else if (ii.avail_in === 0 && hr(Ai) <= hr(Si) && Ai !== F)
      return cr(ii, ge);
    if (ci.status === Ur && ii.avail_in !== 0)
      return cr(ii, ge);
    if (ci.status === wr && ci.wrap === 0 && (ci.status = Vr), ci.status === wr) {
      let Ui = ve + (ci.w_bits - 8 << 4) << 8, _i = -1;
      if (ci.strategy >= Se || ci.level < 2 ? _i = 0 : ci.level < 6 ? _i = 1 : ci.level === 6 ? _i = 2 : _i = 3, Ui |= _i << 6, ci.strstart !== 0 && (Ui |= yr), Ui += 31 - Ui % 31, Lr(ci, Ui), ci.strstart !== 0 && (Lr(ci, ii.adler >>> 16), Lr(ci, ii.adler & 65535)), ii.adler = 1, ci.status = Vr, oi(ii), ci.pending !== 0)
        return ci.last_flush = -1, U;
    }
    if (ci.status === qr) {
      if (ii.adler = 0, ti(ci, 31), ti(ci, 139), ti(ci, 8), ci.gzhead)
        ti(
          ci,
          (ci.gzhead.text ? 1 : 0) + (ci.gzhead.hcrc ? 2 : 0) + (ci.gzhead.extra ? 4 : 0) + (ci.gzhead.name ? 8 : 0) + (ci.gzhead.comment ? 16 : 0)
        ), ti(ci, ci.gzhead.time & 255), ti(ci, ci.gzhead.time >> 8 & 255), ti(ci, ci.gzhead.time >> 16 & 255), ti(ci, ci.gzhead.time >> 24 & 255), ti(ci, ci.level === 9 ? 2 : ci.strategy >= Se || ci.level < 2 ? 4 : 0), ti(ci, ci.gzhead.os & 255), ci.gzhead.extra && ci.gzhead.extra.length && (ti(ci, ci.gzhead.extra.length & 255), ti(ci, ci.gzhead.extra.length >> 8 & 255)), ci.gzhead.hcrc && (ii.adler = E(ii.adler, ci.pending_buf, ci.pending, 0)), ci.gzindex = 0, ci.status = Mr;
      else if (ti(ci, 0), ti(ci, 0), ti(ci, 0), ti(ci, 0), ti(ci, 0), ti(ci, ci.level === 9 ? 2 : ci.strategy >= Se || ci.level < 2 ? 4 : 0), ti(ci, Ar), ci.status = Vr, oi(ii), ci.pending !== 0)
        return ci.last_flush = -1, U;
    }
    if (ci.status === Mr) {
      if (ci.gzhead.extra) {
        let Ui = ci.pending, _i = (ci.gzhead.extra.length & 65535) - ci.gzindex;
        for (; ci.pending + _i > ci.pending_buf_size; ) {
          let Fn = ci.pending_buf_size - ci.pending;
          if (ci.pending_buf.set(ci.gzhead.extra.subarray(ci.gzindex, ci.gzindex + Fn), ci.pending), ci.pending = ci.pending_buf_size, ci.gzhead.hcrc && ci.pending > Ui && (ii.adler = E(ii.adler, ci.pending_buf, ci.pending - Ui, Ui)), ci.gzindex += Fn, oi(ii), ci.pending !== 0)
            return ci.last_flush = -1, U;
          Ui = 0, _i -= Fn;
        }
        let Tn = new Uint8Array(ci.gzhead.extra);
        ci.pending_buf.set(Tn.subarray(ci.gzindex, ci.gzindex + _i), ci.pending), ci.pending += _i, ci.gzhead.hcrc && ci.pending > Ui && (ii.adler = E(ii.adler, ci.pending_buf, ci.pending - Ui, Ui)), ci.gzindex = 0;
      }
      ci.status = Dr;
    }
    if (ci.status === Dr) {
      if (ci.gzhead.name) {
        let Ui = ci.pending, _i;
        do {
          if (ci.pending === ci.pending_buf_size) {
            if (ci.gzhead.hcrc && ci.pending > Ui && (ii.adler = E(ii.adler, ci.pending_buf, ci.pending - Ui, Ui)), oi(ii), ci.pending !== 0)
              return ci.last_flush = -1, U;
            Ui = 0;
          }
          ci.gzindex < ci.gzhead.name.length ? _i = ci.gzhead.name.charCodeAt(ci.gzindex++) & 255 : _i = 0, ti(ci, _i);
        } while (_i !== 0);
        ci.gzhead.hcrc && ci.pending > Ui && (ii.adler = E(ii.adler, ci.pending_buf, ci.pending - Ui, Ui)), ci.gzindex = 0;
      }
      ci.status = Qr;
    }
    if (ci.status === Qr) {
      if (ci.gzhead.comment) {
        let Ui = ci.pending, _i;
        do {
          if (ci.pending === ci.pending_buf_size) {
            if (ci.gzhead.hcrc && ci.pending > Ui && (ii.adler = E(ii.adler, ci.pending_buf, ci.pending - Ui, Ui)), oi(ii), ci.pending !== 0)
              return ci.last_flush = -1, U;
            Ui = 0;
          }
          ci.gzindex < ci.gzhead.comment.length ? _i = ci.gzhead.comment.charCodeAt(ci.gzindex++) & 255 : _i = 0, ti(ci, _i);
        } while (_i !== 0);
        ci.gzhead.hcrc && ci.pending > Ui && (ii.adler = E(ii.adler, ci.pending_buf, ci.pending - Ui, Ui));
      }
      ci.status = Xr;
    }
    if (ci.status === Xr) {
      if (ci.gzhead.hcrc) {
        if (ci.pending + 2 > ci.pending_buf_size && (oi(ii), ci.pending !== 0))
          return ci.last_flush = -1, U;
        ti(ci, ii.adler & 255), ti(ci, ii.adler >> 8 & 255), ii.adler = 0;
      }
      if (ci.status = Vr, oi(ii), ci.pending !== 0)
        return ci.last_flush = -1, U;
    }
    if (ii.avail_in !== 0 || ci.lookahead !== 0 || Ai !== D && ci.status !== Ur) {
      let Ui = ci.level === 0 ? Cr(ci, Ai) : ci.strategy === Se ? Ci(ci, Ai) : ci.strategy === ze ? si(ci, Ai) : Ri[ci.level].func(ci, Ai);
      if ((Ui === Fr || Ui === br) && (ci.status = Ur), Ui === Sr || Ui === Fr)
        return ii.avail_out === 0 && (ci.last_flush = -1), U;
      if (Ui === Gr && (Ai === x ? t(ci) : Ai !== M && (g(ci, 0, 0, !1), Ai === v && (Wr(ci.head), ci.lookahead === 0 && (ci.strstart = 0, ci.block_start = 0, ci.insert = 0))), oi(ii), ii.avail_out === 0))
        return ci.last_flush = -1, U;
    }
    return Ai !== F ? U : ci.wrap <= 0 ? L : (ci.wrap === 2 ? (ti(ci, ii.adler & 255), ti(ci, ii.adler >> 8 & 255), ti(ci, ii.adler >> 16 & 255), ti(ci, ii.adler >> 24 & 255), ti(ci, ii.total_in & 255), ti(ci, ii.total_in >> 8 & 255), ti(ci, ii.total_in >> 16 & 255), ti(ci, ii.total_in >> 24 & 255)) : (Lr(ci, ii.adler >>> 16), Lr(ci, ii.adler & 65535)), oi(ii), ci.wrap > 0 && (ci.wrap = -ci.wrap), ci.pending !== 0 ? U : L);
  }, ro = (ii) => {
    if (Kn(ii))
      return H;
    const Ai = ii.state.status;
    return ii.state = null, Ai === Vr ? cr(ii, fe) : U;
  }, Fs = (ii, Ai) => {
    let ci = Ai.length;
    if (Kn(ii))
      return H;
    const Si = ii.state, Ui = Si.wrap;
    if (Ui === 2 || Ui === 1 && Si.status !== wr || Si.lookahead)
      return H;
    if (Ui === 1 && (ii.adler = d(ii.adler, Ai, ci, 0)), Si.wrap = 0, ci >= Si.w_size) {
      Ui === 0 && (Wr(Si.head), Si.strstart = 0, Si.block_start = 0, Si.insert = 0);
      let ss = new Uint8Array(Si.w_size);
      ss.set(Ai.subarray(ci - Si.w_size, ci), 0), Ai = ss, ci = Si.w_size;
    }
    const _i = ii.avail_in, Tn = ii.next_in, Fn = ii.input;
    for (ii.avail_in = ci, ii.next_in = 0, ii.input = Ai, pr(Si); Si.lookahead >= xt; ) {
      let ss = Si.strstart, rs = Si.lookahead - (xt - 1);
      do
        Si.ins_h = $r(Si, Si.ins_h, Si.window[ss + xt - 1]), Si.prev[ss & Si.w_mask] = Si.head[Si.ins_h], Si.head[Si.ins_h] = ss, ss++;
      while (--rs);
      Si.strstart = ss, Si.lookahead = xt - 1, pr(Si);
    }
    return Si.strstart += Si.lookahead, Si.block_start = Si.strstart, Si.insert = Si.lookahead, Si.lookahead = 0, Si.match_length = Si.prev_length = xt - 1, Si.match_available = 0, ii.next_in = Tn, ii.input = Fn, ii.avail_in = _i, Si.wrap = Ui, U;
  };
  return deflate.deflateInit = Wn, deflate.deflateInit2 = Gs, deflate.deflateReset = os, deflate.deflateResetKeep = Hn, deflate.deflateSetHeader = ts, deflate.deflate = Gn, deflate.deflateEnd = ro, deflate.deflateSetDictionary = Fs, deflate.deflateInfo = "pako deflate (from Nodeca project)", deflate;
}
var common = {}, hasRequiredCommon;
function requireCommon() {
  if (hasRequiredCommon) return common;
  hasRequiredCommon = 1;
  const o = (g, c) => Object.prototype.hasOwnProperty.call(g, c);
  return common.assign = function(g) {
    const c = Array.prototype.slice.call(arguments, 1);
    for (; c.length; ) {
      const y = c.shift();
      if (y) {
        if (typeof y != "object")
          throw new TypeError(y + "must be non-object");
        for (const t in y)
          o(y, t) && (g[t] = y[t]);
      }
    }
    return g;
  }, common.flattenChunks = (g) => {
    let c = 0;
    for (let t = 0, d = g.length; t < d; t++)
      c += g[t].length;
    const y = new Uint8Array(c);
    for (let t = 0, d = 0, E = g.length; t < E; t++) {
      let B = g[t];
      y.set(B, d), d += B.length;
    }
    return y;
  }, common;
}
var strings = {}, hasRequiredStrings;
function requireStrings() {
  if (hasRequiredStrings) return strings;
  hasRequiredStrings = 1;
  let o = !0;
  try {
    String.fromCharCode.apply(null, new Uint8Array(1));
  } catch {
    o = !1;
  }
  const g = new Uint8Array(256);
  for (let y = 0; y < 256; y++)
    g[y] = y >= 252 ? 6 : y >= 248 ? 5 : y >= 240 ? 4 : y >= 224 ? 3 : y >= 192 ? 2 : 1;
  g[254] = g[254] = 1, strings.string2buf = (y) => {
    if (typeof TextEncoder == "function" && TextEncoder.prototype.encode)
      return new TextEncoder().encode(y);
    let t, d, E, B, D, x = y.length, v = 0;
    for (B = 0; B < x; B++)
      d = y.charCodeAt(B), (d & 64512) === 55296 && B + 1 < x && (E = y.charCodeAt(B + 1), (E & 64512) === 56320 && (d = 65536 + (d - 55296 << 10) + (E - 56320), B++)), v += d < 128 ? 1 : d < 2048 ? 2 : d < 65536 ? 3 : 4;
    for (t = new Uint8Array(v), D = 0, B = 0; D < v; B++)
      d = y.charCodeAt(B), (d & 64512) === 55296 && B + 1 < x && (E = y.charCodeAt(B + 1), (E & 64512) === 56320 && (d = 65536 + (d - 55296 << 10) + (E - 56320), B++)), d < 128 ? t[D++] = d : d < 2048 ? (t[D++] = 192 | d >>> 6, t[D++] = 128 | d & 63) : d < 65536 ? (t[D++] = 224 | d >>> 12, t[D++] = 128 | d >>> 6 & 63, t[D++] = 128 | d & 63) : (t[D++] = 240 | d >>> 18, t[D++] = 128 | d >>> 12 & 63, t[D++] = 128 | d >>> 6 & 63, t[D++] = 128 | d & 63);
    return t;
  };
  const c = (y, t) => {
    if (t < 65534 && y.subarray && o)
      return String.fromCharCode.apply(null, y.length === t ? y : y.subarray(0, t));
    let d = "";
    for (let E = 0; E < t; E++)
      d += String.fromCharCode(y[E]);
    return d;
  };
  return strings.buf2string = (y, t) => {
    const d = t || y.length;
    if (typeof TextDecoder == "function" && TextDecoder.prototype.decode)
      return new TextDecoder().decode(y.subarray(0, t));
    let E, B;
    const D = new Array(d * 2);
    for (B = 0, E = 0; E < d; ) {
      let x = y[E++];
      if (x < 128) {
        D[B++] = x;
        continue;
      }
      let v = g[x];
      if (v > 4) {
        D[B++] = 65533, E += v - 1;
        continue;
      }
      for (x &= v === 2 ? 31 : v === 3 ? 15 : 7; v > 1 && E < d; )
        x = x << 6 | y[E++] & 63, v--;
      if (v > 1) {
        D[B++] = 65533;
        continue;
      }
      x < 65536 ? D[B++] = x : (x -= 65536, D[B++] = 55296 | x >> 10 & 1023, D[B++] = 56320 | x & 1023);
    }
    return c(D, B);
  }, strings.utf8border = (y, t) => {
    t = t || y.length, t > y.length && (t = y.length);
    let d = t - 1;
    for (; d >= 0 && (y[d] & 192) === 128; )
      d--;
    return d < 0 || d === 0 ? t : d + g[y[d]] > t ? d : t;
  }, strings;
}
var zstream, hasRequiredZstream;
function requireZstream() {
  if (hasRequiredZstream) return zstream;
  hasRequiredZstream = 1;
  function o() {
    this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
  }
  return zstream = o, zstream;
}
var hasRequiredDeflate;
function requireDeflate() {
  if (hasRequiredDeflate) return deflate$1;
  hasRequiredDeflate = 1;
  const o = requireDeflate$1(), g = requireCommon(), c = requireStrings(), y = requireMessages(), t = requireZstream(), d = Object.prototype.toString, {
    Z_NO_FLUSH: E,
    Z_SYNC_FLUSH: B,
    Z_FULL_FLUSH: D,
    Z_FINISH: x,
    Z_OK: v,
    Z_STREAM_END: F,
    Z_DEFAULT_COMPRESSION: M,
    Z_DEFAULT_STRATEGY: U,
    Z_DEFLATED: L
  } = requireConstants$3();
  function H(Ee) {
    this.options = g.assign({
      level: M,
      method: L,
      chunkSize: 16384,
      windowBits: 15,
      memLevel: 8,
      strategy: U
    }, Ee || {});
    let Se = this.options;
    Se.raw && Se.windowBits > 0 ? Se.windowBits = -Se.windowBits : Se.gzip && Se.windowBits > 0 && Se.windowBits < 16 && (Se.windowBits += 16), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new t(), this.strm.avail_out = 0;
    let ze = o.deflateInit2(
      this.strm,
      Se.level,
      Se.method,
      Se.windowBits,
      Se.memLevel,
      Se.strategy
    );
    if (ze !== v)
      throw new Error(y[ze]);
    if (Se.header && o.deflateSetHeader(this.strm, Se.header), Se.dictionary) {
      let He;
      if (typeof Se.dictionary == "string" ? He = c.string2buf(Se.dictionary) : d.call(Se.dictionary) === "[object ArrayBuffer]" ? He = new Uint8Array(Se.dictionary) : He = Se.dictionary, ze = o.deflateSetDictionary(this.strm, He), ze !== v)
        throw new Error(y[ze]);
      this._dict_set = !0;
    }
  }
  H.prototype.push = function(Ee, Se) {
    const ze = this.strm, He = this.options.chunkSize;
    let Pe, De;
    if (this.ended)
      return !1;
    for (Se === ~~Se ? De = Se : De = Se === !0 ? x : E, typeof Ee == "string" ? ze.input = c.string2buf(Ee) : d.call(Ee) === "[object ArrayBuffer]" ? ze.input = new Uint8Array(Ee) : ze.input = Ee, ze.next_in = 0, ze.avail_in = ze.input.length; ; ) {
      if (ze.avail_out === 0 && (ze.output = new Uint8Array(He), ze.next_out = 0, ze.avail_out = He), (De === B || De === D) && ze.avail_out <= 6) {
        this.onData(ze.output.subarray(0, ze.next_out)), ze.avail_out = 0;
        continue;
      }
      if (Pe = o.deflate(ze, De), Pe === F)
        return ze.next_out > 0 && this.onData(ze.output.subarray(0, ze.next_out)), Pe = o.deflateEnd(this.strm), this.onEnd(Pe), this.ended = !0, Pe === v;
      if (ze.avail_out === 0) {
        this.onData(ze.output);
        continue;
      }
      if (De > 0 && ze.next_out > 0) {
        this.onData(ze.output.subarray(0, ze.next_out)), ze.avail_out = 0;
        continue;
      }
      if (ze.avail_in === 0) break;
    }
    return !0;
  }, H.prototype.onData = function(Ee) {
    this.chunks.push(Ee);
  }, H.prototype.onEnd = function(Ee) {
    Ee === v && (this.result = g.flattenChunks(this.chunks)), this.chunks = [], this.err = Ee, this.msg = this.strm.msg;
  };
  function fe(Ee, Se) {
    const ze = new H(Se);
    if (ze.push(Ee, !0), ze.err)
      throw ze.msg || y[ze.err];
    return ze.result;
  }
  function ge(Ee, Se) {
    return Se = Se || {}, Se.raw = !0, fe(Ee, Se);
  }
  function Ie(Ee, Se) {
    return Se = Se || {}, Se.gzip = !0, fe(Ee, Se);
  }
  return deflate$1.Deflate = H, deflate$1.deflate = fe, deflate$1.deflateRaw = ge, deflate$1.gzip = Ie, deflate$1.constants = requireConstants$3(), deflate$1;
}
var inflate$1 = {}, inflate = {}, inffast, hasRequiredInffast;
function requireInffast() {
  if (hasRequiredInffast) return inffast;
  hasRequiredInffast = 1;
  const o = 16209, g = 16191;
  return inffast = function(y, t) {
    let d, E, B, D, x, v, F, M, U, L, H, fe, ge, Ie, Ee, Se, ze, He, Pe, De, ve, Fe, be, Be;
    const ke = y.state;
    d = y.next_in, be = y.input, E = d + (y.avail_in - 5), B = y.next_out, Be = y.output, D = B - (t - y.avail_out), x = B + (y.avail_out - 257), v = ke.dmax, F = ke.wsize, M = ke.whave, U = ke.wnext, L = ke.window, H = ke.hold, fe = ke.bits, ge = ke.lencode, Ie = ke.distcode, Ee = (1 << ke.lenbits) - 1, Se = (1 << ke.distbits) - 1;
    e:
      do {
        fe < 15 && (H += be[d++] << fe, fe += 8, H += be[d++] << fe, fe += 8), ze = ge[H & Ee];
        t:
          for (; ; ) {
            if (He = ze >>> 24, H >>>= He, fe -= He, He = ze >>> 16 & 255, He === 0)
              Be[B++] = ze & 65535;
            else if (He & 16) {
              Pe = ze & 65535, He &= 15, He && (fe < He && (H += be[d++] << fe, fe += 8), Pe += H & (1 << He) - 1, H >>>= He, fe -= He), fe < 15 && (H += be[d++] << fe, fe += 8, H += be[d++] << fe, fe += 8), ze = Ie[H & Se];
              r:
                for (; ; ) {
                  if (He = ze >>> 24, H >>>= He, fe -= He, He = ze >>> 16 & 255, He & 16) {
                    if (De = ze & 65535, He &= 15, fe < He && (H += be[d++] << fe, fe += 8, fe < He && (H += be[d++] << fe, fe += 8)), De += H & (1 << He) - 1, De > v) {
                      y.msg = "invalid distance too far back", ke.mode = o;
                      break e;
                    }
                    if (H >>>= He, fe -= He, He = B - D, De > He) {
                      if (He = De - He, He > M && ke.sane) {
                        y.msg = "invalid distance too far back", ke.mode = o;
                        break e;
                      }
                      if (ve = 0, Fe = L, U === 0) {
                        if (ve += F - He, He < Pe) {
                          Pe -= He;
                          do
                            Be[B++] = L[ve++];
                          while (--He);
                          ve = B - De, Fe = Be;
                        }
                      } else if (U < He) {
                        if (ve += F + U - He, He -= U, He < Pe) {
                          Pe -= He;
                          do
                            Be[B++] = L[ve++];
                          while (--He);
                          if (ve = 0, U < Pe) {
                            He = U, Pe -= He;
                            do
                              Be[B++] = L[ve++];
                            while (--He);
                            ve = B - De, Fe = Be;
                          }
                        }
                      } else if (ve += U - He, He < Pe) {
                        Pe -= He;
                        do
                          Be[B++] = L[ve++];
                        while (--He);
                        ve = B - De, Fe = Be;
                      }
                      for (; Pe > 2; )
                        Be[B++] = Fe[ve++], Be[B++] = Fe[ve++], Be[B++] = Fe[ve++], Pe -= 3;
                      Pe && (Be[B++] = Fe[ve++], Pe > 1 && (Be[B++] = Fe[ve++]));
                    } else {
                      ve = B - De;
                      do
                        Be[B++] = Be[ve++], Be[B++] = Be[ve++], Be[B++] = Be[ve++], Pe -= 3;
                      while (Pe > 2);
                      Pe && (Be[B++] = Be[ve++], Pe > 1 && (Be[B++] = Be[ve++]));
                    }
                  } else if ((He & 64) === 0) {
                    ze = Ie[(ze & 65535) + (H & (1 << He) - 1)];
                    continue r;
                  } else {
                    y.msg = "invalid distance code", ke.mode = o;
                    break e;
                  }
                  break;
                }
            } else if ((He & 64) === 0) {
              ze = ge[(ze & 65535) + (H & (1 << He) - 1)];
              continue t;
            } else if (He & 32) {
              ke.mode = g;
              break e;
            } else {
              y.msg = "invalid literal/length code", ke.mode = o;
              break e;
            }
            break;
          }
      } while (d < E && B < x);
    Pe = fe >> 3, d -= Pe, fe -= Pe << 3, H &= (1 << fe) - 1, y.next_in = d, y.next_out = B, y.avail_in = d < E ? 5 + (E - d) : 5 - (d - E), y.avail_out = B < x ? 257 + (x - B) : 257 - (B - x), ke.hold = H, ke.bits = fe;
  }, inffast;
}
var inftrees, hasRequiredInftrees;
function requireInftrees() {
  if (hasRequiredInftrees) return inftrees;
  hasRequiredInftrees = 1;
  const o = 15, g = 852, c = 592, y = 0, t = 1, d = 2, E = new Uint16Array([
    /* Length codes 257..285 base */
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    13,
    15,
    17,
    19,
    23,
    27,
    31,
    35,
    43,
    51,
    59,
    67,
    83,
    99,
    115,
    131,
    163,
    195,
    227,
    258,
    0,
    0
  ]), B = new Uint8Array([
    /* Length codes 257..285 extra */
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    17,
    17,
    17,
    17,
    18,
    18,
    18,
    18,
    19,
    19,
    19,
    19,
    20,
    20,
    20,
    20,
    21,
    21,
    21,
    21,
    16,
    72,
    78
  ]), D = new Uint16Array([
    /* Distance codes 0..29 base */
    1,
    2,
    3,
    4,
    5,
    7,
    9,
    13,
    17,
    25,
    33,
    49,
    65,
    97,
    129,
    193,
    257,
    385,
    513,
    769,
    1025,
    1537,
    2049,
    3073,
    4097,
    6145,
    8193,
    12289,
    16385,
    24577,
    0,
    0
  ]), x = new Uint8Array([
    /* Distance codes 0..29 extra */
    16,
    16,
    16,
    16,
    17,
    17,
    18,
    18,
    19,
    19,
    20,
    20,
    21,
    21,
    22,
    22,
    23,
    23,
    24,
    24,
    25,
    25,
    26,
    26,
    27,
    27,
    28,
    28,
    29,
    29,
    64,
    64
  ]);
  return inftrees = (F, M, U, L, H, fe, ge, Ie) => {
    const Ee = Ie.bits;
    let Se = 0, ze = 0, He = 0, Pe = 0, De = 0, ve = 0, Fe = 0, be = 0, Be = 0, ke = 0, xe, Ne, Et, st, Dt, er = null, xt;
    const ir = new Uint16Array(o + 1), sr = new Uint16Array(o + 1);
    let yr = null, wr, qr, Mr;
    for (Se = 0; Se <= o; Se++)
      ir[Se] = 0;
    for (ze = 0; ze < L; ze++)
      ir[M[U + ze]]++;
    for (De = Ee, Pe = o; Pe >= 1 && ir[Pe] === 0; Pe--)
      ;
    if (De > Pe && (De = Pe), Pe === 0)
      return H[fe++] = 1 << 24 | 64 << 16 | 0, H[fe++] = 1 << 24 | 64 << 16 | 0, Ie.bits = 1, 0;
    for (He = 1; He < Pe && ir[He] === 0; He++)
      ;
    for (De < He && (De = He), be = 1, Se = 1; Se <= o; Se++)
      if (be <<= 1, be -= ir[Se], be < 0)
        return -1;
    if (be > 0 && (F === y || Pe !== 1))
      return -1;
    for (sr[1] = 0, Se = 1; Se < o; Se++)
      sr[Se + 1] = sr[Se] + ir[Se];
    for (ze = 0; ze < L; ze++)
      M[U + ze] !== 0 && (ge[sr[M[U + ze]]++] = ze);
    if (F === y ? (er = yr = ge, xt = 20) : F === t ? (er = E, yr = B, xt = 257) : (er = D, yr = x, xt = 0), ke = 0, ze = 0, Se = He, Dt = fe, ve = De, Fe = 0, Et = -1, Be = 1 << De, st = Be - 1, F === t && Be > g || F === d && Be > c)
      return 1;
    for (; ; ) {
      wr = Se - Fe, ge[ze] + 1 < xt ? (qr = 0, Mr = ge[ze]) : ge[ze] >= xt ? (qr = yr[ge[ze] - xt], Mr = er[ge[ze] - xt]) : (qr = 96, Mr = 0), xe = 1 << Se - Fe, Ne = 1 << ve, He = Ne;
      do
        Ne -= xe, H[Dt + (ke >> Fe) + Ne] = wr << 24 | qr << 16 | Mr | 0;
      while (Ne !== 0);
      for (xe = 1 << Se - 1; ke & xe; )
        xe >>= 1;
      if (xe !== 0 ? (ke &= xe - 1, ke += xe) : ke = 0, ze++, --ir[Se] === 0) {
        if (Se === Pe)
          break;
        Se = M[U + ge[ze]];
      }
      if (Se > De && (ke & st) !== Et) {
        for (Fe === 0 && (Fe = De), Dt += He, ve = Se - Fe, be = 1 << ve; ve + Fe < Pe && (be -= ir[ve + Fe], !(be <= 0)); )
          ve++, be <<= 1;
        if (Be += 1 << ve, F === t && Be > g || F === d && Be > c)
          return 1;
        Et = ke & st, H[Et] = De << 24 | ve << 16 | Dt - fe | 0;
      }
    }
    return ke !== 0 && (H[Dt + ke] = Se - Fe << 24 | 64 << 16 | 0), Ie.bits = De, 0;
  }, inftrees;
}
var hasRequiredInflate$1;
function requireInflate$1() {
  if (hasRequiredInflate$1) return inflate;
  hasRequiredInflate$1 = 1;
  const o = requireAdler32(), g = requireCrc32(), c = requireInffast(), y = requireInftrees(), t = 0, d = 1, E = 2, {
    Z_FINISH: B,
    Z_BLOCK: D,
    Z_TREES: x,
    Z_OK: v,
    Z_STREAM_END: F,
    Z_NEED_DICT: M,
    Z_STREAM_ERROR: U,
    Z_DATA_ERROR: L,
    Z_MEM_ERROR: H,
    Z_BUF_ERROR: fe,
    Z_DEFLATED: ge
  } = requireConstants$3(), Ie = 16180, Ee = 16181, Se = 16182, ze = 16183, He = 16184, Pe = 16185, De = 16186, ve = 16187, Fe = 16188, be = 16189, Be = 16190, ke = 16191, xe = 16192, Ne = 16193, Et = 16194, st = 16195, Dt = 16196, er = 16197, xt = 16198, ir = 16199, sr = 16200, yr = 16201, wr = 16202, qr = 16203, Mr = 16204, Dr = 16205, Qr = 16206, Xr = 16207, Vr = 16208, Ur = 16209, Sr = 16210, Gr = 16211, Fr = 852, br = 592, cr = 15, hr = (bi) => (bi >>> 24 & 255) + (bi >>> 8 & 65280) + ((bi & 65280) << 8) + ((bi & 255) << 24);
  function Wr() {
    this.strm = null, this.mode = 0, this.last = !1, this.wrap = 0, this.havedict = !1, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new Uint16Array(320), this.work = new Uint16Array(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
  }
  const fi = (bi) => {
    if (!bi)
      return 1;
    const Ri = bi.state;
    return !Ri || Ri.strm !== bi || Ri.mode < Ie || Ri.mode > Gr ? 1 : 0;
  }, Bi = (bi) => {
    if (fi(bi))
      return U;
    const Ri = bi.state;
    return bi.total_in = bi.total_out = Ri.total = 0, bi.msg = "", Ri.wrap && (bi.adler = Ri.wrap & 1), Ri.mode = Ie, Ri.last = 0, Ri.havedict = 0, Ri.flags = -1, Ri.dmax = 32768, Ri.head = null, Ri.hold = 0, Ri.bits = 0, Ri.lencode = Ri.lendyn = new Int32Array(Fr), Ri.distcode = Ri.distdyn = new Int32Array(br), Ri.sane = 1, Ri.back = -1, v;
  }, $r = (bi) => {
    if (fi(bi))
      return U;
    const Ri = bi.state;
    return Ri.wsize = 0, Ri.whave = 0, Ri.wnext = 0, Bi(bi);
  }, oi = (bi, Ri) => {
    let li;
    if (fi(bi))
      return U;
    const zi = bi.state;
    return Ri < 0 ? (li = 0, Ri = -Ri) : (li = (Ri >> 4) + 5, Ri < 48 && (Ri &= 15)), Ri && (Ri < 8 || Ri > 15) ? U : (zi.window !== null && zi.wbits !== Ri && (zi.window = null), zi.wrap = li, zi.wbits = Ri, $r(bi));
  }, zr = (bi, Ri) => {
    if (!bi)
      return U;
    const li = new Wr();
    bi.state = li, li.strm = bi, li.window = null, li.mode = Ie;
    const zi = oi(bi, Ri);
    return zi !== v && (bi.state = null), zi;
  }, ti = (bi) => zr(bi, cr);
  let Lr = !0, Rr, Ir;
  const pr = (bi) => {
    if (Lr) {
      Rr = new Int32Array(512), Ir = new Int32Array(32);
      let Ri = 0;
      for (; Ri < 144; )
        bi.lens[Ri++] = 8;
      for (; Ri < 256; )
        bi.lens[Ri++] = 9;
      for (; Ri < 280; )
        bi.lens[Ri++] = 7;
      for (; Ri < 288; )
        bi.lens[Ri++] = 8;
      for (y(d, bi.lens, 0, 288, Rr, 0, bi.work, { bits: 9 }), Ri = 0; Ri < 32; )
        bi.lens[Ri++] = 5;
      y(E, bi.lens, 0, 32, Ir, 0, bi.work, { bits: 5 }), Lr = !1;
    }
    bi.lencode = Rr, bi.lenbits = 9, bi.distcode = Ir, bi.distbits = 5;
  }, Cr = (bi, Ri, li, zi) => {
    let Kn;
    const Hn = bi.state;
    return Hn.window === null && (Hn.wsize = 1 << Hn.wbits, Hn.wnext = 0, Hn.whave = 0, Hn.window = new Uint8Array(Hn.wsize)), zi >= Hn.wsize ? (Hn.window.set(Ri.subarray(li - Hn.wsize, li), 0), Hn.wnext = 0, Hn.whave = Hn.wsize) : (Kn = Hn.wsize - Hn.wnext, Kn > zi && (Kn = zi), Hn.window.set(Ri.subarray(li - zi, li - zi + Kn), Hn.wnext), zi -= Kn, zi ? (Hn.window.set(Ri.subarray(li - zi, li), 0), Hn.wnext = zi, Hn.whave = Hn.wsize) : (Hn.wnext += Kn, Hn.wnext === Hn.wsize && (Hn.wnext = 0), Hn.whave < Hn.wsize && (Hn.whave += Kn))), 0;
  }, Er = (bi, Ri) => {
    let li, zi, Kn, Hn, os, ts, Gs, Wn, Gn, ro, Fs, ii, Ai, ci, Si = 0, Ui, _i, Tn, Fn, ss, rs, is, Pr;
    const as = new Uint8Array(4);
    let Rs, ri;
    const Tr = (
      /* permutation of code lengths */
      new Uint8Array([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15])
    );
    if (fi(bi) || !bi.output || !bi.input && bi.avail_in !== 0)
      return U;
    li = bi.state, li.mode === ke && (li.mode = xe), os = bi.next_out, Kn = bi.output, Gs = bi.avail_out, Hn = bi.next_in, zi = bi.input, ts = bi.avail_in, Wn = li.hold, Gn = li.bits, ro = ts, Fs = Gs, Pr = v;
    e:
      for (; ; )
        switch (li.mode) {
          case Ie:
            if (li.wrap === 0) {
              li.mode = xe;
              break;
            }
            for (; Gn < 16; ) {
              if (ts === 0)
                break e;
              ts--, Wn += zi[Hn++] << Gn, Gn += 8;
            }
            if (li.wrap & 2 && Wn === 35615) {
              li.wbits === 0 && (li.wbits = 15), li.check = 0, as[0] = Wn & 255, as[1] = Wn >>> 8 & 255, li.check = g(li.check, as, 2, 0), Wn = 0, Gn = 0, li.mode = Ee;
              break;
            }
            if (li.head && (li.head.done = !1), !(li.wrap & 1) || /* check if zlib header allowed */
            (((Wn & 255) << 8) + (Wn >> 8)) % 31) {
              bi.msg = "incorrect header check", li.mode = Ur;
              break;
            }
            if ((Wn & 15) !== ge) {
              bi.msg = "unknown compression method", li.mode = Ur;
              break;
            }
            if (Wn >>>= 4, Gn -= 4, is = (Wn & 15) + 8, li.wbits === 0 && (li.wbits = is), is > 15 || is > li.wbits) {
              bi.msg = "invalid window size", li.mode = Ur;
              break;
            }
            li.dmax = 1 << li.wbits, li.flags = 0, bi.adler = li.check = 1, li.mode = Wn & 512 ? be : ke, Wn = 0, Gn = 0;
            break;
          case Ee:
            for (; Gn < 16; ) {
              if (ts === 0)
                break e;
              ts--, Wn += zi[Hn++] << Gn, Gn += 8;
            }
            if (li.flags = Wn, (li.flags & 255) !== ge) {
              bi.msg = "unknown compression method", li.mode = Ur;
              break;
            }
            if (li.flags & 57344) {
              bi.msg = "unknown header flags set", li.mode = Ur;
              break;
            }
            li.head && (li.head.text = Wn >> 8 & 1), li.flags & 512 && li.wrap & 4 && (as[0] = Wn & 255, as[1] = Wn >>> 8 & 255, li.check = g(li.check, as, 2, 0)), Wn = 0, Gn = 0, li.mode = Se;
          /* falls through */
          case Se:
            for (; Gn < 32; ) {
              if (ts === 0)
                break e;
              ts--, Wn += zi[Hn++] << Gn, Gn += 8;
            }
            li.head && (li.head.time = Wn), li.flags & 512 && li.wrap & 4 && (as[0] = Wn & 255, as[1] = Wn >>> 8 & 255, as[2] = Wn >>> 16 & 255, as[3] = Wn >>> 24 & 255, li.check = g(li.check, as, 4, 0)), Wn = 0, Gn = 0, li.mode = ze;
          /* falls through */
          case ze:
            for (; Gn < 16; ) {
              if (ts === 0)
                break e;
              ts--, Wn += zi[Hn++] << Gn, Gn += 8;
            }
            li.head && (li.head.xflags = Wn & 255, li.head.os = Wn >> 8), li.flags & 512 && li.wrap & 4 && (as[0] = Wn & 255, as[1] = Wn >>> 8 & 255, li.check = g(li.check, as, 2, 0)), Wn = 0, Gn = 0, li.mode = He;
          /* falls through */
          case He:
            if (li.flags & 1024) {
              for (; Gn < 16; ) {
                if (ts === 0)
                  break e;
                ts--, Wn += zi[Hn++] << Gn, Gn += 8;
              }
              li.length = Wn, li.head && (li.head.extra_len = Wn), li.flags & 512 && li.wrap & 4 && (as[0] = Wn & 255, as[1] = Wn >>> 8 & 255, li.check = g(li.check, as, 2, 0)), Wn = 0, Gn = 0;
            } else li.head && (li.head.extra = null);
            li.mode = Pe;
          /* falls through */
          case Pe:
            if (li.flags & 1024 && (ii = li.length, ii > ts && (ii = ts), ii && (li.head && (is = li.head.extra_len - li.length, li.head.extra || (li.head.extra = new Uint8Array(li.head.extra_len)), li.head.extra.set(
              zi.subarray(
                Hn,
                // extra field is limited to 65536 bytes
                // - no need for additional size check
                Hn + ii
              ),
              /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/
              is
            )), li.flags & 512 && li.wrap & 4 && (li.check = g(li.check, zi, ii, Hn)), ts -= ii, Hn += ii, li.length -= ii), li.length))
              break e;
            li.length = 0, li.mode = De;
          /* falls through */
          case De:
            if (li.flags & 2048) {
              if (ts === 0)
                break e;
              ii = 0;
              do
                is = zi[Hn + ii++], li.head && is && li.length < 65536 && (li.head.name += String.fromCharCode(is));
              while (is && ii < ts);
              if (li.flags & 512 && li.wrap & 4 && (li.check = g(li.check, zi, ii, Hn)), ts -= ii, Hn += ii, is)
                break e;
            } else li.head && (li.head.name = null);
            li.length = 0, li.mode = ve;
          /* falls through */
          case ve:
            if (li.flags & 4096) {
              if (ts === 0)
                break e;
              ii = 0;
              do
                is = zi[Hn + ii++], li.head && is && li.length < 65536 && (li.head.comment += String.fromCharCode(is));
              while (is && ii < ts);
              if (li.flags & 512 && li.wrap & 4 && (li.check = g(li.check, zi, ii, Hn)), ts -= ii, Hn += ii, is)
                break e;
            } else li.head && (li.head.comment = null);
            li.mode = Fe;
          /* falls through */
          case Fe:
            if (li.flags & 512) {
              for (; Gn < 16; ) {
                if (ts === 0)
                  break e;
                ts--, Wn += zi[Hn++] << Gn, Gn += 8;
              }
              if (li.wrap & 4 && Wn !== (li.check & 65535)) {
                bi.msg = "header crc mismatch", li.mode = Ur;
                break;
              }
              Wn = 0, Gn = 0;
            }
            li.head && (li.head.hcrc = li.flags >> 9 & 1, li.head.done = !0), bi.adler = li.check = 0, li.mode = ke;
            break;
          case be:
            for (; Gn < 32; ) {
              if (ts === 0)
                break e;
              ts--, Wn += zi[Hn++] << Gn, Gn += 8;
            }
            bi.adler = li.check = hr(Wn), Wn = 0, Gn = 0, li.mode = Be;
          /* falls through */
          case Be:
            if (li.havedict === 0)
              return bi.next_out = os, bi.avail_out = Gs, bi.next_in = Hn, bi.avail_in = ts, li.hold = Wn, li.bits = Gn, M;
            bi.adler = li.check = 1, li.mode = ke;
          /* falls through */
          case ke:
            if (Ri === D || Ri === x)
              break e;
          /* falls through */
          case xe:
            if (li.last) {
              Wn >>>= Gn & 7, Gn -= Gn & 7, li.mode = Qr;
              break;
            }
            for (; Gn < 3; ) {
              if (ts === 0)
                break e;
              ts--, Wn += zi[Hn++] << Gn, Gn += 8;
            }
            switch (li.last = Wn & 1, Wn >>>= 1, Gn -= 1, Wn & 3) {
              case 0:
                li.mode = Ne;
                break;
              case 1:
                if (pr(li), li.mode = ir, Ri === x) {
                  Wn >>>= 2, Gn -= 2;
                  break e;
                }
                break;
              case 2:
                li.mode = Dt;
                break;
              case 3:
                bi.msg = "invalid block type", li.mode = Ur;
            }
            Wn >>>= 2, Gn -= 2;
            break;
          case Ne:
            for (Wn >>>= Gn & 7, Gn -= Gn & 7; Gn < 32; ) {
              if (ts === 0)
                break e;
              ts--, Wn += zi[Hn++] << Gn, Gn += 8;
            }
            if ((Wn & 65535) !== (Wn >>> 16 ^ 65535)) {
              bi.msg = "invalid stored block lengths", li.mode = Ur;
              break;
            }
            if (li.length = Wn & 65535, Wn = 0, Gn = 0, li.mode = Et, Ri === x)
              break e;
          /* falls through */
          case Et:
            li.mode = st;
          /* falls through */
          case st:
            if (ii = li.length, ii) {
              if (ii > ts && (ii = ts), ii > Gs && (ii = Gs), ii === 0)
                break e;
              Kn.set(zi.subarray(Hn, Hn + ii), os), ts -= ii, Hn += ii, Gs -= ii, os += ii, li.length -= ii;
              break;
            }
            li.mode = ke;
            break;
          case Dt:
            for (; Gn < 14; ) {
              if (ts === 0)
                break e;
              ts--, Wn += zi[Hn++] << Gn, Gn += 8;
            }
            if (li.nlen = (Wn & 31) + 257, Wn >>>= 5, Gn -= 5, li.ndist = (Wn & 31) + 1, Wn >>>= 5, Gn -= 5, li.ncode = (Wn & 15) + 4, Wn >>>= 4, Gn -= 4, li.nlen > 286 || li.ndist > 30) {
              bi.msg = "too many length or distance symbols", li.mode = Ur;
              break;
            }
            li.have = 0, li.mode = er;
          /* falls through */
          case er:
            for (; li.have < li.ncode; ) {
              for (; Gn < 3; ) {
                if (ts === 0)
                  break e;
                ts--, Wn += zi[Hn++] << Gn, Gn += 8;
              }
              li.lens[Tr[li.have++]] = Wn & 7, Wn >>>= 3, Gn -= 3;
            }
            for (; li.have < 19; )
              li.lens[Tr[li.have++]] = 0;
            if (li.lencode = li.lendyn, li.lenbits = 7, Rs = { bits: li.lenbits }, Pr = y(t, li.lens, 0, 19, li.lencode, 0, li.work, Rs), li.lenbits = Rs.bits, Pr) {
              bi.msg = "invalid code lengths set", li.mode = Ur;
              break;
            }
            li.have = 0, li.mode = xt;
          /* falls through */
          case xt:
            for (; li.have < li.nlen + li.ndist; ) {
              for (; Si = li.lencode[Wn & (1 << li.lenbits) - 1], Ui = Si >>> 24, _i = Si >>> 16 & 255, Tn = Si & 65535, !(Ui <= Gn); ) {
                if (ts === 0)
                  break e;
                ts--, Wn += zi[Hn++] << Gn, Gn += 8;
              }
              if (Tn < 16)
                Wn >>>= Ui, Gn -= Ui, li.lens[li.have++] = Tn;
              else {
                if (Tn === 16) {
                  for (ri = Ui + 2; Gn < ri; ) {
                    if (ts === 0)
                      break e;
                    ts--, Wn += zi[Hn++] << Gn, Gn += 8;
                  }
                  if (Wn >>>= Ui, Gn -= Ui, li.have === 0) {
                    bi.msg = "invalid bit length repeat", li.mode = Ur;
                    break;
                  }
                  is = li.lens[li.have - 1], ii = 3 + (Wn & 3), Wn >>>= 2, Gn -= 2;
                } else if (Tn === 17) {
                  for (ri = Ui + 3; Gn < ri; ) {
                    if (ts === 0)
                      break e;
                    ts--, Wn += zi[Hn++] << Gn, Gn += 8;
                  }
                  Wn >>>= Ui, Gn -= Ui, is = 0, ii = 3 + (Wn & 7), Wn >>>= 3, Gn -= 3;
                } else {
                  for (ri = Ui + 7; Gn < ri; ) {
                    if (ts === 0)
                      break e;
                    ts--, Wn += zi[Hn++] << Gn, Gn += 8;
                  }
                  Wn >>>= Ui, Gn -= Ui, is = 0, ii = 11 + (Wn & 127), Wn >>>= 7, Gn -= 7;
                }
                if (li.have + ii > li.nlen + li.ndist) {
                  bi.msg = "invalid bit length repeat", li.mode = Ur;
                  break;
                }
                for (; ii--; )
                  li.lens[li.have++] = is;
              }
            }
            if (li.mode === Ur)
              break;
            if (li.lens[256] === 0) {
              bi.msg = "invalid code -- missing end-of-block", li.mode = Ur;
              break;
            }
            if (li.lenbits = 9, Rs = { bits: li.lenbits }, Pr = y(d, li.lens, 0, li.nlen, li.lencode, 0, li.work, Rs), li.lenbits = Rs.bits, Pr) {
              bi.msg = "invalid literal/lengths set", li.mode = Ur;
              break;
            }
            if (li.distbits = 6, li.distcode = li.distdyn, Rs = { bits: li.distbits }, Pr = y(E, li.lens, li.nlen, li.ndist, li.distcode, 0, li.work, Rs), li.distbits = Rs.bits, Pr) {
              bi.msg = "invalid distances set", li.mode = Ur;
              break;
            }
            if (li.mode = ir, Ri === x)
              break e;
          /* falls through */
          case ir:
            li.mode = sr;
          /* falls through */
          case sr:
            if (ts >= 6 && Gs >= 258) {
              bi.next_out = os, bi.avail_out = Gs, bi.next_in = Hn, bi.avail_in = ts, li.hold = Wn, li.bits = Gn, c(bi, Fs), os = bi.next_out, Kn = bi.output, Gs = bi.avail_out, Hn = bi.next_in, zi = bi.input, ts = bi.avail_in, Wn = li.hold, Gn = li.bits, li.mode === ke && (li.back = -1);
              break;
            }
            for (li.back = 0; Si = li.lencode[Wn & (1 << li.lenbits) - 1], Ui = Si >>> 24, _i = Si >>> 16 & 255, Tn = Si & 65535, !(Ui <= Gn); ) {
              if (ts === 0)
                break e;
              ts--, Wn += zi[Hn++] << Gn, Gn += 8;
            }
            if (_i && (_i & 240) === 0) {
              for (Fn = Ui, ss = _i, rs = Tn; Si = li.lencode[rs + ((Wn & (1 << Fn + ss) - 1) >> Fn)], Ui = Si >>> 24, _i = Si >>> 16 & 255, Tn = Si & 65535, !(Fn + Ui <= Gn); ) {
                if (ts === 0)
                  break e;
                ts--, Wn += zi[Hn++] << Gn, Gn += 8;
              }
              Wn >>>= Fn, Gn -= Fn, li.back += Fn;
            }
            if (Wn >>>= Ui, Gn -= Ui, li.back += Ui, li.length = Tn, _i === 0) {
              li.mode = Dr;
              break;
            }
            if (_i & 32) {
              li.back = -1, li.mode = ke;
              break;
            }
            if (_i & 64) {
              bi.msg = "invalid literal/length code", li.mode = Ur;
              break;
            }
            li.extra = _i & 15, li.mode = yr;
          /* falls through */
          case yr:
            if (li.extra) {
              for (ri = li.extra; Gn < ri; ) {
                if (ts === 0)
                  break e;
                ts--, Wn += zi[Hn++] << Gn, Gn += 8;
              }
              li.length += Wn & (1 << li.extra) - 1, Wn >>>= li.extra, Gn -= li.extra, li.back += li.extra;
            }
            li.was = li.length, li.mode = wr;
          /* falls through */
          case wr:
            for (; Si = li.distcode[Wn & (1 << li.distbits) - 1], Ui = Si >>> 24, _i = Si >>> 16 & 255, Tn = Si & 65535, !(Ui <= Gn); ) {
              if (ts === 0)
                break e;
              ts--, Wn += zi[Hn++] << Gn, Gn += 8;
            }
            if ((_i & 240) === 0) {
              for (Fn = Ui, ss = _i, rs = Tn; Si = li.distcode[rs + ((Wn & (1 << Fn + ss) - 1) >> Fn)], Ui = Si >>> 24, _i = Si >>> 16 & 255, Tn = Si & 65535, !(Fn + Ui <= Gn); ) {
                if (ts === 0)
                  break e;
                ts--, Wn += zi[Hn++] << Gn, Gn += 8;
              }
              Wn >>>= Fn, Gn -= Fn, li.back += Fn;
            }
            if (Wn >>>= Ui, Gn -= Ui, li.back += Ui, _i & 64) {
              bi.msg = "invalid distance code", li.mode = Ur;
              break;
            }
            li.offset = Tn, li.extra = _i & 15, li.mode = qr;
          /* falls through */
          case qr:
            if (li.extra) {
              for (ri = li.extra; Gn < ri; ) {
                if (ts === 0)
                  break e;
                ts--, Wn += zi[Hn++] << Gn, Gn += 8;
              }
              li.offset += Wn & (1 << li.extra) - 1, Wn >>>= li.extra, Gn -= li.extra, li.back += li.extra;
            }
            if (li.offset > li.dmax) {
              bi.msg = "invalid distance too far back", li.mode = Ur;
              break;
            }
            li.mode = Mr;
          /* falls through */
          case Mr:
            if (Gs === 0)
              break e;
            if (ii = Fs - Gs, li.offset > ii) {
              if (ii = li.offset - ii, ii > li.whave && li.sane) {
                bi.msg = "invalid distance too far back", li.mode = Ur;
                break;
              }
              ii > li.wnext ? (ii -= li.wnext, Ai = li.wsize - ii) : Ai = li.wnext - ii, ii > li.length && (ii = li.length), ci = li.window;
            } else
              ci = Kn, Ai = os - li.offset, ii = li.length;
            ii > Gs && (ii = Gs), Gs -= ii, li.length -= ii;
            do
              Kn[os++] = ci[Ai++];
            while (--ii);
            li.length === 0 && (li.mode = sr);
            break;
          case Dr:
            if (Gs === 0)
              break e;
            Kn[os++] = li.length, Gs--, li.mode = sr;
            break;
          case Qr:
            if (li.wrap) {
              for (; Gn < 32; ) {
                if (ts === 0)
                  break e;
                ts--, Wn |= zi[Hn++] << Gn, Gn += 8;
              }
              if (Fs -= Gs, bi.total_out += Fs, li.total += Fs, li.wrap & 4 && Fs && (bi.adler = li.check = /*UPDATE_CHECK(state.check, put - _out, _out);*/
              li.flags ? g(li.check, Kn, Fs, os - Fs) : o(li.check, Kn, Fs, os - Fs)), Fs = Gs, li.wrap & 4 && (li.flags ? Wn : hr(Wn)) !== li.check) {
                bi.msg = "incorrect data check", li.mode = Ur;
                break;
              }
              Wn = 0, Gn = 0;
            }
            li.mode = Xr;
          /* falls through */
          case Xr:
            if (li.wrap && li.flags) {
              for (; Gn < 32; ) {
                if (ts === 0)
                  break e;
                ts--, Wn += zi[Hn++] << Gn, Gn += 8;
              }
              if (li.wrap & 4 && Wn !== (li.total & 4294967295)) {
                bi.msg = "incorrect length check", li.mode = Ur;
                break;
              }
              Wn = 0, Gn = 0;
            }
            li.mode = Vr;
          /* falls through */
          case Vr:
            Pr = F;
            break e;
          case Ur:
            Pr = L;
            break e;
          case Sr:
            return H;
          case Gr:
          /* falls through */
          default:
            return U;
        }
    return bi.next_out = os, bi.avail_out = Gs, bi.next_in = Hn, bi.avail_in = ts, li.hold = Wn, li.bits = Gn, (li.wsize || Fs !== bi.avail_out && li.mode < Ur && (li.mode < Qr || Ri !== B)) && Cr(bi, bi.output, bi.next_out, Fs - bi.avail_out), ro -= bi.avail_in, Fs -= bi.avail_out, bi.total_in += ro, bi.total_out += Fs, li.total += Fs, li.wrap & 4 && Fs && (bi.adler = li.check = /*UPDATE_CHECK(state.check, strm.next_out - _out, _out);*/
    li.flags ? g(li.check, Kn, Fs, bi.next_out - Fs) : o(li.check, Kn, Fs, bi.next_out - Fs)), bi.data_type = li.bits + (li.last ? 64 : 0) + (li.mode === ke ? 128 : 0) + (li.mode === ir || li.mode === Et ? 256 : 0), (ro === 0 && Fs === 0 || Ri === B) && Pr === v && (Pr = fe), Pr;
  }, xr = (bi) => {
    if (fi(bi))
      return U;
    let Ri = bi.state;
    return Ri.window && (Ri.window = null), bi.state = null, v;
  }, si = (bi, Ri) => {
    if (fi(bi))
      return U;
    const li = bi.state;
    return (li.wrap & 2) === 0 ? U : (li.head = Ri, Ri.done = !1, v);
  }, Ci = (bi, Ri) => {
    const li = Ri.length;
    let zi, Kn, Hn;
    return fi(bi) || (zi = bi.state, zi.wrap !== 0 && zi.mode !== Be) ? U : zi.mode === Be && (Kn = 1, Kn = o(Kn, Ri, li, 0), Kn !== zi.check) ? L : (Hn = Cr(bi, Ri, li, li), Hn ? (zi.mode = Sr, H) : (zi.havedict = 1, v));
  };
  return inflate.inflateReset = $r, inflate.inflateReset2 = oi, inflate.inflateResetKeep = Bi, inflate.inflateInit = ti, inflate.inflateInit2 = zr, inflate.inflate = Er, inflate.inflateEnd = xr, inflate.inflateGetHeader = si, inflate.inflateSetDictionary = Ci, inflate.inflateInfo = "pako inflate (from Nodeca project)", inflate;
}
var gzheader, hasRequiredGzheader;
function requireGzheader() {
  if (hasRequiredGzheader) return gzheader;
  hasRequiredGzheader = 1;
  function o() {
    this.text = 0, this.time = 0, this.xflags = 0, this.os = 0, this.extra = null, this.extra_len = 0, this.name = "", this.comment = "", this.hcrc = 0, this.done = !1;
  }
  return gzheader = o, gzheader;
}
var hasRequiredInflate;
function requireInflate() {
  if (hasRequiredInflate) return inflate$1;
  hasRequiredInflate = 1;
  const o = requireInflate$1(), g = requireCommon(), c = requireStrings(), y = requireMessages(), t = requireZstream(), d = requireGzheader(), E = Object.prototype.toString, {
    Z_NO_FLUSH: B,
    Z_FINISH: D,
    Z_OK: x,
    Z_STREAM_END: v,
    Z_NEED_DICT: F,
    Z_STREAM_ERROR: M,
    Z_DATA_ERROR: U,
    Z_MEM_ERROR: L
  } = requireConstants$3();
  function H(Ie) {
    this.options = g.assign({
      chunkSize: 1024 * 64,
      windowBits: 15,
      to: ""
    }, Ie || {});
    const Ee = this.options;
    Ee.raw && Ee.windowBits >= 0 && Ee.windowBits < 16 && (Ee.windowBits = -Ee.windowBits, Ee.windowBits === 0 && (Ee.windowBits = -15)), Ee.windowBits >= 0 && Ee.windowBits < 16 && !(Ie && Ie.windowBits) && (Ee.windowBits += 32), Ee.windowBits > 15 && Ee.windowBits < 48 && (Ee.windowBits & 15) === 0 && (Ee.windowBits |= 15), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new t(), this.strm.avail_out = 0;
    let Se = o.inflateInit2(
      this.strm,
      Ee.windowBits
    );
    if (Se !== x)
      throw new Error(y[Se]);
    if (this.header = new d(), o.inflateGetHeader(this.strm, this.header), Ee.dictionary && (typeof Ee.dictionary == "string" ? Ee.dictionary = c.string2buf(Ee.dictionary) : E.call(Ee.dictionary) === "[object ArrayBuffer]" && (Ee.dictionary = new Uint8Array(Ee.dictionary)), Ee.raw && (Se = o.inflateSetDictionary(this.strm, Ee.dictionary), Se !== x)))
      throw new Error(y[Se]);
  }
  H.prototype.push = function(Ie, Ee) {
    const Se = this.strm, ze = this.options.chunkSize, He = this.options.dictionary;
    let Pe, De, ve;
    if (this.ended) return !1;
    for (Ee === ~~Ee ? De = Ee : De = Ee === !0 ? D : B, E.call(Ie) === "[object ArrayBuffer]" ? Se.input = new Uint8Array(Ie) : Se.input = Ie, Se.next_in = 0, Se.avail_in = Se.input.length; ; ) {
      for (Se.avail_out === 0 && (Se.output = new Uint8Array(ze), Se.next_out = 0, Se.avail_out = ze), Pe = o.inflate(Se, De), Pe === F && He && (Pe = o.inflateSetDictionary(Se, He), Pe === x ? Pe = o.inflate(Se, De) : Pe === U && (Pe = F)); Se.avail_in > 0 && Pe === v && Se.state.wrap > 0 && Ie[Se.next_in] !== 0; )
        o.inflateReset(Se), Pe = o.inflate(Se, De);
      switch (Pe) {
        case M:
        case U:
        case F:
        case L:
          return this.onEnd(Pe), this.ended = !0, !1;
      }
      if (ve = Se.avail_out, Se.next_out && (Se.avail_out === 0 || Pe === v))
        if (this.options.to === "string") {
          let Fe = c.utf8border(Se.output, Se.next_out), be = Se.next_out - Fe, Be = c.buf2string(Se.output, Fe);
          Se.next_out = be, Se.avail_out = ze - be, be && Se.output.set(Se.output.subarray(Fe, Fe + be), 0), this.onData(Be);
        } else
          this.onData(Se.output.length === Se.next_out ? Se.output : Se.output.subarray(0, Se.next_out));
      if (!(Pe === x && ve === 0)) {
        if (Pe === v)
          return Pe = o.inflateEnd(this.strm), this.onEnd(Pe), this.ended = !0, !0;
        if (Se.avail_in === 0) break;
      }
    }
    return !0;
  }, H.prototype.onData = function(Ie) {
    this.chunks.push(Ie);
  }, H.prototype.onEnd = function(Ie) {
    Ie === x && (this.options.to === "string" ? this.result = this.chunks.join("") : this.result = g.flattenChunks(this.chunks)), this.chunks = [], this.err = Ie, this.msg = this.strm.msg;
  };
  function fe(Ie, Ee) {
    const Se = new H(Ee);
    if (Se.push(Ie), Se.err) throw Se.msg || y[Se.err];
    return Se.result;
  }
  function ge(Ie, Ee) {
    return Ee = Ee || {}, Ee.raw = !0, fe(Ie, Ee);
  }
  return inflate$1.Inflate = H, inflate$1.inflate = fe, inflate$1.inflateRaw = ge, inflate$1.ungzip = fe, inflate$1.constants = requireConstants$3(), inflate$1;
}
var hasRequiredPako;
function requirePako() {
  if (hasRequiredPako) return pako;
  hasRequiredPako = 1;
  const { Deflate: o, deflate: g, deflateRaw: c, gzip: y } = requireDeflate(), { Inflate: t, inflate: d, inflateRaw: E, ungzip: B } = requireInflate(), D = requireConstants$3();
  return pako.Deflate = o, pako.deflate = g, pako.deflateRaw = c, pako.gzip = y, pako.Inflate = t, pako.inflate = d, pako.inflateRaw = E, pako.ungzip = B, pako.constants = D, pako;
}
var base_pb = {}, payload_pb = {}, transaction_pb = {}, bch_transaction_pb = {}, btc_transaction_pb = {}, hasRequiredBtc_transaction_pb;
function requireBtc_transaction_pb() {
  if (hasRequiredBtc_transaction_pb) return btc_transaction_pb;
  hasRequiredBtc_transaction_pb = 1, Object.defineProperty(btc_transaction_pb, "__esModule", { value: !0 }), btc_transaction_pb.Output = btc_transaction_pb.utxo = btc_transaction_pb.Input = btc_transaction_pb.Omni = btc_transaction_pb.BtcTx = void 0;
  const o = /* @__PURE__ */ requireCjs$3();
  class g extends o.Message {
    constructor(B) {
      super(), this.fee = o.protoInt64.zero, this.dustThreshold = 0, this.memo = "", this.inputs = [], this.outputs = [], o.proto3.util.initPartial(B, this);
    }
    static fromBinary(B, D) {
      return new g().fromBinary(B, D);
    }
    static fromJson(B, D) {
      return new g().fromJson(B, D);
    }
    static fromJsonString(B, D) {
      return new g().fromJsonString(B, D);
    }
    static equals(B, D) {
      return o.proto3.util.equals(g, B, D);
    }
  }
  btc_transaction_pb.BtcTx = g, g.runtime = o.proto3, g.typeName = "protoc.BtcTx", g.fields = o.proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "fee",
      kind: "scalar",
      T: 3
      /* ScalarType.INT64 */
    },
    {
      no: 2,
      name: "dustThreshold",
      kind: "scalar",
      T: 5
      /* ScalarType.INT32 */
    },
    {
      no: 3,
      name: "memo",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 4, name: "inputs", kind: "message", T: y, repeated: !0 },
    { no: 5, name: "outputs", kind: "message", T: d, repeated: !0 },
    { no: 6, name: "omni", kind: "message", T: c }
  ]);
  class c extends o.Message {
    constructor(B) {
      super(), this.to = "", this.changeAddress = "", this.omniAmount = o.protoInt64.zero, this.propertyId = 0, o.proto3.util.initPartial(B, this);
    }
    static fromBinary(B, D) {
      return new c().fromBinary(B, D);
    }
    static fromJson(B, D) {
      return new c().fromJson(B, D);
    }
    static fromJsonString(B, D) {
      return new c().fromJsonString(B, D);
    }
    static equals(B, D) {
      return o.proto3.util.equals(c, B, D);
    }
  }
  btc_transaction_pb.Omni = c, c.runtime = o.proto3, c.typeName = "protoc.Omni", c.fields = o.proto3.util.newFieldList(() => [
    {
      no: 5,
      name: "to",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 6,
      name: "changeAddress",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 7,
      name: "omniAmount",
      kind: "scalar",
      T: 3
      /* ScalarType.INT64 */
    },
    {
      no: 8,
      name: "propertyId",
      kind: "scalar",
      T: 5
      /* ScalarType.INT32 */
    }
  ]);
  class y extends o.Message {
    constructor(B) {
      super(), this.hash = "", this.index = 0, this.ownerKeyPath = "", o.proto3.util.initPartial(B, this);
    }
    static fromBinary(B, D) {
      return new y().fromBinary(B, D);
    }
    static fromJson(B, D) {
      return new y().fromJson(B, D);
    }
    static fromJsonString(B, D) {
      return new y().fromJsonString(B, D);
    }
    static equals(B, D) {
      return o.proto3.util.equals(y, B, D);
    }
  }
  btc_transaction_pb.Input = y, y.runtime = o.proto3, y.typeName = "protoc.Input", y.fields = o.proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "hash",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "index",
      kind: "scalar",
      T: 5
      /* ScalarType.INT32 */
    },
    { no: 3, name: "utxo", kind: "message", T: t },
    {
      no: 4,
      name: "ownerKeyPath",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]);
  class t extends o.Message {
    constructor(B) {
      super(), this.publicKey = "", this.script = "", this.value = o.protoInt64.zero, o.proto3.util.initPartial(B, this);
    }
    static fromBinary(B, D) {
      return new t().fromBinary(B, D);
    }
    static fromJson(B, D) {
      return new t().fromJson(B, D);
    }
    static fromJsonString(B, D) {
      return new t().fromJsonString(B, D);
    }
    static equals(B, D) {
      return o.proto3.util.equals(t, B, D);
    }
  }
  btc_transaction_pb.utxo = t, t.runtime = o.proto3, t.typeName = "protoc.utxo", t.fields = o.proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "publicKey",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "script",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 3,
      name: "value",
      kind: "scalar",
      T: 3
      /* ScalarType.INT64 */
    }
  ]);
  class d extends o.Message {
    constructor(B) {
      super(), this.address = "", this.value = o.protoInt64.zero, this.isChange = !1, this.changeAddressPath = "", o.proto3.util.initPartial(B, this);
    }
    static fromBinary(B, D) {
      return new d().fromBinary(B, D);
    }
    static fromJson(B, D) {
      return new d().fromJson(B, D);
    }
    static fromJsonString(B, D) {
      return new d().fromJsonString(B, D);
    }
    static equals(B, D) {
      return o.proto3.util.equals(d, B, D);
    }
  }
  return btc_transaction_pb.Output = d, d.runtime = o.proto3, d.typeName = "protoc.Output", d.fields = o.proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "address",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "value",
      kind: "scalar",
      T: 3
      /* ScalarType.INT64 */
    },
    {
      no: 3,
      name: "isChange",
      kind: "scalar",
      T: 8
      /* ScalarType.BOOL */
    },
    {
      no: 4,
      name: "changeAddressPath",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]), btc_transaction_pb;
}
var hasRequiredBch_transaction_pb;
function requireBch_transaction_pb() {
  if (hasRequiredBch_transaction_pb) return bch_transaction_pb;
  hasRequiredBch_transaction_pb = 1, Object.defineProperty(bch_transaction_pb, "__esModule", { value: !0 }), bch_transaction_pb.BchTx_Input = bch_transaction_pb.BchTx = void 0;
  const o = /* @__PURE__ */ requireCjs$3(), g = requireBtc_transaction_pb();
  class c extends o.Message {
    constructor(d) {
      super(), this.fee = o.protoInt64.zero, this.dustThreshold = 0, this.memo = "", this.inputs = [], this.outputs = [], o.proto3.util.initPartial(d, this);
    }
    static fromBinary(d, E) {
      return new c().fromBinary(d, E);
    }
    static fromJson(d, E) {
      return new c().fromJson(d, E);
    }
    static fromJsonString(d, E) {
      return new c().fromJsonString(d, E);
    }
    static equals(d, E) {
      return o.proto3.util.equals(c, d, E);
    }
  }
  bch_transaction_pb.BchTx = c, c.runtime = o.proto3, c.typeName = "protoc.BchTx", c.fields = o.proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "fee",
      kind: "scalar",
      T: 3
      /* ScalarType.INT64 */
    },
    {
      no: 2,
      name: "dustThreshold",
      kind: "scalar",
      T: 5
      /* ScalarType.INT32 */
    },
    {
      no: 3,
      name: "memo",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 4, name: "inputs", kind: "message", T: y, repeated: !0 },
    { no: 5, name: "outputs", kind: "message", T: g.Output, repeated: !0 }
  ]);
  class y extends o.Message {
    constructor(d) {
      super(), this.hash = "", this.index = 0, this.value = o.protoInt64.zero, this.pubkey = "", this.ownerKeyPath = "", o.proto3.util.initPartial(d, this);
    }
    static fromBinary(d, E) {
      return new y().fromBinary(d, E);
    }
    static fromJson(d, E) {
      return new y().fromJson(d, E);
    }
    static fromJsonString(d, E) {
      return new y().fromJsonString(d, E);
    }
    static equals(d, E) {
      return o.proto3.util.equals(y, d, E);
    }
  }
  return bch_transaction_pb.BchTx_Input = y, y.runtime = o.proto3, y.typeName = "protoc.BchTx.Input", y.fields = o.proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "hash",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "index",
      kind: "scalar",
      T: 5
      /* ScalarType.INT32 */
    },
    {
      no: 3,
      name: "value",
      kind: "scalar",
      T: 3
      /* ScalarType.INT64 */
    },
    {
      no: 4,
      name: "pubkey",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 5,
      name: "ownerKeyPath",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]), bch_transaction_pb;
}
var dash_transaction_pb = {}, hasRequiredDash_transaction_pb;
function requireDash_transaction_pb() {
  if (hasRequiredDash_transaction_pb) return dash_transaction_pb;
  hasRequiredDash_transaction_pb = 1, Object.defineProperty(dash_transaction_pb, "__esModule", { value: !0 }), dash_transaction_pb.DashTx_Input = dash_transaction_pb.DashTx = void 0;
  const o = /* @__PURE__ */ requireCjs$3(), g = requireBtc_transaction_pb();
  class c extends o.Message {
    constructor(d) {
      super(), this.fee = o.protoInt64.zero, this.dustThreshold = 0, this.memo = "", this.inputs = [], this.outputs = [], o.proto3.util.initPartial(d, this);
    }
    static fromBinary(d, E) {
      return new c().fromBinary(d, E);
    }
    static fromJson(d, E) {
      return new c().fromJson(d, E);
    }
    static fromJsonString(d, E) {
      return new c().fromJsonString(d, E);
    }
    static equals(d, E) {
      return o.proto3.util.equals(c, d, E);
    }
  }
  dash_transaction_pb.DashTx = c, c.runtime = o.proto3, c.typeName = "protoc.DashTx", c.fields = o.proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "fee",
      kind: "scalar",
      T: 3
      /* ScalarType.INT64 */
    },
    {
      no: 2,
      name: "dustThreshold",
      kind: "scalar",
      T: 5
      /* ScalarType.INT32 */
    },
    {
      no: 3,
      name: "memo",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 4, name: "inputs", kind: "message", T: y, repeated: !0 },
    { no: 5, name: "outputs", kind: "message", T: g.Output, repeated: !0 }
  ]);
  class y extends o.Message {
    constructor(d) {
      super(), this.hash = "", this.index = 0, this.value = o.protoInt64.zero, this.pubkey = "", this.ownerKeyPath = "", o.proto3.util.initPartial(d, this);
    }
    static fromBinary(d, E) {
      return new y().fromBinary(d, E);
    }
    static fromJson(d, E) {
      return new y().fromJson(d, E);
    }
    static fromJsonString(d, E) {
      return new y().fromJsonString(d, E);
    }
    static equals(d, E) {
      return o.proto3.util.equals(y, d, E);
    }
  }
  return dash_transaction_pb.DashTx_Input = y, y.runtime = o.proto3, y.typeName = "protoc.DashTx.Input", y.fields = o.proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "hash",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "index",
      kind: "scalar",
      T: 5
      /* ScalarType.INT32 */
    },
    {
      no: 3,
      name: "value",
      kind: "scalar",
      T: 3
      /* ScalarType.INT64 */
    },
    {
      no: 4,
      name: "pubkey",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 5,
      name: "ownerKeyPath",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]), dash_transaction_pb;
}
var ltc_transaction_pb = {}, hasRequiredLtc_transaction_pb;
function requireLtc_transaction_pb() {
  if (hasRequiredLtc_transaction_pb) return ltc_transaction_pb;
  hasRequiredLtc_transaction_pb = 1, Object.defineProperty(ltc_transaction_pb, "__esModule", { value: !0 }), ltc_transaction_pb.LtcTx = void 0;
  const o = /* @__PURE__ */ requireCjs$3(), g = requireBtc_transaction_pb();
  class c extends o.Message {
    constructor(t) {
      super(), this.fee = o.protoInt64.zero, this.dustThreshold = 0, this.memo = "", this.inputs = [], this.outputs = [], o.proto3.util.initPartial(t, this);
    }
    static fromBinary(t, d) {
      return new c().fromBinary(t, d);
    }
    static fromJson(t, d) {
      return new c().fromJson(t, d);
    }
    static fromJsonString(t, d) {
      return new c().fromJsonString(t, d);
    }
    static equals(t, d) {
      return o.proto3.util.equals(c, t, d);
    }
  }
  return ltc_transaction_pb.LtcTx = c, c.runtime = o.proto3, c.typeName = "protoc.LtcTx", c.fields = o.proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "fee",
      kind: "scalar",
      T: 3
      /* ScalarType.INT64 */
    },
    {
      no: 2,
      name: "dustThreshold",
      kind: "scalar",
      T: 5
      /* ScalarType.INT32 */
    },
    {
      no: 3,
      name: "memo",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 4, name: "inputs", kind: "message", T: g.Input, repeated: !0 },
    { no: 5, name: "outputs", kind: "message", T: g.Output, repeated: !0 }
  ]), ltc_transaction_pb;
}
var doge_transaction_pb = {}, hasRequiredDoge_transaction_pb;
function requireDoge_transaction_pb() {
  if (hasRequiredDoge_transaction_pb) return doge_transaction_pb;
  hasRequiredDoge_transaction_pb = 1, Object.defineProperty(doge_transaction_pb, "__esModule", { value: !0 }), doge_transaction_pb.DogeTx = void 0;
  const o = /* @__PURE__ */ requireCjs$3(), g = requireBtc_transaction_pb();
  class c extends o.Message {
    constructor(t) {
      super(), this.fee = o.protoInt64.zero, this.dustThreshold = 0, this.memo = "", this.inputs = [], this.outputs = [], o.proto3.util.initPartial(t, this);
    }
    static fromBinary(t, d) {
      return new c().fromBinary(t, d);
    }
    static fromJson(t, d) {
      return new c().fromJson(t, d);
    }
    static fromJsonString(t, d) {
      return new c().fromJsonString(t, d);
    }
    static equals(t, d) {
      return o.proto3.util.equals(c, t, d);
    }
  }
  return doge_transaction_pb.DogeTx = c, c.runtime = o.proto3, c.typeName = "protoc.DogeTx", c.fields = o.proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "fee",
      kind: "scalar",
      T: 3
      /* ScalarType.INT64 */
    },
    {
      no: 2,
      name: "dustThreshold",
      kind: "scalar",
      T: 5
      /* ScalarType.INT32 */
    },
    {
      no: 3,
      name: "memo",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 4, name: "inputs", kind: "message", T: g.Input, repeated: !0 },
    { no: 5, name: "outputs", kind: "message", T: g.Output, repeated: !0 }
  ]), doge_transaction_pb;
}
var hasRequiredTransaction_pb;
function requireTransaction_pb() {
  if (hasRequiredTransaction_pb) return transaction_pb;
  hasRequiredTransaction_pb = 1, Object.defineProperty(transaction_pb, "__esModule", { value: !0 }), transaction_pb.SignTransaction = void 0;
  const o = /* @__PURE__ */ requireCjs$3(), g = requireTron_transaction_pb(), c = requireBch_transaction_pb(), y = requireDash_transaction_pb(), t = requireLtc_transaction_pb(), d = requireDoge_transaction_pb();
  class E extends o.Message {
    constructor(D) {
      super(), this.coinCode = "", this.signId = "", this.hdPath = "", this.timestamp = o.protoInt64.zero, this.decimal = 0, this.Transaction = { case: void 0 }, o.proto3.util.initPartial(D, this);
    }
    static fromBinary(D, x) {
      return new E().fromBinary(D, x);
    }
    static fromJson(D, x) {
      return new E().fromJson(D, x);
    }
    static fromJsonString(D, x) {
      return new E().fromJsonString(D, x);
    }
    static equals(D, x) {
      return o.proto3.util.equals(E, D, x);
    }
  }
  return transaction_pb.SignTransaction = E, E.runtime = o.proto3, E.typeName = "protoc.SignTransaction", E.fields = o.proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "coinCode",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "signId",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 3,
      name: "hdPath",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 4,
      name: "timestamp",
      kind: "scalar",
      T: 3
      /* ScalarType.INT64 */
    },
    {
      no: 5,
      name: "decimal",
      kind: "scalar",
      T: 5
      /* ScalarType.INT32 */
    },
    { no: 8, name: "tronTx", kind: "message", T: g.TronTx, oneof: "Transaction" },
    { no: 10, name: "bchTx", kind: "message", T: c.BchTx, oneof: "Transaction" },
    { no: 11, name: "dashTx", kind: "message", T: y.DashTx, oneof: "Transaction" },
    { no: 12, name: "ltcTx", kind: "message", T: t.LtcTx, oneof: "Transaction" },
    { no: 22, name: "dogeTx", kind: "message", T: d.DogeTx, oneof: "Transaction" }
  ]), transaction_pb;
}
var sign_transaction_result_pb = {}, hasRequiredSign_transaction_result_pb;
function requireSign_transaction_result_pb() {
  if (hasRequiredSign_transaction_result_pb) return sign_transaction_result_pb;
  hasRequiredSign_transaction_result_pb = 1, Object.defineProperty(sign_transaction_result_pb, "__esModule", { value: !0 }), sign_transaction_result_pb.SignTransactionResult = void 0;
  const o = /* @__PURE__ */ requireCjs$3();
  class g extends o.Message {
    constructor(y) {
      super(), this.signId = "", this.txId = "", this.rawTx = "", o.proto3.util.initPartial(y, this);
    }
    static fromBinary(y, t) {
      return new g().fromBinary(y, t);
    }
    static fromJson(y, t) {
      return new g().fromJson(y, t);
    }
    static fromJsonString(y, t) {
      return new g().fromJsonString(y, t);
    }
    static equals(y, t) {
      return o.proto3.util.equals(g, y, t);
    }
  }
  return sign_transaction_result_pb.SignTransactionResult = g, g.runtime = o.proto3, g.typeName = "protoc.SignTransactionResult", g.fields = o.proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "signId",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 2,
      name: "txId",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    {
      no: 3,
      name: "rawTx",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]), sign_transaction_result_pb;
}
var hasRequiredPayload_pb;
function requirePayload_pb() {
  if (hasRequiredPayload_pb) return payload_pb;
  hasRequiredPayload_pb = 1, Object.defineProperty(payload_pb, "__esModule", { value: !0 }), payload_pb.Payload_Type = payload_pb.Payload = void 0;
  const o = /* @__PURE__ */ requireCjs$3(), g = requireTransaction_pb(), c = requireSign_transaction_result_pb();
  class y extends o.Message {
    constructor(E) {
      super(), this.type = t.RESERVE, this.xfp = "", this.Content = { case: void 0 }, o.proto3.util.initPartial(E, this);
    }
    static fromBinary(E, B) {
      return new y().fromBinary(E, B);
    }
    static fromJson(E, B) {
      return new y().fromJson(E, B);
    }
    static fromJsonString(E, B) {
      return new y().fromJsonString(E, B);
    }
    static equals(E, B) {
      return o.proto3.util.equals(y, E, B);
    }
  }
  payload_pb.Payload = y, y.runtime = o.proto3, y.typeName = "protoc.Payload", y.fields = o.proto3.util.newFieldList(() => [
    { no: 1, name: "type", kind: "enum", T: o.proto3.getEnumType(t) },
    {
      no: 2,
      name: "xfp",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 4, name: "signTx", kind: "message", T: g.SignTransaction, oneof: "Content" },
    { no: 7, name: "signTxResult", kind: "message", T: c.SignTransactionResult, oneof: "Content" }
  ]);
  var t;
  return function(d) {
    d[d.RESERVE = 0] = "RESERVE", d[d.SYNC = 1] = "SYNC", d[d.SIGN_TX = 2] = "SIGN_TX", d[d.SIGN_MSG = 3] = "SIGN_MSG", d[d.SIGN_MULTI_SIG = 4] = "SIGN_MULTI_SIG", d[d.SYNC_MULTI_SIG_MSG = 5] = "SYNC_MULTI_SIG_MSG", d[d.SIGN_ETH_MULTI_SIG_MSG = 6] = "SIGN_ETH_MULTI_SIG_MSG", d[d.VERIFY_ADDRESS = 7] = "VERIFY_ADDRESS", d[d.STAKING = 8] = "STAKING", d[d.SIGN_TX_RESULT = 9] = "SIGN_TX_RESULT";
  }(t || (payload_pb.Payload_Type = t = {})), o.proto3.util.setEnumType(t, "protoc.Payload.Type", [
    { no: 0, name: "TYPE_RESERVE" },
    { no: 1, name: "TYPE_SYNC" },
    { no: 2, name: "TYPE_SIGN_TX" },
    { no: 3, name: "TYPE_SIGN_MSG" },
    { no: 4, name: "TYPE_SIGN_MULTI_SIG" },
    { no: 5, name: "TYPE_SYNC_MULTI_SIG_MSG" },
    { no: 6, name: "TYPE_SIGN_ETH_MULTI_SIG_MSG" },
    { no: 7, name: "TYPE_VERIFY_ADDRESS" },
    { no: 8, name: "TYPE_STAKING" },
    { no: 9, name: "TYPE_SIGN_TX_RESULT" }
  ]), payload_pb;
}
var hasRequiredBase_pb;
function requireBase_pb() {
  if (hasRequiredBase_pb) return base_pb;
  hasRequiredBase_pb = 1, Object.defineProperty(base_pb, "__esModule", { value: !0 }), base_pb.Base = void 0;
  const o = /* @__PURE__ */ requireCjs$3(), g = requirePayload_pb();
  class c extends o.Message {
    constructor(t) {
      super(), this.version = 0, this.description = "", this.Content = { case: void 0 }, this.deviceType = "", o.proto3.util.initPartial(t, this);
    }
    static fromBinary(t, d) {
      return new c().fromBinary(t, d);
    }
    static fromJson(t, d) {
      return new c().fromJson(t, d);
    }
    static fromJsonString(t, d) {
      return new c().fromJsonString(t, d);
    }
    static equals(t, d) {
      return o.proto3.util.equals(c, t, d);
    }
  }
  return base_pb.Base = c, c.runtime = o.proto3, c.typeName = "protoc.Base", c.fields = o.proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "version",
      kind: "scalar",
      T: 5
      /* ScalarType.INT32 */
    },
    {
      no: 2,
      name: "description",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    },
    { no: 3, name: "data", kind: "message", T: g.Payload },
    { no: 4, name: "hotVersion", kind: "scalar", T: 5, oneof: "Content" },
    { no: 5, name: "coldVersion", kind: "scalar", T: 5, oneof: "Content" },
    {
      no: 6,
      name: "deviceType",
      kind: "scalar",
      T: 9
      /* ScalarType.STRING */
    }
  ]), base_pb;
}
var dist$f = { exports: {} }, bcUrRegistryKeystone_cjs_production_min = {}, hasRequiredBcUrRegistryKeystone_cjs_production_min;
function requireBcUrRegistryKeystone_cjs_production_min() {
  return hasRequiredBcUrRegistryKeystone_cjs_production_min || (hasRequiredBcUrRegistryKeystone_cjs_production_min = 1, function(o) {
    Object.defineProperty(o, "__esModule", { value: !0 });
    var g = requireDist$n();
    const c = { KEYSTONE_SIGN_REQUEST: new g.RegistryType("keystone-sign-request", 6101), KEYSTONE_SIGN_RESULT: new g.RegistryType("keystone-sign-result", 6102) }, { decodeToDataItem: y } = g.extend;
    var t;
    (function(x) {
      x[x.signData = 1] = "signData", x[x.origin = 2] = "origin";
    })(t || (t = {}));
    class d extends g.RegistryItem {
      constructor(v) {
        super(), this.getRegistryType = () => c.KEYSTONE_SIGN_REQUEST, this.getSignData = () => this.signData, this.getOrigin = () => this.origin, this.toDataItem = () => {
          const F = {};
          return F[t.signData] = this.signData, this.origin && (F[t.origin] = this.origin), new g.DataItem(F);
        }, this.signData = v.signData, this.origin = v.origin;
      }
      static constructKeystoneRequest(v, F) {
        return new d({ signData: v, origin: F });
      }
    }
    d.fromDataItem = (x) => {
      const v = x.getData();
      return new d({ signData: v[t.signData], origin: v[t.origin] });
    }, d.fromCBOR = (x) => {
      const v = y(x);
      return d.fromDataItem(v);
    };
    const { decodeToDataItem: E } = g.extend;
    var B;
    (function(x) {
      x[x.signResult = 1] = "signResult";
    })(B || (B = {}));
    class D extends g.RegistryItem {
      constructor(v) {
        super(), this.getRegistryType = () => c.KEYSTONE_SIGN_RESULT, this.getSignResult = () => this.signResult, this.toDataItem = () => {
          const F = {};
          return F[B.signResult] = this.signResult, new g.DataItem(F);
        }, this.signResult = v;
      }
    }
    D.fromDataItem = (x) => {
      const v = x.getData();
      return new D(v[B.signResult]);
    }, D.fromCBOR = (x) => {
      const v = E(x);
      return D.fromDataItem(v);
    }, g.patchTags(Object.values(c).filter((x) => !!x.getTag()).map((x) => x.getTag())), Object.keys(g).forEach(function(x) {
      x !== "default" && Object.defineProperty(o, x, { enumerable: !0, get: function() {
        return g[x];
      } });
    }), o.KeystoneSignRequest = d, o.KeystoneSignResult = D;
  }(bcUrRegistryKeystone_cjs_production_min)), bcUrRegistryKeystone_cjs_production_min;
}
var bcUrRegistryKeystone_cjs_development = {}, hasRequiredBcUrRegistryKeystone_cjs_development;
function requireBcUrRegistryKeystone_cjs_development() {
  return hasRequiredBcUrRegistryKeystone_cjs_development || (hasRequiredBcUrRegistryKeystone_cjs_development = 1, function(o) {
    Object.defineProperty(o, "__esModule", { value: !0 });
    var g = requireDist$n();
    const c = {
      KEYSTONE_SIGN_REQUEST: /* @__PURE__ */ new g.RegistryType("keystone-sign-request", 6101),
      KEYSTONE_SIGN_RESULT: /* @__PURE__ */ new g.RegistryType("keystone-sign-result", 6102)
    }, {
      decodeToDataItem: y
    } = g.extend;
    var t;
    (function(x) {
      x[x.signData = 1] = "signData", x[x.origin = 2] = "origin";
    })(t || (t = {}));
    class d extends g.RegistryItem {
      constructor(v) {
        super(), this.getRegistryType = () => c.KEYSTONE_SIGN_REQUEST, this.getSignData = () => this.signData, this.getOrigin = () => this.origin, this.toDataItem = () => {
          const F = {};
          return F[t.signData] = this.signData, this.origin && (F[t.origin] = this.origin), new g.DataItem(F);
        }, this.signData = v.signData, this.origin = v.origin;
      }
      static constructKeystoneRequest(v, F) {
        return new d({
          signData: v,
          origin: F
        });
      }
    }
    d.fromDataItem = (x) => {
      const v = x.getData();
      return new d({
        signData: v[t.signData],
        origin: v[t.origin]
      });
    }, d.fromCBOR = (x) => {
      const v = y(x);
      return d.fromDataItem(v);
    };
    const {
      decodeToDataItem: E
    } = g.extend;
    var B;
    (function(x) {
      x[x.signResult = 1] = "signResult";
    })(B || (B = {}));
    class D extends g.RegistryItem {
      constructor(v) {
        super(), this.getRegistryType = () => c.KEYSTONE_SIGN_RESULT, this.getSignResult = () => this.signResult, this.toDataItem = () => {
          const F = {};
          return F[B.signResult] = this.signResult, new g.DataItem(F);
        }, this.signResult = v;
      }
    }
    D.fromDataItem = (x) => {
      const F = x.getData()[B.signResult];
      return new D(F);
    }, D.fromCBOR = (x) => {
      const v = E(x);
      return D.fromDataItem(v);
    }, g.patchTags(Object.values(c).filter((x) => !!x.getTag()).map((x) => x.getTag())), Object.keys(g).forEach(function(x) {
      x !== "default" && Object.defineProperty(o, x, {
        enumerable: !0,
        get: function() {
          return g[x];
        }
      });
    }), o.KeystoneSignRequest = d, o.KeystoneSignResult = D;
  }(bcUrRegistryKeystone_cjs_development)), bcUrRegistryKeystone_cjs_development;
}
var hasRequiredDist$g;
function requireDist$g() {
  return hasRequiredDist$g || (hasRequiredDist$g = 1, process$1.env.NODE_ENV === "production" ? dist$f.exports = requireBcUrRegistryKeystone_cjs_production_min() : dist$f.exports = requireBcUrRegistryKeystone_cjs_development()), dist$f.exports;
}
var hasRequiredTron;
function requireTron() {
  if (hasRequiredTron) return tron;
  hasRequiredTron = 1;
  var o = tron && tron.__importDefault || function(v) {
    return v && v.__esModule ? v : { default: v };
  };
  Object.defineProperty(tron, "__esModule", { value: !0 }), tron.KeystoneTronSDK = void 0;
  const g = requireUtils$e(), c = requireUr(), y = requireTransfer(), t = o(requirePako()), d = requireBase_pb(), E = requirePayload_pb(), B = requireTransaction_pb(), D = requireDist$g();
  class x {
    parseSignature(F) {
      var M, U, L, H;
      if (F.type !== c.URType.KeystoneSignResult)
        throw new Error("type not match");
      const fe = D.KeystoneSignResult.fromCBOR(F.cbor), ge = d.Base.fromBinary(t.default.ungzip(fe.getSignResult()));
      if (((M = ge.data) === null || M === void 0 ? void 0 : M.Content.case) !== "signTxResult")
        throw new Error("invalid sign result");
      const { signId: Ie, rawTx: Ee, txId: Se } = (H = (L = (U = ge.data) === null || U === void 0 ? void 0 : U.Content) === null || L === void 0 ? void 0 : L.value) !== null && H !== void 0 ? H : {};
      return {
        requestId: Ie,
        raw: Ee,
        txId: Se
      };
    }
    generateSignRequest({ requestId: F, signData: M, path: U, xfp: L, tokenInfo: H, origin: fe }) {
      const ge = (0, y.raw2tx)((0, g.toBuffer)(M), H), Ie = t.default.gzip(new d.Base({
        version: 2,
        description: "QrCode Protocol",
        deviceType: "",
        data: new E.Payload({
          xfp: L,
          type: E.Payload_Type.SIGN_TX,
          Content: {
            case: "signTx",
            value: new B.SignTransaction({
              coinCode: "TRON",
              hdPath: U,
              signId: F,
              timestamp: BigInt(Date.now()),
              decimal: 6,
              Transaction: {
                case: "tronTx",
                value: ge
              }
            })
          }
        })
      }).toBinary());
      return new D.KeystoneSignRequest({
        signData: Buffer.from(Ie),
        origin: fe
      }).toUR();
    }
  }
  return tron.KeystoneTronSDK = x, tron;
}
var aptos = {}, dist$e = { exports: {} }, bcUrRegistryAptos_cjs_production_min = {}, hasRequiredBcUrRegistryAptos_cjs_production_min;
function requireBcUrRegistryAptos_cjs_production_min() {
  return hasRequiredBcUrRegistryAptos_cjs_production_min || (hasRequiredBcUrRegistryAptos_cjs_production_min = 1, function(o) {
    Object.defineProperty(o, "__esModule", { value: !0 });
    var g = requireDist$n(), c = require$$1$3;
    const y = { APTOS_SIGN_REQUEST: new g.RegistryType("aptos-sign-request", 3101), APTOS_SIGNATURE: new g.RegistryType("aptos-signature", 3102) }, { decodeToDataItem: t, RegistryTypes: d } = g.extend;
    var E, B;
    (E = o.SignType || (o.SignType = {}))[E.SingleSign = 1] = "SingleSign", E[E.MultiSign = 2] = "MultiSign", E[E.SignMessage = 3] = "SignMessage", function(U) {
      U[U.requestId = 1] = "requestId", U[U.signData = 2] = "signData", U[U.authenticationKeyDerivationPaths = 3] = "authenticationKeyDerivationPaths", U[U.accounts = 4] = "accounts", U[U.origin = 5] = "origin", U[U.signType = 6] = "signType";
    }(B || (B = {}));
    class D extends g.RegistryItem {
      constructor(L) {
        super(), this.getRegistryType = () => y.APTOS_SIGN_REQUEST, this.getRequestId = () => this.requestId, this.getSignData = () => this.signData, this.getAuthenticationKeyDerivationPaths = () => this.authenticationKeyDerivationPaths.map((H) => H.getPath()), this.getSignRequestAccounts = () => this.accounts, this.getOrigin = () => this.origin, this.getSignType = () => this.signType, this.toDataItem = () => {
          const H = {};
          return H[B.requestId] = new g.DataItem(this.requestId, d.UUID.getTag()), this.accounts && (H[B.accounts] = this.accounts), this.origin && (H[B.origin] = this.origin), H[B.signData] = this.signData, H[B.signType] = this.signType, H[B.authenticationKeyDerivationPaths] = this.authenticationKeyDerivationPaths.map((fe) => {
            const ge = fe.toDataItem();
            return ge.setTag(fe.getRegistryType().getTag()), ge;
          }), new g.DataItem(H);
        }, this.requestId = L.requestId, this.signData = L.signData, this.authenticationKeyDerivationPaths = L.authenticationKeyDerivationPaths, this.accounts = L.accounts, this.origin = L.origin, this.signType = L.signType;
      }
      static constructAptosRequest(L, H, fe, ge, Ie, Ee, Se) {
        const ze = H.map((He, Pe) => {
          const De = He.replace(/[m|M]\//, "").split("/").map((ve) => {
            const Fe = parseInt(ve.replace("'", ""));
            let be = !1;
            return ve.endsWith("'") && (be = !0), new g.PathComponent({ index: Fe, hardened: be });
          });
          return new g.CryptoKeypath(De, Buffer.from(fe[Pe], "hex"));
        });
        return new D({ requestId: Buffer.from(c.parse(Ie)), signData: L, authenticationKeyDerivationPaths: ze, accounts: Ee || void 0, origin: Se || void 0, signType: ge || o.SignType.SingleSign });
      }
    }
    D.fromDataItem = (U) => {
      const L = U.getData(), H = L[B.signData], fe = L[B.signType], ge = L[B.authenticationKeyDerivationPaths].map((Se) => g.CryptoKeypath.fromDataItem(Se)), Ie = L[B.accounts] ? L[B.accounts] : void 0, Ee = L[B.requestId] ? L[B.requestId].getData() : void 0;
      return new D({ requestId: Ee, signData: H, authenticationKeyDerivationPaths: ge, accounts: Ie, origin: L[B.origin] ? L[B.origin] : void 0, signType: fe });
    }, D.fromCBOR = (U) => {
      const L = t(U);
      return D.fromDataItem(L);
    };
    const { RegistryTypes: x, decodeToDataItem: v } = g.extend;
    var F;
    (function(U) {
      U[U.requestId = 1] = "requestId", U[U.signature = 2] = "signature", U[U.authenticationPublicKey = 3] = "authenticationPublicKey";
    })(F || (F = {}));
    class M extends g.RegistryItem {
      constructor(L, H, fe) {
        super(), this.getRegistryType = () => y.APTOS_SIGNATURE, this.getRequestId = () => this.requestId, this.getSignature = () => this.signature, this.getAuthenticationPublicKey = () => this.authenticationPublicKey, this.toDataItem = () => {
          const ge = {};
          return ge[F.requestId] = new g.DataItem(this.requestId, x.UUID.getTag()), ge[F.signature] = this.signature, ge[F.authenticationPublicKey] = this.authenticationPublicKey, new g.DataItem(ge);
        }, this.signature = L, this.requestId = H, this.authenticationPublicKey = fe;
      }
    }
    M.fromDataItem = (U) => {
      const L = U.getData(), H = L[F.signature], fe = L[F.requestId].getData();
      return new M(H, fe, L[F.authenticationPublicKey]);
    }, M.fromCBOR = (U) => {
      const L = v(U);
      return M.fromDataItem(L);
    }, g.patchTags(Object.values(y).filter((U) => !!U.getTag()).map((U) => U.getTag())), Object.keys(g).forEach(function(U) {
      U !== "default" && Object.defineProperty(o, U, { enumerable: !0, get: function() {
        return g[U];
      } });
    }), o.AptosSignRequest = D, o.AptosSignature = M;
  }(bcUrRegistryAptos_cjs_production_min)), bcUrRegistryAptos_cjs_production_min;
}
var bcUrRegistryAptos_cjs_development = {}, hasRequiredBcUrRegistryAptos_cjs_development;
function requireBcUrRegistryAptos_cjs_development() {
  return hasRequiredBcUrRegistryAptos_cjs_development || (hasRequiredBcUrRegistryAptos_cjs_development = 1, function(o) {
    Object.defineProperty(o, "__esModule", { value: !0 });
    var g = requireDist$n(), c = require$$1$3;
    const y = {
      APTOS_SIGN_REQUEST: /* @__PURE__ */ new g.RegistryType("aptos-sign-request", 3101),
      APTOS_SIGNATURE: /* @__PURE__ */ new g.RegistryType("aptos-signature", 3102)
    }, {
      decodeToDataItem: t,
      RegistryTypes: d
    } = g.extend;
    (function(M) {
      M[M.SingleSign = 1] = "SingleSign", M[M.MultiSign = 2] = "MultiSign", M[M.SignMessage = 3] = "SignMessage";
    })(o.SignType || (o.SignType = {}));
    var E;
    (function(M) {
      M[M.requestId = 1] = "requestId", M[M.signData = 2] = "signData", M[M.authenticationKeyDerivationPaths = 3] = "authenticationKeyDerivationPaths", M[M.accounts = 4] = "accounts", M[M.origin = 5] = "origin", M[M.signType = 6] = "signType";
    })(E || (E = {}));
    class B extends g.RegistryItem {
      constructor(U) {
        super(), this.getRegistryType = () => y.APTOS_SIGN_REQUEST, this.getRequestId = () => this.requestId, this.getSignData = () => this.signData, this.getAuthenticationKeyDerivationPaths = () => this.authenticationKeyDerivationPaths.map((L) => L.getPath()), this.getSignRequestAccounts = () => this.accounts, this.getOrigin = () => this.origin, this.getSignType = () => this.signType, this.toDataItem = () => {
          const L = {};
          return L[E.requestId] = new g.DataItem(this.requestId, d.UUID.getTag()), this.accounts && (L[E.accounts] = this.accounts), this.origin && (L[E.origin] = this.origin), L[E.signData] = this.signData, L[E.signType] = this.signType, L[E.authenticationKeyDerivationPaths] = this.authenticationKeyDerivationPaths.map((H) => {
            const fe = H.toDataItem();
            return fe.setTag(H.getRegistryType().getTag()), fe;
          }), new g.DataItem(L);
        }, this.requestId = U.requestId, this.signData = U.signData, this.authenticationKeyDerivationPaths = U.authenticationKeyDerivationPaths, this.accounts = U.accounts, this.origin = U.origin, this.signType = U.signType;
      }
      static constructAptosRequest(U, L, H, fe, ge, Ie, Ee) {
        const Se = L.map((ze, He) => {
          const De = ze.replace(/[m|M]\//, "").split("/").map((ve) => {
            const Fe = parseInt(ve.replace("'", ""));
            let be = !1;
            return ve.endsWith("'") && (be = !0), new g.PathComponent({
              index: Fe,
              hardened: be
            });
          });
          return new g.CryptoKeypath(De, Buffer.from(H[He], "hex"));
        });
        return new B({
          requestId: Buffer.from(c.parse(ge)),
          signData: U,
          authenticationKeyDerivationPaths: Se,
          accounts: Ie || void 0,
          origin: Ee || void 0,
          signType: fe || o.SignType.SingleSign
        });
      }
    }
    B.fromDataItem = (M) => {
      const U = M.getData(), L = U[E.signData], H = U[E.signType], fe = U[E.authenticationKeyDerivationPaths].map((Se) => g.CryptoKeypath.fromDataItem(Se)), ge = U[E.accounts] ? U[E.accounts] : void 0, Ie = U[E.requestId] ? U[E.requestId].getData() : void 0, Ee = U[E.origin] ? U[E.origin] : void 0;
      return new B({
        requestId: Ie,
        signData: L,
        authenticationKeyDerivationPaths: fe,
        accounts: ge,
        origin: Ee,
        signType: H
      });
    }, B.fromCBOR = (M) => {
      const U = t(M);
      return B.fromDataItem(U);
    };
    const {
      RegistryTypes: D,
      decodeToDataItem: x
    } = g.extend;
    var v;
    (function(M) {
      M[M.requestId = 1] = "requestId", M[M.signature = 2] = "signature", M[M.authenticationPublicKey = 3] = "authenticationPublicKey";
    })(v || (v = {}));
    class F extends g.RegistryItem {
      constructor(U, L, H) {
        super(), this.getRegistryType = () => y.APTOS_SIGNATURE, this.getRequestId = () => this.requestId, this.getSignature = () => this.signature, this.getAuthenticationPublicKey = () => this.authenticationPublicKey, this.toDataItem = () => {
          const fe = {};
          return fe[v.requestId] = new g.DataItem(this.requestId, D.UUID.getTag()), fe[v.signature] = this.signature, fe[v.authenticationPublicKey] = this.authenticationPublicKey, new g.DataItem(fe);
        }, this.signature = U, this.requestId = L, this.authenticationPublicKey = H;
      }
    }
    F.fromDataItem = (M) => {
      const U = M.getData(), L = U[v.signature], H = U[v.requestId].getData(), fe = U[v.authenticationPublicKey];
      return new F(L, H, fe);
    }, F.fromCBOR = (M) => {
      const U = x(M);
      return F.fromDataItem(U);
    }, g.patchTags(Object.values(y).filter((M) => !!M.getTag()).map((M) => M.getTag())), Object.keys(g).forEach(function(M) {
      M !== "default" && Object.defineProperty(o, M, {
        enumerable: !0,
        get: function() {
          return g[M];
        }
      });
    }), o.AptosSignRequest = B, o.AptosSignature = F;
  }(bcUrRegistryAptos_cjs_development)), bcUrRegistryAptos_cjs_development;
}
var hasRequiredDist$f;
function requireDist$f() {
  return hasRequiredDist$f || (hasRequiredDist$f = 1, process$1.env.NODE_ENV === "production" ? dist$e.exports = requireBcUrRegistryAptos_cjs_production_min() : dist$e.exports = requireBcUrRegistryAptos_cjs_development()), dist$e.exports;
}
var hasRequiredAptos;
function requireAptos() {
  if (hasRequiredAptos) return aptos;
  hasRequiredAptos = 1, Object.defineProperty(aptos, "__esModule", { value: !0 }), aptos.KeystoneAptosSDK = void 0;
  const o = requireDist$f(), g = requireUtils$e(), c = requireUr();
  class y {
    parseSignature(d) {
      if (d.type !== c.URType.AptosSignature)
        throw new Error("type not match");
      const E = o.AptosSignature.fromCBOR(d.cbor);
      return {
        requestId: (0, g.uuidStringify)(E.getRequestId()),
        signature: (0, g.toHex)(E.getSignature()),
        authenticationPublicKey: (0, g.toHex)(E.getAuthenticationPublicKey())
      };
    }
    generateSignRequest({ requestId: d, signData: E, signType: B, accounts: D, origin: x }) {
      const v = [], F = [];
      if (D.forEach((M) => {
        v.push(new o.CryptoKeypath((0, g.parsePath)(M.path).map((U) => new o.PathComponent(U)), (0, g.toBuffer)(M.xfp))), M.key !== void 0 && F.push((0, g.toBuffer)(M.key));
      }), F.length > 0 && F.length !== v.length)
        throw new Error("account and path count must match");
      return new o.AptosSignRequest({
        requestId: (0, g.uuidParse)(d),
        signData: (0, g.toBuffer)(E),
        signType: B,
        authenticationKeyDerivationPaths: v,
        accounts: F,
        origin: x
      }).toUR();
    }
  }
  return aptos.KeystoneAptosSDK = y, y.SignType = o.SignType, aptos;
}
var bitcoin_cash = {}, keystone = {}, hasRequiredKeystone;
function requireKeystone() {
  if (hasRequiredKeystone) return keystone;
  hasRequiredKeystone = 1;
  var o = keystone && keystone.__importDefault || function(L) {
    return L && L.__esModule ? L : { default: L };
  };
  Object.defineProperty(keystone, "__esModule", { value: !0 }), keystone.Keystone = keystone.TXCase = keystone.Chain = void 0;
  const g = o(requirePako()), c = requireUr(), y = requireDist$g(), t = requireBase_pb(), d = requirePayload_pb(), E = requireTransaction_pb(), B = requireLtc_transaction_pb(), D = requireBch_transaction_pb(), x = requireDash_transaction_pb(), v = requireDoge_transaction_pb();
  var F;
  (function(L) {
    L.LTC = "LTC", L.BCH = "BCH", L.DASH = "DASH", L.DOGE = "DOGE";
  })(F || (keystone.Chain = F = {}));
  var M;
  (function(L) {
    L.LTC = "ltcTx", L.BCH = "bchTx", L.DASH = "dashTx", L.DOGE = "dogeTx";
  })(M || (keystone.TXCase = M = {}));
  class U {
    generateSignData({ chain: H, requestId: fe, signData: ge, xfp: Ie }) {
      let Ee, Se, ze;
      switch (H) {
        case F.LTC:
          Ee = new B.LtcTx(Object.assign(Object.assign({}, ge), { fee: BigInt(ge.fee), dustThreshold: 5460 })), ze = F.LTC, Se = M.LTC;
          break;
        case F.BCH:
          Ee = new D.BchTx(Object.assign(Object.assign({}, ge), { fee: BigInt(ge.fee), dustThreshold: 546 })), ze = F.BCH, Se = M.BCH;
          break;
        case F.DASH:
          Ee = new x.DashTx(Object.assign(Object.assign({}, ge), { fee: BigInt(ge.fee), dustThreshold: 546 })), ze = F.DASH, Se = M.DASH;
          break;
        case F.DOGE:
          Ee = new v.DogeTx(Object.assign(Object.assign({}, ge), {
            fee: BigInt(ge.fee),
            // 0.01 DOGE = 1000000
            dustThreshold: 1e6
          })), ze = F.DOGE, Se = M.DOGE;
          break;
        default:
          throw new Error("chain not support");
      }
      return g.default.gzip(new t.Base({
        version: 2,
        description: "QrCode Protocol",
        deviceType: "",
        data: new d.Payload({
          xfp: Ie,
          type: d.Payload_Type.SIGN_TX,
          Content: {
            case: "signTx",
            value: new E.SignTransaction({
              coinCode: ze,
              hdPath: "",
              signId: fe,
              timestamp: BigInt(Date.now()),
              decimal: 8,
              Transaction: {
                case: Se,
                value: Ee
              }
            })
          }
        })
      }).toBinary());
    }
    generateSignRequest(H) {
      const fe = Buffer.from(this.generateSignData(H));
      return new y.KeystoneSignRequest({
        signData: fe,
        origin: H.origin
      }).toUR();
    }
    parseSignResult(H) {
      var fe, ge;
      if (H.type !== c.URType.KeystoneSignResult)
        throw new Error("type not match");
      const Ie = y.KeystoneSignResult.fromCBOR(H.cbor), Ee = t.Base.fromBinary(g.default.ungzip(Ie.getSignResult()));
      if (((fe = Ee.data) === null || fe === void 0 ? void 0 : fe.Content.case) !== "signTxResult")
        throw new Error("invalid sign result");
      const Se = (ge = Ee.data) === null || ge === void 0 ? void 0 : ge.Content.value;
      return {
        requestId: Se.signId,
        rawData: Se.rawTx
      };
    }
  }
  return keystone.Keystone = U, keystone;
}
var hasRequiredBitcoin_cash;
function requireBitcoin_cash() {
  if (hasRequiredBitcoin_cash) return bitcoin_cash;
  hasRequiredBitcoin_cash = 1, Object.defineProperty(bitcoin_cash, "__esModule", { value: !0 }), bitcoin_cash.KeystoneBitcoinCashSDK = void 0;
  const o = requireKeystone();
  class g extends o.Keystone {
    generateSignRequest(y) {
      return super.generateSignRequest(Object.assign({ chain: o.Chain.BCH }, y));
    }
  }
  return bitcoin_cash.KeystoneBitcoinCashSDK = g, bitcoin_cash;
}
var dash = {}, hasRequiredDash;
function requireDash() {
  if (hasRequiredDash) return dash;
  hasRequiredDash = 1, Object.defineProperty(dash, "__esModule", { value: !0 }), dash.KeystoneDashSDK = void 0;
  const o = requireKeystone();
  class g extends o.Keystone {
    generateSignRequest(y) {
      return super.generateSignRequest(Object.assign({ chain: o.Chain.DASH }, y));
    }
  }
  return dash.KeystoneDashSDK = g, dash;
}
var litecoin = {}, hasRequiredLitecoin;
function requireLitecoin() {
  if (hasRequiredLitecoin) return litecoin;
  hasRequiredLitecoin = 1, Object.defineProperty(litecoin, "__esModule", { value: !0 }), litecoin.KeystoneLitecoinSDK = void 0;
  const o = requireKeystone();
  class g extends o.Keystone {
    generateSignRequest(y) {
      return super.generateSignRequest(Object.assign({ chain: o.Chain.LTC }, y));
    }
  }
  return litecoin.KeystoneLitecoinSDK = g, litecoin;
}
var near = {}, dist$d = { exports: {} }, bcUrRegistryNear_cjs_production_min = {}, hasRequiredBcUrRegistryNear_cjs_production_min;
function requireBcUrRegistryNear_cjs_production_min() {
  return hasRequiredBcUrRegistryNear_cjs_production_min || (hasRequiredBcUrRegistryNear_cjs_production_min = 1, function(o) {
    Object.defineProperty(o, "__esModule", { value: !0 });
    var g = requireDist$n(), c = require$$1$3;
    const y = { NEAR_SIGN_REQUEST: new g.RegistryType("near-sign-request", 2101), NEAR_SIGNATURE: new g.RegistryType("near-signature", 2102), CRYPTO_MULTI_ACCOUNTS: new g.RegistryType("crypto-multi-accounts", 2103) }, { decodeToDataItem: t, RegistryTypes: d } = g.extend;
    var E;
    (function(M) {
      M[M.requestId = 1] = "requestId", M[M.signData = 2] = "signData", M[M.derivationPath = 3] = "derivationPath", M[M.account = 4] = "account", M[M.origin = 5] = "origin";
    })(E || (E = {}));
    class B extends g.RegistryItem {
      constructor(U) {
        super(), this.getRegistryType = () => y.NEAR_SIGN_REQUEST, this.getRequestId = () => this.requestId, this.getSignData = () => this.signData, this.getDerivationPath = () => this.derivationPath.getPath(), this.getSignRequestAccount = () => this.account, this.getOrigin = () => this.origin, this.toDataItem = () => {
          const L = {};
          this.requestId && (L[E.requestId] = new g.DataItem(this.requestId, d.UUID.getTag())), this.account && (L[E.account] = this.account), this.origin && (L[E.origin] = this.origin), L[E.signData] = this.signData;
          const H = this.derivationPath.toDataItem();
          return H.setTag(this.derivationPath.getRegistryType().getTag()), L[E.derivationPath] = H, new g.DataItem(L);
        }, this.requestId = U.requestId, this.signData = U.signData, this.derivationPath = U.derivationPath, this.account = U.account, this.origin = U.origin;
      }
      static constructNearRequest(U, L, H, fe, ge, Ie) {
        const Ee = L.replace(/[m|M]\//, "").split("/"), Se = new g.CryptoKeypath(Ee.map((ze) => {
          const He = parseInt(ze.replace("'", ""));
          let Pe = !1;
          return ze.endsWith("'") && (Pe = !0), new g.PathComponent({ index: He, hardened: Pe });
        }), Buffer.from(H, "hex"));
        return new B({ requestId: fe ? Buffer.from(c.parse(fe)) : void 0, signData: U, derivationPath: Se, account: ge || void 0, origin: Ie || void 0 });
      }
    }
    B.fromDataItem = (M) => {
      const U = M.getData(), L = U[E.signData], H = g.CryptoKeypath.fromDataItem(U[E.derivationPath]), fe = U[E.account] ? U[E.account] : void 0, ge = U[E.requestId] ? U[E.requestId].getData() : void 0;
      return new B({ requestId: ge, signData: L, derivationPath: H, account: fe, origin: U[E.origin] ? U[E.origin] : void 0 });
    }, B.fromCBOR = (M) => {
      const U = t(M);
      return B.fromDataItem(U);
    };
    const { RegistryTypes: D, decodeToDataItem: x } = g.extend;
    var v;
    (function(M) {
      M[M.requestId = 1] = "requestId", M[M.signature = 2] = "signature";
    })(v || (v = {}));
    class F extends g.RegistryItem {
      constructor(U, L) {
        super(), this.getRegistryType = () => y.NEAR_SIGNATURE, this.getRequestId = () => this.requestId, this.getSignature = () => this.signature, this.toDataItem = () => {
          const H = {};
          return this.requestId && (H[v.requestId] = new g.DataItem(this.requestId, D.UUID.getTag())), H[v.signature] = this.signature, new g.DataItem(H);
        }, this.signature = U, this.requestId = L;
      }
    }
    F.fromDataItem = (M) => {
      const U = M.getData(), L = U[v.signature], H = U[v.requestId] ? U[v.requestId].getData() : void 0;
      return new F(L, H);
    }, F.fromCBOR = (M) => {
      const U = x(M);
      return F.fromDataItem(U);
    }, g.patchTags(Object.values(y).filter((M) => !!M.getTag()).map((M) => M.getTag())), Object.keys(g).forEach(function(M) {
      M !== "default" && Object.defineProperty(o, M, { enumerable: !0, get: function() {
        return g[M];
      } });
    }), o.NearSignRequest = B, o.NearSignature = F;
  }(bcUrRegistryNear_cjs_production_min)), bcUrRegistryNear_cjs_production_min;
}
var bcUrRegistryNear_cjs_development = {}, hasRequiredBcUrRegistryNear_cjs_development;
function requireBcUrRegistryNear_cjs_development() {
  return hasRequiredBcUrRegistryNear_cjs_development || (hasRequiredBcUrRegistryNear_cjs_development = 1, function(o) {
    Object.defineProperty(o, "__esModule", { value: !0 });
    var g = requireDist$n(), c = require$$1$3;
    const y = {
      NEAR_SIGN_REQUEST: /* @__PURE__ */ new g.RegistryType("near-sign-request", 2101),
      NEAR_SIGNATURE: /* @__PURE__ */ new g.RegistryType("near-signature", 2102),
      CRYPTO_MULTI_ACCOUNTS: /* @__PURE__ */ new g.RegistryType("crypto-multi-accounts", 2103)
    }, {
      decodeToDataItem: t,
      RegistryTypes: d
    } = g.extend;
    var E;
    (function(M) {
      M[M.requestId = 1] = "requestId", M[M.signData = 2] = "signData", M[M.derivationPath = 3] = "derivationPath", M[M.account = 4] = "account", M[M.origin = 5] = "origin";
    })(E || (E = {}));
    class B extends g.RegistryItem {
      constructor(U) {
        super(), this.getRegistryType = () => y.NEAR_SIGN_REQUEST, this.getRequestId = () => this.requestId, this.getSignData = () => this.signData, this.getDerivationPath = () => this.derivationPath.getPath(), this.getSignRequestAccount = () => this.account, this.getOrigin = () => this.origin, this.toDataItem = () => {
          const L = {};
          this.requestId && (L[E.requestId] = new g.DataItem(this.requestId, d.UUID.getTag())), this.account && (L[E.account] = this.account), this.origin && (L[E.origin] = this.origin), L[E.signData] = this.signData;
          const H = this.derivationPath.toDataItem();
          return H.setTag(this.derivationPath.getRegistryType().getTag()), L[E.derivationPath] = H, new g.DataItem(L);
        }, this.requestId = U.requestId, this.signData = U.signData, this.derivationPath = U.derivationPath, this.account = U.account, this.origin = U.origin;
      }
      static constructNearRequest(U, L, H, fe, ge, Ie) {
        const Ee = L.replace(/[m|M]\//, "").split("/"), Se = new g.CryptoKeypath(Ee.map((ze) => {
          const He = parseInt(ze.replace("'", ""));
          let Pe = !1;
          return ze.endsWith("'") && (Pe = !0), new g.PathComponent({
            index: He,
            hardened: Pe
          });
        }), Buffer.from(H, "hex"));
        return new B({
          requestId: fe ? Buffer.from(c.parse(fe)) : void 0,
          signData: U,
          derivationPath: Se,
          account: ge || void 0,
          origin: Ie || void 0
        });
      }
    }
    B.fromDataItem = (M) => {
      const U = M.getData(), L = U[E.signData], H = g.CryptoKeypath.fromDataItem(U[E.derivationPath]), fe = U[E.account] ? U[E.account] : void 0, ge = U[E.requestId] ? U[E.requestId].getData() : void 0, Ie = U[E.origin] ? U[E.origin] : void 0;
      return new B({
        requestId: ge,
        signData: L,
        derivationPath: H,
        account: fe,
        origin: Ie
      });
    }, B.fromCBOR = (M) => {
      const U = t(M);
      return B.fromDataItem(U);
    };
    const {
      RegistryTypes: D,
      decodeToDataItem: x
    } = g.extend;
    var v;
    (function(M) {
      M[M.requestId = 1] = "requestId", M[M.signature = 2] = "signature";
    })(v || (v = {}));
    class F extends g.RegistryItem {
      constructor(U, L) {
        super(), this.getRegistryType = () => y.NEAR_SIGNATURE, this.getRequestId = () => this.requestId, this.getSignature = () => this.signature, this.toDataItem = () => {
          const H = {};
          return this.requestId && (H[v.requestId] = new g.DataItem(this.requestId, D.UUID.getTag())), H[v.signature] = this.signature, new g.DataItem(H);
        }, this.signature = U, this.requestId = L;
      }
    }
    F.fromDataItem = (M) => {
      const U = M.getData(), L = U[v.signature], H = U[v.requestId] ? U[v.requestId].getData() : void 0;
      return new F(L, H);
    }, F.fromCBOR = (M) => {
      const U = x(M);
      return F.fromDataItem(U);
    }, g.patchTags(Object.values(y).filter((M) => !!M.getTag()).map((M) => M.getTag())), Object.keys(g).forEach(function(M) {
      M !== "default" && Object.defineProperty(o, M, {
        enumerable: !0,
        get: function() {
          return g[M];
        }
      });
    }), o.NearSignRequest = B, o.NearSignature = F;
  }(bcUrRegistryNear_cjs_development)), bcUrRegistryNear_cjs_development;
}
var hasRequiredDist$e;
function requireDist$e() {
  return hasRequiredDist$e || (hasRequiredDist$e = 1, process$1.env.NODE_ENV === "production" ? dist$d.exports = requireBcUrRegistryNear_cjs_production_min() : dist$d.exports = requireBcUrRegistryNear_cjs_development()), dist$d.exports;
}
var hasRequiredNear;
function requireNear() {
  if (hasRequiredNear) return near;
  hasRequiredNear = 1, Object.defineProperty(near, "__esModule", { value: !0 }), near.KeystoneNearSDK = void 0;
  const o = requireUtils$e(), g = requireUr(), c = requireDist$e();
  class y {
    parseSignature(d) {
      if (d.type !== g.URType.NearSignature)
        throw new Error("type not match");
      const E = c.NearSignature.fromCBOR(d.cbor), B = E.getRequestId();
      return {
        requestId: B === void 0 ? void 0 : (0, o.uuidStringify)(B),
        signature: E.getSignature().map((D) => (0, o.toHex)(D))
      };
    }
    generateSignRequest({ requestId: d, signData: E, path: B, xfp: D, account: x, origin: v }) {
      return new c.NearSignRequest({
        requestId: (0, o.uuidParse)(d),
        signData: E.map((F) => (0, o.toBuffer)(F)),
        derivationPath: new c.CryptoKeypath((0, o.parsePath)(B).map((F) => new c.PathComponent(F)), (0, o.toBuffer)(D)),
        account: x,
        origin: v
      }).toUR();
    }
  }
  return near.KeystoneNearSDK = y, near;
}
var cardano = {}, dist$c = { exports: {} }, bcUrRegistryCardano_cjs_production_min = {}, hasRequiredBcUrRegistryCardano_cjs_production_min;
function requireBcUrRegistryCardano_cjs_production_min() {
  return hasRequiredBcUrRegistryCardano_cjs_production_min || (hasRequiredBcUrRegistryCardano_cjs_production_min = 1, function(o) {
    Object.defineProperty(o, "__esModule", { value: !0 });
    var g = requireDist$n(), c = require$$1$3;
    const y = { CARDANO_UTXO: new g.RegistryType("cardano-utxo", 2201), CARDANO_SIGN_REQUEST: new g.RegistryType("cardano-sign-request", 2202), CARDANO_SIGNATURE: new g.RegistryType("cardano-signature", 2203), CARDANO_CERT_KEY: new g.RegistryType("cardano-cert-key", 2204), CARDANO_SIGN_DATA_REQUEST: new g.RegistryType("cardano-sign-data-request", 2205), CARDANO_SIGN_DATA_SIGNATURE: new g.RegistryType("cardano-sign-data-signature", 2206), CARDANO_CATALYST_VOTING_REGISTRATION: new g.RegistryType("cardano-catalyst-voting-registration", 2207), CARDANO_CATALYST_VOTING_REGISTRATION_SIGNATURE: new g.RegistryType("cardano-catalyst-voting-registration-signature", 2208), CARDANO_DELEGATION: new g.RegistryType("cardano-delegation", 2209), CARDANO_SIGN_CIP8_DATA_REQUEST: new g.RegistryType("cardano-sign-cip8-data-request", 2210), CARDANO_SIGN_CIP8_DATA_SIGNATURE: new g.RegistryType("cardano-sign-cip8-data-signature", 2211), CARDANO_SIGN_TX_HASH_REQUEST: new g.RegistryType("cardano-sign-tx-hash-request", 2212) }, { decodeToDataItem: t } = g.extend;
    var d;
    (function(br) {
      br[br.transactionHash = 1] = "transactionHash", br[br.index = 2] = "index", br[br.amount = 3] = "amount", br[br.keyPath = 4] = "keyPath", br[br.address = 5] = "address";
    })(d || (d = {}));
    class E extends g.RegistryItem {
      constructor(Ar) {
        super(), this.getRegistryType = () => y.CARDANO_UTXO, this.getTransactionHash = () => this.transactionHash, this.getIndex = () => this.index, this.getKeyPath = () => this.keyPath.getPath(), this.getAmount = () => this.amount, this.getAddress = () => this.address, this.toDataItem = () => {
          const cr = {};
          this.transactionHash && (cr[d.transactionHash] = this.transactionHash), cr[d.index] = this.index, cr[d.amount] = this.amount;
          const hr = this.keyPath.toDataItem();
          return hr.setTag(this.keyPath.getRegistryType().getTag()), cr[d.keyPath] = hr, cr[d.address] = this.address, new g.DataItem(cr);
        }, this.transactionHash = Ar.transactionHash, this.index = Ar.index, this.amount = Ar.amount, this.keyPath = Ar.keyPath, this.address = Ar.address;
      }
      static constructCardanoUtxo({ transactionHash: Ar, index: cr, amount: hr, xfp: Wr, hdPath: fi, address: Bi }) {
        const $r = fi.replace(/[m|M]\//, "").split("/"), oi = new g.CryptoKeypath($r.map((zr) => {
          const ti = parseInt(zr.replace("'", "")), Lr = zr.endsWith("'");
          return new g.PathComponent({ index: ti, hardened: Lr });
        }), Buffer.from(Wr, "hex"));
        return new E({ transactionHash: Buffer.from(Ar, "hex"), index: cr, amount: hr, keyPath: oi, address: Bi });
      }
    }
    E.fromDataItem = (br) => {
      const Ar = br.getData(), cr = Ar[d.transactionHash], hr = Ar[d.index], Wr = g.CryptoKeypath.fromDataItem(Ar[d.keyPath]);
      return new E({ transactionHash: cr, index: hr, amount: Ar[d.amount], keyPath: Wr, address: Ar[d.address] });
    }, E.fromCBOR = (br) => {
      const Ar = t(br);
      return E.fromDataItem(Ar);
    };
    const { decodeToDataItem: B } = g.extend;
    var D;
    (function(br) {
      br[br.keyHash = 1] = "keyHash", br[br.keyPath = 2] = "keyPath";
    })(D || (D = {}));
    class x extends g.RegistryItem {
      constructor(Ar) {
        super(), this.getRegistryType = () => y.CARDANO_CERT_KEY, this.getKeyHash = () => this.keyHash, this.getKeyPath = () => this.keyPath.getPath(), this.toDataItem = () => {
          const cr = {};
          cr[D.keyHash] = this.keyHash;
          const hr = this.keyPath.toDataItem();
          return hr.setTag(this.keyPath.getRegistryType().getTag()), cr[D.keyPath] = hr, new g.DataItem(cr);
        }, this.keyHash = Ar.keyHash, this.keyPath = Ar.keyPath;
      }
      static constructCardanoCertKey({ keyHash: Ar, xfp: cr, keyPath: hr }) {
        const Wr = hr.replace(/[m|M]\//, "").split("/"), fi = new g.CryptoKeypath(Wr.map((Bi) => {
          const $r = parseInt(Bi.replace("'", "")), oi = Bi.endsWith("'");
          return new g.PathComponent({ index: $r, hardened: oi });
        }), Buffer.from(cr, "hex"));
        return new x({ keyHash: Buffer.from(Ar, "hex"), keyPath: fi });
      }
    }
    x.fromDataItem = (br) => {
      const Ar = br.getData(), cr = Ar[D.keyHash], hr = g.CryptoKeypath.fromDataItem(Ar[D.keyPath]);
      return new x({ keyHash: cr, keyPath: hr });
    }, x.fromCBOR = (br) => {
      const Ar = B(br);
      return x.fromDataItem(Ar);
    };
    const { decodeToDataItem: v, RegistryTypes: F } = g.extend;
    var M;
    (function(br) {
      br[br.requestId = 1] = "requestId", br[br.signData = 2] = "signData", br[br.utxos = 3] = "utxos", br[br.extraSigners = 4] = "extraSigners", br[br.origin = 5] = "origin";
    })(M || (M = {}));
    class U extends g.RegistryItem {
      constructor(Ar) {
        super(), this.getRegistryType = () => y.CARDANO_SIGN_REQUEST, this.getRequestId = () => this.requestId, this.getSignData = () => this.signData, this.getUtxos = () => this.utxos, this.getAdditionalSigners = () => this.extraSigners, this.getOrigin = () => this.origin, this.toDataItem = () => {
          const cr = {};
          return this.requestId && (cr[M.requestId] = new g.DataItem(this.requestId, F.UUID.getTag())), cr[M.signData] = this.signData, cr[M.utxos] = this.utxos.map((hr) => {
            const Wr = hr.toDataItem();
            return Wr.setTag(hr.getRegistryType().getTag()), Wr;
          }), cr[M.extraSigners] = this.extraSigners.map((hr) => {
            const Wr = hr.toDataItem();
            return Wr.setTag(hr.getRegistryType().getTag()), Wr;
          }), this.origin && (cr[M.origin] = this.origin), new g.DataItem(cr);
        }, this.requestId = Ar.requestId, this.signData = Ar.signData, this.utxos = Ar.utxos, this.extraSigners = Ar.extraSigners, this.origin = Ar.origin;
      }
      static constructCardanoSignRequest(Ar, cr, hr, Wr, fi) {
        const Bi = cr.map((oi) => E.constructCardanoUtxo(oi)), $r = hr.map((oi) => x.constructCardanoCertKey(oi));
        return new U({ requestId: Wr ? Buffer.from(c.parse(Wr)) : void 0, signData: Ar, utxos: Bi, extraSigners: $r, origin: fi || void 0 });
      }
    }
    U.fromDataItem = (br) => {
      const Ar = br.getData(), cr = Ar[M.signData], hr = Ar[M.utxos].map((Bi) => E.fromDataItem(Bi)), Wr = Ar[M.extraSigners].map((Bi) => x.fromDataItem(Bi)), fi = Ar[M.requestId] ? Ar[M.requestId].getData() : void 0;
      return new U({ requestId: fi, signData: cr, utxos: hr, extraSigners: Wr, origin: Ar[M.origin] ? Ar[M.origin] : void 0 });
    }, U.fromCBOR = (br) => {
      const Ar = v(br);
      return U.fromDataItem(Ar);
    };
    const { RegistryTypes: L, decodeToDataItem: H } = g.extend;
    var fe;
    (function(br) {
      br[br.requestId = 1] = "requestId", br[br.signature = 2] = "signature";
    })(fe || (fe = {}));
    class ge extends g.RegistryItem {
      constructor(Ar, cr) {
        super(), this.getRegistryType = () => y.CARDANO_SIGNATURE, this.getRequestId = () => this.requestId, this.getWitnessSet = () => this.witnessSet, this.toDataItem = () => {
          const hr = {};
          return this.requestId && (hr[fe.requestId] = new g.DataItem(this.requestId, L.UUID.getTag())), hr[fe.signature] = this.witnessSet, new g.DataItem(hr);
        }, this.witnessSet = Ar, this.requestId = cr;
      }
    }
    ge.fromDataItem = (br) => {
      const Ar = br.getData(), cr = Ar[fe.signature], hr = Ar[fe.requestId] ? Ar[fe.requestId].getData() : void 0;
      return new ge(cr, hr);
    }, ge.fromCBOR = (br) => {
      const Ar = H(br);
      return ge.fromDataItem(Ar);
    };
    const { decodeToDataItem: Ie, RegistryTypes: Ee } = g.extend;
    var Se;
    (function(br) {
      br[br.requestId = 1] = "requestId", br[br.signData = 2] = "signData", br[br.derivationPath = 3] = "derivationPath", br[br.origin = 4] = "origin", br[br.signType = 5] = "signType", br[br.xpub = 6] = "xpub";
    })(Se || (Se = {}));
    class ze extends g.RegistryItem {
      constructor(Ar) {
        super(), this.getRegistryType = () => y.CARDANO_SIGN_DATA_REQUEST, this.getRequestId = () => this.requestId, this.getSignData = () => this.signData, this.getDerivationPath = () => this.derivationPath.getPath(), this.getOrigin = () => this.origin, this.getXpub = () => this.xpub, this.toDataItem = () => {
          const cr = {};
          this.requestId && (cr[Se.requestId] = new g.DataItem(this.requestId, Ee.UUID.getTag())), this.origin && (cr[Se.origin] = this.origin), cr[Se.signData] = this.signData;
          const hr = this.derivationPath.toDataItem();
          return hr.setTag(this.derivationPath.getRegistryType().getTag()), cr[Se.derivationPath] = hr, cr[Se.xpub] = this.xpub, new g.DataItem(cr);
        }, this.requestId = Ar.requestId, this.signData = Ar.signData, this.derivationPath = Ar.derivationPath, this.origin = Ar.origin, this.xpub = Ar.xpub;
      }
      static constructCardanoSignDataRequest(Ar, cr, hr, Wr, fi, Bi) {
        const $r = cr.replace(/[m|M]\//, "").split("/"), oi = new g.CryptoKeypath($r.map((zr) => {
          const ti = parseInt(zr.replace("'", ""));
          let Lr = !1;
          return zr.endsWith("'") && (Lr = !0), new g.PathComponent({ index: ti, hardened: Lr });
        }), Buffer.from(hr, "hex"));
        return new ze({ requestId: fi ? Buffer.from(c.parse(fi)) : void 0, signData: Buffer.from(Ar, "hex"), derivationPath: oi, origin: Bi || void 0, xpub: Buffer.from(Wr, "hex") });
      }
    }
    ze.fromDataItem = (br) => {
      const Ar = br.getData(), cr = Ar[Se.signData], hr = g.CryptoKeypath.fromDataItem(Ar[Se.derivationPath]), Wr = Ar[Se.requestId] ? Ar[Se.requestId].getData() : void 0;
      return new ze({ requestId: Wr, signData: cr, derivationPath: hr, origin: Ar[Se.origin] ? Ar[Se.origin] : void 0, xpub: Ar[Se.xpub] });
    }, ze.fromCBOR = (br) => {
      const Ar = Ie(br);
      return ze.fromDataItem(Ar);
    };
    const { RegistryTypes: He, decodeToDataItem: Pe } = g.extend;
    var De;
    (function(br) {
      br[br.requestId = 1] = "requestId", br[br.signature = 2] = "signature", br[br.publicKey = 3] = "publicKey";
    })(De || (De = {}));
    class ve extends g.RegistryItem {
      constructor(Ar, cr, hr) {
        super(), this.getRegistryType = () => y.CARDANO_SIGNATURE, this.getRequestId = () => this.requestId, this.getSignature = () => this.signature, this.getPublicKey = () => this.publicKey, this.toDataItem = () => {
          const Wr = {};
          return this.requestId && (Wr[De.requestId] = new g.DataItem(this.requestId, He.UUID.getTag())), Wr[De.signature] = this.getSignature(), Wr[De.publicKey] = this.getPublicKey(), new g.DataItem(Wr);
        }, this.signature = Ar, this.publicKey = cr, this.requestId = hr;
      }
    }
    ve.fromDataItem = (br) => {
      const Ar = br.getData(), cr = Ar[De.signature], hr = Ar[De.publicKey], Wr = Ar[De.requestId] ? Ar[De.requestId].getData() : void 0;
      return new ve(cr, hr, Wr);
    }, ve.fromCBOR = (br) => {
      const Ar = Pe(br);
      return ve.fromDataItem(Ar);
    };
    const { decodeToDataItem: Fe } = g.extend;
    var be;
    (function(br) {
      br[br.pubKey = 1] = "pubKey", br[br.weight = 2] = "weight";
    })(be || (be = {}));
    class Be extends g.RegistryItem {
      constructor(Ar) {
        super(), this.getRegistryType = () => y.CARDANO_DELEGATION, this.getPubKey = () => this.pubKey, this.getWeight = () => this.weight, this.toDataItem = () => {
          const cr = {};
          return cr[be.pubKey] = this.getPubKey(), cr[be.weight] = this.getWeight(), new g.DataItem(cr);
        }, this.pubKey = Ar.pubKey, this.weight = Ar.weight;
      }
      static constructCardanoDelegation({ pubKey: Ar, weight: cr }) {
        return new Be({ pubKey: Ar, weight: cr });
      }
    }
    Be.fromDataItem = (br) => {
      const Ar = br.getData();
      return new Be({ pubKey: Ar[be.pubKey], weight: Ar[be.weight] });
    }, Be.fromCBOR = (br) => {
      const Ar = Fe(br);
      return Be.fromDataItem(Ar);
    };
    const { decodeToDataItem: ke, RegistryTypes: xe } = g.extend;
    var Ne;
    (function(br) {
      br[br.requestId = 1] = "requestId", br[br.delegations = 2] = "delegations", br[br.stakePub = 3] = "stakePub", br[br.paymentAddress = 4] = "paymentAddress", br[br.nonce = 5] = "nonce", br[br.voting_purpose = 6] = "voting_purpose", br[br.derivationPath = 7] = "derivationPath", br[br.origin = 8] = "origin", br[br.signType = 9] = "signType";
    })(Ne || (Ne = {}));
    const Et = (br, Ar) => {
      const cr = br.replace(/[m|M]\//, "").split("/");
      return new g.CryptoKeypath(cr.map((hr) => {
        const Wr = parseInt(hr.replace("'", ""));
        let fi = !1;
        return hr.endsWith("'") && (fi = !0), new g.PathComponent({ index: Wr, hardened: fi });
      }), Buffer.from(Ar, "hex"));
    };
    class st extends g.RegistryItem {
      constructor(Ar) {
        super(), this.getRegistryType = () => y.CARDANO_CATALYST_VOTING_REGISTRATION, this.getRequestId = () => this.requestId, this.getDelegations = () => this.delegations, this.getStakePub = () => this.stakePub, this.getPaymentAddress = () => this.paymentAddress, this.getNonce = () => this.nonce, this.getVotingPurpose = () => this.voting_purpose, this.getDerivationPath = () => this.derivationPath.getPath(), this.getOrigin = () => this.origin, this.toDataItem = () => {
          const cr = {};
          this.requestId && (cr[Ne.requestId] = new g.DataItem(this.requestId, xe.UUID.getTag())), cr[Ne.stakePub] = this.stakePub, cr[Ne.paymentAddress] = this.paymentAddress, cr[Ne.nonce] = this.nonce, cr[Ne.voting_purpose] = this.voting_purpose, cr[Ne.delegations] = this.delegations.map((Wr) => {
            const fi = Wr.toDataItem();
            return fi.setTag(Wr.getRegistryType().getTag()), fi;
          }), this.origin && (cr[Ne.origin] = this.origin);
          const hr = this.derivationPath.toDataItem();
          return hr.setTag(this.derivationPath.getRegistryType().getTag()), cr[Ne.derivationPath] = hr, new g.DataItem(cr);
        }, this.requestId = Ar.requestId, this.derivationPath = Ar.derivationPath, this.delegations = Ar.delegations, this.stakePub = Ar.stakePub, this.paymentAddress = Ar.paymentAddress, this.nonce = Ar.nonce, this.voting_purpose = Ar.voting_purpose, this.origin = Ar.origin;
      }
      static constructCardanoCatalystRequest(Ar, cr, hr, Wr, fi, Bi, $r, oi, zr) {
        const ti = oi ? Buffer.from(c.parse(oi)) : void 0, Lr = Ar.map((Rr) => Be.constructCardanoDelegation({ pubKey: Buffer.from(Rr.pubKey, "hex"), weight: Rr.weight }));
        return new st({ requestId: ti, delegations: Lr, stakePub: Buffer.from(cr, "hex"), paymentAddress: Buffer.from(hr, "hex"), nonce: Wr, voting_purpose: fi, derivationPath: Et(Bi, $r), origin: zr });
      }
    }
    st.fromDataItem = (br) => {
      const Ar = br.getData(), cr = Ar[Ne.delegations].map((zr) => Be.fromDataItem(zr)), hr = Ar[Ne.stakePub], Wr = Ar[Ne.paymentAddress], fi = Ar[Ne.nonce], Bi = Ar[Ne.voting_purpose], $r = g.CryptoKeypath.fromDataItem(Ar[Ne.derivationPath]), oi = Ar[Ne.requestId] ? Ar[Ne.requestId].getData() : void 0;
      return new st({ requestId: oi, delegations: cr, stakePub: hr, paymentAddress: Wr, nonce: fi, voting_purpose: Bi, derivationPath: $r, origin: Ar[Ne.origin] ? Ar[Ne.origin] : void 0 });
    }, st.fromCBOR = (br) => {
      const Ar = ke(br);
      return st.fromDataItem(Ar);
    };
    const { RegistryTypes: Dt, decodeToDataItem: er } = g.extend;
    var xt;
    (function(br) {
      br[br.requestId = 1] = "requestId", br[br.signature = 2] = "signature";
    })(xt || (xt = {}));
    class ir extends g.RegistryItem {
      constructor(Ar, cr) {
        super(), this.getRegistryType = () => y.CARDANO_CATALYST_VOTING_REGISTRATION_SIGNATURE, this.getRequestId = () => this.requestId, this.getSignature = () => this.signature, this.toDataItem = () => {
          const hr = {};
          return this.requestId && (hr[xt.requestId] = new g.DataItem(this.requestId, Dt.UUID.getTag())), hr[xt.signature] = this.getSignature(), new g.DataItem(hr);
        }, this.signature = Ar, this.requestId = cr;
      }
    }
    ir.fromDataItem = (br) => {
      const Ar = br.getData(), cr = Ar[xt.signature], hr = Ar[xt.requestId] ? Ar[xt.requestId].getData() : void 0;
      return new ir(cr, hr);
    }, ir.fromCBOR = (br) => {
      const Ar = er(br);
      return ir.fromDataItem(Ar);
    };
    const { decodeToDataItem: sr, RegistryTypes: yr } = g.extend;
    var wr, qr;
    (function(br) {
      br[br.requestId = 1] = "requestId", br[br.signData = 2] = "signData", br[br.derivationPath = 3] = "derivationPath", br[br.origin = 4] = "origin", br[br.signType = 5] = "signType", br[br.xpub = 6] = "xpub", br[br.hashPayload = 7] = "hashPayload", br[br.addressBench32 = 8] = "addressBench32", br[br.addressFieldType = 9] = "addressFieldType";
    })(wr || (wr = {})), (qr = o.MessageAddressFieldType || (o.MessageAddressFieldType = {})).ADDRESS = "ADDRESS", qr.KEY_HASH = "KEY_HASH";
    class Mr extends g.RegistryItem {
      constructor(Ar) {
        super(), this.getRegistryType = () => y.CARDANO_SIGN_CIP8_DATA_REQUEST, this.getRequestId = () => this.requestId, this.getSignData = () => this.signData, this.getDerivationPath = () => this.derivationPath.getPath(), this.getOrigin = () => this.origin, this.getXpub = () => this.xpub, this.getHashPayload = () => this.hashPayload, this.getAddressBench32 = () => this.addressBench32, this.getAddressFieldType = () => this.addressFieldType, this.toDataItem = () => {
          const cr = {};
          this.requestId && (cr[wr.requestId] = new g.DataItem(this.requestId, yr.UUID.getTag())), this.origin && (cr[wr.origin] = this.origin), cr[wr.signData] = this.signData;
          const hr = this.derivationPath.toDataItem();
          return hr.setTag(this.derivationPath.getRegistryType().getTag()), cr[wr.derivationPath] = hr, cr[wr.xpub] = this.xpub, cr[wr.hashPayload] = this.hashPayload, this.addressBench32 && (cr[wr.addressBench32] = this.addressBench32), cr[wr.addressFieldType] = this.addressFieldType, new g.DataItem(cr);
        }, this.requestId = Ar.requestId, this.signData = Ar.signData, this.derivationPath = Ar.derivationPath, this.origin = Ar.origin, this.xpub = Ar.xpub, this.hashPayload = Ar.hashPayload, this.addressBench32 = Ar.addressBench32, this.addressFieldType = Ar.addressFieldType;
      }
      static constructCardanoSignCip8DataRequest(Ar, cr, hr, Wr, fi, Bi, $r, oi, zr) {
        const ti = cr.replace(/[m|M]\//, "").split("/"), Lr = new g.CryptoKeypath(ti.map((Rr) => {
          const Ir = parseInt(Rr.replace("'", ""));
          let pr = !1;
          return Rr.endsWith("'") && (pr = !0), new g.PathComponent({ index: Ir, hardened: pr });
        }), Buffer.from(hr, "hex"));
        return new Mr({ requestId: oi ? Buffer.from(c.parse(oi)) : void 0, signData: Buffer.from(Ar, "hex"), derivationPath: Lr, origin: zr || void 0, xpub: Buffer.from(Wr, "hex"), hashPayload: fi, addressBench32: $r || void 0, addressFieldType: Bi });
      }
    }
    Mr.fromDataItem = (br) => {
      const Ar = br.getData(), cr = Ar[wr.signData], hr = g.CryptoKeypath.fromDataItem(Ar[wr.derivationPath]), Wr = Ar[wr.requestId] ? Ar[wr.requestId].getData() : void 0;
      return new Mr({ requestId: Wr, signData: cr, derivationPath: hr, origin: Ar[wr.origin] ? Ar[wr.origin] : void 0, xpub: Ar[wr.xpub], hashPayload: Ar[wr.hashPayload], addressBench32: Ar[wr.addressBench32] ? Ar[wr.addressBench32] : void 0, addressFieldType: Ar[wr.addressFieldType] });
    }, Mr.fromCBOR = (br) => {
      const Ar = sr(br);
      return Mr.fromDataItem(Ar);
    };
    const { RegistryTypes: Dr, decodeToDataItem: Qr } = g.extend;
    var Xr;
    (function(br) {
      br[br.requestId = 1] = "requestId", br[br.signature = 2] = "signature", br[br.publicKey = 3] = "publicKey", br[br.addressField = 4] = "addressField";
    })(Xr || (Xr = {}));
    class Vr extends g.RegistryItem {
      constructor(Ar, cr, hr, Wr) {
        super(), this.getRegistryType = () => y.CARDANO_SIGNATURE, this.getRequestId = () => this.requestId, this.getSignature = () => this.signature, this.getPublicKey = () => this.publicKey, this.getAddressField = () => this.addressField, this.toDataItem = () => {
          const fi = {};
          return this.requestId && (fi[Xr.requestId] = new g.DataItem(this.requestId, Dr.UUID.getTag())), fi[Xr.signature] = this.getSignature(), fi[Xr.publicKey] = this.getPublicKey(), fi[Xr.addressField] = this.getAddressField(), new g.DataItem(fi);
        }, this.signature = Ar, this.publicKey = cr, this.requestId = Wr, this.addressField = hr;
      }
    }
    Vr.fromDataItem = (br) => {
      const Ar = br.getData(), cr = Ar[Xr.signature], hr = Ar[Xr.publicKey], Wr = Ar[Xr.requestId] ? Ar[Xr.requestId].getData() : void 0;
      return new Vr(cr, hr, Ar[Xr.addressField], Wr);
    }, Vr.fromCBOR = (br) => {
      const Ar = Qr(br);
      return Vr.fromDataItem(Ar);
    };
    const { decodeToDataItem: Ur, RegistryTypes: Sr } = g.extend;
    var Gr;
    (function(br) {
      br[br.requestId = 1] = "requestId", br[br.txHash = 2] = "txHash", br[br.paths = 3] = "paths", br[br.origin = 4] = "origin", br[br.address_list = 5] = "address_list";
    })(Gr || (Gr = {}));
    class Fr extends g.RegistryItem {
      constructor(Ar) {
        super(), this.getRegistryType = () => y.CARDANO_SIGN_TX_HASH_REQUEST, this.getRequestId = () => this.requestId, this.getTxHash = () => this.txHash, this.getPaths = () => this.paths, this.getOrigin = () => this.origin, this.getAddressList = () => this.addressList, this.toDataItem = () => {
          const cr = {};
          return this.requestId && (cr[Gr.requestId] = new g.DataItem(this.requestId, Sr.UUID.getTag())), cr[Gr.txHash] = this.txHash, cr[Gr.paths] = this.paths.map((hr) => {
            const Wr = hr.toDataItem();
            return Wr.setTag(hr.getRegistryType().getTag()), Wr;
          }), this.origin && (cr[Gr.origin] = this.origin), cr[Gr.address_list] = this.addressList, new g.DataItem(cr);
        }, this.requestId = Ar.requestId, this.txHash = Ar.txHash, this.paths = Ar.paths, this.origin = Ar.origin, this.addressList = Ar.addressList;
      }
      static constructCardanoSignTxHashRequest(Ar, cr, hr, Wr, fi) {
        return new Fr({ requestId: Wr ? Buffer.from(c.parse(Wr)) : void 0, txHash: Ar, paths: cr, origin: fi || void 0, addressList: hr });
      }
    }
    Fr.fromDataItem = (br) => {
      const Ar = br.getData(), cr = Ar[Gr.txHash], hr = Ar[Gr.paths], Wr = Ar[Gr.requestId] ? Ar[Gr.requestId].getData() : void 0;
      return new Fr({ requestId: Wr, txHash: cr, paths: hr, origin: Ar[Gr.origin] ? Ar[Gr.origin] : void 0, addressList: Ar[Gr.address_list] ? Ar[Gr.address_list] : [] });
    }, Fr.fromCBOR = (br) => {
      const Ar = Ur(br);
      return Fr.fromDataItem(Ar);
    }, g.patchTags(Object.values(y).filter((br) => !!br.getTag()).map((br) => br.getTag())), Object.keys(g).forEach(function(br) {
      br !== "default" && Object.defineProperty(o, br, { enumerable: !0, get: function() {
        return g[br];
      } });
    }), o.CardanoCatalystRequest = st, o.CardanoCatalystSignature = ir, o.CardanoCertKey = x, o.CardanoSignCip8DataRequest = Mr, o.CardanoSignCip8DataSignature = Vr, o.CardanoSignDataRequest = ze, o.CardanoSignDataSignature = ve, o.CardanoSignRequest = U, o.CardanoSignTxHashRequest = Fr, o.CardanoSignature = ge;
  }(bcUrRegistryCardano_cjs_production_min)), bcUrRegistryCardano_cjs_production_min;
}
var bcUrRegistryCardano_cjs_development = {}, hasRequiredBcUrRegistryCardano_cjs_development;
function requireBcUrRegistryCardano_cjs_development() {
  return hasRequiredBcUrRegistryCardano_cjs_development || (hasRequiredBcUrRegistryCardano_cjs_development = 1, function(o) {
    Object.defineProperty(o, "__esModule", { value: !0 });
    var g = requireDist$n(), c = require$$1$3;
    const y = {
      CARDANO_UTXO: /* @__PURE__ */ new g.RegistryType("cardano-utxo", 2201),
      CARDANO_SIGN_REQUEST: /* @__PURE__ */ new g.RegistryType("cardano-sign-request", 2202),
      CARDANO_SIGNATURE: /* @__PURE__ */ new g.RegistryType("cardano-signature", 2203),
      CARDANO_CERT_KEY: /* @__PURE__ */ new g.RegistryType("cardano-cert-key", 2204),
      CARDANO_SIGN_DATA_REQUEST: /* @__PURE__ */ new g.RegistryType("cardano-sign-data-request", 2205),
      CARDANO_SIGN_DATA_SIGNATURE: /* @__PURE__ */ new g.RegistryType("cardano-sign-data-signature", 2206),
      CARDANO_CATALYST_VOTING_REGISTRATION: /* @__PURE__ */ new g.RegistryType("cardano-catalyst-voting-registration", 2207),
      CARDANO_CATALYST_VOTING_REGISTRATION_SIGNATURE: /* @__PURE__ */ new g.RegistryType("cardano-catalyst-voting-registration-signature", 2208),
      CARDANO_DELEGATION: /* @__PURE__ */ new g.RegistryType("cardano-delegation", 2209),
      CARDANO_SIGN_CIP8_DATA_REQUEST: /* @__PURE__ */ new g.RegistryType("cardano-sign-cip8-data-request", 2210),
      CARDANO_SIGN_CIP8_DATA_SIGNATURE: /* @__PURE__ */ new g.RegistryType("cardano-sign-cip8-data-signature", 2211),
      CARDANO_SIGN_TX_HASH_REQUEST: /* @__PURE__ */ new g.RegistryType("cardano-sign-tx-hash-request", 2212)
    }, {
      decodeToDataItem: t
    } = g.extend;
    var d;
    (function(Fr) {
      Fr[Fr.transactionHash = 1] = "transactionHash", Fr[Fr.index = 2] = "index", Fr[Fr.amount = 3] = "amount", Fr[Fr.keyPath = 4] = "keyPath", Fr[Fr.address = 5] = "address";
    })(d || (d = {}));
    class E extends g.RegistryItem {
      constructor(br) {
        super(), this.getRegistryType = () => y.CARDANO_UTXO, this.getTransactionHash = () => this.transactionHash, this.getIndex = () => this.index, this.getKeyPath = () => this.keyPath.getPath(), this.getAmount = () => this.amount, this.getAddress = () => this.address, this.toDataItem = () => {
          const Ar = {};
          this.transactionHash && (Ar[d.transactionHash] = this.transactionHash), Ar[d.index] = this.index, Ar[d.amount] = this.amount;
          const cr = this.keyPath.toDataItem();
          return cr.setTag(this.keyPath.getRegistryType().getTag()), Ar[d.keyPath] = cr, Ar[d.address] = this.address, new g.DataItem(Ar);
        }, this.transactionHash = br.transactionHash, this.index = br.index, this.amount = br.amount, this.keyPath = br.keyPath, this.address = br.address;
      }
      static constructCardanoUtxo({
        transactionHash: br,
        index: Ar,
        amount: cr,
        xfp: hr,
        hdPath: Wr,
        address: fi
      }) {
        const Bi = Wr.replace(/[m|M]\//, "").split("/"), $r = new g.CryptoKeypath(Bi.map((oi) => {
          const zr = parseInt(oi.replace("'", "")), ti = oi.endsWith("'");
          return new g.PathComponent({
            index: zr,
            hardened: ti
          });
        }), Buffer.from(hr, "hex"));
        return new E({
          transactionHash: Buffer.from(br, "hex"),
          index: Ar,
          amount: cr,
          keyPath: $r,
          address: fi
        });
      }
    }
    E.fromDataItem = (Fr) => {
      const br = Fr.getData(), Ar = br[d.transactionHash], cr = br[d.index], hr = g.CryptoKeypath.fromDataItem(br[d.keyPath]), Wr = br[d.address], fi = br[d.amount];
      return new E({
        transactionHash: Ar,
        index: cr,
        amount: fi,
        keyPath: hr,
        address: Wr
      });
    }, E.fromCBOR = (Fr) => {
      const br = t(Fr);
      return E.fromDataItem(br);
    };
    const {
      decodeToDataItem: B
    } = g.extend;
    var D;
    (function(Fr) {
      Fr[Fr.keyHash = 1] = "keyHash", Fr[Fr.keyPath = 2] = "keyPath";
    })(D || (D = {}));
    class x extends g.RegistryItem {
      constructor(br) {
        super(), this.getRegistryType = () => y.CARDANO_CERT_KEY, this.getKeyHash = () => this.keyHash, this.getKeyPath = () => this.keyPath.getPath(), this.toDataItem = () => {
          const Ar = {};
          Ar[D.keyHash] = this.keyHash;
          const cr = this.keyPath.toDataItem();
          return cr.setTag(this.keyPath.getRegistryType().getTag()), Ar[D.keyPath] = cr, new g.DataItem(Ar);
        }, this.keyHash = br.keyHash, this.keyPath = br.keyPath;
      }
      static constructCardanoCertKey({
        keyHash: br,
        xfp: Ar,
        keyPath: cr
      }) {
        const hr = cr.replace(/[m|M]\//, "").split("/"), Wr = new g.CryptoKeypath(hr.map((fi) => {
          const Bi = parseInt(fi.replace("'", "")), $r = fi.endsWith("'");
          return new g.PathComponent({
            index: Bi,
            hardened: $r
          });
        }), Buffer.from(Ar, "hex"));
        return new x({
          keyHash: Buffer.from(br, "hex"),
          keyPath: Wr
        });
      }
    }
    x.fromDataItem = (Fr) => {
      const br = Fr.getData(), Ar = br[D.keyHash], cr = g.CryptoKeypath.fromDataItem(br[D.keyPath]);
      return new x({
        keyHash: Ar,
        keyPath: cr
      });
    }, x.fromCBOR = (Fr) => {
      const br = B(Fr);
      return x.fromDataItem(br);
    };
    const {
      decodeToDataItem: v,
      RegistryTypes: F
    } = g.extend;
    var M;
    (function(Fr) {
      Fr[Fr.requestId = 1] = "requestId", Fr[Fr.signData = 2] = "signData", Fr[Fr.utxos = 3] = "utxos", Fr[Fr.extraSigners = 4] = "extraSigners", Fr[Fr.origin = 5] = "origin";
    })(M || (M = {}));
    class U extends g.RegistryItem {
      constructor(br) {
        super(), this.getRegistryType = () => y.CARDANO_SIGN_REQUEST, this.getRequestId = () => this.requestId, this.getSignData = () => this.signData, this.getUtxos = () => this.utxos, this.getAdditionalSigners = () => this.extraSigners, this.getOrigin = () => this.origin, this.toDataItem = () => {
          const Ar = {};
          return this.requestId && (Ar[M.requestId] = new g.DataItem(this.requestId, F.UUID.getTag())), Ar[M.signData] = this.signData, Ar[M.utxos] = this.utxos.map((cr) => {
            const hr = cr.toDataItem();
            return hr.setTag(cr.getRegistryType().getTag()), hr;
          }), Ar[M.extraSigners] = this.extraSigners.map((cr) => {
            const hr = cr.toDataItem();
            return hr.setTag(cr.getRegistryType().getTag()), hr;
          }), this.origin && (Ar[M.origin] = this.origin), new g.DataItem(Ar);
        }, this.requestId = br.requestId, this.signData = br.signData, this.utxos = br.utxos, this.extraSigners = br.extraSigners, this.origin = br.origin;
      }
      static constructCardanoSignRequest(br, Ar, cr, hr, Wr) {
        const fi = Ar.map(($r) => E.constructCardanoUtxo($r)), Bi = cr.map(($r) => x.constructCardanoCertKey($r));
        return new U({
          requestId: hr ? Buffer.from(c.parse(hr)) : void 0,
          signData: br,
          utxos: fi,
          extraSigners: Bi,
          origin: Wr || void 0
        });
      }
    }
    U.fromDataItem = (Fr) => {
      const br = Fr.getData(), Ar = br[M.signData], cr = br[M.utxos].map((Bi) => E.fromDataItem(Bi)), hr = br[M.extraSigners].map((Bi) => x.fromDataItem(Bi)), Wr = br[M.requestId] ? br[M.requestId].getData() : void 0, fi = br[M.origin] ? br[M.origin] : void 0;
      return new U({
        requestId: Wr,
        signData: Ar,
        utxos: cr,
        extraSigners: hr,
        origin: fi
      });
    }, U.fromCBOR = (Fr) => {
      const br = v(Fr);
      return U.fromDataItem(br);
    };
    const {
      RegistryTypes: L,
      decodeToDataItem: H
    } = g.extend;
    var fe;
    (function(Fr) {
      Fr[Fr.requestId = 1] = "requestId", Fr[Fr.signature = 2] = "signature";
    })(fe || (fe = {}));
    class ge extends g.RegistryItem {
      constructor(br, Ar) {
        super(), this.getRegistryType = () => y.CARDANO_SIGNATURE, this.getRequestId = () => this.requestId, this.getWitnessSet = () => this.witnessSet, this.toDataItem = () => {
          const cr = {};
          return this.requestId && (cr[fe.requestId] = new g.DataItem(this.requestId, L.UUID.getTag())), cr[fe.signature] = this.witnessSet, new g.DataItem(cr);
        }, this.witnessSet = br, this.requestId = Ar;
      }
    }
    ge.fromDataItem = (Fr) => {
      const br = Fr.getData(), Ar = br[fe.signature], cr = br[fe.requestId] ? br[fe.requestId].getData() : void 0;
      return new ge(Ar, cr);
    }, ge.fromCBOR = (Fr) => {
      const br = H(Fr);
      return ge.fromDataItem(br);
    };
    const {
      decodeToDataItem: Ie,
      RegistryTypes: Ee
    } = g.extend;
    var Se;
    (function(Fr) {
      Fr[Fr.requestId = 1] = "requestId", Fr[Fr.signData = 2] = "signData", Fr[Fr.derivationPath = 3] = "derivationPath", Fr[Fr.origin = 4] = "origin", Fr[Fr.signType = 5] = "signType", Fr[Fr.xpub = 6] = "xpub";
    })(Se || (Se = {}));
    class ze extends g.RegistryItem {
      constructor(br) {
        super(), this.getRegistryType = () => y.CARDANO_SIGN_DATA_REQUEST, this.getRequestId = () => this.requestId, this.getSignData = () => this.signData, this.getDerivationPath = () => this.derivationPath.getPath(), this.getOrigin = () => this.origin, this.getXpub = () => this.xpub, this.toDataItem = () => {
          const Ar = {};
          this.requestId && (Ar[Se.requestId] = new g.DataItem(this.requestId, Ee.UUID.getTag())), this.origin && (Ar[Se.origin] = this.origin), Ar[Se.signData] = this.signData;
          const cr = this.derivationPath.toDataItem();
          return cr.setTag(this.derivationPath.getRegistryType().getTag()), Ar[Se.derivationPath] = cr, Ar[Se.xpub] = this.xpub, new g.DataItem(Ar);
        }, this.requestId = br.requestId, this.signData = br.signData, this.derivationPath = br.derivationPath, this.origin = br.origin, this.xpub = br.xpub;
      }
      static constructCardanoSignDataRequest(br, Ar, cr, hr, Wr, fi) {
        const Bi = Ar.replace(/[m|M]\//, "").split("/"), $r = new g.CryptoKeypath(Bi.map((oi) => {
          const zr = parseInt(oi.replace("'", ""));
          let ti = !1;
          return oi.endsWith("'") && (ti = !0), new g.PathComponent({
            index: zr,
            hardened: ti
          });
        }), Buffer.from(cr, "hex"));
        return new ze({
          requestId: Wr ? Buffer.from(c.parse(Wr)) : void 0,
          signData: Buffer.from(br, "hex"),
          derivationPath: $r,
          origin: fi || void 0,
          xpub: Buffer.from(hr, "hex")
        });
      }
    }
    ze.fromDataItem = (Fr) => {
      const br = Fr.getData(), Ar = br[Se.signData], cr = g.CryptoKeypath.fromDataItem(br[Se.derivationPath]), hr = br[Se.requestId] ? br[Se.requestId].getData() : void 0, Wr = br[Se.origin] ? br[Se.origin] : void 0, fi = br[Se.xpub];
      return new ze({
        requestId: hr,
        signData: Ar,
        derivationPath: cr,
        origin: Wr,
        xpub: fi
      });
    }, ze.fromCBOR = (Fr) => {
      const br = Ie(Fr);
      return ze.fromDataItem(br);
    };
    const {
      RegistryTypes: He,
      decodeToDataItem: Pe
    } = g.extend;
    var De;
    (function(Fr) {
      Fr[Fr.requestId = 1] = "requestId", Fr[Fr.signature = 2] = "signature", Fr[Fr.publicKey = 3] = "publicKey";
    })(De || (De = {}));
    class ve extends g.RegistryItem {
      constructor(br, Ar, cr) {
        super(), this.getRegistryType = () => y.CARDANO_SIGNATURE, this.getRequestId = () => this.requestId, this.getSignature = () => this.signature, this.getPublicKey = () => this.publicKey, this.toDataItem = () => {
          const hr = {};
          return this.requestId && (hr[De.requestId] = new g.DataItem(this.requestId, He.UUID.getTag())), hr[De.signature] = this.getSignature(), hr[De.publicKey] = this.getPublicKey(), new g.DataItem(hr);
        }, this.signature = br, this.publicKey = Ar, this.requestId = cr;
      }
    }
    ve.fromDataItem = (Fr) => {
      const br = Fr.getData(), Ar = br[De.signature], cr = br[De.publicKey], hr = br[De.requestId] ? br[De.requestId].getData() : void 0;
      return new ve(Ar, cr, hr);
    }, ve.fromCBOR = (Fr) => {
      const br = Pe(Fr);
      return ve.fromDataItem(br);
    };
    const {
      decodeToDataItem: Fe
    } = g.extend;
    var be;
    (function(Fr) {
      Fr[Fr.pubKey = 1] = "pubKey", Fr[Fr.weight = 2] = "weight";
    })(be || (be = {}));
    class Be extends g.RegistryItem {
      constructor(br) {
        super(), this.getRegistryType = () => y.CARDANO_DELEGATION, this.getPubKey = () => this.pubKey, this.getWeight = () => this.weight, this.toDataItem = () => {
          const Ar = {};
          return Ar[be.pubKey] = this.getPubKey(), Ar[be.weight] = this.getWeight(), new g.DataItem(Ar);
        }, this.pubKey = br.pubKey, this.weight = br.weight;
      }
      static constructCardanoDelegation({
        pubKey: br,
        weight: Ar
      }) {
        return new Be({
          pubKey: br,
          weight: Ar
        });
      }
    }
    Be.fromDataItem = (Fr) => {
      const br = Fr.getData(), Ar = br[be.pubKey], cr = br[be.weight];
      return new Be({
        pubKey: Ar,
        weight: cr
      });
    }, Be.fromCBOR = (Fr) => {
      const br = Fe(Fr);
      return Be.fromDataItem(br);
    };
    const {
      decodeToDataItem: ke,
      RegistryTypes: xe
    } = g.extend;
    var Ne;
    (function(Fr) {
      Fr[Fr.requestId = 1] = "requestId", Fr[Fr.delegations = 2] = "delegations", Fr[Fr.stakePub = 3] = "stakePub", Fr[Fr.paymentAddress = 4] = "paymentAddress", Fr[Fr.nonce = 5] = "nonce", Fr[Fr.voting_purpose = 6] = "voting_purpose", Fr[Fr.derivationPath = 7] = "derivationPath", Fr[Fr.origin = 8] = "origin", Fr[Fr.signType = 9] = "signType";
    })(Ne || (Ne = {}));
    const Et = (Fr, br) => {
      const Ar = Fr.replace(/[m|M]\//, "").split("/");
      return new g.CryptoKeypath(Ar.map((cr) => {
        const hr = parseInt(cr.replace("'", ""));
        let Wr = !1;
        return cr.endsWith("'") && (Wr = !0), new g.PathComponent({
          index: hr,
          hardened: Wr
        });
      }), Buffer.from(br, "hex"));
    };
    class st extends g.RegistryItem {
      constructor(br) {
        super(), this.getRegistryType = () => y.CARDANO_CATALYST_VOTING_REGISTRATION, this.getRequestId = () => this.requestId, this.getDelegations = () => this.delegations, this.getStakePub = () => this.stakePub, this.getPaymentAddress = () => this.paymentAddress, this.getNonce = () => this.nonce, this.getVotingPurpose = () => this.voting_purpose, this.getDerivationPath = () => this.derivationPath.getPath(), this.getOrigin = () => this.origin, this.toDataItem = () => {
          const Ar = {};
          this.requestId && (Ar[Ne.requestId] = new g.DataItem(this.requestId, xe.UUID.getTag())), Ar[Ne.stakePub] = this.stakePub, Ar[Ne.paymentAddress] = this.paymentAddress, Ar[Ne.nonce] = this.nonce, Ar[Ne.voting_purpose] = this.voting_purpose, Ar[Ne.delegations] = this.delegations.map((hr) => {
            const Wr = hr.toDataItem();
            return Wr.setTag(hr.getRegistryType().getTag()), Wr;
          }), this.origin && (Ar[Ne.origin] = this.origin);
          const cr = this.derivationPath.toDataItem();
          return cr.setTag(this.derivationPath.getRegistryType().getTag()), Ar[Ne.derivationPath] = cr, new g.DataItem(Ar);
        }, this.requestId = br.requestId, this.derivationPath = br.derivationPath, this.delegations = br.delegations, this.stakePub = br.stakePub, this.paymentAddress = br.paymentAddress, this.nonce = br.nonce, this.voting_purpose = br.voting_purpose, this.origin = br.origin;
      }
      static constructCardanoCatalystRequest(br, Ar, cr, hr, Wr, fi, Bi, $r, oi) {
        const zr = $r ? Buffer.from(c.parse($r)) : void 0, ti = br.map((Lr) => Be.constructCardanoDelegation({
          pubKey: Buffer.from(Lr.pubKey, "hex"),
          weight: Lr.weight
        }));
        return new st({
          requestId: zr,
          delegations: ti,
          stakePub: Buffer.from(Ar, "hex"),
          paymentAddress: Buffer.from(cr, "hex"),
          nonce: hr,
          voting_purpose: Wr,
          derivationPath: Et(fi, Bi),
          origin: oi
        });
      }
    }
    st.fromDataItem = (Fr) => {
      const br = Fr.getData(), Ar = br[Ne.delegations].map((zr) => Be.fromDataItem(zr)), cr = br[Ne.stakePub], hr = br[Ne.paymentAddress], Wr = br[Ne.nonce], fi = br[Ne.voting_purpose], Bi = g.CryptoKeypath.fromDataItem(br[Ne.derivationPath]), $r = br[Ne.requestId] ? br[Ne.requestId].getData() : void 0, oi = br[Ne.origin] ? br[Ne.origin] : void 0;
      return new st({
        requestId: $r,
        delegations: Ar,
        stakePub: cr,
        paymentAddress: hr,
        nonce: Wr,
        voting_purpose: fi,
        derivationPath: Bi,
        origin: oi
      });
    }, st.fromCBOR = (Fr) => {
      const br = ke(Fr);
      return st.fromDataItem(br);
    };
    const {
      RegistryTypes: Dt,
      decodeToDataItem: er
    } = g.extend;
    var xt;
    (function(Fr) {
      Fr[Fr.requestId = 1] = "requestId", Fr[Fr.signature = 2] = "signature";
    })(xt || (xt = {}));
    class ir extends g.RegistryItem {
      constructor(br, Ar) {
        super(), this.getRegistryType = () => y.CARDANO_CATALYST_VOTING_REGISTRATION_SIGNATURE, this.getRequestId = () => this.requestId, this.getSignature = () => this.signature, this.toDataItem = () => {
          const cr = {};
          return this.requestId && (cr[xt.requestId] = new g.DataItem(this.requestId, Dt.UUID.getTag())), cr[xt.signature] = this.getSignature(), new g.DataItem(cr);
        }, this.signature = br, this.requestId = Ar;
      }
    }
    ir.fromDataItem = (Fr) => {
      const br = Fr.getData(), Ar = br[xt.signature], cr = br[xt.requestId] ? br[xt.requestId].getData() : void 0;
      return new ir(Ar, cr);
    }, ir.fromCBOR = (Fr) => {
      const br = er(Fr);
      return ir.fromDataItem(br);
    };
    const {
      decodeToDataItem: sr,
      RegistryTypes: yr
    } = g.extend;
    var wr;
    (function(Fr) {
      Fr[Fr.requestId = 1] = "requestId", Fr[Fr.signData = 2] = "signData", Fr[Fr.derivationPath = 3] = "derivationPath", Fr[Fr.origin = 4] = "origin", Fr[Fr.signType = 5] = "signType", Fr[Fr.xpub = 6] = "xpub", Fr[Fr.hashPayload = 7] = "hashPayload", Fr[Fr.addressBench32 = 8] = "addressBench32", Fr[Fr.addressFieldType = 9] = "addressFieldType";
    })(wr || (wr = {})), function(Fr) {
      Fr.ADDRESS = "ADDRESS", Fr.KEY_HASH = "KEY_HASH";
    }(o.MessageAddressFieldType || (o.MessageAddressFieldType = {}));
    class qr extends g.RegistryItem {
      constructor(br) {
        super(), this.getRegistryType = () => y.CARDANO_SIGN_CIP8_DATA_REQUEST, this.getRequestId = () => this.requestId, this.getSignData = () => this.signData, this.getDerivationPath = () => this.derivationPath.getPath(), this.getOrigin = () => this.origin, this.getXpub = () => this.xpub, this.getHashPayload = () => this.hashPayload, this.getAddressBench32 = () => this.addressBench32, this.getAddressFieldType = () => this.addressFieldType, this.toDataItem = () => {
          const Ar = {};
          this.requestId && (Ar[wr.requestId] = new g.DataItem(this.requestId, yr.UUID.getTag())), this.origin && (Ar[wr.origin] = this.origin), Ar[wr.signData] = this.signData;
          const cr = this.derivationPath.toDataItem();
          return cr.setTag(this.derivationPath.getRegistryType().getTag()), Ar[wr.derivationPath] = cr, Ar[wr.xpub] = this.xpub, Ar[wr.hashPayload] = this.hashPayload, this.addressBench32 && (Ar[wr.addressBench32] = this.addressBench32), Ar[wr.addressFieldType] = this.addressFieldType, new g.DataItem(Ar);
        }, this.requestId = br.requestId, this.signData = br.signData, this.derivationPath = br.derivationPath, this.origin = br.origin, this.xpub = br.xpub, this.hashPayload = br.hashPayload, this.addressBench32 = br.addressBench32, this.addressFieldType = br.addressFieldType;
      }
      static constructCardanoSignCip8DataRequest(br, Ar, cr, hr, Wr, fi, Bi, $r, oi) {
        const zr = Ar.replace(/[m|M]\//, "").split("/"), ti = new g.CryptoKeypath(zr.map((Lr) => {
          const Rr = parseInt(Lr.replace("'", ""));
          let Ir = !1;
          return Lr.endsWith("'") && (Ir = !0), new g.PathComponent({
            index: Rr,
            hardened: Ir
          });
        }), Buffer.from(cr, "hex"));
        return new qr({
          requestId: $r ? Buffer.from(c.parse($r)) : void 0,
          signData: Buffer.from(br, "hex"),
          derivationPath: ti,
          origin: oi || void 0,
          xpub: Buffer.from(hr, "hex"),
          hashPayload: Wr,
          addressBench32: Bi || void 0,
          addressFieldType: fi
        });
      }
    }
    qr.fromDataItem = (Fr) => {
      const br = Fr.getData(), Ar = br[wr.signData], cr = g.CryptoKeypath.fromDataItem(br[wr.derivationPath]), hr = br[wr.requestId] ? br[wr.requestId].getData() : void 0, Wr = br[wr.origin] ? br[wr.origin] : void 0, fi = br[wr.xpub], Bi = br[wr.hashPayload], $r = br[wr.addressBench32] ? br[wr.addressBench32] : void 0, oi = br[wr.addressFieldType];
      return new qr({
        requestId: hr,
        signData: Ar,
        derivationPath: cr,
        origin: Wr,
        xpub: fi,
        hashPayload: Bi,
        addressBench32: $r,
        addressFieldType: oi
      });
    }, qr.fromCBOR = (Fr) => {
      const br = sr(Fr);
      return qr.fromDataItem(br);
    };
    const {
      RegistryTypes: Mr,
      decodeToDataItem: Dr
    } = g.extend;
    var Qr;
    (function(Fr) {
      Fr[Fr.requestId = 1] = "requestId", Fr[Fr.signature = 2] = "signature", Fr[Fr.publicKey = 3] = "publicKey", Fr[Fr.addressField = 4] = "addressField";
    })(Qr || (Qr = {}));
    class Xr extends g.RegistryItem {
      constructor(br, Ar, cr, hr) {
        super(), this.getRegistryType = () => y.CARDANO_SIGNATURE, this.getRequestId = () => this.requestId, this.getSignature = () => this.signature, this.getPublicKey = () => this.publicKey, this.getAddressField = () => this.addressField, this.toDataItem = () => {
          const Wr = {};
          return this.requestId && (Wr[Qr.requestId] = new g.DataItem(this.requestId, Mr.UUID.getTag())), Wr[Qr.signature] = this.getSignature(), Wr[Qr.publicKey] = this.getPublicKey(), Wr[Qr.addressField] = this.getAddressField(), new g.DataItem(Wr);
        }, this.signature = br, this.publicKey = Ar, this.requestId = hr, this.addressField = cr;
      }
    }
    Xr.fromDataItem = (Fr) => {
      const br = Fr.getData(), Ar = br[Qr.signature], cr = br[Qr.publicKey], hr = br[Qr.requestId] ? br[Qr.requestId].getData() : void 0, Wr = br[Qr.addressField];
      return new Xr(Ar, cr, Wr, hr);
    }, Xr.fromCBOR = (Fr) => {
      const br = Dr(Fr);
      return Xr.fromDataItem(br);
    };
    const {
      decodeToDataItem: Vr,
      RegistryTypes: Ur
    } = g.extend;
    var Sr;
    (function(Fr) {
      Fr[Fr.requestId = 1] = "requestId", Fr[Fr.txHash = 2] = "txHash", Fr[Fr.paths = 3] = "paths", Fr[Fr.origin = 4] = "origin", Fr[Fr.address_list = 5] = "address_list";
    })(Sr || (Sr = {}));
    class Gr extends g.RegistryItem {
      constructor(br) {
        super(), this.getRegistryType = () => y.CARDANO_SIGN_TX_HASH_REQUEST, this.getRequestId = () => this.requestId, this.getTxHash = () => this.txHash, this.getPaths = () => this.paths, this.getOrigin = () => this.origin, this.getAddressList = () => this.addressList, this.toDataItem = () => {
          const Ar = {};
          return this.requestId && (Ar[Sr.requestId] = new g.DataItem(this.requestId, Ur.UUID.getTag())), Ar[Sr.txHash] = this.txHash, Ar[Sr.paths] = this.paths.map((cr) => {
            const hr = cr.toDataItem();
            return hr.setTag(cr.getRegistryType().getTag()), hr;
          }), this.origin && (Ar[Sr.origin] = this.origin), Ar[Sr.address_list] = this.addressList, new g.DataItem(Ar);
        }, this.requestId = br.requestId, this.txHash = br.txHash, this.paths = br.paths, this.origin = br.origin, this.addressList = br.addressList;
      }
      static constructCardanoSignTxHashRequest(br, Ar, cr, hr, Wr) {
        return new Gr({
          requestId: hr ? Buffer.from(c.parse(hr)) : void 0,
          txHash: br,
          paths: Ar,
          origin: Wr || void 0,
          addressList: cr
        });
      }
    }
    Gr.fromDataItem = (Fr) => {
      const br = Fr.getData(), Ar = br[Sr.txHash], cr = br[Sr.paths], hr = br[Sr.requestId] ? br[Sr.requestId].getData() : void 0, Wr = br[Sr.origin] ? br[Sr.origin] : void 0, fi = br[Sr.address_list] ? br[Sr.address_list] : [];
      return new Gr({
        requestId: hr,
        txHash: Ar,
        paths: cr,
        origin: Wr,
        addressList: fi
      });
    }, Gr.fromCBOR = (Fr) => {
      const br = Vr(Fr);
      return Gr.fromDataItem(br);
    }, g.patchTags(Object.values(y).filter((Fr) => !!Fr.getTag()).map((Fr) => Fr.getTag())), Object.keys(g).forEach(function(Fr) {
      Fr !== "default" && Object.defineProperty(o, Fr, {
        enumerable: !0,
        get: function() {
          return g[Fr];
        }
      });
    }), o.CardanoCatalystRequest = st, o.CardanoCatalystSignature = ir, o.CardanoCertKey = x, o.CardanoSignCip8DataRequest = qr, o.CardanoSignCip8DataSignature = Xr, o.CardanoSignDataRequest = ze, o.CardanoSignDataSignature = ve, o.CardanoSignRequest = U, o.CardanoSignTxHashRequest = Gr, o.CardanoSignature = ge;
  }(bcUrRegistryCardano_cjs_development)), bcUrRegistryCardano_cjs_development;
}
var hasRequiredDist$d;
function requireDist$d() {
  return hasRequiredDist$d || (hasRequiredDist$d = 1, process$1.env.NODE_ENV === "production" ? dist$c.exports = requireBcUrRegistryCardano_cjs_production_min() : dist$c.exports = requireBcUrRegistryCardano_cjs_development()), dist$c.exports;
}
var blake2b$1 = {}, blake2 = {}, _blake = {}, hasRequired_blake;
function require_blake() {
  if (hasRequired_blake) return _blake;
  hasRequired_blake = 1, Object.defineProperty(_blake, "__esModule", { value: !0 }), _blake.BSIGMA = void 0, _blake.G1s = g, _blake.G2s = c;
  const o = /* @__PURE__ */ requireUtils$j();
  _blake.BSIGMA = Uint8Array.from([
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    14,
    10,
    4,
    8,
    9,
    15,
    13,
    6,
    1,
    12,
    0,
    2,
    11,
    7,
    5,
    3,
    11,
    8,
    12,
    0,
    5,
    2,
    15,
    13,
    10,
    14,
    3,
    6,
    7,
    1,
    9,
    4,
    7,
    9,
    3,
    1,
    13,
    12,
    11,
    14,
    2,
    6,
    5,
    10,
    4,
    0,
    15,
    8,
    9,
    0,
    5,
    7,
    2,
    4,
    10,
    15,
    14,
    1,
    11,
    12,
    6,
    8,
    3,
    13,
    2,
    12,
    6,
    10,
    0,
    11,
    8,
    3,
    4,
    13,
    7,
    5,
    15,
    14,
    1,
    9,
    12,
    5,
    1,
    15,
    14,
    13,
    4,
    10,
    0,
    7,
    6,
    3,
    9,
    2,
    8,
    11,
    13,
    11,
    7,
    14,
    12,
    1,
    3,
    9,
    5,
    0,
    15,
    4,
    8,
    6,
    2,
    10,
    6,
    15,
    14,
    9,
    11,
    3,
    0,
    8,
    12,
    2,
    13,
    7,
    1,
    4,
    10,
    5,
    10,
    2,
    8,
    4,
    7,
    6,
    1,
    5,
    15,
    11,
    9,
    14,
    3,
    12,
    13,
    0,
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    14,
    10,
    4,
    8,
    9,
    15,
    13,
    6,
    1,
    12,
    0,
    2,
    11,
    7,
    5,
    3,
    // Blake1, unused in others
    11,
    8,
    12,
    0,
    5,
    2,
    15,
    13,
    10,
    14,
    3,
    6,
    7,
    1,
    9,
    4,
    7,
    9,
    3,
    1,
    13,
    12,
    11,
    14,
    2,
    6,
    5,
    10,
    4,
    0,
    15,
    8,
    9,
    0,
    5,
    7,
    2,
    4,
    10,
    15,
    14,
    1,
    11,
    12,
    6,
    8,
    3,
    13,
    2,
    12,
    6,
    10,
    0,
    11,
    8,
    3,
    4,
    13,
    7,
    5,
    15,
    14,
    1,
    9
  ]);
  function g(y, t, d, E, B) {
    return y = y + t + B | 0, E = (0, o.rotr)(E ^ y, 16), d = d + E | 0, t = (0, o.rotr)(t ^ d, 12), { a: y, b: t, c: d, d: E };
  }
  function c(y, t, d, E, B) {
    return y = y + t + B | 0, E = (0, o.rotr)(E ^ y, 8), d = d + E | 0, t = (0, o.rotr)(t ^ d, 7), { a: y, b: t, c: d, d: E };
  }
  return _blake;
}
var hasRequiredBlake2;
function requireBlake2() {
  if (hasRequiredBlake2) return blake2;
  hasRequiredBlake2 = 1, Object.defineProperty(blake2, "__esModule", { value: !0 }), blake2.blake2s = blake2.BLAKE2s = blake2.blake2b = blake2.BLAKE2b = blake2.BLAKE2 = void 0, blake2.compress = F;
  const o = /* @__PURE__ */ require_blake(), g = /* @__PURE__ */ require_md$1(), c = /* @__PURE__ */ require_u64$1(), y = /* @__PURE__ */ requireUtils$j(), t = /* @__PURE__ */ Uint32Array.from([
    4089235720,
    1779033703,
    2227873595,
    3144134277,
    4271175723,
    1013904242,
    1595750129,
    2773480762,
    2917565137,
    1359893119,
    725511199,
    2600822924,
    4215389547,
    528734635,
    327033209,
    1541459225
  ]), d = /* @__PURE__ */ new Uint32Array(32);
  function E(L, H, fe, ge, Ie, Ee) {
    const Se = Ie[Ee], ze = Ie[Ee + 1];
    let He = d[2 * L], Pe = d[2 * L + 1], De = d[2 * H], ve = d[2 * H + 1], Fe = d[2 * fe], be = d[2 * fe + 1], Be = d[2 * ge], ke = d[2 * ge + 1], xe = c.add3L(He, De, Se);
    Pe = c.add3H(xe, Pe, ve, ze), He = xe | 0, { Dh: ke, Dl: Be } = { Dh: ke ^ Pe, Dl: Be ^ He }, { Dh: ke, Dl: Be } = { Dh: c.rotr32H(ke, Be), Dl: c.rotr32L(ke, Be) }, { h: be, l: Fe } = c.add(be, Fe, ke, Be), { Bh: ve, Bl: De } = { Bh: ve ^ be, Bl: De ^ Fe }, { Bh: ve, Bl: De } = { Bh: c.rotrSH(ve, De, 24), Bl: c.rotrSL(ve, De, 24) }, d[2 * L] = He, d[2 * L + 1] = Pe, d[2 * H] = De, d[2 * H + 1] = ve, d[2 * fe] = Fe, d[2 * fe + 1] = be, d[2 * ge] = Be, d[2 * ge + 1] = ke;
  }
  function B(L, H, fe, ge, Ie, Ee) {
    const Se = Ie[Ee], ze = Ie[Ee + 1];
    let He = d[2 * L], Pe = d[2 * L + 1], De = d[2 * H], ve = d[2 * H + 1], Fe = d[2 * fe], be = d[2 * fe + 1], Be = d[2 * ge], ke = d[2 * ge + 1], xe = c.add3L(He, De, Se);
    Pe = c.add3H(xe, Pe, ve, ze), He = xe | 0, { Dh: ke, Dl: Be } = { Dh: ke ^ Pe, Dl: Be ^ He }, { Dh: ke, Dl: Be } = { Dh: c.rotrSH(ke, Be, 16), Dl: c.rotrSL(ke, Be, 16) }, { h: be, l: Fe } = c.add(be, Fe, ke, Be), { Bh: ve, Bl: De } = { Bh: ve ^ be, Bl: De ^ Fe }, { Bh: ve, Bl: De } = { Bh: c.rotrBH(ve, De, 63), Bl: c.rotrBL(ve, De, 63) }, d[2 * L] = He, d[2 * L + 1] = Pe, d[2 * H] = De, d[2 * H + 1] = ve, d[2 * fe] = Fe, d[2 * fe + 1] = be, d[2 * ge] = Be, d[2 * ge + 1] = ke;
  }
  function D(L, H = {}, fe, ge, Ie) {
    if ((0, y.anumber)(fe), L < 0 || L > fe)
      throw new Error("outputLen bigger than keyLen");
    const { key: Ee, salt: Se, personalization: ze } = H;
    if (Ee !== void 0 && (Ee.length < 1 || Ee.length > fe))
      throw new Error("key length must be undefined or 1.." + fe);
    if (Se !== void 0 && Se.length !== ge)
      throw new Error("salt must be undefined or " + ge);
    if (ze !== void 0 && ze.length !== Ie)
      throw new Error("personalization must be undefined or " + Ie);
  }
  class x extends y.Hash {
    constructor(H, fe) {
      super(), this.finished = !1, this.destroyed = !1, this.length = 0, this.pos = 0, (0, y.anumber)(H), (0, y.anumber)(fe), this.blockLen = H, this.outputLen = fe, this.buffer = new Uint8Array(H), this.buffer32 = (0, y.u32)(this.buffer);
    }
    update(H) {
      (0, y.aexists)(this), H = (0, y.toBytes)(H), (0, y.abytes)(H);
      const { blockLen: fe, buffer: ge, buffer32: Ie } = this, Ee = H.length, Se = H.byteOffset, ze = H.buffer;
      for (let He = 0; He < Ee; ) {
        this.pos === fe && ((0, y.swap32IfBE)(Ie), this.compress(Ie, 0, !1), (0, y.swap32IfBE)(Ie), this.pos = 0);
        const Pe = Math.min(fe - this.pos, Ee - He), De = Se + He;
        if (Pe === fe && !(De % 4) && He + Pe < Ee) {
          const ve = new Uint32Array(ze, De, Math.floor((Ee - He) / 4));
          (0, y.swap32IfBE)(ve);
          for (let Fe = 0; He + fe < Ee; Fe += Ie.length, He += fe)
            this.length += fe, this.compress(ve, Fe, !1);
          (0, y.swap32IfBE)(ve);
          continue;
        }
        ge.set(H.subarray(He, He + Pe), this.pos), this.pos += Pe, this.length += Pe, He += Pe;
      }
      return this;
    }
    digestInto(H) {
      (0, y.aexists)(this), (0, y.aoutput)(H, this);
      const { pos: fe, buffer32: ge } = this;
      this.finished = !0, (0, y.clean)(this.buffer.subarray(fe)), (0, y.swap32IfBE)(ge), this.compress(ge, 0, !0), (0, y.swap32IfBE)(ge);
      const Ie = (0, y.u32)(H);
      this.get().forEach((Ee, Se) => Ie[Se] = (0, y.swap8IfBE)(Ee));
    }
    digest() {
      const { buffer: H, outputLen: fe } = this;
      this.digestInto(H);
      const ge = H.slice(0, fe);
      return this.destroy(), ge;
    }
    _cloneInto(H) {
      const { buffer: fe, length: ge, finished: Ie, destroyed: Ee, outputLen: Se, pos: ze } = this;
      return H || (H = new this.constructor({ dkLen: Se })), H.set(...this.get()), H.buffer.set(fe), H.destroyed = Ee, H.finished = Ie, H.length = ge, H.pos = ze, H.outputLen = Se, H;
    }
    clone() {
      return this._cloneInto();
    }
  }
  blake2.BLAKE2 = x;
  class v extends x {
    constructor(H = {}) {
      const fe = H.dkLen === void 0 ? 64 : H.dkLen;
      super(128, fe), this.v0l = t[0] | 0, this.v0h = t[1] | 0, this.v1l = t[2] | 0, this.v1h = t[3] | 0, this.v2l = t[4] | 0, this.v2h = t[5] | 0, this.v3l = t[6] | 0, this.v3h = t[7] | 0, this.v4l = t[8] | 0, this.v4h = t[9] | 0, this.v5l = t[10] | 0, this.v5h = t[11] | 0, this.v6l = t[12] | 0, this.v6h = t[13] | 0, this.v7l = t[14] | 0, this.v7h = t[15] | 0, D(fe, H, 64, 16, 16);
      let { key: ge, personalization: Ie, salt: Ee } = H, Se = 0;
      if (ge !== void 0 && (ge = (0, y.toBytes)(ge), Se = ge.length), this.v0l ^= this.outputLen | Se << 8 | 65536 | 1 << 24, Ee !== void 0) {
        Ee = (0, y.toBytes)(Ee);
        const ze = (0, y.u32)(Ee);
        this.v4l ^= (0, y.swap8IfBE)(ze[0]), this.v4h ^= (0, y.swap8IfBE)(ze[1]), this.v5l ^= (0, y.swap8IfBE)(ze[2]), this.v5h ^= (0, y.swap8IfBE)(ze[3]);
      }
      if (Ie !== void 0) {
        Ie = (0, y.toBytes)(Ie);
        const ze = (0, y.u32)(Ie);
        this.v6l ^= (0, y.swap8IfBE)(ze[0]), this.v6h ^= (0, y.swap8IfBE)(ze[1]), this.v7l ^= (0, y.swap8IfBE)(ze[2]), this.v7h ^= (0, y.swap8IfBE)(ze[3]);
      }
      if (ge !== void 0) {
        const ze = new Uint8Array(this.blockLen);
        ze.set(ge), this.update(ze);
      }
    }
    // prettier-ignore
    get() {
      let { v0l: H, v0h: fe, v1l: ge, v1h: Ie, v2l: Ee, v2h: Se, v3l: ze, v3h: He, v4l: Pe, v4h: De, v5l: ve, v5h: Fe, v6l: be, v6h: Be, v7l: ke, v7h: xe } = this;
      return [H, fe, ge, Ie, Ee, Se, ze, He, Pe, De, ve, Fe, be, Be, ke, xe];
    }
    // prettier-ignore
    set(H, fe, ge, Ie, Ee, Se, ze, He, Pe, De, ve, Fe, be, Be, ke, xe) {
      this.v0l = H | 0, this.v0h = fe | 0, this.v1l = ge | 0, this.v1h = Ie | 0, this.v2l = Ee | 0, this.v2h = Se | 0, this.v3l = ze | 0, this.v3h = He | 0, this.v4l = Pe | 0, this.v4h = De | 0, this.v5l = ve | 0, this.v5h = Fe | 0, this.v6l = be | 0, this.v6h = Be | 0, this.v7l = ke | 0, this.v7h = xe | 0;
    }
    compress(H, fe, ge) {
      this.get().forEach((He, Pe) => d[Pe] = He), d.set(t, 16);
      let { h: Ie, l: Ee } = c.fromBig(BigInt(this.length));
      d[24] = t[8] ^ Ee, d[25] = t[9] ^ Ie, ge && (d[28] = ~d[28], d[29] = ~d[29]);
      let Se = 0;
      const ze = o.BSIGMA;
      for (let He = 0; He < 12; He++)
        E(0, 4, 8, 12, H, fe + 2 * ze[Se++]), B(0, 4, 8, 12, H, fe + 2 * ze[Se++]), E(1, 5, 9, 13, H, fe + 2 * ze[Se++]), B(1, 5, 9, 13, H, fe + 2 * ze[Se++]), E(2, 6, 10, 14, H, fe + 2 * ze[Se++]), B(2, 6, 10, 14, H, fe + 2 * ze[Se++]), E(3, 7, 11, 15, H, fe + 2 * ze[Se++]), B(3, 7, 11, 15, H, fe + 2 * ze[Se++]), E(0, 5, 10, 15, H, fe + 2 * ze[Se++]), B(0, 5, 10, 15, H, fe + 2 * ze[Se++]), E(1, 6, 11, 12, H, fe + 2 * ze[Se++]), B(1, 6, 11, 12, H, fe + 2 * ze[Se++]), E(2, 7, 8, 13, H, fe + 2 * ze[Se++]), B(2, 7, 8, 13, H, fe + 2 * ze[Se++]), E(3, 4, 9, 14, H, fe + 2 * ze[Se++]), B(3, 4, 9, 14, H, fe + 2 * ze[Se++]);
      this.v0l ^= d[0] ^ d[16], this.v0h ^= d[1] ^ d[17], this.v1l ^= d[2] ^ d[18], this.v1h ^= d[3] ^ d[19], this.v2l ^= d[4] ^ d[20], this.v2h ^= d[5] ^ d[21], this.v3l ^= d[6] ^ d[22], this.v3h ^= d[7] ^ d[23], this.v4l ^= d[8] ^ d[24], this.v4h ^= d[9] ^ d[25], this.v5l ^= d[10] ^ d[26], this.v5h ^= d[11] ^ d[27], this.v6l ^= d[12] ^ d[28], this.v6h ^= d[13] ^ d[29], this.v7l ^= d[14] ^ d[30], this.v7h ^= d[15] ^ d[31], (0, y.clean)(d);
    }
    destroy() {
      this.destroyed = !0, (0, y.clean)(this.buffer32), this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
    }
  }
  blake2.BLAKE2b = v, blake2.blake2b = (0, y.createOptHasher)((L) => new v(L));
  function F(L, H, fe, ge, Ie, Ee, Se, ze, He, Pe, De, ve, Fe, be, Be, ke, xe, Ne, Et, st) {
    let Dt = 0;
    for (let er = 0; er < ge; er++)
      ({ a: Ie, b: He, c: Fe, d: xe } = (0, o.G1s)(Ie, He, Fe, xe, fe[H + L[Dt++]])), { a: Ie, b: He, c: Fe, d: xe } = (0, o.G2s)(Ie, He, Fe, xe, fe[H + L[Dt++]]), { a: Ee, b: Pe, c: be, d: Ne } = (0, o.G1s)(Ee, Pe, be, Ne, fe[H + L[Dt++]]), { a: Ee, b: Pe, c: be, d: Ne } = (0, o.G2s)(Ee, Pe, be, Ne, fe[H + L[Dt++]]), { a: Se, b: De, c: Be, d: Et } = (0, o.G1s)(Se, De, Be, Et, fe[H + L[Dt++]]), { a: Se, b: De, c: Be, d: Et } = (0, o.G2s)(Se, De, Be, Et, fe[H + L[Dt++]]), { a: ze, b: ve, c: ke, d: st } = (0, o.G1s)(ze, ve, ke, st, fe[H + L[Dt++]]), { a: ze, b: ve, c: ke, d: st } = (0, o.G2s)(ze, ve, ke, st, fe[H + L[Dt++]]), { a: Ie, b: Pe, c: Be, d: st } = (0, o.G1s)(Ie, Pe, Be, st, fe[H + L[Dt++]]), { a: Ie, b: Pe, c: Be, d: st } = (0, o.G2s)(Ie, Pe, Be, st, fe[H + L[Dt++]]), { a: Ee, b: De, c: ke, d: xe } = (0, o.G1s)(Ee, De, ke, xe, fe[H + L[Dt++]]), { a: Ee, b: De, c: ke, d: xe } = (0, o.G2s)(Ee, De, ke, xe, fe[H + L[Dt++]]), { a: Se, b: ve, c: Fe, d: Ne } = (0, o.G1s)(Se, ve, Fe, Ne, fe[H + L[Dt++]]), { a: Se, b: ve, c: Fe, d: Ne } = (0, o.G2s)(Se, ve, Fe, Ne, fe[H + L[Dt++]]), { a: ze, b: He, c: be, d: Et } = (0, o.G1s)(ze, He, be, Et, fe[H + L[Dt++]]), { a: ze, b: He, c: be, d: Et } = (0, o.G2s)(ze, He, be, Et, fe[H + L[Dt++]]);
    return { v0: Ie, v1: Ee, v2: Se, v3: ze, v4: He, v5: Pe, v6: De, v7: ve, v8: Fe, v9: be, v10: Be, v11: ke, v12: xe, v13: Ne, v14: Et, v15: st };
  }
  const M = g.SHA256_IV;
  class U extends x {
    constructor(H = {}) {
      const fe = H.dkLen === void 0 ? 32 : H.dkLen;
      super(64, fe), this.v0 = M[0] | 0, this.v1 = M[1] | 0, this.v2 = M[2] | 0, this.v3 = M[3] | 0, this.v4 = M[4] | 0, this.v5 = M[5] | 0, this.v6 = M[6] | 0, this.v7 = M[7] | 0, D(fe, H, 32, 8, 8);
      let { key: ge, personalization: Ie, salt: Ee } = H, Se = 0;
      if (ge !== void 0 && (ge = (0, y.toBytes)(ge), Se = ge.length), this.v0 ^= this.outputLen | Se << 8 | 65536 | 1 << 24, Ee !== void 0) {
        Ee = (0, y.toBytes)(Ee);
        const ze = (0, y.u32)(Ee);
        this.v4 ^= (0, y.swap8IfBE)(ze[0]), this.v5 ^= (0, y.swap8IfBE)(ze[1]);
      }
      if (Ie !== void 0) {
        Ie = (0, y.toBytes)(Ie);
        const ze = (0, y.u32)(Ie);
        this.v6 ^= (0, y.swap8IfBE)(ze[0]), this.v7 ^= (0, y.swap8IfBE)(ze[1]);
      }
      if (ge !== void 0) {
        (0, y.abytes)(ge);
        const ze = new Uint8Array(this.blockLen);
        ze.set(ge), this.update(ze);
      }
    }
    get() {
      const { v0: H, v1: fe, v2: ge, v3: Ie, v4: Ee, v5: Se, v6: ze, v7: He } = this;
      return [H, fe, ge, Ie, Ee, Se, ze, He];
    }
    // prettier-ignore
    set(H, fe, ge, Ie, Ee, Se, ze, He) {
      this.v0 = H | 0, this.v1 = fe | 0, this.v2 = ge | 0, this.v3 = Ie | 0, this.v4 = Ee | 0, this.v5 = Se | 0, this.v6 = ze | 0, this.v7 = He | 0;
    }
    compress(H, fe, ge) {
      const { h: Ie, l: Ee } = c.fromBig(BigInt(this.length)), { v0: Se, v1: ze, v2: He, v3: Pe, v4: De, v5: ve, v6: Fe, v7: be, v8: Be, v9: ke, v10: xe, v11: Ne, v12: Et, v13: st, v14: Dt, v15: er } = F(o.BSIGMA, fe, H, 10, this.v0, this.v1, this.v2, this.v3, this.v4, this.v5, this.v6, this.v7, M[0], M[1], M[2], M[3], Ee ^ M[4], Ie ^ M[5], ge ? ~M[6] : M[6], M[7]);
      this.v0 ^= Se ^ Be, this.v1 ^= ze ^ ke, this.v2 ^= He ^ xe, this.v3 ^= Pe ^ Ne, this.v4 ^= De ^ Et, this.v5 ^= ve ^ st, this.v6 ^= Fe ^ Dt, this.v7 ^= be ^ er;
    }
    destroy() {
      this.destroyed = !0, (0, y.clean)(this.buffer32), this.set(0, 0, 0, 0, 0, 0, 0, 0);
    }
  }
  return blake2.BLAKE2s = U, blake2.blake2s = (0, y.createOptHasher)((L) => new U(L)), blake2;
}
var hasRequiredBlake2b;
function requireBlake2b() {
  if (hasRequiredBlake2b) return blake2b$1;
  hasRequiredBlake2b = 1, Object.defineProperty(blake2b$1, "__esModule", { value: !0 }), blake2b$1.blake2b = blake2b$1.BLAKE2b = void 0;
  const o = /* @__PURE__ */ requireBlake2();
  return blake2b$1.BLAKE2b = o.BLAKE2b, blake2b$1.blake2b = o.blake2b, blake2b$1;
}
var hasRequiredCardano;
function requireCardano() {
  if (hasRequiredCardano) return cardano;
  hasRequiredCardano = 1, Object.defineProperty(cardano, "__esModule", { value: !0 }), cardano.KeystoneCardanoSDK = void 0;
  const o = requireDist$d(), g = requireUtils$e(), c = requireUr(), y = /* @__PURE__ */ requireBlake2b();
  class t {
    constructor(E) {
      this.config = E;
    }
    parseSignature(E) {
      if (E.type !== c.URType.CardanoSignature)
        throw new Error("type not match");
      const B = o.CardanoSignature.fromCBOR(E.cbor), D = B.getRequestId();
      return {
        requestId: Buffer.isBuffer(D) ? (0, g.uuidStringify)(D) : "",
        witnessSet: (0, g.toHex)(B.getWitnessSet())
      };
    }
    parseSignDataSignature(E) {
      if (E.type !== c.URType.CardanoSignDataSignature)
        throw new Error("type not match");
      const B = o.CardanoSignDataSignature.fromCBOR(E.cbor), D = B.getRequestId();
      return {
        requestId: Buffer.isBuffer(D) ? (0, g.uuidStringify)(D) : "",
        signature: (0, g.toHex)(B.getSignature()),
        publicKey: (0, g.toHex)(B.getPublicKey())
      };
    }
    parseSignCip8DataSignature(E) {
      if (E.type !== c.URType.CardanoSignCip8DataSignature)
        throw new Error("type not match");
      const B = o.CardanoSignCip8DataSignature.fromCBOR(E.cbor), D = B.getSignature(), x = B.getPublicKey(), v = B.getAddressField();
      return {
        requestId: "",
        signature: (0, g.toHex)(D),
        publicKey: (0, g.toHex)(x),
        addressField: (0, g.toHex)(v)
      };
    }
    parseCatalystSignature(E) {
      if (E.type !== c.URType.CardanoCatalystSignature)
        throw new Error("type not match");
      const B = o.CardanoCatalystSignature.fromCBOR(E.cbor), D = B.getRequestId();
      return {
        requestId: Buffer.isBuffer(D) ? (0, g.uuidStringify)(D) : "",
        signature: (0, g.toHex)(B.getSignature())
      };
    }
    generateSignDataRequest({ requestId: E, payload: B, sigStructure: D, path: x, xpub: v, pubKey: F, xfp: M, origin: U }) {
      return o.CardanoSignDataRequest.constructCardanoSignDataRequest(D ?? B, x, M, F ?? v, E, U).toUR();
    }
    generateSignCip8DataRequest(E) {
      return o.CardanoSignCip8DataRequest.constructCardanoSignCip8DataRequest(E.messageHex, E.path, E.xfp, E.xpub, E.hashPayload, E.addressFieldType, "address" in E ? E.address : void 0, E.requestId, E.origin).toUR();
    }
    generateCatalystRequest(E) {
      return o.CardanoCatalystRequest.constructCardanoCatalystRequest(E.delegations, E.stakePub, E.paymentAddress, E.nonce, E.voting_purpose, E.path, E.xfp, E.requestId, E.origin).toUR();
    }
    checkNeedSignTxHash(E) {
      var B, D, x;
      const v = (x = (D = (B = this.config) === null || B === void 0 ? void 0 : B.sizeLimit) === null || D === void 0 ? void 0 : D.ada) !== null && x !== void 0 ? x : 2048;
      return E.length >= v;
    }
    generateTxHash(E) {
      return Buffer.from((0, y.blake2b)(Uint8Array.from(E), { dkLen: 32 })).toString("hex");
    }
    generateSignTxHashRequest(E, B, D, x, v) {
      return o.CardanoSignTxHashRequest.constructCardanoSignTxHashRequest(E, B, D, v, x).toUR();
    }
    generateSignRequest({ signData: E, utxos: B, extraSigners: D, requestId: x, origin: v }) {
      var F, M, U;
      const L = (U = (M = (F = this.config) === null || F === void 0 ? void 0 : F.sizeLimit) === null || M === void 0 ? void 0 : M.ada) !== null && U !== void 0 ? U : 2048;
      if (E.length >= L) {
        const H = (0, y.blake2b)(Uint8Array.from(E), { dkLen: 32 }), fe = B.map((Se) => new o.CryptoKeypath((0, g.parsePath)(Se.hdPath).map((ze) => new o.PathComponent(ze)), (0, g.toBuffer)(Se.xfp))), ge = D.map((Se) => new o.CryptoKeypath((0, g.parsePath)(Se.keyPath).map((ze) => new o.PathComponent(ze)), (0, g.toBuffer)(Se.xfp))), Ie = [...fe, ...ge], Ee = B.map((Se) => Se.address);
        return o.CardanoSignTxHashRequest.constructCardanoSignTxHashRequest(Buffer.from(H).toString("hex"), Ie, Ee, x, v).toUR();
      }
      return o.CardanoSignRequest.constructCardanoSignRequest(E, B, D, x, v).toUR();
    }
  }
  return cardano.KeystoneCardanoSDK = t, cardano;
}
var arweave = {}, dist$b = { exports: {} }, bcUrRegistryArweave_cjs_production_min = {}, hasRequiredBcUrRegistryArweave_cjs_production_min;
function requireBcUrRegistryArweave_cjs_production_min() {
  return hasRequiredBcUrRegistryArweave_cjs_production_min || (hasRequiredBcUrRegistryArweave_cjs_production_min = 1, function(o) {
    Object.defineProperty(o, "__esModule", { value: !0 });
    var g = requireDist$n(), c = require$$1$3;
    const y = { ARWEAVE_CRYPTO_ACCOUNT: new g.RegistryType("arweave-crypto-account", 5101), ARWEAVE_SIGN_REQUEST: new g.RegistryType("arweave-sign-request", 5102), ARWEAVE_SIGNATURE: new g.RegistryType("arweave-signature", 5103) }, { decodeToDataItem: t, RegistryTypes: d } = g.extend;
    var E, B, D;
    (E = o.SignType || (o.SignType = {}))[E.Transaction = 1] = "Transaction", E[E.DataItem = 2] = "DataItem", E[E.Message = 3] = "Message", (B = o.SaltLen || (o.SaltLen = {}))[B.Zero = 0] = "Zero", B[B.Digest = 32] = "Digest", function(ge) {
      ge[ge.masterFingerprint = 1] = "masterFingerprint", ge[ge.requestId = 2] = "requestId", ge[ge.signData = 3] = "signData", ge[ge.signType = 4] = "signType", ge[ge.saltLen = 5] = "saltLen", ge[ge.origin = 6] = "origin", ge[ge.account = 7] = "account";
    }(D || (D = {}));
    class x extends g.RegistryItem {
      constructor(Ie) {
        super(), this.getRegistryType = () => y.ARWEAVE_SIGN_REQUEST, this.getRequestId = () => this.requestId, this.getSignData = () => this.signData, this.getSignType = () => this.signType, this.getSaltLen = () => this.saltLen, this.getOrigin = () => this.origin, this.getAccount = () => this.account, this.getMasterFingerprint = () => this.masterFingerprint, this.toDataItem = () => {
          const Ee = {};
          return this.requestId && (Ee[D.requestId] = new g.DataItem(this.requestId, d.UUID.getTag())), this.account && (Ee[D.account] = this.account), this.origin && (Ee[D.origin] = this.origin), Ee[D.masterFingerprint] = this.masterFingerprint.readUInt32BE(0), Ee[D.signData] = this.signData, Ee[D.signType] = this.signType, Ee[D.saltLen] = this.saltLen, new g.DataItem(Ee);
        }, this.masterFingerprint = Ie.masterFingerprint, this.requestId = Ie.requestId, this.signData = Ie.signData, this.signType = Ie.signType, this.saltLen = Ie.saltLen, this.origin = Ie.origin, this.account = Ie.account;
      }
      static constructArweaveRequest(Ie, Ee, Se, ze, He, Pe, De) {
        return new x({ masterFingerprint: Buffer.from(Ee, "hex"), requestId: He ? Buffer.from(c.parse(He)) : void 0, signData: Ie, signType: Se, saltLen: ze, account: Pe, origin: De });
      }
    }
    x.fromDataItem = (ge) => {
      const Ie = ge.getData(), Ee = Ie[D.signData], Se = Ie[D.account] ? Ie[D.account] : void 0, ze = Ie[D.requestId] ? Ie[D.requestId].getData() : void 0, He = Ie[D.origin] ? Ie[D.origin] : void 0, Pe = Ie[D.signType], De = Ie[D.saltLen], ve = Buffer.alloc(4);
      return ve.writeUInt32BE(Ie[D.masterFingerprint], 0), new x({ masterFingerprint: ve, requestId: ze, signData: Ee, signType: Pe, saltLen: De, origin: He, account: Se });
    }, x.fromCBOR = (ge) => {
      const Ie = t(ge);
      return x.fromDataItem(Ie);
    };
    const { RegistryTypes: v, decodeToDataItem: F } = g.extend;
    var M;
    (function(ge) {
      ge[ge.requestId = 1] = "requestId", ge[ge.signature = 2] = "signature";
    })(M || (M = {}));
    class U extends g.RegistryItem {
      constructor(Ie, Ee) {
        super(), this.getRegistryType = () => y.ARWEAVE_SIGNATURE, this.getRequestId = () => this.requestId, this.getSignature = () => this.signature, this.toDataItem = () => {
          const Se = {};
          return this.requestId && (Se[M.requestId] = new g.DataItem(this.requestId, v.UUID.getTag())), Se[M.signature] = this.signature, new g.DataItem(Se);
        }, this.signature = Ie, this.requestId = Ee;
      }
    }
    U.fromDataItem = (ge) => {
      const Ie = ge.getData(), Ee = Ie[M.signature], Se = Ie[M.requestId] ? Ie[M.requestId].getData() : void 0;
      return new U(Ee, Se);
    }, U.fromCBOR = (ge) => {
      const Ie = F(ge);
      return U.fromDataItem(Ie);
    };
    const { decodeToDataItem: L } = g.extend;
    var H;
    (function(ge) {
      ge[ge.masterFingerprint = 1] = "masterFingerprint", ge[ge.keyData = 2] = "keyData", ge[ge.device = 3] = "device";
    })(H || (H = {}));
    class fe extends g.RegistryItem {
      constructor(Ie, Ee, Se) {
        super(), this.masterFingerprint = Ie, this.keyData = Ee, this.device = Se, this.getRegistryType = () => y.ARWEAVE_CRYPTO_ACCOUNT, this.getMasterFingerprint = () => this.masterFingerprint, this.getKeyData = () => this.keyData, this.getDevice = () => this.device, this.toDataItem = () => {
          const ze = {};
          return ze[H.masterFingerprint] = this.masterFingerprint.readUInt32BE(0), ze[H.keyData] = this.keyData, this.device && (ze[H.device] = this.device), new g.DataItem(ze);
        };
      }
    }
    fe.fromDataItem = (ge) => {
      const Ie = ge.getData(), Ee = Ie[H.keyData], Se = Buffer.alloc(4);
      return Se.writeUInt32BE(Ie[H.masterFingerprint], 0), new fe(Se, Ee, Ie[H.device] ? Ie[H.device] : void 0);
    }, fe.fromCBOR = (ge) => {
      const Ie = L(ge);
      return fe.fromDataItem(Ie);
    }, g.patchTags(Object.values(y).filter((ge) => !!ge.getTag()).map((ge) => ge.getTag())), Object.keys(g).forEach(function(ge) {
      ge !== "default" && Object.defineProperty(o, ge, { enumerable: !0, get: function() {
        return g[ge];
      } });
    }), o.ArweaveCryptoAccount = fe, o.ArweaveSignRequest = x, o.ArweaveSignature = U;
  }(bcUrRegistryArweave_cjs_production_min)), bcUrRegistryArweave_cjs_production_min;
}
var bcUrRegistryArweave_cjs_development = {}, hasRequiredBcUrRegistryArweave_cjs_development;
function requireBcUrRegistryArweave_cjs_development() {
  return hasRequiredBcUrRegistryArweave_cjs_development || (hasRequiredBcUrRegistryArweave_cjs_development = 1, function(o) {
    Object.defineProperty(o, "__esModule", { value: !0 });
    var g = requireDist$n(), c = require$$1$3;
    const y = {
      ARWEAVE_CRYPTO_ACCOUNT: /* @__PURE__ */ new g.RegistryType("arweave-crypto-account", 5101),
      ARWEAVE_SIGN_REQUEST: /* @__PURE__ */ new g.RegistryType("arweave-sign-request", 5102),
      ARWEAVE_SIGNATURE: /* @__PURE__ */ new g.RegistryType("arweave-signature", 5103)
    }, {
      decodeToDataItem: t,
      RegistryTypes: d
    } = g.extend;
    (function(H) {
      H[H.Transaction = 1] = "Transaction", H[H.DataItem = 2] = "DataItem", H[H.Message = 3] = "Message";
    })(o.SignType || (o.SignType = {})), function(H) {
      H[H.Zero = 0] = "Zero", H[H.Digest = 32] = "Digest";
    }(o.SaltLen || (o.SaltLen = {}));
    var E;
    (function(H) {
      H[H.masterFingerprint = 1] = "masterFingerprint", H[H.requestId = 2] = "requestId", H[H.signData = 3] = "signData", H[H.signType = 4] = "signType", H[H.saltLen = 5] = "saltLen", H[H.origin = 6] = "origin", H[H.account = 7] = "account";
    })(E || (E = {}));
    class B extends g.RegistryItem {
      constructor(fe) {
        super(), this.getRegistryType = () => y.ARWEAVE_SIGN_REQUEST, this.getRequestId = () => this.requestId, this.getSignData = () => this.signData, this.getSignType = () => this.signType, this.getSaltLen = () => this.saltLen, this.getOrigin = () => this.origin, this.getAccount = () => this.account, this.getMasterFingerprint = () => this.masterFingerprint, this.toDataItem = () => {
          const ge = {};
          return this.requestId && (ge[E.requestId] = new g.DataItem(this.requestId, d.UUID.getTag())), this.account && (ge[E.account] = this.account), this.origin && (ge[E.origin] = this.origin), ge[E.masterFingerprint] = this.masterFingerprint.readUInt32BE(0), ge[E.signData] = this.signData, ge[E.signType] = this.signType, ge[E.saltLen] = this.saltLen, new g.DataItem(ge);
        }, this.masterFingerprint = fe.masterFingerprint, this.requestId = fe.requestId, this.signData = fe.signData, this.signType = fe.signType, this.saltLen = fe.saltLen, this.origin = fe.origin, this.account = fe.account;
      }
      static constructArweaveRequest(fe, ge, Ie, Ee, Se, ze, He) {
        return new B({
          masterFingerprint: Buffer.from(ge, "hex"),
          requestId: Se ? Buffer.from(c.parse(Se)) : void 0,
          signData: fe,
          signType: Ie,
          saltLen: Ee,
          account: ze,
          origin: He
        });
      }
    }
    B.fromDataItem = (H) => {
      const fe = H.getData(), ge = fe[E.signData], Ie = fe[E.account] ? fe[E.account] : void 0, Ee = fe[E.requestId] ? fe[E.requestId].getData() : void 0, Se = fe[E.origin] ? fe[E.origin] : void 0, ze = fe[E.signType], He = fe[E.saltLen], Pe = Buffer.alloc(4), De = fe[E.masterFingerprint];
      return Pe.writeUInt32BE(De, 0), new B({
        masterFingerprint: Pe,
        requestId: Ee,
        signData: ge,
        signType: ze,
        saltLen: He,
        origin: Se,
        account: Ie
      });
    }, B.fromCBOR = (H) => {
      const fe = t(H);
      return B.fromDataItem(fe);
    };
    const {
      RegistryTypes: D,
      decodeToDataItem: x
    } = g.extend;
    var v;
    (function(H) {
      H[H.requestId = 1] = "requestId", H[H.signature = 2] = "signature";
    })(v || (v = {}));
    class F extends g.RegistryItem {
      constructor(fe, ge) {
        super(), this.getRegistryType = () => y.ARWEAVE_SIGNATURE, this.getRequestId = () => this.requestId, this.getSignature = () => this.signature, this.toDataItem = () => {
          const Ie = {};
          return this.requestId && (Ie[v.requestId] = new g.DataItem(this.requestId, D.UUID.getTag())), Ie[v.signature] = this.signature, new g.DataItem(Ie);
        }, this.signature = fe, this.requestId = ge;
      }
    }
    F.fromDataItem = (H) => {
      const fe = H.getData(), ge = fe[v.signature], Ie = fe[v.requestId] ? fe[v.requestId].getData() : void 0;
      return new F(ge, Ie);
    }, F.fromCBOR = (H) => {
      const fe = x(H);
      return F.fromDataItem(fe);
    };
    const {
      decodeToDataItem: M
    } = g.extend;
    var U;
    (function(H) {
      H[H.masterFingerprint = 1] = "masterFingerprint", H[H.keyData = 2] = "keyData", H[H.device = 3] = "device";
    })(U || (U = {}));
    class L extends g.RegistryItem {
      constructor(fe, ge, Ie) {
        super(), this.masterFingerprint = fe, this.keyData = ge, this.device = Ie, this.getRegistryType = () => y.ARWEAVE_CRYPTO_ACCOUNT, this.getMasterFingerprint = () => this.masterFingerprint, this.getKeyData = () => this.keyData, this.getDevice = () => this.device, this.toDataItem = () => {
          const Ee = {};
          return Ee[U.masterFingerprint] = this.masterFingerprint.readUInt32BE(0), Ee[U.keyData] = this.keyData, this.device && (Ee[U.device] = this.device), new g.DataItem(Ee);
        };
      }
    }
    L.fromDataItem = (H) => {
      const fe = H.getData(), ge = fe[U.keyData], Ie = Buffer.alloc(4), Ee = fe[U.masterFingerprint];
      Ie.writeUInt32BE(Ee, 0);
      const Se = fe[U.device] ? fe[U.device] : void 0;
      return new L(Ie, ge, Se);
    }, L.fromCBOR = (H) => {
      const fe = M(H);
      return L.fromDataItem(fe);
    }, g.patchTags(Object.values(y).filter((H) => !!H.getTag()).map((H) => H.getTag())), Object.keys(g).forEach(function(H) {
      H !== "default" && Object.defineProperty(o, H, {
        enumerable: !0,
        get: function() {
          return g[H];
        }
      });
    }), o.ArweaveCryptoAccount = L, o.ArweaveSignRequest = B, o.ArweaveSignature = F;
  }(bcUrRegistryArweave_cjs_development)), bcUrRegistryArweave_cjs_development;
}
var hasRequiredDist$c;
function requireDist$c() {
  return hasRequiredDist$c || (hasRequiredDist$c = 1, process$1.env.NODE_ENV === "production" ? dist$b.exports = requireBcUrRegistryArweave_cjs_production_min() : dist$b.exports = requireBcUrRegistryArweave_cjs_development()), dist$b.exports;
}
var hasRequiredArweave;
function requireArweave() {
  if (hasRequiredArweave) return arweave;
  hasRequiredArweave = 1, Object.defineProperty(arweave, "__esModule", { value: !0 }), arweave.KeystoneArweaveSDK = void 0;
  const o = requireUtils$e(), g = requireUr(), c = requireDist$c();
  class y {
    parseAccount(d) {
      if (d.type !== g.URType.ArweaveCryptoAccount)
        throw new Error("type not match");
      const E = c.ArweaveCryptoAccount.fromCBOR(d.cbor);
      return {
        masterFingerprint: (0, o.toHex)(E.getMasterFingerprint()),
        keyData: (0, o.toHex)(E.getKeyData()),
        device: E.getDevice()
      };
    }
    parseSignature(d) {
      if (d.type !== g.URType.ArweaveSignature)
        throw new Error("type not match");
      const E = c.ArweaveSignature.fromCBOR(d.cbor), B = E.getRequestId();
      return {
        requestId: (0, o.uuidStringify)(B),
        signature: (0, o.toHex)(E.getSignature())
      };
    }
    generateSignRequest({ requestId: d, signData: E, signType: B, saltLen: D, masterFingerprint: x, account: v, origin: F }) {
      return new c.ArweaveSignRequest({
        requestId: (0, o.uuidParse)(d),
        signData: (0, o.toBuffer)(E),
        signType: B,
        saltLen: D,
        masterFingerprint: (0, o.toBuffer)(x),
        account: v !== void 0 ? (0, o.toBuffer)(v) : void 0,
        origin: F
      }).toUR();
    }
  }
  return arweave.KeystoneArweaveSDK = y, y.SignType = c.SignType, y.SaltLen = c.SaltLen, arweave;
}
var sui = {}, dist$a = { exports: {} }, bcUrRegistrySui_cjs_production_min = {}, hasRequiredBcUrRegistrySui_cjs_production_min;
function requireBcUrRegistrySui_cjs_production_min() {
  return hasRequiredBcUrRegistrySui_cjs_production_min || (hasRequiredBcUrRegistrySui_cjs_production_min = 1, function(o) {
    Object.defineProperty(o, "__esModule", { value: !0 });
    var g = requireDist$n(), c = /* @__PURE__ */ requireCommonjsBrowser();
    const y = { SUI_SIGN_REQUEST: new g.RegistryType("sui-sign-request", 7101), SUI_SIGNATURE: new g.RegistryType("sui-signature", 7102), SUI_SIGN_HASH_REQUEST: new g.RegistryType("sui-sign-hash-request", 7103) }, { decodeToDataItem: t, RegistryTypes: d } = g.extend;
    var E;
    (function(fe) {
      fe[fe.requestId = 1] = "requestId", fe[fe.intentMessage = 2] = "intentMessage", fe[fe.derivationPaths = 3] = "derivationPaths", fe[fe.addresses = 4] = "addresses", fe[fe.origin = 5] = "origin";
    })(E || (E = {}));
    class B extends g.RegistryItem {
      constructor(ge) {
        super(), this.getRegistryType = () => y.SUI_SIGN_REQUEST, this.getRequestId = () => this.requestId, this.getIntentMessage = () => this.intentMessage, this.getDerivationPaths = () => this.derivationPaths.map((Ie) => Ie.getPath()), this.getAddresses = () => this.addresses, this.getOrigin = () => this.origin, this.toDataItem = () => {
          const Ie = {};
          return this.requestId && (Ie[E.requestId] = new g.DataItem(this.requestId, d.UUID.getTag())), this.addresses && (Ie[E.addresses] = this.addresses), this.origin && (Ie[E.origin] = this.origin), Ie[E.intentMessage] = this.intentMessage, Ie[E.derivationPaths] = this.derivationPaths.map((Ee) => {
            const Se = Ee.toDataItem();
            return Se.setTag(Ee.getRegistryType().getTag()), Se;
          }), new g.DataItem(Ie);
        }, this.requestId = ge.requestId, this.intentMessage = ge.intentMessage, this.derivationPaths = ge.derivationPaths, this.addresses = ge.addresses, this.origin = ge.origin;
      }
      static constructSuiRequest(ge, Ie, Ee, Se, ze, He) {
        const Pe = Ie.map((De, ve) => {
          const Fe = De.replace(/[m|M]\//, "").split("/").map((be) => {
            const Be = parseInt(be.replace("'", ""));
            let ke = !1;
            return be.endsWith("'") && (ke = !0), new g.PathComponent({ index: Be, hardened: ke });
          });
          return new g.CryptoKeypath(Fe, Buffer.from(Ee[ve], "hex"));
        });
        return new B({ requestId: Buffer.from(c.parse(Se)), intentMessage: ge, derivationPaths: Pe, addresses: ze || void 0, origin: He || void 0 });
      }
    }
    B.fromDataItem = (fe) => {
      const ge = fe.getData(), Ie = ge[E.intentMessage], Ee = ge[E.derivationPaths].map((He) => g.CryptoKeypath.fromDataItem(He)), Se = ge[E.addresses] ? ge[E.addresses] : void 0, ze = ge[E.requestId] ? ge[E.requestId].getData() : void 0;
      return new B({ requestId: ze, intentMessage: Ie, derivationPaths: Ee, addresses: Se, origin: ge[E.origin] ? ge[E.origin] : void 0 });
    }, B.fromCBOR = (fe) => {
      const ge = t(fe);
      return B.fromDataItem(ge);
    };
    const { RegistryTypes: D, decodeToDataItem: x } = g.extend;
    var v;
    (function(fe) {
      fe[fe.requestId = 1] = "requestId", fe[fe.signature = 2] = "signature", fe[fe.publicKey = 3] = "publicKey";
    })(v || (v = {}));
    class F extends g.RegistryItem {
      constructor(ge, Ie, Ee) {
        super(), this.getRegistryType = () => y.SUI_SIGNATURE, this.getRequestId = () => this.requestId, this.getSignature = () => this.signature, this.getPublicKey = () => this.publicKey, this.toDataItem = () => {
          const Se = {};
          return this.requestId && (Se[v.requestId] = new g.DataItem(this.requestId, D.UUID.getTag())), Se[v.signature] = this.signature, this.publicKey && (Se[v.publicKey] = this.publicKey), new g.DataItem(Se);
        }, this.signature = ge, this.requestId = Ie, this.publicKey = Ee;
      }
    }
    F.fromDataItem = (fe) => {
      const ge = fe.getData(), Ie = ge[v.signature], Ee = ge[v.requestId].getData();
      return new F(Ie, Ee, ge[v.publicKey]);
    }, F.fromCBOR = (fe) => {
      const ge = x(fe);
      return F.fromDataItem(ge);
    };
    const { decodeToDataItem: M, RegistryTypes: U } = g.extend;
    var L;
    (function(fe) {
      fe[fe.requestId = 1] = "requestId", fe[fe.messageHash = 2] = "messageHash", fe[fe.derivationPaths = 3] = "derivationPaths", fe[fe.addresses = 4] = "addresses", fe[fe.origin = 5] = "origin";
    })(L || (L = {}));
    class H extends g.RegistryItem {
      constructor(ge) {
        super(), this.getRegistryType = () => y.SUI_SIGN_HASH_REQUEST, this.getRequestId = () => this.requestId, this.getMessageHash = () => this.messageHash, this.getDerivationPaths = () => this.derivationPaths.map((Ie) => Ie.getPath()), this.getAddresses = () => this.addresses, this.getOrigin = () => this.origin, this.toDataItem = () => {
          const Ie = {};
          return this.requestId && (Ie[L.requestId] = new g.DataItem(this.requestId, U.UUID.getTag())), this.addresses && (Ie[L.addresses] = this.addresses), this.origin && (Ie[L.origin] = this.origin), Ie[L.messageHash] = this.messageHash, Ie[L.derivationPaths] = this.derivationPaths.map((Ee) => {
            const Se = Ee.toDataItem();
            return Se.setTag(Ee.getRegistryType().getTag()), Se;
          }), new g.DataItem(Ie);
        }, this.requestId = ge.requestId, this.messageHash = ge.messageHash, this.derivationPaths = ge.derivationPaths, this.addresses = ge.addresses, this.origin = ge.origin;
      }
      static constructSuiRequest(ge, Ie, Ee, Se, ze, He) {
        const Pe = Ie.map((De, ve) => {
          const Fe = De.replace(/[m|M]\//, "").split("/").map((be) => {
            const Be = parseInt(be.replace("'", ""));
            let ke = !1;
            return be.endsWith("'") && (ke = !0), new g.PathComponent({ index: Be, hardened: ke });
          });
          return new g.CryptoKeypath(Fe, Buffer.from(Ee[ve], "hex"));
        });
        return new H({ requestId: Buffer.from(c.parse(Se)), messageHash: ge, derivationPaths: Pe, addresses: ze || void 0, origin: He || void 0 });
      }
    }
    H.fromDataItem = (fe) => {
      const ge = fe.getData(), Ie = ge[L.messageHash], Ee = ge[L.derivationPaths].map((He) => g.CryptoKeypath.fromDataItem(He)), Se = ge[L.addresses] ? ge[L.addresses] : void 0, ze = ge[L.requestId] ? ge[L.requestId].getData() : void 0;
      return new H({ requestId: ze, messageHash: Ie, derivationPaths: Ee, addresses: Se, origin: ge[L.origin] ? ge[L.origin] : void 0 });
    }, H.fromCBOR = (fe) => {
      const ge = M(fe);
      return H.fromDataItem(ge);
    }, g.patchTags(Object.values(y).filter((fe) => !!fe.getTag()).map((fe) => fe.getTag())), Object.keys(g).forEach(function(fe) {
      fe !== "default" && Object.defineProperty(o, fe, { enumerable: !0, get: function() {
        return g[fe];
      } });
    }), o.SuiSignHashRequest = H, o.SuiSignRequest = B, o.SuiSignature = F;
  }(bcUrRegistrySui_cjs_production_min)), bcUrRegistrySui_cjs_production_min;
}
var bcUrRegistrySui_cjs_development = {}, hasRequiredBcUrRegistrySui_cjs_development;
function requireBcUrRegistrySui_cjs_development() {
  return hasRequiredBcUrRegistrySui_cjs_development || (hasRequiredBcUrRegistrySui_cjs_development = 1, function(o) {
    Object.defineProperty(o, "__esModule", { value: !0 });
    var g = requireDist$n(), c = /* @__PURE__ */ requireCommonjsBrowser();
    const y = {
      SUI_SIGN_REQUEST: /* @__PURE__ */ new g.RegistryType("sui-sign-request", 7101),
      SUI_SIGNATURE: /* @__PURE__ */ new g.RegistryType("sui-signature", 7102),
      SUI_SIGN_HASH_REQUEST: /* @__PURE__ */ new g.RegistryType("sui-sign-hash-request", 7103)
    }, {
      decodeToDataItem: t,
      RegistryTypes: d
    } = g.extend;
    var E;
    (function(fe) {
      fe[fe.requestId = 1] = "requestId", fe[fe.intentMessage = 2] = "intentMessage", fe[fe.derivationPaths = 3] = "derivationPaths", fe[fe.addresses = 4] = "addresses", fe[fe.origin = 5] = "origin";
    })(E || (E = {}));
    class B extends g.RegistryItem {
      constructor(ge) {
        super(), this.getRegistryType = () => y.SUI_SIGN_REQUEST, this.getRequestId = () => this.requestId, this.getIntentMessage = () => this.intentMessage, this.getDerivationPaths = () => this.derivationPaths.map((Ie) => Ie.getPath()), this.getAddresses = () => this.addresses, this.getOrigin = () => this.origin, this.toDataItem = () => {
          const Ie = {};
          return this.requestId && (Ie[E.requestId] = new g.DataItem(this.requestId, d.UUID.getTag())), this.addresses && (Ie[E.addresses] = this.addresses), this.origin && (Ie[E.origin] = this.origin), Ie[E.intentMessage] = this.intentMessage, Ie[E.derivationPaths] = this.derivationPaths.map((Ee) => {
            const Se = Ee.toDataItem();
            return Se.setTag(Ee.getRegistryType().getTag()), Se;
          }), new g.DataItem(Ie);
        }, this.requestId = ge.requestId, this.intentMessage = ge.intentMessage, this.derivationPaths = ge.derivationPaths, this.addresses = ge.addresses, this.origin = ge.origin;
      }
      static constructSuiRequest(ge, Ie, Ee, Se, ze, He) {
        const Pe = Ie.map((De, ve) => {
          const be = De.replace(/[m|M]\//, "").split("/").map((Be) => {
            const ke = parseInt(Be.replace("'", ""));
            let xe = !1;
            return Be.endsWith("'") && (xe = !0), new g.PathComponent({
              index: ke,
              hardened: xe
            });
          });
          return new g.CryptoKeypath(be, Buffer.from(Ee[ve], "hex"));
        });
        return new B({
          requestId: Buffer.from(c.parse(Se)),
          intentMessage: ge,
          derivationPaths: Pe,
          addresses: ze || void 0,
          origin: He || void 0
        });
      }
    }
    B.fromDataItem = (fe) => {
      const ge = fe.getData(), Ie = ge[E.intentMessage], Ee = ge[E.derivationPaths].map((Pe) => g.CryptoKeypath.fromDataItem(Pe)), Se = ge[E.addresses] ? ge[E.addresses] : void 0, ze = ge[E.requestId] ? ge[E.requestId].getData() : void 0, He = ge[E.origin] ? ge[E.origin] : void 0;
      return new B({
        requestId: ze,
        intentMessage: Ie,
        derivationPaths: Ee,
        addresses: Se,
        origin: He
      });
    }, B.fromCBOR = (fe) => {
      const ge = t(fe);
      return B.fromDataItem(ge);
    };
    const {
      RegistryTypes: D,
      decodeToDataItem: x
    } = g.extend;
    var v;
    (function(fe) {
      fe[fe.requestId = 1] = "requestId", fe[fe.signature = 2] = "signature", fe[fe.publicKey = 3] = "publicKey";
    })(v || (v = {}));
    class F extends g.RegistryItem {
      constructor(ge, Ie, Ee) {
        super(), this.getRegistryType = () => y.SUI_SIGNATURE, this.getRequestId = () => this.requestId, this.getSignature = () => this.signature, this.getPublicKey = () => this.publicKey, this.toDataItem = () => {
          const Se = {};
          return this.requestId && (Se[v.requestId] = new g.DataItem(this.requestId, D.UUID.getTag())), Se[v.signature] = this.signature, this.publicKey && (Se[v.publicKey] = this.publicKey), new g.DataItem(Se);
        }, this.signature = ge, this.requestId = Ie, this.publicKey = Ee;
      }
    }
    F.fromDataItem = (fe) => {
      const ge = fe.getData(), Ie = ge[v.signature], Ee = ge[v.requestId].getData(), Se = ge[v.publicKey];
      return new F(Ie, Ee, Se);
    }, F.fromCBOR = (fe) => {
      const ge = x(fe);
      return F.fromDataItem(ge);
    };
    const {
      decodeToDataItem: M,
      RegistryTypes: U
    } = g.extend;
    var L;
    (function(fe) {
      fe[fe.requestId = 1] = "requestId", fe[fe.messageHash = 2] = "messageHash", fe[fe.derivationPaths = 3] = "derivationPaths", fe[fe.addresses = 4] = "addresses", fe[fe.origin = 5] = "origin";
    })(L || (L = {}));
    class H extends g.RegistryItem {
      constructor(ge) {
        super(), this.getRegistryType = () => y.SUI_SIGN_HASH_REQUEST, this.getRequestId = () => this.requestId, this.getMessageHash = () => this.messageHash, this.getDerivationPaths = () => this.derivationPaths.map((Ie) => Ie.getPath()), this.getAddresses = () => this.addresses, this.getOrigin = () => this.origin, this.toDataItem = () => {
          const Ie = {};
          return this.requestId && (Ie[L.requestId] = new g.DataItem(this.requestId, U.UUID.getTag())), this.addresses && (Ie[L.addresses] = this.addresses), this.origin && (Ie[L.origin] = this.origin), Ie[L.messageHash] = this.messageHash, Ie[L.derivationPaths] = this.derivationPaths.map((Ee) => {
            const Se = Ee.toDataItem();
            return Se.setTag(Ee.getRegistryType().getTag()), Se;
          }), new g.DataItem(Ie);
        }, this.requestId = ge.requestId, this.messageHash = ge.messageHash, this.derivationPaths = ge.derivationPaths, this.addresses = ge.addresses, this.origin = ge.origin;
      }
      static constructSuiRequest(ge, Ie, Ee, Se, ze, He) {
        const Pe = Ie.map((De, ve) => {
          const be = De.replace(/[m|M]\//, "").split("/").map((Be) => {
            const ke = parseInt(Be.replace("'", ""));
            let xe = !1;
            return Be.endsWith("'") && (xe = !0), new g.PathComponent({
              index: ke,
              hardened: xe
            });
          });
          return new g.CryptoKeypath(be, Buffer.from(Ee[ve], "hex"));
        });
        return new H({
          requestId: Buffer.from(c.parse(Se)),
          messageHash: ge,
          derivationPaths: Pe,
          addresses: ze || void 0,
          origin: He || void 0
        });
      }
    }
    H.fromDataItem = (fe) => {
      const ge = fe.getData(), Ie = ge[L.messageHash], Ee = ge[L.derivationPaths].map((Pe) => g.CryptoKeypath.fromDataItem(Pe)), Se = ge[L.addresses] ? ge[L.addresses] : void 0, ze = ge[L.requestId] ? ge[L.requestId].getData() : void 0, He = ge[L.origin] ? ge[L.origin] : void 0;
      return new H({
        requestId: ze,
        messageHash: Ie,
        derivationPaths: Ee,
        addresses: Se,
        origin: He
      });
    }, H.fromCBOR = (fe) => {
      const ge = M(fe);
      return H.fromDataItem(ge);
    }, g.patchTags(Object.values(y).filter((fe) => !!fe.getTag()).map((fe) => fe.getTag())), Object.keys(g).forEach(function(fe) {
      fe !== "default" && Object.defineProperty(o, fe, {
        enumerable: !0,
        get: function() {
          return g[fe];
        }
      });
    }), o.SuiSignHashRequest = H, o.SuiSignRequest = B, o.SuiSignature = F;
  }(bcUrRegistrySui_cjs_development)), bcUrRegistrySui_cjs_development;
}
var hasRequiredDist$b;
function requireDist$b() {
  return hasRequiredDist$b || (hasRequiredDist$b = 1, process$1.env.NODE_ENV === "production" ? dist$a.exports = requireBcUrRegistrySui_cjs_production_min() : dist$a.exports = requireBcUrRegistrySui_cjs_development()), dist$a.exports;
}
var hasRequiredSui;
function requireSui() {
  if (hasRequiredSui) return sui;
  hasRequiredSui = 1, Object.defineProperty(sui, "__esModule", { value: !0 }), sui.KeystoneSuiSDK = void 0;
  const o = requireDist$b(), g = requireUtils$e(), c = requireUr(), y = /* @__PURE__ */ requireBlake2b();
  class t {
    constructor(E) {
      this.config = E;
    }
    parseSignature(E) {
      if (E.type !== c.URType.SuiSignature)
        throw new Error("type not match");
      const B = o.SuiSignature.fromCBOR(E.cbor), D = B.getRequestId();
      return {
        requestId: Buffer.isBuffer(D) ? (0, g.uuidStringify)(D) : "",
        signature: (0, g.toHex)(B.getSignature()),
        publicKey: (0, g.toHex)(B.getPublicKey())
      };
    }
    generateSignHashRequest({ requestId: E, messageHash: B, accounts: D, origin: x }) {
      const v = [], F = [];
      if (D.forEach((M) => {
        v.push(new o.CryptoKeypath((0, g.parsePath)(M.path).map((U) => new o.PathComponent(U)), (0, g.toBuffer)(M.xfp))), M.address !== void 0 && F.push((0, g.toBuffer)(M.address.startsWith("0x") ? M.address.substring(2) : M.address));
      }), F.length > 0 && F.length !== v.length)
        throw new Error("address and path count must match");
      return new o.SuiSignHashRequest({
        requestId: (0, g.uuidParse)(E),
        messageHash: B,
        derivationPaths: v,
        addresses: F,
        origin: x
      }).toUR();
    }
    generateIntentMessageHash(E) {
      let B = (0, g.toBuffer)(E);
      const D = (0, y.blake2b)(Uint8Array.from(B), { dkLen: 32 });
      return (0, g.toHex)(D);
    }
    generateSignRequest({ requestId: E, intentMessage: B, accounts: D, origin: x }) {
      var v, F, M;
      const U = (M = (F = (v = this.config) === null || v === void 0 ? void 0 : v.sizeLimit) === null || F === void 0 ? void 0 : F.sui) !== null && M !== void 0 ? M : 2048, L = [], H = [];
      if (D.forEach((ge) => {
        L.push(new o.CryptoKeypath((0, g.parsePath)(ge.path).map((Ie) => new o.PathComponent(Ie)), (0, g.toBuffer)(ge.xfp))), ge.address !== void 0 && H.push((0, g.toBuffer)(ge.address.startsWith("0x") ? ge.address.substring(2) : ge.address));
      }), H.length > 0 && H.length !== L.length)
        throw new Error("address and path count must match");
      let fe = (0, g.toBuffer)(B);
      if (fe.length > U) {
        const ge = (0, y.blake2b)(Uint8Array.from(fe), { dkLen: 32 });
        if (ge.length !== 32)
          throw new Error("hash length must be 32");
        return B = (0, g.toHex)(ge), new o.SuiSignHashRequest({
          requestId: (0, g.uuidParse)(E),
          messageHash: B,
          derivationPaths: L,
          addresses: H,
          origin: x
        }).toUR();
      }
      return new o.SuiSignRequest({
        requestId: (0, g.uuidParse)(E),
        intentMessage: (0, g.toBuffer)(B),
        derivationPaths: L,
        addresses: H,
        origin: x
      }).toUR();
    }
  }
  return sui.KeystoneSuiSDK = t, sui;
}
var ton = {}, dist$9 = { exports: {} }, bcUrRegistryTon_cjs_production_min = {}, hasRequiredBcUrRegistryTon_cjs_production_min;
function requireBcUrRegistryTon_cjs_production_min() {
  return hasRequiredBcUrRegistryTon_cjs_production_min || (hasRequiredBcUrRegistryTon_cjs_production_min = 1, function(o) {
    Object.defineProperty(o, "__esModule", { value: !0 });
    var g = requireDist$n(), c = /* @__PURE__ */ requireCommonjsBrowser();
    const y = { TRON_SIGN_REQUEST: new g.RegistryType("ton-sign-request", 7201), TRON_SIGNATURE: new g.RegistryType("ton-signature", 7202) }, { decodeToDataItem: t, RegistryTypes: d } = g.extend;
    var E, B;
    (function(U) {
      U[U.requestId = 1] = "requestId", U[U.signData = 2] = "signData", U[U.dataType = 3] = "dataType", U[U.derivationPath = 4] = "derivationPath", U[U.address = 5] = "address", U[U.origin = 6] = "origin";
    })(E || (E = {})), (B = o.DataType || (o.DataType = {}))[B.TRANSACTION = 1] = "TRANSACTION", B[B.SIGN_PROOF = 2] = "SIGN_PROOF";
    class D extends g.RegistryItem {
      constructor(L) {
        super(), this.getRegistryType = () => y.TRON_SIGN_REQUEST, this.getRequestId = () => this.requestId, this.getSignData = () => this.signData, this.getDerivationPath = () => this.derivationPath ? this.derivationPath.getPath() : void 0, this.getAddress = () => this.address, this.getOrigin = () => this.origin, this.getDataType = () => this.dataType, this.toDataItem = () => {
          const H = {};
          if (H[E.signData] = this.signData, H[E.dataType] = this.dataType, this.derivationPath) {
            const fe = this.derivationPath.toDataItem();
            fe.setTag(this.derivationPath.getRegistryType().getTag()), H[E.derivationPath] = fe;
          }
          return this.requestId && (H[E.requestId] = new g.DataItem(this.requestId, d.UUID.getTag())), this.address && (H[E.address] = this.address), this.origin && (H[E.origin] = this.origin), new g.DataItem(H);
        }, this.requestId = L.requestId, this.signData = L.signData, this.derivationPath = L.derivationPath, this.address = L.address, this.origin = L.origin, this.dataType = L.dataType;
      }
      static parsePath(L, H) {
        const fe = L.replace(/[m|M]\//, "").split("/").map((ge) => {
          const Ie = parseInt(ge.replace("'", ""));
          let Ee = !1;
          return ge.endsWith("'") && (Ee = !0), new g.PathComponent({ index: Ie, hardened: Ee });
        });
        return new g.CryptoKeypath(fe, Buffer.from(H, "hex"));
      }
      static constructTonRequest(L, H, fe, ge, Ie, Ee, Se) {
        return new D({ requestId: ge ? Buffer.from(c.parse(ge)) : void 0, signData: L, dataType: H, derivationPath: Se && Ee ? D.parsePath(Se, Ee) : void 0, address: fe, origin: Ie });
      }
    }
    D.fromDataItem = (U) => {
      const L = U.getData(), H = L[E.requestId] ? L[E.requestId].getData() : void 0, fe = L[E.derivationPath] ? g.CryptoKeypath.fromDataItem(L[E.derivationPath]) : void 0;
      return new D({ requestId: H, signData: L[E.signData], dataType: L[E.dataType], derivationPath: fe, address: L[E.address], origin: L[E.origin] });
    }, D.fromCBOR = (U) => {
      const L = t(U);
      return D.fromDataItem(L);
    };
    const { RegistryTypes: x, decodeToDataItem: v } = g.extend;
    var F;
    (function(U) {
      U[U.requestId = 1] = "requestId", U[U.signature = 2] = "signature", U[U.origin = 3] = "origin";
    })(F || (F = {}));
    class M extends g.RegistryItem {
      constructor(L, H, fe) {
        super(), this.getRegistryType = () => y.TRON_SIGNATURE, this.getRequestId = () => this.requestId, this.getSignature = () => this.signature, this.getOrigin = () => this.origin, this.toDataItem = () => {
          const ge = {};
          return this.requestId && (ge[F.requestId] = new g.DataItem(this.requestId, x.UUID.getTag())), this.origin && (ge[F.origin] = this.origin), ge[F.signature] = this.signature, new g.DataItem(ge);
        }, this.signature = L, this.requestId = H, this.origin = fe;
      }
    }
    M.fromDataItem = (U) => {
      const L = U.getData(), H = L[F.signature];
      let fe, ge;
      return L[F.requestId] && (fe = L[F.requestId].getData()), L[F.origin] && (ge = L[F.origin]), new M(H, fe, ge);
    }, M.fromCBOR = (U) => {
      const L = v(U);
      return M.fromDataItem(L);
    }, g.patchTags(Object.values(y).filter((U) => !!U.getTag()).map((U) => U.getTag())), Object.keys(g).forEach(function(U) {
      U !== "default" && Object.defineProperty(o, U, { enumerable: !0, get: function() {
        return g[U];
      } });
    }), o.TonSignRequest = D, o.TonSignature = M;
  }(bcUrRegistryTon_cjs_production_min)), bcUrRegistryTon_cjs_production_min;
}
var bcUrRegistryTon_cjs_development = {}, hasRequiredBcUrRegistryTon_cjs_development;
function requireBcUrRegistryTon_cjs_development() {
  return hasRequiredBcUrRegistryTon_cjs_development || (hasRequiredBcUrRegistryTon_cjs_development = 1, function(o) {
    Object.defineProperty(o, "__esModule", { value: !0 });
    var g = requireDist$n(), c = /* @__PURE__ */ requireCommonjsBrowser();
    const y = {
      TRON_SIGN_REQUEST: /* @__PURE__ */ new g.RegistryType("ton-sign-request", 7201),
      TRON_SIGNATURE: /* @__PURE__ */ new g.RegistryType("ton-signature", 7202)
    }, {
      decodeToDataItem: t,
      RegistryTypes: d
    } = g.extend;
    var E;
    (function(M) {
      M[M.requestId = 1] = "requestId", M[M.signData = 2] = "signData", M[M.dataType = 3] = "dataType", M[M.derivationPath = 4] = "derivationPath", M[M.address = 5] = "address", M[M.origin = 6] = "origin";
    })(E || (E = {})), function(M) {
      M[M.TRANSACTION = 1] = "TRANSACTION", M[M.SIGN_PROOF = 2] = "SIGN_PROOF";
    }(o.DataType || (o.DataType = {}));
    class B extends g.RegistryItem {
      constructor(U) {
        super(), this.getRegistryType = () => y.TRON_SIGN_REQUEST, this.getRequestId = () => this.requestId, this.getSignData = () => this.signData, this.getDerivationPath = () => this.derivationPath ? this.derivationPath.getPath() : void 0, this.getAddress = () => this.address, this.getOrigin = () => this.origin, this.getDataType = () => this.dataType, this.toDataItem = () => {
          const L = {};
          if (L[E.signData] = this.signData, L[E.dataType] = this.dataType, this.derivationPath) {
            const H = this.derivationPath.toDataItem();
            H.setTag(this.derivationPath.getRegistryType().getTag()), L[E.derivationPath] = H;
          }
          return this.requestId && (L[E.requestId] = new g.DataItem(this.requestId, d.UUID.getTag())), this.address && (L[E.address] = this.address), this.origin && (L[E.origin] = this.origin), new g.DataItem(L);
        }, this.requestId = U.requestId, this.signData = U.signData, this.derivationPath = U.derivationPath, this.address = U.address, this.origin = U.origin, this.dataType = U.dataType;
      }
      static parsePath(U, L) {
        const fe = U.replace(/[m|M]\//, "").split("/").map((ge) => {
          const Ie = parseInt(ge.replace("'", ""));
          let Ee = !1;
          return ge.endsWith("'") && (Ee = !0), new g.PathComponent({
            index: Ie,
            hardened: Ee
          });
        });
        return new g.CryptoKeypath(fe, Buffer.from(L, "hex"));
      }
      static constructTonRequest(U, L, H, fe, ge, Ie, Ee) {
        return new B({
          requestId: fe ? Buffer.from(c.parse(fe)) : void 0,
          signData: U,
          dataType: L,
          derivationPath: Ee && Ie ? B.parsePath(Ee, Ie) : void 0,
          address: H,
          origin: ge
        });
      }
    }
    B.fromDataItem = (M) => {
      const U = M.getData(), L = U[E.requestId] ? U[E.requestId].getData() : void 0, H = U[E.derivationPath] ? g.CryptoKeypath.fromDataItem(U[E.derivationPath]) : void 0;
      return new B({
        requestId: L,
        signData: U[E.signData],
        dataType: U[E.dataType],
        derivationPath: H,
        address: U[E.address],
        origin: U[E.origin]
      });
    }, B.fromCBOR = (M) => {
      const U = t(M);
      return B.fromDataItem(U);
    };
    const {
      RegistryTypes: D,
      decodeToDataItem: x
    } = g.extend;
    var v;
    (function(M) {
      M[M.requestId = 1] = "requestId", M[M.signature = 2] = "signature", M[M.origin = 3] = "origin";
    })(v || (v = {}));
    class F extends g.RegistryItem {
      constructor(U, L, H) {
        super(), this.getRegistryType = () => y.TRON_SIGNATURE, this.getRequestId = () => this.requestId, this.getSignature = () => this.signature, this.getOrigin = () => this.origin, this.toDataItem = () => {
          const fe = {};
          return this.requestId && (fe[v.requestId] = new g.DataItem(this.requestId, D.UUID.getTag())), this.origin && (fe[v.origin] = this.origin), fe[v.signature] = this.signature, new g.DataItem(fe);
        }, this.signature = U, this.requestId = L, this.origin = H;
      }
    }
    F.fromDataItem = (M) => {
      const U = M.getData(), L = U[v.signature];
      let H, fe;
      return U[v.requestId] && (H = U[v.requestId].getData()), U[v.origin] && (fe = U[v.origin]), new F(L, H, fe);
    }, F.fromCBOR = (M) => {
      const U = x(M);
      return F.fromDataItem(U);
    }, g.patchTags(Object.values(y).filter((M) => !!M.getTag()).map((M) => M.getTag())), Object.keys(g).forEach(function(M) {
      M !== "default" && Object.defineProperty(o, M, {
        enumerable: !0,
        get: function() {
          return g[M];
        }
      });
    }), o.TonSignRequest = B, o.TonSignature = F;
  }(bcUrRegistryTon_cjs_development)), bcUrRegistryTon_cjs_development;
}
var hasRequiredDist$a;
function requireDist$a() {
  return hasRequiredDist$a || (hasRequiredDist$a = 1, process$1.env.NODE_ENV === "production" ? dist$9.exports = requireBcUrRegistryTon_cjs_production_min() : dist$9.exports = requireBcUrRegistryTon_cjs_development()), dist$9.exports;
}
var hasRequiredTon;
function requireTon() {
  if (hasRequiredTon) return ton;
  hasRequiredTon = 1, Object.defineProperty(ton, "__esModule", { value: !0 }), ton.KeystoneTonSDK = void 0;
  const o = requireDist$a(), g = requireUtils$e(), c = requireUr();
  class y {
    constructor(d) {
      this.config = d;
    }
    parseSignature(d) {
      if (d.type !== c.URType.TonSignature)
        throw new Error("type not match");
      const E = o.TonSignature.fromCBOR(d.cbor), B = E.getRequestId();
      return {
        requestId: Buffer.isBuffer(B) ? (0, g.uuidStringify)(B) : "",
        signature: (0, g.toHex)(E.getSignature()),
        origin: E.getOrigin()
      };
    }
    generateSignRequest({ requestId: d, signData: E, dataType: B, xfp: D, derivationPath: x, address: v }) {
      var F;
      return o.TonSignRequest.constructTonRequest((0, g.toBuffer)(E), B, v, d, (F = this.config) === null || F === void 0 ? void 0 : F.origin, D, x).toUR();
    }
  }
  return ton.KeystoneTonSDK = y, y.DataType = o.DataType, ton;
}
var stellar = {}, dist$8 = { exports: {} }, bcUrRegistryStellar_cjs_production_min = {}, hasRequiredBcUrRegistryStellar_cjs_production_min;
function requireBcUrRegistryStellar_cjs_production_min() {
  return hasRequiredBcUrRegistryStellar_cjs_production_min || (hasRequiredBcUrRegistryStellar_cjs_production_min = 1, function(o) {
    Object.defineProperty(o, "__esModule", { value: !0 });
    var g = requireDist$n(), c = require$$1$3;
    const y = { STELLAR_SIGN_REQUEST: new g.RegistryType("stellar-sign-request", 8201), STELLAR_SIGNATURE: new g.RegistryType("stellar-signature", 8202) }, { decodeToDataItem: t, RegistryTypes: d } = g.extend;
    var E, B;
    (E = o.SignType || (o.SignType = {}))[E.Transaction = 1] = "Transaction", E[E.TransactionHash = 2] = "TransactionHash", E[E.Message = 3] = "Message", function(U) {
      U[U.requestId = 1] = "requestId", U[U.signData = 2] = "signData", U[U.derivationPath = 3] = "derivationPath", U[U.address = 4] = "address", U[U.origin = 5] = "origin", U[U.signType = 6] = "signType";
    }(B || (B = {}));
    class D extends g.RegistryItem {
      constructor(L) {
        super(), this.getRegistryType = () => y.STELLAR_SIGN_REQUEST, this.getRequestId = () => this.requestId, this.getSignData = () => this.signData, this.getDerivationPath = () => this.derivationPath.getPath(), this.getSignRequestAddress = () => this.address, this.getOrigin = () => this.origin, this.getSignType = () => this.signType, this.toDataItem = () => {
          const H = {};
          this.requestId && (H[B.requestId] = new g.DataItem(this.requestId, d.UUID.getTag())), this.address && (H[B.address] = this.address), this.origin && (H[B.origin] = this.origin), H[B.signData] = this.signData, H[B.signType] = this.signType;
          const fe = this.derivationPath.toDataItem();
          return fe.setTag(this.derivationPath.getRegistryType().getTag()), H[B.derivationPath] = fe, new g.DataItem(H);
        }, this.requestId = L.requestId, this.signData = L.signData, this.derivationPath = L.derivationPath, this.address = L.address, this.origin = L.origin, this.signType = L.signType;
      }
      static constructStellarRequest(L, H, fe, ge, Ie, Ee, Se) {
        const ze = H.replace(/[m|M]\//, "").split("/"), He = new g.CryptoKeypath(ze.map((Pe) => {
          const De = parseInt(Pe.replace("'", ""));
          let ve = !1;
          return Pe.endsWith("'") && (ve = !0), new g.PathComponent({ index: De, hardened: ve });
        }), Buffer.from(fe, "hex"));
        return new D({ requestId: Ie ? Buffer.from(c.parse(Ie)) : void 0, signData: L, derivationPath: He, address: Ee ? Buffer.from(Ee.replace("0x", ""), "hex") : void 0, origin: Se || void 0, signType: ge });
      }
    }
    D.fromDataItem = (U) => {
      const L = U.getData(), H = L[B.signData], fe = g.CryptoKeypath.fromDataItem(L[B.derivationPath]), ge = L[B.address] ? L[B.address] : void 0, Ie = L[B.requestId] ? L[B.requestId].getData() : void 0;
      return new D({ requestId: Ie, signData: H, derivationPath: fe, address: ge, origin: L[B.origin] ? L[B.origin] : void 0, signType: L[B.signType] });
    }, D.fromCBOR = (U) => {
      const L = t(U);
      return D.fromDataItem(L);
    };
    const { RegistryTypes: x, decodeToDataItem: v } = g.extend;
    var F;
    (function(U) {
      U[U.requestId = 1] = "requestId", U[U.signature = 2] = "signature";
    })(F || (F = {}));
    class M extends g.RegistryItem {
      constructor(L, H) {
        super(), this.getRegistryType = () => y.STELLAR_SIGNATURE, this.getRequestId = () => this.requestId, this.getSignature = () => this.signature, this.toDataItem = () => {
          const fe = {};
          return this.requestId && (fe[F.requestId] = new g.DataItem(this.requestId, x.UUID.getTag())), fe[F.signature] = this.signature, new g.DataItem(fe);
        }, this.signature = L, this.requestId = H;
      }
    }
    M.fromDataItem = (U) => {
      const L = U.getData(), H = L[F.signature], fe = L[F.requestId] ? L[F.requestId].getData() : void 0;
      return new M(H, fe);
    }, M.fromCBOR = (U) => {
      const L = v(U);
      return M.fromDataItem(L);
    }, g.patchTags(Object.values(y).filter((U) => !!U.getTag()).map((U) => U.getTag())), Object.keys(g).forEach(function(U) {
      U !== "default" && Object.defineProperty(o, U, { enumerable: !0, get: function() {
        return g[U];
      } });
    }), o.StellarSignRequest = D, o.StellarSignature = M;
  }(bcUrRegistryStellar_cjs_production_min)), bcUrRegistryStellar_cjs_production_min;
}
var bcUrRegistryStellar_cjs_development = {}, hasRequiredBcUrRegistryStellar_cjs_development;
function requireBcUrRegistryStellar_cjs_development() {
  return hasRequiredBcUrRegistryStellar_cjs_development || (hasRequiredBcUrRegistryStellar_cjs_development = 1, function(o) {
    Object.defineProperty(o, "__esModule", { value: !0 });
    var g = requireDist$n(), c = require$$1$3;
    const y = {
      STELLAR_SIGN_REQUEST: /* @__PURE__ */ new g.RegistryType("stellar-sign-request", 8201),
      STELLAR_SIGNATURE: /* @__PURE__ */ new g.RegistryType("stellar-signature", 8202)
    }, {
      decodeToDataItem: t,
      RegistryTypes: d
    } = g.extend;
    (function(M) {
      M[M.Transaction = 1] = "Transaction", M[M.TransactionHash = 2] = "TransactionHash", M[M.Message = 3] = "Message";
    })(o.SignType || (o.SignType = {}));
    var E;
    (function(M) {
      M[M.requestId = 1] = "requestId", M[M.signData = 2] = "signData", M[M.derivationPath = 3] = "derivationPath", M[M.address = 4] = "address", M[M.origin = 5] = "origin", M[M.signType = 6] = "signType";
    })(E || (E = {}));
    class B extends g.RegistryItem {
      constructor(U) {
        super(), this.getRegistryType = () => y.STELLAR_SIGN_REQUEST, this.getRequestId = () => this.requestId, this.getSignData = () => this.signData, this.getDerivationPath = () => this.derivationPath.getPath(), this.getSignRequestAddress = () => this.address, this.getOrigin = () => this.origin, this.getSignType = () => this.signType, this.toDataItem = () => {
          const L = {};
          this.requestId && (L[E.requestId] = new g.DataItem(this.requestId, d.UUID.getTag())), this.address && (L[E.address] = this.address), this.origin && (L[E.origin] = this.origin), L[E.signData] = this.signData, L[E.signType] = this.signType;
          const H = this.derivationPath.toDataItem();
          return H.setTag(this.derivationPath.getRegistryType().getTag()), L[E.derivationPath] = H, new g.DataItem(L);
        }, this.requestId = U.requestId, this.signData = U.signData, this.derivationPath = U.derivationPath, this.address = U.address, this.origin = U.origin, this.signType = U.signType;
      }
      static constructStellarRequest(U, L, H, fe, ge, Ie, Ee) {
        const Se = L.replace(/[m|M]\//, "").split("/"), ze = new g.CryptoKeypath(Se.map((He) => {
          const Pe = parseInt(He.replace("'", ""));
          let De = !1;
          return He.endsWith("'") && (De = !0), new g.PathComponent({
            index: Pe,
            hardened: De
          });
        }), Buffer.from(H, "hex"));
        return new B({
          requestId: ge ? Buffer.from(c.parse(ge)) : void 0,
          signData: U,
          derivationPath: ze,
          address: Ie ? Buffer.from(Ie.replace("0x", ""), "hex") : void 0,
          origin: Ee || void 0,
          signType: fe
        });
      }
    }
    B.fromDataItem = (M) => {
      const U = M.getData(), L = U[E.signData], H = g.CryptoKeypath.fromDataItem(U[E.derivationPath]), fe = U[E.address] ? U[E.address] : void 0, ge = U[E.requestId] ? U[E.requestId].getData() : void 0, Ie = U[E.origin] ? U[E.origin] : void 0, Ee = U[E.signType];
      return new B({
        requestId: ge,
        signData: L,
        derivationPath: H,
        address: fe,
        origin: Ie,
        signType: Ee
      });
    }, B.fromCBOR = (M) => {
      const U = t(M);
      return B.fromDataItem(U);
    };
    const {
      RegistryTypes: D,
      decodeToDataItem: x
    } = g.extend;
    var v;
    (function(M) {
      M[M.requestId = 1] = "requestId", M[M.signature = 2] = "signature";
    })(v || (v = {}));
    class F extends g.RegistryItem {
      constructor(U, L) {
        super(), this.getRegistryType = () => y.STELLAR_SIGNATURE, this.getRequestId = () => this.requestId, this.getSignature = () => this.signature, this.toDataItem = () => {
          const H = {};
          return this.requestId && (H[v.requestId] = new g.DataItem(this.requestId, D.UUID.getTag())), H[v.signature] = this.signature, new g.DataItem(H);
        }, this.signature = U, this.requestId = L;
      }
    }
    F.fromDataItem = (M) => {
      const U = M.getData(), L = U[v.signature], H = U[v.requestId] ? U[v.requestId].getData() : void 0;
      return new F(L, H);
    }, F.fromCBOR = (M) => {
      const U = x(M);
      return F.fromDataItem(U);
    }, g.patchTags(Object.values(y).filter((M) => !!M.getTag()).map((M) => M.getTag())), Object.keys(g).forEach(function(M) {
      M !== "default" && Object.defineProperty(o, M, {
        enumerable: !0,
        get: function() {
          return g[M];
        }
      });
    }), o.StellarSignRequest = B, o.StellarSignature = F;
  }(bcUrRegistryStellar_cjs_development)), bcUrRegistryStellar_cjs_development;
}
var hasRequiredDist$9;
function requireDist$9() {
  return hasRequiredDist$9 || (hasRequiredDist$9 = 1, process$1.env.NODE_ENV === "production" ? dist$8.exports = requireBcUrRegistryStellar_cjs_production_min() : dist$8.exports = requireBcUrRegistryStellar_cjs_development()), dist$8.exports;
}
var hasRequiredStellar;
function requireStellar() {
  if (hasRequiredStellar) return stellar;
  hasRequiredStellar = 1, Object.defineProperty(stellar, "__esModule", { value: !0 }), stellar.KeystoneStellarSDK = void 0;
  const o = requireUtils$e(), g = requireUr(), c = requireDist$9();
  class y {
    parseSignature(d) {
      if (d.type !== g.URType.StellarSignature)
        throw new Error("type not match");
      const E = c.StellarSignature.fromCBOR(d.cbor), B = E.getRequestId();
      return {
        requestId: B === void 0 ? void 0 : (0, o.uuidStringify)(B),
        signature: (0, o.toHex)(E.getSignature())
      };
    }
    generateSignRequest({ requestId: d, signData: E, dataType: B, path: D, xfp: x, address: v, origin: F }) {
      return new c.StellarSignRequest({
        requestId: (0, o.uuidParse)(d),
        signData: (0, o.toBuffer)(E),
        signType: B,
        derivationPath: new c.CryptoKeypath((0, o.parsePath)(D).map((M) => new c.PathComponent(M)), (0, o.toBuffer)(x)),
        address: v !== void 0 ? (0, o.toBuffer)(v) : void 0,
        origin: F
      }).toUR();
    }
  }
  return stellar.KeystoneStellarSDK = y, y.DataType = c.SignType, stellar;
}
var avalanche = {}, dist$7 = { exports: {} }, bcUrRegistryAvalanche_cjs_production_min = {}, hasRequiredBcUrRegistryAvalanche_cjs_production_min;
function requireBcUrRegistryAvalanche_cjs_production_min() {
  return hasRequiredBcUrRegistryAvalanche_cjs_production_min || (hasRequiredBcUrRegistryAvalanche_cjs_production_min = 1, function(o) {
    Object.defineProperty(o, "__esModule", { value: !0 });
    var g = requireDist$n(), c = require$$1$3, y = requireBuffer$2();
    const t = { AVALANCHE_SIGN_REQUEST: new g.RegistryType("avax-sign-request", 8301), AVALANCHE_SIGNATURE: new g.RegistryType("avax-signature", 8302) }, { RegistryTypes: d } = g.extend;
    var E;
    (function(M) {
      M[M.requestId = 1] = "requestId", M[M.signData = 2] = "signData", M[M.mfp = 3] = "mfp", M[M.xpub = 6] = "xpub", M[M.walletIndex = 7] = "walletIndex";
    })(E || (E = {}));
    class B extends g.RegistryItem {
      constructor(U) {
        super(), this.getRegistryType = () => t.AVALANCHE_SIGN_REQUEST, this.getRequestId = () => this.requestId, this.getSignData = () => this.data, this.toDataItem = () => {
          const L = {};
          return this.requestId && (L[E.requestId] = new g.DataItem(this.requestId, d.UUID.getTag())), L[E.signData] = this.data, L[E.mfp] = this.mfp.readUInt32BE(0), L[E.xpub] = this.xpub, L[E.walletIndex] = Number(this.walletIndex), new g.DataItem(L);
        }, this.requestId = U.requestId, this.data = U.data, this.mfp = U.mfp, this.xpub = U.xpub, this.walletIndex = U.walletIndex;
      }
      static constructAvalancheRequest(U, L, H, fe) {
        const ge = c.v4();
        return new B({ data: U, requestId: y.Buffer.from(c.parse(ge)), mfp: y.Buffer.from(L, "hex"), xpub: H, walletIndex: fe });
      }
    }
    B.fromDataItem = (M) => {
      const U = M.getData(), L = y.Buffer.alloc(4);
      L.writeUInt32BE(U[E.mfp], 0);
      const H = U[E.requestId] ? U[E.requestId].getData() : void 0;
      return new B({ requestId: H, data: U[E.signData], xpub: U[E.xpub], walletIndex: U[E.signData], mfp: L });
    };
    const { RegistryTypes: D, decodeToDataItem: x } = g.extend;
    var v;
    (function(M) {
      M[M.requestId = 1] = "requestId", M[M.signature = 2] = "signature";
    })(v || (v = {}));
    class F extends g.RegistryItem {
      constructor(U, L) {
        super(), this.getRegistryType = () => t.AVALANCHE_SIGNATURE, this.getRequestId = () => this.requestId, this.getSignature = () => this.signature, this.toDataItem = () => {
          const H = {};
          return this.requestId && (H[v.requestId] = new g.DataItem(this.requestId, D.UUID.getTag())), H[v.signature] = this.signature, new g.DataItem(H);
        }, this.signature = U, this.requestId = L;
      }
    }
    F.fromDataItem = (M) => {
      const U = M.getData();
      return new F(U[v.signature]);
    }, F.fromCBOR = (M) => {
      const U = x(M);
      return F.fromDataItem(U);
    }, g.patchTags(Object.values(t).filter((M) => !!M.getTag()).map((M) => M.getTag())), Object.keys(g).forEach(function(M) {
      M !== "default" && Object.defineProperty(o, M, { enumerable: !0, get: function() {
        return g[M];
      } });
    }), o.AvalancheSignRequest = B, o.AvalancheSignature = F;
  }(bcUrRegistryAvalanche_cjs_production_min)), bcUrRegistryAvalanche_cjs_production_min;
}
var bcUrRegistryAvalanche_cjs_development = {}, hasRequiredBcUrRegistryAvalanche_cjs_development;
function requireBcUrRegistryAvalanche_cjs_development() {
  return hasRequiredBcUrRegistryAvalanche_cjs_development || (hasRequiredBcUrRegistryAvalanche_cjs_development = 1, function(o) {
    Object.defineProperty(o, "__esModule", { value: !0 });
    var g = requireDist$n(), c = require$$1$3, y = requireBuffer$2();
    const t = {
      AVALANCHE_SIGN_REQUEST: /* @__PURE__ */ new g.RegistryType("avax-sign-request", 8301),
      AVALANCHE_SIGNATURE: /* @__PURE__ */ new g.RegistryType("avax-signature", 8302)
    }, {
      RegistryTypes: d
    } = g.extend;
    var E;
    (function(M) {
      M[M.requestId = 1] = "requestId", M[M.signData = 2] = "signData", M[M.mfp = 3] = "mfp", M[M.xpub = 6] = "xpub", M[M.walletIndex = 7] = "walletIndex";
    })(E || (E = {}));
    class B extends g.RegistryItem {
      constructor(U) {
        super(), this.getRegistryType = () => t.AVALANCHE_SIGN_REQUEST, this.getRequestId = () => this.requestId, this.getSignData = () => this.data, this.toDataItem = () => {
          const L = {};
          return this.requestId && (L[E.requestId] = new g.DataItem(this.requestId, d.UUID.getTag())), L[E.signData] = this.data, L[E.mfp] = this.mfp.readUInt32BE(0), L[E.xpub] = this.xpub, L[E.walletIndex] = Number(this.walletIndex), new g.DataItem(L);
        }, this.requestId = U.requestId, this.data = U.data, this.mfp = U.mfp, this.xpub = U.xpub, this.walletIndex = U.walletIndex;
      }
      static constructAvalancheRequest(U, L, H, fe) {
        const ge = c.v4();
        return new B({
          data: U,
          requestId: y.Buffer.from(c.parse(ge)),
          mfp: y.Buffer.from(L, "hex"),
          xpub: H,
          walletIndex: fe
        });
      }
    }
    B.fromDataItem = (M) => {
      const U = M.getData(), L = y.Buffer.alloc(4), H = U[E.mfp];
      L.writeUInt32BE(H, 0);
      const fe = U[E.requestId] ? U[E.requestId].getData() : void 0, ge = U[E.signData], Ie = U[E.xpub], Ee = U[E.signData];
      return new B({
        requestId: fe,
        data: ge,
        xpub: Ie,
        walletIndex: Ee,
        mfp: L
      });
    };
    const {
      RegistryTypes: D,
      decodeToDataItem: x
    } = g.extend;
    var v;
    (function(M) {
      M[M.requestId = 1] = "requestId", M[M.signature = 2] = "signature";
    })(v || (v = {}));
    class F extends g.RegistryItem {
      constructor(U, L) {
        super(), this.getRegistryType = () => t.AVALANCHE_SIGNATURE, this.getRequestId = () => this.requestId, this.getSignature = () => this.signature, this.toDataItem = () => {
          const H = {};
          return this.requestId && (H[v.requestId] = new g.DataItem(this.requestId, D.UUID.getTag())), H[v.signature] = this.signature, new g.DataItem(H);
        }, this.signature = U, this.requestId = L;
      }
    }
    F.fromDataItem = (M) => {
      const L = M.getData()[v.signature];
      return new F(L);
    }, F.fromCBOR = (M) => {
      const U = x(M);
      return F.fromDataItem(U);
    }, g.patchTags(Object.values(t).filter((M) => !!M.getTag()).map((M) => M.getTag())), Object.keys(g).forEach(function(M) {
      M !== "default" && Object.defineProperty(o, M, {
        enumerable: !0,
        get: function() {
          return g[M];
        }
      });
    }), o.AvalancheSignRequest = B, o.AvalancheSignature = F;
  }(bcUrRegistryAvalanche_cjs_development)), bcUrRegistryAvalanche_cjs_development;
}
var hasRequiredDist$8;
function requireDist$8() {
  return hasRequiredDist$8 || (hasRequiredDist$8 = 1, process$1.env.NODE_ENV === "production" ? dist$7.exports = requireBcUrRegistryAvalanche_cjs_production_min() : dist$7.exports = requireBcUrRegistryAvalanche_cjs_development()), dist$7.exports;
}
var hasRequiredAvalanche;
function requireAvalanche() {
  if (hasRequiredAvalanche) return avalanche;
  hasRequiredAvalanche = 1, Object.defineProperty(avalanche, "__esModule", { value: !0 }), avalanche.KeystoneAvalancheSDK = void 0;
  const o = requireUtils$e(), g = requireDist$8();
  class c {
    generateSignRequest({ signData: t, mfp: d, xpub: E, walletIndex: B }) {
      return g.AvalancheSignRequest.constructAvalancheRequest((0, o.toBuffer)(t), d, E, B).toUR();
    }
  }
  return avalanche.KeystoneAvalancheSDK = c, avalanche;
}
var doge = {}, hasRequiredDoge;
function requireDoge() {
  if (hasRequiredDoge) return doge;
  hasRequiredDoge = 1, Object.defineProperty(doge, "__esModule", { value: !0 }), doge.KeystoneDogecoinSDK = void 0;
  const o = requireKeystone();
  class g extends o.Keystone {
    generateSignRequest(y) {
      return super.generateSignRequest(Object.assign({ chain: o.Chain.DOGE }, y));
    }
  }
  return doge.KeystoneDogecoinSDK = g, doge;
}
var iota = {}, dist$6 = { exports: {} }, bcUrRegistryIota_cjs_production_min = {}, hasRequiredBcUrRegistryIota_cjs_production_min;
function requireBcUrRegistryIota_cjs_production_min() {
  return hasRequiredBcUrRegistryIota_cjs_production_min || (hasRequiredBcUrRegistryIota_cjs_production_min = 1, function(o) {
    Object.defineProperty(o, "__esModule", { value: !0 });
    var g = requireDist$n(), c = /* @__PURE__ */ requireCommonjsBrowser();
    const y = { IOTA_SIGN_REQUEST: new g.RegistryType("iota-sign-request", 8501), IOTA_SIGNATURE: new g.RegistryType("iota-signature", 8502), IOTA_SIGN_HASH_REQUEST: new g.RegistryType("iota-sign-hash-request", 8503) }, { decodeToDataItem: t, RegistryTypes: d } = g.extend;
    var E;
    (function(fe) {
      fe[fe.requestId = 1] = "requestId", fe[fe.intentMessage = 2] = "intentMessage", fe[fe.derivationPaths = 3] = "derivationPaths", fe[fe.addresses = 4] = "addresses", fe[fe.origin = 5] = "origin";
    })(E || (E = {}));
    class B extends g.RegistryItem {
      constructor(ge) {
        super(), this.getRegistryType = () => y.IOTA_SIGN_REQUEST, this.getRequestId = () => this.requestId, this.getIntentMessage = () => this.intentMessage, this.getDerivationPaths = () => this.derivationPaths, this.getAddresses = () => this.addresses, this.getOrigin = () => this.origin, this.toDataItem = () => {
          const Ie = {};
          this.requestId && (Ie[E.requestId] = new g.DataItem(this.requestId, d.UUID.getTag())), Ie[E.intentMessage] = this.intentMessage;
          const Ee = this.derivationPaths.map((Se) => {
            const ze = Se.toDataItem();
            return ze.setTag(Se.getRegistryType().getTag()), ze;
          });
          return Ie[E.derivationPaths] = Ee, this.addresses && (Ie[E.addresses] = this.addresses), this.origin && (Ie[E.origin] = this.origin), new g.DataItem(Ie);
        }, this.requestId = ge.requestId, this.intentMessage = ge.intentMessage, this.derivationPaths = ge.derivationPaths, this.addresses = ge.addresses, this.origin = ge.origin;
      }
      static parsePath(ge, Ie) {
        const Ee = ge.replace(/[m|M]\//, "").split("/").map((Se) => {
          const ze = parseInt(Se.replace("'", ""));
          let He = !1;
          return Se.endsWith("'") && (He = !0), new g.PathComponent({ index: ze, hardened: He });
        });
        return new g.CryptoKeypath(Ee, Buffer.from(Ie, "hex"));
      }
      static constructIotaSignRequest(ge, Ie, Ee, Se, ze, He) {
        return new B({ requestId: Se ? Buffer.from(c.parse(Se)) : void 0, intentMessage: ge, derivationPaths: Ie.map((Pe) => B.parsePath(Pe, Ee)), addresses: ze, origin: He });
      }
    }
    B.fromDataItem = (fe) => {
      const ge = fe.getData(), Ie = ge[E.requestId] ? ge[E.requestId].getData() : void 0;
      return new B({ requestId: Ie, intentMessage: ge[E.intentMessage], derivationPaths: ge[E.derivationPaths].map((Ee) => g.CryptoKeypath.fromDataItem(Ee)), addresses: ge[E.addresses], origin: ge[E.origin] });
    }, B.fromCBOR = (fe) => {
      const ge = t(fe);
      return B.fromDataItem(ge);
    };
    const { RegistryTypes: D, decodeToDataItem: x } = g.extend;
    var v;
    (function(fe) {
      fe[fe.requestId = 1] = "requestId", fe[fe.signature = 2] = "signature", fe[fe.publicKey = 3] = "publicKey";
    })(v || (v = {}));
    class F extends g.RegistryItem {
      constructor(ge) {
        super(), this.getRegistryType = () => y.IOTA_SIGNATURE, this.getRequestId = () => this.requestId, this.getSignature = () => this.signature, this.getPublicKey = () => this.publicKey, this.toDataItem = () => {
          const Ie = {};
          return Ie[v.requestId] = new g.DataItem(this.requestId, D.UUID.getTag()), Ie[v.signature] = this.signature, this.publicKey && (Ie[v.publicKey] = this.publicKey), new g.DataItem(Ie);
        }, this.requestId = ge.requestId, this.signature = ge.signature, this.publicKey = ge.publicKey;
      }
    }
    F.fromDataItem = (fe) => {
      var ge;
      const Ie = fe.getData(), Ee = Ie[v.signature], Se = (ge = Ie[v.requestId]) === null || ge === void 0 ? void 0 : ge.getData();
      return new F({ requestId: Se, signature: Ee, publicKey: Ie[v.publicKey] });
    }, F.fromCBOR = (fe) => {
      const ge = x(fe);
      return F.fromDataItem(ge);
    };
    const { decodeToDataItem: M, RegistryTypes: U } = g.extend;
    var L;
    (function(fe) {
      fe[fe.requestId = 1] = "requestId", fe[fe.messageHash = 2] = "messageHash", fe[fe.derivationPaths = 3] = "derivationPaths", fe[fe.addresses = 4] = "addresses", fe[fe.origin = 5] = "origin";
    })(L || (L = {}));
    class H extends g.RegistryItem {
      constructor(ge) {
        super(), this.getRegistryType = () => y.IOTA_SIGN_HASH_REQUEST, this.getRequestId = () => this.requestId, this.getMessageHash = () => this.messageHash, this.getDerivationPaths = () => this.derivationPaths, this.getAddresses = () => this.addresses, this.getOrigin = () => this.origin, this.toDataItem = () => {
          const Ie = {};
          Ie[L.messageHash] = this.messageHash;
          const Ee = this.derivationPaths.map((Se) => {
            const ze = Se.toDataItem();
            return ze.setTag(Se.getRegistryType().getTag()), ze;
          });
          return Ie[L.derivationPaths] = Ee, this.requestId && (Ie[L.requestId] = new g.DataItem(this.requestId, U.UUID.getTag())), this.addresses && (Ie[L.addresses] = this.addresses), this.origin && (Ie[L.origin] = this.origin), new g.DataItem(Ie);
        }, this.requestId = ge.requestId, this.messageHash = ge.messageHash, this.derivationPaths = ge.derivationPaths, this.addresses = ge.addresses, this.origin = ge.origin;
      }
      static parsePath(ge, Ie) {
        const Ee = ge.replace(/[m|M]\//, "").split("/").map((Se) => {
          const ze = parseInt(Se.replace("'", ""));
          let He = !1;
          return Se.endsWith("'") && (He = !0), new g.PathComponent({ index: ze, hardened: He });
        });
        return new g.CryptoKeypath(Ee, Buffer.from(Ie, "hex"));
      }
      static constructIotaSignHashRequest(ge, Ie, Ee, Se, ze, He) {
        return new H({ requestId: Se ? Buffer.from(c.parse(Se)) : void 0, messageHash: ge, derivationPaths: Ie.map((Pe) => H.parsePath(Pe, Ee)), addresses: ze, origin: He });
      }
    }
    H.fromDataItem = (fe) => {
      const ge = fe.getData(), Ie = ge[L.requestId] ? ge[L.requestId].getData() : void 0;
      return new H({ requestId: Ie, messageHash: ge[L.messageHash], derivationPaths: ge[L.derivationPaths].map((Ee) => g.CryptoKeypath.fromDataItem(Ee)), addresses: ge[L.addresses], origin: ge[L.origin] });
    }, H.fromCBOR = (fe) => {
      const ge = M(fe);
      return H.fromDataItem(ge);
    }, g.patchTags(Object.values(y).filter((fe) => !!fe.getTag()).map((fe) => fe.getTag())), Object.keys(g).forEach(function(fe) {
      fe !== "default" && Object.defineProperty(o, fe, { enumerable: !0, get: function() {
        return g[fe];
      } });
    }), o.IotaSignHashRequest = H, o.IotaSignRequest = B, o.IotaSignature = F;
  }(bcUrRegistryIota_cjs_production_min)), bcUrRegistryIota_cjs_production_min;
}
var bcUrRegistryIota_cjs_development = {}, hasRequiredBcUrRegistryIota_cjs_development;
function requireBcUrRegistryIota_cjs_development() {
  return hasRequiredBcUrRegistryIota_cjs_development || (hasRequiredBcUrRegistryIota_cjs_development = 1, function(o) {
    Object.defineProperty(o, "__esModule", { value: !0 });
    var g = requireDist$n(), c = /* @__PURE__ */ requireCommonjsBrowser();
    const y = {
      IOTA_SIGN_REQUEST: /* @__PURE__ */ new g.RegistryType("iota-sign-request", 8501),
      IOTA_SIGNATURE: /* @__PURE__ */ new g.RegistryType("iota-signature", 8502),
      IOTA_SIGN_HASH_REQUEST: /* @__PURE__ */ new g.RegistryType("iota-sign-hash-request", 8503)
    }, {
      decodeToDataItem: t,
      RegistryTypes: d
    } = g.extend;
    var E;
    (function(fe) {
      fe[fe.requestId = 1] = "requestId", fe[fe.intentMessage = 2] = "intentMessage", fe[fe.derivationPaths = 3] = "derivationPaths", fe[fe.addresses = 4] = "addresses", fe[fe.origin = 5] = "origin";
    })(E || (E = {}));
    class B extends g.RegistryItem {
      constructor(ge) {
        super(), this.getRegistryType = () => y.IOTA_SIGN_REQUEST, this.getRequestId = () => this.requestId, this.getIntentMessage = () => this.intentMessage, this.getDerivationPaths = () => this.derivationPaths, this.getAddresses = () => this.addresses, this.getOrigin = () => this.origin, this.toDataItem = () => {
          const Ie = {};
          this.requestId && (Ie[E.requestId] = new g.DataItem(this.requestId, d.UUID.getTag())), Ie[E.intentMessage] = this.intentMessage;
          const Ee = this.derivationPaths.map((Se) => {
            const ze = Se.toDataItem();
            return ze.setTag(Se.getRegistryType().getTag()), ze;
          });
          return Ie[E.derivationPaths] = Ee, this.addresses && (Ie[E.addresses] = this.addresses), this.origin && (Ie[E.origin] = this.origin), new g.DataItem(Ie);
        }, this.requestId = ge.requestId, this.intentMessage = ge.intentMessage, this.derivationPaths = ge.derivationPaths, this.addresses = ge.addresses, this.origin = ge.origin;
      }
      static parsePath(ge, Ie) {
        const Se = ge.replace(/[m|M]\//, "").split("/").map((ze) => {
          const He = parseInt(ze.replace("'", ""));
          let Pe = !1;
          return ze.endsWith("'") && (Pe = !0), new g.PathComponent({
            index: He,
            hardened: Pe
          });
        });
        return new g.CryptoKeypath(Se, Buffer.from(Ie, "hex"));
      }
      static constructIotaSignRequest(ge, Ie, Ee, Se, ze, He) {
        return new B({
          requestId: Se ? Buffer.from(c.parse(Se)) : void 0,
          intentMessage: ge,
          derivationPaths: Ie.map((Pe) => B.parsePath(Pe, Ee)),
          addresses: ze,
          origin: He
        });
      }
    }
    B.fromDataItem = (fe) => {
      const ge = fe.getData(), Ie = ge[E.requestId] ? ge[E.requestId].getData() : void 0;
      return new B({
        requestId: Ie,
        intentMessage: ge[E.intentMessage],
        derivationPaths: ge[E.derivationPaths].map((Ee) => g.CryptoKeypath.fromDataItem(Ee)),
        addresses: ge[E.addresses],
        origin: ge[E.origin]
      });
    }, B.fromCBOR = (fe) => {
      const ge = t(fe);
      return B.fromDataItem(ge);
    };
    const {
      RegistryTypes: D,
      decodeToDataItem: x
    } = g.extend;
    var v;
    (function(fe) {
      fe[fe.requestId = 1] = "requestId", fe[fe.signature = 2] = "signature", fe[fe.publicKey = 3] = "publicKey";
    })(v || (v = {}));
    class F extends g.RegistryItem {
      constructor(ge) {
        super(), this.getRegistryType = () => y.IOTA_SIGNATURE, this.getRequestId = () => this.requestId, this.getSignature = () => this.signature, this.getPublicKey = () => this.publicKey, this.toDataItem = () => {
          const Ie = {};
          return Ie[v.requestId] = new g.DataItem(this.requestId, D.UUID.getTag()), Ie[v.signature] = this.signature, this.publicKey && (Ie[v.publicKey] = this.publicKey), new g.DataItem(Ie);
        }, this.requestId = ge.requestId, this.signature = ge.signature, this.publicKey = ge.publicKey;
      }
    }
    F.fromDataItem = (fe) => {
      var ge;
      const Ie = fe.getData(), Ee = Ie[v.signature], Se = (ge = Ie[v.requestId]) === null || ge === void 0 ? void 0 : ge.getData(), ze = Ie[v.publicKey];
      return new F({
        requestId: Se,
        signature: Ee,
        publicKey: ze
      });
    }, F.fromCBOR = (fe) => {
      const ge = x(fe);
      return F.fromDataItem(ge);
    };
    const {
      decodeToDataItem: M,
      RegistryTypes: U
    } = g.extend;
    var L;
    (function(fe) {
      fe[fe.requestId = 1] = "requestId", fe[fe.messageHash = 2] = "messageHash", fe[fe.derivationPaths = 3] = "derivationPaths", fe[fe.addresses = 4] = "addresses", fe[fe.origin = 5] = "origin";
    })(L || (L = {}));
    class H extends g.RegistryItem {
      constructor(ge) {
        super(), this.getRegistryType = () => y.IOTA_SIGN_HASH_REQUEST, this.getRequestId = () => this.requestId, this.getMessageHash = () => this.messageHash, this.getDerivationPaths = () => this.derivationPaths, this.getAddresses = () => this.addresses, this.getOrigin = () => this.origin, this.toDataItem = () => {
          const Ie = {};
          Ie[L.messageHash] = this.messageHash;
          const Ee = this.derivationPaths.map((Se) => {
            const ze = Se.toDataItem();
            return ze.setTag(Se.getRegistryType().getTag()), ze;
          });
          return Ie[L.derivationPaths] = Ee, this.requestId && (Ie[L.requestId] = new g.DataItem(this.requestId, U.UUID.getTag())), this.addresses && (Ie[L.addresses] = this.addresses), this.origin && (Ie[L.origin] = this.origin), new g.DataItem(Ie);
        }, this.requestId = ge.requestId, this.messageHash = ge.messageHash, this.derivationPaths = ge.derivationPaths, this.addresses = ge.addresses, this.origin = ge.origin;
      }
      static parsePath(ge, Ie) {
        const Se = ge.replace(/[m|M]\//, "").split("/").map((ze) => {
          const He = parseInt(ze.replace("'", ""));
          let Pe = !1;
          return ze.endsWith("'") && (Pe = !0), new g.PathComponent({
            index: He,
            hardened: Pe
          });
        });
        return new g.CryptoKeypath(Se, Buffer.from(Ie, "hex"));
      }
      static constructIotaSignHashRequest(ge, Ie, Ee, Se, ze, He) {
        return new H({
          requestId: Se ? Buffer.from(c.parse(Se)) : void 0,
          messageHash: ge,
          derivationPaths: Ie.map((Pe) => H.parsePath(Pe, Ee)),
          addresses: ze,
          origin: He
        });
      }
    }
    H.fromDataItem = (fe) => {
      const ge = fe.getData(), Ie = ge[L.requestId] ? ge[L.requestId].getData() : void 0;
      return new H({
        requestId: Ie,
        messageHash: ge[L.messageHash],
        derivationPaths: ge[L.derivationPaths].map((Ee) => g.CryptoKeypath.fromDataItem(Ee)),
        addresses: ge[L.addresses],
        origin: ge[L.origin]
      });
    }, H.fromCBOR = (fe) => {
      const ge = M(fe);
      return H.fromDataItem(ge);
    }, g.patchTags(Object.values(y).filter((fe) => !!fe.getTag()).map((fe) => fe.getTag())), Object.keys(g).forEach(function(fe) {
      fe !== "default" && Object.defineProperty(o, fe, {
        enumerable: !0,
        get: function() {
          return g[fe];
        }
      });
    }), o.IotaSignHashRequest = H, o.IotaSignRequest = B, o.IotaSignature = F;
  }(bcUrRegistryIota_cjs_development)), bcUrRegistryIota_cjs_development;
}
var hasRequiredDist$7;
function requireDist$7() {
  return hasRequiredDist$7 || (hasRequiredDist$7 = 1, process$1.env.NODE_ENV === "production" ? dist$6.exports = requireBcUrRegistryIota_cjs_production_min() : dist$6.exports = requireBcUrRegistryIota_cjs_development()), dist$6.exports;
}
var hasRequiredIota;
function requireIota() {
  if (hasRequiredIota) return iota;
  hasRequiredIota = 1, Object.defineProperty(iota, "__esModule", { value: !0 }), iota.KeystoneIotaSDK = void 0;
  const o = requireDist$7(), g = requireUtils$e(), c = requireUr(), y = /* @__PURE__ */ requireBlake2b();
  class t {
    constructor(E) {
      this.config = E;
    }
    parseSignature(E) {
      if (E.type !== c.URType.IotaSignature)
        throw new Error("type not match");
      const B = o.IotaSignature.fromCBOR(E.cbor), D = B.getRequestId();
      return {
        requestId: Buffer.isBuffer(D) ? (0, g.uuidStringify)(D) : "",
        signature: (0, g.toHex)(B.getSignature()),
        publicKey: (0, g.toHex)(B.getPublicKey())
      };
    }
    generateSignHashRequest({ requestId: E, messageHash: B, accounts: D, origin: x }) {
      const v = [], F = [];
      if (D.forEach((M) => {
        v.push(new o.CryptoKeypath((0, g.parsePath)(M.path).map((U) => new o.PathComponent(U)), (0, g.toBuffer)(M.xfp))), M.address !== void 0 && F.push((0, g.toBuffer)(M.address.startsWith("0x") ? M.address.substring(2) : M.address));
      }), F.length > 0 && F.length !== v.length)
        throw new Error("address and path count must match");
      return new o.IotaSignHashRequest({
        requestId: (0, g.uuidParse)(E),
        messageHash: B,
        derivationPaths: v,
        addresses: F,
        origin: x
      }).toUR();
    }
    generateIntentMessageHash(E) {
      let B = (0, g.toBuffer)(E);
      const D = (0, y.blake2b)(Uint8Array.from(B), { dkLen: 32 });
      return (0, g.toHex)(D);
    }
    generateSignRequest({ requestId: E, intentMessage: B, accounts: D, origin: x }) {
      var v, F, M;
      const U = (M = (F = (v = this.config) === null || v === void 0 ? void 0 : v.sizeLimit) === null || F === void 0 ? void 0 : F.iota) !== null && M !== void 0 ? M : 2048, L = [], H = [];
      if (D.forEach((ge) => {
        L.push(new o.CryptoKeypath((0, g.parsePath)(ge.path).map((Ie) => new o.PathComponent(Ie)), (0, g.toBuffer)(ge.xfp))), ge.address !== void 0 && H.push((0, g.toBuffer)(ge.address.startsWith("0x") ? ge.address.substring(2) : ge.address));
      }), H.length > 0 && H.length !== L.length)
        throw new Error("address and path count must match");
      let fe = (0, g.toBuffer)(B);
      if (fe.length > U) {
        const ge = (0, y.blake2b)(Uint8Array.from(fe), { dkLen: 32 });
        if (ge.length !== 32)
          throw new Error("hash length must be 32");
        return B = (0, g.toHex)(ge), new o.IotaSignHashRequest({
          requestId: (0, g.uuidParse)(E),
          messageHash: B,
          derivationPaths: L,
          addresses: H,
          origin: x
        }).toUR();
      }
      return new o.IotaSignRequest({
        requestId: (0, g.uuidParse)(E),
        intentMessage: (0, g.toBuffer)(B),
        derivationPaths: L,
        addresses: H,
        origin: x
      }).toUR();
    }
  }
  return iota.KeystoneIotaSDK = t, iota;
}
var psbt$3 = {}, hasRequiredPsbt$3;
function requirePsbt$3() {
  if (hasRequiredPsbt$3) return psbt$3;
  hasRequiredPsbt$3 = 1, Object.defineProperty(psbt$3, "__esModule", { value: !0 }), psbt$3.KeystonePsbtSDK = void 0;
  const o = requireDist$o(), g = requireDist$m(), c = requireUtils$e(), y = requireUr();
  class t {
    constructor(E) {
      this.config = E;
    }
    parsePSBT(E) {
      if (E.type !== y.URType.CryptoPSBTExtend)
        throw new Error("type not match");
      return (0, c.toHex)(o.CryptoPSBTExtend.fromCBOR(E.cbor).getPSBT());
    }
    parseCoinId(E) {
      if (E.type !== y.URType.CryptoPSBTExtend)
        throw new Error("type not match");
      return o.CryptoPSBTExtend.fromCBOR(E.cbor).getCoinId();
    }
    generatePSBT(E, B) {
      return new o.CryptoPSBTExtend(E, B).toUR();
    }
  }
  return psbt$3.KeystonePsbtSDK = t, t.DataType = g.DataType, psbt$3;
}
var zcash = {}, dist$5 = {}, RegistryType = {}, hasRequiredRegistryType;
function requireRegistryType() {
  if (hasRequiredRegistryType) return RegistryType;
  hasRequiredRegistryType = 1, Object.defineProperty(RegistryType, "__esModule", { value: !0 }), RegistryType.ExtendedRegistryTypes = void 0;
  const o = requireDist$j();
  return RegistryType.ExtendedRegistryTypes = {
    ZCASH_ACCOUNTS: new o.RegistryType("zcash-accounts", 49201),
    ZCASH_FULL_VIEWING_KEY: new o.RegistryType("zcash-full-viewing-key", 49202),
    ZCASH_UNIFIED_FULL_VIEWING_KEY: new o.RegistryType("zcash-unified-full-viewing-key", 49203),
    ZCASH_PCZT: new o.RegistryType("zcash-pczt", 49204)
  }, RegistryType;
}
var ZcashPCZT = {}, hasRequiredZcashPCZT;
function requireZcashPCZT() {
  if (hasRequiredZcashPCZT) return ZcashPCZT;
  hasRequiredZcashPCZT = 1, Object.defineProperty(ZcashPCZT, "__esModule", { value: !0 }), ZcashPCZT.ZcashPCZT = void 0;
  const o = requireDist$j(), g = requireRegistryType();
  var c;
  (function(t) {
    t[t.data = 1] = "data";
  })(c || (c = {}));
  let y = class extends o.RegistryItem {
    constructor(d) {
      super(), this.data = d, this.getRegistryType = () => g.ExtendedRegistryTypes.ZCASH_PCZT, this.getData = () => this.data, this.toDataItem = () => {
        const E = {};
        return E[c.data] = this.data, new o.DataItem(E);
      };
    }
  };
  return ZcashPCZT.ZcashPCZT = y, y.fromDataItem = (t) => {
    const E = t.getData()[c.data];
    return new y(E);
  }, y.fromCBOR = (t) => {
    const d = (0, o.decodeToDataItem)(t);
    return y.fromDataItem(d);
  }, ZcashPCZT;
}
var ZcashUnifiedFullViewingKey = {}, hasRequiredZcashUnifiedFullViewingKey;
function requireZcashUnifiedFullViewingKey() {
  if (hasRequiredZcashUnifiedFullViewingKey) return ZcashUnifiedFullViewingKey;
  hasRequiredZcashUnifiedFullViewingKey = 1, Object.defineProperty(ZcashUnifiedFullViewingKey, "__esModule", { value: !0 }), ZcashUnifiedFullViewingKey.ZcashUnifiedFullViewingKey = void 0;
  const o = requireDist$j(), g = requireRegistryType();
  var c;
  (function(t) {
    t[t.UFVK = 1] = "UFVK", t[t.Index = 2] = "Index", t[t.Name = 3] = "Name";
  })(c || (c = {}));
  let y = class extends o.RegistryItem {
    constructor(d, E, B) {
      super(), this.ufvk = d, this.index = E, this.name = B, this.getRegistryType = () => g.ExtendedRegistryTypes.ZCASH_UNIFIED_FULL_VIEWING_KEY, this.getUfvk = () => this.ufvk, this.getIndex = () => this.index, this.getName = () => this.name, this.toDataItem = () => {
        const D = {};
        return D[c.UFVK] = this.ufvk, D[c.Index] = this.index, this.name && (D[c.Name] = this.name), new o.DataItem(D);
      };
    }
  };
  return ZcashUnifiedFullViewingKey.ZcashUnifiedFullViewingKey = y, y.fromDataItem = (t) => {
    const d = t.getData(), E = d[c.UFVK], B = d[c.Index], D = d[c.Name];
    return new y(E, B, D);
  }, y.fromCBOR = (t) => {
    const d = (0, o.decodeToDataItem)(t);
    return y.fromDataItem(d);
  }, ZcashUnifiedFullViewingKey;
}
var ZcashAccounts = {}, hasRequiredZcashAccounts;
function requireZcashAccounts() {
  if (hasRequiredZcashAccounts) return ZcashAccounts;
  hasRequiredZcashAccounts = 1, Object.defineProperty(ZcashAccounts, "__esModule", { value: !0 }), ZcashAccounts.ZcashAccounts = void 0;
  const o = requireDist$j(), g = requireRegistryType(), c = requireZcashUnifiedFullViewingKey(), { decodeToDataItem: y } = o.extend;
  var t;
  (function(E) {
    E[E.seedFingerprint = 1] = "seedFingerprint", E[E.accounts = 2] = "accounts";
  })(t || (t = {}));
  let d = class extends o.RegistryItem {
    constructor(B, D) {
      super(), this.seedFingerprint = B, this.accounts = D, this.getRegistryType = () => g.ExtendedRegistryTypes.ZCASH_ACCOUNTS, this.getSeedFingerprint = () => this.seedFingerprint, this.getAccounts = () => this.accounts, this.toDataItem = () => {
        const x = {};
        return x[t.seedFingerprint] = this.seedFingerprint, this.accounts && (x[t.accounts] = this.accounts.map((v) => {
          const F = v.toDataItem();
          return F.setTag(v.getRegistryType().getTag()), F;
        })), new o.DataItem(x);
      };
    }
  };
  return ZcashAccounts.ZcashAccounts = d, d.fromDataItem = (E) => {
    const B = E.getData(), D = B[t.seedFingerprint], x = B[t.accounts].map((v) => c.ZcashUnifiedFullViewingKey.fromDataItem(v));
    return new d(D, x);
  }, d.fromCBOR = (E) => {
    const B = y(E);
    return d.fromDataItem(B);
  }, ZcashAccounts;
}
var hasRequiredDist$6;
function requireDist$6() {
  return hasRequiredDist$6 || (hasRequiredDist$6 = 1, function(o) {
    var g = dist$5 && dist$5.__createBinding || (Object.create ? function(D, x, v, F) {
      F === void 0 && (F = v);
      var M = Object.getOwnPropertyDescriptor(x, v);
      (!M || ("get" in M ? !x.__esModule : M.writable || M.configurable)) && (M = { enumerable: !0, get: function() {
        return x[v];
      } }), Object.defineProperty(D, F, M);
    } : function(D, x, v, F) {
      F === void 0 && (F = v), D[F] = x[v];
    }), c = dist$5 && dist$5.__exportStar || function(D, x) {
      for (var v in D) v !== "default" && !Object.prototype.hasOwnProperty.call(x, v) && g(x, D, v);
    };
    Object.defineProperty(o, "__esModule", { value: !0 }), o.ZcashAccounts = o.ZcashUnifiedFullViewingKey = o.ZcashPCZT = void 0;
    const y = requireDist$j(), t = requireRegistryType();
    c(requireDist$j(), o), console.log("Registering Zcash UR Registry Types..."), (0, y.patchTags)(Object.values(t.ExtendedRegistryTypes).filter((D) => !!D.getTag()).map((D) => D.getTag()));
    var d = requireZcashPCZT();
    Object.defineProperty(o, "ZcashPCZT", { enumerable: !0, get: function() {
      return d.ZcashPCZT;
    } });
    var E = requireZcashUnifiedFullViewingKey();
    Object.defineProperty(o, "ZcashUnifiedFullViewingKey", { enumerable: !0, get: function() {
      return E.ZcashUnifiedFullViewingKey;
    } });
    var B = requireZcashAccounts();
    Object.defineProperty(o, "ZcashAccounts", { enumerable: !0, get: function() {
      return B.ZcashAccounts;
    } });
  }(dist$5)), dist$5;
}
var hasRequiredZcash;
function requireZcash() {
  if (hasRequiredZcash) return zcash;
  hasRequiredZcash = 1, Object.defineProperty(zcash, "__esModule", { value: !0 }), zcash.KeystoneZcashSDK = void 0;
  const o = requireDist$6(), g = requireUtils$e(), c = requireUr();
  class y {
    generatePczt(d) {
      return new o.ZcashPCZT(d).toUR();
    }
    parsePczt(d) {
      if (d.type !== c.URType.ZcashPCZT)
        throw new Error("type not match");
      return (0, g.toHex)(o.ZcashPCZT.fromCBOR(d.cbor).getData());
    }
  }
  return zcash.KeystoneZcashSDK = y, zcash;
}
var hasRequiredChains;
function requireChains() {
  return hasRequiredChains || (hasRequiredChains = 1, function(o) {
    var g = chains && chains.__createBinding || (Object.create ? function(y, t, d, E) {
      E === void 0 && (E = d);
      var B = Object.getOwnPropertyDescriptor(t, d);
      (!B || ("get" in B ? !t.__esModule : B.writable || B.configurable)) && (B = { enumerable: !0, get: function() {
        return t[d];
      } }), Object.defineProperty(y, E, B);
    } : function(y, t, d, E) {
      E === void 0 && (E = d), y[E] = t[d];
    }), c = chains && chains.__exportStar || function(y, t) {
      for (var d in y) d !== "default" && !Object.prototype.hasOwnProperty.call(t, d) && g(t, y, d);
    };
    Object.defineProperty(o, "__esModule", { value: !0 }), c(requireBitcoin$1(), o), c(requireCosmos(), o), c(requireEvm(), o), c(requireEthereum$2(), o), c(requireSolana(), o), c(requireTron(), o), c(requireAptos(), o), c(requireBitcoin_cash(), o), c(requireDash(), o), c(requireLitecoin(), o), c(requireNear(), o), c(requireCardano(), o), c(requireArweave(), o), c(requireSui(), o), c(requireTon(), o), c(requireStellar(), o), c(requireAvalanche(), o), c(requireDoge(), o), c(requireIota(), o), c(requirePsbt$3(), o), c(requireZcash(), o);
  }(chains)), chains;
}
var wallet$1 = {}, hardwareCall = {}, hasRequiredHardwareCall;
function requireHardwareCall() {
  return hasRequiredHardwareCall || (hasRequiredHardwareCall = 1, function(o) {
    Object.defineProperty(o, "__esModule", { value: !0 }), o.generateDeriveContextHashCall = o.generateKeyDerivationCall = o.parseURBytes = o.QRHardwareCallVersion = o.QRHardwareCallType = o.QRHardwareCall = o.DerivationAlgorithm = o.DeriveContextHashCall = o.Curve = void 0;
    const g = requireDist$o();
    Object.defineProperty(o, "Curve", { enumerable: !0, get: function() {
      return g.Curve;
    } }), Object.defineProperty(o, "DeriveContextHashCall", { enumerable: !0, get: function() {
      return g.DeriveContextHashCall;
    } }), Object.defineProperty(o, "DerivationAlgorithm", { enumerable: !0, get: function() {
      return g.DerivationAlgorithm;
    } }), Object.defineProperty(o, "QRHardwareCall", { enumerable: !0, get: function() {
      return g.QRHardwareCall;
    } }), Object.defineProperty(o, "QRHardwareCallType", { enumerable: !0, get: function() {
      return g.QRHardwareCallType;
    } }), Object.defineProperty(o, "QRHardwareCallVersion", { enumerable: !0, get: function() {
      return g.QRHardwareCallVersion;
    } });
    const c = requireDist$p(), y = requireUtils$e(), t = (B) => {
      const D = typeof B == "string" ? c.URDecoder.decode(B) : B;
      if (D.type !== g.RegistryTypes.BYTES.getType())
        throw new Error("ur bytes is invalid");
      return g.Bytes.fromCBOR(D.cbor).getData();
    };
    o.parseURBytes = t;
    const d = ({ schemas: B, origin: D, version: x }) => {
      const v = B.map(({ path: U, curve: L = g.Curve.secp256k1, algo: H = g.DerivationAlgorithm.slip10, chainType: fe }) => {
        if (L === g.Curve.secp256k1 && H === g.DerivationAlgorithm.bip32ed25519)
          throw new Error("the combination of the given curve and algo not supported");
        return new g.KeyDerivationSchema((0, y.pathToKeypath)(U), L, H, fe);
      }), F = new g.KeyDerivation(v);
      return new g.QRHardwareCall(g.QRHardwareCallType.KeyDerivation, F, D, x ? g.QRHardwareCallVersion.V1 : g.QRHardwareCallVersion.V0).toUR();
    };
    o.generateKeyDerivationCall = d;
    const E = ({ appName: B, network: D, keyPath: x, context: v, origin: F, version: M }) => {
      const U = new g.DeriveContextHashCall(B, D, (0, y.pathToKeypath)(x), v);
      return new g.QRHardwareCall(g.QRHardwareCallType.DeriveContextHash, U, F, M ?? g.QRHardwareCallVersion.V1).toUR();
    };
    o.generateDeriveContextHashCall = E;
  }(hardwareCall)), hardwareCall;
}
var multiAccounts = {}, types$5 = {}, account$1 = {}, hasRequiredAccount$1;
function requireAccount$1() {
  if (hasRequiredAccount$1) return account$1;
  hasRequiredAccount$1 = 1, Object.defineProperty(account$1, "__esModule", { value: !0 }), account$1.AccountNote = void 0;
  var o;
  return function(g) {
    g.Standard = "account.standard", g.LedgerLegacy = "account.ledger_legacy", g.LedgerLive = "account.ledger_live";
  }(o || (account$1.AccountNote = o = {})), account$1;
}
var props = {}, hasRequiredProps;
function requireProps() {
  return hasRequiredProps || (hasRequiredProps = 1, Object.defineProperty(props, "__esModule", { value: !0 })), props;
}
var signature = {}, hasRequiredSignature;
function requireSignature() {
  return hasRequiredSignature || (hasRequiredSignature = 1, Object.defineProperty(signature, "__esModule", { value: !0 })), signature;
}
var token = {}, hasRequiredToken;
function requireToken() {
  return hasRequiredToken || (hasRequiredToken = 1, Object.defineProperty(token, "__esModule", { value: !0 })), token;
}
var config = {}, hasRequiredConfig;
function requireConfig() {
  return hasRequiredConfig || (hasRequiredConfig = 1, Object.defineProperty(config, "__esModule", { value: !0 })), config;
}
var hasRequiredTypes$5;
function requireTypes$5() {
  return hasRequiredTypes$5 || (hasRequiredTypes$5 = 1, function(o) {
    var g = types$5 && types$5.__createBinding || (Object.create ? function(y, t, d, E) {
      E === void 0 && (E = d);
      var B = Object.getOwnPropertyDescriptor(t, d);
      (!B || ("get" in B ? !t.__esModule : B.writable || B.configurable)) && (B = { enumerable: !0, get: function() {
        return t[d];
      } }), Object.defineProperty(y, E, B);
    } : function(y, t, d, E) {
      E === void 0 && (E = d), y[E] = t[d];
    }), c = types$5 && types$5.__exportStar || function(y, t) {
      for (var d in y) d !== "default" && !Object.prototype.hasOwnProperty.call(t, d) && g(t, y, d);
    };
    Object.defineProperty(o, "__esModule", { value: !0 }), c(requireAccount$1(), o), c(requireProps(), o), c(requireSignature(), o), c(requireToken(), o), c(requireUr(), o), c(requireConfig(), o);
  }(types$5)), types$5;
}
var accountHelper = {}, hasRequiredAccountHelper;
function requireAccountHelper() {
  if (hasRequiredAccountHelper) return accountHelper;
  hasRequiredAccountHelper = 1, Object.defineProperty(accountHelper, "__esModule", { value: !0 }), accountHelper.generateExtraData = void 0;
  const o = {
    60: 1
    // ETH
  }, g = (c) => {
    var y;
    return {
      okx: {
        chainId: (y = o[c]) !== null && y !== void 0 ? y : c
      }
    };
  };
  return accountHelper.generateExtraData = g, accountHelper;
}
var hasRequiredMultiAccounts;
function requireMultiAccounts() {
  if (hasRequiredMultiAccounts) return multiAccounts;
  hasRequiredMultiAccounts = 1, Object.defineProperty(multiAccounts, "__esModule", { value: !0 }), multiAccounts.parseMultiAccounts = void 0;
  const o = requireTypes$5(), g = requireDist$o(), c = requireUtils$e(), y = requireAccountHelper(), t = (d) => {
    if (d.type !== o.URType.CryptoMultiAccounts)
      throw new Error("type not match");
    const E = g.CryptoMultiAccounts.fromCBOR(d.cbor), B = (0, c.toHex)(E.getMasterFingerprint());
    return {
      device: E.getDevice(),
      masterFingerprint: B,
      keys: E.getKeys().map((D) => {
        const x = (0, c.toHex)(D.getChainCode()), v = (0, c.toHex)(D.getParentFingerprint()), F = D.getOrigin();
        if (F === void 0)
          throw new Error("multi accounts is invalid");
        let M;
        x.length !== 0 && v.length !== 0 && (M = D.getBip32Key());
        const U = F.getComponents()[1].getIndex();
        return {
          chain: (0, c.getCoinSymbol)(U),
          path: `m/${F.getPath()}`,
          publicKey: (0, c.toHex)(D.getKey()),
          name: D.getName(),
          chainCode: x,
          extendedPublicKey: M,
          note: D.getNote(),
          extra: (0, y.generateExtraData)(U)
        };
      }),
      deviceId: E.getDeviceId(),
      deviceVersion: E.getVersion()
    };
  };
  return multiAccounts.parseMultiAccounts = t, multiAccounts;
}
var hdKey = {}, hasRequiredHdKey;
function requireHdKey() {
  if (hasRequiredHdKey) return hdKey;
  hasRequiredHdKey = 1, Object.defineProperty(hdKey, "__esModule", { value: !0 }), hdKey.parseTonAccount = hdKey.parseHDKey = void 0;
  const o = requireTypes$5(), g = requireDist$o(), c = requireUtils$e(), y = requireAccountHelper(), t = (E) => {
    var B;
    if (E.type !== o.URType.CryptoHDKey)
      throw new Error("type not match");
    const D = g.CryptoHDKey.fromCBOR(E.cbor), x = (0, c.toHex)(D.getChainCode()), v = (0, c.toHex)(D.getParentFingerprint()), F = D.getOrigin();
    if (((B = D.getOrigin().getSourceFingerprint()) === null || B === void 0 ? void 0 : B.toString("hex")) === void 0)
      throw new Error("HDKey is invalid");
    let U;
    x.length !== 0 && v.length !== 0 && (U = D.getBip32Key());
    const L = F.getComponents()[1].getIndex();
    return {
      chain: (0, c.getCoinSymbol)(L),
      path: `m/${F.getPath()}`,
      publicKey: (0, c.toHex)(D.getKey()),
      name: D.getName(),
      xfp: F.getSourceFingerprint().toString("hex"),
      chainCode: x,
      extendedPublicKey: U,
      note: D.getNote(),
      extra: (0, y.generateExtraData)(L)
    };
  };
  hdKey.parseHDKey = t;
  const d = (E) => {
    var B;
    if (E.type !== o.URType.CryptoHDKey)
      throw new Error("type not match");
    const D = g.CryptoHDKey.fromCBOR(E.cbor), x = D.getOrigin();
    if (x) {
      if (((B = D.getOrigin().getSourceFingerprint()) === null || B === void 0 ? void 0 : B.toString("hex")) === void 0)
        throw new Error("HDKey is invalid");
      return {
        path: `m/${x.getPath()}`,
        publicKey: (0, c.toHex)(D.getKey()),
        name: D.getName(),
        xfp: x.getSourceFingerprint().toString("hex")
      };
    } else
      return {
        publicKey: (0, c.toHex)(D.getKey()),
        name: D.getName()
      };
  };
  return hdKey.parseTonAccount = d, hdKey;
}
var account = {}, hasRequiredAccount;
function requireAccount() {
  if (hasRequiredAccount) return account;
  hasRequiredAccount = 1, Object.defineProperty(account, "__esModule", { value: !0 }), account.parseAccount = void 0;
  const o = requireTypes$5(), g = requireDist$o(), c = requireUtils$e(), y = requireAccountHelper(), t = (d) => {
    if (d.type !== o.URType.CryptoAccount)
      throw new Error("type not match");
    const E = g.CryptoAccount.fromCBOR(d.cbor), B = (0, c.toHex)(E.getMasterFingerprint()), D = [];
    return E.getOutputDescriptors().forEach((x) => {
      if (x.getRegistryType() !== g.RegistryTypes.CRYPTO_HDKEY) {
        const v = x.getCryptoKey(), F = (0, c.toHex)(v.getChainCode()), M = (0, c.toHex)(v.getParentFingerprint()), U = v.getOrigin();
        if (U === void 0)
          throw new Error("account is invalid");
        let L;
        F.length !== 0 && M.length !== 0 && (L = v.getBip32Key());
        const H = U.getComponents()[1].getIndex();
        D.push({
          chain: (0, c.getCoinSymbol)(H),
          path: `m/${U.getPath()}`,
          publicKey: (0, c.toHex)(v.getKey()),
          name: v.getName(),
          chainCode: F,
          extendedPublicKey: L,
          note: v.getNote(),
          extra: (0, y.generateExtraData)(H)
        });
      }
    }), {
      masterFingerprint: B,
      keys: D
    };
  };
  return account.parseAccount = t, account;
}
var hasRequiredWallet$1;
function requireWallet$1() {
  return hasRequiredWallet$1 || (hasRequiredWallet$1 = 1, function(o) {
    var g = wallet$1 && wallet$1.__createBinding || (Object.create ? function(y, t, d, E) {
      E === void 0 && (E = d);
      var B = Object.getOwnPropertyDescriptor(t, d);
      (!B || ("get" in B ? !t.__esModule : B.writable || B.configurable)) && (B = { enumerable: !0, get: function() {
        return t[d];
      } }), Object.defineProperty(y, E, B);
    } : function(y, t, d, E) {
      E === void 0 && (E = d), y[E] = t[d];
    }), c = wallet$1 && wallet$1.__exportStar || function(y, t) {
      for (var d in y) d !== "default" && !Object.prototype.hasOwnProperty.call(t, d) && g(t, y, d);
    };
    Object.defineProperty(o, "__esModule", { value: !0 }), c(requireHardwareCall(), o), c(requireMultiAccounts(), o), c(requireHdKey(), o), c(requireAccount(), o);
  }(wallet$1)), wallet$1;
}
var xrp$1 = {}, xrp = {}, dist$4 = {}, coretypes = {}, enums = {};
const TYPES = { Done: -1, Unknown: -2, NotPresent: 0, UInt16: 1, UInt32: 2, UInt64: 3, Hash128: 4, Hash256: 5, Amount: 6, Blob: 7, AccountID: 8, STObject: 14, STArray: 15, UInt8: 16, Hash160: 17, PathSet: 18, Vector256: 19, UInt96: 20, UInt192: 21, UInt384: 22, UInt512: 23, Issue: 24, XChainBridge: 25, Transaction: 10001, LedgerEntry: 10002, Validation: 10003, Metadata: 10004 }, LEDGER_ENTRY_TYPES = { Invalid: -1, AccountRoot: 97, DirectoryNode: 100, RippleState: 114, Ticket: 84, SignerList: 83, Offer: 111, Bridge: 105, LedgerHashes: 104, Amendments: 102, XChainOwnedClaimID: 113, XChainOwnedCreateAccountClaimID: 116, FeeSettings: 115, Escrow: 117, PayChannel: 120, Check: 67, DepositPreauth: 112, NegativeUNL: 78, NFTokenPage: 80, NFTokenOffer: 55, AMM: 121, DID: 73, Any: -3, Child: -2, Nickname: 110, Contract: 99, GeneratorMap: 103 }, FIELDS = /* @__PURE__ */ JSON.parse('[["Generic",{"nth":0,"isVLEncoded":false,"isSerialized":false,"isSigningField":false,"type":"Unknown"}],["Invalid",{"nth":-1,"isVLEncoded":false,"isSerialized":false,"isSigningField":false,"type":"Unknown"}],["ObjectEndMarker",{"nth":1,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STObject"}],["ArrayEndMarker",{"nth":1,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STArray"}],["hash",{"nth":257,"isVLEncoded":false,"isSerialized":false,"isSigningField":false,"type":"Hash256"}],["index",{"nth":258,"isVLEncoded":false,"isSerialized":false,"isSigningField":false,"type":"Hash256"}],["taker_gets_funded",{"nth":258,"isVLEncoded":false,"isSerialized":false,"isSigningField":false,"type":"Amount"}],["taker_pays_funded",{"nth":259,"isVLEncoded":false,"isSerialized":false,"isSigningField":false,"type":"Amount"}],["LedgerEntry",{"nth":257,"isVLEncoded":false,"isSerialized":false,"isSigningField":false,"type":"LedgerEntry"}],["Transaction",{"nth":257,"isVLEncoded":false,"isSerialized":false,"isSigningField":false,"type":"Transaction"}],["Validation",{"nth":257,"isVLEncoded":false,"isSerialized":false,"isSigningField":false,"type":"Validation"}],["Metadata",{"nth":257,"isVLEncoded":false,"isSerialized":false,"isSigningField":false,"type":"Metadata"}],["CloseResolution",{"nth":1,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt8"}],["Method",{"nth":2,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt8"}],["TransactionResult",{"nth":3,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt8"}],["TickSize",{"nth":16,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt8"}],["UNLModifyDisabling",{"nth":17,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt8"}],["HookResult",{"nth":18,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt8"}],["WasLockingChainSend",{"nth":19,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt8"}],["LedgerEntryType",{"nth":1,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt16"}],["TransactionType",{"nth":2,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt16"}],["SignerWeight",{"nth":3,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt16"}],["TransferFee",{"nth":4,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt16"}],["TradingFee",{"nth":5,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt16"}],["DiscountedFee",{"nth":6,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt16"}],["Version",{"nth":16,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt16"}],["HookStateChangeCount",{"nth":17,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt16"}],["HookEmitCount",{"nth":18,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt16"}],["HookExecutionIndex",{"nth":19,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt16"}],["HookApiVersion",{"nth":20,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt16"}],["NetworkID",{"nth":1,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["Flags",{"nth":2,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["SourceTag",{"nth":3,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["Sequence",{"nth":4,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["PreviousTxnLgrSeq",{"nth":5,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["LedgerSequence",{"nth":6,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["CloseTime",{"nth":7,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["ParentCloseTime",{"nth":8,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["SigningTime",{"nth":9,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["Expiration",{"nth":10,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["TransferRate",{"nth":11,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["WalletSize",{"nth":12,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["OwnerCount",{"nth":13,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["DestinationTag",{"nth":14,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["HighQualityIn",{"nth":16,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["HighQualityOut",{"nth":17,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["LowQualityIn",{"nth":18,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["LowQualityOut",{"nth":19,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["QualityIn",{"nth":20,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["QualityOut",{"nth":21,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["StampEscrow",{"nth":22,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["BondAmount",{"nth":23,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["LoadFee",{"nth":24,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["OfferSequence",{"nth":25,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["FirstLedgerSequence",{"nth":26,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["LastLedgerSequence",{"nth":27,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["TransactionIndex",{"nth":28,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["OperationLimit",{"nth":29,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["ReferenceFeeUnits",{"nth":30,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["ReserveBase",{"nth":31,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["ReserveIncrement",{"nth":32,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["SetFlag",{"nth":33,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["ClearFlag",{"nth":34,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["SignerQuorum",{"nth":35,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["CancelAfter",{"nth":36,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["FinishAfter",{"nth":37,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["SignerListID",{"nth":38,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["SettleDelay",{"nth":39,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["TicketCount",{"nth":40,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["TicketSequence",{"nth":41,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["NFTokenTaxon",{"nth":42,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["MintedNFTokens",{"nth":43,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["BurnedNFTokens",{"nth":44,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["HookStateCount",{"nth":45,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["EmitGeneration",{"nth":46,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["VoteWeight",{"nth":48,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["FirstNFTokenSequence",{"nth":50,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["IndexNext",{"nth":1,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt64"}],["IndexPrevious",{"nth":2,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt64"}],["BookNode",{"nth":3,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt64"}],["OwnerNode",{"nth":4,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt64"}],["BaseFee",{"nth":5,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt64"}],["ExchangeRate",{"nth":6,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt64"}],["LowNode",{"nth":7,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt64"}],["HighNode",{"nth":8,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt64"}],["DestinationNode",{"nth":9,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt64"}],["Cookie",{"nth":10,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt64"}],["ServerVersion",{"nth":11,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt64"}],["NFTokenOfferNode",{"nth":12,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt64"}],["EmitBurden",{"nth":13,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt64"}],["HookOn",{"nth":16,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt64"}],["HookInstructionCount",{"nth":17,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt64"}],["HookReturnCode",{"nth":18,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt64"}],["ReferenceCount",{"nth":19,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt64"}],["XChainClaimID",{"nth":20,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt64"}],["XChainAccountCreateCount",{"nth":21,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt64"}],["XChainAccountClaimCount",{"nth":22,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt64"}],["EmailHash",{"nth":1,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Hash128"}],["TakerPaysCurrency",{"nth":1,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Hash160"}],["TakerPaysIssuer",{"nth":2,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Hash160"}],["TakerGetsCurrency",{"nth":3,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Hash160"}],["TakerGetsIssuer",{"nth":4,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Hash160"}],["LedgerHash",{"nth":1,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Hash256"}],["ParentHash",{"nth":2,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Hash256"}],["TransactionHash",{"nth":3,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Hash256"}],["AccountHash",{"nth":4,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Hash256"}],["PreviousTxnID",{"nth":5,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Hash256"}],["LedgerIndex",{"nth":6,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Hash256"}],["WalletLocator",{"nth":7,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Hash256"}],["RootIndex",{"nth":8,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Hash256"}],["AccountTxnID",{"nth":9,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Hash256"}],["NFTokenID",{"nth":10,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Hash256"}],["EmitParentTxnID",{"nth":11,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Hash256"}],["EmitNonce",{"nth":12,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Hash256"}],["EmitHookHash",{"nth":13,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Hash256"}],["AMMID",{"nth":14,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Hash256"}],["BookDirectory",{"nth":16,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Hash256"}],["InvoiceID",{"nth":17,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Hash256"}],["Nickname",{"nth":18,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Hash256"}],["Amendment",{"nth":19,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Hash256"}],["Digest",{"nth":21,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Hash256"}],["Channel",{"nth":22,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Hash256"}],["ConsensusHash",{"nth":23,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Hash256"}],["CheckID",{"nth":24,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Hash256"}],["ValidatedHash",{"nth":25,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Hash256"}],["PreviousPageMin",{"nth":26,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Hash256"}],["NextPageMin",{"nth":27,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Hash256"}],["NFTokenBuyOffer",{"nth":28,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Hash256"}],["NFTokenSellOffer",{"nth":29,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Hash256"}],["HookStateKey",{"nth":30,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Hash256"}],["HookHash",{"nth":31,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Hash256"}],["HookNamespace",{"nth":32,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Hash256"}],["HookSetTxnID",{"nth":33,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Hash256"}],["Amount",{"nth":1,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Amount"}],["Balance",{"nth":2,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Amount"}],["LimitAmount",{"nth":3,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Amount"}],["TakerPays",{"nth":4,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Amount"}],["TakerGets",{"nth":5,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Amount"}],["LowLimit",{"nth":6,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Amount"}],["HighLimit",{"nth":7,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Amount"}],["Fee",{"nth":8,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Amount"}],["SendMax",{"nth":9,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Amount"}],["DeliverMin",{"nth":10,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Amount"}],["Amount2",{"nth":11,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Amount"}],["BidMin",{"nth":12,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Amount"}],["BidMax",{"nth":13,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Amount"}],["MinimumOffer",{"nth":16,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Amount"}],["RippleEscrow",{"nth":17,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Amount"}],["DeliveredAmount",{"nth":18,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Amount"}],["NFTokenBrokerFee",{"nth":19,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Amount"}],["BaseFeeDrops",{"nth":22,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Amount"}],["ReserveBaseDrops",{"nth":23,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Amount"}],["ReserveIncrementDrops",{"nth":24,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Amount"}],["LPTokenOut",{"nth":25,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Amount"}],["LPTokenIn",{"nth":26,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Amount"}],["EPrice",{"nth":27,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Amount"}],["Price",{"nth":28,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Amount"}],["SignatureReward",{"nth":29,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Amount"}],["MinAccountCreateAmount",{"nth":30,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Amount"}],["LPTokenBalance",{"nth":31,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Amount"}],["PublicKey",{"nth":1,"isVLEncoded":true,"isSerialized":true,"isSigningField":true,"type":"Blob"}],["MessageKey",{"nth":2,"isVLEncoded":true,"isSerialized":true,"isSigningField":true,"type":"Blob"}],["SigningPubKey",{"nth":3,"isVLEncoded":true,"isSerialized":true,"isSigningField":true,"type":"Blob"}],["TxnSignature",{"nth":4,"isVLEncoded":true,"isSerialized":true,"isSigningField":false,"type":"Blob"}],["URI",{"nth":5,"isVLEncoded":true,"isSerialized":true,"isSigningField":true,"type":"Blob"}],["Signature",{"nth":6,"isVLEncoded":true,"isSerialized":true,"isSigningField":false,"type":"Blob"}],["Domain",{"nth":7,"isVLEncoded":true,"isSerialized":true,"isSigningField":true,"type":"Blob"}],["FundCode",{"nth":8,"isVLEncoded":true,"isSerialized":true,"isSigningField":true,"type":"Blob"}],["RemoveCode",{"nth":9,"isVLEncoded":true,"isSerialized":true,"isSigningField":true,"type":"Blob"}],["ExpireCode",{"nth":10,"isVLEncoded":true,"isSerialized":true,"isSigningField":true,"type":"Blob"}],["CreateCode",{"nth":11,"isVLEncoded":true,"isSerialized":true,"isSigningField":true,"type":"Blob"}],["MemoType",{"nth":12,"isVLEncoded":true,"isSerialized":true,"isSigningField":true,"type":"Blob"}],["MemoData",{"nth":13,"isVLEncoded":true,"isSerialized":true,"isSigningField":true,"type":"Blob"}],["MemoFormat",{"nth":14,"isVLEncoded":true,"isSerialized":true,"isSigningField":true,"type":"Blob"}],["Fulfillment",{"nth":16,"isVLEncoded":true,"isSerialized":true,"isSigningField":true,"type":"Blob"}],["Condition",{"nth":17,"isVLEncoded":true,"isSerialized":true,"isSigningField":true,"type":"Blob"}],["MasterSignature",{"nth":18,"isVLEncoded":true,"isSerialized":true,"isSigningField":false,"type":"Blob"}],["UNLModifyValidator",{"nth":19,"isVLEncoded":true,"isSerialized":true,"isSigningField":true,"type":"Blob"}],["ValidatorToDisable",{"nth":20,"isVLEncoded":true,"isSerialized":true,"isSigningField":true,"type":"Blob"}],["ValidatorToReEnable",{"nth":21,"isVLEncoded":true,"isSerialized":true,"isSigningField":true,"type":"Blob"}],["HookStateData",{"nth":22,"isVLEncoded":true,"isSerialized":true,"isSigningField":true,"type":"Blob"}],["HookReturnString",{"nth":23,"isVLEncoded":true,"isSerialized":true,"isSigningField":true,"type":"Blob"}],["HookParameterName",{"nth":24,"isVLEncoded":true,"isSerialized":true,"isSigningField":true,"type":"Blob"}],["HookParameterValue",{"nth":25,"isVLEncoded":true,"isSerialized":true,"isSigningField":true,"type":"Blob"}],["DIDDocument",{"nth":26,"isVLEncoded":true,"isSerialized":true,"isSigningField":true,"type":"Blob"}],["Data",{"nth":27,"isVLEncoded":true,"isSerialized":true,"isSigningField":true,"type":"Blob"}],["Account",{"nth":1,"isVLEncoded":true,"isSerialized":true,"isSigningField":true,"type":"AccountID"}],["Owner",{"nth":2,"isVLEncoded":true,"isSerialized":true,"isSigningField":true,"type":"AccountID"}],["Destination",{"nth":3,"isVLEncoded":true,"isSerialized":true,"isSigningField":true,"type":"AccountID"}],["Issuer",{"nth":4,"isVLEncoded":true,"isSerialized":true,"isSigningField":true,"type":"AccountID"}],["Authorize",{"nth":5,"isVLEncoded":true,"isSerialized":true,"isSigningField":true,"type":"AccountID"}],["Unauthorize",{"nth":6,"isVLEncoded":true,"isSerialized":true,"isSigningField":true,"type":"AccountID"}],["RegularKey",{"nth":8,"isVLEncoded":true,"isSerialized":true,"isSigningField":true,"type":"AccountID"}],["NFTokenMinter",{"nth":9,"isVLEncoded":true,"isSerialized":true,"isSigningField":true,"type":"AccountID"}],["EmitCallback",{"nth":10,"isVLEncoded":true,"isSerialized":true,"isSigningField":true,"type":"AccountID"}],["HookAccount",{"nth":16,"isVLEncoded":true,"isSerialized":true,"isSigningField":true,"type":"AccountID"}],["OtherChainSource",{"nth":18,"isVLEncoded":true,"isSerialized":true,"isSigningField":true,"type":"AccountID"}],["OtherChainDestination",{"nth":19,"isVLEncoded":true,"isSerialized":true,"isSigningField":true,"type":"AccountID"}],["AttestationSignerAccount",{"nth":20,"isVLEncoded":true,"isSerialized":true,"isSigningField":true,"type":"AccountID"}],["AttestationRewardAccount",{"nth":21,"isVLEncoded":true,"isSerialized":true,"isSigningField":true,"type":"AccountID"}],["LockingChainDoor",{"nth":22,"isVLEncoded":true,"isSerialized":true,"isSigningField":true,"type":"AccountID"}],["IssuingChainDoor",{"nth":23,"isVLEncoded":true,"isSerialized":true,"isSigningField":true,"type":"AccountID"}],["Indexes",{"nth":1,"isVLEncoded":true,"isSerialized":true,"isSigningField":true,"type":"Vector256"}],["Hashes",{"nth":2,"isVLEncoded":true,"isSerialized":true,"isSigningField":true,"type":"Vector256"}],["Amendments",{"nth":3,"isVLEncoded":true,"isSerialized":true,"isSigningField":true,"type":"Vector256"}],["NFTokenOffers",{"nth":4,"isVLEncoded":true,"isSerialized":true,"isSigningField":true,"type":"Vector256"}],["Paths",{"nth":1,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"PathSet"}],["LockingChainIssue",{"nth":1,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Issue"}],["IssuingChainIssue",{"nth":2,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Issue"}],["Asset",{"nth":3,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Issue"}],["Asset2",{"nth":4,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Issue"}],["XChainBridge",{"nth":1,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"XChainBridge"}],["TransactionMetaData",{"nth":2,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STObject"}],["CreatedNode",{"nth":3,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STObject"}],["DeletedNode",{"nth":4,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STObject"}],["ModifiedNode",{"nth":5,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STObject"}],["PreviousFields",{"nth":6,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STObject"}],["FinalFields",{"nth":7,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STObject"}],["NewFields",{"nth":8,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STObject"}],["TemplateEntry",{"nth":9,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STObject"}],["Memo",{"nth":10,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STObject"}],["SignerEntry",{"nth":11,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STObject"}],["NFToken",{"nth":12,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STObject"}],["EmitDetails",{"nth":13,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STObject"}],["Hook",{"nth":14,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STObject"}],["Signer",{"nth":16,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STObject"}],["Majority",{"nth":18,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STObject"}],["DisabledValidator",{"nth":19,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STObject"}],["EmittedTxn",{"nth":20,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STObject"}],["HookExecution",{"nth":21,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STObject"}],["HookDefinition",{"nth":22,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STObject"}],["HookParameter",{"nth":23,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STObject"}],["HookGrant",{"nth":24,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STObject"}],["VoteEntry",{"nth":25,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STObject"}],["AuctionSlot",{"nth":26,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STObject"}],["AuthAccount",{"nth":27,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STObject"}],["XChainClaimProofSig",{"nth":28,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STObject"}],["XChainCreateAccountProofSig",{"nth":29,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STObject"}],["XChainClaimAttestationCollectionElement",{"nth":30,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STObject"}],["XChainCreateAccountAttestationCollectionElement",{"nth":31,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STObject"}],["Signers",{"nth":3,"isVLEncoded":false,"isSerialized":true,"isSigningField":false,"type":"STArray"}],["SignerEntries",{"nth":4,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STArray"}],["Template",{"nth":5,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STArray"}],["Necessary",{"nth":6,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STArray"}],["Sufficient",{"nth":7,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STArray"}],["AffectedNodes",{"nth":8,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STArray"}],["Memos",{"nth":9,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STArray"}],["NFTokens",{"nth":10,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STArray"}],["Hooks",{"nth":11,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STArray"}],["VoteSlots",{"nth":12,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STArray"}],["Majorities",{"nth":16,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STArray"}],["DisabledValidators",{"nth":17,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STArray"}],["HookExecutions",{"nth":18,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STArray"}],["HookParameters",{"nth":19,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STArray"}],["HookGrants",{"nth":20,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STArray"}],["XChainClaimAttestations",{"nth":21,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STArray"}],["XChainCreateAccountAttestations",{"nth":22,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STArray"}],["AuthAccounts",{"nth":25,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STArray"}]]'), TRANSACTION_RESULTS = { telLOCAL_ERROR: -399, telBAD_DOMAIN: -398, telBAD_PATH_COUNT: -397, telBAD_PUBLIC_KEY: -396, telFAILED_PROCESSING: -395, telINSUF_FEE_P: -394, telNO_DST_PARTIAL: -393, telCAN_NOT_QUEUE: -392, telCAN_NOT_QUEUE_BALANCE: -391, telCAN_NOT_QUEUE_BLOCKS: -390, telCAN_NOT_QUEUE_BLOCKED: -389, telCAN_NOT_QUEUE_FEE: -388, telCAN_NOT_QUEUE_FULL: -387, telWRONG_NETWORK: -386, telREQUIRES_NETWORK_ID: -385, telNETWORK_ID_MAKES_TX_NON_CANONICAL: -384, temMALFORMED: -299, temBAD_AMOUNT: -298, temBAD_CURRENCY: -297, temBAD_EXPIRATION: -296, temBAD_FEE: -295, temBAD_ISSUER: -294, temBAD_LIMIT: -293, temBAD_OFFER: -292, temBAD_PATH: -291, temBAD_PATH_LOOP: -290, temBAD_REGKEY: -289, temBAD_SEND_XRP_LIMIT: -288, temBAD_SEND_XRP_MAX: -287, temBAD_SEND_XRP_NO_DIRECT: -286, temBAD_SEND_XRP_PARTIAL: -285, temBAD_SEND_XRP_PATHS: -284, temBAD_SEQUENCE: -283, temBAD_SIGNATURE: -282, temBAD_SRC_ACCOUNT: -281, temBAD_TRANSFER_RATE: -280, temDST_IS_SRC: -279, temDST_NEEDED: -278, temINVALID: -277, temINVALID_FLAG: -276, temREDUNDANT: -275, temRIPPLE_EMPTY: -274, temDISABLED: -273, temBAD_SIGNER: -272, temBAD_QUORUM: -271, temBAD_WEIGHT: -270, temBAD_TICK_SIZE: -269, temINVALID_ACCOUNT_ID: -268, temCANNOT_PREAUTH_SELF: -267, temINVALID_COUNT: -266, temUNCERTAIN: -265, temUNKNOWN: -264, temSEQ_AND_TICKET: -263, temBAD_NFTOKEN_TRANSFER_FEE: -262, temBAD_AMM_TOKENS: -261, temXCHAIN_EQUAL_DOOR_ACCOUNTS: -260, temXCHAIN_BAD_PROOF: -259, temXCHAIN_BRIDGE_BAD_ISSUES: -258, temXCHAIN_BRIDGE_NONDOOR_OWNER: -257, temXCHAIN_BRIDGE_BAD_MIN_ACCOUNT_CREATE_AMOUNT: -256, temXCHAIN_BRIDGE_BAD_REWARD_AMOUNT: -255, temEMPTY_DID: -254, tefFAILURE: -199, tefALREADY: -198, tefBAD_ADD_AUTH: -197, tefBAD_AUTH: -196, tefBAD_LEDGER: -195, tefCREATED: -194, tefEXCEPTION: -193, tefINTERNAL: -192, tefNO_AUTH_REQUIRED: -191, tefPAST_SEQ: -190, tefWRONG_PRIOR: -189, tefMASTER_DISABLED: -188, tefMAX_LEDGER: -187, tefBAD_SIGNATURE: -186, tefBAD_QUORUM: -185, tefNOT_MULTI_SIGNING: -184, tefBAD_AUTH_MASTER: -183, tefINVARIANT_FAILED: -182, tefTOO_BIG: -181, tefNO_TICKET: -180, tefNFTOKEN_IS_NOT_TRANSFERABLE: -179, terRETRY: -99, terFUNDS_SPENT: -98, terINSUF_FEE_B: -97, terNO_ACCOUNT: -96, terNO_AUTH: -95, terNO_LINE: -94, terOWNERS: -93, terPRE_SEQ: -92, terLAST: -91, terNO_RIPPLE: -90, terQUEUED: -89, terPRE_TICKET: -88, terNO_AMM: -87, terSUBMITTED: -86, tesSUCCESS: 0, tecCLAIM: 100, tecPATH_PARTIAL: 101, tecUNFUNDED_ADD: 102, tecUNFUNDED_OFFER: 103, tecUNFUNDED_PAYMENT: 104, tecFAILED_PROCESSING: 105, tecDIR_FULL: 121, tecINSUF_RESERVE_LINE: 122, tecINSUF_RESERVE_OFFER: 123, tecNO_DST: 124, tecNO_DST_INSUF_XRP: 125, tecNO_LINE_INSUF_RESERVE: 126, tecNO_LINE_REDUNDANT: 127, tecPATH_DRY: 128, tecUNFUNDED: 129, tecNO_ALTERNATIVE_KEY: 130, tecNO_REGULAR_KEY: 131, tecOWNERS: 132, tecNO_ISSUER: 133, tecNO_AUTH: 134, tecNO_LINE: 135, tecINSUFF_FEE: 136, tecFROZEN: 137, tecNO_TARGET: 138, tecNO_PERMISSION: 139, tecNO_ENTRY: 140, tecINSUFFICIENT_RESERVE: 141, tecNEED_MASTER_KEY: 142, tecDST_TAG_NEEDED: 143, tecINTERNAL: 144, tecOVERSIZE: 145, tecCRYPTOCONDITION_ERROR: 146, tecINVARIANT_FAILED: 147, tecEXPIRED: 148, tecDUPLICATE: 149, tecKILLED: 150, tecHAS_OBLIGATIONS: 151, tecTOO_SOON: 152, tecHOOK_REJECTED: 153, tecMAX_SEQUENCE_REACHED: 154, tecNO_SUITABLE_NFTOKEN_PAGE: 155, tecNFTOKEN_BUY_SELL_MISMATCH: 156, tecNFTOKEN_OFFER_TYPE_MISMATCH: 157, tecCANT_ACCEPT_OWN_NFTOKEN_OFFER: 158, tecINSUFFICIENT_FUNDS: 159, tecOBJECT_NOT_FOUND: 160, tecINSUFFICIENT_PAYMENT: 161, tecUNFUNDED_AMM: 162, tecAMM_BALANCE: 163, tecAMM_FAILED: 164, tecAMM_INVALID_TOKENS: 165, tecAMM_EMPTY: 166, tecAMM_NOT_EMPTY: 167, tecAMM_ACCOUNT: 168, tecINCOMPLETE: 169, tecXCHAIN_BAD_TRANSFER_ISSUE: 170, tecXCHAIN_NO_CLAIM_ID: 171, tecXCHAIN_BAD_CLAIM_ID: 172, tecXCHAIN_CLAIM_NO_QUORUM: 173, tecXCHAIN_PROOF_UNKNOWN_KEY: 174, tecXCHAIN_CREATE_ACCOUNT_NONXRP_ISSUE: 175, tecXCHAIN_WRONG_CHAIN: 176, tecXCHAIN_REWARD_MISMATCH: 177, tecXCHAIN_NO_SIGNERS_LIST: 178, tecXCHAIN_SENDING_ACCOUNT_MISMATCH: 179, tecXCHAIN_INSUFF_CREATE_AMOUNT: 180, tecXCHAIN_ACCOUNT_CREATE_PAST: 181, tecXCHAIN_ACCOUNT_CREATE_TOO_MANY: 182, tecXCHAIN_PAYMENT_FAILED: 183, tecXCHAIN_SELF_COMMIT: 184, tecXCHAIN_BAD_PUBLIC_KEY_ACCOUNT_PAIR: 185, tecXCHAIN_CREATE_ACCOUNT_DISABLED: 186, tecEMPTY_DID: 187 }, TRANSACTION_TYPES = { Invalid: -1, Payment: 0, EscrowCreate: 1, EscrowFinish: 2, AccountSet: 3, EscrowCancel: 4, SetRegularKey: 5, NickNameSet: 6, OfferCreate: 7, OfferCancel: 8, Contract: 9, TicketCreate: 10, TicketCancel: 11, SignerListSet: 12, PaymentChannelCreate: 13, PaymentChannelFund: 14, PaymentChannelClaim: 15, CheckCreate: 16, CheckCash: 17, CheckCancel: 18, DepositPreauth: 19, TrustSet: 20, AccountDelete: 21, SetHook: 22, NFTokenMint: 25, NFTokenBurn: 26, NFTokenCreateOffer: 27, NFTokenCancelOffer: 28, NFTokenAcceptOffer: 29, Clawback: 30, AMMCreate: 35, AMMDeposit: 36, AMMWithdraw: 37, AMMVote: 38, AMMBid: 39, AMMDelete: 40, XChainCreateClaimID: 41, XChainCommit: 42, XChainClaim: 43, XChainAccountCreateCommit: 44, XChainAddClaimAttestation: 45, XChainAddAccountCreateAttestation: 46, XChainModifyBridge: 47, XChainCreateBridge: 48, DIDSet: 49, DIDDelete: 50, EnableAmendment: 100, SetFee: 101, UNLModify: 102 }, require$$0 = {
  TYPES,
  LEDGER_ENTRY_TYPES,
  FIELDS,
  TRANSACTION_RESULTS,
  TRANSACTION_TYPES
};
var xrplDefinitionsBase = {}, bytes$1 = {}, hasRequiredBytes;
function requireBytes() {
  if (hasRequiredBytes) return bytes$1;
  hasRequiredBytes = 1, Object.defineProperty(bytes$1, "__esModule", { value: !0 }), bytes$1.BytesLookup = bytes$1.Bytes = void 0;
  const o = requireBuffer$2();
  class g {
    constructor(t, d, E) {
      this.name = t, this.ordinal = d, this.ordinalWidth = E, this.bytes = o.Buffer.alloc(E);
      for (let B = 0; B < E; B++)
        this.bytes[E - B - 1] = d >>> B * 8 & 255;
    }
    toJSON() {
      return this.name;
    }
    toBytesSink(t) {
      t.put(this.bytes);
    }
    toBytes() {
      return this.bytes;
    }
  }
  bytes$1.Bytes = g;
  class c {
    constructor(t, d) {
      this.ordinalWidth = d, Object.entries(t).forEach(([E, B]) => {
        this.add(E, B);
      });
    }
    /**
     * Add a new name value pair to the BytesLookup.
     *
     * @param name - A human readable name for the field.
     * @param value - The numeric value for the field.
     * @throws if the name or value already exist in the lookup because it's unclear how to decode.
     */
    add(t, d) {
      if (this[t])
        throw new SyntaxError(`Attempted to add a value with a duplicate name "${t}". This is not allowed because it is unclear how to decode.`);
      if (this[d.toString()])
        throw new SyntaxError(`Attempted to add a duplicate value under a different name (Given name: "${t}" and previous name: "${this[d.toString()]}. This is not allowed because it is unclear how to decode.
Given value: ${d.toString()}`);
      this[t] = new g(t, d, this.ordinalWidth), this[d.toString()] = this[t];
    }
    from(t) {
      return t instanceof g ? t : this[t];
    }
    fromParser(t) {
      return this.from(t.readUIntN(this.ordinalWidth).toString());
    }
  }
  return bytes$1.BytesLookup = c, bytes$1;
}
var field = {}, serializedType = {}, binarySerializer = {}, hasRequiredBinarySerializer;
function requireBinarySerializer() {
  if (hasRequiredBinarySerializer) return binarySerializer;
  hasRequiredBinarySerializer = 1;
  var o = binarySerializer && binarySerializer.__createBinding || (Object.create ? function(B, D, x, v) {
    v === void 0 && (v = x);
    var F = Object.getOwnPropertyDescriptor(D, x);
    (!F || ("get" in F ? !D.__esModule : F.writable || F.configurable)) && (F = { enumerable: !0, get: function() {
      return D[x];
    } }), Object.defineProperty(B, v, F);
  } : function(B, D, x, v) {
    v === void 0 && (v = x), B[v] = D[x];
  }), g = binarySerializer && binarySerializer.__setModuleDefault || (Object.create ? function(B, D) {
    Object.defineProperty(B, "default", { enumerable: !0, value: D });
  } : function(B, D) {
    B.default = D;
  }), c = binarySerializer && binarySerializer.__importStar || function(B) {
    if (B && B.__esModule) return B;
    var D = {};
    if (B != null) for (var x in B) x !== "default" && Object.prototype.hasOwnProperty.call(B, x) && o(D, B, x);
    return g(D, B), D;
  };
  Object.defineProperty(binarySerializer, "__esModule", { value: !0 }), binarySerializer.BinarySerializer = binarySerializer.BytesList = void 0;
  const y = c(requireAssert$2()), t = requireBuffer$2();
  class d {
    constructor() {
      this.bytesArray = [];
    }
    /**
     * Get the total number of bytes in the BytesList
     *
     * @return the number of bytes
     */
    getLength() {
      return t.Buffer.concat(this.bytesArray).byteLength;
    }
    /**
     * Put bytes in the BytesList
     *
     * @param bytesArg A Buffer
     * @return this BytesList
     */
    put(D) {
      const x = t.Buffer.from(D);
      return this.bytesArray.push(x), this;
    }
    /**
     * Write this BytesList to the back of another bytes list
     *
     *  @param list The BytesList to write to
     */
    toBytesSink(D) {
      D.put(this.toBytes());
    }
    toBytes() {
      return t.Buffer.concat(this.bytesArray);
    }
    toHex() {
      return this.toBytes().toString("hex").toUpperCase();
    }
  }
  binarySerializer.BytesList = d;
  class E {
    constructor(D) {
      this.sink = new d(), this.sink = D;
    }
    /**
     * Write a value to this BinarySerializer
     *
     * @param value a SerializedType value
     */
    write(D) {
      D.toBytesSink(this.sink);
    }
    /**
     * Write bytes to this BinarySerializer
     *
     * @param bytes the bytes to write
     */
    put(D) {
      this.sink.put(D);
    }
    /**
     * Write a value of a given type to this BinarySerializer
     *
     * @param type the type to write
     * @param value a value of that type
     */
    writeType(D, x) {
      this.write(D.from(x));
    }
    /**
     * Write BytesList to this BinarySerializer
     *
     * @param bl BytesList to write to BinarySerializer
     */
    writeBytesList(D) {
      D.toBytesSink(this.sink);
    }
    /**
     * Calculate the header of Variable Length encoded bytes
     *
     * @param length the length of the bytes
     */
    encodeVariableLength(D) {
      const x = t.Buffer.alloc(3);
      if (D <= 192)
        return x[0] = D, x.slice(0, 1);
      if (D <= 12480)
        return D -= 193, x[0] = 193 + (D >>> 8), x[1] = D & 255, x.slice(0, 2);
      if (D <= 918744)
        return D -= 12481, x[0] = 241 + (D >>> 16), x[1] = D >> 8 & 255, x[2] = D & 255, x.slice(0, 3);
      throw new Error("Overflow error");
    }
    /**
     * Write field and value to BinarySerializer
     *
     * @param field field to write to BinarySerializer
     * @param value value to write to BinarySerializer
     */
    writeFieldAndValue(D, x, v = !1) {
      const F = D.associatedType.from(x);
      y.ok(F.toBytesSink !== void 0), y.ok(D.name !== void 0), this.sink.put(D.header), D.isVariableLengthEncoded ? this.writeLengthEncoded(F, v) : F.toBytesSink(this.sink);
    }
    /**
     * Write a variable length encoded value to the BinarySerializer
     *
     * @param value length encoded value to write to BytesList
     */
    writeLengthEncoded(D, x = !1) {
      const v = new d();
      x || D.toBytesSink(v), this.put(this.encodeVariableLength(v.getLength())), this.writeBytesList(v);
    }
  }
  return binarySerializer.BinarySerializer = E, binarySerializer;
}
var hasRequiredSerializedType;
function requireSerializedType() {
  if (hasRequiredSerializedType) return serializedType;
  hasRequiredSerializedType = 1, Object.defineProperty(serializedType, "__esModule", { value: !0 }), serializedType.Comparable = serializedType.SerializedType = void 0;
  const o = requireBinarySerializer(), g = requireBuffer$2();
  class c {
    constructor(d) {
      this.bytes = g.Buffer.alloc(0), this.bytes = d ?? g.Buffer.alloc(0);
    }
    static fromParser(d, E) {
      throw new Error("fromParser not implemented");
    }
    static from(d) {
      throw new Error("from not implemented");
    }
    /**
     * Write the bytes representation of a SerializedType to a BytesList
     *
     * @param list The BytesList to write SerializedType bytes to
     */
    toBytesSink(d) {
      d.put(this.bytes);
    }
    /**
     * Get the hex representation of a SerializedType's bytes
     *
     * @returns hex String of this.bytes
     */
    toHex() {
      return this.toBytes().toString("hex").toUpperCase();
    }
    /**
     * Get the bytes representation of a SerializedType
     *
     * @returns A buffer of the bytes
     */
    toBytes() {
      if (this.bytes)
        return this.bytes;
      const d = new o.BytesList();
      return this.toBytesSink(d), d.toBytes();
    }
    /**
     * Return the JSON representation of a SerializedType
     *
     * @param _definitions rippled definitions used to parse the values of transaction types and such.
     *                          Unused in default, but used in STObject, STArray
     *                          Can be customized for sidechains and amendments.
     * @returns any type, if not overloaded returns hexString representation of bytes
     */
    toJSON(d) {
      return this.toHex();
    }
    /**
     * @returns hexString representation of this.bytes
     */
    toString() {
      return this.toHex();
    }
  }
  serializedType.SerializedType = c;
  class y extends c {
    lt(d) {
      return this.compareTo(d) < 0;
    }
    eq(d) {
      return this.compareTo(d) === 0;
    }
    gt(d) {
      return this.compareTo(d) > 0;
    }
    gte(d) {
      return this.compareTo(d) > -1;
    }
    lte(d) {
      return this.compareTo(d) < 1;
    }
    /**
     * Overload this method to define how two Comparable SerializedTypes are compared
     *
     * @param other The comparable object to compare this to
     * @returns A number denoting the relationship of this and other
     */
    compareTo(d) {
      throw new Error(`cannot compare ${this.toString()} and ${d.toString()}`);
    }
  }
  return serializedType.Comparable = y, serializedType;
}
var constants$2 = {}, hasRequiredConstants$2;
function requireConstants$2() {
  return hasRequiredConstants$2 || (hasRequiredConstants$2 = 1, Object.defineProperty(constants$2, "__esModule", { value: !0 }), constants$2.TRANSACTION_RESULT_WIDTH = constants$2.TRANSACTION_TYPE_WIDTH = constants$2.LEDGER_ENTRY_WIDTH = constants$2.TYPE_WIDTH = void 0, constants$2.TYPE_WIDTH = 2, constants$2.LEDGER_ENTRY_WIDTH = 2, constants$2.TRANSACTION_TYPE_WIDTH = 2, constants$2.TRANSACTION_RESULT_WIDTH = 1), constants$2;
}
var hasRequiredField;
function requireField() {
  if (hasRequiredField) return field;
  hasRequiredField = 1, Object.defineProperty(field, "__esModule", { value: !0 }), field.FieldLookup = void 0;
  const o = requireBytes(), g = requireSerializedType(), c = requireConstants$2(), y = requireBuffer$2();
  function t(B, D) {
    const x = [];
    return B < 16 ? D < 16 ? x.push(B << 4 | D) : x.push(B << 4, D) : D < 16 ? x.push(D, B) : x.push(0, B, D), y.Buffer.from(x);
  }
  function d([B, D], x) {
    const v = t(x, D.nth);
    return {
      name: B,
      nth: D.nth,
      isVariableLengthEncoded: D.isVLEncoded,
      isSerialized: D.isSerialized,
      isSigningField: D.isSigningField,
      ordinal: x << 16 | D.nth,
      type: new o.Bytes(D.type, x, c.TYPE_WIDTH),
      header: v,
      associatedType: g.SerializedType
      // For later assignment in ./types/index.js or Definitions.updateAll(...)
    };
  }
  class E {
    constructor(D, x) {
      D.forEach(([v, F]) => {
        const M = x[F.type];
        this[v] = d([v, F], M), this[this[v].ordinal.toString()] = this[v];
      });
    }
    fromString(D) {
      return this[D];
    }
  }
  return field.FieldLookup = E, field;
}
var hasRequiredXrplDefinitionsBase;
function requireXrplDefinitionsBase() {
  return hasRequiredXrplDefinitionsBase || (hasRequiredXrplDefinitionsBase = 1, function(o) {
    Object.defineProperty(o, "__esModule", { value: !0 }), o.BytesLookup = o.Bytes = o.FieldLookup = o.XrplDefinitionsBase = void 0;
    const g = requireBytes();
    Object.defineProperty(o, "Bytes", { enumerable: !0, get: function() {
      return g.Bytes;
    } }), Object.defineProperty(o, "BytesLookup", { enumerable: !0, get: function() {
      return g.BytesLookup;
    } });
    const c = requireField();
    Object.defineProperty(o, "FieldLookup", { enumerable: !0, get: function() {
      return c.FieldLookup;
    } });
    const y = requireConstants$2();
    class t {
      /**
       * Present rippled types in a typed and updatable format.
       * For an example of the input format see `definitions.json`
       * To generate a new definitions file from rippled source code, use this tool: https://github.com/RichardAH/xrpl-codec-gen
       *
       * See the definitions.test.js file for examples of how to create your own updated definitions.json.
       *
       * @param enums - A json encoding of the core types, transaction types, transaction results, transaction names, and fields.
       * @param types - A list of type objects with the same name as the fields defined.
       *              You can use the coreTypes object if you are not adding new types.
       */
      constructor(E, B) {
        this.type = new g.BytesLookup(E.TYPES, y.TYPE_WIDTH), this.ledgerEntryType = new g.BytesLookup(E.LEDGER_ENTRY_TYPES, y.LEDGER_ENTRY_WIDTH), this.transactionType = new g.BytesLookup(E.TRANSACTION_TYPES, y.TRANSACTION_TYPE_WIDTH), this.transactionResult = new g.BytesLookup(E.TRANSACTION_RESULTS, y.TRANSACTION_RESULT_WIDTH), this.field = new c.FieldLookup(E.FIELDS, E.TYPES), this.transactionNames = Object.entries(E.TRANSACTION_TYPES).filter(([D, x]) => x >= 0).map(([D, x]) => D), this.dataTypes = {}, this.associateTypes(B);
      }
      /**
       * Associates each Field to a corresponding class that TypeScript can recognize.
       *
       * @param types a list of type objects with the same name as the fields defined.
       *              Defaults to xrpl.js's core type definitions.
       */
      associateTypes(E) {
        this.dataTypes = Object.assign({}, this.dataTypes, E), Object.values(this.field).forEach((B) => {
          B.associatedType = this.dataTypes[B.type.name];
        }), this.field.TransactionType.associatedType = this.transactionType, this.field.TransactionResult.associatedType = this.transactionResult, this.field.LedgerEntryType.associatedType = this.ledgerEntryType;
      }
      getAssociatedTypes() {
        return this.dataTypes;
      }
    }
    o.XrplDefinitionsBase = t;
  }(xrplDefinitionsBase)), xrplDefinitionsBase;
}
var hasRequiredEnums;
function requireEnums() {
  return hasRequiredEnums || (hasRequiredEnums = 1, function(o) {
    var g = enums && enums.__createBinding || (Object.create ? function(U, L, H, fe) {
      fe === void 0 && (fe = H);
      var ge = Object.getOwnPropertyDescriptor(L, H);
      (!ge || ("get" in ge ? !L.__esModule : ge.writable || ge.configurable)) && (ge = { enumerable: !0, get: function() {
        return L[H];
      } }), Object.defineProperty(U, fe, ge);
    } : function(U, L, H, fe) {
      fe === void 0 && (fe = H), U[fe] = L[H];
    }), c = enums && enums.__setModuleDefault || (Object.create ? function(U, L) {
      Object.defineProperty(U, "default", { enumerable: !0, value: L });
    } : function(U, L) {
      U.default = L;
    }), y = enums && enums.__importStar || function(U) {
      if (U && U.__esModule) return U;
      var L = {};
      if (U != null) for (var H in U) H !== "default" && Object.prototype.hasOwnProperty.call(U, H) && g(L, U, H);
      return c(L, U), L;
    };
    Object.defineProperty(o, "__esModule", { value: !0 }), o.TRANSACTION_TYPES = o.TransactionType = o.TransactionResult = o.LedgerEntryType = o.Type = o.Field = o.DEFAULT_DEFINITIONS = o.XrplDefinitionsBase = o.Bytes = void 0;
    const t = y(require$$0), d = requireXrplDefinitionsBase();
    Object.defineProperty(o, "XrplDefinitionsBase", { enumerable: !0, get: function() {
      return d.XrplDefinitionsBase;
    } }), Object.defineProperty(o, "Bytes", { enumerable: !0, get: function() {
      return d.Bytes;
    } });
    const E = new d.XrplDefinitionsBase(t, {});
    o.DEFAULT_DEFINITIONS = E;
    const B = E.type;
    o.Type = B;
    const D = E.ledgerEntryType;
    o.LedgerEntryType = D;
    const x = E.transactionType;
    o.TransactionType = x;
    const v = E.transactionResult;
    o.TransactionResult = v;
    const F = E.field;
    o.Field = F;
    const M = E.transactionNames;
    o.TRANSACTION_TYPES = M;
  }(enums)), enums;
}
var types$4 = {}, accountId = {}, dist$3 = {}, xrpCodec = {}, utils$5 = {}, hasRequiredUtils$4;
function requireUtils$4() {
  if (hasRequiredUtils$4) return utils$5;
  hasRequiredUtils$4 = 1, Object.defineProperty(utils$5, "__esModule", { value: !0 }), utils$5.concatArgs = utils$5.seqEqual = void 0;
  function o(y, t) {
    if (y.length !== t.length)
      return !1;
    for (let d = 0; d < y.length; d++)
      if (y[d] !== t[d])
        return !1;
    return !0;
  }
  utils$5.seqEqual = o;
  function g(y) {
    return typeof y != "number";
  }
  function c(...y) {
    const t = [];
    return y.forEach((d) => {
      if (g(d))
        for (const E of d)
          t.push(E);
      else
        t.push(d);
    }), t;
  }
  return utils$5.concatArgs = c, utils$5;
}
var hasRequiredXrpCodec;
function requireXrpCodec() {
  if (hasRequiredXrpCodec) return xrpCodec;
  hasRequiredXrpCodec = 1, Object.defineProperty(xrpCodec, "__esModule", { value: !0 }), xrpCodec.isValidClassicAddress = xrpCodec.decodeAccountPublic = xrpCodec.encodeAccountPublic = xrpCodec.encodeNodePublic = xrpCodec.decodeNodePublic = xrpCodec.decodeAddress = xrpCodec.decodeAccountID = xrpCodec.encodeAddress = xrpCodec.encodeAccountID = xrpCodec.decodeSeed = xrpCodec.encodeSeed = xrpCodec.codec = void 0;
  const o = requireSrc$3(), g = requireBrowser$a(), c = requireUtils$4();
  class y {
    constructor(ze) {
      this._sha256 = ze.sha256, this._alphabet = ze.alphabet, this._codec = o(this._alphabet);
    }
    /**
     * Encoder.
     *
     * @param bytes - Buffer of data to encode.
     * @param opts - Options object including the version bytes and the expected length of the data to encode.
     */
    encode(ze, He) {
      const Pe = He.versions;
      return this._encodeVersioned(ze, Pe, He.expectedLength);
    }
    /**
     * Decoder.
     *
     * @param base58string - Base58Check-encoded string to decode.
     * @param opts - Options object including the version byte(s) and the expected length of the data after decoding.
     */
    /* eslint-disable max-lines-per-function --
     * TODO refactor */
    decode(ze, He) {
      var Pe;
      const De = He.versions, ve = He.versionTypes, Fe = this.decodeChecked(ze);
      if (De.length > 1 && !He.expectedLength)
        throw new Error("expectedLength is required because there are >= 2 possible versions");
      const be = typeof De[0] == "number" ? 1 : De[0].length, Be = (Pe = He.expectedLength) !== null && Pe !== void 0 ? Pe : Fe.length - be, ke = Fe.slice(0, -Be), xe = Fe.slice(-Be);
      for (let Ne = 0; Ne < De.length; Ne++) {
        const Et = Array.isArray(De[Ne]) ? De[Ne] : [De[Ne]];
        if ((0, c.seqEqual)(ke, Et))
          return {
            version: Et,
            bytes: xe,
            type: ve ? ve[Ne] : null
          };
      }
      throw new Error("version_invalid: version bytes do not match any of the provided version(s)");
    }
    encodeChecked(ze) {
      const He = this._sha256(this._sha256(ze)).slice(0, 4);
      return this._encodeRaw(Buffer.from((0, c.concatArgs)(ze, He)));
    }
    decodeChecked(ze) {
      const He = this._decodeRaw(ze);
      if (He.length < 5)
        throw new Error("invalid_input_size: decoded data must have length >= 5");
      if (!this._verifyCheckSum(He))
        throw new Error("checksum_invalid");
      return He.slice(0, -4);
    }
    _encodeVersioned(ze, He, Pe) {
      if (Pe && ze.length !== Pe)
        throw new Error("unexpected_payload_length: bytes.length does not match expectedLength. Ensure that the bytes are a Buffer.");
      return this.encodeChecked(Buffer.from((0, c.concatArgs)(He, ze)));
    }
    _encodeRaw(ze) {
      return this._codec.encode(ze);
    }
    /* eslint-enable max-lines-per-function */
    _decodeRaw(ze) {
      return this._codec.decode(ze);
    }
    _verifyCheckSum(ze) {
      const He = this._sha256(this._sha256(ze.slice(0, -4))).slice(0, 4), Pe = ze.slice(-4);
      return (0, c.seqEqual)(He, Pe);
    }
  }
  const t = 0, d = 35, E = 33, B = 28, D = [1, 225, 75], x = {
    sha256(Se) {
      return g("sha256").update(Buffer.from(Se)).digest();
    },
    alphabet: "rpshnaf39wBUDNEGHJKLM4PQRST7VWXYZ2bcdeCg65jkm8oFqi1tuvAxyz"
  }, v = new y(x);
  xrpCodec.codec = v;
  function F(Se, ze) {
    if (Se.length !== 16)
      throw new Error("entropy must have length 16");
    const He = {
      expectedLength: 16,
      // for secp256k1, use `FAMILY_SEED`
      versions: ze === "ed25519" ? D : [E]
    };
    return v.encode(Se, He);
  }
  xrpCodec.encodeSeed = F;
  function M(Se, ze = {
    versionTypes: ["ed25519", "secp256k1"],
    versions: [D, E],
    expectedLength: 16
  }) {
    return v.decode(Se, ze);
  }
  xrpCodec.decodeSeed = M;
  function U(Se) {
    const ze = { versions: [t], expectedLength: 20 };
    return v.encode(Se, ze);
  }
  xrpCodec.encodeAccountID = U, xrpCodec.encodeAddress = U;
  function L(Se) {
    const ze = { versions: [t], expectedLength: 20 };
    return v.decode(Se, ze).bytes;
  }
  xrpCodec.decodeAccountID = L, xrpCodec.decodeAddress = L;
  function H(Se) {
    const ze = { versions: [B], expectedLength: 33 };
    return v.decode(Se, ze).bytes;
  }
  xrpCodec.decodeNodePublic = H;
  function fe(Se) {
    const ze = { versions: [B], expectedLength: 33 };
    return v.encode(Se, ze);
  }
  xrpCodec.encodeNodePublic = fe;
  function ge(Se) {
    const ze = { versions: [d], expectedLength: 33 };
    return v.encode(Se, ze);
  }
  xrpCodec.encodeAccountPublic = ge;
  function Ie(Se) {
    const ze = { versions: [d], expectedLength: 33 };
    return v.decode(Se, ze).bytes;
  }
  xrpCodec.decodeAccountPublic = Ie;
  function Ee(Se) {
    try {
      L(Se);
    } catch {
      return !1;
    }
    return !0;
  }
  return xrpCodec.isValidClassicAddress = Ee, xrpCodec;
}
var hasRequiredDist$5;
function requireDist$5() {
  return hasRequiredDist$5 || (hasRequiredDist$5 = 1, function(o) {
    var g = dist$3 && dist$3.__createBinding || (Object.create ? function(H, fe, ge, Ie) {
      Ie === void 0 && (Ie = ge);
      var Ee = Object.getOwnPropertyDescriptor(fe, ge);
      (!Ee || ("get" in Ee ? !fe.__esModule : Ee.writable || Ee.configurable)) && (Ee = { enumerable: !0, get: function() {
        return fe[ge];
      } }), Object.defineProperty(H, Ie, Ee);
    } : function(H, fe, ge, Ie) {
      Ie === void 0 && (Ie = ge), H[Ie] = fe[ge];
    }), c = dist$3 && dist$3.__setModuleDefault || (Object.create ? function(H, fe) {
      Object.defineProperty(H, "default", { enumerable: !0, value: fe });
    } : function(H, fe) {
      H.default = fe;
    }), y = dist$3 && dist$3.__importStar || function(H) {
      if (H && H.__esModule) return H;
      var fe = {};
      if (H != null) for (var ge in H) ge !== "default" && Object.prototype.hasOwnProperty.call(H, ge) && g(fe, H, ge);
      return c(fe, H), fe;
    };
    Object.defineProperty(o, "__esModule", { value: !0 }), o.isValidXAddress = o.decodeXAddress = o.xAddressToClassicAddress = o.encodeXAddress = o.classicAddressToXAddress = o.isValidClassicAddress = o.decodeAccountPublic = o.encodeAccountPublic = o.decodeNodePublic = o.encodeNodePublic = o.decodeAccountID = o.encodeAccountID = o.decodeSeed = o.encodeSeed = o.codec = void 0;
    const t = y(requireAssert$2()), d = requireXrpCodec();
    Object.defineProperty(o, "codec", { enumerable: !0, get: function() {
      return d.codec;
    } }), Object.defineProperty(o, "encodeSeed", { enumerable: !0, get: function() {
      return d.encodeSeed;
    } }), Object.defineProperty(o, "decodeSeed", { enumerable: !0, get: function() {
      return d.decodeSeed;
    } }), Object.defineProperty(o, "encodeAccountID", { enumerable: !0, get: function() {
      return d.encodeAccountID;
    } }), Object.defineProperty(o, "decodeAccountID", { enumerable: !0, get: function() {
      return d.decodeAccountID;
    } }), Object.defineProperty(o, "encodeNodePublic", { enumerable: !0, get: function() {
      return d.encodeNodePublic;
    } }), Object.defineProperty(o, "decodeNodePublic", { enumerable: !0, get: function() {
      return d.decodeNodePublic;
    } }), Object.defineProperty(o, "encodeAccountPublic", { enumerable: !0, get: function() {
      return d.encodeAccountPublic;
    } }), Object.defineProperty(o, "decodeAccountPublic", { enumerable: !0, get: function() {
      return d.decodeAccountPublic;
    } }), Object.defineProperty(o, "isValidClassicAddress", { enumerable: !0, get: function() {
      return d.isValidClassicAddress;
    } });
    const E = {
      // 5, 68
      main: Buffer.from([5, 68]),
      // 4, 147
      test: Buffer.from([4, 147])
    }, B = 4294967295;
    function D(H, fe, ge) {
      const Ie = (0, d.decodeAccountID)(H);
      return x(Ie, fe, ge);
    }
    o.classicAddressToXAddress = D;
    function x(H, fe, ge) {
      if (H.length !== 20)
        throw new Error("Account ID must be 20 bytes");
      if (fe > B)
        throw new Error("Invalid tag");
      const Ie = fe || 0, Ee = fe === !1 || fe == null ? 0 : 1, Se = Buffer.concat([
        ge ? E.test : E.main,
        H,
        Buffer.from([
          // 0x00 if no tag, 0x01 if 32-bit tag
          Ee,
          // first byte
          Ie & 255,
          // second byte
          Ie >> 8 & 255,
          // third byte
          Ie >> 16 & 255,
          // fourth byte
          Ie >> 24 & 255,
          0,
          0,
          0,
          // four zero bytes (reserved for 64-bit tags)
          0
        ])
      ]);
      return d.codec.encodeChecked(Se);
    }
    o.encodeXAddress = x;
    function v(H) {
      const { accountId: fe, tag: ge, test: Ie } = F(H);
      return {
        classicAddress: (0, d.encodeAccountID)(fe),
        tag: ge,
        test: Ie
      };
    }
    o.xAddressToClassicAddress = v;
    function F(H) {
      const fe = d.codec.decodeChecked(H), ge = M(fe), Ie = fe.slice(2, 22), Ee = U(fe);
      return {
        accountId: Ie,
        tag: Ee,
        test: ge
      };
    }
    o.decodeXAddress = F;
    function M(H) {
      const fe = H.slice(0, 2);
      if (E.main.equals(fe))
        return !1;
      if (E.test.equals(fe))
        return !0;
      throw new Error("Invalid X-address: bad prefix");
    }
    function U(H) {
      const fe = H[22];
      if (fe >= 2)
        throw new Error("Unsupported X-address");
      return fe === 1 ? H[23] + H[24] * 256 + H[25] * 65536 + H[26] * 16777216 : (t.strictEqual(fe, 0, "flag must be zero to indicate no tag"), t.ok(Buffer.from("0000000000000000", "hex").equals(H.slice(23, 31)), "remaining bytes must be zero"), !1);
    }
    function L(H) {
      try {
        F(H);
      } catch {
        return !1;
      }
      return !0;
    }
    o.isValidXAddress = L;
  }(dist$3)), dist$3;
}
var hash160$2 = {}, hash$n = {}, hasRequiredHash;
function requireHash() {
  if (hasRequiredHash) return hash$n;
  hasRequiredHash = 1, Object.defineProperty(hash$n, "__esModule", { value: !0 }), hash$n.Hash = void 0;
  const o = requireSerializedType(), g = requireBuffer$2();
  class c extends o.Comparable {
    constructor(t) {
      if (super(t), this.bytes.byteLength !== this.constructor.width)
        throw new Error(`Invalid Hash length ${this.bytes.byteLength}`);
    }
    /**
     * Construct a Hash object from an existing Hash object or a hex-string
     *
     * @param value A hash object or hex-string of a hash
     */
    static from(t) {
      if (t instanceof this)
        return t;
      if (typeof t == "string")
        return new this(g.Buffer.from(t, "hex"));
      throw new Error("Cannot construct Hash from given value");
    }
    /**
     * Read a Hash object from a BinaryParser
     *
     * @param parser BinaryParser to read the hash from
     * @param hint length of the bytes to read, optional
     */
    static fromParser(t, d) {
      return new this(t.read(d ?? this.width));
    }
    /**
     * Overloaded operator for comparing two hash objects
     *
     * @param other The Hash to compare this to
     */
    compareTo(t) {
      return this.bytes.compare(this.constructor.from(t).bytes);
    }
    /**
     * @returns the hex-string representation of this Hash
     */
    toString() {
      return this.toHex();
    }
    /**
     * Returns four bits at the specified depth within a hash
     *
     * @param depth The depth of the four bits
     * @returns The number represented by the four bits
     */
    nibblet(t) {
      const d = t > 0 ? t / 2 | 0 : 0;
      let E = this.bytes[d];
      return t % 2 === 0 ? E = (E & 240) >>> 4 : E = E & 15, E;
    }
  }
  return hash$n.Hash = c, hash$n;
}
var hasRequiredHash160;
function requireHash160() {
  if (hasRequiredHash160) return hash160$2;
  hasRequiredHash160 = 1, Object.defineProperty(hash160$2, "__esModule", { value: !0 }), hash160$2.Hash160 = void 0;
  const o = requireHash(), g = requireBuffer$2();
  class c extends o.Hash {
    constructor(t) {
      t && t.byteLength === 0 && (t = c.ZERO_160.bytes), super(t ?? c.ZERO_160.bytes);
    }
  }
  return hash160$2.Hash160 = c, c.width = 20, c.ZERO_160 = new c(g.Buffer.alloc(c.width)), hash160$2;
}
var hasRequiredAccountId;
function requireAccountId() {
  if (hasRequiredAccountId) return accountId;
  hasRequiredAccountId = 1, Object.defineProperty(accountId, "__esModule", { value: !0 }), accountId.AccountID = void 0;
  const o = requireDist$5(), g = requireHash160(), c = requireBuffer$2(), y = /^[A-F0-9]{40}$/;
  class t extends g.Hash160 {
    constructor(E) {
      super(E ?? t.defaultAccountID.bytes);
    }
    /**
     * Defines how to construct an AccountID
     *
     * @param value either an existing AccountID, a hex-string, or a base58 r-Address
     * @returns an AccountID object
     */
    static from(E) {
      if (E instanceof t)
        return E;
      if (typeof E == "string")
        return E === "" ? new t() : y.test(E) ? new t(c.Buffer.from(E, "hex")) : this.fromBase58(E);
      throw new Error("Cannot construct AccountID from value given");
    }
    /**
     * Defines how to build an AccountID from a base58 r-Address
     *
     * @param value a base58 r-Address
     * @returns an AccountID object
     */
    static fromBase58(E) {
      if ((0, o.isValidXAddress)(E)) {
        const B = (0, o.xAddressToClassicAddress)(E);
        if (B.tag !== !1)
          throw new Error("Only allowed to have tag on Account or Destination");
        E = B.classicAddress;
      }
      return new t(c.Buffer.from((0, o.decodeAccountID)(E)));
    }
    /**
     * Overload of toJSON
     *
     * @returns the base58 string for this AccountID
     */
    toJSON() {
      return this.toBase58();
    }
    /**
     * Defines how to encode AccountID into a base58 address
     *
     * @returns the base58 string defined by this.bytes
     */
    toBase58() {
      return (0, o.encodeAccountID)(this.bytes);
    }
  }
  return accountId.AccountID = t, t.defaultAccountID = new t(c.Buffer.alloc(20)), accountId;
}
var amount = {}, decimal$3 = { exports: {} }, decimal$2 = decimal$3.exports, hasRequiredDecimal$1;
function requireDecimal$1() {
  return hasRequiredDecimal$1 || (hasRequiredDecimal$1 = 1, function(o) {
    (function(g) {
      var c = 9e15, y = 1e9, t = "0123456789abcdef", d = "2.3025850929940456840179914546843642076011014886287729760333279009675726096773524802359972050895982983419677840422862486334095254650828067566662873690987816894829072083255546808437998948262331985283935053089653777326288461633662222876982198867465436674744042432743651550489343149393914796194044002221051017141748003688084012647080685567743216228355220114804663715659121373450747856947683463616792101806445070648000277502684916746550586856935673420670581136429224554405758925724208241314695689016758940256776311356919292033376587141660230105703089634572075440370847469940168269282808481184289314848524948644871927809676271275775397027668605952496716674183485704422507197965004714951050492214776567636938662976979522110718264549734772662425709429322582798502585509785265383207606726317164309505995087807523710333101197857547331541421808427543863591778117054309827482385045648019095610299291824318237525357709750539565187697510374970888692180205189339507238539205144634197265287286965110862571492198849978748873771345686209167058", E = "3.1415926535897932384626433832795028841971693993751058209749445923078164062862089986280348253421170679821480865132823066470938446095505822317253594081284811174502841027019385211055596446229489549303819644288109756659334461284756482337867831652712019091456485669234603486104543266482133936072602491412737245870066063155881748815209209628292540917153643678925903600113305305488204665213841469519415116094330572703657595919530921861173819326117931051185480744623799627495673518857527248912279381830119491298336733624406566430860213949463952247371907021798609437027705392171762931767523846748184676694051320005681271452635608277857713427577896091736371787214684409012249534301465495853710507922796892589235420199561121290219608640344181598136297747713099605187072113499999983729780499510597317328160963185950244594553469083026425223082533446850352619311881710100031378387528865875332083814206171776691473035982534904287554687311595628638823537875937519577818577805321712268066130019278766111959092164201989380952572010654858632789", B = {
        // These values must be integers within the stated ranges (inclusive).
        // Most of these values can be changed at run-time using the `Decimal.config` method.
        // The maximum number of significant digits of the result of a calculation or base conversion.
        // E.g. `Decimal.config({ precision: 20 });`
        precision: 20,
        // 1 to MAX_DIGITS
        // The rounding mode used when rounding to `precision`.
        //
        // ROUND_UP         0 Away from zero.
        // ROUND_DOWN       1 Towards zero.
        // ROUND_CEIL       2 Towards +Infinity.
        // ROUND_FLOOR      3 Towards -Infinity.
        // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
        // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
        // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
        // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
        // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
        //
        // E.g.
        // `Decimal.rounding = 4;`
        // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
        rounding: 4,
        // 0 to 8
        // The modulo mode used when calculating the modulus: a mod n.
        // The quotient (q = a / n) is calculated according to the corresponding rounding mode.
        // The remainder (r) is calculated as: r = a - n * q.
        //
        // UP         0 The remainder is positive if the dividend is negative, else is negative.
        // DOWN       1 The remainder has the same sign as the dividend (JavaScript %).
        // FLOOR      3 The remainder has the same sign as the divisor (Python %).
        // HALF_EVEN  6 The IEEE 754 remainder function.
        // EUCLID     9 Euclidian division. q = sign(n) * floor(a / abs(n)). Always positive.
        //
        // Truncated division (1), floored division (3), the IEEE 754 remainder (6), and Euclidian
        // division (9) are commonly used for the modulus operation. The other rounding modes can also
        // be used, but they may not give useful results.
        modulo: 1,
        // 0 to 9
        // The exponent value at and beneath which `toString` returns exponential notation.
        // JavaScript numbers: -7
        toExpNeg: -7,
        // 0 to -EXP_LIMIT
        // The exponent value at and above which `toString` returns exponential notation.
        // JavaScript numbers: 21
        toExpPos: 21,
        // 0 to EXP_LIMIT
        // The minimum exponent value, beneath which underflow to zero occurs.
        // JavaScript numbers: -324  (5e-324)
        minE: -c,
        // -1 to -EXP_LIMIT
        // The maximum exponent value, above which overflow to Infinity occurs.
        // JavaScript numbers: 308  (1.7976931348623157e+308)
        maxE: c,
        // 1 to EXP_LIMIT
        // Whether to use cryptographically-secure random number generation, if available.
        crypto: !1
        // true/false
      }, D, x, v, F, M = !0, U = "[DecimalError] ", L = U + "Invalid argument: ", H = U + "Precision limit exceeded", fe = U + "crypto unavailable", ge = "[object Decimal]", Ie = Math.floor, Ee = Math.pow, Se = /^0b([01]+(\.[01]*)?|\.[01]+)(p[+-]?\d+)?$/i, ze = /^0x([0-9a-f]+(\.[0-9a-f]*)?|\.[0-9a-f]+)(p[+-]?\d+)?$/i, He = /^0o([0-7]+(\.[0-7]*)?|\.[0-7]+)(p[+-]?\d+)?$/i, Pe = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, De = 1e7, ve = 7, Fe = 9007199254740991, be = d.length - 1, Be = E.length - 1, ke = { toStringTag: ge };
      ke.absoluteValue = ke.abs = function() {
        var ri = new this.constructor(this);
        return ri.s < 0 && (ri.s = 1), xt(ri);
      }, ke.ceil = function() {
        return xt(new this.constructor(this), this.e + 1, 2);
      }, ke.clampedTo = ke.clamp = function(ri, Tr) {
        var yi, ki = this, qi = ki.constructor;
        if (ri = new qi(ri), Tr = new qi(Tr), !ri.s || !Tr.s) return new qi(NaN);
        if (ri.gt(Tr)) throw Error(L + Tr);
        return yi = ki.cmp(ri), yi < 0 ? ri : ki.cmp(Tr) > 0 ? Tr : new qi(ki);
      }, ke.comparedTo = ke.cmp = function(ri) {
        var Tr, yi, ki, qi, C = this, l = C.d, w = (ri = new C.constructor(ri)).d, n = C.s, a = ri.s;
        if (!l || !w)
          return !n || !a ? NaN : n !== a ? n : l === w ? 0 : !l ^ n < 0 ? 1 : -1;
        if (!l[0] || !w[0]) return l[0] ? n : w[0] ? -a : 0;
        if (n !== a) return n;
        if (C.e !== ri.e) return C.e > ri.e ^ n < 0 ? 1 : -1;
        for (ki = l.length, qi = w.length, Tr = 0, yi = ki < qi ? ki : qi; Tr < yi; ++Tr)
          if (l[Tr] !== w[Tr]) return l[Tr] > w[Tr] ^ n < 0 ? 1 : -1;
        return ki === qi ? 0 : ki > qi ^ n < 0 ? 1 : -1;
      }, ke.cosine = ke.cos = function() {
        var ri, Tr, yi = this, ki = yi.constructor;
        return yi.d ? yi.d[0] ? (ri = ki.precision, Tr = ki.rounding, ki.precision = ri + Math.max(yi.e, yi.sd()) + ve, ki.rounding = 1, yi = Dt(ki, hr(ki, yi)), ki.precision = ri, ki.rounding = Tr, xt(F == 2 || F == 3 ? yi.neg() : yi, ri, Tr, !0)) : new ki(1) : new ki(NaN);
      }, ke.cubeRoot = ke.cbrt = function() {
        var ri, Tr, yi, ki, qi, C, l, w, n, a, b = this, P = b.constructor;
        if (!b.isFinite() || b.isZero()) return new P(b);
        for (M = !1, C = b.s * Ee(b.s * b, 1 / 3), !C || Math.abs(C) == 1 / 0 ? (yi = xe(b.d), ri = b.e, (C = (ri - yi.length + 1) % 3) && (yi += C == 1 || C == -2 ? "0" : "00"), C = Ee(yi, 1 / 3), ri = Ie((ri + 1) / 3) - (ri % 3 == (ri < 0 ? -1 : 2)), C == 1 / 0 ? yi = "5e" + ri : (yi = C.toExponential(), yi = yi.slice(0, yi.indexOf("e") + 1) + ri), ki = new P(yi), ki.s = b.s) : ki = new P(C.toString()), l = (ri = P.precision) + 3; ; )
          if (w = ki, n = w.times(w).times(w), a = n.plus(b), ki = er(a.plus(b).times(w), a.plus(n), l + 2, 1), xe(w.d).slice(0, l) === (yi = xe(ki.d)).slice(0, l))
            if (yi = yi.slice(l - 3, l + 1), yi == "9999" || !qi && yi == "4999") {
              if (!qi && (xt(w, ri + 1, 0), w.times(w).times(w).eq(b))) {
                ki = w;
                break;
              }
              l += 4, qi = 1;
            } else {
              (!+yi || !+yi.slice(1) && yi.charAt(0) == "5") && (xt(ki, ri + 1, 1), Tr = !ki.times(ki).times(ki).eq(b));
              break;
            }
        return M = !0, xt(ki, ri, P.rounding, Tr);
      }, ke.decimalPlaces = ke.dp = function() {
        var ri, Tr = this.d, yi = NaN;
        if (Tr) {
          if (ri = Tr.length - 1, yi = (ri - Ie(this.e / ve)) * ve, ri = Tr[ri], ri) for (; ri % 10 == 0; ri /= 10) yi--;
          yi < 0 && (yi = 0);
        }
        return yi;
      }, ke.dividedBy = ke.div = function(ri) {
        return er(this, new this.constructor(ri));
      }, ke.dividedToIntegerBy = ke.divToInt = function(ri) {
        var Tr = this, yi = Tr.constructor;
        return xt(er(Tr, new yi(ri), 0, 1, 1), yi.precision, yi.rounding);
      }, ke.equals = ke.eq = function(ri) {
        return this.cmp(ri) === 0;
      }, ke.floor = function() {
        return xt(new this.constructor(this), this.e + 1, 3);
      }, ke.greaterThan = ke.gt = function(ri) {
        return this.cmp(ri) > 0;
      }, ke.greaterThanOrEqualTo = ke.gte = function(ri) {
        var Tr = this.cmp(ri);
        return Tr == 1 || Tr === 0;
      }, ke.hyperbolicCosine = ke.cosh = function() {
        var ri, Tr, yi, ki, qi, C = this, l = C.constructor, w = new l(1);
        if (!C.isFinite()) return new l(C.s ? 1 / 0 : NaN);
        if (C.isZero()) return w;
        yi = l.precision, ki = l.rounding, l.precision = yi + Math.max(C.e, C.sd()) + 4, l.rounding = 1, qi = C.d.length, qi < 32 ? (ri = Math.ceil(qi / 3), Tr = (1 / cr(4, ri)).toString()) : (ri = 16, Tr = "2.3283064365386962890625e-10"), C = Ar(l, 1, C.times(Tr), new l(1), !0);
        for (var n, a = ri, b = new l(8); a--; )
          n = C.times(C), C = w.minus(n.times(b.minus(n.times(b))));
        return xt(C, l.precision = yi, l.rounding = ki, !0);
      }, ke.hyperbolicSine = ke.sinh = function() {
        var ri, Tr, yi, ki, qi = this, C = qi.constructor;
        if (!qi.isFinite() || qi.isZero()) return new C(qi);
        if (Tr = C.precision, yi = C.rounding, C.precision = Tr + Math.max(qi.e, qi.sd()) + 4, C.rounding = 1, ki = qi.d.length, ki < 3)
          qi = Ar(C, 2, qi, qi, !0);
        else {
          ri = 1.4 * Math.sqrt(ki), ri = ri > 16 ? 16 : ri | 0, qi = qi.times(1 / cr(5, ri)), qi = Ar(C, 2, qi, qi, !0);
          for (var l, w = new C(5), n = new C(16), a = new C(20); ri--; )
            l = qi.times(qi), qi = qi.times(w.plus(l.times(n.times(l).plus(a))));
        }
        return C.precision = Tr, C.rounding = yi, xt(qi, Tr, yi, !0);
      }, ke.hyperbolicTangent = ke.tanh = function() {
        var ri, Tr, yi = this, ki = yi.constructor;
        return yi.isFinite() ? yi.isZero() ? new ki(yi) : (ri = ki.precision, Tr = ki.rounding, ki.precision = ri + 7, ki.rounding = 1, er(yi.sinh(), yi.cosh(), ki.precision = ri, ki.rounding = Tr)) : new ki(yi.s);
      }, ke.inverseCosine = ke.acos = function() {
        var ri = this, Tr = ri.constructor, yi = ri.abs().cmp(1), ki = Tr.precision, qi = Tr.rounding;
        return yi !== -1 ? yi === 0 ? ri.isNeg() ? wr(Tr, ki, qi) : new Tr(0) : new Tr(NaN) : ri.isZero() ? wr(Tr, ki + 4, qi).times(0.5) : (Tr.precision = ki + 6, Tr.rounding = 1, ri = new Tr(1).minus(ri).div(ri.plus(1)).sqrt().atan(), Tr.precision = ki, Tr.rounding = qi, ri.times(2));
      }, ke.inverseHyperbolicCosine = ke.acosh = function() {
        var ri, Tr, yi = this, ki = yi.constructor;
        return yi.lte(1) ? new ki(yi.eq(1) ? 0 : NaN) : yi.isFinite() ? (ri = ki.precision, Tr = ki.rounding, ki.precision = ri + Math.max(Math.abs(yi.e), yi.sd()) + 4, ki.rounding = 1, M = !1, yi = yi.times(yi).minus(1).sqrt().plus(yi), M = !0, ki.precision = ri, ki.rounding = Tr, yi.ln()) : new ki(yi);
      }, ke.inverseHyperbolicSine = ke.asinh = function() {
        var ri, Tr, yi = this, ki = yi.constructor;
        return !yi.isFinite() || yi.isZero() ? new ki(yi) : (ri = ki.precision, Tr = ki.rounding, ki.precision = ri + 2 * Math.max(Math.abs(yi.e), yi.sd()) + 6, ki.rounding = 1, M = !1, yi = yi.times(yi).plus(1).sqrt().plus(yi), M = !0, ki.precision = ri, ki.rounding = Tr, yi.ln());
      }, ke.inverseHyperbolicTangent = ke.atanh = function() {
        var ri, Tr, yi, ki, qi = this, C = qi.constructor;
        return qi.isFinite() ? qi.e >= 0 ? new C(qi.abs().eq(1) ? qi.s / 0 : qi.isZero() ? qi : NaN) : (ri = C.precision, Tr = C.rounding, ki = qi.sd(), Math.max(ki, ri) < 2 * -qi.e - 1 ? xt(new C(qi), ri, Tr, !0) : (C.precision = yi = ki - qi.e, qi = er(qi.plus(1), new C(1).minus(qi), yi + ri, 1), C.precision = ri + 4, C.rounding = 1, qi = qi.ln(), C.precision = ri, C.rounding = Tr, qi.times(0.5))) : new C(NaN);
      }, ke.inverseSine = ke.asin = function() {
        var ri, Tr, yi, ki, qi = this, C = qi.constructor;
        return qi.isZero() ? new C(qi) : (Tr = qi.abs().cmp(1), yi = C.precision, ki = C.rounding, Tr !== -1 ? Tr === 0 ? (ri = wr(C, yi + 4, ki).times(0.5), ri.s = qi.s, ri) : new C(NaN) : (C.precision = yi + 6, C.rounding = 1, qi = qi.div(new C(1).minus(qi.times(qi)).sqrt().plus(1)).atan(), C.precision = yi, C.rounding = ki, qi.times(2)));
      }, ke.inverseTangent = ke.atan = function() {
        var ri, Tr, yi, ki, qi, C, l, w, n, a = this, b = a.constructor, P = b.precision, K = b.rounding;
        if (a.isFinite()) {
          if (a.isZero())
            return new b(a);
          if (a.abs().eq(1) && P + 4 <= Be)
            return l = wr(b, P + 4, K).times(0.25), l.s = a.s, l;
        } else {
          if (!a.s) return new b(NaN);
          if (P + 4 <= Be)
            return l = wr(b, P + 4, K).times(0.5), l.s = a.s, l;
        }
        for (b.precision = w = P + 10, b.rounding = 1, yi = Math.min(28, w / ve + 2 | 0), ri = yi; ri; --ri) a = a.div(a.times(a).plus(1).sqrt().plus(1));
        for (M = !1, Tr = Math.ceil(w / ve), ki = 1, n = a.times(a), l = new b(a), qi = a; ri !== -1; )
          if (qi = qi.times(n), C = l.minus(qi.div(ki += 2)), qi = qi.times(n), l = C.plus(qi.div(ki += 2)), l.d[Tr] !== void 0) for (ri = Tr; l.d[ri] === C.d[ri] && ri--; ) ;
        return yi && (l = l.times(2 << yi - 1)), M = !0, xt(l, b.precision = P, b.rounding = K, !0);
      }, ke.isFinite = function() {
        return !!this.d;
      }, ke.isInteger = ke.isInt = function() {
        return !!this.d && Ie(this.e / ve) > this.d.length - 2;
      }, ke.isNaN = function() {
        return !this.s;
      }, ke.isNegative = ke.isNeg = function() {
        return this.s < 0;
      }, ke.isPositive = ke.isPos = function() {
        return this.s > 0;
      }, ke.isZero = function() {
        return !!this.d && this.d[0] === 0;
      }, ke.lessThan = ke.lt = function(ri) {
        return this.cmp(ri) < 0;
      }, ke.lessThanOrEqualTo = ke.lte = function(ri) {
        return this.cmp(ri) < 1;
      }, ke.logarithm = ke.log = function(ri) {
        var Tr, yi, ki, qi, C, l, w, n, a = this, b = a.constructor, P = b.precision, K = b.rounding, pe = 5;
        if (ri == null)
          ri = new b(10), Tr = !0;
        else {
          if (ri = new b(ri), yi = ri.d, ri.s < 0 || !yi || !yi[0] || ri.eq(1)) return new b(NaN);
          Tr = ri.eq(10);
        }
        if (yi = a.d, a.s < 0 || !yi || !yi[0] || a.eq(1))
          return new b(yi && !yi[0] ? -1 / 0 : a.s != 1 ? NaN : yi ? 0 : 1 / 0);
        if (Tr)
          if (yi.length > 1)
            C = !0;
          else {
            for (qi = yi[0]; qi % 10 === 0; ) qi /= 10;
            C = qi !== 1;
          }
        if (M = !1, w = P + pe, l = Ur(a, w), ki = Tr ? yr(b, w + 10) : Ur(ri, w), n = er(l, ki, w, 1), Et(n.d, qi = P, K))
          do
            if (w += 10, l = Ur(a, w), ki = Tr ? yr(b, w + 10) : Ur(ri, w), n = er(l, ki, w, 1), !C) {
              +xe(n.d).slice(qi + 1, qi + 15) + 1 == 1e14 && (n = xt(n, P + 1, 0));
              break;
            }
          while (Et(n.d, qi += 10, K));
        return M = !0, xt(n, P, K);
      }, ke.minus = ke.sub = function(ri) {
        var Tr, yi, ki, qi, C, l, w, n, a, b, P, K, pe = this, Ce = pe.constructor;
        if (ri = new Ce(ri), !pe.d || !ri.d)
          return !pe.s || !ri.s ? ri = new Ce(NaN) : pe.d ? ri.s = -ri.s : ri = new Ce(ri.d || pe.s !== ri.s ? pe : NaN), ri;
        if (pe.s != ri.s)
          return ri.s = -ri.s, pe.plus(ri);
        if (a = pe.d, K = ri.d, w = Ce.precision, n = Ce.rounding, !a[0] || !K[0]) {
          if (K[0]) ri.s = -ri.s;
          else if (a[0]) ri = new Ce(pe);
          else return new Ce(n === 3 ? -0 : 0);
          return M ? xt(ri, w, n) : ri;
        }
        if (yi = Ie(ri.e / ve), b = Ie(pe.e / ve), a = a.slice(), C = b - yi, C) {
          for (P = C < 0, P ? (Tr = a, C = -C, l = K.length) : (Tr = K, yi = b, l = a.length), ki = Math.max(Math.ceil(w / ve), l) + 2, C > ki && (C = ki, Tr.length = 1), Tr.reverse(), ki = C; ki--; ) Tr.push(0);
          Tr.reverse();
        } else {
          for (ki = a.length, l = K.length, P = ki < l, P && (l = ki), ki = 0; ki < l; ki++)
            if (a[ki] != K[ki]) {
              P = a[ki] < K[ki];
              break;
            }
          C = 0;
        }
        for (P && (Tr = a, a = K, K = Tr, ri.s = -ri.s), l = a.length, ki = K.length - l; ki > 0; --ki) a[l++] = 0;
        for (ki = K.length; ki > C; ) {
          if (a[--ki] < K[ki]) {
            for (qi = ki; qi && a[--qi] === 0; ) a[qi] = De - 1;
            --a[qi], a[ki] += De;
          }
          a[ki] -= K[ki];
        }
        for (; a[--l] === 0; ) a.pop();
        for (; a[0] === 0; a.shift()) --yi;
        return a[0] ? (ri.d = a, ri.e = sr(a, yi), M ? xt(ri, w, n) : ri) : new Ce(n === 3 ? -0 : 0);
      }, ke.modulo = ke.mod = function(ri) {
        var Tr, yi = this, ki = yi.constructor;
        return ri = new ki(ri), !yi.d || !ri.s || ri.d && !ri.d[0] ? new ki(NaN) : !ri.d || yi.d && !yi.d[0] ? xt(new ki(yi), ki.precision, ki.rounding) : (M = !1, ki.modulo == 9 ? (Tr = er(yi, ri.abs(), 0, 3, 1), Tr.s *= ri.s) : Tr = er(yi, ri, 0, ki.modulo, 1), Tr = Tr.times(ri), M = !0, yi.minus(Tr));
      }, ke.naturalExponential = ke.exp = function() {
        return Vr(this);
      }, ke.naturalLogarithm = ke.ln = function() {
        return Ur(this);
      }, ke.negated = ke.neg = function() {
        var ri = new this.constructor(this);
        return ri.s = -ri.s, xt(ri);
      }, ke.plus = ke.add = function(ri) {
        var Tr, yi, ki, qi, C, l, w, n, a, b, P = this, K = P.constructor;
        if (ri = new K(ri), !P.d || !ri.d)
          return !P.s || !ri.s ? ri = new K(NaN) : P.d || (ri = new K(ri.d || P.s === ri.s ? P : NaN)), ri;
        if (P.s != ri.s)
          return ri.s = -ri.s, P.minus(ri);
        if (a = P.d, b = ri.d, w = K.precision, n = K.rounding, !a[0] || !b[0])
          return b[0] || (ri = new K(P)), M ? xt(ri, w, n) : ri;
        if (C = Ie(P.e / ve), ki = Ie(ri.e / ve), a = a.slice(), qi = C - ki, qi) {
          for (qi < 0 ? (yi = a, qi = -qi, l = b.length) : (yi = b, ki = C, l = a.length), C = Math.ceil(w / ve), l = C > l ? C + 1 : l + 1, qi > l && (qi = l, yi.length = 1), yi.reverse(); qi--; ) yi.push(0);
          yi.reverse();
        }
        for (l = a.length, qi = b.length, l - qi < 0 && (qi = l, yi = b, b = a, a = yi), Tr = 0; qi; )
          Tr = (a[--qi] = a[qi] + b[qi] + Tr) / De | 0, a[qi] %= De;
        for (Tr && (a.unshift(Tr), ++ki), l = a.length; a[--l] == 0; ) a.pop();
        return ri.d = a, ri.e = sr(a, ki), M ? xt(ri, w, n) : ri;
      }, ke.precision = ke.sd = function(ri) {
        var Tr, yi = this;
        if (ri !== void 0 && ri !== !!ri && ri !== 1 && ri !== 0) throw Error(L + ri);
        return yi.d ? (Tr = qr(yi.d), ri && yi.e + 1 > Tr && (Tr = yi.e + 1)) : Tr = NaN, Tr;
      }, ke.round = function() {
        var ri = this, Tr = ri.constructor;
        return xt(new Tr(ri), ri.e + 1, Tr.rounding);
      }, ke.sine = ke.sin = function() {
        var ri, Tr, yi = this, ki = yi.constructor;
        return yi.isFinite() ? yi.isZero() ? new ki(yi) : (ri = ki.precision, Tr = ki.rounding, ki.precision = ri + Math.max(yi.e, yi.sd()) + ve, ki.rounding = 1, yi = br(ki, hr(ki, yi)), ki.precision = ri, ki.rounding = Tr, xt(F > 2 ? yi.neg() : yi, ri, Tr, !0)) : new ki(NaN);
      }, ke.squareRoot = ke.sqrt = function() {
        var ri, Tr, yi, ki, qi, C, l = this, w = l.d, n = l.e, a = l.s, b = l.constructor;
        if (a !== 1 || !w || !w[0])
          return new b(!a || a < 0 && (!w || w[0]) ? NaN : w ? l : 1 / 0);
        for (M = !1, a = Math.sqrt(+l), a == 0 || a == 1 / 0 ? (Tr = xe(w), (Tr.length + n) % 2 == 0 && (Tr += "0"), a = Math.sqrt(Tr), n = Ie((n + 1) / 2) - (n < 0 || n % 2), a == 1 / 0 ? Tr = "5e" + n : (Tr = a.toExponential(), Tr = Tr.slice(0, Tr.indexOf("e") + 1) + n), ki = new b(Tr)) : ki = new b(a.toString()), yi = (n = b.precision) + 3; ; )
          if (C = ki, ki = C.plus(er(l, C, yi + 2, 1)).times(0.5), xe(C.d).slice(0, yi) === (Tr = xe(ki.d)).slice(0, yi))
            if (Tr = Tr.slice(yi - 3, yi + 1), Tr == "9999" || !qi && Tr == "4999") {
              if (!qi && (xt(C, n + 1, 0), C.times(C).eq(l))) {
                ki = C;
                break;
              }
              yi += 4, qi = 1;
            } else {
              (!+Tr || !+Tr.slice(1) && Tr.charAt(0) == "5") && (xt(ki, n + 1, 1), ri = !ki.times(ki).eq(l));
              break;
            }
        return M = !0, xt(ki, n, b.rounding, ri);
      }, ke.tangent = ke.tan = function() {
        var ri, Tr, yi = this, ki = yi.constructor;
        return yi.isFinite() ? yi.isZero() ? new ki(yi) : (ri = ki.precision, Tr = ki.rounding, ki.precision = ri + 10, ki.rounding = 1, yi = yi.sin(), yi.s = 1, yi = er(yi, new ki(1).minus(yi.times(yi)).sqrt(), ri + 10, 0), ki.precision = ri, ki.rounding = Tr, xt(F == 2 || F == 4 ? yi.neg() : yi, ri, Tr, !0)) : new ki(NaN);
      }, ke.times = ke.mul = function(ri) {
        var Tr, yi, ki, qi, C, l, w, n, a, b = this, P = b.constructor, K = b.d, pe = (ri = new P(ri)).d;
        if (ri.s *= b.s, !K || !K[0] || !pe || !pe[0])
          return new P(!ri.s || K && !K[0] && !pe || pe && !pe[0] && !K ? NaN : !K || !pe ? ri.s / 0 : ri.s * 0);
        for (yi = Ie(b.e / ve) + Ie(ri.e / ve), n = K.length, a = pe.length, n < a && (C = K, K = pe, pe = C, l = n, n = a, a = l), C = [], l = n + a, ki = l; ki--; ) C.push(0);
        for (ki = a; --ki >= 0; ) {
          for (Tr = 0, qi = n + ki; qi > ki; )
            w = C[qi] + pe[ki] * K[qi - ki - 1] + Tr, C[qi--] = w % De | 0, Tr = w / De | 0;
          C[qi] = (C[qi] + Tr) % De | 0;
        }
        for (; !C[--l]; ) C.pop();
        return Tr ? ++yi : C.shift(), ri.d = C, ri.e = sr(C, yi), M ? xt(ri, P.precision, P.rounding) : ri;
      }, ke.toBinary = function(ri, Tr) {
        return Wr(this, 2, ri, Tr);
      }, ke.toDecimalPlaces = ke.toDP = function(ri, Tr) {
        var yi = this, ki = yi.constructor;
        return yi = new ki(yi), ri === void 0 ? yi : (Ne(ri, 0, y), Tr === void 0 ? Tr = ki.rounding : Ne(Tr, 0, 8), xt(yi, ri + yi.e + 1, Tr));
      }, ke.toExponential = function(ri, Tr) {
        var yi, ki = this, qi = ki.constructor;
        return ri === void 0 ? yi = ir(ki, !0) : (Ne(ri, 0, y), Tr === void 0 ? Tr = qi.rounding : Ne(Tr, 0, 8), ki = xt(new qi(ki), ri + 1, Tr), yi = ir(ki, !0, ri + 1)), ki.isNeg() && !ki.isZero() ? "-" + yi : yi;
      }, ke.toFixed = function(ri, Tr) {
        var yi, ki, qi = this, C = qi.constructor;
        return ri === void 0 ? yi = ir(qi) : (Ne(ri, 0, y), Tr === void 0 ? Tr = C.rounding : Ne(Tr, 0, 8), ki = xt(new C(qi), ri + qi.e + 1, Tr), yi = ir(ki, !1, ri + ki.e + 1)), qi.isNeg() && !qi.isZero() ? "-" + yi : yi;
      }, ke.toFraction = function(ri) {
        var Tr, yi, ki, qi, C, l, w, n, a, b, P, K, pe = this, Ce = pe.d, Me = pe.constructor;
        if (!Ce) return new Me(pe);
        if (a = yi = new Me(1), ki = n = new Me(0), Tr = new Me(ki), C = Tr.e = qr(Ce) - pe.e - 1, l = C % ve, Tr.d[0] = Ee(10, l < 0 ? ve + l : l), ri == null)
          ri = C > 0 ? Tr : a;
        else {
          if (w = new Me(ri), !w.isInt() || w.lt(a)) throw Error(L + w);
          ri = w.gt(Tr) ? C > 0 ? Tr : a : w;
        }
        for (M = !1, w = new Me(xe(Ce)), b = Me.precision, Me.precision = C = Ce.length * ve * 2; P = er(w, Tr, 0, 1, 1), qi = yi.plus(P.times(ki)), qi.cmp(ri) != 1; )
          yi = ki, ki = qi, qi = a, a = n.plus(P.times(qi)), n = qi, qi = Tr, Tr = w.minus(P.times(qi)), w = qi;
        return qi = er(ri.minus(yi), ki, 0, 1, 1), n = n.plus(qi.times(a)), yi = yi.plus(qi.times(ki)), n.s = a.s = pe.s, K = er(a, ki, C, 1).minus(pe).abs().cmp(er(n, yi, C, 1).minus(pe).abs()) < 1 ? [a, ki] : [n, yi], Me.precision = b, M = !0, K;
      }, ke.toHexadecimal = ke.toHex = function(ri, Tr) {
        return Wr(this, 16, ri, Tr);
      }, ke.toNearest = function(ri, Tr) {
        var yi = this, ki = yi.constructor;
        if (yi = new ki(yi), ri == null) {
          if (!yi.d) return yi;
          ri = new ki(1), Tr = ki.rounding;
        } else {
          if (ri = new ki(ri), Tr === void 0 ? Tr = ki.rounding : Ne(Tr, 0, 8), !yi.d) return ri.s ? yi : ri;
          if (!ri.d)
            return ri.s && (ri.s = yi.s), ri;
        }
        return ri.d[0] ? (M = !1, yi = er(yi, ri, 0, Tr, 1).times(ri), M = !0, xt(yi)) : (ri.s = yi.s, yi = ri), yi;
      }, ke.toNumber = function() {
        return +this;
      }, ke.toOctal = function(ri, Tr) {
        return Wr(this, 8, ri, Tr);
      }, ke.toPower = ke.pow = function(ri) {
        var Tr, yi, ki, qi, C, l, w = this, n = w.constructor, a = +(ri = new n(ri));
        if (!w.d || !ri.d || !w.d[0] || !ri.d[0]) return new n(Ee(+w, a));
        if (w = new n(w), w.eq(1)) return w;
        if (ki = n.precision, C = n.rounding, ri.eq(1)) return xt(w, ki, C);
        if (Tr = Ie(ri.e / ve), Tr >= ri.d.length - 1 && (yi = a < 0 ? -a : a) <= Fe)
          return qi = Dr(n, w, yi, ki), ri.s < 0 ? new n(1).div(qi) : xt(qi, ki, C);
        if (l = w.s, l < 0) {
          if (Tr < ri.d.length - 1) return new n(NaN);
          if ((ri.d[Tr] & 1) == 0 && (l = 1), w.e == 0 && w.d[0] == 1 && w.d.length == 1)
            return w.s = l, w;
        }
        return yi = Ee(+w, a), Tr = yi == 0 || !isFinite(yi) ? Ie(a * (Math.log("0." + xe(w.d)) / Math.LN10 + w.e + 1)) : new n(yi + "").e, Tr > n.maxE + 1 || Tr < n.minE - 1 ? new n(Tr > 0 ? l / 0 : 0) : (M = !1, n.rounding = w.s = 1, yi = Math.min(12, (Tr + "").length), qi = Vr(ri.times(Ur(w, ki + yi)), ki), qi.d && (qi = xt(qi, ki + 5, 1), Et(qi.d, ki, C) && (Tr = ki + 10, qi = xt(Vr(ri.times(Ur(w, Tr + yi)), Tr), Tr + 5, 1), +xe(qi.d).slice(ki + 1, ki + 15) + 1 == 1e14 && (qi = xt(qi, ki + 1, 0)))), qi.s = l, M = !0, n.rounding = C, xt(qi, ki, C));
      }, ke.toPrecision = function(ri, Tr) {
        var yi, ki = this, qi = ki.constructor;
        return ri === void 0 ? yi = ir(ki, ki.e <= qi.toExpNeg || ki.e >= qi.toExpPos) : (Ne(ri, 1, y), Tr === void 0 ? Tr = qi.rounding : Ne(Tr, 0, 8), ki = xt(new qi(ki), ri, Tr), yi = ir(ki, ri <= ki.e || ki.e <= qi.toExpNeg, ri)), ki.isNeg() && !ki.isZero() ? "-" + yi : yi;
      }, ke.toSignificantDigits = ke.toSD = function(ri, Tr) {
        var yi = this, ki = yi.constructor;
        return ri === void 0 ? (ri = ki.precision, Tr = ki.rounding) : (Ne(ri, 1, y), Tr === void 0 ? Tr = ki.rounding : Ne(Tr, 0, 8)), xt(new ki(yi), ri, Tr);
      }, ke.toString = function() {
        var ri = this, Tr = ri.constructor, yi = ir(ri, ri.e <= Tr.toExpNeg || ri.e >= Tr.toExpPos);
        return ri.isNeg() && !ri.isZero() ? "-" + yi : yi;
      }, ke.truncated = ke.trunc = function() {
        return xt(new this.constructor(this), this.e + 1, 1);
      }, ke.valueOf = ke.toJSON = function() {
        var ri = this, Tr = ri.constructor, yi = ir(ri, ri.e <= Tr.toExpNeg || ri.e >= Tr.toExpPos);
        return ri.isNeg() ? "-" + yi : yi;
      };
      function xe(ri) {
        var Tr, yi, ki, qi = ri.length - 1, C = "", l = ri[0];
        if (qi > 0) {
          for (C += l, Tr = 1; Tr < qi; Tr++)
            ki = ri[Tr] + "", yi = ve - ki.length, yi && (C += Mr(yi)), C += ki;
          l = ri[Tr], ki = l + "", yi = ve - ki.length, yi && (C += Mr(yi));
        } else if (l === 0)
          return "0";
        for (; l % 10 === 0; ) l /= 10;
        return C + l;
      }
      function Ne(ri, Tr, yi) {
        if (ri !== ~~ri || ri < Tr || ri > yi)
          throw Error(L + ri);
      }
      function Et(ri, Tr, yi, ki) {
        var qi, C, l, w;
        for (C = ri[0]; C >= 10; C /= 10) --Tr;
        return --Tr < 0 ? (Tr += ve, qi = 0) : (qi = Math.ceil((Tr + 1) / ve), Tr %= ve), C = Ee(10, ve - Tr), w = ri[qi] % C | 0, ki == null ? Tr < 3 ? (Tr == 0 ? w = w / 100 | 0 : Tr == 1 && (w = w / 10 | 0), l = yi < 4 && w == 99999 || yi > 3 && w == 49999 || w == 5e4 || w == 0) : l = (yi < 4 && w + 1 == C || yi > 3 && w + 1 == C / 2) && (ri[qi + 1] / C / 100 | 0) == Ee(10, Tr - 2) - 1 || (w == C / 2 || w == 0) && (ri[qi + 1] / C / 100 | 0) == 0 : Tr < 4 ? (Tr == 0 ? w = w / 1e3 | 0 : Tr == 1 ? w = w / 100 | 0 : Tr == 2 && (w = w / 10 | 0), l = (ki || yi < 4) && w == 9999 || !ki && yi > 3 && w == 4999) : l = ((ki || yi < 4) && w + 1 == C || !ki && yi > 3 && w + 1 == C / 2) && (ri[qi + 1] / C / 1e3 | 0) == Ee(10, Tr - 3) - 1, l;
      }
      function st(ri, Tr, yi) {
        for (var ki, qi = [0], C, l = 0, w = ri.length; l < w; ) {
          for (C = qi.length; C--; ) qi[C] *= Tr;
          for (qi[0] += t.indexOf(ri.charAt(l++)), ki = 0; ki < qi.length; ki++)
            qi[ki] > yi - 1 && (qi[ki + 1] === void 0 && (qi[ki + 1] = 0), qi[ki + 1] += qi[ki] / yi | 0, qi[ki] %= yi);
        }
        return qi.reverse();
      }
      function Dt(ri, Tr) {
        var yi, ki, qi;
        if (Tr.isZero()) return Tr;
        ki = Tr.d.length, ki < 32 ? (yi = Math.ceil(ki / 3), qi = (1 / cr(4, yi)).toString()) : (yi = 16, qi = "2.3283064365386962890625e-10"), ri.precision += yi, Tr = Ar(ri, 1, Tr.times(qi), new ri(1));
        for (var C = yi; C--; ) {
          var l = Tr.times(Tr);
          Tr = l.times(l).minus(l).times(8).plus(1);
        }
        return ri.precision -= yi, Tr;
      }
      var er = /* @__PURE__ */ function() {
        function ri(ki, qi, C) {
          var l, w = 0, n = ki.length;
          for (ki = ki.slice(); n--; )
            l = ki[n] * qi + w, ki[n] = l % C | 0, w = l / C | 0;
          return w && ki.unshift(w), ki;
        }
        function Tr(ki, qi, C, l) {
          var w, n;
          if (C != l)
            n = C > l ? 1 : -1;
          else
            for (w = n = 0; w < C; w++)
              if (ki[w] != qi[w]) {
                n = ki[w] > qi[w] ? 1 : -1;
                break;
              }
          return n;
        }
        function yi(ki, qi, C, l) {
          for (var w = 0; C--; )
            ki[C] -= w, w = ki[C] < qi[C] ? 1 : 0, ki[C] = w * l + ki[C] - qi[C];
          for (; !ki[0] && ki.length > 1; ) ki.shift();
        }
        return function(ki, qi, C, l, w, n) {
          var a, b, P, K, pe, Ce, Me, Tt, tr, nr, or, lr, gr, kr, Nr, jr, Yr, ei, ai, ui, di = ki.constructor, Ii = ki.s == qi.s ? 1 : -1, wi = ki.d, Ei = qi.d;
          if (!wi || !wi[0] || !Ei || !Ei[0])
            return new di(
              // Return NaN if either NaN, or both Infinity or 0.
              !ki.s || !qi.s || (wi ? Ei && wi[0] == Ei[0] : !Ei) ? NaN : (
                // Return ±0 if x is 0 or y is ±Infinity, or return ±Infinity as y is 0.
                wi && wi[0] == 0 || !Ei ? Ii * 0 : Ii / 0
              )
            );
          for (n ? (pe = 1, b = ki.e - qi.e) : (n = De, pe = ve, b = Ie(ki.e / pe) - Ie(qi.e / pe)), ai = Ei.length, Yr = wi.length, tr = new di(Ii), nr = tr.d = [], P = 0; Ei[P] == (wi[P] || 0); P++) ;
          if (Ei[P] > (wi[P] || 0) && b--, C == null ? (kr = C = di.precision, l = di.rounding) : w ? kr = C + (ki.e - qi.e) + 1 : kr = C, kr < 0)
            nr.push(1), Ce = !0;
          else {
            if (kr = kr / pe + 2 | 0, P = 0, ai == 1) {
              for (K = 0, Ei = Ei[0], kr++; (P < Yr || K) && kr--; P++)
                Nr = K * n + (wi[P] || 0), nr[P] = Nr / Ei | 0, K = Nr % Ei | 0;
              Ce = K || P < Yr;
            } else {
              for (K = n / (Ei[0] + 1) | 0, K > 1 && (Ei = ri(Ei, K, n), wi = ri(wi, K, n), ai = Ei.length, Yr = wi.length), jr = ai, or = wi.slice(0, ai), lr = or.length; lr < ai; ) or[lr++] = 0;
              ui = Ei.slice(), ui.unshift(0), ei = Ei[0], Ei[1] >= n / 2 && ++ei;
              do
                K = 0, a = Tr(Ei, or, ai, lr), a < 0 ? (gr = or[0], ai != lr && (gr = gr * n + (or[1] || 0)), K = gr / ei | 0, K > 1 ? (K >= n && (K = n - 1), Me = ri(Ei, K, n), Tt = Me.length, lr = or.length, a = Tr(Me, or, Tt, lr), a == 1 && (K--, yi(Me, ai < Tt ? ui : Ei, Tt, n))) : (K == 0 && (a = K = 1), Me = Ei.slice()), Tt = Me.length, Tt < lr && Me.unshift(0), yi(or, Me, lr, n), a == -1 && (lr = or.length, a = Tr(Ei, or, ai, lr), a < 1 && (K++, yi(or, ai < lr ? ui : Ei, lr, n))), lr = or.length) : a === 0 && (K++, or = [0]), nr[P++] = K, a && or[0] ? or[lr++] = wi[jr] || 0 : (or = [wi[jr]], lr = 1);
              while ((jr++ < Yr || or[0] !== void 0) && kr--);
              Ce = or[0] !== void 0;
            }
            nr[0] || nr.shift();
          }
          if (pe == 1)
            tr.e = b, x = Ce;
          else {
            for (P = 1, K = nr[0]; K >= 10; K /= 10) P++;
            tr.e = P + b * pe - 1, xt(tr, w ? C + tr.e + 1 : C, l, Ce);
          }
          return tr;
        };
      }();
      function xt(ri, Tr, yi, ki) {
        var qi, C, l, w, n, a, b, P, K, pe = ri.constructor;
        e: if (Tr != null) {
          if (P = ri.d, !P) return ri;
          for (qi = 1, w = P[0]; w >= 10; w /= 10) qi++;
          if (C = Tr - qi, C < 0)
            C += ve, l = Tr, b = P[K = 0], n = b / Ee(10, qi - l - 1) % 10 | 0;
          else if (K = Math.ceil((C + 1) / ve), w = P.length, K >= w)
            if (ki) {
              for (; w++ <= K; ) P.push(0);
              b = n = 0, qi = 1, C %= ve, l = C - ve + 1;
            } else
              break e;
          else {
            for (b = w = P[K], qi = 1; w >= 10; w /= 10) qi++;
            C %= ve, l = C - ve + qi, n = l < 0 ? 0 : b / Ee(10, qi - l - 1) % 10 | 0;
          }
          if (ki = ki || Tr < 0 || P[K + 1] !== void 0 || (l < 0 ? b : b % Ee(10, qi - l - 1)), a = yi < 4 ? (n || ki) && (yi == 0 || yi == (ri.s < 0 ? 3 : 2)) : n > 5 || n == 5 && (yi == 4 || ki || yi == 6 && // Check whether the digit to the left of the rounding digit is odd.
          (C > 0 ? l > 0 ? b / Ee(10, qi - l) : 0 : P[K - 1]) % 10 & 1 || yi == (ri.s < 0 ? 8 : 7)), Tr < 1 || !P[0])
            return P.length = 0, a ? (Tr -= ri.e + 1, P[0] = Ee(10, (ve - Tr % ve) % ve), ri.e = -Tr || 0) : P[0] = ri.e = 0, ri;
          if (C == 0 ? (P.length = K, w = 1, K--) : (P.length = K + 1, w = Ee(10, ve - C), P[K] = l > 0 ? (b / Ee(10, qi - l) % Ee(10, l) | 0) * w : 0), a)
            for (; ; )
              if (K == 0) {
                for (C = 1, l = P[0]; l >= 10; l /= 10) C++;
                for (l = P[0] += w, w = 1; l >= 10; l /= 10) w++;
                C != w && (ri.e++, P[0] == De && (P[0] = 1));
                break;
              } else {
                if (P[K] += w, P[K] != De) break;
                P[K--] = 0, w = 1;
              }
          for (C = P.length; P[--C] === 0; ) P.pop();
        }
        return M && (ri.e > pe.maxE ? (ri.d = null, ri.e = NaN) : ri.e < pe.minE && (ri.e = 0, ri.d = [0])), ri;
      }
      function ir(ri, Tr, yi) {
        if (!ri.isFinite()) return Sr(ri);
        var ki, qi = ri.e, C = xe(ri.d), l = C.length;
        return Tr ? (yi && (ki = yi - l) > 0 ? C = C.charAt(0) + "." + C.slice(1) + Mr(ki) : l > 1 && (C = C.charAt(0) + "." + C.slice(1)), C = C + (ri.e < 0 ? "e" : "e+") + ri.e) : qi < 0 ? (C = "0." + Mr(-qi - 1) + C, yi && (ki = yi - l) > 0 && (C += Mr(ki))) : qi >= l ? (C += Mr(qi + 1 - l), yi && (ki = yi - qi - 1) > 0 && (C = C + "." + Mr(ki))) : ((ki = qi + 1) < l && (C = C.slice(0, ki) + "." + C.slice(ki)), yi && (ki = yi - l) > 0 && (qi + 1 === l && (C += "."), C += Mr(ki))), C;
      }
      function sr(ri, Tr) {
        var yi = ri[0];
        for (Tr *= ve; yi >= 10; yi /= 10) Tr++;
        return Tr;
      }
      function yr(ri, Tr, yi) {
        if (Tr > be)
          throw M = !0, yi && (ri.precision = yi), Error(H);
        return xt(new ri(d), Tr, 1, !0);
      }
      function wr(ri, Tr, yi) {
        if (Tr > Be) throw Error(H);
        return xt(new ri(E), Tr, yi, !0);
      }
      function qr(ri) {
        var Tr = ri.length - 1, yi = Tr * ve + 1;
        if (Tr = ri[Tr], Tr) {
          for (; Tr % 10 == 0; Tr /= 10) yi--;
          for (Tr = ri[0]; Tr >= 10; Tr /= 10) yi++;
        }
        return yi;
      }
      function Mr(ri) {
        for (var Tr = ""; ri--; ) Tr += "0";
        return Tr;
      }
      function Dr(ri, Tr, yi, ki) {
        var qi, C = new ri(1), l = Math.ceil(ki / ve + 4);
        for (M = !1; ; ) {
          if (yi % 2 && (C = C.times(Tr), fi(C.d, l) && (qi = !0)), yi = Ie(yi / 2), yi === 0) {
            yi = C.d.length - 1, qi && C.d[yi] === 0 && ++C.d[yi];
            break;
          }
          Tr = Tr.times(Tr), fi(Tr.d, l);
        }
        return M = !0, C;
      }
      function Qr(ri) {
        return ri.d[ri.d.length - 1] & 1;
      }
      function Xr(ri, Tr, yi) {
        for (var ki, qi, C = new ri(Tr[0]), l = 0; ++l < Tr.length; ) {
          if (qi = new ri(Tr[l]), !qi.s) {
            C = qi;
            break;
          }
          ki = C.cmp(qi), (ki === yi || ki === 0 && C.s === yi) && (C = qi);
        }
        return C;
      }
      function Vr(ri, Tr) {
        var yi, ki, qi, C, l, w, n, a = 0, b = 0, P = 0, K = ri.constructor, pe = K.rounding, Ce = K.precision;
        if (!ri.d || !ri.d[0] || ri.e > 17)
          return new K(ri.d ? ri.d[0] ? ri.s < 0 ? 0 : 1 / 0 : 1 : ri.s ? ri.s < 0 ? 0 : ri : NaN);
        for (Tr == null ? (M = !1, n = Ce) : n = Tr, w = new K(0.03125); ri.e > -2; )
          ri = ri.times(w), P += 5;
        for (ki = Math.log(Ee(2, P)) / Math.LN10 * 2 + 5 | 0, n += ki, yi = C = l = new K(1), K.precision = n; ; ) {
          if (C = xt(C.times(ri), n, 1), yi = yi.times(++b), w = l.plus(er(C, yi, n, 1)), xe(w.d).slice(0, n) === xe(l.d).slice(0, n)) {
            for (qi = P; qi--; ) l = xt(l.times(l), n, 1);
            if (Tr == null)
              if (a < 3 && Et(l.d, n - ki, pe, a))
                K.precision = n += 10, yi = C = w = new K(1), b = 0, a++;
              else
                return xt(l, K.precision = Ce, pe, M = !0);
            else
              return K.precision = Ce, l;
          }
          l = w;
        }
      }
      function Ur(ri, Tr) {
        var yi, ki, qi, C, l, w, n, a, b, P, K, pe = 1, Ce = 10, Me = ri, Tt = Me.d, tr = Me.constructor, nr = tr.rounding, or = tr.precision;
        if (Me.s < 0 || !Tt || !Tt[0] || !Me.e && Tt[0] == 1 && Tt.length == 1)
          return new tr(Tt && !Tt[0] ? -1 / 0 : Me.s != 1 ? NaN : Tt ? 0 : Me);
        if (Tr == null ? (M = !1, b = or) : b = Tr, tr.precision = b += Ce, yi = xe(Tt), ki = yi.charAt(0), Math.abs(C = Me.e) < 15e14) {
          for (; ki < 7 && ki != 1 || ki == 1 && yi.charAt(1) > 3; )
            Me = Me.times(ri), yi = xe(Me.d), ki = yi.charAt(0), pe++;
          C = Me.e, ki > 1 ? (Me = new tr("0." + yi), C++) : Me = new tr(ki + "." + yi.slice(1));
        } else
          return a = yr(tr, b + 2, or).times(C + ""), Me = Ur(new tr(ki + "." + yi.slice(1)), b - Ce).plus(a), tr.precision = or, Tr == null ? xt(Me, or, nr, M = !0) : Me;
        for (P = Me, n = l = Me = er(Me.minus(1), Me.plus(1), b, 1), K = xt(Me.times(Me), b, 1), qi = 3; ; ) {
          if (l = xt(l.times(K), b, 1), a = n.plus(er(l, new tr(qi), b, 1)), xe(a.d).slice(0, b) === xe(n.d).slice(0, b))
            if (n = n.times(2), C !== 0 && (n = n.plus(yr(tr, b + 2, or).times(C + ""))), n = er(n, new tr(pe), b, 1), Tr == null)
              if (Et(n.d, b - Ce, nr, w))
                tr.precision = b += Ce, a = l = Me = er(P.minus(1), P.plus(1), b, 1), K = xt(Me.times(Me), b, 1), qi = w = 1;
              else
                return xt(n, tr.precision = or, nr, M = !0);
            else
              return tr.precision = or, n;
          n = a, qi += 2;
        }
      }
      function Sr(ri) {
        return String(ri.s * ri.s / 0);
      }
      function Gr(ri, Tr) {
        var yi, ki, qi;
        for ((yi = Tr.indexOf(".")) > -1 && (Tr = Tr.replace(".", "")), (ki = Tr.search(/e/i)) > 0 ? (yi < 0 && (yi = ki), yi += +Tr.slice(ki + 1), Tr = Tr.substring(0, ki)) : yi < 0 && (yi = Tr.length), ki = 0; Tr.charCodeAt(ki) === 48; ki++) ;
        for (qi = Tr.length; Tr.charCodeAt(qi - 1) === 48; --qi) ;
        if (Tr = Tr.slice(ki, qi), Tr) {
          if (qi -= ki, ri.e = yi = yi - ki - 1, ri.d = [], ki = (yi + 1) % ve, yi < 0 && (ki += ve), ki < qi) {
            for (ki && ri.d.push(+Tr.slice(0, ki)), qi -= ve; ki < qi; ) ri.d.push(+Tr.slice(ki, ki += ve));
            Tr = Tr.slice(ki), ki = ve - Tr.length;
          } else
            ki -= qi;
          for (; ki--; ) Tr += "0";
          ri.d.push(+Tr), M && (ri.e > ri.constructor.maxE ? (ri.d = null, ri.e = NaN) : ri.e < ri.constructor.minE && (ri.e = 0, ri.d = [0]));
        } else
          ri.e = 0, ri.d = [0];
        return ri;
      }
      function Fr(ri, Tr) {
        var yi, ki, qi, C, l, w, n, a, b;
        if (Tr.indexOf("_") > -1) {
          if (Tr = Tr.replace(/(\d)_(?=\d)/g, "$1"), Pe.test(Tr)) return Gr(ri, Tr);
        } else if (Tr === "Infinity" || Tr === "NaN")
          return +Tr || (ri.s = NaN), ri.e = NaN, ri.d = null, ri;
        if (ze.test(Tr))
          yi = 16, Tr = Tr.toLowerCase();
        else if (Se.test(Tr))
          yi = 2;
        else if (He.test(Tr))
          yi = 8;
        else
          throw Error(L + Tr);
        for (C = Tr.search(/p/i), C > 0 ? (n = +Tr.slice(C + 1), Tr = Tr.substring(2, C)) : Tr = Tr.slice(2), C = Tr.indexOf("."), l = C >= 0, ki = ri.constructor, l && (Tr = Tr.replace(".", ""), w = Tr.length, C = w - C, qi = Dr(ki, new ki(yi), C, C * 2)), a = st(Tr, yi, De), b = a.length - 1, C = b; a[C] === 0; --C) a.pop();
        return C < 0 ? new ki(ri.s * 0) : (ri.e = sr(a, b), ri.d = a, M = !1, l && (ri = er(ri, qi, w * 4)), n && (ri = ri.times(Math.abs(n) < 54 ? Ee(2, n) : D.pow(2, n))), M = !0, ri);
      }
      function br(ri, Tr) {
        var yi, ki = Tr.d.length;
        if (ki < 3)
          return Tr.isZero() ? Tr : Ar(ri, 2, Tr, Tr);
        yi = 1.4 * Math.sqrt(ki), yi = yi > 16 ? 16 : yi | 0, Tr = Tr.times(1 / cr(5, yi)), Tr = Ar(ri, 2, Tr, Tr);
        for (var qi, C = new ri(5), l = new ri(16), w = new ri(20); yi--; )
          qi = Tr.times(Tr), Tr = Tr.times(C.plus(qi.times(l.times(qi).minus(w))));
        return Tr;
      }
      function Ar(ri, Tr, yi, ki, qi) {
        var C, l, w, n, a = ri.precision, b = Math.ceil(a / ve);
        for (M = !1, n = yi.times(yi), w = new ri(ki); ; ) {
          if (l = er(w.times(n), new ri(Tr++ * Tr++), a, 1), w = qi ? ki.plus(l) : ki.minus(l), ki = er(l.times(n), new ri(Tr++ * Tr++), a, 1), l = w.plus(ki), l.d[b] !== void 0) {
            for (C = b; l.d[C] === w.d[C] && C--; ) ;
            if (C == -1) break;
          }
          C = w, w = ki, ki = l, l = C;
        }
        return M = !0, l.d.length = b + 1, l;
      }
      function cr(ri, Tr) {
        for (var yi = ri; --Tr; ) yi *= ri;
        return yi;
      }
      function hr(ri, Tr) {
        var yi, ki = Tr.s < 0, qi = wr(ri, ri.precision, 1), C = qi.times(0.5);
        if (Tr = Tr.abs(), Tr.lte(C))
          return F = ki ? 4 : 1, Tr;
        if (yi = Tr.divToInt(qi), yi.isZero())
          F = ki ? 3 : 2;
        else {
          if (Tr = Tr.minus(yi.times(qi)), Tr.lte(C))
            return F = Qr(yi) ? ki ? 2 : 3 : ki ? 4 : 1, Tr;
          F = Qr(yi) ? ki ? 1 : 4 : ki ? 3 : 2;
        }
        return Tr.minus(qi).abs();
      }
      function Wr(ri, Tr, yi, ki) {
        var qi, C, l, w, n, a, b, P, K, pe = ri.constructor, Ce = yi !== void 0;
        if (Ce ? (Ne(yi, 1, y), ki === void 0 ? ki = pe.rounding : Ne(ki, 0, 8)) : (yi = pe.precision, ki = pe.rounding), !ri.isFinite())
          b = Sr(ri);
        else {
          for (b = ir(ri), l = b.indexOf("."), Ce ? (qi = 2, Tr == 16 ? yi = yi * 4 - 3 : Tr == 8 && (yi = yi * 3 - 2)) : qi = Tr, l >= 0 && (b = b.replace(".", ""), K = new pe(1), K.e = b.length - l, K.d = st(ir(K), 10, qi), K.e = K.d.length), P = st(b, 10, qi), C = n = P.length; P[--n] == 0; ) P.pop();
          if (!P[0])
            b = Ce ? "0p+0" : "0";
          else {
            if (l < 0 ? C-- : (ri = new pe(ri), ri.d = P, ri.e = C, ri = er(ri, K, yi, ki, 0, qi), P = ri.d, C = ri.e, a = x), l = P[yi], w = qi / 2, a = a || P[yi + 1] !== void 0, a = ki < 4 ? (l !== void 0 || a) && (ki === 0 || ki === (ri.s < 0 ? 3 : 2)) : l > w || l === w && (ki === 4 || a || ki === 6 && P[yi - 1] & 1 || ki === (ri.s < 0 ? 8 : 7)), P.length = yi, a)
              for (; ++P[--yi] > qi - 1; )
                P[yi] = 0, yi || (++C, P.unshift(1));
            for (n = P.length; !P[n - 1]; --n) ;
            for (l = 0, b = ""; l < n; l++) b += t.charAt(P[l]);
            if (Ce) {
              if (n > 1)
                if (Tr == 16 || Tr == 8) {
                  for (l = Tr == 16 ? 4 : 3, --n; n % l; n++) b += "0";
                  for (P = st(b, qi, Tr), n = P.length; !P[n - 1]; --n) ;
                  for (l = 1, b = "1."; l < n; l++) b += t.charAt(P[l]);
                } else
                  b = b.charAt(0) + "." + b.slice(1);
              b = b + (C < 0 ? "p" : "p+") + C;
            } else if (C < 0) {
              for (; ++C; ) b = "0" + b;
              b = "0." + b;
            } else if (++C > n) for (C -= n; C--; ) b += "0";
            else C < n && (b = b.slice(0, C) + "." + b.slice(C));
          }
          b = (Tr == 16 ? "0x" : Tr == 2 ? "0b" : Tr == 8 ? "0o" : "") + b;
        }
        return ri.s < 0 ? "-" + b : b;
      }
      function fi(ri, Tr) {
        if (ri.length > Tr)
          return ri.length = Tr, !0;
      }
      function Bi(ri) {
        return new this(ri).abs();
      }
      function $r(ri) {
        return new this(ri).acos();
      }
      function oi(ri) {
        return new this(ri).acosh();
      }
      function zr(ri, Tr) {
        return new this(ri).plus(Tr);
      }
      function ti(ri) {
        return new this(ri).asin();
      }
      function Lr(ri) {
        return new this(ri).asinh();
      }
      function Rr(ri) {
        return new this(ri).atan();
      }
      function Ir(ri) {
        return new this(ri).atanh();
      }
      function pr(ri, Tr) {
        ri = new this(ri), Tr = new this(Tr);
        var yi, ki = this.precision, qi = this.rounding, C = ki + 4;
        return !ri.s || !Tr.s ? yi = new this(NaN) : !ri.d && !Tr.d ? (yi = wr(this, C, 1).times(Tr.s > 0 ? 0.25 : 0.75), yi.s = ri.s) : !Tr.d || ri.isZero() ? (yi = Tr.s < 0 ? wr(this, ki, qi) : new this(0), yi.s = ri.s) : !ri.d || Tr.isZero() ? (yi = wr(this, C, 1).times(0.5), yi.s = ri.s) : Tr.s < 0 ? (this.precision = C, this.rounding = 1, yi = this.atan(er(ri, Tr, C, 1)), Tr = wr(this, C, 1), this.precision = ki, this.rounding = qi, yi = ri.s < 0 ? yi.minus(Tr) : yi.plus(Tr)) : yi = this.atan(er(ri, Tr, C, 1)), yi;
      }
      function Cr(ri) {
        return new this(ri).cbrt();
      }
      function Er(ri) {
        return xt(ri = new this(ri), ri.e + 1, 2);
      }
      function xr(ri, Tr, yi) {
        return new this(ri).clamp(Tr, yi);
      }
      function si(ri) {
        if (!ri || typeof ri != "object") throw Error(U + "Object expected");
        var Tr, yi, ki, qi = ri.defaults === !0, C = [
          "precision",
          1,
          y,
          "rounding",
          0,
          8,
          "toExpNeg",
          -c,
          0,
          "toExpPos",
          0,
          c,
          "maxE",
          0,
          c,
          "minE",
          -c,
          0,
          "modulo",
          0,
          9
        ];
        for (Tr = 0; Tr < C.length; Tr += 3)
          if (yi = C[Tr], qi && (this[yi] = B[yi]), (ki = ri[yi]) !== void 0)
            if (Ie(ki) === ki && ki >= C[Tr + 1] && ki <= C[Tr + 2]) this[yi] = ki;
            else throw Error(L + yi + ": " + ki);
        if (yi = "crypto", qi && (this[yi] = B[yi]), (ki = ri[yi]) !== void 0)
          if (ki === !0 || ki === !1 || ki === 0 || ki === 1)
            if (ki)
              if (typeof crypto < "u" && crypto && (crypto.getRandomValues || crypto.randomBytes))
                this[yi] = !0;
              else
                throw Error(fe);
            else
              this[yi] = !1;
          else
            throw Error(L + yi + ": " + ki);
        return this;
      }
      function Ci(ri) {
        return new this(ri).cos();
      }
      function bi(ri) {
        return new this(ri).cosh();
      }
      function Ri(ri) {
        var Tr, yi, ki;
        function qi(C) {
          var l, w, n, a = this;
          if (!(a instanceof qi)) return new qi(C);
          if (a.constructor = qi, os(C)) {
            a.s = C.s, M ? !C.d || C.e > qi.maxE ? (a.e = NaN, a.d = null) : C.e < qi.minE ? (a.e = 0, a.d = [0]) : (a.e = C.e, a.d = C.d.slice()) : (a.e = C.e, a.d = C.d ? C.d.slice() : C.d);
            return;
          }
          if (n = typeof C, n === "number") {
            if (C === 0) {
              a.s = 1 / C < 0 ? -1 : 1, a.e = 0, a.d = [0];
              return;
            }
            if (C < 0 ? (C = -C, a.s = -1) : a.s = 1, C === ~~C && C < 1e7) {
              for (l = 0, w = C; w >= 10; w /= 10) l++;
              M ? l > qi.maxE ? (a.e = NaN, a.d = null) : l < qi.minE ? (a.e = 0, a.d = [0]) : (a.e = l, a.d = [C]) : (a.e = l, a.d = [C]);
              return;
            }
            if (C * 0 !== 0) {
              C || (a.s = NaN), a.e = NaN, a.d = null;
              return;
            }
            return Gr(a, C.toString());
          }
          if (n === "string")
            return (w = C.charCodeAt(0)) === 45 ? (C = C.slice(1), a.s = -1) : (w === 43 && (C = C.slice(1)), a.s = 1), Pe.test(C) ? Gr(a, C) : Fr(a, C);
          if (n === "bigint")
            return C < 0 ? (C = -C, a.s = -1) : a.s = 1, Gr(a, C.toString());
          throw Error(L + C);
        }
        if (qi.prototype = ke, qi.ROUND_UP = 0, qi.ROUND_DOWN = 1, qi.ROUND_CEIL = 2, qi.ROUND_FLOOR = 3, qi.ROUND_HALF_UP = 4, qi.ROUND_HALF_DOWN = 5, qi.ROUND_HALF_EVEN = 6, qi.ROUND_HALF_CEIL = 7, qi.ROUND_HALF_FLOOR = 8, qi.EUCLID = 9, qi.config = qi.set = si, qi.clone = Ri, qi.isDecimal = os, qi.abs = Bi, qi.acos = $r, qi.acosh = oi, qi.add = zr, qi.asin = ti, qi.asinh = Lr, qi.atan = Rr, qi.atanh = Ir, qi.atan2 = pr, qi.cbrt = Cr, qi.ceil = Er, qi.clamp = xr, qi.cos = Ci, qi.cosh = bi, qi.div = li, qi.exp = zi, qi.floor = Kn, qi.hypot = Hn, qi.ln = ts, qi.log = Gs, qi.log10 = Gn, qi.log2 = Wn, qi.max = ro, qi.min = Fs, qi.mod = ii, qi.mul = Ai, qi.pow = ci, qi.random = Si, qi.round = Ui, qi.sign = _i, qi.sin = Tn, qi.sinh = Fn, qi.sqrt = ss, qi.sub = rs, qi.sum = is, qi.tan = Pr, qi.tanh = as, qi.trunc = Rs, ri === void 0 && (ri = {}), ri && ri.defaults !== !0)
          for (ki = ["precision", "rounding", "toExpNeg", "toExpPos", "maxE", "minE", "modulo", "crypto"], Tr = 0; Tr < ki.length; ) ri.hasOwnProperty(yi = ki[Tr++]) || (ri[yi] = this[yi]);
        return qi.config(ri), qi;
      }
      function li(ri, Tr) {
        return new this(ri).div(Tr);
      }
      function zi(ri) {
        return new this(ri).exp();
      }
      function Kn(ri) {
        return xt(ri = new this(ri), ri.e + 1, 3);
      }
      function Hn() {
        var ri, Tr, yi = new this(0);
        for (M = !1, ri = 0; ri < arguments.length; )
          if (Tr = new this(arguments[ri++]), Tr.d)
            yi.d && (yi = yi.plus(Tr.times(Tr)));
          else {
            if (Tr.s)
              return M = !0, new this(1 / 0);
            yi = Tr;
          }
        return M = !0, yi.sqrt();
      }
      function os(ri) {
        return ri instanceof D || ri && ri.toStringTag === ge || !1;
      }
      function ts(ri) {
        return new this(ri).ln();
      }
      function Gs(ri, Tr) {
        return new this(ri).log(Tr);
      }
      function Wn(ri) {
        return new this(ri).log(2);
      }
      function Gn(ri) {
        return new this(ri).log(10);
      }
      function ro() {
        return Xr(this, arguments, -1);
      }
      function Fs() {
        return Xr(this, arguments, 1);
      }
      function ii(ri, Tr) {
        return new this(ri).mod(Tr);
      }
      function Ai(ri, Tr) {
        return new this(ri).mul(Tr);
      }
      function ci(ri, Tr) {
        return new this(ri).pow(Tr);
      }
      function Si(ri) {
        var Tr, yi, ki, qi, C = 0, l = new this(1), w = [];
        if (ri === void 0 ? ri = this.precision : Ne(ri, 1, y), ki = Math.ceil(ri / ve), this.crypto)
          if (crypto.getRandomValues)
            for (Tr = crypto.getRandomValues(new Uint32Array(ki)); C < ki; )
              qi = Tr[C], qi >= 429e7 ? Tr[C] = crypto.getRandomValues(new Uint32Array(1))[0] : w[C++] = qi % 1e7;
          else if (crypto.randomBytes) {
            for (Tr = crypto.randomBytes(ki *= 4); C < ki; )
              qi = Tr[C] + (Tr[C + 1] << 8) + (Tr[C + 2] << 16) + ((Tr[C + 3] & 127) << 24), qi >= 214e7 ? crypto.randomBytes(4).copy(Tr, C) : (w.push(qi % 1e7), C += 4);
            C = ki / 4;
          } else
            throw Error(fe);
        else for (; C < ki; ) w[C++] = Math.random() * 1e7 | 0;
        for (ki = w[--C], ri %= ve, ki && ri && (qi = Ee(10, ve - ri), w[C] = (ki / qi | 0) * qi); w[C] === 0; C--) w.pop();
        if (C < 0)
          yi = 0, w = [0];
        else {
          for (yi = -1; w[0] === 0; yi -= ve) w.shift();
          for (ki = 1, qi = w[0]; qi >= 10; qi /= 10) ki++;
          ki < ve && (yi -= ve - ki);
        }
        return l.e = yi, l.d = w, l;
      }
      function Ui(ri) {
        return xt(ri = new this(ri), ri.e + 1, this.rounding);
      }
      function _i(ri) {
        return ri = new this(ri), ri.d ? ri.d[0] ? ri.s : 0 * ri.s : ri.s || NaN;
      }
      function Tn(ri) {
        return new this(ri).sin();
      }
      function Fn(ri) {
        return new this(ri).sinh();
      }
      function ss(ri) {
        return new this(ri).sqrt();
      }
      function rs(ri, Tr) {
        return new this(ri).sub(Tr);
      }
      function is() {
        var ri = 0, Tr = arguments, yi = new this(Tr[ri]);
        for (M = !1; yi.s && ++ri < Tr.length; ) yi = yi.plus(Tr[ri]);
        return M = !0, xt(yi, this.precision, this.rounding);
      }
      function Pr(ri) {
        return new this(ri).tan();
      }
      function as(ri) {
        return new this(ri).tanh();
      }
      function Rs(ri) {
        return xt(ri = new this(ri), ri.e + 1, 1);
      }
      D = Ri(B), D.prototype.constructor = D, D.default = D.Decimal = D, d = new D(d), E = new D(E), o.exports ? (typeof Symbol == "function" && typeof Symbol.iterator == "symbol" && (ke[Symbol.for("nodejs.util.inspect.custom")] = ke.toString, ke[Symbol.toStringTag] = "Decimal"), o.exports = D) : (g || (g = typeof self < "u" && self && self.self == self ? self : window), v = g.Decimal, D.noConflict = function() {
        return g.Decimal = v, D;
      }, g.Decimal = D);
    })(decimal$2);
  }(decimal$3)), decimal$3.exports;
}
var binaryParser = {}, hasRequiredBinaryParser;
function requireBinaryParser() {
  if (hasRequiredBinaryParser) return binaryParser;
  hasRequiredBinaryParser = 1;
  var o = binaryParser && binaryParser.__createBinding || (Object.create ? function(B, D, x, v) {
    v === void 0 && (v = x);
    var F = Object.getOwnPropertyDescriptor(D, x);
    (!F || ("get" in F ? !D.__esModule : F.writable || F.configurable)) && (F = { enumerable: !0, get: function() {
      return D[x];
    } }), Object.defineProperty(B, v, F);
  } : function(B, D, x, v) {
    v === void 0 && (v = x), B[v] = D[x];
  }), g = binaryParser && binaryParser.__setModuleDefault || (Object.create ? function(B, D) {
    Object.defineProperty(B, "default", { enumerable: !0, value: D });
  } : function(B, D) {
    B.default = D;
  }), c = binaryParser && binaryParser.__importStar || function(B) {
    if (B && B.__esModule) return B;
    var D = {};
    if (B != null) for (var x in B) x !== "default" && Object.prototype.hasOwnProperty.call(B, x) && o(D, B, x);
    return g(D, B), D;
  };
  Object.defineProperty(binaryParser, "__esModule", { value: !0 }), binaryParser.BinaryParser = void 0;
  const y = c(requireAssert$2()), t = requireEnums(), d = requireBuffer$2();
  class E {
    /**
     * Initialize bytes to a hex string
     *
     * @param hexBytes a hex string
     * @param definitions Rippled definitions used to parse the values of transaction types and such.
     *                          Can be customized for sidechains and amendments.
     */
    constructor(D, x = t.DEFAULT_DEFINITIONS) {
      this.bytes = d.Buffer.from(D, "hex"), this.definitions = x;
    }
    /**
     * Peek the first byte of the BinaryParser
     *
     * @returns The first byte of the BinaryParser
     */
    peek() {
      return y.ok(this.bytes.byteLength !== 0), this.bytes[0];
    }
    /**
     * Consume the first n bytes of the BinaryParser
     *
     * @param n the number of bytes to skip
     */
    skip(D) {
      y.ok(D <= this.bytes.byteLength), this.bytes = this.bytes.slice(D);
    }
    /**
     * read the first n bytes from the BinaryParser
     *
     * @param n The number of bytes to read
     * @return The bytes
     */
    read(D) {
      y.ok(D <= this.bytes.byteLength);
      const x = this.bytes.slice(0, D);
      return this.skip(D), x;
    }
    /**
     * Read an integer of given size
     *
     * @param n The number of bytes to read
     * @return The number represented by those bytes
     */
    readUIntN(D) {
      return y.ok(0 < D && D <= 4, "invalid n"), this.read(D).reduce((x, v) => x << 8 | v) >>> 0;
    }
    readUInt8() {
      return this.readUIntN(1);
    }
    readUInt16() {
      return this.readUIntN(2);
    }
    readUInt32() {
      return this.readUIntN(4);
    }
    size() {
      return this.bytes.byteLength;
    }
    end(D) {
      const x = this.bytes.byteLength;
      return x === 0 || D !== void 0 && x <= D;
    }
    /**
     * Reads variable length encoded bytes
     *
     * @return The variable length bytes
     */
    readVariableLength() {
      return this.read(this.readVariableLengthLength());
    }
    /**
     * Reads the length of the variable length encoded bytes
     *
     * @return The length of the variable length encoded bytes
     */
    readVariableLengthLength() {
      const D = this.readUInt8();
      if (D <= 192)
        return D;
      if (D <= 240) {
        const x = this.readUInt8();
        return 193 + (D - 193) * 256 + x;
      } else if (D <= 254) {
        const x = this.readUInt8(), v = this.readUInt8();
        return 12481 + (D - 241) * 65536 + x * 256 + v;
      }
      throw new Error("Invalid variable length indicator");
    }
    /**
     * Reads the field ordinal from the BinaryParser
     *
     * @return Field ordinal
     */
    readFieldOrdinal() {
      let D = this.readUInt8(), x = D & 15;
      if (D >>= 4, D === 0 && (D = this.readUInt8(), D === 0 || D < 16))
        throw new Error("Cannot read FieldOrdinal, type_code out of range");
      if (x === 0 && (x = this.readUInt8(), x === 0 || x < 16))
        throw new Error("Cannot read FieldOrdinal, field_code out of range");
      return D << 16 | x;
    }
    /**
     * Read the field from the BinaryParser
     *
     * @return The field represented by the bytes at the head of the BinaryParser
     */
    readField() {
      return this.definitions.field.fromString(this.readFieldOrdinal().toString());
    }
    /**
     * Read a given type from the BinaryParser
     *
     * @param type The type that you want to read from the BinaryParser
     * @return The instance of that type read from the BinaryParser
     */
    readType(D) {
      return D.fromParser(this);
    }
    /**
     * Get the type associated with a given field
     *
     * @param field The field that you wan to get the type of
     * @return The type associated with the given field
     */
    typeForField(D) {
      return D.associatedType;
    }
    /**
     * Read value of the type specified by field from the BinaryParser
     *
     * @param field The field that you want to get the associated value for
     * @return The value associated with the given field
     */
    readFieldValue(D) {
      const x = this.typeForField(D);
      if (!x)
        throw new Error(`unsupported: (${D.name}, ${D.type.name})`);
      const v = D.isVariableLengthEncoded ? this.readVariableLengthLength() : void 0, F = x.fromParser(this, v);
      if (F === void 0)
        throw new Error(`fromParser for (${D.name}, ${D.type.name}) -> undefined `);
      return F;
    }
    /**
     * Get the next field and value from the BinaryParser
     *
     * @return The field and value
     */
    readFieldAndValue() {
      const D = this.readField();
      return [D, this.readFieldValue(D)];
    }
  }
  return binaryParser.BinaryParser = E, binaryParser;
}
var currency$1 = {}, hasRequiredCurrency$1;
function requireCurrency$1() {
  if (hasRequiredCurrency$1) return currency$1;
  hasRequiredCurrency$1 = 1, Object.defineProperty(currency$1, "__esModule", { value: !0 }), currency$1.Currency = void 0;
  const o = requireHash160(), g = requireBuffer$2(), c = /^0{40}$/, y = /^[A-Z0-9a-z?!@#$%^&*(){}[\]|]{3}$/, t = /^[A-F0-9]{40}$/, d = /^0{24}[\x00-\x7F]{6}0{10}$/;
  function E(H) {
    const fe = g.Buffer.alloc(20);
    if (H !== "XRP") {
      const ge = H.split("").map((Ie) => Ie.charCodeAt(0));
      fe.set(ge, 12);
    }
    return fe;
  }
  function B(H) {
    return y.test(H);
  }
  function D(H) {
    const fe = H.toString();
    return fe === "XRP" ? null : B(fe) ? fe : null;
  }
  function x(H) {
    return t.test(H);
  }
  function v(H) {
    return H.length === 3 || x(H);
  }
  function F(H) {
    return H.byteLength === 20;
  }
  function M(H) {
    return H instanceof g.Buffer ? F(H) : v(H);
  }
  function U(H) {
    if (!M(H))
      throw new Error(`Unsupported Currency representation: ${H}`);
    return H.length === 3 ? E(H) : g.Buffer.from(H, "hex");
  }
  class L extends o.Hash160 {
    constructor(fe) {
      super(fe ?? L.XRP.bytes);
      const ge = this.bytes.toString("hex");
      c.test(ge) ? this._iso = "XRP" : d.test(ge) ? this._iso = D(this.bytes.slice(12, 15)) : this._iso = null;
    }
    /**
     * Return the ISO code of this currency
     *
     * @returns ISO code if it exists, else null
     */
    iso() {
      return this._iso;
    }
    /**
     * Constructs a Currency object
     *
     * @param val Currency object or a string representation of a currency
     */
    static from(fe) {
      if (fe instanceof L)
        return fe;
      if (typeof fe == "string")
        return new L(U(fe));
      throw new Error("Cannot construct Currency from value given");
    }
    /**
     * Gets the JSON representation of a currency
     *
     * @returns JSON representation
     */
    toJSON() {
      const fe = this.iso();
      return fe !== null ? fe : this.bytes.toString("hex").toUpperCase();
    }
  }
  return currency$1.Currency = L, L.XRP = new L(g.Buffer.alloc(20)), currency$1;
}
var BigInteger = { exports: {} }, hasRequiredBigInteger;
function requireBigInteger() {
  return hasRequiredBigInteger || (hasRequiredBigInteger = 1, function(o) {
    var g = function(c) {
      var y = 1e7, t = 7, d = 9007199254740992, E = L(d), B = "0123456789abcdefghijklmnopqrstuvwxyz", D = typeof BigInt == "function";
      function x(Lr, Rr, Ir, pr) {
        return typeof Lr > "u" ? x[0] : typeof Rr < "u" ? +Rr == 10 && !Ir ? zr(Lr) : cr(Lr, Rr, Ir, pr) : zr(Lr);
      }
      function v(Lr, Rr) {
        this.value = Lr, this.sign = Rr, this.isSmall = !1;
      }
      v.prototype = Object.create(x.prototype);
      function F(Lr) {
        this.value = Lr, this.sign = Lr < 0, this.isSmall = !0;
      }
      F.prototype = Object.create(x.prototype);
      function M(Lr) {
        this.value = Lr;
      }
      M.prototype = Object.create(x.prototype);
      function U(Lr) {
        return -d < Lr && Lr < d;
      }
      function L(Lr) {
        return Lr < 1e7 ? [Lr] : Lr < 1e14 ? [Lr % 1e7, Math.floor(Lr / 1e7)] : [Lr % 1e7, Math.floor(Lr / 1e7) % 1e7, Math.floor(Lr / 1e14)];
      }
      function H(Lr) {
        fe(Lr);
        var Rr = Lr.length;
        if (Rr < 4 && xt(Lr, E) < 0)
          switch (Rr) {
            case 0:
              return 0;
            case 1:
              return Lr[0];
            case 2:
              return Lr[0] + Lr[1] * y;
            default:
              return Lr[0] + (Lr[1] + Lr[2] * y) * y;
          }
        return Lr;
      }
      function fe(Lr) {
        for (var Rr = Lr.length; Lr[--Rr] === 0; ) ;
        Lr.length = Rr + 1;
      }
      function ge(Lr) {
        for (var Rr = new Array(Lr), Ir = -1; ++Ir < Lr; )
          Rr[Ir] = 0;
        return Rr;
      }
      function Ie(Lr) {
        return Lr > 0 ? Math.floor(Lr) : Math.ceil(Lr);
      }
      function Ee(Lr, Rr) {
        var Ir = Lr.length, pr = Rr.length, Cr = new Array(Ir), Er = 0, xr = y, si, Ci;
        for (Ci = 0; Ci < pr; Ci++)
          si = Lr[Ci] + Rr[Ci] + Er, Er = si >= xr ? 1 : 0, Cr[Ci] = si - Er * xr;
        for (; Ci < Ir; )
          si = Lr[Ci] + Er, Er = si === xr ? 1 : 0, Cr[Ci++] = si - Er * xr;
        return Er > 0 && Cr.push(Er), Cr;
      }
      function Se(Lr, Rr) {
        return Lr.length >= Rr.length ? Ee(Lr, Rr) : Ee(Rr, Lr);
      }
      function ze(Lr, Rr) {
        var Ir = Lr.length, pr = new Array(Ir), Cr = y, Er, xr;
        for (xr = 0; xr < Ir; xr++)
          Er = Lr[xr] - Cr + Rr, Rr = Math.floor(Er / Cr), pr[xr] = Er - Rr * Cr, Rr += 1;
        for (; Rr > 0; )
          pr[xr++] = Rr % Cr, Rr = Math.floor(Rr / Cr);
        return pr;
      }
      v.prototype.add = function(Lr) {
        var Rr = zr(Lr);
        if (this.sign !== Rr.sign)
          return this.subtract(Rr.negate());
        var Ir = this.value, pr = Rr.value;
        return Rr.isSmall ? new v(ze(Ir, Math.abs(pr)), this.sign) : new v(Se(Ir, pr), this.sign);
      }, v.prototype.plus = v.prototype.add, F.prototype.add = function(Lr) {
        var Rr = zr(Lr), Ir = this.value;
        if (Ir < 0 !== Rr.sign)
          return this.subtract(Rr.negate());
        var pr = Rr.value;
        if (Rr.isSmall) {
          if (U(Ir + pr)) return new F(Ir + pr);
          pr = L(Math.abs(pr));
        }
        return new v(ze(pr, Math.abs(Ir)), Ir < 0);
      }, F.prototype.plus = F.prototype.add, M.prototype.add = function(Lr) {
        return new M(this.value + zr(Lr).value);
      }, M.prototype.plus = M.prototype.add;
      function He(Lr, Rr) {
        var Ir = Lr.length, pr = Rr.length, Cr = new Array(Ir), Er = 0, xr = y, si, Ci;
        for (si = 0; si < pr; si++)
          Ci = Lr[si] - Er - Rr[si], Ci < 0 ? (Ci += xr, Er = 1) : Er = 0, Cr[si] = Ci;
        for (si = pr; si < Ir; si++) {
          if (Ci = Lr[si] - Er, Ci < 0) Ci += xr;
          else {
            Cr[si++] = Ci;
            break;
          }
          Cr[si] = Ci;
        }
        for (; si < Ir; si++)
          Cr[si] = Lr[si];
        return fe(Cr), Cr;
      }
      function Pe(Lr, Rr, Ir) {
        var pr;
        return xt(Lr, Rr) >= 0 ? pr = He(Lr, Rr) : (pr = He(Rr, Lr), Ir = !Ir), pr = H(pr), typeof pr == "number" ? (Ir && (pr = -pr), new F(pr)) : new v(pr, Ir);
      }
      function De(Lr, Rr, Ir) {
        var pr = Lr.length, Cr = new Array(pr), Er = -Rr, xr = y, si, Ci;
        for (si = 0; si < pr; si++)
          Ci = Lr[si] + Er, Er = Math.floor(Ci / xr), Ci %= xr, Cr[si] = Ci < 0 ? Ci + xr : Ci;
        return Cr = H(Cr), typeof Cr == "number" ? (Ir && (Cr = -Cr), new F(Cr)) : new v(Cr, Ir);
      }
      v.prototype.subtract = function(Lr) {
        var Rr = zr(Lr);
        if (this.sign !== Rr.sign)
          return this.add(Rr.negate());
        var Ir = this.value, pr = Rr.value;
        return Rr.isSmall ? De(Ir, Math.abs(pr), this.sign) : Pe(Ir, pr, this.sign);
      }, v.prototype.minus = v.prototype.subtract, F.prototype.subtract = function(Lr) {
        var Rr = zr(Lr), Ir = this.value;
        if (Ir < 0 !== Rr.sign)
          return this.add(Rr.negate());
        var pr = Rr.value;
        return Rr.isSmall ? new F(Ir - pr) : De(pr, Math.abs(Ir), Ir >= 0);
      }, F.prototype.minus = F.prototype.subtract, M.prototype.subtract = function(Lr) {
        return new M(this.value - zr(Lr).value);
      }, M.prototype.minus = M.prototype.subtract, v.prototype.negate = function() {
        return new v(this.value, !this.sign);
      }, F.prototype.negate = function() {
        var Lr = this.sign, Rr = new F(-this.value);
        return Rr.sign = !Lr, Rr;
      }, M.prototype.negate = function() {
        return new M(-this.value);
      }, v.prototype.abs = function() {
        return new v(this.value, !1);
      }, F.prototype.abs = function() {
        return new F(Math.abs(this.value));
      }, M.prototype.abs = function() {
        return new M(this.value >= 0 ? this.value : -this.value);
      };
      function ve(Lr, Rr) {
        var Ir = Lr.length, pr = Rr.length, Cr = Ir + pr, Er = ge(Cr), xr = y, si, Ci, bi, Ri, li;
        for (bi = 0; bi < Ir; ++bi) {
          Ri = Lr[bi];
          for (var zi = 0; zi < pr; ++zi)
            li = Rr[zi], si = Ri * li + Er[bi + zi], Ci = Math.floor(si / xr), Er[bi + zi] = si - Ci * xr, Er[bi + zi + 1] += Ci;
        }
        return fe(Er), Er;
      }
      function Fe(Lr, Rr) {
        var Ir = Lr.length, pr = new Array(Ir), Cr = y, Er = 0, xr, si;
        for (si = 0; si < Ir; si++)
          xr = Lr[si] * Rr + Er, Er = Math.floor(xr / Cr), pr[si] = xr - Er * Cr;
        for (; Er > 0; )
          pr[si++] = Er % Cr, Er = Math.floor(Er / Cr);
        return pr;
      }
      function be(Lr, Rr) {
        for (var Ir = []; Rr-- > 0; ) Ir.push(0);
        return Ir.concat(Lr);
      }
      function Be(Lr, Rr) {
        var Ir = Math.max(Lr.length, Rr.length);
        if (Ir <= 30) return ve(Lr, Rr);
        Ir = Math.ceil(Ir / 2);
        var pr = Lr.slice(Ir), Cr = Lr.slice(0, Ir), Er = Rr.slice(Ir), xr = Rr.slice(0, Ir), si = Be(Cr, xr), Ci = Be(pr, Er), bi = Be(Se(Cr, pr), Se(xr, Er)), Ri = Se(Se(si, be(He(He(bi, si), Ci), Ir)), be(Ci, 2 * Ir));
        return fe(Ri), Ri;
      }
      function ke(Lr, Rr) {
        return -0.012 * Lr - 0.012 * Rr + 15e-6 * Lr * Rr > 0;
      }
      v.prototype.multiply = function(Lr) {
        var Rr = zr(Lr), Ir = this.value, pr = Rr.value, Cr = this.sign !== Rr.sign, Er;
        if (Rr.isSmall) {
          if (pr === 0) return x[0];
          if (pr === 1) return this;
          if (pr === -1) return this.negate();
          if (Er = Math.abs(pr), Er < y)
            return new v(Fe(Ir, Er), Cr);
          pr = L(Er);
        }
        return ke(Ir.length, pr.length) ? new v(Be(Ir, pr), Cr) : new v(ve(Ir, pr), Cr);
      }, v.prototype.times = v.prototype.multiply;
      function xe(Lr, Rr, Ir) {
        return Lr < y ? new v(Fe(Rr, Lr), Ir) : new v(ve(Rr, L(Lr)), Ir);
      }
      F.prototype._multiplyBySmall = function(Lr) {
        return U(Lr.value * this.value) ? new F(Lr.value * this.value) : xe(Math.abs(Lr.value), L(Math.abs(this.value)), this.sign !== Lr.sign);
      }, v.prototype._multiplyBySmall = function(Lr) {
        return Lr.value === 0 ? x[0] : Lr.value === 1 ? this : Lr.value === -1 ? this.negate() : xe(Math.abs(Lr.value), this.value, this.sign !== Lr.sign);
      }, F.prototype.multiply = function(Lr) {
        return zr(Lr)._multiplyBySmall(this);
      }, F.prototype.times = F.prototype.multiply, M.prototype.multiply = function(Lr) {
        return new M(this.value * zr(Lr).value);
      }, M.prototype.times = M.prototype.multiply;
      function Ne(Lr) {
        var Rr = Lr.length, Ir = ge(Rr + Rr), pr = y, Cr, Er, xr, si, Ci;
        for (xr = 0; xr < Rr; xr++) {
          si = Lr[xr], Er = 0 - si * si;
          for (var bi = xr; bi < Rr; bi++)
            Ci = Lr[bi], Cr = 2 * (si * Ci) + Ir[xr + bi] + Er, Er = Math.floor(Cr / pr), Ir[xr + bi] = Cr - Er * pr;
          Ir[xr + Rr] = Er;
        }
        return fe(Ir), Ir;
      }
      v.prototype.square = function() {
        return new v(Ne(this.value), !1);
      }, F.prototype.square = function() {
        var Lr = this.value * this.value;
        return U(Lr) ? new F(Lr) : new v(Ne(L(Math.abs(this.value))), !1);
      }, M.prototype.square = function(Lr) {
        return new M(this.value * this.value);
      };
      function Et(Lr, Rr) {
        var Ir = Lr.length, pr = Rr.length, Cr = y, Er = ge(Rr.length), xr = Rr[pr - 1], si = Math.ceil(Cr / (2 * xr)), Ci = Fe(Lr, si), bi = Fe(Rr, si), Ri, li, zi, Kn, Hn, os, ts;
        for (Ci.length <= Ir && Ci.push(0), bi.push(0), xr = bi[pr - 1], li = Ir - pr; li >= 0; li--) {
          for (Ri = Cr - 1, Ci[li + pr] !== xr && (Ri = Math.floor((Ci[li + pr] * Cr + Ci[li + pr - 1]) / xr)), zi = 0, Kn = 0, os = bi.length, Hn = 0; Hn < os; Hn++)
            zi += Ri * bi[Hn], ts = Math.floor(zi / Cr), Kn += Ci[li + Hn] - (zi - ts * Cr), zi = ts, Kn < 0 ? (Ci[li + Hn] = Kn + Cr, Kn = -1) : (Ci[li + Hn] = Kn, Kn = 0);
          for (; Kn !== 0; ) {
            for (Ri -= 1, zi = 0, Hn = 0; Hn < os; Hn++)
              zi += Ci[li + Hn] - Cr + bi[Hn], zi < 0 ? (Ci[li + Hn] = zi + Cr, zi = 0) : (Ci[li + Hn] = zi, zi = 1);
            Kn += zi;
          }
          Er[li] = Ri;
        }
        return Ci = Dt(Ci, si)[0], [H(Er), H(Ci)];
      }
      function st(Lr, Rr) {
        for (var Ir = Lr.length, pr = Rr.length, Cr = [], Er = [], xr = y, si, Ci, bi, Ri, li; Ir; ) {
          if (Er.unshift(Lr[--Ir]), fe(Er), xt(Er, Rr) < 0) {
            Cr.push(0);
            continue;
          }
          Ci = Er.length, bi = Er[Ci - 1] * xr + Er[Ci - 2], Ri = Rr[pr - 1] * xr + Rr[pr - 2], Ci > pr && (bi = (bi + 1) * xr), si = Math.ceil(bi / Ri);
          do {
            if (li = Fe(Rr, si), xt(li, Er) <= 0) break;
            si--;
          } while (si);
          Cr.push(si), Er = He(Er, li);
        }
        return Cr.reverse(), [H(Cr), H(Er)];
      }
      function Dt(Lr, Rr) {
        var Ir = Lr.length, pr = ge(Ir), Cr = y, Er, xr, si, Ci;
        for (si = 0, Er = Ir - 1; Er >= 0; --Er)
          Ci = si * Cr + Lr[Er], xr = Ie(Ci / Rr), si = Ci - xr * Rr, pr[Er] = xr | 0;
        return [pr, si | 0];
      }
      function er(Lr, Rr) {
        var Ir, pr = zr(Rr);
        if (D)
          return [new M(Lr.value / pr.value), new M(Lr.value % pr.value)];
        var Cr = Lr.value, Er = pr.value, xr;
        if (Er === 0) throw new Error("Cannot divide by zero");
        if (Lr.isSmall)
          return pr.isSmall ? [new F(Ie(Cr / Er)), new F(Cr % Er)] : [x[0], Lr];
        if (pr.isSmall) {
          if (Er === 1) return [Lr, x[0]];
          if (Er == -1) return [Lr.negate(), x[0]];
          var si = Math.abs(Er);
          if (si < y) {
            Ir = Dt(Cr, si), xr = H(Ir[0]);
            var Ci = Ir[1];
            return Lr.sign && (Ci = -Ci), typeof xr == "number" ? (Lr.sign !== pr.sign && (xr = -xr), [new F(xr), new F(Ci)]) : [new v(xr, Lr.sign !== pr.sign), new F(Ci)];
          }
          Er = L(si);
        }
        var bi = xt(Cr, Er);
        if (bi === -1) return [x[0], Lr];
        if (bi === 0) return [x[Lr.sign === pr.sign ? 1 : -1], x[0]];
        Cr.length + Er.length <= 200 ? Ir = Et(Cr, Er) : Ir = st(Cr, Er), xr = Ir[0];
        var Ri = Lr.sign !== pr.sign, li = Ir[1], zi = Lr.sign;
        return typeof xr == "number" ? (Ri && (xr = -xr), xr = new F(xr)) : xr = new v(xr, Ri), typeof li == "number" ? (zi && (li = -li), li = new F(li)) : li = new v(li, zi), [xr, li];
      }
      v.prototype.divmod = function(Lr) {
        var Rr = er(this, Lr);
        return {
          quotient: Rr[0],
          remainder: Rr[1]
        };
      }, M.prototype.divmod = F.prototype.divmod = v.prototype.divmod, v.prototype.divide = function(Lr) {
        return er(this, Lr)[0];
      }, M.prototype.over = M.prototype.divide = function(Lr) {
        return new M(this.value / zr(Lr).value);
      }, F.prototype.over = F.prototype.divide = v.prototype.over = v.prototype.divide, v.prototype.mod = function(Lr) {
        return er(this, Lr)[1];
      }, M.prototype.mod = M.prototype.remainder = function(Lr) {
        return new M(this.value % zr(Lr).value);
      }, F.prototype.remainder = F.prototype.mod = v.prototype.remainder = v.prototype.mod, v.prototype.pow = function(Lr) {
        var Rr = zr(Lr), Ir = this.value, pr = Rr.value, Cr, Er, xr;
        if (pr === 0) return x[1];
        if (Ir === 0) return x[0];
        if (Ir === 1) return x[1];
        if (Ir === -1) return Rr.isEven() ? x[1] : x[-1];
        if (Rr.sign)
          return x[0];
        if (!Rr.isSmall) throw new Error("The exponent " + Rr.toString() + " is too large.");
        if (this.isSmall && U(Cr = Math.pow(Ir, pr)))
          return new F(Ie(Cr));
        for (Er = this, xr = x[1]; pr & !0 && (xr = xr.times(Er), --pr), pr !== 0; )
          pr /= 2, Er = Er.square();
        return xr;
      }, F.prototype.pow = v.prototype.pow, M.prototype.pow = function(Lr) {
        var Rr = zr(Lr), Ir = this.value, pr = Rr.value, Cr = BigInt(0), Er = BigInt(1), xr = BigInt(2);
        if (pr === Cr) return x[1];
        if (Ir === Cr) return x[0];
        if (Ir === Er) return x[1];
        if (Ir === BigInt(-1)) return Rr.isEven() ? x[1] : x[-1];
        if (Rr.isNegative()) return new M(Cr);
        for (var si = this, Ci = x[1]; (pr & Er) === Er && (Ci = Ci.times(si), --pr), pr !== Cr; )
          pr /= xr, si = si.square();
        return Ci;
      }, v.prototype.modPow = function(Lr, Rr) {
        if (Lr = zr(Lr), Rr = zr(Rr), Rr.isZero()) throw new Error("Cannot take modPow with modulus 0");
        var Ir = x[1], pr = this.mod(Rr);
        for (Lr.isNegative() && (Lr = Lr.multiply(x[-1]), pr = pr.modInv(Rr)); Lr.isPositive(); ) {
          if (pr.isZero()) return x[0];
          Lr.isOdd() && (Ir = Ir.multiply(pr).mod(Rr)), Lr = Lr.divide(2), pr = pr.square().mod(Rr);
        }
        return Ir;
      }, M.prototype.modPow = F.prototype.modPow = v.prototype.modPow;
      function xt(Lr, Rr) {
        if (Lr.length !== Rr.length)
          return Lr.length > Rr.length ? 1 : -1;
        for (var Ir = Lr.length - 1; Ir >= 0; Ir--)
          if (Lr[Ir] !== Rr[Ir]) return Lr[Ir] > Rr[Ir] ? 1 : -1;
        return 0;
      }
      v.prototype.compareAbs = function(Lr) {
        var Rr = zr(Lr), Ir = this.value, pr = Rr.value;
        return Rr.isSmall ? 1 : xt(Ir, pr);
      }, F.prototype.compareAbs = function(Lr) {
        var Rr = zr(Lr), Ir = Math.abs(this.value), pr = Rr.value;
        return Rr.isSmall ? (pr = Math.abs(pr), Ir === pr ? 0 : Ir > pr ? 1 : -1) : -1;
      }, M.prototype.compareAbs = function(Lr) {
        var Rr = this.value, Ir = zr(Lr).value;
        return Rr = Rr >= 0 ? Rr : -Rr, Ir = Ir >= 0 ? Ir : -Ir, Rr === Ir ? 0 : Rr > Ir ? 1 : -1;
      }, v.prototype.compare = function(Lr) {
        if (Lr === 1 / 0)
          return -1;
        if (Lr === -1 / 0)
          return 1;
        var Rr = zr(Lr), Ir = this.value, pr = Rr.value;
        return this.sign !== Rr.sign ? Rr.sign ? 1 : -1 : Rr.isSmall ? this.sign ? -1 : 1 : xt(Ir, pr) * (this.sign ? -1 : 1);
      }, v.prototype.compareTo = v.prototype.compare, F.prototype.compare = function(Lr) {
        if (Lr === 1 / 0)
          return -1;
        if (Lr === -1 / 0)
          return 1;
        var Rr = zr(Lr), Ir = this.value, pr = Rr.value;
        return Rr.isSmall ? Ir == pr ? 0 : Ir > pr ? 1 : -1 : Ir < 0 !== Rr.sign ? Ir < 0 ? -1 : 1 : Ir < 0 ? 1 : -1;
      }, F.prototype.compareTo = F.prototype.compare, M.prototype.compare = function(Lr) {
        if (Lr === 1 / 0)
          return -1;
        if (Lr === -1 / 0)
          return 1;
        var Rr = this.value, Ir = zr(Lr).value;
        return Rr === Ir ? 0 : Rr > Ir ? 1 : -1;
      }, M.prototype.compareTo = M.prototype.compare, v.prototype.equals = function(Lr) {
        return this.compare(Lr) === 0;
      }, M.prototype.eq = M.prototype.equals = F.prototype.eq = F.prototype.equals = v.prototype.eq = v.prototype.equals, v.prototype.notEquals = function(Lr) {
        return this.compare(Lr) !== 0;
      }, M.prototype.neq = M.prototype.notEquals = F.prototype.neq = F.prototype.notEquals = v.prototype.neq = v.prototype.notEquals, v.prototype.greater = function(Lr) {
        return this.compare(Lr) > 0;
      }, M.prototype.gt = M.prototype.greater = F.prototype.gt = F.prototype.greater = v.prototype.gt = v.prototype.greater, v.prototype.lesser = function(Lr) {
        return this.compare(Lr) < 0;
      }, M.prototype.lt = M.prototype.lesser = F.prototype.lt = F.prototype.lesser = v.prototype.lt = v.prototype.lesser, v.prototype.greaterOrEquals = function(Lr) {
        return this.compare(Lr) >= 0;
      }, M.prototype.geq = M.prototype.greaterOrEquals = F.prototype.geq = F.prototype.greaterOrEquals = v.prototype.geq = v.prototype.greaterOrEquals, v.prototype.lesserOrEquals = function(Lr) {
        return this.compare(Lr) <= 0;
      }, M.prototype.leq = M.prototype.lesserOrEquals = F.prototype.leq = F.prototype.lesserOrEquals = v.prototype.leq = v.prototype.lesserOrEquals, v.prototype.isEven = function() {
        return (this.value[0] & 1) === 0;
      }, F.prototype.isEven = function() {
        return (this.value & 1) === 0;
      }, M.prototype.isEven = function() {
        return (this.value & BigInt(1)) === BigInt(0);
      }, v.prototype.isOdd = function() {
        return (this.value[0] & 1) === 1;
      }, F.prototype.isOdd = function() {
        return (this.value & 1) === 1;
      }, M.prototype.isOdd = function() {
        return (this.value & BigInt(1)) === BigInt(1);
      }, v.prototype.isPositive = function() {
        return !this.sign;
      }, F.prototype.isPositive = function() {
        return this.value > 0;
      }, M.prototype.isPositive = F.prototype.isPositive, v.prototype.isNegative = function() {
        return this.sign;
      }, F.prototype.isNegative = function() {
        return this.value < 0;
      }, M.prototype.isNegative = F.prototype.isNegative, v.prototype.isUnit = function() {
        return !1;
      }, F.prototype.isUnit = function() {
        return Math.abs(this.value) === 1;
      }, M.prototype.isUnit = function() {
        return this.abs().value === BigInt(1);
      }, v.prototype.isZero = function() {
        return !1;
      }, F.prototype.isZero = function() {
        return this.value === 0;
      }, M.prototype.isZero = function() {
        return this.value === BigInt(0);
      }, v.prototype.isDivisibleBy = function(Lr) {
        var Rr = zr(Lr);
        return Rr.isZero() ? !1 : Rr.isUnit() ? !0 : Rr.compareAbs(2) === 0 ? this.isEven() : this.mod(Rr).isZero();
      }, M.prototype.isDivisibleBy = F.prototype.isDivisibleBy = v.prototype.isDivisibleBy;
      function ir(Lr) {
        var Rr = Lr.abs();
        if (Rr.isUnit()) return !1;
        if (Rr.equals(2) || Rr.equals(3) || Rr.equals(5)) return !0;
        if (Rr.isEven() || Rr.isDivisibleBy(3) || Rr.isDivisibleBy(5)) return !1;
        if (Rr.lesser(49)) return !0;
      }
      function sr(Lr, Rr) {
        for (var Ir = Lr.prev(), pr = Ir, Cr = 0, Er, xr, si; pr.isEven(); ) pr = pr.divide(2), Cr++;
        e: for (xr = 0; xr < Rr.length; xr++)
          if (!Lr.lesser(Rr[xr]) && (si = g(Rr[xr]).modPow(pr, Lr), !(si.isUnit() || si.equals(Ir)))) {
            for (Er = Cr - 1; Er != 0; Er--) {
              if (si = si.square().mod(Lr), si.isUnit()) return !1;
              if (si.equals(Ir)) continue e;
            }
            return !1;
          }
        return !0;
      }
      v.prototype.isPrime = function(Lr) {
        var Rr = ir(this);
        if (Rr !== c) return Rr;
        var Ir = this.abs(), pr = Ir.bitLength();
        if (pr <= 64)
          return sr(Ir, [2, 3, 5, 7, 11, 13, 17, 19, 23, 29, 31, 37]);
        for (var Cr = Math.log(2) * pr.toJSNumber(), Er = Math.ceil(Lr === !0 ? 2 * Math.pow(Cr, 2) : Cr), xr = [], si = 0; si < Er; si++)
          xr.push(g(si + 2));
        return sr(Ir, xr);
      }, M.prototype.isPrime = F.prototype.isPrime = v.prototype.isPrime, v.prototype.isProbablePrime = function(Lr, Rr) {
        var Ir = ir(this);
        if (Ir !== c) return Ir;
        for (var pr = this.abs(), Cr = Lr === c ? 5 : Lr, Er = [], xr = 0; xr < Cr; xr++)
          Er.push(g.randBetween(2, pr.minus(2), Rr));
        return sr(pr, Er);
      }, M.prototype.isProbablePrime = F.prototype.isProbablePrime = v.prototype.isProbablePrime, v.prototype.modInv = function(Lr) {
        for (var Rr = g.zero, Ir = g.one, pr = zr(Lr), Cr = this.abs(), Er, xr, si; !Cr.isZero(); )
          Er = pr.divide(Cr), xr = Rr, si = pr, Rr = Ir, pr = Cr, Ir = xr.subtract(Er.multiply(Ir)), Cr = si.subtract(Er.multiply(Cr));
        if (!pr.isUnit()) throw new Error(this.toString() + " and " + Lr.toString() + " are not co-prime");
        return Rr.compare(0) === -1 && (Rr = Rr.add(Lr)), this.isNegative() ? Rr.negate() : Rr;
      }, M.prototype.modInv = F.prototype.modInv = v.prototype.modInv, v.prototype.next = function() {
        var Lr = this.value;
        return this.sign ? De(Lr, 1, this.sign) : new v(ze(Lr, 1), this.sign);
      }, F.prototype.next = function() {
        var Lr = this.value;
        return Lr + 1 < d ? new F(Lr + 1) : new v(E, !1);
      }, M.prototype.next = function() {
        return new M(this.value + BigInt(1));
      }, v.prototype.prev = function() {
        var Lr = this.value;
        return this.sign ? new v(ze(Lr, 1), !0) : De(Lr, 1, this.sign);
      }, F.prototype.prev = function() {
        var Lr = this.value;
        return Lr - 1 > -d ? new F(Lr - 1) : new v(E, !0);
      }, M.prototype.prev = function() {
        return new M(this.value - BigInt(1));
      };
      for (var yr = [1]; 2 * yr[yr.length - 1] <= y; ) yr.push(2 * yr[yr.length - 1]);
      var wr = yr.length, qr = yr[wr - 1];
      function Mr(Lr) {
        return Math.abs(Lr) <= y;
      }
      v.prototype.shiftLeft = function(Lr) {
        var Rr = zr(Lr).toJSNumber();
        if (!Mr(Rr))
          throw new Error(String(Rr) + " is too large for shifting.");
        if (Rr < 0) return this.shiftRight(-Rr);
        var Ir = this;
        if (Ir.isZero()) return Ir;
        for (; Rr >= wr; )
          Ir = Ir.multiply(qr), Rr -= wr - 1;
        return Ir.multiply(yr[Rr]);
      }, M.prototype.shiftLeft = F.prototype.shiftLeft = v.prototype.shiftLeft, v.prototype.shiftRight = function(Lr) {
        var Rr, Ir = zr(Lr).toJSNumber();
        if (!Mr(Ir))
          throw new Error(String(Ir) + " is too large for shifting.");
        if (Ir < 0) return this.shiftLeft(-Ir);
        for (var pr = this; Ir >= wr; ) {
          if (pr.isZero() || pr.isNegative() && pr.isUnit()) return pr;
          Rr = er(pr, qr), pr = Rr[1].isNegative() ? Rr[0].prev() : Rr[0], Ir -= wr - 1;
        }
        return Rr = er(pr, yr[Ir]), Rr[1].isNegative() ? Rr[0].prev() : Rr[0];
      }, M.prototype.shiftRight = F.prototype.shiftRight = v.prototype.shiftRight;
      function Dr(Lr, Rr, Ir) {
        Rr = zr(Rr);
        for (var pr = Lr.isNegative(), Cr = Rr.isNegative(), Er = pr ? Lr.not() : Lr, xr = Cr ? Rr.not() : Rr, si = 0, Ci = 0, bi = null, Ri = null, li = []; !Er.isZero() || !xr.isZero(); )
          bi = er(Er, qr), si = bi[1].toJSNumber(), pr && (si = qr - 1 - si), Ri = er(xr, qr), Ci = Ri[1].toJSNumber(), Cr && (Ci = qr - 1 - Ci), Er = bi[0], xr = Ri[0], li.push(Ir(si, Ci));
        for (var zi = Ir(pr ? 1 : 0, Cr ? 1 : 0) !== 0 ? g(-1) : g(0), Kn = li.length - 1; Kn >= 0; Kn -= 1)
          zi = zi.multiply(qr).add(g(li[Kn]));
        return zi;
      }
      v.prototype.not = function() {
        return this.negate().prev();
      }, M.prototype.not = F.prototype.not = v.prototype.not, v.prototype.and = function(Lr) {
        return Dr(this, Lr, function(Rr, Ir) {
          return Rr & Ir;
        });
      }, M.prototype.and = F.prototype.and = v.prototype.and, v.prototype.or = function(Lr) {
        return Dr(this, Lr, function(Rr, Ir) {
          return Rr | Ir;
        });
      }, M.prototype.or = F.prototype.or = v.prototype.or, v.prototype.xor = function(Lr) {
        return Dr(this, Lr, function(Rr, Ir) {
          return Rr ^ Ir;
        });
      }, M.prototype.xor = F.prototype.xor = v.prototype.xor;
      var Qr = 1 << 30, Xr = (y & -y) * (y & -y) | Qr;
      function Vr(Lr) {
        var Rr = Lr.value, Ir = typeof Rr == "number" ? Rr | Qr : typeof Rr == "bigint" ? Rr | BigInt(Qr) : Rr[0] + Rr[1] * y | Xr;
        return Ir & -Ir;
      }
      function Ur(Lr, Rr) {
        if (Rr.compareTo(Lr) <= 0) {
          var Ir = Ur(Lr, Rr.square(Rr)), pr = Ir.p, Cr = Ir.e, Er = pr.multiply(Rr);
          return Er.compareTo(Lr) <= 0 ? { p: Er, e: Cr * 2 + 1 } : { p: pr, e: Cr * 2 };
        }
        return { p: g(1), e: 0 };
      }
      v.prototype.bitLength = function() {
        var Lr = this;
        return Lr.compareTo(g(0)) < 0 && (Lr = Lr.negate().subtract(g(1))), Lr.compareTo(g(0)) === 0 ? g(0) : g(Ur(Lr, g(2)).e).add(g(1));
      }, M.prototype.bitLength = F.prototype.bitLength = v.prototype.bitLength;
      function Sr(Lr, Rr) {
        return Lr = zr(Lr), Rr = zr(Rr), Lr.greater(Rr) ? Lr : Rr;
      }
      function Gr(Lr, Rr) {
        return Lr = zr(Lr), Rr = zr(Rr), Lr.lesser(Rr) ? Lr : Rr;
      }
      function Fr(Lr, Rr) {
        if (Lr = zr(Lr).abs(), Rr = zr(Rr).abs(), Lr.equals(Rr)) return Lr;
        if (Lr.isZero()) return Rr;
        if (Rr.isZero()) return Lr;
        for (var Ir = x[1], pr, Cr; Lr.isEven() && Rr.isEven(); )
          pr = Gr(Vr(Lr), Vr(Rr)), Lr = Lr.divide(pr), Rr = Rr.divide(pr), Ir = Ir.multiply(pr);
        for (; Lr.isEven(); )
          Lr = Lr.divide(Vr(Lr));
        do {
          for (; Rr.isEven(); )
            Rr = Rr.divide(Vr(Rr));
          Lr.greater(Rr) && (Cr = Rr, Rr = Lr, Lr = Cr), Rr = Rr.subtract(Lr);
        } while (!Rr.isZero());
        return Ir.isUnit() ? Lr : Lr.multiply(Ir);
      }
      function br(Lr, Rr) {
        return Lr = zr(Lr).abs(), Rr = zr(Rr).abs(), Lr.divide(Fr(Lr, Rr)).multiply(Rr);
      }
      function Ar(Lr, Rr, Ir) {
        Lr = zr(Lr), Rr = zr(Rr);
        var pr = Ir || Math.random, Cr = Gr(Lr, Rr), Er = Sr(Lr, Rr), xr = Er.subtract(Cr).add(1);
        if (xr.isSmall) return Cr.add(Math.floor(pr() * xr));
        for (var si = fi(xr, y).value, Ci = [], bi = !0, Ri = 0; Ri < si.length; Ri++) {
          var li = bi ? si[Ri] + (Ri + 1 < si.length ? si[Ri + 1] / y : 0) : y, zi = Ie(pr() * li);
          Ci.push(zi), zi < si[Ri] && (bi = !1);
        }
        return Cr.add(x.fromArray(Ci, y, !1));
      }
      var cr = function(Lr, Rr, Ir, pr) {
        Ir = Ir || B, Lr = String(Lr), pr || (Lr = Lr.toLowerCase(), Ir = Ir.toLowerCase());
        var Cr = Lr.length, Er, xr = Math.abs(Rr), si = {};
        for (Er = 0; Er < Ir.length; Er++)
          si[Ir[Er]] = Er;
        for (Er = 0; Er < Cr; Er++) {
          var Ci = Lr[Er];
          if (Ci !== "-" && Ci in si && si[Ci] >= xr) {
            if (Ci === "1" && xr === 1) continue;
            throw new Error(Ci + " is not a valid digit in base " + Rr + ".");
          }
        }
        Rr = zr(Rr);
        var bi = [], Ri = Lr[0] === "-";
        for (Er = Ri ? 1 : 0; Er < Lr.length; Er++) {
          var Ci = Lr[Er];
          if (Ci in si) bi.push(zr(si[Ci]));
          else if (Ci === "<") {
            var li = Er;
            do
              Er++;
            while (Lr[Er] !== ">" && Er < Lr.length);
            bi.push(zr(Lr.slice(li + 1, Er)));
          } else throw new Error(Ci + " is not a valid character");
        }
        return hr(bi, Rr, Ri);
      };
      function hr(Lr, Rr, Ir) {
        var pr = x[0], Cr = x[1], Er;
        for (Er = Lr.length - 1; Er >= 0; Er--)
          pr = pr.add(Lr[Er].times(Cr)), Cr = Cr.times(Rr);
        return Ir ? pr.negate() : pr;
      }
      function Wr(Lr, Rr) {
        return Rr = Rr || B, Lr < Rr.length ? Rr[Lr] : "<" + Lr + ">";
      }
      function fi(Lr, Rr) {
        if (Rr = g(Rr), Rr.isZero()) {
          if (Lr.isZero()) return { value: [0], isNegative: !1 };
          throw new Error("Cannot convert nonzero numbers to base 0.");
        }
        if (Rr.equals(-1)) {
          if (Lr.isZero()) return { value: [0], isNegative: !1 };
          if (Lr.isNegative())
            return {
              value: [].concat.apply(
                [],
                Array.apply(null, Array(-Lr.toJSNumber())).map(Array.prototype.valueOf, [1, 0])
              ),
              isNegative: !1
            };
          var Ir = Array.apply(null, Array(Lr.toJSNumber() - 1)).map(Array.prototype.valueOf, [0, 1]);
          return Ir.unshift([1]), {
            value: [].concat.apply([], Ir),
            isNegative: !1
          };
        }
        var pr = !1;
        if (Lr.isNegative() && Rr.isPositive() && (pr = !0, Lr = Lr.abs()), Rr.isUnit())
          return Lr.isZero() ? { value: [0], isNegative: !1 } : {
            value: Array.apply(null, Array(Lr.toJSNumber())).map(Number.prototype.valueOf, 1),
            isNegative: pr
          };
        for (var Cr = [], Er = Lr, xr; Er.isNegative() || Er.compareAbs(Rr) >= 0; ) {
          xr = Er.divmod(Rr), Er = xr.quotient;
          var si = xr.remainder;
          si.isNegative() && (si = Rr.minus(si).abs(), Er = Er.next()), Cr.push(si.toJSNumber());
        }
        return Cr.push(Er.toJSNumber()), { value: Cr.reverse(), isNegative: pr };
      }
      function Bi(Lr, Rr, Ir) {
        var pr = fi(Lr, Rr);
        return (pr.isNegative ? "-" : "") + pr.value.map(function(Cr) {
          return Wr(Cr, Ir);
        }).join("");
      }
      v.prototype.toArray = function(Lr) {
        return fi(this, Lr);
      }, F.prototype.toArray = function(Lr) {
        return fi(this, Lr);
      }, M.prototype.toArray = function(Lr) {
        return fi(this, Lr);
      }, v.prototype.toString = function(Lr, Rr) {
        if (Lr === c && (Lr = 10), Lr !== 10 || Rr) return Bi(this, Lr, Rr);
        for (var Ir = this.value, pr = Ir.length, Cr = String(Ir[--pr]), Er = "0000000", xr; --pr >= 0; )
          xr = String(Ir[pr]), Cr += Er.slice(xr.length) + xr;
        var si = this.sign ? "-" : "";
        return si + Cr;
      }, F.prototype.toString = function(Lr, Rr) {
        return Lr === c && (Lr = 10), Lr != 10 || Rr ? Bi(this, Lr, Rr) : String(this.value);
      }, M.prototype.toString = F.prototype.toString, M.prototype.toJSON = v.prototype.toJSON = F.prototype.toJSON = function() {
        return this.toString();
      }, v.prototype.valueOf = function() {
        return parseInt(this.toString(), 10);
      }, v.prototype.toJSNumber = v.prototype.valueOf, F.prototype.valueOf = function() {
        return this.value;
      }, F.prototype.toJSNumber = F.prototype.valueOf, M.prototype.valueOf = M.prototype.toJSNumber = function() {
        return parseInt(this.toString(), 10);
      };
      function $r(Lr) {
        if (U(+Lr)) {
          var Rr = +Lr;
          if (Rr === Ie(Rr))
            return D ? new M(BigInt(Rr)) : new F(Rr);
          throw new Error("Invalid integer: " + Lr);
        }
        var Ir = Lr[0] === "-";
        Ir && (Lr = Lr.slice(1));
        var pr = Lr.split(/e/i);
        if (pr.length > 2) throw new Error("Invalid integer: " + pr.join("e"));
        if (pr.length === 2) {
          var Cr = pr[1];
          if (Cr[0] === "+" && (Cr = Cr.slice(1)), Cr = +Cr, Cr !== Ie(Cr) || !U(Cr)) throw new Error("Invalid integer: " + Cr + " is not a valid exponent.");
          var Er = pr[0], xr = Er.indexOf(".");
          if (xr >= 0 && (Cr -= Er.length - xr - 1, Er = Er.slice(0, xr) + Er.slice(xr + 1)), Cr < 0) throw new Error("Cannot include negative exponent part for integers");
          Er += new Array(Cr + 1).join("0"), Lr = Er;
        }
        var si = /^([0-9][0-9]*)$/.test(Lr);
        if (!si) throw new Error("Invalid integer: " + Lr);
        if (D)
          return new M(BigInt(Ir ? "-" + Lr : Lr));
        for (var Ci = [], bi = Lr.length, Ri = t, li = bi - Ri; bi > 0; )
          Ci.push(+Lr.slice(li, bi)), li -= Ri, li < 0 && (li = 0), bi -= Ri;
        return fe(Ci), new v(Ci, Ir);
      }
      function oi(Lr) {
        if (D)
          return new M(BigInt(Lr));
        if (U(Lr)) {
          if (Lr !== Ie(Lr)) throw new Error(Lr + " is not an integer.");
          return new F(Lr);
        }
        return $r(Lr.toString());
      }
      function zr(Lr) {
        return typeof Lr == "number" ? oi(Lr) : typeof Lr == "string" ? $r(Lr) : typeof Lr == "bigint" ? new M(Lr) : Lr;
      }
      for (var ti = 0; ti < 1e3; ti++)
        x[ti] = zr(ti), ti > 0 && (x[-ti] = zr(-ti));
      return x.one = x[1], x.zero = x[0], x.minusOne = x[-1], x.max = Sr, x.min = Gr, x.gcd = Fr, x.lcm = br, x.isInstance = function(Lr) {
        return Lr instanceof v || Lr instanceof F || Lr instanceof M;
      }, x.randBetween = Ar, x.fromArray = function(Lr, Rr, Ir) {
        return hr(Lr.map(zr), zr(Rr || 10), Ir);
      }, x;
    }();
    o.hasOwnProperty("exports") && (o.exports = g);
  }(BigInteger)), BigInteger.exports;
}
var hasRequiredAmount;
function requireAmount() {
  if (hasRequiredAmount) return amount;
  hasRequiredAmount = 1, Object.defineProperty(amount, "__esModule", { value: !0 }), amount.Amount = void 0;
  const o = requireDecimal$1(), g = requireBinaryParser(), c = requireAccountId(), y = requireCurrency$1(), t = requireSerializedType(), d = requireBigInteger(), E = requireBuffer$2(), B = -96, D = 80, x = 16, v = new o.Decimal("1e17"), F = new o.Decimal("1e-6"), M = d(4294967295);
  o.Decimal.config({
    toExpPos: D + x,
    toExpNeg: B - x
  });
  function U(H) {
    const fe = Object.keys(H).sort();
    return fe.length === 3 && fe[0] === "currency" && fe[1] === "issuer" && fe[2] === "value";
  }
  class L extends t.SerializedType {
    constructor(fe) {
      super(fe ?? L.defaultAmount.bytes);
    }
    /**
     * Construct an amount from an IOU or string amount
     *
     * @param value An Amount, object representing an IOU, or a string
     *     representing an integer amount
     * @returns An Amount object
     */
    static from(fe) {
      if (fe instanceof L)
        return fe;
      let ge = E.Buffer.alloc(8);
      if (typeof fe == "string") {
        L.assertXrpIsValid(fe);
        const Ie = d(fe), Ee = [E.Buffer.alloc(4), E.Buffer.alloc(4)];
        return Ee[0].writeUInt32BE(Number(Ie.shiftRight(32)), 0), Ee[1].writeUInt32BE(Number(Ie.and(M)), 0), ge = E.Buffer.concat(Ee), ge[0] |= 64, new L(ge);
      }
      if (U(fe)) {
        const Ie = new o.Decimal(fe.value);
        if (L.assertIouIsValid(Ie), Ie.isZero())
          ge[0] |= 128;
        else {
          const ze = Ie.times(`1e${-(Ie.e - 15)}`).abs().toString(), He = d(ze), Pe = [E.Buffer.alloc(4), E.Buffer.alloc(4)];
          Pe[0].writeUInt32BE(Number(He.shiftRight(32)), 0), Pe[1].writeUInt32BE(Number(He.and(M)), 0), ge = E.Buffer.concat(Pe), ge[0] |= 128, Ie.gt(new o.Decimal(0)) && (ge[0] |= 64);
          const ve = 97 + (Ie.e - 15);
          ge[0] |= ve >>> 2, ge[1] |= (ve & 3) << 6;
        }
        const Ee = y.Currency.from(fe.currency).toBytes(), Se = c.AccountID.from(fe.issuer).toBytes();
        return new L(E.Buffer.concat([ge, Ee, Se]));
      }
      throw new Error("Invalid type to construct an Amount");
    }
    /**
     * Read an amount from a BinaryParser
     *
     * @param parser BinaryParser to read the Amount from
     * @returns An Amount object
     */
    static fromParser(fe) {
      const Ie = fe.peek() & 128 ? 48 : 8;
      return new L(fe.read(Ie));
    }
    /**
     * Get the JSON representation of this Amount
     *
     * @returns the JSON interpretation of this.bytes
     */
    toJSON() {
      if (this.isNative()) {
        const fe = this.bytes, Ie = fe[0] & 64 ? "" : "-";
        fe[0] &= 63;
        const Ee = d(fe.slice(0, 4).readUInt32BE(0)), Se = d(fe.slice(4).readUInt32BE(0)), ze = Ee.shiftLeft(32).or(Se);
        return `${Ie}${ze.toString()}`;
      } else {
        const fe = new g.BinaryParser(this.toString()), ge = fe.read(8), Ie = y.Currency.fromParser(fe), Ee = c.AccountID.fromParser(fe), Se = ge[0], ze = ge[1], Pe = Se & 64 ? "" : "-", De = ((Se & 63) << 2) + ((ze & 255) >> 6) - 97;
        ge[0] = 0, ge[1] &= 63;
        const ve = new o.Decimal(`${Pe}0x${ge.toString("hex")}`).times(`1e${De}`);
        return L.assertIouIsValid(ve), {
          value: ve.toString(),
          currency: Ie.toJSON(),
          issuer: Ee.toJSON()
        };
      }
    }
    /**
     * Validate XRP amount
     *
     * @param amount String representing XRP amount
     * @returns void, but will throw if invalid amount
     */
    static assertXrpIsValid(fe) {
      if (fe.indexOf(".") !== -1)
        throw new Error(`${fe.toString()} is an illegal amount`);
      const ge = new o.Decimal(fe);
      if (!ge.isZero() && (ge.lt(F) || ge.gt(v)))
        throw new Error(`${fe.toString()} is an illegal amount`);
    }
    /**
     * Validate IOU.value amount
     *
     * @param decimal Decimal.js object representing IOU.value
     * @returns void, but will throw if invalid amount
     */
    static assertIouIsValid(fe) {
      if (!fe.isZero()) {
        const ge = fe.precision(), Ie = fe.e - 15;
        if (ge > x || Ie > D || Ie < B)
          throw new Error("Decimal precision out of range");
        this.verifyNoDecimal(fe);
      }
    }
    /**
     * Ensure that the value after being multiplied by the exponent does not
     * contain a decimal.
     *
     * @param decimal a Decimal object
     * @returns a string of the object without a decimal
     */
    static verifyNoDecimal(fe) {
      if (fe.times(`1e${-(fe.e - 15)}`).abs().toString().indexOf(".") !== -1)
        throw new Error("Decimal place found in integerNumberString");
    }
    /**
     * Test if this amount is in units of Native Currency(XRP)
     *
     * @returns true if Native (XRP)
     */
    isNative() {
      return (this.bytes[0] & 128) === 0;
    }
  }
  return amount.Amount = L, L.defaultAmount = new L(E.Buffer.from("4000000000000000", "hex")), amount;
}
var blob = {}, hasRequiredBlob;
function requireBlob() {
  if (hasRequiredBlob) return blob;
  hasRequiredBlob = 1, Object.defineProperty(blob, "__esModule", { value: !0 }), blob.Blob = void 0;
  const o = requireSerializedType(), g = requireBuffer$2();
  class c extends o.SerializedType {
    constructor(t) {
      super(t);
    }
    /**
     * Defines how to read a Blob from a BinaryParser
     *
     * @param parser The binary parser to read the Blob from
     * @param hint The length of the blob, computed by readVariableLengthLength() and passed in
     * @returns A Blob object
     */
    static fromParser(t, d) {
      return new c(t.read(d));
    }
    /**
     * Create a Blob object from a hex-string
     *
     * @param value existing Blob object or a hex-string
     * @returns A Blob object
     */
    static from(t) {
      if (t instanceof c)
        return t;
      if (typeof t == "string")
        return new c(g.Buffer.from(t, "hex"));
      throw new Error("Cannot construct Blob from value given");
    }
  }
  return blob.Blob = c, blob;
}
var hash128 = {}, hasRequiredHash128;
function requireHash128() {
  if (hasRequiredHash128) return hash128;
  hasRequiredHash128 = 1, Object.defineProperty(hash128, "__esModule", { value: !0 }), hash128.Hash128 = void 0;
  const o = requireHash(), g = requireBuffer$2();
  class c extends o.Hash {
    constructor(t) {
      t && t.byteLength === 0 && (t = c.ZERO_128.bytes), super(t ?? c.ZERO_128.bytes);
    }
    /**
     * Get the hex representation of a hash-128 bytes, allowing unset
     *
     * @returns hex String of this.bytes
     */
    toHex() {
      const t = this.toBytes().toString("hex").toUpperCase();
      return /^0+$/.exec(t) ? "" : t;
    }
  }
  return hash128.Hash128 = c, c.width = 16, c.ZERO_128 = new c(g.Buffer.alloc(c.width)), hash128;
}
var hash256 = {}, hasRequiredHash256;
function requireHash256() {
  if (hasRequiredHash256) return hash256;
  hasRequiredHash256 = 1, Object.defineProperty(hash256, "__esModule", { value: !0 }), hash256.Hash256 = void 0;
  const o = requireHash(), g = requireBuffer$2();
  class c extends o.Hash {
    constructor(t) {
      super(t ?? c.ZERO_256.bytes);
    }
  }
  return hash256.Hash256 = c, c.width = 32, c.ZERO_256 = new c(g.Buffer.alloc(c.width)), hash256;
}
var issue = {}, hasRequiredIssue;
function requireIssue() {
  if (hasRequiredIssue) return issue;
  hasRequiredIssue = 1, Object.defineProperty(issue, "__esModule", { value: !0 }), issue.Issue = void 0;
  const o = requireBinaryParser(), g = requireAccountId(), c = requireCurrency$1(), y = requireSerializedType(), t = requireBuffer$2();
  function d(B) {
    const D = Object.keys(B).sort();
    return D.length === 1 ? D[0] === "currency" : D.length === 2 && D[0] === "currency" && D[1] === "issuer";
  }
  class E extends y.SerializedType {
    constructor(D) {
      super(D ?? E.ZERO_ISSUED_CURRENCY.bytes);
    }
    /**
     * Construct an amount from an IOU or string amount
     *
     * @param value An Amount, object representing an IOU, or a string
     *     representing an integer amount
     * @returns An Amount object
     */
    static from(D) {
      if (D instanceof E)
        return D;
      if (d(D)) {
        const x = c.Currency.from(D.currency).toBytes();
        if (D.issuer == null)
          return new E(x);
        const v = g.AccountID.from(D.issuer).toBytes();
        return new E(t.Buffer.concat([x, v]));
      }
      throw new Error("Invalid type to construct an Amount");
    }
    /**
     * Read an amount from a BinaryParser
     *
     * @param parser BinaryParser to read the Amount from
     * @returns An Amount object
     */
    static fromParser(D) {
      const x = D.read(20);
      if (new c.Currency(x).toJSON() === "XRP")
        return new E(x);
      const v = [x, D.read(20)];
      return new E(t.Buffer.concat(v));
    }
    /**
     * Get the JSON representation of this Amount
     *
     * @returns the JSON interpretation of this.bytes
     */
    toJSON() {
      const D = new o.BinaryParser(this.toString()), x = c.Currency.fromParser(D);
      if (x.toJSON() === "XRP")
        return { currency: x.toJSON() };
      const v = g.AccountID.fromParser(D);
      return {
        currency: x.toJSON(),
        issuer: v.toJSON()
      };
    }
  }
  return issue.Issue = E, E.ZERO_ISSUED_CURRENCY = new E(t.Buffer.alloc(20)), issue;
}
var pathSet = {}, hasRequiredPathSet;
function requirePathSet() {
  if (hasRequiredPathSet) return pathSet;
  hasRequiredPathSet = 1, Object.defineProperty(pathSet, "__esModule", { value: !0 }), pathSet.PathSet = void 0;
  const o = requireAccountId(), g = requireCurrency$1(), c = requireBinaryParser(), y = requireSerializedType(), t = requireBuffer$2(), d = 0, E = 255, B = 1, D = 16, x = 32;
  function v(H) {
    return H.issuer !== void 0 || H.account !== void 0 || H.currency !== void 0;
  }
  function F(H) {
    return Array.isArray(H) && H.length === 0 || Array.isArray(H) && Array.isArray(H[0]) && H[0].length === 0 || Array.isArray(H) && Array.isArray(H[0]) && v(H[0][0]);
  }
  class M extends y.SerializedType {
    /**
     * Create a Hop from a HopObject
     *
     * @param value Either a hop or HopObject to create a hop with
     * @returns a Hop
     */
    static from(fe) {
      if (fe instanceof M)
        return fe;
      const ge = [t.Buffer.from([0])];
      return fe.account && (ge.push(o.AccountID.from(fe.account).toBytes()), ge[0][0] |= B), fe.currency && (ge.push(g.Currency.from(fe.currency).toBytes()), ge[0][0] |= D), fe.issuer && (ge.push(o.AccountID.from(fe.issuer).toBytes()), ge[0][0] |= x), new M(t.Buffer.concat(ge));
    }
    /**
     * Construct a Hop from a BinaryParser
     *
     * @param parser BinaryParser to read the Hop from
     * @returns a Hop
     */
    static fromParser(fe) {
      const ge = fe.readUInt8(), Ie = [t.Buffer.from([ge])];
      return ge & B && Ie.push(fe.read(o.AccountID.width)), ge & D && Ie.push(fe.read(g.Currency.width)), ge & x && Ie.push(fe.read(o.AccountID.width)), new M(t.Buffer.concat(Ie));
    }
    /**
     * Get the JSON interpretation of this hop
     *
     * @returns a HopObject, an JS object with optional account, issuer, and currency
     */
    toJSON() {
      const fe = new c.BinaryParser(this.bytes.toString("hex")), ge = fe.readUInt8();
      let Ie, Ee, Se;
      ge & B && (Ie = o.AccountID.fromParser(fe).toJSON()), ge & D && (Ee = g.Currency.fromParser(fe).toJSON()), ge & x && (Se = o.AccountID.fromParser(fe).toJSON());
      const ze = {};
      return Ie && (ze.account = Ie), Se && (ze.issuer = Se), Ee && (ze.currency = Ee), ze;
    }
    /**
     * get a number representing the type of this hop
     *
     * @returns a number to be bitwise and-ed with TYPE_ constants to describe the types in the hop
     */
    type() {
      return this.bytes[0];
    }
  }
  class U extends y.SerializedType {
    /**
     * construct a Path from an array of Hops
     *
     * @param value Path or array of HopObjects to construct a Path
     * @returns the Path
     */
    static from(fe) {
      if (fe instanceof U)
        return fe;
      const ge = [];
      return fe.forEach((Ie) => {
        ge.push(M.from(Ie).toBytes());
      }), new U(t.Buffer.concat(ge));
    }
    /**
     * Read a Path from a BinaryParser
     *
     * @param parser BinaryParser to read Path from
     * @returns the Path represented by the bytes read from the BinaryParser
     */
    static fromParser(fe) {
      const ge = [];
      for (; !fe.end() && (ge.push(M.fromParser(fe).toBytes()), !(fe.peek() === d || fe.peek() === E)); )
        ;
      return new U(t.Buffer.concat(ge));
    }
    /**
     * Get the JSON representation of this Path
     *
     * @returns an Array of HopObject constructed from this.bytes
     */
    toJSON() {
      const fe = [], ge = new c.BinaryParser(this.toString());
      for (; !ge.end(); )
        fe.push(M.fromParser(ge).toJSON());
      return fe;
    }
  }
  class L extends y.SerializedType {
    /**
     * Construct a PathSet from an Array of Arrays representing paths
     *
     * @param value A PathSet or Array of Array of HopObjects
     * @returns the PathSet constructed from value
     */
    static from(fe) {
      if (fe instanceof L)
        return fe;
      if (F(fe)) {
        const ge = [];
        return fe.forEach((Ie) => {
          ge.push(U.from(Ie).toBytes()), ge.push(t.Buffer.from([E]));
        }), ge[ge.length - 1] = t.Buffer.from([d]), new L(t.Buffer.concat(ge));
      }
      throw new Error("Cannot construct PathSet from given value");
    }
    /**
     * Construct a PathSet from a BinaryParser
     *
     * @param parser A BinaryParser to read PathSet from
     * @returns the PathSet read from parser
     */
    static fromParser(fe) {
      const ge = [];
      for (; !fe.end() && (ge.push(U.fromParser(fe).toBytes()), ge.push(fe.read(1)), ge[ge.length - 1][0] != d); )
        ;
      return new L(t.Buffer.concat(ge));
    }
    /**
     * Get the JSON representation of this PathSet
     *
     * @returns an Array of Array of HopObjects, representing this PathSet
     */
    toJSON() {
      const fe = [], ge = new c.BinaryParser(this.toString());
      for (; !ge.end(); )
        fe.push(U.fromParser(ge).toJSON()), ge.skip(1);
      return fe;
    }
  }
  return pathSet.PathSet = L, pathSet;
}
var stArray = {}, stObject = {}, hasRequiredStObject;
function requireStObject() {
  if (hasRequiredStObject) return stObject;
  hasRequiredStObject = 1, Object.defineProperty(stObject, "__esModule", { value: !0 }), stObject.STObject = void 0;
  const o = requireEnums(), g = requireSerializedType(), c = requireDist$5(), y = requireBinaryParser(), t = requireBinarySerializer(), d = requireBuffer$2(), E = requireStArray(), B = d.Buffer.from([225]), D = "ObjectEndMarker", x = "STObject", v = "Destination", F = "Account", M = "SourceTag", U = "DestinationTag";
  function L(ge, Ie) {
    const Ee = (0, c.xAddressToClassicAddress)(Ie);
    let Se;
    if (ge === v)
      Se = U;
    else if (ge === F)
      Se = M;
    else if (Ee.tag !== !1)
      throw new Error(`${ge} cannot have an associated tag`);
    return Ee.tag !== !1 ? { [ge]: Ee.classicAddress, [Se]: Ee.tag } : { [ge]: Ee.classicAddress };
  }
  function H(ge, Ie) {
    if (!(ge[M] === void 0 || Ie[M] === void 0))
      throw new Error("Cannot have Account X-Address and SourceTag");
    if (!(ge[U] === void 0 || Ie[U] === void 0))
      throw new Error("Cannot have Destination X-Address and DestinationTag");
  }
  class fe extends g.SerializedType {
    /**
     * Construct a STObject from a BinaryParser
     *
     * @param parser BinaryParser to read STObject from
     * @returns A STObject object
     */
    static fromParser(Ie) {
      const Ee = new t.BytesList(), Se = new t.BinarySerializer(Ee);
      for (; !Ie.end(); ) {
        const ze = Ie.readField();
        if (ze.name === D)
          break;
        const He = Ie.readFieldValue(ze);
        Se.writeFieldAndValue(ze, He), ze.type.name === x && Se.put(B);
      }
      return new fe(Ee.toBytes());
    }
    /**
     * Construct a STObject from a JSON object
     *
     * @param value An object to include
     * @param filter optional, denote which field to include in serialized object
     * @param definitions optional, types and values to use to encode/decode a transaction
     * @returns a STObject object
     */
    static from(Ie, Ee, Se = o.DEFAULT_DEFINITIONS) {
      if (Ie instanceof fe)
        return Ie;
      const ze = new t.BytesList(), He = new t.BinarySerializer(ze);
      let Pe = !1;
      const De = Object.entries(Ie).reduce((Fe, [be, Be]) => {
        let ke;
        return Be && (0, c.isValidXAddress)(Be.toString()) && (ke = L(be, Be.toString()), H(ke, Ie)), Object.assign(Fe, ke ?? { [be]: Be });
      }, {});
      let ve = Object.keys(De).map((Fe) => Se.field[Fe]).filter((Fe) => Fe !== void 0 && De[Fe.name] !== void 0 && Fe.isSerialized).sort((Fe, be) => Fe.ordinal - be.ordinal);
      return Ee !== void 0 && (ve = ve.filter(Ee)), ve.forEach((Fe) => {
        const be = Fe.type.name === x ? this.from(De[Fe.name], void 0, Se) : Fe.type.name === "STArray" ? E.STArray.from(De[Fe.name], Se) : Fe.associatedType.from(De[Fe.name]);
        if (be == null)
          throw new TypeError(`Unable to interpret "${Fe.name}: ${De[Fe.name]}".`);
        be.name === "UNLModify" && (Pe = !0);
        const Be = Fe.name == "Account" && Pe;
        He.writeFieldAndValue(Fe, be, Be), Fe.type.name === x && He.put(B);
      }), new fe(ze.toBytes());
    }
    /**
     * Get the JSON interpretation of this.bytes
     * @param definitions rippled definitions used to parse the values of transaction types and such.
     *                          Can be customized for sidechains and amendments.
     * @returns a JSON object
     */
    toJSON(Ie) {
      const Ee = new y.BinaryParser(this.toString(), Ie), Se = {};
      for (; !Ee.end(); ) {
        const ze = Ee.readField();
        if (ze.name === D)
          break;
        Se[ze.name] = Ee.readFieldValue(ze).toJSON(Ie);
      }
      return Se;
    }
  }
  return stObject.STObject = fe, stObject;
}
var hasRequiredStArray;
function requireStArray() {
  if (hasRequiredStArray) return stArray;
  hasRequiredStArray = 1, Object.defineProperty(stArray, "__esModule", { value: !0 }), stArray.STArray = void 0;
  const o = requireEnums(), g = requireSerializedType(), c = requireStObject(), y = requireBinaryParser(), t = requireBuffer$2(), d = t.Buffer.from([241]), E = "ArrayEndMarker", B = t.Buffer.from([225]);
  function D(v) {
    return Array.isArray(v) && (v.length === 0 || typeof v[0] == "object");
  }
  class x extends g.SerializedType {
    /**
     * Construct an STArray from a BinaryParser
     *
     * @param parser BinaryParser to parse an STArray from
     * @returns An STArray Object
     */
    static fromParser(F) {
      const M = [];
      for (; !F.end(); ) {
        const U = F.readField();
        if (U.name === E)
          break;
        M.push(U.header, F.readFieldValue(U).toBytes(), B);
      }
      return M.push(d), new x(t.Buffer.concat(M));
    }
    /**
     * Construct an STArray from an Array of JSON Objects
     *
     * @param value STArray or Array of Objects to parse into an STArray
     * @param definitions optional, types and values to use to encode/decode a transaction
     * @returns An STArray object
     */
    static from(F, M = o.DEFAULT_DEFINITIONS) {
      if (F instanceof x)
        return F;
      if (D(F)) {
        const U = [];
        return F.forEach((L) => {
          U.push(c.STObject.from(L, void 0, M).toBytes());
        }), U.push(d), new x(t.Buffer.concat(U));
      }
      throw new Error("Cannot construct STArray from value given");
    }
    /**
     * Return the JSON representation of this.bytes
     *
     * @param definitions optional, types and values to use to encode/decode a transaction
     * @returns An Array of JSON objects
     */
    toJSON(F = o.DEFAULT_DEFINITIONS) {
      const M = [], U = new y.BinaryParser(this.toString(), F);
      for (; !U.end(); ) {
        const L = U.readField();
        if (L.name === E)
          break;
        const H = {};
        H[L.name] = c.STObject.fromParser(U).toJSON(F), M.push(H);
      }
      return M;
    }
  }
  return stArray.STArray = x, stArray;
}
var uint16 = {}, uint = {}, hasRequiredUint;
function requireUint() {
  if (hasRequiredUint) return uint;
  hasRequiredUint = 1, Object.defineProperty(uint, "__esModule", { value: !0 }), uint.UInt = void 0;
  const o = requireSerializedType();
  function g(y, t) {
    return y < t ? -1 : y == t ? 0 : 1;
  }
  class c extends o.Comparable {
    constructor(t) {
      super(t);
    }
    /**
     * Overload of compareTo for Comparable
     *
     * @param other other UInt to compare this to
     * @returns -1, 0, or 1 depending on how the objects relate to each other
     */
    compareTo(t) {
      return g(this.valueOf(), t.valueOf());
    }
    /**
     * Convert a UInt object to JSON
     *
     * @returns number or string represented by this.bytes
     */
    toJSON() {
      const t = this.valueOf();
      return typeof t == "number" ? t : t.toString();
    }
  }
  return uint.UInt = c, uint;
}
var hasRequiredUint16;
function requireUint16() {
  if (hasRequiredUint16) return uint16;
  hasRequiredUint16 = 1, Object.defineProperty(uint16, "__esModule", { value: !0 }), uint16.UInt16 = void 0;
  const o = requireUint(), g = requireBuffer$2();
  class c extends o.UInt {
    constructor(t) {
      super(t ?? c.defaultUInt16.bytes);
    }
    static fromParser(t) {
      return new c(t.read(c.width));
    }
    /**
     * Construct a UInt16 object from a number
     *
     * @param val UInt16 object or number
     */
    static from(t) {
      if (t instanceof c)
        return t;
      if (typeof t == "number") {
        const d = g.Buffer.alloc(c.width);
        return d.writeUInt16BE(t, 0), new c(d);
      }
      throw new Error("Can not construct UInt16 with given value");
    }
    /**
     * get the value of a UInt16 object
     *
     * @returns the number represented by this.bytes
     */
    valueOf() {
      return this.bytes.readUInt16BE(0);
    }
  }
  return uint16.UInt16 = c, c.width = 16 / 8, c.defaultUInt16 = new c(g.Buffer.alloc(c.width)), uint16;
}
var uint32 = {}, hasRequiredUint32;
function requireUint32() {
  if (hasRequiredUint32) return uint32;
  hasRequiredUint32 = 1, Object.defineProperty(uint32, "__esModule", { value: !0 }), uint32.UInt32 = void 0;
  const o = requireUint(), g = requireBuffer$2();
  class c extends o.UInt {
    constructor(t) {
      super(t ?? c.defaultUInt32.bytes);
    }
    static fromParser(t) {
      return new c(t.read(c.width));
    }
    /**
     * Construct a UInt32 object from a number
     *
     * @param val UInt32 object or number
     */
    static from(t) {
      if (t instanceof c)
        return t;
      const d = g.Buffer.alloc(c.width);
      if (typeof t == "string") {
        const E = Number.parseInt(t);
        return d.writeUInt32BE(E, 0), new c(d);
      }
      if (typeof t == "number")
        return d.writeUInt32BE(t, 0), new c(d);
      throw new Error("Cannot construct UInt32 from given value");
    }
    /**
     * get the value of a UInt32 object
     *
     * @returns the number represented by this.bytes
     */
    valueOf() {
      return this.bytes.readUInt32BE(0);
    }
  }
  return uint32.UInt32 = c, c.width = 32 / 8, c.defaultUInt32 = new c(g.Buffer.alloc(c.width)), uint32;
}
var uint64 = {}, hasRequiredUint64;
function requireUint64() {
  if (hasRequiredUint64) return uint64;
  hasRequiredUint64 = 1, Object.defineProperty(uint64, "__esModule", { value: !0 }), uint64.UInt64 = void 0;
  const o = requireUint(), g = requireBigInteger(), c = requireBigInteger(), y = requireBuffer$2(), t = /^[a-fA-F0-9]{1,16}$/, d = g(4294967295);
  class E extends o.UInt {
    constructor(D) {
      super(D ?? E.defaultUInt64.bytes);
    }
    static fromParser(D) {
      return new E(D.read(E.width));
    }
    /**
     * Construct a UInt64 object
     *
     * @param val A UInt64, hex-string, bigInt, or number
     * @returns A UInt64 object
     */
    static from(D) {
      if (D instanceof E)
        return D;
      let x = y.Buffer.alloc(E.width);
      if (typeof D == "number") {
        if (D < 0)
          throw new Error("value must be an unsigned integer");
        const v = g(D), F = [y.Buffer.alloc(4), y.Buffer.alloc(4)];
        return F[0].writeUInt32BE(Number(v.shiftRight(32)), 0), F[1].writeUInt32BE(Number(v.and(d)), 0), new E(y.Buffer.concat(F));
      }
      if (typeof D == "string") {
        if (!t.test(D))
          throw new Error(`${D} is not a valid hex-string`);
        const v = D.padStart(16, "0");
        return x = y.Buffer.from(v, "hex"), new E(x);
      }
      if ((0, c.isInstance)(D)) {
        const v = [y.Buffer.alloc(4), y.Buffer.alloc(4)];
        return v[0].writeUInt32BE(Number(D.shiftRight(g(32))), 0), v[1].writeUInt32BE(Number(D.and(d)), 0), new E(y.Buffer.concat(v));
      }
      throw new Error("Cannot construct UInt64 from given value");
    }
    /**
     * The JSON representation of a UInt64 object
     *
     * @returns a hex-string
     */
    toJSON() {
      return this.bytes.toString("hex").toUpperCase();
    }
    /**
     * Get the value of the UInt64
     *
     * @returns the number represented buy this.bytes
     */
    valueOf() {
      const D = g(this.bytes.slice(0, 4).readUInt32BE(0)), x = g(this.bytes.slice(4).readUInt32BE(0));
      return D.shiftLeft(g(32)).or(x);
    }
    /**
     * Get the bytes representation of the UInt64 object
     *
     * @returns 8 bytes representing the UInt64
     */
    toBytes() {
      return this.bytes;
    }
  }
  return uint64.UInt64 = E, E.width = 64 / 8, E.defaultUInt64 = new E(y.Buffer.alloc(E.width)), uint64;
}
var uint8 = {}, hasRequiredUint8;
function requireUint8() {
  if (hasRequiredUint8) return uint8;
  hasRequiredUint8 = 1, Object.defineProperty(uint8, "__esModule", { value: !0 }), uint8.UInt8 = void 0;
  const o = requireUint(), g = requireBuffer$2();
  class c extends o.UInt {
    constructor(t) {
      super(t ?? c.defaultUInt8.bytes);
    }
    static fromParser(t) {
      return new c(t.read(c.width));
    }
    /**
     * Construct a UInt8 object from a number
     *
     * @param val UInt8 object or number
     */
    static from(t) {
      if (t instanceof c)
        return t;
      if (typeof t == "number") {
        const d = g.Buffer.alloc(c.width);
        return d.writeUInt8(t, 0), new c(d);
      }
      throw new Error("Cannot construct UInt8 from given value");
    }
    /**
     * get the value of a UInt8 object
     *
     * @returns the number represented by this.bytes
     */
    valueOf() {
      return this.bytes.readUInt8(0);
    }
  }
  return uint8.UInt8 = c, c.width = 8 / 8, c.defaultUInt8 = new c(g.Buffer.alloc(c.width)), uint8;
}
var vector256 = {}, hasRequiredVector256;
function requireVector256() {
  if (hasRequiredVector256) return vector256;
  hasRequiredVector256 = 1, Object.defineProperty(vector256, "__esModule", { value: !0 }), vector256.Vector256 = void 0;
  const o = requireSerializedType(), g = requireHash256(), c = requireBinarySerializer();
  function y(d) {
    return Array.isArray(d) && (d.length === 0 || typeof d[0] == "string");
  }
  class t extends o.SerializedType {
    constructor(E) {
      super(E);
    }
    /**
     * Construct a Vector256 from a BinaryParser
     *
     * @param parser BinaryParser to
     * @param hint length of the vector, in bytes, optional
     * @returns a Vector256 object
     */
    static fromParser(E, B) {
      const D = new c.BytesList(), v = (B ?? E.size()) / 32;
      for (let F = 0; F < v; F++)
        g.Hash256.fromParser(E).toBytesSink(D);
      return new t(D.toBytes());
    }
    /**
     * Construct a Vector256 object from an array of hashes
     *
     * @param value A Vector256 object or array of hex-strings representing Hash256's
     * @returns a Vector256 object
     */
    static from(E) {
      if (E instanceof t)
        return E;
      if (y(E)) {
        const B = new c.BytesList();
        return E.forEach((D) => {
          g.Hash256.from(D).toBytesSink(B);
        }), new t(B.toBytes());
      }
      throw new Error("Cannot construct Vector256 from given value");
    }
    /**
     * Return an Array of hex-strings represented by this.bytes
     *
     * @returns An Array of strings representing the Hash256 objects
     */
    toJSON() {
      if (this.bytes.byteLength % 32 !== 0)
        throw new Error("Invalid bytes for Vector256");
      const E = [];
      for (let B = 0; B < this.bytes.byteLength; B += 32)
        E.push(this.bytes.slice(B, B + 32).toString("hex").toUpperCase());
      return E;
    }
  }
  return vector256.Vector256 = t, vector256;
}
var xchainBridge = {}, hasRequiredXchainBridge;
function requireXchainBridge() {
  if (hasRequiredXchainBridge) return xchainBridge;
  hasRequiredXchainBridge = 1, Object.defineProperty(xchainBridge, "__esModule", { value: !0 }), xchainBridge.XChainBridge = void 0;
  const o = requireBinaryParser(), g = requireAccountId(), c = requireSerializedType(), y = requireBuffer$2(), t = requireIssue();
  function d(B) {
    const D = Object.keys(B).sort();
    return D.length === 4 && D[0] === "IssuingChainDoor" && D[1] === "IssuingChainIssue" && D[2] === "LockingChainDoor" && D[3] === "LockingChainIssue";
  }
  class E extends c.SerializedType {
    constructor(D) {
      super(D ?? E.ZERO_XCHAIN_BRIDGE.bytes);
    }
    /**
     * Construct a cross-chain bridge from a JSON
     *
     * @param value XChainBridge or JSON to parse into an XChainBridge
     * @returns An XChainBridge object
     */
    static from(D) {
      if (D instanceof E)
        return D;
      if (!d(D))
        throw new Error("Invalid type to construct an XChainBridge");
      const x = [];
      return this.TYPE_ORDER.forEach((v) => {
        const { name: F, type: M } = v;
        M === g.AccountID && x.push(y.Buffer.from([20]));
        const U = M.from(D[F]);
        x.push(U.toBytes());
      }), new E(y.Buffer.concat(x));
    }
    /**
     * Read an XChainBridge from a BinaryParser
     *
     * @param parser BinaryParser to read the XChainBridge from
     * @returns An XChainBridge object
     */
    static fromParser(D) {
      const x = [];
      return this.TYPE_ORDER.forEach((v) => {
        const { type: F } = v;
        F === g.AccountID && (D.skip(1), x.push(y.Buffer.from([20])));
        const M = F.fromParser(D);
        x.push(M.toBytes());
      }), new E(y.Buffer.concat(x));
    }
    /**
     * Get the JSON representation of this XChainBridge
     *
     * @returns the JSON interpretation of this.bytes
     */
    toJSON() {
      const D = new o.BinaryParser(this.toString()), x = {};
      return E.TYPE_ORDER.forEach((v) => {
        const { name: F, type: M } = v;
        M === g.AccountID && D.skip(1);
        const U = M.fromParser(D).toJSON();
        x[F] = U;
      }), x;
    }
  }
  return xchainBridge.XChainBridge = E, E.ZERO_XCHAIN_BRIDGE = new E(y.Buffer.concat([
    y.Buffer.from([20]),
    y.Buffer.alloc(40),
    y.Buffer.from([20]),
    y.Buffer.alloc(40)
  ])), E.TYPE_ORDER = [
    { name: "LockingChainDoor", type: g.AccountID },
    { name: "LockingChainIssue", type: t.Issue },
    { name: "IssuingChainDoor", type: g.AccountID },
    { name: "IssuingChainIssue", type: t.Issue }
  ], xchainBridge;
}
var hasRequiredTypes$4;
function requireTypes$4() {
  return hasRequiredTypes$4 || (hasRequiredTypes$4 = 1, function(o) {
    Object.defineProperty(o, "__esModule", { value: !0 }), o.Vector256 = o.UInt64 = o.UInt32 = o.UInt16 = o.UInt8 = o.STObject = o.STArray = o.PathSet = o.Hash256 = o.Hash160 = o.Hash128 = o.Currency = o.Blob = o.Amount = o.AccountID = o.coreTypes = void 0;
    const g = requireAccountId();
    Object.defineProperty(o, "AccountID", { enumerable: !0, get: function() {
      return g.AccountID;
    } });
    const c = requireAmount();
    Object.defineProperty(o, "Amount", { enumerable: !0, get: function() {
      return c.Amount;
    } });
    const y = requireBlob();
    Object.defineProperty(o, "Blob", { enumerable: !0, get: function() {
      return y.Blob;
    } });
    const t = requireCurrency$1();
    Object.defineProperty(o, "Currency", { enumerable: !0, get: function() {
      return t.Currency;
    } });
    const d = requireHash128();
    Object.defineProperty(o, "Hash128", { enumerable: !0, get: function() {
      return d.Hash128;
    } });
    const E = requireHash160();
    Object.defineProperty(o, "Hash160", { enumerable: !0, get: function() {
      return E.Hash160;
    } });
    const B = requireHash256();
    Object.defineProperty(o, "Hash256", { enumerable: !0, get: function() {
      return B.Hash256;
    } });
    const D = requireIssue(), x = requirePathSet();
    Object.defineProperty(o, "PathSet", { enumerable: !0, get: function() {
      return x.PathSet;
    } });
    const v = requireStArray();
    Object.defineProperty(o, "STArray", { enumerable: !0, get: function() {
      return v.STArray;
    } });
    const F = requireStObject();
    Object.defineProperty(o, "STObject", { enumerable: !0, get: function() {
      return F.STObject;
    } });
    const M = requireUint16();
    Object.defineProperty(o, "UInt16", { enumerable: !0, get: function() {
      return M.UInt16;
    } });
    const U = requireUint32();
    Object.defineProperty(o, "UInt32", { enumerable: !0, get: function() {
      return U.UInt32;
    } });
    const L = requireUint64();
    Object.defineProperty(o, "UInt64", { enumerable: !0, get: function() {
      return L.UInt64;
    } });
    const H = requireUint8();
    Object.defineProperty(o, "UInt8", { enumerable: !0, get: function() {
      return H.UInt8;
    } });
    const fe = requireVector256();
    Object.defineProperty(o, "Vector256", { enumerable: !0, get: function() {
      return fe.Vector256;
    } });
    const ge = requireXchainBridge(), Ie = requireEnums(), Ee = {
      AccountID: g.AccountID,
      Amount: c.Amount,
      Blob: y.Blob,
      Currency: t.Currency,
      Hash128: d.Hash128,
      Hash160: E.Hash160,
      Hash256: B.Hash256,
      Issue: D.Issue,
      PathSet: x.PathSet,
      STArray: v.STArray,
      STObject: F.STObject,
      UInt8: H.UInt8,
      UInt16: M.UInt16,
      UInt32: U.UInt32,
      UInt64: L.UInt64,
      Vector256: fe.Vector256,
      XChainBridge: ge.XChainBridge
    };
    o.coreTypes = Ee, Ie.DEFAULT_DEFINITIONS.associateTypes(Ee);
  }(types$4)), types$4;
}
var binary = {}, hashPrefixes = {}, hasRequiredHashPrefixes;
function requireHashPrefixes() {
  if (hasRequiredHashPrefixes) return hashPrefixes;
  hasRequiredHashPrefixes = 1, Object.defineProperty(hashPrefixes, "__esModule", { value: !0 }), hashPrefixes.HashPrefix = void 0;
  const o = requireBuffer$2();
  function g(y) {
    const t = o.Buffer.alloc(4);
    return t.writeUInt32BE(y, 0), t;
  }
  const c = {
    transactionID: g(1415073280),
    // transaction plus metadata
    transaction: g(1397638144),
    // account state
    accountStateEntry: g(1296846336),
    // inner node in tree
    innerNode: g(1296649728),
    // ledger master data for signing
    ledgerHeader: g(1280791040),
    // inner transaction to sign
    transactionSig: g(1398036480),
    // inner transaction to sign
    transactionMultiSig: g(1397576704),
    // validation for signing
    validation: g(1447119872),
    // proposal for signing
    proposal: g(1347571712),
    // payment channel claim
    paymentChannelClaim: g(1129073920)
  };
  return hashPrefixes.HashPrefix = c, hashPrefixes;
}
var hashes = {}, hasRequiredHashes;
function requireHashes() {
  if (hasRequiredHashes) return hashes;
  hasRequiredHashes = 1, Object.defineProperty(hashes, "__esModule", { value: !0 }), hashes.transactionID = hashes.sha512Half = hashes.Sha512Half = void 0;
  const o = requireHashPrefixes(), g = requireBrowser$a(), c = requireHash256(), y = requireBinarySerializer(), t = requireBuffer$2();
  class d extends y.BytesList {
    constructor() {
      super(...arguments), this.hash = g("sha512");
    }
    /**
     * Construct a new Sha512Hash and write bytes this.hash
     *
     * @param bytes bytes to write to this.hash
     * @returns the new Sha512Hash object
     */
    static put(x) {
      return new d().put(x);
    }
    /**
     * Write bytes to an existing Sha512Hash
     *
     * @param bytes bytes to write to object
     * @returns the Sha512 object
     */
    put(x) {
      return this.hash.update(x), this;
    }
    /**
     * Compute SHA512 hash and slice in half
     *
     * @returns half of a SHA512 hash
     */
    finish256() {
      return t.Buffer.from(this.hash.digest().slice(0, 32));
    }
    /**
     * Constructs a Hash256 from the Sha512Half object
     *
     * @returns a Hash256 object
     */
    finish() {
      return new c.Hash256(this.finish256());
    }
  }
  hashes.Sha512Half = d;
  function E(...D) {
    const x = new d();
    return D.forEach((v) => x.put(v)), x.finish256();
  }
  hashes.sha512Half = E;
  function B(D) {
    return new c.Hash256(E(o.HashPrefix.transactionID, D));
  }
  return hashes.transactionID = B, hashes;
}
var hasRequiredBinary;
function requireBinary() {
  return hasRequiredBinary || (hasRequiredBinary = 1, function(o) {
    Object.defineProperty(o, "__esModule", { value: !0 }), o.transactionID = o.sha512Half = o.binaryToJSON = o.signingClaimData = o.signingData = o.multiSigningData = o.readJSON = o.serializeObject = o.makeParser = o.BytesList = o.BinarySerializer = o.BinaryParser = void 0;
    const g = requireTypes$4(), c = requireBinaryParser();
    Object.defineProperty(o, "BinaryParser", { enumerable: !0, get: function() {
      return c.BinaryParser;
    } });
    const y = requireHashPrefixes(), t = requireBinarySerializer();
    Object.defineProperty(o, "BinarySerializer", { enumerable: !0, get: function() {
      return t.BinarySerializer;
    } }), Object.defineProperty(o, "BytesList", { enumerable: !0, get: function() {
      return t.BytesList;
    } });
    const d = requireHashes();
    Object.defineProperty(o, "sha512Half", { enumerable: !0, get: function() {
      return d.sha512Half;
    } }), Object.defineProperty(o, "transactionID", { enumerable: !0, get: function() {
      return d.transactionID;
    } });
    const E = requireEnums(), B = requireBigInteger(), D = (H, fe) => new c.BinaryParser(H, fe);
    o.makeParser = D;
    const x = (H, fe = E.DEFAULT_DEFINITIONS) => H.readType(g.coreTypes.STObject).toJSON(fe);
    o.readJSON = x;
    const v = (H, fe) => x(D(H, fe), fe);
    o.binaryToJSON = v;
    function F(H, fe = {}) {
      const { prefix: ge, suffix: Ie, signingFieldsOnly: Ee = !1, definitions: Se } = fe, ze = new t.BytesList();
      ge && ze.put(ge);
      const He = Ee ? (Pe) => Pe.isSigningField : void 0;
      return g.coreTypes.STObject.from(H, He, Se).toBytesSink(ze), Ie && ze.put(Ie), ze.toBytes();
    }
    o.serializeObject = F;
    function M(H, fe = y.HashPrefix.transactionSig, ge = {}) {
      return F(H, {
        prefix: fe,
        signingFieldsOnly: !0,
        definitions: ge.definitions
      });
    }
    o.signingData = M;
    function U(H) {
      const fe = B(String(H.amount)), ge = y.HashPrefix.paymentChannelClaim, Ie = g.coreTypes.Hash256.from(H.channel).toBytes(), Ee = g.coreTypes.UInt64.from(fe).toBytes(), Se = new t.BytesList();
      return Se.put(ge), Se.put(Ie), Se.put(Ee), Se.toBytes();
    }
    o.signingClaimData = U;
    function L(H, fe, ge = {
      definitions: E.DEFAULT_DEFINITIONS
    }) {
      const Ie = y.HashPrefix.transactionMultiSig, Ee = g.coreTypes.AccountID.from(fe).toBytes();
      return F(H, {
        prefix: Ie,
        suffix: Ee,
        signingFieldsOnly: !0,
        definitions: ge.definitions
      });
    }
    o.multiSigningData = L;
  }(binary)), binary;
}
var shamap = {}, hasRequiredShamap;
function requireShamap() {
  if (hasRequiredShamap) return shamap;
  hasRequiredShamap = 1, Object.defineProperty(shamap, "__esModule", { value: !0 }), shamap.ShaMapLeaf = shamap.ShaMapNode = shamap.ShaMap = void 0;
  const o = requireAssert$2(), g = requireTypes$4(), c = requireHashPrefixes(), y = requireHashes(), t = requireBuffer$2();
  class d {
  }
  shamap.ShaMapNode = d;
  class E extends d {
    constructor(v, F) {
      super(), this.index = v, this.item = F;
    }
    /**
     * @returns true as ShaMapLeaf is a leaf node
     */
    isLeaf() {
      return !0;
    }
    /**
     * @returns false as ShaMapLeaf is not an inner node
     */
    isInner() {
      return !1;
    }
    /**
     * Get the prefix of the this.item
     *
     * @returns The hash prefix, unless this.item is undefined, then it returns an empty Buffer
     */
    hashPrefix() {
      return this.item === void 0 ? t.Buffer.alloc(0) : this.item.hashPrefix();
    }
    /**
     * Hash the bytes representation of this
     *
     * @returns hash of this.item concatenated with this.index
     */
    hash() {
      const v = y.Sha512Half.put(this.hashPrefix());
      return this.toBytesSink(v), v.finish();
    }
    /**
     * Write the bytes representation of this to a BytesList
     * @param list BytesList to write bytes to
     */
    toBytesSink(v) {
      this.item !== void 0 && this.item.toBytesSink(v), this.index.toBytesSink(v);
    }
  }
  shamap.ShaMapLeaf = E;
  class B extends d {
    constructor(v = 0) {
      super(), this.depth = v, this.slotBits = 0, this.branches = Array(16);
    }
    /**
     * @returns true as ShaMapInner is an inner node
     */
    isInner() {
      return !0;
    }
    /**
     * @returns false as ShaMapInner is not a leaf node
     */
    isLeaf() {
      return !1;
    }
    /**
     * Get the hash prefix for this node
     *
     * @returns hash prefix describing an inner node
     */
    hashPrefix() {
      return c.HashPrefix.innerNode;
    }
    /**
     * Set a branch of this node to be another node
     *
     * @param slot Slot to add branch to this.branches
     * @param branch Branch to add
     */
    setBranch(v, F) {
      this.slotBits = this.slotBits | 1 << v, this.branches[v] = F;
    }
    /**
     * @returns true if node is empty
     */
    empty() {
      return this.slotBits === 0;
    }
    /**
     * Compute the hash of this node
     *
     * @returns The hash of this node
     */
    hash() {
      if (this.empty())
        return g.coreTypes.Hash256.ZERO_256;
      const v = y.Sha512Half.put(this.hashPrefix());
      return this.toBytesSink(v), v.finish();
    }
    /**
     * Writes the bytes representation of this node to a BytesList
     *
     * @param list BytesList to write bytes to
     */
    toBytesSink(v) {
      for (let F = 0; F < this.branches.length; F++) {
        const M = this.branches[F];
        (M ? M.hash() : g.coreTypes.Hash256.ZERO_256).toBytesSink(v);
      }
    }
    /**
     * Add item to the SHAMap
     *
     * @param index Hash of the index of the item being inserted
     * @param item Item to insert in the map
     * @param leaf Leaf node to insert when branch doesn't exist
     */
    addItem(v, F, M) {
      if (o.strict.ok(v !== void 0), v !== void 0) {
        const U = v.nibblet(this.depth), L = this.branches[U];
        if (L === void 0)
          this.setBranch(U, M || new E(v, F));
        else if (L instanceof E) {
          const H = new B(this.depth + 1);
          H.addItem(L.index, void 0, L), H.addItem(v, F, M), this.setBranch(U, H);
        } else if (L instanceof B)
          L.addItem(v, F, M);
        else
          throw new Error("invalid ShaMap.addItem call");
      }
    }
  }
  class D extends B {
  }
  return shamap.ShaMap = D, shamap;
}
var ledgerHashes = {}, hasRequiredLedgerHashes;
function requireLedgerHashes() {
  if (hasRequiredLedgerHashes) return ledgerHashes;
  hasRequiredLedgerHashes = 1;
  var o = ledgerHashes && ledgerHashes.__createBinding || (Object.create ? function(He, Pe, De, ve) {
    ve === void 0 && (ve = De);
    var Fe = Object.getOwnPropertyDescriptor(Pe, De);
    (!Fe || ("get" in Fe ? !Pe.__esModule : Fe.writable || Fe.configurable)) && (Fe = { enumerable: !0, get: function() {
      return Pe[De];
    } }), Object.defineProperty(He, ve, Fe);
  } : function(He, Pe, De, ve) {
    ve === void 0 && (ve = De), He[ve] = Pe[De];
  }), g = ledgerHashes && ledgerHashes.__setModuleDefault || (Object.create ? function(He, Pe) {
    Object.defineProperty(He, "default", { enumerable: !0, value: Pe });
  } : function(He, Pe) {
    He.default = Pe;
  }), c = ledgerHashes && ledgerHashes.__importStar || function(He) {
    if (He && He.__esModule) return He;
    var Pe = {};
    if (He != null) for (var De in He) De !== "default" && Object.prototype.hasOwnProperty.call(He, De) && o(Pe, He, De);
    return g(Pe, He), Pe;
  };
  Object.defineProperty(ledgerHashes, "__esModule", { value: !0 }), ledgerHashes.decodeLedgerData = ledgerHashes.ledgerHash = ledgerHashes.transactionTreeHash = ledgerHashes.accountStateHash = void 0;
  const y = c(requireAssert$2()), t = requireShamap(), d = requireHashPrefixes(), E = requireHashes(), B = requireBinary(), D = requireHash256(), x = requireStObject(), v = requireUint64(), F = requireUint32(), M = requireUint8(), U = requireBinaryParser(), L = requireBigInteger();
  function H(He, Pe) {
    const De = new t.ShaMap();
    return Pe.forEach((ve) => De.addItem(...He(ve))), De.hash();
  }
  function fe(He) {
    return y.ok(He.hash), [D.Hash256.from(He.hash), {
      hashPrefix() {
        return d.HashPrefix.transaction;
      },
      toBytesSink(ve) {
        const Fe = new B.BinarySerializer(ve);
        Fe.writeLengthEncoded(x.STObject.from(He)), Fe.writeLengthEncoded(x.STObject.from(He.metaData));
      }
    }, void 0];
  }
  function ge(He) {
    const Pe = D.Hash256.from(He.index), De = (0, B.serializeObject)(He);
    return [Pe, {
      hashPrefix() {
        return d.HashPrefix.accountStateEntry;
      },
      toBytesSink(Fe) {
        Fe.put(De);
      }
    }, void 0];
  }
  function Ie(He) {
    return H(fe, He);
  }
  ledgerHashes.transactionTreeHash = Ie;
  function Ee(He) {
    return H(ge, He);
  }
  ledgerHashes.accountStateHash = Ee;
  function Se(He) {
    const Pe = new E.Sha512Half();
    return Pe.put(d.HashPrefix.ledgerHeader), y.ok(He.parent_close_time !== void 0), y.ok(He.close_flags !== void 0), F.UInt32.from(He.ledger_index).toBytesSink(Pe), v.UInt64.from(L(String(He.total_coins))).toBytesSink(Pe), D.Hash256.from(He.parent_hash).toBytesSink(Pe), D.Hash256.from(He.transaction_hash).toBytesSink(Pe), D.Hash256.from(He.account_hash).toBytesSink(Pe), F.UInt32.from(He.parent_close_time).toBytesSink(Pe), F.UInt32.from(He.close_time).toBytesSink(Pe), M.UInt8.from(He.close_time_resolution).toBytesSink(Pe), M.UInt8.from(He.close_flags).toBytesSink(Pe), Pe.finish();
  }
  ledgerHashes.ledgerHash = Se;
  function ze(He, Pe) {
    y.ok(typeof He == "string", "binary must be a hex string");
    const De = new U.BinaryParser(He, Pe);
    return {
      ledger_index: De.readUInt32(),
      total_coins: De.readType(v.UInt64).valueOf().toString(),
      parent_hash: De.readType(D.Hash256).toHex(),
      transaction_hash: De.readType(D.Hash256).toHex(),
      account_hash: De.readType(D.Hash256).toHex(),
      parent_close_time: De.readUInt32(),
      close_time: De.readUInt32(),
      close_time_resolution: De.readUInt8(),
      close_flags: De.readUInt8()
    };
  }
  return ledgerHashes.decodeLedgerData = ze, ledgerHashes;
}
var quality = {}, hasRequiredQuality;
function requireQuality() {
  if (hasRequiredQuality) return quality;
  hasRequiredQuality = 1, Object.defineProperty(quality, "__esModule", { value: !0 }), quality.quality = void 0;
  const o = requireTypes$4(), g = requireDecimal$1(), c = requireBigInteger(), y = requireBuffer$2();
  let t = class {
    /**
     * Encode quality amount
     *
     * @param arg string representation of an amount
     * @returns Serialized quality
     */
    static encode(E) {
      const B = new g.Decimal(E), D = B.e - 15, x = B.times(`1e${-D}`).abs().toString(), v = o.coreTypes.UInt64.from(c(x)).toBytes();
      return v[0] = D + 100, v;
    }
    /**
     * Decode quality amount
     *
     * @param arg hex-string denoting serialized quality
     * @returns deserialized quality
     */
    static decode(E) {
      const B = y.Buffer.from(E, "hex").slice(-8), D = B[0] - 100;
      return new g.Decimal(`0x${B.slice(1).toString("hex")}`).times(`1e${D}`);
    }
  };
  return quality.quality = t, quality;
}
var hasRequiredCoretypes;
function requireCoretypes() {
  return hasRequiredCoretypes || (hasRequiredCoretypes = 1, function(o) {
    var g = coretypes && coretypes.__createBinding || (Object.create ? function(M, U, L, H) {
      H === void 0 && (H = L);
      var fe = Object.getOwnPropertyDescriptor(U, L);
      (!fe || ("get" in fe ? !U.__esModule : fe.writable || fe.configurable)) && (fe = { enumerable: !0, get: function() {
        return U[L];
      } }), Object.defineProperty(M, H, fe);
    } : function(M, U, L, H) {
      H === void 0 && (H = L), M[H] = U[L];
    }), c = coretypes && coretypes.__setModuleDefault || (Object.create ? function(M, U) {
      Object.defineProperty(M, "default", { enumerable: !0, value: U });
    } : function(M, U) {
      M.default = U;
    }), y = coretypes && coretypes.__importStar || function(M) {
      if (M && M.__esModule) return M;
      var U = {};
      if (M != null) for (var L in M) L !== "default" && Object.prototype.hasOwnProperty.call(M, L) && g(U, M, L);
      return c(U, M), U;
    };
    Object.defineProperty(o, "__esModule", { value: !0 }), o.types = o.ShaMap = o.HashPrefix = o.quality = o.TransactionResult = o.Type = o.LedgerEntryType = o.TransactionType = o.Field = o.DEFAULT_DEFINITIONS = o.ledgerHashes = o.binary = o.hashes = void 0;
    const t = requireEnums();
    Object.defineProperty(o, "DEFAULT_DEFINITIONS", { enumerable: !0, get: function() {
      return t.DEFAULT_DEFINITIONS;
    } }), Object.defineProperty(o, "Field", { enumerable: !0, get: function() {
      return t.Field;
    } }), Object.defineProperty(o, "TransactionType", { enumerable: !0, get: function() {
      return t.TransactionType;
    } }), Object.defineProperty(o, "LedgerEntryType", { enumerable: !0, get: function() {
      return t.LedgerEntryType;
    } }), Object.defineProperty(o, "Type", { enumerable: !0, get: function() {
      return t.Type;
    } }), Object.defineProperty(o, "TransactionResult", { enumerable: !0, get: function() {
      return t.TransactionResult;
    } });
    const d = y(requireTypes$4());
    o.types = d;
    const E = y(requireBinary());
    o.binary = E;
    const B = requireShamap();
    Object.defineProperty(o, "ShaMap", { enumerable: !0, get: function() {
      return B.ShaMap;
    } });
    const D = y(requireLedgerHashes());
    o.ledgerHashes = D;
    const x = y(requireHashes());
    o.hashes = x;
    const v = requireQuality();
    Object.defineProperty(o, "quality", { enumerable: !0, get: function() {
      return v.quality;
    } });
    const F = requireHashPrefixes();
    Object.defineProperty(o, "HashPrefix", { enumerable: !0, get: function() {
      return F.HashPrefix;
    } });
  }(coretypes)), coretypes;
}
var xrplDefinitions = {}, hasRequiredXrplDefinitions;
function requireXrplDefinitions() {
  if (hasRequiredXrplDefinitions) return xrplDefinitions;
  hasRequiredXrplDefinitions = 1, Object.defineProperty(xrplDefinitions, "__esModule", { value: !0 }), xrplDefinitions.XrplDefinitions = void 0;
  const o = requireXrplDefinitionsBase(), g = requireTypes$4();
  class c extends o.XrplDefinitionsBase {
    /**
     * Present rippled types in a typed and updatable format.
     * For an example of the input format see `definitions.json`
     * To generate a new definitions file from rippled source code, use this tool: https://github.com/RichardAH/xrpl-codec-gen
     *
     * See the definitions.test.js file for examples of how to create your own updated definitions.json.
     *
     * @param enums - A json encoding of the core types, transaction types, transaction results, transaction names, and fields.
     * @param additionalTypes - A list of SerializedType objects with the same name as the fields defined.
     *              These types will be included in addition to the coreTypes used on mainnet.
     */
    constructor(t, d) {
      const E = Object.assign({}, g.coreTypes, d);
      super(t, E);
    }
  }
  return xrplDefinitions.XrplDefinitions = c, xrplDefinitions;
}
var hasRequiredDist$4;
function requireDist$4() {
  return hasRequiredDist$4 || (hasRequiredDist$4 = 1, function(o) {
    var g = dist$4 && dist$4.__createBinding || (Object.create ? function(He, Pe, De, ve) {
      ve === void 0 && (ve = De);
      var Fe = Object.getOwnPropertyDescriptor(Pe, De);
      (!Fe || ("get" in Fe ? !Pe.__esModule : Fe.writable || Fe.configurable)) && (Fe = { enumerable: !0, get: function() {
        return Pe[De];
      } }), Object.defineProperty(He, ve, Fe);
    } : function(He, Pe, De, ve) {
      ve === void 0 && (ve = De), He[ve] = Pe[De];
    }), c = dist$4 && dist$4.__setModuleDefault || (Object.create ? function(He, Pe) {
      Object.defineProperty(He, "default", { enumerable: !0, value: Pe });
    } : function(He, Pe) {
      He.default = Pe;
    }), y = dist$4 && dist$4.__importStar || function(He) {
      if (He && He.__esModule) return He;
      var Pe = {};
      if (He != null) for (var De in He) De !== "default" && Object.prototype.hasOwnProperty.call(He, De) && g(Pe, He, De);
      return c(Pe, He), Pe;
    };
    Object.defineProperty(o, "__esModule", { value: !0 }), o.coreTypes = o.DEFAULT_DEFINITIONS = o.XrplDefinitionsBase = o.XrplDefinitions = o.TRANSACTION_TYPES = o.decodeLedgerData = o.decodeQuality = o.encodeQuality = o.encodeForMultisigning = o.encodeForSigningClaim = o.encodeForSigning = o.encode = o.decode = void 0;
    const t = y(requireAssert$2()), d = requireCoretypes(), E = requireLedgerHashes();
    Object.defineProperty(o, "decodeLedgerData", { enumerable: !0, get: function() {
      return E.decodeLedgerData;
    } });
    const B = requireEnums();
    Object.defineProperty(o, "XrplDefinitionsBase", { enumerable: !0, get: function() {
      return B.XrplDefinitionsBase;
    } }), Object.defineProperty(o, "TRANSACTION_TYPES", { enumerable: !0, get: function() {
      return B.TRANSACTION_TYPES;
    } }), Object.defineProperty(o, "DEFAULT_DEFINITIONS", { enumerable: !0, get: function() {
      return B.DEFAULT_DEFINITIONS;
    } });
    const D = requireXrplDefinitions();
    Object.defineProperty(o, "XrplDefinitions", { enumerable: !0, get: function() {
      return D.XrplDefinitions;
    } });
    const x = requireTypes$4();
    Object.defineProperty(o, "coreTypes", { enumerable: !0, get: function() {
      return x.coreTypes;
    } });
    const { signingData: v, signingClaimData: F, multiSigningData: M, binaryToJSON: U, serializeObject: L } = d.binary;
    function H(He, Pe) {
      return t.ok(typeof He == "string", "binary must be a hex string"), U(He, Pe);
    }
    o.decode = H;
    function fe(He, Pe) {
      return t.ok(typeof He == "object"), L(He, { definitions: Pe }).toString("hex").toUpperCase();
    }
    o.encode = fe;
    function ge(He, Pe) {
      return t.ok(typeof He == "object"), v(He, d.HashPrefix.transactionSig, {
        definitions: Pe
      }).toString("hex").toUpperCase();
    }
    o.encodeForSigning = ge;
    function Ie(He) {
      return t.ok(typeof He == "object"), F(He).toString("hex").toUpperCase();
    }
    o.encodeForSigningClaim = Ie;
    function Ee(He, Pe, De) {
      return t.ok(typeof He == "object"), t.equal(He.SigningPubKey, ""), M(He, Pe, De ? { definitions: De } : void 0).toString("hex").toUpperCase();
    }
    o.encodeForMultisigning = Ee;
    function Se(He) {
      return t.ok(typeof He == "string"), d.quality.encode(He).toString("hex").toUpperCase();
    }
    o.encodeQuality = Se;
    function ze(He) {
      return t.ok(typeof He == "string"), d.quality.decode(He).toString();
    }
    o.decodeQuality = ze;
  }(dist$4)), dist$4;
}
var hasRequiredXrp$1;
function requireXrp$1() {
  if (hasRequiredXrp$1) return xrp;
  hasRequiredXrp$1 = 1, Object.defineProperty(xrp, "__esModule", { value: !0 }), xrp.KeystoneXrpSDK = void 0;
  const o = requireDist$p(), g = requireDist$4();
  class c {
    parseAccount(t) {
      const d = t.decodeCBOR().toString();
      return JSON.parse(d);
    }
    parseSignature(t) {
      if (t.type !== "bytes")
        throw new Error("type not match");
      try {
        const d = t.decodeCBOR().toString("hex");
        return (0, g.decode)(d).TxnSignature;
      } catch {
        throw new Error("signature is invalid");
      }
    }
    generateSignRequest(t) {
      const d = JSON.stringify(t);
      return o.UR.fromBuffer(Buffer.from(d));
    }
  }
  return xrp.KeystoneXrpSDK = c, xrp;
}
var hasRequiredXrp;
function requireXrp() {
  return hasRequiredXrp || (hasRequiredXrp = 1, function(o) {
    var g = xrp$1 && xrp$1.__createBinding || (Object.create ? function(y, t, d, E) {
      E === void 0 && (E = d);
      var B = Object.getOwnPropertyDescriptor(t, d);
      (!B || ("get" in B ? !t.__esModule : B.writable || B.configurable)) && (B = { enumerable: !0, get: function() {
        return t[d];
      } }), Object.defineProperty(y, E, B);
    } : function(y, t, d, E) {
      E === void 0 && (E = d), y[E] = t[d];
    }), c = xrp$1 && xrp$1.__exportStar || function(y, t) {
      for (var d in y) d !== "default" && !Object.prototype.hasOwnProperty.call(t, d) && g(t, y, d);
    };
    Object.defineProperty(o, "__esModule", { value: !0 }), c(requireXrp$1(), o);
  }(xrp$1)), xrp$1;
}
var hasRequiredSdk;
function requireSdk() {
  if (hasRequiredSdk) return sdk;
  hasRequiredSdk = 1;
  var o = sdk && sdk.__awaiter || function(D, x, v, F) {
    function M(U) {
      return U instanceof v ? U : new v(function(L) {
        L(U);
      });
    }
    return new (v || (v = Promise))(function(U, L) {
      function H(Ie) {
        try {
          ge(F.next(Ie));
        } catch (Ee) {
          L(Ee);
        }
      }
      function fe(Ie) {
        try {
          ge(F.throw(Ie));
        } catch (Ee) {
          L(Ee);
        }
      }
      function ge(Ie) {
        Ie.done ? U(Ie.value) : M(Ie.value).then(H, fe);
      }
      ge((F = F.apply(D, x || [])).next());
    });
  };
  Object.defineProperty(sdk, "__esModule", { value: !0 }), sdk.KeystoneSDK = void 0;
  const g = requireChains(), c = requireWallet$1(), y = requireXrp(), t = requireDoge(), d = requireIota(), E = "https://keyst.one/statics/sdk/config.json";
  class B {
    constructor(x) {
      this.parseMultiAccounts = c.parseMultiAccounts, this.parseTonAccount = c.parseTonAccount, this.parseHDKey = c.parseHDKey, this.parseAccount = c.parseAccount, this.generateDeriveContextHashCall = c.generateDeriveContextHashCall, this.generateKeyDerivationCall = c.generateKeyDerivationCall, this.parseURBytes = c.parseURBytes, this.config = x;
    }
    static create(x) {
      return o(this, void 0, void 0, function* () {
        try {
          const F = yield (yield fetch(E)).json();
          return new B(Object.assign(Object.assign({}, x), F));
        } catch (v) {
          return console.error("fetch config error", v), new B(x);
        }
      });
    }
    get btc() {
      return this._btc === void 0 && (this._btc = new g.KeystoneBitcoinSDK()), this._btc;
    }
    get eth() {
      return this._eth === void 0 && (this._eth = new g.KeystoneEthereumSDK(this.config)), this._eth;
    }
    get sol() {
      return this._sol === void 0 && (this._sol = new g.KeystoneSolanaSDK()), this._sol;
    }
    get stellar() {
      return this._stellar === void 0 && (this._stellar = new g.KeystoneStellarSDK()), this._stellar;
    }
    get cosmos() {
      return this._cosmos === void 0 && (this._cosmos = new g.KeystoneCosmosSDK(this.config)), this._cosmos;
    }
    get evm() {
      return this._evm === void 0 && (this._evm = new g.KeystoneEvmSDK(this.config)), this._evm;
    }
    get tron() {
      return this._tron === void 0 && (this._tron = new g.KeystoneTronSDK()), this._tron;
    }
    get ltc() {
      return this._ltc === void 0 && (this._ltc = new g.KeystoneLitecoinSDK()), this._ltc;
    }
    get doge() {
      return this._doge === void 0 && (this._doge = new t.KeystoneDogecoinSDK()), this._doge;
    }
    get bch() {
      return this._bch === void 0 && (this._bch = new g.KeystoneBitcoinCashSDK()), this._bch;
    }
    get dash() {
      return this._dash === void 0 && (this._dash = new g.KeystoneDashSDK()), this._dash;
    }
    get aptos() {
      return this._aptos === void 0 && (this._aptos = new g.KeystoneAptosSDK()), this._aptos;
    }
    get near() {
      return this._near === void 0 && (this._near = new g.KeystoneNearSDK()), this._near;
    }
    get arweave() {
      return this._arweave === void 0 && (this._arweave = new g.KeystoneArweaveSDK()), this._arweave;
    }
    get sui() {
      return this._sui === void 0 && (this._sui = new g.KeystoneSuiSDK(this.config)), this._sui;
    }
    get iota() {
      return this._iota === void 0 && (this._iota = new d.KeystoneIotaSDK(this.config)), this._iota;
    }
    get cardano() {
      return this._cardano === void 0 && (this._cardano = new g.KeystoneCardanoSDK(this.config)), this._cardano;
    }
    get xrp() {
      return this._xrp === void 0 && (this._xrp = new y.KeystoneXrpSDK()), this._xrp;
    }
    get ton() {
      return this._ton === void 0 && (this._ton = new g.KeystoneTonSDK(this.config)), this._ton;
    }
    get avalanche() {
      return this._avalanche === void 0 && (this._avalanche = new g.KeystoneAvalancheSDK()), this._avalanche;
    }
    get psbt() {
      return this._psbt === void 0 && (this._psbt = new g.KeystonePsbtSDK()), this._psbt;
    }
    get zcash() {
      return this._zcash === void 0 && (this._zcash = new g.KeystoneZcashSDK()), this._zcash;
    }
  }
  return sdk.KeystoneSDK = B, B.parseMultiAccounts = c.parseMultiAccounts, B.parseHDKey = c.parseHDKey, B.generateKeyDerivationCall = c.generateKeyDerivationCall, B.generateDeriveContextHashCall = c.generateDeriveContextHashCall, B.parseURBytes = c.parseURBytes, sdk;
}
var hasRequiredDist$3;
function requireDist$3() {
  return hasRequiredDist$3 || (hasRequiredDist$3 = 1, function(o) {
    var g = dist$p && dist$p.__createBinding || (Object.create ? function(D, x, v, F) {
      F === void 0 && (F = v);
      var M = Object.getOwnPropertyDescriptor(x, v);
      (!M || ("get" in M ? !x.__esModule : M.writable || M.configurable)) && (M = { enumerable: !0, get: function() {
        return x[v];
      } }), Object.defineProperty(D, F, M);
    } : function(D, x, v, F) {
      F === void 0 && (F = v), D[F] = x[v];
    }), c = dist$p && dist$p.__setModuleDefault || (Object.create ? function(D, x) {
      Object.defineProperty(D, "default", { enumerable: !0, value: x });
    } : function(D, x) {
      D.default = x;
    }), y = dist$p && dist$p.__importStar || /* @__PURE__ */ function() {
      var D = function(x) {
        return D = Object.getOwnPropertyNames || function(v) {
          var F = [];
          for (var M in v) Object.prototype.hasOwnProperty.call(v, M) && (F[F.length] = M);
          return F;
        }, D(x);
      };
      return function(x) {
        if (x && x.__esModule) return x;
        var v = {};
        if (x != null) for (var F = D(x), M = 0; M < F.length; M++) F[M] !== "default" && g(v, x, F[M]);
        return c(v, x), v;
      };
    }(), t = dist$p && dist$p.__exportStar || function(D, x) {
      for (var v in D) v !== "default" && !Object.prototype.hasOwnProperty.call(x, v) && g(x, D, v);
    };
    Object.defineProperty(o, "__esModule", { value: !0 }), o.utils = o.KeystoneSDK = o.parseURBytes = o.QRHardwareCallVersion = o.QRHardwareCallType = o.QRHardwareCall = o.DerivationAlgorithm = o.DeriveContextHashCall = o.Curve = void 0;
    const d = y(requireUtils$e());
    o.utils = d;
    const E = requireSdk();
    Object.defineProperty(o, "KeystoneSDK", { enumerable: !0, get: function() {
      return E.KeystoneSDK;
    } }), t(requireDist$p(), o), t(requireTypes$5(), o), t(requireChains(), o);
    var B = requireHardwareCall();
    Object.defineProperty(o, "Curve", { enumerable: !0, get: function() {
      return B.Curve;
    } }), Object.defineProperty(o, "DeriveContextHashCall", { enumerable: !0, get: function() {
      return B.DeriveContextHashCall;
    } }), Object.defineProperty(o, "DerivationAlgorithm", { enumerable: !0, get: function() {
      return B.DerivationAlgorithm;
    } }), Object.defineProperty(o, "QRHardwareCall", { enumerable: !0, get: function() {
      return B.QRHardwareCall;
    } }), Object.defineProperty(o, "QRHardwareCallType", { enumerable: !0, get: function() {
      return B.QRHardwareCallType;
    } }), Object.defineProperty(o, "QRHardwareCallVersion", { enumerable: !0, get: function() {
      return B.QRHardwareCallVersion;
    } }), Object.defineProperty(o, "parseURBytes", { enumerable: !0, get: function() {
      return B.parseURBytes;
    } }), o.default = E.KeystoneSDK;
  }(dist$p)), dist$p;
}
var distExports = requireDist$3();
const j = /* @__PURE__ */ getDefaultExportFromCjs(distExports);
function number(o) {
  if (!Number.isSafeInteger(o) || o < 0)
    throw new Error(`positive integer expected, not ${o}`);
}
function isBytes$6(o) {
  return o instanceof Uint8Array || o != null && typeof o == "object" && o.constructor.name === "Uint8Array";
}
function bytes(o, ...g) {
  if (!isBytes$6(o))
    throw new Error("Uint8Array expected");
  if (g.length > 0 && !g.includes(o.length))
    throw new Error(`Uint8Array expected of length ${g}, not of length=${o.length}`);
}
function hash$m(o) {
  if (typeof o != "function" || typeof o.create != "function")
    throw new Error("Hash should be wrapped by utils.wrapConstructor");
  number(o.outputLen), number(o.blockLen);
}
function exists(o, g = !0) {
  if (o.destroyed)
    throw new Error("Hash instance has been destroyed");
  if (g && o.finished)
    throw new Error("Hash#digest() has already been called");
}
function output(o, g) {
  bytes(o);
  const c = g.outputLen;
  if (o.length < c)
    throw new Error(`digestInto() expects output buffer of length at least ${c}`);
}
const crypto$4 = typeof globalThis == "object" && "crypto" in globalThis ? globalThis.crypto : void 0;
const createView$2 = (o) => new DataView(o.buffer, o.byteOffset, o.byteLength), rotr$1 = (o, g) => o << 32 - g | o >>> g, rotl$1 = (o, g) => o << g | o >>> 32 - g >>> 0;
new Uint8Array(new Uint32Array([287454020]).buffer)[0];
const hexes$2 = /* @__PURE__ */ Array.from({ length: 256 }, (o, g) => g.toString(16).padStart(2, "0"));
function bytesToHex$2(o) {
  bytes(o);
  let g = "";
  for (let c = 0; c < o.length; c++)
    g += hexes$2[o[c]];
  return g;
}
const asciis$2 = { _0: 48, _9: 57, _A: 65, _F: 70, _a: 97, _f: 102 };
function asciiToBase16$2(o) {
  if (o >= asciis$2._0 && o <= asciis$2._9)
    return o - asciis$2._0;
  if (o >= asciis$2._A && o <= asciis$2._F)
    return o - (asciis$2._A - 10);
  if (o >= asciis$2._a && o <= asciis$2._f)
    return o - (asciis$2._a - 10);
}
function hexToBytes$2(o) {
  if (typeof o != "string")
    throw new Error("hex string expected, got " + typeof o);
  const g = o.length, c = g / 2;
  if (g % 2)
    throw new Error("padded hex string expected, got unpadded hex of length " + g);
  const y = new Uint8Array(c);
  for (let t = 0, d = 0; t < c; t++, d += 2) {
    const E = asciiToBase16$2(o.charCodeAt(d)), B = asciiToBase16$2(o.charCodeAt(d + 1));
    if (E === void 0 || B === void 0) {
      const D = o[d] + o[d + 1];
      throw new Error('hex string expected, got non-hex character "' + D + '" at index ' + d);
    }
    y[t] = E * 16 + B;
  }
  return y;
}
function utf8ToBytes$2(o) {
  if (typeof o != "string")
    throw new Error(`utf8ToBytes expected string, got ${typeof o}`);
  return new Uint8Array(new TextEncoder().encode(o));
}
function toBytes$1(o) {
  return typeof o == "string" && (o = utf8ToBytes$2(o)), bytes(o), o;
}
function concatBytes$4(...o) {
  let g = 0;
  for (let y = 0; y < o.length; y++) {
    const t = o[y];
    bytes(t), g += t.length;
  }
  const c = new Uint8Array(g);
  for (let y = 0, t = 0; y < o.length; y++) {
    const d = o[y];
    c.set(d, t), t += d.length;
  }
  return c;
}
let Hash$1 = class {
  // Safe version that clones internal state
  clone() {
    return this._cloneInto();
  }
};
function wrapConstructor(o) {
  const g = (y) => o().update(toBytes$1(y)).digest(), c = o();
  return g.outputLen = c.outputLen, g.blockLen = c.blockLen, g.create = () => o(), g;
}
function randomBytes$1(o = 32) {
  if (crypto$4 && typeof crypto$4.getRandomValues == "function")
    return crypto$4.getRandomValues(new Uint8Array(o));
  throw new Error("crypto.getRandomValues must be defined");
}
let HMAC$1 = class extends Hash$1 {
  constructor(g, c) {
    super(), this.finished = !1, this.destroyed = !1, hash$m(g);
    const y = toBytes$1(c);
    if (this.iHash = g.create(), typeof this.iHash.update != "function")
      throw new Error("Expected instance of class which extends utils.Hash");
    this.blockLen = this.iHash.blockLen, this.outputLen = this.iHash.outputLen;
    const t = this.blockLen, d = new Uint8Array(t);
    d.set(y.length > t ? g.create().update(y).digest() : y);
    for (let E = 0; E < d.length; E++)
      d[E] ^= 54;
    this.iHash.update(d), this.oHash = g.create();
    for (let E = 0; E < d.length; E++)
      d[E] ^= 106;
    this.oHash.update(d), d.fill(0);
  }
  update(g) {
    return exists(this), this.iHash.update(g), this;
  }
  digestInto(g) {
    exists(this), bytes(g, this.outputLen), this.finished = !0, this.iHash.digestInto(g), this.oHash.update(g), this.oHash.digestInto(g), this.destroy();
  }
  digest() {
    const g = new Uint8Array(this.oHash.outputLen);
    return this.digestInto(g), g;
  }
  _cloneInto(g) {
    g || (g = Object.create(Object.getPrototypeOf(this), {}));
    const { oHash: c, iHash: y, finished: t, destroyed: d, blockLen: E, outputLen: B } = this;
    return g = g, g.finished = t, g.destroyed = d, g.blockLen = E, g.outputLen = B, g.oHash = c._cloneInto(g.oHash), g.iHash = y._cloneInto(g.iHash), g;
  }
  destroy() {
    this.destroyed = !0, this.oHash.destroy(), this.iHash.destroy();
  }
};
const hmac$2 = (o, g, c) => new HMAC$1(o, g).update(c).digest();
hmac$2.create = (o, g) => new HMAC$1(o, g);
function setBigUint64$1(o, g, c, y) {
  if (typeof o.setBigUint64 == "function")
    return o.setBigUint64(g, c, y);
  const t = BigInt(32), d = BigInt(4294967295), E = Number(c >> t & d), B = Number(c & d), D = y ? 4 : 0, x = y ? 0 : 4;
  o.setUint32(g + D, E, y), o.setUint32(g + x, B, y);
}
const Chi$1 = (o, g, c) => o & g ^ ~o & c, Maj$1 = (o, g, c) => o & g ^ o & c ^ g & c;
let HashMD$1 = class extends Hash$1 {
  constructor(g, c, y, t) {
    super(), this.blockLen = g, this.outputLen = c, this.padOffset = y, this.isLE = t, this.finished = !1, this.length = 0, this.pos = 0, this.destroyed = !1, this.buffer = new Uint8Array(g), this.view = createView$2(this.buffer);
  }
  update(g) {
    exists(this);
    const { view: c, buffer: y, blockLen: t } = this;
    g = toBytes$1(g);
    const d = g.length;
    for (let E = 0; E < d; ) {
      const B = Math.min(t - this.pos, d - E);
      if (B === t) {
        const D = createView$2(g);
        for (; t <= d - E; E += t)
          this.process(D, E);
        continue;
      }
      y.set(g.subarray(E, E + B), this.pos), this.pos += B, E += B, this.pos === t && (this.process(c, 0), this.pos = 0);
    }
    return this.length += g.length, this.roundClean(), this;
  }
  digestInto(g) {
    exists(this), output(g, this), this.finished = !0;
    const { buffer: c, view: y, blockLen: t, isLE: d } = this;
    let { pos: E } = this;
    c[E++] = 128, this.buffer.subarray(E).fill(0), this.padOffset > t - E && (this.process(y, 0), E = 0);
    for (let F = E; F < t; F++)
      c[F] = 0;
    setBigUint64$1(y, t - 8, BigInt(this.length * 8), d), this.process(y, 0);
    const B = createView$2(g), D = this.outputLen;
    if (D % 4)
      throw new Error("_sha2: outputLen should be aligned to 32bit");
    const x = D / 4, v = this.get();
    if (x > v.length)
      throw new Error("_sha2: outputLen bigger than state");
    for (let F = 0; F < x; F++)
      B.setUint32(4 * F, v[F], d);
  }
  digest() {
    const { buffer: g, outputLen: c } = this;
    this.digestInto(g);
    const y = g.slice(0, c);
    return this.destroy(), y;
  }
  _cloneInto(g) {
    g || (g = new this.constructor()), g.set(...this.get());
    const { blockLen: c, buffer: y, length: t, finished: d, destroyed: E, pos: B } = this;
    return g.length = t, g.pos = B, g.finished = d, g.destroyed = E, t % c && g.buffer.set(y), g;
  }
};
const Rho = /* @__PURE__ */ new Uint8Array([7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8]), Id = /* @__PURE__ */ new Uint8Array(new Array(16).fill(0).map((o, g) => g)), Pi = /* @__PURE__ */ Id.map((o) => (9 * o + 5) % 16);
let idxL$1 = [Id], idxR$1 = [Pi];
for (let o = 0; o < 4; o++)
  for (let g of [idxL$1, idxR$1])
    g.push(g[o].map((c) => Rho[c]));
const shifts = /* @__PURE__ */ [
  [11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8],
  [12, 13, 11, 15, 6, 9, 9, 7, 12, 15, 11, 13, 7, 8, 7, 7],
  [13, 15, 14, 11, 7, 7, 6, 8, 13, 14, 13, 12, 5, 5, 6, 9],
  [14, 11, 12, 14, 8, 6, 5, 5, 15, 12, 15, 14, 9, 9, 8, 6],
  [15, 12, 13, 13, 9, 5, 8, 6, 14, 11, 12, 11, 8, 6, 5, 5]
].map((o) => new Uint8Array(o)), shiftsL = /* @__PURE__ */ idxL$1.map((o, g) => o.map((c) => shifts[g][c])), shiftsR = /* @__PURE__ */ idxR$1.map((o, g) => o.map((c) => shifts[g][c])), Kl = /* @__PURE__ */ new Uint32Array([
  0,
  1518500249,
  1859775393,
  2400959708,
  2840853838
]), Kr = /* @__PURE__ */ new Uint32Array([
  1352829926,
  1548603684,
  1836072691,
  2053994217,
  0
]);
function f(o, g, c, y) {
  return o === 0 ? g ^ c ^ y : o === 1 ? g & c | ~g & y : o === 2 ? (g | ~c) ^ y : o === 3 ? g & y | c & ~y : g ^ (c | ~y);
}
const R_BUF = /* @__PURE__ */ new Uint32Array(16);
let RIPEMD160$1 = class extends HashMD$1 {
  constructor() {
    super(64, 20, 8, !0), this.h0 = 1732584193, this.h1 = -271733879, this.h2 = -1732584194, this.h3 = 271733878, this.h4 = -1009589776;
  }
  get() {
    const { h0: g, h1: c, h2: y, h3: t, h4: d } = this;
    return [g, c, y, t, d];
  }
  set(g, c, y, t, d) {
    this.h0 = g | 0, this.h1 = c | 0, this.h2 = y | 0, this.h3 = t | 0, this.h4 = d | 0;
  }
  process(g, c) {
    for (let U = 0; U < 16; U++, c += 4)
      R_BUF[U] = g.getUint32(c, !0);
    let y = this.h0 | 0, t = y, d = this.h1 | 0, E = d, B = this.h2 | 0, D = B, x = this.h3 | 0, v = x, F = this.h4 | 0, M = F;
    for (let U = 0; U < 5; U++) {
      const L = 4 - U, H = Kl[U], fe = Kr[U], ge = idxL$1[U], Ie = idxR$1[U], Ee = shiftsL[U], Se = shiftsR[U];
      for (let ze = 0; ze < 16; ze++) {
        const He = rotl$1(y + f(U, d, B, x) + R_BUF[ge[ze]] + H, Ee[ze]) + F | 0;
        y = F, F = x, x = rotl$1(B, 10) | 0, B = d, d = He;
      }
      for (let ze = 0; ze < 16; ze++) {
        const He = rotl$1(t + f(L, E, D, v) + R_BUF[Ie[ze]] + fe, Se[ze]) + M | 0;
        t = M, M = v, v = rotl$1(D, 10) | 0, D = E, E = He;
      }
    }
    this.set(this.h1 + B + v | 0, this.h2 + x + M | 0, this.h3 + F + t | 0, this.h4 + y + E | 0, this.h0 + d + D | 0);
  }
  roundClean() {
    R_BUF.fill(0);
  }
  destroy() {
    this.destroyed = !0, this.buffer.fill(0), this.set(0, 0, 0, 0, 0);
  }
};
const ripemd160$3 = /* @__PURE__ */ wrapConstructor(() => new RIPEMD160$1()), SHA256_K$1 = /* @__PURE__ */ new Uint32Array([
  1116352408,
  1899447441,
  3049323471,
  3921009573,
  961987163,
  1508970993,
  2453635748,
  2870763221,
  3624381080,
  310598401,
  607225278,
  1426881987,
  1925078388,
  2162078206,
  2614888103,
  3248222580,
  3835390401,
  4022224774,
  264347078,
  604807628,
  770255983,
  1249150122,
  1555081692,
  1996064986,
  2554220882,
  2821834349,
  2952996808,
  3210313671,
  3336571891,
  3584528711,
  113926993,
  338241895,
  666307205,
  773529912,
  1294757372,
  1396182291,
  1695183700,
  1986661051,
  2177026350,
  2456956037,
  2730485921,
  2820302411,
  3259730800,
  3345764771,
  3516065817,
  3600352804,
  4094571909,
  275423344,
  430227734,
  506948616,
  659060556,
  883997877,
  958139571,
  1322822218,
  1537002063,
  1747873779,
  1955562222,
  2024104815,
  2227730452,
  2361852424,
  2428436474,
  2756734187,
  3204031479,
  3329325298
]), SHA256_IV$1 = /* @__PURE__ */ new Uint32Array([
  1779033703,
  3144134277,
  1013904242,
  2773480762,
  1359893119,
  2600822924,
  528734635,
  1541459225
]), SHA256_W$1 = /* @__PURE__ */ new Uint32Array(64);
let SHA256$1 = class extends HashMD$1 {
  constructor() {
    super(64, 32, 8, !1), this.A = SHA256_IV$1[0] | 0, this.B = SHA256_IV$1[1] | 0, this.C = SHA256_IV$1[2] | 0, this.D = SHA256_IV$1[3] | 0, this.E = SHA256_IV$1[4] | 0, this.F = SHA256_IV$1[5] | 0, this.G = SHA256_IV$1[6] | 0, this.H = SHA256_IV$1[7] | 0;
  }
  get() {
    const { A: g, B: c, C: y, D: t, E: d, F: E, G: B, H: D } = this;
    return [g, c, y, t, d, E, B, D];
  }
  // prettier-ignore
  set(g, c, y, t, d, E, B, D) {
    this.A = g | 0, this.B = c | 0, this.C = y | 0, this.D = t | 0, this.E = d | 0, this.F = E | 0, this.G = B | 0, this.H = D | 0;
  }
  process(g, c) {
    for (let F = 0; F < 16; F++, c += 4)
      SHA256_W$1[F] = g.getUint32(c, !1);
    for (let F = 16; F < 64; F++) {
      const M = SHA256_W$1[F - 15], U = SHA256_W$1[F - 2], L = rotr$1(M, 7) ^ rotr$1(M, 18) ^ M >>> 3, H = rotr$1(U, 17) ^ rotr$1(U, 19) ^ U >>> 10;
      SHA256_W$1[F] = H + SHA256_W$1[F - 7] + L + SHA256_W$1[F - 16] | 0;
    }
    let { A: y, B: t, C: d, D: E, E: B, F: D, G: x, H: v } = this;
    for (let F = 0; F < 64; F++) {
      const M = rotr$1(B, 6) ^ rotr$1(B, 11) ^ rotr$1(B, 25), U = v + M + Chi$1(B, D, x) + SHA256_K$1[F] + SHA256_W$1[F] | 0, H = (rotr$1(y, 2) ^ rotr$1(y, 13) ^ rotr$1(y, 22)) + Maj$1(y, t, d) | 0;
      v = x, x = D, D = B, B = E + U | 0, E = d, d = t, t = y, y = U + H | 0;
    }
    y = y + this.A | 0, t = t + this.B | 0, d = d + this.C | 0, E = E + this.D | 0, B = B + this.E | 0, D = D + this.F | 0, x = x + this.G | 0, v = v + this.H | 0, this.set(y, t, d, E, B, D, x, v);
  }
  roundClean() {
    SHA256_W$1.fill(0);
  }
  destroy() {
    this.set(0, 0, 0, 0, 0, 0, 0, 0), this.buffer.fill(0);
  }
};
const sha256$3 = /* @__PURE__ */ wrapConstructor(() => new SHA256$1()), U32_MASK64 = /* @__PURE__ */ BigInt(2 ** 32 - 1), _32n = /* @__PURE__ */ BigInt(32);
function fromBig(o, g = !1) {
  return g ? { h: Number(o & U32_MASK64), l: Number(o >> _32n & U32_MASK64) } : { h: Number(o >> _32n & U32_MASK64) | 0, l: Number(o & U32_MASK64) | 0 };
}
function split(o, g = !1) {
  let c = new Uint32Array(o.length), y = new Uint32Array(o.length);
  for (let t = 0; t < o.length; t++) {
    const { h: d, l: E } = fromBig(o[t], g);
    [c[t], y[t]] = [d, E];
  }
  return [c, y];
}
const toBig = (o, g) => BigInt(o >>> 0) << _32n | BigInt(g >>> 0), shrSH = (o, g, c) => o >>> c, shrSL = (o, g, c) => o << 32 - c | g >>> c, rotrSH = (o, g, c) => o >>> c | g << 32 - c, rotrSL = (o, g, c) => o << 32 - c | g >>> c, rotrBH = (o, g, c) => o << 64 - c | g >>> c - 32, rotrBL = (o, g, c) => o >>> c - 32 | g << 64 - c, rotr32H = (o, g) => g, rotr32L = (o, g) => o, rotlSH = (o, g, c) => o << c | g >>> 32 - c, rotlSL = (o, g, c) => g << c | o >>> 32 - c, rotlBH = (o, g, c) => g << c - 32 | o >>> 64 - c, rotlBL = (o, g, c) => o << c - 32 | g >>> 64 - c;
function add(o, g, c, y) {
  const t = (g >>> 0) + (y >>> 0);
  return { h: o + c + (t / 2 ** 32 | 0) | 0, l: t | 0 };
}
const add3L = (o, g, c) => (o >>> 0) + (g >>> 0) + (c >>> 0), add3H = (o, g, c, y) => g + c + y + (o / 2 ** 32 | 0) | 0, add4L = (o, g, c, y) => (o >>> 0) + (g >>> 0) + (c >>> 0) + (y >>> 0), add4H = (o, g, c, y, t) => g + c + y + t + (o / 2 ** 32 | 0) | 0, add5L = (o, g, c, y, t) => (o >>> 0) + (g >>> 0) + (c >>> 0) + (y >>> 0) + (t >>> 0), add5H = (o, g, c, y, t, d) => g + c + y + t + d + (o / 2 ** 32 | 0) | 0, u64 = {
  fromBig,
  split,
  toBig,
  shrSH,
  shrSL,
  rotrSH,
  rotrSL,
  rotrBH,
  rotrBL,
  rotr32H,
  rotr32L,
  rotlSH,
  rotlSL,
  rotlBH,
  rotlBL,
  add,
  add3L,
  add3H,
  add4L,
  add4H,
  add5H,
  add5L
}, [SHA512_Kh, SHA512_Kl] = u64.split([
  "0x428a2f98d728ae22",
  "0x7137449123ef65cd",
  "0xb5c0fbcfec4d3b2f",
  "0xe9b5dba58189dbbc",
  "0x3956c25bf348b538",
  "0x59f111f1b605d019",
  "0x923f82a4af194f9b",
  "0xab1c5ed5da6d8118",
  "0xd807aa98a3030242",
  "0x12835b0145706fbe",
  "0x243185be4ee4b28c",
  "0x550c7dc3d5ffb4e2",
  "0x72be5d74f27b896f",
  "0x80deb1fe3b1696b1",
  "0x9bdc06a725c71235",
  "0xc19bf174cf692694",
  "0xe49b69c19ef14ad2",
  "0xefbe4786384f25e3",
  "0x0fc19dc68b8cd5b5",
  "0x240ca1cc77ac9c65",
  "0x2de92c6f592b0275",
  "0x4a7484aa6ea6e483",
  "0x5cb0a9dcbd41fbd4",
  "0x76f988da831153b5",
  "0x983e5152ee66dfab",
  "0xa831c66d2db43210",
  "0xb00327c898fb213f",
  "0xbf597fc7beef0ee4",
  "0xc6e00bf33da88fc2",
  "0xd5a79147930aa725",
  "0x06ca6351e003826f",
  "0x142929670a0e6e70",
  "0x27b70a8546d22ffc",
  "0x2e1b21385c26c926",
  "0x4d2c6dfc5ac42aed",
  "0x53380d139d95b3df",
  "0x650a73548baf63de",
  "0x766a0abb3c77b2a8",
  "0x81c2c92e47edaee6",
  "0x92722c851482353b",
  "0xa2bfe8a14cf10364",
  "0xa81a664bbc423001",
  "0xc24b8b70d0f89791",
  "0xc76c51a30654be30",
  "0xd192e819d6ef5218",
  "0xd69906245565a910",
  "0xf40e35855771202a",
  "0x106aa07032bbd1b8",
  "0x19a4c116b8d2d0c8",
  "0x1e376c085141ab53",
  "0x2748774cdf8eeb99",
  "0x34b0bcb5e19b48a8",
  "0x391c0cb3c5c95a63",
  "0x4ed8aa4ae3418acb",
  "0x5b9cca4f7763e373",
  "0x682e6ff3d6b2b8a3",
  "0x748f82ee5defb2fc",
  "0x78a5636f43172f60",
  "0x84c87814a1f0ab72",
  "0x8cc702081a6439ec",
  "0x90befffa23631e28",
  "0xa4506cebde82bde9",
  "0xbef9a3f7b2c67915",
  "0xc67178f2e372532b",
  "0xca273eceea26619c",
  "0xd186b8c721c0c207",
  "0xeada7dd6cde0eb1e",
  "0xf57d4f7fee6ed178",
  "0x06f067aa72176fba",
  "0x0a637dc5a2c898a6",
  "0x113f9804bef90dae",
  "0x1b710b35131c471b",
  "0x28db77f523047d84",
  "0x32caab7b40c72493",
  "0x3c9ebe0a15c9bebc",
  "0x431d67c49c100d4c",
  "0x4cc5d4becb3e42b6",
  "0x597f299cfc657e2a",
  "0x5fcb6fab3ad6faec",
  "0x6c44198c4a475817"
].map((o) => BigInt(o))), SHA512_W_H = /* @__PURE__ */ new Uint32Array(80), SHA512_W_L = /* @__PURE__ */ new Uint32Array(80);
class SHA512 extends HashMD$1 {
  constructor() {
    super(128, 64, 16, !1), this.Ah = 1779033703, this.Al = -205731576, this.Bh = -1150833019, this.Bl = -2067093701, this.Ch = 1013904242, this.Cl = -23791573, this.Dh = -1521486534, this.Dl = 1595750129, this.Eh = 1359893119, this.El = -1377402159, this.Fh = -1694144372, this.Fl = 725511199, this.Gh = 528734635, this.Gl = -79577749, this.Hh = 1541459225, this.Hl = 327033209;
  }
  // prettier-ignore
  get() {
    const { Ah: g, Al: c, Bh: y, Bl: t, Ch: d, Cl: E, Dh: B, Dl: D, Eh: x, El: v, Fh: F, Fl: M, Gh: U, Gl: L, Hh: H, Hl: fe } = this;
    return [g, c, y, t, d, E, B, D, x, v, F, M, U, L, H, fe];
  }
  // prettier-ignore
  set(g, c, y, t, d, E, B, D, x, v, F, M, U, L, H, fe) {
    this.Ah = g | 0, this.Al = c | 0, this.Bh = y | 0, this.Bl = t | 0, this.Ch = d | 0, this.Cl = E | 0, this.Dh = B | 0, this.Dl = D | 0, this.Eh = x | 0, this.El = v | 0, this.Fh = F | 0, this.Fl = M | 0, this.Gh = U | 0, this.Gl = L | 0, this.Hh = H | 0, this.Hl = fe | 0;
  }
  process(g, c) {
    for (let Ee = 0; Ee < 16; Ee++, c += 4)
      SHA512_W_H[Ee] = g.getUint32(c), SHA512_W_L[Ee] = g.getUint32(c += 4);
    for (let Ee = 16; Ee < 80; Ee++) {
      const Se = SHA512_W_H[Ee - 15] | 0, ze = SHA512_W_L[Ee - 15] | 0, He = u64.rotrSH(Se, ze, 1) ^ u64.rotrSH(Se, ze, 8) ^ u64.shrSH(Se, ze, 7), Pe = u64.rotrSL(Se, ze, 1) ^ u64.rotrSL(Se, ze, 8) ^ u64.shrSL(Se, ze, 7), De = SHA512_W_H[Ee - 2] | 0, ve = SHA512_W_L[Ee - 2] | 0, Fe = u64.rotrSH(De, ve, 19) ^ u64.rotrBH(De, ve, 61) ^ u64.shrSH(De, ve, 6), be = u64.rotrSL(De, ve, 19) ^ u64.rotrBL(De, ve, 61) ^ u64.shrSL(De, ve, 6), Be = u64.add4L(Pe, be, SHA512_W_L[Ee - 7], SHA512_W_L[Ee - 16]), ke = u64.add4H(Be, He, Fe, SHA512_W_H[Ee - 7], SHA512_W_H[Ee - 16]);
      SHA512_W_H[Ee] = ke | 0, SHA512_W_L[Ee] = Be | 0;
    }
    let { Ah: y, Al: t, Bh: d, Bl: E, Ch: B, Cl: D, Dh: x, Dl: v, Eh: F, El: M, Fh: U, Fl: L, Gh: H, Gl: fe, Hh: ge, Hl: Ie } = this;
    for (let Ee = 0; Ee < 80; Ee++) {
      const Se = u64.rotrSH(F, M, 14) ^ u64.rotrSH(F, M, 18) ^ u64.rotrBH(F, M, 41), ze = u64.rotrSL(F, M, 14) ^ u64.rotrSL(F, M, 18) ^ u64.rotrBL(F, M, 41), He = F & U ^ ~F & H, Pe = M & L ^ ~M & fe, De = u64.add5L(Ie, ze, Pe, SHA512_Kl[Ee], SHA512_W_L[Ee]), ve = u64.add5H(De, ge, Se, He, SHA512_Kh[Ee], SHA512_W_H[Ee]), Fe = De | 0, be = u64.rotrSH(y, t, 28) ^ u64.rotrBH(y, t, 34) ^ u64.rotrBH(y, t, 39), Be = u64.rotrSL(y, t, 28) ^ u64.rotrBL(y, t, 34) ^ u64.rotrBL(y, t, 39), ke = y & d ^ y & B ^ d & B, xe = t & E ^ t & D ^ E & D;
      ge = H | 0, Ie = fe | 0, H = U | 0, fe = L | 0, U = F | 0, L = M | 0, { h: F, l: M } = u64.add(x | 0, v | 0, ve | 0, Fe | 0), x = B | 0, v = D | 0, B = d | 0, D = E | 0, d = y | 0, E = t | 0;
      const Ne = u64.add3L(Fe, Be, xe);
      y = u64.add3H(Ne, ve, be, ke), t = Ne | 0;
    }
    ({ h: y, l: t } = u64.add(this.Ah | 0, this.Al | 0, y | 0, t | 0)), { h: d, l: E } = u64.add(this.Bh | 0, this.Bl | 0, d | 0, E | 0), { h: B, l: D } = u64.add(this.Ch | 0, this.Cl | 0, B | 0, D | 0), { h: x, l: v } = u64.add(this.Dh | 0, this.Dl | 0, x | 0, v | 0), { h: F, l: M } = u64.add(this.Eh | 0, this.El | 0, F | 0, M | 0), { h: U, l: L } = u64.add(this.Fh | 0, this.Fl | 0, U | 0, L | 0), { h: H, l: fe } = u64.add(this.Gh | 0, this.Gl | 0, H | 0, fe | 0), { h: ge, l: Ie } = u64.add(this.Hh | 0, this.Hl | 0, ge | 0, Ie | 0), this.set(y, t, d, E, B, D, x, v, F, M, U, L, H, fe, ge, Ie);
  }
  roundClean() {
    SHA512_W_H.fill(0), SHA512_W_L.fill(0);
  }
  destroy() {
    this.buffer.fill(0), this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
  }
}
const sha512$2 = /* @__PURE__ */ wrapConstructor(() => new SHA512());
const _0n$8 = /* @__PURE__ */ BigInt(0), _1n$9 = /* @__PURE__ */ BigInt(1), _2n$5 = /* @__PURE__ */ BigInt(2);
function isBytes$5(o) {
  return o instanceof Uint8Array || o != null && typeof o == "object" && o.constructor.name === "Uint8Array";
}
function abytes$2(o) {
  if (!isBytes$5(o))
    throw new Error("Uint8Array expected");
}
const hexes$1 = /* @__PURE__ */ Array.from({ length: 256 }, (o, g) => g.toString(16).padStart(2, "0"));
function bytesToHex$1(o) {
  abytes$2(o);
  let g = "";
  for (let c = 0; c < o.length; c++)
    g += hexes$1[o[c]];
  return g;
}
function numberToHexUnpadded$1(o) {
  const g = o.toString(16);
  return g.length & 1 ? `0${g}` : g;
}
function hexToNumber$1(o) {
  if (typeof o != "string")
    throw new Error("hex string expected, got " + typeof o);
  return BigInt(o === "" ? "0" : `0x${o}`);
}
const asciis$1 = { _0: 48, _9: 57, _A: 65, _F: 70, _a: 97, _f: 102 };
function asciiToBase16$1(o) {
  if (o >= asciis$1._0 && o <= asciis$1._9)
    return o - asciis$1._0;
  if (o >= asciis$1._A && o <= asciis$1._F)
    return o - (asciis$1._A - 10);
  if (o >= asciis$1._a && o <= asciis$1._f)
    return o - (asciis$1._a - 10);
}
function hexToBytes$1(o) {
  if (typeof o != "string")
    throw new Error("hex string expected, got " + typeof o);
  const g = o.length, c = g / 2;
  if (g % 2)
    throw new Error("padded hex string expected, got unpadded hex of length " + g);
  const y = new Uint8Array(c);
  for (let t = 0, d = 0; t < c; t++, d += 2) {
    const E = asciiToBase16$1(o.charCodeAt(d)), B = asciiToBase16$1(o.charCodeAt(d + 1));
    if (E === void 0 || B === void 0) {
      const D = o[d] + o[d + 1];
      throw new Error('hex string expected, got non-hex character "' + D + '" at index ' + d);
    }
    y[t] = E * 16 + B;
  }
  return y;
}
function bytesToNumberBE$1(o) {
  return hexToNumber$1(bytesToHex$1(o));
}
function bytesToNumberLE$1(o) {
  return abytes$2(o), hexToNumber$1(bytesToHex$1(Uint8Array.from(o).reverse()));
}
function numberToBytesBE$1(o, g) {
  return hexToBytes$1(o.toString(16).padStart(g * 2, "0"));
}
function numberToBytesLE$1(o, g) {
  return numberToBytesBE$1(o, g).reverse();
}
function numberToVarBytesBE(o) {
  return hexToBytes$1(numberToHexUnpadded$1(o));
}
function ensureBytes$1(o, g, c) {
  let y;
  if (typeof g == "string")
    try {
      y = hexToBytes$1(g);
    } catch (d) {
      throw new Error(`${o} must be valid hex string, got "${g}". Cause: ${d}`);
    }
  else if (isBytes$5(g))
    y = Uint8Array.from(g);
  else
    throw new Error(`${o} must be hex string or Uint8Array`);
  const t = y.length;
  if (typeof c == "number" && t !== c)
    throw new Error(`${o} expected ${c} bytes, got ${t}`);
  return y;
}
function concatBytes$3(...o) {
  let g = 0;
  for (let y = 0; y < o.length; y++) {
    const t = o[y];
    abytes$2(t), g += t.length;
  }
  const c = new Uint8Array(g);
  for (let y = 0, t = 0; y < o.length; y++) {
    const d = o[y];
    c.set(d, t), t += d.length;
  }
  return c;
}
function equalBytes$2(o, g) {
  if (o.length !== g.length)
    return !1;
  let c = 0;
  for (let y = 0; y < o.length; y++)
    c |= o[y] ^ g[y];
  return c === 0;
}
function utf8ToBytes$1(o) {
  if (typeof o != "string")
    throw new Error(`utf8ToBytes expected string, got ${typeof o}`);
  return new Uint8Array(new TextEncoder().encode(o));
}
function bitLen$1(o) {
  let g;
  for (g = 0; o > _0n$8; o >>= _1n$9, g += 1)
    ;
  return g;
}
function bitGet(o, g) {
  return o >> BigInt(g) & _1n$9;
}
function bitSet(o, g, c) {
  return o | (c ? _1n$9 : _0n$8) << BigInt(g);
}
const bitMask$1 = (o) => (_2n$5 << BigInt(o - 1)) - _1n$9, u8n = (o) => new Uint8Array(o), u8fr = (o) => Uint8Array.from(o);
function createHmacDrbg$1(o, g, c) {
  if (typeof o != "number" || o < 2)
    throw new Error("hashLen must be a number");
  if (typeof g != "number" || g < 2)
    throw new Error("qByteLen must be a number");
  if (typeof c != "function")
    throw new Error("hmacFn must be a function");
  let y = u8n(o), t = u8n(o), d = 0;
  const E = () => {
    y.fill(1), t.fill(0), d = 0;
  }, B = (...F) => c(t, y, ...F), D = (F = u8n()) => {
    t = B(u8fr([0]), F), y = B(), F.length !== 0 && (t = B(u8fr([1]), F), y = B());
  }, x = () => {
    if (d++ >= 1e3)
      throw new Error("drbg: tried 1000 values");
    let F = 0;
    const M = [];
    for (; F < g; ) {
      y = B();
      const U = y.slice();
      M.push(U), F += y.length;
    }
    return concatBytes$3(...M);
  };
  return (F, M) => {
    E(), D(F);
    let U;
    for (; !(U = M(x())); )
      D();
    return E(), U;
  };
}
const validatorFns = {
  bigint: (o) => typeof o == "bigint",
  function: (o) => typeof o == "function",
  boolean: (o) => typeof o == "boolean",
  string: (o) => typeof o == "string",
  stringOrUint8Array: (o) => typeof o == "string" || isBytes$5(o),
  isSafeInteger: (o) => Number.isSafeInteger(o),
  array: (o) => Array.isArray(o),
  field: (o, g) => g.Fp.isValid(o),
  hash: (o) => typeof o == "function" && Number.isSafeInteger(o.outputLen)
};
function validateObject(o, g, c = {}) {
  const y = (t, d, E) => {
    const B = validatorFns[d];
    if (typeof B != "function")
      throw new Error(`Invalid validator "${d}", expected function`);
    const D = o[t];
    if (!(E && D === void 0) && !B(D, o))
      throw new Error(`Invalid param ${String(t)}=${D} (${typeof D}), expected ${d}`);
  };
  for (const [t, d] of Object.entries(g))
    y(t, d, !1);
  for (const [t, d] of Object.entries(c))
    y(t, d, !0);
  return o;
}
const ut = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  abytes: abytes$2,
  bitGet,
  bitLen: bitLen$1,
  bitMask: bitMask$1,
  bitSet,
  bytesToHex: bytesToHex$1,
  bytesToNumberBE: bytesToNumberBE$1,
  bytesToNumberLE: bytesToNumberLE$1,
  concatBytes: concatBytes$3,
  createHmacDrbg: createHmacDrbg$1,
  ensureBytes: ensureBytes$1,
  equalBytes: equalBytes$2,
  hexToBytes: hexToBytes$1,
  hexToNumber: hexToNumber$1,
  isBytes: isBytes$5,
  numberToBytesBE: numberToBytesBE$1,
  numberToBytesLE: numberToBytesLE$1,
  numberToHexUnpadded: numberToHexUnpadded$1,
  numberToVarBytesBE,
  utf8ToBytes: utf8ToBytes$1,
  validateObject
}, Symbol.toStringTag, { value: "Module" }));
const _0n$7 = BigInt(0), _1n$8 = BigInt(1), _2n$4 = BigInt(2), _3n$3 = BigInt(3), _4n$2 = BigInt(4), _5n$1 = BigInt(5), _8n$1 = BigInt(8);
BigInt(9);
BigInt(16);
function mod$1(o, g) {
  const c = o % g;
  return c >= _0n$7 ? c : g + c;
}
function pow(o, g, c) {
  if (c <= _0n$7 || g < _0n$7)
    throw new Error("Expected power/modulo > 0");
  if (c === _1n$8)
    return _0n$7;
  let y = _1n$8;
  for (; g > _0n$7; )
    g & _1n$8 && (y = y * o % c), o = o * o % c, g >>= _1n$8;
  return y;
}
function pow2$1(o, g, c) {
  let y = o;
  for (; g-- > _0n$7; )
    y *= y, y %= c;
  return y;
}
function invert$1(o, g) {
  if (o === _0n$7 || g <= _0n$7)
    throw new Error(`invert: expected positive integers, got n=${o} mod=${g}`);
  let c = mod$1(o, g), y = g, t = _0n$7, d = _1n$8;
  for (; c !== _0n$7; ) {
    const B = y / c, D = y % c, x = t - d * B;
    y = c, c = D, t = d, d = x;
  }
  if (y !== _1n$8)
    throw new Error("invert: does not exist");
  return mod$1(t, g);
}
function tonelliShanks$1(o) {
  const g = (o - _1n$8) / _2n$4;
  let c, y, t;
  for (c = o - _1n$8, y = 0; c % _2n$4 === _0n$7; c /= _2n$4, y++)
    ;
  for (t = _2n$4; t < o && pow(t, g, o) !== o - _1n$8; t++)
    ;
  if (y === 1) {
    const E = (o + _1n$8) / _4n$2;
    return function(D, x) {
      const v = D.pow(x, E);
      if (!D.eql(D.sqr(v), x))
        throw new Error("Cannot find square root");
      return v;
    };
  }
  const d = (c + _1n$8) / _2n$4;
  return function(B, D) {
    if (B.pow(D, g) === B.neg(B.ONE))
      throw new Error("Cannot find square root");
    let x = y, v = B.pow(B.mul(B.ONE, t), c), F = B.pow(D, d), M = B.pow(D, c);
    for (; !B.eql(M, B.ONE); ) {
      if (B.eql(M, B.ZERO))
        return B.ZERO;
      let U = 1;
      for (let H = B.sqr(M); U < x && !B.eql(H, B.ONE); U++)
        H = B.sqr(H);
      const L = B.pow(v, _1n$8 << BigInt(x - U - 1));
      v = B.sqr(L), F = B.mul(F, L), M = B.mul(M, v), x = U;
    }
    return F;
  };
}
function FpSqrt$1(o) {
  if (o % _4n$2 === _3n$3) {
    const g = (o + _1n$8) / _4n$2;
    return function(y, t) {
      const d = y.pow(t, g);
      if (!y.eql(y.sqr(d), t))
        throw new Error("Cannot find square root");
      return d;
    };
  }
  if (o % _8n$1 === _5n$1) {
    const g = (o - _5n$1) / _8n$1;
    return function(y, t) {
      const d = y.mul(t, _2n$4), E = y.pow(d, g), B = y.mul(t, E), D = y.mul(y.mul(B, _2n$4), E), x = y.mul(B, y.sub(D, y.ONE));
      if (!y.eql(y.sqr(x), t))
        throw new Error("Cannot find square root");
      return x;
    };
  }
  return tonelliShanks$1(o);
}
const FIELD_FIELDS$1 = [
  "create",
  "isValid",
  "is0",
  "neg",
  "inv",
  "sqrt",
  "sqr",
  "eql",
  "add",
  "sub",
  "mul",
  "pow",
  "div",
  "addN",
  "subN",
  "mulN",
  "sqrN"
];
function validateField$1(o) {
  const g = {
    ORDER: "bigint",
    MASK: "bigint",
    BYTES: "isSafeInteger",
    BITS: "isSafeInteger"
  }, c = FIELD_FIELDS$1.reduce((y, t) => (y[t] = "function", y), g);
  return validateObject(o, c);
}
function FpPow$1(o, g, c) {
  if (c < _0n$7)
    throw new Error("Expected power > 0");
  if (c === _0n$7)
    return o.ONE;
  if (c === _1n$8)
    return g;
  let y = o.ONE, t = g;
  for (; c > _0n$7; )
    c & _1n$8 && (y = o.mul(y, t)), t = o.sqr(t), c >>= _1n$8;
  return y;
}
function FpInvertBatch$1(o, g) {
  const c = new Array(g.length), y = g.reduce((d, E, B) => o.is0(E) ? d : (c[B] = d, o.mul(d, E)), o.ONE), t = o.inv(y);
  return g.reduceRight((d, E, B) => o.is0(E) ? d : (c[B] = o.mul(d, c[B]), o.mul(d, E)), t), c;
}
function nLength$1(o, g) {
  const c = g !== void 0 ? g : o.toString(2).length, y = Math.ceil(c / 8);
  return { nBitLength: c, nByteLength: y };
}
function Field$1(o, g, c = !1, y = {}) {
  if (o <= _0n$7)
    throw new Error(`Expected Field ORDER > 0, got ${o}`);
  const { nBitLength: t, nByteLength: d } = nLength$1(o, g);
  if (d > 2048)
    throw new Error("Field lengths over 2048 bytes are not supported");
  const E = FpSqrt$1(o), B = Object.freeze({
    ORDER: o,
    BITS: t,
    BYTES: d,
    MASK: bitMask$1(t),
    ZERO: _0n$7,
    ONE: _1n$8,
    create: (D) => mod$1(D, o),
    isValid: (D) => {
      if (typeof D != "bigint")
        throw new Error(`Invalid field element: expected bigint, got ${typeof D}`);
      return _0n$7 <= D && D < o;
    },
    is0: (D) => D === _0n$7,
    isOdd: (D) => (D & _1n$8) === _1n$8,
    neg: (D) => mod$1(-D, o),
    eql: (D, x) => D === x,
    sqr: (D) => mod$1(D * D, o),
    add: (D, x) => mod$1(D + x, o),
    sub: (D, x) => mod$1(D - x, o),
    mul: (D, x) => mod$1(D * x, o),
    pow: (D, x) => FpPow$1(B, D, x),
    div: (D, x) => mod$1(D * invert$1(x, o), o),
    // Same as above, but doesn't normalize
    sqrN: (D) => D * D,
    addN: (D, x) => D + x,
    subN: (D, x) => D - x,
    mulN: (D, x) => D * x,
    inv: (D) => invert$1(D, o),
    sqrt: y.sqrt || ((D) => E(B, D)),
    invertBatch: (D) => FpInvertBatch$1(B, D),
    // TODO: do we really need constant cmov?
    // We don't have const-time bigints anyway, so probably will be not very useful
    cmov: (D, x, v) => v ? x : D,
    toBytes: (D) => c ? numberToBytesLE$1(D, d) : numberToBytesBE$1(D, d),
    fromBytes: (D) => {
      if (D.length !== d)
        throw new Error(`Fp.fromBytes: expected ${d}, got ${D.length}`);
      return c ? bytesToNumberLE$1(D) : bytesToNumberBE$1(D);
    }
  });
  return Object.freeze(B);
}
function getFieldBytesLength$1(o) {
  if (typeof o != "bigint")
    throw new Error("field order must be bigint");
  const g = o.toString(2).length;
  return Math.ceil(g / 8);
}
function getMinHashLength$1(o) {
  const g = getFieldBytesLength$1(o);
  return g + Math.ceil(g / 2);
}
function mapHashToField$1(o, g, c = !1) {
  const y = o.length, t = getFieldBytesLength$1(g), d = getMinHashLength$1(g);
  if (y < 16 || y < d || y > 1024)
    throw new Error(`expected ${d}-1024 bytes of input, got ${y}`);
  const E = c ? bytesToNumberBE$1(o) : bytesToNumberLE$1(o), B = mod$1(E, g - _1n$8) + _1n$8;
  return c ? numberToBytesLE$1(B, t) : numberToBytesBE$1(B, t);
}
const _0n$6 = BigInt(0), _1n$7 = BigInt(1);
function wNAF$1(o, g) {
  const c = (t, d) => {
    const E = d.negate();
    return t ? E : d;
  }, y = (t) => {
    const d = Math.ceil(g / t) + 1, E = 2 ** (t - 1);
    return { windows: d, windowSize: E };
  };
  return {
    constTimeNegate: c,
    // non-const time multiplication ladder
    unsafeLadder(t, d) {
      let E = o.ZERO, B = t;
      for (; d > _0n$6; )
        d & _1n$7 && (E = E.add(B)), B = B.double(), d >>= _1n$7;
      return E;
    },
    /**
     * Creates a wNAF precomputation window. Used for caching.
     * Default window size is set by `utils.precompute()` and is equal to 8.
     * Number of precomputed points depends on the curve size:
     * 2^(𝑊−1) * (Math.ceil(𝑛 / 𝑊) + 1), where:
     * - 𝑊 is the window size
     * - 𝑛 is the bitlength of the curve order.
     * For a 256-bit curve and window size 8, the number of precomputed points is 128 * 33 = 4224.
     * @returns precomputed point tables flattened to a single array
     */
    precomputeWindow(t, d) {
      const { windows: E, windowSize: B } = y(d), D = [];
      let x = t, v = x;
      for (let F = 0; F < E; F++) {
        v = x, D.push(v);
        for (let M = 1; M < B; M++)
          v = v.add(x), D.push(v);
        x = v.double();
      }
      return D;
    },
    /**
     * Implements ec multiplication using precomputed tables and w-ary non-adjacent form.
     * @param W window size
     * @param precomputes precomputed tables
     * @param n scalar (we don't check here, but should be less than curve order)
     * @returns real and fake (for const-time) points
     */
    wNAF(t, d, E) {
      const { windows: B, windowSize: D } = y(t);
      let x = o.ZERO, v = o.BASE;
      const F = BigInt(2 ** t - 1), M = 2 ** t, U = BigInt(t);
      for (let L = 0; L < B; L++) {
        const H = L * D;
        let fe = Number(E & F);
        E >>= U, fe > D && (fe -= M, E += _1n$7);
        const ge = H, Ie = H + Math.abs(fe) - 1, Ee = L % 2 !== 0, Se = fe < 0;
        fe === 0 ? v = v.add(c(Ee, d[ge])) : x = x.add(c(Se, d[Ie]));
      }
      return { p: x, f: v };
    },
    wNAFCached(t, d, E, B) {
      const D = t._WINDOW_SIZE || 1;
      let x = d.get(t);
      return x || (x = this.precomputeWindow(t, D), D !== 1 && d.set(t, B(x))), this.wNAF(D, x, E);
    }
  };
}
function validateBasic(o) {
  return validateField$1(o.Fp), validateObject(o, {
    n: "bigint",
    h: "bigint",
    Gx: "field",
    Gy: "field"
  }, {
    nBitLength: "isSafeInteger",
    nByteLength: "isSafeInteger"
  }), Object.freeze({
    ...nLength$1(o.n, o.nBitLength),
    ...o,
    p: o.Fp.ORDER
  });
}
function validatePointOpts(o) {
  const g = validateBasic(o);
  validateObject(g, {
    a: "field",
    b: "field"
  }, {
    allowedPrivateKeyLengths: "array",
    wrapPrivateKey: "boolean",
    isTorsionFree: "function",
    clearCofactor: "function",
    allowInfinityPoint: "boolean",
    fromBytes: "function",
    toBytes: "function"
  });
  const { endo: c, Fp: y, a: t } = g;
  if (c) {
    if (!y.eql(t, y.ZERO))
      throw new Error("Endomorphism can only be defined for Koblitz curves that have a=0");
    if (typeof c != "object" || typeof c.beta != "bigint" || typeof c.splitScalar != "function")
      throw new Error("Expected endomorphism with beta: bigint and splitScalar: function");
  }
  return Object.freeze({ ...g });
}
const { bytesToNumberBE: b2n, hexToBytes: h2b } = ut, DER$1 = {
  // asn.1 DER encoding utils
  Err: class extends Error {
    constructor(g = "") {
      super(g);
    }
  },
  _parseInt(o) {
    const { Err: g } = DER$1;
    if (o.length < 2 || o[0] !== 2)
      throw new g("Invalid signature integer tag");
    const c = o[1], y = o.subarray(2, c + 2);
    if (!c || y.length !== c)
      throw new g("Invalid signature integer: wrong length");
    if (y[0] & 128)
      throw new g("Invalid signature integer: negative");
    if (y[0] === 0 && !(y[1] & 128))
      throw new g("Invalid signature integer: unnecessary leading zero");
    return { d: b2n(y), l: o.subarray(c + 2) };
  },
  toSig(o) {
    const { Err: g } = DER$1, c = typeof o == "string" ? h2b(o) : o;
    abytes$2(c);
    let y = c.length;
    if (y < 2 || c[0] != 48)
      throw new g("Invalid signature tag");
    if (c[1] !== y - 2)
      throw new g("Invalid signature: incorrect length");
    const { d: t, l: d } = DER$1._parseInt(c.subarray(2)), { d: E, l: B } = DER$1._parseInt(d);
    if (B.length)
      throw new g("Invalid signature: left bytes after parsing");
    return { r: t, s: E };
  },
  hexFromSig(o) {
    const g = (x) => Number.parseInt(x[0], 16) & 8 ? "00" + x : x, c = (x) => {
      const v = x.toString(16);
      return v.length & 1 ? `0${v}` : v;
    }, y = g(c(o.s)), t = g(c(o.r)), d = y.length / 2, E = t.length / 2, B = c(d), D = c(E);
    return `30${c(E + d + 4)}02${D}${t}02${B}${y}`;
  }
}, _0n$5 = BigInt(0), _1n$6 = BigInt(1);
BigInt(2);
const _3n$2 = BigInt(3);
BigInt(4);
function weierstrassPoints(o) {
  const g = validatePointOpts(o), { Fp: c } = g, y = g.toBytes || ((L, H, fe) => {
    const ge = H.toAffine();
    return concatBytes$3(Uint8Array.from([4]), c.toBytes(ge.x), c.toBytes(ge.y));
  }), t = g.fromBytes || ((L) => {
    const H = L.subarray(1), fe = c.fromBytes(H.subarray(0, c.BYTES)), ge = c.fromBytes(H.subarray(c.BYTES, 2 * c.BYTES));
    return { x: fe, y: ge };
  });
  function d(L) {
    const { a: H, b: fe } = g, ge = c.sqr(L), Ie = c.mul(ge, L);
    return c.add(c.add(Ie, c.mul(L, H)), fe);
  }
  if (!c.eql(c.sqr(g.Gy), d(g.Gx)))
    throw new Error("bad generator point: equation left != right");
  function E(L) {
    return typeof L == "bigint" && _0n$5 < L && L < g.n;
  }
  function B(L) {
    if (!E(L))
      throw new Error("Expected valid bigint: 0 < bigint < curve.n");
  }
  function D(L) {
    const { allowedPrivateKeyLengths: H, nByteLength: fe, wrapPrivateKey: ge, n: Ie } = g;
    if (H && typeof L != "bigint") {
      if (isBytes$5(L) && (L = bytesToHex$1(L)), typeof L != "string" || !H.includes(L.length))
        throw new Error("Invalid key");
      L = L.padStart(fe * 2, "0");
    }
    let Ee;
    try {
      Ee = typeof L == "bigint" ? L : bytesToNumberBE$1(ensureBytes$1("private key", L, fe));
    } catch {
      throw new Error(`private key must be ${fe} bytes, hex or bigint, not ${typeof L}`);
    }
    return ge && (Ee = mod$1(Ee, Ie)), B(Ee), Ee;
  }
  const x = /* @__PURE__ */ new Map();
  function v(L) {
    if (!(L instanceof F))
      throw new Error("ProjectivePoint expected");
  }
  class F {
    constructor(H, fe, ge) {
      if (this.px = H, this.py = fe, this.pz = ge, H == null || !c.isValid(H))
        throw new Error("x required");
      if (fe == null || !c.isValid(fe))
        throw new Error("y required");
      if (ge == null || !c.isValid(ge))
        throw new Error("z required");
    }
    // Does not validate if the point is on-curve.
    // Use fromHex instead, or call assertValidity() later.
    static fromAffine(H) {
      const { x: fe, y: ge } = H || {};
      if (!H || !c.isValid(fe) || !c.isValid(ge))
        throw new Error("invalid affine point");
      if (H instanceof F)
        throw new Error("projective point not allowed");
      const Ie = (Ee) => c.eql(Ee, c.ZERO);
      return Ie(fe) && Ie(ge) ? F.ZERO : new F(fe, ge, c.ONE);
    }
    get x() {
      return this.toAffine().x;
    }
    get y() {
      return this.toAffine().y;
    }
    /**
     * Takes a bunch of Projective Points but executes only one
     * inversion on all of them. Inversion is very slow operation,
     * so this improves performance massively.
     * Optimization: converts a list of projective points to a list of identical points with Z=1.
     */
    static normalizeZ(H) {
      const fe = c.invertBatch(H.map((ge) => ge.pz));
      return H.map((ge, Ie) => ge.toAffine(fe[Ie])).map(F.fromAffine);
    }
    /**
     * Converts hash string or Uint8Array to Point.
     * @param hex short/long ECDSA hex
     */
    static fromHex(H) {
      const fe = F.fromAffine(t(ensureBytes$1("pointHex", H)));
      return fe.assertValidity(), fe;
    }
    // Multiplies generator point by privateKey.
    static fromPrivateKey(H) {
      return F.BASE.multiply(D(H));
    }
    // "Private method", don't use it directly
    _setWindowSize(H) {
      this._WINDOW_SIZE = H, x.delete(this);
    }
    // A point on curve is valid if it conforms to equation.
    assertValidity() {
      if (this.is0()) {
        if (g.allowInfinityPoint && !c.is0(this.py))
          return;
        throw new Error("bad point: ZERO");
      }
      const { x: H, y: fe } = this.toAffine();
      if (!c.isValid(H) || !c.isValid(fe))
        throw new Error("bad point: x or y not FE");
      const ge = c.sqr(fe), Ie = d(H);
      if (!c.eql(ge, Ie))
        throw new Error("bad point: equation left != right");
      if (!this.isTorsionFree())
        throw new Error("bad point: not in prime-order subgroup");
    }
    hasEvenY() {
      const { y: H } = this.toAffine();
      if (c.isOdd)
        return !c.isOdd(H);
      throw new Error("Field doesn't support isOdd");
    }
    /**
     * Compare one point to another.
     */
    equals(H) {
      v(H);
      const { px: fe, py: ge, pz: Ie } = this, { px: Ee, py: Se, pz: ze } = H, He = c.eql(c.mul(fe, ze), c.mul(Ee, Ie)), Pe = c.eql(c.mul(ge, ze), c.mul(Se, Ie));
      return He && Pe;
    }
    /**
     * Flips point to one corresponding to (x, -y) in Affine coordinates.
     */
    negate() {
      return new F(this.px, c.neg(this.py), this.pz);
    }
    // Renes-Costello-Batina exception-free doubling formula.
    // There is 30% faster Jacobian formula, but it is not complete.
    // https://eprint.iacr.org/2015/1060, algorithm 3
    // Cost: 8M + 3S + 3*a + 2*b3 + 15add.
    double() {
      const { a: H, b: fe } = g, ge = c.mul(fe, _3n$2), { px: Ie, py: Ee, pz: Se } = this;
      let ze = c.ZERO, He = c.ZERO, Pe = c.ZERO, De = c.mul(Ie, Ie), ve = c.mul(Ee, Ee), Fe = c.mul(Se, Se), be = c.mul(Ie, Ee);
      return be = c.add(be, be), Pe = c.mul(Ie, Se), Pe = c.add(Pe, Pe), ze = c.mul(H, Pe), He = c.mul(ge, Fe), He = c.add(ze, He), ze = c.sub(ve, He), He = c.add(ve, He), He = c.mul(ze, He), ze = c.mul(be, ze), Pe = c.mul(ge, Pe), Fe = c.mul(H, Fe), be = c.sub(De, Fe), be = c.mul(H, be), be = c.add(be, Pe), Pe = c.add(De, De), De = c.add(Pe, De), De = c.add(De, Fe), De = c.mul(De, be), He = c.add(He, De), Fe = c.mul(Ee, Se), Fe = c.add(Fe, Fe), De = c.mul(Fe, be), ze = c.sub(ze, De), Pe = c.mul(Fe, ve), Pe = c.add(Pe, Pe), Pe = c.add(Pe, Pe), new F(ze, He, Pe);
    }
    // Renes-Costello-Batina exception-free addition formula.
    // There is 30% faster Jacobian formula, but it is not complete.
    // https://eprint.iacr.org/2015/1060, algorithm 1
    // Cost: 12M + 0S + 3*a + 3*b3 + 23add.
    add(H) {
      v(H);
      const { px: fe, py: ge, pz: Ie } = this, { px: Ee, py: Se, pz: ze } = H;
      let He = c.ZERO, Pe = c.ZERO, De = c.ZERO;
      const ve = g.a, Fe = c.mul(g.b, _3n$2);
      let be = c.mul(fe, Ee), Be = c.mul(ge, Se), ke = c.mul(Ie, ze), xe = c.add(fe, ge), Ne = c.add(Ee, Se);
      xe = c.mul(xe, Ne), Ne = c.add(be, Be), xe = c.sub(xe, Ne), Ne = c.add(fe, Ie);
      let Et = c.add(Ee, ze);
      return Ne = c.mul(Ne, Et), Et = c.add(be, ke), Ne = c.sub(Ne, Et), Et = c.add(ge, Ie), He = c.add(Se, ze), Et = c.mul(Et, He), He = c.add(Be, ke), Et = c.sub(Et, He), De = c.mul(ve, Ne), He = c.mul(Fe, ke), De = c.add(He, De), He = c.sub(Be, De), De = c.add(Be, De), Pe = c.mul(He, De), Be = c.add(be, be), Be = c.add(Be, be), ke = c.mul(ve, ke), Ne = c.mul(Fe, Ne), Be = c.add(Be, ke), ke = c.sub(be, ke), ke = c.mul(ve, ke), Ne = c.add(Ne, ke), be = c.mul(Be, Ne), Pe = c.add(Pe, be), be = c.mul(Et, Ne), He = c.mul(xe, He), He = c.sub(He, be), be = c.mul(xe, Be), De = c.mul(Et, De), De = c.add(De, be), new F(He, Pe, De);
    }
    subtract(H) {
      return this.add(H.negate());
    }
    is0() {
      return this.equals(F.ZERO);
    }
    wNAF(H) {
      return U.wNAFCached(this, x, H, (fe) => {
        const ge = c.invertBatch(fe.map((Ie) => Ie.pz));
        return fe.map((Ie, Ee) => Ie.toAffine(ge[Ee])).map(F.fromAffine);
      });
    }
    /**
     * Non-constant-time multiplication. Uses double-and-add algorithm.
     * It's faster, but should only be used when you don't care about
     * an exposed private key e.g. sig verification, which works over *public* keys.
     */
    multiplyUnsafe(H) {
      const fe = F.ZERO;
      if (H === _0n$5)
        return fe;
      if (B(H), H === _1n$6)
        return this;
      const { endo: ge } = g;
      if (!ge)
        return U.unsafeLadder(this, H);
      let { k1neg: Ie, k1: Ee, k2neg: Se, k2: ze } = ge.splitScalar(H), He = fe, Pe = fe, De = this;
      for (; Ee > _0n$5 || ze > _0n$5; )
        Ee & _1n$6 && (He = He.add(De)), ze & _1n$6 && (Pe = Pe.add(De)), De = De.double(), Ee >>= _1n$6, ze >>= _1n$6;
      return Ie && (He = He.negate()), Se && (Pe = Pe.negate()), Pe = new F(c.mul(Pe.px, ge.beta), Pe.py, Pe.pz), He.add(Pe);
    }
    /**
     * Constant time multiplication.
     * Uses wNAF method. Windowed method may be 10% faster,
     * but takes 2x longer to generate and consumes 2x memory.
     * Uses precomputes when available.
     * Uses endomorphism for Koblitz curves.
     * @param scalar by which the point would be multiplied
     * @returns New point
     */
    multiply(H) {
      B(H);
      let fe = H, ge, Ie;
      const { endo: Ee } = g;
      if (Ee) {
        const { k1neg: Se, k1: ze, k2neg: He, k2: Pe } = Ee.splitScalar(fe);
        let { p: De, f: ve } = this.wNAF(ze), { p: Fe, f: be } = this.wNAF(Pe);
        De = U.constTimeNegate(Se, De), Fe = U.constTimeNegate(He, Fe), Fe = new F(c.mul(Fe.px, Ee.beta), Fe.py, Fe.pz), ge = De.add(Fe), Ie = ve.add(be);
      } else {
        const { p: Se, f: ze } = this.wNAF(fe);
        ge = Se, Ie = ze;
      }
      return F.normalizeZ([ge, Ie])[0];
    }
    /**
     * Efficiently calculate `aP + bQ`. Unsafe, can expose private key, if used incorrectly.
     * Not using Strauss-Shamir trick: precomputation tables are faster.
     * The trick could be useful if both P and Q are not G (not in our case).
     * @returns non-zero affine point
     */
    multiplyAndAddUnsafe(H, fe, ge) {
      const Ie = F.BASE, Ee = (ze, He) => He === _0n$5 || He === _1n$6 || !ze.equals(Ie) ? ze.multiplyUnsafe(He) : ze.multiply(He), Se = Ee(this, fe).add(Ee(H, ge));
      return Se.is0() ? void 0 : Se;
    }
    // Converts Projective point to affine (x, y) coordinates.
    // Can accept precomputed Z^-1 - for example, from invertBatch.
    // (x, y, z) ∋ (x=x/z, y=y/z)
    toAffine(H) {
      const { px: fe, py: ge, pz: Ie } = this, Ee = this.is0();
      H == null && (H = Ee ? c.ONE : c.inv(Ie));
      const Se = c.mul(fe, H), ze = c.mul(ge, H), He = c.mul(Ie, H);
      if (Ee)
        return { x: c.ZERO, y: c.ZERO };
      if (!c.eql(He, c.ONE))
        throw new Error("invZ was invalid");
      return { x: Se, y: ze };
    }
    isTorsionFree() {
      const { h: H, isTorsionFree: fe } = g;
      if (H === _1n$6)
        return !0;
      if (fe)
        return fe(F, this);
      throw new Error("isTorsionFree() has not been declared for the elliptic curve");
    }
    clearCofactor() {
      const { h: H, clearCofactor: fe } = g;
      return H === _1n$6 ? this : fe ? fe(F, this) : this.multiplyUnsafe(g.h);
    }
    toRawBytes(H = !0) {
      return this.assertValidity(), y(F, this, H);
    }
    toHex(H = !0) {
      return bytesToHex$1(this.toRawBytes(H));
    }
  }
  F.BASE = new F(g.Gx, g.Gy, c.ONE), F.ZERO = new F(c.ZERO, c.ONE, c.ZERO);
  const M = g.nBitLength, U = wNAF$1(F, g.endo ? Math.ceil(M / 2) : M);
  return {
    CURVE: g,
    ProjectivePoint: F,
    normPrivateKeyToScalar: D,
    weierstrassEquation: d,
    isWithinCurveOrder: E
  };
}
function validateOpts$1(o) {
  const g = validateBasic(o);
  return validateObject(g, {
    hash: "hash",
    hmac: "function",
    randomBytes: "function"
  }, {
    bits2int: "function",
    bits2int_modN: "function",
    lowS: "boolean"
  }), Object.freeze({ lowS: !0, ...g });
}
function weierstrass$1(o) {
  const g = validateOpts$1(o), { Fp: c, n: y } = g, t = c.BYTES + 1, d = 2 * c.BYTES + 1;
  function E(Ne) {
    return _0n$5 < Ne && Ne < c.ORDER;
  }
  function B(Ne) {
    return mod$1(Ne, y);
  }
  function D(Ne) {
    return invert$1(Ne, y);
  }
  const { ProjectivePoint: x, normPrivateKeyToScalar: v, weierstrassEquation: F, isWithinCurveOrder: M } = weierstrassPoints({
    ...g,
    toBytes(Ne, Et, st) {
      const Dt = Et.toAffine(), er = c.toBytes(Dt.x), xt = concatBytes$3;
      return st ? xt(Uint8Array.from([Et.hasEvenY() ? 2 : 3]), er) : xt(Uint8Array.from([4]), er, c.toBytes(Dt.y));
    },
    fromBytes(Ne) {
      const Et = Ne.length, st = Ne[0], Dt = Ne.subarray(1);
      if (Et === t && (st === 2 || st === 3)) {
        const er = bytesToNumberBE$1(Dt);
        if (!E(er))
          throw new Error("Point is not on curve");
        const xt = F(er);
        let ir;
        try {
          ir = c.sqrt(xt);
        } catch (wr) {
          const qr = wr instanceof Error ? ": " + wr.message : "";
          throw new Error("Point is not on curve" + qr);
        }
        const sr = (ir & _1n$6) === _1n$6;
        return (st & 1) === 1 !== sr && (ir = c.neg(ir)), { x: er, y: ir };
      } else if (Et === d && st === 4) {
        const er = c.fromBytes(Dt.subarray(0, c.BYTES)), xt = c.fromBytes(Dt.subarray(c.BYTES, 2 * c.BYTES));
        return { x: er, y: xt };
      } else
        throw new Error(`Point of length ${Et} was invalid. Expected ${t} compressed bytes or ${d} uncompressed bytes`);
    }
  }), U = (Ne) => bytesToHex$1(numberToBytesBE$1(Ne, g.nByteLength));
  function L(Ne) {
    const Et = y >> _1n$6;
    return Ne > Et;
  }
  function H(Ne) {
    return L(Ne) ? B(-Ne) : Ne;
  }
  const fe = (Ne, Et, st) => bytesToNumberBE$1(Ne.slice(Et, st));
  class ge {
    constructor(Et, st, Dt) {
      this.r = Et, this.s = st, this.recovery = Dt, this.assertValidity();
    }
    // pair (bytes of r, bytes of s)
    static fromCompact(Et) {
      const st = g.nByteLength;
      return Et = ensureBytes$1("compactSignature", Et, st * 2), new ge(fe(Et, 0, st), fe(Et, st, 2 * st));
    }
    // DER encoded ECDSA signature
    // https://bitcoin.stackexchange.com/questions/57644/what-are-the-parts-of-a-bitcoin-transaction-input-script
    static fromDER(Et) {
      const { r: st, s: Dt } = DER$1.toSig(ensureBytes$1("DER", Et));
      return new ge(st, Dt);
    }
    assertValidity() {
      if (!M(this.r))
        throw new Error("r must be 0 < r < CURVE.n");
      if (!M(this.s))
        throw new Error("s must be 0 < s < CURVE.n");
    }
    addRecoveryBit(Et) {
      return new ge(this.r, this.s, Et);
    }
    recoverPublicKey(Et) {
      const { r: st, s: Dt, recovery: er } = this, xt = Pe(ensureBytes$1("msgHash", Et));
      if (er == null || ![0, 1, 2, 3].includes(er))
        throw new Error("recovery id invalid");
      const ir = er === 2 || er === 3 ? st + g.n : st;
      if (ir >= c.ORDER)
        throw new Error("recovery id 2 or 3 invalid");
      const sr = (er & 1) === 0 ? "02" : "03", yr = x.fromHex(sr + U(ir)), wr = D(ir), qr = B(-xt * wr), Mr = B(Dt * wr), Dr = x.BASE.multiplyAndAddUnsafe(yr, qr, Mr);
      if (!Dr)
        throw new Error("point at infinify");
      return Dr.assertValidity(), Dr;
    }
    // Signatures should be low-s, to prevent malleability.
    hasHighS() {
      return L(this.s);
    }
    normalizeS() {
      return this.hasHighS() ? new ge(this.r, B(-this.s), this.recovery) : this;
    }
    // DER-encoded
    toDERRawBytes() {
      return hexToBytes$1(this.toDERHex());
    }
    toDERHex() {
      return DER$1.hexFromSig({ r: this.r, s: this.s });
    }
    // padded bytes of r, then padded bytes of s
    toCompactRawBytes() {
      return hexToBytes$1(this.toCompactHex());
    }
    toCompactHex() {
      return U(this.r) + U(this.s);
    }
  }
  const Ie = {
    isValidPrivateKey(Ne) {
      try {
        return v(Ne), !0;
      } catch {
        return !1;
      }
    },
    normPrivateKeyToScalar: v,
    /**
     * Produces cryptographically secure private key from random of size
     * (groupLen + ceil(groupLen / 2)) with modulo bias being negligible.
     */
    randomPrivateKey: () => {
      const Ne = getMinHashLength$1(g.n);
      return mapHashToField$1(g.randomBytes(Ne), g.n);
    },
    /**
     * Creates precompute table for an arbitrary EC point. Makes point "cached".
     * Allows to massively speed-up `point.multiply(scalar)`.
     * @returns cached point
     * @example
     * const fast = utils.precompute(8, ProjectivePoint.fromHex(someonesPubKey));
     * fast.multiply(privKey); // much faster ECDH now
     */
    precompute(Ne = 8, Et = x.BASE) {
      return Et._setWindowSize(Ne), Et.multiply(BigInt(3)), Et;
    }
  };
  function Ee(Ne, Et = !0) {
    return x.fromPrivateKey(Ne).toRawBytes(Et);
  }
  function Se(Ne) {
    const Et = isBytes$5(Ne), st = typeof Ne == "string", Dt = (Et || st) && Ne.length;
    return Et ? Dt === t || Dt === d : st ? Dt === 2 * t || Dt === 2 * d : Ne instanceof x;
  }
  function ze(Ne, Et, st = !0) {
    if (Se(Ne))
      throw new Error("first arg must be private key");
    if (!Se(Et))
      throw new Error("second arg must be public key");
    return x.fromHex(Et).multiply(v(Ne)).toRawBytes(st);
  }
  const He = g.bits2int || function(Ne) {
    const Et = bytesToNumberBE$1(Ne), st = Ne.length * 8 - g.nBitLength;
    return st > 0 ? Et >> BigInt(st) : Et;
  }, Pe = g.bits2int_modN || function(Ne) {
    return B(He(Ne));
  }, De = bitMask$1(g.nBitLength);
  function ve(Ne) {
    if (typeof Ne != "bigint")
      throw new Error("bigint expected");
    if (!(_0n$5 <= Ne && Ne < De))
      throw new Error(`bigint expected < 2^${g.nBitLength}`);
    return numberToBytesBE$1(Ne, g.nByteLength);
  }
  function Fe(Ne, Et, st = be) {
    if (["recovered", "canonical"].some((Xr) => Xr in st))
      throw new Error("sign() legacy options not supported");
    const { hash: Dt, randomBytes: er } = g;
    let { lowS: xt, prehash: ir, extraEntropy: sr } = st;
    xt == null && (xt = !0), Ne = ensureBytes$1("msgHash", Ne), ir && (Ne = ensureBytes$1("prehashed msgHash", Dt(Ne)));
    const yr = Pe(Ne), wr = v(Et), qr = [ve(wr), ve(yr)];
    if (sr != null && sr !== !1) {
      const Xr = sr === !0 ? er(c.BYTES) : sr;
      qr.push(ensureBytes$1("extraEntropy", Xr));
    }
    const Mr = concatBytes$3(...qr), Dr = yr;
    function Qr(Xr) {
      const Vr = He(Xr);
      if (!M(Vr))
        return;
      const Ur = D(Vr), Sr = x.BASE.multiply(Vr).toAffine(), Gr = B(Sr.x);
      if (Gr === _0n$5)
        return;
      const Fr = B(Ur * B(Dr + Gr * wr));
      if (Fr === _0n$5)
        return;
      let br = (Sr.x === Gr ? 0 : 2) | Number(Sr.y & _1n$6), Ar = Fr;
      return xt && L(Fr) && (Ar = H(Fr), br ^= 1), new ge(Gr, Ar, br);
    }
    return { seed: Mr, k2sig: Qr };
  }
  const be = { lowS: g.lowS, prehash: !1 }, Be = { lowS: g.lowS, prehash: !1 };
  function ke(Ne, Et, st = be) {
    const { seed: Dt, k2sig: er } = Fe(Ne, Et, st), xt = g;
    return createHmacDrbg$1(xt.hash.outputLen, xt.nByteLength, xt.hmac)(Dt, er);
  }
  x.BASE._setWindowSize(8);
  function xe(Ne, Et, st, Dt = Be) {
    var Sr;
    const er = Ne;
    if (Et = ensureBytes$1("msgHash", Et), st = ensureBytes$1("publicKey", st), "strict" in Dt)
      throw new Error("options.strict was renamed to lowS");
    const { lowS: xt, prehash: ir } = Dt;
    let sr, yr;
    try {
      if (typeof er == "string" || isBytes$5(er))
        try {
          sr = ge.fromDER(er);
        } catch (Gr) {
          if (!(Gr instanceof DER$1.Err))
            throw Gr;
          sr = ge.fromCompact(er);
        }
      else if (typeof er == "object" && typeof er.r == "bigint" && typeof er.s == "bigint") {
        const { r: Gr, s: Fr } = er;
        sr = new ge(Gr, Fr);
      } else
        throw new Error("PARSE");
      yr = x.fromHex(st);
    } catch (Gr) {
      if (Gr.message === "PARSE")
        throw new Error("signature must be Signature instance, Uint8Array or hex string");
      return !1;
    }
    if (xt && sr.hasHighS())
      return !1;
    ir && (Et = g.hash(Et));
    const { r: wr, s: qr } = sr, Mr = Pe(Et), Dr = D(qr), Qr = B(Mr * Dr), Xr = B(wr * Dr), Vr = (Sr = x.BASE.multiplyAndAddUnsafe(yr, Qr, Xr)) == null ? void 0 : Sr.toAffine();
    return Vr ? B(Vr.x) === wr : !1;
  }
  return {
    CURVE: g,
    getPublicKey: Ee,
    getSharedSecret: ze,
    sign: ke,
    verify: xe,
    ProjectivePoint: x,
    Signature: ge,
    utils: Ie
  };
}
function getHash(o) {
  return {
    hash: o,
    hmac: (g, ...c) => hmac$2(o, g, concatBytes$4(...c)),
    randomBytes: randomBytes$1
  };
}
function createCurve$1(o, g) {
  const c = (y) => weierstrass$1({ ...o, ...getHash(y) });
  return Object.freeze({ ...c(g), create: c });
}
const secp256k1P = BigInt("0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f"), secp256k1N = BigInt("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141"), _1n$5 = BigInt(1), _2n$3 = BigInt(2), divNearest$1 = (o, g) => (o + g / _2n$3) / g;
function sqrtMod$1(o) {
  const g = secp256k1P, c = BigInt(3), y = BigInt(6), t = BigInt(11), d = BigInt(22), E = BigInt(23), B = BigInt(44), D = BigInt(88), x = o * o * o % g, v = x * x * o % g, F = pow2$1(v, c, g) * v % g, M = pow2$1(F, c, g) * v % g, U = pow2$1(M, _2n$3, g) * x % g, L = pow2$1(U, t, g) * U % g, H = pow2$1(L, d, g) * L % g, fe = pow2$1(H, B, g) * H % g, ge = pow2$1(fe, D, g) * fe % g, Ie = pow2$1(ge, B, g) * H % g, Ee = pow2$1(Ie, c, g) * v % g, Se = pow2$1(Ee, E, g) * L % g, ze = pow2$1(Se, y, g) * x % g, He = pow2$1(ze, _2n$3, g);
  if (!Fp.eql(Fp.sqr(He), o))
    throw new Error("Cannot find square root");
  return He;
}
const Fp = Field$1(secp256k1P, void 0, void 0, { sqrt: sqrtMod$1 }), secp256k1$3 = createCurve$1({
  a: BigInt(0),
  // equation params: a, b
  b: BigInt(7),
  // Seem to be rigid: bitcointalk.org/index.php?topic=289795.msg3183975#msg3183975
  Fp,
  // Field's prime: 2n**256n - 2n**32n - 2n**9n - 2n**8n - 2n**7n - 2n**6n - 2n**4n - 1n
  n: secp256k1N,
  // Curve order, total count of valid points in the field
  // Base point (x, y) aka generator point
  Gx: BigInt("55066263022277343669578718895168534326250603453777594175500187360389116729240"),
  Gy: BigInt("32670510020758816978083085130507043184471273380659243275938904335757337482424"),
  h: BigInt(1),
  // Cofactor
  lowS: !0,
  // Allow only low-S signatures by default in sign() and verify()
  /**
   * secp256k1 belongs to Koblitz curves: it has efficiently computable endomorphism.
   * Endomorphism uses 2x less RAM, speeds up precomputation by 2x and ECDH / key recovery by 20%.
   * For precomputed wNAF it trades off 1/2 init time & 1/3 ram for 20% perf hit.
   * Explanation: https://gist.github.com/paulmillr/eb670806793e84df628a7c434a873066
   */
  endo: {
    beta: BigInt("0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee"),
    splitScalar: (o) => {
      const g = secp256k1N, c = BigInt("0x3086d221a7d46bcde86c90e49284eb15"), y = -_1n$5 * BigInt("0xe4437ed6010e88286f547fa90abfe4c3"), t = BigInt("0x114ca50f7a8e2f3f657c1108d9d44cfd8"), d = c, E = BigInt("0x100000000000000000000000000000000"), B = divNearest$1(d * o, g), D = divNearest$1(-y * o, g);
      let x = mod$1(o - B * c - D * t, g), v = mod$1(-B * y - D * d, g);
      const F = x > E, M = v > E;
      if (F && (x = g - x), M && (v = g - v), x > E || v > E)
        throw new Error("splitScalar: Endomorphism failed, k=" + o);
      return { k1neg: F, k1: x, k2neg: M, k2: v };
    }
  }
}, sha256$3);
BigInt(0);
secp256k1$3.ProjectivePoint;
function isBytes$4(o) {
  return o instanceof Uint8Array || o != null && typeof o == "object" && o.constructor.name === "Uint8Array";
}
// @__NO_SIDE_EFFECTS__
function chain$1(...o) {
  const g = (d) => d, c = (d, E) => (B) => d(E(B)), y = o.map((d) => d.encode).reduceRight(c, g), t = o.map((d) => d.decode).reduce(c, g);
  return { encode: y, decode: t };
}
// @__NO_SIDE_EFFECTS__
function alphabet$1(o) {
  return {
    encode: (g) => {
      if (!Array.isArray(g) || g.length && typeof g[0] != "number")
        throw new Error("alphabet.encode input should be an array of numbers");
      return g.map((c) => {
        if (c < 0 || c >= o.length)
          throw new Error(`Digit index outside alphabet: ${c} (alphabet: ${o.length})`);
        return o[c];
      });
    },
    decode: (g) => {
      if (!Array.isArray(g) || g.length && typeof g[0] != "string")
        throw new Error("alphabet.decode input should be array of strings");
      return g.map((c) => {
        if (typeof c != "string")
          throw new Error(`alphabet.decode: not string element=${c}`);
        const y = o.indexOf(c);
        if (y === -1)
          throw new Error(`Unknown letter: "${c}". Allowed: ${o}`);
        return y;
      });
    }
  };
}
// @__NO_SIDE_EFFECTS__
function join$1(o = "") {
  if (typeof o != "string")
    throw new Error("join separator should be string");
  return {
    encode: (g) => {
      if (!Array.isArray(g) || g.length && typeof g[0] != "string")
        throw new Error("join.encode input should be array of strings");
      for (let c of g)
        if (typeof c != "string")
          throw new Error(`join.encode: non-string input=${c}`);
      return g.join(o);
    },
    decode: (g) => {
      if (typeof g != "string")
        throw new Error("join.decode input should be string");
      return g.split(o);
    }
  };
}
// @__NO_SIDE_EFFECTS__
function convertRadix$1(o, g, c) {
  if (g < 2)
    throw new Error(`convertRadix: wrong from=${g}, base cannot be less than 2`);
  if (c < 2)
    throw new Error(`convertRadix: wrong to=${c}, base cannot be less than 2`);
  if (!Array.isArray(o))
    throw new Error("convertRadix: data should be array");
  if (!o.length)
    return [];
  let y = 0;
  const t = [], d = Array.from(o);
  for (d.forEach((E) => {
    if (E < 0 || E >= g)
      throw new Error(`Wrong integer: ${E}`);
  }); ; ) {
    let E = 0, B = !0;
    for (let D = y; D < d.length; D++) {
      const x = d[D], v = g * E + x;
      if (!Number.isSafeInteger(v) || g * E / g !== E || v - x !== g * E)
        throw new Error("convertRadix: carry overflow");
      E = v % c;
      const F = Math.floor(v / c);
      if (d[D] = F, !Number.isSafeInteger(F) || F * c + E !== v)
        throw new Error("convertRadix: carry overflow");
      if (B)
        F ? B = !1 : y = D;
      else continue;
    }
    if (t.push(E), B)
      break;
  }
  for (let E = 0; E < o.length - 1 && o[E] === 0; E++)
    t.push(0);
  return t.reverse();
}
// @__NO_SIDE_EFFECTS__
function radix$1(o) {
  return {
    encode: (g) => {
      if (!isBytes$4(g))
        throw new Error("radix.encode input should be Uint8Array");
      return /* @__PURE__ */ convertRadix$1(Array.from(g), 2 ** 8, o);
    },
    decode: (g) => {
      if (!Array.isArray(g) || g.length && typeof g[0] != "number")
        throw new Error("radix.decode input should be array of numbers");
      return Uint8Array.from(/* @__PURE__ */ convertRadix$1(g, o, 2 ** 8));
    }
  };
}
// @__NO_SIDE_EFFECTS__
function checksum$2(o, g) {
  if (typeof g != "function")
    throw new Error("checksum fn should be function");
  return {
    encode(c) {
      if (!isBytes$4(c))
        throw new Error("checksum.encode: input should be Uint8Array");
      const y = g(c).slice(0, o), t = new Uint8Array(c.length + o);
      return t.set(c), t.set(y, c.length), t;
    },
    decode(c) {
      if (!isBytes$4(c))
        throw new Error("checksum.decode: input should be Uint8Array");
      const y = c.slice(0, -o), t = g(y).slice(0, o), d = c.slice(-o);
      for (let E = 0; E < o; E++)
        if (t[E] !== d[E])
          throw new Error("Invalid checksum");
      return y;
    }
  };
}
const genBase58$1 = (o) => /* @__PURE__ */ chain$1(/* @__PURE__ */ radix$1(58), /* @__PURE__ */ alphabet$1(o), /* @__PURE__ */ join$1("")), base58$1 = /* @__PURE__ */ genBase58$1("123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz"), createBase58check$1 = (o) => /* @__PURE__ */ chain$1(/* @__PURE__ */ checksum$2(4, (g) => o(o(g))), base58$1);
const Point$1 = secp256k1$3.ProjectivePoint, base58check$1 = createBase58check$1(sha256$3);
function bytesToNumber(o) {
  return BigInt(`0x${bytesToHex$2(o)}`);
}
function numberToBytes(o) {
  return hexToBytes$2(o.toString(16).padStart(64, "0"));
}
const MASTER_SECRET = utf8ToBytes$2("Bitcoin seed"), BITCOIN_VERSIONS = { private: 76066276, public: 76067358 }, HARDENED_OFFSET = 2147483648, hash160$1 = (o) => ripemd160$3(sha256$3(o)), fromU32 = (o) => createView$2(o).getUint32(0, !1), toU32 = (o) => {
  if (!Number.isSafeInteger(o) || o < 0 || o > 2 ** 32 - 1)
    throw new Error(`Invalid number=${o}. Should be from 0 to 2 ** 32 - 1`);
  const g = new Uint8Array(4);
  return createView$2(g).setUint32(0, o, !1), g;
};
class HDKey {
  get fingerprint() {
    if (!this.pubHash)
      throw new Error("No publicKey set!");
    return fromU32(this.pubHash);
  }
  get identifier() {
    return this.pubHash;
  }
  get pubKeyHash() {
    return this.pubHash;
  }
  get privateKey() {
    return this.privKeyBytes || null;
  }
  get publicKey() {
    return this.pubKey || null;
  }
  get privateExtendedKey() {
    const g = this.privateKey;
    if (!g)
      throw new Error("No private key");
    return base58check$1.encode(this.serialize(this.versions.private, concatBytes$4(new Uint8Array([0]), g)));
  }
  get publicExtendedKey() {
    if (!this.pubKey)
      throw new Error("No public key");
    return base58check$1.encode(this.serialize(this.versions.public, this.pubKey));
  }
  static fromMasterSeed(g, c = BITCOIN_VERSIONS) {
    if (bytes(g), 8 * g.length < 128 || 8 * g.length > 512)
      throw new Error(`HDKey: wrong seed length=${g.length}. Should be between 128 and 512 bits; 256 bits is advised)`);
    const y = hmac$2(sha512$2, MASTER_SECRET, g);
    return new HDKey({
      versions: c,
      chainCode: y.slice(32),
      privateKey: y.slice(0, 32)
    });
  }
  static fromExtendedKey(g, c = BITCOIN_VERSIONS) {
    const y = base58check$1.decode(g), t = createView$2(y), d = t.getUint32(0, !1), E = {
      versions: c,
      depth: y[4],
      parentFingerprint: t.getUint32(5, !1),
      index: t.getUint32(9, !1),
      chainCode: y.slice(13, 45)
    }, B = y.slice(45), D = B[0] === 0;
    if (d !== c[D ? "private" : "public"])
      throw new Error("Version mismatch");
    return D ? new HDKey({ ...E, privateKey: B.slice(1) }) : new HDKey({ ...E, publicKey: B });
  }
  static fromJSON(g) {
    return HDKey.fromExtendedKey(g.xpriv);
  }
  constructor(g) {
    if (this.depth = 0, this.index = 0, this.chainCode = null, this.parentFingerprint = 0, !g || typeof g != "object")
      throw new Error("HDKey.constructor must not be called directly");
    if (this.versions = g.versions || BITCOIN_VERSIONS, this.depth = g.depth || 0, this.chainCode = g.chainCode || null, this.index = g.index || 0, this.parentFingerprint = g.parentFingerprint || 0, !this.depth && (this.parentFingerprint || this.index))
      throw new Error("HDKey: zero depth with non-zero index/parent fingerprint");
    if (g.publicKey && g.privateKey)
      throw new Error("HDKey: publicKey and privateKey at same time.");
    if (g.privateKey) {
      if (!secp256k1$3.utils.isValidPrivateKey(g.privateKey))
        throw new Error("Invalid private key");
      this.privKey = typeof g.privateKey == "bigint" ? g.privateKey : bytesToNumber(g.privateKey), this.privKeyBytes = numberToBytes(this.privKey), this.pubKey = secp256k1$3.getPublicKey(g.privateKey, !0);
    } else if (g.publicKey)
      this.pubKey = Point$1.fromHex(g.publicKey).toRawBytes(!0);
    else
      throw new Error("HDKey: no public or private key provided");
    this.pubHash = hash160$1(this.pubKey);
  }
  derive(g) {
    if (!/^[mM]'?/.test(g))
      throw new Error('Path must start with "m" or "M"');
    if (/^[mM]'?$/.test(g))
      return this;
    const c = g.replace(/^[mM]'?\//, "").split("/");
    let y = this;
    for (const t of c) {
      const d = /^(\d+)('?)$/.exec(t), E = d && d[1];
      if (!d || d.length !== 3 || typeof E != "string")
        throw new Error(`Invalid child index: ${t}`);
      let B = +E;
      if (!Number.isSafeInteger(B) || B >= HARDENED_OFFSET)
        throw new Error("Invalid index");
      d[2] === "'" && (B += HARDENED_OFFSET), y = y.deriveChild(B);
    }
    return y;
  }
  deriveChild(g) {
    if (!this.pubKey || !this.chainCode)
      throw new Error("No publicKey or chainCode set");
    let c = toU32(g);
    if (g >= HARDENED_OFFSET) {
      const B = this.privateKey;
      if (!B)
        throw new Error("Could not derive hardened child key");
      c = concatBytes$4(new Uint8Array([0]), B, c);
    } else
      c = concatBytes$4(this.pubKey, c);
    const y = hmac$2(sha512$2, this.chainCode, c), t = bytesToNumber(y.slice(0, 32)), d = y.slice(32);
    if (!secp256k1$3.utils.isValidPrivateKey(t))
      throw new Error("Tweak bigger than curve order");
    const E = {
      versions: this.versions,
      chainCode: d,
      depth: this.depth + 1,
      parentFingerprint: this.fingerprint,
      index: g
    };
    try {
      if (this.privateKey) {
        const B = mod$1(this.privKey + t, secp256k1$3.CURVE.n);
        if (!secp256k1$3.utils.isValidPrivateKey(B))
          throw new Error("The tweak was out of range or the resulted private key is invalid");
        E.privateKey = B;
      } else {
        const B = Point$1.fromHex(this.pubKey).add(Point$1.fromPrivateKey(t));
        if (B.equals(Point$1.ZERO))
          throw new Error("The tweak was equal to negative P, which made the result key invalid");
        E.publicKey = B.toRawBytes(!0);
      }
      return new HDKey(E);
    } catch {
      return this.deriveChild(g + 1);
    }
  }
  sign(g) {
    if (!this.privateKey)
      throw new Error("No privateKey set!");
    return bytes(g, 32), secp256k1$3.sign(g, this.privKey).toCompactRawBytes();
  }
  verify(g, c) {
    if (bytes(g, 32), bytes(c, 64), !this.publicKey)
      throw new Error("No publicKey set!");
    let y;
    try {
      y = secp256k1$3.Signature.fromCompact(c);
    } catch {
      return !1;
    }
    return secp256k1$3.verify(y, g, this.publicKey);
  }
  wipePrivateData() {
    return this.privKey = void 0, this.privKeyBytes && (this.privKeyBytes.fill(0), this.privKeyBytes = void 0), this;
  }
  toJSON() {
    return {
      xpriv: this.privateExtendedKey,
      xpub: this.publicExtendedKey
    };
  }
  serialize(g, c) {
    if (!this.chainCode)
      throw new Error("No chainCode set");
    return bytes(c, 33), concatBytes$4(toU32(g), new Uint8Array([this.depth]), toU32(this.parentFingerprint), toU32(this.index), this.chainCode, c);
  }
}
var bip341 = {}, ecc_lib = {}, hasRequiredEcc_lib;
function requireEcc_lib() {
  if (hasRequiredEcc_lib) return ecc_lib;
  hasRequiredEcc_lib = 1, Object.defineProperty(ecc_lib, "__esModule", { value: !0 }), ecc_lib.getEccLib = ecc_lib.initEccLib = void 0;
  const o = {};
  function g(B, D) {
    B ? B !== o.eccLib && (D != null && D.DANGER_DO_NOT_VERIFY_ECCLIB || t(B), o.eccLib = B) : o.eccLib = B;
  }
  ecc_lib.initEccLib = g;
  function c() {
    if (!o.eccLib)
      throw new Error(
        "No ECC Library provided. You must call initEccLib() with a valid TinySecp256k1Interface instance"
      );
    return o.eccLib;
  }
  ecc_lib.getEccLib = c;
  const y = (B) => Buffer.from(B, "hex");
  function t(B) {
    d(typeof B.isXOnlyPoint == "function"), d(
      B.isXOnlyPoint(
        y("79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798")
      )
    ), d(
      B.isXOnlyPoint(
        y("fffffffffffffffffffffffffffffffffffffffffffffffffffffffeeffffc2e")
      )
    ), d(
      B.isXOnlyPoint(
        y("f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9")
      )
    ), d(
      B.isXOnlyPoint(
        y("0000000000000000000000000000000000000000000000000000000000000001")
      )
    ), d(
      !B.isXOnlyPoint(
        y("0000000000000000000000000000000000000000000000000000000000000000")
      )
    ), d(
      !B.isXOnlyPoint(
        y("fffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f")
      )
    ), d(typeof B.xOnlyPointAddTweak == "function"), E.forEach((D) => {
      const x = B.xOnlyPointAddTweak(y(D.pubkey), y(D.tweak));
      D.result === null ? d(x === null) : (d(x !== null), d(x.parity === D.parity), d(Buffer.from(x.xOnlyPubkey).equals(y(D.result))));
    });
  }
  function d(B) {
    if (!B) throw new Error("ecc library invalid");
  }
  const E = [
    {
      pubkey: "79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798",
      tweak: "fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364140",
      parity: -1,
      result: null
    },
    {
      pubkey: "1617d38ed8d8657da4d4761e8057bc396ea9e4b9d29776d4be096016dbd2509b",
      tweak: "a8397a935f0dfceba6ba9618f6451ef4d80637abf4e6af2669fbc9de6a8fd2ac",
      parity: 1,
      result: "e478f99dab91052ab39a33ea35fd5e6e4933f4d28023cd597c9a1f6760346adf"
    },
    {
      pubkey: "2c0b7cf95324a07d05398b240174dc0c2be444d96b159aa6c7f7b1e668680991",
      tweak: "823c3cd2142744b075a87eade7e1b8678ba308d566226a0056ca2b7a76f86b47",
      parity: 0,
      result: "9534f8dc8c6deda2dc007655981c78b49c5d96c778fbf363462a11ec9dfd948c"
    }
  ];
  return ecc_lib;
}
var crypto$3 = {}, ripemd160$2 = {}, legacy = {}, hasRequiredLegacy;
function requireLegacy() {
  if (hasRequiredLegacy) return legacy;
  hasRequiredLegacy = 1, Object.defineProperty(legacy, "__esModule", { value: !0 }), legacy.ripemd160 = legacy.RIPEMD160 = legacy.md5 = legacy.MD5 = legacy.sha1 = legacy.SHA1 = void 0;
  const o = /* @__PURE__ */ require_md$1(), g = /* @__PURE__ */ requireUtils$j(), c = /* @__PURE__ */ Uint32Array.from([
    1732584193,
    4023233417,
    2562383102,
    271733878,
    3285377520
  ]), y = /* @__PURE__ */ new Uint32Array(80);
  class t extends o.HashMD {
    constructor() {
      super(64, 20, 8, !1), this.A = c[0] | 0, this.B = c[1] | 0, this.C = c[2] | 0, this.D = c[3] | 0, this.E = c[4] | 0;
    }
    get() {
      const { A: ve, B: Fe, C: be, D: Be, E: ke } = this;
      return [ve, Fe, be, Be, ke];
    }
    set(ve, Fe, be, Be, ke) {
      this.A = ve | 0, this.B = Fe | 0, this.C = be | 0, this.D = Be | 0, this.E = ke | 0;
    }
    process(ve, Fe) {
      for (let Et = 0; Et < 16; Et++, Fe += 4)
        y[Et] = ve.getUint32(Fe, !1);
      for (let Et = 16; Et < 80; Et++)
        y[Et] = (0, g.rotl)(y[Et - 3] ^ y[Et - 8] ^ y[Et - 14] ^ y[Et - 16], 1);
      let { A: be, B: Be, C: ke, D: xe, E: Ne } = this;
      for (let Et = 0; Et < 80; Et++) {
        let st, Dt;
        Et < 20 ? (st = (0, o.Chi)(Be, ke, xe), Dt = 1518500249) : Et < 40 ? (st = Be ^ ke ^ xe, Dt = 1859775393) : Et < 60 ? (st = (0, o.Maj)(Be, ke, xe), Dt = 2400959708) : (st = Be ^ ke ^ xe, Dt = 3395469782);
        const er = (0, g.rotl)(be, 5) + st + Ne + Dt + y[Et] | 0;
        Ne = xe, xe = ke, ke = (0, g.rotl)(Be, 30), Be = be, be = er;
      }
      be = be + this.A | 0, Be = Be + this.B | 0, ke = ke + this.C | 0, xe = xe + this.D | 0, Ne = Ne + this.E | 0, this.set(be, Be, ke, xe, Ne);
    }
    roundClean() {
      (0, g.clean)(y);
    }
    destroy() {
      this.set(0, 0, 0, 0, 0), (0, g.clean)(this.buffer);
    }
  }
  legacy.SHA1 = t, legacy.sha1 = (0, g.createHasher)(() => new t());
  const d = /* @__PURE__ */ Math.pow(2, 32), E = /* @__PURE__ */ Array.from({ length: 64 }, (De, ve) => Math.floor(d * Math.abs(Math.sin(ve + 1)))), B = /* @__PURE__ */ c.slice(0, 4), D = /* @__PURE__ */ new Uint32Array(16);
  class x extends o.HashMD {
    constructor() {
      super(64, 16, 8, !0), this.A = B[0] | 0, this.B = B[1] | 0, this.C = B[2] | 0, this.D = B[3] | 0;
    }
    get() {
      const { A: ve, B: Fe, C: be, D: Be } = this;
      return [ve, Fe, be, Be];
    }
    set(ve, Fe, be, Be) {
      this.A = ve | 0, this.B = Fe | 0, this.C = be | 0, this.D = Be | 0;
    }
    process(ve, Fe) {
      for (let Ne = 0; Ne < 16; Ne++, Fe += 4)
        D[Ne] = ve.getUint32(Fe, !0);
      let { A: be, B: Be, C: ke, D: xe } = this;
      for (let Ne = 0; Ne < 64; Ne++) {
        let Et, st, Dt;
        Ne < 16 ? (Et = (0, o.Chi)(Be, ke, xe), st = Ne, Dt = [7, 12, 17, 22]) : Ne < 32 ? (Et = (0, o.Chi)(xe, Be, ke), st = (5 * Ne + 1) % 16, Dt = [5, 9, 14, 20]) : Ne < 48 ? (Et = Be ^ ke ^ xe, st = (3 * Ne + 5) % 16, Dt = [4, 11, 16, 23]) : (Et = ke ^ (Be | ~xe), st = 7 * Ne % 16, Dt = [6, 10, 15, 21]), Et = Et + be + E[Ne] + D[st], be = xe, xe = ke, ke = Be, Be = Be + (0, g.rotl)(Et, Dt[Ne % 4]);
      }
      be = be + this.A | 0, Be = Be + this.B | 0, ke = ke + this.C | 0, xe = xe + this.D | 0, this.set(be, Be, ke, xe);
    }
    roundClean() {
      (0, g.clean)(D);
    }
    destroy() {
      this.set(0, 0, 0, 0), (0, g.clean)(this.buffer);
    }
  }
  legacy.MD5 = x, legacy.md5 = (0, g.createHasher)(() => new x());
  const v = /* @__PURE__ */ Uint8Array.from([
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8
  ]), F = Uint8Array.from(new Array(16).fill(0).map((De, ve) => ve)), M = F.map((De) => (9 * De + 5) % 16), U = /* @__PURE__ */ (() => {
    const Fe = [[F], [M]];
    for (let be = 0; be < 4; be++)
      for (let Be of Fe)
        Be.push(Be[be].map((ke) => v[ke]));
    return Fe;
  })(), L = U[0], H = U[1], fe = /* @__PURE__ */ [
    [11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8],
    [12, 13, 11, 15, 6, 9, 9, 7, 12, 15, 11, 13, 7, 8, 7, 7],
    [13, 15, 14, 11, 7, 7, 6, 8, 13, 14, 13, 12, 5, 5, 6, 9],
    [14, 11, 12, 14, 8, 6, 5, 5, 15, 12, 15, 14, 9, 9, 8, 6],
    [15, 12, 13, 13, 9, 5, 8, 6, 14, 11, 12, 11, 8, 6, 5, 5]
  ].map((De) => Uint8Array.from(De)), ge = /* @__PURE__ */ L.map((De, ve) => De.map((Fe) => fe[ve][Fe])), Ie = /* @__PURE__ */ H.map((De, ve) => De.map((Fe) => fe[ve][Fe])), Ee = /* @__PURE__ */ Uint32Array.from([
    0,
    1518500249,
    1859775393,
    2400959708,
    2840853838
  ]), Se = /* @__PURE__ */ Uint32Array.from([
    1352829926,
    1548603684,
    1836072691,
    2053994217,
    0
  ]);
  function ze(De, ve, Fe, be) {
    return De === 0 ? ve ^ Fe ^ be : De === 1 ? ve & Fe | ~ve & be : De === 2 ? (ve | ~Fe) ^ be : De === 3 ? ve & be | Fe & ~be : ve ^ (Fe | ~be);
  }
  const He = /* @__PURE__ */ new Uint32Array(16);
  class Pe extends o.HashMD {
    constructor() {
      super(64, 20, 8, !0), this.h0 = 1732584193, this.h1 = -271733879, this.h2 = -1732584194, this.h3 = 271733878, this.h4 = -1009589776;
    }
    get() {
      const { h0: ve, h1: Fe, h2: be, h3: Be, h4: ke } = this;
      return [ve, Fe, be, Be, ke];
    }
    set(ve, Fe, be, Be, ke) {
      this.h0 = ve | 0, this.h1 = Fe | 0, this.h2 = be | 0, this.h3 = Be | 0, this.h4 = ke | 0;
    }
    process(ve, Fe) {
      for (let ir = 0; ir < 16; ir++, Fe += 4)
        He[ir] = ve.getUint32(Fe, !0);
      let be = this.h0 | 0, Be = be, ke = this.h1 | 0, xe = ke, Ne = this.h2 | 0, Et = Ne, st = this.h3 | 0, Dt = st, er = this.h4 | 0, xt = er;
      for (let ir = 0; ir < 5; ir++) {
        const sr = 4 - ir, yr = Ee[ir], wr = Se[ir], qr = L[ir], Mr = H[ir], Dr = ge[ir], Qr = Ie[ir];
        for (let Xr = 0; Xr < 16; Xr++) {
          const Vr = (0, g.rotl)(be + ze(ir, ke, Ne, st) + He[qr[Xr]] + yr, Dr[Xr]) + er | 0;
          be = er, er = st, st = (0, g.rotl)(Ne, 10) | 0, Ne = ke, ke = Vr;
        }
        for (let Xr = 0; Xr < 16; Xr++) {
          const Vr = (0, g.rotl)(Be + ze(sr, xe, Et, Dt) + He[Mr[Xr]] + wr, Qr[Xr]) + xt | 0;
          Be = xt, xt = Dt, Dt = (0, g.rotl)(Et, 10) | 0, Et = xe, xe = Vr;
        }
      }
      this.set(this.h1 + Ne + Dt | 0, this.h2 + st + xt | 0, this.h3 + er + Be | 0, this.h4 + be + xe | 0, this.h0 + ke + Et | 0);
    }
    roundClean() {
      (0, g.clean)(He);
    }
    destroy() {
      this.destroyed = !0, (0, g.clean)(this.buffer), this.set(0, 0, 0, 0, 0);
    }
  }
  return legacy.RIPEMD160 = Pe, legacy.ripemd160 = (0, g.createHasher)(() => new Pe()), legacy;
}
var hasRequiredRipemd160;
function requireRipemd160() {
  if (hasRequiredRipemd160) return ripemd160$2;
  hasRequiredRipemd160 = 1, Object.defineProperty(ripemd160$2, "__esModule", { value: !0 }), ripemd160$2.ripemd160 = ripemd160$2.RIPEMD160 = void 0;
  const o = /* @__PURE__ */ requireLegacy();
  return ripemd160$2.RIPEMD160 = o.RIPEMD160, ripemd160$2.ripemd160 = o.ripemd160, ripemd160$2;
}
var sha1$2 = {}, hasRequiredSha1$1;
function requireSha1$1() {
  if (hasRequiredSha1$1) return sha1$2;
  hasRequiredSha1$1 = 1, Object.defineProperty(sha1$2, "__esModule", { value: !0 }), sha1$2.sha1 = sha1$2.SHA1 = void 0;
  const o = /* @__PURE__ */ requireLegacy();
  return sha1$2.SHA1 = o.SHA1, sha1$2.sha1 = o.sha1, sha1$2;
}
var hasRequiredCrypto$1;
function requireCrypto$1() {
  return hasRequiredCrypto$1 || (hasRequiredCrypto$1 = 1, function(o) {
    Object.defineProperty(o, "__esModule", { value: !0 }), o.taggedHash = o.TAGGED_HASH_PREFIXES = o.TAGS = o.hash256 = o.hash160 = o.sha256 = o.sha1 = o.ripemd160 = void 0;
    const g = /* @__PURE__ */ requireRipemd160(), c = /* @__PURE__ */ requireSha1$1(), y = /* @__PURE__ */ requireSha256$1();
    function t(v) {
      return Buffer.from((0, g.ripemd160)(Uint8Array.from(v)));
    }
    o.ripemd160 = t;
    function d(v) {
      return Buffer.from((0, c.sha1)(Uint8Array.from(v)));
    }
    o.sha1 = d;
    function E(v) {
      return Buffer.from((0, y.sha256)(Uint8Array.from(v)));
    }
    o.sha256 = E;
    function B(v) {
      return Buffer.from(
        (0, g.ripemd160)((0, y.sha256)(Uint8Array.from(v)))
      );
    }
    o.hash160 = B;
    function D(v) {
      return Buffer.from(
        (0, y.sha256)((0, y.sha256)(Uint8Array.from(v)))
      );
    }
    o.hash256 = D, o.TAGS = [
      "BIP0340/challenge",
      "BIP0340/aux",
      "BIP0340/nonce",
      "TapLeaf",
      "TapBranch",
      "TapSighash",
      "TapTweak",
      "KeyAgg list",
      "KeyAgg coefficient"
    ], o.TAGGED_HASH_PREFIXES = {
      "BIP0340/challenge": Buffer.from([
        123,
        181,
        45,
        122,
        159,
        239,
        88,
        50,
        62,
        177,
        191,
        122,
        64,
        125,
        179,
        130,
        210,
        243,
        242,
        216,
        27,
        177,
        34,
        79,
        73,
        254,
        81,
        143,
        109,
        72,
        211,
        124,
        123,
        181,
        45,
        122,
        159,
        239,
        88,
        50,
        62,
        177,
        191,
        122,
        64,
        125,
        179,
        130,
        210,
        243,
        242,
        216,
        27,
        177,
        34,
        79,
        73,
        254,
        81,
        143,
        109,
        72,
        211,
        124
      ]),
      "BIP0340/aux": Buffer.from([
        241,
        239,
        78,
        94,
        192,
        99,
        202,
        218,
        109,
        148,
        202,
        250,
        157,
        152,
        126,
        160,
        105,
        38,
        88,
        57,
        236,
        193,
        31,
        151,
        45,
        119,
        165,
        46,
        216,
        193,
        204,
        144,
        241,
        239,
        78,
        94,
        192,
        99,
        202,
        218,
        109,
        148,
        202,
        250,
        157,
        152,
        126,
        160,
        105,
        38,
        88,
        57,
        236,
        193,
        31,
        151,
        45,
        119,
        165,
        46,
        216,
        193,
        204,
        144
      ]),
      "BIP0340/nonce": Buffer.from([
        7,
        73,
        119,
        52,
        167,
        155,
        203,
        53,
        91,
        155,
        140,
        125,
        3,
        79,
        18,
        28,
        244,
        52,
        215,
        62,
        247,
        45,
        218,
        25,
        135,
        0,
        97,
        251,
        82,
        191,
        235,
        47,
        7,
        73,
        119,
        52,
        167,
        155,
        203,
        53,
        91,
        155,
        140,
        125,
        3,
        79,
        18,
        28,
        244,
        52,
        215,
        62,
        247,
        45,
        218,
        25,
        135,
        0,
        97,
        251,
        82,
        191,
        235,
        47
      ]),
      TapLeaf: Buffer.from([
        174,
        234,
        143,
        220,
        66,
        8,
        152,
        49,
        5,
        115,
        75,
        88,
        8,
        29,
        30,
        38,
        56,
        211,
        95,
        28,
        181,
        64,
        8,
        212,
        211,
        87,
        202,
        3,
        190,
        120,
        233,
        238,
        174,
        234,
        143,
        220,
        66,
        8,
        152,
        49,
        5,
        115,
        75,
        88,
        8,
        29,
        30,
        38,
        56,
        211,
        95,
        28,
        181,
        64,
        8,
        212,
        211,
        87,
        202,
        3,
        190,
        120,
        233,
        238
      ]),
      TapBranch: Buffer.from([
        25,
        65,
        161,
        242,
        229,
        110,
        185,
        95,
        162,
        169,
        241,
        148,
        190,
        92,
        1,
        247,
        33,
        111,
        51,
        237,
        130,
        176,
        145,
        70,
        52,
        144,
        208,
        91,
        245,
        22,
        160,
        21,
        25,
        65,
        161,
        242,
        229,
        110,
        185,
        95,
        162,
        169,
        241,
        148,
        190,
        92,
        1,
        247,
        33,
        111,
        51,
        237,
        130,
        176,
        145,
        70,
        52,
        144,
        208,
        91,
        245,
        22,
        160,
        21
      ]),
      TapSighash: Buffer.from([
        244,
        10,
        72,
        223,
        75,
        42,
        112,
        200,
        180,
        146,
        75,
        242,
        101,
        70,
        97,
        237,
        61,
        149,
        253,
        102,
        163,
        19,
        235,
        135,
        35,
        117,
        151,
        198,
        40,
        228,
        160,
        49,
        244,
        10,
        72,
        223,
        75,
        42,
        112,
        200,
        180,
        146,
        75,
        242,
        101,
        70,
        97,
        237,
        61,
        149,
        253,
        102,
        163,
        19,
        235,
        135,
        35,
        117,
        151,
        198,
        40,
        228,
        160,
        49
      ]),
      TapTweak: Buffer.from([
        232,
        15,
        225,
        99,
        156,
        156,
        160,
        80,
        227,
        175,
        27,
        57,
        193,
        67,
        198,
        62,
        66,
        156,
        188,
        235,
        21,
        217,
        64,
        251,
        181,
        197,
        161,
        244,
        175,
        87,
        197,
        233,
        232,
        15,
        225,
        99,
        156,
        156,
        160,
        80,
        227,
        175,
        27,
        57,
        193,
        67,
        198,
        62,
        66,
        156,
        188,
        235,
        21,
        217,
        64,
        251,
        181,
        197,
        161,
        244,
        175,
        87,
        197,
        233
      ]),
      "KeyAgg list": Buffer.from([
        72,
        28,
        151,
        28,
        60,
        11,
        70,
        215,
        240,
        178,
        117,
        174,
        89,
        141,
        78,
        44,
        126,
        215,
        49,
        156,
        89,
        74,
        92,
        110,
        199,
        158,
        160,
        212,
        153,
        2,
        148,
        240,
        72,
        28,
        151,
        28,
        60,
        11,
        70,
        215,
        240,
        178,
        117,
        174,
        89,
        141,
        78,
        44,
        126,
        215,
        49,
        156,
        89,
        74,
        92,
        110,
        199,
        158,
        160,
        212,
        153,
        2,
        148,
        240
      ]),
      "KeyAgg coefficient": Buffer.from([
        191,
        201,
        4,
        3,
        77,
        28,
        136,
        232,
        200,
        14,
        34,
        229,
        61,
        36,
        86,
        109,
        100,
        130,
        78,
        214,
        66,
        114,
        129,
        192,
        145,
        0,
        249,
        77,
        205,
        82,
        201,
        129,
        191,
        201,
        4,
        3,
        77,
        28,
        136,
        232,
        200,
        14,
        34,
        229,
        61,
        36,
        86,
        109,
        100,
        130,
        78,
        214,
        66,
        114,
        129,
        192,
        145,
        0,
        249,
        77,
        205,
        82,
        201,
        129
      ])
    };
    function x(v, F) {
      return E(Buffer.concat([o.TAGGED_HASH_PREFIXES[v], F]));
    }
    o.taggedHash = x;
  }(crypto$3)), crypto$3;
}
var bufferutils = {}, types$3 = {}, native$2, hasRequiredNative$1;
function requireNative$1() {
  if (hasRequiredNative$1) return native$2;
  hasRequiredNative$1 = 1;
  var o = {
    Array: function(c) {
      return c != null && c.constructor === Array;
    },
    Boolean: function(c) {
      return typeof c == "boolean";
    },
    Function: function(c) {
      return typeof c == "function";
    },
    Nil: function(c) {
      return c == null;
    },
    Number: function(c) {
      return typeof c == "number";
    },
    Object: function(c) {
      return typeof c == "object";
    },
    String: function(c) {
      return typeof c == "string";
    },
    "": function() {
      return !0;
    }
  };
  o.Null = o.Nil;
  for (var g in o)
    o[g].toJSON = (function(c) {
      return c;
    }).bind(null, g);
  return native$2 = o, native$2;
}
var errors$1, hasRequiredErrors$1;
function requireErrors$1() {
  if (hasRequiredErrors$1) return errors$1;
  hasRequiredErrors$1 = 1;
  var o = requireNative$1();
  function g(M) {
    return M.name || M.toString().match(/function (.*?)\s*\(/)[1];
  }
  function c(M) {
    return o.Nil(M) ? "" : g(M.constructor);
  }
  function y(M) {
    return o.Function(M) ? "" : o.String(M) ? JSON.stringify(M) : M && o.Object(M) ? "" : M;
  }
  function t(M, U) {
    Error.captureStackTrace && Error.captureStackTrace(M, U);
  }
  function d(M) {
    return o.Function(M) ? M.toJSON ? M.toJSON() : g(M) : o.Array(M) ? "Array" : M && o.Object(M) ? "Object" : M !== void 0 ? M : "";
  }
  function E(M, U, L) {
    var H = y(U);
    return "Expected " + d(M) + ", got" + (L !== "" ? " " + L : "") + (H !== "" ? " " + H : "");
  }
  function B(M, U, L) {
    L = L || c(U), this.message = E(M, U, L), t(this, B), this.__type = M, this.__value = U, this.__valueTypeName = L;
  }
  B.prototype = Object.create(Error.prototype), B.prototype.constructor = B;
  function D(M, U, L, H, fe) {
    var ge = '" of type ';
    return U === "key" && (ge = '" with key type '), E('property "' + d(L) + ge + d(M), H, fe);
  }
  function x(M, U, L, H, fe) {
    M ? (fe = fe || c(H), this.message = D(M, L, U, H, fe)) : this.message = 'Unexpected property "' + U + '"', t(this, B), this.__label = L, this.__property = U, this.__type = M, this.__value = H, this.__valueTypeName = fe;
  }
  x.prototype = Object.create(Error.prototype), x.prototype.constructor = B;
  function v(M, U) {
    return new B(M, {}, U);
  }
  function F(M, U, L) {
    return M instanceof x ? (U = U + "." + M.__property, M = new x(
      M.__type,
      U,
      M.__label,
      M.__value,
      M.__valueTypeName
    )) : M instanceof B && (M = new x(
      M.__type,
      U,
      L,
      M.__value,
      M.__valueTypeName
    )), t(M), M;
  }
  return errors$1 = {
    TfTypeError: B,
    TfPropertyTypeError: x,
    tfCustomError: v,
    tfSubError: F,
    tfJSON: d,
    getValueTypeName: c
  }, errors$1;
}
var extra, hasRequiredExtra;
function requireExtra() {
  if (hasRequiredExtra) return extra;
  hasRequiredExtra = 1;
  var o = requireNative$1(), g = requireErrors$1();
  function c(He) {
    return Buffer.isBuffer(He);
  }
  function y(He) {
    return typeof He == "string" && /^([0-9a-f]{2})+$/i.test(He);
  }
  function t(He, Pe) {
    var De = He.toJSON();
    function ve(Fe) {
      if (!He(Fe)) return !1;
      if (Fe.length === Pe) return !0;
      throw g.tfCustomError(De + "(Length: " + Pe + ")", De + "(Length: " + Fe.length + ")");
    }
    return ve.toJSON = function() {
      return De;
    }, ve;
  }
  var d = t.bind(null, o.Array), E = t.bind(null, c), B = t.bind(null, y), D = t.bind(null, o.String);
  function x(He, Pe, De) {
    De = De || o.Number;
    function ve(Fe, be) {
      return De(Fe, be) && Fe > He && Fe < Pe;
    }
    return ve.toJSON = function() {
      return `${De.toJSON()} between [${He}, ${Pe}]`;
    }, ve;
  }
  var v = Math.pow(2, 53) - 1;
  function F(He) {
    return typeof He == "number" && isFinite(He);
  }
  function M(He) {
    return He << 24 >> 24 === He;
  }
  function U(He) {
    return He << 16 >> 16 === He;
  }
  function L(He) {
    return (He | 0) === He;
  }
  function H(He) {
    return typeof He == "number" && He >= -v && He <= v && Math.floor(He) === He;
  }
  function fe(He) {
    return (He & 255) === He;
  }
  function ge(He) {
    return (He & 65535) === He;
  }
  function Ie(He) {
    return He >>> 0 === He;
  }
  function Ee(He) {
    return typeof He == "number" && He >= 0 && He <= v && Math.floor(He) === He;
  }
  var Se = {
    ArrayN: d,
    Buffer: c,
    BufferN: E,
    Finite: F,
    Hex: y,
    HexN: B,
    Int8: M,
    Int16: U,
    Int32: L,
    Int53: H,
    Range: x,
    StringN: D,
    UInt8: fe,
    UInt16: ge,
    UInt32: Ie,
    UInt53: Ee
  };
  for (var ze in Se)
    Se[ze].toJSON = (function(He) {
      return He;
    }).bind(null, ze);
  return extra = Se, extra;
}
var typeforce_1, hasRequiredTypeforce;
function requireTypeforce() {
  if (hasRequiredTypeforce) return typeforce_1;
  hasRequiredTypeforce = 1;
  var o = requireErrors$1(), g = requireNative$1(), c = o.tfJSON, y = o.TfTypeError, t = o.TfPropertyTypeError, d = o.tfSubError, E = o.getValueTypeName, B = {
    arrayOf: function(U, L) {
      U = D(U), L = L || {};
      function H(fe, ge) {
        return !g.Array(fe) || g.Nil(fe) || L.minLength !== void 0 && fe.length < L.minLength || L.maxLength !== void 0 && fe.length > L.maxLength || L.length !== void 0 && fe.length !== L.length ? !1 : fe.every(function(Ie, Ee) {
          try {
            return x(U, Ie, ge);
          } catch (Se) {
            throw d(Se, Ee);
          }
        });
      }
      return H.toJSON = function() {
        var fe = "[" + c(U) + "]";
        return L.length !== void 0 ? fe += "{" + L.length + "}" : (L.minLength !== void 0 || L.maxLength !== void 0) && (fe += "{" + (L.minLength === void 0 ? 0 : L.minLength) + "," + (L.maxLength === void 0 ? 1 / 0 : L.maxLength) + "}"), fe;
      }, H;
    },
    maybe: function M(U) {
      U = D(U);
      function L(H, fe) {
        return g.Nil(H) || U(H, fe, M);
      }
      return L.toJSON = function() {
        return "?" + c(U);
      }, L;
    },
    map: function(U, L) {
      U = D(U), L && (L = D(L));
      function H(fe, ge) {
        if (!g.Object(fe) || g.Nil(fe)) return !1;
        for (var Ie in fe) {
          try {
            L && x(L, Ie, ge);
          } catch (Se) {
            throw d(Se, Ie, "key");
          }
          try {
            var Ee = fe[Ie];
            x(U, Ee, ge);
          } catch (Se) {
            throw d(Se, Ie);
          }
        }
        return !0;
      }
      return L ? H.toJSON = function() {
        return "{" + c(L) + ": " + c(U) + "}";
      } : H.toJSON = function() {
        return "{" + c(U) + "}";
      }, H;
    },
    object: function(U) {
      var L = {};
      for (var H in U)
        L[H] = D(U[H]);
      function fe(ge, Ie) {
        if (!g.Object(ge) || g.Nil(ge)) return !1;
        var Ee;
        try {
          for (Ee in L) {
            var Se = L[Ee], ze = ge[Ee];
            x(Se, ze, Ie);
          }
        } catch (He) {
          throw d(He, Ee);
        }
        if (Ie) {
          for (Ee in ge)
            if (!L[Ee])
              throw new t(void 0, Ee);
        }
        return !0;
      }
      return fe.toJSON = function() {
        return c(L);
      }, fe;
    },
    anyOf: function() {
      var U = [].slice.call(arguments).map(D);
      function L(H, fe) {
        return U.some(function(ge) {
          try {
            return x(ge, H, fe);
          } catch {
            return !1;
          }
        });
      }
      return L.toJSON = function() {
        return U.map(c).join("|");
      }, L;
    },
    allOf: function() {
      var U = [].slice.call(arguments).map(D);
      function L(H, fe) {
        return U.every(function(ge) {
          try {
            return x(ge, H, fe);
          } catch {
            return !1;
          }
        });
      }
      return L.toJSON = function() {
        return U.map(c).join(" & ");
      }, L;
    },
    quacksLike: function(U) {
      function L(H) {
        return U === E(H);
      }
      return L.toJSON = function() {
        return U;
      }, L;
    },
    tuple: function() {
      var U = [].slice.call(arguments).map(D);
      function L(H, fe) {
        return g.Nil(H) || g.Nil(H.length) || fe && H.length !== U.length ? !1 : U.every(function(ge, Ie) {
          try {
            return x(ge, H[Ie], fe);
          } catch (Ee) {
            throw d(Ee, Ie);
          }
        });
      }
      return L.toJSON = function() {
        return "(" + U.map(c).join(", ") + ")";
      }, L;
    },
    value: function(U) {
      function L(H) {
        return H === U;
      }
      return L.toJSON = function() {
        return U;
      }, L;
    }
  };
  B.oneOf = B.anyOf;
  function D(M) {
    if (g.String(M))
      return M[0] === "?" ? B.maybe(M.slice(1)) : g[M] || B.quacksLike(M);
    if (M && g.Object(M)) {
      if (g.Array(M)) {
        if (M.length !== 1) throw new TypeError("Expected compile() parameter of type Array of length 1");
        return B.arrayOf(M[0]);
      }
      return B.object(M);
    } else if (g.Function(M))
      return M;
    return B.value(M);
  }
  function x(M, U, L, H) {
    if (g.Function(M)) {
      if (M(U, L)) return !0;
      throw new y(H || M, U);
    }
    return x(D(M), U, L);
  }
  for (var v in g)
    x[v] = g[v];
  for (v in B)
    x[v] = B[v];
  var F = requireExtra();
  for (v in F)
    x[v] = F[v];
  return x.compile = D, x.TfTypeError = y, x.TfPropertyTypeError = t, typeforce_1 = x, typeforce_1;
}
var hasRequiredTypes$3;
function requireTypes$3() {
  return hasRequiredTypes$3 || (hasRequiredTypes$3 = 1, function(o) {
    Object.defineProperty(o, "__esModule", { value: !0 }), o.oneOf = o.Null = o.BufferN = o.Function = o.UInt32 = o.UInt8 = o.tuple = o.maybe = o.Hex = o.Buffer = o.String = o.Boolean = o.Array = o.Number = o.Hash256bit = o.Hash160bit = o.Buffer256bit = o.isTaptree = o.isTapleaf = o.TAPLEAF_VERSION_MASK = o.Satoshi = o.isPoint = o.stacksEqual = o.typeforce = void 0;
    const g = requireBuffer$2();
    o.typeforce = requireTypeforce();
    const c = g.Buffer.alloc(32, 0), y = g.Buffer.from(
      "fffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f",
      "hex"
    );
    function t(v, F) {
      return v.length !== F.length ? !1 : v.every((M, U) => M.equals(F[U]));
    }
    o.stacksEqual = t;
    function d(v) {
      if (!g.Buffer.isBuffer(v) || v.length < 33) return !1;
      const F = v[0], M = v.slice(1, 33);
      if (M.compare(c) === 0 || M.compare(y) >= 0) return !1;
      if ((F === 2 || F === 3) && v.length === 33)
        return !0;
      const U = v.slice(33);
      return U.compare(c) === 0 || U.compare(y) >= 0 ? !1 : F === 4 && v.length === 65;
    }
    o.isPoint = d;
    const E = 21 * 1e14;
    function B(v) {
      return o.typeforce.UInt53(v) && v <= E;
    }
    o.Satoshi = B, o.TAPLEAF_VERSION_MASK = 254;
    function D(v) {
      return !v || !("output" in v) || !g.Buffer.isBuffer(v.output) ? !1 : v.version !== void 0 ? (v.version & o.TAPLEAF_VERSION_MASK) === v.version : !0;
    }
    o.isTapleaf = D;
    function x(v) {
      return (0, o.Array)(v) ? v.length !== 2 ? !1 : v.every((F) => x(F)) : D(v);
    }
    o.isTaptree = x, o.Buffer256bit = o.typeforce.BufferN(32), o.Hash160bit = o.typeforce.BufferN(20), o.Hash256bit = o.typeforce.BufferN(32), o.Number = o.typeforce.Number, o.Array = o.typeforce.Array, o.Boolean = o.typeforce.Boolean, o.String = o.typeforce.String, o.Buffer = o.typeforce.Buffer, o.Hex = o.typeforce.Hex, o.maybe = o.typeforce.maybe, o.tuple = o.typeforce.tuple, o.UInt8 = o.typeforce.UInt8, o.UInt32 = o.typeforce.UInt32, o.Function = o.typeforce.Function, o.BufferN = o.typeforce.BufferN, o.Null = o.typeforce.Null, o.oneOf = o.typeforce.oneOf;
  }(types$3)), types$3;
}
var varuintBitcoin, hasRequiredVaruintBitcoin;
function requireVaruintBitcoin() {
  if (hasRequiredVaruintBitcoin) return varuintBitcoin;
  hasRequiredVaruintBitcoin = 1;
  var o = requireSafeBuffer$1().Buffer, g = 9007199254740991;
  function c(E) {
    if (E < 0 || E > g || E % 1 !== 0) throw new RangeError("value out of range");
  }
  function y(E, B, D) {
    if (c(E), B || (B = o.allocUnsafe(d(E))), !o.isBuffer(B)) throw new TypeError("buffer must be a Buffer instance");
    return D || (D = 0), E < 253 ? (B.writeUInt8(E, D), y.bytes = 1) : E <= 65535 ? (B.writeUInt8(253, D), B.writeUInt16LE(E, D + 1), y.bytes = 3) : E <= 4294967295 ? (B.writeUInt8(254, D), B.writeUInt32LE(E, D + 1), y.bytes = 5) : (B.writeUInt8(255, D), B.writeUInt32LE(E >>> 0, D + 1), B.writeUInt32LE(E / 4294967296 | 0, D + 5), y.bytes = 9), B;
  }
  function t(E, B) {
    if (!o.isBuffer(E)) throw new TypeError("buffer must be a Buffer instance");
    B || (B = 0);
    var D = E.readUInt8(B);
    if (D < 253)
      return t.bytes = 1, D;
    if (D === 253)
      return t.bytes = 3, E.readUInt16LE(B + 1);
    if (D === 254)
      return t.bytes = 5, E.readUInt32LE(B + 1);
    t.bytes = 9;
    var x = E.readUInt32LE(B + 1), v = E.readUInt32LE(B + 5), F = v * 4294967296 + x;
    return c(F), F;
  }
  function d(E) {
    return c(E), E < 253 ? 1 : E <= 65535 ? 3 : E <= 4294967295 ? 5 : 9;
  }
  return varuintBitcoin = { encode: y, decode: t, encodingLength: d }, varuintBitcoin;
}
var hasRequiredBufferutils;
function requireBufferutils() {
  if (hasRequiredBufferutils) return bufferutils;
  hasRequiredBufferutils = 1, Object.defineProperty(bufferutils, "__esModule", { value: !0 }), bufferutils.BufferReader = bufferutils.BufferWriter = bufferutils.cloneBuffer = bufferutils.reverseBuffer = bufferutils.writeUInt64LE = bufferutils.readUInt64LE = bufferutils.varuint = void 0;
  const o = requireTypes$3(), { typeforce: g } = o, c = requireVaruintBitcoin();
  bufferutils.varuint = c;
  function y(v, F) {
    if (typeof v != "number")
      throw new Error("cannot write a non-number as a number");
    if (v < 0)
      throw new Error("specified a negative value for writing an unsigned value");
    if (v > F) throw new Error("RangeError: value out of range");
    if (Math.floor(v) !== v)
      throw new Error("value has a fractional component");
  }
  function t(v, F) {
    const M = v.readUInt32LE(F);
    let U = v.readUInt32LE(F + 4);
    return U *= 4294967296, y(U + M, 9007199254740991), U + M;
  }
  bufferutils.readUInt64LE = t;
  function d(v, F, M) {
    return y(F, 9007199254740991), v.writeInt32LE(F & -1, M), v.writeUInt32LE(Math.floor(F / 4294967296), M + 4), M + 8;
  }
  bufferutils.writeUInt64LE = d;
  function E(v) {
    if (v.length < 1) return v;
    let F = v.length - 1, M = 0;
    for (let U = 0; U < v.length / 2; U++)
      M = v[U], v[U] = v[F], v[F] = M, F--;
    return v;
  }
  bufferutils.reverseBuffer = E;
  function B(v) {
    const F = Buffer.allocUnsafe(v.length);
    return v.copy(F), F;
  }
  bufferutils.cloneBuffer = B;
  class D {
    static withCapacity(F) {
      return new D(Buffer.alloc(F));
    }
    constructor(F, M = 0) {
      this.buffer = F, this.offset = M, g(o.tuple(o.Buffer, o.UInt32), [F, M]);
    }
    writeUInt8(F) {
      this.offset = this.buffer.writeUInt8(F, this.offset);
    }
    writeInt32(F) {
      this.offset = this.buffer.writeInt32LE(F, this.offset);
    }
    writeUInt32(F) {
      this.offset = this.buffer.writeUInt32LE(F, this.offset);
    }
    writeUInt64(F) {
      this.offset = d(this.buffer, F, this.offset);
    }
    writeVarInt(F) {
      c.encode(F, this.buffer, this.offset), this.offset += c.encode.bytes;
    }
    writeSlice(F) {
      if (this.buffer.length < this.offset + F.length)
        throw new Error("Cannot write slice out of bounds");
      this.offset += F.copy(this.buffer, this.offset);
    }
    writeVarSlice(F) {
      this.writeVarInt(F.length), this.writeSlice(F);
    }
    writeVector(F) {
      this.writeVarInt(F.length), F.forEach((M) => this.writeVarSlice(M));
    }
    end() {
      if (this.buffer.length === this.offset)
        return this.buffer;
      throw new Error(`buffer size ${this.buffer.length}, offset ${this.offset}`);
    }
  }
  bufferutils.BufferWriter = D;
  class x {
    constructor(F, M = 0) {
      this.buffer = F, this.offset = M, g(o.tuple(o.Buffer, o.UInt32), [F, M]);
    }
    readUInt8() {
      const F = this.buffer.readUInt8(this.offset);
      return this.offset++, F;
    }
    readInt32() {
      const F = this.buffer.readInt32LE(this.offset);
      return this.offset += 4, F;
    }
    readUInt32() {
      const F = this.buffer.readUInt32LE(this.offset);
      return this.offset += 4, F;
    }
    readUInt64() {
      const F = t(this.buffer, this.offset);
      return this.offset += 8, F;
    }
    readVarInt() {
      const F = c.decode(this.buffer, this.offset);
      return this.offset += c.decode.bytes, F;
    }
    readSlice(F) {
      if (this.buffer.length < this.offset + F)
        throw new Error("Cannot read slice out of bounds");
      const M = this.buffer.slice(this.offset, this.offset + F);
      return this.offset += F, M;
    }
    readVarSlice() {
      return this.readSlice(this.readVarInt());
    }
    readVector() {
      const F = this.readVarInt(), M = [];
      for (let U = 0; U < F; U++) M.push(this.readVarSlice());
      return M;
    }
  }
  return bufferutils.BufferReader = x, bufferutils;
}
var hasRequiredBip341;
function requireBip341() {
  return hasRequiredBip341 || (hasRequiredBip341 = 1, function(o) {
    Object.defineProperty(o, "__esModule", { value: !0 }), o.tweakKey = o.tapTweakHash = o.tapleafHash = o.findScriptPath = o.toHashTree = o.rootHashFromPath = o.MAX_TAPTREE_DEPTH = o.LEAF_VERSION_TAPSCRIPT = void 0;
    const g = requireBuffer$2(), c = requireEcc_lib(), y = requireCrypto$1(), t = requireBufferutils(), d = requireTypes$3();
    o.LEAF_VERSION_TAPSCRIPT = 192, o.MAX_TAPTREE_DEPTH = 128;
    const E = (H) => "left" in H && "right" in H;
    function B(H, fe) {
      if (H.length < 33)
        throw new TypeError(
          `The control-block length is too small. Got ${H.length}, expected min 33.`
        );
      const ge = (H.length - 33) / 32;
      let Ie = fe;
      for (let Ee = 0; Ee < ge; Ee++) {
        const Se = H.slice(33 + 32 * Ee, 65 + 32 * Ee);
        Ie.compare(Se) < 0 ? Ie = U(Ie, Se) : Ie = U(Se, Ie);
      }
      return Ie;
    }
    o.rootHashFromPath = B;
    function D(H) {
      if ((0, d.isTapleaf)(H))
        return { hash: v(H) };
      const fe = [D(H[0]), D(H[1])];
      fe.sort((Ee, Se) => Ee.hash.compare(Se.hash));
      const [ge, Ie] = fe;
      return {
        hash: U(ge.hash, Ie.hash),
        left: ge,
        right: Ie
      };
    }
    o.toHashTree = D;
    function x(H, fe) {
      if (E(H)) {
        const ge = x(H.left, fe);
        if (ge !== void 0) return [...ge, H.right.hash];
        const Ie = x(H.right, fe);
        if (Ie !== void 0) return [...Ie, H.left.hash];
      } else if (H.hash.equals(fe))
        return [];
    }
    o.findScriptPath = x;
    function v(H) {
      const fe = H.version || o.LEAF_VERSION_TAPSCRIPT;
      return y.taggedHash(
        "TapLeaf",
        g.Buffer.concat([
          g.Buffer.from([fe]),
          L(H.output)
        ])
      );
    }
    o.tapleafHash = v;
    function F(H, fe) {
      return y.taggedHash(
        "TapTweak",
        g.Buffer.concat(fe ? [H, fe] : [H])
      );
    }
    o.tapTweakHash = F;
    function M(H, fe) {
      if (!g.Buffer.isBuffer(H) || H.length !== 32 || fe && fe.length !== 32) return null;
      const ge = F(H, fe), Ie = (0, c.getEccLib)().xOnlyPointAddTweak(H, ge);
      return !Ie || Ie.xOnlyPubkey === null ? null : {
        parity: Ie.parity,
        x: g.Buffer.from(Ie.xOnlyPubkey)
      };
    }
    o.tweakKey = M;
    function U(H, fe) {
      return y.taggedHash("TapBranch", g.Buffer.concat([H, fe]));
    }
    function L(H) {
      const fe = t.varuint.encodingLength(H.length), ge = g.Buffer.allocUnsafe(fe);
      return t.varuint.encode(H.length, ge), g.Buffer.concat([ge, H]);
    }
  }(bip341)), bip341;
}
var bip341Exports = requireBip341(), bip371 = {}, transaction$1 = {}, script$1 = {}, bip66 = {}, hasRequiredBip66;
function requireBip66() {
  if (hasRequiredBip66) return bip66;
  hasRequiredBip66 = 1, Object.defineProperty(bip66, "__esModule", { value: !0 }), bip66.encode = bip66.decode = bip66.check = void 0;
  function o(y) {
    if (y.length < 8 || y.length > 72 || y[0] !== 48 || y[1] !== y.length - 2 || y[2] !== 2) return !1;
    const t = y[3];
    if (t === 0 || 5 + t >= y.length || y[4 + t] !== 2) return !1;
    const d = y[5 + t];
    return !(d === 0 || 6 + t + d !== y.length || y[4] & 128 || t > 1 && y[4] === 0 && !(y[5] & 128) || y[t + 6] & 128 || d > 1 && y[t + 6] === 0 && !(y[t + 7] & 128));
  }
  bip66.check = o;
  function g(y) {
    if (y.length < 8) throw new Error("DER sequence length is too short");
    if (y.length > 72) throw new Error("DER sequence length is too long");
    if (y[0] !== 48) throw new Error("Expected DER sequence");
    if (y[1] !== y.length - 2)
      throw new Error("DER sequence length is invalid");
    if (y[2] !== 2) throw new Error("Expected DER integer");
    const t = y[3];
    if (t === 0) throw new Error("R length is zero");
    if (5 + t >= y.length) throw new Error("R length is too long");
    if (y[4 + t] !== 2) throw new Error("Expected DER integer (2)");
    const d = y[5 + t];
    if (d === 0) throw new Error("S length is zero");
    if (6 + t + d !== y.length) throw new Error("S length is invalid");
    if (y[4] & 128) throw new Error("R value is negative");
    if (t > 1 && y[4] === 0 && !(y[5] & 128))
      throw new Error("R value excessively padded");
    if (y[t + 6] & 128) throw new Error("S value is negative");
    if (d > 1 && y[t + 6] === 0 && !(y[t + 7] & 128))
      throw new Error("S value excessively padded");
    return {
      r: y.slice(4, 4 + t),
      s: y.slice(6 + t)
    };
  }
  bip66.decode = g;
  function c(y, t) {
    const d = y.length, E = t.length;
    if (d === 0) throw new Error("R length is zero");
    if (E === 0) throw new Error("S length is zero");
    if (d > 33) throw new Error("R length is too long");
    if (E > 33) throw new Error("S length is too long");
    if (y[0] & 128) throw new Error("R value is negative");
    if (t[0] & 128) throw new Error("S value is negative");
    if (d > 1 && y[0] === 0 && !(y[1] & 128))
      throw new Error("R value excessively padded");
    if (E > 1 && t[0] === 0 && !(t[1] & 128))
      throw new Error("S value excessively padded");
    const B = Buffer.allocUnsafe(6 + d + E);
    return B[0] = 48, B[1] = B.length - 2, B[2] = 2, B[3] = y.length, y.copy(B, 4), B[4 + d] = 2, B[5 + d] = t.length, t.copy(B, 6 + d), B;
  }
  return bip66.encode = c, bip66;
}
var ops = {}, hasRequiredOps;
function requireOps() {
  if (hasRequiredOps) return ops;
  hasRequiredOps = 1, Object.defineProperty(ops, "__esModule", { value: !0 }), ops.REVERSE_OPS = ops.OPS = void 0;
  const o = {
    OP_FALSE: 0,
    OP_0: 0,
    OP_PUSHDATA1: 76,
    OP_PUSHDATA2: 77,
    OP_PUSHDATA4: 78,
    OP_1NEGATE: 79,
    OP_RESERVED: 80,
    OP_TRUE: 81,
    OP_1: 81,
    OP_2: 82,
    OP_3: 83,
    OP_4: 84,
    OP_5: 85,
    OP_6: 86,
    OP_7: 87,
    OP_8: 88,
    OP_9: 89,
    OP_10: 90,
    OP_11: 91,
    OP_12: 92,
    OP_13: 93,
    OP_14: 94,
    OP_15: 95,
    OP_16: 96,
    OP_NOP: 97,
    OP_VER: 98,
    OP_IF: 99,
    OP_NOTIF: 100,
    OP_VERIF: 101,
    OP_VERNOTIF: 102,
    OP_ELSE: 103,
    OP_ENDIF: 104,
    OP_VERIFY: 105,
    OP_RETURN: 106,
    OP_TOALTSTACK: 107,
    OP_FROMALTSTACK: 108,
    OP_2DROP: 109,
    OP_2DUP: 110,
    OP_3DUP: 111,
    OP_2OVER: 112,
    OP_2ROT: 113,
    OP_2SWAP: 114,
    OP_IFDUP: 115,
    OP_DEPTH: 116,
    OP_DROP: 117,
    OP_DUP: 118,
    OP_NIP: 119,
    OP_OVER: 120,
    OP_PICK: 121,
    OP_ROLL: 122,
    OP_ROT: 123,
    OP_SWAP: 124,
    OP_TUCK: 125,
    OP_CAT: 126,
    OP_SUBSTR: 127,
    OP_LEFT: 128,
    OP_RIGHT: 129,
    OP_SIZE: 130,
    OP_INVERT: 131,
    OP_AND: 132,
    OP_OR: 133,
    OP_XOR: 134,
    OP_EQUAL: 135,
    OP_EQUALVERIFY: 136,
    OP_RESERVED1: 137,
    OP_RESERVED2: 138,
    OP_1ADD: 139,
    OP_1SUB: 140,
    OP_2MUL: 141,
    OP_2DIV: 142,
    OP_NEGATE: 143,
    OP_ABS: 144,
    OP_NOT: 145,
    OP_0NOTEQUAL: 146,
    OP_ADD: 147,
    OP_SUB: 148,
    OP_MUL: 149,
    OP_DIV: 150,
    OP_MOD: 151,
    OP_LSHIFT: 152,
    OP_RSHIFT: 153,
    OP_BOOLAND: 154,
    OP_BOOLOR: 155,
    OP_NUMEQUAL: 156,
    OP_NUMEQUALVERIFY: 157,
    OP_NUMNOTEQUAL: 158,
    OP_LESSTHAN: 159,
    OP_GREATERTHAN: 160,
    OP_LESSTHANOREQUAL: 161,
    OP_GREATERTHANOREQUAL: 162,
    OP_MIN: 163,
    OP_MAX: 164,
    OP_WITHIN: 165,
    OP_RIPEMD160: 166,
    OP_SHA1: 167,
    OP_SHA256: 168,
    OP_HASH160: 169,
    OP_HASH256: 170,
    OP_CODESEPARATOR: 171,
    OP_CHECKSIG: 172,
    OP_CHECKSIGVERIFY: 173,
    OP_CHECKMULTISIG: 174,
    OP_CHECKMULTISIGVERIFY: 175,
    OP_NOP1: 176,
    OP_NOP2: 177,
    OP_CHECKLOCKTIMEVERIFY: 177,
    OP_NOP3: 178,
    OP_CHECKSEQUENCEVERIFY: 178,
    OP_NOP4: 179,
    OP_NOP5: 180,
    OP_NOP6: 181,
    OP_NOP7: 182,
    OP_NOP8: 183,
    OP_NOP9: 184,
    OP_NOP10: 185,
    OP_CHECKSIGADD: 186,
    OP_PUBKEYHASH: 253,
    OP_PUBKEY: 254,
    OP_INVALIDOPCODE: 255
  };
  ops.OPS = o;
  const g = {};
  ops.REVERSE_OPS = g;
  for (const c of Object.keys(o)) {
    const y = o[c];
    g[y] = c;
  }
  return ops;
}
var push_data = {}, hasRequiredPush_data;
function requirePush_data() {
  if (hasRequiredPush_data) return push_data;
  hasRequiredPush_data = 1, Object.defineProperty(push_data, "__esModule", { value: !0 }), push_data.decode = push_data.encode = push_data.encodingLength = void 0;
  const o = requireOps();
  function g(t) {
    return t < o.OPS.OP_PUSHDATA1 ? 1 : t <= 255 ? 2 : t <= 65535 ? 3 : 5;
  }
  push_data.encodingLength = g;
  function c(t, d, E) {
    const B = g(d);
    return B === 1 ? t.writeUInt8(d, E) : B === 2 ? (t.writeUInt8(o.OPS.OP_PUSHDATA1, E), t.writeUInt8(d, E + 1)) : B === 3 ? (t.writeUInt8(o.OPS.OP_PUSHDATA2, E), t.writeUInt16LE(d, E + 1)) : (t.writeUInt8(o.OPS.OP_PUSHDATA4, E), t.writeUInt32LE(d, E + 1)), B;
  }
  push_data.encode = c;
  function y(t, d) {
    const E = t.readUInt8(d);
    let B, D;
    if (E < o.OPS.OP_PUSHDATA1)
      B = E, D = 1;
    else if (E === o.OPS.OP_PUSHDATA1) {
      if (d + 2 > t.length) return null;
      B = t.readUInt8(d + 1), D = 2;
    } else if (E === o.OPS.OP_PUSHDATA2) {
      if (d + 3 > t.length) return null;
      B = t.readUInt16LE(d + 1), D = 3;
    } else {
      if (d + 5 > t.length) return null;
      if (E !== o.OPS.OP_PUSHDATA4) throw new Error("Unexpected opcode");
      B = t.readUInt32LE(d + 1), D = 5;
    }
    return {
      opcode: E,
      number: B,
      size: D
    };
  }
  return push_data.decode = y, push_data;
}
var script_number = {}, hasRequiredScript_number;
function requireScript_number() {
  if (hasRequiredScript_number) return script_number;
  hasRequiredScript_number = 1, Object.defineProperty(script_number, "__esModule", { value: !0 }), script_number.encode = script_number.decode = void 0;
  function o(y, t, d) {
    t = t || 4, d = d === void 0 ? !0 : d;
    const E = y.length;
    if (E === 0) return 0;
    if (E > t) throw new TypeError("Script number overflow");
    if (d && (y[E - 1] & 127) === 0 && (E <= 1 || (y[E - 2] & 128) === 0))
      throw new Error("Non-minimally encoded script number");
    if (E === 5) {
      const D = y.readUInt32LE(0), x = y.readUInt8(4);
      return x & 128 ? -((x & -129) * 4294967296 + D) : x * 4294967296 + D;
    }
    let B = 0;
    for (let D = 0; D < E; ++D)
      B |= y[D] << 8 * D;
    return y[E - 1] & 128 ? -(B & ~(128 << 8 * (E - 1))) : B;
  }
  script_number.decode = o;
  function g(y) {
    return y > 2147483647 ? 5 : y > 8388607 ? 4 : y > 32767 ? 3 : y > 127 ? 2 : y > 0 ? 1 : 0;
  }
  function c(y) {
    let t = Math.abs(y);
    const d = g(t), E = Buffer.allocUnsafe(d), B = y < 0;
    for (let D = 0; D < d; ++D)
      E.writeUInt8(t & 255, D), t >>= 8;
    return E[d - 1] & 128 ? E.writeUInt8(B ? 128 : 0, d - 1) : B && (E[d - 1] |= 128), E;
  }
  return script_number.encode = c, script_number;
}
var script_signature = {}, hasRequiredScript_signature;
function requireScript_signature() {
  if (hasRequiredScript_signature) return script_signature;
  hasRequiredScript_signature = 1, Object.defineProperty(script_signature, "__esModule", { value: !0 }), script_signature.encode = script_signature.decode = void 0;
  const o = requireBip66(), g = requireScript$1(), c = requireTypes$3(), { typeforce: y } = c, t = Buffer.alloc(1, 0);
  function d(x) {
    let v = 0;
    for (; x[v] === 0; ) ++v;
    return v === x.length ? t : (x = x.slice(v), x[0] & 128 ? Buffer.concat([t, x], 1 + x.length) : x);
  }
  function E(x) {
    x[0] === 0 && (x = x.slice(1));
    const v = Buffer.alloc(32, 0), F = Math.max(0, 32 - x.length);
    return x.copy(v, F), v;
  }
  function B(x) {
    const v = x.readUInt8(x.length - 1);
    if (!(0, g.isDefinedHashType)(v))
      throw new Error("Invalid hashType " + v);
    const F = o.decode(x.slice(0, -1)), M = E(F.r), U = E(F.s);
    return { signature: Buffer.concat([M, U], 64), hashType: v };
  }
  script_signature.decode = B;
  function D(x, v) {
    if (y(
      {
        signature: c.BufferN(64),
        hashType: c.UInt8
      },
      { signature: x, hashType: v }
    ), !(0, g.isDefinedHashType)(v))
      throw new Error("Invalid hashType " + v);
    const F = Buffer.allocUnsafe(1);
    F.writeUInt8(v, 0);
    const M = d(x.slice(0, 32)), U = d(x.slice(32, 64));
    return Buffer.concat([o.encode(M, U), F]);
  }
  return script_signature.encode = D, script_signature;
}
var hasRequiredScript$1;
function requireScript$1() {
  return hasRequiredScript$1 || (hasRequiredScript$1 = 1, function(o) {
    Object.defineProperty(o, "__esModule", { value: !0 }), o.signature = o.number = o.isCanonicalScriptSignature = o.isDefinedHashType = o.isCanonicalPubKey = o.toStack = o.fromASM = o.toASM = o.decompile = o.compile = o.countNonPushOnlyOPs = o.isPushOnly = o.OPS = void 0;
    const g = requireBip66(), c = requireOps();
    Object.defineProperty(o, "OPS", {
      enumerable: !0,
      get: function() {
        return c.OPS;
      }
    });
    const y = requirePush_data(), t = requireScript_number(), d = requireScript_signature(), E = requireTypes$3(), { typeforce: B } = E, D = c.OPS.OP_RESERVED;
    function x(ve) {
      return E.Number(ve) && (ve === c.OPS.OP_0 || ve >= c.OPS.OP_1 && ve <= c.OPS.OP_16 || ve === c.OPS.OP_1NEGATE);
    }
    function v(ve) {
      return E.Buffer(ve) || x(ve);
    }
    function F(ve) {
      return E.Array(ve) && ve.every(v);
    }
    o.isPushOnly = F;
    function M(ve) {
      return ve.length - ve.filter(v).length;
    }
    o.countNonPushOnlyOPs = M;
    function U(ve) {
      if (ve.length === 0) return c.OPS.OP_0;
      if (ve.length === 1) {
        if (ve[0] >= 1 && ve[0] <= 16) return D + ve[0];
        if (ve[0] === 129) return c.OPS.OP_1NEGATE;
      }
    }
    function L(ve) {
      return Buffer.isBuffer(ve);
    }
    function H(ve) {
      return E.Array(ve);
    }
    function fe(ve) {
      return Buffer.isBuffer(ve);
    }
    function ge(ve) {
      if (L(ve)) return ve;
      B(E.Array, ve);
      const Fe = ve.reduce((ke, xe) => fe(xe) ? xe.length === 1 && U(xe) !== void 0 ? ke + 1 : ke + y.encodingLength(xe.length) + xe.length : ke + 1, 0), be = Buffer.allocUnsafe(Fe);
      let Be = 0;
      if (ve.forEach((ke) => {
        if (fe(ke)) {
          const xe = U(ke);
          if (xe !== void 0) {
            be.writeUInt8(xe, Be), Be += 1;
            return;
          }
          Be += y.encode(be, ke.length, Be), ke.copy(be, Be), Be += ke.length;
        } else
          be.writeUInt8(ke, Be), Be += 1;
      }), Be !== be.length) throw new Error("Could not decode chunks");
      return be;
    }
    o.compile = ge;
    function Ie(ve) {
      if (H(ve)) return ve;
      B(E.Buffer, ve);
      const Fe = [];
      let be = 0;
      for (; be < ve.length; ) {
        const Be = ve[be];
        if (Be > c.OPS.OP_0 && Be <= c.OPS.OP_PUSHDATA4) {
          const ke = y.decode(ve, be);
          if (ke === null || (be += ke.size, be + ke.number > ve.length)) return null;
          const xe = ve.slice(be, be + ke.number);
          be += ke.number;
          const Ne = U(xe);
          Ne !== void 0 ? Fe.push(Ne) : Fe.push(xe);
        } else
          Fe.push(Be), be += 1;
      }
      return Fe;
    }
    o.decompile = Ie;
    function Ee(ve) {
      if (L(ve) && (ve = Ie(ve)), !ve)
        throw new Error("Could not convert invalid chunks to ASM");
      return ve.map((Fe) => {
        if (fe(Fe)) {
          const be = U(Fe);
          if (be === void 0) return Fe.toString("hex");
          Fe = be;
        }
        return c.REVERSE_OPS[Fe];
      }).join(" ");
    }
    o.toASM = Ee;
    function Se(ve) {
      return B(E.String, ve), ge(
        ve.split(" ").map((Fe) => c.OPS[Fe] !== void 0 ? c.OPS[Fe] : (B(E.Hex, Fe), Buffer.from(Fe, "hex")))
      );
    }
    o.fromASM = Se;
    function ze(ve) {
      return ve = Ie(ve), B(F, ve), ve.map((Fe) => fe(Fe) ? Fe : Fe === c.OPS.OP_0 ? Buffer.allocUnsafe(0) : t.encode(Fe - D));
    }
    o.toStack = ze;
    function He(ve) {
      return E.isPoint(ve);
    }
    o.isCanonicalPubKey = He;
    function Pe(ve) {
      const Fe = ve & -129;
      return Fe > 0 && Fe < 4;
    }
    o.isDefinedHashType = Pe;
    function De(ve) {
      return !Buffer.isBuffer(ve) || !Pe(ve[ve.length - 1]) ? !1 : g.check(ve.slice(0, -1));
    }
    o.isCanonicalScriptSignature = De, o.number = t, o.signature = d;
  }(script$1)), script$1;
}
var hasRequiredTransaction$1;
function requireTransaction$1() {
  if (hasRequiredTransaction$1) return transaction$1;
  hasRequiredTransaction$1 = 1, Object.defineProperty(transaction$1, "__esModule", { value: !0 }), transaction$1.Transaction = void 0;
  const o = requireBufferutils(), g = requireCrypto$1(), c = requireScript$1(), y = requireScript$1(), t = requireTypes$3(), { typeforce: d } = t;
  function E(fe) {
    const ge = fe.length;
    return o.varuint.encodingLength(ge) + ge;
  }
  function B(fe) {
    const ge = fe.length;
    return o.varuint.encodingLength(ge) + fe.reduce((Ie, Ee) => Ie + E(Ee), 0);
  }
  const D = Buffer.allocUnsafe(0), x = [], v = Buffer.from(
    "0000000000000000000000000000000000000000000000000000000000000000",
    "hex"
  ), F = Buffer.from(
    "0000000000000000000000000000000000000000000000000000000000000001",
    "hex"
  ), M = Buffer.from("ffffffffffffffff", "hex"), U = {
    script: D,
    valueBuffer: M
  };
  function L(fe) {
    return fe.value !== void 0;
  }
  class H {
    constructor() {
      this.version = 1, this.locktime = 0, this.ins = [], this.outs = [];
    }
    static fromBuffer(ge, Ie) {
      const Ee = new o.BufferReader(ge), Se = new H();
      Se.version = Ee.readInt32();
      const ze = Ee.readUInt8(), He = Ee.readUInt8();
      let Pe = !1;
      ze === H.ADVANCED_TRANSACTION_MARKER && He === H.ADVANCED_TRANSACTION_FLAG ? Pe = !0 : Ee.offset -= 2;
      const De = Ee.readVarInt();
      for (let Fe = 0; Fe < De; ++Fe)
        Se.ins.push({
          hash: Ee.readSlice(32),
          index: Ee.readUInt32(),
          script: Ee.readVarSlice(),
          sequence: Ee.readUInt32(),
          witness: x
        });
      const ve = Ee.readVarInt();
      for (let Fe = 0; Fe < ve; ++Fe)
        Se.outs.push({
          value: Ee.readUInt64(),
          script: Ee.readVarSlice()
        });
      if (Pe) {
        for (let Fe = 0; Fe < De; ++Fe)
          Se.ins[Fe].witness = Ee.readVector();
        if (!Se.hasWitnesses())
          throw new Error("Transaction has superfluous witness data");
      }
      if (Se.locktime = Ee.readUInt32(), Ie) return Se;
      if (Ee.offset !== ge.length)
        throw new Error("Transaction has unexpected data");
      return Se;
    }
    static fromHex(ge) {
      return H.fromBuffer(Buffer.from(ge, "hex"), !1);
    }
    static isCoinbaseHash(ge) {
      d(t.Hash256bit, ge);
      for (let Ie = 0; Ie < 32; ++Ie)
        if (ge[Ie] !== 0) return !1;
      return !0;
    }
    isCoinbase() {
      return this.ins.length === 1 && H.isCoinbaseHash(this.ins[0].hash);
    }
    addInput(ge, Ie, Ee, Se) {
      return d(
        t.tuple(
          t.Hash256bit,
          t.UInt32,
          t.maybe(t.UInt32),
          t.maybe(t.Buffer)
        ),
        arguments
      ), t.Null(Ee) && (Ee = H.DEFAULT_SEQUENCE), this.ins.push({
        hash: ge,
        index: Ie,
        script: Se || D,
        sequence: Ee,
        witness: x
      }) - 1;
    }
    addOutput(ge, Ie) {
      return d(t.tuple(t.Buffer, t.Satoshi), arguments), this.outs.push({
        script: ge,
        value: Ie
      }) - 1;
    }
    hasWitnesses() {
      return this.ins.some((ge) => ge.witness.length !== 0);
    }
    stripWitnesses() {
      this.ins.forEach((ge) => {
        ge.witness = x;
      });
    }
    weight() {
      const ge = this.byteLength(!1), Ie = this.byteLength(!0);
      return ge * 3 + Ie;
    }
    virtualSize() {
      return Math.ceil(this.weight() / 4);
    }
    byteLength(ge = !0) {
      const Ie = ge && this.hasWitnesses();
      return (Ie ? 10 : 8) + o.varuint.encodingLength(this.ins.length) + o.varuint.encodingLength(this.outs.length) + this.ins.reduce((Ee, Se) => Ee + 40 + E(Se.script), 0) + this.outs.reduce((Ee, Se) => Ee + 8 + E(Se.script), 0) + (Ie ? this.ins.reduce((Ee, Se) => Ee + B(Se.witness), 0) : 0);
    }
    clone() {
      const ge = new H();
      return ge.version = this.version, ge.locktime = this.locktime, ge.ins = this.ins.map((Ie) => ({
        hash: Ie.hash,
        index: Ie.index,
        script: Ie.script,
        sequence: Ie.sequence,
        witness: Ie.witness
      })), ge.outs = this.outs.map((Ie) => ({
        script: Ie.script,
        value: Ie.value
      })), ge;
    }
    /**
     * Hash transaction for signing a specific input.
     *
     * Bitcoin uses a different hash for each signed transaction input.
     * This method copies the transaction, makes the necessary changes based on the
     * hashType, and then hashes the result.
     * This hash can then be used to sign the provided transaction input.
     */
    hashForSignature(ge, Ie, Ee) {
      if (d(
        t.tuple(
          t.UInt32,
          t.Buffer,
          /* types.UInt8 */
          t.Number
        ),
        arguments
      ), ge >= this.ins.length) return F;
      const Se = c.compile(
        c.decompile(Ie).filter((Pe) => Pe !== y.OPS.OP_CODESEPARATOR)
      ), ze = this.clone();
      if ((Ee & 31) === H.SIGHASH_NONE)
        ze.outs = [], ze.ins.forEach((Pe, De) => {
          De !== ge && (Pe.sequence = 0);
        });
      else if ((Ee & 31) === H.SIGHASH_SINGLE) {
        if (ge >= this.outs.length) return F;
        ze.outs.length = ge + 1;
        for (let Pe = 0; Pe < ge; Pe++)
          ze.outs[Pe] = U;
        ze.ins.forEach((Pe, De) => {
          De !== ge && (Pe.sequence = 0);
        });
      }
      Ee & H.SIGHASH_ANYONECANPAY ? (ze.ins = [ze.ins[ge]], ze.ins[0].script = Se) : (ze.ins.forEach((Pe) => {
        Pe.script = D;
      }), ze.ins[ge].script = Se);
      const He = Buffer.allocUnsafe(ze.byteLength(!1) + 4);
      return He.writeInt32LE(Ee, He.length - 4), ze.__toBuffer(He, 0, !1), g.hash256(He);
    }
    hashForWitnessV1(ge, Ie, Ee, Se, ze, He) {
      if (d(
        t.tuple(
          t.UInt32,
          d.arrayOf(t.Buffer),
          d.arrayOf(t.Satoshi),
          t.UInt32
        ),
        arguments
      ), Ee.length !== this.ins.length || Ie.length !== this.ins.length)
        throw new Error("Must supply prevout script and value for all inputs");
      const Pe = Se === H.SIGHASH_DEFAULT ? H.SIGHASH_ALL : Se & H.SIGHASH_OUTPUT_MASK, ve = (Se & H.SIGHASH_INPUT_MASK) === H.SIGHASH_ANYONECANPAY, Fe = Pe === H.SIGHASH_NONE, be = Pe === H.SIGHASH_SINGLE;
      let Be = D, ke = D, xe = D, Ne = D, Et = D;
      if (!ve) {
        let xt = o.BufferWriter.withCapacity(
          36 * this.ins.length
        );
        this.ins.forEach((ir) => {
          xt.writeSlice(ir.hash), xt.writeUInt32(ir.index);
        }), Be = g.sha256(xt.end()), xt = o.BufferWriter.withCapacity(
          8 * this.ins.length
        ), Ee.forEach((ir) => xt.writeUInt64(ir)), ke = g.sha256(xt.end()), xt = o.BufferWriter.withCapacity(
          Ie.map(E).reduce((ir, sr) => ir + sr)
        ), Ie.forEach(
          (ir) => xt.writeVarSlice(ir)
        ), xe = g.sha256(xt.end()), xt = o.BufferWriter.withCapacity(
          4 * this.ins.length
        ), this.ins.forEach((ir) => xt.writeUInt32(ir.sequence)), Ne = g.sha256(xt.end());
      }
      if (Fe || be) {
        if (be && ge < this.outs.length) {
          const xt = this.outs[ge], ir = o.BufferWriter.withCapacity(
            8 + E(xt.script)
          );
          ir.writeUInt64(xt.value), ir.writeVarSlice(xt.script), Et = g.sha256(ir.end());
        }
      } else {
        const xt = this.outs.map((sr) => 8 + E(sr.script)).reduce((sr, yr) => sr + yr), ir = o.BufferWriter.withCapacity(xt);
        this.outs.forEach((sr) => {
          ir.writeUInt64(sr.value), ir.writeVarSlice(sr.script);
        }), Et = g.sha256(ir.end());
      }
      const st = (ze ? 2 : 0) + (He ? 1 : 0), Dt = 174 - (ve ? 49 : 0) - (Fe ? 32 : 0) + (He ? 32 : 0) + (ze ? 37 : 0), er = o.BufferWriter.withCapacity(Dt);
      if (er.writeUInt8(Se), er.writeInt32(this.version), er.writeUInt32(this.locktime), er.writeSlice(Be), er.writeSlice(ke), er.writeSlice(xe), er.writeSlice(Ne), Fe || be || er.writeSlice(Et), er.writeUInt8(st), ve) {
        const xt = this.ins[ge];
        er.writeSlice(xt.hash), er.writeUInt32(xt.index), er.writeUInt64(Ee[ge]), er.writeVarSlice(Ie[ge]), er.writeUInt32(xt.sequence);
      } else
        er.writeUInt32(ge);
      if (He) {
        const xt = o.BufferWriter.withCapacity(
          E(He)
        );
        xt.writeVarSlice(He), er.writeSlice(g.sha256(xt.end()));
      }
      return be && er.writeSlice(Et), ze && (er.writeSlice(ze), er.writeUInt8(0), er.writeUInt32(4294967295)), g.taggedHash(
        "TapSighash",
        Buffer.concat([Buffer.from([0]), er.end()])
      );
    }
    hashForWitnessV0(ge, Ie, Ee, Se) {
      d(
        t.tuple(t.UInt32, t.Buffer, t.Satoshi, t.UInt32),
        arguments
      );
      let ze = Buffer.from([]), He, Pe = v, De = v, ve = v;
      if (Se & H.SIGHASH_ANYONECANPAY || (ze = Buffer.allocUnsafe(36 * this.ins.length), He = new o.BufferWriter(ze, 0), this.ins.forEach((be) => {
        He.writeSlice(be.hash), He.writeUInt32(be.index);
      }), De = g.hash256(ze)), !(Se & H.SIGHASH_ANYONECANPAY) && (Se & 31) !== H.SIGHASH_SINGLE && (Se & 31) !== H.SIGHASH_NONE && (ze = Buffer.allocUnsafe(4 * this.ins.length), He = new o.BufferWriter(ze, 0), this.ins.forEach((be) => {
        He.writeUInt32(be.sequence);
      }), ve = g.hash256(ze)), (Se & 31) !== H.SIGHASH_SINGLE && (Se & 31) !== H.SIGHASH_NONE) {
        const be = this.outs.reduce((Be, ke) => Be + 8 + E(ke.script), 0);
        ze = Buffer.allocUnsafe(be), He = new o.BufferWriter(ze, 0), this.outs.forEach((Be) => {
          He.writeUInt64(Be.value), He.writeVarSlice(Be.script);
        }), Pe = g.hash256(ze);
      } else if ((Se & 31) === H.SIGHASH_SINGLE && ge < this.outs.length) {
        const be = this.outs[ge];
        ze = Buffer.allocUnsafe(8 + E(be.script)), He = new o.BufferWriter(ze, 0), He.writeUInt64(be.value), He.writeVarSlice(be.script), Pe = g.hash256(ze);
      }
      ze = Buffer.allocUnsafe(156 + E(Ie)), He = new o.BufferWriter(ze, 0);
      const Fe = this.ins[ge];
      return He.writeInt32(this.version), He.writeSlice(De), He.writeSlice(ve), He.writeSlice(Fe.hash), He.writeUInt32(Fe.index), He.writeVarSlice(Ie), He.writeUInt64(Ee), He.writeUInt32(Fe.sequence), He.writeSlice(Pe), He.writeUInt32(this.locktime), He.writeUInt32(Se), g.hash256(ze);
    }
    getHash(ge) {
      return ge && this.isCoinbase() ? Buffer.alloc(32, 0) : g.hash256(this.__toBuffer(void 0, void 0, ge));
    }
    getId() {
      return (0, o.reverseBuffer)(this.getHash(!1)).toString(
        "hex"
      );
    }
    toBuffer(ge, Ie) {
      return this.__toBuffer(ge, Ie, !0);
    }
    toHex() {
      return this.toBuffer(void 0, void 0).toString("hex");
    }
    setInputScript(ge, Ie) {
      d(t.tuple(t.Number, t.Buffer), arguments), this.ins[ge].script = Ie;
    }
    setWitness(ge, Ie) {
      d(t.tuple(t.Number, [t.Buffer]), arguments), this.ins[ge].witness = Ie;
    }
    __toBuffer(ge, Ie, Ee = !1) {
      ge || (ge = Buffer.allocUnsafe(this.byteLength(Ee)));
      const Se = new o.BufferWriter(
        ge,
        Ie || 0
      );
      Se.writeInt32(this.version);
      const ze = Ee && this.hasWitnesses();
      return ze && (Se.writeUInt8(H.ADVANCED_TRANSACTION_MARKER), Se.writeUInt8(H.ADVANCED_TRANSACTION_FLAG)), Se.writeVarInt(this.ins.length), this.ins.forEach((He) => {
        Se.writeSlice(He.hash), Se.writeUInt32(He.index), Se.writeVarSlice(He.script), Se.writeUInt32(He.sequence);
      }), Se.writeVarInt(this.outs.length), this.outs.forEach((He) => {
        L(He) ? Se.writeUInt64(He.value) : Se.writeSlice(He.valueBuffer), Se.writeVarSlice(He.script);
      }), ze && this.ins.forEach((He) => {
        Se.writeVector(He.witness);
      }), Se.writeUInt32(this.locktime), Ie !== void 0 ? ge.slice(Ie, Se.offset) : ge;
    }
  }
  return transaction$1.Transaction = H, H.DEFAULT_SEQUENCE = 4294967295, H.SIGHASH_DEFAULT = 0, H.SIGHASH_ALL = 1, H.SIGHASH_NONE = 2, H.SIGHASH_SINGLE = 3, H.SIGHASH_ANYONECANPAY = 128, H.SIGHASH_OUTPUT_MASK = 3, H.SIGHASH_INPUT_MASK = 128, H.ADVANCED_TRANSACTION_MARKER = 0, H.ADVANCED_TRANSACTION_FLAG = 1, transaction$1;
}
var psbtutils = {}, varint$3 = {}, hasRequiredVarint$3;
function requireVarint$3() {
  if (hasRequiredVarint$3) return varint$3;
  hasRequiredVarint$3 = 1, Object.defineProperty(varint$3, "__esModule", { value: !0 });
  const o = 9007199254740991;
  function g(d) {
    if (d < 0 || d > o || d % 1 !== 0)
      throw new RangeError("value out of range");
  }
  function c(d, E, B) {
    if (g(d), E || (E = Buffer.allocUnsafe(t(d))), !Buffer.isBuffer(E))
      throw new TypeError("buffer must be a Buffer instance");
    return B || (B = 0), d < 253 ? (E.writeUInt8(d, B), Object.assign(c, { bytes: 1 })) : d <= 65535 ? (E.writeUInt8(253, B), E.writeUInt16LE(d, B + 1), Object.assign(c, { bytes: 3 })) : d <= 4294967295 ? (E.writeUInt8(254, B), E.writeUInt32LE(d, B + 1), Object.assign(c, { bytes: 5 })) : (E.writeUInt8(255, B), E.writeUInt32LE(d >>> 0, B + 1), E.writeUInt32LE(d / 4294967296 | 0, B + 5), Object.assign(c, { bytes: 9 })), E;
  }
  varint$3.encode = c;
  function y(d, E) {
    if (!Buffer.isBuffer(d))
      throw new TypeError("buffer must be a Buffer instance");
    E || (E = 0);
    const B = d.readUInt8(E);
    if (B < 253)
      return Object.assign(y, { bytes: 1 }), B;
    if (B === 253)
      return Object.assign(y, { bytes: 3 }), d.readUInt16LE(E + 1);
    if (B === 254)
      return Object.assign(y, { bytes: 5 }), d.readUInt32LE(E + 1);
    {
      Object.assign(y, { bytes: 9 });
      const D = d.readUInt32LE(E + 1), v = d.readUInt32LE(E + 5) * 4294967296 + D;
      return g(v), v;
    }
  }
  varint$3.decode = y;
  function t(d) {
    return g(d), d < 253 ? 1 : d <= 65535 ? 3 : d <= 4294967295 ? 5 : 9;
  }
  return varint$3.encodingLength = t, varint$3;
}
var payments = {}, embed = {}, networks$1 = {}, hasRequiredNetworks$1;
function requireNetworks$1() {
  return hasRequiredNetworks$1 || (hasRequiredNetworks$1 = 1, Object.defineProperty(networks$1, "__esModule", { value: !0 }), networks$1.testnet = networks$1.regtest = networks$1.bitcoin = void 0, networks$1.bitcoin = {
    /**
     * The message prefix used for signing Bitcoin messages.
     */
    messagePrefix: `Bitcoin Signed Message:
`,
    /**
     * The Bech32 prefix used for Bitcoin addresses.
     */
    bech32: "bc",
    /**
     * The BIP32 key prefixes for Bitcoin.
     */
    bip32: {
      /**
       * The public key prefix for BIP32 extended public keys.
       */
      public: 76067358,
      /**
       * The private key prefix for BIP32 extended private keys.
       */
      private: 76066276
    },
    /**
     * The prefix for Bitcoin public key hashes.
     */
    pubKeyHash: 0,
    /**
     * The prefix for Bitcoin script hashes.
     */
    scriptHash: 5,
    /**
     * The prefix for Bitcoin Wallet Import Format (WIF) private keys.
     */
    wif: 128
  }, networks$1.regtest = {
    messagePrefix: `Bitcoin Signed Message:
`,
    bech32: "bcrt",
    bip32: {
      public: 70617039,
      private: 70615956
    },
    pubKeyHash: 111,
    scriptHash: 196,
    wif: 239
  }, networks$1.testnet = {
    messagePrefix: `Bitcoin Signed Message:
`,
    bech32: "tb",
    bip32: {
      public: 70617039,
      private: 70615956
    },
    pubKeyHash: 111,
    scriptHash: 196,
    wif: 239
  }), networks$1;
}
var lazy = {}, hasRequiredLazy;
function requireLazy() {
  if (hasRequiredLazy) return lazy;
  hasRequiredLazy = 1, Object.defineProperty(lazy, "__esModule", { value: !0 }), lazy.value = lazy.prop = void 0;
  function o(c, y, t) {
    Object.defineProperty(c, y, {
      configurable: !0,
      enumerable: !0,
      get() {
        const d = t.call(this);
        return this[y] = d, d;
      },
      set(d) {
        Object.defineProperty(this, y, {
          configurable: !0,
          enumerable: !0,
          value: d,
          writable: !0
        });
      }
    });
  }
  lazy.prop = o;
  function g(c) {
    let y;
    return () => (y !== void 0 || (y = c()), y);
  }
  return lazy.value = g, lazy;
}
var hasRequiredEmbed;
function requireEmbed() {
  if (hasRequiredEmbed) return embed;
  hasRequiredEmbed = 1, Object.defineProperty(embed, "__esModule", { value: !0 }), embed.p2data = void 0;
  const o = requireNetworks$1(), g = requireScript$1(), c = requireTypes$3(), y = requireLazy(), t = g.OPS;
  function d(E, B) {
    if (!E.data && !E.output) throw new TypeError("Not enough data");
    B = Object.assign({ validate: !0 }, B || {}), (0, c.typeforce)(
      {
        network: c.typeforce.maybe(c.typeforce.Object),
        output: c.typeforce.maybe(c.typeforce.Buffer),
        data: c.typeforce.maybe(
          c.typeforce.arrayOf(c.typeforce.Buffer)
        )
      },
      E
    );
    const x = { name: "embed", network: E.network || o.bitcoin };
    if (y.prop(x, "output", () => {
      if (E.data)
        return g.compile([t.OP_RETURN].concat(E.data));
    }), y.prop(x, "data", () => {
      if (E.output)
        return g.decompile(E.output).slice(1);
    }), B.validate && E.output) {
      const v = g.decompile(E.output);
      if (v[0] !== t.OP_RETURN) throw new TypeError("Output is invalid");
      if (!v.slice(1).every(c.typeforce.Buffer))
        throw new TypeError("Output is invalid");
      if (E.data && !(0, c.stacksEqual)(E.data, x.data))
        throw new TypeError("Data mismatch");
    }
    return Object.assign(x, E);
  }
  return embed.p2data = d, embed;
}
var p2ms = {}, hasRequiredP2ms;
function requireP2ms() {
  if (hasRequiredP2ms) return p2ms;
  hasRequiredP2ms = 1, Object.defineProperty(p2ms, "__esModule", { value: !0 }), p2ms.p2ms = void 0;
  const o = requireNetworks$1(), g = requireScript$1(), c = requireTypes$3(), y = requireLazy(), t = g.OPS, d = t.OP_RESERVED;
  function E(B, D) {
    if (!B.input && !B.output && !(B.pubkeys && B.m !== void 0) && !B.signatures)
      throw new TypeError("Not enough data");
    D = Object.assign({ validate: !0 }, D || {});
    function x(H) {
      return g.isCanonicalScriptSignature(H) || (D.allowIncomplete && H === t.OP_0) !== void 0;
    }
    (0, c.typeforce)(
      {
        network: c.typeforce.maybe(c.typeforce.Object),
        m: c.typeforce.maybe(c.typeforce.Number),
        n: c.typeforce.maybe(c.typeforce.Number),
        output: c.typeforce.maybe(c.typeforce.Buffer),
        pubkeys: c.typeforce.maybe(
          c.typeforce.arrayOf(c.isPoint)
        ),
        signatures: c.typeforce.maybe(
          c.typeforce.arrayOf(x)
        ),
        input: c.typeforce.maybe(c.typeforce.Buffer)
      },
      B
    );
    const F = { network: B.network || o.bitcoin };
    let M = [], U = !1;
    function L(H) {
      U || (U = !0, M = g.decompile(H), F.m = M[0] - d, F.n = M[M.length - 2] - d, F.pubkeys = M.slice(1, -2));
    }
    if (y.prop(F, "output", () => {
      if (B.m && F.n && B.pubkeys)
        return g.compile(
          [].concat(
            d + B.m,
            B.pubkeys,
            d + F.n,
            t.OP_CHECKMULTISIG
          )
        );
    }), y.prop(F, "m", () => {
      if (F.output)
        return L(F.output), F.m;
    }), y.prop(F, "n", () => {
      if (F.pubkeys)
        return F.pubkeys.length;
    }), y.prop(F, "pubkeys", () => {
      if (B.output)
        return L(B.output), F.pubkeys;
    }), y.prop(F, "signatures", () => {
      if (B.input)
        return g.decompile(B.input).slice(1);
    }), y.prop(F, "input", () => {
      if (B.signatures)
        return g.compile([t.OP_0].concat(B.signatures));
    }), y.prop(F, "witness", () => {
      if (F.input)
        return [];
    }), y.prop(F, "name", () => {
      if (!(!F.m || !F.n))
        return `p2ms(${F.m} of ${F.n})`;
    }), D.validate) {
      if (B.output) {
        if (L(B.output), !c.typeforce.Number(M[0]))
          throw new TypeError("Output is invalid");
        if (!c.typeforce.Number(M[M.length - 2]))
          throw new TypeError("Output is invalid");
        if (M[M.length - 1] !== t.OP_CHECKMULTISIG)
          throw new TypeError("Output is invalid");
        if (F.m <= 0 || F.n > 16 || F.m > F.n || F.n !== M.length - 3)
          throw new TypeError("Output is invalid");
        if (!F.pubkeys.every((H) => (0, c.isPoint)(H)))
          throw new TypeError("Output is invalid");
        if (B.m !== void 0 && B.m !== F.m) throw new TypeError("m mismatch");
        if (B.n !== void 0 && B.n !== F.n) throw new TypeError("n mismatch");
        if (B.pubkeys && !(0, c.stacksEqual)(B.pubkeys, F.pubkeys))
          throw new TypeError("Pubkeys mismatch");
      }
      if (B.pubkeys) {
        if (B.n !== void 0 && B.n !== B.pubkeys.length)
          throw new TypeError("Pubkey count mismatch");
        if (F.n = B.pubkeys.length, F.n < F.m) throw new TypeError("Pubkey count cannot be less than m");
      }
      if (B.signatures) {
        if (B.signatures.length < F.m)
          throw new TypeError("Not enough signatures provided");
        if (B.signatures.length > F.m)
          throw new TypeError("Too many signatures provided");
      }
      if (B.input) {
        if (B.input[0] !== t.OP_0) throw new TypeError("Input is invalid");
        if (F.signatures.length === 0 || !F.signatures.every(x))
          throw new TypeError("Input has invalid signature(s)");
        if (B.signatures && !(0, c.stacksEqual)(B.signatures, F.signatures))
          throw new TypeError("Signature mismatch");
        if (B.m !== void 0 && B.m !== B.signatures.length)
          throw new TypeError("Signature count mismatch");
      }
    }
    return Object.assign(F, B);
  }
  return p2ms.p2ms = E, p2ms;
}
var p2pk = {}, hasRequiredP2pk;
function requireP2pk() {
  if (hasRequiredP2pk) return p2pk;
  hasRequiredP2pk = 1, Object.defineProperty(p2pk, "__esModule", { value: !0 }), p2pk.p2pk = void 0;
  const o = requireNetworks$1(), g = requireScript$1(), c = requireTypes$3(), y = requireLazy(), t = g.OPS;
  function d(E, B) {
    if (!E.input && !E.output && !E.pubkey && !E.input && !E.signature)
      throw new TypeError("Not enough data");
    B = Object.assign({ validate: !0 }, B || {}), (0, c.typeforce)(
      {
        network: c.typeforce.maybe(c.typeforce.Object),
        output: c.typeforce.maybe(c.typeforce.Buffer),
        pubkey: c.typeforce.maybe(c.isPoint),
        signature: c.typeforce.maybe(g.isCanonicalScriptSignature),
        input: c.typeforce.maybe(c.typeforce.Buffer)
      },
      E
    );
    const D = y.value(() => g.decompile(E.input)), v = { name: "p2pk", network: E.network || o.bitcoin };
    if (y.prop(v, "output", () => {
      if (E.pubkey)
        return g.compile([E.pubkey, t.OP_CHECKSIG]);
    }), y.prop(v, "pubkey", () => {
      if (E.output)
        return E.output.slice(1, -1);
    }), y.prop(v, "signature", () => {
      if (E.input)
        return D()[0];
    }), y.prop(v, "input", () => {
      if (E.signature)
        return g.compile([E.signature]);
    }), y.prop(v, "witness", () => {
      if (v.input)
        return [];
    }), B.validate) {
      if (E.output) {
        if (E.output[E.output.length - 1] !== t.OP_CHECKSIG)
          throw new TypeError("Output is invalid");
        if (!(0, c.isPoint)(v.pubkey))
          throw new TypeError("Output pubkey is invalid");
        if (E.pubkey && !E.pubkey.equals(v.pubkey))
          throw new TypeError("Pubkey mismatch");
      }
      if (E.signature && E.input && !E.input.equals(v.input))
        throw new TypeError("Signature mismatch");
      if (E.input) {
        if (D().length !== 1) throw new TypeError("Input is invalid");
        if (!g.isCanonicalScriptSignature(v.signature))
          throw new TypeError("Input has invalid signature");
      }
    }
    return Object.assign(v, E);
  }
  return p2pk.p2pk = d, p2pk;
}
var p2pkh = {}, hasRequiredP2pkh;
function requireP2pkh() {
  if (hasRequiredP2pkh) return p2pkh;
  hasRequiredP2pkh = 1, Object.defineProperty(p2pkh, "__esModule", { value: !0 }), p2pkh.p2pkh = void 0;
  const o = requireCrypto$1(), g = requireNetworks$1(), c = requireScript$1(), y = requireTypes$3(), t = requireLazy(), d = requireBs58check(), E = c.OPS;
  function B(D, x) {
    if (!D.address && !D.hash && !D.output && !D.pubkey && !D.input)
      throw new TypeError("Not enough data");
    x = Object.assign({ validate: !0 }, x || {}), (0, y.typeforce)(
      {
        network: y.typeforce.maybe(y.typeforce.Object),
        address: y.typeforce.maybe(y.typeforce.String),
        hash: y.typeforce.maybe(y.typeforce.BufferN(20)),
        output: y.typeforce.maybe(y.typeforce.BufferN(25)),
        pubkey: y.typeforce.maybe(y.isPoint),
        signature: y.typeforce.maybe(c.isCanonicalScriptSignature),
        input: y.typeforce.maybe(y.typeforce.Buffer)
      },
      D
    );
    const v = t.value(() => {
      const L = Buffer.from(d.decode(D.address)), H = L.readUInt8(0), fe = L.slice(1);
      return { version: H, hash: fe };
    }), F = t.value(() => c.decompile(D.input)), M = D.network || g.bitcoin, U = { name: "p2pkh", network: M };
    if (t.prop(U, "address", () => {
      if (!U.hash) return;
      const L = Buffer.allocUnsafe(21);
      return L.writeUInt8(M.pubKeyHash, 0), U.hash.copy(L, 1), d.encode(L);
    }), t.prop(U, "hash", () => {
      if (D.output) return D.output.slice(3, 23);
      if (D.address) return v().hash;
      if (D.pubkey || U.pubkey) return o.hash160(D.pubkey || U.pubkey);
    }), t.prop(U, "output", () => {
      if (U.hash)
        return c.compile([
          E.OP_DUP,
          E.OP_HASH160,
          U.hash,
          E.OP_EQUALVERIFY,
          E.OP_CHECKSIG
        ]);
    }), t.prop(U, "pubkey", () => {
      if (D.input)
        return F()[1];
    }), t.prop(U, "signature", () => {
      if (D.input)
        return F()[0];
    }), t.prop(U, "input", () => {
      if (D.pubkey && D.signature)
        return c.compile([D.signature, D.pubkey]);
    }), t.prop(U, "witness", () => {
      if (U.input)
        return [];
    }), x.validate) {
      let L = Buffer.from([]);
      if (D.address) {
        if (v().version !== M.pubKeyHash)
          throw new TypeError("Invalid version or Network mismatch");
        if (v().hash.length !== 20) throw new TypeError("Invalid address");
        L = v().hash;
      }
      if (D.hash) {
        if (L.length > 0 && !L.equals(D.hash))
          throw new TypeError("Hash mismatch");
        L = D.hash;
      }
      if (D.output) {
        if (D.output.length !== 25 || D.output[0] !== E.OP_DUP || D.output[1] !== E.OP_HASH160 || D.output[2] !== 20 || D.output[23] !== E.OP_EQUALVERIFY || D.output[24] !== E.OP_CHECKSIG)
          throw new TypeError("Output is invalid");
        const H = D.output.slice(3, 23);
        if (L.length > 0 && !L.equals(H))
          throw new TypeError("Hash mismatch");
        L = H;
      }
      if (D.pubkey) {
        const H = o.hash160(D.pubkey);
        if (L.length > 0 && !L.equals(H))
          throw new TypeError("Hash mismatch");
        L = H;
      }
      if (D.input) {
        const H = F();
        if (H.length !== 2) throw new TypeError("Input is invalid");
        if (!c.isCanonicalScriptSignature(H[0]))
          throw new TypeError("Input has invalid signature");
        if (!(0, y.isPoint)(H[1]))
          throw new TypeError("Input has invalid pubkey");
        if (D.signature && !D.signature.equals(H[0]))
          throw new TypeError("Signature mismatch");
        if (D.pubkey && !D.pubkey.equals(H[1]))
          throw new TypeError("Pubkey mismatch");
        const fe = o.hash160(H[1]);
        if (L.length > 0 && !L.equals(fe))
          throw new TypeError("Hash mismatch");
      }
    }
    return Object.assign(U, D);
  }
  return p2pkh.p2pkh = B, p2pkh;
}
var p2sh = {}, hasRequiredP2sh;
function requireP2sh() {
  if (hasRequiredP2sh) return p2sh;
  hasRequiredP2sh = 1, Object.defineProperty(p2sh, "__esModule", { value: !0 }), p2sh.p2sh = void 0;
  const o = requireCrypto$1(), g = requireNetworks$1(), c = requireScript$1(), y = requireTypes$3(), t = requireLazy(), d = requireBs58check(), E = c.OPS;
  function B(D, x) {
    if (!D.address && !D.hash && !D.output && !D.redeem && !D.input)
      throw new TypeError("Not enough data");
    x = Object.assign({ validate: !0 }, x || {}), (0, y.typeforce)(
      {
        network: y.typeforce.maybe(y.typeforce.Object),
        address: y.typeforce.maybe(y.typeforce.String),
        hash: y.typeforce.maybe(y.typeforce.BufferN(20)),
        output: y.typeforce.maybe(y.typeforce.BufferN(23)),
        redeem: y.typeforce.maybe({
          network: y.typeforce.maybe(y.typeforce.Object),
          output: y.typeforce.maybe(y.typeforce.Buffer),
          input: y.typeforce.maybe(y.typeforce.Buffer),
          witness: y.typeforce.maybe(
            y.typeforce.arrayOf(y.typeforce.Buffer)
          )
        }),
        input: y.typeforce.maybe(y.typeforce.Buffer),
        witness: y.typeforce.maybe(
          y.typeforce.arrayOf(y.typeforce.Buffer)
        )
      },
      D
    );
    let v = D.network;
    v || (v = D.redeem && D.redeem.network || g.bitcoin);
    const F = { network: v }, M = t.value(() => {
      const H = Buffer.from(d.decode(D.address)), fe = H.readUInt8(0), ge = H.slice(1);
      return { version: fe, hash: ge };
    }), U = t.value(() => c.decompile(D.input)), L = t.value(() => {
      const H = U(), fe = H[H.length - 1];
      return {
        network: v,
        output: fe === E.OP_FALSE ? Buffer.from([]) : fe,
        input: c.compile(H.slice(0, -1)),
        witness: D.witness || []
      };
    });
    if (t.prop(F, "address", () => {
      if (!F.hash) return;
      const H = Buffer.allocUnsafe(21);
      return H.writeUInt8(F.network.scriptHash, 0), F.hash.copy(H, 1), d.encode(H);
    }), t.prop(F, "hash", () => {
      if (D.output) return D.output.slice(2, 22);
      if (D.address) return M().hash;
      if (F.redeem && F.redeem.output) return o.hash160(F.redeem.output);
    }), t.prop(F, "output", () => {
      if (F.hash)
        return c.compile([E.OP_HASH160, F.hash, E.OP_EQUAL]);
    }), t.prop(F, "redeem", () => {
      if (D.input)
        return L();
    }), t.prop(F, "input", () => {
      if (!(!D.redeem || !D.redeem.input || !D.redeem.output))
        return c.compile(
          [].concat(c.decompile(D.redeem.input), D.redeem.output)
        );
    }), t.prop(F, "witness", () => {
      if (F.redeem && F.redeem.witness) return F.redeem.witness;
      if (F.input) return [];
    }), t.prop(F, "name", () => {
      const H = ["p2sh"];
      return F.redeem !== void 0 && F.redeem.name !== void 0 && H.push(F.redeem.name), H.join("-");
    }), x.validate) {
      let H = Buffer.from([]);
      if (D.address) {
        if (M().version !== v.scriptHash)
          throw new TypeError("Invalid version or Network mismatch");
        if (M().hash.length !== 20) throw new TypeError("Invalid address");
        H = M().hash;
      }
      if (D.hash) {
        if (H.length > 0 && !H.equals(D.hash))
          throw new TypeError("Hash mismatch");
        H = D.hash;
      }
      if (D.output) {
        if (D.output.length !== 23 || D.output[0] !== E.OP_HASH160 || D.output[1] !== 20 || D.output[22] !== E.OP_EQUAL)
          throw new TypeError("Output is invalid");
        const ge = D.output.slice(2, 22);
        if (H.length > 0 && !H.equals(ge))
          throw new TypeError("Hash mismatch");
        H = ge;
      }
      const fe = (ge) => {
        if (ge.output) {
          const Ie = c.decompile(ge.output);
          if (!Ie || Ie.length < 1)
            throw new TypeError("Redeem.output too short");
          if (ge.output.byteLength > 520)
            throw new TypeError(
              "Redeem.output unspendable if larger than 520 bytes"
            );
          if (c.countNonPushOnlyOPs(Ie) > 201)
            throw new TypeError(
              "Redeem.output unspendable with more than 201 non-push ops"
            );
          const Ee = o.hash160(ge.output);
          if (H.length > 0 && !H.equals(Ee))
            throw new TypeError("Hash mismatch");
          H = Ee;
        }
        if (ge.input) {
          const Ie = ge.input.length > 0, Ee = ge.witness && ge.witness.length > 0;
          if (!Ie && !Ee) throw new TypeError("Empty input");
          if (Ie && Ee)
            throw new TypeError("Input and witness provided");
          if (Ie) {
            const Se = c.decompile(ge.input);
            if (!c.isPushOnly(Se))
              throw new TypeError("Non push-only scriptSig");
          }
        }
      };
      if (D.input) {
        const ge = U();
        if (!ge || ge.length < 1) throw new TypeError("Input too short");
        if (!Buffer.isBuffer(L().output))
          throw new TypeError("Input is invalid");
        fe(L());
      }
      if (D.redeem) {
        if (D.redeem.network && D.redeem.network !== v)
          throw new TypeError("Network mismatch");
        if (D.input) {
          const ge = L();
          if (D.redeem.output && !D.redeem.output.equals(ge.output))
            throw new TypeError("Redeem.output mismatch");
          if (D.redeem.input && !D.redeem.input.equals(ge.input))
            throw new TypeError("Redeem.input mismatch");
        }
        fe(D.redeem);
      }
      if (D.witness && D.redeem && D.redeem.witness && !(0, y.stacksEqual)(D.redeem.witness, D.witness))
        throw new TypeError("Witness and redeem.witness mismatch");
    }
    return Object.assign(F, D);
  }
  return p2sh.p2sh = B, p2sh;
}
var p2wpkh = {}, dist$2 = {}, hasRequiredDist$2;
function requireDist$2() {
  if (hasRequiredDist$2) return dist$2;
  hasRequiredDist$2 = 1, Object.defineProperty(dist$2, "__esModule", { value: !0 }), dist$2.bech32m = dist$2.bech32 = void 0;
  const o = "qpzry9x8gf2tvdw0s3jn54khce6mua7l", g = {};
  for (let x = 0; x < o.length; x++) {
    const v = o.charAt(x);
    g[v] = x;
  }
  function c(x) {
    const v = x >> 25;
    return (x & 33554431) << 5 ^ -(v >> 0 & 1) & 996825010 ^ -(v >> 1 & 1) & 642813549 ^ -(v >> 2 & 1) & 513874426 ^ -(v >> 3 & 1) & 1027748829 ^ -(v >> 4 & 1) & 705979059;
  }
  function y(x) {
    let v = 1;
    for (let F = 0; F < x.length; ++F) {
      const M = x.charCodeAt(F);
      if (M < 33 || M > 126)
        return "Invalid prefix (" + x + ")";
      v = c(v) ^ M >> 5;
    }
    v = c(v);
    for (let F = 0; F < x.length; ++F) {
      const M = x.charCodeAt(F);
      v = c(v) ^ M & 31;
    }
    return v;
  }
  function t(x, v, F, M) {
    let U = 0, L = 0;
    const H = (1 << F) - 1, fe = [];
    for (let ge = 0; ge < x.length; ++ge)
      for (U = U << v | x[ge], L += v; L >= F; )
        L -= F, fe.push(U >> L & H);
    if (M)
      L > 0 && fe.push(U << F - L & H);
    else {
      if (L >= v)
        return "Excess padding";
      if (U << F - L & H)
        return "Non-zero padding";
    }
    return fe;
  }
  function d(x) {
    return t(x, 8, 5, !0);
  }
  function E(x) {
    const v = t(x, 5, 8, !1);
    if (Array.isArray(v))
      return v;
  }
  function B(x) {
    const v = t(x, 5, 8, !1);
    if (Array.isArray(v))
      return v;
    throw new Error(v);
  }
  function D(x) {
    let v;
    x === "bech32" ? v = 1 : v = 734539939;
    function F(H, fe, ge) {
      if (ge = ge || 90, H.length + 7 + fe.length > ge)
        throw new TypeError("Exceeds length limit");
      H = H.toLowerCase();
      let Ie = y(H);
      if (typeof Ie == "string")
        throw new Error(Ie);
      let Ee = H + "1";
      for (let Se = 0; Se < fe.length; ++Se) {
        const ze = fe[Se];
        if (ze >> 5 !== 0)
          throw new Error("Non 5-bit word");
        Ie = c(Ie) ^ ze, Ee += o.charAt(ze);
      }
      for (let Se = 0; Se < 6; ++Se)
        Ie = c(Ie);
      Ie ^= v;
      for (let Se = 0; Se < 6; ++Se) {
        const ze = Ie >> (5 - Se) * 5 & 31;
        Ee += o.charAt(ze);
      }
      return Ee;
    }
    function M(H, fe) {
      if (fe = fe || 90, H.length < 8)
        return H + " too short";
      if (H.length > fe)
        return "Exceeds length limit";
      const ge = H.toLowerCase(), Ie = H.toUpperCase();
      if (H !== ge && H !== Ie)
        return "Mixed-case string " + H;
      H = ge;
      const Ee = H.lastIndexOf("1");
      if (Ee === -1)
        return "No separator character for " + H;
      if (Ee === 0)
        return "Missing prefix for " + H;
      const Se = H.slice(0, Ee), ze = H.slice(Ee + 1);
      if (ze.length < 6)
        return "Data too short";
      let He = y(Se);
      if (typeof He == "string")
        return He;
      const Pe = [];
      for (let De = 0; De < ze.length; ++De) {
        const ve = ze.charAt(De), Fe = g[ve];
        if (Fe === void 0)
          return "Unknown character " + ve;
        He = c(He) ^ Fe, !(De + 6 >= ze.length) && Pe.push(Fe);
      }
      return He !== v ? "Invalid checksum for " + H : { prefix: Se, words: Pe };
    }
    function U(H, fe) {
      const ge = M(H, fe);
      if (typeof ge == "object")
        return ge;
    }
    function L(H, fe) {
      const ge = M(H, fe);
      if (typeof ge == "object")
        return ge;
      throw new Error(ge);
    }
    return {
      decodeUnsafe: U,
      decode: L,
      encode: F,
      toWords: d,
      fromWordsUnsafe: E,
      fromWords: B
    };
  }
  return dist$2.bech32 = D("bech32"), dist$2.bech32m = D("bech32m"), dist$2;
}
var hasRequiredP2wpkh;
function requireP2wpkh() {
  if (hasRequiredP2wpkh) return p2wpkh;
  hasRequiredP2wpkh = 1, Object.defineProperty(p2wpkh, "__esModule", { value: !0 }), p2wpkh.p2wpkh = void 0;
  const o = requireCrypto$1(), g = requireNetworks$1(), c = requireScript$1(), y = requireTypes$3(), t = requireLazy(), d = requireDist$2(), E = c.OPS, B = Buffer.alloc(0);
  function D(x, v) {
    if (!x.address && !x.hash && !x.output && !x.pubkey && !x.witness)
      throw new TypeError("Not enough data");
    v = Object.assign({ validate: !0 }, v || {}), (0, y.typeforce)(
      {
        address: y.typeforce.maybe(y.typeforce.String),
        hash: y.typeforce.maybe(y.typeforce.BufferN(20)),
        input: y.typeforce.maybe(y.typeforce.BufferN(0)),
        network: y.typeforce.maybe(y.typeforce.Object),
        output: y.typeforce.maybe(y.typeforce.BufferN(22)),
        pubkey: y.typeforce.maybe(y.isPoint),
        signature: y.typeforce.maybe(c.isCanonicalScriptSignature),
        witness: y.typeforce.maybe(
          y.typeforce.arrayOf(y.typeforce.Buffer)
        )
      },
      x
    );
    const F = t.value(() => {
      const L = d.bech32.decode(x.address), H = L.words.shift(), fe = d.bech32.fromWords(L.words);
      return {
        version: H,
        prefix: L.prefix,
        data: Buffer.from(fe)
      };
    }), M = x.network || g.bitcoin, U = { name: "p2wpkh", network: M };
    if (t.prop(U, "address", () => {
      if (!U.hash) return;
      const L = d.bech32.toWords(U.hash);
      return L.unshift(0), d.bech32.encode(M.bech32, L);
    }), t.prop(U, "hash", () => {
      if (x.output) return x.output.slice(2, 22);
      if (x.address) return F().data;
      if (x.pubkey || U.pubkey) return o.hash160(x.pubkey || U.pubkey);
    }), t.prop(U, "output", () => {
      if (U.hash)
        return c.compile([E.OP_0, U.hash]);
    }), t.prop(U, "pubkey", () => {
      if (x.pubkey) return x.pubkey;
      if (x.witness)
        return x.witness[1];
    }), t.prop(U, "signature", () => {
      if (x.witness)
        return x.witness[0];
    }), t.prop(U, "input", () => {
      if (U.witness)
        return B;
    }), t.prop(U, "witness", () => {
      if (x.pubkey && x.signature)
        return [x.signature, x.pubkey];
    }), v.validate) {
      let L = Buffer.from([]);
      if (x.address) {
        if (M && M.bech32 !== F().prefix)
          throw new TypeError("Invalid prefix or Network mismatch");
        if (F().version !== 0)
          throw new TypeError("Invalid address version");
        if (F().data.length !== 20)
          throw new TypeError("Invalid address data");
        L = F().data;
      }
      if (x.hash) {
        if (L.length > 0 && !L.equals(x.hash))
          throw new TypeError("Hash mismatch");
        L = x.hash;
      }
      if (x.output) {
        if (x.output.length !== 22 || x.output[0] !== E.OP_0 || x.output[1] !== 20)
          throw new TypeError("Output is invalid");
        if (L.length > 0 && !L.equals(x.output.slice(2)))
          throw new TypeError("Hash mismatch");
        L = x.output.slice(2);
      }
      if (x.pubkey) {
        const H = o.hash160(x.pubkey);
        if (L.length > 0 && !L.equals(H))
          throw new TypeError("Hash mismatch");
        if (L = H, !(0, y.isPoint)(x.pubkey) || x.pubkey.length !== 33)
          throw new TypeError("Invalid pubkey for p2wpkh");
      }
      if (x.witness) {
        if (x.witness.length !== 2) throw new TypeError("Witness is invalid");
        if (!c.isCanonicalScriptSignature(x.witness[0]))
          throw new TypeError("Witness has invalid signature");
        if (!(0, y.isPoint)(x.witness[1]) || x.witness[1].length !== 33)
          throw new TypeError("Witness has invalid pubkey");
        if (x.signature && !x.signature.equals(x.witness[0]))
          throw new TypeError("Signature mismatch");
        if (x.pubkey && !x.pubkey.equals(x.witness[1]))
          throw new TypeError("Pubkey mismatch");
        const H = o.hash160(x.witness[1]);
        if (L.length > 0 && !L.equals(H))
          throw new TypeError("Hash mismatch");
      }
    }
    return Object.assign(U, x);
  }
  return p2wpkh.p2wpkh = D, p2wpkh;
}
var p2wsh = {}, hasRequiredP2wsh;
function requireP2wsh() {
  if (hasRequiredP2wsh) return p2wsh;
  hasRequiredP2wsh = 1, Object.defineProperty(p2wsh, "__esModule", { value: !0 }), p2wsh.p2wsh = void 0;
  const o = requireCrypto$1(), g = requireNetworks$1(), c = requireScript$1(), y = requireTypes$3(), t = requireLazy(), d = requireDist$2(), E = c.OPS, B = Buffer.alloc(0);
  function D(v) {
    return !!(Buffer.isBuffer(v) && v.length === 65 && v[0] === 4 && (0, y.isPoint)(v));
  }
  function x(v, F) {
    if (!v.address && !v.hash && !v.output && !v.redeem && !v.witness)
      throw new TypeError("Not enough data");
    F = Object.assign({ validate: !0 }, F || {}), (0, y.typeforce)(
      {
        network: y.typeforce.maybe(y.typeforce.Object),
        address: y.typeforce.maybe(y.typeforce.String),
        hash: y.typeforce.maybe(y.typeforce.BufferN(32)),
        output: y.typeforce.maybe(y.typeforce.BufferN(34)),
        redeem: y.typeforce.maybe({
          input: y.typeforce.maybe(y.typeforce.Buffer),
          network: y.typeforce.maybe(y.typeforce.Object),
          output: y.typeforce.maybe(y.typeforce.Buffer),
          witness: y.typeforce.maybe(
            y.typeforce.arrayOf(y.typeforce.Buffer)
          )
        }),
        input: y.typeforce.maybe(y.typeforce.BufferN(0)),
        witness: y.typeforce.maybe(
          y.typeforce.arrayOf(y.typeforce.Buffer)
        )
      },
      v
    );
    const M = t.value(() => {
      const fe = d.bech32.decode(v.address), ge = fe.words.shift(), Ie = d.bech32.fromWords(fe.words);
      return {
        version: ge,
        prefix: fe.prefix,
        data: Buffer.from(Ie)
      };
    }), U = t.value(() => c.decompile(v.redeem.input));
    let L = v.network;
    L || (L = v.redeem && v.redeem.network || g.bitcoin);
    const H = { network: L };
    if (t.prop(H, "address", () => {
      if (!H.hash) return;
      const fe = d.bech32.toWords(H.hash);
      return fe.unshift(0), d.bech32.encode(L.bech32, fe);
    }), t.prop(H, "hash", () => {
      if (v.output) return v.output.slice(2);
      if (v.address) return M().data;
      if (H.redeem && H.redeem.output) return o.sha256(H.redeem.output);
    }), t.prop(H, "output", () => {
      if (H.hash)
        return c.compile([E.OP_0, H.hash]);
    }), t.prop(H, "redeem", () => {
      if (v.witness)
        return {
          output: v.witness[v.witness.length - 1],
          input: B,
          witness: v.witness.slice(0, -1)
        };
    }), t.prop(H, "input", () => {
      if (H.witness)
        return B;
    }), t.prop(H, "witness", () => {
      if (v.redeem && v.redeem.input && v.redeem.input.length > 0 && v.redeem.output && v.redeem.output.length > 0) {
        const fe = c.toStack(U());
        return H.redeem = Object.assign({ witness: fe }, v.redeem), H.redeem.input = B, [].concat(fe, v.redeem.output);
      }
      if (v.redeem && v.redeem.output && v.redeem.witness)
        return [].concat(v.redeem.witness, v.redeem.output);
    }), t.prop(H, "name", () => {
      const fe = ["p2wsh"];
      return H.redeem !== void 0 && H.redeem.name !== void 0 && fe.push(H.redeem.name), fe.join("-");
    }), F.validate) {
      let fe = Buffer.from([]);
      if (v.address) {
        if (M().prefix !== L.bech32)
          throw new TypeError("Invalid prefix or Network mismatch");
        if (M().version !== 0)
          throw new TypeError("Invalid address version");
        if (M().data.length !== 32)
          throw new TypeError("Invalid address data");
        fe = M().data;
      }
      if (v.hash) {
        if (fe.length > 0 && !fe.equals(v.hash))
          throw new TypeError("Hash mismatch");
        fe = v.hash;
      }
      if (v.output) {
        if (v.output.length !== 34 || v.output[0] !== E.OP_0 || v.output[1] !== 32)
          throw new TypeError("Output is invalid");
        const ge = v.output.slice(2);
        if (fe.length > 0 && !fe.equals(ge))
          throw new TypeError("Hash mismatch");
        fe = ge;
      }
      if (v.redeem) {
        if (v.redeem.network && v.redeem.network !== L)
          throw new TypeError("Network mismatch");
        if (v.redeem.input && v.redeem.input.length > 0 && v.redeem.witness && v.redeem.witness.length > 0)
          throw new TypeError("Ambiguous witness source");
        if (v.redeem.output) {
          const ge = c.decompile(v.redeem.output);
          if (!ge || ge.length < 1)
            throw new TypeError("Redeem.output is invalid");
          if (v.redeem.output.byteLength > 3600)
            throw new TypeError(
              "Redeem.output unspendable if larger than 3600 bytes"
            );
          if (c.countNonPushOnlyOPs(ge) > 201)
            throw new TypeError(
              "Redeem.output unspendable with more than 201 non-push ops"
            );
          const Ie = o.sha256(v.redeem.output);
          if (fe.length > 0 && !fe.equals(Ie))
            throw new TypeError("Hash mismatch");
          fe = Ie;
        }
        if (v.redeem.input && !c.isPushOnly(U()))
          throw new TypeError("Non push-only scriptSig");
        if (v.witness && v.redeem.witness && !(0, y.stacksEqual)(v.witness, v.redeem.witness))
          throw new TypeError("Witness and redeem.witness mismatch");
        if (v.redeem.input && U().some(D) || v.redeem.output && (c.decompile(v.redeem.output) || []).some(
          D
        ))
          throw new TypeError(
            "redeem.input or redeem.output contains uncompressed pubkey"
          );
      }
      if (v.witness && v.witness.length > 0) {
        const ge = v.witness[v.witness.length - 1];
        if (v.redeem && v.redeem.output && !v.redeem.output.equals(ge))
          throw new TypeError("Witness and redeem.output mismatch");
        if (v.witness.some(D) || (c.decompile(ge) || []).some(D))
          throw new TypeError("Witness contains uncompressed pubkey");
      }
    }
    return Object.assign(H, v);
  }
  return p2wsh.p2wsh = x, p2wsh;
}
var p2tr = {}, address = {}, hasRequiredAddress;
function requireAddress() {
  if (hasRequiredAddress) return address;
  hasRequiredAddress = 1, Object.defineProperty(address, "__esModule", { value: !0 }), address.toOutputScript = address.fromOutputScript = address.toBech32 = address.toBase58Check = address.fromBech32 = address.fromBase58Check = void 0;
  const o = requireNetworks$1(), g = requirePayments(), c = requireScript$1(), y = requireTypes$3(), t = requireDist$2(), d = requireBs58check(), E = 40, B = 2, D = 16, x = 2, v = 80, F = "WARNING: Sending to a future segwit version address can lead to loss of funds. End users MUST be warned carefully in the GUI and asked if they wish to proceed with caution. Wallets should verify the segwit version from the output of fromBech32, then decide when it is safe to use which version of segwit.";
  function M(Ee, Se) {
    const ze = Ee.slice(2);
    if (ze.length < B || ze.length > E)
      throw new TypeError("Invalid program length for segwit address");
    const He = Ee[0] - v;
    if (He < x || He > D)
      throw new TypeError("Invalid version for segwit address");
    if (Ee[1] !== ze.length)
      throw new TypeError("Invalid script for segwit address");
    return console.warn(F), fe(ze, He, Se.bech32);
  }
  function U(Ee) {
    const Se = Buffer.from(d.decode(Ee));
    if (Se.length < 21) throw new TypeError(Ee + " is too short");
    if (Se.length > 21) throw new TypeError(Ee + " is too long");
    const ze = Se.readUInt8(0), He = Se.slice(1);
    return { version: ze, hash: He };
  }
  address.fromBase58Check = U;
  function L(Ee) {
    let Se, ze;
    try {
      Se = t.bech32.decode(Ee);
    } catch {
    }
    if (Se) {
      if (ze = Se.words[0], ze !== 0) throw new TypeError(Ee + " uses wrong encoding");
    } else if (Se = t.bech32m.decode(Ee), ze = Se.words[0], ze === 0) throw new TypeError(Ee + " uses wrong encoding");
    const He = t.bech32.fromWords(Se.words.slice(1));
    return {
      version: ze,
      prefix: Se.prefix,
      data: Buffer.from(He)
    };
  }
  address.fromBech32 = L;
  function H(Ee, Se) {
    (0, y.typeforce)(
      (0, y.tuple)(y.Hash160bit, y.UInt8),
      arguments
    );
    const ze = Buffer.allocUnsafe(21);
    return ze.writeUInt8(Se, 0), Ee.copy(ze, 1), d.encode(ze);
  }
  address.toBase58Check = H;
  function fe(Ee, Se, ze) {
    const He = t.bech32.toWords(Ee);
    return He.unshift(Se), Se === 0 ? t.bech32.encode(ze, He) : t.bech32m.encode(ze, He);
  }
  address.toBech32 = fe;
  function ge(Ee, Se) {
    Se = Se || o.bitcoin;
    try {
      return g.p2pkh({ output: Ee, network: Se }).address;
    } catch {
    }
    try {
      return g.p2sh({ output: Ee, network: Se }).address;
    } catch {
    }
    try {
      return g.p2wpkh({ output: Ee, network: Se }).address;
    } catch {
    }
    try {
      return g.p2wsh({ output: Ee, network: Se }).address;
    } catch {
    }
    try {
      return g.p2tr({ output: Ee, network: Se }).address;
    } catch {
    }
    try {
      return M(Ee, Se);
    } catch {
    }
    throw new Error(c.toASM(Ee) + " has no matching Address");
  }
  address.fromOutputScript = ge;
  function Ie(Ee, Se) {
    Se = Se || o.bitcoin;
    let ze, He;
    try {
      ze = U(Ee);
    } catch {
    }
    if (ze) {
      if (ze.version === Se.pubKeyHash)
        return g.p2pkh({ hash: ze.hash }).output;
      if (ze.version === Se.scriptHash)
        return g.p2sh({ hash: ze.hash }).output;
    } else {
      try {
        He = L(Ee);
      } catch {
      }
      if (He) {
        if (He.prefix !== Se.bech32)
          throw new Error(Ee + " has an invalid prefix");
        if (He.version === 0) {
          if (He.data.length === 20)
            return g.p2wpkh({ hash: He.data }).output;
          if (He.data.length === 32)
            return g.p2wsh({ hash: He.data }).output;
        } else if (He.version === 1) {
          if (He.data.length === 32)
            return g.p2tr({ pubkey: He.data }).output;
        } else if (He.version >= x && He.version <= D && He.data.length >= B && He.data.length <= E)
          return console.warn(F), c.compile([
            He.version + v,
            He.data
          ]);
      }
    }
    throw new Error(Ee + " has no matching Script");
  }
  return address.toOutputScript = Ie, address;
}
var hasRequiredP2tr;
function requireP2tr() {
  if (hasRequiredP2tr) return p2tr;
  hasRequiredP2tr = 1, Object.defineProperty(p2tr, "__esModule", { value: !0 }), p2tr.p2tr = void 0;
  const o = requireBuffer$2(), g = requireNetworks$1(), c = requireScript$1(), y = requireTypes$3(), t = requireEcc_lib(), d = requireBip341(), E = requireLazy(), B = requireDist$2(), D = requireAddress(), x = c.OPS, v = 1, F = 80;
  function M(U, L) {
    if (!U.address && !U.output && !U.pubkey && !U.internalPubkey && !(U.witness && U.witness.length > 1))
      throw new TypeError("Not enough data");
    L = Object.assign({ validate: !0 }, L || {}), (0, y.typeforce)(
      {
        address: y.typeforce.maybe(y.typeforce.String),
        input: y.typeforce.maybe(y.typeforce.BufferN(0)),
        network: y.typeforce.maybe(y.typeforce.Object),
        output: y.typeforce.maybe(y.typeforce.BufferN(34)),
        internalPubkey: y.typeforce.maybe(y.typeforce.BufferN(32)),
        hash: y.typeforce.maybe(y.typeforce.BufferN(32)),
        pubkey: y.typeforce.maybe(y.typeforce.BufferN(32)),
        signature: y.typeforce.maybe(
          y.typeforce.anyOf(
            y.typeforce.BufferN(64),
            y.typeforce.BufferN(65)
          )
        ),
        witness: y.typeforce.maybe(
          y.typeforce.arrayOf(y.typeforce.Buffer)
        ),
        scriptTree: y.typeforce.maybe(y.isTaptree),
        redeem: y.typeforce.maybe({
          output: y.typeforce.maybe(y.typeforce.Buffer),
          redeemVersion: y.typeforce.maybe(y.typeforce.Number),
          witness: y.typeforce.maybe(
            y.typeforce.arrayOf(y.typeforce.Buffer)
          )
        }),
        redeemVersion: y.typeforce.maybe(y.typeforce.Number)
      },
      U
    );
    const H = E.value(() => (0, D.fromBech32)(U.address)), fe = E.value(() => {
      if (!(!U.witness || !U.witness.length))
        return U.witness.length >= 2 && U.witness[U.witness.length - 1][0] === F ? U.witness.slice(0, -1) : U.witness.slice();
    }), ge = E.value(() => {
      if (U.scriptTree) return (0, d.toHashTree)(U.scriptTree);
      if (U.hash) return { hash: U.hash };
    }), Ie = U.network || g.bitcoin, Ee = { name: "p2tr", network: Ie };
    if (E.prop(Ee, "address", () => {
      if (!Ee.pubkey) return;
      const Se = B.bech32m.toWords(Ee.pubkey);
      return Se.unshift(v), B.bech32m.encode(Ie.bech32, Se);
    }), E.prop(Ee, "hash", () => {
      const Se = ge();
      if (Se) return Se.hash;
      const ze = fe();
      if (ze && ze.length > 1) {
        const He = ze[ze.length - 1], Pe = He[0] & y.TAPLEAF_VERSION_MASK, De = ze[ze.length - 2], ve = (0, d.tapleafHash)({
          output: De,
          version: Pe
        });
        return (0, d.rootHashFromPath)(He, ve);
      }
      return null;
    }), E.prop(Ee, "output", () => {
      if (Ee.pubkey)
        return c.compile([x.OP_1, Ee.pubkey]);
    }), E.prop(Ee, "redeemVersion", () => U.redeemVersion ? U.redeemVersion : U.redeem && U.redeem.redeemVersion !== void 0 && U.redeem.redeemVersion !== null ? U.redeem.redeemVersion : d.LEAF_VERSION_TAPSCRIPT), E.prop(Ee, "redeem", () => {
      const Se = fe();
      if (!(!Se || Se.length < 2))
        return {
          output: Se[Se.length - 2],
          witness: Se.slice(0, -2),
          redeemVersion: Se[Se.length - 1][0] & y.TAPLEAF_VERSION_MASK
        };
    }), E.prop(Ee, "pubkey", () => {
      if (U.pubkey) return U.pubkey;
      if (U.output) return U.output.slice(2);
      if (U.address) return H().data;
      if (Ee.internalPubkey) {
        const Se = (0, d.tweakKey)(Ee.internalPubkey, Ee.hash);
        if (Se) return Se.x;
      }
    }), E.prop(Ee, "internalPubkey", () => {
      if (U.internalPubkey) return U.internalPubkey;
      const Se = fe();
      if (Se && Se.length > 1)
        return Se[Se.length - 1].slice(1, 33);
    }), E.prop(Ee, "signature", () => {
      if (U.signature) return U.signature;
      const Se = fe();
      if (!(!Se || Se.length !== 1))
        return Se[0];
    }), E.prop(Ee, "witness", () => {
      if (U.witness) return U.witness;
      const Se = ge();
      if (Se && U.redeem && U.redeem.output && U.internalPubkey) {
        const ze = (0, d.tapleafHash)({
          output: U.redeem.output,
          version: Ee.redeemVersion
        }), He = (0, d.findScriptPath)(Se, ze);
        if (!He) return;
        const Pe = (0, d.tweakKey)(U.internalPubkey, Se.hash);
        if (!Pe) return;
        const De = o.Buffer.concat(
          [
            o.Buffer.from([Ee.redeemVersion | Pe.parity]),
            U.internalPubkey
          ].concat(He)
        );
        return [U.redeem.output, De];
      }
      if (U.signature) return [U.signature];
    }), L.validate) {
      let Se = o.Buffer.from([]);
      if (U.address) {
        if (Ie && Ie.bech32 !== H().prefix)
          throw new TypeError("Invalid prefix or Network mismatch");
        if (H().version !== v)
          throw new TypeError("Invalid address version");
        if (H().data.length !== 32)
          throw new TypeError("Invalid address data");
        Se = H().data;
      }
      if (U.pubkey) {
        if (Se.length > 0 && !Se.equals(U.pubkey))
          throw new TypeError("Pubkey mismatch");
        Se = U.pubkey;
      }
      if (U.output) {
        if (U.output.length !== 34 || U.output[0] !== x.OP_1 || U.output[1] !== 32)
          throw new TypeError("Output is invalid");
        if (Se.length > 0 && !Se.equals(U.output.slice(2)))
          throw new TypeError("Pubkey mismatch");
        Se = U.output.slice(2);
      }
      if (U.internalPubkey) {
        const Pe = (0, d.tweakKey)(U.internalPubkey, Ee.hash);
        if (Se.length > 0 && !Se.equals(Pe.x))
          throw new TypeError("Pubkey mismatch");
        Se = Pe.x;
      }
      if (Se && Se.length && !(0, t.getEccLib)().isXOnlyPoint(Se))
        throw new TypeError("Invalid pubkey for p2tr");
      const ze = ge();
      if (U.hash && ze && !U.hash.equals(ze.hash))
        throw new TypeError("Hash mismatch");
      if (U.redeem && U.redeem.output && ze) {
        const Pe = (0, d.tapleafHash)({
          output: U.redeem.output,
          version: Ee.redeemVersion
        });
        if (!(0, d.findScriptPath)(ze, Pe))
          throw new TypeError("Redeem script not in tree");
      }
      const He = fe();
      if (U.redeem && Ee.redeem) {
        if (U.redeem.redeemVersion && U.redeem.redeemVersion !== Ee.redeem.redeemVersion)
          throw new TypeError("Redeem.redeemVersion and witness mismatch");
        if (U.redeem.output) {
          if (c.decompile(U.redeem.output).length === 0)
            throw new TypeError("Redeem.output is invalid");
          if (Ee.redeem.output && !U.redeem.output.equals(Ee.redeem.output))
            throw new TypeError("Redeem.output and witness mismatch");
        }
        if (U.redeem.witness && Ee.redeem.witness && !(0, y.stacksEqual)(U.redeem.witness, Ee.redeem.witness))
          throw new TypeError("Redeem.witness and witness mismatch");
      }
      if (He && He.length)
        if (He.length === 1) {
          if (U.signature && !U.signature.equals(He[0]))
            throw new TypeError("Signature mismatch");
        } else {
          const Pe = He[He.length - 1];
          if (Pe.length < 33)
            throw new TypeError(
              `The control-block length is too small. Got ${Pe.length}, expected min 33.`
            );
          if ((Pe.length - 33) % 32 !== 0)
            throw new TypeError(
              `The control-block length of ${Pe.length} is incorrect!`
            );
          const De = (Pe.length - 33) / 32;
          if (De > 128)
            throw new TypeError(
              `The script path is too long. Got ${De}, expected max 128.`
            );
          const ve = Pe.slice(1, 33);
          if (U.internalPubkey && !U.internalPubkey.equals(ve))
            throw new TypeError("Internal pubkey mismatch");
          if (!(0, t.getEccLib)().isXOnlyPoint(ve))
            throw new TypeError("Invalid internalPubkey for p2tr witness");
          const Fe = Pe[0] & y.TAPLEAF_VERSION_MASK, be = He[He.length - 2], Be = (0, d.tapleafHash)({
            output: be,
            version: Fe
          }), ke = (0, d.rootHashFromPath)(Pe, Be), xe = (0, d.tweakKey)(ve, ke);
          if (!xe)
            throw new TypeError("Invalid outputKey for p2tr witness");
          if (Se.length && !Se.equals(xe.x))
            throw new TypeError("Pubkey mismatch for p2tr witness");
          if (xe.parity !== (Pe[0] & 1))
            throw new Error("Incorrect parity");
        }
    }
    return Object.assign(Ee, U);
  }
  return p2tr.p2tr = M, p2tr;
}
var hasRequiredPayments;
function requirePayments() {
  return hasRequiredPayments || (hasRequiredPayments = 1, function(o) {
    Object.defineProperty(o, "__esModule", { value: !0 }), o.p2tr = o.p2wsh = o.p2wpkh = o.p2sh = o.p2pkh = o.p2pk = o.p2ms = o.embed = void 0;
    const g = requireEmbed();
    Object.defineProperty(o, "embed", {
      enumerable: !0,
      get: function() {
        return g.p2data;
      }
    });
    const c = requireP2ms();
    Object.defineProperty(o, "p2ms", {
      enumerable: !0,
      get: function() {
        return c.p2ms;
      }
    });
    const y = requireP2pk();
    Object.defineProperty(o, "p2pk", {
      enumerable: !0,
      get: function() {
        return y.p2pk;
      }
    });
    const t = requireP2pkh();
    Object.defineProperty(o, "p2pkh", {
      enumerable: !0,
      get: function() {
        return t.p2pkh;
      }
    });
    const d = requireP2sh();
    Object.defineProperty(o, "p2sh", {
      enumerable: !0,
      get: function() {
        return d.p2sh;
      }
    });
    const E = requireP2wpkh();
    Object.defineProperty(o, "p2wpkh", {
      enumerable: !0,
      get: function() {
        return E.p2wpkh;
      }
    });
    const B = requireP2wsh();
    Object.defineProperty(o, "p2wsh", {
      enumerable: !0,
      get: function() {
        return B.p2wsh;
      }
    });
    const D = requireP2tr();
    Object.defineProperty(o, "p2tr", {
      enumerable: !0,
      get: function() {
        return D.p2tr;
      }
    });
  }(payments)), payments;
}
var hasRequiredPsbtutils;
function requirePsbtutils() {
  if (hasRequiredPsbtutils) return psbtutils;
  hasRequiredPsbtutils = 1, Object.defineProperty(psbtutils, "__esModule", { value: !0 }), psbtutils.signatureBlocksAction = psbtutils.checkInputForSig = psbtutils.pubkeyInScript = psbtutils.pubkeyPositionInScript = psbtutils.witnessStackToScriptWitness = psbtutils.isP2TR = psbtutils.isP2SHScript = psbtutils.isP2WSHScript = psbtutils.isP2WPKH = psbtutils.isP2PKH = psbtutils.isP2PK = psbtutils.isP2MS = void 0;
  const o = requireVarint$3(), g = requireScript$1(), c = requireTransaction$1(), y = requireCrypto$1(), t = requirePayments();
  function d(U) {
    return (L) => {
      try {
        return U({ output: L }), !0;
      } catch {
        return !1;
      }
    };
  }
  psbtutils.isP2MS = d(t.p2ms), psbtutils.isP2PK = d(t.p2pk), psbtutils.isP2PKH = d(t.p2pkh), psbtutils.isP2WPKH = d(t.p2wpkh), psbtutils.isP2WSHScript = d(t.p2wsh), psbtutils.isP2SHScript = d(t.p2sh), psbtutils.isP2TR = d(t.p2tr);
  function E(U) {
    let L = Buffer.allocUnsafe(0);
    function H(Ee) {
      L = Buffer.concat([L, Buffer.from(Ee)]);
    }
    function fe(Ee) {
      const Se = L.length, ze = o.encodingLength(Ee);
      L = Buffer.concat([L, Buffer.allocUnsafe(ze)]), o.encode(Ee, L, Se);
    }
    function ge(Ee) {
      fe(Ee.length), H(Ee);
    }
    function Ie(Ee) {
      fe(Ee.length), Ee.forEach(ge);
    }
    return Ie(U), L;
  }
  psbtutils.witnessStackToScriptWitness = E;
  function B(U, L) {
    const H = (0, y.hash160)(U), fe = U.slice(1, 33), ge = g.decompile(L);
    if (ge === null) throw new Error("Unknown script error");
    return ge.findIndex((Ie) => typeof Ie == "number" ? !1 : Ie.equals(U) || Ie.equals(H) || Ie.equals(fe));
  }
  psbtutils.pubkeyPositionInScript = B;
  function D(U, L) {
    return B(U, L) !== -1;
  }
  psbtutils.pubkeyInScript = D;
  function x(U, L) {
    return F(U).some(
      (fe) => v(fe, g.signature.decode, L)
    );
  }
  psbtutils.checkInputForSig = x;
  function v(U, L, H) {
    const { hashType: fe } = L(U), ge = [];
    switch (fe & c.Transaction.SIGHASH_ANYONECANPAY && ge.push("addInput"), fe & 31) {
      case c.Transaction.SIGHASH_ALL:
        break;
      case c.Transaction.SIGHASH_SINGLE:
      case c.Transaction.SIGHASH_NONE:
        ge.push("addOutput"), ge.push("setInputSequence");
        break;
    }
    return ge.indexOf(H) === -1;
  }
  psbtutils.signatureBlocksAction = v;
  function F(U) {
    let L = [];
    if ((U.partialSig || []).length === 0) {
      if (!U.finalScriptSig && !U.finalScriptWitness) return [];
      L = M(U);
    } else
      L = U.partialSig;
    return L.map((H) => H.signature);
  }
  function M(U) {
    const L = U.finalScriptSig ? g.decompile(U.finalScriptSig) || [] : [], H = U.finalScriptWitness ? g.decompile(U.finalScriptWitness) || [] : [];
    return L.concat(H).filter((fe) => Buffer.isBuffer(fe) && g.isCanonicalScriptSignature(fe)).map((fe) => ({ signature: fe }));
  }
  return psbtutils;
}
var hasRequiredBip371;
function requireBip371() {
  if (hasRequiredBip371) return bip371;
  hasRequiredBip371 = 1, Object.defineProperty(bip371, "__esModule", { value: !0 }), bip371.checkTaprootInputForSigs = bip371.tapTreeFromList = bip371.tapTreeToList = bip371.tweakInternalPubKey = bip371.checkTaprootOutputFields = bip371.checkTaprootInputFields = bip371.isTaprootOutput = bip371.isTaprootInput = bip371.serializeTaprootSignature = bip371.tapScriptFinalizer = bip371.toXOnly = void 0;
  const o = requireTypes$3(), g = requireTransaction$1(), c = requirePsbtutils(), y = requireBip341(), t = requirePayments(), d = requirePsbtutils(), E = (Dt) => Dt.length === 32 ? Dt : Dt.slice(1, 33);
  bip371.toXOnly = E;
  function B(Dt, er, xt) {
    const ir = Ne(
      er,
      Dt,
      xt
    );
    try {
      const yr = ke(er, ir).concat(ir.script).concat(ir.controlBlock);
      return {
        finalScriptWitness: (0, c.witnessStackToScriptWitness)(yr)
      };
    } catch (sr) {
      throw new Error(`Can not finalize taproot input #${Dt}: ${sr}`);
    }
  }
  bip371.tapScriptFinalizer = B;
  function D(Dt, er) {
    const xt = er ? Buffer.from([er]) : Buffer.from([]);
    return Buffer.concat([Dt, xt]);
  }
  bip371.serializeTaprootSignature = D;
  function x(Dt) {
    return Dt && !!(Dt.tapInternalKey || Dt.tapMerkleRoot || Dt.tapLeafScript && Dt.tapLeafScript.length || Dt.tapBip32Derivation && Dt.tapBip32Derivation.length || Dt.witnessUtxo && (0, c.isP2TR)(Dt.witnessUtxo.script));
  }
  bip371.isTaprootInput = x;
  function v(Dt, er) {
    return Dt && !!(Dt.tapInternalKey || Dt.tapTree || Dt.tapBip32Derivation && Dt.tapBip32Derivation.length || er && (0, c.isP2TR)(er));
  }
  bip371.isTaprootOutput = v;
  function F(Dt, er, xt) {
    ve(Dt, er, xt), be(Dt, er, xt);
  }
  bip371.checkTaprootInputFields = F;
  function M(Dt, er, xt) {
    Fe(Dt, er, xt), U(Dt, er);
  }
  bip371.checkTaprootOutputFields = M;
  function U(Dt, er) {
    if (!er.tapTree && !er.tapInternalKey) return;
    const xt = er.tapInternalKey || Dt.tapInternalKey, ir = er.tapTree || Dt.tapTree;
    if (xt) {
      const { script: sr } = Dt, yr = L(xt, ir);
      if (sr && !sr.equals(yr))
        throw new Error("Error adding output. Script or address missmatch.");
    }
  }
  function L(Dt, er) {
    const xt = er && ge(er.leaves), { output: ir } = (0, t.p2tr)({
      internalPubkey: Dt,
      scriptTree: xt
    });
    return ir;
  }
  function H(Dt, er) {
    const xt = er.tapInternalKey, ir = xt && (0, y.tweakKey)(xt, er.tapMerkleRoot);
    if (!ir)
      throw new Error(
        `Cannot tweak tap internal key for input #${Dt}. Public key: ${xt && xt.toString("hex")}`
      );
    return ir.x;
  }
  bip371.tweakInternalPubKey = H;
  function fe(Dt) {
    if (!(0, o.isTaptree)(Dt))
      throw new Error(
        "Cannot convert taptree to tapleaf list. Expecting a tapree structure."
      );
    return He(Dt);
  }
  bip371.tapTreeToList = fe;
  function ge(Dt = []) {
    return Dt.length === 1 && Dt[0].depth === 0 ? {
      output: Dt[0].script,
      version: Dt[0].leafVersion
    } : Pe(Dt);
  }
  bip371.tapTreeFromList = ge;
  function Ie(Dt, er) {
    return Se(Dt).some(
      (ir) => (0, d.signatureBlocksAction)(ir, Ee, er)
    );
  }
  bip371.checkTaprootInputForSigs = Ie;
  function Ee(Dt) {
    return {
      signature: Dt.slice(0, 64),
      hashType: Dt.slice(64)[0] || g.Transaction.SIGHASH_DEFAULT
    };
  }
  function Se(Dt) {
    const er = [];
    if (Dt.tapKeySig && er.push(Dt.tapKeySig), Dt.tapScriptSig && er.push(...Dt.tapScriptSig.map((xt) => xt.signature)), !er.length) {
      const xt = ze(Dt.finalScriptWitness);
      xt && er.push(xt);
    }
    return er;
  }
  function ze(Dt) {
    if (!Dt) return;
    const er = Dt.slice(2);
    if (er.length === 64 || er.length === 65) return er;
  }
  function He(Dt, er = [], xt = 0) {
    if (xt > y.MAX_TAPTREE_DEPTH)
      throw new Error("Max taptree depth exceeded.");
    return Dt ? (0, o.isTapleaf)(Dt) ? (er.push({
      depth: xt,
      leafVersion: Dt.version || y.LEAF_VERSION_TAPSCRIPT,
      script: Dt.output
    }), er) : (Dt[0] && He(Dt[0], er, xt + 1), Dt[1] && He(Dt[1], er, xt + 1), er) : [];
  }
  function Pe(Dt) {
    let er;
    for (const xt of Dt)
      if (er = De(xt, er), !er) throw new Error("No room left to insert tapleaf in tree");
    return er;
  }
  function De(Dt, er, xt = 0) {
    if (xt > y.MAX_TAPTREE_DEPTH)
      throw new Error("Max taptree depth exceeded.");
    if (Dt.depth === xt)
      return er ? void 0 : {
        output: Dt.script,
        version: Dt.leafVersion
      };
    if ((0, o.isTapleaf)(er)) return;
    const ir = De(Dt, er && er[0], xt + 1);
    if (ir) return [ir, er && er[1]];
    const sr = De(Dt, er && er[1], xt + 1);
    if (sr) return [er && er[0], sr];
  }
  function ve(Dt, er, xt) {
    const ir = x(Dt) && st(er), sr = st(Dt) && x(er), yr = Dt === er && x(er) && st(er);
    if (ir || sr || yr)
      throw new Error(
        `Invalid arguments for Psbt.${xt}. Cannot use both taproot and non-taproot fields.`
      );
  }
  function Fe(Dt, er, xt) {
    const ir = v(Dt) && st(er), sr = st(Dt) && v(er), yr = Dt === er && v(er) && st(er);
    if (ir || sr || yr)
      throw new Error(
        `Invalid arguments for Psbt.${xt}. Cannot use both taproot and non-taproot fields.`
      );
  }
  function be(Dt, er, xt) {
    if (er.tapMerkleRoot) {
      const ir = (er.tapLeafScript || []).every(
        (yr) => Be(yr, er.tapMerkleRoot)
      ), sr = (Dt.tapLeafScript || []).every(
        (yr) => Be(yr, er.tapMerkleRoot)
      );
      if (!ir || !sr)
        throw new Error(
          `Invalid arguments for Psbt.${xt}. Tapleaf not part of taptree.`
        );
    } else if (Dt.tapMerkleRoot && !(er.tapLeafScript || []).every(
      (sr) => Be(sr, Dt.tapMerkleRoot)
    ))
      throw new Error(
        `Invalid arguments for Psbt.${xt}. Tapleaf not part of taptree.`
      );
  }
  function Be(Dt, er) {
    if (!er) return !0;
    const xt = (0, y.tapleafHash)({
      output: Dt.script,
      version: Dt.leafVersion
    });
    return (0, y.rootHashFromPath)(
      Dt.controlBlock,
      xt
    ).equals(er);
  }
  function ke(Dt, er) {
    const xt = (0, y.tapleafHash)({
      output: er.script,
      version: er.leafVersion
    });
    return (Dt.tapScriptSig || []).filter((ir) => ir.leafHash.equals(xt)).map((ir) => xe(er.script, ir)).sort((ir, sr) => sr.positionInScript - ir.positionInScript).map((ir) => ir.signature);
  }
  function xe(Dt, er) {
    return Object.assign(
      {
        positionInScript: (0, c.pubkeyPositionInScript)(
          er.pubkey,
          Dt
        )
      },
      er
    );
  }
  function Ne(Dt, er, xt) {
    if (!Dt.tapScriptSig || !Dt.tapScriptSig.length)
      throw new Error(
        `Can not finalize taproot input #${er}. No tapleaf script signature provided.`
      );
    const ir = (Dt.tapLeafScript || []).sort((sr, yr) => sr.controlBlock.length - yr.controlBlock.length).find(
      (sr) => Et(sr, Dt.tapScriptSig, xt)
    );
    if (!ir)
      throw new Error(
        `Can not finalize taproot input #${er}. Signature for tapleaf script not found.`
      );
    return ir;
  }
  function Et(Dt, er, xt) {
    const ir = (0, y.tapleafHash)({
      output: Dt.script,
      version: Dt.leafVersion
    });
    return (!xt || xt.equals(ir)) && er.find((yr) => yr.leafHash.equals(ir)) !== void 0;
  }
  function st(Dt) {
    return Dt && !!(Dt.redeemScript || Dt.witnessScript || Dt.bip32Derivation && Dt.bip32Derivation.length);
  }
  return bip371;
}
var bip371Exports = requireBip371(), psbtutilsExports = requirePsbtutils(), bufferExports = requireBuffer$2(), build$6 = {}, keplr$1 = {}, build$5 = {}, currency = {}, hasRequiredCurrency;
function requireCurrency() {
  return hasRequiredCurrency || (hasRequiredCurrency = 1, Object.defineProperty(currency, "__esModule", { value: !0 })), currency;
}
var bech32$4 = {}, hasRequiredBech32$3;
function requireBech32$3() {
  return hasRequiredBech32$3 || (hasRequiredBech32$3 = 1, Object.defineProperty(bech32$4, "__esModule", { value: !0 })), bech32$4;
}
var bip44 = {}, hasRequiredBip44;
function requireBip44() {
  return hasRequiredBip44 || (hasRequiredBip44 = 1, Object.defineProperty(bip44, "__esModule", { value: !0 })), bip44;
}
var chainInfo = {}, hasRequiredChainInfo;
function requireChainInfo() {
  return hasRequiredChainInfo || (hasRequiredChainInfo = 1, Object.defineProperty(chainInfo, "__esModule", { value: !0 })), chainInfo;
}
var wallet = {}, keplr = {}, hasRequiredKeplr$1;
function requireKeplr$1() {
  return hasRequiredKeplr$1 || (hasRequiredKeplr$1 = 1, Object.defineProperty(keplr, "__esModule", { value: !0 })), keplr;
}
var eip6963 = {}, hasRequiredEip6963;
function requireEip6963() {
  return hasRequiredEip6963 || (hasRequiredEip6963 = 1, function(o) {
    Object.defineProperty(o, "__esModule", { value: !0 }), o.EIP6963EventNames = void 0, function(g) {
      g.Announce = "eip6963:announceProvider", g.Request = "eip6963:requestProvider";
    }(o.EIP6963EventNames || (o.EIP6963EventNames = {}));
  }(eip6963)), eip6963;
}
var ethereum$1 = {}, hasRequiredEthereum$1;
function requireEthereum$1() {
  return hasRequiredEthereum$1 || (hasRequiredEthereum$1 = 1, Object.defineProperty(ethereum$1, "__esModule", { value: !0 })), ethereum$1;
}
var starknet = {}, hasRequiredStarknet;
function requireStarknet() {
  return hasRequiredStarknet || (hasRequiredStarknet = 1, Object.defineProperty(starknet, "__esModule", { value: !0 })), starknet;
}
var bitcoin = {}, hasRequiredBitcoin;
function requireBitcoin() {
  return hasRequiredBitcoin || (hasRequiredBitcoin = 1, function(o) {
    Object.defineProperty(o, "__esModule", { value: !0 }), o.CHAIN_TYPE_TO_GENESIS_HASH = o.GENESIS_HASH_TO_CHAIN_TYPE = o.NETWORK_TO_GENESIS_HASH = o.GENESIS_HASH_TO_NETWORK = o.ChainType = o.Network = o.GenesisHash = o.BitcoinSignMessageType = void 0, function(t) {
      t.ECDSA = "ecdsa", t.BIP322_SIMPLE = "bip322-simple";
    }(o.BitcoinSignMessageType || (o.BitcoinSignMessageType = {}));
    var g;
    (function(t) {
      t.MAINNET = "000000000019d6689c085ae165831e934ff763ae46a2a6c172b3f1b60a8ce26f", t.TESTNET = "000000000933ea01ad0ee984209779baaec3ced90fa3f408719526f8d77f4943", t.SIGNET = "00000008819873e925422c1ff0f99f7cc9bbb232af63a077a480a3633bee1ef6";
    })(g = o.GenesisHash || (o.GenesisHash = {}));
    var c;
    (function(t) {
      t.MAINNET = "mainnet", t.LIVENET = "livenet", t.TESTNET = "testnet", t.SIGNET = "signet";
    })(c = o.Network || (o.Network = {}));
    var y;
    (function(t) {
      t.BITCOIN_MAINNET = "BITCOIN_MAINNET", t.BITCOIN_TESTNET = "BITCOIN_TESTNET", t.BITCOIN_SIGNET = "BITCOIN_SIGNET";
    })(y = o.ChainType || (o.ChainType = {})), o.GENESIS_HASH_TO_NETWORK = {
      [g.MAINNET]: c.MAINNET,
      [g.TESTNET]: c.TESTNET,
      [g.SIGNET]: c.SIGNET
    }, o.NETWORK_TO_GENESIS_HASH = {
      [c.MAINNET]: g.MAINNET,
      [c.LIVENET]: g.MAINNET,
      [c.TESTNET]: g.TESTNET,
      [c.SIGNET]: g.SIGNET
    }, o.GENESIS_HASH_TO_CHAIN_TYPE = {
      [g.MAINNET]: y.BITCOIN_MAINNET,
      [g.TESTNET]: y.BITCOIN_TESTNET,
      [g.SIGNET]: y.BITCOIN_SIGNET
    }, o.CHAIN_TYPE_TO_GENESIS_HASH = {
      [y.BITCOIN_MAINNET]: g.MAINNET,
      [y.BITCOIN_TESTNET]: g.TESTNET,
      [y.BITCOIN_SIGNET]: g.SIGNET
    };
  }(bitcoin)), bitcoin;
}
var hasRequiredWallet;
function requireWallet() {
  return hasRequiredWallet || (hasRequiredWallet = 1, function(o) {
    var g = wallet && wallet.__createBinding || (Object.create ? function(y, t, d, E) {
      E === void 0 && (E = d);
      var B = Object.getOwnPropertyDescriptor(t, d);
      (!B || ("get" in B ? !t.__esModule : B.writable || B.configurable)) && (B = { enumerable: !0, get: function() {
        return t[d];
      } }), Object.defineProperty(y, E, B);
    } : function(y, t, d, E) {
      E === void 0 && (E = d), y[E] = t[d];
    }), c = wallet && wallet.__exportStar || function(y, t) {
      for (var d in y) d !== "default" && !Object.prototype.hasOwnProperty.call(t, d) && g(t, y, d);
    };
    Object.defineProperty(o, "__esModule", { value: !0 }), c(requireKeplr$1(), o), c(requireEip6963(), o), c(requireEthereum$1(), o), c(requireStarknet(), o), c(requireBitcoin(), o);
  }(wallet)), wallet;
}
var window$1 = {}, hasRequiredWindow;
function requireWindow() {
  return hasRequiredWindow || (hasRequiredWindow = 1, Object.defineProperty(window$1, "__esModule", { value: !0 })), window$1;
}
var ethereum = {}, hasRequiredEthereum;
function requireEthereum() {
  return hasRequiredEthereum || (hasRequiredEthereum = 1, function(o) {
    Object.defineProperty(o, "__esModule", { value: !0 }), o.EthTxStatus = o.EthSignType = void 0, function(g) {
      g.MESSAGE = "message", g.TRANSACTION = "transaction", g.EIP712 = "eip-712";
    }(o.EthSignType || (o.EthSignType = {})), function(g) {
      g.Success = "0x1", g.Failure = "0x0";
    }(o.EthTxStatus || (o.EthTxStatus = {}));
  }(ethereum)), ethereum;
}
var cosmjs$1 = {}, hasRequiredCosmjs$1;
function requireCosmjs$1() {
  return hasRequiredCosmjs$1 || (hasRequiredCosmjs$1 = 1, Object.defineProperty(cosmjs$1, "__esModule", { value: !0 })), cosmjs$1;
}
var cosmjsAlt = {}, hasRequiredCosmjsAlt;
function requireCosmjsAlt() {
  return hasRequiredCosmjsAlt || (hasRequiredCosmjsAlt = 1, Object.defineProperty(cosmjsAlt, "__esModule", { value: !0 })), cosmjsAlt;
}
var secretjs = {}, hasRequiredSecretjs;
function requireSecretjs() {
  return hasRequiredSecretjs || (hasRequiredSecretjs = 1, Object.defineProperty(secretjs, "__esModule", { value: !0 })), secretjs;
}
var settled = {}, hasRequiredSettled;
function requireSettled() {
  return hasRequiredSettled || (hasRequiredSettled = 1, Object.defineProperty(settled, "__esModule", { value: !0 })), settled;
}
var hasRequiredBuild$6;
function requireBuild$6() {
  return hasRequiredBuild$6 || (hasRequiredBuild$6 = 1, function(o) {
    var g = build$5 && build$5.__createBinding || (Object.create ? function(y, t, d, E) {
      E === void 0 && (E = d);
      var B = Object.getOwnPropertyDescriptor(t, d);
      (!B || ("get" in B ? !t.__esModule : B.writable || B.configurable)) && (B = { enumerable: !0, get: function() {
        return t[d];
      } }), Object.defineProperty(y, E, B);
    } : function(y, t, d, E) {
      E === void 0 && (E = d), y[E] = t[d];
    }), c = build$5 && build$5.__exportStar || function(y, t) {
      for (var d in y) d !== "default" && !Object.prototype.hasOwnProperty.call(t, d) && g(t, y, d);
    };
    Object.defineProperty(o, "__esModule", { value: !0 }), c(requireCurrency(), o), c(requireBech32$3(), o), c(requireBip44(), o), c(requireChainInfo(), o), c(requireWallet(), o), c(requireWindow(), o), c(requireEthereum(), o), c(requireCosmjs$1(), o), c(requireCosmjsAlt(), o), c(requireSecretjs(), o), c(requireSettled(), o);
  }(build$5)), build$5;
}
var uint8Array = {}, hex$3 = {}, hasRequiredHex$2;
function requireHex$2() {
  if (hasRequiredHex$2) return hex$3;
  hasRequiredHex$2 = 1, Object.defineProperty(hex$3, "__esModule", { value: !0 }), hex$3.fromHex = hex$3.toHex = void 0;
  function o(c) {
    let y = "";
    for (const t of c)
      y += ("0" + t.toString(16)).slice(-2);
    return y;
  }
  hex$3.toHex = o;
  function g(c) {
    if (c.length % 2 !== 0)
      throw new Error("hex string length must be a multiple of 2");
    const y = [];
    for (let t = 0; t < c.length; t += 2) {
      const d = c.substr(t, 2);
      if (!d.match(/[0-9a-f]{2}/i))
        throw new Error("hex string contains invalid characters");
      y.push(parseInt(d, 16));
    }
    return new Uint8Array(y);
  }
  return hex$3.fromHex = g, hex$3;
}
var hasRequiredUint8Array;
function requireUint8Array() {
  if (hasRequiredUint8Array) return uint8Array;
  hasRequiredUint8Array = 1, Object.defineProperty(uint8Array, "__esModule", { value: !0 }), uint8Array.JSONUint8Array = void 0;
  const o = requireHex$2();
  class g {
    static parse(y) {
      return JSON.parse(y, (t, d) => {
        if (t === "__proto__")
          throw new Error("__proto__ is disallowed");
        return d && typeof d == "string" && d.startsWith("__uint8array__") ? (0, o.fromHex)(d.replace("__uint8array__", "")) : typeof BigInt < "u" && d && typeof d == "string" && d.startsWith("__bigint__") ? BigInt(d.replace("__bigint__", "")) : d;
      });
    }
    static stringify(y) {
      return JSON.stringify(y, (t, d) => {
        if (t === "__proto__")
          throw new Error("__proto__ is disallowed");
        if (d && (d instanceof Uint8Array || typeof d == "object" && "type" in d && "data" in d && d.type === "Buffer" && Array.isArray(d.data))) {
          const E = d instanceof Uint8Array ? d : new Uint8Array(d.data);
          return `__uint8array__${(0, o.toHex)(E)}`;
        }
        return typeof d == "bigint" ? `__bigint__${d.toString()}` : d;
      });
    }
    static wrap(y) {
      if (y !== void 0)
        return JSON.parse(g.stringify(y));
    }
    static unwrap(y) {
      if (y !== void 0)
        return g.parse(g.stringify(y));
    }
  }
  return uint8Array.JSONUint8Array = g, uint8Array;
}
var cjs$2, hasRequiredCjs$2;
function requireCjs$2() {
  if (hasRequiredCjs$2) return cjs$2;
  hasRequiredCjs$2 = 1;
  var o = function(Ie) {
    return g(Ie) && !c(Ie);
  };
  function g(ge) {
    return !!ge && typeof ge == "object";
  }
  function c(ge) {
    var Ie = Object.prototype.toString.call(ge);
    return Ie === "[object RegExp]" || Ie === "[object Date]" || d(ge);
  }
  var y = typeof Symbol == "function" && Symbol.for, t = y ? Symbol.for("react.element") : 60103;
  function d(ge) {
    return ge.$$typeof === t;
  }
  function E(ge) {
    return Array.isArray(ge) ? [] : {};
  }
  function B(ge, Ie) {
    return Ie.clone !== !1 && Ie.isMergeableObject(ge) ? H(E(ge), ge, Ie) : ge;
  }
  function D(ge, Ie, Ee) {
    return ge.concat(Ie).map(function(Se) {
      return B(Se, Ee);
    });
  }
  function x(ge, Ie) {
    if (!Ie.customMerge)
      return H;
    var Ee = Ie.customMerge(ge);
    return typeof Ee == "function" ? Ee : H;
  }
  function v(ge) {
    return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(ge).filter(function(Ie) {
      return Object.propertyIsEnumerable.call(ge, Ie);
    }) : [];
  }
  function F(ge) {
    return Object.keys(ge).concat(v(ge));
  }
  function M(ge, Ie) {
    try {
      return Ie in ge;
    } catch {
      return !1;
    }
  }
  function U(ge, Ie) {
    return M(ge, Ie) && !(Object.hasOwnProperty.call(ge, Ie) && Object.propertyIsEnumerable.call(ge, Ie));
  }
  function L(ge, Ie, Ee) {
    var Se = {};
    return Ee.isMergeableObject(ge) && F(ge).forEach(function(ze) {
      Se[ze] = B(ge[ze], Ee);
    }), F(Ie).forEach(function(ze) {
      U(ge, ze) || (M(ge, ze) && Ee.isMergeableObject(Ie[ze]) ? Se[ze] = x(ze, Ee)(ge[ze], Ie[ze], Ee) : Se[ze] = B(Ie[ze], Ee));
    }), Se;
  }
  function H(ge, Ie, Ee) {
    Ee = Ee || {}, Ee.arrayMerge = Ee.arrayMerge || D, Ee.isMergeableObject = Ee.isMergeableObject || o, Ee.cloneUnlessOtherwiseSpecified = B;
    var Se = Array.isArray(Ie), ze = Array.isArray(ge), He = Se === ze;
    return He ? Se ? Ee.arrayMerge(ge, Ie, Ee) : L(ge, Ie, Ee) : B(Ie, Ee);
  }
  H.all = function(Ie, Ee) {
    if (!Array.isArray(Ie))
      throw new Error("first argument should be an array");
    return Ie.reduce(function(Se, ze) {
      return H(Se, ze, Ee);
    }, {});
  };
  var fe = H;
  return cjs$2 = fe, cjs$2;
}
var long, hasRequiredLong;
function requireLong() {
  if (hasRequiredLong) return long;
  hasRequiredLong = 1, long = g;
  var o = null;
  try {
    o = new WebAssembly.Instance(new WebAssembly.Module(new Uint8Array([
      0,
      97,
      115,
      109,
      1,
      0,
      0,
      0,
      1,
      13,
      2,
      96,
      0,
      1,
      127,
      96,
      4,
      127,
      127,
      127,
      127,
      1,
      127,
      3,
      7,
      6,
      0,
      1,
      1,
      1,
      1,
      1,
      6,
      6,
      1,
      127,
      1,
      65,
      0,
      11,
      7,
      50,
      6,
      3,
      109,
      117,
      108,
      0,
      1,
      5,
      100,
      105,
      118,
      95,
      115,
      0,
      2,
      5,
      100,
      105,
      118,
      95,
      117,
      0,
      3,
      5,
      114,
      101,
      109,
      95,
      115,
      0,
      4,
      5,
      114,
      101,
      109,
      95,
      117,
      0,
      5,
      8,
      103,
      101,
      116,
      95,
      104,
      105,
      103,
      104,
      0,
      0,
      10,
      191,
      1,
      6,
      4,
      0,
      35,
      0,
      11,
      36,
      1,
      1,
      126,
      32,
      0,
      173,
      32,
      1,
      173,
      66,
      32,
      134,
      132,
      32,
      2,
      173,
      32,
      3,
      173,
      66,
      32,
      134,
      132,
      126,
      34,
      4,
      66,
      32,
      135,
      167,
      36,
      0,
      32,
      4,
      167,
      11,
      36,
      1,
      1,
      126,
      32,
      0,
      173,
      32,
      1,
      173,
      66,
      32,
      134,
      132,
      32,
      2,
      173,
      32,
      3,
      173,
      66,
      32,
      134,
      132,
      127,
      34,
      4,
      66,
      32,
      135,
      167,
      36,
      0,
      32,
      4,
      167,
      11,
      36,
      1,
      1,
      126,
      32,
      0,
      173,
      32,
      1,
      173,
      66,
      32,
      134,
      132,
      32,
      2,
      173,
      32,
      3,
      173,
      66,
      32,
      134,
      132,
      128,
      34,
      4,
      66,
      32,
      135,
      167,
      36,
      0,
      32,
      4,
      167,
      11,
      36,
      1,
      1,
      126,
      32,
      0,
      173,
      32,
      1,
      173,
      66,
      32,
      134,
      132,
      32,
      2,
      173,
      32,
      3,
      173,
      66,
      32,
      134,
      132,
      129,
      34,
      4,
      66,
      32,
      135,
      167,
      36,
      0,
      32,
      4,
      167,
      11,
      36,
      1,
      1,
      126,
      32,
      0,
      173,
      32,
      1,
      173,
      66,
      32,
      134,
      132,
      32,
      2,
      173,
      32,
      3,
      173,
      66,
      32,
      134,
      132,
      130,
      34,
      4,
      66,
      32,
      135,
      167,
      36,
      0,
      32,
      4,
      167,
      11
    ])), {}).exports;
  } catch {
  }
  function g(Fe, be, Be) {
    this.low = Fe | 0, this.high = be | 0, this.unsigned = !!Be;
  }
  g.prototype.__isLong__, Object.defineProperty(g.prototype, "__isLong__", { value: !0 });
  function c(Fe) {
    return (Fe && Fe.__isLong__) === !0;
  }
  g.isLong = c;
  var y = {}, t = {};
  function d(Fe, be) {
    var Be, ke, xe;
    return be ? (Fe >>>= 0, (xe = 0 <= Fe && Fe < 256) && (ke = t[Fe], ke) ? ke : (Be = B(Fe, (Fe | 0) < 0 ? -1 : 0, !0), xe && (t[Fe] = Be), Be)) : (Fe |= 0, (xe = -128 <= Fe && Fe < 128) && (ke = y[Fe], ke) ? ke : (Be = B(Fe, Fe < 0 ? -1 : 0, !1), xe && (y[Fe] = Be), Be));
  }
  g.fromInt = d;
  function E(Fe, be) {
    if (isNaN(Fe))
      return be ? Ie : ge;
    if (be) {
      if (Fe < 0)
        return Ie;
      if (Fe >= L)
        return Pe;
    } else {
      if (Fe <= -H)
        return De;
      if (Fe + 1 >= H)
        return He;
    }
    return Fe < 0 ? E(-Fe, be).neg() : B(Fe % U | 0, Fe / U | 0, be);
  }
  g.fromNumber = E;
  function B(Fe, be, Be) {
    return new g(Fe, be, Be);
  }
  g.fromBits = B;
  var D = Math.pow;
  function x(Fe, be, Be) {
    if (Fe.length === 0)
      throw Error("empty string");
    if (Fe === "NaN" || Fe === "Infinity" || Fe === "+Infinity" || Fe === "-Infinity")
      return ge;
    if (typeof be == "number" ? (Be = be, be = !1) : be = !!be, Be = Be || 10, Be < 2 || 36 < Be)
      throw RangeError("radix");
    var ke;
    if ((ke = Fe.indexOf("-")) > 0)
      throw Error("interior hyphen");
    if (ke === 0)
      return x(Fe.substring(1), be, Be).neg();
    for (var xe = E(D(Be, 8)), Ne = ge, Et = 0; Et < Fe.length; Et += 8) {
      var st = Math.min(8, Fe.length - Et), Dt = parseInt(Fe.substring(Et, Et + st), Be);
      if (st < 8) {
        var er = E(D(Be, st));
        Ne = Ne.mul(er).add(E(Dt));
      } else
        Ne = Ne.mul(xe), Ne = Ne.add(E(Dt));
    }
    return Ne.unsigned = be, Ne;
  }
  g.fromString = x;
  function v(Fe, be) {
    return typeof Fe == "number" ? E(Fe, be) : typeof Fe == "string" ? x(Fe, be) : B(Fe.low, Fe.high, typeof be == "boolean" ? be : Fe.unsigned);
  }
  g.fromValue = v;
  var F = 65536, M = 1 << 24, U = F * F, L = U * U, H = L / 2, fe = d(M), ge = d(0);
  g.ZERO = ge;
  var Ie = d(0, !0);
  g.UZERO = Ie;
  var Ee = d(1);
  g.ONE = Ee;
  var Se = d(1, !0);
  g.UONE = Se;
  var ze = d(-1);
  g.NEG_ONE = ze;
  var He = B(-1, 2147483647, !1);
  g.MAX_VALUE = He;
  var Pe = B(-1, -1, !0);
  g.MAX_UNSIGNED_VALUE = Pe;
  var De = B(0, -2147483648, !1);
  g.MIN_VALUE = De;
  var ve = g.prototype;
  return ve.toInt = function() {
    return this.unsigned ? this.low >>> 0 : this.low;
  }, ve.toNumber = function() {
    return this.unsigned ? (this.high >>> 0) * U + (this.low >>> 0) : this.high * U + (this.low >>> 0);
  }, ve.toString = function(be) {
    if (be = be || 10, be < 2 || 36 < be)
      throw RangeError("radix");
    if (this.isZero())
      return "0";
    if (this.isNegative())
      if (this.eq(De)) {
        var Be = E(be), ke = this.div(Be), xe = ke.mul(Be).sub(this);
        return ke.toString(be) + xe.toInt().toString(be);
      } else
        return "-" + this.neg().toString(be);
    for (var Ne = E(D(be, 6), this.unsigned), Et = this, st = ""; ; ) {
      var Dt = Et.div(Ne), er = Et.sub(Dt.mul(Ne)).toInt() >>> 0, xt = er.toString(be);
      if (Et = Dt, Et.isZero())
        return xt + st;
      for (; xt.length < 6; )
        xt = "0" + xt;
      st = "" + xt + st;
    }
  }, ve.getHighBits = function() {
    return this.high;
  }, ve.getHighBitsUnsigned = function() {
    return this.high >>> 0;
  }, ve.getLowBits = function() {
    return this.low;
  }, ve.getLowBitsUnsigned = function() {
    return this.low >>> 0;
  }, ve.getNumBitsAbs = function() {
    if (this.isNegative())
      return this.eq(De) ? 64 : this.neg().getNumBitsAbs();
    for (var be = this.high != 0 ? this.high : this.low, Be = 31; Be > 0 && (be & 1 << Be) == 0; Be--)
      ;
    return this.high != 0 ? Be + 33 : Be + 1;
  }, ve.isZero = function() {
    return this.high === 0 && this.low === 0;
  }, ve.eqz = ve.isZero, ve.isNegative = function() {
    return !this.unsigned && this.high < 0;
  }, ve.isPositive = function() {
    return this.unsigned || this.high >= 0;
  }, ve.isOdd = function() {
    return (this.low & 1) === 1;
  }, ve.isEven = function() {
    return (this.low & 1) === 0;
  }, ve.equals = function(be) {
    return c(be) || (be = v(be)), this.unsigned !== be.unsigned && this.high >>> 31 === 1 && be.high >>> 31 === 1 ? !1 : this.high === be.high && this.low === be.low;
  }, ve.eq = ve.equals, ve.notEquals = function(be) {
    return !this.eq(
      /* validates */
      be
    );
  }, ve.neq = ve.notEquals, ve.ne = ve.notEquals, ve.lessThan = function(be) {
    return this.comp(
      /* validates */
      be
    ) < 0;
  }, ve.lt = ve.lessThan, ve.lessThanOrEqual = function(be) {
    return this.comp(
      /* validates */
      be
    ) <= 0;
  }, ve.lte = ve.lessThanOrEqual, ve.le = ve.lessThanOrEqual, ve.greaterThan = function(be) {
    return this.comp(
      /* validates */
      be
    ) > 0;
  }, ve.gt = ve.greaterThan, ve.greaterThanOrEqual = function(be) {
    return this.comp(
      /* validates */
      be
    ) >= 0;
  }, ve.gte = ve.greaterThanOrEqual, ve.ge = ve.greaterThanOrEqual, ve.compare = function(be) {
    if (c(be) || (be = v(be)), this.eq(be))
      return 0;
    var Be = this.isNegative(), ke = be.isNegative();
    return Be && !ke ? -1 : !Be && ke ? 1 : this.unsigned ? be.high >>> 0 > this.high >>> 0 || be.high === this.high && be.low >>> 0 > this.low >>> 0 ? -1 : 1 : this.sub(be).isNegative() ? -1 : 1;
  }, ve.comp = ve.compare, ve.negate = function() {
    return !this.unsigned && this.eq(De) ? De : this.not().add(Ee);
  }, ve.neg = ve.negate, ve.add = function(be) {
    c(be) || (be = v(be));
    var Be = this.high >>> 16, ke = this.high & 65535, xe = this.low >>> 16, Ne = this.low & 65535, Et = be.high >>> 16, st = be.high & 65535, Dt = be.low >>> 16, er = be.low & 65535, xt = 0, ir = 0, sr = 0, yr = 0;
    return yr += Ne + er, sr += yr >>> 16, yr &= 65535, sr += xe + Dt, ir += sr >>> 16, sr &= 65535, ir += ke + st, xt += ir >>> 16, ir &= 65535, xt += Be + Et, xt &= 65535, B(sr << 16 | yr, xt << 16 | ir, this.unsigned);
  }, ve.subtract = function(be) {
    return c(be) || (be = v(be)), this.add(be.neg());
  }, ve.sub = ve.subtract, ve.multiply = function(be) {
    if (this.isZero())
      return ge;
    if (c(be) || (be = v(be)), o) {
      var Be = o.mul(
        this.low,
        this.high,
        be.low,
        be.high
      );
      return B(Be, o.get_high(), this.unsigned);
    }
    if (be.isZero())
      return ge;
    if (this.eq(De))
      return be.isOdd() ? De : ge;
    if (be.eq(De))
      return this.isOdd() ? De : ge;
    if (this.isNegative())
      return be.isNegative() ? this.neg().mul(be.neg()) : this.neg().mul(be).neg();
    if (be.isNegative())
      return this.mul(be.neg()).neg();
    if (this.lt(fe) && be.lt(fe))
      return E(this.toNumber() * be.toNumber(), this.unsigned);
    var ke = this.high >>> 16, xe = this.high & 65535, Ne = this.low >>> 16, Et = this.low & 65535, st = be.high >>> 16, Dt = be.high & 65535, er = be.low >>> 16, xt = be.low & 65535, ir = 0, sr = 0, yr = 0, wr = 0;
    return wr += Et * xt, yr += wr >>> 16, wr &= 65535, yr += Ne * xt, sr += yr >>> 16, yr &= 65535, yr += Et * er, sr += yr >>> 16, yr &= 65535, sr += xe * xt, ir += sr >>> 16, sr &= 65535, sr += Ne * er, ir += sr >>> 16, sr &= 65535, sr += Et * Dt, ir += sr >>> 16, sr &= 65535, ir += ke * xt + xe * er + Ne * Dt + Et * st, ir &= 65535, B(yr << 16 | wr, ir << 16 | sr, this.unsigned);
  }, ve.mul = ve.multiply, ve.divide = function(be) {
    if (c(be) || (be = v(be)), be.isZero())
      throw Error("division by zero");
    if (o) {
      if (!this.unsigned && this.high === -2147483648 && be.low === -1 && be.high === -1)
        return this;
      var Be = (this.unsigned ? o.div_u : o.div_s)(
        this.low,
        this.high,
        be.low,
        be.high
      );
      return B(Be, o.get_high(), this.unsigned);
    }
    if (this.isZero())
      return this.unsigned ? Ie : ge;
    var ke, xe, Ne;
    if (this.unsigned) {
      if (be.unsigned || (be = be.toUnsigned()), be.gt(this))
        return Ie;
      if (be.gt(this.shru(1)))
        return Se;
      Ne = Ie;
    } else {
      if (this.eq(De)) {
        if (be.eq(Ee) || be.eq(ze))
          return De;
        if (be.eq(De))
          return Ee;
        var Et = this.shr(1);
        return ke = Et.div(be).shl(1), ke.eq(ge) ? be.isNegative() ? Ee : ze : (xe = this.sub(be.mul(ke)), Ne = ke.add(xe.div(be)), Ne);
      } else if (be.eq(De))
        return this.unsigned ? Ie : ge;
      if (this.isNegative())
        return be.isNegative() ? this.neg().div(be.neg()) : this.neg().div(be).neg();
      if (be.isNegative())
        return this.div(be.neg()).neg();
      Ne = ge;
    }
    for (xe = this; xe.gte(be); ) {
      ke = Math.max(1, Math.floor(xe.toNumber() / be.toNumber()));
      for (var st = Math.ceil(Math.log(ke) / Math.LN2), Dt = st <= 48 ? 1 : D(2, st - 48), er = E(ke), xt = er.mul(be); xt.isNegative() || xt.gt(xe); )
        ke -= Dt, er = E(ke, this.unsigned), xt = er.mul(be);
      er.isZero() && (er = Ee), Ne = Ne.add(er), xe = xe.sub(xt);
    }
    return Ne;
  }, ve.div = ve.divide, ve.modulo = function(be) {
    if (c(be) || (be = v(be)), o) {
      var Be = (this.unsigned ? o.rem_u : o.rem_s)(
        this.low,
        this.high,
        be.low,
        be.high
      );
      return B(Be, o.get_high(), this.unsigned);
    }
    return this.sub(this.div(be).mul(be));
  }, ve.mod = ve.modulo, ve.rem = ve.modulo, ve.not = function() {
    return B(~this.low, ~this.high, this.unsigned);
  }, ve.and = function(be) {
    return c(be) || (be = v(be)), B(this.low & be.low, this.high & be.high, this.unsigned);
  }, ve.or = function(be) {
    return c(be) || (be = v(be)), B(this.low | be.low, this.high | be.high, this.unsigned);
  }, ve.xor = function(be) {
    return c(be) || (be = v(be)), B(this.low ^ be.low, this.high ^ be.high, this.unsigned);
  }, ve.shiftLeft = function(be) {
    return c(be) && (be = be.toInt()), (be &= 63) === 0 ? this : be < 32 ? B(this.low << be, this.high << be | this.low >>> 32 - be, this.unsigned) : B(0, this.low << be - 32, this.unsigned);
  }, ve.shl = ve.shiftLeft, ve.shiftRight = function(be) {
    return c(be) && (be = be.toInt()), (be &= 63) === 0 ? this : be < 32 ? B(this.low >>> be | this.high << 32 - be, this.high >> be, this.unsigned) : B(this.high >> be - 32, this.high >= 0 ? 0 : -1, this.unsigned);
  }, ve.shr = ve.shiftRight, ve.shiftRightUnsigned = function(be) {
    if (c(be) && (be = be.toInt()), be &= 63, be === 0)
      return this;
    var Be = this.high;
    if (be < 32) {
      var ke = this.low;
      return B(ke >>> be | Be << 32 - be, Be >>> be, this.unsigned);
    } else return be === 32 ? B(Be, 0, this.unsigned) : B(Be >>> be - 32, 0, this.unsigned);
  }, ve.shru = ve.shiftRightUnsigned, ve.shr_u = ve.shiftRightUnsigned, ve.toSigned = function() {
    return this.unsigned ? B(this.low, this.high, !1) : this;
  }, ve.toUnsigned = function() {
    return this.unsigned ? this : B(this.low, this.high, !0);
  }, ve.toBytes = function(be) {
    return be ? this.toBytesLE() : this.toBytesBE();
  }, ve.toBytesLE = function() {
    var be = this.high, Be = this.low;
    return [
      Be & 255,
      Be >>> 8 & 255,
      Be >>> 16 & 255,
      Be >>> 24,
      be & 255,
      be >>> 8 & 255,
      be >>> 16 & 255,
      be >>> 24
    ];
  }, ve.toBytesBE = function() {
    var be = this.high, Be = this.low;
    return [
      be >>> 24,
      be >>> 16 & 255,
      be >>> 8 & 255,
      be & 255,
      Be >>> 24,
      Be >>> 16 & 255,
      Be >>> 8 & 255,
      Be & 255
    ];
  }, g.fromBytes = function(be, Be, ke) {
    return ke ? g.fromBytesLE(be, Be) : g.fromBytesBE(be, Be);
  }, g.fromBytesLE = function(be, Be) {
    return new g(
      be[0] | be[1] << 8 | be[2] << 16 | be[3] << 24,
      be[4] | be[5] << 8 | be[6] << 16 | be[7] << 24,
      Be
    );
  }, g.fromBytesBE = function(be, Be) {
    return new g(
      be[4] << 24 | be[5] << 16 | be[6] << 8 | be[7],
      be[0] << 24 | be[1] << 16 | be[2] << 8 | be[3],
      Be
    );
  }, long;
}
var cosmjs = {}, hasRequiredCosmjs;
function requireCosmjs() {
  if (hasRequiredCosmjs) return cosmjs;
  hasRequiredCosmjs = 1;
  var o = cosmjs && cosmjs.__awaiter || function(y, t, d, E) {
    function B(D) {
      return D instanceof d ? D : new d(function(x) {
        x(D);
      });
    }
    return new (d || (d = Promise))(function(D, x) {
      function v(U) {
        try {
          M(E.next(U));
        } catch (L) {
          x(L);
        }
      }
      function F(U) {
        try {
          M(E.throw(U));
        } catch (L) {
          x(L);
        }
      }
      function M(U) {
        U.done ? D(U.value) : B(U.value).then(v, F);
      }
      M((E = E.apply(y, t || [])).next());
    });
  };
  Object.defineProperty(cosmjs, "__esModule", { value: !0 }), cosmjs.CosmJSOfflineSigner = cosmjs.CosmJSOfflineSignerOnlyAmino = void 0;
  class g {
    constructor(t, d, E) {
      this.chainId = t, this.keplr = d, this.signOptions = E;
    }
    getAccounts() {
      return o(this, void 0, void 0, function* () {
        const t = yield this.keplr.getKey(this.chainId);
        return [
          {
            address: t.bech32Address,
            // Currently, only secp256k1 is supported.
            algo: "secp256k1",
            pubkey: t.pubKey
          }
        ];
      });
    }
    signAmino(t, d) {
      return o(this, void 0, void 0, function* () {
        if (this.chainId !== d.chain_id)
          throw new Error("Unmatched chain id with the offline signer");
        if ((yield this.keplr.getKey(d.chain_id)).bech32Address !== t)
          throw new Error("Unknown signer address");
        return yield this.keplr.signAmino(this.chainId, t, d, this.signOptions);
      });
    }
    // Fallback function for the legacy cosmjs implementation before the stargate.
    sign(t, d) {
      return o(this, void 0, void 0, function* () {
        return yield this.signAmino(t, d);
      });
    }
  }
  cosmjs.CosmJSOfflineSignerOnlyAmino = g;
  class c extends g {
    constructor(t, d, E) {
      super(t, d, E);
    }
    signDirect(t, d) {
      return o(this, void 0, void 0, function* () {
        if (this.chainId !== d.chainId)
          throw new Error("Unmatched chain id with the offline signer");
        if ((yield this.keplr.getKey(d.chainId)).bech32Address !== t)
          throw new Error("Unknown signer address");
        return yield this.keplr.signDirect(this.chainId, t, d, this.signOptions);
      });
    }
  }
  return cosmjs.CosmJSOfflineSigner = c, cosmjs;
}
var enigma = {}, hasRequiredEnigma;
function requireEnigma() {
  if (hasRequiredEnigma) return enigma;
  hasRequiredEnigma = 1;
  var o = enigma && enigma.__awaiter || function(c, y, t, d) {
    function E(B) {
      return B instanceof t ? B : new t(function(D) {
        D(B);
      });
    }
    return new (t || (t = Promise))(function(B, D) {
      function x(M) {
        try {
          F(d.next(M));
        } catch (U) {
          D(U);
        }
      }
      function v(M) {
        try {
          F(d.throw(M));
        } catch (U) {
          D(U);
        }
      }
      function F(M) {
        M.done ? B(M.value) : E(M.value).then(x, v);
      }
      F((d = d.apply(c, y || [])).next());
    });
  };
  Object.defineProperty(enigma, "__esModule", { value: !0 }), enigma.KeplrEnigmaUtils = void 0;
  class g {
    constructor(y, t) {
      this.chainId = y, this.keplr = t;
    }
    getPubkey() {
      return o(this, void 0, void 0, function* () {
        return yield this.keplr.getEnigmaPubKey(this.chainId);
      });
    }
    getTxEncryptionKey(y) {
      return o(this, void 0, void 0, function* () {
        return yield this.keplr.getEnigmaTxEncryptionKey(this.chainId, y);
      });
    }
    encrypt(y, t) {
      return o(this, void 0, void 0, function* () {
        return yield this.keplr.enigmaEncrypt(this.chainId, y, t);
      });
    }
    decrypt(y, t) {
      return o(this, void 0, void 0, function* () {
        return yield this.keplr.enigmaDecrypt(this.chainId, y, t);
      });
    }
  }
  return enigma.KeplrEnigmaUtils = g, enigma;
}
var version$1 = {}, hasRequiredVersion$1;
function requireVersion$1() {
  return hasRequiredVersion$1 || (hasRequiredVersion$1 = 1, Object.defineProperty(version$1, "__esModule", { value: !0 }), version$1.BUILD_VERSION = void 0, version$1.BUILD_VERSION = "0.12.272"), version$1;
}
var constants$1 = {}, hasRequiredConstants$1;
function requireConstants$1() {
  return hasRequiredConstants$1 || (hasRequiredConstants$1 = 1, Object.defineProperty(constants$1, "__esModule", { value: !0 }), constants$1.metaId = constants$1.KeplrLogoBase64 = void 0, constants$1.KeplrLogoBase64 = "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", constants$1.metaId = "d_2hxd99brRo"), constants$1;
}
var cjsBrowser = {}, max = {}, hasRequiredMax;
function requireMax() {
  return hasRequiredMax || (hasRequiredMax = 1, Object.defineProperty(max, "__esModule", { value: !0 }), max.default = "ffffffff-ffff-ffff-ffff-ffffffffffff"), max;
}
var nil = {}, hasRequiredNil;
function requireNil() {
  return hasRequiredNil || (hasRequiredNil = 1, Object.defineProperty(nil, "__esModule", { value: !0 }), nil.default = "00000000-0000-0000-0000-000000000000"), nil;
}
var parse = {}, validate$1 = {}, regex = {}, hasRequiredRegex;
function requireRegex() {
  return hasRequiredRegex || (hasRequiredRegex = 1, Object.defineProperty(regex, "__esModule", { value: !0 }), regex.default = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/i), regex;
}
var hasRequiredValidate;
function requireValidate() {
  if (hasRequiredValidate) return validate$1;
  hasRequiredValidate = 1, Object.defineProperty(validate$1, "__esModule", { value: !0 });
  const o = requireRegex();
  function g(c) {
    return typeof c == "string" && o.default.test(c);
  }
  return validate$1.default = g, validate$1;
}
var hasRequiredParse$1;
function requireParse$1() {
  if (hasRequiredParse$1) return parse;
  hasRequiredParse$1 = 1, Object.defineProperty(parse, "__esModule", { value: !0 });
  const o = requireValidate();
  function g(c) {
    if (!(0, o.default)(c))
      throw TypeError("Invalid UUID");
    let y;
    return Uint8Array.of((y = parseInt(c.slice(0, 8), 16)) >>> 24, y >>> 16 & 255, y >>> 8 & 255, y & 255, (y = parseInt(c.slice(9, 13), 16)) >>> 8, y & 255, (y = parseInt(c.slice(14, 18), 16)) >>> 8, y & 255, (y = parseInt(c.slice(19, 23), 16)) >>> 8, y & 255, (y = parseInt(c.slice(24, 36), 16)) / 1099511627776 & 255, y / 4294967296 & 255, y >>> 24 & 255, y >>> 16 & 255, y >>> 8 & 255, y & 255);
  }
  return parse.default = g, parse;
}
var stringify = {}, hasRequiredStringify;
function requireStringify() {
  if (hasRequiredStringify) return stringify;
  hasRequiredStringify = 1, Object.defineProperty(stringify, "__esModule", { value: !0 }), stringify.unsafeStringify = void 0;
  const o = requireValidate(), g = [];
  for (let t = 0; t < 256; ++t)
    g.push((t + 256).toString(16).slice(1));
  function c(t, d = 0) {
    return (g[t[d + 0]] + g[t[d + 1]] + g[t[d + 2]] + g[t[d + 3]] + "-" + g[t[d + 4]] + g[t[d + 5]] + "-" + g[t[d + 6]] + g[t[d + 7]] + "-" + g[t[d + 8]] + g[t[d + 9]] + "-" + g[t[d + 10]] + g[t[d + 11]] + g[t[d + 12]] + g[t[d + 13]] + g[t[d + 14]] + g[t[d + 15]]).toLowerCase();
  }
  stringify.unsafeStringify = c;
  function y(t, d = 0) {
    const E = c(t, d);
    if (!(0, o.default)(E))
      throw TypeError("Stringified UUID is invalid");
    return E;
  }
  return stringify.default = y, stringify;
}
var v1 = {}, rng$1 = {}, hasRequiredRng;
function requireRng() {
  if (hasRequiredRng) return rng$1;
  hasRequiredRng = 1, Object.defineProperty(rng$1, "__esModule", { value: !0 });
  let o;
  const g = new Uint8Array(16);
  function c() {
    if (!o) {
      if (typeof crypto > "u" || !crypto.getRandomValues)
        throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
      o = crypto.getRandomValues.bind(crypto);
    }
    return o(g);
  }
  return rng$1.default = c, rng$1;
}
var hasRequiredV1;
function requireV1() {
  if (hasRequiredV1) return v1;
  hasRequiredV1 = 1, Object.defineProperty(v1, "__esModule", { value: !0 }), v1.updateV1State = void 0;
  const o = requireRng(), g = requireStringify(), c = {};
  function y(E, B, D) {
    var F;
    let x;
    const v = (E == null ? void 0 : E._v6) ?? !1;
    if (E) {
      const M = Object.keys(E);
      M.length === 1 && M[0] === "_v6" && (E = void 0);
    }
    if (E)
      x = d(E.random ?? ((F = E.rng) == null ? void 0 : F.call(E)) ?? (0, o.default)(), E.msecs, E.nsecs, E.clockseq, E.node, B, D);
    else {
      const M = Date.now(), U = (0, o.default)();
      t(c, M, U), x = d(U, c.msecs, c.nsecs, v ? void 0 : c.clockseq, v ? void 0 : c.node, B, D);
    }
    return B ?? (0, g.unsafeStringify)(x);
  }
  function t(E, B, D) {
    return E.msecs ?? (E.msecs = -1 / 0), E.nsecs ?? (E.nsecs = 0), B === E.msecs ? (E.nsecs++, E.nsecs >= 1e4 && (E.node = void 0, E.nsecs = 0)) : B > E.msecs ? E.nsecs = 0 : B < E.msecs && (E.node = void 0), E.node || (E.node = D.slice(10, 16), E.node[0] |= 1, E.clockseq = (D[8] << 8 | D[9]) & 16383), E.msecs = B, E;
  }
  v1.updateV1State = t;
  function d(E, B, D, x, v, F, M = 0) {
    if (E.length < 16)
      throw new Error("Random bytes length must be >= 16");
    if (!F)
      F = new Uint8Array(16), M = 0;
    else if (M < 0 || M + 16 > F.length)
      throw new RangeError(`UUID byte range ${M}:${M + 15} is out of buffer bounds`);
    B ?? (B = Date.now()), D ?? (D = 0), x ?? (x = (E[8] << 8 | E[9]) & 16383), v ?? (v = E.slice(10, 16)), B += 122192928e5;
    const U = ((B & 268435455) * 1e4 + D) % 4294967296;
    F[M++] = U >>> 24 & 255, F[M++] = U >>> 16 & 255, F[M++] = U >>> 8 & 255, F[M++] = U & 255;
    const L = B / 4294967296 * 1e4 & 268435455;
    F[M++] = L >>> 8 & 255, F[M++] = L & 255, F[M++] = L >>> 24 & 15 | 16, F[M++] = L >>> 16 & 255, F[M++] = x >>> 8 | 128, F[M++] = x & 255;
    for (let H = 0; H < 6; ++H)
      F[M++] = v[H];
    return F;
  }
  return v1.default = y, v1;
}
var v1ToV6 = {}, hasRequiredV1ToV6;
function requireV1ToV6() {
  if (hasRequiredV1ToV6) return v1ToV6;
  hasRequiredV1ToV6 = 1, Object.defineProperty(v1ToV6, "__esModule", { value: !0 });
  const o = requireParse$1(), g = requireStringify();
  function c(t) {
    const d = typeof t == "string" ? (0, o.default)(t) : t, E = y(d);
    return typeof t == "string" ? (0, g.unsafeStringify)(E) : E;
  }
  v1ToV6.default = c;
  function y(t) {
    return Uint8Array.of((t[6] & 15) << 4 | t[7] >> 4 & 15, (t[7] & 15) << 4 | (t[4] & 240) >> 4, (t[4] & 15) << 4 | (t[5] & 240) >> 4, (t[5] & 15) << 4 | (t[0] & 240) >> 4, (t[0] & 15) << 4 | (t[1] & 240) >> 4, (t[1] & 15) << 4 | (t[2] & 240) >> 4, 96 | t[2] & 15, t[3], t[8], t[9], t[10], t[11], t[12], t[13], t[14], t[15]);
  }
  return v1ToV6;
}
var v3 = {}, md5$1 = {}, hasRequiredMd5;
function requireMd5() {
  if (hasRequiredMd5) return md5$1;
  hasRequiredMd5 = 1, Object.defineProperty(md5$1, "__esModule", { value: !0 });
  function o(M) {
    const U = t(M), L = y(U, M.length * 8);
    return g(L);
  }
  function g(M) {
    const U = new Uint8Array(M.length * 4);
    for (let L = 0; L < M.length * 4; L++)
      U[L] = M[L >> 2] >>> L % 4 * 8 & 255;
    return U;
  }
  function c(M) {
    return (M + 64 >>> 9 << 4) + 14 + 1;
  }
  function y(M, U) {
    const L = new Uint32Array(c(U)).fill(0);
    L.set(M), L[U >> 5] |= 128 << U % 32, L[L.length - 1] = U, M = L;
    let H = 1732584193, fe = -271733879, ge = -1732584194, Ie = 271733878;
    for (let Ee = 0; Ee < M.length; Ee += 16) {
      const Se = H, ze = fe, He = ge, Pe = Ie;
      H = D(H, fe, ge, Ie, M[Ee], 7, -680876936), Ie = D(Ie, H, fe, ge, M[Ee + 1], 12, -389564586), ge = D(ge, Ie, H, fe, M[Ee + 2], 17, 606105819), fe = D(fe, ge, Ie, H, M[Ee + 3], 22, -1044525330), H = D(H, fe, ge, Ie, M[Ee + 4], 7, -176418897), Ie = D(Ie, H, fe, ge, M[Ee + 5], 12, 1200080426), ge = D(ge, Ie, H, fe, M[Ee + 6], 17, -1473231341), fe = D(fe, ge, Ie, H, M[Ee + 7], 22, -45705983), H = D(H, fe, ge, Ie, M[Ee + 8], 7, 1770035416), Ie = D(Ie, H, fe, ge, M[Ee + 9], 12, -1958414417), ge = D(ge, Ie, H, fe, M[Ee + 10], 17, -42063), fe = D(fe, ge, Ie, H, M[Ee + 11], 22, -1990404162), H = D(H, fe, ge, Ie, M[Ee + 12], 7, 1804603682), Ie = D(Ie, H, fe, ge, M[Ee + 13], 12, -40341101), ge = D(ge, Ie, H, fe, M[Ee + 14], 17, -1502002290), fe = D(fe, ge, Ie, H, M[Ee + 15], 22, 1236535329), H = x(H, fe, ge, Ie, M[Ee + 1], 5, -165796510), Ie = x(Ie, H, fe, ge, M[Ee + 6], 9, -1069501632), ge = x(ge, Ie, H, fe, M[Ee + 11], 14, 643717713), fe = x(fe, ge, Ie, H, M[Ee], 20, -373897302), H = x(H, fe, ge, Ie, M[Ee + 5], 5, -701558691), Ie = x(Ie, H, fe, ge, M[Ee + 10], 9, 38016083), ge = x(ge, Ie, H, fe, M[Ee + 15], 14, -660478335), fe = x(fe, ge, Ie, H, M[Ee + 4], 20, -405537848), H = x(H, fe, ge, Ie, M[Ee + 9], 5, 568446438), Ie = x(Ie, H, fe, ge, M[Ee + 14], 9, -1019803690), ge = x(ge, Ie, H, fe, M[Ee + 3], 14, -187363961), fe = x(fe, ge, Ie, H, M[Ee + 8], 20, 1163531501), H = x(H, fe, ge, Ie, M[Ee + 13], 5, -1444681467), Ie = x(Ie, H, fe, ge, M[Ee + 2], 9, -51403784), ge = x(ge, Ie, H, fe, M[Ee + 7], 14, 1735328473), fe = x(fe, ge, Ie, H, M[Ee + 12], 20, -1926607734), H = v(H, fe, ge, Ie, M[Ee + 5], 4, -378558), Ie = v(Ie, H, fe, ge, M[Ee + 8], 11, -2022574463), ge = v(ge, Ie, H, fe, M[Ee + 11], 16, 1839030562), fe = v(fe, ge, Ie, H, M[Ee + 14], 23, -35309556), H = v(H, fe, ge, Ie, M[Ee + 1], 4, -1530992060), Ie = v(Ie, H, fe, ge, M[Ee + 4], 11, 1272893353), ge = v(ge, Ie, H, fe, M[Ee + 7], 16, -155497632), fe = v(fe, ge, Ie, H, M[Ee + 10], 23, -1094730640), H = v(H, fe, ge, Ie, M[Ee + 13], 4, 681279174), Ie = v(Ie, H, fe, ge, M[Ee], 11, -358537222), ge = v(ge, Ie, H, fe, M[Ee + 3], 16, -722521979), fe = v(fe, ge, Ie, H, M[Ee + 6], 23, 76029189), H = v(H, fe, ge, Ie, M[Ee + 9], 4, -640364487), Ie = v(Ie, H, fe, ge, M[Ee + 12], 11, -421815835), ge = v(ge, Ie, H, fe, M[Ee + 15], 16, 530742520), fe = v(fe, ge, Ie, H, M[Ee + 2], 23, -995338651), H = F(H, fe, ge, Ie, M[Ee], 6, -198630844), Ie = F(Ie, H, fe, ge, M[Ee + 7], 10, 1126891415), ge = F(ge, Ie, H, fe, M[Ee + 14], 15, -1416354905), fe = F(fe, ge, Ie, H, M[Ee + 5], 21, -57434055), H = F(H, fe, ge, Ie, M[Ee + 12], 6, 1700485571), Ie = F(Ie, H, fe, ge, M[Ee + 3], 10, -1894986606), ge = F(ge, Ie, H, fe, M[Ee + 10], 15, -1051523), fe = F(fe, ge, Ie, H, M[Ee + 1], 21, -2054922799), H = F(H, fe, ge, Ie, M[Ee + 8], 6, 1873313359), Ie = F(Ie, H, fe, ge, M[Ee + 15], 10, -30611744), ge = F(ge, Ie, H, fe, M[Ee + 6], 15, -1560198380), fe = F(fe, ge, Ie, H, M[Ee + 13], 21, 1309151649), H = F(H, fe, ge, Ie, M[Ee + 4], 6, -145523070), Ie = F(Ie, H, fe, ge, M[Ee + 11], 10, -1120210379), ge = F(ge, Ie, H, fe, M[Ee + 2], 15, 718787259), fe = F(fe, ge, Ie, H, M[Ee + 9], 21, -343485551), H = d(H, Se), fe = d(fe, ze), ge = d(ge, He), Ie = d(Ie, Pe);
    }
    return Uint32Array.of(H, fe, ge, Ie);
  }
  function t(M) {
    if (M.length === 0)
      return new Uint32Array();
    const U = new Uint32Array(c(M.length * 8)).fill(0);
    for (let L = 0; L < M.length; L++)
      U[L >> 2] |= (M[L] & 255) << L % 4 * 8;
    return U;
  }
  function d(M, U) {
    const L = (M & 65535) + (U & 65535);
    return (M >> 16) + (U >> 16) + (L >> 16) << 16 | L & 65535;
  }
  function E(M, U) {
    return M << U | M >>> 32 - U;
  }
  function B(M, U, L, H, fe, ge) {
    return d(E(d(d(U, M), d(H, ge)), fe), L);
  }
  function D(M, U, L, H, fe, ge, Ie) {
    return B(U & L | ~U & H, M, U, fe, ge, Ie);
  }
  function x(M, U, L, H, fe, ge, Ie) {
    return B(U & H | L & ~H, M, U, fe, ge, Ie);
  }
  function v(M, U, L, H, fe, ge, Ie) {
    return B(U ^ L ^ H, M, U, fe, ge, Ie);
  }
  function F(M, U, L, H, fe, ge, Ie) {
    return B(L ^ (U | ~H), M, U, fe, ge, Ie);
  }
  return md5$1.default = o, md5$1;
}
var v35 = {}, hasRequiredV35;
function requireV35() {
  if (hasRequiredV35) return v35;
  hasRequiredV35 = 1, Object.defineProperty(v35, "__esModule", { value: !0 }), v35.URL = v35.DNS = v35.stringToBytes = void 0;
  const o = requireParse$1(), g = requireStringify();
  function c(t) {
    t = unescape(encodeURIComponent(t));
    const d = new Uint8Array(t.length);
    for (let E = 0; E < t.length; ++E)
      d[E] = t.charCodeAt(E);
    return d;
  }
  v35.stringToBytes = c, v35.DNS = "6ba7b810-9dad-11d1-80b4-00c04fd430c8", v35.URL = "6ba7b811-9dad-11d1-80b4-00c04fd430c8";
  function y(t, d, E, B, D, x) {
    const v = typeof E == "string" ? c(E) : E, F = typeof B == "string" ? (0, o.default)(B) : B;
    if (typeof B == "string" && (B = (0, o.default)(B)), (B == null ? void 0 : B.length) !== 16)
      throw TypeError("Namespace must be array-like (16 iterable integer values, 0-255)");
    let M = new Uint8Array(16 + v.length);
    if (M.set(F), M.set(v, F.length), M = d(M), M[6] = M[6] & 15 | t, M[8] = M[8] & 63 | 128, D) {
      x = x || 0;
      for (let U = 0; U < 16; ++U)
        D[x + U] = M[U];
      return D;
    }
    return (0, g.unsafeStringify)(M);
  }
  return v35.default = y, v35;
}
var hasRequiredV3;
function requireV3() {
  return hasRequiredV3 || (hasRequiredV3 = 1, function(o) {
    Object.defineProperty(o, "__esModule", { value: !0 }), o.URL = o.DNS = void 0;
    const g = requireMd5(), c = requireV35();
    var y = requireV35();
    Object.defineProperty(o, "DNS", { enumerable: !0, get: function() {
      return y.DNS;
    } }), Object.defineProperty(o, "URL", { enumerable: !0, get: function() {
      return y.URL;
    } });
    function t(d, E, B, D) {
      return (0, c.default)(48, g.default, d, E, B, D);
    }
    t.DNS = c.DNS, t.URL = c.URL, o.default = t;
  }(v3)), v3;
}
var v4$1 = {}, native$1 = {}, hasRequiredNative;
function requireNative() {
  if (hasRequiredNative) return native$1;
  hasRequiredNative = 1, Object.defineProperty(native$1, "__esModule", { value: !0 });
  const o = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto);
  return native$1.default = { randomUUID: o }, native$1;
}
var hasRequiredV4;
function requireV4() {
  if (hasRequiredV4) return v4$1;
  hasRequiredV4 = 1, Object.defineProperty(v4$1, "__esModule", { value: !0 });
  const o = requireNative(), g = requireRng(), c = requireStringify();
  function y(t, d, E) {
    var D;
    if (o.default.randomUUID && !d && !t)
      return o.default.randomUUID();
    t = t || {};
    const B = t.random ?? ((D = t.rng) == null ? void 0 : D.call(t)) ?? (0, g.default)();
    if (B.length < 16)
      throw new Error("Random bytes length must be >= 16");
    if (B[6] = B[6] & 15 | 64, B[8] = B[8] & 63 | 128, d) {
      if (E = E || 0, E < 0 || E + 16 > d.length)
        throw new RangeError(`UUID byte range ${E}:${E + 15} is out of buffer bounds`);
      for (let x = 0; x < 16; ++x)
        d[E + x] = B[x];
      return d;
    }
    return (0, c.unsafeStringify)(B);
  }
  return v4$1.default = y, v4$1;
}
var v5 = {}, sha1$1 = {}, hasRequiredSha1;
function requireSha1() {
  if (hasRequiredSha1) return sha1$1;
  hasRequiredSha1 = 1, Object.defineProperty(sha1$1, "__esModule", { value: !0 });
  function o(y, t, d, E) {
    switch (y) {
      case 0:
        return t & d ^ ~t & E;
      case 1:
        return t ^ d ^ E;
      case 2:
        return t & d ^ t & E ^ d & E;
      case 3:
        return t ^ d ^ E;
    }
  }
  function g(y, t) {
    return y << t | y >>> 32 - t;
  }
  function c(y) {
    const t = [1518500249, 1859775393, 2400959708, 3395469782], d = [1732584193, 4023233417, 2562383102, 271733878, 3285377520], E = new Uint8Array(y.length + 1);
    E.set(y), E[y.length] = 128, y = E;
    const B = y.length / 4 + 2, D = Math.ceil(B / 16), x = new Array(D);
    for (let v = 0; v < D; ++v) {
      const F = new Uint32Array(16);
      for (let M = 0; M < 16; ++M)
        F[M] = y[v * 64 + M * 4] << 24 | y[v * 64 + M * 4 + 1] << 16 | y[v * 64 + M * 4 + 2] << 8 | y[v * 64 + M * 4 + 3];
      x[v] = F;
    }
    x[D - 1][14] = (y.length - 1) * 8 / Math.pow(2, 32), x[D - 1][14] = Math.floor(x[D - 1][14]), x[D - 1][15] = (y.length - 1) * 8 & 4294967295;
    for (let v = 0; v < D; ++v) {
      const F = new Uint32Array(80);
      for (let ge = 0; ge < 16; ++ge)
        F[ge] = x[v][ge];
      for (let ge = 16; ge < 80; ++ge)
        F[ge] = g(F[ge - 3] ^ F[ge - 8] ^ F[ge - 14] ^ F[ge - 16], 1);
      let M = d[0], U = d[1], L = d[2], H = d[3], fe = d[4];
      for (let ge = 0; ge < 80; ++ge) {
        const Ie = Math.floor(ge / 20), Ee = g(M, 5) + o(Ie, U, L, H) + fe + t[Ie] + F[ge] >>> 0;
        fe = H, H = L, L = g(U, 30) >>> 0, U = M, M = Ee;
      }
      d[0] = d[0] + M >>> 0, d[1] = d[1] + U >>> 0, d[2] = d[2] + L >>> 0, d[3] = d[3] + H >>> 0, d[4] = d[4] + fe >>> 0;
    }
    return Uint8Array.of(d[0] >> 24, d[0] >> 16, d[0] >> 8, d[0], d[1] >> 24, d[1] >> 16, d[1] >> 8, d[1], d[2] >> 24, d[2] >> 16, d[2] >> 8, d[2], d[3] >> 24, d[3] >> 16, d[3] >> 8, d[3], d[4] >> 24, d[4] >> 16, d[4] >> 8, d[4]);
  }
  return sha1$1.default = c, sha1$1;
}
var hasRequiredV5;
function requireV5() {
  return hasRequiredV5 || (hasRequiredV5 = 1, function(o) {
    Object.defineProperty(o, "__esModule", { value: !0 }), o.URL = o.DNS = void 0;
    const g = requireSha1(), c = requireV35();
    var y = requireV35();
    Object.defineProperty(o, "DNS", { enumerable: !0, get: function() {
      return y.DNS;
    } }), Object.defineProperty(o, "URL", { enumerable: !0, get: function() {
      return y.URL;
    } });
    function t(d, E, B, D) {
      return (0, c.default)(80, g.default, d, E, B, D);
    }
    t.DNS = c.DNS, t.URL = c.URL, o.default = t;
  }(v5)), v5;
}
var v6 = {}, hasRequiredV6;
function requireV6() {
  if (hasRequiredV6) return v6;
  hasRequiredV6 = 1, Object.defineProperty(v6, "__esModule", { value: !0 });
  const o = requireStringify(), g = requireV1(), c = requireV1ToV6();
  function y(t, d, E) {
    t ?? (t = {}), E ?? (E = 0);
    let B = (0, g.default)({ ...t, _v6: !0 }, new Uint8Array(16));
    if (B = (0, c.default)(B), d) {
      for (let D = 0; D < 16; D++)
        d[E + D] = B[D];
      return d;
    }
    return (0, o.unsafeStringify)(B);
  }
  return v6.default = y, v6;
}
var v6ToV1 = {}, hasRequiredV6ToV1;
function requireV6ToV1() {
  if (hasRequiredV6ToV1) return v6ToV1;
  hasRequiredV6ToV1 = 1, Object.defineProperty(v6ToV1, "__esModule", { value: !0 });
  const o = requireParse$1(), g = requireStringify();
  function c(t) {
    const d = typeof t == "string" ? (0, o.default)(t) : t, E = y(d);
    return typeof t == "string" ? (0, g.unsafeStringify)(E) : E;
  }
  v6ToV1.default = c;
  function y(t) {
    return Uint8Array.of((t[3] & 15) << 4 | t[4] >> 4 & 15, (t[4] & 15) << 4 | (t[5] & 240) >> 4, (t[5] & 15) << 4 | t[6] & 15, t[7], (t[1] & 15) << 4 | (t[2] & 240) >> 4, (t[2] & 15) << 4 | (t[3] & 240) >> 4, 16 | (t[0] & 240) >> 4, (t[0] & 15) << 4 | (t[1] & 240) >> 4, t[8], t[9], t[10], t[11], t[12], t[13], t[14], t[15]);
  }
  return v6ToV1;
}
var v7 = {}, hasRequiredV7;
function requireV7() {
  if (hasRequiredV7) return v7;
  hasRequiredV7 = 1, Object.defineProperty(v7, "__esModule", { value: !0 }), v7.updateV7State = void 0;
  const o = requireRng(), g = requireStringify(), c = {};
  function y(E, B, D) {
    var v;
    let x;
    if (E)
      x = d(E.random ?? ((v = E.rng) == null ? void 0 : v.call(E)) ?? (0, o.default)(), E.msecs, E.seq, B, D);
    else {
      const F = Date.now(), M = (0, o.default)();
      t(c, F, M), x = d(M, c.msecs, c.seq, B, D);
    }
    return B ?? (0, g.unsafeStringify)(x);
  }
  function t(E, B, D) {
    return E.msecs ?? (E.msecs = -1 / 0), E.seq ?? (E.seq = 0), B > E.msecs ? (E.seq = D[6] << 23 | D[7] << 16 | D[8] << 8 | D[9], E.msecs = B) : (E.seq = E.seq + 1 | 0, E.seq === 0 && E.msecs++), E;
  }
  v7.updateV7State = t;
  function d(E, B, D, x, v = 0) {
    if (E.length < 16)
      throw new Error("Random bytes length must be >= 16");
    if (!x)
      x = new Uint8Array(16), v = 0;
    else if (v < 0 || v + 16 > x.length)
      throw new RangeError(`UUID byte range ${v}:${v + 15} is out of buffer bounds`);
    return B ?? (B = Date.now()), D ?? (D = E[6] * 127 << 24 | E[7] << 16 | E[8] << 8 | E[9]), x[v++] = B / 1099511627776 & 255, x[v++] = B / 4294967296 & 255, x[v++] = B / 16777216 & 255, x[v++] = B / 65536 & 255, x[v++] = B / 256 & 255, x[v++] = B & 255, x[v++] = 112 | D >>> 28 & 15, x[v++] = D >>> 20 & 255, x[v++] = 128 | D >>> 14 & 63, x[v++] = D >>> 6 & 255, x[v++] = D << 2 & 255 | E[10] & 3, x[v++] = E[11], x[v++] = E[12], x[v++] = E[13], x[v++] = E[14], x[v++] = E[15], x;
  }
  return v7.default = y, v7;
}
var version = {}, hasRequiredVersion;
function requireVersion() {
  if (hasRequiredVersion) return version;
  hasRequiredVersion = 1, Object.defineProperty(version, "__esModule", { value: !0 });
  const o = requireValidate();
  function g(c) {
    if (!(0, o.default)(c))
      throw TypeError("Invalid UUID");
    return parseInt(c.slice(14, 15), 16);
  }
  return version.default = g, version;
}
var hasRequiredCjsBrowser;
function requireCjsBrowser() {
  return hasRequiredCjsBrowser || (hasRequiredCjsBrowser = 1, function(o) {
    Object.defineProperty(o, "__esModule", { value: !0 }), o.version = o.validate = o.v7 = o.v6ToV1 = o.v6 = o.v5 = o.v4 = o.v3 = o.v1ToV6 = o.v1 = o.stringify = o.parse = o.NIL = o.MAX = void 0;
    var g = requireMax();
    Object.defineProperty(o, "MAX", { enumerable: !0, get: function() {
      return g.default;
    } });
    var c = requireNil();
    Object.defineProperty(o, "NIL", { enumerable: !0, get: function() {
      return c.default;
    } });
    var y = requireParse$1();
    Object.defineProperty(o, "parse", { enumerable: !0, get: function() {
      return y.default;
    } });
    var t = requireStringify();
    Object.defineProperty(o, "stringify", { enumerable: !0, get: function() {
      return t.default;
    } });
    var d = requireV1();
    Object.defineProperty(o, "v1", { enumerable: !0, get: function() {
      return d.default;
    } });
    var E = requireV1ToV6();
    Object.defineProperty(o, "v1ToV6", { enumerable: !0, get: function() {
      return E.default;
    } });
    var B = requireV3();
    Object.defineProperty(o, "v3", { enumerable: !0, get: function() {
      return B.default;
    } });
    var D = requireV4();
    Object.defineProperty(o, "v4", { enumerable: !0, get: function() {
      return D.default;
    } });
    var x = requireV5();
    Object.defineProperty(o, "v5", { enumerable: !0, get: function() {
      return x.default;
    } });
    var v = requireV6();
    Object.defineProperty(o, "v6", { enumerable: !0, get: function() {
      return v.default;
    } });
    var F = requireV6ToV1();
    Object.defineProperty(o, "v6ToV1", { enumerable: !0, get: function() {
      return F.default;
    } });
    var M = requireV7();
    Object.defineProperty(o, "v7", { enumerable: !0, get: function() {
      return M.default;
    } });
    var U = requireValidate();
    Object.defineProperty(o, "validate", { enumerable: !0, get: function() {
      return U.default;
    } });
    var L = requireVersion();
    Object.defineProperty(o, "version", { enumerable: !0, get: function() {
      return L.default;
    } });
  }(cjsBrowser)), cjsBrowser;
}
var hasRequiredKeplr;
function requireKeplr() {
  if (hasRequiredKeplr) return keplr$1;
  hasRequiredKeplr = 1;
  var o = keplr$1 && keplr$1.__awaiter || function(ge, Ie, Ee, Se) {
    function ze(He) {
      return He instanceof Ee ? He : new Ee(function(Pe) {
        Pe(He);
      });
    }
    return new (Ee || (Ee = Promise))(function(He, Pe) {
      function De(be) {
        try {
          Fe(Se.next(be));
        } catch (Be) {
          Pe(Be);
        }
      }
      function ve(be) {
        try {
          Fe(Se.throw(be));
        } catch (Be) {
          Pe(Be);
        }
      }
      function Fe(be) {
        be.done ? He(be.value) : ze(be.value).then(De, ve);
      }
      Fe((Se = Se.apply(ge, Ie || [])).next());
    });
  }, g = keplr$1 && keplr$1.__importDefault || function(ge) {
    return ge && ge.__esModule ? ge : { default: ge };
  };
  Object.defineProperty(keplr$1, "__esModule", { value: !0 }), keplr$1.BitcoinProvider = keplr$1.Keplr = keplr$1.EthereumProviderRpcError = void 0;
  const c = requireBuild$6(), y = requireUint8Array(), t = g(requireCjs$2()), d = g(requireLong()), E = requireCosmjs(), B = requireEnigma(), D = requireVersion$1(), x = g(requireEvents()), v = requireConstants$1(), F = /* @__PURE__ */ requireCjsBrowser();
  class M extends Error {
    constructor(Ie, Ee, Se) {
      super(Ee), this.code = Ie, this.data = Se, Object.setPrototypeOf(this, M.prototype);
    }
  }
  keplr$1.EthereumProviderRpcError = M;
  class U {
    constructor() {
      this.enigmaUtils = /* @__PURE__ */ new Map(), this.version = D.BUILD_VERSION, this.mode = "extension", this.defaultOptions = {}, this.ethereum = new H(this), this.starknet = void 0, this.bitcoin = new fe(this);
    }
    static staticRequestMethod(Ie, Ee) {
      const Se = "ReactNativeWebView" in window, ze = Se ? (be) => {
        window.ReactNativeWebView.postMessage(JSON.stringify(be));
      } : (be) => {
        window.postMessage(be, window.location.origin);
      }, He = Se ? (be) => {
        if (be && typeof be == "string")
          try {
            return JSON.parse(be);
          } catch {
          }
        return be;
      } : (be) => be, Pe = new Uint8Array(8), De = Array.from(crypto.getRandomValues(Pe)).map((be) => be.toString(16)).join(""), Fe = {
        type: window.keplrRequestMetaIdSupport ? `proxy-request${v.metaId ? `-${v.metaId}` : ""}` : "proxy-request",
        id: De,
        method: Ie,
        args: y.JSONUint8Array.wrap(Ee)
      };
      return new Promise((be, Be) => {
        const ke = (xe) => {
          const Ne = He(xe.data);
          if (!Ne || Ne.type !== "proxy-request-response" || Ne.id !== De)
            return;
          window.removeEventListener("message", ke);
          const Et = y.JSONUint8Array.unwrap(Ne.result);
          if (!Et) {
            Be(new Error("Result is null"));
            return;
          }
          if (Et.error) {
            Be(new Error(Et.error));
            return;
          }
          be(Et.return);
        };
        window.addEventListener("message", ke), ze(Fe);
      });
    }
    requestMethod(Ie, Ee) {
      return U.staticRequestMethod(Ie, Ee);
    }
    static getKeplr(Ie = 1500) {
      return o(this, void 0, void 0, function* () {
        yield L();
        const Ee = "ReactNativeWebView" in window, Se = typeof navigator < "u" && "userAgent" in navigator ? navigator.userAgent.includes("Firefox") : !1;
        if (!(!Ee && !Se && window.keplrRequestMetaIdSupport == null))
          return new Promise((ze, He) => {
            const Pe = setTimeout(() => {
              ze(void 0);
            }, Ie);
            U.staticRequestMethod("ping", []).then(() => {
              clearTimeout(Pe), ze(new U());
            }).catch((De) => {
              var ve;
              !((ve = De == null ? void 0 : De.message) === null || ve === void 0) && ve.includes("Invalid method: ping") ? (clearTimeout(Pe), ze(new U())) : He(De);
            });
          });
      });
    }
    ping() {
      return o(this, void 0, void 0, function* () {
        yield this.requestMethod("ping", []);
      });
    }
    enable(Ie) {
      return o(this, void 0, void 0, function* () {
        yield this.requestMethod("enable", [Ie]);
      });
    }
    disable(Ie) {
      return o(this, void 0, void 0, function* () {
        yield this.requestMethod("disable", [Ie]);
      });
    }
    experimentalSuggestChain(Ie) {
      var Ee, Se;
      return o(this, void 0, void 0, function* () {
        if (Ie.hideInUI)
          throw new Error("hideInUI is not allowed");
        (!((Ee = Ie.features) === null || Ee === void 0) && Ee.includes("stargate") || !((Se = Ie.features) === null || Se === void 0) && Se.includes("no-legacy-stdTx")) && console.warn("“stargate”, “no-legacy-stdTx” feature has been deprecated. The launchpad is no longer supported, thus works without the two features. We would keep the aforementioned two feature for a while, but the upcoming update would potentially cause errors. Remove the two feature."), yield this.requestMethod("experimentalSuggestChain", [Ie]);
      });
    }
    getKey(Ie) {
      return o(this, void 0, void 0, function* () {
        return yield this.requestMethod("getKey", [Ie]);
      });
    }
    getKeysSettled(Ie) {
      return o(this, void 0, void 0, function* () {
        return yield this.requestMethod("getKeysSettled", [Ie]);
      });
    }
    sendTx(Ie, Ee, Se) {
      return o(this, void 0, void 0, function* () {
        return "length" in Ee || console.warn("Do not send legacy std tx via `sendTx` API. We now only support protobuf tx. The usage of legeacy std tx would throw an error in the near future."), yield this.requestMethod("sendTx", [Ie, Ee, Se]);
      });
    }
    signAmino(Ie, Ee, Se, ze = {}) {
      var He;
      return o(this, void 0, void 0, function* () {
        return yield this.requestMethod("signAmino", [
          Ie,
          Ee,
          Se,
          (0, t.default)((He = this.defaultOptions.sign) !== null && He !== void 0 ? He : {}, ze)
        ]);
      });
    }
    signDirect(Ie, Ee, Se, ze = {}) {
      var He;
      return o(this, void 0, void 0, function* () {
        const Pe = yield this.requestMethod("signDirect", [
          Ie,
          Ee,
          // We can't send the `Long` with remaing the type.
          // Receiver should change the `string` to `Long`.
          {
            bodyBytes: Se.bodyBytes,
            authInfoBytes: Se.authInfoBytes,
            chainId: Se.chainId,
            accountNumber: Se.accountNumber ? Se.accountNumber.toString() : null
          },
          (0, t.default)((He = this.defaultOptions.sign) !== null && He !== void 0 ? He : {}, ze)
        ]), De = Pe.signed;
        return {
          signed: {
            bodyBytes: De.bodyBytes,
            authInfoBytes: De.authInfoBytes,
            chainId: De.chainId,
            // We can't send the `Long` with remaing the type.
            // Sender should change the `Long` to `string`.
            accountNumber: d.default.fromString(De.accountNumber)
          },
          signature: Pe.signature
        };
      });
    }
    signDirectAux(Ie, Ee, Se, ze = {}) {
      var He;
      return o(this, void 0, void 0, function* () {
        const Pe = yield this.requestMethod("signDirectAux", [
          Ie,
          Ee,
          // We can't send the `Long` with remaing the type.
          // Receiver should change the `string` to `Long`.
          {
            bodyBytes: Se.bodyBytes,
            publicKey: Se.publicKey,
            chainId: Se.chainId,
            accountNumber: Se.accountNumber ? Se.accountNumber.toString() : null,
            sequence: Se.sequence ? Se.sequence.toString() : null
          },
          (0, t.default)({
            preferNoSetMemo: (He = this.defaultOptions.sign) === null || He === void 0 ? void 0 : He.preferNoSetMemo
          }, ze)
        ]), De = Pe.signed;
        return {
          signed: {
            bodyBytes: De.bodyBytes,
            publicKey: De.publicKey || void 0,
            chainId: De.chainId,
            // We can't send the `Long` with remaing the type.
            // Sender should change the `Long` to `string`.
            accountNumber: d.default.fromString(De.accountNumber),
            sequence: d.default.fromString(De.sequence)
          },
          signature: Pe.signature
        };
      });
    }
    signArbitrary(Ie, Ee, Se) {
      return o(this, void 0, void 0, function* () {
        return yield this.requestMethod("signArbitrary", [Ie, Ee, Se]);
      });
    }
    signICNSAdr36(Ie, Ee, Se, ze, He) {
      return this.requestMethod("signICNSAdr36", [
        Ie,
        Ee,
        Se,
        ze,
        He
      ]);
    }
    verifyArbitrary(Ie, Ee, Se, ze) {
      return o(this, void 0, void 0, function* () {
        return yield this.requestMethod("verifyArbitrary", [
          Ie,
          Ee,
          Se,
          ze
        ]);
      });
    }
    signEthereum(Ie, Ee, Se, ze) {
      return o(this, void 0, void 0, function* () {
        return yield this.requestMethod("signEthereum", [
          Ie,
          Ee,
          Se,
          ze
        ]);
      });
    }
    getOfflineSigner(Ie, Ee) {
      return new E.CosmJSOfflineSigner(Ie, this, Ee);
    }
    getOfflineSignerOnlyAmino(Ie, Ee) {
      return new E.CosmJSOfflineSignerOnlyAmino(Ie, this, Ee);
    }
    getOfflineSignerAuto(Ie, Ee) {
      return o(this, void 0, void 0, function* () {
        return (yield this.getKey(Ie)).isNanoLedger ? new E.CosmJSOfflineSignerOnlyAmino(Ie, this, Ee) : new E.CosmJSOfflineSigner(Ie, this, Ee);
      });
    }
    suggestToken(Ie, Ee, Se) {
      return o(this, void 0, void 0, function* () {
        return yield this.requestMethod("suggestToken", [
          Ie,
          Ee,
          Se
        ]);
      });
    }
    getSecret20ViewingKey(Ie, Ee) {
      return o(this, void 0, void 0, function* () {
        return yield this.requestMethod("getSecret20ViewingKey", [
          Ie,
          Ee
        ]);
      });
    }
    getEnigmaPubKey(Ie) {
      return o(this, void 0, void 0, function* () {
        return yield this.requestMethod("getEnigmaPubKey", [Ie]);
      });
    }
    getEnigmaTxEncryptionKey(Ie, Ee) {
      return o(this, void 0, void 0, function* () {
        return yield this.requestMethod("getEnigmaTxEncryptionKey", [
          Ie,
          Ee
        ]);
      });
    }
    enigmaEncrypt(Ie, Ee, Se) {
      return o(this, void 0, void 0, function* () {
        return yield this.requestMethod("enigmaEncrypt", [
          Ie,
          Ee,
          Se
        ]);
      });
    }
    enigmaDecrypt(Ie, Ee, Se) {
      return o(this, void 0, void 0, function* () {
        return yield this.requestMethod("enigmaDecrypt", [
          Ie,
          Ee,
          Se
        ]);
      });
    }
    getEnigmaUtils(Ie) {
      if (this.enigmaUtils.has(Ie))
        return this.enigmaUtils.get(Ie);
      const Ee = new B.KeplrEnigmaUtils(Ie, this);
      return this.enigmaUtils.set(Ie, Ee), Ee;
    }
    experimentalSignEIP712CosmosTx_v0(Ie, Ee, Se, ze, He = {}) {
      var Pe;
      return o(this, void 0, void 0, function* () {
        return yield this.requestMethod("experimentalSignEIP712CosmosTx_v0", [
          Ie,
          Ee,
          Se,
          ze,
          (0, t.default)((Pe = this.defaultOptions.sign) !== null && Pe !== void 0 ? Pe : {}, He)
        ]);
      });
    }
    getChainInfosWithoutEndpoints() {
      return o(this, void 0, void 0, function* () {
        return yield this.requestMethod("getChainInfosWithoutEndpoints", []);
      });
    }
    changeKeyRingName({ defaultName: Ie, editable: Ee = !0 }) {
      return o(this, void 0, void 0, function* () {
        return yield this.requestMethod("changeKeyRingName", [
          { defaultName: Ie, editable: Ee }
        ]);
      });
    }
    sendEthereumTx(Ie, Ee) {
      return o(this, void 0, void 0, function* () {
        return yield this.requestMethod("sendEthereumTx", [Ie, Ee]);
      });
    }
    suggestERC20(Ie, Ee) {
      return o(this, void 0, void 0, function* () {
        return yield this.requestMethod("suggestERC20", [Ie, Ee]);
      });
    }
    getChainInfoWithoutEndpoints(Ie) {
      return o(this, void 0, void 0, function* () {
        return yield this.requestMethod("getChainInfoWithoutEndpoints", [Ie]);
      });
    }
    getStarknetKey(Ie) {
      return o(this, void 0, void 0, function* () {
        return yield this.requestMethod("getStarknetKey", [Ie]);
      });
    }
    getStarknetKeysSettled(Ie) {
      return o(this, void 0, void 0, function* () {
        return yield this.requestMethod("getStarknetKeysSettled", [Ie]);
      });
    }
    signStarknetTx(Ie, Ee, Se) {
      return o(this, void 0, void 0, function* () {
        return yield this.requestMethod("signStarknetTx", [
          Ie,
          Ee,
          Se
        ]);
      });
    }
    signStarknetDeployAccountTransaction(Ie, Ee) {
      return o(this, void 0, void 0, function* () {
        return yield this.requestMethod("signStarknetDeployAccountTransaction", [
          Ie,
          Ee
        ]);
      });
    }
    getBitcoinKey(Ie) {
      return o(this, void 0, void 0, function* () {
        return yield this.requestMethod("getBitcoinKey", [Ie]);
      });
    }
    getBitcoinKeysSettled(Ie) {
      return o(this, void 0, void 0, function* () {
        return yield this.requestMethod("getBitcoinKeysSettled", [Ie]);
      });
    }
    signPsbt(Ie, Ee, Se) {
      return o(this, void 0, void 0, function* () {
        return yield this.requestMethod("signPsbt", [Ie, Ee, Se]);
      });
    }
    signPsbts(Ie, Ee, Se) {
      return o(this, void 0, void 0, function* () {
        return yield this.requestMethod("signPsbts", [
          Ie,
          Ee,
          Se
        ]);
      });
    }
    __core__getAnalyticsId() {
      return o(this, void 0, void 0, function* () {
        return yield this.requestMethod("__core__getAnalyticsId", []);
      });
    }
    __core__privilageSignAminoWithdrawRewards(Ie, Ee, Se) {
      return o(this, void 0, void 0, function* () {
        return yield this.requestMethod("__core__privilageSignAminoWithdrawRewards", [Ie, Ee, Se]);
      });
    }
    __core__privilageSignAminoDelegate(Ie, Ee, Se) {
      return o(this, void 0, void 0, function* () {
        return yield this.requestMethod("__core__privilageSignAminoDelegate", [Ie, Ee, Se]);
      });
    }
    __core__privilageSignAminoExecuteCosmWasm(Ie, Ee, Se) {
      return o(this, void 0, void 0, function* () {
        return yield this.requestMethod("__core__privilageSignAminoExecuteCosmWasm", [Ie, Ee, Se]);
      });
    }
    __core__webpageClosed() {
      return o(this, void 0, void 0, function* () {
        return yield this.requestMethod("__core__webpageClosed", []);
      });
    }
  }
  keplr$1.Keplr = U;
  const L = () => document.readyState === "complete" ? Promise.resolve() : new Promise((ge) => {
    const Ie = (Ee) => {
      Ee.target && Ee.target.readyState === "complete" && (ge(), document.removeEventListener("readystatechange", Ie));
    };
    document.addEventListener("readystatechange", Ie);
  });
  class H extends x.default {
    constructor(Ie) {
      if (super(), this.keplr = Ie, this.eip6963ProviderInfo = {
        uuid: (0, F.v4)(),
        name: "Keplr",
        rdns: "app.keplr",
        icon: `data:image/png;base64,${v.KeplrLogoBase64}`
      }, this.chainId = null, this.networkVersion = null, this.selectedAddress = null, this.isKeplr = !0, this.isMetaMask = !0, this._isConnected = !1, this._currentChainId = null, window.addEventListener("keplr_keystorechange", () => o(this, void 0, void 0, function* () {
        if (this._currentChainId && (yield Ie.getChainInfoWithoutEndpoints(this._currentChainId))) {
          const Se = (yield Ie.getKey(this._currentChainId)).ethereumHexAddress;
          this.handleAccountsChanged(Se);
        }
      })), window.addEventListener("keplr_chainChanged", (Ee) => {
        if (Ee.detail.origin === window.location.origin) {
          const ze = Ee.detail.evmChainId;
          this.handleChainChanged(ze);
        }
      }), window.addEventListener("keplr_ethSubscription", (Ee) => {
        var Se;
        const ze = Ee.detail.origin, He = Ee.detail.providerId;
        if (ze === window.location.origin && He === ((Se = this.eip6963ProviderInfo) === null || Se === void 0 ? void 0 : Se.uuid)) {
          const Pe = Ee.detail.data;
          this.emit("message", {
            type: "eth_subscription",
            data: Pe
          });
        }
      }), this.eip6963ProviderInfo) {
        const Ee = new CustomEvent(c.EIP6963EventNames.Announce, {
          detail: Object.freeze({
            info: this.eip6963ProviderInfo,
            provider: this
          })
        });
        window.addEventListener(c.EIP6963EventNames.Request, () => window.dispatchEvent(Ee)), window.dispatchEvent(Ee);
      }
    }
    static requestMethod(Ie, Ee) {
      return o(this, void 0, void 0, function* () {
        const Se = "ReactNativeWebView" in window, ze = Se ? (be) => {
          window.ReactNativeWebView.postMessage(JSON.stringify(be));
        } : (be) => {
          window.postMessage(be, window.location.origin);
        }, He = Se ? (be) => {
          if (be && typeof be == "string")
            try {
              return JSON.parse(be);
            } catch {
            }
          return be;
        } : (be) => be, Pe = new Uint8Array(8), De = Array.from(crypto.getRandomValues(Pe)).map((be) => be.toString(16)).join(""), Fe = {
          type: window.keplrRequestMetaIdSupport ? `proxy-request${v.metaId ? `-${v.metaId}` : ""}` : "proxy-request",
          id: De,
          method: "ethereum",
          args: y.JSONUint8Array.wrap(Ee),
          ethereumProviderMethod: Ie
        };
        return new Promise((be, Be) => {
          const ke = (xe) => {
            const Ne = He(xe.data);
            if (!Ne || Ne.type !== "proxy-request-response" || Ne.id !== De)
              return;
            window.removeEventListener("message", ke);
            const Et = y.JSONUint8Array.unwrap(Ne.result);
            if (!Et) {
              Be(new Error("Result is null"));
              return;
            }
            if (Et.error) {
              const st = Et.error;
              Be(st.code && !st.module ? new M(st.code, st.message, st.data) : new Error(st));
              return;
            }
            be(Et.return);
          };
          window.addEventListener("message", ke), ze(Fe);
        });
      });
    }
    handleConnect(Ie) {
      return o(this, void 0, void 0, function* () {
        if (!this._isConnected) {
          const { currentEvmChainId: Ee, currentChainId: Se, selectedAddress: ze } = yield H.requestMethod("request", Object.assign({ method: "keplr_connect" }, Ie && { params: [Ie] }));
          this._isConnected = !0, this._currentChainId = Se, this.chainId = `0x${Ee.toString(16)}`, this.networkVersion = Ee.toString(10), this.selectedAddress = ze, this.emit("connect", { chainId: this.chainId });
        }
      });
    }
    handleDisconnect() {
      return o(this, void 0, void 0, function* () {
        this._isConnected && (yield H.requestMethod("request", {
          method: "keplr_disconnect"
        }), this._isConnected = !1, this.chainId = null, this.selectedAddress = null, this.networkVersion = null, this.emit("disconnect"));
      });
    }
    handleChainChanged(Ie) {
      return o(this, void 0, void 0, function* () {
        yield this.handleConnect(Ie);
        const Ee = `0x${Ie.toString(16)}`;
        this.emit("chainChanged", Ee);
      });
    }
    handleAccountsChanged(Ie) {
      return o(this, void 0, void 0, function* () {
        this._isConnected && (this.selectedAddress = Ie, this.emit("accountsChanged", [Ie]));
      });
    }
    isConnected() {
      return this._isConnected;
    }
    request({ method: Ie, params: Ee, chainId: Se }) {
      var ze;
      return o(this, void 0, void 0, function* () {
        if (!this._isConnected) {
          if (Ie === "eth_accounts")
            return [];
          yield this.handleConnect();
        }
        return yield H.requestMethod("request", {
          method: Ie,
          params: Ee,
          providerId: (ze = this.eip6963ProviderInfo) === null || ze === void 0 ? void 0 : ze.uuid,
          chainId: Se
        });
      });
    }
    enable() {
      return o(this, void 0, void 0, function* () {
        return yield H.requestMethod("request", {
          method: "eth_requestAccounts"
        });
      });
    }
    net_version() {
      return o(this, void 0, void 0, function* () {
        return yield H.requestMethod("request", {
          method: "net_version"
        });
      });
    }
  }
  class fe extends x.default {
    constructor(Ie) {
      super(), this.keplr = Ie;
    }
    static _requestMethod(Ie, Ee) {
      return o(this, void 0, void 0, function* () {
        const Se = "ReactNativeWebView" in window, ze = Se ? (be) => {
          window.ReactNativeWebView.postMessage(JSON.stringify(be));
        } : (be) => {
          window.postMessage(be, window.location.origin);
        }, He = Se ? (be) => {
          if (be && typeof be == "string")
            try {
              return JSON.parse(be);
            } catch {
            }
          return be;
        } : (be) => be, Pe = new Uint8Array(8), De = Array.from(crypto.getRandomValues(Pe)).map((be) => be.toString(16)).join(""), Fe = {
          type: window.keplrRequestMetaIdSupport ? `proxy-request${v.metaId ? `-${v.metaId}` : ""}` : "proxy-request",
          id: De,
          method: "bitcoin",
          args: y.JSONUint8Array.wrap(Ee),
          bitcoinProviderMethod: Ie
        };
        return new Promise((be, Be) => {
          const ke = (xe) => {
            const Ne = He(xe.data);
            if (!Ne || Ne.type !== "proxy-request-response" || Ne.id !== De)
              return;
            window.removeEventListener("message", ke);
            const Et = y.JSONUint8Array.unwrap(Ne.result);
            if (!Et) {
              Be(new Error("Result is null"));
              return;
            }
            if (Et.error) {
              Be(new Error(Et.error));
              return;
            }
            be(Et.return);
          };
          window.addEventListener("message", ke), ze(Fe);
        });
      });
    }
    getAccounts() {
      return fe._requestMethod("getAccounts", []);
    }
    requestAccounts() {
      return o(this, void 0, void 0, function* () {
        return fe._requestMethod("requestAccounts", []);
      });
    }
    disconnect() {
      return o(this, void 0, void 0, function* () {
        return fe._requestMethod("disconnect", []);
      });
    }
    getNetwork() {
      return o(this, void 0, void 0, function* () {
        return fe._requestMethod("getNetwork", []);
      });
    }
    switchNetwork(Ie) {
      return o(this, void 0, void 0, function* () {
        return fe._requestMethod("switchNetwork", [Ie]);
      });
    }
    getChain() {
      return o(this, void 0, void 0, function* () {
        return fe._requestMethod("getChain", []);
      });
    }
    switchChain(Ie) {
      return o(this, void 0, void 0, function* () {
        return fe._requestMethod("switchChain", [Ie]);
      });
    }
    getPublicKey() {
      return o(this, void 0, void 0, function* () {
        return fe._requestMethod("getPublicKey", []);
      });
    }
    getBalance() {
      return o(this, void 0, void 0, function* () {
        return fe._requestMethod("getBalance", []);
      });
    }
    getInscriptions(Ie, Ee) {
      return o(this, void 0, void 0, function* () {
        return fe._requestMethod("getInscriptions", [Ie, Ee]);
      });
    }
    signMessage(Ie, Ee) {
      return o(this, void 0, void 0, function* () {
        return fe._requestMethod("signMessage", [Ie, Ee]);
      });
    }
    sendBitcoin(Ie, Ee) {
      return o(this, void 0, void 0, function* () {
        return fe._requestMethod("sendBitcoin", [Ie, Ee]);
      });
    }
    pushTx(Ie) {
      return o(this, void 0, void 0, function* () {
        return fe._requestMethod("pushTx", [Ie]);
      });
    }
    pushPsbt(Ie) {
      return o(this, void 0, void 0, function* () {
        return fe._requestMethod("pushPsbt", [Ie]);
      });
    }
    signPsbt(Ie, Ee) {
      return o(this, void 0, void 0, function* () {
        return fe._requestMethod("signPsbt", [Ie, Ee]);
      });
    }
    signPsbts(Ie, Ee) {
      return o(this, void 0, void 0, function* () {
        return fe._requestMethod("signPsbts", [Ie, Ee]);
      });
    }
    getAddress() {
      return o(this, void 0, void 0, function* () {
        return (yield this.getAccounts())[0];
      });
    }
    connectWallet() {
      return o(this, void 0, void 0, function* () {
        return this.requestAccounts();
      });
    }
  }
  return keplr$1.BitcoinProvider = fe, keplr$1;
}
var keplrFallback = {}, hasRequiredKeplrFallback;
function requireKeplrFallback() {
  if (hasRequiredKeplrFallback) return keplrFallback;
  hasRequiredKeplrFallback = 1;
  var o = keplrFallback && keplrFallback.__awaiter || function(y, t, d, E) {
    function B(D) {
      return D instanceof d ? D : new d(function(x) {
        x(D);
      });
    }
    return new (d || (d = Promise))(function(D, x) {
      function v(U) {
        try {
          M(E.next(U));
        } catch (L) {
          x(L);
        }
      }
      function F(U) {
        try {
          M(E.throw(U));
        } catch (L) {
          x(L);
        }
      }
      function M(U) {
        U.done ? D(U.value) : B(U.value).then(v, F);
      }
      M((E = E.apply(y, t || [])).next());
    });
  };
  Object.defineProperty(keplrFallback, "__esModule", { value: !0 }), keplrFallback.KeplrFallback = void 0;
  const g = requireKeplr();
  class c extends g.Keplr {
    constructor(t) {
      super(), this.onKeplrNotDetected = t, this.isKeplrDetected = null, this.onKeplrNotDetected && g.Keplr.getKeplr(500).then((d) => {
        var E;
        d || (E = this.onKeplrNotDetected) === null || E === void 0 || E.call(this);
      });
    }
    requestMethod(t, d) {
      return o(this, void 0, void 0, function* () {
        if (this.isKeplrDetected == null && ((yield g.Keplr.getKeplr(500)) ? this.isKeplrDetected = !0 : this.isKeplrDetected = !1), this.isKeplrDetected)
          return g.Keplr.staticRequestMethod(t, d);
        {
          const E = window.keplr;
          if (E)
            return E[t](...d);
          throw new Error("Can't detect keplr fallback");
        }
      });
    }
  }
  return keplrFallback.KeplrFallback = c, keplrFallback;
}
var hasRequiredBuild$5;
function requireBuild$5() {
  return hasRequiredBuild$5 || (hasRequiredBuild$5 = 1, function(o) {
    var g = build$6 && build$6.__createBinding || (Object.create ? function(y, t, d, E) {
      E === void 0 && (E = d);
      var B = Object.getOwnPropertyDescriptor(t, d);
      (!B || ("get" in B ? !t.__esModule : B.writable || B.configurable)) && (B = { enumerable: !0, get: function() {
        return t[d];
      } }), Object.defineProperty(y, E, B);
    } : function(y, t, d, E) {
      E === void 0 && (E = d), y[E] = t[d];
    }), c = build$6 && build$6.__exportStar || function(y, t) {
      for (var d in y) d !== "default" && !Object.prototype.hasOwnProperty.call(t, d) && g(t, y, d);
    };
    Object.defineProperty(o, "__esModule", { value: !0 }), c(requireKeplr(), o), c(requireKeplrFallback(), o);
  }(build$6)), build$6;
}
var buildExports$1 = requireBuild$5(), lib$4 = {}, signer = {}, base64Url = {}, hasRequiredBase64Url;
function requireBase64Url() {
  if (hasRequiredBase64Url) return base64Url;
  hasRequiredBase64Url = 1, Object.defineProperty(base64Url, "__esModule", { value: !0 }), base64Url.decode = base64Url.encode = base64Url.unescape = base64Url.escape = base64Url.pad = void 0;
  const o = requireBase64Js();
  function g(E) {
    return `${E}${"=".repeat(4 - (E.length % 4 || 4))}`;
  }
  base64Url.pad = g;
  function c(E) {
    return E.replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
  }
  base64Url.escape = c;
  function y(E) {
    return g(E).replace(/-/g, "+").replace(/_/g, "/");
  }
  base64Url.unescape = y;
  function t(E) {
    return c((0, o.fromByteArray)(new TextEncoder().encode(E)));
  }
  base64Url.encode = t;
  function d(E) {
    return new TextDecoder().decode((0, o.toByteArray)(g(y(E))));
  }
  return base64Url.decode = d, base64Url;
}
var cryptoClients = {}, secp256k1$2 = {}, lib$3 = {}, hasRequiredLib$4;
function requireLib$4() {
  return hasRequiredLib$4 || (hasRequiredLib$4 = 1, function(o) {
    Object.defineProperty(o, "__esModule", { value: !0 }), o.utils = o.schnorr = o.verify = o.signSync = o.sign = o.getSharedSecret = o.recoverPublicKey = o.getPublicKey = o.hexToBytes = o.bytesToHex = o.Signature = o.Point = o.CURVE = void 0;
    const g = requireCryptoBrowserify(), c = BigInt(0), y = BigInt(1), t = BigInt(2), d = BigInt(3), E = BigInt(8), B = Object.freeze({
      a: c,
      b: BigInt(7),
      P: BigInt("0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f"),
      n: BigInt("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141"),
      h: y,
      Gx: BigInt("55066263022277343669578718895168534326250603453777594175500187360389116729240"),
      Gy: BigInt("32670510020758816978083085130507043184471273380659243275938904335757337482424"),
      beta: BigInt("0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee")
    });
    o.CURVE = B;
    const D = (Ai, ci) => (Ai + ci / t) / ci, x = {
      beta: BigInt("0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee"),
      splitScalar(Ai) {
        const { n: ci } = B, Si = BigInt("0x3086d221a7d46bcde86c90e49284eb15"), Ui = -y * BigInt("0xe4437ed6010e88286f547fa90abfe4c3"), _i = BigInt("0x114ca50f7a8e2f3f657c1108d9d44cfd8"), Tn = Si, Fn = BigInt("0x100000000000000000000000000000000"), ss = D(Tn * Ai, ci), rs = D(-Ui * Ai, ci);
        let is = Dr(Ai - ss * Si - rs * _i, ci), Pr = Dr(-ss * Ui - rs * Tn, ci);
        const as = is > Fn, Rs = Pr > Fn;
        if (as && (is = ci - is), Rs && (Pr = ci - Pr), is > Fn || Pr > Fn)
          throw new Error("splitScalarEndo: Endomorphism failed, k=" + Ai);
        return { k1neg: as, k1: is, k2neg: Rs, k2: Pr };
      }
    }, v = 32, F = 32, M = 32, U = v + 1, L = 2 * v + 1;
    function H(Ai) {
      const { a: ci, b: Si } = B, Ui = Dr(Ai * Ai), _i = Dr(Ui * Ai);
      return Dr(_i + ci * Ai + Si);
    }
    const fe = B.a === c;
    class ge extends Error {
      constructor(ci) {
        super(ci);
      }
    }
    function Ie(Ai) {
      if (!(Ai instanceof Ee))
        throw new TypeError("JacobianPoint expected");
    }
    class Ee {
      constructor(ci, Si, Ui) {
        this.x = ci, this.y = Si, this.z = Ui;
      }
      static fromAffine(ci) {
        if (!(ci instanceof He))
          throw new TypeError("JacobianPoint#fromAffine: expected Point");
        return ci.equals(He.ZERO) ? Ee.ZERO : new Ee(ci.x, ci.y, y);
      }
      static toAffineBatch(ci) {
        const Si = Ur(ci.map((Ui) => Ui.z));
        return ci.map((Ui, _i) => Ui.toAffine(Si[_i]));
      }
      static normalizeZ(ci) {
        return Ee.toAffineBatch(ci).map(Ee.fromAffine);
      }
      equals(ci) {
        Ie(ci);
        const { x: Si, y: Ui, z: _i } = this, { x: Tn, y: Fn, z: ss } = ci, rs = Dr(_i * _i), is = Dr(ss * ss), Pr = Dr(Si * is), as = Dr(Tn * rs), Rs = Dr(Dr(Ui * ss) * is), ri = Dr(Dr(Fn * _i) * rs);
        return Pr === as && Rs === ri;
      }
      negate() {
        return new Ee(this.x, Dr(-this.y), this.z);
      }
      double() {
        const { x: ci, y: Si, z: Ui } = this, _i = Dr(ci * ci), Tn = Dr(Si * Si), Fn = Dr(Tn * Tn), ss = ci + Tn, rs = Dr(t * (Dr(ss * ss) - _i - Fn)), is = Dr(d * _i), Pr = Dr(is * is), as = Dr(Pr - t * rs), Rs = Dr(is * (rs - as) - E * Fn), ri = Dr(t * Si * Ui);
        return new Ee(as, Rs, ri);
      }
      add(ci) {
        Ie(ci);
        const { x: Si, y: Ui, z: _i } = this, { x: Tn, y: Fn, z: ss } = ci;
        if (Tn === c || Fn === c)
          return this;
        if (Si === c || Ui === c)
          return ci;
        const rs = Dr(_i * _i), is = Dr(ss * ss), Pr = Dr(Si * is), as = Dr(Tn * rs), Rs = Dr(Dr(Ui * ss) * is), ri = Dr(Dr(Fn * _i) * rs), Tr = Dr(as - Pr), yi = Dr(ri - Rs);
        if (Tr === c)
          return yi === c ? this.double() : Ee.ZERO;
        const ki = Dr(Tr * Tr), qi = Dr(Tr * ki), C = Dr(Pr * ki), l = Dr(yi * yi - qi - t * C), w = Dr(yi * (C - l) - Rs * qi), n = Dr(_i * ss * Tr);
        return new Ee(l, w, n);
      }
      subtract(ci) {
        return this.add(ci.negate());
      }
      multiplyUnsafe(ci) {
        const Si = Ee.ZERO;
        if (typeof ci == "bigint" && ci === c)
          return Si;
        let Ui = Mr(ci);
        if (Ui === y)
          return this;
        if (!fe) {
          let as = Si, Rs = this;
          for (; Ui > c; )
            Ui & y && (as = as.add(Rs)), Rs = Rs.double(), Ui >>= y;
          return as;
        }
        let { k1neg: _i, k1: Tn, k2neg: Fn, k2: ss } = x.splitScalar(Ui), rs = Si, is = Si, Pr = this;
        for (; Tn > c || ss > c; )
          Tn & y && (rs = rs.add(Pr)), ss & y && (is = is.add(Pr)), Pr = Pr.double(), Tn >>= y, ss >>= y;
        return _i && (rs = rs.negate()), Fn && (is = is.negate()), is = new Ee(Dr(is.x * x.beta), is.y, is.z), rs.add(is);
      }
      precomputeWindow(ci) {
        const Si = fe ? 128 / ci + 1 : 256 / ci + 1, Ui = [];
        let _i = this, Tn = _i;
        for (let Fn = 0; Fn < Si; Fn++) {
          Tn = _i, Ui.push(Tn);
          for (let ss = 1; ss < 2 ** (ci - 1); ss++)
            Tn = Tn.add(_i), Ui.push(Tn);
          _i = Tn.double();
        }
        return Ui;
      }
      wNAF(ci, Si) {
        !Si && this.equals(Ee.BASE) && (Si = He.BASE);
        const Ui = Si && Si._WINDOW_SIZE || 1;
        if (256 % Ui)
          throw new Error("Point#wNAF: Invalid precomputation window, must be power of 2");
        let _i = Si && ze.get(Si);
        _i || (_i = this.precomputeWindow(Ui), Si && Ui !== 1 && (_i = Ee.normalizeZ(_i), ze.set(Si, _i)));
        let Tn = Ee.ZERO, Fn = Ee.BASE;
        const ss = 1 + (fe ? 128 / Ui : 256 / Ui), rs = 2 ** (Ui - 1), is = BigInt(2 ** Ui - 1), Pr = 2 ** Ui, as = BigInt(Ui);
        for (let Rs = 0; Rs < ss; Rs++) {
          const ri = Rs * rs;
          let Tr = Number(ci & is);
          ci >>= as, Tr > rs && (Tr -= Pr, ci += y);
          const yi = ri, ki = ri + Math.abs(Tr) - 1, qi = Rs % 2 !== 0, C = Tr < 0;
          Tr === 0 ? Fn = Fn.add(Se(qi, _i[yi])) : Tn = Tn.add(Se(C, _i[ki]));
        }
        return { p: Tn, f: Fn };
      }
      multiply(ci, Si) {
        let Ui = Mr(ci), _i, Tn;
        if (fe) {
          const { k1neg: Fn, k1: ss, k2neg: rs, k2: is } = x.splitScalar(Ui);
          let { p: Pr, f: as } = this.wNAF(ss, Si), { p: Rs, f: ri } = this.wNAF(is, Si);
          Pr = Se(Fn, Pr), Rs = Se(rs, Rs), Rs = new Ee(Dr(Rs.x * x.beta), Rs.y, Rs.z), _i = Pr.add(Rs), Tn = as.add(ri);
        } else {
          const { p: Fn, f: ss } = this.wNAF(Ui, Si);
          _i = Fn, Tn = ss;
        }
        return Ee.normalizeZ([_i, Tn])[0];
      }
      toAffine(ci) {
        const { x: Si, y: Ui, z: _i } = this, Tn = this.equals(Ee.ZERO);
        ci == null && (ci = Tn ? E : Vr(_i));
        const Fn = ci, ss = Dr(Fn * Fn), rs = Dr(ss * Fn), is = Dr(Si * ss), Pr = Dr(Ui * rs), as = Dr(_i * Fn);
        if (Tn)
          return He.ZERO;
        if (as !== y)
          throw new Error("invZ was invalid");
        return new He(is, Pr);
      }
    }
    Ee.BASE = new Ee(B.Gx, B.Gy, y), Ee.ZERO = new Ee(c, y, c);
    function Se(Ai, ci) {
      const Si = ci.negate();
      return Ai ? Si : ci;
    }
    const ze = /* @__PURE__ */ new WeakMap();
    class He {
      constructor(ci, Si) {
        this.x = ci, this.y = Si;
      }
      _setWindowSize(ci) {
        this._WINDOW_SIZE = ci, ze.delete(this);
      }
      hasEvenY() {
        return this.y % t === c;
      }
      static fromCompressedHex(ci) {
        const Si = ci.length === 32, Ui = wr(Si ? ci : ci.subarray(1));
        if (!hr(Ui))
          throw new Error("Point is not on curve");
        const _i = H(Ui);
        let Tn = Xr(_i);
        const Fn = (Tn & y) === y;
        Si ? Fn && (Tn = Dr(-Tn)) : (ci[0] & 1) === 1 !== Fn && (Tn = Dr(-Tn));
        const ss = new He(Ui, Tn);
        return ss.assertValidity(), ss;
      }
      static fromUncompressedHex(ci) {
        const Si = wr(ci.subarray(1, v + 1)), Ui = wr(ci.subarray(v + 1, v * 2 + 1)), _i = new He(Si, Ui);
        return _i.assertValidity(), _i;
      }
      static fromHex(ci) {
        const Si = qr(ci), Ui = Si.length, _i = Si[0];
        if (Ui === v)
          return this.fromCompressedHex(Si);
        if (Ui === U && (_i === 2 || _i === 3))
          return this.fromCompressedHex(Si);
        if (Ui === L && _i === 4)
          return this.fromUncompressedHex(Si);
        throw new Error(`Point.fromHex: received invalid point. Expected 32-${U} compressed bytes or ${L} uncompressed bytes, not ${Ui}`);
      }
      static fromPrivateKey(ci) {
        return He.BASE.multiply(fi(ci));
      }
      static fromSignature(ci, Si, Ui) {
        const { r: _i, s: Tn } = $r(Si);
        if (![0, 1, 2, 3].includes(Ui))
          throw new Error("Cannot recover: invalid recovery bit");
        const Fn = Gr(qr(ci)), { n: ss } = B, rs = Ui === 2 || Ui === 3 ? _i + ss : _i, is = Vr(rs, ss), Pr = Dr(-Fn * is, ss), as = Dr(Tn * is, ss), Rs = Ui & 1 ? "03" : "02", ri = He.fromHex(Rs + xt(rs)), Tr = He.BASE.multiplyAndAddUnsafe(ri, Pr, as);
        if (!Tr)
          throw new Error("Cannot recover signature: point at infinify");
        return Tr.assertValidity(), Tr;
      }
      toRawBytes(ci = !1) {
        return Dt(this.toHex(ci));
      }
      toHex(ci = !1) {
        const Si = xt(this.x);
        return ci ? `${this.hasEvenY() ? "02" : "03"}${Si}` : `04${Si}${xt(this.y)}`;
      }
      toHexX() {
        return this.toHex(!0).slice(2);
      }
      toRawX() {
        return this.toRawBytes(!0).slice(1);
      }
      assertValidity() {
        const ci = "Point is not on elliptic curve", { x: Si, y: Ui } = this;
        if (!hr(Si) || !hr(Ui))
          throw new Error(ci);
        const _i = Dr(Ui * Ui), Tn = H(Si);
        if (Dr(_i - Tn) !== c)
          throw new Error(ci);
      }
      equals(ci) {
        return this.x === ci.x && this.y === ci.y;
      }
      negate() {
        return new He(this.x, Dr(-this.y));
      }
      double() {
        return Ee.fromAffine(this).double().toAffine();
      }
      add(ci) {
        return Ee.fromAffine(this).add(Ee.fromAffine(ci)).toAffine();
      }
      subtract(ci) {
        return this.add(ci.negate());
      }
      multiply(ci) {
        return Ee.fromAffine(this).multiply(ci, this).toAffine();
      }
      multiplyAndAddUnsafe(ci, Si, Ui) {
        const _i = Ee.fromAffine(this), Tn = Si === c || Si === y || this !== He.BASE ? _i.multiplyUnsafe(Si) : _i.multiply(Si), Fn = Ee.fromAffine(ci).multiplyUnsafe(Ui), ss = Tn.add(Fn);
        return ss.equals(Ee.ZERO) ? void 0 : ss.toAffine();
      }
    }
    o.Point = He, He.BASE = new He(B.Gx, B.Gy), He.ZERO = new He(c, c);
    function Pe(Ai) {
      return Number.parseInt(Ai[0], 16) >= 8 ? "00" + Ai : Ai;
    }
    function De(Ai) {
      if (Ai.length < 2 || Ai[0] !== 2)
        throw new Error(`Invalid signature integer tag: ${Ne(Ai)}`);
      const ci = Ai[1], Si = Ai.subarray(2, ci + 2);
      if (!ci || Si.length !== ci)
        throw new Error("Invalid signature integer: wrong length");
      if (Si[0] === 0 && Si[1] <= 127)
        throw new Error("Invalid signature integer: trailing length");
      return { data: wr(Si), left: Ai.subarray(ci + 2) };
    }
    function ve(Ai) {
      if (Ai.length < 2 || Ai[0] != 48)
        throw new Error(`Invalid signature tag: ${Ne(Ai)}`);
      if (Ai[1] !== Ai.length - 2)
        throw new Error("Invalid signature: incorrect length");
      const { data: ci, left: Si } = De(Ai.subarray(2)), { data: Ui, left: _i } = De(Si);
      if (_i.length)
        throw new Error(`Invalid signature: left bytes after parsing: ${Ne(_i)}`);
      return { r: ci, s: Ui };
    }
    class Fe {
      constructor(ci, Si) {
        this.r = ci, this.s = Si, this.assertValidity();
      }
      static fromCompact(ci) {
        const Si = be(ci), Ui = "Signature.fromCompact";
        if (typeof ci != "string" && !Si)
          throw new TypeError(`${Ui}: Expected string or Uint8Array`);
        const _i = Si ? Ne(ci) : ci;
        if (_i.length !== 128)
          throw new Error(`${Ui}: Expected 64-byte hex`);
        return new Fe(yr(_i.slice(0, 64)), yr(_i.slice(64, 128)));
      }
      static fromDER(ci) {
        const Si = be(ci);
        if (typeof ci != "string" && !Si)
          throw new TypeError("Signature.fromDER: Expected string or Uint8Array");
        const { r: Ui, s: _i } = ve(Si ? ci : Dt(ci));
        return new Fe(Ui, _i);
      }
      static fromHex(ci) {
        return this.fromDER(ci);
      }
      assertValidity() {
        const { r: ci, s: Si } = this;
        if (!cr(ci))
          throw new Error("Invalid Signature: r must be 0 < r < n");
        if (!cr(Si))
          throw new Error("Invalid Signature: s must be 0 < s < n");
      }
      hasHighS() {
        const ci = B.n >> y;
        return this.s > ci;
      }
      normalizeS() {
        return this.hasHighS() ? new Fe(this.r, Dr(-this.s, B.n)) : this;
      }
      toDERRawBytes() {
        return Dt(this.toDERHex());
      }
      toDERHex() {
        const ci = Pe(sr(this.s)), Si = Pe(sr(this.r)), Ui = ci.length / 2, _i = Si.length / 2, Tn = sr(Ui), Fn = sr(_i);
        return `30${sr(_i + Ui + 4)}02${Fn}${Si}02${Tn}${ci}`;
      }
      toRawBytes() {
        return this.toDERRawBytes();
      }
      toHex() {
        return this.toDERHex();
      }
      toCompactRawBytes() {
        return Dt(this.toCompactHex());
      }
      toCompactHex() {
        return xt(this.r) + xt(this.s);
      }
    }
    o.Signature = Fe;
    function be(Ai) {
      return Ai instanceof Uint8Array || ArrayBuffer.isView(Ai) && Ai.constructor.name === "Uint8Array";
    }
    function Be(Ai) {
      if (!be(Ai))
        throw new Error("Uint8Array expected");
    }
    function ke(...Ai) {
      if (Ai.every(Be), Ai.length === 1)
        return Ai[0];
      const ci = Ai.reduce((Ui, _i) => Ui + _i.length, 0), Si = new Uint8Array(ci);
      for (let Ui = 0, _i = 0; Ui < Ai.length; Ui++) {
        const Tn = Ai[Ui];
        Si.set(Tn, _i), _i += Tn.length;
      }
      return Si;
    }
    const xe = Array.from({ length: 256 }, (Ai, ci) => ci.toString(16).padStart(2, "0"));
    function Ne(Ai) {
      Be(Ai);
      let ci = "";
      for (let Si = 0; Si < Ai.length; Si++)
        ci += xe[Ai[Si]];
      return ci;
    }
    o.bytesToHex = Ne;
    const Et = { _0: 48, _9: 57, A: 65, F: 70, a: 97, f: 102 };
    function st(Ai) {
      if (Ai >= Et._0 && Ai <= Et._9)
        return Ai - Et._0;
      if (Ai >= Et.A && Ai <= Et.F)
        return Ai - (Et.A - 10);
      if (Ai >= Et.a && Ai <= Et.f)
        return Ai - (Et.a - 10);
    }
    function Dt(Ai) {
      if (typeof Ai != "string")
        throw new Error("hex string expected, got " + typeof Ai);
      const ci = Ai.length, Si = ci / 2;
      if (ci % 2)
        throw new Error("hex string expected, got unpadded hex of length " + ci);
      const Ui = new Uint8Array(Si);
      for (let _i = 0, Tn = 0; _i < Si; _i++, Tn += 2) {
        const Fn = st(Ai.charCodeAt(Tn)), ss = st(Ai.charCodeAt(Tn + 1));
        if (Fn === void 0 || ss === void 0) {
          const rs = Ai[Tn] + Ai[Tn + 1];
          throw new Error('hex string expected, got non-hex character "' + rs + '" at index ' + Tn);
        }
        Ui[_i] = Fn * 16 + ss;
      }
      return Ui;
    }
    o.hexToBytes = Dt;
    const er = BigInt("0x10000000000000000000000000000000000000000000000000000000000000000");
    function xt(Ai) {
      if (typeof Ai != "bigint")
        throw new Error("Expected bigint");
      if (!(c <= Ai && Ai < er))
        throw new Error("Expected number 0 <= n < 2^256");
      return Ai.toString(16).padStart(64, "0");
    }
    function ir(Ai) {
      const ci = Dt(xt(Ai));
      if (ci.length !== 32)
        throw new Error("Error: expected 32 bytes");
      return ci;
    }
    function sr(Ai) {
      const ci = Ai.toString(16);
      return ci.length & 1 ? `0${ci}` : ci;
    }
    function yr(Ai) {
      if (typeof Ai != "string")
        throw new TypeError("hexToNumber: expected string, got " + typeof Ai);
      return BigInt(`0x${Ai}`);
    }
    function wr(Ai) {
      return yr(Ne(Ai));
    }
    function qr(Ai) {
      return be(Ai) ? Uint8Array.from(Ai) : Dt(Ai);
    }
    function Mr(Ai) {
      if (typeof Ai == "number" && Number.isSafeInteger(Ai) && Ai > 0)
        return BigInt(Ai);
      if (typeof Ai == "bigint" && cr(Ai))
        return Ai;
      throw new TypeError("Expected valid private scalar: 0 < scalar < curve.n");
    }
    function Dr(Ai, ci = B.P) {
      const Si = Ai % ci;
      return Si >= c ? Si : ci + Si;
    }
    function Qr(Ai, ci) {
      const { P: Si } = B;
      let Ui = Ai;
      for (; ci-- > c; )
        Ui *= Ui, Ui %= Si;
      return Ui;
    }
    function Xr(Ai) {
      const { P: ci } = B, Si = BigInt(6), Ui = BigInt(11), _i = BigInt(22), Tn = BigInt(23), Fn = BigInt(44), ss = BigInt(88), rs = Ai * Ai * Ai % ci, is = rs * rs * Ai % ci, Pr = Qr(is, d) * is % ci, as = Qr(Pr, d) * is % ci, Rs = Qr(as, t) * rs % ci, ri = Qr(Rs, Ui) * Rs % ci, Tr = Qr(ri, _i) * ri % ci, yi = Qr(Tr, Fn) * Tr % ci, ki = Qr(yi, ss) * yi % ci, qi = Qr(ki, Fn) * Tr % ci, C = Qr(qi, d) * is % ci, l = Qr(C, Tn) * ri % ci, w = Qr(l, Si) * rs % ci, n = Qr(w, t);
      if (n * n % ci !== Ai)
        throw new Error("Cannot find square root");
      return n;
    }
    function Vr(Ai, ci = B.P) {
      if (Ai === c || ci <= c)
        throw new Error(`invert: expected positive integers, got n=${Ai} mod=${ci}`);
      let Si = Dr(Ai, ci), Ui = ci, _i = c, Tn = y;
      for (; Si !== c; ) {
        const ss = Ui / Si, rs = Ui % Si, is = _i - Tn * ss;
        Ui = Si, Si = rs, _i = Tn, Tn = is;
      }
      if (Ui !== y)
        throw new Error("invert: does not exist");
      return Dr(_i, ci);
    }
    function Ur(Ai, ci = B.P) {
      const Si = new Array(Ai.length), Ui = Ai.reduce((Tn, Fn, ss) => Fn === c ? Tn : (Si[ss] = Tn, Dr(Tn * Fn, ci)), y), _i = Vr(Ui, ci);
      return Ai.reduceRight((Tn, Fn, ss) => Fn === c ? Tn : (Si[ss] = Dr(Tn * Si[ss], ci), Dr(Tn * Fn, ci)), _i), Si;
    }
    function Sr(Ai) {
      const ci = Ai.length * 8 - F * 8, Si = wr(Ai);
      return ci > 0 ? Si >> BigInt(ci) : Si;
    }
    function Gr(Ai, ci = !1) {
      const Si = Sr(Ai);
      if (ci)
        return Si;
      const { n: Ui } = B;
      return Si >= Ui ? Si - Ui : Si;
    }
    let Fr, br;
    class Ar {
      constructor(ci, Si) {
        if (this.hashLen = ci, this.qByteLen = Si, typeof ci != "number" || ci < 2)
          throw new Error("hashLen must be a number");
        if (typeof Si != "number" || Si < 2)
          throw new Error("qByteLen must be a number");
        this.v = new Uint8Array(ci).fill(1), this.k = new Uint8Array(ci).fill(0), this.counter = 0;
      }
      hmac(...ci) {
        return o.utils.hmacSha256(this.k, ...ci);
      }
      hmacSync(...ci) {
        return br(this.k, ...ci);
      }
      checkSync() {
        if (typeof br != "function")
          throw new ge("hmacSha256Sync needs to be set");
      }
      incr() {
        if (this.counter >= 1e3)
          throw new Error("Tried 1,000 k values for sign(), all were invalid");
        this.counter += 1;
      }
      async reseed(ci = new Uint8Array()) {
        this.k = await this.hmac(this.v, Uint8Array.from([0]), ci), this.v = await this.hmac(this.v), ci.length !== 0 && (this.k = await this.hmac(this.v, Uint8Array.from([1]), ci), this.v = await this.hmac(this.v));
      }
      reseedSync(ci = new Uint8Array()) {
        this.checkSync(), this.k = this.hmacSync(this.v, Uint8Array.from([0]), ci), this.v = this.hmacSync(this.v), ci.length !== 0 && (this.k = this.hmacSync(this.v, Uint8Array.from([1]), ci), this.v = this.hmacSync(this.v));
      }
      async generate() {
        this.incr();
        let ci = 0;
        const Si = [];
        for (; ci < this.qByteLen; ) {
          this.v = await this.hmac(this.v);
          const Ui = this.v.slice();
          Si.push(Ui), ci += this.v.length;
        }
        return ke(...Si);
      }
      generateSync() {
        this.checkSync(), this.incr();
        let ci = 0;
        const Si = [];
        for (; ci < this.qByteLen; ) {
          this.v = this.hmacSync(this.v);
          const Ui = this.v.slice();
          Si.push(Ui), ci += this.v.length;
        }
        return ke(...Si);
      }
    }
    function cr(Ai) {
      return c < Ai && Ai < B.n;
    }
    function hr(Ai) {
      return c < Ai && Ai < B.P;
    }
    function Wr(Ai, ci, Si, Ui = !0) {
      const { n: _i } = B, Tn = Gr(Ai, !0);
      if (!cr(Tn))
        return;
      const Fn = Vr(Tn, _i), ss = He.BASE.multiply(Tn), rs = Dr(ss.x, _i);
      if (rs === c)
        return;
      const is = Dr(Fn * Dr(ci + Si * rs, _i), _i);
      if (is === c)
        return;
      let Pr = new Fe(rs, is), as = (ss.x === Pr.r ? 0 : 2) | Number(ss.y & y);
      return Ui && Pr.hasHighS() && (Pr = Pr.normalizeS(), as ^= 1), { sig: Pr, recovery: as };
    }
    function fi(Ai) {
      let ci;
      if (typeof Ai == "bigint")
        ci = Ai;
      else if (typeof Ai == "number" && Number.isSafeInteger(Ai) && Ai > 0)
        ci = BigInt(Ai);
      else if (typeof Ai == "string") {
        if (Ai.length !== 2 * F)
          throw new Error("Expected 32 bytes of private key");
        ci = yr(Ai);
      } else if (be(Ai)) {
        if (Ai.length !== F)
          throw new Error("Expected 32 bytes of private key");
        ci = wr(Ai);
      } else
        throw new TypeError("Expected valid private key");
      if (!cr(ci))
        throw new Error("Expected private key: 0 < key < n");
      return ci;
    }
    function Bi(Ai) {
      return Ai instanceof He ? (Ai.assertValidity(), Ai) : He.fromHex(Ai);
    }
    function $r(Ai) {
      if (Ai instanceof Fe)
        return Ai.assertValidity(), Ai;
      try {
        return Fe.fromDER(Ai);
      } catch {
        return Fe.fromCompact(Ai);
      }
    }
    function oi(Ai, ci = !1) {
      return He.fromPrivateKey(Ai).toRawBytes(ci);
    }
    o.getPublicKey = oi;
    function zr(Ai, ci, Si, Ui = !1) {
      return He.fromSignature(Ai, ci, Si).toRawBytes(Ui);
    }
    o.recoverPublicKey = zr;
    function ti(Ai) {
      const ci = be(Ai), Si = typeof Ai == "string", Ui = (ci || Si) && Ai.length;
      return ci ? Ui === U || Ui === L : Si ? Ui === U * 2 || Ui === L * 2 : Ai instanceof He;
    }
    function Lr(Ai, ci, Si = !1) {
      if (ti(Ai))
        throw new TypeError("getSharedSecret: first arg must be private key");
      if (!ti(ci))
        throw new TypeError("getSharedSecret: second arg must be public key");
      const Ui = Bi(ci);
      return Ui.assertValidity(), Ui.multiply(fi(Ai)).toRawBytes(Si);
    }
    o.getSharedSecret = Lr;
    function Rr(Ai) {
      const ci = Ai.length > v ? Ai.slice(0, v) : Ai;
      return wr(ci);
    }
    function Ir(Ai) {
      const ci = Rr(Ai), Si = Dr(ci, B.n);
      return pr(Si < c ? ci : Si);
    }
    function pr(Ai) {
      return ir(Ai);
    }
    function Cr(Ai, ci, Si) {
      if (Ai == null)
        throw new Error(`sign: expected valid message hash, not "${Ai}"`);
      const Ui = qr(Ai), _i = fi(ci), Tn = [pr(_i), Ir(Ui)];
      if (Si != null) {
        Si === !0 && (Si = o.utils.randomBytes(v));
        const rs = qr(Si);
        if (rs.length !== v)
          throw new Error(`sign: Expected ${v} bytes of extra data`);
        Tn.push(rs);
      }
      const Fn = ke(...Tn), ss = Rr(Ui);
      return { seed: Fn, m: ss, d: _i };
    }
    function Er(Ai, ci) {
      const { sig: Si, recovery: Ui } = Ai, { der: _i, recovered: Tn } = Object.assign({ canonical: !0, der: !0 }, ci), Fn = _i ? Si.toDERRawBytes() : Si.toCompactRawBytes();
      return Tn ? [Fn, Ui] : Fn;
    }
    async function xr(Ai, ci, Si = {}) {
      const { seed: Ui, m: _i, d: Tn } = Cr(Ai, ci, Si.extraEntropy), Fn = new Ar(M, F);
      await Fn.reseed(Ui);
      let ss;
      for (; !(ss = Wr(await Fn.generate(), _i, Tn, Si.canonical)); )
        await Fn.reseed();
      return Er(ss, Si);
    }
    o.sign = xr;
    function si(Ai, ci, Si = {}) {
      const { seed: Ui, m: _i, d: Tn } = Cr(Ai, ci, Si.extraEntropy), Fn = new Ar(M, F);
      Fn.reseedSync(Ui);
      let ss;
      for (; !(ss = Wr(Fn.generateSync(), _i, Tn, Si.canonical)); )
        Fn.reseedSync();
      return Er(ss, Si);
    }
    o.signSync = si;
    const Ci = { strict: !0 };
    function bi(Ai, ci, Si, Ui = Ci) {
      let _i;
      try {
        _i = $r(Ai), ci = qr(ci);
      } catch {
        return !1;
      }
      const { r: Tn, s: Fn } = _i;
      if (Ui.strict && _i.hasHighS())
        return !1;
      const ss = Gr(ci);
      let rs;
      try {
        rs = Bi(Si);
      } catch {
        return !1;
      }
      const { n: is } = B, Pr = Vr(Fn, is), as = Dr(ss * Pr, is), Rs = Dr(Tn * Pr, is), ri = He.BASE.multiplyAndAddUnsafe(rs, as, Rs);
      return ri ? Dr(ri.x, is) === Tn : !1;
    }
    o.verify = bi;
    function Ri(Ai) {
      return Dr(wr(Ai), B.n);
    }
    class li {
      constructor(ci, Si) {
        this.r = ci, this.s = Si, this.assertValidity();
      }
      static fromHex(ci) {
        const Si = qr(ci);
        if (Si.length !== 64)
          throw new TypeError(`SchnorrSignature.fromHex: expected 64 bytes, not ${Si.length}`);
        const Ui = wr(Si.subarray(0, 32)), _i = wr(Si.subarray(32, 64));
        return new li(Ui, _i);
      }
      assertValidity() {
        const { r: ci, s: Si } = this;
        if (!hr(ci) || !cr(Si))
          throw new Error("Invalid signature");
      }
      toHex() {
        return xt(this.r) + xt(this.s);
      }
      toRawBytes() {
        return Dt(this.toHex());
      }
    }
    function zi(Ai) {
      return He.fromPrivateKey(Ai).toRawX();
    }
    class Kn {
      constructor(ci, Si, Ui = o.utils.randomBytes()) {
        if (ci == null)
          throw new TypeError(`sign: Expected valid message, not "${ci}"`);
        this.m = qr(ci);
        const { x: _i, scalar: Tn } = this.getScalar(fi(Si));
        if (this.px = _i, this.d = Tn, this.rand = qr(Ui), this.rand.length !== 32)
          throw new TypeError("sign: Expected 32 bytes of aux randomness");
      }
      getScalar(ci) {
        const Si = He.fromPrivateKey(ci), Ui = Si.hasEvenY() ? ci : B.n - ci;
        return { point: Si, scalar: Ui, x: Si.toRawX() };
      }
      initNonce(ci, Si) {
        return ir(ci ^ wr(Si));
      }
      finalizeNonce(ci) {
        const Si = Dr(wr(ci), B.n);
        if (Si === c)
          throw new Error("sign: Creation of signature failed. k is zero");
        const { point: Ui, x: _i, scalar: Tn } = this.getScalar(Si);
        return { R: Ui, rx: _i, k: Tn };
      }
      finalizeSig(ci, Si, Ui, _i) {
        return new li(ci.x, Dr(Si + Ui * _i, B.n)).toRawBytes();
      }
      error() {
        throw new Error("sign: Invalid signature produced");
      }
      async calc() {
        const { m: ci, d: Si, px: Ui, rand: _i } = this, Tn = o.utils.taggedHash, Fn = this.initNonce(Si, await Tn(Fs.aux, _i)), { R: ss, rx: rs, k: is } = this.finalizeNonce(await Tn(Fs.nonce, Fn, Ui, ci)), Pr = Ri(await Tn(Fs.challenge, rs, Ui, ci)), as = this.finalizeSig(ss, is, Pr, Si);
        return await Wn(as, ci, Ui) || this.error(), as;
      }
      calcSync() {
        const { m: ci, d: Si, px: Ui, rand: _i } = this, Tn = o.utils.taggedHashSync, Fn = this.initNonce(Si, Tn(Fs.aux, _i)), { R: ss, rx: rs, k: is } = this.finalizeNonce(Tn(Fs.nonce, Fn, Ui, ci)), Pr = Ri(Tn(Fs.challenge, rs, Ui, ci)), as = this.finalizeSig(ss, is, Pr, Si);
        return Gn(as, ci, Ui) || this.error(), as;
      }
    }
    async function Hn(Ai, ci, Si) {
      return new Kn(Ai, ci, Si).calc();
    }
    function os(Ai, ci, Si) {
      return new Kn(Ai, ci, Si).calcSync();
    }
    function ts(Ai, ci, Si) {
      const Ui = Ai instanceof li, _i = Ui ? Ai : li.fromHex(Ai);
      return Ui && _i.assertValidity(), {
        ..._i,
        m: qr(ci),
        P: Bi(Si)
      };
    }
    function Gs(Ai, ci, Si, Ui) {
      const _i = He.BASE.multiplyAndAddUnsafe(ci, fi(Si), Dr(-Ui, B.n));
      return !(!_i || !_i.hasEvenY() || _i.x !== Ai);
    }
    async function Wn(Ai, ci, Si) {
      try {
        const { r: Ui, s: _i, m: Tn, P: Fn } = ts(Ai, ci, Si), ss = Ri(await o.utils.taggedHash(Fs.challenge, ir(Ui), Fn.toRawX(), Tn));
        return Gs(Ui, Fn, _i, ss);
      } catch {
        return !1;
      }
    }
    function Gn(Ai, ci, Si) {
      try {
        const { r: Ui, s: _i, m: Tn, P: Fn } = ts(Ai, ci, Si), ss = Ri(o.utils.taggedHashSync(Fs.challenge, ir(Ui), Fn.toRawX(), Tn));
        return Gs(Ui, Fn, _i, ss);
      } catch (Ui) {
        if (Ui instanceof ge)
          throw Ui;
        return !1;
      }
    }
    o.schnorr = {
      Signature: li,
      getPublicKey: zi,
      sign: Hn,
      verify: Wn,
      signSync: os,
      verifySync: Gn
    }, He.BASE._setWindowSize(8);
    const ro = {
      node: g,
      web: typeof self == "object" && "crypto" in self ? self.crypto : void 0
    }, Fs = {
      challenge: "BIP0340/challenge",
      aux: "BIP0340/aux",
      nonce: "BIP0340/nonce"
    }, ii = {};
    o.utils = {
      bytesToHex: Ne,
      hexToBytes: Dt,
      concatBytes: ke,
      mod: Dr,
      invert: Vr,
      isValidPrivateKey(Ai) {
        try {
          return fi(Ai), !0;
        } catch {
          return !1;
        }
      },
      _bigintTo32Bytes: ir,
      _normalizePrivateKey: fi,
      hashToPrivateKey: (Ai) => {
        Ai = qr(Ai);
        const ci = F + 8;
        if (Ai.length < ci || Ai.length > 1024)
          throw new Error("Expected valid bytes of private key as per FIPS 186");
        const Si = Dr(wr(Ai), B.n - y) + y;
        return ir(Si);
      },
      randomBytes: (Ai = 32) => {
        if (ro.web)
          return ro.web.getRandomValues(new Uint8Array(Ai));
        if (ro.node) {
          const { randomBytes: ci } = ro.node;
          return Uint8Array.from(ci(Ai));
        } else
          throw new Error("The environment doesn't have randomBytes function");
      },
      randomPrivateKey: () => o.utils.hashToPrivateKey(o.utils.randomBytes(F + 8)),
      precompute(Ai = 8, ci = He.BASE) {
        const Si = ci === He.BASE ? ci : new He(ci.x, ci.y);
        return Si._setWindowSize(Ai), Si.multiply(d), Si;
      },
      sha256: async (...Ai) => {
        if (ro.web) {
          const ci = await ro.web.subtle.digest("SHA-256", ke(...Ai));
          return new Uint8Array(ci);
        } else if (ro.node) {
          const { createHash: ci } = ro.node, Si = ci("sha256");
          return Ai.forEach((Ui) => Si.update(Ui)), Uint8Array.from(Si.digest());
        } else
          throw new Error("The environment doesn't have sha256 function");
      },
      hmacSha256: async (Ai, ...ci) => {
        if (ro.web) {
          const Si = await ro.web.subtle.importKey("raw", Ai, { name: "HMAC", hash: { name: "SHA-256" } }, !1, ["sign"]), Ui = ke(...ci), _i = await ro.web.subtle.sign("HMAC", Si, Ui);
          return new Uint8Array(_i);
        } else if (ro.node) {
          const { createHmac: Si } = ro.node, Ui = Si("sha256", Ai);
          return ci.forEach((_i) => Ui.update(_i)), Uint8Array.from(Ui.digest());
        } else
          throw new Error("The environment doesn't have hmac-sha256 function");
      },
      sha256Sync: void 0,
      hmacSha256Sync: void 0,
      taggedHash: async (Ai, ...ci) => {
        let Si = ii[Ai];
        if (Si === void 0) {
          const Ui = await o.utils.sha256(Uint8Array.from(Ai, (_i) => _i.charCodeAt(0)));
          Si = ke(Ui, Ui), ii[Ai] = Si;
        }
        return o.utils.sha256(Si, ...ci);
      },
      taggedHashSync: (Ai, ...ci) => {
        if (typeof Fr != "function")
          throw new ge("sha256Sync is undefined, you need to set it");
        let Si = ii[Ai];
        if (Si === void 0) {
          const Ui = Fr(Uint8Array.from(Ai, (_i) => _i.charCodeAt(0)));
          Si = ke(Ui, Ui), ii[Ai] = Si;
        }
        return Fr(Si, ...ci);
      },
      _JacobianPoint: Ee
    }, Object.defineProperties(o.utils, {
      sha256Sync: {
        configurable: !1,
        get() {
          return Fr;
        },
        set(Ai) {
          Fr || (Fr = Ai);
        }
      },
      hmacSha256Sync: {
        configurable: !1,
        get() {
          return br;
        },
        set(Ai) {
          br || (br = Ai);
        }
      }
    });
  }(lib$3)), lib$3;
}
var ecdsaSigFormatter = {}, hasRequiredEcdsaSigFormatter;
function requireEcdsaSigFormatter() {
  if (hasRequiredEcdsaSigFormatter) return ecdsaSigFormatter;
  hasRequiredEcdsaSigFormatter = 1, Object.defineProperty(ecdsaSigFormatter, "__esModule", { value: !0 }), ecdsaSigFormatter.joseToDer = ecdsaSigFormatter.derToJose = void 0;
  const o = requireBase64Js(), g = requireBase64Url();
  function c(fe) {
    return (fe / 8 | 0) + (fe % 8 === 0 ? 0 : 1);
  }
  const y = {
    ES256: c(256),
    ES384: c(384),
    ES512: c(521)
  };
  function t(fe) {
    const ge = y[fe];
    if (ge)
      return ge;
    throw new Error(`Unknown algorithm "${fe}"`);
  }
  const d = 128, E = 0, B = 32, D = 16, x = 2, v = D | B | E << 6, F = x | E << 6;
  function M(fe) {
    if (fe instanceof Uint8Array)
      return fe;
    if (typeof fe == "string")
      return (0, o.toByteArray)((0, g.pad)(fe));
    throw new TypeError("ECDSA signature must be a Base64 string or a Uint8Array");
  }
  function U(fe, ge) {
    const Ie = M(fe), Ee = t(ge), Se = Ee + 1, ze = Ie.length;
    let He = 0;
    if (Ie[He++] !== v)
      throw new Error('Could not find expected "seq"');
    let Pe = Ie[He++];
    if (Pe === (d | 1) && (Pe = Ie[He++]), ze - He < Pe)
      throw new Error(`"seq" specified length of "${Pe}", only "${ze - He}" remaining`);
    if (Ie[He++] !== F)
      throw new Error('Could not find expected "int" for "r"');
    const De = Ie[He++];
    if (ze - He - 2 < De)
      throw new Error(`"r" specified length of "${De}", only "${ze - He - 2}" available`);
    if (Se < De)
      throw new Error(`"r" specified length of "${De}", max of "${Se}" is acceptable`);
    const ve = He;
    if (He += De, Ie[He++] !== F)
      throw new Error('Could not find expected "int" for "s"');
    const Fe = Ie[He++];
    if (ze - He !== Fe)
      throw new Error(`"s" specified length of "${Fe}", expected "${ze - He}"`);
    if (Se < Fe)
      throw new Error(`"s" specified length of "${Fe}", max of "${Se}" is acceptable`);
    const be = He;
    if (He += Fe, He !== ze)
      throw new Error(`Expected to consume entire array, but "${ze - He}" bytes remain`);
    const Be = Ee - De, ke = Ee - Fe, xe = new Uint8Array(Be + De + ke + Fe);
    for (He = 0; He < Be; ++He)
      xe[He] = 0;
    xe.set(Ie.subarray(ve + Math.max(-Be, 0), ve + De), He), He = Ee;
    for (const Ne = He; He < Ne + ke; ++He)
      xe[He] = 0;
    return xe.set(Ie.subarray(be + Math.max(-ke, 0), be + Fe), He), (0, g.escape)((0, o.fromByteArray)(xe));
  }
  ecdsaSigFormatter.derToJose = U;
  function L(fe, ge, Ie) {
    let Ee = 0;
    for (; ge + Ee < Ie && fe[ge + Ee] === 0; )
      ++Ee;
    return fe[ge + Ee] >= d && --Ee, Ee;
  }
  function H(fe, ge) {
    fe = M(fe);
    const Ie = t(ge), Ee = fe.length;
    if (Ee !== Ie * 2)
      throw new TypeError(`"${ge}" signatures must be "${Ie * 2}" bytes, saw "${Ee}"`);
    const Se = L(fe, 0, Ie), ze = L(fe, Ie, fe.length), He = Ie - Se, Pe = Ie - ze, De = 2 + He + 1 + 1 + Pe, ve = De < d, Fe = new Uint8Array((ve ? 2 : 3) + De);
    let be = 0;
    return Fe[be++] = v, ve ? Fe[be++] = De : (Fe[be++] = d | 1, Fe[be++] = De & 255), Fe[be++] = F, Fe[be++] = He, Se < 0 ? (Fe[be++] = 0, Fe.set(fe.subarray(0, Ie), be), be += Ie) : (Fe.set(fe.subarray(Se, Ie), be), be += Ie - Se), Fe[be++] = F, Fe[be++] = Pe, ze < 0 ? (Fe[be++] = 0, Fe.set(fe.subarray(Ie), be)) : Fe.set(fe.subarray(Ie + ze), be), Fe;
  }
  return ecdsaSigFormatter.joseToDer = H, ecdsaSigFormatter;
}
var errors = {}, hasRequiredErrors;
function requireErrors() {
  if (hasRequiredErrors) return errors;
  hasRequiredErrors = 1, Object.defineProperty(errors, "__esModule", { value: !0 }), errors.InvalidTokenError = errors.MissingParametersError = void 0;
  class o extends Error {
    constructor(y) {
      super(), this.name = "MissingParametersError", this.message = y || "";
    }
  }
  errors.MissingParametersError = o;
  class g extends Error {
    constructor(y) {
      super(), this.name = "InvalidTokenError", this.message = y || "";
    }
  }
  return errors.InvalidTokenError = g, errors;
}
var hasRequiredSecp256k1$1;
function requireSecp256k1$1() {
  if (hasRequiredSecp256k1$1) return secp256k1$2;
  hasRequiredSecp256k1$1 = 1, Object.defineProperty(secp256k1$2, "__esModule", { value: !0 }), secp256k1$2.SECP256K1Client = void 0;
  const o = /* @__PURE__ */ requireHmac$3(), g = /* @__PURE__ */ requireSha256$1(), c = requireLib$4(), y = requireEcdsaSigFormatter(), t = requireErrors(), d = /* @__PURE__ */ requireUtils$j();
  c.utils.hmacSha256Sync = (B, ...D) => {
    const x = o.hmac.create(g.sha256, B);
    return D.forEach((v) => x.update(v)), x.digest();
  };
  class E {
    static derivePublicKey(D, x = !0) {
      return D.length === 66 && (D = D.slice(0, 64)), D.length < 64 && (D = D.padStart(64, "0")), (0, d.bytesToHex)(c.getPublicKey(D, x));
    }
    static signHash(D, x, v = "jose") {
      if (!D || !x)
        throw new t.MissingParametersError("a signing input hash and private key are all required");
      const F = c.signSync(D, x.slice(0, 64), {
        der: !0,
        canonical: !1
      });
      if (v === "der")
        return (0, d.bytesToHex)(F);
      if (v === "jose")
        return (0, y.derToJose)(F, "ES256");
      throw Error("Invalid signature format");
    }
    static loadSignature(D) {
      return (0, y.joseToDer)(D, "ES256");
    }
    static verifyHash(D, x, v) {
      if (!D || !x || !v)
        throw new t.MissingParametersError("a signing input hash, der signature, and public key are all required");
      return c.verify(x, D, v, { strict: !1 });
    }
  }
  return secp256k1$2.SECP256K1Client = E, E.algorithmName = "ES256K", secp256k1$2;
}
var hasRequiredCryptoClients;
function requireCryptoClients() {
  return hasRequiredCryptoClients || (hasRequiredCryptoClients = 1, function(o) {
    Object.defineProperty(o, "__esModule", { value: !0 }), o.cryptoClients = o.SECP256K1Client = void 0;
    const g = requireSecp256k1$1();
    Object.defineProperty(o, "SECP256K1Client", { enumerable: !0, get: function() {
      return g.SECP256K1Client;
    } });
    const c = {
      ES256K: g.SECP256K1Client
    };
    o.cryptoClients = c;
  }(cryptoClients)), cryptoClients;
}
var sha256$2 = {}, hasRequiredSha256;
function requireSha256() {
  if (hasRequiredSha256) return sha256$2;
  hasRequiredSha256 = 1;
  var o = sha256$2 && sha256$2.__awaiter || function(t, d, E, B) {
    function D(x) {
      return x instanceof E ? x : new E(function(v) {
        v(x);
      });
    }
    return new (E || (E = Promise))(function(x, v) {
      function F(L) {
        try {
          U(B.next(L));
        } catch (H) {
          v(H);
        }
      }
      function M(L) {
        try {
          U(B.throw(L));
        } catch (H) {
          v(H);
        }
      }
      function U(L) {
        L.done ? x(L.value) : D(L.value).then(F, M);
      }
      U((B = B.apply(t, d || [])).next());
    });
  };
  Object.defineProperty(sha256$2, "__esModule", { value: !0 }), sha256$2.hashSha256Async = sha256$2.hashSha256 = void 0;
  const g = /* @__PURE__ */ requireSha256$1();
  function c(t) {
    return (0, g.sha256)(t);
  }
  sha256$2.hashSha256 = c;
  function y(t) {
    return o(this, void 0, void 0, function* () {
      try {
        if (typeof crypto < "u" && typeof crypto.subtle < "u") {
          const E = typeof t == "string" ? new TextEncoder().encode(t) : t, B = yield crypto.subtle.digest("SHA-256", E);
          return new Uint8Array(B);
        } else {
          const E = requireCryptoBrowserify();
          if (!E.createHash)
            throw new Error("`crypto` module does not contain `createHash`");
          return Promise.resolve(E.createHash("sha256").update(t).digest());
        }
      } catch (d) {
        return console.log(d), console.log('Crypto lib not found. Neither the global `crypto.subtle` Web Crypto API, nor the or the Node.js `require("crypto").createHash` module is available. Falling back to JS implementation.'), Promise.resolve(c(t));
      }
    });
  }
  return sha256$2.hashSha256Async = y, sha256$2;
}
var hasRequiredSigner;
function requireSigner() {
  if (hasRequiredSigner) return signer;
  hasRequiredSigner = 1;
  var o = signer && signer.__awaiter || function(D, x, v, F) {
    function M(U) {
      return U instanceof v ? U : new v(function(L) {
        L(U);
      });
    }
    return new (v || (v = Promise))(function(U, L) {
      function H(Ie) {
        try {
          ge(F.next(Ie));
        } catch (Ee) {
          L(Ee);
        }
      }
      function fe(Ie) {
        try {
          ge(F.throw(Ie));
        } catch (Ee) {
          L(Ee);
        }
      }
      function ge(Ie) {
        Ie.done ? U(Ie.value) : M(Ie.value).then(H, fe);
      }
      ge((F = F.apply(D, x || [])).next());
    });
  };
  Object.defineProperty(signer, "__esModule", { value: !0 }), signer.TokenSigner = signer.createUnsecuredToken = void 0;
  const g = requireBase64Url(), c = requireCryptoClients(), y = requireErrors(), t = requireSha256();
  function d(D, x) {
    const v = [], F = g.encode(JSON.stringify(x));
    v.push(F);
    const M = g.encode(JSON.stringify(D));
    return v.push(M), v.join(".");
  }
  function E(D) {
    return d(D, { typ: "JWT", alg: "none" }) + ".";
  }
  signer.createUnsecuredToken = E;
  class B {
    constructor(x, v) {
      if (!(x && v))
        throw new y.MissingParametersError("a signing algorithm and private key are required");
      if (typeof x != "string")
        throw new Error("signing algorithm parameter must be a string");
      if (x = x.toUpperCase(), !c.cryptoClients.hasOwnProperty(x))
        throw new Error("invalid signing algorithm");
      this.tokenType = "JWT", this.cryptoClient = c.cryptoClients[x], this.rawPrivateKey = v;
    }
    header(x = {}) {
      const v = { typ: this.tokenType, alg: this.cryptoClient.algorithmName };
      return Object.assign({}, v, x);
    }
    sign(x, v = !1, F = {}) {
      const M = this.header(F), U = d(x, M), L = (0, t.hashSha256)(U);
      return this.createWithSignedHash(x, v, M, U, L);
    }
    signAsync(x, v = !1, F = {}) {
      return o(this, void 0, void 0, function* () {
        const M = this.header(F), U = d(x, M), L = yield (0, t.hashSha256Async)(U);
        return this.createWithSignedHash(x, v, M, U, L);
      });
    }
    createWithSignedHash(x, v, F, M, U) {
      const L = this.cryptoClient.signHash(U, this.rawPrivateKey);
      return v ? {
        header: [g.encode(JSON.stringify(F))],
        payload: JSON.stringify(x),
        signature: [L]
      } : [M, L].join(".");
    }
  }
  return signer.TokenSigner = B, signer;
}
var verifier = {}, hasRequiredVerifier;
function requireVerifier() {
  if (hasRequiredVerifier) return verifier;
  hasRequiredVerifier = 1, Object.defineProperty(verifier, "__esModule", { value: !0 }), verifier.TokenVerifier = void 0;
  const o = requireBase64Url(), g = requireCryptoClients(), c = requireErrors(), y = requireSha256();
  class t {
    constructor(E, B) {
      if (!(E && B))
        throw new c.MissingParametersError("a signing algorithm and public key are required");
      if (typeof E != "string")
        throw "signing algorithm parameter must be a string";
      if (E = E.toUpperCase(), !g.cryptoClients.hasOwnProperty(E))
        throw "invalid signing algorithm";
      this.tokenType = "JWT", this.cryptoClient = g.cryptoClients[E], this.rawPublicKey = B;
    }
    verify(E) {
      return typeof E == "string" ? this.verifyCompact(E, !1) : typeof E == "object" ? this.verifyExpanded(E, !1) : !1;
    }
    verifyAsync(E) {
      return typeof E == "string" ? this.verifyCompact(E, !0) : typeof E == "object" ? this.verifyExpanded(E, !0) : Promise.resolve(!1);
    }
    verifyCompact(E, B) {
      const D = E.split("."), x = D[0] + "." + D[1], v = (F) => {
        const M = this.cryptoClient.loadSignature(D[2]);
        return this.cryptoClient.verifyHash(F, M, this.rawPublicKey);
      };
      if (B)
        return (0, y.hashSha256Async)(x).then((F) => v(F));
      {
        const F = (0, y.hashSha256)(x);
        return v(F);
      }
    }
    verifyExpanded(E, B) {
      const D = [E.header.join("."), o.encode(E.payload)].join(".");
      let x = !0;
      const v = (F) => (E.signature.map((M) => {
        const U = this.cryptoClient.loadSignature(M);
        this.cryptoClient.verifyHash(F, U, this.rawPublicKey) || (x = !1);
      }), x);
      if (B)
        return (0, y.hashSha256Async)(D).then((F) => v(F));
      {
        const F = (0, y.hashSha256)(D);
        return v(F);
      }
    }
  }
  return verifier.TokenVerifier = t, verifier;
}
var decode = {}, hasRequiredDecode;
function requireDecode() {
  if (hasRequiredDecode) return decode;
  hasRequiredDecode = 1, Object.defineProperty(decode, "__esModule", { value: !0 }), decode.decodeToken = void 0;
  const o = requireBase64Url();
  function g(c) {
    if (typeof c == "string") {
      const y = c.split("."), t = JSON.parse(o.decode(y[0])), d = JSON.parse(o.decode(y[1])), E = y[2];
      return {
        header: t,
        payload: d,
        signature: E
      };
    } else if (typeof c == "object") {
      if (typeof c.payload != "string")
        throw new Error("Expected token payload to be a base64 or json string");
      let y = c.payload;
      c.payload[0] !== "{" && (y = o.decode(y));
      const t = [];
      return c.header.map((d) => {
        const E = JSON.parse(o.decode(d));
        t.push(E);
      }), {
        header: t,
        payload: JSON.parse(y),
        signature: c.signature
      };
    }
  }
  return decode.decodeToken = g, decode;
}
var hasRequiredLib$3;
function requireLib$3() {
  return hasRequiredLib$3 || (hasRequiredLib$3 = 1, function(o) {
    var g = lib$4 && lib$4.__createBinding || (Object.create ? function(y, t, d, E) {
      E === void 0 && (E = d);
      var B = Object.getOwnPropertyDescriptor(t, d);
      (!B || ("get" in B ? !t.__esModule : B.writable || B.configurable)) && (B = { enumerable: !0, get: function() {
        return t[d];
      } }), Object.defineProperty(y, E, B);
    } : function(y, t, d, E) {
      E === void 0 && (E = d), y[E] = t[d];
    }), c = lib$4 && lib$4.__exportStar || function(y, t) {
      for (var d in y) d !== "default" && !Object.prototype.hasOwnProperty.call(t, d) && g(t, y, d);
    };
    Object.defineProperty(o, "__esModule", { value: !0 }), c(requireSigner(), o), c(requireVerifier(), o), c(requireDecode(), o), c(requireErrors(), o), c(requireCryptoClients(), o);
  }(lib$4)), lib$4;
}
var libExports = requireLib$3(), build$4 = {}, bip39 = {}, build$3 = {}, ascii$1 = {}, hasRequiredAscii$1;
function requireAscii$1() {
  if (hasRequiredAscii$1) return ascii$1;
  hasRequiredAscii$1 = 1, Object.defineProperty(ascii$1, "__esModule", { value: !0 }), ascii$1.toAscii = o, ascii$1.fromAscii = g;
  function o(c) {
    const y = (t) => t.split("").map((d) => {
      const E = d.charCodeAt(0);
      if (E < 32 || E > 126)
        throw new Error(`Cannot encode character that is out of printable ASCII range: ${E}`);
      return E;
    });
    return Uint8Array.from(y(c));
  }
  function g(c) {
    return ((t) => t.map((d) => {
      if (d < 32 || d > 126)
        throw new Error(`Cannot decode character that is out of printable ASCII range: ${d}`);
      return String.fromCharCode(d);
    }))(Array.from(c)).join("");
  }
  return ascii$1;
}
var base64$2 = {}, hasRequiredBase64$2;
function requireBase64$2() {
  if (hasRequiredBase64$2) return base64$2;
  hasRequiredBase64$2 = 1;
  var o = base64$2 && base64$2.__createBinding || (Object.create ? function(E, B, D, x) {
    x === void 0 && (x = D);
    var v = Object.getOwnPropertyDescriptor(B, D);
    (!v || ("get" in v ? !B.__esModule : v.writable || v.configurable)) && (v = { enumerable: !0, get: function() {
      return B[D];
    } }), Object.defineProperty(E, x, v);
  } : function(E, B, D, x) {
    x === void 0 && (x = D), E[x] = B[D];
  }), g = base64$2 && base64$2.__setModuleDefault || (Object.create ? function(E, B) {
    Object.defineProperty(E, "default", { enumerable: !0, value: B });
  } : function(E, B) {
    E.default = B;
  }), c = base64$2 && base64$2.__importStar || /* @__PURE__ */ function() {
    var E = function(B) {
      return E = Object.getOwnPropertyNames || function(D) {
        var x = [];
        for (var v in D) Object.prototype.hasOwnProperty.call(D, v) && (x[x.length] = v);
        return x;
      }, E(B);
    };
    return function(B) {
      if (B && B.__esModule) return B;
      var D = {};
      if (B != null) for (var x = E(B), v = 0; v < x.length; v++) x[v] !== "default" && o(D, B, x[v]);
      return g(D, B), D;
    };
  }();
  Object.defineProperty(base64$2, "__esModule", { value: !0 }), base64$2.toBase64 = t, base64$2.fromBase64 = d;
  const y = c(requireBase64Js());
  function t(E) {
    return y.fromByteArray(E);
  }
  function d(E) {
    if (!E.match(/^[a-zA-Z0-9+/]*={0,2}$/))
      throw new Error("Invalid base64 string format");
    return y.toByteArray(E);
  }
  return base64$2;
}
var bech32$3 = {}, bech32$2, hasRequiredBech32$2;
function requireBech32$2() {
  if (hasRequiredBech32$2) return bech32$2;
  hasRequiredBech32$2 = 1;
  for (var o = "qpzry9x8gf2tvdw0s3jn54khce6mua7l", g = {}, c = 0; c < o.length; c++) {
    var y = o.charAt(c);
    if (g[y] !== void 0) throw new TypeError(y + " is ambiguous");
    g[y] = c;
  }
  function t(H) {
    var fe = H >> 25;
    return (H & 33554431) << 5 ^ -(fe >> 0 & 1) & 996825010 ^ -(fe >> 1 & 1) & 642813549 ^ -(fe >> 2 & 1) & 513874426 ^ -(fe >> 3 & 1) & 1027748829 ^ -(fe >> 4 & 1) & 705979059;
  }
  function d(H) {
    for (var fe = 1, ge = 0; ge < H.length; ++ge) {
      var Ie = H.charCodeAt(ge);
      if (Ie < 33 || Ie > 126) return "Invalid prefix (" + H + ")";
      fe = t(fe) ^ Ie >> 5;
    }
    for (fe = t(fe), ge = 0; ge < H.length; ++ge) {
      var Ee = H.charCodeAt(ge);
      fe = t(fe) ^ Ee & 31;
    }
    return fe;
  }
  function E(H, fe, ge) {
    if (ge = ge || 90, H.length + 7 + fe.length > ge) throw new TypeError("Exceeds length limit");
    H = H.toLowerCase();
    var Ie = d(H);
    if (typeof Ie == "string") throw new Error(Ie);
    for (var Ee = H + "1", Se = 0; Se < fe.length; ++Se) {
      var ze = fe[Se];
      if (ze >> 5 !== 0) throw new Error("Non 5-bit word");
      Ie = t(Ie) ^ ze, Ee += o.charAt(ze);
    }
    for (Se = 0; Se < 6; ++Se)
      Ie = t(Ie);
    for (Ie ^= 1, Se = 0; Se < 6; ++Se) {
      var He = Ie >> (5 - Se) * 5 & 31;
      Ee += o.charAt(He);
    }
    return Ee;
  }
  function B(H, fe) {
    if (fe = fe || 90, H.length < 8) return H + " too short";
    if (H.length > fe) return "Exceeds length limit";
    var ge = H.toLowerCase(), Ie = H.toUpperCase();
    if (H !== ge && H !== Ie) return "Mixed-case string " + H;
    H = ge;
    var Ee = H.lastIndexOf("1");
    if (Ee === -1) return "No separator character for " + H;
    if (Ee === 0) return "Missing prefix for " + H;
    var Se = H.slice(0, Ee), ze = H.slice(Ee + 1);
    if (ze.length < 6) return "Data too short";
    var He = d(Se);
    if (typeof He == "string") return He;
    for (var Pe = [], De = 0; De < ze.length; ++De) {
      var ve = ze.charAt(De), Fe = g[ve];
      if (Fe === void 0) return "Unknown character " + ve;
      He = t(He) ^ Fe, !(De + 6 >= ze.length) && Pe.push(Fe);
    }
    return He !== 1 ? "Invalid checksum for " + H : { prefix: Se, words: Pe };
  }
  function D() {
    var H = B.apply(null, arguments);
    if (typeof H == "object") return H;
  }
  function x(H) {
    var fe = B.apply(null, arguments);
    if (typeof fe == "object") return fe;
    throw new Error(fe);
  }
  function v(H, fe, ge, Ie) {
    for (var Ee = 0, Se = 0, ze = (1 << ge) - 1, He = [], Pe = 0; Pe < H.length; ++Pe)
      for (Ee = Ee << fe | H[Pe], Se += fe; Se >= ge; )
        Se -= ge, He.push(Ee >> Se & ze);
    if (Ie)
      Se > 0 && He.push(Ee << ge - Se & ze);
    else {
      if (Se >= fe) return "Excess padding";
      if (Ee << ge - Se & ze) return "Non-zero padding";
    }
    return He;
  }
  function F(H) {
    var fe = v(H, 8, 5, !0);
    if (Array.isArray(fe)) return fe;
  }
  function M(H) {
    var fe = v(H, 8, 5, !0);
    if (Array.isArray(fe)) return fe;
    throw new Error(fe);
  }
  function U(H) {
    var fe = v(H, 5, 8, !1);
    if (Array.isArray(fe)) return fe;
  }
  function L(H) {
    var fe = v(H, 5, 8, !1);
    if (Array.isArray(fe)) return fe;
    throw new Error(fe);
  }
  return bech32$2 = {
    decodeUnsafe: D,
    decode: x,
    encode: E,
    toWordsUnsafe: F,
    toWords: M,
    fromWordsUnsafe: U,
    fromWords: L
  }, bech32$2;
}
var hasRequiredBech32$1;
function requireBech32$1() {
  if (hasRequiredBech32$1) return bech32$3;
  hasRequiredBech32$1 = 1;
  var o = bech32$3 && bech32$3.__createBinding || (Object.create ? function(B, D, x, v) {
    v === void 0 && (v = x);
    var F = Object.getOwnPropertyDescriptor(D, x);
    (!F || ("get" in F ? !D.__esModule : F.writable || F.configurable)) && (F = { enumerable: !0, get: function() {
      return D[x];
    } }), Object.defineProperty(B, v, F);
  } : function(B, D, x, v) {
    v === void 0 && (v = x), B[v] = D[x];
  }), g = bech32$3 && bech32$3.__setModuleDefault || (Object.create ? function(B, D) {
    Object.defineProperty(B, "default", { enumerable: !0, value: D });
  } : function(B, D) {
    B.default = D;
  }), c = bech32$3 && bech32$3.__importStar || /* @__PURE__ */ function() {
    var B = function(D) {
      return B = Object.getOwnPropertyNames || function(x) {
        var v = [];
        for (var F in x) Object.prototype.hasOwnProperty.call(x, F) && (v[v.length] = F);
        return v;
      }, B(D);
    };
    return function(D) {
      if (D && D.__esModule) return D;
      var x = {};
      if (D != null) for (var v = B(D), F = 0; F < v.length; F++) v[F] !== "default" && o(x, D, v[F]);
      return g(x, D), x;
    };
  }();
  Object.defineProperty(bech32$3, "__esModule", { value: !0 }), bech32$3.toBech32 = t, bech32$3.fromBech32 = d, bech32$3.normalizeBech32 = E;
  const y = c(requireBech32$2());
  function t(B, D, x) {
    return y.encode(B, y.toWords(D), x);
  }
  function d(B, D = 1 / 0) {
    const x = y.decode(B, D);
    return {
      prefix: x.prefix,
      data: new Uint8Array(y.fromWords(x.words))
    };
  }
  function E(B) {
    const { prefix: D, data: x } = d(B);
    return t(D, x);
  }
  return bech32$3;
}
var hex$2 = {}, hasRequiredHex$1;
function requireHex$1() {
  if (hasRequiredHex$1) return hex$2;
  hasRequiredHex$1 = 1, Object.defineProperty(hex$2, "__esModule", { value: !0 }), hex$2.toHex = o, hex$2.fromHex = g;
  function o(c) {
    let y = "";
    for (const t of c)
      y += ("0" + t.toString(16)).slice(-2);
    return y;
  }
  function g(c) {
    if (c.length % 2 !== 0)
      throw new Error("hex string length must be a multiple of 2");
    const y = new Uint8Array(c.length / 2);
    for (let t = 0; t < y.length; t++) {
      const d = 2 * t, E = c.slice(d, d + 2);
      if (!E.match(/[0-9a-f]{2}/i))
        throw new Error("hex string contains invalid characters");
      y[t] = parseInt(E, 16);
    }
    return y;
  }
  return hex$2;
}
var rfc3339$1 = {}, hasRequiredRfc3339$1;
function requireRfc3339$1() {
  if (hasRequiredRfc3339$1) return rfc3339$1;
  hasRequiredRfc3339$1 = 1, Object.defineProperty(rfc3339$1, "__esModule", { value: !0 }), rfc3339$1.fromRfc3339 = c, rfc3339$1.toRfc3339 = y;
  const o = /^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2}):(\d{2})(\.\d{1,9})?((?:[+-]\d{2}:\d{2})|Z)$/;
  function g(t, d = 2) {
    return t.toString().padStart(d, "0");
  }
  function c(t) {
    const d = o.exec(t);
    if (!d)
      throw new Error("Date string is not in RFC3339 format");
    const E = +d[1], B = +d[2], D = +d[3], x = +d[4], v = +d[5], F = +d[6], M = d[7] ? Math.floor(+d[7] * 1e3) : 0;
    let U, L, H;
    d[8] === "Z" ? (U = 1, L = 0, H = 0) : (U = d[8].substring(0, 1) === "-" ? -1 : 1, L = +d[8].substring(1, 3), H = +d[8].substring(4, 6));
    const fe = U * (L * 60 + H) * 60, ge = /* @__PURE__ */ new Date();
    return ge.setUTCFullYear(E, B - 1, D), ge.setUTCHours(x, v, F, M), new Date(ge.getTime() - fe * 1e3);
  }
  function y(t) {
    const d = t.getUTCFullYear(), E = g(t.getUTCMonth() + 1), B = g(t.getUTCDate()), D = g(t.getUTCHours()), x = g(t.getUTCMinutes()), v = g(t.getUTCSeconds()), F = g(t.getUTCMilliseconds(), 3);
    return `${d}-${E}-${B}T${D}:${x}:${v}.${F}Z`;
  }
  return rfc3339$1;
}
var utf8$3 = {}, hasRequiredUtf8$2;
function requireUtf8$2() {
  if (hasRequiredUtf8$2) return utf8$3;
  hasRequiredUtf8$2 = 1, Object.defineProperty(utf8$3, "__esModule", { value: !0 }), utf8$3.toUtf8 = o, utf8$3.fromUtf8 = g;
  function o(c) {
    return new TextEncoder().encode(c);
  }
  function g(c, y = !1) {
    const t = !y;
    return new TextDecoder("utf-8", { fatal: t }).decode(c);
  }
  return utf8$3;
}
var hasRequiredBuild$4;
function requireBuild$4() {
  return hasRequiredBuild$4 || (hasRequiredBuild$4 = 1, function(o) {
    Object.defineProperty(o, "__esModule", { value: !0 }), o.toUtf8 = o.fromUtf8 = o.toRfc3339 = o.fromRfc3339 = o.toHex = o.fromHex = o.toBech32 = o.normalizeBech32 = o.fromBech32 = o.toBase64 = o.fromBase64 = o.toAscii = o.fromAscii = void 0;
    var g = requireAscii$1();
    Object.defineProperty(o, "fromAscii", { enumerable: !0, get: function() {
      return g.fromAscii;
    } }), Object.defineProperty(o, "toAscii", { enumerable: !0, get: function() {
      return g.toAscii;
    } });
    var c = requireBase64$2();
    Object.defineProperty(o, "fromBase64", { enumerable: !0, get: function() {
      return c.fromBase64;
    } }), Object.defineProperty(o, "toBase64", { enumerable: !0, get: function() {
      return c.toBase64;
    } });
    var y = requireBech32$1();
    Object.defineProperty(o, "fromBech32", { enumerable: !0, get: function() {
      return y.fromBech32;
    } }), Object.defineProperty(o, "normalizeBech32", { enumerable: !0, get: function() {
      return y.normalizeBech32;
    } }), Object.defineProperty(o, "toBech32", { enumerable: !0, get: function() {
      return y.toBech32;
    } });
    var t = requireHex$1();
    Object.defineProperty(o, "fromHex", { enumerable: !0, get: function() {
      return t.fromHex;
    } }), Object.defineProperty(o, "toHex", { enumerable: !0, get: function() {
      return t.toHex;
    } });
    var d = requireRfc3339$1();
    Object.defineProperty(o, "fromRfc3339", { enumerable: !0, get: function() {
      return d.fromRfc3339;
    } }), Object.defineProperty(o, "toRfc3339", { enumerable: !0, get: function() {
      return d.toRfc3339;
    } });
    var E = requireUtf8$2();
    Object.defineProperty(o, "fromUtf8", { enumerable: !0, get: function() {
      return E.fromUtf8;
    } }), Object.defineProperty(o, "toUtf8", { enumerable: !0, get: function() {
      return E.toUtf8;
    } });
  }(build$3)), build$3;
}
var pbkdf2$2 = {}, build$2 = {}, arrays = {}, hasRequiredArrays;
function requireArrays() {
  if (hasRequiredArrays) return arrays;
  hasRequiredArrays = 1, Object.defineProperty(arrays, "__esModule", { value: !0 }), arrays.arrayContentEquals = o, arrays.arrayContentStartsWith = g;
  function o(c, y) {
    if (c.length !== y.length)
      return !1;
    for (let t = 0; t < c.length; ++t)
      if (c[t] !== y[t])
        return !1;
    return !0;
  }
  function g(c, y) {
    if (c.length < y.length)
      return !1;
    for (let t = 0; t < y.length; ++t)
      if (c[t] !== y[t])
        return !1;
    return !0;
  }
  return arrays;
}
var assert = {}, hasRequiredAssert;
function requireAssert() {
  if (hasRequiredAssert) return assert;
  hasRequiredAssert = 1, Object.defineProperty(assert, "__esModule", { value: !0 }), assert.assert = o, assert.assertDefined = g, assert.assertDefinedAndNotNull = c;
  function o(y, t) {
    if (!y)
      throw new Error(t || "condition is not truthy");
  }
  function g(y, t) {
    if (y === void 0)
      throw new Error(t ?? "value is undefined");
  }
  function c(y, t) {
    if (y == null)
      throw new Error(t ?? "value is undefined or null");
  }
  return assert;
}
var sleep = {}, hasRequiredSleep;
function requireSleep() {
  if (hasRequiredSleep) return sleep;
  hasRequiredSleep = 1, Object.defineProperty(sleep, "__esModule", { value: !0 }), sleep.sleep = o;
  async function o(g) {
    return new Promise((c) => setTimeout(c, g));
  }
  return sleep;
}
var typechecks = {}, hasRequiredTypechecks;
function requireTypechecks() {
  if (hasRequiredTypechecks) return typechecks;
  hasRequiredTypechecks = 1, Object.defineProperty(typechecks, "__esModule", { value: !0 }), typechecks.isNonNullObject = o, typechecks.isUint8Array = g, typechecks.isDefined = c;
  function o(y) {
    return typeof y == "object" && y !== null;
  }
  function g(y) {
    return !(!o(y) || Object.prototype.toString.call(y) !== "[object Uint8Array]" || typeof Buffer < "u" && typeof Buffer.isBuffer < "u" && Buffer.isBuffer(y));
  }
  function c(y) {
    return y !== void 0;
  }
  return typechecks;
}
var hasRequiredBuild$3;
function requireBuild$3() {
  return hasRequiredBuild$3 || (hasRequiredBuild$3 = 1, function(o) {
    Object.defineProperty(o, "__esModule", { value: !0 }), o.isUint8Array = o.isNonNullObject = o.isDefined = o.sleep = o.assertDefinedAndNotNull = o.assertDefined = o.assert = o.arrayContentStartsWith = o.arrayContentEquals = void 0;
    var g = requireArrays();
    Object.defineProperty(o, "arrayContentEquals", { enumerable: !0, get: function() {
      return g.arrayContentEquals;
    } }), Object.defineProperty(o, "arrayContentStartsWith", { enumerable: !0, get: function() {
      return g.arrayContentStartsWith;
    } });
    var c = requireAssert();
    Object.defineProperty(o, "assert", { enumerable: !0, get: function() {
      return c.assert;
    } }), Object.defineProperty(o, "assertDefined", { enumerable: !0, get: function() {
      return c.assertDefined;
    } }), Object.defineProperty(o, "assertDefinedAndNotNull", { enumerable: !0, get: function() {
      return c.assertDefinedAndNotNull;
    } });
    var y = requireSleep();
    Object.defineProperty(o, "sleep", { enumerable: !0, get: function() {
      return y.sleep;
    } });
    var t = requireTypechecks();
    Object.defineProperty(o, "isDefined", { enumerable: !0, get: function() {
      return t.isDefined;
    } }), Object.defineProperty(o, "isNonNullObject", { enumerable: !0, get: function() {
      return t.isNonNullObject;
    } }), Object.defineProperty(o, "isUint8Array", { enumerable: !0, get: function() {
      return t.isUint8Array;
    } });
  }(build$2)), build$2;
}
var pbkdf2$1 = {}, hasRequiredPbkdf2$1;
function requirePbkdf2$1() {
  if (hasRequiredPbkdf2$1) return pbkdf2$1;
  hasRequiredPbkdf2$1 = 1, Object.defineProperty(pbkdf2$1, "__esModule", { value: !0 }), pbkdf2$1.pbkdf2 = t, pbkdf2$1.pbkdf2Async = d;
  const o = /* @__PURE__ */ requireHmac$3(), g = /* @__PURE__ */ requireUtils$j();
  function c(E, B, D, x) {
    (0, g.ahash)(E);
    const v = (0, g.checkOpts)({ dkLen: 32, asyncTick: 10 }, x), { c: F, dkLen: M, asyncTick: U } = v;
    if ((0, g.anumber)(F), (0, g.anumber)(M), (0, g.anumber)(U), F < 1)
      throw new Error("iterations (c) should be >= 1");
    const L = (0, g.kdfInputToBytes)(B), H = (0, g.kdfInputToBytes)(D), fe = new Uint8Array(M), ge = o.hmac.create(E, L), Ie = ge._cloneInto().update(H);
    return { c: F, dkLen: M, asyncTick: U, DK: fe, PRF: ge, PRFSalt: Ie };
  }
  function y(E, B, D, x, v) {
    return E.destroy(), B.destroy(), x && x.destroy(), (0, g.clean)(v), D;
  }
  function t(E, B, D, x) {
    const { c: v, dkLen: F, DK: M, PRF: U, PRFSalt: L } = c(E, B, D, x);
    let H;
    const fe = new Uint8Array(4), ge = (0, g.createView)(fe), Ie = new Uint8Array(U.outputLen);
    for (let Ee = 1, Se = 0; Se < F; Ee++, Se += U.outputLen) {
      const ze = M.subarray(Se, Se + U.outputLen);
      ge.setInt32(0, Ee, !1), (H = L._cloneInto(H)).update(fe).digestInto(Ie), ze.set(Ie.subarray(0, ze.length));
      for (let He = 1; He < v; He++) {
        U._cloneInto(H).update(Ie).digestInto(Ie);
        for (let Pe = 0; Pe < ze.length; Pe++)
          ze[Pe] ^= Ie[Pe];
      }
    }
    return y(U, L, M, H, Ie);
  }
  async function d(E, B, D, x) {
    const { c: v, dkLen: F, asyncTick: M, DK: U, PRF: L, PRFSalt: H } = c(E, B, D, x);
    let fe;
    const ge = new Uint8Array(4), Ie = (0, g.createView)(ge), Ee = new Uint8Array(L.outputLen);
    for (let Se = 1, ze = 0; ze < F; Se++, ze += L.outputLen) {
      const He = U.subarray(ze, ze + L.outputLen);
      Ie.setInt32(0, Se, !1), (fe = H._cloneInto(fe)).update(ge).digestInto(Ee), He.set(Ee.subarray(0, He.length)), await (0, g.asyncLoop)(v - 1, M, () => {
        L._cloneInto(fe).update(Ee).digestInto(Ee);
        for (let Pe = 0; Pe < He.length; Pe++)
          He[Pe] ^= Ee[Pe];
      });
    }
    return y(L, H, U, fe, Ee);
  }
  return pbkdf2$1;
}
var hasRequiredPbkdf2;
function requirePbkdf2() {
  if (hasRequiredPbkdf2) return pbkdf2$2;
  hasRequiredPbkdf2 = 1, Object.defineProperty(pbkdf2$2, "__esModule", { value: !0 }), pbkdf2$2.getSubtle = y, pbkdf2$2.pbkdf2Sha512Subtle = t, pbkdf2$2.pbkdf2Sha512Noble = d, pbkdf2$2.pbkdf2Sha512 = E;
  const o = requireBuild$3(), g = /* @__PURE__ */ requirePbkdf2$1(), c = /* @__PURE__ */ requireSha2();
  async function y() {
    var B;
    return (B = globalThis == null ? void 0 : globalThis.crypto) == null ? void 0 : B.subtle;
  }
  async function t(B, D, x, v, F) {
    return (0, o.assert)(B, "Argument subtle is falsy"), (0, o.assert)(typeof B == "object", "Argument subtle is not of type object"), (0, o.assert)(typeof B.importKey == "function", "subtle.importKey is not a function"), (0, o.assert)(typeof B.deriveBits == "function", "subtle.deriveBits is not a function"), B.importKey("raw", D, { name: "PBKDF2" }, !1, ["deriveBits"]).then((M) => B.deriveBits({
      name: "PBKDF2",
      salt: x,
      iterations: v,
      hash: { name: "SHA-512" }
    }, M, F * 8).then((U) => new Uint8Array(U)));
  }
  async function d(B, D, x, v) {
    return (0, g.pbkdf2Async)(c.sha512, B, D, { c: x, dkLen: v });
  }
  async function E(B, D, x, v) {
    const F = await y();
    return F ? t(F, B, D, x, v) : d(B, D, x, v);
  }
  return pbkdf2$2;
}
var sha = {}, utils$4 = {}, hasRequiredUtils$3;
function requireUtils$3() {
  if (hasRequiredUtils$3) return utils$4;
  hasRequiredUtils$3 = 1, Object.defineProperty(utils$4, "__esModule", { value: !0 }), utils$4.toRealUint8Array = o;
  function o(g) {
    return g instanceof Uint8Array ? g : Uint8Array.from(g);
  }
  return utils$4;
}
var hasRequiredSha;
function requireSha() {
  if (hasRequiredSha) return sha;
  hasRequiredSha = 1, Object.defineProperty(sha, "__esModule", { value: !0 }), sha.Sha512 = sha.Sha256 = void 0, sha.sha256 = y, sha.sha512 = d;
  const o = /* @__PURE__ */ requireSha2(), g = requireUtils$3();
  class c {
    constructor(B) {
      Vi(this, "blockSize", 512 / 8);
      Vi(this, "impl", o.sha256.create());
      B && this.update(B);
    }
    update(B) {
      return this.impl.update((0, g.toRealUint8Array)(B)), this;
    }
    digest() {
      return this.impl.digest();
    }
  }
  sha.Sha256 = c;
  function y(E) {
    return new c(E).digest();
  }
  class t {
    constructor(B) {
      Vi(this, "blockSize", 1024 / 8);
      Vi(this, "impl", o.sha512.create());
      B && this.update(B);
    }
    update(B) {
      return this.impl.update((0, g.toRealUint8Array)(B)), this;
    }
    digest() {
      return this.impl.digest();
    }
  }
  sha.Sha512 = t;
  function d(E) {
    return new t(E).digest();
  }
  return sha;
}
var hasRequiredBip39;
function requireBip39() {
  if (hasRequiredBip39) return bip39;
  hasRequiredBip39 = 1, Object.defineProperty(bip39, "__esModule", { value: !0 }), bip39.Bip39 = bip39.EnglishMnemonic = void 0, bip39.entropyToMnemonic = x, bip39.mnemonicToEntropy = H;
  const o = requireBuild$4(), g = requirePbkdf2(), c = requireSha(), y = [
    "abandon",
    "ability",
    "able",
    "about",
    "above",
    "absent",
    "absorb",
    "abstract",
    "absurd",
    "abuse",
    "access",
    "accident",
    "account",
    "accuse",
    "achieve",
    "acid",
    "acoustic",
    "acquire",
    "across",
    "act",
    "action",
    "actor",
    "actress",
    "actual",
    "adapt",
    "add",
    "addict",
    "address",
    "adjust",
    "admit",
    "adult",
    "advance",
    "advice",
    "aerobic",
    "affair",
    "afford",
    "afraid",
    "again",
    "age",
    "agent",
    "agree",
    "ahead",
    "aim",
    "air",
    "airport",
    "aisle",
    "alarm",
    "album",
    "alcohol",
    "alert",
    "alien",
    "all",
    "alley",
    "allow",
    "almost",
    "alone",
    "alpha",
    "already",
    "also",
    "alter",
    "always",
    "amateur",
    "amazing",
    "among",
    "amount",
    "amused",
    "analyst",
    "anchor",
    "ancient",
    "anger",
    "angle",
    "angry",
    "animal",
    "ankle",
    "announce",
    "annual",
    "another",
    "answer",
    "antenna",
    "antique",
    "anxiety",
    "any",
    "apart",
    "apology",
    "appear",
    "apple",
    "approve",
    "april",
    "arch",
    "arctic",
    "area",
    "arena",
    "argue",
    "arm",
    "armed",
    "armor",
    "army",
    "around",
    "arrange",
    "arrest",
    "arrive",
    "arrow",
    "art",
    "artefact",
    "artist",
    "artwork",
    "ask",
    "aspect",
    "assault",
    "asset",
    "assist",
    "assume",
    "asthma",
    "athlete",
    "atom",
    "attack",
    "attend",
    "attitude",
    "attract",
    "auction",
    "audit",
    "august",
    "aunt",
    "author",
    "auto",
    "autumn",
    "average",
    "avocado",
    "avoid",
    "awake",
    "aware",
    "away",
    "awesome",
    "awful",
    "awkward",
    "axis",
    "baby",
    "bachelor",
    "bacon",
    "badge",
    "bag",
    "balance",
    "balcony",
    "ball",
    "bamboo",
    "banana",
    "banner",
    "bar",
    "barely",
    "bargain",
    "barrel",
    "base",
    "basic",
    "basket",
    "battle",
    "beach",
    "bean",
    "beauty",
    "because",
    "become",
    "beef",
    "before",
    "begin",
    "behave",
    "behind",
    "believe",
    "below",
    "belt",
    "bench",
    "benefit",
    "best",
    "betray",
    "better",
    "between",
    "beyond",
    "bicycle",
    "bid",
    "bike",
    "bind",
    "biology",
    "bird",
    "birth",
    "bitter",
    "black",
    "blade",
    "blame",
    "blanket",
    "blast",
    "bleak",
    "bless",
    "blind",
    "blood",
    "blossom",
    "blouse",
    "blue",
    "blur",
    "blush",
    "board",
    "boat",
    "body",
    "boil",
    "bomb",
    "bone",
    "bonus",
    "book",
    "boost",
    "border",
    "boring",
    "borrow",
    "boss",
    "bottom",
    "bounce",
    "box",
    "boy",
    "bracket",
    "brain",
    "brand",
    "brass",
    "brave",
    "bread",
    "breeze",
    "brick",
    "bridge",
    "brief",
    "bright",
    "bring",
    "brisk",
    "broccoli",
    "broken",
    "bronze",
    "broom",
    "brother",
    "brown",
    "brush",
    "bubble",
    "buddy",
    "budget",
    "buffalo",
    "build",
    "bulb",
    "bulk",
    "bullet",
    "bundle",
    "bunker",
    "burden",
    "burger",
    "burst",
    "bus",
    "business",
    "busy",
    "butter",
    "buyer",
    "buzz",
    "cabbage",
    "cabin",
    "cable",
    "cactus",
    "cage",
    "cake",
    "call",
    "calm",
    "camera",
    "camp",
    "can",
    "canal",
    "cancel",
    "candy",
    "cannon",
    "canoe",
    "canvas",
    "canyon",
    "capable",
    "capital",
    "captain",
    "car",
    "carbon",
    "card",
    "cargo",
    "carpet",
    "carry",
    "cart",
    "case",
    "cash",
    "casino",
    "castle",
    "casual",
    "cat",
    "catalog",
    "catch",
    "category",
    "cattle",
    "caught",
    "cause",
    "caution",
    "cave",
    "ceiling",
    "celery",
    "cement",
    "census",
    "century",
    "cereal",
    "certain",
    "chair",
    "chalk",
    "champion",
    "change",
    "chaos",
    "chapter",
    "charge",
    "chase",
    "chat",
    "cheap",
    "check",
    "cheese",
    "chef",
    "cherry",
    "chest",
    "chicken",
    "chief",
    "child",
    "chimney",
    "choice",
    "choose",
    "chronic",
    "chuckle",
    "chunk",
    "churn",
    "cigar",
    "cinnamon",
    "circle",
    "citizen",
    "city",
    "civil",
    "claim",
    "clap",
    "clarify",
    "claw",
    "clay",
    "clean",
    "clerk",
    "clever",
    "click",
    "client",
    "cliff",
    "climb",
    "clinic",
    "clip",
    "clock",
    "clog",
    "close",
    "cloth",
    "cloud",
    "clown",
    "club",
    "clump",
    "cluster",
    "clutch",
    "coach",
    "coast",
    "coconut",
    "code",
    "coffee",
    "coil",
    "coin",
    "collect",
    "color",
    "column",
    "combine",
    "come",
    "comfort",
    "comic",
    "common",
    "company",
    "concert",
    "conduct",
    "confirm",
    "congress",
    "connect",
    "consider",
    "control",
    "convince",
    "cook",
    "cool",
    "copper",
    "copy",
    "coral",
    "core",
    "corn",
    "correct",
    "cost",
    "cotton",
    "couch",
    "country",
    "couple",
    "course",
    "cousin",
    "cover",
    "coyote",
    "crack",
    "cradle",
    "craft",
    "cram",
    "crane",
    "crash",
    "crater",
    "crawl",
    "crazy",
    "cream",
    "credit",
    "creek",
    "crew",
    "cricket",
    "crime",
    "crisp",
    "critic",
    "crop",
    "cross",
    "crouch",
    "crowd",
    "crucial",
    "cruel",
    "cruise",
    "crumble",
    "crunch",
    "crush",
    "cry",
    "crystal",
    "cube",
    "culture",
    "cup",
    "cupboard",
    "curious",
    "current",
    "curtain",
    "curve",
    "cushion",
    "custom",
    "cute",
    "cycle",
    "dad",
    "damage",
    "damp",
    "dance",
    "danger",
    "daring",
    "dash",
    "daughter",
    "dawn",
    "day",
    "deal",
    "debate",
    "debris",
    "decade",
    "december",
    "decide",
    "decline",
    "decorate",
    "decrease",
    "deer",
    "defense",
    "define",
    "defy",
    "degree",
    "delay",
    "deliver",
    "demand",
    "demise",
    "denial",
    "dentist",
    "deny",
    "depart",
    "depend",
    "deposit",
    "depth",
    "deputy",
    "derive",
    "describe",
    "desert",
    "design",
    "desk",
    "despair",
    "destroy",
    "detail",
    "detect",
    "develop",
    "device",
    "devote",
    "diagram",
    "dial",
    "diamond",
    "diary",
    "dice",
    "diesel",
    "diet",
    "differ",
    "digital",
    "dignity",
    "dilemma",
    "dinner",
    "dinosaur",
    "direct",
    "dirt",
    "disagree",
    "discover",
    "disease",
    "dish",
    "dismiss",
    "disorder",
    "display",
    "distance",
    "divert",
    "divide",
    "divorce",
    "dizzy",
    "doctor",
    "document",
    "dog",
    "doll",
    "dolphin",
    "domain",
    "donate",
    "donkey",
    "donor",
    "door",
    "dose",
    "double",
    "dove",
    "draft",
    "dragon",
    "drama",
    "drastic",
    "draw",
    "dream",
    "dress",
    "drift",
    "drill",
    "drink",
    "drip",
    "drive",
    "drop",
    "drum",
    "dry",
    "duck",
    "dumb",
    "dune",
    "during",
    "dust",
    "dutch",
    "duty",
    "dwarf",
    "dynamic",
    "eager",
    "eagle",
    "early",
    "earn",
    "earth",
    "easily",
    "east",
    "easy",
    "echo",
    "ecology",
    "economy",
    "edge",
    "edit",
    "educate",
    "effort",
    "egg",
    "eight",
    "either",
    "elbow",
    "elder",
    "electric",
    "elegant",
    "element",
    "elephant",
    "elevator",
    "elite",
    "else",
    "embark",
    "embody",
    "embrace",
    "emerge",
    "emotion",
    "employ",
    "empower",
    "empty",
    "enable",
    "enact",
    "end",
    "endless",
    "endorse",
    "enemy",
    "energy",
    "enforce",
    "engage",
    "engine",
    "enhance",
    "enjoy",
    "enlist",
    "enough",
    "enrich",
    "enroll",
    "ensure",
    "enter",
    "entire",
    "entry",
    "envelope",
    "episode",
    "equal",
    "equip",
    "era",
    "erase",
    "erode",
    "erosion",
    "error",
    "erupt",
    "escape",
    "essay",
    "essence",
    "estate",
    "eternal",
    "ethics",
    "evidence",
    "evil",
    "evoke",
    "evolve",
    "exact",
    "example",
    "excess",
    "exchange",
    "excite",
    "exclude",
    "excuse",
    "execute",
    "exercise",
    "exhaust",
    "exhibit",
    "exile",
    "exist",
    "exit",
    "exotic",
    "expand",
    "expect",
    "expire",
    "explain",
    "expose",
    "express",
    "extend",
    "extra",
    "eye",
    "eyebrow",
    "fabric",
    "face",
    "faculty",
    "fade",
    "faint",
    "faith",
    "fall",
    "false",
    "fame",
    "family",
    "famous",
    "fan",
    "fancy",
    "fantasy",
    "farm",
    "fashion",
    "fat",
    "fatal",
    "father",
    "fatigue",
    "fault",
    "favorite",
    "feature",
    "february",
    "federal",
    "fee",
    "feed",
    "feel",
    "female",
    "fence",
    "festival",
    "fetch",
    "fever",
    "few",
    "fiber",
    "fiction",
    "field",
    "figure",
    "file",
    "film",
    "filter",
    "final",
    "find",
    "fine",
    "finger",
    "finish",
    "fire",
    "firm",
    "first",
    "fiscal",
    "fish",
    "fit",
    "fitness",
    "fix",
    "flag",
    "flame",
    "flash",
    "flat",
    "flavor",
    "flee",
    "flight",
    "flip",
    "float",
    "flock",
    "floor",
    "flower",
    "fluid",
    "flush",
    "fly",
    "foam",
    "focus",
    "fog",
    "foil",
    "fold",
    "follow",
    "food",
    "foot",
    "force",
    "forest",
    "forget",
    "fork",
    "fortune",
    "forum",
    "forward",
    "fossil",
    "foster",
    "found",
    "fox",
    "fragile",
    "frame",
    "frequent",
    "fresh",
    "friend",
    "fringe",
    "frog",
    "front",
    "frost",
    "frown",
    "frozen",
    "fruit",
    "fuel",
    "fun",
    "funny",
    "furnace",
    "fury",
    "future",
    "gadget",
    "gain",
    "galaxy",
    "gallery",
    "game",
    "gap",
    "garage",
    "garbage",
    "garden",
    "garlic",
    "garment",
    "gas",
    "gasp",
    "gate",
    "gather",
    "gauge",
    "gaze",
    "general",
    "genius",
    "genre",
    "gentle",
    "genuine",
    "gesture",
    "ghost",
    "giant",
    "gift",
    "giggle",
    "ginger",
    "giraffe",
    "girl",
    "give",
    "glad",
    "glance",
    "glare",
    "glass",
    "glide",
    "glimpse",
    "globe",
    "gloom",
    "glory",
    "glove",
    "glow",
    "glue",
    "goat",
    "goddess",
    "gold",
    "good",
    "goose",
    "gorilla",
    "gospel",
    "gossip",
    "govern",
    "gown",
    "grab",
    "grace",
    "grain",
    "grant",
    "grape",
    "grass",
    "gravity",
    "great",
    "green",
    "grid",
    "grief",
    "grit",
    "grocery",
    "group",
    "grow",
    "grunt",
    "guard",
    "guess",
    "guide",
    "guilt",
    "guitar",
    "gun",
    "gym",
    "habit",
    "hair",
    "half",
    "hammer",
    "hamster",
    "hand",
    "happy",
    "harbor",
    "hard",
    "harsh",
    "harvest",
    "hat",
    "have",
    "hawk",
    "hazard",
    "head",
    "health",
    "heart",
    "heavy",
    "hedgehog",
    "height",
    "hello",
    "helmet",
    "help",
    "hen",
    "hero",
    "hidden",
    "high",
    "hill",
    "hint",
    "hip",
    "hire",
    "history",
    "hobby",
    "hockey",
    "hold",
    "hole",
    "holiday",
    "hollow",
    "home",
    "honey",
    "hood",
    "hope",
    "horn",
    "horror",
    "horse",
    "hospital",
    "host",
    "hotel",
    "hour",
    "hover",
    "hub",
    "huge",
    "human",
    "humble",
    "humor",
    "hundred",
    "hungry",
    "hunt",
    "hurdle",
    "hurry",
    "hurt",
    "husband",
    "hybrid",
    "ice",
    "icon",
    "idea",
    "identify",
    "idle",
    "ignore",
    "ill",
    "illegal",
    "illness",
    "image",
    "imitate",
    "immense",
    "immune",
    "impact",
    "impose",
    "improve",
    "impulse",
    "inch",
    "include",
    "income",
    "increase",
    "index",
    "indicate",
    "indoor",
    "industry",
    "infant",
    "inflict",
    "inform",
    "inhale",
    "inherit",
    "initial",
    "inject",
    "injury",
    "inmate",
    "inner",
    "innocent",
    "input",
    "inquiry",
    "insane",
    "insect",
    "inside",
    "inspire",
    "install",
    "intact",
    "interest",
    "into",
    "invest",
    "invite",
    "involve",
    "iron",
    "island",
    "isolate",
    "issue",
    "item",
    "ivory",
    "jacket",
    "jaguar",
    "jar",
    "jazz",
    "jealous",
    "jeans",
    "jelly",
    "jewel",
    "job",
    "join",
    "joke",
    "journey",
    "joy",
    "judge",
    "juice",
    "jump",
    "jungle",
    "junior",
    "junk",
    "just",
    "kangaroo",
    "keen",
    "keep",
    "ketchup",
    "key",
    "kick",
    "kid",
    "kidney",
    "kind",
    "kingdom",
    "kiss",
    "kit",
    "kitchen",
    "kite",
    "kitten",
    "kiwi",
    "knee",
    "knife",
    "knock",
    "know",
    "lab",
    "label",
    "labor",
    "ladder",
    "lady",
    "lake",
    "lamp",
    "language",
    "laptop",
    "large",
    "later",
    "latin",
    "laugh",
    "laundry",
    "lava",
    "law",
    "lawn",
    "lawsuit",
    "layer",
    "lazy",
    "leader",
    "leaf",
    "learn",
    "leave",
    "lecture",
    "left",
    "leg",
    "legal",
    "legend",
    "leisure",
    "lemon",
    "lend",
    "length",
    "lens",
    "leopard",
    "lesson",
    "letter",
    "level",
    "liar",
    "liberty",
    "library",
    "license",
    "life",
    "lift",
    "light",
    "like",
    "limb",
    "limit",
    "link",
    "lion",
    "liquid",
    "list",
    "little",
    "live",
    "lizard",
    "load",
    "loan",
    "lobster",
    "local",
    "lock",
    "logic",
    "lonely",
    "long",
    "loop",
    "lottery",
    "loud",
    "lounge",
    "love",
    "loyal",
    "lucky",
    "luggage",
    "lumber",
    "lunar",
    "lunch",
    "luxury",
    "lyrics",
    "machine",
    "mad",
    "magic",
    "magnet",
    "maid",
    "mail",
    "main",
    "major",
    "make",
    "mammal",
    "man",
    "manage",
    "mandate",
    "mango",
    "mansion",
    "manual",
    "maple",
    "marble",
    "march",
    "margin",
    "marine",
    "market",
    "marriage",
    "mask",
    "mass",
    "master",
    "match",
    "material",
    "math",
    "matrix",
    "matter",
    "maximum",
    "maze",
    "meadow",
    "mean",
    "measure",
    "meat",
    "mechanic",
    "medal",
    "media",
    "melody",
    "melt",
    "member",
    "memory",
    "mention",
    "menu",
    "mercy",
    "merge",
    "merit",
    "merry",
    "mesh",
    "message",
    "metal",
    "method",
    "middle",
    "midnight",
    "milk",
    "million",
    "mimic",
    "mind",
    "minimum",
    "minor",
    "minute",
    "miracle",
    "mirror",
    "misery",
    "miss",
    "mistake",
    "mix",
    "mixed",
    "mixture",
    "mobile",
    "model",
    "modify",
    "mom",
    "moment",
    "monitor",
    "monkey",
    "monster",
    "month",
    "moon",
    "moral",
    "more",
    "morning",
    "mosquito",
    "mother",
    "motion",
    "motor",
    "mountain",
    "mouse",
    "move",
    "movie",
    "much",
    "muffin",
    "mule",
    "multiply",
    "muscle",
    "museum",
    "mushroom",
    "music",
    "must",
    "mutual",
    "myself",
    "mystery",
    "myth",
    "naive",
    "name",
    "napkin",
    "narrow",
    "nasty",
    "nation",
    "nature",
    "near",
    "neck",
    "need",
    "negative",
    "neglect",
    "neither",
    "nephew",
    "nerve",
    "nest",
    "net",
    "network",
    "neutral",
    "never",
    "news",
    "next",
    "nice",
    "night",
    "noble",
    "noise",
    "nominee",
    "noodle",
    "normal",
    "north",
    "nose",
    "notable",
    "note",
    "nothing",
    "notice",
    "novel",
    "now",
    "nuclear",
    "number",
    "nurse",
    "nut",
    "oak",
    "obey",
    "object",
    "oblige",
    "obscure",
    "observe",
    "obtain",
    "obvious",
    "occur",
    "ocean",
    "october",
    "odor",
    "off",
    "offer",
    "office",
    "often",
    "oil",
    "okay",
    "old",
    "olive",
    "olympic",
    "omit",
    "once",
    "one",
    "onion",
    "online",
    "only",
    "open",
    "opera",
    "opinion",
    "oppose",
    "option",
    "orange",
    "orbit",
    "orchard",
    "order",
    "ordinary",
    "organ",
    "orient",
    "original",
    "orphan",
    "ostrich",
    "other",
    "outdoor",
    "outer",
    "output",
    "outside",
    "oval",
    "oven",
    "over",
    "own",
    "owner",
    "oxygen",
    "oyster",
    "ozone",
    "pact",
    "paddle",
    "page",
    "pair",
    "palace",
    "palm",
    "panda",
    "panel",
    "panic",
    "panther",
    "paper",
    "parade",
    "parent",
    "park",
    "parrot",
    "party",
    "pass",
    "patch",
    "path",
    "patient",
    "patrol",
    "pattern",
    "pause",
    "pave",
    "payment",
    "peace",
    "peanut",
    "pear",
    "peasant",
    "pelican",
    "pen",
    "penalty",
    "pencil",
    "people",
    "pepper",
    "perfect",
    "permit",
    "person",
    "pet",
    "phone",
    "photo",
    "phrase",
    "physical",
    "piano",
    "picnic",
    "picture",
    "piece",
    "pig",
    "pigeon",
    "pill",
    "pilot",
    "pink",
    "pioneer",
    "pipe",
    "pistol",
    "pitch",
    "pizza",
    "place",
    "planet",
    "plastic",
    "plate",
    "play",
    "please",
    "pledge",
    "pluck",
    "plug",
    "plunge",
    "poem",
    "poet",
    "point",
    "polar",
    "pole",
    "police",
    "pond",
    "pony",
    "pool",
    "popular",
    "portion",
    "position",
    "possible",
    "post",
    "potato",
    "pottery",
    "poverty",
    "powder",
    "power",
    "practice",
    "praise",
    "predict",
    "prefer",
    "prepare",
    "present",
    "pretty",
    "prevent",
    "price",
    "pride",
    "primary",
    "print",
    "priority",
    "prison",
    "private",
    "prize",
    "problem",
    "process",
    "produce",
    "profit",
    "program",
    "project",
    "promote",
    "proof",
    "property",
    "prosper",
    "protect",
    "proud",
    "provide",
    "public",
    "pudding",
    "pull",
    "pulp",
    "pulse",
    "pumpkin",
    "punch",
    "pupil",
    "puppy",
    "purchase",
    "purity",
    "purpose",
    "purse",
    "push",
    "put",
    "puzzle",
    "pyramid",
    "quality",
    "quantum",
    "quarter",
    "question",
    "quick",
    "quit",
    "quiz",
    "quote",
    "rabbit",
    "raccoon",
    "race",
    "rack",
    "radar",
    "radio",
    "rail",
    "rain",
    "raise",
    "rally",
    "ramp",
    "ranch",
    "random",
    "range",
    "rapid",
    "rare",
    "rate",
    "rather",
    "raven",
    "raw",
    "razor",
    "ready",
    "real",
    "reason",
    "rebel",
    "rebuild",
    "recall",
    "receive",
    "recipe",
    "record",
    "recycle",
    "reduce",
    "reflect",
    "reform",
    "refuse",
    "region",
    "regret",
    "regular",
    "reject",
    "relax",
    "release",
    "relief",
    "rely",
    "remain",
    "remember",
    "remind",
    "remove",
    "render",
    "renew",
    "rent",
    "reopen",
    "repair",
    "repeat",
    "replace",
    "report",
    "require",
    "rescue",
    "resemble",
    "resist",
    "resource",
    "response",
    "result",
    "retire",
    "retreat",
    "return",
    "reunion",
    "reveal",
    "review",
    "reward",
    "rhythm",
    "rib",
    "ribbon",
    "rice",
    "rich",
    "ride",
    "ridge",
    "rifle",
    "right",
    "rigid",
    "ring",
    "riot",
    "ripple",
    "risk",
    "ritual",
    "rival",
    "river",
    "road",
    "roast",
    "robot",
    "robust",
    "rocket",
    "romance",
    "roof",
    "rookie",
    "room",
    "rose",
    "rotate",
    "rough",
    "round",
    "route",
    "royal",
    "rubber",
    "rude",
    "rug",
    "rule",
    "run",
    "runway",
    "rural",
    "sad",
    "saddle",
    "sadness",
    "safe",
    "sail",
    "salad",
    "salmon",
    "salon",
    "salt",
    "salute",
    "same",
    "sample",
    "sand",
    "satisfy",
    "satoshi",
    "sauce",
    "sausage",
    "save",
    "say",
    "scale",
    "scan",
    "scare",
    "scatter",
    "scene",
    "scheme",
    "school",
    "science",
    "scissors",
    "scorpion",
    "scout",
    "scrap",
    "screen",
    "script",
    "scrub",
    "sea",
    "search",
    "season",
    "seat",
    "second",
    "secret",
    "section",
    "security",
    "seed",
    "seek",
    "segment",
    "select",
    "sell",
    "seminar",
    "senior",
    "sense",
    "sentence",
    "series",
    "service",
    "session",
    "settle",
    "setup",
    "seven",
    "shadow",
    "shaft",
    "shallow",
    "share",
    "shed",
    "shell",
    "sheriff",
    "shield",
    "shift",
    "shine",
    "ship",
    "shiver",
    "shock",
    "shoe",
    "shoot",
    "shop",
    "short",
    "shoulder",
    "shove",
    "shrimp",
    "shrug",
    "shuffle",
    "shy",
    "sibling",
    "sick",
    "side",
    "siege",
    "sight",
    "sign",
    "silent",
    "silk",
    "silly",
    "silver",
    "similar",
    "simple",
    "since",
    "sing",
    "siren",
    "sister",
    "situate",
    "six",
    "size",
    "skate",
    "sketch",
    "ski",
    "skill",
    "skin",
    "skirt",
    "skull",
    "slab",
    "slam",
    "sleep",
    "slender",
    "slice",
    "slide",
    "slight",
    "slim",
    "slogan",
    "slot",
    "slow",
    "slush",
    "small",
    "smart",
    "smile",
    "smoke",
    "smooth",
    "snack",
    "snake",
    "snap",
    "sniff",
    "snow",
    "soap",
    "soccer",
    "social",
    "sock",
    "soda",
    "soft",
    "solar",
    "soldier",
    "solid",
    "solution",
    "solve",
    "someone",
    "song",
    "soon",
    "sorry",
    "sort",
    "soul",
    "sound",
    "soup",
    "source",
    "south",
    "space",
    "spare",
    "spatial",
    "spawn",
    "speak",
    "special",
    "speed",
    "spell",
    "spend",
    "sphere",
    "spice",
    "spider",
    "spike",
    "spin",
    "spirit",
    "split",
    "spoil",
    "sponsor",
    "spoon",
    "sport",
    "spot",
    "spray",
    "spread",
    "spring",
    "spy",
    "square",
    "squeeze",
    "squirrel",
    "stable",
    "stadium",
    "staff",
    "stage",
    "stairs",
    "stamp",
    "stand",
    "start",
    "state",
    "stay",
    "steak",
    "steel",
    "stem",
    "step",
    "stereo",
    "stick",
    "still",
    "sting",
    "stock",
    "stomach",
    "stone",
    "stool",
    "story",
    "stove",
    "strategy",
    "street",
    "strike",
    "strong",
    "struggle",
    "student",
    "stuff",
    "stumble",
    "style",
    "subject",
    "submit",
    "subway",
    "success",
    "such",
    "sudden",
    "suffer",
    "sugar",
    "suggest",
    "suit",
    "summer",
    "sun",
    "sunny",
    "sunset",
    "super",
    "supply",
    "supreme",
    "sure",
    "surface",
    "surge",
    "surprise",
    "surround",
    "survey",
    "suspect",
    "sustain",
    "swallow",
    "swamp",
    "swap",
    "swarm",
    "swear",
    "sweet",
    "swift",
    "swim",
    "swing",
    "switch",
    "sword",
    "symbol",
    "symptom",
    "syrup",
    "system",
    "table",
    "tackle",
    "tag",
    "tail",
    "talent",
    "talk",
    "tank",
    "tape",
    "target",
    "task",
    "taste",
    "tattoo",
    "taxi",
    "teach",
    "team",
    "tell",
    "ten",
    "tenant",
    "tennis",
    "tent",
    "term",
    "test",
    "text",
    "thank",
    "that",
    "theme",
    "then",
    "theory",
    "there",
    "they",
    "thing",
    "this",
    "thought",
    "three",
    "thrive",
    "throw",
    "thumb",
    "thunder",
    "ticket",
    "tide",
    "tiger",
    "tilt",
    "timber",
    "time",
    "tiny",
    "tip",
    "tired",
    "tissue",
    "title",
    "toast",
    "tobacco",
    "today",
    "toddler",
    "toe",
    "together",
    "toilet",
    "token",
    "tomato",
    "tomorrow",
    "tone",
    "tongue",
    "tonight",
    "tool",
    "tooth",
    "top",
    "topic",
    "topple",
    "torch",
    "tornado",
    "tortoise",
    "toss",
    "total",
    "tourist",
    "toward",
    "tower",
    "town",
    "toy",
    "track",
    "trade",
    "traffic",
    "tragic",
    "train",
    "transfer",
    "trap",
    "trash",
    "travel",
    "tray",
    "treat",
    "tree",
    "trend",
    "trial",
    "tribe",
    "trick",
    "trigger",
    "trim",
    "trip",
    "trophy",
    "trouble",
    "truck",
    "true",
    "truly",
    "trumpet",
    "trust",
    "truth",
    "try",
    "tube",
    "tuition",
    "tumble",
    "tuna",
    "tunnel",
    "turkey",
    "turn",
    "turtle",
    "twelve",
    "twenty",
    "twice",
    "twin",
    "twist",
    "two",
    "type",
    "typical",
    "ugly",
    "umbrella",
    "unable",
    "unaware",
    "uncle",
    "uncover",
    "under",
    "undo",
    "unfair",
    "unfold",
    "unhappy",
    "uniform",
    "unique",
    "unit",
    "universe",
    "unknown",
    "unlock",
    "until",
    "unusual",
    "unveil",
    "update",
    "upgrade",
    "uphold",
    "upon",
    "upper",
    "upset",
    "urban",
    "urge",
    "usage",
    "use",
    "used",
    "useful",
    "useless",
    "usual",
    "utility",
    "vacant",
    "vacuum",
    "vague",
    "valid",
    "valley",
    "valve",
    "van",
    "vanish",
    "vapor",
    "various",
    "vast",
    "vault",
    "vehicle",
    "velvet",
    "vendor",
    "venture",
    "venue",
    "verb",
    "verify",
    "version",
    "very",
    "vessel",
    "veteran",
    "viable",
    "vibrant",
    "vicious",
    "victory",
    "video",
    "view",
    "village",
    "vintage",
    "violin",
    "virtual",
    "virus",
    "visa",
    "visit",
    "visual",
    "vital",
    "vivid",
    "vocal",
    "voice",
    "void",
    "volcano",
    "volume",
    "vote",
    "voyage",
    "wage",
    "wagon",
    "wait",
    "walk",
    "wall",
    "walnut",
    "want",
    "warfare",
    "warm",
    "warrior",
    "wash",
    "wasp",
    "waste",
    "water",
    "wave",
    "way",
    "wealth",
    "weapon",
    "wear",
    "weasel",
    "weather",
    "web",
    "wedding",
    "weekend",
    "weird",
    "welcome",
    "west",
    "wet",
    "whale",
    "what",
    "wheat",
    "wheel",
    "when",
    "where",
    "whip",
    "whisper",
    "wide",
    "width",
    "wife",
    "wild",
    "will",
    "win",
    "window",
    "wine",
    "wing",
    "wink",
    "winner",
    "winter",
    "wire",
    "wisdom",
    "wise",
    "wish",
    "witness",
    "wolf",
    "woman",
    "wonder",
    "wood",
    "wool",
    "word",
    "work",
    "world",
    "worry",
    "worth",
    "wrap",
    "wreck",
    "wrestle",
    "wrist",
    "write",
    "wrong",
    "yard",
    "year",
    "yellow",
    "you",
    "young",
    "youth",
    "zebra",
    "zero",
    "zone",
    "zoo"
  ];
  function t(Ee) {
    return Array.from(Ee).map((Se) => Se.toString(2).padStart(8, "0")).join("");
  }
  function d(Ee) {
    const ze = Ee.length * 8 / 32, He = (0, c.sha256)(Ee);
    return t(He).slice(0, ze);
  }
  function E(Ee) {
    return parseInt(Ee, 2);
  }
  const B = [16, 20, 24, 28, 32], D = [12, 15, 18, 21, 24];
  function x(Ee) {
    if (B.indexOf(Ee.length) === -1)
      throw new Error("invalid input length");
    const Se = t(Ee), ze = d(Ee);
    return (Se + ze).match(/(.{11})/g).map((ve) => {
      const Fe = E(ve);
      return y[Fe];
    }).join(" ");
  }
  const v = "Invalid number of words", F = "Found word that is not in the wordlist", M = "Invalid entropy", U = "Invalid mnemonic checksum";
  function L(Ee) {
    return Ee.normalize("NFKD");
  }
  function H(Ee) {
    const Se = L(Ee).split(" ");
    if (!D.includes(Se.length))
      throw new Error(v);
    const ze = Se.map((Be) => {
      const ke = y.indexOf(Be);
      if (ke === -1)
        throw new Error(F);
      return ke.toString(2).padStart(11, "0");
    }).join(""), He = Math.floor(ze.length / 33) * 32, Pe = ze.slice(0, He), De = ze.slice(He), ve = Pe.match(/(.{1,8})/g).map(E);
    if (ve.length < 16 || ve.length > 32 || ve.length % 4 !== 0)
      throw new Error(M);
    const Fe = Uint8Array.from(ve);
    if (d(Fe) !== De)
      throw new Error(U);
    return Fe;
  }
  const Ie = class Ie {
    constructor(Se) {
      Vi(this, "data");
      if (!Ie.mnemonicMatcher.test(Se))
        throw new Error("Invalid mnemonic format");
      const ze = Se.split(" "), He = [12, 15, 18, 21, 24];
      if (He.indexOf(ze.length) === -1)
        throw new Error(`Invalid word count in mnemonic (allowed: ${He} got: ${ze.length})`);
      for (const Pe of ze)
        if (Ie.wordlist.indexOf(Pe) === -1)
          throw new Error("Mnemonic contains invalid word");
      H(Se), this.data = Se;
    }
    toString() {
      return this.data;
    }
  };
  Vi(Ie, "wordlist", y), // list of space separated lower case words (1 or more)
  Vi(Ie, "mnemonicMatcher", /^[a-z]+( [a-z]+)*$/);
  let fe = Ie;
  bip39.EnglishMnemonic = fe;
  class ge {
    /**
     * Encodes raw entropy of length 16, 20, 24, 28 or 32 bytes as an English mnemonic between 12 and 24 words.
     *
     * | Entropy            | Words |
     * |--------------------|-------|
     * | 128 bit (16 bytes) |    12 |
     * | 160 bit (20 bytes) |    15 |
     * | 192 bit (24 bytes) |    18 |
     * | 224 bit (28 bytes) |    21 |
     * | 256 bit (32 bytes) |    24 |
     *
     *
     * @see https://github.com/bitcoin/bips/blob/master/bip-0039.mediawiki#generating-the-mnemonic
     * @param entropy The entropy to be encoded. This must be cryptographically secure.
     */
    static encode(Se) {
      return new fe(x(Se));
    }
    static decode(Se) {
      return H(Se.toString());
    }
    static async mnemonicToSeed(Se, ze) {
      const He = (0, o.toUtf8)(L(Se.toString())), Pe = "mnemonic" + (ze ? L(ze) : ""), De = (0, o.toUtf8)(Pe);
      return (0, g.pbkdf2Sha512)(He, De, 2048, 64);
    }
  }
  return bip39.Bip39 = ge, bip39;
}
var hmac$1 = {}, hasRequiredHmac;
function requireHmac() {
  if (hasRequiredHmac) return hmac$1;
  hasRequiredHmac = 1, Object.defineProperty(hmac$1, "__esModule", { value: !0 }), hmac$1.Hmac = void 0;
  class o {
    constructor(c, y) {
      Vi(this, "blockSize");
      Vi(this, "messageHasher");
      Vi(this, "oKeyPad");
      Vi(this, "iKeyPad");
      Vi(this, "hash");
      const t = new c().blockSize;
      this.hash = (E) => new c().update(E).digest();
      let d = y;
      if (d.length > t && (d = this.hash(d)), d.length < t) {
        const E = new Uint8Array(t - d.length);
        d = new Uint8Array([...d, ...E]);
      }
      this.oKeyPad = d.map((E) => E ^ 92), this.iKeyPad = d.map((E) => E ^ 54), this.messageHasher = new c(), this.blockSize = t, this.update(this.iKeyPad);
    }
    update(c) {
      return this.messageHasher.update(c), this;
    }
    digest() {
      const c = this.messageHasher.digest();
      return this.hash(new Uint8Array([...this.oKeyPad, ...c]));
    }
  }
  return hmac$1.Hmac = o, hmac$1;
}
var keccak$1 = {}, sha3$1 = {}, hasRequiredSha3;
function requireSha3() {
  if (hasRequiredSha3) return sha3$1;
  hasRequiredSha3 = 1, Object.defineProperty(sha3$1, "__esModule", { value: !0 }), sha3$1.shake256 = sha3$1.shake128 = sha3$1.keccak_512 = sha3$1.keccak_384 = sha3$1.keccak_256 = sha3$1.keccak_224 = sha3$1.sha3_512 = sha3$1.sha3_384 = sha3$1.sha3_256 = sha3$1.sha3_224 = sha3$1.Keccak = void 0, sha3$1.keccakP = fe;
  const o = /* @__PURE__ */ require_u64$1(), g = /* @__PURE__ */ requireUtils$j(), c = BigInt(0), y = BigInt(1), t = BigInt(2), d = BigInt(7), E = BigInt(256), B = BigInt(113), D = [], x = [], v = [];
  for (let Se = 0, ze = y, He = 1, Pe = 0; Se < 24; Se++) {
    [He, Pe] = [Pe, (2 * He + 3 * Pe) % 5], D.push(2 * (5 * Pe + He)), x.push((Se + 1) * (Se + 2) / 2 % 64);
    let De = c;
    for (let ve = 0; ve < 7; ve++)
      ze = (ze << y ^ (ze >> d) * B) % E, ze & t && (De ^= y << (y << /* @__PURE__ */ BigInt(ve)) - y);
    v.push(De);
  }
  const F = (0, o.split)(v, !0), M = F[0], U = F[1], L = (Se, ze, He) => He > 32 ? (0, o.rotlBH)(Se, ze, He) : (0, o.rotlSH)(Se, ze, He), H = (Se, ze, He) => He > 32 ? (0, o.rotlBL)(Se, ze, He) : (0, o.rotlSL)(Se, ze, He);
  function fe(Se, ze = 24) {
    const He = new Uint32Array(10);
    for (let Pe = 24 - ze; Pe < 24; Pe++) {
      for (let Fe = 0; Fe < 10; Fe++)
        He[Fe] = Se[Fe] ^ Se[Fe + 10] ^ Se[Fe + 20] ^ Se[Fe + 30] ^ Se[Fe + 40];
      for (let Fe = 0; Fe < 10; Fe += 2) {
        const be = (Fe + 8) % 10, Be = (Fe + 2) % 10, ke = He[Be], xe = He[Be + 1], Ne = L(ke, xe, 1) ^ He[be], Et = H(ke, xe, 1) ^ He[be + 1];
        for (let st = 0; st < 50; st += 10)
          Se[Fe + st] ^= Ne, Se[Fe + st + 1] ^= Et;
      }
      let De = Se[2], ve = Se[3];
      for (let Fe = 0; Fe < 24; Fe++) {
        const be = x[Fe], Be = L(De, ve, be), ke = H(De, ve, be), xe = D[Fe];
        De = Se[xe], ve = Se[xe + 1], Se[xe] = Be, Se[xe + 1] = ke;
      }
      for (let Fe = 0; Fe < 50; Fe += 10) {
        for (let be = 0; be < 10; be++)
          He[be] = Se[Fe + be];
        for (let be = 0; be < 10; be++)
          Se[Fe + be] ^= ~He[(be + 2) % 10] & He[(be + 4) % 10];
      }
      Se[0] ^= M[Pe], Se[1] ^= U[Pe];
    }
    (0, g.clean)(He);
  }
  class ge extends g.Hash {
    // NOTE: we accept arguments in bytes instead of bits here.
    constructor(ze, He, Pe, De = !1, ve = 24) {
      if (super(), this.pos = 0, this.posOut = 0, this.finished = !1, this.destroyed = !1, this.enableXOF = !1, this.blockLen = ze, this.suffix = He, this.outputLen = Pe, this.enableXOF = De, this.rounds = ve, (0, g.anumber)(Pe), !(0 < ze && ze < 200))
        throw new Error("only keccak-f1600 function is supported");
      this.state = new Uint8Array(200), this.state32 = (0, g.u32)(this.state);
    }
    clone() {
      return this._cloneInto();
    }
    keccak() {
      (0, g.swap32IfBE)(this.state32), fe(this.state32, this.rounds), (0, g.swap32IfBE)(this.state32), this.posOut = 0, this.pos = 0;
    }
    update(ze) {
      (0, g.aexists)(this), ze = (0, g.toBytes)(ze), (0, g.abytes)(ze);
      const { blockLen: He, state: Pe } = this, De = ze.length;
      for (let ve = 0; ve < De; ) {
        const Fe = Math.min(He - this.pos, De - ve);
        for (let be = 0; be < Fe; be++)
          Pe[this.pos++] ^= ze[ve++];
        this.pos === He && this.keccak();
      }
      return this;
    }
    finish() {
      if (this.finished)
        return;
      this.finished = !0;
      const { state: ze, suffix: He, pos: Pe, blockLen: De } = this;
      ze[Pe] ^= He, (He & 128) !== 0 && Pe === De - 1 && this.keccak(), ze[De - 1] ^= 128, this.keccak();
    }
    writeInto(ze) {
      (0, g.aexists)(this, !1), (0, g.abytes)(ze), this.finish();
      const He = this.state, { blockLen: Pe } = this;
      for (let De = 0, ve = ze.length; De < ve; ) {
        this.posOut >= Pe && this.keccak();
        const Fe = Math.min(Pe - this.posOut, ve - De);
        ze.set(He.subarray(this.posOut, this.posOut + Fe), De), this.posOut += Fe, De += Fe;
      }
      return ze;
    }
    xofInto(ze) {
      if (!this.enableXOF)
        throw new Error("XOF is not possible for this instance");
      return this.writeInto(ze);
    }
    xof(ze) {
      return (0, g.anumber)(ze), this.xofInto(new Uint8Array(ze));
    }
    digestInto(ze) {
      if ((0, g.aoutput)(ze, this), this.finished)
        throw new Error("digest() was already called");
      return this.writeInto(ze), this.destroy(), ze;
    }
    digest() {
      return this.digestInto(new Uint8Array(this.outputLen));
    }
    destroy() {
      this.destroyed = !0, (0, g.clean)(this.state);
    }
    _cloneInto(ze) {
      const { blockLen: He, suffix: Pe, outputLen: De, rounds: ve, enableXOF: Fe } = this;
      return ze || (ze = new ge(He, Pe, De, Fe, ve)), ze.state32.set(this.state32), ze.pos = this.pos, ze.posOut = this.posOut, ze.finished = this.finished, ze.rounds = ve, ze.suffix = Pe, ze.outputLen = De, ze.enableXOF = Fe, ze.destroyed = this.destroyed, ze;
    }
  }
  sha3$1.Keccak = ge;
  const Ie = (Se, ze, He) => (0, g.createHasher)(() => new ge(ze, Se, He));
  sha3$1.sha3_224 = Ie(6, 144, 224 / 8), sha3$1.sha3_256 = Ie(6, 136, 256 / 8), sha3$1.sha3_384 = Ie(6, 104, 384 / 8), sha3$1.sha3_512 = Ie(6, 72, 512 / 8), sha3$1.keccak_224 = Ie(1, 144, 224 / 8), sha3$1.keccak_256 = Ie(1, 136, 256 / 8), sha3$1.keccak_384 = Ie(1, 104, 384 / 8), sha3$1.keccak_512 = Ie(1, 72, 512 / 8);
  const Ee = (Se, ze, He) => (0, g.createXOFer)((Pe = {}) => new ge(ze, Se, Pe.dkLen === void 0 ? He : Pe.dkLen, !0));
  return sha3$1.shake128 = Ee(31, 168, 128 / 8), sha3$1.shake256 = Ee(31, 136, 256 / 8), sha3$1;
}
var hasRequiredKeccak;
function requireKeccak() {
  if (hasRequiredKeccak) return keccak$1;
  hasRequiredKeccak = 1, Object.defineProperty(keccak$1, "__esModule", { value: !0 }), keccak$1.Keccak256 = void 0, keccak$1.keccak256 = y;
  const o = /* @__PURE__ */ requireSha3(), g = requireUtils$3();
  class c {
    constructor(d) {
      Vi(this, "blockSize", 512 / 8);
      Vi(this, "impl", o.keccak_256.create());
      d && this.update(d);
    }
    update(d) {
      return this.impl.update((0, g.toRealUint8Array)(d)), this;
    }
    digest() {
      return this.impl.digest();
    }
  }
  keccak$1.Keccak256 = c;
  function y(t) {
    return new c(t).digest();
  }
  return keccak$1;
}
var libsodium = {}, chacha = {}, _arx = {}, utils$3 = {}, hasRequiredUtils$2;
function requireUtils$2() {
  return hasRequiredUtils$2 || (hasRequiredUtils$2 = 1, function(o) {
    Object.defineProperty(o, "__esModule", { value: !0 }), o.wrapCipher = o.Hash = o.nextTick = o.isLE = void 0, o.isBytes = g, o.abool = c, o.anumber = y, o.abytes = t, o.ahash = d, o.aexists = E, o.aoutput = B, o.u8 = D, o.u32 = x, o.clean = v, o.createView = F, o.bytesToHex = L, o.hexToBytes = ge, o.hexToNumber = Ie, o.bytesToNumberBE = Ee, o.numberToBytesBE = Se, o.utf8ToBytes = He, o.bytesToUtf8 = Pe, o.toBytes = De, o.overlapBytes = ve, o.complexOverlapBytes = Fe, o.concatBytes = be, o.checkOpts = Be, o.equalBytes = ke, o.getOutput = Et, o.setBigUint64 = st, o.u64Lengths = Dt, o.isAligned32 = er, o.copyBytes = xt;
    function g(ir) {
      return ir instanceof Uint8Array || ArrayBuffer.isView(ir) && ir.constructor.name === "Uint8Array";
    }
    function c(ir) {
      if (typeof ir != "boolean")
        throw new Error(`boolean expected, not ${ir}`);
    }
    function y(ir) {
      if (!Number.isSafeInteger(ir) || ir < 0)
        throw new Error("positive integer expected, got " + ir);
    }
    function t(ir, ...sr) {
      if (!g(ir))
        throw new Error("Uint8Array expected");
      if (sr.length > 0 && !sr.includes(ir.length))
        throw new Error("Uint8Array expected of length " + sr + ", got length=" + ir.length);
    }
    function d(ir) {
      if (typeof ir != "function" || typeof ir.create != "function")
        throw new Error("Hash should be wrapped by utils.createHasher");
      y(ir.outputLen), y(ir.blockLen);
    }
    function E(ir, sr = !0) {
      if (ir.destroyed)
        throw new Error("Hash instance has been destroyed");
      if (sr && ir.finished)
        throw new Error("Hash#digest() has already been called");
    }
    function B(ir, sr) {
      t(ir);
      const yr = sr.outputLen;
      if (ir.length < yr)
        throw new Error("digestInto() expects output buffer of length at least " + yr);
    }
    function D(ir) {
      return new Uint8Array(ir.buffer, ir.byteOffset, ir.byteLength);
    }
    function x(ir) {
      return new Uint32Array(ir.buffer, ir.byteOffset, Math.floor(ir.byteLength / 4));
    }
    function v(...ir) {
      for (let sr = 0; sr < ir.length; sr++)
        ir[sr].fill(0);
    }
    function F(ir) {
      return new DataView(ir.buffer, ir.byteOffset, ir.byteLength);
    }
    o.isLE = new Uint8Array(new Uint32Array([287454020]).buffer)[0] === 68;
    const M = /* @ts-ignore */ typeof Uint8Array.from([]).toHex == "function" && typeof Uint8Array.fromHex == "function", U = /* @__PURE__ */ Array.from({ length: 256 }, (ir, sr) => sr.toString(16).padStart(2, "0"));
    function L(ir) {
      if (t(ir), M)
        return ir.toHex();
      let sr = "";
      for (let yr = 0; yr < ir.length; yr++)
        sr += U[ir[yr]];
      return sr;
    }
    const H = { _0: 48, _9: 57, A: 65, F: 70, a: 97, f: 102 };
    function fe(ir) {
      if (ir >= H._0 && ir <= H._9)
        return ir - H._0;
      if (ir >= H.A && ir <= H.F)
        return ir - (H.A - 10);
      if (ir >= H.a && ir <= H.f)
        return ir - (H.a - 10);
    }
    function ge(ir) {
      if (typeof ir != "string")
        throw new Error("hex string expected, got " + typeof ir);
      if (M)
        return Uint8Array.fromHex(ir);
      const sr = ir.length, yr = sr / 2;
      if (sr % 2)
        throw new Error("hex string expected, got unpadded hex of length " + sr);
      const wr = new Uint8Array(yr);
      for (let qr = 0, Mr = 0; qr < yr; qr++, Mr += 2) {
        const Dr = fe(ir.charCodeAt(Mr)), Qr = fe(ir.charCodeAt(Mr + 1));
        if (Dr === void 0 || Qr === void 0) {
          const Xr = ir[Mr] + ir[Mr + 1];
          throw new Error('hex string expected, got non-hex character "' + Xr + '" at index ' + Mr);
        }
        wr[qr] = Dr * 16 + Qr;
      }
      return wr;
    }
    function Ie(ir) {
      if (typeof ir != "string")
        throw new Error("hex string expected, got " + typeof ir);
      return BigInt(ir === "" ? "0" : "0x" + ir);
    }
    function Ee(ir) {
      return Ie(L(ir));
    }
    function Se(ir, sr) {
      return ge(ir.toString(16).padStart(sr * 2, "0"));
    }
    const ze = async () => {
    };
    o.nextTick = ze;
    function He(ir) {
      if (typeof ir != "string")
        throw new Error("string expected");
      return new Uint8Array(new TextEncoder().encode(ir));
    }
    function Pe(ir) {
      return new TextDecoder().decode(ir);
    }
    function De(ir) {
      if (typeof ir == "string")
        ir = He(ir);
      else if (g(ir))
        ir = xt(ir);
      else
        throw new Error("Uint8Array expected, got " + typeof ir);
      return ir;
    }
    function ve(ir, sr) {
      return ir.buffer === sr.buffer && // best we can do, may fail with an obscure Proxy
      ir.byteOffset < sr.byteOffset + sr.byteLength && // a starts before b end
      sr.byteOffset < ir.byteOffset + ir.byteLength;
    }
    function Fe(ir, sr) {
      if (ve(ir, sr) && ir.byteOffset < sr.byteOffset)
        throw new Error("complex overlap of input and output is not supported");
    }
    function be(...ir) {
      let sr = 0;
      for (let wr = 0; wr < ir.length; wr++) {
        const qr = ir[wr];
        t(qr), sr += qr.length;
      }
      const yr = new Uint8Array(sr);
      for (let wr = 0, qr = 0; wr < ir.length; wr++) {
        const Mr = ir[wr];
        yr.set(Mr, qr), qr += Mr.length;
      }
      return yr;
    }
    function Be(ir, sr) {
      if (sr == null || typeof sr != "object")
        throw new Error("options must be defined");
      return Object.assign(ir, sr);
    }
    function ke(ir, sr) {
      if (ir.length !== sr.length)
        return !1;
      let yr = 0;
      for (let wr = 0; wr < ir.length; wr++)
        yr |= ir[wr] ^ sr[wr];
      return yr === 0;
    }
    class xe {
    }
    o.Hash = xe;
    const Ne = /* @__NO_SIDE_EFFECTS__ */ (ir, sr) => {
      function yr(wr, ...qr) {
        if (t(wr), !o.isLE)
          throw new Error("Non little-endian hardware is not yet supported");
        if (ir.nonceLength !== void 0) {
          const Ur = qr[0];
          if (!Ur)
            throw new Error("nonce / iv required");
          ir.varSizeNonce ? t(Ur) : t(Ur, ir.nonceLength);
        }
        const Mr = ir.tagLength;
        Mr && qr[1] !== void 0 && t(qr[1]);
        const Dr = sr(wr, ...qr), Qr = (Ur, Sr) => {
          if (Sr !== void 0) {
            if (Ur !== 2)
              throw new Error("cipher output not supported");
            t(Sr);
          }
        };
        let Xr = !1;
        return {
          encrypt(Ur, Sr) {
            if (Xr)
              throw new Error("cannot encrypt() twice with same key + nonce");
            return Xr = !0, t(Ur), Qr(Dr.encrypt.length, Sr), Dr.encrypt(Ur, Sr);
          },
          decrypt(Ur, Sr) {
            if (t(Ur), Mr && Ur.length < Mr)
              throw new Error("invalid ciphertext length: smaller than tagLength=" + Mr);
            return Qr(Dr.decrypt.length, Sr), Dr.decrypt(Ur, Sr);
          }
        };
      }
      return Object.assign(yr, ir), yr;
    };
    o.wrapCipher = Ne;
    function Et(ir, sr, yr = !0) {
      if (sr === void 0)
        return new Uint8Array(ir);
      if (sr.length !== ir)
        throw new Error("invalid output length, expected " + ir + ", got: " + sr.length);
      if (yr && !er(sr))
        throw new Error("invalid output, must be aligned");
      return sr;
    }
    function st(ir, sr, yr, wr) {
      if (typeof ir.setBigUint64 == "function")
        return ir.setBigUint64(sr, yr, wr);
      const qr = BigInt(32), Mr = BigInt(4294967295), Dr = Number(yr >> qr & Mr), Qr = Number(yr & Mr), Xr = wr ? 4 : 0, Vr = wr ? 0 : 4;
      ir.setUint32(sr + Xr, Dr, wr), ir.setUint32(sr + Vr, Qr, wr);
    }
    function Dt(ir, sr, yr) {
      c(yr);
      const wr = new Uint8Array(16), qr = F(wr);
      return st(qr, 0, BigInt(sr), yr), st(qr, 8, BigInt(ir), yr), wr;
    }
    function er(ir) {
      return ir.byteOffset % 4 === 0;
    }
    function xt(ir) {
      return Uint8Array.from(ir);
    }
  }(utils$3)), utils$3;
}
var hasRequired_arx;
function require_arx() {
  if (hasRequired_arx) return _arx;
  hasRequired_arx = 1, Object.defineProperty(_arx, "__esModule", { value: !0 }), _arx.rotl = E, _arx.createCipher = U;
  const o = /* @__PURE__ */ requireUtils$2(), g = (L) => Uint8Array.from(L.split("").map((H) => H.charCodeAt(0))), c = g("expand 16-byte k"), y = g("expand 32-byte k"), t = (0, o.u32)(c), d = (0, o.u32)(y);
  function E(L, H) {
    return L << H | L >>> 32 - H;
  }
  function B(L) {
    return L.byteOffset % 4 === 0;
  }
  const D = 64, x = 16, v = 2 ** 32 - 1, F = new Uint32Array();
  function M(L, H, fe, ge, Ie, Ee, Se, ze) {
    const He = Ie.length, Pe = new Uint8Array(D), De = (0, o.u32)(Pe), ve = B(Ie) && B(Ee), Fe = ve ? (0, o.u32)(Ie) : F, be = ve ? (0, o.u32)(Ee) : F;
    for (let Be = 0; Be < He; Se++) {
      if (L(H, fe, ge, De, Se, ze), Se >= v)
        throw new Error("arx: counter overflow");
      const ke = Math.min(D, He - Be);
      if (ve && ke === D) {
        const xe = Be / 4;
        if (Be % 4 !== 0)
          throw new Error("arx: invalid block position");
        for (let Ne = 0, Et; Ne < x; Ne++)
          Et = xe + Ne, be[Et] = Fe[Et] ^ De[Ne];
        Be += D;
        continue;
      }
      for (let xe = 0, Ne; xe < ke; xe++)
        Ne = Be + xe, Ee[Ne] = Ie[Ne] ^ Pe[xe];
      Be += ke;
    }
  }
  function U(L, H) {
    const { allowShortKeys: fe, extendNonceFn: ge, counterLength: Ie, counterRight: Ee, rounds: Se } = (0, o.checkOpts)({ allowShortKeys: !1, counterLength: 8, counterRight: !1, rounds: 20 }, H);
    if (typeof L != "function")
      throw new Error("core must be a function");
    return (0, o.anumber)(Ie), (0, o.anumber)(Se), (0, o.abool)(Ee), (0, o.abool)(fe), (ze, He, Pe, De, ve = 0) => {
      (0, o.abytes)(ze), (0, o.abytes)(He), (0, o.abytes)(Pe);
      const Fe = Pe.length;
      if (De === void 0 && (De = new Uint8Array(Fe)), (0, o.abytes)(De), (0, o.anumber)(ve), ve < 0 || ve >= v)
        throw new Error("arx: counter overflow");
      if (De.length < Fe)
        throw new Error(`arx: output (${De.length}) is shorter than data (${Fe})`);
      const be = [];
      let Be = ze.length, ke, xe;
      if (Be === 32)
        be.push(ke = (0, o.copyBytes)(ze)), xe = d;
      else if (Be === 16 && fe)
        ke = new Uint8Array(32), ke.set(ze), ke.set(ze, 16), xe = t, be.push(ke);
      else
        throw new Error(`arx: invalid 32-byte key, got length=${Be}`);
      B(He) || be.push(He = (0, o.copyBytes)(He));
      const Ne = (0, o.u32)(ke);
      if (ge) {
        if (He.length !== 24)
          throw new Error("arx: extended nonce must be 24 bytes");
        ge(xe, Ne, (0, o.u32)(He.subarray(0, 16)), Ne), He = He.subarray(16);
      }
      const Et = 16 - Ie;
      if (Et !== He.length)
        throw new Error(`arx: nonce must be ${Et} or 16 bytes`);
      if (Et !== 12) {
        const Dt = new Uint8Array(12);
        Dt.set(He, Ee ? 0 : 12 - He.length), He = Dt, be.push(He);
      }
      const st = (0, o.u32)(He);
      return M(L, xe, Ne, st, Pe, De, ve, Se), (0, o.clean)(...be), De;
    };
  }
  return _arx;
}
var _poly1305 = {}, hasRequired_poly1305;
function require_poly1305() {
  if (hasRequired_poly1305) return _poly1305;
  hasRequired_poly1305 = 1, Object.defineProperty(_poly1305, "__esModule", { value: !0 }), _poly1305.poly1305 = void 0, _poly1305.wrapConstructorWithKey = y;
  const o = /* @__PURE__ */ requireUtils$2(), g = (t, d) => t[d++] & 255 | (t[d++] & 255) << 8;
  class c {
    constructor(d) {
      this.blockLen = 16, this.outputLen = 16, this.buffer = new Uint8Array(16), this.r = new Uint16Array(10), this.h = new Uint16Array(10), this.pad = new Uint16Array(8), this.pos = 0, this.finished = !1, d = (0, o.toBytes)(d), (0, o.abytes)(d, 32);
      const E = g(d, 0), B = g(d, 2), D = g(d, 4), x = g(d, 6), v = g(d, 8), F = g(d, 10), M = g(d, 12), U = g(d, 14);
      this.r[0] = E & 8191, this.r[1] = (E >>> 13 | B << 3) & 8191, this.r[2] = (B >>> 10 | D << 6) & 7939, this.r[3] = (D >>> 7 | x << 9) & 8191, this.r[4] = (x >>> 4 | v << 12) & 255, this.r[5] = v >>> 1 & 8190, this.r[6] = (v >>> 14 | F << 2) & 8191, this.r[7] = (F >>> 11 | M << 5) & 8065, this.r[8] = (M >>> 8 | U << 8) & 8191, this.r[9] = U >>> 5 & 127;
      for (let L = 0; L < 8; L++)
        this.pad[L] = g(d, 16 + 2 * L);
    }
    process(d, E, B = !1) {
      const D = B ? 0 : 2048, { h: x, r: v } = this, F = v[0], M = v[1], U = v[2], L = v[3], H = v[4], fe = v[5], ge = v[6], Ie = v[7], Ee = v[8], Se = v[9], ze = g(d, E + 0), He = g(d, E + 2), Pe = g(d, E + 4), De = g(d, E + 6), ve = g(d, E + 8), Fe = g(d, E + 10), be = g(d, E + 12), Be = g(d, E + 14);
      let ke = x[0] + (ze & 8191), xe = x[1] + ((ze >>> 13 | He << 3) & 8191), Ne = x[2] + ((He >>> 10 | Pe << 6) & 8191), Et = x[3] + ((Pe >>> 7 | De << 9) & 8191), st = x[4] + ((De >>> 4 | ve << 12) & 8191), Dt = x[5] + (ve >>> 1 & 8191), er = x[6] + ((ve >>> 14 | Fe << 2) & 8191), xt = x[7] + ((Fe >>> 11 | be << 5) & 8191), ir = x[8] + ((be >>> 8 | Be << 8) & 8191), sr = x[9] + (Be >>> 5 | D), yr = 0, wr = yr + ke * F + xe * (5 * Se) + Ne * (5 * Ee) + Et * (5 * Ie) + st * (5 * ge);
      yr = wr >>> 13, wr &= 8191, wr += Dt * (5 * fe) + er * (5 * H) + xt * (5 * L) + ir * (5 * U) + sr * (5 * M), yr += wr >>> 13, wr &= 8191;
      let qr = yr + ke * M + xe * F + Ne * (5 * Se) + Et * (5 * Ee) + st * (5 * Ie);
      yr = qr >>> 13, qr &= 8191, qr += Dt * (5 * ge) + er * (5 * fe) + xt * (5 * H) + ir * (5 * L) + sr * (5 * U), yr += qr >>> 13, qr &= 8191;
      let Mr = yr + ke * U + xe * M + Ne * F + Et * (5 * Se) + st * (5 * Ee);
      yr = Mr >>> 13, Mr &= 8191, Mr += Dt * (5 * Ie) + er * (5 * ge) + xt * (5 * fe) + ir * (5 * H) + sr * (5 * L), yr += Mr >>> 13, Mr &= 8191;
      let Dr = yr + ke * L + xe * U + Ne * M + Et * F + st * (5 * Se);
      yr = Dr >>> 13, Dr &= 8191, Dr += Dt * (5 * Ee) + er * (5 * Ie) + xt * (5 * ge) + ir * (5 * fe) + sr * (5 * H), yr += Dr >>> 13, Dr &= 8191;
      let Qr = yr + ke * H + xe * L + Ne * U + Et * M + st * F;
      yr = Qr >>> 13, Qr &= 8191, Qr += Dt * (5 * Se) + er * (5 * Ee) + xt * (5 * Ie) + ir * (5 * ge) + sr * (5 * fe), yr += Qr >>> 13, Qr &= 8191;
      let Xr = yr + ke * fe + xe * H + Ne * L + Et * U + st * M;
      yr = Xr >>> 13, Xr &= 8191, Xr += Dt * F + er * (5 * Se) + xt * (5 * Ee) + ir * (5 * Ie) + sr * (5 * ge), yr += Xr >>> 13, Xr &= 8191;
      let Vr = yr + ke * ge + xe * fe + Ne * H + Et * L + st * U;
      yr = Vr >>> 13, Vr &= 8191, Vr += Dt * M + er * F + xt * (5 * Se) + ir * (5 * Ee) + sr * (5 * Ie), yr += Vr >>> 13, Vr &= 8191;
      let Ur = yr + ke * Ie + xe * ge + Ne * fe + Et * H + st * L;
      yr = Ur >>> 13, Ur &= 8191, Ur += Dt * U + er * M + xt * F + ir * (5 * Se) + sr * (5 * Ee), yr += Ur >>> 13, Ur &= 8191;
      let Sr = yr + ke * Ee + xe * Ie + Ne * ge + Et * fe + st * H;
      yr = Sr >>> 13, Sr &= 8191, Sr += Dt * L + er * U + xt * M + ir * F + sr * (5 * Se), yr += Sr >>> 13, Sr &= 8191;
      let Gr = yr + ke * Se + xe * Ee + Ne * Ie + Et * ge + st * fe;
      yr = Gr >>> 13, Gr &= 8191, Gr += Dt * H + er * L + xt * U + ir * M + sr * F, yr += Gr >>> 13, Gr &= 8191, yr = (yr << 2) + yr | 0, yr = yr + wr | 0, wr = yr & 8191, yr = yr >>> 13, qr += yr, x[0] = wr, x[1] = qr, x[2] = Mr, x[3] = Dr, x[4] = Qr, x[5] = Xr, x[6] = Vr, x[7] = Ur, x[8] = Sr, x[9] = Gr;
    }
    finalize() {
      const { h: d, pad: E } = this, B = new Uint16Array(10);
      let D = d[1] >>> 13;
      d[1] &= 8191;
      for (let F = 2; F < 10; F++)
        d[F] += D, D = d[F] >>> 13, d[F] &= 8191;
      d[0] += D * 5, D = d[0] >>> 13, d[0] &= 8191, d[1] += D, D = d[1] >>> 13, d[1] &= 8191, d[2] += D, B[0] = d[0] + 5, D = B[0] >>> 13, B[0] &= 8191;
      for (let F = 1; F < 10; F++)
        B[F] = d[F] + D, D = B[F] >>> 13, B[F] &= 8191;
      B[9] -= 8192;
      let x = (D ^ 1) - 1;
      for (let F = 0; F < 10; F++)
        B[F] &= x;
      x = ~x;
      for (let F = 0; F < 10; F++)
        d[F] = d[F] & x | B[F];
      d[0] = (d[0] | d[1] << 13) & 65535, d[1] = (d[1] >>> 3 | d[2] << 10) & 65535, d[2] = (d[2] >>> 6 | d[3] << 7) & 65535, d[3] = (d[3] >>> 9 | d[4] << 4) & 65535, d[4] = (d[4] >>> 12 | d[5] << 1 | d[6] << 14) & 65535, d[5] = (d[6] >>> 2 | d[7] << 11) & 65535, d[6] = (d[7] >>> 5 | d[8] << 8) & 65535, d[7] = (d[8] >>> 8 | d[9] << 5) & 65535;
      let v = d[0] + E[0];
      d[0] = v & 65535;
      for (let F = 1; F < 8; F++)
        v = (d[F] + E[F] | 0) + (v >>> 16) | 0, d[F] = v & 65535;
      (0, o.clean)(B);
    }
    update(d) {
      (0, o.aexists)(this), d = (0, o.toBytes)(d), (0, o.abytes)(d);
      const { buffer: E, blockLen: B } = this, D = d.length;
      for (let x = 0; x < D; ) {
        const v = Math.min(B - this.pos, D - x);
        if (v === B) {
          for (; B <= D - x; x += B)
            this.process(d, x);
          continue;
        }
        E.set(d.subarray(x, x + v), this.pos), this.pos += v, x += v, this.pos === B && (this.process(E, 0, !1), this.pos = 0);
      }
      return this;
    }
    destroy() {
      (0, o.clean)(this.h, this.r, this.buffer, this.pad);
    }
    digestInto(d) {
      (0, o.aexists)(this), (0, o.aoutput)(d, this), this.finished = !0;
      const { buffer: E, h: B } = this;
      let { pos: D } = this;
      if (D) {
        for (E[D++] = 1; D < 16; D++)
          E[D] = 0;
        this.process(E, 0, !0);
      }
      this.finalize();
      let x = 0;
      for (let v = 0; v < 8; v++)
        d[x++] = B[v] >>> 0, d[x++] = B[v] >>> 8;
      return d;
    }
    digest() {
      const { buffer: d, outputLen: E } = this;
      this.digestInto(d);
      const B = d.slice(0, E);
      return this.destroy(), B;
    }
  }
  function y(t) {
    const d = (B, D) => t(D).update((0, o.toBytes)(B)).digest(), E = t(new Uint8Array(32));
    return d.outputLen = E.outputLen, d.blockLen = E.blockLen, d.create = (B) => t(B), d;
  }
  return _poly1305.poly1305 = y((t) => new c(t)), _poly1305;
}
var hasRequiredChacha;
function requireChacha() {
  return hasRequiredChacha || (hasRequiredChacha = 1, function(o) {
    Object.defineProperty(o, "__esModule", { value: !0 }), o.xchacha20poly1305 = o.chacha20poly1305 = o._poly1305_aead = o.chacha12 = o.chacha8 = o.xchacha20 = o.chacha20 = o.chacha20orig = void 0, o.hchacha = d;
    const g = /* @__PURE__ */ require_arx(), c = /* @__PURE__ */ require_poly1305(), y = /* @__PURE__ */ requireUtils$2();
    function t(F, M, U, L, H, fe = 20) {
      let ge = F[0], Ie = F[1], Ee = F[2], Se = F[3], ze = M[0], He = M[1], Pe = M[2], De = M[3], ve = M[4], Fe = M[5], be = M[6], Be = M[7], ke = H, xe = U[0], Ne = U[1], Et = U[2], st = ge, Dt = Ie, er = Ee, xt = Se, ir = ze, sr = He, yr = Pe, wr = De, qr = ve, Mr = Fe, Dr = be, Qr = Be, Xr = ke, Vr = xe, Ur = Ne, Sr = Et;
      for (let Fr = 0; Fr < fe; Fr += 2)
        st = st + ir | 0, Xr = (0, g.rotl)(Xr ^ st, 16), qr = qr + Xr | 0, ir = (0, g.rotl)(ir ^ qr, 12), st = st + ir | 0, Xr = (0, g.rotl)(Xr ^ st, 8), qr = qr + Xr | 0, ir = (0, g.rotl)(ir ^ qr, 7), Dt = Dt + sr | 0, Vr = (0, g.rotl)(Vr ^ Dt, 16), Mr = Mr + Vr | 0, sr = (0, g.rotl)(sr ^ Mr, 12), Dt = Dt + sr | 0, Vr = (0, g.rotl)(Vr ^ Dt, 8), Mr = Mr + Vr | 0, sr = (0, g.rotl)(sr ^ Mr, 7), er = er + yr | 0, Ur = (0, g.rotl)(Ur ^ er, 16), Dr = Dr + Ur | 0, yr = (0, g.rotl)(yr ^ Dr, 12), er = er + yr | 0, Ur = (0, g.rotl)(Ur ^ er, 8), Dr = Dr + Ur | 0, yr = (0, g.rotl)(yr ^ Dr, 7), xt = xt + wr | 0, Sr = (0, g.rotl)(Sr ^ xt, 16), Qr = Qr + Sr | 0, wr = (0, g.rotl)(wr ^ Qr, 12), xt = xt + wr | 0, Sr = (0, g.rotl)(Sr ^ xt, 8), Qr = Qr + Sr | 0, wr = (0, g.rotl)(wr ^ Qr, 7), st = st + sr | 0, Sr = (0, g.rotl)(Sr ^ st, 16), Dr = Dr + Sr | 0, sr = (0, g.rotl)(sr ^ Dr, 12), st = st + sr | 0, Sr = (0, g.rotl)(Sr ^ st, 8), Dr = Dr + Sr | 0, sr = (0, g.rotl)(sr ^ Dr, 7), Dt = Dt + yr | 0, Xr = (0, g.rotl)(Xr ^ Dt, 16), Qr = Qr + Xr | 0, yr = (0, g.rotl)(yr ^ Qr, 12), Dt = Dt + yr | 0, Xr = (0, g.rotl)(Xr ^ Dt, 8), Qr = Qr + Xr | 0, yr = (0, g.rotl)(yr ^ Qr, 7), er = er + wr | 0, Vr = (0, g.rotl)(Vr ^ er, 16), qr = qr + Vr | 0, wr = (0, g.rotl)(wr ^ qr, 12), er = er + wr | 0, Vr = (0, g.rotl)(Vr ^ er, 8), qr = qr + Vr | 0, wr = (0, g.rotl)(wr ^ qr, 7), xt = xt + ir | 0, Ur = (0, g.rotl)(Ur ^ xt, 16), Mr = Mr + Ur | 0, ir = (0, g.rotl)(ir ^ Mr, 12), xt = xt + ir | 0, Ur = (0, g.rotl)(Ur ^ xt, 8), Mr = Mr + Ur | 0, ir = (0, g.rotl)(ir ^ Mr, 7);
      let Gr = 0;
      L[Gr++] = ge + st | 0, L[Gr++] = Ie + Dt | 0, L[Gr++] = Ee + er | 0, L[Gr++] = Se + xt | 0, L[Gr++] = ze + ir | 0, L[Gr++] = He + sr | 0, L[Gr++] = Pe + yr | 0, L[Gr++] = De + wr | 0, L[Gr++] = ve + qr | 0, L[Gr++] = Fe + Mr | 0, L[Gr++] = be + Dr | 0, L[Gr++] = Be + Qr | 0, L[Gr++] = ke + Xr | 0, L[Gr++] = xe + Vr | 0, L[Gr++] = Ne + Ur | 0, L[Gr++] = Et + Sr | 0;
    }
    function d(F, M, U, L) {
      let H = F[0], fe = F[1], ge = F[2], Ie = F[3], Ee = M[0], Se = M[1], ze = M[2], He = M[3], Pe = M[4], De = M[5], ve = M[6], Fe = M[7], be = U[0], Be = U[1], ke = U[2], xe = U[3];
      for (let Et = 0; Et < 20; Et += 2)
        H = H + Ee | 0, be = (0, g.rotl)(be ^ H, 16), Pe = Pe + be | 0, Ee = (0, g.rotl)(Ee ^ Pe, 12), H = H + Ee | 0, be = (0, g.rotl)(be ^ H, 8), Pe = Pe + be | 0, Ee = (0, g.rotl)(Ee ^ Pe, 7), fe = fe + Se | 0, Be = (0, g.rotl)(Be ^ fe, 16), De = De + Be | 0, Se = (0, g.rotl)(Se ^ De, 12), fe = fe + Se | 0, Be = (0, g.rotl)(Be ^ fe, 8), De = De + Be | 0, Se = (0, g.rotl)(Se ^ De, 7), ge = ge + ze | 0, ke = (0, g.rotl)(ke ^ ge, 16), ve = ve + ke | 0, ze = (0, g.rotl)(ze ^ ve, 12), ge = ge + ze | 0, ke = (0, g.rotl)(ke ^ ge, 8), ve = ve + ke | 0, ze = (0, g.rotl)(ze ^ ve, 7), Ie = Ie + He | 0, xe = (0, g.rotl)(xe ^ Ie, 16), Fe = Fe + xe | 0, He = (0, g.rotl)(He ^ Fe, 12), Ie = Ie + He | 0, xe = (0, g.rotl)(xe ^ Ie, 8), Fe = Fe + xe | 0, He = (0, g.rotl)(He ^ Fe, 7), H = H + Se | 0, xe = (0, g.rotl)(xe ^ H, 16), ve = ve + xe | 0, Se = (0, g.rotl)(Se ^ ve, 12), H = H + Se | 0, xe = (0, g.rotl)(xe ^ H, 8), ve = ve + xe | 0, Se = (0, g.rotl)(Se ^ ve, 7), fe = fe + ze | 0, be = (0, g.rotl)(be ^ fe, 16), Fe = Fe + be | 0, ze = (0, g.rotl)(ze ^ Fe, 12), fe = fe + ze | 0, be = (0, g.rotl)(be ^ fe, 8), Fe = Fe + be | 0, ze = (0, g.rotl)(ze ^ Fe, 7), ge = ge + He | 0, Be = (0, g.rotl)(Be ^ ge, 16), Pe = Pe + Be | 0, He = (0, g.rotl)(He ^ Pe, 12), ge = ge + He | 0, Be = (0, g.rotl)(Be ^ ge, 8), Pe = Pe + Be | 0, He = (0, g.rotl)(He ^ Pe, 7), Ie = Ie + Ee | 0, ke = (0, g.rotl)(ke ^ Ie, 16), De = De + ke | 0, Ee = (0, g.rotl)(Ee ^ De, 12), Ie = Ie + Ee | 0, ke = (0, g.rotl)(ke ^ Ie, 8), De = De + ke | 0, Ee = (0, g.rotl)(Ee ^ De, 7);
      let Ne = 0;
      L[Ne++] = H, L[Ne++] = fe, L[Ne++] = ge, L[Ne++] = Ie, L[Ne++] = be, L[Ne++] = Be, L[Ne++] = ke, L[Ne++] = xe;
    }
    o.chacha20orig = (0, g.createCipher)(t, {
      counterRight: !1,
      counterLength: 8,
      allowShortKeys: !0
    }), o.chacha20 = (0, g.createCipher)(t, {
      counterRight: !1,
      counterLength: 4,
      allowShortKeys: !1
    }), o.xchacha20 = (0, g.createCipher)(t, {
      counterRight: !1,
      counterLength: 8,
      extendNonceFn: d,
      allowShortKeys: !1
    }), o.chacha8 = (0, g.createCipher)(t, {
      counterRight: !1,
      counterLength: 4,
      rounds: 8
    }), o.chacha12 = (0, g.createCipher)(t, {
      counterRight: !1,
      counterLength: 4,
      rounds: 12
    });
    const E = /* @__PURE__ */ new Uint8Array(16), B = (F, M) => {
      F.update(M);
      const U = M.length % 16;
      U && F.update(E.subarray(U));
    }, D = /* @__PURE__ */ new Uint8Array(32);
    function x(F, M, U, L, H) {
      const fe = F(M, U, D), ge = c.poly1305.create(fe);
      H && B(ge, H), B(ge, L);
      const Ie = (0, y.u64Lengths)(L.length, H ? H.length : 0, !0);
      ge.update(Ie);
      const Ee = ge.digest();
      return (0, y.clean)(fe, Ie), Ee;
    }
    const v = (F) => (M, U, L) => ({
      encrypt(fe, ge) {
        const Ie = fe.length;
        ge = (0, y.getOutput)(Ie + 16, ge, !1), ge.set(fe);
        const Ee = ge.subarray(0, -16);
        F(M, U, Ee, Ee, 1);
        const Se = x(F, M, U, Ee, L);
        return ge.set(Se, Ie), (0, y.clean)(Se), ge;
      },
      decrypt(fe, ge) {
        ge = (0, y.getOutput)(fe.length - 16, ge, !1);
        const Ie = fe.subarray(0, -16), Ee = fe.subarray(-16), Se = x(F, M, U, Ie, L);
        if (!(0, y.equalBytes)(Ee, Se))
          throw new Error("invalid tag");
        return ge.set(fe.subarray(0, -16)), F(M, U, ge, ge, 1), (0, y.clean)(Se), ge;
      }
    });
    o._poly1305_aead = v, o.chacha20poly1305 = (0, y.wrapCipher)({ blockSize: 64, nonceLength: 12, tagLength: 16 }, (0, o._poly1305_aead)(o.chacha20)), o.xchacha20poly1305 = (0, y.wrapCipher)({ blockSize: 64, nonceLength: 24, tagLength: 16 }, (0, o._poly1305_aead)(o.xchacha20));
  }(chacha)), chacha;
}
var ed25519 = {}, edwards = {}, hasRequiredEdwards;
function requireEdwards() {
  if (hasRequiredEdwards) return edwards;
  hasRequiredEdwards = 1, Object.defineProperty(edwards, "__esModule", { value: !0 }), edwards.PrimeEdwardsPoint = void 0, edwards.edwards = D, edwards.eddsa = v, edwards.twistedEdwards = U;
  const o = /* @__PURE__ */ requireUtils$i(), g = /* @__PURE__ */ requireCurve$2(), c = /* @__PURE__ */ requireModular$1(), y = BigInt(0), t = BigInt(1), d = BigInt(2), E = BigInt(8);
  function B(L, H, fe, ge) {
    const Ie = L.sqr(fe), Ee = L.sqr(ge), Se = L.add(L.mul(H.a, Ie), Ee), ze = L.add(L.ONE, L.mul(H.d, L.mul(Ie, Ee)));
    return L.eql(Se, ze);
  }
  function D(L, H = {}) {
    const fe = (0, g._createCurveFields)("edwards", L, H, H.FpFnLE), { Fp: ge, Fn: Ie } = fe;
    let Ee = fe.CURVE;
    const { h: Se } = Ee;
    (0, o._validateObject)(H, {}, { uvRatio: "function" });
    const ze = d << BigInt(Ie.BYTES * 8) - t, He = (xe) => ge.create(xe), Pe = H.uvRatio || ((xe, Ne) => {
      try {
        return { isValid: !0, value: ge.sqrt(ge.div(xe, Ne)) };
      } catch {
        return { isValid: !1, value: y };
      }
    });
    if (!B(ge, Ee, Ee.Gx, Ee.Gy))
      throw new Error("bad curve params: generator point");
    function De(xe, Ne, Et = !1) {
      const st = Et ? t : y;
      return (0, o.aInRange)("coordinate " + xe, Ne, st, ze), Ne;
    }
    function ve(xe) {
      if (!(xe instanceof Be))
        throw new Error("ExtendedPoint expected");
    }
    const Fe = (0, o.memoized)((xe, Ne) => {
      const { X: Et, Y: st, Z: Dt } = xe, er = xe.is0();
      Ne == null && (Ne = er ? E : ge.inv(Dt));
      const xt = He(Et * Ne), ir = He(st * Ne), sr = ge.mul(Dt, Ne);
      if (er)
        return { x: y, y: t };
      if (sr !== t)
        throw new Error("invZ was invalid");
      return { x: xt, y: ir };
    }), be = (0, o.memoized)((xe) => {
      const { a: Ne, d: Et } = Ee;
      if (xe.is0())
        throw new Error("bad point: ZERO");
      const { X: st, Y: Dt, Z: er, T: xt } = xe, ir = He(st * st), sr = He(Dt * Dt), yr = He(er * er), wr = He(yr * yr), qr = He(ir * Ne), Mr = He(yr * He(qr + sr)), Dr = He(wr + He(Et * He(ir * sr)));
      if (Mr !== Dr)
        throw new Error("bad point: equation left != right (1)");
      const Qr = He(st * Dt), Xr = He(er * xt);
      if (Qr !== Xr)
        throw new Error("bad point: equation left != right (2)");
      return !0;
    });
    class Be {
      constructor(Ne, Et, st, Dt) {
        this.X = De("x", Ne), this.Y = De("y", Et), this.Z = De("z", st, !0), this.T = De("t", Dt), Object.freeze(this);
      }
      static CURVE() {
        return Ee;
      }
      static fromAffine(Ne) {
        if (Ne instanceof Be)
          throw new Error("extended point not allowed");
        const { x: Et, y: st } = Ne || {};
        return De("x", Et), De("y", st), new Be(Et, st, t, He(Et * st));
      }
      // Uses algo from RFC8032 5.1.3.
      static fromBytes(Ne, Et = !1) {
        const st = ge.BYTES, { a: Dt, d: er } = Ee;
        Ne = (0, o.copyBytes)((0, o._abytes2)(Ne, st, "point")), (0, o._abool2)(Et, "zip215");
        const xt = (0, o.copyBytes)(Ne), ir = Ne[st - 1];
        xt[st - 1] = ir & -129;
        const sr = (0, o.bytesToNumberLE)(xt), yr = Et ? ze : ge.ORDER;
        (0, o.aInRange)("point.y", sr, y, yr);
        const wr = He(sr * sr), qr = He(wr - t), Mr = He(er * wr - Dt);
        let { isValid: Dr, value: Qr } = Pe(qr, Mr);
        if (!Dr)
          throw new Error("bad point: invalid y coordinate");
        const Xr = (Qr & t) === t, Vr = (ir & 128) !== 0;
        if (!Et && Qr === y && Vr)
          throw new Error("bad point: x=0 and x_0=1");
        return Vr !== Xr && (Qr = He(-Qr)), Be.fromAffine({ x: Qr, y: sr });
      }
      static fromHex(Ne, Et = !1) {
        return Be.fromBytes((0, o.ensureBytes)("point", Ne), Et);
      }
      get x() {
        return this.toAffine().x;
      }
      get y() {
        return this.toAffine().y;
      }
      precompute(Ne = 8, Et = !0) {
        return ke.createCache(this, Ne), Et || this.multiply(d), this;
      }
      // Useful in fromAffine() - not for fromBytes(), which always created valid points.
      assertValidity() {
        be(this);
      }
      // Compare one point to another.
      equals(Ne) {
        ve(Ne);
        const { X: Et, Y: st, Z: Dt } = this, { X: er, Y: xt, Z: ir } = Ne, sr = He(Et * ir), yr = He(er * Dt), wr = He(st * ir), qr = He(xt * Dt);
        return sr === yr && wr === qr;
      }
      is0() {
        return this.equals(Be.ZERO);
      }
      negate() {
        return new Be(He(-this.X), this.Y, this.Z, He(-this.T));
      }
      // Fast algo for doubling Extended Point.
      // https://hyperelliptic.org/EFD/g1p/auto-twisted-extended.html#doubling-dbl-2008-hwcd
      // Cost: 4M + 4S + 1*a + 6add + 1*2.
      double() {
        const { a: Ne } = Ee, { X: Et, Y: st, Z: Dt } = this, er = He(Et * Et), xt = He(st * st), ir = He(d * He(Dt * Dt)), sr = He(Ne * er), yr = Et + st, wr = He(He(yr * yr) - er - xt), qr = sr + xt, Mr = qr - ir, Dr = sr - xt, Qr = He(wr * Mr), Xr = He(qr * Dr), Vr = He(wr * Dr), Ur = He(Mr * qr);
        return new Be(Qr, Xr, Ur, Vr);
      }
      // Fast algo for adding 2 Extended Points.
      // https://hyperelliptic.org/EFD/g1p/auto-twisted-extended.html#addition-add-2008-hwcd
      // Cost: 9M + 1*a + 1*d + 7add.
      add(Ne) {
        ve(Ne);
        const { a: Et, d: st } = Ee, { X: Dt, Y: er, Z: xt, T: ir } = this, { X: sr, Y: yr, Z: wr, T: qr } = Ne, Mr = He(Dt * sr), Dr = He(er * yr), Qr = He(ir * st * qr), Xr = He(xt * wr), Vr = He((Dt + er) * (sr + yr) - Mr - Dr), Ur = Xr - Qr, Sr = Xr + Qr, Gr = He(Dr - Et * Mr), Fr = He(Vr * Ur), br = He(Sr * Gr), Ar = He(Vr * Gr), cr = He(Ur * Sr);
        return new Be(Fr, br, cr, Ar);
      }
      subtract(Ne) {
        return this.add(Ne.negate());
      }
      // Constant-time multiplication.
      multiply(Ne) {
        if (!Ie.isValidNot0(Ne))
          throw new Error("invalid scalar: expected 1 <= sc < curve.n");
        const { p: Et, f: st } = ke.cached(this, Ne, (Dt) => (0, g.normalizeZ)(Be, Dt));
        return (0, g.normalizeZ)(Be, [Et, st])[0];
      }
      // Non-constant-time multiplication. Uses double-and-add algorithm.
      // It's faster, but should only be used when you don't care about
      // an exposed private key e.g. sig verification.
      // Does NOT allow scalars higher than CURVE.n.
      // Accepts optional accumulator to merge with multiply (important for sparse scalars)
      multiplyUnsafe(Ne, Et = Be.ZERO) {
        if (!Ie.isValid(Ne))
          throw new Error("invalid scalar: expected 0 <= sc < curve.n");
        return Ne === y ? Be.ZERO : this.is0() || Ne === t ? this : ke.unsafe(this, Ne, (st) => (0, g.normalizeZ)(Be, st), Et);
      }
      // Checks if point is of small order.
      // If you add something to small order point, you will have "dirty"
      // point with torsion component.
      // Multiplies point by cofactor and checks if the result is 0.
      isSmallOrder() {
        return this.multiplyUnsafe(Se).is0();
      }
      // Multiplies point by curve order and checks if the result is 0.
      // Returns `false` is the point is dirty.
      isTorsionFree() {
        return ke.unsafe(this, Ee.n).is0();
      }
      // Converts Extended point to default (x, y) coordinates.
      // Can accept precomputed Z^-1 - for example, from invertBatch.
      toAffine(Ne) {
        return Fe(this, Ne);
      }
      clearCofactor() {
        return Se === t ? this : this.multiplyUnsafe(Se);
      }
      toBytes() {
        const { x: Ne, y: Et } = this.toAffine(), st = ge.toBytes(Et);
        return st[st.length - 1] |= Ne & t ? 128 : 0, st;
      }
      toHex() {
        return (0, o.bytesToHex)(this.toBytes());
      }
      toString() {
        return `<Point ${this.is0() ? "ZERO" : this.toHex()}>`;
      }
      // TODO: remove
      get ex() {
        return this.X;
      }
      get ey() {
        return this.Y;
      }
      get ez() {
        return this.Z;
      }
      get et() {
        return this.T;
      }
      static normalizeZ(Ne) {
        return (0, g.normalizeZ)(Be, Ne);
      }
      static msm(Ne, Et) {
        return (0, g.pippenger)(Be, Ie, Ne, Et);
      }
      _setWindowSize(Ne) {
        this.precompute(Ne);
      }
      toRawBytes() {
        return this.toBytes();
      }
    }
    Be.BASE = new Be(Ee.Gx, Ee.Gy, t, He(Ee.Gx * Ee.Gy)), Be.ZERO = new Be(y, t, t, y), Be.Fp = ge, Be.Fn = Ie;
    const ke = new g.wNAF(Be, Ie.BITS);
    return Be.BASE.precompute(8), Be;
  }
  class x {
    constructor(H) {
      this.ep = H;
    }
    // Static methods that must be implemented by subclasses
    static fromBytes(H) {
      (0, o.notImplemented)();
    }
    static fromHex(H) {
      (0, o.notImplemented)();
    }
    get x() {
      return this.toAffine().x;
    }
    get y() {
      return this.toAffine().y;
    }
    // Common implementations
    clearCofactor() {
      return this;
    }
    assertValidity() {
      this.ep.assertValidity();
    }
    toAffine(H) {
      return this.ep.toAffine(H);
    }
    toHex() {
      return (0, o.bytesToHex)(this.toBytes());
    }
    toString() {
      return this.toHex();
    }
    isTorsionFree() {
      return !0;
    }
    isSmallOrder() {
      return !1;
    }
    add(H) {
      return this.assertSame(H), this.init(this.ep.add(H.ep));
    }
    subtract(H) {
      return this.assertSame(H), this.init(this.ep.subtract(H.ep));
    }
    multiply(H) {
      return this.init(this.ep.multiply(H));
    }
    multiplyUnsafe(H) {
      return this.init(this.ep.multiplyUnsafe(H));
    }
    double() {
      return this.init(this.ep.double());
    }
    negate() {
      return this.init(this.ep.negate());
    }
    precompute(H, fe) {
      return this.init(this.ep.precompute(H, fe));
    }
    /** @deprecated use `toBytes` */
    toRawBytes() {
      return this.toBytes();
    }
  }
  edwards.PrimeEdwardsPoint = x;
  function v(L, H, fe = {}) {
    if (typeof H != "function")
      throw new Error('"hash" function param is required');
    (0, o._validateObject)(fe, {}, {
      adjustScalarBytes: "function",
      randomBytes: "function",
      domain: "function",
      prehash: "function",
      mapToCurve: "function"
    });
    const { prehash: ge } = fe, { BASE: Ie, Fp: Ee, Fn: Se } = L, ze = fe.randomBytes || o.randomBytes, He = fe.adjustScalarBytes || ((yr) => yr), Pe = fe.domain || ((yr, wr, qr) => {
      if ((0, o._abool2)(qr, "phflag"), wr.length || qr)
        throw new Error("Contexts/pre-hash are not supported");
      return yr;
    });
    function De(yr) {
      return Se.create((0, o.bytesToNumberLE)(yr));
    }
    function ve(yr) {
      const wr = st.secretKey;
      yr = (0, o.ensureBytes)("private key", yr, wr);
      const qr = (0, o.ensureBytes)("hashed private key", H(yr), 2 * wr), Mr = He(qr.slice(0, wr)), Dr = qr.slice(wr, 2 * wr), Qr = De(Mr);
      return { head: Mr, prefix: Dr, scalar: Qr };
    }
    function Fe(yr) {
      const { head: wr, prefix: qr, scalar: Mr } = ve(yr), Dr = Ie.multiply(Mr), Qr = Dr.toBytes();
      return { head: wr, prefix: qr, scalar: Mr, point: Dr, pointBytes: Qr };
    }
    function be(yr) {
      return Fe(yr).pointBytes;
    }
    function Be(yr = Uint8Array.of(), ...wr) {
      const qr = (0, o.concatBytes)(...wr);
      return De(H(Pe(qr, (0, o.ensureBytes)("context", yr), !!ge)));
    }
    function ke(yr, wr, qr = {}) {
      yr = (0, o.ensureBytes)("message", yr), ge && (yr = ge(yr));
      const { prefix: Mr, scalar: Dr, pointBytes: Qr } = Fe(wr), Xr = Be(qr.context, Mr, yr), Vr = Ie.multiply(Xr).toBytes(), Ur = Be(qr.context, Vr, Qr, yr), Sr = Se.create(Xr + Ur * Dr);
      if (!Se.isValid(Sr))
        throw new Error("sign failed: invalid s");
      const Gr = (0, o.concatBytes)(Vr, Se.toBytes(Sr));
      return (0, o._abytes2)(Gr, st.signature, "result");
    }
    const xe = { zip215: !0 };
    function Ne(yr, wr, qr, Mr = xe) {
      const { context: Dr, zip215: Qr } = Mr, Xr = st.signature;
      yr = (0, o.ensureBytes)("signature", yr, Xr), wr = (0, o.ensureBytes)("message", wr), qr = (0, o.ensureBytes)("publicKey", qr, st.publicKey), Qr !== void 0 && (0, o._abool2)(Qr, "zip215"), ge && (wr = ge(wr));
      const Vr = Xr / 2, Ur = yr.subarray(0, Vr), Sr = (0, o.bytesToNumberLE)(yr.subarray(Vr, Xr));
      let Gr, Fr, br;
      try {
        Gr = L.fromBytes(qr, Qr), Fr = L.fromBytes(Ur, Qr), br = Ie.multiplyUnsafe(Sr);
      } catch {
        return !1;
      }
      if (!Qr && Gr.isSmallOrder())
        return !1;
      const Ar = Be(Dr, Fr.toBytes(), Gr.toBytes(), wr);
      return Fr.add(Gr.multiplyUnsafe(Ar)).subtract(br).clearCofactor().is0();
    }
    const Et = Ee.BYTES, st = {
      secretKey: Et,
      publicKey: Et,
      signature: 2 * Et,
      seed: Et
    };
    function Dt(yr = ze(st.seed)) {
      return (0, o._abytes2)(yr, st.seed, "seed");
    }
    function er(yr) {
      const wr = sr.randomSecretKey(yr);
      return { secretKey: wr, publicKey: be(wr) };
    }
    function xt(yr) {
      return (0, o.isBytes)(yr) && yr.length === Se.BYTES;
    }
    function ir(yr, wr) {
      try {
        return !!L.fromBytes(yr, wr);
      } catch {
        return !1;
      }
    }
    const sr = {
      getExtendedPublicKey: Fe,
      randomSecretKey: Dt,
      isValidSecretKey: xt,
      isValidPublicKey: ir,
      /**
       * Converts ed public key to x public key. Uses formula:
       * - ed25519:
       *   - `(u, v) = ((1+y)/(1-y), sqrt(-486664)*u/x)`
       *   - `(x, y) = (sqrt(-486664)*u/v, (u-1)/(u+1))`
       * - ed448:
       *   - `(u, v) = ((y-1)/(y+1), sqrt(156324)*u/x)`
       *   - `(x, y) = (sqrt(156324)*u/v, (1+u)/(1-u))`
       */
      toMontgomery(yr) {
        const { y: wr } = L.fromBytes(yr), qr = st.publicKey, Mr = qr === 32;
        if (!Mr && qr !== 57)
          throw new Error("only defined for 25519 and 448");
        const Dr = Mr ? Ee.div(t + wr, t - wr) : Ee.div(wr - t, wr + t);
        return Ee.toBytes(Dr);
      },
      toMontgomerySecret(yr) {
        const wr = st.secretKey;
        (0, o._abytes2)(yr, wr);
        const qr = H(yr.subarray(0, wr));
        return He(qr).subarray(0, wr);
      },
      /** @deprecated */
      randomPrivateKey: Dt,
      /** @deprecated */
      precompute(yr = 8, wr = L.BASE) {
        return wr.precompute(yr, !1);
      }
    };
    return Object.freeze({
      keygen: er,
      getPublicKey: be,
      sign: ke,
      verify: Ne,
      utils: sr,
      Point: L,
      lengths: st
    });
  }
  function F(L) {
    const H = {
      a: L.a,
      d: L.d,
      p: L.Fp.ORDER,
      n: L.n,
      h: L.h,
      Gx: L.Gx,
      Gy: L.Gy
    }, fe = L.Fp, ge = (0, c.Field)(H.n, L.nBitLength, !0), Ie = { Fp: fe, Fn: ge, uvRatio: L.uvRatio }, Ee = {
      randomBytes: L.randomBytes,
      adjustScalarBytes: L.adjustScalarBytes,
      domain: L.domain,
      prehash: L.prehash,
      mapToCurve: L.mapToCurve
    };
    return { CURVE: H, curveOpts: Ie, hash: L.hash, eddsaOpts: Ee };
  }
  function M(L, H) {
    const fe = H.Point;
    return Object.assign({}, H, {
      ExtendedPoint: fe,
      CURVE: L,
      nBitLength: fe.Fn.BITS,
      nByteLength: fe.Fn.BYTES
    });
  }
  function U(L) {
    const { CURVE: H, curveOpts: fe, hash: ge, eddsaOpts: Ie } = F(L), Ee = D(H, fe), Se = v(Ee, ge, Ie);
    return M(L, Se);
  }
  return edwards;
}
var montgomery = {}, hasRequiredMontgomery;
function requireMontgomery() {
  if (hasRequiredMontgomery) return montgomery;
  hasRequiredMontgomery = 1, Object.defineProperty(montgomery, "__esModule", { value: !0 }), montgomery.montgomery = E;
  const o = /* @__PURE__ */ requireUtils$i(), g = /* @__PURE__ */ requireModular$1(), c = BigInt(0), y = BigInt(1), t = BigInt(2);
  function d(B) {
    return (0, o._validateObject)(B, {
      adjustScalarBytes: "function",
      powPminus2: "function"
    }), Object.freeze({ ...B });
  }
  function E(B) {
    const D = d(B), { P: x, type: v, adjustScalarBytes: F, powPminus2: M, randomBytes: U } = D, L = v === "x25519";
    if (!L && v !== "x448")
      throw new Error("invalid type");
    const H = U || o.randomBytes, fe = L ? 255 : 448, ge = L ? 32 : 56, Ie = BigInt(L ? 9 : 5), Ee = BigInt(L ? 121665 : 39081), Se = L ? t ** BigInt(254) : t ** BigInt(447), ze = L ? BigInt(8) * t ** BigInt(251) - y : BigInt(4) * t ** BigInt(445) - y, He = Se + ze + y, Pe = (xt) => (0, g.mod)(xt, x), De = ve(Ie);
    function ve(xt) {
      return (0, o.numberToBytesLE)(Pe(xt), ge);
    }
    function Fe(xt) {
      const ir = (0, o.ensureBytes)("u coordinate", xt, ge);
      return L && (ir[31] &= 127), Pe((0, o.bytesToNumberLE)(ir));
    }
    function be(xt) {
      return (0, o.bytesToNumberLE)(F((0, o.ensureBytes)("scalar", xt, ge)));
    }
    function Be(xt, ir) {
      const sr = Ne(Fe(ir), be(xt));
      if (sr === c)
        throw new Error("invalid private or public key received");
      return ve(sr);
    }
    function ke(xt) {
      return Be(xt, De);
    }
    function xe(xt, ir, sr) {
      const yr = Pe(xt * (ir - sr));
      return ir = Pe(ir - yr), sr = Pe(sr + yr), { x_2: ir, x_3: sr };
    }
    function Ne(xt, ir) {
      (0, o.aInRange)("u", xt, c, x), (0, o.aInRange)("scalar", ir, Se, He);
      const sr = ir, yr = xt;
      let wr = y, qr = c, Mr = xt, Dr = y, Qr = c;
      for (let Vr = BigInt(fe - 1); Vr >= c; Vr--) {
        const Ur = sr >> Vr & y;
        Qr ^= Ur, { x_2: wr, x_3: Mr } = xe(Qr, wr, Mr), { x_2: qr, x_3: Dr } = xe(Qr, qr, Dr), Qr = Ur;
        const Sr = wr + qr, Gr = Pe(Sr * Sr), Fr = wr - qr, br = Pe(Fr * Fr), Ar = Gr - br, cr = Mr + Dr, hr = Mr - Dr, Wr = Pe(hr * Sr), fi = Pe(cr * Fr), Bi = Wr + fi, $r = Wr - fi;
        Mr = Pe(Bi * Bi), Dr = Pe(yr * Pe($r * $r)), wr = Pe(Gr * br), qr = Pe(Ar * (Gr + Pe(Ee * Ar)));
      }
      ({ x_2: wr, x_3: Mr } = xe(Qr, wr, Mr)), { x_2: qr, x_3: Dr } = xe(Qr, qr, Dr);
      const Xr = M(qr);
      return Pe(wr * Xr);
    }
    const Et = {
      secretKey: ge,
      publicKey: ge,
      seed: ge
    }, st = (xt = H(ge)) => ((0, o.abytes)(xt, Et.seed), xt);
    function Dt(xt) {
      const ir = st(xt);
      return { secretKey: ir, publicKey: ke(ir) };
    }
    return {
      keygen: Dt,
      getSharedSecret: (xt, ir) => Be(xt, ir),
      getPublicKey: (xt) => ke(xt),
      scalarMult: Be,
      scalarMultBase: ke,
      utils: {
        randomSecretKey: st,
        randomPrivateKey: st
      },
      GuBytes: De.slice(),
      lengths: Et
    };
  }
  return montgomery;
}
var hasRequiredEd25519;
function requireEd25519() {
  return hasRequiredEd25519 || (hasRequiredEd25519 = 1, function(o) {
    Object.defineProperty(o, "__esModule", { value: !0 }), o.hash_to_ristretto255 = o.hashToRistretto255 = o.encodeToCurve = o.hashToCurve = o.RistrettoPoint = o.edwardsToMontgomery = o.ED25519_TORSION_SUBGROUP = o.ristretto255_hasher = o.ristretto255 = o.ed25519_hasher = o.x25519 = o.ed25519ph = o.ed25519ctx = o.ed25519 = void 0, o.edwardsToMontgomeryPub = Mr, o.edwardsToMontgomeryPriv = Dr;
    const g = /* @__PURE__ */ requireSha2(), c = /* @__PURE__ */ requireUtils$j(), y = /* @__PURE__ */ requireCurve$2(), t = /* @__PURE__ */ requireEdwards(), d = /* @__PURE__ */ requireHashToCurve$1(), E = /* @__PURE__ */ requireModular$1(), B = /* @__PURE__ */ requireMontgomery(), D = /* @__PURE__ */ requireUtils$i(), x = /* @__PURE__ */ BigInt(0), v = BigInt(1), F = BigInt(2), M = BigInt(3), U = BigInt(5), L = BigInt(8), H = BigInt("0x7fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffed"), fe = {
      p: H,
      n: BigInt("0x1000000000000000000000000000000014def9dea2f79cd65812631a5cf5d3ed"),
      h: L,
      a: BigInt("0x7fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffec"),
      d: BigInt("0x52036cee2b6ffe738cc740797779e89800700a4d4141d8ab75eb4dca135978a3"),
      Gx: BigInt("0x216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a"),
      Gy: BigInt("0x6666666666666666666666666666666666666666666666666666666666666658")
    };
    function ge(Qr) {
      const Xr = BigInt(10), Vr = BigInt(20), Ur = BigInt(40), Sr = BigInt(80), Gr = H, br = Qr * Qr % Gr * Qr % Gr, Ar = (0, E.pow2)(br, F, Gr) * br % Gr, cr = (0, E.pow2)(Ar, v, Gr) * Qr % Gr, hr = (0, E.pow2)(cr, U, Gr) * cr % Gr, Wr = (0, E.pow2)(hr, Xr, Gr) * hr % Gr, fi = (0, E.pow2)(Wr, Vr, Gr) * Wr % Gr, Bi = (0, E.pow2)(fi, Ur, Gr) * fi % Gr, $r = (0, E.pow2)(Bi, Sr, Gr) * Bi % Gr, oi = (0, E.pow2)($r, Sr, Gr) * Bi % Gr, zr = (0, E.pow2)(oi, Xr, Gr) * hr % Gr;
      return { pow_p_5_8: (0, E.pow2)(zr, F, Gr) * Qr % Gr, b2: br };
    }
    function Ie(Qr) {
      return Qr[0] &= 248, Qr[31] &= 127, Qr[31] |= 64, Qr;
    }
    const Ee = /* @__PURE__ */ BigInt("19681161376707505956807079304988542015446066515923890162744021073123829784752");
    function Se(Qr, Xr) {
      const Vr = H, Ur = (0, E.mod)(Xr * Xr * Xr, Vr), Sr = (0, E.mod)(Ur * Ur * Xr, Vr), Gr = ge(Qr * Sr).pow_p_5_8;
      let Fr = (0, E.mod)(Qr * Ur * Gr, Vr);
      const br = (0, E.mod)(Xr * Fr * Fr, Vr), Ar = Fr, cr = (0, E.mod)(Fr * Ee, Vr), hr = br === Qr, Wr = br === (0, E.mod)(-Qr, Vr), fi = br === (0, E.mod)(-Qr * Ee, Vr);
      return hr && (Fr = Ar), (Wr || fi) && (Fr = cr), (0, E.isNegativeLE)(Fr, Vr) && (Fr = (0, E.mod)(-Fr, Vr)), { isValid: hr || Wr, value: Fr };
    }
    const ze = (0, E.Field)(fe.p, { isLE: !0 }), He = (0, E.Field)(fe.n, { isLE: !0 }), Pe = {
      ...fe,
      Fp: ze,
      hash: g.sha512,
      adjustScalarBytes: Ie,
      // dom2
      // Ratio of u to v. Allows us to combine inversion and square root. Uses algo from RFC8032 5.1.3.
      // Constant-time, u/√v
      uvRatio: Se
    };
    o.ed25519 = (0, t.twistedEdwards)(Pe);
    function De(Qr, Xr, Vr) {
      if (Xr.length > 255)
        throw new Error("Context is too big");
      return (0, c.concatBytes)((0, c.utf8ToBytes)("SigEd25519 no Ed25519 collisions"), new Uint8Array([Vr ? 1 : 0, Xr.length]), Xr, Qr);
    }
    o.ed25519ctx = (0, t.twistedEdwards)({
      ...Pe,
      domain: De
    }), o.ed25519ph = (0, t.twistedEdwards)(Object.assign({}, Pe, {
      domain: De,
      prehash: g.sha512
    })), o.x25519 = (() => {
      const Qr = ze.ORDER;
      return (0, B.montgomery)({
        P: Qr,
        type: "x25519",
        powPminus2: (Xr) => {
          const { pow_p_5_8: Vr, b2: Ur } = ge(Xr);
          return (0, E.mod)((0, E.pow2)(Vr, M, Qr) * Ur, Qr);
        },
        adjustScalarBytes: Ie
      });
    })();
    const ve = (H + M) / L, Fe = ze.pow(F, ve), be = ze.sqrt(ze.neg(ze.ONE));
    function Be(Qr) {
      const Xr = (H - U) / L, Vr = BigInt(486662);
      let Ur = ze.sqr(Qr);
      Ur = ze.mul(Ur, F);
      let Sr = ze.add(Ur, ze.ONE), Gr = ze.neg(Vr), Fr = ze.sqr(Sr), br = ze.mul(Fr, Sr), Ar = ze.mul(Ur, Vr);
      Ar = ze.mul(Ar, Gr), Ar = ze.add(Ar, Fr), Ar = ze.mul(Ar, Gr);
      let cr = ze.sqr(br);
      Fr = ze.sqr(cr), cr = ze.mul(cr, br), cr = ze.mul(cr, Ar), Fr = ze.mul(Fr, cr);
      let hr = ze.pow(Fr, Xr);
      hr = ze.mul(hr, cr);
      let Wr = ze.mul(hr, be);
      Fr = ze.sqr(hr), Fr = ze.mul(Fr, br);
      let fi = ze.eql(Fr, Ar), Bi = ze.cmov(Wr, hr, fi), $r = ze.mul(Gr, Ur), oi = ze.mul(hr, Qr);
      oi = ze.mul(oi, Fe);
      let zr = ze.mul(oi, be), ti = ze.mul(Ar, Ur);
      Fr = ze.sqr(oi), Fr = ze.mul(Fr, br);
      let Lr = ze.eql(Fr, ti), Rr = ze.cmov(zr, oi, Lr);
      Fr = ze.sqr(Bi), Fr = ze.mul(Fr, br);
      let Ir = ze.eql(Fr, Ar), pr = ze.cmov($r, Gr, Ir), Cr = ze.cmov(Rr, Bi, Ir), Er = ze.isOdd(Cr);
      return Cr = ze.cmov(Cr, ze.neg(Cr), Ir !== Er), { xMn: pr, xMd: Sr, yMn: Cr, yMd: v };
    }
    const ke = (0, E.FpSqrtEven)(ze, ze.neg(BigInt(486664)));
    function xe(Qr) {
      const { xMn: Xr, xMd: Vr, yMn: Ur, yMd: Sr } = Be(Qr);
      let Gr = ze.mul(Xr, Sr);
      Gr = ze.mul(Gr, ke);
      let Fr = ze.mul(Vr, Ur), br = ze.sub(Xr, Vr), Ar = ze.add(Xr, Vr), cr = ze.mul(Fr, Ar), hr = ze.eql(cr, ze.ZERO);
      Gr = ze.cmov(Gr, ze.ZERO, hr), Fr = ze.cmov(Fr, ze.ONE, hr), br = ze.cmov(br, ze.ONE, hr), Ar = ze.cmov(Ar, ze.ONE, hr);
      const [Wr, fi] = (0, E.FpInvertBatch)(ze, [Fr, Ar], !0);
      return { x: ze.mul(Gr, Wr), y: ze.mul(br, fi) };
    }
    o.ed25519_hasher = (0, d.createHasher)(o.ed25519.Point, (Qr) => xe(Qr[0]), {
      DST: "edwards25519_XMD:SHA-512_ELL2_RO_",
      encodeDST: "edwards25519_XMD:SHA-512_ELL2_NU_",
      p: H,
      m: 1,
      k: 128,
      expand: "xmd",
      hash: g.sha512
    });
    const Ne = Ee, Et = /* @__PURE__ */ BigInt("25063068953384623474111414158702152701244531502492656460079210482610430750235"), st = /* @__PURE__ */ BigInt("54469307008909316920995813868745141605393597292927456921205312896311721017578"), Dt = /* @__PURE__ */ BigInt("1159843021668779879193775521855586647937357759715417654439879720876111806838"), er = /* @__PURE__ */ BigInt("40440834346308536858101042469323190826248399146238708352240133220865137265952"), xt = (Qr) => Se(v, Qr), ir = /* @__PURE__ */ BigInt("0x7fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff"), sr = (Qr) => o.ed25519.Point.Fp.create((0, D.bytesToNumberLE)(Qr) & ir);
    function yr(Qr) {
      const { d: Xr } = fe, Vr = H, Ur = (ti) => ze.create(ti), Sr = Ur(Ne * Qr * Qr), Gr = Ur((Sr + v) * Dt);
      let Fr = BigInt(-1);
      const br = Ur((Fr - Xr * Sr) * Ur(Sr + Xr));
      let { isValid: Ar, value: cr } = Se(Gr, br), hr = Ur(cr * Qr);
      (0, E.isNegativeLE)(hr, Vr) || (hr = Ur(-hr)), Ar || (cr = hr), Ar || (Fr = Sr);
      const Wr = Ur(Fr * (Sr - v) * er - br), fi = cr * cr, Bi = Ur((cr + cr) * br), $r = Ur(Wr * Et), oi = Ur(v - fi), zr = Ur(v + fi);
      return new o.ed25519.Point(Ur(Bi * zr), Ur(oi * $r), Ur($r * zr), Ur(Bi * oi));
    }
    function wr(Qr) {
      (0, c.abytes)(Qr, 64);
      const Xr = sr(Qr.subarray(0, 32)), Vr = yr(Xr), Ur = sr(Qr.subarray(32, 64)), Sr = yr(Ur);
      return new qr(Vr.add(Sr));
    }
    class qr extends t.PrimeEdwardsPoint {
      constructor(Xr) {
        super(Xr);
      }
      static fromAffine(Xr) {
        return new qr(o.ed25519.Point.fromAffine(Xr));
      }
      assertSame(Xr) {
        if (!(Xr instanceof qr))
          throw new Error("RistrettoPoint expected");
      }
      init(Xr) {
        return new qr(Xr);
      }
      /** @deprecated use `import { ristretto255_hasher } from '@noble/curves/ed25519.js';` */
      static hashToCurve(Xr) {
        return wr((0, D.ensureBytes)("ristrettoHash", Xr, 64));
      }
      static fromBytes(Xr) {
        (0, c.abytes)(Xr, 32);
        const { a: Vr, d: Ur } = fe, Sr = H, Gr = (Ir) => ze.create(Ir), Fr = sr(Xr);
        if (!(0, D.equalBytes)(ze.toBytes(Fr), Xr) || (0, E.isNegativeLE)(Fr, Sr))
          throw new Error("invalid ristretto255 encoding 1");
        const br = Gr(Fr * Fr), Ar = Gr(v + Vr * br), cr = Gr(v - Vr * br), hr = Gr(Ar * Ar), Wr = Gr(cr * cr), fi = Gr(Vr * Ur * hr - Wr), { isValid: Bi, value: $r } = xt(Gr(fi * Wr)), oi = Gr($r * cr), zr = Gr($r * oi * fi);
        let ti = Gr((Fr + Fr) * oi);
        (0, E.isNegativeLE)(ti, Sr) && (ti = Gr(-ti));
        const Lr = Gr(Ar * zr), Rr = Gr(ti * Lr);
        if (!Bi || (0, E.isNegativeLE)(Rr, Sr) || Lr === x)
          throw new Error("invalid ristretto255 encoding 2");
        return new qr(new o.ed25519.Point(ti, Lr, v, Rr));
      }
      /**
       * Converts ristretto-encoded string to ristretto point.
       * Described in [RFC9496](https://www.rfc-editor.org/rfc/rfc9496#name-decode).
       * @param hex Ristretto-encoded 32 bytes. Not every 32-byte string is valid ristretto encoding
       */
      static fromHex(Xr) {
        return qr.fromBytes((0, D.ensureBytes)("ristrettoHex", Xr, 32));
      }
      static msm(Xr, Vr) {
        return (0, y.pippenger)(qr, o.ed25519.Point.Fn, Xr, Vr);
      }
      /**
       * Encodes ristretto point to Uint8Array.
       * Described in [RFC9496](https://www.rfc-editor.org/rfc/rfc9496#name-encode).
       */
      toBytes() {
        let { X: Xr, Y: Vr, Z: Ur, T: Sr } = this.ep;
        const Gr = H, Fr = (zr) => ze.create(zr), br = Fr(Fr(Ur + Vr) * Fr(Ur - Vr)), Ar = Fr(Xr * Vr), cr = Fr(Ar * Ar), { value: hr } = xt(Fr(br * cr)), Wr = Fr(hr * br), fi = Fr(hr * Ar), Bi = Fr(Wr * fi * Sr);
        let $r;
        if ((0, E.isNegativeLE)(Sr * Bi, Gr)) {
          let zr = Fr(Vr * Ne), ti = Fr(Xr * Ne);
          Xr = zr, Vr = ti, $r = Fr(Wr * st);
        } else
          $r = fi;
        (0, E.isNegativeLE)(Xr * Bi, Gr) && (Vr = Fr(-Vr));
        let oi = Fr((Ur - Vr) * $r);
        return (0, E.isNegativeLE)(oi, Gr) && (oi = Fr(-oi)), ze.toBytes(oi);
      }
      /**
       * Compares two Ristretto points.
       * Described in [RFC9496](https://www.rfc-editor.org/rfc/rfc9496#name-equals).
       */
      equals(Xr) {
        this.assertSame(Xr);
        const { X: Vr, Y: Ur } = this.ep, { X: Sr, Y: Gr } = Xr.ep, Fr = (cr) => ze.create(cr), br = Fr(Vr * Gr) === Fr(Ur * Sr), Ar = Fr(Ur * Gr) === Fr(Vr * Sr);
        return br || Ar;
      }
      is0() {
        return this.equals(qr.ZERO);
      }
    }
    qr.BASE = new qr(o.ed25519.Point.BASE), qr.ZERO = new qr(o.ed25519.Point.ZERO), qr.Fp = ze, qr.Fn = He, o.ristretto255 = { Point: qr }, o.ristretto255_hasher = {
      hashToCurve(Qr, Xr) {
        const Vr = (Xr == null ? void 0 : Xr.DST) || "ristretto255_XMD:SHA-512_R255MAP_RO_", Ur = (0, d.expand_message_xmd)(Qr, Vr, 64, g.sha512);
        return wr(Ur);
      },
      hashToScalar(Qr, Xr = { DST: d._DST_scalar }) {
        const Vr = (0, d.expand_message_xmd)(Qr, Xr.DST, 64, g.sha512);
        return He.create((0, D.bytesToNumberLE)(Vr));
      }
    }, o.ED25519_TORSION_SUBGROUP = [
      "0100000000000000000000000000000000000000000000000000000000000000",
      "c7176a703d4dd84fba3c0b760d10670f2a2053fa2c39ccc64ec7fd7792ac037a",
      "0000000000000000000000000000000000000000000000000000000000000080",
      "26e8958fc2b227b045c3f489f2ef98f0d5dfac05d3c63339b13802886d53fc05",
      "ecffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff7f",
      "26e8958fc2b227b045c3f489f2ef98f0d5dfac05d3c63339b13802886d53fc85",
      "0000000000000000000000000000000000000000000000000000000000000000",
      "c7176a703d4dd84fba3c0b760d10670f2a2053fa2c39ccc64ec7fd7792ac03fa"
    ];
    function Mr(Qr) {
      return o.ed25519.utils.toMontgomery((0, D.ensureBytes)("pub", Qr));
    }
    o.edwardsToMontgomery = Mr;
    function Dr(Qr) {
      return o.ed25519.utils.toMontgomerySecret((0, D.ensureBytes)("pub", Qr));
    }
    o.RistrettoPoint = qr, o.hashToCurve = o.ed25519_hasher.hashToCurve, o.encodeToCurve = o.ed25519_hasher.encodeToCurve, o.hashToRistretto255 = o.ristretto255_hasher.hashToCurve, o.hash_to_ristretto255 = o.ristretto255_hasher.hashToCurve;
  }(ed25519)), ed25519;
}
const global$1 = globalThis || void 0 || self;
var name$l = "adler32", data$l = "AGFzbQEAAAABDANgAAF/YAAAYAF/AAMHBgABAgEAAgUEAQECAgYOAn8BQYCJBQt/AEGACAsHcAgGbWVtb3J5AgAOSGFzaF9HZXRCdWZmZXIAAAlIYXNoX0luaXQAAQtIYXNoX1VwZGF0ZQACCkhhc2hfRmluYWwAAw1IYXNoX0dldFN0YXRlAAQOSGFzaF9DYWxjdWxhdGUABQpTVEFURV9TSVpFAwEK6wkGBQBBgAkLCgBBAEEBNgKECAvjCAEHf0EAKAKECCIBQf//A3EhAiABQRB2IQMCQAJAIABBAUcNACACQQAtAIAJaiIBQY+AfGogASABQfD/A0sbIgEgA2oiBEEQdCIFQYCAPGogBSAEQfD/A0sbIAFyIQEMAQsCQAJAAkACQAJAIABBEEkNAEGACSEGIABBsCtJDQFBgAkhBgNAQQAhBQNAIAYgBWoiASgCACIEQf8BcSACaiICIANqIAIgBEEIdkH/AXFqIgJqIAIgBEEQdkH/AXFqIgJqIAIgBEEYdmoiAmogAiABQQRqKAIAIgRB/wFxaiICaiACIARBCHZB/wFxaiICaiACIARBEHZB/wFxaiICaiACIARBGHZqIgJqIAIgAUEIaigCACIEQf8BcWoiAmogAiAEQQh2Qf8BcWoiAmogAiAEQRB2Qf8BcWoiAmogAiAEQRh2aiIEaiAEIAFBDGooAgAiAUH/AXFqIgRqIAQgAUEIdkH/AXFqIgRqIAQgAUEQdkH/AXFqIgRqIAQgAUEYdmoiAmohAyAFQRBqIgVBsCtHDQALIANB8f8DcCEDIAJB8f8DcCECIAZBsCtqIQYgAEHQVGoiAEGvK0sNAAsgAEUNBCAAQQ9LDQEMAgsCQCAARQ0AAkACQCAAQQNxIgUNAEGACSEBIAAhBAwBCyAAQXxxIQRBACEBA0AgAiABQYAJai0AAGoiAiADaiEDIAUgAUEBaiIBRw0ACyAFQYAJaiEBCyAAQQRJDQADQCACIAEtAABqIgUgAS0AAWoiBiABLQACaiIAIAFBA2otAABqIgIgACAGIAUgA2pqamohAyABQQRqIQEgBEF8aiIEDQALCyACQY+AfGogAiACQfD/A0sbIANB8f8DcEEQdHIhAQwECwNAIAYoAgAiAUH/AXEgAmoiBCADaiAEIAFBCHZB/wFxaiIEaiAEIAFBEHZB/wFxaiIEaiAEIAFBGHZqIgRqIAQgBkEEaigCACIBQf8BcWoiBGogBCABQQh2Qf8BcWoiBGogBCABQRB2Qf8BcWoiBGogBCABQRh2aiIEaiAEIAZBCGooAgAiAUH/AXFqIgRqIAQgAUEIdkH/AXFqIgRqIAQgAUEQdkH/AXFqIgRqIAQgAUEYdmoiBGogBCAGQQxqKAIAIgFB/wFxaiIEaiAEIAFBCHZB/wFxaiIEaiAEIAFBEHZB/wFxaiIEaiAEIAFBGHZqIgJqIQMgBkEQaiEGIABBcGoiAEEPSw0ACyAARQ0BCyAAQX9qIQcCQCAAQQNxIgVFDQAgAEF8cSEAIAUhBCAGIQEDQCACIAEtAABqIgIgA2ohAyABQQFqIQEgBEF/aiIEDQALIAYgBWohBgsgB0EDSQ0AA0AgAiAGLQAAaiIBIAYtAAFqIgQgBi0AAmoiBSAGQQNqLQAAaiICIAUgBCABIANqampqIQMgBkEEaiEGIABBfGoiAA0ACwsgA0Hx/wNwIQMgAkHx/wNwIQILIAIgA0EQdHIhAQtBACABNgKECAsxAQF/QQBBACgChAgiAEEYdCAAQYD+A3FBCHRyIABBCHZBgP4DcSAAQRh2cnI2AoAJCwUAQYQICzsAQQBBATYChAggABACQQBBACgChAgiAEEYdCAAQYD+A3FBCHRyIABBCHZBgP4DcSAAQRh2cnI2AoAJCwsVAgBBgAgLBAQAAAAAQYQICwQBAAAA", hash$l = "02ddbd17", wasmJson$l = {
  name: name$l,
  data: data$l,
  hash: hash$l
};
function __awaiter(o, g, c, y) {
  function t(d) {
    return d instanceof c ? d : new c(function(E) {
      E(d);
    });
  }
  return new (c || (c = Promise))(function(d, E) {
    function B(v) {
      try {
        x(y.next(v));
      } catch (F) {
        E(F);
      }
    }
    function D(v) {
      try {
        x(y.throw(v));
      } catch (F) {
        E(F);
      }
    }
    function x(v) {
      v.done ? d(v.value) : t(v.value).then(B, D);
    }
    x((y = y.apply(o, [])).next());
  });
}
typeof SuppressedError == "function" && SuppressedError;
class Mutex {
  constructor() {
    this.mutex = Promise.resolve();
  }
  lock() {
    let g = () => {
    };
    return this.mutex = this.mutex.then(() => new Promise(g)), new Promise((c) => {
      g = c;
    });
  }
  dispatch(g) {
    return __awaiter(this, void 0, void 0, function* () {
      const c = yield this.lock();
      try {
        return yield Promise.resolve(g());
      } finally {
        c();
      }
    });
  }
}
var _a;
function getGlobal() {
  return typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global$1;
}
const globalObject = getGlobal(), nodeBuffer = (_a = globalObject.Buffer) !== null && _a !== void 0 ? _a : null, textEncoder = globalObject.TextEncoder ? new globalObject.TextEncoder() : null;
function intArrayToString(o, g) {
  return String.fromCharCode(...o.subarray(0, g));
}
function hexCharCodesToInt(o, g) {
  return (o & 15) + (o >> 6 | o >> 3 & 8) << 4 | (g & 15) + (g >> 6 | g >> 3 & 8);
}
function writeHexToUInt8(o, g) {
  const c = g.length >> 1;
  for (let y = 0; y < c; y++) {
    const t = y << 1;
    o[y] = hexCharCodesToInt(g.charCodeAt(t), g.charCodeAt(t + 1));
  }
}
function hexStringEqualsUInt8(o, g) {
  if (o.length !== g.length * 2)
    return !1;
  for (let c = 0; c < g.length; c++) {
    const y = c << 1;
    if (g[c] !== hexCharCodesToInt(o.charCodeAt(y), o.charCodeAt(y + 1)))
      return !1;
  }
  return !0;
}
const alpha = 87, digit = 48;
function getDigestHex(o, g, c) {
  let y = 0;
  for (let t = 0; t < c; t++) {
    let d = g[t] >>> 4;
    o[y++] = d > 9 ? d + alpha : d + digit, d = g[t] & 15, o[y++] = d > 9 ? d + alpha : d + digit;
  }
  return String.fromCharCode.apply(null, o);
}
const getUInt8Buffer = nodeBuffer !== null ? (o) => {
  if (typeof o == "string") {
    const g = nodeBuffer.from(o, "utf8");
    return new Uint8Array(g.buffer, g.byteOffset, g.length);
  }
  if (nodeBuffer.isBuffer(o))
    return new Uint8Array(o.buffer, o.byteOffset, o.length);
  if (ArrayBuffer.isView(o))
    return new Uint8Array(o.buffer, o.byteOffset, o.byteLength);
  throw new Error("Invalid data type!");
} : (o) => {
  if (typeof o == "string")
    return textEncoder.encode(o);
  if (ArrayBuffer.isView(o))
    return new Uint8Array(o.buffer, o.byteOffset, o.byteLength);
  throw new Error("Invalid data type!");
}, base64Chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", base64Lookup = new Uint8Array(256);
for (let o = 0; o < base64Chars.length; o++)
  base64Lookup[base64Chars.charCodeAt(o)] = o;
function encodeBase64(o, g = !0) {
  const c = o.length, y = c % 3, t = [], d = c - y;
  for (let E = 0; E < d; E += 3) {
    const B = (o[E] << 16 & 16711680) + (o[E + 1] << 8 & 65280) + (o[E + 2] & 255), D = base64Chars.charAt(B >> 18 & 63) + base64Chars.charAt(B >> 12 & 63) + base64Chars.charAt(B >> 6 & 63) + base64Chars.charAt(B & 63);
    t.push(D);
  }
  if (y === 1) {
    const E = o[c - 1], B = base64Chars.charAt(E >> 2), D = base64Chars.charAt(E << 4 & 63);
    t.push(`${B}${D}`), g && t.push("==");
  } else if (y === 2) {
    const E = (o[c - 2] << 8) + o[c - 1], B = base64Chars.charAt(E >> 10), D = base64Chars.charAt(E >> 4 & 63), x = base64Chars.charAt(E << 2 & 63);
    t.push(`${B}${D}${x}`), g && t.push("=");
  }
  return t.join("");
}
function getDecodeBase64Length(o) {
  let g = Math.floor(o.length * 0.75);
  const c = o.length;
  return o[c - 1] === "=" && (g -= 1, o[c - 2] === "=" && (g -= 1)), g;
}
function decodeBase64(o) {
  const g = getDecodeBase64Length(o), c = o.length, y = new Uint8Array(g);
  let t = 0;
  for (let d = 0; d < c; d += 4) {
    const E = base64Lookup[o.charCodeAt(d)], B = base64Lookup[o.charCodeAt(d + 1)], D = base64Lookup[o.charCodeAt(d + 2)], x = base64Lookup[o.charCodeAt(d + 3)];
    y[t] = E << 2 | B >> 4, t += 1, y[t] = (B & 15) << 4 | D >> 2, t += 1, y[t] = (D & 3) << 6 | x & 63, t += 1;
  }
  return y;
}
const MAX_HEAP = 16 * 1024, WASM_FUNC_HASH_LENGTH = 4, wasmMutex = new Mutex(), wasmModuleCache = /* @__PURE__ */ new Map();
function WASMInterface(o, g) {
  return __awaiter(this, void 0, void 0, function* () {
    let c = null, y = null, t = !1;
    if (typeof WebAssembly > "u")
      throw new Error("WebAssembly is not supported in this environment!");
    const d = (He, Pe = 0) => {
      y.set(He, Pe);
    }, E = () => y, B = () => c.exports, D = (He) => {
      c.exports.Hash_SetMemorySize(He);
      const Pe = c.exports.Hash_GetBuffer(), De = c.exports.memory.buffer;
      y = new Uint8Array(De, Pe, He);
    }, x = () => new DataView(c.exports.memory.buffer).getUint32(c.exports.STATE_SIZE, !0), v = wasmMutex.dispatch(() => __awaiter(this, void 0, void 0, function* () {
      if (!wasmModuleCache.has(o.name)) {
        const Pe = decodeBase64(o.data), De = WebAssembly.compile(Pe);
        wasmModuleCache.set(o.name, De);
      }
      const He = yield wasmModuleCache.get(o.name);
      c = yield WebAssembly.instantiate(He, {
        // env: {
        //   emscripten_memcpy_big: (dest, src, num) => {
        //     const memoryBuffer = wasmInstance.exports.memory.buffer;
        //     const memView = new Uint8Array(memoryBuffer, 0);
        //     memView.set(memView.subarray(src, src + num), dest);
        //   },
        //   print_memory: (offset, len) => {
        //     const memoryBuffer = wasmInstance.exports.memory.buffer;
        //     const memView = new Uint8Array(memoryBuffer, 0);
        //     console.log('print_int32', memView.subarray(offset, offset + len));
        //   },
        // },
      });
    })), F = () => __awaiter(this, void 0, void 0, function* () {
      c || (yield v);
      const He = c.exports.Hash_GetBuffer(), Pe = c.exports.memory.buffer;
      y = new Uint8Array(Pe, He, MAX_HEAP);
    }), M = (He = null) => {
      t = !0, c.exports.Hash_Init(He);
    }, U = (He) => {
      let Pe = 0;
      for (; Pe < He.length; ) {
        const De = He.subarray(Pe, Pe + MAX_HEAP);
        Pe += De.length, y.set(De), c.exports.Hash_Update(De.length);
      }
    }, L = (He) => {
      if (!t)
        throw new Error("update() called before init()");
      const Pe = getUInt8Buffer(He);
      U(Pe);
    }, H = new Uint8Array(g * 2), fe = (He, Pe = null) => {
      if (!t)
        throw new Error("digest() called before init()");
      return t = !1, c.exports.Hash_Final(Pe), He === "binary" ? y.slice(0, g) : getDigestHex(H, y, g);
    }, ge = () => {
      if (!t)
        throw new Error("save() can only be called after init() and before digest()");
      const He = c.exports.Hash_GetState(), Pe = x(), De = c.exports.memory.buffer, ve = new Uint8Array(De, He, Pe), Fe = new Uint8Array(WASM_FUNC_HASH_LENGTH + Pe);
      return writeHexToUInt8(Fe, o.hash), Fe.set(ve, WASM_FUNC_HASH_LENGTH), Fe;
    }, Ie = (He) => {
      if (!(He instanceof Uint8Array))
        throw new Error("load() expects an Uint8Array generated by save()");
      const Pe = c.exports.Hash_GetState(), De = x(), ve = WASM_FUNC_HASH_LENGTH + De, Fe = c.exports.memory.buffer;
      if (He.length !== ve)
        throw new Error(`Bad state length (expected ${ve} bytes, got ${He.length})`);
      if (!hexStringEqualsUInt8(o.hash, He.subarray(0, WASM_FUNC_HASH_LENGTH)))
        throw new Error("This state was written by an incompatible hash implementation");
      const be = He.subarray(WASM_FUNC_HASH_LENGTH);
      new Uint8Array(Fe, Pe, De).set(be), t = !0;
    }, Ee = (He) => typeof He == "string" ? He.length < MAX_HEAP / 4 : He.byteLength < MAX_HEAP;
    let Se = Ee;
    switch (o.name) {
      case "argon2":
      case "scrypt":
        Se = () => !0;
        break;
      case "blake2b":
      case "blake2s":
        Se = (He, Pe) => Pe <= 512 && Ee(He);
        break;
      case "blake3":
        Se = (He, Pe) => Pe === 0 && Ee(He);
        break;
      case "xxhash64":
      // cannot simplify
      case "xxhash3":
      case "xxhash128":
      case "crc64":
        Se = () => !1;
        break;
    }
    const ze = (He, Pe = null, De = null) => {
      if (!Se(He, Pe))
        return M(Pe), L(He), fe("hex", De);
      const ve = getUInt8Buffer(He);
      return y.set(ve), c.exports.Hash_Calculate(ve.length, Pe, De), getDigestHex(H, y, g);
    };
    return yield F(), {
      getMemory: E,
      writeMemory: d,
      getExports: B,
      setMemorySize: D,
      init: M,
      update: L,
      digest: fe,
      save: ge,
      load: Ie,
      calculate: ze,
      hashLength: g
    };
  });
}
function lockedCreate(o, g, c) {
  return __awaiter(this, void 0, void 0, function* () {
    const y = yield o.lock(), t = yield WASMInterface(g, c);
    return y(), t;
  });
}
const mutex$l = new Mutex();
let wasmCache$l = null;
function adler32(o) {
  if (wasmCache$l === null)
    return lockedCreate(mutex$l, wasmJson$l, 4).then((g) => (wasmCache$l = g, wasmCache$l.calculate(o)));
  try {
    const g = wasmCache$l.calculate(o);
    return Promise.resolve(g);
  } catch (g) {
    return Promise.reject(g);
  }
}
function createAdler32() {
  return WASMInterface(wasmJson$l, 4).then((o) => {
    o.init();
    const g = {
      init: () => (o.init(), g),
      update: (c) => (o.update(c), g),
      // biome-ignore lint/suspicious/noExplicitAny: Conflict with IHasher type
      digest: (c) => o.digest(c),
      save: () => o.save(),
      load: (c) => (o.load(c), g),
      blockSize: 4,
      digestSize: 4
    };
    return g;
  });
}
var name$k = "argon2", data$k = "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", hash$k = "e4cdc523", wasmJson$k = {
  name: name$k,
  data: data$k,
  hash: hash$k
}, name$j = "blake2b", data$j = "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", hash$j = "c6f286e6", wasmJson$j = {
  name: name$j,
  data: data$j,
  hash: hash$j
};
const mutex$k = new Mutex();
let wasmCache$k = null;
function validateBits$4(o) {
  return !Number.isInteger(o) || o < 8 || o > 512 || o % 8 !== 0 ? new Error("Invalid variant! Valid values: 8, 16, ..., 512") : null;
}
function getInitParam$1(o, g) {
  return o | g << 16;
}
function blake2b(o, g = 512, c = null) {
  if (validateBits$4(g))
    return Promise.reject(validateBits$4(g));
  let y = null, t = g;
  if (c !== null) {
    if (y = getUInt8Buffer(c), y.length > 64)
      return Promise.reject(new Error("Max key length is 64 bytes"));
    t = getInitParam$1(g, y.length);
  }
  const d = g / 8;
  if (wasmCache$k === null || wasmCache$k.hashLength !== d)
    return lockedCreate(mutex$k, wasmJson$j, d).then((E) => (wasmCache$k = E, t > 512 && wasmCache$k.writeMemory(y), wasmCache$k.calculate(o, t)));
  try {
    t > 512 && wasmCache$k.writeMemory(y);
    const E = wasmCache$k.calculate(o, t);
    return Promise.resolve(E);
  } catch (E) {
    return Promise.reject(E);
  }
}
function createBLAKE2b(o = 512, g = null) {
  if (validateBits$4(o))
    return Promise.reject(validateBits$4(o));
  let c = null, y = o;
  if (g !== null) {
    if (c = getUInt8Buffer(g), c.length > 64)
      return Promise.reject(new Error("Max key length is 64 bytes"));
    y = getInitParam$1(o, c.length);
  }
  const t = o / 8;
  return WASMInterface(wasmJson$j, t).then((d) => {
    y > 512 && d.writeMemory(c), d.init(y);
    const E = {
      init: y > 512 ? () => (d.writeMemory(c), d.init(y), E) : () => (d.init(y), E),
      update: (B) => (d.update(B), E),
      // biome-ignore lint/suspicious/noExplicitAny: Conflict with IHasher type
      digest: (B) => d.digest(B),
      save: () => d.save(),
      load: (B) => (d.load(B), E),
      blockSize: 128,
      digestSize: t
    };
    return E;
  });
}
function encodeResult(o, g, c) {
  const y = [
    `m=${g.memorySize}`,
    `t=${g.iterations}`,
    `p=${g.parallelism}`
  ].join(",");
  return `$argon2${g.hashType}$v=19$${y}$${encodeBase64(o, !1)}$${encodeBase64(c, !1)}`;
}
const uint32View = new DataView(new ArrayBuffer(4));
function int32LE(o) {
  return uint32View.setInt32(0, o, !0), new Uint8Array(uint32View.buffer);
}
function hashFunc(o, g, c) {
  return __awaiter(this, void 0, void 0, function* () {
    if (c <= 64) {
      const D = yield createBLAKE2b(c * 8);
      return D.update(int32LE(c)), D.update(g), D.digest("binary");
    }
    const y = Math.ceil(c / 32) - 2, t = new Uint8Array(c);
    o.init(), o.update(int32LE(c)), o.update(g);
    let d = o.digest("binary");
    t.set(d.subarray(0, 32), 0);
    for (let D = 1; D < y; D++)
      o.init(), o.update(d), d = o.digest("binary"), t.set(d.subarray(0, 32), D * 32);
    const E = c - 32 * y;
    let B;
    return E === 64 ? (B = o, B.init()) : B = yield createBLAKE2b(E * 8), B.update(d), d = B.digest("binary"), t.set(d.subarray(0, E), y * 32), t;
  });
}
function getHashType(o) {
  switch (o) {
    case "d":
      return 0;
    case "i":
      return 1;
    default:
      return 2;
  }
}
function argon2Internal(o) {
  return __awaiter(this, void 0, void 0, function* () {
    var g;
    const { parallelism: c, iterations: y, hashLength: t } = o, d = getUInt8Buffer(o.password), E = getUInt8Buffer(o.salt), B = 19, D = getHashType(o.hashType), { memorySize: x } = o, v = getUInt8Buffer((g = o.secret) !== null && g !== void 0 ? g : ""), [F, M] = yield Promise.all([
      WASMInterface(wasmJson$k, 1024),
      createBLAKE2b(512)
    ]);
    F.setMemorySize(x * 1024 + 1024);
    const U = new Uint8Array(24), L = new DataView(U.buffer);
    L.setInt32(0, c, !0), L.setInt32(4, t, !0), L.setInt32(8, x, !0), L.setInt32(12, y, !0), L.setInt32(16, B, !0), L.setInt32(20, D, !0), F.writeMemory(U, x * 1024), M.init(), M.update(U), M.update(int32LE(d.length)), M.update(d), M.update(int32LE(E.length)), M.update(E), M.update(int32LE(v.length)), M.update(v), M.update(int32LE(0));
    const fe = Math.floor(x / (c * 4)) * 4, ge = new Uint8Array(72), Ie = M.digest("binary");
    ge.set(Ie);
    for (let ze = 0; ze < c; ze++) {
      ge.set(int32LE(0), 64), ge.set(int32LE(ze), 68);
      let He = ze * fe, Pe = yield hashFunc(M, ge, 1024);
      F.writeMemory(Pe, He * 1024), He += 1, ge.set(int32LE(1), 64), Pe = yield hashFunc(M, ge, 1024), F.writeMemory(Pe, He * 1024);
    }
    const Ee = new Uint8Array(1024);
    writeHexToUInt8(Ee, F.calculate(new Uint8Array([]), x));
    const Se = yield hashFunc(M, Ee, t);
    if (o.outputType === "hex") {
      const ze = new Uint8Array(t * 2);
      return getDigestHex(ze, Se, t);
    }
    return o.outputType === "encoded" ? encodeResult(E, o, Se) : Se;
  });
}
const validateOptions$3 = (o) => {
  var g;
  if (!o || typeof o != "object")
    throw new Error("Invalid options parameter. It requires an object.");
  if (!o.password)
    throw new Error("Password must be specified");
  if (o.password = getUInt8Buffer(o.password), o.password.length < 1)
    throw new Error("Password must be specified");
  if (!o.salt)
    throw new Error("Salt must be specified");
  if (o.salt = getUInt8Buffer(o.salt), o.salt.length < 8)
    throw new Error("Salt should be at least 8 bytes long");
  if (o.secret = getUInt8Buffer((g = o.secret) !== null && g !== void 0 ? g : ""), !Number.isInteger(o.iterations) || o.iterations < 1)
    throw new Error("Iterations should be a positive number");
  if (!Number.isInteger(o.parallelism) || o.parallelism < 1)
    throw new Error("Parallelism should be a positive number");
  if (!Number.isInteger(o.hashLength) || o.hashLength < 4)
    throw new Error("Hash length should be at least 4 bytes.");
  if (!Number.isInteger(o.memorySize))
    throw new Error("Memory size should be specified.");
  if (o.memorySize < 8 * o.parallelism)
    throw new Error("Memory size should be at least 8 * parallelism.");
  if (o.outputType === void 0 && (o.outputType = "hex"), !["hex", "binary", "encoded"].includes(o.outputType))
    throw new Error(`Insupported output type ${o.outputType}. Valid values: ['hex', 'binary', 'encoded']`);
};
function argon2i(o) {
  return __awaiter(this, void 0, void 0, function* () {
    return validateOptions$3(o), argon2Internal(Object.assign(Object.assign({}, o), { hashType: "i" }));
  });
}
function argon2id(o) {
  return __awaiter(this, void 0, void 0, function* () {
    return validateOptions$3(o), argon2Internal(Object.assign(Object.assign({}, o), { hashType: "id" }));
  });
}
function argon2d(o) {
  return __awaiter(this, void 0, void 0, function* () {
    return validateOptions$3(o), argon2Internal(Object.assign(Object.assign({}, o), { hashType: "d" }));
  });
}
const getHashParameters = (o, g, c) => {
  const y = /^\$argon2(id|i|d)\$v=([0-9]+)\$((?:[mtp]=[0-9]+,){2}[mtp]=[0-9]+)\$([A-Za-z0-9+/]+)\$([A-Za-z0-9+/]+)$/, t = g.match(y);
  if (!t)
    throw new Error("Invalid hash");
  const [, d, E, B, D, x] = t;
  if (E !== "19")
    throw new Error(`Unsupported version: ${E}`);
  const v = {}, F = { m: "memorySize", p: "parallelism", t: "iterations" };
  for (const M of B.split(",")) {
    const [U, L] = M.split("=");
    v[F[U]] = Number(L);
  }
  return Object.assign(Object.assign({}, v), {
    password: o,
    secret: c,
    hashType: d,
    salt: decodeBase64(D),
    hashLength: getDecodeBase64Length(x),
    outputType: "encoded"
  });
}, validateVerifyOptions$1 = (o) => {
  if (!o || typeof o != "object")
    throw new Error("Invalid options parameter. It requires an object.");
  if (o.hash === void 0 || typeof o.hash != "string")
    throw new Error("Hash should be specified");
};
function argon2Verify(o) {
  return __awaiter(this, void 0, void 0, function* () {
    validateVerifyOptions$1(o);
    const g = getHashParameters(o.password, o.hash, o.secret);
    validateOptions$3(g);
    const c = o.hash.lastIndexOf("$") + 1;
    return (yield argon2Internal(g)).substring(c) === o.hash.substring(c);
  });
}
var name$i = "blake2s", data$i = "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", hash$i = "5c0ff166", wasmJson$i = {
  name: name$i,
  data: data$i,
  hash: hash$i
};
const mutex$j = new Mutex();
let wasmCache$j = null;
function validateBits$3(o) {
  return !Number.isInteger(o) || o < 8 || o > 256 || o % 8 !== 0 ? new Error("Invalid variant! Valid values: 8, 16, ..., 256") : null;
}
function getInitParam(o, g) {
  return o | g << 16;
}
function blake2s(o, g = 256, c = null) {
  if (validateBits$3(g))
    return Promise.reject(validateBits$3(g));
  let y = null, t = g;
  if (c !== null) {
    if (y = getUInt8Buffer(c), y.length > 32)
      return Promise.reject(new Error("Max key length is 32 bytes"));
    t = getInitParam(g, y.length);
  }
  const d = g / 8;
  if (wasmCache$j === null || wasmCache$j.hashLength !== d)
    return lockedCreate(mutex$j, wasmJson$i, d).then((E) => (wasmCache$j = E, t > 512 && wasmCache$j.writeMemory(y), wasmCache$j.calculate(o, t)));
  try {
    t > 512 && wasmCache$j.writeMemory(y);
    const E = wasmCache$j.calculate(o, t);
    return Promise.resolve(E);
  } catch (E) {
    return Promise.reject(E);
  }
}
function createBLAKE2s(o = 256, g = null) {
  if (validateBits$3(o))
    return Promise.reject(validateBits$3(o));
  let c = null, y = o;
  if (g !== null) {
    if (c = getUInt8Buffer(g), c.length > 32)
      return Promise.reject(new Error("Max key length is 32 bytes"));
    y = getInitParam(o, c.length);
  }
  const t = o / 8;
  return WASMInterface(wasmJson$i, t).then((d) => {
    y > 512 && d.writeMemory(c), d.init(y);
    const E = {
      init: y > 512 ? () => (d.writeMemory(c), d.init(y), E) : () => (d.init(y), E),
      update: (B) => (d.update(B), E),
      // biome-ignore lint/suspicious/noExplicitAny: Conflict with IHasher type
      digest: (B) => d.digest(B),
      save: () => d.save(),
      load: (B) => (d.load(B), E),
      blockSize: 64,
      digestSize: t
    };
    return E;
  });
}
var name$h = "blake3", data$h = "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", hash$h = "215d875f", wasmJson$h = {
  name: name$h,
  data: data$h,
  hash: hash$h
};
const mutex$i = new Mutex();
let wasmCache$i = null;
function validateBits$2(o) {
  return !Number.isInteger(o) || o < 8 || o % 8 !== 0 ? new Error("Invalid variant! Valid values: 8, 16, ...") : null;
}
function blake3(o, g = 256, c = null) {
  if (validateBits$2(g))
    return Promise.reject(validateBits$2(g));
  let y = null, t = 0;
  if (c !== null) {
    if (y = getUInt8Buffer(c), y.length !== 32)
      return Promise.reject(new Error("Key length must be exactly 32 bytes"));
    t = 32;
  }
  const d = g / 8, E = d;
  if (wasmCache$i === null || wasmCache$i.hashLength !== d)
    return lockedCreate(mutex$i, wasmJson$h, d).then((B) => (wasmCache$i = B, t === 32 && wasmCache$i.writeMemory(y), wasmCache$i.calculate(o, t, E)));
  try {
    t === 32 && wasmCache$i.writeMemory(y);
    const B = wasmCache$i.calculate(o, t, E);
    return Promise.resolve(B);
  } catch (B) {
    return Promise.reject(B);
  }
}
function createBLAKE3(o = 256, g = null) {
  if (validateBits$2(o))
    return Promise.reject(validateBits$2(o));
  let c = null, y = 0;
  if (g !== null) {
    if (c = getUInt8Buffer(g), c.length !== 32)
      return Promise.reject(new Error("Key length must be exactly 32 bytes"));
    y = 32;
  }
  const t = o / 8, d = t;
  return WASMInterface(wasmJson$h, t).then((E) => {
    y === 32 && E.writeMemory(c), E.init(y);
    const B = {
      init: y === 32 ? () => (E.writeMemory(c), E.init(y), B) : () => (E.init(y), B),
      update: (D) => (E.update(D), B),
      // biome-ignore lint/suspicious/noExplicitAny: Conflict with IHasher type
      digest: (D) => E.digest(D, d),
      save: () => E.save(),
      load: (D) => (E.load(D), B),
      blockSize: 64,
      digestSize: t
    };
    return B;
  });
}
var name$g = "crc32", data$g = "AGFzbQEAAAABEQRgAAF/YAF/AGAAAGACf38AAwgHAAEBAQIAAwUEAQECAgYOAn8BQZDJBQt/AEGACAsHcAgGbWVtb3J5AgAOSGFzaF9HZXRCdWZmZXIAAAlIYXNoX0luaXQAAgtIYXNoX1VwZGF0ZQADCkhhc2hfRmluYWwABA1IYXNoX0dldFN0YXRlAAUOSGFzaF9DYWxjdWxhdGUABgpTVEFURV9TSVpFAwEKkggHBQBBgAkLwwMBA39BgIkBIQFBACECA0AgAUEAQQBBAEEAQQBBAEEAQQAgAkEBcWsgAHEgAkEBdnMiA0EBcWsgAHEgA0EBdnMiA0EBcWsgAHEgA0EBdnMiA0EBcWsgAHEgA0EBdnMiA0EBcWsgAHEgA0EBdnMiA0EBcWsgAHEgA0EBdnMiA0EBcWsgAHEgA0EBdnMiA0EBcWsgAHEgA0EBdnM2AgAgAUEEaiEBIAJBAWoiAkGAAkcNAAtBACEAA0AgAEGEkQFqIABBhIkBaigCACICQf8BcUECdEGAiQFqKAIAIAJBCHZzIgI2AgAgAEGEmQFqIAJB/wFxQQJ0QYCJAWooAgAgAkEIdnMiAjYCACAAQYShAWogAkH/AXFBAnRBgIkBaigCACACQQh2cyICNgIAIABBhKkBaiACQf8BcUECdEGAiQFqKAIAIAJBCHZzIgI2AgAgAEGEsQFqIAJB/wFxQQJ0QYCJAWooAgAgAkEIdnMiAjYCACAAQYS5AWogAkH/AXFBAnRBgIkBaigCACACQQh2cyICNgIAIABBhMEBaiACQf8BcUECdEGAiQFqKAIAIAJBCHZzNgIAIABBBGoiAEH8B0cNAAsLJwACQEEAKAKAyQEgAEYNACAAEAFBACAANgKAyQELQQBBADYChMkBC4gDAQN/QQAoAoTJAUF/cyEBQYAJIQICQCAAQQhJDQBBgAkhAgNAIAJBBGooAgAiA0EOdkH8B3FBgJEBaigCACADQRZ2QfwHcUGAiQFqKAIAcyADQQZ2QfwHcUGAmQFqKAIAcyADQf8BcUECdEGAoQFqKAIAcyACKAIAIAFzIgFBFnZB/AdxQYCpAWooAgBzIAFBDnZB/AdxQYCxAWooAgBzIAFBBnZB/AdxQYC5AWooAgBzIAFB/wFxQQJ0QYDBAWooAgBzIQEgAkEIaiECIABBeGoiAEEHSw0ACwsCQCAARQ0AAkACQCAAQQFxDQAgACEDDAELIAFB/wFxIAItAABzQQJ0QYCJAWooAgAgAUEIdnMhASACQQFqIQIgAEF/aiEDCyAAQQFGDQADQCABQf8BcSACLQAAc0ECdEGAiQFqKAIAIAFBCHZzIgFB/wFxIAJBAWotAABzQQJ0QYCJAWooAgAgAUEIdnMhASACQQJqIQIgA0F+aiIDDQALC0EAIAFBf3M2AoTJAQsyAQF/QQBBACgChMkBIgBBGHQgAEGA/gNxQQh0ciAAQQh2QYD+A3EgAEEYdnJyNgKACQsGAEGEyQELWQACQEEAKAKAyQEgAUYNACABEAFBACABNgKAyQELQQBBADYChMkBIAAQA0EAQQAoAoTJASIBQRh0IAFBgP4DcUEIdHIgAUEIdkGA/gNxIAFBGHZycjYCgAkLCwsBAEGACAsEBAAAAA==", hash$g = "d2eba587", wasmJson$g = {
  name: name$g,
  data: data$g,
  hash: hash$g
};
const mutex$h = new Mutex();
let wasmCache$h = null;
function validatePoly(o) {
  return !Number.isInteger(o) || o < 0 || o > 4294967295 ? new Error("Polynomial must be a valid 32-bit long unsigned integer") : null;
}
function crc32(o, g = 3988292384) {
  if (validatePoly(g))
    return Promise.reject(validatePoly(g));
  if (wasmCache$h === null)
    return lockedCreate(mutex$h, wasmJson$g, 4).then((c) => (wasmCache$h = c, wasmCache$h.calculate(o, g)));
  try {
    const c = wasmCache$h.calculate(o, g);
    return Promise.resolve(c);
  } catch (c) {
    return Promise.reject(c);
  }
}
function createCRC32(o = 3988292384) {
  return validatePoly(o) ? Promise.reject(validatePoly(o)) : WASMInterface(wasmJson$g, 4).then((g) => {
    g.init(o);
    const c = {
      init: () => (g.init(o), c),
      update: (y) => (g.update(y), c),
      // biome-ignore lint/suspicious/noExplicitAny: Conflict with IHasher type
      digest: (y) => g.digest(y),
      save: () => g.save(),
      load: (y) => (g.load(y), c),
      blockSize: 4,
      digestSize: 4
    };
    return c;
  });
}
var name$f = "crc64", data$f = "AGFzbQEAAAABDANgAAF/YAAAYAF/AAMHBgABAgEAAQUEAQECAgYOAn8BQZCJBgt/AEGACAsHcAgGbWVtb3J5AgAOSGFzaF9HZXRCdWZmZXIAAAlIYXNoX0luaXQAAQtIYXNoX1VwZGF0ZQACCkhhc2hfRmluYWwAAw1IYXNoX0dldFN0YXRlAAQOSGFzaF9DYWxjdWxhdGUABQpTVEFURV9TSVpFAwEKgwgGBQBBgAkL9QMDAX4BfwJ+AkBBACkDgIkCQQApA4AJIgBRDQBBgIkBIQFCACECA0AgAUIAQgBCAEIAQgBCAEIAQgAgAkIBg30gAIMgAkIBiIUiA0IBg30gAIMgA0IBiIUiA0IBg30gAIMgA0IBiIUiA0IBg30gAIMgA0IBiIUiA0IBg30gAIMgA0IBiIUiA0IBg30gAIMgA0IBiIUiA0IBg30gAIMgA0IBiIUiA0IBg30gAIMgA0IBiIU3AwAgAUEIaiEBIAJCAXwiAkKAAlINAAtBACEBA0AgAUGImQFqIAFBiIkBaikDACICp0H/AXFBA3RBgIkBaikDACACQgiIhSICNwMAIAFBiKkBaiACp0H/AXFBA3RBgIkBaikDACACQgiIhSICNwMAIAFBiLkBaiACp0H/AXFBA3RBgIkBaikDACACQgiIhSICNwMAIAFBiMkBaiACp0H/AXFBA3RBgIkBaikDACACQgiIhSICNwMAIAFBiNkBaiACp0H/AXFBA3RBgIkBaikDACACQgiIhSICNwMAIAFBiOkBaiACp0H/AXFBA3RBgIkBaikDACACQgiIhSICNwMAIAFBiPkBaiACp0H/AXFBA3RBgIkBaikDACACQgiIhTcDACABQQhqIgFB+A9HDQALQQAgADcDgIkCC0EAQgA3A4iJAguUAwIBfgJ/QQApA4iJAkJ/hSEBQYAJIQICQCAAQQhJDQBBgAkhAgNAIAIpAwAgAYUiAUIwiKdB/wFxQQN0QYCZAWopAwAgAUI4iKdBA3RBgIkBaikDAIUgAUIoiKdB/wFxQQN0QYCpAWopAwCFIAFCIIinQf8BcUEDdEGAuQFqKQMAhSABpyIDQRV2QfgPcUGAyQFqKQMAhSADQQ12QfgPcUGA2QFqKQMAhSADQQV2QfgPcUGA6QFqKQMAhSADQf8BcUEDdEGA+QFqKQMAhSEBIAJBCGohAiAAQXhqIgBBB0sNAAsLAkAgAEUNAAJAAkAgAEEBcQ0AIAAhAwwBCyABQv8BgyACMQAAhadBA3RBgIkBaikDACABQgiIhSEBIAJBAWohAiAAQX9qIQMLIABBAUYNAANAIAFC/wGDIAIxAACFp0EDdEGAiQFqKQMAIAFCCIiFIgFC/wGDIAJBAWoxAACFp0EDdEGAiQFqKQMAIAFCCIiFIQEgAkECaiECIANBfmoiAw0ACwtBACABQn+FNwOIiQILZAEBfkEAQQApA4iJAiIAQjiGIABCgP4Dg0IohoQgAEKAgPwHg0IYhiAAQoCAgPgPg0IIhoSEIABCCIhCgICA+A+DIABCGIhCgID8B4OEIABCKIhCgP4DgyAAQjiIhISENwOACQsGAEGIiQILAgALCwsBAEGACAsECAAAAA==", hash$f = "c5ac6c16", wasmJson$f = {
  name: name$f,
  data: data$f,
  hash: hash$f
};
const mutex$g = new Mutex();
let wasmCache$g = null;
const polyBuffer = new Uint8Array(8);
function parsePoly(o) {
  const g = "Polynomial must be provided as a 16 char long hex string";
  if (typeof o != "string" || o.length !== 16)
    return { hi: 0, lo: 0, err: new Error(g) };
  const c = +`0x${o.slice(0, 8)}`, y = +`0x${o.slice(8)}`;
  return Number.isNaN(c) || Number.isNaN(y) ? { hi: c, lo: y, err: new Error(g) } : { hi: c, lo: y, err: null };
}
function writePoly(o, g, c) {
  const y = new DataView(o);
  y.setUint32(0, g, !0), y.setUint32(4, c, !0);
}
function crc64(o, g = "c96c5795d7870f42") {
  const { hi: c, lo: y, err: t } = parsePoly(g);
  if (t !== null)
    return Promise.reject(t);
  if (wasmCache$g === null)
    return lockedCreate(mutex$g, wasmJson$f, 8).then((d) => (wasmCache$g = d, writePoly(polyBuffer.buffer, y, c), wasmCache$g.writeMemory(polyBuffer), wasmCache$g.calculate(o)));
  try {
    writePoly(polyBuffer.buffer, y, c), wasmCache$g.writeMemory(polyBuffer);
    const d = wasmCache$g.calculate(o);
    return Promise.resolve(d);
  } catch (d) {
    return Promise.reject(d);
  }
}
function createCRC64(o = "c96c5795d7870f42") {
  const { hi: g, lo: c, err: y } = parsePoly(o);
  return y !== null ? Promise.reject(y) : WASMInterface(wasmJson$f, 8).then((t) => {
    const d = new Uint8Array(8);
    writePoly(d.buffer, c, g), t.writeMemory(d), t.init();
    const E = {
      init: () => (t.writeMemory(d), t.init(), E),
      update: (B) => (t.update(B), E),
      // biome-ignore lint/suspicious/noExplicitAny: Conflict with IHasher type
      digest: (B) => t.digest(B),
      save: () => t.save(),
      load: (B) => (t.load(B), E),
      blockSize: 8,
      digestSize: 8
    };
    return E;
  });
}
var name$e = "md4", data$e = "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", hash$e = "bd8ce7c7", wasmJson$e = {
  name: name$e,
  data: data$e,
  hash: hash$e
};
const mutex$f = new Mutex();
let wasmCache$f = null;
function md4(o) {
  if (wasmCache$f === null)
    return lockedCreate(mutex$f, wasmJson$e, 16).then((g) => (wasmCache$f = g, wasmCache$f.calculate(o)));
  try {
    const g = wasmCache$f.calculate(o);
    return Promise.resolve(g);
  } catch (g) {
    return Promise.reject(g);
  }
}
function createMD4() {
  return WASMInterface(wasmJson$e, 16).then((o) => {
    o.init();
    const g = {
      init: () => (o.init(), g),
      update: (c) => (o.update(c), g),
      // biome-ignore lint/suspicious/noExplicitAny: Conflict with IHasher type
      digest: (c) => o.digest(c),
      save: () => o.save(),
      load: (c) => (o.load(c), g),
      blockSize: 64,
      digestSize: 16
    };
    return g;
  });
}
var name$d = "md5", data$d = "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", hash$d = "e6508e4b", wasmJson$d = {
  name: name$d,
  data: data$d,
  hash: hash$d
};
const mutex$e = new Mutex();
let wasmCache$e = null;
function md5(o) {
  if (wasmCache$e === null)
    return lockedCreate(mutex$e, wasmJson$d, 16).then((g) => (wasmCache$e = g, wasmCache$e.calculate(o)));
  try {
    const g = wasmCache$e.calculate(o);
    return Promise.resolve(g);
  } catch (g) {
    return Promise.reject(g);
  }
}
function createMD5() {
  return WASMInterface(wasmJson$d, 16).then((o) => {
    o.init();
    const g = {
      init: () => (o.init(), g),
      update: (c) => (o.update(c), g),
      // biome-ignore lint/suspicious/noExplicitAny: Conflict with IHasher type
      digest: (c) => o.digest(c),
      save: () => o.save(),
      load: (c) => (o.load(c), g),
      blockSize: 64,
      digestSize: 16
    };
    return g;
  });
}
var name$c = "sha1", data$c = "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", hash$c = "6b530c24", wasmJson$c = {
  name: name$c,
  data: data$c,
  hash: hash$c
};
const mutex$d = new Mutex();
let wasmCache$d = null;
function sha1(o) {
  if (wasmCache$d === null)
    return lockedCreate(mutex$d, wasmJson$c, 20).then((g) => (wasmCache$d = g, wasmCache$d.calculate(o)));
  try {
    const g = wasmCache$d.calculate(o);
    return Promise.resolve(g);
  } catch (g) {
    return Promise.reject(g);
  }
}
function createSHA1() {
  return WASMInterface(wasmJson$c, 20).then((o) => {
    o.init();
    const g = {
      init: () => (o.init(), g),
      update: (c) => (o.update(c), g),
      // biome-ignore lint/suspicious/noExplicitAny: Conflict with IHasher type
      digest: (c) => o.digest(c),
      save: () => o.save(),
      load: (c) => (o.load(c), g),
      blockSize: 64,
      digestSize: 20
    };
    return g;
  });
}
var name$b = "sha3", data$b = "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", hash$b = "fb24e536", wasmJson$b = {
  name: name$b,
  data: data$b,
  hash: hash$b
};
const mutex$c = new Mutex();
let wasmCache$c = null;
function validateBits$1(o) {
  return [224, 256, 384, 512].includes(o) ? null : new Error("Invalid variant! Valid values: 224, 256, 384, 512");
}
function sha3(o, g = 512) {
  if (validateBits$1(g))
    return Promise.reject(validateBits$1(g));
  const c = g / 8;
  if (wasmCache$c === null || wasmCache$c.hashLength !== c)
    return lockedCreate(mutex$c, wasmJson$b, c).then((y) => (wasmCache$c = y, wasmCache$c.calculate(o, g, 6)));
  try {
    const y = wasmCache$c.calculate(o, g, 6);
    return Promise.resolve(y);
  } catch (y) {
    return Promise.reject(y);
  }
}
function createSHA3(o = 512) {
  if (validateBits$1(o))
    return Promise.reject(validateBits$1(o));
  const g = o / 8;
  return WASMInterface(wasmJson$b, g).then((c) => {
    c.init(o);
    const y = {
      init: () => (c.init(o), y),
      update: (t) => (c.update(t), y),
      // biome-ignore lint/suspicious/noExplicitAny: Conflict with IHasher type
      digest: (t) => c.digest(t, 6),
      save: () => c.save(),
      load: (t) => (c.load(t), y),
      blockSize: 200 - 2 * g,
      digestSize: g
    };
    return y;
  });
}
const mutex$b = new Mutex();
let wasmCache$b = null;
function validateBits(o) {
  return [224, 256, 384, 512].includes(o) ? null : new Error("Invalid variant! Valid values: 224, 256, 384, 512");
}
function keccak(o, g = 512) {
  if (validateBits(g))
    return Promise.reject(validateBits(g));
  const c = g / 8;
  if (wasmCache$b === null || wasmCache$b.hashLength !== c)
    return lockedCreate(mutex$b, wasmJson$b, c).then((y) => (wasmCache$b = y, wasmCache$b.calculate(o, g, 1)));
  try {
    const y = wasmCache$b.calculate(o, g, 1);
    return Promise.resolve(y);
  } catch (y) {
    return Promise.reject(y);
  }
}
function createKeccak(o = 512) {
  if (validateBits(o))
    return Promise.reject(validateBits(o));
  const g = o / 8;
  return WASMInterface(wasmJson$b, g).then((c) => {
    c.init(o);
    const y = {
      init: () => (c.init(o), y),
      update: (t) => (c.update(t), y),
      // biome-ignore lint/suspicious/noExplicitAny: Conflict with IHasher type
      digest: (t) => c.digest(t, 1),
      save: () => c.save(),
      load: (t) => (c.load(t), y),
      blockSize: 200 - 2 * g,
      digestSize: g
    };
    return y;
  });
}
var name$a = "sha256", data$a = "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", hash$a = "8c18dd94", wasmJson$a = {
  name: name$a,
  data: data$a,
  hash: hash$a
};
const mutex$a = new Mutex();
let wasmCache$a = null;
function sha224(o) {
  if (wasmCache$a === null)
    return lockedCreate(mutex$a, wasmJson$a, 28).then((g) => (wasmCache$a = g, wasmCache$a.calculate(o, 224)));
  try {
    const g = wasmCache$a.calculate(o, 224);
    return Promise.resolve(g);
  } catch (g) {
    return Promise.reject(g);
  }
}
function createSHA224() {
  return WASMInterface(wasmJson$a, 28).then((o) => {
    o.init(224);
    const g = {
      init: () => (o.init(224), g),
      update: (c) => (o.update(c), g),
      // biome-ignore lint/suspicious/noExplicitAny: Conflict with IHasher type
      digest: (c) => o.digest(c),
      save: () => o.save(),
      load: (c) => (o.load(c), g),
      blockSize: 64,
      digestSize: 28
    };
    return g;
  });
}
const mutex$9 = new Mutex();
let wasmCache$9 = null;
function sha256$1(o) {
  if (wasmCache$9 === null)
    return lockedCreate(mutex$9, wasmJson$a, 32).then((g) => (wasmCache$9 = g, wasmCache$9.calculate(o, 256)));
  try {
    const g = wasmCache$9.calculate(o, 256);
    return Promise.resolve(g);
  } catch (g) {
    return Promise.reject(g);
  }
}
function createSHA256() {
  return WASMInterface(wasmJson$a, 32).then((o) => {
    o.init(256);
    const g = {
      init: () => (o.init(256), g),
      update: (c) => (o.update(c), g),
      // biome-ignore lint/suspicious/noExplicitAny: Conflict with IHasher type
      digest: (c) => o.digest(c),
      save: () => o.save(),
      load: (c) => (o.load(c), g),
      blockSize: 64,
      digestSize: 32
    };
    return g;
  });
}
var name$9 = "sha512", data$9 = "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", hash$9 = "f2e40eb1", wasmJson$9 = {
  name: name$9,
  data: data$9,
  hash: hash$9
};
const mutex$8 = new Mutex();
let wasmCache$8 = null;
function sha384(o) {
  if (wasmCache$8 === null)
    return lockedCreate(mutex$8, wasmJson$9, 48).then((g) => (wasmCache$8 = g, wasmCache$8.calculate(o, 384)));
  try {
    const g = wasmCache$8.calculate(o, 384);
    return Promise.resolve(g);
  } catch (g) {
    return Promise.reject(g);
  }
}
function createSHA384() {
  return WASMInterface(wasmJson$9, 48).then((o) => {
    o.init(384);
    const g = {
      init: () => (o.init(384), g),
      update: (c) => (o.update(c), g),
      // biome-ignore lint/suspicious/noExplicitAny: Conflict with IHasher type
      digest: (c) => o.digest(c),
      save: () => o.save(),
      load: (c) => (o.load(c), g),
      blockSize: 128,
      digestSize: 48
    };
    return g;
  });
}
const mutex$7 = new Mutex();
let wasmCache$7 = null;
function sha512$1(o) {
  if (wasmCache$7 === null)
    return lockedCreate(mutex$7, wasmJson$9, 64).then((g) => (wasmCache$7 = g, wasmCache$7.calculate(o, 512)));
  try {
    const g = wasmCache$7.calculate(o, 512);
    return Promise.resolve(g);
  } catch (g) {
    return Promise.reject(g);
  }
}
function createSHA512() {
  return WASMInterface(wasmJson$9, 64).then((o) => {
    o.init(512);
    const g = {
      init: () => (o.init(512), g),
      update: (c) => (o.update(c), g),
      // biome-ignore lint/suspicious/noExplicitAny: Conflict with IHasher type
      digest: (c) => o.digest(c),
      save: () => o.save(),
      load: (c) => (o.load(c), g),
      blockSize: 128,
      digestSize: 64
    };
    return g;
  });
}
var name$8 = "xxhash32", data$8 = "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", hash$8 = "4bb12485", wasmJson$8 = {
  name: name$8,
  data: data$8,
  hash: hash$8
};
const mutex$6 = new Mutex();
let wasmCache$6 = null;
function validateSeed$3(o) {
  return !Number.isInteger(o) || o < 0 || o > 4294967295 ? new Error("Seed must be a valid 32-bit long unsigned integer.") : null;
}
function xxhash32(o, g = 0) {
  if (validateSeed$3(g))
    return Promise.reject(validateSeed$3(g));
  if (wasmCache$6 === null)
    return lockedCreate(mutex$6, wasmJson$8, 4).then((c) => (wasmCache$6 = c, wasmCache$6.calculate(o, g)));
  try {
    const c = wasmCache$6.calculate(o, g);
    return Promise.resolve(c);
  } catch (c) {
    return Promise.reject(c);
  }
}
function createXXHash32(o = 0) {
  return validateSeed$3(o) ? Promise.reject(validateSeed$3(o)) : WASMInterface(wasmJson$8, 4).then((g) => {
    g.init(o);
    const c = {
      init: () => (g.init(o), c),
      update: (y) => (g.update(y), c),
      // biome-ignore lint/suspicious/noExplicitAny: Conflict with IHasher type
      digest: (y) => g.digest(y),
      save: () => g.save(),
      load: (y) => (g.load(y), c),
      blockSize: 16,
      digestSize: 4
    };
    return c;
  });
}
var name$7 = "xxhash64", data$7 = "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", hash$7 = "177fbfa3", wasmJson$7 = {
  name: name$7,
  data: data$7,
  hash: hash$7
};
const mutex$5 = new Mutex();
let wasmCache$5 = null;
const seedBuffer$2 = new Uint8Array(8);
function validateSeed$2(o) {
  return !Number.isInteger(o) || o < 0 || o > 4294967295 ? new Error("Seed must be given as two valid 32-bit long unsigned integers (lo + high).") : null;
}
function writeSeed$2(o, g, c) {
  const y = new DataView(o);
  y.setUint32(0, g, !0), y.setUint32(4, c, !0);
}
function xxhash64(o, g = 0, c = 0) {
  if (validateSeed$2(g))
    return Promise.reject(validateSeed$2(g));
  if (validateSeed$2(c))
    return Promise.reject(validateSeed$2(c));
  if (wasmCache$5 === null)
    return lockedCreate(mutex$5, wasmJson$7, 8).then((y) => (wasmCache$5 = y, writeSeed$2(seedBuffer$2.buffer, g, c), wasmCache$5.writeMemory(seedBuffer$2), wasmCache$5.calculate(o)));
  try {
    writeSeed$2(seedBuffer$2.buffer, g, c), wasmCache$5.writeMemory(seedBuffer$2);
    const y = wasmCache$5.calculate(o);
    return Promise.resolve(y);
  } catch (y) {
    return Promise.reject(y);
  }
}
function createXXHash64(o = 0, g = 0) {
  return validateSeed$2(o) ? Promise.reject(validateSeed$2(o)) : validateSeed$2(g) ? Promise.reject(validateSeed$2(g)) : WASMInterface(wasmJson$7, 8).then((c) => {
    const y = new Uint8Array(8);
    writeSeed$2(y.buffer, o, g), c.writeMemory(y), c.init();
    const t = {
      init: () => (c.writeMemory(y), c.init(), t),
      update: (d) => (c.update(d), t),
      // biome-ignore lint/suspicious/noExplicitAny: Conflict with IHasher type
      digest: (d) => c.digest(d),
      save: () => c.save(),
      load: (d) => (c.load(d), t),
      blockSize: 32,
      digestSize: 8
    };
    return t;
  });
}
var name$6 = "xxhash3", data$6 = "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", hash$6 = "5a2fbdbb", wasmJson$6 = {
  name: name$6,
  data: data$6,
  hash: hash$6
};
const mutex$4 = new Mutex();
let wasmCache$4 = null;
const seedBuffer$1 = new Uint8Array(8);
function validateSeed$1(o) {
  return !Number.isInteger(o) || o < 0 || o > 4294967295 ? new Error("Seed must be given as two valid 32-bit long unsigned integers (lo + high).") : null;
}
function writeSeed$1(o, g, c) {
  const y = new DataView(o);
  y.setUint32(0, g, !0), y.setUint32(4, c, !0);
}
function xxhash3(o, g = 0, c = 0) {
  if (validateSeed$1(g))
    return Promise.reject(validateSeed$1(g));
  if (validateSeed$1(c))
    return Promise.reject(validateSeed$1(c));
  if (wasmCache$4 === null)
    return lockedCreate(mutex$4, wasmJson$6, 8).then((y) => (wasmCache$4 = y, writeSeed$1(seedBuffer$1.buffer, g, c), wasmCache$4.writeMemory(seedBuffer$1), wasmCache$4.calculate(o)));
  try {
    writeSeed$1(seedBuffer$1.buffer, g, c), wasmCache$4.writeMemory(seedBuffer$1);
    const y = wasmCache$4.calculate(o);
    return Promise.resolve(y);
  } catch (y) {
    return Promise.reject(y);
  }
}
function createXXHash3(o = 0, g = 0) {
  return validateSeed$1(o) ? Promise.reject(validateSeed$1(o)) : validateSeed$1(g) ? Promise.reject(validateSeed$1(g)) : WASMInterface(wasmJson$6, 8).then((c) => {
    const y = new Uint8Array(8);
    writeSeed$1(y.buffer, o, g), c.writeMemory(y), c.init();
    const t = {
      init: () => (c.writeMemory(y), c.init(), t),
      update: (d) => (c.update(d), t),
      // biome-ignore lint/suspicious/noExplicitAny: Conflict with IHasher type
      digest: (d) => c.digest(d),
      save: () => c.save(),
      load: (d) => (c.load(d), t),
      blockSize: 512,
      digestSize: 8
    };
    return t;
  });
}
var name$5 = "xxhash128", data$5 = "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", hash$5 = "b9ab74e2", wasmJson$5 = {
  name: name$5,
  data: data$5,
  hash: hash$5
};
const mutex$3 = new Mutex();
let wasmCache$3 = null;
const seedBuffer = new Uint8Array(8);
function validateSeed(o) {
  return !Number.isInteger(o) || o < 0 || o > 4294967295 ? new Error("Seed must be given as two valid 32-bit long unsigned integers (lo + high).") : null;
}
function writeSeed(o, g, c) {
  const y = new DataView(o);
  y.setUint32(0, g, !0), y.setUint32(4, c, !0);
}
function xxhash128(o, g = 0, c = 0) {
  if (validateSeed(g))
    return Promise.reject(validateSeed(g));
  if (validateSeed(c))
    return Promise.reject(validateSeed(c));
  if (wasmCache$3 === null)
    return lockedCreate(mutex$3, wasmJson$5, 16).then((y) => (wasmCache$3 = y, writeSeed(seedBuffer.buffer, g, c), wasmCache$3.writeMemory(seedBuffer), wasmCache$3.calculate(o)));
  try {
    writeSeed(seedBuffer.buffer, g, c), wasmCache$3.writeMemory(seedBuffer);
    const y = wasmCache$3.calculate(o);
    return Promise.resolve(y);
  } catch (y) {
    return Promise.reject(y);
  }
}
function createXXHash128(o = 0, g = 0) {
  return validateSeed(o) ? Promise.reject(validateSeed(o)) : validateSeed(g) ? Promise.reject(validateSeed(g)) : WASMInterface(wasmJson$5, 16).then((c) => {
    const y = new Uint8Array(8);
    writeSeed(y.buffer, o, g), c.writeMemory(y), c.init();
    const t = {
      init: () => (c.writeMemory(y), c.init(), t),
      update: (d) => (c.update(d), t),
      // biome-ignore lint/suspicious/noExplicitAny: Conflict with IHasher type
      digest: (d) => c.digest(d),
      save: () => c.save(),
      load: (d) => (c.load(d), t),
      blockSize: 512,
      digestSize: 16
    };
    return t;
  });
}
var name$4 = "ripemd160", data$4 = "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", hash$4 = "6abbce74", wasmJson$4 = {
  name: name$4,
  data: data$4,
  hash: hash$4
};
const mutex$2 = new Mutex();
let wasmCache$2 = null;
function ripemd160$1(o) {
  if (wasmCache$2 === null)
    return lockedCreate(mutex$2, wasmJson$4, 20).then((g) => (wasmCache$2 = g, wasmCache$2.calculate(o)));
  try {
    const g = wasmCache$2.calculate(o);
    return Promise.resolve(g);
  } catch (g) {
    return Promise.reject(g);
  }
}
function createRIPEMD160() {
  return WASMInterface(wasmJson$4, 20).then((o) => {
    o.init();
    const g = {
      init: () => (o.init(), g),
      update: (c) => (o.update(c), g),
      // biome-ignore lint/suspicious/noExplicitAny: Conflict with IHasher type
      digest: (c) => o.digest(c),
      save: () => o.save(),
      load: (c) => (o.load(c), g),
      blockSize: 64,
      digestSize: 20
    };
    return g;
  });
}
function calculateKeyBuffer(o, g) {
  const { blockSize: c } = o, y = getUInt8Buffer(g);
  if (y.length > c) {
    o.update(y);
    const t = o.digest("binary");
    return o.init(), t;
  }
  return new Uint8Array(y.buffer, y.byteOffset, y.length);
}
function calculateHmac(o, g) {
  o.init();
  const { blockSize: c } = o, y = calculateKeyBuffer(o, g), t = new Uint8Array(c);
  t.set(y);
  const d = new Uint8Array(c);
  for (let B = 0; B < c; B++) {
    const D = t[B];
    d[B] = D ^ 92, t[B] = D ^ 54;
  }
  o.update(t);
  const E = {
    init: () => (o.init(), o.update(t), E),
    update: (B) => (o.update(B), E),
    digest: (B) => {
      const D = o.digest("binary");
      return o.init(), o.update(d), o.update(D), o.digest(B);
    },
    save: () => {
      throw new Error("save() not supported");
    },
    load: () => {
      throw new Error("load() not supported");
    },
    blockSize: o.blockSize,
    digestSize: o.digestSize
  };
  return E;
}
function createHMAC(o, g) {
  if (!o || !o.then)
    throw new Error('Invalid hash function is provided! Usage: createHMAC(createMD5(), "key").');
  return o.then((c) => calculateHmac(c, g));
}
function calculatePBKDF2(o, g, c, y, t) {
  return __awaiter(this, void 0, void 0, function* () {
    const d = new Uint8Array(y), E = new Uint8Array(g.length + 4), B = new DataView(E.buffer), D = getUInt8Buffer(g), x = new Uint8Array(D.buffer, D.byteOffset, D.length);
    E.set(x);
    let v = 0;
    const F = o.digestSize, M = Math.ceil(y / F);
    let U = null, L = null;
    for (let fe = 1; fe <= M; fe++) {
      B.setUint32(g.length, fe), o.init(), o.update(E), U = o.digest("binary"), L = U.slice();
      for (let ge = 1; ge < c; ge++) {
        o.init(), o.update(L), L = o.digest("binary");
        for (let Ie = 0; Ie < F; Ie++)
          U[Ie] ^= L[Ie];
      }
      d.set(U.subarray(0, y - v), v), v += F;
    }
    if (t === "binary")
      return d;
    const H = new Uint8Array(y * 2);
    return getDigestHex(H, d, y);
  });
}
const validateOptions$2 = (o) => {
  if (!o || typeof o != "object")
    throw new Error("Invalid options parameter. It requires an object.");
  if (!o.hashFunction || !o.hashFunction.then)
    throw new Error('Invalid hash function is provided! Usage: pbkdf2("password", "salt", 1000, 32, createSHA1()).');
  if (!Number.isInteger(o.iterations) || o.iterations < 1)
    throw new Error("Iterations should be a positive number");
  if (!Number.isInteger(o.hashLength) || o.hashLength < 1)
    throw new Error("Hash length should be a positive number");
  if (o.outputType === void 0 && (o.outputType = "hex"), !["hex", "binary"].includes(o.outputType))
    throw new Error(`Insupported output type ${o.outputType}. Valid values: ['hex', 'binary']`);
};
function pbkdf2(o) {
  return __awaiter(this, void 0, void 0, function* () {
    validateOptions$2(o);
    const g = yield createHMAC(o.hashFunction, o.password);
    return calculatePBKDF2(g, o.salt, o.iterations, o.hashLength, o.outputType);
  });
}
var name$3 = "scrypt", data$3 = "AGFzbQEAAAABGwVgAX8Bf2AAAX9gBH9/f38AYAF/AGADf39/AAMGBQABAgMEBQYBAQKAgAIGCAF/AUGQiAQLBzkEBm1lbW9yeQIAEkhhc2hfU2V0TWVtb3J5U2l6ZQAADkhhc2hfR2V0QnVmZmVyAAEGc2NyeXB0AAQK7iYFWAECf0EAIQECQCAAQQAoAogIIgJGDQACQCAAIAJrIgBBEHYgAEGAgHxxIABJaiIAQABBf0cNAEH/AcAPC0EAIQFBAEEAKQOICCAAQRB0rXw3A4gICyABwAtwAQJ/AkBBACgCgAgiAA0AQQA/AEEQdCIANgKACEEAKAKICCIBQYCAIEYNAAJAQYCAICABayIAQRB2IABBgIB8cSAASWoiAEAAQX9HDQBBAA8LQQBBACkDiAggAEEQdK18NwOICEEAKAKACCEACyAAC6QFAQN/IAIgA0EHdCAAakFAaiIEKQMANwMAIAIgBCkDCDcDCCACIAQpAxA3AxAgAiAEKQMYNwMYIAIgBCkDIDcDICACIAQpAyg3AyggAiAEKQMwNwMwIAIgBCkDODcDOAJAIANFDQAgA0EBdCEFIANBBnQhBkEAIQMDQCACIAIpAwAgACkDAIU3AwAgAiACKQMIIABBCGopAwCFNwMIIAIgAikDECAAQRBqKQMAhTcDECACIAIpAxggAEEYaikDAIU3AxggAiACKQMgIABBIGopAwCFNwMgIAIgAikDKCAAQShqKQMAhTcDKCACIAIpAzAgAEEwaikDAIU3AzAgAiACKQM4IABBOGopAwCFNwM4IAIQAyABIAIpAwA3AwAgAUEIaiACKQMINwMAIAFBEGogAikDEDcDACABQRhqIAIpAxg3AwAgAUEgaiACKQMgNwMAIAFBKGogAikDKDcDACABQTBqIAIpAzA3AwAgAUE4aiACKQM4NwMAIAIgAikDACAAQcAAaikDAIU3AwAgAiACKQMIIABByABqKQMAhTcDCCACIAIpAxAgAEHQAGopAwCFNwMQIAIgAikDGCAAQdgAaikDAIU3AxggAiACKQMgIABB4ABqKQMAhTcDICACIAIpAyggAEHoAGopAwCFNwMoIAIgAikDMCAAQfAAaikDAIU3AzAgAiACKQM4IABB+ABqKQMAhTcDOCACEAMgASAGaiIEIAIpAwA3AwAgBEEIaiACKQMINwMAIARBEGogAikDEDcDACAEQRhqIAIpAxg3AwAgBEEgaiACKQMgNwMAIARBKGogAikDKDcDACAEQTBqIAIpAzA3AwAgBEE4aiACKQM4NwMAIABBgAFqIQAgAUHAAGohASADQQJqIgMgBUkNAAsLC7oNCAF+AX8BfgF/AX4BfwF+En8gACAAKAIEIAApAygiAUIgiKciAiAAKQM4IgNCIIinIgRqQQd3IAApAwgiBUIgiKdzIgYgBGpBCXcgACkDGCIHQiCIp3MiCCAGakENdyACcyIJIAenIgogAaciC2pBB3cgA6dzIgIgC2pBCXcgBadzIgwgAmpBDXcgCnMiDSAMakESdyALcyIOIAApAwAiAUIgiKciDyAAKQMQIgNCIIinIhBqQQd3IAApAyAiBUIgiKdzIgtqQQd3cyIKIAkgCGpBEncgBHMiESACakEHdyAAKQMwIgenIgkgAaciEmpBB3cgA6dzIgQgEmpBCXcgBadzIhMgBGpBDXcgCXMiFHMiCSARakEJdyALIBBqQQl3IAdCIIincyIVcyIWIAlqQQ13IAJzIhcgFmpBEncgEXMiEWpBB3cgBiAUIBNqQRJ3IBJzIhJqQQd3IBUgC2pBDXcgD3MiFHMiAiASakEJdyAMcyIPIAJqQQ13IAZzIhhzIgYgEWpBCXcgCCANIBQgFWpBEncgEHMiECAEakEHd3MiDCAQakEJd3MiCHMiFSAGakENdyAKcyIUIAwgCiAOakEJdyATcyITIApqQQ13IAtzIhkgE2pBEncgDnMiCmpBB3cgF3MiCyAKakEJdyAPcyIOIAtqQQ13IAxzIhcgDmpBEncgCnMiDSACIAggDGpBDXcgBHMiDCAIakESdyAQcyIIakEHdyAZcyIKakEHd3MiBCAUIBVqQRJ3IBFzIhAgC2pBB3cgCSAYIA9qQRJ3IBJzIhFqQQd3IAxzIgwgEWpBCXcgE3MiEiAMakENdyAJcyIPcyIJIBBqQQl3IAogCGpBCXcgFnMiE3MiFiAJakENdyALcyIUIBZqQRJ3IBBzIhBqQQd3IAYgDyASakESdyARcyIRakEHdyATIApqQQ13IAJzIgtzIgIgEWpBCXcgDnMiDiACakENdyAGcyIYcyIGIBBqQQl3IBUgFyALIBNqQRJ3IAhzIgggDGpBB3dzIgsgCGpBCXdzIhNzIhUgBmpBDXcgBHMiFyALIAQgDWpBCXcgEnMiEiAEakENdyAKcyIZIBJqQRJ3IA1zIgRqQQd3IBRzIgogBGpBCXcgDnMiDyAKakENdyALcyIUIA9qQRJ3IARzIg0gAiATIAtqQQ13IAxzIgwgE2pBEncgCHMiCGpBB3cgGXMiC2pBB3dzIgQgFyAVakESdyAQcyIQIApqQQd3IAkgGCAOakESdyARcyIOakEHdyAMcyIMIA5qQQl3IBJzIhEgDGpBDXcgCXMiF3MiCSAQakEJdyALIAhqQQl3IBZzIhJzIhMgCWpBDXcgCnMiGCATakESdyAQcyIQakEHdyAGIBcgEWpBEncgDnMiCmpBB3cgEiALakENdyACcyIXcyICIApqQQl3IA9zIg4gAmpBDXcgBnMiFnMiBiAJIBYgDmpBEncgCnMiFmpBB3cgFSAUIBcgEmpBEncgCHMiCCAMakEHd3MiCiAIakEJd3MiEiAKakENdyAMcyIPcyIMIBZqQQl3IAQgDWpBCXcgEXMiEXMiFSAMakENdyAJcyIUIBVqQRJ3IBZzIglqQQd3IAIgDyASakESdyAIcyIIakEHdyARIARqQQ13IAtzIg9zIgsgCGpBCXcgE3MiEyALakENdyACcyIXcyIWajYCBCAAIAAoAgggFiAJakEJdyAKIA8gEWpBEncgDXMiEWpBB3cgGHMiAiARakEJdyAOcyIOcyIPajYCCCAAIAAoAgwgDyAWakENdyAGcyINajYCDCAAIAAoAhAgBiAQakEJdyAScyISIA4gAmpBDXcgCnMiGCAXIBNqQRJ3IAhzIgogDGpBB3dzIgggCmpBCXdzIhYgCGpBDXcgDHMiDGo2AhAgACAAKAIAIA0gD2pBEncgCXNqNgIAIAAgACgCFCAMIBZqQRJ3IApzajYCFCAAIAAoAhggCGo2AhggACAAKAIcIBZqNgIcIAAgACgCICASIAZqQQ13IARzIgkgGCAOakESdyARcyIGIAtqQQd3cyIKIAZqQQl3IBVzIgRqNgIgIAAgACgCJCAEIApqQQ13IAtzIgtqNgIkIAAgACgCKCALIARqQRJ3IAZzajYCKCAAIAAoAiwgCmo2AiwgACAAKAIwIAkgEmpBEncgEHMiBiACakEHdyAUcyILajYCMCAAIAAoAjQgCyAGakEJdyATcyIKajYCNCAAIAAoAjggCiALakENdyACcyICajYCOCAAIAAoAjwgAiAKakESdyAGc2o2AjwLvxIDFX8Bfg5/AkAgAkUNACAAQQd0IgNBQGoiBEEAKAKACCIFIAMgAmwiBmogAyABbGoiByADaiIIaiEJIAAgAkEHdCIKIAFBB3RqIgtsIQwgACALQYABamwhDSAAQQV0IgtBASALQQFLGyILQWBxIQ4gC0EBcSEPIAdBeGohECAHQXBqIREgB0FoaiESIAdBYGohEyAHQVhqIRQgB0FQaiEVIAdBSGohFiAHQUBqIRcgAa1Cf3whGCAEIAdqIRkgByAAQQh0IhpqIRsgACAKQYABamwhHCALQQRJIR1BACEeQQAhHwNAQQAoAoAIIiAgAyAfbGohIQJAIABFDQBBACEiAkAgHQ0AICAgHmohI0EAIQtBACEiA0AgByALaiIEICMgC2oiJCgCADYCACAEQQRqICRBBGooAgA2AgAgBEEIaiAkQQhqKAIANgIAIARBDGogJEEMaigCADYCACALQRBqIQsgDiAiQQRqIiJHDQALCyAPRQ0AIAcgIkECdCILaiAhIAtqKAIANgIACwJAIAFFDQBBACElIBwhIyAGISYDQCAFISQgACEiAkACQCAADQAgGyAXKQMANwMAIBsgFikDADcDCCAbIBUpAwA3AxAgGyAUKQMANwMYIBsgEykDADcDICAbIBIpAwA3AyggGyARKQMANwMwIBsgECkDADcDOAwBCwNAICQgJmoiCyAkIAxqIgQpAwA3AwAgC0EIaiAEQQhqKQMANwMAIAtBEGogBEEQaikDADcDACALQRhqIARBGGopAwA3AwAgC0EgaiAEQSBqKQMANwMAIAtBKGogBEEoaikDADcDACALQTBqIARBMGopAwA3AwAgC0E4aiAEQThqKQMANwMAIAtBwABqIARBwABqKQMANwMAIAtByABqIARByABqKQMANwMAIAtB0ABqIARB0ABqKQMANwMAIAtB2ABqIARB2ABqKQMANwMAIAtB4ABqIARB4ABqKQMANwMAIAtB6ABqIARB6ABqKQMANwMAIAtB8ABqIARB8ABqKQMANwMAIAtB+ABqIARB+ABqKQMANwMAICRBgAFqISQgIkF/aiIiDQALIAcgCCAbIAAQAiAFISQgACEiA0AgJCAjaiILICQgDWoiBCkDADcDACALQQhqIARBCGopAwA3AwAgC0EQaiAEQRBqKQMANwMAIAtBGGogBEEYaikDADcDACALQSBqIARBIGopAwA3AwAgC0EoaiAEQShqKQMANwMAIAtBMGogBEEwaikDADcDACALQThqIARBOGopAwA3AwAgC0HAAGogBEHAAGopAwA3AwAgC0HIAGogBEHIAGopAwA3AwAgC0HQAGogBEHQAGopAwA3AwAgC0HYAGogBEHYAGopAwA3AwAgC0HgAGogBEHgAGopAwA3AwAgC0HoAGogBEHoAGopAwA3AwAgC0HwAGogBEHwAGopAwA3AwAgC0H4AGogBEH4AGopAwA3AwAgJEGAAWohJCAiQX9qIiINAAsLIAggByAbIAAQAiAjIBpqISMgJiAaaiEmICVBAmoiJSABSQ0AC0EAISUDQAJAAkAgAA0AIBsgFykDADcDACAbIBYpAwA3AwggGyAVKQMANwMQIBsgFCkDADcDGCAbIBMpAwA3AyAgGyASKQMANwMoIBsgESkDADcDMCAbIBApAwA3AzgMAQsgACAKIBkpAgAgGIOnQQd0amwhJiAFISQgACEiA0AgJCAMaiILIAspAwAgJCAmaiIEKQMAhTcDACALQQhqIiMgIykDACAEQQhqKQMAhTcDACALQRBqIiMgIykDACAEQRBqKQMAhTcDACALQRhqIiMgIykDACAEQRhqKQMAhTcDACALQSBqIiMgIykDACAEQSBqKQMAhTcDACALQShqIiMgIykDACAEQShqKQMAhTcDACALQTBqIiMgIykDACAEQTBqKQMAhTcDACALQThqIiMgIykDACAEQThqKQMAhTcDACALQcAAaiIjICMpAwAgBEHAAGopAwCFNwMAIAtByABqIiMgIykDACAEQcgAaikDAIU3AwAgC0HQAGoiIyAjKQMAIARB0ABqKQMAhTcDACALQdgAaiIjICMpAwAgBEHYAGopAwCFNwMAIAtB4ABqIiMgIykDACAEQeAAaikDAIU3AwAgC0HoAGoiIyAjKQMAIARB6ABqKQMAhTcDACALQfAAaiIjICMpAwAgBEHwAGopAwCFNwMAIAtB+ABqIgsgCykDACAEQfgAaikDAIU3AwAgJEGAAWohJCAiQX9qIiINAAsgByAIIBsgABACIAAgCiAJKQIAIBiDp0EHdGpsISYgBSEkIAAhIgNAICQgDWoiCyALKQMAICQgJmoiBCkDAIU3AwAgC0EIaiIjICMpAwAgBEEIaikDAIU3AwAgC0EQaiIjICMpAwAgBEEQaikDAIU3AwAgC0EYaiIjICMpAwAgBEEYaikDAIU3AwAgC0EgaiIjICMpAwAgBEEgaikDAIU3AwAgC0EoaiIjICMpAwAgBEEoaikDAIU3AwAgC0EwaiIjICMpAwAgBEEwaikDAIU3AwAgC0E4aiIjICMpAwAgBEE4aikDAIU3AwAgC0HAAGoiIyAjKQMAIARBwABqKQMAhTcDACALQcgAaiIjICMpAwAgBEHIAGopAwCFNwMAIAtB0ABqIiMgIykDACAEQdAAaikDAIU3AwAgC0HYAGoiIyAjKQMAIARB2ABqKQMAhTcDACALQeAAaiIjICMpAwAgBEHgAGopAwCFNwMAIAtB6ABqIiMgIykDACAEQegAaikDAIU3AwAgC0HwAGoiIyAjKQMAIARB8ABqKQMAhTcDACALQfgAaiILIAspAwAgBEH4AGopAwCFNwMAICRBgAFqISQgIkF/aiIiDQALCyAIIAcgGyAAEAIgJUECaiIlIAFJDQALCwJAIABFDQBBACEiAkAgHQ0AICAgHmohI0EAIQtBACEiA0AgIyALaiIEIAcgC2oiJCgCADYCACAEQQRqICRBBGooAgA2AgAgBEEIaiAkQQhqKAIANgIAIARBDGogJEEMaigCADYCACALQRBqIQsgDiAiQQRqIiJHDQALCyAPRQ0AICEgIkECdCILaiAHIAtqKAIANgIACyAeIANqIR4gH0EBaiIfIAJHDQALCws=", hash$3 = "b32721f8", wasmJson$3 = {
  name: name$3,
  data: data$3,
  hash: hash$3
};
function scryptInternal(o) {
  return __awaiter(this, void 0, void 0, function* () {
    const { costFactor: g, blockSize: c, parallelism: y, hashLength: t } = o, d = createSHA256(), E = yield pbkdf2({
      password: o.password,
      salt: o.salt,
      iterations: 1,
      hashLength: 128 * c * y,
      hashFunction: d,
      outputType: "binary"
    }), B = yield WASMInterface(wasmJson$3, 0), D = 128 * c * g, x = 256 * c;
    B.setMemorySize(E.length + D + x), B.writeMemory(E, 0), B.getExports().scrypt(c, g, y);
    const v = B.getMemory().subarray(0, 128 * c * y), F = yield pbkdf2({
      password: o.password,
      salt: v,
      iterations: 1,
      hashLength: t,
      hashFunction: d,
      outputType: "binary"
    });
    if (o.outputType === "hex") {
      const M = new Uint8Array(t * 2);
      return getDigestHex(M, F, t);
    }
    return F;
  });
}
const isPowerOfTwo = (o) => o && !(o & o - 1), validateOptions$1 = (o) => {
  if (!o || typeof o != "object")
    throw new Error("Invalid options parameter. It requires an object.");
  if (!Number.isInteger(o.blockSize) || o.blockSize < 1)
    throw new Error("Block size should be a positive number");
  if (!Number.isInteger(o.costFactor) || o.costFactor < 2 || !isPowerOfTwo(o.costFactor))
    throw new Error("Cost factor should be a power of 2, greater than 1");
  if (!Number.isInteger(o.parallelism) || o.parallelism < 1)
    throw new Error("Parallelism should be a positive number");
  if (!Number.isInteger(o.hashLength) || o.hashLength < 1)
    throw new Error("Hash length should be a positive number.");
  if (o.outputType === void 0 && (o.outputType = "hex"), !["hex", "binary"].includes(o.outputType))
    throw new Error(`Insupported output type ${o.outputType}. Valid values: ['hex', 'binary']`);
};
function scrypt(o) {
  return __awaiter(this, void 0, void 0, function* () {
    return validateOptions$1(o), scryptInternal(o);
  });
}
var name$2 = "bcrypt", data$2 = "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", hash$2 = "8bd8822d", wasmJson$2 = {
  name: name$2,
  data: data$2,
  hash: hash$2
};
function bcryptInternal(o) {
  return __awaiter(this, void 0, void 0, function* () {
    const { costFactor: g, password: c, salt: y } = o, t = yield WASMInterface(wasmJson$2, 0);
    t.writeMemory(getUInt8Buffer(y), 0);
    const d = getUInt8Buffer(c);
    t.writeMemory(d, 16);
    const E = o.outputType === "encoded" ? 1 : 0;
    t.getExports().bcrypt(d.length, g, E);
    const B = t.getMemory();
    if (o.outputType === "encoded")
      return intArrayToString(B, 60);
    if (o.outputType === "hex") {
      const D = new Uint8Array(48);
      return getDigestHex(D, B, 24);
    }
    return B.slice(0, 24);
  });
}
const validateOptions = (o) => {
  if (!o || typeof o != "object")
    throw new Error("Invalid options parameter. It requires an object.");
  if (!Number.isInteger(o.costFactor) || o.costFactor < 4 || o.costFactor > 31)
    throw new Error("Cost factor should be a number between 4 and 31");
  if (o.password = getUInt8Buffer(o.password), o.password.length < 1)
    throw new Error("Password should be at least 1 byte long");
  if (o.password.length > 72)
    throw new Error("Password should be at most 72 bytes long");
  if (o.salt = getUInt8Buffer(o.salt), o.salt.length !== 16)
    throw new Error("Salt should be 16 bytes long");
  if (o.outputType === void 0 && (o.outputType = "encoded"), !["hex", "binary", "encoded"].includes(o.outputType))
    throw new Error(`Insupported output type ${o.outputType}. Valid values: ['hex', 'binary', 'encoded']`);
};
function bcrypt(o) {
  return __awaiter(this, void 0, void 0, function* () {
    return validateOptions(o), bcryptInternal(o);
  });
}
const validateHashCharacters = (o) => !(!/^\$2[axyb]\$[0-3][0-9]\$[./A-Za-z0-9]{53}$/.test(o) || o[4] === "0" && Number(o[5]) < 4 || o[4] === "3" && Number(o[5]) > 1), validateVerifyOptions = (o) => {
  if (!o || typeof o != "object")
    throw new Error("Invalid options parameter. It requires an object.");
  if (o.hash === void 0 || typeof o.hash != "string")
    throw new Error("Hash should be specified");
  if (o.hash.length !== 60)
    throw new Error("Hash should be 60 bytes long");
  if (!validateHashCharacters(o.hash))
    throw new Error("Invalid hash");
  if (o.password = getUInt8Buffer(o.password), o.password.length < 1)
    throw new Error("Password should be at least 1 byte long");
  if (o.password.length > 72)
    throw new Error("Password should be at most 72 bytes long");
};
function bcryptVerify(o) {
  return __awaiter(this, void 0, void 0, function* () {
    validateVerifyOptions(o);
    const { hash: g, password: c } = o, y = yield WASMInterface(wasmJson$2, 0);
    y.writeMemory(getUInt8Buffer(g), 0);
    const t = getUInt8Buffer(c);
    return y.writeMemory(t, 60), !!y.getExports().bcrypt_verify(t.length);
  });
}
var name$1 = "whirlpool", data$1 = "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", hash$1 = "8d8f6035", wasmJson$1 = {
  name: name$1,
  data: data$1,
  hash: hash$1
};
const mutex$1 = new Mutex();
let wasmCache$1 = null;
function whirlpool(o) {
  if (wasmCache$1 === null)
    return lockedCreate(mutex$1, wasmJson$1, 64).then((g) => (wasmCache$1 = g, wasmCache$1.calculate(o)));
  try {
    const g = wasmCache$1.calculate(o);
    return Promise.resolve(g);
  } catch (g) {
    return Promise.reject(g);
  }
}
function createWhirlpool() {
  return WASMInterface(wasmJson$1, 64).then((o) => {
    o.init();
    const g = {
      init: () => (o.init(), g),
      update: (c) => (o.update(c), g),
      // biome-ignore lint/suspicious/noExplicitAny: Conflict with IHasher type
      digest: (c) => o.digest(c),
      save: () => o.save(),
      load: (c) => (o.load(c), g),
      blockSize: 64,
      digestSize: 64
    };
    return g;
  });
}
var name = "sm3", data$m = "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", hash = "b6fb4b8e", wasmJson = {
  name,
  data: data$m,
  hash
};
const mutex = new Mutex();
let wasmCache = null;
function sm3(o) {
  if (wasmCache === null)
    return lockedCreate(mutex, wasmJson, 32).then((g) => (wasmCache = g, wasmCache.calculate(o)));
  try {
    const g = wasmCache.calculate(o);
    return Promise.resolve(g);
  } catch (g) {
    return Promise.reject(g);
  }
}
function createSM3() {
  return WASMInterface(wasmJson, 32).then((o) => {
    o.init();
    const g = {
      init: () => (o.init(), g),
      update: (c) => (o.update(c), g),
      // biome-ignore lint/suspicious/noExplicitAny: Conflict with IHasher type
      digest: (c) => o.digest(c),
      save: () => o.save(),
      load: (c) => (o.load(c), g),
      blockSize: 64,
      digestSize: 32
    };
    return g;
  });
}
const index_esm = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  adler32,
  argon2Verify,
  argon2d,
  argon2i,
  argon2id,
  bcrypt,
  bcryptVerify,
  blake2b,
  blake2s,
  blake3,
  crc32,
  crc64,
  createAdler32,
  createBLAKE2b,
  createBLAKE2s,
  createBLAKE3,
  createCRC32,
  createCRC64,
  createHMAC,
  createKeccak,
  createMD4,
  createMD5,
  createRIPEMD160,
  createSHA1,
  createSHA224,
  createSHA256,
  createSHA3,
  createSHA384,
  createSHA512,
  createSM3,
  createWhirlpool,
  createXXHash128,
  createXXHash3,
  createXXHash32,
  createXXHash64,
  keccak,
  md4,
  md5,
  pbkdf2,
  ripemd160: ripemd160$1,
  scrypt,
  sha1,
  sha224,
  sha256: sha256$1,
  sha3,
  sha384,
  sha512: sha512$1,
  sm3,
  whirlpool,
  xxhash128,
  xxhash3,
  xxhash32,
  xxhash64
}, Symbol.toStringTag, { value: "Module" })), require$$3 = /* @__PURE__ */ getAugmentedNamespace(index_esm);
var hasRequiredLibsodium;
function requireLibsodium() {
  if (hasRequiredLibsodium) return libsodium;
  hasRequiredLibsodium = 1, Object.defineProperty(libsodium, "__esModule", { value: !0 }), libsodium.Xchacha20poly1305Ietf = libsodium.xchacha20NonceLength = libsodium.Ed25519 = libsodium.Ed25519Keypair = libsodium.Argon2id = void 0, libsodium.isArgon2idOptions = t;
  const o = requireBuild$3(), g = /* @__PURE__ */ requireChacha(), c = /* @__PURE__ */ requireEd25519(), y = require$$3;
  function t(x) {
    return !(!(0, o.isNonNullObject)(x) || typeof x.outputLength != "number" || typeof x.opsLimit != "number" || typeof x.memLimitKib != "number");
  }
  class d {
    static async execute(v, F, M) {
      const U = {
        password: v,
        salt: F,
        outputType: "binary",
        iterations: M.opsLimit,
        memorySize: M.memLimitKib,
        parallelism: 1,
        // no parallelism allowed, just like libsodium
        hashLength: M.outputLength
      };
      if (F.length !== 16)
        throw new Error(`Got invalid salt length ${F.length}. Must be 16.`);
      const L = await (0, y.argon2id)(U);
      return (0, o.assert)(typeof L != "string"), L;
    }
  }
  libsodium.Argon2id = d;
  class E {
    constructor(v, F) {
      Vi(this, "privkey");
      Vi(this, "pubkey");
      this.privkey = v, this.pubkey = F;
    }
    // a libsodium privkey has the format `<ed25519 privkey> + <ed25519 pubkey>`
    static fromLibsodiumPrivkey(v) {
      if (v.length !== 64)
        throw new Error(`Unexpected key length ${v.length}. Must be 64.`);
      return new E(v.slice(0, 32), v.slice(32, 64));
    }
    toLibsodiumPrivkey() {
      return new Uint8Array([...this.privkey, ...this.pubkey]);
    }
  }
  libsodium.Ed25519Keypair = E;
  class B {
    /**
     * Generates a keypair deterministically from a given 32 bytes seed.
     *
     * This seed equals the Ed25519 private key.
     * For implementation details see crypto_sign_seed_keypair in
     * https://download.libsodium.org/doc/public-key_cryptography/public-key_signatures.html
     * and diagram on https://blog.mozilla.org/warner/2011/11/29/ed25519-keys/
     */
    static async makeKeypair(v) {
      const F = c.ed25519.getPublicKey(v);
      return new E(v, F);
    }
    static async createSignature(v, F) {
      return c.ed25519.sign(v, F.privkey);
    }
    static async verifySignature(v, F, M) {
      return c.ed25519.verify(v, F, M);
    }
  }
  libsodium.Ed25519 = B, libsodium.xchacha20NonceLength = 24;
  class D {
    static async encrypt(v, F, M) {
      return (0, g.xchacha20poly1305)(F, M, void 0).encrypt(v);
    }
    static async decrypt(v, F, M) {
      return (0, g.xchacha20poly1305)(F, M, void 0).decrypt(v);
    }
  }
  return libsodium.Xchacha20poly1305Ietf = D, libsodium;
}
var random = {}, hasRequiredRandom;
function requireRandom() {
  if (hasRequiredRandom) return random;
  hasRequiredRandom = 1, Object.defineProperty(random, "__esModule", { value: !0 }), random.Random = void 0;
  class o {
    /**
     * Returns `count` cryptographically secure random bytes
     */
    static getBytes(c) {
      const y = new Uint8Array(c);
      return globalThis.crypto.getRandomValues(y), y;
    }
  }
  return random.Random = o, random;
}
var ripemd = {}, hasRequiredRipemd;
function requireRipemd() {
  if (hasRequiredRipemd) return ripemd;
  hasRequiredRipemd = 1, Object.defineProperty(ripemd, "__esModule", { value: !0 }), ripemd.Ripemd160 = void 0, ripemd.ripemd160 = y;
  const o = /* @__PURE__ */ requireLegacy(), g = requireUtils$3();
  class c {
    constructor(d) {
      Vi(this, "blockSize", 512 / 8);
      Vi(this, "impl", o.ripemd160.create());
      d && this.update(d);
    }
    update(d) {
      return this.impl.update((0, g.toRealUint8Array)(d)), this;
    }
    digest() {
      return this.impl.digest();
    }
  }
  ripemd.Ripemd160 = c;
  function y(t) {
    return new c(t).digest();
  }
  return ripemd;
}
var secp256k1$1 = {}, secp256k1signature = {}, hasRequiredSecp256k1signature;
function requireSecp256k1signature() {
  if (hasRequiredSecp256k1signature) return secp256k1signature;
  hasRequiredSecp256k1signature = 1, Object.defineProperty(secp256k1signature, "__esModule", { value: !0 }), secp256k1signature.ExtendedSecp256k1Signature = secp256k1signature.Secp256k1Signature = void 0;
  function o(t) {
    let d = 0;
    for (const E of t)
      if (E === 0)
        d++;
      else
        break;
    return t.slice(d);
  }
  const g = 2;
  class c {
    constructor(d, E) {
      Vi(this, "data");
      if (d.length > 32 || d.length === 0 || d[0] === 0)
        throw new Error("Unsigned integer r must be encoded as unpadded big endian.");
      if (E.length > 32 || E.length === 0 || E[0] === 0)
        throw new Error("Unsigned integer s must be encoded as unpadded big endian.");
      this.data = {
        r: d,
        s: E
      };
    }
    /**
     * Takes the pair of integers (r, s) as 2x32 byte of binary data.
     *
     * Note: This is the format Cosmos SDK uses natively.
     *
     * @param data a 64 byte value containing integers r and s.
     */
    static fromFixedLength(d) {
      if (d.length !== 64)
        throw new Error(`Got invalid data length: ${d.length}. Expected 2x 32 bytes for the pair (r, s)`);
      return new c(o(d.slice(0, 32)), o(d.slice(32, 64)));
    }
    static fromDer(d) {
      let E = 0;
      if (d[E++] !== 48)
        throw new Error("Prefix 0x30 expected");
      const B = d[E++];
      if (d.length - E !== B)
        throw new Error("Data length mismatch detected");
      if (d[E++] !== g)
        throw new Error("INTEGER tag expected");
      const x = d[E++];
      if (x >= 128)
        throw new Error("Decoding length values above 127 not supported");
      const v = d.slice(E, E + x);
      if (E += x, d[E++] !== g)
        throw new Error("INTEGER tag expected");
      const M = d[E++];
      if (M >= 128)
        throw new Error("Decoding length values above 127 not supported");
      const U = d.slice(E, E + M);
      return E += M, new c(
        // r/s data can contain leading 0 bytes to express integers being non-negative in DER
        o(v),
        o(U)
      );
    }
    r(d) {
      if (d === void 0)
        return this.data.r;
      {
        const E = d - this.data.r.length;
        if (E < 0)
          throw new Error("Length too small to hold parameter r");
        const B = new Uint8Array(E);
        return new Uint8Array([...B, ...this.data.r]);
      }
    }
    s(d) {
      if (d === void 0)
        return this.data.s;
      {
        const E = d - this.data.s.length;
        if (E < 0)
          throw new Error("Length too small to hold parameter s");
        const B = new Uint8Array(E);
        return new Uint8Array([...B, ...this.data.s]);
      }
    }
    toFixedLength() {
      return new Uint8Array([...this.r(32), ...this.s(32)]);
    }
    toDer() {
      const d = this.data.r[0] >= 128 ? new Uint8Array([0, ...this.data.r]) : this.data.r, E = this.data.s[0] >= 128 ? new Uint8Array([0, ...this.data.s]) : this.data.s, B = d.length, D = E.length, x = new Uint8Array([g, B, ...d, g, D, ...E]);
      return new Uint8Array([48, x.length, ...x]);
    }
  }
  secp256k1signature.Secp256k1Signature = c;
  class y extends c {
    constructor(E, B, D) {
      super(E, B);
      Vi(this, "recovery");
      if (!Number.isInteger(D))
        throw new Error("The recovery parameter must be an integer.");
      if (D < 0 || D > 4)
        throw new Error("The recovery parameter must be one of 0, 1, 2, 3.");
      this.recovery = D;
    }
    /**
     * Decode extended signature from the simple fixed length encoding
     * described in toFixedLength().
     */
    static fromFixedLength(E) {
      if (E.length !== 65)
        throw new Error(`Got invalid data length ${E.length}. Expected 32 + 32 + 1`);
      return new y(o(E.slice(0, 32)), o(E.slice(32, 64)), E[64]);
    }
    /**
     * A simple custom encoding that encodes the extended signature as
     * r (32 bytes) | s (32 bytes) | recovery param (1 byte)
     * where | denotes concatenation of bonary data.
     */
    toFixedLength() {
      return new Uint8Array([...this.r(32), ...this.s(32), this.recovery]);
    }
  }
  return secp256k1signature.ExtendedSecp256k1Signature = y, secp256k1signature;
}
var hasRequiredSecp256k1;
function requireSecp256k1() {
  if (hasRequiredSecp256k1) return secp256k1$1;
  hasRequiredSecp256k1 = 1, Object.defineProperty(secp256k1$1, "__esModule", { value: !0 }), secp256k1$1.Secp256k1 = void 0;
  const o = requireBuild$4(), g = requireBuild$3(), c = /* @__PURE__ */ requireSecp256k1$5(), y = requireSecp256k1signature();
  function t(B) {
    (0, g.assert)(B >= 0n);
    let D = B.toString(16);
    return D.length % 2 && (D = "0" + D), (0, o.fromHex)(D);
  }
  function d(B) {
    return BigInt("0x" + (0, o.toHex)(B));
  }
  class E {
    /**
     * Takes a 32 byte private key and returns a privkey/pubkey pair.
     *
     * The resulting pubkey is uncompressed. For the use in Cosmos it should
     * be compressed first using `Secp256k1.compressPubkey`.
     */
    static async makeKeypair(D) {
      if (D.length !== 32)
        throw new Error("input data is not a valid secp256k1 private key");
      if (!c.secp256k1.utils.isValidPrivateKey(D))
        throw new Error("input data is not a valid secp256k1 private key");
      return {
        privkey: D,
        // encodes uncompressed as
        // - 1-byte prefix "04"
        // - 32-byte x coordinate
        // - 32-byte y coordinate
        pubkey: c.secp256k1.getPublicKey(D, !1)
      };
    }
    /**
     * Creates a signature that is
     * - deterministic (RFC 6979)
     * - lowS signature
     * - DER encoded
     */
    static async createSignature(D, x) {
      if (D.length === 0)
        throw new Error("Message hash must not be empty");
      if (D.length > 32)
        throw new Error("Message hash length must not exceed 32 bytes");
      const { recovery: v, r: F, s: M } = c.secp256k1.sign(D, x, {
        lowS: !0
      });
      if (typeof v != "number")
        throw new Error("Recovery param missing");
      return new y.ExtendedSecp256k1Signature(t(F), t(M), v);
    }
    static async verifySignature(D, x, v) {
      if (x.length === 0)
        throw new Error("Message hash must not be empty");
      if (x.length > 32)
        throw new Error("Message hash length must not exceed 32 bytes");
      const F = c.secp256k1.Signature.fromDER(D.toDer());
      return c.secp256k1.verify(F, x, v, { lowS: !1 });
    }
    static recoverPubkey(D, x) {
      return new c.secp256k1.Signature(d(D.r()), d(D.s()), D.recovery).recoverPublicKey(x).toBytes(!1);
    }
    /**
     * Takes a compressed or uncompressed pubkey and return a compressed one.
     *
     * This function is idempotent.
     */
    static compressPubkey(D) {
      switch (D.length) {
        case 33:
          return D;
        case 65:
          return c.secp256k1.Point.fromBytes(D).toBytes(!0);
        default:
          throw new Error("Invalid pubkey length");
      }
    }
    /**
     * Takes a compressed or uncompressed pubkey and returns an uncompressed one.
     *
     * This function is idempotent.
     */
    static uncompressPubkey(D) {
      switch (D.length) {
        case 33:
          return c.secp256k1.Point.fromBytes(D).toBytes(!1);
        case 65:
          return D;
        default:
          throw new Error("Invalid pubkey length");
      }
    }
    static trimRecoveryByte(D) {
      switch (D.length) {
        case 64:
          return D;
        case 65:
          return D.slice(0, 64);
        default:
          throw new Error("Invalid signature length");
      }
    }
  }
  return secp256k1$1.Secp256k1 = E, secp256k1$1;
}
var slip10 = {}, build$1 = {}, decimal$1 = {}, hasRequiredDecimal;
function requireDecimal() {
  if (hasRequiredDecimal) return decimal$1;
  hasRequiredDecimal = 1, Object.defineProperty(decimal$1, "__esModule", { value: !0 }), decimal$1.Decimal = void 0;
  const o = 100;
  class g {
    constructor(y, t) {
      Vi(this, "data");
      if (!y.match(/^[0-9]+$/))
        throw new Error("Invalid string format. Only non-negative integers in decimal representation supported.");
      this.data = {
        atomics: BigInt(y),
        fractionalDigits: t
      };
    }
    static fromUserInput(y, t) {
      g.verifyFractionalDigits(t);
      const d = y.match(/[^0-9.]/);
      if (d)
        throw new Error(`Invalid character at position ${d.index + 1}`);
      let E, B;
      if (y === "")
        E = "0", B = "";
      else if (y.search(/\./) === -1)
        E = y, B = "";
      else {
        const x = y.split(".");
        switch (x.length) {
          case 0:
          case 1:
            throw new Error("Fewer than two elements in split result. This must not happen here.");
          case 2:
            if (!x[1])
              throw new Error("Fractional part missing");
            E = x[0], B = x[1].replace(/0+$/, "");
            break;
          default:
            throw new Error("More than one separator found");
        }
      }
      if (B.length > t)
        throw new Error("Got more fractional digits than supported");
      const D = `${E}${B.padEnd(t, "0")}`;
      return new g(D, t);
    }
    static fromAtomics(y, t) {
      return g.verifyFractionalDigits(t), new g(y, t);
    }
    /**
     * Creates a Decimal with value 0.0 and the given number of fractional digits.
     *
     * Fractional digits are not relevant for the value but needed to be able
     * to perform arithmetic operations with other decimals.
     */
    static zero(y) {
      return g.verifyFractionalDigits(y), new g("0", y);
    }
    /**
     * Creates a Decimal with value 1.0 and the given number of fractional digits.
     *
     * Fractional digits are not relevant for the value but needed to be able
     * to perform arithmetic operations with other decimals.
     */
    static one(y) {
      return g.verifyFractionalDigits(y), new g("1" + "0".repeat(y), y);
    }
    static verifyFractionalDigits(y) {
      if (!Number.isInteger(y))
        throw new Error("Fractional digits is not an integer");
      if (y < 0)
        throw new Error("Fractional digits must not be negative");
      if (y > o)
        throw new Error(`Fractional digits must not exceed ${o}`);
    }
    static compare(y, t) {
      if (y.fractionalDigits !== t.fractionalDigits)
        throw new Error("Fractional digits do not match");
      const d = y.data.atomics - t.data.atomics;
      return d < 0n ? -1 : d > 0n ? 1 : 0;
    }
    get atomics() {
      return this.data.atomics.toString();
    }
    get fractionalDigits() {
      return this.data.fractionalDigits;
    }
    /** Creates a new instance with the same value */
    clone() {
      return new g(this.atomics, this.fractionalDigits);
    }
    /** Returns the greatest decimal <= this which has no fractional part (rounding down) */
    floor() {
      const y = 10n ** BigInt(this.data.fractionalDigits), t = this.data.atomics / y;
      return this.data.atomics % y === 0n ? this.clone() : g.fromAtomics((t * y).toString(), this.fractionalDigits);
    }
    /** Returns the smallest decimal >= this which has no fractional part (rounding up) */
    ceil() {
      const y = 10n ** BigInt(this.data.fractionalDigits), t = this.data.atomics / y;
      return this.data.atomics % y === 0n ? this.clone() : g.fromAtomics(((t + 1n) * y).toString(), this.fractionalDigits);
    }
    toString() {
      const y = 10n ** BigInt(this.data.fractionalDigits), t = this.data.atomics / y, d = this.data.atomics % y;
      if (d === 0n)
        return t.toString();
      {
        const B = d.toString().padStart(this.data.fractionalDigits, "0").replace(/0+$/, "");
        return `${t.toString()}.${B}`;
      }
    }
    /**
     * Returns an approximation as a float type. Only use this if no
     * exact calculation is required.
     */
    toFloatApproximation() {
      const y = Number(this.toString());
      if (Number.isNaN(y))
        throw new Error("Conversion to number failed");
      return y;
    }
    /**
     * a.plus(b) returns a+b.
     *
     * Both values need to have the same fractional digits.
     */
    plus(y) {
      if (this.fractionalDigits !== y.fractionalDigits)
        throw new Error("Fractional digits do not match");
      const t = this.data.atomics + y.data.atomics;
      return new g(t.toString(), this.fractionalDigits);
    }
    /**
     * a.minus(b) returns a-b.
     *
     * Both values need to have the same fractional digits.
     * The resulting difference needs to be non-negative.
     */
    minus(y) {
      if (this.fractionalDigits !== y.fractionalDigits)
        throw new Error("Fractional digits do not match");
      const t = this.data.atomics - y.data.atomics;
      if (t < 0n)
        throw new Error("Difference must not be negative");
      return new g(t.toString(), this.fractionalDigits);
    }
    /**
     * a.multiply(b) returns a*b.
     *
     * We only allow multiplication by unsigned integers to avoid rounding errors.
     */
    multiply(y) {
      const t = this.data.atomics * y.toBigInt();
      return new g(t.toString(), this.fractionalDigits);
    }
    equals(y) {
      return g.compare(this, y) === 0;
    }
    isLessThan(y) {
      return g.compare(this, y) < 0;
    }
    isLessThanOrEqual(y) {
      return g.compare(this, y) <= 0;
    }
    isGreaterThan(y) {
      return g.compare(this, y) > 0;
    }
    isGreaterThanOrEqual(y) {
      return g.compare(this, y) >= 0;
    }
  }
  return decimal$1.Decimal = g, decimal$1;
}
var integers = {}, hasRequiredIntegers;
function requireIntegers() {
  if (hasRequiredIntegers) return integers;
  hasRequiredIntegers = 1, Object.defineProperty(integers, "__esModule", { value: !0 }), integers.Uint64 = integers.Uint53 = integers.Int53 = integers.Uint32 = void 0;
  const o = 18446744073709551615n;
  class g {
    constructor(E) {
      Vi(this, "data");
      if (Number.isNaN(E))
        throw new Error("Input is not a number");
      if (!Number.isInteger(E))
        throw new Error("Input is not an integer");
      if (E < 0 || E > 4294967295)
        throw new Error("Input not in uint32 range: " + E.toString());
      this.data = E;
    }
    /** @deprecated use Uint32.fromBytes */
    static fromBigEndianBytes(E) {
      return g.fromBytes(E);
    }
    /**
     * Creates a Uint32 from a fixed length byte array.
     *
     * @param bytes a list of exactly 4 bytes
     * @param endianness defaults to big endian
     */
    static fromBytes(E, B = "be") {
      if (E.length !== 4)
        throw new Error("Invalid input length. Expected 4 bytes.");
      for (let x = 0; x < E.length; ++x)
        if (!Number.isInteger(E[x]) || E[x] > 255 || E[x] < 0)
          throw new Error(`Invalid value in byte. Found: ${E[x]}`);
      const D = B === "be" ? E : Array.from(E).reverse();
      return new g(D[0] * 2 ** 24 + D[1] * 2 ** 16 + D[2] * 2 ** 8 + D[3]);
    }
    static fromString(E) {
      if (!E.match(/^[0-9]+$/))
        throw new Error("Invalid string format");
      return new g(Number.parseInt(E, 10));
    }
    toBytesBigEndian() {
      return new Uint8Array([
        Math.floor(this.data / 2 ** 24) & 255,
        Math.floor(this.data / 2 ** 16) & 255,
        Math.floor(this.data / 2 ** 8) & 255,
        Math.floor(this.data / 2 ** 0) & 255
      ]);
    }
    toBytesLittleEndian() {
      return new Uint8Array([
        Math.floor(this.data / 2 ** 0) & 255,
        Math.floor(this.data / 2 ** 8) & 255,
        Math.floor(this.data / 2 ** 16) & 255,
        Math.floor(this.data / 2 ** 24) & 255
      ]);
    }
    toNumber() {
      return this.data;
    }
    toBigInt() {
      return BigInt(this.toNumber());
    }
    toString() {
      return this.data.toString();
    }
  }
  integers.Uint32 = g;
  class c {
    constructor(E) {
      Vi(this, "data");
      if (Number.isNaN(E))
        throw new Error("Input is not a number");
      if (!Number.isInteger(E))
        throw new Error("Input is not an integer");
      if (E < Number.MIN_SAFE_INTEGER || E > Number.MAX_SAFE_INTEGER)
        throw new Error("Input not in int53 range: " + E.toString());
      this.data = E;
    }
    static fromString(E) {
      if (!E.match(/^-?[0-9]+$/))
        throw new Error("Invalid string format");
      return new c(Number.parseInt(E, 10));
    }
    toNumber() {
      return this.data;
    }
    toBigInt() {
      return BigInt(this.toNumber());
    }
    toString() {
      return this.data.toString();
    }
  }
  integers.Int53 = c;
  class y {
    constructor(E) {
      Vi(this, "data");
      const B = new c(E);
      if (B.toNumber() < 0)
        throw new Error("Input is negative");
      this.data = B;
    }
    static fromString(E) {
      const B = c.fromString(E);
      return new y(B.toNumber());
    }
    toNumber() {
      return this.data.toNumber();
    }
    toBigInt() {
      return BigInt(this.toNumber());
    }
    toString() {
      return this.data.toString();
    }
  }
  integers.Uint53 = y;
  class t {
    constructor(E) {
      Vi(this, "data");
      if (E < 0n)
        throw new Error("Input is negative");
      if (E > o)
        throw new Error("Input exceeds uint64 range");
      this.data = E;
    }
    /** @deprecated use Uint64.fromBytes */
    static fromBytesBigEndian(E) {
      return t.fromBytes(E);
    }
    /**
     * Creates a Uint64 from a fixed length byte array.
     *
     * @param bytes a list of exactly 8 bytes
     * @param endianness defaults to big endian
     */
    static fromBytes(E, B = "be") {
      if (E.length !== 8)
        throw new Error("Invalid input length. Expected 8 bytes.");
      const D = B === "be" ? Array.from(E) : Array.from(E).reverse();
      let x = 0n;
      for (const v of D) {
        if (x *= 256n, !Number.isInteger(v) || v > 255 || v < 0)
          throw new Error(`Invalid value in byte. Found: ${v}`);
        x += BigInt(v);
      }
      return new t(x);
    }
    static fromString(E) {
      if (!E.match(/^[0-9]+$/))
        throw new Error("Invalid string format");
      return new t(BigInt(E));
    }
    static fromNumber(E) {
      if (Number.isNaN(E))
        throw new Error("Input is not a number");
      if (!Number.isInteger(E))
        throw new Error("Input is not an integer");
      if (!Number.isSafeInteger(E))
        throw new Error("Input is not a safe integer");
      const B = BigInt(E);
      return new t(B);
    }
    toBytesBigEndian() {
      return this.toBytesLittleEndian().reverse();
    }
    toBytesLittleEndian() {
      const E = new Uint8Array(8);
      let B = this.data;
      for (let D = 0; D < E.length; D++)
        E[D] = Number(B % 256n), B /= 256n;
      return E;
    }
    toString() {
      return this.data.toString(10);
    }
    toBigInt() {
      return this.data;
    }
    toNumber() {
      if (this.data > BigInt(Number.MAX_SAFE_INTEGER))
        throw new Error("number can only safely store up to 53 bits");
      return Number(this.data);
    }
  }
  return integers.Uint64 = t, integers;
}
var hasRequiredBuild$2;
function requireBuild$2() {
  return hasRequiredBuild$2 || (hasRequiredBuild$2 = 1, function(o) {
    Object.defineProperty(o, "__esModule", { value: !0 }), o.Uint64 = o.Uint53 = o.Uint32 = o.Int53 = o.Decimal = void 0;
    var g = requireDecimal();
    Object.defineProperty(o, "Decimal", { enumerable: !0, get: function() {
      return g.Decimal;
    } });
    var c = requireIntegers();
    Object.defineProperty(o, "Int53", { enumerable: !0, get: function() {
      return c.Int53;
    } }), Object.defineProperty(o, "Uint32", { enumerable: !0, get: function() {
      return c.Uint32;
    } }), Object.defineProperty(o, "Uint53", { enumerable: !0, get: function() {
      return c.Uint53;
    } }), Object.defineProperty(o, "Uint64", { enumerable: !0, get: function() {
      return c.Uint64;
    } });
  }(build$1)), build$1;
}
var hasRequiredSlip10;
function requireSlip10() {
  if (hasRequiredSlip10) return slip10;
  hasRequiredSlip10 = 1, Object.defineProperty(slip10, "__esModule", { value: !0 }), slip10.Slip10 = slip10.Slip10RawIndex = slip10.Slip10Curve = void 0, slip10.slip10CurveFromString = x, slip10.pathToString = M, slip10.stringToPath = U;
  const o = requireBuild$4(), g = requireBuild$2(), c = requireBuild$3(), y = /* @__PURE__ */ requireSecp256k1$5(), t = requireHmac(), d = requireSha();
  var E;
  (function(L) {
    L.Secp256k1 = "Bitcoin seed", L.Ed25519 = "ed25519 seed";
  })(E || (slip10.Slip10Curve = E = {}));
  function B(L) {
    return BigInt("0x" + (0, o.toHex)(L));
  }
  function D(L) {
    (0, c.assert)(L >= 0n), (0, c.assert)(L < 2n ** (32n * 8n));
    const H = L.toString(16).padStart(64, "0");
    return (0, o.fromHex)(H);
  }
  function x(L) {
    switch (L) {
      case E.Ed25519:
        return E.Ed25519;
      case E.Secp256k1:
        return E.Secp256k1;
      default:
        throw new Error(`Unknown curve string: '${L}'`);
    }
  }
  class v extends g.Uint32 {
    static hardened(H) {
      return new v(H + 2 ** 31);
    }
    static normal(H) {
      return new v(H);
    }
    isHardened() {
      return this.data >= 2 ** 31;
    }
  }
  slip10.Slip10RawIndex = v;
  class F {
    static derivePath(H, fe, ge) {
      let Ie = this.master(H, fe);
      for (const Ee of ge)
        Ie = this.child(H, Ie.privkey, Ie.chainCode, Ee);
      return Ie;
    }
    static master(H, fe) {
      const ge = new t.Hmac(d.Sha512, (0, o.toAscii)(H)).update(fe).digest(), Ie = ge.slice(0, 32), Ee = ge.slice(32, 64);
      return H !== E.Ed25519 && (this.isZero(Ie) || this.isGteN(H, Ie)) ? this.master(H, ge) : {
        chainCode: Ee,
        privkey: Ie
      };
    }
    static child(H, fe, ge, Ie) {
      let Ee;
      if (Ie.isHardened()) {
        const Se = new Uint8Array([0, ...fe, ...Ie.toBytesBigEndian()]);
        Ee = new t.Hmac(d.Sha512, ge).update(Se).digest();
      } else {
        if (H === E.Ed25519)
          throw new Error("Normal keys are not allowed with ed25519");
        {
          const Se = new Uint8Array([
            ...F.serializedPoint(H, B(fe)),
            ...Ie.toBytesBigEndian()
          ]);
          Ee = new t.Hmac(d.Sha512, ge).update(Se).digest();
        }
      }
      return this.childImpl(H, fe, ge, Ie, Ee);
    }
    /**
     * Implementation of ser_P(point(k_par)) from BIP-0032
     *
     * @see https://github.com/bitcoin/bips/blob/master/bip-0032.mediawiki
     */
    static serializedPoint(H, fe) {
      switch (H) {
        case E.Secp256k1:
          return y.secp256k1.Point.BASE.multiply(fe).toBytes(!0);
        default:
          throw new Error("curve not supported");
      }
    }
    static childImpl(H, fe, ge, Ie, Ee) {
      const Se = Ee.slice(0, 32), ze = Ee.slice(32, 64), He = ze;
      if (H === E.Ed25519)
        return {
          chainCode: He,
          privkey: Se
        };
      const Pe = this.n(H), De = (B(Se) + B(fe)) % Pe, ve = D(De);
      if (this.isGteN(H, Se) || this.isZero(ve)) {
        const Fe = new t.Hmac(d.Sha512, ge).update(new Uint8Array([1, ...ze, ...Ie.toBytesBigEndian()])).digest();
        return this.childImpl(H, fe, ge, Ie, Fe);
      }
      return {
        chainCode: He,
        privkey: ve
      };
    }
    static isZero(H) {
      return H.every((fe) => fe === 0);
    }
    static isGteN(H, fe) {
      return B(fe) >= this.n(H);
    }
    static n(H) {
      switch (H) {
        case E.Secp256k1:
          return 0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141n;
        default:
          throw new Error("curve not supported");
      }
    }
  }
  slip10.Slip10 = F;
  function M(L) {
    return L.reduce((H, fe) => {
      const ge = fe.isHardened() ? `${fe.toNumber() - 2147483648}'` : fe.toString();
      return H + "/" + ge;
    }, "m");
  }
  function U(L) {
    if (!L.startsWith("m"))
      throw new Error("Path string must start with 'm'");
    let H = L.slice(1);
    const fe = new Array();
    for (; H; ) {
      const ge = H.match(/^\/([0-9]+)('?)/);
      if (!ge)
        throw new Error("Syntax error while reading path component");
      const [Ie, Ee, Se] = ge, ze = g.Uint53.fromString(Ee).toNumber();
      if (ze >= 2 ** 31)
        throw new Error("Component value too high. Must not exceed 2**31-1.");
      Se ? fe.push(v.hardened(ze)) : fe.push(v.normal(ze)), H = H.slice(Ie.length);
    }
    return fe;
  }
  return slip10;
}
var hasRequiredBuild$1;
function requireBuild$1() {
  return hasRequiredBuild$1 || (hasRequiredBuild$1 = 1, function(o) {
    Object.defineProperty(o, "__esModule", { value: !0 }), o.stringToPath = o.Slip10RawIndex = o.slip10CurveFromString = o.Slip10Curve = o.Slip10 = o.pathToString = o.sha512 = o.Sha512 = o.sha256 = o.Sha256 = o.Secp256k1Signature = o.ExtendedSecp256k1Signature = o.Secp256k1 = o.ripemd160 = o.Ripemd160 = o.Random = o.Xchacha20poly1305Ietf = o.xchacha20NonceLength = o.isArgon2idOptions = o.Ed25519Keypair = o.Ed25519 = o.Argon2id = o.keccak256 = o.Keccak256 = o.Hmac = o.EnglishMnemonic = o.Bip39 = void 0;
    var g = requireBip39();
    Object.defineProperty(o, "Bip39", { enumerable: !0, get: function() {
      return g.Bip39;
    } }), Object.defineProperty(o, "EnglishMnemonic", { enumerable: !0, get: function() {
      return g.EnglishMnemonic;
    } });
    var c = requireHmac();
    Object.defineProperty(o, "Hmac", { enumerable: !0, get: function() {
      return c.Hmac;
    } });
    var y = requireKeccak();
    Object.defineProperty(o, "Keccak256", { enumerable: !0, get: function() {
      return y.Keccak256;
    } }), Object.defineProperty(o, "keccak256", { enumerable: !0, get: function() {
      return y.keccak256;
    } });
    var t = requireLibsodium();
    Object.defineProperty(o, "Argon2id", { enumerable: !0, get: function() {
      return t.Argon2id;
    } }), Object.defineProperty(o, "Ed25519", { enumerable: !0, get: function() {
      return t.Ed25519;
    } }), Object.defineProperty(o, "Ed25519Keypair", { enumerable: !0, get: function() {
      return t.Ed25519Keypair;
    } }), Object.defineProperty(o, "isArgon2idOptions", { enumerable: !0, get: function() {
      return t.isArgon2idOptions;
    } }), Object.defineProperty(o, "xchacha20NonceLength", { enumerable: !0, get: function() {
      return t.xchacha20NonceLength;
    } }), Object.defineProperty(o, "Xchacha20poly1305Ietf", { enumerable: !0, get: function() {
      return t.Xchacha20poly1305Ietf;
    } });
    var d = requireRandom();
    Object.defineProperty(o, "Random", { enumerable: !0, get: function() {
      return d.Random;
    } });
    var E = requireRipemd();
    Object.defineProperty(o, "Ripemd160", { enumerable: !0, get: function() {
      return E.Ripemd160;
    } }), Object.defineProperty(o, "ripemd160", { enumerable: !0, get: function() {
      return E.ripemd160;
    } });
    var B = requireSecp256k1();
    Object.defineProperty(o, "Secp256k1", { enumerable: !0, get: function() {
      return B.Secp256k1;
    } });
    var D = requireSecp256k1signature();
    Object.defineProperty(o, "ExtendedSecp256k1Signature", { enumerable: !0, get: function() {
      return D.ExtendedSecp256k1Signature;
    } }), Object.defineProperty(o, "Secp256k1Signature", { enumerable: !0, get: function() {
      return D.Secp256k1Signature;
    } });
    var x = requireSha();
    Object.defineProperty(o, "Sha256", { enumerable: !0, get: function() {
      return x.Sha256;
    } }), Object.defineProperty(o, "sha256", { enumerable: !0, get: function() {
      return x.sha256;
    } }), Object.defineProperty(o, "Sha512", { enumerable: !0, get: function() {
      return x.Sha512;
    } }), Object.defineProperty(o, "sha512", { enumerable: !0, get: function() {
      return x.sha512;
    } });
    var v = requireSlip10();
    Object.defineProperty(o, "pathToString", { enumerable: !0, get: function() {
      return v.pathToString;
    } }), Object.defineProperty(o, "Slip10", { enumerable: !0, get: function() {
      return v.Slip10;
    } }), Object.defineProperty(o, "Slip10Curve", { enumerable: !0, get: function() {
      return v.Slip10Curve;
    } }), Object.defineProperty(o, "slip10CurveFromString", { enumerable: !0, get: function() {
      return v.slip10CurveFromString;
    } }), Object.defineProperty(o, "Slip10RawIndex", { enumerable: !0, get: function() {
      return v.Slip10RawIndex;
    } }), Object.defineProperty(o, "stringToPath", { enumerable: !0, get: function() {
      return v.stringToPath;
    } });
  }(build$4)), build$4;
}
var buildExports = requireBuild$1(), tx = {}, indexMinimal = {}, minimal$1 = {}, aspromise, hasRequiredAspromise;
function requireAspromise() {
  if (hasRequiredAspromise) return aspromise;
  hasRequiredAspromise = 1, aspromise = o;
  function o(g, c) {
    for (var y = new Array(arguments.length - 1), t = 0, d = 2, E = !0; d < arguments.length; )
      y[t++] = arguments[d++];
    return new Promise(function(D, x) {
      y[t] = function(F) {
        if (E)
          if (E = !1, F)
            x(F);
          else {
            for (var M = new Array(arguments.length - 1), U = 0; U < M.length; )
              M[U++] = arguments[U];
            D.apply(null, M);
          }
      };
      try {
        g.apply(c || null, y);
      } catch (v) {
        E && (E = !1, x(v));
      }
    });
  }
  return aspromise;
}
var base64$1 = {}, hasRequiredBase64$1;
function requireBase64$1() {
  return hasRequiredBase64$1 || (hasRequiredBase64$1 = 1, function(o) {
    var g = o;
    g.length = function(B) {
      var D = B.length;
      if (!D)
        return 0;
      for (var x = 0; --D % 4 > 1 && B.charAt(D) === "="; )
        ++x;
      return Math.ceil(B.length * 3) / 4 - x;
    };
    for (var c = new Array(64), y = new Array(123), t = 0; t < 64; )
      y[c[t] = t < 26 ? t + 65 : t < 52 ? t + 71 : t < 62 ? t - 4 : t - 59 | 43] = t++;
    g.encode = function(B, D, x) {
      for (var v = null, F = [], M = 0, U = 0, L; D < x; ) {
        var H = B[D++];
        switch (U) {
          case 0:
            F[M++] = c[H >> 2], L = (H & 3) << 4, U = 1;
            break;
          case 1:
            F[M++] = c[L | H >> 4], L = (H & 15) << 2, U = 2;
            break;
          case 2:
            F[M++] = c[L | H >> 6], F[M++] = c[H & 63], U = 0;
            break;
        }
        M > 8191 && ((v || (v = [])).push(String.fromCharCode.apply(String, F)), M = 0);
      }
      return U && (F[M++] = c[L], F[M++] = 61, U === 1 && (F[M++] = 61)), v ? (M && v.push(String.fromCharCode.apply(String, F.slice(0, M))), v.join("")) : String.fromCharCode.apply(String, F.slice(0, M));
    };
    var d = "invalid encoding";
    g.decode = function(B, D, x) {
      for (var v = x, F = 0, M, U = 0; U < B.length; ) {
        var L = B.charCodeAt(U++);
        if (L === 61 && F > 1)
          break;
        if ((L = y[L]) === void 0)
          throw Error(d);
        switch (F) {
          case 0:
            M = L, F = 1;
            break;
          case 1:
            D[x++] = M << 2 | (L & 48) >> 4, M = L, F = 2;
            break;
          case 2:
            D[x++] = (M & 15) << 4 | (L & 60) >> 2, M = L, F = 3;
            break;
          case 3:
            D[x++] = (M & 3) << 6 | L, F = 0;
            break;
        }
      }
      if (F === 1)
        throw Error(d);
      return x - v;
    }, g.test = function(B) {
      return /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/.test(B);
    };
  }(base64$1)), base64$1;
}
var eventemitter, hasRequiredEventemitter;
function requireEventemitter() {
  if (hasRequiredEventemitter) return eventemitter;
  hasRequiredEventemitter = 1, eventemitter = o;
  function o() {
    this._listeners = {};
  }
  return o.prototype.on = function(c, y, t) {
    return (this._listeners[c] || (this._listeners[c] = [])).push({
      fn: y,
      ctx: t || this
    }), this;
  }, o.prototype.off = function(c, y) {
    if (c === void 0)
      this._listeners = {};
    else if (y === void 0)
      this._listeners[c] = [];
    else
      for (var t = this._listeners[c], d = 0; d < t.length; )
        t[d].fn === y ? t.splice(d, 1) : ++d;
    return this;
  }, o.prototype.emit = function(c) {
    var y = this._listeners[c];
    if (y) {
      for (var t = [], d = 1; d < arguments.length; )
        t.push(arguments[d++]);
      for (d = 0; d < y.length; )
        y[d].fn.apply(y[d++].ctx, t);
    }
    return this;
  }, eventemitter;
}
var float, hasRequiredFloat;
function requireFloat() {
  if (hasRequiredFloat) return float;
  hasRequiredFloat = 1, float = o(o);
  function o(d) {
    return typeof Float32Array < "u" ? function() {
      var E = new Float32Array([-0]), B = new Uint8Array(E.buffer), D = B[3] === 128;
      function x(U, L, H) {
        E[0] = U, L[H] = B[0], L[H + 1] = B[1], L[H + 2] = B[2], L[H + 3] = B[3];
      }
      function v(U, L, H) {
        E[0] = U, L[H] = B[3], L[H + 1] = B[2], L[H + 2] = B[1], L[H + 3] = B[0];
      }
      d.writeFloatLE = D ? x : v, d.writeFloatBE = D ? v : x;
      function F(U, L) {
        return B[0] = U[L], B[1] = U[L + 1], B[2] = U[L + 2], B[3] = U[L + 3], E[0];
      }
      function M(U, L) {
        return B[3] = U[L], B[2] = U[L + 1], B[1] = U[L + 2], B[0] = U[L + 3], E[0];
      }
      d.readFloatLE = D ? F : M, d.readFloatBE = D ? M : F;
    }() : function() {
      function E(D, x, v, F) {
        var M = x < 0 ? 1 : 0;
        if (M && (x = -x), x === 0)
          D(1 / x > 0 ? (
            /* positive */
            0
          ) : (
            /* negative 0 */
            2147483648
          ), v, F);
        else if (isNaN(x))
          D(2143289344, v, F);
        else if (x > 34028234663852886e22)
          D((M << 31 | 2139095040) >>> 0, v, F);
        else if (x < 11754943508222875e-54)
          D((M << 31 | Math.round(x / 1401298464324817e-60)) >>> 0, v, F);
        else {
          var U = Math.floor(Math.log(x) / Math.LN2), L = Math.round(x * Math.pow(2, -U) * 8388608) & 8388607;
          D((M << 31 | U + 127 << 23 | L) >>> 0, v, F);
        }
      }
      d.writeFloatLE = E.bind(null, g), d.writeFloatBE = E.bind(null, c);
      function B(D, x, v) {
        var F = D(x, v), M = (F >> 31) * 2 + 1, U = F >>> 23 & 255, L = F & 8388607;
        return U === 255 ? L ? NaN : M * (1 / 0) : U === 0 ? M * 1401298464324817e-60 * L : M * Math.pow(2, U - 150) * (L + 8388608);
      }
      d.readFloatLE = B.bind(null, y), d.readFloatBE = B.bind(null, t);
    }(), typeof Float64Array < "u" ? function() {
      var E = new Float64Array([-0]), B = new Uint8Array(E.buffer), D = B[7] === 128;
      function x(U, L, H) {
        E[0] = U, L[H] = B[0], L[H + 1] = B[1], L[H + 2] = B[2], L[H + 3] = B[3], L[H + 4] = B[4], L[H + 5] = B[5], L[H + 6] = B[6], L[H + 7] = B[7];
      }
      function v(U, L, H) {
        E[0] = U, L[H] = B[7], L[H + 1] = B[6], L[H + 2] = B[5], L[H + 3] = B[4], L[H + 4] = B[3], L[H + 5] = B[2], L[H + 6] = B[1], L[H + 7] = B[0];
      }
      d.writeDoubleLE = D ? x : v, d.writeDoubleBE = D ? v : x;
      function F(U, L) {
        return B[0] = U[L], B[1] = U[L + 1], B[2] = U[L + 2], B[3] = U[L + 3], B[4] = U[L + 4], B[5] = U[L + 5], B[6] = U[L + 6], B[7] = U[L + 7], E[0];
      }
      function M(U, L) {
        return B[7] = U[L], B[6] = U[L + 1], B[5] = U[L + 2], B[4] = U[L + 3], B[3] = U[L + 4], B[2] = U[L + 5], B[1] = U[L + 6], B[0] = U[L + 7], E[0];
      }
      d.readDoubleLE = D ? F : M, d.readDoubleBE = D ? M : F;
    }() : function() {
      function E(D, x, v, F, M, U) {
        var L = F < 0 ? 1 : 0;
        if (L && (F = -F), F === 0)
          D(0, M, U + x), D(1 / F > 0 ? (
            /* positive */
            0
          ) : (
            /* negative 0 */
            2147483648
          ), M, U + v);
        else if (isNaN(F))
          D(0, M, U + x), D(2146959360, M, U + v);
        else if (F > 17976931348623157e292)
          D(0, M, U + x), D((L << 31 | 2146435072) >>> 0, M, U + v);
        else {
          var H;
          if (F < 22250738585072014e-324)
            H = F / 5e-324, D(H >>> 0, M, U + x), D((L << 31 | H / 4294967296) >>> 0, M, U + v);
          else {
            var fe = Math.floor(Math.log(F) / Math.LN2);
            fe === 1024 && (fe = 1023), H = F * Math.pow(2, -fe), D(H * 4503599627370496 >>> 0, M, U + x), D((L << 31 | fe + 1023 << 20 | H * 1048576 & 1048575) >>> 0, M, U + v);
          }
        }
      }
      d.writeDoubleLE = E.bind(null, g, 0, 4), d.writeDoubleBE = E.bind(null, c, 4, 0);
      function B(D, x, v, F, M) {
        var U = D(F, M + x), L = D(F, M + v), H = (L >> 31) * 2 + 1, fe = L >>> 20 & 2047, ge = 4294967296 * (L & 1048575) + U;
        return fe === 2047 ? ge ? NaN : H * (1 / 0) : fe === 0 ? H * 5e-324 * ge : H * Math.pow(2, fe - 1075) * (ge + 4503599627370496);
      }
      d.readDoubleLE = B.bind(null, y, 0, 4), d.readDoubleBE = B.bind(null, t, 4, 0);
    }(), d;
  }
  function g(d, E, B) {
    E[B] = d & 255, E[B + 1] = d >>> 8 & 255, E[B + 2] = d >>> 16 & 255, E[B + 3] = d >>> 24;
  }
  function c(d, E, B) {
    E[B] = d >>> 24, E[B + 1] = d >>> 16 & 255, E[B + 2] = d >>> 8 & 255, E[B + 3] = d & 255;
  }
  function y(d, E) {
    return (d[E] | d[E + 1] << 8 | d[E + 2] << 16 | d[E + 3] << 24) >>> 0;
  }
  function t(d, E) {
    return (d[E] << 24 | d[E + 1] << 16 | d[E + 2] << 8 | d[E + 3]) >>> 0;
  }
  return float;
}
var inquire_1, hasRequiredInquire;
function requireInquire() {
  if (hasRequiredInquire) return inquire_1;
  hasRequiredInquire = 1, inquire_1 = inquire;
  function inquire(moduleName) {
    try {
      var mod = eval("quire".replace(/^/, "re"))(moduleName);
      if (mod && (mod.length || Object.keys(mod).length))
        return mod;
    } catch (o) {
    }
    return null;
  }
  return inquire_1;
}
var utf8$2 = {}, hasRequiredUtf8$1;
function requireUtf8$1() {
  return hasRequiredUtf8$1 || (hasRequiredUtf8$1 = 1, function(o) {
    var g = o;
    g.length = function(y) {
      for (var t = 0, d = 0, E = 0; E < y.length; ++E)
        d = y.charCodeAt(E), d < 128 ? t += 1 : d < 2048 ? t += 2 : (d & 64512) === 55296 && (y.charCodeAt(E + 1) & 64512) === 56320 ? (++E, t += 4) : t += 3;
      return t;
    }, g.read = function(y, t, d) {
      var E = d - t;
      if (E < 1)
        return "";
      for (var B = null, D = [], x = 0, v; t < d; )
        v = y[t++], v < 128 ? D[x++] = v : v > 191 && v < 224 ? D[x++] = (v & 31) << 6 | y[t++] & 63 : v > 239 && v < 365 ? (v = ((v & 7) << 18 | (y[t++] & 63) << 12 | (y[t++] & 63) << 6 | y[t++] & 63) - 65536, D[x++] = 55296 + (v >> 10), D[x++] = 56320 + (v & 1023)) : D[x++] = (v & 15) << 12 | (y[t++] & 63) << 6 | y[t++] & 63, x > 8191 && ((B || (B = [])).push(String.fromCharCode.apply(String, D)), x = 0);
      return B ? (x && B.push(String.fromCharCode.apply(String, D.slice(0, x))), B.join("")) : String.fromCharCode.apply(String, D.slice(0, x));
    }, g.write = function(y, t, d) {
      for (var E = d, B, D, x = 0; x < y.length; ++x)
        B = y.charCodeAt(x), B < 128 ? t[d++] = B : B < 2048 ? (t[d++] = B >> 6 | 192, t[d++] = B & 63 | 128) : (B & 64512) === 55296 && ((D = y.charCodeAt(x + 1)) & 64512) === 56320 ? (B = 65536 + ((B & 1023) << 10) + (D & 1023), ++x, t[d++] = B >> 18 | 240, t[d++] = B >> 12 & 63 | 128, t[d++] = B >> 6 & 63 | 128, t[d++] = B & 63 | 128) : (t[d++] = B >> 12 | 224, t[d++] = B >> 6 & 63 | 128, t[d++] = B & 63 | 128);
      return d - E;
    };
  }(utf8$2)), utf8$2;
}
var pool_1, hasRequiredPool;
function requirePool() {
  if (hasRequiredPool) return pool_1;
  hasRequiredPool = 1, pool_1 = o;
  function o(g, c, y) {
    var t = y || 8192, d = t >>> 1, E = null, B = t;
    return function(x) {
      if (x < 1 || x > d)
        return g(x);
      B + x > t && (E = g(t), B = 0);
      var v = c.call(E, B, B += x);
      return B & 7 && (B = (B | 7) + 1), v;
    };
  }
  return pool_1;
}
var longbits, hasRequiredLongbits;
function requireLongbits() {
  if (hasRequiredLongbits) return longbits;
  hasRequiredLongbits = 1, longbits = g;
  var o = requireMinimal$1();
  function g(d, E) {
    this.lo = d >>> 0, this.hi = E >>> 0;
  }
  var c = g.zero = new g(0, 0);
  c.toNumber = function() {
    return 0;
  }, c.zzEncode = c.zzDecode = function() {
    return this;
  }, c.length = function() {
    return 1;
  };
  var y = g.zeroHash = "\0\0\0\0\0\0\0\0";
  g.fromNumber = function(E) {
    if (E === 0)
      return c;
    var B = E < 0;
    B && (E = -E);
    var D = E >>> 0, x = (E - D) / 4294967296 >>> 0;
    return B && (x = ~x >>> 0, D = ~D >>> 0, ++D > 4294967295 && (D = 0, ++x > 4294967295 && (x = 0))), new g(D, x);
  }, g.from = function(E) {
    if (typeof E == "number")
      return g.fromNumber(E);
    if (o.isString(E))
      if (o.Long)
        E = o.Long.fromString(E);
      else
        return g.fromNumber(parseInt(E, 10));
    return E.low || E.high ? new g(E.low >>> 0, E.high >>> 0) : c;
  }, g.prototype.toNumber = function(E) {
    if (!E && this.hi >>> 31) {
      var B = ~this.lo + 1 >>> 0, D = ~this.hi >>> 0;
      return B || (D = D + 1 >>> 0), -(B + D * 4294967296);
    }
    return this.lo + this.hi * 4294967296;
  }, g.prototype.toLong = function(E) {
    return o.Long ? new o.Long(this.lo | 0, this.hi | 0, !!E) : { low: this.lo | 0, high: this.hi | 0, unsigned: !!E };
  };
  var t = String.prototype.charCodeAt;
  return g.fromHash = function(E) {
    return E === y ? c : new g(
      (t.call(E, 0) | t.call(E, 1) << 8 | t.call(E, 2) << 16 | t.call(E, 3) << 24) >>> 0,
      (t.call(E, 4) | t.call(E, 5) << 8 | t.call(E, 6) << 16 | t.call(E, 7) << 24) >>> 0
    );
  }, g.prototype.toHash = function() {
    return String.fromCharCode(
      this.lo & 255,
      this.lo >>> 8 & 255,
      this.lo >>> 16 & 255,
      this.lo >>> 24,
      this.hi & 255,
      this.hi >>> 8 & 255,
      this.hi >>> 16 & 255,
      this.hi >>> 24
    );
  }, g.prototype.zzEncode = function() {
    var E = this.hi >> 31;
    return this.hi = ((this.hi << 1 | this.lo >>> 31) ^ E) >>> 0, this.lo = (this.lo << 1 ^ E) >>> 0, this;
  }, g.prototype.zzDecode = function() {
    var E = -(this.lo & 1);
    return this.lo = ((this.lo >>> 1 | this.hi << 31) ^ E) >>> 0, this.hi = (this.hi >>> 1 ^ E) >>> 0, this;
  }, g.prototype.length = function() {
    var E = this.lo, B = (this.lo >>> 28 | this.hi << 4) >>> 0, D = this.hi >>> 24;
    return D === 0 ? B === 0 ? E < 16384 ? E < 128 ? 1 : 2 : E < 2097152 ? 3 : 4 : B < 16384 ? B < 128 ? 5 : 6 : B < 2097152 ? 7 : 8 : D < 128 ? 9 : 10;
  }, longbits;
}
var hasRequiredMinimal$1;
function requireMinimal$1() {
  return hasRequiredMinimal$1 || (hasRequiredMinimal$1 = 1, function(o) {
    var g = o;
    g.asPromise = requireAspromise(), g.base64 = requireBase64$1(), g.EventEmitter = requireEventemitter(), g.float = requireFloat(), g.inquire = requireInquire(), g.utf8 = requireUtf8$1(), g.pool = requirePool(), g.LongBits = requireLongbits(), g.isNode = !!(typeof commonjsGlobal < "u" && commonjsGlobal && commonjsGlobal.process && commonjsGlobal.process.versions && commonjsGlobal.process.versions.node), g.global = g.isNode && commonjsGlobal || typeof window < "u" && window || typeof self < "u" && self || minimal$1, g.emptyArray = Object.freeze ? Object.freeze([]) : (
      /* istanbul ignore next */
      []
    ), g.emptyObject = Object.freeze ? Object.freeze({}) : (
      /* istanbul ignore next */
      {}
    ), g.isInteger = Number.isInteger || /* istanbul ignore next */
    function(d) {
      return typeof d == "number" && isFinite(d) && Math.floor(d) === d;
    }, g.isString = function(d) {
      return typeof d == "string" || d instanceof String;
    }, g.isObject = function(d) {
      return d && typeof d == "object";
    }, g.isset = /**
     * Checks if a property on a message is considered to be present.
     * @param {Object} obj Plain object or message instance
     * @param {string} prop Property name
     * @returns {boolean} `true` if considered to be present, otherwise `false`
     */
    g.isSet = function(d, E) {
      var B = d[E];
      return B != null && d.hasOwnProperty(E) ? typeof B != "object" || (Array.isArray(B) ? B.length : Object.keys(B).length) > 0 : !1;
    }, g.Buffer = function() {
      try {
        var t = g.inquire("buffer").Buffer;
        return t.prototype.utf8Write ? t : (
          /* istanbul ignore next */
          null
        );
      } catch {
        return null;
      }
    }(), g._Buffer_from = null, g._Buffer_allocUnsafe = null, g.newBuffer = function(d) {
      return typeof d == "number" ? g.Buffer ? g._Buffer_allocUnsafe(d) : new g.Array(d) : g.Buffer ? g._Buffer_from(d) : typeof Uint8Array > "u" ? d : new Uint8Array(d);
    }, g.Array = typeof Uint8Array < "u" ? Uint8Array : Array, g.Long = /* istanbul ignore next */
    g.global.dcodeIO && /* istanbul ignore next */
    g.global.dcodeIO.Long || /* istanbul ignore next */
    g.global.Long || g.inquire("long"), g.key2Re = /^true|false|0|1$/, g.key32Re = /^-?(?:0|[1-9][0-9]*)$/, g.key64Re = /^(?:[\\x00-\\xff]{8}|-?(?:0|[1-9][0-9]*))$/, g.longToHash = function(d) {
      return d ? g.LongBits.from(d).toHash() : g.LongBits.zeroHash;
    }, g.longFromHash = function(d, E) {
      var B = g.LongBits.fromHash(d);
      return g.Long ? g.Long.fromBits(B.lo, B.hi, E) : B.toNumber(!!E);
    };
    function c(t, d, E) {
      for (var B = Object.keys(d), D = 0; D < B.length; ++D)
        (t[B[D]] === void 0 || !E) && (t[B[D]] = d[B[D]]);
      return t;
    }
    g.merge = c, g.lcFirst = function(d) {
      return d.charAt(0).toLowerCase() + d.substring(1);
    };
    function y(t) {
      function d(E, B) {
        if (!(this instanceof d))
          return new d(E, B);
        Object.defineProperty(this, "message", { get: function() {
          return E;
        } }), Error.captureStackTrace ? Error.captureStackTrace(this, d) : Object.defineProperty(this, "stack", { value: new Error().stack || "" }), B && c(this, B);
      }
      return (d.prototype = Object.create(Error.prototype)).constructor = d, Object.defineProperty(d.prototype, "name", { get: function() {
        return t;
      } }), d.prototype.toString = function() {
        return this.name + ": " + this.message;
      }, d;
    }
    g.newError = y, g.ProtocolError = y("ProtocolError"), g.oneOfGetter = function(d) {
      for (var E = {}, B = 0; B < d.length; ++B)
        E[d[B]] = 1;
      return function() {
        for (var D = Object.keys(this), x = D.length - 1; x > -1; --x)
          if (E[D[x]] === 1 && this[D[x]] !== void 0 && this[D[x]] !== null)
            return D[x];
      };
    }, g.oneOfSetter = function(d) {
      return function(E) {
        for (var B = 0; B < d.length; ++B)
          d[B] !== E && delete this[d[B]];
      };
    }, g.toJSONOptions = {
      longs: String,
      enums: String,
      bytes: String,
      json: !0
    }, g._configure = function() {
      var t = g.Buffer;
      if (!t) {
        g._Buffer_from = g._Buffer_allocUnsafe = null;
        return;
      }
      g._Buffer_from = t.from !== Uint8Array.from && t.from || /* istanbul ignore next */
      function(E, B) {
        return new t(E, B);
      }, g._Buffer_allocUnsafe = t.allocUnsafe || /* istanbul ignore next */
      function(E) {
        return new t(E);
      };
    };
  }(minimal$1)), minimal$1;
}
var writer, hasRequiredWriter;
function requireWriter() {
  if (hasRequiredWriter) return writer;
  hasRequiredWriter = 1, writer = D;
  var o = requireMinimal$1(), g, c = o.LongBits, y = o.base64, t = o.utf8;
  function d(fe, ge, Ie) {
    this.fn = fe, this.len = ge, this.next = void 0, this.val = Ie;
  }
  function E() {
  }
  function B(fe) {
    this.head = fe.head, this.tail = fe.tail, this.len = fe.len, this.next = fe.states;
  }
  function D() {
    this.len = 0, this.head = new d(E, 0, 0), this.tail = this.head, this.states = null;
  }
  var x = function() {
    return o.Buffer ? function() {
      return (D.create = function() {
        return new g();
      })();
    } : function() {
      return new D();
    };
  };
  D.create = x(), D.alloc = function(ge) {
    return new o.Array(ge);
  }, o.Array !== Array && (D.alloc = o.pool(D.alloc, o.Array.prototype.subarray)), D.prototype._push = function(ge, Ie, Ee) {
    return this.tail = this.tail.next = new d(ge, Ie, Ee), this.len += Ie, this;
  };
  function v(fe, ge, Ie) {
    ge[Ie] = fe & 255;
  }
  function F(fe, ge, Ie) {
    for (; fe > 127; )
      ge[Ie++] = fe & 127 | 128, fe >>>= 7;
    ge[Ie] = fe;
  }
  function M(fe, ge) {
    this.len = fe, this.next = void 0, this.val = ge;
  }
  M.prototype = Object.create(d.prototype), M.prototype.fn = F, D.prototype.uint32 = function(ge) {
    return this.len += (this.tail = this.tail.next = new M(
      (ge = ge >>> 0) < 128 ? 1 : ge < 16384 ? 2 : ge < 2097152 ? 3 : ge < 268435456 ? 4 : 5,
      ge
    )).len, this;
  }, D.prototype.int32 = function(ge) {
    return ge < 0 ? this._push(U, 10, c.fromNumber(ge)) : this.uint32(ge);
  }, D.prototype.sint32 = function(ge) {
    return this.uint32((ge << 1 ^ ge >> 31) >>> 0);
  };
  function U(fe, ge, Ie) {
    for (; fe.hi; )
      ge[Ie++] = fe.lo & 127 | 128, fe.lo = (fe.lo >>> 7 | fe.hi << 25) >>> 0, fe.hi >>>= 7;
    for (; fe.lo > 127; )
      ge[Ie++] = fe.lo & 127 | 128, fe.lo = fe.lo >>> 7;
    ge[Ie++] = fe.lo;
  }
  D.prototype.uint64 = function(ge) {
    var Ie = c.from(ge);
    return this._push(U, Ie.length(), Ie);
  }, D.prototype.int64 = D.prototype.uint64, D.prototype.sint64 = function(ge) {
    var Ie = c.from(ge).zzEncode();
    return this._push(U, Ie.length(), Ie);
  }, D.prototype.bool = function(ge) {
    return this._push(v, 1, ge ? 1 : 0);
  };
  function L(fe, ge, Ie) {
    ge[Ie] = fe & 255, ge[Ie + 1] = fe >>> 8 & 255, ge[Ie + 2] = fe >>> 16 & 255, ge[Ie + 3] = fe >>> 24;
  }
  D.prototype.fixed32 = function(ge) {
    return this._push(L, 4, ge >>> 0);
  }, D.prototype.sfixed32 = D.prototype.fixed32, D.prototype.fixed64 = function(ge) {
    var Ie = c.from(ge);
    return this._push(L, 4, Ie.lo)._push(L, 4, Ie.hi);
  }, D.prototype.sfixed64 = D.prototype.fixed64, D.prototype.float = function(ge) {
    return this._push(o.float.writeFloatLE, 4, ge);
  }, D.prototype.double = function(ge) {
    return this._push(o.float.writeDoubleLE, 8, ge);
  };
  var H = o.Array.prototype.set ? function(ge, Ie, Ee) {
    Ie.set(ge, Ee);
  } : function(ge, Ie, Ee) {
    for (var Se = 0; Se < ge.length; ++Se)
      Ie[Ee + Se] = ge[Se];
  };
  return D.prototype.bytes = function(ge) {
    var Ie = ge.length >>> 0;
    if (!Ie)
      return this._push(v, 1, 0);
    if (o.isString(ge)) {
      var Ee = D.alloc(Ie = y.length(ge));
      y.decode(ge, Ee, 0), ge = Ee;
    }
    return this.uint32(Ie)._push(H, Ie, ge);
  }, D.prototype.string = function(ge) {
    var Ie = t.length(ge);
    return Ie ? this.uint32(Ie)._push(t.write, Ie, ge) : this._push(v, 1, 0);
  }, D.prototype.fork = function() {
    return this.states = new B(this), this.head = this.tail = new d(E, 0, 0), this.len = 0, this;
  }, D.prototype.reset = function() {
    return this.states ? (this.head = this.states.head, this.tail = this.states.tail, this.len = this.states.len, this.states = this.states.next) : (this.head = this.tail = new d(E, 0, 0), this.len = 0), this;
  }, D.prototype.ldelim = function() {
    var ge = this.head, Ie = this.tail, Ee = this.len;
    return this.reset().uint32(Ee), Ee && (this.tail.next = ge.next, this.tail = Ie, this.len += Ee), this;
  }, D.prototype.finish = function() {
    for (var ge = this.head.next, Ie = this.constructor.alloc(this.len), Ee = 0; ge; )
      ge.fn(ge.val, Ie, Ee), Ee += ge.len, ge = ge.next;
    return Ie;
  }, D._configure = function(fe) {
    g = fe, D.create = x(), g._configure();
  }, writer;
}
var writer_buffer, hasRequiredWriter_buffer;
function requireWriter_buffer() {
  if (hasRequiredWriter_buffer) return writer_buffer;
  hasRequiredWriter_buffer = 1, writer_buffer = c;
  var o = requireWriter();
  (c.prototype = Object.create(o.prototype)).constructor = c;
  var g = requireMinimal$1();
  function c() {
    o.call(this);
  }
  c._configure = function() {
    c.alloc = g._Buffer_allocUnsafe, c.writeBytesBuffer = g.Buffer && g.Buffer.prototype instanceof Uint8Array && g.Buffer.prototype.set.name === "set" ? function(d, E, B) {
      E.set(d, B);
    } : function(d, E, B) {
      if (d.copy)
        d.copy(E, B, 0, d.length);
      else for (var D = 0; D < d.length; )
        E[B++] = d[D++];
    };
  }, c.prototype.bytes = function(d) {
    g.isString(d) && (d = g._Buffer_from(d, "base64"));
    var E = d.length >>> 0;
    return this.uint32(E), E && this._push(c.writeBytesBuffer, E, d), this;
  };
  function y(t, d, E) {
    t.length < 40 ? g.utf8.write(t, d, E) : d.utf8Write ? d.utf8Write(t, E) : d.write(t, E);
  }
  return c.prototype.string = function(d) {
    var E = g.Buffer.byteLength(d);
    return this.uint32(E), E && this._push(y, E, d), this;
  }, c._configure(), writer_buffer;
}
var reader, hasRequiredReader;
function requireReader() {
  if (hasRequiredReader) return reader;
  hasRequiredReader = 1, reader = d;
  var o = requireMinimal$1(), g, c = o.LongBits, y = o.utf8;
  function t(F, M) {
    return RangeError("index out of range: " + F.pos + " + " + (M || 1) + " > " + F.len);
  }
  function d(F) {
    this.buf = F, this.pos = 0, this.len = F.length;
  }
  var E = typeof Uint8Array < "u" ? function(M) {
    if (M instanceof Uint8Array || Array.isArray(M))
      return new d(M);
    throw Error("illegal buffer");
  } : function(M) {
    if (Array.isArray(M))
      return new d(M);
    throw Error("illegal buffer");
  }, B = function() {
    return o.Buffer ? function(U) {
      return (d.create = function(H) {
        return o.Buffer.isBuffer(H) ? new g(H) : E(H);
      })(U);
    } : E;
  };
  d.create = B(), d.prototype._slice = o.Array.prototype.subarray || /* istanbul ignore next */
  o.Array.prototype.slice, d.prototype.uint32 = /* @__PURE__ */ function() {
    var M = 4294967295;
    return function() {
      if (M = (this.buf[this.pos] & 127) >>> 0, this.buf[this.pos++] < 128 || (M = (M | (this.buf[this.pos] & 127) << 7) >>> 0, this.buf[this.pos++] < 128) || (M = (M | (this.buf[this.pos] & 127) << 14) >>> 0, this.buf[this.pos++] < 128) || (M = (M | (this.buf[this.pos] & 127) << 21) >>> 0, this.buf[this.pos++] < 128) || (M = (M | (this.buf[this.pos] & 15) << 28) >>> 0, this.buf[this.pos++] < 128)) return M;
      if ((this.pos += 5) > this.len)
        throw this.pos = this.len, t(this, 10);
      return M;
    };
  }(), d.prototype.int32 = function() {
    return this.uint32() | 0;
  }, d.prototype.sint32 = function() {
    var M = this.uint32();
    return M >>> 1 ^ -(M & 1) | 0;
  };
  function D() {
    var F = new c(0, 0), M = 0;
    if (this.len - this.pos > 4) {
      for (; M < 4; ++M)
        if (F.lo = (F.lo | (this.buf[this.pos] & 127) << M * 7) >>> 0, this.buf[this.pos++] < 128)
          return F;
      if (F.lo = (F.lo | (this.buf[this.pos] & 127) << 28) >>> 0, F.hi = (F.hi | (this.buf[this.pos] & 127) >> 4) >>> 0, this.buf[this.pos++] < 128)
        return F;
      M = 0;
    } else {
      for (; M < 3; ++M) {
        if (this.pos >= this.len)
          throw t(this);
        if (F.lo = (F.lo | (this.buf[this.pos] & 127) << M * 7) >>> 0, this.buf[this.pos++] < 128)
          return F;
      }
      return F.lo = (F.lo | (this.buf[this.pos++] & 127) << M * 7) >>> 0, F;
    }
    if (this.len - this.pos > 4) {
      for (; M < 5; ++M)
        if (F.hi = (F.hi | (this.buf[this.pos] & 127) << M * 7 + 3) >>> 0, this.buf[this.pos++] < 128)
          return F;
    } else
      for (; M < 5; ++M) {
        if (this.pos >= this.len)
          throw t(this);
        if (F.hi = (F.hi | (this.buf[this.pos] & 127) << M * 7 + 3) >>> 0, this.buf[this.pos++] < 128)
          return F;
      }
    throw Error("invalid varint encoding");
  }
  d.prototype.bool = function() {
    return this.uint32() !== 0;
  };
  function x(F, M) {
    return (F[M - 4] | F[M - 3] << 8 | F[M - 2] << 16 | F[M - 1] << 24) >>> 0;
  }
  d.prototype.fixed32 = function() {
    if (this.pos + 4 > this.len)
      throw t(this, 4);
    return x(this.buf, this.pos += 4);
  }, d.prototype.sfixed32 = function() {
    if (this.pos + 4 > this.len)
      throw t(this, 4);
    return x(this.buf, this.pos += 4) | 0;
  };
  function v() {
    if (this.pos + 8 > this.len)
      throw t(this, 8);
    return new c(x(this.buf, this.pos += 4), x(this.buf, this.pos += 4));
  }
  return d.prototype.float = function() {
    if (this.pos + 4 > this.len)
      throw t(this, 4);
    var M = o.float.readFloatLE(this.buf, this.pos);
    return this.pos += 4, M;
  }, d.prototype.double = function() {
    if (this.pos + 8 > this.len)
      throw t(this, 4);
    var M = o.float.readDoubleLE(this.buf, this.pos);
    return this.pos += 8, M;
  }, d.prototype.bytes = function() {
    var M = this.uint32(), U = this.pos, L = this.pos + M;
    if (L > this.len)
      throw t(this, M);
    return this.pos += M, Array.isArray(this.buf) ? this.buf.slice(U, L) : U === L ? new this.buf.constructor(0) : this._slice.call(this.buf, U, L);
  }, d.prototype.string = function() {
    var M = this.bytes();
    return y.read(M, 0, M.length);
  }, d.prototype.skip = function(M) {
    if (typeof M == "number") {
      if (this.pos + M > this.len)
        throw t(this, M);
      this.pos += M;
    } else
      do
        if (this.pos >= this.len)
          throw t(this);
      while (this.buf[this.pos++] & 128);
    return this;
  }, d.prototype.skipType = function(F) {
    switch (F) {
      case 0:
        this.skip();
        break;
      case 1:
        this.skip(8);
        break;
      case 2:
        this.skip(this.uint32());
        break;
      case 3:
        for (; (F = this.uint32() & 7) !== 4; )
          this.skipType(F);
        break;
      case 5:
        this.skip(4);
        break;
      /* istanbul ignore next */
      default:
        throw Error("invalid wire type " + F + " at offset " + this.pos);
    }
    return this;
  }, d._configure = function(F) {
    g = F, d.create = B(), g._configure();
    var M = o.Long ? "toLong" : (
      /* istanbul ignore next */
      "toNumber"
    );
    o.merge(d.prototype, {
      int64: function() {
        return D.call(this)[M](!1);
      },
      uint64: function() {
        return D.call(this)[M](!0);
      },
      sint64: function() {
        return D.call(this).zzDecode()[M](!1);
      },
      fixed64: function() {
        return v.call(this)[M](!0);
      },
      sfixed64: function() {
        return v.call(this)[M](!1);
      }
    });
  }, reader;
}
var reader_buffer, hasRequiredReader_buffer;
function requireReader_buffer() {
  if (hasRequiredReader_buffer) return reader_buffer;
  hasRequiredReader_buffer = 1, reader_buffer = c;
  var o = requireReader();
  (c.prototype = Object.create(o.prototype)).constructor = c;
  var g = requireMinimal$1();
  function c(y) {
    o.call(this, y);
  }
  return c._configure = function() {
    g.Buffer && (c.prototype._slice = g.Buffer.prototype.slice);
  }, c.prototype.string = function() {
    var t = this.uint32();
    return this.buf.utf8Slice ? this.buf.utf8Slice(this.pos, this.pos = Math.min(this.pos + t, this.len)) : this.buf.toString("utf-8", this.pos, this.pos = Math.min(this.pos + t, this.len));
  }, c._configure(), reader_buffer;
}
var rpc = {}, service, hasRequiredService;
function requireService() {
  if (hasRequiredService) return service;
  hasRequiredService = 1, service = g;
  var o = requireMinimal$1();
  (g.prototype = Object.create(o.EventEmitter.prototype)).constructor = g;
  function g(c, y, t) {
    if (typeof c != "function")
      throw TypeError("rpcImpl must be a function");
    o.EventEmitter.call(this), this.rpcImpl = c, this.requestDelimited = !!y, this.responseDelimited = !!t;
  }
  return g.prototype.rpcCall = function c(y, t, d, E, B) {
    if (!E)
      throw TypeError("request must be specified");
    var D = this;
    if (!B)
      return o.asPromise(c, D, y, t, d, E);
    if (!D.rpcImpl) {
      setTimeout(function() {
        B(Error("already ended"));
      }, 0);
      return;
    }
    try {
      return D.rpcImpl(
        y,
        t[D.requestDelimited ? "encodeDelimited" : "encode"](E).finish(),
        function(v, F) {
          if (v)
            return D.emit("error", v, y), B(v);
          if (F === null) {
            D.end(
              /* endedByRPC */
              !0
            );
            return;
          }
          if (!(F instanceof d))
            try {
              F = d[D.responseDelimited ? "decodeDelimited" : "decode"](F);
            } catch (M) {
              return D.emit("error", M, y), B(M);
            }
          return D.emit("data", F, y), B(null, F);
        }
      );
    } catch (x) {
      D.emit("error", x, y), setTimeout(function() {
        B(x);
      }, 0);
      return;
    }
  }, g.prototype.end = function(y) {
    return this.rpcImpl && (y || this.rpcImpl(null, null, null), this.rpcImpl = null, this.emit("end").off()), this;
  }, service;
}
var hasRequiredRpc;
function requireRpc() {
  return hasRequiredRpc || (hasRequiredRpc = 1, function(o) {
    var g = o;
    g.Service = requireService();
  }(rpc)), rpc;
}
var roots, hasRequiredRoots;
function requireRoots() {
  return hasRequiredRoots || (hasRequiredRoots = 1, roots = {}), roots;
}
var hasRequiredIndexMinimal;
function requireIndexMinimal() {
  return hasRequiredIndexMinimal || (hasRequiredIndexMinimal = 1, function(o) {
    var g = o;
    g.build = "minimal", g.Writer = requireWriter(), g.BufferWriter = requireWriter_buffer(), g.Reader = requireReader(), g.BufferReader = requireReader_buffer(), g.util = requireMinimal$1(), g.rpc = requireRpc(), g.roots = requireRoots(), g.configure = c;
    function c() {
      g.util._configure(), g.Writer._configure(g.BufferWriter), g.Reader._configure(g.BufferReader);
    }
    c();
  }(indexMinimal)), indexMinimal;
}
var minimal, hasRequiredMinimal;
function requireMinimal() {
  return hasRequiredMinimal || (hasRequiredMinimal = 1, minimal = requireIndexMinimal()), minimal;
}
var signing = {}, any = {}, hasRequiredAny;
function requireAny() {
  if (hasRequiredAny) return any;
  hasRequiredAny = 1;
  var o = any && any.__importDefault || function(v) {
    return v && v.__esModule ? v : { default: v };
  };
  Object.defineProperty(any, "__esModule", { value: !0 }), any.Any = any.protobufPackage = void 0;
  const g = o(requireLong()), c = o(requireMinimal());
  any.protobufPackage = "google.protobuf";
  function y() {
    return { typeUrl: "", value: new Uint8Array() };
  }
  any.Any = {
    encode(v, F = c.default.Writer.create()) {
      return v.typeUrl !== "" && F.uint32(10).string(v.typeUrl), v.value.length !== 0 && F.uint32(18).bytes(v.value), F;
    },
    decode(v, F) {
      const M = v instanceof c.default.Reader ? v : new c.default.Reader(v);
      let U = F === void 0 ? M.len : M.pos + F;
      const L = y();
      for (; M.pos < U; ) {
        const H = M.uint32();
        switch (H >>> 3) {
          case 1:
            L.typeUrl = M.string();
            break;
          case 2:
            L.value = M.bytes();
            break;
          default:
            M.skipType(H & 7);
            break;
        }
      }
      return L;
    },
    fromJSON(v) {
      return {
        typeUrl: x(v.typeUrl) ? String(v.typeUrl) : "",
        value: x(v.value) ? E(v.value) : new Uint8Array()
      };
    },
    toJSON(v) {
      const F = {};
      return v.typeUrl !== void 0 && (F.typeUrl = v.typeUrl), v.value !== void 0 && (F.value = D(v.value !== void 0 ? v.value : new Uint8Array())), F;
    },
    fromPartial(v) {
      var F, M;
      const U = y();
      return U.typeUrl = (F = v.typeUrl) !== null && F !== void 0 ? F : "", U.value = (M = v.value) !== null && M !== void 0 ? M : new Uint8Array(), U;
    }
  };
  var t = (() => {
    if (typeof t < "u")
      return t;
    if (typeof self < "u")
      return self;
    if (typeof window < "u")
      return window;
    if (typeof commonjsGlobal < "u")
      return commonjsGlobal;
    throw "Unable to locate global object";
  })();
  const d = t.atob || ((v) => t.Buffer.from(v, "base64").toString("binary"));
  function E(v) {
    const F = d(v), M = new Uint8Array(F.length);
    for (let U = 0; U < F.length; ++U)
      M[U] = F.charCodeAt(U);
    return M;
  }
  const B = t.btoa || ((v) => t.Buffer.from(v, "binary").toString("base64"));
  function D(v) {
    const F = [];
    for (const M of v)
      F.push(String.fromCharCode(M));
    return B(F.join(""));
  }
  c.default.util.Long !== g.default && (c.default.util.Long = g.default, c.default.configure());
  function x(v) {
    return v != null;
  }
  return any;
}
var multisig = {}, hasRequiredMultisig;
function requireMultisig() {
  if (hasRequiredMultisig) return multisig;
  hasRequiredMultisig = 1;
  var o = multisig && multisig.__importDefault || function(F) {
    return F && F.__esModule ? F : { default: F };
  };
  Object.defineProperty(multisig, "__esModule", { value: !0 }), multisig.CompactBitArray = multisig.MultiSignature = multisig.protobufPackage = void 0;
  const g = o(requireLong()), c = o(requireMinimal());
  multisig.protobufPackage = "cosmos.crypto.multisig.v1beta1";
  function y() {
    return { signatures: [] };
  }
  multisig.MultiSignature = {
    encode(F, M = c.default.Writer.create()) {
      for (const U of F.signatures)
        M.uint32(10).bytes(U);
      return M;
    },
    decode(F, M) {
      const U = F instanceof c.default.Reader ? F : new c.default.Reader(F);
      let L = M === void 0 ? U.len : U.pos + M;
      const H = y();
      for (; U.pos < L; ) {
        const fe = U.uint32();
        switch (fe >>> 3) {
          case 1:
            H.signatures.push(U.bytes());
            break;
          default:
            U.skipType(fe & 7);
            break;
        }
      }
      return H;
    },
    fromJSON(F) {
      return {
        signatures: Array.isArray(F == null ? void 0 : F.signatures) ? F.signatures.map((M) => B(M)) : []
      };
    },
    toJSON(F) {
      const M = {};
      return F.signatures ? M.signatures = F.signatures.map((U) => x(U !== void 0 ? U : new Uint8Array())) : M.signatures = [], M;
    },
    fromPartial(F) {
      var M;
      const U = y();
      return U.signatures = ((M = F.signatures) === null || M === void 0 ? void 0 : M.map((L) => L)) || [], U;
    }
  };
  function t() {
    return { extraBitsStored: 0, elems: new Uint8Array() };
  }
  multisig.CompactBitArray = {
    encode(F, M = c.default.Writer.create()) {
      return F.extraBitsStored !== 0 && M.uint32(8).uint32(F.extraBitsStored), F.elems.length !== 0 && M.uint32(18).bytes(F.elems), M;
    },
    decode(F, M) {
      const U = F instanceof c.default.Reader ? F : new c.default.Reader(F);
      let L = M === void 0 ? U.len : U.pos + M;
      const H = t();
      for (; U.pos < L; ) {
        const fe = U.uint32();
        switch (fe >>> 3) {
          case 1:
            H.extraBitsStored = U.uint32();
            break;
          case 2:
            H.elems = U.bytes();
            break;
          default:
            U.skipType(fe & 7);
            break;
        }
      }
      return H;
    },
    fromJSON(F) {
      return {
        extraBitsStored: v(F.extraBitsStored) ? Number(F.extraBitsStored) : 0,
        elems: v(F.elems) ? B(F.elems) : new Uint8Array()
      };
    },
    toJSON(F) {
      const M = {};
      return F.extraBitsStored !== void 0 && (M.extraBitsStored = Math.round(F.extraBitsStored)), F.elems !== void 0 && (M.elems = x(F.elems !== void 0 ? F.elems : new Uint8Array())), M;
    },
    fromPartial(F) {
      var M, U;
      const L = t();
      return L.extraBitsStored = (M = F.extraBitsStored) !== null && M !== void 0 ? M : 0, L.elems = (U = F.elems) !== null && U !== void 0 ? U : new Uint8Array(), L;
    }
  };
  var d = (() => {
    if (typeof d < "u")
      return d;
    if (typeof self < "u")
      return self;
    if (typeof window < "u")
      return window;
    if (typeof commonjsGlobal < "u")
      return commonjsGlobal;
    throw "Unable to locate global object";
  })();
  const E = d.atob || ((F) => d.Buffer.from(F, "base64").toString("binary"));
  function B(F) {
    const M = E(F), U = new Uint8Array(M.length);
    for (let L = 0; L < M.length; ++L)
      U[L] = M.charCodeAt(L);
    return U;
  }
  const D = d.btoa || ((F) => d.Buffer.from(F, "binary").toString("base64"));
  function x(F) {
    const M = [];
    for (const U of F)
      M.push(String.fromCharCode(U));
    return D(M.join(""));
  }
  c.default.util.Long !== g.default && (c.default.util.Long = g.default, c.default.configure());
  function v(F) {
    return F != null;
  }
  return multisig;
}
var hasRequiredSigning;
function requireSigning() {
  return hasRequiredSigning || (hasRequiredSigning = 1, function(o) {
    var g = signing && signing.__importDefault || function(ze) {
      return ze && ze.__esModule ? ze : { default: ze };
    };
    Object.defineProperty(o, "__esModule", { value: !0 }), o.SignatureDescriptor_Data_Multi = o.SignatureDescriptor_Data_Single = o.SignatureDescriptor_Data = o.SignatureDescriptor = o.SignatureDescriptors = o.signModeToJSON = o.signModeFromJSON = o.SignMode = o.protobufPackage = void 0;
    const c = g(requireLong()), y = g(requireMinimal()), t = requireAny(), d = requireMultisig();
    o.protobufPackage = "cosmos.tx.signing.v1beta1";
    var E;
    (function(ze) {
      ze[ze.SIGN_MODE_UNSPECIFIED = 0] = "SIGN_MODE_UNSPECIFIED", ze[ze.SIGN_MODE_DIRECT = 1] = "SIGN_MODE_DIRECT", ze[ze.SIGN_MODE_TEXTUAL = 2] = "SIGN_MODE_TEXTUAL", ze[ze.SIGN_MODE_DIRECT_AUX = 3] = "SIGN_MODE_DIRECT_AUX", ze[ze.SIGN_MODE_LEGACY_AMINO_JSON = 127] = "SIGN_MODE_LEGACY_AMINO_JSON", ze[ze.SIGN_MODE_EIP_191 = 191] = "SIGN_MODE_EIP_191", ze[ze.UNRECOGNIZED = -1] = "UNRECOGNIZED";
    })(E = o.SignMode || (o.SignMode = {}));
    function B(ze) {
      switch (ze) {
        case 0:
        case "SIGN_MODE_UNSPECIFIED":
          return E.SIGN_MODE_UNSPECIFIED;
        case 1:
        case "SIGN_MODE_DIRECT":
          return E.SIGN_MODE_DIRECT;
        case 2:
        case "SIGN_MODE_TEXTUAL":
          return E.SIGN_MODE_TEXTUAL;
        case 3:
        case "SIGN_MODE_DIRECT_AUX":
          return E.SIGN_MODE_DIRECT_AUX;
        case 127:
        case "SIGN_MODE_LEGACY_AMINO_JSON":
          return E.SIGN_MODE_LEGACY_AMINO_JSON;
        case 191:
        case "SIGN_MODE_EIP_191":
          return E.SIGN_MODE_EIP_191;
        case -1:
        case "UNRECOGNIZED":
        default:
          return E.UNRECOGNIZED;
      }
    }
    o.signModeFromJSON = B;
    function D(ze) {
      switch (ze) {
        case E.SIGN_MODE_UNSPECIFIED:
          return "SIGN_MODE_UNSPECIFIED";
        case E.SIGN_MODE_DIRECT:
          return "SIGN_MODE_DIRECT";
        case E.SIGN_MODE_TEXTUAL:
          return "SIGN_MODE_TEXTUAL";
        case E.SIGN_MODE_DIRECT_AUX:
          return "SIGN_MODE_DIRECT_AUX";
        case E.SIGN_MODE_LEGACY_AMINO_JSON:
          return "SIGN_MODE_LEGACY_AMINO_JSON";
        case E.SIGN_MODE_EIP_191:
          return "SIGN_MODE_EIP_191";
        default:
          return "UNKNOWN";
      }
    }
    o.signModeToJSON = D;
    function x() {
      return { signatures: [] };
    }
    o.SignatureDescriptors = {
      encode(ze, He = y.default.Writer.create()) {
        for (const Pe of ze.signatures)
          o.SignatureDescriptor.encode(Pe, He.uint32(10).fork()).ldelim();
        return He;
      },
      decode(ze, He) {
        const Pe = ze instanceof y.default.Reader ? ze : new y.default.Reader(ze);
        let De = He === void 0 ? Pe.len : Pe.pos + He;
        const ve = x();
        for (; Pe.pos < De; ) {
          const Fe = Pe.uint32();
          switch (Fe >>> 3) {
            case 1:
              ve.signatures.push(o.SignatureDescriptor.decode(Pe, Pe.uint32()));
              break;
            default:
              Pe.skipType(Fe & 7);
              break;
          }
        }
        return ve;
      },
      fromJSON(ze) {
        return {
          signatures: Array.isArray(ze == null ? void 0 : ze.signatures) ? ze.signatures.map((He) => o.SignatureDescriptor.fromJSON(He)) : []
        };
      },
      toJSON(ze) {
        const He = {};
        return ze.signatures ? He.signatures = ze.signatures.map((Pe) => Pe ? o.SignatureDescriptor.toJSON(Pe) : void 0) : He.signatures = [], He;
      },
      fromPartial(ze) {
        var He;
        const Pe = x();
        return Pe.signatures = ((He = ze.signatures) === null || He === void 0 ? void 0 : He.map((De) => o.SignatureDescriptor.fromPartial(De))) || [], Pe;
      }
    };
    function v() {
      return { publicKey: void 0, data: void 0, sequence: "0" };
    }
    o.SignatureDescriptor = {
      encode(ze, He = y.default.Writer.create()) {
        return ze.publicKey !== void 0 && t.Any.encode(ze.publicKey, He.uint32(10).fork()).ldelim(), ze.data !== void 0 && o.SignatureDescriptor_Data.encode(ze.data, He.uint32(18).fork()).ldelim(), ze.sequence !== "0" && He.uint32(24).uint64(ze.sequence), He;
      },
      decode(ze, He) {
        const Pe = ze instanceof y.default.Reader ? ze : new y.default.Reader(ze);
        let De = He === void 0 ? Pe.len : Pe.pos + He;
        const ve = v();
        for (; Pe.pos < De; ) {
          const Fe = Pe.uint32();
          switch (Fe >>> 3) {
            case 1:
              ve.publicKey = t.Any.decode(Pe, Pe.uint32());
              break;
            case 2:
              ve.data = o.SignatureDescriptor_Data.decode(Pe, Pe.uint32());
              break;
            case 3:
              ve.sequence = Ee(Pe.uint64());
              break;
            default:
              Pe.skipType(Fe & 7);
              break;
          }
        }
        return ve;
      },
      fromJSON(ze) {
        return {
          publicKey: Se(ze.publicKey) ? t.Any.fromJSON(ze.publicKey) : void 0,
          data: Se(ze.data) ? o.SignatureDescriptor_Data.fromJSON(ze.data) : void 0,
          sequence: Se(ze.sequence) ? String(ze.sequence) : "0"
        };
      },
      toJSON(ze) {
        const He = {};
        return ze.publicKey !== void 0 && (He.publicKey = ze.publicKey ? t.Any.toJSON(ze.publicKey) : void 0), ze.data !== void 0 && (He.data = ze.data ? o.SignatureDescriptor_Data.toJSON(ze.data) : void 0), ze.sequence !== void 0 && (He.sequence = ze.sequence), He;
      },
      fromPartial(ze) {
        var He;
        const Pe = v();
        return Pe.publicKey = ze.publicKey !== void 0 && ze.publicKey !== null ? t.Any.fromPartial(ze.publicKey) : void 0, Pe.data = ze.data !== void 0 && ze.data !== null ? o.SignatureDescriptor_Data.fromPartial(ze.data) : void 0, Pe.sequence = (He = ze.sequence) !== null && He !== void 0 ? He : "0", Pe;
      }
    };
    function F() {
      return { single: void 0, multi: void 0 };
    }
    o.SignatureDescriptor_Data = {
      encode(ze, He = y.default.Writer.create()) {
        return ze.single !== void 0 && o.SignatureDescriptor_Data_Single.encode(ze.single, He.uint32(10).fork()).ldelim(), ze.multi !== void 0 && o.SignatureDescriptor_Data_Multi.encode(ze.multi, He.uint32(18).fork()).ldelim(), He;
      },
      decode(ze, He) {
        const Pe = ze instanceof y.default.Reader ? ze : new y.default.Reader(ze);
        let De = He === void 0 ? Pe.len : Pe.pos + He;
        const ve = F();
        for (; Pe.pos < De; ) {
          const Fe = Pe.uint32();
          switch (Fe >>> 3) {
            case 1:
              ve.single = o.SignatureDescriptor_Data_Single.decode(Pe, Pe.uint32());
              break;
            case 2:
              ve.multi = o.SignatureDescriptor_Data_Multi.decode(Pe, Pe.uint32());
              break;
            default:
              Pe.skipType(Fe & 7);
              break;
          }
        }
        return ve;
      },
      fromJSON(ze) {
        return {
          single: Se(ze.single) ? o.SignatureDescriptor_Data_Single.fromJSON(ze.single) : void 0,
          multi: Se(ze.multi) ? o.SignatureDescriptor_Data_Multi.fromJSON(ze.multi) : void 0
        };
      },
      toJSON(ze) {
        const He = {};
        return ze.single !== void 0 && (He.single = ze.single ? o.SignatureDescriptor_Data_Single.toJSON(ze.single) : void 0), ze.multi !== void 0 && (He.multi = ze.multi ? o.SignatureDescriptor_Data_Multi.toJSON(ze.multi) : void 0), He;
      },
      fromPartial(ze) {
        const He = F();
        return He.single = ze.single !== void 0 && ze.single !== null ? o.SignatureDescriptor_Data_Single.fromPartial(ze.single) : void 0, He.multi = ze.multi !== void 0 && ze.multi !== null ? o.SignatureDescriptor_Data_Multi.fromPartial(ze.multi) : void 0, He;
      }
    };
    function M() {
      return { mode: 0, signature: new Uint8Array() };
    }
    o.SignatureDescriptor_Data_Single = {
      encode(ze, He = y.default.Writer.create()) {
        return ze.mode !== 0 && He.uint32(8).int32(ze.mode), ze.signature.length !== 0 && He.uint32(18).bytes(ze.signature), He;
      },
      decode(ze, He) {
        const Pe = ze instanceof y.default.Reader ? ze : new y.default.Reader(ze);
        let De = He === void 0 ? Pe.len : Pe.pos + He;
        const ve = M();
        for (; Pe.pos < De; ) {
          const Fe = Pe.uint32();
          switch (Fe >>> 3) {
            case 1:
              ve.mode = Pe.int32();
              break;
            case 2:
              ve.signature = Pe.bytes();
              break;
            default:
              Pe.skipType(Fe & 7);
              break;
          }
        }
        return ve;
      },
      fromJSON(ze) {
        return {
          mode: Se(ze.mode) ? B(ze.mode) : 0,
          signature: Se(ze.signature) ? fe(ze.signature) : new Uint8Array()
        };
      },
      toJSON(ze) {
        const He = {};
        return ze.mode !== void 0 && (He.mode = D(ze.mode)), ze.signature !== void 0 && (He.signature = Ie(ze.signature !== void 0 ? ze.signature : new Uint8Array())), He;
      },
      fromPartial(ze) {
        var He, Pe;
        const De = M();
        return De.mode = (He = ze.mode) !== null && He !== void 0 ? He : 0, De.signature = (Pe = ze.signature) !== null && Pe !== void 0 ? Pe : new Uint8Array(), De;
      }
    };
    function U() {
      return { bitarray: void 0, signatures: [] };
    }
    o.SignatureDescriptor_Data_Multi = {
      encode(ze, He = y.default.Writer.create()) {
        ze.bitarray !== void 0 && d.CompactBitArray.encode(ze.bitarray, He.uint32(10).fork()).ldelim();
        for (const Pe of ze.signatures)
          o.SignatureDescriptor_Data.encode(Pe, He.uint32(18).fork()).ldelim();
        return He;
      },
      decode(ze, He) {
        const Pe = ze instanceof y.default.Reader ? ze : new y.default.Reader(ze);
        let De = He === void 0 ? Pe.len : Pe.pos + He;
        const ve = U();
        for (; Pe.pos < De; ) {
          const Fe = Pe.uint32();
          switch (Fe >>> 3) {
            case 1:
              ve.bitarray = d.CompactBitArray.decode(Pe, Pe.uint32());
              break;
            case 2:
              ve.signatures.push(o.SignatureDescriptor_Data.decode(Pe, Pe.uint32()));
              break;
            default:
              Pe.skipType(Fe & 7);
              break;
          }
        }
        return ve;
      },
      fromJSON(ze) {
        return {
          bitarray: Se(ze.bitarray) ? d.CompactBitArray.fromJSON(ze.bitarray) : void 0,
          signatures: Array.isArray(ze == null ? void 0 : ze.signatures) ? ze.signatures.map((He) => o.SignatureDescriptor_Data.fromJSON(He)) : []
        };
      },
      toJSON(ze) {
        const He = {};
        return ze.bitarray !== void 0 && (He.bitarray = ze.bitarray ? d.CompactBitArray.toJSON(ze.bitarray) : void 0), ze.signatures ? He.signatures = ze.signatures.map((Pe) => Pe ? o.SignatureDescriptor_Data.toJSON(Pe) : void 0) : He.signatures = [], He;
      },
      fromPartial(ze) {
        var He;
        const Pe = U();
        return Pe.bitarray = ze.bitarray !== void 0 && ze.bitarray !== null ? d.CompactBitArray.fromPartial(ze.bitarray) : void 0, Pe.signatures = ((He = ze.signatures) === null || He === void 0 ? void 0 : He.map((De) => o.SignatureDescriptor_Data.fromPartial(De))) || [], Pe;
      }
    };
    var L = (() => {
      if (typeof L < "u")
        return L;
      if (typeof self < "u")
        return self;
      if (typeof window < "u")
        return window;
      if (typeof commonjsGlobal < "u")
        return commonjsGlobal;
      throw "Unable to locate global object";
    })();
    const H = L.atob || ((ze) => L.Buffer.from(ze, "base64").toString("binary"));
    function fe(ze) {
      const He = H(ze), Pe = new Uint8Array(He.length);
      for (let De = 0; De < He.length; ++De)
        Pe[De] = He.charCodeAt(De);
      return Pe;
    }
    const ge = L.btoa || ((ze) => L.Buffer.from(ze, "binary").toString("base64"));
    function Ie(ze) {
      const He = [];
      for (const Pe of ze)
        He.push(String.fromCharCode(Pe));
      return ge(He.join(""));
    }
    function Ee(ze) {
      return ze.toString();
    }
    y.default.util.Long !== c.default && (y.default.util.Long = c.default, y.default.configure());
    function Se(ze) {
      return ze != null;
    }
  }(signing)), signing;
}
var coin = {}, hasRequiredCoin;
function requireCoin() {
  if (hasRequiredCoin) return coin;
  hasRequiredCoin = 1;
  var o = coin && coin.__importDefault || function(D) {
    return D && D.__esModule ? D : { default: D };
  };
  Object.defineProperty(coin, "__esModule", { value: !0 }), coin.DecProto = coin.IntProto = coin.DecCoin = coin.Coin = coin.protobufPackage = void 0;
  const g = o(requireLong()), c = o(requireMinimal());
  coin.protobufPackage = "cosmos.base.v1beta1";
  function y() {
    return { denom: "", amount: "" };
  }
  coin.Coin = {
    encode(D, x = c.default.Writer.create()) {
      return D.denom !== "" && x.uint32(10).string(D.denom), D.amount !== "" && x.uint32(18).string(D.amount), x;
    },
    decode(D, x) {
      const v = D instanceof c.default.Reader ? D : new c.default.Reader(D);
      let F = x === void 0 ? v.len : v.pos + x;
      const M = y();
      for (; v.pos < F; ) {
        const U = v.uint32();
        switch (U >>> 3) {
          case 1:
            M.denom = v.string();
            break;
          case 2:
            M.amount = v.string();
            break;
          default:
            v.skipType(U & 7);
            break;
        }
      }
      return M;
    },
    fromJSON(D) {
      return {
        denom: B(D.denom) ? String(D.denom) : "",
        amount: B(D.amount) ? String(D.amount) : ""
      };
    },
    toJSON(D) {
      const x = {};
      return D.denom !== void 0 && (x.denom = D.denom), D.amount !== void 0 && (x.amount = D.amount), x;
    },
    fromPartial(D) {
      var x, v;
      const F = y();
      return F.denom = (x = D.denom) !== null && x !== void 0 ? x : "", F.amount = (v = D.amount) !== null && v !== void 0 ? v : "", F;
    }
  };
  function t() {
    return { denom: "", amount: "" };
  }
  coin.DecCoin = {
    encode(D, x = c.default.Writer.create()) {
      return D.denom !== "" && x.uint32(10).string(D.denom), D.amount !== "" && x.uint32(18).string(D.amount), x;
    },
    decode(D, x) {
      const v = D instanceof c.default.Reader ? D : new c.default.Reader(D);
      let F = x === void 0 ? v.len : v.pos + x;
      const M = t();
      for (; v.pos < F; ) {
        const U = v.uint32();
        switch (U >>> 3) {
          case 1:
            M.denom = v.string();
            break;
          case 2:
            M.amount = v.string();
            break;
          default:
            v.skipType(U & 7);
            break;
        }
      }
      return M;
    },
    fromJSON(D) {
      return {
        denom: B(D.denom) ? String(D.denom) : "",
        amount: B(D.amount) ? String(D.amount) : ""
      };
    },
    toJSON(D) {
      const x = {};
      return D.denom !== void 0 && (x.denom = D.denom), D.amount !== void 0 && (x.amount = D.amount), x;
    },
    fromPartial(D) {
      var x, v;
      const F = t();
      return F.denom = (x = D.denom) !== null && x !== void 0 ? x : "", F.amount = (v = D.amount) !== null && v !== void 0 ? v : "", F;
    }
  };
  function d() {
    return { int: "" };
  }
  coin.IntProto = {
    encode(D, x = c.default.Writer.create()) {
      return D.int !== "" && x.uint32(10).string(D.int), x;
    },
    decode(D, x) {
      const v = D instanceof c.default.Reader ? D : new c.default.Reader(D);
      let F = x === void 0 ? v.len : v.pos + x;
      const M = d();
      for (; v.pos < F; ) {
        const U = v.uint32();
        switch (U >>> 3) {
          case 1:
            M.int = v.string();
            break;
          default:
            v.skipType(U & 7);
            break;
        }
      }
      return M;
    },
    fromJSON(D) {
      return {
        int: B(D.int) ? String(D.int) : ""
      };
    },
    toJSON(D) {
      const x = {};
      return D.int !== void 0 && (x.int = D.int), x;
    },
    fromPartial(D) {
      var x;
      const v = d();
      return v.int = (x = D.int) !== null && x !== void 0 ? x : "", v;
    }
  };
  function E() {
    return { dec: "" };
  }
  coin.DecProto = {
    encode(D, x = c.default.Writer.create()) {
      return D.dec !== "" && x.uint32(10).string(D.dec), x;
    },
    decode(D, x) {
      const v = D instanceof c.default.Reader ? D : new c.default.Reader(D);
      let F = x === void 0 ? v.len : v.pos + x;
      const M = E();
      for (; v.pos < F; ) {
        const U = v.uint32();
        switch (U >>> 3) {
          case 1:
            M.dec = v.string();
            break;
          default:
            v.skipType(U & 7);
            break;
        }
      }
      return M;
    },
    fromJSON(D) {
      return {
        dec: B(D.dec) ? String(D.dec) : ""
      };
    },
    toJSON(D) {
      const x = {};
      return D.dec !== void 0 && (x.dec = D.dec), x;
    },
    fromPartial(D) {
      var x;
      const v = E();
      return v.dec = (x = D.dec) !== null && x !== void 0 ? x : "", v;
    }
  }, c.default.util.Long !== g.default && (c.default.util.Long = g.default, c.default.configure());
  function B(D) {
    return D != null;
  }
  return coin;
}
var hasRequiredTx;
function requireTx() {
  return hasRequiredTx || (hasRequiredTx = 1, function(o) {
    var g = tx && tx.__importDefault || function(be) {
      return be && be.__esModule ? be : { default: be };
    };
    Object.defineProperty(o, "__esModule", { value: !0 }), o.AuxSignerData = o.Fee = o.ModeInfo_Multi = o.ModeInfo_Single = o.ModeInfo = o.SignerInfo = o.AuthInfo = o.TxBody = o.SignDocDirectAux = o.SignDoc = o.TxRaw = o.Tx = o.protobufPackage = void 0;
    const c = g(requireLong()), y = g(requireMinimal()), t = requireSigning(), d = requireAny(), E = requireMultisig(), B = requireCoin();
    o.protobufPackage = "cosmos.tx.v1beta1";
    function D() {
      return { body: void 0, authInfo: void 0, signatures: [] };
    }
    o.Tx = {
      encode(be, Be = y.default.Writer.create()) {
        be.body !== void 0 && o.TxBody.encode(be.body, Be.uint32(10).fork()).ldelim(), be.authInfo !== void 0 && o.AuthInfo.encode(be.authInfo, Be.uint32(18).fork()).ldelim();
        for (const ke of be.signatures)
          Be.uint32(26).bytes(ke);
        return Be;
      },
      decode(be, Be) {
        const ke = be instanceof y.default.Reader ? be : new y.default.Reader(be);
        let xe = Be === void 0 ? ke.len : ke.pos + Be;
        const Ne = D();
        for (; ke.pos < xe; ) {
          const Et = ke.uint32();
          switch (Et >>> 3) {
            case 1:
              Ne.body = o.TxBody.decode(ke, ke.uint32());
              break;
            case 2:
              Ne.authInfo = o.AuthInfo.decode(ke, ke.uint32());
              break;
            case 3:
              Ne.signatures.push(ke.bytes());
              break;
            default:
              ke.skipType(Et & 7);
              break;
          }
        }
        return Ne;
      },
      fromJSON(be) {
        return {
          body: Fe(be.body) ? o.TxBody.fromJSON(be.body) : void 0,
          authInfo: Fe(be.authInfo) ? o.AuthInfo.fromJSON(be.authInfo) : void 0,
          signatures: Array.isArray(be == null ? void 0 : be.signatures) ? be.signatures.map((Be) => He(Be)) : []
        };
      },
      toJSON(be) {
        const Be = {};
        return be.body !== void 0 && (Be.body = be.body ? o.TxBody.toJSON(be.body) : void 0), be.authInfo !== void 0 && (Be.authInfo = be.authInfo ? o.AuthInfo.toJSON(be.authInfo) : void 0), be.signatures ? Be.signatures = be.signatures.map((ke) => De(ke !== void 0 ? ke : new Uint8Array())) : Be.signatures = [], Be;
      },
      fromPartial(be) {
        var Be;
        const ke = D();
        return ke.body = be.body !== void 0 && be.body !== null ? o.TxBody.fromPartial(be.body) : void 0, ke.authInfo = be.authInfo !== void 0 && be.authInfo !== null ? o.AuthInfo.fromPartial(be.authInfo) : void 0, ke.signatures = ((Be = be.signatures) === null || Be === void 0 ? void 0 : Be.map((xe) => xe)) || [], ke;
      }
    };
    function x() {
      return {
        bodyBytes: new Uint8Array(),
        authInfoBytes: new Uint8Array(),
        signatures: []
      };
    }
    o.TxRaw = {
      encode(be, Be = y.default.Writer.create()) {
        be.bodyBytes.length !== 0 && Be.uint32(10).bytes(be.bodyBytes), be.authInfoBytes.length !== 0 && Be.uint32(18).bytes(be.authInfoBytes);
        for (const ke of be.signatures)
          Be.uint32(26).bytes(ke);
        return Be;
      },
      decode(be, Be) {
        const ke = be instanceof y.default.Reader ? be : new y.default.Reader(be);
        let xe = Be === void 0 ? ke.len : ke.pos + Be;
        const Ne = x();
        for (; ke.pos < xe; ) {
          const Et = ke.uint32();
          switch (Et >>> 3) {
            case 1:
              Ne.bodyBytes = ke.bytes();
              break;
            case 2:
              Ne.authInfoBytes = ke.bytes();
              break;
            case 3:
              Ne.signatures.push(ke.bytes());
              break;
            default:
              ke.skipType(Et & 7);
              break;
          }
        }
        return Ne;
      },
      fromJSON(be) {
        return {
          bodyBytes: Fe(be.bodyBytes) ? He(be.bodyBytes) : new Uint8Array(),
          authInfoBytes: Fe(be.authInfoBytes) ? He(be.authInfoBytes) : new Uint8Array(),
          signatures: Array.isArray(be == null ? void 0 : be.signatures) ? be.signatures.map((Be) => He(Be)) : []
        };
      },
      toJSON(be) {
        const Be = {};
        return be.bodyBytes !== void 0 && (Be.bodyBytes = De(be.bodyBytes !== void 0 ? be.bodyBytes : new Uint8Array())), be.authInfoBytes !== void 0 && (Be.authInfoBytes = De(be.authInfoBytes !== void 0 ? be.authInfoBytes : new Uint8Array())), be.signatures ? Be.signatures = be.signatures.map((ke) => De(ke !== void 0 ? ke : new Uint8Array())) : Be.signatures = [], Be;
      },
      fromPartial(be) {
        var Be, ke, xe;
        const Ne = x();
        return Ne.bodyBytes = (Be = be.bodyBytes) !== null && Be !== void 0 ? Be : new Uint8Array(), Ne.authInfoBytes = (ke = be.authInfoBytes) !== null && ke !== void 0 ? ke : new Uint8Array(), Ne.signatures = ((xe = be.signatures) === null || xe === void 0 ? void 0 : xe.map((Et) => Et)) || [], Ne;
      }
    };
    function v() {
      return {
        bodyBytes: new Uint8Array(),
        authInfoBytes: new Uint8Array(),
        chainId: "",
        accountNumber: "0"
      };
    }
    o.SignDoc = {
      encode(be, Be = y.default.Writer.create()) {
        return be.bodyBytes.length !== 0 && Be.uint32(10).bytes(be.bodyBytes), be.authInfoBytes.length !== 0 && Be.uint32(18).bytes(be.authInfoBytes), be.chainId !== "" && Be.uint32(26).string(be.chainId), be.accountNumber !== "0" && Be.uint32(32).uint64(be.accountNumber), Be;
      },
      decode(be, Be) {
        const ke = be instanceof y.default.Reader ? be : new y.default.Reader(be);
        let xe = Be === void 0 ? ke.len : ke.pos + Be;
        const Ne = v();
        for (; ke.pos < xe; ) {
          const Et = ke.uint32();
          switch (Et >>> 3) {
            case 1:
              Ne.bodyBytes = ke.bytes();
              break;
            case 2:
              Ne.authInfoBytes = ke.bytes();
              break;
            case 3:
              Ne.chainId = ke.string();
              break;
            case 4:
              Ne.accountNumber = ve(ke.uint64());
              break;
            default:
              ke.skipType(Et & 7);
              break;
          }
        }
        return Ne;
      },
      fromJSON(be) {
        return {
          bodyBytes: Fe(be.bodyBytes) ? He(be.bodyBytes) : new Uint8Array(),
          authInfoBytes: Fe(be.authInfoBytes) ? He(be.authInfoBytes) : new Uint8Array(),
          chainId: Fe(be.chainId) ? String(be.chainId) : "",
          accountNumber: Fe(be.accountNumber) ? String(be.accountNumber) : "0"
        };
      },
      toJSON(be) {
        const Be = {};
        return be.bodyBytes !== void 0 && (Be.bodyBytes = De(be.bodyBytes !== void 0 ? be.bodyBytes : new Uint8Array())), be.authInfoBytes !== void 0 && (Be.authInfoBytes = De(be.authInfoBytes !== void 0 ? be.authInfoBytes : new Uint8Array())), be.chainId !== void 0 && (Be.chainId = be.chainId), be.accountNumber !== void 0 && (Be.accountNumber = be.accountNumber), Be;
      },
      fromPartial(be) {
        var Be, ke, xe, Ne;
        const Et = v();
        return Et.bodyBytes = (Be = be.bodyBytes) !== null && Be !== void 0 ? Be : new Uint8Array(), Et.authInfoBytes = (ke = be.authInfoBytes) !== null && ke !== void 0 ? ke : new Uint8Array(), Et.chainId = (xe = be.chainId) !== null && xe !== void 0 ? xe : "", Et.accountNumber = (Ne = be.accountNumber) !== null && Ne !== void 0 ? Ne : "0", Et;
      }
    };
    function F() {
      return {
        bodyBytes: new Uint8Array(),
        publicKey: void 0,
        chainId: "",
        accountNumber: "0",
        sequence: "0"
      };
    }
    o.SignDocDirectAux = {
      encode(be, Be = y.default.Writer.create()) {
        return be.bodyBytes.length !== 0 && Be.uint32(10).bytes(be.bodyBytes), be.publicKey !== void 0 && d.Any.encode(be.publicKey, Be.uint32(18).fork()).ldelim(), be.chainId !== "" && Be.uint32(26).string(be.chainId), be.accountNumber !== "0" && Be.uint32(32).uint64(be.accountNumber), be.sequence !== "0" && Be.uint32(40).uint64(be.sequence), Be;
      },
      decode(be, Be) {
        const ke = be instanceof y.default.Reader ? be : new y.default.Reader(be);
        let xe = Be === void 0 ? ke.len : ke.pos + Be;
        const Ne = F();
        for (; ke.pos < xe; ) {
          const Et = ke.uint32();
          switch (Et >>> 3) {
            case 1:
              Ne.bodyBytes = ke.bytes();
              break;
            case 2:
              Ne.publicKey = d.Any.decode(ke, ke.uint32());
              break;
            case 3:
              Ne.chainId = ke.string();
              break;
            case 4:
              Ne.accountNumber = ve(ke.uint64());
              break;
            case 5:
              Ne.sequence = ve(ke.uint64());
              break;
            default:
              ke.skipType(Et & 7);
              break;
          }
        }
        return Ne;
      },
      fromJSON(be) {
        return {
          bodyBytes: Fe(be.bodyBytes) ? He(be.bodyBytes) : new Uint8Array(),
          publicKey: Fe(be.publicKey) ? d.Any.fromJSON(be.publicKey) : void 0,
          chainId: Fe(be.chainId) ? String(be.chainId) : "",
          accountNumber: Fe(be.accountNumber) ? String(be.accountNumber) : "0",
          sequence: Fe(be.sequence) ? String(be.sequence) : "0"
        };
      },
      toJSON(be) {
        const Be = {};
        return be.bodyBytes !== void 0 && (Be.bodyBytes = De(be.bodyBytes !== void 0 ? be.bodyBytes : new Uint8Array())), be.publicKey !== void 0 && (Be.publicKey = be.publicKey ? d.Any.toJSON(be.publicKey) : void 0), be.chainId !== void 0 && (Be.chainId = be.chainId), be.accountNumber !== void 0 && (Be.accountNumber = be.accountNumber), be.sequence !== void 0 && (Be.sequence = be.sequence), Be;
      },
      fromPartial(be) {
        var Be, ke, xe, Ne;
        const Et = F();
        return Et.bodyBytes = (Be = be.bodyBytes) !== null && Be !== void 0 ? Be : new Uint8Array(), Et.publicKey = be.publicKey !== void 0 && be.publicKey !== null ? d.Any.fromPartial(be.publicKey) : void 0, Et.chainId = (ke = be.chainId) !== null && ke !== void 0 ? ke : "", Et.accountNumber = (xe = be.accountNumber) !== null && xe !== void 0 ? xe : "0", Et.sequence = (Ne = be.sequence) !== null && Ne !== void 0 ? Ne : "0", Et;
      }
    };
    function M() {
      return {
        messages: [],
        memo: "",
        timeoutHeight: "0",
        extensionOptions: [],
        nonCriticalExtensionOptions: []
      };
    }
    o.TxBody = {
      encode(be, Be = y.default.Writer.create()) {
        for (const ke of be.messages)
          d.Any.encode(ke, Be.uint32(10).fork()).ldelim();
        be.memo !== "" && Be.uint32(18).string(be.memo), be.timeoutHeight !== "0" && Be.uint32(24).uint64(be.timeoutHeight);
        for (const ke of be.extensionOptions)
          d.Any.encode(ke, Be.uint32(8186).fork()).ldelim();
        for (const ke of be.nonCriticalExtensionOptions)
          d.Any.encode(ke, Be.uint32(16378).fork()).ldelim();
        return Be;
      },
      decode(be, Be) {
        const ke = be instanceof y.default.Reader ? be : new y.default.Reader(be);
        let xe = Be === void 0 ? ke.len : ke.pos + Be;
        const Ne = M();
        for (; ke.pos < xe; ) {
          const Et = ke.uint32();
          switch (Et >>> 3) {
            case 1:
              Ne.messages.push(d.Any.decode(ke, ke.uint32()));
              break;
            case 2:
              Ne.memo = ke.string();
              break;
            case 3:
              Ne.timeoutHeight = ve(ke.uint64());
              break;
            case 1023:
              Ne.extensionOptions.push(d.Any.decode(ke, ke.uint32()));
              break;
            case 2047:
              Ne.nonCriticalExtensionOptions.push(d.Any.decode(ke, ke.uint32()));
              break;
            default:
              ke.skipType(Et & 7);
              break;
          }
        }
        return Ne;
      },
      fromJSON(be) {
        return {
          messages: Array.isArray(be == null ? void 0 : be.messages) ? be.messages.map((Be) => d.Any.fromJSON(Be)) : [],
          memo: Fe(be.memo) ? String(be.memo) : "",
          timeoutHeight: Fe(be.timeoutHeight) ? String(be.timeoutHeight) : "0",
          extensionOptions: Array.isArray(be == null ? void 0 : be.extensionOptions) ? be.extensionOptions.map((Be) => d.Any.fromJSON(Be)) : [],
          nonCriticalExtensionOptions: Array.isArray(be == null ? void 0 : be.nonCriticalExtensionOptions) ? be.nonCriticalExtensionOptions.map((Be) => d.Any.fromJSON(Be)) : []
        };
      },
      toJSON(be) {
        const Be = {};
        return be.messages ? Be.messages = be.messages.map((ke) => ke ? d.Any.toJSON(ke) : void 0) : Be.messages = [], be.memo !== void 0 && (Be.memo = be.memo), be.timeoutHeight !== void 0 && (Be.timeoutHeight = be.timeoutHeight), be.extensionOptions ? Be.extensionOptions = be.extensionOptions.map((ke) => ke ? d.Any.toJSON(ke) : void 0) : Be.extensionOptions = [], be.nonCriticalExtensionOptions ? Be.nonCriticalExtensionOptions = be.nonCriticalExtensionOptions.map((ke) => ke ? d.Any.toJSON(ke) : void 0) : Be.nonCriticalExtensionOptions = [], Be;
      },
      fromPartial(be) {
        var Be, ke, xe, Ne, Et;
        const st = M();
        return st.messages = ((Be = be.messages) === null || Be === void 0 ? void 0 : Be.map((Dt) => d.Any.fromPartial(Dt))) || [], st.memo = (ke = be.memo) !== null && ke !== void 0 ? ke : "", st.timeoutHeight = (xe = be.timeoutHeight) !== null && xe !== void 0 ? xe : "0", st.extensionOptions = ((Ne = be.extensionOptions) === null || Ne === void 0 ? void 0 : Ne.map((Dt) => d.Any.fromPartial(Dt))) || [], st.nonCriticalExtensionOptions = ((Et = be.nonCriticalExtensionOptions) === null || Et === void 0 ? void 0 : Et.map((Dt) => d.Any.fromPartial(Dt))) || [], st;
      }
    };
    function U() {
      return { signerInfos: [], fee: void 0 };
    }
    o.AuthInfo = {
      encode(be, Be = y.default.Writer.create()) {
        for (const ke of be.signerInfos)
          o.SignerInfo.encode(ke, Be.uint32(10).fork()).ldelim();
        return be.fee !== void 0 && o.Fee.encode(be.fee, Be.uint32(18).fork()).ldelim(), Be;
      },
      decode(be, Be) {
        const ke = be instanceof y.default.Reader ? be : new y.default.Reader(be);
        let xe = Be === void 0 ? ke.len : ke.pos + Be;
        const Ne = U();
        for (; ke.pos < xe; ) {
          const Et = ke.uint32();
          switch (Et >>> 3) {
            case 1:
              Ne.signerInfos.push(o.SignerInfo.decode(ke, ke.uint32()));
              break;
            case 2:
              Ne.fee = o.Fee.decode(ke, ke.uint32());
              break;
            default:
              ke.skipType(Et & 7);
              break;
          }
        }
        return Ne;
      },
      fromJSON(be) {
        return {
          signerInfos: Array.isArray(be == null ? void 0 : be.signerInfos) ? be.signerInfos.map((Be) => o.SignerInfo.fromJSON(Be)) : [],
          fee: Fe(be.fee) ? o.Fee.fromJSON(be.fee) : void 0
        };
      },
      toJSON(be) {
        const Be = {};
        return be.signerInfos ? Be.signerInfos = be.signerInfos.map((ke) => ke ? o.SignerInfo.toJSON(ke) : void 0) : Be.signerInfos = [], be.fee !== void 0 && (Be.fee = be.fee ? o.Fee.toJSON(be.fee) : void 0), Be;
      },
      fromPartial(be) {
        var Be;
        const ke = U();
        return ke.signerInfos = ((Be = be.signerInfos) === null || Be === void 0 ? void 0 : Be.map((xe) => o.SignerInfo.fromPartial(xe))) || [], ke.fee = be.fee !== void 0 && be.fee !== null ? o.Fee.fromPartial(be.fee) : void 0, ke;
      }
    };
    function L() {
      return { publicKey: void 0, modeInfo: void 0, sequence: "0" };
    }
    o.SignerInfo = {
      encode(be, Be = y.default.Writer.create()) {
        return be.publicKey !== void 0 && d.Any.encode(be.publicKey, Be.uint32(10).fork()).ldelim(), be.modeInfo !== void 0 && o.ModeInfo.encode(be.modeInfo, Be.uint32(18).fork()).ldelim(), be.sequence !== "0" && Be.uint32(24).uint64(be.sequence), Be;
      },
      decode(be, Be) {
        const ke = be instanceof y.default.Reader ? be : new y.default.Reader(be);
        let xe = Be === void 0 ? ke.len : ke.pos + Be;
        const Ne = L();
        for (; ke.pos < xe; ) {
          const Et = ke.uint32();
          switch (Et >>> 3) {
            case 1:
              Ne.publicKey = d.Any.decode(ke, ke.uint32());
              break;
            case 2:
              Ne.modeInfo = o.ModeInfo.decode(ke, ke.uint32());
              break;
            case 3:
              Ne.sequence = ve(ke.uint64());
              break;
            default:
              ke.skipType(Et & 7);
              break;
          }
        }
        return Ne;
      },
      fromJSON(be) {
        return {
          publicKey: Fe(be.publicKey) ? d.Any.fromJSON(be.publicKey) : void 0,
          modeInfo: Fe(be.modeInfo) ? o.ModeInfo.fromJSON(be.modeInfo) : void 0,
          sequence: Fe(be.sequence) ? String(be.sequence) : "0"
        };
      },
      toJSON(be) {
        const Be = {};
        return be.publicKey !== void 0 && (Be.publicKey = be.publicKey ? d.Any.toJSON(be.publicKey) : void 0), be.modeInfo !== void 0 && (Be.modeInfo = be.modeInfo ? o.ModeInfo.toJSON(be.modeInfo) : void 0), be.sequence !== void 0 && (Be.sequence = be.sequence), Be;
      },
      fromPartial(be) {
        var Be;
        const ke = L();
        return ke.publicKey = be.publicKey !== void 0 && be.publicKey !== null ? d.Any.fromPartial(be.publicKey) : void 0, ke.modeInfo = be.modeInfo !== void 0 && be.modeInfo !== null ? o.ModeInfo.fromPartial(be.modeInfo) : void 0, ke.sequence = (Be = be.sequence) !== null && Be !== void 0 ? Be : "0", ke;
      }
    };
    function H() {
      return { single: void 0, multi: void 0 };
    }
    o.ModeInfo = {
      encode(be, Be = y.default.Writer.create()) {
        return be.single !== void 0 && o.ModeInfo_Single.encode(be.single, Be.uint32(10).fork()).ldelim(), be.multi !== void 0 && o.ModeInfo_Multi.encode(be.multi, Be.uint32(18).fork()).ldelim(), Be;
      },
      decode(be, Be) {
        const ke = be instanceof y.default.Reader ? be : new y.default.Reader(be);
        let xe = Be === void 0 ? ke.len : ke.pos + Be;
        const Ne = H();
        for (; ke.pos < xe; ) {
          const Et = ke.uint32();
          switch (Et >>> 3) {
            case 1:
              Ne.single = o.ModeInfo_Single.decode(ke, ke.uint32());
              break;
            case 2:
              Ne.multi = o.ModeInfo_Multi.decode(ke, ke.uint32());
              break;
            default:
              ke.skipType(Et & 7);
              break;
          }
        }
        return Ne;
      },
      fromJSON(be) {
        return {
          single: Fe(be.single) ? o.ModeInfo_Single.fromJSON(be.single) : void 0,
          multi: Fe(be.multi) ? o.ModeInfo_Multi.fromJSON(be.multi) : void 0
        };
      },
      toJSON(be) {
        const Be = {};
        return be.single !== void 0 && (Be.single = be.single ? o.ModeInfo_Single.toJSON(be.single) : void 0), be.multi !== void 0 && (Be.multi = be.multi ? o.ModeInfo_Multi.toJSON(be.multi) : void 0), Be;
      },
      fromPartial(be) {
        const Be = H();
        return Be.single = be.single !== void 0 && be.single !== null ? o.ModeInfo_Single.fromPartial(be.single) : void 0, Be.multi = be.multi !== void 0 && be.multi !== null ? o.ModeInfo_Multi.fromPartial(be.multi) : void 0, Be;
      }
    };
    function fe() {
      return { mode: 0 };
    }
    o.ModeInfo_Single = {
      encode(be, Be = y.default.Writer.create()) {
        return be.mode !== 0 && Be.uint32(8).int32(be.mode), Be;
      },
      decode(be, Be) {
        const ke = be instanceof y.default.Reader ? be : new y.default.Reader(be);
        let xe = Be === void 0 ? ke.len : ke.pos + Be;
        const Ne = fe();
        for (; ke.pos < xe; ) {
          const Et = ke.uint32();
          switch (Et >>> 3) {
            case 1:
              Ne.mode = ke.int32();
              break;
            default:
              ke.skipType(Et & 7);
              break;
          }
        }
        return Ne;
      },
      fromJSON(be) {
        return {
          mode: Fe(be.mode) ? (0, t.signModeFromJSON)(be.mode) : 0
        };
      },
      toJSON(be) {
        const Be = {};
        return be.mode !== void 0 && (Be.mode = (0, t.signModeToJSON)(be.mode)), Be;
      },
      fromPartial(be) {
        var Be;
        const ke = fe();
        return ke.mode = (Be = be.mode) !== null && Be !== void 0 ? Be : 0, ke;
      }
    };
    function ge() {
      return { bitarray: void 0, modeInfos: [] };
    }
    o.ModeInfo_Multi = {
      encode(be, Be = y.default.Writer.create()) {
        be.bitarray !== void 0 && E.CompactBitArray.encode(be.bitarray, Be.uint32(10).fork()).ldelim();
        for (const ke of be.modeInfos)
          o.ModeInfo.encode(ke, Be.uint32(18).fork()).ldelim();
        return Be;
      },
      decode(be, Be) {
        const ke = be instanceof y.default.Reader ? be : new y.default.Reader(be);
        let xe = Be === void 0 ? ke.len : ke.pos + Be;
        const Ne = ge();
        for (; ke.pos < xe; ) {
          const Et = ke.uint32();
          switch (Et >>> 3) {
            case 1:
              Ne.bitarray = E.CompactBitArray.decode(ke, ke.uint32());
              break;
            case 2:
              Ne.modeInfos.push(o.ModeInfo.decode(ke, ke.uint32()));
              break;
            default:
              ke.skipType(Et & 7);
              break;
          }
        }
        return Ne;
      },
      fromJSON(be) {
        return {
          bitarray: Fe(be.bitarray) ? E.CompactBitArray.fromJSON(be.bitarray) : void 0,
          modeInfos: Array.isArray(be == null ? void 0 : be.modeInfos) ? be.modeInfos.map((Be) => o.ModeInfo.fromJSON(Be)) : []
        };
      },
      toJSON(be) {
        const Be = {};
        return be.bitarray !== void 0 && (Be.bitarray = be.bitarray ? E.CompactBitArray.toJSON(be.bitarray) : void 0), be.modeInfos ? Be.modeInfos = be.modeInfos.map((ke) => ke ? o.ModeInfo.toJSON(ke) : void 0) : Be.modeInfos = [], Be;
      },
      fromPartial(be) {
        var Be;
        const ke = ge();
        return ke.bitarray = be.bitarray !== void 0 && be.bitarray !== null ? E.CompactBitArray.fromPartial(be.bitarray) : void 0, ke.modeInfos = ((Be = be.modeInfos) === null || Be === void 0 ? void 0 : Be.map((xe) => o.ModeInfo.fromPartial(xe))) || [], ke;
      }
    };
    function Ie() {
      return { amount: [], gasLimit: "0", payer: "", granter: "" };
    }
    o.Fee = {
      encode(be, Be = y.default.Writer.create()) {
        for (const ke of be.amount)
          B.Coin.encode(ke, Be.uint32(10).fork()).ldelim();
        return be.gasLimit !== "0" && Be.uint32(16).uint64(be.gasLimit), be.payer !== "" && Be.uint32(26).string(be.payer), be.granter !== "" && Be.uint32(34).string(be.granter), Be;
      },
      decode(be, Be) {
        const ke = be instanceof y.default.Reader ? be : new y.default.Reader(be);
        let xe = Be === void 0 ? ke.len : ke.pos + Be;
        const Ne = Ie();
        for (; ke.pos < xe; ) {
          const Et = ke.uint32();
          switch (Et >>> 3) {
            case 1:
              Ne.amount.push(B.Coin.decode(ke, ke.uint32()));
              break;
            case 2:
              Ne.gasLimit = ve(ke.uint64());
              break;
            case 3:
              Ne.payer = ke.string();
              break;
            case 4:
              Ne.granter = ke.string();
              break;
            default:
              ke.skipType(Et & 7);
              break;
          }
        }
        return Ne;
      },
      fromJSON(be) {
        return {
          amount: Array.isArray(be == null ? void 0 : be.amount) ? be.amount.map((Be) => B.Coin.fromJSON(Be)) : [],
          gasLimit: Fe(be.gasLimit) ? String(be.gasLimit) : "0",
          payer: Fe(be.payer) ? String(be.payer) : "",
          granter: Fe(be.granter) ? String(be.granter) : ""
        };
      },
      toJSON(be) {
        const Be = {};
        return be.amount ? Be.amount = be.amount.map((ke) => ke ? B.Coin.toJSON(ke) : void 0) : Be.amount = [], be.gasLimit !== void 0 && (Be.gasLimit = be.gasLimit), be.payer !== void 0 && (Be.payer = be.payer), be.granter !== void 0 && (Be.granter = be.granter), Be;
      },
      fromPartial(be) {
        var Be, ke, xe, Ne;
        const Et = Ie();
        return Et.amount = ((Be = be.amount) === null || Be === void 0 ? void 0 : Be.map((st) => B.Coin.fromPartial(st))) || [], Et.gasLimit = (ke = be.gasLimit) !== null && ke !== void 0 ? ke : "0", Et.payer = (xe = be.payer) !== null && xe !== void 0 ? xe : "", Et.granter = (Ne = be.granter) !== null && Ne !== void 0 ? Ne : "", Et;
      }
    };
    function Ee() {
      return { address: "", signDoc: void 0, mode: 0, sig: new Uint8Array() };
    }
    o.AuxSignerData = {
      encode(be, Be = y.default.Writer.create()) {
        return be.address !== "" && Be.uint32(10).string(be.address), be.signDoc !== void 0 && o.SignDocDirectAux.encode(be.signDoc, Be.uint32(18).fork()).ldelim(), be.mode !== 0 && Be.uint32(24).int32(be.mode), be.sig.length !== 0 && Be.uint32(34).bytes(be.sig), Be;
      },
      decode(be, Be) {
        const ke = be instanceof y.default.Reader ? be : new y.default.Reader(be);
        let xe = Be === void 0 ? ke.len : ke.pos + Be;
        const Ne = Ee();
        for (; ke.pos < xe; ) {
          const Et = ke.uint32();
          switch (Et >>> 3) {
            case 1:
              Ne.address = ke.string();
              break;
            case 2:
              Ne.signDoc = o.SignDocDirectAux.decode(ke, ke.uint32());
              break;
            case 3:
              Ne.mode = ke.int32();
              break;
            case 4:
              Ne.sig = ke.bytes();
              break;
            default:
              ke.skipType(Et & 7);
              break;
          }
        }
        return Ne;
      },
      fromJSON(be) {
        return {
          address: Fe(be.address) ? String(be.address) : "",
          signDoc: Fe(be.signDoc) ? o.SignDocDirectAux.fromJSON(be.signDoc) : void 0,
          mode: Fe(be.mode) ? (0, t.signModeFromJSON)(be.mode) : 0,
          sig: Fe(be.sig) ? He(be.sig) : new Uint8Array()
        };
      },
      toJSON(be) {
        const Be = {};
        return be.address !== void 0 && (Be.address = be.address), be.signDoc !== void 0 && (Be.signDoc = be.signDoc ? o.SignDocDirectAux.toJSON(be.signDoc) : void 0), be.mode !== void 0 && (Be.mode = (0, t.signModeToJSON)(be.mode)), be.sig !== void 0 && (Be.sig = De(be.sig !== void 0 ? be.sig : new Uint8Array())), Be;
      },
      fromPartial(be) {
        var Be, ke, xe;
        const Ne = Ee();
        return Ne.address = (Be = be.address) !== null && Be !== void 0 ? Be : "", Ne.signDoc = be.signDoc !== void 0 && be.signDoc !== null ? o.SignDocDirectAux.fromPartial(be.signDoc) : void 0, Ne.mode = (ke = be.mode) !== null && ke !== void 0 ? ke : 0, Ne.sig = (xe = be.sig) !== null && xe !== void 0 ? xe : new Uint8Array(), Ne;
      }
    };
    var Se = (() => {
      if (typeof Se < "u")
        return Se;
      if (typeof self < "u")
        return self;
      if (typeof window < "u")
        return window;
      if (typeof commonjsGlobal < "u")
        return commonjsGlobal;
      throw "Unable to locate global object";
    })();
    const ze = Se.atob || ((be) => Se.Buffer.from(be, "base64").toString("binary"));
    function He(be) {
      const Be = ze(be), ke = new Uint8Array(Be.length);
      for (let xe = 0; xe < Be.length; ++xe)
        ke[xe] = Be.charCodeAt(xe);
      return ke;
    }
    const Pe = Se.btoa || ((be) => Se.Buffer.from(be, "binary").toString("base64"));
    function De(be) {
      const Be = [];
      for (const ke of be)
        Be.push(String.fromCharCode(ke));
      return Pe(Be.join(""));
    }
    function ve(be) {
      return be.toString();
    }
    y.default.util.Long !== c.default && (y.default.util.Long = c.default, y.default.configure());
    function Fe(be) {
      return be != null;
    }
  }(tx)), tx;
}
var txExports = requireTx();
var wasm$1 = null;
try {
  wasm$1 = new WebAssembly.Instance(
    new WebAssembly.Module(
      new Uint8Array([
        // \0asm
        0,
        97,
        115,
        109,
        // version 1
        1,
        0,
        0,
        0,
        // section "type"
        1,
        13,
        2,
        // 0, () => i32
        96,
        0,
        1,
        127,
        // 1, (i32, i32, i32, i32) => i32
        96,
        4,
        127,
        127,
        127,
        127,
        1,
        127,
        // section "function"
        3,
        7,
        6,
        // 0, type 0
        0,
        // 1, type 1
        1,
        // 2, type 1
        1,
        // 3, type 1
        1,
        // 4, type 1
        1,
        // 5, type 1
        1,
        // section "global"
        6,
        6,
        1,
        // 0, "high", mutable i32
        127,
        1,
        65,
        0,
        11,
        // section "export"
        7,
        50,
        6,
        // 0, "mul"
        3,
        109,
        117,
        108,
        0,
        1,
        // 1, "div_s"
        5,
        100,
        105,
        118,
        95,
        115,
        0,
        2,
        // 2, "div_u"
        5,
        100,
        105,
        118,
        95,
        117,
        0,
        3,
        // 3, "rem_s"
        5,
        114,
        101,
        109,
        95,
        115,
        0,
        4,
        // 4, "rem_u"
        5,
        114,
        101,
        109,
        95,
        117,
        0,
        5,
        // 5, "get_high"
        8,
        103,
        101,
        116,
        95,
        104,
        105,
        103,
        104,
        0,
        0,
        // section "code"
        10,
        191,
        1,
        6,
        // 0, "get_high"
        4,
        0,
        35,
        0,
        11,
        // 1, "mul"
        36,
        1,
        1,
        126,
        32,
        0,
        173,
        32,
        1,
        173,
        66,
        32,
        134,
        132,
        32,
        2,
        173,
        32,
        3,
        173,
        66,
        32,
        134,
        132,
        126,
        34,
        4,
        66,
        32,
        135,
        167,
        36,
        0,
        32,
        4,
        167,
        11,
        // 2, "div_s"
        36,
        1,
        1,
        126,
        32,
        0,
        173,
        32,
        1,
        173,
        66,
        32,
        134,
        132,
        32,
        2,
        173,
        32,
        3,
        173,
        66,
        32,
        134,
        132,
        127,
        34,
        4,
        66,
        32,
        135,
        167,
        36,
        0,
        32,
        4,
        167,
        11,
        // 3, "div_u"
        36,
        1,
        1,
        126,
        32,
        0,
        173,
        32,
        1,
        173,
        66,
        32,
        134,
        132,
        32,
        2,
        173,
        32,
        3,
        173,
        66,
        32,
        134,
        132,
        128,
        34,
        4,
        66,
        32,
        135,
        167,
        36,
        0,
        32,
        4,
        167,
        11,
        // 4, "rem_s"
        36,
        1,
        1,
        126,
        32,
        0,
        173,
        32,
        1,
        173,
        66,
        32,
        134,
        132,
        32,
        2,
        173,
        32,
        3,
        173,
        66,
        32,
        134,
        132,
        129,
        34,
        4,
        66,
        32,
        135,
        167,
        36,
        0,
        32,
        4,
        167,
        11,
        // 5, "rem_u"
        36,
        1,
        1,
        126,
        32,
        0,
        173,
        32,
        1,
        173,
        66,
        32,
        134,
        132,
        32,
        2,
        173,
        32,
        3,
        173,
        66,
        32,
        134,
        132,
        130,
        34,
        4,
        66,
        32,
        135,
        167,
        36,
        0,
        32,
        4,
        167,
        11
      ])
    ),
    {}
  ).exports;
} catch {
}
function Long(o, g, c) {
  this.low = o | 0, this.high = g | 0, this.unsigned = !!c;
}
Long.prototype.__isLong__;
Object.defineProperty(Long.prototype, "__isLong__", { value: !0 });
function isLong(o) {
  return (o && o.__isLong__) === !0;
}
function ctz32(o) {
  var g = Math.clz32(o & -o);
  return o ? 31 - g : g;
}
Long.isLong = isLong;
var INT_CACHE = {}, UINT_CACHE = {};
function fromInt(o, g) {
  var c, y, t;
  return g ? (o >>>= 0, (t = 0 <= o && o < 256) && (y = UINT_CACHE[o], y) ? y : (c = fromBits(o, 0, !0), t && (UINT_CACHE[o] = c), c)) : (o |= 0, (t = -128 <= o && o < 128) && (y = INT_CACHE[o], y) ? y : (c = fromBits(o, o < 0 ? -1 : 0, !1), t && (INT_CACHE[o] = c), c));
}
Long.fromInt = fromInt;
function fromNumber(o, g) {
  if (isNaN(o)) return g ? UZERO : ZERO;
  if (g) {
    if (o < 0) return UZERO;
    if (o >= TWO_PWR_64_DBL) return MAX_UNSIGNED_VALUE;
  } else {
    if (o <= -TWO_PWR_63_DBL) return MIN_VALUE;
    if (o + 1 >= TWO_PWR_63_DBL) return MAX_VALUE;
  }
  return o < 0 ? fromNumber(-o, g).neg() : fromBits(
    o % TWO_PWR_32_DBL | 0,
    o / TWO_PWR_32_DBL | 0,
    g
  );
}
Long.fromNumber = fromNumber;
function fromBits(o, g, c) {
  return new Long(o, g, c);
}
Long.fromBits = fromBits;
var pow_dbl = Math.pow;
function fromString(o, g, c) {
  if (o.length === 0) throw Error("empty string");
  if (typeof g == "number" ? (c = g, g = !1) : g = !!g, o === "NaN" || o === "Infinity" || o === "+Infinity" || o === "-Infinity")
    return g ? UZERO : ZERO;
  if (c = c || 10, c < 2 || 36 < c) throw RangeError("radix");
  var y;
  if ((y = o.indexOf("-")) > 0) throw Error("interior hyphen");
  if (y === 0)
    return fromString(o.substring(1), g, c).neg();
  for (var t = fromNumber(pow_dbl(c, 8)), d = ZERO, E = 0; E < o.length; E += 8) {
    var B = Math.min(8, o.length - E), D = parseInt(o.substring(E, E + B), c);
    if (B < 8) {
      var x = fromNumber(pow_dbl(c, B));
      d = d.mul(x).add(fromNumber(D));
    } else
      d = d.mul(t), d = d.add(fromNumber(D));
  }
  return d.unsigned = g, d;
}
Long.fromString = fromString;
function fromValue(o, g) {
  return typeof o == "number" ? fromNumber(o, g) : typeof o == "string" ? fromString(o, g) : fromBits(
    o.low,
    o.high,
    typeof g == "boolean" ? g : o.unsigned
  );
}
Long.fromValue = fromValue;
var TWO_PWR_16_DBL = 65536, TWO_PWR_24_DBL = 1 << 24, TWO_PWR_32_DBL = TWO_PWR_16_DBL * TWO_PWR_16_DBL, TWO_PWR_64_DBL = TWO_PWR_32_DBL * TWO_PWR_32_DBL, TWO_PWR_63_DBL = TWO_PWR_64_DBL / 2, TWO_PWR_24 = fromInt(TWO_PWR_24_DBL), ZERO = fromInt(0);
Long.ZERO = ZERO;
var UZERO = fromInt(0, !0);
Long.UZERO = UZERO;
var ONE = fromInt(1);
Long.ONE = ONE;
var UONE = fromInt(1, !0);
Long.UONE = UONE;
var NEG_ONE = fromInt(-1);
Long.NEG_ONE = NEG_ONE;
var MAX_VALUE = fromBits(-1, 2147483647, !1);
Long.MAX_VALUE = MAX_VALUE;
var MAX_UNSIGNED_VALUE = fromBits(-1, -1, !0);
Long.MAX_UNSIGNED_VALUE = MAX_UNSIGNED_VALUE;
var MIN_VALUE = fromBits(0, -2147483648, !1);
Long.MIN_VALUE = MIN_VALUE;
var LongPrototype = Long.prototype;
LongPrototype.toInt = function o() {
  return this.unsigned ? this.low >>> 0 : this.low;
};
LongPrototype.toNumber = function o() {
  return this.unsigned ? (this.high >>> 0) * TWO_PWR_32_DBL + (this.low >>> 0) : this.high * TWO_PWR_32_DBL + (this.low >>> 0);
};
LongPrototype.toString = function o(g) {
  if (g = g || 10, g < 2 || 36 < g) throw RangeError("radix");
  if (this.isZero()) return "0";
  if (this.isNegative())
    if (this.eq(MIN_VALUE)) {
      var c = fromNumber(g), y = this.div(c), t = y.mul(c).sub(this);
      return y.toString(g) + t.toInt().toString(g);
    } else return "-" + this.neg().toString(g);
  for (var d = fromNumber(pow_dbl(g, 6), this.unsigned), E = this, B = ""; ; ) {
    var D = E.div(d), x = E.sub(D.mul(d)).toInt() >>> 0, v = x.toString(g);
    if (E = D, E.isZero()) return v + B;
    for (; v.length < 6; ) v = "0" + v;
    B = "" + v + B;
  }
};
LongPrototype.getHighBits = function o() {
  return this.high;
};
LongPrototype.getHighBitsUnsigned = function o() {
  return this.high >>> 0;
};
LongPrototype.getLowBits = function o() {
  return this.low;
};
LongPrototype.getLowBitsUnsigned = function o() {
  return this.low >>> 0;
};
LongPrototype.getNumBitsAbs = function o() {
  if (this.isNegative())
    return this.eq(MIN_VALUE) ? 64 : this.neg().getNumBitsAbs();
  for (var g = this.high != 0 ? this.high : this.low, c = 31; c > 0 && (g & 1 << c) == 0; c--) ;
  return this.high != 0 ? c + 33 : c + 1;
};
LongPrototype.isSafeInteger = function o() {
  var g = this.high >> 21;
  return g ? this.unsigned ? !1 : g === -1 && !(this.low === 0 && this.high === -2097152) : !0;
};
LongPrototype.isZero = function o() {
  return this.high === 0 && this.low === 0;
};
LongPrototype.eqz = LongPrototype.isZero;
LongPrototype.isNegative = function o() {
  return !this.unsigned && this.high < 0;
};
LongPrototype.isPositive = function o() {
  return this.unsigned || this.high >= 0;
};
LongPrototype.isOdd = function o() {
  return (this.low & 1) === 1;
};
LongPrototype.isEven = function o() {
  return (this.low & 1) === 0;
};
LongPrototype.equals = function o(g) {
  return isLong(g) || (g = fromValue(g)), this.unsigned !== g.unsigned && this.high >>> 31 === 1 && g.high >>> 31 === 1 ? !1 : this.high === g.high && this.low === g.low;
};
LongPrototype.eq = LongPrototype.equals;
LongPrototype.notEquals = function o(g) {
  return !this.eq(
    /* validates */
    g
  );
};
LongPrototype.neq = LongPrototype.notEquals;
LongPrototype.ne = LongPrototype.notEquals;
LongPrototype.lessThan = function o(g) {
  return this.comp(
    /* validates */
    g
  ) < 0;
};
LongPrototype.lt = LongPrototype.lessThan;
LongPrototype.lessThanOrEqual = function o(g) {
  return this.comp(
    /* validates */
    g
  ) <= 0;
};
LongPrototype.lte = LongPrototype.lessThanOrEqual;
LongPrototype.le = LongPrototype.lessThanOrEqual;
LongPrototype.greaterThan = function o(g) {
  return this.comp(
    /* validates */
    g
  ) > 0;
};
LongPrototype.gt = LongPrototype.greaterThan;
LongPrototype.greaterThanOrEqual = function o(g) {
  return this.comp(
    /* validates */
    g
  ) >= 0;
};
LongPrototype.gte = LongPrototype.greaterThanOrEqual;
LongPrototype.ge = LongPrototype.greaterThanOrEqual;
LongPrototype.compare = function o(g) {
  if (isLong(g) || (g = fromValue(g)), this.eq(g)) return 0;
  var c = this.isNegative(), y = g.isNegative();
  return c && !y ? -1 : !c && y ? 1 : this.unsigned ? g.high >>> 0 > this.high >>> 0 || g.high === this.high && g.low >>> 0 > this.low >>> 0 ? -1 : 1 : this.sub(g).isNegative() ? -1 : 1;
};
LongPrototype.comp = LongPrototype.compare;
LongPrototype.negate = function o() {
  return !this.unsigned && this.eq(MIN_VALUE) ? MIN_VALUE : this.not().add(ONE);
};
LongPrototype.neg = LongPrototype.negate;
LongPrototype.add = function o(g) {
  isLong(g) || (g = fromValue(g));
  var c = this.high >>> 16, y = this.high & 65535, t = this.low >>> 16, d = this.low & 65535, E = g.high >>> 16, B = g.high & 65535, D = g.low >>> 16, x = g.low & 65535, v = 0, F = 0, M = 0, U = 0;
  return U += d + x, M += U >>> 16, U &= 65535, M += t + D, F += M >>> 16, M &= 65535, F += y + B, v += F >>> 16, F &= 65535, v += c + E, v &= 65535, fromBits(M << 16 | U, v << 16 | F, this.unsigned);
};
LongPrototype.subtract = function o(g) {
  return isLong(g) || (g = fromValue(g)), this.add(g.neg());
};
LongPrototype.sub = LongPrototype.subtract;
LongPrototype.multiply = function o(g) {
  if (this.isZero()) return this;
  if (isLong(g) || (g = fromValue(g)), wasm$1) {
    var c = wasm$1.mul(this.low, this.high, g.low, g.high);
    return fromBits(c, wasm$1.get_high(), this.unsigned);
  }
  if (g.isZero()) return this.unsigned ? UZERO : ZERO;
  if (this.eq(MIN_VALUE)) return g.isOdd() ? MIN_VALUE : ZERO;
  if (g.eq(MIN_VALUE)) return this.isOdd() ? MIN_VALUE : ZERO;
  if (this.isNegative())
    return g.isNegative() ? this.neg().mul(g.neg()) : this.neg().mul(g).neg();
  if (g.isNegative()) return this.mul(g.neg()).neg();
  if (this.lt(TWO_PWR_24) && g.lt(TWO_PWR_24))
    return fromNumber(this.toNumber() * g.toNumber(), this.unsigned);
  var y = this.high >>> 16, t = this.high & 65535, d = this.low >>> 16, E = this.low & 65535, B = g.high >>> 16, D = g.high & 65535, x = g.low >>> 16, v = g.low & 65535, F = 0, M = 0, U = 0, L = 0;
  return L += E * v, U += L >>> 16, L &= 65535, U += d * v, M += U >>> 16, U &= 65535, U += E * x, M += U >>> 16, U &= 65535, M += t * v, F += M >>> 16, M &= 65535, M += d * x, F += M >>> 16, M &= 65535, M += E * D, F += M >>> 16, M &= 65535, F += y * v + t * x + d * D + E * B, F &= 65535, fromBits(U << 16 | L, F << 16 | M, this.unsigned);
};
LongPrototype.mul = LongPrototype.multiply;
LongPrototype.divide = function o(g) {
  if (isLong(g) || (g = fromValue(g)), g.isZero()) throw Error("division by zero");
  if (wasm$1) {
    if (!this.unsigned && this.high === -2147483648 && g.low === -1 && g.high === -1)
      return this;
    var c = (this.unsigned ? wasm$1.div_u : wasm$1.div_s)(
      this.low,
      this.high,
      g.low,
      g.high
    );
    return fromBits(c, wasm$1.get_high(), this.unsigned);
  }
  if (this.isZero()) return this.unsigned ? UZERO : ZERO;
  var y, t, d;
  if (this.unsigned) {
    if (g.unsigned || (g = g.toUnsigned()), g.gt(this)) return UZERO;
    if (g.gt(this.shru(1)))
      return UONE;
    d = UZERO;
  } else {
    if (this.eq(MIN_VALUE)) {
      if (g.eq(ONE) || g.eq(NEG_ONE))
        return MIN_VALUE;
      if (g.eq(MIN_VALUE)) return ONE;
      var E = this.shr(1);
      return y = E.div(g).shl(1), y.eq(ZERO) ? g.isNegative() ? ONE : NEG_ONE : (t = this.sub(g.mul(y)), d = y.add(t.div(g)), d);
    } else if (g.eq(MIN_VALUE)) return this.unsigned ? UZERO : ZERO;
    if (this.isNegative())
      return g.isNegative() ? this.neg().div(g.neg()) : this.neg().div(g).neg();
    if (g.isNegative()) return this.div(g.neg()).neg();
    d = ZERO;
  }
  for (t = this; t.gte(g); ) {
    y = Math.max(1, Math.floor(t.toNumber() / g.toNumber()));
    for (var B = Math.ceil(Math.log(y) / Math.LN2), D = B <= 48 ? 1 : pow_dbl(2, B - 48), x = fromNumber(y), v = x.mul(g); v.isNegative() || v.gt(t); )
      y -= D, x = fromNumber(y, this.unsigned), v = x.mul(g);
    x.isZero() && (x = ONE), d = d.add(x), t = t.sub(v);
  }
  return d;
};
LongPrototype.div = LongPrototype.divide;
LongPrototype.modulo = function o(g) {
  if (isLong(g) || (g = fromValue(g)), wasm$1) {
    var c = (this.unsigned ? wasm$1.rem_u : wasm$1.rem_s)(
      this.low,
      this.high,
      g.low,
      g.high
    );
    return fromBits(c, wasm$1.get_high(), this.unsigned);
  }
  return this.sub(this.div(g).mul(g));
};
LongPrototype.mod = LongPrototype.modulo;
LongPrototype.rem = LongPrototype.modulo;
LongPrototype.not = function o() {
  return fromBits(~this.low, ~this.high, this.unsigned);
};
LongPrototype.countLeadingZeros = function o() {
  return this.high ? Math.clz32(this.high) : Math.clz32(this.low) + 32;
};
LongPrototype.clz = LongPrototype.countLeadingZeros;
LongPrototype.countTrailingZeros = function o() {
  return this.low ? ctz32(this.low) : ctz32(this.high) + 32;
};
LongPrototype.ctz = LongPrototype.countTrailingZeros;
LongPrototype.and = function o(g) {
  return isLong(g) || (g = fromValue(g)), fromBits(this.low & g.low, this.high & g.high, this.unsigned);
};
LongPrototype.or = function o(g) {
  return isLong(g) || (g = fromValue(g)), fromBits(this.low | g.low, this.high | g.high, this.unsigned);
};
LongPrototype.xor = function o(g) {
  return isLong(g) || (g = fromValue(g)), fromBits(this.low ^ g.low, this.high ^ g.high, this.unsigned);
};
LongPrototype.shiftLeft = function o(g) {
  return isLong(g) && (g = g.toInt()), (g &= 63) === 0 ? this : g < 32 ? fromBits(
    this.low << g,
    this.high << g | this.low >>> 32 - g,
    this.unsigned
  ) : fromBits(0, this.low << g - 32, this.unsigned);
};
LongPrototype.shl = LongPrototype.shiftLeft;
LongPrototype.shiftRight = function o(g) {
  return isLong(g) && (g = g.toInt()), (g &= 63) === 0 ? this : g < 32 ? fromBits(
    this.low >>> g | this.high << 32 - g,
    this.high >> g,
    this.unsigned
  ) : fromBits(
    this.high >> g - 32,
    this.high >= 0 ? 0 : -1,
    this.unsigned
  );
};
LongPrototype.shr = LongPrototype.shiftRight;
LongPrototype.shiftRightUnsigned = function o(g) {
  return isLong(g) && (g = g.toInt()), (g &= 63) === 0 ? this : g < 32 ? fromBits(
    this.low >>> g | this.high << 32 - g,
    this.high >>> g,
    this.unsigned
  ) : g === 32 ? fromBits(this.high, 0, this.unsigned) : fromBits(this.high >>> g - 32, 0, this.unsigned);
};
LongPrototype.shru = LongPrototype.shiftRightUnsigned;
LongPrototype.shr_u = LongPrototype.shiftRightUnsigned;
LongPrototype.rotateLeft = function o(g) {
  var c;
  return isLong(g) && (g = g.toInt()), (g &= 63) === 0 ? this : g === 32 ? fromBits(this.high, this.low, this.unsigned) : g < 32 ? (c = 32 - g, fromBits(
    this.low << g | this.high >>> c,
    this.high << g | this.low >>> c,
    this.unsigned
  )) : (g -= 32, c = 32 - g, fromBits(
    this.high << g | this.low >>> c,
    this.low << g | this.high >>> c,
    this.unsigned
  ));
};
LongPrototype.rotl = LongPrototype.rotateLeft;
LongPrototype.rotateRight = function o(g) {
  var c;
  return isLong(g) && (g = g.toInt()), (g &= 63) === 0 ? this : g === 32 ? fromBits(this.high, this.low, this.unsigned) : g < 32 ? (c = 32 - g, fromBits(
    this.high << c | this.low >>> g,
    this.low << c | this.high >>> g,
    this.unsigned
  )) : (g -= 32, c = 32 - g, fromBits(
    this.low << c | this.high >>> g,
    this.high << c | this.low >>> g,
    this.unsigned
  ));
};
LongPrototype.rotr = LongPrototype.rotateRight;
LongPrototype.toSigned = function o() {
  return this.unsigned ? fromBits(this.low, this.high, !1) : this;
};
LongPrototype.toUnsigned = function o() {
  return this.unsigned ? this : fromBits(this.low, this.high, !0);
};
LongPrototype.toBytes = function o(g) {
  return g ? this.toBytesLE() : this.toBytesBE();
};
LongPrototype.toBytesLE = function o() {
  var g = this.high, c = this.low;
  return [
    c & 255,
    c >>> 8 & 255,
    c >>> 16 & 255,
    c >>> 24,
    g & 255,
    g >>> 8 & 255,
    g >>> 16 & 255,
    g >>> 24
  ];
};
LongPrototype.toBytesBE = function o() {
  var g = this.high, c = this.low;
  return [
    g >>> 24,
    g >>> 16 & 255,
    g >>> 8 & 255,
    g & 255,
    c >>> 24,
    c >>> 16 & 255,
    c >>> 8 & 255,
    c & 255
  ];
};
Long.fromBytes = function o(g, c, y) {
  return y ? Long.fromBytesLE(g, c) : Long.fromBytesBE(g, c);
};
Long.fromBytesLE = function o(g, c) {
  return new Long(
    g[0] | g[1] << 8 | g[2] << 16 | g[3] << 24,
    g[4] | g[5] << 8 | g[6] << 16 | g[7] << 24,
    c
  );
};
Long.fromBytesBE = function o(g, c) {
  return new Long(
    g[4] << 24 | g[5] << 16 | g[6] << 8 | g[7],
    g[0] << 24 | g[1] << 16 | g[2] << 8 | g[3],
    c
  );
};
typeof BigInt == "function" && (Long.fromBigInt = function(g, c) {
  var y = Number(BigInt.asIntN(32, g)), t = Number(BigInt.asIntN(32, g >> BigInt(32)));
  return fromBits(y, t, c);
}, Long.fromValue = function(g, c) {
  return typeof g == "bigint" ? Long.fromBigInt(g, c) : fromValue(g, c);
}, LongPrototype.toBigInt = function() {
  var g = BigInt(this.low >>> 0), c = BigInt(this.unsigned ? this.high >>> 0 : this.high);
  return c << BigInt(32) | g;
});
var classnames = { exports: {} };
var hasRequiredClassnames;
function requireClassnames() {
  return hasRequiredClassnames || (hasRequiredClassnames = 1, function(o) {
    (function() {
      var g = {}.hasOwnProperty;
      function c() {
        for (var d = "", E = 0; E < arguments.length; E++) {
          var B = arguments[E];
          B && (d = t(d, y(B)));
        }
        return d;
      }
      function y(d) {
        if (typeof d == "string" || typeof d == "number")
          return d;
        if (typeof d != "object")
          return "";
        if (Array.isArray(d))
          return c.apply(null, d);
        if (d.toString !== Object.prototype.toString && !d.toString.toString().includes("[native code]"))
          return d.toString();
        var E = "";
        for (var B in d)
          g.call(d, B) && d[B] && (E = t(E, B));
        return E;
      }
      function t(d, E) {
        return E ? d ? d + " " + E : d + E : d;
      }
      o.exports ? (c.default = c, o.exports = c) : window.classNames = c;
    })();
  }(classnames)), classnames.exports;
}
var classnamesExports = requireClassnames();
const iA = /* @__PURE__ */ getDefaultExportFromCjs(classnamesExports);
var we = Object.defineProperty, he = (o, g, c) => g in o ? we(o, g, { enumerable: !0, configurable: !0, writable: !0, value: c }) : o[g] = c, rA = (o, g, c) => he(o, typeof g != "symbol" ? g + "" : g, c);
const V = { BASE_URL: "/", DEV: !1, MODE: "production", PROD: !0, SSR: !1 };
function zt(o) {
  return "init" in o;
}
function CA(o) {
  return !!o.write;
}
function gt(o) {
  return "v" in o || "e" in o;
}
function dA(o) {
  if ("e" in o)
    throw o.e;
  if ((V ? "production" : void 0) !== "production" && !("v" in o))
    throw new Error("[Bug] atom state is not initialized");
  return o.v;
}
const lA = /* @__PURE__ */ new WeakMap();
function Ft(o) {
  var g;
  return uA(o) && !!((g = lA.get(o)) != null && g[0]);
}
function Le(o) {
  const g = lA.get(o);
  g != null && g[0] && (g[0] = !1, g[1].forEach((c) => c()));
}
function BA(o, g) {
  let c = lA.get(o);
  if (!c) {
    c = [!0, /* @__PURE__ */ new Set()], lA.set(o, c);
    const y = () => {
      c[0] = !1;
    };
    o.then(y, y);
  }
  c[1].add(g);
}
function uA(o) {
  return typeof (o == null ? void 0 : o.then) == "function";
}
function Ht(o, g, c) {
  if (!c.p.has(o)) {
    c.p.add(o);
    const y = () => c.p.delete(o);
    g.then(y, y);
  }
}
function Mt(o, g, c) {
  var y;
  const t = /* @__PURE__ */ new Set();
  for (const d of ((y = c.get(o)) == null ? void 0 : y.t) || [])
    t.add(d);
  for (const d of g.p)
    t.add(d);
  return t;
}
const Je = (o, g, ...c) => g.read(...c), We = (o, g, ...c) => g.write(...c), Qe = (o, g) => {
  if (g.INTERNAL_onInit)
    return g.INTERNAL_onInit(o);
}, Oe = (o, g, c) => {
  var y;
  return (y = g.onMount) == null ? void 0 : y.call(g, c);
}, Ke = (o, g) => {
  var c;
  const y = k(o), t = y[0], d = y[6], E = y[9];
  if ((V ? "production" : void 0) !== "production" && !g)
    throw new Error("Atom is undefined or null");
  let B = t.get(g);
  return B || (B = { d: /* @__PURE__ */ new Map(), p: /* @__PURE__ */ new Set(), n: 0 }, t.set(g, B), (c = d.i) == null || c.call(d, g), E == null || E(o, g)), B;
}, Ve = (o) => {
  const g = k(o), c = g[1], y = g[3], t = g[4], d = g[5], E = g[6], B = g[13], D = [], x = (v) => {
    try {
      v();
    } catch (F) {
      D.push(F);
    }
  };
  do {
    E.f && x(E.f);
    const v = /* @__PURE__ */ new Set(), F = v.add.bind(v);
    y.forEach((M) => {
      var U;
      return (U = c.get(M)) == null ? void 0 : U.l.forEach(F);
    }), y.clear(), d.forEach(F), d.clear(), t.forEach(F), t.clear(), v.forEach(x), y.size && B(o);
  } while (y.size || d.size || t.size);
  if (D.length)
    throw new AggregateError(D);
}, Ue = (o) => {
  const g = k(o), c = g[1], y = g[2], t = g[3], d = g[11], E = g[14], B = g[17], D = [], x = /* @__PURE__ */ new WeakSet(), v = /* @__PURE__ */ new WeakSet(), F = Array.from(t);
  for (; F.length; ) {
    const M = F[F.length - 1], U = d(o, M);
    if (v.has(M)) {
      F.pop();
      continue;
    }
    if (x.has(M)) {
      if (y.get(M) === U.n)
        D.push([M, U]);
      else if ((V ? "production" : void 0) !== "production" && y.has(M))
        throw new Error("[Bug] invalidated atom exists");
      v.add(M), F.pop();
      continue;
    }
    x.add(M);
    for (const L of Mt(M, U, c))
      x.has(L) || F.push(L);
  }
  for (let M = D.length - 1; M >= 0; --M) {
    const [U, L] = D[M];
    let H = !1;
    for (const fe of L.d.keys())
      if (fe !== U && t.has(fe)) {
        H = !0;
        break;
      }
    H && (E(o, U), B(o, U)), y.delete(U);
  }
}, PA = /* @__PURE__ */ new WeakSet(), qe = (o, g) => {
  var c, y;
  const t = k(o), d = t[1], E = t[2], B = t[3], D = t[6], x = t[7], v = t[11], F = t[12], M = t[13], U = t[14], L = t[16], H = t[17], fe = t[20], ge = v(o, g);
  if (gt(ge)) {
    if (d.has(g) && E.get(g) !== ge.n)
      return ge;
    let ve = !1;
    for (const [Fe, be] of ge.d)
      if (U(o, Fe).n !== be) {
        ve = !0;
        break;
      }
    if (!ve)
      return ge;
  }
  ge.d.clear();
  let Ie = !0;
  function Ee() {
    d.has(g) && (H(o, g), M(o), F(o));
  }
  function Se(ve) {
    var Fe;
    if (ve === g) {
      const Be = v(o, ve);
      if (!gt(Be))
        if (zt(ve))
          fe(o, ve, ve.init);
        else
          throw new Error("no atom init");
      return dA(Be);
    }
    const be = U(o, ve);
    try {
      return dA(be);
    } finally {
      ge.d.set(ve, be.n), Ft(ge.v) && Ht(g, ge.v, be), d.has(g) && ((Fe = d.get(ve)) == null || Fe.t.add(g)), Ie || Ee();
    }
  }
  let ze, He;
  const Pe = {
    get signal() {
      return ze || (ze = new AbortController()), ze.signal;
    },
    get setSelf() {
      return (V ? "production" : void 0) !== "production" && console.warn(
        "[DEPRECATED] setSelf is deprecated and will be removed in v3."
      ), (V ? "production" : void 0) !== "production" && !CA(g) && console.warn("setSelf function cannot be used with read-only atom"), !He && CA(g) && (He = (...ve) => {
        if ((V ? "production" : void 0) !== "production" && Ie && console.warn("setSelf function cannot be called in sync"), !Ie)
          try {
            return L(o, g, ...ve);
          } finally {
            M(o), F(o);
          }
      }), He;
    }
  }, De = ge.n;
  try {
    (V ? "production" : void 0) !== "production" && PA.delete(o);
    const ve = x(o, g, Se, Pe);
    return (V ? "production" : void 0) !== "production" && PA.has(o) && console.warn(
      "Detected store mutation during atom read. This is not supported."
    ), fe(o, g, ve), uA(ve) && (BA(ve, () => ze == null ? void 0 : ze.abort()), ve.then(Ee, Ee)), (c = D.r) == null || c.call(D, g), ge;
  } catch (ve) {
    return delete ge.v, ge.e = ve, ++ge.n, ge;
  } finally {
    Ie = !1, De !== ge.n && E.get(g) === De && (E.set(g, ge.n), B.add(g), (y = D.c) == null || y.call(D, g));
  }
}, Re = (o, g) => {
  const c = k(o), y = c[1], t = c[2], d = c[11], E = [g];
  for (; E.length; ) {
    const B = E.pop(), D = d(o, B);
    for (const x of Mt(B, D, y)) {
      const v = d(o, x);
      t.set(x, v.n), E.push(x);
    }
  }
}, Ge = (o, g, ...c) => {
  const y = k(o), t = y[3], d = y[6], E = y[8], B = y[11], D = y[12], x = y[13], v = y[14], F = y[15], M = y[16], U = y[17], L = y[20];
  let H = !0;
  const fe = (Ie) => dA(v(o, Ie)), ge = (Ie, ...Ee) => {
    var Se;
    const ze = B(o, Ie);
    try {
      if (Ie === g) {
        if (!zt(Ie))
          throw new Error("atom not writable");
        (V ? "production" : void 0) !== "production" && PA.add(o);
        const He = ze.n, Pe = Ee[0];
        L(o, Ie, Pe), U(o, Ie), He !== ze.n && (t.add(Ie), F(o, Ie), (Se = d.c) == null || Se.call(d, Ie));
        return;
      } else
        return M(o, Ie, ...Ee);
    } finally {
      H || (x(o), D(o));
    }
  };
  try {
    return E(o, g, fe, ge, ...c);
  } finally {
    H = !1;
  }
}, Ze = (o, g) => {
  var c;
  const y = k(o), t = y[1], d = y[3], E = y[6], B = y[11], D = y[15], x = y[18], v = y[19], F = B(o, g), M = t.get(g);
  if (M && !Ft(F.v)) {
    for (const [U, L] of F.d)
      if (!M.d.has(U)) {
        const H = B(o, U);
        x(o, U).t.add(g), M.d.add(U), L !== H.n && (d.add(U), D(o, U), (c = E.c) == null || c.call(E, U));
      }
    for (const U of M.d)
      if (!F.d.has(U)) {
        M.d.delete(U);
        const L = v(o, U);
        L == null || L.t.delete(g);
      }
  }
}, je = (o, g) => {
  var c;
  const y = k(o), t = y[1], d = y[4], E = y[6], B = y[10], D = y[11], x = y[12], v = y[13], F = y[14], M = y[16], U = y[18], L = D(o, g);
  let H = t.get(g);
  if (!H) {
    F(o, g);
    for (const fe of L.d.keys())
      U(o, fe).t.add(g);
    if (H = {
      l: /* @__PURE__ */ new Set(),
      d: new Set(L.d.keys()),
      t: /* @__PURE__ */ new Set()
    }, t.set(g, H), CA(g)) {
      const fe = () => {
        let ge = !0;
        const Ie = (...Ee) => {
          try {
            return M(o, g, ...Ee);
          } finally {
            ge || (v(o), x(o));
          }
        };
        try {
          const Ee = B(o, g, Ie);
          Ee && (H.u = () => {
            ge = !0;
            try {
              Ee();
            } finally {
              ge = !1;
            }
          });
        } finally {
          ge = !1;
        }
      };
      d.add(fe);
    }
    (c = E.m) == null || c.call(E, g);
  }
  return H;
}, Ye = (o, g) => {
  var c, y;
  const t = k(o), d = t[1], E = t[5], B = t[6], D = t[11], x = t[19], v = D(o, g);
  let F = d.get(g);
  if (!F || F.l.size)
    return F;
  let M = !1;
  for (const U of F.t)
    if ((c = d.get(U)) != null && c.d.has(g)) {
      M = !0;
      break;
    }
  if (!M) {
    F.u && E.add(F.u), F = void 0, d.delete(g);
    for (const U of v.d.keys()) {
      const L = x(o, U);
      L == null || L.t.delete(g);
    }
    (y = B.u) == null || y.call(B, g);
    return;
  }
  return F;
}, _e = (o, g, c) => {
  const y = k(o)[11], t = y(o, g), d = "v" in t, E = t.v;
  if (uA(c))
    for (const B of t.d.keys())
      Ht(
        g,
        c,
        y(o, B)
      );
  t.v = c, delete t.e, (!d || !Object.is(E, t.v)) && (++t.n, uA(E) && Le(E));
}, $e = (o, g) => {
  const c = k(o)[14];
  return dA(c(o, g));
}, A2 = (o, g, ...c) => {
  const y = k(o), t = y[12], d = y[13], E = y[16];
  try {
    return E(o, g, ...c);
  } finally {
    d(o), t(o);
  }
}, t2 = (o, g, c) => {
  const y = k(o), t = y[12], d = y[18], E = y[19], B = d(o, g).l;
  return B.add(c), t(o), () => {
    B.delete(c), E(o, g), t(o);
  };
}, Xt = /* @__PURE__ */ new WeakMap(), k = (o) => {
  const g = Xt.get(o);
  if ((V ? "production" : void 0) !== "production" && !g)
    throw new Error(
      "Store must be created by buildStore to read its building blocks"
    );
  return g;
};
function e2(...o) {
  const g = {
    get(y) {
      const t = k(g)[21];
      return t(g, y);
    },
    set(y, ...t) {
      const d = k(g)[22];
      return d(g, y, ...t);
    },
    sub(y, t) {
      const d = k(g)[23];
      return d(g, y, t);
    }
  }, c = [
    // store state
    /* @__PURE__ */ new WeakMap(),
    // atomStateMap
    /* @__PURE__ */ new WeakMap(),
    // mountedMap
    /* @__PURE__ */ new WeakMap(),
    // invalidatedAtoms
    /* @__PURE__ */ new Set(),
    // changedAtoms
    /* @__PURE__ */ new Set(),
    // mountCallbacks
    /* @__PURE__ */ new Set(),
    // unmountCallbacks
    {},
    // storeHooks
    // atom interceptors
    Je,
    We,
    Qe,
    Oe,
    // building-block functions
    Ke,
    Ve,
    Ue,
    qe,
    Re,
    Ge,
    Ze,
    je,
    Ye,
    _e,
    $e,
    A2,
    t2,
    void 0
  ].map((y, t) => o[t] || y);
  return Xt.set(g, Object.freeze(c)), g;
}
const Lt = {};
let n2 = 0;
function X(o, g) {
  const c = `atom${++n2}`, y = {
    toString() {
      return (Lt ? "production" : void 0) !== "production" && this.debugLabel ? c + ":" + this.debugLabel : c;
    }
  };
  return typeof o == "function" ? y.read = o : (y.init = o, y.read = o2, y.write = r2), g && (y.write = g), y;
}
function o2(o) {
  return o(this);
}
function r2(o, g, c) {
  return g(
    this,
    typeof c == "function" ? c(o(this)) : c
  );
}
function Jt() {
  return e2();
}
let eA;
function i2() {
  return eA || (eA = Jt(), (Lt ? "production" : void 0) !== "production" && (globalThis.__JOTAI_DEFAULT_STORE__ || (globalThis.__JOTAI_DEFAULT_STORE__ = eA), globalThis.__JOTAI_DEFAULT_STORE__ !== eA && console.warn(
    "Detected multiple Jotai instances. It may cause unexpected behavior with the default store. https://github.com/pmndrs/jotai/discussions/2044"
  ))), eA;
}
const s2 = {}, NA = createContext(
  void 0
);
function Wt(o) {
  return useContext(NA) || i2();
}
function a2({
  children: o,
  store: g
}) {
  const c = useRef(null);
  return g ? createElement(NA.Provider, { value: g }, o) : (c.current === null && (c.current = Jt()), createElement(
    NA.Provider,
    {
      // TODO: If this is not a false positive, consider using useState instead of useRef like https://github.com/pmndrs/jotai/pull/2771
      // eslint-disable-next-line react-hooks/refs
      value: c.current
    },
    o
  ));
}
const IA = (o) => typeof (o == null ? void 0 : o.then) == "function", SA = (o) => {
  o.status || (o.status = "pending", o.then(
    (g) => {
      o.status = "fulfilled", o.value = g;
    },
    (g) => {
      o.status = "rejected", o.reason = g;
    }
  ));
}, c2 = kt.use || // A shim for older React versions
((o) => {
  if (o.status === "pending")
    throw o;
  if (o.status === "fulfilled")
    return o.value;
  throw o.status === "rejected" ? o.reason : (SA(o), o);
}), mA = /* @__PURE__ */ new WeakMap(), wt = (o, g) => {
  let c = mA.get(o);
  return c || (c = new Promise((y, t) => {
    let d = o;
    const E = (x) => (v) => {
      d === x && y(v);
    }, B = (x) => (v) => {
      d === x && t(v);
    }, D = () => {
      try {
        const x = g();
        IA(x) ? (mA.set(x, c), d = x, x.then(E(x), B(x)), BA(x, D)) : y(x);
      } catch (x) {
        t(x);
      }
    };
    o.then(E(o), B(o)), BA(o, D);
  }), mA.set(o, c)), c;
};
function T(o, g) {
  const { delay: c, unstable_promiseStatus: y = !kt.use } = {}, t = Wt(), [[d, E, B], D] = useReducer(
    (v) => {
      const F = t.get(o);
      return Object.is(v[0], F) && v[1] === t && v[2] === o ? v : [F, t, o];
    },
    void 0,
    () => [t.get(o), t, o]
  );
  let x = d;
  if ((E !== t || B !== o) && (D(), x = t.get(o)), useEffect(() => {
    const v = t.sub(o, () => {
      if (y)
        try {
          const F = t.get(o);
          IA(F) && SA(
            wt(F, () => t.get(o))
          );
        } catch {
        }
      if (typeof c == "number") {
        setTimeout(D, c);
        return;
      }
      D();
    });
    return D(), v;
  }, [t, o, c, y]), useDebugValue(x), IA(x)) {
    const v = wt(x, () => t.get(o));
    return y && SA(v), c2(v);
  }
  return x;
}
function R(o, g) {
  const c = Wt();
  return useCallback(
    (...y) => {
      if ((s2 ? "production" : void 0) !== "production" && !("write" in o))
        throw new Error("not writable atom");
      return c.set(o, ...y);
    },
    [c, o]
  );
}
function d2(o, g) {
  return [
    T(o),
    // We do wrong type assertion here, which results in throwing an error.
    R(o)
  ];
}
var l2 = Object.defineProperty, u2 = (o, g, c) => g in o ? l2(o, g, { enumerable: !0, configurable: !0, writable: !0, value: c }) : o[g] = c, h = (o, g, c) => u2(o, typeof g != "symbol" ? g + "" : g, c), I;
(function(o) {
  o.MAINNET = "mainnet", o.TESTNET = "testnet", o.SIGNET = "signet";
})(I || (I = {}));
class Qt {
  constructor(g) {
    h(this, "chains"), h(this, "option"), this.chains = g.chains, this.option = g;
  }
  // If constructor or init throws an exception, the wallet will be considered not installed.
  // This method is used to handle asynchronous initialization
  init() {
    return Promise.resolve();
  }
}
function S(o) {
  return o != null && o.getWindow ? o.getWindow() : window;
}
let xA;
function f2(o) {
  xA = o;
}
let Ot;
function g2(o) {
  Ot = o;
}
const tA = (o) => {
  if (xA)
    return xA + "/";
  if (o === I.MAINNET)
    return "https://mempool.space/api/";
  if (o === I.TESTNET)
    return "https://mempool.space/testnet/api/";
  if (o === I.SIGNET)
    return "https://mempool.space/signet/api/";
};
function w2(o) {
  const g = Object.keys(o);
  return g.length ? "?" + g.map((c) => encodeURIComponent(c) + "=" + (o[c] ? encodeURIComponent(o[c]) : "")).join("&") : "";
}
function h2(o, g) {
  return new URL(tA(o) + "address/" + g);
}
function ht(o) {
  return new URL(tA(o) + "tx");
}
function p2(o, g) {
  return new URL(tA(o) + "address/" + g + "/utxo");
}
function m2(o) {
  return new URL(tA(o) + "v1/fees/recommended");
}
function v2(o) {
  return new URL(tA(o) + "blocks/tip/height");
}
async function y2(o, g) {
  const c = await fetch(ht(o), {
    method: "POST",
    body: g
  });
  if (c.ok)
    return await c.text();
  try {
    const y = await c.text();
    alert(`Error: ${y} ${o} ${ht(o)}`);
    const t = y.split('"message":"')[1].split('"}')[0];
    throw y.includes("error") || y.includes("message") ? new Error(t) : new Error("Error broadcasting transaction. Please try again");
  } catch (y) {
    throw new Error((y == null ? void 0 : y.message) || y);
  }
}
async function b2(o, g) {
  const c = await fetch(h2(o, g));
  if (c.ok) {
    const y = await c.json();
    return y.chain_stats.funded_txo_sum - y.chain_stats.spent_txo_sum;
  } else {
    const y = await c.text();
    throw new Error(y);
  }
}
async function C2(o) {
  const g = await fetch(m2(o));
  if (g.ok)
    return await g.json();
  {
    const c = await g.text();
    throw new Error(c);
  }
}
async function B2(o) {
  const g = await fetch(v2(o)), c = await g.text();
  if (!g.ok)
    throw new Error(c);
  const y = Number(c);
  if (Number.isNaN(y))
    throw new Error("Invalid result returned");
  return y;
}
function P2(o, g) {
  return new URL(tA(o) + "v1/validate-address/" + g);
}
async function N2(o, g, c) {
  let y = null;
  try {
    y = await (await fetch(p2(o, g))).json();
  } catch (F) {
    throw new Error((F == null ? void 0 : F.message) || F);
  }
  const t = y.filter((F) => F.status.confirmed).sort((F, M) => M.value - F.value);
  let d = t;
  if (c) {
    for (var E = 0, B = 0; B < t.length && (E += t[B].value, !(E > c)); ++B)
      ;
    if (E < c)
      return [];
    d = t.slice(0, B + 1);
  }
  const D = await (await fetch(P2(o, g))).json(), { isvalid: x, scriptPubKey: v } = D;
  if (!x)
    throw new Error("Invalid address");
  return d.map((F) => ({
    txid: F.txid,
    vout: F.vout,
    value: F.value,
    scriptPubKey: v
  }));
}
async function I2(o) {
  const g = await fetch(`${Ot || "https://apps-prod.unyx.tech/api"}/openapi/bitcoin/inscriptions${w2(o)}`);
  if (g.ok)
    return (await g.json()).result;
  {
    const c = await g.text();
    throw new Error(c);
  }
}
let pt = !1;
function at() {
  pt || (pt = !0, initEccLib(ye));
}
class z extends Qt {
  constructor(g, c) {
    var y, t, d, E, B, D;
    super(g), h(this, "bitcoinNetworkProvider"), this.bitcoinNetworkProvider = c, at(), f2((d = (t = (y = this.chains) == null ? void 0 : y[0]) == null ? void 0 : t.backendUrls) == null ? void 0 : d.mempoolUrl), g2((D = (B = (E = this.chains) == null ? void 0 : E[0]) == null ? void 0 : B.backendUrls) == null ? void 0 : D.inscriptionUrl);
  }
  /**
   * Gets the address of the connected wallet.
   * @returns A promise that resolves to the address of the connected wallet.
   */
  async getAddress() {
    const g = await this.bitcoinNetworkProvider.getAccounts() || [];
    if (!(g != null && g[0]))
      throw new Error("Wallet not connected");
    return g[0];
  }
  /**
   * Gets the public key of the connected wallet.
   * @returns A promise that resolves to the public key of the connected wallet.
   */
  async getPublicKeyHex() {
    return await this.bitcoinNetworkProvider.getPublicKey();
  }
  /**
   * Signs the given PSBT in hex format.
   * @param psbtHex - The hex string of the unsigned PSBT to sign.
   * @param options - Optional parameters for signing the PSBT.
   * @returns A promise that resolves to the hex string of the signed PSBT.
   */
  async signPsbt(g, c) {
    return await this.bitcoinNetworkProvider.signPsbt(g, c);
  }
  /**
   * Signs multiple PSBTs in hex format.
   * @param psbtsHexes - The hex strings of the unsigned PSBTs to sign.
   * @param options - Optional parameters for signing the PSBTs.
   * @returns A promise that resolves to an array of hex strings, each representing a signed PSBT.
   */
  async signPsbts(g, c) {
    return await this.bitcoinNetworkProvider.signPsbts(g, c);
  }
  /**
   * Gets the network of the current account.
   * @returns A promise that resolves to the network of the current account.
   */
  async getNetwork() {
    return (await this.bitcoinNetworkProvider.getNetwork()).replace("livenet", "mainnet");
  }
  /**
   * Signs a message using BIP-322 simple.
   * @param message - The message to sign.
   * @returns A promise that resolves to the signed message.
   */
  async signMessageBIP322(g) {
    return await this.signMessage(g, "bip322-simple");
  }
  async signMessage(g, c = "ecdsa") {
    return await this.bitcoinNetworkProvider.signMessage(g, c);
  }
  /**
   * Registers an event listener for the specified event.
   * At the moment, only the "accountChanged" event is supported.
   * @param eventName - The name of the event to listen for.
   * @param callBack - The callback function to be executed when the event occurs.
   */
  on(g, c) {
    var y, t;
    (t = (y = this.bitcoinNetworkProvider) == null ? void 0 : y.on) == null || t.call(y, g, c);
  }
  off(g, c) {
    var y, t;
    (t = (y = this.bitcoinNetworkProvider) == null ? void 0 : y.off) == null || t.call(y, g, c);
  }
  async switchNetwork(g) {
    await this.bitcoinNetworkProvider.switchNetwork(g);
  }
  async sendBitcoin(g, c) {
    return await this.bitcoinNetworkProvider.sendBitcoin(g, Number(c));
  }
  /**
   * Retrieves the inscriptions for the connected wallet.
   * @returns A promise that resolves to an array of inscriptions.
   */
  async getInscriptions(g, c) {
    return await I2({
      address: await this.getAddress(),
      // @ts-ignore
      networkType: (await this.getNetwork()).toUpperCase(),
      cursor: g,
      size: c
    });
  }
  /**
   * Retrieves the network fees.
   * @returns A promise that resolves to the network fees.
   */
  async getNetworkFees() {
    return await C2(await this.getNetwork());
  }
  /**
   * Pushes a transaction to the network.
   * @param txHex - The hexadecimal representation of the transaction.
   * @returns A promise that resolves to a string representing the transaction ID.
   */
  async pushTx(g) {
    return await y2(await this.getNetwork(), g);
  }
  /**
   * Retrieves the unspent transaction outputs (UTXOs) for a given address and amount.
   *
   * If the amount is provided, it will return UTXOs that cover the specified amount.
   * If the amount is not provided, it will return all available UTXOs for the address.
   *
   * @param address - The address to retrieve UTXOs for.
   * @param amount - Optional amount of funds required.
   * @returns A promise that resolves to an array of UTXOs.
   */
  async getUtxos(g, c) {
    return await N2(await this.getNetwork(), g, c);
  }
  /**
   * Retrieves the tip height of the BTC chain.
   * @returns A promise that resolves to the block height.
   */
  async getBTCTipHeight() {
    return await B2(await this.getNetwork());
  }
  /**
   * Gets the balance for the connected wallet address.
   * By default, this method will return the mempool balance if not implemented by the child class.
   * @returns A promise that resolves to the balance of the wallet.
   */
  async getBalance() {
    return await b2(await this.getNetwork(), await this.getAddress());
  }
}
const Kt = "data:image/svg+xml,%3csvg%20width='28'%20height='28'%20viewBox='0%200%2028%2028'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%20xmlns:xlink='http://www.w3.org/1999/xlink'%3e%3crect%20width='28'%20height='28'%20fill='url(%23pattern0_260_7740)'/%3e%3cdefs%3e%3cpattern%20id='pattern0_260_7740'%20patternContentUnits='objectBoundingBox'%20width='1'%20height='1'%3e%3cuse%20xlink:href='%23image0_260_7740'%20transform='scale(0.0208333)'/%3e%3c/pattern%3e%3cimage%20id='image0_260_7740'%20width='48'%20height='48'%20xlink:href='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAMKADAAQAAAABAAAAMAAAAADbN2wMAAACsUlEQVRoBe1avY7aQBBeW0aAAOGKhsaRgAYQLigoED9PEOUJcm9CHiV5goQngOvo8LU05xRQ0MQIEP/yzUQyuvPv+m5t2TqvtAIv45lvvtn1aDxwxGYMBgPxer1+hykfDgf5eDyKuq5LNqKBLaVSKRVsaoVCQU2n03/O5/PjbDZTPQ32er1RpVL5VywWdRCOxMzlcnqtVtMRm6MDwLrUbrfnKBwV4GYcmUxGR4ydTkeyOII/QKgiC95wxnDijQMYmjiAN5zAXdLtdn+gExxundVq9bxYLPA6NqNarWrlcvkLf7vdBsvlMjbADaDr9Vq8XC4PPDyevu73e2M9Np+bzYbAY77F73Y7KTaoTUAhP8kCrImmddtLWZaJKLqLTqdT23vNi6x0nU4nkWCCAAOuEw46JEXvAcBc9aAdlroQO29m5yPXXhHyo5tWF1MH/ABkJZs4wIrJ9+pJIvBe5ljd9zkioGkaK8IIS10ICjOx51AUhQyHQ1c5BNbv98loNHKVG4/HVLrQJtWgycSgyDPDosxkMvFM1yhDq89LjnkmBoOhj89xiEOn1YfBJAI+yApENIlAILT6UEqVyFAfTRmIScproAyNLtryNCkpXzNOWwa+vsfpO62u5BA7MRjWehKBsJh2spNEwImZsNapIsCyDGSpC0kSeJ5X4VOC6ThoS0qaMpClLuxkklarNQfkzMq8MHXV6/U5D72xJ0fqI/5DPp//y0MYFOgJRxyqFR40+giQ/xsd+Fkqldi9+LHaCmQFGnwEu/f/lWPLMsoNbgD55oxir9hos97ZiWuj+54H4EB8azabCuyru1NR+4L7vtFoKIDV+TUhhgbfeEVpS+EfT/APKJZtAwxzdixj9x4b4NhD3m63Esdx2FSW7GSDWgObKux1LZvNKoIg4PwFZablYfMCcyEt0t7W+RoAAAAASUVORK5CYII='/%3e%3c/defs%3e%3c/svg%3e";
class S2 extends z {
  constructor(g) {
    const c = S(g).okxwallet, y = c == null ? void 0 : c.bitcoin;
    if (!y)
      throw new Error("OKX Wallet extension not found");
    super(g, y), h(this, "okxWalletInfo"), h(this, "okxWallet"), h(this, "networkEnv", I.MAINNET), h(this, "getAddress", async () => await this.bitcoinNetworkProvider.getSelectedAddress()), h(this, "getNetwork", async () => {
      if (!this.networkEnv)
        throw new Error("Network not set");
      return this.networkEnv;
    }), h(this, "getPublicKeyHex", async () => {
      if (!this.okxWalletInfo)
        throw new Error("OKX Wallet not connected");
      return this.okxWalletInfo.publicKeyHex;
    }), h(this, "getBalance", async () => (await this.bitcoinNetworkProvider.getBalance()).confirmed), h(this, "pushTx", async (t) => await this.bitcoinNetworkProvider.pushTx(t)), this.okxWallet = c;
  }
  async connectWallet() {
    var g;
    try {
      await this.okxWallet.enable();
    } catch (d) {
      throw (g = d == null ? void 0 : d.message) != null && g.includes("rejected") ? new Error("Connection to OKX Wallet was rejected") : new Error(d == null ? void 0 : d.message);
    }
    let c = null;
    try {
      c = await this.bitcoinNetworkProvider.connect();
    } catch {
      throw new Error(`BTC ${this.networkEnv} is not enabled in OKX Wallet`);
    }
    const { address: y, compressedPublicKey: t } = c;
    if (t && y)
      return this.okxWalletInfo = {
        publicKeyHex: t,
        address: y
      }, this;
    throw new Error("Could not connect to OKX Wallet");
  }
  async switchNetwork(g) {
    switch (g) {
      case I.MAINNET:
        this.bitcoinNetworkProvider = this.okxWallet.bitcoin;
        break;
      case I.TESTNET:
        this.bitcoinNetworkProvider = this.okxWallet.bitcoinTestnet;
        break;
      case I.SIGNET:
        this.bitcoinNetworkProvider = this.okxWallet.bitcoinSignet;
        break;
      default:
        throw new Error("Unsupported network");
    }
    this.networkEnv = g, await this.connectWallet();
  }
  async sendBitcoin(g, c) {
    return await this.bitcoinNetworkProvider.sendBitcoin(
      g,
      // @ts-ignore
      BigInt(c)
    );
  }
  async getInscriptions(g, c) {
    return await this.bitcoinNetworkProvider.getInscriptions(g, c);
  }
  getWalletProviderIcon() {
    return Promise.resolve(DA.img);
  }
  getWalletProviderName() {
    return Promise.resolve(DA.name);
  }
}
const DA = {
  id: "bitcoin_okx",
  img: Kt,
  name: "OKX",
  chainType: "bitcoin",
  connectProvider: S2,
  type: "extension"
}, Vt = "data:image/svg+xml,%3csvg%20width='42'%20height='42'%20viewBox='0%200%2042%2042'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20clip-path='url(%23clip0_6_1029)'%3e%3cg%20clip-path='url(%23clip1_6_1029)'%3e%3cg%20clip-path='url(%23clip2_6_1029)'%3e%3cpath%20d='M28.0078%203.74221L36.5506%2012.201C37.2772%2012.9192%2037.6342%2013.6458%2037.6216%2014.3808C37.609%2015.1116%2037.2982%2015.7836%2036.685%2016.3884C36.0466%2017.0226%2035.3578%2017.346%2034.6186%2017.3586C33.8794%2017.3712%2033.1486%2017.0142%2032.4178%2016.296L23.6818%207.64401C22.6906%206.66121%2021.733%205.96401%2020.809%205.55661C19.8892%205.14921%2018.919%205.08621%2017.9026%205.36341C16.8862%205.64061%2015.7942%206.35881%2014.6266%207.51801C13.0138%209.11401%2012.2452%2010.6134%2012.325%2012.0162C12.4048%2013.419%2013.2028%2014.868%2014.7232%2016.3758L23.5306%2025.0992C24.2656%2025.8258%2024.6268%2026.5524%2024.6142%2027.2748C24.6016%2027.9972%2024.2866%2028.6692%2023.665%2029.2824C23.0434%2029.8956%2022.363%2030.219%2021.6154%2030.2442C20.872%2030.2694%2020.1328%2029.9166%2019.3978%2029.19L10.8634%2020.7312C9.4732%2019.3536%208.4694%2018.0516%207.852%2016.8252C7.2346%2015.5988%207.0036%2014.2086%207.1632%2012.6588C7.306%2011.3316%207.7344%2010.0464%208.44%208.79901C9.1498%207.55161%2010.162%206.27901%2011.4766%204.97281C13.0432%203.41881%2014.5384%202.23021%2015.9664%201.40281C17.3944%200.575413%2018.772%200.113413%2020.1034%200.0168127C21.4348%20-0.0797873%2022.7494%200.184813%2024.0514%200.810613C25.3492%201.43641%2026.668%202.41081%2028.012%203.74221H28.0078Z'%20fill='url(%23paint0_linear_6_1029)'/%3e%3cpath%20d='M14.6141%2037.8798L6.07132%2029.421C5.34472%2028.7028%204.98772%2027.9762%205.00032%2027.2412C5.01292%2026.5062%205.32372%2025.8384%205.93692%2025.2336C6.57532%2024.5994%207.26412%2024.276%208.00332%2024.2634C8.74252%2024.2508%209.47332%2024.6036%2010.2041%2025.326L18.9401%2033.978C19.9355%2034.9608%2020.8889%2035.658%2021.8129%2036.0654C22.7369%2036.4728%2023.7029%2036.5358%2024.7193%2036.2586C25.7357%2035.9814%2026.8277%2035.2632%2027.9953%2034.104C29.6081%2032.508%2030.3767%2031.0086%2030.2969%2029.6058C30.2171%2028.203%2029.4191%2026.7498%2027.8987%2025.2462L23.2073%2020.6388C22.4723%2019.9122%2022.1111%2019.1856%2022.1237%2018.4632C22.1363%2017.7408%2022.4513%2017.0688%2023.0729%2016.4556C23.6945%2015.8424%2024.3749%2015.519%2025.1225%2015.4938C25.8659%2015.4686%2026.6051%2015.8214%2027.3401%2016.548L31.7627%2020.8908C33.1529%2022.2684%2034.1567%2023.5704%2034.7741%2024.7968C35.3915%2026.0232%2035.6225%2027.4134%2035.4629%2028.9632C35.3201%2030.2904%2034.8917%2031.5756%2034.1861%2032.823C33.4763%2034.0704%2032.4641%2035.343%2031.1495%2036.6492C29.5829%2038.2032%2028.0877%2039.3918%2026.6597%2040.2192C25.2317%2041.0466%2023.8541%2041.5086%2022.5227%2041.6052C21.1913%2041.7018%2019.8767%2041.4372%2018.5747%2040.8114C17.2769%2040.1856%2015.9539%2039.2112%2014.6141%2037.8798Z'%20fill='url(%23paint1_linear_6_1029)'/%3e%3cpath%20d='M19.9401%2016.0524C21.6729%2016.0524%2023.0775%2014.6477%2023.0775%2012.915C23.0775%2011.1822%2021.6729%209.77759%2019.9401%209.77759C18.2074%209.77759%2016.8027%2011.1822%2016.8027%2012.915C16.8027%2014.6477%2018.2074%2016.0524%2019.9401%2016.0524Z'%20fill='url(%23paint2_radial_6_1029)'/%3e%3c/g%3e%3c/g%3e%3c/g%3e%3cdefs%3e%3clinearGradient%20id='paint0_linear_6_1029'%20x1='35.1508'%20y1='8.6366'%20x2='8.6783'%20y2='20.4003'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='%23070100'/%3e%3cstop%20offset='0.36'%20stop-color='%2377390D'/%3e%3cstop%20offset='0.67'%20stop-color='%23EA8101'/%3e%3cstop%20offset='1'%20stop-color='%23F4B852'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint1_linear_6_1029'%20x1='8.20796'%20y1='33.2636'%20x2='38.8824'%20y2='24.1302'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='%23070100'/%3e%3cstop%20offset='0.37'%20stop-color='%2377390D'/%3e%3cstop%20offset='0.67'%20stop-color='%23EA8101'/%3e%3cstop%20offset='1'%20stop-color='%23F4FB52'/%3e%3c/linearGradient%3e%3cradialGradient%20id='paint2_radial_6_1029'%20cx='0'%20cy='0'%20r='1'%20gradientUnits='userSpaceOnUse'%20gradientTransform='translate(19.9359%2012.9192)%20scale(3.1374)'%3e%3cstop%20stop-color='%23F4B852'/%3e%3cstop%20offset='0.33'%20stop-color='%23EA8101'/%3e%3cstop%20offset='0.64'%20stop-color='%2377390D'/%3e%3cstop%20offset='1'%20stop-color='%23070100'/%3e%3c/radialGradient%3e%3cclipPath%20id='clip0_6_1029'%3e%3crect%20width='42'%20height='42'%20fill='white'/%3e%3c/clipPath%3e%3cclipPath%20id='clip1_6_1029'%3e%3crect%20width='42'%20height='42'%20fill='white'/%3e%3c/clipPath%3e%3cclipPath%20id='clip2_6_1029'%3e%3crect%20width='42'%20height='42'%20fill='white'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e";
class x2 extends z {
  constructor(g) {
    const c = S(g).unisat_wallet;
    if (!c)
      throw new Error("UniSat Wallet extension not found");
    super(g, c), h(this, "connectWallet", async () => {
      const y = this.bitcoinNetworkProvider;
      try {
        const t = await y.requestAccounts(), d = await y.getPublicKey();
        if (!t || !d)
          throw new Error("Could not connect to unisat wallet");
        return this;
      } catch {
        throw new Error("Failed to connect to unisat wallet");
      }
    }), h(this, "getBalance", async () => (await this.bitcoinNetworkProvider.getBalance()).confirmed), h(this, "pushTx", async (y) => await this.bitcoinNetworkProvider.pushTx(y)), h(this, "signPsbt", async (y, t) => {
      const d = {
        curNetwork: await this.getNetwork(),
        curAddress: await this.getAddress(),
        curPublicKey: await this.getPublicKeyHex()
      };
      if (!d.curAddress)
        throw new Error("Unisat Wallet not connected");
      if (!y)
        throw new Error("psbt hex is required");
      try {
        const E = {
          ...this.getSignPsbtDefaultOptions(y, d),
          ...t
        };
        return await this.bitcoinNetworkProvider.signPsbt(
          y,
          // @ts-ignore
          E
        );
      } catch (E) {
        throw new Error((E == null ? void 0 : E.message) || E);
      }
    }), h(this, "signPsbts", async (y, t) => {
      const d = {
        curNetwork: await this.getNetwork(),
        curAddress: await this.getAddress(),
        curPublicKey: await this.getPublicKeyHex()
      };
      if (!d.curAddress)
        throw new Error("Unisat Wallet not connected");
      if (!y && !Array.isArray(y))
        throw new Error("psbts hexes are required");
      try {
        const E = y.map((D) => this.getSignPsbtDefaultOptions(D, d)), B = t == null ? void 0 : t.map((D, x) => ({
          ...E[x],
          ...D
        }));
        return await this.bitcoinNetworkProvider.signPsbts(
          y,
          // @ts-ignore
          B
        );
      } catch (E) {
        throw new Error((E == null ? void 0 : E.message) || E);
      }
    });
  }
  async switchNetwork(g) {
    return await this.bitcoinNetworkProvider.switchNetwork(g.replace("mainnet", "livenet"));
  }
  async getNetwork() {
    return (await this.bitcoinNetworkProvider.getNetwork()).replace("livenet", "mainnet").replace("unknown", "signet");
  }
  async sendBitcoin(g, c) {
    return await this.bitcoinNetworkProvider.sendBitcoin(g, c);
  }
  getSignPsbtDefaultOptions(g, c) {
    const y = [], t = Psbt.fromHex(g), { curNetwork: d, curPublicKey: E, curAddress: B } = c;
    return t.data.inputs.forEach((D, x) => {
      let v = !1;
      if (D.witnessUtxo && D.witnessUtxo.script) {
        let F = networks$2.bitcoin;
        (d === I.TESTNET || d === I.SIGNET) && (F = networks$2.testnet);
        let M;
        try {
          M = address$2.fromOutputScript(D.witnessUtxo.script, F);
        } catch (U) {
          if (U instanceof Error && U.message.toLowerCase().includes("has no matching address"))
            M = address$2.fromOutputScript(D.witnessUtxo.script, F);
          else
            throw new Error(U);
        }
        (M.indexOf("tb1p") === 0 || M.indexOf("bc1p") === 0) && M === B && (v = !0);
      }
      D.finalScriptSig || D.finalScriptWitness || y.push({
        index: x,
        publicKey: E,
        sighashTypes: void 0,
        useTweakedSigner: v
      });
    }), {
      autoFinalized: !0,
      toSignInputs: y
    };
  }
  async getInscriptions(g, c) {
    return await this.bitcoinNetworkProvider.getInscriptions(g, c);
  }
  getWalletProviderName() {
    return Promise.resolve(kA.name);
  }
  getWalletProviderIcon() {
    return Promise.resolve(kA.img);
  }
}
const kA = {
  id: "bitcoin_unisat",
  img: Vt,
  name: "Unisat",
  chainType: "bitcoin",
  connectProvider: x2,
  type: "extension"
}, Ut = "data:image/png;base64,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", D2 = "tomo_btc";
class k2 extends z {
  constructor(g) {
    const c = S(g)[D2];
    if (!c)
      throw new Error("Tomo Wallet extension not found");
    super(g, c), h(this, "connectWallet", async () => {
      const y = "1.2.0";
      if (!this.bitcoinNetworkProvider)
        throw new Error("Tomo Wallet extension not found");
      if (this.bitcoinNetworkProvider.getVersion && await this.bitcoinNetworkProvider.getVersion() < y)
        throw new Error("Please update Tomo Wallet to the latest version");
      let t = null, d = null;
      try {
        if (t = await this.bitcoinNetworkProvider.connectWallet(), d = await this.bitcoinNetworkProvider.getPublicKey(), !t || t.length === 0 || !d)
          throw new Error("BTC is not enabled in Tomo Wallet");
      } catch {
        throw new Error("BTC is not enabled in Tomo Wallet");
      }
      return this;
    }), h(this, "getBalance", async () => await this.bitcoinNetworkProvider.getBalance()), h(this, "pushTx", async (y) => await this.bitcoinNetworkProvider.pushTx(y));
  }
  getWalletProviderName() {
    return Promise.resolve(TA.name);
  }
  getWalletProviderIcon() {
    return Promise.resolve(TA.img);
  }
}
const TA = {
  id: "bitcoin_tomo",
  img: Ut,
  name: "Tomo",
  chainType: "bitcoin",
  connectProvider: k2,
  type: "extension"
}, qt = "data:image/png;base64,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", T2 = {
  [I.MAINNET]: "livenet",
  [I.TESTNET]: "testnet",
  [I.SIGNET]: "signet"
}, E2 = "bitkeep";
class z2 extends z {
  constructor(g) {
    var c;
    const y = (
      // @ts-ignore
      (c = S(g)[E2]) == null ? void 0 : c.unisat
    );
    if (!y)
      throw new Error("Bitget Wallet extension not found");
    super(g, y), h(this, "connectWallet", async () => {
      var t;
      try {
        await this.bitcoinNetworkProvider.requestAccounts();
      } catch (B) {
        throw (t = B == null ? void 0 : B.message) != null && t.includes("rejected") ? new Error("Connection to Bitget Wallet was rejected") : new Error(B == null ? void 0 : B.message);
      }
      const d = await this.getAddress(), E = await this.getPublicKeyHex();
      if (!d || !E)
        throw new Error("Could not connect to Bitget Wallet");
      return this;
    }), h(this, "signPsbt", async (t, d) => {
      const E = {
        method: "signPsbt",
        params: {
          // @ts-ignore
          from: this.bitcoinNetworkProvider.selectedAddress,
          __internalFunc: "__signPsbt_babylon",
          psbtHex: t,
          options: d || {
            autoFinalized: !0
          }
        }
      }, B = await this.bitcoinNetworkProvider.request("dappsSign", E), D = Psbt.fromHex(B);
      return D.data.inputs.every((x) => x.finalScriptWitness || x.finalScriptSig) || D.finalizeAllInputs(), D.toHex();
    }), h(this, "signPsbts", async (t, d) => {
      if (!t && !Array.isArray(t))
        throw new Error("params error");
      const E = d || t.map((D) => ({
        autoFinalized: !0
      })), B = {
        method: "signPsbt",
        params: {
          // @ts-ignore
          from: this.bitcoinNetworkProvider.selectedAddress,
          __internalFunc: "__signPsbts_babylon",
          psbtHex: "_",
          psbtHexs: t,
          options: E
        }
      };
      try {
        let D = await this.bitcoinNetworkProvider.request("dappsSign", B);
        return D = D.split(","), D.map((x) => {
          const v = Psbt.fromHex(x);
          return v.data.inputs.every((F) => F.finalScriptWitness || F.finalScriptSig) || v.finalizeAllInputs(), v.toHex();
        });
      } catch (D) {
        throw new Error(D == null ? void 0 : D.message);
      }
    });
  }
  async switchNetwork(g) {
    return await this.bitcoinNetworkProvider.switchNetwork(T2[g]);
  }
  async getInscriptions(g, c) {
    var y, t;
    return await ((t = (y = this.bitcoinNetworkProvider) == null ? void 0 : y.getInscriptions) == null ? void 0 : t.call(y, g, c));
  }
  getWalletProviderName() {
    return Promise.resolve(EA.name);
  }
  getWalletProviderIcon() {
    return Promise.resolve(EA.img);
  }
}
const EA = {
  id: "bitcoin_bitget",
  img: qt,
  name: "Bitget Wallet",
  chainType: "bitcoin",
  connectProvider: z2,
  type: "extension"
}, Rt = "data:image/svg+xml,%3csvg%20width='128'%20height='128'%20viewBox='0%200%20128%20128'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20clip-path='url(%23clip0_45922_88)'%3e%3cpath%20d='M127.61%2063.8049C127.61%20107.853%20107.853%20127.61%2063.8049%20127.61C19.7568%20127.61%200%20107.853%200%2063.8049C0%2019.7568%2019.7568%200%2063.8049%200C107.853%200%20127.61%2019.7568%20127.61%2063.8049Z'%20fill='%233BD23D'/%3e%3cpath%20d='M69.5699%2027.0557L51.8197%2027.0557L48.7056%2036.4719H58.5645L58.5645%2056.3063H69.5699V27.0557Z'%20fill='black'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M84.0486%2080.3111C84.0486%2091.4912%2074.9854%20100.554%2063.8053%20100.554C52.6253%20100.554%2043.5621%2091.4912%2043.5621%2080.3111C43.5621%2069.1311%2052.6253%2060.0678%2063.8053%2060.0678C74.9854%2060.0678%2084.0486%2069.1311%2084.0486%2080.3111ZM74.8584%2080.3111C74.8584%2086.4155%2069.9097%2091.3641%2063.8053%2091.3641C57.7008%2091.3641%2052.7522%2086.4155%2052.7522%2080.3111C52.7522%2074.2066%2057.7008%2069.258%2063.8053%2069.258C69.9097%2069.258%2074.8584%2074.2066%2074.8584%2080.3111Z'%20fill='black'/%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_45922_88'%3e%3crect%20width='128'%20height='128'%20fill='white'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e", F2 = "$onekey", H2 = {
  [I.MAINNET]: "livenet",
  [I.TESTNET]: "testnet",
  [I.SIGNET]: "signet"
};
class M2 extends z {
  constructor(g) {
    var c;
    const y = (c = S(g)[F2]) == null ? void 0 : c.btcwallet;
    if (!y)
      throw new Error("OneKey Wallet extension not found");
    super(g, y), h(this, "getBalance", async () => await this.getNetwork() === I.MAINNET ? await this.bitcoinNetworkProvider.getBalance() : await super.getBalance()), h(this, "pushTx", async (t) => await this.bitcoinNetworkProvider.pushTx(t));
  }
  async connectWallet() {
    return await this.bitcoinNetworkProvider.connectWallet();
  }
  async switchNetwork(g) {
    return await this.bitcoinNetworkProvider.switchNetwork(H2[g]);
  }
  getWalletProviderName() {
    return Promise.resolve(zA.name);
  }
  getWalletProviderIcon() {
    return Promise.resolve(zA.img);
  }
}
const zA = {
  id: "bitcoin_onekey",
  img: Rt,
  name: "OneKey",
  chainType: "bitcoin",
  connectProvider: M2,
  type: "extension"
};
I.MAINNET;
const fA = (o) => {
  switch (o) {
    case I.MAINNET:
      return networks$2.bitcoin;
    case I.TESTNET:
    case I.SIGNET:
      return networks$2.testnet;
    default:
      throw new Error("Unsupported network");
  }
}, X2 = "data:image/svg+xml,%3csvg%20width='513'%20height='512'%20viewBox='0%200%20513%20512'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20clip-path='url(%23clip0_893_2592)'%3e%3cmask%20id='mask0_893_2592'%20style='mask-type:luminance'%20maskUnits='userSpaceOnUse'%20x='0'%20y='0'%20width='513'%20height='512'%3e%3cpath%20d='M512.319%200H0.319336V512H512.319V0Z'%20fill='white'/%3e%3c/mask%3e%3cg%20mask='url(%23mask0_893_2592)'%3e%3cpath%20d='M256.319%20512C397.704%20512%20512.319%20397.385%20512.319%20256C512.319%20114.615%20397.704%200%20256.319%200C114.934%200%200.319336%20114.615%200.319336%20256C0.319336%20397.385%20114.934%20512%20256.319%20512Z'%20fill='url(%23paint0_linear_893_2592)'/%3e%3cpath%20d='M417.436%20158.291C428.084%20302.507%20335.382%20370.67%20252.277%20377.939C175.014%20384.696%20102.287%20337.221%2095.9067%20264.279C90.6436%20204.017%20127.889%20178.361%20157.152%20175.804C187.249%20173.165%20212.542%20193.921%20214.736%20219.052C216.849%20243.213%20201.773%20254.211%20191.288%20255.126C182.996%20255.853%20172.564%20250.819%20171.622%20240.01C170.814%20230.722%20174.341%20229.457%20173.479%20219.59C171.945%20202.024%20156.627%20199.978%20148.241%20200.705C138.092%20201.594%20119.678%20213.439%20122.262%20242.944C124.86%20272.705%20153.396%20296.221%20190.803%20292.95C231.171%20289.423%20259.276%20257.993%20261.39%20213.91C261.37%20211.575%20261.862%20209.264%20262.83%20207.139L262.843%20207.086C263.278%20206.162%20263.787%20205.275%20264.364%20204.434C265.226%20203.142%20266.33%20201.715%20267.756%20200.153C267.77%20200.113%20267.77%20200.113%20267.797%20200.113C268.833%20198.942%20270.085%20197.677%20271.498%20196.317C289.132%20179.68%20352.638%20140.443%20412.698%20152.867C413.968%20153.139%20415.115%20153.814%20415.969%20154.792C416.823%20155.77%20417.337%20156.997%20417.436%20158.291Z'%20fill='white'/%3e%3c/g%3e%3c/g%3e%3cdefs%3e%3clinearGradient%20id='paint0_linear_893_2592'%20x1='512.013'%20y1='86.519'%20x2='17.5951'%20y2='279.502'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='%230CC5FF'/%3e%3cstop%20offset='1'%20stop-color='%23007FFF'/%3e%3c/linearGradient%3e%3cclipPath%20id='clip0_893_2592'%3e%3crect%20width='513'%20height='512'%20fill='white'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e", L2 = "bitcoin";
class J2 extends z {
  constructor(g) {
    var c;
    const y = (c = S(g)) == null ? void 0 : c[L2];
    if (!y)
      throw new Error("imToken Wallet not found");
    super(g, y), h(this, "walletInfo"), h(this, "connectWallet", async () => {
      const t = (await this.bitcoinNetworkProvider.request({
        method: "btc_requestAccounts"
      }))[0], d = await this.bitcoinNetworkProvider.request({
        method: "btc_getPublicKey"
      });
      if (!t || !d)
        throw new Error("Could not connect to imToken Wallet");
      return this.walletInfo = {
        publicKeyHex: d,
        address: t
      }, this;
    }), h(this, "getAddress", async () => (await this.bitcoinNetworkProvider.request({
      method: "btc_requestAccounts"
    }))[0]), h(this, "getPublicKeyHex", async () => {
      if (!this.walletInfo)
        throw new Error("imToken Wallet not connected");
      return this.walletInfo.publicKeyHex;
    }), h(this, "signPsbt", async (t, d) => await this.bitcoinNetworkProvider.request({
      method: "btc_signPsbt",
      params: [t, d]
    })), h(this, "signPsbts", async (t, d) => {
      if (!t && !Array.isArray(t))
        throw new Error("params error");
      return await this.bitcoinNetworkProvider.request({
        method: "btc_signPsbts",
        params: [t, d]
      });
    }), h(this, "getNetwork", async () => await this.bitcoinNetworkProvider.request({
      method: "btc_getNetwork",
      params: []
    })), h(this, "on", (t, d) => {
      var E, B, D, x;
      return t === "accountChanged" ? (B = (E = this.bitcoinNetworkProvider) == null ? void 0 : E.on) == null ? void 0 : B.call(E, "accountsChanged", d) : (x = (D = this.bitcoinNetworkProvider) == null ? void 0 : D.on) == null ? void 0 : x.call(D, t, d);
    }), h(this, "off", (t, d) => {
      var E, B, D, x;
      return t === "accountChanged" ? (B = (E = this.bitcoinNetworkProvider) == null ? void 0 : E.off) == null ? void 0 : B.call(E, "accountsChanged", d) : (x = (D = this.bitcoinNetworkProvider) == null ? void 0 : D.off) == null ? void 0 : x.call(D, t, d);
    }), h(this, "getBalance", async () => {
      var t;
      return await this.getNetwork() === I.MAINNET ? await this.bitcoinNetworkProvider.request({
        method: "btc_getBalance",
        params: [(t = this.walletInfo) == null ? void 0 : t.address]
      }) : await super.getBalance();
    });
  }
  async signMessage(g, c = "ecdsa") {
    return await this.bitcoinNetworkProvider.request({
      method: "btc_signMessage",
      params: [g, c]
    });
  }
  async sendBitcoin(g, c) {
    try {
      const y = await this.getAddress(), t = await this.getUtxos(y);
      t.sort((U, L) => U.value - L.value);
      let d = 0;
      const E = [], B = (await this.getNetworkFees()).fastestFee;
      let D = 0;
      for (const U of t)
        if (E.push({
          hash: U.txid,
          index: U.vout,
          witnessUtxo: {
            script: Buffer.from(U.scriptPubKey, "hex"),
            value: U.value
          }
        }), d += U.value, D = (E.length * 180 + 68 + 10) * B, d >= c + D)
          break;
      if (d < c + D)
        throw new Error("1Insufficient funds for the transaction.");
      if (E.length === 0)
        throw new Error("No inputs available for the transaction.");
      const x = d - c - D, v = new Psbt({ network: fA(await this.getNetwork()) });
      for (const U of E)
        v.addInput(U);
      if (v.addOutput({
        address: g,
        value: c
      }), x > 0) {
        const U = await this.getAddress();
        v.addOutput({
          address: U,
          value: x
        });
      }
      const F = await this.signPsbt(v.toHex()), M = Psbt.fromHex(F).extractTransaction();
      return await this.pushTx(M.toHex());
    } catch (y) {
      throw y;
    }
  }
  async switchNetwork(g) {
    throw new Error("Method not implemented.");
  }
  getWalletProviderName() {
    return Promise.resolve(FA.name);
  }
  getWalletProviderIcon() {
    return Promise.resolve(FA.img);
  }
}
const FA = {
  id: "bitcoin_imtoken",
  img: X2,
  name: "imToken",
  chainType: "bitcoin",
  connectProvider: J2,
  type: "injected"
};
class sA {
  /**
   * Compute the message hash as specified in the BIP-322.
   * The standard is specified in BIP-340 as:
   *      The function hashtag(x) where tag is a UTF-8 encoded tag name and x is a byte array returns the 32-byte hash SHA256(SHA256(tag) || SHA256(tag) || x).
   * @param message Message to be hashed
   * @returns Hashed message
   */
  static hashMessage(g) {
    const { sha256: c } = pA.crypto, y = c(this.TAG);
    return c(Buffer.concat([y, y, Buffer.from(g)]));
  }
  /**
   * Build a to_spend transaction using simple signature in accordance to the BIP-322.
   * @param message Message to be signed using BIP-322
   * @param scriptPublicKey The script public key for the signing wallet
   * @returns Bitcoin transaction that correspond to the to_spend transaction
   */
  static buildToSpendTx(g, c) {
    const y = new pA.Psbt();
    y.setVersion(0), y.setLocktime(0);
    const t = this.hashMessage(g), d = 0, E = 32, B = new Uint8Array([d, E]), D = new Uint8Array(B.length + t.length);
    return D.set(B), D.set(t, B.length), y.addInput({
      hash: "0".repeat(64),
      // vin[0].prevout.hash = 0000...000
      index: 4294967295,
      // vin[0].prevout.n = 0xFFFFFFFF
      sequence: 0,
      // vin[0].nSequence = 0
      finalScriptSig: Buffer.from(D),
      // vin[0].scriptSig = OP_0 PUSH32[ message_hash ]
      witnessScript: Buffer.from([])
      // vin[0].scriptWitness = []
    }), y.addOutput({
      value: 0,
      // vout[0].nValue = 0
      script: c
      // vout[0].scriptPubKey = message_challenge
    }), y.extractTransaction();
  }
  /**
   * Build a to_sign transaction using simple signature in accordance to the BIP-322.
   * @param toSpendTxId Transaction ID of the to_spend transaction as constructed by buildToSpendTx
   * @param witnessScript The script public key for the signing wallet, or the redeemScript for P2SH-P2WPKH address
   * @param isRedeemScript Set to true if the provided witnessScript is a redeemScript for P2SH-P2WPKH address, default to false
   * @param tapInternalKey Used to set the taproot internal public key of a taproot signing address when provided, default to undefined
   * @returns Ready-to-be-signed bitcoinjs.Psbt transaction
   */
  static buildToSignTx(g, c, y = !1, t) {
    const d = new pA.Psbt();
    return d.setVersion(0), d.setLocktime(0), d.addInput({
      hash: g,
      // vin[0].prevout.hash = to_spend.txid
      index: 0,
      // vin[0].prevout.n = 0
      sequence: 0,
      // vin[0].nSequence = 0
      witnessUtxo: {
        script: c,
        value: 0
      }
    }), y && d.updateInput(0, {
      redeemScript: c
    }), t && d.updateInput(0, {
      tapInternalKey: t
    }), d.addOutput({
      value: 0,
      // vout[0].nValue = 0
      script: Buffer.from([106])
      // vout[0].scriptPubKey = OP_RETURN
    }), d;
  }
  /**
   * Encode witness stack in a signed BIP-322 PSBT into its base-64 encoded format.
   * @param signedPsbt Signed PSBT
   * @returns Base-64 encoded witness data
   */
  static encodeWitness(g) {
    const c = g.data.inputs[0].finalScriptWitness;
    if (!c)
      throw new Error("Cannot encode empty witness stack.");
    return c.toString("base64");
  }
}
h(sA, "TAG", Buffer.from("BIP0322-signed-message"));
const Gt = "data:image/svg+xml,%3csvg%20width='160'%20height='160'%20viewBox='0%200%20160%20160'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M30%2025H90L50%20110H20L30%2025Z'%20fill='black'/%3e%3cpath%20d='M130%20135L70%20135L110%2050L140%2050L130%20135Z'%20fill='%23F5870A'/%3e%3c/svg%3e", mt = Y.default ? Y.default : Y;
var vt;
const W2 = (vt = j) != null && vt.default ? j.default : j;
class Q2 extends z {
  constructor(g) {
    super(g, {}), h(this, "keystoneWaleltInfo"), h(this, "viewSDK"), h(this, "dataSdk"), h(this, "networkEnv"), h(this, "connectWallet", async () => {
      const c = await (await this.viewSDK.getSdk()).read([SupportedResult.UR_CRYPTO_ACCOUNT], {
        title: "Sync Keystone with Babylon Staking App",
        description: "Please scan the QR code displayed on your Keystone, Currently only the first Taproot Address will be used",
        renderInitial: {
          walletMode: "btc",
          link: "",
          description: [
            "1. Turn on your Keystone 3 with Multi-Coin firmware or BTC only firmware.",
            '2. Click "Connect Software Wallet" and choose "Babylon" or "Sparrow" for connection.',
            '3. Press the "Sync Keystone" button and scan the QR Code displayed on your Keystone hardware wallet',
            "4. The first Taproot address will be used for staking."
          ]
        },
        URTypeErrorMessage: "The scanned QR code is not the sync code from the Keystone hardware wallet. Please verify the code and try again."
      });
      if (c.status === ReadStatus.canceled)
        throw new Error("Connection to Keystone was canceled");
      if (c.status !== ReadStatus.success)
        throw new Error("Error reading QR code, Please try again.");
      const y = this.dataSdk.parseAccount(c.result), t = 3, d = y.keys[t].extendedPublicKey;
      if (this.keystoneWaleltInfo = {
        mfp: y.masterFingerprint,
        extendedPublicKey: d,
        path: y.keys[t].path,
        address: void 0,
        publicKeyHex: void 0,
        scriptPubKeyHex: void 0
      }, !this.keystoneWaleltInfo.extendedPublicKey)
        throw new Error("Could not retrieve the extended public key");
      const E = await this.getNetwork();
      return await this.switchNetwork(E), this;
    }), h(this, "getAddress", async () => {
      var c, y;
      if ((c = this.keystoneWaleltInfo) != null && c.address)
        return (y = this.keystoneWaleltInfo) == null ? void 0 : y.address;
      throw new Error("Could not retrieve the address");
    }), h(this, "getPublicKeyHex", async () => {
      var c, y;
      if ((c = this.keystoneWaleltInfo) != null && c.publicKeyHex)
        return (y = this.keystoneWaleltInfo) == null ? void 0 : y.publicKeyHex;
      throw new Error("Could not retrieve the BTC public key");
    }), h(this, "signPsbt", async (c, y) => {
      var t, d;
      if (!((t = this.keystoneWaleltInfo) != null && t.address) || !((d = this.keystoneWaleltInfo) != null && d.publicKeyHex))
        throw new Error("Keystone Wallet not connected");
      if (!c)
        throw new Error("psbt hex is required");
      let E = Psbt.fromHex(c);
      E = this.enhancePsbt(E);
      const B = E.toHex();
      return (await this.sign(B)).toHex();
    }), h(this, "signPsbts", async (c, y) => {
      var t, d;
      if (!((t = this.keystoneWaleltInfo) != null && t.address) || !((d = this.keystoneWaleltInfo) != null && d.publicKeyHex))
        throw new Error("Keystone Wallet not connected");
      if (!c && !Array.isArray(c))
        throw new Error("psbts hexes are required");
      const E = [];
      for (const B of c) {
        const D = await this.signPsbt(B);
        E.push(D);
      }
      return E;
    }), h(this, "getNetwork", async () => {
      if (!this.networkEnv)
        throw new Error("Network not set");
      return this.networkEnv;
    }), h(this, "signMessageBIP322", async (c) => {
      const y = Buffer.from(this.keystoneWaleltInfo.scriptPubKeyHex, "hex"), t = sA.buildToSpendTx(c, y), d = bip371Exports.toXOnly(Buffer.from(this.keystoneWaleltInfo.publicKeyHex, "hex"));
      let E = sA.buildToSignTx(t.getId(), y, !1, d);
      E.updateInput(0, {
        sighashType: Transaction$1.SIGHASH_ALL
      }), E = this.enhancePsbt(E);
      const B = await this.sign(E.toHex());
      return sA.encodeWitness(B);
    }), h(this, "signMessageECDSA", async (c) => {
      if (!this.keystoneWaleltInfo)
        throw new Error("Keystone Wallet not connected");
      const y = this.dataSdk.btc.generateSignRequest({
        requestId: "7afd5e09-9267-43fb-a02e-08c4a09417ec",
        signData: Buffer.from(c, "utf-8").toString("hex"),
        dataType: distExports.KeystoneBitcoinSDK.DataType.message,
        accounts: [
          {
            path: `${this.keystoneWaleltInfo.path}/0/0`,
            xfp: `${this.keystoneWaleltInfo.mfp}`,
            address: this.keystoneWaleltInfo.address
          }
        ],
        origin: "babylon staking app"
      }), t = yt(SupportedResult.UR_BTC_SIGNATURE), d = await this.viewSDK.getSdk(), E = await t(d, y), B = this.dataSdk.btc.parseSignature(E);
      return Buffer.from(B.signature, "hex").toString("base64");
    }), h(this, "sign", async (c) => {
      if (!c)
        throw new Error("psbt hex is required");
      const y = this.dataSdk.btc.generatePSBT(Buffer.from(c, "hex")), t = yt(SupportedResult.UR_PSBT), d = await this.viewSDK.getSdk(), E = await t(d, y), B = this.dataSdk.btc.parsePSBT(E), D = Psbt.fromHex(B);
      return D.finalizeAllInputs(), D;
    }), h(this, "enhancePsbt", (c) => {
      var y, t, d, E;
      if (!((y = this.keystoneWaleltInfo) != null && y.scriptPubKeyHex) || !((t = this.keystoneWaleltInfo) != null && t.publicKeyHex) || !((d = this.keystoneWaleltInfo) != null && d.mfp) || !((E = this.keystoneWaleltInfo) != null && E.path))
        throw new Error("Keystone Wallet not connected");
      const B = {
        masterFingerprint: Buffer.from(this.keystoneWaleltInfo.mfp, "hex"),
        path: `${this.keystoneWaleltInfo.path}/0/0`,
        pubkey: Buffer.from(this.keystoneWaleltInfo.publicKeyHex, "hex")
      };
      return c.data.inputs.forEach((D) => {
        D.tapBip32Derivation = [
          {
            ...B,
            pubkey: bip371Exports.toXOnly(B.pubkey),
            leafHashes: K2(D, B.pubkey)
          }
        ];
      }), c;
    }), h(this, "on", () => {
    }), h(this, "off", () => {
    }), at(), mt.bootstrap(), this.viewSDK = mt, this.dataSdk = new W2({
      origin: ""
    }), this.networkEnv = I.MAINNET, this.keystoneWaleltInfo = {};
  }
  async signMessage(g, c = "ecdsa") {
    if (c === "bip322-simple")
      return await this.signMessageBIP322(g);
    if (c === "ecdsa")
      return await this.signMessageECDSA(g);
    throw new Error("Unsupported message signing type");
  }
  async switchNetwork(g) {
    this.networkEnv = g;
    const { address: c, pubkeyHex: y, scriptPubKeyHex: t } = O2(
      // @ts-ignore
      this.keystoneWaleltInfo.extendedPublicKey,
      "M/0/0",
      fA(g)
    );
    this.keystoneWaleltInfo.address = c, this.keystoneWaleltInfo.publicKeyHex = y, this.keystoneWaleltInfo.scriptPubKeyHex = t;
  }
  async sendBitcoin(g, c) {
    const y = await this.getAddress(), t = await this.getUtxos(y);
    t.sort((U, L) => U.value - L.value);
    let d = 0;
    const E = [], B = (await this.getNetworkFees()).fastestFee;
    let D = 0;
    for (const U of t)
      if (E.push({
        hash: U.txid,
        index: U.vout,
        witnessUtxo: {
          script: Buffer.from(U.scriptPubKey, "hex"),
          value: U.value
        }
      }), d += U.value, D = (E.length * 180 + 68 + 10) * B, d >= c + D)
        break;
    if (d < c + D)
      throw new Error("1Insufficient funds for the transaction.");
    if (E.length === 0)
      throw new Error("No inputs available for the transaction.");
    const x = d - c - D, v = new Psbt({ network: fA(await this.getNetwork()) });
    for (const U of E)
      v.addInput(U);
    if (v.addOutput({
      address: g,
      value: c
    }), x > 0) {
      const U = await this.getAddress();
      v.addOutput({
        address: U,
        value: x
      });
    }
    const F = await this.signPsbt(v.toHex()), M = Psbt.fromHex(F).extractTransaction();
    return await this.pushTx(M.toHex());
  }
  getWalletProviderName() {
    return Promise.resolve(HA.name);
  }
  getWalletProviderIcon() {
    return Promise.resolve(HA.img);
  }
}
const HA = {
  id: "bitcoin_keystone",
  img: Gt,
  name: "Keystone",
  chainType: "bitcoin",
  connectProvider: Q2,
  type: "qrcode"
}, yt = (o) => async (g, c) => {
  if (await g.play(c, {
    title: "Scan the QR Code",
    description: "Please scan the QR code with your Keystone device."
  }) !== PlayStatus.success)
    throw new Error("Could not generate the QR code, please try again.");
  const y = await g.read([o], {
    title: "Get the Signature from Keystone",
    description: "Please scan the QR code displayed on your Keystone",
    URTypeErrorMessage: "The scanned QR code can't be read. please verify and try again."
  });
  if (y.status !== ReadStatus.success)
    throw new Error("Could not extract the signature, please try again.");
  return y.result;
}, O2 = (o, g, c) => {
  const y = HDKey.fromExtendedKey(o).derive(g), t = Buffer.from(y.publicKey), d = bip371Exports.toXOnly(t), { address: E, output: B } = payments$1.p2tr({
    internalPubkey: d,
    network: c
  });
  return {
    address: E,
    pubkeyHex: t.toString("hex"),
    scriptPubKeyHex: B.toString("hex")
  };
}, K2 = (o, g) => o.tapInternalKey && !o.tapLeafScript ? [] : (o.tapLeafScript || []).filter((c) => psbtutilsExports.pubkeyInScript(g, c.script)).map((c) => {
  const y = bip341Exports.tapleafHash({
    output: c.script,
    version: c.leafVersion
  });
  return Object.assign({ hash: y }, c);
}).map((c) => c.hash), V2 = "data:image/webp;base64,UklGRmIEAABXRUJQVlA4TFUEAAAvL8ALABrJ2ravUzK6old2S8PWbj2p7tYjobtjujvAE/r/flPkev7md13U9ydGPovuticEkgCAZaTM2raND+zevN33eeyZ5yza8byhjFU4jCTbtBUF8PX2XONdnGd8q/8MJEmSMdXlZnbxirRZ9FbIQAMd7bVXPQYda+Y2ufDvyzB0qE74a1f/7WjWNkHHmb5ODvRpUz+3+P5ccqAvQkeZuUMO+Paor1t8BEbDGTsEHaQdvjzy7eJvji9iHDrC9A2ywadbvpz85cWH1SgEb8Yu2eDDJZ8O/nTwh5M/Y7E3ArGt2cxdgqC1BDenuNvZneFWj6k4wykeEkFwpm+S9IMb3+vkef8j/dnkBrAizUJQ2+Zgd4irjV0Z7cntSSbJwDnS188NYfAXBZ4dAKdvhBXvdrHb2G5jGyK2JdfHmVYGzkSRP+3JFRHHxx1it+Lt/J2QAQRaKVOQgUulOTj1ZqWrJFnZ6ok3JstmTJIkp9rqBgMkTyCwShwD0YQMnCrN3qFWC13innh9lIkiUSh1CkTi1FI83lfd7bcSRkC0GUAhAFHSOCKVVu/QK+cEwASXvk+RxFEQAfg/Cce2YCHjs3IQWWr6/LQYmJEKiytaHFkgEp8UQ+2QmeKjnLfSMf+SwG8jvT9Y+OiKZ3ZvSARm6W+16elduVlFISCmTELwYca74ilqCMa8c/IdTN+Dzu/MvDfSft0ZD0+KDogxIZb8Zpse1tdtaiizspg0Bn4ODzLuy/r6N73fZR4S+PKSQTq/mjgbCAs4ou5V0wERpU4BysxkVcxGsVDRSRBmPqu60cVFI+FFE+NflwxCH3XZoF8mVg2kCtgj9qpyK1kUs1FYJFf2k1c5ImajGPp12RBIPpK+C42XjazoSemzRfVxwXrvlJitWZW+PrMsZZ1W5L8e3E+b5b6+qNrLx7aBvk8c34XaSwaWrVF5VDAgHOWaisVmNMm8XdqJItc1TAT3MmbMwLPKTQdWgES+s6LH6UnJsEZQ2grPqoZLWSdW9CMwZyoHAYSHwYOc0aG0exYY2H+SPAko/LFGGS1hfJhXQLQNsEkEd9PKGkajiKVtxwWQ/LPNtv8bZdDiMBV6kFNAFA4zQ1Na7I0ilLQtywQFROoUsODXGKRXYydgDv29rOR6wp20nGGj0Atf0jEYpgDZCXDillSB1VCrxpZhCt3dtETmIDcISQ3t+UdCChQ8vge5ozVEq5BmGLW5kxaIt9MCuCGoiVZ4Ou8agUuEhzfgFaPW19/EbMjL3EsEIxEeWEeLI9VEKpFkaJj8yj1JRaTclTkXCE4i3L+GZkeoiFAg4YP5VldknyFYiXD3HJpsUhKSQ8ghbckRCcgRFIRaHDq+h+Alwj0raLQbBW5aYcPR12Q3x/bQERLh3lXwkePm37F9dIxEuGseDfZZjs8t8Bxab7TPR7bRURLhgQ002KdWfBxutE9su+NyZBeNzmGD2ZE5b2ChYyVCpF4KAgA=";
class U2 extends z {
  constructor(g) {
    var c, y;
    const t = (y = (c = S(g)) == null ? void 0 : c.binancew3w) == null ? void 0 : y.bitcoin;
    if (!t)
      throw new Error("Binance Wallet not found");
    super(g, t), h(this, "connectWallet", async () => {
      const d = (await this.bitcoinNetworkProvider.requestAccounts())[0], E = await this.getPublicKeyHex();
      if (!d || !E)
        throw new Error("Could not connect to imToken Wallet");
      return this;
    }), h(this, "signPsbts", async (d) => {
      throw new Error('Method "signPsbts" not implemented.');
    }), h(this, "on", (d, E) => {
      var B, D, x, v;
      return d === "accountChanged" ? (D = (B = this.bitcoinNetworkProvider) == null ? void 0 : B.on) == null ? void 0 : D.call(B, "accountsChanged", E) : (v = (x = this.bitcoinNetworkProvider) == null ? void 0 : x.on) == null ? void 0 : v.call(x, d, E);
    }), h(this, "off", (d, E) => {
      var B, D;
      return d === "accountChanged" ? (B = this.bitcoinNetworkProvider) == null ? void 0 : B.removeListener("accountsChanged", E) : (D = this.bitcoinNetworkProvider) == null ? void 0 : D.removeListener(d, E);
    }), h(this, "getBalance", async () => await this.bitcoinNetworkProvider.getBalance(await this.getAddress())), at();
  }
  async sendBitcoin(g, c) {
    const y = await this.getAddress(), t = await this.getUtxos(y);
    t.sort((U, L) => U.value - L.value);
    let d = 0;
    const E = [], B = (await this.getNetworkFees()).fastestFee;
    let D = 0;
    for (const U of t)
      if (E.push({
        hash: U.txid,
        index: U.vout,
        witnessUtxo: {
          script: Buffer.from(U.scriptPubKey, "hex"),
          value: U.value
        }
      }), d += U.value, D = (E.length * 180 + 68 + 10) * B, d >= c + D)
        break;
    if (d < c + D)
      throw new Error("1Insufficient funds for the transaction.");
    if (E.length === 0)
      throw new Error("No inputs available for the transaction.");
    const x = d - c - D, v = new Psbt({ network: fA(await this.getNetwork()) });
    for (const U of E)
      v.addInput(U);
    if (v.addOutput({
      address: g,
      value: c
    }), x > 0) {
      const U = await this.getAddress();
      v.addOutput({
        address: U,
        value: x
      });
    }
    const F = await this.signPsbt(v.toHex()), M = Psbt.fromHex(F).extractTransaction();
    return await this.pushTx(M.toHex());
  }
  async switchNetwork(g) {
    await this.bitcoinNetworkProvider.switchNetwork(
      // @ts-ignore
      g.replace("mainnet", "livenet")
    );
  }
  getWalletProviderName() {
    return Promise.resolve(MA.name);
  }
  getWalletProviderIcon() {
    return Promise.resolve(MA.img);
  }
}
const MA = {
  id: "bitcoin_binance",
  img: V2,
  name: "Binance",
  chainType: "bitcoin",
  connectProvider: U2,
  type: "injected"
}, q2 = "https://cosmoshub.validator.network:443";
class J extends Qt {
  constructor(g, c) {
    super(g), h(this, "provider"), h(this, "offlineSigner"), h(this, "clientPromise"), this.provider = c;
  }
  async connectWallet() {
    const g = await this.getNetwork();
    return await this.provider.enable(g), this.offlineSigner = this.provider.getOfflineSigner(g), await this.getAddress(), this;
  }
  initSigningStargateClient(g) {
    this.clientPromise = Promise.resolve(g);
  }
  /**
   * get @cosmjs/stargate SigningStargateClient
   */
  async getSigningStargateClient(g) {
    return this.clientPromise || (this.clientPromise = this.createSigningStargateClient(g)), await this.clientPromise;
  }
  async createSigningStargateClient(g) {
    var c, y, t;
    const d = ((t = (y = (c = this.chains) == null ? void 0 : c[0]) == null ? void 0 : y.backendUrls) == null ? void 0 : t.rpcUrl) || q2;
    if (!this.offlineSigner)
      throw new Error("Offline signer is not initialized");
    return await SigningStargateClient.connectWithSigner(d, this.offlineSigner, g);
  }
  async getBalance(g) {
    const c = await this.getSigningStargateClient();
    return BigInt((await c.getBalance(await this.getAddress(), g)).amount);
  }
  /**
   * Gets the bech32Address of the connected wallet.
   * @returns A promise that resolves to the address of the connected wallet.
   */
  async getAddress() {
    const g = await this.getNetwork();
    return (await this.provider.getKey(g)).bech32Address;
  }
  /**
   * get the chainId of the connected wallet
   */
  async getNetwork() {
    var g, c;
    return (c = (g = this.chains) == null ? void 0 : g[0]) == null ? void 0 : c.network;
  }
  async signAmino(g, c, y) {
    const t = await this.getNetwork();
    if (t !== c.chain_id)
      throw new Error("Unmatched chain id with the offline signer");
    if (await this.getAddress() !== g)
      throw new Error("Unknown signer address");
    return await this.provider.signAmino(t, g, c, y);
  }
  async signArbitrary(g, c) {
    const y = await this.getNetwork();
    return await this.provider.signArbitrary(y, g, c);
  }
  async broadcastTx(g, c, y) {
    return await (await this.getSigningStargateClient()).broadcastTx(g, c, y);
  }
  async getPublicKeyHex() {
    const g = await this.getNetwork(), c = await this.provider.getKey(g);
    return bufferExports.Buffer.from(c.pubKey).toString("hex");
  }
  async getOfflineSigner() {
    const g = await this.getNetwork();
    return this.provider.getOfflineSigner(g);
  }
  /**
   * Registers an event listener for the specified event.
   * At the moment, only the "accountChanged" event is supported.
   * @param eventName - The name of the event to listen for.
   * @param callBack - The callback function to be executed when the event occurs.
   */
  on(g, c) {
  }
  /**
   * Unregisters an event listener for the specified event.
   * @param eventName - The name of the event to listen for.
   * @param callBack - The callback function to be executed when the event occurs.
   */
  off(g, c) {
  }
}
const Zt = "data:image/png;base64,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", R2 = "keplr";
class G2 extends J {
  constructor(g) {
    const c = S(g)[R2];
    if (!c)
      throw new Error("Keplr Wallet extension not found");
    super(g, c);
  }
  async init() {
    const g = await buildExports$1.Keplr.getKeplr();
    if (!g)
      throw new Error("Keplr Wallet extension not found");
    this.provider = g;
  }
  getWalletProviderName() {
    return Promise.resolve(XA.name);
  }
  getWalletProviderIcon() {
    return Promise.resolve(XA.img);
  }
  on(g, c) {
    g === "accountChanged" && window.addEventListener("keplr_keystorechange", c);
  }
  off(g, c) {
    g === "accountChanged" && window.removeEventListener("keplr_keystorechange", c);
  }
}
const XA = {
  id: "cosmos_keplr",
  img: Zt,
  name: "Keplr",
  chainType: "cosmos",
  connectProvider: G2,
  type: "extension"
};
class Z2 extends J {
  constructor(g) {
    var c;
    const y = (c = S(g).okxwallet) == null ? void 0 : c.keplr;
    if (!y)
      throw new Error("OKX Wallet extension not found");
    super(g, y);
  }
  getWalletProviderName() {
    return Promise.resolve(LA.name);
  }
  getWalletProviderIcon() {
    return Promise.resolve(LA.img);
  }
  on(g, c) {
    g === "accountChanged" && window.addEventListener("okx_keystorechange", c);
  }
  off(g, c) {
    g === "accountChanged" && window.removeEventListener("okx_keystorechange", c);
  }
}
const LA = {
  id: "cosmos_okx",
  img: Kt,
  name: "OKX",
  chainType: "cosmos",
  connectProvider: Z2,
  type: "extension"
}, jt = "data:image/x-icon;base64,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";
class j2 extends J {
  constructor(g) {
    var c, y;
    const t = (y = (c = S(g).cosmostation) == null ? void 0 : c.providers) == null ? void 0 : y.keplr;
    if (!t)
      throw new Error("Cosmostation Wallet extension not found");
    super(g, t);
  }
  getWalletProviderName() {
    return Promise.resolve(JA.name);
  }
  getWalletProviderIcon() {
    return Promise.resolve(JA.img);
  }
  on(g, c) {
    g === "accountChanged" && window.addEventListener("cosmostation_keystorechange", c);
  }
  off(g, c) {
    g === "accountChanged" && window.removeEventListener("cosmostation_keystorechange", c);
  }
}
const JA = {
  id: "cosmos_cosmostation",
  img: jt,
  name: "Cosmostation",
  chainType: "cosmos",
  connectProvider: j2,
  type: "extension"
}, Yt = "data:image/png;base64,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";
class Y2 extends J {
  constructor(g) {
    const c = S(g).leap;
    if (!c)
      throw new Error("OKX Wallet extension not found");
    super(g, c);
  }
  getWalletProviderName() {
    return Promise.resolve(WA.name);
  }
  getWalletProviderIcon() {
    return Promise.resolve(WA.img);
  }
  on(g, c) {
    g === "accountChanged" && window.addEventListener("leap_keystorechange", c);
  }
  off(g, c) {
    g === "accountChanged" && window.removeEventListener("leap_keystorechange", c);
  }
}
const WA = {
  id: "cosmos_leap",
  img: Yt,
  name: "Leap",
  chainType: "cosmos",
  connectProvider: Y2,
  type: "extension"
};
class _2 extends J {
  constructor(g) {
    var c;
    const y = (c = S(g).$onekey) == null ? void 0 : c.cosmos;
    if (!y)
      throw new Error("OneKey Wallet extension not found");
    super(g, y);
  }
  getWalletProviderName() {
    return Promise.resolve(QA.name);
  }
  getWalletProviderIcon() {
    return Promise.resolve(QA.img);
  }
  on(g, c) {
    g === "accountChanged" && window.addEventListener("keplr_keystorechange", c);
  }
  off(g, c) {
    g === "accountChanged" && window.removeEventListener("keplr_keystorechange", c);
  }
}
const QA = {
  id: "cosmos_onekey",
  img: Rt,
  name: "OneKey",
  chainType: "cosmos",
  connectProvider: _2,
  type: "extension"
}, $2 = "data:image/svg+xml,%3csvg%20width='57'%20height='54'%20viewBox='0%200%2018%2017'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cmask%20id='mask0_2982_13847'%20maskUnits='userSpaceOnUse'%20x='0'%20y='0'%20width='18'%20height='17'%20style='mask-type:%20luminance;'%3e%3cpath%20d='M18%200H0V17H18V0Z'%20fill='white'%3e%3c/path%3e%3c/mask%3e%3cg%20mask='url(%23mask0_2982_13847)'%3e%3cpath%20d='M4.07466%205.38463C3.65195%206.2559%203.70642%207.22272%204.16617%207.79598C4.07015%207.05094%204.19885%206.29317%204.53441%205.62804C4.85575%204.95394%205.3666%204.39837%205.99864%204.03564H5.91802C5.20769%204.04247%204.47122%204.58616%204.07466%205.38463Z'%20fill='%23075CEE'%3e%3c/path%3e%3cpath%20d='M15.4461%209.60666C15.4701%208.54658%2015.0343%207.58886%2014.215%207.14754L13.6115%206.82451L9.68944%204.74984L8.15113%203.93317C7.6609%203.68664%207.10087%203.63723%206.57796%203.7944L4.33585%202.60693C3.33791%202.08144%202.02622%202.7002%201.40523%203.97184C0.784235%205.24349%201.08928%206.72669%202.07851%207.25218C2.09022%207.25958%202.10264%207.26567%202.11555%207.27038L4.32714%208.45331C4.51535%208.98189%204.88716%209.41716%205.36866%209.67263C5.37775%209.67657%205.38792%209.67657%205.39699%209.67263L11.4282%2012.8574C12.254%2013.2988%2013.252%2013.1008%2014.0429%2012.4434L14.86%2012.8756L16.2523%2010.0048L15.4352%209.59074L15.4461%209.60666Z'%20fill='%23075CEE'%3e%3c/path%3e%3cpath%20d='M2.49267%2012.1887L6.34935%2014.3316L3.89589%2016.9545C3.88034%2016.9745%203.85892%2016.9887%203.83493%2016.9949C3.81094%2017.001%203.78566%2016.9988%203.76298%2016.9886H3.75209L0.0653596%2015.014C0.0358593%2014.9971%200.0138623%2014.9689%200.00408632%2014.9353C-0.00568966%2014.9017%20-0.00246613%2014.8655%200.0130656%2014.8343C0.0185887%2014.823%200.0251569%2014.8124%200.0326759%2014.8025L2.49267%2012.1887ZM5.61288%208.87191C5.62844%208.85187%205.64983%208.83768%205.67384%208.83151C5.69783%208.82537%205.72311%208.82755%205.74579%208.83779H5.75669L9.44123%2010.7987C9.45644%2010.8064%209.46999%2010.8172%209.48106%2010.8306C9.4921%2010.8439%209.50045%2010.8595%209.50555%2010.8763C9.51065%2010.8931%209.51241%2010.9109%209.51071%2010.9284C9.50901%2010.946%209.50392%2010.963%209.4957%2010.9784L9.48045%2011.0035V11.0148L6.61954%2014.0654L2.75414%2011.9157L5.61288%208.87191ZM14.6902%2011.0103C15.0759%2010.2141%2015.7797%209.77958%2016.2699%2010.0366C16.7602%2010.2937%2016.8386%2011.149%2016.453%2011.943C16.0673%2012.7369%2015.3635%2013.1737%2014.8733%2012.9166C14.383%2012.6595%2014.3024%2011.7974%2014.6902%2011.0035V11.0103ZM5.91793%203.65794C6.14198%203.65435%206.36441%203.69846%206.5716%203.78761C6.39258%203.84141%206.21894%203.91302%206.05302%204.00145L5.99637%204.0333H5.91575C5.20542%204.0333%204.46895%204.58609%204.07239%205.38456C3.64968%206.25583%203.70415%207.22264%204.1639%207.79591C4.19667%208.01341%204.25071%208.22683%204.32514%208.43287C3.41653%207.86188%203.16596%206.45374%203.75862%205.21395C4.22709%204.24941%205.08994%203.65794%205.91793%203.65794ZM11.2584%203.07558L15.1129%205.23214L13.6117%206.82454L9.68962%204.74988L11.2584%203.07558ZM14.0976%200.0431891C14.1119%200.021571%2014.1328%200.00558169%2014.1569%20-0.00224709C14.181%20-0.0100758%2014.2069%20-0.00929676%2014.2305%20-3.31039e-05L17.9281%201.97682C17.9583%201.99296%2017.9815%202.02058%2017.9928%202.054C18.0042%202.08742%2018.0029%202.12411%2017.9891%202.15653C17.9836%202.16779%2017.977%202.17846%2017.9695%202.18838L15.3831%204.94324L11.5177%202.7935L14.0976%200.0431891Z'%20fill='%2388B2FB'%3e%3c/path%3e%3c/g%3e%3c/svg%3e";
class A0 extends J {
  constructor(g) {
    var c;
    const y = (c = S(g).station) == null ? void 0 : c.keplr;
    if (!y)
      throw new Error("Station Wallet extension not found");
    super(g, y);
  }
  getWalletProviderName() {
    return Promise.resolve(OA.name);
  }
  getWalletProviderIcon() {
    return Promise.resolve(OA.img);
  }
}
const OA = {
  id: "cosmos_station",
  img: $2,
  name: "Station",
  chainType: "cosmos",
  connectProvider: A0,
  type: "extension"
}, _t = "data:image/svg+xml,%3csvg%20width='44'%20height='44'%20viewBox='0%200%2044%2044'%20fill='%233173FA'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M22.01376%200c11.54538.00706%2021.00722%208.90338%2021.91609%2020.21383a.30206.30206%200%2001-.2706.32468l-.03146.00154h-1.25892c-.1564%200-.28503-.11886-.3005-.27117l-.00156-.03089v-1.66267c0-.06673-.04868-.12209-.11247-.13249l-.02178-.00176h-1.57004c-.06672%200-.12208.04869-.13249.11248l-.00175.02177V20.238c0%20.1564-.11886.28503-.27118.3005l-.03088.00156h-.91826c-.1564%200-.28504-.11886-.3005-.27117l-.00156-.03089v-1.66267c0-.06673-.04869-.12209-.11248-.13249l-.02177-.00176h-1.57071c-.06673%200-.12209.04869-.1325.11248l-.00175.02177V20.238c0%20.1564-.11886.28503-.27118.3005l-.03088.00156H30.1207c-.53353-.00063-1.00676-.3427-1.17468-.84912-.96357-2.8991-3.69184-4.99305-6.91146-5.00714-1.94706-.01596-3.8196.74761-5.2003%202.12056s-2.1548%203.24115-2.1498%205.18827c-.00404%204.04424%203.2733%207.32394%207.31654%207.32394%203.23103%200%205.97272-2.09428%206.942-4.99942.16138-.49215.60957-.8311%201.1231-.85575l.05527-.00143h13.50507a.30206.30206%200%2001.30206.3269C43.01897%2035.10132%2033.54874%2044%2022%2044%209.84982%2044%200%2034.14615%200%2022.00034%200%209.85453%209.86795-.00738%2022.01376%200z'%3e%3c/path%3e%3c/svg%3e";
class t0 extends z {
  constructor(g) {
    const c = S(g).cactuslink;
    if (!c)
      throw new Error("Cactus Link Wallet extension not found");
    super(g, c), h(this, "signPsbt", async (y, t) => await this.bitcoinNetworkProvider.signPsbt(y, t || {
      autoFinalized: !0
    })), h(this, "signPsbts", async (y, t) => {
      const d = t || y.map((E) => ({
        autoFinalized: !0
      }));
      return await this.bitcoinNetworkProvider.signPsbts(y, d);
    }), h(this, "on", (y, t) => {
      var d, E, B, D;
      return y === "accountChanged" ? (E = (d = this.bitcoinNetworkProvider) == null ? void 0 : d.on) == null ? void 0 : E.call(d, "accountsChanged", t) : (D = (B = this.bitcoinNetworkProvider) == null ? void 0 : B.on) == null ? void 0 : D.call(B, y, t);
    }), h(this, "off", (y, t) => {
      var d, E, B, D;
      return y === "accountChanged" ? (E = (d = this.bitcoinNetworkProvider) == null ? void 0 : d.off) == null ? void 0 : E.call(d, "accountsChanged", t) : (D = (B = this.bitcoinNetworkProvider) == null ? void 0 : B.off) == null ? void 0 : D.call(B, y, t);
    });
  }
  async connectWallet() {
    var g;
    await this.getNetwork();
    try {
      await this.bitcoinNetworkProvider.requestAccounts();
    } catch (t) {
      throw (g = t == null ? void 0 : t.message) != null && g.includes("rejected") ? new Error("Connection to Cactus Link Wallet was rejected") : new Error(t == null ? void 0 : t.message);
    }
    const c = await this.getAddress(), y = await this.getPublicKeyHex();
    if (!c || !y)
      throw new Error("Could not connect to Cactus Link Wallet");
    return this;
  }
  getWalletProviderName() {
    return Promise.resolve(KA.name);
  }
  getWalletProviderIcon() {
    return Promise.resolve(KA.img);
  }
}
const KA = {
  id: "bitcoin_cactuslink",
  img: _t,
  name: "Cactus Link",
  chainType: "bitcoin",
  connectProvider: t0,
  type: "extension"
}, e0 = "leapBitcoin";
class n0 extends z {
  constructor(g) {
    var c;
    const y = (c = S(g)) == null ? void 0 : c[e0];
    if (!y)
      throw new Error("Leap Wallet extension not found");
    super(g, y), h(this, "connectWallet", async () => {
      const t = (await this.bitcoinNetworkProvider.requestAccounts())[0], d = await this.getPublicKeyHex();
      if (!t || !d)
        throw new Error("Could not connect to Leap Wallet");
      return this;
    });
  }
  getWalletProviderIcon() {
    return Promise.resolve(VA.img);
  }
  getWalletProviderName() {
    return Promise.resolve(VA.name);
  }
}
const VA = {
  id: "bitcoin_leap",
  img: Yt,
  name: "Leap",
  chainType: "bitcoin",
  connectProvider: n0,
  type: "extension"
};
class o0 extends z {
  constructor(g) {
    var c;
    const y = (c = S(g).cosmostation) == null ? void 0 : c.bitcoin;
    if (!y)
      throw new Error("Cosmostation Wallet extension not found");
    super(g, y), h(this, "connectWallet", async () => {
      if (!this.bitcoinNetworkProvider)
        throw new Error("Cosmostation Wallet extension not found");
      let t = null, d = null;
      try {
        if (t = await this.bitcoinNetworkProvider.connectWallet(), d = await this.bitcoinNetworkProvider.getPublicKey(), !t || t.length === 0 || !d)
          throw new Error("BTC is not enabled in Cosmostation Wallet");
        return this;
      } catch {
        throw new Error("BTC is not enabled in Cosmostation Wallet");
      }
    }), h(this, "getBalance", async () => await this.bitcoinNetworkProvider.getBalance()), h(this, "pushTx", async (t) => await this.bitcoinNetworkProvider.pushTx(t)), h(this, "getNetwork", async () => await this.bitcoinNetworkProvider.getNetwork());
  }
  async switchNetwork(g) {
    return await this.bitcoinNetworkProvider.switchNetwork(g);
  }
  async getPublicKeyHex() {
    return await this.bitcoinNetworkProvider.getPublicKey();
  }
  getWalletProviderName() {
    return Promise.resolve(UA.name);
  }
  getWalletProviderIcon() {
    return Promise.resolve(UA.img);
  }
}
const UA = {
  id: "bitcoin_cosmostation",
  img: jt,
  name: "Cosmostation",
  chainType: "bitcoin",
  connectProvider: o0,
  type: "extension"
};
class r0 extends J {
  constructor(g) {
    var c;
    const y = (c = S(g).bitkeep) == null ? void 0 : c.keplr;
    if (!y)
      throw new Error("Bitget Wallet extension not found");
    super(g, y);
  }
  getWalletProviderName() {
    return Promise.resolve(qA.name);
  }
  getWalletProviderIcon() {
    return Promise.resolve(qA.img);
  }
  on(g, c) {
    g === "accountChanged" && window.addEventListener("bitget_keystorechange", c);
  }
  off(g, c) {
    g === "accountChanged" && window.removeEventListener("bitget_keystorechange", c);
  }
}
const qA = {
  id: "cosmos_bitget",
  img: qt,
  name: "Bitget Wallet",
  chainType: "cosmos",
  connectProvider: r0,
  type: "extension"
};
class i0 extends J {
  constructor(g) {
    var c, y;
    const t = (y = (c = S(g)) == null ? void 0 : c.unisat_wallet) == null ? void 0 : y.keplr;
    if (!t)
      throw new Error("UniSat Wallet extension not found");
    super(g, t);
  }
  getWalletProviderName() {
    return Promise.resolve(RA.name);
  }
  getWalletProviderIcon() {
    return Promise.resolve(RA.img);
  }
  on(g, c) {
    var y, t;
    if (g === "accountChanged") {
      const d = (y = S(this.option)) == null ? void 0 : y.unisat;
      (t = d == null ? void 0 : d.on) == null || t.call(d, "accountsChanged", c);
    }
  }
  off(g, c) {
    var y, t;
    if (g === "accountChanged") {
      const d = (y = S(this.option)) == null ? void 0 : y.unisat;
      (t = d == null ? void 0 : d.on) == null || t.call(d, "accountsChanged", c);
    }
  }
}
const RA = {
  id: "cosmos_unisat",
  img: Vt,
  name: "Unisat",
  chainType: "cosmos",
  connectProvider: i0,
  type: "extension"
}, s0 = "data:image/png;base64,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";
class a0 extends z {
  constructor(g) {
    var c;
    const y = S(g), t = (c = y == null ? void 0 : y.XverseProviders) == null ? void 0 : c.BitcoinProvider;
    if (!t)
      throw new Error("Xverse Wallet extension not found");
    super(g, t), h(this, "getConnectionInfo", async () => {
      var d;
      const E = await this.request("getAddresses", {
        purposes: ["ordinals"]
      });
      if (!((d = E.addresses) != null && d.length))
        throw new Error("Failed to connect to Xverse Wallet");
      return E.addresses[0];
    }), h(this, "connectWallet", async () => {
      var d;
      try {
        if (!(await this.request("wallet_getCurrentPermissions")).length)
          throw new Error("No permissions found.");
        return this;
      } catch {
        const E = await this.request("wallet_connect");
        if (!((d = E.addresses) != null && d.length) || !E.addresses.some((B) => B.purpose === "ordinals"))
          throw new Error("Failed to connect to Xverse Wallet");
        return this;
      }
    }), h(this, "getBalance", async () => (await this.request("getBalance", void 0)).confirmed), h(this, "signPsbt", async (d, E) => {
      if (!d)
        throw new Error("psbt hex is required");
      const B = {
        curNetwork: await this.getNetwork(),
        curAddress: await this.getAddress(),
        curPublicKey: await this.getPublicKeyHex()
      };
      if (!B.curAddress)
        throw new Error("Wallet not connected");
      try {
        const { psbtBase64: D, toSignInputs: x } = this.getSignPsbtDefaultOptions(d, B), v = await this.request("signPsbt", {
          psbt: D,
          signInputs: x
        }), F = Psbt.fromBase64(v.psbt);
        return F.finalizeAllInputs(), F.toHex();
      } catch (D) {
        throw console.error("signPsbt error", D), D;
      }
    }), h(this, "signPsbts", async (d, E) => {
      if (!d && !Array.isArray(d))
        throw new Error("psbts hexes are required");
      const B = {
        curNetwork: await this.getNetwork(),
        curAddress: await this.getAddress(),
        curPublicKey: await this.getPublicKeyHex()
      };
      if (!B.curAddress)
        throw new Error("Unisat Wallet not connected");
      try {
        const D = d.map((x) => {
          const { psbtBase64: v, toSignInputs: F } = this.getSignPsbtDefaultOptions(x, B);
          return {
            psbtBase64: v,
            signingIndexes: F
            // sigHash: btc.SignatureHash.SINGLE
          };
        });
        return await this.bitcoinNetworkProvider.signMultipleTransactions(libExports.createUnsecuredToken({
          payload: {
            network: {
              type: B.curNetwork
            },
            message: "Sign Transaction",
            psbts: D
          }
        }));
      } catch (D) {
        throw console.error("signPsbts error", D), D;
      }
    });
  }
  // async requestAccounts() {
  //   await this.connectWallet()
  //   return await this.getAccounts()
  // }
  //
  // async getAccounts() {
  //   return [await this.getAddress()]
  // }
  // async getPublicKey() {
  //   return this.getPublicKeyHex()
  // }
  async request(g, c) {
    var y;
    const t = await this.bitcoinNetworkProvider.request(g, c || null);
    if (t.error)
      throw new Error((y = t.error) == null ? void 0 : y.message);
    if (t.result === void 0)
      throw new Error("Received unknown response from provider.");
    return t.result;
  }
  async getAddress() {
    return (await this.getConnectionInfo()).address;
  }
  async getPublicKeyHex() {
    const g = (await this.getConnectionInfo()).publicKey;
    return g.length === 64 ? "03" + g : g;
  }
  async switchNetwork(g) {
    throw new Error(`please use the Xverse wallet extension to switch networks: ${g}`);
  }
  async getNetwork() {
    const g = await this.getAddress();
    if (g.startsWith("bc1"))
      return I.MAINNET;
    if (g.startsWith("tb1"))
      return I.SIGNET;
    throw new Error("Unknown network");
  }
  async sendBitcoin(g, c) {
    const y = await this.request("sendTransfer", {
      recipients: [
        {
          address: g,
          amount: c
        }
      ]
    });
    return y == null ? void 0 : y.txid;
  }
  async signMessage(g, c = "ecdsa") {
    return (await this.request("signMessage", {
      address: await this.getAddress(),
      message: g,
      protocol: c === "bip322-simple" ? "BIP322" : "ECDSA"
    })).signature;
  }
  getSignPsbtDefaultOptions(g, c) {
    const y = Psbt.fromHex(g), { curNetwork: t, curPublicKey: d, curAddress: E } = c, B = {
      [E]: []
    };
    return y.data.inputs.forEach((D, x) => {
      if (D.witnessUtxo && D.witnessUtxo.script) {
        let v = networks$2.bitcoin;
        (t === I.TESTNET || t === I.SIGNET) && (v = networks$2.testnet);
        let F;
        try {
          F = address$2.fromOutputScript(D.witnessUtxo.script, v);
        } catch (M) {
          if (M instanceof Error && M.message.toLowerCase().includes("has no matching address"))
            F = address$2.fromOutputScript(D.witnessUtxo.script, v);
          else
            throw new Error(M);
        }
        F.indexOf("tb1p") === 0 || F.indexOf("bc1p");
      }
      D.finalScriptSig || D.finalScriptWitness || B[E].push(x);
    }), {
      psbtBase64: y.toBase64(),
      toSignInputs: B
    };
  }
  getWalletProviderName() {
    return Promise.resolve(GA.name);
  }
  getWalletProviderIcon() {
    return Promise.resolve(GA.img);
  }
}
const GA = {
  id: "bitcoin_xverse",
  img: s0,
  name: "Xverse",
  chainType: "bitcoin",
  connectProvider: a0,
  type: "extension"
}, c0 = "bitcoin_keplr";
class d0 extends z {
  constructor(g) {
    var c;
    const y = (c = S(g)) == null ? void 0 : c[c0];
    if (!y)
      throw new Error("Keplr Wallet extension not found");
    super(g, y), h(this, "connectWallet", async () => {
      if (!this.bitcoinNetworkProvider)
        throw new Error("Keplr Wallet extension not found");
      let t = null, d = null;
      try {
        if (t = await this.bitcoinNetworkProvider.connectWallet(), d = await this.bitcoinNetworkProvider.getPublicKey(), !t || t.length === 0 || !d)
          throw new Error("BTC is not enabled in Keplr Wallet");
      } catch {
        throw new Error("BTC is not enabled in Keplr Wallet");
      }
      return this;
    }), h(this, "getBalance", async () => (await this.bitcoinNetworkProvider.getBalance()).confirmed), h(this, "pushTx", async (t) => await this.bitcoinNetworkProvider.pushTx(t));
  }
  async switchNetwork(g) {
    return await this.bitcoinNetworkProvider.switchNetwork(g.replace("mainnet", "livenet"));
  }
  async getNetwork() {
    return (await this.bitcoinNetworkProvider.getNetwork()).replace("livenet", "mainnet");
  }
  getWalletProviderName() {
    return Promise.resolve(ZA.name);
  }
  getWalletProviderIcon() {
    return Promise.resolve(ZA.img);
  }
}
const ZA = {
  id: "bitcoin_keplr",
  img: Zt,
  name: "Keplr",
  chainType: "bitcoin",
  connectProvider: d0,
  type: "extension"
};
var nA = {};
Object.defineProperty(nA, "__esModule", { value: !0 });
nA.bech32m = jA = nA.bech32 = void 0;
const gA = "qpzry9x8gf2tvdw0s3jn54khce6mua7l", $t = {};
for (let o = 0; o < gA.length; o++) {
  const g = gA.charAt(o);
  $t[g] = o;
}
function $(o) {
  const g = o >> 25;
  return (o & 33554431) << 5 ^ -(g >> 0 & 1) & 996825010 ^ -(g >> 1 & 1) & 642813549 ^ -(g >> 2 & 1) & 513874426 ^ -(g >> 3 & 1) & 1027748829 ^ -(g >> 4 & 1) & 705979059;
}
function bt(o) {
  let g = 1;
  for (let c = 0; c < o.length; ++c) {
    const y = o.charCodeAt(c);
    if (y < 33 || y > 126)
      return "Invalid prefix (" + o + ")";
    g = $(g) ^ y >> 5;
  }
  g = $(g);
  for (let c = 0; c < o.length; ++c) {
    const y = o.charCodeAt(c);
    g = $(g) ^ y & 31;
  }
  return g;
}
function ct(o, g, c, y) {
  let t = 0, d = 0;
  const E = (1 << c) - 1, B = [];
  for (let D = 0; D < o.length; ++D)
    for (t = t << g | o[D], d += g; d >= c; )
      d -= c, B.push(t >> d & E);
  if (y)
    d > 0 && B.push(t << c - d & E);
  else {
    if (d >= g)
      return "Excess padding";
    if (t << c - d & E)
      return "Non-zero padding";
  }
  return B;
}
function l0(o) {
  return ct(o, 8, 5, !0);
}
function u0(o) {
  const g = ct(o, 5, 8, !1);
  if (Array.isArray(g))
    return g;
}
function f0(o) {
  const g = ct(o, 5, 8, !1);
  if (Array.isArray(g))
    return g;
  throw new Error(g);
}
function Ae(o) {
  let g;
  o === "bech32" ? g = 1 : g = 734539939;
  function c(E, B, D) {
    if (D = D || 90, E.length + 7 + B.length > D)
      throw new TypeError("Exceeds length limit");
    E = E.toLowerCase();
    let x = bt(E);
    if (typeof x == "string")
      throw new Error(x);
    let v = E + "1";
    for (let F = 0; F < B.length; ++F) {
      const M = B[F];
      if (M >> 5)
        throw new Error("Non 5-bit word");
      x = $(x) ^ M, v += gA.charAt(M);
    }
    for (let F = 0; F < 6; ++F)
      x = $(x);
    x ^= g;
    for (let F = 0; F < 6; ++F) {
      const M = x >> (5 - F) * 5 & 31;
      v += gA.charAt(M);
    }
    return v;
  }
  function y(E, B) {
    if (B = B || 90, E.length < 8)
      return E + " too short";
    if (E.length > B)
      return "Exceeds length limit";
    const D = E.toLowerCase(), x = E.toUpperCase();
    if (E !== D && E !== x)
      return "Mixed-case string " + E;
    E = D;
    const v = E.lastIndexOf("1");
    if (v === -1)
      return "No separator character for " + E;
    if (v === 0)
      return "Missing prefix for " + E;
    const F = E.slice(0, v), M = E.slice(v + 1);
    if (M.length < 6)
      return "Data too short";
    let U = bt(F);
    if (typeof U == "string")
      return U;
    const L = [];
    for (let H = 0; H < M.length; ++H) {
      const fe = M.charAt(H), ge = $t[fe];
      if (ge === void 0)
        return "Unknown character " + fe;
      U = $(U) ^ ge, !(H + 6 >= M.length) && L.push(ge);
    }
    return U !== g ? "Invalid checksum for " + E : { prefix: F, words: L };
  }
  function t(E, B) {
    const D = y(E, B);
    if (typeof D == "object")
      return D;
  }
  function d(E, B) {
    const D = y(E, B);
    if (typeof D == "object")
      return D;
    throw new Error(D);
  }
  return {
    decodeUnsafe: t,
    decode: d,
    encode: c,
    toWords: l0,
    fromWordsUnsafe: u0,
    fromWords: f0
  };
}
var jA = nA.bech32 = Ae("bech32");
nA.bech32m = Ae("bech32m");
const g0 = Y.default ? Y.default : Y;
var Ct;
const w0 = (Ct = j) != null && Ct.default ? j.default : j;
class h0 {
  constructor(g) {
    h(this, "viewSDK"), h(this, "dataSdk"), h(this, "account"), h(this, "publicKey"), h(this, "chains"), h(this, "xfp"), this.chains = g, this.viewSDK = g0, this.dataSdk = new w0({
      origin: ""
    });
  }
  async enable(g) {
    const c = Array.isArray(g) ? g[0] : g;
    if (!this.chains.find((B) => B.network === c))
      throw new Error(`ChainId ${c} not found`);
    const y = await (await this.viewSDK.getSdk()).read([SupportedResult.UR_CRYPTO_MULTI_ACCOUNTS], {
      title: "Sync Keystone with Babylon Staking App",
      description: "Please scan the QR code displayed on your Keystone",
      renderInitial: {
        walletMode: "cosmos",
        link: "",
        description: [
          "1. Version M-9.0 (Multi-Coin) or newer running on your Keystone Essential or Pro. ",
          '2. Click connect software wallet and use "Keplr" for connection.',
          '3. Press the "Sync Keystone" button and scan the QR Code displayed on your Keystone hardware wallet'
        ]
      },
      URTypeErrorMessage: "The scanned QR code can't be read. please verify and try again."
    }), t = this.dataSdk.parseMultiAccounts(y.result), d = t.keys.find((B) => B.chain === "ATOM");
    if (!d)
      throw new Error("Keystone does not support the Cosmos network.");
    const E = Buffer.from(d.publicKey, "hex");
    this.account = d, this.publicKey = E, this.xfp = t.masterFingerprint;
  }
  async getKey(g) {
    var c, y;
    if (!this.publicKey)
      throw new Error("Keystone Wallet not connected");
    const t = this.chains.find((B) => B.network === g);
    if (!t)
      throw new Error(`ChainId ${g} not found`);
    const d = (y = (c = t.modularData) == null ? void 0 : c.bech32Config) == null ? void 0 : y.bech32PrefixAccAddr;
    if (!d)
      throw new Error("chain.modularData.Bech32Config not specified");
    const E = jA.encode(d, jA.toWords(this.getRipemd160()));
    return {
      name: "Keystone",
      algo: "secp256k1",
      address: this.getRipemd160(),
      pubKey: new Uint8Array(this.publicKey),
      bech32Address: E,
      isNanoLedger: !1,
      isKeystone: !0
    };
  }
  getRipemd160() {
    if (!this.publicKey)
      throw new Error("Keystone Wallet not connected");
    const g = buildExports.sha256(this.publicKey);
    return buildExports.ripemd160(g);
  }
  getOfflineSigner(g, c) {
    return {
      getAccounts: async () => [await this.getKey(g)].map((y) => ({
        address: y.bech32Address,
        pubkey: y.pubKey,
        algo: y.algo
      })),
      signAmino: this.signAmino.bind(this, g),
      signDirect: async (y, t) => {
        var d, E;
        if (!this.publicKey)
          throw new Error("Keystone Wallet not connected");
        const B = {
          ...t,
          accountNumber: t.accountNumber.toString()
        }, D = {
          requestId: "7AFD5E09-9267-43FB-A02E-08C4A09417EC",
          signData: Buffer.from(y0(B)).toString("hex"),
          dataType: distExports.KeystoneCosmosSDK.DataType.direct,
          accounts: [
            {
              path: (d = this.account) == null ? void 0 : d.path,
              xfp: this.xfp,
              address: (await this.getKey(g)).bech32Address
            }
          ]
        }, x = this.dataSdk.cosmos.generateSignRequest(D), v = Bt(SupportedResult.UR_COSMOS_SIGNATURE), F = await this.viewSDK.getSdk(), M = await v(F, x), U = this.dataSdk.cosmos.parseSignature(M);
        if (U.publicKey !== ((E = this.publicKey) == null ? void 0 : E.toString("hex")))
          throw new Error("Public key mismatch");
        return {
          signed: {
            ...t,
            accountNumber: new Long(Number(t.accountNumber))
          },
          signature: Pt(this.publicKey, Buffer.from(U.signature, "hex"))
        };
      }
    };
  }
  async signAmino(g, c, y, t) {
    var d;
    if (!this.publicKey)
      throw new Error("Keystone Wallet not connected");
    const E = Buffer.from(v0(y)).toString("hex"), B = this.dataSdk.cosmos.generateSignRequest({
      requestId: "7AFD5E09-9267-43FB-A02E-08C4A09417EC",
      signData: E,
      dataType: distExports.KeystoneCosmosSDK.DataType.amino,
      accounts: [
        {
          path: this.account.path,
          xfp: this.xfp,
          address: (await this.getKey(g)).bech32Address
        }
      ]
    }), D = Bt(SupportedResult.UR_COSMOS_SIGNATURE), x = await this.viewSDK.getSdk(), v = await D(x, B), F = this.dataSdk.cosmos.parseSignature(v);
    if (F.publicKey !== ((d = this.publicKey) == null ? void 0 : d.toString("hex")))
      throw new Error("Public key mismatch");
    return {
      signed: y,
      signature: Pt(this.publicKey, Buffer.from(F.signature, "hex"))
    };
  }
  async signArbitrary(g, c, y) {
    throw new Error("signArbitrary not supported yet");
  }
  async sendTx(g, c, y) {
    throw new Error("sendTx not implemented");
  }
}
function YA(o) {
  if (typeof o != "object" || o === null)
    return o;
  if (Array.isArray(o))
    return o.map(YA);
  const g = Object.keys(o).sort(), c = {};
  return g.forEach((y) => {
    c[y] = YA(o[y]);
  }), c;
}
function p0(o) {
  return JSON.stringify(YA(o));
}
function m0(o) {
  return o.replace(/</g, "\\u003c").replace(/>/g, "\\u003e").replace(/&/g, "\\u0026");
}
function v0(o) {
  return Buffer.from(m0(p0(o)));
}
const Bt = (o) => async (g, c) => {
  if (await g.play(c, {
    title: "Scan the QR Code",
    description: "Please scan the QR code with your Keystone device."
  }) !== PlayStatus.success)
    throw new Error("Could not generate the QR code, please try again.");
  const y = await g.read([o], {
    title: "Get the Signature from Keystone",
    description: "Please scan the QR code displayed on your Keystone",
    URTypeErrorMessage: "The scanned QR code can't be read. please verify and try again."
  });
  if (y.status !== ReadStatus.success)
    throw new Error("Could not extract the signature, please try again.");
  return y.result;
};
function y0(o) {
  return "authInfoBytes" in o ? txExports.SignDoc.encode(o).finish() : txExports.SignDocDirectAux.encode(o).finish();
}
function Pt(o, g) {
  if (g.length !== 64)
    throw new Error("Signature must be 64 bytes long. Cosmos SDK uses a 2x32 byte fixed length encoding for the secp256k1 signature integers r and s.");
  return {
    pub_key: b0(o),
    signature: Buffer.from(g).toString("base64")
  };
}
function b0(o) {
  if (o.length !== 33 || o[0] !== 2 && o[0] !== 3)
    throw new Error("Public key must be compressed secp256k1, i.e. 33 bytes starting with 0x02 or 0x03");
  return {
    type: "tendermint/PubKeySecp256k1",
    value: Buffer.from(o).toString("base64")
  };
}
class C0 extends J {
  constructor(g) {
    const c = new h0(g.chains);
    super(g, c);
  }
  getWalletProviderName() {
    return Promise.resolve(_A.name);
  }
  getWalletProviderIcon() {
    return Promise.resolve(_A.img);
  }
}
const _A = {
  id: "cosmos_keystone",
  img: Gt,
  name: "Keystone",
  chainType: "cosmos",
  connectProvider: C0,
  type: "qrcode"
}, B0 = "tomo_cosmos";
class P0 extends J {
  constructor(g) {
    const c = S(g)[B0];
    if (!c)
      throw new Error("Tomo Wallet extension not found");
    super(g, c);
  }
  getWalletProviderName() {
    return Promise.resolve($A.name);
  }
  getWalletProviderIcon() {
    return Promise.resolve($A.img);
  }
  on(g, c) {
    var y, t;
    (t = (y = S(this.option).tomo_btc) == null ? void 0 : y.on) == null || t.call(y, g, c);
  }
  off(g, c) {
    var y, t;
    (t = (y = S(this.option).tomo_btc) == null ? void 0 : y.off) == null || t.call(y, g, c);
  }
}
const $A = {
  id: "cosmos_tomo",
  img: Ut,
  name: "Tomo",
  chainType: "cosmos",
  connectProvider: P0,
  type: "extension"
};
class N0 extends J {
  constructor(g) {
    const c = S(g).cactuslink_cosmos;
    if (!c)
      throw new Error("CactusLink Wallet extension not found");
    super(g, c);
  }
  getWalletProviderName() {
    return Promise.resolve(At.name);
  }
  getWalletProviderIcon() {
    return Promise.resolve(At.img);
  }
}
const At = {
  id: "cosmos_cactuslink",
  img: _t,
  name: "Cactus Link",
  chainType: "cosmos",
  connectProvider: N0,
  type: "extension"
}, I0 = [
  DA,
  EA,
  kA,
  TA,
  zA,
  KA,
  FA,
  MA,
  HA,
  VA,
  UA,
  GA,
  ZA
], S0 = [
  XA,
  LA,
  qA,
  RA,
  $A,
  JA,
  WA,
  QA,
  OA,
  _A,
  At
];
class x0 extends z {
  constructor(g) {
    var c;
    const y = (c = S(g)) == null ? void 0 : c.injectedTomo, t = y == null ? void 0 : y.bitcoin;
    if (!t)
      throw new Error("Injected Tomo Wallet not found");
    super(g, t), rA(this, "injectedTomo"), rA(this, "connectWallet", async () => {
      var d;
      const E = (await ((d = this.bitcoinNetworkProvider) == null ? void 0 : d.requestAccounts()))[0], B = await this.getPublicKeyHex();
      if (!E || !B)
        throw new Error("Could not connect to injected Wallet");
      return this;
    }), tt.img = y.info.logo, tt.name = y.info.name, this.injectedTomo = y;
  }
  getWalletProviderName() {
    var g, c;
    return Promise.resolve((c = (g = this.injectedTomo) == null ? void 0 : g.info) == null ? void 0 : c.name);
  }
  getWalletProviderIcon() {
    var g, c;
    return Promise.resolve((c = (g = this.injectedTomo) == null ? void 0 : g.info) == null ? void 0 : c.logo);
  }
}
class D0 extends J {
  constructor(g) {
    var c;
    const y = (c = S(g)) == null ? void 0 : c.injectedTomo, t = y == null ? void 0 : y.cosmos;
    if (!t)
      throw new Error("Injected Tomo Wallet not found");
    super(g, t), rA(this, "injectedTomo"), et.img = y.info.logo, et.name = y.info.name, this.injectedTomo = y;
  }
  getWalletProviderName() {
    var g, c;
    return Promise.resolve((c = (g = this.injectedTomo) == null ? void 0 : g.info) == null ? void 0 : c.name);
  }
  getWalletProviderIcon() {
    var g, c;
    return Promise.resolve((c = (g = this.injectedTomo) == null ? void 0 : g.info) == null ? void 0 : c.logo);
  }
}
const tt = {
  id: "bitcoin_tomo_auto",
  img: "",
  name: "Tomo Injected",
  chainType: "bitcoin",
  connectProvider: x0,
  type: "injected"
}, et = {
  id: "cosmos_tomo_auto",
  img: "",
  name: "Tomo Injected",
  chainType: "cosmos",
  connectProvider: D0,
  type: "injected"
}, te = [
  tt,
  et,
  ...I0,
  ...S0
], k0 = te.reduce((o, g) => (o[g.id] = g, o), {}), ee = te.map((o) => o.id);
function nt(o, g) {
  var c;
  return ((c = g.additionalWallets) == null ? void 0 : c.find((y) => y.id === o)) || k0[o];
}
function ne(o) {
  let g = (o.indexWallets || []).map((c) => nt(c, o)).filter((c) => !!c);
  return (!o.indexWallets || o.indexWallets === ee) && o.additionalWallets && (g = [
    ...g.filter((c) => {
      var y;
      return (y = o.additionalWallets) == null ? void 0 : y.every((t) => t.id !== c.id);
    }),
    ...o.additionalWallets
  ]), g;
}
const T0 = "data:image/svg+xml,%3csvg%20width='32'%20height='32'%20viewBox='0%200%2032%2032'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20id='Token'%3e%3cpath%20id='Network%20Icon%20Background'%20d='M16%2032C24.8366%2032%2032%2024.8366%2032%2016C32%207.16344%2024.8366%200%2016%200C7.16344%200%200%207.16344%200%2016C0%2024.8366%207.16344%2032%2016%2032Z'%20fill='%23F7931A'/%3e%3cpath%20id='Vector'%20d='M23.3198%2014.1189C23.6398%2012.1016%2022.0122%2011.0169%2019.7884%2010.2932L20.51%207.55978L18.7489%207.14593L18.0457%209.80711C17.583%209.69739%2017.1081%209.59537%2016.6342%209.49335L17.3425%206.81484L15.5814%206.40002L14.8599%209.13243C14.4767%209.04966%2014.0996%208.96882%2013.7347%208.88219L13.7368%208.87353L11.3071%208.30087L10.8383%2010.0776C10.8383%2010.0776%2012.1459%2010.3605%2012.1184%2010.3778C12.8318%2010.5463%2012.9602%2010.9919%2012.9388%2011.3461L12.1173%2014.4596C12.1663%2014.4712%2012.2295%2014.4885%2012.3008%2014.5145L12.1143%2014.4712L10.9627%2018.833C10.875%2019.037%2010.6539%2019.3441%2010.1545%2019.2276C10.1728%2019.2517%208.87443%2018.9264%208.87443%2018.9264L8%2020.8301L10.2931%2021.37C10.7191%2021.4711%2011.1369%2021.577%2011.5476%2021.6761L10.819%2024.4403L12.579%2024.8541L13.3006%2022.1208C13.7816%2022.243%2014.2484%2022.3566%2014.705%2022.4643L13.9854%2025.1862L15.7465%2025.6L16.4752%2022.8416C19.4796%2023.3787%2021.7381%2023.1621%2022.6889%2020.5962C23.4553%2018.5308%2022.6512%2017.3383%2021.0705%2016.5616C22.2222%2016.3114%2023.0884%2015.5963%2023.3198%2014.1189ZM19.2942%2019.449C18.751%2021.5154%2015.0667%2020.398%2013.8723%2020.1179L14.8405%2016.4557C16.0349%2016.7377%2019.8639%2017.295%2019.2942%2019.449ZM19.8394%2014.0891C19.3431%2015.9687%2016.2775%2015.013%2015.2838%2014.7792L16.1603%2011.4587C17.154%2011.6926%2020.3571%2012.1286%2019.8394%2014.0891Z'%20fill='white'/%3e%3c/g%3e%3c/svg%3e", E0 = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M20%2040C31.0457%2040%2040%2031.0457%2040%2020C40%208.9543%2031.0457%200%2020%200C8.9543%200%200%208.9543%200%2020C0%2031.0457%208.9543%2040%2020%2040Z'%20fill='%23AE219E'/%3e%3cpath%20d='M29.1497%2017.6486C29.5497%2015.127%2027.5153%2013.7711%2024.7356%2012.8664L25.6375%209.4497L23.4361%208.93238L22.5571%2012.2589C21.9788%2012.1217%2021.3851%2011.9942%2020.7927%2011.8667L21.6781%208.51852L19.4768%208L18.5748%2011.4155C18.0958%2011.312%2017.6245%2011.211%2017.1684%2011.1027L17.171%2011.0919L14.1339%2010.3761L13.5479%2012.5969C13.5479%2012.5969%2015.1824%2012.9506%2015.148%2012.9723C16.0397%2013.1828%2016.2002%2013.7398%2016.1735%2014.1826L15.1467%2018.0745C15.2078%2018.0889%2015.2868%2018.1106%2015.376%2018.1431L15.1429%2018.0889L13.7033%2023.5412C13.5938%2023.7963%2013.3173%2024.1801%2012.6931%2024.0345C12.716%2024.0646%2011.093%2023.6579%2011.093%2023.6579L10%2026.0376L12.8663%2026.7125C13.3988%2026.8388%2013.9212%2026.9712%2014.4346%2027.0951L13.5237%2030.5503L15.7238%2031.0676L16.6257%2027.6509C17.227%2027.8037%2017.8105%2027.9457%2018.3812%2028.0804L17.4818%2031.4827L19.6831%2032L20.594%2028.552C24.3496%2029.2233%2027.1726%2028.9526%2028.3612%2025.7453C29.3192%2023.1635%2028.314%2021.6729%2026.3382%2020.702C27.7777%2020.3892%2028.8605%2019.4953%2029.1497%2017.6486V17.6486ZM24.1177%2024.3112C23.4387%2026.8942%2018.8334%2025.4974%2017.3404%2025.1473L18.5506%2020.5697C20.0437%2020.9222%2024.8298%2021.6187%2024.1177%2024.3112ZM24.7993%2017.6113C24.1788%2019.9609%2020.3469%2018.7663%2019.1048%2018.4739L20.2004%2014.3233C21.4424%2014.6157%2025.4464%2015.1607%2024.7993%2017.6113Z'%20fill='white'/%3e%3c/svg%3e", z0 = "data:image/svg+xml,%3csvg%20width='1024'%20height='1024'%20viewBox='0%200%201024%201024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3ccircle%20cx='512'%20cy='512'%20r='512'%20fill='url(%23paint0_radial)'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M559.489%20834.999C575.149%20766.673%20586.037%20671.007%20588.667%20562.846L612.66%20563.429C610.005%20672.632%20599.01%20769.997%20582.883%20840.361C574.842%20875.446%20565.383%20904.46%20554.695%20924.986C549.359%20935.233%20543.415%20943.961%20536.702%20950.27C529.942%20956.624%20521.636%20961.2%20512%20961.2C500.94%20961.2%20491.681%20955.206%20484.372%20947.318C477.039%20939.402%20470.522%20928.41%20464.667%20915.38C452.92%20889.241%20442.683%20852.265%20434.371%20807.75L457.963%20803.345C466.127%20847.065%20475.94%20881.915%20486.558%20905.543C491.885%20917.397%20497.13%20925.774%20501.978%20931.006C506.851%20936.266%20510.194%20937.2%20512%20937.2C513.589%20937.2%20516.306%20936.503%20520.265%20932.783C524.27%20929.017%20528.739%20922.868%20533.408%20913.902C542.727%20896.005%20551.637%20869.259%20559.489%20834.999Z'%20fill='url(%23paint1_linear)'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M472.024%20159.599C457.662%20209.824%20446.256%20281.346%20440%20365.329L416.066%20363.546C422.388%20278.678%20433.97%20205.382%20448.949%20153.001C456.413%20126.9%20464.908%20105.31%20474.426%2089.9811C483.479%2075.4018%20495.808%2062.8003%20511.998%2062.8003C521.634%2062.8003%20529.94%2067.3757%20536.7%2073.7298C543.412%2080.0394%20549.357%2088.7673%20554.692%2099.0135C565.381%20119.54%20574.839%20148.554%20582.881%20183.639C599.008%20254.003%20610.003%20351.368%20612.657%20460.571L588.665%20461.154C586.035%20352.993%20575.147%20257.327%20559.487%20189.001C551.635%20154.741%20542.725%20127.995%20533.405%20110.098C528.737%20101.132%20524.268%2094.9826%20520.262%2091.2174C516.304%2087.4967%20513.586%2086.8003%20511.998%2086.8003C509.194%2086.8003%20503.102%2089.2971%20494.815%20102.642C486.994%20115.237%20479.231%20134.397%20472.024%20159.599Z'%20fill='url(%23paint2_linear)'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M440.002%20365.329C436.591%20411.12%20434.719%20460.503%20434.719%20512C434.719%20624.426%20443.64%20726.638%20457.963%20803.345L434.37%20807.75C419.716%20729.271%20410.719%20625.538%20410.719%20512C410.719%20459.931%20412.611%20409.952%20416.068%20363.546L440.002%20365.329Z'%20fill='url(%23paint3_linear)'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M428.801%20552.768C350.948%20505.24%20283.687%20457.047%20233.733%20414.458L218.162%20432.722C269.286%20476.307%20337.624%20525.225%20416.296%20573.252L428.801%20552.768Z'%20fill='url(%23paint4_linear)'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M767.494%20714.63C700.498%20694.032%20612.212%20655.633%20517.234%20603.835L505.743%20624.905C601.636%20677.202%20691.446%20716.357%20760.441%20737.57C794.843%20748.147%20824.697%20754.462%20847.816%20755.468C859.356%20755.97%20869.886%20755.186%20878.706%20752.527C887.588%20749.849%20895.703%20744.944%20900.521%20736.6C908.648%20722.523%20903.832%20705.465%20895.658%20690.267C887.059%20674.28%20872.482%20656.027%20853.448%20636.401C815.251%20597.014%20757.103%20550.07%20686.25%20501.935L672.763%20521.787C742.879%20569.422%20799.58%20615.329%20836.219%20653.109C854.604%20672.066%20867.443%20688.477%20874.521%20701.636C882.024%20715.585%20881.146%20722.158%20879.736%20724.6C878.942%20725.975%20876.98%20727.98%20871.779%20729.548C866.516%20731.135%20858.957%20731.93%20848.859%20731.491C828.702%20730.613%20801.087%20724.958%20767.494%20714.63Z'%20fill='url(%23paint5_linear)'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M550.142%20445.073C594.052%20470.424%20635.28%20496.323%20672.762%20521.787L686.249%20501.935C648.265%20476.13%20606.54%20449.922%20562.142%20424.288C457.09%20363.637%20356.566%20317.459%20278.943%20291.673C240.225%20278.812%20206.608%20270.82%20180.71%20268.863C167.793%20267.887%20156.102%20268.352%20146.399%20270.883C136.678%20273.419%20127.677%20278.403%20122.483%20287.4C116.91%20297.053%20117.522%20308.162%20120.767%20318.51C124.025%20328.902%20130.394%20340.143%20138.889%20351.844C155.934%20375.32%20183.256%20402.964%20218.161%20432.722L233.731%20414.459C199.44%20385.224%20173.744%20359%20158.31%20337.744C150.567%20327.079%20145.833%20318.237%20143.667%20311.33C141.488%20304.381%20142.358%20300.976%20143.267%20299.4C144.118%20297.927%20146.344%20295.701%20152.457%20294.106C158.588%20292.507%20167.34%20291.921%20178.901%20292.795C201.959%20294.537%20233.439%20301.847%20271.377%20314.45C347.064%20339.592%20446.084%20384.995%20550.142%20445.073Z'%20fill='url(%23paint6_linear)'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M520.48%20418.94C601.097%20375.105%20676.844%20340.946%20738.738%20319.198L730.782%20296.555C667.411%20318.822%20590.478%20353.561%20509.016%20397.855L520.48%20418.94Z'%20fill='url(%23paint7_linear)'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M208.476%20632.887C259.443%20585.405%20336.327%20528.414%20428.139%20472.245L415.614%20451.773C322.917%20508.484%20244.615%20566.418%20192.116%20615.326C165.939%20639.713%20145.692%20662.301%20133.359%20681.732C127.202%20691.432%20122.654%20700.906%20120.571%20709.841C118.473%20718.842%20118.68%20728.286%20123.48%20736.6C131.596%20750.657%20148.739%20755.021%20165.952%20755.552C184.057%20756.111%20207.098%20752.635%20233.547%20745.995C286.627%20732.669%20356.187%20705.881%20433.135%20668.71L422.696%20647.099C346.549%20683.883%20278.611%20709.937%20227.704%20722.717C202.16%20729.13%20181.585%20732.023%20166.692%20731.564C150.909%20731.077%20145.672%20727.037%20144.265%20724.6C143.473%20723.229%20142.72%20720.542%20143.945%20715.29C145.184%20709.973%20148.241%20703.07%20153.622%20694.593C164.363%20677.669%20182.919%20656.695%20208.476%20632.887Z'%20fill='url(%23paint8_linear)'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M551.138%20578.927C506.978%20604.423%20463.696%20627.293%20422.695%20647.099L433.135%20668.709C474.685%20648.638%20518.488%20625.491%20563.138%20599.711C668.19%20539.06%20758.443%20475.093%20819.586%20420.762C850.083%20393.662%20873.812%20368.545%20888.456%20347.094C895.76%20336.397%20901.203%20326.039%20903.862%20316.37C906.527%20306.684%20906.711%20296.397%20901.516%20287.4C896.007%20277.858%20886.239%20272.837%20875.802%20270.442C865.332%20268.039%20852.623%20267.871%20838.494%20269.285C810.15%20272.121%20773.234%20281.637%20730.78%20296.555L738.736%20319.197C780.427%20304.548%20815.286%20295.727%20840.884%20293.166C853.726%20291.881%20863.531%20292.25%20870.433%20293.834C877.369%20295.426%20879.832%20297.842%20880.732%20299.4C881.582%20300.873%20882.398%20303.914%20880.722%20310.005C879.041%20316.115%20875.173%20323.986%20868.635%20333.562C855.597%20352.659%20833.527%20376.267%20803.644%20402.821C744.026%20455.797%20655.196%20518.849%20551.138%20578.927Z'%20fill='url(%23paint9_linear)'/%3e%3ccircle%20cx='449.975'%20cy='804.495'%20r='31.3505'%20fill='white'/%3e%3ccircle%20r='31.3505'%20transform='matrix(0.5%20-0.866025%20-0.866025%20-0.5%20227.181%20419.466)'%20fill='white'/%3e%3ccircle%20r='31.3505'%20transform='matrix(0.5%200.866025%200.866025%20-0.5%20734.794%20312.039)'%20fill='white'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M512.012%20457.433C542.156%20457.433%20566.592%20481.869%20566.592%20512.012C566.592%20542.156%20542.156%20566.592%20512.012%20566.592C481.869%20566.592%20457.433%20542.156%20457.433%20512.012C457.433%20481.869%20481.869%20457.433%20512.012%20457.433Z'%20fill='white'/%3e%3cdefs%3e%3cradialGradient%20id='paint0_radial'%20cx='0'%20cy='0'%20r='1'%20gradientUnits='userSpaceOnUse'%20gradientTransform='translate(512%20512)%20rotate(90)%20scale(512)'%3e%3cstop%20offset='0.0909055'%20stop-color='%237C7C7C'/%3e%3cstop%20offset='0.233848'%20stop-color='%233E3E3E'/%3e%3cstop%20offset='0.817221'/%3e%3c/radialGradient%3e%3clinearGradient%20id='paint1_linear'%20x1='523.515'%20y1='961.2'%20x2='639.469'%20y2='570.809'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20offset='0.377307'%20stop-color='white'%20stop-opacity='0.6'/%3e%3cstop%20offset='0.992239'%20stop-color='white'%20stop-opacity='0'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint2_linear'%20x1='514.362'%20y1='62.8003'%20x2='663.926'%20y2='441'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20offset='0.634963'%20stop-color='white'%20stop-opacity='0.81'/%3e%3cstop%20offset='1'%20stop-color='white'%20stop-opacity='0'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint3_linear'%20x1='457.499'%20y1='363.546'%20x2='457.499'%20y2='808.261'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='white'%20stop-opacity='0.81'/%3e%3cstop%20offset='0.646422'%20stop-color='white'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint4_linear'%20x1='234.384'%20y1='411.354'%20x2='430.501'%20y2='549.696'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='white'%20stop-opacity='0.6'/%3e%3cstop%20offset='1'%20stop-color='white'%20stop-opacity='0'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint5_linear'%20x1='923.391'%20y1='735.037'%20x2='488.534'%20y2='662.67'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20offset='0.60731'%20stop-color='white'%20stop-opacity='0.81'/%3e%3cstop%20offset='1'%20stop-color='white'%20stop-opacity='0'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint6_linear'%20x1='674.619'%20y1='497.805'%20x2='110.127'%20y2='288.499'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='white'%20stop-opacity='0.81'/%3e%3cstop%20offset='0.478389'%20stop-color='white'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint7_linear'%20x1='743.225'%20y1='320.878'%20x2='508.048'%20y2='430.154'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='white'%20stop-opacity='0.6'/%3e%3cstop%20offset='1'%20stop-color='white'%20stop-opacity='0'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint8_linear'%20x1='110.421'%20y1='738.194'%20x2='404.819'%20y2='431.181'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20offset='0.54518'%20stop-color='white'%20stop-opacity='0.81'/%3e%3cstop%20offset='1'%20stop-color='white'%20stop-opacity='0'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint9_linear'%20x1='913.606'%20y1='276.28'%20x2='438.264'%20y2='671.645'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20offset='0.518582'%20stop-color='white'/%3e%3cstop%20offset='1'%20stop-color='white'%20stop-opacity='0.81'/%3e%3c/linearGradient%3e%3c/defs%3e%3c/svg%3e", F0 = {
  id: 1,
  name: "Bitcoin",
  network: "mainnet",
  type: "bitcoin",
  logo: T0
}, H0 = {
  id: 2,
  name: "Bitcoin Signet",
  type: "bitcoin",
  network: "signet",
  logo: E0
}, M0 = {
  id: 1,
  name: "Cosmos",
  type: "cosmos",
  network: "cosmoshub-4",
  logo: z0
}, X0 = [F0, H0], L0 = [M0];
typeof window < "u" && (window.Buffer = bufferExports.Buffer);
const dt = [];
function J0(o, g) {
  if (typeof window > "u")
    return X(g);
  const c = localStorage.getItem(o), y = X(c === "undefined" || c === null ? g : JSON.parse(c));
  return X((t) => t(y), (t, d, E) => {
    let B = E;
    return typeof E == "function" && (B = E(t(y))), localStorage.setItem(o, JSON.stringify(B)), d(y, B), B;
  });
}
const oe = [
  // 'evm',
  "bitcoin",
  "cosmos"
  // 'solana',
  // 'ton',
  // 'tron'
], re$2 = {
  isConnected: !1,
  bitcoin: {
    connected: !1,
    chainType: "bitcoin"
  },
  cosmos: {
    connected: !1,
    chainType: "cosmos"
  }
  // btcAddressType: 'P2TR'
}, Q = J0("tomo_wallet_state", re$2), G = X({
  state: 0
}), Nt = X(dt), lt = X([]);
X((o) => o(lt).findLast((g) => g.type === "page"));
const W0 = {
  bitcoinChains: X0,
  cosmosChains: L0,
  // @ts-ignore
  chainTypes: oe,
  socialTypes: [],
  indexWallets: ee,
  onlySocial: !1,
  useServerSettings: !1
}, O = X(W0);
X(void 0);
const ot = X({
  open: !1,
  chainType: "bitcoin"
}), ie = X(dt), se = X({
  theme: "light"
});
function q(o, g) {
  const c = useMemo(
    () => X(null, (y, t, ...d) => o(y, t, ...d)),
    [o]
  );
  return R(c);
}
function Q0(o) {
  return o && o.__esModule && Object.prototype.hasOwnProperty.call(o, "default") ? o.default : o;
}
var rt = { exports: {} };
(function(o, g) {
  Object.defineProperty(g, "__esModule", { value: !0 });
  function c(Pe) {
    return typeof Pe == "object" && !("toString" in Pe) ? Object.prototype.toString.call(Pe).slice(8, -1) : Pe;
  }
  var y = typeof process$1 == "object" && process$1.env.NODE_ENV === "production";
  function t(Pe, De) {
    if (!Pe)
      throw y ? new Error("Invariant failed") : new Error(De());
  }
  g.invariant = t;
  var d = Object.prototype.hasOwnProperty, E = Array.prototype.splice, B = Object.prototype.toString;
  function D(Pe) {
    return B.call(Pe).slice(8, -1);
  }
  var x = Object.assign || /* istanbul ignore next */
  function(Pe, De) {
    return v(De).forEach(function(ve) {
      d.call(De, ve) && (Pe[ve] = De[ve]);
    }), Pe;
  }, v = typeof Object.getOwnPropertySymbols == "function" ? function(Pe) {
    return Object.keys(Pe).concat(Object.getOwnPropertySymbols(Pe));
  } : function(Pe) {
    return Object.keys(Pe);
  };
  function F(Pe) {
    return Array.isArray(Pe) ? x(Pe.constructor(Pe.length), Pe) : D(Pe) === "Map" ? new Map(Pe) : D(Pe) === "Set" ? new Set(Pe) : Pe && typeof Pe == "object" ? x(Object.create(Object.getPrototypeOf(Pe)), Pe) : Pe;
  }
  var M = (
    /** @class */
    function() {
      function Pe() {
        this.commands = x({}, U), this.update = this.update.bind(this), this.update.extend = this.extend = this.extend.bind(this), this.update.isEquals = function(De, ve) {
          return De === ve;
        }, this.update.newContext = function() {
          return new Pe().update;
        };
      }
      return Object.defineProperty(Pe.prototype, "isEquals", {
        get: function() {
          return this.update.isEquals;
        },
        set: function(De) {
          this.update.isEquals = De;
        },
        enumerable: !0,
        configurable: !0
      }), Pe.prototype.extend = function(De, ve) {
        this.commands[De] = ve;
      }, Pe.prototype.update = function(De, ve) {
        var Fe = this, be = typeof ve == "function" ? { $apply: ve } : ve;
        Array.isArray(De) && Array.isArray(be) || t(!Array.isArray(be), function() {
          return "update(): You provided an invalid spec to update(). The spec may not contain an array except as the value of $set, $push, $unshift, $splice or any custom command allowing an array value.";
        }), t(typeof be == "object" && be !== null, function() {
          return "update(): You provided an invalid spec to update(). The spec and every included key path must be plain objects containing one of the " + ("following commands: " + Object.keys(Fe.commands).join(", ") + ".");
        });
        var Be = De;
        return v(be).forEach(function(ke) {
          if (d.call(Fe.commands, ke)) {
            var xe = De === Be;
            Be = Fe.commands[ke](be[ke], Be, be, De), xe && Fe.isEquals(Be, De) && (Be = De);
          } else {
            var Ne = D(De) === "Map" ? Fe.update(De.get(ke), be[ke]) : Fe.update(De[ke], be[ke]), Et = D(Be) === "Map" ? Be.get(ke) : Be[ke];
            (!Fe.isEquals(Ne, Et) || typeof Ne > "u" && !d.call(De, ke)) && (Be === De && (Be = F(De)), D(Be) === "Map" ? Be.set(ke, Ne) : Be[ke] = Ne);
          }
        }), Be;
      }, Pe;
    }()
  );
  g.Context = M;
  var U = {
    $push: function(Pe, De, ve) {
      return H(De, ve, "$push"), Pe.length ? De.concat(Pe) : De;
    },
    $unshift: function(Pe, De, ve) {
      return H(De, ve, "$unshift"), Pe.length ? Pe.concat(De) : De;
    },
    $splice: function(Pe, De, ve, Fe) {
      return ge(De, ve), Pe.forEach(function(be) {
        Ie(be), De === Fe && be.length && (De = F(Fe)), E.apply(De, be);
      }), De;
    },
    $set: function(Pe, De, ve) {
      return Se(ve), Pe;
    },
    $toggle: function(Pe, De) {
      fe(Pe, "$toggle");
      var ve = Pe.length ? F(De) : De;
      return Pe.forEach(function(Fe) {
        ve[Fe] = !De[Fe];
      }), ve;
    },
    $unset: function(Pe, De, ve, Fe) {
      return fe(Pe, "$unset"), Pe.forEach(function(be) {
        Object.hasOwnProperty.call(De, be) && (De === Fe && (De = F(Fe)), delete De[be]);
      }), De;
    },
    $add: function(Pe, De, ve, Fe) {
      return He(De, "$add"), fe(Pe, "$add"), D(De) === "Map" ? Pe.forEach(function(be) {
        var Be = be[0], ke = be[1];
        De === Fe && De.get(Be) !== ke && (De = F(Fe)), De.set(Be, ke);
      }) : Pe.forEach(function(be) {
        De === Fe && !De.has(be) && (De = F(Fe)), De.add(be);
      }), De;
    },
    $remove: function(Pe, De, ve, Fe) {
      return He(De, "$remove"), fe(Pe, "$remove"), Pe.forEach(function(be) {
        De === Fe && De.has(be) && (De = F(Fe)), De.delete(be);
      }), De;
    },
    $merge: function(Pe, De, ve, Fe) {
      return ze(De, Pe), v(Pe).forEach(function(be) {
        Pe[be] !== De[be] && (De === Fe && (De = F(Fe)), De[be] = Pe[be]);
      }), De;
    },
    $apply: function(Pe, De) {
      return Ee(Pe), Pe(De);
    }
  }, L = new M();
  g.isEquals = L.update.isEquals, g.extend = L.extend, g.default = L.update, g.default.default = o.exports = x(g.default, g);
  function H(Pe, De, ve) {
    t(Array.isArray(Pe), function() {
      return "update(): expected target of " + c(ve) + " to be an array; got " + c(Pe) + ".";
    }), fe(De[ve], ve);
  }
  function fe(Pe, De) {
    t(Array.isArray(Pe), function() {
      return "update(): expected spec of " + c(De) + " to be an array; got " + c(Pe) + ". Did you forget to wrap your parameter in an array?";
    });
  }
  function ge(Pe, De) {
    t(Array.isArray(Pe), function() {
      return "Expected $splice target to be an array; got " + c(Pe);
    }), Ie(De.$splice);
  }
  function Ie(Pe) {
    t(Array.isArray(Pe), function() {
      return "update(): expected spec of $splice to be an array of arrays; got " + c(Pe) + ". Did you forget to wrap your parameters in an array?";
    });
  }
  function Ee(Pe) {
    t(typeof Pe == "function", function() {
      return "update(): expected spec of $apply to be a function; got " + c(Pe) + ".";
    });
  }
  function Se(Pe) {
    t(Object.keys(Pe).length === 1, function() {
      return "Cannot have more than one key in an object with $set";
    });
  }
  function ze(Pe, De) {
    t(De && typeof De == "object", function() {
      return "update(): $merge expects a spec of type 'object'; got " + c(De);
    }), t(Pe && typeof Pe == "object", function() {
      return "update(): $merge expects a target of type 'object'; got " + c(Pe);
    });
  }
  function He(Pe, De) {
    var ve = D(Pe);
    t(ve === "Map" || ve === "Set", function() {
      return "update(): " + c(De) + " expects a target of type Set or Map; got " + c(ve);
    });
  }
})(rt, rt.exports);
var O0 = rt.exports;
const Z = /* @__PURE__ */ Q0(O0), K0 = [
  {
    wallet: "cosmos_keplr",
    messageRegex: /There is no modular chain info for/
  },
  {
    wallet: "cosmos_leap",
    messageRegex: /Invalid chain id/
  },
  {
    wallet: "cosmos_cosmostation",
    messageRegex: /There is no chain info for/
  }
];
function V0(o, g) {
  return o[g + "Chains"];
}
function hA() {
  const o = R(Q), g = R(G), c = q(useCallback(async (E, B, D) => {
    const { chainType: x } = D, v = await E(G)[`${x}Provider`].getAddress();
    o((F) => Z(F, {
      [x]: {
        address: {
          $set: v
        }
      }
    }));
  }, [])), y = q(useCallback(async (E, B, D, x = {}) => {
    var v;
    const { type: F = "connect" } = x, M = E(G), U = E(O), L = E(Q);
    try {
      const H = M[`${D}Provider`];
      if (!H)
        throw new Error(`Unsupported Chain: ${D}`);
      try {
        await H.connectWallet();
      } catch (Ie) {
        if (D !== "cosmos" || // @ts-ignore
        !((v = H == null ? void 0 : H.provider) != null && v.experimentalSuggestChain))
          throw Ie;
        const Ee = K0.find((ze) => {
          var He;
          return ze.wallet === ((He = L.cosmos) == null ? void 0 : He.walletId);
        });
        if (!Ee || !Ee.messageRegex.test(Ie.message || ""))
          throw Ie;
        const Se = U.cosmosChains[0].modularData;
        if (!Se)
          throw Ie;
        await H.provider.experimentalSuggestChain(Se), await H.connectWallet();
      }
      const fe = await H.getNetwork();
      let ge = U[`${D}Chains`].find((Ie) => Ie.network === fe);
      if (!ge) {
        const Ie = V0(U, D);
        if (!(Ie != null && Ie.length))
          throw new Error("Unsupported network");
        ge = Ie[0], await t(ge);
        return;
      }
      await c({ chainType: D }), o((Ie) => Z(Ie, {
        [D]: {
          $merge: {
            network: fe,
            chainId: ge.id
          }
        }
      }));
    } catch (H) {
      throw H;
    }
  }, [])), t = q(useCallback(async (E, B, D) => {
    const x = E(G)[`${D.type}Provider`];
    if (!x || !x.switchNetwork)
      throw new Error(`switchNetwork error: ${D.type}`);
    await x.switchNetwork(D.network);
    const v = await (x == null ? void 0 : x.getAddress()), F = await (x == null ? void 0 : x.getNetwork());
    o((M) => Z(M, {
      [D.type]: {
        $merge: {
          network: F,
          chainId: D.id,
          address: v
        }
      }
    }));
  }, [])), d = q(useCallback(async (E, B, D) => {
    const x = E(O), v = {}, F = nt(D, x);
    if (!F)
      throw new Error("Wallet does not exist");
    const M = v[`${F.chainType}Provider`] = new F.connectProvider(
      // @ts-ignore
      {
        chains: x[`${F.chainType}Chains`],
        ...x.providerOptions
      }
    );
    return await M.init(), g((U) => ({
      ...U,
      ...v
    })), M;
  }, []));
  return {
    initProvider: d,
    switchChainType: y,
    switchChain: t,
    reloadAddress: c,
    disconnect: q(useCallback(async (E, B) => {
      const D = E(O);
      o(ae(re$2, D));
    }, [])),
    connect: q(useCallback(async (E, B, D) => {
      var x;
      const v = E(O);
      for (const M of D) {
        const U = nt(M, v);
        if (!U)
          throw new Error("Wallet does not exist");
        o((L) => Z(L, {
          [U.chainType]: {
            $merge: {
              walletId: M
            }
          }
        })), await d(M), await y(U.chainType), o((L) => Z(L, {
          [U.chainType]: {
            $merge: {
              connected: !0
            }
          }
        }));
      }
      const F = E(Q);
      (x = v.chainTypes) != null && x.every((M) => F[M].connected) && o((M) => ({
        ...M,
        isConnected: !0
      }));
    }, []))
  };
}
const U0 = (o) => {
  if (window.ethereum) {
    let g = [];
    const c = (y) => {
      const t = [y.detail];
      g = g.concat(t), o(g || []);
    };
    window.addEventListener("eip6963:announceProvider", c), window.dispatchEvent(new Event("eip6963:requestProvider")), window.removeEventListener("eip6963:announceProvider", c);
  } else
    o([]);
};
function q0(o) {
  return o ? o == null ? void 0 : o.map((g) => g) : [];
}
function ae(o, g) {
  let c = o;
  return g.chainTypes.forEach((y) => {
    c[y] || (c = {
      ...c,
      [y]: {
        connected: !1,
        chainType: y
      }
    });
  }), c;
}
function R0(o) {
  const g = T(Nt), c = hA(), y = R(Nt);
  useEffect(() => {
    U0(y);
  }, []);
  const t = q(useCallback(async (d, E) => {
    var B;
    const D = {
      ...d(O),
      ...o
    };
    oe.forEach((F) => {
      D[`${F}Chains`] = q0(
        // @ts-ignore
        D[`${F}Chains`]
      );
    }), E(Q, (F) => ae(F, D)), E(O, D);
    const x = () => {
      E(Q, (F) => {
        var M;
        return (M = D.chainTypes) == null || M.forEach((U) => {
          F = Z(F, {
            [U]: {
              connected: {
                $set: !1
              }
            }
          });
        }), {
          ...F,
          isConnected: !1
        };
      });
    }, v = d(Q);
    if (v.isConnected && D.autoReconnect !== !1)
      try {
        if ((B = D.chainTypes) != null && B.some((M) => !v[M].connected))
          throw new Error("chain not connected");
        const F = D.chainTypes;
        for (const M of F) {
          const U = v[M].walletId;
          await c.initProvider(U), await c.switchChainType(M, {
            type: "init"
          });
        }
      } catch {
        E(Q, (F) => ({
          ...F,
          isConnected: !1
        })), x();
      }
    else
      x();
    E(G, (F) => ({
      ...F,
      state: 1
    }));
  }, []));
  return useEffect(() => {
    g !== dt && t();
  }, [g]), null;
}
function G0() {
  const o = T(G), g = hA(), c = T(Q);
  useEffect(() => {
    var y, t;
    if (!c.bitcoin.connected)
      return;
    const d = async () => {
      await g.reloadAddress({ chainType: "bitcoin" });
    };
    return (t = (y = o.bitcoinProvider) == null ? void 0 : y.on) == null || t.call(y, "accountsChanged", d), () => {
      var E, B;
      (B = (E = o.bitcoinProvider) == null ? void 0 : E.off) == null || B.call(E, "accountsChanged", d);
    };
  }, [o.bitcoinProvider, c.bitcoin.connected]), useEffect(() => {
    var y, t;
    if (!c.cosmos.connected)
      return;
    const d = async () => {
      await g.reloadAddress({ chainType: "cosmos" });
    };
    return (t = (y = o.cosmosProvider) == null ? void 0 : y.on) == null || t.call(y, "accountChanged", d), () => {
      var E, B;
      (B = (E = o.cosmosProvider) == null ? void 0 : E.off) == null || B.call(E, "accountChanged", d);
    };
  }, [o.cosmosProvider, c.cosmos.connected]);
}
function Z0(o) {
  return jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "12", height: "12", viewBox: "0 0 12 12", fill: "none", ...o, children: jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.41425 6.00025L11.7072 1.70725C12.0982 1.31625 12.0982 0.68425 11.7072 0.29325C11.3162 -0.09775 10.6842 -0.09775 10.2933 0.29325L6.00025 4.58625L1.70725 0.29325C1.31625 -0.09775 0.68425 -0.09775 0.29325 0.29325C-0.09775 0.68425 -0.09775 1.31625 0.29325 1.70725L4.58625 6.00025L0.29325 10.2933C-0.09775 10.6842 -0.09775 11.3162 0.29325 11.7072C0.48825 11.9022 0.74425 12.0002 1.00025 12.0002C1.25625 12.0002 1.51225 11.9022 1.70725 11.7072L6.00025 7.41425L10.2933 11.7072C10.4882 11.9022 10.7443 12.0002 11.0002 12.0002C11.2562 12.0002 11.5122 11.9022 11.7072 11.7072C12.0982 11.3162 12.0982 10.6842 11.7072 10.2933L7.41425 6.00025Z", fill: "currentColor", fillOpacity: "0.4" }) });
}
function ce(o) {
  return jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", ...o, children: [jsx("g", { clipPath: "url(#clip0_1_1460)", children: jsx("path", { d: "M14.6672 7.33284C14.2985 7.33284 14.0001 7.63127 14.0001 8.00002C14.0001 11.3078 11.3079 14 8.00005 14C6.59849 14 5.2813 13.525 4.22661 12.6672H5.33442C5.70317 12.6672 6.00161 12.3688 6.00161 12C6.00161 11.6313 5.70317 11.3328 5.33442 11.3328H2.66724C2.66099 11.3328 2.65474 11.3344 2.64849 11.3344C2.62661 11.3344 2.60474 11.3375 2.58442 11.3406C2.56255 11.3438 2.54067 11.3453 2.5188 11.35C2.50005 11.3547 2.4813 11.361 2.46255 11.3672C2.43911 11.375 2.41724 11.3813 2.39536 11.3922C2.37974 11.4 2.36411 11.4094 2.34849 11.4172C2.32505 11.4297 2.30317 11.4422 2.2813 11.4578C2.27661 11.461 2.27192 11.4625 2.2688 11.4656C2.25786 11.4735 2.25005 11.4844 2.23911 11.4922C2.22036 11.5078 2.20161 11.525 2.18442 11.5422C2.17036 11.5578 2.15786 11.5735 2.1438 11.5906C2.12974 11.6078 2.11724 11.625 2.1063 11.6438C2.0938 11.6625 2.08442 11.6813 2.07505 11.7016C2.06567 11.7203 2.0563 11.7391 2.04849 11.7594C2.04067 11.7813 2.03442 11.8031 2.02817 11.825C2.02349 11.8438 2.01724 11.8625 2.01411 11.8828C2.00942 11.9078 2.00786 11.9344 2.0063 11.961C2.0063 11.9735 2.00317 11.986 2.00317 11.9985V14.6656C2.00317 15.0344 2.30161 15.3328 2.67036 15.3328C3.03911 15.3328 3.33755 15.0344 3.33755 14.6656V13.6594C4.63599 14.736 6.26724 15.3313 8.00474 15.3313C12.0485 15.3313 15.3376 12.0422 15.3376 7.99846C15.3329 7.63127 15.0344 7.33284 14.6672 7.33284ZM8.00005 2.00002C9.40161 2.00002 10.7188 2.47502 11.7735 3.33284H10.6657C10.2969 3.33284 9.99849 3.63127 9.99849 4.00002C9.99849 4.36877 10.2969 4.66721 10.6657 4.66721H13.3329C13.3391 4.66721 13.3438 4.66565 13.3501 4.66565C13.3735 4.66565 13.3954 4.66096 13.4188 4.6594C13.4391 4.65627 13.461 4.65471 13.4813 4.65002C13.5016 4.64534 13.5204 4.63752 13.5407 4.63127C13.5625 4.62346 13.5844 4.61721 13.6063 4.60784C13.6235 4.60002 13.6391 4.59065 13.6547 4.58127C13.6766 4.56877 13.7 4.55627 13.7204 4.54221C13.725 4.53909 13.7297 4.53752 13.7344 4.5344C13.7454 4.52502 13.7547 4.51565 13.7657 4.50627C13.7844 4.49065 13.8016 4.47502 13.8188 4.45784C13.8344 4.44221 13.8469 4.42502 13.8594 4.40784C13.8719 4.39065 13.886 4.37502 13.8969 4.35627C13.9094 4.33752 13.9188 4.31721 13.9282 4.2969C13.9376 4.27815 13.9469 4.2594 13.9532 4.24065C13.961 4.21877 13.9672 4.1969 13.9735 4.17502C13.9782 4.15627 13.9844 4.13752 13.9876 4.11877C13.9922 4.09221 13.9938 4.06565 13.9954 4.04065C13.9954 4.02815 13.9985 4.01721 13.9985 4.00315V1.33284C13.9985 0.964087 13.7001 0.665649 13.3313 0.665649C12.9626 0.665649 12.6641 0.964087 12.6641 1.33284V2.33909C11.3657 1.26252 9.73442 0.667212 7.99692 0.667212C3.9563 0.667212 0.667236 3.95627 0.667236 8.00002C0.667236 8.36877 0.965674 8.66721 1.33442 8.66721C1.70317 8.66721 2.00005 8.36877 2.00005 8.00002C2.00005 4.69221 4.69224 2.00002 8.00005 2.00002Z", fill: "currentColor" }) }), jsx("defs", { children: jsx("clipPath", { id: "clip0_1_1460", children: jsx("rect", { width: "16", height: "16", fill: "white" }) }) })] });
}
function j0(o) {
  return jsx("svg", { viewBox: "64 64 896 896", focusable: "false", "data-icon": "check-circle", width: "1em", height: "1em", fill: "currentColor", "aria-hidden": "true", ...o, children: jsx("path", { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm193.5 301.7l-210.6 292a31.8 31.8 0 01-51.7 0L318.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.2 0 19.9 4.9 25.9 13.3l71.2 98.8 157.2-218c6-8.3 15.6-13.3 25.9-13.3H699c6.5 0 10.3 7.4 6.5 12.7z" }) });
}
function Y0(o) {
  return jsx("svg", { viewBox: "64 64 896 896", focusable: "false", "data-icon": "exclamation-circle", width: "1em", height: "1em", fill: "currentColor", "aria-hidden": "true", ...o, children: jsx("path", { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-32 232c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V296zm32 440a48.01 48.01 0 010-96 48.01 48.01 0 010 96z" }) });
}
function _0(o) {
  return jsx("svg", { fillRule: "evenodd", viewBox: "64 64 896 896", focusable: "false", "data-icon": "close-circle", width: "1em", height: "1em", fill: "currentColor", "aria-hidden": "true", ...o, children: jsx("path", { d: "M512 64c247.4 0 448 200.6 448 448S759.4 960 512 960 64 759.4 64 512 264.6 64 512 64zm127.98 274.82h-.04l-.08.06L512 466.75 384.14 338.88c-.04-.05-.06-.06-.08-.06a.12.12 0 00-.07 0c-.03 0-.05.01-.09.05l-45.02 45.02a.2.2 0 00-.05.09.12.12 0 000 .07v.02a.27.27 0 00.06.06L466.75 512 338.88 639.86c-.05.04-.06.06-.06.08a.12.12 0 000 .07c0 .03.01.05.05.09l45.02 45.02a.2.2 0 00.09.05.12.12 0 00.07 0c.02 0 .04-.01.08-.05L512 557.25l127.86 127.87c.04.04.06.05.08.05a.12.12 0 00.07 0c.03 0 .05-.01.09-.05l45.02-45.02a.2.2 0 00.05-.09.12.12 0 000-.07v-.02a.27.27 0 00-.05-.06L557.25 512l127.87-127.86c.04-.04.05-.06.05-.08a.12.12 0 000-.07c0-.03-.01-.05-.05-.09l-45.02-45.02a.2.2 0 00-.09-.05.12.12 0 00-.07 0z" }) });
}
let $0 = 1;
function de() {
  const o = R(lt), g = useContext(it);
  return {
    open: (c, y) => {
      const { type: t = "page", showClose: d = !0, ...E } = y || {}, B = $0++, D = new Promise((x) => {
        o((v) => [
          ...v,
          {
            jsx: c,
            resolve: x,
            type: t,
            showClose: d,
            openPageId: t === "drawer" ? g.page.type === "drawer" ? g.page.openPageId : g.id : void 0,
            id: B,
            opt: E
          }
        ]);
      });
      return D._pageId = B, D;
    },
    close: (c, y) => {
      o((t) => {
        const d = t.find((E) => E.id === c);
        return d && d.resolve(y), t.filter((E) => E.id !== c);
      });
    }
  };
}
const it = createContext({ id: 0, page: {} }), It = {
  getNextState(o, g) {
    return (!o || typeof o == "boolean") && (o = 0), o + g;
  },
  createFn(o) {
    return async function(g) {
      if (typeof g == "boolean") {
        o(g ? 1 : -1);
        return;
      }
      o(1);
      let c;
      try {
        typeof g == "function" ? c = await g() : c = await g;
      } catch (y) {
        throw o(-1), y;
      }
      return o(-1), c;
    };
  }
};
function An(o = !1) {
  const [g, c] = useState(o);
  return [
    !!g,
    It.createFn((y) => {
      c((t) => It.getNextState(t, y));
    })
  ];
}
function tn(o) {
  const g = de();
  useEffect(() => {
    if (o) {
      const c = g.open(jsx(le, {}), {
        type: "drawer",
        noBg: !0,
        full: !0,
        animate: !1
      });
      return () => {
        g.close(c._pageId);
      };
    }
  }, [o]);
}
function le() {
  return jsx("div", { className: "tm-flex tm-h-full tm-w-full tm-items-center tm-justify-center", children: jsx("div", { className: "tm-flex tm-size-16 tm-items-center tm-justify-center tm-rounded-lg tm-bg-white dark:tm-bg-white-dark", children: jsx(ce, { className: "tm-size-7 tm-animate-spin tm-text-tc1 dark:tm-text-tc1-dark" }) }) });
}
const en = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='38'%20height='16'%20viewBox='0%200%2038%2016'%20fill='none'%3e%3crect%20width='37.0683'%20height='16.0002'%20rx='1.11164'%20fill='%23666666'/%3e%3cpath%20d='M19.946%207.50648C19.5159%207.50648%2019.1206%207.40657%2018.7601%207.20674C18.4039%207.00692%2018.1194%206.72891%2017.9065%206.37271C17.698%206.01216%2017.5938%205.60817%2017.5938%205.16075C17.5938%204.71332%2017.698%204.31151%2017.9065%203.9553C18.1194%203.5991%2018.4039%203.32109%2018.7601%203.12127C19.1206%202.92144%2019.5159%202.82153%2019.946%202.82153C20.376%202.82153%2020.7692%202.92144%2021.1254%203.12127C21.4859%203.32109%2021.7683%203.5991%2021.9724%203.9553C22.181%204.31151%2022.2852%204.71332%2022.2852%205.16075C22.2852%205.60817%2022.181%206.01216%2021.9724%206.37271C21.7639%206.72891%2021.4816%207.00692%2021.1254%207.20674C20.7692%207.40657%2020.376%207.50648%2019.946%207.50648ZM19.946%206.48999C20.3109%206.48999%2020.6019%206.36836%2020.8191%206.1251C21.0407%205.88184%2021.1514%205.56039%2021.1514%205.16075C21.1514%204.75676%2021.0407%204.43531%2020.8191%204.19639C20.6019%203.95313%2020.3109%203.8315%2019.946%203.8315C19.5768%203.8315%2019.2814%203.95096%2019.0598%204.18988C18.8426%204.42879%2018.734%204.75242%2018.734%205.16075C18.734%205.56473%2018.8426%205.88836%2019.0598%206.13162C19.2814%206.37054%2019.5768%206.48999%2019.946%206.48999Z'%20fill='%23121212'/%3e%3cpath%20d='M16.9809%202.88672V7.46089H15.8667V4.71769L14.8437%207.46089H13.9445L12.915%204.71118V7.46089H11.8008V2.88672H13.117L14.4006%206.05345L15.6712%202.88672H16.9809Z'%20fill='%23121212'/%3e%3cpath%20d='M8.84248%207.50648C8.41243%207.50648%208.01713%207.40657%207.65658%207.20674C7.30038%207.00692%207.01585%206.72891%206.803%206.37271C6.59449%206.01216%206.49023%205.60817%206.49023%205.16075C6.49023%204.71332%206.59449%204.31151%206.803%203.9553C7.01585%203.5991%207.30038%203.32109%207.65658%203.12127C8.01713%202.92144%208.41243%202.82153%208.84248%202.82153C9.27253%202.82153%209.66566%202.92144%2010.0219%203.12127C10.3824%203.32109%2010.6648%203.5991%2010.8689%203.9553C11.0774%204.31151%2011.1817%204.71332%2011.1817%205.16075C11.1817%205.60817%2011.0774%206.01216%2010.8689%206.37271C10.6604%206.72891%2010.3781%207.00692%2010.0219%207.20674C9.66566%207.40657%209.27253%207.50648%208.84248%207.50648ZM8.84248%206.48999C9.20737%206.48999%209.49842%206.36836%209.71561%206.1251C9.93715%205.88184%2010.0479%205.56039%2010.0479%205.16075C10.0479%204.75676%209.93715%204.43531%209.71561%204.19639C9.49842%203.95313%209.20737%203.8315%208.84248%203.8315C8.47324%203.8315%208.17786%203.95096%207.95632%204.18988C7.73912%204.42879%207.63052%204.75242%207.63052%205.16075C7.63052%205.56473%207.73912%205.88836%207.95632%206.13162C8.17786%206.37054%208.47324%206.48999%208.84248%206.48999Z'%20fill='%23121212'/%3e%3cpath%20d='M6.12017%202.88672V3.7794H4.90821V7.46089H3.79399V3.7794H2.58203V2.88672H6.12017Z'%20fill='%23121212'/%3e%3cpath%20d='M34.4932%209.06519V9.95787H33.2813V13.6394H32.167V9.95787H30.9551V9.06519H34.4932Z'%20fill='%23121212'/%3e%3cpath%20d='M26.0508%2011.3458C26.0508%2010.894%2026.1485%2010.4922%2026.344%2010.1403C26.5395%209.78411%2026.811%209.50827%2027.1585%209.31279C27.5103%209.11297%2027.9078%209.01306%2028.3509%209.01306C28.8939%209.01306%2029.3587%209.15641%2029.7453%209.44311C30.1319%209.72981%2030.3904%2010.1208%2030.5207%2010.616H29.2957C29.2045%2010.4248%2029.0742%2010.2793%2028.9048%2010.1794C28.7397%2010.0795%2028.5507%2010.0295%2028.3379%2010.0295C27.9947%2010.0295%2027.7167%2010.149%2027.5038%2010.3879C27.291%2010.6268%2027.1846%2010.9461%2027.1846%2011.3458C27.1846%2011.7454%2027.291%2012.0647%2027.5038%2012.3036C27.7167%2012.5425%2027.9947%2012.662%2028.3379%2012.662C28.5507%2012.662%2028.7397%2012.612%2028.9048%2012.5121C29.0742%2012.4122%2029.2045%2012.2667%2029.2957%2012.0755H30.5207C30.3904%2012.5708%2030.1319%2012.9617%2029.7453%2013.2484C29.3587%2013.5308%2028.8939%2013.6719%2028.3509%2013.6719C27.9078%2013.6719%2027.5103%2013.5742%2027.1585%2013.3787C26.811%2013.1789%2026.5395%2012.9031%2026.344%2012.5512C26.1485%2012.1993%2026.0508%2011.7975%2026.0508%2011.3458Z'%20fill='%23121212'/%3e%3cpath%20d='M23.8291%209.95787V10.8831H25.3212V11.7432H23.8291V12.7467H25.5167V13.6394H22.7148V9.06519H25.5167V9.95787H23.8291Z'%20fill='%23121212'/%3e%3cpath%20d='M21.9064%2013.6394H20.7922L18.9287%2010.818V13.6394H17.8145V9.06519H18.9287L20.7922%2011.8996V9.06519H21.9064V13.6394Z'%20fill='%23121212'/%3e%3cpath%20d='M17.008%2013.6394H15.8938L14.0302%2010.818V13.6394H12.916V9.06519H14.0302L15.8938%2011.8996V9.06519H17.008V13.6394Z'%20fill='%23121212'/%3e%3cpath%20d='M9.95576%2013.6849C9.52571%2013.6849%209.13041%2013.585%208.76986%2013.3852C8.41366%2013.1854%208.12913%2012.9074%207.91628%2012.5512C7.70777%2012.1906%207.60352%2011.7866%207.60352%2011.3392C7.60352%2010.8918%207.70777%2010.49%207.91628%2010.1338C8.12913%209.77757%208.41366%209.49955%208.76986%209.29973C9.13041%209.09991%209.52571%209%209.95576%209C10.3858%209%2010.7789%209.09991%2011.1351%209.29973C11.4957%209.49955%2011.778%209.77757%2011.9822%2010.1338C12.1907%2010.49%2012.295%2010.8918%2012.295%2011.3392C12.295%2011.7866%2012.1907%2012.1906%2011.9822%2012.5512C11.7737%2012.9074%2011.4913%2013.1854%2011.1351%2013.3852C10.7789%2013.585%2010.3858%2013.6849%209.95576%2013.6849ZM9.95576%2012.6685C10.3207%2012.6685%2010.6117%2012.5468%2010.8289%2012.3036C11.0504%2012.0603%2011.1612%2011.7389%2011.1612%2011.3392C11.1612%2010.9352%2011.0504%2010.6138%2010.8289%2010.3749C10.6117%2010.1316%2010.3207%2010.01%209.95576%2010.01C9.58653%2010.01%209.29114%2010.1294%209.0696%2010.3683C8.8524%2010.6073%208.7438%2010.9309%208.7438%2011.3392C8.7438%2011.7432%208.8524%2012.0668%209.0696%2012.3101C9.29114%2012.549%209.58653%2012.6685%209.95576%2012.6685Z'%20fill='%23121212'/%3e%3cpath%20d='M2.64062%2011.3458C2.64062%2010.894%202.73836%2010.4922%202.93384%2010.1403C3.12932%209.78411%203.40082%209.50827%203.74833%209.31279C4.10019%209.11297%204.49766%209.01306%204.94074%209.01306C5.48374%209.01306%205.94854%209.15641%206.33515%209.44311C6.72176%209.72981%206.98022%2010.1208%207.11054%2010.616H5.88555C5.79433%2010.4248%205.66401%2010.2793%205.4946%2010.1794C5.32953%2010.0795%205.14056%2010.0295%204.92771%2010.0295C4.58454%2010.0295%204.30653%2010.149%204.09367%2010.3879C3.88082%2010.6268%203.77439%2010.9461%203.77439%2011.3458C3.77439%2011.7454%203.88082%2012.0647%204.09367%2012.3036C4.30653%2012.5425%204.58454%2012.662%204.92771%2012.662C5.14056%2012.662%205.32953%2012.612%205.4946%2012.5121C5.66401%2012.4122%205.79433%2012.2667%205.88555%2012.0755H7.11054C6.98022%2012.5708%206.72176%2012.9617%206.33515%2013.2484C5.94854%2013.5308%205.48374%2013.6719%204.94074%2013.6719C4.49766%2013.6719%204.10019%2013.5742%203.74833%2013.3787C3.40082%2013.1789%203.12932%2012.9031%202.93384%2012.5512C2.73836%2012.1993%202.64062%2011.7975%202.64062%2011.3458Z'%20fill='%23121212'/%3e%3c/svg%3e", nn = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='38'%20height='16'%20viewBox='0%200%2038%2016'%20fill='none'%3e%3crect%20width='37.0683'%20height='16.0002'%20rx='1.11164'%20fill='black'/%3e%3cpath%20d='M19.946%207.50648C19.5159%207.50648%2019.1206%207.40657%2018.7601%207.20674C18.4039%207.00692%2018.1194%206.72891%2017.9065%206.37271C17.698%206.01216%2017.5938%205.60817%2017.5938%205.16075C17.5938%204.71332%2017.698%204.31151%2017.9065%203.9553C18.1194%203.5991%2018.4039%203.32109%2018.7601%203.12127C19.1206%202.92144%2019.5159%202.82153%2019.946%202.82153C20.376%202.82153%2020.7692%202.92144%2021.1254%203.12127C21.4859%203.32109%2021.7683%203.5991%2021.9724%203.9553C22.181%204.31151%2022.2852%204.71332%2022.2852%205.16075C22.2852%205.60817%2022.181%206.01216%2021.9724%206.37271C21.7639%206.72891%2021.4816%207.00692%2021.1254%207.20674C20.7692%207.40657%2020.376%207.50648%2019.946%207.50648ZM19.946%206.48999C20.3109%206.48999%2020.6019%206.36836%2020.8191%206.1251C21.0407%205.88184%2021.1514%205.56039%2021.1514%205.16075C21.1514%204.75676%2021.0407%204.43531%2020.8191%204.19639C20.6019%203.95313%2020.3109%203.8315%2019.946%203.8315C19.5768%203.8315%2019.2814%203.95096%2019.0598%204.18988C18.8426%204.42879%2018.734%204.75242%2018.734%205.16075C18.734%205.56473%2018.8426%205.88836%2019.0598%206.13162C19.2814%206.37054%2019.5768%206.48999%2019.946%206.48999Z'%20fill='white'/%3e%3cpath%20d='M16.9809%202.88672V7.46089H15.8667V4.71769L14.8437%207.46089H13.9445L12.915%204.71118V7.46089H11.8008V2.88672H13.117L14.4006%206.05345L15.6712%202.88672H16.9809Z'%20fill='white'/%3e%3cpath%20d='M8.84248%207.50648C8.41243%207.50648%208.01713%207.40657%207.65658%207.20674C7.30038%207.00692%207.01585%206.72891%206.803%206.37271C6.59449%206.01216%206.49023%205.60817%206.49023%205.16075C6.49023%204.71332%206.59449%204.31151%206.803%203.9553C7.01585%203.5991%207.30038%203.32109%207.65658%203.12127C8.01713%202.92144%208.41243%202.82153%208.84248%202.82153C9.27253%202.82153%209.66566%202.92144%2010.0219%203.12127C10.3824%203.32109%2010.6648%203.5991%2010.8689%203.9553C11.0774%204.31151%2011.1817%204.71332%2011.1817%205.16075C11.1817%205.60817%2011.0774%206.01216%2010.8689%206.37271C10.6604%206.72891%2010.3781%207.00692%2010.0219%207.20674C9.66566%207.40657%209.27253%207.50648%208.84248%207.50648ZM8.84248%206.48999C9.20737%206.48999%209.49842%206.36836%209.71561%206.1251C9.93715%205.88184%2010.0479%205.56039%2010.0479%205.16075C10.0479%204.75676%209.93715%204.43531%209.71561%204.19639C9.49842%203.95313%209.20737%203.8315%208.84248%203.8315C8.47324%203.8315%208.17786%203.95096%207.95632%204.18988C7.73912%204.42879%207.63052%204.75242%207.63052%205.16075C7.63052%205.56473%207.73912%205.88836%207.95632%206.13162C8.17786%206.37054%208.47324%206.48999%208.84248%206.48999Z'%20fill='white'/%3e%3cpath%20d='M6.12017%202.88672V3.7794H4.90821V7.46089H3.79399V3.7794H2.58203V2.88672H6.12017Z'%20fill='white'/%3e%3cpath%20d='M34.4932%209.06519V9.95787H33.2813V13.6394H32.167V9.95787H30.9551V9.06519H34.4932Z'%20fill='white'/%3e%3cpath%20d='M26.0508%2011.3458C26.0508%2010.894%2026.1485%2010.4922%2026.344%2010.1403C26.5395%209.78411%2026.811%209.50827%2027.1585%209.31279C27.5103%209.11297%2027.9078%209.01306%2028.3509%209.01306C28.8939%209.01306%2029.3587%209.15641%2029.7453%209.44311C30.1319%209.72981%2030.3904%2010.1208%2030.5207%2010.616H29.2957C29.2045%2010.4248%2029.0742%2010.2793%2028.9048%2010.1794C28.7397%2010.0795%2028.5507%2010.0295%2028.3379%2010.0295C27.9947%2010.0295%2027.7167%2010.149%2027.5038%2010.3879C27.291%2010.6268%2027.1846%2010.9461%2027.1846%2011.3458C27.1846%2011.7454%2027.291%2012.0647%2027.5038%2012.3036C27.7167%2012.5425%2027.9947%2012.662%2028.3379%2012.662C28.5507%2012.662%2028.7397%2012.612%2028.9048%2012.5121C29.0742%2012.4122%2029.2045%2012.2667%2029.2957%2012.0755H30.5207C30.3904%2012.5708%2030.1319%2012.9617%2029.7453%2013.2484C29.3587%2013.5308%2028.8939%2013.6719%2028.3509%2013.6719C27.9078%2013.6719%2027.5103%2013.5742%2027.1585%2013.3787C26.811%2013.1789%2026.5395%2012.9031%2026.344%2012.5512C26.1485%2012.1993%2026.0508%2011.7975%2026.0508%2011.3458Z'%20fill='white'/%3e%3cpath%20d='M23.8291%209.95787V10.8831H25.3212V11.7432H23.8291V12.7467H25.5167V13.6394H22.7148V9.06519H25.5167V9.95787H23.8291Z'%20fill='white'/%3e%3cpath%20d='M21.9064%2013.6394H20.7922L18.9287%2010.818V13.6394H17.8145V9.06519H18.9287L20.7922%2011.8996V9.06519H21.9064V13.6394Z'%20fill='white'/%3e%3cpath%20d='M17.008%2013.6394H15.8938L14.0302%2010.818V13.6394H12.916V9.06519H14.0302L15.8938%2011.8996V9.06519H17.008V13.6394Z'%20fill='white'/%3e%3cpath%20d='M9.95576%2013.6849C9.52571%2013.6849%209.13041%2013.585%208.76986%2013.3852C8.41366%2013.1854%208.12913%2012.9074%207.91628%2012.5512C7.70777%2012.1906%207.60352%2011.7866%207.60352%2011.3392C7.60352%2010.8918%207.70777%2010.49%207.91628%2010.1338C8.12913%209.77757%208.41366%209.49955%208.76986%209.29973C9.13041%209.09991%209.52571%209%209.95576%209C10.3858%209%2010.7789%209.09991%2011.1351%209.29973C11.4957%209.49955%2011.778%209.77757%2011.9822%2010.1338C12.1907%2010.49%2012.295%2010.8918%2012.295%2011.3392C12.295%2011.7866%2012.1907%2012.1906%2011.9822%2012.5512C11.7737%2012.9074%2011.4913%2013.1854%2011.1351%2013.3852C10.7789%2013.585%2010.3858%2013.6849%209.95576%2013.6849ZM9.95576%2012.6685C10.3207%2012.6685%2010.6117%2012.5468%2010.8289%2012.3036C11.0504%2012.0603%2011.1612%2011.7389%2011.1612%2011.3392C11.1612%2010.9352%2011.0504%2010.6138%2010.8289%2010.3749C10.6117%2010.1316%2010.3207%2010.01%209.95576%2010.01C9.58653%2010.01%209.29114%2010.1294%209.0696%2010.3683C8.8524%2010.6073%208.7438%2010.9309%208.7438%2011.3392C8.7438%2011.7432%208.8524%2012.0668%209.0696%2012.3101C9.29114%2012.549%209.58653%2012.6685%209.95576%2012.6685Z'%20fill='white'/%3e%3cpath%20d='M2.64062%2011.3458C2.64062%2010.894%202.73836%2010.4922%202.93384%2010.1403C3.12932%209.78411%203.40082%209.50827%203.74833%209.31279C4.10019%209.11297%204.49766%209.01306%204.94074%209.01306C5.48374%209.01306%205.94854%209.15641%206.33515%209.44311C6.72176%209.72981%206.98022%2010.1208%207.11054%2010.616H5.88555C5.79433%2010.4248%205.66401%2010.2793%205.4946%2010.1794C5.32953%2010.0795%205.14056%2010.0295%204.92771%2010.0295C4.58454%2010.0295%204.30653%2010.149%204.09367%2010.3879C3.88082%2010.6268%203.77439%2010.9461%203.77439%2011.3458C3.77439%2011.7454%203.88082%2012.0647%204.09367%2012.3036C4.30653%2012.5425%204.58454%2012.662%204.92771%2012.662C5.14056%2012.662%205.32953%2012.612%205.4946%2012.5121C5.66401%2012.4122%205.79433%2012.2667%205.88555%2012.0755H7.11054C6.98022%2012.5708%206.72176%2012.9617%206.33515%2013.2484C5.94854%2013.5308%205.48374%2013.6719%204.94074%2013.6719C4.49766%2013.6719%204.10019%2013.5742%203.74833%2013.3787C3.40082%2013.1789%203.12932%2012.9031%202.93384%2012.5512C2.73836%2012.1993%202.64062%2011.7975%202.64062%2011.3458Z'%20fill='white'/%3e%3c/svg%3e";
function on() {
  const { theme: o } = T(se);
  return jsxs("div", { className: "tm-flex tm-gap-2 tm-pb-2.5 tm-text-xs tm-text-tc4 dark:tm-text-tc4-dark", children: [jsx("div", { children: "Powered by" }), jsx("img", { alt: "tomo", src: o === "dark" ? en : nn })] });
}
function rn() {
  const o = T(ie);
  return jsx("div", { className: "tm-pointer-events-none tm-absolute tm-bottom-20 tm-flex tm-w-full tm-flex-col tm-items-center tm-gap-4", children: [...o].reverse().map((g) => jsx(an, { msg: g }, g.id)) });
}
const sn = {
  success: jsx(j0, { className: "tm-size-4 tm-text-success" }),
  error: jsx(_0, { className: "tm-size-4 tm-text-danger" }),
  warning: jsx(Y0, { className: "tm-size-4 tm-text-warning" })
};
function an({ msg: o }) {
  const [g, c] = useState(!0), y = ue();
  return useEffect(() => {
    if (g) {
      const t = setTimeout(() => {
        y.remove(o.id);
      }, o.duration);
      return () => clearTimeout(t);
    }
  }, [g]), jsxs("div", { className: "tm-pointer-events-auto tm-flex tm-max-w-[80%] tm-items-center tm-gap-2 tm-overflow-hidden tm-rounded-lg tm-bg-white tm-px-4 tm-py-2 tm-text-sm dark:tm-bg-white-dark animate__animated animate__fadeInUp animate__faster", onMouseOver: () => {
    c(!1);
  }, onMouseLeave: () => {
    c(!0);
  }, style: {
    // boxShadow: '0px 0px 4px 0px rgba(213, 213, 213, 0.25)',
    boxShadow: "0 6px 16px 0 rgba(0, 0, 0, 0.08),0 3px 6px -4px rgba(0, 0, 0, 0.12),0 9px 28px 8px rgba(0, 0, 0, 0.05)"
  }, children: [sn[o.type || ""], jsx("div", { className: "tm-flex-1 tm-overflow-hidden", children: o.title })] }, o.id);
}
let cn = 1;
function ue() {
  const o = R(ie);
  return useMemo(() => ({
    remove: (g) => {
      o((c) => c.filter((y) => y.id !== g));
    },
    removeSameMsg: (g) => {
      o((c) => c.filter((y) => y.title !== g));
    },
    show: (g) => {
      o((c) => [...c, { type: "success", ...g, id: cn++ }]);
    }
  }), []);
}
function dn() {
  const o = (y) => (t) => {
    typeof t == "string" ? t = {
      duration: 3e3,
      title: t,
      type: y
    } : t = { ...t, type: y }, g.show(t);
  }, g = ue(), c = (y) => {
    typeof y == "string" && (y = {
      duration: 3e3,
      title: y
    }), g.show(y);
  };
  return c.success = o("success"), c.warning = o("warning"), c.error = o("error"), c;
}
function ln() {
  const o = navigator.userAgent;
  return /(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(o) ? "tablet" : /Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(o) ? "mobile" : "desktop";
}
function un({ chainType: o }) {
  return jsx(wn, { type: "connect", chainType: o });
}
function fn() {
  const o = hA(), g = T(O);
  return async (c) => {
    try {
      await new c.connectProvider({
        chains: [],
        ...g.providerOptions
      }).init();
    } catch {
      throw new Error("Wallet not installed");
    }
    await o.connect([c.id]);
  };
}
function Vn(o) {
  const g = T(O);
  return useMemo(() => ne(g).filter((c) => o ? c.chainType === o : !0), [g, o]);
}
function gn(o) {
  const g = T(O), [c, y] = useState(() => ne(g).map((E) => ({
    ...E,
    isInstall: !1
  }))), t = useMemo(() => {
    let E = !1;
    const B = ln() === "desktop";
    return c.filter((D) => {
      const x = o ? D.chainType === o : !0;
      if (x && D.type === "injected" && !B)
        if (D.isInstall)
          E = !0;
        else
          return !1;
      return x;
    }).filter((D) => B ? D.isInstall || D.type !== "injected" : D.isInstall || !E);
  }, [c, o]), d = async () => {
    c.filter((E) => o ? E.chainType === o : !0).forEach(async (E) => {
      if (!E.isInstall)
        try {
          await new E.connectProvider({
            chains: [],
            ...g.providerOptions
          }).init(), y((B) => Z(B, {
            [B.findIndex((D) => E.id === D.id)]: {
              isInstall: { $set: !0 }
            }
          }));
        } catch {
        }
    });
  };
  return useEffect(() => {
    d();
  }, [g, o]), t;
}
function wn(o) {
  const { chainType: g, type: c } = o, [y, t] = An();
  tn(y);
  const d = fn(), E = dn(), B = gn(g) || [];
  return jsxs("div", { className: "tm-relative tm-flex tm-h-[700px] tm-w-[660px] tm-max-w-full tm-max-w-full tm-flex-col tm-justify-start tm-gap-5 tm-overflow-hidden tm-bg-white tm-pt-9 tm-text-tc1 dark:tm-bg-mbg-dark dark:tm-text-tc1-dark", children: [jsxs("div", { className: "tm-flex tm-flex-col tm-gap-5 tm-px-6 tm-pb-9", children: [jsx("div", { className: "tm-text-[24px]", children: "Select your wallet" }), jsxs("div", { children: ["Connect a ", jsx("span", { className: "tm-capitalize", children: g }), " Wallet"] })] }), jsx("div", { className: "tm-box-border tm-w-full tm-flex-1 tm-gap-5 tm-overflow-y-auto tm-pb-6 tm-pt-2", children: jsx("div", { className: "tm-grid tm-w-full tm-flex-1 tm-grid-cols-1 sm:tm-grid-cols-2 tm-gap-6 tm-px-6", children: B.map((D) => jsx(hn, { wallet: D, onClick: () => {
    t(async () => {
      try {
        await d(D);
      } catch (x) {
        E.error((x == null ? void 0 : x.message) || "Failed");
      }
    });
  } }, `some-${D.id}`)) }) }), jsx("div", { className: "tm-bg-red tm-flex tm-flex-row tm-items-center tm-justify-center tm-text-center", children: jsx(on, {}) })] });
}
function hn({ wallet: o, ...g }) {
  const { onClick: c, checked: y } = g, t = () => {
    c && c();
  };
  return jsxs("div", { className: iA("tm-flex tm-h-[58px] tm-cursor-pointer tm-justify-between tm-rounded-lg tm-bg-white dark:tm-bg-[#282828] tm-px-2 hover:tm-bg-tc1/5 dark:hover:tm-bg-opacity-60 tm-border tm-border-[rgba(94,96,97,0.30)] tm-transition", {
    "tm-border tm-border-primary": y
  }), onClick: t, children: [jsxs("div", { className: "tm-flex tm-items-center tm-gap-3.5 ", children: [jsx("div", { className: "tm-size-[34px]", children: jsx("img", { src: o == null ? void 0 : o.img, alt: o == null ? void 0 : o.name, className: "tm-h-full tm-w-full tm-rounded-lg" }) }), jsx("div", { className: "tm-text-sm", children: o.name })] }), jsxs("div", { className: "tm-flex tm-items-center tm-gap-2", children: [o.type === "extension" && o.isInstall && jsx(vA, { children: "Installed" }), o.type === "qrcode" && jsx(vA, { children: "QR code" }), o.type === "injected" && jsx(vA, { children: "Injected" })] })] });
}
function vA({ children: o }) {
  return jsx("div", { className: "tm-rounded-full tm-bg-[#f6f7f3] tm-px-2.5 tm-py-1 tm-text-[10px] tm-text-[#666] dark:tm-bg-[#444] dark:tm-text-white", children: o });
}
function pn({ className: o, isModal: g, chainType: c }) {
  var y;
  const t = T(lt), d = de(), E = t.filter((v) => v.type === "page").length, B = t.filter((v) => v.type === "page"), D = ((y = B[B.length - 1]) == null ? void 0 : y.id) || 0, x = t.filter((v) => v.type === "drawer");
  return jsxs("div", { className: iA("tomo-social tm-relative tm-flex tm-max-w-full tm-justify-start tm-overflow-hidden tm-rounded-3xl tm-bg-mbg dark:tm-bg-mbg-dark tm-text-tc1 dark:tm-text-tc1-dark", {
    "tm-rounded-b-none": g
  }, o), style: {
    filter: "drop-shadow(0px 2px 5px rgba(0, 0, 0, 0.20))"
  }, children: [jsxs("div", { className: "tm-flex tm-max-w-full", style: {
    transform: `translateX(-${E / (E + 1) * 100}%)`
  }, children: [jsx("div", { className: "tm-h-fit tm-max-w-full tm-overflow-hidden", children: jsx(mn, { chainType: c }) }), B.map((v) => jsx("div", { className: "tm-relative tm-overflow-hidden", children: jsx(Suspense, { fallback: jsx(le, {}), children: jsx(it.Provider, { value: { id: v.id, page: v }, children: v.jsx }) }) }, v.id))] }), x.map((v) => {
    var F, M, U, L;
    const H = D !== v.openPageId;
    return jsx("div", { className: iA("tm-absolute tm-bottom-0 tm-left-0 tm-h-full tm-w-full tm-bg-tc1/70", {
      "tm-hidden": H,
      "animate__animated animate__fadeIn animate__faster": ((F = v.opt) == null ? void 0 : F.animate) !== !1
    }), onClick: () => {
      var fe;
      ((fe = v.opt) == null ? void 0 : fe.maskClosable) !== !1 && d.close(v.id);
    }, children: jsx("div", { onClick: (fe) => {
      fe.stopPropagation();
    }, className: iA("tm-absolute tm-bottom-0 tm-left-0 tm-max-h-full tm-w-full tm-overflow-hidden", {
      "tm-bg-white dark:tm-bg-white-dark": !((M = v.opt) != null && M.noBg),
      "tm-h-full": (U = v.opt) == null ? void 0 : U.full,
      "animate__animated animate__fadeInUp animate__faster": ((L = v.opt) == null ? void 0 : L.animate) !== !1
    }), children: jsx(it.Provider, { value: { id: v.id, page: v }, children: v.jsx }) }) }, v.id);
  }), jsx(rn, {})] });
}
function mn({ chainType: o }) {
  return T(G).state ? jsx(un, { chainType: o }) : (
    // eslint-disable-next-line tailwindcss/no-custom-classname
    jsx("div", { className: "tm-flex tm-h-[700px] tm-w-[660px] tm-items-center tm-justify-center", children: jsx(ce, { className: "tm-size-6 tm-animate-spin tm-text-tc1 dark:tm-text-tc1-dark" }) })
  );
}
function vn() {
  const o = T(Q), g = T(ot), c = yn(), { connected: y } = o[g.chainType] || { connected: !1 };
  return useEffect(() => {
    y && c.close({
      walletState: o
    });
  }, [y, g.open]), g.open ? createPortal(jsx("div", { className: "tomo-social tm-fixed tm-left-0 tm-top-0 tm-z-40 tm-box-border tm-flex tm-h-screen tm-w-screen tm-overflow-auto tm-bg-tc1/30  tm-font-poppins", onClick: () => {
    c.close(void 0);
  }, children: jsxs("div", {
    // className={'tm-relative tm-m-auto tm-overflow-hidden tm-rounded-3xl'}
    className: "tm-absolute sm:tm-relative sm:tm-m-auto sm:tm-w-auto tm-bottom-0 tm-left-0 tm-w-full tm-overflow-hidden tm-rounded-t-3xl sm:tm-rounded-b-3xl animate__animated animate__fadeInUp animate__faster sm:tm-animate-none",
    style: {
      filter: "drop-shadow(0px 4px 20px rgba(0, 0, 0, 0.30))",
      animationDuration: "0.3s"
    },
    onClick: (t) => t.stopPropagation(),
    children: [y ? null : jsx("div", { className: "tm-absolute tm-right-0 tm-top-3 tm-z-10 tm-cursor-pointer tm-p-4 tm-text-tc1 dark:tm-text-tc1-dark hover:tm-text-opacity-70", onClick: () => {
      c.close(void 0);
    }, children: jsx(Z0, {}) }), jsx(pn, { isModal: !0, chainType: g.chainType })]
  }) }), document.body) : null;
}
function yn() {
  const o = R(ot);
  return {
    open: q(useCallback((g, c, y) => {
      if (!g(Q)[y].connected)
        return new Promise((t) => {
          o({ open: !0, resolve: t, chainType: y });
        });
    }, [])),
    close: q(useCallback((g, c, y) => {
      var t;
      const d = g(ot);
      (t = d.resolve) == null || t.call(d, y), o((E) => ({ ...E, open: !1 }));
    }, []))
  };
}
const St = {
  rounded: "medium",
  theme: "light",
  primaryColor: "#121212"
}, yA = {
  rounded: {
    sizeList: [
      ["--tms-rounded", 4],
      ["--tms-rounded-md", 6],
      ["--tms-rounded-lg", 8],
      ["--tms-rounded-xl", 12],
      ["--tms-rounded-2xl", 16],
      ["--tms-rounded-3xl", 24],
      ["--tms-rounded-full", 9999]
    ],
    scale: {
      none: 0,
      small: 0.5,
      medium: 1,
      large: 2
    }
  }
};
function bn(o) {
  const [g, c] = d2(O), y = R(se), t = {
    ...St,
    ...o.style
  }, d = o.uiOptions;
  useEffect(() => {
    c((E) => ({ ...E, uiOptions: d }));
  }, [JSON.stringify(d)]), useEffect(() => {
    yA.rounded.sizeList.forEach(([E, B]) => {
      let D = yA.rounded.scale[t == null ? void 0 : t.rounded];
      isNaN(D) && (D = yA.rounded.scale.medium), document.documentElement.style.setProperty(E, `${B * D}px`);
    });
  }, [t == null ? void 0 : t.rounded]), useEffect(() => {
    (t == null ? void 0 : t.theme) === "dark" ? document.documentElement.classList.add("tm-dark") : document.documentElement.classList.remove("tm-dark"), y({ theme: (t == null ? void 0 : t.theme) === "dark" ? "dark" : "light" });
  }, [t == null ? void 0 : t.theme]), useEffect(() => {
    const E = !(t != null && t.primaryColor) || (t == null ? void 0 : t.primaryColor.toLowerCase()) === St.primaryColor;
    document.documentElement.style.setProperty("--tms-colors-primary-btn-text-dark", E ? "#121212" : "#ffffff"), document.documentElement.style.setProperty("--tms-colors-primary", Cn(E ? "#121212" : t.primaryColor)), document.documentElement.style.setProperty("--tms-colors-primary-dark", E ? "#ffffffe9" : t.primaryColor);
  }, [t == null ? void 0 : t.primaryColor]);
}
function Cn(o) {
  if (!/^#?([a-fA-F0-9]{6}|[a-fA-F0-9]{3})$/.test(o))
    throw new Error("Invalid hex color format");
  o = o.replace(/^#/, "");
  let g = parseInt(o, 16), c = g >> 16 & 255, y = g >> 8 & 255, t = g & 255;
  return `${c} ${y} ${t}`;
}
function Un({ children: o, ...g }) {
  return jsxs(a2, { children: [jsx(Bn, { otherProps: g }), jsx(vn, {}), o] });
}
function Bn({ otherProps: o }) {
  return R0(o), G0(), bn(o), null;
}
function qn() {
  return T(Q);
}
function Rn() {
  return T(G);
}
function Zn() {
  const o = hA();
  return {
    switchChainType: o.switchChainType,
    disconnect: o.disconnect,
    switchChain: o.switchChain
  };
}
const ExternalWallets = ({ chainName: o, onError: g, supportedWallets: c }) => {
  const y = fn(), t = gn(o), d = c ? (t || []).filter((B) => c.includes(B.id)) : t || [], E = async (B) => {
    try {
      await y(B);
    } catch (D) {
      g == null || g(D);
    }
  };
  return d.length === 0 ? null : /* @__PURE__ */ jsxs("div", { className: "pt-10 text-accent-primary", children: [
    /* @__PURE__ */ jsx(Text, { className: "mb-4", children: "More wallets with Tomo Connect" }),
    /* @__PURE__ */ jsx("div", { className: "grid grid-cols-3 items-center justify-between gap-6 rounded border border-secondary-strokeLight p-6 md:grid-cols-7", children: d.map((B) => {
      var D;
      return /* @__PURE__ */ jsxs(
        "button",
        {
          disabled: !B.isInstall,
          className: twJoin("flex flex-col items-center gap-2.5", B.isInstall ? "opacity-100" : "opacity-50"),
          onClick: () => E(B),
          "data-testid": `tomo-wallet-option-${o}_${(D = B.name) == null ? void 0 : D.toLowerCase()}`,
          children: [
            /* @__PURE__ */ jsx("img", { className: "size-10 object-contain", src: B.img, alt: B.name }),
            /* @__PURE__ */ jsx(Text, { className: "whitespace-nowrap leading-none", variant: "body2", children: B.name })
          ]
        },
        B.id
      );
    }) })
  ] });
};
function adaptBtcConfig(o) {
  return {
    id: 1,
    name: o.networkName,
    type: "bitcoin",
    network: o.network,
    backendUrls: {
      mempoolUrl: o.mempoolApiUrl + "/api/"
    }
  };
}
function adaptBbnConfig(o) {
  return {
    id: 2,
    name: o.chainData.chainName,
    type: "cosmos",
    network: o.chainId,
    modularData: o.chainData,
    backendUrls: {
      rpcUrl: o.rpc
    },
    logo: o.chainData.chainSymbolImageUrl
  };
}
const TomoConnectionProvider = ({ children: o, theme: g, config: c }) => {
  const y = useMemo(
    () => c.filter((d) => d.chain === "BTC").map((d) => adaptBtcConfig(d.config)),
    [c]
  ), t = useMemo(
    () => c.filter((d) => d.chain === "BBN").map((d) => adaptBbnConfig(d.config)),
    [c]
  );
  return /* @__PURE__ */ jsx(
    Un,
    {
      autoReconnect: !1,
      bitcoinChains: y,
      chainTypes: ["bitcoin", "cosmos"],
      cosmosChains: t,
      style: {
        rounded: "medium",
        theme: g,
        primaryColor: "#FF7C2A"
      },
      children: o
    }
  );
}, HEX_STRINGS = "0123456789abcdefABCDEF";
HEX_STRINGS.split("").map((o) => o.codePointAt(0));
Array(256).fill(!0).map((o, g) => {
  const c = String.fromCodePoint(g), y = HEX_STRINGS.indexOf(c);
  return y < 0 ? void 0 : y < 16 ? y : y - 6;
});
new TextEncoder();
new TextDecoder("ascii");
function compare(o, g) {
  const c = Math.min(o.length, g.length);
  for (let y = 0; y < c; ++y)
    if (o[y] !== g[y])
      return o[y] < g[y] ? -1 : 1;
  return o.length === g.length ? 0 : o.length > g.length ? 1 : -1;
}
const ERROR_BAD_PRIVATE = 0, ERROR_BAD_POINT = 1, ERROR_BAD_TWEAK = 2, ERROR_BAD_HASH = 3, ERROR_BAD_SIGNATURE = 4, ERROR_BAD_EXTRA_DATA = 5, ERROR_BAD_PARITY = 6, ERROR_BAD_RECOVERY_ID = 7, ERRORS_MESSAGES = {
  [ERROR_BAD_PRIVATE.toString()]: "Expected Private",
  [ERROR_BAD_POINT.toString()]: "Expected Point",
  [ERROR_BAD_TWEAK.toString()]: "Expected Tweak",
  [ERROR_BAD_HASH.toString()]: "Expected Hash",
  [ERROR_BAD_SIGNATURE.toString()]: "Expected Signature",
  [ERROR_BAD_EXTRA_DATA.toString()]: "Expected Extra Data (32 bytes)",
  [ERROR_BAD_PARITY.toString()]: "Expected Parity (1 | 0)",
  [ERROR_BAD_RECOVERY_ID.toString()]: "Bad Recovery Id"
};
function throwError(o) {
  const g = ERRORS_MESSAGES[o.toString()] || `Unknow error code: ${o}`;
  throw new TypeError(g);
}
const $_validate_error_js = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ERROR_BAD_EXTRA_DATA,
  ERROR_BAD_HASH,
  ERROR_BAD_PARITY,
  ERROR_BAD_POINT,
  ERROR_BAD_PRIVATE,
  ERROR_BAD_RECOVERY_ID,
  ERROR_BAD_SIGNATURE,
  ERROR_BAD_TWEAK,
  throwError
}, Symbol.toStringTag, { value: "Module" })), PRIVATE_KEY_SIZE = 32, PUBLIC_KEY_COMPRESSED_SIZE = 33, PUBLIC_KEY_UNCOMPRESSED_SIZE = 65, X_ONLY_PUBLIC_KEY_SIZE = 32, TWEAK_SIZE = 32, HASH_SIZE = 32, EXTRA_DATA_SIZE = 32, SIGNATURE_SIZE = 64, BN32_ZERO = new Uint8Array(32), BN32_N = new Uint8Array([
  255,
  255,
  255,
  255,
  255,
  255,
  255,
  255,
  255,
  255,
  255,
  255,
  255,
  255,
  255,
  254,
  186,
  174,
  220,
  230,
  175,
  72,
  160,
  59,
  191,
  210,
  94,
  140,
  208,
  54,
  65,
  65
]), BN32_P_MINUS_N = new Uint8Array([
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  1,
  69,
  81,
  35,
  25,
  80,
  183,
  95,
  196,
  64,
  45,
  161,
  114,
  47,
  201,
  186,
  238
]);
function isUint8Array(o) {
  return o instanceof Uint8Array;
}
function cmpBN32(o, g) {
  for (let c = 0; c < 32; ++c)
    if (o[c] !== g[c])
      return o[c] < g[c] ? -1 : 1;
  return 0;
}
function isZero(o) {
  return cmpBN32(o, BN32_ZERO) === 0;
}
function isPrivate$1(o) {
  return isUint8Array(o) && o.length === PRIVATE_KEY_SIZE && cmpBN32(o, BN32_ZERO) > 0 && cmpBN32(o, BN32_N) < 0;
}
function isPoint$2(o) {
  return isUint8Array(o) && (o.length === PUBLIC_KEY_COMPRESSED_SIZE || o.length === PUBLIC_KEY_UNCOMPRESSED_SIZE || o.length === X_ONLY_PUBLIC_KEY_SIZE);
}
function isXOnlyPoint$1(o) {
  return isUint8Array(o) && o.length === X_ONLY_PUBLIC_KEY_SIZE;
}
function isDERPoint(o) {
  return isUint8Array(o) && (o.length === PUBLIC_KEY_COMPRESSED_SIZE || o.length === PUBLIC_KEY_UNCOMPRESSED_SIZE);
}
function isPointCompressed$1(o) {
  return isUint8Array(o) && o.length === PUBLIC_KEY_COMPRESSED_SIZE;
}
function isTweak(o) {
  return isUint8Array(o) && o.length === TWEAK_SIZE && cmpBN32(o, BN32_N) < 0;
}
function isHash(o) {
  return isUint8Array(o) && o.length === HASH_SIZE;
}
function isExtraData(o) {
  return o === void 0 || isUint8Array(o) && o.length === EXTRA_DATA_SIZE;
}
function isSignature(o) {
  return isUint8Array(o) && o.length === 64 && cmpBN32(o.subarray(0, 32), BN32_N) < 0 && cmpBN32(o.subarray(32, 64), BN32_N) < 0;
}
function isSigrLessThanPMinusN(o) {
  return isUint8Array(o) && o.length === 64 && cmpBN32(o.subarray(0, 32), BN32_P_MINUS_N) < 0;
}
function validateParity(o) {
  o !== 0 && o !== 1 && throwError(ERROR_BAD_PARITY);
}
function validatePrivate(o) {
  isPrivate$1(o) || throwError(ERROR_BAD_PRIVATE);
}
function validatePoint(o) {
  isPoint$2(o) || throwError(ERROR_BAD_POINT);
}
function validateXOnlyPoint(o) {
  isXOnlyPoint$1(o) || throwError(ERROR_BAD_POINT);
}
function validateTweak(o) {
  isTweak(o) || throwError(ERROR_BAD_TWEAK);
}
function validateHash(o) {
  isHash(o) || throwError(ERROR_BAD_HASH);
}
function validateExtraData(o) {
  isExtraData(o) || throwError(ERROR_BAD_EXTRA_DATA);
}
function validateSignature(o) {
  isSignature(o) || throwError(ERROR_BAD_SIGNATURE);
}
function validateSignatureCustom(o) {
  o() || throwError(ERROR_BAD_SIGNATURE);
}
function validateSignatureNonzeroRS(o) {
  isZero(o.subarray(0, 32)) && throwError(ERROR_BAD_SIGNATURE), isZero(o.subarray(32, 64)) && throwError(ERROR_BAD_SIGNATURE);
}
function validateSigrPMinusN(o) {
  isSigrLessThanPMinusN(o) || throwError(ERROR_BAD_RECOVERY_ID);
}
function get4RandomBytes() {
  const o = new Uint8Array(4);
  if (typeof crypto > "u")
    throw new Error("The crypto object is unavailable. This may occur if your environment does not support the Web Cryptography API.");
  return crypto.getRandomValues(o), o;
}
function generateInt32() {
  const o = get4RandomBytes();
  return (o[0] << 24) + (o[1] << 16) + (o[2] << 8) + o[3];
}
const $_rand_js = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  generateInt32
}, Symbol.toStringTag, { value: "Module" }));
var bufferView, base64ReverseLookup = new Uint8Array(
  123
  /*'z'+1*/
);
for (var i = 25; i >= 0; --i)
  base64ReverseLookup[48 + i] = 52 + i, base64ReverseLookup[65 + i] = i, base64ReverseLookup[97 + i] = 26 + i;
base64ReverseLookup[43] = 62;
base64ReverseLookup[47] = 63;
function base64DecodeToExistingUint8Array(o, g, c) {
  for (var y, t, d = 0, E = g, B = c.length, D = g + (B * 3 >> 2) - (c[B - 2] == "=") - (c[B - 1] == "="); d < B; d += 4)
    y = base64ReverseLookup[c.charCodeAt(d + 1)], t = base64ReverseLookup[c.charCodeAt(d + 2)], o[E++] = base64ReverseLookup[c.charCodeAt(d)] << 2 | y >> 4, E < D && (o[E++] = y << 4 | t >> 2), E < D && (o[E++] = t << 6 | base64ReverseLookup[c.charCodeAt(d + 3)]);
}
function initActiveSegments(o) {
  base64DecodeToExistingUint8Array(bufferView, 655360, "AQAAAAQAAAAEAAAAAgAAAAEAAAAEAAAABAAAAAM="), base64DecodeToExistingUint8Array(bufferView, 655716, "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"), base64DecodeToExistingUint8Array(bufferView, 689368, "BgAAAAAAAAAG"), base64DecodeToExistingUint8Array(bufferView, 689392, "BgAAAAAAAAByZXQASW52YWxpZCBmbGFncwBzZWxmIHRlc3QgZmFpbGVkAEZvciB0aGlzIHNhbXBsZSwgdGhpcyA2My1ieXRlIHN0cmluZyB3aWxsIGJlIHVzZWQgYXMgaW5wdXQgZGF0YQAoZmxhZ3MgJiBTRUNQMjU2SzFfRkxBR1NfVFlQRV9NQVNLKSA9PSBTRUNQMjU2SzFfRkxBR1NfVFlQRV9DT01QUkVTU0lPTgBzZWNrZXkgIT0gTlVMTAB4b25seV9wdWJrZXkgIT0gTlVMTABvdXRwdXRfcHVia2V5ICE9IE5VTEwAaW50ZXJuYWxfcHVia2V5ICE9IE5VTEwAb3V0cHV0ICE9IE5VTEwAaW5wdXQgIT0gTlVMTABwdWJub25jZXMgIT0gTlVMTABrZXlwYWlyICE9IE5VTEwAc2lnaW4gIT0gTlVMTABvdXRwdXRsZW4gIT0gTlVMTABzaWcgIT0gTlVMTABzaWduYXR1cmUgIT0gTlVMTABwdWJub25jZSAhPSBOVUxMAHJlY2lkICE9IE5VTEwAcHVibm9uY2VzW2ldICE9IE5VTEwAb3V0cHV0NjQgIT0gTlVMTABpbnB1dDY0ICE9IE5VTEwAc2lnNjQgIT0gTlVMTABzZWNrZXkzMiAhPSBOVUxMAHR3ZWFrZWRfcHVia2V5MzIgIT0gTlVMTABvdXRwdXQzMiAhPSBOVUxMAGlucHV0MzIgIT0gTlVMTAB0d2VhazMyICE9IE5VTEwAbXNnaGFzaDMyICE9IE5VTEwAcmVjaWQgPj0gMCAmJiByZWNpZCA8PSAzAG4gPj0gMQBtc2cgIT0gTlVMTCB8fCBtc2dsZW4gPT0gMABydXN0c2VjcDI1NmsxX3YwXzhfMV9lY211bHRfZ2VuX2NvbnRleHRfaXNfYnVpbHQoJmN0eC0+ZWNtdWx0X2dlbl9jdHgpACFydXN0c2VjcDI1NmsxX3YwXzhfMV9mZV9pc196ZXJvKCZnZS0+eCkAKm91dHB1dGxlbiA+PSAoKGZsYWdzICYgU0VDUDI1NksxX0ZMQUdTX0JJVF9DT01QUkVTU0lPTikgPyAzM3UgOiA2NXUpAAAAAAAABgAAAAAAAAAEAAAAAAAAAAE="), base64DecodeToExistingUint8Array(bufferView, 690288, "8Ip4y7ruCCsFKuBwjzL6HlDFxCGqdyul27QGoupr40JBQTbQjF7SP+6AIr2ac7sq6/////////8="), base64DecodeToExistingUint8Array(bufferView, 690353, "AQAAAAAAAMFOd6qZAPI0AAEAAAAAAACYF/gWW4ECAJ+VjeLcsg0A/JsCBwuHDgBcKQZaxboLANz5fma+eQAAuNQQ+4/QBwDEmUFVaIoEALQX/agIEQ4AwL9P2lVGDACjJnfaOkg="), base64DecodeToExistingUint8Array(bufferView, 690464, "L/z///7///8="), base64DecodeToExistingUint8Array(bufferView, 690497, "AQAAAAAAAM/K2i3i9scngA=="), base64DecodeToExistingUint8Array(bufferView, 690576, "w+S/Cql/VG8oiA4B1n5D5A=="), base64DecodeToExistingUint8Array(bufferView, 690608, "LFaxPajNZddtNHQHxQooiv7///////////////////8xsNtFmiCT6H/K6HEUiqo9FeuEkuSQbOjNa9SnIdKGMHF/xIqutHEVxgb1nawIEiLE5L8KqX9UbyiIDgHWfkPkcr0jG3yWAt94ZoEg6iIuElpkEogCHCal4DBcwEytY1NCSVAwMzQwL25vbmNl"), base64DecodeToExistingUint8Array(bufferView, 690752, "MIQK");
}
function wasm2js_trap() {
  throw new Error("abort");
}
function asmFunc(o) {
  var g = new ArrayBuffer(720896), c = new Int8Array(g), y = new Int16Array(g), t = new Int32Array(g), d = new Uint8Array(g), E = new Uint16Array(g), B = Math.imul, D = Math.clz32, x = o["./rand.js"], v = x.generateInt32, F = o["./validate_error.js"], M = F.throwError, U = 655360, L = 690820, H = 655584, fe = 690949, ge = 690885, Ie = 690917, Ee = 690788, Se = 655649, ze = 655681, He = 690981, Pe = 691052, De = 691056, ve = 0;
  function Fe(C, l) {
    C = C | 0, l = l | 0;
    var w = 0, n = 0, a = 0;
    a = U - 128 | 0, U = a, C = t[C >> 2];
    e: {
      t: {
        r: {
          i: {
            if (w = t[l + 24 >> 2], !(w & 16)) {
              if (w & 32)
                break i;
              C = t[C >> 2], w = (C | 0) >= 0, C = be(w ? C : 0 - C | 0, w ? 0 : 0 - ((C >> 31) + ((C | 0) != 0) | 0) | 0, w, l);
              break r;
            }
            for (C = t[C >> 2], w = 0; n = C & 15, c[(w + a | 0) + 127 | 0] = n + (n >>> 0 < 10 ? 48 : 87), w = w - 1 | 0, n = C >>> 0 > 15, C = C >>> 4 | 0, !!n; )
              ;
            if (w + 128 >>> 0 >= 129)
              break t;
            C = Be(l, 1, 2, (w + a | 0) + 128 | 0, 0 - w | 0);
            break r;
          }
          for (C = t[C >> 2], w = 0; n = C & 15, c[(w + a | 0) + 127 | 0] = n + (n >>> 0 < 10 ? 48 : 55), w = w - 1 | 0, n = C >>> 0 > 15, C = C >>> 4 | 0, !!n; )
            ;
          if (w + 128 >>> 0 >= 129)
            break e;
          C = Be(l, 1, 2, (w + a | 0) + 128 | 0, 0 - w | 0);
        }
        return U = a + 128 | 0, C | 0;
      }
      wasm2js_trap();
    }
    wasm2js_trap();
  }
  function be(C, l, w, n) {
    var a = 0, b = 0, P = 0, K = 0, pe = 0, Ce = 0, Me = 0, Tt = 0, tr = 0, nr = 0, or = 0, lr = 0, gr = 0;
    if (Me = U - 48 | 0, U = Me, K = 39, !(!l & C >>> 0 < 1e4))
      for (; ; ) {
        nr = (Me + 9 | 0) + K | 0, or = nr - 4 | 0, b = C, Ce = 0, Tt = 0;
        e: {
          t: {
            if (!l) {
              C = (b >>> 0) / 1e4 | 0;
              break t;
            }
            if (P = 51 - D(l) | 0, a = 0 - P | 0, pe = P & 63, C = pe & 31, pe >>> 0 >= 32 ? pe = l >>> C | 0 : (Ce = l >>> C | 0, pe = ((1 << C) - 1 & l) << 32 - C | b >>> C), a = a & 63, C = a & 31, a >>> 0 >= 32 ? (a = b << C, C = 0) : (a = (1 << C) - 1 & b >>> 32 - C | l << C, C = b << C), P)
              for (; lr = Ce << 1 | pe >>> 31, tr = pe << 1 | a >>> 31, gr = 0 - (lr + (tr >>> 0 > 9999) | 0) >> 31, Ce = gr & 1e4, pe = tr - Ce | 0, Ce = lr - (Ce >>> 0 > tr >>> 0) | 0, a = a << 1 | C >>> 31, C = C << 1 | Tt, Tt = gr & 1, P = P - 1 | 0, !!P; )
                ;
            ve = a << 1 | C >>> 31, C = C << 1 | Tt;
            break e;
          }
          ve = 0;
        }
        if (pe = ve, a = ri(C, pe, 55536, 0) + b | 0, Ce = ((a & 65535) >>> 0) / 100 | 0, P = (Ce << 1) + 655718 | 0, P = d[P | 0] | d[P + 1 | 0] << 8, c[or | 0] = P, c[or + 1 | 0] = P >>> 8, P = nr - 2 | 0, a = ((B(Ce, -100) + a & 65535) << 1) + 655718 | 0, a = d[a | 0] | d[a + 1 | 0] << 8, c[P | 0] = a, c[P + 1 | 0] = a >>> 8, K = K - 4 | 0, b = !l & b >>> 0 > 99999999 | (l | 0) != 0, l = pe, !b)
          break;
      }
    C >>> 0 > 99 && (K = K - 2 | 0, l = K + (Me + 9 | 0) | 0, pe = C, C = ((C & 65535) >>> 0) / 100 | 0, b = ((pe + B(C, -100) & 65535) << 1) + 655718 | 0, b = d[b | 0] | d[b + 1 | 0] << 8, c[l | 0] = b, c[l + 1 | 0] = b >>> 8);
    e: {
      if (C >>> 0 >= 10) {
        K = K - 2 | 0, l = K + (Me + 9 | 0) | 0, C = (C << 1) + 655718 | 0, C = d[C | 0] | d[C + 1 | 0] << 8, c[l | 0] = C, c[l + 1 | 0] = C >>> 8;
        break e;
      }
      K = K - 1 | 0, c[K + (Me + 9 | 0) | 0] = C + 48;
    }
    return C = Be(n, w, 0, (Me + 9 | 0) + K | 0, 39 - K | 0), U = Me + 48 | 0, C;
  }
  function Be(C, l, w, n, a) {
    var b = 0, P = 0, K = 0, pe = 0, Ce = 0, Me = 0, Tt = 0, tr = 0;
    Ce = 655716;
    e: {
      if (l) {
        b = t[C + 24 >> 2], l = b & 1, Me = l ? 43 : 1114112, P = l + a | 0;
        break e;
      }
      b = t[C + 24 >> 2], Me = 45, P = a + 1 | 0;
    }
    e: {
      if (!(b & 4)) {
        Ce = 0;
        break e;
      }
      t: {
        if (!w || (K = w & 3, !K))
          break t;
        for (l = 655716; pe = pe + (c[l | 0] > -65) | 0, l = l + 1 | 0, K = K - 1 | 0, !!K; )
          ;
      }
      P = P + pe | 0;
    }
    e: {
      t: {
        if (!t[C + 8 >> 2]) {
          if (l = 1, P = t[C >> 2], C = t[C + 4 >> 2], cr(P, C, Me, Ce, w))
            break t;
          break e;
        }
        r: {
          i: {
            n: {
              s: {
                if (K = t[C + 12 >> 2], K >>> 0 > P >>> 0) {
                  if (b & 8)
                    break r;
                  switch (b = K - P | 0, P = b, l = d[C + 32 | 0], l = (l | 0) == 3 ? 1 : l, l - 1 | 0) {
                    case 1:
                      break n;
                    case 0:
                      break s;
                    default:
                      break i;
                  }
                }
                if (l = 1, P = t[C >> 2], C = t[C + 4 >> 2], cr(P, C, Me, Ce, w))
                  break t;
                break e;
              }
              P = 0, l = b;
              break i;
            }
            l = b >>> 1 | 0, P = b + 1 >>> 1 | 0;
          }
          l = l + 1 | 0, b = t[C + 4 >> 2], pe = t[C + 28 >> 2], K = t[C >> 2];
          i: {
            for (; ; ) {
              if (l = l - 1 | 0, !l)
                break i;
              if (yi[t[b + 16 >> 2]](K, pe) | 0)
                break;
            }
            return 1;
          }
          if (l = 1, (pe | 0) == 1114112 || cr(K, b, Me, Ce, w) || yi[t[b + 12 >> 2]](K, n, a) | 0)
            break t;
          l = 0;
          i: {
            for (; ; ) {
              if (C = P, (C | 0) == (l | 0))
                break i;
              if (l = l + 1 | 0, !!(yi[t[b + 16 >> 2]](K, pe) | 0))
                break;
            }
            C = l - 1 | 0;
          }
          l = C >>> 0 < P >>> 0;
          break t;
        }
        if (Tt = t[C + 28 >> 2], t[C + 28 >> 2] = 48, tr = d[C + 32 | 0], l = 1, c[C + 32 | 0] = 1, b = t[C >> 2], pe = t[C + 4 >> 2], cr(b, pe, Me, Ce, w))
          break t;
        l = (K - P | 0) + 1 | 0;
        r: {
          for (; ; ) {
            if (l = l - 1 | 0, !l)
              break r;
            if (yi[t[pe + 16 >> 2]](b, 48) | 0)
              break;
          }
          return 1;
        }
        if (l = 1, yi[t[pe + 12 >> 2]](b, n, a) | 0)
          break t;
        return c[C + 32 | 0] = tr, t[C + 28 >> 2] = Tt, 0;
      }
      return l;
    }
    return yi[t[C + 12 >> 2]](P, n, a) | 0;
  }
  function ke(C, l) {
    C = C | 0, l = l | 0;
    var w = 0, n = 0, a = 0;
    a = U - 128 | 0, U = a, C = t[C >> 2];
    e: {
      t: {
        r: {
          i: {
            if (w = t[l + 24 >> 2], !(w & 16)) {
              if (w & 32)
                break i;
              C = be(t[C >> 2], 0, 1, l);
              break r;
            }
            for (C = t[C >> 2], w = 0; n = C & 15, c[(w + a | 0) + 127 | 0] = n + (n >>> 0 < 10 ? 48 : 87), w = w - 1 | 0, n = C >>> 0 > 15, C = C >>> 4 | 0, !!n; )
              ;
            if (w + 128 >>> 0 >= 129)
              break t;
            C = Be(l, 1, 2, (w + a | 0) + 128 | 0, 0 - w | 0);
            break r;
          }
          for (C = t[C >> 2], w = 0; n = C & 15, c[(w + a | 0) + 127 | 0] = n + (n >>> 0 < 10 ? 48 : 55), w = w - 1 | 0, n = C >>> 0 > 15, C = C >>> 4 | 0, !!n; )
            ;
          if (w + 128 >>> 0 >= 129)
            break e;
          C = Be(l, 1, 2, (w + a | 0) + 128 | 0, 0 - w | 0);
        }
        return U = a + 128 | 0, C | 0;
      }
      wasm2js_trap();
    }
    wasm2js_trap();
  }
  function xe(C) {
  }
  function Ne(C) {
    var l = 0, w = 0, n = 0, a = 0, b = 0;
    n = U - 32 | 0, U = n, l = C + 16 | 0, a = t[l + 4 >> 2], w = n + 8 | 0, b = w + 16 | 0, t[b >> 2] = t[l >> 2], t[b + 4 >> 2] = a, l = C + 8 | 0, a = t[l + 4 >> 2], w = w + 8 | 0, t[w >> 2] = t[l >> 2], t[w + 4 >> 2] = a, l = t[C + 4 >> 2], t[n + 8 >> 2] = t[C >> 2], t[n + 12 >> 2] = l, wasm2js_trap();
  }
  function Et() {
    var C = 0, l = 0, w = 0, n = 0, a = 0, b = 0, P = 0, K = 0, pe = 0, Ce = 0, Me = 0, Tt = 0, tr = 0, nr = 0, or = 0, lr = 0, gr = 0, kr = 0, Nr = 0, jr = 0, Yr = 0, ei = 0, ai = 0, ui = 0, di = 0, Ii = 0, wi = 0, Ei = 0, Ti = 0, Di = 0, Qi = 0, Li = 0, Ki = 0, Wi = 0, Xi = 0, $i = 0, In = 0, kn = 0, Dn = 0, Mn = 0, zn = 0, es = 0, ns = 0, fs = 0, ps = 0, Es = 0, Ss = 0, Ps = 0, xs = 0, Bs = 0, vs = 0;
    Wi = U - 32 | 0, U = Wi;
    e: {
      if (d[690756]) {
        Ps = t[172762];
        break e;
      }
      for (t[Wi >> 2] = 192, t[Wi + 4 >> 2] = 192, C = U - 144 | 0, U = C, t[C + 104 >> 2] = 0, t[C + 108 >> 2] = 0, t[C + 32 >> 2] = 528734635, t[C + 36 >> 2] = 1541459225, t[C + 24 >> 2] = 1359893119, t[C + 28 >> 2] = -1694144372, t[C + 16 >> 2] = 1013904242, t[C + 20 >> 2] = -1521486534, t[C + 8 >> 2] = 1779033703, t[C + 12 >> 2] = -1150833019, l = C + 8 | 0, Wr(l, 689435, 63), fi(l, C + 112 | 0); a = d[(C + 112 | 0) + n | 0] - d[n + 690288 | 0] | 0, !!(!a && (l = (n | 0) != 31, n = n + 1 | 0, l)); )
        ;
      a && hr(689418, 0), t[163880] = 0, t[163881] = 0, t[163878] = 1, t[163879] = 0, l = t[172349], t[163892] = t[172348], t[163893] = l, l = t[172559], t[163890] = t[172558], t[163891] = l, l = t[172595], t[163858] = t[172594], t[163859] = l, l = t[172597], t[163860] = t[172596], t[163861] = l, l = t[172599], t[163862] = t[172598], t[163863] = l, l = t[172601], t[163864] = t[172600], t[163865] = l, l = t[172603], t[163866] = t[172602], t[163867] = l, t[163882] = 0, t[163883] = 0, t[163884] = 0, t[163885] = 0, t[163886] = 0, t[163887] = 0, t[163888] = 0, t[163876] = 629725529, t[163877] = 243653, t[163874] = 632307772, t[163875] = 3389866, t[163872] = 1459808328, t[163873] = 3272439, t[163870] = -1430362568, t[163871] = 3896727, t[163868] = 82779140, t[163869] = 3682156, t[163856] = 0, t[163857] = 0, t[163850] = 1, t[163851] = 0, t[163854] = 0, t[163855] = 0, t[163852] = 0, t[163853] = 0, t[163894] = 0, t[163848] = 1, U = C + 144 | 0, Ps = 655392, Bs = 690756, vs = v() | 0, t[Bs >> 2] = vs, Bs = 690760, vs = v() | 0, t[Bs >> 2] = vs, Bs = 690764, vs = v() | 0, t[Bs >> 2] = vs, Bs = 690768, vs = v() | 0, t[Bs >> 2] = vs, Bs = 690772, vs = v() | 0, t[Bs >> 2] = vs, Bs = 690776, vs = v() | 0, t[Bs >> 2] = vs, Bs = 690780, vs = v() | 0, t[Bs >> 2] = vs, Bs = 690784, vs = v() | 0, t[Bs >> 2] = vs, or = U - 720 | 0, U = or, t[163848] && (C = d[690760] | d[690761] << 8 | (d[690762] << 16 | d[690763] << 24), tr = or + 336 | 0, nr = tr + 32 | 0, t[nr >> 2] = d[690756] | d[690757] << 8 | (d[690758] << 16 | d[690759] << 24), t[nr + 4 >> 2] = C, C = d[690768] | d[690769] << 8 | (d[690770] << 16 | d[690771] << 24), Me = tr + 40 | 0, t[Me >> 2] = d[690764] | d[690765] << 8 | (d[690766] << 16 | d[690767] << 24), t[Me + 4 >> 2] = C, C = d[690776] | d[690777] << 8 | (d[690778] << 16 | d[690779] << 24), K = or + 384 | 0, t[K >> 2] = d[690772] | d[690773] << 8 | (d[690774] << 16 | d[690775] << 24), t[K + 4 >> 2] = C, C = d[690784] | d[690785] << 8 | (d[690786] << 16 | d[690787] << 24), pe = or + 392 | 0, t[pe >> 2] = d[690780] | d[690781] << 8 | (d[690782] << 16 | d[690783] << 24), t[pe + 4 >> 2] = C, a = t[163850], b = a << 8 & 16711680 | a << 24, w = a >>> 8 | 0, l = t[163851], n = (w | l << 24) & 65280, a = a >>> 24 | 0, b = b | (n | (a | l << 8) & 255), C = l, n = (w | (C & 255) << 24) & -16777216, n = n | (a | (C & 16777215) << 8) & 16711680, Ce = tr + 24 | 0, t[Ce >> 2] = C >>> 8 & 65280 | C >>> 24 | n, t[Ce + 4 >> 2] = b, a = t[163852], b = a << 8 & 16711680 | a << 24, l = t[163853], n = (l << 24 | a >>> 8) & 65280, b = b | (n | (l << 8 | a >>> 24) & 255), C = l, n = ((C & 255) << 24 | a >>> 8) & -16777216, n = n | ((C & 16777215) << 8 | a >>> 24) & 16711680, Tt = tr + 16 | 0, t[Tt >> 2] = C >>> 8 & 65280 | C >>> 24 | n, t[Tt + 4 >> 2] = b, a = t[163856], b = a << 8 & 16711680 | a << 24, l = t[163857], n = (l << 24 | a >>> 8) & 65280, b = b | (n | (l << 8 | a >>> 24) & 255), C = l, n = ((C & 255) << 24 | a >>> 8) & -16777216, n = n | ((C & 16777215) << 8 | a >>> 24) & 16711680, w = or, t[w + 336 >> 2] = C >>> 8 & 65280 | C >>> 24 | n, t[w + 340 >> 2] = b, a = t[163854], b = a << 8 & 16711680 | a << 24, l = t[163855], n = (l << 24 | a >>> 8) & 65280, b = b | (n | (l << 8 | a >>> 24) & 255), C = l, n = ((C & 255) << 24 | a >>> 8) & -16777216, n = n | ((C & 16777215) << 8 | a >>> 24) & 16711680, t[w + 344 >> 2] = C >>> 8 & 65280 | C >>> 24 | n, t[w + 348 >> 2] = b, Mn = w + 408 | 0, bi(Mn, tr, 64), t[pe >> 2] = 0, t[pe + 4 >> 2] = 0, t[K >> 2] = 0, t[K + 4 >> 2] = 0, t[Me >> 2] = 0, t[Me + 4 >> 2] = 0, t[nr >> 2] = 0, t[nr + 4 >> 2] = 0, t[Ce >> 2] = 0, t[Ce + 4 >> 2] = 0, t[Tt >> 2] = 0, t[Tt + 4 >> 2] = 0, t[w + 344 >> 2] = 0, t[w + 348 >> 2] = 0, t[w + 336 >> 2] = 0, t[w + 340 >> 2] = 0, Xi = w + 480 | 0, Ri(Mn, Xi), l = d[w + 497 | 0], C = l >>> 24 | 0, n = d[w + 498 | 0] | l << 8, l = C, Es = Xi + 16 | 0, a = d[Es | 0], C = a >>> 16 | 0, n = a << 16 | n, a = C | l, l = d[w + 495 | 0], C = l >>> 8 | 0, n = n | l << 24, Tt = d[w + 492 | 0], a = d[w + 494 | 0] | (C | a) | d[w + 493 | 0] << 8 | (Tt & 15) << 16, l = d[w + 484 | 0], C = l >>> 24 | 0, P = d[w + 485 | 0] | l << 8, l = C, b = d[w + 483 | 0], C = b >>> 16 | 0, P = b << 16 | P, b = C | l, l = d[w + 482 | 0], C = l >>> 8 | 0, tr = l << 24 | P, nr = d[w + 481 | 0] | (C | b) | d[w + 480 | 0] << 8, l = d[w + 491 | 0], C = l >>> 28 | 0, P = l << 4 | Tt >>> 4, l = C, b = d[w + 490 | 0], C = b >>> 20 | 0, P = b << 12 | P, b = C | l, l = d[w + 489 | 0], C = l >>> 12 | 0, P = l << 20 | P, b = C | b, l = d[w + 488 | 0], C = l >>> 4 | 0, Me = l << 28 | P, K = C | b | d[w + 487 | 0] << 4 | d[w + 486 | 0] << 12, Ss = Xi + 24 | 0, l = d[Ss | 0], C = l >>> 28 | 0, pe = d[w + 505 | 0], P = l << 4 | pe >>> 4, l = C, b = d[w + 503 | 0], C = b >>> 20 | 0, P = b << 12 | P, b = C | l, l = d[w + 502 | 0], C = l >>> 12 | 0, P = l << 20 | P, b = C | b, l = d[w + 501 | 0], C = l >>> 4 | 0, Ce = l << 28 | P, Yr = C | b | d[w + 500 | 0] << 4 | d[w + 499 | 0] << 12, Tt = Yr, l = d[w + 510 | 0], C = l >>> 24 | 0, P = d[w + 511 | 0] | l << 8, l = C, b = d[w + 509 | 0], C = b >>> 16 | 0, P = b << 16 | P, b = C | l, l = d[w + 508 | 0], C = l >>> 8 | 0, Di = w + 520 | 0, zn = Di + 32 | 0, l = P | l << 24, pe = d[w + 507 | 0] | (C | b) | d[w + 506 | 0] << 8 | (pe & 15) << 16, C = !(tr | (Me | (n | (l | Ce))) | (nr | (K | (a | (pe | Tt))))) | (n & Ce & Me) == -1 & (a & Tt & K) == 1048575 & ((tr | 0) == -1 & (nr | 0) == 65535) & ((pe | 0) == 1048574 & l >>> 0 > 4294966318 | pe >>> 0 > 1048574), b = C - 1 | 0, Tt = b & tr, t[zn >> 2] = Tt, P = nr, nr = 0 - !C | 0, P = P & nr, t[zn + 4 >> 2] = P, es = Di + 24 | 0, ui = b & Me, t[es >> 2] = ui, di = K & nr, t[es + 4 >> 2] = di, ns = Di + 16 | 0, Nr = n & b, t[ns >> 2] = Nr, lr = a & nr, t[ns + 4 >> 2] = lr, fs = Di + 8 | 0, ei = b & Ce, t[fs >> 2] = ei, gr = nr & Yr, t[fs + 4 >> 2] = gr, b = l & b | C, t[w + 520 >> 2] = b, C = pe & nr, Yr = C, t[w + 524 >> 2] = C, tr = w + 128 | 0, Qi = b << 1, Ii = C << 1 | b >>> 31, Pr(tr, Qi, Ii, 0, 0, ui, di, 0, 0), nr = w + 192 | 0, a = ei << 1, n = gr << 1 | ei >>> 31, Pr(nr, a, n, 0, 0, Nr, lr, 0, 0), K = w + 320 | 0, Pr(K, Tt, P, 0, 0, Tt, P, 0, 0), pe = w + 304 | 0, Pr(pe, t[w + 320 >> 2], t[w + 324 >> 2], 0, 0, 15632, 16, 0, 0), l = Tt, C = P << 1 | l >>> 31, $i = w + 80 | 0, ps = l << 1, wi = C, Pr($i, ps, C, 0, 0, b, Yr, 0, 0), In = w + 176 | 0, Pr(In, a, n, 0, 0, ui, di, 0, 0), kn = w + 240 | 0, Pr(kn, Nr, lr, 0, 0, Nr, lr, 0, 0), Me = w + 288 | 0, C = K + 8 | 0, Pr(Me, t[C >> 2], t[C + 4 >> 2], 0, 0, 64028672, 65536, 0, 0), Pr(w, b, Yr, 0, 0, b, Yr, 0, 0), xs = w + 160 | 0, Pr(xs, ps, wi, 0, 0, ei, gr, 0, 0), Li = w + 208 | 0, Pr(Li, Nr << 1, lr << 1 | Nr >>> 31, 0, 0, ui, di, 0, 0), K = t[w + 132 >> 2], C = K + t[w + 196 >> 2] | 0, b = t[w + 128 >> 2], a = t[w + 192 >> 2], l = b + a | 0, n = t[w + 304 >> 2], Yr = l + n | 0, a = l >>> 0 < a >>> 0 ? C + 1 | 0 : C, C = a + t[w + 308 >> 2] | 0, n = n >>> 0 > Yr >>> 0 ? C + 1 | 0 : C, Ce = (a | 0) == (n | 0) & l >>> 0 > Yr >>> 0 | n >>> 0 < a >>> 0, C = pe + 8 | 0, Tt = t[C >> 2], P = t[C + 4 >> 2], b = (a | 0) == (K | 0) & l >>> 0 < b >>> 0 | a >>> 0 < K >>> 0, a = nr + 8 | 0, l = t[a >> 2], C = tr + 8 | 0, pe = l + t[C >> 2] | 0, C = t[C + 4 >> 2] + t[a + 4 >> 2] | 0, C = l >>> 0 > pe >>> 0 ? C + 1 | 0 : C, l = b + pe | 0, C = (l >>> 0 < pe >>> 0 ? C + 1 | 0 : C) + P | 0, a = l, l = l + Tt | 0, C = a >>> 0 > l >>> 0 ? C + 1 | 0 : C, a = l, l = l + Ce | 0, C = a >>> 0 > l >>> 0 ? C + 1 | 0 : C, tr = n, Tt = l << 12 | n >>> 20, a = C, b = C << 12 | l >>> 20, Dn = t[w + 176 >> 2], l = t[w + 240 >> 2], Ce = Dn + l | 0, Ki = t[w + 180 >> 2], C = Ki + t[w + 244 >> 2] | 0, C = l >>> 0 > Ce >>> 0 ? C + 1 | 0 : C, l = t[w + 80 >> 2], P = l + Ce | 0, K = C, C = C + t[w + 84 >> 2] | 0, C = l >>> 0 > P >>> 0 ? C + 1 | 0 : C, l = t[w + 288 >> 2], n = l + P | 0, pe = C, C = C + t[w + 292 >> 2] | 0, l = l >>> 0 > n >>> 0 ? C + 1 | 0 : C, C = l + b | 0, Ei = w + 16 | 0, Tt = n + Tt | 0, b = Tt >>> 0 < n >>> 0 ? C + 1 | 0 : C, ai = (l | 0) == (b | 0) & n >>> 0 > Tt >>> 0 | l >>> 0 > b >>> 0, Ti = (l | 0) == (pe | 0) & P >>> 0 > n >>> 0 | l >>> 0 < pe >>> 0, C = Me + 8 | 0, kr = t[C >> 2], jr = t[C + 4 >> 2], nr = (K | 0) == (pe | 0) & P >>> 0 < Ce >>> 0 | K >>> 0 > pe >>> 0, C = $i + 8 | 0, Me = t[C >> 2], pe = t[C + 4 >> 2], P = (K | 0) == (Ki | 0) & Ce >>> 0 < Dn >>> 0 | K >>> 0 < Ki >>> 0, n = kn + 8 | 0, l = t[n >> 2], C = In + 8 | 0, Ce = l + t[C >> 2] | 0, C = t[C + 4 >> 2] + t[n + 4 >> 2] | 0, C = l >>> 0 > Ce >>> 0 ? C + 1 | 0 : C, l = P + Ce | 0, C = (l >>> 0 < Ce >>> 0 ? C + 1 | 0 : C) + pe | 0, n = l, l = l + Me | 0, C = n >>> 0 > l >>> 0 ? C + 1 | 0 : C, n = l, l = l + nr | 0, C = (n >>> 0 > l >>> 0 ? C + 1 | 0 : C) + jr | 0, n = l, l = l + kr | 0, C = n >>> 0 > l >>> 0 ? C + 1 | 0 : C, n = l + Ti | 0, C = n >>> 0 < l >>> 0 ? C + 1 | 0 : C, a = a >>> 20 | 0, l = n + a | 0, C = a >>> 0 > l >>> 0 ? C + 1 | 0 : C, a = l, l = l + ai | 0, C = a >>> 0 > l >>> 0 ? C + 1 | 0 : C, a = b, P = l << 12 | a >>> 20, n = C, Ce = C << 12 | l >>> 20, kr = t[w + 164 >> 2], C = kr + t[w + 212 >> 2] | 0, Me = t[w + 160 >> 2], l = t[w + 208 >> 2], b = Me + l | 0, pe = b, P = b + P | 0, l = l >>> 0 > b >>> 0 ? C + 1 | 0 : C, C = l + Ce | 0, K = P << 4 & -16, b = P >>> 0 < b >>> 0 ? C + 1 | 0 : C, Ce = (b << 4 | P >>> 28) & 16777215, nr = a, Pr(Ei, K | a >>> 16 & 15, Ce, 0, 0, 977, 1, 0, 0), ai = t[w + 20 >> 2], C = ai + t[w + 4 >> 2] | 0, Ti = t[w + 16 >> 2], a = t[w >> 2], Ce = Ti + a | 0, t[w + 560 >> 2] = Ce, a = a >>> 0 > Ce >>> 0 ? C + 1 | 0 : C, t[w + 564 >> 2] = a & 1048575, $i = w + 112 | 0, Pr($i, Qi, Ii, 0, 0, ei, gr, 0, 0), In = w + 224 | 0, Pr(In, ps, wi, 0, 0, Nr, lr, 0, 0), kn = w + 272 | 0, Pr(kn, ui, di, 0, 0, ui, di, 0, 0), Dn = w - -64 | 0, jr = Dn, K = (l | 0) == (b | 0) & P >>> 0 < pe >>> 0 | l >>> 0 > b >>> 0, pe = (l | 0) == (kr | 0) & pe >>> 0 < Me >>> 0 | l >>> 0 < kr >>> 0, P = Li + 8 | 0, l = t[P >> 2], C = xs + 8 | 0, Me = l + t[C >> 2] | 0, C = t[C + 4 >> 2] + t[P + 4 >> 2] | 0, C = l >>> 0 > Me >>> 0 ? C + 1 | 0 : C, P = pe + Me | 0, C = P >>> 0 < Me >>> 0 ? C + 1 | 0 : C, n = n >>> 20 | 0, l = P + n | 0, C = n >>> 0 > l >>> 0 ? C + 1 | 0 : C, n = l, l = l + K | 0, C = n >>> 0 > l >>> 0 ? C + 1 | 0 : C, pe = l << 12 | b >>> 20, P = C, b = C << 12 | l >>> 20, Ki = t[w + 224 >> 2], l = t[w + 272 >> 2], kr = Ki + l | 0, Li = t[w + 228 >> 2], C = Li + t[w + 276 >> 2] | 0, n = l >>> 0 > kr >>> 0 ? C + 1 | 0 : C, C = n + b | 0, Me = pe + kr | 0, C = Me >>> 0 < kr >>> 0 ? C + 1 | 0 : C, pe = C, Pr(jr, Me, C & 1048575, 0, 0, 15632, 16, 0, 0), Ce = (a | 0) == (ai | 0) & Ce >>> 0 < Ti >>> 0 | a >>> 0 < ai >>> 0, b = w + 8 | 0, l = t[b >> 2], C = Ei + 8 | 0, K = l + t[C >> 2] | 0, C = t[C + 4 >> 2] + t[b + 4 >> 2] | 0, C = l >>> 0 > K >>> 0 ? C + 1 | 0 : C, l = K + Ce | 0, C = l >>> 0 < K >>> 0 ? C + 1 | 0 : C, K = l << 12 | a >>> 20, b = C, Ce = C << 12 | l >>> 20, ai = t[w + 64 >> 2], l = t[w + 112 >> 2], jr = ai + l | 0, Ei = t[w + 68 >> 2], C = Ei + t[w + 116 >> 2] | 0, a = l >>> 0 > jr >>> 0 ? C + 1 | 0 : C, C = a + Ce | 0, K = K + jr | 0, C = K >>> 0 < jr >>> 0 ? C + 1 | 0 : C, t[w + 568 >> 2] = K, Ce = C, t[w + 572 >> 2] = C & 1048575, Ti = w + 96 | 0, Pr(Ti, Qi, Ii, 0, 0, Nr, lr, 0, 0), Qi = w + 144 | 0, Pr(Qi, ei, gr, 0, 0, ei, gr, 0, 0), ei = w + 256 | 0, Pr(ei, ps, wi, 0, 0, ui, di, 0, 0), Nr = w + 48 | 0, lr = (n | 0) == (pe | 0) & Me >>> 0 < kr >>> 0 | n >>> 0 > pe >>> 0, Me = (n | 0) == (Li | 0) & kr >>> 0 < Ki >>> 0 | n >>> 0 < Li >>> 0, n = kn + 8 | 0, l = t[n >> 2], C = In + 8 | 0, gr = l + t[C >> 2] | 0, C = t[C + 4 >> 2] + t[n + 4 >> 2] | 0, C = l >>> 0 > gr >>> 0 ? C + 1 | 0 : C, n = Me + gr | 0, C = n >>> 0 < gr >>> 0 ? C + 1 | 0 : C, P = P >>> 20 | 0, l = P + n | 0, C = P >>> 0 > l >>> 0 ? C + 1 | 0 : C, n = l, l = l + lr | 0, C = n >>> 0 > l >>> 0 ? C + 1 | 0 : C, gr = l << 12 | pe >>> 20, P = t[w + 256 >> 2], pe = gr + P | 0, n = C, Ii = C << 12 | l >>> 20, C = Ii + t[w + 260 >> 2] | 0, Me = P >>> 0 > pe >>> 0 ? C + 1 | 0 : C, Pr(Nr, pe, Me, 0, 0, 15632, 16, 0, 0), P = w, K = (a | 0) == (Ce | 0) & K >>> 0 < jr >>> 0 | a >>> 0 > Ce >>> 0, w = (a | 0) == (Ei | 0) & jr >>> 0 < ai >>> 0 | a >>> 0 < Ei >>> 0, a = $i + 8 | 0, l = t[a >> 2], C = Dn + 8 | 0, lr = l + t[C >> 2] | 0, C = t[C + 4 >> 2] + t[a + 4 >> 2] | 0, C = l >>> 0 > lr >>> 0 ? C + 1 | 0 : C, a = w + lr | 0, C = a >>> 0 < lr >>> 0 ? C + 1 | 0 : C, b = b >>> 20 | 0, l = b + a | 0, C = b >>> 0 > l >>> 0 ? C + 1 | 0 : C, a = l, l = l + K | 0, C = a >>> 0 > l >>> 0 ? C + 1 | 0 : C, w = l << 12 | Ce >>> 20, a = C, b = C << 12 | l >>> 20, kr = t[P + 96 >> 2], l = t[P + 144 >> 2], K = kr + l | 0, wi = t[P + 100 >> 2], C = wi + t[P + 148 >> 2] | 0, C = l >>> 0 > K >>> 0 ? C + 1 | 0 : C, l = t[P + 48 >> 2], Ce = l + K | 0, lr = C, C = C + t[P + 52 >> 2] | 0, l = l >>> 0 > Ce >>> 0 ? C + 1 | 0 : C, C = l + b | 0, w = w + Ce | 0, C = w >>> 0 < Ce >>> 0 ? C + 1 | 0 : C, t[P + 576 >> 2] = w, b = C, t[P + 580 >> 2] = C & 1048575, jr = P + 32 | 0, gr = (Me | 0) == (Ii | 0) & pe >>> 0 < gr >>> 0 | Me >>> 0 < Ii >>> 0, C = ei + 8 | 0, Me = t[C >> 2], C = t[C + 4 >> 2], n = n >>> 20 | 0, pe = n, n = n + Me | 0, C = pe >>> 0 > n >>> 0 ? C + 1 | 0 : C, pe = n, n = n + gr | 0, C = pe >>> 0 > n >>> 0 ? C + 1 | 0 : C, Pr(jr, n, C, 0, 0, 64028672, 65536, 0, 0), n = P, gr = (l | 0) == (b | 0) & w >>> 0 < Ce >>> 0 | l >>> 0 > b >>> 0, Me = (l | 0) == (lr | 0) & K >>> 0 > Ce >>> 0 | l >>> 0 < lr >>> 0, C = Nr + 8 | 0, pe = t[C >> 2], Ce = t[C + 4 >> 2], w = (lr | 0) == (wi | 0) & K >>> 0 < kr >>> 0 | lr >>> 0 < wi >>> 0, P = Qi + 8 | 0, l = t[P >> 2], C = Ti + 8 | 0, K = l + t[C >> 2] | 0, C = t[C + 4 >> 2] + t[P + 4 >> 2] | 0, C = l >>> 0 > K >>> 0 ? C + 1 | 0 : C, l = w + K | 0, C = (l >>> 0 < K >>> 0 ? C + 1 | 0 : C) + Ce | 0, P = l, l = l + pe | 0, C = P >>> 0 > l >>> 0 ? C + 1 | 0 : C, P = l + Me | 0, C = P >>> 0 < l >>> 0 ? C + 1 | 0 : C, a = a >>> 20 | 0, l = P + a | 0, C = a >>> 0 > l >>> 0 ? C + 1 | 0 : C, a = l, l = l + gr | 0, C = a >>> 0 > l >>> 0 ? C + 1 | 0 : C, Ce = l << 12 | b >>> 20, a = C, b = C << 12 | l >>> 20, K = t[n + 32 >> 2], l = Yr & -2, P = K + l | 0, Me = t[n + 36 >> 2], C = Me + (tr & 1048575) | 0, w = l >>> 0 > P >>> 0 ? C + 1 | 0 : C, C = w + b | 0, b = P + Ce | 0, C = b >>> 0 < P >>> 0 ? C + 1 | 0 : C, t[n + 584 >> 2] = b, l = C, t[n + 588 >> 2] = C & 1048575, pe = nr & 65535, Ce = (C | 0) == (w | 0) & P >>> 0 > b >>> 0 | C >>> 0 < w >>> 0, n = (w | 0) == (Me | 0) & P >>> 0 < K >>> 0 | w >>> 0 < Me >>> 0, C = jr + 8 | 0, b = n + t[C >> 2] | 0, C = t[C + 4 >> 2], C = n >>> 0 > b >>> 0 ? C + 1 | 0 : C, a = a >>> 20 | 0, n = a, a = b + a | 0, C = n >>> 0 > a >>> 0 ? C + 1 | 0 : C, n = a, a = a + Ce | 0, C = n >>> 0 > a >>> 0 ? C + 1 | 0 : C, l = a << 12 | l >>> 20, n = l + Tt | 0, C = pe + (C << 12 | a >>> 20) | 0, t[or + 592 >> 2] = n, t[or + 596 >> 2] = l >>> 0 > n >>> 0 ? C + 1 | 0 : C, Nr = or + 560 | 0, zr(655432, 655432, Nr), zr(655472, 655472, Nr), zr(655472, 655472, Di), zr(655512, 655512, Di), t[fs >> 2] = 0, t[fs + 4 >> 2] = 0, t[ns >> 2] = 0, t[ns + 4 >> 2] = 0, t[es >> 2] = 0, t[es + 4 >> 2] = 0, t[zn >> 2] = 0, t[zn + 4 >> 2] = 0, t[or + 520 >> 2] = 0, t[or + 524 >> 2] = 0, Ri(Mn, Xi), kr = or + 688 | 0, Ir(kr, Xi, 0), l = kr + 24 | 0, K = t[l >> 2], a = kr + 16 | 0, Me = t[a >> 2], n = kr + 8 | 0, tr = t[n >> 2], nr = t[or + 688 >> 2], pe = K | (Me | (tr | nr)), P = t[l + 4 >> 2], Tt = t[a + 4 >> 2], Ce = t[n + 4 >> 2], w = t[or + 692 >> 2], b = P | (Tt | (Ce | w)), C = pe | b ? -1 : 0, jr = C & K, t[l >> 2] = jr, gr = C & P, t[l + 4 >> 2] = gr, lr = C & Me, t[a >> 2] = lr, Yr = C & Tt, t[a + 4 >> 2] = Yr, tr = C & tr, t[n >> 2] = tr, Me = C & Ce, t[n + 4 >> 2] = Me, b = !(b | pe) | C & nr, t[or + 688 >> 2] = b, P = C & w, t[or + 692 >> 2] = P, is(Mn, 68), t[Ss >> 2] = 0, t[Ss + 4 >> 2] = 0, t[Es >> 2] = 0, t[Es + 4 >> 2] = 0, t[or + 488 >> 2] = 0, t[or + 492 >> 2] = 0, t[or + 480 >> 2] = 0, t[or + 484 >> 2] = 0, zi(655392, Nr, kr), C = tr | lr | jr | b | (Me | Yr | gr | P) ? -1 : 0, K = b ^ -1, w = K - 801750718 | 0, b = C, Tt = P ^ -1, P = Tt - ((K >>> 0 < 801750718) + 1076732275 | 0) | 0, C = C & P, pe = C, Ce = w & b, t[163850] = Ce, t[163851] = C, Me = Me ^ -1, C = Me, nr = tr ^ -1, tr = nr + ((P | 0) == (Tt | 0) & w >>> 0 < K >>> 0 | P >>> 0 < Tt >>> 0) | 0, w = tr - 1354194885 | 0, Tt = w & b, t[n >> 2] = Tt, C = tr >>> 0 < nr >>> 0 ? C + 1 | 0 : C, K = C - ((tr >>> 0 < 1354194885) + 1162945305 | 0) | 0, P = K & b, t[n + 4 >> 2] = P, t[163852] = Tt, t[163853] = P, P = (C | 0) == (K | 0) & w >>> 0 < tr >>> 0 | C >>> 0 > K >>> 0, Tt = P + ((C | 0) == (Me | 0) & tr >>> 0 < nr >>> 0 | C >>> 0 < Me >>> 0) | 0, nr = lr ^ -1, tr = nr + Tt | 0, Me = Yr ^ -1, C = Me + (P >>> 0 > Tt >>> 0) | 0, w = tr - 2 | 0, Tt = w & b, t[a >> 2] = Tt, C = tr >>> 0 < nr >>> 0 ? C + 1 | 0 : C, K = C - (tr >>> 0 < 2) | 0, P = K & b, t[a + 4 >> 2] = P, t[163854] = Tt, t[163855] = P, P = (C | 0) == (K | 0) & w >>> 0 < tr >>> 0 | C >>> 0 > K >>> 0, w = P + ((C | 0) == (Me | 0) & tr >>> 0 < nr >>> 0 | C >>> 0 < Me >>> 0) | 0, C = w >>> 0 < P >>> 0, Tt = w - jr | 0, P = Tt - 2 & b, t[l >> 2] = P, C = (C - ((w >>> 0 < jr >>> 0) + gr | 0) | 0) - (Tt >>> 0 < 2) & b, t[l + 4 >> 2] = C, t[163856] = P, t[163857] = C, t[or + 688 >> 2] = Ce, t[or + 692 >> 2] = pe, as(655432, Nr, 128), t[l >> 2] = 0, t[l + 4 >> 2] = 0, t[a >> 2] = 0, t[a + 4 >> 2] = 0, t[n >> 2] = 0, t[n + 4 >> 2] = 0, t[or + 688 >> 2] = 0, t[or + 692 >> 2] = 0, is(Nr, 124)), U = or + 720 | 0, c[690757] = 0, c[690758] = 0, c[690759] = 0, c[690760] = 0, c[690761] = 0, c[690762] = 0, c[690763] = 0, c[690764] = 0, c[690756] = 1, c[690765] = 0, c[690766] = 0, c[690767] = 0, c[690768] = 0, c[690769] = 0, c[690770] = 0, c[690771] = 0, c[690772] = 0, c[690773] = 0, c[690774] = 0, c[690775] = 0, c[690776] = 0, c[690777] = 0, c[690778] = 0, c[690779] = 0, c[690780] = 0, c[690780] = 0, c[690781] = 0, c[690782] = 0, c[690783] = 0, c[690784] = 0, c[690785] = 0, c[690786] = 0, c[690787] = 0, t[Wi + 4 >> 2] = 1, t[172762] = 655392;
    }
    return U = Wi + 32 | 0, Ps;
  }
  function st() {
    Et();
  }
  function Dt(C) {
    C = C | 0;
    var l = 0, w = 0;
    l = U + -64 | 0, U = l;
    e: {
      if ((C | 0) != 32) {
        w = l + 56 | 0, t[w >> 2] = 0, t[w + 4 >> 2] = 0, w = l + 48 | 0, t[w >> 2] = 0, t[w + 4 >> 2] = 0, w = l + 40 | 0, t[w >> 2] = 0, t[w + 4 >> 2] = 0, w = l + 32 | 0, t[w >> 2] = 0, t[w + 4 >> 2] = 0, w = l + 24 | 0, t[w >> 2] = 0, t[w + 4 >> 2] = 0, w = l + 16 | 0, t[w >> 2] = 0, t[w + 4 >> 2] = 0, w = l + 8 | 0, t[w >> 2] = 0, t[w + 4 >> 2] = 0, t[l >> 2] = 0, t[l + 4 >> 2] = 0, C = Bi(t[172688], l, 690820, C);
        break e;
      }
      C = l + 56 | 0, t[C >> 2] = 0, t[C + 4 >> 2] = 0, C = l + 48 | 0, t[C >> 2] = 0, t[C + 4 >> 2] = 0, C = l + 40 | 0, t[C >> 2] = 0, t[C + 4 >> 2] = 0, C = l + 32 | 0, t[C >> 2] = 0, t[C + 4 >> 2] = 0, C = l + 24 | 0, t[C >> 2] = 0, t[C + 4 >> 2] = 0, C = l + 16 | 0, t[C >> 2] = 0, t[C + 4 >> 2] = 0, C = l + 8 | 0, t[C >> 2] = 0, t[C + 4 >> 2] = 0, t[l >> 2] = 0, t[l + 4 >> 2] = 0, C = Fs(t[172688], l, 690820);
    }
    return U = l - -64 | 0, (C | 0) == 1 | 0;
  }
  function er(C, l, w) {
    C = C | 0, l = l | 0, w = w | 0;
    var n = 0, a = 0, b = 0, P = 0, K = 0, pe = 0, Ce = 0, Me = 0, Tt = 0, tr = 0, nr = 0, or = 0, lr = 0, gr = 0, kr = 0, Nr = 0, jr = 0, Yr = 0, ei = 0, ai = 0, ui = 0, di = 0, Ii = 0, wi = 0, Ei = 0;
    b = U - 272 | 0, U = b, n = b + 200 | 0, wi = n + 56 | 0, t[wi >> 2] = 0, t[wi + 4 >> 2] = 0, Ce = n + 48 | 0, t[Ce >> 2] = 0, t[Ce + 4 >> 2] = 0, gr = n + 40 | 0, t[gr >> 2] = 0, t[gr + 4 >> 2] = 0, Nr = n + 32 | 0, t[Nr >> 2] = 0, t[Nr + 4 >> 2] = 0, kr = n + 24 | 0, t[kr >> 2] = 0, t[kr + 4 >> 2] = 0, jr = n + 16 | 0, t[jr >> 2] = 0, t[jr + 4 >> 2] = 0, Ii = n + 8 | 0, t[Ii >> 2] = 0, t[Ii + 4 >> 2] = 0, t[b + 200 >> 2] = 0, t[b + 204 >> 2] = 0;
    e: {
      t: {
        if ((Bi(t[172688], n, 690820, C) | 0) == 1) {
          if (Yr = b + 200 | 0, or = Yr + 15 | 0, n = or, C = d[n + 4 | 0] | d[n + 5 | 0] << 8 | (d[n + 6 | 0] << 16 | d[n + 7 | 0] << 24), Me = b - -64 | 0, ai = Me + 8 | 0, t[ai >> 2] = d[n | 0] | d[n + 1 | 0] << 8 | (d[n + 2 | 0] << 16 | d[n + 3 | 0] << 24), t[ai + 4 >> 2] = C, nr = Yr + 23 | 0, n = nr, C = d[n + 4 | 0] | d[n + 5 | 0] << 8 | (d[n + 6 | 0] << 16 | d[n + 7 | 0] << 24), ui = Me + 16 | 0, t[ui >> 2] = d[n | 0] | d[n + 1 | 0] << 8 | (d[n + 2 | 0] << 16 | d[n + 3 | 0] << 24), t[ui + 4 >> 2] = C, Tt = Yr + 31 | 0, n = Tt, C = d[n + 4 | 0] | d[n + 5 | 0] << 8 | (d[n + 6 | 0] << 16 | d[n + 7 | 0] << 24), di = Me + 24 | 0, t[di >> 2] = d[n | 0] | d[n + 1 | 0] << 8 | (d[n + 2 | 0] << 16 | d[n + 3 | 0] << 24), t[di + 4 >> 2] = C, tr = Yr + 39 | 0, n = tr, C = d[n + 4 | 0] | d[n + 5 | 0] << 8 | (d[n + 6 | 0] << 16 | d[n + 7 | 0] << 24), Ei = Me + 32 | 0, t[Ei >> 2] = d[n | 0] | d[n + 1 | 0] << 8 | (d[n + 2 | 0] << 16 | d[n + 3 | 0] << 24), t[Ei + 4 >> 2] = C, P = Yr + 47 | 0, n = P, C = d[n + 4 | 0] | d[n + 5 | 0] << 8 | (d[n + 6 | 0] << 16 | d[n + 7 | 0] << 24), a = Me + 40 | 0, t[a >> 2] = d[n | 0] | d[n + 1 | 0] << 8 | (d[n + 2 | 0] << 16 | d[n + 3 | 0] << 24), t[a + 4 >> 2] = C, n = Yr + 55 | 0, C = d[n + 4 | 0] | d[n + 5 | 0] << 8 | (d[n + 6 | 0] << 16 | d[n + 7 | 0] << 24), K = Me + 48 | 0, t[K >> 2] = d[n | 0] | d[n + 1 | 0] << 8 | (d[n + 2 | 0] << 16 | d[n + 3 | 0] << 24), t[K + 4 >> 2] = C, pe = Me + 56 | 0, Me = Yr + 63 | 0, c[pe | 0] = d[Me | 0], c[b + 2 | 0] = d[b + 202 | 0], y[b >> 1] = E[b + 200 >> 1], C = d[b + 211 | 0] | d[b + 212 | 0] << 8 | (d[b + 213 | 0] << 16 | d[b + 214 | 0] << 24), t[b + 64 >> 2] = d[b + 207 | 0] | d[b + 208 | 0] << 8 | (d[b + 209 | 0] << 16 | d[b + 210 | 0] << 24), t[b + 68 >> 2] = C, C = d[b + 203 | 0] | d[b + 204 | 0] << 8 | (d[b + 205 | 0] << 16 | d[b + 206 | 0] << 24), c[b + 63 | 0] = d[pe | 0], lr = t[K + 4 >> 2], ei = b + 55 | 0, pe = t[K >> 2], c[ei | 0] = pe, c[ei + 1 | 0] = pe >>> 8, c[ei + 2 | 0] = pe >>> 16, c[ei + 3 | 0] = pe >>> 24, c[ei + 4 | 0] = lr, c[ei + 5 | 0] = lr >>> 8, c[ei + 6 | 0] = lr >>> 16, c[ei + 7 | 0] = lr >>> 24, K = t[a + 4 >> 2], lr = b + 47 | 0, pe = t[a >> 2], c[lr | 0] = pe, c[lr + 1 | 0] = pe >>> 8, c[lr + 2 | 0] = pe >>> 16, c[lr + 3 | 0] = pe >>> 24, c[lr + 4 | 0] = K, c[lr + 5 | 0] = K >>> 8, c[lr + 6 | 0] = K >>> 16, c[lr + 7 | 0] = K >>> 24, K = t[Ei + 4 >> 2], a = b + 39 | 0, pe = t[Ei >> 2], c[a | 0] = pe, c[a + 1 | 0] = pe >>> 8, c[a + 2 | 0] = pe >>> 16, c[a + 3 | 0] = pe >>> 24, c[a + 4 | 0] = K, c[a + 5 | 0] = K >>> 8, c[a + 6 | 0] = K >>> 16, c[a + 7 | 0] = K >>> 24, K = t[di + 4 >> 2], a = b + 31 | 0, pe = t[di >> 2], c[a | 0] = pe, c[a + 1 | 0] = pe >>> 8, c[a + 2 | 0] = pe >>> 16, c[a + 3 | 0] = pe >>> 24, c[a + 4 | 0] = K, c[a + 5 | 0] = K >>> 8, c[a + 6 | 0] = K >>> 16, c[a + 7 | 0] = K >>> 24, K = t[ui + 4 >> 2], a = b + 23 | 0, pe = t[ui >> 2], c[a | 0] = pe, c[a + 1 | 0] = pe >>> 8, c[a + 2 | 0] = pe >>> 16, c[a + 3 | 0] = pe >>> 24, c[a + 4 | 0] = K, c[a + 5 | 0] = K >>> 8, c[a + 6 | 0] = K >>> 16, c[a + 7 | 0] = K >>> 24, K = t[ai + 4 >> 2], a = b + 15 | 0, pe = t[ai >> 2], c[a | 0] = pe, c[a + 1 | 0] = pe >>> 8, c[a + 2 | 0] = pe >>> 16, c[a + 3 | 0] = pe >>> 24, c[a + 4 | 0] = K, c[a + 5 | 0] = K >>> 8, c[a + 6 | 0] = K >>> 16, c[a + 7 | 0] = K >>> 24, c[b + 3 | 0] = C, c[b + 4 | 0] = C >>> 8, c[b + 5 | 0] = C >>> 16, c[b + 6 | 0] = C >>> 24, pe = t[b + 68 >> 2], C = t[b + 64 >> 2], c[b + 7 | 0] = C, c[b + 8 | 0] = C >>> 8, c[b + 9 | 0] = C >>> 16, c[b + 10 | 0] = C >>> 24, c[b + 11 | 0] = pe, c[b + 12 | 0] = pe >>> 8, c[b + 13 | 0] = pe >>> 16, c[b + 14 | 0] = pe >>> 24, t[wi >> 2] = 0, t[wi + 4 >> 2] = 0, t[Ce >> 2] = 0, t[Ce + 4 >> 2] = 0, t[gr >> 2] = 0, t[gr + 4 >> 2] = 0, t[Nr >> 2] = 0, t[Nr + 4 >> 2] = 0, t[kr >> 2] = 0, t[kr + 4 >> 2] = 0, t[jr >> 2] = 0, t[jr + 4 >> 2] = 0, t[Ii >> 2] = 0, t[Ii + 4 >> 2] = 0, t[b + 200 >> 2] = 0, t[b + 204 >> 2] = 0, lr = 0, (Bi(t[172688], Yr, 655584, l) | 0) == 1) {
            C = d[or + 4 | 0] | d[or + 5 | 0] << 8 | (d[or + 6 | 0] << 16 | d[or + 7 | 0] << 24), l = b + 128 | 0, pe = l + 8 | 0, t[pe >> 2] = d[or | 0] | d[or + 1 | 0] << 8 | (d[or + 2 | 0] << 16 | d[or + 3 | 0] << 24), t[pe + 4 >> 2] = C, C = d[nr + 4 | 0] | d[nr + 5 | 0] << 8 | (d[nr + 6 | 0] << 16 | d[nr + 7 | 0] << 24), or = l + 16 | 0, t[or >> 2] = d[nr | 0] | d[nr + 1 | 0] << 8 | (d[nr + 2 | 0] << 16 | d[nr + 3 | 0] << 24), t[or + 4 >> 2] = C, C = d[Tt + 4 | 0] | d[Tt + 5 | 0] << 8 | (d[Tt + 6 | 0] << 16 | d[Tt + 7 | 0] << 24), nr = l + 24 | 0, t[nr >> 2] = d[Tt | 0] | d[Tt + 1 | 0] << 8 | (d[Tt + 2 | 0] << 16 | d[Tt + 3 | 0] << 24), t[nr + 4 >> 2] = C, C = d[tr + 4 | 0] | d[tr + 5 | 0] << 8 | (d[tr + 6 | 0] << 16 | d[tr + 7 | 0] << 24), Tt = l + 32 | 0, t[Tt >> 2] = d[tr | 0] | d[tr + 1 | 0] << 8 | (d[tr + 2 | 0] << 16 | d[tr + 3 | 0] << 24), t[Tt + 4 >> 2] = C, C = d[P + 4 | 0] | d[P + 5 | 0] << 8 | (d[P + 6 | 0] << 16 | d[P + 7 | 0] << 24), tr = l + 40 | 0, t[tr >> 2] = d[P | 0] | d[P + 1 | 0] << 8 | (d[P + 2 | 0] << 16 | d[P + 3 | 0] << 24), t[tr + 4 >> 2] = C, C = d[n + 4 | 0] | d[n + 5 | 0] << 8 | (d[n + 6 | 0] << 16 | d[n + 7 | 0] << 24), P = l + 48 | 0, t[P >> 2] = d[n | 0] | d[n + 1 | 0] << 8 | (d[n + 2 | 0] << 16 | d[n + 3 | 0] << 24), t[P + 4 >> 2] = C, l = l + 56 | 0, c[l | 0] = d[Me | 0], c[b + 66 | 0] = d[b + 202 | 0], y[b + 64 >> 1] = E[b + 200 >> 1], C = d[b + 211 | 0] | d[b + 212 | 0] << 8 | (d[b + 213 | 0] << 16 | d[b + 214 | 0] << 24), t[b + 128 >> 2] = d[b + 207 | 0] | d[b + 208 | 0] << 8 | (d[b + 209 | 0] << 16 | d[b + 210 | 0] << 24), t[b + 132 >> 2] = C, C = d[b + 203 | 0] | d[b + 204 | 0] << 8 | (d[b + 205 | 0] << 16 | d[b + 206 | 0] << 24), K = b - -64 | 0, c[K + 63 | 0] = d[l | 0], n = t[P + 4 >> 2], Me = K + 55 | 0, l = t[P >> 2], c[Me | 0] = l, c[Me + 1 | 0] = l >>> 8, c[Me + 2 | 0] = l >>> 16, c[Me + 3 | 0] = l >>> 24, c[Me + 4 | 0] = n, c[Me + 5 | 0] = n >>> 8, c[Me + 6 | 0] = n >>> 16, c[Me + 7 | 0] = n >>> 24, n = t[tr + 4 >> 2], P = K + 47 | 0, l = t[tr >> 2], c[P | 0] = l, c[P + 1 | 0] = l >>> 8, c[P + 2 | 0] = l >>> 16, c[P + 3 | 0] = l >>> 24, c[P + 4 | 0] = n, c[P + 5 | 0] = n >>> 8, c[P + 6 | 0] = n >>> 16, c[P + 7 | 0] = n >>> 24, n = t[Tt + 4 >> 2], P = K + 39 | 0, l = t[Tt >> 2], c[P | 0] = l, c[P + 1 | 0] = l >>> 8, c[P + 2 | 0] = l >>> 16, c[P + 3 | 0] = l >>> 24, c[P + 4 | 0] = n, c[P + 5 | 0] = n >>> 8, c[P + 6 | 0] = n >>> 16, c[P + 7 | 0] = n >>> 24, n = t[nr + 4 >> 2], P = K + 31 | 0, l = t[nr >> 2], c[P | 0] = l, c[P + 1 | 0] = l >>> 8, c[P + 2 | 0] = l >>> 16, c[P + 3 | 0] = l >>> 24, c[P + 4 | 0] = n, c[P + 5 | 0] = n >>> 8, c[P + 6 | 0] = n >>> 16, c[P + 7 | 0] = n >>> 24, n = t[or + 4 >> 2], P = K + 23 | 0, l = t[or >> 2], c[P | 0] = l, c[P + 1 | 0] = l >>> 8, c[P + 2 | 0] = l >>> 16, c[P + 3 | 0] = l >>> 24, c[P + 4 | 0] = n, c[P + 5 | 0] = n >>> 8, c[P + 6 | 0] = n >>> 16, c[P + 7 | 0] = n >>> 24, n = t[pe + 4 >> 2], P = K + 15 | 0, l = t[pe >> 2], c[P | 0] = l, c[P + 1 | 0] = l >>> 8, c[P + 2 | 0] = l >>> 16, c[P + 3 | 0] = l >>> 24, c[P + 4 | 0] = n, c[P + 5 | 0] = n >>> 8, c[P + 6 | 0] = n >>> 16, c[P + 7 | 0] = n >>> 24, c[b + 67 | 0] = C, c[b + 68 | 0] = C >>> 8, c[b + 69 | 0] = C >>> 16, c[b + 70 | 0] = C >>> 24, l = t[b + 132 >> 2], C = t[b + 128 >> 2], c[b + 71 | 0] = C, c[b + 72 | 0] = C >>> 8, c[b + 73 | 0] = C >>> 16, c[b + 74 | 0] = C >>> 24, c[b + 75 | 0] = l, c[b + 76 | 0] = l >>> 8, c[b + 77 | 0] = l >>> 16, c[b + 78 | 0] = l >>> 24, Ce = b + 200 | 0, C = Ce + 56 | 0, t[C >> 2] = 0, t[C + 4 >> 2] = 0, C = Ce + 48 | 0, t[C >> 2] = 0, t[C + 4 >> 2] = 0, C = Ce + 40 | 0, t[C >> 2] = 0, t[C + 4 >> 2] = 0, C = Ce + 32 | 0, t[C >> 2] = 0, t[C + 4 >> 2] = 0, C = Ce + 24 | 0, t[C >> 2] = 0, t[C + 4 >> 2] = 0, C = Ce + 16 | 0, t[C >> 2] = 0, t[C + 4 >> 2] = 0, C = Ce + 8 | 0, t[C >> 2] = 0, t[C + 4 >> 2] = 0, t[b + 200 >> 2] = 0, t[b + 204 >> 2] = 0, t[b + 196 >> 2] = K, t[b + 192 >> 2] = b, gr = t[172688], kr = b + 192 | 0, jr = 2, K = U - 224 | 0, U = K;
            r: {
              if (!Ce) {
                yi[t[gr + 168 >> 2]](689778, t[gr + 172 >> 2]), C = 0;
                break r;
              }
              if (c[Ce | 0] = 0, c[Ce + 1 | 0] = 0, c[Ce + 2 | 0] = 0, c[Ce + 3 | 0] = 0, c[Ce + 4 | 0] = 0, c[Ce + 5 | 0] = 0, c[Ce + 6 | 0] = 0, c[Ce + 7 | 0] = 0, C = Ce + 56 | 0, c[C | 0] = 0, c[C + 1 | 0] = 0, c[C + 2 | 0] = 0, c[C + 3 | 0] = 0, c[C + 4 | 0] = 0, c[C + 5 | 0] = 0, c[C + 6 | 0] = 0, c[C + 7 | 0] = 0, C = Ce + 48 | 0, c[C | 0] = 0, c[C + 1 | 0] = 0, c[C + 2 | 0] = 0, c[C + 3 | 0] = 0, c[C + 4 | 0] = 0, c[C + 5 | 0] = 0, c[C + 6 | 0] = 0, c[C + 7 | 0] = 0, C = Ce + 40 | 0, c[C | 0] = 0, c[C + 1 | 0] = 0, c[C + 2 | 0] = 0, c[C + 3 | 0] = 0, c[C + 4 | 0] = 0, c[C + 5 | 0] = 0, c[C + 6 | 0] = 0, c[C + 7 | 0] = 0, C = Ce + 32 | 0, c[C | 0] = 0, c[C + 1 | 0] = 0, c[C + 2 | 0] = 0, c[C + 3 | 0] = 0, c[C + 4 | 0] = 0, c[C + 5 | 0] = 0, c[C + 6 | 0] = 0, c[C + 7 | 0] = 0, C = Ce + 24 | 0, c[C | 0] = 0, c[C + 1 | 0] = 0, c[C + 2 | 0] = 0, c[C + 3 | 0] = 0, c[C + 4 | 0] = 0, c[C + 5 | 0] = 0, c[C + 6 | 0] = 0, c[C + 7 | 0] = 0, C = Ce + 16 | 0, c[C | 0] = 0, c[C + 1 | 0] = 0, c[C + 2 | 0] = 0, c[C + 3 | 0] = 0, c[C + 4 | 0] = 0, c[C + 5 | 0] = 0, c[C + 6 | 0] = 0, c[C + 7 | 0] = 0, C = Ce + 8 | 0, c[C | 0] = 0, c[C + 1 | 0] = 0, c[C + 2 | 0] = 0, c[C + 3 | 0] = 0, c[C + 4 | 0] = 0, c[C + 5 | 0] = 0, c[C + 6 | 0] = 0, c[C + 7 | 0] = 0, !kr) {
                yi[t[gr + 168 >> 2]](689682, t[gr + 172 >> 2]), C = 0;
                break r;
              }
              for (t[K + 216 >> 2] = 1, is(K + 96 | 0, 120), Ii = gr + 172 | 0; ; ) {
                if (a = t[kr >> 2], !a) {
                  yi[t[gr + 168 >> 2]](689809, t[gr + 172 >> 2]), C = 0;
                  break r;
                }
                if (t[K + 88 >> 2] = 0, l = d[a + 60 | 0] | d[a + 61 | 0] << 8 | (d[a + 62 | 0] << 16 | d[a + 63 | 0] << 24), Tt = l >>> 16 | 0, C = K, n = d[a + 56 | 0] | d[a + 57 | 0] << 8 | (d[a + 58 | 0] << 16 | d[a + 59 | 0] << 24), t[C + 80 >> 2] = (l & 65535) << 16 | n >>> 16, t[C + 84 >> 2] = Tt, P = d[a + 36 | 0] | d[a + 37 | 0] << 8 | (d[a + 38 | 0] << 16 | d[a + 39 | 0] << 24), t[C + 48 >> 2] = d[a + 32 | 0] | d[a + 33 | 0] << 8 | (d[a + 34 | 0] << 16 | d[a + 35 | 0] << 24), t[C + 52 >> 2] = P & 1048575, Tt = n << 4 & 1048560, l = d[a + 52 | 0] | d[a + 53 | 0] << 8 | (d[a + 54 | 0] << 16 | d[a + 55 | 0] << 24), pe = l >>> 28 | 0, n = d[a + 48 | 0] | d[a + 49 | 0] << 8 | (d[a + 50 | 0] << 16 | d[a + 51 | 0] << 24), t[C + 72 >> 2] = (l & 268435455) << 4 | n >>> 28, t[C + 76 >> 2] = pe | Tt, Tt = l << 24 | n >>> 8, nr = n << 24 & -16777216, n = d[a + 40 | 0] | d[a + 41 | 0] << 8 | (d[a + 42 | 0] << 16 | d[a + 43 | 0] << 24), l = d[a + 44 | 0] | d[a + 45 | 0] << 8 | (d[a + 46 | 0] << 16 | d[a + 47 | 0] << 24), t[C + 64 >> 2] = l >>> 8 | nr, t[C + 68 >> 2] = Tt & 1048575, Nr = l << 12 | n >>> 20, t[C + 56 >> 2] = n << 12 & -4096 | P >>> 20, t[C + 60 >> 2] = Nr & 1048575, n = d[a + 12 | 0] | d[a + 13 | 0] << 8 | (d[a + 14 | 0] << 16 | d[a + 15 | 0] << 24), Me = n, l = d[a + 8 | 0] | d[a + 9 | 0] << 8 | (d[a + 10 | 0] << 16 | d[a + 11 | 0] << 24), Nr = n << 12 | l >>> 20, tr = l << 12 & -4096, or = d[a | 0] | d[a + 1 | 0] << 8 | (d[a + 2 | 0] << 16 | d[a + 3 | 0] << 24), l = d[a + 4 | 0] | d[a + 5 | 0] << 8 | (d[a + 6 | 0] << 16 | d[a + 7 | 0] << 24), n = l, ai = n >>> 20 | tr, t[C + 16 >> 2] = ai, ui = Nr & 1048575, t[C + 20 >> 2] = ui, t[C + 8 >> 2] = or, di = n & 1048575, t[C + 12 >> 2] = di, l = d[a + 24 | 0] | d[a + 25 | 0] << 8 | (d[a + 26 | 0] << 16 | d[a + 27 | 0] << 24), nr = l, n = d[a + 28 | 0] | d[a + 29 | 0] << 8 | (d[a + 30 | 0] << 16 | d[a + 31 | 0] << 24), P = (n & 65535) << 16 | l >>> 16, t[C + 40 >> 2] = P, tr = n >>> 16 | 0, t[C + 44 >> 2] = tr, l = d[a + 16 | 0] | d[a + 17 | 0] << 8 | (d[a + 18 | 0] << 16 | d[a + 19 | 0] << 24), n = d[a + 20 | 0] | d[a + 21 | 0] << 8 | (d[a + 22 | 0] << 16 | d[a + 23 | 0] << 24), pe = n << 24 | l >>> 8, a = l << 24 & -16777216 | Me >>> 8, t[C + 24 >> 2] = a, Me = pe & 1048575, t[C + 28 >> 2] = Me, Tt = nr << 4 & 1048560, l = (n & 268435455) << 4 | l >>> 28, t[C + 32 >> 2] = l, C = n >>> 28 | Tt, t[K + 36 >> 2] = C, or | ai | P | a | l | (ui | di | tr | Me | C) || yi[t[gr + 168 >> 2]](690116, t[Ii >> 2]), kr = kr + 4 | 0, C = K + 96 | 0, Gs(C, C, K + 8 | 0), jr = jr - 1 | 0, !jr)
                  break;
              }
              if (C = 0, t[K + 216 >> 2])
                break r;
              C = K + 8 | 0, Kn(C, K + 96 | 0), ti(Ce, C), C = 1;
            }
            if (U = K + 224 | 0, !C)
              break e;
            if (t[b + 264 >> 2] = w, C = Lr(t[172688], b + 264 | 0, b + 200 | 0, (w | 0) == 33 ? 258 : 2), t[b + 268 >> 2] = C, (C | 0) != 1)
              break t;
            lr = 1;
            break e;
          }
          M(1);
          break e;
        }
        M(1);
        break e;
      }
      t[b + 136 >> 2] = 0, Ne(b + 128 | 0), wasm2js_trap();
    }
    return U = b + 272 | 0, lr | 0;
  }
  function xt(C, l) {
    C = C | 0, l = l | 0;
    var w = 0, n = 0, a = 0, b = 0, P = 0, K = 0, pe = 0, Ce = 0, Me = 0, Tt = 0, tr = 0, nr = 0, or = 0, lr = 0, gr = 0, kr = 0, Nr = 0, jr = 0, Yr = 0;
    P = U - 208 | 0, U = P, w = P + 136 | 0, n = w + 56 | 0, t[n >> 2] = 0, t[n + 4 >> 2] = 0, n = w + 48 | 0, t[n >> 2] = 0, t[n + 4 >> 2] = 0, n = w + 40 | 0, t[n >> 2] = 0, t[n + 4 >> 2] = 0, n = w + 32 | 0, t[n >> 2] = 0, t[n + 4 >> 2] = 0, n = w + 24 | 0, t[n >> 2] = 0, t[n + 4 >> 2] = 0, n = w + 16 | 0, t[n >> 2] = 0, t[n + 4 >> 2] = 0, n = w + 8 | 0, t[n >> 2] = 0, t[n + 4 >> 2] = 0, t[P + 136 >> 2] = 0, t[P + 140 >> 2] = 0;
    e: {
      if ((Bi(t[172688], w, 690820, C) | 0) == 1) {
        Ce = P + 136 | 0, w = Ce + 15 | 0, C = d[w + 4 | 0] | d[w + 5 | 0] << 8 | (d[w + 6 | 0] << 16 | d[w + 7 | 0] << 24), n = P + 72 | 0, nr = n + 8 | 0, t[nr >> 2] = d[w | 0] | d[w + 1 | 0] << 8 | (d[w + 2 | 0] << 16 | d[w + 3 | 0] << 24), t[nr + 4 >> 2] = C, w = Ce + 23 | 0, C = d[w + 4 | 0] | d[w + 5 | 0] << 8 | (d[w + 6 | 0] << 16 | d[w + 7 | 0] << 24), Tt = n + 16 | 0, t[Tt >> 2] = d[w | 0] | d[w + 1 | 0] << 8 | (d[w + 2 | 0] << 16 | d[w + 3 | 0] << 24), t[Tt + 4 >> 2] = C, w = Ce + 31 | 0, C = d[w + 4 | 0] | d[w + 5 | 0] << 8 | (d[w + 6 | 0] << 16 | d[w + 7 | 0] << 24), tr = n + 24 | 0, t[tr >> 2] = d[w | 0] | d[w + 1 | 0] << 8 | (d[w + 2 | 0] << 16 | d[w + 3 | 0] << 24), t[tr + 4 >> 2] = C, w = Ce + 39 | 0, C = d[w + 4 | 0] | d[w + 5 | 0] << 8 | (d[w + 6 | 0] << 16 | d[w + 7 | 0] << 24), Me = n + 32 | 0, t[Me >> 2] = d[w | 0] | d[w + 1 | 0] << 8 | (d[w + 2 | 0] << 16 | d[w + 3 | 0] << 24), t[Me + 4 >> 2] = C, w = Ce + 47 | 0, C = d[w + 4 | 0] | d[w + 5 | 0] << 8 | (d[w + 6 | 0] << 16 | d[w + 7 | 0] << 24), K = n + 40 | 0, t[K >> 2] = d[w | 0] | d[w + 1 | 0] << 8 | (d[w + 2 | 0] << 16 | d[w + 3 | 0] << 24), t[K + 4 >> 2] = C, pe = Ce + 55 | 0, C = d[pe + 4 | 0] | d[pe + 5 | 0] << 8 | (d[pe + 6 | 0] << 16 | d[pe + 7 | 0] << 24), w = n + 48 | 0, t[w >> 2] = d[pe | 0] | d[pe + 1 | 0] << 8 | (d[pe + 2 | 0] << 16 | d[pe + 3 | 0] << 24), t[w + 4 >> 2] = C, n = n + 56 | 0, c[n | 0] = d[Ce + 63 | 0], c[P + 10 | 0] = d[P + 138 | 0], y[P + 8 >> 1] = E[P + 136 >> 1], C = d[P + 147 | 0] | d[P + 148 | 0] << 8 | (d[P + 149 | 0] << 16 | d[P + 150 | 0] << 24), t[P + 72 >> 2] = d[P + 143 | 0] | d[P + 144 | 0] << 8 | (d[P + 145 | 0] << 16 | d[P + 146 | 0] << 24), t[P + 76 >> 2] = C, Ce = d[P + 139 | 0] | d[P + 140 | 0] << 8 | (d[P + 141 | 0] << 16 | d[P + 142 | 0] << 24), a = P + 8 | 0, c[a + 63 | 0] = d[n | 0], n = t[w + 4 >> 2], pe = a + 55 | 0, C = t[w >> 2], c[pe | 0] = C, c[pe + 1 | 0] = C >>> 8, c[pe + 2 | 0] = C >>> 16, c[pe + 3 | 0] = C >>> 24, c[pe + 4 | 0] = n, c[pe + 5 | 0] = n >>> 8, c[pe + 6 | 0] = n >>> 16, c[pe + 7 | 0] = n >>> 24, n = t[K + 4 >> 2], w = a + 47 | 0, C = t[K >> 2], c[w | 0] = C, c[w + 1 | 0] = C >>> 8, c[w + 2 | 0] = C >>> 16, c[w + 3 | 0] = C >>> 24, c[w + 4 | 0] = n, c[w + 5 | 0] = n >>> 8, c[w + 6 | 0] = n >>> 16, c[w + 7 | 0] = n >>> 24, n = t[Me + 4 >> 2], w = a + 39 | 0, C = t[Me >> 2], c[w | 0] = C, c[w + 1 | 0] = C >>> 8, c[w + 2 | 0] = C >>> 16, c[w + 3 | 0] = C >>> 24, c[w + 4 | 0] = n, c[w + 5 | 0] = n >>> 8, c[w + 6 | 0] = n >>> 16, c[w + 7 | 0] = n >>> 24, n = t[tr + 4 >> 2], w = a + 31 | 0, C = t[tr >> 2], c[w | 0] = C, c[w + 1 | 0] = C >>> 8, c[w + 2 | 0] = C >>> 16, c[w + 3 | 0] = C >>> 24, c[w + 4 | 0] = n, c[w + 5 | 0] = n >>> 8, c[w + 6 | 0] = n >>> 16, c[w + 7 | 0] = n >>> 24, n = t[Tt + 4 >> 2], w = a + 23 | 0, C = t[Tt >> 2], c[w | 0] = C, c[w + 1 | 0] = C >>> 8, c[w + 2 | 0] = C >>> 16, c[w + 3 | 0] = C >>> 24, c[w + 4 | 0] = n, c[w + 5 | 0] = n >>> 8, c[w + 6 | 0] = n >>> 16, c[w + 7 | 0] = n >>> 24, n = t[nr + 4 >> 2], w = a + 15 | 0, C = t[nr >> 2], c[w | 0] = C, c[w + 1 | 0] = C >>> 8, c[w + 2 | 0] = C >>> 16, c[w + 3 | 0] = C >>> 24, c[w + 4 | 0] = n, c[w + 5 | 0] = n >>> 8, c[w + 6 | 0] = n >>> 16, c[w + 7 | 0] = n >>> 24, c[P + 11 | 0] = Ce, c[P + 12 | 0] = Ce >>> 8, c[P + 13 | 0] = Ce >>> 16, c[P + 14 | 0] = Ce >>> 24, n = t[P + 76 >> 2], C = t[P + 72 >> 2], c[P + 15 | 0] = C, c[P + 16 | 0] = C >>> 8, c[P + 17 | 0] = C >>> 16, c[P + 18 | 0] = C >>> 24, c[P + 19 | 0] = n, c[P + 20 | 0] = n >>> 8, c[P + 21 | 0] = n >>> 16, c[P + 22 | 0] = n >>> 24, or = Et(), b = U - 288 | 0, U = b;
        t: {
          if (!a) {
            yi[t[or + 168 >> 2]](689638, t[or + 172 >> 2]);
            break t;
          }
          if (C = d[a + 60 | 0] | d[a + 61 | 0] << 8 | (d[a + 62 | 0] << 16 | d[a + 63 | 0] << 24), Tt = C >>> 16 | 0, K = b + 72 | 0, n = d[a + 56 | 0] | d[a + 57 | 0] << 8 | (d[a + 58 | 0] << 16 | d[a + 59 | 0] << 24), t[K >> 2] = (C & 65535) << 16 | n >>> 16, t[K + 4 >> 2] = Tt, K = n << 4 & 1048560, C = d[a + 52 | 0] | d[a + 53 | 0] << 8 | (d[a + 54 | 0] << 16 | d[a + 55 | 0] << 24), pe = C >>> 28 | 0, Me = b - -64 | 0, n = d[a + 48 | 0] | d[a + 49 | 0] << 8 | (d[a + 50 | 0] << 16 | d[a + 51 | 0] << 24), t[Me >> 2] = (C & 268435455) << 4 | n >>> 28, t[Me + 4 >> 2] = K | pe, Tt = C << 24 | n >>> 8, Me = n << 24 & -16777216, n = d[a + 40 | 0] | d[a + 41 | 0] << 8 | (d[a + 42 | 0] << 16 | d[a + 43 | 0] << 24), tr = b + 56 | 0, C = d[a + 44 | 0] | d[a + 45 | 0] << 8 | (d[a + 46 | 0] << 16 | d[a + 47 | 0] << 24), t[tr >> 2] = C >>> 8 | Me, t[tr + 4 >> 2] = Tt & 1048575, Tt = C << 12 | n >>> 20, Me = n << 12 & -4096, w = d[a + 32 | 0] | d[a + 33 | 0] << 8 | (d[a + 34 | 0] << 16 | d[a + 35 | 0] << 24), C = d[a + 36 | 0] | d[a + 37 | 0] << 8 | (d[a + 38 | 0] << 16 | d[a + 39 | 0] << 24), tr = b + 48 | 0, t[tr >> 2] = C >>> 20 | Me, t[tr + 4 >> 2] = Tt & 1048575, t[b + 80 >> 2] = 0, t[b + 40 >> 2] = w, t[b + 44 >> 2] = C & 1048575, w = d[a + 12 | 0] | d[a + 13 | 0] << 8 | (d[a + 14 | 0] << 16 | d[a + 15 | 0] << 24), Ce = w, n = d[a + 8 | 0] | d[a + 9 | 0] << 8 | (d[a + 10 | 0] << 16 | d[a + 11 | 0] << 24), Tt = w << 12 | n >>> 20, Me = n << 12 & -4096, nr = d[a | 0] | d[a + 1 | 0] << 8 | (d[a + 2 | 0] << 16 | d[a + 3 | 0] << 24), n = d[a + 4 | 0] | d[a + 5 | 0] << 8 | (d[a + 6 | 0] << 16 | d[a + 7 | 0] << 24), w = n, C = b, lr = w >>> 20 | Me, t[C + 8 >> 2] = lr, gr = Tt & 1048575, t[C + 12 >> 2] = gr, t[C >> 2] = nr, kr = w & 1048575, t[C + 4 >> 2] = kr, n = d[a + 24 | 0] | d[a + 25 | 0] << 8 | (d[a + 26 | 0] << 16 | d[a + 27 | 0] << 24), Tt = n, w = d[a + 28 | 0] | d[a + 29 | 0] << 8 | (d[a + 30 | 0] << 16 | d[a + 31 | 0] << 24), K = (w & 65535) << 16 | n >>> 16, t[C + 32 >> 2] = K, Me = w >>> 16 | 0, t[C + 36 >> 2] = Me, n = d[a + 16 | 0] | d[a + 17 | 0] << 8 | (d[a + 18 | 0] << 16 | d[a + 19 | 0] << 24), w = d[a + 20 | 0] | d[a + 21 | 0] << 8 | (d[a + 22 | 0] << 16 | d[a + 23 | 0] << 24), pe = w << 24 | n >>> 8, Nr = n << 24 & -16777216 | Ce >>> 8, t[C + 16 >> 2] = Nr, Ce = pe & 1048575, t[C + 20 >> 2] = Ce, tr = Tt << 4 & 1048560, n = (w & 268435455) << 4 | n >>> 28, t[C + 24 >> 2] = n, C = w >>> 28 | tr, t[b + 28 >> 2] = C, !(nr | lr | K | Nr | n | (gr | kr | Me | Ce | C))) {
            yi[t[or + 168 >> 2]](690116, t[or + 172 >> 2]), C = a + 56 | 0, c[C | 0] = 0, c[C + 1 | 0] = 0, c[C + 2 | 0] = 0, c[C + 3 | 0] = 0, c[C + 4 | 0] = 0, c[C + 5 | 0] = 0, c[C + 6 | 0] = 0, c[C + 7 | 0] = 0, C = a + 48 | 0, c[C | 0] = 0, c[C + 1 | 0] = 0, c[C + 2 | 0] = 0, c[C + 3 | 0] = 0, c[C + 4 | 0] = 0, c[C + 5 | 0] = 0, c[C + 6 | 0] = 0, c[C + 7 | 0] = 0, C = a + 40 | 0, c[C | 0] = 0, c[C + 1 | 0] = 0, c[C + 2 | 0] = 0, c[C + 3 | 0] = 0, c[C + 4 | 0] = 0, c[C + 5 | 0] = 0, c[C + 6 | 0] = 0, c[C + 7 | 0] = 0, C = a + 32 | 0, c[C | 0] = 0, c[C + 1 | 0] = 0, c[C + 2 | 0] = 0, c[C + 3 | 0] = 0, c[C + 4 | 0] = 0, c[C + 5 | 0] = 0, c[C + 6 | 0] = 0, c[C + 7 | 0] = 0, C = a + 24 | 0, c[C | 0] = 0, c[C + 1 | 0] = 0, c[C + 2 | 0] = 0, c[C + 3 | 0] = 0, c[C + 4 | 0] = 0, c[C + 5 | 0] = 0, c[C + 6 | 0] = 0, c[C + 7 | 0] = 0, C = a + 16 | 0, c[C | 0] = 0, c[C + 1 | 0] = 0, c[C + 2 | 0] = 0, c[C + 3 | 0] = 0, c[C + 4 | 0] = 0, c[C + 5 | 0] = 0, c[C + 6 | 0] = 0, c[C + 7 | 0] = 0, C = a + 8 | 0, c[C | 0] = 0, c[C + 1 | 0] = 0, c[C + 2 | 0] = 0, c[C + 3 | 0] = 0, c[C + 4 | 0] = 0, c[C + 5 | 0] = 0, c[C + 6 | 0] = 0, c[C + 7 | 0] = 0, c[a | 0] = 0, c[a + 1 | 0] = 0, c[a + 2 | 0] = 0, c[a + 3 | 0] = 0, c[a + 4 | 0] = 0, c[a + 5 | 0] = 0, c[a + 6 | 0] = 0, c[a + 7 | 0] = 0;
            break t;
          }
          if (c[a | 0] = 0, c[a + 1 | 0] = 0, c[a + 2 | 0] = 0, c[a + 3 | 0] = 0, c[a + 4 | 0] = 0, c[a + 5 | 0] = 0, c[a + 6 | 0] = 0, c[a + 7 | 0] = 0, C = a + 56 | 0, c[C | 0] = 0, c[C + 1 | 0] = 0, c[C + 2 | 0] = 0, c[C + 3 | 0] = 0, c[C + 4 | 0] = 0, c[C + 5 | 0] = 0, c[C + 6 | 0] = 0, c[C + 7 | 0] = 0, C = a + 48 | 0, c[C | 0] = 0, c[C + 1 | 0] = 0, c[C + 2 | 0] = 0, c[C + 3 | 0] = 0, c[C + 4 | 0] = 0, c[C + 5 | 0] = 0, c[C + 6 | 0] = 0, c[C + 7 | 0] = 0, C = a + 40 | 0, c[C | 0] = 0, c[C + 1 | 0] = 0, c[C + 2 | 0] = 0, c[C + 3 | 0] = 0, c[C + 4 | 0] = 0, c[C + 5 | 0] = 0, c[C + 6 | 0] = 0, c[C + 7 | 0] = 0, C = a + 32 | 0, c[C | 0] = 0, c[C + 1 | 0] = 0, c[C + 2 | 0] = 0, c[C + 3 | 0] = 0, c[C + 4 | 0] = 0, c[C + 5 | 0] = 0, c[C + 6 | 0] = 0, c[C + 7 | 0] = 0, C = a + 24 | 0, c[C | 0] = 0, c[C + 1 | 0] = 0, c[C + 2 | 0] = 0, c[C + 3 | 0] = 0, c[C + 4 | 0] = 0, c[C + 5 | 0] = 0, c[C + 6 | 0] = 0, c[C + 7 | 0] = 0, C = a + 16 | 0, c[C | 0] = 0, c[C + 1 | 0] = 0, c[C + 2 | 0] = 0, c[C + 3 | 0] = 0, c[C + 4 | 0] = 0, c[C + 5 | 0] = 0, c[C + 6 | 0] = 0, c[C + 7 | 0] = 0, C = a + 8 | 0, c[C | 0] = 0, c[C + 1 | 0] = 0, c[C + 2 | 0] = 0, c[C + 3 | 0] = 0, c[C + 4 | 0] = 0, c[C + 5 | 0] = 0, c[C + 6 | 0] = 0, c[C + 7 | 0] = 0, t[b + 92 >> 2] = 0, Ir(b + 96 | 0, 690949, b + 92 | 0), t[b + 92 >> 2] || (w = b + 8 | 0, n = t[w + 4 >> 2], K = b + 160 | 0, C = K + 8 | 0, t[C >> 2] = t[w >> 2], t[C + 4 >> 2] = n, w = b + 16 | 0, n = t[w + 4 >> 2], C = K + 16 | 0, t[C >> 2] = t[w >> 2], t[C + 4 >> 2] = n, w = b + 24 | 0, n = t[w + 4 >> 2], C = K + 24 | 0, t[C >> 2] = t[w >> 2], t[C + 4 >> 2] = n, w = b + 32 | 0, n = t[w + 4 >> 2], C = K + 32 | 0, t[C >> 2] = t[w >> 2], t[C + 4 >> 2] = n, w = b + 48 | 0, n = t[w + 4 >> 2], C = K + 48 | 0, t[C >> 2] = t[w >> 2], t[C + 4 >> 2] = n, w = b + 56 | 0, n = t[w + 4 >> 2], C = K + 56 | 0, t[C >> 2] = t[w >> 2], t[C + 4 >> 2] = n, w = b - -64 | 0, n = t[w + 4 >> 2], C = K - -64 | 0, t[C >> 2] = t[w >> 2], t[C + 4 >> 2] = n, w = b + 72 | 0, n = t[w + 4 >> 2], C = K + 72 | 0, t[C >> 2] = t[w >> 2], t[C + 4 >> 2] = n, t[b + 280 >> 2] = 0, C = t[b + 4 >> 2], t[b + 160 >> 2] = t[b >> 2], t[b + 164 >> 2] = C, C = t[b + 44 >> 2], t[b + 200 >> 2] = t[b + 40 >> 2], t[b + 204 >> 2] = C, C = b + 248 | 0, t[C >> 2] = 0, t[C + 4 >> 2] = 0, C = b + 256 | 0, t[C >> 2] = 0, t[C + 4 >> 2] = 0, C = b + 264 | 0, t[C >> 2] = 0, t[C + 4 >> 2] = 0, C = b + 272 | 0, t[C >> 2] = 0, t[C + 4 >> 2] = 0, n = b + 128 | 0, C = n + 16 | 0, t[C >> 2] = 0, t[C + 4 >> 2] = 0, C = n + 24 | 0, t[C >> 2] = 0, t[C + 4 >> 2] = 0, t[b + 240 >> 2] = 1, t[b + 244 >> 2] = 0, t[b + 136 >> 2] = 0, t[b + 140 >> 2] = 0, t[b + 128 >> 2] = 1, t[b + 132 >> 2] = 0, xr(K, K, n, b + 96 | 0), t[b + 280 >> 2]))
            break t;
          Kn(b, b + 160 | 0), ti(a, b), jr = 1;
        }
        if (U = b + 288 | 0, !jr || (t[P + 204 >> 2] = l, C = Lr(t[172688], P + 204 | 0, P + 8 | 0, (l | 0) == 33 ? 258 : 2), t[P + 72 >> 2] = C, Yr = 1, (C | 0) == 1))
          break e;
        t[P + 144 >> 2] = 0, Ne(P + 136 | 0), wasm2js_trap();
      }
      M(1);
    }
    return U = P + 208 | 0, Yr | 0;
  }
  function ir() {
    var C = 0, l = 0, w = 0, n = 0, a = 0, b = 0, P = 0, K = 0, pe = 0, Ce = 0, Me = 0, Tt = 0, tr = 0, nr = 0, or = 0, lr = 0, gr = 0, kr = 0, Nr = 0, jr = 0;
    P = U - 208 | 0, U = P, w = P + 136 | 0, gr = w + 56 | 0, t[gr >> 2] = 0, t[gr + 4 >> 2] = 0, kr = w + 48 | 0, t[kr >> 2] = 0, t[kr + 4 >> 2] = 0, tr = w + 40 | 0, t[tr >> 2] = 0, t[tr + 4 >> 2] = 0, Nr = w + 32 | 0, t[Nr >> 2] = 0, t[Nr + 4 >> 2] = 0, b = w + 24 | 0, t[b >> 2] = 0, t[b + 4 >> 2] = 0, lr = w + 16 | 0, t[lr >> 2] = 0, t[lr + 4 >> 2] = 0, or = w + 8 | 0, t[or >> 2] = 0, t[or + 4 >> 2] = 0, t[P + 136 >> 2] = 0, t[P + 140 >> 2] = 0;
    e: {
      t: {
        if ((Fs(t[172688], w, 690885) | 0) == 1) {
          pe = P + 136 | 0, l = pe + 15 | 0, C = d[l + 4 | 0] | d[l + 5 | 0] << 8 | (d[l + 6 | 0] << 16 | d[l + 7 | 0] << 24), w = P + 72 | 0, jr = w + 8 | 0, t[jr >> 2] = d[l | 0] | d[l + 1 | 0] << 8 | (d[l + 2 | 0] << 16 | d[l + 3 | 0] << 24), t[jr + 4 >> 2] = C, l = pe + 23 | 0, C = d[l + 4 | 0] | d[l + 5 | 0] << 8 | (d[l + 6 | 0] << 16 | d[l + 7 | 0] << 24), Me = w + 16 | 0, t[Me >> 2] = d[l | 0] | d[l + 1 | 0] << 8 | (d[l + 2 | 0] << 16 | d[l + 3 | 0] << 24), t[Me + 4 >> 2] = C, l = pe + 31 | 0, C = d[l + 4 | 0] | d[l + 5 | 0] << 8 | (d[l + 6 | 0] << 16 | d[l + 7 | 0] << 24), Tt = w + 24 | 0, t[Tt >> 2] = d[l | 0] | d[l + 1 | 0] << 8 | (d[l + 2 | 0] << 16 | d[l + 3 | 0] << 24), t[Tt + 4 >> 2] = C, l = pe + 39 | 0, C = d[l + 4 | 0] | d[l + 5 | 0] << 8 | (d[l + 6 | 0] << 16 | d[l + 7 | 0] << 24), Ce = w + 32 | 0, t[Ce >> 2] = d[l | 0] | d[l + 1 | 0] << 8 | (d[l + 2 | 0] << 16 | d[l + 3 | 0] << 24), t[Ce + 4 >> 2] = C, l = pe + 47 | 0, C = d[l + 4 | 0] | d[l + 5 | 0] << 8 | (d[l + 6 | 0] << 16 | d[l + 7 | 0] << 24), a = w + 40 | 0, t[a >> 2] = d[l | 0] | d[l + 1 | 0] << 8 | (d[l + 2 | 0] << 16 | d[l + 3 | 0] << 24), t[a + 4 >> 2] = C, K = pe + 55 | 0, C = d[K + 4 | 0] | d[K + 5 | 0] << 8 | (d[K + 6 | 0] << 16 | d[K + 7 | 0] << 24), l = w + 48 | 0, t[l >> 2] = d[K | 0] | d[K + 1 | 0] << 8 | (d[K + 2 | 0] << 16 | d[K + 3 | 0] << 24), t[l + 4 >> 2] = C, w = w + 56 | 0, c[w | 0] = d[pe + 63 | 0], c[P + 10 | 0] = d[P + 138 | 0], y[P + 8 >> 1] = E[P + 136 >> 1], C = d[P + 147 | 0] | d[P + 148 | 0] << 8 | (d[P + 149 | 0] << 16 | d[P + 150 | 0] << 24), t[P + 72 >> 2] = d[P + 143 | 0] | d[P + 144 | 0] << 8 | (d[P + 145 | 0] << 16 | d[P + 146 | 0] << 24), t[P + 76 >> 2] = C, C = d[P + 139 | 0] | d[P + 140 | 0] << 8 | (d[P + 141 | 0] << 16 | d[P + 142 | 0] << 24), n = P + 8 | 0, c[n + 63 | 0] = d[w | 0], K = t[l + 4 >> 2], nr = n + 55 | 0, w = t[l >> 2], c[nr | 0] = w, c[nr + 1 | 0] = w >>> 8, c[nr + 2 | 0] = w >>> 16, c[nr + 3 | 0] = w >>> 24, c[nr + 4 | 0] = K, c[nr + 5 | 0] = K >>> 8, c[nr + 6 | 0] = K >>> 16, c[nr + 7 | 0] = K >>> 24, l = t[a + 4 >> 2], K = n + 47 | 0, w = t[a >> 2], c[K | 0] = w, c[K + 1 | 0] = w >>> 8, c[K + 2 | 0] = w >>> 16, c[K + 3 | 0] = w >>> 24, c[K + 4 | 0] = l, c[K + 5 | 0] = l >>> 8, c[K + 6 | 0] = l >>> 16, c[K + 7 | 0] = l >>> 24, l = t[Ce + 4 >> 2], a = n + 39 | 0, w = t[Ce >> 2], c[a | 0] = w, c[a + 1 | 0] = w >>> 8, c[a + 2 | 0] = w >>> 16, c[a + 3 | 0] = w >>> 24, c[a + 4 | 0] = l, c[a + 5 | 0] = l >>> 8, c[a + 6 | 0] = l >>> 16, c[a + 7 | 0] = l >>> 24, l = t[Tt + 4 >> 2], a = n + 31 | 0, w = t[Tt >> 2], c[a | 0] = w, c[a + 1 | 0] = w >>> 8, c[a + 2 | 0] = w >>> 16, c[a + 3 | 0] = w >>> 24, c[a + 4 | 0] = l, c[a + 5 | 0] = l >>> 8, c[a + 6 | 0] = l >>> 16, c[a + 7 | 0] = l >>> 24, l = t[Me + 4 >> 2], a = n + 23 | 0, w = t[Me >> 2], c[a | 0] = w, c[a + 1 | 0] = w >>> 8, c[a + 2 | 0] = w >>> 16, c[a + 3 | 0] = w >>> 24, c[a + 4 | 0] = l, c[a + 5 | 0] = l >>> 8, c[a + 6 | 0] = l >>> 16, c[a + 7 | 0] = l >>> 24, l = t[jr + 4 >> 2], a = n + 15 | 0, w = t[jr >> 2], c[a | 0] = w, c[a + 1 | 0] = w >>> 8, c[a + 2 | 0] = w >>> 16, c[a + 3 | 0] = w >>> 24, c[a + 4 | 0] = l, c[a + 5 | 0] = l >>> 8, c[a + 6 | 0] = l >>> 16, c[a + 7 | 0] = l >>> 24, c[P + 11 | 0] = C, c[P + 12 | 0] = C >>> 8, c[P + 13 | 0] = C >>> 16, c[P + 14 | 0] = C >>> 24, w = t[P + 76 >> 2], C = t[P + 72 >> 2], c[P + 15 | 0] = C, c[P + 16 | 0] = C >>> 8, c[P + 17 | 0] = C >>> 16, c[P + 18 | 0] = C >>> 24, c[P + 19 | 0] = w, c[P + 20 | 0] = w >>> 8, c[P + 21 | 0] = w >>> 16, c[P + 22 | 0] = w >>> 24, t[gr >> 2] = 0, t[gr + 4 >> 2] = 0, t[kr >> 2] = 0, t[kr + 4 >> 2] = 0, t[tr >> 2] = 0, t[tr + 4 >> 2] = 0, t[Nr >> 2] = 0, t[Nr + 4 >> 2] = 0, t[b >> 2] = 0, t[b + 4 >> 2] = 0, t[lr >> 2] = 0, t[lr + 4 >> 2] = 0, t[or >> 2] = 0, t[or + 4 >> 2] = 0, t[P + 136 >> 2] = 0, t[P + 140 >> 2] = 0, tr = Et(), nr = 0, b = U - 288 | 0, U = b;
          r: {
            if (!pe) {
              yi[t[tr + 168 >> 2]](689607, t[tr + 172 >> 2]);
              break r;
            }
            if (c[pe | 0] = 0, c[pe + 1 | 0] = 0, c[pe + 2 | 0] = 0, c[pe + 3 | 0] = 0, c[pe + 4 | 0] = 0, c[pe + 5 | 0] = 0, c[pe + 6 | 0] = 0, c[pe + 7 | 0] = 0, C = pe + 56 | 0, c[C | 0] = 0, c[C + 1 | 0] = 0, c[C + 2 | 0] = 0, c[C + 3 | 0] = 0, c[C + 4 | 0] = 0, c[C + 5 | 0] = 0, c[C + 6 | 0] = 0, c[C + 7 | 0] = 0, C = pe + 48 | 0, c[C | 0] = 0, c[C + 1 | 0] = 0, c[C + 2 | 0] = 0, c[C + 3 | 0] = 0, c[C + 4 | 0] = 0, c[C + 5 | 0] = 0, c[C + 6 | 0] = 0, c[C + 7 | 0] = 0, C = pe + 40 | 0, c[C | 0] = 0, c[C + 1 | 0] = 0, c[C + 2 | 0] = 0, c[C + 3 | 0] = 0, c[C + 4 | 0] = 0, c[C + 5 | 0] = 0, c[C + 6 | 0] = 0, c[C + 7 | 0] = 0, C = pe + 32 | 0, c[C | 0] = 0, c[C + 1 | 0] = 0, c[C + 2 | 0] = 0, c[C + 3 | 0] = 0, c[C + 4 | 0] = 0, c[C + 5 | 0] = 0, c[C + 6 | 0] = 0, c[C + 7 | 0] = 0, C = pe + 24 | 0, c[C | 0] = 0, c[C + 1 | 0] = 0, c[C + 2 | 0] = 0, c[C + 3 | 0] = 0, c[C + 4 | 0] = 0, c[C + 5 | 0] = 0, c[C + 6 | 0] = 0, c[C + 7 | 0] = 0, C = pe + 16 | 0, c[C | 0] = 0, c[C + 1 | 0] = 0, c[C + 2 | 0] = 0, c[C + 3 | 0] = 0, c[C + 4 | 0] = 0, c[C + 5 | 0] = 0, c[C + 6 | 0] = 0, c[C + 7 | 0] = 0, C = pe + 8 | 0, c[C | 0] = 0, c[C + 1 | 0] = 0, c[C + 2 | 0] = 0, c[C + 3 | 0] = 0, c[C + 4 | 0] = 0, c[C + 5 | 0] = 0, c[C + 6 | 0] = 0, c[C + 7 | 0] = 0, !n) {
              yi[t[tr + 168 >> 2]](689629, t[tr + 172 >> 2]);
              break r;
            }
            if (C = d[n + 60 | 0] | d[n + 61 | 0] << 8 | (d[n + 62 | 0] << 16 | d[n + 63 | 0] << 24), Me = C >>> 16 | 0, a = b + 72 | 0, w = d[n + 56 | 0] | d[n + 57 | 0] << 8 | (d[n + 58 | 0] << 16 | d[n + 59 | 0] << 24), t[a >> 2] = (C & 65535) << 16 | w >>> 16, t[a + 4 >> 2] = Me, a = w << 4 & 1048560, C = d[n + 52 | 0] | d[n + 53 | 0] << 8 | (d[n + 54 | 0] << 16 | d[n + 55 | 0] << 24), lr = C >>> 28 | 0, Ce = b - -64 | 0, w = d[n + 48 | 0] | d[n + 49 | 0] << 8 | (d[n + 50 | 0] << 16 | d[n + 51 | 0] << 24), t[Ce >> 2] = (C & 268435455) << 4 | w >>> 28, t[Ce + 4 >> 2] = a | lr, Me = C << 24 | w >>> 8, Ce = w << 24 & -16777216, w = d[n + 40 | 0] | d[n + 41 | 0] << 8 | (d[n + 42 | 0] << 16 | d[n + 43 | 0] << 24), Tt = b + 56 | 0, C = d[n + 44 | 0] | d[n + 45 | 0] << 8 | (d[n + 46 | 0] << 16 | d[n + 47 | 0] << 24), t[Tt >> 2] = C >>> 8 | Ce, t[Tt + 4 >> 2] = Me & 1048575, Me = C << 12 | w >>> 20, Ce = w << 12 & -4096, l = d[n + 32 | 0] | d[n + 33 | 0] << 8 | (d[n + 34 | 0] << 16 | d[n + 35 | 0] << 24), C = d[n + 36 | 0] | d[n + 37 | 0] << 8 | (d[n + 38 | 0] << 16 | d[n + 39 | 0] << 24), Tt = b + 48 | 0, t[Tt >> 2] = C >>> 20 | Ce, t[Tt + 4 >> 2] = Me & 1048575, t[b + 80 >> 2] = 0, t[b + 40 >> 2] = l, t[b + 44 >> 2] = C & 1048575, l = d[n + 12 | 0] | d[n + 13 | 0] << 8 | (d[n + 14 | 0] << 16 | d[n + 15 | 0] << 24), or = l, w = d[n + 8 | 0] | d[n + 9 | 0] << 8 | (d[n + 10 | 0] << 16 | d[n + 11 | 0] << 24), Me = l << 12 | w >>> 20, Ce = w << 12 & -4096, jr = d[n | 0] | d[n + 1 | 0] << 8 | (d[n + 2 | 0] << 16 | d[n + 3 | 0] << 24), w = d[n + 4 | 0] | d[n + 5 | 0] << 8 | (d[n + 6 | 0] << 16 | d[n + 7 | 0] << 24), l = w, C = b, K = l >>> 20 | Ce, t[C + 8 >> 2] = K, gr = Me & 1048575, t[C + 12 >> 2] = gr, t[C >> 2] = jr, kr = l & 1048575, t[C + 4 >> 2] = kr, w = d[n + 24 | 0] | d[n + 25 | 0] << 8 | (d[n + 26 | 0] << 16 | d[n + 27 | 0] << 24), Me = w, l = d[n + 28 | 0] | d[n + 29 | 0] << 8 | (d[n + 30 | 0] << 16 | d[n + 31 | 0] << 24), a = (l & 65535) << 16 | w >>> 16, t[C + 32 >> 2] = a, Ce = l >>> 16 | 0, t[C + 36 >> 2] = Ce, w = d[n + 16 | 0] | d[n + 17 | 0] << 8 | (d[n + 18 | 0] << 16 | d[n + 19 | 0] << 24), l = d[n + 20 | 0] | d[n + 21 | 0] << 8 | (d[n + 22 | 0] << 16 | d[n + 23 | 0] << 24), lr = l << 24 | w >>> 8, Nr = w << 24 & -16777216 | or >>> 8, t[C + 16 >> 2] = Nr, or = lr & 1048575, t[C + 20 >> 2] = or, Tt = Me << 4 & 1048560, w = (l & 268435455) << 4 | w >>> 28, t[C + 24 >> 2] = w, C = l >>> 28 | Tt, t[b + 28 >> 2] = C, !(K | jr | a | Nr | w | (gr | kr | Ce | or | C))) {
              yi[t[tr + 168 >> 2]](690116, t[tr + 172 >> 2]);
              break r;
            }
            if (t[b + 92 >> 2] = 0, Ir(b + 96 | 0, 690949, b + 92 | 0), t[b + 92 >> 2] || (l = b + 8 | 0, w = t[l + 4 >> 2], a = b + 160 | 0, C = a + 8 | 0, t[C >> 2] = t[l >> 2], t[C + 4 >> 2] = w, l = b + 16 | 0, w = t[l + 4 >> 2], C = a + 16 | 0, t[C >> 2] = t[l >> 2], t[C + 4 >> 2] = w, l = b + 24 | 0, w = t[l + 4 >> 2], C = a + 24 | 0, t[C >> 2] = t[l >> 2], t[C + 4 >> 2] = w, l = b + 32 | 0, w = t[l + 4 >> 2], C = a + 32 | 0, t[C >> 2] = t[l >> 2], t[C + 4 >> 2] = w, l = b + 48 | 0, w = t[l + 4 >> 2], C = a + 48 | 0, t[C >> 2] = t[l >> 2], t[C + 4 >> 2] = w, l = b + 56 | 0, w = t[l + 4 >> 2], C = a + 56 | 0, t[C >> 2] = t[l >> 2], t[C + 4 >> 2] = w, l = b - -64 | 0, w = t[l + 4 >> 2], C = a - -64 | 0, t[C >> 2] = t[l >> 2], t[C + 4 >> 2] = w, l = b + 72 | 0, w = t[l + 4 >> 2], C = a + 72 | 0, t[C >> 2] = t[l >> 2], t[C + 4 >> 2] = w, t[b + 280 >> 2] = 0, C = t[b + 4 >> 2], t[b + 160 >> 2] = t[b >> 2], t[b + 164 >> 2] = C, C = t[b + 44 >> 2], t[b + 200 >> 2] = t[b + 40 >> 2], t[b + 204 >> 2] = C, C = b + 248 | 0, t[C >> 2] = 0, t[C + 4 >> 2] = 0, C = b + 256 | 0, t[C >> 2] = 0, t[C + 4 >> 2] = 0, C = b + 264 | 0, t[C >> 2] = 0, t[C + 4 >> 2] = 0, C = b + 272 | 0, t[C >> 2] = 0, t[C + 4 >> 2] = 0, w = b + 128 | 0, C = w + 16 | 0, t[C >> 2] = 0, t[C + 4 >> 2] = 0, C = w + 24 | 0, t[C >> 2] = 0, t[C + 4 >> 2] = 0, t[b + 240 >> 2] = 1, t[b + 244 >> 2] = 0, t[b + 136 >> 2] = 0, t[b + 140 >> 2] = 0, t[b + 128 >> 2] = 1, t[b + 132 >> 2] = 0, xr(a, a, w, b + 96 | 0), t[b + 280 >> 2]))
              break r;
            Kn(b, b + 160 | 0), ti(pe, b), nr = 1;
          }
          if (U = b + 288 | 0, nr) {
            if (t[P + 132 >> 2] = 0, C = Ai(Et(), P + 8 | 0, P + 132 | 0, P + 136 | 0), t[P + 204 >> 2] = C, (C | 0) != 1 || (C = ii(t[172688], P + 8 | 0), t[P + 204 >> 2] = C, (C | 0) != 1))
              break e;
            C = t[P + 132 >> 2];
            break t;
          }
          C = -1;
          break t;
        }
        M(1);
      }
      return U = P + 208 | 0, C | 0;
    }
    t[P + 80 >> 2] = 0, Ne(P + 72 | 0), wasm2js_trap();
  }
  function sr(C) {
    C = C | 0;
    var l = 0, w = 0, n = 0, a = 0, b = 0, P = 0, K = 0, pe = 0, Ce = 0, Me = 0, Tt = 0, tr = 0, nr = 0, or = 0, lr = 0, gr = 0, kr = 0, Nr = 0, jr = 0, Yr = 0, ei = 0, ai = 0, ui = 0, di = 0, Ii = 0, wi = 0;
    n = U - 192 | 0, U = n, w = n + 128 | 0, Ce = w + 56 | 0, t[Ce >> 2] = 0, t[Ce + 4 >> 2] = 0, Me = w + 48 | 0, t[Me >> 2] = 0, t[Me + 4 >> 2] = 0, K = w + 40 | 0, t[K >> 2] = 0, t[K + 4 >> 2] = 0, nr = w + 32 | 0, t[nr >> 2] = 0, t[nr + 4 >> 2] = 0, Nr = w + 24 | 0, t[Nr >> 2] = 0, t[Nr + 4 >> 2] = 0, jr = w + 16 | 0, t[jr >> 2] = 0, t[jr + 4 >> 2] = 0, kr = w + 8 | 0, t[kr >> 2] = 0, t[kr + 4 >> 2] = 0, t[n + 128 >> 2] = 0, t[n + 132 >> 2] = 0;
    e: {
      if ((Fs(t[172688], w, 690885) | 0) == 1) {
        if (w = n + 128 | 0, l = w + 15 | 0, a = d[l + 4 | 0] | d[l + 5 | 0] << 8 | (d[l + 6 | 0] << 16 | d[l + 7 | 0] << 24), b = n - -64 | 0, Tt = b + 8 | 0, t[Tt >> 2] = d[l | 0] | d[l + 1 | 0] << 8 | (d[l + 2 | 0] << 16 | d[l + 3 | 0] << 24), t[Tt + 4 >> 2] = a, l = w + 23 | 0, a = d[l + 4 | 0] | d[l + 5 | 0] << 8 | (d[l + 6 | 0] << 16 | d[l + 7 | 0] << 24), or = b + 16 | 0, t[or >> 2] = d[l | 0] | d[l + 1 | 0] << 8 | (d[l + 2 | 0] << 16 | d[l + 3 | 0] << 24), t[or + 4 >> 2] = a, l = w + 31 | 0, a = d[l + 4 | 0] | d[l + 5 | 0] << 8 | (d[l + 6 | 0] << 16 | d[l + 7 | 0] << 24), tr = b + 24 | 0, t[tr >> 2] = d[l | 0] | d[l + 1 | 0] << 8 | (d[l + 2 | 0] << 16 | d[l + 3 | 0] << 24), t[tr + 4 >> 2] = a, l = w + 39 | 0, a = d[l + 4 | 0] | d[l + 5 | 0] << 8 | (d[l + 6 | 0] << 16 | d[l + 7 | 0] << 24), lr = b + 32 | 0, t[lr >> 2] = d[l | 0] | d[l + 1 | 0] << 8 | (d[l + 2 | 0] << 16 | d[l + 3 | 0] << 24), t[lr + 4 >> 2] = a, l = w + 47 | 0, a = d[l + 4 | 0] | d[l + 5 | 0] << 8 | (d[l + 6 | 0] << 16 | d[l + 7 | 0] << 24), gr = b + 40 | 0, t[gr >> 2] = d[l | 0] | d[l + 1 | 0] << 8 | (d[l + 2 | 0] << 16 | d[l + 3 | 0] << 24), t[gr + 4 >> 2] = a, l = w + 55 | 0, a = d[l + 4 | 0] | d[l + 5 | 0] << 8 | (d[l + 6 | 0] << 16 | d[l + 7 | 0] << 24), pe = b + 48 | 0, t[pe >> 2] = d[l | 0] | d[l + 1 | 0] << 8 | (d[l + 2 | 0] << 16 | d[l + 3 | 0] << 24), t[pe + 4 >> 2] = a, l = b + 56 | 0, c[l | 0] = d[w + 63 | 0], c[n + 2 | 0] = d[n + 130 | 0], y[n >> 1] = E[n + 128 >> 1], b = d[n + 139 | 0] | d[n + 140 | 0] << 8 | (d[n + 141 | 0] << 16 | d[n + 142 | 0] << 24), t[n + 64 >> 2] = d[n + 135 | 0] | d[n + 136 | 0] << 8 | (d[n + 137 | 0] << 16 | d[n + 138 | 0] << 24), t[n + 68 >> 2] = b, b = d[n + 131 | 0] | d[n + 132 | 0] << 8 | (d[n + 133 | 0] << 16 | d[n + 134 | 0] << 24), c[n + 63 | 0] = d[l | 0], a = t[pe + 4 >> 2], l = n + 55 | 0, pe = t[pe >> 2], c[l | 0] = pe, c[l + 1 | 0] = pe >>> 8, c[l + 2 | 0] = pe >>> 16, c[l + 3 | 0] = pe >>> 24, c[l + 4 | 0] = a, c[l + 5 | 0] = a >>> 8, c[l + 6 | 0] = a >>> 16, c[l + 7 | 0] = a >>> 24, a = t[gr + 4 >> 2], l = n + 47 | 0, gr = t[gr >> 2], c[l | 0] = gr, c[l + 1 | 0] = gr >>> 8, c[l + 2 | 0] = gr >>> 16, c[l + 3 | 0] = gr >>> 24, c[l + 4 | 0] = a, c[l + 5 | 0] = a >>> 8, c[l + 6 | 0] = a >>> 16, c[l + 7 | 0] = a >>> 24, a = t[lr + 4 >> 2], l = n + 39 | 0, lr = t[lr >> 2], c[l | 0] = lr, c[l + 1 | 0] = lr >>> 8, c[l + 2 | 0] = lr >>> 16, c[l + 3 | 0] = lr >>> 24, c[l + 4 | 0] = a, c[l + 5 | 0] = a >>> 8, c[l + 6 | 0] = a >>> 16, c[l + 7 | 0] = a >>> 24, a = t[tr + 4 >> 2], l = n + 31 | 0, tr = t[tr >> 2], c[l | 0] = tr, c[l + 1 | 0] = tr >>> 8, c[l + 2 | 0] = tr >>> 16, c[l + 3 | 0] = tr >>> 24, c[l + 4 | 0] = a, c[l + 5 | 0] = a >>> 8, c[l + 6 | 0] = a >>> 16, c[l + 7 | 0] = a >>> 24, a = t[or + 4 >> 2], l = n + 23 | 0, or = t[or >> 2], c[l | 0] = or, c[l + 1 | 0] = or >>> 8, c[l + 2 | 0] = or >>> 16, c[l + 3 | 0] = or >>> 24, c[l + 4 | 0] = a, c[l + 5 | 0] = a >>> 8, c[l + 6 | 0] = a >>> 16, c[l + 7 | 0] = a >>> 24, a = t[Tt + 4 >> 2], l = n + 15 | 0, Tt = t[Tt >> 2], c[l | 0] = Tt, c[l + 1 | 0] = Tt >>> 8, c[l + 2 | 0] = Tt >>> 16, c[l + 3 | 0] = Tt >>> 24, c[l + 4 | 0] = a, c[l + 5 | 0] = a >>> 8, c[l + 6 | 0] = a >>> 16, c[l + 7 | 0] = a >>> 24, c[n + 3 | 0] = b, c[n + 4 | 0] = b >>> 8, c[n + 5 | 0] = b >>> 16, c[n + 6 | 0] = b >>> 24, l = t[n + 68 >> 2], b = t[n + 64 >> 2], c[n + 7 | 0] = b, c[n + 8 | 0] = b >>> 8, c[n + 9 | 0] = b >>> 16, c[n + 10 | 0] = b >>> 24, c[n + 11 | 0] = l, c[n + 12 | 0] = l >>> 8, c[n + 13 | 0] = l >>> 16, c[n + 14 | 0] = l >>> 24, t[Ce >> 2] = 0, t[Ce + 4 >> 2] = 0, t[Me >> 2] = 0, t[Me + 4 >> 2] = 0, t[K >> 2] = 0, t[K + 4 >> 2] = 0, t[nr >> 2] = 0, t[nr + 4 >> 2] = 0, t[Nr >> 2] = 0, t[Nr + 4 >> 2] = 0, t[jr >> 2] = 0, t[jr + 4 >> 2] = 0, t[kr >> 2] = 0, t[kr + 4 >> 2] = 0, t[n + 128 >> 2] = 0, t[n + 132 >> 2] = 0, (Fs(t[172688], w, 690917) | 0) == 1) {
          kr = Et(), P = U - 288 | 0, U = P;
          t: {
            if (!n) {
              yi[t[kr + 168 >> 2]](689629, t[kr + 172 >> 2]);
              break t;
            }
            if (b = d[n + 60 | 0] | d[n + 61 | 0] << 8 | (d[n + 62 | 0] << 16 | d[n + 63 | 0] << 24), w = b >>> 16 | 0, a = P + 72 | 0, l = d[n + 56 | 0] | d[n + 57 | 0] << 8 | (d[n + 58 | 0] << 16 | d[n + 59 | 0] << 24), t[a >> 2] = (b & 65535) << 16 | l >>> 16, t[a + 4 >> 2] = w, Ce = l << 4 & 1048560, b = d[n + 52 | 0] | d[n + 53 | 0] << 8 | (d[n + 54 | 0] << 16 | d[n + 55 | 0] << 24), w = b >>> 28 | 0, a = P - -64 | 0, l = d[n + 48 | 0] | d[n + 49 | 0] << 8 | (d[n + 50 | 0] << 16 | d[n + 51 | 0] << 24), t[a >> 2] = (b & 268435455) << 4 | l >>> 28, t[a + 4 >> 2] = w | Ce, w = b << 24 | l >>> 8, Ce = l << 24 & -16777216, l = d[n + 40 | 0] | d[n + 41 | 0] << 8 | (d[n + 42 | 0] << 16 | d[n + 43 | 0] << 24), a = P + 56 | 0, b = d[n + 44 | 0] | d[n + 45 | 0] << 8 | (d[n + 46 | 0] << 16 | d[n + 47 | 0] << 24), t[a >> 2] = b >>> 8 | Ce, t[a + 4 >> 2] = w & 1048575, b = (b << 12 | l >>> 20) & 1048575, Ce = d[n + 32 | 0] | d[n + 33 | 0] << 8 | (d[n + 34 | 0] << 16 | d[n + 35 | 0] << 24), a = P + 48 | 0, Me = d[n + 36 | 0] | d[n + 37 | 0] << 8 | (d[n + 38 | 0] << 16 | d[n + 39 | 0] << 24), t[a >> 2] = l << 12 & -4096 | Me >>> 20, t[a + 4 >> 2] = b, t[P + 40 >> 2] = Ce, t[P + 44 >> 2] = Me & 1048575, w = d[n + 12 | 0] | d[n + 13 | 0] << 8 | (d[n + 14 | 0] << 16 | d[n + 15 | 0] << 24), a = w, b = d[n + 8 | 0] | d[n + 9 | 0] << 8 | (d[n + 10 | 0] << 16 | d[n + 11 | 0] << 24), w = w << 12 | b >>> 20, Ce = b << 12 & -4096, b = d[n | 0] | d[n + 1 | 0] << 8 | (d[n + 2 | 0] << 16 | d[n + 3 | 0] << 24), l = P, K = d[n + 4 | 0] | d[n + 5 | 0] << 8 | (d[n + 6 | 0] << 16 | d[n + 7 | 0] << 24), Tt = K >>> 20 | Ce, t[l + 8 >> 2] = Tt, or = w & 1048575, t[l + 12 >> 2] = or, Ce = b, t[l >> 2] = b, tr = K & 1048575, t[l + 4 >> 2] = tr, b = d[n + 28 | 0] | d[n + 29 | 0] << 8 | (d[n + 30 | 0] << 16 | d[n + 31 | 0] << 24), w = b >>> 16 | 0, Me = d[n + 24 | 0] | d[n + 25 | 0] << 8 | (d[n + 26 | 0] << 16 | d[n + 27 | 0] << 24), Nr = (b & 65535) << 16 | Me >>> 16, t[l + 32 >> 2] = Nr, nr = w, t[l + 36 >> 2] = w, w = d[n + 20 | 0] | d[n + 21 | 0] << 8 | (d[n + 22 | 0] << 16 | d[n + 23 | 0] << 24), b = d[n + 16 | 0] | d[n + 17 | 0] << 8 | (d[n + 18 | 0] << 16 | d[n + 19 | 0] << 24), gr = (w << 24 | b >>> 8) & 1048575, a = b << 24 & -16777216 | a >>> 8, t[l + 16 >> 2] = a, lr = gr, t[l + 20 >> 2] = lr, Me = Me << 4 & 1048560, l = w, w = l >>> 28 | 0, l = (l & 268435455) << 4 | b >>> 28, t[P + 24 >> 2] = l, w = w | Me, t[P + 28 >> 2] = w, !(Ce | Tt | Nr | a | l | (or | tr | nr | lr | w))) {
              yi[t[kr + 168 >> 2]](690116, t[kr + 172 >> 2]);
              break t;
            }
            if (t[P + 92 >> 2] = 0, Ir(P + 96 | 0, 690949, P + 92 | 0), t[P + 92 >> 2] || (l = P + 8 | 0, b = t[l + 4 >> 2], w = P + 160 | 0, a = w + 8 | 0, t[a >> 2] = t[l >> 2], t[a + 4 >> 2] = b, l = P + 16 | 0, b = t[l + 4 >> 2], a = w + 16 | 0, t[a >> 2] = t[l >> 2], t[a + 4 >> 2] = b, l = P + 24 | 0, b = t[l + 4 >> 2], a = w + 24 | 0, t[a >> 2] = t[l >> 2], t[a + 4 >> 2] = b, l = P + 32 | 0, b = t[l + 4 >> 2], a = w + 32 | 0, t[a >> 2] = t[l >> 2], t[a + 4 >> 2] = b, l = P + 48 | 0, b = t[l + 4 >> 2], a = w + 48 | 0, t[a >> 2] = t[l >> 2], t[a + 4 >> 2] = b, l = P + 56 | 0, b = t[l + 4 >> 2], a = w + 56 | 0, t[a >> 2] = t[l >> 2], t[a + 4 >> 2] = b, l = P - -64 | 0, b = t[l + 4 >> 2], a = w - -64 | 0, t[a >> 2] = t[l >> 2], t[a + 4 >> 2] = b, l = P + 72 | 0, b = t[l + 4 >> 2], a = w + 72 | 0, t[a >> 2] = t[l >> 2], t[a + 4 >> 2] = b, t[P + 280 >> 2] = 0, l = t[P + 4 >> 2], t[P + 160 >> 2] = t[P >> 2], t[P + 164 >> 2] = l, l = t[P + 44 >> 2], t[P + 200 >> 2] = t[P + 40 >> 2], t[P + 204 >> 2] = l, l = P + 248 | 0, t[l >> 2] = 0, t[l + 4 >> 2] = 0, l = P + 256 | 0, t[l >> 2] = 0, t[l + 4 >> 2] = 0, l = P + 264 | 0, t[l >> 2] = 0, t[l + 4 >> 2] = 0, l = P + 272 | 0, t[l >> 2] = 0, t[l + 4 >> 2] = 0, l = P + 128 | 0, b = l + 16 | 0, t[b >> 2] = 0, t[b + 4 >> 2] = 0, b = l + 24 | 0, t[b >> 2] = 0, t[b + 4 >> 2] = 0, t[P + 240 >> 2] = 1, t[P + 244 >> 2] = 0, t[P + 136 >> 2] = 0, t[P + 140 >> 2] = 0, t[P + 128 >> 2] = 1, t[P + 132 >> 2] = 0, xr(w, w, l, P + 96 | 0), t[P + 280 >> 2]) || (Kn(P, P + 160 | 0), b = t[P + 8 >> 2], a = t[P + 12 >> 2], Ce = t[P + 4 >> 2], K = t[P + 32 >> 2], Me = t[P + 36 >> 2], Nr = Me, w = t[P >> 2], l = ri(Me >>> 16 | 0, 0, 977, 1), lr = w + l | 0, w = Ce + ve | 0, nr = l >>> 0 > lr >>> 0 ? w + 1 | 0 : w, w = a, l = nr >>> 20 | 0, a = l, l = l + b | 0, a = a >>> 0 > l >>> 0 ? w + 1 | 0 : w, kr = a & 1048575, jr = t[P + 24 >> 2], Tt = t[P + 28 >> 2], w = t[P + 20 >> 2], b = a >>> 20 | 0, Me = b + t[P + 16 >> 2] | 0, Ce = b >>> 0 > Me >>> 0 ? w + 1 | 0 : w, w = Tt, b = Ce >>> 20 | 0, pe = b, b = b + jr | 0, w = pe >>> 0 > b >>> 0 ? w + 1 | 0 : w, Tt = w & 1048575, Ce = Ce & 1048575, jr = (l & Me & b) == -1 & (a & Ce & w) == 1048575, a = w, w = Nr & 65535, a = a >>> 20 | 0, tr = a + K | 0, w = a >>> 0 > tr >>> 0 ? w + 1 | 0 : w, a = w, or = nr & 1048575, jr & ((tr | 0) == -1 & (w | 0) == 65535) & ((or | 0) == 1048574 & lr >>> 0 > 4294966318 | or >>> 0 > 1048574) | w >>> 16 && (w = or + 1 | 0, lr = lr + 977 | 0, w = lr >>> 0 < 977 ? w + 1 | 0 : w, or = w & 1048575, K = w, w = kr, K = K >>> 20 | 0, l = l + K | 0, w = K >>> 0 > l >>> 0 ? w + 1 | 0 : w, kr = w & 1048575, K = w, w = Ce, K = K >>> 20 | 0, Me = K + Me | 0, w = K >>> 0 > Me >>> 0 ? w + 1 | 0 : w, Ce = w & 1048575, K = w, w = Tt, K = K >>> 20 | 0, b = b + K | 0, w = K >>> 0 > b >>> 0 ? w + 1 | 0 : w, Tt = w & 1048575, K = w, w = a, a = tr, tr = (K >>> 20 | 0) + tr | 0, a = (a >>> 0 > tr >>> 0 ? w + 1 | 0 : w) & 65535), t[P + 32 >> 2] = tr, t[P + 36 >> 2] = a, t[P + 24 >> 2] = b, t[P + 28 >> 2] = Tt, t[P + 16 >> 2] = Me, t[P + 20 >> 2] = Ce, t[P + 8 >> 2] = l, t[P + 12 >> 2] = kr, t[P >> 2] = lr, t[P + 4 >> 2] = or, Nr = t[P + 48 >> 2], jr = t[P + 52 >> 2], pe = t[P + 44 >> 2], K = t[P + 72 >> 2], gr = t[P + 76 >> 2], ui = gr, w = t[P + 40 >> 2], nr = ri(gr >>> 16 | 0, 0, 977, 1), gr = w + nr | 0, w = pe + ve | 0, ei = nr >>> 0 > gr >>> 0 ? w + 1 | 0 : w, w = jr, nr = ei >>> 20 | 0, Nr = nr + Nr | 0, pe = nr >>> 0 > Nr >>> 0 ? w + 1 | 0 : w, di = pe & 1048575, ai = K, Ii = ui & 65535, nr = t[P + 64 >> 2], Yr = t[P + 68 >> 2], w = t[P + 60 >> 2], K = pe >>> 20 | 0, jr = K + t[P + 56 >> 2] | 0, ui = K >>> 0 > jr >>> 0 ? w + 1 | 0 : w, w = Yr, K = ui >>> 20 | 0, Yr = K, K = K + nr | 0, nr = Yr >>> 0 > K >>> 0 ? w + 1 | 0 : w, w = Ii, Yr = nr >>> 20 | 0, Ii = Yr, Yr = ai + Yr | 0, w = Ii >>> 0 > Yr >>> 0 ? w + 1 | 0 : w, ai = ui & 1048575, ei = ei & 1048575, (jr & Nr & K) == -1 & (pe & ai & nr) == 1048575 & ((Yr | 0) == -1 & (w | 0) == 65535) & ((ei | 0) == 1048574 & gr >>> 0 > 4294966318 | ei >>> 0 > 1048574) | w >>> 16 && (w = ei + 1 | 0, gr = gr + 977 | 0, w = gr >>> 0 < 977 ? w + 1 | 0 : w, ei = w & 1048575, pe = w, w = di, pe = pe >>> 20 | 0, Nr = pe + Nr | 0, w = pe >>> 0 > Nr >>> 0 ? w + 1 | 0 : w, di = w & 1048575, pe = w, w = ai, pe = pe >>> 20 | 0, jr = pe + jr | 0, w = pe >>> 0 > jr >>> 0 ? w + 1 | 0 : w, ai = w & 1048575, pe = w, w = nr, pe = pe >>> 20 | 0, K = K + pe | 0, nr = pe >>> 0 > K >>> 0 ? w + 1 | 0 : w), t[P + 56 >> 2] = jr, t[P + 60 >> 2] = ai, t[P + 48 >> 2] = Nr, t[P + 52 >> 2] = di, t[P + 40 >> 2] = gr, t[P + 44 >> 2] = ei, t[P + 64 >> 2] = K, t[P + 68 >> 2] = nr & 1048575, d[690917] != (a >>> 8 & 255)) || d[690918] != (a & 255) || d[690919] != (((a & 16777215) << 8 | tr >>> 24) & 255) || d[690920] != (((a & 65535) << 16 | tr >>> 16) & 255) || d[690921] != (((a & 255) << 24 | tr >>> 8) & 255) || d[690922] != (tr & 255) || d[690923] != (Tt >>> 12 | 0) || d[690924] != (Tt >>> 4 & 255) || d[690925] != (((Tt & 268435455) << 4 | b >>> 28) & 255) || d[690926] != (((Tt & 1048575) << 12 | b >>> 20) & 255) || d[690927] != (((Tt & 4095) << 20 | b >>> 12) & 255) || d[690928] != (((Tt & 15) << 28 | b >>> 4) & 255) || d[690929] != ((b << 4 | Ce >>> 16) & 255) || (w = Ce, d[690930] != (w >>> 8 & 255)) || d[690931] != (w & 255) || d[690932] != (((Ce & 16777215) << 8 | Me >>> 24) & 255) || d[690933] != (((Ce & 65535) << 16 | Me >>> 16) & 255) || d[690934] != (((Ce & 255) << 24 | Me >>> 8) & 255) || d[690935] != (Me & 255) || d[690936] != (kr >>> 12 | 0) || d[690937] != (kr >>> 4 & 255) || d[690938] != (((kr & 268435455) << 4 | l >>> 28) & 255) || d[690939] != (((kr & 1048575) << 12 | l >>> 20) & 255) || d[690940] != (((kr & 4095) << 20 | l >>> 12) & 255) || d[690941] != (((kr & 15) << 28 | l >>> 4) & 255) || d[690942] != ((l << 4 | or >>> 16) & 255) || (w = or, d[690943] != (w >>> 8 & 255)) || d[690944] != (w & 255) || d[690945] != (((or & 16777215) << 8 | lr >>> 24) & 255) || d[690946] != (((or & 65535) << 16 | lr >>> 16) & 255) || d[690947] != (((or & 255) << 24 | lr >>> 8) & 255) || d[690948] != (lr & 255))
              break t;
            wi = (gr & 1) == (C | 0);
          }
          U = P + 288 | 0;
          break e;
        }
        M(1);
        break e;
      }
      M(1);
    }
    return U = n + 192 | 0, wi | 0;
  }
  function yr(C, l) {
    C = C | 0, l = l | 0;
    var w = 0, n = 0, a = 0, b = 0, P = 0, K = 0, pe = 0, Ce = 0, Me = 0, Tt = 0;
    n = U - 208 | 0, U = n, w = n + 136 | 0, b = w + 56 | 0, t[b >> 2] = 0, t[b + 4 >> 2] = 0, b = w + 48 | 0, t[b >> 2] = 0, t[b + 4 >> 2] = 0, b = w + 40 | 0, t[b >> 2] = 0, t[b + 4 >> 2] = 0, b = w + 32 | 0, t[b >> 2] = 0, t[b + 4 >> 2] = 0, b = w + 24 | 0, t[b >> 2] = 0, t[b + 4 >> 2] = 0, b = w + 16 | 0, t[b >> 2] = 0, t[b + 4 >> 2] = 0, b = w + 8 | 0, t[b >> 2] = 0, t[b + 4 >> 2] = 0, t[n + 136 >> 2] = 0, t[n + 140 >> 2] = 0;
    e: {
      if ((Bi(t[172688], w, 690820, C) | 0) == 1) {
        if (w = n + 136 | 0, C = w + 15 | 0, a = d[C + 4 | 0] | d[C + 5 | 0] << 8 | (d[C + 6 | 0] << 16 | d[C + 7 | 0] << 24), b = n + 72 | 0, P = b + 8 | 0, t[P >> 2] = d[C | 0] | d[C + 1 | 0] << 8 | (d[C + 2 | 0] << 16 | d[C + 3 | 0] << 24), t[P + 4 >> 2] = a, C = w + 23 | 0, a = d[C + 4 | 0] | d[C + 5 | 0] << 8 | (d[C + 6 | 0] << 16 | d[C + 7 | 0] << 24), K = b + 16 | 0, t[K >> 2] = d[C | 0] | d[C + 1 | 0] << 8 | (d[C + 2 | 0] << 16 | d[C + 3 | 0] << 24), t[K + 4 >> 2] = a, C = w + 31 | 0, a = d[C + 4 | 0] | d[C + 5 | 0] << 8 | (d[C + 6 | 0] << 16 | d[C + 7 | 0] << 24), pe = b + 24 | 0, t[pe >> 2] = d[C | 0] | d[C + 1 | 0] << 8 | (d[C + 2 | 0] << 16 | d[C + 3 | 0] << 24), t[pe + 4 >> 2] = a, C = w + 39 | 0, a = d[C + 4 | 0] | d[C + 5 | 0] << 8 | (d[C + 6 | 0] << 16 | d[C + 7 | 0] << 24), Ce = b + 32 | 0, t[Ce >> 2] = d[C | 0] | d[C + 1 | 0] << 8 | (d[C + 2 | 0] << 16 | d[C + 3 | 0] << 24), t[Ce + 4 >> 2] = a, C = w + 47 | 0, a = d[C + 4 | 0] | d[C + 5 | 0] << 8 | (d[C + 6 | 0] << 16 | d[C + 7 | 0] << 24), Me = b + 40 | 0, t[Me >> 2] = d[C | 0] | d[C + 1 | 0] << 8 | (d[C + 2 | 0] << 16 | d[C + 3 | 0] << 24), t[Me + 4 >> 2] = a, C = w + 55 | 0, a = d[C + 4 | 0] | d[C + 5 | 0] << 8 | (d[C + 6 | 0] << 16 | d[C + 7 | 0] << 24), Tt = b + 48 | 0, t[Tt >> 2] = d[C | 0] | d[C + 1 | 0] << 8 | (d[C + 2 | 0] << 16 | d[C + 3 | 0] << 24), t[Tt + 4 >> 2] = a, a = b + 56 | 0, c[a | 0] = d[w + 63 | 0], c[n + 10 | 0] = d[n + 138 | 0], y[n + 8 >> 1] = E[n + 136 >> 1], C = d[n + 147 | 0] | d[n + 148 | 0] << 8 | (d[n + 149 | 0] << 16 | d[n + 150 | 0] << 24), t[n + 72 >> 2] = d[n + 143 | 0] | d[n + 144 | 0] << 8 | (d[n + 145 | 0] << 16 | d[n + 146 | 0] << 24), t[n + 76 >> 2] = C, b = d[n + 139 | 0] | d[n + 140 | 0] << 8 | (d[n + 141 | 0] << 16 | d[n + 142 | 0] << 24), C = n + 8 | 0, c[C + 63 | 0] = d[a | 0], a = t[Tt + 4 >> 2], w = C + 55 | 0, Tt = t[Tt >> 2], c[w | 0] = Tt, c[w + 1 | 0] = Tt >>> 8, c[w + 2 | 0] = Tt >>> 16, c[w + 3 | 0] = Tt >>> 24, c[w + 4 | 0] = a, c[w + 5 | 0] = a >>> 8, c[w + 6 | 0] = a >>> 16, c[w + 7 | 0] = a >>> 24, a = t[Me + 4 >> 2], w = C + 47 | 0, Me = t[Me >> 2], c[w | 0] = Me, c[w + 1 | 0] = Me >>> 8, c[w + 2 | 0] = Me >>> 16, c[w + 3 | 0] = Me >>> 24, c[w + 4 | 0] = a, c[w + 5 | 0] = a >>> 8, c[w + 6 | 0] = a >>> 16, c[w + 7 | 0] = a >>> 24, a = t[Ce + 4 >> 2], w = C + 39 | 0, Ce = t[Ce >> 2], c[w | 0] = Ce, c[w + 1 | 0] = Ce >>> 8, c[w + 2 | 0] = Ce >>> 16, c[w + 3 | 0] = Ce >>> 24, c[w + 4 | 0] = a, c[w + 5 | 0] = a >>> 8, c[w + 6 | 0] = a >>> 16, c[w + 7 | 0] = a >>> 24, a = t[pe + 4 >> 2], w = C + 31 | 0, pe = t[pe >> 2], c[w | 0] = pe, c[w + 1 | 0] = pe >>> 8, c[w + 2 | 0] = pe >>> 16, c[w + 3 | 0] = pe >>> 24, c[w + 4 | 0] = a, c[w + 5 | 0] = a >>> 8, c[w + 6 | 0] = a >>> 16, c[w + 7 | 0] = a >>> 24, a = t[K + 4 >> 2], w = C + 23 | 0, K = t[K >> 2], c[w | 0] = K, c[w + 1 | 0] = K >>> 8, c[w + 2 | 0] = K >>> 16, c[w + 3 | 0] = K >>> 24, c[w + 4 | 0] = a, c[w + 5 | 0] = a >>> 8, c[w + 6 | 0] = a >>> 16, c[w + 7 | 0] = a >>> 24, a = t[P + 4 >> 2], w = C + 15 | 0, P = t[P >> 2], c[w | 0] = P, c[w + 1 | 0] = P >>> 8, c[w + 2 | 0] = P >>> 16, c[w + 3 | 0] = P >>> 24, c[w + 4 | 0] = a, c[w + 5 | 0] = a >>> 8, c[w + 6 | 0] = a >>> 16, c[w + 7 | 0] = a >>> 24, c[n + 11 | 0] = b, c[n + 12 | 0] = b >>> 8, c[n + 13 | 0] = b >>> 16, c[n + 14 | 0] = b >>> 24, w = t[n + 76 >> 2], b = t[n + 72 >> 2], c[n + 15 | 0] = b, c[n + 16 | 0] = b >>> 8, c[n + 17 | 0] = b >>> 16, c[n + 18 | 0] = b >>> 24, c[n + 19 | 0] = w, c[n + 20 | 0] = w >>> 8, c[n + 21 | 0] = w >>> 16, c[n + 22 | 0] = w >>> 24, t[n + 204 >> 2] = l, C = Lr(t[172688], n + 204 | 0, C, (l | 0) == 33 ? 258 : 2), t[n + 72 >> 2] = C, (C | 0) == 1)
          break e;
        t[n + 144 >> 2] = 0, Ne(n + 136 | 0), wasm2js_trap();
      }
      M(1);
    }
    U = n + 208 | 0;
  }
  function wr(C) {
    C = C | 0;
    var l = 0, w = 0, n = 0, a = 0, b = 0, P = 0, K = 0, pe = 0, Ce = 0, Me = 0, Tt = 0, tr = 0, nr = 0, or = 0, lr = 0, gr = 0;
    w = U - 96 | 0, U = w, l = w + 56 | 0, t[l >> 2] = 0, t[l + 4 >> 2] = 0, l = w + 48 | 0, t[l >> 2] = 0, t[l + 4 >> 2] = 0, l = w + 40 | 0, t[l >> 2] = 0, t[l + 4 >> 2] = 0, l = w + 32 | 0, t[l >> 2] = 0, t[l + 4 >> 2] = 0, l = w + 24 | 0, t[l >> 2] = 0, t[l + 4 >> 2] = 0, l = w + 16 | 0, t[l >> 2] = 0, t[l + 4 >> 2] = 0, l = w + 8 | 0, t[l >> 2] = 0, t[l + 4 >> 2] = 0, t[w >> 2] = 0, t[w + 4 >> 2] = 0, a = Et(), n = U - 256 | 0, U = n;
    e: {
      if (!w) {
        yi[t[a + 168 >> 2]](689638, t[a + 172 >> 2]), l = 0;
        break e;
      }
      if (c[w | 0] = 0, c[w + 1 | 0] = 0, c[w + 2 | 0] = 0, c[w + 3 | 0] = 0, c[w + 4 | 0] = 0, c[w + 5 | 0] = 0, c[w + 6 | 0] = 0, c[w + 7 | 0] = 0, l = w + 56 | 0, c[l | 0] = 0, c[l + 1 | 0] = 0, c[l + 2 | 0] = 0, c[l + 3 | 0] = 0, c[l + 4 | 0] = 0, c[l + 5 | 0] = 0, c[l + 6 | 0] = 0, c[l + 7 | 0] = 0, l = w + 48 | 0, c[l | 0] = 0, c[l + 1 | 0] = 0, c[l + 2 | 0] = 0, c[l + 3 | 0] = 0, c[l + 4 | 0] = 0, c[l + 5 | 0] = 0, c[l + 6 | 0] = 0, c[l + 7 | 0] = 0, l = w + 40 | 0, c[l | 0] = 0, c[l + 1 | 0] = 0, c[l + 2 | 0] = 0, c[l + 3 | 0] = 0, c[l + 4 | 0] = 0, c[l + 5 | 0] = 0, c[l + 6 | 0] = 0, c[l + 7 | 0] = 0, l = w + 32 | 0, c[l | 0] = 0, c[l + 1 | 0] = 0, c[l + 2 | 0] = 0, c[l + 3 | 0] = 0, c[l + 4 | 0] = 0, c[l + 5 | 0] = 0, c[l + 6 | 0] = 0, c[l + 7 | 0] = 0, l = w + 24 | 0, c[l | 0] = 0, c[l + 1 | 0] = 0, c[l + 2 | 0] = 0, c[l + 3 | 0] = 0, c[l + 4 | 0] = 0, c[l + 5 | 0] = 0, c[l + 6 | 0] = 0, c[l + 7 | 0] = 0, l = w + 16 | 0, c[l | 0] = 0, c[l + 1 | 0] = 0, c[l + 2 | 0] = 0, c[l + 3 | 0] = 0, c[l + 4 | 0] = 0, c[l + 5 | 0] = 0, c[l + 6 | 0] = 0, c[l + 7 | 0] = 0, l = w + 8 | 0, c[l | 0] = 0, c[l + 1 | 0] = 0, c[l + 2 | 0] = 0, c[l + 3 | 0] = 0, c[l + 4 | 0] = 0, c[l + 5 | 0] = 0, c[l + 6 | 0] = 0, c[l + 7 | 0] = 0, !t[a >> 2]) {
        yi[t[a + 168 >> 2]](690045, t[a + 172 >> 2]), l = 0;
        break e;
      }
      pe = n + 8 | 0, P = n + 128 | 0, Ir(pe, 690788, P), Ce = t[n + 32 >> 2], Me = t[n + 24 >> 2], b = t[n + 16 >> 2], Tt = t[n + 8 >> 2], tr = t[n + 36 >> 2], nr = t[n + 28 >> 2], or = t[n + 20 >> 2], lr = t[n + 12 >> 2], K = t[n + 128 >> 2] | !(Ce | (Me | (b | Tt)) | (tr | (nr | (or | lr)))), l = K ? 0 : -1, t[n + 32 >> 2] = l & Ce, t[n + 36 >> 2] = l & tr, t[n + 24 >> 2] = l & Me, t[n + 28 >> 2] = l & nr, t[n + 16 >> 2] = l & b, t[n + 20 >> 2] = l & or, b = (K | 0) != 0, t[n + 8 >> 2] = b | l & Tt, t[n + 12 >> 2] = l & lr, zi(a, P, pe), l = n + 40 | 0, Kn(l, P), ti(w, l), t[n + 128 >> 2] = b, l = t[n + 128 >> 2] - 1 | 0, c[w | 0] = l & d[w | 0], c[w + 1 | 0] = d[w + 1 | 0] & l, c[w + 2 | 0] = d[w + 2 | 0] & l, c[w + 3 | 0] = d[w + 3 | 0] & l, c[w + 4 | 0] = d[w + 4 | 0] & l, c[w + 5 | 0] = d[w + 5 | 0] & l, c[w + 6 | 0] = d[w + 6 | 0] & l, c[w + 7 | 0] = d[w + 7 | 0] & l, c[w + 8 | 0] = d[w + 8 | 0] & l, c[w + 9 | 0] = d[w + 9 | 0] & l, c[w + 10 | 0] = d[w + 10 | 0] & l, c[w + 11 | 0] = d[w + 11 | 0] & l, c[w + 12 | 0] = d[w + 12 | 0] & l, c[w + 13 | 0] = d[w + 13 | 0] & l, c[w + 14 | 0] = d[w + 14 | 0] & l, c[w + 15 | 0] = d[w + 15 | 0] & l, c[w + 16 | 0] = d[w + 16 | 0] & l, c[w + 17 | 0] = d[w + 17 | 0] & l, c[w + 18 | 0] = d[w + 18 | 0] & l, c[w + 19 | 0] = d[w + 19 | 0] & l, c[w + 20 | 0] = d[w + 20 | 0] & l, c[w + 21 | 0] = d[w + 21 | 0] & l, c[w + 22 | 0] = d[w + 22 | 0] & l, c[w + 23 | 0] = d[w + 23 | 0] & l, c[w + 24 | 0] = d[w + 24 | 0] & l, c[w + 25 | 0] = d[w + 25 | 0] & l, c[w + 26 | 0] = d[w + 26 | 0] & l, c[w + 27 | 0] = d[w + 27 | 0] & l, c[w + 28 | 0] = d[w + 28 | 0] & l, c[w + 29 | 0] = d[w + 29 | 0] & l, c[w + 30 | 0] = d[w + 30 | 0] & l, c[w + 31 | 0] = d[w + 31 | 0] & l, c[w + 32 | 0] = d[w + 32 | 0] & l, c[w + 33 | 0] = d[w + 33 | 0] & l, c[w + 34 | 0] = d[w + 34 | 0] & l, c[w + 35 | 0] = d[w + 35 | 0] & l, c[w + 36 | 0] = d[w + 36 | 0] & l, c[w + 37 | 0] = d[w + 37 | 0] & l, c[w + 38 | 0] = d[w + 38 | 0] & l, c[w + 39 | 0] = d[w + 39 | 0] & l, c[w + 40 | 0] = d[w + 40 | 0] & l, c[w + 41 | 0] = d[w + 41 | 0] & l, c[w + 42 | 0] = d[w + 42 | 0] & l, c[w + 43 | 0] = d[w + 43 | 0] & l, c[w + 44 | 0] = d[w + 44 | 0] & l, c[w + 45 | 0] = d[w + 45 | 0] & l, c[w + 46 | 0] = d[w + 46 | 0] & l, c[w + 47 | 0] = d[w + 47 | 0] & l, c[w + 48 | 0] = d[w + 48 | 0] & l, c[w + 49 | 0] = d[w + 49 | 0] & l, c[w + 50 | 0] = d[w + 50 | 0] & l, c[w + 51 | 0] = d[w + 51 | 0] & l, c[w + 52 | 0] = d[w + 52 | 0] & l, c[w + 53 | 0] = d[w + 53 | 0] & l, c[w + 54 | 0] = d[w + 54 | 0] & l, c[w + 55 | 0] = d[w + 55 | 0] & l, c[w + 56 | 0] = d[w + 56 | 0] & l, c[w + 57 | 0] = d[w + 57 | 0] & l, c[w + 58 | 0] = d[w + 58 | 0] & l, c[w + 59 | 0] = d[w + 59 | 0] & l, c[w + 60 | 0] = d[w + 60 | 0] & l, c[w + 61 | 0] = d[w + 61 | 0] & l, c[w + 62 | 0] = d[w + 62 | 0] & l, c[w + 63 | 0] = d[w + 63 | 0] & l, l = !K;
    }
    U = n + 256 | 0;
    e: {
      if (l) {
        if (t[w + 64 >> 2] = C, C = Lr(t[172688], w - -64 | 0, w, (C | 0) == 33 ? 258 : 2), t[w + 68 >> 2] = C, (C | 0) != 1)
          break e;
        gr = 1;
      }
      return U = w + 96 | 0, gr | 0;
    }
    t[w + 80 >> 2] = 0, Ne(w + 72 | 0), wasm2js_trap();
  }
  function qr() {
    var C = 0, l = 0, w = 0, n = 0, a = 0, b = 0, P = 0, K = 0, pe = 0, Ce = 0, Me = 0, Tt = 0, tr = 0, nr = 0, or = 0, lr = 0, gr = 0, kr = 0, Nr = 0, jr = 0, Yr = 0, ei = 0, ai = 0, ui = 0, di = 0, Ii = 0, wi = 0, Ei = 0;
    n = U - 304 | 0, U = n, w = n + 200 | 0, is(w, 96);
    e: {
      t: {
        r: {
          if ((ci(Et(), w) | 0) == 1) {
            c[n + 10 | 0] = d[n + 202 | 0], y[n + 8 >> 1] = E[n + 200 >> 1], w = d[n + 203 | 0] | d[n + 204 | 0] << 8 | (d[n + 205 | 0] << 16 | d[n + 206 | 0] << 24), C = n + 104 | 0, b = n + 200 | 0, as(C, b | 7, 89), l = n + 8 | 0, as(l | 7, C, 89), c[n + 11 | 0] = w, c[n + 12 | 0] = w >>> 8, c[n + 13 | 0] = w >>> 16, c[n + 14 | 0] = w >>> 24, w = n + 256 | 0, t[w >> 2] = 0, t[w + 4 >> 2] = 0, w = n + 248 | 0, t[w >> 2] = 0, t[w + 4 >> 2] = 0, w = n + 240 | 0, t[w >> 2] = 0, t[w + 4 >> 2] = 0, w = n + 232 | 0, t[w >> 2] = 0, t[w + 4 >> 2] = 0, w = n + 224 | 0, t[w >> 2] = 0, t[w + 4 >> 2] = 0, w = n + 216 | 0, t[w >> 2] = 0, t[w + 4 >> 2] = 0, w = n + 208 | 0, t[w >> 2] = 0, t[w + 4 >> 2] = 0, t[n + 200 >> 2] = 0, t[n + 204 >> 2] = 0, t[n + 196 >> 2] = 0, Me = Et(), lr = n + 196 | 0, w = U - 96 | 0, U = w;
            i: {
              if (!b) {
                yi[t[Me + 168 >> 2]](689638, t[Me + 172 >> 2]), C = 0;
                break i;
              }
              if (c[b | 0] = 0, c[b + 1 | 0] = 0, c[b + 2 | 0] = 0, c[b + 3 | 0] = 0, c[b + 4 | 0] = 0, c[b + 5 | 0] = 0, c[b + 6 | 0] = 0, c[b + 7 | 0] = 0, C = b + 56 | 0, c[C | 0] = 0, c[C + 1 | 0] = 0, c[C + 2 | 0] = 0, c[C + 3 | 0] = 0, c[C + 4 | 0] = 0, c[C + 5 | 0] = 0, c[C + 6 | 0] = 0, c[C + 7 | 0] = 0, C = b + 48 | 0, c[C | 0] = 0, c[C + 1 | 0] = 0, c[C + 2 | 0] = 0, c[C + 3 | 0] = 0, c[C + 4 | 0] = 0, c[C + 5 | 0] = 0, c[C + 6 | 0] = 0, c[C + 7 | 0] = 0, C = b + 40 | 0, c[C | 0] = 0, c[C + 1 | 0] = 0, c[C + 2 | 0] = 0, c[C + 3 | 0] = 0, c[C + 4 | 0] = 0, c[C + 5 | 0] = 0, c[C + 6 | 0] = 0, c[C + 7 | 0] = 0, C = b + 32 | 0, c[C | 0] = 0, c[C + 1 | 0] = 0, c[C + 2 | 0] = 0, c[C + 3 | 0] = 0, c[C + 4 | 0] = 0, c[C + 5 | 0] = 0, c[C + 6 | 0] = 0, c[C + 7 | 0] = 0, C = b + 24 | 0, c[C | 0] = 0, c[C + 1 | 0] = 0, c[C + 2 | 0] = 0, c[C + 3 | 0] = 0, c[C + 4 | 0] = 0, c[C + 5 | 0] = 0, c[C + 6 | 0] = 0, c[C + 7 | 0] = 0, C = b + 16 | 0, c[C | 0] = 0, c[C + 1 | 0] = 0, c[C + 2 | 0] = 0, c[C + 3 | 0] = 0, c[C + 4 | 0] = 0, c[C + 5 | 0] = 0, c[C + 6 | 0] = 0, c[C + 7 | 0] = 0, C = b + 8 | 0, c[C | 0] = 0, c[C + 1 | 0] = 0, c[C + 2 | 0] = 0, c[C + 3 | 0] = 0, c[C + 4 | 0] = 0, c[C + 5 | 0] = 0, c[C + 6 | 0] = 0, c[C + 7 | 0] = 0, !l) {
                yi[t[Me + 168 >> 2]](689700, t[Me + 172 >> 2]), C = 0;
                break i;
              }
              if (Tt = d[l + 92 | 0] | d[l + 93 | 0] << 8 | (d[l + 94 | 0] << 16 | d[l + 95 | 0] << 24), C = Tt >>> 16 | 0, P = w + 80 | 0, K = d[l + 88 | 0] | d[l + 89 | 0] << 8 | (d[l + 90 | 0] << 16 | d[l + 91 | 0] << 24), Tt = (Tt & 65535) << 16 | K >>> 16, t[P >> 2] = Tt, di = C, t[P + 4 >> 2] = C, Ce = K << 4 & 1048560, a = d[l + 84 | 0] | d[l + 85 | 0] << 8 | (d[l + 86 | 0] << 16 | d[l + 87 | 0] << 24), C = a >>> 28 | 0, P = w + 72 | 0, K = d[l + 80 | 0] | d[l + 81 | 0] << 8 | (d[l + 82 | 0] << 16 | d[l + 83 | 0] << 24), tr = (a & 268435455) << 4 | K >>> 28, t[P >> 2] = tr, gr = C | Ce, t[P + 4 >> 2] = gr, C = a << 24 | K >>> 8, pe = K << 24 & -16777216, K = d[l + 72 | 0] | d[l + 73 | 0] << 8 | (d[l + 74 | 0] << 16 | d[l + 75 | 0] << 24), Ce = w + 8 | 0, P = Ce + 56 | 0, a = d[l + 76 | 0] | d[l + 77 | 0] << 8 | (d[l + 78 | 0] << 16 | d[l + 79 | 0] << 24), nr = a >>> 8 | pe, t[P >> 2] = nr, kr = C & 1048575, t[P + 4 >> 2] = kr, C = K, a = a << 12 | C >>> 20, K = d[l + 64 | 0] | d[l + 65 | 0] << 8 | (d[l + 66 | 0] << 16 | d[l + 67 | 0] << 24), P = Ce + 48 | 0, pe = d[l + 68 | 0] | d[l + 69 | 0] << 8 | (d[l + 70 | 0] << 16 | d[l + 71 | 0] << 24), or = C << 12 & -4096 | pe >>> 20, t[P >> 2] = or, Nr = a & 1048575, t[P + 4 >> 2] = Nr, t[w + 88 >> 2] = 0, t[w + 48 >> 2] = K, jr = pe & 1048575, t[w + 52 >> 2] = jr, C = d[l + 44 | 0] | d[l + 45 | 0] << 8 | (d[l + 46 | 0] << 16 | d[l + 47 | 0] << 24), P = C, a = d[l + 40 | 0] | d[l + 41 | 0] << 8 | (d[l + 42 | 0] << 16 | d[l + 43 | 0] << 24), pe = (C << 12 | a >>> 20) & 1048575, C = d[l + 32 | 0] | d[l + 33 | 0] << 8 | (d[l + 34 | 0] << 16 | d[l + 35 | 0] << 24), Ce = a << 12 & -4096, a = d[l + 36 | 0] | d[l + 37 | 0] << 8 | (d[l + 38 | 0] << 16 | d[l + 39 | 0] << 24), Yr = Ce | a >>> 20, t[w + 16 >> 2] = Yr, Ii = pe, t[w + 20 >> 2] = pe, Ce = C, t[w + 8 >> 2] = C, ei = a & 1048575, t[w + 12 >> 2] = ei, a = d[l + 60 | 0] | d[l + 61 | 0] << 8 | (d[l + 62 | 0] << 16 | d[l + 63 | 0] << 24), C = a >>> 16 | 0, pe = d[l + 56 | 0] | d[l + 57 | 0] << 8 | (d[l + 58 | 0] << 16 | d[l + 59 | 0] << 24), ai = (a & 65535) << 16 | pe >>> 16, t[w + 40 >> 2] = ai, wi = C, t[w + 44 >> 2] = C, a = d[l + 48 | 0] | d[l + 49 | 0] << 8 | (d[l + 50 | 0] << 16 | d[l + 51 | 0] << 24), C = d[l + 52 | 0] | d[l + 53 | 0] << 8 | (d[l + 54 | 0] << 16 | d[l + 55 | 0] << 24), l = C, ui = (C << 24 | a >>> 8) & 1048575, P = a << 24 & -16777216 | P >>> 8, t[w + 24 >> 2] = P, t[w + 28 >> 2] = ui, pe = pe << 4 & 1048560, C = C >>> 28 | 0, a = (l & 268435455) << 4 | a >>> 28, t[w + 32 >> 2] = a, C = C | pe, t[w + 36 >> 2] = C, !(Ce | Yr | ai | P | a | (Ii | ei | wi | ui | C))) {
                yi[t[Me + 168 >> 2]](690116, t[Me + 172 >> 2]), C = 0;
                break i;
              }
              K & 1 && (t[w + 80 >> 2] = -4 - Tt, t[w + 84 >> 2] = 262143 - ((Tt >>> 0 > 4294967292) + di | 0), t[w + 72 >> 2] = -4 - tr, t[w + 76 >> 2] = 4194303 - ((tr >>> 0 > 4294967292) + gr | 0), t[w + 64 >> 2] = -4 - nr, t[w + 68 >> 2] = 4194303 - ((nr >>> 0 > 4294967292) + kr | 0), t[w + 56 >> 2] = -4 - or, t[w + 60 >> 2] = 4194303 - ((or >>> 0 > 4294967292) + Nr | 0), t[w + 48 >> 2] = -3908 - K, t[w + 52 >> 2] = 4194299 - ((K >>> 0 > 4294963388) + jr | 0), Ei = 1), lr && (t[lr >> 2] = Ei), ti(b, w + 8 | 0), C = 1;
            }
            if (U = w + 96 | 0, t[n + 300 >> 2] = C, (C | 0) == 1)
              break r;
            break e;
          }
          M(0);
          break t;
        }
        if (w = ii(t[172688], n + 200 | 0), t[n + 300 >> 2] = w, C = 1, (w | 0) == 1)
          break t;
        break e;
      }
      return U = n + 304 | 0, C | 0;
    }
    t[n + 112 >> 2] = 0, Ne(n + 104 | 0), wasm2js_trap();
  }
  function Mr(C) {
    C = C | 0;
    var l = 0, w = 0, n = 0, a = 0, b = 0, P = 0, K = 0, pe = 0, Ce = 0, Me = 0, Tt = 0, tr = 0, nr = 0, or = 0, lr = 0, gr = 0;
    n = U - 272 | 0, U = n, l = n + 8 | 0, a = l + 56 | 0, t[a >> 2] = 0, t[a + 4 >> 2] = 0, w = l + 48 | 0, t[w >> 2] = 0, t[w + 4 >> 2] = 0, b = l + 40 | 0, t[b >> 2] = 0, t[b + 4 >> 2] = 0, P = l + 32 | 0, t[P >> 2] = 0, t[P + 4 >> 2] = 0, K = l + 24 | 0, t[K >> 2] = 0, t[K + 4 >> 2] = 0, pe = l + 16 | 0, t[pe >> 2] = 0, t[pe + 4 >> 2] = 0, Ce = l + 8 | 0, t[Ce >> 2] = 0, t[Ce + 4 >> 2] = 0, t[n + 8 >> 2] = 0, t[n + 12 >> 2] = 0, t[n + 76 >> 2] = 0, l = n + 208 | 0, Me = l + 56 | 0, t[Me >> 2] = 0, t[Me + 4 >> 2] = 0, Tt = l + 48 | 0, t[Tt >> 2] = 0, t[Tt + 4 >> 2] = 0, tr = l + 40 | 0, t[tr >> 2] = 0, t[tr + 4 >> 2] = 0, nr = l + 32 | 0, t[nr >> 2] = 0, t[nr + 4 >> 2] = 0, or = l + 24 | 0, t[or >> 2] = 0, t[or + 4 >> 2] = 0, lr = l + 16 | 0, t[lr >> 2] = 0, t[lr + 4 >> 2] = 0, gr = l + 8 | 0, t[gr >> 2] = 0, t[gr + 4 >> 2] = 0, t[n + 208 >> 2] = 0, t[n + 212 >> 2] = 0;
    e: {
      t: {
        if ((Bi(t[172688], l, 690820, C) | 0) == 1) {
          if (l = n + 208 | 0, C = l + 15 | 0, w = d[C + 4 | 0] | d[C + 5 | 0] << 8 | (d[C + 6 | 0] << 16 | d[C + 7 | 0] << 24), a = n + 144 | 0, b = a + 8 | 0, t[b >> 2] = d[C | 0] | d[C + 1 | 0] << 8 | (d[C + 2 | 0] << 16 | d[C + 3 | 0] << 24), t[b + 4 >> 2] = w, C = l + 23 | 0, w = d[C + 4 | 0] | d[C + 5 | 0] << 8 | (d[C + 6 | 0] << 16 | d[C + 7 | 0] << 24), P = a + 16 | 0, t[P >> 2] = d[C | 0] | d[C + 1 | 0] << 8 | (d[C + 2 | 0] << 16 | d[C + 3 | 0] << 24), t[P + 4 >> 2] = w, C = l + 31 | 0, w = d[C + 4 | 0] | d[C + 5 | 0] << 8 | (d[C + 6 | 0] << 16 | d[C + 7 | 0] << 24), K = a + 24 | 0, t[K >> 2] = d[C | 0] | d[C + 1 | 0] << 8 | (d[C + 2 | 0] << 16 | d[C + 3 | 0] << 24), t[K + 4 >> 2] = w, C = l + 39 | 0, w = d[C + 4 | 0] | d[C + 5 | 0] << 8 | (d[C + 6 | 0] << 16 | d[C + 7 | 0] << 24), pe = a + 32 | 0, t[pe >> 2] = d[C | 0] | d[C + 1 | 0] << 8 | (d[C + 2 | 0] << 16 | d[C + 3 | 0] << 24), t[pe + 4 >> 2] = w, C = l + 47 | 0, w = d[C + 4 | 0] | d[C + 5 | 0] << 8 | (d[C + 6 | 0] << 16 | d[C + 7 | 0] << 24), Ce = a + 40 | 0, t[Ce >> 2] = d[C | 0] | d[C + 1 | 0] << 8 | (d[C + 2 | 0] << 16 | d[C + 3 | 0] << 24), t[Ce + 4 >> 2] = w, C = l + 55 | 0, w = d[C + 4 | 0] | d[C + 5 | 0] << 8 | (d[C + 6 | 0] << 16 | d[C + 7 | 0] << 24), Me = a + 48 | 0, t[Me >> 2] = d[C | 0] | d[C + 1 | 0] << 8 | (d[C + 2 | 0] << 16 | d[C + 3 | 0] << 24), t[Me + 4 >> 2] = w, w = a + 56 | 0, c[w | 0] = d[l + 63 | 0], c[n + 82 | 0] = d[n + 210 | 0], y[n + 80 >> 1] = E[n + 208 >> 1], C = d[n + 219 | 0] | d[n + 220 | 0] << 8 | (d[n + 221 | 0] << 16 | d[n + 222 | 0] << 24), t[n + 144 >> 2] = d[n + 215 | 0] | d[n + 216 | 0] << 8 | (d[n + 217 | 0] << 16 | d[n + 218 | 0] << 24), t[n + 148 >> 2] = C, a = d[n + 211 | 0] | d[n + 212 | 0] << 8 | (d[n + 213 | 0] << 16 | d[n + 214 | 0] << 24), C = n + 80 | 0, c[C + 63 | 0] = d[w | 0], w = t[Me + 4 >> 2], l = C + 55 | 0, Me = t[Me >> 2], c[l | 0] = Me, c[l + 1 | 0] = Me >>> 8, c[l + 2 | 0] = Me >>> 16, c[l + 3 | 0] = Me >>> 24, c[l + 4 | 0] = w, c[l + 5 | 0] = w >>> 8, c[l + 6 | 0] = w >>> 16, c[l + 7 | 0] = w >>> 24, w = t[Ce + 4 >> 2], l = C + 47 | 0, Ce = t[Ce >> 2], c[l | 0] = Ce, c[l + 1 | 0] = Ce >>> 8, c[l + 2 | 0] = Ce >>> 16, c[l + 3 | 0] = Ce >>> 24, c[l + 4 | 0] = w, c[l + 5 | 0] = w >>> 8, c[l + 6 | 0] = w >>> 16, c[l + 7 | 0] = w >>> 24, w = t[pe + 4 >> 2], l = C + 39 | 0, pe = t[pe >> 2], c[l | 0] = pe, c[l + 1 | 0] = pe >>> 8, c[l + 2 | 0] = pe >>> 16, c[l + 3 | 0] = pe >>> 24, c[l + 4 | 0] = w, c[l + 5 | 0] = w >>> 8, c[l + 6 | 0] = w >>> 16, c[l + 7 | 0] = w >>> 24, w = t[K + 4 >> 2], l = C + 31 | 0, K = t[K >> 2], c[l | 0] = K, c[l + 1 | 0] = K >>> 8, c[l + 2 | 0] = K >>> 16, c[l + 3 | 0] = K >>> 24, c[l + 4 | 0] = w, c[l + 5 | 0] = w >>> 8, c[l + 6 | 0] = w >>> 16, c[l + 7 | 0] = w >>> 24, w = t[P + 4 >> 2], l = C + 23 | 0, P = t[P >> 2], c[l | 0] = P, c[l + 1 | 0] = P >>> 8, c[l + 2 | 0] = P >>> 16, c[l + 3 | 0] = P >>> 24, c[l + 4 | 0] = w, c[l + 5 | 0] = w >>> 8, c[l + 6 | 0] = w >>> 16, c[l + 7 | 0] = w >>> 24, w = t[b + 4 >> 2], l = C + 15 | 0, b = t[b >> 2], c[l | 0] = b, c[l + 1 | 0] = b >>> 8, c[l + 2 | 0] = b >>> 16, c[l + 3 | 0] = b >>> 24, c[l + 4 | 0] = w, c[l + 5 | 0] = w >>> 8, c[l + 6 | 0] = w >>> 16, c[l + 7 | 0] = w >>> 24, c[n + 83 | 0] = a, c[n + 84 | 0] = a >>> 8, c[n + 85 | 0] = a >>> 16, c[n + 86 | 0] = a >>> 24, l = t[n + 148 >> 2], a = t[n + 144 >> 2], c[n + 87 | 0] = a, c[n + 88 | 0] = a >>> 8, c[n + 89 | 0] = a >>> 16, c[n + 90 | 0] = a >>> 24, c[n + 91 | 0] = l, c[n + 92 | 0] = l >>> 8, c[n + 93 | 0] = l >>> 16, c[n + 94 | 0] = l >>> 24, C = Ai(Et(), n + 8 | 0, n + 76 | 0, C), t[n + 144 >> 2] = C, (C | 0) != 1)
            break e;
          C = n + 8 | 0, a = C + 8 | 0, w = t[a + 4 >> 2], l = n + 208 | 0, b = l + 8 | 0, t[b >> 2] = t[a >> 2], t[b + 4 >> 2] = w, a = C + 16 | 0, w = t[a + 4 >> 2], b = l + 16 | 0, t[b >> 2] = t[a >> 2], t[b + 4 >> 2] = w, a = C + 24 | 0, w = t[a + 4 >> 2], b = l + 24 | 0, t[b >> 2] = t[a >> 2], t[b + 4 >> 2] = w, a = C + 32 | 0, w = t[a + 4 >> 2], b = l + 32 | 0, t[b >> 2] = t[a >> 2], t[b + 4 >> 2] = w, a = C + 40 | 0, w = t[a + 4 >> 2], b = l + 40 | 0, t[b >> 2] = t[a >> 2], t[b + 4 >> 2] = w, a = C + 48 | 0, w = t[a + 4 >> 2], b = l + 48 | 0, t[b >> 2] = t[a >> 2], t[b + 4 >> 2] = w, C = C + 56 | 0, a = t[C + 4 >> 2], l = l + 56 | 0, t[l >> 2] = t[C >> 2], t[l + 4 >> 2] = a;
          break t;
        }
        M(1), C = t[a + 4 >> 2], t[Me >> 2] = t[a >> 2], t[Me + 4 >> 2] = C, C = t[w + 4 >> 2], t[Tt >> 2] = t[w >> 2], t[Tt + 4 >> 2] = C, C = t[b + 4 >> 2], t[tr >> 2] = t[b >> 2], t[tr + 4 >> 2] = C, C = t[P + 4 >> 2], t[nr >> 2] = t[P >> 2], t[nr + 4 >> 2] = C, C = t[K + 4 >> 2], t[or >> 2] = t[K >> 2], t[or + 4 >> 2] = C, C = t[pe + 4 >> 2], t[lr >> 2] = t[pe >> 2], t[lr + 4 >> 2] = C, C = t[Ce + 4 >> 2], t[gr >> 2] = t[Ce >> 2], t[gr + 4 >> 2] = C;
      }
      if (C = t[n + 12 >> 2], t[n + 208 >> 2] = t[n + 8 >> 2], t[n + 212 >> 2] = C, l = n + 208 | 0, a = l + 56 | 0, w = t[a + 4 >> 2], C = n + 80 | 0, b = C + 56 | 0, t[b >> 2] = t[a >> 2], t[b + 4 >> 2] = w, a = l + 48 | 0, w = t[a + 4 >> 2], b = C + 48 | 0, t[b >> 2] = t[a >> 2], t[b + 4 >> 2] = w, a = l + 40 | 0, w = t[a + 4 >> 2], b = C + 40 | 0, t[b >> 2] = t[a >> 2], t[b + 4 >> 2] = w, a = l + 32 | 0, w = t[a + 4 >> 2], b = C + 32 | 0, t[b >> 2] = t[a >> 2], t[b + 4 >> 2] = w, a = l + 24 | 0, w = t[a + 4 >> 2], b = C + 24 | 0, t[b >> 2] = t[a >> 2], t[b + 4 >> 2] = w, a = l + 16 | 0, w = t[a + 4 >> 2], b = C + 16 | 0, t[b >> 2] = t[a >> 2], t[b + 4 >> 2] = w, l = l + 8 | 0, a = t[l + 4 >> 2], w = C + 8 | 0, t[w >> 2] = t[l >> 2], t[w + 4 >> 2] = a, l = t[n + 212 >> 2], t[n + 80 >> 2] = t[n + 208 >> 2], t[n + 84 >> 2] = l, C = ii(t[172688], C), t[n + 8 >> 2] = C, (C | 0) != 1)
        break e;
      return U = n + 272 | 0, 1;
    }
    t[n + 216 >> 2] = 0, Ne(n + 208 | 0), wasm2js_trap();
  }
  function Dr(C, l) {
    C = C | 0, l = l | 0;
    var w = 0, n = 0, a = 0, b = 0, P = 0, K = 0, pe = 0, Ce = 0, Me = 0, Tt = 0, tr = 0, nr = 0, or = 0, lr = 0, gr = 0, kr = 0, Nr = 0, jr = 0, Yr = 0;
    b = U - 208 | 0, U = b, w = b + 136 | 0, a = w + 56 | 0, t[a >> 2] = 0, t[a + 4 >> 2] = 0, a = w + 48 | 0, t[a >> 2] = 0, t[a + 4 >> 2] = 0, a = w + 40 | 0, t[a >> 2] = 0, t[a + 4 >> 2] = 0, a = w + 32 | 0, t[a >> 2] = 0, t[a + 4 >> 2] = 0, a = w + 24 | 0, t[a >> 2] = 0, t[a + 4 >> 2] = 0, a = w + 16 | 0, t[a >> 2] = 0, t[a + 4 >> 2] = 0, a = w + 8 | 0, t[a >> 2] = 0, t[a + 4 >> 2] = 0, t[b + 136 >> 2] = 0, t[b + 140 >> 2] = 0;
    e: {
      if ((Bi(t[172688], w, 690820, C) | 0) == 1) {
        Me = b + 136 | 0, w = Me + 15 | 0, C = d[w + 4 | 0] | d[w + 5 | 0] << 8 | (d[w + 6 | 0] << 16 | d[w + 7 | 0] << 24), a = b + 72 | 0, nr = a + 8 | 0, t[nr >> 2] = d[w | 0] | d[w + 1 | 0] << 8 | (d[w + 2 | 0] << 16 | d[w + 3 | 0] << 24), t[nr + 4 >> 2] = C, w = Me + 23 | 0, C = d[w + 4 | 0] | d[w + 5 | 0] << 8 | (d[w + 6 | 0] << 16 | d[w + 7 | 0] << 24), tr = a + 16 | 0, t[tr >> 2] = d[w | 0] | d[w + 1 | 0] << 8 | (d[w + 2 | 0] << 16 | d[w + 3 | 0] << 24), t[tr + 4 >> 2] = C, w = Me + 31 | 0, C = d[w + 4 | 0] | d[w + 5 | 0] << 8 | (d[w + 6 | 0] << 16 | d[w + 7 | 0] << 24), Ce = a + 24 | 0, t[Ce >> 2] = d[w | 0] | d[w + 1 | 0] << 8 | (d[w + 2 | 0] << 16 | d[w + 3 | 0] << 24), t[Ce + 4 >> 2] = C, w = Me + 39 | 0, C = d[w + 4 | 0] | d[w + 5 | 0] << 8 | (d[w + 6 | 0] << 16 | d[w + 7 | 0] << 24), K = a + 32 | 0, t[K >> 2] = d[w | 0] | d[w + 1 | 0] << 8 | (d[w + 2 | 0] << 16 | d[w + 3 | 0] << 24), t[K + 4 >> 2] = C, w = Me + 47 | 0, C = d[w + 4 | 0] | d[w + 5 | 0] << 8 | (d[w + 6 | 0] << 16 | d[w + 7 | 0] << 24), Tt = a + 40 | 0, t[Tt >> 2] = d[w | 0] | d[w + 1 | 0] << 8 | (d[w + 2 | 0] << 16 | d[w + 3 | 0] << 24), t[Tt + 4 >> 2] = C, pe = Me + 55 | 0, C = d[pe + 4 | 0] | d[pe + 5 | 0] << 8 | (d[pe + 6 | 0] << 16 | d[pe + 7 | 0] << 24), w = a + 48 | 0, t[w >> 2] = d[pe | 0] | d[pe + 1 | 0] << 8 | (d[pe + 2 | 0] << 16 | d[pe + 3 | 0] << 24), t[w + 4 >> 2] = C, a = a + 56 | 0, c[a | 0] = d[Me + 63 | 0], c[b + 10 | 0] = d[b + 138 | 0], y[b + 8 >> 1] = E[b + 136 >> 1], C = d[b + 147 | 0] | d[b + 148 | 0] << 8 | (d[b + 149 | 0] << 16 | d[b + 150 | 0] << 24), t[b + 72 >> 2] = d[b + 143 | 0] | d[b + 144 | 0] << 8 | (d[b + 145 | 0] << 16 | d[b + 146 | 0] << 24), t[b + 76 >> 2] = C, Me = d[b + 139 | 0] | d[b + 140 | 0] << 8 | (d[b + 141 | 0] << 16 | d[b + 142 | 0] << 24), n = b + 8 | 0, c[n + 63 | 0] = d[a | 0], a = t[w + 4 >> 2], pe = n + 55 | 0, C = t[w >> 2], c[pe | 0] = C, c[pe + 1 | 0] = C >>> 8, c[pe + 2 | 0] = C >>> 16, c[pe + 3 | 0] = C >>> 24, c[pe + 4 | 0] = a, c[pe + 5 | 0] = a >>> 8, c[pe + 6 | 0] = a >>> 16, c[pe + 7 | 0] = a >>> 24, a = t[Tt + 4 >> 2], w = n + 47 | 0, C = t[Tt >> 2], c[w | 0] = C, c[w + 1 | 0] = C >>> 8, c[w + 2 | 0] = C >>> 16, c[w + 3 | 0] = C >>> 24, c[w + 4 | 0] = a, c[w + 5 | 0] = a >>> 8, c[w + 6 | 0] = a >>> 16, c[w + 7 | 0] = a >>> 24, a = t[K + 4 >> 2], w = n + 39 | 0, C = t[K >> 2], c[w | 0] = C, c[w + 1 | 0] = C >>> 8, c[w + 2 | 0] = C >>> 16, c[w + 3 | 0] = C >>> 24, c[w + 4 | 0] = a, c[w + 5 | 0] = a >>> 8, c[w + 6 | 0] = a >>> 16, c[w + 7 | 0] = a >>> 24, a = t[Ce + 4 >> 2], w = n + 31 | 0, C = t[Ce >> 2], c[w | 0] = C, c[w + 1 | 0] = C >>> 8, c[w + 2 | 0] = C >>> 16, c[w + 3 | 0] = C >>> 24, c[w + 4 | 0] = a, c[w + 5 | 0] = a >>> 8, c[w + 6 | 0] = a >>> 16, c[w + 7 | 0] = a >>> 24, a = t[tr + 4 >> 2], w = n + 23 | 0, C = t[tr >> 2], c[w | 0] = C, c[w + 1 | 0] = C >>> 8, c[w + 2 | 0] = C >>> 16, c[w + 3 | 0] = C >>> 24, c[w + 4 | 0] = a, c[w + 5 | 0] = a >>> 8, c[w + 6 | 0] = a >>> 16, c[w + 7 | 0] = a >>> 24, a = t[nr + 4 >> 2], w = n + 15 | 0, C = t[nr >> 2], c[w | 0] = C, c[w + 1 | 0] = C >>> 8, c[w + 2 | 0] = C >>> 16, c[w + 3 | 0] = C >>> 24, c[w + 4 | 0] = a, c[w + 5 | 0] = a >>> 8, c[w + 6 | 0] = a >>> 16, c[w + 7 | 0] = a >>> 24, c[b + 11 | 0] = Me, c[b + 12 | 0] = Me >>> 8, c[b + 13 | 0] = Me >>> 16, c[b + 14 | 0] = Me >>> 24, a = t[b + 76 >> 2], C = t[b + 72 >> 2], c[b + 15 | 0] = C, c[b + 16 | 0] = C >>> 8, c[b + 17 | 0] = C >>> 16, c[b + 18 | 0] = C >>> 24, c[b + 19 | 0] = a, c[b + 20 | 0] = a >>> 8, c[b + 21 | 0] = a >>> 16, c[b + 22 | 0] = a >>> 24, or = Et(), P = U - 288 | 0, U = P, t[P + 4 >> 2] = 0;
        t: {
          if (!n) {
            yi[t[or + 168 >> 2]](689638, t[or + 172 >> 2]);
            break t;
          }
          if (Ir(P + 8 | 0, 690949, P + 4 | 0), t[P + 4 >> 2]) {
            c[n | 0] = 0, c[n + 1 | 0] = 0, c[n + 2 | 0] = 0, c[n + 3 | 0] = 0, c[n + 4 | 0] = 0, c[n + 5 | 0] = 0, c[n + 6 | 0] = 0, c[n + 7 | 0] = 0, C = n + 56 | 0, c[C | 0] = 0, c[C + 1 | 0] = 0, c[C + 2 | 0] = 0, c[C + 3 | 0] = 0, c[C + 4 | 0] = 0, c[C + 5 | 0] = 0, c[C + 6 | 0] = 0, c[C + 7 | 0] = 0, C = n + 48 | 0, c[C | 0] = 0, c[C + 1 | 0] = 0, c[C + 2 | 0] = 0, c[C + 3 | 0] = 0, c[C + 4 | 0] = 0, c[C + 5 | 0] = 0, c[C + 6 | 0] = 0, c[C + 7 | 0] = 0, C = n + 40 | 0, c[C | 0] = 0, c[C + 1 | 0] = 0, c[C + 2 | 0] = 0, c[C + 3 | 0] = 0, c[C + 4 | 0] = 0, c[C + 5 | 0] = 0, c[C + 6 | 0] = 0, c[C + 7 | 0] = 0, C = n + 32 | 0, c[C | 0] = 0, c[C + 1 | 0] = 0, c[C + 2 | 0] = 0, c[C + 3 | 0] = 0, c[C + 4 | 0] = 0, c[C + 5 | 0] = 0, c[C + 6 | 0] = 0, c[C + 7 | 0] = 0, C = n + 24 | 0, c[C | 0] = 0, c[C + 1 | 0] = 0, c[C + 2 | 0] = 0, c[C + 3 | 0] = 0, c[C + 4 | 0] = 0, c[C + 5 | 0] = 0, c[C + 6 | 0] = 0, c[C + 7 | 0] = 0, C = n + 16 | 0, c[C | 0] = 0, c[C + 1 | 0] = 0, c[C + 2 | 0] = 0, c[C + 3 | 0] = 0, c[C + 4 | 0] = 0, c[C + 5 | 0] = 0, c[C + 6 | 0] = 0, c[C + 7 | 0] = 0, C = n + 8 | 0, c[C | 0] = 0, c[C + 1 | 0] = 0, c[C + 2 | 0] = 0, c[C + 3 | 0] = 0, c[C + 4 | 0] = 0, c[C + 5 | 0] = 0, c[C + 6 | 0] = 0, c[C + 7 | 0] = 0;
            break t;
          }
          if (C = d[n + 60 | 0] | d[n + 61 | 0] << 8 | (d[n + 62 | 0] << 16 | d[n + 63 | 0] << 24), pe = C >>> 16 | 0, Tt = P + 112 | 0, a = d[n + 56 | 0] | d[n + 57 | 0] << 8 | (d[n + 58 | 0] << 16 | d[n + 59 | 0] << 24), t[Tt >> 2] = (C & 65535) << 16 | a >>> 16, t[Tt + 4 >> 2] = pe, Tt = a << 4 & 1048560, C = d[n + 52 | 0] | d[n + 53 | 0] << 8 | (d[n + 54 | 0] << 16 | d[n + 55 | 0] << 24), pe = C >>> 28 | 0, K = P + 104 | 0, a = d[n + 48 | 0] | d[n + 49 | 0] << 8 | (d[n + 50 | 0] << 16 | d[n + 51 | 0] << 24), t[K >> 2] = (C & 268435455) << 4 | a >>> 28, t[K + 4 >> 2] = pe | Tt, pe = C << 24 | a >>> 8, K = a << 24 & -16777216, a = d[n + 40 | 0] | d[n + 41 | 0] << 8 | (d[n + 42 | 0] << 16 | d[n + 43 | 0] << 24), Ce = P + 40 | 0, tr = Ce + 56 | 0, C = d[n + 44 | 0] | d[n + 45 | 0] << 8 | (d[n + 46 | 0] << 16 | d[n + 47 | 0] << 24), t[tr >> 2] = C >>> 8 | K, t[tr + 4 >> 2] = pe & 1048575, tr = C << 12 | a >>> 20, K = a << 12 & -4096, w = d[n + 32 | 0] | d[n + 33 | 0] << 8 | (d[n + 34 | 0] << 16 | d[n + 35 | 0] << 24), C = d[n + 36 | 0] | d[n + 37 | 0] << 8 | (d[n + 38 | 0] << 16 | d[n + 39 | 0] << 24), Ce = Ce + 48 | 0, t[Ce >> 2] = C >>> 20 | K, t[Ce + 4 >> 2] = tr & 1048575, t[P + 120 >> 2] = 0, t[P + 80 >> 2] = w, t[P + 84 >> 2] = C & 1048575, w = d[n + 12 | 0] | d[n + 13 | 0] << 8 | (d[n + 14 | 0] << 16 | d[n + 15 | 0] << 24), Me = w, a = d[n + 8 | 0] | d[n + 9 | 0] << 8 | (d[n + 10 | 0] << 16 | d[n + 11 | 0] << 24), pe = w << 12 | a >>> 20, K = a << 12 & -4096, nr = d[n | 0] | d[n + 1 | 0] << 8 | (d[n + 2 | 0] << 16 | d[n + 3 | 0] << 24), a = d[n + 4 | 0] | d[n + 5 | 0] << 8 | (d[n + 6 | 0] << 16 | d[n + 7 | 0] << 24), w = a, C = P, lr = w >>> 20 | K, t[C + 48 >> 2] = lr, gr = pe & 1048575, t[C + 52 >> 2] = gr, t[C + 40 >> 2] = nr, kr = w & 1048575, t[C + 44 >> 2] = kr, a = d[n + 24 | 0] | d[n + 25 | 0] << 8 | (d[n + 26 | 0] << 16 | d[n + 27 | 0] << 24), tr = a, w = d[n + 28 | 0] | d[n + 29 | 0] << 8 | (d[n + 30 | 0] << 16 | d[n + 31 | 0] << 24), Tt = (w & 65535) << 16 | a >>> 16, t[C + 72 >> 2] = Tt, K = w >>> 16 | 0, t[C + 76 >> 2] = K, a = d[n + 16 | 0] | d[n + 17 | 0] << 8 | (d[n + 18 | 0] << 16 | d[n + 19 | 0] << 24), w = d[n + 20 | 0] | d[n + 21 | 0] << 8 | (d[n + 22 | 0] << 16 | d[n + 23 | 0] << 24), pe = w << 24 | a >>> 8, Nr = a << 24 & -16777216 | Me >>> 8, t[C + 56 >> 2] = Nr, Me = pe & 1048575, t[C + 60 >> 2] = Me, Ce = tr << 4 & 1048560, a = (w & 268435455) << 4 | a >>> 28, t[C + 64 >> 2] = a, C = w >>> 28 | Ce, t[P + 68 >> 2] = C, !(nr | lr | Tt | Nr | a | (gr | kr | K | Me | C))) {
            yi[t[or + 168 >> 2]](690116, t[or + 172 >> 2]), C = n + 56 | 0, c[C | 0] = 0, c[C + 1 | 0] = 0, c[C + 2 | 0] = 0, c[C + 3 | 0] = 0, c[C + 4 | 0] = 0, c[C + 5 | 0] = 0, c[C + 6 | 0] = 0, c[C + 7 | 0] = 0, C = n + 48 | 0, c[C | 0] = 0, c[C + 1 | 0] = 0, c[C + 2 | 0] = 0, c[C + 3 | 0] = 0, c[C + 4 | 0] = 0, c[C + 5 | 0] = 0, c[C + 6 | 0] = 0, c[C + 7 | 0] = 0, C = n + 40 | 0, c[C | 0] = 0, c[C + 1 | 0] = 0, c[C + 2 | 0] = 0, c[C + 3 | 0] = 0, c[C + 4 | 0] = 0, c[C + 5 | 0] = 0, c[C + 6 | 0] = 0, c[C + 7 | 0] = 0, C = n + 32 | 0, c[C | 0] = 0, c[C + 1 | 0] = 0, c[C + 2 | 0] = 0, c[C + 3 | 0] = 0, c[C + 4 | 0] = 0, c[C + 5 | 0] = 0, c[C + 6 | 0] = 0, c[C + 7 | 0] = 0, C = n + 24 | 0, c[C | 0] = 0, c[C + 1 | 0] = 0, c[C + 2 | 0] = 0, c[C + 3 | 0] = 0, c[C + 4 | 0] = 0, c[C + 5 | 0] = 0, c[C + 6 | 0] = 0, c[C + 7 | 0] = 0, C = n + 16 | 0, c[C | 0] = 0, c[C + 1 | 0] = 0, c[C + 2 | 0] = 0, c[C + 3 | 0] = 0, c[C + 4 | 0] = 0, c[C + 5 | 0] = 0, c[C + 6 | 0] = 0, c[C + 7 | 0] = 0, C = n + 8 | 0, c[C | 0] = 0, c[C + 1 | 0] = 0, c[C + 2 | 0] = 0, c[C + 3 | 0] = 0, c[C + 4 | 0] = 0, c[C + 5 | 0] = 0, c[C + 6 | 0] = 0, c[C + 7 | 0] = 0, c[n | 0] = 0, c[n + 1 | 0] = 0, c[n + 2 | 0] = 0, c[n + 3 | 0] = 0, c[n + 4 | 0] = 0, c[n + 5 | 0] = 0, c[n + 6 | 0] = 0, c[n + 7 | 0] = 0;
            break t;
          }
          if (c[n | 0] = 0, c[n + 1 | 0] = 0, c[n + 2 | 0] = 0, c[n + 3 | 0] = 0, c[n + 4 | 0] = 0, c[n + 5 | 0] = 0, c[n + 6 | 0] = 0, c[n + 7 | 0] = 0, C = n + 56 | 0, c[C | 0] = 0, c[C + 1 | 0] = 0, c[C + 2 | 0] = 0, c[C + 3 | 0] = 0, c[C + 4 | 0] = 0, c[C + 5 | 0] = 0, c[C + 6 | 0] = 0, c[C + 7 | 0] = 0, C = n + 48 | 0, c[C | 0] = 0, c[C + 1 | 0] = 0, c[C + 2 | 0] = 0, c[C + 3 | 0] = 0, c[C + 4 | 0] = 0, c[C + 5 | 0] = 0, c[C + 6 | 0] = 0, c[C + 7 | 0] = 0, C = n + 40 | 0, c[C | 0] = 0, c[C + 1 | 0] = 0, c[C + 2 | 0] = 0, c[C + 3 | 0] = 0, c[C + 4 | 0] = 0, c[C + 5 | 0] = 0, c[C + 6 | 0] = 0, c[C + 7 | 0] = 0, C = n + 32 | 0, c[C | 0] = 0, c[C + 1 | 0] = 0, c[C + 2 | 0] = 0, c[C + 3 | 0] = 0, c[C + 4 | 0] = 0, c[C + 5 | 0] = 0, c[C + 6 | 0] = 0, c[C + 7 | 0] = 0, C = n + 24 | 0, c[C | 0] = 0, c[C + 1 | 0] = 0, c[C + 2 | 0] = 0, c[C + 3 | 0] = 0, c[C + 4 | 0] = 0, c[C + 5 | 0] = 0, c[C + 6 | 0] = 0, c[C + 7 | 0] = 0, C = n + 16 | 0, c[C | 0] = 0, c[C + 1 | 0] = 0, c[C + 2 | 0] = 0, c[C + 3 | 0] = 0, c[C + 4 | 0] = 0, c[C + 5 | 0] = 0, c[C + 6 | 0] = 0, c[C + 7 | 0] = 0, C = n + 8 | 0, c[C | 0] = 0, c[C + 1 | 0] = 0, c[C + 2 | 0] = 0, c[C + 3 | 0] = 0, c[C + 4 | 0] = 0, c[C + 5 | 0] = 0, c[C + 6 | 0] = 0, c[C + 7 | 0] = 0, !(t[P + 32 >> 2] | (t[P + 24 >> 2] | (t[P + 16 >> 2] | t[P + 8 >> 2])) | (t[P + 36 >> 2] | (t[P + 28 >> 2] | (t[P + 20 >> 2] | t[P + 12 >> 2])))))
            break t;
          Tt = P + 256 | 0, C = Tt + 24 | 0, t[C >> 2] = 0, t[C + 4 >> 2] = 0, C = Tt + 16 | 0, t[C >> 2] = 0, t[C + 4 >> 2] = 0, C = Tt + 8 | 0, t[C >> 2] = 0, t[C + 4 >> 2] = 0, K = P + 40 | 0, w = K + 8 | 0, a = t[w + 4 >> 2], Ce = P + 128 | 0, C = Ce + 8 | 0, t[C >> 2] = t[w >> 2], t[C + 4 >> 2] = a, w = K + 16 | 0, a = t[w + 4 >> 2], C = Ce + 16 | 0, t[C >> 2] = t[w >> 2], t[C + 4 >> 2] = a, w = K + 24 | 0, a = t[w + 4 >> 2], C = Ce + 24 | 0, t[C >> 2] = t[w >> 2], t[C + 4 >> 2] = a, w = K + 32 | 0, a = t[w + 4 >> 2], C = Ce + 32 | 0, t[C >> 2] = t[w >> 2], t[C + 4 >> 2] = a, w = K + 48 | 0, a = t[w + 4 >> 2], C = Ce + 48 | 0, t[C >> 2] = t[w >> 2], t[C + 4 >> 2] = a, w = K + 56 | 0, a = t[w + 4 >> 2], C = Ce + 56 | 0, t[C >> 2] = t[w >> 2], t[C + 4 >> 2] = a, w = K - -64 | 0, a = t[w + 4 >> 2], C = Ce - -64 | 0, t[C >> 2] = t[w >> 2], t[C + 4 >> 2] = a, w = K + 72 | 0, a = t[w + 4 >> 2], C = Ce + 72 | 0, t[C >> 2] = t[w >> 2], t[C + 4 >> 2] = a, t[P + 256 >> 2] = 0, t[P + 260 >> 2] = 0, t[P + 248 >> 2] = 0, C = t[P + 44 >> 2], t[P + 128 >> 2] = t[P + 40 >> 2], t[P + 132 >> 2] = C, C = t[P + 84 >> 2], t[P + 168 >> 2] = t[P + 80 >> 2], t[P + 172 >> 2] = C, C = P + 240 | 0, t[C >> 2] = 0, t[C + 4 >> 2] = 0, C = P + 232 | 0, t[C >> 2] = 0, t[C + 4 >> 2] = 0, C = P + 224 | 0, t[C >> 2] = 0, t[C + 4 >> 2] = 0, C = P + 216 | 0, t[C >> 2] = 0, t[C + 4 >> 2] = 0, t[P + 208 >> 2] = 1, t[P + 212 >> 2] = 0, xr(Ce, Ce, P + 8 | 0, Tt), Kn(K, Ce), ti(n, K), jr = 1;
        }
        if (U = P + 288 | 0, !jr || (t[b + 204 >> 2] = l, C = Lr(t[172688], b + 204 | 0, b + 8 | 0, (l | 0) == 33 ? 258 : 2), t[b + 72 >> 2] = C, Yr = 1, (C | 0) == 1))
          break e;
        t[b + 144 >> 2] = 0, Ne(b + 136 | 0), wasm2js_trap();
      }
      M(1);
    }
    return U = b + 208 | 0, Yr | 0;
  }
  function Qr() {
    return (ts() | 0) == 1 | 0;
  }
  function Xr() {
    var C = 0, l = 0;
    if (C = U - 32 | 0, U = C, l = os(t[172688], 690949), t[C + 4 >> 2] = l, (l | 0) == 1)
      return l = ts(), U = C + 32 | 0, (l | 0) == 1 | 0;
    t[C + 16 >> 2] = 0, Ne(C + 8 | 0), wasm2js_trap();
  }
  function Vr() {
    var C = 0, l = 0;
    if (C = U - 32 | 0, U = C, l = os(t[172688], 690788), t[C + 4 >> 2] = l, (l | 0) == 1) {
      U = C + 32 | 0;
      return;
    }
    t[C + 16 >> 2] = 0, Ne(C + 8 | 0), wasm2js_trap();
  }
  function Ur(C) {
    C = C | 0;
    var l = 0, w = 0, n = 0, a = 0, b = 0, P = 0;
    n = U - 96 | 0, U = n, l = n + 56 | 0, t[l >> 2] = 0, t[l + 4 >> 2] = 0, l = n + 48 | 0, t[l >> 2] = 0, t[l + 4 >> 2] = 0, l = n + 40 | 0, t[l >> 2] = 0, t[l + 4 >> 2] = 0, l = n + 32 | 0, t[l >> 2] = 0, t[l + 4 >> 2] = 0, l = n + 24 | 0, t[l >> 2] = 0, t[l + 4 >> 2] = 0, l = n + 16 | 0, t[l >> 2] = 0, t[l + 4 >> 2] = 0, l = n + 8 | 0, t[l >> 2] = 0, t[l + 4 >> 2] = 0, t[n >> 2] = 0, t[n + 4 >> 2] = 0, w = Et(), b = t[172560], C = C ? 655681 : 0, l = U + -64 | 0, U = l;
    e: {
      if (!t[w >> 2]) {
        yi[t[w + 168 >> 2]](690045, t[w + 172 >> 2]), C = 0;
        break e;
      }
      if (!n) {
        yi[t[w + 168 >> 2]](689760, t[w + 172 >> 2]), C = 0;
        break e;
      }
      a = l + 32 | 0, C = li(w, a, l, 0, b, C), P = a + 24 | 0, b = t[P + 4 >> 2], w = n + 24 | 0, P = t[P >> 2], c[w | 0] = P, c[w + 1 | 0] = P >>> 8, c[w + 2 | 0] = P >>> 16, c[w + 3 | 0] = P >>> 24, c[w + 4 | 0] = b, c[w + 5 | 0] = b >>> 8, c[w + 6 | 0] = b >>> 16, c[w + 7 | 0] = b >>> 24, P = a + 16 | 0, b = t[P + 4 >> 2], w = n + 16 | 0, P = t[P >> 2], c[w | 0] = P, c[w + 1 | 0] = P >>> 8, c[w + 2 | 0] = P >>> 16, c[w + 3 | 0] = P >>> 24, c[w + 4 | 0] = b, c[w + 5 | 0] = b >>> 8, c[w + 6 | 0] = b >>> 16, c[w + 7 | 0] = b >>> 24, a = a + 8 | 0, b = t[a + 4 >> 2], w = n + 8 | 0, a = t[a >> 2], c[w | 0] = a, c[w + 1 | 0] = a >>> 8, c[w + 2 | 0] = a >>> 16, c[w + 3 | 0] = a >>> 24, c[w + 4 | 0] = b, c[w + 5 | 0] = b >>> 8, c[w + 6 | 0] = b >>> 16, c[w + 7 | 0] = b >>> 24, w = t[l + 36 >> 2], b = t[l + 32 >> 2], c[n | 0] = b, c[n + 1 | 0] = b >>> 8, c[n + 2 | 0] = b >>> 16, c[n + 3 | 0] = b >>> 24, c[n + 4 | 0] = w, c[n + 5 | 0] = w >>> 8, c[n + 6 | 0] = w >>> 16, c[n + 7 | 0] = w >>> 24, w = t[l + 4 >> 2], b = t[l >> 2], c[n + 32 | 0] = b, c[n + 33 | 0] = b >>> 8, c[n + 34 | 0] = b >>> 16, c[n + 35 | 0] = b >>> 24, c[n + 36 | 0] = w, c[n + 37 | 0] = w >>> 8, c[n + 38 | 0] = w >>> 16, c[n + 39 | 0] = w >>> 24, a = l + 8 | 0, b = t[a + 4 >> 2], w = n + 40 | 0, a = t[a >> 2], c[w | 0] = a, c[w + 1 | 0] = a >>> 8, c[w + 2 | 0] = a >>> 16, c[w + 3 | 0] = a >>> 24, c[w + 4 | 0] = b, c[w + 5 | 0] = b >>> 8, c[w + 6 | 0] = b >>> 16, c[w + 7 | 0] = b >>> 24, a = l + 16 | 0, b = t[a + 4 >> 2], w = n + 48 | 0, a = t[a >> 2], c[w | 0] = a, c[w + 1 | 0] = a >>> 8, c[w + 2 | 0] = a >>> 16, c[w + 3 | 0] = a >>> 24, c[w + 4 | 0] = b, c[w + 5 | 0] = b >>> 8, c[w + 6 | 0] = b >>> 16, c[w + 7 | 0] = b >>> 24, a = l + 24 | 0, b = t[a + 4 >> 2], w = n + 56 | 0, a = t[a >> 2], c[w | 0] = a, c[w + 1 | 0] = a >>> 8, c[w + 2 | 0] = a >>> 16, c[w + 3 | 0] = a >>> 24, c[w + 4 | 0] = b, c[w + 5 | 0] = b >>> 8, c[w + 6 | 0] = b >>> 16, c[w + 7 | 0] = b >>> 24;
    }
    U = l - -64 | 0, t[n + 68 >> 2] = C;
    e: {
      t: {
        if ((C | 0) == 1) {
          l = t[172688], C = U + -64 | 0, U = C;
          r: {
            if (!n) {
              yi[t[l + 168 >> 2]](689748, t[l + 172 >> 2]), l = 0;
              break r;
            }
            l = n + 24 | 0, b = d[l + 4 | 0] | d[l + 5 | 0] << 8 | (d[l + 6 | 0] << 16 | d[l + 7 | 0] << 24), w = C + 32 | 0, a = w + 24 | 0, t[a >> 2] = d[l | 0] | d[l + 1 | 0] << 8 | (d[l + 2 | 0] << 16 | d[l + 3 | 0] << 24), t[a + 4 >> 2] = b, l = n + 16 | 0, b = d[l + 4 | 0] | d[l + 5 | 0] << 8 | (d[l + 6 | 0] << 16 | d[l + 7 | 0] << 24), a = w + 16 | 0, t[a >> 2] = d[l | 0] | d[l + 1 | 0] << 8 | (d[l + 2 | 0] << 16 | d[l + 3 | 0] << 24), t[a + 4 >> 2] = b, l = n + 8 | 0, b = d[l + 4 | 0] | d[l + 5 | 0] << 8 | (d[l + 6 | 0] << 16 | d[l + 7 | 0] << 24), a = w + 8 | 0, t[a >> 2] = d[l | 0] | d[l + 1 | 0] << 8 | (d[l + 2 | 0] << 16 | d[l + 3 | 0] << 24), t[a + 4 >> 2] = b, l = n + 40 | 0, b = d[l + 4 | 0] | d[l + 5 | 0] << 8 | (d[l + 6 | 0] << 16 | d[l + 7 | 0] << 24), a = C + 8 | 0, t[a >> 2] = d[l | 0] | d[l + 1 | 0] << 8 | (d[l + 2 | 0] << 16 | d[l + 3 | 0] << 24), t[a + 4 >> 2] = b, l = n + 48 | 0, b = d[l + 4 | 0] | d[l + 5 | 0] << 8 | (d[l + 6 | 0] << 16 | d[l + 7 | 0] << 24), a = C + 16 | 0, t[a >> 2] = d[l | 0] | d[l + 1 | 0] << 8 | (d[l + 2 | 0] << 16 | d[l + 3 | 0] << 24), t[a + 4 >> 2] = b, l = n + 56 | 0, b = d[l + 4 | 0] | d[l + 5 | 0] << 8 | (d[l + 6 | 0] << 16 | d[l + 7 | 0] << 24), a = C + 24 | 0, t[a >> 2] = d[l | 0] | d[l + 1 | 0] << 8 | (d[l + 2 | 0] << 16 | d[l + 3 | 0] << 24), t[a + 4 >> 2] = b, l = d[n + 4 | 0] | d[n + 5 | 0] << 8 | (d[n + 6 | 0] << 16 | d[n + 7 | 0] << 24), t[C + 32 >> 2] = d[n | 0] | d[n + 1 | 0] << 8 | (d[n + 2 | 0] << 16 | d[n + 3 | 0] << 24), t[C + 36 >> 2] = l, l = d[n + 36 | 0] | d[n + 37 | 0] << 8 | (d[n + 38 | 0] << 16 | d[n + 39 | 0] << 24), t[C >> 2] = d[n + 32 | 0] | d[n + 33 | 0] << 8 | (d[n + 34 | 0] << 16 | d[n + 35 | 0] << 24), t[C + 4 >> 2] = l, pr(690981, w), pr(691013, C), l = 1;
          }
          if (U = C - -64 | 0, t[n + 68 >> 2] = l, (l | 0) == 1)
            break t;
          break e;
        }
        break e;
      }
      U = n + 96 | 0;
      return;
    }
    t[n + 80 >> 2] = 0, Ne(n + 72 | 0), wasm2js_trap();
  }
  function Sr(C) {
    C = C | 0;
    var l = 0, w = 0, n = 0, a = 0, b = 0, P = 0, K = 0, pe = 0, Ce = 0, Me = 0, Tt = 0, tr = 0, nr = 0, or = 0;
    pe = U - 112 | 0, U = pe, b = pe + 16 | 0, is(b, 65), l = Et(), n = t[172560], C = C ? 655681 : 0, w = U - 80 | 0, U = w;
    e: {
      if (!t[l >> 2]) {
        yi[t[l + 168 >> 2]](690045, t[l + 172 >> 2]), C = 0;
        break e;
      }
      if (!b) {
        yi[t[l + 168 >> 2]](689760, t[l + 172 >> 2]), C = 0;
        break e;
      }
      a = w + 48 | 0, K = w + 16 | 0, C = li(l, a, K, w + 12 | 0, n, C), l = t[w + 52 >> 2], n = t[w + 48 >> 2], c[b | 0] = n, c[b + 1 | 0] = n >>> 8, c[b + 2 | 0] = n >>> 16, c[b + 3 | 0] = n >>> 24, c[b + 4 | 0] = l, c[b + 5 | 0] = l >>> 8, c[b + 6 | 0] = l >>> 16, c[b + 7 | 0] = l >>> 24, P = a + 8 | 0, n = t[P + 4 >> 2], l = b + 8 | 0, P = t[P >> 2], c[l | 0] = P, c[l + 1 | 0] = P >>> 8, c[l + 2 | 0] = P >>> 16, c[l + 3 | 0] = P >>> 24, c[l + 4 | 0] = n, c[l + 5 | 0] = n >>> 8, c[l + 6 | 0] = n >>> 16, c[l + 7 | 0] = n >>> 24, P = a + 16 | 0, n = t[P + 4 >> 2], l = b + 16 | 0, P = t[P >> 2], c[l | 0] = P, c[l + 1 | 0] = P >>> 8, c[l + 2 | 0] = P >>> 16, c[l + 3 | 0] = P >>> 24, c[l + 4 | 0] = n, c[l + 5 | 0] = n >>> 8, c[l + 6 | 0] = n >>> 16, c[l + 7 | 0] = n >>> 24, a = a + 24 | 0, n = t[a + 4 >> 2], l = b + 24 | 0, a = t[a >> 2], c[l | 0] = a, c[l + 1 | 0] = a >>> 8, c[l + 2 | 0] = a >>> 16, c[l + 3 | 0] = a >>> 24, c[l + 4 | 0] = n, c[l + 5 | 0] = n >>> 8, c[l + 6 | 0] = n >>> 16, c[l + 7 | 0] = n >>> 24, l = t[w + 20 >> 2], n = t[w + 16 >> 2], c[b + 32 | 0] = n, c[b + 33 | 0] = n >>> 8, c[b + 34 | 0] = n >>> 16, c[b + 35 | 0] = n >>> 24, c[b + 36 | 0] = l, c[b + 37 | 0] = l >>> 8, c[b + 38 | 0] = l >>> 16, c[b + 39 | 0] = l >>> 24, a = K + 8 | 0, n = t[a + 4 >> 2], l = b + 40 | 0, a = t[a >> 2], c[l | 0] = a, c[l + 1 | 0] = a >>> 8, c[l + 2 | 0] = a >>> 16, c[l + 3 | 0] = a >>> 24, c[l + 4 | 0] = n, c[l + 5 | 0] = n >>> 8, c[l + 6 | 0] = n >>> 16, c[l + 7 | 0] = n >>> 24, a = K + 16 | 0, n = t[a + 4 >> 2], l = b + 48 | 0, a = t[a >> 2], c[l | 0] = a, c[l + 1 | 0] = a >>> 8, c[l + 2 | 0] = a >>> 16, c[l + 3 | 0] = a >>> 24, c[l + 4 | 0] = n, c[l + 5 | 0] = n >>> 8, c[l + 6 | 0] = n >>> 16, c[l + 7 | 0] = n >>> 24, a = K + 24 | 0, n = t[a + 4 >> 2], l = b + 56 | 0, a = t[a >> 2], c[l | 0] = a, c[l + 1 | 0] = a >>> 8, c[l + 2 | 0] = a >>> 16, c[l + 3 | 0] = a >>> 24, c[l + 4 | 0] = n, c[l + 5 | 0] = n >>> 8, c[l + 6 | 0] = n >>> 16, c[l + 7 | 0] = n >>> 24, c[b + 64 | 0] = t[w + 12 >> 2];
    }
    if (U = w + 80 | 0, t[pe + 84 >> 2] = C, (C | 0) == 1) {
      t[pe + 12 >> 2] = 0, w = t[172688], n = pe + 12 | 0, b = U + -64 | 0, U = b, C = pe + 16 | 0;
      e: {
        if (!C) {
          yi[t[w + 168 >> 2]](689748, t[w + 172 >> 2]);
          break e;
        }
        if (!n) {
          yi[t[w + 168 >> 2]](689795, t[w + 172 >> 2]);
          break e;
        }
        w = C + 24 | 0, a = d[w + 4 | 0] | d[w + 5 | 0] << 8 | (d[w + 6 | 0] << 16 | d[w + 7 | 0] << 24), l = b + 32 | 0, K = l + 24 | 0, t[K >> 2] = d[w | 0] | d[w + 1 | 0] << 8 | (d[w + 2 | 0] << 16 | d[w + 3 | 0] << 24), t[K + 4 >> 2] = a, w = C + 16 | 0, a = d[w + 4 | 0] | d[w + 5 | 0] << 8 | (d[w + 6 | 0] << 16 | d[w + 7 | 0] << 24), K = l + 16 | 0, t[K >> 2] = d[w | 0] | d[w + 1 | 0] << 8 | (d[w + 2 | 0] << 16 | d[w + 3 | 0] << 24), t[K + 4 >> 2] = a, w = C + 8 | 0, a = d[w + 4 | 0] | d[w + 5 | 0] << 8 | (d[w + 6 | 0] << 16 | d[w + 7 | 0] << 24), K = l + 8 | 0, t[K >> 2] = d[w | 0] | d[w + 1 | 0] << 8 | (d[w + 2 | 0] << 16 | d[w + 3 | 0] << 24), t[K + 4 >> 2] = a, w = C + 56 | 0, a = d[w | 0] | d[w + 1 | 0] << 8 | (d[w + 2 | 0] << 16 | d[w + 3 | 0] << 24), K = d[w + 4 | 0] | d[w + 5 | 0] << 8 | (d[w + 6 | 0] << 16 | d[w + 7 | 0] << 24), w = C + 48 | 0, P = d[w | 0] | d[w + 1 | 0] << 8 | (d[w + 2 | 0] << 16 | d[w + 3 | 0] << 24), Ce = d[w + 4 | 0] | d[w + 5 | 0] << 8 | (d[w + 6 | 0] << 16 | d[w + 7 | 0] << 24), w = C + 40 | 0, Me = d[w | 0] | d[w + 1 | 0] << 8 | (d[w + 2 | 0] << 16 | d[w + 3 | 0] << 24), w = d[w + 4 | 0] | d[w + 5 | 0] << 8 | (d[w + 6 | 0] << 16 | d[w + 7 | 0] << 24), Tt = d[C + 32 | 0] | d[C + 33 | 0] << 8 | (d[C + 34 | 0] << 16 | d[C + 35 | 0] << 24), tr = d[C + 36 | 0] | d[C + 37 | 0] << 8 | (d[C + 38 | 0] << 16 | d[C + 39 | 0] << 24), nr = d[C | 0] | d[C + 1 | 0] << 8 | (d[C + 2 | 0] << 16 | d[C + 3 | 0] << 24), or = d[C + 4 | 0] | d[C + 5 | 0] << 8 | (d[C + 6 | 0] << 16 | d[C + 7 | 0] << 24), t[n >> 2] = d[C + 64 | 0], C = b + 8 | 0, t[C >> 2] = Me, t[C + 4 >> 2] = w, C = b + 16 | 0, t[C >> 2] = P, t[C + 4 >> 2] = Ce, C = b + 24 | 0, t[C >> 2] = a, t[C + 4 >> 2] = K, t[b + 32 >> 2] = nr, t[b + 36 >> 2] = or, t[b >> 2] = Tt, t[b + 4 >> 2] = tr, pr(690981, l), pr(691013, b);
      }
      return U = b - -64 | 0, U = pe + 112 | 0, t[pe + 12 >> 2];
    }
    t[pe + 96 >> 2] = 0, Ne(pe + 88 | 0), wasm2js_trap();
  }
  function Gr(C) {
    C = C | 0;
    var l = 0, w = 0, n = 0, a = 0, b = 0, P = 0, K = 0, pe = 0, Ce = 0, Me = 0, Tt = 0, tr = 0, nr = 0, or = 0, lr = 0, gr = 0, kr = 0, Nr = 0, jr = 0, Yr = 0, ei = 0, ai = 0, ui = 0, di = 0, Ii = 0, wi = 0;
    w = U - 128 | 0, U = w, K = is(w, 96), w = ci(Et(), K), t[K + 100 >> 2] = w;
    e: {
      t: {
        if ((w | 0) == 1) {
          lr = Et(), wi = C ? 655681 : 0, l = U - 640 | 0, U = l, C = l + 88 | 0, t[C >> 2] = 0, t[C + 4 >> 2] = 0, C = l + 80 | 0, t[C >> 2] = 0, t[C + 4 >> 2] = 0, t[l + 72 >> 2] = 0, t[l + 76 >> 2] = 0, t[l + 64 >> 2] = 0, t[l + 68 >> 2] = 0;
          r: {
            if (!t[lr >> 2]) {
              yi[t[lr + 168 >> 2]](690045, t[lr + 172 >> 2]);
              break r;
            }
            if (!K) {
              yi[t[lr + 168 >> 2]](689700, t[lr + 172 >> 2]);
              break r;
            }
            kr = l + 472 | 0, ui = U - 16 | 0, U = ui, Nr = d[K + 40 | 0] | d[K + 41 | 0] << 8 | (d[K + 42 | 0] << 16 | d[K + 43 | 0] << 24), P = d[K + 44 | 0] | d[K + 45 | 0] << 8 | (d[K + 46 | 0] << 16 | d[K + 47 | 0] << 24), Me = d[K + 48 | 0] | d[K + 49 | 0] << 8 | (d[K + 50 | 0] << 16 | d[K + 51 | 0] << 24), b = d[K + 52 | 0] | d[K + 53 | 0] << 8 | (d[K + 54 | 0] << 16 | d[K + 55 | 0] << 24), jr = d[K + 72 | 0] | d[K + 73 | 0] << 8 | (d[K + 74 | 0] << 16 | d[K + 75 | 0] << 24), tr = d[K + 76 | 0] | d[K + 77 | 0] << 8 | (d[K + 78 | 0] << 16 | d[K + 79 | 0] << 24), pe = d[K + 80 | 0] | d[K + 81 | 0] << 8 | (d[K + 82 | 0] << 16 | d[K + 83 | 0] << 24), n = d[K + 84 | 0] | d[K + 85 | 0] << 8 | (d[K + 86 | 0] << 16 | d[K + 87 | 0] << 24), gr = d[K + 32 | 0] | d[K + 33 | 0] << 8 | (d[K + 34 | 0] << 16 | d[K + 35 | 0] << 24), nr = d[K + 36 | 0] | d[K + 37 | 0] << 8 | (d[K + 38 | 0] << 16 | d[K + 39 | 0] << 24), Tt = d[K + 56 | 0] | d[K + 57 | 0] << 8 | (d[K + 58 | 0] << 16 | d[K + 59 | 0] << 24), a = d[K + 60 | 0] | d[K + 61 | 0] << 8 | (d[K + 62 | 0] << 16 | d[K + 63 | 0] << 24), ai = d[K + 64 | 0] | d[K + 65 | 0] << 8 | (d[K + 66 | 0] << 16 | d[K + 67 | 0] << 24), or = d[K + 68 | 0] | d[K + 69 | 0] << 8 | (d[K + 70 | 0] << 16 | d[K + 71 | 0] << 24), Ce = d[K + 88 | 0] | d[K + 89 | 0] << 8 | (d[K + 90 | 0] << 16 | d[K + 91 | 0] << 24), Yr = d[K + 92 | 0] | d[K + 93 | 0] << 8 | (d[K + 94 | 0] << 16 | d[K + 95 | 0] << 24), w = l + 192 | 0, t[w + 80 >> 2] = 0, ei = w + 72 | 0, t[ei >> 2] = (Yr & 65535) << 16 | Ce >>> 16, t[ei + 4 >> 2] = Yr >>> 16, t[w + 40 >> 2] = ai, t[w + 44 >> 2] = or & 1048575, ei = (a & 65535) << 16 | Tt >>> 16, t[w + 32 >> 2] = ei, ai = a >>> 16 | 0, t[w + 36 >> 2] = ai, t[w >> 2] = gr, Yr = nr & 1048575, t[w + 4 >> 2] = Yr, di = w - -64 | 0, t[di >> 2] = (n & 268435455) << 4 | pe >>> 28, t[di + 4 >> 2] = Ce << 4 & 1048560 | n >>> 28, C = n << 24 | pe >>> 8, Ce = w + 56 | 0, n = tr, t[Ce >> 2] = pe << 24 & -16777216 | n >>> 8, t[Ce + 4 >> 2] = C & 1048575, C = n << 12, n = jr, pe = (C | n >>> 20) & 1048575, tr = w + 48 | 0, t[tr >> 2] = n << 12 & -4096 | or >>> 20, t[tr + 4 >> 2] = pe, n = Tt << 4 & 1048560, a = b, C = a >>> 28 | 0, b = (a & 268435455) << 4 | Me >>> 28, t[w + 24 >> 2] = b, n = C | n, t[w + 28 >> 2] = n, C = a << 24 | Me >>> 8, a = P, P = Me << 24 & -16777216 | a >>> 8, t[w + 16 >> 2] = P, Me = C & 1048575, t[w + 20 >> 2] = Me, C = a << 12, a = Nr, tr = (C | a >>> 20) & 1048575, a = a << 12 & -4096 | nr >>> 20, t[w + 8 >> 2] = a, C = tr, t[w + 12 >> 2] = C;
            i: {
              n: {
                if (!(a | gr | ei | P | b | (C | Yr | ai | Me | n))) {
                  if (yi[t[lr + 168 >> 2]](690116, t[lr + 172 >> 2]), as(w, 690376, 88), kr)
                    break n;
                  break i;
                }
                if (Ii = 1, !kr || (Ir(kr, K, ui + 12 | 0), !(t[ui + 12 >> 2] | !(t[kr + 24 >> 2] | (t[kr + 16 >> 2] | (t[kr + 8 >> 2] | t[kr >> 2])) | (t[kr + 28 >> 2] | (t[kr + 20 >> 2] | (t[kr + 12 >> 2] | t[kr + 4 >> 2])))))))
                  break i;
                yi[t[lr + 168 >> 2]](689400, t[lr + 172 >> 2]), as(w, 690376, 88);
              }
              Ii = 0, C = t[172569], w = kr + 24 | 0, t[w >> 2] = t[172568], t[w + 4 >> 2] = C, C = t[172567], w = kr + 16 | 0, t[w >> 2] = t[172566], t[w + 4 >> 2] = C, C = t[172565], w = kr + 8 | 0, t[w >> 2] = t[172564], t[w + 4 >> 2] = C, C = t[172563], t[kr >> 2] = t[172562], t[kr + 4 >> 2] = C;
            }
            U = ui + 16 | 0;
            i: {
              if (!(c[l + 232 | 0] & 1)) {
                Nr = t[l + 472 >> 2], tr = t[l + 476 >> 2], pe = t[l + 480 >> 2], w = t[l + 484 >> 2], n = t[l + 488 >> 2], b = t[l + 492 >> 2], jr = t[l + 496 >> 2], Me = t[l + 500 >> 2];
                break i;
              }
              nr = t[l + 496 >> 2], or = t[l + 488 >> 2], n = t[l + 480 >> 2], C = t[l + 472 >> 2], gr = t[l + 500 >> 2], jr = t[l + 492 >> 2], b = t[l + 484 >> 2], w = t[l + 476 >> 2], P = nr | (or | (n | C)) | (gr | (jr | (b | w))) ? -1 : 0, C = C ^ -1, Me = C - 801750718 | 0, Nr = P & Me, t[l + 472 >> 2] = Nr, w = w ^ -1, a = w - ((C >>> 0 < 801750718) + 1076732275 | 0) | 0, tr = a & P, t[l + 476 >> 2] = tr, C = (w | 0) == (a | 0) & C >>> 0 > Me >>> 0 | w >>> 0 > a >>> 0, Me = n ^ -1, n = C + Me | 0, b = b ^ -1, C = b, Ce = n - 1354194885 | 0, pe = Ce & P, t[l + 480 >> 2] = pe, C = n >>> 0 < Me >>> 0 ? C + 1 | 0 : C, Tt = C - ((n >>> 0 < 1354194885) + 1162945305 | 0) | 0, w = Tt & P, t[l + 484 >> 2] = w, a = (C | 0) == (b | 0) & n >>> 0 < Me >>> 0 | C >>> 0 < b >>> 0, Me = (C | 0) == (Tt | 0) & n >>> 0 > Ce >>> 0 | C >>> 0 > Tt >>> 0, n = a + Me | 0, C = n >>> 0 < Me >>> 0, Tt = or ^ -1, Me = Tt + n | 0, or = jr ^ -1, C = or + C | 0, Ce = Me - 2 | 0, n = Ce & P, t[l + 488 >> 2] = n, C = Me >>> 0 < Tt >>> 0 ? C + 1 | 0 : C, jr = C - (Me >>> 0 < 2) | 0, b = jr & P, t[l + 492 >> 2] = b, a = (C | 0) == (or | 0) & Me >>> 0 < Tt >>> 0 | C >>> 0 < or >>> 0, Me = (C | 0) == (jr | 0) & Ce >>> 0 < Me >>> 0 | C >>> 0 > jr >>> 0, a = a + Me | 0, C = a >>> 0 < Me >>> 0, Me = a - nr | 0, jr = Me - 2 & P, t[l + 496 >> 2] = jr, Me = (C - ((a >>> 0 < nr >>> 0) + gr | 0) | 0) - (Me >>> 0 < 2) & P, t[l + 500 >> 2] = Me;
            }
            c[l + 31 | 0] = Nr, c[l + 30 | 0] = (tr & 255) << 24 | Nr >>> 8, c[l + 29 | 0] = (tr & 65535) << 16 | Nr >>> 16, c[l + 28 | 0] = (tr & 16777215) << 8 | Nr >>> 24, c[l + 27 | 0] = tr, c[l + 26 | 0] = tr >>> 8, c[l + 25 | 0] = tr >>> 16, c[l + 24 | 0] = tr >>> 24, c[l + 23 | 0] = pe, c[l + 22 | 0] = (w & 255) << 24 | pe >>> 8, c[l + 21 | 0] = (w & 65535) << 16 | pe >>> 16, c[l + 20 | 0] = (w & 16777215) << 8 | pe >>> 24, c[l + 19 | 0] = w, c[l + 18 | 0] = w >>> 8, c[l + 17 | 0] = w >>> 16, c[l + 16 | 0] = w >>> 24, c[l + 15 | 0] = n, c[l + 14 | 0] = (b & 255) << 24 | n >>> 8, c[l + 13 | 0] = (b & 65535) << 16 | n >>> 16, c[l + 12 | 0] = (b & 16777215) << 8 | n >>> 24, c[l + 11 | 0] = b, c[l + 10 | 0] = b >>> 8, c[l + 9 | 0] = b >>> 16, c[l + 8 | 0] = b >>> 24, c[l + 7 | 0] = jr, c[l + 6 | 0] = (Me & 255) << 24 | jr >>> 8, c[l + 5 | 0] = (Me & 65535) << 16 | jr >>> 16, c[l + 4 | 0] = (Me & 16777215) << 8 | jr >>> 24, c[l + 3 | 0] = Me, c[l + 2 | 0] = Me >>> 8, c[l + 1 | 0] = Me >>> 16, c[l | 0] = Me >>> 24, w = t[l + 228 >> 2], a = t[l + 224 >> 2], c[l + 37 | 0] = a, C = t[l + 212 >> 2], n = t[l + 208 >> 2], c[l + 50 | 0] = n, c[l + 36 | 0] = (w & 255) << 24 | a >>> 8, c[l + 35 | 0] = (w & 65535) << 16 | a >>> 16, c[l + 34 | 0] = (w & 16777215) << 8 | a >>> 24, c[l + 33 | 0] = w, c[l + 32 | 0] = w >>> 8, w = t[l + 220 >> 2], a = t[l + 216 >> 2], c[l + 43 | 0] = (w & 15) << 28 | a >>> 4, c[l + 42 | 0] = (w & 4095) << 20 | a >>> 12, c[l + 41 | 0] = (w & 1048575) << 12 | a >>> 20, c[l + 40 | 0] = (w & 268435455) << 4 | a >>> 28, c[l + 39 | 0] = w >>> 4, c[l + 38 | 0] = w >>> 12, c[l + 49 | 0] = (C & 255) << 24 | n >>> 8, c[l + 48 | 0] = (C & 65535) << 16 | n >>> 16, c[l + 47 | 0] = (C & 16777215) << 8 | n >>> 24, c[l + 46 | 0] = C, c[l + 45 | 0] = C >>> 8, c[l + 44 | 0] = C >>> 16 & 15 | a << 4, C = t[l + 196 >> 2], n = t[l + 192 >> 2], c[l + 63 | 0] = n, w = t[l + 204 >> 2], a = t[l + 200 >> 2], c[l + 56 | 0] = (w & 15) << 28 | a >>> 4, c[l + 55 | 0] = (w & 4095) << 20 | a >>> 12, c[l + 54 | 0] = (w & 1048575) << 12 | a >>> 20, c[l + 53 | 0] = (w & 268435455) << 4 | a >>> 28, c[l + 52 | 0] = w >>> 4, c[l + 51 | 0] = w >>> 12, c[l + 62 | 0] = (C & 255) << 24 | n >>> 8, c[l + 61 | 0] = (C & 65535) << 16 | n >>> 16, c[l + 60 | 0] = (C & 16777215) << 8 | n >>> 24, c[l + 59 | 0] = C, c[l + 58 | 0] = C >>> 8, c[l + 57 | 0] = C >>> 16 & 15 | a << 4, C = l - -64 | 0, w = Si(C, 655649, 32, l, l + 32 | 0, 690736, 13, wi), a = l + 408 | 0, Ir(a, C, 0), C = Ii & (w | 0) != 0, w = t[l + 432 >> 2], b = t[l + 424 >> 2], n = t[l + 416 >> 2], P = t[l + 408 >> 2], Me = t[l + 436 >> 2], nr = t[l + 428 >> 2], tr = t[l + 420 >> 2], pe = t[l + 412 >> 2], di = C & (w | (b | (n | P)) | (Me | (nr | (tr | pe)))) != 0, ui = !di, C = ui - 1 | 0, jr = C & w, t[l + 432 >> 2] = jr, w = 0 - !ui | 0, Me = w & Me, t[l + 436 >> 2] = Me, Yr = C & b, t[l + 424 >> 2] = Yr, ai = w & nr, t[l + 428 >> 2] = ai, ei = C & n, t[l + 416 >> 2] = ei, kr = w & tr, t[l + 420 >> 2] = kr, Nr = C & P | ui, t[l + 408 >> 2] = Nr, tr = w & pe, t[l + 412 >> 2] = tr, C = l + 280 | 0, zi(lr, C, a), Kn(l + 104 | 0, C), C = l + 152 | 0, a = t[C >> 2], P = t[C + 4 >> 2], b = t[l + 148 >> 2], C = l + 176 | 0, pe = t[C >> 2], n = t[C + 4 >> 2], or = n, C = t[l + 144 >> 2], w = ri(n >>> 16 | 0, 0, 977, 1), n = C + w | 0, C = b + ve | 0, Ce = w >>> 0 > n >>> 0 ? C + 1 | 0 : C, C = P, w = Ce >>> 20 | 0, b = w, w = w + a | 0, b = b >>> 0 > w >>> 0 ? C + 1 | 0 : C, nr = b & 1048575, C = l + 168 | 0, gr = t[C >> 2], lr = t[C + 4 >> 2], C = l + 160 | 0, P = t[C >> 2], C = t[C + 4 >> 2], a = b >>> 20 | 0, Tt = a, a = a + P | 0, Tt = Tt >>> 0 > a >>> 0 ? C + 1 | 0 : C, C = lr, P = Tt >>> 20 | 0, lr = P, P = P + gr | 0, C = lr >>> 0 > P >>> 0 ? C + 1 | 0 : C, gr = C & 1048575, Tt = Tt & 1048575, lr = (w & a & P) == -1 & (b & Tt & C) == 1048575, b = C, C = or & 65535, b = b >>> 20 | 0, or = b + pe | 0, C = b >>> 0 > or >>> 0 ? C + 1 | 0 : C, pe = C, b = Ce & 1048575, lr & ((or | 0) == -1 & (C | 0) == 65535) & ((b | 0) == 1048574 & n >>> 0 > 4294966318 | b >>> 0 > 1048574) | C >>> 16 && (C = b + 1 | 0, n = n + 977 | 0, C = n >>> 0 < 977 ? C + 1 | 0 : C, b = C & 1048575, Ce = C, C = nr, Ce = Ce >>> 20 | 0, w = w + Ce | 0, C = Ce >>> 0 > w >>> 0 ? C + 1 | 0 : C, nr = C & 1048575, Ce = C, C = Tt, Ce = Ce >>> 20 | 0, a = a + Ce | 0, C = Ce >>> 0 > a >>> 0 ? C + 1 | 0 : C, Tt = C & 1048575, Ce = C, C = gr, Ce = Ce >>> 20 | 0, P = P + Ce | 0, C = Ce >>> 0 > P >>> 0 ? C + 1 | 0 : C, gr = C & 1048575, Ce = C, C = pe, pe = or, or = (Ce >>> 20 | 0) + or | 0, pe = (pe >>> 0 > or >>> 0 ? C + 1 | 0 : C) & 65535), t[l + 176 >> 2] = or, t[l + 180 >> 2] = pe, t[l + 168 >> 2] = P, t[l + 172 >> 2] = gr, t[l + 160 >> 2] = a, t[l + 164 >> 2] = Tt, t[l + 152 >> 2] = w, t[l + 156 >> 2] = nr, t[l + 144 >> 2] = n, t[l + 148 >> 2] = b, n & 1 && (a = Nr | ei | Yr | jr | (tr | kr | ai | Me) ? -1 : 0, C = Nr ^ -1, P = C - 801750718 | 0, Nr = a & P, t[l + 408 >> 2] = Nr, w = tr ^ -1, n = w - ((C >>> 0 < 801750718) + 1076732275 | 0) | 0, tr = n & a, t[l + 412 >> 2] = tr, C = (w | 0) == (n | 0) & C >>> 0 > P >>> 0 | w >>> 0 > n >>> 0, P = ei ^ -1, n = C + P | 0, b = kr ^ -1, C = b, nr = n - 1354194885 | 0, ei = nr & a, t[l + 416 >> 2] = ei, C = n >>> 0 < P >>> 0 ? C + 1 | 0 : C, pe = C - ((n >>> 0 < 1354194885) + 1162945305 | 0) | 0, kr = pe & a, t[l + 420 >> 2] = kr, w = (C | 0) == (b | 0) & n >>> 0 < P >>> 0 | C >>> 0 < b >>> 0, P = (C | 0) == (pe | 0) & n >>> 0 > nr >>> 0 | C >>> 0 > pe >>> 0, n = w + P | 0, b = ai ^ -1, C = b + (n >>> 0 < P >>> 0) | 0, P = Yr ^ -1, n = P + n | 0, nr = n - 2 | 0, Yr = nr & a, t[l + 424 >> 2] = Yr, C = n >>> 0 < P >>> 0 ? C + 1 | 0 : C, pe = C - (n >>> 0 < 2) | 0, ai = pe & a, t[l + 428 >> 2] = ai, w = (C | 0) == (b | 0) & n >>> 0 < P >>> 0 | C >>> 0 < b >>> 0, n = (C | 0) == (pe | 0) & n >>> 0 > nr >>> 0 | C >>> 0 > pe >>> 0, w = w + n | 0, C = w >>> 0 < n >>> 0, n = w - jr | 0, P = n - 2 | 0, Me = (C - ((w >>> 0 < jr >>> 0) + Me | 0) | 0) - (n >>> 0 < 2) & a, jr = a & P, t[l + 432 >> 2] = jr, t[l + 436 >> 2] = Me), a = t[l + 112 >> 2], n = t[l + 116 >> 2], b = t[l + 108 >> 2], or = t[l + 136 >> 2], P = t[l + 140 >> 2], Ce = P, C = t[l + 104 >> 2], w = ri(P >>> 16 | 0, 0, 977, 1), P = C + w | 0, C = b + ve | 0, gr = w >>> 0 > P >>> 0 ? C + 1 | 0 : C, C = n, w = gr >>> 20 | 0, n = w + a | 0, pe = w >>> 0 > n >>> 0 ? C + 1 | 0 : C, b = pe & 1048575, nr = t[l + 128 >> 2], lr = t[l + 132 >> 2], C = t[l + 124 >> 2], w = pe >>> 20 | 0, a = w + t[l + 120 >> 2] | 0, Tt = w >>> 0 > a >>> 0 ? C + 1 | 0 : C, C = lr, w = Tt >>> 20 | 0, lr = w, w = w + nr | 0, C = lr >>> 0 > w >>> 0 ? C + 1 | 0 : C, nr = C & 1048575, Tt = Tt & 1048575, lr = (n & a & w) == -1 & (pe & Tt & C) == 1048575, pe = C, C = Ce & 65535, pe = pe >>> 20 | 0, or = pe + or | 0, C = pe >>> 0 > or >>> 0 ? C + 1 | 0 : C, pe = C, gr = gr & 1048575, lr & ((or | 0) == -1 & (C | 0) == 65535) & ((gr | 0) == 1048574 & P >>> 0 > 4294966318 | gr >>> 0 > 1048574) | C >>> 16 && (C = gr + 1 | 0, P = P + 977 | 0, C = P >>> 0 < 977 ? C + 1 | 0 : C, gr = C & 1048575, Ce = C, C = b, Ce = Ce >>> 20 | 0, n = n + Ce | 0, C = Ce >>> 0 > n >>> 0 ? C + 1 | 0 : C, b = C & 1048575, Ce = C, C = Tt, Ce = Ce >>> 20 | 0, a = a + Ce | 0, C = Ce >>> 0 > a >>> 0 ? C + 1 | 0 : C, Tt = C & 1048575, Ce = C, C = nr, Ce = Ce >>> 20 | 0, w = w + Ce | 0, C = Ce >>> 0 > w >>> 0 ? C + 1 | 0 : C, nr = C & 1048575, Ce = C, C = pe, pe = or, or = (Ce >>> 20 | 0) + or | 0, pe = (pe >>> 0 > or >>> 0 ? C + 1 | 0 : C) & 65535), t[l + 136 >> 2] = or, t[l + 140 >> 2] = pe, t[l + 128 >> 2] = w, t[l + 132 >> 2] = nr, t[l + 120 >> 2] = a, t[l + 124 >> 2] = Tt, t[l + 112 >> 2] = n, t[l + 116 >> 2] = b, t[l + 104 >> 2] = P, t[l + 108 >> 2] = gr, Rr(690981, l + 104 | 0), t[l + 600 >> 2] = 64, t[l + 604 >> 2] = 0, t[l + 528 >> 2] = -1862921884, t[l + 532 >> 2] = 870954602, t[l + 520 >> 2] = -1748470448, t[l + 524 >> 2] = 3983205, t[l + 512 >> 2] = 292000018, t[l + 516 >> 2] = -782074353, t[l + 504 >> 2] = -1662207471, t[l + 508 >> 2] = 596792193, C = l + 504 | 0, Wr(C, 690981, 32), Wr(C, l + 32 | 0, 32), Wr(C, 655649, 32), w = C, C = l + 608 | 0, fi(w, C), Ce = l + 440 | 0, Ir(Ce, C, 0), lr = l + 472 | 0, Er(Ce, Ce, lr), w = t[l + 440 >> 2], pe = w + Nr | 0, C = tr + t[l + 444 >> 2] | 0, b = w >>> 0 > pe >>> 0 ? C + 1 | 0 : C, n = (tr | 0) == (b | 0) & pe >>> 0 < Nr >>> 0 | b >>> 0 < tr >>> 0, w = t[l + 448 >> 2], a = n + w | 0, C = t[l + 452 >> 2], w = w >>> 0 > a >>> 0 ? C + 1 | 0 : C, C = w + kr | 0, n = !w & n >>> 0 > a >>> 0, tr = a + ei | 0, P = tr >>> 0 < ei >>> 0 ? C + 1 | 0 : C, a = (w | 0) == (P | 0) & a >>> 0 > tr >>> 0 | w >>> 0 > P >>> 0, w = n + a | 0, C = w >>> 0 < a >>> 0, Tt = w, w = t[l + 456 >> 2], a = Tt + w | 0, n = C, C = C + t[l + 460 >> 2] | 0, w = w >>> 0 > a >>> 0 ? C + 1 | 0 : C, C = w + ai | 0, nr = a, or = a + Yr | 0, C = or >>> 0 < Yr >>> 0 ? C + 1 | 0 : C, Nr = Me, Tt = (w | 0) == (n | 0) & a >>> 0 < Tt >>> 0 | w >>> 0 < n >>> 0, a = C, Me = or, n = (w | 0) == (C | 0) & Me >>> 0 < nr >>> 0 | C >>> 0 < w >>> 0, w = Tt + n | 0, C = w >>> 0 < n >>> 0, gr = w, n = t[l + 464 >> 2], w = w + n | 0, nr = C, C = C + t[l + 468 >> 2] | 0, n = w >>> 0 < n >>> 0 ? C + 1 | 0 : C, C = n + Nr | 0, Tt = w, w = w + jr | 0, Nr = Tt >>> 0 > w >>> 0 ? C + 1 | 0 : C, or = w, gr = ((n | 0) == (Nr | 0) & Tt >>> 0 > w >>> 0 | n >>> 0 > Nr >>> 0) + ((n | 0) == (nr | 0) & Tt >>> 0 < gr >>> 0 | n >>> 0 < nr >>> 0) | 0, n = (a | 0) == -1, nr = n & Me >>> 0 < 4294967294 | (a | 0) != -1 | (w & Nr) != -1, C = (P | 0) == -1162945306, Tt = (nr | (C & tr >>> 0 < 2940772411 | P >>> 0 < 3132021990)) ^ -1, nr = gr + (Tt & ((b | 0) == -1076732276 & pe >>> 0 > 3493216576 | b >>> 0 > 3218235020) | (Tt & (C & tr >>> 0 > 2940772411 | P >>> 0 > 3132021990) | (Me | 0) == -1 & n & (nr ^ -1))) | 0, n = ri(nr, 0, 801750719, 1076732275), Tt = n + pe | 0, C = b + ve | 0, t[l + 440 >> 2] = Tt, C = n >>> 0 > Tt >>> 0 ? C + 1 | 0 : C, t[l + 444 >> 2] = C, pe = (C | 0) == (b | 0) & pe >>> 0 > Tt >>> 0 | C >>> 0 < b >>> 0, b = ri(nr, 0, 1354194884, 1162945305), w = b + tr | 0, C = P + ve | 0, C = w >>> 0 < b >>> 0 ? C + 1 | 0 : C, b = w, w = C, pe = b + pe | 0, C = pe >>> 0 < b >>> 0 ? C + 1 | 0 : C, t[l + 448 >> 2] = pe, t[l + 452 >> 2] = C, n = (w | 0) == (P | 0) & b >>> 0 < tr >>> 0 | w >>> 0 < P >>> 0, P = (C | 0) == (w | 0) & b >>> 0 > pe >>> 0 | C >>> 0 < w >>> 0, w = n + P | 0, b = w, P = w >>> 0 < P >>> 0, C = a, tr = Me + nr | 0, w = tr >>> 0 < nr >>> 0 ? C + 1 | 0 : C, C = w + P | 0, P = tr, b = b + P | 0, C = P >>> 0 > b >>> 0 ? C + 1 | 0 : C, t[l + 456 >> 2] = b, t[l + 460 >> 2] = C, n = (w | 0) == (a | 0) & P >>> 0 < Me >>> 0 | w >>> 0 < a >>> 0, a = (C | 0) == (w | 0) & b >>> 0 < P >>> 0 | C >>> 0 < w >>> 0, w = n + a | 0, C = Nr + (w >>> 0 < a >>> 0) | 0, w = w + or | 0, C = w >>> 0 < or >>> 0 ? C + 1 | 0 : C, t[l + 464 >> 2] = w, t[l + 468 >> 2] = C, pr(691013, Ce), t[l + 504 >> 2] = ui, C = t[l + 504 >> 2] - 1 | 0, c[690981] = C & d[690981], c[690982] = d[690982] & C, c[690983] = d[690983] & C, c[690984] = d[690984] & C, c[690985] = d[690985] & C, c[690986] = d[690986] & C, c[690987] = d[690987] & C, c[690988] = d[690988] & C, c[690989] = d[690989] & C, c[690990] = d[690990] & C, c[690991] = d[690991] & C, c[690992] = d[690992] & C, c[690993] = d[690993] & C, c[690994] = d[690994] & C, c[690995] = d[690995] & C, c[690996] = d[690996] & C, c[690997] = d[690997] & C, c[690998] = d[690998] & C, c[690999] = d[690999] & C, c[691e3] = d[691e3] & C, c[691001] = d[691001] & C, c[691002] = d[691002] & C, c[691003] = d[691003] & C, c[691004] = d[691004] & C, c[691005] = d[691005] & C, c[691006] = d[691006] & C, c[691007] = d[691007] & C, c[691008] = d[691008] & C, c[691009] = d[691009] & C, c[691010] = d[691010] & C, c[691011] = d[691011] & C, c[691012] = d[691012] & C, c[691013] = d[691013] & C, c[691014] = d[691014] & C, c[691015] = d[691015] & C, c[691016] = d[691016] & C, c[691017] = d[691017] & C, c[691018] = d[691018] & C, c[691019] = d[691019] & C, c[691020] = d[691020] & C, c[691021] = d[691021] & C, c[691022] = d[691022] & C, c[691023] = d[691023] & C, c[691024] = d[691024] & C, c[691025] = d[691025] & C, c[691026] = d[691026] & C, c[691027] = d[691027] & C, c[691028] = d[691028] & C, c[691029] = d[691029] & C, c[691030] = d[691030] & C, c[691031] = d[691031] & C, c[691032] = d[691032] & C, c[691033] = d[691033] & C, c[691034] = d[691034] & C, c[691035] = d[691035] & C, c[691036] = d[691036] & C, c[691037] = d[691037] & C, c[691038] = d[691038] & C, c[691039] = d[691039] & C, c[691040] = d[691040] & C, c[691041] = d[691041] & C, c[691042] = d[691042] & C, c[691043] = d[691043] & C, c[691044] = d[691044] & C, C = l + 408 | 0, w = C + 24 | 0, t[w >> 2] = 0, t[w + 4 >> 2] = 0, w = C + 16 | 0, t[w >> 2] = 0, t[w + 4 >> 2] = 0, C = C + 8 | 0, t[C >> 2] = 0, t[C + 4 >> 2] = 0, t[l + 408 >> 2] = 0, t[l + 412 >> 2] = 0, C = lr + 24 | 0, t[C >> 2] = 0, t[C + 4 >> 2] = 0, C = lr + 16 | 0, t[C >> 2] = 0, t[C + 4 >> 2] = 0, C = lr + 8 | 0, t[C >> 2] = 0, t[C + 4 >> 2] = 0, t[l + 472 >> 2] = 0, t[l + 476 >> 2] = 0, C = l + 24 | 0, t[C >> 2] = 0, t[C + 4 >> 2] = 0, C = l + 16 | 0, t[C >> 2] = 0, t[C + 4 >> 2] = 0, t[l + 8 >> 2] = 0, t[l + 12 >> 2] = 0, t[l >> 2] = 0, t[l + 4 >> 2] = 0;
          }
          if (U = l + 640 | 0, t[K + 100 >> 2] = di, di)
            break t;
          break e;
        }
        break e;
      }
      U = K + 128 | 0;
      return;
    }
    t[K + 112 >> 2] = 0, Ne(K + 104 | 0), wasm2js_trap();
  }
  function Fr(C, l) {
    C = C | 0, l = l | 0;
    var w = 0, n = 0, a = 0, b = 0, P = 0, K = 0, pe = 0, Ce = 0, Me = 0, Tt = 0, tr = 0, nr = 0, or = 0, lr = 0, gr = 0, kr = 0, Nr = 0, jr = 0, Yr = 0, ei = 0, ai = 0, ui = 0, di = 0, Ii = 0, wi = 0, Ei = 0, Ti = 0, Di = 0, Qi = 0, Li = 0, Ki = 0, Wi = 0, Xi = 0, $i = 0, In = 0, kn = 0;
    b = U - 192 | 0, U = b, a = b + 128 | 0, P = a + 56 | 0, t[P >> 2] = 0, t[P + 4 >> 2] = 0, K = a + 48 | 0, t[K >> 2] = 0, t[K + 4 >> 2] = 0, pe = a + 40 | 0, t[pe >> 2] = 0, t[pe + 4 >> 2] = 0, tr = a + 32 | 0, t[tr >> 2] = 0, t[tr + 4 >> 2] = 0, Ce = a + 24 | 0, t[Ce >> 2] = 0, t[Ce + 4 >> 2] = 0, Tt = a + 16 | 0, t[Tt >> 2] = 0, t[Tt + 4 >> 2] = 0, kr = a + 8 | 0, t[kr >> 2] = 0, t[kr + 4 >> 2] = 0, t[b + 128 >> 2] = 0, t[b + 132 >> 2] = 0;
    e: {
      if ((Bi(t[172688], a, 690820, C) | 0) == 1) {
        a = b + 128 | 0, C = a + 15 | 0, w = d[C + 4 | 0] | d[C + 5 | 0] << 8 | (d[C + 6 | 0] << 16 | d[C + 7 | 0] << 24), n = b - -64 | 0, Me = n + 8 | 0, t[Me >> 2] = d[C | 0] | d[C + 1 | 0] << 8 | (d[C + 2 | 0] << 16 | d[C + 3 | 0] << 24), t[Me + 4 >> 2] = w, C = a + 23 | 0, w = d[C + 4 | 0] | d[C + 5 | 0] << 8 | (d[C + 6 | 0] << 16 | d[C + 7 | 0] << 24), or = n + 16 | 0, t[or >> 2] = d[C | 0] | d[C + 1 | 0] << 8 | (d[C + 2 | 0] << 16 | d[C + 3 | 0] << 24), t[or + 4 >> 2] = w, C = a + 31 | 0, w = d[C + 4 | 0] | d[C + 5 | 0] << 8 | (d[C + 6 | 0] << 16 | d[C + 7 | 0] << 24), gr = n + 24 | 0, t[gr >> 2] = d[C | 0] | d[C + 1 | 0] << 8 | (d[C + 2 | 0] << 16 | d[C + 3 | 0] << 24), t[gr + 4 >> 2] = w, C = a + 39 | 0, w = d[C + 4 | 0] | d[C + 5 | 0] << 8 | (d[C + 6 | 0] << 16 | d[C + 7 | 0] << 24), lr = n + 32 | 0, t[lr >> 2] = d[C | 0] | d[C + 1 | 0] << 8 | (d[C + 2 | 0] << 16 | d[C + 3 | 0] << 24), t[lr + 4 >> 2] = w, C = a + 47 | 0, w = d[C + 4 | 0] | d[C + 5 | 0] << 8 | (d[C + 6 | 0] << 16 | d[C + 7 | 0] << 24), nr = n + 40 | 0, t[nr >> 2] = d[C | 0] | d[C + 1 | 0] << 8 | (d[C + 2 | 0] << 16 | d[C + 3 | 0] << 24), t[nr + 4 >> 2] = w, C = a + 55 | 0, w = d[C + 4 | 0] | d[C + 5 | 0] << 8 | (d[C + 6 | 0] << 16 | d[C + 7 | 0] << 24), Nr = n + 48 | 0, t[Nr >> 2] = d[C | 0] | d[C + 1 | 0] << 8 | (d[C + 2 | 0] << 16 | d[C + 3 | 0] << 24), t[Nr + 4 >> 2] = w, n = n + 56 | 0, c[n | 0] = d[a + 63 | 0], c[b + 2 | 0] = d[b + 130 | 0], y[b >> 1] = E[b + 128 >> 1], C = d[b + 139 | 0] | d[b + 140 | 0] << 8 | (d[b + 141 | 0] << 16 | d[b + 142 | 0] << 24), t[b + 64 >> 2] = d[b + 135 | 0] | d[b + 136 | 0] << 8 | (d[b + 137 | 0] << 16 | d[b + 138 | 0] << 24), t[b + 68 >> 2] = C, C = d[b + 131 | 0] | d[b + 132 | 0] << 8 | (d[b + 133 | 0] << 16 | d[b + 134 | 0] << 24), c[b + 63 | 0] = d[n | 0], w = t[Nr + 4 >> 2], n = b + 55 | 0, Nr = t[Nr >> 2], c[n | 0] = Nr, c[n + 1 | 0] = Nr >>> 8, c[n + 2 | 0] = Nr >>> 16, c[n + 3 | 0] = Nr >>> 24, c[n + 4 | 0] = w, c[n + 5 | 0] = w >>> 8, c[n + 6 | 0] = w >>> 16, c[n + 7 | 0] = w >>> 24, w = t[nr + 4 >> 2], n = b + 47 | 0, nr = t[nr >> 2], c[n | 0] = nr, c[n + 1 | 0] = nr >>> 8, c[n + 2 | 0] = nr >>> 16, c[n + 3 | 0] = nr >>> 24, c[n + 4 | 0] = w, c[n + 5 | 0] = w >>> 8, c[n + 6 | 0] = w >>> 16, c[n + 7 | 0] = w >>> 24, w = t[lr + 4 >> 2], n = b + 39 | 0, lr = t[lr >> 2], c[n | 0] = lr, c[n + 1 | 0] = lr >>> 8, c[n + 2 | 0] = lr >>> 16, c[n + 3 | 0] = lr >>> 24, c[n + 4 | 0] = w, c[n + 5 | 0] = w >>> 8, c[n + 6 | 0] = w >>> 16, c[n + 7 | 0] = w >>> 24, w = t[gr + 4 >> 2], n = b + 31 | 0, gr = t[gr >> 2], c[n | 0] = gr, c[n + 1 | 0] = gr >>> 8, c[n + 2 | 0] = gr >>> 16, c[n + 3 | 0] = gr >>> 24, c[n + 4 | 0] = w, c[n + 5 | 0] = w >>> 8, c[n + 6 | 0] = w >>> 16, c[n + 7 | 0] = w >>> 24, w = t[or + 4 >> 2], n = b + 23 | 0, or = t[or >> 2], c[n | 0] = or, c[n + 1 | 0] = or >>> 8, c[n + 2 | 0] = or >>> 16, c[n + 3 | 0] = or >>> 24, c[n + 4 | 0] = w, c[n + 5 | 0] = w >>> 8, c[n + 6 | 0] = w >>> 16, c[n + 7 | 0] = w >>> 24, w = t[Me + 4 >> 2], n = b + 15 | 0, Me = t[Me >> 2], c[n | 0] = Me, c[n + 1 | 0] = Me >>> 8, c[n + 2 | 0] = Me >>> 16, c[n + 3 | 0] = Me >>> 24, c[n + 4 | 0] = w, c[n + 5 | 0] = w >>> 8, c[n + 6 | 0] = w >>> 16, c[n + 7 | 0] = w >>> 24, c[b + 3 | 0] = C, c[b + 4 | 0] = C >>> 8, c[b + 5 | 0] = C >>> 16, c[b + 6 | 0] = C >>> 24, C = t[b + 68 >> 2], n = t[b + 64 >> 2], c[b + 7 | 0] = n, c[b + 8 | 0] = n >>> 8, c[b + 9 | 0] = n >>> 16, c[b + 10 | 0] = n >>> 24, c[b + 11 | 0] = C, c[b + 12 | 0] = C >>> 8, c[b + 13 | 0] = C >>> 16, c[b + 14 | 0] = C >>> 24, t[P >> 2] = 0, t[P + 4 >> 2] = 0, t[K >> 2] = 0, t[K + 4 >> 2] = 0, t[pe >> 2] = 0, t[pe + 4 >> 2] = 0, t[tr >> 2] = 0, t[tr + 4 >> 2] = 0, t[Ce >> 2] = 0, t[Ce + 4 >> 2] = 0, t[Tt >> 2] = 0, t[Tt + 4 >> 2] = 0, t[kr >> 2] = 0, t[kr + 4 >> 2] = 0, t[b + 128 >> 2] = 0, t[b + 132 >> 2] = 0, n = 0, P = t[172688], w = 0, C = U - 80 | 0, U = C, t[C + 12 >> 2] = 0;
        t: {
          if (!a) {
            yi[t[P + 168 >> 2]](689748, t[P + 172 >> 2]);
            break t;
          }
          if (w = C + 12 | 0, Ir(C + 48 | 0, 690981, w), P = t[C + 12 >> 2], Ir(C + 16 | 0, 691013, w), !(P | t[C + 12 >> 2])) {
            w = t[C + 52 >> 2], P = t[C + 48 >> 2], c[a | 0] = P, c[a + 1 | 0] = P >>> 8, c[a + 2 | 0] = P >>> 16, c[a + 3 | 0] = P >>> 24, c[a + 4 | 0] = w, c[a + 5 | 0] = w >>> 8, c[a + 6 | 0] = w >>> 16, c[a + 7 | 0] = w >>> 24, w = t[C + 20 >> 2], P = t[C + 16 >> 2], c[a + 32 | 0] = P, c[a + 33 | 0] = P >>> 8, c[a + 34 | 0] = P >>> 16, c[a + 35 | 0] = P >>> 24, c[a + 36 | 0] = w, c[a + 37 | 0] = w >>> 8, c[a + 38 | 0] = w >>> 16, c[a + 39 | 0] = w >>> 24, pe = C + 48 | 0, K = pe + 24 | 0, P = t[K + 4 >> 2], w = a + 24 | 0, K = t[K >> 2], c[w | 0] = K, c[w + 1 | 0] = K >>> 8, c[w + 2 | 0] = K >>> 16, c[w + 3 | 0] = K >>> 24, c[w + 4 | 0] = P, c[w + 5 | 0] = P >>> 8, c[w + 6 | 0] = P >>> 16, c[w + 7 | 0] = P >>> 24, K = pe + 16 | 0, P = t[K + 4 >> 2], w = a + 16 | 0, K = t[K >> 2], c[w | 0] = K, c[w + 1 | 0] = K >>> 8, c[w + 2 | 0] = K >>> 16, c[w + 3 | 0] = K >>> 24, c[w + 4 | 0] = P, c[w + 5 | 0] = P >>> 8, c[w + 6 | 0] = P >>> 16, c[w + 7 | 0] = P >>> 24, K = pe + 8 | 0, P = t[K + 4 >> 2], w = a + 8 | 0, K = t[K >> 2], c[w | 0] = K, c[w + 1 | 0] = K >>> 8, c[w + 2 | 0] = K >>> 16, c[w + 3 | 0] = K >>> 24, c[w + 4 | 0] = P, c[w + 5 | 0] = P >>> 8, c[w + 6 | 0] = P >>> 16, c[w + 7 | 0] = P >>> 24, pe = C + 16 | 0, K = pe + 8 | 0, P = t[K + 4 >> 2], w = a + 40 | 0, K = t[K >> 2], c[w | 0] = K, c[w + 1 | 0] = K >>> 8, c[w + 2 | 0] = K >>> 16, c[w + 3 | 0] = K >>> 24, c[w + 4 | 0] = P, c[w + 5 | 0] = P >>> 8, c[w + 6 | 0] = P >>> 16, c[w + 7 | 0] = P >>> 24, K = pe + 16 | 0, P = t[K + 4 >> 2], w = a + 48 | 0, K = t[K >> 2], c[w | 0] = K, c[w + 1 | 0] = K >>> 8, c[w + 2 | 0] = K >>> 16, c[w + 3 | 0] = K >>> 24, c[w + 4 | 0] = P, c[w + 5 | 0] = P >>> 8, c[w + 6 | 0] = P >>> 16, c[w + 7 | 0] = P >>> 24, P = pe + 24 | 0, w = t[P + 4 >> 2], a = a + 56 | 0, P = t[P >> 2], c[a | 0] = P, c[a + 1 | 0] = P >>> 8, c[a + 2 | 0] = P >>> 16, c[a + 3 | 0] = P >>> 24, c[a + 4 | 0] = w, c[a + 5 | 0] = w >>> 8, c[a + 6 | 0] = w >>> 16, c[a + 7 | 0] = w >>> 24, w = 1;
            break t;
          }
          c[a | 0] = 0, c[a + 1 | 0] = 0, c[a + 2 | 0] = 0, c[a + 3 | 0] = 0, c[a + 4 | 0] = 0, c[a + 5 | 0] = 0, c[a + 6 | 0] = 0, c[a + 7 | 0] = 0, w = a + 56 | 0, c[w | 0] = 0, c[w + 1 | 0] = 0, c[w + 2 | 0] = 0, c[w + 3 | 0] = 0, c[w + 4 | 0] = 0, c[w + 5 | 0] = 0, c[w + 6 | 0] = 0, c[w + 7 | 0] = 0, w = a + 48 | 0, c[w | 0] = 0, c[w + 1 | 0] = 0, c[w + 2 | 0] = 0, c[w + 3 | 0] = 0, c[w + 4 | 0] = 0, c[w + 5 | 0] = 0, c[w + 6 | 0] = 0, c[w + 7 | 0] = 0, w = a + 40 | 0, c[w | 0] = 0, c[w + 1 | 0] = 0, c[w + 2 | 0] = 0, c[w + 3 | 0] = 0, c[w + 4 | 0] = 0, c[w + 5 | 0] = 0, c[w + 6 | 0] = 0, c[w + 7 | 0] = 0, w = a + 32 | 0, c[w | 0] = 0, c[w + 1 | 0] = 0, c[w + 2 | 0] = 0, c[w + 3 | 0] = 0, c[w + 4 | 0] = 0, c[w + 5 | 0] = 0, c[w + 6 | 0] = 0, c[w + 7 | 0] = 0, w = a + 24 | 0, c[w | 0] = 0, c[w + 1 | 0] = 0, c[w + 2 | 0] = 0, c[w + 3 | 0] = 0, c[w + 4 | 0] = 0, c[w + 5 | 0] = 0, c[w + 6 | 0] = 0, c[w + 7 | 0] = 0, w = a + 16 | 0, c[w | 0] = 0, c[w + 1 | 0] = 0, c[w + 2 | 0] = 0, c[w + 3 | 0] = 0, c[w + 4 | 0] = 0, c[w + 5 | 0] = 0, c[w + 6 | 0] = 0, c[w + 7 | 0] = 0, a = a + 8 | 0, c[a | 0] = 0, c[a + 1 | 0] = 0, c[a + 2 | 0] = 0, c[a + 3 | 0] = 0, c[a + 4 | 0] = 0, c[a + 5 | 0] = 0, c[a + 6 | 0] = 0, c[a + 7 | 0] = 0, w = 0;
        }
        if (U = C + 80 | 0, !w) {
          M(4);
          break e;
        }
        if (!l)
          t: {
            if (C = t[172688], w = b + 128 | 0, !w) {
              yi[t[C + 168 >> 2]](689716, t[C + 172 >> 2]);
              break t;
            }
            l = d[w + 60 | 0] | d[w + 61 | 0] << 8 | (d[w + 62 | 0] << 16 | d[w + 63 | 0] << 24), tr = l, l = l >>> 31 | 0, n = l ^ -1, Ce = d[w + 44 | 0] | d[w + 45 | 0] << 8 | (d[w + 46 | 0] << 16 | d[w + 47 | 0] << 24), a = (Ce | 0) == 1566010995, Tt = d[w + 40 | 0] | d[w + 41 | 0] << 8 | (d[w + 42 | 0] << 16 | d[w + 43 | 0] << 24), Me = d[w + 48 | 0] | d[w + 49 | 0] << 8 | (d[w + 50 | 0] << 16 | d[w + 51 | 0] << 24), or = d[w + 52 | 0] | d[w + 53 | 0] << 8 | (d[w + 54 | 0] << 16 | d[w + 55 | 0] << 24), C = d[w + 56 | 0] | d[w + 57 | 0] << 8 | (d[w + 58 | 0] << 16 | d[w + 59 | 0] << 24), n = (n & (a & Tt >>> 0 < 1470386205 | Ce >>> 0 < 1566010995) | (n & (Me & or) != -1 | ((tr | 0) == 2147483647 & (C | 0) != -1 | tr >>> 0 < 2147483647))) ^ -1, kr = d[w + 36 | 0] | d[w + 37 | 0] << 8 | (d[w + 38 | 0] << 16 | d[w + 39 | 0] << 24), gr = d[w + 32 | 0] | d[w + 33 | 0] << 8 | (d[w + 34 | 0] << 16 | d[w + 35 | 0] << 24), l = n & ((kr | 0) == -538366138 & gr >>> 0 > 1746608288 | kr >>> 0 > 3756601158) | (n & (a & Tt >>> 0 > 1470386205 | Ce >>> 0 > 1566010995) | l), w && (l && (l = gr ^ -1, a = l - 801750718 | 0, nr = a, n = kr ^ -1, K = n - ((l >>> 0 < 801750718) + 1076732275 | 0) | 0, a = (n | 0) == (K | 0) & l >>> 0 > a >>> 0 | n >>> 0 > K >>> 0, lr = Tt ^ -1, l = a + lr | 0, n = Ce ^ -1, P = l >>> 0 < a >>> 0 ? n + 1 | 0 : n, a = l - 1354194885 | 0, Nr = a, jr = Me ^ -1, n = (n | 0) == (P | 0) & l >>> 0 < lr >>> 0 | n >>> 0 > P >>> 0, lr = P - ((l >>> 0 < 1354194885) + 1162945305 | 0) | 0, a = (lr | 0) == (P | 0) & l >>> 0 > a >>> 0 | P >>> 0 > lr >>> 0, l = n + a | 0, pe = or ^ -1, n = pe + (l >>> 0 < a >>> 0) | 0, a = l + jr | 0, n = a >>> 0 < l >>> 0 ? n + 1 | 0 : n, P = a - 2 | 0, Yr = P, l = Tt | gr | Me | C | (Ce | kr | or | tr) ? -1 : 0, or = (n | 0) == (pe | 0) & a >>> 0 < jr >>> 0 | n >>> 0 < pe >>> 0, pe = n - (a >>> 0 < 2) | 0, n = (pe | 0) == (n | 0) & a >>> 0 > P >>> 0 | n >>> 0 > pe >>> 0, a = or + n | 0, P = n >>> 0 > a >>> 0, n = C, Ce = a - n | 0, C = Ce - 2 & l, tr = l & (P - ((n >>> 0 > a >>> 0) + tr | 0) | 0) - (Ce >>> 0 < 2), n = l, Me = n & Yr, or = n & pe, gr = n & nr, kr = n & K, Tt = n & Nr, Ce = n & lr), P = w + 8 | 0, lr = d[P | 0] | d[P + 1 | 0] << 8 | (d[P + 2 | 0] << 16 | d[P + 3 | 0] << 24), n = d[P + 4 | 0] | d[P + 5 | 0] << 8 | (d[P + 6 | 0] << 16 | d[P + 7 | 0] << 24), K = w + 16 | 0, nr = d[K | 0] | d[K + 1 | 0] << 8 | (d[K + 2 | 0] << 16 | d[K + 3 | 0] << 24), l = d[K + 4 | 0] | d[K + 5 | 0] << 8 | (d[K + 6 | 0] << 16 | d[K + 7 | 0] << 24), Nr = d[w | 0] | d[w + 1 | 0] << 8 | (d[w + 2 | 0] << 16 | d[w + 3 | 0] << 24), a = d[w + 4 | 0] | d[w + 5 | 0] << 8 | (d[w + 6 | 0] << 16 | d[w + 7 | 0] << 24), pe = w + 24 | 0, jr = d[pe + 4 | 0] | d[pe + 5 | 0] << 8 | (d[pe + 6 | 0] << 16 | d[pe + 7 | 0] << 24), Yr = d[pe | 0] | d[pe + 1 | 0] << 8 | (d[pe + 2 | 0] << 16 | d[pe + 3 | 0] << 24), c[pe | 0] = Yr, c[pe + 1 | 0] = Yr >>> 8, c[pe + 2 | 0] = Yr >>> 16, c[pe + 3 | 0] = Yr >>> 24, c[pe + 4 | 0] = jr, c[pe + 5 | 0] = jr >>> 8, c[pe + 6 | 0] = jr >>> 16, c[pe + 7 | 0] = jr >>> 24, c[K | 0] = nr, c[K + 1 | 0] = nr >>> 8, c[K + 2 | 0] = nr >>> 16, c[K + 3 | 0] = nr >>> 24, c[K + 4 | 0] = l, c[K + 5 | 0] = l >>> 8, c[K + 6 | 0] = l >>> 16, c[K + 7 | 0] = l >>> 24, c[P | 0] = lr, c[P + 1 | 0] = lr >>> 8, c[P + 2 | 0] = lr >>> 16, c[P + 3 | 0] = lr >>> 24, c[P + 4 | 0] = n, c[P + 5 | 0] = n >>> 8, c[P + 6 | 0] = n >>> 16, c[P + 7 | 0] = n >>> 24, c[w | 0] = Nr, c[w + 1 | 0] = Nr >>> 8, c[w + 2 | 0] = Nr >>> 16, c[w + 3 | 0] = Nr >>> 24, c[w + 4 | 0] = a, c[w + 5 | 0] = a >>> 8, c[w + 6 | 0] = a >>> 16, c[w + 7 | 0] = a >>> 24, c[w + 56 | 0] = C, c[w + 57 | 0] = C >>> 8, c[w + 58 | 0] = C >>> 16, c[w + 59 | 0] = C >>> 24, c[w + 60 | 0] = tr, c[w + 61 | 0] = tr >>> 8, c[w + 62 | 0] = tr >>> 16, c[w + 63 | 0] = tr >>> 24, c[w + 48 | 0] = Me, c[w + 49 | 0] = Me >>> 8, c[w + 50 | 0] = Me >>> 16, c[w + 51 | 0] = Me >>> 24, c[w + 52 | 0] = or, c[w + 53 | 0] = or >>> 8, c[w + 54 | 0] = or >>> 16, c[w + 55 | 0] = or >>> 24, c[w + 40 | 0] = Tt, c[w + 41 | 0] = Tt >>> 8, c[w + 42 | 0] = Tt >>> 16, c[w + 43 | 0] = Tt >>> 24, c[w + 44 | 0] = Ce, c[w + 45 | 0] = Ce >>> 8, c[w + 46 | 0] = Ce >>> 16, c[w + 47 | 0] = Ce >>> 24, c[w + 32 | 0] = gr, c[w + 33 | 0] = gr >>> 8, c[w + 34 | 0] = gr >>> 16, c[w + 35 | 0] = gr >>> 24, c[w + 36 | 0] = kr, c[w + 37 | 0] = kr >>> 8, c[w + 38 | 0] = kr >>> 16, c[w + 39 | 0] = kr >>> 24);
          }
        nr = Et(), C = 0, l = U - 464 | 0, U = l, n = b + 128 | 0;
        t: {
          if (!n) {
            yi[t[nr + 168 >> 2]](689748, t[nr + 172 >> 2]);
            break t;
          }
          if (!b) {
            yi[t[nr + 168 >> 2]](689638, t[nr + 172 >> 2]);
            break t;
          }
          if (Ir(l + 8 | 0, 655649, 0), a = n + 24 | 0, P = d[a + 4 | 0] | d[a + 5 | 0] << 8 | (d[a + 6 | 0] << 16 | d[a + 7 | 0] << 24), w = l + 40 | 0, K = w + 24 | 0, t[K >> 2] = d[a | 0] | d[a + 1 | 0] << 8 | (d[a + 2 | 0] << 16 | d[a + 3 | 0] << 24), t[K + 4 >> 2] = P, a = n + 16 | 0, P = d[a + 4 | 0] | d[a + 5 | 0] << 8 | (d[a + 6 | 0] << 16 | d[a + 7 | 0] << 24), K = w + 16 | 0, t[K >> 2] = d[a | 0] | d[a + 1 | 0] << 8 | (d[a + 2 | 0] << 16 | d[a + 3 | 0] << 24), t[K + 4 >> 2] = P, a = n + 8 | 0, P = d[a + 4 | 0] | d[a + 5 | 0] << 8 | (d[a + 6 | 0] << 16 | d[a + 7 | 0] << 24), w = w + 8 | 0, t[w >> 2] = d[a | 0] | d[a + 1 | 0] << 8 | (d[a + 2 | 0] << 16 | d[a + 3 | 0] << 24), t[w + 4 >> 2] = P, a = d[n + 4 | 0] | d[n + 5 | 0] << 8 | (d[n + 6 | 0] << 16 | d[n + 7 | 0] << 24), t[l + 40 >> 2] = d[n | 0] | d[n + 1 | 0] << 8 | (d[n + 2 | 0] << 16 | d[n + 3 | 0] << 24), t[l + 44 >> 2] = a, P = d[n + 36 | 0] | d[n + 37 | 0] << 8 | (d[n + 38 | 0] << 16 | d[n + 39 | 0] << 24), ei = d[n + 32 | 0] | d[n + 33 | 0] << 8 | (d[n + 34 | 0] << 16 | d[n + 35 | 0] << 24), a = d[n + 60 | 0] | d[n + 61 | 0] << 8 | (d[n + 62 | 0] << 16 | d[n + 63 | 0] << 24), pe = a >>> 31 | 0, Me = pe ^ -1, w = d[n + 44 | 0] | d[n + 45 | 0] << 8 | (d[n + 46 | 0] << 16 | d[n + 47 | 0] << 24), Tt = (w | 0) == 1566010995, K = d[n + 40 | 0] | d[n + 41 | 0] << 8 | (d[n + 42 | 0] << 16 | d[n + 43 | 0] << 24), kr = d[n + 48 | 0] | d[n + 49 | 0] << 8 | (d[n + 50 | 0] << 16 | d[n + 51 | 0] << 24), Ce = d[n + 52 | 0] | d[n + 53 | 0] << 8 | (d[n + 54 | 0] << 16 | d[n + 55 | 0] << 24), tr = d[n + 56 | 0] | d[n + 57 | 0] << 8 | (d[n + 58 | 0] << 16 | d[n + 59 | 0] << 24), n = (Me & (Tt & K >>> 0 < 1470386205 | w >>> 0 < 1566010995) | (Me & (kr & Ce) != -1 | ((a | 0) == 2147483647 & (tr | 0) != -1 | a >>> 0 < 2147483647))) ^ -1, ((P | 0) == -538366138 & ei >>> 0 > 1746608288 | P >>> 0 > 3756601158) & n | (n & (Tt & K >>> 0 > 1470386205 | w >>> 0 > 1566010995) | pe))
            break t;
          if (n = d[b + 12 | 0] | d[b + 13 | 0] << 8 | (d[b + 14 | 0] << 16 | d[b + 15 | 0] << 24), Tt = n, pe = d[b + 8 | 0] | d[b + 9 | 0] << 8 | (d[b + 10 | 0] << 16 | d[b + 11 | 0] << 24), Me = (n << 12 | pe >>> 20) & 1048575, or = d[b + 4 | 0] | d[b + 5 | 0] << 8 | (d[b + 6 | 0] << 16 | d[b + 7 | 0] << 24), Nr = or, ai = pe << 12 & -4096 | or >>> 20, ui = Me, pe = d[b + 16 | 0] | d[b + 17 | 0] << 8 | (d[b + 18 | 0] << 16 | d[b + 19 | 0] << 24), jr = pe, n = d[b + 20 | 0] | d[b + 21 | 0] << 8 | (d[b + 22 | 0] << 16 | d[b + 23 | 0] << 24), lr = n, Me = (n << 24 | pe >>> 8) & 1048575, di = pe << 24 & -16777216 | Tt >>> 8, Ii = Me, Tt = d[b + 28 | 0] | d[b + 29 | 0] << 8 | (d[b + 30 | 0] << 16 | d[b + 31 | 0] << 24), n = Tt >>> 16 | 0, pe = d[b + 24 | 0] | d[b + 25 | 0] << 8 | (d[b + 26 | 0] << 16 | d[b + 27 | 0] << 24), Me = (Tt & 65535) << 16 | pe >>> 16, or = n, Tt = pe << 4 & 1048560, pe = lr, n = pe >>> 28 | 0, wi = (pe & 268435455) << 4 | jr >>> 28, Ei = d[b | 0] | d[b + 1 | 0] << 8 | (d[b + 2 | 0] << 16 | d[b + 3 | 0] << 24), Ti = n | Tt, Di = Nr & 1048575, !(wi | (di | (Me | (ai | Ei))) | (Ti | (Ii | (or | (ui | Di)))))) {
            yi[t[nr + 168 >> 2]](690116, t[nr + 172 >> 2]);
            break t;
          }
          if (Tt = t[l + 64 >> 2], gr = t[l + 56 >> 2], Qi = t[l + 48 >> 2], Li = t[l + 40 >> 2], pe = t[l + 68 >> 2], Nr = t[l + 60 >> 2], lr = t[l + 52 >> 2], nr = t[l + 44 >> 2], !(Tt | (gr | (Qi | Li)) | (pe | (Nr | (lr | nr)))) || !(K | ei | kr | tr | (w | P | Ce | a)) || (jr = d[b + 48 | 0] | d[b + 49 | 0] << 8 | (d[b + 50 | 0] << 16 | d[b + 51 | 0] << 24), Yr = d[b + 52 | 0] | d[b + 53 | 0] << 8 | (d[b + 54 | 0] << 16 | d[b + 55 | 0] << 24), Ki = d[b + 56 | 0] | d[b + 57 | 0] << 8 | (d[b + 58 | 0] << 16 | d[b + 59 | 0] << 24), Xi = d[b + 60 | 0] | d[b + 61 | 0] << 8 | (d[b + 62 | 0] << 16 | d[b + 63 | 0] << 24), $i = d[b + 40 | 0] | d[b + 41 | 0] << 8 | (d[b + 42 | 0] << 16 | d[b + 43 | 0] << 24), In = d[b + 44 | 0] | d[b + 45 | 0] << 8 | (d[b + 46 | 0] << 16 | d[b + 47 | 0] << 24), kn = d[b + 32 | 0] | d[b + 33 | 0] << 8 | (d[b + 34 | 0] << 16 | d[b + 35 | 0] << 24), Wi = d[b + 36 | 0] | d[b + 37 | 0] << 8 | (d[b + 38 | 0] << 16 | d[b + 39 | 0] << 24), t[l + 232 >> 2] = a >>> 24, t[l + 236 >> 2] = 0, t[l + 200 >> 2] = ei, t[l + 204 >> 2] = P & 1073741823, n = a << 6 | tr >>> 26, a = Ce, t[l + 224 >> 2] = tr << 6 | a >>> 26, t[l + 228 >> 2] = n & 1073741823, n = a << 4 | kr >>> 28, t[l + 216 >> 2] = kr << 4 | w >>> 28, t[l + 220 >> 2] = n & 1073741823, w = w << 2 | K >>> 30, t[l + 208 >> 2] = K << 2 | P >>> 30, t[l + 212 >> 2] = w & 1073741823, tr = l + 200 | 0, Cr(tr, 690320), w = t[l + 232 >> 2] << 24, K = t[l + 228 >> 2], n = K >>> 6 | 0, P = t[l + 224 >> 2], t[l + 456 >> 2] = (K & 63) << 26 | P >>> 6, t[l + 460 >> 2] = w | n, w = P << 26, K = t[l + 220 >> 2], n = K >>> 4 | 0, P = t[l + 216 >> 2], t[l + 448 >> 2] = (K & 15) << 28 | P >>> 4, t[l + 452 >> 2] = w | n, w = P << 28, K = t[l + 212 >> 2], n = K >>> 2 | 0, P = t[l + 208 >> 2], t[l + 440 >> 2] = (K & 3) << 30 | P >>> 2, t[l + 444 >> 2] = w | n, w = t[l + 204 >> 2], n = P << 30, t[l + 432 >> 2] = t[l + 200 >> 2], t[l + 436 >> 2] = w | n, P = l + 400 | 0, n = l + 432 | 0, Er(P, n, l + 8 | 0), K = l + 368 | 0, Er(K, n, l + 40 | 0), n = l + 288 | 0, t[n >> 2] = 0, t[n + 4 >> 2] = 0, a = Xi, n = a >>> 16 | 0, w = l + 272 | 0, t[w >> 2] = (a & 65535) << 16 | Ki >>> 16, t[w + 4 >> 2] = n, Ce = Ki << 4 & 1048560, a = Yr, n = a >>> 28 | 0, w = l + 264 | 0, t[w >> 2] = (a & 268435455) << 4 | jr >>> 28, t[w + 4 >> 2] = n | Ce, n = a << 24 | jr >>> 8, w = l + 256 | 0, a = In, t[w >> 2] = jr << 24 & -16777216 | a >>> 8, t[w + 4 >> 2] = n & 1048575, n = a << 12, a = $i, Ce = (n | a >>> 20) & 1048575, w = l + 248 | 0, t[w >> 2] = a << 12 & -4096 | Wi >>> 20, t[w + 4 >> 2] = Ce, n = l + 296 | 0, t[n >> 2] = 0, t[n + 4 >> 2] = 0, n = l + 304 | 0, t[n >> 2] = 0, t[n + 4 >> 2] = 0, n = l + 312 | 0, t[n >> 2] = 0, t[n + 4 >> 2] = 0, t[l + 280 >> 2] = 1, t[l + 284 >> 2] = 0, t[l + 240 >> 2] = kn, t[l + 244 >> 2] = Wi & 1048575, t[l + 232 >> 2] = Me, t[l + 236 >> 2] = or, t[l + 224 >> 2] = wi, t[l + 228 >> 2] = Ti, t[l + 216 >> 2] = di, t[l + 220 >> 2] = Ii, t[l + 208 >> 2] = ai, t[l + 212 >> 2] = ui, t[l + 200 >> 2] = Ei, t[l + 204 >> 2] = Di, t[l + 320 >> 2] = 0, xr(l + 72 | 0, tr, K, P), t[l + 192 >> 2]) || (C = pe, n = C >>> 16 | 0, t[l + 360 >> 2] = (C & 65535) << 16 | Tt >>> 16, t[l + 364 >> 2] = n, a = Li, t[l + 328 >> 2] = a, pe = nr & 1048575, t[l + 332 >> 2] = pe, w = C, C = Nr, n = Tt << 4 & 1048560 | C >>> 28, kr = n, Me = (C & 268435455) << 4 | gr >>> 28, t[l + 352 >> 2] = Me, t[l + 356 >> 2] = n, n = C << 24 | gr >>> 8, C = lr, tr = gr << 24 & -16777216 | C >>> 8, t[l + 344 >> 2] = tr, P = n & 1048575, t[l + 348 >> 2] = P, n = C << 12, C = Qi, K = (n | C >>> 20) & 1048575, Ce = C << 12 & -4096 | nr >>> 20, t[l + 336 >> 2] = Ce, t[l + 340 >> 2] = K, C = 1, si(l + 328 | 0, l + 72 | 0)))
            break t;
          if (w | !w & Tt >>> 0 > 65535) {
            C = 0;
            break t;
          }
          if (Me | kr) {
            C = 0;
            break t;
          }
          if (P | !P & tr >>> 0 > 21319971) {
            C = 0;
            break t;
          }
          r: {
            if (P | (tr | 0) != 21319971)
              break r;
            if ((K | 0) == 103691 & Ce >>> 0 > 1979466754 | K >>> 0 > 103691) {
              C = 0;
              break t;
            }
            if ((Ce | 0) != 1979466754 | (K | 0) != 103691)
              break r;
            if (C = 0, (pe | 0) == 893298 & a >>> 0 > 801749741 | pe >>> 0 > 893298)
              break t;
          }
          t[l + 360 >> 2] = -1, t[l + 364 >> 2] = 65535, t[l + 352 >> 2] = -1, t[l + 356 >> 2] = 1048575, n = P + 1048575 | 0, C = tr - 21319972 | 0, n = C >>> 0 < 4273647324 ? n + 1 | 0 : n, t[l + 344 >> 2] = C, t[l + 348 >> 2] = n, n = K + 944884 | 0, w = Ce - 1979466755 | 0, n = w >>> 0 < 2315500541 ? n + 1 | 0 : n, t[l + 336 >> 2] = w, t[l + 340 >> 2] = n, P = pe + 155276 | 0, C = a - 801750719 | 0, P = C >>> 0 < 3493216577 ? P + 1 | 0 : P, t[l + 328 >> 2] = C, t[l + 332 >> 2] = P, C = (si(l + 328 | 0, l + 72 | 0) | 0) != 0;
        }
        U = l + 464 | 0, n = C;
        break e;
      }
      M(1);
    }
    return U = b + 192 | 0, n | 0;
  }
  function br(C, l) {
    C = C | 0, l = l | 0;
    var w = 0, n = 0, a = 0, b = 0, P = 0, K = 0, pe = 0, Ce = 0, Me = 0, Tt = 0, tr = 0, nr = 0, or = 0, lr = 0, gr = 0, kr = 0, Nr = 0, jr = 0, Yr = 0, ei = 0, ai = 0, ui = 0, di = 0, Ii = 0;
    Me = U - 176 | 0, U = Me, K = Me + 8 | 0, is(K, 65), w = t[172688], b = U - 80 | 0, U = b, t[b + 12 >> 2] = 0;
    e: {
      if (!K) {
        yi[t[w + 168 >> 2]](689748, t[w + 172 >> 2]);
        break e;
      }
      if (l >>> 0 >= 4) {
        yi[t[w + 168 >> 2]](689986, t[w + 172 >> 2]);
        break e;
      }
      if (w = b + 12 | 0, Ir(b + 48 | 0, 690981, w), n = t[b + 12 >> 2], Ir(b + 16 | 0, 691013, w), !(n | t[b + 12 >> 2])) {
        w = t[b + 52 >> 2], n = t[b + 48 >> 2], c[K | 0] = n, c[K + 1 | 0] = n >>> 8, c[K + 2 | 0] = n >>> 16, c[K + 3 | 0] = n >>> 24, c[K + 4 | 0] = w, c[K + 5 | 0] = w >>> 8, c[K + 6 | 0] = w >>> 16, c[K + 7 | 0] = w >>> 24, w = t[b + 20 >> 2], n = t[b + 16 >> 2], c[K + 32 | 0] = n, c[K + 33 | 0] = n >>> 8, c[K + 34 | 0] = n >>> 16, c[K + 35 | 0] = n >>> 24, c[K + 36 | 0] = w, c[K + 37 | 0] = w >>> 8, c[K + 38 | 0] = w >>> 16, c[K + 39 | 0] = w >>> 24, c[K + 64 | 0] = l, n = b + 48 | 0, l = n + 24 | 0, w = t[l + 4 >> 2], a = K + 24 | 0, l = t[l >> 2], c[a | 0] = l, c[a + 1 | 0] = l >>> 8, c[a + 2 | 0] = l >>> 16, c[a + 3 | 0] = l >>> 24, c[a + 4 | 0] = w, c[a + 5 | 0] = w >>> 8, c[a + 6 | 0] = w >>> 16, c[a + 7 | 0] = w >>> 24, l = n + 16 | 0, w = t[l + 4 >> 2], a = K + 16 | 0, l = t[l >> 2], c[a | 0] = l, c[a + 1 | 0] = l >>> 8, c[a + 2 | 0] = l >>> 16, c[a + 3 | 0] = l >>> 24, c[a + 4 | 0] = w, c[a + 5 | 0] = w >>> 8, c[a + 6 | 0] = w >>> 16, c[a + 7 | 0] = w >>> 24, l = n + 8 | 0, n = t[l + 4 >> 2], w = K + 8 | 0, l = t[l >> 2], c[w | 0] = l, c[w + 1 | 0] = l >>> 8, c[w + 2 | 0] = l >>> 16, c[w + 3 | 0] = l >>> 24, c[w + 4 | 0] = n, c[w + 5 | 0] = n >>> 8, c[w + 6 | 0] = n >>> 16, c[w + 7 | 0] = n >>> 24, n = b + 16 | 0, l = n + 8 | 0, w = t[l + 4 >> 2], a = K + 40 | 0, l = t[l >> 2], c[a | 0] = l, c[a + 1 | 0] = l >>> 8, c[a + 2 | 0] = l >>> 16, c[a + 3 | 0] = l >>> 24, c[a + 4 | 0] = w, c[a + 5 | 0] = w >>> 8, c[a + 6 | 0] = w >>> 16, c[a + 7 | 0] = w >>> 24, l = n + 16 | 0, w = t[l + 4 >> 2], a = K + 48 | 0, l = t[l >> 2], c[a | 0] = l, c[a + 1 | 0] = l >>> 8, c[a + 2 | 0] = l >>> 16, c[a + 3 | 0] = l >>> 24, c[a + 4 | 0] = w, c[a + 5 | 0] = w >>> 8, c[a + 6 | 0] = w >>> 16, c[a + 7 | 0] = w >>> 24, l = n + 24 | 0, n = t[l + 4 >> 2], w = K + 56 | 0, l = t[l >> 2], c[w | 0] = l, c[w + 1 | 0] = l >>> 8, c[w + 2 | 0] = l >>> 16, c[w + 3 | 0] = l >>> 24, c[w + 4 | 0] = n, c[w + 5 | 0] = n >>> 8, c[w + 6 | 0] = n >>> 16, c[w + 7 | 0] = n >>> 24, n = 1;
        break e;
      }
      n = 0, is(K, 65);
    }
    U = b + 80 | 0;
    e: {
      t: {
        if (!n) {
          M(4);
          break t;
        }
        l = Me + 136 | 0, t[l >> 2] = 0, t[l + 4 >> 2] = 0, l = Me + 128 | 0, t[l >> 2] = 0, t[l + 4 >> 2] = 0, l = Me + 120 | 0, t[l >> 2] = 0, t[l + 4 >> 2] = 0, l = Me + 112 | 0, t[l >> 2] = 0, t[l + 4 >> 2] = 0, l = Me + 104 | 0, t[l >> 2] = 0, t[l + 4 >> 2] = 0, l = Me + 96 | 0, t[l >> 2] = 0, t[l + 4 >> 2] = 0, l = Me + 88 | 0, t[l >> 2] = 0, t[l + 4 >> 2] = 0, t[Me + 80 >> 2] = 0, t[Me + 84 >> 2] = 0, w = Et(), tr = Me + 80 | 0, n = U - 640 | 0, U = n, l = Me + 8 | 0;
        r: {
          i: {
            if (!l) {
              yi[t[w + 168 >> 2]](689760, t[w + 172 >> 2]);
              break i;
            }
            if (!tr) {
              yi[t[w + 168 >> 2]](689638, t[w + 172 >> 2]);
              break i;
            }
            b = l + 40 | 0, a = d[b + 4 | 0] | d[b + 5 | 0] << 8 | (d[b + 6 | 0] << 16 | d[b + 7 | 0] << 24), w = n + 48 | 0, t[w >> 2] = d[b | 0] | d[b + 1 | 0] << 8 | (d[b + 2 | 0] << 16 | d[b + 3 | 0] << 24), t[w + 4 >> 2] = a, b = l + 48 | 0, a = d[b + 4 | 0] | d[b + 5 | 0] << 8 | (d[b + 6 | 0] << 16 | d[b + 7 | 0] << 24), w = n + 56 | 0, t[w >> 2] = d[b | 0] | d[b + 1 | 0] << 8 | (d[b + 2 | 0] << 16 | d[b + 3 | 0] << 24), t[w + 4 >> 2] = a, b = l + 56 | 0, a = d[b + 4 | 0] | d[b + 5 | 0] << 8 | (d[b + 6 | 0] << 16 | d[b + 7 | 0] << 24), w = n - -64 | 0, t[w >> 2] = d[b | 0] | d[b + 1 | 0] << 8 | (d[b + 2 | 0] << 16 | d[b + 3 | 0] << 24), t[w + 4 >> 2] = a, w = d[l + 36 | 0] | d[l + 37 | 0] << 8 | (d[l + 38 | 0] << 16 | d[l + 39 | 0] << 24), t[n + 40 >> 2] = d[l + 32 | 0] | d[l + 33 | 0] << 8 | (d[l + 34 | 0] << 16 | d[l + 35 | 0] << 24), t[n + 44 >> 2] = w, kr = d[l + 64 | 0], Tt = d[l + 24 | 0] | d[l + 25 | 0] << 8 | (d[l + 26 | 0] << 16 | d[l + 27 | 0] << 24), w = d[l + 28 | 0] | d[l + 29 | 0] << 8 | (d[l + 30 | 0] << 16 | d[l + 31 | 0] << 24), or = d[l + 16 | 0] | d[l + 17 | 0] << 8 | (d[l + 18 | 0] << 16 | d[l + 19 | 0] << 24), K = d[l + 20 | 0] | d[l + 21 | 0] << 8 | (d[l + 22 | 0] << 16 | d[l + 23 | 0] << 24), Nr = d[l + 8 | 0] | d[l + 9 | 0] << 8 | (d[l + 10 | 0] << 16 | d[l + 11 | 0] << 24), b = d[l + 12 | 0] | d[l + 13 | 0] << 8 | (d[l + 14 | 0] << 16 | d[l + 15 | 0] << 24), jr = d[l | 0] | d[l + 1 | 0] << 8 | (d[l + 2 | 0] << 16 | d[l + 3 | 0] << 24), a = d[l + 4 | 0] | d[l + 5 | 0] << 8 | (d[l + 6 | 0] << 16 | d[l + 7 | 0] << 24), Ir(n + 8 | 0, 655649, 0);
            n: {
              if (!(Tt | (or | (Nr | jr)) | (w | (K | (a | b)))) || !(t[n + 64 >> 2] | (t[n + 56 >> 2] | (t[n + 48 >> 2] | t[n + 40 >> 2])) | (t[n + 68 >> 2] | (t[n + 60 >> 2] | (t[n + 52 >> 2] | t[n + 44 >> 2])))))
                break n;
              if (l = n, t[l + 632 >> 2] = (w & 65535) << 16 | Tt >>> 16, t[l + 636 >> 2] = w >>> 16, t[l + 600 >> 2] = jr, ui = a & 1048575, t[l + 604 >> 2] = ui, lr = Tt << 4, Ce = lr & 1044480, P = Ce | (lr & 4080 | K >>> 28), di = P, ei = (K & 268435455) << 4 | or >>> 28, t[l + 624 >> 2] = ei, t[l + 628 >> 2] = P, lr = K << 24 | or >>> 8, Yr = lr & 983040, gr = lr & 65280, nr = or << 24 & -16777216 | b >>> 8, t[l + 616 >> 2] = nr, ai = Yr | (gr | lr & 255), t[l + 620 >> 2] = ai, P = b << 12 | Nr >>> 20, Yr = P & 1044480, gr = P & 4080, l = Nr << 12, lr = l & -268435456, Ce = P & 15, pe = l & 267386880, pe = lr | (pe | (l & 1044480 | a >>> 20)), t[n + 608 >> 2] = pe, Ce = Yr | (Ce | gr), t[n + 612 >> 2] = Ce, kr & 2) {
                if (w | !w & Tt >>> 0 > 65535 || di | ei || ai | !ai & nr >>> 0 > 21319971)
                  break n;
                s: {
                  if (ai | (nr | 0) != 21319971)
                    break s;
                  if ((Ce | 0) == 103691 & pe >>> 0 > 1979466754 | Ce >>> 0 > 103691)
                    break n;
                  if ((pe | 0) != 1979466754 | (Ce | 0) != 103691)
                    break s;
                  if ((ui | 0) == 893298 & jr >>> 0 > 801749741 | ui >>> 0 > 893298)
                    break n;
                }
                t[n + 632 >> 2] = -1, t[n + 636 >> 2] = 65535, t[n + 624 >> 2] = -1, t[n + 628 >> 2] = 1048575, P = ai + 1048575 | 0, l = nr - 21319972 | 0, P = l >>> 0 < 4273647324 ? P + 1 | 0 : P, t[n + 616 >> 2] = l, t[n + 620 >> 2] = P, l = Ce + 944884 | 0, pe = pe - 1979466755 | 0, l = pe >>> 0 < 2315500541 ? l + 1 | 0 : l, t[n + 608 >> 2] = pe, t[n + 612 >> 2] = l, P = ui + 155276 | 0, l = jr - 801750719 | 0, P = l >>> 0 < 3493216577 ? P + 1 | 0 : P, t[n + 600 >> 2] = l, t[n + 604 >> 2] = P;
              }
              if (!oi(n + 512 | 0, n + 600 | 0, kr & 1) || (Ce = n + 512 | 0, pe = Ce + 8 | 0, P = t[pe + 4 >> 2], nr = n + 384 | 0, l = nr + 8 | 0, t[l >> 2] = t[pe >> 2], t[l + 4 >> 2] = P, pe = Ce + 16 | 0, P = t[pe + 4 >> 2], l = nr + 16 | 0, t[l >> 2] = t[pe >> 2], t[l + 4 >> 2] = P, pe = Ce + 24 | 0, P = t[pe + 4 >> 2], l = nr + 24 | 0, t[l >> 2] = t[pe >> 2], t[l + 4 >> 2] = P, pe = Ce + 32 | 0, P = t[pe + 4 >> 2], l = nr + 32 | 0, t[l >> 2] = t[pe >> 2], t[l + 4 >> 2] = P, pe = Ce + 48 | 0, P = t[pe + 4 >> 2], l = nr + 48 | 0, t[l >> 2] = t[pe >> 2], t[l + 4 >> 2] = P, pe = Ce + 56 | 0, P = t[pe + 4 >> 2], l = nr + 56 | 0, t[l >> 2] = t[pe >> 2], t[l + 4 >> 2] = P, pe = Ce - -64 | 0, P = t[pe + 4 >> 2], l = nr - -64 | 0, t[l >> 2] = t[pe >> 2], t[l + 4 >> 2] = P, pe = Ce + 72 | 0, P = t[pe + 4 >> 2], l = nr + 72 | 0, t[l >> 2] = t[pe >> 2], t[l + 4 >> 2] = P, t[n + 504 >> 2] = t[n + 592 >> 2], l = t[n + 516 >> 2], t[n + 384 >> 2] = t[n + 512 >> 2], t[n + 388 >> 2] = l, l = t[n + 556 >> 2], t[n + 424 >> 2] = t[n + 552 >> 2], t[n + 428 >> 2] = l, l = n + 472 | 0, t[l >> 2] = 0, t[l + 4 >> 2] = 0, l = n + 480 | 0, t[l >> 2] = 0, t[l + 4 >> 2] = 0, l = n + 488 | 0, t[l >> 2] = 0, t[l + 4 >> 2] = 0, l = n + 496 | 0, t[l >> 2] = 0, t[l + 4 >> 2] = 0, t[n + 464 >> 2] = 1, t[n + 468 >> 2] = 0, t[n + 104 >> 2] = w >>> 24, t[n + 108 >> 2] = 0, w = w << 6 | Tt >>> 26, l = K, t[n + 96 >> 2] = Tt << 6 | l >>> 26, t[n + 100 >> 2] = w & 1073741823, K = l << 4 | or >>> 28, w = n, l = b, t[w + 88 >> 2] = or << 4 | l >>> 28, t[w + 92 >> 2] = K & 1073741823, t[w + 80 >> 2] = Nr << 2 | a >>> 30, t[w + 84 >> 2] = (l << 2 | Nr >>> 30) & 1073741823, t[w + 72 >> 2] = jr, t[w + 76 >> 2] = a & 1073741823, lr = w + 72 | 0, Cr(lr, 690320), K = t[w + 104 >> 2] << 24, a = t[w + 100 >> 2], l = a >>> 6 | 0, b = t[w + 96 >> 2], t[w + 376 >> 2] = (a & 63) << 26 | b >>> 6, t[w + 380 >> 2] = l | K, b = b << 26, l = t[w + 92 >> 2], P = l >>> 4 | 0, a = t[w + 88 >> 2], t[w + 368 >> 2] = (l & 15) << 28 | a >>> 4, t[w + 372 >> 2] = P | b, K = a << 28, a = t[w + 84 >> 2], l = a >>> 2 | 0, b = t[w + 80 >> 2], t[w + 360 >> 2] = (a & 3) << 30 | b >>> 2, t[w + 364 >> 2] = l | K, K = t[w + 76 >> 2], P = b << 30, t[w + 352 >> 2] = t[w + 72 >> 2], t[w + 356 >> 2] = P | K, Ce = w + 320 | 0, pe = w + 352 | 0, Er(Ce, pe, w + 8 | 0), ei = t[w + 344 >> 2], jr = t[w + 336 >> 2], Tt = t[w + 328 >> 2], a = t[w + 320 >> 2], Nr = t[w + 348 >> 2], or = t[w + 340 >> 2], P = t[w + 332 >> 2], K = t[w + 324 >> 2], l = ei | (jr | (Tt | a)) | (Nr | (or | (P | K))) ? -1 : 0, gr = a ^ -1, b = gr - 801750718 | 0, t[w + 320 >> 2] = l & b, a = l, K = K ^ -1, l = K - ((gr >>> 0 < 801750718) + 1076732275 | 0) | 0, t[w + 324 >> 2] = a & l, l = (l | 0) == (K | 0) & b >>> 0 < gr >>> 0 | l >>> 0 < K >>> 0, Tt = Tt ^ -1, kr = l + Tt | 0, Yr = P ^ -1, P = Yr, P = l >>> 0 > kr >>> 0 ? P + 1 | 0 : P, l = kr - 1354194885 | 0, t[w + 328 >> 2] = l & a, gr = P - ((kr >>> 0 < 1354194885) + 1162945305 | 0) | 0, t[w + 332 >> 2] = gr & a, K = jr ^ -1, l = (P | 0) == (gr | 0) & l >>> 0 < kr >>> 0 | P >>> 0 > gr >>> 0, Tt = l + ((P | 0) == (Yr | 0) & Tt >>> 0 > kr >>> 0 | P >>> 0 < Yr >>> 0) | 0, or = or ^ -1, l = or + (l >>> 0 > Tt >>> 0) | 0, P = K + Tt | 0, l = P >>> 0 < Tt >>> 0 ? l + 1 | 0 : l, b = P - 2 | 0, t[w + 336 >> 2] = b & a, Tt = l - (P >>> 0 < 2) | 0, t[w + 340 >> 2] = Tt & a, di = (l | 0) == (or | 0) & P >>> 0 < K >>> 0 | l >>> 0 < or >>> 0, l = (l | 0) == (Tt | 0) & P >>> 0 > b >>> 0 | l >>> 0 > Tt >>> 0, w = di + l | 0, P = l >>> 0 > w >>> 0, l = w - ei | 0, t[n + 344 >> 2] = l - 2 & a, t[n + 348 >> 2] = (P - ((w >>> 0 < ei >>> 0) + Nr | 0) | 0) - (l >>> 0 < 2) & a, w = n + 288 | 0, Er(w, pe, n + 40 | 0), l = n + 160 | 0, xr(l, nr, w, Ce), ro(lr, l), t[n + 280 >> 2]))
                break n;
              ti(tr, n + 72 | 0), l = 1;
              break r;
            }
            c[tr | 0] = 0, c[tr + 1 | 0] = 0, c[tr + 2 | 0] = 0, c[tr + 3 | 0] = 0, c[tr + 4 | 0] = 0, c[tr + 5 | 0] = 0, c[tr + 6 | 0] = 0, c[tr + 7 | 0] = 0, l = tr + 56 | 0, c[l | 0] = 0, c[l + 1 | 0] = 0, c[l + 2 | 0] = 0, c[l + 3 | 0] = 0, c[l + 4 | 0] = 0, c[l + 5 | 0] = 0, c[l + 6 | 0] = 0, c[l + 7 | 0] = 0, l = tr + 48 | 0, c[l | 0] = 0, c[l + 1 | 0] = 0, c[l + 2 | 0] = 0, c[l + 3 | 0] = 0, c[l + 4 | 0] = 0, c[l + 5 | 0] = 0, c[l + 6 | 0] = 0, c[l + 7 | 0] = 0, l = tr + 40 | 0, c[l | 0] = 0, c[l + 1 | 0] = 0, c[l + 2 | 0] = 0, c[l + 3 | 0] = 0, c[l + 4 | 0] = 0, c[l + 5 | 0] = 0, c[l + 6 | 0] = 0, c[l + 7 | 0] = 0, l = tr + 32 | 0, c[l | 0] = 0, c[l + 1 | 0] = 0, c[l + 2 | 0] = 0, c[l + 3 | 0] = 0, c[l + 4 | 0] = 0, c[l + 5 | 0] = 0, c[l + 6 | 0] = 0, c[l + 7 | 0] = 0, l = tr + 24 | 0, c[l | 0] = 0, c[l + 1 | 0] = 0, c[l + 2 | 0] = 0, c[l + 3 | 0] = 0, c[l + 4 | 0] = 0, c[l + 5 | 0] = 0, c[l + 6 | 0] = 0, c[l + 7 | 0] = 0, l = tr + 16 | 0, c[l | 0] = 0, c[l + 1 | 0] = 0, c[l + 2 | 0] = 0, c[l + 3 | 0] = 0, c[l + 4 | 0] = 0, c[l + 5 | 0] = 0, c[l + 6 | 0] = 0, c[l + 7 | 0] = 0, l = tr + 8 | 0, c[l | 0] = 0, c[l + 1 | 0] = 0, c[l + 2 | 0] = 0, c[l + 3 | 0] = 0, c[l + 4 | 0] = 0, c[l + 5 | 0] = 0, c[l + 6 | 0] = 0, c[l + 7 | 0] = 0;
          }
          l = 0;
        }
        if (U = n + 640 | 0, !l)
          break t;
        if (t[Me + 144 >> 2] = C, C = Lr(t[172688], Me + 144 | 0, Me + 80 | 0, (C | 0) == 33 ? 258 : 2), t[Me + 148 >> 2] = C, (C | 0) != 1)
          break e;
        Ii = 1;
      }
      return U = Me + 176 | 0, Ii | 0;
    }
    t[Me + 160 >> 2] = 0, Ne(Me + 152 | 0), wasm2js_trap();
  }
  function Ar() {
    var C = 0, l = 0, w = 0, n = 0, a = 0, b = 0, P = 0, K = 0, pe = 0, Ce = 0, Me = 0, Tt = 0, tr = 0, nr = 0, or = 0, lr = 0, gr = 0, kr = 0, Nr = 0, jr = 0, Yr = 0, ei = 0, ai = 0, ui = 0, di = 0, Ii = 0, wi = 0, Ei = 0, Ti = 0, Di = 0, Qi = 0, Li = 0, Ki = 0, Wi = 0, Xi = 0;
    n = U - 192 | 0, U = n, C = n + 128 | 0, w = C + 56 | 0, t[w >> 2] = 0, t[w + 4 >> 2] = 0, w = C + 48 | 0, t[w >> 2] = 0, t[w + 4 >> 2] = 0, w = C + 40 | 0, t[w >> 2] = 0, t[w + 4 >> 2] = 0, w = C + 32 | 0, t[w >> 2] = 0, t[w + 4 >> 2] = 0, w = C + 24 | 0, t[w >> 2] = 0, t[w + 4 >> 2] = 0, w = C + 16 | 0, t[w >> 2] = 0, t[w + 4 >> 2] = 0, w = C + 8 | 0, t[w >> 2] = 0, t[w + 4 >> 2] = 0, t[n + 128 >> 2] = 0, t[n + 132 >> 2] = 0;
    e: {
      if ((Fs(t[172688], C, 690885) | 0) == 1) {
        w = n + 128 | 0, C = w + 15 | 0, P = d[C + 4 | 0] | d[C + 5 | 0] << 8 | (d[C + 6 | 0] << 16 | d[C + 7 | 0] << 24), a = n - -64 | 0, b = a + 8 | 0, t[b >> 2] = d[C | 0] | d[C + 1 | 0] << 8 | (d[C + 2 | 0] << 16 | d[C + 3 | 0] << 24), t[b + 4 >> 2] = P, C = w + 23 | 0, l = d[C + 4 | 0] | d[C + 5 | 0] << 8 | (d[C + 6 | 0] << 16 | d[C + 7 | 0] << 24), P = a + 16 | 0, t[P >> 2] = d[C | 0] | d[C + 1 | 0] << 8 | (d[C + 2 | 0] << 16 | d[C + 3 | 0] << 24), t[P + 4 >> 2] = l, C = w + 31 | 0, Ce = d[C + 4 | 0] | d[C + 5 | 0] << 8 | (d[C + 6 | 0] << 16 | d[C + 7 | 0] << 24), l = a + 24 | 0, t[l >> 2] = d[C | 0] | d[C + 1 | 0] << 8 | (d[C + 2 | 0] << 16 | d[C + 3 | 0] << 24), t[l + 4 >> 2] = Ce, C = w + 39 | 0, K = d[C + 4 | 0] | d[C + 5 | 0] << 8 | (d[C + 6 | 0] << 16 | d[C + 7 | 0] << 24), Ce = a + 32 | 0, t[Ce >> 2] = d[C | 0] | d[C + 1 | 0] << 8 | (d[C + 2 | 0] << 16 | d[C + 3 | 0] << 24), t[Ce + 4 >> 2] = K, C = w + 47 | 0, Tt = d[C + 4 | 0] | d[C + 5 | 0] << 8 | (d[C + 6 | 0] << 16 | d[C + 7 | 0] << 24), K = a + 40 | 0, t[K >> 2] = d[C | 0] | d[C + 1 | 0] << 8 | (d[C + 2 | 0] << 16 | d[C + 3 | 0] << 24), t[K + 4 >> 2] = Tt, C = w + 55 | 0, Me = d[C + 4 | 0] | d[C + 5 | 0] << 8 | (d[C + 6 | 0] << 16 | d[C + 7 | 0] << 24), Tt = a + 48 | 0, t[Tt >> 2] = d[C | 0] | d[C + 1 | 0] << 8 | (d[C + 2 | 0] << 16 | d[C + 3 | 0] << 24), t[Tt + 4 >> 2] = Me, C = a + 56 | 0, c[C | 0] = d[w + 63 | 0], c[n + 2 | 0] = d[n + 130 | 0], y[n >> 1] = E[n + 128 >> 1], w = d[n + 139 | 0] | d[n + 140 | 0] << 8 | (d[n + 141 | 0] << 16 | d[n + 142 | 0] << 24), t[n + 64 >> 2] = d[n + 135 | 0] | d[n + 136 | 0] << 8 | (d[n + 137 | 0] << 16 | d[n + 138 | 0] << 24), t[n + 68 >> 2] = w, w = d[n + 131 | 0] | d[n + 132 | 0] << 8 | (d[n + 133 | 0] << 16 | d[n + 134 | 0] << 24), c[n + 63 | 0] = d[C | 0], a = t[Tt + 4 >> 2], C = n + 55 | 0, Tt = t[Tt >> 2], c[C | 0] = Tt, c[C + 1 | 0] = Tt >>> 8, c[C + 2 | 0] = Tt >>> 16, c[C + 3 | 0] = Tt >>> 24, c[C + 4 | 0] = a, c[C + 5 | 0] = a >>> 8, c[C + 6 | 0] = a >>> 16, c[C + 7 | 0] = a >>> 24, a = t[K + 4 >> 2], C = n + 47 | 0, K = t[K >> 2], c[C | 0] = K, c[C + 1 | 0] = K >>> 8, c[C + 2 | 0] = K >>> 16, c[C + 3 | 0] = K >>> 24, c[C + 4 | 0] = a, c[C + 5 | 0] = a >>> 8, c[C + 6 | 0] = a >>> 16, c[C + 7 | 0] = a >>> 24, a = t[Ce + 4 >> 2], C = n + 39 | 0, Ce = t[Ce >> 2], c[C | 0] = Ce, c[C + 1 | 0] = Ce >>> 8, c[C + 2 | 0] = Ce >>> 16, c[C + 3 | 0] = Ce >>> 24, c[C + 4 | 0] = a, c[C + 5 | 0] = a >>> 8, c[C + 6 | 0] = a >>> 16, c[C + 7 | 0] = a >>> 24, a = t[l + 4 >> 2], C = n + 31 | 0, l = t[l >> 2], c[C | 0] = l, c[C + 1 | 0] = l >>> 8, c[C + 2 | 0] = l >>> 16, c[C + 3 | 0] = l >>> 24, c[C + 4 | 0] = a, c[C + 5 | 0] = a >>> 8, c[C + 6 | 0] = a >>> 16, c[C + 7 | 0] = a >>> 24, a = t[P + 4 >> 2], C = n + 23 | 0, P = t[P >> 2], c[C | 0] = P, c[C + 1 | 0] = P >>> 8, c[C + 2 | 0] = P >>> 16, c[C + 3 | 0] = P >>> 24, c[C + 4 | 0] = a, c[C + 5 | 0] = a >>> 8, c[C + 6 | 0] = a >>> 16, c[C + 7 | 0] = a >>> 24, a = t[b + 4 >> 2], C = n + 15 | 0, b = t[b >> 2], c[C | 0] = b, c[C + 1 | 0] = b >>> 8, c[C + 2 | 0] = b >>> 16, c[C + 3 | 0] = b >>> 24, c[C + 4 | 0] = a, c[C + 5 | 0] = a >>> 8, c[C + 6 | 0] = a >>> 16, c[C + 7 | 0] = a >>> 24, c[n + 3 | 0] = w, c[n + 4 | 0] = w >>> 8, c[n + 5 | 0] = w >>> 16, c[n + 6 | 0] = w >>> 24, C = t[n + 68 >> 2], w = t[n + 64 >> 2], c[n + 7 | 0] = w, c[n + 8 | 0] = w >>> 8, c[n + 9 | 0] = w >>> 16, c[n + 10 | 0] = w >>> 24, c[n + 11 | 0] = C, c[n + 12 | 0] = C >>> 8, c[n + 13 | 0] = C >>> 16, c[n + 14 | 0] = C >>> 24, gr = Et(), l = U - 496 | 0, U = l;
        t: {
          if (!n) {
            yi[t[gr + 168 >> 2]](689638, t[gr + 172 >> 2]);
            break t;
          }
          if (!$r(l + 136 | 0, 690981) || (Ir(l + 464 | 0, 691013, l + 12 | 0), t[l + 12 >> 2]))
            break t;
          if (w = d[n + 4 | 0] | d[n + 5 | 0] << 8 | (d[n + 6 | 0] << 16 | d[n + 7 | 0] << 24), P = w, Me = w >>> 20 | 0, b = Me, C = d[n + 12 | 0] | d[n + 13 | 0] << 8 | (d[n + 14 | 0] << 16 | d[n + 15 | 0] << 24), tr = C, ai = d[n + 8 | 0] | d[n + 9 | 0] << 8 | (d[n + 10 | 0] << 16 | d[n + 11 | 0] << 24), w = ai, C = C << 12 | w >>> 20, kr = w << 12, ui = b | kr & -4096, Tt = C, di = C & 1048575, Ii = tr >>> 8 | 0, Ce = Ii, C = d[n + 20 | 0] | d[n + 21 | 0] << 8 | (d[n + 22 | 0] << 16 | d[n + 23 | 0] << 24), K = C, Yr = d[n + 16 | 0] | d[n + 17 | 0] << 8 | (d[n + 18 | 0] << 16 | d[n + 19 | 0] << 24), w = Yr, C = C << 24 | w >>> 8, wi = Ce | w << 24 & -16777216, w = C, Ei = C & 1048575, b = d[n + 28 | 0] | d[n + 29 | 0] << 8 | (d[n + 30 | 0] << 16 | d[n + 31 | 0] << 24), Ce = b, or = d[n + 24 | 0] | d[n + 25 | 0] << 8 | (d[n + 26 | 0] << 16 | d[n + 27 | 0] << 24), Nr = (b & 65535) << 16 | or >>> 16, lr = b >>> 16 | 0, b = K >>> 28 | 0, pe = (K & 268435455) << 4 | Yr >>> 28, jr = d[n | 0] | d[n + 1 | 0] << 8 | (d[n + 2 | 0] << 16 | d[n + 3 | 0] << 24), a = or, C = a << 4, Ti = b | C & 1048560, nr = P & 1048575, !(pe | (wi | (Nr | (jr | ui))) | (Ti | (Ei | (lr | (nr | di)))))) {
            yi[t[gr + 168 >> 2]](690116, t[gr + 172 >> 2]);
            break t;
          }
          if (or = d[n + 56 | 0] | d[n + 57 | 0] << 8 | (d[n + 58 | 0] << 16 | d[n + 59 | 0] << 24), gr = d[n + 60 | 0] | d[n + 61 | 0] << 8 | (d[n + 62 | 0] << 16 | d[n + 63 | 0] << 24), ei = d[n + 48 | 0] | d[n + 49 | 0] << 8 | (d[n + 50 | 0] << 16 | d[n + 51 | 0] << 24), Qi = d[n + 52 | 0] | d[n + 53 | 0] << 8 | (d[n + 54 | 0] << 16 | d[n + 55 | 0] << 24), Li = d[n + 40 | 0] | d[n + 41 | 0] << 8 | (d[n + 42 | 0] << 16 | d[n + 43 | 0] << 24), Ki = d[n + 44 | 0] | d[n + 45 | 0] << 8 | (d[n + 46 | 0] << 16 | d[n + 47 | 0] << 24), Wi = d[n + 32 | 0] | d[n + 33 | 0] << 8 | (d[n + 34 | 0] << 16 | d[n + 35 | 0] << 24), Di = d[n + 36 | 0] | d[n + 37 | 0] << 8 | (d[n + 38 | 0] << 16 | d[n + 39 | 0] << 24), c[l + 34 | 0] = Ii, c[l + 21 | 0] = Nr, c[l + 38 | 0] = (Tt & 1048575) << 12 | kr >>> 20, c[l + 37 | 0] = (Tt & 268435455) << 4 | kr >>> 28, c[l + 36 | 0] = Tt >>> 4, c[l + 35 | 0] = Tt >>> 12, c[l + 30 | 0] = w, c[l + 29 | 0] = w >>> 8, c[l + 22 | 0] = C >>> 12, c[l + 47 | 0] = jr, c[l + 46 | 0] = (P & 255) << 24 | jr >>> 8, c[l + 45 | 0] = (P & 65535) << 16 | jr >>> 16, c[l + 44 | 0] = (P & 16777215) << 8 | jr >>> 24, c[l + 43 | 0] = P, c[l + 42 | 0] = P >>> 8, c[l + 41 | 0] = Me << 4 | nr >>> 16, c[l + 40 | 0] = P >>> 24, c[l + 39 | 0] = ai, c[l + 33 | 0] = tr >>> 16, c[l + 32 | 0] = tr >>> 24, c[l + 31 | 0] = Yr, C = K, c[l + 27 | 0] = C, c[l + 26 | 0] = C >>> 8, c[l + 25 | 0] = C >>> 16, c[l + 24 | 0] = C >>> 24, c[l + 23 | 0] = a, C = Ce, c[l + 20 | 0] = (C & 16777215) << 8 | a >>> 24, c[l + 19 | 0] = C, c[l + 18 | 0] = C >>> 8, c[l + 17 | 0] = C >>> 16, c[l + 16 | 0] = C >>> 24, c[l + 28 | 0] = w >>> 16 & 15 | pe << 4, t[l + 400 >> 2] = 64, t[l + 404 >> 2] = 0, t[l + 328 >> 2] = -1862921884, t[l + 332 >> 2] = 870954602, t[l + 320 >> 2] = -1748470448, t[l + 324 >> 2] = 3983205, t[l + 312 >> 2] = 292000018, t[l + 316 >> 2] = -782074353, t[l + 304 >> 2] = -1662207471, t[l + 308 >> 2] = 596792193, P = l + 304 | 0, Wr(P, 690981, 32), Wr(P, l + 16 | 0, 32), Wr(P, 655649, 32), K = l + 48 | 0, fi(P, K), kr = l + 432 | 0, Ir(kr, K, 0), w = gr, C = w >>> 16 | 0, Ce = l + 176 | 0, a = Ce + 72 | 0, t[a >> 2] = (w & 65535) << 16 | or >>> 16, t[a + 4 >> 2] = C, b = or << 4 & 1048560, w = Qi, C = w >>> 28 | 0, a = Ce - -64 | 0, t[a >> 2] = (w & 268435455) << 4 | ei >>> 28, t[a + 4 >> 2] = C | b, C = w << 24 | ei >>> 8, a = Ce + 56 | 0, w = Ki, t[a >> 2] = ei << 24 & -16777216 | w >>> 8, t[a + 4 >> 2] = C & 1048575, C = w << 12, w = Li, b = (C | w >>> 20) & 1048575, a = Ce + 48 | 0, t[a >> 2] = w << 12 & -4096 | Di >>> 20, t[a + 4 >> 2] = b, t[l + 296 >> 2] = 0, t[l + 256 >> 2] = 1, t[l + 260 >> 2] = 0, t[l + 216 >> 2] = Wi, t[l + 220 >> 2] = Di & 1048575, t[l + 208 >> 2] = Nr, t[l + 212 >> 2] = lr, t[l + 200 >> 2] = pe, t[l + 204 >> 2] = Ti, t[l + 192 >> 2] = wi, t[l + 196 >> 2] = Ei, t[l + 184 >> 2] = ui, t[l + 188 >> 2] = di, t[l + 176 >> 2] = jr, t[l + 180 >> 2] = nr, Tt = t[l + 456 >> 2], nr = t[l + 448 >> 2], tr = t[l + 440 >> 2], C = t[l + 432 >> 2], Nr = t[l + 460 >> 2], or = t[l + 452 >> 2], pe = t[l + 444 >> 2], w = t[l + 436 >> 2], a = Tt | (nr | (tr | C)) | (Nr | (or | (pe | w))) ? -1 : 0, C = C ^ -1, lr = C - 801750718 | 0, t[l + 432 >> 2] = a & lr, b = w ^ -1, Me = b - ((C >>> 0 < 801750718) + 1076732275 | 0) | 0, t[l + 436 >> 2] = Me & a, C = (b | 0) == (Me | 0) & C >>> 0 > lr >>> 0 | b >>> 0 > Me >>> 0, Me = tr ^ -1, b = C + Me | 0, tr = pe ^ -1, C = tr, lr = b - 1354194885 | 0, t[l + 440 >> 2] = lr & a, C = b >>> 0 < Me >>> 0 ? C + 1 | 0 : C, pe = C - ((b >>> 0 < 1354194885) + 1162945305 | 0) | 0, t[l + 444 >> 2] = pe & a, gr = nr ^ -1, w = (C | 0) == (tr | 0) & b >>> 0 < Me >>> 0 | C >>> 0 < tr >>> 0, Me = (C | 0) == (pe | 0) & b >>> 0 > lr >>> 0 | C >>> 0 > pe >>> 0, b = w + Me | 0, nr = or ^ -1, C = nr + (b >>> 0 < Me >>> 0) | 0, w = b, b = b + gr | 0, C = w >>> 0 > b >>> 0 ? C + 1 | 0 : C, tr = b - 2 | 0, t[l + 448 >> 2] = tr & a, Me = C - (b >>> 0 < 2) | 0, t[l + 452 >> 2] = Me & a, w = (C | 0) == (nr | 0) & b >>> 0 < gr >>> 0 | C >>> 0 < nr >>> 0, b = (C | 0) == (Me | 0) & b >>> 0 > tr >>> 0 | C >>> 0 > Me >>> 0, w = w + b | 0, C = w >>> 0 < b >>> 0, b = w - Tt | 0, t[l + 456 >> 2] = b - 2 & a, t[l + 460 >> 2] = (C - ((w >>> 0 < Tt >>> 0) + Nr | 0) | 0) - (b >>> 0 < 2) & a, C = l + 288 | 0, t[C >> 2] = 0, t[C + 4 >> 2] = 0, C = l + 280 | 0, t[C >> 2] = 0, t[C + 4 >> 2] = 0, C = l + 272 | 0, t[C >> 2] = 0, t[C + 4 >> 2] = 0, C = l + 264 | 0, t[C >> 2] = 0, t[C + 4 >> 2] = 0, xr(P, Ce, kr, l + 464 | 0), ro(K, P), t[l + 128 >> 2] || (b = t[l + 92 >> 2], a = l + 48 | 0, C = a + 72 | 0, pe = t[C >> 2], P = t[C + 4 >> 2], nr = P, C = t[l + 88 >> 2], w = ri(P >>> 16 | 0, 0, 977, 1), Ce = C + w | 0, C = b + ve | 0, K = w >>> 0 > Ce >>> 0 ? C + 1 | 0 : C, C = a + 48 | 0, b = t[C >> 2], C = t[C + 4 >> 2], w = K >>> 20 | 0, P = w, w = w + b | 0, P = P >>> 0 > w >>> 0 ? C + 1 | 0 : C, Tt = P & 1048575, C = a - -64 | 0, Me = t[C >> 2], or = t[C + 4 >> 2], C = a + 56 | 0, b = t[C >> 2], C = t[C + 4 >> 2], a = P >>> 20 | 0, b = a + b | 0, tr = a >>> 0 > b >>> 0 ? C + 1 | 0 : C, C = or, a = tr >>> 20 | 0, or = a, a = a + Me | 0, C = or >>> 0 > a >>> 0 ? C + 1 | 0 : C, Me = C & 1048575, tr = tr & 1048575, or = (w & b & a) == -1 & (P & tr & C) == 1048575, P = C, C = nr & 65535, P = P >>> 20 | 0, pe = P + pe | 0, P = P >>> 0 > pe >>> 0 ? C + 1 | 0 : C, C = K & 1048575, nr = C, K = pe, or & ((K | 0) == -1 & (P | 0) == 65535) & ((C | 0) == 1048574 & Ce >>> 0 > 4294966318 | C >>> 0 > 1048574) | P >>> 16 && (C = nr + 1 | 0, Ce = Ce + 977 | 0, C = Ce >>> 0 < 977 ? C + 1 | 0 : C, nr = C & 1048575, pe = C, C = Tt, pe = pe >>> 20 | 0, w = w + pe | 0, C = pe >>> 0 > w >>> 0 ? C + 1 | 0 : C, Tt = C & 1048575, pe = C, C = tr, pe = pe >>> 20 | 0, b = b + pe | 0, C = pe >>> 0 > b >>> 0 ? C + 1 | 0 : C, tr = C & 1048575, pe = C, C = Me, pe = pe >>> 20 | 0, a = a + pe | 0, C = pe >>> 0 > a >>> 0 ? C + 1 | 0 : C, Me = C & 1048575, pe = C, C = P, P = K, K = (pe >>> 20 | 0) + K | 0, P = (P >>> 0 > K >>> 0 ? C + 1 | 0 : C) & 65535), t[l + 120 >> 2] = K, t[l + 124 >> 2] = P, t[l + 112 >> 2] = a, t[l + 116 >> 2] = Me, t[l + 104 >> 2] = b, t[l + 108 >> 2] = tr, t[l + 96 >> 2] = w, t[l + 100 >> 2] = Tt, t[l + 88 >> 2] = Ce, t[l + 92 >> 2] = nr, Ce & 1) || (C = t[l + 48 >> 2], w = t[l + 136 >> 2], a = C - w | 0, P = t[l + 52 >> 2] - (t[l + 140 >> 2] + (C >>> 0 < w >>> 0) | 0) | 0, C = t[l + 80 >> 2], b = t[l + 168 >> 2], w = (C - b | 0) - 4 | 0, C = (t[l + 84 >> 2] - (t[l + 172 >> 2] + (C >>> 0 < b >>> 0) | 0) | 0) + 262143 | 0, b = w >>> 0 < 4294967292 ? C + 1 | 0 : C, Ce = ri(b >>> 16 | 0, 0, 977, 1), a = Ce + a | 0, C = P + ve | 0, C = (a >>> 0 < Ce >>> 0 ? C + 1 | 0 : C) + 4194299 | 0, a = a - 3908 | 0, C = a >>> 0 < 4294963388 ? C + 1 | 0 : C, P = C & 1048575, nr = P, tr = a ^ 976, or = P ^ 1, ((tr | 0) != -1 | (or | 0) != 1048575) & (a | P) != 0))
            break t;
          Me = w, Nr = b & 65535, w = t[l + 72 >> 2], b = t[l + 160 >> 2], Tt = w - b | 0, pe = t[l + 76 >> 2] - (t[l + 164 >> 2] + (w >>> 0 < b >>> 0) | 0) | 0, w = t[l + 64 >> 2], b = t[l + 152 >> 2], Ce = w - b | 0, K = t[l + 68 >> 2] - (t[l + 156 >> 2] + (w >>> 0 < b >>> 0) | 0) | 0, w = C >>> 20 | 0, kr = t[l + 144 >> 2], lr = w - kr | 0, b = lr + t[l + 56 >> 2] | 0, C = t[l + 60 >> 2] - (t[l + 148 >> 2] + (w >>> 0 < kr >>> 0) | 0) | 0, C = (b >>> 0 < lr >>> 0 ? C + 1 | 0 : C) + 4194303 | 0, w = b - 4 | 0, b = w >>> 0 < 4294967292 ? C + 1 | 0 : C, C = K, P = b >>> 20 | 0, K = P, P = P + Ce | 0, C = (K >>> 0 > P >>> 0 ? C + 1 | 0 : C) + 4194303 | 0, P = P - 4 | 0, Ce = P >>> 0 < 4294967292 ? C + 1 | 0 : C, C = pe, K = Ce >>> 20 | 0, pe = K, K = K + Tt | 0, C = (pe >>> 0 > K >>> 0 ? C + 1 | 0 : C) + 4194303 | 0, K = K - 4 | 0, Tt = K >>> 0 < 4294967292 ? C + 1 | 0 : C, C = Nr, pe = Tt >>> 20 | 0, Me = pe + Me | 0, C = pe >>> 0 > Me >>> 0 ? C + 1 | 0 : C, (w & tr & P & K & Me) == -1 ? pe = (b & or & Ce & Tt & (C ^ 983040)) == 1048575 : pe = 0, pe ? (w = 0, C = 0) : (w = K | (P | (w | a)) | Me, C = Tt & 1048575 | (Ce & 1048575 | (b & 1048575 | nr)) | C), Xi = !(C | w);
        }
        U = l + 496 | 0;
        break e;
      }
      M(1);
    }
    return U = n + 192 | 0, Xi | 0;
  }
  function cr(C, l, w, n, a) {
    var b = 0;
    e: {
      t: {
        if ((w | 0) != 1114112 && (b = 1, yi[t[l + 16 >> 2]](C, w) | 0))
          break t;
        if (n)
          break e;
        b = 0;
      }
      return b;
    }
    return yi[t[l + 12 >> 2]](C, n, a) | 0;
  }
  function hr(C, l) {
    C = C | 0, l = l | 0;
    var w = 0;
    if (d[C | 0])
      for (l = C + 1 | 0, C = 0; w = C + l | 0, C = C + 1 | 0, !!d[w | 0]; )
        ;
    wasm2js_trap();
  }
  function Wr(C, l, w) {
    var n = 0, a = 0, b = 0, P = 0, K = 0, pe = 0, Ce = 0, Me = 0, Tt = 0, tr = 0, nr = 0, or = 0, lr = 0, gr = 0, kr = 0, Nr = 0, jr = 0, Yr = 0, ei = 0, ai = 0, ui = 0, di = 0, Ii = 0, wi = 0, Ei = 0, Ti = 0, Di = 0, Qi = 0, Li = 0, Ki = 0, Wi = 0, Xi = 0, $i = 0, In = 0, kn = 0, Dn = 0, Mn = 0, zn = 0, es = 0, ns = 0, fs = 0, ps = 0, Es = 0, Ss = 0, Ps = 0, xs = 0, Bs = 0, vs = 0, eo = 0, Xs = 0, fo = 0, co = 0, ao = 0, no = 0, bo = 0, Io = 0, Po = 0, To = 0, mo = 0, Yi = 0, En = 0, On = 0, Xn = 0, ls = 0, Yn = 0, cs = 0, ks = 0, ws = 0, Ro = 0, jo = 0, Yo = 0, Mo = 0, No = 0, _s = 0;
    if (n = t[C + 100 >> 2], a = t[C + 96 >> 2], K = a + w | 0, n = K >>> 0 < w >>> 0 ? n + 1 | 0 : n, t[C + 96 >> 2] = K, t[C + 100 >> 2] = n, n = a & 63, mo = 64 - n | 0, mo >>> 0 <= w >>> 0)
      for (Mo = C + 32 | 0; as(n + Mo | 0, l, mo), a = d[C + 67 | 0], n = d[C + 65 | 0] << 16 | d[C + 64 | 0] << 24, Dn = a | (n | d[C + 66 | 0] << 8), Ce = d[C + 39 | 0], K = d[C + 37 | 0] << 16 | d[C + 36 | 0] << 24, Tt = Ce | (K | d[C + 38 | 0] << 8), ai = d[C + 59 | 0], ui = d[C + 57 | 0] << 16 | d[C + 56 | 0] << 24, Yr = ai | (ui | d[C + 58 | 0] << 8), P = d[C + 51 | 0], kr = d[C + 49 | 0] << 16 | d[C + 48 | 0] << 24, or = P | (kr | d[C + 50 | 0] << 8), tr = d[C + 43 | 0], Me = d[C + 41 | 0] << 16 | d[C + 40 | 0] << 24, nr = tr | (Me | d[C + 42 | 0] << 8), Po = (a << 25 | Dn >>> 7) ^ (Dn << 14 | n >>> 18) ^ Dn >>> 3, lr = d[C + 63 | 0], a = d[C + 61 | 0] << 16 | d[C + 60 | 0] << 24, ei = lr | (a | d[C + 62 | 0] << 8), jr = d[C + 71 | 0], gr = d[C + 69 | 0] << 16 | d[C + 68 | 0] << 24, fs = jr | (gr | d[C + 70 | 0] << 8), n = d[C + 32 | 0] | d[C + 33 | 0] << 8 | (d[C + 34 | 0] << 16 | d[C + 35 | 0] << 24), Xs = n << 8 & 16711680 | n << 24 | (n >>> 8 & 65280 | n >>> 24), pe = fs + (Xs + ((Ce << 25 | Tt >>> 7) ^ (Tt << 14 | K >>> 18) ^ Tt >>> 3) | 0) | 0, K = d[C + 89 | 0] << 16 | d[C + 88 | 0] << 24, n = K | d[C + 90 | 0] << 8, di = d[C + 91 | 0], wi = n | di, b = pe + ((wi << 15 | K >>> 17) ^ ((wi << 13 | K >>> 19) ^ n >>> 10)) | 0, fo = (ai << 25 | Yr >>> 7) ^ (Yr << 14 | ui >>> 18) ^ Yr >>> 3, ai = d[C + 55 | 0], ui = d[C + 53 | 0] << 16 | d[C + 52 | 0] << 24, Nr = ai | (ui | d[C + 54 | 0] << 8), Wi = d[C + 83 | 0], Ti = d[C + 81 | 0] << 16 | d[C + 80 | 0] << 24, ps = Wi | (Ti | d[C + 82 | 0] << 8), pe = (P << 25 | or >>> 7) ^ (or << 14 | kr >>> 18) ^ or >>> 3, Ii = d[C + 47 | 0], kr = d[C + 45 | 0] << 16 | d[C + 44 | 0] << 24, co = Ii | (kr | d[C + 46 | 0] << 8), Xi = d[C + 75 | 0], $i = d[C + 73 | 0] << 16 | d[C + 72 | 0] << 24, Es = Xi | ($i | d[C + 74 | 0] << 8), In = d[C + 95 | 0], Ce = d[C + 93 | 0] << 16 | d[C + 92 | 0] << 24, n = Ce | d[C + 94 | 0] << 8, Ei = In | n, P = (Es + (((tr << 25 | nr >>> 7) ^ (nr << 14 | Me >>> 18) ^ nr >>> 3) + Tt | 0) | 0) + ((Ei << 15 | Ce >>> 17) ^ ((Ei << 13 | Ce >>> 19) ^ n >>> 10)) | 0, Me = (ps + (pe + co | 0) | 0) + (Tr(P, 15) ^ Tr(P, 13) ^ P >>> 10) | 0, tr = ((fo + Nr | 0) + wi | 0) + (Tr(Me, 15) ^ Tr(Me, 13) ^ Me >>> 10) | 0, n = ((Po + ei | 0) + b | 0) + (Tr(tr, 15) ^ Tr(tr, 13) ^ tr >>> 10) | 0, ks = (((jr << 25 | fs >>> 7) ^ (fs << 14 | gr >>> 18) ^ fs >>> 3) + Dn | 0) + P | 0, Po = (((lr << 25 | ei >>> 7) ^ (ei << 14 | a >>> 18) ^ ei >>> 3) + Yr | 0) + Ei | 0, fo = ((ai << 25 | Nr >>> 7) ^ (Nr << 14 | ui >>> 18) ^ Nr >>> 3) + or | 0, ai = d[C + 87 | 0], ui = d[C + 85 | 0] << 16 | d[C + 84 | 0] << 24, To = ai | (ui | d[C + 86 | 0] << 8), pe = ((Ii << 25 | co >>> 7) ^ (co << 14 | kr >>> 18) ^ co >>> 3) + nr | 0, kn = d[C + 79 | 0], kr = d[C + 77 | 0] << 16 | d[C + 76 | 0] << 24, Ss = kn | (kr | d[C + 78 | 0] << 8), lr = (pe + Ss | 0) + (Tr(b, 15) ^ Tr(b, 13) ^ b >>> 10) | 0, gr = (fo + To | 0) + (Tr(lr, 15) ^ Tr(lr, 13) ^ lr >>> 10) | 0, jr = Po + (Tr(gr, 15) ^ Tr(gr, 13) ^ gr >>> 10) | 0, a = ks + (Tr(jr, 15) ^ Tr(jr, 13) ^ jr >>> 10) | 0, Di = a + ((Tr(b, 25) ^ Tr(b, 14) ^ b >>> 3) + Ei | 0) | 0, pe = (((di << 25 | wi >>> 7) ^ (wi << 14 | K >>> 18) ^ wi >>> 3) + To | 0) + jr | 0, di = ((((Xi << 25 | Es >>> 7) ^ (Es << 14 | $i >>> 18) ^ Es >>> 3) + fs | 0) + lr | 0) + (Tr(n, 15) ^ Tr(n, 13) ^ n >>> 10) | 0, Ii = ((((Wi << 25 | ps >>> 7) ^ (ps << 14 | Ti >>> 18) ^ ps >>> 3) + Ss | 0) + gr | 0) + (Tr(di, 15) ^ Tr(di, 13) ^ di >>> 10) | 0, Ti = pe + (Tr(Ii, 15) ^ Tr(Ii, 13) ^ Ii >>> 10) | 0, K = Di + (Tr(Ti, 15) ^ Tr(Ti, 13) ^ Ti >>> 10) | 0, Mn = K + ((Tr(n, 25) ^ Tr(n, 14) ^ n >>> 3) + jr | 0) | 0, Di = ((Tr(tr, 25) ^ Tr(tr, 14) ^ tr >>> 3) + gr | 0) + Ti | 0, Qi = ((Tr(Me, 25) ^ Tr(Me, 14) ^ Me >>> 3) + lr | 0) + Ii | 0, Li = ((Tr(P, 25) ^ Tr(P, 14) ^ P >>> 3) + b | 0) + di | 0, Wi = ((((kn << 25 | Ss >>> 7) ^ (Ss << 14 | kr >>> 18) ^ Ss >>> 3) + Es | 0) + Me | 0) + (Tr(a, 15) ^ Tr(a, 13) ^ a >>> 10) | 0, $i = ((((ai << 25 | To >>> 7) ^ (To << 14 | ui >>> 18) ^ To >>> 3) + ps | 0) + tr | 0) + (Tr(Wi, 15) ^ Tr(Wi, 13) ^ Wi >>> 10) | 0, Xi = ((((In << 25 | Ei >>> 7) ^ (Ei << 14 | Ce >>> 18) ^ Ei >>> 3) + wi | 0) + n | 0) + (Tr($i, 15) ^ Tr($i, 13) ^ $i >>> 10) | 0, In = Li + (Tr(Xi, 15) ^ Tr(Xi, 13) ^ Xi >>> 10) | 0, kn = Qi + (Tr(In, 15) ^ Tr(In, 13) ^ In >>> 10) | 0, Di = Di + (Tr(kn, 15) ^ Tr(kn, 13) ^ kn >>> 10) | 0, Ce = Mn + (Tr(Di, 15) ^ Tr(Di, 13) ^ Di >>> 10) | 0, ui = Ce + ((Tr(Xi, 25) ^ Tr(Xi, 14) ^ Xi >>> 3) + Ti | 0) | 0, ai = ((Tr($i, 25) ^ Tr($i, 14) ^ $i >>> 3) + Ii | 0) + Di | 0, kr = ((Tr(Wi, 25) ^ Tr(Wi, 14) ^ Wi >>> 3) + di | 0) + kn | 0, zn = ((Tr(a, 25) ^ Tr(a, 14) ^ a >>> 3) + n | 0) + In | 0, Li = ((Tr(jr, 25) ^ Tr(jr, 14) ^ jr >>> 3) + tr | 0) + Xi | 0, Qi = ((Tr(gr, 25) ^ Tr(gr, 14) ^ gr >>> 3) + Me | 0) + $i | 0, Mn = (((Tr(lr, 25) ^ Tr(lr, 14) ^ lr >>> 3) + P | 0) + Wi | 0) + (Tr(K, 15) ^ Tr(K, 13) ^ K >>> 10) | 0, Qi = Qi + (Tr(Mn, 15) ^ Tr(Mn, 13) ^ Mn >>> 10) | 0, Li = Li + (Tr(Qi, 15) ^ Tr(Qi, 13) ^ Qi >>> 10) | 0, zn = zn + (Tr(Li, 15) ^ Tr(Li, 13) ^ Li >>> 10) | 0, Ps = kr + (Tr(zn, 15) ^ Tr(zn, 13) ^ zn >>> 10) | 0, xs = ai + (Tr(Ps, 15) ^ Tr(Ps, 13) ^ Ps >>> 10) | 0, ui = ui + (Tr(xs, 15) ^ Tr(xs, 13) ^ xs >>> 10) | 0, ai = ((Tr(K, 25) ^ Tr(K, 14) ^ K >>> 3) + Xi | 0) + zn | 0, kr = ((Tr(Ti, 25) ^ Tr(Ti, 14) ^ Ti >>> 3) + $i | 0) + Li | 0, es = ((Tr(Ii, 25) ^ Tr(Ii, 14) ^ Ii >>> 3) + Wi | 0) + Qi | 0, Bs = (((Tr(di, 25) ^ Tr(di, 14) ^ di >>> 3) + a | 0) + Mn | 0) + (Tr(Ce, 15) ^ Tr(Ce, 13) ^ Ce >>> 10) | 0, es = es + (Tr(Bs, 15) ^ Tr(Bs, 13) ^ Bs >>> 10) | 0, vs = kr + (Tr(es, 15) ^ Tr(es, 13) ^ es >>> 10) | 0, ai = ai + (Tr(vs, 15) ^ Tr(vs, 13) ^ vs >>> 10) | 0, kr = ai + ((Tr(Ce, 25) ^ Tr(Ce, 14) ^ Ce >>> 3) + Li | 0) | 0, Ki = ((Tr(Di, 25) ^ Tr(Di, 14) ^ Di >>> 3) + Qi | 0) + vs | 0, ns = ((Tr(kn, 25) ^ Tr(kn, 14) ^ kn >>> 3) + Mn | 0) + es | 0, eo = (((Tr(In, 25) ^ Tr(In, 14) ^ In >>> 3) + K | 0) + Bs | 0) + (Tr(ui, 15) ^ Tr(ui, 13) ^ ui >>> 10) | 0, Yi = ns + (Tr(eo, 15) ^ Tr(eo, 13) ^ eo >>> 10) | 0, En = Ki + (Tr(Yi, 15) ^ Tr(Yi, 13) ^ Yi >>> 10) | 0, On = kr + (Tr(En, 15) ^ Tr(En, 13) ^ En >>> 10) | 0, kr = On + ((Tr(ui, 25) ^ Tr(ui, 14) ^ ui >>> 3) + vs | 0) | 0, Ki = ((Tr(xs, 25) ^ Tr(xs, 14) ^ xs >>> 3) + es | 0) + En | 0, ao = ((Tr(Ps, 25) ^ Tr(Ps, 14) ^ Ps >>> 3) + Bs | 0) + Yi | 0, no = ((Tr(zn, 25) ^ Tr(zn, 14) ^ zn >>> 3) + Ce | 0) + eo | 0, bo = ((Tr(Li, 25) ^ Tr(Li, 14) ^ Li >>> 3) + Di | 0) + ui | 0, Io = ((Tr(Qi, 25) ^ Tr(Qi, 14) ^ Qi >>> 3) + kn | 0) + xs | 0, ns = (((Tr(Mn, 25) ^ Tr(Mn, 14) ^ Mn >>> 3) + In | 0) + Ps | 0) + (Tr(ai, 15) ^ Tr(ai, 13) ^ ai >>> 10) | 0, Io = Io + (Tr(ns, 15) ^ Tr(ns, 13) ^ ns >>> 10) | 0, bo = bo + (Tr(Io, 15) ^ Tr(Io, 13) ^ Io >>> 10) | 0, no = no + (Tr(bo, 15) ^ Tr(bo, 13) ^ bo >>> 10) | 0, ao = ao + (Tr(no, 15) ^ Tr(no, 13) ^ no >>> 10) | 0, ws = Ki + (Tr(ao, 15) ^ Tr(ao, 13) ^ ao >>> 10) | 0, Ro = kr + (Tr(ws, 15) ^ Tr(ws, 13) ^ ws >>> 10) | 0, ks = t[C + 12 >> 2], Po = t[C + 28 >> 2], Ki = t[C + 16 >> 2], kr = Po + (Tr(Ki, 26) ^ Tr(Ki, 21) ^ Tr(Ki, 7)) | 0, Xn = t[C + 20 >> 2], jo = t[C + 24 >> 2], ls = (Xs + (kr + ((Xn ^ jo) & Ki ^ jo) | 0) | 0) + 1116352408 | 0, kr = ls + ks | 0, Xs = t[C + 4 >> 2], pe = nr + Xn | 0, Yo = t[C + 8 >> 2], Yn = (((jo + (kr & (Ki ^ Xn) ^ Xn) | 0) + Tt | 0) + (Tr(kr, 26) ^ Tr(kr, 21) ^ Tr(kr, 7)) | 0) + 1899447441 | 0, nr = Yo + Yn | 0, cs = ((pe + (nr & (kr ^ Ki) ^ Ki) | 0) + (Tr(nr, 26) ^ Tr(nr, 21) ^ Tr(nr, 7)) | 0) - 1245643825 | 0, Tt = Xs + cs | 0, pe = or + kr | 0, fo = (((Ki + co | 0) + (Tt & (nr ^ kr) ^ kr) | 0) + (Tr(Tt, 26) ^ Tr(Tt, 21) ^ Tr(Tt, 7)) | 0) - 373957723 | 0, kr = t[C >> 2], or = fo + kr | 0, co = ((pe + (or & (Tt ^ nr) ^ nr) | 0) + (Tr(or, 26) ^ Tr(or, 21) ^ Tr(or, 7)) | 0) + 961987163 | 0, pe = nr + Nr | 0, nr = ((Yo & (kr | Xs) | kr & Xs) + (Tr(kr, 30) ^ Tr(kr, 19) ^ Tr(kr, 10)) | 0) + ls | 0, Nr = nr + co | 0, ls = ((pe + (Nr & (Tt ^ or) ^ Tt) | 0) + (Tr(Nr, 26) ^ Tr(Nr, 21) ^ Tr(Nr, 7)) | 0) + 1508970993 | 0, pe = Tt + Yr | 0, Tt = (((nr | kr) & Xs | nr & kr) + (Tr(nr, 30) ^ Tr(nr, 19) ^ Tr(nr, 10)) | 0) + Yn | 0, Yr = Tt + ls | 0, Yn = ((pe + (Yr & (or ^ Nr) ^ or) | 0) + (Tr(Yr, 26) ^ Tr(Yr, 21) ^ Tr(Yr, 7)) | 0) - 1841331548 | 0, pe = or + ei | 0, or = (((Tt | nr) & kr | Tt & nr) + (Tr(Tt, 30) ^ Tr(Tt, 19) ^ Tr(Tt, 10)) | 0) + cs | 0, ei = or + Yn | 0, cs = ((pe + (ei & (Nr ^ Yr) ^ Nr) | 0) + (Tr(ei, 26) ^ Tr(ei, 21) ^ Tr(ei, 7)) | 0) - 1424204075 | 0, pe = Nr + Dn | 0, nr = (((Tt | or) & nr | Tt & or) + (Tr(or, 30) ^ Tr(or, 19) ^ Tr(or, 10)) | 0) + fo | 0, Nr = nr + cs | 0, Dn = ((pe + (Nr & (Yr ^ ei) ^ Yr) | 0) + (Tr(Nr, 26) ^ Tr(Nr, 21) ^ Tr(Nr, 7)) | 0) - 670586216 | 0, pe = Yr + fs | 0, Tt = (((nr | or) & Tt | nr & or) + (Tr(nr, 30) ^ Tr(nr, 19) ^ Tr(nr, 10)) | 0) + co | 0, Yr = Tt + Dn | 0, fs = ((pe + (Yr & (Nr ^ ei) ^ ei) | 0) + (Tr(Yr, 26) ^ Tr(Yr, 21) ^ Tr(Yr, 7)) | 0) + 310598401 | 0, pe = ei + Es | 0, or = (((Tt | nr) & or | Tt & nr) + (Tr(Tt, 30) ^ Tr(Tt, 19) ^ Tr(Tt, 10)) | 0) + ls | 0, ei = or + fs | 0, Es = ((pe + (ei & (Nr ^ Yr) ^ Nr) | 0) + (Tr(ei, 26) ^ Tr(ei, 21) ^ Tr(ei, 7)) | 0) + 607225278 | 0, pe = Nr + Ss | 0, nr = (((Tt | or) & nr | Tt & or) + (Tr(or, 30) ^ Tr(or, 19) ^ Tr(or, 10)) | 0) + Yn | 0, Nr = nr + Es | 0, Ss = ((pe + (Nr & (Yr ^ ei) ^ Yr) | 0) + (Tr(Nr, 26) ^ Tr(Nr, 21) ^ Tr(Nr, 7)) | 0) + 1426881987 | 0, pe = Yr + ps | 0, Tt = (((nr | or) & Tt | nr & or) + (Tr(nr, 30) ^ Tr(nr, 19) ^ Tr(nr, 10)) | 0) + cs | 0, Yr = Tt + Ss | 0, ps = ((pe + (Yr & (Nr ^ ei) ^ ei) | 0) + (Tr(Yr, 26) ^ Tr(Yr, 21) ^ Tr(Yr, 7)) | 0) + 1925078388 | 0, pe = ei + To | 0, or = (((Tt | nr) & or | Tt & nr) + (Tr(Tt, 30) ^ Tr(Tt, 19) ^ Tr(Tt, 10)) | 0) + Dn | 0, ei = or + ps | 0, Dn = ((pe + (ei & (Nr ^ Yr) ^ Nr) | 0) + (Tr(ei, 26) ^ Tr(ei, 21) ^ Tr(ei, 7)) | 0) - 2132889090 | 0, pe = Nr + wi | 0, nr = (((Tt | or) & nr | Tt & or) + (Tr(or, 30) ^ Tr(or, 19) ^ Tr(or, 10)) | 0) + fs | 0, wi = nr + Dn | 0, Nr = ((pe + (wi & (Yr ^ ei) ^ Yr) | 0) + (Tr(wi, 26) ^ Tr(wi, 21) ^ Tr(wi, 7)) | 0) - 1680079193 | 0, pe = Yr + Ei | 0, Tt = (((nr | or) & Tt | nr & or) + (Tr(nr, 30) ^ Tr(nr, 19) ^ Tr(nr, 10)) | 0) + Es | 0, Ei = Tt + Nr | 0, Yr = ((pe + (Ei & (ei ^ wi) ^ ei) | 0) + (Tr(Ei, 26) ^ Tr(Ei, 21) ^ Tr(Ei, 7)) | 0) - 1046744716 | 0, pe = b + ei | 0, b = (((Tt | nr) & or | Tt & nr) + (Tr(Tt, 30) ^ Tr(Tt, 19) ^ Tr(Tt, 10)) | 0) + Ss | 0, or = b + Yr | 0, ei = ((pe + (or & (wi ^ Ei) ^ wi) | 0) + (Tr(or, 26) ^ Tr(or, 21) ^ Tr(or, 7)) | 0) - 459576895 | 0, pe = P + wi | 0, P = (((b | Tt) & nr | b & Tt) + (Tr(b, 30) ^ Tr(b, 19) ^ Tr(b, 10)) | 0) + ps | 0, nr = P + ei | 0, wi = ((pe + (nr & (or ^ Ei) ^ Ei) | 0) + (Tr(nr, 26) ^ Tr(nr, 21) ^ Tr(nr, 7)) | 0) - 272742522 | 0, pe = lr + Ei | 0, lr = (((b | P) & Tt | b & P) + (Tr(P, 30) ^ Tr(P, 19) ^ Tr(P, 10)) | 0) + Dn | 0, Tt = lr + wi | 0, Ei = ((pe + (Tt & (nr ^ or) ^ or) | 0) + (Tr(Tt, 26) ^ Tr(Tt, 21) ^ Tr(Tt, 7)) | 0) + 264347078 | 0, pe = Me + or | 0, b = (((P | lr) & b | P & lr) + (Tr(lr, 30) ^ Tr(lr, 19) ^ Tr(lr, 10)) | 0) + Nr | 0, or = b + Ei | 0, Nr = ((pe + (or & (Tt ^ nr) ^ nr) | 0) + (Tr(or, 26) ^ Tr(or, 21) ^ Tr(or, 7)) | 0) + 604807628 | 0, pe = nr + gr | 0, P = (((b | lr) & P | b & lr) + (Tr(b, 30) ^ Tr(b, 19) ^ Tr(b, 10)) | 0) + Yr | 0, gr = P + Nr | 0, nr = ((pe + (gr & (Tt ^ or) ^ Tt) | 0) + (Tr(gr, 26) ^ Tr(gr, 21) ^ Tr(gr, 7)) | 0) + 770255983 | 0, pe = Tt + tr | 0, Me = (((b | P) & lr | b & P) + (Tr(P, 30) ^ Tr(P, 19) ^ Tr(P, 10)) | 0) + ei | 0, tr = Me + nr | 0, Tt = ((pe + (tr & (or ^ gr) ^ or) | 0) + (Tr(tr, 26) ^ Tr(tr, 21) ^ Tr(tr, 7)) | 0) + 1249150122 | 0, b = (((P | Me) & b | P & Me) + (Tr(Me, 30) ^ Tr(Me, 19) ^ Tr(Me, 10)) | 0) + wi | 0, lr = b + Tt | 0, jr = (((or + jr | 0) + (lr & (tr ^ gr) ^ gr) | 0) + (Tr(lr, 26) ^ Tr(lr, 21) ^ Tr(lr, 7)) | 0) + 1555081692 | 0, pe = n + gr | 0, n = (((b | Me) & P | b & Me) + (Tr(b, 30) ^ Tr(b, 19) ^ Tr(b, 10)) | 0) + Ei | 0, P = n + jr | 0, gr = ((pe + (P & (tr ^ lr) ^ tr) | 0) + (Tr(P, 26) ^ Tr(P, 21) ^ Tr(P, 7)) | 0) + 1996064986 | 0, pe = a + tr | 0, a = (((n | b) & Me | n & b) + (Tr(n, 30) ^ Tr(n, 19) ^ Tr(n, 10)) | 0) + Nr | 0, Me = a + gr | 0, or = ((pe + (Me & (P ^ lr) ^ lr) | 0) + (Tr(Me, 26) ^ Tr(Me, 21) ^ Tr(Me, 7)) | 0) - 1740746414 | 0, b = (((n | a) & b | n & a) + (Tr(a, 30) ^ Tr(a, 19) ^ Tr(a, 10)) | 0) + nr | 0, tr = b + or | 0, lr = (((lr + di | 0) + (tr & (P ^ Me) ^ P) | 0) + (Tr(tr, 26) ^ Tr(tr, 21) ^ Tr(tr, 7)) | 0) - 1473132947 | 0, pe = P + Wi | 0, n = (((a | b) & n | a & b) + (Tr(b, 30) ^ Tr(b, 19) ^ Tr(b, 10)) | 0) + Tt | 0, P = n + lr | 0, di = ((pe + (P & (Me ^ tr) ^ Me) | 0) + (Tr(P, 26) ^ Tr(P, 21) ^ Tr(P, 7)) | 0) - 1341970488 | 0, pe = Me + Ii | 0, a = (((n | b) & a | n & b) + (Tr(n, 30) ^ Tr(n, 19) ^ Tr(n, 10)) | 0) + jr | 0, Me = a + di | 0, jr = ((pe + (Me & (P ^ tr) ^ tr) | 0) + (Tr(Me, 26) ^ Tr(Me, 21) ^ Tr(Me, 7)) | 0) - 1084653625 | 0, pe = tr + $i | 0, b = (((n | a) & b | n & a) + (Tr(a, 30) ^ Tr(a, 19) ^ Tr(a, 10)) | 0) + gr | 0, tr = b + jr | 0, gr = ((pe + (tr & (P ^ Me) ^ P) | 0) + (Tr(tr, 26) ^ Tr(tr, 21) ^ Tr(tr, 7)) | 0) - 958395405 | 0, pe = P + Ti | 0, n = (((a | b) & n | a & b) + (Tr(b, 30) ^ Tr(b, 19) ^ Tr(b, 10)) | 0) + or | 0, P = n + gr | 0, Ii = ((pe + (P & (Me ^ tr) ^ Me) | 0) + (Tr(P, 26) ^ Tr(P, 21) ^ Tr(P, 7)) | 0) - 710438585 | 0, pe = Me + Xi | 0, a = (((n | b) & a | n & b) + (Tr(n, 30) ^ Tr(n, 19) ^ Tr(n, 10)) | 0) + lr | 0, Me = a + Ii | 0, lr = ((pe + (Me & (P ^ tr) ^ tr) | 0) + (Tr(Me, 26) ^ Tr(Me, 21) ^ Tr(Me, 7)) | 0) + 113926993 | 0, pe = K + tr | 0, K = (((n | a) & b | n & a) + (Tr(a, 30) ^ Tr(a, 19) ^ Tr(a, 10)) | 0) + di | 0, b = K + lr | 0, tr = ((pe + (b & (P ^ Me) ^ P) | 0) + (Tr(b, 26) ^ Tr(b, 21) ^ Tr(b, 7)) | 0) + 338241895 | 0, pe = P + In | 0, n = (((a | K) & n | a & K) + (Tr(K, 30) ^ Tr(K, 19) ^ Tr(K, 10)) | 0) + jr | 0, P = n + tr | 0, jr = ((pe + (P & (b ^ Me) ^ Me) | 0) + (Tr(P, 26) ^ Tr(P, 21) ^ Tr(P, 7)) | 0) + 666307205 | 0, pe = Me + Mn | 0, a = (((n | K) & a | n & K) + (Tr(n, 30) ^ Tr(n, 19) ^ Tr(n, 10)) | 0) + gr | 0, Me = a + jr | 0, gr = ((pe + (Me & (b ^ P) ^ b) | 0) + (Tr(Me, 26) ^ Tr(Me, 21) ^ Tr(Me, 7)) | 0) + 773529912 | 0, pe = b + kn | 0, K = (((n | a) & K | n & a) + (Tr(a, 30) ^ Tr(a, 19) ^ Tr(a, 10)) | 0) + Ii | 0, b = K + gr | 0, di = ((pe + (b & (P ^ Me) ^ P) | 0) + (Tr(b, 26) ^ Tr(b, 21) ^ Tr(b, 7)) | 0) + 1294757372 | 0, pe = P + Qi | 0, n = (((a | K) & n | a & K) + (Tr(K, 30) ^ Tr(K, 19) ^ Tr(K, 10)) | 0) + lr | 0, P = n + di | 0, lr = ((pe + (P & (b ^ Me) ^ Me) | 0) + (Tr(P, 26) ^ Tr(P, 21) ^ Tr(P, 7)) | 0) + 1396182291 | 0, pe = Me + Di | 0, a = (((n | K) & a | n & K) + (Tr(n, 30) ^ Tr(n, 19) ^ Tr(n, 10)) | 0) + tr | 0, Me = a + lr | 0, tr = ((pe + (Me & (b ^ P) ^ b) | 0) + (Tr(Me, 26) ^ Tr(Me, 21) ^ Tr(Me, 7)) | 0) + 1695183700 | 0, pe = b + Li | 0, K = (((n | a) & K | n & a) + (Tr(a, 30) ^ Tr(a, 19) ^ Tr(a, 10)) | 0) + jr | 0, b = K + tr | 0, jr = ((pe + (b & (P ^ Me) ^ P) | 0) + (Tr(b, 26) ^ Tr(b, 21) ^ Tr(b, 7)) | 0) + 1986661051 | 0, pe = P + Ce | 0, n = (((a | K) & n | a & K) + (Tr(K, 30) ^ Tr(K, 19) ^ Tr(K, 10)) | 0) + gr | 0, Ce = n + jr | 0, gr = ((pe + (Ce & (b ^ Me) ^ Me) | 0) + (Tr(Ce, 26) ^ Tr(Ce, 21) ^ Tr(Ce, 7)) | 0) - 2117940946 | 0, a = (((n | K) & a | n & K) + (Tr(n, 30) ^ Tr(n, 19) ^ Tr(n, 10)) | 0) + di | 0, P = a + gr | 0, Me = (((Me + zn | 0) + (P & (b ^ Ce) ^ b) | 0) + (Tr(P, 26) ^ Tr(P, 21) ^ Tr(P, 7)) | 0) - 1838011259 | 0, pe = b + Bs | 0, K = (((n | a) & K | n & a) + (Tr(a, 30) ^ Tr(a, 19) ^ Tr(a, 10)) | 0) + lr | 0, b = K + Me | 0, lr = ((pe + (b & (P ^ Ce) ^ Ce) | 0) + (Tr(b, 26) ^ Tr(b, 21) ^ Tr(b, 7)) | 0) - 1564481375 | 0, pe = Ce + Ps | 0, n = (((a | K) & n | a & K) + (Tr(K, 30) ^ Tr(K, 19) ^ Tr(K, 10)) | 0) + tr | 0, Ce = n + lr | 0, tr = ((pe + (Ce & (b ^ P) ^ P) | 0) + (Tr(Ce, 26) ^ Tr(Ce, 21) ^ Tr(Ce, 7)) | 0) - 1474664885 | 0, pe = P + es | 0, a = (((n | K) & a | n & K) + (Tr(n, 30) ^ Tr(n, 19) ^ Tr(n, 10)) | 0) + jr | 0, P = a + tr | 0, jr = ((pe + (P & (b ^ Ce) ^ b) | 0) + (Tr(P, 26) ^ Tr(P, 21) ^ Tr(P, 7)) | 0) - 1035236496 | 0, pe = b + xs | 0, K = (((n | a) & K | n & a) + (Tr(a, 30) ^ Tr(a, 19) ^ Tr(a, 10)) | 0) + gr | 0, b = K + jr | 0, gr = ((pe + (b & (P ^ Ce) ^ Ce) | 0) + (Tr(b, 26) ^ Tr(b, 21) ^ Tr(b, 7)) | 0) - 949202525 | 0, pe = Ce + vs | 0, n = (((a | K) & n | a & K) + (Tr(K, 30) ^ Tr(K, 19) ^ Tr(K, 10)) | 0) + Me | 0, Ce = n + gr | 0, Me = ((pe + (Ce & (b ^ P) ^ P) | 0) + (Tr(Ce, 26) ^ Tr(Ce, 21) ^ Tr(Ce, 7)) | 0) - 778901479 | 0, pe = P + ui | 0, a = (((n | K) & a | n & K) + (Tr(n, 30) ^ Tr(n, 19) ^ Tr(n, 10)) | 0) + lr | 0, P = a + Me | 0, lr = ((pe + (P & (b ^ Ce) ^ b) | 0) + (Tr(P, 26) ^ Tr(P, 21) ^ Tr(P, 7)) | 0) - 694614492 | 0, pe = b + ai | 0, K = (((n | a) & K | n & a) + (Tr(a, 30) ^ Tr(a, 19) ^ Tr(a, 10)) | 0) + tr | 0, b = K + lr | 0, tr = ((pe + (b & (P ^ Ce) ^ Ce) | 0) + (Tr(b, 26) ^ Tr(b, 21) ^ Tr(b, 7)) | 0) - 200395387 | 0, pe = Ce + eo | 0, n = (((a | K) & n | a & K) + (Tr(K, 30) ^ Tr(K, 19) ^ Tr(K, 10)) | 0) + jr | 0, Ce = n + tr | 0, jr = ((pe + (Ce & (b ^ P) ^ P) | 0) + (Tr(Ce, 26) ^ Tr(Ce, 21) ^ Tr(Ce, 7)) | 0) + 275423344 | 0, pe = P + ns | 0, a = (((n | K) & a | n & K) + (Tr(n, 30) ^ Tr(n, 19) ^ Tr(n, 10)) | 0) + gr | 0, P = a + jr | 0, gr = ((pe + (P & (b ^ Ce) ^ b) | 0) + (Tr(P, 26) ^ Tr(P, 21) ^ Tr(P, 7)) | 0) + 430227734 | 0, pe = b + Yi | 0, K = (((n | a) & K | n & a) + (Tr(a, 30) ^ Tr(a, 19) ^ Tr(a, 10)) | 0) + Me | 0, b = K + gr | 0, Me = ((pe + (b & (P ^ Ce) ^ Ce) | 0) + (Tr(b, 26) ^ Tr(b, 21) ^ Tr(b, 7)) | 0) + 506948616 | 0, pe = Ce + Io | 0, n = (((a | K) & n | a & K) + (Tr(K, 30) ^ Tr(K, 19) ^ Tr(K, 10)) | 0) + lr | 0, Ce = n + Me | 0, di = ((pe + (Ce & (b ^ P) ^ P) | 0) + (Tr(Ce, 26) ^ Tr(Ce, 21) ^ Tr(Ce, 7)) | 0) + 659060556 | 0, pe = P + En | 0, a = (((n | K) & a | n & K) + (Tr(n, 30) ^ Tr(n, 19) ^ Tr(n, 10)) | 0) + tr | 0, P = a + di | 0, tr = ((pe + (P & (b ^ Ce) ^ b) | 0) + (Tr(P, 26) ^ Tr(P, 21) ^ Tr(P, 7)) | 0) + 883997877 | 0, pe = b + bo | 0, K = (((n | a) & K | n & a) + (Tr(a, 30) ^ Tr(a, 19) ^ Tr(a, 10)) | 0) + jr | 0, b = K + tr | 0, jr = ((pe + (b & (P ^ Ce) ^ Ce) | 0) + (Tr(b, 26) ^ Tr(b, 21) ^ Tr(b, 7)) | 0) + 958139571 | 0, pe = Ce + On | 0, n = (((a | K) & n | a & K) + (Tr(K, 30) ^ Tr(K, 19) ^ Tr(K, 10)) | 0) + gr | 0, Ce = n + jr | 0, Ii = ((pe + (Ce & (b ^ P) ^ P) | 0) + (Tr(Ce, 26) ^ Tr(Ce, 21) ^ Tr(Ce, 7)) | 0) + 1322822218 | 0, pe = P + no | 0, a = (((n | K) & a | n & K) + (Tr(n, 30) ^ Tr(n, 19) ^ Tr(n, 10)) | 0) + Me | 0, P = a + Ii | 0, Ti = ((pe + (P & (b ^ Ce) ^ b) | 0) + (Tr(P, 26) ^ Tr(P, 21) ^ Tr(P, 7)) | 0) + 1537002063 | 0, lr = (((Tr(Bs, 25) ^ Tr(Bs, 14) ^ Bs >>> 3) + zn | 0) + ns | 0) + (Tr(On, 15) ^ Tr(On, 13) ^ On >>> 10) | 0, pe = lr + b | 0, K = (((n | a) & K | n & a) + (Tr(a, 30) ^ Tr(a, 19) ^ Tr(a, 10)) | 0) + di | 0, b = K + Ti | 0, di = ((pe + (b & (P ^ Ce) ^ Ce) | 0) + (Tr(b, 26) ^ Tr(b, 21) ^ Tr(b, 7)) | 0) + 1747873779 | 0, pe = Ce + ao | 0, n = (((a | K) & n | a & K) + (Tr(K, 30) ^ Tr(K, 19) ^ Tr(K, 10)) | 0) + tr | 0, Ce = n + di | 0, tr = ((pe + (Ce & (b ^ P) ^ P) | 0) + (Tr(Ce, 26) ^ Tr(Ce, 21) ^ Tr(Ce, 7)) | 0) + 1955562222 | 0, gr = ((Tr(vs, 25) ^ Tr(vs, 14) ^ vs >>> 3) + xs | 0) + bo | 0, Me = (((Tr(es, 25) ^ Tr(es, 14) ^ es >>> 3) + Ps | 0) + Io | 0) + (Tr(lr, 15) ^ Tr(lr, 13) ^ lr >>> 10) | 0, gr = gr + (Tr(Me, 15) ^ Tr(Me, 13) ^ Me >>> 10) | 0, pe = P + Me | 0, a = (((n | K) & a | n & K) + (Tr(n, 30) ^ Tr(n, 19) ^ Tr(n, 10)) | 0) + jr | 0, P = a + tr | 0, jr = ((pe + (P & (b ^ Ce) ^ b) | 0) + (Tr(P, 26) ^ Tr(P, 21) ^ Tr(P, 7)) | 0) + 2024104815 | 0, pe = b + ws | 0, K = (((n | a) & K | n & a) + (Tr(a, 30) ^ Tr(a, 19) ^ Tr(a, 10)) | 0) + Ii | 0, b = K + jr | 0, Ii = ((pe + (b & (P ^ Ce) ^ Ce) | 0) + (Tr(b, 26) ^ Tr(b, 21) ^ Tr(b, 7)) | 0) - 2067236844 | 0, n = (((a | K) & n | a & K) + (Tr(K, 30) ^ Tr(K, 19) ^ Tr(K, 10)) | 0) + Ti | 0, Me = n + Ii | 0, Ti = (((Ce + gr | 0) + (Me & (b ^ P) ^ P) | 0) + (Tr(Me, 26) ^ Tr(Me, 21) ^ Tr(Me, 7)) | 0) - 1933114872 | 0, pe = P + Ro | 0, a = (((n | K) & a | n & K) + (Tr(n, 30) ^ Tr(n, 19) ^ Tr(n, 10)) | 0) + di | 0, P = a + Ti | 0, di = ((pe + (P & (b ^ Me) ^ b) | 0) + (Tr(P, 26) ^ Tr(P, 21) ^ Tr(P, 7)) | 0) - 1866530822 | 0, K = (((n | a) & K | n & a) + (Tr(a, 30) ^ Tr(a, 19) ^ Tr(a, 10)) | 0) + tr | 0, tr = di + K | 0, t[C + 28 >> 2] = tr + Po, Ce = (((a | K) & n | a & K) + (Tr(K, 30) ^ Tr(K, 19) ^ Tr(K, 10)) | 0) + jr | 0, n = ((a & (Ce | K) | K & Ce) + (Tr(Ce, 30) ^ Tr(Ce, 19) ^ Tr(Ce, 10)) | 0) + Ii | 0, a = (((n | Ce) & K | n & Ce) + (Tr(n, 30) ^ Tr(n, 19) ^ Tr(n, 10)) | 0) + Ti | 0, K = (((a | n) & Ce | n & a) + (Tr(a, 30) ^ Tr(a, 19) ^ Tr(a, 10)) | 0) + di | 0, t[C + 12 >> 2] = K + ks, fo = Ce, pe = b, b = (((Tr(ai, 25) ^ Tr(ai, 14) ^ ai >>> 3) + ui | 0) + no | 0) + (Tr(gr, 15) ^ Tr(gr, 13) ^ gr >>> 10) | 0, Ce = (((pe + b | 0) + (tr & (P ^ Me) ^ Me) | 0) + (Tr(tr, 26) ^ Tr(tr, 21) ^ Tr(tr, 7)) | 0) - 1538233109 | 0, ui = fo + Ce | 0, t[C + 24 >> 2] = ui + jo, Ce = (((a | K) & n | a & K) + (Tr(K, 30) ^ Tr(K, 19) ^ Tr(K, 10)) | 0) + Ce | 0, t[C + 8 >> 2] = Ce + Yo, pe = n, n = ((((((ai + (Tr(eo, 25) ^ Tr(eo, 14) ^ eo >>> 3) | 0) + lr | 0) + (Tr(Ro, 15) ^ Tr(Ro, 13) ^ Ro >>> 10) | 0) + Me | 0) + (ui & (P ^ tr) ^ P) | 0) + (Tr(ui, 26) ^ Tr(ui, 21) ^ Tr(ui, 7)) | 0) - 1090935817 | 0, ai = pe + n | 0, t[C + 20 >> 2] = ai + Xn, n = (((K | Ce) & a | K & Ce) + (Tr(Ce, 30) ^ Tr(Ce, 19) ^ Tr(Ce, 10)) | 0) + n | 0, t[C + 4 >> 2] = n + Xs, pe = a + Ki | 0, a = ((((((eo + (Tr(ns, 25) ^ Tr(ns, 14) ^ ns >>> 3) | 0) + ao | 0) + (Tr(b, 15) ^ Tr(b, 13) ^ b >>> 10) | 0) + P | 0) + (ai & (tr ^ ui) ^ tr) | 0) + (Tr(ai, 26) ^ Tr(ai, 21) ^ Tr(ai, 7)) | 0) - 965641998 | 0, t[C + 16 >> 2] = pe + a, No = C, _s = ((kr + ((n | Ce) & K | n & Ce) | 0) + (Tr(n, 30) ^ Tr(n, 19) ^ Tr(n, 10)) | 0) + a | 0, t[No >> 2] = _s, l = l + mo | 0, w = w - mo | 0, mo = 64, n = 0, w >>> 0 > 63; )
        ;
    w && as((C + n | 0) + 32 | 0, l, w);
  }
  function fi(C, l) {
    var w = 0, n = 0, a = 0;
    n = U - 16 | 0, U = n, w = t[C + 100 >> 2], a = t[C + 96 >> 2], c[n + 11 | 0] = (w & 536870911) << 3 | a >>> 29, c[n + 10 | 0] = w >>> 5, c[n + 9 | 0] = w >>> 13, c[n + 8 | 0] = w >>> 21, c[n + 15 | 0] = a << 3, c[n + 14 | 0] = a >>> 5, c[n + 13 | 0] = a >>> 13, c[n + 12 | 0] = a >>> 21, Wr(C, 690512, (55 - a & 63) + 1 | 0), Wr(C, n + 8 | 0, 8), w = t[C >> 2], w = w << 8 & 16711680 | w << 24 | (w >>> 8 & 65280 | w >>> 24), c[l | 0] = w, c[l + 1 | 0] = w >>> 8, c[l + 2 | 0] = w >>> 16, c[l + 3 | 0] = w >>> 24, t[C >> 2] = 0, w = t[C + 4 >> 2], w = w << 8 & 16711680 | w << 24 | (w >>> 8 & 65280 | w >>> 24), c[l + 4 | 0] = w, c[l + 5 | 0] = w >>> 8, c[l + 6 | 0] = w >>> 16, c[l + 7 | 0] = w >>> 24, t[C + 4 >> 2] = 0, w = t[C + 8 >> 2], w = w << 8 & 16711680 | w << 24 | (w >>> 8 & 65280 | w >>> 24), c[l + 8 | 0] = w, c[l + 9 | 0] = w >>> 8, c[l + 10 | 0] = w >>> 16, c[l + 11 | 0] = w >>> 24, t[C + 8 >> 2] = 0, w = t[C + 12 >> 2], w = w << 8 & 16711680 | w << 24 | (w >>> 8 & 65280 | w >>> 24), c[l + 12 | 0] = w, c[l + 13 | 0] = w >>> 8, c[l + 14 | 0] = w >>> 16, c[l + 15 | 0] = w >>> 24, t[C + 12 >> 2] = 0, w = t[C + 16 >> 2], w = w << 8 & 16711680 | w << 24 | (w >>> 8 & 65280 | w >>> 24), c[l + 16 | 0] = w, c[l + 17 | 0] = w >>> 8, c[l + 18 | 0] = w >>> 16, c[l + 19 | 0] = w >>> 24, t[C + 16 >> 2] = 0, w = t[C + 20 >> 2], w = w << 8 & 16711680 | w << 24 | (w >>> 8 & 65280 | w >>> 24), c[l + 20 | 0] = w, c[l + 21 | 0] = w >>> 8, c[l + 22 | 0] = w >>> 16, c[l + 23 | 0] = w >>> 24, t[C + 20 >> 2] = 0, w = t[C + 24 >> 2], w = w << 8 & 16711680 | w << 24 | (w >>> 8 & 65280 | w >>> 24), c[l + 24 | 0] = w, c[l + 25 | 0] = w >>> 8, c[l + 26 | 0] = w >>> 16, c[l + 27 | 0] = w >>> 24, t[C + 24 >> 2] = 0, w = t[C + 28 >> 2], w = w << 8 & 16711680 | w << 24 | (w >>> 8 & 65280 | w >>> 24), c[l + 28 | 0] = w, c[l + 29 | 0] = w >>> 8, c[l + 30 | 0] = w >>> 16, c[l + 31 | 0] = w >>> 24, t[C + 28 >> 2] = 0, U = n + 16 | 0;
  }
  function Bi(C, l, w, n) {
    var a = 0, b = 0, P = 0, K = 0, pe = 0, Ce = 0, Me = 0, Tt = 0, tr = 0, nr = 0, or = 0, lr = 0, gr = 0, kr = 0, Nr = 0, jr = 0, Yr = 0, ei = 0, ai = 0, ui = 0, di = 0, Ii = 0, wi = 0, Ei = 0, Ti = 0, Di = 0, Qi = 0, Li = 0, Ki = 0, Wi = 0, Xi = 0, $i = 0, In = 0, kn = 0, Dn = 0, Mn = 0, zn = 0, es = 0, ns = 0, fs = 0, ps = 0, Es = 0, Ss = 0, Ps = 0, xs = 0, Bs = 0, vs = 0;
    P = U - 880 | 0, U = P;
    e: {
      if (!l) {
        yi[t[C + 168 >> 2]](689638, t[C + 172 >> 2]), C = 0;
        break e;
      }
      if (c[l | 0] = 0, c[l + 1 | 0] = 0, c[l + 2 | 0] = 0, c[l + 3 | 0] = 0, c[l + 4 | 0] = 0, c[l + 5 | 0] = 0, c[l + 6 | 0] = 0, c[l + 7 | 0] = 0, a = l + 56 | 0, c[a | 0] = 0, c[a + 1 | 0] = 0, c[a + 2 | 0] = 0, c[a + 3 | 0] = 0, c[a + 4 | 0] = 0, c[a + 5 | 0] = 0, c[a + 6 | 0] = 0, c[a + 7 | 0] = 0, a = l + 48 | 0, c[a | 0] = 0, c[a + 1 | 0] = 0, c[a + 2 | 0] = 0, c[a + 3 | 0] = 0, c[a + 4 | 0] = 0, c[a + 5 | 0] = 0, c[a + 6 | 0] = 0, c[a + 7 | 0] = 0, a = l + 40 | 0, c[a | 0] = 0, c[a + 1 | 0] = 0, c[a + 2 | 0] = 0, c[a + 3 | 0] = 0, c[a + 4 | 0] = 0, c[a + 5 | 0] = 0, c[a + 6 | 0] = 0, c[a + 7 | 0] = 0, a = l + 32 | 0, c[a | 0] = 0, c[a + 1 | 0] = 0, c[a + 2 | 0] = 0, c[a + 3 | 0] = 0, c[a + 4 | 0] = 0, c[a + 5 | 0] = 0, c[a + 6 | 0] = 0, c[a + 7 | 0] = 0, a = l + 24 | 0, c[a | 0] = 0, c[a + 1 | 0] = 0, c[a + 2 | 0] = 0, c[a + 3 | 0] = 0, c[a + 4 | 0] = 0, c[a + 5 | 0] = 0, c[a + 6 | 0] = 0, c[a + 7 | 0] = 0, a = l + 16 | 0, c[a | 0] = 0, c[a + 1 | 0] = 0, c[a + 2 | 0] = 0, c[a + 3 | 0] = 0, c[a + 4 | 0] = 0, c[a + 5 | 0] = 0, c[a + 6 | 0] = 0, c[a + 7 | 0] = 0, a = l + 8 | 0, c[a | 0] = 0, c[a + 1 | 0] = 0, c[a + 2 | 0] = 0, c[a + 3 | 0] = 0, c[a + 4 | 0] = 0, c[a + 5 | 0] = 0, c[a + 6 | 0] = 0, c[a + 7 | 0] = 0, !w) {
        yi[t[C + 168 >> 2]](689668, t[C + 172 >> 2]), C = 0;
        break e;
      }
      C = 0;
      t: {
        if ((n | 0) != 65) {
          if ((n | 0) != 33 || (d[w | 0] & 254) != 2)
            break e;
          if (!$r(P + 840 | 0, w + 1 | 0)) {
            n = 0;
            break t;
          }
          n = (oi(P + 672 | 0, P + 840 | 0, d[w | 0] == 3) | 0) != 0;
          break t;
        }
        if (n = d[w | 0], n >>> 0 > 7 || !(1 << n & 208))
          break e;
        if (n = 0, !$r(P + 800 | 0, w + 1 | 0) || !$r(P + 760 | 0, w + 33 | 0) || (K = P + 800 | 0, b = K + 8 | 0, a = t[b + 4 >> 2], pe = P + 672 | 0, n = pe + 8 | 0, t[n >> 2] = t[b >> 2], t[n + 4 >> 2] = a, b = K + 16 | 0, a = t[b + 4 >> 2], n = pe + 16 | 0, t[n >> 2] = t[b >> 2], t[n + 4 >> 2] = a, b = K + 24 | 0, a = t[b + 4 >> 2], n = pe + 24 | 0, t[n >> 2] = t[b >> 2], t[n + 4 >> 2] = a, b = K + 32 | 0, a = t[b + 4 >> 2], n = pe + 32 | 0, t[n >> 2] = t[b >> 2], t[n + 4 >> 2] = a, b = P + 760 | 0, a = b + 8 | 0, n = t[a + 4 >> 2], jr = P + 720 | 0, t[jr >> 2] = t[a >> 2], t[jr + 4 >> 2] = n, a = b + 16 | 0, n = t[a + 4 >> 2], or = P + 728 | 0, t[or >> 2] = t[a >> 2], t[or + 4 >> 2] = n, a = b + 24 | 0, n = t[a + 4 >> 2], K = P + 736 | 0, t[K >> 2] = t[a >> 2], t[K + 4 >> 2] = n, a = b + 32 | 0, n = t[a + 4 >> 2], ui = P + 744 | 0, t[ui >> 2] = t[a >> 2], t[ui + 4 >> 2] = n, t[P + 752 >> 2] = 0, n = t[P + 804 >> 2], t[P + 672 >> 2] = t[P + 800 >> 2], t[P + 676 >> 2] = n, n = t[P + 764 >> 2], t[P + 712 >> 2] = t[P + 760 >> 2], t[P + 716 >> 2] = n, w = d[w | 0], (w & 254) == 6 && (n = 0, (c[P + 760 | 0] & 1) == ((w | 0) != 7 | 0))))
          break t;
        w = t[P + 716 >> 2], Ti = w, Ce = t[P + 712 >> 2], n = Ce, w = w << 1 | n >>> 31, lr = P + 96 | 0, Me = t[K >> 2], Tt = t[K + 4 >> 2], di = n << 1, Qi = w, Pr(lr, Me, Tt, 0, 0, di, w, 0, 0), w = t[jr + 4 >> 2], Ii = w, wi = t[jr >> 2], a = wi, w = w << 1 | a >>> 31, tr = P + 160 | 0, nr = t[or >> 2], or = t[or + 4 >> 2], a = a << 1, b = w, Pr(tr, nr, or, 0, 0, a, w, 0, 0), jr = P + 288 | 0, n = t[ui >> 2], w = t[ui + 4 >> 2], Pr(jr, n, w, 0, 0, n, w, 0, 0), K = P + 272 | 0, Pr(K, t[P + 288 >> 2], t[P + 292 >> 2], 0, 0, 15632, 16, 0, 0), w = w << 1 | n >>> 31, Wi = P + 128 | 0, kr = n << 1, ui = w, Pr(Wi, kr, w, 0, 0, Ce, Ti, 0, 0), Xi = P + 144 | 0, Pr(Xi, Me, Tt, 0, 0, a, b, 0, 0), $i = P + 224 | 0, Pr($i, nr, or, 0, 0, nr, or, 0, 0), gr = P + 256 | 0, w = jr + 8 | 0, Pr(gr, t[w >> 2], t[w + 4 >> 2], 0, 0, 64028672, 65536, 0, 0), fs = P + 112 | 0, Pr(fs, Ce, Ti, 0, 0, Ce, Ti, 0, 0), Li = P + 192 | 0, Pr(Li, kr, ui, 0, 0, wi, Ii, 0, 0), Dn = P + 240 | 0, Pr(Dn, Me, Tt, 0, 0, nr << 1, or << 1 | nr >>> 31, 0, 0), Ti = t[P + 100 >> 2], w = Ti + t[P + 164 >> 2] | 0, pe = t[P + 96 >> 2], n = t[P + 160 >> 2], b = pe + n | 0, a = t[P + 272 >> 2], Mn = b + a | 0, n = n >>> 0 > b >>> 0 ? w + 1 | 0 : w, w = n + t[P + 276 >> 2] | 0, a = a >>> 0 > Mn >>> 0 ? w + 1 | 0 : w, Ce = (n | 0) == (a | 0) & b >>> 0 > Mn >>> 0 | n >>> 0 > a >>> 0, w = K + 8 | 0, jr = t[w >> 2], K = t[w + 4 >> 2], pe = (n | 0) == (Ti | 0) & b >>> 0 < pe >>> 0 | n >>> 0 < Ti >>> 0, b = tr + 8 | 0, n = t[b >> 2], w = lr + 8 | 0, tr = n + t[w >> 2] | 0, w = t[w + 4 >> 2] + t[b + 4 >> 2] | 0, w = n >>> 0 > tr >>> 0 ? w + 1 | 0 : w, n = pe + tr | 0, w = (n >>> 0 < tr >>> 0 ? w + 1 | 0 : w) + K | 0, b = n, n = n + jr | 0, w = b >>> 0 > n >>> 0 ? w + 1 | 0 : w, b = n, n = n + Ce | 0, w = b >>> 0 > n >>> 0 ? w + 1 | 0 : w, zn = a, jr = n << 12 | a >>> 20, b = w, pe = w << 12 | n >>> 20, ei = t[P + 144 >> 2], n = t[P + 224 >> 2], tr = ei + n | 0, Ki = t[P + 148 >> 2], w = Ki + t[P + 228 >> 2] | 0, w = n >>> 0 > tr >>> 0 ? w + 1 | 0 : w, n = t[P + 128 >> 2], Ce = n + tr | 0, lr = w, w = w + t[P + 132 >> 2] | 0, w = n >>> 0 > Ce >>> 0 ? w + 1 | 0 : w, n = t[P + 256 >> 2], K = n + Ce | 0, a = w, w = w + t[P + 260 >> 2] | 0, n = n >>> 0 > K >>> 0 ? w + 1 | 0 : w, w = n + pe | 0, ps = P + 32 | 0, Di = ps, jr = K + jr | 0, pe = jr >>> 0 < K >>> 0 ? w + 1 | 0 : w, Ei = (n | 0) == (pe | 0) & K >>> 0 > jr >>> 0 | n >>> 0 > pe >>> 0, ai = (n | 0) == (a | 0) & K >>> 0 < Ce >>> 0 | n >>> 0 < a >>> 0, w = gr + 8 | 0, Nr = t[w >> 2], Yr = t[w + 4 >> 2], Ti = (a | 0) == (lr | 0) & Ce >>> 0 < tr >>> 0 | a >>> 0 < lr >>> 0, w = Wi + 8 | 0, gr = t[w >> 2], Ce = t[w + 4 >> 2], K = (lr | 0) == (Ki | 0) & tr >>> 0 < ei >>> 0 | lr >>> 0 < Ki >>> 0, a = $i + 8 | 0, n = t[a >> 2], w = Xi + 8 | 0, tr = n + t[w >> 2] | 0, w = t[w + 4 >> 2] + t[a + 4 >> 2] | 0, w = n >>> 0 > tr >>> 0 ? w + 1 | 0 : w, n = K + tr | 0, w = (n >>> 0 < tr >>> 0 ? w + 1 | 0 : w) + Ce | 0, a = n, n = n + gr | 0, w = a >>> 0 > n >>> 0 ? w + 1 | 0 : w, a = n, n = n + Ti | 0, w = (a >>> 0 > n >>> 0 ? w + 1 | 0 : w) + Yr | 0, a = n, n = n + Nr | 0, w = a >>> 0 > n >>> 0 ? w + 1 | 0 : w, a = n + ai | 0, w = a >>> 0 < n >>> 0 ? w + 1 | 0 : w, b = b >>> 20 | 0, n = a + b | 0, w = b >>> 0 > n >>> 0 ? w + 1 | 0 : w, b = n, n = n + Ei | 0, w = b >>> 0 > n >>> 0 ? w + 1 | 0 : w, a = pe, K = n << 12 | a >>> 20, b = w, pe = w << 12 | n >>> 20, Nr = t[P + 192 >> 2], n = t[P + 240 >> 2], Ce = Nr + n | 0, ai = t[P + 196 >> 2], w = ai + t[P + 244 >> 2] | 0, n = n >>> 0 > Ce >>> 0 ? w + 1 | 0 : w, w = n + pe | 0, K = K + Ce | 0, w = K >>> 0 < Ce >>> 0 ? w + 1 | 0 : w, lr = K << 4 & -16, pe = w, tr = (w << 4 | K >>> 28) & 16777215, Ti = a, Pr(Di, lr | a >>> 16 & 15, tr, 0, 0, 977, 1, 0, 0), Es = P + 16 | 0, Pr(Es, wi, Ii, 0, 0, di, Qi, 0, 0), Yr = P + 208 | 0, Pr(Yr, kr, ui, 0, 0, nr, or, 0, 0), gr = P + 320 | 0, Pr(gr, Me, Tt, 0, 0, Me, Tt, 0, 0), Ss = P + 80 | 0, lr = Ss, tr = (n | 0) == (w | 0) & K >>> 0 < Ce >>> 0 | n >>> 0 > w >>> 0, K = (n | 0) == (ai | 0) & Ce >>> 0 < Nr >>> 0 | n >>> 0 < ai >>> 0, a = Dn + 8 | 0, n = t[a >> 2], w = Li + 8 | 0, Ce = n + t[w >> 2] | 0, w = t[w + 4 >> 2] + t[a + 4 >> 2] | 0, w = n >>> 0 > Ce >>> 0 ? w + 1 | 0 : w, a = K + Ce | 0, w = a >>> 0 < Ce >>> 0 ? w + 1 | 0 : w, b = b >>> 20 | 0, n = a + b | 0, w = b >>> 0 > n >>> 0 ? w + 1 | 0 : w, b = n, n = n + tr | 0, w = b >>> 0 > n >>> 0 ? w + 1 | 0 : w, pe = n << 12 | pe >>> 20, a = w, Ce = w << 12 | n >>> 20, Nr = t[P + 212 >> 2], w = Nr + t[P + 324 >> 2] | 0, tr = t[P + 208 >> 2], n = t[P + 320 >> 2], b = tr + n | 0, K = b, pe = b + pe | 0, n = n >>> 0 > b >>> 0 ? w + 1 | 0 : w, w = n + Ce | 0, b = b >>> 0 > pe >>> 0 ? w + 1 | 0 : w, Pr(lr, pe, b & 1048575, 0, 0, 15632, 16, 0, 0), Pr(P, nr, or, 0, 0, di, Qi, 0, 0), Ps = P + 176 | 0, Pr(Ps, wi, Ii, 0, 0, wi, Ii, 0, 0), Ce = P + 304 | 0, Pr(Ce, kr, ui, 0, 0, Me, Tt, 0, 0), xs = P - -64 | 0, Tt = xs, or = (n | 0) == (b | 0) & K >>> 0 > pe >>> 0 | n >>> 0 > b >>> 0, K = (n | 0) == (Nr | 0) & K >>> 0 < tr >>> 0 | n >>> 0 < Nr >>> 0, pe = gr + 8 | 0, n = t[pe >> 2], w = Yr + 8 | 0, Me = n + t[w >> 2] | 0, w = t[w + 4 >> 2] + t[pe + 4 >> 2] | 0, w = n >>> 0 > Me >>> 0 ? w + 1 | 0 : w, pe = K + Me | 0, w = pe >>> 0 < Me >>> 0 ? w + 1 | 0 : w, a = a >>> 20 | 0, n = a + pe | 0, w = a >>> 0 > n >>> 0 ? w + 1 | 0 : w, a = n, n = n + or | 0, w = a >>> 0 > n >>> 0 ? w + 1 | 0 : w, pe = n << 12 | b >>> 20, b = t[P + 304 >> 2], or = pe + b | 0, a = w, n = w << 12 | n >>> 20, w = n + t[P + 308 >> 2] | 0, w = b >>> 0 > or >>> 0 ? w + 1 | 0 : w, Pr(Tt, or, w, 0, 0, 15632, 16, 0, 0), Bs = P + 48 | 0, K = Bs, pe = (w | 0) == (n | 0) & pe >>> 0 > or >>> 0 | w >>> 0 < n >>> 0, w = Ce + 8 | 0, b = t[w >> 2], w = t[w + 4 >> 2], a = a >>> 20 | 0, n = a + b | 0, w = a >>> 0 > n >>> 0 ? w + 1 | 0 : w, b = n, n = n + pe | 0, w = b >>> 0 > n >>> 0 ? w + 1 | 0 : w, Pr(K, n, w, 0, 0, 64028672, 65536, 0, 0), w = t[P + 676 >> 2], nr = w, Tt = t[P + 672 >> 2], n = Tt, w = w << 1 | n >>> 31, Ce = P + 432 | 0, gr = t[P + 696 >> 2], lr = t[P + 700 >> 2], Ei = n << 1, Di = w, Pr(Ce, gr, lr, 0, 0, Ei, w, 0, 0), w = t[P + 684 >> 2], ns = w, es = t[P + 680 >> 2], a = es, w = w << 1 | a >>> 31, Me = P + 496 | 0, Nr = t[P + 688 >> 2], kr = t[P + 692 >> 2], a = a << 1, b = w, Pr(Me, Nr, kr, 0, 0, a, w, 0, 0), or = P + 624 | 0, n = t[P + 704 >> 2], w = t[P + 708 >> 2], Pr(or, n, w, 0, 0, n, w, 0, 0), K = P + 608 | 0, Pr(K, t[P + 624 >> 2], t[P + 628 >> 2], 0, 0, 15632, 16, 0, 0), w = w << 1 | n >>> 31, wi = P + 464 | 0, Dn = n << 1, ai = w, Pr(wi, Dn, w, 0, 0, Tt, nr, 0, 0), Ki = P + 480 | 0, Pr(Ki, gr, lr, 0, 0, a, b, 0, 0), Wi = P + 560 | 0, Pr(Wi, Nr, kr, 0, 0, Nr, kr, 0, 0), tr = P + 592 | 0, w = or + 8 | 0, Pr(tr, t[w >> 2], t[w + 4 >> 2], 0, 0, 64028672, 65536, 0, 0), vs = P + 448 | 0, Pr(vs, Tt, nr, 0, 0, Tt, nr, 0, 0), In = P + 528 | 0, Pr(In, Dn, ai, 0, 0, es, ns, 0, 0), kn = P + 576 | 0, Pr(kn, gr, lr, 0, 0, Nr << 1, kr << 1 | Nr >>> 31, 0, 0), nr = t[P + 436 >> 2], w = nr + t[P + 500 >> 2] | 0, pe = t[P + 432 >> 2], n = t[P + 496 >> 2], a = pe + n | 0, b = t[P + 608 >> 2], Qi = a + b | 0, n = n >>> 0 > a >>> 0 ? w + 1 | 0 : w, w = n + t[P + 612 >> 2] | 0, b = b >>> 0 > Qi >>> 0 ? w + 1 | 0 : w, Tt = (n | 0) == (b | 0) & a >>> 0 > Qi >>> 0 | n >>> 0 > b >>> 0, w = K + 8 | 0, or = t[w >> 2], K = t[w + 4 >> 2], pe = (n | 0) == (nr | 0) & a >>> 0 < pe >>> 0 | n >>> 0 < nr >>> 0, a = Me + 8 | 0, n = t[a >> 2], w = Ce + 8 | 0, Me = n + t[w >> 2] | 0, w = t[w + 4 >> 2] + t[a + 4 >> 2] | 0, w = n >>> 0 > Me >>> 0 ? w + 1 | 0 : w, n = pe + Me | 0, w = (n >>> 0 < Me >>> 0 ? w + 1 | 0 : w) + K | 0, a = n, n = n + or | 0, w = a >>> 0 > n >>> 0 ? w + 1 | 0 : w, a = n, n = n + Tt | 0, w = a >>> 0 > n >>> 0 ? w + 1 | 0 : w, di = b, or = n << 12 | b >>> 20, a = w, pe = w << 12 | n >>> 20, Xi = t[P + 480 >> 2], n = t[P + 560 >> 2], Tt = Xi + n | 0, Ii = t[P + 484 >> 2], w = Ii + t[P + 564 >> 2] | 0, w = n >>> 0 > Tt >>> 0 ? w + 1 | 0 : w, n = t[P + 464 >> 2], K = n + Tt | 0, Ce = w, w = w + t[P + 468 >> 2] | 0, w = n >>> 0 > K >>> 0 ? w + 1 | 0 : w, n = t[P + 592 >> 2], b = n + K | 0, Me = w, w = w + t[P + 596 >> 2] | 0, n = n >>> 0 > b >>> 0 ? w + 1 | 0 : w, w = n + pe | 0, $i = P + 368 | 0, or = b + or | 0, pe = or >>> 0 < b >>> 0 ? w + 1 | 0 : w, Li = (n | 0) == (pe | 0) & b >>> 0 > or >>> 0 | n >>> 0 > pe >>> 0, ei = (n | 0) == (Me | 0) & b >>> 0 < K >>> 0 | n >>> 0 < Me >>> 0, w = tr + 8 | 0, Yr = t[w >> 2], ui = t[w + 4 >> 2], nr = (Ce | 0) == (Me | 0) & K >>> 0 < Tt >>> 0 | Ce >>> 0 > Me >>> 0, w = wi + 8 | 0, tr = t[w >> 2], Me = t[w + 4 >> 2], K = (Ce | 0) == (Ii | 0) & Tt >>> 0 < Xi >>> 0 | Ce >>> 0 < Ii >>> 0, b = Wi + 8 | 0, n = t[b >> 2], w = Ki + 8 | 0, Tt = n + t[w >> 2] | 0, w = t[w + 4 >> 2] + t[b + 4 >> 2] | 0, w = n >>> 0 > Tt >>> 0 ? w + 1 | 0 : w, n = K + Tt | 0, w = (n >>> 0 < Tt >>> 0 ? w + 1 | 0 : w) + Me | 0, b = n, n = n + tr | 0, w = b >>> 0 > n >>> 0 ? w + 1 | 0 : w, b = n, n = n + nr | 0, w = (b >>> 0 > n >>> 0 ? w + 1 | 0 : w) + ui | 0, b = n, n = n + Yr | 0, w = b >>> 0 > n >>> 0 ? w + 1 | 0 : w, b = n + ei | 0, w = b >>> 0 < n >>> 0 ? w + 1 | 0 : w, a = a >>> 20 | 0, n = a + b | 0, w = a >>> 0 > n >>> 0 ? w + 1 | 0 : w, b = n, n = n + Li | 0, w = b >>> 0 > n >>> 0 ? w + 1 | 0 : w, a = pe, K = n << 12 | a >>> 20, b = w, Tt = w << 12 | n >>> 20, ei = t[P + 532 >> 2], w = ei + t[P + 580 >> 2] | 0, nr = t[P + 528 >> 2], n = t[P + 576 >> 2], pe = nr + n | 0, Ce = pe, K = pe + K | 0, n = n >>> 0 > pe >>> 0 ? w + 1 | 0 : w, w = n + Tt | 0, Me = K << 4 & -16, pe = K >>> 0 < pe >>> 0 ? w + 1 | 0 : w, Tt = (pe << 4 | K >>> 28) & 16777215, ui = a, Pr($i, Me | a >>> 16 & 15, Tt, 0, 0, 977, 1, 0, 0), Tt = t[P + 372 >> 2], w = Tt + t[P + 452 >> 2] | 0, Li = t[P + 368 >> 2], a = t[P + 448 >> 2], Me = Li + a | 0, t[P + 840 >> 2] = Me, a = a >>> 0 > Me >>> 0 ? w + 1 | 0 : w, t[P + 844 >> 2] = a & 1048575, Ii = P + 352 | 0, Pr(Ii, es, ns, 0, 0, Ei, Di, 0, 0), wi = P + 544 | 0, Pr(wi, Dn, ai, 0, 0, Nr, kr, 0, 0), Ki = P + 656 | 0, Pr(Ki, gr, lr, 0, 0, gr, lr, 0, 0), Wi = P + 416 | 0, Yr = Wi, tr = (n | 0) == (pe | 0) & K >>> 0 < Ce >>> 0 | n >>> 0 > pe >>> 0, Ce = (n | 0) == (ei | 0) & Ce >>> 0 < nr >>> 0 | n >>> 0 < ei >>> 0, K = kn + 8 | 0, n = t[K >> 2], w = In + 8 | 0, nr = n + t[w >> 2] | 0, w = t[w + 4 >> 2] + t[K + 4 >> 2] | 0, w = n >>> 0 > nr >>> 0 ? w + 1 | 0 : w, K = Ce + nr | 0, w = K >>> 0 < nr >>> 0 ? w + 1 | 0 : w, b = b >>> 20 | 0, n = b + K | 0, w = b >>> 0 > n >>> 0 ? w + 1 | 0 : w, b = n, n = n + tr | 0, w = b >>> 0 > n >>> 0 ? w + 1 | 0 : w, Ce = n << 12 | pe >>> 20, K = w, pe = w << 12 | n >>> 20, In = t[P + 548 >> 2], w = In + t[P + 660 >> 2] | 0, Xi = t[P + 544 >> 2], b = t[P + 656 >> 2], n = Xi + b | 0, ei = n, nr = n + Ce | 0, b = n >>> 0 < b >>> 0 ? w + 1 | 0 : w, w = b + pe | 0, Ce = nr >>> 0 < n >>> 0 ? w + 1 | 0 : w, Pr(Yr, nr, Ce & 1048575, 0, 0, 15632, 16, 0, 0), Me = (a | 0) == (Tt | 0) & Me >>> 0 < Li >>> 0 | a >>> 0 < Tt >>> 0, pe = vs + 8 | 0, n = t[pe >> 2], w = $i + 8 | 0, tr = n + t[w >> 2] | 0, w = t[w + 4 >> 2] + t[pe + 4 >> 2] | 0, w = n >>> 0 > tr >>> 0 ? w + 1 | 0 : w, n = Me + tr | 0, w = n >>> 0 < tr >>> 0 ? w + 1 | 0 : w, tr = n << 12 | a >>> 20, pe = w, Me = w << 12 | n >>> 20, $i = t[P + 416 >> 2], n = t[P + 352 >> 2], Yr = $i + n | 0, kn = t[P + 420 >> 2], w = kn + t[P + 356 >> 2] | 0, a = n >>> 0 > Yr >>> 0 ? w + 1 | 0 : w, w = a + Me | 0, tr = tr + Yr | 0, w = tr >>> 0 < Yr >>> 0 ? w + 1 | 0 : w, t[P + 848 >> 2] = tr, Me = w, t[P + 852 >> 2] = w & 1048575, Li = P + 336 | 0, Pr(Li, Nr, kr, 0, 0, Ei, Di, 0, 0), Di = P + 512 | 0, Pr(Di, es, ns, 0, 0, es, ns, 0, 0), Ei = P + 640 | 0, Pr(Ei, Dn, ai, 0, 0, gr, lr, 0, 0), Nr = P + 400 | 0, gr = Nr, kr = (b | 0) == (Ce | 0) & nr >>> 0 < ei >>> 0 | b >>> 0 > Ce >>> 0, nr = (b | 0) == (In | 0) & ei >>> 0 < Xi >>> 0 | b >>> 0 < In >>> 0, b = Ki + 8 | 0, n = t[b >> 2], w = wi + 8 | 0, lr = n + t[w >> 2] | 0, w = t[w + 4 >> 2] + t[b + 4 >> 2] | 0, w = n >>> 0 > lr >>> 0 ? w + 1 | 0 : w, b = nr + lr | 0, w = b >>> 0 < lr >>> 0 ? w + 1 | 0 : w, K = K >>> 20 | 0, n = b + K | 0, w = K >>> 0 > n >>> 0 ? w + 1 | 0 : w, b = n, n = n + kr | 0, w = b >>> 0 > n >>> 0 ? w + 1 | 0 : w, lr = n << 12 | Ce >>> 20, K = t[P + 640 >> 2], Ce = lr + K | 0, b = w, ei = w << 12 | n >>> 20, w = ei + t[P + 644 >> 2] | 0, nr = K >>> 0 > Ce >>> 0 ? w + 1 | 0 : w, Pr(gr, Ce, nr, 0, 0, 15632, 16, 0, 0), tr = (a | 0) == (Me | 0) & tr >>> 0 < Yr >>> 0 | a >>> 0 > Me >>> 0, Tt = (a | 0) == (kn | 0) & Yr >>> 0 < $i >>> 0 | a >>> 0 < kn >>> 0, a = Ii + 8 | 0, n = t[a >> 2], w = Wi + 8 | 0, kr = n + t[w >> 2] | 0, w = t[w + 4 >> 2] + t[a + 4 >> 2] | 0, w = n >>> 0 > kr >>> 0 ? w + 1 | 0 : w, a = Tt + kr | 0, w = a >>> 0 < kr >>> 0 ? w + 1 | 0 : w, pe = pe >>> 20 | 0, n = a + pe | 0, w = pe >>> 0 > n >>> 0 ? w + 1 | 0 : w, a = n, n = n + tr | 0, w = a >>> 0 > n >>> 0 ? w + 1 | 0 : w, Tt = n << 12 | Me >>> 20, a = w, pe = w << 12 | n >>> 20, Yr = t[P + 336 >> 2], n = t[P + 512 >> 2], tr = Yr + n | 0, ai = t[P + 340 >> 2], w = ai + t[P + 516 >> 2] | 0, w = n >>> 0 > tr >>> 0 ? w + 1 | 0 : w, n = t[P + 400 >> 2], Me = n + tr | 0, kr = w, w = w + t[P + 404 >> 2] | 0, n = n >>> 0 > Me >>> 0 ? w + 1 | 0 : w, w = n + pe | 0, Tt = Tt + Me | 0, w = Tt >>> 0 < Me >>> 0 ? w + 1 | 0 : w, t[P + 856 >> 2] = Tt, pe = w, t[P + 860 >> 2] = w & 1048575, gr = P + 384 | 0, lr = (nr | 0) == (ei | 0) & Ce >>> 0 < lr >>> 0 | nr >>> 0 < ei >>> 0, w = Ei + 8 | 0, nr = t[w >> 2], w = t[w + 4 >> 2], b = b >>> 20 | 0, K = b, b = b + nr | 0, w = K >>> 0 > b >>> 0 ? w + 1 | 0 : w, K = b, b = b + lr | 0, w = K >>> 0 > b >>> 0 ? w + 1 | 0 : w, Pr(gr, b, w, 0, 0, 64028672, 65536, 0, 0), lr = (n | 0) == (pe | 0) & Tt >>> 0 < Me >>> 0 | n >>> 0 > pe >>> 0, nr = (n | 0) == (kr | 0) & Me >>> 0 < tr >>> 0 | n >>> 0 < kr >>> 0, w = Nr + 8 | 0, Ce = t[w >> 2], Me = t[w + 4 >> 2], Tt = (kr | 0) == (ai | 0) & tr >>> 0 < Yr >>> 0 | kr >>> 0 < ai >>> 0, K = Di + 8 | 0, n = t[K >> 2], w = Li + 8 | 0, tr = n + t[w >> 2] | 0, w = t[w + 4 >> 2] + t[K + 4 >> 2] | 0, w = n >>> 0 > tr >>> 0 ? w + 1 | 0 : w, n = Tt + tr | 0, w = (n >>> 0 < tr >>> 0 ? w + 1 | 0 : w) + Me | 0, b = n, n = n + Ce | 0, w = b >>> 0 > n >>> 0 ? w + 1 | 0 : w, K = n + nr | 0, w = K >>> 0 < n >>> 0 ? w + 1 | 0 : w, a = a >>> 20 | 0, n = a + K | 0, w = a >>> 0 > n >>> 0 ? w + 1 | 0 : w, b = n, n = n + lr | 0, w = b >>> 0 > n >>> 0 ? w + 1 | 0 : w, K = n << 12 | pe >>> 20, a = w, Me = w << 12 | n >>> 20, tr = t[P + 384 >> 2], pe = Qi & -2, n = tr + pe | 0, nr = t[P + 388 >> 2], w = nr + (di & 1048575) | 0, Tt = n >>> 0 < pe >>> 0 ? w + 1 | 0 : w, w = Tt + Me | 0, b = K, K = n, pe = b + n | 0, t[P + 864 >> 2] = pe, n = n >>> 0 > pe >>> 0 ? w + 1 | 0 : w, t[P + 868 >> 2] = n & 1048575, Ce = ui & 65535, Me = (n | 0) == (Tt | 0) & K >>> 0 > pe >>> 0 | n >>> 0 < Tt >>> 0, b = (Tt | 0) == (nr | 0) & K >>> 0 < tr >>> 0 | Tt >>> 0 < nr >>> 0, w = gr + 8 | 0, pe = b + t[w >> 2] | 0, w = t[w + 4 >> 2], w = b >>> 0 > pe >>> 0 ? w + 1 | 0 : w, a = a >>> 20 | 0, b = a, a = a + pe | 0, w = b >>> 0 > a >>> 0 ? w + 1 | 0 : w, b = a, a = a + Me | 0, w = b >>> 0 > a >>> 0 ? w + 1 | 0 : w, n = a << 12 | n >>> 20, b = n + or | 0, w = Ce + (w << 12 | a >>> 20) | 0, t[P + 872 >> 2] = b, t[P + 876 >> 2] = n >>> 0 > b >>> 0 ? w + 1 | 0 : w, w = fs + 8 | 0, K = t[w >> 2], pe = t[w + 4 >> 2], w = ps + 8 | 0, Ki = t[w >> 2], a = t[w + 4 >> 2], b = t[P + 112 >> 2], n = t[P + 116 >> 2], nr = t[P + 32 >> 2], In = t[P + 36 >> 2], w = Es + 8 | 0, Yr = t[w >> 2], gr = t[w + 4 >> 2], w = Ss + 8 | 0, Wi = t[w >> 2], di = t[w + 4 >> 2], Nr = t[P + 16 >> 2], tr = t[P + 20 >> 2], Xi = t[P + 80 >> 2], kn = t[P + 84 >> 2], w = Ps + 8 | 0, lr = t[w >> 2], kr = t[w + 4 >> 2], w = P + 8 | 0, $i = t[w >> 2], Qi = t[w + 4 >> 2], ei = t[P + 176 >> 2], Ce = t[P + 180 >> 2], Di = t[P >> 2], Ii = t[P + 4 >> 2], w = xs + 8 | 0, Tt = t[w >> 2], or = t[w + 4 >> 2], Ei = t[P + 64 >> 2], Me = t[P + 68 >> 2], Li = t[P + 48 >> 2], wi = t[P + 52 >> 2], w = Bs + 8 | 0, Dn = t[w >> 2], ui = t[w + 4 >> 2], w = P + 840 | 0, zr(w, w, P + 672 | 0), w = n + In | 0, n = b + nr | 0, b = n >>> 0 < b >>> 0 ? w + 1 | 0 : w, ai = n, n = (In | 0) == (b | 0) & n >>> 0 < nr >>> 0 | b >>> 0 < In >>> 0, w = a + pe | 0, a = K + Ki | 0, w = a >>> 0 < Ki >>> 0 ? w + 1 | 0 : w, n = n + a | 0, w = n >>> 0 < a >>> 0 ? w + 1 | 0 : w, nr = b, K = n << 12 | b >>> 20, a = w, pe = w << 12 | n >>> 20, w = tr + kn | 0, b = Nr + Xi | 0, n = b >>> 0 < Nr >>> 0 ? w + 1 | 0 : w, w = n + pe | 0, Nr = b + K | 0, pe = Nr >>> 0 < b >>> 0 ? w + 1 | 0 : w, K = (n | 0) == (pe | 0) & b >>> 0 > Nr >>> 0 | n >>> 0 > pe >>> 0, n = (n | 0) == (kn | 0) & b >>> 0 < Xi >>> 0 | n >>> 0 < kn >>> 0, w = gr + di | 0, b = Yr + Wi | 0, w = b >>> 0 < Wi >>> 0 ? w + 1 | 0 : w, Yr = b, b = n + b | 0, w = Yr >>> 0 > b >>> 0 ? w + 1 | 0 : w, a = a >>> 20 | 0, n = a + b | 0, w = a >>> 0 > n >>> 0 ? w + 1 | 0 : w, b = n, n = n + K | 0, w = b >>> 0 > n >>> 0 ? w + 1 | 0 : w, tr = pe, di = n << 12 | pe >>> 20, b = w, K = w << 12 | n >>> 20, w = Ce + Ii | 0, n = ei + Di | 0, a = n >>> 0 < ei >>> 0 ? w + 1 | 0 : w, w = Me + a | 0, Me = n, pe = n + Ei | 0, n = pe >>> 0 < Ei >>> 0 ? w + 1 | 0 : w, w = n + K | 0, Ce = pe, K = pe + di | 0, pe = pe >>> 0 > K >>> 0 ? w + 1 | 0 : w, Yr = K, di = (n | 0) == (pe | 0) & K >>> 0 < Ce >>> 0 | n >>> 0 > pe >>> 0, w = a, Ce = (w | 0) == (n | 0) & Ce >>> 0 < Me >>> 0 | w >>> 0 > n >>> 0, a = Tt, n = or, K = (w | 0) == (Ii | 0) & Me >>> 0 < Di >>> 0 | w >>> 0 < Ii >>> 0, w = kr + Qi | 0, or = lr + $i | 0, w = or >>> 0 < $i >>> 0 ? w + 1 | 0 : w, K = K + or | 0, w = (K >>> 0 < or >>> 0 ? w + 1 | 0 : w) + n | 0, n = a + K | 0, w = n >>> 0 < K >>> 0 ? w + 1 | 0 : w, a = n + Ce | 0, w = a >>> 0 < n >>> 0 ? w + 1 | 0 : w, b = b >>> 20 | 0, n = a + b | 0, w = b >>> 0 > n >>> 0 ? w + 1 | 0 : w, b = n, n = n + di | 0, w = b >>> 0 > n >>> 0 ? w + 1 | 0 : w, Ce = pe, pe = n << 12 | pe >>> 20, a = w, b = w << 12 | n >>> 20, n = Mn & -2, gr = n + Li | 0, w = wi + (zn & 1048575) | 0, n = n >>> 0 > gr >>> 0 ? w + 1 | 0 : w, w = n + b | 0, b = pe + gr | 0, w = b >>> 0 < gr >>> 0 ? w + 1 | 0 : w, zn = b, pe = w, ei = t[P + 864 >> 2], Di = t[P + 868 >> 2], Ei = t[P + 856 >> 2], Qi = t[P + 860 >> 2], di = t[P + 848 >> 2], Me = t[P + 852 >> 2], K = t[P + 844 >> 2], or = t[P + 872 >> 2], b = t[P + 876 >> 2], Mn = b, w = t[P + 840 >> 2], b = ri(b >>> 16 | 0, 0, 977, 1), Tt = w + b | 0, w = K + ve | 0, w = b >>> 0 > Tt >>> 0 ? w + 1 | 0 : w, b = Tt + 7 | 0, w = b >>> 0 < 7 ? w + 1 | 0 : w, lr = b, K = w, w = Me, b = K >>> 20 | 0, Me = b, b = b + di | 0, w = Me >>> 0 > b >>> 0 ? w + 1 | 0 : w, kr = b, Me = w, w = Qi, b = Me >>> 20 | 0, Tt = b, b = b + Ei | 0, w = Tt >>> 0 > b >>> 0 ? w + 1 | 0 : w, Qi = b, Tt = w, w = Di, b = Tt >>> 20 | 0, Di = b, b = b + ei | 0, w = Di >>> 0 > b >>> 0 ? w + 1 | 0 : w, di = b, b = w, Ei = lr - ai | 0, ai = (K & 1048575) - ((nr & 1048575) + (lr >>> 0 < ai >>> 0) | 0) | 0, Mn = Mn & 65535, lr = Ti & 65535, nr = (n | 0) == (pe | 0) & gr >>> 0 > zn >>> 0 | n >>> 0 > pe >>> 0, n = (n | 0) == (wi | 0) & gr >>> 0 < Li >>> 0 | n >>> 0 < wi >>> 0, K = n + Dn | 0, w = ui, w = n >>> 0 > K >>> 0 ? w + 1 | 0 : w, a = a >>> 20 | 0, n = a + K | 0, w = a >>> 0 > n >>> 0 ? w + 1 | 0 : w, a = n, n = n + nr | 0, w = a >>> 0 > n >>> 0 ? w + 1 | 0 : w, a = n << 12 | pe >>> 20, K = a + jr | 0, w = lr + (w << 12 | n >>> 20) | 0, w = a >>> 0 > K >>> 0 ? w + 1 | 0 : w, a = or - K | 0, w = Mn - ((K >>> 0 > or >>> 0) + w | 0) | 0, K = b >>> 20 | 0, n = a + K | 0, w = (K >>> 0 > n >>> 0 ? w + 1 | 0 : w) + 262143 | 0, n = n - 4 | 0, or = n >>> 0 < 4294967292 ? w + 1 | 0 : w, a = ri(or >>> 16 | 0, 0, 977, 1), K = a + Ei | 0, w = ai + ve | 0, w = (a >>> 0 > K >>> 0 ? w + 1 | 0 : w) + 4194299 | 0, a = K - 3908 | 0, w = a >>> 0 < 4294963388 ? w + 1 | 0 : w, Ti = a ^ 976, K = w & 1048575, gr = K ^ 1, ((Ti | 0) != -1 | (gr | 0) != 1048575) & (a | K) != 0 ? n = 0 : (lr = di - zn | 0, ui = (b & 1048575) - ((pe & 1048575) + (di >>> 0 < zn >>> 0) | 0) | 0, nr = Qi - Yr | 0, jr = (Tt & 1048575) - ((Ce & 1048575) + (Yr >>> 0 > Qi >>> 0) | 0) | 0, a = w, w = (Me & 1048575) - ((tr & 1048575) + (kr >>> 0 < Nr >>> 0) | 0) | 0, a = a >>> 20 | 0, b = a, a = a + (kr - Nr | 0) | 0, w = (b >>> 0 > a >>> 0 ? w + 1 | 0 : w) + 4194303 | 0, K = a - 4 | 0, pe = K >>> 0 < 4294967292 ? w + 1 | 0 : w, w = jr, a = pe >>> 20 | 0, b = a, a = a + nr | 0, w = (b >>> 0 > a >>> 0 ? w + 1 | 0 : w) + 4194303 | 0, b = a - 4 | 0, a = b >>> 0 < 4294967292 ? w + 1 | 0 : w, w = ui, jr = a >>> 20 | 0, Ce = jr, jr = lr + jr | 0, w = (Ce >>> 0 > jr >>> 0 ? w + 1 | 0 : w) + 4194303 | 0, jr = jr - 4 | 0, w = jr >>> 0 < 4294967292 ? w + 1 | 0 : w, K = jr & (K & Ti & b), pe = w & (pe & gr & a), a = n, n = w, w = or & 65535, n = n >>> 20 | 0, b = n, n = n + a | 0, w = b >>> 0 > n >>> 0 ? w + 1 | 0 : w, n = (n & K) == -1 & (pe & (w ^ 983040)) == 1048575);
      }
      if (!n)
        break e;
      ti(l, P + 672 | 0), C = 1;
    }
    return U = P + 880 | 0, C;
  }
  function $r(C, l) {
    var w = 0, n = 0, a = 0, b = 0, P = 0, K = 0, pe = 0, Ce = 0, Me = 0, Tt = 0, tr = 0, nr = 0;
    return a = C, w = d[l + 30 | 0], C = w >>> 24 | 0, n = d[l + 31 | 0] | w << 8, w = C, b = d[l + 29 | 0], C = b >>> 16 | 0, b = b << 16 | n, n = C | w, w = d[l + 28 | 0], C = w >>> 8 | 0, w = w << 24 | b, C = d[l + 27 | 0] | (C | n) | d[l + 26 | 0] << 8 | (d[l + 25 | 0] & 15) << 16, b = C, nr = w, t[a >> 2] = w, t[a + 4 >> 2] = C, w = d[l + 24 | 0], C = w >>> 28 | 0, P = w << 4 | d[l + 25 | 0] >>> 4, w = C, n = d[l + 23 | 0], C = n >>> 20 | 0, n = n << 12 | P, P = C | w, w = d[l + 22 | 0], C = w >>> 12 | 0, n = w << 20 | n, P = C | P, w = d[l + 21 | 0], C = w >>> 4 | 0, w = w << 28 | n, n = C | P | d[l + 20 | 0] << 4, C = d[l + 19 | 0] << 12, P = w, t[a + 8 >> 2] = w, Me = C | n, t[a + 12 >> 2] = Me, w = d[l + 17 | 0], C = w >>> 24 | 0, pe = d[l + 18 | 0] | w << 8, w = C, n = d[l + 16 | 0], C = n >>> 16 | 0, n = n << 16 | pe, pe = C | w, w = d[l + 15 | 0], C = w >>> 8 | 0, w = w << 24 | n, n = d[l + 14 | 0] | (C | pe) | d[l + 13 | 0] << 8, C = (d[l + 12 | 0] & 15) << 16, pe = w, t[a + 16 >> 2] = w, Tt = C | n, t[a + 20 >> 2] = Tt, w = d[l + 11 | 0], C = w >>> 28 | 0, K = w << 4 | d[l + 12 | 0] >>> 4, w = C, n = d[l + 10 | 0], C = n >>> 20 | 0, n = n << 12 | K, K = C | w, w = d[l + 9 | 0], C = w >>> 12 | 0, n = w << 20 | n, K = C | K, w = d[l + 8 | 0], C = w >>> 4 | 0, w = w << 28 | n, n = C | K | d[l + 7 | 0] << 4, C = d[l + 6 | 0] << 12, K = w, t[a + 24 >> 2] = w, tr = C | n, t[a + 28 >> 2] = tr, w = d[l + 4 | 0], C = w >>> 24 | 0, Ce = d[l + 5 | 0] | w << 8, w = C, n = d[l + 3 | 0], C = n >>> 16 | 0, n = n << 16 | Ce, Ce = C | w, w = d[l + 2 | 0], C = w >>> 8 | 0, w = w << 24 | n, n = d[l + 1 | 0] | (C | Ce), C = d[l | 0] << 8, t[a + 32 >> 2] = w, C = C | n, t[a + 36 >> 2] = C, (P & pe & K) != -1 | (Me & Tt & tr) != 1048575 | ((w | 0) != -1 | (C | 0) != 65535) | ((b | 0) == 1048574 & nr >>> 0 < 4294966319 | b >>> 0 < 1048574);
  }
  function oi(C, l, w) {
    var n = 0, a = 0, b = 0, P = 0, K = 0, pe = 0, Ce = 0, Me = 0, Tt = 0, tr = 0, nr = 0, or = 0, lr = 0, gr = 0, kr = 0, Nr = 0, jr = 0, Yr = 0, ei = 0, ai = 0, ui = 0, di = 0, Ii = 0, wi = 0, Ei = 0, Ti = 0, Di = 0, Qi = 0, Li = 0, Ki = 0, Wi = 0, Xi = 0, $i = 0, In = 0, kn = 0, Dn = 0, Mn = 0, zn = 0, es = 0, ns = 0, fs = 0, ps = 0;
    for (P = U - 7616 | 0, U = P, b = l + 32 | 0, a = t[b + 4 >> 2], n = C + 32 | 0, t[n >> 2] = t[b >> 2], t[n + 4 >> 2] = a, b = l + 24 | 0, a = t[b + 4 >> 2], n = C + 24 | 0, t[n >> 2] = t[b >> 2], t[n + 4 >> 2] = a, b = l + 16 | 0, a = t[b + 4 >> 2], n = C + 16 | 0, t[n >> 2] = t[b >> 2], t[n + 4 >> 2] = a, b = l + 8 | 0, a = t[b + 4 >> 2], n = C + 8 | 0, t[n >> 2] = t[b >> 2], t[n + 4 >> 2] = a, n = t[l + 4 >> 2], t[C >> 2] = t[l >> 2], t[C + 4 >> 2] = n, n = P + 7096 | 0, Wn(n, l), es = P + 7056 | 0, zr(es, l, n), t[C + 80 >> 2] = 0, n = t[P + 7060 >> 2], a = t[P + 7056 >> 2] + 7 | 0, l = a >>> 0 < 7 ? n + 1 | 0 : n, n = a, t[P + 7056 >> 2] = n, t[P + 7060 >> 2] = l, nr = P + 6848 | 0, ei = t[P + 7080 >> 2], kr = t[P + 7084 >> 2], Ti = n << 1, K = n, ai = l << 1 | n >>> 31, Pr(nr, ei, kr, 0, 0, Ti, ai, 0, 0), n = t[P + 7068 >> 2], zn = n, Wi = t[P + 7064 >> 2], b = Wi, n = n << 1 | b >>> 31, tr = P + 6880 | 0, di = t[P + 7072 >> 2], Nr = t[P + 7076 >> 2], b = b << 1, pe = n, Pr(tr, di, Nr, 0, 0, b, n, 0, 0), Ce = P + 7008 | 0, a = t[P + 7088 >> 2], n = t[P + 7092 >> 2], Pr(Ce, a, n, 0, 0, a, n, 0, 0), Me = P + 6992 | 0, Pr(Me, t[P + 7008 >> 2], t[P + 7012 >> 2], 0, 0, 15632, 16, 0, 0), n = n << 1 | a >>> 31, Li = P + 6800 | 0, ui = a << 1, Yr = n, Pr(Li, ui, n, 0, 0, K, l, 0, 0), kn = P + 6864 | 0, Pr(kn, ei, kr, 0, 0, b, pe, 0, 0), Qi = P + 6944 | 0, Pr(Qi, di, Nr, 0, 0, di, Nr, 0, 0), or = P + 6976 | 0, n = Ce + 8 | 0, Pr(or, t[n >> 2], t[n + 4 >> 2], 0, 0, 64028672, 65536, 0, 0), Mn = P + 6720 | 0, Pr(Mn, K, l, 0, 0, K, l, 0, 0), Dn = P + 6912 | 0, Pr(Dn, ui, Yr, 0, 0, Wi, zn, 0, 0), $i = P + 6960 | 0, Pr($i, ei, kr, 0, 0, di << 1, Nr << 1 | di >>> 31, 0, 0), gr = t[P + 6852 >> 2], n = gr + t[P + 6884 >> 2] | 0, pe = t[P + 6848 >> 2], a = t[P + 6880 >> 2], l = pe + a | 0, b = t[P + 6992 >> 2], lr = l + b | 0, a = l >>> 0 < a >>> 0 ? n + 1 | 0 : n, n = a + t[P + 6996 >> 2] | 0, b = b >>> 0 > lr >>> 0 ? n + 1 | 0 : n, Ce = (a | 0) == (b | 0) & l >>> 0 > lr >>> 0 | a >>> 0 > b >>> 0, n = Me + 8 | 0, Tt = t[n >> 2], K = t[n + 4 >> 2], pe = (a | 0) == (gr | 0) & l >>> 0 < pe >>> 0 | a >>> 0 < gr >>> 0, n = tr + 8 | 0, a = t[n >> 2], l = nr + 8 | 0, Me = a + t[l >> 2] | 0, n = t[l + 4 >> 2] + t[n + 4 >> 2] | 0, n = a >>> 0 > Me >>> 0 ? n + 1 | 0 : n, l = pe + Me | 0, n = (l >>> 0 < Me >>> 0 ? n + 1 | 0 : n) + K | 0, a = l, l = l + Tt | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = l, l = l + Ce | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, gr = b, Tt = l << 12 | b >>> 20, a = n, pe = n << 12 | l >>> 20, Ki = t[P + 6864 >> 2], l = t[P + 6944 >> 2], Ce = Ki + l | 0, Xi = t[P + 6868 >> 2], n = Xi + t[P + 6948 >> 2] | 0, n = l >>> 0 > Ce >>> 0 ? n + 1 | 0 : n, l = t[P + 6800 >> 2], K = l + Ce | 0, tr = n, n = n + t[P + 6804 >> 2] | 0, n = l >>> 0 > K >>> 0 ? n + 1 | 0 : n, l = t[P + 6976 >> 2], b = l + K | 0, Me = n, n = n + t[P + 6980 >> 2] | 0, l = l >>> 0 > b >>> 0 ? n + 1 | 0 : n, n = l + pe | 0, In = P + 6736 | 0, Di = In, Tt = b + Tt | 0, pe = Tt >>> 0 < b >>> 0 ? n + 1 | 0 : n, Ei = (l | 0) == (pe | 0) & b >>> 0 > Tt >>> 0 | l >>> 0 > pe >>> 0, Ii = (l | 0) == (Me | 0) & b >>> 0 < K >>> 0 | l >>> 0 < Me >>> 0, l = or + 8 | 0, jr = t[l >> 2], wi = t[l + 4 >> 2], nr = (Me | 0) == (tr | 0) & K >>> 0 < Ce >>> 0 | Me >>> 0 < tr >>> 0, l = Li + 8 | 0, or = t[l >> 2], Me = t[l + 4 >> 2], K = (tr | 0) == (Xi | 0) & Ce >>> 0 < Ki >>> 0 | tr >>> 0 < Xi >>> 0, n = Qi + 8 | 0, b = t[n >> 2], l = kn + 8 | 0, Ce = b + t[l >> 2] | 0, n = t[l + 4 >> 2] + t[n + 4 >> 2] | 0, n = b >>> 0 > Ce >>> 0 ? n + 1 | 0 : n, l = K + Ce | 0, n = (l >>> 0 < Ce >>> 0 ? n + 1 | 0 : n) + Me | 0, b = l, l = l + or | 0, n = b >>> 0 > l >>> 0 ? n + 1 | 0 : n, b = l, l = l + nr | 0, n = (b >>> 0 > l >>> 0 ? n + 1 | 0 : n) + wi | 0, b = l, l = l + jr | 0, n = b >>> 0 > l >>> 0 ? n + 1 | 0 : n, b = l + Ii | 0, n = b >>> 0 < l >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, l = a + b | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = l, l = l + Ei | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = pe, K = l << 12 | a >>> 20, b = n, pe = n << 12 | l >>> 20, or = t[P + 6912 >> 2], l = t[P + 6960 >> 2], Me = or + l | 0, jr = t[P + 6916 >> 2], n = jr + t[P + 6964 >> 2] | 0, l = l >>> 0 > Me >>> 0 ? n + 1 | 0 : n, n = l + pe | 0, K = K + Me | 0, n = K >>> 0 < Me >>> 0 ? n + 1 | 0 : n, tr = K << 4 & -16, pe = n, Ce = (n << 4 | K >>> 28) & 16777215, nr = a, Pr(Di, tr | a >>> 16 & 15, Ce, 0, 0, 977, 1, 0, 0), Ei = t[P + 6740 >> 2], n = Ei + t[P + 6724 >> 2] | 0, Ii = t[P + 6736 >> 2], a = t[P + 6720 >> 2], Ce = Ii + a | 0, t[P + 7576 >> 2] = Ce, a = a >>> 0 > Ce >>> 0 ? n + 1 | 0 : n, t[P + 7580 >> 2] = a & 1048575, Li = P + 6832 | 0, Pr(Li, Wi, zn, 0, 0, Ti, ai, 0, 0), kn = P + 6928 | 0, Pr(kn, ui, Yr, 0, 0, di, Nr, 0, 0), Qi = P + 7040 | 0, Pr(Qi, ei, kr, 0, 0, ei, kr, 0, 0), Ki = P + 6784 | 0, wi = Ki, tr = (l | 0) == (pe | 0) & K >>> 0 < Me >>> 0 | l >>> 0 > pe >>> 0, Me = (l | 0) == (jr | 0) & Me >>> 0 < or >>> 0 | l >>> 0 < jr >>> 0, n = $i + 8 | 0, K = t[n >> 2], l = Dn + 8 | 0, or = K + t[l >> 2] | 0, n = t[l + 4 >> 2] + t[n + 4 >> 2] | 0, n = K >>> 0 > or >>> 0 ? n + 1 | 0 : n, K = Me + or | 0, n = K >>> 0 < or >>> 0 ? n + 1 | 0 : n, b = b >>> 20 | 0, l = b + K | 0, n = b >>> 0 > l >>> 0 ? n + 1 | 0 : n, b = l, l = l + tr | 0, n = b >>> 0 > l >>> 0 ? n + 1 | 0 : n, Me = l << 12 | pe >>> 20, K = n, pe = n << 12 | l >>> 20, $i = t[P + 6932 >> 2], n = $i + t[P + 7044 >> 2] | 0, Di = t[P + 6928 >> 2], b = t[P + 7040 >> 2], l = Di + b | 0, jr = l, or = l + Me | 0, b = l >>> 0 < b >>> 0 ? n + 1 | 0 : n, n = b + pe | 0, Me = or >>> 0 < l >>> 0 ? n + 1 | 0 : n, Pr(wi, or, Me & 1048575, 0, 0, 15632, 16, 0, 0), Ce = (a | 0) == (Ei | 0) & Ce >>> 0 < Ii >>> 0 | a >>> 0 < Ei >>> 0, n = Mn + 8 | 0, pe = t[n >> 2], l = In + 8 | 0, tr = pe + t[l >> 2] | 0, n = t[l + 4 >> 2] + t[n + 4 >> 2] | 0, n = pe >>> 0 > tr >>> 0 ? n + 1 | 0 : n, l = Ce + tr | 0, n = l >>> 0 < tr >>> 0 ? n + 1 | 0 : n, tr = l << 12 | a >>> 20, pe = n, Ce = n << 12 | l >>> 20, Ei = t[P + 6784 >> 2], l = t[P + 6832 >> 2], wi = Ei + l | 0, In = t[P + 6788 >> 2], n = In + t[P + 6836 >> 2] | 0, a = l >>> 0 > wi >>> 0 ? n + 1 | 0 : n, n = a + Ce | 0, tr = tr + wi | 0, n = tr >>> 0 < wi >>> 0 ? n + 1 | 0 : n, t[P + 7584 >> 2] = tr, Ce = n, t[P + 7588 >> 2] = n & 1048575, Ii = P + 6816 | 0, Pr(Ii, di, Nr, 0, 0, Ti, ai, 0, 0), ai = P + 6896 | 0, Pr(ai, Wi, zn, 0, 0, Wi, zn, 0, 0), Ti = P + 7024 | 0, Pr(Ti, ui, Yr, 0, 0, ei, kr, 0, 0), di = P + 6768 | 0, ei = di, Nr = (b | 0) == (Me | 0) & or >>> 0 < jr >>> 0 | b >>> 0 > Me >>> 0, or = (b | 0) == ($i | 0) & jr >>> 0 < Di >>> 0 | b >>> 0 < $i >>> 0, n = Qi + 8 | 0, b = t[n >> 2], l = kn + 8 | 0, kr = b + t[l >> 2] | 0, n = t[l + 4 >> 2] + t[n + 4 >> 2] | 0, n = b >>> 0 > kr >>> 0 ? n + 1 | 0 : n, b = or + kr | 0, n = b >>> 0 < kr >>> 0 ? n + 1 | 0 : n, K = K >>> 20 | 0, l = b + K | 0, n = K >>> 0 > l >>> 0 ? n + 1 | 0 : n, b = l, l = l + Nr | 0, n = b >>> 0 > l >>> 0 ? n + 1 | 0 : n, kr = l << 12 | Me >>> 20, K = t[P + 7024 >> 2], Me = kr + K | 0, b = n, jr = n << 12 | l >>> 20, n = jr + t[P + 7028 >> 2] | 0, or = K >>> 0 > Me >>> 0 ? n + 1 | 0 : n, Pr(ei, Me, or, 0, 0, 15632, 16, 0, 0), tr = (a | 0) == (Ce | 0) & tr >>> 0 < wi >>> 0 | a >>> 0 > Ce >>> 0, K = (a | 0) == (In | 0) & wi >>> 0 < Ei >>> 0 | a >>> 0 < In >>> 0, n = Li + 8 | 0, a = t[n >> 2], l = Ki + 8 | 0, Nr = a + t[l >> 2] | 0, n = t[l + 4 >> 2] + t[n + 4 >> 2] | 0, n = a >>> 0 > Nr >>> 0 ? n + 1 | 0 : n, a = K + Nr | 0, n = a >>> 0 < Nr >>> 0 ? n + 1 | 0 : n, pe = pe >>> 20 | 0, l = a + pe | 0, n = pe >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = l, l = l + tr | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, K = l << 12 | Ce >>> 20, a = n, pe = n << 12 | l >>> 20, wi = t[P + 6816 >> 2], l = t[P + 6896 >> 2], tr = wi + l | 0, Yr = t[P + 6820 >> 2], n = Yr + t[P + 6900 >> 2] | 0, n = l >>> 0 > tr >>> 0 ? n + 1 | 0 : n, l = t[P + 6768 >> 2], Ce = l + tr | 0, Nr = n, n = n + t[P + 6772 >> 2] | 0, l = l >>> 0 > Ce >>> 0 ? n + 1 | 0 : n, n = l + pe | 0, K = K + Ce | 0, n = K >>> 0 < Ce >>> 0 ? n + 1 | 0 : n, t[P + 7592 >> 2] = K, pe = n, t[P + 7596 >> 2] = n & 1048575, ei = P + 6752 | 0, kr = (or | 0) == (jr | 0) & Me >>> 0 < kr >>> 0 | or >>> 0 < jr >>> 0, n = Ti + 8 | 0, or = t[n >> 2], n = t[n + 4 >> 2], b = b >>> 20 | 0, Me = b, b = b + or | 0, n = Me >>> 0 > b >>> 0 ? n + 1 | 0 : n, Me = b, b = b + kr | 0, n = Me >>> 0 > b >>> 0 ? n + 1 | 0 : n, Pr(ei, b, n, 0, 0, 64028672, 65536, 0, 0), kr = (l | 0) == (pe | 0) & K >>> 0 < Ce >>> 0 | l >>> 0 > pe >>> 0, or = (l | 0) == (Nr | 0) & Ce >>> 0 < tr >>> 0 | l >>> 0 < Nr >>> 0, l = di + 8 | 0, Me = t[l >> 2], Ce = t[l + 4 >> 2], K = (Nr | 0) == (Yr | 0) & tr >>> 0 < wi >>> 0 | Nr >>> 0 < Yr >>> 0, n = ai + 8 | 0, b = t[n >> 2], l = Ii + 8 | 0, tr = b + t[l >> 2] | 0, n = t[l + 4 >> 2] + t[n + 4 >> 2] | 0, n = b >>> 0 > tr >>> 0 ? n + 1 | 0 : n, l = K + tr | 0, n = (l >>> 0 < tr >>> 0 ? n + 1 | 0 : n) + Ce | 0, b = l, l = l + Me | 0, n = b >>> 0 > l >>> 0 ? n + 1 | 0 : n, b = l + or | 0, n = b >>> 0 < l >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, l = a + b | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = l, l = l + kr | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, Ce = l << 12 | pe >>> 20, a = n, b = n << 12 | l >>> 20, tr = t[P + 6752 >> 2], l = lr & -2, pe = tr + l | 0, or = t[P + 6756 >> 2], n = or + (gr & 1048575) | 0, K = l >>> 0 > pe >>> 0 ? n + 1 | 0 : n, n = K + b | 0, b = pe + Ce | 0, n = b >>> 0 < pe >>> 0 ? n + 1 | 0 : n, t[P + 7600 >> 2] = b, l = n, t[P + 7604 >> 2] = n & 1048575, Me = nr & 65535, Ce = (n | 0) == (K | 0) & b >>> 0 < pe >>> 0 | n >>> 0 < K >>> 0, b = (K | 0) == (or | 0) & pe >>> 0 < tr >>> 0 | K >>> 0 < or >>> 0, n = ei + 8 | 0, pe = b + t[n >> 2] | 0, n = t[n + 4 >> 2], n = b >>> 0 > pe >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, b = a, a = a + pe | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, b = a, a = a + Ce | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, l = a << 12 | l >>> 20, b = l + Tt | 0, n = Me + (n << 12 | a >>> 20) | 0, t[P + 7608 >> 2] = b, t[P + 7612 >> 2] = l >>> 0 > b >>> 0 ? n + 1 | 0 : n, zn = P + 7576 | 0, zr(zn, zn, es), l = t[P + 7580 >> 2], gr = l, nr = t[P + 7576 >> 2], K = nr, n = l << 1 | K >>> 31, tr = P + 6448 | 0, di = t[P + 7600 >> 2], wi = t[P + 7604 >> 2], jr = K << 1, ui = n, Pr(tr, di, wi, 0, 0, jr, n, 0, 0), l = t[P + 7588 >> 2], ps = l, fs = t[P + 7584 >> 2], a = fs, n = l << 1 | a >>> 31, Me = P + 6656 | 0, Ti = t[P + 7592 >> 2], ei = t[P + 7596 >> 2], a = a << 1, b = n, Pr(Me, Ti, ei, 0, 0, a, n, 0, 0), Ce = P + 6608 | 0, pe = t[P + 7608 >> 2], l = t[P + 7612 >> 2], Pr(Ce, pe, l, 0, 0, pe, l, 0, 0), Tt = P + 6592 | 0, Pr(Tt, t[P + 6608 >> 2], t[P + 6612 >> 2], 0, 0, 15632, 16, 0, 0), n = l << 1 | pe >>> 31, In = P + 6560 | 0, Ei = pe << 1, ai = n, Pr(In, Ei, n, 0, 0, K, gr, 0, 0), Li = P + 6464 | 0, Pr(Li, di, wi, 0, 0, a, b, 0, 0), kn = P + 6640 | 0, Pr(kn, Ti, ei, 0, 0, Ti, ei, 0, 0), or = P + 6576 | 0, l = Ce + 8 | 0, Pr(or, t[l >> 2], t[l + 4 >> 2], 0, 0, 64028672, 65536, 0, 0), Mn = P + 6704 | 0, Pr(Mn, K, gr, 0, 0, K, gr, 0, 0), Dn = P + 6544 | 0, Pr(Dn, Ei, n, 0, 0, fs, ps, 0, 0), Qi = P + 6480 | 0, Pr(Qi, di, wi, 0, 0, Ti << 1, ei << 1 | Ti >>> 31, 0, 0), nr = t[P + 6452 >> 2], n = nr + t[P + 6660 >> 2] | 0, pe = t[P + 6448 >> 2], a = t[P + 6656 >> 2], l = pe + a | 0, b = t[P + 6592 >> 2], kr = l + b | 0, a = l >>> 0 < a >>> 0 ? n + 1 | 0 : n, n = a + t[P + 6596 >> 2] | 0, b = b >>> 0 > kr >>> 0 ? n + 1 | 0 : n, Ce = (a | 0) == (b | 0) & l >>> 0 > kr >>> 0 | a >>> 0 > b >>> 0, n = Tt + 8 | 0, Tt = t[n >> 2], K = t[n + 4 >> 2], pe = (a | 0) == (nr | 0) & l >>> 0 < pe >>> 0 | a >>> 0 < nr >>> 0, n = Me + 8 | 0, a = t[n >> 2], l = tr + 8 | 0, Me = a + t[l >> 2] | 0, n = t[l + 4 >> 2] + t[n + 4 >> 2] | 0, n = a >>> 0 > Me >>> 0 ? n + 1 | 0 : n, l = pe + Me | 0, n = (l >>> 0 < Me >>> 0 ? n + 1 | 0 : n) + K | 0, a = l, l = l + Tt | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = l, l = l + Ce | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, Nr = b, Tt = l << 12 | b >>> 20, a = n, pe = n << 12 | l >>> 20, Ki = t[P + 6464 >> 2], l = t[P + 6640 >> 2], Ce = Ki + l | 0, $i = t[P + 6468 >> 2], n = $i + t[P + 6644 >> 2] | 0, n = l >>> 0 > Ce >>> 0 ? n + 1 | 0 : n, l = t[P + 6560 >> 2], K = l + Ce | 0, tr = n, n = n + t[P + 6564 >> 2] | 0, n = l >>> 0 > K >>> 0 ? n + 1 | 0 : n, l = t[P + 6576 >> 2], b = l + K | 0, Me = n, n = n + t[P + 6580 >> 2] | 0, l = l >>> 0 > b >>> 0 ? n + 1 | 0 : n, n = l + pe | 0, Di = P + 6384 | 0, Tt = b + Tt | 0, pe = Tt >>> 0 < b >>> 0 ? n + 1 | 0 : n, Ii = (l | 0) == (pe | 0) & b >>> 0 > Tt >>> 0 | l >>> 0 > pe >>> 0, Yr = (l | 0) == (Me | 0) & b >>> 0 < K >>> 0 | l >>> 0 < Me >>> 0, l = or + 8 | 0, lr = t[l >> 2], gr = t[l + 4 >> 2], nr = (Me | 0) == (tr | 0) & K >>> 0 < Ce >>> 0 | Me >>> 0 < tr >>> 0, l = In + 8 | 0, or = t[l >> 2], Me = t[l + 4 >> 2], K = (tr | 0) == ($i | 0) & Ce >>> 0 < Ki >>> 0 | tr >>> 0 < $i >>> 0, n = kn + 8 | 0, b = t[n >> 2], l = Li + 8 | 0, Ce = b + t[l >> 2] | 0, n = t[l + 4 >> 2] + t[n + 4 >> 2] | 0, n = b >>> 0 > Ce >>> 0 ? n + 1 | 0 : n, l = K + Ce | 0, n = (l >>> 0 < Ce >>> 0 ? n + 1 | 0 : n) + Me | 0, b = l, l = l + or | 0, n = b >>> 0 > l >>> 0 ? n + 1 | 0 : n, b = l, l = l + nr | 0, n = (b >>> 0 > l >>> 0 ? n + 1 | 0 : n) + gr | 0, b = l, l = l + lr | 0, n = b >>> 0 > l >>> 0 ? n + 1 | 0 : n, b = l + Yr | 0, n = b >>> 0 < l >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, l = a + b | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = l, l = l + Ii | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = pe, K = l << 12 | a >>> 20, b = n, pe = n << 12 | l >>> 20, or = t[P + 6544 >> 2], l = t[P + 6480 >> 2], Ce = or + l | 0, nr = t[P + 6548 >> 2], n = nr + t[P + 6484 >> 2] | 0, l = l >>> 0 > Ce >>> 0 ? n + 1 | 0 : n, n = l + pe | 0, K = K + Ce | 0, n = K >>> 0 < Ce >>> 0 ? n + 1 | 0 : n, tr = K << 4 & -16, pe = n, Me = (n << 4 | K >>> 28) & 16777215, lr = a, Pr(Di, tr | a >>> 16 & 15, Me, 0, 0, 977, 1, 0, 0), $i = P + 6688 | 0, Pr($i, fs, ps, 0, 0, jr, ui, 0, 0), In = P + 6528 | 0, Pr(In, Ei, ai, 0, 0, Ti, ei, 0, 0), Li = P + 6496 | 0, Pr(Li, di, wi, 0, 0, di, wi, 0, 0), kn = P + 6432 | 0, tr = kn, Me = (l | 0) == (n | 0) & K >>> 0 < Ce >>> 0 | l >>> 0 > n >>> 0, K = (l | 0) == (nr | 0) & Ce >>> 0 < or >>> 0 | l >>> 0 < nr >>> 0, n = Qi + 8 | 0, a = t[n >> 2], l = Dn + 8 | 0, Ce = a + t[l >> 2] | 0, n = t[l + 4 >> 2] + t[n + 4 >> 2] | 0, n = a >>> 0 > Ce >>> 0 ? n + 1 | 0 : n, a = K + Ce | 0, n = a >>> 0 < Ce >>> 0 ? n + 1 | 0 : n, b = b >>> 20 | 0, l = a + b | 0, n = b >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = l, l = l + Me | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, pe = l << 12 | pe >>> 20, K = n, a = n << 12 | l >>> 20, Qi = t[P + 6528 >> 2], l = t[P + 6496 >> 2], Yr = Qi + l | 0, Wi = t[P + 6532 >> 2], n = Wi + t[P + 6500 >> 2] | 0, b = l >>> 0 > Yr >>> 0 ? n + 1 | 0 : n, n = b + a | 0, gr = pe + Yr | 0, n = gr >>> 0 < Yr >>> 0 ? n + 1 | 0 : n, Me = n, Pr(tr, gr, n & 1048575, 0, 0, 15632, 16, 0, 0), pe = t[P + 6384 >> 2], l = t[P + 6704 >> 2], nr = pe + l | 0, Ce = t[P + 6388 >> 2], n = Ce + t[P + 6708 >> 2] | 0, ns = P + 7536 | 0, Xi = ns + 8 | 0, a = l >>> 0 > nr >>> 0 ? n + 1 | 0 : n, Ce = (Ce | 0) == (a | 0) & pe >>> 0 > nr >>> 0 | a >>> 0 < Ce >>> 0, n = Mn + 8 | 0, pe = t[n >> 2], l = Di + 8 | 0, tr = pe + t[l >> 2] | 0, n = t[l + 4 >> 2] + t[n + 4 >> 2] | 0, n = pe >>> 0 > tr >>> 0 ? n + 1 | 0 : n, l = Ce + tr | 0, n = l >>> 0 < tr >>> 0 ? n + 1 | 0 : n, or = a, tr = l << 12 | a >>> 20, pe = n, Ce = n << 12 | l >>> 20, Dn = t[P + 6436 >> 2], n = Dn + t[P + 6692 >> 2] | 0, Ki = t[P + 6432 >> 2], a = t[P + 6688 >> 2], l = Ki + a | 0, Ii = l, tr = l + tr | 0, a = l >>> 0 < a >>> 0 ? n + 1 | 0 : n, n = a + Ce | 0, t[Xi >> 2] = tr, Ce = tr >>> 0 < l >>> 0 ? n + 1 | 0 : n, t[Xi + 4 >> 2] = Ce & 1048575, Di = P + 6624 | 0, Pr(Di, Ti, ei, 0, 0, jr, ui, 0, 0), ui = P + 6672 | 0, Pr(ui, fs, ps, 0, 0, fs, ps, 0, 0), jr = P + 6512 | 0, Pr(jr, Ei, ai, 0, 0, di, wi, 0, 0), ai = P + 6416 | 0, ei = (b | 0) == (Me | 0) & gr >>> 0 < Yr >>> 0 | b >>> 0 > Me >>> 0, gr = (b | 0) == (Wi | 0) & Yr >>> 0 < Qi >>> 0 | b >>> 0 < Wi >>> 0, n = Li + 8 | 0, b = t[n >> 2], l = In + 8 | 0, di = b + t[l >> 2] | 0, n = t[l + 4 >> 2] + t[n + 4 >> 2] | 0, n = b >>> 0 > di >>> 0 ? n + 1 | 0 : n, b = gr + di | 0, n = b >>> 0 < di >>> 0 ? n + 1 | 0 : n, K = K >>> 20 | 0, l = b + K | 0, n = K >>> 0 > l >>> 0 ? n + 1 | 0 : n, b = l, l = l + ei | 0, n = b >>> 0 > l >>> 0 ? n + 1 | 0 : n, Ti = l << 12 | Me >>> 20, K = t[P + 6512 >> 2], Me = Ti + K | 0, b = n, Qi = n << 12 | l >>> 20, n = Qi + t[P + 6516 >> 2] | 0, gr = K >>> 0 > Me >>> 0 ? n + 1 | 0 : n, Pr(ai, Me, gr, 0, 0, 15632, 16, 0, 0), Ei = ns + 16 | 0, di = Ei, tr = (a | 0) == (Ce | 0) & tr >>> 0 < Ii >>> 0 | a >>> 0 > Ce >>> 0, K = (a | 0) == (Dn | 0) & Ii >>> 0 < Ki >>> 0 | a >>> 0 < Dn >>> 0, n = $i + 8 | 0, a = t[n >> 2], l = kn + 8 | 0, ei = a + t[l >> 2] | 0, n = t[l + 4 >> 2] + t[n + 4 >> 2] | 0, n = a >>> 0 > ei >>> 0 ? n + 1 | 0 : n, a = K + ei | 0, n = a >>> 0 < ei >>> 0 ? n + 1 | 0 : n, pe = pe >>> 20 | 0, l = a + pe | 0, n = pe >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = l, l = l + tr | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, K = l << 12 | Ce >>> 20, a = n, wi = n << 12 | l >>> 20, Yr = t[P + 6624 >> 2], l = t[P + 6672 >> 2], Ce = Yr + l | 0, Ii = t[P + 6628 >> 2], n = Ii + t[P + 6676 >> 2] | 0, ei = l >>> 0 > Ce >>> 0 ? n + 1 | 0 : n, n = ei + t[P + 6420 >> 2] | 0, l = t[P + 6416 >> 2], pe = l + Ce | 0, tr = pe, K = pe + K | 0, l = l >>> 0 > pe >>> 0 ? n + 1 | 0 : n, n = l + wi | 0, t[di >> 2] = K, pe = K >>> 0 < pe >>> 0 ? n + 1 | 0 : n, t[di + 4 >> 2] = pe & 1048575, di = P + 6400 | 0, wi = (gr | 0) == (Qi | 0) & Me >>> 0 < Ti >>> 0 | gr >>> 0 < Qi >>> 0, n = jr + 8 | 0, gr = t[n >> 2], n = t[n + 4 >> 2], b = b >>> 20 | 0, Me = b, b = b + gr | 0, n = Me >>> 0 > b >>> 0 ? n + 1 | 0 : n, gr = b, b = b + wi | 0, n = gr >>> 0 > b >>> 0 ? n + 1 | 0 : n, Pr(di, b, n, 0, 0, 64028672, 65536, 0, 0), Ti = ns + 24 | 0, wi = (l | 0) == (pe | 0) & K >>> 0 < tr >>> 0 | l >>> 0 > pe >>> 0, gr = (l | 0) == (ei | 0) & Ce >>> 0 > tr >>> 0 | l >>> 0 < ei >>> 0, l = ai + 8 | 0, tr = t[l >> 2], Me = t[l + 4 >> 2], K = (ei | 0) == (Ii | 0) & Ce >>> 0 < Yr >>> 0 | ei >>> 0 < Ii >>> 0, n = ui + 8 | 0, b = t[n >> 2], l = Di + 8 | 0, Ce = b + t[l >> 2] | 0, n = t[l + 4 >> 2] + t[n + 4 >> 2] | 0, n = b >>> 0 > Ce >>> 0 ? n + 1 | 0 : n, l = K + Ce | 0, n = (l >>> 0 < Ce >>> 0 ? n + 1 | 0 : n) + Me | 0, b = l, l = l + tr | 0, n = b >>> 0 > l >>> 0 ? n + 1 | 0 : n, b = l + gr | 0, n = b >>> 0 < l >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, l = a + b | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = l, l = l + wi | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, pe = l << 12 | pe >>> 20, a = n, Ce = n << 12 | l >>> 20, tr = t[P + 6400 >> 2], b = kr & -2, l = tr + b | 0, kr = t[P + 6404 >> 2], n = kr + (Nr & 1048575) | 0, K = l >>> 0 < b >>> 0 ? n + 1 | 0 : n, n = K + Ce | 0, b = pe, pe = l, b = b + l | 0, t[Ti >> 2] = b, l = l >>> 0 > b >>> 0 ? n + 1 | 0 : n, t[Ti + 4 >> 2] = l & 1048575, Nr = ns + 32 | 0, gr = Nr, Me = lr & 65535, Ce = (l | 0) == (K | 0) & b >>> 0 < pe >>> 0 | l >>> 0 < K >>> 0, b = (K | 0) == (kr | 0) & pe >>> 0 < tr >>> 0 | K >>> 0 < kr >>> 0, n = di + 8 | 0, pe = b + t[n >> 2] | 0, n = t[n + 4 >> 2], n = b >>> 0 > pe >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, b = a, a = a + pe | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, b = a, a = a + Ce | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, l = a << 12 | l >>> 20, b = l + Tt | 0, n = Me + (n << 12 | a >>> 20) | 0, t[gr >> 2] = b, t[gr + 4 >> 2] = l >>> 0 > b >>> 0 ? n + 1 | 0 : n, t[P + 7536 >> 2] = nr, t[P + 7540 >> 2] = or & 1048575, zr(ns, ns, es), l = t[P + 7540 >> 2], ai = l, Yr = t[P + 7536 >> 2], K = Yr, n = l << 1 | K >>> 31, lr = P + 6224 | 0, tr = t[Ti >> 2], Me = t[Ti + 4 >> 2], ei = K << 1, wi = n, Pr(lr, tr, Me, 0, 0, ei, n, 0, 0), l = t[Xi + 4 >> 2], es = l, Wi = t[Xi >> 2], a = Wi, n = l << 1 | a >>> 31, gr = P + 6320 | 0, nr = t[Ei >> 2], Ce = t[Ei + 4 >> 2], a = a << 1, b = n, Pr(gr, nr, Ce, 0, 0, a, n, 0, 0), or = P + 6208 | 0, pe = t[Nr >> 2], l = t[Nr + 4 >> 2], Pr(or, pe, l, 0, 0, pe, l, 0, 0), Tt = P + 6192 | 0, Pr(Tt, t[P + 6208 >> 2], t[P + 6212 >> 2], 0, 0, 15632, 16, 0, 0), n = l << 1 | pe >>> 31, Mn = P + 6160 | 0, di = pe << 1, kr = n, Pr(Mn, di, n, 0, 0, K, ai, 0, 0), Dn = P + 6240 | 0, Pr(Dn, tr, Me, 0, 0, a, b, 0, 0), $i = P + 6304 | 0, Pr($i, nr, Ce, 0, 0, nr, Ce, 0, 0), Ti = P + 6176 | 0, l = or + 8 | 0, Pr(Ti, t[l >> 2], t[l + 4 >> 2], 0, 0, 64028672, 65536, 0, 0), In = P + 6368 | 0, Pr(In, K, ai, 0, 0, K, ai, 0, 0), Li = P + 6144 | 0, Pr(Li, di, n, 0, 0, Wi, es, 0, 0), kn = P + 6256 | 0, Pr(kn, tr, Me, 0, 0, nr << 1, Ce << 1 | nr >>> 31, 0, 0), Yr = t[P + 6228 >> 2], n = Yr + t[P + 6324 >> 2] | 0, pe = t[P + 6224 >> 2], a = t[P + 6320 >> 2], l = pe + a | 0, b = t[P + 6192 >> 2], Nr = l + b | 0, a = l >>> 0 < a >>> 0 ? n + 1 | 0 : n, n = a + t[P + 6196 >> 2] | 0, b = b >>> 0 > Nr >>> 0 ? n + 1 | 0 : n, or = (a | 0) == (b | 0) & l >>> 0 > Nr >>> 0 | a >>> 0 > b >>> 0, n = Tt + 8 | 0, Tt = t[n >> 2], K = t[n + 4 >> 2], pe = (a | 0) == (Yr | 0) & l >>> 0 < pe >>> 0 | a >>> 0 < Yr >>> 0, n = gr + 8 | 0, a = t[n >> 2], l = lr + 8 | 0, gr = a + t[l >> 2] | 0, n = t[l + 4 >> 2] + t[n + 4 >> 2] | 0, n = a >>> 0 > gr >>> 0 ? n + 1 | 0 : n, l = pe + gr | 0, n = (l >>> 0 < gr >>> 0 ? n + 1 | 0 : n) + K | 0, a = l, l = l + Tt | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = l, l = l + or | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, lr = b, Tt = l << 12 | b >>> 20, a = n, pe = n << 12 | l >>> 20, Qi = t[P + 6240 >> 2], l = t[P + 6304 >> 2], or = Qi + l | 0, Xi = t[P + 6244 >> 2], n = Xi + t[P + 6308 >> 2] | 0, n = l >>> 0 > or >>> 0 ? n + 1 | 0 : n, l = t[P + 6160 >> 2], K = l + or | 0, Yr = n, n = n + t[P + 6164 >> 2] | 0, n = l >>> 0 > K >>> 0 ? n + 1 | 0 : n, l = t[P + 6176 >> 2], b = l + K | 0, gr = n, n = n + t[P + 6180 >> 2] | 0, l = l >>> 0 > b >>> 0 ? n + 1 | 0 : n, n = l + pe | 0, Ki = P + 6128 | 0, Di = Ki, Tt = b + Tt | 0, pe = Tt >>> 0 < b >>> 0 ? n + 1 | 0 : n, Ei = (l | 0) == (pe | 0) & b >>> 0 > Tt >>> 0 | l >>> 0 > pe >>> 0, Ii = (l | 0) == (gr | 0) & b >>> 0 < K >>> 0 | l >>> 0 < gr >>> 0, l = Ti + 8 | 0, ui = t[l >> 2], jr = t[l + 4 >> 2], ai = (gr | 0) == (Yr | 0) & K >>> 0 < or >>> 0 | gr >>> 0 < Yr >>> 0, l = Mn + 8 | 0, Ti = t[l >> 2], gr = t[l + 4 >> 2], K = (Yr | 0) == (Xi | 0) & or >>> 0 < Qi >>> 0 | Yr >>> 0 < Xi >>> 0, n = $i + 8 | 0, b = t[n >> 2], l = Dn + 8 | 0, or = b + t[l >> 2] | 0, n = t[l + 4 >> 2] + t[n + 4 >> 2] | 0, n = b >>> 0 > or >>> 0 ? n + 1 | 0 : n, l = K + or | 0, n = (l >>> 0 < or >>> 0 ? n + 1 | 0 : n) + gr | 0, b = l, l = l + Ti | 0, n = b >>> 0 > l >>> 0 ? n + 1 | 0 : n, b = l, l = l + ai | 0, n = (b >>> 0 > l >>> 0 ? n + 1 | 0 : n) + jr | 0, b = l, l = l + ui | 0, n = b >>> 0 > l >>> 0 ? n + 1 | 0 : n, b = l + Ii | 0, n = b >>> 0 < l >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, l = a + b | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = l, l = l + Ei | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = pe, K = l << 12 | a >>> 20, b = n, gr = n << 12 | l >>> 20, ui = t[P + 6148 >> 2], n = ui + t[P + 6260 >> 2] | 0, jr = t[P + 6144 >> 2], l = t[P + 6256 >> 2], pe = jr + l | 0, or = pe, K = pe + K | 0, l = l >>> 0 > pe >>> 0 ? n + 1 | 0 : n, n = l + gr | 0, Ti = K << 4 & -16, pe = K >>> 0 < pe >>> 0 ? n + 1 | 0 : n, Yr = (pe << 4 | K >>> 28) & 16777215, gr = a, Pr(Di, Ti | a >>> 16 & 15, Yr, 0, 0, 977, 1, 0, 0), Di = P + 6352 | 0, Pr(Di, Wi, es, 0, 0, ei, wi, 0, 0), Ii = P + 6096 | 0, Pr(Ii, di, kr, 0, 0, nr, Ce, 0, 0), ai = P + 6272 | 0, Pr(ai, tr, Me, 0, 0, tr, Me, 0, 0), Ti = P + 6080 | 0, Yr = (l | 0) == (pe | 0) & K >>> 0 < or >>> 0 | l >>> 0 > pe >>> 0, K = (l | 0) == (ui | 0) & or >>> 0 < jr >>> 0 | l >>> 0 < ui >>> 0, n = kn + 8 | 0, a = t[n >> 2], l = Li + 8 | 0, or = a + t[l >> 2] | 0, n = t[l + 4 >> 2] + t[n + 4 >> 2] | 0, n = a >>> 0 > or >>> 0 ? n + 1 | 0 : n, a = K + or | 0, n = a >>> 0 < or >>> 0 ? n + 1 | 0 : n, b = b >>> 20 | 0, l = a + b | 0, n = b >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = l, l = l + Yr | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, pe = l << 12 | pe >>> 20, a = n, b = n << 12 | l >>> 20, Yr = t[P + 6096 >> 2], l = t[P + 6272 >> 2], K = Yr + l | 0, Ei = t[P + 6100 >> 2], n = Ei + t[P + 6276 >> 2] | 0, l = l >>> 0 > K >>> 0 ? n + 1 | 0 : n, n = l + b | 0, pe = K + pe | 0, n = pe >>> 0 < K >>> 0 ? n + 1 | 0 : n, b = n, Pr(Ti, pe, n & 1048575, 0, 0, 15632, 16, 0, 0), ui = P + 6288 | 0, Pr(ui, nr, Ce, 0, 0, ei, wi, 0, 0), jr = P + 6336 | 0, Pr(jr, Wi, es, 0, 0, Wi, es, 0, 0), or = P + 6032 | 0, Pr(or, di, kr, 0, 0, tr, Me, 0, 0), ei = P + 6016 | 0, Me = ei, Ce = (l | 0) == (n | 0) & K >>> 0 > pe >>> 0 | l >>> 0 > n >>> 0, K = (l | 0) == (Ei | 0) & K >>> 0 < Yr >>> 0 | l >>> 0 < Ei >>> 0, n = ai + 8 | 0, pe = t[n >> 2], l = Ii + 8 | 0, tr = pe + t[l >> 2] | 0, n = t[l + 4 >> 2] + t[n + 4 >> 2] | 0, n = pe >>> 0 > tr >>> 0 ? n + 1 | 0 : n, pe = K + tr | 0, n = pe >>> 0 < tr >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, l = a + pe | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = l, l = l + Ce | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, pe = l << 12 | b >>> 20, b = t[P + 6032 >> 2], Ce = pe + b | 0, a = n, l = n << 12 | l >>> 20, n = l + t[P + 6036 >> 2] | 0, n = b >>> 0 > Ce >>> 0 ? n + 1 | 0 : n, Pr(Me, Ce, n, 0, 0, 15632, 16, 0, 0), Ei = P + 5952 | 0, K = Ei, pe = (l | 0) == (n | 0) & pe >>> 0 > Ce >>> 0 | l >>> 0 > n >>> 0, l = or + 8 | 0, b = t[l >> 2], n = t[l + 4 >> 2], a = a >>> 20 | 0, l = a + b | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = l, l = l + pe | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, Pr(K, l, n, 0, 0, 64028672, 65536, 0, 0), a = t[P + 6128 >> 2], l = t[P + 6368 >> 2], K = a + l | 0, pe = t[P + 6132 >> 2], n = pe + t[P + 6372 >> 2] | 0, b = l >>> 0 > K >>> 0 ? n + 1 | 0 : n, pe = (pe | 0) == (b | 0) & a >>> 0 > K >>> 0 | b >>> 0 < pe >>> 0, n = In + 8 | 0, a = t[n >> 2], l = Ki + 8 | 0, Ce = a + t[l >> 2] | 0, n = t[l + 4 >> 2] + t[n + 4 >> 2] | 0, n = a >>> 0 > Ce >>> 0 ? n + 1 | 0 : n, l = pe + Ce | 0, n = l >>> 0 < Ce >>> 0 ? n + 1 | 0 : n, nr = b, pe = l << 12 | b >>> 20, a = n, b = n << 12 | l >>> 20, Me = t[P + 6080 >> 2], l = t[P + 6352 >> 2], Ce = Me + l | 0, or = t[P + 6084 >> 2], n = or + t[P + 6356 >> 2] | 0, l = l >>> 0 > Ce >>> 0 ? n + 1 | 0 : n, n = l + b | 0, pe = pe + Ce | 0, b = pe >>> 0 < Ce >>> 0 ? n + 1 | 0 : n, tr = (l | 0) == (b | 0) & pe >>> 0 < Ce >>> 0 | l >>> 0 > b >>> 0, Me = (l | 0) == (or | 0) & Ce >>> 0 < Me >>> 0 | l >>> 0 < or >>> 0, n = Di + 8 | 0, Ce = t[n >> 2], l = Ti + 8 | 0, or = Ce + t[l >> 2] | 0, n = t[l + 4 >> 2] + t[n + 4 >> 2] | 0, n = Ce >>> 0 > or >>> 0 ? n + 1 | 0 : n, Ce = Me + or | 0, n = Ce >>> 0 < or >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, l = a + Ce | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = l, l = l + tr | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, or = b, Ce = l << 12 | b >>> 20, a = n, b = n << 12 | l >>> 20, ai = t[P + 6288 >> 2], l = t[P + 6336 >> 2], tr = ai + l | 0, Di = t[P + 6292 >> 2], n = Di + t[P + 6340 >> 2] | 0, n = l >>> 0 > tr >>> 0 ? n + 1 | 0 : n, l = t[P + 6016 >> 2], Me = l + tr | 0, kr = n, n = n + t[P + 6020 >> 2] | 0, l = l >>> 0 > Me >>> 0 ? n + 1 | 0 : n, n = l + b | 0, Ii = P + 5936 | 0, Ti = Ii, b = Ce + Me | 0, Ce = b >>> 0 < Me >>> 0 ? n + 1 | 0 : n, Yr = (l | 0) == (Ce | 0) & b >>> 0 < Me >>> 0 | l >>> 0 > Ce >>> 0, di = (l | 0) == (kr | 0) & Me >>> 0 < tr >>> 0 | l >>> 0 < kr >>> 0, l = ei + 8 | 0, wi = t[l >> 2], ei = t[l + 4 >> 2], tr = (kr | 0) == (Di | 0) & tr >>> 0 < ai >>> 0 | kr >>> 0 < Di >>> 0, n = jr + 8 | 0, Me = t[n >> 2], l = ui + 8 | 0, kr = Me + t[l >> 2] | 0, n = t[l + 4 >> 2] + t[n + 4 >> 2] | 0, n = Me >>> 0 > kr >>> 0 ? n + 1 | 0 : n, l = tr + kr | 0, n = (l >>> 0 < kr >>> 0 ? n + 1 | 0 : n) + ei | 0, tr = l, l = l + wi | 0, n = tr >>> 0 > l >>> 0 ? n + 1 | 0 : n, Me = l + di | 0, n = Me >>> 0 < l >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, l = a + Me | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = l, l = l + Yr | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, Me = Ce, tr = l << 12 | Ce >>> 20, a = n, kr = n << 12 | l >>> 20, Di = t[P + 5956 >> 2], n = Di + (lr & 1048575) | 0, ai = t[P + 5952 >> 2], l = Nr & -2, Ce = ai + l | 0, lr = Ce, tr = Ce + tr | 0, l = l >>> 0 > Ce >>> 0 ? n + 1 | 0 : n, n = l + kr | 0, Ce = tr >>> 0 < Ce >>> 0 ? n + 1 | 0 : n, kr = Ce & 1048575, n = nr & 1048575, Ki = n, nr = K, n = n << 1 | K >>> 31, wi = K << 1, di = n, Pr(Ti, tr, kr, 0, 0, wi, n, 0, 0), n = or & 1048575, Wi = n, ui = P + 5968 | 0, Nr = Me & 1048575, K = pe << 1, Ti = pe, Me = n << 1 | pe >>> 31, Pr(ui, b, Nr, 0, 0, K, Me, 0, 0), jr = P + 5872 | 0, Yr = jr, ei = gr & 65535, gr = (l | 0) == (Ce | 0) & tr >>> 0 < lr >>> 0 | l >>> 0 > Ce >>> 0, or = (l | 0) == (Di | 0) & lr >>> 0 < ai >>> 0 | l >>> 0 < Di >>> 0, l = Ei + 8 | 0, pe = or + t[l >> 2] | 0, n = t[l + 4 >> 2], n = pe >>> 0 < or >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, l = a + pe | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = l, l = l + gr | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, pe = l << 12 | Ce >>> 20, a = pe + Tt | 0, n = ei + (n << 12 | l >>> 20) | 0, n = a >>> 0 < pe >>> 0 ? n + 1 | 0 : n, Pr(Yr, a, n, 0, 0, a, n, 0, 0), Tt = P + 5856 | 0, Pr(Tt, t[P + 5872 >> 2], t[P + 5876 >> 2], 0, 0, 15632, 16, 0, 0), l = a, n = n << 1 | l >>> 31, Mn = P + 5824 | 0, Yr = l << 1, ei = n, Pr(Mn, Yr, n, 0, 0, nr, Ki, 0, 0), Dn = P + 5920 | 0, Pr(Dn, tr, kr, 0, 0, K, Me, 0, 0), $i = P + 5984 | 0, Pr($i, b, Nr, 0, 0, b, Nr, 0, 0), ai = P + 5840 | 0, l = jr + 8 | 0, Pr(ai, t[l >> 2], t[l + 4 >> 2], 0, 0, 64028672, 65536, 0, 0), In = P + 6112 | 0, Pr(In, nr, Ki, 0, 0, nr, Ki, 0, 0), Li = P + 5808 | 0, Pr(Li, Yr, n, 0, 0, Ti, Wi, 0, 0), kn = P + 5888 | 0, Me = kr, Ce = Nr, kr = b, Pr(kn, tr, Me, 0, 0, b << 1, Ce << 1 | b >>> 31, 0, 0), pe = t[P + 5936 >> 2], a = t[P + 5968 >> 2], l = pe + a | 0, nr = t[P + 5940 >> 2], n = nr + t[P + 5972 >> 2] | 0, n = l >>> 0 < a >>> 0 ? n + 1 | 0 : n, a = t[P + 5856 >> 2], Nr = a + l | 0, b = n, n = n + t[P + 5860 >> 2] | 0, a = a >>> 0 > Nr >>> 0 ? n + 1 | 0 : n, or = (b | 0) == (a | 0) & l >>> 0 > Nr >>> 0 | a >>> 0 < b >>> 0, n = Tt + 8 | 0, Tt = t[n >> 2], K = t[n + 4 >> 2], pe = (b | 0) == (nr | 0) & l >>> 0 < pe >>> 0 | b >>> 0 < nr >>> 0, n = ui + 8 | 0, b = t[n >> 2], l = Ii + 8 | 0, nr = b + t[l >> 2] | 0, n = t[l + 4 >> 2] + t[n + 4 >> 2] | 0, n = b >>> 0 > nr >>> 0 ? n + 1 | 0 : n, l = pe + nr | 0, n = (l >>> 0 < nr >>> 0 ? n + 1 | 0 : n) + K | 0, b = l, l = l + Tt | 0, n = b >>> 0 > l >>> 0 ? n + 1 | 0 : n, b = l, l = l + or | 0, n = b >>> 0 > l >>> 0 ? n + 1 | 0 : n, lr = a, Tt = l << 12 | a >>> 20, b = n, pe = n << 12 | l >>> 20, Qi = t[P + 5920 >> 2], l = t[P + 5984 >> 2], nr = Qi + l | 0, Xi = t[P + 5924 >> 2], n = Xi + t[P + 5988 >> 2] | 0, n = l >>> 0 > nr >>> 0 ? n + 1 | 0 : n, l = t[P + 5824 >> 2], or = l + nr | 0, a = n, n = n + t[P + 5828 >> 2] | 0, n = l >>> 0 > or >>> 0 ? n + 1 | 0 : n, l = t[P + 5840 >> 2], K = l + or | 0, gr = n, n = n + t[P + 5844 >> 2] | 0, l = l >>> 0 > K >>> 0 ? n + 1 | 0 : n, n = l + pe | 0, Ki = P + 5712 | 0, Di = Ki, Tt = K + Tt | 0, pe = Tt >>> 0 < K >>> 0 ? n + 1 | 0 : n, Ei = (l | 0) == (pe | 0) & K >>> 0 > Tt >>> 0 | l >>> 0 > pe >>> 0, Ii = (l | 0) == (gr | 0) & K >>> 0 < or >>> 0 | l >>> 0 < gr >>> 0, l = ai + 8 | 0, ui = t[l >> 2], jr = t[l + 4 >> 2], ai = (a | 0) == (gr | 0) & nr >>> 0 > or >>> 0 | a >>> 0 > gr >>> 0, l = Mn + 8 | 0, gr = t[l >> 2], or = t[l + 4 >> 2], K = (a | 0) == (Xi | 0) & nr >>> 0 < Qi >>> 0 | a >>> 0 < Xi >>> 0, n = $i + 8 | 0, a = t[n >> 2], l = Dn + 8 | 0, nr = a + t[l >> 2] | 0, n = t[l + 4 >> 2] + t[n + 4 >> 2] | 0, n = a >>> 0 > nr >>> 0 ? n + 1 | 0 : n, l = K + nr | 0, n = (l >>> 0 < nr >>> 0 ? n + 1 | 0 : n) + or | 0, a = l, l = l + gr | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = l, l = l + ai | 0, n = (a >>> 0 > l >>> 0 ? n + 1 | 0 : n) + jr | 0, a = l, l = l + ui | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = l + Ii | 0, n = a >>> 0 < l >>> 0 ? n + 1 | 0 : n, b = b >>> 20 | 0, l = a + b | 0, n = b >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = l, l = l + Ei | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = pe, K = l << 12 | a >>> 20, b = n, pe = n << 12 | l >>> 20, jr = t[P + 5808 >> 2], l = t[P + 5888 >> 2], or = jr + l | 0, ui = t[P + 5812 >> 2], n = ui + t[P + 5892 >> 2] | 0, l = l >>> 0 > or >>> 0 ? n + 1 | 0 : n, n = l + pe | 0, K = K + or | 0, n = K >>> 0 < or >>> 0 ? n + 1 | 0 : n, ai = K << 4 & -16, pe = n, nr = (n << 4 | K >>> 28) & 16777215, gr = a, Pr(Di, ai | a >>> 16 & 15, nr, 0, 0, 977, 1, 0, 0), Di = P + 6048 | 0, Pr(Di, Ti, Wi, 0, 0, wi, di, 0, 0), Ei = P + 5792 | 0, Pr(Ei, Yr, ei, 0, 0, kr, Ce, 0, 0), Ii = P + 5904 | 0, Pr(Ii, tr, Me, 0, 0, tr, Me, 0, 0), ai = P + 5776 | 0, nr = (l | 0) == (n | 0) & K >>> 0 < or >>> 0 | l >>> 0 > n >>> 0, K = (l | 0) == (ui | 0) & or >>> 0 < jr >>> 0 | l >>> 0 < ui >>> 0, n = kn + 8 | 0, a = t[n >> 2], l = Li + 8 | 0, or = a + t[l >> 2] | 0, n = t[l + 4 >> 2] + t[n + 4 >> 2] | 0, n = a >>> 0 > or >>> 0 ? n + 1 | 0 : n, a = K + or | 0, n = a >>> 0 < or >>> 0 ? n + 1 | 0 : n, b = b >>> 20 | 0, l = a + b | 0, n = b >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = l, l = l + nr | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, pe = l << 12 | pe >>> 20, a = n, b = n << 12 | l >>> 20, nr = t[P + 5792 >> 2], l = t[P + 5904 >> 2], K = nr + l | 0, Qi = t[P + 5796 >> 2], n = Qi + t[P + 5908 >> 2] | 0, l = l >>> 0 > K >>> 0 ? n + 1 | 0 : n, n = l + b | 0, pe = K + pe | 0, n = pe >>> 0 < K >>> 0 ? n + 1 | 0 : n, b = n, Pr(ai, pe, n & 1048575, 0, 0, 15632, 16, 0, 0), ui = P + 6e3 | 0, Pr(ui, kr, Ce, 0, 0, wi, di, 0, 0), jr = P + 6064 | 0, Pr(jr, Ti, Wi, 0, 0, Ti, Wi, 0, 0), or = P + 5760 | 0, Pr(or, tr, Me, 0, 0, Yr, ei, 0, 0), ei = P + 5744 | 0, Me = ei, Ce = (l | 0) == (n | 0) & K >>> 0 > pe >>> 0 | l >>> 0 > n >>> 0, K = (l | 0) == (Qi | 0) & K >>> 0 < nr >>> 0 | l >>> 0 < Qi >>> 0, n = Ii + 8 | 0, pe = t[n >> 2], l = Ei + 8 | 0, tr = pe + t[l >> 2] | 0, n = t[l + 4 >> 2] + t[n + 4 >> 2] | 0, n = pe >>> 0 > tr >>> 0 ? n + 1 | 0 : n, pe = K + tr | 0, n = pe >>> 0 < tr >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, l = a + pe | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = l, l = l + Ce | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, pe = l << 12 | b >>> 20, b = t[P + 5760 >> 2], Ce = pe + b | 0, a = n, l = n << 12 | l >>> 20, n = l + t[P + 5764 >> 2] | 0, n = b >>> 0 > Ce >>> 0 ? n + 1 | 0 : n, Pr(Me, Ce, n, 0, 0, 15632, 16, 0, 0), Ei = P + 5728 | 0, K = Ei, pe = (l | 0) == (n | 0) & pe >>> 0 > Ce >>> 0 | l >>> 0 > n >>> 0, l = or + 8 | 0, b = t[l >> 2], n = t[l + 4 >> 2], a = a >>> 20 | 0, l = a + b | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = l, l = l + pe | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, Pr(K, l, n, 0, 0, 64028672, 65536, 0, 0), a = t[P + 5712 >> 2], l = t[P + 6112 >> 2], K = a + l | 0, pe = t[P + 5716 >> 2], n = pe + t[P + 6116 >> 2] | 0, b = l >>> 0 > K >>> 0 ? n + 1 | 0 : n, pe = (pe | 0) == (b | 0) & a >>> 0 > K >>> 0 | b >>> 0 < pe >>> 0, n = In + 8 | 0, a = t[n >> 2], l = Ki + 8 | 0, Ce = a + t[l >> 2] | 0, n = t[l + 4 >> 2] + t[n + 4 >> 2] | 0, n = a >>> 0 > Ce >>> 0 ? n + 1 | 0 : n, l = pe + Ce | 0, n = l >>> 0 < Ce >>> 0 ? n + 1 | 0 : n, nr = b, pe = l << 12 | b >>> 20, a = n, b = n << 12 | l >>> 20, Me = t[P + 5776 >> 2], l = t[P + 6048 >> 2], Ce = Me + l | 0, or = t[P + 5780 >> 2], n = or + t[P + 6052 >> 2] | 0, l = l >>> 0 > Ce >>> 0 ? n + 1 | 0 : n, n = l + b | 0, pe = pe + Ce | 0, b = pe >>> 0 < Ce >>> 0 ? n + 1 | 0 : n, tr = (l | 0) == (b | 0) & pe >>> 0 < Ce >>> 0 | l >>> 0 > b >>> 0, Me = (l | 0) == (or | 0) & Ce >>> 0 < Me >>> 0 | l >>> 0 < or >>> 0, n = Di + 8 | 0, Ce = t[n >> 2], l = ai + 8 | 0, or = Ce + t[l >> 2] | 0, n = t[l + 4 >> 2] + t[n + 4 >> 2] | 0, n = Ce >>> 0 > or >>> 0 ? n + 1 | 0 : n, Ce = Me + or | 0, n = Ce >>> 0 < or >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, l = a + Ce | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = l, l = l + tr | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, or = b, Ce = l << 12 | b >>> 20, a = n, b = n << 12 | l >>> 20, ai = t[P + 6e3 >> 2], l = t[P + 6064 >> 2], tr = ai + l | 0, Di = t[P + 6004 >> 2], n = Di + t[P + 6068 >> 2] | 0, n = l >>> 0 > tr >>> 0 ? n + 1 | 0 : n, l = t[P + 5744 >> 2], Me = l + tr | 0, kr = n, n = n + t[P + 5748 >> 2] | 0, l = l >>> 0 > Me >>> 0 ? n + 1 | 0 : n, n = l + b | 0, Ii = P + 5632 | 0, Ti = Ii, b = Ce + Me | 0, Ce = b >>> 0 < Me >>> 0 ? n + 1 | 0 : n, Yr = (l | 0) == (Ce | 0) & b >>> 0 < Me >>> 0 | l >>> 0 > Ce >>> 0, di = (l | 0) == (kr | 0) & Me >>> 0 < tr >>> 0 | l >>> 0 < kr >>> 0, l = ei + 8 | 0, wi = t[l >> 2], ei = t[l + 4 >> 2], tr = (kr | 0) == (Di | 0) & tr >>> 0 < ai >>> 0 | kr >>> 0 < Di >>> 0, n = jr + 8 | 0, Me = t[n >> 2], l = ui + 8 | 0, kr = Me + t[l >> 2] | 0, n = t[l + 4 >> 2] + t[n + 4 >> 2] | 0, n = Me >>> 0 > kr >>> 0 ? n + 1 | 0 : n, l = tr + kr | 0, n = (l >>> 0 < kr >>> 0 ? n + 1 | 0 : n) + ei | 0, tr = l, l = l + wi | 0, n = tr >>> 0 > l >>> 0 ? n + 1 | 0 : n, Me = l + di | 0, n = Me >>> 0 < l >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, l = a + Me | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = l, l = l + Yr | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, Me = Ce, tr = l << 12 | Ce >>> 20, a = n, kr = n << 12 | l >>> 20, Di = t[P + 5732 >> 2], n = Di + (lr & 1048575) | 0, ai = t[P + 5728 >> 2], l = Nr & -2, Ce = ai + l | 0, lr = Ce, tr = Ce + tr | 0, l = l >>> 0 > Ce >>> 0 ? n + 1 | 0 : n, n = l + kr | 0, Ce = tr >>> 0 < Ce >>> 0 ? n + 1 | 0 : n, Yr = Ce & 1048575, Nr = Yr, n = nr & 1048575, Ki = n, nr = K, n = n << 1 | K >>> 31, ei = K << 1, wi = n, Pr(Ti, tr, Nr, 0, 0, ei, n, 0, 0), n = or & 1048575, Wi = n, ui = P + 5584 | 0, Nr = Me & 1048575, K = pe << 1, Ti = pe, Me = n << 1 | pe >>> 31, Pr(ui, b, Nr, 0, 0, K, Me, 0, 0), jr = P + 5536 | 0, kr = gr & 65535, gr = (l | 0) == (Ce | 0) & tr >>> 0 < lr >>> 0 | l >>> 0 > Ce >>> 0, or = (l | 0) == (Di | 0) & lr >>> 0 < ai >>> 0 | l >>> 0 < Di >>> 0, l = Ei + 8 | 0, pe = or + t[l >> 2] | 0, n = t[l + 4 >> 2], n = pe >>> 0 < or >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, l = a + pe | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = l, l = l + gr | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, pe = l << 12 | Ce >>> 20, a = pe + Tt | 0, n = kr + (n << 12 | l >>> 20) | 0, n = a >>> 0 < pe >>> 0 ? n + 1 | 0 : n, Pr(jr, a, n, 0, 0, a, n, 0, 0), Tt = P + 5520 | 0, Pr(Tt, t[P + 5536 >> 2], t[P + 5540 >> 2], 0, 0, 15632, 16, 0, 0), l = a, n = n << 1 | l >>> 31, Mn = P + 5488 | 0, di = l << 1, kr = n, Pr(Mn, di, n, 0, 0, nr, Ki, 0, 0), Dn = P + 5568 | 0, Pr(Dn, tr, Yr, 0, 0, K, Me, 0, 0), $i = P + 5680 | 0, Pr($i, b, Nr, 0, 0, b, Nr, 0, 0), ai = P + 5504 | 0, l = jr + 8 | 0, Pr(ai, t[l >> 2], t[l + 4 >> 2], 0, 0, 64028672, 65536, 0, 0), In = P + 5648 | 0, Pr(In, nr, Ki, 0, 0, nr, Ki, 0, 0), Li = P + 5472 | 0, Pr(Li, di, n, 0, 0, Ti, Wi, 0, 0), kn = P + 5552 | 0, gr = tr, nr = Yr, Ce = Nr, Nr = b, Pr(kn, tr, nr, 0, 0, b << 1, Ce << 1 | b >>> 31, 0, 0), pe = t[P + 5632 >> 2], a = t[P + 5584 >> 2], l = pe + a | 0, tr = t[P + 5636 >> 2], n = tr + t[P + 5588 >> 2] | 0, n = l >>> 0 < a >>> 0 ? n + 1 | 0 : n, a = t[P + 5520 >> 2], or = a + l | 0, b = n, n = n + t[P + 5524 >> 2] | 0, a = a >>> 0 > or >>> 0 ? n + 1 | 0 : n, Me = (b | 0) == (a | 0) & l >>> 0 > or >>> 0 | a >>> 0 < b >>> 0, n = Tt + 8 | 0, Tt = t[n >> 2], K = t[n + 4 >> 2], pe = (b | 0) == (tr | 0) & l >>> 0 < pe >>> 0 | b >>> 0 < tr >>> 0, n = ui + 8 | 0, b = t[n >> 2], l = Ii + 8 | 0, tr = b + t[l >> 2] | 0, n = t[l + 4 >> 2] + t[n + 4 >> 2] | 0, n = b >>> 0 > tr >>> 0 ? n + 1 | 0 : n, l = pe + tr | 0, n = (l >>> 0 < tr >>> 0 ? n + 1 | 0 : n) + K | 0, b = l, l = l + Tt | 0, n = b >>> 0 > l >>> 0 ? n + 1 | 0 : n, b = l, l = l + Me | 0, n = b >>> 0 > l >>> 0 ? n + 1 | 0 : n, tr = a, K = l << 12 | a >>> 20, b = n, pe = n << 12 | l >>> 20, Qi = t[P + 5568 >> 2], l = t[P + 5680 >> 2], lr = Qi + l | 0, Xi = t[P + 5572 >> 2], n = Xi + t[P + 5684 >> 2] | 0, n = l >>> 0 > lr >>> 0 ? n + 1 | 0 : n, l = t[P + 5488 >> 2], Me = l + lr | 0, a = n, n = n + t[P + 5492 >> 2] | 0, n = l >>> 0 > Me >>> 0 ? n + 1 | 0 : n, l = t[P + 5504 >> 2], Tt = l + Me | 0, Yr = n, n = n + t[P + 5508 >> 2] | 0, l = l >>> 0 > Tt >>> 0 ? n + 1 | 0 : n, n = l + pe | 0, Ki = P + 5376 | 0, Di = Ki, pe = K + Tt | 0, K = pe >>> 0 < Tt >>> 0 ? n + 1 | 0 : n, Ei = (l | 0) == (K | 0) & pe >>> 0 < Tt >>> 0 | l >>> 0 > K >>> 0, Ii = (l | 0) == (Yr | 0) & Me >>> 0 > Tt >>> 0 | l >>> 0 < Yr >>> 0, l = ai + 8 | 0, ui = t[l >> 2], jr = t[l + 4 >> 2], ai = (a | 0) == (Yr | 0) & Me >>> 0 < lr >>> 0 | a >>> 0 > Yr >>> 0, l = Mn + 8 | 0, Yr = t[l >> 2], Me = t[l + 4 >> 2], Tt = (a | 0) == (Xi | 0) & lr >>> 0 < Qi >>> 0 | a >>> 0 < Xi >>> 0, n = $i + 8 | 0, a = t[n >> 2], l = Dn + 8 | 0, lr = a + t[l >> 2] | 0, n = t[l + 4 >> 2] + t[n + 4 >> 2] | 0, n = a >>> 0 > lr >>> 0 ? n + 1 | 0 : n, l = Tt + lr | 0, n = (l >>> 0 < lr >>> 0 ? n + 1 | 0 : n) + Me | 0, a = l, l = l + Yr | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = l, l = l + ai | 0, n = (a >>> 0 > l >>> 0 ? n + 1 | 0 : n) + jr | 0, a = l, l = l + ui | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = l + Ii | 0, n = a >>> 0 < l >>> 0 ? n + 1 | 0 : n, b = b >>> 20 | 0, l = a + b | 0, n = b >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = l, l = l + Ei | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = K, Tt = l << 12 | a >>> 20, b = n, K = n << 12 | l >>> 20, jr = t[P + 5472 >> 2], l = t[P + 5552 >> 2], lr = jr + l | 0, Qi = t[P + 5476 >> 2], n = Qi + t[P + 5556 >> 2] | 0, l = l >>> 0 > lr >>> 0 ? n + 1 | 0 : n, n = l + K | 0, Tt = Tt + lr | 0, n = Tt >>> 0 < lr >>> 0 ? n + 1 | 0 : n, ai = Tt << 4 & -16, K = n, Yr = (n << 4 | Tt >>> 28) & 16777215, Me = a, Pr(Di, ai | a >>> 16 & 15, Yr, 0, 0, 977, 1, 0, 0), Di = P + 5616 | 0, Pr(Di, Ti, Wi, 0, 0, ei, wi, 0, 0), Ei = P + 5456 | 0, Pr(Ei, di, kr, 0, 0, Nr, Ce, 0, 0), Ii = P + 5696 | 0, Pr(Ii, gr, nr, 0, 0, gr, nr, 0, 0), ui = P + 5440 | 0, ai = ui, Yr = (l | 0) == (n | 0) & Tt >>> 0 < lr >>> 0 | l >>> 0 > n >>> 0, Tt = (l | 0) == (Qi | 0) & lr >>> 0 < jr >>> 0 | l >>> 0 < Qi >>> 0, n = kn + 8 | 0, a = t[n >> 2], l = Li + 8 | 0, lr = a + t[l >> 2] | 0, n = t[l + 4 >> 2] + t[n + 4 >> 2] | 0, n = a >>> 0 > lr >>> 0 ? n + 1 | 0 : n, a = Tt + lr | 0, n = a >>> 0 < lr >>> 0 ? n + 1 | 0 : n, b = b >>> 20 | 0, l = a + b | 0, n = b >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = l, l = l + Yr | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, K = l << 12 | K >>> 20, a = n, b = n << 12 | l >>> 20, Yr = t[P + 5456 >> 2], l = t[P + 5696 >> 2], Tt = Yr + l | 0, Qi = t[P + 5460 >> 2], n = Qi + t[P + 5700 >> 2] | 0, l = l >>> 0 > Tt >>> 0 ? n + 1 | 0 : n, n = l + b | 0, K = K + Tt | 0, n = K >>> 0 < Tt >>> 0 ? n + 1 | 0 : n, b = n, Pr(ai, K, n & 1048575, 0, 0, 15632, 16, 0, 0), jr = P + 5600 | 0, Pr(jr, Nr, Ce, 0, 0, ei, wi, 0, 0), ai = P + 5664 | 0, Pr(ai, Ti, Wi, 0, 0, Ti, Wi, 0, 0), lr = P + 5424 | 0, Pr(lr, gr, nr, 0, 0, di, kr, 0, 0), Nr = P + 5408 | 0, nr = Nr, Ce = (l | 0) == (n | 0) & K >>> 0 < Tt >>> 0 | l >>> 0 > n >>> 0, Tt = (l | 0) == (Qi | 0) & Tt >>> 0 < Yr >>> 0 | l >>> 0 < Qi >>> 0, n = Ii + 8 | 0, K = t[n >> 2], l = Ei + 8 | 0, gr = K + t[l >> 2] | 0, n = t[l + 4 >> 2] + t[n + 4 >> 2] | 0, n = K >>> 0 > gr >>> 0 ? n + 1 | 0 : n, K = Tt + gr | 0, n = K >>> 0 < gr >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, l = a + K | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = l, l = l + Ce | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, K = l << 12 | b >>> 20, b = t[P + 5424 >> 2], Ce = K + b | 0, a = n, l = n << 12 | l >>> 20, n = l + t[P + 5428 >> 2] | 0, n = b >>> 0 > Ce >>> 0 ? n + 1 | 0 : n, Pr(nr, Ce, n, 0, 0, 15632, 16, 0, 0), Yr = P + 5392 | 0, Tt = Yr, K = (l | 0) == (n | 0) & K >>> 0 > Ce >>> 0 | l >>> 0 > n >>> 0, l = lr + 8 | 0, b = t[l >> 2], n = t[l + 4 >> 2], a = a >>> 20 | 0, l = a + b | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = l, l = l + K | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, Pr(Tt, l, n, 0, 0, 64028672, 65536, 0, 0), a = t[P + 5376 >> 2], l = t[P + 5648 >> 2], Ce = a + l | 0, K = t[P + 5380 >> 2], n = K + t[P + 5652 >> 2] | 0, Qi = P + 7496 | 0, Ei = Qi + 8 | 0, gr = Ei, b = l >>> 0 > Ce >>> 0 ? n + 1 | 0 : n, K = (K | 0) == (b | 0) & a >>> 0 > Ce >>> 0 | b >>> 0 < K >>> 0, n = In + 8 | 0, a = t[n >> 2], l = Ki + 8 | 0, Tt = a + t[l >> 2] | 0, n = t[l + 4 >> 2] + t[n + 4 >> 2] | 0, n = a >>> 0 > Tt >>> 0 ? n + 1 | 0 : n, l = K + Tt | 0, n = l >>> 0 < Tt >>> 0 ? n + 1 | 0 : n, Tt = b, K = l << 12 | b >>> 20, a = n, b = n << 12 | l >>> 20, lr = t[P + 5440 >> 2], l = t[P + 5616 >> 2], nr = lr + l | 0, ei = t[P + 5444 >> 2], n = ei + t[P + 5620 >> 2] | 0, l = l >>> 0 > nr >>> 0 ? n + 1 | 0 : n, n = l + b | 0, K = K + nr | 0, n = K >>> 0 < nr >>> 0 ? n + 1 | 0 : n, t[gr >> 2] = K, b = n, t[gr + 4 >> 2] = n & 1048575, Ii = Qi + 16 | 0, kr = Ii, gr = (l | 0) == (n | 0) & K >>> 0 < nr >>> 0 | l >>> 0 > n >>> 0, nr = (l | 0) == (ei | 0) & nr >>> 0 < lr >>> 0 | l >>> 0 < ei >>> 0, n = Di + 8 | 0, K = t[n >> 2], l = ui + 8 | 0, lr = K + t[l >> 2] | 0, n = t[l + 4 >> 2] + t[n + 4 >> 2] | 0, n = K >>> 0 > lr >>> 0 ? n + 1 | 0 : n, K = nr + lr | 0, n = K >>> 0 < lr >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, l = a + K | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = l, l = l + gr | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, K = l << 12 | b >>> 20, a = n, b = n << 12 | l >>> 20, di = t[P + 5600 >> 2], l = t[P + 5664 >> 2], gr = di + l | 0, ui = t[P + 5604 >> 2], n = ui + t[P + 5668 >> 2] | 0, n = l >>> 0 > gr >>> 0 ? n + 1 | 0 : n, l = t[P + 5408 >> 2], nr = l + gr | 0, lr = n, n = n + t[P + 5412 >> 2] | 0, l = l >>> 0 > nr >>> 0 ? n + 1 | 0 : n, n = l + b | 0, K = K + nr | 0, n = K >>> 0 < nr >>> 0 ? n + 1 | 0 : n, t[kr >> 2] = K, b = n, t[kr + 4 >> 2] = n & 1048575, Ti = Qi + 24 | 0, wi = (l | 0) == (n | 0) & K >>> 0 < nr >>> 0 | l >>> 0 > n >>> 0, ei = (l | 0) == (lr | 0) & nr >>> 0 < gr >>> 0 | l >>> 0 < lr >>> 0, l = Nr + 8 | 0, kr = t[l >> 2], Nr = t[l + 4 >> 2], nr = (lr | 0) == (ui | 0) & gr >>> 0 < di >>> 0 | lr >>> 0 < ui >>> 0, n = ai + 8 | 0, K = t[n >> 2], l = jr + 8 | 0, gr = K + t[l >> 2] | 0, n = t[l + 4 >> 2] + t[n + 4 >> 2] | 0, n = K >>> 0 > gr >>> 0 ? n + 1 | 0 : n, l = nr + gr | 0, n = (l >>> 0 < gr >>> 0 ? n + 1 | 0 : n) + Nr | 0, K = l, l = l + kr | 0, n = K >>> 0 > l >>> 0 ? n + 1 | 0 : n, K = l + ei | 0, n = K >>> 0 < l >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, l = a + K | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = l, l = l + wi | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, nr = l << 12 | b >>> 20, a = n, K = n << 12 | l >>> 20, gr = t[P + 5392 >> 2], b = or & -2, l = gr + b | 0, kr = t[P + 5396 >> 2], n = kr + (tr & 1048575) | 0, or = l >>> 0 < b >>> 0 ? n + 1 | 0 : n, n = or + K | 0, tr = l, b = l + nr | 0, t[Ti >> 2] = b, l = l >>> 0 > b >>> 0 ? n + 1 | 0 : n, t[Ti + 4 >> 2] = l & 1048575, Nr = Qi + 32 | 0, lr = Nr, K = pe, nr = Me & 65535, Me = (l | 0) == (or | 0) & b >>> 0 < tr >>> 0 | l >>> 0 < or >>> 0, b = (or | 0) == (kr | 0) & tr >>> 0 < gr >>> 0 | or >>> 0 < kr >>> 0, n = Yr + 8 | 0, pe = b + t[n >> 2] | 0, n = t[n + 4 >> 2], n = b >>> 0 > pe >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, b = a, a = a + pe | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, b = a, a = a + Me | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, l = a << 12 | l >>> 20, b = l + K | 0, n = nr + (n << 12 | a >>> 20) | 0, t[lr >> 2] = b, t[lr + 4 >> 2] = l >>> 0 > b >>> 0 ? n + 1 | 0 : n, t[P + 7496 >> 2] = Ce, t[P + 7500 >> 2] = Tt & 1048575, zr(Qi, Qi, ns), l = t[P + 7500 >> 2], ai = l, Yr = t[P + 7496 >> 2], K = Yr, n = l << 1 | K >>> 31, lr = P + 5216 | 0, tr = t[Ti >> 2], Me = t[Ti + 4 >> 2], ei = K << 1, wi = n, Pr(lr, tr, Me, 0, 0, ei, n, 0, 0), l = t[Ei + 4 >> 2], es = l, Wi = t[Ei >> 2], a = Wi, n = l << 1 | a >>> 31, gr = P + 5312 | 0, nr = t[Ii >> 2], Ce = t[Ii + 4 >> 2], a = a << 1, b = n, Pr(gr, nr, Ce, 0, 0, a, n, 0, 0), or = P + 5200 | 0, pe = t[Nr >> 2], l = t[Nr + 4 >> 2], Pr(or, pe, l, 0, 0, pe, l, 0, 0), Tt = P + 5184 | 0, Pr(Tt, t[P + 5200 >> 2], t[P + 5204 >> 2], 0, 0, 15632, 16, 0, 0), n = l << 1 | pe >>> 31, Mn = P + 5152 | 0, di = pe << 1, kr = n, Pr(Mn, di, n, 0, 0, K, ai, 0, 0), Dn = P + 5232 | 0, Pr(Dn, tr, Me, 0, 0, a, b, 0, 0), $i = P + 5296 | 0, Pr($i, nr, Ce, 0, 0, nr, Ce, 0, 0), Ti = P + 5168 | 0, l = or + 8 | 0, Pr(Ti, t[l >> 2], t[l + 4 >> 2], 0, 0, 64028672, 65536, 0, 0), In = P + 5360 | 0, Pr(In, K, ai, 0, 0, K, ai, 0, 0), Li = P + 5136 | 0, Pr(Li, di, n, 0, 0, Wi, es, 0, 0), kn = P + 5248 | 0, Pr(kn, tr, Me, 0, 0, nr << 1, Ce << 1 | nr >>> 31, 0, 0), Yr = t[P + 5220 >> 2], n = Yr + t[P + 5316 >> 2] | 0, pe = t[P + 5216 >> 2], a = t[P + 5312 >> 2], l = pe + a | 0, b = t[P + 5184 >> 2], Nr = l + b | 0, a = l >>> 0 < a >>> 0 ? n + 1 | 0 : n, n = a + t[P + 5188 >> 2] | 0, b = b >>> 0 > Nr >>> 0 ? n + 1 | 0 : n, or = (a | 0) == (b | 0) & l >>> 0 > Nr >>> 0 | a >>> 0 > b >>> 0, n = Tt + 8 | 0, Tt = t[n >> 2], K = t[n + 4 >> 2], pe = (a | 0) == (Yr | 0) & l >>> 0 < pe >>> 0 | a >>> 0 < Yr >>> 0, n = gr + 8 | 0, a = t[n >> 2], l = lr + 8 | 0, gr = a + t[l >> 2] | 0, n = t[l + 4 >> 2] + t[n + 4 >> 2] | 0, n = a >>> 0 > gr >>> 0 ? n + 1 | 0 : n, l = pe + gr | 0, n = (l >>> 0 < gr >>> 0 ? n + 1 | 0 : n) + K | 0, a = l, l = l + Tt | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = l, l = l + or | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, lr = b, Tt = l << 12 | b >>> 20, a = n, pe = n << 12 | l >>> 20, Qi = t[P + 5232 >> 2], l = t[P + 5296 >> 2], or = Qi + l | 0, Xi = t[P + 5236 >> 2], n = Xi + t[P + 5300 >> 2] | 0, n = l >>> 0 > or >>> 0 ? n + 1 | 0 : n, l = t[P + 5152 >> 2], K = l + or | 0, Yr = n, n = n + t[P + 5156 >> 2] | 0, n = l >>> 0 > K >>> 0 ? n + 1 | 0 : n, l = t[P + 5168 >> 2], b = l + K | 0, gr = n, n = n + t[P + 5172 >> 2] | 0, l = l >>> 0 > b >>> 0 ? n + 1 | 0 : n, n = l + pe | 0, Ki = P + 5120 | 0, Di = Ki, Tt = b + Tt | 0, pe = Tt >>> 0 < b >>> 0 ? n + 1 | 0 : n, Ei = (l | 0) == (pe | 0) & b >>> 0 > Tt >>> 0 | l >>> 0 > pe >>> 0, Ii = (l | 0) == (gr | 0) & b >>> 0 < K >>> 0 | l >>> 0 < gr >>> 0, l = Ti + 8 | 0, ui = t[l >> 2], jr = t[l + 4 >> 2], ai = (gr | 0) == (Yr | 0) & K >>> 0 < or >>> 0 | gr >>> 0 < Yr >>> 0, l = Mn + 8 | 0, Ti = t[l >> 2], gr = t[l + 4 >> 2], K = (Yr | 0) == (Xi | 0) & or >>> 0 < Qi >>> 0 | Yr >>> 0 < Xi >>> 0, n = $i + 8 | 0, b = t[n >> 2], l = Dn + 8 | 0, or = b + t[l >> 2] | 0, n = t[l + 4 >> 2] + t[n + 4 >> 2] | 0, n = b >>> 0 > or >>> 0 ? n + 1 | 0 : n, l = K + or | 0, n = (l >>> 0 < or >>> 0 ? n + 1 | 0 : n) + gr | 0, b = l, l = l + Ti | 0, n = b >>> 0 > l >>> 0 ? n + 1 | 0 : n, b = l, l = l + ai | 0, n = (b >>> 0 > l >>> 0 ? n + 1 | 0 : n) + jr | 0, b = l, l = l + ui | 0, n = b >>> 0 > l >>> 0 ? n + 1 | 0 : n, b = l + Ii | 0, n = b >>> 0 < l >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, l = a + b | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = l, l = l + Ei | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = pe, K = l << 12 | a >>> 20, b = n, pe = n << 12 | l >>> 20, jr = t[P + 5136 >> 2], l = t[P + 5248 >> 2], or = jr + l | 0, ui = t[P + 5140 >> 2], n = ui + t[P + 5252 >> 2] | 0, l = l >>> 0 > or >>> 0 ? n + 1 | 0 : n, n = l + pe | 0, K = K + or | 0, n = K >>> 0 < or >>> 0 ? n + 1 | 0 : n, Ti = K << 4 & -16, pe = n, Yr = (n << 4 | K >>> 28) & 16777215, gr = a, Pr(Di, Ti | a >>> 16 & 15, Yr, 0, 0, 977, 1, 0, 0), Di = P + 5344 | 0, Pr(Di, Wi, es, 0, 0, ei, wi, 0, 0), Ii = P + 5088 | 0, Pr(Ii, di, kr, 0, 0, nr, Ce, 0, 0), ai = P + 5264 | 0, Pr(ai, tr, Me, 0, 0, tr, Me, 0, 0), Ti = P + 5072 | 0, Yr = (l | 0) == (n | 0) & K >>> 0 < or >>> 0 | l >>> 0 > n >>> 0, K = (l | 0) == (ui | 0) & or >>> 0 < jr >>> 0 | l >>> 0 < ui >>> 0, n = kn + 8 | 0, a = t[n >> 2], l = Li + 8 | 0, or = a + t[l >> 2] | 0, n = t[l + 4 >> 2] + t[n + 4 >> 2] | 0, n = a >>> 0 > or >>> 0 ? n + 1 | 0 : n, a = K + or | 0, n = a >>> 0 < or >>> 0 ? n + 1 | 0 : n, b = b >>> 20 | 0, l = a + b | 0, n = b >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = l, l = l + Yr | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, pe = l << 12 | pe >>> 20, a = n, b = n << 12 | l >>> 20, Yr = t[P + 5088 >> 2], l = t[P + 5264 >> 2], K = Yr + l | 0, Ei = t[P + 5092 >> 2], n = Ei + t[P + 5268 >> 2] | 0, l = l >>> 0 > K >>> 0 ? n + 1 | 0 : n, n = l + b | 0, pe = K + pe | 0, n = pe >>> 0 < K >>> 0 ? n + 1 | 0 : n, b = n, Pr(Ti, pe, n & 1048575, 0, 0, 15632, 16, 0, 0), ui = P + 5280 | 0, Pr(ui, nr, Ce, 0, 0, ei, wi, 0, 0), jr = P + 5328 | 0, Pr(jr, Wi, es, 0, 0, Wi, es, 0, 0), or = P + 5024 | 0, Pr(or, di, kr, 0, 0, tr, Me, 0, 0), ei = P + 5008 | 0, Me = ei, Ce = (l | 0) == (n | 0) & K >>> 0 > pe >>> 0 | l >>> 0 > n >>> 0, K = (l | 0) == (Ei | 0) & K >>> 0 < Yr >>> 0 | l >>> 0 < Ei >>> 0, n = ai + 8 | 0, pe = t[n >> 2], l = Ii + 8 | 0, tr = pe + t[l >> 2] | 0, n = t[l + 4 >> 2] + t[n + 4 >> 2] | 0, n = pe >>> 0 > tr >>> 0 ? n + 1 | 0 : n, pe = K + tr | 0, n = pe >>> 0 < tr >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, l = a + pe | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = l, l = l + Ce | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, pe = l << 12 | b >>> 20, b = t[P + 5024 >> 2], Ce = pe + b | 0, a = n, l = n << 12 | l >>> 20, n = l + t[P + 5028 >> 2] | 0, n = b >>> 0 > Ce >>> 0 ? n + 1 | 0 : n, Pr(Me, Ce, n, 0, 0, 15632, 16, 0, 0), Ei = P + 4944 | 0, K = Ei, pe = (l | 0) == (n | 0) & pe >>> 0 > Ce >>> 0 | l >>> 0 > n >>> 0, l = or + 8 | 0, b = t[l >> 2], n = t[l + 4 >> 2], a = a >>> 20 | 0, l = a + b | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = l, l = l + pe | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, Pr(K, l, n, 0, 0, 64028672, 65536, 0, 0), a = t[P + 5120 >> 2], l = t[P + 5360 >> 2], K = a + l | 0, pe = t[P + 5124 >> 2], n = pe + t[P + 5364 >> 2] | 0, b = l >>> 0 > K >>> 0 ? n + 1 | 0 : n, pe = (pe | 0) == (b | 0) & a >>> 0 > K >>> 0 | b >>> 0 < pe >>> 0, n = In + 8 | 0, a = t[n >> 2], l = Ki + 8 | 0, Ce = a + t[l >> 2] | 0, n = t[l + 4 >> 2] + t[n + 4 >> 2] | 0, n = a >>> 0 > Ce >>> 0 ? n + 1 | 0 : n, l = pe + Ce | 0, n = l >>> 0 < Ce >>> 0 ? n + 1 | 0 : n, nr = b, pe = l << 12 | b >>> 20, a = n, b = n << 12 | l >>> 20, Me = t[P + 5072 >> 2], l = t[P + 5344 >> 2], Ce = Me + l | 0, or = t[P + 5076 >> 2], n = or + t[P + 5348 >> 2] | 0, l = l >>> 0 > Ce >>> 0 ? n + 1 | 0 : n, n = l + b | 0, pe = pe + Ce | 0, b = pe >>> 0 < Ce >>> 0 ? n + 1 | 0 : n, tr = (l | 0) == (b | 0) & pe >>> 0 < Ce >>> 0 | l >>> 0 > b >>> 0, Me = (l | 0) == (or | 0) & Ce >>> 0 < Me >>> 0 | l >>> 0 < or >>> 0, n = Di + 8 | 0, Ce = t[n >> 2], l = Ti + 8 | 0, or = Ce + t[l >> 2] | 0, n = t[l + 4 >> 2] + t[n + 4 >> 2] | 0, n = Ce >>> 0 > or >>> 0 ? n + 1 | 0 : n, Ce = Me + or | 0, n = Ce >>> 0 < or >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, l = a + Ce | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = l, l = l + tr | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, or = b, Ce = l << 12 | b >>> 20, a = n, b = n << 12 | l >>> 20, ai = t[P + 5280 >> 2], l = t[P + 5328 >> 2], tr = ai + l | 0, Di = t[P + 5284 >> 2], n = Di + t[P + 5332 >> 2] | 0, n = l >>> 0 > tr >>> 0 ? n + 1 | 0 : n, l = t[P + 5008 >> 2], Me = l + tr | 0, kr = n, n = n + t[P + 5012 >> 2] | 0, l = l >>> 0 > Me >>> 0 ? n + 1 | 0 : n, n = l + b | 0, Ii = P + 4928 | 0, Ti = Ii, b = Ce + Me | 0, Ce = b >>> 0 < Me >>> 0 ? n + 1 | 0 : n, Yr = (l | 0) == (Ce | 0) & b >>> 0 < Me >>> 0 | l >>> 0 > Ce >>> 0, di = (l | 0) == (kr | 0) & Me >>> 0 < tr >>> 0 | l >>> 0 < kr >>> 0, l = ei + 8 | 0, wi = t[l >> 2], ei = t[l + 4 >> 2], tr = (kr | 0) == (Di | 0) & tr >>> 0 < ai >>> 0 | kr >>> 0 < Di >>> 0, n = jr + 8 | 0, Me = t[n >> 2], l = ui + 8 | 0, kr = Me + t[l >> 2] | 0, n = t[l + 4 >> 2] + t[n + 4 >> 2] | 0, n = Me >>> 0 > kr >>> 0 ? n + 1 | 0 : n, l = tr + kr | 0, n = (l >>> 0 < kr >>> 0 ? n + 1 | 0 : n) + ei | 0, tr = l, l = l + wi | 0, n = tr >>> 0 > l >>> 0 ? n + 1 | 0 : n, Me = l + di | 0, n = Me >>> 0 < l >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, l = a + Me | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = l, l = l + Yr | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, Me = Ce, tr = l << 12 | Ce >>> 20, a = n, kr = n << 12 | l >>> 20, Di = t[P + 4948 >> 2], n = Di + (lr & 1048575) | 0, ai = t[P + 4944 >> 2], l = Nr & -2, Ce = ai + l | 0, lr = Ce, tr = Ce + tr | 0, l = l >>> 0 > Ce >>> 0 ? n + 1 | 0 : n, n = l + kr | 0, Ce = tr >>> 0 < Ce >>> 0 ? n + 1 | 0 : n, kr = Ce & 1048575, n = nr & 1048575, Ki = n, nr = K, n = n << 1 | K >>> 31, wi = K << 1, di = n, Pr(Ti, tr, kr, 0, 0, wi, n, 0, 0), n = or & 1048575, Wi = n, ui = P + 4960 | 0, Nr = Me & 1048575, K = pe << 1, Ti = pe, Me = n << 1 | pe >>> 31, Pr(ui, b, Nr, 0, 0, K, Me, 0, 0), jr = P + 4864 | 0, Yr = jr, ei = gr & 65535, gr = (l | 0) == (Ce | 0) & tr >>> 0 < lr >>> 0 | l >>> 0 > Ce >>> 0, or = (l | 0) == (Di | 0) & lr >>> 0 < ai >>> 0 | l >>> 0 < Di >>> 0, l = Ei + 8 | 0, pe = or + t[l >> 2] | 0, n = t[l + 4 >> 2], n = pe >>> 0 < or >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, l = a + pe | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = l, l = l + gr | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, pe = l << 12 | Ce >>> 20, a = pe + Tt | 0, n = ei + (n << 12 | l >>> 20) | 0, n = a >>> 0 < pe >>> 0 ? n + 1 | 0 : n, Pr(Yr, a, n, 0, 0, a, n, 0, 0), Tt = P + 4848 | 0, Pr(Tt, t[P + 4864 >> 2], t[P + 4868 >> 2], 0, 0, 15632, 16, 0, 0), l = a, n = n << 1 | l >>> 31, Mn = P + 4816 | 0, Yr = l << 1, ei = n, Pr(Mn, Yr, n, 0, 0, nr, Ki, 0, 0), Dn = P + 4912 | 0, Pr(Dn, tr, kr, 0, 0, K, Me, 0, 0), $i = P + 4976 | 0, Pr($i, b, Nr, 0, 0, b, Nr, 0, 0), ai = P + 4832 | 0, l = jr + 8 | 0, Pr(ai, t[l >> 2], t[l + 4 >> 2], 0, 0, 64028672, 65536, 0, 0), In = P + 5104 | 0, Pr(In, nr, Ki, 0, 0, nr, Ki, 0, 0), Li = P + 4800 | 0, Pr(Li, Yr, n, 0, 0, Ti, Wi, 0, 0), kn = P + 4880 | 0, Me = kr, Ce = Nr, kr = b, Pr(kn, tr, Me, 0, 0, b << 1, Ce << 1 | b >>> 31, 0, 0), pe = t[P + 4928 >> 2], a = t[P + 4960 >> 2], l = pe + a | 0, nr = t[P + 4932 >> 2], n = nr + t[P + 4964 >> 2] | 0, n = l >>> 0 < a >>> 0 ? n + 1 | 0 : n, a = t[P + 4848 >> 2], Nr = a + l | 0, b = n, n = n + t[P + 4852 >> 2] | 0, a = a >>> 0 > Nr >>> 0 ? n + 1 | 0 : n, or = (b | 0) == (a | 0) & l >>> 0 > Nr >>> 0 | a >>> 0 < b >>> 0, n = Tt + 8 | 0, Tt = t[n >> 2], K = t[n + 4 >> 2], pe = (b | 0) == (nr | 0) & l >>> 0 < pe >>> 0 | b >>> 0 < nr >>> 0, n = ui + 8 | 0, b = t[n >> 2], l = Ii + 8 | 0, nr = b + t[l >> 2] | 0, n = t[l + 4 >> 2] + t[n + 4 >> 2] | 0, n = b >>> 0 > nr >>> 0 ? n + 1 | 0 : n, l = pe + nr | 0, n = (l >>> 0 < nr >>> 0 ? n + 1 | 0 : n) + K | 0, b = l, l = l + Tt | 0, n = b >>> 0 > l >>> 0 ? n + 1 | 0 : n, b = l, l = l + or | 0, n = b >>> 0 > l >>> 0 ? n + 1 | 0 : n, lr = a, Tt = l << 12 | a >>> 20, b = n, pe = n << 12 | l >>> 20, Qi = t[P + 4912 >> 2], l = t[P + 4976 >> 2], nr = Qi + l | 0, Xi = t[P + 4916 >> 2], n = Xi + t[P + 4980 >> 2] | 0, n = l >>> 0 > nr >>> 0 ? n + 1 | 0 : n, l = t[P + 4816 >> 2], or = l + nr | 0, a = n, n = n + t[P + 4820 >> 2] | 0, n = l >>> 0 > or >>> 0 ? n + 1 | 0 : n, l = t[P + 4832 >> 2], K = l + or | 0, gr = n, n = n + t[P + 4836 >> 2] | 0, l = l >>> 0 > K >>> 0 ? n + 1 | 0 : n, n = l + pe | 0, Ki = P + 4704 | 0, Di = Ki, Tt = K + Tt | 0, pe = Tt >>> 0 < K >>> 0 ? n + 1 | 0 : n, Ei = (l | 0) == (pe | 0) & K >>> 0 > Tt >>> 0 | l >>> 0 > pe >>> 0, Ii = (l | 0) == (gr | 0) & K >>> 0 < or >>> 0 | l >>> 0 < gr >>> 0, l = ai + 8 | 0, ui = t[l >> 2], jr = t[l + 4 >> 2], ai = (a | 0) == (gr | 0) & nr >>> 0 > or >>> 0 | a >>> 0 > gr >>> 0, l = Mn + 8 | 0, gr = t[l >> 2], or = t[l + 4 >> 2], K = (a | 0) == (Xi | 0) & nr >>> 0 < Qi >>> 0 | a >>> 0 < Xi >>> 0, n = $i + 8 | 0, a = t[n >> 2], l = Dn + 8 | 0, nr = a + t[l >> 2] | 0, n = t[l + 4 >> 2] + t[n + 4 >> 2] | 0, n = a >>> 0 > nr >>> 0 ? n + 1 | 0 : n, l = K + nr | 0, n = (l >>> 0 < nr >>> 0 ? n + 1 | 0 : n) + or | 0, a = l, l = l + gr | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = l, l = l + ai | 0, n = (a >>> 0 > l >>> 0 ? n + 1 | 0 : n) + jr | 0, a = l, l = l + ui | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = l + Ii | 0, n = a >>> 0 < l >>> 0 ? n + 1 | 0 : n, b = b >>> 20 | 0, l = a + b | 0, n = b >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = l, l = l + Ei | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = pe, K = l << 12 | a >>> 20, b = n, pe = n << 12 | l >>> 20, jr = t[P + 4800 >> 2], l = t[P + 4880 >> 2], or = jr + l | 0, ui = t[P + 4804 >> 2], n = ui + t[P + 4884 >> 2] | 0, l = l >>> 0 > or >>> 0 ? n + 1 | 0 : n, n = l + pe | 0, K = K + or | 0, n = K >>> 0 < or >>> 0 ? n + 1 | 0 : n, ai = K << 4 & -16, pe = n, nr = (n << 4 | K >>> 28) & 16777215, gr = a, Pr(Di, ai | a >>> 16 & 15, nr, 0, 0, 977, 1, 0, 0), Di = P + 5040 | 0, Pr(Di, Ti, Wi, 0, 0, wi, di, 0, 0), Ei = P + 4784 | 0, Pr(Ei, Yr, ei, 0, 0, kr, Ce, 0, 0), Ii = P + 4896 | 0, Pr(Ii, tr, Me, 0, 0, tr, Me, 0, 0), ai = P + 4768 | 0, nr = (l | 0) == (n | 0) & K >>> 0 < or >>> 0 | l >>> 0 > n >>> 0, K = (l | 0) == (ui | 0) & or >>> 0 < jr >>> 0 | l >>> 0 < ui >>> 0, n = kn + 8 | 0, a = t[n >> 2], l = Li + 8 | 0, or = a + t[l >> 2] | 0, n = t[l + 4 >> 2] + t[n + 4 >> 2] | 0, n = a >>> 0 > or >>> 0 ? n + 1 | 0 : n, a = K + or | 0, n = a >>> 0 < or >>> 0 ? n + 1 | 0 : n, b = b >>> 20 | 0, l = a + b | 0, n = b >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = l, l = l + nr | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, pe = l << 12 | pe >>> 20, a = n, b = n << 12 | l >>> 20, nr = t[P + 4784 >> 2], l = t[P + 4896 >> 2], K = nr + l | 0, Qi = t[P + 4788 >> 2], n = Qi + t[P + 4900 >> 2] | 0, l = l >>> 0 > K >>> 0 ? n + 1 | 0 : n, n = l + b | 0, pe = K + pe | 0, n = pe >>> 0 < K >>> 0 ? n + 1 | 0 : n, b = n, Pr(ai, pe, n & 1048575, 0, 0, 15632, 16, 0, 0), ui = P + 4992 | 0, Pr(ui, kr, Ce, 0, 0, wi, di, 0, 0), jr = P + 5056 | 0, Pr(jr, Ti, Wi, 0, 0, Ti, Wi, 0, 0), or = P + 4752 | 0, Pr(or, tr, Me, 0, 0, Yr, ei, 0, 0), ei = P + 4736 | 0, Me = ei, Ce = (l | 0) == (n | 0) & K >>> 0 > pe >>> 0 | l >>> 0 > n >>> 0, K = (l | 0) == (Qi | 0) & K >>> 0 < nr >>> 0 | l >>> 0 < Qi >>> 0, n = Ii + 8 | 0, pe = t[n >> 2], l = Ei + 8 | 0, tr = pe + t[l >> 2] | 0, n = t[l + 4 >> 2] + t[n + 4 >> 2] | 0, n = pe >>> 0 > tr >>> 0 ? n + 1 | 0 : n, pe = K + tr | 0, n = pe >>> 0 < tr >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, l = a + pe | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = l, l = l + Ce | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, pe = l << 12 | b >>> 20, b = t[P + 4752 >> 2], Ce = pe + b | 0, a = n, l = n << 12 | l >>> 20, n = l + t[P + 4756 >> 2] | 0, n = b >>> 0 > Ce >>> 0 ? n + 1 | 0 : n, Pr(Me, Ce, n, 0, 0, 15632, 16, 0, 0), Ei = P + 4720 | 0, K = Ei, pe = (l | 0) == (n | 0) & pe >>> 0 > Ce >>> 0 | l >>> 0 > n >>> 0, l = or + 8 | 0, b = t[l >> 2], n = t[l + 4 >> 2], a = a >>> 20 | 0, l = a + b | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = l, l = l + pe | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, Pr(K, l, n, 0, 0, 64028672, 65536, 0, 0), a = t[P + 4704 >> 2], l = t[P + 5104 >> 2], K = a + l | 0, pe = t[P + 4708 >> 2], n = pe + t[P + 5108 >> 2] | 0, b = l >>> 0 > K >>> 0 ? n + 1 | 0 : n, pe = (pe | 0) == (b | 0) & a >>> 0 > K >>> 0 | b >>> 0 < pe >>> 0, n = In + 8 | 0, a = t[n >> 2], l = Ki + 8 | 0, Ce = a + t[l >> 2] | 0, n = t[l + 4 >> 2] + t[n + 4 >> 2] | 0, n = a >>> 0 > Ce >>> 0 ? n + 1 | 0 : n, l = pe + Ce | 0, n = l >>> 0 < Ce >>> 0 ? n + 1 | 0 : n, nr = b, pe = l << 12 | b >>> 20, a = n, tr = n << 12 | l >>> 20, or = t[P + 4772 >> 2], n = or + t[P + 5044 >> 2] | 0, Me = t[P + 4768 >> 2], l = t[P + 5040 >> 2], b = Me + l | 0, Ce = b, pe = b + pe | 0, l = l >>> 0 > b >>> 0 ? n + 1 | 0 : n, n = l + tr | 0, b = pe >>> 0 < b >>> 0 ? n + 1 | 0 : n, tr = (l | 0) == (b | 0) & pe >>> 0 < Ce >>> 0 | l >>> 0 > b >>> 0, Me = (l | 0) == (or | 0) & Ce >>> 0 < Me >>> 0 | l >>> 0 < or >>> 0, n = Di + 8 | 0, Ce = t[n >> 2], l = ai + 8 | 0, or = Ce + t[l >> 2] | 0, n = t[l + 4 >> 2] + t[n + 4 >> 2] | 0, n = Ce >>> 0 > or >>> 0 ? n + 1 | 0 : n, Ce = Me + or | 0, n = Ce >>> 0 < or >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, l = a + Ce | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = l, l = l + tr | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, or = b, Ce = l << 12 | b >>> 20, a = n, b = n << 12 | l >>> 20, ai = t[P + 4992 >> 2], l = t[P + 5056 >> 2], tr = ai + l | 0, Di = t[P + 4996 >> 2], n = Di + t[P + 5060 >> 2] | 0, n = l >>> 0 > tr >>> 0 ? n + 1 | 0 : n, l = t[P + 4736 >> 2], Me = l + tr | 0, kr = n, n = n + t[P + 4740 >> 2] | 0, l = l >>> 0 > Me >>> 0 ? n + 1 | 0 : n, n = l + b | 0, Ii = P + 4624 | 0, Ti = Ii, b = Ce + Me | 0, Ce = b >>> 0 < Me >>> 0 ? n + 1 | 0 : n, Yr = (l | 0) == (Ce | 0) & b >>> 0 < Me >>> 0 | l >>> 0 > Ce >>> 0, di = (l | 0) == (kr | 0) & Me >>> 0 < tr >>> 0 | l >>> 0 < kr >>> 0, l = ei + 8 | 0, wi = t[l >> 2], ei = t[l + 4 >> 2], tr = (kr | 0) == (Di | 0) & tr >>> 0 < ai >>> 0 | kr >>> 0 < Di >>> 0, n = jr + 8 | 0, Me = t[n >> 2], l = ui + 8 | 0, kr = Me + t[l >> 2] | 0, n = t[l + 4 >> 2] + t[n + 4 >> 2] | 0, n = Me >>> 0 > kr >>> 0 ? n + 1 | 0 : n, l = tr + kr | 0, n = (l >>> 0 < kr >>> 0 ? n + 1 | 0 : n) + ei | 0, tr = l, l = l + wi | 0, n = tr >>> 0 > l >>> 0 ? n + 1 | 0 : n, Me = l + di | 0, n = Me >>> 0 < l >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, l = a + Me | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = l, l = l + Yr | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, Me = Ce, kr = l << 12 | Ce >>> 20, a = n, tr = n << 12 | l >>> 20, Di = t[P + 4724 >> 2], n = Di + (lr & 1048575) | 0, ai = t[P + 4720 >> 2], Ce = Nr & -2, l = ai + Ce | 0, lr = l, l = l >>> 0 < Ce >>> 0 ? n + 1 | 0 : n, n = l + tr | 0, tr = lr + kr | 0, Ce = tr >>> 0 < lr >>> 0 ? n + 1 | 0 : n, Yr = Ce & 1048575, Nr = Yr, n = nr & 1048575, Ki = n, nr = K, n = n << 1 | K >>> 31, ei = K << 1, wi = n, Pr(Ti, tr, Nr, 0, 0, ei, n, 0, 0), n = or & 1048575, Wi = n, ui = P + 4576 | 0, Nr = Me & 1048575, K = pe << 1, Ti = pe, Me = n << 1 | pe >>> 31, Pr(ui, b, Nr, 0, 0, K, Me, 0, 0), jr = P + 4528 | 0, kr = gr & 65535, gr = (l | 0) == (Ce | 0) & tr >>> 0 < lr >>> 0 | l >>> 0 > Ce >>> 0, or = (l | 0) == (Di | 0) & lr >>> 0 < ai >>> 0 | l >>> 0 < Di >>> 0, l = Ei + 8 | 0, pe = or + t[l >> 2] | 0, n = t[l + 4 >> 2], n = pe >>> 0 < or >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, l = a + pe | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = l, l = l + gr | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, pe = l << 12 | Ce >>> 20, a = pe + Tt | 0, n = kr + (n << 12 | l >>> 20) | 0, n = a >>> 0 < pe >>> 0 ? n + 1 | 0 : n, Pr(jr, a, n, 0, 0, a, n, 0, 0), Tt = P + 4512 | 0, Pr(Tt, t[P + 4528 >> 2], t[P + 4532 >> 2], 0, 0, 15632, 16, 0, 0), l = a, n = n << 1 | l >>> 31, Mn = P + 4480 | 0, di = l << 1, kr = n, Pr(Mn, di, n, 0, 0, nr, Ki, 0, 0), Dn = P + 4560 | 0, Pr(Dn, tr, Yr, 0, 0, K, Me, 0, 0), $i = P + 4672 | 0, Pr($i, b, Nr, 0, 0, b, Nr, 0, 0), ai = P + 4496 | 0, l = jr + 8 | 0, Pr(ai, t[l >> 2], t[l + 4 >> 2], 0, 0, 64028672, 65536, 0, 0), In = P + 4640 | 0, Pr(In, nr, Ki, 0, 0, nr, Ki, 0, 0), Li = P + 4464 | 0, Pr(Li, di, n, 0, 0, Ti, Wi, 0, 0), kn = P + 4544 | 0, gr = tr, nr = Yr, Ce = Nr, Nr = b, Pr(kn, tr, nr, 0, 0, b << 1, Ce << 1 | b >>> 31, 0, 0), pe = t[P + 4624 >> 2], a = t[P + 4576 >> 2], l = pe + a | 0, tr = t[P + 4628 >> 2], n = tr + t[P + 4580 >> 2] | 0, n = l >>> 0 < a >>> 0 ? n + 1 | 0 : n, a = t[P + 4512 >> 2], or = a + l | 0, b = n, n = n + t[P + 4516 >> 2] | 0, a = a >>> 0 > or >>> 0 ? n + 1 | 0 : n, Me = (b | 0) == (a | 0) & l >>> 0 > or >>> 0 | a >>> 0 < b >>> 0, n = Tt + 8 | 0, Tt = t[n >> 2], K = t[n + 4 >> 2], pe = (b | 0) == (tr | 0) & l >>> 0 < pe >>> 0 | b >>> 0 < tr >>> 0, n = ui + 8 | 0, b = t[n >> 2], l = Ii + 8 | 0, tr = b + t[l >> 2] | 0, n = t[l + 4 >> 2] + t[n + 4 >> 2] | 0, n = b >>> 0 > tr >>> 0 ? n + 1 | 0 : n, l = pe + tr | 0, n = (l >>> 0 < tr >>> 0 ? n + 1 | 0 : n) + K | 0, b = l, l = l + Tt | 0, n = b >>> 0 > l >>> 0 ? n + 1 | 0 : n, b = l, l = l + Me | 0, n = b >>> 0 > l >>> 0 ? n + 1 | 0 : n, tr = a, K = l << 12 | a >>> 20, b = n, pe = n << 12 | l >>> 20, Qi = t[P + 4560 >> 2], l = t[P + 4672 >> 2], lr = Qi + l | 0, Xi = t[P + 4564 >> 2], n = Xi + t[P + 4676 >> 2] | 0, n = l >>> 0 > lr >>> 0 ? n + 1 | 0 : n, l = t[P + 4480 >> 2], Me = l + lr | 0, a = n, n = n + t[P + 4484 >> 2] | 0, n = l >>> 0 > Me >>> 0 ? n + 1 | 0 : n, l = t[P + 4496 >> 2], Tt = l + Me | 0, Yr = n, n = n + t[P + 4500 >> 2] | 0, l = l >>> 0 > Tt >>> 0 ? n + 1 | 0 : n, n = l + pe | 0, Ki = P + 4368 | 0, Di = Ki, pe = K + Tt | 0, K = pe >>> 0 < Tt >>> 0 ? n + 1 | 0 : n, Ei = (l | 0) == (K | 0) & pe >>> 0 < Tt >>> 0 | l >>> 0 > K >>> 0, Ii = (l | 0) == (Yr | 0) & Me >>> 0 > Tt >>> 0 | l >>> 0 < Yr >>> 0, l = ai + 8 | 0, ui = t[l >> 2], jr = t[l + 4 >> 2], ai = (a | 0) == (Yr | 0) & Me >>> 0 < lr >>> 0 | a >>> 0 > Yr >>> 0, l = Mn + 8 | 0, Yr = t[l >> 2], Me = t[l + 4 >> 2], Tt = (a | 0) == (Xi | 0) & lr >>> 0 < Qi >>> 0 | a >>> 0 < Xi >>> 0, n = $i + 8 | 0, a = t[n >> 2], l = Dn + 8 | 0, lr = a + t[l >> 2] | 0, n = t[l + 4 >> 2] + t[n + 4 >> 2] | 0, n = a >>> 0 > lr >>> 0 ? n + 1 | 0 : n, l = Tt + lr | 0, n = (l >>> 0 < lr >>> 0 ? n + 1 | 0 : n) + Me | 0, a = l, l = l + Yr | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = l, l = l + ai | 0, n = (a >>> 0 > l >>> 0 ? n + 1 | 0 : n) + jr | 0, a = l, l = l + ui | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = l + Ii | 0, n = a >>> 0 < l >>> 0 ? n + 1 | 0 : n, b = b >>> 20 | 0, l = a + b | 0, n = b >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = l, l = l + Ei | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = K, Tt = l << 12 | a >>> 20, b = n, K = n << 12 | l >>> 20, jr = t[P + 4464 >> 2], l = t[P + 4544 >> 2], lr = jr + l | 0, Qi = t[P + 4468 >> 2], n = Qi + t[P + 4548 >> 2] | 0, l = l >>> 0 > lr >>> 0 ? n + 1 | 0 : n, n = l + K | 0, Tt = Tt + lr | 0, n = Tt >>> 0 < lr >>> 0 ? n + 1 | 0 : n, ai = Tt << 4 & -16, K = n, Yr = (n << 4 | Tt >>> 28) & 16777215, Me = a, Pr(Di, ai | a >>> 16 & 15, Yr, 0, 0, 977, 1, 0, 0), Di = P + 4608 | 0, Pr(Di, Ti, Wi, 0, 0, ei, wi, 0, 0), Ei = P + 4448 | 0, Pr(Ei, di, kr, 0, 0, Nr, Ce, 0, 0), Ii = P + 4688 | 0, Pr(Ii, gr, nr, 0, 0, gr, nr, 0, 0), ui = P + 4432 | 0, ai = ui, Yr = (l | 0) == (n | 0) & Tt >>> 0 < lr >>> 0 | l >>> 0 > n >>> 0, Tt = (l | 0) == (Qi | 0) & lr >>> 0 < jr >>> 0 | l >>> 0 < Qi >>> 0, n = kn + 8 | 0, a = t[n >> 2], l = Li + 8 | 0, lr = a + t[l >> 2] | 0, n = t[l + 4 >> 2] + t[n + 4 >> 2] | 0, n = a >>> 0 > lr >>> 0 ? n + 1 | 0 : n, a = Tt + lr | 0, n = a >>> 0 < lr >>> 0 ? n + 1 | 0 : n, b = b >>> 20 | 0, l = a + b | 0, n = b >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = l, l = l + Yr | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, K = l << 12 | K >>> 20, a = n, b = n << 12 | l >>> 20, Yr = t[P + 4448 >> 2], l = t[P + 4688 >> 2], Tt = Yr + l | 0, Qi = t[P + 4452 >> 2], n = Qi + t[P + 4692 >> 2] | 0, l = l >>> 0 > Tt >>> 0 ? n + 1 | 0 : n, n = l + b | 0, K = K + Tt | 0, n = K >>> 0 < Tt >>> 0 ? n + 1 | 0 : n, b = n, Pr(ai, K, n & 1048575, 0, 0, 15632, 16, 0, 0), jr = P + 4592 | 0, Pr(jr, Nr, Ce, 0, 0, ei, wi, 0, 0), ai = P + 4656 | 0, Pr(ai, Ti, Wi, 0, 0, Ti, Wi, 0, 0), lr = P + 4416 | 0, Pr(lr, gr, nr, 0, 0, di, kr, 0, 0), Nr = P + 4400 | 0, nr = Nr, Ce = (l | 0) == (n | 0) & K >>> 0 < Tt >>> 0 | l >>> 0 > n >>> 0, Tt = (l | 0) == (Qi | 0) & Tt >>> 0 < Yr >>> 0 | l >>> 0 < Qi >>> 0, n = Ii + 8 | 0, K = t[n >> 2], l = Ei + 8 | 0, gr = K + t[l >> 2] | 0, n = t[l + 4 >> 2] + t[n + 4 >> 2] | 0, n = K >>> 0 > gr >>> 0 ? n + 1 | 0 : n, K = Tt + gr | 0, n = K >>> 0 < gr >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, l = a + K | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = l, l = l + Ce | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, K = l << 12 | b >>> 20, b = t[P + 4416 >> 2], Ce = K + b | 0, a = n, l = n << 12 | l >>> 20, n = l + t[P + 4420 >> 2] | 0, n = b >>> 0 > Ce >>> 0 ? n + 1 | 0 : n, Pr(nr, Ce, n, 0, 0, 15632, 16, 0, 0), Yr = P + 4384 | 0, Tt = Yr, K = (l | 0) == (n | 0) & K >>> 0 > Ce >>> 0 | l >>> 0 > n >>> 0, l = lr + 8 | 0, b = t[l >> 2], n = t[l + 4 >> 2], a = a >>> 20 | 0, l = a + b | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = l, l = l + K | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, Pr(Tt, l, n, 0, 0, 64028672, 65536, 0, 0), a = t[P + 4368 >> 2], l = t[P + 4640 >> 2], Ce = a + l | 0, K = t[P + 4372 >> 2], n = K + t[P + 4644 >> 2] | 0, Qi = P + 7456 | 0, Ei = Qi + 8 | 0, kr = Ei, b = l >>> 0 > Ce >>> 0 ? n + 1 | 0 : n, K = (K | 0) == (b | 0) & a >>> 0 > Ce >>> 0 | b >>> 0 < K >>> 0, n = In + 8 | 0, a = t[n >> 2], l = Ki + 8 | 0, Tt = a + t[l >> 2] | 0, n = t[l + 4 >> 2] + t[n + 4 >> 2] | 0, n = a >>> 0 > Tt >>> 0 ? n + 1 | 0 : n, l = K + Tt | 0, n = l >>> 0 < Tt >>> 0 ? n + 1 | 0 : n, Tt = b, K = l << 12 | b >>> 20, a = n, gr = n << 12 | l >>> 20, ei = t[P + 4436 >> 2], n = ei + t[P + 4612 >> 2] | 0, lr = t[P + 4432 >> 2], l = t[P + 4608 >> 2], b = lr + l | 0, nr = b, K = b + K | 0, l = l >>> 0 > b >>> 0 ? n + 1 | 0 : n, n = l + gr | 0, t[kr >> 2] = K, b = K >>> 0 < b >>> 0 ? n + 1 | 0 : n, t[kr + 4 >> 2] = b & 1048575, Ii = Qi + 16 | 0, kr = Ii, gr = (l | 0) == (b | 0) & K >>> 0 < nr >>> 0 | l >>> 0 > b >>> 0, nr = (l | 0) == (ei | 0) & nr >>> 0 < lr >>> 0 | l >>> 0 < ei >>> 0, n = Di + 8 | 0, K = t[n >> 2], l = ui + 8 | 0, lr = K + t[l >> 2] | 0, n = t[l + 4 >> 2] + t[n + 4 >> 2] | 0, n = K >>> 0 > lr >>> 0 ? n + 1 | 0 : n, K = nr + lr | 0, n = K >>> 0 < lr >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, l = a + K | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = l, l = l + gr | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, K = l << 12 | b >>> 20, a = n, b = n << 12 | l >>> 20, di = t[P + 4592 >> 2], l = t[P + 4656 >> 2], gr = di + l | 0, ui = t[P + 4596 >> 2], n = ui + t[P + 4660 >> 2] | 0, n = l >>> 0 > gr >>> 0 ? n + 1 | 0 : n, l = t[P + 4400 >> 2], nr = l + gr | 0, lr = n, n = n + t[P + 4404 >> 2] | 0, l = l >>> 0 > nr >>> 0 ? n + 1 | 0 : n, n = l + b | 0, K = K + nr | 0, n = K >>> 0 < nr >>> 0 ? n + 1 | 0 : n, t[kr >> 2] = K, b = n, t[kr + 4 >> 2] = n & 1048575, Ti = Qi + 24 | 0, wi = (l | 0) == (n | 0) & K >>> 0 < nr >>> 0 | l >>> 0 > n >>> 0, ei = (l | 0) == (lr | 0) & nr >>> 0 < gr >>> 0 | l >>> 0 < lr >>> 0, l = Nr + 8 | 0, kr = t[l >> 2], Nr = t[l + 4 >> 2], nr = (lr | 0) == (ui | 0) & gr >>> 0 < di >>> 0 | lr >>> 0 < ui >>> 0, n = ai + 8 | 0, K = t[n >> 2], l = jr + 8 | 0, gr = K + t[l >> 2] | 0, n = t[l + 4 >> 2] + t[n + 4 >> 2] | 0, n = K >>> 0 > gr >>> 0 ? n + 1 | 0 : n, l = nr + gr | 0, n = (l >>> 0 < gr >>> 0 ? n + 1 | 0 : n) + Nr | 0, K = l, l = l + kr | 0, n = K >>> 0 > l >>> 0 ? n + 1 | 0 : n, K = l + ei | 0, n = K >>> 0 < l >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, l = a + K | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = l, l = l + wi | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, nr = l << 12 | b >>> 20, a = n, K = n << 12 | l >>> 20, gr = t[P + 4384 >> 2], b = or & -2, l = gr + b | 0, kr = t[P + 4388 >> 2], n = kr + (tr & 1048575) | 0, or = l >>> 0 < b >>> 0 ? n + 1 | 0 : n, n = or + K | 0, tr = l, b = l + nr | 0, t[Ti >> 2] = b, l = l >>> 0 > b >>> 0 ? n + 1 | 0 : n, t[Ti + 4 >> 2] = l & 1048575, Nr = Qi + 32 | 0, lr = Nr, K = pe, nr = Me & 65535, Me = (l | 0) == (or | 0) & b >>> 0 < tr >>> 0 | l >>> 0 < or >>> 0, b = (or | 0) == (kr | 0) & tr >>> 0 < gr >>> 0 | or >>> 0 < kr >>> 0, n = Yr + 8 | 0, pe = b + t[n >> 2] | 0, n = t[n + 4 >> 2], n = b >>> 0 > pe >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, b = a, a = a + pe | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, b = a, a = a + Me | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, l = a << 12 | l >>> 20, b = l + K | 0, n = nr + (n << 12 | a >>> 20) | 0, t[lr >> 2] = b, t[lr + 4 >> 2] = l >>> 0 > b >>> 0 ? n + 1 | 0 : n, t[P + 7456 >> 2] = Ce, t[P + 7460 >> 2] = Tt & 1048575, zr(Qi, Qi, ns), l = t[P + 7460 >> 2], ai = l, Yr = t[P + 7456 >> 2], K = Yr, n = l << 1 | K >>> 31, lr = P + 4208 | 0, tr = t[Ti >> 2], Me = t[Ti + 4 >> 2], ei = K << 1, wi = n, Pr(lr, tr, Me, 0, 0, ei, n, 0, 0), l = t[Ei + 4 >> 2], es = l, Wi = t[Ei >> 2], a = Wi, n = l << 1 | a >>> 31, gr = P + 4304 | 0, nr = t[Ii >> 2], Ce = t[Ii + 4 >> 2], a = a << 1, b = n, Pr(gr, nr, Ce, 0, 0, a, n, 0, 0), or = P + 4192 | 0, pe = t[Nr >> 2], l = t[Nr + 4 >> 2], Pr(or, pe, l, 0, 0, pe, l, 0, 0), Tt = P + 4176 | 0, Pr(Tt, t[P + 4192 >> 2], t[P + 4196 >> 2], 0, 0, 15632, 16, 0, 0), n = l << 1 | pe >>> 31, Mn = P + 4144 | 0, di = pe << 1, kr = n, Pr(Mn, di, n, 0, 0, K, ai, 0, 0), Dn = P + 4224 | 0, Pr(Dn, tr, Me, 0, 0, a, b, 0, 0), $i = P + 4288 | 0, Pr($i, nr, Ce, 0, 0, nr, Ce, 0, 0), Ti = P + 4160 | 0, l = or + 8 | 0, Pr(Ti, t[l >> 2], t[l + 4 >> 2], 0, 0, 64028672, 65536, 0, 0), In = P + 4352 | 0, Pr(In, K, ai, 0, 0, K, ai, 0, 0), Li = P + 4128 | 0, Pr(Li, di, n, 0, 0, Wi, es, 0, 0), kn = P + 4240 | 0, Pr(kn, tr, Me, 0, 0, nr << 1, Ce << 1 | nr >>> 31, 0, 0), Yr = t[P + 4212 >> 2], n = Yr + t[P + 4308 >> 2] | 0, pe = t[P + 4208 >> 2], a = t[P + 4304 >> 2], l = pe + a | 0, b = t[P + 4176 >> 2], Nr = l + b | 0, a = l >>> 0 < a >>> 0 ? n + 1 | 0 : n, n = a + t[P + 4180 >> 2] | 0, b = b >>> 0 > Nr >>> 0 ? n + 1 | 0 : n, or = (a | 0) == (b | 0) & l >>> 0 > Nr >>> 0 | a >>> 0 > b >>> 0, n = Tt + 8 | 0, Tt = t[n >> 2], K = t[n + 4 >> 2], pe = (a | 0) == (Yr | 0) & l >>> 0 < pe >>> 0 | a >>> 0 < Yr >>> 0, n = gr + 8 | 0, a = t[n >> 2], l = lr + 8 | 0, gr = a + t[l >> 2] | 0, n = t[l + 4 >> 2] + t[n + 4 >> 2] | 0, n = a >>> 0 > gr >>> 0 ? n + 1 | 0 : n, l = pe + gr | 0, n = (l >>> 0 < gr >>> 0 ? n + 1 | 0 : n) + K | 0, a = l, l = l + Tt | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = l, l = l + or | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, lr = b, Tt = l << 12 | b >>> 20, a = n, pe = n << 12 | l >>> 20, Qi = t[P + 4224 >> 2], l = t[P + 4288 >> 2], or = Qi + l | 0, Xi = t[P + 4228 >> 2], n = Xi + t[P + 4292 >> 2] | 0, n = l >>> 0 > or >>> 0 ? n + 1 | 0 : n, l = t[P + 4144 >> 2], K = l + or | 0, Yr = n, n = n + t[P + 4148 >> 2] | 0, n = l >>> 0 > K >>> 0 ? n + 1 | 0 : n, l = t[P + 4160 >> 2], b = l + K | 0, gr = n, n = n + t[P + 4164 >> 2] | 0, l = l >>> 0 > b >>> 0 ? n + 1 | 0 : n, n = l + pe | 0, Ki = P + 4112 | 0, Di = Ki, Tt = b + Tt | 0, pe = Tt >>> 0 < b >>> 0 ? n + 1 | 0 : n, Ei = (l | 0) == (pe | 0) & b >>> 0 > Tt >>> 0 | l >>> 0 > pe >>> 0, Ii = (l | 0) == (gr | 0) & b >>> 0 < K >>> 0 | l >>> 0 < gr >>> 0, l = Ti + 8 | 0, ui = t[l >> 2], jr = t[l + 4 >> 2], ai = (gr | 0) == (Yr | 0) & K >>> 0 < or >>> 0 | gr >>> 0 < Yr >>> 0, l = Mn + 8 | 0, Ti = t[l >> 2], gr = t[l + 4 >> 2], K = (Yr | 0) == (Xi | 0) & or >>> 0 < Qi >>> 0 | Yr >>> 0 < Xi >>> 0, n = $i + 8 | 0, b = t[n >> 2], l = Dn + 8 | 0, or = b + t[l >> 2] | 0, n = t[l + 4 >> 2] + t[n + 4 >> 2] | 0, n = b >>> 0 > or >>> 0 ? n + 1 | 0 : n, l = K + or | 0, n = (l >>> 0 < or >>> 0 ? n + 1 | 0 : n) + gr | 0, b = l, l = l + Ti | 0, n = b >>> 0 > l >>> 0 ? n + 1 | 0 : n, b = l, l = l + ai | 0, n = (b >>> 0 > l >>> 0 ? n + 1 | 0 : n) + jr | 0, b = l, l = l + ui | 0, n = b >>> 0 > l >>> 0 ? n + 1 | 0 : n, b = l + Ii | 0, n = b >>> 0 < l >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, l = a + b | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = l, l = l + Ei | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = pe, K = l << 12 | a >>> 20, b = n, pe = n << 12 | l >>> 20, jr = t[P + 4128 >> 2], l = t[P + 4240 >> 2], or = jr + l | 0, ui = t[P + 4132 >> 2], n = ui + t[P + 4244 >> 2] | 0, l = l >>> 0 > or >>> 0 ? n + 1 | 0 : n, n = l + pe | 0, K = K + or | 0, n = K >>> 0 < or >>> 0 ? n + 1 | 0 : n, Ti = K << 4 & -16, pe = n, Yr = (n << 4 | K >>> 28) & 16777215, gr = a, Pr(Di, Ti | a >>> 16 & 15, Yr, 0, 0, 977, 1, 0, 0), Di = P + 4336 | 0, Pr(Di, Wi, es, 0, 0, ei, wi, 0, 0), Ii = P + 4080 | 0, Pr(Ii, di, kr, 0, 0, nr, Ce, 0, 0), ai = P + 4256 | 0, Pr(ai, tr, Me, 0, 0, tr, Me, 0, 0), Ti = P + 4064 | 0, Yr = (l | 0) == (n | 0) & K >>> 0 < or >>> 0 | l >>> 0 > n >>> 0, K = (l | 0) == (ui | 0) & or >>> 0 < jr >>> 0 | l >>> 0 < ui >>> 0, n = kn + 8 | 0, a = t[n >> 2], l = Li + 8 | 0, or = a + t[l >> 2] | 0, n = t[l + 4 >> 2] + t[n + 4 >> 2] | 0, n = a >>> 0 > or >>> 0 ? n + 1 | 0 : n, a = K + or | 0, n = a >>> 0 < or >>> 0 ? n + 1 | 0 : n, b = b >>> 20 | 0, l = a + b | 0, n = b >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = l, l = l + Yr | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, pe = l << 12 | pe >>> 20, a = n, b = n << 12 | l >>> 20, Yr = t[P + 4080 >> 2], l = t[P + 4256 >> 2], K = Yr + l | 0, Ei = t[P + 4084 >> 2], n = Ei + t[P + 4260 >> 2] | 0, l = l >>> 0 > K >>> 0 ? n + 1 | 0 : n, n = l + b | 0, pe = K + pe | 0, n = pe >>> 0 < K >>> 0 ? n + 1 | 0 : n, b = n, Pr(Ti, pe, n & 1048575, 0, 0, 15632, 16, 0, 0), ui = P + 4272 | 0, Pr(ui, nr, Ce, 0, 0, ei, wi, 0, 0), jr = P + 4320 | 0, Pr(jr, Wi, es, 0, 0, Wi, es, 0, 0), or = P + 4016 | 0, Pr(or, di, kr, 0, 0, tr, Me, 0, 0), ei = P + 4e3 | 0, Me = ei, Ce = (l | 0) == (n | 0) & K >>> 0 > pe >>> 0 | l >>> 0 > n >>> 0, K = (l | 0) == (Ei | 0) & K >>> 0 < Yr >>> 0 | l >>> 0 < Ei >>> 0, n = ai + 8 | 0, pe = t[n >> 2], l = Ii + 8 | 0, tr = pe + t[l >> 2] | 0, n = t[l + 4 >> 2] + t[n + 4 >> 2] | 0, n = pe >>> 0 > tr >>> 0 ? n + 1 | 0 : n, pe = K + tr | 0, n = pe >>> 0 < tr >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, l = a + pe | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = l, l = l + Ce | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, pe = l << 12 | b >>> 20, b = t[P + 4016 >> 2], Ce = pe + b | 0, a = n, l = n << 12 | l >>> 20, n = l + t[P + 4020 >> 2] | 0, n = b >>> 0 > Ce >>> 0 ? n + 1 | 0 : n, Pr(Me, Ce, n, 0, 0, 15632, 16, 0, 0), Ei = P + 3936 | 0, K = Ei, pe = (l | 0) == (n | 0) & pe >>> 0 > Ce >>> 0 | l >>> 0 > n >>> 0, l = or + 8 | 0, b = t[l >> 2], n = t[l + 4 >> 2], a = a >>> 20 | 0, l = a + b | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = l, l = l + pe | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, Pr(K, l, n, 0, 0, 64028672, 65536, 0, 0), a = t[P + 4112 >> 2], l = t[P + 4352 >> 2], K = a + l | 0, pe = t[P + 4116 >> 2], n = pe + t[P + 4356 >> 2] | 0, b = l >>> 0 > K >>> 0 ? n + 1 | 0 : n, pe = (pe | 0) == (b | 0) & a >>> 0 > K >>> 0 | b >>> 0 < pe >>> 0, n = In + 8 | 0, a = t[n >> 2], l = Ki + 8 | 0, Ce = a + t[l >> 2] | 0, n = t[l + 4 >> 2] + t[n + 4 >> 2] | 0, n = a >>> 0 > Ce >>> 0 ? n + 1 | 0 : n, l = pe + Ce | 0, n = l >>> 0 < Ce >>> 0 ? n + 1 | 0 : n, nr = b, pe = l << 12 | b >>> 20, a = n, b = n << 12 | l >>> 20, Me = t[P + 4064 >> 2], l = t[P + 4336 >> 2], Ce = Me + l | 0, or = t[P + 4068 >> 2], n = or + t[P + 4340 >> 2] | 0, l = l >>> 0 > Ce >>> 0 ? n + 1 | 0 : n, n = l + b | 0, pe = pe + Ce | 0, b = pe >>> 0 < Ce >>> 0 ? n + 1 | 0 : n, tr = (l | 0) == (b | 0) & pe >>> 0 < Ce >>> 0 | l >>> 0 > b >>> 0, Me = (l | 0) == (or | 0) & Ce >>> 0 < Me >>> 0 | l >>> 0 < or >>> 0, n = Di + 8 | 0, Ce = t[n >> 2], l = Ti + 8 | 0, or = Ce + t[l >> 2] | 0, n = t[l + 4 >> 2] + t[n + 4 >> 2] | 0, n = Ce >>> 0 > or >>> 0 ? n + 1 | 0 : n, Ce = Me + or | 0, n = Ce >>> 0 < or >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, l = a + Ce | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = l, l = l + tr | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, or = b, Ce = l << 12 | b >>> 20, a = n, b = n << 12 | l >>> 20, ai = t[P + 4272 >> 2], l = t[P + 4320 >> 2], tr = ai + l | 0, Di = t[P + 4276 >> 2], n = Di + t[P + 4324 >> 2] | 0, n = l >>> 0 > tr >>> 0 ? n + 1 | 0 : n, l = t[P + 4e3 >> 2], Me = l + tr | 0, kr = n, n = n + t[P + 4004 >> 2] | 0, l = l >>> 0 > Me >>> 0 ? n + 1 | 0 : n, n = l + b | 0, Ii = P + 3920 | 0, Ti = Ii, b = Ce + Me | 0, Ce = b >>> 0 < Me >>> 0 ? n + 1 | 0 : n, Yr = (l | 0) == (Ce | 0) & b >>> 0 < Me >>> 0 | l >>> 0 > Ce >>> 0, di = (l | 0) == (kr | 0) & Me >>> 0 < tr >>> 0 | l >>> 0 < kr >>> 0, l = ei + 8 | 0, wi = t[l >> 2], ei = t[l + 4 >> 2], tr = (kr | 0) == (Di | 0) & tr >>> 0 < ai >>> 0 | kr >>> 0 < Di >>> 0, n = jr + 8 | 0, Me = t[n >> 2], l = ui + 8 | 0, kr = Me + t[l >> 2] | 0, n = t[l + 4 >> 2] + t[n + 4 >> 2] | 0, n = Me >>> 0 > kr >>> 0 ? n + 1 | 0 : n, l = tr + kr | 0, n = (l >>> 0 < kr >>> 0 ? n + 1 | 0 : n) + ei | 0, tr = l, l = l + wi | 0, n = tr >>> 0 > l >>> 0 ? n + 1 | 0 : n, Me = l + di | 0, n = Me >>> 0 < l >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, l = a + Me | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = l, l = l + Yr | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, Me = Ce, tr = l << 12 | Ce >>> 20, a = n, kr = n << 12 | l >>> 20, Di = t[P + 3940 >> 2], n = Di + (lr & 1048575) | 0, ai = t[P + 3936 >> 2], l = Nr & -2, Ce = ai + l | 0, lr = Ce, tr = Ce + tr | 0, l = l >>> 0 > Ce >>> 0 ? n + 1 | 0 : n, n = l + kr | 0, Ce = tr >>> 0 < Ce >>> 0 ? n + 1 | 0 : n, Yr = Ce & 1048575, Nr = Yr, n = nr & 1048575, Ki = n, nr = K, n = n << 1 | K >>> 31, ei = K << 1, wi = n, Pr(Ti, tr, Nr, 0, 0, ei, n, 0, 0), n = or & 1048575, Wi = n, ui = P + 3952 | 0, Nr = Me & 1048575, K = pe << 1, Ti = pe, Me = n << 1 | pe >>> 31, Pr(ui, b, Nr, 0, 0, K, Me, 0, 0), jr = P + 3856 | 0, kr = gr & 65535, gr = (l | 0) == (Ce | 0) & tr >>> 0 < lr >>> 0 | l >>> 0 > Ce >>> 0, or = (l | 0) == (Di | 0) & lr >>> 0 < ai >>> 0 | l >>> 0 < Di >>> 0, l = Ei + 8 | 0, pe = or + t[l >> 2] | 0, n = t[l + 4 >> 2], n = pe >>> 0 < or >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, l = a + pe | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = l, l = l + gr | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, pe = l << 12 | Ce >>> 20, a = pe + Tt | 0, n = kr + (n << 12 | l >>> 20) | 0, n = a >>> 0 < pe >>> 0 ? n + 1 | 0 : n, Pr(jr, a, n, 0, 0, a, n, 0, 0), Tt = P + 3840 | 0, Pr(Tt, t[P + 3856 >> 2], t[P + 3860 >> 2], 0, 0, 15632, 16, 0, 0), l = a, n = n << 1 | l >>> 31, Mn = P + 3808 | 0, di = l << 1, kr = n, Pr(Mn, di, n, 0, 0, nr, Ki, 0, 0), Dn = P + 3904 | 0, Pr(Dn, tr, Yr, 0, 0, K, Me, 0, 0), $i = P + 3968 | 0, Pr($i, b, Nr, 0, 0, b, Nr, 0, 0), ai = P + 3824 | 0, l = jr + 8 | 0, Pr(ai, t[l >> 2], t[l + 4 >> 2], 0, 0, 64028672, 65536, 0, 0), In = P + 4096 | 0, Pr(In, nr, Ki, 0, 0, nr, Ki, 0, 0), Li = P + 3792 | 0, Pr(Li, di, n, 0, 0, Ti, Wi, 0, 0), kn = P + 3872 | 0, gr = tr, nr = Yr, Ce = Nr, Nr = b, Pr(kn, tr, nr, 0, 0, b << 1, Ce << 1 | b >>> 31, 0, 0), pe = t[P + 3920 >> 2], a = t[P + 3952 >> 2], l = pe + a | 0, tr = t[P + 3924 >> 2], n = tr + t[P + 3956 >> 2] | 0, n = l >>> 0 < a >>> 0 ? n + 1 | 0 : n, a = t[P + 3840 >> 2], or = a + l | 0, b = n, n = n + t[P + 3844 >> 2] | 0, a = a >>> 0 > or >>> 0 ? n + 1 | 0 : n, Me = (b | 0) == (a | 0) & l >>> 0 > or >>> 0 | a >>> 0 < b >>> 0, n = Tt + 8 | 0, Tt = t[n >> 2], K = t[n + 4 >> 2], pe = (b | 0) == (tr | 0) & l >>> 0 < pe >>> 0 | b >>> 0 < tr >>> 0, n = ui + 8 | 0, b = t[n >> 2], l = Ii + 8 | 0, tr = b + t[l >> 2] | 0, n = t[l + 4 >> 2] + t[n + 4 >> 2] | 0, n = b >>> 0 > tr >>> 0 ? n + 1 | 0 : n, l = pe + tr | 0, n = (l >>> 0 < tr >>> 0 ? n + 1 | 0 : n) + K | 0, b = l, l = l + Tt | 0, n = b >>> 0 > l >>> 0 ? n + 1 | 0 : n, b = l, l = l + Me | 0, n = b >>> 0 > l >>> 0 ? n + 1 | 0 : n, tr = a, K = l << 12 | a >>> 20, b = n, pe = n << 12 | l >>> 20, Qi = t[P + 3904 >> 2], l = t[P + 3968 >> 2], lr = Qi + l | 0, Xi = t[P + 3908 >> 2], n = Xi + t[P + 3972 >> 2] | 0, n = l >>> 0 > lr >>> 0 ? n + 1 | 0 : n, l = t[P + 3808 >> 2], Me = l + lr | 0, a = n, n = n + t[P + 3812 >> 2] | 0, n = l >>> 0 > Me >>> 0 ? n + 1 | 0 : n, l = t[P + 3824 >> 2], Tt = l + Me | 0, Yr = n, n = n + t[P + 3828 >> 2] | 0, l = l >>> 0 > Tt >>> 0 ? n + 1 | 0 : n, n = l + pe | 0, Ki = P + 3696 | 0, Di = Ki, pe = K + Tt | 0, K = pe >>> 0 < Tt >>> 0 ? n + 1 | 0 : n, Ei = (l | 0) == (K | 0) & pe >>> 0 < Tt >>> 0 | l >>> 0 > K >>> 0, Ii = (l | 0) == (Yr | 0) & Me >>> 0 > Tt >>> 0 | l >>> 0 < Yr >>> 0, l = ai + 8 | 0, ui = t[l >> 2], jr = t[l + 4 >> 2], ai = (a | 0) == (Yr | 0) & Me >>> 0 < lr >>> 0 | a >>> 0 > Yr >>> 0, l = Mn + 8 | 0, Yr = t[l >> 2], Me = t[l + 4 >> 2], Tt = (a | 0) == (Xi | 0) & lr >>> 0 < Qi >>> 0 | a >>> 0 < Xi >>> 0, n = $i + 8 | 0, a = t[n >> 2], l = Dn + 8 | 0, lr = a + t[l >> 2] | 0, n = t[l + 4 >> 2] + t[n + 4 >> 2] | 0, n = a >>> 0 > lr >>> 0 ? n + 1 | 0 : n, l = Tt + lr | 0, n = (l >>> 0 < lr >>> 0 ? n + 1 | 0 : n) + Me | 0, a = l, l = l + Yr | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = l, l = l + ai | 0, n = (a >>> 0 > l >>> 0 ? n + 1 | 0 : n) + jr | 0, a = l, l = l + ui | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = l + Ii | 0, n = a >>> 0 < l >>> 0 ? n + 1 | 0 : n, b = b >>> 20 | 0, l = a + b | 0, n = b >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = l, l = l + Ei | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = K, Tt = l << 12 | a >>> 20, b = n, K = n << 12 | l >>> 20, jr = t[P + 3792 >> 2], l = t[P + 3872 >> 2], lr = jr + l | 0, Qi = t[P + 3796 >> 2], n = Qi + t[P + 3876 >> 2] | 0, l = l >>> 0 > lr >>> 0 ? n + 1 | 0 : n, n = l + K | 0, Tt = Tt + lr | 0, n = Tt >>> 0 < lr >>> 0 ? n + 1 | 0 : n, ai = Tt << 4 & -16, K = n, Yr = (n << 4 | Tt >>> 28) & 16777215, Me = a, Pr(Di, ai | a >>> 16 & 15, Yr, 0, 0, 977, 1, 0, 0), Di = P + 4032 | 0, Pr(Di, Ti, Wi, 0, 0, ei, wi, 0, 0), Ei = P + 3776 | 0, Pr(Ei, di, kr, 0, 0, Nr, Ce, 0, 0), Ii = P + 3888 | 0, Pr(Ii, gr, nr, 0, 0, gr, nr, 0, 0), ui = P + 3760 | 0, ai = ui, Yr = (l | 0) == (n | 0) & Tt >>> 0 < lr >>> 0 | l >>> 0 > n >>> 0, Tt = (l | 0) == (Qi | 0) & lr >>> 0 < jr >>> 0 | l >>> 0 < Qi >>> 0, n = kn + 8 | 0, a = t[n >> 2], l = Li + 8 | 0, lr = a + t[l >> 2] | 0, n = t[l + 4 >> 2] + t[n + 4 >> 2] | 0, n = a >>> 0 > lr >>> 0 ? n + 1 | 0 : n, a = Tt + lr | 0, n = a >>> 0 < lr >>> 0 ? n + 1 | 0 : n, b = b >>> 20 | 0, l = a + b | 0, n = b >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = l, l = l + Yr | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, K = l << 12 | K >>> 20, a = n, b = n << 12 | l >>> 20, Yr = t[P + 3776 >> 2], l = t[P + 3888 >> 2], Tt = Yr + l | 0, Qi = t[P + 3780 >> 2], n = Qi + t[P + 3892 >> 2] | 0, l = l >>> 0 > Tt >>> 0 ? n + 1 | 0 : n, n = l + b | 0, K = K + Tt | 0, n = K >>> 0 < Tt >>> 0 ? n + 1 | 0 : n, b = n, Pr(ai, K, n & 1048575, 0, 0, 15632, 16, 0, 0), jr = P + 3984 | 0, Pr(jr, Nr, Ce, 0, 0, ei, wi, 0, 0), ai = P + 4048 | 0, Pr(ai, Ti, Wi, 0, 0, Ti, Wi, 0, 0), lr = P + 3744 | 0, Pr(lr, gr, nr, 0, 0, di, kr, 0, 0), Nr = P + 3728 | 0, nr = Nr, Ce = (l | 0) == (n | 0) & K >>> 0 < Tt >>> 0 | l >>> 0 > n >>> 0, Tt = (l | 0) == (Qi | 0) & Tt >>> 0 < Yr >>> 0 | l >>> 0 < Qi >>> 0, n = Ii + 8 | 0, K = t[n >> 2], l = Ei + 8 | 0, gr = K + t[l >> 2] | 0, n = t[l + 4 >> 2] + t[n + 4 >> 2] | 0, n = K >>> 0 > gr >>> 0 ? n + 1 | 0 : n, K = Tt + gr | 0, n = K >>> 0 < gr >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, l = a + K | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = l, l = l + Ce | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, K = l << 12 | b >>> 20, b = t[P + 3744 >> 2], Ce = K + b | 0, a = n, l = n << 12 | l >>> 20, n = l + t[P + 3748 >> 2] | 0, n = b >>> 0 > Ce >>> 0 ? n + 1 | 0 : n, Pr(nr, Ce, n, 0, 0, 15632, 16, 0, 0), Yr = P + 3712 | 0, Tt = Yr, K = (l | 0) == (n | 0) & K >>> 0 > Ce >>> 0 | l >>> 0 > n >>> 0, l = lr + 8 | 0, b = t[l >> 2], n = t[l + 4 >> 2], a = a >>> 20 | 0, l = a + b | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = l, l = l + K | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, Pr(Tt, l, n, 0, 0, 64028672, 65536, 0, 0), a = t[P + 3696 >> 2], l = t[P + 4096 >> 2], Ce = a + l | 0, K = t[P + 3700 >> 2], n = K + t[P + 4100 >> 2] | 0, Qi = P + 7416 | 0, Ei = Qi + 8 | 0, kr = Ei, b = l >>> 0 > Ce >>> 0 ? n + 1 | 0 : n, K = (K | 0) == (b | 0) & a >>> 0 > Ce >>> 0 | b >>> 0 < K >>> 0, n = In + 8 | 0, a = t[n >> 2], l = Ki + 8 | 0, Tt = a + t[l >> 2] | 0, n = t[l + 4 >> 2] + t[n + 4 >> 2] | 0, n = a >>> 0 > Tt >>> 0 ? n + 1 | 0 : n, l = K + Tt | 0, n = l >>> 0 < Tt >>> 0 ? n + 1 | 0 : n, Tt = b, K = l << 12 | b >>> 20, a = n, gr = n << 12 | l >>> 20, ei = t[P + 3764 >> 2], n = ei + t[P + 4036 >> 2] | 0, lr = t[P + 3760 >> 2], l = t[P + 4032 >> 2], b = lr + l | 0, nr = b, K = b + K | 0, l = l >>> 0 > b >>> 0 ? n + 1 | 0 : n, n = l + gr | 0, t[kr >> 2] = K, b = K >>> 0 < b >>> 0 ? n + 1 | 0 : n, t[kr + 4 >> 2] = b & 1048575, Ii = Qi + 16 | 0, kr = Ii, gr = (l | 0) == (b | 0) & K >>> 0 < nr >>> 0 | l >>> 0 > b >>> 0, nr = (l | 0) == (ei | 0) & nr >>> 0 < lr >>> 0 | l >>> 0 < ei >>> 0, n = Di + 8 | 0, K = t[n >> 2], l = ui + 8 | 0, lr = K + t[l >> 2] | 0, n = t[l + 4 >> 2] + t[n + 4 >> 2] | 0, n = K >>> 0 > lr >>> 0 ? n + 1 | 0 : n, K = nr + lr | 0, n = K >>> 0 < lr >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, l = a + K | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = l, l = l + gr | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, K = l << 12 | b >>> 20, a = n, b = n << 12 | l >>> 20, di = t[P + 3984 >> 2], l = t[P + 4048 >> 2], gr = di + l | 0, ui = t[P + 3988 >> 2], n = ui + t[P + 4052 >> 2] | 0, n = l >>> 0 > gr >>> 0 ? n + 1 | 0 : n, l = t[P + 3728 >> 2], nr = l + gr | 0, lr = n, n = n + t[P + 3732 >> 2] | 0, l = l >>> 0 > nr >>> 0 ? n + 1 | 0 : n, n = l + b | 0, K = K + nr | 0, n = K >>> 0 < nr >>> 0 ? n + 1 | 0 : n, t[kr >> 2] = K, b = n, t[kr + 4 >> 2] = n & 1048575, Ti = Qi + 24 | 0, wi = (l | 0) == (n | 0) & K >>> 0 < nr >>> 0 | l >>> 0 > n >>> 0, ei = (l | 0) == (lr | 0) & nr >>> 0 < gr >>> 0 | l >>> 0 < lr >>> 0, l = Nr + 8 | 0, kr = t[l >> 2], Nr = t[l + 4 >> 2], nr = (lr | 0) == (ui | 0) & gr >>> 0 < di >>> 0 | lr >>> 0 < ui >>> 0, n = ai + 8 | 0, K = t[n >> 2], l = jr + 8 | 0, gr = K + t[l >> 2] | 0, n = t[l + 4 >> 2] + t[n + 4 >> 2] | 0, n = K >>> 0 > gr >>> 0 ? n + 1 | 0 : n, l = nr + gr | 0, n = (l >>> 0 < gr >>> 0 ? n + 1 | 0 : n) + Nr | 0, K = l, l = l + kr | 0, n = K >>> 0 > l >>> 0 ? n + 1 | 0 : n, K = l + ei | 0, n = K >>> 0 < l >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, l = a + K | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = l, l = l + wi | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, nr = l << 12 | b >>> 20, a = n, K = n << 12 | l >>> 20, gr = t[P + 3712 >> 2], b = or & -2, l = gr + b | 0, Nr = t[P + 3716 >> 2], n = Nr + (tr & 1048575) | 0, or = l >>> 0 < b >>> 0 ? n + 1 | 0 : n, n = or + K | 0, tr = l, b = l + nr | 0, t[Ti >> 2] = b, l = l >>> 0 > b >>> 0 ? n + 1 | 0 : n, t[Ti + 4 >> 2] = l & 1048575, lr = Qi + 32 | 0, K = pe, nr = Me & 65535, Me = (l | 0) == (or | 0) & b >>> 0 < tr >>> 0 | l >>> 0 < or >>> 0, b = (or | 0) == (Nr | 0) & tr >>> 0 < gr >>> 0 | or >>> 0 < Nr >>> 0, n = Yr + 8 | 0, pe = b + t[n >> 2] | 0, n = t[n + 4 >> 2], n = b >>> 0 > pe >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, b = a, a = a + pe | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, b = a, a = a + Me | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, l = a << 12 | l >>> 20, b = l + K | 0, n = nr + (n << 12 | a >>> 20) | 0, t[lr >> 2] = b, t[lr + 4 >> 2] = l >>> 0 > b >>> 0 ? n + 1 | 0 : n, t[P + 7416 >> 2] = Ce, t[P + 7420 >> 2] = Tt & 1048575, zr(Qi, Qi, zn), Ce = t[lr + 4 >> 2], n = P + 7376 | 0, l = n + 32 | 0, a = t[lr >> 2], t[l >> 2] = a, t[l + 4 >> 2] = Ce, Me = t[Ti + 4 >> 2], l = n + 24 | 0, Tt = t[Ti >> 2], t[l >> 2] = Tt, t[l + 4 >> 2] = Me, nr = t[Ii + 4 >> 2], l = n + 16 | 0, K = t[Ii >> 2], t[l >> 2] = K, t[l + 4 >> 2] = nr, or = t[Ei + 4 >> 2], l = n + 8 | 0, pe = t[Ei >> 2], t[l >> 2] = pe, t[l + 4 >> 2] = or, tr = t[P + 7420 >> 2], b = t[P + 7416 >> 2], t[P + 7376 >> 2] = b, t[P + 7380 >> 2] = tr, l = 11; lr = b, n = tr << 1 | b >>> 31, Ii = P + 3664 | 0, Yr = b << 1, Ti = n, Pr(Ii, Tt, Me, 0, 0, Yr, n, 0, 0), jr = P + 3584 | 0, b = pe << 1, gr = or, di = pe, pe = or << 1 | pe >>> 31, Pr(jr, K, nr, 0, 0, b, pe, 0, 0), kr = P + 3520 | 0, Pr(kr, a, Ce, 0, 0, a, Ce, 0, 0), Nr = P + 3504 | 0, Pr(Nr, t[P + 3520 >> 2], t[P + 3524 >> 2], 0, 0, 15632, 16, 0, 0), n = Ce << 1 | a >>> 31, Wi = P + 3472 | 0, ai = a << 1, wi = n, Pr(Wi, ai, n, 0, 0, lr, tr, 0, 0), Xi = P + 3632 | 0, Pr(Xi, Tt, Me, 0, 0, b, pe, 0, 0), Mn = P + 3568 | 0, Pr(Mn, K, nr, 0, 0, K, nr, 0, 0), ui = P + 3488 | 0, n = kr + 8 | 0, Pr(ui, t[n >> 2], t[n + 4 >> 2], 0, 0, 64028672, 65536, 0, 0), Dn = P + 3680 | 0, Pr(Dn, lr, tr, 0, 0, lr, tr, 0, 0), $i = P + 3456 | 0, Pr($i, ai, wi, 0, 0, di, or, 0, 0), In = P + 3536 | 0, tr = Tt, ei = K, Pr(In, Tt, Me, 0, 0, K << 1, nr << 1 | K >>> 31, 0, 0), lr = t[P + 3668 >> 2], n = lr + t[P + 3588 >> 2] | 0, K = t[P + 3664 >> 2], b = t[P + 3584 >> 2], a = K + b | 0, pe = t[P + 3504 >> 2], kr = a + pe | 0, b = a >>> 0 < b >>> 0 ? n + 1 | 0 : n, n = b + t[P + 3508 >> 2] | 0, pe = pe >>> 0 > kr >>> 0 ? n + 1 | 0 : n, or = (b | 0) == (pe | 0) & a >>> 0 > kr >>> 0 | b >>> 0 > pe >>> 0, n = Nr + 8 | 0, Ce = t[n >> 2], Tt = t[n + 4 >> 2], K = (b | 0) == (lr | 0) & a >>> 0 < K >>> 0 | b >>> 0 < lr >>> 0, b = jr + 8 | 0, a = t[b >> 2], n = Ii + 8 | 0, lr = a + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[b + 4 >> 2] | 0, n = a >>> 0 > lr >>> 0 ? n + 1 | 0 : n, a = K + lr | 0, n = (a >>> 0 < lr >>> 0 ? n + 1 | 0 : n) + Tt | 0, b = a, a = a + Ce | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, b = a, a = a + or | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, or = pe, Ce = a << 12 | pe >>> 20, b = n, K = n << 12 | a >>> 20, Li = t[P + 3632 >> 2], a = t[P + 3568 >> 2], lr = Li + a | 0, zn = t[P + 3636 >> 2], n = zn + t[P + 3572 >> 2] | 0, n = a >>> 0 > lr >>> 0 ? n + 1 | 0 : n, a = t[P + 3472 >> 2], Tt = a + lr | 0, jr = n, n = n + t[P + 3476 >> 2] | 0, n = a >>> 0 > Tt >>> 0 ? n + 1 | 0 : n, a = t[P + 3488 >> 2], pe = a + Tt | 0, Nr = n, n = n + t[P + 3492 >> 2] | 0, a = a >>> 0 > pe >>> 0 ? n + 1 | 0 : n, n = a + K | 0, kn = P + 3440 | 0, Ce = pe + Ce | 0, K = Ce >>> 0 < pe >>> 0 ? n + 1 | 0 : n, Qi = (a | 0) == (K | 0) & pe >>> 0 > Ce >>> 0 | a >>> 0 > K >>> 0, Ki = (a | 0) == (Nr | 0) & pe >>> 0 < Tt >>> 0 | a >>> 0 < Nr >>> 0, n = ui + 8 | 0, Di = t[n >> 2], Ei = t[n + 4 >> 2], Ii = (Nr | 0) == (jr | 0) & Tt >>> 0 < lr >>> 0 | Nr >>> 0 < jr >>> 0, n = Wi + 8 | 0, ui = t[n >> 2], Nr = t[n + 4 >> 2], Tt = (jr | 0) == (zn | 0) & lr >>> 0 < Li >>> 0 | jr >>> 0 < zn >>> 0, pe = Mn + 8 | 0, a = t[pe >> 2], n = Xi + 8 | 0, lr = a + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[pe + 4 >> 2] | 0, n = a >>> 0 > lr >>> 0 ? n + 1 | 0 : n, a = Tt + lr | 0, n = (a >>> 0 < lr >>> 0 ? n + 1 | 0 : n) + Nr | 0, pe = a, a = a + ui | 0, n = pe >>> 0 > a >>> 0 ? n + 1 | 0 : n, pe = a, a = a + Ii | 0, n = (pe >>> 0 > a >>> 0 ? n + 1 | 0 : n) + Ei | 0, pe = a, a = a + Di | 0, n = pe >>> 0 > a >>> 0 ? n + 1 | 0 : n, pe = a + Ki | 0, n = pe >>> 0 < a >>> 0 ? n + 1 | 0 : n, b = b >>> 20 | 0, a = b + pe | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, b = a, a = a + Qi | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, b = K, Tt = a << 12 | b >>> 20, pe = n, Nr = n << 12 | a >>> 20, Li = t[P + 3460 >> 2], n = Li + t[P + 3540 >> 2] | 0, Ii = t[P + 3456 >> 2], a = t[P + 3536 >> 2], K = Ii + a | 0, lr = K, Tt = K + Tt | 0, a = a >>> 0 > K >>> 0 ? n + 1 | 0 : n, n = a + Nr | 0, ui = Tt << 4 & -16, K = Tt >>> 0 < K >>> 0 ? n + 1 | 0 : n, jr = (K << 4 | Tt >>> 28) & 16777215, Nr = b, Pr(kn, ui | b >>> 16 & 15, jr, 0, 0, 977, 1, 0, 0), Qi = P + 3616 | 0, Pr(Qi, di, gr, 0, 0, Yr, Ti, 0, 0), Ki = P + 3424 | 0, Pr(Ki, ai, wi, 0, 0, ei, nr, 0, 0), Di = P + 3648 | 0, Pr(Di, tr, Me, 0, 0, tr, Me, 0, 0), Ei = P + 3408 | 0, ui = Ei, jr = (a | 0) == (K | 0) & Tt >>> 0 < lr >>> 0 | a >>> 0 > K >>> 0, Tt = (a | 0) == (Li | 0) & lr >>> 0 < Ii >>> 0 | a >>> 0 < Li >>> 0, b = In + 8 | 0, a = t[b >> 2], n = $i + 8 | 0, lr = a + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[b + 4 >> 2] | 0, n = a >>> 0 > lr >>> 0 ? n + 1 | 0 : n, b = Tt + lr | 0, n = b >>> 0 < lr >>> 0 ? n + 1 | 0 : n, pe = pe >>> 20 | 0, a = b + pe | 0, n = pe >>> 0 > a >>> 0 ? n + 1 | 0 : n, b = a, a = a + jr | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, K = a << 12 | K >>> 20, b = n, jr = n << 12 | a >>> 20, Li = t[P + 3428 >> 2], n = Li + t[P + 3652 >> 2] | 0, lr = t[P + 3424 >> 2], a = t[P + 3648 >> 2], pe = lr + a | 0, Tt = pe, K = pe + K | 0, a = a >>> 0 > pe >>> 0 ? n + 1 | 0 : n, n = a + jr | 0, pe = K >>> 0 < pe >>> 0 ? n + 1 | 0 : n, Pr(ui, K, pe & 1048575, 0, 0, 15632, 16, 0, 0), Ii = P + 3552 | 0, Pr(Ii, ei, nr, 0, 0, Yr, Ti, 0, 0), ui = P + 3600 | 0, Pr(ui, di, gr, 0, 0, di, gr, 0, 0), nr = P + 3392 | 0, Pr(nr, ai, wi, 0, 0, tr, Me, 0, 0), wi = P + 3376 | 0, tr = wi, Me = (a | 0) == (pe | 0) & K >>> 0 < Tt >>> 0 | a >>> 0 > pe >>> 0, Tt = (a | 0) == (Li | 0) & Tt >>> 0 < lr >>> 0 | a >>> 0 < Li >>> 0, K = Di + 8 | 0, a = t[K >> 2], n = Ki + 8 | 0, gr = a + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[K + 4 >> 2] | 0, n = a >>> 0 > gr >>> 0 ? n + 1 | 0 : n, K = Tt + gr | 0, n = K >>> 0 < gr >>> 0 ? n + 1 | 0 : n, b = b >>> 20 | 0, a = b + K | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, b = a, a = a + Me | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, K = a << 12 | pe >>> 20, pe = t[P + 3392 >> 2], Me = K + pe | 0, b = n, a = n << 12 | a >>> 20, n = a + t[P + 3396 >> 2] | 0, n = pe >>> 0 > Me >>> 0 ? n + 1 | 0 : n, Pr(tr, Me, n, 0, 0, 15632, 16, 0, 0), jr = P + 3360 | 0, Tt = jr, K = (n | 0) == (a | 0) & K >>> 0 > Me >>> 0 | n >>> 0 < a >>> 0, n = nr + 8 | 0, pe = t[n >> 2], n = t[n + 4 >> 2], b = b >>> 20 | 0, a = b + pe | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, b = a, a = a + K | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, Pr(Tt, a, n, 0, 0, 64028672, 65536, 0, 0), b = t[P + 3440 >> 2], a = t[P + 3680 >> 2], tr = b + a | 0, K = t[P + 3444 >> 2], n = K + t[P + 3684 >> 2] | 0, pe = a >>> 0 > tr >>> 0 ? n + 1 | 0 : n, K = (K | 0) == (pe | 0) & b >>> 0 > tr >>> 0 | K >>> 0 > pe >>> 0, b = Dn + 8 | 0, a = t[b >> 2], n = kn + 8 | 0, Tt = a + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[b + 4 >> 2] | 0, n = a >>> 0 > Tt >>> 0 ? n + 1 | 0 : n, a = K + Tt | 0, n = a >>> 0 < Tt >>> 0 ? n + 1 | 0 : n, lr = pe, K = a << 12 | pe >>> 20, b = n, pe = n << 12 | a >>> 20, Me = t[P + 3408 >> 2], a = t[P + 3616 >> 2], Tt = Me + a | 0, gr = t[P + 3412 >> 2], n = gr + t[P + 3620 >> 2] | 0, a = a >>> 0 > Tt >>> 0 ? n + 1 | 0 : n, n = a + pe | 0, pe = K + Tt | 0, K = pe >>> 0 < Tt >>> 0 ? n + 1 | 0 : n, nr = (a | 0) == (K | 0) & pe >>> 0 < Tt >>> 0 | a >>> 0 > K >>> 0, Me = (a | 0) == (gr | 0) & Me >>> 0 > Tt >>> 0 | a >>> 0 < gr >>> 0, Tt = Qi + 8 | 0, a = t[Tt >> 2], n = Ei + 8 | 0, gr = a + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[Tt + 4 >> 2] | 0, n = a >>> 0 > gr >>> 0 ? n + 1 | 0 : n, Tt = Me + gr | 0, n = Tt >>> 0 < gr >>> 0 ? n + 1 | 0 : n, b = b >>> 20 | 0, a = b + Tt | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, b = a, a = a + nr | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, gr = K, Tt = a << 12 | K >>> 20, b = n, K = n << 12 | a >>> 20, ai = t[P + 3552 >> 2], a = t[P + 3600 >> 2], nr = ai + a | 0, Ei = t[P + 3556 >> 2], n = Ei + t[P + 3604 >> 2] | 0, n = a >>> 0 > nr >>> 0 ? n + 1 | 0 : n, a = t[P + 3376 >> 2], Me = a + nr | 0, ei = n, n = n + t[P + 3380 >> 2] | 0, a = a >>> 0 > Me >>> 0 ? n + 1 | 0 : n, n = a + K | 0, K = Me + Tt | 0, Tt = K >>> 0 < Me >>> 0 ? n + 1 | 0 : n, Ti = (a | 0) == (Tt | 0) & K >>> 0 < Me >>> 0 | a >>> 0 > Tt >>> 0, Yr = (a | 0) == (ei | 0) & Me >>> 0 < nr >>> 0 | a >>> 0 < ei >>> 0, n = wi + 8 | 0, di = t[n >> 2], wi = t[n + 4 >> 2], nr = (ei | 0) == (Ei | 0) & nr >>> 0 < ai >>> 0 | ei >>> 0 < Ei >>> 0, Me = ui + 8 | 0, a = t[Me >> 2], n = Ii + 8 | 0, ei = a + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[Me + 4 >> 2] | 0, n = a >>> 0 > ei >>> 0 ? n + 1 | 0 : n, a = nr + ei | 0, n = (a >>> 0 < ei >>> 0 ? n + 1 | 0 : n) + wi | 0, nr = a, a = a + di | 0, n = nr >>> 0 > a >>> 0 ? n + 1 | 0 : n, Me = a + Yr | 0, n = Me >>> 0 < a >>> 0 ? n + 1 | 0 : n, b = b >>> 20 | 0, a = b + Me | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, b = a, a = a + Ti | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, nr = Tt, ei = a << 12 | Tt >>> 20, b = n, Me = n << 12 | a >>> 20, di = t[P + 3360 >> 2], Tt = di + (kr & -2) | 0, wi = t[P + 3364 >> 2], n = wi + (or & 1048575) | 0, n = Tt >>> 0 < di >>> 0 ? n + 1 | 0 : n, kr = Tt, Tt = Tt + ei | 0, a = n, n = n + Me | 0, or = Ce, ei = Nr & 65535, Me = Tt >>> 0 < kr >>> 0 ? n + 1 | 0 : n, Nr = (a | 0) == (Me | 0) & Tt >>> 0 < kr >>> 0 | a >>> 0 > Me >>> 0, a = (a | 0) == (wi | 0) & kr >>> 0 < di >>> 0 | a >>> 0 < wi >>> 0, n = jr + 8 | 0, Ce = a + t[n >> 2] | 0, n = t[n + 4 >> 2], n = a >>> 0 > Ce >>> 0 ? n + 1 | 0 : n, b = b >>> 20 | 0, a = b + Ce | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, b = a, a = a + Nr | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, Ce = a << 12 | Me >>> 20, b = Ce + or | 0, n = ei + (n << 12 | a >>> 20) | 0, a = b, Ce = a >>> 0 < Ce >>> 0 ? n + 1 | 0 : n, Me = Me & 1048575, nr = nr & 1048575, or = gr & 1048575, b = tr, tr = lr & 1048575, l = l - 1 | 0, !!l; )
      ;
    for (l = P + 7376 | 0, kr = l + 32 | 0, t[kr >> 2] = a, t[kr + 4 >> 2] = Ce, Nr = l + 24 | 0, t[Nr >> 2] = Tt, t[Nr + 4 >> 2] = Me, lr = l + 16 | 0, t[lr >> 2] = K, t[lr + 4 >> 2] = nr, gr = l + 8 | 0, t[gr >> 2] = pe, t[gr + 4 >> 2] = or, t[P + 7376 >> 2] = b, t[P + 7380 >> 2] = tr, zr(l, l, P + 7416 | 0), Ce = t[kr + 4 >> 2], n = P + 7336 | 0, l = n + 32 | 0, a = t[kr >> 2], t[l >> 2] = a, t[l + 4 >> 2] = Ce, Me = t[Nr + 4 >> 2], l = n + 24 | 0, Tt = t[Nr >> 2], t[l >> 2] = Tt, t[l + 4 >> 2] = Me, nr = t[lr + 4 >> 2], l = n + 16 | 0, K = t[lr >> 2], t[l >> 2] = K, t[l + 4 >> 2] = nr, or = t[gr + 4 >> 2], l = n + 8 | 0, pe = t[gr >> 2], t[l >> 2] = pe, t[l + 4 >> 2] = or, tr = t[P + 7380 >> 2], b = t[P + 7376 >> 2], t[P + 7336 >> 2] = b, t[P + 7340 >> 2] = tr, l = 22; lr = b, n = tr << 1 | b >>> 31, Ii = P + 3328 | 0, Yr = b << 1, Ti = n, Pr(Ii, Tt, Me, 0, 0, Yr, n, 0, 0), jr = P + 3248 | 0, b = pe << 1, gr = or, di = pe, pe = or << 1 | pe >>> 31, Pr(jr, K, nr, 0, 0, b, pe, 0, 0), kr = P + 3184 | 0, Pr(kr, a, Ce, 0, 0, a, Ce, 0, 0), Nr = P + 3168 | 0, Pr(Nr, t[P + 3184 >> 2], t[P + 3188 >> 2], 0, 0, 15632, 16, 0, 0), n = Ce << 1 | a >>> 31, Wi = P + 3136 | 0, ai = a << 1, wi = n, Pr(Wi, ai, n, 0, 0, lr, tr, 0, 0), Xi = P + 3296 | 0, Pr(Xi, Tt, Me, 0, 0, b, pe, 0, 0), Mn = P + 3232 | 0, Pr(Mn, K, nr, 0, 0, K, nr, 0, 0), ui = P + 3152 | 0, n = kr + 8 | 0, Pr(ui, t[n >> 2], t[n + 4 >> 2], 0, 0, 64028672, 65536, 0, 0), Dn = P + 3344 | 0, Pr(Dn, lr, tr, 0, 0, lr, tr, 0, 0), $i = P + 3120 | 0, Pr($i, ai, wi, 0, 0, di, or, 0, 0), In = P + 3200 | 0, tr = Tt, ei = K, Pr(In, Tt, Me, 0, 0, K << 1, nr << 1 | K >>> 31, 0, 0), lr = t[P + 3332 >> 2], n = lr + t[P + 3252 >> 2] | 0, K = t[P + 3328 >> 2], b = t[P + 3248 >> 2], a = K + b | 0, pe = t[P + 3168 >> 2], kr = a + pe | 0, b = a >>> 0 < b >>> 0 ? n + 1 | 0 : n, n = b + t[P + 3172 >> 2] | 0, pe = pe >>> 0 > kr >>> 0 ? n + 1 | 0 : n, or = (b | 0) == (pe | 0) & a >>> 0 > kr >>> 0 | b >>> 0 > pe >>> 0, n = Nr + 8 | 0, Ce = t[n >> 2], Tt = t[n + 4 >> 2], K = (b | 0) == (lr | 0) & a >>> 0 < K >>> 0 | b >>> 0 < lr >>> 0, b = jr + 8 | 0, a = t[b >> 2], n = Ii + 8 | 0, lr = a + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[b + 4 >> 2] | 0, n = a >>> 0 > lr >>> 0 ? n + 1 | 0 : n, a = K + lr | 0, n = (a >>> 0 < lr >>> 0 ? n + 1 | 0 : n) + Tt | 0, b = a, a = a + Ce | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, b = a, a = a + or | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, or = pe, Tt = a << 12 | pe >>> 20, b = n, K = n << 12 | a >>> 20, Li = t[P + 3296 >> 2], a = t[P + 3232 >> 2], lr = Li + a | 0, zn = t[P + 3300 >> 2], n = zn + t[P + 3236 >> 2] | 0, n = a >>> 0 > lr >>> 0 ? n + 1 | 0 : n, a = t[P + 3136 >> 2], Ce = a + lr | 0, jr = n, n = n + t[P + 3140 >> 2] | 0, n = a >>> 0 > Ce >>> 0 ? n + 1 | 0 : n, a = t[P + 3152 >> 2], pe = a + Ce | 0, Nr = n, n = n + t[P + 3156 >> 2] | 0, a = a >>> 0 > pe >>> 0 ? n + 1 | 0 : n, n = a + K | 0, kn = P + 3104 | 0, Tt = pe + Tt | 0, K = Tt >>> 0 < pe >>> 0 ? n + 1 | 0 : n, Qi = (a | 0) == (K | 0) & pe >>> 0 > Tt >>> 0 | a >>> 0 > K >>> 0, Ki = (a | 0) == (Nr | 0) & pe >>> 0 < Ce >>> 0 | a >>> 0 < Nr >>> 0, n = ui + 8 | 0, Di = t[n >> 2], Ei = t[n + 4 >> 2], Ii = (Nr | 0) == (jr | 0) & Ce >>> 0 < lr >>> 0 | Nr >>> 0 < jr >>> 0, n = Wi + 8 | 0, ui = t[n >> 2], Nr = t[n + 4 >> 2], Ce = (jr | 0) == (zn | 0) & lr >>> 0 < Li >>> 0 | jr >>> 0 < zn >>> 0, pe = Mn + 8 | 0, a = t[pe >> 2], n = Xi + 8 | 0, lr = a + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[pe + 4 >> 2] | 0, n = a >>> 0 > lr >>> 0 ? n + 1 | 0 : n, a = Ce + lr | 0, n = (a >>> 0 < lr >>> 0 ? n + 1 | 0 : n) + Nr | 0, pe = a, a = a + ui | 0, n = pe >>> 0 > a >>> 0 ? n + 1 | 0 : n, pe = a, a = a + Ii | 0, n = (pe >>> 0 > a >>> 0 ? n + 1 | 0 : n) + Ei | 0, pe = a, a = a + Di | 0, n = pe >>> 0 > a >>> 0 ? n + 1 | 0 : n, pe = a + Ki | 0, n = pe >>> 0 < a >>> 0 ? n + 1 | 0 : n, b = b >>> 20 | 0, a = b + pe | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, b = a, a = a + Qi | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, b = K, Ce = a << 12 | b >>> 20, pe = n, Nr = n << 12 | a >>> 20, Li = t[P + 3124 >> 2], n = Li + t[P + 3204 >> 2] | 0, Ii = t[P + 3120 >> 2], a = t[P + 3200 >> 2], K = Ii + a | 0, lr = K, Ce = K + Ce | 0, a = a >>> 0 > K >>> 0 ? n + 1 | 0 : n, n = a + Nr | 0, ui = Ce << 4 & -16, K = Ce >>> 0 < K >>> 0 ? n + 1 | 0 : n, jr = (K << 4 | Ce >>> 28) & 16777215, Nr = b, Pr(kn, ui | b >>> 16 & 15, jr, 0, 0, 977, 1, 0, 0), Qi = P + 3280 | 0, Pr(Qi, di, gr, 0, 0, Yr, Ti, 0, 0), Ki = P + 3088 | 0, Pr(Ki, ai, wi, 0, 0, ei, nr, 0, 0), Di = P + 3312 | 0, Pr(Di, tr, Me, 0, 0, tr, Me, 0, 0), Ei = P + 3072 | 0, ui = Ei, jr = (a | 0) == (K | 0) & Ce >>> 0 < lr >>> 0 | a >>> 0 > K >>> 0, Ce = (a | 0) == (Li | 0) & lr >>> 0 < Ii >>> 0 | a >>> 0 < Li >>> 0, b = In + 8 | 0, a = t[b >> 2], n = $i + 8 | 0, lr = a + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[b + 4 >> 2] | 0, n = a >>> 0 > lr >>> 0 ? n + 1 | 0 : n, b = Ce + lr | 0, n = b >>> 0 < lr >>> 0 ? n + 1 | 0 : n, pe = pe >>> 20 | 0, a = b + pe | 0, n = pe >>> 0 > a >>> 0 ? n + 1 | 0 : n, b = a, a = a + jr | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, K = a << 12 | K >>> 20, b = n, jr = n << 12 | a >>> 20, Li = t[P + 3092 >> 2], n = Li + t[P + 3316 >> 2] | 0, lr = t[P + 3088 >> 2], a = t[P + 3312 >> 2], pe = lr + a | 0, Ce = pe, K = pe + K | 0, a = a >>> 0 > pe >>> 0 ? n + 1 | 0 : n, n = a + jr | 0, pe = K >>> 0 < pe >>> 0 ? n + 1 | 0 : n, Pr(ui, K, pe & 1048575, 0, 0, 15632, 16, 0, 0), Ii = P + 3216 | 0, Pr(Ii, ei, nr, 0, 0, Yr, Ti, 0, 0), ui = P + 3264 | 0, Pr(ui, di, gr, 0, 0, di, gr, 0, 0), nr = P + 3056 | 0, Pr(nr, ai, wi, 0, 0, tr, Me, 0, 0), wi = P + 3040 | 0, tr = wi, Me = (a | 0) == (pe | 0) & K >>> 0 < Ce >>> 0 | a >>> 0 > pe >>> 0, Ce = (a | 0) == (Li | 0) & Ce >>> 0 < lr >>> 0 | a >>> 0 < Li >>> 0, K = Di + 8 | 0, a = t[K >> 2], n = Ki + 8 | 0, gr = a + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[K + 4 >> 2] | 0, n = a >>> 0 > gr >>> 0 ? n + 1 | 0 : n, K = Ce + gr | 0, n = K >>> 0 < gr >>> 0 ? n + 1 | 0 : n, b = b >>> 20 | 0, a = b + K | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, b = a, a = a + Me | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, K = a << 12 | pe >>> 20, pe = t[P + 3056 >> 2], Me = K + pe | 0, b = n, a = n << 12 | a >>> 20, n = a + t[P + 3060 >> 2] | 0, n = pe >>> 0 > Me >>> 0 ? n + 1 | 0 : n, Pr(tr, Me, n, 0, 0, 15632, 16, 0, 0), jr = P + 3024 | 0, Ce = jr, K = (n | 0) == (a | 0) & K >>> 0 > Me >>> 0 | n >>> 0 < a >>> 0, n = nr + 8 | 0, pe = t[n >> 2], n = t[n + 4 >> 2], b = b >>> 20 | 0, a = b + pe | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, b = a, a = a + K | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, Pr(Ce, a, n, 0, 0, 64028672, 65536, 0, 0), b = t[P + 3104 >> 2], a = t[P + 3344 >> 2], tr = b + a | 0, K = t[P + 3108 >> 2], n = K + t[P + 3348 >> 2] | 0, pe = a >>> 0 > tr >>> 0 ? n + 1 | 0 : n, K = (K | 0) == (pe | 0) & b >>> 0 > tr >>> 0 | K >>> 0 > pe >>> 0, b = Dn + 8 | 0, a = t[b >> 2], n = kn + 8 | 0, Ce = a + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[b + 4 >> 2] | 0, n = a >>> 0 > Ce >>> 0 ? n + 1 | 0 : n, a = K + Ce | 0, n = a >>> 0 < Ce >>> 0 ? n + 1 | 0 : n, lr = pe, Ce = a << 12 | pe >>> 20, b = n, K = n << 12 | a >>> 20, Me = t[P + 3072 >> 2], a = t[P + 3280 >> 2], pe = Me + a | 0, gr = t[P + 3076 >> 2], n = gr + t[P + 3284 >> 2] | 0, n = a >>> 0 > pe >>> 0 ? n + 1 | 0 : n, a = Ce, Ce = pe, pe = a + pe | 0, a = n, n = n + K | 0, K = pe >>> 0 < Ce >>> 0 ? n + 1 | 0 : n, nr = (a | 0) == (K | 0) & pe >>> 0 < Ce >>> 0 | a >>> 0 > K >>> 0, Me = (a | 0) == (gr | 0) & Ce >>> 0 < Me >>> 0 | a >>> 0 < gr >>> 0, Ce = Qi + 8 | 0, a = t[Ce >> 2], n = Ei + 8 | 0, gr = a + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[Ce + 4 >> 2] | 0, n = a >>> 0 > gr >>> 0 ? n + 1 | 0 : n, Ce = Me + gr | 0, n = Ce >>> 0 < gr >>> 0 ? n + 1 | 0 : n, b = b >>> 20 | 0, a = b + Ce | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, b = a, a = a + nr | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, gr = K, Ce = a << 12 | K >>> 20, b = n, K = n << 12 | a >>> 20, ai = t[P + 3216 >> 2], a = t[P + 3264 >> 2], nr = ai + a | 0, Ei = t[P + 3220 >> 2], n = Ei + t[P + 3268 >> 2] | 0, n = a >>> 0 > nr >>> 0 ? n + 1 | 0 : n, a = t[P + 3040 >> 2], Me = a + nr | 0, ei = n, n = n + t[P + 3044 >> 2] | 0, a = a >>> 0 > Me >>> 0 ? n + 1 | 0 : n, n = a + K | 0, K = Ce + Me | 0, Ce = K >>> 0 < Me >>> 0 ? n + 1 | 0 : n, Ti = (a | 0) == (Ce | 0) & K >>> 0 < Me >>> 0 | a >>> 0 > Ce >>> 0, Yr = (a | 0) == (ei | 0) & Me >>> 0 < nr >>> 0 | a >>> 0 < ei >>> 0, n = wi + 8 | 0, di = t[n >> 2], wi = t[n + 4 >> 2], nr = (ei | 0) == (Ei | 0) & nr >>> 0 < ai >>> 0 | ei >>> 0 < Ei >>> 0, Me = ui + 8 | 0, a = t[Me >> 2], n = Ii + 8 | 0, ei = a + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[Me + 4 >> 2] | 0, n = a >>> 0 > ei >>> 0 ? n + 1 | 0 : n, a = nr + ei | 0, n = (a >>> 0 < ei >>> 0 ? n + 1 | 0 : n) + wi | 0, nr = a, a = a + di | 0, n = nr >>> 0 > a >>> 0 ? n + 1 | 0 : n, Me = a + Yr | 0, n = Me >>> 0 < a >>> 0 ? n + 1 | 0 : n, b = b >>> 20 | 0, a = b + Me | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, b = a, a = a + Ti | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, nr = Ce, Me = a << 12 | Ce >>> 20, b = n, Ce = n << 12 | a >>> 20, di = t[P + 3024 >> 2], kr = di + (kr & -2) | 0, wi = t[P + 3028 >> 2], n = wi + (or & 1048575) | 0, a = kr >>> 0 < di >>> 0 ? n + 1 | 0 : n, n = a + Ce | 0, or = Tt, ei = Nr & 65535, Me = Me + kr | 0, Ce = Me >>> 0 < kr >>> 0 ? n + 1 | 0 : n, Tt = Me, Nr = (a | 0) == (Ce | 0) & Me >>> 0 < kr >>> 0 | a >>> 0 > Ce >>> 0, a = (a | 0) == (wi | 0) & kr >>> 0 < di >>> 0 | a >>> 0 < wi >>> 0, n = jr + 8 | 0, Me = a + t[n >> 2] | 0, n = t[n + 4 >> 2], n = a >>> 0 > Me >>> 0 ? n + 1 | 0 : n, b = b >>> 20 | 0, a = b + Me | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, b = a, a = a + Nr | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, b = Ce, Me = a << 12 | b >>> 20, Ce = Me + or | 0, n = ei + (n << 12 | a >>> 20) | 0, a = Ce, Ce = a >>> 0 < Me >>> 0 ? n + 1 | 0 : n, Me = b & 1048575, nr = nr & 1048575, or = gr & 1048575, b = tr, tr = lr & 1048575, l = l - 1 | 0, !!l; )
      ;
    for (l = P + 7336 | 0, kr = l + 32 | 0, t[kr >> 2] = a, t[kr + 4 >> 2] = Ce, Nr = l + 24 | 0, t[Nr >> 2] = Tt, t[Nr + 4 >> 2] = Me, lr = l + 16 | 0, t[lr >> 2] = K, t[lr + 4 >> 2] = nr, gr = l + 8 | 0, t[gr >> 2] = pe, t[gr + 4 >> 2] = or, t[P + 7336 >> 2] = b, t[P + 7340 >> 2] = tr, zr(l, l, P + 7376 | 0), Ce = t[kr + 4 >> 2], n = P + 7296 | 0, l = n + 32 | 0, a = t[kr >> 2], t[l >> 2] = a, t[l + 4 >> 2] = Ce, Me = t[Nr + 4 >> 2], l = n + 24 | 0, Tt = t[Nr >> 2], t[l >> 2] = Tt, t[l + 4 >> 2] = Me, nr = t[lr + 4 >> 2], l = n + 16 | 0, K = t[lr >> 2], t[l >> 2] = K, t[l + 4 >> 2] = nr, or = t[gr + 4 >> 2], l = n + 8 | 0, pe = t[gr >> 2], t[l >> 2] = pe, t[l + 4 >> 2] = or, tr = t[P + 7340 >> 2], b = t[P + 7336 >> 2], t[P + 7296 >> 2] = b, t[P + 7300 >> 2] = tr, l = 44; lr = b, n = tr << 1 | b >>> 31, Ii = P + 2992 | 0, Yr = b << 1, Ti = n, Pr(Ii, Tt, Me, 0, 0, Yr, n, 0, 0), jr = P + 2912 | 0, b = pe << 1, gr = or, di = pe, pe = or << 1 | pe >>> 31, Pr(jr, K, nr, 0, 0, b, pe, 0, 0), kr = P + 2848 | 0, Pr(kr, a, Ce, 0, 0, a, Ce, 0, 0), Nr = P + 2832 | 0, Pr(Nr, t[P + 2848 >> 2], t[P + 2852 >> 2], 0, 0, 15632, 16, 0, 0), n = Ce << 1 | a >>> 31, Wi = P + 2800 | 0, ai = a << 1, wi = n, Pr(Wi, ai, n, 0, 0, lr, tr, 0, 0), Xi = P + 2960 | 0, Pr(Xi, Tt, Me, 0, 0, b, pe, 0, 0), Mn = P + 2896 | 0, Pr(Mn, K, nr, 0, 0, K, nr, 0, 0), ui = P + 2816 | 0, n = kr + 8 | 0, Pr(ui, t[n >> 2], t[n + 4 >> 2], 0, 0, 64028672, 65536, 0, 0), Dn = P + 3008 | 0, Pr(Dn, lr, tr, 0, 0, lr, tr, 0, 0), $i = P + 2784 | 0, Pr($i, ai, wi, 0, 0, di, or, 0, 0), In = P + 2864 | 0, tr = Tt, ei = K, Pr(In, Tt, Me, 0, 0, K << 1, nr << 1 | K >>> 31, 0, 0), lr = t[P + 2996 >> 2], n = lr + t[P + 2916 >> 2] | 0, K = t[P + 2992 >> 2], b = t[P + 2912 >> 2], a = K + b | 0, pe = t[P + 2832 >> 2], kr = a + pe | 0, b = a >>> 0 < b >>> 0 ? n + 1 | 0 : n, n = b + t[P + 2836 >> 2] | 0, pe = pe >>> 0 > kr >>> 0 ? n + 1 | 0 : n, or = (b | 0) == (pe | 0) & a >>> 0 > kr >>> 0 | b >>> 0 > pe >>> 0, n = Nr + 8 | 0, Ce = t[n >> 2], Tt = t[n + 4 >> 2], K = (b | 0) == (lr | 0) & a >>> 0 < K >>> 0 | b >>> 0 < lr >>> 0, b = jr + 8 | 0, a = t[b >> 2], n = Ii + 8 | 0, lr = a + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[b + 4 >> 2] | 0, n = a >>> 0 > lr >>> 0 ? n + 1 | 0 : n, a = K + lr | 0, n = (a >>> 0 < lr >>> 0 ? n + 1 | 0 : n) + Tt | 0, b = a, a = a + Ce | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, b = a, a = a + or | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, or = pe, Ce = a << 12 | pe >>> 20, b = n, K = n << 12 | a >>> 20, Li = t[P + 2960 >> 2], a = t[P + 2896 >> 2], lr = Li + a | 0, zn = t[P + 2964 >> 2], n = zn + t[P + 2900 >> 2] | 0, n = a >>> 0 > lr >>> 0 ? n + 1 | 0 : n, a = t[P + 2800 >> 2], Tt = a + lr | 0, jr = n, n = n + t[P + 2804 >> 2] | 0, n = a >>> 0 > Tt >>> 0 ? n + 1 | 0 : n, a = t[P + 2816 >> 2], pe = a + Tt | 0, Nr = n, n = n + t[P + 2820 >> 2] | 0, a = a >>> 0 > pe >>> 0 ? n + 1 | 0 : n, n = a + K | 0, kn = P + 2768 | 0, Ce = pe + Ce | 0, K = Ce >>> 0 < pe >>> 0 ? n + 1 | 0 : n, Qi = (a | 0) == (K | 0) & pe >>> 0 > Ce >>> 0 | a >>> 0 > K >>> 0, Ki = (a | 0) == (Nr | 0) & pe >>> 0 < Tt >>> 0 | a >>> 0 < Nr >>> 0, n = ui + 8 | 0, Di = t[n >> 2], Ei = t[n + 4 >> 2], Ii = (Nr | 0) == (jr | 0) & Tt >>> 0 < lr >>> 0 | Nr >>> 0 < jr >>> 0, n = Wi + 8 | 0, ui = t[n >> 2], Nr = t[n + 4 >> 2], Tt = (jr | 0) == (zn | 0) & lr >>> 0 < Li >>> 0 | jr >>> 0 < zn >>> 0, pe = Mn + 8 | 0, a = t[pe >> 2], n = Xi + 8 | 0, lr = a + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[pe + 4 >> 2] | 0, n = a >>> 0 > lr >>> 0 ? n + 1 | 0 : n, a = Tt + lr | 0, n = (a >>> 0 < lr >>> 0 ? n + 1 | 0 : n) + Nr | 0, pe = a, a = a + ui | 0, n = pe >>> 0 > a >>> 0 ? n + 1 | 0 : n, pe = a, a = a + Ii | 0, n = (pe >>> 0 > a >>> 0 ? n + 1 | 0 : n) + Ei | 0, pe = a, a = a + Di | 0, n = pe >>> 0 > a >>> 0 ? n + 1 | 0 : n, pe = a + Ki | 0, n = pe >>> 0 < a >>> 0 ? n + 1 | 0 : n, b = b >>> 20 | 0, a = b + pe | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, b = a, a = a + Qi | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, b = K, Tt = a << 12 | b >>> 20, pe = n, Nr = n << 12 | a >>> 20, Li = t[P + 2788 >> 2], n = Li + t[P + 2868 >> 2] | 0, Ii = t[P + 2784 >> 2], a = t[P + 2864 >> 2], K = Ii + a | 0, lr = K, Tt = K + Tt | 0, a = a >>> 0 > K >>> 0 ? n + 1 | 0 : n, n = a + Nr | 0, ui = Tt << 4 & -16, K = Tt >>> 0 < K >>> 0 ? n + 1 | 0 : n, jr = (K << 4 | Tt >>> 28) & 16777215, Nr = b, Pr(kn, ui | b >>> 16 & 15, jr, 0, 0, 977, 1, 0, 0), Qi = P + 2944 | 0, Pr(Qi, di, gr, 0, 0, Yr, Ti, 0, 0), Ki = P + 2752 | 0, Pr(Ki, ai, wi, 0, 0, ei, nr, 0, 0), Di = P + 2976 | 0, Pr(Di, tr, Me, 0, 0, tr, Me, 0, 0), Ei = P + 2736 | 0, ui = Ei, jr = (a | 0) == (K | 0) & Tt >>> 0 < lr >>> 0 | a >>> 0 > K >>> 0, Tt = (a | 0) == (Li | 0) & lr >>> 0 < Ii >>> 0 | a >>> 0 < Li >>> 0, b = In + 8 | 0, a = t[b >> 2], n = $i + 8 | 0, lr = a + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[b + 4 >> 2] | 0, n = a >>> 0 > lr >>> 0 ? n + 1 | 0 : n, b = Tt + lr | 0, n = b >>> 0 < lr >>> 0 ? n + 1 | 0 : n, pe = pe >>> 20 | 0, a = b + pe | 0, n = pe >>> 0 > a >>> 0 ? n + 1 | 0 : n, b = a, a = a + jr | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, K = a << 12 | K >>> 20, b = n, jr = n << 12 | a >>> 20, Li = t[P + 2756 >> 2], n = Li + t[P + 2980 >> 2] | 0, lr = t[P + 2752 >> 2], a = t[P + 2976 >> 2], pe = lr + a | 0, Tt = pe, K = pe + K | 0, a = a >>> 0 > pe >>> 0 ? n + 1 | 0 : n, n = a + jr | 0, pe = K >>> 0 < pe >>> 0 ? n + 1 | 0 : n, Pr(ui, K, pe & 1048575, 0, 0, 15632, 16, 0, 0), Ii = P + 2880 | 0, Pr(Ii, ei, nr, 0, 0, Yr, Ti, 0, 0), ui = P + 2928 | 0, Pr(ui, di, gr, 0, 0, di, gr, 0, 0), nr = P + 2720 | 0, Pr(nr, ai, wi, 0, 0, tr, Me, 0, 0), wi = P + 2704 | 0, tr = wi, Me = (a | 0) == (pe | 0) & K >>> 0 < Tt >>> 0 | a >>> 0 > pe >>> 0, Tt = (a | 0) == (Li | 0) & Tt >>> 0 < lr >>> 0 | a >>> 0 < Li >>> 0, K = Di + 8 | 0, a = t[K >> 2], n = Ki + 8 | 0, gr = a + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[K + 4 >> 2] | 0, n = a >>> 0 > gr >>> 0 ? n + 1 | 0 : n, K = Tt + gr | 0, n = K >>> 0 < gr >>> 0 ? n + 1 | 0 : n, b = b >>> 20 | 0, a = b + K | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, b = a, a = a + Me | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, K = a << 12 | pe >>> 20, pe = t[P + 2720 >> 2], Me = K + pe | 0, b = n, a = n << 12 | a >>> 20, n = a + t[P + 2724 >> 2] | 0, n = pe >>> 0 > Me >>> 0 ? n + 1 | 0 : n, Pr(tr, Me, n, 0, 0, 15632, 16, 0, 0), jr = P + 2688 | 0, Tt = jr, K = (n | 0) == (a | 0) & K >>> 0 > Me >>> 0 | n >>> 0 < a >>> 0, n = nr + 8 | 0, pe = t[n >> 2], n = t[n + 4 >> 2], b = b >>> 20 | 0, a = b + pe | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, b = a, a = a + K | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, Pr(Tt, a, n, 0, 0, 64028672, 65536, 0, 0), b = t[P + 2768 >> 2], a = t[P + 3008 >> 2], tr = b + a | 0, K = t[P + 2772 >> 2], n = K + t[P + 3012 >> 2] | 0, pe = a >>> 0 > tr >>> 0 ? n + 1 | 0 : n, K = (K | 0) == (pe | 0) & b >>> 0 > tr >>> 0 | K >>> 0 > pe >>> 0, b = Dn + 8 | 0, a = t[b >> 2], n = kn + 8 | 0, Tt = a + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[b + 4 >> 2] | 0, n = a >>> 0 > Tt >>> 0 ? n + 1 | 0 : n, a = K + Tt | 0, n = a >>> 0 < Tt >>> 0 ? n + 1 | 0 : n, lr = pe, K = a << 12 | pe >>> 20, b = n, pe = n << 12 | a >>> 20, Me = t[P + 2736 >> 2], a = t[P + 2944 >> 2], Tt = Me + a | 0, gr = t[P + 2740 >> 2], n = gr + t[P + 2948 >> 2] | 0, a = a >>> 0 > Tt >>> 0 ? n + 1 | 0 : n, n = a + pe | 0, pe = K + Tt | 0, K = pe >>> 0 < Tt >>> 0 ? n + 1 | 0 : n, nr = (a | 0) == (K | 0) & pe >>> 0 < Tt >>> 0 | a >>> 0 > K >>> 0, Me = (a | 0) == (gr | 0) & Me >>> 0 > Tt >>> 0 | a >>> 0 < gr >>> 0, Tt = Qi + 8 | 0, a = t[Tt >> 2], n = Ei + 8 | 0, gr = a + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[Tt + 4 >> 2] | 0, n = a >>> 0 > gr >>> 0 ? n + 1 | 0 : n, Tt = Me + gr | 0, n = Tt >>> 0 < gr >>> 0 ? n + 1 | 0 : n, b = b >>> 20 | 0, a = b + Tt | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, b = a, a = a + nr | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, gr = K, Tt = a << 12 | K >>> 20, b = n, K = n << 12 | a >>> 20, ai = t[P + 2880 >> 2], a = t[P + 2928 >> 2], nr = ai + a | 0, Ei = t[P + 2884 >> 2], n = Ei + t[P + 2932 >> 2] | 0, n = a >>> 0 > nr >>> 0 ? n + 1 | 0 : n, a = t[P + 2704 >> 2], Me = a + nr | 0, ei = n, n = n + t[P + 2708 >> 2] | 0, a = a >>> 0 > Me >>> 0 ? n + 1 | 0 : n, n = a + K | 0, K = Me + Tt | 0, Tt = K >>> 0 < Me >>> 0 ? n + 1 | 0 : n, Ti = (a | 0) == (Tt | 0) & K >>> 0 < Me >>> 0 | a >>> 0 > Tt >>> 0, Yr = (a | 0) == (ei | 0) & Me >>> 0 < nr >>> 0 | a >>> 0 < ei >>> 0, n = wi + 8 | 0, di = t[n >> 2], wi = t[n + 4 >> 2], nr = (ei | 0) == (Ei | 0) & nr >>> 0 < ai >>> 0 | ei >>> 0 < Ei >>> 0, Me = ui + 8 | 0, a = t[Me >> 2], n = Ii + 8 | 0, ei = a + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[Me + 4 >> 2] | 0, n = a >>> 0 > ei >>> 0 ? n + 1 | 0 : n, a = nr + ei | 0, n = (a >>> 0 < ei >>> 0 ? n + 1 | 0 : n) + wi | 0, nr = a, a = a + di | 0, n = nr >>> 0 > a >>> 0 ? n + 1 | 0 : n, Me = a + Yr | 0, n = Me >>> 0 < a >>> 0 ? n + 1 | 0 : n, b = b >>> 20 | 0, a = b + Me | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, b = a, a = a + Ti | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, nr = Tt, ei = a << 12 | Tt >>> 20, b = n, Me = n << 12 | a >>> 20, di = t[P + 2688 >> 2], Tt = di + (kr & -2) | 0, wi = t[P + 2692 >> 2], n = wi + (or & 1048575) | 0, n = Tt >>> 0 < di >>> 0 ? n + 1 | 0 : n, kr = Tt, Tt = Tt + ei | 0, a = n, n = n + Me | 0, or = Ce, ei = Nr & 65535, Me = Tt >>> 0 < kr >>> 0 ? n + 1 | 0 : n, Nr = (a | 0) == (Me | 0) & Tt >>> 0 < kr >>> 0 | a >>> 0 > Me >>> 0, a = (a | 0) == (wi | 0) & kr >>> 0 < di >>> 0 | a >>> 0 < wi >>> 0, n = jr + 8 | 0, Ce = a + t[n >> 2] | 0, n = t[n + 4 >> 2], n = a >>> 0 > Ce >>> 0 ? n + 1 | 0 : n, b = b >>> 20 | 0, a = b + Ce | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, b = a, a = a + Nr | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, Ce = a << 12 | Me >>> 20, b = Ce + or | 0, n = ei + (n << 12 | a >>> 20) | 0, a = b, Ce = a >>> 0 < Ce >>> 0 ? n + 1 | 0 : n, Me = Me & 1048575, nr = nr & 1048575, or = gr & 1048575, b = tr, tr = lr & 1048575, l = l - 1 | 0, !!l; )
      ;
    for (l = P + 7296 | 0, kr = l + 32 | 0, t[kr >> 2] = a, t[kr + 4 >> 2] = Ce, Nr = l + 24 | 0, t[Nr >> 2] = Tt, t[Nr + 4 >> 2] = Me, lr = l + 16 | 0, t[lr >> 2] = K, t[lr + 4 >> 2] = nr, gr = l + 8 | 0, t[gr >> 2] = pe, t[gr + 4 >> 2] = or, t[P + 7296 >> 2] = b, t[P + 7300 >> 2] = tr, zr(l, l, P + 7336 | 0), Ce = t[kr + 4 >> 2], n = P + 7256 | 0, l = n + 32 | 0, a = t[kr >> 2], t[l >> 2] = a, t[l + 4 >> 2] = Ce, Me = t[Nr + 4 >> 2], l = n + 24 | 0, Tt = t[Nr >> 2], t[l >> 2] = Tt, t[l + 4 >> 2] = Me, nr = t[lr + 4 >> 2], l = n + 16 | 0, K = t[lr >> 2], t[l >> 2] = K, t[l + 4 >> 2] = nr, or = t[gr + 4 >> 2], l = n + 8 | 0, pe = t[gr >> 2], t[l >> 2] = pe, t[l + 4 >> 2] = or, tr = t[P + 7300 >> 2], b = t[P + 7296 >> 2], t[P + 7256 >> 2] = b, t[P + 7260 >> 2] = tr, l = 88; lr = b, n = tr << 1 | b >>> 31, Ii = P + 2656 | 0, Yr = b << 1, Ti = n, Pr(Ii, Tt, Me, 0, 0, Yr, n, 0, 0), jr = P + 2576 | 0, b = pe << 1, gr = or, di = pe, pe = or << 1 | pe >>> 31, Pr(jr, K, nr, 0, 0, b, pe, 0, 0), kr = P + 2512 | 0, Pr(kr, a, Ce, 0, 0, a, Ce, 0, 0), Nr = P + 2496 | 0, Pr(Nr, t[P + 2512 >> 2], t[P + 2516 >> 2], 0, 0, 15632, 16, 0, 0), n = Ce << 1 | a >>> 31, Wi = P + 2464 | 0, ai = a << 1, wi = n, Pr(Wi, ai, n, 0, 0, lr, tr, 0, 0), Xi = P + 2624 | 0, Pr(Xi, Tt, Me, 0, 0, b, pe, 0, 0), Mn = P + 2560 | 0, Pr(Mn, K, nr, 0, 0, K, nr, 0, 0), ui = P + 2480 | 0, n = kr + 8 | 0, Pr(ui, t[n >> 2], t[n + 4 >> 2], 0, 0, 64028672, 65536, 0, 0), Dn = P + 2672 | 0, Pr(Dn, lr, tr, 0, 0, lr, tr, 0, 0), $i = P + 2448 | 0, Pr($i, ai, wi, 0, 0, di, or, 0, 0), In = P + 2528 | 0, tr = Tt, ei = K, Pr(In, Tt, Me, 0, 0, K << 1, nr << 1 | K >>> 31, 0, 0), lr = t[P + 2660 >> 2], n = lr + t[P + 2580 >> 2] | 0, K = t[P + 2656 >> 2], b = t[P + 2576 >> 2], a = K + b | 0, pe = t[P + 2496 >> 2], kr = a + pe | 0, b = a >>> 0 < b >>> 0 ? n + 1 | 0 : n, n = b + t[P + 2500 >> 2] | 0, pe = pe >>> 0 > kr >>> 0 ? n + 1 | 0 : n, or = (b | 0) == (pe | 0) & a >>> 0 > kr >>> 0 | b >>> 0 > pe >>> 0, n = Nr + 8 | 0, Ce = t[n >> 2], Tt = t[n + 4 >> 2], K = (b | 0) == (lr | 0) & a >>> 0 < K >>> 0 | b >>> 0 < lr >>> 0, b = jr + 8 | 0, a = t[b >> 2], n = Ii + 8 | 0, lr = a + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[b + 4 >> 2] | 0, n = a >>> 0 > lr >>> 0 ? n + 1 | 0 : n, a = K + lr | 0, n = (a >>> 0 < lr >>> 0 ? n + 1 | 0 : n) + Tt | 0, b = a, a = a + Ce | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, b = a, a = a + or | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, or = pe, Tt = a << 12 | pe >>> 20, b = n, K = n << 12 | a >>> 20, Li = t[P + 2624 >> 2], a = t[P + 2560 >> 2], lr = Li + a | 0, zn = t[P + 2628 >> 2], n = zn + t[P + 2564 >> 2] | 0, n = a >>> 0 > lr >>> 0 ? n + 1 | 0 : n, a = t[P + 2464 >> 2], Ce = a + lr | 0, jr = n, n = n + t[P + 2468 >> 2] | 0, n = a >>> 0 > Ce >>> 0 ? n + 1 | 0 : n, a = t[P + 2480 >> 2], pe = a + Ce | 0, Nr = n, n = n + t[P + 2484 >> 2] | 0, a = a >>> 0 > pe >>> 0 ? n + 1 | 0 : n, n = a + K | 0, kn = P + 2432 | 0, Tt = pe + Tt | 0, K = Tt >>> 0 < pe >>> 0 ? n + 1 | 0 : n, Qi = (a | 0) == (K | 0) & pe >>> 0 > Tt >>> 0 | a >>> 0 > K >>> 0, Ki = (a | 0) == (Nr | 0) & pe >>> 0 < Ce >>> 0 | a >>> 0 < Nr >>> 0, n = ui + 8 | 0, Di = t[n >> 2], Ei = t[n + 4 >> 2], Ii = (Nr | 0) == (jr | 0) & Ce >>> 0 < lr >>> 0 | Nr >>> 0 < jr >>> 0, n = Wi + 8 | 0, ui = t[n >> 2], Nr = t[n + 4 >> 2], Ce = (jr | 0) == (zn | 0) & lr >>> 0 < Li >>> 0 | jr >>> 0 < zn >>> 0, pe = Mn + 8 | 0, a = t[pe >> 2], n = Xi + 8 | 0, lr = a + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[pe + 4 >> 2] | 0, n = a >>> 0 > lr >>> 0 ? n + 1 | 0 : n, a = Ce + lr | 0, n = (a >>> 0 < lr >>> 0 ? n + 1 | 0 : n) + Nr | 0, pe = a, a = a + ui | 0, n = pe >>> 0 > a >>> 0 ? n + 1 | 0 : n, pe = a, a = a + Ii | 0, n = (pe >>> 0 > a >>> 0 ? n + 1 | 0 : n) + Ei | 0, pe = a, a = a + Di | 0, n = pe >>> 0 > a >>> 0 ? n + 1 | 0 : n, pe = a + Ki | 0, n = pe >>> 0 < a >>> 0 ? n + 1 | 0 : n, b = b >>> 20 | 0, a = b + pe | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, b = a, a = a + Qi | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, b = K, Ce = a << 12 | b >>> 20, pe = n, Nr = n << 12 | a >>> 20, Li = t[P + 2452 >> 2], n = Li + t[P + 2532 >> 2] | 0, Ii = t[P + 2448 >> 2], a = t[P + 2528 >> 2], K = Ii + a | 0, lr = K, Ce = K + Ce | 0, a = a >>> 0 > K >>> 0 ? n + 1 | 0 : n, n = a + Nr | 0, ui = Ce << 4 & -16, K = Ce >>> 0 < K >>> 0 ? n + 1 | 0 : n, jr = (K << 4 | Ce >>> 28) & 16777215, Nr = b, Pr(kn, ui | b >>> 16 & 15, jr, 0, 0, 977, 1, 0, 0), Qi = P + 2608 | 0, Pr(Qi, di, gr, 0, 0, Yr, Ti, 0, 0), Ki = P + 2416 | 0, Pr(Ki, ai, wi, 0, 0, ei, nr, 0, 0), Di = P + 2640 | 0, Pr(Di, tr, Me, 0, 0, tr, Me, 0, 0), Ei = P + 2400 | 0, ui = Ei, jr = (a | 0) == (K | 0) & Ce >>> 0 < lr >>> 0 | a >>> 0 > K >>> 0, Ce = (a | 0) == (Li | 0) & lr >>> 0 < Ii >>> 0 | a >>> 0 < Li >>> 0, b = In + 8 | 0, a = t[b >> 2], n = $i + 8 | 0, lr = a + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[b + 4 >> 2] | 0, n = a >>> 0 > lr >>> 0 ? n + 1 | 0 : n, b = Ce + lr | 0, n = b >>> 0 < lr >>> 0 ? n + 1 | 0 : n, pe = pe >>> 20 | 0, a = b + pe | 0, n = pe >>> 0 > a >>> 0 ? n + 1 | 0 : n, b = a, a = a + jr | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, K = a << 12 | K >>> 20, b = n, jr = n << 12 | a >>> 20, Li = t[P + 2420 >> 2], n = Li + t[P + 2644 >> 2] | 0, lr = t[P + 2416 >> 2], a = t[P + 2640 >> 2], pe = lr + a | 0, Ce = pe, K = pe + K | 0, a = a >>> 0 > pe >>> 0 ? n + 1 | 0 : n, n = a + jr | 0, pe = K >>> 0 < pe >>> 0 ? n + 1 | 0 : n, Pr(ui, K, pe & 1048575, 0, 0, 15632, 16, 0, 0), Ii = P + 2544 | 0, Pr(Ii, ei, nr, 0, 0, Yr, Ti, 0, 0), ui = P + 2592 | 0, Pr(ui, di, gr, 0, 0, di, gr, 0, 0), nr = P + 2384 | 0, Pr(nr, ai, wi, 0, 0, tr, Me, 0, 0), wi = P + 2368 | 0, tr = wi, Me = (a | 0) == (pe | 0) & K >>> 0 < Ce >>> 0 | a >>> 0 > pe >>> 0, Ce = (a | 0) == (Li | 0) & Ce >>> 0 < lr >>> 0 | a >>> 0 < Li >>> 0, K = Di + 8 | 0, a = t[K >> 2], n = Ki + 8 | 0, gr = a + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[K + 4 >> 2] | 0, n = a >>> 0 > gr >>> 0 ? n + 1 | 0 : n, K = Ce + gr | 0, n = K >>> 0 < gr >>> 0 ? n + 1 | 0 : n, b = b >>> 20 | 0, a = b + K | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, b = a, a = a + Me | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, K = a << 12 | pe >>> 20, pe = t[P + 2384 >> 2], Me = K + pe | 0, b = n, a = n << 12 | a >>> 20, n = a + t[P + 2388 >> 2] | 0, n = pe >>> 0 > Me >>> 0 ? n + 1 | 0 : n, Pr(tr, Me, n, 0, 0, 15632, 16, 0, 0), jr = P + 2352 | 0, Ce = jr, K = (n | 0) == (a | 0) & K >>> 0 > Me >>> 0 | n >>> 0 < a >>> 0, n = nr + 8 | 0, pe = t[n >> 2], n = t[n + 4 >> 2], b = b >>> 20 | 0, a = b + pe | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, b = a, a = a + K | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, Pr(Ce, a, n, 0, 0, 64028672, 65536, 0, 0), b = t[P + 2432 >> 2], a = t[P + 2672 >> 2], tr = b + a | 0, K = t[P + 2436 >> 2], n = K + t[P + 2676 >> 2] | 0, pe = a >>> 0 > tr >>> 0 ? n + 1 | 0 : n, K = (K | 0) == (pe | 0) & b >>> 0 > tr >>> 0 | K >>> 0 > pe >>> 0, b = Dn + 8 | 0, a = t[b >> 2], n = kn + 8 | 0, Ce = a + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[b + 4 >> 2] | 0, n = a >>> 0 > Ce >>> 0 ? n + 1 | 0 : n, a = K + Ce | 0, n = a >>> 0 < Ce >>> 0 ? n + 1 | 0 : n, lr = pe, Ce = a << 12 | pe >>> 20, b = n, K = n << 12 | a >>> 20, Me = t[P + 2400 >> 2], a = t[P + 2608 >> 2], pe = Me + a | 0, gr = t[P + 2404 >> 2], n = gr + t[P + 2612 >> 2] | 0, n = a >>> 0 > pe >>> 0 ? n + 1 | 0 : n, a = Ce, Ce = pe, pe = a + pe | 0, a = n, n = n + K | 0, K = pe >>> 0 < Ce >>> 0 ? n + 1 | 0 : n, nr = (a | 0) == (K | 0) & pe >>> 0 < Ce >>> 0 | a >>> 0 > K >>> 0, Me = (a | 0) == (gr | 0) & Ce >>> 0 < Me >>> 0 | a >>> 0 < gr >>> 0, Ce = Qi + 8 | 0, a = t[Ce >> 2], n = Ei + 8 | 0, gr = a + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[Ce + 4 >> 2] | 0, n = a >>> 0 > gr >>> 0 ? n + 1 | 0 : n, Ce = Me + gr | 0, n = Ce >>> 0 < gr >>> 0 ? n + 1 | 0 : n, b = b >>> 20 | 0, a = b + Ce | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, b = a, a = a + nr | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, gr = K, Ce = a << 12 | K >>> 20, b = n, K = n << 12 | a >>> 20, ai = t[P + 2544 >> 2], a = t[P + 2592 >> 2], nr = ai + a | 0, Ei = t[P + 2548 >> 2], n = Ei + t[P + 2596 >> 2] | 0, n = a >>> 0 > nr >>> 0 ? n + 1 | 0 : n, a = t[P + 2368 >> 2], Me = a + nr | 0, ei = n, n = n + t[P + 2372 >> 2] | 0, a = a >>> 0 > Me >>> 0 ? n + 1 | 0 : n, n = a + K | 0, K = Ce + Me | 0, Ce = K >>> 0 < Me >>> 0 ? n + 1 | 0 : n, Ti = (a | 0) == (Ce | 0) & K >>> 0 < Me >>> 0 | a >>> 0 > Ce >>> 0, Yr = (a | 0) == (ei | 0) & Me >>> 0 < nr >>> 0 | a >>> 0 < ei >>> 0, n = wi + 8 | 0, di = t[n >> 2], wi = t[n + 4 >> 2], nr = (ei | 0) == (Ei | 0) & nr >>> 0 < ai >>> 0 | ei >>> 0 < Ei >>> 0, Me = ui + 8 | 0, a = t[Me >> 2], n = Ii + 8 | 0, ei = a + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[Me + 4 >> 2] | 0, n = a >>> 0 > ei >>> 0 ? n + 1 | 0 : n, a = nr + ei | 0, n = (a >>> 0 < ei >>> 0 ? n + 1 | 0 : n) + wi | 0, nr = a, a = a + di | 0, n = nr >>> 0 > a >>> 0 ? n + 1 | 0 : n, Me = a + Yr | 0, n = Me >>> 0 < a >>> 0 ? n + 1 | 0 : n, b = b >>> 20 | 0, a = b + Me | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, b = a, a = a + Ti | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, nr = Ce, Me = a << 12 | Ce >>> 20, b = n, Ce = n << 12 | a >>> 20, di = t[P + 2352 >> 2], kr = di + (kr & -2) | 0, wi = t[P + 2356 >> 2], n = wi + (or & 1048575) | 0, a = kr >>> 0 < di >>> 0 ? n + 1 | 0 : n, n = a + Ce | 0, or = Tt, ei = Nr & 65535, Me = Me + kr | 0, Ce = Me >>> 0 < kr >>> 0 ? n + 1 | 0 : n, Tt = Me, Nr = (a | 0) == (Ce | 0) & Me >>> 0 < kr >>> 0 | a >>> 0 > Ce >>> 0, a = (a | 0) == (wi | 0) & kr >>> 0 < di >>> 0 | a >>> 0 < wi >>> 0, n = jr + 8 | 0, Me = a + t[n >> 2] | 0, n = t[n + 4 >> 2], n = a >>> 0 > Me >>> 0 ? n + 1 | 0 : n, b = b >>> 20 | 0, a = b + Me | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, b = a, a = a + Nr | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, b = Ce, Me = a << 12 | b >>> 20, Ce = Me + or | 0, n = ei + (n << 12 | a >>> 20) | 0, a = Ce, Ce = a >>> 0 < Me >>> 0 ? n + 1 | 0 : n, Me = b & 1048575, nr = nr & 1048575, or = gr & 1048575, b = tr, tr = lr & 1048575, l = l - 1 | 0, !!l; )
      ;
    for (l = P + 7256 | 0, kr = l + 32 | 0, t[kr >> 2] = a, t[kr + 4 >> 2] = Ce, Nr = l + 24 | 0, t[Nr >> 2] = Tt, t[Nr + 4 >> 2] = Me, lr = l + 16 | 0, t[lr >> 2] = K, t[lr + 4 >> 2] = nr, gr = l + 8 | 0, t[gr >> 2] = pe, t[gr + 4 >> 2] = or, t[P + 7256 >> 2] = b, t[P + 7260 >> 2] = tr, zr(l, l, P + 7296 | 0), Ce = t[kr + 4 >> 2], n = P + 7216 | 0, l = n + 32 | 0, a = t[kr >> 2], t[l >> 2] = a, t[l + 4 >> 2] = Ce, Me = t[Nr + 4 >> 2], l = n + 24 | 0, Tt = t[Nr >> 2], t[l >> 2] = Tt, t[l + 4 >> 2] = Me, nr = t[lr + 4 >> 2], l = n + 16 | 0, K = t[lr >> 2], t[l >> 2] = K, t[l + 4 >> 2] = nr, or = t[gr + 4 >> 2], l = n + 8 | 0, pe = t[gr >> 2], t[l >> 2] = pe, t[l + 4 >> 2] = or, tr = t[P + 7260 >> 2], b = t[P + 7256 >> 2], t[P + 7216 >> 2] = b, t[P + 7220 >> 2] = tr, l = 44; lr = b, n = tr << 1 | b >>> 31, Ii = P + 2320 | 0, Yr = b << 1, Ti = n, Pr(Ii, Tt, Me, 0, 0, Yr, n, 0, 0), jr = P + 2240 | 0, b = pe << 1, gr = or, di = pe, pe = or << 1 | pe >>> 31, Pr(jr, K, nr, 0, 0, b, pe, 0, 0), kr = P + 2176 | 0, Pr(kr, a, Ce, 0, 0, a, Ce, 0, 0), Nr = P + 2160 | 0, Pr(Nr, t[P + 2176 >> 2], t[P + 2180 >> 2], 0, 0, 15632, 16, 0, 0), n = Ce << 1 | a >>> 31, Wi = P + 2128 | 0, ai = a << 1, wi = n, Pr(Wi, ai, n, 0, 0, lr, tr, 0, 0), Xi = P + 2288 | 0, Pr(Xi, Tt, Me, 0, 0, b, pe, 0, 0), Mn = P + 2224 | 0, Pr(Mn, K, nr, 0, 0, K, nr, 0, 0), ui = P + 2144 | 0, n = kr + 8 | 0, Pr(ui, t[n >> 2], t[n + 4 >> 2], 0, 0, 64028672, 65536, 0, 0), Dn = P + 2336 | 0, Pr(Dn, lr, tr, 0, 0, lr, tr, 0, 0), $i = P + 2112 | 0, Pr($i, ai, wi, 0, 0, di, or, 0, 0), In = P + 2192 | 0, tr = Tt, ei = K, Pr(In, Tt, Me, 0, 0, K << 1, nr << 1 | K >>> 31, 0, 0), lr = t[P + 2324 >> 2], n = lr + t[P + 2244 >> 2] | 0, K = t[P + 2320 >> 2], b = t[P + 2240 >> 2], a = K + b | 0, pe = t[P + 2160 >> 2], kr = a + pe | 0, b = a >>> 0 < b >>> 0 ? n + 1 | 0 : n, n = b + t[P + 2164 >> 2] | 0, pe = pe >>> 0 > kr >>> 0 ? n + 1 | 0 : n, or = (b | 0) == (pe | 0) & a >>> 0 > kr >>> 0 | b >>> 0 > pe >>> 0, n = Nr + 8 | 0, Ce = t[n >> 2], Tt = t[n + 4 >> 2], K = (b | 0) == (lr | 0) & a >>> 0 < K >>> 0 | b >>> 0 < lr >>> 0, b = jr + 8 | 0, a = t[b >> 2], n = Ii + 8 | 0, lr = a + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[b + 4 >> 2] | 0, n = a >>> 0 > lr >>> 0 ? n + 1 | 0 : n, a = K + lr | 0, n = (a >>> 0 < lr >>> 0 ? n + 1 | 0 : n) + Tt | 0, b = a, a = a + Ce | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, b = a, a = a + or | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, or = pe, Ce = a << 12 | pe >>> 20, b = n, K = n << 12 | a >>> 20, Li = t[P + 2288 >> 2], a = t[P + 2224 >> 2], lr = Li + a | 0, zn = t[P + 2292 >> 2], n = zn + t[P + 2228 >> 2] | 0, n = a >>> 0 > lr >>> 0 ? n + 1 | 0 : n, a = t[P + 2128 >> 2], Tt = a + lr | 0, jr = n, n = n + t[P + 2132 >> 2] | 0, n = a >>> 0 > Tt >>> 0 ? n + 1 | 0 : n, a = t[P + 2144 >> 2], pe = a + Tt | 0, Nr = n, n = n + t[P + 2148 >> 2] | 0, a = a >>> 0 > pe >>> 0 ? n + 1 | 0 : n, n = a + K | 0, kn = P + 2096 | 0, Ce = pe + Ce | 0, K = Ce >>> 0 < pe >>> 0 ? n + 1 | 0 : n, Qi = (a | 0) == (K | 0) & pe >>> 0 > Ce >>> 0 | a >>> 0 > K >>> 0, Ki = (a | 0) == (Nr | 0) & pe >>> 0 < Tt >>> 0 | a >>> 0 < Nr >>> 0, n = ui + 8 | 0, Di = t[n >> 2], Ei = t[n + 4 >> 2], Ii = (Nr | 0) == (jr | 0) & Tt >>> 0 < lr >>> 0 | Nr >>> 0 < jr >>> 0, n = Wi + 8 | 0, ui = t[n >> 2], Nr = t[n + 4 >> 2], Tt = (jr | 0) == (zn | 0) & lr >>> 0 < Li >>> 0 | jr >>> 0 < zn >>> 0, pe = Mn + 8 | 0, a = t[pe >> 2], n = Xi + 8 | 0, lr = a + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[pe + 4 >> 2] | 0, n = a >>> 0 > lr >>> 0 ? n + 1 | 0 : n, a = Tt + lr | 0, n = (a >>> 0 < lr >>> 0 ? n + 1 | 0 : n) + Nr | 0, pe = a, a = a + ui | 0, n = pe >>> 0 > a >>> 0 ? n + 1 | 0 : n, pe = a, a = a + Ii | 0, n = (pe >>> 0 > a >>> 0 ? n + 1 | 0 : n) + Ei | 0, pe = a, a = a + Di | 0, n = pe >>> 0 > a >>> 0 ? n + 1 | 0 : n, pe = a + Ki | 0, n = pe >>> 0 < a >>> 0 ? n + 1 | 0 : n, b = b >>> 20 | 0, a = b + pe | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, b = a, a = a + Qi | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, b = K, Tt = a << 12 | b >>> 20, pe = n, Nr = n << 12 | a >>> 20, Li = t[P + 2116 >> 2], n = Li + t[P + 2196 >> 2] | 0, Ii = t[P + 2112 >> 2], a = t[P + 2192 >> 2], K = Ii + a | 0, lr = K, Tt = K + Tt | 0, a = a >>> 0 > K >>> 0 ? n + 1 | 0 : n, n = a + Nr | 0, ui = Tt << 4 & -16, K = Tt >>> 0 < K >>> 0 ? n + 1 | 0 : n, jr = (K << 4 | Tt >>> 28) & 16777215, Nr = b, Pr(kn, ui | b >>> 16 & 15, jr, 0, 0, 977, 1, 0, 0), Qi = P + 2272 | 0, Pr(Qi, di, gr, 0, 0, Yr, Ti, 0, 0), Ki = P + 2080 | 0, Pr(Ki, ai, wi, 0, 0, ei, nr, 0, 0), Di = P + 2304 | 0, Pr(Di, tr, Me, 0, 0, tr, Me, 0, 0), Ei = P + 2064 | 0, ui = Ei, jr = (a | 0) == (K | 0) & Tt >>> 0 < lr >>> 0 | a >>> 0 > K >>> 0, Tt = (a | 0) == (Li | 0) & lr >>> 0 < Ii >>> 0 | a >>> 0 < Li >>> 0, b = In + 8 | 0, a = t[b >> 2], n = $i + 8 | 0, lr = a + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[b + 4 >> 2] | 0, n = a >>> 0 > lr >>> 0 ? n + 1 | 0 : n, b = Tt + lr | 0, n = b >>> 0 < lr >>> 0 ? n + 1 | 0 : n, pe = pe >>> 20 | 0, a = b + pe | 0, n = pe >>> 0 > a >>> 0 ? n + 1 | 0 : n, b = a, a = a + jr | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, K = a << 12 | K >>> 20, b = n, jr = n << 12 | a >>> 20, Li = t[P + 2084 >> 2], n = Li + t[P + 2308 >> 2] | 0, lr = t[P + 2080 >> 2], a = t[P + 2304 >> 2], pe = lr + a | 0, Tt = pe, K = pe + K | 0, a = a >>> 0 > pe >>> 0 ? n + 1 | 0 : n, n = a + jr | 0, pe = K >>> 0 < pe >>> 0 ? n + 1 | 0 : n, Pr(ui, K, pe & 1048575, 0, 0, 15632, 16, 0, 0), Ii = P + 2208 | 0, Pr(Ii, ei, nr, 0, 0, Yr, Ti, 0, 0), ui = P + 2256 | 0, Pr(ui, di, gr, 0, 0, di, gr, 0, 0), nr = P + 2048 | 0, Pr(nr, ai, wi, 0, 0, tr, Me, 0, 0), wi = P + 2032 | 0, tr = wi, Me = (a | 0) == (pe | 0) & K >>> 0 < Tt >>> 0 | a >>> 0 > pe >>> 0, Tt = (a | 0) == (Li | 0) & Tt >>> 0 < lr >>> 0 | a >>> 0 < Li >>> 0, K = Di + 8 | 0, a = t[K >> 2], n = Ki + 8 | 0, gr = a + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[K + 4 >> 2] | 0, n = a >>> 0 > gr >>> 0 ? n + 1 | 0 : n, K = Tt + gr | 0, n = K >>> 0 < gr >>> 0 ? n + 1 | 0 : n, b = b >>> 20 | 0, a = b + K | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, b = a, a = a + Me | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, K = a << 12 | pe >>> 20, pe = t[P + 2048 >> 2], Me = K + pe | 0, b = n, a = n << 12 | a >>> 20, n = a + t[P + 2052 >> 2] | 0, n = pe >>> 0 > Me >>> 0 ? n + 1 | 0 : n, Pr(tr, Me, n, 0, 0, 15632, 16, 0, 0), jr = P + 2016 | 0, Tt = jr, K = (n | 0) == (a | 0) & K >>> 0 > Me >>> 0 | n >>> 0 < a >>> 0, n = nr + 8 | 0, pe = t[n >> 2], n = t[n + 4 >> 2], b = b >>> 20 | 0, a = b + pe | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, b = a, a = a + K | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, Pr(Tt, a, n, 0, 0, 64028672, 65536, 0, 0), b = t[P + 2096 >> 2], a = t[P + 2336 >> 2], tr = b + a | 0, K = t[P + 2100 >> 2], n = K + t[P + 2340 >> 2] | 0, pe = a >>> 0 > tr >>> 0 ? n + 1 | 0 : n, K = (K | 0) == (pe | 0) & b >>> 0 > tr >>> 0 | K >>> 0 > pe >>> 0, b = Dn + 8 | 0, a = t[b >> 2], n = kn + 8 | 0, Tt = a + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[b + 4 >> 2] | 0, n = a >>> 0 > Tt >>> 0 ? n + 1 | 0 : n, a = K + Tt | 0, n = a >>> 0 < Tt >>> 0 ? n + 1 | 0 : n, lr = pe, K = a << 12 | pe >>> 20, b = n, pe = n << 12 | a >>> 20, Me = t[P + 2064 >> 2], a = t[P + 2272 >> 2], Tt = Me + a | 0, gr = t[P + 2068 >> 2], n = gr + t[P + 2276 >> 2] | 0, a = a >>> 0 > Tt >>> 0 ? n + 1 | 0 : n, n = a + pe | 0, pe = K + Tt | 0, K = pe >>> 0 < Tt >>> 0 ? n + 1 | 0 : n, nr = (a | 0) == (K | 0) & pe >>> 0 < Tt >>> 0 | a >>> 0 > K >>> 0, Me = (a | 0) == (gr | 0) & Me >>> 0 > Tt >>> 0 | a >>> 0 < gr >>> 0, Tt = Qi + 8 | 0, a = t[Tt >> 2], n = Ei + 8 | 0, gr = a + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[Tt + 4 >> 2] | 0, n = a >>> 0 > gr >>> 0 ? n + 1 | 0 : n, Tt = Me + gr | 0, n = Tt >>> 0 < gr >>> 0 ? n + 1 | 0 : n, b = b >>> 20 | 0, a = b + Tt | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, b = a, a = a + nr | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, gr = K, Tt = a << 12 | K >>> 20, b = n, K = n << 12 | a >>> 20, ai = t[P + 2208 >> 2], a = t[P + 2256 >> 2], nr = ai + a | 0, Ei = t[P + 2212 >> 2], n = Ei + t[P + 2260 >> 2] | 0, n = a >>> 0 > nr >>> 0 ? n + 1 | 0 : n, a = t[P + 2032 >> 2], Me = a + nr | 0, ei = n, n = n + t[P + 2036 >> 2] | 0, a = a >>> 0 > Me >>> 0 ? n + 1 | 0 : n, n = a + K | 0, K = Me + Tt | 0, Tt = K >>> 0 < Me >>> 0 ? n + 1 | 0 : n, Ti = (a | 0) == (Tt | 0) & K >>> 0 < Me >>> 0 | a >>> 0 > Tt >>> 0, Yr = (a | 0) == (ei | 0) & Me >>> 0 < nr >>> 0 | a >>> 0 < ei >>> 0, n = wi + 8 | 0, di = t[n >> 2], wi = t[n + 4 >> 2], nr = (ei | 0) == (Ei | 0) & nr >>> 0 < ai >>> 0 | ei >>> 0 < Ei >>> 0, Me = ui + 8 | 0, a = t[Me >> 2], n = Ii + 8 | 0, ei = a + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[Me + 4 >> 2] | 0, n = a >>> 0 > ei >>> 0 ? n + 1 | 0 : n, a = nr + ei | 0, n = (a >>> 0 < ei >>> 0 ? n + 1 | 0 : n) + wi | 0, nr = a, a = a + di | 0, n = nr >>> 0 > a >>> 0 ? n + 1 | 0 : n, Me = a + Yr | 0, n = Me >>> 0 < a >>> 0 ? n + 1 | 0 : n, b = b >>> 20 | 0, a = b + Me | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, b = a, a = a + Ti | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, nr = Tt, ei = a << 12 | Tt >>> 20, b = n, Me = n << 12 | a >>> 20, di = t[P + 2016 >> 2], Tt = di + (kr & -2) | 0, wi = t[P + 2020 >> 2], n = wi + (or & 1048575) | 0, n = Tt >>> 0 < di >>> 0 ? n + 1 | 0 : n, kr = Tt, Tt = Tt + ei | 0, a = n, n = n + Me | 0, or = Ce, ei = Nr & 65535, Me = Tt >>> 0 < kr >>> 0 ? n + 1 | 0 : n, Nr = (a | 0) == (Me | 0) & Tt >>> 0 < kr >>> 0 | a >>> 0 > Me >>> 0, a = (a | 0) == (wi | 0) & kr >>> 0 < di >>> 0 | a >>> 0 < wi >>> 0, n = jr + 8 | 0, Ce = a + t[n >> 2] | 0, n = t[n + 4 >> 2], n = a >>> 0 > Ce >>> 0 ? n + 1 | 0 : n, b = b >>> 20 | 0, a = b + Ce | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, b = a, a = a + Nr | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, Ce = a << 12 | Me >>> 20, b = Ce + or | 0, n = ei + (n << 12 | a >>> 20) | 0, a = b, Ce = a >>> 0 < Ce >>> 0 ? n + 1 | 0 : n, Me = Me & 1048575, nr = nr & 1048575, or = gr & 1048575, b = tr, tr = lr & 1048575, l = l - 1 | 0, !!l; )
      ;
    for (n = P + 7216 | 0, di = n + 32 | 0, t[di >> 2] = a, t[di + 4 >> 2] = Ce, l = n + 24 | 0, t[l >> 2] = Tt, t[l + 4 >> 2] = Me, Ce = n + 16 | 0, t[Ce >> 2] = K, t[Ce + 4 >> 2] = nr, kr = n + 8 | 0, t[kr >> 2] = pe, t[kr + 4 >> 2] = or, t[P + 7216 >> 2] = b, t[P + 7220 >> 2] = tr, zr(n, n, P + 7336 | 0), tr = t[l >> 2], b = tr, Me = t[l + 4 >> 2], a = Me, l = t[P + 7220 >> 2], Yr = l, Nr = t[P + 7216 >> 2], K = Nr, n = l << 1 | K >>> 31, lr = P + 1856 | 0, ei = K << 1, wi = n, Pr(lr, b, a, 0, 0, ei, n, 0, 0), l = t[kr + 4 >> 2], zn = l, Wi = t[kr >> 2], a = Wi, n = l << 1 | a >>> 31, gr = P + 1952 | 0, nr = t[Ce >> 2], Ce = t[Ce + 4 >> 2], a = a << 1, b = n, Pr(gr, nr, Ce, 0, 0, a, n, 0, 0), or = P + 1840 | 0, pe = t[di >> 2], l = t[di + 4 >> 2], Pr(or, pe, l, 0, 0, pe, l, 0, 0), Tt = P + 1824 | 0, Pr(Tt, t[P + 1840 >> 2], t[P + 1844 >> 2], 0, 0, 15632, 16, 0, 0), n = l << 1 | pe >>> 31, Mn = P + 1792 | 0, di = pe << 1, kr = n, Pr(Mn, di, n, 0, 0, K, Yr, 0, 0), Dn = P + 1872 | 0, Pr(Dn, tr, Me, 0, 0, a, b, 0, 0), $i = P + 1936 | 0, Pr($i, nr, Ce, 0, 0, nr, Ce, 0, 0), Ti = P + 1808 | 0, l = or + 8 | 0, Pr(Ti, t[l >> 2], t[l + 4 >> 2], 0, 0, 64028672, 65536, 0, 0), In = P + 2e3 | 0, Pr(In, K, Yr, 0, 0, K, Yr, 0, 0), Li = P + 1776 | 0, Pr(Li, di, n, 0, 0, Wi, zn, 0, 0), kn = P + 1888 | 0, Pr(kn, tr, Me, 0, 0, nr << 1, Ce << 1 | nr >>> 31, 0, 0), Yr = t[P + 1860 >> 2], n = Yr + t[P + 1956 >> 2] | 0, pe = t[P + 1856 >> 2], a = t[P + 1952 >> 2], l = pe + a | 0, b = t[P + 1824 >> 2], Nr = l + b | 0, a = l >>> 0 < a >>> 0 ? n + 1 | 0 : n, n = a + t[P + 1828 >> 2] | 0, b = b >>> 0 > Nr >>> 0 ? n + 1 | 0 : n, or = (a | 0) == (b | 0) & l >>> 0 > Nr >>> 0 | a >>> 0 > b >>> 0, n = Tt + 8 | 0, Tt = t[n >> 2], K = t[n + 4 >> 2], pe = (a | 0) == (Yr | 0) & l >>> 0 < pe >>> 0 | a >>> 0 < Yr >>> 0, n = gr + 8 | 0, a = t[n >> 2], l = lr + 8 | 0, gr = a + t[l >> 2] | 0, n = t[l + 4 >> 2] + t[n + 4 >> 2] | 0, n = a >>> 0 > gr >>> 0 ? n + 1 | 0 : n, l = pe + gr | 0, n = (l >>> 0 < gr >>> 0 ? n + 1 | 0 : n) + K | 0, a = l, l = l + Tt | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = l, l = l + or | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, lr = b, Tt = l << 12 | b >>> 20, a = n, pe = n << 12 | l >>> 20, Qi = t[P + 1872 >> 2], l = t[P + 1936 >> 2], or = Qi + l | 0, Xi = t[P + 1876 >> 2], n = Xi + t[P + 1940 >> 2] | 0, n = l >>> 0 > or >>> 0 ? n + 1 | 0 : n, l = t[P + 1792 >> 2], K = l + or | 0, Yr = n, n = n + t[P + 1796 >> 2] | 0, n = l >>> 0 > K >>> 0 ? n + 1 | 0 : n, l = t[P + 1808 >> 2], b = l + K | 0, gr = n, n = n + t[P + 1812 >> 2] | 0, l = l >>> 0 > b >>> 0 ? n + 1 | 0 : n, n = l + pe | 0, Ki = P + 1760 | 0, Di = Ki, Tt = b + Tt | 0, pe = Tt >>> 0 < b >>> 0 ? n + 1 | 0 : n, Ei = (l | 0) == (pe | 0) & b >>> 0 > Tt >>> 0 | l >>> 0 > pe >>> 0, Ii = (l | 0) == (gr | 0) & b >>> 0 < K >>> 0 | l >>> 0 < gr >>> 0, l = Ti + 8 | 0, ui = t[l >> 2], jr = t[l + 4 >> 2], ai = (gr | 0) == (Yr | 0) & K >>> 0 < or >>> 0 | gr >>> 0 < Yr >>> 0, l = Mn + 8 | 0, Ti = t[l >> 2], gr = t[l + 4 >> 2], K = (Yr | 0) == (Xi | 0) & or >>> 0 < Qi >>> 0 | Yr >>> 0 < Xi >>> 0, n = $i + 8 | 0, b = t[n >> 2], l = Dn + 8 | 0, or = b + t[l >> 2] | 0, n = t[l + 4 >> 2] + t[n + 4 >> 2] | 0, n = b >>> 0 > or >>> 0 ? n + 1 | 0 : n, l = K + or | 0, n = (l >>> 0 < or >>> 0 ? n + 1 | 0 : n) + gr | 0, b = l, l = l + Ti | 0, n = b >>> 0 > l >>> 0 ? n + 1 | 0 : n, b = l, l = l + ai | 0, n = (b >>> 0 > l >>> 0 ? n + 1 | 0 : n) + jr | 0, b = l, l = l + ui | 0, n = b >>> 0 > l >>> 0 ? n + 1 | 0 : n, b = l + Ii | 0, n = b >>> 0 < l >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, l = a + b | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = l, l = l + Ei | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = pe, K = l << 12 | a >>> 20, b = n, pe = n << 12 | l >>> 20, jr = t[P + 1776 >> 2], l = t[P + 1888 >> 2], or = jr + l | 0, ui = t[P + 1780 >> 2], n = ui + t[P + 1892 >> 2] | 0, l = l >>> 0 > or >>> 0 ? n + 1 | 0 : n, n = l + pe | 0, K = K + or | 0, n = K >>> 0 < or >>> 0 ? n + 1 | 0 : n, Ti = K << 4 & -16, pe = n, Yr = (n << 4 | K >>> 28) & 16777215, gr = a, Pr(Di, Ti | a >>> 16 & 15, Yr, 0, 0, 977, 1, 0, 0), Di = P + 1984 | 0, Pr(Di, Wi, zn, 0, 0, ei, wi, 0, 0), Ii = P + 1728 | 0, Pr(Ii, di, kr, 0, 0, nr, Ce, 0, 0), ai = P + 1904 | 0, Pr(ai, tr, Me, 0, 0, tr, Me, 0, 0), Ti = P + 1712 | 0, Yr = (l | 0) == (n | 0) & K >>> 0 < or >>> 0 | l >>> 0 > n >>> 0, K = (l | 0) == (ui | 0) & or >>> 0 < jr >>> 0 | l >>> 0 < ui >>> 0, n = kn + 8 | 0, a = t[n >> 2], l = Li + 8 | 0, or = a + t[l >> 2] | 0, n = t[l + 4 >> 2] + t[n + 4 >> 2] | 0, n = a >>> 0 > or >>> 0 ? n + 1 | 0 : n, a = K + or | 0, n = a >>> 0 < or >>> 0 ? n + 1 | 0 : n, b = b >>> 20 | 0, l = a + b | 0, n = b >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = l, l = l + Yr | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, pe = l << 12 | pe >>> 20, a = n, or = n << 12 | l >>> 20, Ei = t[P + 1732 >> 2], n = Ei + t[P + 1908 >> 2] | 0, Yr = t[P + 1728 >> 2], l = t[P + 1904 >> 2], b = Yr + l | 0, K = b, pe = b + pe | 0, l = l >>> 0 > b >>> 0 ? n + 1 | 0 : n, n = l + or | 0, b = b >>> 0 > pe >>> 0 ? n + 1 | 0 : n, Pr(Ti, pe, b & 1048575, 0, 0, 15632, 16, 0, 0), ui = P + 1920 | 0, Pr(ui, nr, Ce, 0, 0, ei, wi, 0, 0), jr = P + 1968 | 0, Pr(jr, Wi, zn, 0, 0, Wi, zn, 0, 0), or = P + 1664 | 0, Pr(or, di, kr, 0, 0, tr, Me, 0, 0), ei = P + 1648 | 0, Me = ei, Ce = (l | 0) == (b | 0) & K >>> 0 > pe >>> 0 | l >>> 0 > b >>> 0, K = (l | 0) == (Ei | 0) & K >>> 0 < Yr >>> 0 | l >>> 0 < Ei >>> 0, n = ai + 8 | 0, pe = t[n >> 2], l = Ii + 8 | 0, tr = pe + t[l >> 2] | 0, n = t[l + 4 >> 2] + t[n + 4 >> 2] | 0, n = pe >>> 0 > tr >>> 0 ? n + 1 | 0 : n, pe = K + tr | 0, n = pe >>> 0 < tr >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, l = a + pe | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = l, l = l + Ce | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, pe = l << 12 | b >>> 20, b = t[P + 1664 >> 2], Ce = pe + b | 0, a = n, l = n << 12 | l >>> 20, n = l + t[P + 1668 >> 2] | 0, n = b >>> 0 > Ce >>> 0 ? n + 1 | 0 : n, Pr(Me, Ce, n, 0, 0, 15632, 16, 0, 0), Ei = P + 1584 | 0, K = Ei, pe = (l | 0) == (n | 0) & pe >>> 0 > Ce >>> 0 | l >>> 0 > n >>> 0, l = or + 8 | 0, b = t[l >> 2], n = t[l + 4 >> 2], a = a >>> 20 | 0, l = a + b | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = l, l = l + pe | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, Pr(K, l, n, 0, 0, 64028672, 65536, 0, 0), a = t[P + 1760 >> 2], l = t[P + 2e3 >> 2], K = a + l | 0, pe = t[P + 1764 >> 2], n = pe + t[P + 2004 >> 2] | 0, b = l >>> 0 > K >>> 0 ? n + 1 | 0 : n, pe = (pe | 0) == (b | 0) & a >>> 0 > K >>> 0 | b >>> 0 < pe >>> 0, n = In + 8 | 0, a = t[n >> 2], l = Ki + 8 | 0, Ce = a + t[l >> 2] | 0, n = t[l + 4 >> 2] + t[n + 4 >> 2] | 0, n = a >>> 0 > Ce >>> 0 ? n + 1 | 0 : n, l = pe + Ce | 0, n = l >>> 0 < Ce >>> 0 ? n + 1 | 0 : n, nr = b, pe = l << 12 | b >>> 20, a = n, tr = n << 12 | l >>> 20, or = t[P + 1716 >> 2], n = or + t[P + 1988 >> 2] | 0, Me = t[P + 1712 >> 2], l = t[P + 1984 >> 2], b = Me + l | 0, Ce = b, pe = b + pe | 0, l = l >>> 0 > b >>> 0 ? n + 1 | 0 : n, n = l + tr | 0, b = pe >>> 0 < b >>> 0 ? n + 1 | 0 : n, tr = (l | 0) == (b | 0) & pe >>> 0 < Ce >>> 0 | l >>> 0 > b >>> 0, Me = (l | 0) == (or | 0) & Ce >>> 0 < Me >>> 0 | l >>> 0 < or >>> 0, n = Di + 8 | 0, Ce = t[n >> 2], l = Ti + 8 | 0, or = Ce + t[l >> 2] | 0, n = t[l + 4 >> 2] + t[n + 4 >> 2] | 0, n = Ce >>> 0 > or >>> 0 ? n + 1 | 0 : n, Ce = Me + or | 0, n = Ce >>> 0 < or >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, l = a + Ce | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = l, l = l + tr | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, or = b, Ce = l << 12 | b >>> 20, a = n, b = n << 12 | l >>> 20, ai = t[P + 1920 >> 2], l = t[P + 1968 >> 2], tr = ai + l | 0, Di = t[P + 1924 >> 2], n = Di + t[P + 1972 >> 2] | 0, n = l >>> 0 > tr >>> 0 ? n + 1 | 0 : n, l = t[P + 1648 >> 2], Me = l + tr | 0, kr = n, n = n + t[P + 1652 >> 2] | 0, l = l >>> 0 > Me >>> 0 ? n + 1 | 0 : n, n = l + b | 0, Ii = P + 1568 | 0, b = Ce + Me | 0, Ce = b >>> 0 < Me >>> 0 ? n + 1 | 0 : n, Yr = (l | 0) == (Ce | 0) & b >>> 0 < Me >>> 0 | l >>> 0 > Ce >>> 0, di = (l | 0) == (kr | 0) & Me >>> 0 < tr >>> 0 | l >>> 0 < kr >>> 0, l = ei + 8 | 0, wi = t[l >> 2], ei = t[l + 4 >> 2], tr = (kr | 0) == (Di | 0) & tr >>> 0 < ai >>> 0 | kr >>> 0 < Di >>> 0, n = jr + 8 | 0, Me = t[n >> 2], l = ui + 8 | 0, kr = Me + t[l >> 2] | 0, n = t[l + 4 >> 2] + t[n + 4 >> 2] | 0, n = Me >>> 0 > kr >>> 0 ? n + 1 | 0 : n, l = tr + kr | 0, n = (l >>> 0 < kr >>> 0 ? n + 1 | 0 : n) + ei | 0, tr = l, l = l + wi | 0, n = tr >>> 0 > l >>> 0 ? n + 1 | 0 : n, Me = l + di | 0, n = Me >>> 0 < l >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, l = a + Me | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = l, l = l + Yr | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, Me = Ce, kr = l << 12 | Ce >>> 20, a = n, tr = n << 12 | l >>> 20, Di = t[P + 1588 >> 2], n = Di + (lr & 1048575) | 0, ai = t[P + 1584 >> 2], Ce = Nr & -2, l = ai + Ce | 0, lr = l, l = l >>> 0 < Ce >>> 0 ? n + 1 | 0 : n, n = l + tr | 0, tr = lr + kr | 0, Ce = tr >>> 0 < lr >>> 0 ? n + 1 | 0 : n, kr = Ce & 1048575, n = nr & 1048575, Ki = n, nr = K, n = n << 1 | K >>> 31, wi = K << 1, di = n, Pr(Ii, tr, kr, 0, 0, wi, n, 0, 0), n = or & 1048575, Wi = n, ui = P + 1600 | 0, Nr = Me & 1048575, K = pe << 1, Ti = pe, Me = n << 1 | pe >>> 31, Pr(ui, b, Nr, 0, 0, K, Me, 0, 0), jr = P + 1504 | 0, ei = gr & 65535, gr = (l | 0) == (Ce | 0) & tr >>> 0 < lr >>> 0 | l >>> 0 > Ce >>> 0, or = (l | 0) == (Di | 0) & lr >>> 0 < ai >>> 0 | l >>> 0 < Di >>> 0, l = Ei + 8 | 0, pe = or + t[l >> 2] | 0, n = t[l + 4 >> 2], n = pe >>> 0 < or >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, l = a + pe | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = l, l = l + gr | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, pe = l << 12 | Ce >>> 20, a = pe + Tt | 0, n = ei + (n << 12 | l >>> 20) | 0, n = a >>> 0 < pe >>> 0 ? n + 1 | 0 : n, Pr(jr, a, n, 0, 0, a, n, 0, 0), Tt = P + 1488 | 0, Pr(Tt, t[P + 1504 >> 2], t[P + 1508 >> 2], 0, 0, 15632, 16, 0, 0), l = a, n = n << 1 | l >>> 31, Mn = P + 1456 | 0, Yr = l << 1, ei = n, Pr(Mn, Yr, n, 0, 0, nr, Ki, 0, 0), Dn = P + 1552 | 0, Pr(Dn, tr, kr, 0, 0, K, Me, 0, 0), $i = P + 1616 | 0, Pr($i, b, Nr, 0, 0, b, Nr, 0, 0), ai = P + 1472 | 0, l = jr + 8 | 0, Pr(ai, t[l >> 2], t[l + 4 >> 2], 0, 0, 64028672, 65536, 0, 0), In = P + 1744 | 0, Pr(In, nr, Ki, 0, 0, nr, Ki, 0, 0), Li = P + 1440 | 0, Pr(Li, Yr, n, 0, 0, Ti, Wi, 0, 0), kn = P + 1520 | 0, Me = kr, Ce = Nr, kr = b, Pr(kn, tr, Me, 0, 0, b << 1, Ce << 1 | b >>> 31, 0, 0), pe = t[P + 1568 >> 2], a = t[P + 1600 >> 2], l = pe + a | 0, nr = t[P + 1572 >> 2], n = nr + t[P + 1604 >> 2] | 0, n = l >>> 0 < a >>> 0 ? n + 1 | 0 : n, a = t[P + 1488 >> 2], Nr = a + l | 0, b = n, n = n + t[P + 1492 >> 2] | 0, a = a >>> 0 > Nr >>> 0 ? n + 1 | 0 : n, or = (b | 0) == (a | 0) & l >>> 0 > Nr >>> 0 | a >>> 0 < b >>> 0, n = Tt + 8 | 0, Tt = t[n >> 2], K = t[n + 4 >> 2], pe = (b | 0) == (nr | 0) & l >>> 0 < pe >>> 0 | b >>> 0 < nr >>> 0, n = ui + 8 | 0, b = t[n >> 2], l = Ii + 8 | 0, nr = b + t[l >> 2] | 0, n = t[l + 4 >> 2] + t[n + 4 >> 2] | 0, n = b >>> 0 > nr >>> 0 ? n + 1 | 0 : n, l = pe + nr | 0, n = (l >>> 0 < nr >>> 0 ? n + 1 | 0 : n) + K | 0, b = l, l = l + Tt | 0, n = b >>> 0 > l >>> 0 ? n + 1 | 0 : n, b = l, l = l + or | 0, n = b >>> 0 > l >>> 0 ? n + 1 | 0 : n, lr = a, Tt = l << 12 | a >>> 20, b = n, pe = n << 12 | l >>> 20, Qi = t[P + 1552 >> 2], l = t[P + 1616 >> 2], nr = Qi + l | 0, Xi = t[P + 1556 >> 2], n = Xi + t[P + 1620 >> 2] | 0, n = l >>> 0 > nr >>> 0 ? n + 1 | 0 : n, l = t[P + 1456 >> 2], or = l + nr | 0, a = n, n = n + t[P + 1460 >> 2] | 0, n = l >>> 0 > or >>> 0 ? n + 1 | 0 : n, l = t[P + 1472 >> 2], K = l + or | 0, gr = n, n = n + t[P + 1476 >> 2] | 0, l = l >>> 0 > K >>> 0 ? n + 1 | 0 : n, n = l + pe | 0, Ki = P + 1344 | 0, Di = Ki, Tt = K + Tt | 0, pe = Tt >>> 0 < K >>> 0 ? n + 1 | 0 : n, Ei = (l | 0) == (pe | 0) & K >>> 0 > Tt >>> 0 | l >>> 0 > pe >>> 0, Ii = (l | 0) == (gr | 0) & K >>> 0 < or >>> 0 | l >>> 0 < gr >>> 0, l = ai + 8 | 0, ui = t[l >> 2], jr = t[l + 4 >> 2], ai = (a | 0) == (gr | 0) & nr >>> 0 > or >>> 0 | a >>> 0 > gr >>> 0, l = Mn + 8 | 0, gr = t[l >> 2], or = t[l + 4 >> 2], K = (a | 0) == (Xi | 0) & nr >>> 0 < Qi >>> 0 | a >>> 0 < Xi >>> 0, n = $i + 8 | 0, a = t[n >> 2], l = Dn + 8 | 0, nr = a + t[l >> 2] | 0, n = t[l + 4 >> 2] + t[n + 4 >> 2] | 0, n = a >>> 0 > nr >>> 0 ? n + 1 | 0 : n, l = K + nr | 0, n = (l >>> 0 < nr >>> 0 ? n + 1 | 0 : n) + or | 0, a = l, l = l + gr | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = l, l = l + ai | 0, n = (a >>> 0 > l >>> 0 ? n + 1 | 0 : n) + jr | 0, a = l, l = l + ui | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = l + Ii | 0, n = a >>> 0 < l >>> 0 ? n + 1 | 0 : n, b = b >>> 20 | 0, l = a + b | 0, n = b >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = l, l = l + Ei | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = pe, K = l << 12 | a >>> 20, b = n, pe = n << 12 | l >>> 20, jr = t[P + 1440 >> 2], l = t[P + 1520 >> 2], or = jr + l | 0, ui = t[P + 1444 >> 2], n = ui + t[P + 1524 >> 2] | 0, l = l >>> 0 > or >>> 0 ? n + 1 | 0 : n, n = l + pe | 0, K = K + or | 0, n = K >>> 0 < or >>> 0 ? n + 1 | 0 : n, ai = K << 4 & -16, pe = n, nr = (n << 4 | K >>> 28) & 16777215, gr = a, Pr(Di, ai | a >>> 16 & 15, nr, 0, 0, 977, 1, 0, 0), Di = P + 1680 | 0, Pr(Di, Ti, Wi, 0, 0, wi, di, 0, 0), Ei = P + 1424 | 0, Pr(Ei, Yr, ei, 0, 0, kr, Ce, 0, 0), Ii = P + 1536 | 0, Pr(Ii, tr, Me, 0, 0, tr, Me, 0, 0), ai = P + 1408 | 0, nr = (l | 0) == (n | 0) & K >>> 0 < or >>> 0 | l >>> 0 > n >>> 0, K = (l | 0) == (ui | 0) & or >>> 0 < jr >>> 0 | l >>> 0 < ui >>> 0, n = kn + 8 | 0, a = t[n >> 2], l = Li + 8 | 0, or = a + t[l >> 2] | 0, n = t[l + 4 >> 2] + t[n + 4 >> 2] | 0, n = a >>> 0 > or >>> 0 ? n + 1 | 0 : n, a = K + or | 0, n = a >>> 0 < or >>> 0 ? n + 1 | 0 : n, b = b >>> 20 | 0, l = a + b | 0, n = b >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = l, l = l + nr | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, pe = l << 12 | pe >>> 20, a = n, b = n << 12 | l >>> 20, nr = t[P + 1424 >> 2], l = t[P + 1536 >> 2], K = nr + l | 0, Qi = t[P + 1428 >> 2], n = Qi + t[P + 1540 >> 2] | 0, l = l >>> 0 > K >>> 0 ? n + 1 | 0 : n, n = l + b | 0, pe = K + pe | 0, n = pe >>> 0 < K >>> 0 ? n + 1 | 0 : n, b = n, Pr(ai, pe, n & 1048575, 0, 0, 15632, 16, 0, 0), ui = P + 1632 | 0, Pr(ui, kr, Ce, 0, 0, wi, di, 0, 0), jr = P + 1696 | 0, Pr(jr, Ti, Wi, 0, 0, Ti, Wi, 0, 0), or = P + 1392 | 0, Pr(or, tr, Me, 0, 0, Yr, ei, 0, 0), ei = P + 1376 | 0, Me = ei, Ce = (l | 0) == (n | 0) & K >>> 0 > pe >>> 0 | l >>> 0 > n >>> 0, K = (l | 0) == (Qi | 0) & K >>> 0 < nr >>> 0 | l >>> 0 < Qi >>> 0, n = Ii + 8 | 0, pe = t[n >> 2], l = Ei + 8 | 0, tr = pe + t[l >> 2] | 0, n = t[l + 4 >> 2] + t[n + 4 >> 2] | 0, n = pe >>> 0 > tr >>> 0 ? n + 1 | 0 : n, pe = K + tr | 0, n = pe >>> 0 < tr >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, l = a + pe | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = l, l = l + Ce | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, pe = l << 12 | b >>> 20, b = t[P + 1392 >> 2], Ce = pe + b | 0, a = n, l = n << 12 | l >>> 20, n = l + t[P + 1396 >> 2] | 0, n = b >>> 0 > Ce >>> 0 ? n + 1 | 0 : n, Pr(Me, Ce, n, 0, 0, 15632, 16, 0, 0), Ei = P + 1360 | 0, K = Ei, pe = (l | 0) == (n | 0) & pe >>> 0 > Ce >>> 0 | l >>> 0 > n >>> 0, l = or + 8 | 0, b = t[l >> 2], n = t[l + 4 >> 2], a = a >>> 20 | 0, l = a + b | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = l, l = l + pe | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, Pr(K, l, n, 0, 0, 64028672, 65536, 0, 0), a = t[P + 1344 >> 2], l = t[P + 1744 >> 2], K = a + l | 0, pe = t[P + 1348 >> 2], n = pe + t[P + 1748 >> 2] | 0, b = l >>> 0 > K >>> 0 ? n + 1 | 0 : n, pe = (pe | 0) == (b | 0) & a >>> 0 > K >>> 0 | b >>> 0 < pe >>> 0, n = In + 8 | 0, a = t[n >> 2], l = Ki + 8 | 0, Ce = a + t[l >> 2] | 0, n = t[l + 4 >> 2] + t[n + 4 >> 2] | 0, n = a >>> 0 > Ce >>> 0 ? n + 1 | 0 : n, l = pe + Ce | 0, n = l >>> 0 < Ce >>> 0 ? n + 1 | 0 : n, nr = b, pe = l << 12 | b >>> 20, a = n, b = n << 12 | l >>> 20, Me = t[P + 1408 >> 2], l = t[P + 1680 >> 2], Ce = Me + l | 0, or = t[P + 1412 >> 2], n = or + t[P + 1684 >> 2] | 0, l = l >>> 0 > Ce >>> 0 ? n + 1 | 0 : n, n = l + b | 0, pe = pe + Ce | 0, b = pe >>> 0 < Ce >>> 0 ? n + 1 | 0 : n, tr = (l | 0) == (b | 0) & pe >>> 0 < Ce >>> 0 | l >>> 0 > b >>> 0, Me = (l | 0) == (or | 0) & Ce >>> 0 < Me >>> 0 | l >>> 0 < or >>> 0, n = Di + 8 | 0, Ce = t[n >> 2], l = ai + 8 | 0, or = Ce + t[l >> 2] | 0, n = t[l + 4 >> 2] + t[n + 4 >> 2] | 0, n = Ce >>> 0 > or >>> 0 ? n + 1 | 0 : n, Ce = Me + or | 0, n = Ce >>> 0 < or >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, l = a + Ce | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = l, l = l + tr | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, or = b, Ce = l << 12 | b >>> 20, a = n, b = n << 12 | l >>> 20, ai = t[P + 1632 >> 2], l = t[P + 1696 >> 2], tr = ai + l | 0, Di = t[P + 1636 >> 2], n = Di + t[P + 1700 >> 2] | 0, n = l >>> 0 > tr >>> 0 ? n + 1 | 0 : n, l = t[P + 1376 >> 2], Me = l + tr | 0, kr = n, n = n + t[P + 1380 >> 2] | 0, l = l >>> 0 > Me >>> 0 ? n + 1 | 0 : n, n = l + b | 0, Ii = P + 1264 | 0, b = Ce + Me | 0, Ce = b >>> 0 < Me >>> 0 ? n + 1 | 0 : n, Yr = (l | 0) == (Ce | 0) & b >>> 0 < Me >>> 0 | l >>> 0 > Ce >>> 0, di = (l | 0) == (kr | 0) & Me >>> 0 < tr >>> 0 | l >>> 0 < kr >>> 0, l = ei + 8 | 0, wi = t[l >> 2], ei = t[l + 4 >> 2], tr = (kr | 0) == (Di | 0) & tr >>> 0 < ai >>> 0 | kr >>> 0 < Di >>> 0, n = jr + 8 | 0, Me = t[n >> 2], l = ui + 8 | 0, kr = Me + t[l >> 2] | 0, n = t[l + 4 >> 2] + t[n + 4 >> 2] | 0, n = Me >>> 0 > kr >>> 0 ? n + 1 | 0 : n, l = tr + kr | 0, n = (l >>> 0 < kr >>> 0 ? n + 1 | 0 : n) + ei | 0, tr = l, l = l + wi | 0, n = tr >>> 0 > l >>> 0 ? n + 1 | 0 : n, Me = l + di | 0, n = Me >>> 0 < l >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, l = a + Me | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = l, l = l + Yr | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, Me = Ce, tr = l << 12 | Ce >>> 20, a = n, kr = n << 12 | l >>> 20, Di = t[P + 1364 >> 2], n = Di + (lr & 1048575) | 0, ai = t[P + 1360 >> 2], l = Nr & -2, Ce = ai + l | 0, lr = Ce, tr = Ce + tr | 0, l = l >>> 0 > Ce >>> 0 ? n + 1 | 0 : n, n = l + kr | 0, Ce = tr >>> 0 < Ce >>> 0 ? n + 1 | 0 : n, Yr = Ce & 1048575, Nr = Yr, n = nr & 1048575, Ki = n, nr = K, n = n << 1 | K >>> 31, ei = K << 1, wi = n, Pr(Ii, tr, Nr, 0, 0, ei, n, 0, 0), n = or & 1048575, Wi = n, ui = P + 1216 | 0, Nr = Me & 1048575, K = pe << 1, Ti = pe, Me = n << 1 | pe >>> 31, Pr(ui, b, Nr, 0, 0, K, Me, 0, 0), jr = P + 1168 | 0, kr = gr & 65535, gr = (l | 0) == (Ce | 0) & tr >>> 0 < lr >>> 0 | l >>> 0 > Ce >>> 0, or = (l | 0) == (Di | 0) & lr >>> 0 < ai >>> 0 | l >>> 0 < Di >>> 0, l = Ei + 8 | 0, pe = or + t[l >> 2] | 0, n = t[l + 4 >> 2], n = pe >>> 0 < or >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, l = a + pe | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = l, l = l + gr | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, pe = l << 12 | Ce >>> 20, a = pe + Tt | 0, n = kr + (n << 12 | l >>> 20) | 0, n = a >>> 0 < pe >>> 0 ? n + 1 | 0 : n, Pr(jr, a, n, 0, 0, a, n, 0, 0), Tt = P + 1152 | 0, Pr(Tt, t[P + 1168 >> 2], t[P + 1172 >> 2], 0, 0, 15632, 16, 0, 0), l = a, n = n << 1 | l >>> 31, Mn = P + 1120 | 0, di = l << 1, kr = n, Pr(Mn, di, n, 0, 0, nr, Ki, 0, 0), Dn = P + 1200 | 0, Pr(Dn, tr, Yr, 0, 0, K, Me, 0, 0), $i = P + 1312 | 0, Pr($i, b, Nr, 0, 0, b, Nr, 0, 0), ai = P + 1136 | 0, l = jr + 8 | 0, Pr(ai, t[l >> 2], t[l + 4 >> 2], 0, 0, 64028672, 65536, 0, 0), In = P + 1280 | 0, Pr(In, nr, Ki, 0, 0, nr, Ki, 0, 0), Li = P + 1104 | 0, Pr(Li, di, n, 0, 0, Ti, Wi, 0, 0), kn = P + 1184 | 0, gr = tr, nr = Yr, Ce = Nr, Nr = b, Pr(kn, tr, nr, 0, 0, b << 1, Ce << 1 | b >>> 31, 0, 0), pe = t[P + 1264 >> 2], a = t[P + 1216 >> 2], l = pe + a | 0, tr = t[P + 1268 >> 2], n = tr + t[P + 1220 >> 2] | 0, n = l >>> 0 < a >>> 0 ? n + 1 | 0 : n, a = t[P + 1152 >> 2], or = a + l | 0, b = n, n = n + t[P + 1156 >> 2] | 0, a = a >>> 0 > or >>> 0 ? n + 1 | 0 : n, Me = (b | 0) == (a | 0) & l >>> 0 > or >>> 0 | a >>> 0 < b >>> 0, n = Tt + 8 | 0, Tt = t[n >> 2], K = t[n + 4 >> 2], pe = (b | 0) == (tr | 0) & l >>> 0 < pe >>> 0 | b >>> 0 < tr >>> 0, n = ui + 8 | 0, b = t[n >> 2], l = Ii + 8 | 0, tr = b + t[l >> 2] | 0, n = t[l + 4 >> 2] + t[n + 4 >> 2] | 0, n = b >>> 0 > tr >>> 0 ? n + 1 | 0 : n, l = pe + tr | 0, n = (l >>> 0 < tr >>> 0 ? n + 1 | 0 : n) + K | 0, b = l, l = l + Tt | 0, n = b >>> 0 > l >>> 0 ? n + 1 | 0 : n, b = l, l = l + Me | 0, n = b >>> 0 > l >>> 0 ? n + 1 | 0 : n, tr = a, K = l << 12 | a >>> 20, b = n, pe = n << 12 | l >>> 20, Qi = t[P + 1200 >> 2], l = t[P + 1312 >> 2], lr = Qi + l | 0, Xi = t[P + 1204 >> 2], n = Xi + t[P + 1316 >> 2] | 0, n = l >>> 0 > lr >>> 0 ? n + 1 | 0 : n, l = t[P + 1120 >> 2], Me = l + lr | 0, a = n, n = n + t[P + 1124 >> 2] | 0, n = l >>> 0 > Me >>> 0 ? n + 1 | 0 : n, l = t[P + 1136 >> 2], Tt = l + Me | 0, Yr = n, n = n + t[P + 1140 >> 2] | 0, l = l >>> 0 > Tt >>> 0 ? n + 1 | 0 : n, n = l + pe | 0, Ki = P + 1008 | 0, Di = Ki, pe = K + Tt | 0, K = pe >>> 0 < Tt >>> 0 ? n + 1 | 0 : n, Ei = (l | 0) == (K | 0) & pe >>> 0 < Tt >>> 0 | l >>> 0 > K >>> 0, Ii = (l | 0) == (Yr | 0) & Me >>> 0 > Tt >>> 0 | l >>> 0 < Yr >>> 0, l = ai + 8 | 0, ui = t[l >> 2], jr = t[l + 4 >> 2], ai = (a | 0) == (Yr | 0) & Me >>> 0 < lr >>> 0 | a >>> 0 > Yr >>> 0, l = Mn + 8 | 0, Yr = t[l >> 2], Me = t[l + 4 >> 2], Tt = (a | 0) == (Xi | 0) & lr >>> 0 < Qi >>> 0 | a >>> 0 < Xi >>> 0, n = $i + 8 | 0, a = t[n >> 2], l = Dn + 8 | 0, lr = a + t[l >> 2] | 0, n = t[l + 4 >> 2] + t[n + 4 >> 2] | 0, n = a >>> 0 > lr >>> 0 ? n + 1 | 0 : n, l = Tt + lr | 0, n = (l >>> 0 < lr >>> 0 ? n + 1 | 0 : n) + Me | 0, a = l, l = l + Yr | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = l, l = l + ai | 0, n = (a >>> 0 > l >>> 0 ? n + 1 | 0 : n) + jr | 0, a = l, l = l + ui | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = l + Ii | 0, n = a >>> 0 < l >>> 0 ? n + 1 | 0 : n, b = b >>> 20 | 0, l = a + b | 0, n = b >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = l, l = l + Ei | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = K, Tt = l << 12 | a >>> 20, b = n, K = n << 12 | l >>> 20, jr = t[P + 1104 >> 2], l = t[P + 1184 >> 2], lr = jr + l | 0, Qi = t[P + 1108 >> 2], n = Qi + t[P + 1188 >> 2] | 0, l = l >>> 0 > lr >>> 0 ? n + 1 | 0 : n, n = l + K | 0, Tt = Tt + lr | 0, n = Tt >>> 0 < lr >>> 0 ? n + 1 | 0 : n, ai = Tt << 4 & -16, K = n, Yr = (n << 4 | Tt >>> 28) & 16777215, Me = a, Pr(Di, ai | a >>> 16 & 15, Yr, 0, 0, 977, 1, 0, 0), Di = P + 1248 | 0, Pr(Di, Ti, Wi, 0, 0, ei, wi, 0, 0), Ei = P + 1088 | 0, Pr(Ei, di, kr, 0, 0, Nr, Ce, 0, 0), Ii = P + 1328 | 0, Pr(Ii, gr, nr, 0, 0, gr, nr, 0, 0), ui = P + 1072 | 0, ai = ui, Yr = (l | 0) == (n | 0) & Tt >>> 0 < lr >>> 0 | l >>> 0 > n >>> 0, Tt = (l | 0) == (Qi | 0) & lr >>> 0 < jr >>> 0 | l >>> 0 < Qi >>> 0, n = kn + 8 | 0, a = t[n >> 2], l = Li + 8 | 0, lr = a + t[l >> 2] | 0, n = t[l + 4 >> 2] + t[n + 4 >> 2] | 0, n = a >>> 0 > lr >>> 0 ? n + 1 | 0 : n, a = Tt + lr | 0, n = a >>> 0 < lr >>> 0 ? n + 1 | 0 : n, b = b >>> 20 | 0, l = a + b | 0, n = b >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = l, l = l + Yr | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, K = l << 12 | K >>> 20, a = n, b = n << 12 | l >>> 20, Yr = t[P + 1088 >> 2], l = t[P + 1328 >> 2], Tt = Yr + l | 0, Qi = t[P + 1092 >> 2], n = Qi + t[P + 1332 >> 2] | 0, l = l >>> 0 > Tt >>> 0 ? n + 1 | 0 : n, n = l + b | 0, K = K + Tt | 0, n = K >>> 0 < Tt >>> 0 ? n + 1 | 0 : n, b = n, Pr(ai, K, n & 1048575, 0, 0, 15632, 16, 0, 0), jr = P + 1232 | 0, Pr(jr, Nr, Ce, 0, 0, ei, wi, 0, 0), ai = P + 1296 | 0, Pr(ai, Ti, Wi, 0, 0, Ti, Wi, 0, 0), lr = P + 1056 | 0, Pr(lr, gr, nr, 0, 0, di, kr, 0, 0), Nr = P + 1040 | 0, nr = Nr, Ce = (l | 0) == (n | 0) & K >>> 0 < Tt >>> 0 | l >>> 0 > n >>> 0, Tt = (l | 0) == (Qi | 0) & Tt >>> 0 < Yr >>> 0 | l >>> 0 < Qi >>> 0, n = Ii + 8 | 0, K = t[n >> 2], l = Ei + 8 | 0, gr = K + t[l >> 2] | 0, n = t[l + 4 >> 2] + t[n + 4 >> 2] | 0, n = K >>> 0 > gr >>> 0 ? n + 1 | 0 : n, K = Tt + gr | 0, n = K >>> 0 < gr >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, l = a + K | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = l, l = l + Ce | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, K = l << 12 | b >>> 20, b = t[P + 1056 >> 2], Ce = K + b | 0, a = n, l = n << 12 | l >>> 20, n = l + t[P + 1060 >> 2] | 0, n = b >>> 0 > Ce >>> 0 ? n + 1 | 0 : n, Pr(nr, Ce, n, 0, 0, 15632, 16, 0, 0), Yr = P + 1024 | 0, Tt = Yr, K = (l | 0) == (n | 0) & K >>> 0 > Ce >>> 0 | l >>> 0 > n >>> 0, l = lr + 8 | 0, b = t[l >> 2], n = t[l + 4 >> 2], a = a >>> 20 | 0, l = a + b | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = l, l = l + K | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, Pr(Tt, l, n, 0, 0, 64028672, 65536, 0, 0), a = t[P + 1008 >> 2], l = t[P + 1280 >> 2], Ce = a + l | 0, K = t[P + 1012 >> 2], n = K + t[P + 1284 >> 2] | 0, Qi = P + 7176 | 0, Ei = Qi + 8 | 0, gr = Ei, b = l >>> 0 > Ce >>> 0 ? n + 1 | 0 : n, K = (K | 0) == (b | 0) & a >>> 0 > Ce >>> 0 | b >>> 0 < K >>> 0, n = In + 8 | 0, a = t[n >> 2], l = Ki + 8 | 0, Tt = a + t[l >> 2] | 0, n = t[l + 4 >> 2] + t[n + 4 >> 2] | 0, n = a >>> 0 > Tt >>> 0 ? n + 1 | 0 : n, l = K + Tt | 0, n = l >>> 0 < Tt >>> 0 ? n + 1 | 0 : n, Tt = b, K = l << 12 | b >>> 20, a = n, b = n << 12 | l >>> 20, lr = t[P + 1072 >> 2], l = t[P + 1248 >> 2], nr = lr + l | 0, ei = t[P + 1076 >> 2], n = ei + t[P + 1252 >> 2] | 0, l = l >>> 0 > nr >>> 0 ? n + 1 | 0 : n, n = l + b | 0, K = K + nr | 0, n = K >>> 0 < nr >>> 0 ? n + 1 | 0 : n, t[gr >> 2] = K, b = n, t[gr + 4 >> 2] = n & 1048575, Ii = Qi + 16 | 0, kr = Ii, gr = (l | 0) == (n | 0) & K >>> 0 < nr >>> 0 | l >>> 0 > n >>> 0, nr = (l | 0) == (ei | 0) & nr >>> 0 < lr >>> 0 | l >>> 0 < ei >>> 0, n = Di + 8 | 0, K = t[n >> 2], l = ui + 8 | 0, lr = K + t[l >> 2] | 0, n = t[l + 4 >> 2] + t[n + 4 >> 2] | 0, n = K >>> 0 > lr >>> 0 ? n + 1 | 0 : n, K = nr + lr | 0, n = K >>> 0 < lr >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, l = a + K | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = l, l = l + gr | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, K = l << 12 | b >>> 20, a = n, b = n << 12 | l >>> 20, di = t[P + 1232 >> 2], l = t[P + 1296 >> 2], gr = di + l | 0, ui = t[P + 1236 >> 2], n = ui + t[P + 1300 >> 2] | 0, n = l >>> 0 > gr >>> 0 ? n + 1 | 0 : n, l = t[P + 1040 >> 2], nr = l + gr | 0, lr = n, n = n + t[P + 1044 >> 2] | 0, l = l >>> 0 > nr >>> 0 ? n + 1 | 0 : n, n = l + b | 0, K = K + nr | 0, n = K >>> 0 < nr >>> 0 ? n + 1 | 0 : n, t[kr >> 2] = K, b = n, t[kr + 4 >> 2] = n & 1048575, Ti = Qi + 24 | 0, wi = (l | 0) == (n | 0) & K >>> 0 < nr >>> 0 | l >>> 0 > n >>> 0, ei = (l | 0) == (lr | 0) & nr >>> 0 < gr >>> 0 | l >>> 0 < lr >>> 0, l = Nr + 8 | 0, kr = t[l >> 2], Nr = t[l + 4 >> 2], nr = (lr | 0) == (ui | 0) & gr >>> 0 < di >>> 0 | lr >>> 0 < ui >>> 0, n = ai + 8 | 0, K = t[n >> 2], l = jr + 8 | 0, gr = K + t[l >> 2] | 0, n = t[l + 4 >> 2] + t[n + 4 >> 2] | 0, n = K >>> 0 > gr >>> 0 ? n + 1 | 0 : n, l = nr + gr | 0, n = (l >>> 0 < gr >>> 0 ? n + 1 | 0 : n) + Nr | 0, K = l, l = l + kr | 0, n = K >>> 0 > l >>> 0 ? n + 1 | 0 : n, K = l + ei | 0, n = K >>> 0 < l >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, l = a + K | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = l, l = l + wi | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, nr = l << 12 | b >>> 20, a = n, K = n << 12 | l >>> 20, gr = t[P + 1024 >> 2], b = or & -2, l = gr + b | 0, Nr = t[P + 1028 >> 2], n = Nr + (tr & 1048575) | 0, or = l >>> 0 < b >>> 0 ? n + 1 | 0 : n, n = or + K | 0, tr = l, b = l + nr | 0, n = l >>> 0 > b >>> 0 ? n + 1 | 0 : n, t[Ti >> 2] = b, l = n, t[Ti + 4 >> 2] = n & 1048575, lr = Qi + 32 | 0, K = pe, nr = Me & 65535, Me = (n | 0) == (or | 0) & b >>> 0 < tr >>> 0 | n >>> 0 < or >>> 0, b = (or | 0) == (Nr | 0) & tr >>> 0 < gr >>> 0 | or >>> 0 < Nr >>> 0, n = Yr + 8 | 0, pe = b + t[n >> 2] | 0, n = t[n + 4 >> 2], n = b >>> 0 > pe >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, b = a, a = a + pe | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, b = a, a = a + Me | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, l = a << 12 | l >>> 20, b = l + K | 0, n = nr + (n << 12 | a >>> 20) | 0, t[lr >> 2] = b, t[lr + 4 >> 2] = l >>> 0 > b >>> 0 ? n + 1 | 0 : n, t[P + 7176 >> 2] = Ce, t[P + 7180 >> 2] = Tt & 1048575, zr(Qi, Qi, P + 7536 | 0), Ce = t[lr + 4 >> 2], n = P + 7136 | 0, l = n + 32 | 0, a = t[lr >> 2], t[l >> 2] = a, t[l + 4 >> 2] = Ce, Me = t[Ti + 4 >> 2], l = n + 24 | 0, Tt = t[Ti >> 2], t[l >> 2] = Tt, t[l + 4 >> 2] = Me, nr = t[Ii + 4 >> 2], l = n + 16 | 0, K = t[Ii >> 2], t[l >> 2] = K, t[l + 4 >> 2] = nr, or = t[Ei + 4 >> 2], l = n + 8 | 0, pe = t[Ei >> 2], t[l >> 2] = pe, t[l + 4 >> 2] = or, tr = t[P + 7180 >> 2], b = t[P + 7176 >> 2], t[P + 7136 >> 2] = b, t[P + 7140 >> 2] = tr, l = 23; lr = b, n = tr << 1 | b >>> 31, Ii = P + 976 | 0, Yr = b << 1, Ti = n, Pr(Ii, Tt, Me, 0, 0, Yr, n, 0, 0), jr = P + 896 | 0, b = pe << 1, gr = or, di = pe, pe = or << 1 | pe >>> 31, Pr(jr, K, nr, 0, 0, b, pe, 0, 0), kr = P + 832 | 0, Pr(kr, a, Ce, 0, 0, a, Ce, 0, 0), Nr = P + 816 | 0, Pr(Nr, t[P + 832 >> 2], t[P + 836 >> 2], 0, 0, 15632, 16, 0, 0), n = Ce << 1 | a >>> 31, Wi = P + 784 | 0, ai = a << 1, wi = n, Pr(Wi, ai, n, 0, 0, lr, tr, 0, 0), Xi = P + 944 | 0, Pr(Xi, Tt, Me, 0, 0, b, pe, 0, 0), Mn = P + 880 | 0, Pr(Mn, K, nr, 0, 0, K, nr, 0, 0), ui = P + 800 | 0, n = kr + 8 | 0, Pr(ui, t[n >> 2], t[n + 4 >> 2], 0, 0, 64028672, 65536, 0, 0), Dn = P + 992 | 0, Pr(Dn, lr, tr, 0, 0, lr, tr, 0, 0), $i = P + 768 | 0, Pr($i, ai, wi, 0, 0, di, or, 0, 0), In = P + 848 | 0, tr = Tt, ei = K, Pr(In, Tt, Me, 0, 0, K << 1, nr << 1 | K >>> 31, 0, 0), lr = t[P + 980 >> 2], n = lr + t[P + 900 >> 2] | 0, K = t[P + 976 >> 2], b = t[P + 896 >> 2], a = K + b | 0, pe = t[P + 816 >> 2], kr = a + pe | 0, b = a >>> 0 < b >>> 0 ? n + 1 | 0 : n, n = b + t[P + 820 >> 2] | 0, pe = pe >>> 0 > kr >>> 0 ? n + 1 | 0 : n, or = (b | 0) == (pe | 0) & a >>> 0 > kr >>> 0 | b >>> 0 > pe >>> 0, n = Nr + 8 | 0, Ce = t[n >> 2], Tt = t[n + 4 >> 2], K = (b | 0) == (lr | 0) & a >>> 0 < K >>> 0 | b >>> 0 < lr >>> 0, b = jr + 8 | 0, a = t[b >> 2], n = Ii + 8 | 0, lr = a + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[b + 4 >> 2] | 0, n = a >>> 0 > lr >>> 0 ? n + 1 | 0 : n, a = K + lr | 0, n = (a >>> 0 < lr >>> 0 ? n + 1 | 0 : n) + Tt | 0, b = a, a = a + Ce | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, b = a, a = a + or | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, or = pe, Tt = a << 12 | pe >>> 20, b = n, K = n << 12 | a >>> 20, Li = t[P + 944 >> 2], a = t[P + 880 >> 2], lr = Li + a | 0, zn = t[P + 948 >> 2], n = zn + t[P + 884 >> 2] | 0, n = a >>> 0 > lr >>> 0 ? n + 1 | 0 : n, a = t[P + 784 >> 2], Ce = a + lr | 0, jr = n, n = n + t[P + 788 >> 2] | 0, n = a >>> 0 > Ce >>> 0 ? n + 1 | 0 : n, a = t[P + 800 >> 2], pe = a + Ce | 0, Nr = n, n = n + t[P + 804 >> 2] | 0, a = a >>> 0 > pe >>> 0 ? n + 1 | 0 : n, n = a + K | 0, kn = P + 752 | 0, Tt = pe + Tt | 0, K = Tt >>> 0 < pe >>> 0 ? n + 1 | 0 : n, Qi = (a | 0) == (K | 0) & pe >>> 0 > Tt >>> 0 | a >>> 0 > K >>> 0, Ki = (a | 0) == (Nr | 0) & pe >>> 0 < Ce >>> 0 | a >>> 0 < Nr >>> 0, n = ui + 8 | 0, Di = t[n >> 2], Ei = t[n + 4 >> 2], Ii = (Nr | 0) == (jr | 0) & Ce >>> 0 < lr >>> 0 | Nr >>> 0 < jr >>> 0, n = Wi + 8 | 0, ui = t[n >> 2], Nr = t[n + 4 >> 2], Ce = (jr | 0) == (zn | 0) & lr >>> 0 < Li >>> 0 | jr >>> 0 < zn >>> 0, pe = Mn + 8 | 0, a = t[pe >> 2], n = Xi + 8 | 0, lr = a + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[pe + 4 >> 2] | 0, n = a >>> 0 > lr >>> 0 ? n + 1 | 0 : n, a = Ce + lr | 0, n = (a >>> 0 < lr >>> 0 ? n + 1 | 0 : n) + Nr | 0, pe = a, a = a + ui | 0, n = pe >>> 0 > a >>> 0 ? n + 1 | 0 : n, pe = a, a = a + Ii | 0, n = (pe >>> 0 > a >>> 0 ? n + 1 | 0 : n) + Ei | 0, pe = a, a = a + Di | 0, n = pe >>> 0 > a >>> 0 ? n + 1 | 0 : n, pe = a + Ki | 0, n = pe >>> 0 < a >>> 0 ? n + 1 | 0 : n, b = b >>> 20 | 0, a = b + pe | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, b = a, a = a + Qi | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, b = K, Ce = a << 12 | b >>> 20, pe = n, Nr = n << 12 | a >>> 20, Li = t[P + 772 >> 2], n = Li + t[P + 852 >> 2] | 0, Ii = t[P + 768 >> 2], a = t[P + 848 >> 2], K = Ii + a | 0, lr = K, Ce = K + Ce | 0, a = a >>> 0 > K >>> 0 ? n + 1 | 0 : n, n = a + Nr | 0, ui = Ce << 4 & -16, K = Ce >>> 0 < K >>> 0 ? n + 1 | 0 : n, jr = (K << 4 | Ce >>> 28) & 16777215, Nr = b, Pr(kn, ui | b >>> 16 & 15, jr, 0, 0, 977, 1, 0, 0), Qi = P + 928 | 0, Pr(Qi, di, gr, 0, 0, Yr, Ti, 0, 0), Ki = P + 736 | 0, Pr(Ki, ai, wi, 0, 0, ei, nr, 0, 0), Di = P + 960 | 0, Pr(Di, tr, Me, 0, 0, tr, Me, 0, 0), Ei = P + 720 | 0, ui = Ei, jr = (a | 0) == (K | 0) & Ce >>> 0 < lr >>> 0 | a >>> 0 > K >>> 0, Ce = (a | 0) == (Li | 0) & lr >>> 0 < Ii >>> 0 | a >>> 0 < Li >>> 0, b = In + 8 | 0, a = t[b >> 2], n = $i + 8 | 0, lr = a + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[b + 4 >> 2] | 0, n = a >>> 0 > lr >>> 0 ? n + 1 | 0 : n, b = Ce + lr | 0, n = b >>> 0 < lr >>> 0 ? n + 1 | 0 : n, pe = pe >>> 20 | 0, a = b + pe | 0, n = pe >>> 0 > a >>> 0 ? n + 1 | 0 : n, b = a, a = a + jr | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, K = a << 12 | K >>> 20, b = n, pe = n << 12 | a >>> 20, lr = t[P + 736 >> 2], a = t[P + 960 >> 2], Ce = lr + a | 0, jr = t[P + 740 >> 2], n = jr + t[P + 964 >> 2] | 0, a = a >>> 0 > Ce >>> 0 ? n + 1 | 0 : n, n = a + pe | 0, K = K + Ce | 0, n = K >>> 0 < Ce >>> 0 ? n + 1 | 0 : n, pe = n, Pr(ui, K, n & 1048575, 0, 0, 15632, 16, 0, 0), Ii = P + 864 | 0, Pr(Ii, ei, nr, 0, 0, Yr, Ti, 0, 0), ui = P + 912 | 0, Pr(ui, di, gr, 0, 0, di, gr, 0, 0), nr = P + 704 | 0, Pr(nr, ai, wi, 0, 0, tr, Me, 0, 0), wi = P + 688 | 0, tr = wi, Me = (n | 0) == (a | 0) & K >>> 0 < Ce >>> 0 | n >>> 0 < a >>> 0, Ce = (a | 0) == (jr | 0) & Ce >>> 0 < lr >>> 0 | a >>> 0 < jr >>> 0, K = Di + 8 | 0, a = t[K >> 2], n = Ki + 8 | 0, gr = a + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[K + 4 >> 2] | 0, n = a >>> 0 > gr >>> 0 ? n + 1 | 0 : n, K = Ce + gr | 0, n = K >>> 0 < gr >>> 0 ? n + 1 | 0 : n, b = b >>> 20 | 0, a = b + K | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, b = a, a = a + Me | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, K = a << 12 | pe >>> 20, pe = t[P + 704 >> 2], Me = K + pe | 0, b = n, a = n << 12 | a >>> 20, n = a + t[P + 708 >> 2] | 0, n = pe >>> 0 > Me >>> 0 ? n + 1 | 0 : n, Pr(tr, Me, n, 0, 0, 15632, 16, 0, 0), jr = P + 672 | 0, Ce = jr, K = (n | 0) == (a | 0) & K >>> 0 > Me >>> 0 | n >>> 0 < a >>> 0, n = nr + 8 | 0, pe = t[n >> 2], n = t[n + 4 >> 2], b = b >>> 20 | 0, a = b + pe | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, b = a, a = a + K | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, Pr(Ce, a, n, 0, 0, 64028672, 65536, 0, 0), b = t[P + 752 >> 2], a = t[P + 992 >> 2], tr = b + a | 0, K = t[P + 756 >> 2], n = K + t[P + 996 >> 2] | 0, pe = a >>> 0 > tr >>> 0 ? n + 1 | 0 : n, K = (K | 0) == (pe | 0) & b >>> 0 > tr >>> 0 | K >>> 0 > pe >>> 0, b = Dn + 8 | 0, a = t[b >> 2], n = kn + 8 | 0, Ce = a + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[b + 4 >> 2] | 0, n = a >>> 0 > Ce >>> 0 ? n + 1 | 0 : n, a = K + Ce | 0, n = a >>> 0 < Ce >>> 0 ? n + 1 | 0 : n, lr = pe, Ce = a << 12 | pe >>> 20, b = n, K = n << 12 | a >>> 20, Me = t[P + 720 >> 2], a = t[P + 928 >> 2], pe = Me + a | 0, gr = t[P + 724 >> 2], n = gr + t[P + 932 >> 2] | 0, n = a >>> 0 > pe >>> 0 ? n + 1 | 0 : n, a = Ce, Ce = pe, pe = a + pe | 0, a = n, n = n + K | 0, K = pe >>> 0 < Ce >>> 0 ? n + 1 | 0 : n, nr = (a | 0) == (K | 0) & pe >>> 0 < Ce >>> 0 | a >>> 0 > K >>> 0, Me = (a | 0) == (gr | 0) & Ce >>> 0 < Me >>> 0 | a >>> 0 < gr >>> 0, Ce = Qi + 8 | 0, a = t[Ce >> 2], n = Ei + 8 | 0, gr = a + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[Ce + 4 >> 2] | 0, n = a >>> 0 > gr >>> 0 ? n + 1 | 0 : n, Ce = Me + gr | 0, n = Ce >>> 0 < gr >>> 0 ? n + 1 | 0 : n, b = b >>> 20 | 0, a = b + Ce | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, b = a, a = a + nr | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, gr = K, Ce = a << 12 | K >>> 20, b = n, K = n << 12 | a >>> 20, ai = t[P + 864 >> 2], a = t[P + 912 >> 2], nr = ai + a | 0, Ei = t[P + 868 >> 2], n = Ei + t[P + 916 >> 2] | 0, n = a >>> 0 > nr >>> 0 ? n + 1 | 0 : n, a = t[P + 688 >> 2], Me = a + nr | 0, ei = n, n = n + t[P + 692 >> 2] | 0, a = a >>> 0 > Me >>> 0 ? n + 1 | 0 : n, n = a + K | 0, K = Ce + Me | 0, Ce = K >>> 0 < Me >>> 0 ? n + 1 | 0 : n, Ti = (a | 0) == (Ce | 0) & K >>> 0 < Me >>> 0 | a >>> 0 > Ce >>> 0, Yr = (a | 0) == (ei | 0) & Me >>> 0 < nr >>> 0 | a >>> 0 < ei >>> 0, n = wi + 8 | 0, di = t[n >> 2], wi = t[n + 4 >> 2], nr = (ei | 0) == (Ei | 0) & nr >>> 0 < ai >>> 0 | ei >>> 0 < Ei >>> 0, Me = ui + 8 | 0, a = t[Me >> 2], n = Ii + 8 | 0, ei = a + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[Me + 4 >> 2] | 0, n = a >>> 0 > ei >>> 0 ? n + 1 | 0 : n, a = nr + ei | 0, n = (a >>> 0 < ei >>> 0 ? n + 1 | 0 : n) + wi | 0, nr = a, a = a + di | 0, n = nr >>> 0 > a >>> 0 ? n + 1 | 0 : n, Me = a + Yr | 0, n = Me >>> 0 < a >>> 0 ? n + 1 | 0 : n, b = b >>> 20 | 0, a = b + Me | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, b = a, a = a + Ti | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, nr = Ce, Me = a << 12 | Ce >>> 20, b = n, Ce = n << 12 | a >>> 20, di = t[P + 672 >> 2], kr = di + (kr & -2) | 0, wi = t[P + 676 >> 2], n = wi + (or & 1048575) | 0, a = kr >>> 0 < di >>> 0 ? n + 1 | 0 : n, n = a + Ce | 0, or = Tt, ei = Nr & 65535, Me = Me + kr | 0, Ce = Me >>> 0 < kr >>> 0 ? n + 1 | 0 : n, Tt = Me, Nr = (a | 0) == (Ce | 0) & Me >>> 0 < kr >>> 0 | a >>> 0 > Ce >>> 0, a = (a | 0) == (wi | 0) & kr >>> 0 < di >>> 0 | a >>> 0 < wi >>> 0, n = jr + 8 | 0, Me = a + t[n >> 2] | 0, n = t[n + 4 >> 2], n = a >>> 0 > Me >>> 0 ? n + 1 | 0 : n, b = b >>> 20 | 0, a = b + Me | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, b = a, a = a + Nr | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, b = Ce, Me = a << 12 | b >>> 20, Ce = Me + or | 0, n = ei + (n << 12 | a >>> 20) | 0, a = Ce, Ce = a >>> 0 < Me >>> 0 ? n + 1 | 0 : n, Me = b & 1048575, nr = nr & 1048575, or = gr & 1048575, b = tr, tr = lr & 1048575, l = l - 1 | 0, !!l; )
      ;
    for (t[P + 7168 >> 2] = a, t[P + 7172 >> 2] = Ce, t[P + 7160 >> 2] = Tt, t[P + 7164 >> 2] = Me, t[P + 7152 >> 2] = K, t[P + 7156 >> 2] = nr, t[P + 7144 >> 2] = pe, t[P + 7148 >> 2] = or, t[P + 7136 >> 2] = b, t[P + 7140 >> 2] = tr, l = P + 7136 | 0, zr(l, l, P + 7376 | 0), l = 6, a = t[P + 7168 >> 2], Ce = t[P + 7172 >> 2], Tt = t[P + 7160 >> 2], Me = t[P + 7164 >> 2], K = t[P + 7152 >> 2], nr = t[P + 7156 >> 2], pe = t[P + 7144 >> 2], or = t[P + 7148 >> 2], b = t[P + 7136 >> 2], tr = t[P + 7140 >> 2]; lr = b, n = tr << 1 | b >>> 31, Ii = P + 640 | 0, Yr = b << 1, Ti = n, Pr(Ii, Tt, Me, 0, 0, Yr, n, 0, 0), jr = P + 560 | 0, b = pe << 1, gr = or, di = pe, pe = or << 1 | pe >>> 31, Pr(jr, K, nr, 0, 0, b, pe, 0, 0), kr = P + 496 | 0, Pr(kr, a, Ce, 0, 0, a, Ce, 0, 0), Nr = P + 480 | 0, Pr(Nr, t[P + 496 >> 2], t[P + 500 >> 2], 0, 0, 15632, 16, 0, 0), n = Ce << 1 | a >>> 31, Wi = P + 448 | 0, ai = a << 1, wi = n, Pr(Wi, ai, n, 0, 0, lr, tr, 0, 0), Xi = P + 608 | 0, Pr(Xi, Tt, Me, 0, 0, b, pe, 0, 0), Mn = P + 544 | 0, Pr(Mn, K, nr, 0, 0, K, nr, 0, 0), ui = P + 464 | 0, n = kr + 8 | 0, Pr(ui, t[n >> 2], t[n + 4 >> 2], 0, 0, 64028672, 65536, 0, 0), Dn = P + 656 | 0, Pr(Dn, lr, tr, 0, 0, lr, tr, 0, 0), $i = P + 432 | 0, Pr($i, ai, wi, 0, 0, di, or, 0, 0), In = P + 512 | 0, tr = Tt, ei = K, Pr(In, Tt, Me, 0, 0, K << 1, nr << 1 | K >>> 31, 0, 0), lr = t[P + 644 >> 2], n = lr + t[P + 564 >> 2] | 0, K = t[P + 640 >> 2], b = t[P + 560 >> 2], a = K + b | 0, pe = t[P + 480 >> 2], kr = a + pe | 0, b = a >>> 0 < b >>> 0 ? n + 1 | 0 : n, n = b + t[P + 484 >> 2] | 0, pe = pe >>> 0 > kr >>> 0 ? n + 1 | 0 : n, or = (b | 0) == (pe | 0) & a >>> 0 > kr >>> 0 | b >>> 0 > pe >>> 0, n = Nr + 8 | 0, Ce = t[n >> 2], Tt = t[n + 4 >> 2], K = (b | 0) == (lr | 0) & a >>> 0 < K >>> 0 | b >>> 0 < lr >>> 0, b = jr + 8 | 0, a = t[b >> 2], n = Ii + 8 | 0, lr = a + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[b + 4 >> 2] | 0, n = a >>> 0 > lr >>> 0 ? n + 1 | 0 : n, a = K + lr | 0, n = (a >>> 0 < lr >>> 0 ? n + 1 | 0 : n) + Tt | 0, b = a, a = a + Ce | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, b = a, a = a + or | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, or = pe, Tt = a << 12 | pe >>> 20, b = n, K = n << 12 | a >>> 20, Li = t[P + 608 >> 2], a = t[P + 544 >> 2], lr = Li + a | 0, zn = t[P + 612 >> 2], n = zn + t[P + 548 >> 2] | 0, n = a >>> 0 > lr >>> 0 ? n + 1 | 0 : n, a = t[P + 448 >> 2], Ce = a + lr | 0, jr = n, n = n + t[P + 452 >> 2] | 0, n = a >>> 0 > Ce >>> 0 ? n + 1 | 0 : n, a = t[P + 464 >> 2], pe = a + Ce | 0, Nr = n, n = n + t[P + 468 >> 2] | 0, a = a >>> 0 > pe >>> 0 ? n + 1 | 0 : n, n = a + K | 0, kn = P + 416 | 0, Tt = pe + Tt | 0, K = Tt >>> 0 < pe >>> 0 ? n + 1 | 0 : n, Qi = (a | 0) == (K | 0) & pe >>> 0 > Tt >>> 0 | a >>> 0 > K >>> 0, Ki = (a | 0) == (Nr | 0) & pe >>> 0 < Ce >>> 0 | a >>> 0 < Nr >>> 0, n = ui + 8 | 0, Di = t[n >> 2], Ei = t[n + 4 >> 2], Ii = (Nr | 0) == (jr | 0) & Ce >>> 0 < lr >>> 0 | Nr >>> 0 < jr >>> 0, n = Wi + 8 | 0, ui = t[n >> 2], Nr = t[n + 4 >> 2], Ce = (jr | 0) == (zn | 0) & lr >>> 0 < Li >>> 0 | jr >>> 0 < zn >>> 0, pe = Mn + 8 | 0, a = t[pe >> 2], n = Xi + 8 | 0, lr = a + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[pe + 4 >> 2] | 0, n = a >>> 0 > lr >>> 0 ? n + 1 | 0 : n, a = Ce + lr | 0, n = (a >>> 0 < lr >>> 0 ? n + 1 | 0 : n) + Nr | 0, pe = a, a = a + ui | 0, n = pe >>> 0 > a >>> 0 ? n + 1 | 0 : n, pe = a, a = a + Ii | 0, n = (pe >>> 0 > a >>> 0 ? n + 1 | 0 : n) + Ei | 0, pe = a, a = a + Di | 0, n = pe >>> 0 > a >>> 0 ? n + 1 | 0 : n, pe = a + Ki | 0, n = pe >>> 0 < a >>> 0 ? n + 1 | 0 : n, b = b >>> 20 | 0, a = b + pe | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, b = a, a = a + Qi | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, b = K, Ce = a << 12 | b >>> 20, pe = n, K = n << 12 | a >>> 20, Ii = t[P + 432 >> 2], a = t[P + 512 >> 2], lr = Ii + a | 0, Li = t[P + 436 >> 2], n = Li + t[P + 516 >> 2] | 0, a = a >>> 0 > lr >>> 0 ? n + 1 | 0 : n, n = a + K | 0, Ce = Ce + lr | 0, n = Ce >>> 0 < lr >>> 0 ? n + 1 | 0 : n, ui = Ce << 4 & -16, K = n, jr = (n << 4 | Ce >>> 28) & 16777215, Nr = b, Pr(kn, ui | b >>> 16 & 15, jr, 0, 0, 977, 1, 0, 0), Qi = P + 592 | 0, Pr(Qi, di, gr, 0, 0, Yr, Ti, 0, 0), Ki = P + 400 | 0, Pr(Ki, ai, wi, 0, 0, ei, nr, 0, 0), Di = P + 624 | 0, Pr(Di, tr, Me, 0, 0, tr, Me, 0, 0), Ei = P + 384 | 0, ui = Ei, jr = (a | 0) == (n | 0) & Ce >>> 0 < lr >>> 0 | a >>> 0 > n >>> 0, Ce = (a | 0) == (Li | 0) & lr >>> 0 < Ii >>> 0 | a >>> 0 < Li >>> 0, b = In + 8 | 0, a = t[b >> 2], n = $i + 8 | 0, lr = a + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[b + 4 >> 2] | 0, n = a >>> 0 > lr >>> 0 ? n + 1 | 0 : n, b = Ce + lr | 0, n = b >>> 0 < lr >>> 0 ? n + 1 | 0 : n, pe = pe >>> 20 | 0, a = b + pe | 0, n = pe >>> 0 > a >>> 0 ? n + 1 | 0 : n, b = a, a = a + jr | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, K = a << 12 | K >>> 20, b = n, jr = n << 12 | a >>> 20, Li = t[P + 404 >> 2], n = Li + t[P + 628 >> 2] | 0, lr = t[P + 400 >> 2], a = t[P + 624 >> 2], pe = lr + a | 0, Ce = pe, K = pe + K | 0, a = a >>> 0 > pe >>> 0 ? n + 1 | 0 : n, n = a + jr | 0, pe = K >>> 0 < pe >>> 0 ? n + 1 | 0 : n, Pr(ui, K, pe & 1048575, 0, 0, 15632, 16, 0, 0), Ii = P + 528 | 0, Pr(Ii, ei, nr, 0, 0, Yr, Ti, 0, 0), ui = P + 576 | 0, Pr(ui, di, gr, 0, 0, di, gr, 0, 0), nr = P + 368 | 0, Pr(nr, ai, wi, 0, 0, tr, Me, 0, 0), wi = P + 352 | 0, tr = wi, Me = (a | 0) == (pe | 0) & K >>> 0 < Ce >>> 0 | a >>> 0 > pe >>> 0, Ce = (a | 0) == (Li | 0) & Ce >>> 0 < lr >>> 0 | a >>> 0 < Li >>> 0, K = Di + 8 | 0, a = t[K >> 2], n = Ki + 8 | 0, gr = a + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[K + 4 >> 2] | 0, n = a >>> 0 > gr >>> 0 ? n + 1 | 0 : n, K = Ce + gr | 0, n = K >>> 0 < gr >>> 0 ? n + 1 | 0 : n, b = b >>> 20 | 0, a = b + K | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, b = a, a = a + Me | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, K = a << 12 | pe >>> 20, pe = t[P + 368 >> 2], Me = K + pe | 0, b = n, a = n << 12 | a >>> 20, n = a + t[P + 372 >> 2] | 0, n = pe >>> 0 > Me >>> 0 ? n + 1 | 0 : n, Pr(tr, Me, n, 0, 0, 15632, 16, 0, 0), jr = P + 336 | 0, Ce = jr, K = (n | 0) == (a | 0) & K >>> 0 > Me >>> 0 | n >>> 0 < a >>> 0, n = nr + 8 | 0, pe = t[n >> 2], n = t[n + 4 >> 2], b = b >>> 20 | 0, a = b + pe | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, b = a, a = a + K | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, Pr(Ce, a, n, 0, 0, 64028672, 65536, 0, 0), b = t[P + 416 >> 2], a = t[P + 656 >> 2], tr = b + a | 0, K = t[P + 420 >> 2], n = K + t[P + 660 >> 2] | 0, pe = a >>> 0 > tr >>> 0 ? n + 1 | 0 : n, K = (K | 0) == (pe | 0) & b >>> 0 > tr >>> 0 | K >>> 0 > pe >>> 0, b = Dn + 8 | 0, a = t[b >> 2], n = kn + 8 | 0, Ce = a + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[b + 4 >> 2] | 0, n = a >>> 0 > Ce >>> 0 ? n + 1 | 0 : n, a = K + Ce | 0, n = a >>> 0 < Ce >>> 0 ? n + 1 | 0 : n, lr = pe, Ce = a << 12 | pe >>> 20, b = n, K = n << 12 | a >>> 20, Me = t[P + 384 >> 2], a = t[P + 592 >> 2], pe = Me + a | 0, gr = t[P + 388 >> 2], n = gr + t[P + 596 >> 2] | 0, n = a >>> 0 > pe >>> 0 ? n + 1 | 0 : n, a = Ce, Ce = pe, pe = a + pe | 0, a = n, n = n + K | 0, K = pe >>> 0 < Ce >>> 0 ? n + 1 | 0 : n, nr = (a | 0) == (K | 0) & pe >>> 0 < Ce >>> 0 | a >>> 0 > K >>> 0, Me = (a | 0) == (gr | 0) & Ce >>> 0 < Me >>> 0 | a >>> 0 < gr >>> 0, Ce = Qi + 8 | 0, a = t[Ce >> 2], n = Ei + 8 | 0, gr = a + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[Ce + 4 >> 2] | 0, n = a >>> 0 > gr >>> 0 ? n + 1 | 0 : n, Ce = Me + gr | 0, n = Ce >>> 0 < gr >>> 0 ? n + 1 | 0 : n, b = b >>> 20 | 0, a = b + Ce | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, b = a, a = a + nr | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, gr = K, Ce = a << 12 | K >>> 20, b = n, K = n << 12 | a >>> 20, ai = t[P + 528 >> 2], a = t[P + 576 >> 2], nr = ai + a | 0, Ei = t[P + 532 >> 2], n = Ei + t[P + 580 >> 2] | 0, n = a >>> 0 > nr >>> 0 ? n + 1 | 0 : n, a = t[P + 352 >> 2], Me = a + nr | 0, ei = n, n = n + t[P + 356 >> 2] | 0, a = a >>> 0 > Me >>> 0 ? n + 1 | 0 : n, n = a + K | 0, K = Ce + Me | 0, Ce = K >>> 0 < Me >>> 0 ? n + 1 | 0 : n, Ti = (a | 0) == (Ce | 0) & K >>> 0 < Me >>> 0 | a >>> 0 > Ce >>> 0, Yr = (a | 0) == (ei | 0) & Me >>> 0 < nr >>> 0 | a >>> 0 < ei >>> 0, n = wi + 8 | 0, di = t[n >> 2], wi = t[n + 4 >> 2], nr = (ei | 0) == (Ei | 0) & nr >>> 0 < ai >>> 0 | ei >>> 0 < Ei >>> 0, Me = ui + 8 | 0, a = t[Me >> 2], n = Ii + 8 | 0, ei = a + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[Me + 4 >> 2] | 0, n = a >>> 0 > ei >>> 0 ? n + 1 | 0 : n, a = nr + ei | 0, n = (a >>> 0 < ei >>> 0 ? n + 1 | 0 : n) + wi | 0, nr = a, a = a + di | 0, n = nr >>> 0 > a >>> 0 ? n + 1 | 0 : n, Me = a + Yr | 0, n = Me >>> 0 < a >>> 0 ? n + 1 | 0 : n, b = b >>> 20 | 0, a = b + Me | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, b = a, a = a + Ti | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, nr = Ce, Me = a << 12 | Ce >>> 20, b = n, Ce = n << 12 | a >>> 20, di = t[P + 336 >> 2], kr = di + (kr & -2) | 0, wi = t[P + 340 >> 2], n = wi + (or & 1048575) | 0, a = kr >>> 0 < di >>> 0 ? n + 1 | 0 : n, n = a + Ce | 0, or = Tt, ei = Nr & 65535, Me = Me + kr | 0, Ce = Me >>> 0 < kr >>> 0 ? n + 1 | 0 : n, Tt = Me, Nr = (a | 0) == (Ce | 0) & Me >>> 0 < kr >>> 0 | a >>> 0 > Ce >>> 0, a = (a | 0) == (wi | 0) & kr >>> 0 < di >>> 0 | a >>> 0 < wi >>> 0, n = jr + 8 | 0, Me = a + t[n >> 2] | 0, n = t[n + 4 >> 2], n = a >>> 0 > Me >>> 0 ? n + 1 | 0 : n, b = b >>> 20 | 0, a = b + Me | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, b = a, a = a + Nr | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, b = Ce, Me = a << 12 | b >>> 20, Ce = Me + or | 0, n = ei + (n << 12 | a >>> 20) | 0, a = Ce, Ce = a >>> 0 < Me >>> 0 ? n + 1 | 0 : n, Me = b & 1048575, nr = nr & 1048575, or = gr & 1048575, b = tr, tr = lr & 1048575, l = l - 1 | 0, !!l; )
      ;
    t[P + 7168 >> 2] = a, t[P + 7172 >> 2] = Ce, t[P + 7160 >> 2] = Tt, t[P + 7164 >> 2] = Me, t[P + 7152 >> 2] = K, t[P + 7156 >> 2] = nr, t[P + 7144 >> 2] = pe, t[P + 7148 >> 2] = or, t[P + 7136 >> 2] = b, t[P + 7140 >> 2] = tr, Mn = P + 7136 | 0, zr(Mn, Mn, P + 7576 | 0), l = t[P + 7140 >> 2], gr = l, or = t[P + 7136 >> 2], K = or, n = l << 1 | K >>> 31, tr = P - -64 | 0, ei = t[P + 7160 >> 2], kr = t[P + 7164 >> 2], Ti = K << 1, ai = n, Pr(tr, ei, kr, 0, 0, Ti, n, 0, 0), l = t[P + 7148 >> 2], Wi = l, Xi = t[P + 7144 >> 2], a = Xi, n = l << 1 | a >>> 31, Me = P + 272 | 0, di = t[P + 7152 >> 2], Nr = t[P + 7156 >> 2], a = a << 1, b = n, Pr(Me, di, Nr, 0, 0, a, n, 0, 0), Ce = P + 224 | 0, pe = t[P + 7168 >> 2], l = t[P + 7172 >> 2], Pr(Ce, pe, l, 0, 0, pe, l, 0, 0), Tt = P + 208 | 0, Pr(Tt, t[P + 224 >> 2], t[P + 228 >> 2], 0, 0, 15632, 16, 0, 0), n = l << 1 | pe >>> 31, kn = P + 176 | 0, ui = pe << 1, Yr = n, Pr(kn, ui, n, 0, 0, K, gr, 0, 0), Qi = P + 80 | 0, Pr(Qi, ei, kr, 0, 0, a, b, 0, 0), Ki = P + 256 | 0, Pr(Ki, di, Nr, 0, 0, di, Nr, 0, 0), nr = P + 192 | 0, l = Ce + 8 | 0, Pr(nr, t[l >> 2], t[l + 4 >> 2], 0, 0, 64028672, 65536, 0, 0), Dn = P + 320 | 0, Pr(Dn, K, gr, 0, 0, K, gr, 0, 0), $i = P + 160 | 0, Pr($i, ui, n, 0, 0, Xi, Wi, 0, 0), In = P + 96 | 0, Pr(In, ei, kr, 0, 0, di << 1, Nr << 1 | di >>> 31, 0, 0), or = t[P + 68 >> 2], n = or + t[P + 276 >> 2] | 0, pe = t[P + 64 >> 2], a = t[P + 272 >> 2], l = pe + a | 0, b = t[P + 208 >> 2], lr = l + b | 0, a = l >>> 0 < a >>> 0 ? n + 1 | 0 : n, n = a + t[P + 212 >> 2] | 0, b = b >>> 0 > lr >>> 0 ? n + 1 | 0 : n, Ce = (a | 0) == (b | 0) & l >>> 0 > lr >>> 0 | a >>> 0 > b >>> 0, n = Tt + 8 | 0, Tt = t[n >> 2], K = t[n + 4 >> 2], pe = (a | 0) == (or | 0) & l >>> 0 < pe >>> 0 | a >>> 0 < or >>> 0, n = Me + 8 | 0, a = t[n >> 2], l = tr + 8 | 0, Me = a + t[l >> 2] | 0, n = t[l + 4 >> 2] + t[n + 4 >> 2] | 0, n = a >>> 0 > Me >>> 0 ? n + 1 | 0 : n, l = pe + Me | 0, n = (l >>> 0 < Me >>> 0 ? n + 1 | 0 : n) + K | 0, a = l, l = l + Tt | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = l, l = l + Ce | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, gr = b, K = l << 12 | b >>> 20, a = n, pe = n << 12 | l >>> 20, Di = t[P + 80 >> 2], l = t[P + 256 >> 2], Me = Di + l | 0, Li = t[P + 84 >> 2], n = Li + t[P + 260 >> 2] | 0, n = l >>> 0 > Me >>> 0 ? n + 1 | 0 : n, l = t[P + 176 >> 2], Ce = l + Me | 0, or = n, n = n + t[P + 180 >> 2] | 0, n = l >>> 0 > Ce >>> 0 ? n + 1 | 0 : n, l = t[P + 192 >> 2], b = l + Ce | 0, tr = n, n = n + t[P + 196 >> 2] | 0, l = l >>> 0 > b >>> 0 ? n + 1 | 0 : n, n = l + pe | 0, pe = P, Tt = b + K | 0, K = Tt >>> 0 < b >>> 0 ? n + 1 | 0 : n, Ei = (l | 0) == (K | 0) & b >>> 0 > Tt >>> 0 | l >>> 0 > K >>> 0, Ii = (l | 0) == (tr | 0) & b >>> 0 < Ce >>> 0 | l >>> 0 < tr >>> 0, l = nr + 8 | 0, jr = t[l >> 2], wi = t[l + 4 >> 2], P = (tr | 0) == (or | 0) & Ce >>> 0 < Me >>> 0 | tr >>> 0 < or >>> 0, l = kn + 8 | 0, nr = t[l >> 2], tr = t[l + 4 >> 2], Ce = (or | 0) == (Li | 0) & Me >>> 0 < Di >>> 0 | or >>> 0 < Li >>> 0, n = Ki + 8 | 0, b = t[n >> 2], l = Qi + 8 | 0, Me = b + t[l >> 2] | 0, n = t[l + 4 >> 2] + t[n + 4 >> 2] | 0, n = b >>> 0 > Me >>> 0 ? n + 1 | 0 : n, l = Ce + Me | 0, n = (l >>> 0 < Me >>> 0 ? n + 1 | 0 : n) + tr | 0, b = l, l = l + nr | 0, n = b >>> 0 > l >>> 0 ? n + 1 | 0 : n, b = l, l = l + P | 0, n = (b >>> 0 > l >>> 0 ? n + 1 | 0 : n) + wi | 0, b = l, l = l + jr | 0, n = b >>> 0 > l >>> 0 ? n + 1 | 0 : n, b = l + Ii | 0, n = b >>> 0 < l >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, l = a + b | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = l, l = l + Ei | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = K, Me = l << 12 | a >>> 20, b = n, Ce = n << 12 | l >>> 20, nr = t[pe + 160 >> 2], l = t[pe + 96 >> 2], K = nr + l | 0, jr = t[pe + 164 >> 2], n = jr + t[pe + 100 >> 2] | 0, l = l >>> 0 > K >>> 0 ? n + 1 | 0 : n, n = l + Ce | 0, tr = K, K = K + Me | 0, or = K << 4 & -16, Ce = K >>> 0 < tr >>> 0 ? n + 1 | 0 : n, Me = (Ce << 4 | K >>> 28) & 16777215, P = a, Pr(pe, or | a >>> 16 & 15, Me, 0, 0, 977, 1, 0, 0), Ei = t[pe + 4 >> 2], n = Ei + t[pe + 324 >> 2] | 0, Ii = t[pe >> 2], a = t[pe + 320 >> 2], Me = Ii + a | 0, t[pe + 7136 >> 2] = Me, a = a >>> 0 > Me >>> 0 ? n + 1 | 0 : n, t[pe + 7140 >> 2] = a & 1048575, Li = pe + 304 | 0, Pr(Li, Xi, Wi, 0, 0, Ti, ai, 0, 0), kn = pe + 144 | 0, Pr(kn, ui, Yr, 0, 0, di, Nr, 0, 0), Qi = pe + 112 | 0, Pr(Qi, ei, kr, 0, 0, ei, kr, 0, 0), Ki = pe + 48 | 0, wi = Ki, or = (l | 0) == (Ce | 0) & K >>> 0 < tr >>> 0 | l >>> 0 > Ce >>> 0, tr = (l | 0) == (jr | 0) & tr >>> 0 < nr >>> 0 | l >>> 0 < jr >>> 0, n = In + 8 | 0, K = t[n >> 2], l = $i + 8 | 0, nr = K + t[l >> 2] | 0, n = t[l + 4 >> 2] + t[n + 4 >> 2] | 0, n = K >>> 0 > nr >>> 0 ? n + 1 | 0 : n, K = tr + nr | 0, n = K >>> 0 < nr >>> 0 ? n + 1 | 0 : n, b = b >>> 20 | 0, l = b + K | 0, n = b >>> 0 > l >>> 0 ? n + 1 | 0 : n, b = l, l = l + or | 0, n = b >>> 0 > l >>> 0 ? n + 1 | 0 : n, tr = l << 12 | Ce >>> 20, K = n, Ce = n << 12 | l >>> 20, $i = t[pe + 148 >> 2], n = $i + t[pe + 116 >> 2] | 0, Di = t[pe + 144 >> 2], b = t[pe + 112 >> 2], l = Di + b | 0, jr = l, nr = l + tr | 0, b = l >>> 0 < b >>> 0 ? n + 1 | 0 : n, n = b + Ce | 0, tr = nr >>> 0 < l >>> 0 ? n + 1 | 0 : n, Pr(wi, nr, tr & 1048575, 0, 0, 15632, 16, 0, 0), Ce = pe, Me = (a | 0) == (Ei | 0) & Me >>> 0 < Ii >>> 0 | a >>> 0 < Ei >>> 0, n = Dn + 8 | 0, pe = t[n >> 2], l = Ce + 8 | 0, or = pe + t[l >> 2] | 0, n = t[l + 4 >> 2] + t[n + 4 >> 2] | 0, n = pe >>> 0 > or >>> 0 ? n + 1 | 0 : n, l = Me + or | 0, n = l >>> 0 < or >>> 0 ? n + 1 | 0 : n, or = l << 12 | a >>> 20, pe = n, Me = n << 12 | l >>> 20, Ei = t[Ce + 48 >> 2], l = t[Ce + 304 >> 2], wi = Ei + l | 0, In = t[Ce + 52 >> 2], n = In + t[Ce + 308 >> 2] | 0, a = l >>> 0 > wi >>> 0 ? n + 1 | 0 : n, n = a + Me | 0, or = or + wi | 0, n = or >>> 0 < wi >>> 0 ? n + 1 | 0 : n, t[Ce + 7144 >> 2] = or, Me = n, t[Ce + 7148 >> 2] = n & 1048575, Ii = Ce + 240 | 0, Pr(Ii, di, Nr, 0, 0, Ti, ai, 0, 0), ai = Ce + 288 | 0, Pr(ai, Xi, Wi, 0, 0, Xi, Wi, 0, 0), Ti = Ce + 128 | 0, Pr(Ti, ui, Yr, 0, 0, ei, kr, 0, 0), di = Ce + 32 | 0, ei = di, Nr = (b | 0) == (tr | 0) & nr >>> 0 < jr >>> 0 | b >>> 0 > tr >>> 0, nr = (b | 0) == ($i | 0) & jr >>> 0 < Di >>> 0 | b >>> 0 < $i >>> 0, n = Qi + 8 | 0, b = t[n >> 2], l = kn + 8 | 0, kr = b + t[l >> 2] | 0, n = t[l + 4 >> 2] + t[n + 4 >> 2] | 0, n = b >>> 0 > kr >>> 0 ? n + 1 | 0 : n, b = nr + kr | 0, n = b >>> 0 < kr >>> 0 ? n + 1 | 0 : n, K = K >>> 20 | 0, l = b + K | 0, n = K >>> 0 > l >>> 0 ? n + 1 | 0 : n, b = l, l = l + Nr | 0, n = b >>> 0 > l >>> 0 ? n + 1 | 0 : n, kr = l << 12 | tr >>> 20, K = t[Ce + 128 >> 2], tr = kr + K | 0, b = n, jr = n << 12 | l >>> 20, n = jr + t[Ce + 132 >> 2] | 0, nr = K >>> 0 > tr >>> 0 ? n + 1 | 0 : n, Pr(ei, tr, nr, 0, 0, 15632, 16, 0, 0), K = Ce, or = (a | 0) == (Me | 0) & or >>> 0 < wi >>> 0 | a >>> 0 > Me >>> 0, Ce = (a | 0) == (In | 0) & wi >>> 0 < Ei >>> 0 | a >>> 0 < In >>> 0, n = Li + 8 | 0, a = t[n >> 2], l = Ki + 8 | 0, Nr = a + t[l >> 2] | 0, n = t[l + 4 >> 2] + t[n + 4 >> 2] | 0, n = a >>> 0 > Nr >>> 0 ? n + 1 | 0 : n, a = Ce + Nr | 0, n = a >>> 0 < Nr >>> 0 ? n + 1 | 0 : n, pe = pe >>> 20 | 0, l = a + pe | 0, n = pe >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = l, l = l + or | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, Ce = l << 12 | Me >>> 20, a = n, pe = n << 12 | l >>> 20, wi = t[K + 240 >> 2], l = t[K + 288 >> 2], or = wi + l | 0, Yr = t[K + 244 >> 2], n = Yr + t[K + 292 >> 2] | 0, n = l >>> 0 > or >>> 0 ? n + 1 | 0 : n, l = t[K + 32 >> 2], Me = l + or | 0, Nr = n, n = n + t[K + 36 >> 2] | 0, l = l >>> 0 > Me >>> 0 ? n + 1 | 0 : n, n = l + pe | 0, Ce = Ce + Me | 0, n = Ce >>> 0 < Me >>> 0 ? n + 1 | 0 : n, t[K + 7152 >> 2] = Ce, pe = n, t[K + 7156 >> 2] = n & 1048575, ei = K + 16 | 0, kr = (nr | 0) == (jr | 0) & tr >>> 0 < kr >>> 0 | nr >>> 0 < jr >>> 0, n = Ti + 8 | 0, nr = t[n >> 2], n = t[n + 4 >> 2], b = b >>> 20 | 0, tr = b, b = b + nr | 0, n = tr >>> 0 > b >>> 0 ? n + 1 | 0 : n, tr = b, b = b + kr | 0, n = tr >>> 0 > b >>> 0 ? n + 1 | 0 : n, Pr(ei, b, n, 0, 0, 64028672, 65536, 0, 0), b = K, kr = (l | 0) == (pe | 0) & Ce >>> 0 < Me >>> 0 | l >>> 0 > pe >>> 0, nr = (l | 0) == (Nr | 0) & Me >>> 0 < or >>> 0 | l >>> 0 < Nr >>> 0, l = di + 8 | 0, tr = t[l >> 2], Me = t[l + 4 >> 2], Ce = (Nr | 0) == (Yr | 0) & or >>> 0 < wi >>> 0 | Nr >>> 0 < Yr >>> 0, n = ai + 8 | 0, K = t[n >> 2], l = Ii + 8 | 0, or = K + t[l >> 2] | 0, n = t[l + 4 >> 2] + t[n + 4 >> 2] | 0, n = K >>> 0 > or >>> 0 ? n + 1 | 0 : n, l = Ce + or | 0, n = (l >>> 0 < or >>> 0 ? n + 1 | 0 : n) + Me | 0, K = l, l = l + tr | 0, n = K >>> 0 > l >>> 0 ? n + 1 | 0 : n, K = l + nr | 0, n = K >>> 0 < l >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, l = a + K | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = l, l = l + kr | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, K = l << 12 | pe >>> 20, a = n, Me = n << 12 | l >>> 20, or = t[b + 16 >> 2], pe = lr & -2, l = or + pe | 0, nr = t[b + 20 >> 2], n = nr + (gr & 1048575) | 0, Ce = l >>> 0 < pe >>> 0 ? n + 1 | 0 : n, n = Ce + Me | 0, pe = K, K = l, pe = pe + l | 0, t[b + 7160 >> 2] = pe, l = l >>> 0 > pe >>> 0 ? n + 1 | 0 : n, t[b + 7164 >> 2] = l & 1048575, gr = b, tr = P & 65535, Me = (l | 0) == (Ce | 0) & K >>> 0 > pe >>> 0 | l >>> 0 < Ce >>> 0, b = (Ce | 0) == (nr | 0) & K >>> 0 < or >>> 0 | Ce >>> 0 < nr >>> 0, n = ei + 8 | 0, pe = b + t[n >> 2] | 0, n = t[n + 4 >> 2], n = b >>> 0 > pe >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, b = a, a = a + pe | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, b = a, a = a + Me | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, l = a << 12 | l >>> 20, b = l + Tt | 0, n = tr + (n << 12 | a >>> 20) | 0, t[gr + 7168 >> 2] = b, t[gr + 7172 >> 2] = l >>> 0 > b >>> 0 ? n + 1 | 0 : n, l = C + 40 | 0, Wn(l, Mn), Wn(Mn, l), n = t[gr + 7080 >> 2], l = t[gr + 7160 >> 2], Nr = n - l | 0, lr = t[gr + 7084 >> 2] - (t[gr + 7164 >> 2] + (l >>> 0 > n >>> 0) | 0) | 0, n = t[gr + 7072 >> 2], l = t[gr + 7152 >> 2], P = n - l | 0, nr = t[gr + 7076 >> 2] - (t[gr + 7156 >> 2] + (l >>> 0 > n >>> 0) | 0) | 0, n = t[gr + 7064 >> 2], l = t[gr + 7144 >> 2], Ce = n - l | 0, Tt = t[gr + 7068 >> 2] - (t[gr + 7148 >> 2] + (l >>> 0 > n >>> 0) | 0) | 0, n = t[gr + 7056 >> 2], l = t[gr + 7136 >> 2], K = n - l | 0, b = t[gr + 7060 >> 2] - (t[gr + 7140 >> 2] + (l >>> 0 > n >>> 0) | 0) | 0, a = t[gr + 7088 >> 2], n = t[gr + 7168 >> 2], l = (a - n | 0) - 4 | 0, n = (t[gr + 7092 >> 2] - (t[gr + 7172 >> 2] + (n >>> 0 > a >>> 0) | 0) | 0) + 262143 | 0, pe = l >>> 0 < 4294967292 ? n + 1 | 0 : n, a = ri(pe >>> 16 | 0, 0, 977, 1), K = a + K | 0, n = b + ve | 0, n = (a >>> 0 > K >>> 0 ? n + 1 | 0 : n) + 4194299 | 0, a = K - 3908 | 0, n = a >>> 0 < 4294963388 ? n + 1 | 0 : n, or = a, tr = n, n = Tt, a = tr >>> 20 | 0, b = a, a = a + Ce | 0, n = (b >>> 0 > a >>> 0 ? n + 1 | 0 : n) + 4194303 | 0, a = a - 4 | 0, n = a >>> 0 < 4294967292 ? n + 1 | 0 : n, Me = a, Ce = n, n = nr, a = Ce >>> 20 | 0, b = a, a = a + P | 0, n = (b >>> 0 > a >>> 0 ? n + 1 | 0 : n) + 4194303 | 0, a = a - 4 | 0, n = a >>> 0 < 4294967292 ? n + 1 | 0 : n, Tt = a, K = n, n = lr, a = K >>> 20 | 0, b = a, a = a + Nr | 0, n = (b >>> 0 > a >>> 0 ? n + 1 | 0 : n) + 4194303 | 0, b = a - 4 | 0, a = b >>> 0 < 4294967292 ? n + 1 | 0 : n, nr = pe & 65535, pe = b, n = nr, b = a >>> 20 | 0, lr = b, b = l + b | 0, n = lr >>> 0 > b >>> 0 ? n + 1 | 0 : n;
    e: {
      if (b | (pe | (Me | or | Tt)) | (n | (Ce | tr | K | a) & 1048575) && (l = 0, (Me & (or ^ 976) & Tt & pe & b) != -1 ? n = 1 : n = (Ce & (tr ^ 1) & K & a & (n ^ 983040)) != 1048575, n) || (l = C + 48 | 0, Tt = t[l >> 2], pe = t[l + 4 >> 2], a = t[C + 44 >> 2], l = C + 72 | 0, Me = t[l >> 2], l = t[l + 4 >> 2], lr = l, n = t[C + 40 >> 2], l = ri(l >>> 16 | 0, 0, 977, 1), K = n + l | 0, n = a + ve | 0, nr = l >>> 0 > K >>> 0 ? n + 1 | 0 : n, n = pe, l = nr >>> 20 | 0, pe = l + Tt | 0, l = l >>> 0 > pe >>> 0 ? n + 1 | 0 : n, or = l & 1048575, n = C - -64 | 0, tr = t[n >> 2], Ce = t[n + 4 >> 2], n = C + 56 | 0, b = t[n >> 2], n = t[n + 4 >> 2], Tt = l >>> 20 | 0, a = b + Tt | 0, Tt = Tt >>> 0 > a >>> 0 ? n + 1 | 0 : n, n = Ce, b = Tt >>> 20 | 0, Ce = b, b = b + tr | 0, n = Ce >>> 0 > b >>> 0 ? n + 1 | 0 : n, tr = n & 1048575, Ce = Tt & 1048575, P = (a & pe & b) == -1 & (l & Ce & n) == 1048575, l = n, n = lr & 65535, l = l >>> 20 | 0, Tt = l + Me | 0, n = l >>> 0 > Tt >>> 0 ? n + 1 | 0 : n, Me = n, nr = nr & 1048575, P & ((Tt | 0) == -1 & (n | 0) == 65535) & ((nr | 0) == 1048574 & K >>> 0 > 4294966318 | nr >>> 0 > 1048574) | n >>> 16 && (n = nr + 1 | 0, K = K + 977 | 0, n = K >>> 0 < 977 ? n + 1 | 0 : n, nr = n & 1048575, l = n, n = or, l = l >>> 20 | 0, pe = l + pe | 0, n = l >>> 0 > pe >>> 0 ? n + 1 | 0 : n, or = n & 1048575, l = n, n = Ce, l = l >>> 20 | 0, a = l + a | 0, n = l >>> 0 > a >>> 0 ? n + 1 | 0 : n, Ce = n & 1048575, l = n, n = tr, l = l >>> 20 | 0, b = l + b | 0, n = l >>> 0 > b >>> 0 ? n + 1 | 0 : n, tr = n & 1048575, l = n, n = Me, lr = Tt, Tt = (l >>> 20 | 0) + Tt | 0, Me = (lr >>> 0 > Tt >>> 0 ? n + 1 | 0 : n) & 65535), t[C + 72 >> 2] = Tt, t[C + 76 >> 2] = Me, t[C + 64 >> 2] = b, t[C + 68 >> 2] = tr, t[C + 56 >> 2] = a, t[C + 60 >> 2] = Ce, t[C + 48 >> 2] = pe, t[C + 52 >> 2] = or, t[C + 40 >> 2] = K, t[C + 44 >> 2] = nr, l = 1, (K & 1) == (w | 0)))
        break e;
      t[C + 72 >> 2] = -4 - Tt, t[C + 76 >> 2] = 262143 - ((Tt >>> 0 > 4294967292) + Me | 0), t[C + 64 >> 2] = -4 - b, t[C + 68 >> 2] = 4194303 - ((b >>> 0 > 4294967292) + tr | 0), t[C + 56 >> 2] = -4 - a, t[C + 60 >> 2] = 4194303 - ((a >>> 0 > 4294967292) + Ce | 0), t[C + 48 >> 2] = -4 - pe, t[C + 52 >> 2] = 4194303 - ((pe >>> 0 > 4294967292) + or | 0), t[C + 40 >> 2] = -3908 - K, t[C + 44 >> 2] = 4194299 - ((K >>> 0 > 4294963388) + nr | 0);
    }
    return U = gr + 7616 | 0, l;
  }
  function zr(C, l, w) {
    var n = 0, a = 0, b = 0, P = 0, K = 0, pe = 0, Ce = 0, Me = 0, Tt = 0, tr = 0, nr = 0, or = 0, lr = 0, gr = 0, kr = 0, Nr = 0, jr = 0, Yr = 0, ei = 0, ai = 0, ui = 0, di = 0, Ii = 0, wi = 0, Ei = 0, Ti = 0, Di = 0, Qi = 0, Li = 0, Ki = 0, Wi = 0, Xi = 0, $i = 0, In = 0, kn = 0, Dn = 0, Mn = 0, zn = 0, es = 0, ns = 0, fs = 0, ps = 0, Es = 0, Ss = 0, Ps = 0, xs = 0, Bs = 0, vs = 0, eo = 0, Xs = 0, fo = 0, co = 0, ao = 0, no = 0, bo = 0, Io = 0, Po = 0, To = 0, mo = 0, Yi = 0, En = 0, On = 0;
    n = U - 496 | 0, U = n, jr = n - -64 | 0, Li = t[w + 24 >> 2], Ki = t[w + 28 >> 2], Wi = t[l >> 2], Xi = t[l + 4 >> 2], Pr(jr, Li, Ki, 0, 0, Wi, Xi, 0, 0), ei = n + 208 | 0, $i = t[w + 16 >> 2], In = t[w + 20 >> 2], kn = t[l + 8 >> 2], Dn = t[l + 12 >> 2], Pr(ei, $i, In, 0, 0, kn, Dn, 0, 0), gr = n + 320 | 0, Mn = t[w + 8 >> 2], zn = t[w + 12 >> 2], es = t[l + 16 >> 2], ns = t[l + 20 >> 2], Pr(gr, Mn, zn, 0, 0, es, ns, 0, 0), Me = n + 400 | 0, fs = t[w >> 2], ps = t[w + 4 >> 2], Es = t[l + 24 >> 2], Ss = t[l + 28 >> 2], Pr(Me, fs, ps, 0, 0, Es, Ss, 0, 0), a = n + 480 | 0, Ps = t[w + 32 >> 2], xs = t[w + 36 >> 2], Bs = t[l + 32 >> 2], di = t[l + 36 >> 2], Pr(a, Ps, xs, 0, 0, Bs, di, 0, 0), Ce = n + 464 | 0, Pr(Ce, t[n + 480 >> 2], t[n + 484 >> 2], 0, 0, 15632, 16, 0, 0), Yr = n + 80 | 0, Pr(Yr, Ps, xs, 0, 0, Wi, Xi, 0, 0), vs = n + 144 | 0, Pr(vs, Li, Ki, 0, 0, kn, Dn, 0, 0), eo = n + 272 | 0, Pr(eo, $i, In, 0, 0, es, ns, 0, 0), Xs = n + 368 | 0, Pr(Xs, Mn, zn, 0, 0, Es, Ss, 0, 0), wi = n + 432 | 0, Pr(wi, fs, ps, 0, 0, Bs, di, 0, 0), lr = n + 448 | 0, l = a + 8 | 0, Pr(lr, t[l >> 2], t[l + 4 >> 2], 0, 0, 64028672, 65536, 0, 0), fo = n + 96 | 0, Pr(fo, fs, ps, 0, 0, Wi, Xi, 0, 0), co = n + 224 | 0, Pr(co, Ps, xs, 0, 0, kn, Dn, 0, 0), ao = n + 160 | 0, Pr(ao, Li, Ki, 0, 0, es, ns, 0, 0), no = n + 288 | 0, Pr(no, $i, In, 0, 0, Es, Ss, 0, 0), Ti = n + 384 | 0, Pr(Ti, Mn, zn, 0, 0, Bs, di, 0, 0), or = t[n + 208 >> 2], w = t[n + 64 >> 2], Nr = or + w | 0, kr = t[n + 212 >> 2], l = kr + t[n + 68 >> 2] | 0, l = w >>> 0 > Nr >>> 0 ? l + 1 | 0 : l, w = t[n + 320 >> 2], pe = w + Nr | 0, a = l, l = l + t[n + 324 >> 2] | 0, K = w >>> 0 > pe >>> 0 ? l + 1 | 0 : l, l = K + t[n + 404 >> 2] | 0, w = t[n + 400 >> 2], P = w + pe | 0, b = t[n + 464 >> 2], bo = P + b | 0, w = w >>> 0 > P >>> 0 ? l + 1 | 0 : l, l = w + t[n + 468 >> 2] | 0, b = b >>> 0 > bo >>> 0 ? l + 1 | 0 : l, tr = (w | 0) == (b | 0) & P >>> 0 > bo >>> 0 | w >>> 0 > b >>> 0, l = Ce + 8 | 0, Io = t[l >> 2], Ei = t[l + 4 >> 2], Tt = (w | 0) == (K | 0) & pe >>> 0 > P >>> 0 | w >>> 0 < K >>> 0, l = Me + 8 | 0, nr = t[l >> 2], Me = t[l + 4 >> 2], Ce = (a | 0) == (K | 0) & pe >>> 0 < Nr >>> 0 | a >>> 0 > K >>> 0, l = gr + 8 | 0, K = t[l >> 2], pe = t[l + 4 >> 2], P = (a | 0) == (kr | 0) & or >>> 0 > Nr >>> 0 | a >>> 0 < kr >>> 0, a = jr + 8 | 0, w = t[a >> 2], l = ei + 8 | 0, Nr = w + t[l >> 2] | 0, l = t[l + 4 >> 2] + t[a + 4 >> 2] | 0, l = w >>> 0 > Nr >>> 0 ? l + 1 | 0 : l, w = P + Nr | 0, l = (w >>> 0 < Nr >>> 0 ? l + 1 | 0 : l) + pe | 0, a = w, w = w + K | 0, l = a >>> 0 > w >>> 0 ? l + 1 | 0 : l, a = w, w = w + Ce | 0, l = (a >>> 0 > w >>> 0 ? l + 1 | 0 : l) + Me | 0, a = w, w = w + nr | 0, l = a >>> 0 > w >>> 0 ? l + 1 | 0 : l, a = w, w = w + Tt | 0, l = (a >>> 0 > w >>> 0 ? l + 1 | 0 : l) + Ei | 0, a = w, w = w + Io | 0, l = a >>> 0 > w >>> 0 ? l + 1 | 0 : l, a = w, w = w + tr | 0, l = a >>> 0 > w >>> 0 ? l + 1 | 0 : l, Io = b, Nr = w << 12 | b >>> 20, a = l, P = l << 12 | w >>> 20, ai = t[n + 272 >> 2], w = t[n + 144 >> 2], Me = ai + w | 0, Di = t[n + 276 >> 2], l = Di + t[n + 148 >> 2] | 0, l = w >>> 0 > Me >>> 0 ? l + 1 | 0 : l, w = t[n + 368 >> 2], Ce = w + Me | 0, tr = l, l = l + t[n + 372 >> 2] | 0, l = w >>> 0 > Ce >>> 0 ? l + 1 | 0 : l, w = t[n + 432 >> 2], K = w + Ce | 0, Ei = l, l = l + t[n + 436 >> 2] | 0, l = w >>> 0 > K >>> 0 ? l + 1 | 0 : l, w = t[n + 80 >> 2], pe = w + K | 0, Tt = l, l = l + t[n + 84 >> 2] | 0, l = w >>> 0 > pe >>> 0 ? l + 1 | 0 : l, w = t[n + 448 >> 2], b = w + pe | 0, nr = l, l = l + t[n + 452 >> 2] | 0, w = w >>> 0 > b >>> 0 ? l + 1 | 0 : l, l = w + P | 0, Nr = b + Nr | 0, P = Nr >>> 0 < b >>> 0 ? l + 1 | 0 : l, Ii = (w | 0) == (P | 0) & b >>> 0 > Nr >>> 0 | w >>> 0 > P >>> 0, ui = (w | 0) == (nr | 0) & b >>> 0 < pe >>> 0 | w >>> 0 < nr >>> 0, l = lr + 8 | 0, kr = t[l >> 2], jr = t[l + 4 >> 2], ei = (Tt | 0) == (nr | 0) & pe >>> 0 < K >>> 0 | Tt >>> 0 > nr >>> 0, l = Yr + 8 | 0, gr = t[l >> 2], Yr = t[l + 4 >> 2], lr = (Tt | 0) == (Ei | 0) & K >>> 0 < Ce >>> 0 | Tt >>> 0 < Ei >>> 0, l = wi + 8 | 0, or = t[l >> 2], Tt = t[l + 4 >> 2], nr = (tr | 0) == (Ei | 0) & Me >>> 0 > Ce >>> 0 | tr >>> 0 > Ei >>> 0, l = Xs + 8 | 0, Ce = t[l >> 2], K = t[l + 4 >> 2], pe = (tr | 0) == (Di | 0) & Me >>> 0 < ai >>> 0 | tr >>> 0 < Di >>> 0, b = vs + 8 | 0, w = t[b >> 2], l = eo + 8 | 0, Me = w + t[l >> 2] | 0, l = t[l + 4 >> 2] + t[b + 4 >> 2] | 0, l = w >>> 0 > Me >>> 0 ? l + 1 | 0 : l, w = pe + Me | 0, l = (w >>> 0 < Me >>> 0 ? l + 1 | 0 : l) + K | 0, b = w, w = w + Ce | 0, l = b >>> 0 > w >>> 0 ? l + 1 | 0 : l, b = w, w = w + nr | 0, l = (b >>> 0 > w >>> 0 ? l + 1 | 0 : l) + Tt | 0, b = w, w = w + or | 0, l = b >>> 0 > w >>> 0 ? l + 1 | 0 : l, b = w, w = w + lr | 0, l = (b >>> 0 > w >>> 0 ? l + 1 | 0 : l) + Yr | 0, b = w, w = w + gr | 0, l = b >>> 0 > w >>> 0 ? l + 1 | 0 : l, b = w, w = w + ei | 0, l = (b >>> 0 > w >>> 0 ? l + 1 | 0 : l) + jr | 0, b = w, w = w + kr | 0, l = b >>> 0 > w >>> 0 ? l + 1 | 0 : l, b = w + ui | 0, l = b >>> 0 < w >>> 0 ? l + 1 | 0 : l, a = a >>> 20 | 0, w = a + b | 0, l = a >>> 0 > w >>> 0 ? l + 1 | 0 : l, a = w, w = w + Ii | 0, l = a >>> 0 > w >>> 0 ? l + 1 | 0 : l, a = P, pe = w << 12 | a >>> 20, b = l, P = l << 12 | w >>> 20, ui = t[n + 288 >> 2], w = t[n + 160 >> 2], Tt = ui + w | 0, ai = t[n + 292 >> 2], l = ai + t[n + 164 >> 2] | 0, l = w >>> 0 > Tt >>> 0 ? l + 1 | 0 : l, w = t[n + 384 >> 2], nr = w + Tt | 0, or = l, l = l + t[n + 388 >> 2] | 0, l = w >>> 0 > nr >>> 0 ? l + 1 | 0 : l, w = t[n + 224 >> 2], Me = w + nr | 0, tr = l, l = l + t[n + 228 >> 2] | 0, w = w >>> 0 > Me >>> 0 ? l + 1 | 0 : l, l = w + P | 0, pe = pe + Me | 0, l = pe >>> 0 < Me >>> 0 ? l + 1 | 0 : l, Ce = pe << 4 & -16, P = l, K = (l << 4 | pe >>> 28) & 16777215, Ei = a, Pr(n, Ce | a >>> 16 & 15, K, 0, 0, 977, 1, 0, 0), Ii = t[n + 4 >> 2], l = Ii + t[n + 100 >> 2] | 0, K = C, kr = t[n >> 2], C = t[n + 96 >> 2], Ce = kr + C | 0, t[K >> 2] = Ce, a = C >>> 0 > Ce >>> 0 ? l + 1 | 0 : l, t[K + 4 >> 2] = a & 1048575, mo = n + 112 | 0, Pr(mo, Mn, zn, 0, 0, Wi, Xi, 0, 0), Yi = n + 240 | 0, Pr(Yi, fs, ps, 0, 0, kn, Dn, 0, 0), En = n + 336 | 0, Pr(En, Ps, xs, 0, 0, es, ns, 0, 0), Qi = n + 176 | 0, Pr(Qi, Li, Ki, 0, 0, Es, Ss, 0, 0), wi = n + 304 | 0, Pr(wi, $i, In, 0, 0, Bs, di, 0, 0), On = n + 48 | 0, jr = On, ei = (w | 0) == (P | 0) & pe >>> 0 < Me >>> 0 | w >>> 0 > P >>> 0, gr = (w | 0) == (tr | 0) & Me >>> 0 < nr >>> 0 | w >>> 0 < tr >>> 0, C = co + 8 | 0, Yr = t[C >> 2], lr = t[C + 4 >> 2], tr = (tr | 0) == (or | 0) & Tt >>> 0 > nr >>> 0 | tr >>> 0 < or >>> 0, C = Ti + 8 | 0, nr = t[C >> 2], Me = t[C + 4 >> 2], pe = (or | 0) == (ai | 0) & Tt >>> 0 < ui >>> 0 | or >>> 0 < ai >>> 0, l = ao + 8 | 0, w = t[l >> 2], C = no + 8 | 0, Tt = w + t[C >> 2] | 0, l = t[C + 4 >> 2] + t[l + 4 >> 2] | 0, l = w >>> 0 > Tt >>> 0 ? l + 1 | 0 : l, C = pe + Tt | 0, l = (C >>> 0 < Tt >>> 0 ? l + 1 | 0 : l) + Me | 0, w = C, C = C + nr | 0, l = w >>> 0 > C >>> 0 ? l + 1 | 0 : l, w = C, C = C + tr | 0, l = (w >>> 0 > C >>> 0 ? l + 1 | 0 : l) + lr | 0, w = C, C = C + Yr | 0, l = w >>> 0 > C >>> 0 ? l + 1 | 0 : l, w = C + gr | 0, l = w >>> 0 < C >>> 0 ? l + 1 | 0 : l, b = b >>> 20 | 0, C = w + b | 0, l = b >>> 0 > C >>> 0 ? l + 1 | 0 : l, w = C, C = C + ei | 0, l = w >>> 0 > C >>> 0 ? l + 1 | 0 : l, b = C << 12 | P >>> 20, pe = l, w = l << 12 | C >>> 20, Ti = t[n + 304 >> 2], C = t[n + 176 >> 2], or = Ti + C | 0, Po = t[n + 308 >> 2], l = Po + t[n + 180 >> 2] | 0, l = C >>> 0 > or >>> 0 ? l + 1 | 0 : l, C = t[n + 336 >> 2], tr = C + or | 0, lr = l, l = l + t[n + 340 >> 2] | 0, P = C >>> 0 > tr >>> 0 ? l + 1 | 0 : l, l = P + w | 0, Tt = b + tr | 0, l = Tt >>> 0 < tr >>> 0 ? l + 1 | 0 : l, Me = l, Pr(jr, Tt, l & 1048575, 0, 0, 15632, 16, 0, 0), b = (a | 0) == (Ii | 0) & Ce >>> 0 < kr >>> 0 | a >>> 0 < Ii >>> 0, l = fo + 8 | 0, w = t[l >> 2], C = n + 8 | 0, Ce = w + t[C >> 2] | 0, l = t[C + 4 >> 2] + t[l + 4 >> 2] | 0, l = w >>> 0 > Ce >>> 0 ? l + 1 | 0 : l, C = b + Ce | 0, l = C >>> 0 < Ce >>> 0 ? l + 1 | 0 : l, nr = C << 12 | a >>> 20, b = l, Ce = l << 12 | C >>> 20, Di = t[n + 240 >> 2], C = t[n + 112 >> 2], gr = Di + C | 0, To = t[n + 244 >> 2], l = To + t[n + 116 >> 2] | 0, ui = C >>> 0 > gr >>> 0 ? l + 1 | 0 : l, l = ui + t[n + 52 >> 2] | 0, w = t[n + 48 >> 2], C = w + gr | 0, ei = C, nr = C + nr | 0, a = C >>> 0 < w >>> 0 ? l + 1 | 0 : l, l = a + Ce | 0, t[K + 8 >> 2] = nr, Ce = nr >>> 0 < C >>> 0 ? l + 1 | 0 : l, t[K + 12 >> 2] = Ce & 1048575, vs = n + 128 | 0, Pr(vs, $i, In, 0, 0, Wi, Xi, 0, 0), eo = n + 256 | 0, Pr(eo, Mn, zn, 0, 0, kn, Dn, 0, 0), Xs = n + 352 | 0, Pr(Xs, fs, ps, 0, 0, es, ns, 0, 0), fo = n + 416 | 0, Pr(fo, Ps, xs, 0, 0, Es, Ss, 0, 0), co = n + 192 | 0, Pr(co, Li, Ki, 0, 0, Bs, di, 0, 0), ao = n + 32 | 0, ai = ao, no = t[n + 416 >> 2], C = t[n + 192 >> 2], Yr = no + C | 0, di = t[n + 420 >> 2], l = di + t[n + 196 >> 2] | 0, w = C >>> 0 > Yr >>> 0 ? l + 1 | 0 : l, Ii = (P | 0) == (Me | 0) & Tt >>> 0 < tr >>> 0 | P >>> 0 > Me >>> 0, kr = (P | 0) == (lr | 0) & tr >>> 0 < or >>> 0 | P >>> 0 < lr >>> 0, C = En + 8 | 0, jr = t[C >> 2], tr = t[C + 4 >> 2], Tt = (lr | 0) == (Po | 0) & or >>> 0 < Ti >>> 0 | lr >>> 0 < Po >>> 0, l = Qi + 8 | 0, P = t[l >> 2], C = wi + 8 | 0, or = P + t[C >> 2] | 0, l = t[C + 4 >> 2] + t[l + 4 >> 2] | 0, l = P >>> 0 > or >>> 0 ? l + 1 | 0 : l, C = Tt + or | 0, l = (C >>> 0 < or >>> 0 ? l + 1 | 0 : l) + tr | 0, P = C, C = C + jr | 0, l = P >>> 0 > C >>> 0 ? l + 1 | 0 : l, P = C + kr | 0, l = P >>> 0 < C >>> 0 ? l + 1 | 0 : l, pe = pe >>> 20 | 0, C = pe + P | 0, l = pe >>> 0 > C >>> 0 ? l + 1 | 0 : l, P = C, C = C + Ii | 0, l = P >>> 0 > C >>> 0 ? l + 1 | 0 : l, pe = C << 12 | Me >>> 20, Me = pe + Yr | 0, P = l, l = w + (l << 12 | C >>> 20) | 0, lr = pe >>> 0 > Me >>> 0 ? l + 1 | 0 : l, Pr(ai, Me, lr, 0, 0, 15632, 16, 0, 0), pe = K, wi = t[n + 256 >> 2], C = t[n + 128 >> 2], or = wi + C | 0, Qi = t[n + 260 >> 2], l = Qi + t[n + 132 >> 2] | 0, l = C >>> 0 > or >>> 0 ? l + 1 | 0 : l, C = t[n + 352 >> 2], tr = C + or | 0, kr = l, l = l + t[n + 356 >> 2] | 0, l = C >>> 0 > tr >>> 0 ? l + 1 | 0 : l, C = t[n + 32 >> 2], Tt = C + tr | 0, jr = l, l = l + t[n + 36 >> 2] | 0, C = C >>> 0 > Tt >>> 0 ? l + 1 | 0 : l, Ti = (a | 0) == (Ce | 0) & nr >>> 0 < ei >>> 0 | a >>> 0 > Ce >>> 0, ai = (a | 0) == (ui | 0) & gr >>> 0 > ei >>> 0 | a >>> 0 < ui >>> 0, l = On + 8 | 0, Ii = t[l >> 2], ei = t[l + 4 >> 2], nr = (ui | 0) == (To | 0) & gr >>> 0 < Di >>> 0 | ui >>> 0 < To >>> 0, K = mo + 8 | 0, a = t[K >> 2], l = Yi + 8 | 0, gr = a + t[l >> 2] | 0, l = t[l + 4 >> 2] + t[K + 4 >> 2] | 0, l = a >>> 0 > gr >>> 0 ? l + 1 | 0 : l, a = nr + gr | 0, l = (a >>> 0 < gr >>> 0 ? l + 1 | 0 : l) + ei | 0, K = a, a = a + Ii | 0, l = K >>> 0 > a >>> 0 ? l + 1 | 0 : l, K = a + ai | 0, l = K >>> 0 < a >>> 0 ? l + 1 | 0 : l, b = b >>> 20 | 0, a = b + K | 0, l = b >>> 0 > a >>> 0 ? l + 1 | 0 : l, b = a, a = a + Ti | 0, l = b >>> 0 > a >>> 0 ? l + 1 | 0 : l, K = a << 12 | Ce >>> 20, Ce = K + Tt | 0, b = l, l = C + (l << 12 | a >>> 20) | 0, t[pe + 16 >> 2] = Ce, K = K >>> 0 > Ce >>> 0 ? l + 1 | 0 : l, t[pe + 20 >> 2] = K & 1048575, gr = n + 16 | 0, nr = (w | 0) == (lr | 0) & Me >>> 0 < Yr >>> 0 | w >>> 0 > lr >>> 0, Me = (w | 0) == (di | 0) & Yr >>> 0 < no >>> 0 | w >>> 0 < di >>> 0, a = co + 8 | 0, w = t[a >> 2], l = fo + 8 | 0, lr = w + t[l >> 2] | 0, l = t[l + 4 >> 2] + t[a + 4 >> 2] | 0, l = w >>> 0 > lr >>> 0 ? l + 1 | 0 : l, a = Me + lr | 0, l = a >>> 0 < lr >>> 0 ? l + 1 | 0 : l, P = P >>> 20 | 0, w = a + P | 0, l = P >>> 0 > w >>> 0 ? l + 1 | 0 : l, a = w, w = w + nr | 0, l = a >>> 0 > w >>> 0 ? l + 1 | 0 : l, Pr(gr, w, l, 0, 0, 64028672, 65536, 0, 0), a = pe, Yr = (C | 0) == (K | 0) & Ce >>> 0 < Tt >>> 0 | C >>> 0 > K >>> 0, lr = (C | 0) == (jr | 0) & Tt >>> 0 < tr >>> 0 | C >>> 0 < jr >>> 0, C = ao + 8 | 0, Tt = t[C >> 2], nr = t[C + 4 >> 2], Me = (kr | 0) == (jr | 0) & tr >>> 0 < or >>> 0 | kr >>> 0 > jr >>> 0, C = Xs + 8 | 0, Ce = t[C >> 2], pe = t[C + 4 >> 2], P = (kr | 0) == (Qi | 0) & or >>> 0 < wi >>> 0 | kr >>> 0 < Qi >>> 0, l = vs + 8 | 0, w = t[l >> 2], C = eo + 8 | 0, tr = w + t[C >> 2] | 0, l = t[C + 4 >> 2] + t[l + 4 >> 2] | 0, l = w >>> 0 > tr >>> 0 ? l + 1 | 0 : l, C = P + tr | 0, l = (C >>> 0 < tr >>> 0 ? l + 1 | 0 : l) + pe | 0, w = C, C = C + Ce | 0, l = w >>> 0 > C >>> 0 ? l + 1 | 0 : l, w = C, C = C + Me | 0, l = (w >>> 0 > C >>> 0 ? l + 1 | 0 : l) + nr | 0, w = C, C = C + Tt | 0, l = w >>> 0 > C >>> 0 ? l + 1 | 0 : l, w = C + lr | 0, l = w >>> 0 < C >>> 0 ? l + 1 | 0 : l, b = b >>> 20 | 0, C = w + b | 0, l = b >>> 0 > C >>> 0 ? l + 1 | 0 : l, w = C, C = C + Yr | 0, l = w >>> 0 > C >>> 0 ? l + 1 | 0 : l, b = C << 12 | K >>> 20, w = l, P = l << 12 | C >>> 20, Tt = t[n + 20 >> 2], l = Tt + (Io & 1048575) | 0, nr = t[n + 16 >> 2], C = bo + nr | 0, K = C >>> 0 < bo >>> 0 ? l + 1 | 0 : l, l = K + P | 0, pe = C, b = C + b | 0, t[a + 24 >> 2] = b, C = C >>> 0 > b >>> 0 ? l + 1 | 0 : l, t[a + 28 >> 2] = C & 1048575, P = a, Me = Ei & 65535, Ce = (C | 0) == (K | 0) & b >>> 0 < pe >>> 0 | C >>> 0 < K >>> 0, a = (K | 0) == (Tt | 0) & pe >>> 0 < nr >>> 0 | K >>> 0 < Tt >>> 0, l = gr + 8 | 0, b = a + t[l >> 2] | 0, l = t[l + 4 >> 2], l = a >>> 0 > b >>> 0 ? l + 1 | 0 : l, w = w >>> 20 | 0, a = w, w = w + b | 0, l = a >>> 0 > w >>> 0 ? l + 1 | 0 : l, a = w, w = w + Ce | 0, l = a >>> 0 > w >>> 0 ? l + 1 | 0 : l, C = w << 12 | C >>> 20, a = C + Nr | 0, l = Me + (l << 12 | w >>> 20) | 0, t[P + 32 >> 2] = a, t[P + 36 >> 2] = C >>> 0 > a >>> 0 ? l + 1 | 0 : l, U = n + 496 | 0;
  }
  function ti(C, l) {
    var w = 0, n = 0, a = 0, b = 0, P = 0, K = 0, pe = 0, Ce = 0, Me = 0, Tt = 0, tr = 0, nr = 0, or = 0, lr = 0, gr = 0, kr = 0, Nr = 0, jr = 0, Yr = 0, ei = 0, ai = 0, ui = 0, di = 0, Ii = 0;
    n = l - -64 | 0, Tt = t[n >> 2], pe = t[n + 4 >> 2], n = l + 56 | 0, P = t[n >> 2], kr = t[n + 4 >> 2], n = l + 48 | 0, Nr = t[n >> 2], tr = t[n + 4 >> 2], n = l + 72 | 0, or = t[n >> 2], b = t[n + 4 >> 2], Yr = t[l + 40 >> 2], ai = t[l + 44 >> 2], jr = t[l + 24 >> 2], nr = t[l + 28 >> 2], K = t[l + 16 >> 2], gr = t[l + 20 >> 2], w = t[l + 8 >> 2], Ce = t[l + 12 >> 2], Me = t[l + 4 >> 2], ei = t[l + 32 >> 2], a = t[l + 36 >> 2], di = a, l = t[l >> 2], n = ri(a >>> 16 | 0, 0, 977, 1), a = l + n | 0, l = Me + ve | 0, Me = n >>> 0 > a >>> 0 ? l + 1 | 0 : l, l = Ce, n = Me >>> 20 | 0, Ce = n, n = w + n | 0, Ce = Ce >>> 0 > n >>> 0 ? l + 1 | 0 : l, l = gr, w = Ce >>> 20 | 0, lr = w, w = w + K | 0, gr = lr >>> 0 > w >>> 0 ? l + 1 | 0 : l, l = nr, K = gr >>> 20 | 0, nr = K, K = K + jr | 0, jr = nr >>> 0 > K >>> 0 ? l + 1 | 0 : l, Ii = Ce & 1048575, l = Me & 1048575, lr = l, nr = n, Me = w, ui = gr & 1048575, w = (n & w & K) == -1 & (ui & Ce & jr) == 1048575, l = di & 65535, n = jr >>> 20 | 0, Ce = n, n = n + ei | 0, l = Ce >>> 0 > n >>> 0 ? l + 1 | 0 : l, ei = n, Ce = l, n = ri(w & ((n | 0) == -1 & (l | 0) == 65535) & ((lr | 0) == 1048574 & a >>> 0 > 4294966318 | lr >>> 0 > 1048574) | l >>> 16, 0, 977, 1), a = n + a | 0, l = lr + ve | 0, w = n >>> 0 > a >>> 0 ? l + 1 | 0 : l, l = Ii, n = w >>> 20 | 0, gr = n + nr | 0, n = n >>> 0 > gr >>> 0 ? l + 1 | 0 : l, c[C | 0] = a, c[C + 1 | 0] = a >>> 8, c[C + 2 | 0] = a >>> 16, c[C + 3 | 0] = a >>> 24, l = w & 1048575 | gr << 20, c[C + 4 | 0] = l, c[C + 5 | 0] = l >>> 8, c[C + 6 | 0] = l >>> 16, c[C + 7 | 0] = l >>> 24, nr = or, lr = b & 65535, or = Tt, Tt = P, w = ri(b >>> 16 | 0, 0, 977, 1), a = w + Yr | 0, l = ai + ve | 0, Yr = w >>> 0 > a >>> 0 ? l + 1 | 0 : l, l = tr, w = Yr >>> 20 | 0, b = w, w = w + Nr | 0, P = b >>> 0 > w >>> 0 ? l + 1 | 0 : l, l = kr, b = P >>> 20 | 0, Tt = b + Tt | 0, tr = b >>> 0 > Tt >>> 0 ? l + 1 | 0 : l, l = pe, b = tr >>> 20 | 0, pe = b, b = b + or | 0, kr = pe >>> 0 > b >>> 0 ? l + 1 | 0 : l, l = lr, pe = kr >>> 20 | 0, or = pe, pe = pe + nr | 0, l = or >>> 0 > pe >>> 0 ? l + 1 | 0 : l, Nr = pe, pe = l, ai = P & 1048575, l = Yr & 1048575, lr = a, or = w, nr = tr & 1048575, a = ri((Tt & w & b) == -1 & (nr & P & kr) == 1048575 & ((Nr | 0) == -1 & (pe | 0) == 65535) & ((l | 0) == 1048574 & a >>> 0 > 4294966318 | l >>> 0 > 1048574) | pe >>> 16, 0, 977, 1), w = lr + a | 0, l = l + ve | 0, P = w >>> 0 < a >>> 0 ? l + 1 | 0 : l, l = ai, a = P >>> 20 | 0, tr = a + or | 0, a = a >>> 0 > tr >>> 0 ? l + 1 | 0 : l, c[C + 32 | 0] = w, c[C + 33 | 0] = w >>> 8, c[C + 34 | 0] = w >>> 16, c[C + 35 | 0] = w >>> 24, l = P & 1048575 | tr << 20, c[C + 36 | 0] = l, c[C + 37 | 0] = l >>> 8, c[C + 38 | 0] = l >>> 16, c[C + 39 | 0] = l >>> 24, P = (n & 4095) << 20 | gr >>> 12, or = n >>> 12 & 255, l = ui, w = (n >>> 20 | 0) + Me | 0, n = w >>> 0 < Me >>> 0 ? l + 1 | 0 : l, Me = w, l = w << 8, w = C, c[w + 8 | 0] = P, c[w + 9 | 0] = P >>> 8, c[w + 10 | 0] = P >>> 16, c[w + 11 | 0] = P >>> 24, l = l | or, c[w + 12 | 0] = l, c[w + 13 | 0] = l >>> 8, c[w + 14 | 0] = l >>> 16, c[w + 15 | 0] = l >>> 24, P = (a & 4095) << 20 | tr >>> 12, tr = a >>> 12 & 255, l = nr, w = (a >>> 20 | 0) + Tt | 0, a = w >>> 0 < Tt >>> 0 ? l + 1 | 0 : l, Tt = w, l = w << 8, w = C, c[w + 40 | 0] = P, c[w + 41 | 0] = P >>> 8, c[w + 42 | 0] = P >>> 16, c[w + 43 | 0] = P >>> 24, l = l | tr, c[w + 44 | 0] = l, c[w + 45 | 0] = l >>> 8, c[w + 46 | 0] = l >>> 16, c[w + 47 | 0] = l >>> 24, Me = ((n & 16777215) << 8 | Me >>> 24) & 268435455, l = jr & 1048575, n = n >>> 20 | 0, w = n + K | 0, n = n >>> 0 > w >>> 0 ? l + 1 | 0 : l, l = n << 28 | w >>> 4, K = w << 28, w = C, K = K | Me, c[w + 16 | 0] = K, c[w + 17 | 0] = K >>> 8, c[w + 18 | 0] = K >>> 16, c[w + 19 | 0] = K >>> 24, c[w + 20 | 0] = l, c[w + 21 | 0] = l >>> 8, c[w + 22 | 0] = l >>> 16, c[w + 23 | 0] = l >>> 24, K = ((a & 16777215) << 8 | Tt >>> 24) & 268435455, l = kr & 1048575, a = a >>> 20 | 0, w = a + b | 0, a = a >>> 0 > w >>> 0 ? l + 1 | 0 : l, l = a << 28 | w >>> 4, b = w << 28, w = C, b = b | K, c[w + 48 | 0] = b, c[w + 49 | 0] = b >>> 8, c[w + 50 | 0] = b >>> 16, c[w + 51 | 0] = b >>> 24, c[w + 52 | 0] = l, c[w + 53 | 0] = l >>> 8, c[w + 54 | 0] = l >>> 16, c[w + 55 | 0] = l >>> 24, w = n >>> 4 & 65535, l = Ce, n = (n >>> 20 | 0) + ei | 0, l = (n >>> 0 < ei >>> 0 ? l + 1 | 0 : l) << 16 | n >>> 16, b = n << 16, n = C, w = w | b, c[n + 24 | 0] = w, c[n + 25 | 0] = w >>> 8, c[n + 26 | 0] = w >>> 16, c[n + 27 | 0] = w >>> 24, c[n + 28 | 0] = l, c[n + 29 | 0] = l >>> 8, c[n + 30 | 0] = l >>> 16, c[n + 31 | 0] = l >>> 24, w = a >>> 4 & 65535, l = pe, n = (a >>> 20 | 0) + Nr | 0, l = (n >>> 0 < Nr >>> 0 ? l + 1 | 0 : l) << 16 | n >>> 16, n = n << 16 | w, c[C + 56 | 0] = n, c[C + 57 | 0] = n >>> 8, c[C + 58 | 0] = n >>> 16, c[C + 59 | 0] = n >>> 24, c[C + 60 | 0] = l, c[C + 61 | 0] = l >>> 8, c[C + 62 | 0] = l >>> 16, c[C + 63 | 0] = l >>> 24;
  }
  function Lr(C, l, w, n) {
    var a = 0, b = 0, P = 0, K = 0, pe = 0, Ce = 0, Me = 0, Tt = 0, tr = 0, nr = 0, or = 0, lr = 0, gr = 0, kr = 0, Nr = 0, jr = 0, Yr = 0, ei = 0, ai = 0, ui = 0, di = 0, Ii = 0, wi = 0, Ei = 0, Ti = 0, Di = 0, Qi = 0;
    pe = U - 96 | 0, U = pe;
    e: {
      if (!l) {
        yi[t[C + 168 >> 2]](689730, t[C + 172 >> 2]);
        break e;
      }
      if (b = t[l >> 2], wi = n & 256, b >>> 0 < (wi ? 33 : 65) >>> 0) {
        yi[t[C + 168 >> 2]](690157, t[C + 172 >> 2]);
        break e;
      }
      if (t[l >> 2] = 0, ai = is(690820, b), !w) {
        yi[t[C + 168 >> 2]](689638, t[C + 172 >> 2]);
        break e;
      }
      if ((n & 255) != 2) {
        yi[t[C + 168 >> 2]](689499, t[C + 172 >> 2]);
        break e;
      }
      if (t[pe + 88 >> 2] = 0, n = d[w + 12 | 0] | d[w + 13 | 0] << 8 | (d[w + 14 | 0] << 16 | d[w + 15 | 0] << 24), P = n, b = d[w + 8 | 0] | d[w + 9 | 0] << 8 | (d[w + 10 | 0] << 16 | d[w + 11 | 0] << 24), K = (n << 12 | b >>> 20) & 1048575, Ce = d[w + 4 | 0] | d[w + 5 | 0] << 8 | (d[w + 6 | 0] << 16 | d[w + 7 | 0] << 24), a = Ce, b = b << 12 & -4096 | a >>> 20, Yr = K, K = d[w + 16 | 0] | d[w + 17 | 0] << 8 | (d[w + 18 | 0] << 16 | d[w + 19 | 0] << 24), Tt = K, n = d[w + 20 | 0] | d[w + 21 | 0] << 8 | (d[w + 22 | 0] << 16 | d[w + 23 | 0] << 24), Ce = n, tr = (n << 24 | K >>> 8) & 1048575, gr = K << 24 & -16777216 | P >>> 8, ui = tr, Me = tr, K = d[w + 28 | 0] | d[w + 29 | 0] << 8 | (d[w + 30 | 0] << 16 | d[w + 31 | 0] << 24), n = K >>> 16 | 0, P = d[w + 24 | 0] | d[w + 25 | 0] << 8 | (d[w + 26 | 0] << 16 | d[w + 27 | 0] << 24), K = (K & 65535) << 16 | P >>> 16, kr = d[w | 0] | d[w + 1 | 0] << 8 | (d[w + 2 | 0] << 16 | d[w + 3 | 0] << 24), lr = gr | (K | (kr | b)), di = n, Nr = a & 1048575, a = Me | (n | (Nr | Yr)), Me = P << 4 & 1048560, P = Ce, n = P >>> 28 | 0, tr = (P & 268435455) << 4 | Tt >>> 28, Ce = lr | tr, lr = n | Me, !(Ce | (a | lr))) {
        yi[t[C + 168 >> 2]](690116, t[C + 172 >> 2]);
        break e;
      }
      P = d[w + 52 | 0] | d[w + 53 | 0] << 8 | (d[w + 54 | 0] << 16 | d[w + 55 | 0] << 24), n = P >>> 28 | 0, C = d[w + 48 | 0] | d[w + 49 | 0] << 8 | (d[w + 50 | 0] << 16 | d[w + 51 | 0] << 24), Ce = (P & 268435455) << 4 | C >>> 28, Tt = n, n = d[w + 56 | 0] | d[w + 57 | 0] << 8 | (d[w + 58 | 0] << 16 | d[w + 59 | 0] << 24), Ei = n, nr = d[w + 60 | 0] | d[w + 61 | 0] << 8 | (d[w + 62 | 0] << 16 | d[w + 63 | 0] << 24), Ti = n << 4 & 1048560, a = d[w + 40 | 0] | d[w + 41 | 0] << 8 | (d[w + 42 | 0] << 16 | d[w + 43 | 0] << 24), Me = d[w + 44 | 0] | d[w + 45 | 0] << 8 | (d[w + 46 | 0] << 16 | d[w + 47 | 0] << 24), jr = Me >>> 8 | 0, n = P << 24 | C >>> 8, Di = C << 24 & -16777216, Qi = n & 1048575, P = d[w + 32 | 0] | d[w + 33 | 0] << 8 | (d[w + 34 | 0] << 16 | d[w + 35 | 0] << 24), C = d[w + 36 | 0] | d[w + 37 | 0] << 8 | (d[w + 38 | 0] << 16 | d[w + 39 | 0] << 24), or = C, w = C >>> 20 | 0, C = a, n = Me << 12 | C >>> 20, Me = C << 12 & -4096, Ii = n & 1048575, ei = or & 1048575;
      t: {
        if ((Nr | 0) == 1048574 & kr >>> 0 < 4294966319 | Nr >>> 0 < 1048574 || (b & gr & tr) != -1 | (Yr & ui & lr) != 1048575 || (K | 0) != -1 | (di | 0) != 65535)
          break t;
        C = Nr + 1 | 0, kr = kr + 977 | 0, C = kr >>> 0 < 977 ? C + 1 | 0 : C, Nr = C & 1048575, a = C >>> 20 | 0, C = Yr, b = a + b | 0, C = b >>> 0 < a >>> 0 ? C + 1 | 0 : C, Yr = C & 1048575, n = ui, C = C >>> 20 | 0, gr = C + gr | 0, n = C >>> 0 > gr >>> 0 ? n + 1 | 0 : n, ui = n & 1048575, a = n >>> 20 | 0, C = lr, tr = a + tr | 0, C = tr >>> 0 < a >>> 0 ? C + 1 | 0 : C, lr = C & 1048575, a = C >>> 20 | 0, C = di, n = K, K = a + K | 0, di = (n >>> 0 > K >>> 0 ? C + 1 | 0 : C) & 65535;
      }
      a = Ce, or = Tt | Ti, Tt = jr | Di, jr = Qi, Me = w | Me, C = nr, n = C >>> 16 | 0, Ce = (C & 65535) << 16 | Ei >>> 16, nr = n, w = pe, t[w + 40 >> 2] = K, t[w + 44 >> 2] = di, t[w + 32 >> 2] = tr, t[w + 36 >> 2] = lr, t[w + 24 >> 2] = gr, t[w + 28 >> 2] = ui, t[w + 16 >> 2] = b, t[w + 20 >> 2] = Yr, t[w + 8 >> 2] = kr, t[w + 12 >> 2] = Nr;
      t: {
        if ((ei | 0) == 1048574 & P >>> 0 < 4294966319 | ei >>> 0 < 1048574 || (Me & Tt & a) != -1 | (Ii & jr & or) != 1048575 || (Ce | 0) != -1 | (nr | 0) != 65535)
          break t;
        n = ei + 1 | 0, P = P + 977 | 0, n = P >>> 0 < 977 ? n + 1 | 0 : n, ei = n & 1048575, C = Ii, n = n >>> 20 | 0, Me = n + Me | 0, C = n >>> 0 > Me >>> 0 ? C + 1 | 0 : C, Ii = C & 1048575, b = C >>> 20 | 0, n = jr, Tt = b + Tt | 0, n = Tt >>> 0 < b >>> 0 ? n + 1 | 0 : n, jr = n & 1048575, b = n >>> 20 | 0, n = or, a = a + b | 0, n = a >>> 0 < b >>> 0 ? n + 1 | 0 : n, or = n & 1048575, C = nr, nr = Ce, Ce = (n >>> 20 | 0) + Ce | 0, nr = (nr >>> 0 > Ce >>> 0 ? C + 1 | 0 : C) & 65535;
      }
      t[w + 80 >> 2] = Ce, t[pe + 84 >> 2] = nr, t[pe + 72 >> 2] = a, t[pe + 76 >> 2] = or, t[pe + 64 >> 2] = Tt, t[pe + 68 >> 2] = jr, t[pe + 56 >> 2] = Me, t[pe + 60 >> 2] = Ii, t[pe + 48 >> 2] = P, t[pe + 52 >> 2] = ei, Rr(ai + 1 | 0, pe + 8 | 0);
      t: {
        if (wi) {
          c[ai | 0] = P & 1 ? 3 : 2, C = 33;
          break t;
        }
        c[ai | 0] = 4, Rr(ai + 33 | 0, pe + 48 | 0), C = 65;
      }
      t[l >> 2] = C, or = 1;
    }
    return U = pe + 96 | 0, or;
  }
  function Rr(C, l) {
    c[C | 0] = t[l + 36 >> 2] >>> 8, c[C + 1 | 0] = t[l + 36 >> 2], c[C + 2 | 0] = (t[l + 36 >> 2] & 16777215) << 8 | t[l + 32 >> 2] >>> 24, c[C + 3 | 0] = (t[l + 36 >> 2] & 65535) << 16 | t[l + 32 >> 2] >>> 16, c[C + 4 | 0] = (t[l + 36 >> 2] & 255) << 24 | t[l + 32 >> 2] >>> 8, c[C + 5 | 0] = t[l + 32 >> 2], c[C + 6 | 0] = t[l + 28 >> 2] >>> 12, c[C + 7 | 0] = t[l + 28 >> 2] >>> 4, c[C + 8 | 0] = (t[l + 28 >> 2] & 268435455) << 4 | t[l + 24 >> 2] >>> 28, c[C + 9 | 0] = (t[l + 28 >> 2] & 1048575) << 12 | t[l + 24 >> 2] >>> 20, c[C + 10 | 0] = (t[l + 28 >> 2] & 4095) << 20 | t[l + 24 >> 2] >>> 12, c[C + 11 | 0] = (t[l + 28 >> 2] & 15) << 28 | t[l + 24 >> 2] >>> 4, c[C + 12 | 0] = E[l + 22 >> 1] & 15 | t[l + 24 >> 2] << 4, c[C + 13 | 0] = t[l + 20 >> 2] >>> 8, c[C + 14 | 0] = t[l + 20 >> 2], c[C + 15 | 0] = (t[l + 20 >> 2] & 16777215) << 8 | t[l + 16 >> 2] >>> 24, c[C + 16 | 0] = (t[l + 20 >> 2] & 65535) << 16 | t[l + 16 >> 2] >>> 16, c[C + 17 | 0] = (t[l + 20 >> 2] & 255) << 24 | t[l + 16 >> 2] >>> 8, c[C + 18 | 0] = t[l + 16 >> 2], c[C + 19 | 0] = t[l + 12 >> 2] >>> 12, c[C + 20 | 0] = t[l + 12 >> 2] >>> 4, c[C + 21 | 0] = (t[l + 12 >> 2] & 268435455) << 4 | t[l + 8 >> 2] >>> 28, c[C + 22 | 0] = (t[l + 12 >> 2] & 1048575) << 12 | t[l + 8 >> 2] >>> 20, c[C + 23 | 0] = (t[l + 12 >> 2] & 4095) << 20 | t[l + 8 >> 2] >>> 12, c[C + 24 | 0] = (t[l + 12 >> 2] & 15) << 28 | t[l + 8 >> 2] >>> 4, c[C + 25 | 0] = E[l + 6 >> 1] & 15 | t[l + 8 >> 2] << 4, c[C + 26 | 0] = t[l + 4 >> 2] >>> 8, c[C + 27 | 0] = t[l + 4 >> 2], c[C + 28 | 0] = (t[l + 4 >> 2] & 16777215) << 8 | t[l >> 2] >>> 24, c[C + 29 | 0] = (t[l + 4 >> 2] & 65535) << 16 | t[l >> 2] >>> 16, c[C + 30 | 0] = (t[l + 4 >> 2] & 255) << 24 | t[l >> 2] >>> 8, c[C + 31 | 0] = t[l >> 2];
  }
  function Ir(C, l, w) {
    var n = 0, a = 0, b = 0, P = 0, K = 0, pe = 0, Ce = 0, Me = 0, Tt = 0, tr = 0, nr = 0, or = 0, lr = 0;
    P = C, n = l, l = d[n + 24 | 0] | d[n + 25 | 0] << 8 | (d[n + 26 | 0] << 16 | d[n + 27 | 0] << 24), b = l << 8 & 16711680, tr = l << 24 | b, a = l >>> 8 | 0, C = d[n + 28 | 0] | d[n + 29 | 0] << 8 | (d[n + 30 | 0] << 16 | d[n + 31 | 0] << 24), b = (a | C << 24) & 65280, l = l >>> 24 | 0, b = tr | (b | (l | C << 8) & 255), a = (l | (C & 16777215) << 8) & 16711680 | (a | (C & 255) << 24) & -16777216, pe = C >>> 8 & 65280 | C >>> 24 | a, t[P >> 2] = pe, t[P + 4 >> 2] = b, l = d[n + 16 | 0] | d[n + 17 | 0] << 8 | (d[n + 18 | 0] << 16 | d[n + 19 | 0] << 24), K = l << 8 & 16711680 | l << 24, C = d[n + 20 | 0] | d[n + 21 | 0] << 8 | (d[n + 22 | 0] << 16 | d[n + 23 | 0] << 24), a = (C << 24 | l >>> 8) & 65280, tr = K | (a | (C << 8 | l >>> 24) & 255), a = ((C & 255) << 24 | l >>> 8) & -16777216, K = a | ((C & 16777215) << 8 | l >>> 24) & 16711680, lr = C >>> 8 & 65280 | C >>> 24 | K, t[P + 8 >> 2] = lr, Ce = tr, t[P + 12 >> 2] = Ce, l = d[n + 8 | 0] | d[n + 9 | 0] << 8 | (d[n + 10 | 0] << 16 | d[n + 11 | 0] << 24), K = l << 8 & 16711680, nr = l << 24 | K, C = d[n + 12 | 0] | d[n + 13 | 0] << 8 | (d[n + 14 | 0] << 16 | d[n + 15 | 0] << 24), K = (C << 24 | l >>> 8) & 65280, K = nr | (K | (C << 8 | l >>> 24) & 255), a = ((C & 255) << 24 | l >>> 8) & -16777216, a = a | ((C & 16777215) << 8 | l >>> 24) & 16711680, or = C >>> 8 & 65280 | C >>> 24 | a, t[P + 16 >> 2] = or, nr = K, t[P + 20 >> 2] = K, C = d[n + 4 | 0] | d[n + 5 | 0] << 8 | (d[n + 6 | 0] << 16 | d[n + 7 | 0] << 24), l = d[n | 0] | d[n + 1 | 0] << 8 | (d[n + 2 | 0] << 16 | d[n + 3 | 0] << 24), K = l << 8 & 16711680 | l << 24, tr = K | ((C << 8 | l >>> 24) & 255 | (C << 24 | l >>> 8) & 65280), n = ((C & 255) << 24 | l >>> 8) & -16777216, Me = n | ((C & 16777215) << 8 | l >>> 24) & 16711680, K = C >>> 8 & 65280, l = C >>> 24 | 0, C = tr, n = (nr | 0) == -1, K = l | K | Me, l = n & or >>> 0 < 4294967294 | (nr | 0) != -1 | (C & K) != -1, a = (Ce | 0) == -1162945306, C = (l | (a & lr >>> 0 < 2940772411 | Ce >>> 0 < 3132021990)) ^ -1, Me = C & ((b | 0) == -1076732276 & pe >>> 0 > 3493216576 | b >>> 0 > 3218235020) | (C & (a & lr >>> 0 > 2940772411 | Ce >>> 0 > 3132021990) | (or | 0) == -1 & n & (l ^ -1)), Tt = ri(Me, 0, 801750719, 1076732275), a = ve, n = a + b | 0, C = pe + Tt | 0, n = C >>> 0 < Tt >>> 0 ? n + 1 | 0 : n, t[P >> 2] = C, t[P + 4 >> 2] = n, l = P, n = (n | 0) == (a | 0) & C >>> 0 < Tt >>> 0 | n >>> 0 < a >>> 0, Tt = ri(Me, 0, 1354194884, 1162945305), b = ve, pe = b + Ce | 0, P = Tt + lr | 0, C = P >>> 0 < Tt >>> 0 ? pe + 1 | 0 : pe, n = n + P | 0, a = n >>> 0 < P >>> 0 ? C + 1 | 0 : C, t[l + 8 >> 2] = n, t[l + 12 >> 2] = a, Ce = (C | 0) == (b | 0) & P >>> 0 < Tt >>> 0 | C >>> 0 < b >>> 0, C = (C | 0) == (a | 0) & n >>> 0 < P >>> 0 | C >>> 0 > a >>> 0, b = Ce + C | 0, a = nr, n = C >>> 0 > b >>> 0, P = Me + or | 0, C = P >>> 0 < or >>> 0 ? a + 1 | 0 : a, pe = n + C | 0, a = P, b = a + b | 0, pe = a >>> 0 > b >>> 0 ? pe + 1 | 0 : pe, t[l + 16 >> 2] = b, t[l + 20 >> 2] = pe, n = l, P = K, l = !C & a >>> 0 < Me >>> 0, C = (C | 0) == (pe | 0) & a >>> 0 > b >>> 0 | C >>> 0 > pe >>> 0, b = l + C | 0, l = (C >>> 0 > b >>> 0) + tr | 0, C = b + P | 0, l = C >>> 0 < b >>> 0 ? l + 1 | 0 : l, t[n + 24 >> 2] = C, t[n + 28 >> 2] = l, w && (t[w >> 2] = Me);
  }
  function pr(C, l) {
    c[C | 0] = d[l + 31 | 0], c[C + 1 | 0] = E[l + 30 >> 1], c[C + 2 | 0] = t[l + 28 >> 2] >>> 8, c[C + 3 | 0] = t[l + 28 >> 2], c[C + 4 | 0] = (t[l + 28 >> 2] & 16777215) << 8 | t[l + 24 >> 2] >>> 24, c[C + 5 | 0] = (t[l + 28 >> 2] & 65535) << 16 | t[l + 24 >> 2] >>> 16, c[C + 6 | 0] = (t[l + 28 >> 2] & 255) << 24 | t[l + 24 >> 2] >>> 8, c[C + 7 | 0] = t[l + 24 >> 2], c[C + 8 | 0] = d[l + 23 | 0], c[C + 9 | 0] = E[l + 22 >> 1], c[C + 10 | 0] = t[l + 20 >> 2] >>> 8, c[C + 11 | 0] = t[l + 20 >> 2], c[C + 12 | 0] = (t[l + 20 >> 2] & 16777215) << 8 | t[l + 16 >> 2] >>> 24, c[C + 13 | 0] = (t[l + 20 >> 2] & 65535) << 16 | t[l + 16 >> 2] >>> 16, c[C + 14 | 0] = (t[l + 20 >> 2] & 255) << 24 | t[l + 16 >> 2] >>> 8, c[C + 15 | 0] = t[l + 16 >> 2], c[C + 16 | 0] = d[l + 15 | 0], c[C + 17 | 0] = E[l + 14 >> 1], c[C + 18 | 0] = t[l + 12 >> 2] >>> 8, c[C + 19 | 0] = t[l + 12 >> 2], c[C + 20 | 0] = (t[l + 12 >> 2] & 16777215) << 8 | t[l + 8 >> 2] >>> 24, c[C + 21 | 0] = (t[l + 12 >> 2] & 65535) << 16 | t[l + 8 >> 2] >>> 16, c[C + 22 | 0] = (t[l + 12 >> 2] & 255) << 24 | t[l + 8 >> 2] >>> 8, c[C + 23 | 0] = t[l + 8 >> 2], c[C + 24 | 0] = d[l + 7 | 0], c[C + 25 | 0] = E[l + 6 >> 1], c[C + 26 | 0] = t[l + 4 >> 2] >>> 8, c[C + 27 | 0] = t[l + 4 >> 2], c[C + 28 | 0] = (t[l + 4 >> 2] & 16777215) << 8 | t[l >> 2] >>> 24, c[C + 29 | 0] = (t[l + 4 >> 2] & 65535) << 16 | t[l >> 2] >>> 16, c[C + 30 | 0] = (t[l + 4 >> 2] & 255) << 24 | t[l >> 2] >>> 8, c[C + 31 | 0] = t[l >> 2];
  }
  function Cr(C, l) {
    var w = 0, n = 0, a = 0, b = 0, P = 0, K = 0, pe = 0, Ce = 0, Me = 0, Tt = 0, tr = 0, nr = 0, or = 0, lr = 0, gr = 0, kr = 0, Nr = 0, jr = 0, Yr = 0, ei = 0, ai = 0, ui = 0, di = 0, Ii = 0, wi = 0, Ei = 0, Ti = 0, Di = 0, Qi = 0, Li = 0, Ki = 0, Wi = 0, Xi = 0, $i = 0, In = 0, kn = 0, Dn = 0, Mn = 0, zn = 0, es = 0, ns = 0, fs = 0, ps = 0;
    for (P = U - 320 | 0, U = P, w = P + 280 | 0, n = w + 32 | 0, t[n >> 2] = 0, t[n + 4 >> 2] = 0, n = w + 24 | 0, t[n >> 2] = 0, t[n + 4 >> 2] = 0, n = w + 16 | 0, t[n >> 2] = 0, t[n + 4 >> 2] = 0, w = w + 8 | 0, t[w >> 2] = 0, t[w + 4 >> 2] = 0, t[P + 280 >> 2] = 0, t[P + 284 >> 2] = 0, w = P + 240 | 0, n = w + 32 | 0, t[n >> 2] = 0, t[n + 4 >> 2] = 0, n = w + 24 | 0, t[n >> 2] = 0, t[n + 4 >> 2] = 0, w = w + 16 | 0, t[w >> 2] = 0, t[w + 4 >> 2] = 0, t[P + 248 >> 2] = 0, t[P + 252 >> 2] = 0, t[P + 240 >> 2] = 1, t[P + 244 >> 2] = 0, n = l + 32 | 0, a = t[n + 4 >> 2], w = P + 200 | 0, b = w + 32 | 0, t[b >> 2] = t[n >> 2], t[b + 4 >> 2] = a, n = l + 24 | 0, a = t[n + 4 >> 2], b = w + 24 | 0, t[b >> 2] = t[n >> 2], t[b + 4 >> 2] = a, n = l + 16 | 0, a = t[n + 4 >> 2], b = w + 16 | 0, t[b >> 2] = t[n >> 2], t[b + 4 >> 2] = a, n = l + 8 | 0, a = t[n + 4 >> 2], w = w + 8 | 0, t[w >> 2] = t[n >> 2], t[w + 4 >> 2] = a, w = t[l + 4 >> 2], t[P + 200 >> 2] = t[l >> 2], t[P + 204 >> 2] = w, n = C + 32 | 0, a = t[n + 4 >> 2], w = P + 160 | 0, Qi = w + 32 | 0, t[Qi >> 2] = t[n >> 2], t[Qi + 4 >> 2] = a, n = C + 24 | 0, a = t[n + 4 >> 2], b = w + 24 | 0, t[b >> 2] = t[n >> 2], t[b + 4 >> 2] = a, n = C + 16 | 0, a = t[n + 4 >> 2], b = w + 16 | 0, t[b >> 2] = t[n >> 2], t[b + 4 >> 2] = a, n = C + 8 | 0, a = t[n + 4 >> 2], w = w + 8 | 0, t[w >> 2] = t[n >> 2], t[w + 4 >> 2] = a, w = t[C + 4 >> 2], t[P + 160 >> 2] = t[C >> 2], t[P + 164 >> 2] = w, di = 5, ai = -1, Ii = -1; ; ) {
      w = ai, Yr = t[P + 160 >> 2], gr = t[P + 164 >> 2], n = Rs(Yr, gr | -1073741824), ai = w - n | 0, Ii = Ii - (ve + (w >>> 0 < n >>> 0) | 0) | 0, w = n & 31, (n & 63) >>> 0 >= 32 ? (pe = 0, or = 1 << w) : (pe = 1 << w, or = pe - 1 & 1 >>> 32 - w), Ti = t[P + 200 >> 2], wi = t[P + 204 >> 2], b = n;
      e: {
        if ((n | 0) == 62) {
          K = 0, b = 0, nr = 1, Tt = 0, ei = 0, Nr = 0;
          break e;
        }
        for (n = b & 31, (b & 63) >>> 0 >= 32 ? (a = gr >>> n | 0, n = 0) : (a = ((1 << n) - 1 & gr) << 32 - n | Yr >>> n, n = gr >>> n | 0), tr = 62 - b | 0, nr = 1, Tt = 0, ei = 0, Nr = 0, Me = Ti, Ce = wi, K = 0, b = 0; ; ) {
          t: {
            if ((Ii | 0) < 0) {
              w = ri(a, n, a, n), kr = w - 2 | 0, ui = ve - (w >>> 0 < 2) | 0, jr = 0 - Me | 0, w = 0 - (((Me | 0) != 0) + Ce | 0) | 0, Me = ri(kr, ui, ri(jr, w, a, n), ve), Ii = 0 - (((ai | 0) != 0) + Ii | 0) | 0, ai = 0 - ai | 0, Ce = ai + 1 | 0, lr = 64 - ((Ce | 0) > (tr | 0) ? tr : Ce) | 0, Ce = lr & 31, (lr & 63) >>> 0 >= 32 ? Ce = -1 >>> Ce | 0 : Ce = (1 << Ce) - 1 << 32 - Ce | -1 >>> Ce, Li = Ce & Me & 63, lr = 0 - ei | 0, kr = 0 - (((ei | 0) != 0) + Nr | 0) | 0, ui = 0 - pe | 0, Wi = 0 - (((pe | 0) != 0) + or | 0) | 0, Me = a, Ce = n;
              break t;
            }
            lr = (Me << 1) + 2 | 0, w = Ce, kr = lr & 8, lr = kr + Me | 0, lr = 0 - ri(lr, lr >>> 0 < kr >>> 0 ? w + 1 | 0 : w, a, n) | 0, w = ai + 1 | 0, kr = 64 - ((w | 0) > (tr | 0) ? tr : w) | 0, w = kr & 31, (kr & 63) >>> 0 >= 32 ? w = -1 >>> w | 0 : w = (1 << w) - 1 << 32 - w | -1 >>> w, Li = w & lr & 15, ui = K, Wi = b, lr = nr, kr = Tt, jr = a, w = n, K = pe, b = or, nr = ei, Tt = Nr;
          }
          if (pe = ai, n = ri(Me, Ce, Li, 0) + jr | 0, w = ve + w | 0, a = n >>> 0 < jr >>> 0 ? w + 1 | 0 : w, w = tr & 31, (tr & 63) >>> 0 >= 32 ? (or = 0, w = -1 << w) : (or = -1 << w, w = or | (1 << w) - 1 & -1 >>> 32 - w), jr = Rs(n | or, w | a), ai = pe - jr | 0, Ii = Ii - (ve + (pe >>> 0 < jr >>> 0) | 0) | 0, pe = jr & 31, (jr & 63) >>> 0 >= 32 ? (ei = 0, Nr = nr << pe) : (ei = nr << pe, Nr = (1 << pe) - 1 & nr >>> 32 - pe | Tt << pe), pe = jr & 31, (jr & 63) >>> 0 >= 32 ? (w = K << pe, pe = 0) : (w = (1 << pe) - 1 & K >>> 32 - pe | b << pe, pe = K << pe), or = w, Di = jr & 31, (jr & 63) >>> 0 >= 32 ? (w = 0, a = a >>> Di | 0) : (w = a >>> Di | 0, a = ((1 << Di) - 1 & a) << 32 - Di | n >>> Di), n = w, nr = ri(nr, Tt, Li, 0) + lr | 0, w = ve + kr | 0, Tt = nr >>> 0 < lr >>> 0 ? w + 1 | 0 : w, K = ri(K, b, Li, 0) + ui | 0, w = ve + Wi | 0, b = K >>> 0 < ui >>> 0 ? w + 1 | 0 : w, tr = tr - jr | 0, !tr)
            break;
        }
      }
      if (t[P + 152 >> 2] = nr, t[P + 156 >> 2] = Tt, t[P + 144 >> 2] = K, t[P + 148 >> 2] = b, t[P + 136 >> 2] = ei, t[P + 140 >> 2] = Nr, t[P + 128 >> 2] = pe, t[P + 132 >> 2] = or, rs(P + 280 | 0, P + 240 | 0, P + 128 | 0, l), ui = or, w = or >> 31, or = w, Me = w, w = wi >> 31, Ce = P + 112 | 0, jr = pe, n = w, Pr(Ce, pe, ui, Me, Me, Ti, wi, w, w), Wi = ei, w = Nr >> 31, ei = w, pe = w, w = gr >> 31, Me = P + 80 | 0, Di = Nr, a = w, Pr(Me, Wi, Nr, pe, pe, Yr, gr, w, w), w = b >> 31, pe = P + 96 | 0, Li = K, ns = b, In = w, Pr(pe, K, b, w, w, Ti, wi, n, n), w = Tt >> 31, tr = P - -64 | 0, Ti = nr, wi = Tt, kn = w, Pr(tr, nr, Tt, w, w, Yr, gr, a, a), K = t[P + 80 >> 2], a = t[P + 112 >> 2], n = K + a | 0, b = t[P + 84 >> 2], w = b + t[P + 116 >> 2] | 0, w = n >>> 0 < a >>> 0 ? w + 1 | 0 : w, a = n, n = w, b = (b | 0) == (w | 0) & a >>> 0 < K >>> 0 | w >>> 0 < b >>> 0, w = Ce + 8 | 0, K = t[w >> 2], Ce = Me + 8 | 0, a = K + t[Ce >> 2] | 0, w = t[Ce + 4 >> 2] + t[w + 4 >> 2] | 0, w = a >>> 0 < K >>> 0 ? w + 1 | 0 : w, K = a, a = a + b | 0, b = K >>> 0 > a >>> 0 ? w + 1 | 0 : w, K = b << 2 | a >>> 30, a = a << 2 | n >>> 30, n = K, Tt = t[P + 64 >> 2], Ce = t[P + 96 >> 2], K = Tt + Ce | 0, Me = t[P + 68 >> 2], w = Me + t[P + 100 >> 2] | 0, w = K >>> 0 < Ce >>> 0 ? w + 1 | 0 : w, Ce = K, K = w, Me = (Me | 0) == (w | 0) & Ce >>> 0 < Tt >>> 0 | w >>> 0 < Me >>> 0, w = pe + 8 | 0, Tt = t[w >> 2], pe = tr + 8 | 0, Ce = Tt + t[pe >> 2] | 0, w = t[pe + 4 >> 2] + t[w + 4 >> 2] | 0, w = Ce >>> 0 < Tt >>> 0 ? w + 1 | 0 : w, pe = Ce, Ce = Me + Ce | 0, Tt = pe >>> 0 > Ce >>> 0 ? w + 1 | 0 : w, pe = Tt << 2 | Ce >>> 30, Me = Ce << 2 | K >>> 30, Ce = pe, Dn = (di | 0) < 2, !Dn)
        for (w = b >> 31, b = b >> 30, pe = w, lr = Tt >> 30, kr = Tt >> 31, Ei = di - 1 | 0, tr = P + 160 | 0, Tt = P + 200 | 0; nr = Tt + 8 | 0, gr = t[nr >> 2], w = t[nr + 4 >> 2], Yr = w, w = w >> 31, K = w, Pr(P, gr, Yr, w, w, jr, ui, or, or), Mn = P + 32 | 0, Nr = tr + 8 | 0, Xi = t[Nr >> 2], w = t[Nr + 4 >> 2], Ki = w, w = w >> 31, Pr(Mn, Xi, Ki, w, w, Wi, Di, ei, ei), zn = P + 16 | 0, Pr(zn, gr, Yr, K, K, Li, ns, In, In), es = P + 48 | 0, Pr(es, Xi, Ki, w, w, Ti, wi, kn, kn), K = t[P >> 2], fs = K, Ki = t[P + 4 >> 2], w = Ki + n | 0, gr = a + K | 0, a = gr >>> 0 < a >>> 0 ? w + 1 | 0 : w, w = a + t[P + 36 >> 2] | 0, n = t[P + 32 >> 2], K = n + gr | 0, Yr = K, t[Tt >> 2] = K, n = n >>> 0 > K >>> 0 ? w + 1 | 0 : w, t[Tt + 4 >> 2] = n & 1073741823, K = t[P + 16 >> 2], ps = K, $i = t[P + 20 >> 2], w = $i + Ce | 0, Tt = K + Me | 0, Me = Tt >>> 0 < Me >>> 0 ? w + 1 | 0 : w, w = Me + t[P + 52 >> 2] | 0, K = t[P + 48 >> 2], Ce = K + Tt | 0, Xi = Ce, t[tr >> 2] = Ce, K = K >>> 0 > Ce >>> 0 ? w + 1 | 0 : w, t[tr + 4 >> 2] = K & 1073741823, Ce = (n | 0) == (a | 0) & gr >>> 0 > Yr >>> 0 | n >>> 0 < a >>> 0, w = Mn + 8 | 0, tr = t[w >> 2], Yr = t[w + 4 >> 2], gr = (a | 0) == (Ki | 0) & gr >>> 0 < fs >>> 0 | a >>> 0 < Ki >>> 0, w = P + 8 | 0, a = t[w >> 2] + b | 0, w = t[w + 4 >> 2] + pe | 0, w = a >>> 0 < b >>> 0 ? w + 1 | 0 : w, pe = a, a = a + gr | 0, w = (pe >>> 0 > a >>> 0 ? w + 1 | 0 : w) + Yr | 0, pe = a, a = a + tr | 0, w = pe >>> 0 > a >>> 0 ? w + 1 | 0 : w, pe = a, a = a + Ce | 0, Ce = pe >>> 0 > a >>> 0 ? w + 1 | 0 : w, w = Ce >> 31, b = Ce >> 30, pe = w, tr = (K | 0) == (Me | 0) & Tt >>> 0 > Xi >>> 0 | K >>> 0 < Me >>> 0, w = es + 8 | 0, gr = t[w >> 2], Yr = t[w + 4 >> 2], Tt = (Me | 0) == ($i | 0) & Tt >>> 0 < ps >>> 0 | Me >>> 0 < $i >>> 0, w = zn + 8 | 0, Me = t[w >> 2] + lr | 0, w = t[w + 4 >> 2] + kr | 0, w = Me >>> 0 < lr >>> 0 ? w + 1 | 0 : w, kr = Me, Me = Me + Tt | 0, w = (kr >>> 0 > Me >>> 0 ? w + 1 | 0 : w) + Yr | 0, Tt = Me, Me = Me + gr | 0, w = Tt >>> 0 > Me >>> 0 ? w + 1 | 0 : w, Tt = Me, Me = Me + tr | 0, Tt = Tt >>> 0 > Me >>> 0 ? w + 1 | 0 : w, w = Tt >> 31, lr = Tt >> 30, kr = w, Ce = Ce << 2 | a >>> 30, a = a << 2 | n >>> 30, n = Ce, Tt = Tt << 2 | Me >>> 30, Me = Me << 2 | K >>> 30, Ce = Tt, Tt = nr, tr = Nr, Ei = Ei - 1 | 0, !!Ei; )
          ;
      pe = di - 1 | 0, w = pe << 3, b = w + (P + 160 | 0) | 0, t[b >> 2] = Me, t[b + 4 >> 2] = Ce, w = (P + 200 | 0) + w | 0, t[w >> 2] = a, t[w + 4 >> 2] = n;
      e: {
        if (!(t[P + 164 >> 2] | t[P + 160 >> 2])) {
          if (Dn)
            break e;
          Tt = pe & 3;
          t: {
            if (di - 2 >>> 0 < 3) {
              K = 0, b = 0, w = 1;
              break t;
            }
            for (w = pe & -4, Ei = 0, K = 0, b = 0, tr = Qi; or = tr - 8 | 0, nr = tr - 16 | 0, ei = tr - 24 | 0, K = t[tr >> 2] | (t[or >> 2] | (t[nr >> 2] | (t[ei >> 2] | K))), b = t[tr + 4 >> 2] | (t[or + 4 >> 2] | (t[nr + 4 >> 2] | (t[ei + 4 >> 2] | b))), tr = tr + 32 | 0, Ei = Ei + 4 | 0, (w | 0) != (Ei | 0); )
              ;
            w = Ei + 1 | 0;
          }
          if (Tt)
            for (tr = (P + 160 | 0) + (w << 3) | 0; K = t[tr >> 2] | K, b = t[tr + 4 >> 2] | b, tr = tr + 8 | 0, Tt = Tt - 1 | 0, !!Tt; )
              ;
          if (!(b | K))
            break e;
        }
        if (w = Ce >> 31, b = w ^ Me, K = w ^ Ce, w = (di >> 31) - (di >>> 0 < 2) >> 31, b = w | b, K = w | K, w = n >> 31, b | w ^ a | (K | w ^ n))
          continue;
        K = (di << 3) - 16 | 0, w = K + (P + 200 | 0) | 0, or = t[w + 4 >> 2], t[w >> 2] = t[w >> 2], t[w + 4 >> 2] = a << 30 | or, w = (P + 160 | 0) + K | 0, b = t[w + 4 >> 2], t[w >> 2] = t[w >> 2], t[w + 4 >> 2] = Me << 30 | b, di = pe;
        continue;
      }
      break;
    }
    w = n >> 31, n = w, Tt = P + 280 | 0, w = Tt + 32 | 0, pe = t[w >> 2], w = t[w + 4 >> 2], or = w, w = w >> 31, a = w, Ce = t[l >> 2], nr = w & Ce, b = nr + t[P + 280 >> 2] | 0, Me = t[l + 4 >> 2], w = t[P + 284 >> 2] + (Me & w) | 0, w = b >>> 0 < nr >>> 0 ? w + 1 | 0 : w, b = n ^ b, Ii = b - n | 0, b = (w ^ n) - ((n >>> 0 > b >>> 0) + n | 0) | 0, K = C, tr = Ce, ei = Me, C = t[l + 32 >> 2], gr = C, Ce = C & a, C = Ce + pe | 0, Yr = t[l + 36 >> 2], w = or + (Yr & a) | 0, w = C >>> 0 < Ce >>> 0 ? w + 1 | 0 : w, C = C ^ n, nr = C - n | 0, ai = (w ^ n) - ((C >>> 0 < n >>> 0) + n | 0) | 0, C = t[l + 24 >> 2], Ti = C, Me = C & a, Ce = Tt + 24 | 0, C = Me + t[Ce >> 2] | 0, wi = t[l + 28 >> 2], w = t[Ce + 4 >> 2] + (wi & a) | 0, w = C >>> 0 < Me >>> 0 ? w + 1 | 0 : w, C = C ^ n, or = C - n | 0, kr = (w ^ n) - ((C >>> 0 < n >>> 0) + n | 0) | 0, C = t[l + 16 >> 2], di = C, pe = C & a, Me = Tt + 16 | 0, C = pe + t[Me >> 2] | 0, jr = t[l + 20 >> 2], w = t[Me + 4 >> 2] + (jr & a) | 0, w = C >>> 0 < pe >>> 0 ? w + 1 | 0 : w, C = C ^ n, pe = C - n | 0, lr = (w ^ n) - ((C >>> 0 < n >>> 0) + n | 0) | 0, ui = t[l + 8 >> 2], Nr = ui & a, Tt = Tt + 8 | 0, C = Nr + t[Tt >> 2] | 0, Qi = t[l + 12 >> 2], w = t[Tt + 4 >> 2] + (Qi & a) | 0, w = C >>> 0 < Nr >>> 0 ? w + 1 | 0 : w, C = C ^ n, l = C - n | 0, w = ((w ^ n) - ((C >>> 0 < n >>> 0) + n | 0) | 0) + (b >> 31) | 0, C = b >> 30, a = C + l | 0, Nr = C >>> 0 > a >>> 0 ? w + 1 | 0 : w, w = (Nr >> 31) + lr | 0, C = Nr >> 30, pe = C + pe | 0, lr = C >>> 0 > pe >>> 0 ? w + 1 | 0 : w, w = (lr >> 31) + kr | 0, C = lr >> 30, or = C + or | 0, kr = C >>> 0 > or >>> 0 ? w + 1 | 0 : w, w = (kr >> 31) + ai | 0, C = kr >> 30, nr = C + nr | 0, ai = C >>> 0 > nr >>> 0 ? w + 1 | 0 : w, C = ai >> 31, w = (C & ei) + (b & 1073741823) | 0, n = C, l = (n & tr) + Ii | 0, C = l >>> 0 < Ii >>> 0 ? w + 1 | 0 : w, w = C & 1073741823, tr = w, t[K >> 2] = l, t[K + 4 >> 2] = w, w = (n & Qi) + (Nr & 1073741823) | 0, b = a, a = (n & ui) + a | 0, w = (C >> 31) + (b >>> 0 > a >>> 0 ? w + 1 | 0 : w) | 0, C = C >> 30, b = C, C = C + a | 0, w = b >>> 0 > C >>> 0 ? w + 1 | 0 : w, a = C, t[Tt >> 2] = a, C = w, w = w & 1073741823, t[Tt + 4 >> 2] = w, b = K + 8 | 0, t[b >> 2] = a, t[b + 4 >> 2] = w, w = (n & jr) + (lr & 1073741823) | 0, a = (n & di) + pe | 0, w = (C >> 31) + (a >>> 0 < pe >>> 0 ? w + 1 | 0 : w) | 0, C = C >> 30, pe = C, C = C + a | 0, w = pe >>> 0 > C >>> 0 ? w + 1 | 0 : w, a = C, t[Me >> 2] = a, C = w, w = w & 1073741823, t[Me + 4 >> 2] = w, b = K + 16 | 0, t[b >> 2] = a, t[b + 4 >> 2] = w, w = (n & wi) + (kr & 1073741823) | 0, a = (n & Ti) + or | 0, w = (C >> 31) + (a >>> 0 < or >>> 0 ? w + 1 | 0 : w) | 0, C = C >> 30, pe = C, C = C + a | 0, w = pe >>> 0 > C >>> 0 ? w + 1 | 0 : w, a = C, t[Ce >> 2] = a, C = w, w = w & 1073741823, t[Ce + 4 >> 2] = w, b = K + 24 | 0, t[b >> 2] = a, t[b + 4 >> 2] = w, b = K + 32 | 0, w = (n & Yr) + ai | 0, n = (n & gr) + nr | 0, w = (C >> 31) + (n >>> 0 < nr >>> 0 ? w + 1 | 0 : w) | 0, C = C >> 30, a = C, C = C + n | 0, w = a >>> 0 > C >>> 0 ? w + 1 | 0 : w, t[b >> 2] = C, t[b + 4 >> 2] = w, t[P + 280 >> 2] = l, t[P + 284 >> 2] = tr, U = P + 320 | 0;
  }
  function Er(C, l, w) {
    var n = 0, a = 0, b = 0, P = 0, K = 0, pe = 0, Ce = 0, Me = 0, Tt = 0, tr = 0, nr = 0, or = 0, lr = 0, gr = 0, kr = 0, Nr = 0, jr = 0, Yr = 0, ei = 0, ai = 0, ui = 0, di = 0, Ii = 0, wi = 0, Ei = 0, Ti = 0, Di = 0, Qi = 0, Li = 0;
    b = U - 288 | 0, U = b, ss(b + 224 | 0, l, w), n = b + 208 | 0, ai = t[b + 256 >> 2], kr = t[b + 260 >> 2], Pr(n, ai, kr, 0, 0, 801750719, 1076732275, 0, 0), Nr = b + 176 | 0, Di = t[b + 264 >> 2], di = t[b + 268 >> 2], Pr(Nr, Di, di, 0, 0, 801750719, 1076732275, 0, 0), Tt = b + 192 | 0, Pr(Tt, ai, kr, 0, 0, 1354194884, 1162945305, 0, 0), ei = b + 144 | 0, Qi = t[b + 272 >> 2], wi = t[b + 276 >> 2], Pr(ei, Qi, wi, 0, 0, 801750719, 1076732275, 0, 0), gr = b + 160 | 0, Pr(gr, Di, di, 0, 0, 1354194884, 1162945305, 0, 0), Ei = b + 112 | 0, ui = t[b + 280 >> 2], Ti = t[b + 284 >> 2], Pr(Ei, ui, Ti, 0, 0, 801750719, 1076732275, 0, 0), Ii = b + 128 | 0, Pr(Ii, Qi, wi, 0, 0, 1354194884, 1162945305, 0, 0), Li = b + 96 | 0, Pr(Li, ui, Ti, 0, 0, 1354194884, 1162945305, 0, 0), a = t[b + 224 >> 2], w = t[b + 208 >> 2], nr = a + w | 0, pe = t[b + 228 >> 2], l = pe + t[b + 212 >> 2] | 0, jr = w >>> 0 > nr >>> 0 ? l + 1 | 0 : l, a = (pe | 0) == (jr | 0) & a >>> 0 > nr >>> 0 | pe >>> 0 > jr >>> 0, Me = t[b + 232 >> 2], l = n + 8 | 0, w = t[l >> 2], n = Me + w | 0, tr = t[b + 236 >> 2], l = tr + t[l + 4 >> 2] | 0, l = w >>> 0 > n >>> 0 ? l + 1 | 0 : l, w = n + a | 0, a = w >>> 0 < n >>> 0 ? l + 1 | 0 : l, l = a + t[b + 180 >> 2] | 0, pe = w, w = t[b + 176 >> 2], n = pe + w | 0, P = t[b + 192 >> 2], or = n + P | 0, w = w >>> 0 > n >>> 0 ? l + 1 | 0 : l, l = w + t[b + 196 >> 2] | 0, lr = P >>> 0 > or >>> 0 ? l + 1 | 0 : l, Ce = (w | 0) == (lr | 0) & n >>> 0 > or >>> 0 | w >>> 0 > lr >>> 0, K = (w | 0) == (a | 0) & n >>> 0 < pe >>> 0 | w >>> 0 < a >>> 0, P = (a | 0) == (tr | 0) & pe >>> 0 < Me >>> 0 | a >>> 0 < tr >>> 0, w = t[b + 240 >> 2], tr = w, n = Tt + 8 | 0, a = t[n >> 2], l = Nr + 8 | 0, Me = a + t[l >> 2] | 0, l = t[l + 4 >> 2] + t[n + 4 >> 2] | 0, Yr = t[b + 244 >> 2], l = Yr + (a >>> 0 > Me >>> 0 ? l + 1 | 0 : l) | 0, w = w + Me | 0, l = w >>> 0 < Me >>> 0 ? l + 1 | 0 : l, n = w, w = w + P | 0, l = n >>> 0 > w >>> 0 ? l + 1 | 0 : l, n = w, w = w + K | 0, l = n >>> 0 > w >>> 0 ? l + 1 | 0 : l, n = w, w = w + Ce | 0, l = n >>> 0 > w >>> 0 ? l + 1 | 0 : l, Ce = w, w = t[b + 144 >> 2], K = Ce + w | 0, n = l, l = l + t[b + 148 >> 2] | 0, l = w >>> 0 > K >>> 0 ? l + 1 | 0 : l, w = t[b + 160 >> 2], P = w + K | 0, a = l, l = l + t[b + 164 >> 2] | 0, w = w >>> 0 > P >>> 0 ? l + 1 | 0 : l, l = kr + w | 0, pe = P + ai | 0, kr = pe >>> 0 < ai >>> 0 ? l + 1 | 0 : l, Nr = pe, Tt = (w | 0) == (kr | 0) & pe >>> 0 < P >>> 0 | w >>> 0 > kr >>> 0, Me = (w | 0) == (a | 0) & P >>> 0 < K >>> 0 | w >>> 0 < a >>> 0, K = (n | 0) == (a | 0) & K >>> 0 < Ce >>> 0 | n >>> 0 > a >>> 0, P = (n | 0) == (Yr | 0) & Ce >>> 0 < tr >>> 0 | n >>> 0 < Yr >>> 0, w = t[b + 248 >> 2], Yr = w, n = gr + 8 | 0, a = t[n >> 2], l = ei + 8 | 0, Ce = a + t[l >> 2] | 0, l = t[l + 4 >> 2] + t[n + 4 >> 2] | 0, ai = t[b + 252 >> 2], l = ai + (a >>> 0 > Ce >>> 0 ? l + 1 | 0 : l) | 0, w = w + Ce | 0, l = w >>> 0 < Ce >>> 0 ? l + 1 | 0 : l, n = w, w = w + P | 0, l = n >>> 0 > w >>> 0 ? l + 1 | 0 : l, n = w, w = w + K | 0, l = n >>> 0 > w >>> 0 ? l + 1 | 0 : l, n = w, w = w + Me | 0, l = n >>> 0 > w >>> 0 ? l + 1 | 0 : l, n = w, w = w + Tt | 0, l = n >>> 0 > w >>> 0 ? l + 1 | 0 : l, Ce = w, w = t[b + 112 >> 2], K = Ce + w | 0, n = l, l = l + t[b + 116 >> 2] | 0, l = w >>> 0 > K >>> 0 ? l + 1 | 0 : l, w = t[b + 128 >> 2], P = w + K | 0, a = l, l = l + t[b + 132 >> 2] | 0, w = w >>> 0 > P >>> 0 ? l + 1 | 0 : l, l = di + w | 0, di = b + 80 | 0, gr = di, pe = P + Di | 0, ei = pe >>> 0 < Di >>> 0 ? l + 1 | 0 : l, Tt = pe, tr = (w | 0) == (ei | 0) & pe >>> 0 < P >>> 0 | w >>> 0 > ei >>> 0, Me = (w | 0) == (a | 0) & P >>> 0 < K >>> 0 | w >>> 0 < a >>> 0, P = (n | 0) == (a | 0) & K >>> 0 < Ce >>> 0 | n >>> 0 > a >>> 0, pe = (n | 0) == (ai | 0) & Ce >>> 0 < Yr >>> 0 | n >>> 0 < ai >>> 0, l = Ei + 8 | 0, n = t[l >> 2], a = t[l + 4 >> 2], K = t[b + 96 >> 2], l = Ii + 8 | 0, w = t[l >> 2], Yr = K + w | 0, Ce = t[b + 100 >> 2], l = Ce + t[l + 4 >> 2] | 0, l = (w >>> 0 > Yr >>> 0 ? l + 1 | 0 : l) + a | 0, w = n + Yr | 0, l = w >>> 0 < Yr >>> 0 ? l + 1 | 0 : l, n = w, w = w + pe | 0, l = n >>> 0 > w >>> 0 ? l + 1 | 0 : l, n = w, w = w + P | 0, l = n >>> 0 > w >>> 0 ? l + 1 | 0 : l, n = w, w = w + Me | 0, l = n >>> 0 > w >>> 0 ? l + 1 | 0 : l, a = w + tr | 0, w = a >>> 0 < w >>> 0 ? l + 1 | 0 : l, l = wi + w | 0, n = a, a = n + Qi | 0, l = a >>> 0 < Qi >>> 0 ? l + 1 | 0 : l, Ii = a, Me = l, Pr(gr, a, l, 0, 0, 801750719, 1076732275, 0, 0), wi = b + 48 | 0, P = wi, pe = (l | 0) == (w | 0) & n >>> 0 > a >>> 0 | l >>> 0 < w >>> 0, a = (w | 0) == (Ce | 0) & n >>> 0 < K >>> 0 | w >>> 0 < Ce >>> 0, l = Li + 8 | 0, w = t[l >> 2], n = w + ui | 0, l = Ti + t[l + 4 >> 2] | 0, l = w >>> 0 > n >>> 0 ? l + 1 | 0 : l, w = n + a | 0, l = w >>> 0 < n >>> 0 ? l + 1 | 0 : l, n = w, w = w + pe | 0, l = n >>> 0 > w >>> 0 ? l + 1 | 0 : l, Yr = w, gr = l, Pr(P, w, l, 0, 0, 801750719, 1076732275, 0, 0), ai = b - -64 | 0, Pr(ai, Ii, Me, 0, 0, 1354194884, 1162945305, 0, 0), Ei = b + 32 | 0, Pr(Ei, w, l, 0, 0, 1354194884, 1162945305, 0, 0), w = t[b + 80 >> 2], tr = w + nr | 0, l = jr + t[b + 84 >> 2] | 0, pe = w >>> 0 > tr >>> 0 ? l + 1 | 0 : l, a = (jr | 0) == (pe | 0) & tr >>> 0 < nr >>> 0 | pe >>> 0 < jr >>> 0, l = di + 8 | 0, w = t[l >> 2], n = w + or | 0, l = lr + t[l + 4 >> 2] | 0, l = w >>> 0 > n >>> 0 ? l + 1 | 0 : l, w = n + a | 0, a = w >>> 0 < n >>> 0 ? l + 1 | 0 : l, l = a + t[b + 52 >> 2] | 0, K = w, w = t[b + 48 >> 2], n = K + w | 0, P = t[b + 64 >> 2], nr = n + P | 0, w = w >>> 0 > n >>> 0 ? l + 1 | 0 : l, l = w + t[b + 68 >> 2] | 0, ui = (gr | 0) == (Ti | 0) & Yr >>> 0 < ui >>> 0 | gr >>> 0 < Ti >>> 0, Li = ui ? 801750719 : 0, di = ui ? 1076732275 : 0, P = P >>> 0 > nr >>> 0 ? l + 1 | 0 : l, jr = (w | 0) == (P | 0) & n >>> 0 > nr >>> 0 | w >>> 0 > P >>> 0, Ce = (w | 0) == (a | 0) & n >>> 0 < K >>> 0 | w >>> 0 < a >>> 0, K = (a | 0) == (lr | 0) & K >>> 0 < or >>> 0 | a >>> 0 < lr >>> 0, l = wi + 8 | 0, n = t[l >> 2], a = t[l + 4 >> 2], l = ai + 8 | 0, w = t[l >> 2], or = w + Nr | 0, l = kr + t[l + 4 >> 2] | 0, l = (w >>> 0 > or >>> 0 ? l + 1 | 0 : l) + a | 0, w = n + or | 0, l = w >>> 0 < or >>> 0 ? l + 1 | 0 : l, n = w, w = w + K | 0, l = n >>> 0 > w >>> 0 ? l + 1 | 0 : l, n = w, w = w + Ce | 0, l = n >>> 0 > w >>> 0 ? l + 1 | 0 : l, n = w, w = w + jr | 0, n = n >>> 0 > w >>> 0 ? l + 1 | 0 : l, l = n + di | 0, lr = w, w = w + Li | 0, l = lr >>> 0 > w >>> 0 ? l + 1 | 0 : l, Ce = w, w = t[b + 32 >> 2], K = Ce + w | 0, a = l, l = l + t[b + 36 >> 2] | 0, w = w >>> 0 > K >>> 0 ? l + 1 | 0 : l, l = Me + w | 0, or = K + Ii | 0, Me = or >>> 0 < Ii >>> 0 ? l + 1 | 0 : l, Ii = (w | 0) == (Me | 0) & K >>> 0 > or >>> 0 | w >>> 0 > Me >>> 0, jr = (w | 0) == (a | 0) & K >>> 0 < Ce >>> 0 | w >>> 0 < a >>> 0, K = (n | 0) == (a | 0) & Ce >>> 0 < lr >>> 0 | n >>> 0 > a >>> 0, a = (n | 0) == (kr | 0) & lr >>> 0 < Nr >>> 0 | n >>> 0 < kr >>> 0, l = Ei + 8 | 0, w = t[l >> 2], n = w + Tt | 0, l = ei + t[l + 4 >> 2] | 0, l = w >>> 0 > n >>> 0 ? l + 1 | 0 : l, w = n + a | 0, l = w >>> 0 < n >>> 0 ? l + 1 | 0 : l, n = w, w = w + K | 0, l = n >>> 0 > w >>> 0 ? l + 1 | 0 : l, n = w, w = w + jr | 0, l = n >>> 0 > w >>> 0 ? l + 1 | 0 : l, n = w, w = w + Ii | 0, l = n >>> 0 > w >>> 0 ? l + 1 | 0 : l, K = w, w = ui ? 1354194884 : 0, n = K + w | 0, a = l, l = l + (ui ? 1162945305 : 0) | 0, w = w >>> 0 > n >>> 0 ? l + 1 | 0 : l, l = gr + w | 0, kr = b + 16 | 0, Nr = n + Yr | 0, Ce = Nr >>> 0 < Yr >>> 0 ? l + 1 | 0 : l, lr = (w | 0) == (Ce | 0) & n >>> 0 > Nr >>> 0 | w >>> 0 > Ce >>> 0, w = (w | 0) == (a | 0) & n >>> 0 < K >>> 0 | w >>> 0 < a >>> 0, a = ui + ((a | 0) == (ei | 0) & K >>> 0 < Tt >>> 0 | a >>> 0 < ei >>> 0) | 0, l = ui >>> 0 > a >>> 0, w = w + a | 0, l = w >>> 0 < a >>> 0 ? l + 1 | 0 : l, Tt = w + lr | 0, l = Tt >>> 0 < w >>> 0 ? l + 1 | 0 : l, lr = l, Pr(kr, Tt, l, 0, 0, 801750719, 1076732275, 0, 0), Pr(b, Tt, l, 0, 0, 1354194884, 1162945305, 0, 0), w = t[b + 16 >> 2], gr = w, jr = t[b + 20 >> 2], l = jr + pe | 0, a = w + tr | 0, pe = a >>> 0 < tr >>> 0 ? l + 1 | 0 : l, w = t[b >> 2], K = w, ei = t[b + 4 >> 2], l = ei + P | 0, n = w + nr | 0, w = n >>> 0 < nr >>> 0 ? l + 1 | 0 : l, P = n, n = (pe | 0) == (jr | 0) & a >>> 0 < gr >>> 0 | pe >>> 0 < jr >>> 0, l = kr + 8 | 0, nr = n + t[l >> 2] | 0, l = t[l + 4 >> 2], l = (n >>> 0 > nr >>> 0 ? l + 1 | 0 : l) + w | 0, n = P + nr | 0, tr = n >>> 0 < nr >>> 0 ? l + 1 | 0 : l, nr = n, n = (w | 0) == (tr | 0) & n >>> 0 < P >>> 0 | w >>> 0 > tr >>> 0, w = (w | 0) == (ei | 0) & P >>> 0 < K >>> 0 | w >>> 0 < ei >>> 0, l = b + 8 | 0, P = w + t[l >> 2] | 0, l = t[l + 4 >> 2], l = w >>> 0 > P >>> 0 ? l + 1 | 0 : l, K = n + P | 0, P = K >>> 0 < P >>> 0 ? l + 1 | 0 : l, l = Me + lr | 0, n = Tt + or | 0, w = n >>> 0 < or >>> 0 ? l + 1 | 0 : l, l = w + P | 0, gr = (w | 0) == (lr | 0) & n >>> 0 < Tt >>> 0 | w >>> 0 < lr >>> 0, Me = n, K = n + K | 0, n = K >>> 0 < n >>> 0 ? l + 1 | 0 : l, l = Me, Me = K, P = (w | 0) == (n | 0) & l >>> 0 > K >>> 0 | w >>> 0 > n >>> 0, w = gr + P | 0, P = w >>> 0 < P >>> 0, l = Ce + P | 0, Ce = w + Nr | 0, l = Ce >>> 0 < Nr >>> 0 ? l + 1 | 0 : l, Nr = (n | 0) == -1, K = l, Tt = Nr & Me >>> 0 < 4294967294 | (n | 0) != -1 | (l & Ce) != -1, or = (tr | 0) == -1162945306, l = (Tt | (or & nr >>> 0 < 2940772411 | tr >>> 0 < 3132021990)) ^ -1, Tt = (l & ((pe | 0) == -1076732276 & a >>> 0 > 3493216576 | pe >>> 0 > 3218235020) | (l & (or & nr >>> 0 > 2940772411 | tr >>> 0 > 3132021990) | (Me | 0) == -1 & Nr & (Tt ^ -1))) + ((P | 0) == (K | 0) & w >>> 0 > Ce >>> 0 | P >>> 0 > K >>> 0) | 0, w = ri(Tt, 0, 801750719, 1076732275), P = w + a | 0, l = pe + ve | 0, t[C >> 2] = P, l = w >>> 0 > P >>> 0 ? l + 1 | 0 : l, t[C + 4 >> 2] = l, w = C, pe = (l | 0) == (pe | 0) & a >>> 0 > P >>> 0 | l >>> 0 < pe >>> 0, C = ri(Tt, 0, 1354194884, 1162945305), a = C + nr | 0, l = tr + ve | 0, l = C >>> 0 > a >>> 0 ? l + 1 | 0 : l, C = l, pe = a + pe | 0, l = pe >>> 0 < a >>> 0 ? l + 1 | 0 : l, t[w + 8 >> 2] = pe, t[w + 12 >> 2] = l, gr = (C | 0) == (tr | 0) & a >>> 0 < nr >>> 0 | C >>> 0 < tr >>> 0, C = (C | 0) == (l | 0) & a >>> 0 > pe >>> 0 | C >>> 0 > l >>> 0, P = gr + C | 0, pe = C >>> 0 > P >>> 0, l = n, a = Me + Tt | 0, C = a >>> 0 < Tt >>> 0 ? l + 1 | 0 : l, l = C + pe | 0, pe = a + P | 0, l = pe >>> 0 < a >>> 0 ? l + 1 | 0 : l, t[w + 16 >> 2] = pe, t[w + 20 >> 2] = l, n = (C | 0) == (n | 0) & a >>> 0 < Me >>> 0 | C >>> 0 < n >>> 0, C = (C | 0) == (l | 0) & a >>> 0 > pe >>> 0 | C >>> 0 > l >>> 0, a = n + C | 0, l = K + (C >>> 0 > a >>> 0) | 0, C = a + Ce | 0, l = C >>> 0 < Ce >>> 0 ? l + 1 | 0 : l, t[w + 24 >> 2] = C, t[w + 28 >> 2] = l, U = b + 288 | 0;
  }
  function xr(C, l, w, n) {
    var a = 0, b = 0, P = 0, K = 0, pe = 0, Ce = 0, Me = 0, Tt = 0, tr = 0, nr = 0, or = 0, lr = 0, gr = 0, kr = 0, Nr = 0, jr = 0, Yr = 0, ei = 0, ai = 0, ui = 0, di = 0, Ii = 0, wi = 0, Ei = 0, Ti = 0, Di = 0, Qi = 0, Li = 0, Ki = 0, Wi = 0, Xi = 0, $i = 0, In = 0, kn = 0, Dn = 0, Mn = 0, zn = 0, es = 0, ns = 0, fs = 0, ps = 0, Es = 0, Ss = 0, Ps = 0, xs = 0, Bs = 0, vs = 0, eo = 0, Xs = 0, fo = 0, co = 0, ao = 0, no = 0, bo = 0, Io = 0, Po = 0, To = 0, mo = 0, Yi = 0, En = 0, On = 0;
    Me = U - 3808 | 0, U = Me, a = Me + 3696 | 0, t[a >> 2] = 0, t[a + 4 >> 2] = 0, a = Me + 3704 | 0, t[a >> 2] = 0, t[a + 4 >> 2] = 0, a = Me + 3712 | 0, t[a >> 2] = 0, t[a + 4 >> 2] = 0, t[Me + 3688 >> 2] = 0, t[Me + 3692 >> 2] = 0, t[Me + 3680 >> 2] = 1, t[Me + 3684 >> 2] = 0;
    e: {
      if (!(!t[l + 120 >> 2] && t[w + 24 >> 2] | (t[w + 16 >> 2] | (t[w + 8 >> 2] | t[w >> 2])) | (t[w + 28 >> 2] | (t[w + 20 >> 2] | (t[w + 12 >> 2] | t[w + 4 >> 2]))))) {
        w = 0, l = 0;
        break e;
      }
      b = U - 128 | 0, U = b, K = b - -64 | 0, ss(K, w, 690640), t[b + 56 >> 2] = 0, t[b + 60 >> 2] = 0, pe = ((t[b + 108 >> 2] >>> 31 | 0) - 1 >>> 8 ^ -1) & 1, P = t[b + 112 >> 2], nr = pe + P | 0, a = t[b + 116 >> 2], t[b + 32 >> 2] = nr, a = P >>> 0 > nr >>> 0 ? a + 1 | 0 : a, t[b + 36 >> 2] = a, pe = !a & pe >>> 0 > nr >>> 0, P = t[b + 120 >> 2], nr = pe + P | 0, a = t[b + 124 >> 2], t[b + 40 >> 2] = nr, a = P >>> 0 > nr >>> 0 ? a + 1 | 0 : a, t[b + 44 >> 2] = a, t[b + 48 >> 2] = !a & pe >>> 0 > nr >>> 0, t[b + 52 >> 2] = 0, ss(K, w, 690672), t[b + 24 >> 2] = 0, t[b + 28 >> 2] = 0, pe = ((t[b + 108 >> 2] >>> 31 | 0) - 1 >>> 8 ^ -1) & 1, P = t[b + 112 >> 2], K = pe + P | 0, a = t[b + 116 >> 2], t[b >> 2] = K, a = P >>> 0 > K >>> 0 ? a + 1 | 0 : a, t[b + 4 >> 2] = a, P = !a & K >>> 0 < pe >>> 0, Nr = b, b = t[b + 120 >> 2], pe = P + b | 0, a = t[Nr + 124 >> 2], t[Nr + 8 >> 2] = pe, a = b >>> 0 > pe >>> 0 ? a + 1 | 0 : a, t[Nr + 12 >> 2] = a, t[Nr + 16 >> 2] = !a & P >>> 0 > pe >>> 0, t[Nr + 20 >> 2] = 0, a = Nr + 32 | 0, Er(a, a, 690576), Er(Nr, Nr, 690608), pe = t[Nr >> 2], P = t[Nr + 32 >> 2], b = pe + P | 0, K = t[Nr + 4 >> 2], a = K + t[Nr + 36 >> 2] | 0, jr = b >>> 0 < P >>> 0 ? a + 1 | 0 : a, tr = b, nr = (K | 0) == (jr | 0) & b >>> 0 < pe >>> 0 | K >>> 0 > jr >>> 0, b = t[Nr + 40 >> 2], pe = nr + b | 0, a = t[Nr + 44 >> 2], K = t[Nr + 8 >> 2], P = K + pe | 0, b = b >>> 0 > pe >>> 0 ? a + 1 | 0 : a, a = b + t[Nr + 12 >> 2] | 0, Ce = !b & pe >>> 0 < nr >>> 0, kr = P >>> 0 < K >>> 0 ? a + 1 | 0 : a, gr = P, b = (b | 0) == (kr | 0) & pe >>> 0 > P >>> 0 | b >>> 0 > kr >>> 0, P = Ce + b | 0, Ce = b >>> 0 > P >>> 0, a = Ce + t[Nr + 52 >> 2] | 0, b = t[Nr + 48 >> 2], nr = b + P | 0, K = t[Nr + 16 >> 2], pe = nr + K | 0, b = b >>> 0 > nr >>> 0 ? a + 1 | 0 : a, a = b + t[Nr + 20 >> 2] | 0, P = (b | 0) == (Ce | 0) & P >>> 0 > nr >>> 0 | b >>> 0 < Ce >>> 0, K = K >>> 0 > pe >>> 0 ? a + 1 | 0 : a, Yr = pe, b = (b | 0) == (K | 0) & nr >>> 0 > pe >>> 0 | b >>> 0 > K >>> 0, P = P + b | 0, nr = b >>> 0 > P >>> 0, a = nr + t[Nr + 60 >> 2] | 0, b = t[Nr + 56 >> 2], pe = b + P | 0, Ce = t[Nr + 24 >> 2], or = pe + Ce | 0, b = b >>> 0 > pe >>> 0 ? a + 1 | 0 : a, a = b + t[Nr + 28 >> 2] | 0, lr = Ce >>> 0 > or >>> 0 ? a + 1 | 0 : a, Ce = ((b | 0) == (nr | 0) & P >>> 0 > pe >>> 0 | b >>> 0 < nr >>> 0) + ((b | 0) == (lr | 0) & pe >>> 0 > or >>> 0 | b >>> 0 > lr >>> 0) | 0, P = (K | 0) == -1, b = P & Yr >>> 0 < 4294967294 | (K | 0) != -1 | (or & lr) != -1, pe = (kr | 0) == -1162945306, a = (b | (pe & gr >>> 0 < 2940772411 | kr >>> 0 < 3132021990)) ^ -1, ui = Ce + (a & ((jr | 0) == -1076732276 & tr >>> 0 > 3493216576 | jr >>> 0 > 3218235020) | (a & (pe & gr >>> 0 > 2940772411 | kr >>> 0 > 3132021990) | (Yr | 0) == -1 & P & (b ^ -1))) | 0, P = ri(ui, 0, 801750719, 1076732275), b = P + tr | 0, a = jr + ve | 0, Ce = Me + 3720 | 0, t[Ce >> 2] = b, nr = b >>> 0 < P >>> 0 ? a + 1 | 0 : a, t[Ce + 4 >> 2] = nr, pe = Ce, P = ri(ui, 0, 1354194884, 1162945305), Tt = P + gr | 0, a = kr + ve | 0, b = (nr | 0) == (jr | 0) & b >>> 0 < tr >>> 0 | nr >>> 0 < jr >>> 0, Ce = Tt + b | 0, a = P >>> 0 > Tt >>> 0 ? a + 1 | 0 : a, P = a, t[pe + 8 >> 2] = Ce, tr = b >>> 0 > Ce >>> 0 ? a + 1 | 0 : a, t[pe + 12 >> 2] = tr, a = K, nr = Yr + ui | 0, b = nr >>> 0 < Yr >>> 0 ? a + 1 | 0 : a, a = (P | 0) == (kr | 0) & Tt >>> 0 < gr >>> 0 | P >>> 0 < kr >>> 0, P = (P | 0) == (tr | 0) & Ce >>> 0 < Tt >>> 0 | P >>> 0 > tr >>> 0, Ce = a + P | 0, a = (P >>> 0 > Ce >>> 0) + b | 0, P = Ce + nr | 0, a = P >>> 0 < Ce >>> 0 ? a + 1 | 0 : a, t[pe + 16 >> 2] = P, t[pe + 20 >> 2] = a, gr = pe, K = (b | 0) == (K | 0) & nr >>> 0 < Yr >>> 0 | b >>> 0 < K >>> 0, b = (a | 0) == (b | 0) & P >>> 0 < nr >>> 0 | a >>> 0 < b >>> 0, P = K + b | 0, a = lr + (b >>> 0 > P >>> 0) | 0, b = P + or | 0, a = b >>> 0 < or >>> 0 ? a + 1 | 0 : a, t[pe + 24 >> 2] = b, t[pe + 28 >> 2] = a, pe = Me + 2560 | 0, Er(pe, gr, 690704), di = t[pe + 24 >> 2], or = t[pe + 16 >> 2], nr = t[pe + 8 >> 2], b = t[pe >> 2], tr = t[pe + 28 >> 2], Ce = t[pe + 20 >> 2], Tt = t[pe + 12 >> 2], K = t[pe + 4 >> 2], a = di | (or | (nr | b)) | (tr | (Ce | (Tt | K))) ? -1 : 0, Yr = b ^ -1, P = Yr - 801750718 | 0, ui = a & P, t[pe >> 2] = ui, b = a, K = K ^ -1, a = K - ((Yr >>> 0 < 801750718) + 1076732275 | 0) | 0, lr = b & a, t[pe + 4 >> 2] = lr, P = (a | 0) == (K | 0) & P >>> 0 < Yr >>> 0 | a >>> 0 < K >>> 0, nr = nr ^ -1, jr = P + nr | 0, Yr = Tt ^ -1, a = Yr, K = jr - 1354194885 | 0, kr = K & b, t[pe + 8 >> 2] = kr, a = P >>> 0 > jr >>> 0 ? a + 1 | 0 : a, Tt = a - ((jr >>> 0 < 1354194885) + 1162945305 | 0) | 0, P = Tt & b, t[pe + 12 >> 2] = P, K = (a | 0) == (Tt | 0) & K >>> 0 < jr >>> 0 | a >>> 0 > Tt >>> 0, nr = K + ((a | 0) == (Yr | 0) & nr >>> 0 > jr >>> 0 | a >>> 0 < Yr >>> 0) | 0, Yr = or ^ -1, Qi = Yr + nr | 0, or = Ce ^ -1, a = or + (K >>> 0 > nr >>> 0) | 0, a = Yr >>> 0 > Qi >>> 0 ? a + 1 | 0 : a, Tt = a - (Qi >>> 0 < 2) | 0, nr = Tt & b, jr = nr, K = Qi - 2 | 0, Ce = K & b, t[pe + 16 >> 2] = Ce, t[pe + 20 >> 2] = nr, K = (a | 0) == (Tt | 0) & K >>> 0 < Qi >>> 0 | a >>> 0 > Tt >>> 0, nr = K + ((a | 0) == (or | 0) & Yr >>> 0 > Qi >>> 0 | a >>> 0 < or >>> 0) | 0, a = K >>> 0 > nr >>> 0, K = nr - di | 0, Qi = K - 2 & b, t[pe + 24 >> 2] = Qi, Tt = (a - ((nr >>> 0 < di >>> 0) + tr | 0) | 0) - (K >>> 0 < 2) & b, t[pe + 28 >> 2] = Tt, b = t[w >> 2], K = b, nr = t[w + 4 >> 2], a = nr + lr | 0, b = b + ui | 0, a = b >>> 0 < ui >>> 0 ? a + 1 | 0 : a, lr = b, t[pe >> 2] = b, Yr = a, t[pe + 4 >> 2] = a, a = P, tr = (nr | 0) == (Yr | 0) & b >>> 0 < K >>> 0 | nr >>> 0 > Yr >>> 0, b = tr + kr | 0, P = b >>> 0 < kr >>> 0 ? a + 1 | 0 : a, a = P + t[w + 12 >> 2] | 0, K = b, nr = t[w + 8 >> 2], b = b + nr | 0, or = b, t[pe + 8 >> 2] = b, kr = b >>> 0 < nr >>> 0 ? a + 1 | 0 : a, t[pe + 12 >> 2] = kr, Ii = t[w + 16 >> 2], Ce = Ii + Ce | 0, di = t[w + 20 >> 2], a = di + jr | 0, b = Ce >>> 0 < Ii >>> 0 ? a + 1 | 0 : a, a = !P & K >>> 0 < tr >>> 0, P = (P | 0) == (kr | 0) & K >>> 0 > or >>> 0 | P >>> 0 > kr >>> 0, K = a + P | 0, a = (P >>> 0 > K >>> 0) + b | 0, P = K + Ce | 0, a = P >>> 0 < K >>> 0 ? a + 1 | 0 : a, jr = P, t[pe + 16 >> 2] = P, K = a, t[pe + 20 >> 2] = a, P = t[w + 24 >> 2], tr = P, ui = t[w + 28 >> 2], a = ui + Tt | 0, P = P + Qi | 0, w = P >>> 0 < Qi >>> 0 ? a + 1 | 0 : a, nr = P, a = (b | 0) == (di | 0) & Ce >>> 0 < Ii >>> 0 | b >>> 0 < di >>> 0, b = (b | 0) == (K | 0) & Ce >>> 0 > jr >>> 0 | b >>> 0 > K >>> 0, Ce = a + b | 0, a = (b >>> 0 > Ce >>> 0) + w | 0, Tt = P + Ce | 0, a = Tt >>> 0 < Ce >>> 0 ? a + 1 | 0 : a, P = pe, Ce = a, nr = ((w | 0) == (ui | 0) & tr >>> 0 > nr >>> 0 | w >>> 0 < ui >>> 0) + ((w | 0) == (a | 0) & Tt >>> 0 < nr >>> 0 | w >>> 0 > a >>> 0) | 0, b = (K | 0) == -1, a = b & jr >>> 0 < 4294967294 | (K | 0) != -1 | (a & Tt) != -1, pe = (kr | 0) == -1162945306, w = (a | (pe & or >>> 0 < 2940772411 | kr >>> 0 < 3132021990)) ^ -1, ui = nr + (w & ((Yr | 0) == -1076732276 & lr >>> 0 > 3493216576 | Yr >>> 0 > 3218235020) | (w & (pe & or >>> 0 > 2940772411 | kr >>> 0 > 3132021990) | (jr | 0) == -1 & b & (a ^ -1))) | 0, b = ri(ui, 0, 801750719, 1076732275), w = b + lr | 0, a = Yr + ve | 0, t[P >> 2] = w, pe = w >>> 0 < b >>> 0 ? a + 1 | 0 : a, t[P + 4 >> 2] = pe, b = ri(ui, 0, 1354194884, 1162945305), tr = b + or | 0, a = kr + ve | 0, w = (pe | 0) == (Yr | 0) & w >>> 0 < lr >>> 0 | pe >>> 0 < Yr >>> 0, nr = tr + w | 0, a = b >>> 0 > tr >>> 0 ? a + 1 | 0 : a, b = a, t[P + 8 >> 2] = nr, lr = w >>> 0 > nr >>> 0 ? a + 1 | 0 : a, t[P + 12 >> 2] = lr, a = K, pe = jr + ui | 0, w = pe >>> 0 < jr >>> 0 ? a + 1 | 0 : a, a = (b | 0) == (kr | 0) & or >>> 0 > tr >>> 0 | b >>> 0 < kr >>> 0, b = (b | 0) == (lr | 0) & tr >>> 0 > nr >>> 0 | b >>> 0 > lr >>> 0, nr = a + b | 0, a = (b >>> 0 > nr >>> 0) + w | 0, b = pe + nr | 0, a = b >>> 0 < nr >>> 0 ? a + 1 | 0 : a, t[P + 16 >> 2] = b, t[P + 20 >> 2] = a, K = (w | 0) == (K | 0) & pe >>> 0 < jr >>> 0 | w >>> 0 < K >>> 0, w = (w | 0) == (a | 0) & b >>> 0 < pe >>> 0 | w >>> 0 > a >>> 0, b = K + w | 0, a = Ce + (w >>> 0 > b >>> 0) | 0, w = b + Tt | 0, a = w >>> 0 < Tt >>> 0 ? a + 1 | 0 : a, t[P + 24 >> 2] = w, t[P + 28 >> 2] = a, U = Nr + 128 | 0, En = Me, On = Ui(Me + 496 | 0, P, 5), t[En + 1528 >> 2] = On, Yi = Ui(Me + 1012 | 0, gr, 5), t[Me + 1532 >> 2] = Yi, Xs = t[Me + 1528 >> 2], Mn = Me + 3088 | 0, as(Mn, l, 128), w = Me + 1536 | 0, Ss = Me + 2240 | 0, eo = Me + 3680 | 0, tr = 0, lr = 0, Tt = 0, K = 0, kr = U - 720 | 0, U = kr;
      t: {
        if (t[Mn + 120 >> 2]) {
          t[kr + 672 >> 2] = 1, is(kr + 552 | 0, 120), pe = 0, P = 0;
          break t;
        }
        Gn(kr + 552 | 0, Mn), l = kr + 664 | 0, Tt = t[l >> 2], K = t[l + 4 >> 2], l = kr + 648 | 0, ai = t[l >> 2], ei = t[l + 4 >> 2], l = kr + 640 | 0, Ei = t[l >> 2], wi = t[l + 4 >> 2], tr = t[kr + 632 >> 2], lr = t[kr + 636 >> 2], l = kr + 656 | 0, pe = t[l >> 2], P = t[l + 4 >> 2];
      }
      for (Ki = kr + 552 | 0, b = Ki + 8 | 0, a = t[b + 4 >> 2], Es = kr + 336 | 0, l = Es + 8 | 0, t[l >> 2] = t[b >> 2], t[l + 4 >> 2] = a, b = Ki + 16 | 0, a = t[b + 4 >> 2], l = Es + 16 | 0, t[l >> 2] = t[b >> 2], t[l + 4 >> 2] = a, b = Ki + 24 | 0, a = t[b + 4 >> 2], l = Es + 24 | 0, t[l >> 2] = t[b >> 2], t[l + 4 >> 2] = a, b = Ki + 32 | 0, a = t[b + 4 >> 2], l = Es + 32 | 0, t[l >> 2] = t[b >> 2], t[l + 4 >> 2] = a, b = Ki + 48 | 0, a = t[b + 4 >> 2], l = Es + 48 | 0, t[l >> 2] = t[b >> 2], t[l + 4 >> 2] = a, b = Ki + 56 | 0, a = t[b + 4 >> 2], l = Es + 56 | 0, t[l >> 2] = t[b >> 2], t[l + 4 >> 2] = a, b = Ki - -64 | 0, a = t[b + 4 >> 2], l = Es - -64 | 0, t[l >> 2] = t[b >> 2], t[l + 4 >> 2] = a, b = Ki + 72 | 0, a = t[b + 4 >> 2], l = Es + 72 | 0, t[l >> 2] = t[b >> 2], t[l + 4 >> 2] = a, t[kr + 416 >> 2] = 0, l = t[kr + 556 >> 2], t[kr + 336 >> 2] = t[kr + 552 >> 2], t[kr + 340 >> 2] = l, l = t[kr + 596 >> 2], t[kr + 376 >> 2] = t[kr + 592 >> 2], t[kr + 380 >> 2] = l, Di = kr + 304 | 0, Li = tr << 1, $i = lr << 1 | tr >>> 31, Pr(Di, pe, P, 0, 0, Li, $i, 0, 0), Ti = kr + 224 | 0, b = ai, l = ei, nr = Ei << 1, Ce = wi << 1 | Ei >>> 31, Pr(Ti, b, l, 0, 0, nr, Ce, 0, 0), or = kr + 160 | 0, a = K, Pr(or, Tt, a, 0, 0, Tt, a, 0, 0), Yr = kr + 144 | 0, Pr(Yr, t[kr + 160 >> 2], t[kr + 164 >> 2], 0, 0, 15632, 16, 0, 0), K = Tt, a = a << 1 | K >>> 31, ns = kr + 112 | 0, fs = K << 1, Qi = a, Pr(ns, fs, a, 0, 0, tr, lr, 0, 0), ps = kr + 272 | 0, Pr(ps, pe, P, 0, 0, nr, Ce, 0, 0), In = kr + 208 | 0, Pr(In, b, l, 0, 0, b, l, 0, 0), ui = kr + 128 | 0, a = or + 8 | 0, Pr(ui, t[a >> 2], t[a + 4 >> 2], 0, 0, 64028672, 65536, 0, 0), vs = kr + 320 | 0, Pr(vs, tr, lr, 0, 0, tr, lr, 0, 0), Ps = kr + 96 | 0, Pr(Ps, fs, Qi, 0, 0, Ei, wi, 0, 0), jr = l, Ii = b, a = l << 1 | b >>> 31, xs = kr + 176 | 0, ai = pe, ei = P, Pr(xs, pe, P, 0, 0, b << 1, a, 0, 0), Ce = t[kr + 304 >> 2], b = t[kr + 224 >> 2], l = Ce + b | 0, Wi = t[kr + 308 >> 2], a = Wi + t[kr + 228 >> 2] | 0, a = l >>> 0 < b >>> 0 ? a + 1 | 0 : a, b = t[kr + 144 >> 2], di = b + l | 0, P = a, a = a + t[kr + 148 >> 2] | 0, nr = b >>> 0 > di >>> 0 ? a + 1 | 0 : a, zn = t[kr + 272 >> 2], b = t[kr + 208 >> 2], or = zn + b | 0, es = t[kr + 276 >> 2], a = es + t[kr + 212 >> 2] | 0, a = b >>> 0 > or >>> 0 ? a + 1 | 0 : a, b = t[kr + 112 >> 2], gr = b + or | 0, K = a, a = a + t[kr + 116 >> 2] | 0, a = b >>> 0 > gr >>> 0 ? a + 1 | 0 : a, b = t[kr + 128 >> 2], tr = b + gr | 0, pe = a, a = a + t[kr + 132 >> 2] | 0, b = b >>> 0 > tr >>> 0 ? a + 1 | 0 : a, Nr = (P | 0) == (nr | 0) & l >>> 0 > di >>> 0 | P >>> 0 > nr >>> 0, a = Yr + 8 | 0, Tt = t[a >> 2], lr = t[a + 4 >> 2], Ce = (P | 0) == (Wi | 0) & l >>> 0 < Ce >>> 0 | P >>> 0 < Wi >>> 0, a = Ti + 8 | 0, P = t[a >> 2], l = Di + 8 | 0, Yr = P + t[l >> 2] | 0, a = t[l + 4 >> 2] + t[a + 4 >> 2] | 0, a = P >>> 0 > Yr >>> 0 ? a + 1 | 0 : a, l = Ce + Yr | 0, a = (l >>> 0 < Yr >>> 0 ? a + 1 | 0 : a) + lr | 0, P = l, l = l + Tt | 0, a = P >>> 0 > l >>> 0 ? a + 1 | 0 : a, P = l, l = l + Nr | 0, a = P >>> 0 > l >>> 0 ? a + 1 | 0 : a, Yr = nr, nr = l << 12 | nr >>> 20, lr = nr + tr | 0, P = a, a = b + (a << 12 | l >>> 20) | 0, nr = lr >>> 0 < nr >>> 0 ? a + 1 | 0 : a, Bs = kr + 80 | 0, Wi = Bs, kn = t[kr + 96 >> 2], l = t[kr + 176 >> 2], Tt = kn + l | 0, Xi = t[kr + 100 >> 2], a = Xi + t[kr + 180 >> 2] | 0, l = l >>> 0 > Tt >>> 0 ? a + 1 | 0 : a, Di = (b | 0) == (nr | 0) & tr >>> 0 > lr >>> 0 | b >>> 0 > nr >>> 0, Ti = (b | 0) == (pe | 0) & tr >>> 0 < gr >>> 0 | b >>> 0 < pe >>> 0, a = ui + 8 | 0, ui = t[a >> 2], Nr = t[a + 4 >> 2], gr = (K | 0) == (pe | 0) & or >>> 0 > gr >>> 0 | K >>> 0 > pe >>> 0, a = ns + 8 | 0, tr = t[a >> 2], Ce = t[a + 4 >> 2], K = (K | 0) == (es | 0) & or >>> 0 < zn >>> 0 | K >>> 0 < es >>> 0, pe = In + 8 | 0, b = t[pe >> 2], a = ps + 8 | 0, or = b + t[a >> 2] | 0, a = t[a + 4 >> 2] + t[pe + 4 >> 2] | 0, a = b >>> 0 > or >>> 0 ? a + 1 | 0 : a, b = K + or | 0, a = (b >>> 0 < or >>> 0 ? a + 1 | 0 : a) + Ce | 0, K = b, b = b + tr | 0, a = K >>> 0 > b >>> 0 ? a + 1 | 0 : a, K = b, b = b + gr | 0, a = (K >>> 0 > b >>> 0 ? a + 1 | 0 : a) + Nr | 0, K = b, b = b + ui | 0, a = K >>> 0 > b >>> 0 ? a + 1 | 0 : a, pe = b + Ti | 0, a = pe >>> 0 < b >>> 0 ? a + 1 | 0 : a, P = P >>> 20 | 0, b = P + pe | 0, a = P >>> 0 > b >>> 0 ? a + 1 | 0 : a, P = b, b = b + Di | 0, P = P >>> 0 > b >>> 0 ? a + 1 | 0 : a, pe = P << 12 | b >>> 20, a = b << 12, b = nr, nr = a | b >>> 20, K = nr + Tt | 0, a = l + pe | 0, nr = K >>> 0 < nr >>> 0 ? a + 1 | 0 : a, pe = K, a = nr << 4 | pe >>> 28, Ce = pe << 4 & -16, K = a & 16777215, Nr = b, Pr(Wi, Ce | b >>> 16 & 15, K, 0, 0, 977, 1, 0, 0), Ce = kr, Ti = t[Ce + 80 >> 2], b = t[Ce + 320 >> 2], tr = Ti + b | 0, Dn = t[Ce + 84 >> 2], a = Dn + t[Ce + 324 >> 2] | 0, t[Ce + 424 >> 2] = tr, K = b >>> 0 > tr >>> 0 ? a + 1 | 0 : a, t[Ce + 428 >> 2] = K & 1048575, ns = Ce + 256 | 0, Pr(ns, Ei, wi, 0, 0, Li, $i, 0, 0), ps = Ce - -64 | 0, Pr(ps, fs, Qi, 0, 0, Ii, jr, 0, 0), In = Ce + 288 | 0, Pr(In, ai, ei, 0, 0, ai, ei, 0, 0), zn = Ce + 48 | 0, kr = zn, Wi = t[Ce + 64 >> 2], b = t[Ce + 288 >> 2], ui = Wi + b | 0, es = t[Ce + 68 >> 2], a = es + t[Ce + 292 >> 2] | 0, b = b >>> 0 > ui >>> 0 ? a + 1 | 0 : a, or = ui, gr = (l | 0) == (nr | 0) & pe >>> 0 < Tt >>> 0 | l >>> 0 > nr >>> 0, Tt = (l | 0) == (Xi | 0) & Tt >>> 0 < kn >>> 0 | l >>> 0 < Xi >>> 0, a = xs + 8 | 0, pe = t[a >> 2], l = Ps + 8 | 0, Di = pe + t[l >> 2] | 0, a = t[l + 4 >> 2] + t[a + 4 >> 2] | 0, a = pe >>> 0 > Di >>> 0 ? a + 1 | 0 : a, pe = Tt + Di | 0, a = pe >>> 0 < Di >>> 0 ? a + 1 | 0 : a, P = P >>> 20 | 0, l = P + pe | 0, a = P >>> 0 > l >>> 0 ? a + 1 | 0 : a, P = l, l = l + gr | 0, a = P >>> 0 > l >>> 0 ? a + 1 | 0 : a, P = l << 12 | nr >>> 20, or = P + or | 0, pe = a, a = b + (a << 12 | l >>> 20) | 0, Tt = P >>> 0 > or >>> 0 ? a + 1 | 0 : a, Pr(kr, or, Tt & 1048575, 0, 0, 15632, 16, 0, 0), Di = t[Ce + 48 >> 2], l = t[Ce + 256 >> 2], kr = Di + l | 0, kn = t[Ce + 52 >> 2], a = kn + t[Ce + 260 >> 2] | 0, l = l >>> 0 > kr >>> 0 ? a + 1 | 0 : a, gr = kr, tr = (K | 0) == (Dn | 0) & tr >>> 0 < Ti >>> 0 | K >>> 0 < Dn >>> 0, nr = vs + 8 | 0, P = t[nr >> 2], a = Bs + 8 | 0, Ti = P + t[a >> 2] | 0, a = t[a + 4 >> 2] + t[nr + 4 >> 2] | 0, a = P >>> 0 > Ti >>> 0 ? a + 1 | 0 : a, P = tr + Ti | 0, a = P >>> 0 < Ti >>> 0 ? a + 1 | 0 : a, K = P << 12 | K >>> 20, gr = K + gr | 0, nr = a, a = l + (a << 12 | P >>> 20) | 0, t[Ce + 432 >> 2] = gr, tr = K >>> 0 > gr >>> 0 ? a + 1 | 0 : a, t[Ce + 436 >> 2] = tr & 1048575, Ti = Ce + 192 | 0, Pr(Ti, Ii, jr, 0, 0, Li, $i, 0, 0), Li = Ce + 240 | 0, Pr(Li, Ei, wi, 0, 0, Ei, wi, 0, 0), Ei = Ce + 32 | 0, Pr(Ei, fs, Qi, 0, 0, ai, ei, 0, 0), Ii = Ce + 16 | 0, jr = Ii, or = (b | 0) == (Tt | 0) & or >>> 0 < ui >>> 0 | b >>> 0 > Tt >>> 0, K = (b | 0) == (es | 0) & ui >>> 0 < Wi >>> 0 | b >>> 0 < es >>> 0, P = In + 8 | 0, b = t[P >> 2], a = ps + 8 | 0, ei = b + t[a >> 2] | 0, a = t[a + 4 >> 2] + t[P + 4 >> 2] | 0, a = b >>> 0 > ei >>> 0 ? a + 1 | 0 : a, P = K + ei | 0, a = P >>> 0 < ei >>> 0 ? a + 1 | 0 : a, pe = pe >>> 20 | 0, b = P + pe | 0, a = pe >>> 0 > b >>> 0 ? a + 1 | 0 : a, P = b, b = b + or | 0, a = P >>> 0 > b >>> 0 ? a + 1 | 0 : a, ui = b << 12 | Tt >>> 20, P = t[Ce + 32 >> 2], Tt = ui + P | 0, K = a, $i = a << 12 | b >>> 20, a = $i + t[Ce + 36 >> 2] | 0, ei = P >>> 0 > Tt >>> 0 ? a + 1 | 0 : a, Pr(jr, Tt, ei, 0, 0, 15632, 16, 0, 0), wi = t[Ce + 192 >> 2], b = t[Ce + 240 >> 2], jr = wi + b | 0, Qi = t[Ce + 196 >> 2], a = Qi + t[Ce + 244 >> 2] | 0, a = b >>> 0 > jr >>> 0 ? a + 1 | 0 : a, b = t[Ce + 16 >> 2], or = b + jr | 0, pe = a, a = a + t[Ce + 20 >> 2] | 0, b = b >>> 0 > or >>> 0 ? a + 1 | 0 : a, ai = (l | 0) == (tr | 0) & gr >>> 0 < kr >>> 0 | l >>> 0 > tr >>> 0, gr = (l | 0) == (kn | 0) & kr >>> 0 < Di >>> 0 | l >>> 0 < kn >>> 0, a = ns + 8 | 0, P = t[a >> 2], l = zn + 8 | 0, kr = P + t[l >> 2] | 0, a = t[l + 4 >> 2] + t[a + 4 >> 2] | 0, a = P >>> 0 > kr >>> 0 ? a + 1 | 0 : a, P = gr + kr | 0, a = P >>> 0 < kr >>> 0 ? a + 1 | 0 : a, nr = nr >>> 20 | 0, l = P + nr | 0, a = nr >>> 0 > l >>> 0 ? a + 1 | 0 : a, P = l, l = l + ai | 0, a = P >>> 0 > l >>> 0 ? a + 1 | 0 : a, nr = l << 12 | tr >>> 20, tr = nr + or | 0, P = a, a = b + (a << 12 | l >>> 20) | 0, t[Ce + 440 >> 2] = tr, nr = tr >>> 0 < nr >>> 0 ? a + 1 | 0 : a, t[Ce + 444 >> 2] = nr & 1048575, l = Ce, gr = (ei | 0) == ($i | 0) & Tt >>> 0 < ui >>> 0 | ei >>> 0 < $i >>> 0, a = Ei + 8 | 0, Tt = t[a >> 2], a = t[a + 4 >> 2], K = K >>> 20 | 0, Ce = K, K = K + Tt | 0, a = Ce >>> 0 > K >>> 0 ? a + 1 | 0 : a, Ce = K, K = K + gr | 0, a = Ce >>> 0 > K >>> 0 ? a + 1 | 0 : a, Pr(l, K, a, 0, 0, 64028672, 65536, 0, 0), K = l, ei = t[l >> 2], l = di & -2, Ce = ei + l | 0, ai = t[K + 4 >> 2], a = ai + (Yr & 1048575) | 0, l = l >>> 0 > Ce >>> 0 ? a + 1 | 0 : a, Yr = (b | 0) == (nr | 0) & or >>> 0 > tr >>> 0 | b >>> 0 > nr >>> 0, or = (b | 0) == (pe | 0) & or >>> 0 < jr >>> 0 | b >>> 0 < pe >>> 0, a = Ii + 8 | 0, gr = t[a >> 2], Tt = t[a + 4 >> 2], tr = (pe | 0) == (Qi | 0) & jr >>> 0 < wi >>> 0 | pe >>> 0 < Qi >>> 0, pe = Li + 8 | 0, b = t[pe >> 2], a = Ti + 8 | 0, jr = b + t[a >> 2] | 0, a = t[a + 4 >> 2] + t[pe + 4 >> 2] | 0, a = b >>> 0 > jr >>> 0 ? a + 1 | 0 : a, b = tr + jr | 0, a = (b >>> 0 < jr >>> 0 ? a + 1 | 0 : a) + Tt | 0, pe = b, b = b + gr | 0, a = pe >>> 0 > b >>> 0 ? a + 1 | 0 : a, pe = b + or | 0, a = pe >>> 0 < b >>> 0 ? a + 1 | 0 : a, P = P >>> 20 | 0, b = P + pe | 0, a = P >>> 0 > b >>> 0 ? a + 1 | 0 : a, P = b, b = b + Yr | 0, a = P >>> 0 > b >>> 0 ? a + 1 | 0 : a, nr = b << 12 | nr >>> 20, pe = nr + Ce | 0, P = a, a = l + (a << 12 | b >>> 20) | 0, t[K + 448 >> 2] = pe, b = pe >>> 0 < nr >>> 0 ? a + 1 | 0 : a, t[K + 452 >> 2] = b & 1048575, Tt = Nr & 65535, tr = (l | 0) == (b | 0) & Ce >>> 0 > pe >>> 0 | l >>> 0 > b >>> 0, nr = (l | 0) == (ai | 0) & Ce >>> 0 < ei >>> 0 | l >>> 0 < ai >>> 0, l = K + 8 | 0, pe = nr + t[l >> 2] | 0, a = t[l + 4 >> 2], a = pe >>> 0 < nr >>> 0 ? a + 1 | 0 : a, P = P >>> 20 | 0, l = P + pe | 0, a = P >>> 0 > l >>> 0 ? a + 1 | 0 : a, P = l, l = l + tr | 0, a = P >>> 0 > l >>> 0 ? a + 1 | 0 : a, b = l << 12 | b >>> 20, P = b + lr | 0, a = Tt + (a << 12 | l >>> 20) | 0, t[K + 456 >> 2] = P, t[K + 460 >> 2] = b >>> 0 > P >>> 0 ? a + 1 | 0 : a, l = K + 680 | 0, jr = K + 424 | 0, nr = Ki + 80 | 0, zr(l, jr, nr), zr(w, Mn, jr), zr(w + 40 | 0, Mn + 40 | 0, l), b = t[Mn + 120 >> 2], t[w + 80 >> 2] = b, a = w + 8 | 0, l = t[a + 4 >> 2], Yr = jr + 8 | 0, t[Yr >> 2] = t[a >> 2], t[Yr + 4 >> 2] = l, a = w + 16 | 0, l = t[a + 4 >> 2], Nr = jr + 16 | 0, t[Nr >> 2] = t[a >> 2], t[Nr + 4 >> 2] = l, a = w + 24 | 0, l = t[a + 4 >> 2], or = jr + 24 | 0, t[or >> 2] = t[a >> 2], t[or + 4 >> 2] = l, a = w + 32 | 0, l = t[a + 4 >> 2], gr = jr + 32 | 0, t[gr >> 2] = t[a >> 2], t[gr + 4 >> 2] = l, a = w + 48 | 0, l = t[a + 4 >> 2], Tt = jr + 48 | 0, t[Tt >> 2] = t[a >> 2], t[Tt + 4 >> 2] = l, a = w + 56 | 0, l = t[a + 4 >> 2], tr = jr + 56 | 0, t[tr >> 2] = t[a >> 2], t[tr + 4 >> 2] = l, a = w - -64 | 0, l = t[a + 4 >> 2], lr = jr - -64 | 0, t[lr >> 2] = t[a >> 2], t[lr + 4 >> 2] = l, a = w + 72 | 0, l = t[a + 4 >> 2], Ce = jr + 72 | 0, t[Ce >> 2] = t[a >> 2], t[Ce + 4 >> 2] = l, t[K + 544 >> 2] = b, l = t[w + 4 >> 2], t[K + 424 >> 2] = t[w >> 2], t[K + 428 >> 2] = l, l = t[w + 44 >> 2], t[K + 464 >> 2] = t[w + 40 >> 2], t[K + 468 >> 2] = l, b = Mn + 112 | 0, a = t[b + 4 >> 2], l = jr + 112 | 0, t[l >> 2] = t[b >> 2], t[l + 4 >> 2] = a, b = Mn + 104 | 0, a = t[b + 4 >> 2], l = jr + 104 | 0, t[l >> 2] = t[b >> 2], t[l + 4 >> 2] = a, b = Mn + 96 | 0, a = t[b + 4 >> 2], l = jr + 96 | 0, t[l >> 2] = t[b >> 2], t[l + 4 >> 2] = a, b = Mn + 88 | 0, a = t[b + 4 >> 2], l = jr + 88 | 0, t[l >> 2] = t[b >> 2], t[l + 4 >> 2] = a, pe = t[Mn + 80 >> 2], P = t[Mn + 84 >> 2], l = t[K + 636 >> 2], t[Ss >> 2] = t[K + 632 >> 2], t[Ss + 4 >> 2] = l, b = Ki + 88 | 0, a = t[b + 4 >> 2], l = Ss + 8 | 0, t[l >> 2] = t[b >> 2], t[l + 4 >> 2] = a, b = Ki + 96 | 0, a = t[b + 4 >> 2], l = Ss + 16 | 0, t[l >> 2] = t[b >> 2], t[l + 4 >> 2] = a, b = Ki + 104 | 0, a = t[b + 4 >> 2], l = Ss + 24 | 0, t[l >> 2] = t[b >> 2], t[l + 4 >> 2] = a, b = Ki + 112 | 0, a = t[b + 4 >> 2], l = Ss + 32 | 0, t[l >> 2] = t[b >> 2], t[l + 4 >> 2] = a, t[K + 504 >> 2] = pe, t[K + 508 >> 2] = P, Fn(jr, jr, Es, Ss + 40 | 0), t[w + 168 >> 2] = 0, l = t[K + 428 >> 2], t[w + 88 >> 2] = t[K + 424 >> 2], t[w + 92 >> 2] = l, a = t[Yr + 4 >> 2], l = w + 96 | 0, t[l >> 2] = t[Yr >> 2], t[l + 4 >> 2] = a, a = t[Nr + 4 >> 2], l = w + 104 | 0, t[l >> 2] = t[Nr >> 2], t[l + 4 >> 2] = a, a = t[or + 4 >> 2], l = w + 112 | 0, t[l >> 2] = t[or >> 2], t[l + 4 >> 2] = a, a = t[gr + 4 >> 2], l = w + 120 | 0, t[l >> 2] = t[gr >> 2], t[l + 4 >> 2] = a, a = t[K + 468 >> 2], l = w + 128 | 0, t[l >> 2] = t[K + 464 >> 2], t[l + 4 >> 2] = a, a = t[Tt + 4 >> 2], l = w + 136 | 0, t[l >> 2] = t[Tt >> 2], t[l + 4 >> 2] = a, a = t[tr + 4 >> 2], l = w + 144 | 0, t[l >> 2] = t[tr >> 2], t[l + 4 >> 2] = a, a = t[lr + 4 >> 2], l = w + 152 | 0, t[l >> 2] = t[lr >> 2], t[l + 4 >> 2] = a, a = t[Ce + 4 >> 2], l = w + 160 | 0, t[l >> 2] = t[Ce >> 2], t[l + 4 >> 2] = a, Fn(jr, jr, Es, Ss + 80 | 0), t[w + 256 >> 2] = 0, l = t[K + 428 >> 2], t[w + 176 >> 2] = t[K + 424 >> 2], t[w + 180 >> 2] = l, a = t[Yr + 4 >> 2], l = w + 184 | 0, t[l >> 2] = t[Yr >> 2], t[l + 4 >> 2] = a, a = t[Nr + 4 >> 2], l = w + 192 | 0, t[l >> 2] = t[Nr >> 2], t[l + 4 >> 2] = a, a = t[or + 4 >> 2], l = w + 200 | 0, t[l >> 2] = t[or >> 2], t[l + 4 >> 2] = a, a = t[gr + 4 >> 2], l = w + 208 | 0, t[l >> 2] = t[gr >> 2], t[l + 4 >> 2] = a, a = t[K + 468 >> 2], l = w + 216 | 0, t[l >> 2] = t[K + 464 >> 2], t[l + 4 >> 2] = a, a = t[Tt + 4 >> 2], l = w + 224 | 0, t[l >> 2] = t[Tt >> 2], t[l + 4 >> 2] = a, a = t[tr + 4 >> 2], l = w + 232 | 0, t[l >> 2] = t[tr >> 2], t[l + 4 >> 2] = a, a = t[lr + 4 >> 2], l = w + 240 | 0, t[l >> 2] = t[lr >> 2], t[l + 4 >> 2] = a, a = t[Ce + 4 >> 2], l = w + 248 | 0, t[l >> 2] = t[Ce >> 2], t[l + 4 >> 2] = a, Fn(jr, jr, Es, Ss + 120 | 0), t[w + 344 >> 2] = 0, l = t[K + 428 >> 2], t[w + 264 >> 2] = t[K + 424 >> 2], t[w + 268 >> 2] = l, a = t[Yr + 4 >> 2], l = w + 272 | 0, t[l >> 2] = t[Yr >> 2], t[l + 4 >> 2] = a, a = t[Nr + 4 >> 2], l = w + 280 | 0, t[l >> 2] = t[Nr >> 2], t[l + 4 >> 2] = a, a = t[or + 4 >> 2], l = w + 288 | 0, t[l >> 2] = t[or >> 2], t[l + 4 >> 2] = a, a = t[gr + 4 >> 2], l = w + 296 | 0, t[l >> 2] = t[gr >> 2], t[l + 4 >> 2] = a, a = t[K + 468 >> 2], l = w + 304 | 0, t[l >> 2] = t[K + 464 >> 2], t[l + 4 >> 2] = a, a = t[Tt + 4 >> 2], l = w + 312 | 0, t[l >> 2] = t[Tt >> 2], t[l + 4 >> 2] = a, a = t[tr + 4 >> 2], l = w + 320 | 0, t[l >> 2] = t[tr >> 2], t[l + 4 >> 2] = a, a = t[lr + 4 >> 2], l = w + 328 | 0, t[l >> 2] = t[lr >> 2], t[l + 4 >> 2] = a, a = t[Ce + 4 >> 2], l = w + 336 | 0, t[l >> 2] = t[Ce >> 2], t[l + 4 >> 2] = a, Fn(jr, jr, Es, Ss + 160 | 0), t[w + 432 >> 2] = 0, l = t[K + 428 >> 2], t[w + 352 >> 2] = t[K + 424 >> 2], t[w + 356 >> 2] = l, a = t[Yr + 4 >> 2], l = w + 360 | 0, t[l >> 2] = t[Yr >> 2], t[l + 4 >> 2] = a, a = t[Nr + 4 >> 2], l = w + 368 | 0, t[l >> 2] = t[Nr >> 2], t[l + 4 >> 2] = a, a = t[or + 4 >> 2], l = w + 376 | 0, t[l >> 2] = t[or >> 2], t[l + 4 >> 2] = a, a = t[gr + 4 >> 2], l = w + 384 | 0, t[l >> 2] = t[gr >> 2], t[l + 4 >> 2] = a, a = t[K + 468 >> 2], l = w + 392 | 0, t[l >> 2] = t[K + 464 >> 2], t[l + 4 >> 2] = a, a = t[Tt + 4 >> 2], l = w + 400 | 0, t[l >> 2] = t[Tt >> 2], t[l + 4 >> 2] = a, a = t[tr + 4 >> 2], l = w + 408 | 0, t[l >> 2] = t[tr >> 2], t[l + 4 >> 2] = a, a = t[lr + 4 >> 2], l = w + 416 | 0, t[l >> 2] = t[lr >> 2], t[l + 4 >> 2] = a, a = t[Ce + 4 >> 2], l = w + 424 | 0, t[l >> 2] = t[Ce >> 2], t[l + 4 >> 2] = a, Fn(jr, jr, Es, Ss + 200 | 0), t[w + 520 >> 2] = 0, l = t[K + 428 >> 2], t[w + 440 >> 2] = t[K + 424 >> 2], t[w + 444 >> 2] = l, a = t[Yr + 4 >> 2], l = w + 448 | 0, t[l >> 2] = t[Yr >> 2], t[l + 4 >> 2] = a, a = t[Nr + 4 >> 2], l = w + 456 | 0, t[l >> 2] = t[Nr >> 2], t[l + 4 >> 2] = a, a = t[or + 4 >> 2], l = w + 464 | 0, t[l >> 2] = t[or >> 2], t[l + 4 >> 2] = a, a = t[gr + 4 >> 2], l = w + 472 | 0, t[l >> 2] = t[gr >> 2], t[l + 4 >> 2] = a, a = t[K + 468 >> 2], l = w + 480 | 0, t[l >> 2] = t[K + 464 >> 2], t[l + 4 >> 2] = a, a = t[Tt + 4 >> 2], l = w + 488 | 0, t[l >> 2] = t[Tt >> 2], t[l + 4 >> 2] = a, a = t[tr + 4 >> 2], l = w + 496 | 0, t[l >> 2] = t[tr >> 2], t[l + 4 >> 2] = a, a = t[lr + 4 >> 2], l = w + 504 | 0, t[l >> 2] = t[lr >> 2], t[l + 4 >> 2] = a, a = t[Ce + 4 >> 2], l = w + 512 | 0, t[l >> 2] = t[Ce >> 2], t[l + 4 >> 2] = a, ui = Ss + 240 | 0, Fn(jr, jr, Es, ui), t[w + 608 >> 2] = 0, l = t[K + 428 >> 2], t[w + 528 >> 2] = t[K + 424 >> 2], t[w + 532 >> 2] = l, a = t[Yr + 4 >> 2], l = w + 536 | 0, t[l >> 2] = t[Yr >> 2], t[l + 4 >> 2] = a, a = t[Nr + 4 >> 2], l = w + 544 | 0, t[l >> 2] = t[Nr >> 2], t[l + 4 >> 2] = a, a = t[or + 4 >> 2], l = w + 552 | 0, t[l >> 2] = t[or >> 2], t[l + 4 >> 2] = a, a = t[gr + 4 >> 2], l = w + 560 | 0, t[l >> 2] = t[gr >> 2], t[l + 4 >> 2] = a, a = t[K + 468 >> 2], l = w + 568 | 0, t[l >> 2] = t[K + 464 >> 2], t[l + 4 >> 2] = a, a = t[Tt + 4 >> 2], l = w + 576 | 0, t[l >> 2] = t[Tt >> 2], t[l + 4 >> 2] = a, a = t[tr + 4 >> 2], l = w + 584 | 0, t[l >> 2] = t[tr >> 2], t[l + 4 >> 2] = a, a = t[lr + 4 >> 2], l = w + 592 | 0, t[l >> 2] = t[lr >> 2], t[l + 4 >> 2] = a, a = t[Ce + 4 >> 2], l = w + 600 | 0, t[l >> 2] = t[Ce >> 2], t[l + 4 >> 2] = a, P = Ss + 280 | 0, Fn(jr, jr, Es, P), t[w + 696 >> 2] = 0, l = t[K + 428 >> 2], t[w + 616 >> 2] = t[K + 424 >> 2], t[w + 620 >> 2] = l, a = t[Yr + 4 >> 2], l = w + 624 | 0, t[l >> 2] = t[Yr >> 2], t[l + 4 >> 2] = a, a = t[Nr + 4 >> 2], l = w + 632 | 0, t[l >> 2] = t[Nr >> 2], t[l + 4 >> 2] = a, a = t[or + 4 >> 2], l = w + 640 | 0, t[l >> 2] = t[or >> 2], t[l + 4 >> 2] = a, a = t[gr + 4 >> 2], l = w + 648 | 0, t[l >> 2] = t[gr >> 2], t[l + 4 >> 2] = a, a = t[K + 468 >> 2], l = w + 656 | 0, t[l >> 2] = t[K + 464 >> 2], t[l + 4 >> 2] = a, a = t[Tt + 4 >> 2], l = w + 664 | 0, t[l >> 2] = t[Tt >> 2], t[l + 4 >> 2] = a, a = t[tr + 4 >> 2], l = w + 672 | 0, t[l >> 2] = t[tr >> 2], t[l + 4 >> 2] = a, a = t[lr + 4 >> 2], l = w + 680 | 0, t[l >> 2] = t[lr >> 2], t[l + 4 >> 2] = a, a = t[Ce + 4 >> 2], l = w + 688 | 0, t[l >> 2] = t[Ce >> 2], t[l + 4 >> 2] = a, zr(eo, jr + 80 | 0, nr), U = K + 720 | 0, Tt = U - 928 | 0, U = Tt, pe = w + 616 | 0, K = pe + 72 | 0, b = t[K >> 2], nr = t[pe + 44 >> 2], a = t[pe + 40 >> 2], lr = t[K + 4 >> 2], l = ri(lr >>> 16 | 0, 0, 977, 1), Ce = a + l | 0, a = nr + ve | 0, t[pe + 40 >> 2] = Ce, a = l >>> 0 > Ce >>> 0 ? a + 1 | 0 : a, t[pe + 44 >> 2] = a & 1048575, tr = pe + 48 | 0, Ce = t[tr >> 2], l = a, a = t[tr + 4 >> 2], l = l >>> 20 | 0, nr = l, l = l + Ce | 0, a = nr >>> 0 > l >>> 0 ? a + 1 | 0 : a, t[tr >> 2] = l, t[tr + 4 >> 2] = a & 1048575, tr = pe + 56 | 0, Ce = t[tr >> 2], l = a, a = t[tr + 4 >> 2], l = l >>> 20 | 0, nr = l, l = l + Ce | 0, a = nr >>> 0 > l >>> 0 ? a + 1 | 0 : a, t[tr >> 2] = l, t[tr + 4 >> 2] = a & 1048575, Ce = pe - -64 | 0, nr = t[Ce >> 2], l = a, a = t[Ce + 4 >> 2], l = l >>> 20 | 0, pe = l, l = l + nr | 0, a = pe >>> 0 > l >>> 0 ? a + 1 | 0 : a, t[Ce >> 2] = l, t[Ce + 4 >> 2] = a & 1048575, pe = K, l = a, a = lr & 65535, l = l >>> 20 | 0, K = l, l = l + b | 0, a = K >>> 0 > l >>> 0 ? a + 1 | 0 : a, t[pe >> 2] = l, t[pe + 4 >> 2] = a, b = P + 8 | 0, a = t[b + 4 >> 2], es = Tt + 808 | 0, l = es + 8 | 0, t[l >> 2] = t[b >> 2], t[l + 4 >> 2] = a, b = P + 16 | 0, a = t[b + 4 >> 2], l = es + 16 | 0, t[l >> 2] = t[b >> 2], t[l + 4 >> 2] = a, b = P + 24 | 0, a = t[b + 4 >> 2], l = es + 24 | 0, t[l >> 2] = t[b >> 2], t[l + 4 >> 2] = a, b = P + 32 | 0, a = t[b + 4 >> 2], l = es + 32 | 0, t[l >> 2] = t[b >> 2], t[l + 4 >> 2] = a, l = t[P + 4 >> 2], t[Tt + 808 >> 2] = t[P >> 2], t[Tt + 812 >> 2] = l, eo = 6, Xi = w + 528 | 0, b = Xi + 8 | 0, a = t[b + 4 >> 2], Dn = Tt + 680 | 0, l = Dn + 8 | 0, t[l >> 2] = t[b >> 2], t[l + 4 >> 2] = a, b = Xi + 16 | 0, a = t[b + 4 >> 2], l = Dn + 16 | 0, t[l >> 2] = t[b >> 2], t[l + 4 >> 2] = a, b = Xi + 24 | 0, a = t[b + 4 >> 2], l = Dn + 24 | 0, t[l >> 2] = t[b >> 2], t[l + 4 >> 2] = a, b = Xi + 32 | 0, a = t[b + 4 >> 2], l = Dn + 32 | 0, t[l >> 2] = t[b >> 2], t[l + 4 >> 2] = a, b = Xi + 48 | 0, a = t[b + 4 >> 2], l = Dn + 48 | 0, t[l >> 2] = t[b >> 2], t[l + 4 >> 2] = a, b = Xi + 56 | 0, a = t[b + 4 >> 2], l = Dn + 56 | 0, t[l >> 2] = t[b >> 2], t[l + 4 >> 2] = a, b = Xi - -64 | 0, a = t[b + 4 >> 2], l = Dn - -64 | 0, t[l >> 2] = t[b >> 2], t[l + 4 >> 2] = a, b = Xi + 72 | 0, a = t[b + 4 >> 2], l = Dn + 72 | 0, t[l >> 2] = t[b >> 2], t[l + 4 >> 2] = a, l = t[Xi + 4 >> 2], t[Tt + 680 >> 2] = t[Xi >> 2], t[Tt + 684 >> 2] = l, l = t[Xi + 44 >> 2], t[Tt + 720 >> 2] = t[Xi + 40 >> 2], t[Tt + 724 >> 2] = l, gr = t[Tt + 840 >> 2], K = t[Tt + 844 >> 2], b = t[Tt + 824 >> 2], nr = t[Tt + 828 >> 2], Li = t[Tt + 816 >> 2], kr = t[Tt + 820 >> 2], pe = t[Tt + 832 >> 2], P = t[Tt + 836 >> 2], tr = t[Tt + 808 >> 2], lr = t[Tt + 812 >> 2], t[Tt + 800 >> 2] = 0, Ii = Tt + 440 | 0, $i = tr << 1, fs = lr << 1 | tr >>> 31, Pr(Ii, pe, P, 0, 0, $i, fs, 0, 0), di = Tt + 504 | 0, l = nr, nr = Li << 1, Ce = kr << 1 | Li >>> 31, Pr(di, b, l, 0, 0, nr, Ce, 0, 0), Yr = Tt + 632 | 0, a = K, Pr(Yr, gr, a, 0, 0, gr, a, 0, 0), Nr = Tt + 616 | 0, Pr(Nr, t[Tt + 632 >> 2], t[Tt + 636 >> 2], 0, 0, 15632, 16, 0, 0), K = gr, a = a << 1 | K >>> 31, ns = Tt + 472 | 0, Ti = K << 1, Ei = a, Pr(ns, Ti, a, 0, 0, tr, lr, 0, 0), ps = Tt + 488 | 0, Pr(ps, pe, P, 0, 0, nr, Ce, 0, 0), In = Tt + 568 | 0, Pr(In, b, l, 0, 0, b, l, 0, 0), gr = Tt + 600 | 0, a = Yr + 8 | 0, Pr(gr, t[a >> 2], t[a + 4 >> 2], 0, 0, 64028672, 65536, 0, 0), Ps = Tt + 456 | 0, Pr(Ps, tr, lr, 0, 0, tr, lr, 0, 0), xs = Tt + 536 | 0, Pr(xs, Ti, Ei, 0, 0, Li, kr, 0, 0), ei = l, Qi = b, a = l << 1 | b >>> 31, Bs = Tt + 584 | 0, wi = pe, ai = P, Pr(Bs, pe, P, 0, 0, b << 1, a, 0, 0), pe = t[Tt + 440 >> 2], b = t[Tt + 504 >> 2], l = pe + b | 0, lr = t[Tt + 444 >> 2], a = lr + t[Tt + 508 >> 2] | 0, a = l >>> 0 < b >>> 0 ? a + 1 | 0 : a, b = t[Tt + 616 >> 2], jr = b + l | 0, P = a, a = a + t[Tt + 620 >> 2] | 0, b = b >>> 0 > jr >>> 0 ? a + 1 | 0 : a, Ce = (P | 0) == (b | 0) & l >>> 0 > jr >>> 0 | b >>> 0 < P >>> 0, a = Nr + 8 | 0, nr = t[a >> 2], K = t[a + 4 >> 2], pe = (P | 0) == (lr | 0) & l >>> 0 < pe >>> 0 | P >>> 0 < lr >>> 0, a = di + 8 | 0, P = t[a >> 2], l = Ii + 8 | 0, lr = P + t[l >> 2] | 0, a = t[l + 4 >> 2] + t[a + 4 >> 2] | 0, a = P >>> 0 > lr >>> 0 ? a + 1 | 0 : a, l = pe + lr | 0, a = (l >>> 0 < lr >>> 0 ? a + 1 | 0 : a) + K | 0, P = l, l = l + nr | 0, a = P >>> 0 > l >>> 0 ? a + 1 | 0 : a, P = l, l = l + Ce | 0, a = P >>> 0 > l >>> 0 ? a + 1 | 0 : a, Yr = b, nr = l << 12 | b >>> 20, pe = a, K = a << 12 | l >>> 20, zn = t[Tt + 488 >> 2], l = t[Tt + 568 >> 2], tr = zn + l | 0, kn = t[Tt + 492 >> 2], a = kn + t[Tt + 572 >> 2] | 0, a = l >>> 0 > tr >>> 0 ? a + 1 | 0 : a, l = t[Tt + 472 >> 2], lr = l + tr | 0, P = a, a = a + t[Tt + 476 >> 2] | 0, a = l >>> 0 > lr >>> 0 ? a + 1 | 0 : a, l = t[Tt + 600 >> 2], Ce = l + lr | 0, b = a, a = a + t[Tt + 604 >> 2] | 0, l = l >>> 0 > Ce >>> 0 ? a + 1 | 0 : a, a = l + K | 0, Wi = Tt + 376 | 0, Di = Wi, nr = Ce + nr | 0, K = nr >>> 0 < Ce >>> 0 ? a + 1 | 0 : a, Ii = (l | 0) == (K | 0) & Ce >>> 0 > nr >>> 0 | l >>> 0 > K >>> 0, di = (l | 0) == (b | 0) & Ce >>> 0 < lr >>> 0 | l >>> 0 < b >>> 0, l = gr + 8 | 0, Nr = t[l >> 2], or = t[l + 4 >> 2], gr = (b | 0) == (P | 0) & tr >>> 0 > lr >>> 0 | b >>> 0 < P >>> 0, l = ns + 8 | 0, lr = t[l >> 2], Ce = t[l + 4 >> 2], P = (P | 0) == (kn | 0) & tr >>> 0 < zn >>> 0 | P >>> 0 < kn >>> 0, a = In + 8 | 0, b = t[a >> 2], l = ps + 8 | 0, tr = b + t[l >> 2] | 0, a = t[l + 4 >> 2] + t[a + 4 >> 2] | 0, a = b >>> 0 > tr >>> 0 ? a + 1 | 0 : a, l = P + tr | 0, a = (l >>> 0 < tr >>> 0 ? a + 1 | 0 : a) + Ce | 0, b = l, l = l + lr | 0, a = b >>> 0 > l >>> 0 ? a + 1 | 0 : a, b = l, l = l + gr | 0, a = (b >>> 0 > l >>> 0 ? a + 1 | 0 : a) + or | 0, b = l, l = l + Nr | 0, a = b >>> 0 > l >>> 0 ? a + 1 | 0 : a, b = l + di | 0, a = b >>> 0 < l >>> 0 ? a + 1 | 0 : a, P = pe >>> 20 | 0, l = b + P | 0, a = P >>> 0 > l >>> 0 ? a + 1 | 0 : a, b = l, l = l + Ii | 0, a = b >>> 0 > l >>> 0 ? a + 1 | 0 : a, b = K, K = l << 12 | b >>> 20, P = a, Ce = a << 12 | l >>> 20, Ii = t[Tt + 540 >> 2], a = Ii + t[Tt + 588 >> 2] | 0, or = t[Tt + 536 >> 2], l = t[Tt + 584 >> 2], pe = or + l | 0, tr = pe, K = pe + K | 0, l = l >>> 0 > pe >>> 0 ? a + 1 | 0 : a, a = l + Ce | 0, lr = K << 4 & -16, pe = K >>> 0 < pe >>> 0 ? a + 1 | 0 : a, Ce = (pe << 4 | K >>> 28) & 16777215, Nr = b, Pr(Di, lr | b >>> 16 & 15, Ce, 0, 0, 977, 1, 0, 0), Ce = Tt, Di = t[Ce + 376 >> 2], b = t[Ce + 456 >> 2], lr = Di + b | 0, vs = t[Ce + 380 >> 2], a = vs + t[Ce + 460 >> 2] | 0, t[Ce + 888 >> 2] = lr, b = b >>> 0 > lr >>> 0 ? a + 1 | 0 : a, t[Ce + 892 >> 2] = b & 1048575, kn = Ce + 360 | 0, Pr(kn, Li, kr, 0, 0, $i, fs, 0, 0), ns = Ce + 552 | 0, Pr(ns, Ti, Ei, 0, 0, Qi, ei, 0, 0), ps = Ce + 664 | 0, Pr(ps, wi, ai, 0, 0, wi, ai, 0, 0), In = Ce + 424 | 0, di = In, gr = (l | 0) == (pe | 0) & K >>> 0 < tr >>> 0 | l >>> 0 > pe >>> 0, tr = (l | 0) == (Ii | 0) & or >>> 0 > tr >>> 0 | l >>> 0 < Ii >>> 0, a = Bs + 8 | 0, K = t[a >> 2], l = xs + 8 | 0, or = K + t[l >> 2] | 0, a = t[l + 4 >> 2] + t[a + 4 >> 2] | 0, a = K >>> 0 > or >>> 0 ? a + 1 | 0 : a, K = or + tr | 0, a = K >>> 0 < or >>> 0 ? a + 1 | 0 : a, P = P >>> 20 | 0, l = P + K | 0, a = P >>> 0 > l >>> 0 ? a + 1 | 0 : a, P = l, l = l + gr | 0, a = P >>> 0 > l >>> 0 ? a + 1 | 0 : a, tr = l << 12 | pe >>> 20, K = a, P = a << 12 | l >>> 20, zn = t[Ce + 552 >> 2], l = t[Ce + 664 >> 2], Ii = zn + l | 0, xs = t[Ce + 556 >> 2], a = xs + t[Ce + 668 >> 2] | 0, pe = l >>> 0 > Ii >>> 0 ? a + 1 | 0 : a, a = pe + P | 0, or = tr + Ii | 0, a = or >>> 0 < Ii >>> 0 ? a + 1 | 0 : a, tr = a, Pr(di, or, a & 1048575, 0, 0, 15632, 16, 0, 0), lr = (b | 0) == (vs | 0) & lr >>> 0 < Di >>> 0 | b >>> 0 < vs >>> 0, a = Ps + 8 | 0, P = t[a >> 2], l = Wi + 8 | 0, gr = P + t[l >> 2] | 0, a = t[l + 4 >> 2] + t[a + 4 >> 2] | 0, a = P >>> 0 > gr >>> 0 ? a + 1 | 0 : a, l = lr + gr | 0, a = l >>> 0 < gr >>> 0 ? a + 1 | 0 : a, gr = l << 12 | b >>> 20, P = a, lr = a << 12 | l >>> 20, Wi = t[Ce + 424 >> 2], l = t[Ce + 360 >> 2], di = Wi + l | 0, Bs = t[Ce + 428 >> 2], a = Bs + t[Ce + 364 >> 2] | 0, b = l >>> 0 > di >>> 0 ? a + 1 | 0 : a, a = b + lr | 0, gr = gr + di | 0, a = gr >>> 0 < di >>> 0 ? a + 1 | 0 : a, t[Ce + 896 >> 2] = gr, lr = a, t[Ce + 900 >> 2] = a & 1048575, Di = Ce + 344 | 0, Pr(Di, Qi, ei, 0, 0, $i, fs, 0, 0), $i = Ce + 520 | 0, Pr($i, Li, kr, 0, 0, Li, kr, 0, 0), Li = Ce + 648 | 0, Pr(Li, Ti, Ei, 0, 0, wi, ai, 0, 0), Qi = Ce + 408 | 0, wi = Qi, ei = (pe | 0) == (tr | 0) & or >>> 0 < Ii >>> 0 | pe >>> 0 > tr >>> 0, or = (pe | 0) == (xs | 0) & Ii >>> 0 < zn >>> 0 | pe >>> 0 < xs >>> 0, a = ps + 8 | 0, pe = t[a >> 2], l = ns + 8 | 0, ai = pe + t[l >> 2] | 0, a = t[l + 4 >> 2] + t[a + 4 >> 2] | 0, a = pe >>> 0 > ai >>> 0 ? a + 1 | 0 : a, pe = or + ai | 0, a = pe >>> 0 < ai >>> 0 ? a + 1 | 0 : a, K = K >>> 20 | 0, l = K + pe | 0, a = K >>> 0 > l >>> 0 ? a + 1 | 0 : a, K = l, l = l + ei | 0, a = K >>> 0 > l >>> 0 ? a + 1 | 0 : a, ai = l << 12 | tr >>> 20, K = t[Ce + 648 >> 2], tr = ai + K | 0, pe = a, Ii = a << 12 | l >>> 20, a = Ii + t[Ce + 652 >> 2] | 0, ei = K >>> 0 > tr >>> 0 ? a + 1 | 0 : a, Pr(wi, tr, ei, 0, 0, 15632, 16, 0, 0), K = Ce, gr = (b | 0) == (lr | 0) & gr >>> 0 < di >>> 0 | b >>> 0 > lr >>> 0, Ce = (b | 0) == (Bs | 0) & di >>> 0 < Wi >>> 0 | b >>> 0 < Bs >>> 0, a = kn + 8 | 0, b = t[a >> 2], l = In + 8 | 0, or = b + t[l >> 2] | 0, a = t[l + 4 >> 2] + t[a + 4 >> 2] | 0, a = b >>> 0 > or >>> 0 ? a + 1 | 0 : a, b = Ce + or | 0, a = b >>> 0 < or >>> 0 ? a + 1 | 0 : a, P = P >>> 20 | 0, l = b + P | 0, a = P >>> 0 > l >>> 0 ? a + 1 | 0 : a, b = l, l = l + gr | 0, a = b >>> 0 > l >>> 0 ? a + 1 | 0 : a, lr = l << 12 | lr >>> 20, P = a, Ce = a << 12 | l >>> 20, kr = t[K + 344 >> 2], l = t[K + 520 >> 2], or = kr + l | 0, di = t[K + 348 >> 2], a = di + t[K + 524 >> 2] | 0, a = l >>> 0 > or >>> 0 ? a + 1 | 0 : a, l = t[K + 408 >> 2], gr = l + or | 0, b = a, a = a + t[K + 412 >> 2] | 0, l = l >>> 0 > gr >>> 0 ? a + 1 | 0 : a, a = l + Ce | 0, lr = lr + gr | 0, a = lr >>> 0 < gr >>> 0 ? a + 1 | 0 : a, t[K + 904 >> 2] = lr, Ce = a, t[K + 908 >> 2] = a & 1048575, wi = K + 392 | 0, ai = (ei | 0) == (Ii | 0) & tr >>> 0 < ai >>> 0 | ei >>> 0 < Ii >>> 0, a = Li + 8 | 0, ei = t[a >> 2], a = t[a + 4 >> 2], pe = pe >>> 20 | 0, tr = pe, pe = pe + ei | 0, a = tr >>> 0 > pe >>> 0 ? a + 1 | 0 : a, tr = pe, pe = pe + ai | 0, a = tr >>> 0 > pe >>> 0 ? a + 1 | 0 : a, Pr(wi, pe, a, 0, 0, 64028672, 65536, 0, 0), pe = K, ei = (l | 0) == (Ce | 0) & lr >>> 0 < gr >>> 0 | l >>> 0 > Ce >>> 0, gr = (l | 0) == (b | 0) & or >>> 0 > gr >>> 0 | l >>> 0 < b >>> 0, l = Qi + 8 | 0, tr = t[l >> 2], lr = t[l + 4 >> 2], K = (b | 0) == (di | 0) & or >>> 0 < kr >>> 0 | b >>> 0 < di >>> 0, a = $i + 8 | 0, b = t[a >> 2], l = Di + 8 | 0, or = b + t[l >> 2] | 0, a = t[l + 4 >> 2] + t[a + 4 >> 2] | 0, a = b >>> 0 > or >>> 0 ? a + 1 | 0 : a, l = K + or | 0, a = (l >>> 0 < or >>> 0 ? a + 1 | 0 : a) + lr | 0, b = l, l = l + tr | 0, a = b >>> 0 > l >>> 0 ? a + 1 | 0 : a, b = l + gr | 0, a = b >>> 0 < l >>> 0 ? a + 1 | 0 : a, P = P >>> 20 | 0, l = b + P | 0, a = P >>> 0 > l >>> 0 ? a + 1 | 0 : a, b = l, l = l + ei | 0, a = b >>> 0 > l >>> 0 ? a + 1 | 0 : a, K = l << 12 | Ce >>> 20, P = a, lr = a << 12 | l >>> 20, gr = t[pe + 396 >> 2], a = gr + (Yr & 1048575) | 0, tr = t[pe + 392 >> 2], b = jr & -2, l = tr + b | 0, Ce = l, K = l + K | 0, b = l >>> 0 < b >>> 0 ? a + 1 | 0 : a, a = b + lr | 0, t[pe + 912 >> 2] = K, l = l >>> 0 > K >>> 0 ? a + 1 | 0 : a, t[pe + 916 >> 2] = l & 1048575, lr = Nr & 65535, K = (l | 0) == (b | 0) & Ce >>> 0 > K >>> 0 | l >>> 0 < b >>> 0, b = (b | 0) == (gr | 0) & Ce >>> 0 < tr >>> 0 | b >>> 0 < gr >>> 0, a = wi + 8 | 0, pe = b + t[a >> 2] | 0, a = t[a + 4 >> 2], a = b >>> 0 > pe >>> 0 ? a + 1 | 0 : a, P = P >>> 20 | 0, b = P + pe | 0, a = P >>> 0 > b >>> 0 ? a + 1 | 0 : a, P = b, b = b + K | 0, a = P >>> 0 > b >>> 0 ? a + 1 | 0 : a, l = b << 12 | l >>> 20, P = l + nr | 0, a = lr + (a << 12 | b >>> 20) | 0, t[Tt + 920 >> 2] = P, t[Tt + 924 >> 2] = l >>> 0 > P >>> 0 ? a + 1 | 0 : a, a = Tt + 848 | 0, l = Tt + 888 | 0, zr(a, l, es), zr(Xi, Dn, l), Mn = Dn + 40 | 0, zr(Xi + 40 | 0, Mn, a), t[Xi + 80 >> 2] = 0, $i = ui, Ki = w + 440 | 0; vs = Tt + 808 | 0, zr(vs, vs, $i), b = Ki + 32 | 0, a = t[b + 4 >> 2], Xi = Tt + 680 | 0, l = Xi + 32 | 0, t[l >> 2] = t[b >> 2], t[l + 4 >> 2] = a, b = Ki + 24 | 0, a = t[b + 4 >> 2], l = Xi + 24 | 0, t[l >> 2] = t[b >> 2], t[l + 4 >> 2] = a, b = Ki + 16 | 0, a = t[b + 4 >> 2], l = Xi + 16 | 0, t[l >> 2] = t[b >> 2], t[l + 4 >> 2] = a, b = Ki + 8 | 0, a = t[b + 4 >> 2], l = Xi + 8 | 0, t[l >> 2] = t[b >> 2], t[l + 4 >> 2] = a, Ps = Ki + 40 | 0, l = t[Ps + 4 >> 2], t[Mn >> 2] = t[Ps >> 2], t[Mn + 4 >> 2] = l, b = Ki + 48 | 0, a = t[b + 4 >> 2], l = Mn + 8 | 0, t[l >> 2] = t[b >> 2], t[l + 4 >> 2] = a, b = Ki + 56 | 0, a = t[b + 4 >> 2], l = Mn + 16 | 0, t[l >> 2] = t[b >> 2], t[l + 4 >> 2] = a, b = Ki - -64 | 0, a = t[b + 4 >> 2], l = Mn + 24 | 0, t[l >> 2] = t[b >> 2], t[l + 4 >> 2] = a, b = Ki + 72 | 0, a = t[b + 4 >> 2], l = Mn + 32 | 0, t[l >> 2] = t[b >> 2], t[l + 4 >> 2] = a, l = t[Ki + 4 >> 2], t[Tt + 680 >> 2] = t[Ki >> 2], t[Tt + 684 >> 2] = l, t[Tt + 800 >> 2] = 0, l = t[Tt + 812 >> 2], Nr = l, or = t[Tt + 808 >> 2], K = or, a = l << 1 | K >>> 31, tr = Tt + 72 | 0, wi = t[Tt + 832 >> 2], ai = t[Tt + 836 >> 2], Ii = K << 1, Qi = a, Pr(tr, wi, ai, 0, 0, Ii, a, 0, 0), l = t[Tt + 820 >> 2], Dn = l, es = t[Tt + 816 >> 2], b = es, a = l << 1 | b >>> 31, lr = Tt + 280 | 0, ui = t[Tt + 824 >> 2], ei = t[Tt + 828 >> 2], b = b << 1, P = a, Pr(lr, ui, ei, 0, 0, b, a, 0, 0), Ce = Tt + 232 | 0, pe = t[Tt + 840 >> 2], l = t[Tt + 844 >> 2], Pr(Ce, pe, l, 0, 0, pe, l, 0, 0), nr = Tt + 216 | 0, Pr(nr, t[Tt + 232 >> 2], t[Tt + 236 >> 2], 0, 0, 15632, 16, 0, 0), a = l << 1 | pe >>> 31, In = Tt + 184 | 0, Li = pe << 1, di = a, Pr(In, Li, a, 0, 0, K, Nr, 0, 0), zn = Tt + 88 | 0, Pr(zn, wi, ai, 0, 0, b, P, 0, 0), Wi = Tt + 264 | 0, Pr(Wi, ui, ei, 0, 0, ui, ei, 0, 0), gr = Tt + 200 | 0, l = Ce + 8 | 0, Pr(gr, t[l >> 2], t[l + 4 >> 2], 0, 0, 64028672, 65536, 0, 0), Bs = Tt + 328 | 0, Pr(Bs, K, Nr, 0, 0, K, Nr, 0, 0), kn = Tt + 168 | 0, Pr(kn, Li, a, 0, 0, es, Dn, 0, 0), ns = Tt + 104 | 0, Pr(ns, wi, ai, 0, 0, ui << 1, ei << 1 | ui >>> 31, 0, 0), pe = t[Tt + 72 >> 2], b = t[Tt + 280 >> 2], l = pe + b | 0, or = t[Tt + 76 >> 2], a = or + t[Tt + 284 >> 2] | 0, a = l >>> 0 < b >>> 0 ? a + 1 | 0 : a, b = t[Tt + 216 >> 2], jr = b + l | 0, P = a, a = a + t[Tt + 220 >> 2] | 0, b = b >>> 0 > jr >>> 0 ? a + 1 | 0 : a, Ce = (P | 0) == (b | 0) & l >>> 0 > jr >>> 0 | b >>> 0 < P >>> 0, a = nr + 8 | 0, nr = t[a >> 2], K = t[a + 4 >> 2], pe = (P | 0) == (or | 0) & l >>> 0 < pe >>> 0 | P >>> 0 < or >>> 0, a = lr + 8 | 0, P = t[a >> 2], l = tr + 8 | 0, lr = P + t[l >> 2] | 0, a = t[l + 4 >> 2] + t[a + 4 >> 2] | 0, a = P >>> 0 > lr >>> 0 ? a + 1 | 0 : a, l = pe + lr | 0, a = (l >>> 0 < lr >>> 0 ? a + 1 | 0 : a) + K | 0, P = l, l = l + nr | 0, a = P >>> 0 > l >>> 0 ? a + 1 | 0 : a, P = l, l = l + Ce | 0, a = P >>> 0 > l >>> 0 ? a + 1 | 0 : a, Yr = b, nr = l << 12 | b >>> 20, pe = a, K = a << 12 | l >>> 20, Di = t[Tt + 88 >> 2], l = t[Tt + 264 >> 2], tr = Di + l | 0, ps = t[Tt + 92 >> 2], a = ps + t[Tt + 268 >> 2] | 0, a = l >>> 0 > tr >>> 0 ? a + 1 | 0 : a, l = t[Tt + 184 >> 2], lr = l + tr | 0, P = a, a = a + t[Tt + 188 >> 2] | 0, a = l >>> 0 > lr >>> 0 ? a + 1 | 0 : a, l = t[Tt + 200 >> 2], Ce = l + lr | 0, b = a, a = a + t[Tt + 204 >> 2] | 0, l = l >>> 0 > Ce >>> 0 ? a + 1 | 0 : a, a = l + K | 0, Ti = Tt + 8 | 0, nr = Ce + nr | 0, K = nr >>> 0 < Ce >>> 0 ? a + 1 | 0 : a, Ei = (l | 0) == (K | 0) & Ce >>> 0 > nr >>> 0 | l >>> 0 > K >>> 0, kr = (l | 0) == (b | 0) & Ce >>> 0 < lr >>> 0 | l >>> 0 < b >>> 0, l = gr + 8 | 0, Nr = t[l >> 2], or = t[l + 4 >> 2], gr = (b | 0) == (P | 0) & tr >>> 0 > lr >>> 0 | b >>> 0 < P >>> 0, l = In + 8 | 0, lr = t[l >> 2], Ce = t[l + 4 >> 2], P = (P | 0) == (ps | 0) & tr >>> 0 < Di >>> 0 | P >>> 0 < ps >>> 0, a = Wi + 8 | 0, b = t[a >> 2], l = zn + 8 | 0, tr = b + t[l >> 2] | 0, a = t[l + 4 >> 2] + t[a + 4 >> 2] | 0, a = b >>> 0 > tr >>> 0 ? a + 1 | 0 : a, l = P + tr | 0, a = (l >>> 0 < tr >>> 0 ? a + 1 | 0 : a) + Ce | 0, b = l, l = l + lr | 0, a = b >>> 0 > l >>> 0 ? a + 1 | 0 : a, b = l, l = l + gr | 0, a = (b >>> 0 > l >>> 0 ? a + 1 | 0 : a) + or | 0, b = l, l = l + Nr | 0, a = b >>> 0 > l >>> 0 ? a + 1 | 0 : a, b = l + kr | 0, a = b >>> 0 < l >>> 0 ? a + 1 | 0 : a, P = pe >>> 20 | 0, l = b + P | 0, a = P >>> 0 > l >>> 0 ? a + 1 | 0 : a, b = l, l = l + Ei | 0, a = b >>> 0 > l >>> 0 ? a + 1 | 0 : a, b = K, K = l << 12 | b >>> 20, P = a, Ce = a << 12 | l >>> 20, Ei = t[Tt + 172 >> 2], a = Ei + t[Tt + 108 >> 2] | 0, or = t[Tt + 168 >> 2], l = t[Tt + 104 >> 2], pe = or + l | 0, tr = pe, K = pe + K | 0, l = l >>> 0 > pe >>> 0 ? a + 1 | 0 : a, a = l + Ce | 0, lr = K << 4 & -16, pe = K >>> 0 < pe >>> 0 ? a + 1 | 0 : a, Ce = (pe << 4 | K >>> 28) & 16777215, Nr = b, Pr(Ti, lr | b >>> 16 & 15, Ce, 0, 0, 977, 1, 0, 0), Ce = Tt, fs = t[Ce + 8 >> 2], b = t[Ce + 328 >> 2], lr = fs + b | 0, xs = t[Ce + 12 >> 2], a = xs + t[Ce + 332 >> 2] | 0, t[Ce + 888 >> 2] = lr, b = b >>> 0 > lr >>> 0 ? a + 1 | 0 : a, t[Ce + 892 >> 2] = b & 1048575, ps = Ce + 312 | 0, Pr(ps, es, Dn, 0, 0, Ii, Qi, 0, 0), In = Ce + 152 | 0, Pr(In, Li, di, 0, 0, ui, ei, 0, 0), zn = Ce + 120 | 0, Pr(zn, wi, ai, 0, 0, wi, ai, 0, 0), Wi = Ce + 56 | 0, kr = Wi, gr = (l | 0) == (pe | 0) & K >>> 0 < tr >>> 0 | l >>> 0 > pe >>> 0, tr = (l | 0) == (Ei | 0) & or >>> 0 > tr >>> 0 | l >>> 0 < Ei >>> 0, a = ns + 8 | 0, K = t[a >> 2], l = kn + 8 | 0, or = K + t[l >> 2] | 0, a = t[l + 4 >> 2] + t[a + 4 >> 2] | 0, a = K >>> 0 > or >>> 0 ? a + 1 | 0 : a, K = or + tr | 0, a = K >>> 0 < or >>> 0 ? a + 1 | 0 : a, P = P >>> 20 | 0, l = P + K | 0, a = P >>> 0 > l >>> 0 ? a + 1 | 0 : a, P = l, l = l + gr | 0, a = P >>> 0 > l >>> 0 ? a + 1 | 0 : a, gr = l << 12 | pe >>> 20, K = a, tr = a << 12 | l >>> 20, kn = t[Ce + 156 >> 2], a = kn + t[Ce + 124 >> 2] | 0, Di = t[Ce + 152 >> 2], P = t[Ce + 120 >> 2], l = Di + P | 0, Ei = l, or = l + gr | 0, pe = l >>> 0 < P >>> 0 ? a + 1 | 0 : a, a = pe + tr | 0, tr = or >>> 0 < l >>> 0 ? a + 1 | 0 : a, Pr(kr, or, tr & 1048575, 0, 0, 15632, 16, 0, 0), lr = (b | 0) == (xs | 0) & lr >>> 0 < fs >>> 0 | b >>> 0 < xs >>> 0, a = Bs + 8 | 0, P = t[a >> 2], l = Ti + 8 | 0, gr = P + t[l >> 2] | 0, a = t[l + 4 >> 2] + t[a + 4 >> 2] | 0, a = P >>> 0 > gr >>> 0 ? a + 1 | 0 : a, l = lr + gr | 0, a = l >>> 0 < gr >>> 0 ? a + 1 | 0 : a, gr = l << 12 | b >>> 20, P = a, lr = a << 12 | l >>> 20, Ti = t[Ce + 56 >> 2], l = t[Ce + 312 >> 2], kr = Ti + l | 0, ns = t[Ce + 60 >> 2], a = ns + t[Ce + 316 >> 2] | 0, b = l >>> 0 > kr >>> 0 ? a + 1 | 0 : a, a = b + lr | 0, gr = gr + kr | 0, a = gr >>> 0 < kr >>> 0 ? a + 1 | 0 : a, t[Ce + 896 >> 2] = gr, lr = a, t[Ce + 900 >> 2] = a & 1048575, fs = Ce + 248 | 0, Pr(fs, ui, ei, 0, 0, Ii, Qi, 0, 0), Qi = Ce + 296 | 0, Pr(Qi, es, Dn, 0, 0, es, Dn, 0, 0), Ii = Ce + 136 | 0, Pr(Ii, Li, di, 0, 0, wi, ai, 0, 0), ui = Ce + 40 | 0, ei = (pe | 0) == (tr | 0) & or >>> 0 < Ei >>> 0 | pe >>> 0 > tr >>> 0, or = (pe | 0) == (kn | 0) & Ei >>> 0 < Di >>> 0 | pe >>> 0 < kn >>> 0, a = zn + 8 | 0, pe = t[a >> 2], l = In + 8 | 0, ai = pe + t[l >> 2] | 0, a = t[l + 4 >> 2] + t[a + 4 >> 2] | 0, a = pe >>> 0 > ai >>> 0 ? a + 1 | 0 : a, pe = or + ai | 0, a = pe >>> 0 < ai >>> 0 ? a + 1 | 0 : a, K = K >>> 20 | 0, l = K + pe | 0, a = K >>> 0 > l >>> 0 ? a + 1 | 0 : a, K = l, l = l + ei | 0, a = K >>> 0 > l >>> 0 ? a + 1 | 0 : a, ai = l << 12 | tr >>> 20, K = t[Ce + 136 >> 2], tr = ai + K | 0, pe = a, Ei = a << 12 | l >>> 20, a = Ei + t[Ce + 140 >> 2] | 0, ei = K >>> 0 > tr >>> 0 ? a + 1 | 0 : a, Pr(ui, tr, ei, 0, 0, 15632, 16, 0, 0), K = Ce, gr = (b | 0) == (lr | 0) & gr >>> 0 < kr >>> 0 | b >>> 0 > lr >>> 0, Ce = (b | 0) == (ns | 0) & kr >>> 0 < Ti >>> 0 | b >>> 0 < ns >>> 0, a = ps + 8 | 0, b = t[a >> 2], l = Wi + 8 | 0, or = b + t[l >> 2] | 0, a = t[l + 4 >> 2] + t[a + 4 >> 2] | 0, a = b >>> 0 > or >>> 0 ? a + 1 | 0 : a, b = Ce + or | 0, a = b >>> 0 < or >>> 0 ? a + 1 | 0 : a, P = P >>> 20 | 0, l = b + P | 0, a = P >>> 0 > l >>> 0 ? a + 1 | 0 : a, b = l, l = l + gr | 0, a = b >>> 0 > l >>> 0 ? a + 1 | 0 : a, lr = l << 12 | lr >>> 20, P = a, Ce = a << 12 | l >>> 20, kr = t[K + 248 >> 2], l = t[K + 296 >> 2], or = kr + l | 0, di = t[K + 252 >> 2], a = di + t[K + 300 >> 2] | 0, a = l >>> 0 > or >>> 0 ? a + 1 | 0 : a, l = t[K + 40 >> 2], gr = l + or | 0, b = a, a = a + t[K + 44 >> 2] | 0, l = l >>> 0 > gr >>> 0 ? a + 1 | 0 : a, a = l + Ce | 0, lr = lr + gr | 0, a = lr >>> 0 < gr >>> 0 ? a + 1 | 0 : a, t[K + 904 >> 2] = lr, Ce = a, t[K + 908 >> 2] = a & 1048575, wi = K + 24 | 0, ai = (ei | 0) == (Ei | 0) & tr >>> 0 < ai >>> 0 | ei >>> 0 < Ei >>> 0, a = Ii + 8 | 0, ei = t[a >> 2], a = t[a + 4 >> 2], pe = pe >>> 20 | 0, tr = pe, pe = pe + ei | 0, a = tr >>> 0 > pe >>> 0 ? a + 1 | 0 : a, tr = pe, pe = pe + ai | 0, a = tr >>> 0 > pe >>> 0 ? a + 1 | 0 : a, Pr(wi, pe, a, 0, 0, 64028672, 65536, 0, 0), pe = K, ei = (l | 0) == (Ce | 0) & lr >>> 0 < gr >>> 0 | l >>> 0 > Ce >>> 0, gr = (l | 0) == (b | 0) & or >>> 0 > gr >>> 0 | l >>> 0 < b >>> 0, l = ui + 8 | 0, tr = t[l >> 2], lr = t[l + 4 >> 2], K = (b | 0) == (di | 0) & or >>> 0 < kr >>> 0 | b >>> 0 < di >>> 0, a = Qi + 8 | 0, b = t[a >> 2], l = fs + 8 | 0, or = b + t[l >> 2] | 0, a = t[l + 4 >> 2] + t[a + 4 >> 2] | 0, a = b >>> 0 > or >>> 0 ? a + 1 | 0 : a, l = K + or | 0, a = (l >>> 0 < or >>> 0 ? a + 1 | 0 : a) + lr | 0, b = l, l = l + tr | 0, a = b >>> 0 > l >>> 0 ? a + 1 | 0 : a, b = l + gr | 0, a = b >>> 0 < l >>> 0 ? a + 1 | 0 : a, P = P >>> 20 | 0, l = b + P | 0, a = P >>> 0 > l >>> 0 ? a + 1 | 0 : a, b = l, l = l + ei | 0, a = b >>> 0 > l >>> 0 ? a + 1 | 0 : a, lr = l << 12 | Ce >>> 20, P = a, K = a << 12 | l >>> 20, tr = t[pe + 24 >> 2], l = jr & -2, Ce = tr + l | 0, gr = t[pe + 28 >> 2], a = gr + (Yr & 1048575) | 0, b = l >>> 0 > Ce >>> 0 ? a + 1 | 0 : a, a = b + K | 0, K = Ce + lr | 0, a = K >>> 0 < Ce >>> 0 ? a + 1 | 0 : a, t[pe + 912 >> 2] = K, l = a, t[pe + 916 >> 2] = a & 1048575, lr = Nr & 65535, K = (a | 0) == (b | 0) & Ce >>> 0 > K >>> 0 | a >>> 0 < b >>> 0, b = (b | 0) == (gr | 0) & Ce >>> 0 < tr >>> 0 | b >>> 0 < gr >>> 0, a = wi + 8 | 0, pe = b + t[a >> 2] | 0, a = t[a + 4 >> 2], a = b >>> 0 > pe >>> 0 ? a + 1 | 0 : a, P = P >>> 20 | 0, b = P + pe | 0, a = P >>> 0 > b >>> 0 ? a + 1 | 0 : a, P = b, b = b + K | 0, a = P >>> 0 > b >>> 0 ? a + 1 | 0 : a, l = b << 12 | l >>> 20, P = l + nr | 0, a = lr + (a << 12 | b >>> 20) | 0, t[Tt + 920 >> 2] = P, t[Tt + 924 >> 2] = l >>> 0 > P >>> 0 ? a + 1 | 0 : a, a = Tt + 848 | 0, l = Tt + 888 | 0, zr(a, l, vs), zr(Ki, Xi, l), zr(Ps, Mn, a), t[Ki + 80 >> 2] = 0, Ki = Ki - 88 | 0, $i = $i - 40 | 0, eo = eo - 1 | 0, !!eo; )
        ;
      for (U = Tt + 928 | 0, l = 0, Ki = (Xs | 0) > 0 ? Xs : 0; zn = Me - -64 | 0, fo = t[w >> 2], co = t[w + 4 >> 2], Pr(zn, fo, co, 0, 0, -431719958, 28934, 0, 0), Wi = Me + 416 | 0, a = w + 8 | 0, ao = t[a >> 2], no = t[a + 4 >> 2], Pr(Wi, ao, no, 0, 0, -375590839, 799796, 0, 0), Di = Me + 336 | 0, a = w + 16 | 0, bo = t[a >> 2], Io = t[a + 4 >> 2], Pr(Di, bo, Io, 0, 0, 1486445587, 479535, 0, 0), wi = Me + 256 | 0, a = w + 24 | 0, Po = t[a >> 2], To = t[a + 4 >> 2], Pr(wi, Po, To, 0, 0, 1905590766, 617512, 0, 0), b = Me + 176 | 0, a = w + 32 | 0, mo = t[a >> 2], Es = t[a + 4 >> 2], Pr(b, mo, Es, 0, 0, 1781228924, 31465, 0, 0), jr = Me + 160 | 0, Pr(jr, t[Me + 176 >> 2] & -4, t[Me + 180 >> 2], 0, 0, 15632, 16, 0, 0), Xi = Me + 80 | 0, Pr(Xi, fo, co, 0, 0, 1781228924, 31465, 0, 0), eo = Me + 432 | 0, Pr(eo, ao, no, 0, 0, -431719958, 28934, 0, 0), vs = Me + 352 | 0, Pr(vs, bo, Io, 0, 0, -375590839, 799796, 0, 0), Ps = Me + 272 | 0, Pr(Ps, Po, To, 0, 0, 1486445587, 479535, 0, 0), xs = Me + 192 | 0, Pr(xs, mo, Es, 0, 0, 1905590766, 617512, 0, 0), Ti = Me + 144 | 0, a = b + 8 | 0, Pr(Ti, t[a >> 2], t[a + 4 >> 2], 0, 0, 64028672, 65536, 0, 0), Dn = Me + 96 | 0, Pr(Dn, fo, co, 0, 0, 1905590766, 617512, 0, 0), es = Me + 448 | 0, Pr(es, ao, no, 0, 0, 1781228924, 31465, 0, 0), Bs = Me + 368 | 0, Pr(Bs, bo, Io, 0, 0, -431719958, 28934, 0, 0), kn = Me + 288 | 0, Pr(kn, Po, To, 0, 0, -375590839, 799796, 0, 0), ns = Me + 208 | 0, Pr(ns, mo, Es, 0, 0, 1486445587, 479535, 0, 0), ps = t[Me + 432 >> 2], b = t[Me + 80 >> 2], ui = ps + b | 0, Xs = t[Me + 436 >> 2], a = Xs + t[Me + 84 >> 2] | 0, a = b >>> 0 > ui >>> 0 ? a + 1 | 0 : a, b = t[Me + 352 >> 2], ai = b + ui | 0, di = a, a = a + t[Me + 356 >> 2] | 0, a = b >>> 0 > ai >>> 0 ? a + 1 | 0 : a, b = t[Me + 272 >> 2], ei = b + ai | 0, tr = a, a = a + t[Me + 276 >> 2] | 0, a = b >>> 0 > ei >>> 0 ? a + 1 | 0 : a, b = t[Me + 192 >> 2], Yr = b + ei | 0, lr = a, a = a + t[Me + 196 >> 2] | 0, a = b >>> 0 > Yr >>> 0 ? a + 1 | 0 : a, b = t[Me + 144 >> 2], Nr = b + Yr | 0, Ce = a, a = a + t[Me + 148 >> 2] | 0, P = b >>> 0 > Nr >>> 0 ? a + 1 | 0 : a, fs = t[Me + 416 >> 2], b = t[Me + 64 >> 2], or = fs + b | 0, In = t[Me + 420 >> 2], a = In + t[Me + 68 >> 2] | 0, a = b >>> 0 > or >>> 0 ? a + 1 | 0 : a, b = t[Me + 336 >> 2], gr = b + or | 0, K = a, a = a + t[Me + 340 >> 2] | 0, pe = b >>> 0 > gr >>> 0 ? a + 1 | 0 : a, a = pe + t[Me + 260 >> 2] | 0, b = t[Me + 256 >> 2], Tt = b + gr | 0, nr = t[Me + 160 >> 2], Qi = Tt + nr | 0, b = b >>> 0 > Tt >>> 0 ? a + 1 | 0 : a, a = b + t[Me + 164 >> 2] | 0, nr = nr >>> 0 > Qi >>> 0 ? a + 1 | 0 : a, $i = (b | 0) == (nr | 0) & Tt >>> 0 > Qi >>> 0 | b >>> 0 > nr >>> 0, a = jr + 8 | 0, Li = t[a >> 2], Ei = t[a + 4 >> 2], Ii = (b | 0) == (pe | 0) & Tt >>> 0 < gr >>> 0 | b >>> 0 < pe >>> 0, a = wi + 8 | 0, kr = t[a >> 2], wi = t[a + 4 >> 2], jr = (K | 0) == (pe | 0) & or >>> 0 > gr >>> 0 | K >>> 0 > pe >>> 0, a = Di + 8 | 0, gr = t[a >> 2], Tt = t[a + 4 >> 2], K = (K | 0) == (In | 0) & or >>> 0 < fs >>> 0 | K >>> 0 < In >>> 0, pe = zn + 8 | 0, b = t[pe >> 2], a = Wi + 8 | 0, or = b + t[a >> 2] | 0, a = t[a + 4 >> 2] + t[pe + 4 >> 2] | 0, a = b >>> 0 > or >>> 0 ? a + 1 | 0 : a, b = K + or | 0, a = (b >>> 0 < or >>> 0 ? a + 1 | 0 : a) + Tt | 0, K = b, b = b + gr | 0, a = K >>> 0 > b >>> 0 ? a + 1 | 0 : a, K = b, b = b + jr | 0, a = (K >>> 0 > b >>> 0 ? a + 1 | 0 : a) + wi | 0, K = b, b = b + kr | 0, a = K >>> 0 > b >>> 0 ? a + 1 | 0 : a, K = b, b = b + Ii | 0, a = (K >>> 0 > b >>> 0 ? a + 1 | 0 : a) + Ei | 0, K = b, b = b + Li | 0, a = K >>> 0 > b >>> 0 ? a + 1 | 0 : a, K = b, b = b + $i | 0, a = K >>> 0 > b >>> 0 ? a + 1 | 0 : a, jr = nr, K = b << 12 | nr >>> 20, Tt = K + Nr | 0, pe = a, a = P + (a << 12 | b >>> 20) | 0, gr = K >>> 0 > Tt >>> 0 ? a + 1 | 0 : a, In = t[Me + 368 >> 2], b = t[Me + 448 >> 2], kr = In + b | 0, Mn = t[Me + 372 >> 2], a = Mn + t[Me + 452 >> 2] | 0, a = b >>> 0 > kr >>> 0 ? a + 1 | 0 : a, b = t[Me + 288 >> 2], wi = b + kr | 0, nr = a, a = a + t[Me + 292 >> 2] | 0, a = b >>> 0 > wi >>> 0 ? a + 1 | 0 : a, b = t[Me + 208 >> 2], or = b + wi | 0, K = a, a = a + t[Me + 212 >> 2] | 0, b = b >>> 0 > or >>> 0 ? a + 1 | 0 : a, zn = (P | 0) == (gr | 0) & Tt >>> 0 < Nr >>> 0 | P >>> 0 > gr >>> 0, Wi = (P | 0) == (Ce | 0) & Nr >>> 0 < Yr >>> 0 | P >>> 0 < Ce >>> 0, a = Ti + 8 | 0, Di = t[a >> 2], Ti = t[a + 4 >> 2], fs = (Ce | 0) == (lr | 0) & Yr >>> 0 < ei >>> 0 | Ce >>> 0 < lr >>> 0, a = xs + 8 | 0, $i = t[a >> 2], Li = t[a + 4 >> 2], Ei = (tr | 0) == (lr | 0) & ei >>> 0 < ai >>> 0 | tr >>> 0 > lr >>> 0, a = Ps + 8 | 0, Ii = t[a >> 2], ei = t[a + 4 >> 2], Yr = (tr | 0) == (di | 0) & ai >>> 0 < ui >>> 0 | tr >>> 0 < di >>> 0, a = vs + 8 | 0, Nr = t[a >> 2], tr = t[a + 4 >> 2], lr = (di | 0) == (Xs | 0) & ui >>> 0 < ps >>> 0 | di >>> 0 < Xs >>> 0, Ce = Xi + 8 | 0, P = t[Ce >> 2], a = eo + 8 | 0, ai = P + t[a >> 2] | 0, a = t[a + 4 >> 2] + t[Ce + 4 >> 2] | 0, a = P >>> 0 > ai >>> 0 ? a + 1 | 0 : a, P = lr + ai | 0, a = (P >>> 0 < ai >>> 0 ? a + 1 | 0 : a) + tr | 0, Ce = P, P = P + Nr | 0, a = Ce >>> 0 > P >>> 0 ? a + 1 | 0 : a, Ce = P, P = P + Yr | 0, a = (Ce >>> 0 > P >>> 0 ? a + 1 | 0 : a) + ei | 0, Ce = P, P = P + Ii | 0, a = Ce >>> 0 > P >>> 0 ? a + 1 | 0 : a, Ce = P, P = P + Ei | 0, a = (Ce >>> 0 > P >>> 0 ? a + 1 | 0 : a) + Li | 0, Ce = P, P = P + $i | 0, a = Ce >>> 0 > P >>> 0 ? a + 1 | 0 : a, Ce = P, P = P + fs | 0, a = (Ce >>> 0 > P >>> 0 ? a + 1 | 0 : a) + Ti | 0, Ce = P, P = P + Di | 0, a = Ce >>> 0 > P >>> 0 ? a + 1 | 0 : a, Ce = P + Wi | 0, a = Ce >>> 0 < P >>> 0 ? a + 1 | 0 : a, pe = pe >>> 20 | 0, P = Ce + pe | 0, a = pe >>> 0 > P >>> 0 ? a + 1 | 0 : a, pe = P, P = P + zn | 0, pe = pe >>> 0 > P >>> 0 ? a + 1 | 0 : a, Ce = pe << 12 | P >>> 20, a = P << 12, P = gr, lr = a | P >>> 20, gr = lr + or | 0, a = b + Ce | 0, tr = lr >>> 0 > gr >>> 0 ? a + 1 | 0 : a, Ce = gr, a = tr << 4 | Ce >>> 28, lr = Ce << 4 & -16, Ce = a & 16777215, Yr = P, Pr(Me, lr | P >>> 16 & 15, Ce, 0, 0, 977, 1, 0, 0), Wi = t[Me + 4 >> 2], a = Wi + t[Me + 100 >> 2] | 0, Ss = (Me + 2240 | 0) + l | 0, Ce = Ss, Di = t[Me >> 2], P = t[Me + 96 >> 2], Nr = Di + P | 0, t[Ce >> 2] = Nr, lr = P >>> 0 > Nr >>> 0 ? a + 1 | 0 : a, t[Ce + 4 >> 2] = lr & 1048575, eo = Me + 112 | 0, Pr(eo, fo, co, 0, 0, 1486445587, 479535, 0, 0), vs = Me + 464 | 0, Pr(vs, ao, no, 0, 0, 1905590766, 617512, 0, 0), Ps = Me + 384 | 0, Pr(Ps, bo, Io, 0, 0, 1781228924, 31465, 0, 0), Ti = Me + 304 | 0, Pr(Ti, Po, To, 0, 0, -431719958, 28934, 0, 0), fs = Me + 224 | 0, Pr(fs, mo, Es, 0, 0, -375590839, 799796, 0, 0), xs = Me + 48 | 0, Li = xs, $i = t[Me + 304 >> 2], P = t[Me + 384 >> 2], ai = $i + P | 0, Xs = t[Me + 308 >> 2], a = Xs + t[Me + 388 >> 2] | 0, a = P >>> 0 > ai >>> 0 ? a + 1 | 0 : a, P = t[Me + 224 >> 2], ei = P + ai | 0, Ce = a, a = a + t[Me + 228 >> 2] | 0, P = P >>> 0 > ei >>> 0 ? a + 1 | 0 : a, Ei = (b | 0) == (tr | 0) & or >>> 0 > gr >>> 0 | b >>> 0 > tr >>> 0, Ii = (b | 0) == (K | 0) & or >>> 0 < wi >>> 0 | b >>> 0 < K >>> 0, a = ns + 8 | 0, di = t[a >> 2], ui = t[a + 4 >> 2], wi = (K | 0) == (nr | 0) & kr >>> 0 > wi >>> 0 | K >>> 0 < nr >>> 0, a = kn + 8 | 0, or = t[a >> 2], gr = t[a + 4 >> 2], nr = (nr | 0) == (Mn | 0) & kr >>> 0 < In >>> 0 | nr >>> 0 < Mn >>> 0, K = es + 8 | 0, b = t[K >> 2], a = Bs + 8 | 0, kr = b + t[a >> 2] | 0, a = t[a + 4 >> 2] + t[K + 4 >> 2] | 0, a = b >>> 0 > kr >>> 0 ? a + 1 | 0 : a, b = nr + kr | 0, a = (b >>> 0 < kr >>> 0 ? a + 1 | 0 : a) + gr | 0, K = b, b = b + or | 0, a = K >>> 0 > b >>> 0 ? a + 1 | 0 : a, K = b, b = b + wi | 0, a = (K >>> 0 > b >>> 0 ? a + 1 | 0 : a) + ui | 0, K = b, b = b + di | 0, a = K >>> 0 > b >>> 0 ? a + 1 | 0 : a, K = b + Ii | 0, a = K >>> 0 < b >>> 0 ? a + 1 | 0 : a, pe = pe >>> 20 | 0, b = K + pe | 0, a = pe >>> 0 > b >>> 0 ? a + 1 | 0 : a, K = b, b = b + Ei | 0, a = K >>> 0 > b >>> 0 ? a + 1 | 0 : a, pe = b << 12 | tr >>> 20, or = pe + ei | 0, nr = a, a = P + (a << 12 | b >>> 20) | 0, gr = pe >>> 0 > or >>> 0 ? a + 1 | 0 : a, Pr(Li, or, gr & 1048575, 0, 0, 15632, 16, 0, 0), kr = Ss + 8 | 0, Bs = t[Me + 464 >> 2], b = t[Me + 112 >> 2], Ii = Bs + b | 0, Xi = t[Me + 468 >> 2], a = Xi + t[Me + 116 >> 2] | 0, a = b >>> 0 > Ii >>> 0 ? a + 1 | 0 : a, b = t[Me + 48 >> 2], di = b + Ii | 0, Ei = a, a = a + t[Me + 52 >> 2] | 0, pe = b >>> 0 > di >>> 0 ? a + 1 | 0 : a, tr = (lr | 0) == (Wi | 0) & Nr >>> 0 < Di >>> 0 | lr >>> 0 < Wi >>> 0, K = Dn + 8 | 0, b = t[K >> 2], a = Me + 8 | 0, Nr = b + t[a >> 2] | 0, a = t[a + 4 >> 2] + t[K + 4 >> 2] | 0, a = b >>> 0 > Nr >>> 0 ? a + 1 | 0 : a, b = tr + Nr | 0, a = b >>> 0 < Nr >>> 0 ? a + 1 | 0 : a, lr = b << 12 | lr >>> 20, Nr = lr + di | 0, K = a, a = pe + (a << 12 | b >>> 20) | 0, t[kr >> 2] = Nr, tr = lr >>> 0 > Nr >>> 0 ? a + 1 | 0 : a, t[kr + 4 >> 2] = tr & 1048575, kn = Me + 128 | 0, Pr(kn, fo, co, 0, 0, -375590839, 799796, 0, 0), ns = Me + 480 | 0, Pr(ns, ao, no, 0, 0, 1486445587, 479535, 0, 0), ps = Me + 400 | 0, Pr(ps, bo, Io, 0, 0, 1905590766, 617512, 0, 0), In = Me + 320 | 0, Pr(In, Po, To, 0, 0, 1781228924, 31465, 0, 0), zn = Me + 240 | 0, Pr(zn, mo, Es, 0, 0, -431719958, 28934, 0, 0), Wi = Me + 32 | 0, Li = Wi, Di = t[Me + 240 >> 2], b = t[Me + 320 >> 2], ui = Di + b | 0, Dn = t[Me + 244 >> 2], a = Dn + t[Me + 324 >> 2] | 0, b = b >>> 0 > ui >>> 0 ? a + 1 | 0 : a, kr = (P | 0) == (gr | 0) & or >>> 0 < ei >>> 0 | P >>> 0 > gr >>> 0, wi = (P | 0) == (Ce | 0) & ei >>> 0 < ai >>> 0 | P >>> 0 < Ce >>> 0, a = fs + 8 | 0, ei = t[a >> 2], or = t[a + 4 >> 2], lr = (Ce | 0) == (Xs | 0) & ai >>> 0 < $i >>> 0 | Ce >>> 0 < Xs >>> 0, Ce = Ps + 8 | 0, P = t[Ce >> 2], a = Ti + 8 | 0, ai = P + t[a >> 2] | 0, a = t[a + 4 >> 2] + t[Ce + 4 >> 2] | 0, a = P >>> 0 > ai >>> 0 ? a + 1 | 0 : a, P = lr + ai | 0, a = (P >>> 0 < ai >>> 0 ? a + 1 | 0 : a) + or | 0, Ce = P, P = P + ei | 0, a = Ce >>> 0 > P >>> 0 ? a + 1 | 0 : a, Ce = P + wi | 0, a = Ce >>> 0 < P >>> 0 ? a + 1 | 0 : a, nr = nr >>> 20 | 0, P = Ce + nr | 0, a = nr >>> 0 > P >>> 0 ? a + 1 | 0 : a, Ce = P, P = P + kr | 0, a = Ce >>> 0 > P >>> 0 ? a + 1 | 0 : a, nr = P << 12 | gr >>> 20, or = nr + ui | 0, lr = a, a = b + (a << 12 | P >>> 20) | 0, kr = or >>> 0 < nr >>> 0 ? a + 1 | 0 : a, Pr(Li, or, kr, 0, 0, 15632, 16, 0, 0), es = Ss + 16 | 0, Ti = t[Me + 480 >> 2], P = t[Me + 128 >> 2], wi = Ti + P | 0, Ps = t[Me + 484 >> 2], a = Ps + t[Me + 132 >> 2] | 0, a = P >>> 0 > wi >>> 0 ? a + 1 | 0 : a, P = t[Me + 400 >> 2], ai = P + wi | 0, Ce = a, a = a + t[Me + 404 >> 2] | 0, a = P >>> 0 > ai >>> 0 ? a + 1 | 0 : a, P = t[Me + 32 >> 2], ei = P + ai | 0, nr = a, a = a + t[Me + 36 >> 2] | 0, P = P >>> 0 > ei >>> 0 ? a + 1 | 0 : a, fs = (pe | 0) == (tr | 0) & Nr >>> 0 < di >>> 0 | pe >>> 0 > tr >>> 0, $i = (pe | 0) == (Ei | 0) & Ii >>> 0 > di >>> 0 | pe >>> 0 < Ei >>> 0, a = xs + 8 | 0, Li = t[a >> 2], di = t[a + 4 >> 2], Nr = (Ei | 0) == (Xi | 0) & Ii >>> 0 < Bs >>> 0 | Ei >>> 0 < Xi >>> 0, gr = eo + 8 | 0, pe = t[gr >> 2], a = vs + 8 | 0, Ii = pe + t[a >> 2] | 0, a = t[a + 4 >> 2] + t[gr + 4 >> 2] | 0, a = pe >>> 0 > Ii >>> 0 ? a + 1 | 0 : a, pe = Nr + Ii | 0, a = (pe >>> 0 < Ii >>> 0 ? a + 1 | 0 : a) + di | 0, gr = pe, pe = pe + Li | 0, a = gr >>> 0 > pe >>> 0 ? a + 1 | 0 : a, gr = pe + $i | 0, a = gr >>> 0 < pe >>> 0 ? a + 1 | 0 : a, K = K >>> 20 | 0, pe = K + gr | 0, a = K >>> 0 > pe >>> 0 ? a + 1 | 0 : a, K = pe, pe = pe + fs | 0, a = K >>> 0 > pe >>> 0 ? a + 1 | 0 : a, tr = pe << 12 | tr >>> 20, gr = tr + ei | 0, K = a, a = P + (a << 12 | pe >>> 20) | 0, t[es >> 2] = gr, tr = tr >>> 0 > gr >>> 0 ? a + 1 | 0 : a, t[es + 4 >> 2] = tr & 1048575, Ii = Me + 16 | 0, di = Ii, Nr = (b | 0) == (kr | 0) & or >>> 0 < ui >>> 0 | b >>> 0 > kr >>> 0, or = (b | 0) == (Dn | 0) & ui >>> 0 < Di >>> 0 | b >>> 0 < Dn >>> 0, pe = In + 8 | 0, b = t[pe >> 2], a = zn + 8 | 0, kr = b + t[a >> 2] | 0, a = t[a + 4 >> 2] + t[pe + 4 >> 2] | 0, a = b >>> 0 > kr >>> 0 ? a + 1 | 0 : a, pe = or + kr | 0, a = pe >>> 0 < kr >>> 0 ? a + 1 | 0 : a, lr = lr >>> 20 | 0, b = pe + lr | 0, a = lr >>> 0 > b >>> 0 ? a + 1 | 0 : a, pe = b, b = b + Nr | 0, a = pe >>> 0 > b >>> 0 ? a + 1 | 0 : a, Pr(di, b, a, 0, 0, 64028672, 65536, 0, 0), Li = Ss + 24 | 0, Ei = t[Me + 20 >> 2], a = Ei + (jr & 1048575) | 0, di = t[Me + 16 >> 2], pe = Qi + di | 0, b = pe >>> 0 < Qi >>> 0 ? a + 1 | 0 : a, lr = pe, ui = (P | 0) == (tr | 0) & gr >>> 0 < ei >>> 0 | P >>> 0 > tr >>> 0, kr = (P | 0) == (nr | 0) & ei >>> 0 < ai >>> 0 | P >>> 0 < nr >>> 0, a = Wi + 8 | 0, ei = t[a >> 2], jr = t[a + 4 >> 2], Nr = (Ce | 0) == (nr | 0) & ai >>> 0 < wi >>> 0 | Ce >>> 0 > nr >>> 0, a = ps + 8 | 0, or = t[a >> 2], gr = t[a + 4 >> 2], nr = (Ce | 0) == (Ps | 0) & wi >>> 0 < Ti >>> 0 | Ce >>> 0 < Ps >>> 0, pe = kn + 8 | 0, P = t[pe >> 2], a = ns + 8 | 0, Ce = P + t[a >> 2] | 0, a = t[a + 4 >> 2] + t[pe + 4 >> 2] | 0, a = P >>> 0 > Ce >>> 0 ? a + 1 | 0 : a, P = Ce + nr | 0, a = (P >>> 0 < Ce >>> 0 ? a + 1 | 0 : a) + gr | 0, pe = P, P = P + or | 0, a = pe >>> 0 > P >>> 0 ? a + 1 | 0 : a, pe = P, P = P + Nr | 0, a = (pe >>> 0 > P >>> 0 ? a + 1 | 0 : a) + jr | 0, pe = P, P = P + ei | 0, a = pe >>> 0 > P >>> 0 ? a + 1 | 0 : a, pe = P + kr | 0, a = pe >>> 0 < P >>> 0 ? a + 1 | 0 : a, K = K >>> 20 | 0, P = K + pe | 0, a = K >>> 0 > P >>> 0 ? a + 1 | 0 : a, K = P, P = P + ui | 0, a = K >>> 0 > P >>> 0 ? a + 1 | 0 : a, nr = P << 12 | tr >>> 20, K = nr + lr | 0, pe = a, a = b + (a << 12 | P >>> 20) | 0, t[Li >> 2] = K, P = K >>> 0 < nr >>> 0 ? a + 1 | 0 : a, t[Li + 4 >> 2] = P & 1048575, tr = Ss + 32 | 0, Ce = Yr & 65535, nr = (b | 0) == (P | 0) & K >>> 0 < lr >>> 0 | b >>> 0 > P >>> 0, b = (b | 0) == (Ei | 0) & lr >>> 0 < di >>> 0 | b >>> 0 < Ei >>> 0, a = Ii + 8 | 0, K = b + t[a >> 2] | 0, a = t[a + 4 >> 2], a = b >>> 0 > K >>> 0 ? a + 1 | 0 : a, pe = pe >>> 20 | 0, b = K + pe | 0, a = pe >>> 0 > b >>> 0 ? a + 1 | 0 : a, K = b, b = b + nr | 0, a = K >>> 0 > b >>> 0 ? a + 1 | 0 : a, P = b << 12 | P >>> 20, pe = P + Tt | 0, a = Ce + (a << 12 | b >>> 20) | 0, t[tr >> 2] = pe, t[tr + 4 >> 2] = P >>> 0 > pe >>> 0 ? a + 1 | 0 : a, w = w + 88 | 0, l = l + 40 | 0, (l | 0) != 320; )
        ;
      w = (Ki | 0) < (Yi | 0) ? Yi : Ki, l = 1;
    }
    e: {
      if (!n) {
        tr = 0, nr = 0;
        break e;
      }
      P = Me + 3648 | 0, a = P + 24 | 0, t[a >> 2] = 0, t[a + 4 >> 2] = 0, b = Me + 3616 | 0, a = b + 24 | 0, t[a >> 2] = 0, t[a + 4 >> 2] = 0, t[Me + 3664 >> 2] = 0, t[Me + 3668 >> 2] = 0, t[Me + 3632 >> 2] = 0, t[Me + 3636 >> 2] = 0, a = t[n + 4 >> 2], t[Me + 3648 >> 2] = t[n >> 2], t[Me + 3652 >> 2] = a, a = t[n + 12 >> 2], t[Me + 3656 >> 2] = t[n + 8 >> 2], t[Me + 3660 >> 2] = a, a = t[n + 20 >> 2], t[Me + 3616 >> 2] = t[n + 16 >> 2], t[Me + 3620 >> 2] = a, a = t[n + 28 >> 2], t[Me + 3624 >> 2] = t[n + 24 >> 2], t[Me + 3628 >> 2] = a, tr = Ui(Me + 3088 | 0, P, 4), nr = Ui(Me + 2560 | 0, b, 4), w = (w | 0) < (tr | 0) ? tr : w, w = (w | 0) < (nr | 0) ? nr : w;
    }
    t[C + 120 >> 2] = 1, or = is(C, 120);
    e: {
      if ((w | 0) <= 0)
        break e;
      C = w - 1 | 0;
      t: {
        if (!l)
          for (C = C << 2, n = C + (Me + 3088 | 0) | 0, C = (Me + 2560 | 0) + C | 0, Tt = 1; ; ) {
            r: {
              if (Tt) {
                t[or + 120 >> 2] = 1, is(or, 120);
                break r;
              }
              Gn(or, or);
            }
            r: {
              if ((w | 0) > (tr | 0) || (a = t[n >> 2], !a))
                break r;
              l = Me + 3720 | 0, _i(l, 655920, a), Tn(or, or, l, Me + 3680 | 0);
            }
            l = w - 1 | 0;
            r: {
              if ((w | 0) > (nr | 0) || (a = t[C >> 2], !a))
                break r;
              w = Me + 3720 | 0, _i(w, 656176, a), Tn(or, or, w, Me + 3680 | 0);
            }
            if ((l | 0) <= 0)
              break t;
            n = n - 4 | 0, C = C - 4 | 0, Tt = t[or + 120 >> 2], w = l;
          }
        for (gr = Me + 3760 | 0, n = ((w << 2) + Me | 0) + 1008 | 0, l = C << 2, C = l + (Me + 3088 | 0) | 0, Tt = (Me + 2560 | 0) + l | 0, K = t[Me + 1532 >> 2], pe = t[Me + 1528 >> 2], a = 1; ; ) {
          r: {
            if (a) {
              t[or + 120 >> 2] = 1, is(or, 120);
              break r;
            }
            Gn(or, or);
          }
          r: {
            if ((w | 0) > (pe | 0) || (l = t[n - 516 >> 2], !l))
              break r;
            i: {
              if ((l | 0) <= 0) {
                as(Me + 3720 | 0, (Me + 1536 | 0) + B((l ^ -1) / 2 | 0, 88) | 0, 88), l = t[Me + 3760 >> 2], a = -3908 - l | 0, l = 4194299 - (t[Me + 3764 >> 2] + (l >>> 0 > 4294963388) | 0) | 0, t[Me + 3760 >> 2] = a, t[Me + 3764 >> 2] = l, l = t[Me + 3768 >> 2], a = -4 - l | 0, l = 4194303 - (t[Me + 3772 >> 2] + (l >>> 0 > 4294967292) | 0) | 0, t[Me + 3768 >> 2] = a, t[Me + 3772 >> 2] = l, l = t[Me + 3776 >> 2], a = -4 - l | 0, l = 4194303 - (t[Me + 3780 >> 2] + (l >>> 0 > 4294967292) | 0) | 0, t[Me + 3776 >> 2] = a, t[Me + 3780 >> 2] = l, l = t[Me + 3784 >> 2], a = -4 - l | 0, l = 4194303 - (t[Me + 3788 >> 2] + (l >>> 0 > 4294967292) | 0) | 0, t[Me + 3784 >> 2] = a, t[Me + 3788 >> 2] = l, l = t[Me + 3792 >> 2], a = -4 - l | 0, l = 262143 - (t[Me + 3796 >> 2] + (l >>> 0 > 4294967292) | 0) | 0, t[Me + 3792 >> 2] = a, t[Me + 3796 >> 2] = l;
                break i;
              }
              as(Me + 3720 | 0, (Me + 1536 | 0) + B(l - 1 >>> 1 | 0, 88) | 0, 88);
            }
            Fn(or, or, Me + 3720 | 0, 0);
          }
          r: {
            if ((w | 0) > (K | 0) || (l = t[n >> 2], !l))
              break r;
            i: {
              if ((l | 0) <= 0) {
                P = (l ^ -1) / 2 | 0, Ce = (Me + 1536 | 0) + B(P, 88) | 0, l = t[Ce + 44 >> 2], t[gr >> 2] = t[Ce + 40 >> 2], t[gr + 4 >> 2] = l, b = Ce + 48 | 0, a = t[b + 4 >> 2], l = gr + 8 | 0, t[l >> 2] = t[b >> 2], t[l + 4 >> 2] = a, b = Ce + 56 | 0, a = t[b + 4 >> 2], l = gr + 16 | 0, t[l >> 2] = t[b >> 2], t[l + 4 >> 2] = a, b = Ce - -64 | 0, a = t[b + 4 >> 2], l = gr + 24 | 0, t[l >> 2] = t[b >> 2], t[l + 4 >> 2] = a, b = Ce + 72 | 0, a = t[b + 4 >> 2], l = gr + 32 | 0, t[l >> 2] = t[b >> 2], t[l + 4 >> 2] = a, Ce = (Me + 2240 | 0) + B(P, 40) | 0, b = Ce + 8 | 0, a = t[b + 4 >> 2], P = Me + 3720 | 0, l = P + 8 | 0, t[l >> 2] = t[b >> 2], t[l + 4 >> 2] = a, b = Ce + 16 | 0, a = t[b + 4 >> 2], l = P + 16 | 0, t[l >> 2] = t[b >> 2], t[l + 4 >> 2] = a, b = Ce + 24 | 0, a = t[b + 4 >> 2], l = P + 24 | 0, t[l >> 2] = t[b >> 2], t[l + 4 >> 2] = a, b = Ce + 32 | 0, a = t[b + 4 >> 2], l = P + 32 | 0, t[l >> 2] = t[b >> 2], t[l + 4 >> 2] = a, t[Me + 3800 >> 2] = 0, l = t[Ce + 4 >> 2], t[Me + 3720 >> 2] = t[Ce >> 2], t[Me + 3724 >> 2] = l, l = t[Me + 3760 >> 2], a = -3908 - l | 0, l = 4194299 - (t[Me + 3764 >> 2] + (l >>> 0 > 4294963388) | 0) | 0, t[Me + 3760 >> 2] = a, t[Me + 3764 >> 2] = l, l = t[Me + 3768 >> 2], a = -4 - l | 0, l = 4194303 - (t[Me + 3772 >> 2] + (l >>> 0 > 4294967292) | 0) | 0, t[Me + 3768 >> 2] = a, t[Me + 3772 >> 2] = l, l = t[Me + 3776 >> 2], a = -4 - l | 0, l = 4194303 - (t[Me + 3780 >> 2] + (l >>> 0 > 4294967292) | 0) | 0, t[Me + 3776 >> 2] = a, t[Me + 3780 >> 2] = l, l = t[Me + 3784 >> 2], a = -4 - l | 0, l = 4194303 - (t[Me + 3788 >> 2] + (l >>> 0 > 4294967292) | 0) | 0, t[Me + 3784 >> 2] = a, t[Me + 3788 >> 2] = l, l = t[Me + 3792 >> 2], a = -4 - l | 0, l = 262143 - (t[Me + 3796 >> 2] + (l >>> 0 > 4294967292) | 0) | 0, t[Me + 3792 >> 2] = a, t[Me + 3796 >> 2] = l;
                break i;
              }
              a = l - 1 >>> 1 | 0, lr = (Me + 1536 | 0) + B(a, 88) | 0, l = t[lr + 44 >> 2], t[gr >> 2] = t[lr + 40 >> 2], t[gr + 4 >> 2] = l, Ce = (Me + 2240 | 0) + B(a, 40) | 0, b = Ce + 8 | 0, a = t[b + 4 >> 2], P = Me + 3720 | 0, l = P + 8 | 0, t[l >> 2] = t[b >> 2], t[l + 4 >> 2] = a, b = Ce + 16 | 0, a = t[b + 4 >> 2], l = P + 16 | 0, t[l >> 2] = t[b >> 2], t[l + 4 >> 2] = a, b = Ce + 24 | 0, a = t[b + 4 >> 2], l = P + 24 | 0, t[l >> 2] = t[b >> 2], t[l + 4 >> 2] = a, b = Ce + 32 | 0, a = t[b + 4 >> 2], l = P + 32 | 0, t[l >> 2] = t[b >> 2], t[l + 4 >> 2] = a, b = lr + 48 | 0, a = t[b + 4 >> 2], l = gr + 8 | 0, t[l >> 2] = t[b >> 2], t[l + 4 >> 2] = a, b = lr + 56 | 0, a = t[b + 4 >> 2], l = gr + 16 | 0, t[l >> 2] = t[b >> 2], t[l + 4 >> 2] = a, b = lr - -64 | 0, a = t[b + 4 >> 2], l = gr + 24 | 0, t[l >> 2] = t[b >> 2], t[l + 4 >> 2] = a, b = lr + 72 | 0, a = t[b + 4 >> 2], l = gr + 32 | 0, t[l >> 2] = t[b >> 2], t[l + 4 >> 2] = a, t[Me + 3800 >> 2] = 0, l = t[Ce + 4 >> 2], t[Me + 3720 >> 2] = t[Ce >> 2], t[Me + 3724 >> 2] = l;
            }
            Fn(or, or, Me + 3720 | 0, 0);
          }
          r: {
            if ((w | 0) > (tr | 0) || (a = t[C >> 2], !a))
              break r;
            l = Me + 3720 | 0, _i(l, 655920, a), Tn(or, or, l, Me + 3680 | 0);
          }
          l = w - 1 | 0;
          r: {
            if ((w | 0) > (nr | 0) || (a = t[Tt >> 2], !a))
              break r;
            w = Me + 3720 | 0, _i(w, 656176, a), Tn(or, or, w, Me + 3680 | 0);
          }
          if ((l | 0) <= 0)
            break t;
          C = C - 4 | 0, Tt = Tt - 4 | 0, n = n - 4 | 0, a = t[or + 120 >> 2], w = l;
        }
      }
      if (t[or + 120 >> 2])
        break e;
      C = or + 80 | 0, zr(C, C, Me + 3680 | 0);
    }
    U = Me + 3808 | 0;
  }
  function si(C, l) {
    var w = 0, n = 0, a = 0, b = 0, P = 0, K = 0, pe = 0, Ce = 0, Me = 0, Tt = 0, tr = 0, nr = 0, or = 0, lr = 0, gr = 0;
    pe = U - 48 | 0, U = pe, n = pe + 8 | 0, Wn(n, l + 80 | 0), zr(n, n, C), b = t[l + 24 >> 2], a = t[l + 28 >> 2], Ce = t[l + 16 >> 2], P = t[l + 20 >> 2], n = t[l + 8 >> 2], Tt = t[l + 12 >> 2], w = t[l >> 2], K = t[l + 4 >> 2], tr = t[l + 32 >> 2], l = t[l + 36 >> 2], nr = l, C = w, w = ri(l >>> 16 | 0, 0, 977, 1), l = C + w | 0, C = K + ve | 0, C = l >>> 0 < w >>> 0 ? C + 1 | 0 : C, w = l, K = C, C = Tt, l = K >>> 20 | 0, Me = l, l = l + n | 0, Tt = Me >>> 0 > l >>> 0 ? C + 1 | 0 : C, C = P, n = Tt >>> 20 | 0, Ce = n + Ce | 0, P = n >>> 0 > Ce >>> 0 ? C + 1 | 0 : C, C = a, n = P >>> 20 | 0, b = n + b | 0, n = n >>> 0 > b >>> 0 ? C + 1 | 0 : C, C = t[pe + 8 >> 2], a = w - C | 0, or = (K & 1048575) - (t[pe + 12 >> 2] + (C >>> 0 > w >>> 0) | 0) | 0, C = t[pe + 40 >> 2], K = tr - C | 0, C = (nr & 65535) - (t[pe + 44 >> 2] + (C >>> 0 > tr >>> 0) | 0) | 0, w = n >>> 20 | 0, Me = w, w = w + K | 0, C = (Me >>> 0 > w >>> 0 ? C + 1 | 0 : C) + 262143 | 0, Me = a, w = w - 4 | 0, tr = w >>> 0 < 4294967292 ? C + 1 | 0 : C, a = ri(tr >>> 16 | 0, 0, 977, 1), K = Me + a | 0, C = or + ve | 0, C = (K >>> 0 < a >>> 0 ? C + 1 | 0 : C) + 4194299 | 0, K = K - 3908 | 0, C = K >>> 0 < 4294963388 ? C + 1 | 0 : C, a = C & 1048575, lr = a, nr = K ^ 976, or = a ^ 1, U = pe + 48 | 0;
    e: {
      if (K | a && (a = 0, (nr | 0) != -1 | (or | 0) != 1048575))
        break e;
      a = w, tr = tr & 65535, w = t[pe + 32 >> 2], gr = b - w | 0, Me = (n & 1048575) - (t[pe + 36 >> 2] + (w >>> 0 > b >>> 0) | 0) | 0, n = t[pe + 24 >> 2], b = Ce - n | 0, Ce = (P & 1048575) - (t[pe + 28 >> 2] + (n >>> 0 > Ce >>> 0) | 0) | 0, n = C, C = Tt & 1048575, n = n >>> 20 | 0, w = n, n = l + n | 0, C = w >>> 0 > n >>> 0 ? C + 1 | 0 : C, w = t[pe + 16 >> 2], l = (n - w | 0) - 4 | 0, C = (C - (t[pe + 20 >> 2] + (n >>> 0 < w >>> 0) | 0) | 0) + 4194303 | 0, n = l >>> 0 < 4294967292 ? C + 1 | 0 : C, C = Ce, w = n >>> 20 | 0, P = w, w = w + b | 0, C = (P >>> 0 > w >>> 0 ? C + 1 | 0 : C) + 4194303 | 0, w = w - 4 | 0, Ce = w >>> 0 < 4294967292 ? C + 1 | 0 : C, C = Me, b = Ce >>> 20 | 0, P = b, b = b + gr | 0, C = (P >>> 0 > b >>> 0 ? C + 1 | 0 : C) + 4194303 | 0, b = b - 4 | 0, Tt = b >>> 0 < 4294967292 ? C + 1 | 0 : C, C = tr, P = Tt >>> 20 | 0, Me = P, P = a + P | 0, C = Me >>> 0 > P >>> 0 ? C + 1 | 0 : C, (l & nr & w & b & P) == -1 ? a = (n & or & Ce & Tt & (C ^ 983040)) == 1048575 : a = 0, a ? (l = 0, C = 0) : (l = b | (w | (l | K)) | P, C = Tt & 1048575 | (Ce & 1048575 | (n & 1048575 | lr)) | C), a = !(C | l);
    }
    return a;
  }
  function Ci(C, l, w, n, a, b) {
    C = C | 0, l = l | 0, w = w | 0, n = n | 0, a = a | 0, b = b | 0;
    var P = 0, K = 0, pe = 0, Ce = 0, Me = 0, Tt = 0, tr = 0;
    for (P = U - 224 | 0, U = P, Ir(P + 8 | 0, l, 0), l = w + 16 | 0, K = d[l + 4 | 0] | d[l + 5 | 0] << 8 | (d[l + 6 | 0] << 16 | d[l + 7 | 0] << 24), pe = P + 112 | 0, Ce = pe + 16 | 0, t[Ce >> 2] = d[l | 0] | d[l + 1 | 0] << 8 | (d[l + 2 | 0] << 16 | d[l + 3 | 0] << 24), t[Ce + 4 >> 2] = K, l = w + 24 | 0, K = d[l + 4 | 0] | d[l + 5 | 0] << 8 | (d[l + 6 | 0] << 16 | d[l + 7 | 0] << 24), pe = pe + 24 | 0, t[pe >> 2] = d[l | 0] | d[l + 1 | 0] << 8 | (d[l + 2 | 0] << 16 | d[l + 3 | 0] << 24), t[pe + 4 >> 2] = K, l = d[w + 4 | 0] | d[w + 5 | 0] << 8 | (d[w + 6 | 0] << 16 | d[w + 7 | 0] << 24), t[P + 112 >> 2] = d[w | 0] | d[w + 1 | 0] << 8 | (d[w + 2 | 0] << 16 | d[w + 3 | 0] << 24), t[P + 116 >> 2] = l, l = w + 8 | 0, w = d[l + 4 | 0] | d[l + 5 | 0] << 8 | (d[l + 6 | 0] << 16 | d[l + 7 | 0] << 24), t[P + 120 >> 2] = d[l | 0] | d[l + 1 | 0] << 8 | (d[l + 2 | 0] << 16 | d[l + 3 | 0] << 24), t[P + 124 >> 2] = w, l = t[P + 12 >> 2], Ce = t[P + 8 >> 2], c[P + 175 | 0] = Ce, w = t[P + 20 >> 2], Me = t[P + 16 >> 2], c[P + 167 | 0] = Me, K = t[P + 28 >> 2], Tt = t[P + 24 >> 2], c[P + 159 | 0] = Tt, pe = t[P + 36 >> 2], tr = t[P + 32 >> 2], c[P + 151 | 0] = tr, c[P + 174 | 0] = (l & 255) << 24 | Ce >>> 8, c[P + 173 | 0] = (l & 65535) << 16 | Ce >>> 16, c[P + 172 | 0] = (l & 16777215) << 8 | Ce >>> 24, c[P + 171 | 0] = l, c[P + 170 | 0] = l >>> 8, c[P + 169 | 0] = l >>> 16, c[P + 168 | 0] = l >>> 24, c[P + 166 | 0] = (w & 255) << 24 | Me >>> 8, c[P + 165 | 0] = (w & 65535) << 16 | Me >>> 16, c[P + 164 | 0] = (w & 16777215) << 8 | Me >>> 24, c[P + 163 | 0] = w, c[P + 162 | 0] = w >>> 8, c[P + 161 | 0] = w >>> 16, c[P + 160 | 0] = w >>> 24, c[P + 158 | 0] = (K & 255) << 24 | Tt >>> 8, c[P + 157 | 0] = (K & 65535) << 16 | Tt >>> 16, c[P + 156 | 0] = (K & 16777215) << 8 | Tt >>> 24, c[P + 155 | 0] = K, c[P + 154 | 0] = K >>> 8, c[P + 153 | 0] = K >>> 16, c[P + 152 | 0] = K >>> 24, c[P + 150 | 0] = (pe & 255) << 24 | tr >>> 8, c[P + 149 | 0] = (pe & 65535) << 16 | tr >>> 16, c[P + 148 | 0] = (pe & 16777215) << 8 | tr >>> 24, c[P + 147 | 0] = pe, c[P + 146 | 0] = pe >>> 8, c[P + 145 | 0] = pe >>> 16, c[P + 144 | 0] = pe >>> 24, a ? (l = a + 24 | 0, w = d[l + 4 | 0] | d[l + 5 | 0] << 8 | (d[l + 6 | 0] << 16 | d[l + 7 | 0] << 24), K = P + 200 | 0, t[K >> 2] = d[l | 0] | d[l + 1 | 0] << 8 | (d[l + 2 | 0] << 16 | d[l + 3 | 0] << 24), t[K + 4 >> 2] = w, l = a + 16 | 0, w = d[l + 4 | 0] | d[l + 5 | 0] << 8 | (d[l + 6 | 0] << 16 | d[l + 7 | 0] << 24), K = P + 192 | 0, t[K >> 2] = d[l | 0] | d[l + 1 | 0] << 8 | (d[l + 2 | 0] << 16 | d[l + 3 | 0] << 24), t[K + 4 >> 2] = w, l = a + 8 | 0, w = d[l + 4 | 0] | d[l + 5 | 0] << 8 | (d[l + 6 | 0] << 16 | d[l + 7 | 0] << 24), K = P + 184 | 0, t[K >> 2] = d[l | 0] | d[l + 1 | 0] << 8 | (d[l + 2 | 0] << 16 | d[l + 3 | 0] << 24), t[K + 4 >> 2] = w, l = d[a + 4 | 0] | d[a + 5 | 0] << 8 | (d[a + 6 | 0] << 16 | d[a + 7 | 0] << 24), t[P + 176 >> 2] = d[a | 0] | d[a + 1 | 0] << 8 | (d[a + 2 | 0] << 16 | d[a + 3 | 0] << 24), t[P + 180 >> 2] = l, w = 96) : w = 64, n && (a = d[n + 4 | 0] | d[n + 5 | 0] << 8 | (d[n + 6 | 0] << 16 | d[n + 7 | 0] << 24), l = (P + 112 | 0) + w | 0, K = d[n | 0] | d[n + 1 | 0] << 8 | (d[n + 2 | 0] << 16 | d[n + 3 | 0] << 24), c[l | 0] = K, c[l + 1 | 0] = K >>> 8, c[l + 2 | 0] = K >>> 16, c[l + 3 | 0] = K >>> 24, c[l + 4 | 0] = a, c[l + 5 | 0] = a >>> 8, c[l + 6 | 0] = a >>> 16, c[l + 7 | 0] = a >>> 24, n = n + 8 | 0, a = d[n + 4 | 0] | d[n + 5 | 0] << 8 | (d[n + 6 | 0] << 16 | d[n + 7 | 0] << 24), l = l + 8 | 0, n = d[n | 0] | d[n + 1 | 0] << 8 | (d[n + 2 | 0] << 16 | d[n + 3 | 0] << 24), c[l | 0] = n, c[l + 1 | 0] = n >>> 8, c[l + 2 | 0] = n >>> 16, c[l + 3 | 0] = n >>> 24, c[l + 4 | 0] = a, c[l + 5 | 0] = a >>> 8, c[l + 6 | 0] = a >>> 16, c[l + 7 | 0] = a >>> 24, w = w | 16), l = P + 112 | 0, bi(P + 40 | 0, l, w), w = 0, is(l, 112); Ri(P + 40 | 0, C), w = w + 1 | 0, b >>> 0 >= w >>> 0; )
      ;
    return U = P + 224 | 0, 1;
  }
  function bi(C, l, w) {
    var n = 0, a = 0, b = 0, P = 0, K = 0, pe = 0, Ce = 0;
    for (n = U - 272 | 0, U = n, t[C >> 2] = 16843009, t[C + 4 >> 2] = 16843009, t[C + 32 >> 2] = 0, t[C + 36 >> 2] = 0, P = C + 24 | 0, t[P >> 2] = 16843009, t[P + 4 >> 2] = 16843009, P = C + 16 | 0, t[P >> 2] = 16843009, t[P + 4 >> 2] = 16843009, P = C + 8 | 0, t[P >> 2] = 16843009, t[P + 4 >> 2] = 16843009, P = C + 40 | 0, t[P >> 2] = 0, t[P + 4 >> 2] = 0, P = C + 48 | 0, t[P >> 2] = 0, t[P + 4 >> 2] = 0, P = C + 56 | 0, t[P >> 2] = 0, t[P + 4 >> 2] = 0, P = n + 128 | 0, t[P >> 2] = 528734635, t[P + 4 >> 2] = 1541459225, P = n + 120 | 0, t[P >> 2] = 1359893119, t[P + 4 >> 2] = -1694144372, P = n + 112 | 0, t[P >> 2] = 1013904242, t[P + 4 >> 2] = -1521486534, P = n + 200 | 0, t[P >> 2] = 0, t[P + 4 >> 2] = 0, P = n + 208 | 0, a = P + 56 | 0, t[a >> 2] = 0, t[a + 4 >> 2] = 0, a = P + 48 | 0, t[a >> 2] = 0, t[a + 4 >> 2] = 0, a = P + 40 | 0, t[a >> 2] = 0, t[a + 4 >> 2] = 0, a = P + 32 | 0, t[a >> 2] = 0, t[a + 4 >> 2] = 0, a = P + 24 | 0, t[a >> 2] = 0, t[a + 4 >> 2] = 0, P = P + 16 | 0, t[P >> 2] = 0, t[P + 4 >> 2] = 0, t[n + 104 >> 2] = 1779033703, t[n + 108 >> 2] = -1150833019, t[n + 216 >> 2] = 0, t[n + 220 >> 2] = 0, t[n + 208 >> 2] = 0, t[n + 212 >> 2] = 0, P = C + 32 | 0, pe = n + 104 | 0, a = 0; b = (n + 208 | 0) + a | 0, c[b | 0] = d[b | 0] ^ 92, K = b + 1 | 0, c[K | 0] = d[K | 0] ^ 92, K = b + 2 | 0, c[K | 0] = d[K | 0] ^ 92, b = b + 3 | 0, c[b | 0] = d[b | 0] ^ 92, a = a + 4 | 0, (a | 0) != 64; )
      ;
    for (Wr(pe, n + 208 | 0, 64), t[n + 96 >> 2] = 0, t[n + 100 >> 2] = 0, t[n + 24 >> 2] = 528734635, t[n + 28 >> 2] = 1541459225, t[n + 16 >> 2] = 1359893119, t[n + 20 >> 2] = -1694144372, t[n + 8 >> 2] = 1013904242, t[n + 12 >> 2] = -1521486534, t[n >> 2] = 1779033703, t[n + 4 >> 2] = -1150833019, a = 0; b = (n + 208 | 0) + a | 0, c[b | 0] = d[b | 0] ^ 106, K = b + 1 | 0, c[K | 0] = d[K | 0] ^ 106, K = b + 2 | 0, c[K | 0] = d[K | 0] ^ 106, b = b + 3 | 0, c[b | 0] = d[b | 0] ^ 106, a = a + 4 | 0, (a | 0) != 64; )
      ;
    for (b = n + 208 | 0, Wr(n, b, 64), Wr(n, C, 32), Wr(n, 690368, 1), Wr(n, l, w), fi(n, b), Wr(pe, b, 32), fi(pe, P), a = n + 248 | 0, t[a >> 2] = 0, t[a + 4 >> 2] = 0, a = n + 256 | 0, t[a >> 2] = 0, t[a + 4 >> 2] = 0, a = n + 264 | 0, t[a >> 2] = 0, t[a + 4 >> 2] = 0, a = P + 24 | 0, K = d[a + 4 | 0] | d[a + 5 | 0] << 8 | (d[a + 6 | 0] << 16 | d[a + 7 | 0] << 24), Ce = b + 24 | 0, t[Ce >> 2] = d[a | 0] | d[a + 1 | 0] << 8 | (d[a + 2 | 0] << 16 | d[a + 3 | 0] << 24), t[Ce + 4 >> 2] = K, a = P + 16 | 0, K = d[a + 4 | 0] | d[a + 5 | 0] << 8 | (d[a + 6 | 0] << 16 | d[a + 7 | 0] << 24), b = b + 16 | 0, t[b >> 2] = d[a | 0] | d[a + 1 | 0] << 8 | (d[a + 2 | 0] << 16 | d[a + 3 | 0] << 24), t[b + 4 >> 2] = K, t[n + 200 >> 2] = 0, t[n + 204 >> 2] = 0, t[n + 128 >> 2] = 528734635, t[n + 132 >> 2] = 1541459225, t[n + 120 >> 2] = 1359893119, t[n + 124 >> 2] = -1694144372, t[n + 112 >> 2] = 1013904242, t[n + 116 >> 2] = -1521486534, t[n + 104 >> 2] = 1779033703, t[n + 108 >> 2] = -1150833019, t[n + 240 >> 2] = 0, t[n + 244 >> 2] = 0, a = P + 8 | 0, b = d[a + 4 | 0] | d[a + 5 | 0] << 8 | (d[a + 6 | 0] << 16 | d[a + 7 | 0] << 24), t[n + 216 >> 2] = d[a | 0] | d[a + 1 | 0] << 8 | (d[a + 2 | 0] << 16 | d[a + 3 | 0] << 24), t[n + 220 >> 2] = b, a = d[P + 4 | 0] | d[P + 5 | 0] << 8 | (d[P + 6 | 0] << 16 | d[P + 7 | 0] << 24), t[n + 208 >> 2] = d[P | 0] | d[P + 1 | 0] << 8 | (d[P + 2 | 0] << 16 | d[P + 3 | 0] << 24), t[n + 212 >> 2] = a, a = 0; b = (n + 208 | 0) + a | 0, c[b | 0] = d[b | 0] ^ 92, K = b + 1 | 0, c[K | 0] = d[K | 0] ^ 92, K = b + 2 | 0, c[K | 0] = d[K | 0] ^ 92, b = b + 3 | 0, c[b | 0] = d[b | 0] ^ 92, a = a + 4 | 0, (a | 0) != 64; )
      ;
    for (Wr(pe, n + 208 | 0, 64), t[n + 96 >> 2] = 0, t[n + 100 >> 2] = 0, t[n + 24 >> 2] = 528734635, t[n + 28 >> 2] = 1541459225, t[n + 16 >> 2] = 1359893119, t[n + 20 >> 2] = -1694144372, t[n + 8 >> 2] = 1013904242, t[n + 12 >> 2] = -1521486534, t[n >> 2] = 1779033703, t[n + 4 >> 2] = -1150833019, a = 0; b = (n + 208 | 0) + a | 0, c[b | 0] = d[b | 0] ^ 106, K = b + 1 | 0, c[K | 0] = d[K | 0] ^ 106, K = b + 2 | 0, c[K | 0] = d[K | 0] ^ 106, b = b + 3 | 0, c[b | 0] = d[b | 0] ^ 106, a = a + 4 | 0, (a | 0) != 64; )
      ;
    for (b = n + 208 | 0, Wr(n, b, 64), Wr(n, C, 32), fi(n, b), Wr(pe, b, 32), fi(pe, C), a = n + 248 | 0, t[a >> 2] = 0, t[a + 4 >> 2] = 0, a = n + 256 | 0, t[a >> 2] = 0, t[a + 4 >> 2] = 0, a = n + 264 | 0, t[a >> 2] = 0, t[a + 4 >> 2] = 0, a = P + 24 | 0, K = d[a + 4 | 0] | d[a + 5 | 0] << 8 | (d[a + 6 | 0] << 16 | d[a + 7 | 0] << 24), Ce = b + 24 | 0, t[Ce >> 2] = d[a | 0] | d[a + 1 | 0] << 8 | (d[a + 2 | 0] << 16 | d[a + 3 | 0] << 24), t[Ce + 4 >> 2] = K, a = P + 16 | 0, K = d[a + 4 | 0] | d[a + 5 | 0] << 8 | (d[a + 6 | 0] << 16 | d[a + 7 | 0] << 24), b = b + 16 | 0, t[b >> 2] = d[a | 0] | d[a + 1 | 0] << 8 | (d[a + 2 | 0] << 16 | d[a + 3 | 0] << 24), t[b + 4 >> 2] = K, t[n + 200 >> 2] = 0, t[n + 204 >> 2] = 0, t[n + 128 >> 2] = 528734635, t[n + 132 >> 2] = 1541459225, t[n + 120 >> 2] = 1359893119, t[n + 124 >> 2] = -1694144372, t[n + 112 >> 2] = 1013904242, t[n + 116 >> 2] = -1521486534, t[n + 104 >> 2] = 1779033703, t[n + 108 >> 2] = -1150833019, t[n + 240 >> 2] = 0, t[n + 244 >> 2] = 0, a = P + 8 | 0, b = d[a + 4 | 0] | d[a + 5 | 0] << 8 | (d[a + 6 | 0] << 16 | d[a + 7 | 0] << 24), t[n + 216 >> 2] = d[a | 0] | d[a + 1 | 0] << 8 | (d[a + 2 | 0] << 16 | d[a + 3 | 0] << 24), t[n + 220 >> 2] = b, a = d[P + 4 | 0] | d[P + 5 | 0] << 8 | (d[P + 6 | 0] << 16 | d[P + 7 | 0] << 24), t[n + 208 >> 2] = d[P | 0] | d[P + 1 | 0] << 8 | (d[P + 2 | 0] << 16 | d[P + 3 | 0] << 24), t[n + 212 >> 2] = a, a = 0; b = (n + 208 | 0) + a | 0, c[b | 0] = d[b | 0] ^ 92, K = b + 1 | 0, c[K | 0] = d[K | 0] ^ 92, K = b + 2 | 0, c[K | 0] = d[K | 0] ^ 92, b = b + 3 | 0, c[b | 0] = d[b | 0] ^ 92, a = a + 4 | 0, (a | 0) != 64; )
      ;
    for (Wr(pe, n + 208 | 0, 64), t[n + 96 >> 2] = 0, t[n + 100 >> 2] = 0, t[n + 24 >> 2] = 528734635, t[n + 28 >> 2] = 1541459225, t[n + 16 >> 2] = 1359893119, t[n + 20 >> 2] = -1694144372, t[n + 8 >> 2] = 1013904242, t[n + 12 >> 2] = -1521486534, t[n >> 2] = 1779033703, t[n + 4 >> 2] = -1150833019, a = 0; b = (n + 208 | 0) + a | 0, c[b | 0] = d[b | 0] ^ 106, K = b + 1 | 0, c[K | 0] = d[K | 0] ^ 106, K = b + 2 | 0, c[K | 0] = d[K | 0] ^ 106, b = b + 3 | 0, c[b | 0] = d[b | 0] ^ 106, a = a + 4 | 0, (a | 0) != 64; )
      ;
    for (a = n + 208 | 0, Wr(n, a, 64), Wr(n, C, 32), Wr(n, 690369, 1), Wr(n, l, w), fi(n, a), Wr(pe, a, 32), fi(pe, P), l = n + 248 | 0, t[l >> 2] = 0, t[l + 4 >> 2] = 0, l = n + 256 | 0, t[l >> 2] = 0, t[l + 4 >> 2] = 0, l = n + 264 | 0, t[l >> 2] = 0, t[l + 4 >> 2] = 0, l = P + 24 | 0, w = d[l + 4 | 0] | d[l + 5 | 0] << 8 | (d[l + 6 | 0] << 16 | d[l + 7 | 0] << 24), b = a + 24 | 0, t[b >> 2] = d[l | 0] | d[l + 1 | 0] << 8 | (d[l + 2 | 0] << 16 | d[l + 3 | 0] << 24), t[b + 4 >> 2] = w, l = P + 16 | 0, w = d[l + 4 | 0] | d[l + 5 | 0] << 8 | (d[l + 6 | 0] << 16 | d[l + 7 | 0] << 24), a = a + 16 | 0, t[a >> 2] = d[l | 0] | d[l + 1 | 0] << 8 | (d[l + 2 | 0] << 16 | d[l + 3 | 0] << 24), t[a + 4 >> 2] = w, t[n + 200 >> 2] = 0, t[n + 204 >> 2] = 0, t[n + 128 >> 2] = 528734635, t[n + 132 >> 2] = 1541459225, t[n + 120 >> 2] = 1359893119, t[n + 124 >> 2] = -1694144372, t[n + 112 >> 2] = 1013904242, t[n + 116 >> 2] = -1521486534, t[n + 104 >> 2] = 1779033703, t[n + 108 >> 2] = -1150833019, t[n + 240 >> 2] = 0, t[n + 244 >> 2] = 0, l = P + 8 | 0, w = d[l + 4 | 0] | d[l + 5 | 0] << 8 | (d[l + 6 | 0] << 16 | d[l + 7 | 0] << 24), t[n + 216 >> 2] = d[l | 0] | d[l + 1 | 0] << 8 | (d[l + 2 | 0] << 16 | d[l + 3 | 0] << 24), t[n + 220 >> 2] = w, l = d[P + 4 | 0] | d[P + 5 | 0] << 8 | (d[P + 6 | 0] << 16 | d[P + 7 | 0] << 24), t[n + 208 >> 2] = d[P | 0] | d[P + 1 | 0] << 8 | (d[P + 2 | 0] << 16 | d[P + 3 | 0] << 24), t[n + 212 >> 2] = l, a = 0; l = (n + 208 | 0) + a | 0, c[l | 0] = d[l | 0] ^ 92, w = l + 1 | 0, c[w | 0] = d[w | 0] ^ 92, w = l + 2 | 0, c[w | 0] = d[w | 0] ^ 92, l = l + 3 | 0, c[l | 0] = d[l | 0] ^ 92, a = a + 4 | 0, (a | 0) != 64; )
      ;
    for (Wr(pe, n + 208 | 0, 64), t[n + 96 >> 2] = 0, t[n + 100 >> 2] = 0, t[n + 24 >> 2] = 528734635, t[n + 28 >> 2] = 1541459225, t[n + 16 >> 2] = 1359893119, t[n + 20 >> 2] = -1694144372, t[n + 8 >> 2] = 1013904242, t[n + 12 >> 2] = -1521486534, t[n >> 2] = 1779033703, t[n + 4 >> 2] = -1150833019, a = 0; l = (n + 208 | 0) + a | 0, c[l | 0] = d[l | 0] ^ 106, w = l + 1 | 0, c[w | 0] = d[w | 0] ^ 106, w = l + 2 | 0, c[w | 0] = d[w | 0] ^ 106, l = l + 3 | 0, c[l | 0] = d[l | 0] ^ 106, a = a + 4 | 0, (a | 0) != 64; )
      ;
    l = n + 208 | 0, Wr(n, l, 64), Wr(n, C, 32), fi(n, l), Wr(pe, l, 32), fi(pe, C), t[C + 64 >> 2] = 0, U = n + 272 | 0;
  }
  function Ri(C, l) {
    var w = 0, n = 0, a = 0, b = 0, P = 0, K = 0, pe = 0;
    if (a = U - 272 | 0, U = a, t[C + 64 >> 2]) {
      for (w = a + 208 | 0, n = w + 40 | 0, t[n >> 2] = 0, t[n + 4 >> 2] = 0, n = w + 48 | 0, t[n >> 2] = 0, t[n + 4 >> 2] = 0, w = w + 56 | 0, t[w >> 2] = 0, t[w + 4 >> 2] = 0, w = a + 200 | 0, t[w >> 2] = 0, t[w + 4 >> 2] = 0, w = a + 128 | 0, t[w >> 2] = 528734635, t[w + 4 >> 2] = 1541459225, w = a + 120 | 0, t[w >> 2] = 1359893119, t[w + 4 >> 2] = -1694144372, w = a + 112 | 0, t[w >> 2] = 1013904242, t[w + 4 >> 2] = -1521486534, w = C + 56 | 0, n = d[w + 4 | 0] | d[w + 5 | 0] << 8 | (d[w + 6 | 0] << 16 | d[w + 7 | 0] << 24), P = a + 232 | 0, t[P >> 2] = d[w | 0] | d[w + 1 | 0] << 8 | (d[w + 2 | 0] << 16 | d[w + 3 | 0] << 24), t[P + 4 >> 2] = n, w = C + 48 | 0, n = d[w + 4 | 0] | d[w + 5 | 0] << 8 | (d[w + 6 | 0] << 16 | d[w + 7 | 0] << 24), P = a + 224 | 0, t[P >> 2] = d[w | 0] | d[w + 1 | 0] << 8 | (d[w + 2 | 0] << 16 | d[w + 3 | 0] << 24), t[P + 4 >> 2] = n, t[a + 104 >> 2] = 1779033703, t[a + 108 >> 2] = -1150833019, t[a + 240 >> 2] = 0, t[a + 244 >> 2] = 0, w = C + 40 | 0, n = d[w + 4 | 0] | d[w + 5 | 0] << 8 | (d[w + 6 | 0] << 16 | d[w + 7 | 0] << 24), t[a + 216 >> 2] = d[w | 0] | d[w + 1 | 0] << 8 | (d[w + 2 | 0] << 16 | d[w + 3 | 0] << 24), t[a + 220 >> 2] = n, w = d[C + 36 | 0] | d[C + 37 | 0] << 8 | (d[C + 38 | 0] << 16 | d[C + 39 | 0] << 24), t[a + 208 >> 2] = d[C + 32 | 0] | d[C + 33 | 0] << 8 | (d[C + 34 | 0] << 16 | d[C + 35 | 0] << 24), t[a + 212 >> 2] = w, w = C + 32 | 0, P = a + 104 | 0, n = 0; b = (a + 208 | 0) + n | 0, c[b | 0] = d[b | 0] ^ 92, K = b + 1 | 0, c[K | 0] = d[K | 0] ^ 92, K = b + 2 | 0, c[K | 0] = d[K | 0] ^ 92, b = b + 3 | 0, c[b | 0] = d[b | 0] ^ 92, n = n + 4 | 0, (n | 0) != 64; )
        ;
      for (Wr(P, a + 208 | 0, 64), t[a + 96 >> 2] = 0, t[a + 100 >> 2] = 0, t[a + 24 >> 2] = 528734635, t[a + 28 >> 2] = 1541459225, t[a + 16 >> 2] = 1359893119, t[a + 20 >> 2] = -1694144372, t[a + 8 >> 2] = 1013904242, t[a + 12 >> 2] = -1521486534, t[a >> 2] = 1779033703, t[a + 4 >> 2] = -1150833019, n = 0; b = (a + 208 | 0) + n | 0, c[b | 0] = d[b | 0] ^ 106, K = b + 1 | 0, c[K | 0] = d[K | 0] ^ 106, K = b + 2 | 0, c[K | 0] = d[K | 0] ^ 106, b = b + 3 | 0, c[b | 0] = d[b | 0] ^ 106, n = n + 4 | 0, (n | 0) != 64; )
        ;
      for (b = a + 208 | 0, Wr(a, b, 64), Wr(a, C, 32), Wr(a, 690370, 1), fi(a, b), Wr(P, b, 32), fi(P, w), n = a + 248 | 0, t[n >> 2] = 0, t[n + 4 >> 2] = 0, n = a + 256 | 0, t[n >> 2] = 0, t[n + 4 >> 2] = 0, n = a + 264 | 0, t[n >> 2] = 0, t[n + 4 >> 2] = 0, n = w + 24 | 0, K = d[n + 4 | 0] | d[n + 5 | 0] << 8 | (d[n + 6 | 0] << 16 | d[n + 7 | 0] << 24), pe = b + 24 | 0, t[pe >> 2] = d[n | 0] | d[n + 1 | 0] << 8 | (d[n + 2 | 0] << 16 | d[n + 3 | 0] << 24), t[pe + 4 >> 2] = K, n = w + 16 | 0, K = d[n + 4 | 0] | d[n + 5 | 0] << 8 | (d[n + 6 | 0] << 16 | d[n + 7 | 0] << 24), b = b + 16 | 0, t[b >> 2] = d[n | 0] | d[n + 1 | 0] << 8 | (d[n + 2 | 0] << 16 | d[n + 3 | 0] << 24), t[b + 4 >> 2] = K, t[a + 200 >> 2] = 0, t[a + 204 >> 2] = 0, t[a + 128 >> 2] = 528734635, t[a + 132 >> 2] = 1541459225, t[a + 120 >> 2] = 1359893119, t[a + 124 >> 2] = -1694144372, t[a + 112 >> 2] = 1013904242, t[a + 116 >> 2] = -1521486534, t[a + 104 >> 2] = 1779033703, t[a + 108 >> 2] = -1150833019, t[a + 240 >> 2] = 0, t[a + 244 >> 2] = 0, n = w + 8 | 0, b = d[n + 4 | 0] | d[n + 5 | 0] << 8 | (d[n + 6 | 0] << 16 | d[n + 7 | 0] << 24), t[a + 216 >> 2] = d[n | 0] | d[n + 1 | 0] << 8 | (d[n + 2 | 0] << 16 | d[n + 3 | 0] << 24), t[a + 220 >> 2] = b, n = d[w + 4 | 0] | d[w + 5 | 0] << 8 | (d[w + 6 | 0] << 16 | d[w + 7 | 0] << 24), t[a + 208 >> 2] = d[w | 0] | d[w + 1 | 0] << 8 | (d[w + 2 | 0] << 16 | d[w + 3 | 0] << 24), t[a + 212 >> 2] = n, n = 0; w = (a + 208 | 0) + n | 0, c[w | 0] = d[w | 0] ^ 92, b = w + 1 | 0, c[b | 0] = d[b | 0] ^ 92, b = w + 2 | 0, c[b | 0] = d[b | 0] ^ 92, w = w + 3 | 0, c[w | 0] = d[w | 0] ^ 92, n = n + 4 | 0, (n | 0) != 64; )
        ;
      for (Wr(P, a + 208 | 0, 64), t[a + 96 >> 2] = 0, t[a + 100 >> 2] = 0, t[a + 24 >> 2] = 528734635, t[a + 28 >> 2] = 1541459225, t[a + 16 >> 2] = 1359893119, t[a + 20 >> 2] = -1694144372, t[a + 8 >> 2] = 1013904242, t[a + 12 >> 2] = -1521486534, t[a >> 2] = 1779033703, t[a + 4 >> 2] = -1150833019, n = 0; w = (a + 208 | 0) + n | 0, c[w | 0] = d[w | 0] ^ 106, b = w + 1 | 0, c[b | 0] = d[b | 0] ^ 106, b = w + 2 | 0, c[b | 0] = d[b | 0] ^ 106, w = w + 3 | 0, c[w | 0] = d[w | 0] ^ 106, n = n + 4 | 0, (n | 0) != 64; )
        ;
      w = a + 208 | 0, Wr(a, w, 64), Wr(a, C, 32), fi(a, w), Wr(P, w, 32), fi(P, C);
    }
    for (w = a + 208 | 0, n = w + 40 | 0, t[n >> 2] = 0, t[n + 4 >> 2] = 0, n = w + 48 | 0, t[n >> 2] = 0, t[n + 4 >> 2] = 0, w = w + 56 | 0, t[w >> 2] = 0, t[w + 4 >> 2] = 0, w = a + 200 | 0, t[w >> 2] = 0, t[w + 4 >> 2] = 0, w = a + 128 | 0, t[w >> 2] = 528734635, t[w + 4 >> 2] = 1541459225, w = a + 120 | 0, t[w >> 2] = 1359893119, t[w + 4 >> 2] = -1694144372, w = a + 112 | 0, t[w >> 2] = 1013904242, t[w + 4 >> 2] = -1521486534, w = C + 56 | 0, n = d[w + 4 | 0] | d[w + 5 | 0] << 8 | (d[w + 6 | 0] << 16 | d[w + 7 | 0] << 24), P = a + 232 | 0, t[P >> 2] = d[w | 0] | d[w + 1 | 0] << 8 | (d[w + 2 | 0] << 16 | d[w + 3 | 0] << 24), t[P + 4 >> 2] = n, w = C + 48 | 0, n = d[w + 4 | 0] | d[w + 5 | 0] << 8 | (d[w + 6 | 0] << 16 | d[w + 7 | 0] << 24), P = a + 224 | 0, t[P >> 2] = d[w | 0] | d[w + 1 | 0] << 8 | (d[w + 2 | 0] << 16 | d[w + 3 | 0] << 24), t[P + 4 >> 2] = n, t[a + 104 >> 2] = 1779033703, t[a + 108 >> 2] = -1150833019, t[a + 240 >> 2] = 0, t[a + 244 >> 2] = 0, w = C + 40 | 0, n = d[w + 4 | 0] | d[w + 5 | 0] << 8 | (d[w + 6 | 0] << 16 | d[w + 7 | 0] << 24), t[a + 216 >> 2] = d[w | 0] | d[w + 1 | 0] << 8 | (d[w + 2 | 0] << 16 | d[w + 3 | 0] << 24), t[a + 220 >> 2] = n, w = d[C + 36 | 0] | d[C + 37 | 0] << 8 | (d[C + 38 | 0] << 16 | d[C + 39 | 0] << 24), t[a + 208 >> 2] = d[C + 32 | 0] | d[C + 33 | 0] << 8 | (d[C + 34 | 0] << 16 | d[C + 35 | 0] << 24), t[a + 212 >> 2] = w, P = a + 104 | 0, n = 0; w = (a + 208 | 0) + n | 0, c[w | 0] = d[w | 0] ^ 92, b = w + 1 | 0, c[b | 0] = d[b | 0] ^ 92, b = w + 2 | 0, c[b | 0] = d[b | 0] ^ 92, w = w + 3 | 0, c[w | 0] = d[w | 0] ^ 92, n = n + 4 | 0, (n | 0) != 64; )
      ;
    for (Wr(P, a + 208 | 0, 64), t[a + 96 >> 2] = 0, t[a + 100 >> 2] = 0, t[a + 24 >> 2] = 528734635, t[a + 28 >> 2] = 1541459225, t[a + 16 >> 2] = 1359893119, t[a + 20 >> 2] = -1694144372, t[a + 8 >> 2] = 1013904242, t[a + 12 >> 2] = -1521486534, t[a >> 2] = 1779033703, t[a + 4 >> 2] = -1150833019, n = 0; w = (a + 208 | 0) + n | 0, c[w | 0] = d[w | 0] ^ 106, b = w + 1 | 0, c[b | 0] = d[b | 0] ^ 106, b = w + 2 | 0, c[b | 0] = d[b | 0] ^ 106, w = w + 3 | 0, c[w | 0] = d[w | 0] ^ 106, n = n + 4 | 0, (n | 0) != 64; )
      ;
    w = a + 208 | 0, Wr(a, w, 64), Wr(a, C, 32), fi(a, w), Wr(P, w, 32), fi(P, C), w = C + 24 | 0, P = d[w + 4 | 0] | d[w + 5 | 0] << 8 | (d[w + 6 | 0] << 16 | d[w + 7 | 0] << 24), n = l + 24 | 0, w = d[w | 0] | d[w + 1 | 0] << 8 | (d[w + 2 | 0] << 16 | d[w + 3 | 0] << 24), c[n | 0] = w, c[n + 1 | 0] = w >>> 8, c[n + 2 | 0] = w >>> 16, c[n + 3 | 0] = w >>> 24, c[n + 4 | 0] = P, c[n + 5 | 0] = P >>> 8, c[n + 6 | 0] = P >>> 16, c[n + 7 | 0] = P >>> 24, w = C + 16 | 0, P = d[w + 4 | 0] | d[w + 5 | 0] << 8 | (d[w + 6 | 0] << 16 | d[w + 7 | 0] << 24), n = l + 16 | 0, w = d[w | 0] | d[w + 1 | 0] << 8 | (d[w + 2 | 0] << 16 | d[w + 3 | 0] << 24), c[n | 0] = w, c[n + 1 | 0] = w >>> 8, c[n + 2 | 0] = w >>> 16, c[n + 3 | 0] = w >>> 24, c[n + 4 | 0] = P, c[n + 5 | 0] = P >>> 8, c[n + 6 | 0] = P >>> 16, c[n + 7 | 0] = P >>> 24, w = C + 8 | 0, P = d[w + 4 | 0] | d[w + 5 | 0] << 8 | (d[w + 6 | 0] << 16 | d[w + 7 | 0] << 24), n = l + 8 | 0, w = d[w | 0] | d[w + 1 | 0] << 8 | (d[w + 2 | 0] << 16 | d[w + 3 | 0] << 24), c[n | 0] = w, c[n + 1 | 0] = w >>> 8, c[n + 2 | 0] = w >>> 16, c[n + 3 | 0] = w >>> 24, c[n + 4 | 0] = P, c[n + 5 | 0] = P >>> 8, c[n + 6 | 0] = P >>> 16, c[n + 7 | 0] = P >>> 24, w = d[C + 4 | 0] | d[C + 5 | 0] << 8 | (d[C + 6 | 0] << 16 | d[C + 7 | 0] << 24), n = d[C | 0] | d[C + 1 | 0] << 8 | (d[C + 2 | 0] << 16 | d[C + 3 | 0] << 24), c[l | 0] = n, c[l + 1 | 0] = n >>> 8, c[l + 2 | 0] = n >>> 16, c[l + 3 | 0] = n >>> 24, c[l + 4 | 0] = w, c[l + 5 | 0] = w >>> 8, c[l + 6 | 0] = w >>> 16, c[l + 7 | 0] = w >>> 24, t[C + 64 >> 2] = 1, U = a + 272 | 0;
  }
  function li(C, l, w, n, a, b) {
    var P = 0, K = 0, pe = 0, Ce = 0, Me = 0, Tt = 0, tr = 0, nr = 0, or = 0, lr = 0, gr = 0, kr = 0, Nr = 0, jr = 0, Yr = 0, ei = 0, ai = 0, ui = 0, di = 0, Ii = 0, wi = 0, Ei = 0, Ti = 0, Di = 0, Qi = 0, Li = 0, Ki = 0;
    Tt = U - 464 | 0, U = Tt, P = l + 24 | 0, t[P >> 2] = 0, t[P + 4 >> 2] = 0, P = l + 16 | 0, t[P >> 2] = 0, t[P + 4 >> 2] = 0, P = l + 8 | 0, t[P >> 2] = 0, t[P + 4 >> 2] = 0, t[l >> 2] = 0, t[l + 4 >> 2] = 0, P = w + 24 | 0, t[P >> 2] = 0, t[P + 4 >> 2] = 0, P = w + 16 | 0, t[P >> 2] = 0, t[P + 4 >> 2] = 0, P = w + 8 | 0, t[P >> 2] = 0, t[P + 4 >> 2] = 0, t[w >> 2] = 0, t[w + 4 >> 2] = 0, n && (t[n >> 2] = 0), Ir(Tt + 96 | 0, 690788, Tt + 256 | 0), or = t[Tt + 120 >> 2], nr = t[Tt + 112 >> 2], Me = t[Tt + 104 >> 2], tr = t[Tt + 96 >> 2], Nr = t[Tt + 124 >> 2], gr = t[Tt + 116 >> 2], pe = t[Tt + 108 >> 2], lr = t[Tt + 100 >> 2], K = t[Tt + 256 >> 2] | !(or | (nr | (Me | tr)) | (Nr | (gr | (pe | lr)))), P = K ? 0 : -1, t[Tt + 120 >> 2] = P & or, t[Tt + 124 >> 2] = P & Nr, t[Tt + 112 >> 2] = P & nr, t[Tt + 116 >> 2] = P & gr, t[Tt + 104 >> 2] = P & Me, t[Tt + 108 >> 2] = P & pe, t[Tt + 96 >> 2] = P & tr | (K | 0) != 0, t[Tt + 100 >> 2] = P & lr, Ir(Tt + 32 | 0, 655649, 0), Li = !K, Ti = a || 4;
    e: {
      if (!(yi[Ti | 0](Tt, 655649, 690788, 0, b, 0) | 0))
        break e;
      for (a = 1; ; ) {
        Di = a, Ir(Tt - -64 | 0, Tt, Tt + 256 | 0);
        t: {
          if (t[Tt + 256 >> 2] | !(t[Tt + 88 >> 2] | (t[Tt + 80 >> 2] | (t[Tt + 72 >> 2] | t[Tt + 64 >> 2])) | (t[Tt + 92 >> 2] | (t[Tt + 84 >> 2] | (t[Tt + 76 >> 2] | t[Tt + 68 >> 2])))) || (t[Tt + 132 >> 2] = 0, a = Tt + 256 | 0, zi(C, a, Tt - -64 | 0), Kn(Tt + 168 | 0, a), P = Tt, gr = t[P + 232 >> 2], Nr = t[P + 236 >> 2], or = t[P + 224 >> 2], lr = t[P + 228 >> 2], Me = t[P + 216 >> 2], pe = t[P + 220 >> 2], Ce = t[P + 212 >> 2], tr = t[P + 240 >> 2], nr = t[P + 244 >> 2], Yr = nr, a = t[P + 208 >> 2], nr = ri(nr >>> 16 | 0, 0, 977, 1), K = a + nr | 0, a = Ce + ve | 0, nr = K >>> 0 < nr >>> 0 ? a + 1 | 0 : a, a = pe, Ce = nr >>> 20 | 0, kr = Ce, Ce = Me + Ce | 0, pe = kr >>> 0 > Ce >>> 0 ? a + 1 | 0 : a, a = lr, Me = pe >>> 20 | 0, lr = Me, Me = Me + or | 0, or = lr >>> 0 > Me >>> 0 ? a + 1 | 0 : a, a = Nr, lr = or >>> 20 | 0, kr = lr, lr = gr + lr | 0, a = kr >>> 0 > lr >>> 0 ? a + 1 | 0 : a, ei = Me, gr = a, Qi = or & 1048575, or = (lr & (Me & Ce)) == -1 & (a & (Qi & pe)) == 1048575, a = Yr & 65535, Me = gr >>> 20 | 0, kr = Me, Me = Me + tr | 0, Nr = kr >>> 0 > Me >>> 0 ? a + 1 | 0 : a, a = nr & 1048575, ai = Me, Me = ri(or & ((Me | 0) == -1 & (Nr | 0) == 65535) & ((a | 0) == 1048574 & K >>> 0 > 4294966318 | a >>> 0 > 1048574) | Nr >>> 16, 0, 977, 1) + K | 0, a = ve + a | 0, Ei = Me, t[P + 208 >> 2] = Me, or = K >>> 0 > Me >>> 0 ? a + 1 | 0 : a, t[P + 212 >> 2] = or & 1048575, Yr = t[P + 192 >> 2], kr = t[P + 196 >> 2], nr = t[P + 184 >> 2], ui = t[P + 188 >> 2], tr = t[P + 176 >> 2], jr = t[P + 180 >> 2], Ii = t[P + 172 >> 2], wi = t[P + 200 >> 2], Me = t[P + 204 >> 2], Ki = Me, a = t[P + 168 >> 2], K = ri(Me >>> 16 | 0, 0, 977, 1), Me = a + K | 0, a = Ii + ve | 0, Ii = K >>> 0 > Me >>> 0 ? a + 1 | 0 : a, a = jr, K = Ii >>> 20 | 0, jr = K, K = K + tr | 0, jr = jr >>> 0 > K >>> 0 ? a + 1 | 0 : a, a = ui, tr = jr >>> 20 | 0, ui = tr, tr = tr + nr | 0, di = ui >>> 0 > tr >>> 0 ? a + 1 | 0 : a, a = kr, nr = di >>> 20 | 0, Yr = nr + Yr | 0, a = nr >>> 0 > Yr >>> 0 ? a + 1 | 0 : a, nr = jr & 1048575, ui = tr, kr = a, di = di & 1048575, tr = (K & tr & Yr) == -1 & (a & (jr & di)) == 1048575, a = Ki & 65535, P = kr >>> 20 | 0, jr = P, P = P + wi | 0, jr = jr >>> 0 > P >>> 0 ? a + 1 | 0 : a, a = Ii & 1048575, wi = P, P = ri(tr & ((P | 0) == -1 & (jr | 0) == 65535) & ((a | 0) == 1048574 & Me >>> 0 > 4294966318 | a >>> 0 > 1048574) | jr >>> 16, 0, 977, 1) + Me | 0, a = ve + a | 0, a = P >>> 0 < Me >>> 0 ? a + 1 | 0 : a, Me = P, P = a, a = nr, tr = P >>> 20 | 0, nr = tr, tr = K + tr | 0, a = nr >>> 0 > tr >>> 0 ? a + 1 | 0 : a, t[Tt + 176 >> 2] = tr, K = a, t[Tt + 180 >> 2] = a & 1048575, a = pe & 1048575, or = or >>> 20 | 0, Ce = Ce + or | 0, a = or >>> 0 > Ce >>> 0 ? a + 1 | 0 : a, t[Tt + 216 >> 2] = Ce, t[Tt + 220 >> 2] = a & 1048575, Ce = a, a = Qi, Ce = (Ce >>> 20 | 0) + ei | 0, a = Ce >>> 0 < ei >>> 0 ? a + 1 | 0 : a, t[Tt + 224 >> 2] = Ce, ei = a, t[Tt + 228 >> 2] = a & 1048575, pe = Tt, Ce = Yr, kr = kr & 1048575, a = di, Yr = K, nr = (K >>> 20 | 0) + ui | 0, K = nr >>> 0 < ui >>> 0 ? a + 1 | 0 : a, a = kr, or = K >>> 20 | 0, kr = or, or = Ce + or | 0, a = kr >>> 0 > or >>> 0 ? a + 1 | 0 : a, t[pe + 192 >> 2] = or, Ce = a, t[pe + 196 >> 2] = a & 1048575, a = gr & 1048575, gr = ei >>> 20 | 0, lr = gr + lr | 0, a = gr >>> 0 > lr >>> 0 ? a + 1 | 0 : a, t[pe + 232 >> 2] = lr, lr = a, t[pe + 236 >> 2] = a & 1048575, a = jr, gr = Ce, kr = (Ce >>> 20 | 0) + wi | 0, a = kr >>> 0 < wi >>> 0 ? a + 1 | 0 : a, t[pe + 200 >> 2] = kr, Ce = a, t[pe + 204 >> 2] = a & 65535, a = Nr, lr = (lr >>> 20 | 0) + ai | 0, a = lr >>> 0 < ai >>> 0 ? a + 1 | 0 : a, t[pe + 240 >> 2] = lr, t[pe + 244 >> 2] = a & 65535, lr = nr, t[pe + 184 >> 2] = nr, a = K & 1048575, t[pe + 188 >> 2] = a, t[pe + 168 >> 2] = Me, nr = P & 1048575, t[pe + 172 >> 2] = nr, c[pe + 415 | 0] = Me, c[pe + 414 | 0] = (P & 255) << 24 | Me >>> 8, c[pe + 413 | 0] = (P & 65535) << 16 | Me >>> 16, c[pe + 412 | 0] = (P & 16777215) << 8 | Me >>> 24, c[pe + 411 | 0] = P, c[pe + 410 | 0] = P >>> 8, P = tr >>> 28 | 0, c[pe + 409 | 0] = tr << 4 | nr >>> 16, c[pe + 408 | 0] = (Yr & 15) << 28 | tr >>> 4, c[pe + 407 | 0] = (Yr & 4095) << 20 | tr >>> 12, c[pe + 406 | 0] = (Yr & 1048575) << 12 | tr >>> 20, c[pe + 405 | 0] = P | (Yr & 268435455) << 4, c[pe + 404 | 0] = Yr >>> 4, c[pe + 403 | 0] = Yr >>> 12, c[pe + 402 | 0] = lr, c[pe + 401 | 0] = (K & 255) << 24 | lr >>> 8, c[pe + 400 | 0] = (K & 65535) << 16 | lr >>> 16, c[pe + 399 | 0] = (K & 16777215) << 8 | lr >>> 24, c[pe + 398 | 0] = K, c[pe + 397 | 0] = K >>> 8, P = or >>> 28 | 0, c[pe + 396 | 0] = or << 4 | a >>> 16, c[pe + 395 | 0] = (gr & 15) << 28 | or >>> 4, c[pe + 394 | 0] = (gr & 4095) << 20 | or >>> 12, c[pe + 393 | 0] = (gr & 1048575) << 12 | or >>> 20, c[pe + 392 | 0] = P | (gr & 268435455) << 4, c[pe + 391 | 0] = gr >>> 4, c[pe + 390 | 0] = gr >>> 12, c[pe + 389 | 0] = kr, c[pe + 388 | 0] = (Ce & 255) << 24 | kr >>> 8, c[pe + 387 | 0] = (Ce & 65535) << 16 | kr >>> 16, c[pe + 386 | 0] = (Ce & 16777215) << 8 | kr >>> 24, c[pe + 385 | 0] = Ce, c[pe + 384 | 0] = Ce >>> 8, Ir(l, pe + 384 | 0, pe + 132 | 0), n && (t[n >> 2] = Ei & 1 | t[pe + 132 >> 2] << 1), ei = pe + 136 | 0, Er(ei, l, pe + 96 | 0), K = t[pe + 32 >> 2], Ce = t[pe + 136 >> 2], lr = K + Ce | 0, P = t[pe + 36 >> 2], a = P + t[pe + 140 >> 2] | 0, Me = Ce >>> 0 > lr >>> 0 ? a + 1 | 0 : a, Nr = (P | 0) == (Me | 0) & K >>> 0 > lr >>> 0 | P >>> 0 > Me >>> 0, K = t[pe + 144 >> 2], P = Nr + K | 0, a = t[pe + 148 >> 2], a = P >>> 0 < K >>> 0 ? a + 1 | 0 : a, Ce = P, P = t[pe + 40 >> 2], nr = Ce + P | 0, K = a, a = a + t[pe + 44 >> 2] | 0, tr = P >>> 0 > nr >>> 0 ? a + 1 | 0 : a, jr = t[pe + 48 >> 2], P = t[pe + 152 >> 2], or = jr + P | 0, Yr = t[pe + 52 >> 2], a = Yr + t[pe + 156 >> 2] | 0, P = P >>> 0 > or >>> 0 ? a + 1 | 0 : a, gr = or, a = !K & Ce >>> 0 < Nr >>> 0, Ce = (K | 0) == (tr | 0) & Ce >>> 0 > nr >>> 0 | K >>> 0 > tr >>> 0, K = a + Ce | 0, a = (K >>> 0 < Ce >>> 0) + P | 0, or = K + or | 0, Ce = or >>> 0 < K >>> 0 ? a + 1 | 0 : a, ai = t[pe + 56 >> 2], K = t[pe + 160 >> 2], Nr = ai + K | 0, kr = t[pe + 60 >> 2], a = kr + t[pe + 164 >> 2] | 0, K = K >>> 0 > Nr >>> 0 ? a + 1 | 0 : a, a = (P | 0) == (Yr | 0) & gr >>> 0 < jr >>> 0 | P >>> 0 < Yr >>> 0, gr = (P | 0) == (Ce | 0) & or >>> 0 < gr >>> 0 | P >>> 0 > Ce >>> 0, P = a + gr | 0, a = (P >>> 0 < gr >>> 0) + K | 0, gr = P, P = P + Nr | 0, a = gr >>> 0 > P >>> 0 ? a + 1 | 0 : a, gr = P, P = pe, Yr = a, kr = ((K | 0) == (kr | 0) & Nr >>> 0 < ai >>> 0 | K >>> 0 < kr >>> 0) + ((K | 0) == (a | 0) & gr >>> 0 < Nr >>> 0 | a >>> 0 < K >>> 0) | 0, K = (Ce | 0) == -1, pe = K & or >>> 0 < 4294967294 | (Ce | 0) != -1 | (gr & a) != -1, a = (tr | 0) == -1162945306, Nr = (pe | (a & nr >>> 0 < 2940772411 | tr >>> 0 < 3132021990)) ^ -1, jr = kr + (Nr & ((Me | 0) == -1076732276 & lr >>> 0 > 3493216576 | Me >>> 0 > 3218235020) | (Nr & (a & nr >>> 0 > 2940772411 | tr >>> 0 > 3132021990) | (or | 0) == -1 & K & (pe ^ -1))) | 0, pe = ri(jr, 0, 801750719, 1076732275), K = pe + lr | 0, a = Me + ve | 0, kr = K, t[P + 136 >> 2] = K, pe = K >>> 0 < pe >>> 0 ? a + 1 | 0 : a, t[P + 140 >> 2] = pe, K = P, P = ri(jr, 0, 1354194884, 1162945305), Nr = P + nr | 0, a = tr + ve | 0, pe = (pe | 0) == (Me | 0) & lr >>> 0 > kr >>> 0 | pe >>> 0 < Me >>> 0, Me = Nr + pe | 0, a = P >>> 0 > Nr >>> 0 ? a + 1 | 0 : a, P = a, kr = Me, t[K + 144 >> 2] = Me, pe = pe >>> 0 > Me >>> 0 ? a + 1 | 0 : a, t[K + 148 >> 2] = pe, Me = K, a = Ce, lr = or + jr | 0, K = lr >>> 0 < jr >>> 0 ? a + 1 | 0 : a, a = (P | 0) == (tr | 0) & nr >>> 0 > Nr >>> 0 | P >>> 0 < tr >>> 0, tr = (P | 0) == (pe | 0) & Nr >>> 0 > kr >>> 0 | P >>> 0 > pe >>> 0, P = a + tr | 0, a = (P >>> 0 < tr >>> 0) + K | 0, kr = P, P = P + lr | 0, a = kr >>> 0 > P >>> 0 ? a + 1 | 0 : a, t[Me + 152 >> 2] = P, t[Me + 156 >> 2] = a, Ce = (K | 0) == (Ce | 0) & or >>> 0 > lr >>> 0 | K >>> 0 < Ce >>> 0, K = (a | 0) == (K | 0) & P >>> 0 < lr >>> 0 | a >>> 0 < K >>> 0, P = Ce + K | 0, a = Yr + (P >>> 0 < K >>> 0) | 0, P = P + gr | 0, a = P >>> 0 < gr >>> 0 ? a + 1 | 0 : a, t[Me + 160 >> 2] = P, t[Me + 164 >> 2] = a, P = t[Me + 88 >> 2], K = t[Me + 92 >> 2], t[Me + 456 >> 2] = K >>> 24, t[Me + 460 >> 2] = 0, K = K << 6 | P >>> 26, Ce = t[Me + 80 >> 2], tr = t[Me + 84 >> 2], t[Me + 448 >> 2] = P << 6 | tr >>> 26, t[Me + 452 >> 2] = K & 1073741823, P = Ce, K = tr << 4 | P >>> 28, Ce = t[Me + 72 >> 2], tr = t[Me + 76 >> 2], t[Me + 440 >> 2] = P << 4 | tr >>> 28, t[Me + 444 >> 2] = K & 1073741823, P = Ce, K = tr << 2 | P >>> 30, Ce = t[Tt + 64 >> 2], Me = t[Tt + 68 >> 2], t[Tt + 432 >> 2] = P << 2 | Me >>> 30, t[Tt + 436 >> 2] = K & 1073741823, t[Tt + 424 >> 2] = Ce, t[Tt + 428 >> 2] = Me & 1073741823, Hn(Tt + 424 | 0, 690320), K = t[Tt + 456 >> 2] << 24, Me = t[Tt + 452 >> 2], a = Me >>> 6 | 0, Ce = t[Tt + 448 >> 2], t[w + 24 >> 2] = (Me & 63) << 26 | Ce >>> 6, t[w + 28 >> 2] = a | K, K = Ce << 26, Me = t[Tt + 444 >> 2], a = Me >>> 4 | 0, Ce = t[Tt + 440 >> 2], t[w + 16 >> 2] = (Me & 15) << 28 | Ce >>> 4, t[w + 20 >> 2] = a | K, K = Ce << 28, Me = t[Tt + 436 >> 2], a = Me >>> 2 | 0, Ce = t[Tt + 432 >> 2], t[w + 8 >> 2] = (Me & 3) << 30 | Ce >>> 2, t[w + 12 >> 2] = a | K, K = t[Tt + 428 >> 2], a = Ce << 30, t[w >> 2] = t[Tt + 424 >> 2], t[w + 4 >> 2] = a | K, Er(w, w, ei), a = t[w + 28 >> 2], Nr = a, a = a >>> 31 | 0, P = a ^ -1, pe = t[w + 12 >> 2], Ce = (pe | 0) == 1566010995, nr = t[w + 8 >> 2], kr = t[w + 16 >> 2], jr = t[w + 20 >> 2], Yr = t[w + 24 >> 2], P = (P & (Ce & nr >>> 0 < 1470386205 | pe >>> 0 < 1566010995) | ((kr & jr) != -1 & P | ((Nr | 0) == 2147483647 & (Yr | 0) != -1 | Nr >>> 0 < 2147483647))) ^ -1, K = t[w + 4 >> 2], tr = t[w >> 2], gr = P & ((K | 0) == -538366138 & tr >>> 0 > 1746608288 | K >>> 0 > 3756601158) | (P & (Ce & nr >>> 0 > 1470386205 | pe >>> 0 > 1566010995) | a), lr = gr ? -801750718 : 0, Me = gr ? -1 : 0, Ce = Me ^ tr, P = lr + Ce | 0, ei = gr ? -1076732276 : 0, a = ei + (K ^ Me) | 0, tr = kr | Yr | nr | tr | (Nr | jr | pe | K) ? -1 : 0, ui = P & tr, t[w >> 2] = ui, Ce = P >>> 0 < Ce >>> 0 ? a + 1 | 0 : a, wi = tr & Ce, t[w + 4 >> 2] = wi, K = w, ai = gr ? -1162945306 : 0, a = ai + (pe ^ Me) | 0, or = (Ce | 0) == (ei | 0) & P >>> 0 < lr >>> 0 | Ce >>> 0 < ei >>> 0, Ei = gr ? -1354194885 : 0, P = Me ^ nr, nr = Ei + P | 0, Ce = or + nr | 0, a = P >>> 0 > nr >>> 0 ? a + 1 | 0 : a, P = a, lr = Ce, ei = Ce & tr, t[K + 8 >> 2] = ei, or = Ce >>> 0 < or >>> 0 ? a + 1 | 0 : a, Ii = tr & or, t[K + 12 >> 2] = Ii, Ce = K, di = gr ? -2 : 0, K = Me ^ kr, pe = di + K | 0, kr = gr ? -1 : 0, a = kr + (Me ^ jr) | 0, K = K >>> 0 > pe >>> 0 ? a + 1 | 0 : a, a = (P | 0) == (ai | 0) & nr >>> 0 < Ei >>> 0 | P >>> 0 < ai >>> 0, nr = (P | 0) == (or | 0) & nr >>> 0 > lr >>> 0 | P >>> 0 > or >>> 0, P = a + nr | 0, a = (P >>> 0 < nr >>> 0) + K | 0, lr = P, P = P + pe | 0, a = lr >>> 0 > P >>> 0 ? a + 1 | 0 : a, nr = P & tr, t[Ce + 16 >> 2] = nr, or = a & tr, t[Ce + 20 >> 2] = or, Ce = (K | 0) == (kr | 0) & pe >>> 0 < di >>> 0 | K >>> 0 < kr >>> 0, K = (a | 0) == (K | 0) & P >>> 0 < pe >>> 0 | a >>> 0 < K >>> 0, P = Ce + K | 0, a = P >>> 0 < K >>> 0, K = Me ^ Yr, Ce = K - gr | 0, P = Ce + P | 0, a = a + ((Me ^ Nr) - (K >>> 0 < gr >>> 0) | 0) | 0, a = P >>> 0 < Ce >>> 0 ? a + 1 | 0 : a, P = P & tr, t[w + 24 >> 2] = P, a = a & tr, t[w + 28 >> 2] = a, n && (t[n >> 2] = t[n >> 2] ^ gr), !(ei | ui | nr | P | (Ii | wi | or | a))) || !(t[l + 24 >> 2] | (t[l + 16 >> 2] | (t[l + 8 >> 2] | t[l >> 2])) | (t[l + 28 >> 2] | (t[l + 20 >> 2] | (t[l + 12 >> 2] | t[l + 4 >> 2])))))
            break t;
          Ce = 1;
          break e;
        }
        if (a = Di + 1 | 0, Ce = 0, !(yi[Ti | 0](Tt, 655649, 690788, 0, b, Di) | 0))
          break;
      }
    }
    return P = Ce & Li, b = !P, C = b - 1 | 0, a = 0 - !b | 0, K = a & t[l + 4 >> 2], t[l >> 2] = C & t[l >> 2], t[l + 4 >> 2] = K, K = t[l + 12 >> 2] & a, t[l + 8 >> 2] = t[l + 8 >> 2] & C, t[l + 12 >> 2] = K, K = t[l + 20 >> 2] & a, t[l + 16 >> 2] = t[l + 16 >> 2] & C, t[l + 20 >> 2] = K, K = t[l + 28 >> 2] & a, t[l + 24 >> 2] = t[l + 24 >> 2] & C, t[l + 28 >> 2] = K, l = t[w + 4 >> 2] & a, t[w >> 2] = t[w >> 2] & C, t[w + 4 >> 2] = l, l = t[w + 12 >> 2] & a, t[w + 8 >> 2] = t[w + 8 >> 2] & C, t[w + 12 >> 2] = l, l = t[w + 20 >> 2] & a, t[w + 16 >> 2] = t[w + 16 >> 2] & C, t[w + 20 >> 2] = l, l = t[w + 28 >> 2] & a, t[w + 24 >> 2] = t[w + 24 >> 2] & C, t[w + 28 >> 2] = l, n && (t[Tt + 256 >> 2] = b, t[n >> 2] = t[n >> 2] & t[Tt + 256 >> 2] - 1), U = Tt + 464 | 0, P;
  }
  function zi(C, l, w) {
    var n = 0, a = 0, b = 0, P = 0, K = 0, pe = 0, Ce = 0, Me = 0, Tt = 0, tr = 0, nr = 0, or = 0, lr = 0, gr = 0, kr = 0, Nr = 0, jr = 0, Yr = 0, ei = 0, ai = 0, ui = 0, di = 0, Ii = 0, wi = 0, Ei = 0, Ti = 0, Di = 0, Qi = 0;
    for (b = U - 128 | 0, U = b, wi = as(l, C + 40 | 0, 128), P = t[C + 8 >> 2], Ce = t[w >> 2], Yr = P + Ce | 0, l = t[C + 12 >> 2], n = l + t[w + 4 >> 2] | 0, K = Ce >>> 0 > Yr >>> 0 ? n + 1 | 0 : n, pe = (l | 0) == (K | 0) & P >>> 0 > Yr >>> 0 | l >>> 0 > K >>> 0, P = t[w + 8 >> 2], n = pe + P | 0, l = t[w + 12 >> 2], l = n >>> 0 < P >>> 0 ? l + 1 | 0 : l, P = n, n = C + 16 | 0, Ce = t[n >> 2], jr = P + Ce | 0, n = l + t[n + 4 >> 2] | 0, pe = !l & P >>> 0 < pe >>> 0, Ce = Ce >>> 0 > jr >>> 0 ? n + 1 | 0 : n, P = (l | 0) == (Ce | 0) & P >>> 0 > jr >>> 0 | l >>> 0 > Ce >>> 0, n = pe + P | 0, l = n >>> 0 < P >>> 0, nr = n, n = t[w + 16 >> 2], pe = nr + n | 0, P = l, l = l + t[w + 20 >> 2] | 0, n = n >>> 0 > pe >>> 0 ? l + 1 | 0 : l, l = C + 24 | 0, kr = t[l >> 2], Tt = kr + pe | 0, l = n + t[l + 4 >> 2] | 0, nr = (n | 0) == (P | 0) & pe >>> 0 < nr >>> 0 | n >>> 0 < P >>> 0, P = Tt >>> 0 < kr >>> 0 ? l + 1 | 0 : l, l = pe, pe = Tt, Tt = (n | 0) == (P | 0) & l >>> 0 > pe >>> 0 | n >>> 0 > P >>> 0, n = nr + Tt | 0, l = n >>> 0 < Tt >>> 0, kr = n, nr = t[w + 24 >> 2], Tt = n + nr | 0, n = l, l = l + t[w + 28 >> 2] | 0, l = Tt >>> 0 < nr >>> 0 ? l + 1 | 0 : l, C = C + 32 | 0, nr = t[C >> 2], w = nr + Tt | 0, C = l + t[C + 4 >> 2] | 0, ei = w >>> 0 < nr >>> 0 ? C + 1 | 0 : C, nr = w, kr = ((l | 0) == (n | 0) & Tt >>> 0 < kr >>> 0 | l >>> 0 < n >>> 0) + ((l | 0) == (ei | 0) & w >>> 0 < Tt >>> 0 | l >>> 0 > ei >>> 0) | 0, l = (P | 0) == -1, w = l & pe >>> 0 < 4294967294 | (P | 0) != -1 | (w & ei) != -1, C = (Ce | 0) == -1162945306, n = (w | (C & jr >>> 0 < 2940772411 | Ce >>> 0 < 3132021990)) ^ -1, Tt = kr + (n & ((K | 0) == -1076732276 & Yr >>> 0 > 3493216576 | K >>> 0 > 3218235020) | (n & (C & jr >>> 0 > 2940772411 | Ce >>> 0 > 3132021990) | (pe | 0) == -1 & l & (w ^ -1))) | 0, C = ri(Tt, 0, 801750719, 1076732275), w = C + Yr | 0, l = K + ve | 0, t[b + 8 >> 2] = w, l = C >>> 0 > w >>> 0 ? l + 1 | 0 : l, t[b + 12 >> 2] = l, C = b, K = (l | 0) == (K | 0) & w >>> 0 < Yr >>> 0 | l >>> 0 < K >>> 0, n = ri(Tt, 0, 1354194884, 1162945305), w = n + jr | 0, l = Ce + ve | 0, l = w >>> 0 < n >>> 0 ? l + 1 | 0 : l, K = w + K | 0, n = K >>> 0 < w >>> 0 ? l + 1 | 0 : l, t[C + 16 >> 2] = K, t[C + 20 >> 2] = n, n = (l | 0) == (n | 0) & w >>> 0 > K >>> 0 | l >>> 0 > n >>> 0, w = n + ((l | 0) == (Ce | 0) & w >>> 0 < jr >>> 0 | l >>> 0 < Ce >>> 0) | 0, l = w >>> 0 < n >>> 0, n = w, Ce = l, l = P, K = pe + Tt | 0, w = K >>> 0 < pe >>> 0 ? l + 1 | 0 : l, l = w + Ce | 0, kr = n, n = K, K = kr + n | 0, t[C + 24 >> 2] = K, l = n >>> 0 > K >>> 0 ? l + 1 | 0 : l, t[C + 28 >> 2] = l, C = (w | 0) == (P | 0) & n >>> 0 < pe >>> 0 | w >>> 0 < P >>> 0, w = (l | 0) == (w | 0) & n >>> 0 > K >>> 0 | l >>> 0 < w >>> 0, l = C + w | 0, n = ei + (l >>> 0 < w >>> 0) | 0, C = l + nr | 0, n = C >>> 0 < nr >>> 0 ? n + 1 | 0 : n, t[b + 32 >> 2] = C, t[b + 36 >> 2] = n, w = 0, jr = 0, P = 0, Yr = 0, Tt = 0, nr = 0, Ce = 0, K = 0, kr = 0, pe = 0, ei = 0; t[b + 120 >> 2] = 0, l = (b + 8 | 0) + (Ei >>> 2 & 1073741816) | 0, C = t[l >> 2], n = t[l + 4 >> 2], a = Ti & 62, l = a & 31, a >>> 0 >= 32 ? C = n >>> l | 0 : C = ((1 << l) - 1 & n) << 32 - l | C >>> l, tr = C & 3, or = (tr | 0) == 1, a = ai + 656432 | 0, C = a + 248 | 0, l = a + 184 | 0, n = a + 120 | 0, Me = a + 56 | 0, lr = (tr | 0) == 2, gr = (tr | 0) == 3, w = gr ? t[C >> 2] : lr ? t[l >> 2] : or ? t[n >> 2] : tr ? w : t[Me >> 2], l = gr ? t[C + 4 >> 2] : lr ? t[l + 4 >> 2] : or ? t[n + 4 >> 2] : tr ? jr : t[Me + 4 >> 2], jr = l, C = l >>> 16 | 0, t[b + 112 >> 2] = (l & 65535) << 16 | w >>> 16, t[b + 116 >> 2] = C, C = a + 224 | 0, l = a + 160 | 0, n = a + 96 | 0, Me = a + 32 | 0, Di = gr ? t[C >> 2] : lr ? t[l >> 2] : or ? t[n >> 2] : tr ? Di : t[Me >> 2], Ce = gr ? t[C + 4 >> 2] : lr ? t[l + 4 >> 2] : or ? t[n + 4 >> 2] : tr ? Ce : t[Me + 4 >> 2], t[b + 80 >> 2] = Di, t[b + 84 >> 2] = Ce & 1048575, C = a + 216 | 0, l = a + 152 | 0, n = a + 88 | 0, Me = a + 24 | 0, K = gr ? t[C >> 2] : lr ? t[l >> 2] : or ? t[n >> 2] : tr ? K : t[Me >> 2], C = gr ? t[C + 4 >> 2] : lr ? t[l + 4 >> 2] : or ? t[n + 4 >> 2] : tr ? kr : t[Me + 4 >> 2], kr = C, n = C >>> 16 | 0, t[b + 72 >> 2] = (C & 65535) << 16 | K >>> 16, t[b + 76 >> 2] = n, C = a + 192 | 0, l = a + 128 | 0, n = a - -64 | 0, Qi = gr ? t[C >> 2] : lr ? t[l >> 2] : or ? t[n >> 2] : tr ? Qi : t[a >> 2], ui = gr ? t[C + 4 >> 2] : lr ? t[l + 4 >> 2] : or ? t[n + 4 >> 2] : tr ? ui : t[a + 4 >> 2], t[b + 40 >> 2] = Qi, t[b + 44 >> 2] = ui & 1048575, n = w << 4 & 1048560, C = a + 240 | 0, l = a + 176 | 0, Me = a + 112 | 0, Nr = a + 48 | 0, P = gr ? t[C >> 2] : lr ? t[l >> 2] : or ? t[Me >> 2] : tr ? P : t[Nr >> 2], l = gr ? t[C + 4 >> 2] : lr ? t[l + 4 >> 2] : or ? t[Me + 4 >> 2] : tr ? Yr : t[Nr + 4 >> 2], Yr = l, C = l >>> 28 | 0, t[b + 104 >> 2] = (l & 268435455) << 4 | P >>> 28, t[b + 108 >> 2] = C | n, n = a + 232 | 0, Me = a + 168 | 0, Nr = a + 104 | 0, C = a + 40 | 0, Tt = gr ? t[n >> 2] : lr ? t[Me >> 2] : or ? t[Nr >> 2] : tr ? Tt : t[C >> 2], nr = gr ? t[n + 4 >> 2] : lr ? t[Me + 4 >> 2] : or ? t[Nr + 4 >> 2] : tr ? nr : t[C + 4 >> 2], t[b + 96 >> 2] = P << 24 & -16777216 | nr >>> 8, t[b + 100 >> 2] = (l << 24 | P >>> 8) & 1048575, t[b + 88 >> 2] = Tt << 12 & -4096 | Ce >>> 20, t[b + 92 >> 2] = (nr << 12 | Tt >>> 20) & 1048575, C = a + 208 | 0, l = a + 144 | 0, Me = a + 80 | 0, Nr = a + 16 | 0, pe = gr ? t[C >> 2] : lr ? t[l >> 2] : or ? t[Me >> 2] : tr ? pe : t[Nr >> 2], C = gr ? t[C + 4 >> 2] : lr ? t[l + 4 >> 2] : or ? t[Me + 4 >> 2] : tr ? ei : t[Nr + 4 >> 2], ei = C, l = C >>> 28 | 0, t[b + 64 >> 2] = (C & 268435455) << 4 | pe >>> 28, t[b + 68 >> 2] = l | K << 4 & 1048560, l = pe << 24 & -16777216, C = a + 200 | 0, Me = a + 136 | 0, Nr = a + 72 | 0, a = a + 8 | 0, di = gr ? t[C >> 2] : lr ? t[Me >> 2] : or ? t[Nr >> 2] : tr ? di : t[a >> 2], Ii = gr ? t[C + 4 >> 2] : lr ? t[Me + 4 >> 2] : or ? t[Nr + 4 >> 2] : tr ? Ii : t[a + 4 >> 2], t[b + 56 >> 2] = Ii >>> 8 | l, t[b + 60 >> 2] = (ei << 24 | pe >>> 8) & 1048575, t[b + 48 >> 2] = di << 12 & -4096 | ui >>> 20, t[b + 52 >> 2] = (Ii << 12 | di >>> 20) & 1048575, Gs(wi, wi, b + 40 | 0), Ti = Ti + 2 | 0, Ei = Ei + 1 | 0, ai = ai + 256 | 0, (ai | 0) != 32768; )
      ;
    U = b + 128 | 0;
  }
  function Kn(C, l) {
    var w = 0, n = 0, a = 0, b = 0, P = 0, K = 0, pe = 0, Ce = 0, Me = 0, Tt = 0, tr = 0, nr = 0, or = 0, lr = 0, gr = 0, kr = 0, Nr = 0, jr = 0, Yr = 0, ei = 0, ai = 0;
    P = U - 80 | 0, U = P, t[C + 80 >> 2] = t[l + 120 >> 2], nr = l + 104 | 0, Tt = t[nr >> 2], tr = t[nr + 4 >> 2], or = l + 96 | 0, K = t[or >> 2], Me = t[or + 4 >> 2], lr = l + 88 | 0, b = t[lr >> 2], pe = t[lr + 4 >> 2], Ce = t[l + 84 >> 2], gr = l + 112 | 0, kr = t[gr >> 2], a = t[gr + 4 >> 2], ei = a, w = t[l + 80 >> 2], n = ri(a >>> 16 | 0, 0, 977, 1), a = w + n | 0, w = Ce + ve | 0, Ce = n >>> 0 > a >>> 0 ? w + 1 | 0 : w, w = pe, n = Ce >>> 20 | 0, pe = n, n = n + b | 0, pe = pe >>> 0 > n >>> 0 ? w + 1 | 0 : w, w = Me, b = pe >>> 20 | 0, Me = b, b = b + K | 0, Me = Me >>> 0 > b >>> 0 ? w + 1 | 0 : w, w = tr, K = Me >>> 20 | 0, tr = K, K = K + Tt | 0, Tt = tr >>> 0 > K >>> 0 ? w + 1 | 0 : w, ai = pe & 1048575, w = Ce & 1048575, jr = a, Nr = w, tr = n, Ce = b, Yr = Me & 1048575, b = (n & b & K) == -1 & (Yr & pe & Tt) == 1048575, w = ei & 65535, n = Tt >>> 20 | 0, a = n, n = n + kr | 0, w = a >>> 0 > n >>> 0 ? w + 1 | 0 : w, pe = n, a = w, b = ri(b & ((n | 0) == -1 & (w | 0) == 65535) & ((Nr | 0) == 1048574 & jr >>> 0 > 4294966318 | Nr >>> 0 > 1048574) | w >>> 16, 0, 977, 1), n = b + jr | 0, w = Nr + ve | 0, w = n >>> 0 < b >>> 0 ? w + 1 | 0 : w, b = n, kr = w, w = ai, n = kr >>> 20 | 0, Me = n + tr | 0, n = n >>> 0 > Me >>> 0 ? w + 1 | 0 : w, t[P + 40 >> 2] = b, t[P + 44 >> 2] = Me << 20 & 1072693248 | kr & 1048575, w = Yr, tr = Ce, b = n, Ce = (n >>> 20 | 0) + Ce | 0, n = tr >>> 0 > Ce >>> 0 ? w + 1 | 0 : w, kr = Ce << 10 & 1073740800, w = b >>> 10 | 0, t[P + 48 >> 2] = (b & 1023) << 22 | Me >>> 10, t[P + 52 >> 2] = kr | w & 1023, w = Tt & 1048575, b = n, n = n >>> 20 | 0, K = n + K | 0, n = n >>> 0 > K >>> 0 ? w + 1 | 0 : w, t[P + 56 >> 2] = (b & 1048575) << 12 | Ce >>> 20, t[P + 60 >> 2] = K & 1073741823, w = a, a = (n >>> 20 | 0) + pe | 0, w = a >>> 0 < pe >>> 0 ? w + 1 | 0 : w, t[P + 72 >> 2] = w >>> 8 & 255, t[P + 76 >> 2] = 0, w = w << 22 | a >>> 10, t[P + 64 >> 2] = ((n & 1073741823) << 2 | K >>> 30) & 4194303 | a << 22 & -4194304, t[P + 68 >> 2] = w & 1073741823, pe = P + 40 | 0, Hn(pe, 690464), n = t[P + 44 >> 2], a = n, t[l + 80 >> 2] = t[P + 40 >> 2], t[l + 84 >> 2] = n & 1048575, b = t[P + 72 >> 2] << 8, Tt = t[P + 68 >> 2], w = Tt >>> 22 | 0, K = t[P + 64 >> 2], t[gr >> 2] = (Tt & 4194303) << 10 | K >>> 22, t[gr + 4 >> 2] = w | b, n = K, w = Tt << 30 | n >>> 2, K = n << 30 & -1073741824, n = t[P + 56 >> 2], b = t[P + 60 >> 2], t[nr >> 2] = b | K, t[nr + 4 >> 2] = w & 1048575, w = b << 20 | n >>> 12, K = n << 20 & -1048576, n = t[P + 48 >> 2], b = t[P + 52 >> 2], t[or >> 2] = b >>> 10 | K, t[or + 4 >> 2] = w & 1048575, b = (b << 10 | n >>> 22) & 1048575, t[lr >> 2] = n << 10 & -1024 | a >>> 20, t[lr + 4 >> 2] = b, w = l + 80 | 0, Wn(pe, w), zr(P, w, pe), zr(l, l, pe), w = l + 40 | 0, zr(w, w, P), t[gr >> 2] = 0, t[gr + 4 >> 2] = 0, t[nr >> 2] = 0, t[nr + 4 >> 2] = 0, t[or >> 2] = 0, t[or + 4 >> 2] = 0, t[lr >> 2] = 0, t[lr + 4 >> 2] = 0, t[l + 80 >> 2] = 1, t[l + 84 >> 2] = 0, w = t[l + 4 >> 2], t[C >> 2] = t[l >> 2], t[C + 4 >> 2] = w, w = l + 8 | 0, n = t[w + 4 >> 2], a = C + 8 | 0, t[a >> 2] = t[w >> 2], t[a + 4 >> 2] = n, w = l + 16 | 0, n = t[w + 4 >> 2], a = C + 16 | 0, t[a >> 2] = t[w >> 2], t[a + 4 >> 2] = n, w = l + 24 | 0, n = t[w + 4 >> 2], a = C + 24 | 0, t[a >> 2] = t[w >> 2], t[a + 4 >> 2] = n, w = l + 32 | 0, n = t[w + 4 >> 2], a = C + 32 | 0, t[a >> 2] = t[w >> 2], t[a + 4 >> 2] = n, w = t[l + 44 >> 2], t[C + 40 >> 2] = t[l + 40 >> 2], t[C + 44 >> 2] = w, w = l + 48 | 0, n = t[w + 4 >> 2], a = C + 48 | 0, t[a >> 2] = t[w >> 2], t[a + 4 >> 2] = n, w = l + 56 | 0, n = t[w + 4 >> 2], a = C + 56 | 0, t[a >> 2] = t[w >> 2], t[a + 4 >> 2] = n, w = l - -64 | 0, n = t[w + 4 >> 2], a = C - -64 | 0, t[a >> 2] = t[w >> 2], t[a + 4 >> 2] = n, l = l + 72 | 0, w = t[l + 4 >> 2], C = C + 72 | 0, t[C >> 2] = t[l >> 2], t[C + 4 >> 2] = w, U = P + 80 | 0;
  }
  function Hn(C, l) {
    var w = 0, n = 0, a = 0, b = 0, P = 0, K = 0, pe = 0, Ce = 0, Me = 0, Tt = 0, tr = 0, nr = 0, or = 0, lr = 0, gr = 0, kr = 0, Nr = 0, jr = 0, Yr = 0, ei = 0, ai = 0, ui = 0, di = 0, Ii = 0, wi = 0, Ei = 0, Ti = 0, Di = 0, Qi = 0, Li = 0, Ki = 0, Wi = 0, Xi = 0, $i = 0, In = 0, kn = 0, Dn = 0, Mn = 0, zn = 0, es = 0, ns = 0, fs = 0, ps = 0, Es = 0;
    for (K = U - 432 | 0, U = K, n = K + 392 | 0, w = n + 32 | 0, t[w >> 2] = 0, t[w + 4 >> 2] = 0, w = n + 24 | 0, t[w >> 2] = 0, t[w + 4 >> 2] = 0, w = n + 16 | 0, t[w >> 2] = 0, t[w + 4 >> 2] = 0, n = n + 8 | 0, t[n >> 2] = 0, t[n + 4 >> 2] = 0, t[K + 392 >> 2] = 0, t[K + 396 >> 2] = 0, n = K + 352 | 0, w = n + 32 | 0, t[w >> 2] = 0, t[w + 4 >> 2] = 0, w = n + 24 | 0, t[w >> 2] = 0, t[w + 4 >> 2] = 0, n = n + 16 | 0, t[n >> 2] = 0, t[n + 4 >> 2] = 0, t[K + 360 >> 2] = 0, t[K + 364 >> 2] = 0, t[K + 352 >> 2] = 1, t[K + 356 >> 2] = 0, Xi = C, es = t[C + 32 >> 2], fs = t[C + 36 >> 2], Yr = t[C + 24 >> 2], Mn = t[C + 28 >> 2], wi = t[C + 16 >> 2], Di = t[C + 20 >> 2], ai = t[C + 8 >> 2], $i = t[C + 12 >> 2], n = t[C >> 2], Ce = t[C + 4 >> 2], ns = t[l + 32 >> 2], ui = t[l + 36 >> 2], Qi = t[l + 24 >> 2], Li = t[l + 28 >> 2], Ei = t[l + 16 >> 2], Ki = t[l + 20 >> 2], di = t[l + 8 >> 2], Wi = t[l + 12 >> 2], w = t[l >> 2], Tt = t[l + 4 >> 2], ps = -1, ei = -1; ; ) {
      for (b = 8, a = 0, In = 59, P = 0, or = 0, pe = n, C = Ce, tr = w, jr = Tt, Me = 0, lr = 0, gr = 8, nr = 0; Nr = C, C = pe & 1, Ti = 0 - C | 0, kn = 0 - C | 0, Ii = kn, Dn = ei, C = ei >> 31, kr = C, C = C ^ tr, ei = C - kr & Ti, pe = ei + pe | 0, C = Nr + (Ii & (kr ^ jr) - ((C >>> 0 < kr >>> 0) + kr | 0)) | 0, zn = pe, pe = pe >>> 0 < ei >>> 0 ? C + 1 | 0 : C, Nr = kr & Ii, C = (pe & Nr) + jr | 0, jr = tr, ei = kr & Ti, tr = (ei & zn) + tr | 0, jr = jr >>> 0 > tr >>> 0 ? C + 1 | 0 : C, C = P ^ kr, Ii = C - kr & Ti, gr = Ii + gr | 0, C = nr + ((or ^ kr) - ((C >>> 0 < kr >>> 0) + kr | 0) & kn) | 0, nr = gr >>> 0 < Ii >>> 0 ? C + 1 | 0 : C, C = (nr & Nr) + or | 0, or = P, P = (gr & ei) + P | 0, C = (or >>> 0 > P >>> 0 ? C + 1 | 0 : C) << 1 | P >>> 31, P = P << 1, or = C, Ii = ei, C = b ^ kr, ei = (C - kr & Ti) + Me | 0, C = ((a ^ kr) - ((C >>> 0 < kr >>> 0) + kr | 0) & kn) + lr | 0, lr = Me >>> 0 > ei >>> 0 ? C + 1 | 0 : C, C = (lr & Nr) + a | 0, a = b, Me = ei, b = (Ii & Me) + b | 0, C = (a >>> 0 > b >>> 0 ? C + 1 | 0 : C) << 1 | b >>> 31, b = b << 1, a = C, C = Ii ^ ps, ps = C - 1 | 0, ei = (Nr ^ Dn) - !C | 0, C = pe >>> 1 | 0, pe = (pe & 1) << 31 | zn >>> 1, In = In - 1 | 0, !!In; )
        ;
      if (t[K + 344 >> 2] = gr, t[K + 348 >> 2] = nr, t[K + 336 >> 2] = Me, t[K + 340 >> 2] = lr, t[K + 328 >> 2] = P, t[K + 332 >> 2] = or, t[K + 320 >> 2] = b, t[K + 324 >> 2] = a, rs(K + 392 | 0, K + 352 | 0, K + 320 | 0, l), C = Tt >> 31, zn = K + 304 | 0, pe = a >> 31, tr = w, jr = C, Pr(zn, b, a, pe, pe, w, Tt, C, C), C = Ce >> 31, Ii = K + 272 | 0, w = or >> 31, Nr = n, kr = C, Pr(Ii, P, or, w, w, n, Ce, C, C), C = lr >> 31, Ti = K + 288 | 0, Dn = Me, n = C, Pr(Ti, Me, lr, C, C, tr, Tt, jr, jr), C = nr >> 31, Tt = K + 256 | 0, Me = C, Pr(Tt, gr, nr, C, C, Nr, Ce, kr, kr), C = Wi >> 31, tr = K + 240 | 0, Ce = C, Pr(tr, b, a, pe, pe, di, Wi, C, C), jr = K + 208 | 0, Nr = $i, C = Nr >> 31, Pr(jr, P, or, w, w, ai, Nr, C, C), Nr = K + 224 | 0, Pr(Nr, Dn, lr, n, n, di, Wi, Ce, Ce), kr = K + 192 | 0, Pr(kr, gr, nr, Me, Me, ai, $i, C, C), C = Ki >> 31, ai = K + 176 | 0, Ce = C, Pr(ai, b, a, pe, pe, Ei, Ki, C, C), $i = K + 144 | 0, C = Di >> 31, Pr($i, P, or, w, w, wi, Di, C, C), Wi = K + 160 | 0, Pr(Wi, Dn, lr, n, n, Ei, Ki, Ce, Ce), Ki = K + 128 | 0, Pr(Ki, gr, nr, Me, Me, wi, Di, C, C), C = Li >> 31, wi = K + 112 | 0, Ce = C, Pr(wi, b, a, pe, pe, Qi, Li, C, C), Di = K + 80 | 0, di = Mn, C = di >> 31, Pr(Di, P, or, w, w, Yr, di, C, C), kn = K + 96 | 0, Pr(kn, Dn, lr, n, n, Qi, Li, Ce, Ce), Li = K - -64 | 0, Pr(Li, gr, nr, Me, Me, Yr, di, C, C), C = ui >> 31, Yr = K + 48 | 0, Ce = pe, pe = C, Pr(Yr, b, a, Ce, Ce, ns, ui, C, C), Mn = K + 16 | 0, a = fs, C = a >> 31, Pr(Mn, P, or, w, w, es, a, C, C), In = K + 32 | 0, Pr(In, Dn, lr, n, n, ns, ui, pe, pe), Pr(K, gr, nr, Me, Me, es, a, C, C), b = t[K + 272 >> 2], w = t[K + 304 >> 2], n = b + w | 0, pe = t[K + 276 >> 2], C = pe + t[K + 308 >> 2] | 0, C = w >>> 0 > n >>> 0 ? C + 1 | 0 : C, w = n, n = C, pe = (pe | 0) == (C | 0) & w >>> 0 < b >>> 0 | C >>> 0 < pe >>> 0, C = zn + 8 | 0, b = t[C >> 2], a = Ii + 8 | 0, w = b + t[a >> 2] | 0, C = t[a + 4 >> 2] + t[C + 4 >> 2] | 0, C = w >>> 0 < b >>> 0 ? C + 1 | 0 : C, pe = w + pe | 0, w = pe >>> 0 < w >>> 0 ? C + 1 | 0 : C, b = w << 2 | pe >>> 30, a = pe << 2 | n >>> 30, Me = t[K + 208 >> 2], pe = t[K + 240 >> 2], n = Me + pe | 0, P = t[K + 212 >> 2], C = P + t[K + 244 >> 2] | 0, pe = n >>> 0 < pe >>> 0 ? C + 1 | 0 : C, C = pe + b | 0, b = n, a = n + a | 0, n = n >>> 0 > a >>> 0 ? C + 1 | 0 : C, C = pe, pe = a, or = (n | 0) == (C | 0) & a >>> 0 < b >>> 0 | C >>> 0 > n >>> 0, a = (C | 0) == (P | 0) & b >>> 0 < Me >>> 0 | C >>> 0 < P >>> 0, C = tr + 8 | 0, P = t[C >> 2], Me = jr + 8 | 0, b = P + t[Me >> 2] | 0, C = t[Me + 4 >> 2] + t[C + 4 >> 2] | 0, C = b >>> 0 < P >>> 0 ? C + 1 | 0 : C, P = b, b = a + b | 0, C = (w >> 31) + (P >>> 0 > b >>> 0 ? C + 1 | 0 : C) | 0, w = w >> 30, a = w, w = w + b | 0, C = a >>> 0 > w >>> 0 ? C + 1 | 0 : C, b = w + or | 0, w = b >>> 0 < w >>> 0 ? C + 1 | 0 : C, a = w << 2 | b >>> 30, or = n, Me = b << 2 | n >>> 30, nr = t[K + 144 >> 2], b = t[K + 176 >> 2], n = nr + b | 0, P = t[K + 148 >> 2], C = P + t[K + 180 >> 2] | 0, b = n >>> 0 < b >>> 0 ? C + 1 | 0 : C, C = b + a | 0, a = n, di = n + Me | 0, n = n >>> 0 > di >>> 0 ? C + 1 | 0 : C, Me = (b | 0) == (n | 0) & a >>> 0 > di >>> 0 | n >>> 0 < b >>> 0, a = (b | 0) == (P | 0) & a >>> 0 < nr >>> 0 | b >>> 0 < P >>> 0, C = ai + 8 | 0, P = t[C >> 2], lr = $i + 8 | 0, b = P + t[lr >> 2] | 0, C = t[lr + 4 >> 2] + t[C + 4 >> 2] | 0, C = b >>> 0 < P >>> 0 ? C + 1 | 0 : C, P = b, b = a + b | 0, C = (w >> 31) + (P >>> 0 > b >>> 0 ? C + 1 | 0 : C) | 0, w = w >> 30, a = w, w = w + b | 0, C = a >>> 0 > w >>> 0 ? C + 1 | 0 : C, b = w + Me | 0, w = b >>> 0 < w >>> 0 ? C + 1 | 0 : C, a = w << 2 | b >>> 30, Me = n, lr = b << 2 | n >>> 30, gr = t[K + 80 >> 2], b = t[K + 112 >> 2], n = gr + b | 0, P = t[K + 84 >> 2], C = P + t[K + 116 >> 2] | 0, b = n >>> 0 < b >>> 0 ? C + 1 | 0 : C, C = b + a | 0, a = n, Ei = n + lr | 0, n = n >>> 0 > Ei >>> 0 ? C + 1 | 0 : C, lr = (b | 0) == (n | 0) & a >>> 0 > Ei >>> 0 | n >>> 0 < b >>> 0, a = (b | 0) == (P | 0) & a >>> 0 < gr >>> 0 | b >>> 0 < P >>> 0, C = wi + 8 | 0, P = t[C >> 2], nr = Di + 8 | 0, b = P + t[nr >> 2] | 0, C = t[nr + 4 >> 2] + t[C + 4 >> 2] | 0, C = b >>> 0 < P >>> 0 ? C + 1 | 0 : C, P = b, b = a + b | 0, C = (w >> 31) + (P >>> 0 > b >>> 0 ? C + 1 | 0 : C) | 0, w = w >> 30, a = w, w = w + b | 0, C = a >>> 0 > w >>> 0 ? C + 1 | 0 : C, b = w + lr | 0, w = b >>> 0 < w >>> 0 ? C + 1 | 0 : C, a = w << 2 | b >>> 30, lr = n, nr = b << 2 | n >>> 30, Ce = t[K + 16 >> 2], b = t[K + 48 >> 2], n = Ce + b | 0, P = t[K + 20 >> 2], C = P + t[K + 52 >> 2] | 0, b = n >>> 0 < b >>> 0 ? C + 1 | 0 : C, C = b + a | 0, a = n, Qi = n + nr | 0, n = n >>> 0 > Qi >>> 0 ? C + 1 | 0 : C, nr = (b | 0) == (n | 0) & a >>> 0 > Qi >>> 0 | n >>> 0 < b >>> 0, a = (b | 0) == (P | 0) & a >>> 0 < Ce >>> 0 | b >>> 0 < P >>> 0, C = Yr + 8 | 0, P = t[C >> 2], gr = Mn + 8 | 0, b = P + t[gr >> 2] | 0, C = t[gr + 4 >> 2] + t[C + 4 >> 2] | 0, C = b >>> 0 < P >>> 0 ? C + 1 | 0 : C, P = b, b = a + b | 0, C = (w >> 31) + (P >>> 0 > b >>> 0 ? C + 1 | 0 : C) | 0, w = w >> 30, a = w, w = w + b | 0, C = a >>> 0 > w >>> 0 ? C + 1 | 0 : C, a = w, w = w + nr | 0, b = (a >>> 0 > w >>> 0 ? C + 1 | 0 : C) << 2 | w >>> 30, nr = n, ns = w << 2 | n >>> 30, ui = b, a = t[K + 256 >> 2], w = t[K + 288 >> 2], n = a + w | 0, b = t[K + 260 >> 2], C = b + t[K + 292 >> 2] | 0, C = w >>> 0 > n >>> 0 ? C + 1 | 0 : C, w = n, n = C, b = (b | 0) == (C | 0) & w >>> 0 < a >>> 0 | C >>> 0 < b >>> 0, C = Ti + 8 | 0, a = t[C >> 2], P = Tt + 8 | 0, w = a + t[P >> 2] | 0, C = t[P + 4 >> 2] + t[C + 4 >> 2] | 0, C = w >>> 0 < a >>> 0 ? C + 1 | 0 : C, b = w + b | 0, w = b >>> 0 < w >>> 0 ? C + 1 | 0 : C, a = w << 2 | b >>> 30, P = b << 2 | n >>> 30, Tt = t[K + 192 >> 2], b = t[K + 224 >> 2], n = Tt + b | 0, gr = t[K + 196 >> 2], C = gr + t[K + 228 >> 2] | 0, b = n >>> 0 < b >>> 0 ? C + 1 | 0 : C, C = b + a | 0, a = n, P = n + P | 0, n = n >>> 0 > P >>> 0 ? C + 1 | 0 : C, C = b, b = P, Ce = (n | 0) == (C | 0) & a >>> 0 > b >>> 0 | C >>> 0 > n >>> 0, P = (C | 0) == (gr | 0) & a >>> 0 < Tt >>> 0 | C >>> 0 < gr >>> 0, C = Nr + 8 | 0, gr = t[C >> 2], Tt = kr + 8 | 0, a = gr + t[Tt >> 2] | 0, C = t[Tt + 4 >> 2] + t[C + 4 >> 2] | 0, C = a >>> 0 < gr >>> 0 ? C + 1 | 0 : C, jr = a, a = a + P | 0, C = (w >> 31) + (jr >>> 0 > a >>> 0 ? C + 1 | 0 : C) | 0, w = w >> 30, P = w, w = w + a | 0, C = P >>> 0 > w >>> 0 ? C + 1 | 0 : C, a = w + Ce | 0, w = a >>> 0 < w >>> 0 ? C + 1 | 0 : C, P = w << 2 | a >>> 30, gr = n, Tt = a << 2 | n >>> 30, Yr = t[K + 128 >> 2], a = t[K + 160 >> 2], n = Yr + a | 0, Ce = t[K + 132 >> 2], C = Ce + t[K + 164 >> 2] | 0, a = n >>> 0 < a >>> 0 ? C + 1 | 0 : C, C = a + P | 0, P = n, ai = n + Tt | 0, n = n >>> 0 > ai >>> 0 ? C + 1 | 0 : C, Tt = (a | 0) == (n | 0) & P >>> 0 > ai >>> 0 | n >>> 0 < a >>> 0, P = (a | 0) == (Ce | 0) & P >>> 0 < Yr >>> 0 | a >>> 0 < Ce >>> 0, C = Wi + 8 | 0, Ce = t[C >> 2], tr = Ki + 8 | 0, a = Ce + t[tr >> 2] | 0, C = t[tr + 4 >> 2] + t[C + 4 >> 2] | 0, C = a >>> 0 < Ce >>> 0 ? C + 1 | 0 : C, Ce = a, a = a + P | 0, C = (w >> 31) + (Ce >>> 0 > a >>> 0 ? C + 1 | 0 : C) | 0, w = w >> 30, P = w, w = w + a | 0, C = P >>> 0 > w >>> 0 ? C + 1 | 0 : C, a = w + Tt | 0, w = a >>> 0 < w >>> 0 ? C + 1 | 0 : C, P = w << 2 | a >>> 30, Ce = n, tr = a << 2 | n >>> 30, jr = t[K + 64 >> 2], a = t[K + 96 >> 2], n = jr + a | 0, Tt = t[K + 68 >> 2], C = Tt + t[K + 100 >> 2] | 0, a = n >>> 0 < a >>> 0 ? C + 1 | 0 : C, C = a + P | 0, P = n, wi = n + tr | 0, n = n >>> 0 > wi >>> 0 ? C + 1 | 0 : C, tr = (a | 0) == (n | 0) & P >>> 0 > wi >>> 0 | n >>> 0 < a >>> 0, P = (a | 0) == (Tt | 0) & P >>> 0 < jr >>> 0 | a >>> 0 < Tt >>> 0, C = kn + 8 | 0, Tt = t[C >> 2], Yr = Li + 8 | 0, a = Tt + t[Yr >> 2] | 0, C = t[Yr + 4 >> 2] + t[C + 4 >> 2] | 0, C = a >>> 0 < Tt >>> 0 ? C + 1 | 0 : C, jr = a, a = a + P | 0, C = (w >> 31) + (jr >>> 0 > a >>> 0 ? C + 1 | 0 : C) | 0, w = w >> 30, P = w, w = w + a | 0, C = P >>> 0 > w >>> 0 ? C + 1 | 0 : C, a = w + tr | 0, w = a >>> 0 < w >>> 0 ? C + 1 | 0 : C, P = w << 2 | a >>> 30, Tt = n, Yr = a << 2 | n >>> 30, Nr = t[K >> 2], a = t[K + 32 >> 2], n = Nr + a | 0, tr = t[K + 4 >> 2], C = tr + t[K + 36 >> 2] | 0, a = n >>> 0 < a >>> 0 ? C + 1 | 0 : C, C = a + P | 0, P = n, Yr = n + Yr | 0, n = n >>> 0 > Yr >>> 0 ? C + 1 | 0 : C, jr = (a | 0) == (n | 0) & P >>> 0 > Yr >>> 0 | n >>> 0 < a >>> 0, P = (a | 0) == (tr | 0) & P >>> 0 < Nr >>> 0 | a >>> 0 < tr >>> 0, C = In + 8 | 0, tr = t[C >> 2], Nr = K + 8 | 0, a = tr + t[Nr >> 2] | 0, C = t[Nr + 4 >> 2] + t[C + 4 >> 2] | 0, C = a >>> 0 < tr >>> 0 ? C + 1 | 0 : C, tr = a, a = a + P | 0, C = (w >> 31) + (tr >>> 0 > a >>> 0 ? C + 1 | 0 : C) | 0, w = w >> 30, P = w, w = w + a | 0, C = P >>> 0 > w >>> 0 ? C + 1 | 0 : C, a = w, w = w + jr | 0, a = (a >>> 0 > w >>> 0 ? C + 1 | 0 : C) << 2 | w >>> 30, es = w << 2 | n >>> 30, fs = a, Mn = n & 1073741823, Li = nr & 1073741823, Di = Tt & 1073741823, Ki = lr & 1073741823, $i = Ce & 1073741823, Wi = Me & 1073741823, n = b, Ce = gr & 1073741823, w = pe, Tt = or & 1073741823, Es = Es + 1 | 0, (Es | 0) == 10)
        break;
    }
    C = ui >> 31, n = C, or = K + 392 | 0, pe = or + 32 | 0, lr = t[pe >> 2], C = t[pe + 4 >> 2], Ce = C, C = C >> 31, w = C, a = t[l >> 2], nr = C & a, b = nr + t[K + 392 >> 2] | 0, P = t[l + 4 >> 2], C = t[K + 396 >> 2] + (P & C) | 0, C = b >>> 0 < nr >>> 0 ? C + 1 | 0 : C, b = n ^ b, Yr = b - n | 0, b = (C ^ n) - ((n >>> 0 > b >>> 0) + n | 0) | 0, nr = a, gr = P, C = t[l + 32 >> 2], wi = C, P = C & w, a = P + lr | 0, ai = t[l + 36 >> 2], C = Ce + (ai & w) | 0, C = a >>> 0 < P >>> 0 ? C + 1 | 0 : C, a = n ^ a, lr = a - n | 0, tr = (C ^ n) - ((n >>> 0 > a >>> 0) + n | 0) | 0, C = t[l + 24 >> 2], Qi = C, Me = C & w, a = or + 24 | 0, P = Me + t[a >> 2] | 0, Ei = t[l + 28 >> 2], C = t[a + 4 >> 2] + (Ei & w) | 0, C = P >>> 0 < Me >>> 0 ? C + 1 | 0 : C, P = n ^ P, Tt = P - n | 0, di = (C ^ n) - ((n >>> 0 > P >>> 0) + n | 0) | 0, C = t[l + 16 >> 2], jr = C, Ce = C & w, P = or + 16 | 0, Me = Ce + t[P >> 2] | 0, ei = t[l + 20 >> 2], C = t[P + 4 >> 2] + (ei & w) | 0, C = Ce >>> 0 > Me >>> 0 ? C + 1 | 0 : C, Me = n ^ Me, ui = Me - n | 0, Me = (C ^ n) - ((n >>> 0 > Me >>> 0) + n | 0) | 0, Nr = t[l + 8 >> 2], Ce = Nr & w, C = or + 8 | 0, or = Ce + t[C >> 2] | 0, kr = t[l + 12 >> 2], C = t[C + 4 >> 2] + (kr & w) | 0, l = n ^ or, w = l - n | 0, C = ((n ^ (Ce >>> 0 > or >>> 0 ? C + 1 | 0 : C)) - ((l >>> 0 < n >>> 0) + n | 0) | 0) + (b >> 31) | 0, l = b >> 30, w = l + w | 0, Ce = l >>> 0 > w >>> 0 ? C + 1 | 0 : C, C = (Ce >> 31) + Me | 0, l = Ce >> 30, or = l + ui | 0, ui = l >>> 0 > or >>> 0 ? C + 1 | 0 : C, C = (ui >> 31) + di | 0, l = ui >> 30, Me = l + Tt | 0, Tt = l >>> 0 > Me >>> 0 ? C + 1 | 0 : C, C = (Tt >> 31) + tr | 0, l = Tt >> 30, lr = l + lr | 0, tr = l >>> 0 > lr >>> 0 ? C + 1 | 0 : C, l = tr >> 31, C = (l & gr) + (b & 1073741823) | 0, n = l, l = (n & nr) + Yr | 0, C = l >>> 0 < Yr >>> 0 ? C + 1 | 0 : C, t[Xi >> 2] = l, l = C, t[Xi + 4 >> 2] = C & 1073741823, nr = Xi + 8 | 0, C = (n & kr) + (Ce & 1073741823) | 0, b = w, w = (n & Nr) + w | 0, C = (l >> 31) + (b >>> 0 > w >>> 0 ? C + 1 | 0 : C) | 0, l = l >> 30, b = l, l = l + w | 0, C = b >>> 0 > l >>> 0 ? C + 1 | 0 : C, t[nr >> 2] = l, l = C, t[nr + 4 >> 2] = C & 1073741823, C = (n & ei) + (ui & 1073741823) | 0, w = (n & jr) + or | 0, C = (l >> 31) + (w >>> 0 < or >>> 0 ? C + 1 | 0 : C) | 0, l = l >> 30, b = l, l = l + w | 0, C = b >>> 0 > l >>> 0 ? C + 1 | 0 : C, w = l, t[P >> 2] = w, l = C, C = C & 1073741823, t[P + 4 >> 2] = C, b = Xi + 16 | 0, t[b >> 2] = w, t[b + 4 >> 2] = C, C = (n & Ei) + (Tt & 1073741823) | 0, w = (n & Qi) + Me | 0, C = (l >> 31) + (w >>> 0 < Me >>> 0 ? C + 1 | 0 : C) | 0, l = l >> 30, b = l, l = l + w | 0, C = b >>> 0 > l >>> 0 ? C + 1 | 0 : C, w = l, t[a >> 2] = w, l = C, C = C & 1073741823, t[a + 4 >> 2] = C, b = Xi + 24 | 0, t[b >> 2] = w, t[b + 4 >> 2] = C, C = (n & ai) + tr | 0, n = (n & wi) + lr | 0, C = (l >> 31) + (n >>> 0 < lr >>> 0 ? C + 1 | 0 : C) | 0, l = l >> 30, w = l, l = l + n | 0, C = w >>> 0 > l >>> 0 ? C + 1 | 0 : C, t[pe >> 2] = l, t[pe + 4 >> 2] = C, n = Xi + 32 | 0, t[n >> 2] = l, t[n + 4 >> 2] = C, U = K + 432 | 0;
  }
  function os(C, l) {
    var w = 0, n = 0, a = 0, b = 0, P = 0, K = 0, pe = 0, Ce = 0, Me = 0, Tt = 0, tr = 0, nr = 0, or = 0, lr = 0, gr = 0;
    a = U - 48 | 0, U = a;
    e: {
      if (!l) {
        yi[t[C + 168 >> 2]](689571, t[C + 172 >> 2]), C = 0;
        break e;
      }
      or = a + 8 | 0, Ir(or, l, a + 44 | 0), pe = t[a + 32 >> 2], w = t[a + 24 >> 2], K = t[a + 16 >> 2], n = t[a + 8 >> 2], Tt = t[a + 36 >> 2], Ce = t[a + 28 >> 2], b = t[a + 20 >> 2], P = t[a + 12 >> 2], lr = t[a + 44 >> 2] | !(pe | (w | (K | n)) | (Tt | (Ce | (b | P)))), C = lr ? 0 : -1, pe = C & pe, tr = C & w, Me = C & K, n = C & n, Tt = C & Tt, gr = C & Ce, nr = C & b, w = C & P, K = pe | (tr | (Me | n)) | (Tt | (gr | (nr | w))) ? -1 : 0, n = n ^ -1, P = n - 801750718 | 0, t[a + 8 >> 2] = K & P, w = w ^ -1, b = w - ((n >>> 0 < 801750718) + 1076732275 | 0) | 0, t[a + 12 >> 2] = b & K, C = (w | 0) == (b | 0) & n >>> 0 > P >>> 0 | w >>> 0 > b >>> 0, b = Me ^ -1, n = C + b | 0, P = nr ^ -1, w = P, nr = n - 1354194885 | 0, t[a + 16 >> 2] = nr & K, w = n >>> 0 < b >>> 0 ? w + 1 | 0 : w, Ce = w - ((n >>> 0 < 1354194885) + 1162945305 | 0) | 0, t[a + 20 >> 2] = Ce & K, tr = tr ^ -1, C = (w | 0) == (P | 0) & n >>> 0 < b >>> 0 | w >>> 0 < P >>> 0, b = (w | 0) == (Ce | 0) & n >>> 0 > nr >>> 0 | w >>> 0 > Ce >>> 0, w = C + b | 0, Me = gr ^ -1, n = Me + (w >>> 0 < b >>> 0) | 0, C = w, w = w + tr | 0, n = C >>> 0 > w >>> 0 ? n + 1 | 0 : n, P = w - 2 | 0, t[a + 24 >> 2] = P & K, b = n - (w >>> 0 < 2) | 0, t[a + 28 >> 2] = b & K, C = (n | 0) == (Me | 0) & w >>> 0 < tr >>> 0 | n >>> 0 < Me >>> 0, w = (n | 0) == (b | 0) & w >>> 0 > P >>> 0 | n >>> 0 > b >>> 0, C = C + w | 0, n = C >>> 0 < w >>> 0, w = C - pe | 0, t[a + 32 >> 2] = w - 2 & K, t[a + 36 >> 2] = (n - ((C >>> 0 < pe >>> 0) + Tt | 0) | 0) - (w >>> 0 < 2) & K, pr(l, or), C = !lr;
    }
    return U = a + 48 | 0, C;
  }
  function ts() {
    var C = 0, l = 0, w = 0, n = 0, a = 0, b = 0, P = 0, K = 0, pe = 0, Ce = 0, Me = 0, Tt = 0, tr = 0, nr = 0, or = 0, lr = 0, gr = 0, kr = 0, Nr = 0, jr = 0, Yr = 0, ei = 0, ai = 0, ui = 0, di = 0, Ii = 0, wi = 0, Ei = 0, Ti = 0, Di = 0;
    return a = U - 80 | 0, U = a, di = a + 8 | 0, C = a + 48 | 0, Ir(di, 690788, C), Di = t[a + 48 >> 2], Yr = t[a + 32 >> 2], Ii = t[a + 36 >> 2], ei = t[a + 24 >> 2], wi = t[a + 28 >> 2], ai = t[a + 8 >> 2], Ei = t[a + 12 >> 2], ui = t[a + 16 >> 2], Ti = t[a + 20 >> 2], t[a + 44 >> 2] = 0, Ir(C, 690949, a + 44 | 0), n = t[a + 52 >> 2], C = n + Ei | 0, w = t[a + 48 >> 2], Nr = w + ai | 0, lr = Nr >>> 0 < ai >>> 0 ? C + 1 | 0 : C, b = t[a + 60 >> 2], C = b + Ti | 0, Ce = C + 1 | 0, Me = C, C = t[a + 56 >> 2], l = C + ui | 0, P = l >>> 0 < ui >>> 0 ? Ce : Me, b = (P | 0) == (b | 0) & C >>> 0 > l >>> 0 | P >>> 0 < b >>> 0, C = (n | 0) == (lr | 0) & w >>> 0 > Nr >>> 0 | n >>> 0 > lr >>> 0, kr = C + l | 0, nr = kr >>> 0 < C >>> 0 ? P + 1 | 0 : P, w = (nr | 0) == (P | 0) & l >>> 0 > kr >>> 0 | P >>> 0 > nr >>> 0, b = b + w | 0, l = t[a + 68 >> 2], C = l + wi | 0, Ce = C + 1 | 0, Me = C, C = t[a + 64 >> 2], P = C + ei | 0, K = P >>> 0 < ei >>> 0 ? Ce : Me, w = K + (w >>> 0 > b >>> 0) | 0, gr = P + b | 0, b = gr >>> 0 < b >>> 0 ? w + 1 | 0 : w, n = (b | 0) == (K | 0) & P >>> 0 > gr >>> 0 | b >>> 0 < K >>> 0, pe = n + ((l | 0) == (K | 0) & C >>> 0 > P >>> 0 | l >>> 0 > K >>> 0) | 0, C = b, P = (C | 0) == -1, or = t[a + 76 >> 2], w = or + Ii | 0, l = t[a + 72 >> 2], tr = l + Yr | 0, Tt = tr >>> 0 < Yr >>> 0 ? w + 1 | 0 : w, w = Tt + (n >>> 0 > pe >>> 0) | 0, Ce = w + 1 | 0, Me = w, w = pe + tr | 0, jr = w >>> 0 < pe >>> 0 ? Ce : Me, n = P & gr >>> 0 < 4294967294 | (C | 0) != -1 | (jr & w) != -1, K = (nr | 0) == -1162945306, pe = (n | (K & kr >>> 0 < 2940772411 | nr >>> 0 < 3132021990)) ^ -1, n = (((Tt | 0) == (or | 0) & l >>> 0 > tr >>> 0 | Tt >>> 0 < or >>> 0) + ((Tt | 0) == (jr | 0) & w >>> 0 < tr >>> 0 | Tt >>> 0 > jr >>> 0) | 0) + (pe & ((lr | 0) == -1076732276 & Nr >>> 0 > 3493216576 | lr >>> 0 > 3218235020) | (pe & (K & kr >>> 0 > 2940772411 | nr >>> 0 > 3132021990) | (gr | 0) == -1 & P & (n ^ -1))) | 0, tr = n + gr | 0, tr >>> 0 < gr >>> 0 && (C = C + 1 | 0), K = ri(n, 0, 1354194884, 1162945305), P = nr + ve | 0, l = ri(n, 0, 801750719, 1076732275), Ce = l + Nr | 0, or = K + kr | 0, n = lr + ve | 0, pe = l >>> 0 > Ce >>> 0 ? n + 1 | 0 : n, n = (pe | 0) == (lr | 0) & Nr >>> 0 > Ce >>> 0 | pe >>> 0 < lr >>> 0, Tt = or + n | 0, l = K >>> 0 > or >>> 0 ? P + 1 | 0 : P, K = n >>> 0 > Tt >>> 0 ? l + 1 | 0 : l, n = (l | 0) == (K | 0) & Tt >>> 0 < or >>> 0 | l >>> 0 > K >>> 0, l = n + ((l | 0) == (nr | 0) & or >>> 0 < kr >>> 0 | l >>> 0 < nr >>> 0) | 0, Me = (C | 0) == (b | 0) & tr >>> 0 < gr >>> 0 | C >>> 0 < b >>> 0, n = (l >>> 0 < n >>> 0) + C | 0, b = l, l = l + tr | 0, P = b >>> 0 > l >>> 0 ? n + 1 | 0 : n, C = (P | 0) == (C | 0) & l >>> 0 < tr >>> 0 | C >>> 0 > P >>> 0, b = Me + C | 0, C = jr + (C >>> 0 > b >>> 0) | 0, b = w + b | 0, n = b >>> 0 < w >>> 0 ? C + 1 | 0 : C, C = a, b | (Tt | Ce | l) | (n | (K | pe | P)) ? Me = t[C + 44 >> 2] | (Di | !(Yr | (ei | (ai | ui)) | (Ii | (wi | (Ei | Ti))))) : Me = 1, a = !Me, w = 0 - a | 0, t[C + 32 >> 2] = b & w, t[C + 36 >> 2] = w & n, t[C + 24 >> 2] = l & w, t[C + 28 >> 2] = w & P, t[C + 16 >> 2] = w & Tt, t[C + 20 >> 2] = w & K, t[C + 8 >> 2] = w & Ce, t[C + 12 >> 2] = w & pe, pr(690788, di), U = C + 80 | 0, a;
  }
  function Gs(C, l, w) {
    var n = 0, a = 0, b = 0, P = 0, K = 0, pe = 0, Ce = 0, Me = 0, Tt = 0, tr = 0, nr = 0, or = 0, lr = 0, gr = 0, kr = 0, Nr = 0, jr = 0, Yr = 0, ei = 0, ai = 0, ui = 0, di = 0, Ii = 0, wi = 0, Ei = 0, Ti = 0, Di = 0, Qi = 0, Li = 0, Ki = 0, Wi = 0, Xi = 0, $i = 0, In = 0, kn = 0, Dn = 0, Mn = 0, zn = 0, es = 0, ns = 0, fs = 0, ps = 0, Es = 0, Ss = 0, Ps = 0, xs = 0, Bs = 0, vs = 0, eo = 0, Xs = 0, fo = 0, co = 0, ao = 0, no = 0, bo = 0, Io = 0, Po = 0, To = 0, mo = 0, Yi = 0, En = 0, On = 0, Xn = 0, ls = 0, Yn = 0, cs = 0, ks = 0, ws = 0, Ro = 0, jo = 0, Yo = 0, Mo = 0, No = 0, _s = 0, Zo = 0, ru = 0, Ca = 0;
    b = U - 1744 | 0, U = b, lr = b + 1704 | 0, ks = l + 80 | 0, Wn(lr, ks), $i = b + 1664 | 0, Yr = $i + 8 | 0, P = Yr, n = l + 8 | 0, Ei = t[n >> 2], jr = t[n + 4 >> 2], K = t[l + 4 >> 2], n = l + 32 | 0, Tt = t[n >> 2], Ce = t[n + 4 >> 2], pe = Ce, a = t[l >> 2], Ce = ri(pe >>> 16 | 0, 0, 977, 1), a = a + Ce | 0, n = K + ve | 0, K = a >>> 0 < Ce >>> 0 ? n + 1 | 0 : n, n = jr, Ce = K >>> 20 | 0, di = Ce + Ei | 0, n = Ce >>> 0 > di >>> 0 ? n + 1 | 0 : n, t[P >> 2] = di, Ro = n & 1048575, t[P + 4 >> 2] = Ro, Ei = $i + 16 | 0, Ce = Ei, P = l + 16 | 0, jr = t[P >> 2], nr = t[P + 4 >> 2], P = n, n = nr, P = P >>> 20 | 0, Ii = P + jr | 0, n = P >>> 0 > Ii >>> 0 ? n + 1 | 0 : n, t[Ce >> 2] = Ii, jo = n & 1048575, t[Ce + 4 >> 2] = jo, jr = $i + 24 | 0, Ce = jr, P = l + 24 | 0, nr = t[P >> 2], Ps = t[P + 4 >> 2], P = n, n = Ps, P = P >>> 20 | 0, Ti = P + nr | 0, n = P >>> 0 > Ti >>> 0 ? n + 1 | 0 : n, t[Ce >> 2] = Ti, Yo = n & 1048575, t[Ce + 4 >> 2] = Yo, nr = $i + 32 | 0, Ce = nr, P = n, n = pe & 65535, P = P >>> 20 | 0, Es = P + Tt | 0, n = P >>> 0 > Es >>> 0 ? n + 1 | 0 : n, t[Ce >> 2] = Es, bo = n, t[Ce + 4 >> 2] = n, co = a, t[b + 1664 >> 2] = a, Mo = K & 1048575, t[b + 1668 >> 2] = Mo, zr(b + 1624 | 0, w, lr), n = l - -64 | 0, ai = t[n >> 2], gr = t[n + 4 >> 2], n = l + 56 | 0, ei = t[n >> 2], Wi = t[n + 4 >> 2], n = l + 48 | 0, Dn = t[n >> 2], ns = t[n + 4 >> 2], n = l + 72 | 0, ps = t[n >> 2], Ps = t[n + 4 >> 2], In = t[l + 40 >> 2], wi = t[l + 44 >> 2], n = b + 1584 | 0, zr(n, w + 40 | 0, lr), zr(n, n, ks), Xi = t[b + 1636 >> 2], n = Xi + t[Yr + 4 >> 2] | 0, En = b + 1544 | 0, Xn = En + 8 | 0, a = Xn, Io = t[b + 1632 >> 2], Tt = t[Yr >> 2], Ce = Io + Tt | 0, t[a >> 2] = Ce, lr = Ce >>> 0 < Tt >>> 0 ? n + 1 | 0 : n, t[a + 4 >> 2] = lr, Li = t[b + 1644 >> 2], n = Li + t[Ei + 4 >> 2] | 0, ls = En + 16 | 0, K = ls, Po = t[b + 1640 >> 2], a = t[Ei >> 2], Tt = Po + a | 0, t[K >> 2] = Tt, a = a >>> 0 > Tt >>> 0 ? n + 1 | 0 : n, t[K + 4 >> 2] = a, Ki = t[b + 1652 >> 2], n = Ki + t[jr + 4 >> 2] | 0, Yn = En + 24 | 0, Yr = Yn, Mn = t[b + 1648 >> 2], K = t[jr >> 2], P = Mn + K | 0, t[Yr >> 2] = P, K = P >>> 0 < K >>> 0 ? n + 1 | 0 : n, t[Yr + 4 >> 2] = K, xs = t[b + 1660 >> 2], n = xs + t[nr + 4 >> 2] | 0, mo = En + 32 | 0, Ei = mo, kn = t[b + 1656 >> 2], jr = t[nr >> 2], Yr = kn + jr | 0, t[Ei >> 2] = Yr, nr = jr >>> 0 > Yr >>> 0 ? n + 1 | 0 : n, t[Ei + 4 >> 2] = nr, eo = t[b + 1628 >> 2], n = eo + t[b + 1668 >> 2] | 0, Qi = t[b + 1624 >> 2], jr = t[b + 1664 >> 2], Ei = Qi + jr | 0, t[b + 1544 >> 2] = Ei, jr = jr >>> 0 > Ei >>> 0 ? n + 1 | 0 : n, t[b + 1548 >> 2] = jr, no = b + 1232 | 0, tr = Ei << 1, Me = jr << 1 | Ei >>> 31, Pr(no, P, K, 0, 0, tr, Me, 0, 0), zn = b + 1312 | 0, ui = Ce << 1, kr = lr, or = Ce, lr = lr << 1 | Ce >>> 31, Pr(zn, Tt, a, 0, 0, ui, lr, 0, 0), Nr = b + 1168 | 0, n = nr, Pr(Nr, Yr, n, 0, 0, Yr, n, 0, 0), Xs = b + 1152 | 0, Pr(Xs, t[b + 1168 >> 2], t[b + 1172 >> 2], 0, 0, 15632, 16, 0, 0), fs = b + 1120 | 0, Ce = Yr << 1, nr = n << 1 | Yr >>> 31, Pr(fs, Ce, nr, 0, 0, Ei, jr, 0, 0), Ss = b + 1216 | 0, Pr(Ss, P, K, 0, 0, ui, lr, 0, 0), fo = b + 1328 | 0, Pr(fo, Tt, a, 0, 0, Tt, a, 0, 0), Bs = b + 1136 | 0, n = Nr + 8 | 0, Pr(Bs, t[n >> 2], t[n + 4 >> 2], 0, 0, 64028672, 65536, 0, 0), To = b + 1248 | 0, Pr(To, Ei, jr, 0, 0, Ei, jr, 0, 0), vs = b + 1104 | 0, Pr(vs, Ce, nr, 0, 0, or, kr, 0, 0), es = a, Ei = Tt, n = a << 1 | Tt >>> 31, ao = b + 1200 | 0, ui = P, Nr = K, Pr(ao, P, K, 0, 0, Tt << 1, n, 0, 0), lr = t[b + 1232 >> 2], a = t[b + 1312 >> 2], Tt = lr + a | 0, P = t[b + 1236 >> 2], n = P + t[b + 1316 >> 2] | 0, a = a >>> 0 > Tt >>> 0 ? n + 1 | 0 : n, n = a + t[b + 1156 >> 2] | 0, K = Tt, Yr = t[b + 1152 >> 2], Tt = K + Yr | 0, Di = Tt, Tt = Tt >>> 0 < Yr >>> 0 ? n + 1 | 0 : n, Yr = (a | 0) == (Tt | 0) & K >>> 0 > Di >>> 0 | a >>> 0 > Tt >>> 0, n = Xs + 8 | 0, jr = t[n >> 2], pe = t[n + 4 >> 2], P = (a | 0) == (P | 0) & K >>> 0 < lr >>> 0 | a >>> 0 < P >>> 0, n = zn + 8 | 0, lr = t[n >> 2], a = no + 8 | 0, K = lr + t[a >> 2] | 0, a = t[a + 4 >> 2] + t[n + 4 >> 2] | 0, n = K >>> 0 < lr >>> 0 ? a + 1 | 0 : a, a = P + K | 0, n = (a >>> 0 < K >>> 0 ? n + 1 | 0 : n) + pe | 0, P = a, a = a + jr | 0, n = P >>> 0 > a >>> 0 ? n + 1 | 0 : n, P = a, a = a + Yr | 0, K = P >>> 0 > a >>> 0 ? n + 1 | 0 : n, P = K << 12 | a >>> 20, zn = Tt, Tt = a << 12 | Tt >>> 20, no = P, Yi = t[b + 1216 >> 2], P = t[b + 1328 >> 2], a = Yi + P | 0, Xs = t[b + 1220 >> 2], n = Xs + t[b + 1332 >> 2] | 0, P = a >>> 0 < P >>> 0 ? n + 1 | 0 : n, Yr = a, lr = t[b + 1120 >> 2], n = a + lr | 0, a = P + t[b + 1124 >> 2] | 0, lr = n >>> 0 < lr >>> 0 ? a + 1 | 0 : a, jr = n, pe = t[b + 1136 >> 2], a = n + pe | 0, n = lr + t[b + 1140 >> 2] | 0, n = a >>> 0 < pe >>> 0 ? n + 1 | 0 : n, pe = a, a = n, n = n + no | 0, cs = b + 1088 | 0, no = pe + Tt | 0, Tt = no >>> 0 < pe >>> 0 ? n + 1 | 0 : n, On = (a | 0) == (Tt | 0) & pe >>> 0 > no >>> 0 | a >>> 0 > Tt >>> 0, pe = (a | 0) == (lr | 0) & pe >>> 0 < jr >>> 0 | a >>> 0 < lr >>> 0, n = Bs + 8 | 0, Bs = t[n >> 2], ws = t[n + 4 >> 2], lr = (P | 0) == (lr | 0) & jr >>> 0 < Yr >>> 0 | P >>> 0 > lr >>> 0, n = fs + 8 | 0, jr = t[n >> 2], fs = t[n + 4 >> 2], Yr = (P | 0) == (Xs | 0) & Yr >>> 0 < Yi >>> 0 | P >>> 0 < Xs >>> 0, n = fo + 8 | 0, Xs = t[n >> 2], a = Ss + 8 | 0, P = Xs + t[a >> 2] | 0, a = t[a + 4 >> 2] + t[n + 4 >> 2] | 0, n = P >>> 0 < Xs >>> 0 ? a + 1 | 0 : a, a = P + Yr | 0, n = (a >>> 0 < P >>> 0 ? n + 1 | 0 : n) + fs | 0, P = a, a = a + jr | 0, n = P >>> 0 > a >>> 0 ? n + 1 | 0 : n, P = a, a = a + lr | 0, n = (P >>> 0 > a >>> 0 ? n + 1 | 0 : n) + ws | 0, P = a + Bs | 0, a = P >>> 0 < a >>> 0 ? n + 1 | 0 : n, n = P + pe | 0, a = n >>> 0 < P >>> 0 ? a + 1 | 0 : a, P = n, n = a, K = K >>> 20 | 0, a = P + K | 0, n = K >>> 0 > a >>> 0 ? n + 1 | 0 : n, P = a, a = a + On | 0, K = P >>> 0 > a >>> 0 ? n + 1 | 0 : n, lr = K << 12 | a >>> 20, P = Tt, a = a << 12 | P >>> 20, Tt = lr, pe = t[b + 1104 >> 2], lr = t[b + 1200 >> 2], Yr = pe + lr | 0, jr = t[b + 1108 >> 2], n = jr + t[b + 1204 >> 2] | 0, lr = lr >>> 0 > Yr >>> 0 ? n + 1 | 0 : n, n = a + Yr | 0, a = Tt + lr | 0, Tt = n >>> 0 < Yr >>> 0 ? a + 1 | 0 : a, a = n, n = Tt << 4 | n >>> 28, fs = a << 4 & -16, Xs = P, Pr(cs, fs | P >>> 16 & 15, n & 16777215, 0, 0, 977, 1, 0, 0), fs = b + 1280 | 0, Pr(fs, or, kr, 0, 0, tr, Me, 0, 0), Ss = b + 1072 | 0, Pr(Ss, Ce, nr, 0, 0, Ei, es, 0, 0), fo = b + 1184 | 0, Pr(fo, ui, Nr, 0, 0, ui, Nr, 0, 0), On = b + 1056 | 0, Bs = On, Yi = (Tt | 0) == (lr | 0) & a >>> 0 < Yr >>> 0 | Tt >>> 0 < lr >>> 0, P = (lr | 0) == (jr | 0) & pe >>> 0 > Yr >>> 0 | lr >>> 0 < jr >>> 0, n = ao + 8 | 0, lr = t[n >> 2], Yr = vs + 8 | 0, a = lr + t[Yr >> 2] | 0, n = t[Yr + 4 >> 2] + t[n + 4 >> 2] | 0, n = a >>> 0 < lr >>> 0 ? n + 1 | 0 : n, pe = a, a = a + P | 0, n = pe >>> 0 > a >>> 0 ? n + 1 | 0 : n, K = K >>> 20 | 0, P = K, K = a + K | 0, a = P >>> 0 > K >>> 0 ? n + 1 | 0 : n, n = K + Yi | 0, a = n >>> 0 < K >>> 0 ? a + 1 | 0 : a, P = a << 12 | n >>> 20, K = n << 12 | Tt >>> 20, lr = P, jr = t[b + 1072 >> 2], P = t[b + 1184 >> 2], Tt = jr + P | 0, Yr = t[b + 1076 >> 2], n = Yr + t[b + 1188 >> 2] | 0, n = P >>> 0 > Tt >>> 0 ? n + 1 | 0 : n, P = Tt, Tt = n, n = n + lr | 0, K = P + K | 0, n = K >>> 0 < P >>> 0 ? n + 1 | 0 : n, lr = K, K = n, Pr(Bs, lr, n & 1048575, 0, 0, 15632, 16, 0, 0), pe = b + 1264 | 0, Pr(pe, Ei, es, 0, 0, tr, Me, 0, 0), Me = b + 1296 | 0, Pr(Me, or, kr, 0, 0, or, kr, 0, 0), Ei = b + 1040 | 0, Pr(Ei, Ce, nr, 0, 0, ui, Nr, 0, 0), tr = b + 1024 | 0, Ce = tr, lr = (n | 0) == (Tt | 0) & P >>> 0 > lr >>> 0 | n >>> 0 < Tt >>> 0, P = (Tt | 0) == (Yr | 0) & P >>> 0 < jr >>> 0 | Tt >>> 0 < Yr >>> 0, n = fo + 8 | 0, Yr = t[n >> 2], jr = Ss + 8 | 0, Tt = Yr + t[jr >> 2] | 0, n = t[jr + 4 >> 2] + t[n + 4 >> 2] | 0, n = Tt >>> 0 < Yr >>> 0 ? n + 1 | 0 : n, nr = Tt, Tt = P + Tt | 0, n = nr >>> 0 > Tt >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, P = a, a = a + Tt | 0, n = P >>> 0 > a >>> 0 ? n + 1 | 0 : n, Tt = a + lr | 0, a = Tt >>> 0 < a >>> 0 ? n + 1 | 0 : n, P = a << 12 | Tt >>> 20, lr = Tt << 12 | K >>> 20, Yr = t[b + 1040 >> 2], Tt = lr + Yr | 0, K = P, n = P + t[b + 1044 >> 2] | 0, n = Tt >>> 0 < Yr >>> 0 ? n + 1 | 0 : n, Pr(Ce, Tt, n, 0, 0, 15632, 16, 0, 0), or = b + 1008 | 0, P = or, Tt = (n | 0) == (K | 0) & Tt >>> 0 < lr >>> 0 | n >>> 0 < K >>> 0, n = Ei + 8 | 0, K = t[n >> 2], n = t[n + 4 >> 2], a = a >>> 20 | 0, Ce = a, a = a + K | 0, n = Ce >>> 0 > a >>> 0 ? n + 1 | 0 : n, K = a, a = a + Tt | 0, n = K >>> 0 > a >>> 0 ? n + 1 | 0 : n, Pr(P, a, n, 0, 0, 64028672, 65536, 0, 0), Bs = t[b + 1608 >> 2], fo = t[b + 1612 >> 2], vs = t[b + 1600 >> 2], ws = t[b + 1604 >> 2], Yi = t[b + 1584 >> 2], No = t[b + 1588 >> 2], Ei = t[b + 1616 >> 2], jr = t[b + 1620 >> 2], ao = t[b + 1592 >> 2], _s = t[b + 1596 >> 2], t[b + 1416 >> 2] = -4 - kn, t[b + 1420 >> 2] = 262143 - ((kn >>> 0 > 4294967292) + xs | 0), t[b + 1408 >> 2] = -4 - Mn, t[b + 1412 >> 2] = 4194303 - ((Mn >>> 0 > 4294967292) + Ki | 0), t[b + 1400 >> 2] = -4 - Po, t[b + 1404 >> 2] = 4194303 - ((Po >>> 0 > 4294967292) + Li | 0), t[b + 1392 >> 2] = -4 - Io, t[b + 1396 >> 2] = 4194303 - ((Io >>> 0 > 4294967292) + Xi | 0), t[b + 1384 >> 2] = -3908 - Qi, t[b + 1388 >> 2] = 4194299 - ((Qi >>> 0 > 4294963388) + eo | 0), n = To + 8 | 0, kr = t[n >> 2], ui = t[n + 4 >> 2], n = cs + 8 | 0, K = t[n >> 2], Mn = t[n + 4 >> 2], Tt = t[b + 1248 >> 2], n = t[b + 1252 >> 2], P = t[b + 1088 >> 2], a = t[b + 1092 >> 2], lr = fs + 8 | 0, kn = t[lr >> 2], Qi = t[lr + 4 >> 2], lr = On + 8 | 0, Ce = t[lr >> 2], Xi = t[lr + 4 >> 2], Yr = t[b + 1280 >> 2], Li = t[b + 1284 >> 2], nr = t[b + 1056 >> 2], lr = t[b + 1060 >> 2], Me = Me + 8 | 0, To = t[Me >> 2], cs = t[Me + 4 >> 2], pe = pe + 8 | 0, eo = t[pe >> 2], On = t[pe + 4 >> 2], pe = t[b + 1296 >> 2], Zo = t[b + 1300 >> 2], fs = t[b + 1264 >> 2], Ki = t[b + 1268 >> 2], Me = tr + 8 | 0, es = t[Me >> 2], Io = t[Me + 4 >> 2], Me = t[b + 1024 >> 2], tr = t[b + 1028 >> 2], Ss = t[b + 1008 >> 2], xs = t[b + 1012 >> 2], or = or + 8 | 0, ru = t[or >> 2], Po = t[or + 4 >> 2], Ca = b + 1384 | 0, zr(b + 1504 | 0, $i, Ca), n = n + a | 0, Nr = P + Tt | 0, Tt = Nr >>> 0 < Tt >>> 0 ? n + 1 | 0 : n, P = (a | 0) == (Tt | 0) & P >>> 0 > Nr >>> 0 | a >>> 0 > Tt >>> 0, a = ui + Mn | 0, n = K, K = K + kr | 0, n = n >>> 0 > K >>> 0 ? a + 1 | 0 : a, a = P + K | 0, K = a >>> 0 < K >>> 0 ? n + 1 | 0 : n, n = K << 12 | a >>> 20, $i = Tt, Tt = a << 12 | Tt >>> 20, or = n, n = lr + Li | 0, P = nr + Yr | 0, a = P >>> 0 < Yr >>> 0 ? n + 1 | 0 : n, n = a + or | 0, ui = P + Tt | 0, Tt = ui >>> 0 < P >>> 0 ? n + 1 | 0 : n, Yr = (a | 0) == (Tt | 0) & P >>> 0 > ui >>> 0 | a >>> 0 > Tt >>> 0, lr = (a | 0) == (lr | 0) & P >>> 0 < nr >>> 0 | a >>> 0 < lr >>> 0, n = Qi + Xi | 0, P = Ce + kn | 0, a = P >>> 0 < Ce >>> 0 ? n + 1 | 0 : n, n = P + lr | 0, a = n >>> 0 < P >>> 0 ? a + 1 | 0 : a, P = n, n = a, K = K >>> 20 | 0, a = P + K | 0, n = K >>> 0 > a >>> 0 ? n + 1 | 0 : n, P = a, a = a + Yr | 0, lr = P >>> 0 > a >>> 0 ? n + 1 | 0 : n, K = lr << 12 | a >>> 20, Mn = Tt, Tt = a << 12 | Tt >>> 20, n = Ki + Zo | 0, or = pe + fs | 0, Ce = or >>> 0 < pe >>> 0 ? n + 1 | 0 : n, a = Ce + tr | 0, tr = Me + or | 0, Yr = tr >>> 0 < Me >>> 0 ? a + 1 | 0 : a, n = Yr + K | 0, kr = Tt + tr | 0, Tt = kr >>> 0 < tr >>> 0 ? n + 1 | 0 : n, K = Ei, P = jr, Me = ps, ps = Ps & 65535, a = ri(Ps >>> 16 | 0, 0, 977, 1), jr = a + In | 0, n = wi + ve | 0, kn = a >>> 0 > jr >>> 0 ? n + 1 | 0 : n, n = ns, a = kn >>> 20 | 0, Ei = a + Dn | 0, Qi = a >>> 0 > Ei >>> 0 ? n + 1 | 0 : n, n = Wi, a = Qi >>> 20 | 0, nr = a + ei | 0, Xi = a >>> 0 > nr >>> 0 ? n + 1 | 0 : n, a = gr, n = ps, pe = Xi >>> 20 | 0, gr = pe, pe = pe + ai | 0, Li = gr >>> 0 > pe >>> 0 ? a + 1 | 0 : a, a = Li >>> 20 | 0, Ps = a + Me | 0, Me = a >>> 0 > Ps >>> 0 ? n + 1 | 0 : n, n = Me + P | 0, P = K + Ps | 0, K = P >>> 0 < Ps >>> 0 ? n + 1 | 0 : n, gr = t[b + 1528 >> 2], ei = t[b + 1532 >> 2], ai = (Tt | 0) == (Yr | 0) & tr >>> 0 > kr >>> 0 | Tt >>> 0 < Yr >>> 0, Yr = (Ce | 0) == (Yr | 0) & tr >>> 0 < or >>> 0 | Ce >>> 0 > Yr >>> 0, tr = (Ce | 0) == (Ki | 0) & or >>> 0 < fs >>> 0 | Ce >>> 0 < Ki >>> 0, n = On + cs | 0, Ce = eo + To | 0, a = Ce >>> 0 < eo >>> 0 ? n + 1 | 0 : n, n = Ce, Ce = Ce + tr | 0, n = (n >>> 0 > Ce >>> 0 ? a + 1 | 0 : a) + Io | 0, a = Ce + es | 0, n = a >>> 0 < Ce >>> 0 ? n + 1 | 0 : n, Ce = a, a = a + Yr | 0, n = Ce >>> 0 > a >>> 0 ? n + 1 | 0 : n, lr = lr >>> 20 | 0, a = a + lr | 0, n = lr >>> 0 > a >>> 0 ? n + 1 | 0 : n, Ce = a, a = a + ai | 0, lr = Ce >>> 0 > a >>> 0 ? n + 1 | 0 : n, n = a, a = lr << 12 | n >>> 20, ai = Tt, Tt = n << 12 | Tt >>> 20, tr = a, Ce = Di & -2, a = Ce + Ss | 0, n = xs + (zn & 1048575) | 0, Ce = a >>> 0 < Ce >>> 0 ? n + 1 | 0 : n, n = Ce + tr | 0, Yr = a, Wi = a + Tt | 0, Tt = a >>> 0 > Wi >>> 0 ? n + 1 | 0 : n, n = ei + (Tt & 1048575) | 0, tr = gr + Wi | 0, or = tr >>> 0 < Wi >>> 0 ? n + 1 | 0 : n, n = t[b + 1524 >> 2] + (ai & 1048575) | 0, a = kr, kr = t[b + 1520 >> 2] + kr | 0, ai = a >>> 0 > kr >>> 0 ? n + 1 | 0 : n, n = t[b + 1516 >> 2] + (Mn & 1048575) | 0, a = ui, ui = t[b + 1512 >> 2] + ui | 0, gr = a >>> 0 > ui >>> 0 ? n + 1 | 0 : n, a = t[b + 1508 >> 2] + ($i & 1048575) | 0, n = Nr, Nr = t[b + 1504 >> 2] + Nr | 0, ei = n >>> 0 > Nr >>> 0 ? a + 1 | 0 : a, n = t[b + 1540 >> 2] + (Xs & 65535) | 0, a = t[b + 1536 >> 2] + no | 0, n = a >>> 0 < no >>> 0 ? n + 1 | 0 : n, no = a, Dn = n, Wi = (Ce | 0) == (Tt | 0) & Yr >>> 0 > Wi >>> 0 | Ce >>> 0 > Tt >>> 0, Ce = (Ce | 0) == (xs | 0) & Yr >>> 0 < Ss >>> 0 | Ce >>> 0 < xs >>> 0, a = Ce + ru | 0, n = Po, n = a >>> 0 < Ce >>> 0 ? n + 1 | 0 : n, lr = lr >>> 20 | 0, Ce = lr, lr = a + lr | 0, a = Ce >>> 0 > lr >>> 0 ? n + 1 | 0 : n, n = lr, lr = lr + Wi | 0, n = (n >>> 0 > lr >>> 0 ? a + 1 | 0 : a) << 12 | lr >>> 20, a = lr << 12 | Tt >>> 20, Tt = a + no | 0, n = n + Dn | 0, lr = a >>> 0 > Tt >>> 0 ? n + 1 | 0 : n, Ce = ri(lr >>> 16 | 0, 0, 977, 1), a = Ce + Nr | 0, n = ei + ve | 0, Wi = a, Dn = a >>> 0 < Ce >>> 0 ? n + 1 | 0 : n, n = gr, a = Dn >>> 20 | 0, ns = a + ui | 0, ps = a >>> 0 > ns >>> 0 ? n + 1 | 0 : n, a = ai, n = or, Ce = ps >>> 20 | 0, In = Ce + kr | 0, wi = Ce >>> 0 > In >>> 0 ? a + 1 | 0 : a, a = wi >>> 20 | 0, es = a + tr | 0, Ce = a >>> 0 > es >>> 0 ? n + 1 | 0 : n, n = lr & 65535, a = Ce >>> 20 | 0, Di = a + Tt | 0, zn = a >>> 0 > Di >>> 0 ? n + 1 | 0 : n, xs = Ps << 1, eo = Me << 1 | Ps >>> 31, fs = Tt, Ss = lr, Ps = P, To = K & 65535, a = fo, fo = Li & 1048575, n = a + fo | 0, Xs = pe + Bs | 0, lr = Xs >>> 0 < Bs >>> 0 ? n + 1 | 0 : n, Bs = Xi & 1048575, n = Bs + ws | 0, Io = nr + vs | 0, Yr = Io >>> 0 < vs >>> 0 ? n + 1 | 0 : n, vs = Qi & 1048575, a = vs + _s | 0, P = Ei, Po = P + ao | 0, Ei = Po >>> 0 < ao >>> 0 ? a + 1 | 0 : a, ao = kn & 1048575, n = ao + No | 0, Me = jr, jr = Me + Yi | 0, Tt = jr >>> 0 < Yi >>> 0 ? n + 1 | 0 : n, no = K, K = ri(K >>> 16 | 0, 0, 977, 1), a = K + jr | 0, n = Tt + ve | 0, n = a >>> 0 < K >>> 0 ? n + 1 | 0 : n, K = a, $i = n, n = Ei, a = $i >>> 20 | 0, Mn = a + Po | 0, kn = a >>> 0 > Mn >>> 0 ? n + 1 | 0 : n, n = Yr, a = kn >>> 20 | 0, Qi = a + Io | 0, Xi = a >>> 0 > Qi >>> 0 ? n + 1 | 0 : n, a = lr, n = To, Li = Xi >>> 20 | 0, Ki = Li, Li = Li + Xs | 0, a = Ki >>> 0 > Li >>> 0 ? a + 1 | 0 : a, Ki = a >>> 20 | 0, To = Ki, Ki = Ki + Ps | 0, n = To >>> 0 > Ki >>> 0 ? n + 1 | 0 : n, Ki | (Li | (K | Mn | Qi)) | (n | ($i | kn | Xi | a) & 1048575) ? (Mn & (K ^ 976) & Qi & Li & Ki) == -1 ? a = (kn & ($i ^ 1) & Xi & a & (n ^ 983040)) == 1048575 : a = 0 : a = 1, n = a, es | (Wi | ns | In) | Di | ((ps | Dn | wi | Ce) & 1048575 | zn) ? (ns & (Wi ^ 976) & In & es & Di) == -1 ? a = (ps & (Dn ^ 1) & wi & Ce & (zn ^ 983040)) == 1048575 : a = 0 : a = 1, Di = n & a, t[b + 1376 >> 2] = Di ? xs : fs, t[b + 1380 >> 2] = Di ? eo : Ss, t[b + 1368 >> 2] = Di ? pe << 1 : tr, t[b + 1372 >> 2] = Di ? fo << 1 | pe >>> 31 : or, t[b + 1360 >> 2] = Di ? nr << 1 : kr, t[b + 1364 >> 2] = Di ? Bs << 1 | nr >>> 31 : ai, t[b + 1352 >> 2] = Di ? P << 1 : ui, t[b + 1356 >> 2] = Di ? vs << 1 | P >>> 31 : gr, t[b + 1344 >> 2] = Di ? Me << 1 : Nr, t[b + 1348 >> 2] = Di ? ao << 1 | Me >>> 31 : ei, n = t[b + 1420 >> 2] + bo | 0, a = t[b + 1416 >> 2] + Es | 0, n = a >>> 0 < Es >>> 0 ? n + 1 | 0 : n, pe = Di ? a : Ps, t[b + 1416 >> 2] = pe, Me = Di ? n : no, t[b + 1420 >> 2] = Me, n = t[b + 1412 >> 2] + Yo | 0, a = t[b + 1408 >> 2] + Ti | 0, n = a >>> 0 < Ti >>> 0 ? n + 1 | 0 : n, es = Di ? a : Xs, t[b + 1408 >> 2] = es, zn = Di ? n : lr, t[b + 1412 >> 2] = zn, n = t[b + 1404 >> 2] + jo | 0, a = t[b + 1400 >> 2] + Ii | 0, n = a >>> 0 < Ii >>> 0 ? n + 1 | 0 : n, K = Di ? a : Io, t[b + 1400 >> 2] = K, P = Di ? n : Yr, t[b + 1404 >> 2] = P, n = t[b + 1396 >> 2] + Ro | 0, a = t[b + 1392 >> 2] + di | 0, n = a >>> 0 < di >>> 0 ? n + 1 | 0 : n, a = Di ? a : Po, t[b + 1392 >> 2] = a, Ce = Di ? n : Ei, t[b + 1396 >> 2] = Ce, n = t[b + 1388 >> 2] + Mo | 0, nr = t[b + 1384 >> 2] + co | 0, n = nr >>> 0 < co >>> 0 ? n + 1 | 0 : n, nr = Di ? nr : jr, t[b + 1384 >> 2] = nr, n = Di ? n : Tt, tr = n, t[b + 1388 >> 2] = n, or = b + 896 | 0, Ii = nr << 1, di = n << 1 | nr >>> 31, Pr(or, Ii, di, 0, 0, es, zn, 0, 0), Wi = Ce, Ti = a, a = Ce << 1 | a >>> 31, kr = b + 944 | 0, Ce = Ti << 1, Pr(kr, Ce, a, 0, 0, K, P, 0, 0), ai = b + 832 | 0, Pr(ai, pe, Me, 0, 0, pe, Me, 0, 0), ui = b + 816 | 0, Pr(ui, t[b + 832 >> 2], t[b + 836 >> 2], 0, 0, 15632, 16, 0, 0), Nr = b + 784 | 0, gr = pe << 1, Es = Me << 1 | pe >>> 31, Pr(Nr, gr, Es, 0, 0, nr, n, 0, 0), ei = b + 880 | 0, Pr(ei, Ce, a, 0, 0, es, zn, 0, 0), In = b + 928 | 0, Pr(In, K, P, 0, 0, K, P, 0, 0), wi = b + 800 | 0, n = ai + 8 | 0, Pr(wi, t[n >> 2], t[n + 4 >> 2], 0, 0, 64028672, 65536, 0, 0), Mn = b + 992 | 0, Pr(Mn, nr, tr, 0, 0, nr, tr, 0, 0), $i = b + 768 | 0, Pr($i, gr, Es, 0, 0, Ti, Wi, 0, 0), Dn = P, co = K, a = P << 1 | K >>> 31, kn = b + 864 | 0, Pr(kn, K << 1, a, 0, 0, es, zn, 0, 0), nr = t[b + 896 >> 2], K = t[b + 944 >> 2], a = nr + K | 0, Ce = t[b + 900 >> 2], n = Ce + t[b + 948 >> 2] | 0, K = a >>> 0 < K >>> 0 ? n + 1 | 0 : n, n = K + t[b + 820 >> 2] | 0, P = a, pe = t[b + 816 >> 2], a = a + pe | 0, ns = a, a = a >>> 0 < pe >>> 0 ? n + 1 | 0 : n, pe = (K | 0) == (a | 0) & P >>> 0 > ns >>> 0 | a >>> 0 < K >>> 0, n = ui + 8 | 0, Me = t[n >> 2], tr = t[n + 4 >> 2], P = (K | 0) == (Ce | 0) & P >>> 0 < nr >>> 0 | K >>> 0 < Ce >>> 0, n = kr + 8 | 0, Ce = t[n >> 2], nr = or + 8 | 0, K = Ce + t[nr >> 2] | 0, n = t[nr + 4 >> 2] + t[n + 4 >> 2] | 0, n = K >>> 0 < Ce >>> 0 ? n + 1 | 0 : n, Ce = K, K = P + K | 0, n = (Ce >>> 0 > K >>> 0 ? n + 1 | 0 : n) + tr | 0, P = K, K = K + Me | 0, n = P >>> 0 > K >>> 0 ? n + 1 | 0 : n, P = K, K = K + pe | 0, P = P >>> 0 > K >>> 0 ? n + 1 | 0 : n, Ce = P << 12 | K >>> 20, ps = a, K = K << 12 | a >>> 20, nr = Ce, ai = t[b + 880 >> 2], Ce = t[b + 928 >> 2], n = ai + Ce | 0, kr = t[b + 884 >> 2], a = kr + t[b + 932 >> 2] | 0, pe = n >>> 0 < Ce >>> 0 ? a + 1 | 0 : a, Me = n, Ce = t[b + 784 >> 2], a = n + Ce | 0, n = pe + t[b + 788 >> 2] | 0, n = a >>> 0 < Ce >>> 0 ? n + 1 | 0 : n, tr = a, or = t[b + 800 >> 2], a = a + or | 0, Ce = n, n = n + t[b + 804 >> 2] | 0, n = a >>> 0 < or >>> 0 ? n + 1 | 0 : n, or = a, a = n + nr | 0, Qi = b + 752 | 0, ui = Qi, nr = K + or | 0, K = nr >>> 0 < or >>> 0 ? a + 1 | 0 : a, Xi = (n | 0) == (K | 0) & nr >>> 0 < or >>> 0 | n >>> 0 > K >>> 0, or = (n | 0) == (Ce | 0) & tr >>> 0 > or >>> 0 | n >>> 0 < Ce >>> 0, n = wi + 8 | 0, wi = t[n >> 2], Li = t[n + 4 >> 2], Ce = (pe | 0) == (Ce | 0) & Me >>> 0 > tr >>> 0 | pe >>> 0 > Ce >>> 0, n = Nr + 8 | 0, tr = t[n >> 2], Nr = t[n + 4 >> 2], pe = (pe | 0) == (kr | 0) & Me >>> 0 < ai >>> 0 | pe >>> 0 < kr >>> 0, n = In + 8 | 0, Me = t[n >> 2], kr = ei + 8 | 0, a = Me + t[kr >> 2] | 0, n = t[kr + 4 >> 2] + t[n + 4 >> 2] | 0, n = a >>> 0 < Me >>> 0 ? n + 1 | 0 : n, Me = a, a = a + pe | 0, n = (Me >>> 0 > a >>> 0 ? n + 1 | 0 : n) + Nr | 0, pe = a, a = a + tr | 0, n = pe >>> 0 > a >>> 0 ? n + 1 | 0 : n, Ce = a + Ce | 0, a = (Ce >>> 0 < a >>> 0 ? n + 1 | 0 : n) + Li | 0, n = Ce, Ce = Ce + wi | 0, n = n >>> 0 > Ce >>> 0 ? a + 1 | 0 : a, a = Ce + or | 0, n = a >>> 0 < Ce >>> 0 ? n + 1 | 0 : n, P = P >>> 20 | 0, a = a + P | 0, n = P >>> 0 > a >>> 0 ? n + 1 | 0 : n, P = a, a = a + Xi | 0, P = P >>> 0 > a >>> 0 ? n + 1 | 0 : n, Ce = P << 12 | a >>> 20, Me = a << 12 | K >>> 20, n = Ce, Nr = t[b + 768 >> 2], Ce = t[b + 864 >> 2], pe = Nr + Ce | 0, or = t[b + 772 >> 2], a = or + t[b + 868 >> 2] | 0, Ce = pe >>> 0 < Ce >>> 0 ? a + 1 | 0 : a, n = Ce + n | 0, Me = pe + Me | 0, a = Me >>> 0 < pe >>> 0 ? n + 1 | 0 : n, tr = Me, n = a << 4 | Me >>> 28, In = K, Pr(ui, K >>> 16 & 15 | Me << 4 & -16, n & 16777215, 0, 0, 977, 1, 0, 0), kr = t[b + 756 >> 2], n = kr + t[b + 996 >> 2] | 0, ei = t[b + 752 >> 2], K = t[b + 992 >> 2], Me = ei + K | 0, ai = Me, t[b + 1464 >> 2] = Me, K = K >>> 0 > Me >>> 0 ? n + 1 | 0 : n, ui = K & 1048575, t[b + 1468 >> 2] = ui, Xi = b + 976 | 0, Pr(Xi, Ii, di, 0, 0, Ti, Wi, 0, 0), Li = b + 720 | 0, Pr(Li, gr, Es, 0, 0, co, Dn, 0, 0), Ki = b + 848 | 0, Pr(Ki, es, zn, 0, 0, es, zn, 0, 0), bo = b + 704 | 0, tr = (a | 0) == (Ce | 0) & pe >>> 0 > tr >>> 0 | a >>> 0 < Ce >>> 0, pe = (Ce | 0) == (or | 0) & pe >>> 0 < Nr >>> 0 | Ce >>> 0 < or >>> 0, n = kn + 8 | 0, or = t[n >> 2], Nr = $i + 8 | 0, Ce = or + t[Nr >> 2] | 0, n = t[Nr + 4 >> 2] + t[n + 4 >> 2] | 0, n = Ce >>> 0 < or >>> 0 ? n + 1 | 0 : n, or = Ce, Ce = pe + Ce | 0, n = or >>> 0 > Ce >>> 0 ? n + 1 | 0 : n, P = P >>> 20 | 0, pe = P, P = P + Ce | 0, n = pe >>> 0 > P >>> 0 ? n + 1 | 0 : n, Ce = P, P = P + tr | 0, Ce = Ce >>> 0 > P >>> 0 ? n + 1 | 0 : n, pe = Ce << 12 | P >>> 20, a = P << 12 | a >>> 20, P = pe, kn = t[b + 720 >> 2], pe = t[b + 848 >> 2], Nr = kn + pe | 0, $i = t[b + 724 >> 2], n = $i + t[b + 852 >> 2] | 0, pe = pe >>> 0 > Nr >>> 0 ? n + 1 | 0 : n, n = pe + P | 0, a = a + Nr | 0, n = a >>> 0 < Nr >>> 0 ? n + 1 | 0 : n, wi = a, P = n, Pr(bo, a, n & 1048575, 0, 0, 15632, 16, 0, 0), Me = (K | 0) == (kr | 0) & Me >>> 0 < ei >>> 0 | K >>> 0 < kr >>> 0, n = Mn + 8 | 0, tr = t[n >> 2], or = Qi + 8 | 0, a = tr + t[or >> 2] | 0, n = t[or + 4 >> 2] + t[n + 4 >> 2] | 0, n = a >>> 0 < tr >>> 0 ? n + 1 | 0 : n, tr = a, a = a + Me | 0, Me = tr >>> 0 > a >>> 0 ? n + 1 | 0 : n, tr = Me << 12 | a >>> 20, K = a << 12 | K >>> 20, n = tr, Qi = t[b + 704 >> 2], tr = t[b + 976 >> 2], ei = Qi + tr | 0, Mn = t[b + 708 >> 2], a = Mn + t[b + 980 >> 2] | 0, tr = tr >>> 0 > ei >>> 0 ? a + 1 | 0 : a, n = tr + n | 0, a = K + ei | 0, n = a >>> 0 < ei >>> 0 ? n + 1 | 0 : n, or = a, t[b + 1472 >> 2] = a, K = n, kr = n & 1048575, t[b + 1476 >> 2] = kr, xs = b + 912 | 0, Pr(xs, Ii, di, 0, 0, co, Dn, 0, 0), co = b + 960 | 0, Pr(co, Ti, Wi, 0, 0, Ti, Wi, 0, 0), Wi = b + 656 | 0, Pr(Wi, gr, Es, 0, 0, es, zn, 0, 0), Es = b + 640 | 0, gr = Es, di = (P | 0) == (pe | 0) & Nr >>> 0 > wi >>> 0 | P >>> 0 < pe >>> 0, pe = (pe | 0) == ($i | 0) & Nr >>> 0 < kn >>> 0 | pe >>> 0 < $i >>> 0, n = Ki + 8 | 0, Nr = t[n >> 2], Ii = Li + 8 | 0, a = Nr + t[Ii >> 2] | 0, n = t[Ii + 4 >> 2] + t[n + 4 >> 2] | 0, n = a >>> 0 < Nr >>> 0 ? n + 1 | 0 : n, Nr = a, a = a + pe | 0, n = Nr >>> 0 > a >>> 0 ? n + 1 | 0 : n, pe = a, Ce = Ce >>> 20 | 0, a = Ce, Ce = pe + Ce | 0, n = a >>> 0 > Ce >>> 0 ? n + 1 | 0 : n, a = Ce + di | 0, Ce = a >>> 0 < Ce >>> 0 ? n + 1 | 0 : n, n = Ce << 12 | a >>> 20, Dn = a << 12 | P >>> 20, pe = t[b + 656 >> 2], P = Dn + pe | 0, Ii = n, n = n + t[b + 660 >> 2] | 0, di = P, Nr = P >>> 0 < pe >>> 0 ? n + 1 | 0 : n, Pr(gr, P, Nr, 0, 0, 15632, 16, 0, 0), gr = (K | 0) == (tr | 0) & or >>> 0 < ei >>> 0 | K >>> 0 < tr >>> 0, P = (tr | 0) == (Mn | 0) & ei >>> 0 < Qi >>> 0 | tr >>> 0 < Mn >>> 0, n = Xi + 8 | 0, pe = t[n >> 2], tr = bo + 8 | 0, a = pe + t[tr >> 2] | 0, n = t[tr + 4 >> 2] + t[n + 4 >> 2] | 0, n = a >>> 0 < pe >>> 0 ? n + 1 | 0 : n, pe = a, a = a + P | 0, n = pe >>> 0 > a >>> 0 ? n + 1 | 0 : n, P = a, pe = Me >>> 20 | 0, P = P + pe | 0, n = pe >>> 0 > P >>> 0 ? n + 1 | 0 : n, a = P + gr | 0, P = a >>> 0 < P >>> 0 ? n + 1 | 0 : n, n = P << 12 | a >>> 20, K = a << 12 | K >>> 20, Me = n, wi = t[b + 912 >> 2], pe = t[b + 960 >> 2], a = wi + pe | 0, Ti = t[b + 916 >> 2], n = Ti + t[b + 964 >> 2] | 0, n = a >>> 0 < pe >>> 0 ? n + 1 | 0 : n, ei = a, a = t[b + 640 >> 2], gr = ei + a | 0, tr = n, n = n + t[b + 644 >> 2] | 0, a = a >>> 0 > gr >>> 0 ? n + 1 | 0 : n, n = a + Me | 0, pe = K + gr | 0, n = pe >>> 0 < gr >>> 0 ? n + 1 | 0 : n, t[b + 1480 >> 2] = pe, K = n, Me = n & 1048575, t[b + 1484 >> 2] = Me, es = b + 576 | 0, Nr = (Nr | 0) == (Ii | 0) & di >>> 0 < Dn >>> 0 | Nr >>> 0 < Ii >>> 0, n = Wi + 8 | 0, di = t[n >> 2], n = t[n + 4 >> 2], Ce = Ce >>> 20 | 0, Ii = Ce, Ce = Ce + di | 0, n = Ii >>> 0 > Ce >>> 0 ? n + 1 | 0 : n, di = Ce, Ce = Ce + Nr | 0, n = di >>> 0 > Ce >>> 0 ? n + 1 | 0 : n, Pr(es, Ce, n, 0, 0, 64028672, 65536, 0, 0), Nr = (a | 0) == (K | 0) & pe >>> 0 < gr >>> 0 | a >>> 0 > K >>> 0, gr = (a | 0) == (tr | 0) & gr >>> 0 < ei >>> 0 | a >>> 0 < tr >>> 0, n = Es + 8 | 0, di = t[n >> 2], Ii = t[n + 4 >> 2], tr = (tr | 0) == (Ti | 0) & ei >>> 0 < wi >>> 0 | tr >>> 0 < Ti >>> 0, n = co + 8 | 0, a = t[n >> 2], ei = xs + 8 | 0, Ce = a + t[ei >> 2] | 0, n = t[ei + 4 >> 2] + t[n + 4 >> 2] | 0, a = a >>> 0 > Ce >>> 0 ? n + 1 | 0 : n, n = Ce, Ce = Ce + tr | 0, n = (n >>> 0 > Ce >>> 0 ? a + 1 | 0 : a) + Ii | 0, a = Ce + di | 0, n = a >>> 0 < Ce >>> 0 ? n + 1 | 0 : n, Ce = a, a = a + gr | 0, n = Ce >>> 0 > a >>> 0 ? n + 1 | 0 : n, P = P >>> 20 | 0, a = P + a | 0, n = P >>> 0 > a >>> 0 ? n + 1 | 0 : n, P = a, a = a + Nr | 0, P = P >>> 0 > a >>> 0 ? n + 1 | 0 : n, n = a, a = P << 12 | n >>> 20, K = n << 12 | K >>> 20, Ce = a, Nr = t[b + 576 >> 2], gr = Nr + (ns & -2) | 0, ei = t[b + 580 >> 2], n = ei + (ps & 1048575) | 0, a = gr >>> 0 < Nr >>> 0 ? n + 1 | 0 : n, n = a + Ce | 0, K = K + gr | 0, n = K >>> 0 < gr >>> 0 ? n + 1 | 0 : n, t[b + 1488 >> 2] = K, Ce = n, tr = n & 1048575, t[b + 1492 >> 2] = tr, di = In & 65535, Ii = (n | 0) == (a | 0) & K >>> 0 < gr >>> 0 | n >>> 0 < a >>> 0, gr = (a | 0) == (ei | 0) & gr >>> 0 < Nr >>> 0 | a >>> 0 < ei >>> 0, a = es + 8 | 0, n = gr + t[a >> 2] | 0, a = t[a + 4 >> 2], a = n >>> 0 < gr >>> 0 ? a + 1 | 0 : a, gr = n, n = a, P = P >>> 20 | 0, a = P + gr | 0, n = P >>> 0 > a >>> 0 ? n + 1 | 0 : n, P = a, a = a + Ii | 0, n = di + ((P >>> 0 > a >>> 0 ? n + 1 | 0 : n) << 12 | a >>> 20) | 0, a = a << 12 | Ce >>> 20, P = a + nr | 0, t[b + 1496 >> 2] = P, a = a >>> 0 > P >>> 0 ? n + 1 | 0 : n, t[b + 1500 >> 2] = a, n = t[b + 1544 >> 2], Ce = -5862 - n | 0, n = 6291449 - (t[b + 1548 >> 2] + (n >>> 0 > 4294961434) | 0) | 0, t[b + 1424 >> 2] = Ce, t[b + 1428 >> 2] = n, n = t[Xn >> 2], Ce = -6 - n | 0, n = 6291455 - (t[Xn + 4 >> 2] + (n >>> 0 > 4294967290) | 0) | 0, t[b + 1432 >> 2] = Ce, t[b + 1436 >> 2] = n, n = t[ls >> 2], Ce = -6 - n | 0, n = 6291455 - (t[ls + 4 >> 2] + (n >>> 0 > 4294967290) | 0) | 0, t[b + 1440 >> 2] = Ce, t[b + 1444 >> 2] = n, n = t[Yn >> 2], Ce = -6 - n | 0, n = 6291455 - (t[Yn + 4 >> 2] + (n >>> 0 > 4294967290) | 0) | 0, t[b + 1448 >> 2] = Ce, t[b + 1452 >> 2] = n, n = t[mo >> 2], Ce = -6 - n | 0, n = 393215 - (t[mo + 4 >> 2] + (n >>> 0 > 4294967290) | 0) | 0, t[b + 1456 >> 2] = Ce, t[b + 1460 >> 2] = n, gr = ui, n = gr << 1 | ai >>> 31, co = b + 528 | 0, Ce = tr, ui = ai << 1, tr = n, Pr(co, K, Ce, 0, 0, ui, n, 0, 0), Wi = b + 592 | 0, nr = pe, pe = Me, di = or << 1, ei = kr, Nr = kr << 1 | or >>> 31, Pr(Wi, nr, pe, 0, 0, di, Nr, 0, 0), Ii = b + 496 | 0, Pr(Ii, P, a, 0, 0, P, a, 0, 0), Dn = b + 480 | 0, Pr(Dn, t[b + 496 >> 2], t[b + 500 >> 2], 0, 0, 15632, 16, 0, 0), ns = b + 448 | 0, Me = P << 1, kr = a << 1 | P >>> 31, Pr(ns, Me, kr, 0, 0, ai, gr, 0, 0), ps = b + 544 | 0, Pr(ps, K, Ce, 0, 0, di, Nr, 0, 0), In = b + 608 | 0, Pr(In, nr, pe, 0, 0, nr, pe, 0, 0), wi = b + 464 | 0, n = Ii + 8 | 0, Pr(wi, t[n >> 2], t[n + 4 >> 2], 0, 0, 64028672, 65536, 0, 0), es = b + 736 | 0, Pr(es, ai, gr, 0, 0, ai, gr, 0, 0), zn = b + 432 | 0, Pr(zn, Me, kr, 0, 0, or, ei, 0, 0), $i = b + 512 | 0, di = K, Ii = Ce, Ti = pe, ai = nr, Pr($i, K, Ce, 0, 0, nr << 1, pe << 1 | nr >>> 31, 0, 0), nr = t[b + 528 >> 2], K = t[b + 592 >> 2], a = nr + K | 0, Ce = t[b + 532 >> 2], n = Ce + t[b + 596 >> 2] | 0, n = a >>> 0 < K >>> 0 ? n + 1 | 0 : n, P = a, pe = t[b + 480 >> 2], K = a + pe | 0, a = n + t[b + 484 >> 2] | 0, Es = K, K = K >>> 0 < pe >>> 0 ? a + 1 | 0 : a, pe = (n | 0) == (K | 0) & P >>> 0 > Es >>> 0 | n >>> 0 > K >>> 0, a = Dn + 8 | 0, gr = t[a >> 2], Nr = t[a + 4 >> 2], P = (n | 0) == (Ce | 0) & P >>> 0 < nr >>> 0 | n >>> 0 < Ce >>> 0, n = Wi + 8 | 0, Ce = t[n >> 2], nr = co + 8 | 0, a = Ce + t[nr >> 2] | 0, n = t[nr + 4 >> 2] + t[n + 4 >> 2] | 0, n = a >>> 0 < Ce >>> 0 ? n + 1 | 0 : n, P = a + P | 0, a = (P >>> 0 < a >>> 0 ? n + 1 | 0 : n) + Nr | 0, n = P, P = P + gr | 0, n = n >>> 0 > P >>> 0 ? a + 1 | 0 : a, a = P + pe | 0, P = a >>> 0 < P >>> 0 ? n + 1 | 0 : n, n = P << 12 | a >>> 20, co = K, Wi = a << 12 | K >>> 20, Mn = n, kn = t[b + 544 >> 2], K = t[b + 608 >> 2], a = kn + K | 0, Dn = t[b + 548 >> 2], n = Dn + t[b + 612 >> 2] | 0, n = a >>> 0 < K >>> 0 ? n + 1 | 0 : n, pe = a, a = t[b + 448 >> 2], K = pe + a | 0, nr = n, n = n + t[b + 452 >> 2] | 0, n = a >>> 0 > K >>> 0 ? n + 1 | 0 : n, gr = K, Ce = t[b + 464 >> 2], K = K + Ce | 0, a = n, n = n + t[b + 468 >> 2] | 0, Ce = K >>> 0 < Ce >>> 0 ? n + 1 | 0 : n, n = Ce + Mn | 0, Mn = b + 416 | 0, Nr = K, Wi = K + Wi | 0, K = K >>> 0 > Wi >>> 0 ? n + 1 | 0 : n, n = Ce, Ce = Wi, Wi = (K | 0) == (n | 0) & Nr >>> 0 > Ce >>> 0 | n >>> 0 > K >>> 0, Nr = (n | 0) == (a | 0) & gr >>> 0 > Nr >>> 0 | n >>> 0 < a >>> 0, n = wi + 8 | 0, wi = t[n >> 2], Qi = t[n + 4 >> 2], gr = (a | 0) == (nr | 0) & pe >>> 0 > gr >>> 0 | a >>> 0 < nr >>> 0, n = ns + 8 | 0, ns = t[n >> 2], Xi = t[n + 4 >> 2], pe = (nr | 0) == (Dn | 0) & pe >>> 0 < kn >>> 0 | nr >>> 0 < Dn >>> 0, n = In + 8 | 0, a = t[n >> 2], Dn = ps + 8 | 0, nr = a + t[Dn >> 2] | 0, n = t[Dn + 4 >> 2] + t[n + 4 >> 2] | 0, a = a >>> 0 > nr >>> 0 ? n + 1 | 0 : n, n = nr, nr = pe + nr | 0, n = (n >>> 0 > nr >>> 0 ? a + 1 | 0 : a) + Xi | 0, a = nr + ns | 0, n = a >>> 0 < nr >>> 0 ? n + 1 | 0 : n, pe = a, a = a + gr | 0, n = (pe >>> 0 > a >>> 0 ? n + 1 | 0 : n) + Qi | 0, pe = a, a = a + wi | 0, n = pe >>> 0 > a >>> 0 ? n + 1 | 0 : n, pe = a, a = a + Nr | 0, n = pe >>> 0 > a >>> 0 ? n + 1 | 0 : n, nr = a, P = P >>> 20 | 0, a = P, P = P + nr | 0, n = a >>> 0 > P >>> 0 ? n + 1 | 0 : n, a = P + Wi | 0, P = a >>> 0 < P >>> 0 ? n + 1 | 0 : n, n = P << 12 | a >>> 20, nr = K, K = a << 12 | K >>> 20, Wi = n, Dn = t[b + 432 >> 2], a = t[b + 512 >> 2], pe = Dn + a | 0, Nr = t[b + 436 >> 2], n = Nr + t[b + 516 >> 2] | 0, a = a >>> 0 > pe >>> 0 ? n + 1 | 0 : n, n = a + Wi | 0, gr = K + pe | 0, n = gr >>> 0 < pe >>> 0 ? n + 1 | 0 : n, ns = gr << 4 & -16, Wi = nr, K = n, Pr(Mn, ns | nr >>> 16 & 15, (n << 4 | gr >>> 28) & 16777215, 0, 0, 977, 1, 0, 0), kn = b + 672 | 0, Pr(kn, or, ei, 0, 0, ui, tr, 0, 0), ns = b + 400 | 0, Pr(ns, Me, kr, 0, 0, ai, Ti, 0, 0), ps = b + 560 | 0, Pr(ps, di, Ii, 0, 0, di, Ii, 0, 0), bo = b + 384 | 0, In = bo, gr = (a | 0) == (n | 0) & pe >>> 0 > gr >>> 0 | a >>> 0 > n >>> 0, pe = (a | 0) == (Nr | 0) & pe >>> 0 < Dn >>> 0 | a >>> 0 < Nr >>> 0, n = $i + 8 | 0, a = t[n >> 2], Nr = zn + 8 | 0, nr = a + t[Nr >> 2] | 0, n = t[Nr + 4 >> 2] + t[n + 4 >> 2] | 0, a = a >>> 0 > nr >>> 0 ? n + 1 | 0 : n, n = pe + nr | 0, a = n >>> 0 < nr >>> 0 ? a + 1 | 0 : a, nr = n, n = a, P = P >>> 20 | 0, a = P + nr | 0, n = P >>> 0 > a >>> 0 ? n + 1 | 0 : n, P = a, a = a + gr | 0, P = P >>> 0 > a >>> 0 ? n + 1 | 0 : n, nr = P << 12 | a >>> 20, K = a << 12 | K >>> 20, pe = nr, Nr = t[b + 400 >> 2], nr = t[b + 560 >> 2], a = Nr + nr | 0, gr = t[b + 404 >> 2], n = gr + t[b + 564 >> 2] | 0, n = a >>> 0 < nr >>> 0 ? n + 1 | 0 : n, nr = a, a = n + pe | 0, K = K + nr | 0, a = K >>> 0 < nr >>> 0 ? a + 1 | 0 : a, pe = K, K = a, Pr(In, pe, a & 1048575, 0, 0, 15632, 16, 0, 0), zn = b + 624 | 0, Pr(zn, ai, Ti, 0, 0, ui, tr, 0, 0), $i = b + 688 | 0, Pr($i, or, ei, 0, 0, or, ei, 0, 0), tr = b + 368 | 0, Pr(tr, Me, kr, 0, 0, di, Ii, 0, 0), xs = b + 352 | 0, Me = xs, pe = (n | 0) == (a | 0) & pe >>> 0 < nr >>> 0 | n >>> 0 > a >>> 0, nr = (n | 0) == (gr | 0) & nr >>> 0 < Nr >>> 0 | n >>> 0 < gr >>> 0, n = ps + 8 | 0, or = t[n >> 2], kr = ns + 8 | 0, a = or + t[kr >> 2] | 0, n = t[kr + 4 >> 2] + t[n + 4 >> 2] | 0, n = a >>> 0 < or >>> 0 ? n + 1 | 0 : n, or = a, a = a + nr | 0, n = or >>> 0 > a >>> 0 ? n + 1 | 0 : n, nr = a, P = P >>> 20 | 0, a = P, P = P + nr | 0, n = a >>> 0 > P >>> 0 ? n + 1 | 0 : n, a = P + pe | 0, P = a >>> 0 < P >>> 0 ? n + 1 | 0 : n, n = P << 12 | a >>> 20, nr = a << 12 | K >>> 20, pe = t[b + 368 >> 2], K = nr + pe | 0, a = n, n = n + t[b + 372 >> 2] | 0, n = K >>> 0 < pe >>> 0 ? n + 1 | 0 : n, Pr(Me, K, n, 0, 0, 15632, 16, 0, 0), vs = b + 336 | 0, pe = vs, nr = (n | 0) == (a | 0) & K >>> 0 < nr >>> 0 | n >>> 0 < a >>> 0, n = tr + 8 | 0, Me = t[n >> 2], n = t[n + 4 >> 2], K = P >>> 20 | 0, a = K + Me | 0, n = K >>> 0 > a >>> 0 ? n + 1 | 0 : n, P = a, a = a + nr | 0, n = P >>> 0 > a >>> 0 ? n + 1 | 0 : n, Pr(pe, a, n, 0, 0, 64028672, 65536, 0, 0), n = b + 1424 | 0, zr(n, n, b + 1464 | 0), n = t[b + 1348 >> 2], gr = n, Nr = t[b + 1344 >> 2], P = Nr, n = n << 1 | P >>> 31, ei = b - -64 | 0, a = t[b + 1368 >> 2], K = t[b + 1372 >> 2], kr = P << 1, or = n, Pr(ei, a, K, 0, 0, kr, n, 0, 0), n = t[b + 1356 >> 2], ps = n, In = t[b + 1352 >> 2], pe = In, n = n << 1 | pe >>> 31, ns = b + 272 | 0, P = t[b + 1360 >> 2], nr = t[b + 1364 >> 2], ui = pe << 1, Me = n, Pr(ns, P, nr, 0, 0, ui, n, 0, 0), di = b + 224 | 0, n = t[b + 1376 >> 2], pe = t[b + 1380 >> 2], Pr(di, n, pe, 0, 0, n, pe, 0, 0), wi = b + 208 | 0, Pr(wi, t[b + 224 >> 2], t[b + 228 >> 2], 0, 0, 15632, 16, 0, 0), tr = pe << 1, pe = n, n = tr | n >>> 31, Qi = b + 176 | 0, tr = pe << 1, ai = n, Pr(Qi, tr, n, 0, 0, Nr, gr, 0, 0), Xi = b + 80 | 0, Pr(Xi, a, K, 0, 0, ui, Me, 0, 0), Li = b + 256 | 0, Pr(Li, P, nr, 0, 0, P, nr, 0, 0), Ki = b + 192 | 0, n = di + 8 | 0, Pr(Ki, t[n >> 2], t[n + 4 >> 2], 0, 0, 64028672, 65536, 0, 0), eo = b + 320 | 0, Pr(eo, Nr, gr, 0, 0, Nr, gr, 0, 0), fs = b + 160 | 0, Pr(fs, tr, ai, 0, 0, In, ps, 0, 0), Ss = b + 96 | 0, di = a, Ii = K, Ti = nr, ui = P, Pr(Ss, a, K, 0, 0, P << 1, nr << 1 | P >>> 31, 0, 0), Me = t[b + 64 >> 2], K = t[b + 272 >> 2], a = Me + K | 0, pe = t[b + 68 >> 2], n = pe + t[b + 276 >> 2] | 0, n = a >>> 0 < K >>> 0 ? n + 1 | 0 : n, P = a, a = t[b + 208 >> 2], nr = P + a | 0, K = n, n = n + t[b + 212 >> 2] | 0, a = a >>> 0 > nr >>> 0 ? n + 1 | 0 : n, Dn = nr, nr = (K | 0) == (a | 0) & nr >>> 0 < P >>> 0 | a >>> 0 < K >>> 0, n = wi + 8 | 0, gr = t[n >> 2], Nr = t[n + 4 >> 2], P = (K | 0) == (pe | 0) & P >>> 0 < Me >>> 0 | K >>> 0 < pe >>> 0, n = ns + 8 | 0, pe = t[n >> 2], Me = ei + 8 | 0, K = pe + t[Me >> 2] | 0, n = t[Me + 4 >> 2] + t[n + 4 >> 2] | 0, n = K >>> 0 < pe >>> 0 ? n + 1 | 0 : n, pe = K, K = P + K | 0, n = (pe >>> 0 > K >>> 0 ? n + 1 | 0 : n) + Nr | 0, P = K, K = K + gr | 0, n = P >>> 0 > K >>> 0 ? n + 1 | 0 : n, P = K, K = K + nr | 0, P = P >>> 0 > K >>> 0 ? n + 1 | 0 : n, nr = P << 12 | K >>> 20, ns = a, K = K << 12 | a >>> 20, fo = t[b + 80 >> 2], pe = t[b + 256 >> 2], a = fo + pe | 0, wi = t[b + 84 >> 2], n = wi + t[b + 260 >> 2] | 0, n = a >>> 0 < pe >>> 0 ? n + 1 | 0 : n, gr = a, Me = t[b + 176 >> 2], a = a + Me | 0, pe = n, n = n + t[b + 180 >> 2] | 0, n = a >>> 0 < Me >>> 0 ? n + 1 | 0 : n, Nr = a, ei = t[b + 192 >> 2], a = a + ei | 0, Me = n, n = n + t[b + 196 >> 2] | 0, n = a >>> 0 < ei >>> 0 ? n + 1 | 0 : n, ei = a, a = n, n = n + nr | 0, nr = K + ei | 0, K = nr >>> 0 < ei >>> 0 ? n + 1 | 0 : n, Bs = (a | 0) == (K | 0) & nr >>> 0 < ei >>> 0 | a >>> 0 > K >>> 0, ei = (a | 0) == (Me | 0) & Nr >>> 0 > ei >>> 0 | a >>> 0 < Me >>> 0, n = Ki + 8 | 0, Ki = t[n >> 2], ao = t[n + 4 >> 2], Me = (pe | 0) == (Me | 0) & gr >>> 0 > Nr >>> 0 | pe >>> 0 > Me >>> 0, n = Qi + 8 | 0, Nr = t[n >> 2], Qi = t[n + 4 >> 2], pe = (pe | 0) == (wi | 0) & gr >>> 0 < fo >>> 0 | pe >>> 0 < wi >>> 0, n = Li + 8 | 0, gr = t[n >> 2], wi = Xi + 8 | 0, a = gr + t[wi >> 2] | 0, n = t[wi + 4 >> 2] + t[n + 4 >> 2] | 0, n = a >>> 0 < gr >>> 0 ? n + 1 | 0 : n, gr = a, a = a + pe | 0, n = (gr >>> 0 > a >>> 0 ? n + 1 | 0 : n) + Qi | 0, pe = a + Nr | 0, a = pe >>> 0 < a >>> 0 ? n + 1 | 0 : n, n = pe, pe = pe + Me | 0, n = (n >>> 0 > pe >>> 0 ? a + 1 | 0 : a) + ao | 0, a = pe + Ki | 0, n = a >>> 0 < pe >>> 0 ? n + 1 | 0 : n, pe = a, a = a + ei | 0, n = pe >>> 0 > a >>> 0 ? n + 1 | 0 : n, P = P >>> 20 | 0, a = P + a | 0, n = P >>> 0 > a >>> 0 ? n + 1 | 0 : n, P = a, a = a + Bs | 0, P = P >>> 0 > a >>> 0 ? n + 1 | 0 : n, n = a, Me = P << 12 | n >>> 20, a = K, gr = n << 12 | a >>> 20, wi = t[b + 160 >> 2], pe = t[b + 96 >> 2], K = wi + pe | 0, ei = t[b + 164 >> 2], n = ei + t[b + 100 >> 2] | 0, pe = K >>> 0 < pe >>> 0 ? n + 1 | 0 : n, n = pe + Me | 0, Me = K, gr = K + gr | 0, n = K >>> 0 > gr >>> 0 ? n + 1 | 0 : n, Qi = gr << 4 & -16, Nr = a, K = n, Pr(b, Qi | a >>> 16 & 15, (n << 4 | gr >>> 28) & 16777215, 0, 0, 977, 1, 0, 0), Li = b + 304 | 0, Pr(Li, In, ps, 0, 0, kr, or, 0, 0), Qi = b + 144 | 0, Pr(Qi, tr, ai, 0, 0, ui, Ti, 0, 0), Xi = b + 112 | 0, Pr(Xi, di, Ii, 0, 0, di, Ii, 0, 0), Ki = b + 48 | 0, gr = (n | 0) == (pe | 0) & Me >>> 0 > gr >>> 0 | n >>> 0 < pe >>> 0, Me = (pe | 0) == (ei | 0) & Me >>> 0 < wi >>> 0 | pe >>> 0 < ei >>> 0, n = Ss + 8 | 0, ei = t[n >> 2], a = fs + 8 | 0, pe = ei + t[a >> 2] | 0, a = t[a + 4 >> 2] + t[n + 4 >> 2] | 0, n = pe >>> 0 < ei >>> 0 ? a + 1 | 0 : a, a = pe + Me | 0, n = a >>> 0 < pe >>> 0 ? n + 1 | 0 : n, P = P >>> 20 | 0, a = a + P | 0, n = P >>> 0 > a >>> 0 ? n + 1 | 0 : n, P = a, a = a + gr | 0, P = P >>> 0 > a >>> 0 ? n + 1 | 0 : n, pe = P << 12 | a >>> 20, K = a << 12 | K >>> 20, n = pe, ei = t[b + 144 >> 2], Me = t[b + 112 >> 2], pe = ei + Me | 0, gr = t[b + 148 >> 2], a = gr + t[b + 116 >> 2] | 0, a = pe >>> 0 < Me >>> 0 ? a + 1 | 0 : a, n = a + n | 0, K = K + pe | 0, n = K >>> 0 < pe >>> 0 ? n + 1 | 0 : n, Me = K, K = n, Pr(Ki, Me, n & 1048575, 0, 0, 15632, 16, 0, 0), wi = b + 240 | 0, Pr(wi, ui, Ti, 0, 0, kr, or, 0, 0), fs = b + 288 | 0, Pr(fs, In, ps, 0, 0, In, ps, 0, 0), or = b + 128 | 0, Pr(or, tr, ai, 0, 0, di, Ii, 0, 0), In = b + 32 | 0, tr = In, Me = (n | 0) == (a | 0) & pe >>> 0 > Me >>> 0 | n >>> 0 < a >>> 0, pe = (a | 0) == (gr | 0) & pe >>> 0 < ei >>> 0 | a >>> 0 < gr >>> 0, n = Xi + 8 | 0, kr = t[n >> 2], ai = Qi + 8 | 0, a = kr + t[ai >> 2] | 0, n = t[ai + 4 >> 2] + t[n + 4 >> 2] | 0, n = a >>> 0 < kr >>> 0 ? n + 1 | 0 : n, gr = a, a = a + pe | 0, n = gr >>> 0 > a >>> 0 ? n + 1 | 0 : n, P = P >>> 20 | 0, pe = P, P = a + P | 0, a = pe >>> 0 > P >>> 0 ? n + 1 | 0 : n, n = P + Me | 0, a = n >>> 0 < P >>> 0 ? a + 1 | 0 : a, pe = a << 12 | n >>> 20, Me = n << 12 | K >>> 20, kr = t[b + 128 >> 2], K = Me + kr | 0, P = pe, n = P + t[b + 132 >> 2] | 0, n = K >>> 0 < kr >>> 0 ? n + 1 | 0 : n, Pr(tr, K, n, 0, 0, 15632, 16, 0, 0), Ss = b + 16 | 0, pe = Ss, P = (n | 0) == (P | 0) & K >>> 0 < Me >>> 0 | n >>> 0 < P >>> 0, n = or + 8 | 0, K = t[n >> 2], n = t[n + 4 >> 2], a = a >>> 20 | 0, K = a + K | 0, a = a >>> 0 > K >>> 0 ? n + 1 | 0 : n, n = P + K | 0, a = n >>> 0 < K >>> 0 ? a + 1 | 0 : a, Pr(pe, n, a, 0, 0, 64028672, 65536, 0, 0), zr(C + 80 | 0, ks, Ca), ks = t[l + 120 >> 2], K = C, C = t[b + 1424 >> 2], gr = C, n = t[b + 1428 >> 2], ei = n, P = C, pe = n, or = t[b >> 2], C = t[b + 320 >> 2], a = or + C | 0, tr = t[b + 4 >> 2], n = tr + t[b + 324 >> 2] | 0, C = C >>> 0 > a >>> 0 ? n + 1 | 0 : n, n = pe + (C & 1048575) | 0, P = a + P | 0, n = P >>> 0 < a >>> 0 ? n + 1 | 0 : n, t[K >> 2] = P, pe = n, t[K + 4 >> 2] = n, Qi = K + 8 | 0, di = Qi, n = t[b + 1432 >> 2], ai = n, Me = t[b + 1436 >> 2], ui = Me, Me = (C | 0) == (tr | 0) & a >>> 0 < or >>> 0 | C >>> 0 < tr >>> 0, n = eo + 8 | 0, tr = t[n >> 2], or = b + 8 | 0, a = tr + t[or >> 2] | 0, n = t[or + 4 >> 2] + t[n + 4 >> 2] | 0, n = a >>> 0 < tr >>> 0 ? n + 1 | 0 : n, tr = a, a = a + Me | 0, Me = tr >>> 0 > a >>> 0 ? n + 1 | 0 : n, tr = Me << 12 | a >>> 20, C = a << 12 | C >>> 20, a = tr, eo = t[b + 48 >> 2], tr = t[b + 304 >> 2], or = eo + tr | 0, Ti = t[b + 52 >> 2], n = Ti + t[b + 308 >> 2] | 0, tr = tr >>> 0 > or >>> 0 ? n + 1 | 0 : n, a = tr + a | 0, n = C + or | 0, C = n >>> 0 < or >>> 0 ? a + 1 | 0 : a, kr = n, a = ai + n | 0, n = ui + (C & 1048575) | 0, t[di >> 2] = a, n = a >>> 0 < kr >>> 0 ? n + 1 | 0 : n, t[di + 4 >> 2] = n, di = n << 1, n = a, a = di | n >>> 31, di = n << 1, n = a + ui | 0, a = ai + di | 0, n = a >>> 0 < di >>> 0 ? n + 1 | 0 : n, t[Xn >> 2] = a, t[Xn + 4 >> 2] = n, Xi = K + 16 | 0, n = t[b + 1440 >> 2], di = n, a = t[b + 1444 >> 2], Ii = a, kr = (C | 0) == (tr | 0) & or >>> 0 > kr >>> 0 | C >>> 0 < tr >>> 0, tr = (tr | 0) == (Ti | 0) & or >>> 0 < eo >>> 0 | tr >>> 0 < Ti >>> 0, n = Li + 8 | 0, or = t[n >> 2], ai = Ki + 8 | 0, a = or + t[ai >> 2] | 0, n = t[ai + 4 >> 2] + t[n + 4 >> 2] | 0, n = a >>> 0 < or >>> 0 ? n + 1 | 0 : n, or = a, a = a + tr | 0, n = or >>> 0 > a >>> 0 ? n + 1 | 0 : n, tr = a, Me = Me >>> 20 | 0, a = Me, Me = Me + tr | 0, n = a >>> 0 > Me >>> 0 ? n + 1 | 0 : n, a = Me + kr | 0, Me = a >>> 0 < Me >>> 0 ? n + 1 | 0 : n, n = Me << 12 | a >>> 20, or = a << 12 | C >>> 20, Li = n, Ki = t[b + 240 >> 2], a = t[b + 288 >> 2], C = Ki + a | 0, Ti = t[b + 244 >> 2], n = Ti + t[b + 292 >> 2] | 0, n = C >>> 0 < a >>> 0 ? n + 1 | 0 : n, kr = C, a = t[b + 32 >> 2], C = C + a | 0, tr = n, n = n + t[b + 36 >> 2] | 0, a = C >>> 0 < a >>> 0 ? n + 1 | 0 : n, n = a + Li | 0, ai = C, or = C + or | 0, C = C >>> 0 > or >>> 0 ? n + 1 | 0 : n, n = Ii + (C & 1048575) | 0, ui = or, or = di + or | 0, t[Xi >> 2] = or, n = or >>> 0 < ui >>> 0 ? n + 1 | 0 : n, t[Xi + 4 >> 2] = n, n = (n << 1 | or >>> 31) + Ii | 0, or = or << 1, Ii = or, or = or + di | 0, n = Ii >>> 0 > or >>> 0 ? n + 1 | 0 : n, t[ls >> 2] = or, t[ls + 4 >> 2] = n, Li = K + 24 | 0, n = t[b + 1448 >> 2], or = t[b + 1452 >> 2], di = n, Ii = or, or = (C | 0) == (a | 0) & ai >>> 0 > ui >>> 0 | C >>> 0 < a >>> 0, ai = (a | 0) == (tr | 0) & kr >>> 0 > ai >>> 0 | a >>> 0 < tr >>> 0, n = In + 8 | 0, ui = t[n >> 2], In = t[n + 4 >> 2], kr = (tr | 0) == (Ti | 0) & kr >>> 0 < Ki >>> 0 | tr >>> 0 < Ti >>> 0, n = fs + 8 | 0, a = t[n >> 2], Ti = wi + 8 | 0, tr = a + t[Ti >> 2] | 0, n = t[Ti + 4 >> 2] + t[n + 4 >> 2] | 0, a = a >>> 0 > tr >>> 0 ? n + 1 | 0 : n, n = tr, tr = tr + kr | 0, n = (n >>> 0 > tr >>> 0 ? a + 1 | 0 : a) + In | 0, a = tr + ui | 0, n = a >>> 0 < tr >>> 0 ? n + 1 | 0 : n, tr = a, a = a + ai | 0, n = tr >>> 0 > a >>> 0 ? n + 1 | 0 : n, Me = Me >>> 20 | 0, a = Me + a | 0, n = Me >>> 0 > a >>> 0 ? n + 1 | 0 : n, Me = a, a = a + or | 0, Me = Me >>> 0 > a >>> 0 ? n + 1 | 0 : n, n = a, a = Me << 12 | n >>> 20, kr = n << 12 | C >>> 20, In = t[b + 16 >> 2], tr = Dn & -2, C = In + tr | 0, Ti = t[b + 20 >> 2], n = Ti + (ns & 1048575) | 0, tr = C >>> 0 < tr >>> 0 ? n + 1 | 0 : n, n = tr + a | 0, or = C, kr = C + kr | 0, C = C >>> 0 > kr >>> 0 ? n + 1 | 0 : n, n = Ii + (C & 1048575) | 0, a = kr + di | 0, n = a >>> 0 < kr >>> 0 ? n + 1 | 0 : n, t[Li >> 2] = a, t[Li + 4 >> 2] = n, ai = a << 1, a = (n << 1 | a >>> 31) + Ii | 0, n = ai + di | 0, a = n >>> 0 < ai >>> 0 ? a + 1 | 0 : a, t[Yn >> 2] = n, t[Yn + 4 >> 2] = a, Ki = K + 32 | 0, Ii = Ki, n = t[b + 1456 >> 2], a = t[b + 1460 >> 2], ai = n, ui = a, di = nr, Nr = Nr & 65535, kr = (C | 0) == (tr | 0) & or >>> 0 > kr >>> 0 | C >>> 0 < tr >>> 0, nr = (tr | 0) == (Ti | 0) & or >>> 0 < In >>> 0 | tr >>> 0 < Ti >>> 0, n = Ss + 8 | 0, a = nr + t[n >> 2] | 0, n = t[n + 4 >> 2], n = a >>> 0 < nr >>> 0 ? n + 1 | 0 : n, Me = Me >>> 20 | 0, nr = a + Me | 0, a = Me >>> 0 > nr >>> 0 ? n + 1 | 0 : n, n = nr, nr = nr + kr | 0, n = (n >>> 0 > nr >>> 0 ? a + 1 | 0 : a) << 12 | nr >>> 20, a = nr << 12 | C >>> 20, C = a + di | 0, n = n + Nr | 0, n = (C >>> 0 < a >>> 0 ? n + 1 | 0 : n) + ui | 0, a = C, C = C + ai | 0, n = a >>> 0 > C >>> 0 ? n + 1 | 0 : n, t[Ii >> 2] = C, t[Ii + 4 >> 2] = n, n = (n << 1 | C >>> 31) + ui | 0, C = C << 1, a = C, C = C + ai | 0, n = a >>> 0 > C >>> 0 ? n + 1 | 0 : n, t[mo >> 2] = C, t[mo + 4 >> 2] = n, nr = b, n = (pe << 1 | P >>> 31) + ei | 0, C = P << 1, a = C, C = C + gr | 0, n = a >>> 0 > C >>> 0 ? n + 1 | 0 : n, t[b + 1544 >> 2] = C, t[b + 1548 >> 2] = n, C = es + 8 | 0, tr = t[C >> 2], Yi = t[C + 4 >> 2], C = Mn + 8 | 0, Ro = t[C >> 2], jo = t[C + 4 >> 2], C = t[b + 736 >> 2], n = t[b + 740 >> 2], or = t[b + 416 >> 2], P = t[b + 420 >> 2], a = kn + 8 | 0, Yo = t[a >> 2], Mo = t[a + 4 >> 2], a = bo + 8 | 0, kr = t[a >> 2], To = t[a + 4 >> 2], wi = t[b + 672 >> 2], cs = t[b + 676 >> 2], es = t[b + 384 >> 2], b = t[b + 388 >> 2], a = $i + 8 | 0, On = t[a >> 2], ws = t[a + 4 >> 2], a = zn + 8 | 0, eo = t[a >> 2], No = t[a + 4 >> 2], fs = t[nr + 688 >> 2], _s = t[nr + 692 >> 2], Ss = t[nr + 624 >> 2], bo = t[nr + 628 >> 2], a = xs + 8 | 0, ai = t[a >> 2], ui = t[a + 4 >> 2], fo = t[nr + 352 >> 2], Zo = t[nr + 356 >> 2], Bs = t[nr + 336 >> 2], xs = t[nr + 340 >> 2], a = vs + 8 | 0, ru = t[a >> 2], gr = t[a + 4 >> 2], zn = K + 104 | 0, Nr = t[zn >> 2], ei = t[zn + 4 >> 2], $i = K + 96 | 0, di = t[$i >> 2], Ii = t[$i + 4 >> 2], Mn = K + 88 | 0, Ti = t[Mn >> 2], Dn = t[Mn + 4 >> 2], kn = K + 112 | 0, ns = t[kn >> 2], pe = t[kn + 4 >> 2], ps = t[K + 80 >> 2], In = t[K + 84 >> 2], zr(En, En, nr + 1344 | 0), Me = t[nr + 1544 >> 2], vs = t[nr + 1548 >> 2], n = n + P | 0, a = C + or | 0, C = a >>> 0 < C >>> 0 ? n + 1 | 0 : n, ao = Me, n = a, Me = Di ? jr : n, jr = ao + Me | 0, a = vs + (Di ? Tt : C & 1048575) | 0, En = 8388599 - ((jr >>> 0 > 4294959480) + (Me >>> 0 > jr >>> 0 ? a + 1 | 0 : a) | 0) | 0, vs = -7816 - jr | 0, a = vs & 1, ao = 0 - a | 0, Me = 0 - a | 0, P = (C | 0) == (P | 0) & n >>> 0 < or >>> 0 | C >>> 0 < P >>> 0, n = Yi + jo | 0, Tt = tr + Ro | 0, a = Tt >>> 0 < tr >>> 0 ? n + 1 | 0 : n, n = P + Tt | 0, a = n >>> 0 < Tt >>> 0 ? a + 1 | 0 : a, P = a << 12 | n >>> 20, C = n << 12 | C >>> 20, jr = P, n = b + cs | 0, P = wi + es | 0, Tt = P >>> 0 < wi >>> 0 ? n + 1 | 0 : n, n = Tt + jr | 0, jr = C + P | 0, C = jr >>> 0 < P >>> 0 ? n + 1 | 0 : n, wi = jr, jr = (Tt | 0) == (C | 0) & jr >>> 0 < P >>> 0 | C >>> 0 < Tt >>> 0, P = (b | 0) == (Tt | 0) & P >>> 0 < es >>> 0 | b >>> 0 > Tt >>> 0, n = To + Mo | 0, Tt = kr + Yo | 0, n = Tt >>> 0 < kr >>> 0 ? n + 1 | 0 : n, tr = Tt, Tt = P + Tt | 0, n = tr >>> 0 > Tt >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, Tt = a + Tt | 0, a = a >>> 0 > Tt >>> 0 ? n + 1 | 0 : n, n = Tt + jr | 0, P = n >>> 0 < Tt >>> 0 ? a + 1 | 0 : a, Tt = P << 12 | n >>> 20, es = C, C = n << 12 | C >>> 20, n = bo + _s | 0, tr = fs + Ss | 0, a = tr >>> 0 < fs >>> 0 ? n + 1 | 0 : n, n = Zo + a | 0, b = tr + fo | 0, jr = b >>> 0 < fo >>> 0 ? n + 1 | 0 : n, n = jr + Tt | 0, or = C + b | 0, Tt = or >>> 0 < b >>> 0 ? n + 1 | 0 : n, C = Es & -2, kr = C + Bs | 0, n = xs + (co & 1048575) | 0, C = C >>> 0 > kr >>> 0 ? n + 1 | 0 : n, Es = (Tt | 0) == (jr | 0) & b >>> 0 > or >>> 0 | Tt >>> 0 < jr >>> 0, b = (a | 0) == (jr | 0) & b >>> 0 < tr >>> 0 | a >>> 0 > jr >>> 0, tr = (a | 0) == (bo | 0) & tr >>> 0 < Ss >>> 0 | a >>> 0 < bo >>> 0, a = ws + No | 0, jr = eo + On | 0, n = jr >>> 0 < eo >>> 0 ? a + 1 | 0 : a, a = tr + jr | 0, n = (a >>> 0 < jr >>> 0 ? n + 1 | 0 : n) + ui | 0, tr = a, a = a + ai | 0, n = tr >>> 0 > a >>> 0 ? n + 1 | 0 : n, tr = a, a = a + b | 0, n = tr >>> 0 > a >>> 0 ? n + 1 | 0 : n, P = P >>> 20 | 0, tr = P, P = a + P | 0, a = tr >>> 0 > P >>> 0 ? n + 1 | 0 : n, n = P + Es | 0, a = n >>> 0 < P >>> 0 ? a + 1 | 0 : a, P = n, n = C + (a << 12 | n >>> 20) | 0, tr = Tt, P = P << 12 | Tt >>> 20, Tt = P + kr | 0, jr = Tt, Tt = P >>> 0 > Tt >>> 0 ? n + 1 | 0 : n, ai = K + 72 | 0, P = Me, n = P >>> 16 | 0, b = (P & 65535) << 16 | ao >>> 16, Me = n, ui = t[mo >> 2], mo = t[mo + 4 >> 2], Es = Wi & 65535, co = (C | 0) == (Tt | 0) & kr >>> 0 > jr >>> 0 | C >>> 0 > Tt >>> 0, kr = (C | 0) == (xs | 0) & kr >>> 0 < Bs >>> 0 | C >>> 0 < xs >>> 0, C = ru + kr | 0, n = gr, n = C >>> 0 < kr >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, C = C + a | 0, a = a >>> 0 > C >>> 0 ? n + 1 | 0 : n, n = C, C = C + co | 0, a = (n >>> 0 > C >>> 0 ? a + 1 | 0 : a) << 12 | C >>> 20, kr = Tt, Tt = C << 12 | Tt >>> 20, C = Tt + Ce | 0, n = a + Es | 0, n = C >>> 0 < Tt >>> 0 ? n + 1 | 0 : n, a = Di ? Ps : C, C = a + ui | 0, n = mo + (Di ? no : n) | 0, n = (Me - ((C >>> 0 > b >>> 0) + (C >>> 0 < a >>> 0 ? n + 1 | 0 : n) | 0) | 0) + 524287 | 0, C = (b - C | 0) - 8 | 0, a = C >>> 0 < 4294967288 ? n + 1 | 0 : n, n = a >>> 1 | 0, b = (a & 1) << 31 | C >>> 1, t[ai >> 2] = b, Ce = n, t[ai + 4 >> 2] = n, ui = K - -64 | 0, Me = ui, Ps = C << 19 & 524288, Tt = (P & 4095) << 20 | ao >>> 12, C = P >>> 12 | 0, P = Di ? Xs : jr, a = P + t[Yn >> 2] | 0, n = t[Yn + 4 >> 2] + (Di ? lr : kr & 1048575) | 0, n = (C - ((a >>> 0 > Tt >>> 0) + (a >>> 0 < P >>> 0 ? n + 1 | 0 : n) | 0) | 0) + 8388607 | 0, P = (Tt - a | 0) - 8 | 0, lr = P >>> 0 < 4294967288 ? n + 1 | 0 : n, a = (lr >>> 1 | 0) + Ps | 0, jr = (lr & 1) << 31 | P >>> 1, n = jr, a = n >>> 0 > n >>> 0 ? a + 1 | 0 : a, t[Me >> 2] = n, Ps = a, t[Me + 4 >> 2] = a, kr = K + 56 | 0, Me = kr, gr = P << 19 & 524288, P = Di ? Io : or, a = P + t[ls >> 2] | 0, n = t[ls + 4 >> 2] + (Di ? Yr : tr & 1048575) | 0, n = (C - ((a >>> 0 > Tt >>> 0) + (a >>> 0 < P >>> 0 ? n + 1 | 0 : n) | 0) | 0) + 8388607 | 0, a = (Tt - a | 0) - 8 | 0, P = a >>> 0 < 4294967288 ? n + 1 | 0 : n, n = (P >>> 1 | 0) + gr | 0, lr = (P & 1) << 31 | a >>> 1, n = lr >>> 0 > lr >>> 0 ? n + 1 | 0 : n, t[Me >> 2] = lr, Yr = n, t[Me + 4 >> 2] = n, or = K + 48 | 0, tr = a << 19 & 524288, P = Tt, Me = C, n = Di ? Po : wi, C = n + t[Xn >> 2] | 0, a = t[Xn + 4 >> 2] + (Di ? Ei : es & 1048575) | 0, n = (Me - ((C >>> 0 > P >>> 0) + (C >>> 0 < n >>> 0 ? a + 1 | 0 : a) | 0) | 0) + 8388607 | 0, C = (P - C | 0) - 8 | 0, Tt = C >>> 0 < 4294967288 ? n + 1 | 0 : n, n = (Tt >>> 1 | 0) + tr | 0, Ei = (Tt & 1) << 31 | C >>> 1, a = Ei, n = a >>> 0 > a >>> 0 ? n + 1 | 0 : n, t[or >> 2] = a, tr = n, t[or + 4 >> 2] = n, Tt = C << 19 & 524288, n = (Me & 1048574) + En | 0, C = (P & -977) + vs | 0, n = C >>> 0 < vs >>> 0 ? n + 1 | 0 : n, C = (n & 1) << 31 | C >>> 1, n = (n >>> 1 | 0) + Tt | 0, Tt = C, n = C >>> 0 < C >>> 0 ? n + 1 | 0 : n, t[K + 40 >> 2] = C, t[K + 44 >> 2] = n, l = t[l + 120 >> 2], P = l >> 31, C = l - 1 | 0, gr = C, a = 0 - (((l | 0) != 0) + P | 0) | 0, Me = P - !l | 0, P = a & t[w + 4 >> 2] | Me & t[K + 4 >> 2], l = 0 - l | 0, t[K >> 2] = l & t[w >> 2] | C & t[K >> 2], t[K + 4 >> 2] = P, P = t[w + 12 >> 2] & a | t[Qi + 4 >> 2] & Me, t[Qi >> 2] = t[w + 8 >> 2] & l | t[Qi >> 2] & C, t[Qi + 4 >> 2] = P, P = t[w + 20 >> 2] & a | t[Xi + 4 >> 2] & Me, t[Xi >> 2] = t[w + 16 >> 2] & l | t[Xi >> 2] & C, t[Xi + 4 >> 2] = P, P = t[w + 28 >> 2] & a | t[Li + 4 >> 2] & Me, t[Li >> 2] = t[w + 24 >> 2] & l | t[Li >> 2] & C, t[Li + 4 >> 2] = P, P = t[w + 36 >> 2] & a | t[Ki + 4 >> 2] & Me, t[Ki >> 2] = t[w + 32 >> 2] & l | t[Ki >> 2] & C, t[Ki + 4 >> 2] = P, n = t[w + 44 >> 2] & a | n & Me, t[K + 40 >> 2] = t[w + 40 >> 2] & l | C & Tt, t[K + 44 >> 2] = n, n = w + 48 | 0, Tt = t[n >> 2], n = t[n + 4 >> 2] & a | Me & tr, t[or >> 2] = l & Tt | C & Ei, t[or + 4 >> 2] = n, n = w + 56 | 0, Tt = t[n >> 2], n = t[n + 4 >> 2] & a | Me & Yr, t[kr >> 2] = l & Tt | C & lr, t[kr + 4 >> 2] = n, n = w - -64 | 0, Tt = t[n >> 2], n = t[n + 4 >> 2] & a | Me & Ps, t[ui >> 2] = l & Tt | C & jr, t[ui + 4 >> 2] = n, w = w + 72 | 0, n = t[w >> 2], w = t[w + 4 >> 2] & a | Ce & Me, t[ai >> 2] = l & n | C & b, t[ai + 4 >> 2] = w, w = Me & t[K + 84 >> 2], t[K + 80 >> 2] = t[K + 80 >> 2] & C | l & 1, t[K + 84 >> 2] = w, l = t[Mn + 4 >> 2] & Me, t[Mn >> 2] = t[Mn >> 2] & C, t[Mn + 4 >> 2] = l, l = t[$i + 4 >> 2] & Me, t[$i >> 2] = t[$i >> 2] & C, t[$i + 4 >> 2] = l, l = t[zn + 4 >> 2] & Me, t[zn >> 2] = t[zn >> 2] & C, t[zn + 4 >> 2] = l, jr = t[kn >> 2], b = t[kn + 4 >> 2], Yr = K, tr = pe & 65535, l = ri(pe >>> 16 | 0, 0, 977, 1), C = l + ps | 0, n = In + ve | 0, l = C >>> 0 < l >>> 0 ? n + 1 | 0 : n, w = l >>> 20 | 0, n = Dn, a = w, w = w + Ti | 0, Tt = a >>> 0 > w >>> 0 ? n + 1 | 0 : n, n = Ii, a = Tt >>> 20 | 0, K = a + di | 0, P = a >>> 0 > K >>> 0 ? n + 1 | 0 : n, n = ei, a = P >>> 20 | 0, lr = a + Nr | 0, Ce = a >>> 0 > lr >>> 0 ? n + 1 | 0 : n, a = tr, Ei = Ce >>> 20 | 0, n = Ei + ns | 0, a = Ei >>> 0 > n >>> 0 ? a + 1 | 0 : a, n | (lr | (C | w | K)) | (a | (l | Tt | P | Ce) & 1048575) ? (w & (C ^ 976) & K & lr & n) == -1 ? C = (Tt & (l ^ 1) & P & Ce & (a ^ 983040)) == 1048575 : C = 0 : C = 1, t[Yr + 120 >> 2] = C & (ks ^ -1), t[kn >> 2] = gr & jr, t[kn + 4 >> 2] = b & Me, U = nr + 1744 | 0;
  }
  function Wn(C, l) {
    var w = 0, n = 0, a = 0, b = 0, P = 0, K = 0, pe = 0, Ce = 0, Me = 0, Tt = 0, tr = 0, nr = 0, or = 0, lr = 0, gr = 0, kr = 0, Nr = 0, jr = 0, Yr = 0, ei = 0, ai = 0, ui = 0, di = 0, Ii = 0, wi = 0, Ei = 0, Ti = 0, Di = 0, Qi = 0, Li = 0, Ki = 0, Wi = 0, Xi = 0, $i = 0, In = 0, kn = 0;
    a = U - 336 | 0, U = a, w = t[l + 4 >> 2], jr = w, lr = t[l >> 2], n = lr, w = w << 1 | n >>> 31, Me = a - -64 | 0, or = t[l + 24 >> 2], nr = t[l + 28 >> 2], Ii = n << 1, Di = w, Pr(Me, or, nr, 0, 0, Ii, w, 0, 0), w = t[l + 12 >> 2], $i = w, Qi = t[l + 8 >> 2], n = Qi, w = w << 1 | n >>> 31, pe = a + 272 | 0, Nr = t[l + 16 >> 2], tr = t[l + 20 >> 2], n = n << 1, b = w, Pr(pe, Nr, tr, 0, 0, n, w, 0, 0), K = a + 224 | 0, P = t[l + 32 >> 2], l = t[l + 36 >> 2], Pr(K, P, l, 0, 0, P, l, 0, 0), Ce = a + 208 | 0, Pr(Ce, t[a + 224 >> 2], t[a + 228 >> 2], 0, 0, 15632, 16, 0, 0), w = l << 1 | P >>> 31, Li = a + 176 | 0, ei = P << 1, Ki = w, Pr(Li, ei, w, 0, 0, lr, jr, 0, 0), Wi = a + 80 | 0, Pr(Wi, or, nr, 0, 0, n, b, 0, 0), Xi = a + 256 | 0, Pr(Xi, Nr, tr, 0, 0, Nr, tr, 0, 0), Tt = a + 192 | 0, l = K + 8 | 0, Pr(Tt, t[l >> 2], t[l + 4 >> 2], 0, 0, 64028672, 65536, 0, 0), kn = a + 320 | 0, Pr(kn, lr, jr, 0, 0, lr, jr, 0, 0), wi = a + 160 | 0, Pr(wi, ei, w, 0, 0, Qi, $i, 0, 0), Ei = a + 96 | 0, Pr(Ei, or, nr, 0, 0, Nr << 1, tr << 1 | Nr >>> 31, 0, 0), lr = t[a + 68 >> 2], w = lr + t[a + 276 >> 2] | 0, P = t[a + 64 >> 2], l = t[a + 272 >> 2], n = P + l | 0, b = t[a + 208 >> 2], In = n + b | 0, l = l >>> 0 > n >>> 0 ? w + 1 | 0 : w, w = l + t[a + 212 >> 2] | 0, b = b >>> 0 > In >>> 0 ? w + 1 | 0 : w, K = (l | 0) == (b | 0) & n >>> 0 > In >>> 0 | l >>> 0 > b >>> 0, w = Ce + 8 | 0, Ce = t[w >> 2], ui = t[w + 4 >> 2], P = (l | 0) == (lr | 0) & n >>> 0 < P >>> 0 | l >>> 0 < lr >>> 0, w = pe + 8 | 0, n = t[w >> 2], l = Me + 8 | 0, pe = n + t[l >> 2] | 0, w = t[l + 4 >> 2] + t[w + 4 >> 2] | 0, w = n >>> 0 > pe >>> 0 ? w + 1 | 0 : w, l = P + pe | 0, w = (l >>> 0 < pe >>> 0 ? w + 1 | 0 : w) + ui | 0, n = l, l = l + Ce | 0, w = n >>> 0 > l >>> 0 ? w + 1 | 0 : w, n = l, l = l + K | 0, w = n >>> 0 > l >>> 0 ? w + 1 | 0 : w, jr = b, ui = l << 12 | b >>> 20, n = w, P = w << 12 | l >>> 20, Yr = t[a + 80 >> 2], l = t[a + 256 >> 2], K = Yr + l | 0, Ti = t[a + 84 >> 2], w = Ti + t[a + 260 >> 2] | 0, w = l >>> 0 > K >>> 0 ? w + 1 | 0 : w, l = t[a + 176 >> 2], Ce = l + K | 0, Me = w, w = w + t[a + 180 >> 2] | 0, w = l >>> 0 > Ce >>> 0 ? w + 1 | 0 : w, l = t[a + 192 >> 2], b = l + Ce | 0, pe = w, w = w + t[a + 196 >> 2] | 0, l = l >>> 0 > b >>> 0 ? w + 1 | 0 : w, w = l + P | 0, ui = b + ui | 0, P = ui >>> 0 < b >>> 0 ? w + 1 | 0 : w, ai = (l | 0) == (P | 0) & b >>> 0 > ui >>> 0 | l >>> 0 > P >>> 0, di = (l | 0) == (pe | 0) & b >>> 0 < Ce >>> 0 | l >>> 0 < pe >>> 0, l = Tt + 8 | 0, kr = t[l >> 2], gr = t[l + 4 >> 2], lr = (pe | 0) == (Me | 0) & K >>> 0 > Ce >>> 0 | pe >>> 0 < Me >>> 0, l = Li + 8 | 0, Tt = t[l >> 2], pe = t[l + 4 >> 2], Ce = (Me | 0) == (Ti | 0) & K >>> 0 < Yr >>> 0 | Me >>> 0 < Ti >>> 0, w = Xi + 8 | 0, b = t[w >> 2], l = Wi + 8 | 0, K = b + t[l >> 2] | 0, w = t[l + 4 >> 2] + t[w + 4 >> 2] | 0, w = b >>> 0 > K >>> 0 ? w + 1 | 0 : w, l = K + Ce | 0, w = (l >>> 0 < K >>> 0 ? w + 1 | 0 : w) + pe | 0, b = l, l = l + Tt | 0, w = b >>> 0 > l >>> 0 ? w + 1 | 0 : w, b = l, l = l + lr | 0, w = (b >>> 0 > l >>> 0 ? w + 1 | 0 : w) + gr | 0, b = l, l = l + kr | 0, w = b >>> 0 > l >>> 0 ? w + 1 | 0 : w, b = l + di | 0, w = b >>> 0 < l >>> 0 ? w + 1 | 0 : w, n = n >>> 20 | 0, l = n + b | 0, w = n >>> 0 > l >>> 0 ? w + 1 | 0 : w, n = l, l = l + ai | 0, w = n >>> 0 > l >>> 0 ? w + 1 | 0 : w, n = P, K = l << 12 | n >>> 20, b = w, Ce = w << 12 | l >>> 20, kr = t[a + 160 >> 2], l = t[a + 96 >> 2], P = kr + l | 0, Yr = t[a + 164 >> 2], w = Yr + t[a + 100 >> 2] | 0, l = l >>> 0 > P >>> 0 ? w + 1 | 0 : w, w = l + Ce | 0, Tt = P, P = P + K | 0, K = P << 4 & -16, pe = P >>> 0 < Tt >>> 0 ? w + 1 | 0 : w, Ce = (pe << 4 | P >>> 28) & 16777215, lr = n, Pr(a, K | n >>> 16 & 15, Ce, 0, 0, 977, 1, 0, 0), ai = t[a + 4 >> 2], w = ai + t[a + 324 >> 2] | 0, Ce = C, di = t[a >> 2], C = t[a + 320 >> 2], Me = di + C | 0, t[Ce >> 2] = Me, K = C >>> 0 > Me >>> 0 ? w + 1 | 0 : w, t[Ce + 4 >> 2] = K & 1048575, Ti = a + 304 | 0, Pr(Ti, Qi, $i, 0, 0, Ii, Di, 0, 0), Li = a + 144 | 0, Pr(Li, ei, Ki, 0, 0, Nr, tr, 0, 0), Wi = a + 112 | 0, Pr(Wi, or, nr, 0, 0, or, nr, 0, 0), Xi = a + 48 | 0, gr = Xi, P = (l | 0) == (pe | 0) & P >>> 0 < Tt >>> 0 | l >>> 0 > pe >>> 0, n = (l | 0) == (Yr | 0) & Tt >>> 0 < kr >>> 0 | l >>> 0 < Yr >>> 0, w = Ei + 8 | 0, l = t[w >> 2], C = wi + 8 | 0, Tt = l + t[C >> 2] | 0, w = t[C + 4 >> 2] + t[w + 4 >> 2] | 0, w = l >>> 0 > Tt >>> 0 ? w + 1 | 0 : w, l = n + Tt | 0, w = l >>> 0 < Tt >>> 0 ? w + 1 | 0 : w, n = b >>> 20 | 0, C = l + n | 0, w = n >>> 0 > C >>> 0 ? w + 1 | 0 : w, l = C, C = C + P | 0, w = l >>> 0 > C >>> 0 ? w + 1 | 0 : w, pe = C << 12 | pe >>> 20, P = w, b = w << 12 | C >>> 20, wi = t[a + 148 >> 2], w = wi + t[a + 116 >> 2] | 0, Yr = t[a + 144 >> 2], l = t[a + 112 >> 2], C = Yr + l | 0, kr = C, Tt = C + pe | 0, n = C >>> 0 < l >>> 0 ? w + 1 | 0 : w, w = n + b | 0, pe = Tt >>> 0 < C >>> 0 ? w + 1 | 0 : w, Pr(gr, Tt, pe & 1048575, 0, 0, 15632, 16, 0, 0), b = (K | 0) == (ai | 0) & Me >>> 0 < di >>> 0 | K >>> 0 < ai >>> 0, w = kn + 8 | 0, l = t[w >> 2], C = a + 8 | 0, Me = l + t[C >> 2] | 0, w = t[C + 4 >> 2] + t[w + 4 >> 2] | 0, w = l >>> 0 > Me >>> 0 ? w + 1 | 0 : w, C = b + Me | 0, w = C >>> 0 < Me >>> 0 ? w + 1 | 0 : w, Me = C << 12 | K >>> 20, b = w, K = w << 12 | C >>> 20, ai = t[a + 48 >> 2], C = t[a + 304 >> 2], gr = ai + C | 0, Ei = t[a + 52 >> 2], w = Ei + t[a + 308 >> 2] | 0, l = C >>> 0 > gr >>> 0 ? w + 1 | 0 : w, w = l + K | 0, Me = Me + gr | 0, w = Me >>> 0 < gr >>> 0 ? w + 1 | 0 : w, t[Ce + 8 >> 2] = Me, K = w, t[Ce + 12 >> 2] = w & 1048575, di = a + 240 | 0, Pr(di, Nr, tr, 0, 0, Ii, Di, 0, 0), Di = a + 288 | 0, Pr(Di, Qi, $i, 0, 0, Qi, $i, 0, 0), Ii = a + 128 | 0, Pr(Ii, ei, Ki, 0, 0, or, nr, 0, 0), Ki = a + 32 | 0, nr = Ki, tr = (n | 0) == (pe | 0) & Tt >>> 0 < kr >>> 0 | n >>> 0 > pe >>> 0, Tt = (n | 0) == (wi | 0) & kr >>> 0 < Yr >>> 0 | n >>> 0 < wi >>> 0, w = Wi + 8 | 0, n = t[w >> 2], C = Li + 8 | 0, or = n + t[C >> 2] | 0, w = t[C + 4 >> 2] + t[w + 4 >> 2] | 0, w = n >>> 0 > or >>> 0 ? w + 1 | 0 : w, n = Tt + or | 0, w = n >>> 0 < or >>> 0 ? w + 1 | 0 : w, P = P >>> 20 | 0, C = n + P | 0, w = P >>> 0 > C >>> 0 ? w + 1 | 0 : w, n = C, C = C + tr | 0, w = n >>> 0 > C >>> 0 ? w + 1 | 0 : w, Nr = C << 12 | pe >>> 20, P = t[a + 128 >> 2], pe = Nr + P | 0, n = w, ei = w << 12 | C >>> 20, w = ei + t[a + 132 >> 2] | 0, Tt = P >>> 0 > pe >>> 0 ? w + 1 | 0 : w, Pr(nr, pe, Tt, 0, 0, 15632, 16, 0, 0), P = Ce, Me = (l | 0) == (K | 0) & Me >>> 0 < gr >>> 0 | l >>> 0 > K >>> 0, Ce = (l | 0) == (Ei | 0) & gr >>> 0 < ai >>> 0 | l >>> 0 < Ei >>> 0, w = Ti + 8 | 0, l = t[w >> 2], C = Xi + 8 | 0, tr = l + t[C >> 2] | 0, w = t[C + 4 >> 2] + t[w + 4 >> 2] | 0, w = l >>> 0 > tr >>> 0 ? w + 1 | 0 : w, l = Ce + tr | 0, w = l >>> 0 < tr >>> 0 ? w + 1 | 0 : w, b = b >>> 20 | 0, C = l + b | 0, w = b >>> 0 > C >>> 0 ? w + 1 | 0 : w, l = C, C = C + Me | 0, w = l >>> 0 > C >>> 0 ? w + 1 | 0 : w, Ce = C << 12 | K >>> 20, l = w, nr = w << 12 | C >>> 20, gr = t[a + 240 >> 2], C = t[a + 288 >> 2], K = gr + C | 0, kr = t[a + 244 >> 2], w = kr + t[a + 292 >> 2] | 0, tr = C >>> 0 > K >>> 0 ? w + 1 | 0 : w, w = tr + t[a + 36 >> 2] | 0, C = t[a + 32 >> 2], b = C + K | 0, Me = b, Ce = b + Ce | 0, C = C >>> 0 > b >>> 0 ? w + 1 | 0 : w, w = C + nr | 0, t[P + 16 >> 2] = Ce, b = Ce >>> 0 < b >>> 0 ? w + 1 | 0 : w, t[P + 20 >> 2] = b & 1048575, or = a + 16 | 0, nr = (Tt | 0) == (ei | 0) & pe >>> 0 < Nr >>> 0 | Tt >>> 0 < ei >>> 0, w = Ii + 8 | 0, Tt = t[w >> 2], w = t[w + 4 >> 2], n = n >>> 20 | 0, pe = n, n = n + Tt | 0, w = pe >>> 0 > n >>> 0 ? w + 1 | 0 : w, pe = n, n = n + nr | 0, w = pe >>> 0 > n >>> 0 ? w + 1 | 0 : w, Pr(or, n, w, 0, 0, 64028672, 65536, 0, 0), n = P, nr = (C | 0) == (b | 0) & Ce >>> 0 < Me >>> 0 | C >>> 0 > b >>> 0, Tt = (C | 0) == (tr | 0) & K >>> 0 > Me >>> 0 | C >>> 0 < tr >>> 0, C = Ki + 8 | 0, Me = t[C >> 2], pe = t[C + 4 >> 2], Ce = (tr | 0) == (kr | 0) & K >>> 0 < gr >>> 0 | tr >>> 0 < kr >>> 0, w = Di + 8 | 0, P = t[w >> 2], C = di + 8 | 0, K = P + t[C >> 2] | 0, w = t[C + 4 >> 2] + t[w + 4 >> 2] | 0, w = K >>> 0 < P >>> 0 ? w + 1 | 0 : w, C = K + Ce | 0, w = (C >>> 0 < K >>> 0 ? w + 1 | 0 : w) + pe | 0, P = C, C = C + Me | 0, w = P >>> 0 > C >>> 0 ? w + 1 | 0 : w, P = C + Tt | 0, w = P >>> 0 < C >>> 0 ? w + 1 | 0 : w, l = l >>> 20 | 0, C = l + P | 0, w = l >>> 0 > C >>> 0 ? w + 1 | 0 : w, l = C, C = C + nr | 0, w = l >>> 0 > C >>> 0 ? w + 1 | 0 : w, P = C << 12 | b >>> 20, l = w, b = w << 12 | C >>> 20, Tt = t[a + 16 >> 2], C = In & -2, Ce = Tt + C | 0, w = jr & 1048575, jr = t[a + 20 >> 2], w = w + jr | 0, K = C >>> 0 > Ce >>> 0 ? w + 1 | 0 : w, w = K + b | 0, b = P + Ce | 0, w = b >>> 0 < Ce >>> 0 ? w + 1 | 0 : w, t[n + 24 >> 2] = b, C = w, t[n + 28 >> 2] = w & 1048575, P = n, Me = lr & 65535, pe = (w | 0) == (K | 0) & b >>> 0 < Ce >>> 0 | w >>> 0 < K >>> 0, n = (K | 0) == (jr | 0) & Ce >>> 0 < Tt >>> 0 | K >>> 0 < jr >>> 0, w = or + 8 | 0, b = n + t[w >> 2] | 0, w = t[w + 4 >> 2], w = n >>> 0 > b >>> 0 ? w + 1 | 0 : w, l = l >>> 20 | 0, n = l, l = l + b | 0, w = n >>> 0 > l >>> 0 ? w + 1 | 0 : w, n = l, l = l + pe | 0, w = n >>> 0 > l >>> 0 ? w + 1 | 0 : w, C = l << 12 | C >>> 20, n = C + ui | 0, w = Me + (w << 12 | l >>> 20) | 0, t[P + 32 >> 2] = n, t[P + 36 >> 2] = C >>> 0 > n >>> 0 ? w + 1 | 0 : w, U = a + 336 | 0;
  }
  function Gn(C, l) {
    var w = 0, n = 0, a = 0, b = 0, P = 0, K = 0, pe = 0, Ce = 0, Me = 0, Tt = 0, tr = 0, nr = 0, or = 0, lr = 0, gr = 0, kr = 0, Nr = 0, jr = 0, Yr = 0, ei = 0, ai = 0, ui = 0, di = 0, Ii = 0, wi = 0, Ei = 0, Ti = 0, Di = 0, Qi = 0, Li = 0, Ki = 0, Wi = 0, Xi = 0, $i = 0, In = 0, kn = 0, Dn = 0, Mn = 0, zn = 0, es = 0, ns = 0, fs = 0, ps = 0, Es = 0, Ss = 0, Ps = 0, xs = 0, Bs = 0, vs = 0, eo = 0, Xs = 0, fo = 0, co = 0, ao = 0, no = 0, bo = 0, Io = 0, Po = 0, To = 0;
    a = U - 464 | 0, U = a, t[C + 120 >> 2] = t[l + 120 >> 2], w = l + 40 | 0, zr(C + 80 | 0, l + 80 | 0, w), Wn(a + 384 | 0, w), Wi = a + 424 | 0, Wn(Wi, l), lr = t[a + 388 >> 2], gr = t[a + 384 >> 2], t[a + 344 >> 2] = -3908 - gr, t[a + 348 >> 2] = 4194299 - ((gr >>> 0 > 4294963388) + lr | 0), nr = t[a + 396 >> 2], jr = t[a + 392 >> 2], t[a + 352 >> 2] = -4 - jr, t[a + 356 >> 2] = 4194303 - ((jr >>> 0 > 4294967292) + nr | 0), ei = t[a + 404 >> 2], Nr = t[a + 400 >> 2], t[a + 360 >> 2] = -4 - Nr, t[a + 364 >> 2] = 4194303 - ((Nr >>> 0 > 4294967292) + ei | 0), Me = t[a + 412 >> 2], K = t[a + 408 >> 2], t[a + 368 >> 2] = -4 - K, t[a + 372 >> 2] = 4194303 - ((K >>> 0 > 4294967292) + Me | 0), P = ri(t[a + 456 >> 2], t[a + 460 >> 2], 3, 0), b = ve, Yr = ri(t[a + 424 >> 2], t[a + 428 >> 2], 3, 0), Ce = ve, w = Yr & 1, n = 0 - w | 0, tr = n, Tt = 0 - w | 0, w = (Tt >>> 16 | 0) + b | 0, n = (Tt & 65535) << 16 | n >>> 16, b = n + P | 0, w = n >>> 0 > b >>> 0 ? w + 1 | 0 : w, t[a + 456 >> 2] = (w & 1) << 31 | b >>> 1, t[a + 460 >> 2] = w >>> 1, pe = b << 19 & 524288, P = Tt >>> 12 | 0, tr = (Tt & 4095) << 20 | tr >>> 12, n = ri(t[a + 448 >> 2], t[a + 452 >> 2], 3, 0), b = tr + n | 0, w = P + ve | 0, n = n >>> 0 > b >>> 0 ? w + 1 | 0 : w, w = (n >>> 1 | 0) + pe | 0, Tt = (n & 1) << 31 | b >>> 1, w = Tt >>> 0 > Tt >>> 0 ? w + 1 | 0 : w, t[a + 448 >> 2] = Tt, t[a + 452 >> 2] = w, Tt = b << 19 & 524288, b = ri(t[a + 440 >> 2], t[a + 444 >> 2], 3, 0) + tr | 0, n = ve + P | 0, n = b >>> 0 < tr >>> 0 ? n + 1 | 0 : n, w = (n >>> 1 | 0) + Tt | 0, pe = (n & 1) << 31 | b >>> 1, w = pe >>> 0 > pe >>> 0 ? w + 1 | 0 : w, t[a + 440 >> 2] = pe, t[a + 444 >> 2] = w, pe = b << 19 & 524288, n = ri(t[a + 432 >> 2], t[a + 436 >> 2], 3, 0), Tt = n + tr | 0, w = P + ve | 0, b = n >>> 0 > Tt >>> 0 ? w + 1 | 0 : w, w = (b >>> 1 | 0) + pe | 0, ai = (b & 1) << 31 | Tt >>> 1, n = ai, w = n >>> 0 > n >>> 0 ? w + 1 | 0 : w, t[a + 432 >> 2] = n, t[a + 436 >> 2] = w, Tt = Tt << 19 & 524288, w = (P & 1048574) + Ce | 0, b = (tr & -977) + Yr | 0, w = b >>> 0 < Yr >>> 0 ? w + 1 | 0 : w, b = (w & 1) << 31 | b >>> 1, w = (w >>> 1 | 0) + Tt | 0, n = b, w = n >>> 0 < n >>> 0 ? w + 1 | 0 : w, t[a + 424 >> 2] = n, t[a + 428 >> 2] = w, Ce = t[a + 420 >> 2], pe = t[a + 416 >> 2], t[a + 376 >> 2] = -4 - pe, t[a + 380 >> 2] = 262143 - ((pe >>> 0 > 4294967292) + Ce | 0), Xi = a + 344 | 0, zr(Xi, Xi, l), Wn(C, Wi), l = t[a + 376 >> 2], eo = l, w = t[a + 380 >> 2], Xs = w, w = t[C + 36 >> 2] + (w << 1 | l >>> 31) | 0, l = l << 1, n = l, l = l + t[C + 32 >> 2] | 0, w = n >>> 0 > l >>> 0 ? w + 1 | 0 : w, Dn = l, t[C + 32 >> 2] = l, Di = w, t[C + 36 >> 2] = w, P = C, b = t[C + 24 >> 2], C = t[a + 368 >> 2], fo = C, l = t[a + 372 >> 2], co = l, w = t[P + 28 >> 2] + (l << 1 | C >>> 31) | 0, C = C << 1, l = C, C = C + b | 0, w = l >>> 0 > C >>> 0 ? w + 1 | 0 : w, Mn = C, t[P + 24 >> 2] = C, $i = w, t[P + 28 >> 2] = w, C = t[a + 360 >> 2], ao = C, l = t[a + 364 >> 2], no = l, w = t[P + 20 >> 2] + (l << 1 | C >>> 31) | 0, C = C << 1, l = C, C = C + t[P + 16 >> 2] | 0, w = l >>> 0 > C >>> 0 ? w + 1 | 0 : w, zn = C, t[P + 16 >> 2] = C, In = w, t[P + 20 >> 2] = w, C = t[a + 352 >> 2], bo = C, l = t[a + 356 >> 2], Io = l, n = t[P + 12 >> 2] + (l << 1 | C >>> 31) | 0, C = C << 1, l = C, C = C + t[P + 8 >> 2] | 0, n = l >>> 0 > C >>> 0 ? n + 1 | 0 : n, es = C, t[P + 8 >> 2] = C, Yr = n, t[P + 12 >> 2] = n, C = t[a + 344 >> 2], Po = C, l = t[a + 348 >> 2], To = l, w = t[P + 4 >> 2] + (l << 1 | C >>> 31) | 0, C = C << 1, l = C, C = C + t[P >> 2] | 0, w = l >>> 0 > C >>> 0 ? w + 1 | 0 : w, ns = C, t[P >> 2] = C, ai = w, t[P + 4 >> 2] = w, di = a + 104 | 0, Tt = K, b = Me, Ei = gr << 1, Ii = lr << 1 | gr >>> 31, Pr(di, K, b, 0, 0, Ei, Ii, 0, 0), kr = a + 168 | 0, l = Nr, C = ei, tr = jr << 1, K = nr << 1 | jr >>> 31, Pr(kr, l, C, 0, 0, tr, K, 0, 0), Nr = a + 328 | 0, Pr(Nr, pe, Ce, 0, 0, pe, Ce, 0, 0), or = a + 312 | 0, Pr(or, t[a + 328 >> 2], t[a + 332 >> 2], 0, 0, 15632, 16, 0, 0), n = pe, w = Ce << 1 | n >>> 31, fs = a + 136 | 0, Qi = n << 1, ei = w, Pr(fs, Qi, w, 0, 0, gr, lr, 0, 0), ps = a + 152 | 0, Pr(ps, Tt, b, 0, 0, tr, K, 0, 0), Es = a + 232 | 0, Pr(Es, l, C, 0, 0, l, C, 0, 0), wi = a + 296 | 0, w = Nr + 8 | 0, Pr(wi, t[w >> 2], t[w + 4 >> 2], 0, 0, 64028672, 65536, 0, 0), Ss = a + 120 | 0, Pr(Ss, gr, lr, 0, 0, gr, lr, 0, 0), Ps = a + 200 | 0, Pr(Ps, Qi, ei, 0, 0, jr, nr, 0, 0), pe = C, Nr = l, w = C << 1 | l >>> 31, xs = a + 248 | 0, Me = Tt, Ce = b, Pr(xs, Me, b, 0, 0, l << 1, w, 0, 0), lr = t[a + 108 >> 2], w = lr + t[a + 172 >> 2] | 0, b = t[a + 104 >> 2], C = t[a + 168 >> 2], n = b + C | 0, l = t[a + 312 >> 2], gr = n + l | 0, C = C >>> 0 > n >>> 0 ? w + 1 | 0 : w, w = C + t[a + 316 >> 2] | 0, l = l >>> 0 > gr >>> 0 ? w + 1 | 0 : w, K = (C | 0) == (l | 0) & n >>> 0 > gr >>> 0 | C >>> 0 > l >>> 0, w = or + 8 | 0, tr = t[w >> 2], Tt = t[w + 4 >> 2], b = (C | 0) == (lr | 0) & n >>> 0 < b >>> 0 | C >>> 0 < lr >>> 0, w = kr + 8 | 0, n = t[w >> 2], C = di + 8 | 0, lr = n + t[C >> 2] | 0, w = t[C + 4 >> 2] + t[w + 4 >> 2] | 0, w = n >>> 0 > lr >>> 0 ? w + 1 | 0 : w, C = b + lr | 0, w = (C >>> 0 < lr >>> 0 ? w + 1 | 0 : w) + Tt | 0, n = C, C = C + tr | 0, n = n >>> 0 > C >>> 0 ? w + 1 | 0 : w, w = C, C = C + K | 0, n = w >>> 0 > C >>> 0 ? n + 1 | 0 : n, lr = l, Tt = C << 12 | l >>> 20, l = n << 12 | C >>> 20, Bs = t[a + 152 >> 2], C = t[a + 232 >> 2], K = Bs + C | 0, kn = t[a + 156 >> 2], w = kn + t[a + 236 >> 2] | 0, w = C >>> 0 > K >>> 0 ? w + 1 | 0 : w, C = t[a + 136 >> 2], tr = C + K | 0, kr = w, w = w + t[a + 140 >> 2] | 0, w = C >>> 0 > tr >>> 0 ? w + 1 | 0 : w, C = t[a + 296 >> 2], b = C + tr | 0, or = w, w = w + t[a + 300 >> 2] | 0, C = C >>> 0 > b >>> 0 ? w + 1 | 0 : w, w = C + l | 0, vs = a + 40 | 0, Tt = b + Tt | 0, l = Tt >>> 0 < b >>> 0 ? w + 1 | 0 : w, Ti = (C | 0) == (l | 0) & b >>> 0 > Tt >>> 0 | C >>> 0 > l >>> 0, ui = (C | 0) == (or | 0) & b >>> 0 < tr >>> 0 | C >>> 0 < or >>> 0, C = wi + 8 | 0, Li = t[C >> 2], Ki = t[C + 4 >> 2], di = (or | 0) == (kr | 0) & K >>> 0 > tr >>> 0 | or >>> 0 < kr >>> 0, C = fs + 8 | 0, wi = t[C >> 2], or = t[C + 4 >> 2], tr = (kr | 0) == (kn | 0) & K >>> 0 < Bs >>> 0 | kr >>> 0 < kn >>> 0, w = Es + 8 | 0, b = t[w >> 2], C = ps + 8 | 0, K = b + t[C >> 2] | 0, w = t[C + 4 >> 2] + t[w + 4 >> 2] | 0, w = b >>> 0 > K >>> 0 ? w + 1 | 0 : w, C = K + tr | 0, w = (C >>> 0 < K >>> 0 ? w + 1 | 0 : w) + or | 0, b = C, C = C + wi | 0, w = b >>> 0 > C >>> 0 ? w + 1 | 0 : w, b = C, C = C + di | 0, w = (b >>> 0 > C >>> 0 ? w + 1 | 0 : w) + Ki | 0, b = C, C = C + Li | 0, w = b >>> 0 > C >>> 0 ? w + 1 | 0 : w, b = C + ui | 0, w = b >>> 0 < C >>> 0 ? w + 1 | 0 : w, n = n >>> 20 | 0, C = n + b | 0, w = n >>> 0 > C >>> 0 ? w + 1 | 0 : w, n = C, C = C + Ti | 0, w = n >>> 0 > C >>> 0 ? w + 1 | 0 : w, K = C << 12 | l >>> 20, n = w, tr = w << 12 | C >>> 20, Ti = t[a + 204 >> 2], w = Ti + t[a + 252 >> 2] | 0, ui = t[a + 200 >> 2], C = t[a + 248 >> 2], b = ui + C | 0, or = b, K = b + K | 0, C = C >>> 0 > b >>> 0 ? w + 1 | 0 : w, w = C + tr | 0, b = K >>> 0 < b >>> 0 ? w + 1 | 0 : w, w = b << 4 | K >>> 28, kr = K << 4 & -16, tr = l, Pr(vs, kr | l >>> 16 & 15, w & 16777215, 0, 0, 977, 1, 0, 0), Li = a + 24 | 0, Pr(Li, jr, nr, 0, 0, Ei, Ii, 0, 0), Ki = a + 216 | 0, Pr(Ki, Qi, ei, 0, 0, Nr, pe, 0, 0), di = a + 280 | 0, Pr(di, Me, Ce, 0, 0, Me, Ce, 0, 0), wi = a + 88 | 0, kr = (C | 0) == (b | 0) & K >>> 0 < or >>> 0 | C >>> 0 > b >>> 0, K = (C | 0) == (Ti | 0) & or >>> 0 < ui >>> 0 | C >>> 0 < Ti >>> 0, w = xs + 8 | 0, l = t[w >> 2], C = Ps + 8 | 0, or = l + t[C >> 2] | 0, w = t[C + 4 >> 2] + t[w + 4 >> 2] | 0, w = l >>> 0 > or >>> 0 ? w + 1 | 0 : w, C = n, l = K + or | 0, w = l >>> 0 < or >>> 0 ? w + 1 | 0 : w, C = C >>> 20 | 0, n = C, C = C + l | 0, w = n >>> 0 > C >>> 0 ? w + 1 | 0 : w, l = C, C = C + kr | 0, l = l >>> 0 > C >>> 0 ? w + 1 | 0 : w, n = l << 12 | C >>> 20, K = C << 12 | b >>> 20, b = n, kr = t[a + 216 >> 2], C = t[a + 280 >> 2], n = kr + C | 0, ui = t[a + 220 >> 2], w = ui + t[a + 284 >> 2] | 0, C = C >>> 0 > n >>> 0 ? w + 1 | 0 : w, w = C + b | 0, b = K, K = n, n = b + n | 0, b = n >>> 0 < K >>> 0 ? w + 1 | 0 : w, Pr(wi, n, b & 1048575, 0, 0, 15632, 16, 0, 0), or = a + 8 | 0, Pr(or, Nr, pe, 0, 0, Ei, Ii, 0, 0), Ei = a + 184 | 0, Pr(Ei, jr, nr, 0, 0, jr, nr, 0, 0), nr = a + 264 | 0, Pr(nr, Qi, ei, 0, 0, Me, Ce, 0, 0), ei = a + 72 | 0, Ce = ei, pe = (C | 0) == (b | 0) & n >>> 0 < K >>> 0 | C >>> 0 > b >>> 0, K = (C | 0) == (ui | 0) & K >>> 0 < kr >>> 0 | C >>> 0 < ui >>> 0, n = di + 8 | 0, w = t[n >> 2], C = Ki + 8 | 0, Me = w + t[C >> 2] | 0, n = t[C + 4 >> 2] + t[n + 4 >> 2] | 0, w = w >>> 0 > Me >>> 0 ? n + 1 | 0 : n, n = K + Me | 0, w = n >>> 0 < Me >>> 0 ? w + 1 | 0 : w, l = l >>> 20 | 0, C = l + n | 0, w = l >>> 0 > C >>> 0 ? w + 1 | 0 : w, l = C, C = C + pe | 0, w = l >>> 0 > C >>> 0 ? w + 1 | 0 : w, pe = C << 12 | b >>> 20, b = t[a + 264 >> 2], Me = pe + b | 0, l = w, C = w << 12 | C >>> 20, n = C + t[a + 268 >> 2] | 0, n = b >>> 0 > Me >>> 0 ? n + 1 | 0 : n, Pr(Ce, Me, n, 0, 0, 15632, 16, 0, 0), Nr = a + 56 | 0, K = Nr, b = (C | 0) == (n | 0) & pe >>> 0 > Me >>> 0 | C >>> 0 > n >>> 0, C = nr + 8 | 0, n = t[C >> 2], w = t[C + 4 >> 2], l = l >>> 20 | 0, C = l + n | 0, w = l >>> 0 > C >>> 0 ? w + 1 | 0 : w, l = C, C = C + b | 0, w = l >>> 0 > C >>> 0 ? w + 1 | 0 : w, Pr(K, C, w, 0, 0, 64028672, 65536, 0, 0), C = a, n = Di + Xs | 0, l = Dn + eo | 0, n = l >>> 0 < Dn >>> 0 ? n + 1 | 0 : n, t[C + 376 >> 2] = l, t[C + 380 >> 2] = n, w = $i + co | 0, l = Mn + fo | 0, w = l >>> 0 < Mn >>> 0 ? w + 1 | 0 : w, t[C + 368 >> 2] = l, t[C + 372 >> 2] = w, w = In + no | 0, l = zn + ao | 0, w = l >>> 0 < zn >>> 0 ? w + 1 | 0 : w, t[C + 360 >> 2] = l, t[C + 364 >> 2] = w, w = Yr + Io | 0, l = es + bo | 0, w = l >>> 0 < es >>> 0 ? w + 1 | 0 : w, t[C + 352 >> 2] = l, t[C + 356 >> 2] = w, pe = C, w = ai + To | 0, C = ns + Po | 0, w = C >>> 0 < ns >>> 0 ? w + 1 | 0 : w, t[a + 344 >> 2] = C, t[a + 348 >> 2] = w, zr(P + 40 | 0, Xi, Wi), K = P, P = t[P + 40 >> 2], w = t[K + 44 >> 2], b = t[a + 40 >> 2], l = t[a + 120 >> 2], C = b + l | 0, Ce = t[a + 44 >> 2], n = Ce + t[a + 124 >> 2] | 0, l = C >>> 0 < l >>> 0 ? n + 1 | 0 : n, w = w + (l & 1048575) | 0, n = C + P | 0, w = n >>> 0 < C >>> 0 ? w + 1 | 0 : w, t[K + 40 >> 2] = -5862 - n, t[K + 44 >> 2] = 6291449 - ((n >>> 0 > 4294961434) + w | 0), w = K + 48 | 0, nr = w, Me = t[w >> 2], a = t[w + 4 >> 2], b = (l | 0) == (Ce | 0) & C >>> 0 < b >>> 0 | l >>> 0 < Ce >>> 0, w = Ss + 8 | 0, n = t[w >> 2], C = vs + 8 | 0, P = n + t[C >> 2] | 0, w = t[C + 4 >> 2] + t[w + 4 >> 2] | 0, n = n >>> 0 > P >>> 0 ? w + 1 | 0 : w, C = b + P | 0, n = C >>> 0 < P >>> 0 ? n + 1 | 0 : n, P = C << 12 | l >>> 20, b = n << 12 | C >>> 20, Ce = t[pe + 88 >> 2], C = t[pe + 24 >> 2], l = Ce + C | 0, Yr = t[pe + 92 >> 2], w = Yr + t[pe + 28 >> 2] | 0, w = C >>> 0 > l >>> 0 ? w + 1 | 0 : w, C = P, P = l, l = C + l | 0, C = w, w = w + b | 0, b = l >>> 0 < P >>> 0 ? w + 1 | 0 : w, w = a + (b & 1048575) | 0, Me = l + Me | 0, w = Me >>> 0 < l >>> 0 ? w + 1 | 0 : w, t[nr >> 2] = -6 - Me, t[nr + 4 >> 2] = 6291455 - ((Me >>> 0 > 4294967290) + w | 0), w = K + 56 | 0, ai = w, nr = t[w >> 2], Me = t[w + 4 >> 2], a = (C | 0) == (b | 0) & l >>> 0 < P >>> 0 | C >>> 0 > b >>> 0, P = (C | 0) == (Yr | 0) & P >>> 0 < Ce >>> 0 | C >>> 0 < Yr >>> 0, w = Li + 8 | 0, l = t[w >> 2], C = wi + 8 | 0, Ce = l + t[C >> 2] | 0, w = t[C + 4 >> 2] + t[w + 4 >> 2] | 0, w = l >>> 0 > Ce >>> 0 ? w + 1 | 0 : w, l = P + Ce | 0, w = l >>> 0 < Ce >>> 0 ? w + 1 | 0 : w, n = n >>> 20 | 0, C = l + n | 0, w = n >>> 0 > C >>> 0 ? w + 1 | 0 : w, l = C, C = C + a | 0, w = l >>> 0 > C >>> 0 ? w + 1 | 0 : w, b = C << 12 | b >>> 20, l = w, n = w << 12 | C >>> 20, Di = t[pe + 8 >> 2], C = t[pe + 184 >> 2], a = Di + C | 0, Ii = t[pe + 12 >> 2], w = Ii + t[pe + 188 >> 2] | 0, w = C >>> 0 > a >>> 0 ? w + 1 | 0 : w, C = t[pe + 72 >> 2], P = C + a | 0, Ce = w, w = w + t[pe + 76 >> 2] | 0, C = C >>> 0 > P >>> 0 ? w + 1 | 0 : w, w = C + n | 0, b = b + P | 0, n = b >>> 0 < P >>> 0 ? w + 1 | 0 : w, w = Me + (n & 1048575) | 0, nr = b + nr | 0, w = nr >>> 0 < b >>> 0 ? w + 1 | 0 : w, t[ai >> 2] = -6 - nr, t[ai + 4 >> 2] = 6291455 - ((nr >>> 0 > 4294967290) + w | 0), w = K - -64 | 0, jr = w, $i = t[w >> 2], In = t[w + 4 >> 2], Yr = (C | 0) == (n | 0) & b >>> 0 < P >>> 0 | C >>> 0 > n >>> 0, ai = (C | 0) == (Ce | 0) & a >>> 0 > P >>> 0 | C >>> 0 < Ce >>> 0, C = ei + 8 | 0, nr = t[C >> 2], Me = t[C + 4 >> 2], P = (Ce | 0) == (Ii | 0) & a >>> 0 < Di >>> 0 | Ce >>> 0 < Ii >>> 0, w = Ei + 8 | 0, b = t[w >> 2], C = or + 8 | 0, a = b + t[C >> 2] | 0, w = t[C + 4 >> 2] + t[w + 4 >> 2] | 0, w = a >>> 0 < b >>> 0 ? w + 1 | 0 : w, C = a + P | 0, w = (C >>> 0 < a >>> 0 ? w + 1 | 0 : w) + Me | 0, b = C, C = C + nr | 0, w = b >>> 0 > C >>> 0 ? w + 1 | 0 : w, b = C + ai | 0, w = b >>> 0 < C >>> 0 ? w + 1 | 0 : w, l = l >>> 20 | 0, C = l + b | 0, w = l >>> 0 > C >>> 0 ? w + 1 | 0 : w, l = C, C = C + Yr | 0, w = l >>> 0 > C >>> 0 ? w + 1 | 0 : w, b = C << 12 | n >>> 20, l = w, a = w << 12 | C >>> 20, Ce = t[pe + 56 >> 2], n = gr & -2, C = Ce + n | 0, Me = t[pe + 60 >> 2], w = Me + (lr & 1048575) | 0, P = C >>> 0 < n >>> 0 ? w + 1 | 0 : w, w = P + a | 0, n = b, b = C, n = n + C | 0, C = n >>> 0 < C >>> 0 ? w + 1 | 0 : w, w = In + (C & 1048575) | 0, a = n + $i | 0, w = a >>> 0 < n >>> 0 ? w + 1 | 0 : w, t[jr >> 2] = -6 - a, t[jr + 4 >> 2] = 6291455 - ((a >>> 0 > 4294967290) + w | 0), w = K + 72 | 0, gr = w, lr = t[w >> 2], K = t[w + 4 >> 2], tr = tr & 65535, a = (C | 0) == (P | 0) & n >>> 0 < b >>> 0 | C >>> 0 < P >>> 0, n = (P | 0) == (Me | 0) & b >>> 0 < Ce >>> 0 | P >>> 0 < Me >>> 0, w = Nr + 8 | 0, b = n + t[w >> 2] | 0, w = t[w + 4 >> 2], w = n >>> 0 > b >>> 0 ? w + 1 | 0 : w, l = l >>> 20 | 0, n = l, l = l + b | 0, w = n >>> 0 > l >>> 0 ? w + 1 | 0 : w, n = l, l = l + a | 0, w = n >>> 0 > l >>> 0 ? w + 1 | 0 : w, C = l << 12 | C >>> 20, b = C + Tt | 0, n = tr + (w << 12 | l >>> 20) | 0, w = (C >>> 0 > b >>> 0 ? n + 1 | 0 : n) + K | 0, C = b + lr | 0, w = C >>> 0 < b >>> 0 ? w + 1 | 0 : w, t[gr >> 2] = -6 - C, t[gr + 4 >> 2] = 393215 - ((C >>> 0 > 4294967290) + w | 0), U = pe + 464 | 0;
  }
  function ro(C, l) {
    var w = 0, n = 0, a = 0, b = 0, P = 0, K = 0, pe = 0, Ce = 0, Me = 0, Tt = 0, tr = 0, nr = 0, or = 0, lr = 0, gr = 0, kr = 0, Nr = 0;
    K = U - 80 | 0, U = K;
    e: {
      if (t[l + 120 >> 2]) {
        t[C + 80 >> 2] = 1, is(C, 80);
        break e;
      }
      Tt = l + 88 | 0, a = t[Tt >> 2], P = t[Tt + 4 >> 2], b = t[l + 84 >> 2], n = l + 112 | 0, or = t[n >> 2], pe = t[n + 4 >> 2], lr = pe, n = t[l + 80 >> 2], w = ri(pe >>> 16 | 0, 0, 977, 1), Me = n + w | 0, b = b + ve | 0, n = P, Ce = w >>> 0 > Me >>> 0 ? b + 1 | 0 : b, w = Ce >>> 20 | 0, P = w, w = w + a | 0, P = P >>> 0 > w >>> 0 ? n + 1 | 0 : n, gr = P & 1048575, b = l + 104 | 0, nr = t[b >> 2], kr = t[b + 4 >> 2], b = l + 96 | 0, pe = t[b >> 2], a = t[b + 4 >> 2], b = P >>> 20 | 0, pe = b + pe | 0, a = b >>> 0 > pe >>> 0 ? a + 1 | 0 : a, n = kr, tr = a, a = a >>> 20 | 0, b = a + nr | 0, n = a >>> 0 > b >>> 0 ? n + 1 | 0 : n, nr = n & 1048575, kr = l + 80 | 0, a = pe, tr = tr & 1048575, Nr = (w & a & b) == -1 & (P & tr & n) == 1048575, P = n >>> 20 | 0, n = lr & 65535, pe = P + or | 0, P = pe >>> 0 < P >>> 0 ? n + 1 | 0 : n, n = Ce & 1048575, or = n, Nr & ((pe | 0) == -1 & (P | 0) == 65535) & ((n | 0) == 1048574 & Me >>> 0 > 4294966318 | n >>> 0 > 1048574) | P >>> 16 && (n = or + 1 | 0, Me = Me + 977 | 0, n = Me >>> 0 < 977 ? n + 1 | 0 : n, or = n & 1048575, Ce = n, n = gr, Ce = Ce >>> 20 | 0, w = w + Ce | 0, n = Ce >>> 0 > w >>> 0 ? n + 1 | 0 : n, gr = n & 1048575, Ce = a, lr = n >>> 20 | 0, a = tr, n = Ce + lr | 0, a = n >>> 0 < lr >>> 0 ? a + 1 | 0 : a, tr = a & 1048575, Ce = a, a = n, n = nr, Ce = Ce >>> 20 | 0, b = b + Ce | 0, n = Ce >>> 0 > b >>> 0 ? n + 1 | 0 : n, nr = n & 1048575, Ce = n, n = P, P = pe, pe = (Ce >>> 20 | 0) + pe | 0, P = (P >>> 0 > pe >>> 0 ? n + 1 | 0 : n) & 65535), t[K + 72 >> 2] = P >>> 8, t[K + 76 >> 2] = 0, n = P << 22 | pe >>> 10, t[K + 64 >> 2] = pe << 22 & -4194304 | ((nr & 1073741823) << 2 | b >>> 30), t[K + 68 >> 2] = n & 1073741823 | nr >>> 30, t[K + 56 >> 2] = (tr & 1048575) << 12 | a >>> 20, t[K + 60 >> 2] = b & 1073741823 | tr >>> 20, a = a << 10 & 1073740800, t[K + 48 >> 2] = (gr & 1023) << 22 | w >>> 10, t[K + 52 >> 2] = gr >>> 10 | a, t[K + 40 >> 2] = Me, t[K + 44 >> 2] = or | w << 20 & 1072693248, Me = K + 40 | 0, Cr(Me, 690464), b = t[K + 44 >> 2], a = b, t[l + 80 >> 2] = t[K + 40 >> 2], t[l + 84 >> 2] = a & 1048575, b = t[K + 72 >> 2] << 8, pe = t[K + 68 >> 2], n = pe >>> 22 | 0, P = t[K + 64 >> 2], t[l + 112 >> 2] = (pe & 4194303) << 10 | P >>> 22, t[l + 116 >> 2] = n | b, w = P, n = pe << 30 | w >>> 2, P = w << 30 & -1073741824, w = t[K + 56 >> 2], b = t[K + 60 >> 2], t[l + 104 >> 2] = b | P, t[l + 108 >> 2] = n & 1048575, b = b << 20 | w >>> 12, P = w << 20 & -1048576, pe = b & 1048575, w = t[K + 48 >> 2], b = t[K + 52 >> 2], t[l + 96 >> 2] = b >>> 10 | P, t[l + 100 >> 2] = pe, n = b << 10 | w >>> 22, t[l + 88 >> 2] = w << 10 & -1024 | a >>> 20, t[l + 92 >> 2] = n & 1048575, Wn(Me, kr), zr(K, kr, Me), zr(l, l, Me), w = l + 40 | 0, zr(w, w, K), t[Tt >> 2] = 0, t[Tt + 4 >> 2] = 0, w = Tt + 8 | 0, t[w >> 2] = 0, t[w + 4 >> 2] = 0, w = Tt + 16 | 0, t[w >> 2] = 0, t[w + 4 >> 2] = 0, w = Tt + 24 | 0, t[w >> 2] = 0, t[w + 4 >> 2] = 0, t[C + 80 >> 2] = 0, t[l + 80 >> 2] = 1, t[l + 84 >> 2] = 0, w = t[l + 4 >> 2], t[C >> 2] = t[l >> 2], t[C + 4 >> 2] = w, w = l + 8 | 0, b = t[w + 4 >> 2], a = C + 8 | 0, t[a >> 2] = t[w >> 2], t[a + 4 >> 2] = b, w = l + 16 | 0, b = t[w + 4 >> 2], a = C + 16 | 0, t[a >> 2] = t[w >> 2], t[a + 4 >> 2] = b, w = l + 24 | 0, b = t[w + 4 >> 2], a = C + 24 | 0, t[a >> 2] = t[w >> 2], t[a + 4 >> 2] = b, w = l + 32 | 0, b = t[w + 4 >> 2], a = C + 32 | 0, t[a >> 2] = t[w >> 2], t[a + 4 >> 2] = b, w = l + 72 | 0, b = t[w + 4 >> 2], a = C + 72 | 0, t[a >> 2] = t[w >> 2], t[a + 4 >> 2] = b, w = l - -64 | 0, b = t[w + 4 >> 2], a = C - -64 | 0, t[a >> 2] = t[w >> 2], t[a + 4 >> 2] = b, w = l + 56 | 0, b = t[w + 4 >> 2], a = C + 56 | 0, t[a >> 2] = t[w >> 2], t[a + 4 >> 2] = b, w = l + 48 | 0, b = t[w + 4 >> 2], a = C + 48 | 0, t[a >> 2] = t[w >> 2], t[a + 4 >> 2] = b, w = t[l + 44 >> 2], t[C + 40 >> 2] = t[l + 40 >> 2], t[C + 44 >> 2] = w;
    }
    U = K + 80 | 0;
  }
  function Fs(C, l, w) {
    var n = 0, a = 0;
    a = U - 128 | 0, U = a;
    e: {
      if (!l) {
        yi[t[C + 168 >> 2]](689638, t[C + 172 >> 2]), C = 0;
        break e;
      }
      if (c[l | 0] = 0, c[l + 1 | 0] = 0, c[l + 2 | 0] = 0, c[l + 3 | 0] = 0, c[l + 4 | 0] = 0, c[l + 5 | 0] = 0, c[l + 6 | 0] = 0, c[l + 7 | 0] = 0, n = l + 56 | 0, c[n | 0] = 0, c[n + 1 | 0] = 0, c[n + 2 | 0] = 0, c[n + 3 | 0] = 0, c[n + 4 | 0] = 0, c[n + 5 | 0] = 0, c[n + 6 | 0] = 0, c[n + 7 | 0] = 0, n = l + 48 | 0, c[n | 0] = 0, c[n + 1 | 0] = 0, c[n + 2 | 0] = 0, c[n + 3 | 0] = 0, c[n + 4 | 0] = 0, c[n + 5 | 0] = 0, c[n + 6 | 0] = 0, c[n + 7 | 0] = 0, n = l + 40 | 0, c[n | 0] = 0, c[n + 1 | 0] = 0, c[n + 2 | 0] = 0, c[n + 3 | 0] = 0, c[n + 4 | 0] = 0, c[n + 5 | 0] = 0, c[n + 6 | 0] = 0, c[n + 7 | 0] = 0, n = l + 32 | 0, c[n | 0] = 0, c[n + 1 | 0] = 0, c[n + 2 | 0] = 0, c[n + 3 | 0] = 0, c[n + 4 | 0] = 0, c[n + 5 | 0] = 0, c[n + 6 | 0] = 0, c[n + 7 | 0] = 0, n = l + 24 | 0, c[n | 0] = 0, c[n + 1 | 0] = 0, c[n + 2 | 0] = 0, c[n + 3 | 0] = 0, c[n + 4 | 0] = 0, c[n + 5 | 0] = 0, c[n + 6 | 0] = 0, c[n + 7 | 0] = 0, n = l + 16 | 0, c[n | 0] = 0, c[n + 1 | 0] = 0, c[n + 2 | 0] = 0, c[n + 3 | 0] = 0, c[n + 4 | 0] = 0, c[n + 5 | 0] = 0, c[n + 6 | 0] = 0, c[n + 7 | 0] = 0, n = l + 8 | 0, c[n | 0] = 0, c[n + 1 | 0] = 0, c[n + 2 | 0] = 0, c[n + 3 | 0] = 0, c[n + 4 | 0] = 0, c[n + 5 | 0] = 0, c[n + 6 | 0] = 0, c[n + 7 | 0] = 0, !w) {
        yi[t[C + 168 >> 2]](689936, t[C + 172 >> 2]), C = 0;
        break e;
      }
      if (C = 0, !$r(a, w) || (C = 0, !oi(a + 40 | 0, a, 0)))
        break e;
      ti(l, a + 40 | 0), C = 1;
    }
    return U = a + 128 | 0, C;
  }
  function ii(C, l) {
    var w = 0, n = 0, a = 0, b = 0, P = 0, K = 0, pe = 0, Ce = 0, Me = 0, Tt = 0, tr = 0, nr = 0, or = 0, lr = 0;
    n = U - 96 | 0, U = n, c[690885] = 0, c[690886] = 0, c[690887] = 0, c[690888] = 0, c[690889] = 0, c[690890] = 0, c[690891] = 0, c[690892] = 0, c[690909] = 0, c[690910] = 0, c[690911] = 0, c[690912] = 0, c[690913] = 0, c[690914] = 0, c[690915] = 0, c[690916] = 0, c[690901] = 0, c[690902] = 0, c[690903] = 0, c[690904] = 0, c[690905] = 0, c[690906] = 0, c[690907] = 0, c[690908] = 0, c[690893] = 0, c[690894] = 0, c[690895] = 0, c[690896] = 0, c[690897] = 0, c[690898] = 0, c[690899] = 0, c[690900] = 0;
    e: {
      if (!l) {
        yi[t[C + 168 >> 2]](689638, t[C + 172 >> 2]);
        break e;
      }
      if (b = d[l + 60 | 0] | d[l + 61 | 0] << 8 | (d[l + 62 | 0] << 16 | d[l + 63 | 0] << 24), pe = b >>> 16 | 0, a = n + 80 | 0, w = d[l + 56 | 0] | d[l + 57 | 0] << 8 | (d[l + 58 | 0] << 16 | d[l + 59 | 0] << 24), t[a >> 2] = (b & 65535) << 16 | w >>> 16, t[a + 4 >> 2] = pe, K = w << 4 & 1048560, a = d[l + 52 | 0] | d[l + 53 | 0] << 8 | (d[l + 54 | 0] << 16 | d[l + 55 | 0] << 24), w = a >>> 28 | 0, P = n + 72 | 0, b = d[l + 48 | 0] | d[l + 49 | 0] << 8 | (d[l + 50 | 0] << 16 | d[l + 51 | 0] << 24), t[P >> 2] = (a & 268435455) << 4 | b >>> 28, t[P + 4 >> 2] = w | K, w = b, pe = a << 24 | w >>> 8, b = d[l + 40 | 0] | d[l + 41 | 0] << 8 | (d[l + 42 | 0] << 16 | d[l + 43 | 0] << 24), K = n - -64 | 0, a = d[l + 44 | 0] | d[l + 45 | 0] << 8 | (d[l + 46 | 0] << 16 | d[l + 47 | 0] << 24), t[K >> 2] = w << 24 & -16777216 | a >>> 8, t[K + 4 >> 2] = pe & 1048575, w = b, a = (a << 12 | w >>> 20) & 1048575, K = d[l + 32 | 0] | d[l + 33 | 0] << 8 | (d[l + 34 | 0] << 16 | d[l + 35 | 0] << 24), P = n + 56 | 0, Ce = d[l + 36 | 0] | d[l + 37 | 0] << 8 | (d[l + 38 | 0] << 16 | d[l + 39 | 0] << 24), t[P >> 2] = w << 12 & -4096 | Ce >>> 20, t[P + 4 >> 2] = a, t[n + 88 >> 2] = 0, t[n + 48 >> 2] = K, t[n + 52 >> 2] = Ce & 1048575, b = d[l + 12 | 0] | d[l + 13 | 0] << 8 | (d[l + 14 | 0] << 16 | d[l + 15 | 0] << 24), w = d[l + 8 | 0] | d[l + 9 | 0] << 8 | (d[l + 10 | 0] << 16 | d[l + 11 | 0] << 24), pe = b << 12 | w >>> 20, a = w << 12 & -4096, w = d[l | 0] | d[l + 1 | 0] << 8 | (d[l + 2 | 0] << 16 | d[l + 3 | 0] << 24), Ce = d[l + 4 | 0] | d[l + 5 | 0] << 8 | (d[l + 6 | 0] << 16 | d[l + 7 | 0] << 24), Me = Ce >>> 20 | a, t[n + 16 >> 2] = Me, Tt = pe & 1048575, t[n + 20 >> 2] = Tt, a = w, t[n + 8 >> 2] = w, tr = Ce & 1048575, t[n + 12 >> 2] = tr, P = d[l + 28 | 0] | d[l + 29 | 0] << 8 | (d[l + 30 | 0] << 16 | d[l + 31 | 0] << 24), w = P >>> 16 | 0, K = d[l + 24 | 0] | d[l + 25 | 0] << 8 | (d[l + 26 | 0] << 16 | d[l + 27 | 0] << 24), Ce = (P & 65535) << 16 | K >>> 16, t[n + 40 >> 2] = Ce, P = w, t[n + 44 >> 2] = w, w = d[l + 16 | 0] | d[l + 17 | 0] << 8 | (d[l + 18 | 0] << 16 | d[l + 19 | 0] << 24), or = w, nr = d[l + 20 | 0] | d[l + 21 | 0] << 8 | (d[l + 22 | 0] << 16 | d[l + 23 | 0] << 24), l = w, w = nr << 24 | l >>> 8, b = l << 24 & -16777216 | b >>> 8, t[n + 24 >> 2] = b, pe = w & 1048575, t[n + 28 >> 2] = pe, l = nr, w = l >>> 28 | 0, l = (l & 268435455) << 4 | or >>> 28, t[n + 32 >> 2] = l, w = w | K << 4 & 1048560, t[n + 36 >> 2] = w, !(a | Me | Ce | b | l | (Tt | tr | P | pe | w))) {
        yi[t[C + 168 >> 2]](690116, t[C + 172 >> 2]);
        break e;
      }
      Rr(690885, n + 8 | 0), lr = 1;
    }
    return U = n + 96 | 0, lr;
  }
  function Ai(C, l, w, n) {
    var a = 0, b = 0, P = 0, K = 0, pe = 0, Ce = 0, Me = 0, Tt = 0, tr = 0, nr = 0, or = 0, lr = 0, gr = 0, kr = 0, Nr = 0, jr = 0, Yr = 0, ei = 0, ai = 0, ui = 0, di = 0, Ii = 0, wi = 0, Ei = 0;
    a = U - 96 | 0, U = a;
    e: {
      if (!l) {
        yi[t[C + 168 >> 2]](689586, t[C + 172 >> 2]), C = 0;
        break e;
      }
      if (!n) {
        yi[t[C + 168 >> 2]](689638, t[C + 172 >> 2]), C = 0;
        break e;
      }
      if (Tt = d[n + 60 | 0] | d[n + 61 | 0] << 8 | (d[n + 62 | 0] << 16 | d[n + 63 | 0] << 24), b = Tt >>> 16 | 0, P = a + 80 | 0, K = d[n + 56 | 0] | d[n + 57 | 0] << 8 | (d[n + 58 | 0] << 16 | d[n + 59 | 0] << 24), Tt = (Tt & 65535) << 16 | K >>> 16, t[P >> 2] = Tt, di = b, t[P + 4 >> 2] = b, Me = K << 4 & 1048560, pe = d[n + 52 | 0] | d[n + 53 | 0] << 8 | (d[n + 54 | 0] << 16 | d[n + 55 | 0] << 24), b = pe >>> 28 | 0, P = a + 72 | 0, K = d[n + 48 | 0] | d[n + 49 | 0] << 8 | (d[n + 50 | 0] << 16 | d[n + 51 | 0] << 24), nr = (pe & 268435455) << 4 | K >>> 28, t[P >> 2] = nr, gr = b | Me, t[P + 4 >> 2] = gr, b = pe << 24 | K >>> 8, Me = K << 24 & -16777216, K = d[n + 40 | 0] | d[n + 41 | 0] << 8 | (d[n + 42 | 0] << 16 | d[n + 43 | 0] << 24), P = a - -64 | 0, pe = d[n + 44 | 0] | d[n + 45 | 0] << 8 | (d[n + 46 | 0] << 16 | d[n + 47 | 0] << 24), or = pe >>> 8 | Me, t[P >> 2] = or, kr = b & 1048575, t[P + 4 >> 2] = kr, b = K, Me = pe << 12 | b >>> 20, K = d[n + 32 | 0] | d[n + 33 | 0] << 8 | (d[n + 34 | 0] << 16 | d[n + 35 | 0] << 24), P = a + 56 | 0, Ce = d[n + 36 | 0] | d[n + 37 | 0] << 8 | (d[n + 38 | 0] << 16 | d[n + 39 | 0] << 24), lr = b << 12 & -4096 | Ce >>> 20, t[P >> 2] = lr, Nr = Me & 1048575, t[P + 4 >> 2] = Nr, t[a + 88 >> 2] = 0, t[a + 48 >> 2] = K, jr = Ce & 1048575, t[a + 52 >> 2] = jr, b = d[n + 12 | 0] | d[n + 13 | 0] << 8 | (d[n + 14 | 0] << 16 | d[n + 15 | 0] << 24), P = b, pe = d[n + 8 | 0] | d[n + 9 | 0] << 8 | (d[n + 10 | 0] << 16 | d[n + 11 | 0] << 24), Ce = (b << 12 | pe >>> 20) & 1048575, b = d[n | 0] | d[n + 1 | 0] << 8 | (d[n + 2 | 0] << 16 | d[n + 3 | 0] << 24), tr = d[n + 4 | 0] | d[n + 5 | 0] << 8 | (d[n + 6 | 0] << 16 | d[n + 7 | 0] << 24), Yr = pe << 12 & -4096 | tr >>> 20, t[a + 16 >> 2] = Yr, Ii = Ce, t[a + 20 >> 2] = Ce, pe = b, t[a + 8 >> 2] = b, ei = tr & 1048575, t[a + 12 >> 2] = ei, Ce = d[n + 28 | 0] | d[n + 29 | 0] << 8 | (d[n + 30 | 0] << 16 | d[n + 31 | 0] << 24), b = Ce >>> 16 | 0, Me = d[n + 24 | 0] | d[n + 25 | 0] << 8 | (d[n + 26 | 0] << 16 | d[n + 27 | 0] << 24), tr = (Ce & 65535) << 16 | Me >>> 16, t[a + 40 >> 2] = tr, Ce = b, t[a + 44 >> 2] = b, b = d[n + 16 | 0] | d[n + 17 | 0] << 8 | (d[n + 18 | 0] << 16 | d[n + 19 | 0] << 24), wi = b, ai = d[n + 20 | 0] | d[n + 21 | 0] << 8 | (d[n + 22 | 0] << 16 | d[n + 23 | 0] << 24), n = b, ui = (ai << 24 | n >>> 8) & 1048575, P = n << 24 & -16777216 | P >>> 8, t[a + 24 >> 2] = P, t[a + 28 >> 2] = ui, n = ai, b = n >>> 28 | 0, n = (n & 268435455) << 4 | wi >>> 28, t[a + 32 >> 2] = n, b = b | Me << 4 & 1048560, t[a + 36 >> 2] = b, !(pe | Yr | tr | P | n | (Ii | ei | Ce | ui | b))) {
        yi[t[C + 168 >> 2]](690116, t[C + 172 >> 2]), C = 0;
        break e;
      }
      K & 1 && (t[a + 80 >> 2] = -4 - Tt, t[a + 84 >> 2] = 262143 - ((Tt >>> 0 > 4294967292) + di | 0), t[a + 72 >> 2] = -4 - nr, t[a + 76 >> 2] = 4194303 - ((nr >>> 0 > 4294967292) + gr | 0), t[a + 64 >> 2] = -4 - or, t[a + 68 >> 2] = 4194303 - ((or >>> 0 > 4294967292) + kr | 0), t[a + 56 >> 2] = -4 - lr, t[a + 60 >> 2] = 4194303 - ((lr >>> 0 > 4294967292) + Nr | 0), t[a + 48 >> 2] = -3908 - K, t[a + 52 >> 2] = 4194299 - ((K >>> 0 > 4294963388) + jr | 0), Ei = 1), w && (t[w >> 2] = Ei), ti(l, a + 8 | 0), C = 1;
    }
    return U = a + 96 | 0, C;
  }
  function ci(C, l) {
    var w = 0, n = 0, a = 0, b = 0, P = 0, K = 0, pe = 0, Ce = 0, Me = 0, Tt = 0, tr = 0, nr = 0, or = 0, lr = 0;
    w = U - 256 | 0, U = w;
    e: {
      if (!l) {
        yi[t[C + 168 >> 2]](689700, t[C + 172 >> 2]);
        break e;
      }
      if (P = is(l, 96), !t[C >> 2]) {
        yi[t[C + 168 >> 2]](690045, t[C + 172 >> 2]);
        break e;
      }
      for (n = w + 96 | 0, K = w + 128 | 0, Ir(n, 690788, K), Ce = t[w + 120 >> 2], Me = t[w + 112 >> 2], a = t[w + 104 >> 2], Tt = t[w + 96 >> 2], tr = t[w + 124 >> 2], nr = t[w + 116 >> 2], or = t[w + 108 >> 2], lr = t[w + 100 >> 2], pe = t[w + 128 >> 2] | !(Ce | (Me | (a | Tt)) | (tr | (nr | (or | lr)))), l = pe ? 0 : -1, t[w + 120 >> 2] = l & Ce, t[w + 124 >> 2] = l & tr, t[w + 112 >> 2] = l & Me, t[w + 116 >> 2] = l & nr, t[w + 104 >> 2] = l & a, t[w + 108 >> 2] = l & or, a = (pe | 0) != 0, t[w + 96 >> 2] = a | l & Tt, t[w + 100 >> 2] = l & lr, zi(C, K, n), C = w + 8 | 0, Kn(C, K), pr(P, n), ti(P + 32 | 0, C), t[w + 128 >> 2] = a, C = t[w + 128 >> 2] - 1 | 0; l = b + P | 0, c[l | 0] = d[l | 0] & C, n = l + 1 | 0, c[n | 0] = d[n | 0] & C, n = l + 2 | 0, c[n | 0] = d[n | 0] & C, n = l + 3 | 0, c[n | 0] = d[n | 0] & C, n = l + 4 | 0, c[n | 0] = d[n | 0] & C, l = l + 5 | 0, c[l | 0] = d[l | 0] & C, b = b + 6 | 0, (b | 0) != 96; )
        ;
      b = !pe;
    }
    return U = w + 256 | 0, b;
  }
  function Si(C, l, w, n, a, b, P, K) {
    C = C | 0, l = l | 0, w = w | 0, n = n | 0, a = a | 0, b = b | 0, P = P | 0, K = K | 0;
    var pe = 0, Ce = 0;
    if (pe = U - 176 | 0, U = pe, b) {
      e: {
        if (!K) {
          c[pe | 0] = d[n | 0] ^ 84, c[pe + 1 | 0] = d[n + 1 | 0] ^ 241, c[pe + 2 | 0] = d[n + 2 | 0] ^ 105, c[pe + 3 | 0] = d[n + 3 | 0] ^ 207, c[pe + 4 | 0] = d[n + 4 | 0] ^ 201, c[pe + 5 | 0] = d[n + 5 | 0] ^ 226, c[pe + 6 | 0] = d[n + 6 | 0] ^ 229, c[pe + 7 | 0] = d[n + 7 | 0] ^ 114, c[pe + 8 | 0] = d[n + 8 | 0] ^ 116, c[pe + 9 | 0] = d[n + 9 | 0] ^ 128, c[pe + 10 | 0] = d[n + 10 | 0] ^ 68, c[pe + 11 | 0] = d[n + 11 | 0] ^ 31, c[pe + 12 | 0] = d[n + 12 | 0] ^ 144, c[pe + 13 | 0] = d[n + 13 | 0] ^ 186, c[pe + 14 | 0] = d[n + 14 | 0] ^ 37, c[pe + 15 | 0] = d[n + 15 | 0] ^ 196, c[pe + 16 | 0] = d[n + 16 | 0] ^ 136, c[pe + 17 | 0] = d[n + 17 | 0] ^ 244, c[pe + 18 | 0] = d[n + 18 | 0] ^ 97, c[pe + 19 | 0] = d[n + 19 | 0] ^ 199, c[pe + 20 | 0] = d[n + 20 | 0] ^ 11, c[pe + 21 | 0] = d[n + 21 | 0] ^ 94, c[pe + 22 | 0] = d[n + 22 | 0] ^ 165, c[pe + 23 | 0] = d[n + 23 | 0] ^ 220, c[pe + 24 | 0] = d[n + 24 | 0] ^ 170, c[pe + 25 | 0] = d[n + 25 | 0] ^ 247, c[pe + 26 | 0] = d[n + 26 | 0] ^ 175, c[pe + 27 | 0] = d[n + 27 | 0] ^ 105, c[pe + 28 | 0] = d[n + 28 | 0] ^ 39, c[pe + 29 | 0] = d[n + 29 | 0] ^ 10, c[pe + 30 | 0] = d[n + 30 | 0] ^ 165, c[pe + 31 | 0] = d[n + 31 | 0] ^ 20;
          break e;
        }
        t[pe + 136 >> 2] = 64, t[pe + 140 >> 2] = 0, t[pe + 64 >> 2] = 1252796217, t[pe + 68 >> 2] = 614368522, t[pe + 56 >> 2] = 989586609, t[pe + 60 >> 2] = 1279582103, t[pe + 48 >> 2] = -904942663, t[pe + 52 >> 2] = 262346349, t[pe + 40 >> 2] = 618476057, t[pe + 44 >> 2] = 1320844912, Ce = pe + 40 | 0, Wr(Ce, K, 32), fi(Ce, pe), c[pe | 0] = d[pe | 0] ^ d[n | 0], c[pe + 1 | 0] = d[pe + 1 | 0] ^ d[n + 1 | 0], c[pe + 2 | 0] = d[pe + 2 | 0] ^ d[n + 2 | 0], c[pe + 3 | 0] = d[pe + 3 | 0] ^ d[n + 3 | 0], c[pe + 4 | 0] = d[pe + 4 | 0] ^ d[n + 4 | 0], c[pe + 5 | 0] = d[pe + 5 | 0] ^ d[n + 5 | 0], c[pe + 6 | 0] = d[pe + 6 | 0] ^ d[n + 6 | 0], c[pe + 7 | 0] = d[pe + 7 | 0] ^ d[n + 7 | 0], c[pe + 8 | 0] = d[pe + 8 | 0] ^ d[n + 8 | 0], c[pe + 9 | 0] = d[pe + 9 | 0] ^ d[n + 9 | 0], c[pe + 10 | 0] = d[pe + 10 | 0] ^ d[n + 10 | 0], c[pe + 11 | 0] = d[pe + 11 | 0] ^ d[n + 11 | 0], c[pe + 12 | 0] = d[pe + 12 | 0] ^ d[n + 12 | 0], c[pe + 13 | 0] = d[pe + 13 | 0] ^ d[n + 13 | 0], c[pe + 14 | 0] = d[pe + 14 | 0] ^ d[n + 14 | 0], c[pe + 15 | 0] = d[pe + 15 | 0] ^ d[n + 15 | 0], c[pe + 16 | 0] = d[pe + 16 | 0] ^ d[n + 16 | 0], c[pe + 17 | 0] = d[pe + 17 | 0] ^ d[n + 17 | 0], c[pe + 18 | 0] = d[pe + 18 | 0] ^ d[n + 18 | 0], c[pe + 19 | 0] = d[pe + 19 | 0] ^ d[n + 19 | 0], c[pe + 20 | 0] = d[pe + 20 | 0] ^ d[n + 20 | 0], c[pe + 21 | 0] = d[pe + 21 | 0] ^ d[n + 21 | 0], c[pe + 22 | 0] = d[pe + 22 | 0] ^ d[n + 22 | 0], c[pe + 23 | 0] = d[pe + 23 | 0] ^ d[n + 23 | 0], c[pe + 24 | 0] = d[pe + 24 | 0] ^ d[n + 24 | 0], c[pe + 25 | 0] = d[pe + 25 | 0] ^ d[n + 25 | 0], c[pe + 26 | 0] = d[pe + 26 | 0] ^ d[n + 26 | 0], c[pe + 27 | 0] = d[pe + 27 | 0] ^ d[n + 27 | 0], c[pe + 28 | 0] = d[pe + 28 | 0] ^ d[n + 28 | 0], c[pe + 29 | 0] = d[pe + 29 | 0] ^ d[n + 29 | 0], c[pe + 30 | 0] = d[pe + 30 | 0] ^ d[n + 30 | 0], c[pe + 31 | 0] = d[pe + 31 | 0] ^ d[n + 31 | 0];
      }
      e: {
        if ((P | 0) == 13) {
          t: {
            if (d[b | 0] != 66 || d[b + 1 | 0] != 73 || d[b + 2 | 0] != 80 || d[b + 3 | 0] != 48 || d[b + 4 | 0] != 51 || d[b + 5 | 0] != 52 || d[b + 6 | 0] != 48 || d[b + 7 | 0] != 47 || d[b + 8 | 0] != 110 || d[b + 9 | 0] != 111 || d[b + 10 | 0] != 110 || d[b + 11 | 0] != 99 || d[b + 12 | 0] != 101)
              break t;
            t[pe + 136 >> 2] = 64, t[pe + 140 >> 2] = 0, t[pe + 64 >> 2] = 564305492, t[pe + 68 >> 2] = 1756396364, t[pe + 56 >> 2] = 1612804480, t[pe + 60 >> 2] = 1463125601, t[pe + 48 >> 2] = -1618098575, t[pe + 52 >> 2] = -2090698061, t[pe + 40 >> 2] = 1180785461, t[pe + 44 >> 2] = -188760073;
            break e;
          }
          t[pe + 136 >> 2] = 0, t[pe + 140 >> 2] = 0, t[pe + 64 >> 2] = 528734635, t[pe + 68 >> 2] = 1541459225, t[pe + 56 >> 2] = 1359893119, t[pe + 60 >> 2] = -1694144372, t[pe + 48 >> 2] = 1013904242, t[pe + 52 >> 2] = -1521486534, t[pe + 40 >> 2] = 1779033703, t[pe + 44 >> 2] = -1150833019, n = pe + 40 | 0, Wr(n, b, 13), b = pe + 144 | 0, fi(n, b), t[pe + 136 >> 2] = 0, t[pe + 140 >> 2] = 0, t[pe + 64 >> 2] = 528734635, t[pe + 68 >> 2] = 1541459225, t[pe + 56 >> 2] = 1359893119, t[pe + 60 >> 2] = -1694144372, t[pe + 48 >> 2] = 1013904242, t[pe + 52 >> 2] = -1521486534, t[pe + 40 >> 2] = 1779033703, t[pe + 44 >> 2] = -1150833019, Wr(n, b, 32), Wr(n, b, 32);
          break e;
        }
        t[pe + 136 >> 2] = 0, t[pe + 140 >> 2] = 0, t[pe + 64 >> 2] = 528734635, t[pe + 68 >> 2] = 1541459225, t[pe + 56 >> 2] = 1359893119, t[pe + 60 >> 2] = -1694144372, t[pe + 48 >> 2] = 1013904242, t[pe + 52 >> 2] = -1521486534, t[pe + 40 >> 2] = 1779033703, t[pe + 44 >> 2] = -1150833019, n = pe + 40 | 0, Wr(n, b, P), b = pe + 144 | 0, fi(n, b), t[pe + 136 >> 2] = 0, t[pe + 140 >> 2] = 0, t[pe + 64 >> 2] = 528734635, t[pe + 68 >> 2] = 1541459225, t[pe + 56 >> 2] = 1359893119, t[pe + 60 >> 2] = -1694144372, t[pe + 48 >> 2] = 1013904242, t[pe + 52 >> 2] = -1521486534, t[pe + 40 >> 2] = 1779033703, t[pe + 44 >> 2] = -1150833019, Wr(n, b, 32), Wr(n, b, 32);
      }
      n = pe + 40 | 0, Wr(n, pe, 32), Wr(n, a, 32), Wr(n, l, w), fi(n, C), C = 1;
    } else
      C = 0;
    return U = pe + 176 | 0, C | 0;
  }
  function Ui(C, l, w) {
    var n = 0, a = 0, b = 0, P = 0, K = 0, pe = 0, Ce = 0, Me = 0, Tt = 0, tr = 0, nr = 0, or = 0;
    for (K = U - 32 | 0, U = K, nr = is(C, 516), C = l + 24 | 0, Me = t[C >> 2], C = t[C + 4 >> 2], a = K + 24 | 0, t[a >> 2] = Me, t[a + 4 >> 2] = C, a = l + 16 | 0, n = t[a + 4 >> 2], b = K + 16 | 0, t[b >> 2] = t[a >> 2], t[b + 4 >> 2] = n, a = l + 8 | 0, n = t[a + 4 >> 2], b = K + 8 | 0, t[b >> 2] = t[a >> 2], t[b + 4 >> 2] = n, a = t[l + 4 >> 2], t[K >> 2] = t[l >> 2], t[K + 4 >> 2] = a, pe = 1, a = C, (C | 0) < 0 && (n = t[K >> 2] ^ -1, b = n - 801750718 | 0, P = t[K + 4 >> 2] ^ -1, l = P - ((n >>> 0 < 801750718) + 1076732275 | 0) | 0, t[K >> 2] = b, t[K + 4 >> 2] = l, l = (l | 0) == (P | 0) & n >>> 0 > b >>> 0 | l >>> 0 < P >>> 0, C = K, b = t[C + 8 >> 2] ^ -1, l = l + b | 0, P = t[C + 12 >> 2] ^ -1, n = P, Ce = l - 1354194885 | 0, t[C + 8 >> 2] = Ce, n = l >>> 0 < b >>> 0 ? n + 1 | 0 : n, pe = n - ((l >>> 0 < 1354194885) + 1162945305 | 0) | 0, t[C + 12 >> 2] = pe, P = (n | 0) == (P | 0) & l >>> 0 < b >>> 0 | n >>> 0 < P >>> 0, b = (n | 0) == (pe | 0) & l >>> 0 > Ce >>> 0 | n >>> 0 > pe >>> 0, l = P + b | 0, P = t[C + 20 >> 2] ^ -1, n = P + (l >>> 0 < b >>> 0) | 0, b = t[C + 16 >> 2] ^ -1, l = b + l | 0, Ce = l - 2 | 0, t[C + 16 >> 2] = Ce, n = l >>> 0 < b >>> 0 ? n + 1 | 0 : n, pe = n - (l >>> 0 < 2) | 0, t[C + 20 >> 2] = pe, C = (n | 0) == (P | 0) & l >>> 0 < b >>> 0 | n >>> 0 < P >>> 0, n = (n | 0) == (pe | 0) & l >>> 0 > Ce >>> 0 | n >>> 0 > pe >>> 0, C = C + n | 0, l = C >>> 0 < n >>> 0, n = C - Me | 0, t[K + 24 >> 2] = n - 2, t[K + 28 >> 2] = (l - ((C >>> 0 < Me >>> 0) + a | 0) | 0) - (n >>> 0 < 2), pe = -1), or = w - 1 | 0, Me = -1, l = 0; ; ) {
      n = l >>> 6 | 0, tr = n << 3, a = tr + K | 0, C = t[a >> 2], b = t[a + 4 >> 2], P = l & 63, a = P & 31, P >>> 0 >= 32 ? a = b >>> a | 0 : a = ((1 << a) - 1 & b) << 32 - a | C >>> a;
      e: {
        if ((Tt | 0) == (a & 1)) {
          C = l + 1 | 0;
          break e;
        }
        C = 129 - l | 0, Ce = (C | 0) < (w | 0) ? C : w, C = Ce + l | 0, (n | 0) != (C - 1 >>> 6 | 0) && (n = (K + tr | 0) + 8 | 0, Me = t[n >> 2], n = 64 - P | 0, P = n & 31, a = ((n & 63) >>> 0 < 32 ? Me << P : 0) | a), n = Ce & 31, a = Tt + (a & (((Ce & 63) >>> 0 < 32 ? -1 << n : 0) ^ -1)) | 0, Tt = a >>> or & 1, t[nr + (l << 2) >> 2] = B(a - (Tt << w) | 0, pe), Me = l;
      }
      if (l = C, !((l | 0) < 129))
        break;
    }
    return U = K + 32 | 0, Me + 1 | 0;
  }
  function _i(C, l, w) {
    var n = 0, a = 0, b = 0, P = 0, K = 0, pe = 0, Ce = 0, Me = 0, Tt = 0, tr = 0, nr = 0, or = 0;
    e: {
      if ((w | 0) > 0) {
        n = l + ((w << 5) - 32 & -64) | 0, l = t[n >> 2], w = t[n + 4 >> 2] & 1048575, t[C >> 2] = l, t[C + 4 >> 2] = w, l = t[n + 8 >> 2], w = t[n + 12 >> 2] << 12 | l >>> 20, t[C + 8 >> 2] = l << 12 & -4096 | t[n + 4 >> 2] >>> 20, t[C + 12 >> 2] = w & 1048575, l = t[n + 16 >> 2], w = t[n + 20 >> 2] << 24 | l >>> 8, t[C + 16 >> 2] = l << 24 & -16777216 | t[n + 12 >> 2] >>> 8, t[C + 20 >> 2] = w & 1048575, a = t[n + 24 >> 2] << 4 & 1048560, w = t[n + 20 >> 2], l = w >>> 28 | 0, t[C + 24 >> 2] = (w & 268435455) << 4 | t[n + 16 >> 2] >>> 28, t[C + 28 >> 2] = l | a, l = t[n + 28 >> 2], w = l >>> 16 | 0, t[C + 32 >> 2] = (l & 65535) << 16 | t[n + 24 >> 2] >>> 16, t[C + 36 >> 2] = w, l = t[n + 36 >> 2] & 1048575, t[C + 40 >> 2] = t[n + 32 >> 2], t[C + 44 >> 2] = l, a = n + 40 | 0, l = t[a >> 2], w = t[a + 4 >> 2] << 12 | l >>> 20, b = C + 48 | 0, t[b >> 2] = l << 12 & -4096 | t[n + 36 >> 2] >>> 20, t[b + 4 >> 2] = w & 1048575, b = n + 48 | 0, l = t[b >> 2], w = t[b + 4 >> 2] << 24 | l >>> 8, P = C + 56 | 0, t[P >> 2] = l << 24 & -16777216 | t[a + 4 >> 2] >>> 8, t[P + 4 >> 2] = w & 1048575, n = n + 56 | 0, l = t[n >> 2], P = l << 4 & 1048560, w = t[b + 4 >> 2], l = w >>> 28 | 0, a = C - -64 | 0, t[a >> 2] = (w & 268435455) << 4 | t[b >> 2] >>> 28, t[a + 4 >> 2] = l | P, l = C + 72 | 0, a = t[n + 4 >> 2], t[l >> 2] = (a & 65535) << 16 | t[n >> 2] >>> 16, t[l + 4 >> 2] = a >>> 16;
        break e;
      }
      n = l + ((w ^ -1) / 2 << 6) | 0, l = t[n >> 2], w = t[n + 4 >> 2] & 1048575, t[C >> 2] = l, t[C + 4 >> 2] = w, l = t[n + 8 >> 2], w = t[n + 12 >> 2] << 12 | l >>> 20, t[C + 8 >> 2] = l << 12 & -4096 | t[n + 4 >> 2] >>> 20, t[C + 12 >> 2] = w & 1048575, l = t[n + 16 >> 2], w = t[n + 20 >> 2] << 24 | l >>> 8, t[C + 16 >> 2] = l << 24 & -16777216 | t[n + 12 >> 2] >>> 8, t[C + 20 >> 2] = w & 1048575, a = t[n + 24 >> 2] << 4 & 1048560, w = t[n + 20 >> 2], l = w >>> 28 | 0, t[C + 24 >> 2] = (w & 268435455) << 4 | t[n + 16 >> 2] >>> 28, t[C + 28 >> 2] = l | a, l = t[n + 28 >> 2], w = l >>> 16 | 0, t[C + 32 >> 2] = (l & 65535) << 16 | t[n + 24 >> 2] >>> 16, t[C + 36 >> 2] = w, P = t[n + 36 >> 2] & 1048575, Ce = t[n + 32 >> 2], t[C + 40 >> 2] = Ce, t[C + 44 >> 2] = P, a = n + 40 | 0, l = t[a >> 2], w = t[a + 4 >> 2] << 12 | l >>> 20, Me = C + 48 | 0, b = Me, Tt = l << 12 & -4096 | t[n + 36 >> 2] >>> 20, t[b >> 2] = Tt, nr = w & 1048575, t[b + 4 >> 2] = nr, b = n + 48 | 0, l = t[b >> 2], w = t[b + 4 >> 2] << 24 | l >>> 8, K = C + 56 | 0, a = l << 24 & -16777216 | t[a + 4 >> 2] >>> 8, t[K >> 2] = a, or = w & 1048575, t[K + 4 >> 2] = or, n = n + 56 | 0, l = t[n >> 2], tr = l << 4 & 1048560, w = t[b + 4 >> 2], l = w >>> 28 | 0, pe = C - -64 | 0, w = (w & 268435455) << 4 | t[b >> 2] >>> 28, t[pe >> 2] = w, b = l | tr, t[pe + 4 >> 2] = b, tr = t[n >> 2], l = t[n + 4 >> 2], t[pe >> 2] = -4 - w, t[pe + 4 >> 2] = 4194303 - ((w >>> 0 > 4294967292) + b | 0), t[K >> 2] = -4 - a, t[K + 4 >> 2] = 4194303 - ((a >>> 0 > 4294967292) + or | 0), t[Me >> 2] = -4 - Tt, t[Me + 4 >> 2] = 4194303 - ((Tt >>> 0 > 4294967292) + nr | 0), t[C + 40 >> 2] = -3908 - Ce, t[C + 44 >> 2] = 4194299 - ((Ce >>> 0 > 4294963388) + P | 0), n = l >>> 16 | 0, w = C + 72 | 0, l = (l & 65535) << 16 | tr >>> 16, t[w >> 2] = -4 - l, t[w + 4 >> 2] = 262143 - ((l >>> 0 > 4294967292) + n | 0);
    }
    t[C + 80 >> 2] = 0;
  }
  function Tn(C, l, w, n) {
    var a = 0, b = 0, P = 0, K = 0, pe = 0, Ce = 0, Me = 0, Tt = 0, tr = 0, nr = 0, or = 0, lr = 0, gr = 0, kr = 0, Nr = 0, jr = 0, Yr = 0, ei = 0, ai = 0, ui = 0, di = 0, Ii = 0, wi = 0, Ei = 0, Ti = 0, Di = 0, Qi = 0, Li = 0, Ki = 0, Wi = 0, Xi = 0, $i = 0, In = 0, kn = 0, Dn = 0, Mn = 0, zn = 0, es = 0, ns = 0, fs = 0, ps = 0, Es = 0, Ss = 0;
    P = U - 1120 | 0, U = P;
    e: {
      if (t[l + 120 >> 2]) {
        t[C + 120 >> 2] = t[w + 80 >> 2], a = P + 1080 | 0, Wn(a, n), l = P + 1040 | 0, zr(l, a, n), zr(C, w, a), zr(C + 40 | 0, w + 40 | 0, l), l = C + 88 | 0, t[l >> 2] = 0, t[l + 4 >> 2] = 0, t[C + 80 >> 2] = 1, t[C + 84 >> 2] = 0, l = C + 96 | 0, t[l >> 2] = 0, t[l + 4 >> 2] = 0, l = C + 104 | 0, t[l >> 2] = 0, t[l + 4 >> 2] = 0, C = C + 112 | 0, t[C >> 2] = 0, t[C + 4 >> 2] = 0;
        break e;
      }
      if (t[w + 80 >> 2]) {
        as(C, l, 128);
        break e;
      }
      ps = P + 1080 | 0, Es = l + 80 | 0, zr(ps, Es, n), n = t[P + 1084 >> 2], lr = n, tr = t[P + 1080 >> 2], a = tr, n = n << 1 | a >>> 31, nr = P + 408 | 0, ei = t[P + 1104 >> 2], jr = t[P + 1108 >> 2], ai = a << 1, Ei = n, Pr(nr, ei, jr, 0, 0, ai, n, 0, 0), n = t[P + 1092 >> 2], ns = n, es = t[P + 1088 >> 2], b = es, n = n << 1 | b >>> 31, Ce = P + 616 | 0, Nr = t[P + 1096 >> 2], kr = t[P + 1100 >> 2], b = b << 1, pe = n, Pr(Ce, Nr, kr, 0, 0, b, n, 0, 0), or = P + 568 | 0, a = t[P + 1112 >> 2], n = t[P + 1116 >> 2], Pr(or, a, n, 0, 0, a, n, 0, 0), Me = P + 552 | 0, Pr(Me, t[P + 568 >> 2], t[P + 572 >> 2], 0, 0, 15632, 16, 0, 0), n = n << 1 | a >>> 31, kn = P + 520 | 0, Ti = a << 1, Yr = n, Pr(kn, Ti, n, 0, 0, tr, lr, 0, 0), Ki = P + 424 | 0, Pr(Ki, ei, jr, 0, 0, b, pe, 0, 0), Qi = P + 600 | 0, Pr(Qi, Nr, kr, 0, 0, Nr, kr, 0, 0), Tt = P + 536 | 0, n = or + 8 | 0, Pr(Tt, t[n >> 2], t[n + 4 >> 2], 0, 0, 64028672, 65536, 0, 0), Mn = P + 664 | 0, Pr(Mn, tr, lr, 0, 0, tr, lr, 0, 0), Dn = P + 504 | 0, Pr(Dn, Ti, Yr, 0, 0, es, ns, 0, 0), $i = P + 440 | 0, Pr($i, ei, jr, 0, 0, Nr << 1, kr << 1 | Nr >>> 31, 0, 0), lr = t[P + 412 >> 2], n = lr + t[P + 620 >> 2] | 0, K = t[P + 408 >> 2], b = t[P + 616 >> 2], a = K + b | 0, pe = t[P + 552 >> 2], Ii = a + pe | 0, b = a >>> 0 < b >>> 0 ? n + 1 | 0 : n, n = b + t[P + 556 >> 2] | 0, pe = pe >>> 0 > Ii >>> 0 ? n + 1 | 0 : n, tr = (b | 0) == (pe | 0) & a >>> 0 > Ii >>> 0 | b >>> 0 > pe >>> 0, n = Me + 8 | 0, or = t[n >> 2], Me = t[n + 4 >> 2], K = (b | 0) == (lr | 0) & a >>> 0 < K >>> 0 | b >>> 0 < lr >>> 0, b = Ce + 8 | 0, a = t[b >> 2], n = nr + 8 | 0, Ce = a + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[b + 4 >> 2] | 0, n = a >>> 0 > Ce >>> 0 ? n + 1 | 0 : n, a = K + Ce | 0, n = (a >>> 0 < Ce >>> 0 ? n + 1 | 0 : n) + Me | 0, b = a, a = a + or | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, b = a, a = a + tr | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, Wi = pe, or = a << 12 | pe >>> 20, b = n, K = n << 12 | a >>> 20, Di = t[P + 424 >> 2], a = t[P + 600 >> 2], tr = Di + a | 0, In = t[P + 428 >> 2], n = In + t[P + 604 >> 2] | 0, n = a >>> 0 > tr >>> 0 ? n + 1 | 0 : n, a = t[P + 520 >> 2], Me = a + tr | 0, nr = n, n = n + t[P + 524 >> 2] | 0, n = a >>> 0 > Me >>> 0 ? n + 1 | 0 : n, a = t[P + 536 >> 2], pe = a + Me | 0, Ce = n, n = n + t[P + 540 >> 2] | 0, a = a >>> 0 > pe >>> 0 ? n + 1 | 0 : n, n = a + K | 0, Xi = P + 344 | 0, Li = Xi, or = pe + or | 0, K = or >>> 0 < pe >>> 0 ? n + 1 | 0 : n, wi = (a | 0) == (K | 0) & pe >>> 0 > or >>> 0 | a >>> 0 > K >>> 0, ui = (a | 0) == (Ce | 0) & pe >>> 0 < Me >>> 0 | a >>> 0 < Ce >>> 0, n = Tt + 8 | 0, di = t[n >> 2], gr = t[n + 4 >> 2], lr = (Ce | 0) == (nr | 0) & tr >>> 0 > Me >>> 0 | Ce >>> 0 < nr >>> 0, n = kn + 8 | 0, Tt = t[n >> 2], Ce = t[n + 4 >> 2], Me = (nr | 0) == (In | 0) & tr >>> 0 < Di >>> 0 | nr >>> 0 < In >>> 0, pe = Qi + 8 | 0, a = t[pe >> 2], n = Ki + 8 | 0, tr = a + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[pe + 4 >> 2] | 0, n = a >>> 0 > tr >>> 0 ? n + 1 | 0 : n, a = tr + Me | 0, n = (a >>> 0 < tr >>> 0 ? n + 1 | 0 : n) + Ce | 0, pe = a, a = a + Tt | 0, n = pe >>> 0 > a >>> 0 ? n + 1 | 0 : n, pe = a, a = a + lr | 0, n = (pe >>> 0 > a >>> 0 ? n + 1 | 0 : n) + gr | 0, pe = a, a = a + di | 0, n = pe >>> 0 > a >>> 0 ? n + 1 | 0 : n, pe = a + ui | 0, n = pe >>> 0 < a >>> 0 ? n + 1 | 0 : n, b = b >>> 20 | 0, a = b + pe | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, b = a, a = a + wi | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, b = K, Me = a << 12 | b >>> 20, pe = n, K = n << 12 | a >>> 20, lr = t[P + 504 >> 2], a = t[P + 440 >> 2], nr = lr + a | 0, ui = t[P + 508 >> 2], n = ui + t[P + 444 >> 2] | 0, a = a >>> 0 > nr >>> 0 ? n + 1 | 0 : n, n = a + K | 0, Me = Me + nr | 0, n = Me >>> 0 < nr >>> 0 ? n + 1 | 0 : n, Ce = Me << 4 & -16, K = n, tr = (n << 4 | Me >>> 28) & 16777215, gr = b, Pr(Li, Ce | b >>> 16 & 15, tr, 0, 0, 977, 1, 0, 0), b = l + 8 | 0, n = t[b + 4 >> 2], tr = P + 1e3 | 0, Qi = tr + 8 | 0, t[Qi >> 2] = t[b >> 2], t[Qi + 4 >> 2] = n, b = l + 16 | 0, n = t[b + 4 >> 2], Di = tr + 16 | 0, t[Di >> 2] = t[b >> 2], t[Di + 4 >> 2] = n, b = l + 24 | 0, n = t[b + 4 >> 2], Li = tr + 24 | 0, t[Li >> 2] = t[b >> 2], t[Li + 4 >> 2] = n, b = l + 32 | 0, n = t[b + 4 >> 2], wi = tr + 32 | 0, t[wi >> 2] = t[b >> 2], t[wi + 4 >> 2] = n, n = t[l + 4 >> 2], t[P + 1e3 >> 2] = t[l >> 2], t[P + 1004 >> 2] = n, fs = t[P + 348 >> 2], n = fs + t[P + 668 >> 2] | 0, Ki = t[P + 344 >> 2], b = t[P + 664 >> 2], Ce = Ki + b | 0, t[P + 1040 >> 2] = Ce, b = b >>> 0 > Ce >>> 0 ? n + 1 | 0 : n, t[P + 1044 >> 2] = b & 1048575, Ss = P + 648 | 0, Pr(Ss, es, ns, 0, 0, ai, Ei, 0, 0), zn = P + 488 | 0, Pr(zn, Ti, Yr, 0, 0, Nr, kr, 0, 0), In = P + 456 | 0, Pr(In, ei, jr, 0, 0, ei, jr, 0, 0), kn = P + 392 | 0, di = kn, Tt = (a | 0) == (K | 0) & Me >>> 0 < nr >>> 0 | a >>> 0 > K >>> 0, nr = (a | 0) == (ui | 0) & nr >>> 0 < lr >>> 0 | a >>> 0 < ui >>> 0, Me = $i + 8 | 0, a = t[Me >> 2], n = Dn + 8 | 0, lr = a + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[Me + 4 >> 2] | 0, n = a >>> 0 > lr >>> 0 ? n + 1 | 0 : n, Me = nr + lr | 0, n = Me >>> 0 < lr >>> 0 ? n + 1 | 0 : n, pe = pe >>> 20 | 0, a = pe + Me | 0, n = pe >>> 0 > a >>> 0 ? n + 1 | 0 : n, pe = a, a = a + Tt | 0, n = pe >>> 0 > a >>> 0 ? n + 1 | 0 : n, nr = a << 12 | K >>> 20, Me = n, K = n << 12 | a >>> 20, tr = t[P + 492 >> 2], n = tr + t[P + 460 >> 2] | 0, Dn = t[P + 488 >> 2], pe = t[P + 456 >> 2], a = Dn + pe | 0, ui = a, lr = a + nr | 0, pe = a >>> 0 < pe >>> 0 ? n + 1 | 0 : n, n = pe + K | 0, nr = lr >>> 0 < a >>> 0 ? n + 1 | 0 : n, Pr(di, lr, nr & 1048575, 0, 0, 15632, 16, 0, 0), Ce = (b | 0) == (fs | 0) & Ce >>> 0 < Ki >>> 0 | b >>> 0 < fs >>> 0, K = Mn + 8 | 0, a = t[K >> 2], n = Xi + 8 | 0, Tt = a + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[K + 4 >> 2] | 0, n = a >>> 0 > Tt >>> 0 ? n + 1 | 0 : n, a = Ce + Tt | 0, n = a >>> 0 < Tt >>> 0 ? n + 1 | 0 : n, Tt = a << 12 | b >>> 20, K = n, Ce = n << 12 | a >>> 20, Mn = t[P + 396 >> 2], n = Mn + t[P + 652 >> 2] | 0, $i = t[P + 392 >> 2], b = t[P + 648 >> 2], a = $i + b | 0, di = a, Tt = a + Tt | 0, b = a >>> 0 < b >>> 0 ? n + 1 | 0 : n, n = b + Ce | 0, t[P + 1048 >> 2] = Tt, Ce = Tt >>> 0 < a >>> 0 ? n + 1 | 0 : n, t[P + 1052 >> 2] = Ce & 1048575, Xi = P + 584 | 0, Pr(Xi, Nr, kr, 0, 0, ai, Ei, 0, 0), Ki = P + 632 | 0, Pr(Ki, es, ns, 0, 0, es, ns, 0, 0), Ei = P + 472 | 0, Pr(Ei, Ti, Yr, 0, 0, ei, jr, 0, 0), ai = P + 376 | 0, jr = ai, kr = (pe | 0) == (nr | 0) & lr >>> 0 < ui >>> 0 | pe >>> 0 > nr >>> 0, lr = (pe | 0) == (tr | 0) & ui >>> 0 < Dn >>> 0 | pe >>> 0 < tr >>> 0, pe = In + 8 | 0, a = t[pe >> 2], n = zn + 8 | 0, ei = a + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[pe + 4 >> 2] | 0, n = a >>> 0 > ei >>> 0 ? n + 1 | 0 : n, pe = lr + ei | 0, n = pe >>> 0 < ei >>> 0 ? n + 1 | 0 : n, Me = Me >>> 20 | 0, a = pe + Me | 0, n = Me >>> 0 > a >>> 0 ? n + 1 | 0 : n, pe = a, a = a + kr | 0, n = pe >>> 0 > a >>> 0 ? n + 1 | 0 : n, Yr = a << 12 | nr >>> 20, Me = t[P + 472 >> 2], nr = Yr + Me | 0, pe = n, ui = n << 12 | a >>> 20, n = ui + t[P + 476 >> 2] | 0, lr = Me >>> 0 > nr >>> 0 ? n + 1 | 0 : n, Pr(jr, nr, lr, 0, 0, 15632, 16, 0, 0), Tt = (b | 0) == (Ce | 0) & Tt >>> 0 < di >>> 0 | b >>> 0 > Ce >>> 0, tr = (b | 0) == (Mn | 0) & di >>> 0 < $i >>> 0 | b >>> 0 < Mn >>> 0, b = Ss + 8 | 0, a = t[b >> 2], n = kn + 8 | 0, kr = a + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[b + 4 >> 2] | 0, n = a >>> 0 > kr >>> 0 ? n + 1 | 0 : n, b = tr + kr | 0, n = b >>> 0 < kr >>> 0 ? n + 1 | 0 : n, K = K >>> 20 | 0, a = b + K | 0, n = K >>> 0 > a >>> 0 ? n + 1 | 0 : n, b = a, a = a + Tt | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, tr = a << 12 | Ce >>> 20, b = n, jr = n << 12 | a >>> 20, Nr = t[P + 584 >> 2], a = t[P + 632 >> 2], Ce = Nr + a | 0, di = t[P + 588 >> 2], n = di + t[P + 636 >> 2] | 0, kr = a >>> 0 > Ce >>> 0 ? n + 1 | 0 : n, n = kr + t[P + 380 >> 2] | 0, a = t[P + 376 >> 2], K = a + Ce | 0, Tt = K, tr = K + tr | 0, a = a >>> 0 > K >>> 0 ? n + 1 | 0 : n, n = a + jr | 0, t[P + 1056 >> 2] = tr, K = tr >>> 0 < K >>> 0 ? n + 1 | 0 : n, t[P + 1060 >> 2] = K & 1048575, ei = P + 360 | 0, jr = (lr | 0) == (ui | 0) & nr >>> 0 < Yr >>> 0 | lr >>> 0 < ui >>> 0, n = Ei + 8 | 0, lr = t[n >> 2], n = t[n + 4 >> 2], pe = pe >>> 20 | 0, Me = pe, pe = pe + lr | 0, n = Me >>> 0 > pe >>> 0 ? n + 1 | 0 : n, Me = pe, pe = pe + jr | 0, n = Me >>> 0 > pe >>> 0 ? n + 1 | 0 : n, Pr(ei, pe, n, 0, 0, 64028672, 65536, 0, 0), jr = (a | 0) == (K | 0) & tr >>> 0 < Tt >>> 0 | a >>> 0 > K >>> 0, lr = (a | 0) == (kr | 0) & Ce >>> 0 > Tt >>> 0 | a >>> 0 < kr >>> 0, n = ai + 8 | 0, Tt = t[n >> 2], nr = t[n + 4 >> 2], tr = (kr | 0) == (di | 0) & Ce >>> 0 < Nr >>> 0 | kr >>> 0 < di >>> 0, Me = Ki + 8 | 0, a = t[Me >> 2], n = Xi + 8 | 0, Ce = a + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[Me + 4 >> 2] | 0, n = a >>> 0 > Ce >>> 0 ? n + 1 | 0 : n, a = Ce + tr | 0, n = (a >>> 0 < Ce >>> 0 ? n + 1 | 0 : n) + nr | 0, pe = a, a = a + Tt | 0, n = pe >>> 0 > a >>> 0 ? n + 1 | 0 : n, Me = a + lr | 0, n = Me >>> 0 < a >>> 0 ? n + 1 | 0 : n, b = b >>> 20 | 0, a = b + Me | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, b = a, a = a + jr | 0, n = b >>> 0 > a >>> 0 ? n + 1 | 0 : n, Me = a << 12 | K >>> 20, b = n, Ce = n << 12 | a >>> 20, Tt = t[P + 360 >> 2], K = Ii & -2, a = Tt + K | 0, lr = t[P + 364 >> 2], n = lr + (Wi & 1048575) | 0, tr = a >>> 0 < K >>> 0 ? n + 1 | 0 : n, n = tr + Ce | 0, pe = Me, Me = a, K = pe + a | 0, t[P + 1064 >> 2] = K, a = a >>> 0 > K >>> 0 ? n + 1 | 0 : n, t[P + 1068 >> 2] = a & 1048575, nr = gr & 65535, Ce = (a | 0) == (tr | 0) & K >>> 0 < Me >>> 0 | a >>> 0 < tr >>> 0, K = (tr | 0) == (lr | 0) & Me >>> 0 < Tt >>> 0 | tr >>> 0 < lr >>> 0, n = ei + 8 | 0, Me = K + t[n >> 2] | 0, n = t[n + 4 >> 2], n = K >>> 0 > Me >>> 0 ? n + 1 | 0 : n, b = b >>> 20 | 0, pe = b, b = b + Me | 0, n = pe >>> 0 > b >>> 0 ? n + 1 | 0 : n, pe = b, b = b + Ce | 0, n = pe >>> 0 > b >>> 0 ? n + 1 | 0 : n, a = b << 12 | a >>> 20, K = a + or | 0, n = nr + (n << 12 | b >>> 20) | 0, t[P + 1072 >> 2] = K, t[P + 1076 >> 2] = a >>> 0 > K >>> 0 ? n + 1 | 0 : n, or = Qi, Ce = t[or >> 2], tr = t[or + 4 >> 2], Me = t[P + 1004 >> 2], K = t[wi >> 2], a = t[wi + 4 >> 2], Tt = a, n = t[P + 1e3 >> 2], b = ri(a >>> 16 | 0, 0, 977, 1), a = n + b | 0, n = Me + ve | 0, Me = a >>> 0 < b >>> 0 ? n + 1 | 0 : n, n = tr, b = Me >>> 20 | 0, pe = b, b = b + Ce | 0, n = pe >>> 0 > b >>> 0 ? n + 1 | 0 : n, lr = b, t[or >> 2] = b, Qi = n & 1048575, t[or + 4 >> 2] = Qi, or = Di, Ce = t[or >> 2], b = n, n = t[or + 4 >> 2], b = b >>> 20 | 0, pe = b, b = b + Ce | 0, n = pe >>> 0 > b >>> 0 ? n + 1 | 0 : n, nr = b, t[or >> 2] = b, Di = n & 1048575, t[or + 4 >> 2] = Di, or = Li, Ce = t[or >> 2], b = n, n = t[or + 4 >> 2], b = b >>> 20 | 0, pe = b, b = b + Ce | 0, n = pe >>> 0 > b >>> 0 ? n + 1 | 0 : n, Ce = b, t[or >> 2] = b, Li = n & 1048575, t[or + 4 >> 2] = Li, or = wi, b = n, n = Tt & 65535, b = b >>> 20 | 0, pe = b, b = b + K | 0, n = pe >>> 0 > b >>> 0 ? n + 1 | 0 : n, ei = b, t[or >> 2] = b, Wi = n, t[or + 4 >> 2] = n, or = a, t[P + 1e3 >> 2] = a, wi = Me & 1048575, t[P + 1004 >> 2] = wi, Ti = P + 1040 | 0, zr(P + 960 | 0, w, Ti), kr = P + 920 | 0, Ii = kr + 8 | 0, n = l + 48 | 0, Tt = t[n >> 2], tr = t[n + 4 >> 2], Me = t[l + 44 >> 2], n = l + 72 | 0, K = t[n >> 2], a = t[n + 4 >> 2], gr = a, n = t[l + 40 >> 2], b = ri(a >>> 16 | 0, 0, 977, 1), a = n + b | 0, n = Me + ve | 0, Me = a >>> 0 < b >>> 0 ? n + 1 | 0 : n, n = tr, b = Me >>> 20 | 0, pe = b, b = b + Tt | 0, n = pe >>> 0 > b >>> 0 ? n + 1 | 0 : n, Yr = b, t[Ii >> 2] = b, ui = n & 1048575, t[Ii + 4 >> 2] = ui, Ii = kr + 16 | 0, b = l + 56 | 0, Tt = t[b >> 2], tr = t[b + 4 >> 2], b = n, n = tr, b = b >>> 20 | 0, pe = b, b = b + Tt | 0, n = pe >>> 0 > b >>> 0 ? n + 1 | 0 : n, Nr = b, t[Ii >> 2] = b, di = n & 1048575, t[Ii + 4 >> 2] = di, Ii = kr + 24 | 0, b = l - -64 | 0, Tt = t[b >> 2], tr = t[b + 4 >> 2], b = n, n = tr, b = b >>> 20 | 0, pe = b, b = b + Tt | 0, n = pe >>> 0 > b >>> 0 ? n + 1 | 0 : n, jr = b, t[Ii >> 2] = b, Ei = n & 1048575, t[Ii + 4 >> 2] = Ei, Tt = kr + 32 | 0, b = n, n = gr & 65535, b = b >>> 20 | 0, K = b + K | 0, n = b >>> 0 > K >>> 0 ? n + 1 | 0 : n, kr = K, t[Tt >> 2] = K, b = n, t[Tt + 4 >> 2] = n, Ii = a, t[P + 920 >> 2] = a, ai = Me & 1048575, t[P + 924 >> 2] = ai, n = P + 880 | 0, zr(n, w + 40 | 0, Ti), zr(n, n, ps), a = P, w = t[a + 960 >> 2], tr = (w - or | 0) - 3908 | 0, n = (t[a + 964 >> 2] - ((w >>> 0 < or >>> 0) + wi | 0) | 0) + 4194299 | 0, t[a + 840 >> 2] = tr, Me = tr >>> 0 < 4294963388 ? n + 1 | 0 : n, t[a + 844 >> 2] = Me, w = t[a + 968 >> 2], Tt = (w - lr | 0) - 4 | 0, n = (t[a + 972 >> 2] - ((w >>> 0 < lr >>> 0) + Qi | 0) | 0) + 4194303 | 0, t[a + 848 >> 2] = Tt, or = Tt >>> 0 < 4294967292 ? n + 1 | 0 : n, t[a + 852 >> 2] = or, w = t[a + 976 >> 2], gr = (w - nr | 0) - 4 | 0, n = (t[a + 980 >> 2] - ((w >>> 0 < nr >>> 0) + Di | 0) | 0) + 4194303 | 0, t[a + 856 >> 2] = gr, nr = gr >>> 0 < 4294967292 ? n + 1 | 0 : n, t[a + 860 >> 2] = nr, w = t[a + 984 >> 2], lr = (w - Ce | 0) - 4 | 0, n = (t[a + 988 >> 2] - ((w >>> 0 < Ce >>> 0) + Li | 0) | 0) + 4194303 | 0, t[a + 864 >> 2] = lr, Ce = lr >>> 0 < 4294967292 ? n + 1 | 0 : n, t[a + 868 >> 2] = Ce, n = t[a + 992 >> 2], w = (n - ei | 0) - 4 | 0, n = (t[a + 996 >> 2] - ((n >>> 0 < ei >>> 0) + Wi | 0) | 0) + 262143 | 0, t[a + 872 >> 2] = w, K = w >>> 0 < 4294967292 ? n + 1 | 0 : n, t[a + 876 >> 2] = K, n = t[a + 912 >> 2], Wi = (kr - n | 0) - 4 | 0, n = (b - (t[a + 916 >> 2] + (n >>> 0 > kr >>> 0) | 0) | 0) + 262143 | 0, b = Wi, t[a + 832 >> 2] = b, pe = b >>> 0 < 4294967292 ? n + 1 | 0 : n, t[a + 836 >> 2] = pe, n = t[a + 904 >> 2], Di = (jr - n | 0) - 4 | 0, n = (Ei - (t[a + 908 >> 2] + (n >>> 0 > jr >>> 0) | 0) | 0) + 4194303 | 0, t[a + 824 >> 2] = Di, ei = Di >>> 0 < 4294967292 ? n + 1 | 0 : n, t[a + 828 >> 2] = ei, n = t[a + 896 >> 2], Li = (Nr - n | 0) - 4 | 0, n = (di - (t[a + 900 >> 2] + (n >>> 0 > Nr >>> 0) | 0) | 0) + 4194303 | 0, t[a + 816 >> 2] = Li, jr = Li >>> 0 < 4294967292 ? n + 1 | 0 : n, t[a + 820 >> 2] = jr, n = t[a + 888 >> 2], wi = (Yr - n | 0) - 4 | 0, n = (ui - (t[a + 892 >> 2] + (n >>> 0 > Yr >>> 0) | 0) | 0) + 4194303 | 0, t[a + 808 >> 2] = wi, kr = wi >>> 0 < 4294967292 ? n + 1 | 0 : n, t[a + 812 >> 2] = kr, n = t[a + 880 >> 2], Ti = (Ii - n | 0) - 3908 | 0, n = (ai - (t[a + 884 >> 2] + (n >>> 0 > Ii >>> 0) | 0) | 0) + 4194299 | 0, t[a + 800 >> 2] = Ti, Ii = Ti >>> 0 < 4294963388 ? n + 1 | 0 : n, t[a + 804 >> 2] = Ii, a = ri(K >>> 16 | 0, 0, 977, 1) + tr | 0, n = ve + Me | 0, n = a >>> 0 < tr >>> 0 ? n + 1 | 0 : n, Nr = n & 1048575, $i = Nr;
      t: {
        if (Wi = a, Xi = a ^ 976, Ki = Nr ^ 1, ((Xi | 0) != -1 | (Ki | 0) != 1048575) & (a | Nr) != 0 || (Qi = K & 65535, a = n, n = or, a = (a >>> 20 | 0) + Tt | 0, n = a >>> 0 < Tt >>> 0 ? n + 1 | 0 : n, ui = a, di = n, n = nr, a = (di >>> 20 | 0) + gr | 0, n = a >>> 0 < gr >>> 0 ? n + 1 | 0 : n, Ei = a, ai = n, n = Ce, a = (ai >>> 20 | 0) + lr | 0, n = a >>> 0 < lr >>> 0 ? n + 1 | 0 : n, Yr = a, Nr = n, n = Qi, a = Nr >>> 20 | 0, Qi = a, a = w + a | 0, n = Qi >>> 0 > a >>> 0 ? n + 1 | 0 : n, a | (Yr | (Ei | (ui | Wi))) | (n | (Nr & 1048575 | (ai & 1048575 | (di & 1048575 | $i)))) && ((ui & Xi & Ei & Yr & a) != -1 ? n = 1 : n = (di & Ki & ai & Nr & (n ^ 983040)) != 1048575, n)))
          break t;
        w = ri(pe >>> 16 | 0, 0, 977, 1) + Ti | 0, n = ve + Ii | 0, n = w >>> 0 < Ti >>> 0 ? n + 1 | 0 : n, K = n & 1048575, gr = K;
        r: {
          if (a = w, lr = a ^ 976, Tt = K ^ 1, ((lr | 0) != -1 | (Tt | 0) != 1048575) & (a | K) != 0 || (nr = pe & 65535, w = n, n = kr, w = (w >>> 20 | 0) + wi | 0, n = w >>> 0 < wi >>> 0 ? n + 1 | 0 : n, Ce = w, tr = n, n = jr, w = (tr >>> 20 | 0) + Li | 0, n = w >>> 0 < Li >>> 0 ? n + 1 | 0 : n, or = w, Me = n, n = ei, w = (Me >>> 20 | 0) + Di | 0, n = w >>> 0 < Di >>> 0 ? n + 1 | 0 : n, K = w, pe = n, n = nr, w = pe >>> 20 | 0, nr = w, w = w + b | 0, n = nr >>> 0 > w >>> 0 ? n + 1 | 0 : n, w | (K | (or | (a | Ce))) | (n | (pe & 1048575 | (Me & 1048575 | (tr & 1048575 | gr)))) && ((Ce & lr & or & K & w) != -1 ? w = 1 : w = (tr & Tt & Me & pe & (n ^ 983040)) != 1048575, w)))
            break r;
          if (t[l + 120 >> 2]) {
            t[C + 120 >> 2] = 1, is(C, 120);
            break e;
          }
          Gn(C, l);
          break e;
        }
        t[C + 120 >> 2] = 1, is(C, 120);
        break e;
      }
      t[C + 120 >> 2] = 0, In = P + 840 | 0, zr(C + 80 | 0, Es, In), Ei = P + 312 | 0, pe = lr, b = Ce, jr = tr << 1, Ce = Me, ei = Ce << 1 | tr >>> 31, Pr(Ei, pe, b, 0, 0, jr, ei, 0, 0), Yr = P + 232 | 0, a = gr, l = nr, Me = Tt << 1, lr = or, kr = Tt, or = or << 1 | Tt >>> 31, Pr(Yr, a, l, 0, 0, Me, or, 0, 0), Tt = P + 168 | 0, Pr(Tt, w, K, 0, 0, w, K, 0, 0), gr = P + 152 | 0, Pr(gr, t[P + 168 >> 2], t[P + 172 >> 2], 0, 0, 15632, 16, 0, 0), n = K << 1 | w >>> 31, kn = P + 120 | 0, Nr = w << 1, Ii = n, Pr(kn, Nr, n, 0, 0, tr, Ce, 0, 0), Dn = P + 280 | 0, Pr(Dn, pe, b, 0, 0, Me, or, 0, 0), $i = P + 216 | 0, Pr($i, a, l, 0, 0, a, l, 0, 0), ai = P + 136 | 0, w = Tt + 8 | 0, Pr(ai, t[w >> 2], t[w + 4 >> 2], 0, 0, 64028672, 65536, 0, 0), Xi = P + 328 | 0, Pr(Xi, tr, Ce, 0, 0, tr, Ce, 0, 0), Ki = P + 104 | 0, Pr(Ki, Nr, n, 0, 0, kr, lr, 0, 0), Ce = l, Wi = a, n = l << 1 | a >>> 31, Qi = P + 184 | 0, Tt = pe, nr = b, Pr(Qi, pe, b, 0, 0, a << 1, n, 0, 0), or = t[P + 316 >> 2], n = or + t[P + 236 >> 2] | 0, b = t[P + 312 >> 2], w = t[P + 232 >> 2], l = b + w | 0, a = t[P + 152 >> 2], tr = l + a | 0, w = l >>> 0 < w >>> 0 ? n + 1 | 0 : n, n = w + t[P + 156 >> 2] | 0, a = a >>> 0 > tr >>> 0 ? n + 1 | 0 : n, Me = (w | 0) == (a | 0) & l >>> 0 > tr >>> 0 | w >>> 0 > a >>> 0, n = gr + 8 | 0, K = t[n >> 2], pe = t[n + 4 >> 2], b = (w | 0) == (or | 0) & l >>> 0 < b >>> 0 | w >>> 0 < or >>> 0, n = Yr + 8 | 0, w = t[n >> 2], l = Ei + 8 | 0, or = w + t[l >> 2] | 0, n = t[l + 4 >> 2] + t[n + 4 >> 2] | 0, n = w >>> 0 > or >>> 0 ? n + 1 | 0 : n, l = b + or | 0, n = (l >>> 0 < or >>> 0 ? n + 1 | 0 : n) + pe | 0, w = l, l = l + K | 0, n = w >>> 0 > l >>> 0 ? n + 1 | 0 : n, w = l, l = l + Me | 0, n = w >>> 0 > l >>> 0 ? n + 1 | 0 : n, Me = a, pe = l << 12 | a >>> 20, w = n, b = n << 12 | l >>> 20, Di = t[P + 280 >> 2], l = t[P + 216 >> 2], or = Di + l | 0, zn = t[P + 284 >> 2], n = zn + t[P + 220 >> 2] | 0, n = l >>> 0 > or >>> 0 ? n + 1 | 0 : n, l = t[P + 120 >> 2], K = l + or | 0, Yr = n, n = n + t[P + 124 >> 2] | 0, n = l >>> 0 > K >>> 0 ? n + 1 | 0 : n, l = t[P + 136 >> 2], a = l + K | 0, gr = n, n = n + t[P + 140 >> 2] | 0, l = l >>> 0 > a >>> 0 ? n + 1 | 0 : n, n = l + b | 0, Li = P + 88 | 0, b = a + pe | 0, pe = b >>> 0 < a >>> 0 ? n + 1 | 0 : n, wi = (l | 0) == (pe | 0) & a >>> 0 > b >>> 0 | l >>> 0 > pe >>> 0, Ti = (l | 0) == (gr | 0) & a >>> 0 < K >>> 0 | l >>> 0 < gr >>> 0, l = ai + 8 | 0, ui = t[l >> 2], di = t[l + 4 >> 2], Ei = (gr | 0) == (Yr | 0) & K >>> 0 < or >>> 0 | gr >>> 0 < Yr >>> 0, l = kn + 8 | 0, ai = t[l >> 2], gr = t[l + 4 >> 2], K = (Yr | 0) == (zn | 0) & or >>> 0 < Di >>> 0 | Yr >>> 0 < zn >>> 0, n = $i + 8 | 0, a = t[n >> 2], l = Dn + 8 | 0, or = a + t[l >> 2] | 0, n = t[l + 4 >> 2] + t[n + 4 >> 2] | 0, n = a >>> 0 > or >>> 0 ? n + 1 | 0 : n, l = K + or | 0, n = (l >>> 0 < or >>> 0 ? n + 1 | 0 : n) + gr | 0, a = l, l = l + ai | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = l, l = l + Ei | 0, n = (a >>> 0 > l >>> 0 ? n + 1 | 0 : n) + di | 0, a = l, l = l + ui | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, a = l + Ti | 0, n = a >>> 0 < l >>> 0 ? n + 1 | 0 : n, w = w >>> 20 | 0, l = w + a | 0, n = w >>> 0 > l >>> 0 ? n + 1 | 0 : n, w = l, l = l + wi | 0, n = w >>> 0 > l >>> 0 ? n + 1 | 0 : n, w = pe, K = l << 12 | w >>> 20, a = n, pe = n << 12 | l >>> 20, ai = t[P + 104 >> 2], l = t[P + 184 >> 2], gr = ai + l | 0, wi = t[P + 108 >> 2], n = wi + t[P + 188 >> 2] | 0, l = l >>> 0 > gr >>> 0 ? n + 1 | 0 : n, n = l + pe | 0, K = K + gr | 0, n = K >>> 0 < gr >>> 0 ? n + 1 | 0 : n, Yr = K << 4 & -16, or = w, pe = n, Pr(Li, Yr | w >>> 16 & 15, (n << 4 | K >>> 28) & 16777215, 0, 0, 977, 1, 0, 0), Ti = P + 264 | 0, Pr(Ti, kr, lr, 0, 0, jr, ei, 0, 0), ui = P + 72 | 0, Pr(ui, Nr, Ii, 0, 0, Wi, Ce, 0, 0), di = P + 296 | 0, Pr(di, Tt, nr, 0, 0, Tt, nr, 0, 0), Ei = P + 56 | 0, Yr = (l | 0) == (n | 0) & K >>> 0 < gr >>> 0 | l >>> 0 > n >>> 0, K = (l | 0) == (wi | 0) & gr >>> 0 < ai >>> 0 | l >>> 0 < wi >>> 0, n = Qi + 8 | 0, w = t[n >> 2], l = Ki + 8 | 0, gr = w + t[l >> 2] | 0, n = t[l + 4 >> 2] + t[n + 4 >> 2] | 0, n = w >>> 0 > gr >>> 0 ? n + 1 | 0 : n, w = K + gr | 0, n = w >>> 0 < gr >>> 0 ? n + 1 | 0 : n, a = a >>> 20 | 0, l = w + a | 0, n = a >>> 0 > l >>> 0 ? n + 1 | 0 : n, w = l, l = l + Yr | 0, n = w >>> 0 > l >>> 0 ? n + 1 | 0 : n, pe = l << 12 | pe >>> 20, w = n, a = n << 12 | l >>> 20, ai = t[P + 72 >> 2], l = t[P + 296 >> 2], K = ai + l | 0, wi = t[P + 76 >> 2], n = wi + t[P + 300 >> 2] | 0, l = l >>> 0 > K >>> 0 ? n + 1 | 0 : n, n = l + a | 0, pe = pe + K | 0, n = pe >>> 0 < K >>> 0 ? n + 1 | 0 : n, a = n, Pr(Ei, pe, n & 1048575, 0, 0, 15632, 16, 0, 0), Yr = P + 200 | 0, Pr(Yr, Wi, Ce, 0, 0, jr, ei, 0, 0), ei = P + 248 | 0, Pr(ei, kr, lr, 0, 0, kr, lr, 0, 0), gr = P + 40 | 0, Pr(gr, Nr, Ii, 0, 0, Tt, nr, 0, 0), lr = P + 24 | 0, nr = lr, Ce = (l | 0) == (n | 0) & pe >>> 0 < K >>> 0 | l >>> 0 > n >>> 0, K = (l | 0) == (wi | 0) & K >>> 0 < ai >>> 0 | l >>> 0 < wi >>> 0, n = di + 8 | 0, pe = t[n >> 2], l = ui + 8 | 0, Tt = pe + t[l >> 2] | 0, n = t[l + 4 >> 2] + t[n + 4 >> 2] | 0, n = pe >>> 0 > Tt >>> 0 ? n + 1 | 0 : n, pe = K + Tt | 0, n = pe >>> 0 < Tt >>> 0 ? n + 1 | 0 : n, w = w >>> 20 | 0, l = w + pe | 0, n = w >>> 0 > l >>> 0 ? n + 1 | 0 : n, w = l, l = l + Ce | 0, n = w >>> 0 > l >>> 0 ? n + 1 | 0 : n, pe = l << 12 | a >>> 20, a = t[P + 40 >> 2], Ce = pe + a | 0, w = n, l = n << 12 | l >>> 20, n = l + t[P + 44 >> 2] | 0, n = a >>> 0 > Ce >>> 0 ? n + 1 | 0 : n, Pr(nr, Ce, n, 0, 0, 15632, 16, 0, 0), jr = P + 8 | 0, K = jr, pe = (l | 0) == (n | 0) & pe >>> 0 > Ce >>> 0 | l >>> 0 > n >>> 0, l = gr + 8 | 0, a = t[l >> 2], n = t[l + 4 >> 2], w = w >>> 20 | 0, l = w + a | 0, n = w >>> 0 > l >>> 0 ? n + 1 | 0 : n, w = l, l = l + pe | 0, n = w >>> 0 > l >>> 0 ? n + 1 | 0 : n, Pr(K, l, n, 0, 0, 64028672, 65536, 0, 0), Ce = t[P + 92 >> 2], n = Ce + t[P + 332 >> 2] | 0, K = t[P + 88 >> 2], w = t[P + 328 >> 2], l = K + w | 0, t[P + 760 >> 2] = -3908 - l, a = l >>> 0 < w >>> 0 ? n + 1 | 0 : n, t[P + 764 >> 2] = 4194299 - ((a & 1048575) + (l >>> 0 > 4294963388) | 0), K = (a | 0) == (Ce | 0) & l >>> 0 < K >>> 0 | a >>> 0 < Ce >>> 0, n = Xi + 8 | 0, w = t[n >> 2], l = Li + 8 | 0, Ce = w + t[l >> 2] | 0, n = t[l + 4 >> 2] + t[n + 4 >> 2] | 0, n = w >>> 0 > Ce >>> 0 ? n + 1 | 0 : n, l = K + Ce | 0, n = l >>> 0 < Ce >>> 0 ? n + 1 | 0 : n, K = l << 12 | a >>> 20, w = n, nr = n << 12 | l >>> 20, gr = t[P + 60 >> 2], n = gr + t[P + 268 >> 2] | 0, Tt = t[P + 56 >> 2], l = t[P + 264 >> 2], a = Tt + l | 0, Ce = a, K = a + K | 0, l = l >>> 0 > a >>> 0 ? n + 1 | 0 : n, n = l + nr | 0, a = K >>> 0 < a >>> 0 ? n + 1 | 0 : n, n = K, t[P + 768 >> 2] = -4 - n, t[P + 772 >> 2] = 4194303 - ((a & 1048575) + (n >>> 0 > 4294967292) | 0), nr = (l | 0) == (a | 0) & n >>> 0 < Ce >>> 0 | l >>> 0 > a >>> 0, Ce = (l | 0) == (gr | 0) & Ce >>> 0 < Tt >>> 0 | l >>> 0 < gr >>> 0, n = Ti + 8 | 0, K = t[n >> 2], l = Ei + 8 | 0, Tt = K + t[l >> 2] | 0, n = t[l + 4 >> 2] + t[n + 4 >> 2] | 0, n = K >>> 0 > Tt >>> 0 ? n + 1 | 0 : n, K = Ce + Tt | 0, n = K >>> 0 < Tt >>> 0 ? n + 1 | 0 : n, w = w >>> 20 | 0, l = w + K | 0, n = w >>> 0 > l >>> 0 ? n + 1 | 0 : n, w = l, l = l + nr | 0, n = w >>> 0 > l >>> 0 ? n + 1 | 0 : n, K = l << 12 | a >>> 20, w = n, a = n << 12 | l >>> 20, kr = t[P + 200 >> 2], l = t[P + 248 >> 2], nr = kr + l | 0, Nr = t[P + 204 >> 2], n = Nr + t[P + 252 >> 2] | 0, n = l >>> 0 > nr >>> 0 ? n + 1 | 0 : n, l = t[P + 24 >> 2], Ce = l + nr | 0, Tt = n, n = n + t[P + 28 >> 2] | 0, l = l >>> 0 > Ce >>> 0 ? n + 1 | 0 : n, n = l + a | 0, K = K + Ce | 0, n = K >>> 0 < Ce >>> 0 ? n + 1 | 0 : n, t[P + 776 >> 2] = -4 - K, a = n, t[P + 780 >> 2] = 4194303 - ((n & 1048575) + (K >>> 0 > 4294967292) | 0), Ii = (l | 0) == (n | 0) & K >>> 0 < Ce >>> 0 | l >>> 0 > n >>> 0, Wi = (l | 0) == (Tt | 0) & Ce >>> 0 < nr >>> 0 | l >>> 0 < Tt >>> 0, l = lr + 8 | 0, gr = t[l >> 2], lr = t[l + 4 >> 2], Ce = (Tt | 0) == (Nr | 0) & nr >>> 0 < kr >>> 0 | Tt >>> 0 < Nr >>> 0, n = ei + 8 | 0, K = t[n >> 2], l = Yr + 8 | 0, nr = K + t[l >> 2] | 0, n = t[l + 4 >> 2] + t[n + 4 >> 2] | 0, n = K >>> 0 > nr >>> 0 ? n + 1 | 0 : n, l = Ce + nr | 0, n = (l >>> 0 < nr >>> 0 ? n + 1 | 0 : n) + lr | 0, pe = l, l = l + gr | 0, n = pe >>> 0 > l >>> 0 ? n + 1 | 0 : n, K = l + Wi | 0, n = K >>> 0 < l >>> 0 ? n + 1 | 0 : n, w = w >>> 20 | 0, l = w + K | 0, n = w >>> 0 > l >>> 0 ? n + 1 | 0 : n, w = l, l = l + Ii | 0, n = w >>> 0 > l >>> 0 ? n + 1 | 0 : n, K = l << 12 | a >>> 20, w = n, Tt = n << 12 | l >>> 20, lr = t[P + 12 >> 2], n = lr + (Me & 1048575) | 0, nr = t[P + 8 >> 2], a = tr & -2, l = nr + a | 0, tr = l, K = l + K | 0, Ce = l >>> 0 < a >>> 0 ? n + 1 | 0 : n, n = Ce + Tt | 0, t[P + 784 >> 2] = -4 - K, l = K >>> 0 < l >>> 0 ? n + 1 | 0 : n, t[P + 788 >> 2] = 4194303 - ((l & 1048575) + (K >>> 0 > 4294967292) | 0), a = P, Me = b, or = or & 65535, K = (l | 0) == (Ce | 0) & K >>> 0 < tr >>> 0 | l >>> 0 < Ce >>> 0, b = (Ce | 0) == (lr | 0) & tr >>> 0 < nr >>> 0 | Ce >>> 0 < lr >>> 0, n = jr + 8 | 0, pe = b + t[n >> 2] | 0, n = t[n + 4 >> 2], n = b >>> 0 > pe >>> 0 ? n + 1 | 0 : n, w = w >>> 20 | 0, b = w, w = w + pe | 0, n = b >>> 0 > w >>> 0 ? n + 1 | 0 : n, b = w, w = w + K | 0, n = b >>> 0 > w >>> 0 ? n + 1 | 0 : n, l = w << 12 | l >>> 20, b = l + Me | 0, n = or + (n << 12 | w >>> 20) | 0, t[a + 792 >> 2] = -4 - b, t[a + 796 >> 2] = 262143 - ((b >>> 0 > 4294967292) + (l >>> 0 > b >>> 0 ? n + 1 | 0 : n) | 0), ui = a + 720 | 0, l = a + 760 | 0, zr(ui, l, In), Ei = a + 680 | 0, zr(Ei, a + 1e3 | 0, l), ai = a + 800 | 0, Wn(C, ai), l = t[a + 752 >> 2], b = l + t[C + 32 >> 2] | 0, n = t[C + 36 >> 2] + t[a + 756 >> 2] | 0, w = l >>> 0 > b >>> 0 ? n + 1 | 0 : n, l = t[a + 712 >> 2], Yr = l, n = t[a + 716 >> 2], Nr = n, n = (n << 1 | l >>> 31) + w | 0, l = l << 1, w = l, l = l + b | 0, n = w >>> 0 > l >>> 0 ? n + 1 | 0 : n, Tt = l, t[C + 32 >> 2] = l, tr = n, t[C + 36 >> 2] = n, l = C, C = t[a + 744 >> 2], b = C + t[l + 24 >> 2] | 0, n = t[l + 28 >> 2] + t[a + 748 >> 2] | 0, w = C >>> 0 > b >>> 0 ? n + 1 | 0 : n, C = t[a + 704 >> 2], ei = C, n = t[a + 708 >> 2], jr = n, n = (n << 1 | C >>> 31) + w | 0, C = C << 1, w = C, C = C + b | 0, n = w >>> 0 > C >>> 0 ? n + 1 | 0 : n, nr = C, t[l + 24 >> 2] = C, or = n, t[l + 28 >> 2] = n, C = t[a + 736 >> 2], b = C + t[l + 16 >> 2] | 0, n = t[l + 20 >> 2] + t[a + 740 >> 2] | 0, w = C >>> 0 > b >>> 0 ? n + 1 | 0 : n, C = t[a + 696 >> 2], kr = C, n = t[a + 700 >> 2], Ii = n, n = (n << 1 | C >>> 31) + w | 0, C = C << 1, w = C, C = C + b | 0, n = w >>> 0 > C >>> 0 ? n + 1 | 0 : n, Ce = C, t[l + 16 >> 2] = C, Me = n, t[l + 20 >> 2] = n, C = t[a + 728 >> 2], w = C + t[l + 8 >> 2] | 0, n = t[l + 12 >> 2] + t[a + 732 >> 2] | 0, C = C >>> 0 > w >>> 0 ? n + 1 | 0 : n, n = t[a + 692 >> 2], Wi = n, di = t[a + 688 >> 2], b = di, n = (n << 1 | b >>> 31) + C | 0, b = b << 1, K = w + b | 0, n = b >>> 0 > K >>> 0 ? n + 1 | 0 : n, t[l + 8 >> 2] = K, pe = n, t[l + 12 >> 2] = n, C = t[a + 720 >> 2], b = C + t[l >> 2] | 0, n = t[l + 4 >> 2] + t[a + 724 >> 2] | 0, w = C >>> 0 > b >>> 0 ? n + 1 | 0 : n, C = t[a + 680 >> 2], gr = C, n = t[a + 684 >> 2], lr = n, n = (n << 1 | C >>> 31) + w | 0, C = C << 1, w = C, C = C + b | 0, n = w >>> 0 > C >>> 0 ? n + 1 | 0 : n, b = C, t[l >> 2] = b, w = n, t[l + 4 >> 2] = n, n = tr + Nr | 0, a = Tt + Yr | 0, n = a >>> 0 < Tt >>> 0 ? n + 1 | 0 : n, t[P + 712 >> 2] = a, t[P + 716 >> 2] = n, n = or + jr | 0, a = nr + ei | 0, n = a >>> 0 < nr >>> 0 ? n + 1 | 0 : n, t[P + 704 >> 2] = a, t[P + 708 >> 2] = n, n = Me + Ii | 0, a = Ce + kr | 0, n = a >>> 0 < Ce >>> 0 ? n + 1 | 0 : n, t[P + 696 >> 2] = a, t[P + 700 >> 2] = n, n = pe + Wi | 0, a = K + di | 0, n = a >>> 0 < di >>> 0 ? n + 1 | 0 : n, t[P + 688 >> 2] = a, t[P + 692 >> 2] = n, n = w + lr | 0, C = b + gr | 0, n = C >>> 0 < b >>> 0 ? n + 1 | 0 : n, t[P + 680 >> 2] = C, t[P + 684 >> 2] = n, zr(l + 40 | 0, Ei, ai), zr(ui, ui, P + 920 | 0), n = t[l + 44 >> 2] + t[P + 724 >> 2] | 0, C = t[P + 720 >> 2], w = C + t[l + 40 >> 2] | 0, t[l + 40 >> 2] = w, t[l + 44 >> 2] = C >>> 0 > w >>> 0 ? n + 1 | 0 : n, n = l + 48 | 0, a = n, C = t[P + 728 >> 2], w = C + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[P + 732 >> 2] | 0, t[a >> 2] = w, t[a + 4 >> 2] = C >>> 0 > w >>> 0 ? n + 1 | 0 : n, n = l + 56 | 0, a = n, C = t[P + 736 >> 2], w = C + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[P + 740 >> 2] | 0, t[a >> 2] = w, t[a + 4 >> 2] = C >>> 0 > w >>> 0 ? n + 1 | 0 : n, n = l - -64 | 0, a = n, C = t[P + 744 >> 2], w = C + t[n >> 2] | 0, n = t[n + 4 >> 2] + t[P + 748 >> 2] | 0, t[a >> 2] = w, t[a + 4 >> 2] = C >>> 0 > w >>> 0 ? n + 1 | 0 : n, C = t[P + 752 >> 2], w = l + 72 | 0, l = C + t[w >> 2] | 0, n = t[w + 4 >> 2] + t[P + 756 >> 2] | 0, t[w >> 2] = l, t[w + 4 >> 2] = C >>> 0 > l >>> 0 ? n + 1 | 0 : n;
    }
    U = P + 1120 | 0;
  }
  function Fn(C, l, w, n) {
    var a = 0, b = 0, P = 0, K = 0, pe = 0, Ce = 0, Me = 0, Tt = 0, tr = 0, nr = 0, or = 0, lr = 0, gr = 0, kr = 0, Nr = 0, jr = 0, Yr = 0, ei = 0, ai = 0, ui = 0, di = 0, Ii = 0, wi = 0, Ei = 0, Ti = 0, Di = 0, Qi = 0, Li = 0, Ki = 0, Wi = 0, Xi = 0, $i = 0, In = 0, kn = 0;
    pe = U - 736 | 0, U = pe, a = t[w + 80 >> 2];
    e: {
      if (t[l + 120 >> 2]) {
        t[C + 120 >> 2] = a, l = t[w + 4 >> 2], t[C >> 2] = t[w >> 2], t[C + 4 >> 2] = l, l = w + 8 | 0, n = t[l + 4 >> 2], a = C + 8 | 0, t[a >> 2] = t[l >> 2], t[a + 4 >> 2] = n, l = w + 16 | 0, n = t[l + 4 >> 2], a = C + 16 | 0, t[a >> 2] = t[l >> 2], t[a + 4 >> 2] = n, l = w + 24 | 0, n = t[l + 4 >> 2], a = C + 24 | 0, t[a >> 2] = t[l >> 2], t[a + 4 >> 2] = n, l = w + 32 | 0, n = t[l + 4 >> 2], a = C + 32 | 0, t[a >> 2] = t[l >> 2], t[a + 4 >> 2] = n, l = t[w + 44 >> 2], t[C + 40 >> 2] = t[w + 40 >> 2], t[C + 44 >> 2] = l, l = w + 48 | 0, n = t[l + 4 >> 2], a = C + 48 | 0, t[a >> 2] = t[l >> 2], t[a + 4 >> 2] = n, l = w + 56 | 0, n = t[l + 4 >> 2], a = C + 56 | 0, t[a >> 2] = t[l >> 2], t[a + 4 >> 2] = n, l = w - -64 | 0, n = t[l + 4 >> 2], a = C - -64 | 0, t[a >> 2] = t[l >> 2], t[a + 4 >> 2] = n, l = w + 72 | 0, w = t[l + 4 >> 2], n = C + 72 | 0, t[n >> 2] = t[l >> 2], t[n + 4 >> 2] = w, l = C + 88 | 0, t[l >> 2] = 0, t[l + 4 >> 2] = 0, t[C + 80 >> 2] = 1, t[C + 84 >> 2] = 0, l = C + 96 | 0, t[l >> 2] = 0, t[l + 4 >> 2] = 0, l = C + 104 | 0, t[l >> 2] = 0, t[l + 4 >> 2] = 0, C = C + 112 | 0, t[C >> 2] = 0, t[C + 4 >> 2] = 0;
        break e;
      }
      if (a) {
        n && (t[n + 8 >> 2] = 0, t[n + 12 >> 2] = 0, t[n >> 2] = 1, t[n + 4 >> 2] = 0, w = n + 16 | 0, t[w >> 2] = 0, t[w + 4 >> 2] = 0, w = n + 24 | 0, t[w >> 2] = 0, t[w + 4 >> 2] = 0, w = n + 32 | 0, t[w >> 2] = 0, t[w + 4 >> 2] = 0), as(C, l, 128);
        break e;
      }
      Nr = pe + 696 | 0, Qi = l + 80 | 0, Wn(Nr, Qi), or = pe + 656 | 0, Me = or + 8 | 0, a = l + 8 | 0, K = t[a >> 2], tr = t[a + 4 >> 2], P = t[l + 4 >> 2], a = l + 32 | 0, Tt = t[a >> 2], Ce = t[a + 4 >> 2], kr = Ce, a = t[l >> 2], Ce = ri(Ce >>> 16 | 0, 0, 977, 1), b = a + Ce | 0, a = P + ve | 0, Ce = b >>> 0 < Ce >>> 0 ? a + 1 | 0 : a, a = tr, P = Ce >>> 20 | 0, tr = P, P = P + K | 0, a = tr >>> 0 > P >>> 0 ? a + 1 | 0 : a, t[Me >> 2] = P, jr = a & 1048575, t[Me + 4 >> 2] = jr, K = or + 16 | 0, Me = l + 16 | 0, tr = t[Me >> 2], lr = t[Me + 4 >> 2], Me = a, a = lr, Me = Me >>> 20 | 0, nr = Me, Me = Me + tr | 0, a = nr >>> 0 > Me >>> 0 ? a + 1 | 0 : a, t[K >> 2] = Me, Ti = a & 1048575, t[K + 4 >> 2] = Ti, tr = or + 24 | 0, K = l + 24 | 0, lr = t[K >> 2], nr = t[K + 4 >> 2], K = a, a = nr, K = K >>> 20 | 0, nr = K, K = K + lr | 0, a = nr >>> 0 > K >>> 0 ? a + 1 | 0 : a, t[tr >> 2] = K, di = a & 1048575, t[tr + 4 >> 2] = di, tr = or + 32 | 0, or = a, a = kr & 65535, or = or >>> 20 | 0, kr = Tt + or | 0, a = or >>> 0 > kr >>> 0 ? a + 1 | 0 : a, t[tr >> 2] = kr, ei = a, t[tr + 4 >> 2] = a, Tt = b, t[pe + 656 >> 2] = b, Yr = Ce & 1048575, t[pe + 660 >> 2] = Yr, zr(pe + 616 | 0, w, Nr), lr = pe + 576 | 0, tr = lr + 8 | 0, a = l + 48 | 0, gr = t[a >> 2], ai = t[a + 4 >> 2], or = t[l + 44 >> 2], a = l + 72 | 0, Ce = t[a >> 2], nr = t[a + 4 >> 2], ui = nr, a = t[l + 40 >> 2], nr = ri(nr >>> 16 | 0, 0, 977, 1), b = a + nr | 0, a = or + ve | 0, or = b >>> 0 < nr >>> 0 ? a + 1 | 0 : a, a = ai, nr = or >>> 20 | 0, ai = nr + gr | 0, a = nr >>> 0 > ai >>> 0 ? a + 1 | 0 : a, t[tr >> 2] = ai, Li = a & 1048575, t[tr + 4 >> 2] = Li, nr = lr + 16 | 0, tr = l + 56 | 0, gr = t[tr >> 2], Ii = t[tr + 4 >> 2], tr = a, a = Ii, tr = tr >>> 20 | 0, Ii = tr + gr | 0, a = tr >>> 0 > Ii >>> 0 ? a + 1 | 0 : a, t[nr >> 2] = Ii, Ei = a & 1048575, t[nr + 4 >> 2] = Ei, nr = lr + 24 | 0, tr = l - -64 | 0, gr = t[tr >> 2], wi = t[tr + 4 >> 2], tr = a, a = wi, tr = tr >>> 20 | 0, wi = tr + gr | 0, a = tr >>> 0 > wi >>> 0 ? a + 1 | 0 : a, t[nr >> 2] = wi, Di = a & 1048575, t[nr + 4 >> 2] = Di, lr = lr + 32 | 0, tr = a, a = ui & 65535, tr = tr >>> 20 | 0, nr = Ce + tr | 0, a = tr >>> 0 > nr >>> 0 ? a + 1 | 0 : a, t[lr >> 2] = nr, gr = a, t[lr + 4 >> 2] = a, ui = b, t[pe + 576 >> 2] = b, Ki = or & 1048575, t[pe + 580 >> 2] = Ki, a = pe + 536 | 0, zr(a, w + 40 | 0, Nr), zr(a, a, Qi), w = t[pe + 616 >> 2], Ce = (w - Tt | 0) - 3908 | 0, a = (t[pe + 620 >> 2] - ((w >>> 0 < Tt >>> 0) + Yr | 0) | 0) + 4194299 | 0, t[pe + 496 >> 2] = Ce, tr = Ce >>> 0 < 4294963388 ? a + 1 | 0 : a, t[pe + 500 >> 2] = tr, w = pe, a = t[w + 624 >> 2], Tt = (a - P | 0) - 4 | 0, a = (t[w + 628 >> 2] - ((a >>> 0 < P >>> 0) + jr | 0) | 0) + 4194303 | 0, t[w + 504 >> 2] = Tt, or = Tt >>> 0 < 4294967292 ? a + 1 | 0 : a, t[w + 508 >> 2] = or, a = t[w + 632 >> 2], b = (a - Me | 0) - 4 | 0, a = (t[w + 636 >> 2] - ((a >>> 0 < Me >>> 0) + Ti | 0) | 0) + 4194303 | 0, t[w + 512 >> 2] = b, Me = b >>> 0 < 4294967292 ? a + 1 | 0 : a, t[w + 516 >> 2] = Me, a = t[w + 640 >> 2], P = (a - K | 0) - 4 | 0, a = (t[w + 644 >> 2] - ((a >>> 0 < K >>> 0) + di | 0) | 0) + 4194303 | 0, t[w + 520 >> 2] = P, K = P >>> 0 < 4294967292 ? a + 1 | 0 : a, t[w + 524 >> 2] = K, a = t[w + 648 >> 2], w = (a - kr | 0) - 4 | 0, a = (t[pe + 652 >> 2] - ((a >>> 0 < kr >>> 0) + ei | 0) | 0) + 262143 | 0, t[pe + 528 >> 2] = w, kr = w >>> 0 < 4294967292 ? a + 1 | 0 : a, t[pe + 532 >> 2] = kr, a = t[pe + 568 >> 2], ei = (nr - a | 0) - 4 | 0, a = (gr - (t[pe + 572 >> 2] + (a >>> 0 > nr >>> 0) | 0) | 0) + 262143 | 0, t[pe + 488 >> 2] = ei, nr = ei >>> 0 < 4294967292 ? a + 1 | 0 : a, t[pe + 492 >> 2] = nr, a = t[pe + 560 >> 2], gr = (wi - a | 0) - 4 | 0, a = (Di - (t[pe + 564 >> 2] + (a >>> 0 > wi >>> 0) | 0) | 0) + 4194303 | 0, wi = gr, t[pe + 480 >> 2] = gr, Di = gr >>> 0 < 4294967292 ? a + 1 | 0 : a, t[pe + 484 >> 2] = Di, a = t[pe + 552 >> 2], gr = (Ii - a | 0) - 4 | 0, a = (Ei - (t[pe + 556 >> 2] + (a >>> 0 > Ii >>> 0) | 0) | 0) + 4194303 | 0, Ii = gr, t[pe + 472 >> 2] = gr, Ei = gr >>> 0 < 4294967292 ? a + 1 | 0 : a, t[pe + 476 >> 2] = Ei, a = t[pe + 544 >> 2], gr = (ai - a | 0) - 4 | 0, a = (Li - (t[pe + 548 >> 2] + (a >>> 0 > ai >>> 0) | 0) | 0) + 4194303 | 0, t[pe + 464 >> 2] = gr, Li = gr >>> 0 < 4294967292 ? a + 1 | 0 : a, t[pe + 468 >> 2] = Li, a = t[pe + 536 >> 2], lr = (ui - a | 0) - 3908 | 0, a = (Ki - (t[pe + 540 >> 2] + (a >>> 0 > ui >>> 0) | 0) | 0) + 4194299 | 0, ai = lr, t[pe + 456 >> 2] = lr, Ki = lr >>> 0 < 4294963388 ? a + 1 | 0 : a, t[pe + 460 >> 2] = Ki, lr = ri(kr >>> 16 | 0, 0, 977, 1) + Ce | 0, a = ve + tr | 0, a = Ce >>> 0 > lr >>> 0 ? a + 1 | 0 : a, ui = a & 1048575, Wi = ui;
      t: {
        if (Xi = lr, $i = lr ^ 976, In = ui ^ 1, (($i | 0) != -1 | (In | 0) != 1048575) & (lr | ui) != 0 || (Yr = kr & 65535, lr = a, a = or, lr = (lr >>> 20 | 0) + Tt | 0, ui = lr >>> 0 < Tt >>> 0 ? a + 1 | 0 : a, a = Me, Nr = (ui >>> 20 | 0) + b | 0, jr = Nr >>> 0 < b >>> 0 ? a + 1 | 0 : a, a = K, Ti = (jr >>> 20 | 0) + P | 0, di = Ti >>> 0 < P >>> 0 ? a + 1 | 0 : a, a = Yr, Yr = di >>> 20 | 0, kn = Yr, Yr = w + Yr | 0, a = kn >>> 0 > Yr >>> 0 ? a + 1 | 0 : a, Yr | (Ti | (Nr | (lr | Xi))) | (a | (di & 1048575 | (jr & 1048575 | (ui & 1048575 | Wi)))) && ((lr & $i & Nr & Ti & Yr) != -1 ? a = 1 : a = (ui & In & jr & di & (a ^ 983040)) != 1048575, a)))
          break t;
        w = ri(nr >>> 16 | 0, 0, 977, 1) + ai | 0, a = ve + Ki | 0, a = w >>> 0 < ai >>> 0 ? a + 1 | 0 : a, b = a & 1048575, tr = b;
        r: {
          if (or = w, kr = w ^ 976, lr = b ^ 1, ((kr | 0) != -1 | (lr | 0) != 1048575) & (w | b) != 0 || (nr = nr & 65535, w = a, a = Li, w = (w >>> 20 | 0) + gr | 0, b = w >>> 0 < gr >>> 0 ? a + 1 | 0 : a, a = Ei, P = (b >>> 20 | 0) + Ii | 0, Tt = P >>> 0 < Ii >>> 0 ? a + 1 | 0 : a, a = Di, Me = (Tt >>> 20 | 0) + wi | 0, K = Me >>> 0 < wi >>> 0 ? a + 1 | 0 : a, a = nr, Ce = K >>> 20 | 0, nr = Ce, Ce = Ce + ei | 0, a = nr >>> 0 > Ce >>> 0 ? a + 1 | 0 : a, Ce | (Me | (P | (w | or))) | (a | (K & 1048575 | (Tt & 1048575 | (b & 1048575 | tr)))) && ((w & kr & P & Me & Ce) != -1 ? w = 1 : w = (b & lr & Tt & K & (a ^ 983040)) != 1048575, w)))
            break r;
          if (t[l + 120 >> 2]) {
            if (t[C + 120 >> 2] = 1, is(C, 120), !n)
              break e;
            t[n + 8 >> 2] = 0, t[n + 12 >> 2] = 0, t[n >> 2] = 1, t[n + 4 >> 2] = 0, C = n + 16 | 0, t[C >> 2] = 0, t[C + 4 >> 2] = 0, C = n + 24 | 0, t[C >> 2] = 0, t[C + 4 >> 2] = 0, C = n + 32 | 0, t[C >> 2] = 0, t[C + 4 >> 2] = 0;
            break e;
          }
          n && (w = l + 40 | 0, a = t[w >> 2], b = t[w + 4 >> 2], t[n >> 2] = a, t[n + 4 >> 2] = b, P = w + 8 | 0, Tt = t[P >> 2], or = Tt, Me = t[P + 4 >> 2], tr = Me, P = n + 8 | 0, t[P >> 2] = Tt, t[P + 4 >> 2] = Me, Tt = w + 16 | 0, Me = t[Tt >> 2], kr = Me, K = t[Tt + 4 >> 2], lr = K, Tt = n + 16 | 0, t[Tt >> 2] = Me, t[Tt + 4 >> 2] = K, Me = w + 24 | 0, K = t[Me >> 2], nr = K, Ce = t[Me + 4 >> 2], ei = Ce, Me = n + 24 | 0, t[Me >> 2] = K, t[Me + 4 >> 2] = Ce, w = w + 32 | 0, K = t[w >> 2], w = t[w + 4 >> 2], Ce = n + 32 | 0, t[Ce >> 2] = K, t[Ce + 4 >> 2] = w, ai = ri(w >>> 16 | 0, 0, 977, 1), gr = ai + a | 0, a = b + ve | 0, t[n >> 2] = gr, a = gr >>> 0 < ai >>> 0 ? a + 1 | 0 : a, t[n + 4 >> 2] = a & 1048575, n = a, a = tr, n = n >>> 20 | 0, b = n, n = n + or | 0, a = b >>> 0 > n >>> 0 ? a + 1 | 0 : a, t[P >> 2] = n, t[P + 4 >> 2] = a & 1048575, n = a, a = lr, n = n >>> 20 | 0, b = n, n = n + kr | 0, a = b >>> 0 > n >>> 0 ? a + 1 | 0 : a, t[Tt >> 2] = n, t[Tt + 4 >> 2] = a & 1048575, n = a, a = ei, n = n >>> 20 | 0, b = n, n = n + nr | 0, a = b >>> 0 > n >>> 0 ? a + 1 | 0 : a, t[Me >> 2] = n, t[Me + 4 >> 2] = a & 1048575, n = w & 65535, w = a, a = n, w = w >>> 20 | 0, n = w, w = w + K | 0, a = n >>> 0 > w >>> 0 ? a + 1 | 0 : a, t[Ce >> 2] = w, t[Ce + 4 >> 2] = a), Gn(C, l);
          break e;
        }
        n && (t[n >> 2] = 0, t[n + 4 >> 2] = 0, l = n + 32 | 0, t[l >> 2] = 0, t[l + 4 >> 2] = 0, l = n + 24 | 0, t[l >> 2] = 0, t[l + 4 >> 2] = 0, l = n + 16 | 0, t[l >> 2] = 0, t[l + 4 >> 2] = 0, l = n + 8 | 0, t[l >> 2] = 0, t[l + 4 >> 2] = 0), t[C + 120 >> 2] = 1, is(C, 120);
        break e;
      }
      t[C + 120 >> 2] = 0, n && (l = t[pe + 500 >> 2], t[n >> 2] = t[pe + 496 >> 2], t[n + 4 >> 2] = l, l = pe + 496 | 0, a = l + 32 | 0, lr = t[a + 4 >> 2], nr = n + 32 | 0, t[nr >> 2] = t[a >> 2], t[nr + 4 >> 2] = lr, a = l + 24 | 0, lr = t[a + 4 >> 2], nr = n + 24 | 0, t[nr >> 2] = t[a >> 2], t[nr + 4 >> 2] = lr, a = l + 16 | 0, lr = t[a + 4 >> 2], nr = n + 16 | 0, t[nr >> 2] = t[a >> 2], t[nr + 4 >> 2] = lr, l = l + 8 | 0, a = t[l + 4 >> 2], n = n + 8 | 0, t[n >> 2] = t[l >> 2], t[n + 4 >> 2] = a), Ti = pe + 496 | 0, zr(C + 80 | 0, Qi, Ti), ui = pe + 304 | 0, lr = Ce << 1, l = tr, tr = l << 1 | Ce >>> 31, Pr(ui, P, K, 0, 0, lr, tr, 0, 0), Nr = pe + 224 | 0, n = Tt << 1, ei = or, or = Tt, nr = ei << 1 | Tt >>> 31, Pr(Nr, b, Me, 0, 0, n, nr, 0, 0), gr = pe + 160 | 0, Pr(gr, w, kr, 0, 0, w, kr, 0, 0), jr = pe + 144 | 0, Pr(jr, t[pe + 160 >> 2], t[pe + 164 >> 2], 0, 0, 15632, 16, 0, 0), di = pe + 112 | 0, Tt = w << 1, kr = kr << 1 | w >>> 31, Pr(di, Tt, kr, 0, 0, Ce, l, 0, 0), Yr = pe + 272 | 0, Pr(Yr, P, K, 0, 0, n, nr, 0, 0), Di = pe + 208 | 0, Pr(Di, b, Me, 0, 0, b, Me, 0, 0), Ei = pe + 128 | 0, w = gr + 8 | 0, Pr(Ei, t[w >> 2], t[w + 4 >> 2], 0, 0, 64028672, 65536, 0, 0), Li = pe + 320 | 0, Pr(Li, Ce, l, 0, 0, Ce, l, 0, 0), Ki = pe + 96 | 0, Pr(Ki, Tt, kr, 0, 0, or, ei, 0, 0), Xi = pe + 176 | 0, gr = P, ai = K, Ii = Me, Me = b, Pr(Xi, P, K, 0, 0, b << 1, Ii << 1 | b >>> 31, 0, 0), P = t[pe + 304 >> 2], w = t[pe + 224 >> 2], l = P + w | 0, b = t[pe + 308 >> 2], a = b + t[pe + 228 >> 2] | 0, w = l >>> 0 < w >>> 0 ? a + 1 | 0 : a, a = w + t[pe + 148 >> 2] | 0, n = l, K = t[pe + 144 >> 2], l = l + K | 0, wi = l, l = l >>> 0 < K >>> 0 ? a + 1 | 0 : a, K = (w | 0) == (l | 0) & n >>> 0 > wi >>> 0 | l >>> 0 < w >>> 0, a = jr + 8 | 0, Ce = t[a >> 2], nr = t[a + 4 >> 2], n = (w | 0) == (b | 0) & n >>> 0 < P >>> 0 | w >>> 0 < b >>> 0, a = Nr + 8 | 0, b = t[a >> 2], P = ui + 8 | 0, w = b + t[P >> 2] | 0, a = t[P + 4 >> 2] + t[a + 4 >> 2] | 0, a = w >>> 0 < b >>> 0 ? a + 1 | 0 : a, b = w, w = w + n | 0, a = (b >>> 0 > w >>> 0 ? a + 1 | 0 : a) + nr | 0, n = w, w = w + Ce | 0, a = n >>> 0 > w >>> 0 ? a + 1 | 0 : a, n = w + K | 0, w = n >>> 0 < w >>> 0 ? a + 1 | 0 : a, b = w << 12 | n >>> 20, ui = l, Nr = n << 12 | l >>> 20, Qi = b, Wi = t[pe + 272 >> 2], n = t[pe + 208 >> 2], l = Wi + n | 0, jr = t[pe + 276 >> 2], a = jr + t[pe + 212 >> 2] | 0, a = l >>> 0 < n >>> 0 ? a + 1 | 0 : a, K = l, n = t[pe + 112 >> 2], l = l + n | 0, b = a, a = a + t[pe + 116 >> 2] | 0, a = l >>> 0 < n >>> 0 ? a + 1 | 0 : a, Ce = l, n = t[pe + 128 >> 2], l = l + n | 0, P = a, a = a + t[pe + 132 >> 2] | 0, n = l >>> 0 < n >>> 0 ? a + 1 | 0 : a, a = n + Qi | 0, Qi = pe + 80 | 0, nr = l, Nr = l + Nr | 0, l = l >>> 0 > Nr >>> 0 ? a + 1 | 0 : a, a = n, n = Nr, Nr = (l | 0) == (a | 0) & n >>> 0 < nr >>> 0 | l >>> 0 < a >>> 0, nr = (a | 0) == (P | 0) & Ce >>> 0 > nr >>> 0 | a >>> 0 < P >>> 0, a = Ei + 8 | 0, Ei = t[a >> 2], $i = t[a + 4 >> 2], P = (b | 0) == (P | 0) & Ce >>> 0 < K >>> 0 | b >>> 0 > P >>> 0, a = di + 8 | 0, Ce = t[a >> 2], di = t[a + 4 >> 2], K = (b | 0) == (jr | 0) & K >>> 0 < Wi >>> 0 | b >>> 0 < jr >>> 0, a = Di + 8 | 0, jr = t[a >> 2], Yr = Yr + 8 | 0, b = jr + t[Yr >> 2] | 0, a = t[Yr + 4 >> 2] + t[a + 4 >> 2] | 0, a = b >>> 0 < jr >>> 0 ? a + 1 | 0 : a, Yr = b, b = b + K | 0, a = (Yr >>> 0 > b >>> 0 ? a + 1 | 0 : a) + di | 0, K = b, b = b + Ce | 0, a = K >>> 0 > b >>> 0 ? a + 1 | 0 : a, K = b, b = b + P | 0, a = (K >>> 0 > b >>> 0 ? a + 1 | 0 : a) + $i | 0, K = b, b = b + Ei | 0, a = K >>> 0 > b >>> 0 ? a + 1 | 0 : a, K = b, b = b + nr | 0, a = K >>> 0 > b >>> 0 ? a + 1 | 0 : a, w = w >>> 20 | 0, K = w, w = w + b | 0, a = K >>> 0 > w >>> 0 ? a + 1 | 0 : a, b = w + Nr | 0, w = b >>> 0 < w >>> 0 ? a + 1 | 0 : a, a = w << 12 | b >>> 20, K = b << 12, b = l, Ce = K | l >>> 20, nr = a, jr = t[pe + 96 >> 2], P = t[pe + 176 >> 2], l = jr + P | 0, Nr = t[pe + 100 >> 2], a = Nr + t[pe + 180 >> 2] | 0, P = l >>> 0 < P >>> 0 ? a + 1 | 0 : a, a = P + nr | 0, K = l, Ce = l + Ce | 0, a = l >>> 0 > Ce >>> 0 ? a + 1 | 0 : a, di = Ce << 4 & -16, nr = b, l = a, Pr(Qi, di | b >>> 16 & 15, (a << 4 | Ce >>> 28) & 16777215, 0, 0, 977, 1, 0, 0), di = pe + 256 | 0, Pr(di, or, ei, 0, 0, lr, tr, 0, 0), Yr = pe - -64 | 0, Pr(Yr, Tt, kr, 0, 0, Me, Ii, 0, 0), Di = pe + 288 | 0, Pr(Di, gr, ai, 0, 0, gr, ai, 0, 0), Ei = pe + 48 | 0, Ce = (a | 0) == (P | 0) & Ce >>> 0 < K >>> 0 | a >>> 0 < P >>> 0, P = (P | 0) == (Nr | 0) & K >>> 0 < jr >>> 0 | P >>> 0 < Nr >>> 0, a = Xi + 8 | 0, K = t[a >> 2], Nr = Ki + 8 | 0, b = K + t[Nr >> 2] | 0, a = t[Nr + 4 >> 2] + t[a + 4 >> 2] | 0, a = b >>> 0 < K >>> 0 ? a + 1 | 0 : a, K = b, b = b + P | 0, a = K >>> 0 > b >>> 0 ? a + 1 | 0 : a, w = w >>> 20 | 0, K = w, w = w + b | 0, a = K >>> 0 > w >>> 0 ? a + 1 | 0 : a, b = w + Ce | 0, w = b >>> 0 < w >>> 0 ? a + 1 | 0 : a, P = w << 12 | b >>> 20, b = b << 12 | l >>> 20, K = P, Nr = t[pe + 64 >> 2], P = t[pe + 288 >> 2], l = Nr + P | 0, Ce = t[pe + 68 >> 2], a = Ce + t[pe + 292 >> 2] | 0, a = l >>> 0 < P >>> 0 ? a + 1 | 0 : a, P = l, l = a, a = a + K | 0, b = b + P | 0, a = b >>> 0 < P >>> 0 ? a + 1 | 0 : a, K = b, b = a, Pr(Ei, K, a & 1048575, 0, 0, 15632, 16, 0, 0), jr = pe + 192 | 0, Pr(jr, Me, Ii, 0, 0, lr, tr, 0, 0), tr = pe + 240 | 0, Pr(tr, or, ei, 0, 0, or, ei, 0, 0), Me = pe + 32 | 0, Pr(Me, Tt, kr, 0, 0, gr, ai, 0, 0), kr = pe + 16 | 0, Tt = kr, K = (l | 0) == (a | 0) & P >>> 0 > K >>> 0 | l >>> 0 > a >>> 0, P = (l | 0) == (Ce | 0) & P >>> 0 < Nr >>> 0 | l >>> 0 < Ce >>> 0, a = Di + 8 | 0, Ce = t[a >> 2], or = Yr + 8 | 0, l = Ce + t[or >> 2] | 0, a = t[or + 4 >> 2] + t[a + 4 >> 2] | 0, a = l >>> 0 < Ce >>> 0 ? a + 1 | 0 : a, or = l, l = l + P | 0, a = or >>> 0 > l >>> 0 ? a + 1 | 0 : a, w = w >>> 20 | 0, l = l + w | 0, a = w >>> 0 > l >>> 0 ? a + 1 | 0 : a, w = l + K | 0, l = w >>> 0 < l >>> 0 ? a + 1 | 0 : a, P = l << 12 | w >>> 20, K = w << 12 | b >>> 20, Ce = t[pe + 32 >> 2], w = K + Ce | 0, b = P, a = b + t[pe + 36 >> 2] | 0, a = w >>> 0 < Ce >>> 0 ? a + 1 | 0 : a, Pr(Tt, w, a, 0, 0, 15632, 16, 0, 0), w = (a | 0) == (b | 0) & w >>> 0 < K >>> 0 | a >>> 0 < b >>> 0, a = Me + 8 | 0, b = t[a >> 2], a = t[a + 4 >> 2], l = l >>> 20 | 0, K = l, l = l + b | 0, a = K >>> 0 > l >>> 0 ? a + 1 | 0 : a, b = l, l = l + w | 0, a = b >>> 0 > l >>> 0 ? a + 1 | 0 : a, Pr(pe, l, a, 0, 0, 64028672, 65536, 0, 0), l = pe, Tt = t[l + 80 >> 2], w = t[l + 320 >> 2], b = Tt + w | 0, P = t[l + 84 >> 2], a = P + t[l + 324 >> 2] | 0, t[l + 416 >> 2] = -3908 - b, w = w >>> 0 > b >>> 0 ? a + 1 | 0 : a, t[l + 420 >> 2] = 4194299 - ((w & 1048575) + (b >>> 0 > 4294963388) | 0), P = (w | 0) == (P | 0) & b >>> 0 < Tt >>> 0 | w >>> 0 < P >>> 0, a = Li + 8 | 0, Tt = t[a >> 2], Me = Qi + 8 | 0, b = Tt + t[Me >> 2] | 0, a = t[Me + 4 >> 2] + t[a + 4 >> 2] | 0, a = b >>> 0 < Tt >>> 0 ? a + 1 | 0 : a, P = b + P | 0, b = P >>> 0 < b >>> 0 ? a + 1 | 0 : a, Tt = b << 12 | P >>> 20, P = P << 12 | w >>> 20, Me = Tt, Ce = t[l + 48 >> 2], Tt = t[l + 256 >> 2], w = Ce + Tt | 0, K = t[l + 52 >> 2], a = K + t[l + 260 >> 2] | 0, a = w >>> 0 < Tt >>> 0 ? a + 1 | 0 : a, Tt = w, w = a, a = a + Me | 0, P = P + Tt | 0, a = P >>> 0 < Tt >>> 0 ? a + 1 | 0 : a, Me = P, t[l + 424 >> 2] = -4 - P, P = a, t[l + 428 >> 2] = 4194303 - ((a & 1048575) + (Me >>> 0 > 4294967292) | 0), Me = (w | 0) == (a | 0) & Me >>> 0 < Tt >>> 0 | w >>> 0 > a >>> 0, Tt = (w | 0) == (K | 0) & Ce >>> 0 > Tt >>> 0 | w >>> 0 < K >>> 0, a = di + 8 | 0, K = t[a >> 2], Ce = Ei + 8 | 0, w = K + t[Ce >> 2] | 0, a = t[Ce + 4 >> 2] + t[a + 4 >> 2] | 0, a = w >>> 0 < K >>> 0 ? a + 1 | 0 : a, K = w, w = w + Tt | 0, a = K >>> 0 > w >>> 0 ? a + 1 | 0 : a, b = b >>> 20 | 0, w = w + b | 0, a = b >>> 0 > w >>> 0 ? a + 1 | 0 : a, b = w + Me | 0, w = b >>> 0 < w >>> 0 ? a + 1 | 0 : a, Tt = w << 12 | b >>> 20, Ce = b << 12 | P >>> 20, ei = t[l + 192 >> 2], b = t[l + 240 >> 2], P = ei + b | 0, or = t[l + 196 >> 2], a = or + t[l + 244 >> 2] | 0, a = b >>> 0 > P >>> 0 ? a + 1 | 0 : a, K = P, P = t[l + 16 >> 2], Me = K + P | 0, b = a, a = a + t[l + 20 >> 2] | 0, P = P >>> 0 > Me >>> 0 ? a + 1 | 0 : a, a = P + Tt | 0, Tt = Ce + Me | 0, a = Tt >>> 0 < Me >>> 0 ? a + 1 | 0 : a, Ce = Tt, t[l + 432 >> 2] = -4 - Ce, Tt = a, t[l + 436 >> 2] = 4194303 - ((a & 1048575) + (Ce >>> 0 > 4294967292) | 0), Ce = (a | 0) == (P | 0) & Ce >>> 0 < Me >>> 0 | a >>> 0 < P >>> 0, P = (b | 0) == (P | 0) & K >>> 0 > Me >>> 0 | b >>> 0 > P >>> 0, a = kr + 8 | 0, Me = t[a >> 2], kr = t[a + 4 >> 2], K = (b | 0) == (or | 0) & K >>> 0 < ei >>> 0 | b >>> 0 < or >>> 0, a = tr + 8 | 0, or = t[a >> 2], tr = jr + 8 | 0, b = or + t[tr >> 2] | 0, a = t[tr + 4 >> 2] + t[a + 4 >> 2] | 0, a = b >>> 0 < or >>> 0 ? a + 1 | 0 : a, tr = b, b = b + K | 0, a = (tr >>> 0 > b >>> 0 ? a + 1 | 0 : a) + kr | 0, K = b, b = b + Me | 0, a = K >>> 0 > b >>> 0 ? a + 1 | 0 : a, K = b, b = b + P | 0, a = K >>> 0 > b >>> 0 ? a + 1 | 0 : a, w = w >>> 20 | 0, K = w, w = w + b | 0, a = K >>> 0 > w >>> 0 ? a + 1 | 0 : a, b = w + Ce | 0, w = b >>> 0 < w >>> 0 ? a + 1 | 0 : a, P = w << 12 | b >>> 20, Me = b << 12 | Tt >>> 20, or = t[l >> 2], b = wi & -2, Tt = or + b | 0, Ce = t[l + 4 >> 2], a = Ce + (ui & 1048575) | 0, b = b >>> 0 > Tt >>> 0 ? a + 1 | 0 : a, a = b + P | 0, Me = Me + Tt | 0, a = Me >>> 0 < Tt >>> 0 ? a + 1 | 0 : a, t[l + 440 >> 2] = -4 - Me, P = a, t[l + 444 >> 2] = 4194303 - ((a & 1048575) + (Me >>> 0 > 4294967292) | 0), K = n, tr = nr & 65535, Me = (a | 0) == (b | 0) & Me >>> 0 < Tt >>> 0 | a >>> 0 < b >>> 0, b = (b | 0) == (Ce | 0) & Tt >>> 0 < or >>> 0 | b >>> 0 < Ce >>> 0, a = l + 8 | 0, n = b + t[a >> 2] | 0, a = t[a + 4 >> 2], a = n >>> 0 < b >>> 0 ? a + 1 | 0 : a, w = w >>> 20 | 0, b = w, w = w + n | 0, a = b >>> 0 > w >>> 0 ? a + 1 | 0 : a, n = w, w = w + Me | 0, a = tr + ((n >>> 0 > w >>> 0 ? a + 1 | 0 : a) << 12 | w >>> 20) | 0, b = w << 12 | P >>> 20, w = b + K | 0, t[l + 448 >> 2] = -4 - w, t[l + 452 >> 2] = 262143 - ((w >>> 0 > 4294967292) + (w >>> 0 < b >>> 0 ? a + 1 | 0 : a) | 0), lr = l + 376 | 0, w = l + 416 | 0, zr(lr, w, Ti), gr = l + 336 | 0, zr(gr, l + 656 | 0, w), ai = l + 456 | 0, Wn(C, ai), n = t[l + 408 >> 2], w = n + t[C + 32 >> 2] | 0, a = t[C + 36 >> 2] + t[l + 412 >> 2] | 0, n = w >>> 0 < n >>> 0 ? a + 1 | 0 : a, a = t[l + 372 >> 2], Ii = a, nr = t[l + 368 >> 2], b = nr, a = (a << 1 | b >>> 31) + n | 0, b = b << 1, w = w + b | 0, a = b >>> 0 > w >>> 0 ? a + 1 | 0 : a, P = w, t[C + 32 >> 2] = w, Tt = a, t[C + 36 >> 2] = a, n = t[l + 400 >> 2], w = n + t[C + 24 >> 2] | 0, a = t[C + 28 >> 2] + t[l + 404 >> 2] | 0, a = w >>> 0 < n >>> 0 ? a + 1 | 0 : a, n = w, b = a, w = t[l + 360 >> 2], wi = w, a = t[l + 364 >> 2], ui = a, a = (a << 1 | w >>> 31) + b | 0, w = w << 1, b = w, w = w + n | 0, a = b >>> 0 > w >>> 0 ? a + 1 | 0 : a, t[C + 24 >> 2] = w, Me = a, t[C + 28 >> 2] = a, b = t[l + 392 >> 2], n = b + t[C + 16 >> 2] | 0, a = t[C + 20 >> 2] + t[l + 396 >> 2] | 0, a = n >>> 0 < b >>> 0 ? a + 1 | 0 : a, b = n, K = a, n = t[l + 352 >> 2], Nr = n, a = t[l + 356 >> 2], jr = a, a = (a << 1 | n >>> 31) + K | 0, n = n << 1, K = n, n = n + b | 0, a = K >>> 0 > n >>> 0 ? a + 1 | 0 : a, t[C + 16 >> 2] = n, K = a, t[C + 20 >> 2] = a, Ce = t[l + 384 >> 2], b = Ce + t[C + 8 >> 2] | 0, a = t[C + 12 >> 2] + t[l + 388 >> 2] | 0, Ce = b >>> 0 < Ce >>> 0 ? a + 1 | 0 : a, a = t[l + 348 >> 2], Ti = a, ei = t[l + 344 >> 2], or = ei, a = (a << 1 | or >>> 31) + Ce | 0, or = or << 1, b = b + or | 0, a = or >>> 0 > b >>> 0 ? a + 1 | 0 : a, Ce = b, t[C + 8 >> 2] = b, or = a, t[C + 12 >> 2] = a, tr = t[l + 376 >> 2], b = tr + t[C >> 2] | 0, a = t[C + 4 >> 2] + t[l + 380 >> 2] | 0, a = b >>> 0 < tr >>> 0 ? a + 1 | 0 : a, tr = b, kr = a, b = t[l + 336 >> 2], di = b, a = t[l + 340 >> 2], Yr = a, a = (a << 1 | b >>> 31) + kr | 0, b = b << 1, kr = b, b = b + tr | 0, a = kr >>> 0 > b >>> 0 ? a + 1 | 0 : a, t[C >> 2] = b, tr = a, t[C + 4 >> 2] = a, a = Tt + Ii | 0, P = P + nr | 0, a = P >>> 0 < nr >>> 0 ? a + 1 | 0 : a, t[l + 368 >> 2] = P, t[l + 372 >> 2] = a, a = Me + ui | 0, P = w, w = w + wi | 0, a = P >>> 0 > w >>> 0 ? a + 1 | 0 : a, t[l + 360 >> 2] = w, t[l + 364 >> 2] = a, a = K + jr | 0, w = n + Nr | 0, a = w >>> 0 < n >>> 0 ? a + 1 | 0 : a, t[l + 352 >> 2] = w, t[l + 356 >> 2] = a, a = or + Ti | 0, w = Ce + ei | 0, a = w >>> 0 < ei >>> 0 ? a + 1 | 0 : a, t[l + 344 >> 2] = w, t[l + 348 >> 2] = a, a = tr + Yr | 0, l = b + di | 0, a = l >>> 0 < b >>> 0 ? a + 1 | 0 : a, t[pe + 336 >> 2] = l, t[pe + 340 >> 2] = a, zr(C + 40 | 0, gr, ai), zr(lr, lr, pe + 576 | 0), a = t[C + 44 >> 2] + t[pe + 380 >> 2] | 0, w = t[pe + 376 >> 2], l = w + t[C + 40 >> 2] | 0, t[C + 40 >> 2] = l, t[C + 44 >> 2] = l >>> 0 < w >>> 0 ? a + 1 | 0 : a, n = t[pe + 384 >> 2], l = C + 48 | 0, w = n + t[l >> 2] | 0, a = t[l + 4 >> 2] + t[pe + 388 >> 2] | 0, t[l >> 2] = w, t[l + 4 >> 2] = w >>> 0 < n >>> 0 ? a + 1 | 0 : a, n = t[pe + 392 >> 2], l = C + 56 | 0, w = n + t[l >> 2] | 0, a = t[l + 4 >> 2] + t[pe + 396 >> 2] | 0, t[l >> 2] = w, t[l + 4 >> 2] = w >>> 0 < n >>> 0 ? a + 1 | 0 : a, n = t[pe + 400 >> 2], l = C - -64 | 0, w = n + t[l >> 2] | 0, a = t[l + 4 >> 2] + t[pe + 404 >> 2] | 0, t[l >> 2] = w, t[l + 4 >> 2] = w >>> 0 < n >>> 0 ? a + 1 | 0 : a, w = t[pe + 408 >> 2], C = C + 72 | 0, l = w + t[C >> 2] | 0, a = t[C + 4 >> 2] + t[pe + 412 >> 2] | 0, t[C >> 2] = l, t[C + 4 >> 2] = l >>> 0 < w >>> 0 ? a + 1 | 0 : a;
    }
    U = pe + 736 | 0;
  }
  function ss(C, l, w) {
    var n = 0, a = 0, b = 0, P = 0, K = 0, pe = 0, Ce = 0, Me = 0, Tt = 0, tr = 0, nr = 0, or = 0, lr = 0, gr = 0, kr = 0, Nr = 0, jr = 0, Yr = 0, ei = 0, ai = 0, ui = 0, di = 0, Ii = 0, wi = 0, Ei = 0, Ti = 0;
    P = U - 256 | 0, U = P, pe = P + 240 | 0, Pr(pe, t[w >> 2], t[w + 4 >> 2], 0, 0, t[l >> 2], t[l + 4 >> 2], 0, 0), n = t[P + 244 >> 2], t[C >> 2] = t[P + 240 >> 2], t[C + 4 >> 2] = n, Me = P + 208 | 0, Pr(Me, t[w + 8 >> 2], t[w + 12 >> 2], 0, 0, t[l >> 2], t[l + 4 >> 2], 0, 0), K = P + 224 | 0, Pr(K, t[w >> 2], t[w + 4 >> 2], 0, 0, t[l + 8 >> 2], t[l + 12 >> 2], 0, 0), or = C, a = t[P + 208 >> 2], C = pe + 8 | 0, n = t[C >> 2], nr = a + n | 0, Tt = t[P + 212 >> 2], C = Tt + t[C + 4 >> 2] | 0, Ce = n >>> 0 > nr >>> 0 ? C + 1 | 0 : C, C = Ce + t[P + 228 >> 2] | 0, n = t[P + 224 >> 2], pe = n + nr | 0, t[or + 8 >> 2] = pe, b = n >>> 0 > pe >>> 0 ? C + 1 | 0 : C, t[or + 12 >> 2] = b, kr = P + 160 | 0, Pr(kr, t[w + 16 >> 2], t[w + 20 >> 2], 0, 0, t[l >> 2], t[l + 4 >> 2], 0, 0), Yr = P + 176 | 0, Pr(Yr, t[w + 8 >> 2], t[w + 12 >> 2], 0, 0, t[l + 8 >> 2], t[l + 12 >> 2], 0, 0), Nr = P + 192 | 0, Pr(Nr, t[w >> 2], t[w + 4 >> 2], 0, 0, t[l + 16 >> 2], t[l + 20 >> 2], 0, 0), a = (Ce | 0) == (Tt | 0) & a >>> 0 > nr >>> 0 | Ce >>> 0 < Tt >>> 0, C = Me + 8 | 0, n = a + t[C >> 2] | 0, C = t[C + 4 >> 2], a = n >>> 0 < a >>> 0 ? C + 1 | 0 : C, pe = (b | 0) == (Ce | 0) & pe >>> 0 < nr >>> 0 | b >>> 0 < Ce >>> 0, C = K + 8 | 0, b = pe + t[C >> 2] | 0, C = t[C + 4 >> 2], C = (b >>> 0 < pe >>> 0 ? C + 1 | 0 : C) + a | 0, pe = n + b | 0, C = pe >>> 0 < b >>> 0 ? C + 1 | 0 : C, Tt = pe, pe = t[P + 160 >> 2], b = Tt + pe | 0, lr = C, C = C + t[P + 164 >> 2] | 0, C = b >>> 0 < pe >>> 0 ? C + 1 | 0 : C, pe = t[P + 176 >> 2], Me = pe + b | 0, gr = C, C = C + t[P + 180 >> 2] | 0, tr = pe >>> 0 > Me >>> 0 ? C + 1 | 0 : C, C = tr + t[P + 196 >> 2] | 0, pe = t[P + 192 >> 2], Ce = pe + Me | 0, t[or + 16 >> 2] = Ce, K = Ce >>> 0 < pe >>> 0 ? C + 1 | 0 : C, t[or + 20 >> 2] = K, Ii = P + 96 | 0, Pr(Ii, t[w + 24 >> 2], t[w + 28 >> 2], 0, 0, t[l >> 2], t[l + 4 >> 2], 0, 0), ui = P + 112 | 0, Pr(ui, t[w + 16 >> 2], t[w + 20 >> 2], 0, 0, t[l + 8 >> 2], t[l + 12 >> 2], 0, 0), di = P + 128 | 0, Pr(di, t[w + 8 >> 2], t[w + 12 >> 2], 0, 0, t[l + 16 >> 2], t[l + 20 >> 2], 0, 0), ai = P + 144 | 0, Pr(ai, t[w >> 2], t[w + 4 >> 2], 0, 0, t[l + 24 >> 2], t[l + 28 >> 2], 0, 0), pe = (lr | 0) == (gr | 0) & b >>> 0 < Tt >>> 0 | lr >>> 0 > gr >>> 0, C = kr + 8 | 0, nr = pe + t[C >> 2] | 0, C = t[C + 4 >> 2], n = (a | 0) == (lr | 0) & n >>> 0 > Tt >>> 0 | a >>> 0 > lr >>> 0, kr = nr + n | 0, C = pe >>> 0 > nr >>> 0 ? C + 1 | 0 : C, pe = C, a = n >>> 0 > kr >>> 0 ? C + 1 | 0 : C, Tt = kr, n = (tr | 0) == (gr | 0) & b >>> 0 > Me >>> 0 | tr >>> 0 < gr >>> 0, C = Yr + 8 | 0, b = n + t[C >> 2] | 0, C = t[C + 4 >> 2], C = (n >>> 0 > b >>> 0 ? C + 1 | 0 : C) + a | 0, ei = b, b = b + Tt | 0, n = ei >>> 0 > b >>> 0 ? C + 1 | 0 : C, Yr = b, Tt = b, b = (K | 0) == (tr | 0) & Ce >>> 0 < Me >>> 0 | K >>> 0 < tr >>> 0, C = Nr + 8 | 0, Ce = b + t[C >> 2] | 0, C = t[C + 4 >> 2], C = (b >>> 0 > Ce >>> 0 ? C + 1 | 0 : C) + n | 0, b = Ce + Tt | 0, C = b >>> 0 < Ce >>> 0 ? C + 1 | 0 : C, lr = b, b = t[P + 96 >> 2], gr = lr + b | 0, Nr = C, C = C + t[P + 100 >> 2] | 0, C = b >>> 0 > gr >>> 0 ? C + 1 | 0 : C, b = t[P + 112 >> 2], tr = b + gr | 0, jr = C, C = C + t[P + 116 >> 2] | 0, C = b >>> 0 > tr >>> 0 ? C + 1 | 0 : C, b = t[P + 128 >> 2], K = b + tr | 0, ei = C, C = C + t[P + 132 >> 2] | 0, Me = b >>> 0 > K >>> 0 ? C + 1 | 0 : C, C = Me + t[P + 148 >> 2] | 0, b = t[P + 144 >> 2], Ce = b + K | 0, t[or + 24 >> 2] = Ce, C = b >>> 0 > Ce >>> 0 ? C + 1 | 0 : C, t[or + 28 >> 2] = C, wi = P + 48 | 0, Pr(wi, t[w + 24 >> 2], t[w + 28 >> 2], 0, 0, t[l + 8 >> 2], t[l + 12 >> 2], 0, 0), Ei = P - -64 | 0, Pr(Ei, t[w + 16 >> 2], t[w + 20 >> 2], 0, 0, t[l + 16 >> 2], t[l + 20 >> 2], 0, 0), Ti = P + 80 | 0, Pr(Ti, t[w + 8 >> 2], t[w + 12 >> 2], 0, 0, t[l + 24 >> 2], t[l + 28 >> 2], 0, 0), Ce = (C | 0) == (Me | 0) & K >>> 0 > Ce >>> 0 | C >>> 0 < Me >>> 0, C = ai + 8 | 0, b = Ce + t[C >> 2] | 0, C = t[C + 4 >> 2], Ce = b >>> 0 < Ce >>> 0 ? C + 1 | 0 : C, K = (Me | 0) == (ei | 0) & K >>> 0 < tr >>> 0 | Me >>> 0 < ei >>> 0, C = di + 8 | 0, Tt = K + t[C >> 2] | 0, C = t[C + 4 >> 2], Me = K >>> 0 > Tt >>> 0 ? C + 1 | 0 : C, K = (n | 0) == (Nr | 0) & lr >>> 0 < Yr >>> 0 | n >>> 0 > Nr >>> 0, C = (n | 0) == (a | 0) & kr >>> 0 > Yr >>> 0 | n >>> 0 < a >>> 0, n = (a | 0) == (pe | 0) & nr >>> 0 > kr >>> 0 | a >>> 0 < pe >>> 0, a = C + n | 0, C = n >>> 0 > a >>> 0, pe = a + K | 0, nr = pe >>> 0 < a >>> 0 ? C + 1 | 0 : C, n = (Nr | 0) == (jr | 0) & lr >>> 0 > gr >>> 0 | Nr >>> 0 > jr >>> 0, C = Ii + 8 | 0, a = n + t[C >> 2] | 0, C = t[C + 4 >> 2], C = (n >>> 0 > a >>> 0 ? C + 1 | 0 : C) + nr | 0, K = a, a = a + pe | 0, n = K >>> 0 > a >>> 0 ? C + 1 | 0 : C, Nr = a, K = a, a = (jr | 0) == (ei | 0) & tr >>> 0 < gr >>> 0 | jr >>> 0 > ei >>> 0, C = ui + 8 | 0, tr = a + t[C >> 2] | 0, C = t[C + 4 >> 2], C = (a >>> 0 > tr >>> 0 ? C + 1 | 0 : C) + n | 0, K = K + tr | 0, a = K >>> 0 < tr >>> 0 ? C + 1 | 0 : C, C = a + Me | 0, ei = K, gr = K + Tt | 0, kr = K >>> 0 > gr >>> 0 ? C + 1 | 0 : C, C = kr + Ce | 0, K = b + gr | 0, C = K >>> 0 < gr >>> 0 ? C + 1 | 0 : C, Yr = K, K = t[P + 48 >> 2], lr = Yr + K | 0, ai = C, C = C + t[P + 52 >> 2] | 0, jr = K >>> 0 > lr >>> 0 ? C + 1 | 0 : C, C = jr + t[P + 68 >> 2] | 0, Me = t[P + 64 >> 2], K = Me + lr | 0, Tt = t[P + 80 >> 2], tr = K + Tt | 0, Me = K >>> 0 < Me >>> 0 ? C + 1 | 0 : C, C = Me + t[P + 84 >> 2] | 0, t[or + 32 >> 2] = tr, C = tr >>> 0 < Tt >>> 0 ? C + 1 | 0 : C, t[or + 36 >> 2] = C, ui = P + 16 | 0, Pr(ui, t[w + 24 >> 2], t[w + 28 >> 2], 0, 0, t[l + 16 >> 2], t[l + 20 >> 2], 0, 0), di = P + 32 | 0, Pr(di, t[w + 16 >> 2], t[w + 20 >> 2], 0, 0, t[l + 24 >> 2], t[l + 28 >> 2], 0, 0), Tt = (C | 0) == (Me | 0) & K >>> 0 > tr >>> 0 | C >>> 0 < Me >>> 0, C = Ti + 8 | 0, tr = Tt + t[C >> 2] | 0, C = t[C + 4 >> 2], Tt = tr >>> 0 < Tt >>> 0 ? C + 1 | 0 : C, K = (Me | 0) == (jr | 0) & K >>> 0 < lr >>> 0 | Me >>> 0 < jr >>> 0, C = Ei + 8 | 0, Me = K + t[C >> 2] | 0, C = t[C + 4 >> 2], K = K >>> 0 > Me >>> 0 ? C + 1 | 0 : C, Ce = (Ce | 0) == (ai | 0) & b >>> 0 > Yr >>> 0 | Ce >>> 0 > ai >>> 0, b = (a | 0) == (kr | 0) & gr >>> 0 < ei >>> 0 | a >>> 0 > kr >>> 0, C = (n | 0) == (a | 0) & Nr >>> 0 > ei >>> 0 | n >>> 0 > a >>> 0, n = (n | 0) == (nr | 0) & pe >>> 0 > Nr >>> 0 | n >>> 0 < nr >>> 0, a = C + n | 0, C = n >>> 0 > a >>> 0, n = a + b | 0, C = n >>> 0 < a >>> 0 ? C + 1 | 0 : C, pe = n + Ce | 0, b = pe >>> 0 < n >>> 0 ? C + 1 | 0 : C, n = (jr | 0) == (ai | 0) & lr >>> 0 < Yr >>> 0 | jr >>> 0 < ai >>> 0, C = wi + 8 | 0, a = n + t[C >> 2] | 0, C = t[C + 4 >> 2], C = (n >>> 0 > a >>> 0 ? C + 1 | 0 : C) + b | 0, n = a + pe | 0, a = n >>> 0 < a >>> 0 ? C + 1 | 0 : C, C = a + K | 0, K = tr, gr = n, nr = n + Me | 0, tr = nr, Ce = K + tr | 0, n = n >>> 0 > tr >>> 0 ? C + 1 | 0 : C, C = n + Tt | 0, nr = t[P + 16 >> 2], Me = nr + Ce | 0, lr = Ce >>> 0 < tr >>> 0 ? C + 1 | 0 : C, C = lr + t[P + 20 >> 2] | 0, Tt = Me >>> 0 < nr >>> 0 ? C + 1 | 0 : C, C = Tt + t[P + 36 >> 2] | 0, K = t[P + 32 >> 2], nr = K + Me | 0, t[or + 40 >> 2] = nr, K = K >>> 0 > nr >>> 0 ? C + 1 | 0 : C, t[or + 44 >> 2] = K, Pr(P, t[w + 24 >> 2], t[w + 28 >> 2], 0, 0, t[l + 24 >> 2], t[l + 28 >> 2], 0, 0), w = or, l = (Tt | 0) == (lr | 0) & Ce >>> 0 > Me >>> 0 | Tt >>> 0 < lr >>> 0, C = ui + 8 | 0, or = l + t[C >> 2] | 0, C = t[C + 4 >> 2], l = l >>> 0 > or >>> 0 ? C + 1 | 0 : C, Ce = (n | 0) == (lr | 0) & Ce >>> 0 < tr >>> 0 | n >>> 0 > lr >>> 0, C = (n | 0) == (a | 0) & tr >>> 0 < gr >>> 0 | n >>> 0 < a >>> 0, n = (a | 0) == (b | 0) & pe >>> 0 > gr >>> 0 | a >>> 0 < b >>> 0, a = C + n | 0, C = n >>> 0 > a >>> 0, pe = a + Ce | 0, Ce = pe >>> 0 < a >>> 0 ? C + 1 | 0 : C, C = Ce + l | 0, l = pe + or | 0, n = l >>> 0 < pe >>> 0 ? C + 1 | 0 : C, b = l, a = l, l = (K | 0) == (Tt | 0) & Me >>> 0 > nr >>> 0 | K >>> 0 < Tt >>> 0, C = di + 8 | 0, or = l + t[C >> 2] | 0, C = t[C + 4 >> 2], C = (l >>> 0 > or >>> 0 ? C + 1 | 0 : C) + n | 0, a = a + or | 0, l = a >>> 0 < or >>> 0 ? C + 1 | 0 : C, C = l + t[P + 4 >> 2] | 0, or = t[P >> 2], nr = or + a | 0, t[w + 48 >> 2] = nr, C = or >>> 0 > nr >>> 0 ? C + 1 | 0 : C, t[w + 52 >> 2] = C, or = (C | 0) == (l | 0) & a >>> 0 > nr >>> 0 | C >>> 0 < l >>> 0, a = (l | 0) == (n | 0) & a >>> 0 < b >>> 0 | l >>> 0 < n >>> 0, l = (n | 0) == (Ce | 0) & b >>> 0 < pe >>> 0 | n >>> 0 < Ce >>> 0, C = P + 8 | 0, n = l + t[C >> 2] | 0, C = t[C + 4 >> 2], C = l >>> 0 > n >>> 0 ? C + 1 | 0 : C, l = n + a | 0, C = l >>> 0 < n >>> 0 ? C + 1 | 0 : C, b = l, l = l + or | 0, C = b >>> 0 > l >>> 0 ? C + 1 | 0 : C, t[w + 56 >> 2] = l, t[w + 60 >> 2] = C, U = P + 256 | 0;
  }
  function rs(C, l, w, n) {
    var a = 0, b = 0, P = 0, K = 0, pe = 0, Ce = 0, Me = 0, Tt = 0, tr = 0, nr = 0, or = 0, lr = 0, gr = 0, kr = 0, Nr = 0, jr = 0, Yr = 0, ei = 0, ai = 0, ui = 0, di = 0, Ii = 0, wi = 0, Ei = 0, Ti = 0, Di = 0, Qi = 0, Li = 0, Ki = 0, Wi = 0, Xi = 0, $i = 0, In = 0, kn = 0, Dn = 0, Mn = 0, zn = 0, es = 0, ns = 0, fs = 0, ps = 0, Es = 0, Ss = 0, Ps = 0, xs = 0, Bs = 0, vs = 0;
    K = U - 480 | 0, U = K, a = t[w + 4 >> 2], Qi = a, Me = a >> 31, a = t[C + 4 >> 2], tr = a, a = a >> 31, $i = K + 352 | 0, Ti = t[w >> 2], P = t[C >> 2], b = a, Pr($i, Ti, Qi, Me, Me, P, tr, a, a), a = t[w + 12 >> 2], Li = a, nr = a >> 31, a = t[l + 4 >> 2], Tt = a, a = a >> 31, Dn = K + 384 | 0, gr = t[w + 8 >> 2], lr = t[l >> 2], Ce = a, Pr(Dn, gr, Li, nr, nr, lr, Tt, a, a), a = t[w + 20 >> 2], kr = a, a = a >> 31, In = K + 368 | 0, Ki = t[w + 16 >> 2], ui = a, Pr(In, Ki, kr, a, a, P, tr, b, b), kn = t[w + 24 >> 2], w = t[w + 28 >> 2], Nr = w, w = w >> 31, Wi = K + 400 | 0, Ei = w, Pr(Wi, kn, Nr, w, w, lr, Tt, Ce, Ce), fs = t[l + 32 >> 2], w = t[l + 36 >> 2], vs = w, w = w >> 31, Ce = w, b = w & gr, ps = t[C + 32 >> 2], w = t[C + 36 >> 2], Es = w, w = w >> 31, a = b, tr = w, b = w & Ti, w = a + b | 0, a = (tr & Qi) + (Ce & Li) | 0, b = w >>> 0 < b >>> 0 ? a + 1 | 0 : a, a = t[n + 40 >> 2], pe = a, ei = t[K + 388 >> 2], a = ei + t[K + 356 >> 2] | 0, di = t[n + 44 >> 2], ai = t[K + 384 >> 2], P = t[K + 352 >> 2], Tt = ai + P | 0, P = P >>> 0 > Tt >>> 0 ? a + 1 | 0 : a, Ii = ri(pe, di, Tt, P), lr = Ii + w | 0, a = b + ve | 0, Di = w - lr | 0, w = b - (((lr >>> 0 < Ii >>> 0 ? a + 1 | 0 : a) & 1073741823) + (w >>> 0 < lr >>> 0) | 0) | 0, Ii = w, or = w >> 31, w = t[n + 4 >> 2], jr = w, w = w >> 31, Mn = K + 320 | 0, Yr = t[n >> 2], lr = w, Pr(Mn, Di, Ii, or, or, Yr, jr, w, w), b = tr & Ki, w = b + (Ce & kn) | 0, a = (Ce & Nr) + (tr & kr) | 0, b = w >>> 0 < b >>> 0 ? a + 1 | 0 : a, wi = t[K + 404 >> 2], a = wi + t[K + 372 >> 2] | 0, zn = t[K + 400 >> 2], Ce = t[K + 368 >> 2], tr = zn + Ce | 0, Ce = Ce >>> 0 > tr >>> 0 ? a + 1 | 0 : a, di = ri(tr, Ce, pe, di), pe = di + w | 0, a = b + ve | 0, Xi = w - pe | 0, w = b - (((pe >>> 0 < di >>> 0 ? a + 1 | 0 : a) & 1073741823) + (w >>> 0 < pe >>> 0) | 0) | 0, di = w, w = w >> 31, es = K + 336 | 0, ns = w, Pr(es, Xi, di, w, w, Yr, jr, lr, lr), w = t[C + 12 >> 2], pe = w, w = w >> 31, Ss = K + 416 | 0, lr = t[C + 8 >> 2], b = w, Pr(Ss, Ti, Qi, Me, Me, lr, pe, w, w), w = t[l + 12 >> 2], jr = w, w = w >> 31, a = w, Ps = K + 448 | 0, Yr = t[l + 8 >> 2], Pr(Ps, gr, Li, nr, nr, Yr, jr, a, a), xs = K + 432 | 0, Pr(xs, Ki, kr, ui, ui, lr, pe, b, b), Bs = K + 464 | 0, Pr(Bs, kn, Nr, Ei, Ei, Yr, jr, a, a), w = t[K + 336 >> 2], pe = w, lr = t[K + 340 >> 2], a = lr + Ce | 0, w = w + tr | 0, a = w >>> 0 < tr >>> 0 ? a + 1 | 0 : a, b = w, w = a, lr = (lr | 0) == (a | 0) & b >>> 0 < pe >>> 0 | a >>> 0 < lr >>> 0, a = es + 8 | 0, pe = t[a >> 2], Yr = t[a + 4 >> 2], Ce = (Ce | 0) == (wi | 0) & tr >>> 0 < zn >>> 0 | Ce >>> 0 < wi >>> 0, a = In + 8 | 0, tr = t[a >> 2], jr = Wi + 8 | 0, b = tr + t[jr >> 2] | 0, a = t[jr + 4 >> 2] + t[a + 4 >> 2] | 0, a = b >>> 0 < tr >>> 0 ? a + 1 | 0 : a, tr = b, b = b + Ce | 0, a = (tr >>> 0 > b >>> 0 ? a + 1 | 0 : a) + Yr | 0, Ce = b, b = b + pe | 0, a = Ce >>> 0 > b >>> 0 ? a + 1 | 0 : a, Ce = b + lr | 0, b = Ce >>> 0 < b >>> 0 ? a + 1 | 0 : a, tr = b << 2 | Ce >>> 30, lr = Ce << 2 | w >>> 30, jr = t[K + 464 >> 2], w = t[K + 432 >> 2], Ce = jr + w | 0, pe = t[K + 468 >> 2], a = pe + t[K + 436 >> 2] | 0, w = w >>> 0 > Ce >>> 0 ? a + 1 | 0 : a, a = w + tr | 0, tr = Ce + lr | 0, lr = tr >>> 0 < Ce >>> 0 ? a + 1 | 0 : a, Yr = (w | 0) == (lr | 0) & Ce >>> 0 > tr >>> 0 | w >>> 0 > lr >>> 0, Ce = (w | 0) == (pe | 0) & Ce >>> 0 < jr >>> 0 | w >>> 0 < pe >>> 0, a = xs + 8 | 0, pe = t[a >> 2], jr = Bs + 8 | 0, w = pe + t[jr >> 2] | 0, a = t[jr + 4 >> 2] + t[a + 4 >> 2] | 0, a = w >>> 0 < pe >>> 0 ? a + 1 | 0 : a, pe = w, w = w + Ce | 0, a = (b >> 31) + (pe >>> 0 > w >>> 0 ? a + 1 | 0 : a) | 0, b = b >> 30, w = w + b | 0, a = b >>> 0 > w >>> 0 ? a + 1 | 0 : a, Ce = w + Yr | 0, w = Ce >>> 0 < w >>> 0 ? a + 1 | 0 : a, b = t[K + 320 >> 2], jr = b, Yr = t[K + 324 >> 2], a = Yr + P | 0, b = b + Tt | 0, a = b >>> 0 < Tt >>> 0 ? a + 1 | 0 : a, pe = b, b = a, pe = (Yr | 0) == (a | 0) & pe >>> 0 < jr >>> 0 | a >>> 0 < Yr >>> 0, a = Mn + 8 | 0, Yr = t[a >> 2], jr = t[a + 4 >> 2], Tt = (P | 0) == (ei | 0) & Tt >>> 0 < ai >>> 0 | P >>> 0 < ei >>> 0, a = $i + 8 | 0, ei = t[a >> 2], wi = Dn + 8 | 0, P = ei + t[wi >> 2] | 0, a = t[wi + 4 >> 2] + t[a + 4 >> 2] | 0, a = P >>> 0 < ei >>> 0 ? a + 1 | 0 : a, ai = P, P = P + Tt | 0, a = (ai >>> 0 > P >>> 0 ? a + 1 | 0 : a) + jr | 0, Tt = P, P = P + Yr | 0, a = Tt >>> 0 > P >>> 0 ? a + 1 | 0 : a, Tt = P + pe | 0, P = Tt >>> 0 < P >>> 0 ? a + 1 | 0 : a, pe = P << 2 | Tt >>> 30, Tt = Tt << 2 | b >>> 30, jr = t[K + 448 >> 2], ei = t[K + 416 >> 2], b = jr + ei | 0, Yr = t[K + 452 >> 2], a = Yr + t[K + 420 >> 2] | 0, a = b >>> 0 < ei >>> 0 ? a + 1 | 0 : a, ei = b, b = a, a = a + pe | 0, pe = Tt + ei | 0, Tt = pe >>> 0 < ei >>> 0 ? a + 1 | 0 : a, wi = (b | 0) == (Tt | 0) & pe >>> 0 < ei >>> 0 | b >>> 0 > Tt >>> 0, ei = (b | 0) == (Yr | 0) & jr >>> 0 > ei >>> 0 | b >>> 0 < Yr >>> 0, a = Ss + 8 | 0, Yr = t[a >> 2], jr = Ps + 8 | 0, b = Yr + t[jr >> 2] | 0, a = t[jr + 4 >> 2] + t[a + 4 >> 2] | 0, a = b >>> 0 < Yr >>> 0 ? a + 1 | 0 : a, jr = b, b = b + ei | 0, a = (P >> 31) + (jr >>> 0 > b >>> 0 ? a + 1 | 0 : a) | 0, P = P >> 30, b = b + P | 0, a = P >>> 0 > b >>> 0 ? a + 1 | 0 : a, P = b + wi | 0, b = P >>> 0 < b >>> 0 ? a + 1 | 0 : a, ei = t[l + 24 >> 2], Yr = t[l + 28 >> 2], jr = t[l + 16 >> 2], wi = t[l + 20 >> 2], $i = t[C + 24 >> 2], Dn = t[C + 28 >> 2], In = t[C + 16 >> 2], Wi = t[C + 20 >> 2], a = t[n + 8 >> 2], ai = t[n + 12 >> 2], a | ai && (es = K + 304 | 0, zn = a, a = ai >> 31, Pr(es, Di, Ii, or, or, zn, ai, a, a), Mn = K + 288 | 0, Pr(Mn, Xi, di, ns, ns, zn, ai, a, a), or = lr, ai = tr, lr = t[K + 288 >> 2], tr = tr + lr | 0, a = or + t[K + 292 >> 2] | 0, lr = tr >>> 0 < lr >>> 0 ? a + 1 | 0 : a, or = (or | 0) == (lr | 0) & tr >>> 0 < ai >>> 0 | or >>> 0 > lr >>> 0, a = Mn + 8 | 0, ai = t[a >> 2], Ce = ai + Ce | 0, a = w + t[a + 4 >> 2] | 0, a = Ce >>> 0 < ai >>> 0 ? a + 1 | 0 : a, w = Ce, Ce = Ce + or | 0, w = w >>> 0 > Ce >>> 0 ? a + 1 | 0 : a, or = Tt, ai = pe, Tt = t[K + 304 >> 2], pe = pe + Tt | 0, a = or + t[K + 308 >> 2] | 0, Tt = pe >>> 0 < Tt >>> 0 ? a + 1 | 0 : a, or = (or | 0) == (Tt | 0) & pe >>> 0 < ai >>> 0 | Tt >>> 0 < or >>> 0, a = es + 8 | 0, ai = t[a >> 2], P = ai + P | 0, a = b + t[a + 4 >> 2] | 0, a = P >>> 0 < ai >>> 0 ? a + 1 | 0 : a, b = P, P = P + or | 0, b = b >>> 0 > P >>> 0 ? a + 1 | 0 : a), t[C >> 2] = pe, t[C + 4 >> 2] = Tt & 1073741823, t[l >> 2] = tr, t[l + 4 >> 2] = lr & 1073741823, a = Wi >> 31, pe = a, ai = K + 272 | 0, or = Ti, Pr(ai, or, Qi, Me, Me, In, Wi, a, a), ns = K + 240 | 0, Ti = gr, Me = nr, gr = wi, a = gr >> 31, Pr(ns, Ti, Li, Me, Me, jr, gr, a, a), nr = K + 256 | 0, Pr(nr, Ki, kr, ui, ui, In, Wi, pe, pe), gr = K + 224 | 0, Pr(gr, kn, Nr, Ei, Ei, jr, wi, a, a), ui = t[K + 224 >> 2], pe = t[K + 256 >> 2], tr = ui + pe | 0, Me = t[K + 228 >> 2], a = Me + t[K + 260 >> 2] | 0, pe = pe >>> 0 > tr >>> 0 ? a + 1 | 0 : a, ui = (Me | 0) == (pe | 0) & tr >>> 0 < ui >>> 0 | pe >>> 0 < Me >>> 0, a = nr + 8 | 0, nr = t[a >> 2], gr = gr + 8 | 0, Me = nr + t[gr >> 2] | 0, a = t[gr + 4 >> 2] + t[a + 4 >> 2] | 0, a = Me >>> 0 < nr >>> 0 ? a + 1 | 0 : a, nr = Me, Me = Me + ui | 0, a = (w >> 31) + (nr >>> 0 > Me >>> 0 ? a + 1 | 0 : a) | 0, gr = w >> 30, Me = Me + gr | 0, a = gr >>> 0 > Me >>> 0 ? a + 1 | 0 : a, nr = Me, Me = a, a = w << 2 | Ce >>> 30, w = Ce << 2 | lr >>> 30, Ce = w + tr | 0, a = a + pe | 0, w = w >>> 0 > Ce >>> 0 ? a + 1 | 0 : a, lr = (pe | 0) == (w | 0) & Ce >>> 0 < tr >>> 0 | w >>> 0 < pe >>> 0, tr = lr + nr | 0, a = Me, lr = tr >>> 0 < lr >>> 0 ? a + 1 | 0 : a, gr = t[K + 240 >> 2], Me = t[K + 272 >> 2], pe = gr + Me | 0, nr = t[K + 244 >> 2], a = nr + t[K + 276 >> 2] | 0, Me = pe >>> 0 < Me >>> 0 ? a + 1 | 0 : a, gr = (nr | 0) == (Me | 0) & pe >>> 0 < gr >>> 0 | Me >>> 0 < nr >>> 0, a = ai + 8 | 0, ui = t[a >> 2], Ei = ns + 8 | 0, nr = ui + t[Ei >> 2] | 0, a = t[Ei + 4 >> 2] + t[a + 4 >> 2] | 0, a = nr >>> 0 < ui >>> 0 ? a + 1 | 0 : a, jr = nr, nr = nr + gr | 0, a = (b >> 31) + (jr >>> 0 > nr >>> 0 ? a + 1 | 0 : a) | 0, ui = b >> 30, nr = nr + ui | 0, a = ui >>> 0 > nr >>> 0 ? a + 1 | 0 : a, gr = nr, nr = a, a = b << 2 | P >>> 30, b = P << 2 | Tt >>> 30, P = b + pe | 0, a = a + Me | 0, b = b >>> 0 > P >>> 0 ? a + 1 | 0 : a, pe = (Me | 0) == (b | 0) & P >>> 0 < pe >>> 0 | b >>> 0 < Me >>> 0, Tt = pe + gr | 0, a = nr, pe = pe >>> 0 > Tt >>> 0 ? a + 1 | 0 : a, nr = t[n + 16 >> 2], gr = t[n + 20 >> 2], nr | gr && (a = gr >> 31, ui = K + 208 | 0, Me = a, a = Ii >> 31, Pr(ui, nr, gr, Me, Me, Di, Ii, a, a), Ei = K + 192 | 0, a = di >> 31, Pr(Ei, nr, gr, Me, Me, Xi, di, a, a), Me = t[K + 196 >> 2], a = Me + w | 0, w = Ce, nr = t[K + 192 >> 2], Ce = nr + Ce | 0, w = w >>> 0 > Ce >>> 0 ? a + 1 | 0 : a, nr = (Me | 0) == (w | 0) & Ce >>> 0 < nr >>> 0 | w >>> 0 < Me >>> 0, a = Ei + 8 | 0, Me = t[a >> 2] + tr | 0, a = t[a + 4 >> 2] + lr | 0, a = tr >>> 0 > Me >>> 0 ? a + 1 | 0 : a, tr = Me + nr | 0, lr = tr >>> 0 < Me >>> 0 ? a + 1 | 0 : a, Me = t[K + 212 >> 2], a = Me + b | 0, b = P, nr = t[K + 208 >> 2], P = nr + P | 0, b = b >>> 0 > P >>> 0 ? a + 1 | 0 : a, nr = (Me | 0) == (b | 0) & P >>> 0 < nr >>> 0 | b >>> 0 < Me >>> 0, a = ui + 8 | 0, Me = t[a >> 2] + Tt | 0, a = t[a + 4 >> 2] + pe | 0, a = Tt >>> 0 > Me >>> 0 ? a + 1 | 0 : a, Tt = Me + nr | 0, pe = Tt >>> 0 < Me >>> 0 ? a + 1 | 0 : a), t[C + 8 >> 2] = P, t[C + 12 >> 2] = b & 1073741823, t[l + 8 >> 2] = Ce, t[l + 12 >> 2] = w & 1073741823, a = Qi >> 31, Me = a, a = Dn >> 31, In = K + 176 | 0, gr = or, Ce = a, Pr(In, or, Qi, Me, Me, $i, Dn, a, a), a = Li >> 31, nr = a, a = Yr >> 31, Wi = K + 144 | 0, P = a, Pr(Wi, Ti, Li, nr, nr, ei, Yr, a, a), a = kr, ui = a, a = a >> 31, ai = K + 160 | 0, Ei = a, Pr(ai, Ki, kr, a, a, $i, Dn, Ce, Ce), a = Nr, jr = a, a = a >> 31, $i = K + 128 | 0, wi = a, Pr($i, kn, Nr, a, a, ei, Yr, P, P), Nr = t[K + 128 >> 2], Ce = t[K + 160 >> 2], P = Nr + Ce | 0, kr = t[K + 132 >> 2], a = kr + t[K + 164 >> 2] | 0, Ce = P >>> 0 < Ce >>> 0 ? a + 1 | 0 : a, or = lr << 2 | tr >>> 30, w = tr << 2 | w >>> 30, tr = w + P | 0, a = Ce + or | 0, w = w >>> 0 > tr >>> 0 ? a + 1 | 0 : a, a = Ce, Ce = tr, or = (w | 0) == (a | 0) & P >>> 0 > Ce >>> 0 | w >>> 0 < a >>> 0, tr = (a | 0) == (kr | 0) & P >>> 0 < Nr >>> 0 | a >>> 0 < kr >>> 0, a = ai + 8 | 0, kr = t[a >> 2], Nr = $i + 8 | 0, P = kr + t[Nr >> 2] | 0, a = t[Nr + 4 >> 2] + t[a + 4 >> 2] | 0, a = P >>> 0 < kr >>> 0 ? a + 1 | 0 : a, Nr = P, P = P + tr | 0, a = (lr >> 31) + (Nr >>> 0 > P >>> 0 ? a + 1 | 0 : a) | 0, lr = lr >> 30, P = P + lr | 0, a = lr >>> 0 > P >>> 0 ? a + 1 | 0 : a, tr = P + or | 0, lr = tr >>> 0 < P >>> 0 ? a + 1 | 0 : a, ei = t[K + 144 >> 2], P = t[K + 176 >> 2], or = ei + P | 0, Nr = t[K + 148 >> 2], a = Nr + t[K + 180 >> 2] | 0, P = P >>> 0 > or >>> 0 ? a + 1 | 0 : a, kr = pe << 2 | Tt >>> 30, b = Tt << 2 | b >>> 30, Tt = b + or | 0, a = P + kr | 0, b = b >>> 0 > Tt >>> 0 ? a + 1 | 0 : a, a = P, P = Tt, kr = (b | 0) == (a | 0) & or >>> 0 > P >>> 0 | a >>> 0 > b >>> 0, or = (a | 0) == (Nr | 0) & or >>> 0 < ei >>> 0 | a >>> 0 < Nr >>> 0, a = In + 8 | 0, Nr = t[a >> 2], ei = Wi + 8 | 0, Tt = Nr + t[ei >> 2] | 0, a = t[ei + 4 >> 2] + t[a + 4 >> 2] | 0, a = Tt >>> 0 < Nr >>> 0 ? a + 1 | 0 : a, Nr = Tt, Tt = Tt + or | 0, a = (pe >> 31) + (Nr >>> 0 > Tt >>> 0 ? a + 1 | 0 : a) | 0, pe = pe >> 30, Tt = pe + Tt | 0, a = pe >>> 0 > Tt >>> 0 ? a + 1 | 0 : a, pe = Tt, Tt = Tt + kr | 0, pe = pe >>> 0 > Tt >>> 0 ? a + 1 | 0 : a, kr = t[n + 24 >> 2], Nr = t[n + 28 >> 2], kr | Nr && (a = Nr >> 31, ei = K + 112 | 0, or = a, a = Ii >> 31, Pr(ei, kr, Nr, or, or, Di, Ii, a, a), Yr = K + 96 | 0, a = di >> 31, Pr(Yr, kr, Nr, or, or, Xi, di, a, a), or = t[K + 100 >> 2], a = or + w | 0, w = Ce, kr = t[K + 96 >> 2], Ce = kr + Ce | 0, w = w >>> 0 > Ce >>> 0 ? a + 1 | 0 : a, kr = (or | 0) == (w | 0) & Ce >>> 0 < kr >>> 0 | w >>> 0 < or >>> 0, a = Yr + 8 | 0, or = t[a >> 2] + tr | 0, a = t[a + 4 >> 2] + lr | 0, a = tr >>> 0 > or >>> 0 ? a + 1 | 0 : a, tr = or + kr | 0, lr = tr >>> 0 < or >>> 0 ? a + 1 | 0 : a, or = t[K + 116 >> 2], a = or + b | 0, b = P, kr = t[K + 112 >> 2], P = kr + P | 0, b = b >>> 0 > P >>> 0 ? a + 1 | 0 : a, kr = (or | 0) == (b | 0) & P >>> 0 < kr >>> 0 | b >>> 0 < or >>> 0, a = ei + 8 | 0, or = t[a >> 2] + Tt | 0, a = t[a + 4 >> 2] + pe | 0, a = Tt >>> 0 > or >>> 0 ? a + 1 | 0 : a, Tt = or + kr | 0, pe = Tt >>> 0 < or >>> 0 ? a + 1 | 0 : a), t[C + 16 >> 2] = P, t[C + 20 >> 2] = b & 1073741823, t[l + 16 >> 2] = Ce, t[l + 20 >> 2] = w & 1073741823, a = Es >> 31, P = a, kr = K + 80 | 0, Nr = Es, Pr(kr, gr, Qi, Me, Me, ps, Nr, a, a), Qi = K + 48 | 0, Me = nr, gr = vs, a = gr >> 31, Pr(Qi, Ti, Li, Me, Me, fs, gr, a, a), Ti = K - -64 | 0, Pr(Ti, Ki, ui, Ei, Ei, ps, Nr, P, P), Li = K + 32 | 0, Pr(Li, kn, jr, wi, wi, fs, gr, a, a), Ce = t[n + 32 >> 2], n = t[n + 36 >> 2], P = n, n = P >> 31, a = Ii >> 31, Pr(K, Ce, P, n, n, Di, Ii, a, a), gr = K + 16 | 0, a = di >> 31, Pr(gr, Ce, P, n, n, Xi, di, a, a), Ce = C, Nr = t[K + 48 >> 2], C = t[K + 80 >> 2], n = Nr + C | 0, nr = t[K + 52 >> 2], a = nr + t[K + 84 >> 2] | 0, C = C >>> 0 > n >>> 0 ? a + 1 | 0 : a, Ii = n, b = Tt << 2 | b >>> 30, n = n + b | 0, a = C + (pe << 2 | Tt >>> 30) | 0, P = n >>> 0 < b >>> 0 ? a + 1 | 0 : a, a = P + t[K + 4 >> 2] | 0, Di = n, n = t[K >> 2], b = Di + n | 0, Me = b, t[Ce + 24 >> 2] = b, n = n >>> 0 > b >>> 0 ? a + 1 | 0 : a, t[Ce + 28 >> 2] = n & 1073741823, b = l, l = tr << 2 | w >>> 30, tr = lr << 2 | tr >>> 30, Ki = t[K + 32 >> 2], w = t[K + 64 >> 2], Tt = Ki + w | 0, or = t[K + 36 >> 2], a = or + t[K + 68 >> 2] | 0, w = w >>> 0 > Tt >>> 0 ? a + 1 | 0 : a, a = w + tr | 0, l = l + Tt | 0, tr = l >>> 0 < Tt >>> 0 ? a + 1 | 0 : a, a = tr + t[K + 20 >> 2] | 0, di = l, l = t[K + 16 >> 2], Xi = di + l | 0, t[b + 24 >> 2] = Xi, l = l >>> 0 > Xi >>> 0 ? a + 1 | 0 : a, t[b + 28 >> 2] = l & 1073741823, Me = (n | 0) == (P | 0) & Me >>> 0 < Di >>> 0 | n >>> 0 < P >>> 0, a = K + 8 | 0, kn = t[a >> 2], ui = t[a + 4 >> 2], Di = (C | 0) == (P | 0) & Ii >>> 0 > Di >>> 0 | C >>> 0 > P >>> 0, P = (C | 0) == (nr | 0) & Nr >>> 0 > Ii >>> 0 | C >>> 0 < nr >>> 0, a = kr + 8 | 0, Ii = t[a >> 2], nr = Qi + 8 | 0, C = Ii + t[nr >> 2] | 0, a = t[nr + 4 >> 2] + t[a + 4 >> 2] | 0, a = C >>> 0 < Ii >>> 0 ? a + 1 | 0 : a, nr = C, C = C + P | 0, a = (pe >> 31) + (nr >>> 0 > C >>> 0 ? a + 1 | 0 : a) | 0, pe = pe >> 30, C = C + pe | 0, a = pe >>> 0 > C >>> 0 ? a + 1 | 0 : a, P = C, C = C + Di | 0, a = (P >>> 0 > C >>> 0 ? a + 1 | 0 : a) + ui | 0, P = C, C = C + kn | 0, a = P >>> 0 > C >>> 0 ? a + 1 | 0 : a, P = C, C = C + Me | 0, P = (P >>> 0 > C >>> 0 ? a + 1 | 0 : a) << 2 | C >>> 30, t[Ce + 32 >> 2] = C << 2 | n >>> 30, t[Ce + 36 >> 2] = P, Ce = (l | 0) == (tr | 0) & di >>> 0 > Xi >>> 0 | l >>> 0 < tr >>> 0, C = gr + 8 | 0, P = t[C >> 2], pe = t[C + 4 >> 2], tr = (w | 0) == (tr | 0) & Tt >>> 0 > di >>> 0 | w >>> 0 > tr >>> 0, w = (w | 0) == (or | 0) & Tt >>> 0 < Ki >>> 0 | w >>> 0 < or >>> 0, n = Ti + 8 | 0, Tt = t[n >> 2], a = Li + 8 | 0, C = Tt + t[a >> 2] | 0, a = t[a + 4 >> 2] + t[n + 4 >> 2] | 0, a = C >>> 0 < Tt >>> 0 ? a + 1 | 0 : a, n = C, C = C + w | 0, a = (lr >> 31) + (n >>> 0 > C >>> 0 ? a + 1 | 0 : a) | 0, n = lr >> 30, C = C + n | 0, a = n >>> 0 > C >>> 0 ? a + 1 | 0 : a, w = C, C = C + tr | 0, a = (w >>> 0 > C >>> 0 ? a + 1 | 0 : a) + pe | 0, w = C, C = C + P | 0, a = w >>> 0 > C >>> 0 ? a + 1 | 0 : a, w = C, C = C + Ce | 0, w = (w >>> 0 > C >>> 0 ? a + 1 | 0 : a) << 2 | C >>> 30, t[b + 32 >> 2] = C << 2 | l >>> 30, t[b + 36 >> 2] = w, U = K + 480 | 0;
  }
  function is(C, l) {
    var w = 0, n = 0, a = 0;
    w = l;
    e: {
      if (l >>> 0 <= 15) {
        l = C;
        break e;
      }
      if (n = 0 - C & 3, a = n + C | 0, n)
        for (l = C; c[l | 0] = 0, l = l + 1 | 0, a >>> 0 > l >>> 0; )
          ;
      if (w = w - n | 0, n = w & -4, l = n + a | 0, (n | 0) > 0)
        for (; t[a >> 2] = 0, a = a + 4 | 0, a >>> 0 < l >>> 0; )
          ;
      w = w & 3;
    }
    if (w)
      for (w = l + w | 0; c[l | 0] = 0, l = l + 1 | 0, w >>> 0 > l >>> 0; )
        ;
    return C;
  }
  function Pr(C, l, w, n, a, b, P, K, pe) {
    var Ce = 0, Me = 0, Tt = 0, tr = 0, nr = 0, or = 0, lr = 0;
    Ce = ri(b, 0, l, 0), tr = C, Me = ve, lr = l, l = ri(l, 0, P, 0), Tt = ve, nr = ri(b, 0, w, 0), or = ve, C = Tt + or | 0, Tt = l + nr | 0, l = Tt >>> 0 < nr >>> 0 ? C + 1 | 0 : C, C = Me + Tt | 0, C = 0 > Ce >>> 0 ? C + 1 | 0 : C, t[tr >> 2] = Ce, t[tr + 4 >> 2] = C, Me = (C | 0) == (Me | 0) & Ce >>> 0 < Ce >>> 0 | C >>> 0 < Me >>> 0, C = (l | 0) == (or | 0) & Tt >>> 0 < nr >>> 0 | l >>> 0 < or >>> 0, Ce = l, l = l + ri(w, 0, P, 0) | 0, C = ve + C | 0, C = l >>> 0 < Ce >>> 0 ? C + 1 | 0 : C, Ce = l, l = l + Me | 0, Ce = Ce >>> 0 > l >>> 0 ? C + 1 | 0 : C, C = ri(lr, w, K, pe), K = ve, n = ri(n, a, b, P), w = n + C | 0, C = K + ve | 0, C = (w >>> 0 < n >>> 0 ? C + 1 | 0 : C) + Ce | 0, l = l + w | 0, C = l >>> 0 < w >>> 0 ? C + 1 | 0 : C, t[tr + 8 >> 2] = l, t[tr + 12 >> 2] = C;
  }
  function as(C, l, w) {
    var n = 0, a = 0, b = 0, P = 0, K = 0, pe = 0, Ce = 0, Me = 0;
    P = w;
    e: {
      if (w >>> 0 <= 15) {
        w = C;
        break e;
      }
      if (b = 0 - C & 3, a = b + C | 0, b)
        for (w = C, n = l; c[w | 0] = d[n | 0], n = n + 1 | 0, w = w + 1 | 0, a >>> 0 > w >>> 0; )
          ;
      P = P - b | 0, K = P & -4, w = K + a | 0, b = l + b | 0, n = b & 3;
      t: {
        if (n) {
          if ((K | 0) <= 0)
            break t;
          for (pe = b & -4, l = pe + 4 | 0, Ce = n << 3, Me = 0 - Ce & 24, n = t[pe >> 2]; pe = n >>> Ce | 0, n = t[l >> 2], t[a >> 2] = pe | n << Me, l = l + 4 | 0, a = a + 4 | 0, a >>> 0 < w >>> 0; )
            ;
          break t;
        }
        if ((K | 0) <= 0)
          break t;
        for (l = b; t[a >> 2] = t[l >> 2], l = l + 4 | 0, a = a + 4 | 0, a >>> 0 < w >>> 0; )
          ;
      }
      P = P & 3, l = b + K | 0;
    }
    if (P)
      for (n = w + P | 0; c[w | 0] = d[l | 0], l = l + 1 | 0, w = w + 1 | 0, n >>> 0 > w >>> 0; )
        ;
    return C;
  }
  function Rs(C, l) {
    var w = 0, n = 0;
    return C | l ? (w = l - 1 | 0, n = C - 1 | 0, w = (n | 0) != -1 ? w + 1 | 0 : w, n = C ^ n, C = D(l ^ w), (C | 0) == 32 && (C = D(n) + 32 | 0), ve = 0 - (C >>> 0 > 63) | 0, 63 - C | 0) : (ve = 0, 64);
  }
  function ri(C, l, w, n) {
    var a = 0, b = 0, P = 0, K = 0, pe = 0, Ce = 0;
    return a = w & 65535, b = C & 65535, P = B(a, b), K = w >>> 16 | 0, Ce = B(b, K), pe = C >>> 16 | 0, b = B(a, pe) + (P >>> 16 | 0) | 0, a = Ce + (b & 65535) | 0, ve = (B(l, w) + B(K, pe) | 0) + B(C, n) + (b >>> 16) + (a >>> 16) | 0, P & 65535 | a << 16;
  }
  function Tr(C, l) {
    var w = 0, n = 0;
    return w = l & 31, n = (-1 >>> w & C) << w, w = C, C = 0 - l & 31, n | (w & -1 << C) >>> C;
  }
  bufferView = d, initActiveSegments();
  var yi = [null, xe, Fe, ke, Ci, Si, hr];
  function ki() {
    return g.byteLength / 65536 | 0;
  }
  function qi(C) {
    C = C | 0;
    var l = ki() | 0, w = l + C | 0;
    if (l < w && w < 65536) {
      var n = new ArrayBuffer(B(w, 65536)), a = new Int8Array(n);
      a.set(c), c = new Int8Array(n), y = new Int16Array(n), t = new Int32Array(n), d = new Uint8Array(n), E = new Uint16Array(n), g = n, bufferView = d;
    }
    return l;
  }
  return {
    memory: Object.create(Object.prototype, {
      grow: {
        value: qi
      },
      buffer: {
        get: function() {
          return g;
        }
      }
    }),
    initializeContext: st,
    isPoint: Dt,
    PUBLIC_KEY_INPUT: {
      get value() {
        return L;
      },
      set value(C) {
        L = C;
      }
    },
    pointAdd: er,
    PUBLIC_KEY_INPUT2: {
      get value() {
        return H;
      },
      set value(C) {
        H = C;
      }
    },
    pointAddScalar: xt,
    TWEAK_INPUT: {
      get value() {
        return fe;
      },
      set value(C) {
        fe = C;
      }
    },
    xOnlyPointAddTweak: ir,
    X_ONLY_PUBLIC_KEY_INPUT: {
      get value() {
        return ge;
      },
      set value(C) {
        ge = C;
      }
    },
    xOnlyPointAddTweakCheck: sr,
    X_ONLY_PUBLIC_KEY_INPUT2: {
      get value() {
        return Ie;
      },
      set value(C) {
        Ie = C;
      }
    },
    pointCompress: yr,
    pointFromScalar: wr,
    PRIVATE_INPUT: {
      get value() {
        return Ee;
      },
      set value(C) {
        Ee = C;
      }
    },
    xOnlyPointFromScalar: qr,
    xOnlyPointFromPoint: Mr,
    pointMultiply: Dr,
    privateAdd: Qr,
    privateSub: Xr,
    privateNegate: Vr,
    sign: Ur,
    HASH_INPUT: {
      get value() {
        return Se;
      },
      set value(C) {
        Se = C;
      }
    },
    EXTRA_DATA_INPUT: {
      get value() {
        return ze;
      },
      set value(C) {
        ze = C;
      }
    },
    SIGNATURE_INPUT: {
      get value() {
        return He;
      },
      set value(C) {
        He = C;
      }
    },
    signRecoverable: Sr,
    signSchnorr: Gr,
    verify: Fr,
    recover: br,
    verifySchnorr: Ar,
    rustsecp256k1_v0_8_1_default_error_callback_fn: hr,
    rustsecp256k1_v0_8_1_default_illegal_callback_fn: hr,
    __data_end: {
      get value() {
        return Pe;
      },
      set value(C) {
        Pe = C;
      }
    },
    __heap_base: {
      get value() {
        return De;
      },
      set value(C) {
        De = C;
      }
    }
  };
}
var retasmFunc = asmFunc({
  "./rand.js": $_rand_js,
  "./validate_error.js": $_validate_error_js
}), memory = retasmFunc.memory, initializeContext = retasmFunc.initializeContext, isPoint$1 = retasmFunc.isPoint, PUBLIC_KEY_INPUT$1 = retasmFunc.PUBLIC_KEY_INPUT, pointAdd$1 = retasmFunc.pointAdd, PUBLIC_KEY_INPUT2$1 = retasmFunc.PUBLIC_KEY_INPUT2, pointAddScalar$1 = retasmFunc.pointAddScalar, TWEAK_INPUT$1 = retasmFunc.TWEAK_INPUT, xOnlyPointAddTweak$1 = retasmFunc.xOnlyPointAddTweak, X_ONLY_PUBLIC_KEY_INPUT$1 = retasmFunc.X_ONLY_PUBLIC_KEY_INPUT, xOnlyPointAddTweakCheck$1 = retasmFunc.xOnlyPointAddTweakCheck, X_ONLY_PUBLIC_KEY_INPUT2$1 = retasmFunc.X_ONLY_PUBLIC_KEY_INPUT2, pointCompress$1 = retasmFunc.pointCompress, pointFromScalar$1 = retasmFunc.pointFromScalar, PRIVATE_INPUT = retasmFunc.PRIVATE_INPUT, xOnlyPointFromScalar$1 = retasmFunc.xOnlyPointFromScalar, xOnlyPointFromPoint$1 = retasmFunc.xOnlyPointFromPoint, pointMultiply$1 = retasmFunc.pointMultiply, privateAdd$1 = retasmFunc.privateAdd, privateSub$1 = retasmFunc.privateSub, privateNegate$1 = retasmFunc.privateNegate, sign$1 = retasmFunc.sign, HASH_INPUT$1 = retasmFunc.HASH_INPUT, EXTRA_DATA_INPUT$1 = retasmFunc.EXTRA_DATA_INPUT, SIGNATURE_INPUT$1 = retasmFunc.SIGNATURE_INPUT, signRecoverable$1 = retasmFunc.signRecoverable, signSchnorr$2 = retasmFunc.signSchnorr, verify$1 = retasmFunc.verify, recover$1 = retasmFunc.recover, verifySchnorr$1 = retasmFunc.verifySchnorr, rustsecp256k1_v0_8_1_default_error_callback_fn = retasmFunc.rustsecp256k1_v0_8_1_default_error_callback_fn, rustsecp256k1_v0_8_1_default_illegal_callback_fn = retasmFunc.rustsecp256k1_v0_8_1_default_illegal_callback_fn, __data_end = retasmFunc.__data_end, __heap_base = retasmFunc.__heap_base;
const wasm = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  EXTRA_DATA_INPUT: EXTRA_DATA_INPUT$1,
  HASH_INPUT: HASH_INPUT$1,
  PRIVATE_INPUT,
  PUBLIC_KEY_INPUT: PUBLIC_KEY_INPUT$1,
  PUBLIC_KEY_INPUT2: PUBLIC_KEY_INPUT2$1,
  SIGNATURE_INPUT: SIGNATURE_INPUT$1,
  TWEAK_INPUT: TWEAK_INPUT$1,
  X_ONLY_PUBLIC_KEY_INPUT: X_ONLY_PUBLIC_KEY_INPUT$1,
  X_ONLY_PUBLIC_KEY_INPUT2: X_ONLY_PUBLIC_KEY_INPUT2$1,
  __data_end,
  __heap_base,
  initializeContext,
  isPoint: isPoint$1,
  memory,
  pointAdd: pointAdd$1,
  pointAddScalar: pointAddScalar$1,
  pointCompress: pointCompress$1,
  pointFromScalar: pointFromScalar$1,
  pointMultiply: pointMultiply$1,
  privateAdd: privateAdd$1,
  privateNegate: privateNegate$1,
  privateSub: privateSub$1,
  recover: recover$1,
  rustsecp256k1_v0_8_1_default_error_callback_fn,
  rustsecp256k1_v0_8_1_default_illegal_callback_fn,
  sign: sign$1,
  signRecoverable: signRecoverable$1,
  signSchnorr: signSchnorr$2,
  verify: verify$1,
  verifySchnorr: verifySchnorr$1,
  xOnlyPointAddTweak: xOnlyPointAddTweak$1,
  xOnlyPointAddTweakCheck: xOnlyPointAddTweakCheck$1,
  xOnlyPointFromPoint: xOnlyPointFromPoint$1,
  xOnlyPointFromScalar: xOnlyPointFromScalar$1
}, Symbol.toStringTag, { value: "Module" })), WASM_BUFFER = new Uint8Array(wasm.memory.buffer), WASM_PRIVATE_KEY_PTR = wasm.PRIVATE_INPUT.value, WASM_PUBLIC_KEY_INPUT_PTR = wasm.PUBLIC_KEY_INPUT.value, WASM_PUBLIC_KEY_INPUT_PTR2 = wasm.PUBLIC_KEY_INPUT2.value, WASM_X_ONLY_PUBLIC_KEY_INPUT_PTR = wasm.X_ONLY_PUBLIC_KEY_INPUT.value, WASM_X_ONLY_PUBLIC_KEY_INPUT2_PTR = wasm.X_ONLY_PUBLIC_KEY_INPUT2.value, WASM_TWEAK_INPUT_PTR = wasm.TWEAK_INPUT.value, WASM_HASH_INPUT_PTR = wasm.HASH_INPUT.value, WASM_EXTRA_DATA_INPUT_PTR = wasm.EXTRA_DATA_INPUT.value, WASM_SIGNATURE_INPUT_PTR = wasm.SIGNATURE_INPUT.value, PRIVATE_KEY_INPUT = WASM_BUFFER.subarray(WASM_PRIVATE_KEY_PTR, WASM_PRIVATE_KEY_PTR + PRIVATE_KEY_SIZE), PUBLIC_KEY_INPUT = WASM_BUFFER.subarray(WASM_PUBLIC_KEY_INPUT_PTR, WASM_PUBLIC_KEY_INPUT_PTR + PUBLIC_KEY_UNCOMPRESSED_SIZE), PUBLIC_KEY_INPUT2 = WASM_BUFFER.subarray(WASM_PUBLIC_KEY_INPUT_PTR2, WASM_PUBLIC_KEY_INPUT_PTR2 + PUBLIC_KEY_UNCOMPRESSED_SIZE), X_ONLY_PUBLIC_KEY_INPUT = WASM_BUFFER.subarray(WASM_X_ONLY_PUBLIC_KEY_INPUT_PTR, WASM_X_ONLY_PUBLIC_KEY_INPUT_PTR + X_ONLY_PUBLIC_KEY_SIZE), X_ONLY_PUBLIC_KEY_INPUT2 = WASM_BUFFER.subarray(WASM_X_ONLY_PUBLIC_KEY_INPUT2_PTR, WASM_X_ONLY_PUBLIC_KEY_INPUT2_PTR + X_ONLY_PUBLIC_KEY_SIZE), TWEAK_INPUT = WASM_BUFFER.subarray(WASM_TWEAK_INPUT_PTR, WASM_TWEAK_INPUT_PTR + TWEAK_SIZE), HASH_INPUT = WASM_BUFFER.subarray(WASM_HASH_INPUT_PTR, WASM_HASH_INPUT_PTR + HASH_SIZE), EXTRA_DATA_INPUT = WASM_BUFFER.subarray(WASM_EXTRA_DATA_INPUT_PTR, WASM_EXTRA_DATA_INPUT_PTR + EXTRA_DATA_SIZE), SIGNATURE_INPUT = WASM_BUFFER.subarray(WASM_SIGNATURE_INPUT_PTR, WASM_SIGNATURE_INPUT_PTR + SIGNATURE_SIZE);
function assumeCompression(o, g) {
  return o === void 0 ? g !== void 0 ? g.length : PUBLIC_KEY_COMPRESSED_SIZE : o ? PUBLIC_KEY_COMPRESSED_SIZE : PUBLIC_KEY_UNCOMPRESSED_SIZE;
}
function _isPoint(o) {
  try {
    return PUBLIC_KEY_INPUT.set(o), wasm.isPoint(o.length) === 1;
  } finally {
    PUBLIC_KEY_INPUT.fill(0);
  }
}
function __initializeContext() {
  wasm.initializeContext();
}
function isPoint(o) {
  return isDERPoint(o) && _isPoint(o);
}
function isPointCompressed(o) {
  return isPointCompressed$1(o) && _isPoint(o);
}
function isXOnlyPoint(o) {
  return isXOnlyPoint$1(o) && _isPoint(o);
}
function isPrivate(o) {
  return isPrivate$1(o);
}
function pointAdd(o, g, c) {
  validatePoint(o), validatePoint(g);
  const y = assumeCompression(c, o);
  try {
    return PUBLIC_KEY_INPUT.set(o), PUBLIC_KEY_INPUT2.set(g), wasm.pointAdd(o.length, g.length, y) === 1 ? PUBLIC_KEY_INPUT.slice(0, y) : null;
  } finally {
    PUBLIC_KEY_INPUT.fill(0), PUBLIC_KEY_INPUT2.fill(0);
  }
}
function pointAddScalar(o, g, c) {
  validatePoint(o), validateTweak(g);
  const y = assumeCompression(c, o);
  try {
    return PUBLIC_KEY_INPUT.set(o), TWEAK_INPUT.set(g), wasm.pointAddScalar(o.length, y) === 1 ? PUBLIC_KEY_INPUT.slice(0, y) : null;
  } finally {
    PUBLIC_KEY_INPUT.fill(0), TWEAK_INPUT.fill(0);
  }
}
function pointCompress(o, g) {
  validatePoint(o);
  const c = assumeCompression(g, o);
  try {
    return PUBLIC_KEY_INPUT.set(o), wasm.pointCompress(o.length, c), PUBLIC_KEY_INPUT.slice(0, c);
  } finally {
    PUBLIC_KEY_INPUT.fill(0);
  }
}
function pointFromScalar(o, g) {
  validatePrivate(o);
  const c = assumeCompression(g);
  try {
    return PRIVATE_KEY_INPUT.set(o), wasm.pointFromScalar(c) === 1 ? PUBLIC_KEY_INPUT.slice(0, c) : null;
  } finally {
    PRIVATE_KEY_INPUT.fill(0), PUBLIC_KEY_INPUT.fill(0);
  }
}
function xOnlyPointFromScalar(o) {
  validatePrivate(o);
  try {
    return PRIVATE_KEY_INPUT.set(o), wasm.xOnlyPointFromScalar(), X_ONLY_PUBLIC_KEY_INPUT.slice(0, X_ONLY_PUBLIC_KEY_SIZE);
  } finally {
    PRIVATE_KEY_INPUT.fill(0), X_ONLY_PUBLIC_KEY_INPUT.fill(0);
  }
}
function xOnlyPointFromPoint(o) {
  validatePoint(o);
  try {
    return PUBLIC_KEY_INPUT.set(o), wasm.xOnlyPointFromPoint(o.length), X_ONLY_PUBLIC_KEY_INPUT.slice(0, X_ONLY_PUBLIC_KEY_SIZE);
  } finally {
    PUBLIC_KEY_INPUT.fill(0), X_ONLY_PUBLIC_KEY_INPUT.fill(0);
  }
}
function pointMultiply(o, g, c) {
  validatePoint(o), validateTweak(g);
  const y = assumeCompression(c, o);
  try {
    return PUBLIC_KEY_INPUT.set(o), TWEAK_INPUT.set(g), wasm.pointMultiply(o.length, y) === 1 ? PUBLIC_KEY_INPUT.slice(0, y) : null;
  } finally {
    PUBLIC_KEY_INPUT.fill(0), TWEAK_INPUT.fill(0);
  }
}
function privateAdd(o, g) {
  validatePrivate(o), validateTweak(g);
  try {
    return PRIVATE_KEY_INPUT.set(o), TWEAK_INPUT.set(g), wasm.privateAdd() === 1 ? PRIVATE_KEY_INPUT.slice(0, PRIVATE_KEY_SIZE) : null;
  } finally {
    PRIVATE_KEY_INPUT.fill(0), TWEAK_INPUT.fill(0);
  }
}
function privateSub(o, g) {
  if (validatePrivate(o), validateTweak(g), isZero(g))
    return new Uint8Array(o);
  try {
    return PRIVATE_KEY_INPUT.set(o), TWEAK_INPUT.set(g), wasm.privateSub() === 1 ? PRIVATE_KEY_INPUT.slice(0, PRIVATE_KEY_SIZE) : null;
  } finally {
    PRIVATE_KEY_INPUT.fill(0), TWEAK_INPUT.fill(0);
  }
}
function privateNegate(o) {
  validatePrivate(o);
  try {
    return PRIVATE_KEY_INPUT.set(o), wasm.privateNegate(), PRIVATE_KEY_INPUT.slice(0, PRIVATE_KEY_SIZE);
  } finally {
    PRIVATE_KEY_INPUT.fill(0);
  }
}
function xOnlyPointAddTweak(o, g) {
  validateXOnlyPoint(o), validateTweak(g);
  try {
    X_ONLY_PUBLIC_KEY_INPUT.set(o), TWEAK_INPUT.set(g);
    const c = wasm.xOnlyPointAddTweak();
    return c !== -1 ? {
      parity: c,
      xOnlyPubkey: X_ONLY_PUBLIC_KEY_INPUT.slice(0, X_ONLY_PUBLIC_KEY_SIZE)
    } : null;
  } finally {
    X_ONLY_PUBLIC_KEY_INPUT.fill(0), TWEAK_INPUT.fill(0);
  }
}
function xOnlyPointAddTweakCheck(o, g, c, y) {
  validateXOnlyPoint(o), validateXOnlyPoint(c), validateTweak(g);
  const t = y !== void 0;
  t && validateParity(y);
  try {
    if (X_ONLY_PUBLIC_KEY_INPUT.set(o), X_ONLY_PUBLIC_KEY_INPUT2.set(c), TWEAK_INPUT.set(g), t)
      return wasm.xOnlyPointAddTweakCheck(y) === 1;
    {
      wasm.xOnlyPointAddTweak();
      const d = X_ONLY_PUBLIC_KEY_INPUT.slice(0, X_ONLY_PUBLIC_KEY_SIZE);
      return compare(d, c) === 0;
    }
  } finally {
    X_ONLY_PUBLIC_KEY_INPUT.fill(0), X_ONLY_PUBLIC_KEY_INPUT2.fill(0), TWEAK_INPUT.fill(0);
  }
}
function sign(o, g, c) {
  validateHash(o), validatePrivate(g), validateExtraData(c);
  try {
    return HASH_INPUT.set(o), PRIVATE_KEY_INPUT.set(g), c !== void 0 && EXTRA_DATA_INPUT.set(c), wasm.sign(c === void 0 ? 0 : 1), SIGNATURE_INPUT.slice(0, SIGNATURE_SIZE);
  } finally {
    HASH_INPUT.fill(0), PRIVATE_KEY_INPUT.fill(0), c !== void 0 && EXTRA_DATA_INPUT.fill(0), SIGNATURE_INPUT.fill(0);
  }
}
function signRecoverable(o, g, c) {
  validateHash(o), validatePrivate(g), validateExtraData(c);
  try {
    HASH_INPUT.set(o), PRIVATE_KEY_INPUT.set(g), c !== void 0 && EXTRA_DATA_INPUT.set(c);
    const y = wasm.signRecoverable(c === void 0 ? 0 : 1);
    return {
      signature: SIGNATURE_INPUT.slice(0, SIGNATURE_SIZE),
      recoveryId: y
    };
  } finally {
    HASH_INPUT.fill(0), PRIVATE_KEY_INPUT.fill(0), c !== void 0 && EXTRA_DATA_INPUT.fill(0), SIGNATURE_INPUT.fill(0);
  }
}
function signSchnorr$1(o, g, c) {
  validateHash(o), validatePrivate(g), validateExtraData(c);
  try {
    return HASH_INPUT.set(o), PRIVATE_KEY_INPUT.set(g), c !== void 0 && EXTRA_DATA_INPUT.set(c), wasm.signSchnorr(c === void 0 ? 0 : 1), SIGNATURE_INPUT.slice(0, SIGNATURE_SIZE);
  } finally {
    HASH_INPUT.fill(0), PRIVATE_KEY_INPUT.fill(0), c !== void 0 && EXTRA_DATA_INPUT.fill(0), SIGNATURE_INPUT.fill(0);
  }
}
function verify(o, g, c, y = !1) {
  validateHash(o), validatePoint(g), validateSignature(c);
  try {
    return HASH_INPUT.set(o), PUBLIC_KEY_INPUT.set(g), SIGNATURE_INPUT.set(c), wasm.verify(g.length, y === !0 ? 1 : 0) === 1;
  } finally {
    HASH_INPUT.fill(0), PUBLIC_KEY_INPUT.fill(0), SIGNATURE_INPUT.fill(0);
  }
}
function recover(o, g, c, y = !1) {
  validateHash(o), validateSignature(g), validateSignatureNonzeroRS(g), c & 2 && validateSigrPMinusN(g), validateSignatureCustom(() => isXOnlyPoint(g.subarray(0, 32)));
  const t = assumeCompression(y);
  try {
    return HASH_INPUT.set(o), SIGNATURE_INPUT.set(g), wasm.recover(t, c) === 1 ? PUBLIC_KEY_INPUT.slice(0, t) : null;
  } finally {
    HASH_INPUT.fill(0), SIGNATURE_INPUT.fill(0), PUBLIC_KEY_INPUT.fill(0);
  }
}
function verifySchnorr(o, g, c) {
  validateHash(o), validateXOnlyPoint(g), validateSignature(c);
  try {
    return HASH_INPUT.set(o), X_ONLY_PUBLIC_KEY_INPUT.set(g), SIGNATURE_INPUT.set(c), wasm.verifySchnorr() === 1;
  } finally {
    HASH_INPUT.fill(0), X_ONLY_PUBLIC_KEY_INPUT.fill(0), SIGNATURE_INPUT.fill(0);
  }
}
const ecc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  __initializeContext,
  isPoint,
  isPointCompressed,
  isPrivate,
  isXOnlyPoint,
  pointAdd,
  pointAddScalar,
  pointCompress,
  pointFromScalar,
  pointMultiply,
  privateAdd,
  privateNegate,
  privateSub,
  recover,
  sign,
  signRecoverable,
  signSchnorr: signSchnorr$1,
  verify,
  verifySchnorr,
  xOnlyPointAddTweak,
  xOnlyPointAddTweakCheck,
  xOnlyPointFromPoint,
  xOnlyPointFromScalar
}, Symbol.toStringTag, { value: "Module" })), initBTCCurve = () => {
  initEccLib(ecc);
}, COMPRESSED_PUBLIC_KEY_HEX_LENGTH = 66, X_ONLY_PUBLIC_KEY_HEX_LENGTH = 64, HEX_PATTERN = /^[0-9a-fA-F]+$/;
function toXOnlyPublicKeyHex(o) {
  if (o.length === 0)
    throw new WalletError({
      code: ERROR_CODES.INVALID_PUBLIC_KEY,
      message: "Invalid public key: must not be empty"
    });
  if (!HEX_PATTERN.test(o))
    throw new WalletError({
      code: ERROR_CODES.INVALID_PUBLIC_KEY,
      message: "Invalid public key: contains non-hex characters"
    });
  if (o.length === COMPRESSED_PUBLIC_KEY_HEX_LENGTH) {
    const g = o.slice(0, 2);
    if (g !== "02" && g !== "03")
      throw new WalletError({
        code: ERROR_CODES.INVALID_PUBLIC_KEY,
        message: `Invalid compressed public key prefix '${g}', expected '02' or '03'`
      });
    return o.slice(2);
  }
  if (o.length === X_ONLY_PUBLIC_KEY_HEX_LENGTH)
    return o;
  throw new WalletError({
    code: ERROR_CODES.INVALID_PUBLIC_KEY,
    message: `Unexpected public key length ${o.length} chars (expected ${COMPRESSED_PUBLIC_KEY_HEX_LENGTH} for compressed or ${X_ONLY_PUBLIC_KEY_HEX_LENGTH} for x-only)`
  });
}
const NETWORKS = {
  [Network.MAINNET]: {
    name: "Mainnet",
    config: networks$2.bitcoin,
    addressPrefix: {
      common: "bc1",
      nativeSegWit: "bc1q",
      taproot: "bc1p"
    }
  },
  [Network.TESTNET]: {
    name: "Testnet",
    config: networks$2.testnet,
    addressPrefix: {
      common: "tb1",
      nativeSegWit: "tb1q",
      taproot: "tb1p"
    }
  },
  [Network.SIGNET]: {
    name: "Signet",
    config: networks$2.testnet,
    addressPrefix: {
      common: "tb1",
      nativeSegWit: "tb1q",
      taproot: "tb1p"
    }
  }
}, getTaprootAddress = (o, g) => {
  initBTCCurve();
  const c = toXOnlyPublicKeyHex(o), y = Buffer.from(c, "hex"), { address: t, output: d } = payments$1.p2tr({
    internalPubkey: bip371Exports.toXOnly(y),
    network: NETWORKS[g].config
  });
  if (!t || !d)
    throw new WalletError({
      code: ERROR_CODES.ADDRESS_GENERATION_FAILED,
      message: "Failed to generate taproot address or script from public key"
    });
  return t;
}, getNativeSegwitAddress = (o, g) => {
  if (o.length !== COMPRESSED_PUBLIC_KEY_HEX_LENGTH)
    throw new WalletError({
      code: ERROR_CODES.INVALID_PUBLIC_KEY,
      message: "Invalid public key length for generating native segwit address"
    });
  const c = Buffer.from(o, "hex"), { address: y, output: t } = payments$1.p2wpkh({
    pubkey: c,
    network: NETWORKS[g].config
  });
  if (!y || !t)
    throw new WalletError({
      code: ERROR_CODES.ADDRESS_GENERATION_FAILED,
      message: "Failed to generate native segwit address or script from public key"
    });
  return y;
};
function validateAddressWithPK(o, g, c) {
  return o.startsWith(NETWORKS[c].addressPrefix.taproot) ? o === getTaprootAddress(g, c) : o.startsWith(NETWORKS[c].addressPrefix.nativeSegWit) ? o === getNativeSegwitAddress(g, c) : !1;
}
function validateAddress(o, g) {
  const { addressPrefix: c, name: y } = NETWORKS[o];
  if (!(o in NETWORKS))
    throw new WalletError({
      code: ERROR_CODES.UNSUPPORTED_NETWORK,
      message: `Unsupported network: ${o}. Please provide a valid network.`
    });
  if (!g.startsWith(c.common))
    throw new WalletError({
      code: ERROR_CODES.INVALID_ADDRESS_PREFIX,
      message: `Incorrect address prefix for ${y}. Expected address to start with '${c.common}'.`
    });
}
const toNetwork = (o) => NETWORKS[o].config, getPublicKeyFromXpub = (o, g, c) => {
  const t = HDKey.fromExtendedKey(o, c == null ? void 0 : c.bip32).derive(g);
  return Buffer.from(t.publicKey);
}, generateP2TRAddressFromXpub = (o, g, c) => {
  initBTCCurve();
  const y = getPublicKeyFromXpub(o, g), t = bip371Exports.toXOnly(y), { address: d, output: E } = payments$1.p2tr({
    internalPubkey: t,
    network: c
  });
  if (!d || !E)
    throw new WalletError({
      code: ERROR_CODES.ADDRESS_GENERATION_FAILED,
      message: "Failed to generate taproot address or script from extended public key"
    });
  return {
    address: d,
    publicKeyHex: y.toString("hex"),
    scriptPubKeyHex: E.toString("hex")
  };
}, icon$2 = "data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='UTF-8'?%3e%3csvg%20id='Layer_1'%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%20800%20800'%3e%3cdefs%3e%3cstyle%3e.cls-1{fill:%23ce6533;fill-rule:evenodd;}%3c/style%3e%3c/defs%3e%3cpath%20class='cls-1'%20d='M66.5,198.56c-3.27-8.85-1.09-18.79,5.58-25.47l90.82-90.82c6.67-6.67,16.62-8.85,25.46-5.59l193.65,71.14c4.76,1.75,7.92,6.28,7.92,11.35v42.4c0,3.21-1.27,6.28-3.54,8.55l-47.14,47.13c-3.33,3.34-8.3,4.43-12.73,2.79l-52.02-19.18-57.16-21.09c-4.83-1.79-9.55,2.92-7.76,7.76l40.27,109.18c1.63,4.43,.55,9.4-2.79,12.73l-41.91,41.89c-4.72,4.72-4.72,12.38,0,17.1l42.13,42.13c3.34,3.34,4.43,8.31,2.79,12.73l-40.27,109.17c-1.79,4.84,2.92,9.55,7.76,7.76l109.18-40.28c4.43-1.63,9.4-.54,12.73,2.79l46.91,46.91c2.27,2.27,3.54,5.34,3.54,8.55v42.41c0,5.06-3.15,9.59-7.9,11.34l-193.42,71.36c-8.85,3.27-18.8,1.08-25.47-5.59l-90.83-90.83c-6.67-6.67-8.85-16.61-5.58-25.47l71.11-192.77c1.99-5.4,1.99-11.34,0-16.74L66.5,198.56Z'/%3e%3cpath%20class='cls-1'%20d='M733.5,601.44c3.27,8.85,1.09,18.79-5.58,25.47l-90.82,90.83c-6.67,6.67-16.61,8.85-25.46,5.59l-193.65-71.14c-4.76-1.75-7.92-6.28-7.92-11.35v-42.4c0-3.21,1.27-6.28,3.54-8.55l47.14-47.13c3.33-3.34,8.3-4.43,12.73-2.79l52.02,19.18,57.16,21.09c4.83,1.79,9.54-2.92,7.76-7.76l-40.27-109.18c-1.63-4.43-.55-9.4,2.79-12.73l41.91-41.89c4.72-4.72,4.72-12.38,0-17.1l-42.13-42.13c-3.34-3.34-4.43-8.31-2.79-12.73l40.27-109.17c1.79-4.84-2.92-9.55-7.76-7.76l-109.18,40.28c-4.43,1.63-9.4,.54-12.73-2.79l-46.91-46.91c-2.27-2.27-3.54-5.34-3.54-8.55v-42.41c0-5.06,3.15-9.59,7.9-11.34l193.42-71.36c8.85-3.27,18.79-1.08,25.47,5.59l90.82,90.83c6.68,6.67,8.86,16.61,5.59,25.47l-71.11,192.77c-2,5.4-2,11.34,0,16.74l71.34,193.37h0Z'/%3e%3c/svg%3e", metadata$g = {
  id: "injectable",
  name: (o) => {
    var g;
    return (g = o.getWalletProviderName) == null ? void 0 : g.call(o);
  },
  icon: (o) => {
    var g;
    return (g = o.getWalletProviderIcon) == null ? void 0 : g.call(o);
  },
  docs: "",
  wallet: "bbnwallet",
  createProvider: (o) => o,
  networks: [Network.MAINNET, Network.SIGNET],
  label: "Injectable"
}, logo$8 = "data:image/svg+xml,%3csvg%20width='100'%20height='101'%20viewBox='0%200%20100%20101'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20clip-path='url(%23clip0_408_204)'%3e%3cpath%20d='M0%2050.5C0%2032.9984%200%2024.2475%203.40605%2017.5628C6.40209%2011.6827%2011.1827%206.90209%2017.0628%203.90605C23.7475%200.5%2032.4984%200.5%2050%200.5C67.5016%200.5%2076.2525%200.5%2082.9372%203.90605C88.8173%206.90209%2093.5979%2011.6827%2096.594%2017.5628C100%2024.2475%20100%2032.9984%20100%2050.5C100%2068.0016%20100%2076.7525%2096.594%2083.4372C93.5979%2089.3173%2088.8173%2094.0979%2082.9372%2097.094C76.2525%20100.5%2067.5016%20100.5%2050%20100.5C32.4984%20100.5%2023.7475%20100.5%2017.0628%2097.094C11.1827%2094.0979%206.40209%2089.3173%203.40605%2083.4372C0%2076.7525%200%2068.0016%200%2050.5Z'%20fill='%2314AFEB'/%3e%3cpath%20d='M52.0838%2032.7979C52.6512%2038.5974%2052.9348%2041.4973%2054.4549%2043.6237C55.1062%2044.5349%2055.9095%2045.3275%2056.8295%2045.9663C58.9765%2047.4571%2061.88%2047.7013%2067.6865%2048.1896L70.1416%2048.3958V52.6003L67.6865%2052.8064C61.88%2053.2947%2058.9765%2053.539%2056.8295%2055.0298C55.9095%2055.6686%2055.1062%2056.461%2054.4549%2057.3722C52.9348%2059.4986%2052.6512%2062.3986%2052.0838%2068.1981H47.9162C47.3488%2062.3986%2047.0652%2059.4986%2045.5451%2057.3722C44.8938%2056.461%2044.0905%2055.6686%2043.1705%2055.0298C41.0235%2053.539%2038.12%2053.2947%2032.3135%2052.8064L29.8584%2052.6003V48.3958L32.3135%2048.1896C38.12%2047.7013%2041.0235%2047.4571%2043.1705%2045.9663C44.0905%2045.3275%2044.8938%2044.5349%2045.5451%2043.6237C47.0652%2041.4973%2047.3488%2038.5974%2047.9162%2032.7979H52.0838Z'%20fill='white'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M50%2011.4355C82.168%2011.4355%2089.0625%2018.3301%2089.0625%2050.498C89.0625%2082.666%2082.168%2089.5605%2050%2089.5605C17.832%2089.5605%2010.9375%2082.666%2010.9375%2050.498C10.9375%2018.3301%2017.832%2011.4355%2050%2011.4355ZM75.5299%2024.9354C66.0693%2015.475%2046.9628%2019.243%2032.8541%2033.3516C18.7454%2047.4603%2014.9774%2066.5673%2024.438%2076.0279C33.8986%2085.4883%2053.005%2081.7204%2067.1137%2067.6117C81.2224%2053.503%2084.9904%2034.396%2075.5299%2024.9354Z'%20fill='white'/%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_408_204'%3e%3crect%20width='100'%20height='101'%20fill='white'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e", WALLET_PROVIDER_NAME$b = "Keplr";
class KeplrProvider {
  constructor(g, c) {
    Vi(this, "walletInfo");
    Vi(this, "chainId");
    Vi(this, "rpc");
    Vi(this, "chainData");
    Vi(this, "on", (g, c) => {
      if (!this.walletInfo)
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "Wallet not connected",
          wallet: WALLET_PROVIDER_NAME$b
        });
      isAccountChangeEvent(g) && window.addEventListener("keplr_keystorechange", c);
    });
    Vi(this, "off", (g, c) => {
      if (!this.walletInfo)
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "Wallet not connected",
          wallet: WALLET_PROVIDER_NAME$b
        });
      isAccountChangeEvent(g) && window.removeEventListener("keplr_keystorechange", c);
    });
    if (this.keplr = g, !g)
      throw new WalletError({
        code: ERROR_CODES.EXTENSION_NOT_FOUND,
        message: "Keplr extension not found",
        wallet: WALLET_PROVIDER_NAME$b
      });
    this.chainId = c.chainId, this.rpc = c.rpc, this.chainData = c.chainData;
  }
  async connectWallet() {
    if (!this.chainId || !this.rpc || !this.keplr)
      throw new WalletError({
        code: ERROR_CODES.WALLET_INITIALIZATION_FAILED,
        message: `Keplr provider initialization failed: Missing ${this.chainId ? this.rpc ? "Keplr extension" : "RPC URL" : "Chain ID"}`,
        wallet: WALLET_PROVIDER_NAME$b
      });
    try {
      await this.keplr.enable(this.chainId);
    } catch (g) {
      if (g != null && g.message.includes(this.chainId))
        try {
          await this.keplr.experimentalSuggestChain(this.chainData), await this.keplr.enable(this.chainId);
        } catch {
          throw new WalletError({
            code: ERROR_CODES.FAILED_TO_ADD_CHAIN,
            message: "Failed to add BBN chain",
            wallet: WALLET_PROVIDER_NAME$b
          });
        }
      else
        throw g != null && g.message.includes("rejected") ? new WalletError({
          code: ERROR_CODES.CONNECTION_REJECTED,
          message: "Keplr wallet connection request rejected",
          wallet: WALLET_PROVIDER_NAME$b
        }) : g != null && g.message.includes("context invalidated") ? new WalletError({
          code: ERROR_CODES.EXTENSION_CONTEXT_INVALIDATED,
          message: "Keplr extension context invalidated",
          wallet: WALLET_PROVIDER_NAME$b
        }) : new WalletError({
          code: ERROR_CODES.CONNECTION_FAILED,
          message: (g == null ? void 0 : g.message) || "Failed to connect to Keplr",
          wallet: WALLET_PROVIDER_NAME$b
        });
    }
    this.walletInfo = await this.getLiveWalletInfo();
  }
  async getLiveWalletInfo() {
    const g = await this.keplr.getKey(this.chainId);
    if (!g)
      throw new WalletError({
        code: ERROR_CODES.WALLET_INITIALIZATION_FAILED,
        message: "Failed to get Keplr key",
        wallet: WALLET_PROVIDER_NAME$b
      });
    const { bech32Address: c, pubKey: y } = g;
    if (c && y)
      return {
        publicKeyHex: bufferExports.Buffer.from(g.pubKey).toString("hex"),
        address: c
      };
    throw new WalletError({
      code: ERROR_CODES.CONNECTION_FAILED,
      message: "Could not connect to Keplr",
      wallet: WALLET_PROVIDER_NAME$b
    });
  }
  async getAddress() {
    if (!this.walletInfo)
      throw new WalletError({
        code: ERROR_CODES.WALLET_NOT_CONNECTED,
        message: "Wallet not connected",
        wallet: WALLET_PROVIDER_NAME$b
      });
    return (await this.getLiveWalletInfo()).address;
  }
  async getPublicKeyHex() {
    if (!this.walletInfo)
      throw new WalletError({
        code: ERROR_CODES.WALLET_NOT_CONNECTED,
        message: "Wallet not connected",
        wallet: WALLET_PROVIDER_NAME$b
      });
    return (await this.getLiveWalletInfo()).publicKeyHex;
  }
  async getWalletProviderName() {
    return WALLET_PROVIDER_NAME$b;
  }
  async getWalletProviderIcon() {
    return logo$8;
  }
  async getOfflineSigner() {
    if (!this.keplr || !this.chainId)
      throw new WalletError({
        code: ERROR_CODES.WALLET_INITIALIZATION_FAILED,
        message: this.keplr ? "Chain ID is not initialized" : "Keplr extension not found",
        wallet: WALLET_PROVIDER_NAME$b
      });
    try {
      return this.keplr.getOfflineSigner(this.chainId);
    } catch {
      throw new WalletError({
        code: ERROR_CODES.WALLET_INITIALIZATION_FAILED,
        message: "Failed to get offline signer",
        wallet: WALLET_PROVIDER_NAME$b
      });
    }
  }
  async getOfflineSignerAuto() {
    if (!this.keplr || !this.chainId)
      throw new WalletError({
        code: ERROR_CODES.WALLET_INITIALIZATION_FAILED,
        message: this.keplr ? "Chain ID is not initialized" : "Keplr extension not found",
        wallet: WALLET_PROVIDER_NAME$b
      });
    try {
      return this.keplr.getOfflineSignerAuto(this.chainId);
    } catch {
      throw new WalletError({
        code: ERROR_CODES.UNKNOWN_ERROR,
        // Or a more specific one if available
        message: "Failed to get offline signer auto",
        wallet: WALLET_PROVIDER_NAME$b
      });
    }
  }
}
const metadata$f = {
  id: "keplr",
  name: WALLET_PROVIDER_NAME$b,
  icon: logo$8,
  docs: "https://www.keplr.app/",
  wallet: () => buildExports$1.Keplr.getKeplr(),
  createProvider: (o, g) => new KeplrProvider(o, g),
  networks: [Network.MAINNET, Network.SIGNET]
}, logo$7 = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='58'%20height='58'%3e%3cg%20fill='none'%20fill-rule='nonzero'%3e%3cpath%20fill='%2324A95A'%20stroke='%23138D3E'%20stroke-width='.039'%20d='M51.466%2036.118c0%204.001-2.44%206.816-6.403%208.631-3.963%201.816-9.446%202.631-15.522%202.631-6.077%200-11.595-.815-15.594-2.63-3.999-1.816-6.474-4.631-6.474-8.632%200-4.002%202.46-7.625%206.44-10.248%203.982-2.623%209.482-4.245%2015.556-4.245%206.075%200%2011.575%201.626%2015.556%204.25%203.981%202.625%206.441%206.248%206.441%2010.243Z'/%3e%3cpath%20fill='%2332DA6D'%20stroke='%23138D3E'%20stroke-width='.039'%20d='m35.608%2013.791.012.003.007-.009A7.686%207.686%200%200%201%2041.555%2011c4.236%200%207.675%203.421%207.675%207.634%200%201.385-.37%202.671-1.009%203.788l-.005.009.004.01a9.644%209.644%200%200%201%20.94%204.13c0%203.711-2.198%207.072-5.753%209.505-3.555%202.434-8.468%203.939-13.893%203.939-5.426%200-10.339-1.505-13.894-3.939-3.555-2.433-5.752-5.794-5.752-9.506%200-1.442.327-2.829.939-4.13l.004-.009-.005-.009a7.583%207.583%200%200%201-1.01-3.788c0-4.213%203.44-7.634%207.676-7.634a7.73%207.73%200%200%201%205.928%202.785l.007.01.012-.004a27.43%2027.43%200%200%201%206.095-.665c2.121%200%204.172.24%206.094.665Z'/%3e%3cpath%20fill='%23FFF'%20d='M16.845%2022.88c2.597%200%204.703-2.094%204.703-4.677%200-2.583-2.106-4.677-4.703-4.677-2.597%200-4.702%202.094-4.702%204.677%200%202.583%202.105%204.677%204.702%204.677ZM41.932%2022.88c2.597%200%204.702-2.094%204.702-4.677%200-2.583-2.105-4.677-4.702-4.677-2.598%200-4.703%202.094-4.703%204.677%200%202.583%202.105%204.677%204.703%204.677Z'/%3e%3cpath%20fill='%2332DA6D'%20stroke='%23138D3E'%20stroke-width='.039'%20d='M4.032%2044.13a.163.163%200%200%200%20.018-.008l-.002-.004-.004-.01-.017-.046-.066-.174a70.962%2070.962%200%200%201-1.02-2.947c-.6-1.87-1.295-4.301-1.669-6.54-.187-1.12-.293-2.192-.268-3.122.025-.93.181-1.716.52-2.266.337-.55.855-.865%201.608-.856.754.01%201.746.347%203.027%201.108%207.702%204.573%209.453%2012.176%209.866%2015.688.113.98-.676%201.85-1.676%201.85H2.308c-.794%200-1.084-1.037-.39-1.438l2.123-1.219.015-.008-.006-.016-.018.007ZM54.276%2044.123l.018.006a.481.481%200%200%201-.018-.006v-.001l.002-.003.003-.011.016-.045a44.607%2044.607%200%200%200%20.276-.83c.183-.56.433-1.356.705-2.291.543-1.871%201.17-4.302%201.507-6.541.169-1.12.265-2.192.242-3.122-.023-.93-.165-1.716-.47-2.267a1.677%201.677%200%200%200-.587-.637%201.587%201.587%200%200%200-.867-.218c-.681.01-1.577.346-2.736%201.107-6.946%204.573-8.541%2012.19-8.897%2015.69-.1.982.606%201.849%201.505%201.849h10.887c.352%200%20.596-.258.672-.569.077-.31-.014-.67-.326-.87l-1.932-1.241Zm0%200-.005.014.013.009%201.924%201.218-1.932-1.241Z'/%3e%3cpath%20fill='%23092511'%20d='M16.893%2021.02a2.805%202.805%200%201%200%200-5.61%202.805%202.805%200%200%200%200%205.61ZM41.98%2021.02a2.805%202.805%200%201%200%200-5.61%202.805%202.805%200%200%200%200%205.61ZM36.998%2029.488a7.536%207.536%200%200%201-10.976%206.042%207.534%207.534%200%200%201-4.037-7.334l7.507.646%207.506.646Z'/%3e%3c/g%3e%3c/svg%3e", WALLET_PROVIDER_NAME$a = "Leap";
class LeapProvider {
  constructor(g, c) {
    Vi(this, "walletInfo");
    Vi(this, "chainId");
    Vi(this, "rpc");
    Vi(this, "chainData");
    Vi(this, "on", (g, c) => {
      if (!this.walletInfo)
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "Wallet not connected",
          wallet: WALLET_PROVIDER_NAME$a
        });
      isAccountChangeEvent(g) && window.addEventListener("leap_keystorechange", c);
    });
    Vi(this, "off", (g, c) => {
      if (!this.walletInfo)
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "Wallet not connected",
          wallet: WALLET_PROVIDER_NAME$a
        });
      isAccountChangeEvent(g) && window.removeEventListener("leap_keystorechange", c);
    });
    if (this.wallet = g, !g)
      throw new WalletError({
        code: ERROR_CODES.EXTENSION_NOT_FOUND,
        message: "Leap extension not found",
        wallet: WALLET_PROVIDER_NAME$a
      });
    this.chainId = c.chainId, this.rpc = c.rpc, this.chainData = c.chainData;
  }
  async connectWallet() {
    if (!this.chainId)
      throw new WalletError({
        code: ERROR_CODES.CHAIN_ID_NOT_INITIALIZED,
        message: "Chain ID is not initialized",
        wallet: WALLET_PROVIDER_NAME$a
      });
    if (!this.rpc)
      throw new WalletError({
        code: ERROR_CODES.RPC_URL_NOT_INITIALIZED,
        message: "RPC URL is not initialized",
        wallet: WALLET_PROVIDER_NAME$a
      });
    if (!this.wallet)
      throw new WalletError({
        code: ERROR_CODES.EXTENSION_NOT_FOUND,
        message: "Leap extension not found",
        wallet: WALLET_PROVIDER_NAME$a
      });
    try {
      await this.wallet.enable(this.chainId);
    } catch (g) {
      if (g != null && g.message.includes(this.chainId) || g != null && g.message.includes("chain id"))
        try {
          await this.wallet.experimentalSuggestChain(this.chainData), await this.wallet.enable(this.chainId);
        } catch {
          throw new WalletError({
            code: ERROR_CODES.FAILED_TO_ADD_CHAIN,
            message: "Failed to add BBN chain",
            wallet: WALLET_PROVIDER_NAME$a
          });
        }
      else
        throw g != null && g.message.includes("rejected") ? new WalletError({
          code: ERROR_CODES.CONNECTION_REJECTED,
          message: "Leap wallet connection request rejected",
          wallet: WALLET_PROVIDER_NAME$a
        }) : g != null && g.message.includes("context invalidated") ? new WalletError({
          code: ERROR_CODES.EXTENSION_CONTEXT_INVALIDATED,
          message: "Leap extension context invalidated",
          wallet: WALLET_PROVIDER_NAME$a
        }) : new WalletError({
          code: ERROR_CODES.CONNECTION_FAILED,
          message: (g == null ? void 0 : g.message) || "Failed to connect to Leap",
          wallet: WALLET_PROVIDER_NAME$a
        });
    }
    this.walletInfo = await this.getLiveWalletInfo();
  }
  async getLiveWalletInfo() {
    const g = await this.wallet.getKey(this.chainId);
    if (!g)
      throw new WalletError({
        code: ERROR_CODES.FAILED_TO_GET_KEY,
        message: "Failed to get Leap key",
        wallet: WALLET_PROVIDER_NAME$a
      });
    const { bech32Address: c, pubKey: y } = g;
    if (c && y)
      return {
        publicKeyHex: bufferExports.Buffer.from(g.pubKey).toString("hex"),
        address: c
      };
    throw new WalletError({
      code: ERROR_CODES.CONNECTION_FAILED,
      message: "Could not connect to Leap",
      wallet: WALLET_PROVIDER_NAME$a
    });
  }
  async getAddress() {
    if (!this.walletInfo)
      throw new WalletError({
        code: ERROR_CODES.WALLET_NOT_CONNECTED,
        message: "Wallet not connected",
        wallet: WALLET_PROVIDER_NAME$a
      });
    return (await this.getLiveWalletInfo()).address;
  }
  async getPublicKeyHex() {
    if (!this.walletInfo)
      throw new WalletError({
        code: ERROR_CODES.WALLET_NOT_CONNECTED,
        message: "Wallet not connected",
        wallet: WALLET_PROVIDER_NAME$a
      });
    return (await this.getLiveWalletInfo()).publicKeyHex;
  }
  async getWalletProviderName() {
    return WALLET_PROVIDER_NAME$a;
  }
  async getWalletProviderIcon() {
    return logo$7;
  }
  async getOfflineSigner() {
    if (!this.wallet)
      throw new WalletError({
        code: ERROR_CODES.EXTENSION_NOT_FOUND,
        message: "Leap extension not found",
        wallet: WALLET_PROVIDER_NAME$a
      });
    if (!this.chainId)
      throw new WalletError({
        code: ERROR_CODES.CHAIN_ID_NOT_INITIALIZED,
        message: "Chain ID is not initialized",
        wallet: WALLET_PROVIDER_NAME$a
      });
    try {
      return this.wallet.getOfflineSigner(this.chainId);
    } catch {
      throw new WalletError({
        code: ERROR_CODES.UNKNOWN_ERROR,
        message: "Failed to get offline signer",
        wallet: WALLET_PROVIDER_NAME$a
      });
    }
  }
  async getOfflineSignerAuto() {
    if (!this.wallet)
      throw new WalletError({
        code: ERROR_CODES.EXTENSION_NOT_FOUND,
        message: "Leap extension not found",
        wallet: WALLET_PROVIDER_NAME$a
      });
    if (!this.chainId)
      throw new WalletError({
        code: ERROR_CODES.CHAIN_ID_NOT_INITIALIZED,
        message: "Chain ID is not initialized",
        wallet: WALLET_PROVIDER_NAME$a
      });
    try {
      return this.wallet.getOfflineSignerAuto(this.chainId);
    } catch {
      throw new WalletError({
        code: ERROR_CODES.UNKNOWN_ERROR,
        message: "Failed to get offline signer auto",
        wallet: WALLET_PROVIDER_NAME$a
      });
    }
  }
}
const metadata$e = {
  id: "leap",
  name: WALLET_PROVIDER_NAME$a,
  icon: logo$7,
  docs: "https://www.leapwallet.io/",
  wallet: "leap",
  createProvider: (o, g) => new LeapProvider(o, g),
  networks: [Network.MAINNET, Network.SIGNET]
}, WALLET_PROVIDER_NAME$9 = "OKX";
class OKXBabylonProvider {
  constructor(g, c) {
    Vi(this, "walletInfo");
    Vi(this, "chainId");
    Vi(this, "rpc");
    Vi(this, "chainData");
    Vi(this, "on", (g, c) => {
      if (!this.walletInfo)
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "Wallet not connected",
          wallet: WALLET_PROVIDER_NAME$9
        });
      isAccountChangeEvent(g) && window.addEventListener("okx_keystorechange", c);
    });
    Vi(this, "off", (g, c) => {
      if (!this.walletInfo)
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "Wallet not connected",
          wallet: WALLET_PROVIDER_NAME$9
        });
      isAccountChangeEvent(g) && window.removeEventListener("okx_keystorechange", c);
    });
    if (this.wallet = g, !g || !g.keplr)
      throw new WalletError({
        code: ERROR_CODES.EXTENSION_NOT_FOUND,
        message: "OKX Wallet extension not found",
        wallet: WALLET_PROVIDER_NAME$9
      });
    this.chainId = c.chainId, this.rpc = c.rpc, this.chainData = c.chainData;
  }
  async connectWallet() {
    if (!this.chainId)
      throw new WalletError({
        code: ERROR_CODES.CHAIN_ID_NOT_INITIALIZED,
        message: "Chain ID is not initialized",
        wallet: WALLET_PROVIDER_NAME$9
      });
    if (!this.rpc)
      throw new WalletError({
        code: ERROR_CODES.RPC_URL_NOT_INITIALIZED,
        message: "RPC URL is not initialized",
        wallet: WALLET_PROVIDER_NAME$9
      });
    if (!this.wallet.keplr)
      throw new WalletError({
        code: ERROR_CODES.EXTENSION_NOT_FOUND,
        message: "OKX Wallet extension not found",
        wallet: WALLET_PROVIDER_NAME$9
      });
    try {
      await this.wallet.keplr.enable(this.chainId);
    } catch (g) {
      if (g != null && g.message.includes(this.chainId))
        try {
          await this.wallet.keplr.experimentalSuggestChain(this.chainData), await this.wallet.keplr.enable(this.chainId);
        } catch {
          throw new WalletError({
            code: ERROR_CODES.FAILED_TO_ADD_CHAIN,
            message: "Failed to add BBN chain",
            wallet: WALLET_PROVIDER_NAME$9
          });
        }
      else
        throw g != null && g.message.includes("rejected") ? new WalletError({
          code: ERROR_CODES.CONNECTION_REJECTED,
          message: "OKX Wallet connection request rejected",
          wallet: WALLET_PROVIDER_NAME$9
        }) : g != null && g.message.includes("context invalidated") ? new WalletError({
          code: ERROR_CODES.EXTENSION_CONTEXT_INVALIDATED,
          message: "OKX Wallet extension context invalidated",
          wallet: WALLET_PROVIDER_NAME$9
        }) : new WalletError({
          code: ERROR_CODES.CONNECTION_FAILED,
          message: (g == null ? void 0 : g.message) || "Failed to connect to OKX Wallet",
          wallet: WALLET_PROVIDER_NAME$9
        });
    }
    this.walletInfo = await this.getLiveWalletInfo();
  }
  async getLiveWalletInfo() {
    const g = await this.wallet.keplr.getKey(this.chainId);
    if (!g)
      throw new WalletError({
        code: ERROR_CODES.FAILED_TO_GET_KEY,
        message: "Failed to get OKX Wallet key",
        wallet: WALLET_PROVIDER_NAME$9
      });
    const { bech32Address: c, pubKey: y } = g;
    if (c && y)
      return {
        publicKeyHex: bufferExports.Buffer.from(g.pubKey).toString("hex"),
        address: c
      };
    throw new WalletError({
      code: ERROR_CODES.CONNECTION_FAILED,
      message: "Could not connect to OKX Wallet",
      wallet: WALLET_PROVIDER_NAME$9
    });
  }
  async getAddress() {
    if (!this.walletInfo)
      throw new WalletError({
        code: ERROR_CODES.WALLET_NOT_CONNECTED,
        message: "Wallet not connected",
        wallet: WALLET_PROVIDER_NAME$9
      });
    return (await this.getLiveWalletInfo()).address;
  }
  async getPublicKeyHex() {
    if (!this.walletInfo)
      throw new WalletError({
        code: ERROR_CODES.WALLET_NOT_CONNECTED,
        message: "Wallet not connected",
        wallet: WALLET_PROVIDER_NAME$9
      });
    return (await this.getLiveWalletInfo()).publicKeyHex;
  }
  async getWalletProviderName() {
    return WALLET_PROVIDER_NAME$9;
  }
  async getWalletProviderIcon() {
    return okxLogo;
  }
  async getOfflineSigner() {
    if (!this.wallet.keplr)
      throw new WalletError({
        code: ERROR_CODES.EXTENSION_NOT_FOUND,
        message: "OKX Wallet extension not found",
        wallet: WALLET_PROVIDER_NAME$9
      });
    if (!this.chainId)
      throw new WalletError({
        code: ERROR_CODES.CHAIN_ID_NOT_INITIALIZED,
        message: "Chain ID is not initialized",
        wallet: WALLET_PROVIDER_NAME$9
      });
    try {
      return this.wallet.keplr.getOfflineSigner(this.chainId);
    } catch {
      throw new WalletError({
        code: ERROR_CODES.UNKNOWN_ERROR,
        message: "Failed to get offline signer",
        wallet: WALLET_PROVIDER_NAME$9
      });
    }
  }
  async getOfflineSignerAuto() {
    if (!this.wallet.keplr)
      throw new WalletError({
        code: ERROR_CODES.EXTENSION_NOT_FOUND,
        message: "OKX Wallet extension not found",
        wallet: WALLET_PROVIDER_NAME$9
      });
    if (!this.chainId)
      throw new WalletError({
        code: ERROR_CODES.CHAIN_ID_NOT_INITIALIZED,
        message: "Chain ID is not initialized",
        wallet: WALLET_PROVIDER_NAME$9
      });
    try {
      return this.wallet.keplr.getOfflineSignerAuto(this.chainId);
    } catch {
      throw new WalletError({
        code: ERROR_CODES.UNKNOWN_ERROR,
        message: "Failed to get offline signer auto",
        wallet: WALLET_PROVIDER_NAME$9
      });
    }
  }
  getVersion() {
    return this.wallet.getVersion();
  }
}
const metadata$d = {
  id: "okx",
  name: WALLET_PROVIDER_NAME$9,
  icon: okxLogo,
  iconBackground: MONOCHROME_MARK_BACKGROUND,
  docs: "https://www.okx.com/web3",
  wallet: "okxwallet",
  createProvider: (o, g) => new OKXBabylonProvider(o, g),
  networks: [Network.MAINNET, Network.SIGNET]
}, metadata$c = {
  chain: "BBN",
  name: "Babylon Chain",
  icon: icon$2,
  wallets: [metadata$d, metadata$g, metadata$f, metadata$e]
}, icon$1 = "data:image/svg+xml,%3csvg%20width='48'%20height='48'%20viewBox='0%200%2048%2048'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3crect%20width='48'%20height='48'%20rx='14'%20fill='%23FF573B'/%3e%3cpath%20d='M10%2029H38V33C38%2034.1046%2037.0714%2035%2035.9259%2035H12.0741C10.9286%2035%2010%2034.1046%2010%2033V29Z'%20fill='white'/%3e%3cpath%20d='M10%2021H38V27H10V21Z'%20fill='white'/%3e%3cpath%20d='M10%2015C10%2013.8954%2010.9286%2013%2012.0741%2013H35.9259C37.0714%2013%2038%2013.8954%2038%2015V19H10V15Z'%20fill='white'/%3e%3c/svg%3e";
function resolveUseTweakedSigner(o) {
  if (typeof o.useTweakedSigner == "boolean")
    return o.useTweakedSigner;
  if (typeof o.disableTweakSigner == "boolean")
    return !o.disableTweakSigner;
}
function mapSignInputsToToSignInputs(o) {
  return o.map((g) => {
    const c = resolveUseTweakedSigner(g);
    return {
      index: g.index,
      publicKey: g.publicKey,
      address: g.address,
      sighashTypes: g.sighashTypes,
      ...c !== void 0 && {
        useTweakedSigner: c,
        disableTweakSigner: !c
      }
    };
  });
}
function unsupportedDeriveContextHash(o) {
  return async (g, c) => {
    throw new WalletError({
      code: ERROR_CODES.WALLET_METHOD_NOT_SUPPORTED,
      message: `${o} does not support deriveContextHash (requested by app "${g}", context length ${c.length}). Use a wallet that implements the deriveContextHash specification.`,
      wallet: o
    });
  };
}
const APPKIT_BTC_CONNECTED_EVENT = "babylon:appkit-btc-connected", APPKIT_PROVIDER_NAME$1 = "AppKit", NETWORK_TO_CAIP_NETWORK = {
  mainnet: bitcoin$2,
  signet: bitcoinSignet
};
function getCaipNetworkForNetwork(o) {
  return NETWORK_TO_CAIP_NETWORK[o];
}
function caipNetworkIdToNetwork(o) {
  return o === bitcoin$2.caipNetworkId ? Network.MAINNET : o === bitcoinSignet.caipNetworkId ? Network.SIGNET : null;
}
function resolveLiveNetwork(o, g) {
  if (o === void 0)
    return g;
  const c = caipNetworkIdToNetwork(o);
  if (c === null)
    throw new WalletError({
      code: ERROR_CODES.UNSUPPORTED_NETWORK,
      message: `AppKit Bitcoin wallet is on an unsupported network (caipNetworkId="${o}")`,
      wallet: APPKIT_PROVIDER_NAME$1
    });
  if (c !== g)
    throw new WalletError({
      code: ERROR_CODES.UNSUPPORTED_NETWORK,
      message: `AppKit Bitcoin wallet network mismatch: app expects ${g}, wallet is on ${c}`,
      wallet: APPKIT_PROVIDER_NAME$1
    });
  return c;
}
const BITCOIN_CAPABILITY = "Bitcoin";
let sharedBtcAppKitConfig = null;
function setSharedBtcAppKitConfig(o) {
  const g = {
    modal: o.modal,
    adapter: o.adapter,
    network: o.network,
    // Preserve the existing bus across repeated setter calls (e.g. HMR,
    // network switch, re-init). Replacing it would strand any
    // `AppKitBTCProvider` already listening on the prior `EventTarget`
    // while the bridge dispatches on the new one — account-change events
    // would silently stop propagating. An explicit caller override still
    // wins for tests that need a deterministic instance.
    connectionEvents: o.connectionEvents ?? (sharedBtcAppKitConfig == null ? void 0 : sharedBtcAppKitConfig.connectionEvents) ?? new EventTarget()
  };
  registerManualAppKitConfig(BITCOIN_CAPABILITY, o.modal), sharedBtcAppKitConfig = g;
}
function getSharedBtcAppKitConfig() {
  const o = getAppKitState();
  if (o)
    return o.btcConfig || failInitialization("AppKit was initialized without Bitcoin support. Initialize it with Bitcoin support.", "BTC"), o.btcConfig;
  if (!sharedBtcAppKitConfig)
    throw new Error(
      "Shared BTC AppKit config not initialized. Initialize AppKit with Bitcoin support, or use setSharedBtcAppKitConfig() as an exclusive manual alternative."
    );
  return sharedBtcAppKitConfig;
}
function hasSharedBtcAppKitConfig() {
  const o = getAppKitState();
  return o ? o.btcConfig !== void 0 : sharedBtcAppKitConfig !== null;
}
function btcDisconnectWouldDropEthereum() {
  var y;
  if (!hasSharedBtcAppKitConfig())
    return !1;
  const { modal: o } = getSharedBtcAppKitConfig(), g = o.getProviderType("bip122");
  return (g === "WALLET_CONNECT" || g === "AUTH") && ((y = o.getAccount("eip155")) == null ? void 0 : y.isConnected) === !0;
}
const APPKIT_PROVIDER_NAME = "AppKit";
function getAdapterConnections(o) {
  return o.connections ?? [];
}
class AppKitBTCProvider {
  constructor(g) {
    Vi(this, "config");
    Vi(this, "address");
    Vi(this, "publicKey");
    Vi(this, "eventHandlers", /* @__PURE__ */ new Map());
    Vi(this, "listeningForChanges", !1);
    Vi(this, "boundHandleAccountChange", null);
    Vi(this, "unsubscribeNetwork", null);
    Vi(this, "lastBtcNetworkId");
    /**
     * The {@link EventTarget} we currently have a persistent listener on.
     * Captured at registration time so we always remove the listener from
     * the same target we added it to, even if the shared config singleton
     * is replaced mid-session.
     */
    Vi(this, "boundConnectionEventsTarget", null);
    Vi(this, "deriveContextHash", unsupportedDeriveContextHash("AppKit Bitcoin"));
    this.config = g;
  }
  /**
   * Emit an event to all registered handlers for the given event name.
   */
  emit(g, ...c) {
    const y = this.eventHandlers.get(g);
    if (y)
      for (const t of y)
        try {
          t(...c);
        } catch (d) {
          console.error(`[AppKit Provider] Error in ${g} handler:`, d);
        }
  }
  /**
   * Start listening for account changes from the bridge hook.
   *
   * The listener is attached to the private `connectionEvents`
   * {@link EventTarget} held inside {@link SharedBtcAppKitConfig}, NOT on
   * `window`. The previous implementation listened on `window` for
   * `APPKIT_BTC_CONNECTED_EVENT` and adopted `event.detail.{address, publicKey}`
   * as truth. Any same-origin script (XSS, malicious extension content
   * script) could `window.dispatchEvent` a forged event with attacker-chosen
   * values and overwrite this provider's cached address/pubkey, which then
   * propagated through `accountsChanged` into `BTCWalletProvider` React
   * state and downstream consumers. Listening on a private `EventTarget`
   * instance closes that channel — there is no global handle for an attacker
   * to dispatch on.
   */
  startListeningForAccountChanges() {
    if (this.listeningForChanges || !hasSharedBtcAppKitConfig()) return;
    const { connectionEvents: g, modal: c } = getSharedBtcAppKitConfig();
    this.boundHandleAccountChange = (t) => {
      const d = t.detail;
      if (!(d != null && d.address)) {
        this.emit("accountsChanged", []);
        return;
      }
      d.address !== this.address && (this.address = d.address, this.publicKey = d.publicKey, this.emit("accountsChanged", [d.address]));
    }, g.addEventListener(APPKIT_BTC_CONNECTED_EVENT, this.boundHandleAccountChange), this.boundConnectionEventsTarget = g;
    const y = this.config.network === Network.MAINNET ? "mainnet" : "signet";
    this.lastBtcNetworkId = getCaipNetworkForNetwork(y).caipNetworkId, this.unsubscribeNetwork = c.subscribeNetwork(({ caipNetwork: t }) => {
      if ((t == null ? void 0 : t.chainNamespace) !== "bip122") return;
      const d = t.caipNetworkId;
      d !== this.lastBtcNetworkId && (this.lastBtcNetworkId = d, this.emit(NETWORK_CHANGE_EVENT, d));
    }), this.listeningForChanges = !0;
  }
  stopListeningForAccountChanges() {
    var g;
    !this.listeningForChanges || !this.boundHandleAccountChange || !this.boundConnectionEventsTarget || (this.boundConnectionEventsTarget.removeEventListener(APPKIT_BTC_CONNECTED_EVENT, this.boundHandleAccountChange), this.boundHandleAccountChange = null, this.boundConnectionEventsTarget = null, (g = this.unsubscribeNetwork) == null || g.call(this), this.unsubscribeNetwork = null, this.lastBtcNetworkId = void 0, this.listeningForChanges = !1);
  }
  /**
   * Get the shared AppKit config
   */
  getAppKitConfig() {
    if (!hasSharedBtcAppKitConfig())
      throw new Error(
        "AppKit BTC not initialized. Ensure AppKit modal is initialized at application startup by calling initializeAppKitModal() with btc config in your app's entry point."
      );
    return getSharedBtcAppKitConfig();
  }
  async connectWallet() {
    try {
      if (typeof window > "u")
        throw new Error("Window not available for AppKit modal");
      const { connectionEvents: g } = this.getAppKitConfig();
      window.dispatchEvent(new CustomEvent(APPKIT_OPEN_EVENT)), await new Promise((y, t) => {
        const d = setTimeout(() => {
          console.error("[AppKit Provider] Connection timeout after 60 seconds"), B(), t(new Error("Connection timeout"));
        }, 6e4), E = (D) => {
          const x = D.detail;
          x != null && x.address ? (B(), this.address = x.address, this.publicKey = x.publicKey, y()) : console.warn("[AppKit Provider] Event received but no address in detail");
        }, B = () => {
          clearTimeout(d), g.removeEventListener(APPKIT_BTC_CONNECTED_EVENT, E);
        };
        g.addEventListener(APPKIT_BTC_CONNECTED_EVENT, E);
      }), this.startListeningForAccountChanges();
    } catch (g) {
      throw console.error(
        "[AppKit Provider] Failed to connect Bitcoin wallet:",
        g instanceof Error ? g.message : "Unknown error"
      ), new Error(`Failed to connect Bitcoin wallet: ${g instanceof Error ? g.message : "Unknown error"}`);
    }
  }
  /**
   * `"local"` releases only this provider's cached session: the bridge calls
   * it once AppKit already reports bip122 disconnected, and the dialog calls
   * it for a wallet it rejected. `"chain"` disconnects only the bip122
   * namespace and refuses when AppKit would widen that to eip155 (WalletConnect
   * and Auth share one connector across namespaces). Local state clears only
   * after AppKit resolves: when AppKit rejects, its bip122 session is still
   * up. `"all"` is never refused and always clears local state.
   */
  async disconnect(g) {
    if (g === "local") {
      this.clearSession();
      return;
    }
    const { modal: c } = this.getAppKitConfig();
    if (g === "chain") {
      if (btcDisconnectWouldDropEthereum())
        throw new WalletError({
          code: ERROR_CODES.SHARED_SESSION_DISCONNECT_REFUSED,
          message: "Bitcoin and Ethereum share one wallet session. Disconnecting Bitcoin alone would also disconnect Ethereum. Disconnect all wallets instead.",
          wallet: APPKIT_PROVIDER_NAME,
          chainId: "BTC"
        });
      await c.disconnect("bip122"), this.clearSession();
      return;
    }
    try {
      await c.disconnect();
    } finally {
      this.clearSession();
    }
  }
  clearSession() {
    this.stopListeningForAccountChanges(), this.address = void 0, this.publicKey = void 0;
  }
  async getAddress() {
    var g;
    if (this.address)
      return this.address;
    if (hasSharedBtcAppKitConfig()) {
      const { adapter: c } = this.getAppKitConfig(), y = getAdapterConnections(c);
      if (y.length > 0 && ((g = y[0].account) != null && g.address) && (this.address = y[0].account.address, this.address))
        return this.address;
    }
    throw new Error("Bitcoin wallet not connected");
  }
  async getPublicKeyHex() {
    var g;
    if (this.publicKey)
      return this.publicKey;
    if (hasSharedBtcAppKitConfig()) {
      const { adapter: c } = this.getAppKitConfig(), y = getAdapterConnections(c);
      if (y.length > 0 && ((g = y[0].account) != null && g.publicKey) && (this.publicKey = y[0].account.publicKey, this.publicKey))
        return this.publicKey;
    }
    throw new Error("Bitcoin wallet not connected or public key not available");
  }
  async signPsbt(g, c) {
    try {
      const { modal: y } = this.getAppKitConfig(), t = await this.getAddress(), d = y.getProvider("bip122");
      if (!d)
        throw new Error("No wallet provider found for bip122 namespace");
      if (!d.signPSBT)
        throw new Error("Connected wallet does not support PSBT signing");
      const E = Psbt.fromHex(g).toBase64(), B = c != null && c.autoFinalized || !(c != null && c.signInputs) ? void 0 : c.signInputs.map((x) => {
        const v = resolveUseTweakedSigner(x);
        return {
          address: x.address ?? t,
          index: x.index,
          sighashTypes: x.sighashTypes ?? [],
          ...x.publicKey && { publicKey: x.publicKey },
          ...v !== void 0 && {
            useTweakedSigner: v,
            disableTweakSigner: !v
          }
        };
      }), D = await d.signPSBT({
        psbt: E,
        broadcast: !1,
        ...B && { signInputs: B }
      });
      if (!D.psbt)
        throw new Error("Unexpected signPSBT response: missing psbt field");
      return Psbt.fromBase64(D.psbt).toHex();
    } catch (y) {
      const t = y instanceof Error ? y.message : "Unknown error";
      throw console.error("[AppKit Provider] signPsbt failed:", t), isUserRejectionMessage(t) ? new WalletError({
        code: ERROR_CODES.CONNECTION_REJECTED,
        message: "User rejected the PSBT signing request in AppKit",
        wallet: "AppKit"
      }) : new Error(`Failed to sign PSBT: ${t}`);
    }
  }
  async signPsbts(g, c) {
    const y = [];
    for (let t = 0; t < g.length; t++) {
      const d = await this.signPsbt(g[t], c == null ? void 0 : c[t]);
      y.push(d);
    }
    return y;
  }
  async getNetwork() {
    var t, d;
    const { adapter: g } = this.getAppKitConfig(), c = getAdapterConnections(g);
    if (c.length === 0)
      throw new WalletError({
        code: ERROR_CODES.WALLET_NOT_CONNECTED,
        message: "AppKit Bitcoin wallet is not connected",
        wallet: APPKIT_PROVIDER_NAME
      });
    const y = (d = (t = c[0]) == null ? void 0 : t.caipNetwork) == null ? void 0 : d.caipNetworkId;
    return resolveLiveNetwork(y, this.config.network);
  }
  async signMessage(g, c) {
    try {
      const { modal: y } = this.getAppKitConfig(), t = await this.getAddress(), d = y.getProvider("bip122");
      if (!d)
        throw new Error("No wallet provider found for bip122 namespace");
      if (!d.signMessage)
        throw new Error("Connected wallet does not support message signing");
      const E = c === "bip322-simple" ? "bip322" : "ecdsa";
      return await d.signMessage({
        message: g,
        address: t,
        protocol: E
      });
    } catch (y) {
      throw console.error("[AppKit Provider] signMessage failed:", y instanceof Error ? y.message : "Unknown error"), new Error(`Failed to sign message: ${y instanceof Error ? y.message : "Unknown error"}`);
    }
  }
  on(g, c) {
    this.eventHandlers.has(g) || this.eventHandlers.set(g, /* @__PURE__ */ new Set()), this.eventHandlers.get(g).add(c);
  }
  off(g, c) {
    const y = this.eventHandlers.get(g);
    y && y.delete(c);
  }
  async getWalletProviderName() {
    return "AppKit Bitcoin";
  }
  async getWalletProviderIcon() {
    return icon$1;
  }
  async getInscriptions() {
    return [];
  }
  destroy() {
    this.stopListeningForAccountChanges(), this.eventHandlers.clear();
  }
}
const WALLET_PROVIDER_NAME$8 = "AppKit", metadata$b = {
  id: APPKIT_BTC_CONNECTOR_ID,
  name: WALLET_PROVIDER_NAME$8,
  icon: icon$1,
  docs: "https://docs.reown.com/appkit/networks/bitcoin",
  // Don't check for browser global - AppKit is modal-based, not extension-based
  wallet: void 0,
  createProvider: (o, g) => new AppKitBTCProvider(g),
  networks: [Network.MAINNET, Network.SIGNET],
  label: "Connect BTC Wallet"
}, icon = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='64'%20height='64'%3e%3cpath%20fill='%23f7931a'%20d='M63.04%2039.741c-4.275%2017.143-21.638%2027.576-38.783%2023.301C7.12%2058.768-3.313%2041.404.962%2024.262%205.234%207.117%2022.597-3.317%2039.737.957c17.144%204.274%2027.576%2021.64%2023.302%2038.784z'/%3e%3cpath%20fill='%23FFF'%20d='M46.11%2027.441c.636-4.258-2.606-6.547-7.039-8.074l1.438-5.768-3.51-.875-1.4%205.616c-.924-.23-1.872-.447-2.814-.662l1.41-5.653-3.509-.875-1.439%205.766c-.764-.174-1.514-.346-2.242-.527l.004-.018-4.842-1.209-.934%203.75s2.605.597%202.55.634c1.422.355%201.68%201.296%201.636%202.042l-1.638%206.571c.098.025.225.061.365.117l-.37-.092-2.297%209.205c-.174.432-.615%201.08-1.609.834.035.051-2.552-.637-2.552-.637l-1.743%204.019%204.57%201.139c.85.213%201.682.436%202.502.646l-1.453%205.834%203.507.875%201.44-5.772c.957.26%201.887.5%202.797.726l-1.434%205.745%203.511.875%201.453-5.823c5.987%201.133%2010.49.676%2012.384-4.739%201.527-4.36-.076-6.875-3.226-8.515%202.294-.529%204.022-2.038%204.483-5.155zM38.086%2038.69c-1.085%204.36-8.426%202.003-10.806%201.412l1.928-7.729c2.38.594%2010.012%201.77%208.878%206.317zm1.086-11.312c-.99%203.966-7.1%201.951-9.082%201.457l1.748-7.01c1.982.494%208.365%201.416%207.334%205.553z'/%3e%3c/svg%3e", wrapInjectable = (o) => {
  if (typeof o.deriveContextHash == "function") return o;
  const g = Object.create(o);
  return g.deriveContextHash = unsupportedDeriveContextHash("Injectable"), g;
}, metadata$a = {
  id: "injectable",
  name: (o) => {
    var g;
    return (g = o.getWalletProviderName) == null ? void 0 : g.call(o);
  },
  icon: (o) => {
    var g;
    return (g = o.getWalletProviderIcon) == null ? void 0 : g.call(o);
  },
  docs: "",
  wallet: "btcwallet",
  createProvider: (o) => wrapInjectable(o),
  networks: [Network.MAINNET, Network.SIGNET],
  label: "Injectable"
}, logo$6 = "data:image/svg+xml,%3csvg%20width='160'%20height='160'%20viewBox='0%200%20160%20160'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M30%2025H90L50%20110H20L30%2025Z'%20fill='%23FFFFFF'/%3e%3cpath%20d='M130%20135L70%20135L110%2050L140%2050L130%20135Z'%20fill='%23F5870A'/%3e%3c/svg%3e", byteToHex = [];
for (let o = 0; o < 256; ++o)
  byteToHex.push((o + 256).toString(16).slice(1));
function unsafeStringify(o, g = 0) {
  return (byteToHex[o[g + 0]] + byteToHex[o[g + 1]] + byteToHex[o[g + 2]] + byteToHex[o[g + 3]] + "-" + byteToHex[o[g + 4]] + byteToHex[o[g + 5]] + "-" + byteToHex[o[g + 6]] + byteToHex[o[g + 7]] + "-" + byteToHex[o[g + 8]] + byteToHex[o[g + 9]] + "-" + byteToHex[o[g + 10]] + byteToHex[o[g + 11]] + byteToHex[o[g + 12]] + byteToHex[o[g + 13]] + byteToHex[o[g + 14]] + byteToHex[o[g + 15]]).toLowerCase();
}
let getRandomValues;
const rnds8 = new Uint8Array(16);
function rng() {
  if (!getRandomValues) {
    if (typeof crypto > "u" || !crypto.getRandomValues)
      throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    getRandomValues = crypto.getRandomValues.bind(crypto);
  }
  return getRandomValues(rnds8);
}
const randomUUID = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), native = { randomUUID };
function v4(o, g, c) {
  var t;
  if (native.randomUUID && !o)
    return native.randomUUID();
  o = o || {};
  const y = o.random ?? ((t = o.rng) == null ? void 0 : t.call(o)) ?? rng();
  if (y.length < 16)
    throw new Error("Random bytes length must be >= 16");
  return y[6] = y[6] & 15 | 64, y[8] = y[8] & 63 | 128, unsafeStringify(y);
}
class BIP322 {
  /**
   * Compute the message hash as specified in the BIP-322.
   * The standard is specified in BIP-340 as:
   *      The function hashtag(x) where tag is a UTF-8 encoded tag name and x is a byte array returns the 32-byte hash SHA256(SHA256(tag) || SHA256(tag) || x).
   * @param message Message to be hashed
   * @returns Hashed message
   */
  static hashMessage(g) {
    const { sha256: c } = crypto$8, y = c(this.TAG);
    return c(Buffer.concat([y, y, Buffer.from(g)]));
  }
  /**
   * Build a to_spend transaction using simple signature in accordance to the BIP-322.
   * @param message Message to be signed using BIP-322
   * @param scriptPublicKey The script public key for the signing wallet
   * @returns Bitcoin transaction that correspond to the to_spend transaction
   */
  static buildToSpendTx(g, c) {
    const y = new Psbt();
    y.setVersion(0), y.setLocktime(0);
    const t = this.hashMessage(g), d = 0, E = 32, B = new Uint8Array([d, E]), D = new Uint8Array(B.length + t.length);
    return D.set(B), D.set(t, B.length), y.addInput({
      hash: "0".repeat(64),
      // vin[0].prevout.hash = 0000...000
      index: 4294967295,
      // vin[0].prevout.n = 0xFFFFFFFF
      sequence: 0,
      // vin[0].nSequence = 0
      finalScriptSig: Buffer.from(D),
      // vin[0].scriptSig = OP_0 PUSH32[ message_hash ]
      witnessScript: Buffer.from([])
      // vin[0].scriptWitness = []
    }), y.addOutput({
      value: 0,
      // vout[0].nValue = 0
      script: c
      // vout[0].scriptPubKey = message_challenge
    }), y.extractTransaction();
  }
  /**
   * Build a to_sign transaction using simple signature in accordance to the BIP-322.
   * @param toSpendTxId Transaction ID of the to_spend transaction as constructed by buildToSpendTx
   * @param witnessScript The script public key for the signing wallet, or the redeemScript for P2SH-P2WPKH address
   * @param isRedeemScript Set to true if the provided witnessScript is a redeemScript for P2SH-P2WPKH address, default to false
   * @param tapInternalKey Used to set the taproot internal public key of a taproot signing address when provided, default to undefined
   * @returns Ready-to-be-signed bitcoinjs.Psbt transaction
   */
  static buildToSignTx(g, c, y = !1, t) {
    const d = new Psbt();
    return d.setVersion(0), d.setLocktime(0), d.addInput({
      hash: g,
      // vin[0].prevout.hash = to_spend.txid
      index: 0,
      // vin[0].prevout.n = 0
      sequence: 0,
      // vin[0].nSequence = 0
      witnessUtxo: {
        script: c,
        value: 0
      }
    }), y && d.updateInput(0, {
      redeemScript: c
    }), t && d.updateInput(0, {
      tapInternalKey: t
    }), d.addOutput({
      value: 0,
      // vout[0].nValue = 0
      script: Buffer.from([106])
      // vout[0].scriptPubKey = OP_RETURN
    }), d;
  }
  /**
   * Encode witness stack in a signed BIP-322 PSBT into its base-64 encoded format.
   * @param signedPsbt Signed PSBT
   * @returns Base-64 encoded witness data
   */
  static encodeWitness(g) {
    const c = g.data.inputs[0].finalScriptWitness;
    if (!c)
      throw new WalletError({
        code: ERROR_CODES.EMPTY_WITNESS_STACK,
        message: "Cannot encode empty witness stack."
      });
    return c.toString("base64");
  }
}
// BIP322 message tag
Vi(BIP322, "TAG", Buffer.from("BIP0322-signed-message"));
const CANONICAL_NETWORK_NAME = {
  [Network.MAINNET]: "bitcoin-mainnet",
  [Network.TESTNET]: "bitcoin-testnet",
  [Network.SIGNET]: "bitcoin-signet"
}, canonicalNetworkName = (o) => CANONICAL_NETWORK_NAME[o], connectedLeafKeyPath = (o) => `${o}/0/0`, CONTEXT_HASH_OUTPUT_HEX_LENGTH = 64, LOWERCASE_HEX = /^[0-9a-f]+$/, isValidContextHashOutput = (o) => o.length === CONTEXT_HASH_OUTPUT_HEX_LENGTH && LOWERCASE_HEX.test(o), signingProgressLabel = (o, g) => `Transaction ${o + 1} of ${g}`, TAPROOT_PURPOSE = 86, TAPROOT_COIN_TYPE = {
  [Network.MAINNET]: 0,
  [Network.TESTNET]: 1,
  [Network.SIGNET]: 1
}, expectedTaprootCoinType = (o) => TAPROOT_COIN_TYPE[o], normalizeHardenedPath = (o) => o.replace(/h(?=\/|$)/g, "'"), purposeOf = (o) => parseInt(normalizeHardenedPath(o).split("/")[1], 10), getCoinType = (o) => parseInt(normalizeHardenedPath(o).split("/")[2], 10), findTaprootAccount = (o) => {
  const g = o.find((c) => purposeOf(c.path) === TAPROOT_PURPOSE);
  return g ? { ...g, path: normalizeHardenedPath(g.path) } : void 0;
}, WALLET_PROVIDER_NAME$7 = "Keystone", MIN_KEYSTONE_FIRMWARE_VERSION = "2.4.6";
class KeystoneProvider {
  constructor(g, c) {
    Vi(this, "keystoneWalletInfo");
    Vi(this, "viewSDK");
    Vi(this, "dataSdk");
    Vi(this, "config");
    /**
     * Connects the staking app to the Keystone device and retrieves the necessary information.
     * @returns A Promise that resolves to the current instance of the class.
     * @throws An error if there is an issue reading the QR code or retrieving the extended public key.
     */
    Vi(this, "connectWallet", async () => {
      const c = await (await this.viewSDK.getSdk()).read([SupportedResult.UR_CRYPTO_ACCOUNT], {
        title: "Sync Keystone with Babylon Staking App",
        description: "Please scan the QR code displayed on your Keystone, Currently only the first Taproot Address will be used",
        renderInitial: {
          walletMode: "",
          link: "",
          description: [
            `Requires Keystone firmware ${MIN_KEYSTONE_FIRMWARE_VERSION} or later.`,
            "1. Turn on your Keystone 3.",
            "2. Click connect software wallet and select Bitcoin Wallets.",
            '3. Press the "Sync Keystone" button and scan the QR Code displayed on your Keystone hardware wallet',
            "4. The first Taproot address will be used for staking."
          ]
        },
        URTypeErrorMessage: "The scanned QR code is not the sync code from the Keystone hardware wallet. Please verify the code and try again."
      });
      if (c.status === ReadStatus.canceled)
        throw new WalletError({
          code: ERROR_CODES.CONNECTION_CANCELED,
          message: "Connection to Keystone was canceled",
          wallet: WALLET_PROVIDER_NAME$7
        });
      if (c.status !== ReadStatus.success)
        throw new WalletError({
          code: ERROR_CODES.QR_READ_ERROR,
          message: "Error reading QR code, Please try again.",
          wallet: WALLET_PROVIDER_NAME$7
        });
      const y = this.dataSdk.parseAccount(c.result), t = findTaprootAccount(y.keys);
      if (!(t != null && t.extendedPublicKey))
        throw new WalletError({
          code: ERROR_CODES.EXTENSION_NOT_FOUND,
          message: "Could not retrieve the Taproot extended public key",
          wallet: WALLET_PROVIDER_NAME$7
        });
      const d = t.extendedPublicKey, E = getCoinType(t.path), B = expectedTaprootCoinType(this.config.network);
      E !== B && console.warn(
        `[Keystone] exported coin_type ${E} but ${this.config.network} expects ${B}; derived keys will not match software wallets for the same seed. Use a Keystone firmware/mode whose network matches the app.`
      ), this.keystoneWalletInfo = {
        mfp: y.masterFingerprint,
        extendedPublicKey: d,
        path: t.path,
        address: void 0,
        publicKeyHex: void 0,
        scriptPubKeyHex: void 0
      };
      const { address: D, publicKeyHex: x, scriptPubKeyHex: v } = generateP2TRAddressFromXpub(
        d,
        "M/0/0",
        toNetwork(this.config.network)
      );
      this.keystoneWalletInfo.address = D, this.keystoneWalletInfo.publicKeyHex = x, this.keystoneWalletInfo.scriptPubKeyHex = v;
    });
    Vi(this, "getAddress", async () => {
      var g;
      if (!((g = this.keystoneWalletInfo) != null && g.address))
        throw new WalletError({
          code: ERROR_CODES.ADDRESS_NOT_FOUND,
          message: "Could not retrieve the address",
          wallet: WALLET_PROVIDER_NAME$7
        });
      return this.keystoneWalletInfo.address;
    });
    Vi(this, "getPublicKeyHex", async () => {
      var g;
      if (!((g = this.keystoneWalletInfo) != null && g.publicKeyHex))
        throw new WalletError({
          code: ERROR_CODES.PUBLIC_KEY_NOT_FOUND,
          message: "Could not retrieve the BTC public key",
          wallet: WALLET_PROVIDER_NAME$7
        });
      return this.keystoneWalletInfo.publicKeyHex;
    });
    Vi(this, "signPsbt", async (g, c) => {
      var B, D, x;
      if (!((B = this.keystoneWalletInfo) != null && B.address) || !((D = this.keystoneWalletInfo) != null && D.publicKeyHex))
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "Keystone Wallet not connected",
          wallet: WALLET_PROVIDER_NAME$7
        });
      if (!g)
        throw new WalletError({
          code: ERROR_CODES.PSBT_HEX_REQUIRED,
          message: "psbt hex is required",
          wallet: WALLET_PROVIDER_NAME$7
        });
      const y = (x = c == null ? void 0 : c.signInputs) == null ? void 0 : x.map((v) => v.index);
      let t = Psbt.fromHex(g);
      t = this.enhancePsbt(t, y);
      const d = t.toHex();
      return (await this.sign(d, c)).toHex();
    });
    Vi(this, "signPsbts", async (g, c) => {
      var t, d;
      if (!((t = this.keystoneWalletInfo) != null && t.address) || !((d = this.keystoneWalletInfo) != null && d.publicKeyHex))
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "Keystone Wallet not connected",
          wallet: WALLET_PROVIDER_NAME$7
        });
      if (!g && !Array.isArray(g))
        throw new WalletError({
          code: ERROR_CODES.PSBTS_HEXES_REQUIRED,
          message: "psbts hexes are required",
          wallet: WALLET_PROVIDER_NAME$7
        });
      const y = [];
      for (let E = 0; E < g.length; E++) {
        const B = c == null ? void 0 : c[E], D = await this.signPsbt(g[E], {
          ...B,
          displayMessage: (B == null ? void 0 : B.displayMessage) ?? signingProgressLabel(E, g.length)
        });
        y.push(D);
      }
      return y;
    });
    Vi(this, "getNetwork", async () => this.config.network);
    Vi(this, "signMessage", async (g, c) => c === "bip322-simple" ? this.signMessageBIP322(g) : this.signMessageECDSA(g));
    /**
     * https://github.com/bitcoin/bips/blob/master/bip-0322.mediawiki
     * signMessageBIP322 signs a message using the BIP322 standard.
     * @param message
     * @returns signature
     */
    Vi(this, "signMessageBIP322", async (g) => {
      var B, D;
      if (!((B = this.keystoneWalletInfo) != null && B.scriptPubKeyHex) || !((D = this.keystoneWalletInfo) != null && D.publicKeyHex))
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "Keystone Wallet not connected",
          wallet: WALLET_PROVIDER_NAME$7
        });
      const c = bufferExports.Buffer.from(this.keystoneWalletInfo.scriptPubKeyHex, "hex"), y = BIP322.buildToSpendTx(g, c), t = bip371Exports.toXOnly(bufferExports.Buffer.from(this.keystoneWalletInfo.publicKeyHex, "hex"));
      let d = BIP322.buildToSignTx(y.getId(), c, !1, t);
      d.updateInput(0, {
        sighashType: Transaction$1.SIGHASH_ALL
      }), d = this.enhancePsbt(d);
      const E = await this.sign(d.toHex());
      return BIP322.encodeWitness(E);
    });
    Vi(this, "signMessageECDSA", async (g) => {
      var B, D, x;
      if (!((B = this.keystoneWalletInfo) != null && B.address) || !((D = this.keystoneWalletInfo) != null && D.publicKeyHex) || !((x = this.keystoneWalletInfo) != null && x.path))
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "Keystone Wallet not connected",
          wallet: WALLET_PROVIDER_NAME$7
        });
      const c = this.dataSdk.btc.generateSignRequest({
        requestId: v4(),
        signData: bufferExports.Buffer.from(g, "utf-8").toString("hex"),
        dataType: distExports.KeystoneBitcoinSDK.DataType.message,
        accounts: [
          {
            path: connectedLeafKeyPath(this.keystoneWalletInfo.path),
            xfp: `${this.keystoneWalletInfo.mfp}`,
            address: this.keystoneWalletInfo.address
          }
        ],
        origin: "babylon staking app"
      }), y = composeQRProcess(SupportedResult.UR_BTC_SIGNATURE), t = await this.viewSDK.getSdk(), d = await y(t, c), E = this.dataSdk.btc.parseSignature(d);
      return bufferExports.Buffer.from(E.signature, "hex").toString("base64");
    });
    Vi(this, "getInscriptions", async () => {
      throw new WalletError({
        code: ERROR_CODES.METHOD_NOT_IMPLEMENTED,
        message: "Method not implemented.",
        wallet: WALLET_PROVIDER_NAME$7
      });
    });
    // Not implemented because of the Airgapped HW nature
    Vi(this, "on", () => {
    });
    Vi(this, "off", () => {
    });
    Vi(this, "getWalletProviderName", async () => WALLET_PROVIDER_NAME$7);
    Vi(this, "getWalletProviderIcon", async () => logo$6);
    /**
     * Sign the PSBT with the Keystone device.
     *
     * @param psbtHex - The PSBT in hex format.
     * @param options - Optional signing parameters.
     * @returns The signed PSBT.
     * */
    Vi(this, "sign", async (g, c) => {
      if (!g)
        throw new WalletError({
          code: ERROR_CODES.PSBT_HEX_REQUIRED,
          message: "psbt hex is required",
          wallet: WALLET_PROVIDER_NAME$7
        });
      const y = this.dataSdk.btc.generatePSBT(bufferExports.Buffer.from(g, "hex")), t = composeQRProcess(SupportedResult.UR_PSBT, c == null ? void 0 : c.displayMessage), d = await this.viewSDK.getSdk(), E = await t(d, y), B = this.dataSdk.btc.parsePSBT(E), D = Psbt.fromHex(B);
      return (c == null ? void 0 : c.autoFinalized) === !1 || (initBTCCurve(), D.finalizeAllInputs()), D;
    });
    /**
     * Add the BIP32 derivation information for each input.
     * The Keystone device is stateless, so it needs to know which key to use to sign the PSBT.
     * Therefore, add the Taproot BIP32 derivation information to the PSBT.
     * https://github.com/bitcoin/bips/blob/master/bip-0174.mediawiki#Specification
     * @param psbt - The PSBT object.
     * @param inputIndexes - Optional array of input indexes to enhance. If not provided, all inputs are enhanced.
     * @returns The PSBT object with the BIP32 derivation information added.
     */
    Vi(this, "enhancePsbt", (g, c) => {
      var t, d, E, B;
      if (!((t = this.keystoneWalletInfo) != null && t.scriptPubKeyHex) || !((d = this.keystoneWalletInfo) != null && d.publicKeyHex) || !((E = this.keystoneWalletInfo) != null && E.mfp) || !((B = this.keystoneWalletInfo) != null && B.path))
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "Keystone Wallet not connected",
          wallet: WALLET_PROVIDER_NAME$7
        });
      const y = {
        masterFingerprint: bufferExports.Buffer.from(this.keystoneWalletInfo.mfp, "hex"),
        path: connectedLeafKeyPath(this.keystoneWalletInfo.path),
        pubkey: bufferExports.Buffer.from(this.keystoneWalletInfo.publicKeyHex, "hex")
      };
      return g.data.inputs.forEach((D, x) => {
        c && !c.includes(x) || (D.tapBip32Derivation = [
          {
            ...y,
            pubkey: bip371Exports.toXOnly(y.pubkey),
            leafHashes: calculateTapLeafHash(D, y.pubkey)
          }
        ]);
      }), g;
    });
    Vi(this, "deriveContextHash", async (g, c) => {
      var x;
      if (!((x = this.keystoneWalletInfo) != null && x.path))
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "Keystone Wallet not connected",
          wallet: WALLET_PROVIDER_NAME$7
        });
      const y = connectedLeafKeyPath(this.keystoneWalletInfo.path), t = this.dataSdk.generateDeriveContextHashCall({
        appName: g,
        network: canonicalNetworkName(this.config.network),
        keyPath: y,
        context: c,
        origin: "babylon staking app"
      }), d = composeQRProcess(SupportedResult.UR_BYTES), E = await this.viewSDK.getSdk(), B = await d(E, t), D = this.dataSdk.parseURBytes(B).toString("hex");
      if (!isValidContextHashOutput(D))
        throw new WalletError({
          code: ERROR_CODES.SIGNATURE_EXTRACT_ERROR,
          message: `Keystone returned an invalid deriveContextHash output; expected ${CONTEXT_HASH_OUTPUT_HEX_LENGTH} lowercase hex characters`,
          wallet: WALLET_PROVIDER_NAME$7
        });
      return D;
    });
    this.config = c, viewSdk.bootstrap(), this.viewSDK = viewSdk, this.dataSdk = new distExports.KeystoneSDK({
      origin: "babylon staking app"
    });
  }
}
const composeQRProcess = (o, g) => async (c, y) => {
  const t = g ? ` · ${g}` : "";
  if (await c.play(y, {
    title: `Scan the QR Code${t}`,
    description: "Please scan the QR code with your Keystone device."
  }) !== PlayStatus.success)
    throw new WalletError({
      code: ERROR_CODES.QR_SCAN_ERROR,
      message: "Could not generate the QR code, please try again.",
      wallet: WALLET_PROVIDER_NAME$7
    });
  const E = await c.read([o], {
    title: `Get the Signature from Keystone${t}`,
    description: "Please scan the QR code displayed on your Keystone",
    URTypeErrorMessage: "The scanned QR code can't be read. please verify and try again."
  });
  if (E.status !== ReadStatus.success)
    throw new WalletError({
      code: ERROR_CODES.SIGNATURE_EXTRACT_ERROR,
      message: "Could not extract the signature, please try again.",
      wallet: WALLET_PROVIDER_NAME$7
    });
  return E.result;
}, calculateTapLeafHash = (o, g) => o.tapInternalKey && !o.tapLeafScript ? [] : (o.tapLeafScript || []).filter((y) => psbtutilsExports.pubkeyInScript(g, y.script)).map((y) => {
  const t = bip341Exports.tapleafHash({
    output: y.script,
    version: y.leafVersion
  });
  return Object.assign({ hash: t }, y);
}).map((y) => y.hash), metadata$9 = {
  id: "keystone",
  name: WALLET_PROVIDER_NAME$7,
  icon: logo$6,
  iconBackground: MONOCHROME_MARK_BACKGROUND,
  docs: "https://www.keyst.one/btc-only",
  createProvider: (o, g) => new KeystoneProvider(o, g),
  networks: [Network.MAINNET, Network.SIGNET],
  label: "Hardware wallet",
  hardware: !0
}, logo$5 = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='157'%20height='157'%3e%3cpath%20fill='%23FFFFFF'%20fill-rule='nonzero'%20d='M5%20106.655V143h55.308v-8.06h-47.25v-28.285H5Zm138.98%200v28.285H96.731v8.058h55.308v-36.343h-8.059Zm-83.592-55.31v55.308h36.343v-7.269H68.446V51.345h-8.058ZM5%2015v36.345h8.058V23.058h47.25V15H5Zm91.731%200v8.058h47.249v28.287h8.059V15H96.731Z'/%3e%3c/svg%3e";
var eventsExports = requireEvents();
const EventEmitter = /* @__PURE__ */ getDefaultExportFromCjs(eventsExports), errorClasses = {}, deserializers = {}, addCustomErrorDeserializer = (o, g) => {
  deserializers[o] = g;
}, createCustomErrorClass = (o) => {
  class g extends Error {
    constructor(t, d, E) {
      super(t || o, E);
      Vi(this, "cause");
      if (Object.setPrototypeOf(this, g.prototype), this.name = o, d)
        for (const B in d)
          this[B] = d[B];
      if (E && isObject(E) && "cause" in E && !this.cause) {
        const B = E.cause;
        this.cause = B, "stack" in B && (this.stack = this.stack + `
CAUSE: ` + B.stack);
      }
    }
  }
  return errorClasses[o] = g, g;
};
function isObject(o) {
  return typeof o == "object";
}
createCustomErrorClass("AccountNameRequired");
createCustomErrorClass("AccountNotSupported");
createCustomErrorClass("AccountAwaitingSendPendingOperations");
createCustomErrorClass("AmountRequired");
createCustomErrorClass("BluetoothRequired");
createCustomErrorClass("BtcUnmatchedApp");
createCustomErrorClass("CantOpenDevice");
createCustomErrorClass("CashAddrNotSupported");
createCustomErrorClass("ClaimRewardsFeesWarning");
createCustomErrorClass("CurrencyNotSupported");
createCustomErrorClass("DeviceAppVerifyNotSupported");
createCustomErrorClass("DeviceGenuineSocketEarlyClose");
createCustomErrorClass("DeviceNotGenuine");
createCustomErrorClass("DeviceOnDashboardExpected");
createCustomErrorClass("DeviceOnDashboardUnexpected");
createCustomErrorClass("DeviceInOSUExpected");
createCustomErrorClass("DeviceHalted");
createCustomErrorClass("DeviceNameInvalid");
createCustomErrorClass("DeviceSocketFail");
createCustomErrorClass("DeviceSocketNoBulkStatus");
createCustomErrorClass("DeviceSocketNoBulkStatus");
createCustomErrorClass("UnresponsiveDeviceError");
const DisconnectedDevice = createCustomErrorClass("DisconnectedDevice"), DisconnectedDeviceDuringOperation = createCustomErrorClass("DisconnectedDeviceDuringOperation");
createCustomErrorClass("DeviceExtractOnboardingStateError");
createCustomErrorClass("DeviceOnboardingStatePollingError");
createCustomErrorClass("EnpointConfig");
createCustomErrorClass("EthAppPleaseEnableContractData");
createCustomErrorClass("FeeEstimationFailed");
createCustomErrorClass("FirmwareNotRecognized");
createCustomErrorClass("HardResetFail");
createCustomErrorClass("InvalidXRPTag");
createCustomErrorClass("InvalidAddress");
createCustomErrorClass("InvalidNonce");
createCustomErrorClass("InvalidAddressBecauseDestinationIsAlsoSource");
createCustomErrorClass("LatestMCUInstalledError");
createCustomErrorClass("LatestFirmwareVersionRequired");
createCustomErrorClass("UnknownMCU");
createCustomErrorClass("LedgerAPIError");
createCustomErrorClass("LedgerAPIErrorWithMessage");
createCustomErrorClass("LedgerAPINotAvailable");
createCustomErrorClass("ManagerAppAlreadyInstalled");
createCustomErrorClass("ManagerAppRelyOnBTC");
createCustomErrorClass("ManagerAppDepInstallRequired");
createCustomErrorClass("ManagerAppDepUninstallRequired");
createCustomErrorClass("ManagerDeviceLocked");
createCustomErrorClass("ManagerFirmwareNotEnoughSpace");
createCustomErrorClass("ManagerNotEnoughSpace");
createCustomErrorClass("ManagerUninstallBTCDep");
createCustomErrorClass("NetworkDown");
createCustomErrorClass("NetworkError");
createCustomErrorClass("NoAddressesFound");
createCustomErrorClass("NotEnoughBalance");
createCustomErrorClass("NotEnoughBalanceFees");
createCustomErrorClass("NotEnoughBalanceSwap");
createCustomErrorClass("NotEnoughBalanceToDelegate");
createCustomErrorClass("UnstakeNotEnoughStakedBalanceLeft");
createCustomErrorClass("RestakeNotEnoughStakedBalanceLeft");
createCustomErrorClass("NotEnoughToRestake");
createCustomErrorClass("NotEnoughToUnstake");
createCustomErrorClass("NotEnoughBalanceInParentAccount");
createCustomErrorClass("NotEnoughSpendableBalance");
createCustomErrorClass("NotEnoughBalanceBecauseDestinationNotCreated");
createCustomErrorClass("NotEnoughToStake");
createCustomErrorClass("NoAccessToCamera");
createCustomErrorClass("NotEnoughGas");
createCustomErrorClass("NotEnoughGasSwap");
createCustomErrorClass("TronEmptyAccount");
createCustomErrorClass("MaybeKeepTronAccountAlive");
createCustomErrorClass("NotSupportedLegacyAddress");
createCustomErrorClass("GasLessThanEstimate");
createCustomErrorClass("PriorityFeeTooLow");
createCustomErrorClass("PriorityFeeTooHigh");
createCustomErrorClass("PriorityFeeHigherThanMaxFee");
createCustomErrorClass("MaxFeeTooLow");
createCustomErrorClass("PasswordsDontMatch");
createCustomErrorClass("PasswordIncorrect");
createCustomErrorClass("RecommendSubAccountsToEmpty");
createCustomErrorClass("RecommendUndelegation");
createCustomErrorClass("TimeoutTagged");
createCustomErrorClass("UnexpectedBootloader");
createCustomErrorClass("MCUNotGenuineToDashboard");
createCustomErrorClass("RecipientRequired");
createCustomErrorClass("UnavailableTezosOriginatedAccountReceive");
createCustomErrorClass("UnavailableTezosOriginatedAccountSend");
createCustomErrorClass("UpdateFetchFileFail");
createCustomErrorClass("UpdateIncorrectHash");
createCustomErrorClass("UpdateIncorrectSig");
createCustomErrorClass("UpdateYourApp");
createCustomErrorClass("UserRefusedDeviceNameChange");
createCustomErrorClass("UserRefusedAddress");
createCustomErrorClass("UserRefusedFirmwareUpdate");
createCustomErrorClass("UserRefusedAllowManager");
createCustomErrorClass("UserRefusedOnDevice");
createCustomErrorClass("PinNotSet");
createCustomErrorClass("ExpertModeRequired");
const TransportOpenUserCancelled = createCustomErrorClass("TransportOpenUserCancelled"), TransportInterfaceNotAvailable = createCustomErrorClass("TransportInterfaceNotAvailable"), TransportRaceCondition = createCustomErrorClass("TransportRaceCondition"), TransportWebUSBGestureRequired = createCustomErrorClass("TransportWebUSBGestureRequired");
createCustomErrorClass("TransactionHasBeenValidatedError");
createCustomErrorClass("TransportExchangeTimeoutError");
createCustomErrorClass("DeviceShouldStayInApp");
createCustomErrorClass("WebsocketConnectionError");
createCustomErrorClass("WebsocketConnectionFailed");
createCustomErrorClass("WrongDeviceForAccount");
createCustomErrorClass("WrongDeviceForAccountPayout");
createCustomErrorClass("MissingSwapPayloadParamaters");
createCustomErrorClass("WrongDeviceForAccountRefund");
createCustomErrorClass("WrongAppForCurrency");
createCustomErrorClass("ETHAddressNonEIP");
createCustomErrorClass("CantScanQRCode");
createCustomErrorClass("FeeNotLoaded");
createCustomErrorClass("FeeNotLoadedSwap");
createCustomErrorClass("FeeRequired");
createCustomErrorClass("FeeTooHigh");
createCustomErrorClass("PendingOperation");
createCustomErrorClass("SyncError");
createCustomErrorClass("PairingFailed");
createCustomErrorClass("PeerRemovedPairing");
createCustomErrorClass("GenuineCheckFailed");
createCustomErrorClass("LedgerAPI4xx");
createCustomErrorClass("LedgerAPI5xx");
createCustomErrorClass("FirmwareOrAppUpdateRequired");
createCustomErrorClass("ReplacementTransactionUnderpriced");
createCustomErrorClass("OpReturnSizeLimit");
createCustomErrorClass("DustLimit");
createCustomErrorClass("HederaInsufficientFundsForAssociation");
createCustomErrorClass("HederaRecipientTokenAssociationRequired");
createCustomErrorClass("HederaRecipientTokenAssociationUnverified");
createCustomErrorClass("LanguageNotFound");
createCustomErrorClass("NoDBPathGiven");
createCustomErrorClass("DBWrongPassword");
createCustomErrorClass("DBNotReset");
createCustomErrorClass("SequenceNumberError");
createCustomErrorClass("DisabledTransactionBroadcastError");
var HwTransportErrorType;
(function(o) {
  o.Unknown = "Unknown", o.LocationServicesDisabled = "LocationServicesDisabled", o.LocationServicesUnauthorized = "LocationServicesUnauthorized", o.BluetoothScanStartFailed = "BluetoothScanStartFailed";
})(HwTransportErrorType || (HwTransportErrorType = {}));
class TransportError extends Error {
  constructor(c, y) {
    const t = "TransportError";
    super(c || t);
    Vi(this, "id");
    this.name = t, this.message = c, this.stack = new Error(c).stack, this.id = y;
  }
}
addCustomErrorDeserializer("TransportError", (o) => new TransportError(o.message, o.id));
const StatusCodes = {
  ACCESS_CONDITION_NOT_FULFILLED: 38916,
  ALGORITHM_NOT_SUPPORTED: 38020,
  CLA_NOT_SUPPORTED: 28160,
  CODE_BLOCKED: 38976,
  CODE_NOT_INITIALIZED: 38914,
  COMMAND_INCOMPATIBLE_FILE_STRUCTURE: 27009,
  CONDITIONS_OF_USE_NOT_SATISFIED: 27013,
  CONTRADICTION_INVALIDATION: 38928,
  CONTRADICTION_SECRET_CODE_STATUS: 38920,
  DEVICE_IN_RECOVERY_MODE: 26159,
  CUSTOM_IMAGE_EMPTY: 26158,
  FILE_ALREADY_EXISTS: 27273,
  FILE_NOT_FOUND: 37892,
  GP_AUTH_FAILED: 25344,
  HALTED: 28586,
  INCONSISTENT_FILE: 37896,
  INCORRECT_DATA: 27264,
  INCORRECT_LENGTH: 26368,
  INCORRECT_P1_P2: 27392,
  INS_NOT_SUPPORTED: 27904,
  DEVICE_NOT_ONBOARDED: 27911,
  DEVICE_NOT_ONBOARDED_2: 26129,
  INVALID_KCV: 38021,
  INVALID_OFFSET: 37890,
  LICENSING: 28482,
  LOCKED_DEVICE: 21781,
  MAX_VALUE_REACHED: 38992,
  MEMORY_PROBLEM: 37440,
  MISSING_CRITICAL_PARAMETER: 26624,
  NO_EF_SELECTED: 37888,
  NOT_ENOUGH_MEMORY_SPACE: 27268,
  OK: 36864,
  PIN_REMAINING_ATTEMPTS: 25536,
  REFERENCED_DATA_NOT_FOUND: 27272,
  SECURITY_STATUS_NOT_SATISFIED: 27010,
  TECHNICAL_PROBLEM: 28416,
  UNKNOWN_APDU: 27906,
  USER_REFUSED_ON_DEVICE: 21761,
  NOT_ENOUGH_SPACE: 20738,
  APP_NOT_FOUND_OR_INVALID_CONTEXT: 20771,
  INVALID_APP_NAME_LENGTH: 26378,
  GEN_AES_KEY_FAILED: 21529,
  INTERNAL_CRYPTO_OPERATION_FAILED: 21530,
  INTERNAL_COMPUTE_AES_CMAC_FAILED: 21531,
  ENCRYPT_APP_STORAGE_FAILED: 21532,
  INVALID_BACKUP_STATE: 26178,
  PIN_NOT_SET: 21762,
  INVALID_BACKUP_LENGTH: 26419,
  INVALID_RESTORE_STATE: 26179,
  INVALID_CHUNK_LENGTH: 26420,
  INVALID_BACKUP_HEADER: 26698,
  // Not documented:
  TRUSTCHAIN_WRONG_SEED: 45063
};
function getAltStatusMessage(o) {
  switch (o) {
    // improve text of most common errors
    case 26368:
      return "Incorrect length";
    case 26624:
      return "Missing critical parameter";
    case 27010:
      return "Security not satisfied (dongle locked or have invalid access rights)";
    case 27013:
      return "Condition of use not satisfied (denied by the user?)";
    case 27264:
      return "Invalid data received";
    case 27392:
      return "Invalid parameter received";
    case 21781:
      return "Locked device";
  }
  if (28416 <= o && o <= 28671)
    return "Internal error, please report";
}
class TransportStatusError extends Error {
  /**
   * @param statusCode The error status code coming from a Transport implementation
   * @param options containing:
   *  - canBeMappedToChildError: enable the mapping of TransportStatusError to an error extending/inheriting from it
   *  . Ex: LockedDeviceError. Default to true.
   */
  constructor(c, { canBeMappedToChildError: y = !0 } = {}) {
    const t = Object.keys(StatusCodes).find((D) => StatusCodes[D] === c) || "UNKNOWN_ERROR", d = getAltStatusMessage(c) || t, E = c.toString(16), B = `Ledger device: ${d} (0x${E})`;
    super(B);
    Vi(this, "statusCode");
    Vi(this, "statusText");
    if (this.name = "TransportStatusError", this.statusCode = c, this.statusText = t, Object.setPrototypeOf(this, TransportStatusError.prototype), y && c === StatusCodes.LOCKED_DEVICE)
      return new LockedDeviceError(B);
  }
}
class LockedDeviceError extends TransportStatusError {
  constructor(g) {
    super(StatusCodes.LOCKED_DEVICE, { canBeMappedToChildError: !1 }), g && (this.message = g), this.name = "LockedDeviceError", Object.setPrototypeOf(this, LockedDeviceError.prototype);
  }
}
addCustomErrorDeserializer("TransportStatusError", (o) => new TransportStatusError(o.statusCode));
let id = 0;
const subscribers = [], log = (o, g, c) => {
  const y = {
    type: o,
    id: String(++id),
    date: /* @__PURE__ */ new Date()
  };
  g && (y.message = g), dispatch(y);
}, trace = ({ type: o, message: g, data: c, context: y }) => {
  const t = {
    type: o,
    id: String(++id),
    date: /* @__PURE__ */ new Date()
  };
  g && (t.message = g), c && (t.data = c), y && (t.context = y), dispatch(t);
};
class LocalTracer {
  constructor(g, c) {
    Vi(this, "type");
    Vi(this, "context");
    this.type = g, this.context = c;
  }
  trace(g, c) {
    trace({
      type: this.type,
      message: g,
      data: c,
      context: this.context
    });
  }
  getContext() {
    return this.context;
  }
  setContext(g) {
    this.context = g;
  }
  updateContext(g) {
    this.context = { ...this.context, ...g };
  }
  getType() {
    return this.type;
  }
  setType(g) {
    this.type = g;
  }
  /**
   * Create a new instance of the LocalTracer with an updated `type`
   *
   * It does not mutate the calling instance, but returns a new LocalTracer,
   * following a simple builder pattern.
   */
  withType(g) {
    return new LocalTracer(g, this.context);
  }
  /**
   * Create a new instance of the LocalTracer with a new `context`
   *
   * It does not mutate the calling instance, but returns a new LocalTracer,
   * following a simple builder pattern.
   *
   * @param context A TraceContext, that can undefined to reset the context
   */
  withContext(g) {
    return new LocalTracer(this.type, g);
  }
  /**
   * Create a new instance of the LocalTracer with an updated `context`,
   * on which an additional context is merged with the existing one.
   *
   * It does not mutate the calling instance, but returns a new LocalTracer,
   * following a simple builder pattern.
   */
  withUpdatedContext(g) {
    return new LocalTracer(this.type, { ...this.context, ...g });
  }
}
const listen = (o) => (subscribers.push(o), () => {
  const g = subscribers.indexOf(o);
  g !== -1 && (subscribers[g] = subscribers[subscribers.length - 1], subscribers.pop());
});
function dispatch(o) {
  for (let g = 0; g < subscribers.length; g++)
    try {
      subscribers[g](o);
    } catch (c) {
      console.error(c);
    }
}
typeof window < "u" && (window.__ledgerLogsListen = listen);
const DEFAULT_LOG_TYPE = "transport";
class Transport {
  constructor({ context: g, logType: c } = {}) {
    Vi(this, "exchangeTimeout", 3e4);
    Vi(this, "unresponsiveTimeout", 15e3);
    Vi(this, "deviceModel", null);
    Vi(this, "tracer");
    Vi(this, "_events", new EventEmitter());
    /**
     * Send data to the device using the higher level API.
     *
     * @param {number} cla - The instruction class for the command.
     * @param {number} ins - The instruction code for the command.
     * @param {number} p1 - The first parameter for the instruction.
     * @param {number} p2 - The second parameter for the instruction.
     * @param {Buffer} data - The data to be sent. Defaults to an empty buffer.
     * @param {Array<number>} statusList - A list of acceptable status codes for the response. Defaults to [StatusCodes.OK].
     * @param {Object} options - Contains optional options for the exchange function
     *  - abortTimeoutMs: stop the send after a given timeout. Another timeout exists
     *    to detect unresponsive device (see `unresponsiveTimeout`). This timeout aborts the exchange.
     * @returns {Promise<Buffer>} A promise that resolves with the response data from the device.
     */
    Vi(this, "send", async (g, c, y, t, d = Buffer.alloc(0), E = [StatusCodes.OK], { abortTimeoutMs: B } = {}) => {
      const D = this.tracer.withUpdatedContext({ function: "send" });
      if (d.length >= 256)
        throw D.trace("data.length exceeded 256 bytes limit", { dataLength: d.length }), new TransportError("data.length exceed 256 bytes limit. Got: " + d.length, "DataLengthTooBig");
      D.trace("Starting an exchange", { abortTimeoutMs: B });
      const x = await this.exchange(
        // The size of the data is added in 1 byte just before `data`
        Buffer.concat([Buffer.from([g, c, y, t]), Buffer.from([d.length]), d]),
        { abortTimeoutMs: B }
      );
      D.trace("Received response from exchange");
      const v = x.readUInt16BE(x.length - 2);
      if (!E.some((F) => F === v))
        throw new TransportStatusError(v);
      return x;
    });
    // Blocks other exchange to happen concurrently
    Vi(this, "exchangeBusyPromise");
    Vi(this, "_appAPIlock", null);
    this.tracer = new LocalTracer(c ?? DEFAULT_LOG_TYPE, g);
  }
  /**
   * Send data to the device using a low level API.
   * It's recommended to use the "send" method for a higher level API.
   * @param {Buffer} apdu - The data to send.
   * @param {Object} options - Contains optional options for the exchange function
   *  - abortTimeoutMs: stop the exchange after a given timeout. Another timeout exists
   *    to detect unresponsive device (see `unresponsiveTimeout`). This timeout aborts the exchange.
   * @returns {Promise<Buffer>} A promise that resolves with the response data from the device.
   */
  exchange(g, { abortTimeoutMs: c } = {}) {
    throw new Error("exchange not implemented");
  }
  /**
   * Send apdus in batch to the device using a low level API.
   * The default implementation is to call exchange for each apdu.
   * @param {Array<Buffer>} apdus - array of apdus to send.
   * @param {Observer<Buffer>} observer - an observer that will receive the response of each apdu.
   * @returns {Subscription} A Subscription object on which you can call ".unsubscribe()" to stop sending apdus.
   */
  exchangeBulk(g, c) {
    let y = !1;
    const t = () => {
      y = !0;
    };
    return (async () => {
      if (!y)
        for (const E of g) {
          const B = await this.exchange(E);
          if (y)
            return;
          const D = B.readUInt16BE(B.length - 2);
          if (D !== StatusCodes.OK)
            throw new TransportStatusError(D);
          c.next(B);
        }
    })().then(() => !y && c.complete(), (E) => !y && c.error(E)), { unsubscribe: t };
  }
  /**
   * Set the "scramble key" for the next data exchanges with the device.
   * Each app can have a different scramble key and it is set internally during instantiation.
   * @param {string} key - The scramble key to set.
   * deprecated This method is no longer needed for modern transports and should be migrated away from.
   * no @ before deprecated as it breaks documentationjs on version 14.0.2
   * https://github.com/documentationjs/documentation/issues/1596
   */
  setScrambleKey(g) {
  }
  /**
   * Close the connection with the device.
   *
   * Note: for certain transports (hw-transport-node-hid-singleton for ex), once the promise resolved,
   * the transport instance is actually still cached, and the device is disconnected only after a defined timeout.
   * But for the consumer of the Transport, this does not matter and it can consider the transport to be closed.
   *
   * @returns {Promise<void>} A promise that resolves when the transport is closed.
   */
  close() {
    return Promise.resolve();
  }
  /**
   * Listen for an event on the transport instance.
   * Transport implementations may have specific events. Common events include:
   * "disconnect" : triggered when the transport is disconnected.
   * @param {string} eventName - The name of the event to listen for.
   * @param {(...args: Array<any>) => any} cb - The callback function to be invoked when the event occurs.
   */
  on(g, c) {
    this._events.on(g, c);
  }
  /**
   * Stop listening to an event on an instance of transport.
   */
  off(g, c) {
    this._events.removeListener(g, c);
  }
  emit(g, ...c) {
    this._events.emit(g, ...c);
  }
  /**
   * Enable or not logs of the binary exchange
   */
  setDebugMode() {
    console.warn("setDebugMode is deprecated. use @ledgerhq/logs instead. No logs are emitted in this anymore.");
  }
  /**
   * Set a timeout (in milliseconds) for the exchange call. Only some transport might implement it. (e.g. U2F)
   */
  setExchangeTimeout(g) {
    this.exchangeTimeout = g;
  }
  /**
   * Define the delay before emitting "unresponsive" on an exchange that does not respond
   */
  setExchangeUnresponsiveTimeout(g) {
    this.unresponsiveTimeout = g;
  }
  /**
   * create() allows to open the first descriptor available or
   * throw if there is none or if timeout is reached.
   * This is a light helper, alternative to using listen() and open() (that you may need for any more advanced usecase)
   * @example
  TransportFoo.create().then(transport => ...)
   */
  static create(g = 3e3, c) {
    return new Promise((y, t) => {
      let d = !1;
      const E = this.listen({
        next: (D) => {
          d = !0, E && E.unsubscribe(), B && clearTimeout(B), this.open(D.descriptor, g).then(y, t);
        },
        error: (D) => {
          B && clearTimeout(B), t(D);
        },
        complete: () => {
          B && clearTimeout(B), d || t(new TransportError(this.ErrorMessage_NoDeviceFound, "NoDeviceFound"));
        }
      }), B = c ? setTimeout(() => {
        E.unsubscribe(), t(new TransportError(this.ErrorMessage_ListenTimeout, "ListenTimeout"));
      }, c) : null;
    });
  }
  /**
   * Wrapper to make an exchange "atomic" (blocking any other exchange)
   *
   * It also handles "unresponsiveness" by emitting "unresponsive" and "responsive" events.
   *
   * @param f The exchange job, using the transport to run
   * @returns a Promise resolving with the output of the given job
   */
  async exchangeAtomicImpl(g) {
    const c = this.tracer.withUpdatedContext({
      function: "exchangeAtomicImpl",
      unresponsiveTimeout: this.unresponsiveTimeout
    });
    if (this.exchangeBusyPromise)
      throw c.trace("Atomic exchange is already busy"), new TransportRaceCondition("An action was already pending on the Ledger device. Please deny or reconnect.");
    let y;
    const t = new Promise((B) => {
      y = B;
    });
    this.exchangeBusyPromise = t;
    let d = !1;
    const E = setTimeout(() => {
      c.trace('Timeout reached, emitting Transport event "unresponsive"', {
        unresponsiveTimeout: this.unresponsiveTimeout
      }), d = !0, this.emit("unresponsive");
    }, this.unresponsiveTimeout);
    try {
      const B = await g();
      return d && (c.trace("Device was unresponsive, emitting responsive"), this.emit("responsive")), B;
    } finally {
      c.trace("Finalize, clearing busy guard"), clearTimeout(E), y && y(), this.exchangeBusyPromise = null;
    }
  }
  decorateAppAPIMethods(g, c, y) {
    for (const t of c)
      g[t] = this.decorateAppAPIMethod(t, g[t], g, y);
  }
  decorateAppAPIMethod(g, c, y, t) {
    return async (...d) => {
      const { _appAPIlock: E } = this;
      if (E)
        return Promise.reject(new TransportError("Ledger Device is busy (lock " + E + ")", "TransportLocked"));
      try {
        return this._appAPIlock = g, this.setScrambleKey(t), await c.apply(y, d);
      } finally {
        this._appAPIlock = null;
      }
    };
  }
  /**
   * Sets the context used by the logging/tracing mechanism
   *
   * Useful when re-using (cached) the same Transport instance,
   * but with a new tracing context.
   *
   * @param context A TraceContext, that can undefined to reset the context
   */
  setTraceContext(g) {
    this.tracer = this.tracer.withContext(g);
  }
  /**
   * Updates the context used by the logging/tracing mechanism
   *
   * The update only overrides the key-value that are already defined in the current context.
   *
   * @param contextToAdd A TraceContext that will be added to the current context
   */
  updateTraceContext(g) {
    this.tracer.updateContext(g);
  }
  /**
   * Gets the tracing context of the transport instance
   */
  getTraceContext() {
    return this.tracer.getContext();
  }
}
/**
 * Check if the transport is supported on the current platform/browser.
 * @returns {Promise<boolean>} A promise that resolves with a boolean indicating support.
 */
Vi(Transport, "isSupported"), /**
 * List all available descriptors for the transport.
 * For a better granularity, checkout `listen()`.
 *
 * @returns {Promise<Array<any>>} A promise that resolves with an array of descriptors.
 * @example
 * TransportFoo.list().then(descriptors => ...)
 */
Vi(Transport, "list"), /**
 * Listen for device events for the transport. The method takes an observer of DescriptorEvent and returns a Subscription.
 * A DescriptorEvent is an object containing a "descriptor" and a "type" field. The "type" field can be "add" or "remove", and the "descriptor" field can be passed to the "open" method.
 * The "listen" method will first emit all currently connected devices and then will emit events as they occur, such as when a USB device is plugged in or a Bluetooth device becomes discoverable.
 * @param {Observer<DescriptorEvent<any>>} observer - An object with "next", "error", and "complete" functions, following the observer pattern.
 * @returns {Subscription} A Subscription object on which you can call ".unsubscribe()" to stop listening to descriptors.
 * @example
const sub = TransportFoo.listen({
next: e => {
  if (e.type==="add") {
    sub.unsubscribe();
    const transport = await TransportFoo.open(e.descriptor);
    ...
  }
},
error: error => {},
complete: () => {}
})
 */
Vi(Transport, "listen"), /**
 * Attempt to create a Transport instance with a specific descriptor.
 * @param {any} descriptor - The descriptor to open the transport with.
 * @param {number} timeout - An optional timeout for the transport connection.
 * @param {TraceContext} context Optional tracing/log context
 * @returns {Promise<Transport>} A promise that resolves with a Transport instance.
 * @example
TransportFoo.open(descriptor).then(transport => ...)
 */
Vi(Transport, "open"), Vi(Transport, "ErrorMessage_ListenTimeout", "No Ledger device found (timeout)"), Vi(Transport, "ErrorMessage_NoDeviceFound", "No Ledger device found");
const Tag = 5;
function asUInt16BE(o) {
  const g = Buffer.alloc(2);
  return g.writeUInt16BE(o, 0), g;
}
const initialAcc = {
  data: Buffer.alloc(0),
  dataLength: 0,
  sequence: 0
}, createHIDframing = (o, g) => ({
  /**
   * Frames/encodes an APDU message into HID USB packets/frames
   *
   * @param apdu The APDU message to send, in a Buffer containing [cla, ins, p1, p2, data length, data(if not empty)]
   * @returns an array of HID USB frames ready to be sent
   */
  makeBlocks(c) {
    let y = Buffer.concat([asUInt16BE(c.length), c]);
    const t = g - 5, d = Math.ceil(y.length / t);
    y = Buffer.concat([y, Buffer.alloc(d * t - y.length + 1).fill(0)]);
    const E = [];
    for (let B = 0; B < d; B++) {
      const D = Buffer.alloc(5);
      D.writeUInt16BE(o, 0), D.writeUInt8(Tag, 2), D.writeUInt16BE(B, 3);
      const x = y.slice(B * t, (B + 1) * t);
      E.push(Buffer.concat([D, x]));
    }
    return E;
  },
  /**
   * Reduces HID USB packets/frames to one response.
   *
   * @param acc The value resulting from (accumulating) the previous call of reduceResponse.
   *   On first call initialized to `initialAcc`. The accumulator enables handling multi-frames messages.
   * @param chunk Current chunk to reduce into accumulator
   * @returns An accumulator value updated with the current chunk
   */
  reduceResponse(c, y) {
    let { data: t, dataLength: d, sequence: E } = c || initialAcc;
    if (y.readUInt16BE(0) !== o)
      throw new TransportError("Invalid channel", "InvalidChannel");
    if (y.readUInt8(2) !== Tag)
      throw new TransportError("Invalid tag", "InvalidTag");
    if (y.readUInt16BE(3) !== E)
      throw new TransportError("Invalid sequence", "InvalidSequence");
    c || (d = y.readUInt16BE(5)), E++;
    const B = y.slice(c ? 5 : 7);
    return t = Buffer.concat([t, B]), t.length > d && (t = t.slice(0, d)), {
      data: t,
      dataLength: d,
      sequence: E
    };
  },
  /**
   * Returns the response message that has been reduced from the HID USB frames
   *
   * @param acc The accumulator
   * @returns A Buffer containing the cleaned response message, or null if no response message, or undefined if the
   *   accumulator is incorrect (message length is not valid)
   */
  getReducedResult(c) {
    if (c && c.dataLength === c.data.length)
      return c.data;
  }
});
var re$1 = { exports: {} }, constants, hasRequiredConstants;
function requireConstants() {
  if (hasRequiredConstants) return constants;
  hasRequiredConstants = 1;
  const o = "2.0.0", g = 256, c = Number.MAX_SAFE_INTEGER || /* istanbul ignore next */
  9007199254740991, y = 16, t = g - 6;
  return constants = {
    MAX_LENGTH: g,
    MAX_SAFE_COMPONENT_LENGTH: y,
    MAX_SAFE_BUILD_LENGTH: t,
    MAX_SAFE_INTEGER: c,
    RELEASE_TYPES: [
      "major",
      "premajor",
      "minor",
      "preminor",
      "patch",
      "prepatch",
      "prerelease"
    ],
    SEMVER_SPEC_VERSION: o,
    FLAG_INCLUDE_PRERELEASE: 1,
    FLAG_LOOSE: 2
  }, constants;
}
var debug_1, hasRequiredDebug;
function requireDebug() {
  return hasRequiredDebug || (hasRequiredDebug = 1, debug_1 = typeof process$1 == "object" && process$1.env && process$1.env.NODE_DEBUG && /\bsemver\b/i.test(process$1.env.NODE_DEBUG) ? (...g) => console.error("SEMVER", ...g) : () => {
  }), debug_1;
}
var hasRequiredRe$1;
function requireRe$1() {
  return hasRequiredRe$1 || (hasRequiredRe$1 = 1, function(o, g) {
    const {
      MAX_SAFE_COMPONENT_LENGTH: c,
      MAX_SAFE_BUILD_LENGTH: y,
      MAX_LENGTH: t
    } = requireConstants(), d = requireDebug();
    g = o.exports = {};
    const E = g.re = [], B = g.safeRe = [], D = g.src = [], x = g.safeSrc = [], v = g.t = {};
    let F = 0;
    const M = "[a-zA-Z0-9-]", U = [
      ["\\s", 1],
      ["\\d", t],
      [M, y]
    ], L = (fe) => {
      for (const [ge, Ie] of U)
        fe = fe.split(`${ge}*`).join(`${ge}{0,${Ie}}`).split(`${ge}+`).join(`${ge}{1,${Ie}}`);
      return fe;
    }, H = (fe, ge, Ie) => {
      const Ee = L(ge), Se = F++;
      d(fe, Se, ge), v[fe] = Se, D[Se] = ge, x[Se] = Ee, E[Se] = new RegExp(ge, Ie ? "g" : void 0), B[Se] = new RegExp(Ee, Ie ? "g" : void 0);
    };
    H("NUMERICIDENTIFIER", "0|[1-9]\\d*"), H("NUMERICIDENTIFIERLOOSE", "\\d+"), H("NONNUMERICIDENTIFIER", `\\d*[a-zA-Z-]${M}*`), H("MAINVERSION", `(${D[v.NUMERICIDENTIFIER]})\\.(${D[v.NUMERICIDENTIFIER]})\\.(${D[v.NUMERICIDENTIFIER]})`), H("MAINVERSIONLOOSE", `(${D[v.NUMERICIDENTIFIERLOOSE]})\\.(${D[v.NUMERICIDENTIFIERLOOSE]})\\.(${D[v.NUMERICIDENTIFIERLOOSE]})`), H("PRERELEASEIDENTIFIER", `(?:${D[v.NONNUMERICIDENTIFIER]}|${D[v.NUMERICIDENTIFIER]})`), H("PRERELEASEIDENTIFIERLOOSE", `(?:${D[v.NONNUMERICIDENTIFIER]}|${D[v.NUMERICIDENTIFIERLOOSE]})`), H("PRERELEASE", `(?:-(${D[v.PRERELEASEIDENTIFIER]}(?:\\.${D[v.PRERELEASEIDENTIFIER]})*))`), H("PRERELEASELOOSE", `(?:-?(${D[v.PRERELEASEIDENTIFIERLOOSE]}(?:\\.${D[v.PRERELEASEIDENTIFIERLOOSE]})*))`), H("BUILDIDENTIFIER", `${M}+`), H("BUILD", `(?:\\+(${D[v.BUILDIDENTIFIER]}(?:\\.${D[v.BUILDIDENTIFIER]})*))`), H("FULLPLAIN", `v?${D[v.MAINVERSION]}${D[v.PRERELEASE]}?${D[v.BUILD]}?`), H("FULL", `^${D[v.FULLPLAIN]}$`), H("LOOSEPLAIN", `[v=\\s]*${D[v.MAINVERSIONLOOSE]}${D[v.PRERELEASELOOSE]}?${D[v.BUILD]}?`), H("LOOSE", `^${D[v.LOOSEPLAIN]}$`), H("GTLT", "((?:<|>)?=?)"), H("XRANGEIDENTIFIERLOOSE", `${D[v.NUMERICIDENTIFIERLOOSE]}|x|X|\\*`), H("XRANGEIDENTIFIER", `${D[v.NUMERICIDENTIFIER]}|x|X|\\*`), H("XRANGEPLAIN", `[v=\\s]*(${D[v.XRANGEIDENTIFIER]})(?:\\.(${D[v.XRANGEIDENTIFIER]})(?:\\.(${D[v.XRANGEIDENTIFIER]})(?:${D[v.PRERELEASE]})?${D[v.BUILD]}?)?)?`), H("XRANGEPLAINLOOSE", `[v=\\s]*(${D[v.XRANGEIDENTIFIERLOOSE]})(?:\\.(${D[v.XRANGEIDENTIFIERLOOSE]})(?:\\.(${D[v.XRANGEIDENTIFIERLOOSE]})(?:${D[v.PRERELEASELOOSE]})?${D[v.BUILD]}?)?)?`), H("XRANGE", `^${D[v.GTLT]}\\s*${D[v.XRANGEPLAIN]}$`), H("XRANGELOOSE", `^${D[v.GTLT]}\\s*${D[v.XRANGEPLAINLOOSE]}$`), H("COERCEPLAIN", `(^|[^\\d])(\\d{1,${c}})(?:\\.(\\d{1,${c}}))?(?:\\.(\\d{1,${c}}))?`), H("COERCE", `${D[v.COERCEPLAIN]}(?:$|[^\\d])`), H("COERCEFULL", D[v.COERCEPLAIN] + `(?:${D[v.PRERELEASE]})?(?:${D[v.BUILD]})?(?:$|[^\\d])`), H("COERCERTL", D[v.COERCE], !0), H("COERCERTLFULL", D[v.COERCEFULL], !0), H("LONETILDE", "(?:~>?)"), H("TILDETRIM", `(\\s*)${D[v.LONETILDE]}\\s+`, !0), g.tildeTrimReplace = "$1~", H("TILDE", `^${D[v.LONETILDE]}${D[v.XRANGEPLAIN]}$`), H("TILDELOOSE", `^${D[v.LONETILDE]}${D[v.XRANGEPLAINLOOSE]}$`), H("LONECARET", "(?:\\^)"), H("CARETTRIM", `(\\s*)${D[v.LONECARET]}\\s+`, !0), g.caretTrimReplace = "$1^", H("CARET", `^${D[v.LONECARET]}${D[v.XRANGEPLAIN]}$`), H("CARETLOOSE", `^${D[v.LONECARET]}${D[v.XRANGEPLAINLOOSE]}$`), H("COMPARATORLOOSE", `^${D[v.GTLT]}\\s*(${D[v.LOOSEPLAIN]})$|^$`), H("COMPARATOR", `^${D[v.GTLT]}\\s*(${D[v.FULLPLAIN]})$|^$`), H("COMPARATORTRIM", `(\\s*)${D[v.GTLT]}\\s*(${D[v.LOOSEPLAIN]}|${D[v.XRANGEPLAIN]})`, !0), g.comparatorTrimReplace = "$1$2$3", H("HYPHENRANGE", `^\\s*(${D[v.XRANGEPLAIN]})\\s+-\\s+(${D[v.XRANGEPLAIN]})\\s*$`), H("HYPHENRANGELOOSE", `^\\s*(${D[v.XRANGEPLAINLOOSE]})\\s+-\\s+(${D[v.XRANGEPLAINLOOSE]})\\s*$`), H("STAR", "(<|>)?=?\\s*\\*"), H("GTE0", "^\\s*>=\\s*0\\.0\\.0\\s*$"), H("GTE0PRE", "^\\s*>=\\s*0\\.0\\.0-0\\s*$");
  }(re$1, re$1.exports)), re$1.exports;
}
var parseOptions_1, hasRequiredParseOptions;
function requireParseOptions() {
  if (hasRequiredParseOptions) return parseOptions_1;
  hasRequiredParseOptions = 1;
  const o = Object.freeze({ loose: !0 }), g = Object.freeze({});
  return parseOptions_1 = (y) => y ? typeof y != "object" ? o : y : g, parseOptions_1;
}
var identifiers, hasRequiredIdentifiers;
function requireIdentifiers() {
  if (hasRequiredIdentifiers) return identifiers;
  hasRequiredIdentifiers = 1;
  const o = /^[0-9]+$/, g = (y, t) => {
    const d = o.test(y), E = o.test(t);
    return d && E && (y = +y, t = +t), y === t ? 0 : d && !E ? -1 : E && !d ? 1 : y < t ? -1 : 1;
  };
  return identifiers = {
    compareIdentifiers: g,
    rcompareIdentifiers: (y, t) => g(t, y)
  }, identifiers;
}
var semver$2, hasRequiredSemver$1;
function requireSemver$1() {
  if (hasRequiredSemver$1) return semver$2;
  hasRequiredSemver$1 = 1;
  const o = requireDebug(), { MAX_LENGTH: g, MAX_SAFE_INTEGER: c } = requireConstants(), { safeRe: y, t } = requireRe$1(), d = requireParseOptions(), { compareIdentifiers: E } = requireIdentifiers();
  class B {
    constructor(x, v) {
      if (v = d(v), x instanceof B) {
        if (x.loose === !!v.loose && x.includePrerelease === !!v.includePrerelease)
          return x;
        x = x.version;
      } else if (typeof x != "string")
        throw new TypeError(`Invalid version. Must be a string. Got type "${typeof x}".`);
      if (x.length > g)
        throw new TypeError(
          `version is longer than ${g} characters`
        );
      o("SemVer", x, v), this.options = v, this.loose = !!v.loose, this.includePrerelease = !!v.includePrerelease;
      const F = x.trim().match(v.loose ? y[t.LOOSE] : y[t.FULL]);
      if (!F)
        throw new TypeError(`Invalid Version: ${x}`);
      if (this.raw = x, this.major = +F[1], this.minor = +F[2], this.patch = +F[3], this.major > c || this.major < 0)
        throw new TypeError("Invalid major version");
      if (this.minor > c || this.minor < 0)
        throw new TypeError("Invalid minor version");
      if (this.patch > c || this.patch < 0)
        throw new TypeError("Invalid patch version");
      F[4] ? this.prerelease = F[4].split(".").map((M) => {
        if (/^[0-9]+$/.test(M)) {
          const U = +M;
          if (U >= 0 && U < c)
            return U;
        }
        return M;
      }) : this.prerelease = [], this.build = F[5] ? F[5].split(".") : [], this.format();
    }
    format() {
      return this.version = `${this.major}.${this.minor}.${this.patch}`, this.prerelease.length && (this.version += `-${this.prerelease.join(".")}`), this.version;
    }
    toString() {
      return this.version;
    }
    compare(x) {
      if (o("SemVer.compare", this.version, this.options, x), !(x instanceof B)) {
        if (typeof x == "string" && x === this.version)
          return 0;
        x = new B(x, this.options);
      }
      return x.version === this.version ? 0 : this.compareMain(x) || this.comparePre(x);
    }
    compareMain(x) {
      return x instanceof B || (x = new B(x, this.options)), E(this.major, x.major) || E(this.minor, x.minor) || E(this.patch, x.patch);
    }
    comparePre(x) {
      if (x instanceof B || (x = new B(x, this.options)), this.prerelease.length && !x.prerelease.length)
        return -1;
      if (!this.prerelease.length && x.prerelease.length)
        return 1;
      if (!this.prerelease.length && !x.prerelease.length)
        return 0;
      let v = 0;
      do {
        const F = this.prerelease[v], M = x.prerelease[v];
        if (o("prerelease compare", v, F, M), F === void 0 && M === void 0)
          return 0;
        if (M === void 0)
          return 1;
        if (F === void 0)
          return -1;
        if (F === M)
          continue;
        return E(F, M);
      } while (++v);
    }
    compareBuild(x) {
      x instanceof B || (x = new B(x, this.options));
      let v = 0;
      do {
        const F = this.build[v], M = x.build[v];
        if (o("build compare", v, F, M), F === void 0 && M === void 0)
          return 0;
        if (M === void 0)
          return 1;
        if (F === void 0)
          return -1;
        if (F === M)
          continue;
        return E(F, M);
      } while (++v);
    }
    // preminor will bump the version up to the next minor release, and immediately
    // down to pre-release. premajor and prepatch work the same way.
    inc(x, v, F) {
      if (x.startsWith("pre")) {
        if (!v && F === !1)
          throw new Error("invalid increment argument: identifier is empty");
        if (v) {
          const M = `-${v}`.match(this.options.loose ? y[t.PRERELEASELOOSE] : y[t.PRERELEASE]);
          if (!M || M[1] !== v)
            throw new Error(`invalid identifier: ${v}`);
        }
      }
      switch (x) {
        case "premajor":
          this.prerelease.length = 0, this.patch = 0, this.minor = 0, this.major++, this.inc("pre", v, F);
          break;
        case "preminor":
          this.prerelease.length = 0, this.patch = 0, this.minor++, this.inc("pre", v, F);
          break;
        case "prepatch":
          this.prerelease.length = 0, this.inc("patch", v, F), this.inc("pre", v, F);
          break;
        // If the input is a non-prerelease version, this acts the same as
        // prepatch.
        case "prerelease":
          this.prerelease.length === 0 && this.inc("patch", v, F), this.inc("pre", v, F);
          break;
        case "release":
          if (this.prerelease.length === 0)
            throw new Error(`version ${this.raw} is not a prerelease`);
          this.prerelease.length = 0;
          break;
        case "major":
          (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0) && this.major++, this.minor = 0, this.patch = 0, this.prerelease = [];
          break;
        case "minor":
          (this.patch !== 0 || this.prerelease.length === 0) && this.minor++, this.patch = 0, this.prerelease = [];
          break;
        case "patch":
          this.prerelease.length === 0 && this.patch++, this.prerelease = [];
          break;
        // This probably shouldn't be used publicly.
        // 1.0.0 'pre' would become 1.0.0-0 which is the wrong direction.
        case "pre": {
          const M = Number(F) ? 1 : 0;
          if (this.prerelease.length === 0)
            this.prerelease = [M];
          else {
            let U = this.prerelease.length;
            for (; --U >= 0; )
              typeof this.prerelease[U] == "number" && (this.prerelease[U]++, U = -2);
            if (U === -1) {
              if (v === this.prerelease.join(".") && F === !1)
                throw new Error("invalid increment argument: identifier already exists");
              this.prerelease.push(M);
            }
          }
          if (v) {
            let U = [v, M];
            F === !1 && (U = [v]), E(this.prerelease[0], v) === 0 ? isNaN(this.prerelease[1]) && (this.prerelease = U) : this.prerelease = U;
          }
          break;
        }
        default:
          throw new Error(`invalid increment argument: ${x}`);
      }
      return this.raw = this.format(), this.build.length && (this.raw += `+${this.build.join(".")}`), this;
    }
  }
  return semver$2 = B, semver$2;
}
var parse_1, hasRequiredParse;
function requireParse() {
  if (hasRequiredParse) return parse_1;
  hasRequiredParse = 1;
  const o = requireSemver$1();
  return parse_1 = (c, y, t = !1) => {
    if (c instanceof o)
      return c;
    try {
      return new o(c, y);
    } catch (d) {
      if (!t)
        return null;
      throw d;
    }
  }, parse_1;
}
var valid_1, hasRequiredValid$1;
function requireValid$1() {
  if (hasRequiredValid$1) return valid_1;
  hasRequiredValid$1 = 1;
  const o = requireParse();
  return valid_1 = (c, y) => {
    const t = o(c, y);
    return t ? t.version : null;
  }, valid_1;
}
var clean_1, hasRequiredClean;
function requireClean() {
  if (hasRequiredClean) return clean_1;
  hasRequiredClean = 1;
  const o = requireParse();
  return clean_1 = (c, y) => {
    const t = o(c.trim().replace(/^[=v]+/, ""), y);
    return t ? t.version : null;
  }, clean_1;
}
var inc_1, hasRequiredInc;
function requireInc() {
  if (hasRequiredInc) return inc_1;
  hasRequiredInc = 1;
  const o = requireSemver$1();
  return inc_1 = (c, y, t, d, E) => {
    typeof t == "string" && (E = d, d = t, t = void 0);
    try {
      return new o(
        c instanceof o ? c.version : c,
        t
      ).inc(y, d, E).version;
    } catch {
      return null;
    }
  }, inc_1;
}
var diff_1, hasRequiredDiff;
function requireDiff() {
  if (hasRequiredDiff) return diff_1;
  hasRequiredDiff = 1;
  const o = requireParse();
  return diff_1 = (c, y) => {
    const t = o(c, null, !0), d = o(y, null, !0), E = t.compare(d);
    if (E === 0)
      return null;
    const B = E > 0, D = B ? t : d, x = B ? d : t, v = !!D.prerelease.length;
    if (!!x.prerelease.length && !v) {
      if (!x.patch && !x.minor)
        return "major";
      if (x.compareMain(D) === 0)
        return x.minor && !x.patch ? "minor" : "patch";
    }
    const M = v ? "pre" : "";
    return t.major !== d.major ? M + "major" : t.minor !== d.minor ? M + "minor" : t.patch !== d.patch ? M + "patch" : "prerelease";
  }, diff_1;
}
var major_1, hasRequiredMajor;
function requireMajor() {
  if (hasRequiredMajor) return major_1;
  hasRequiredMajor = 1;
  const o = requireSemver$1();
  return major_1 = (c, y) => new o(c, y).major, major_1;
}
var minor_1, hasRequiredMinor;
function requireMinor() {
  if (hasRequiredMinor) return minor_1;
  hasRequiredMinor = 1;
  const o = requireSemver$1();
  return minor_1 = (c, y) => new o(c, y).minor, minor_1;
}
var patch_1, hasRequiredPatch;
function requirePatch() {
  if (hasRequiredPatch) return patch_1;
  hasRequiredPatch = 1;
  const o = requireSemver$1();
  return patch_1 = (c, y) => new o(c, y).patch, patch_1;
}
var prerelease_1, hasRequiredPrerelease;
function requirePrerelease() {
  if (hasRequiredPrerelease) return prerelease_1;
  hasRequiredPrerelease = 1;
  const o = requireParse();
  return prerelease_1 = (c, y) => {
    const t = o(c, y);
    return t && t.prerelease.length ? t.prerelease : null;
  }, prerelease_1;
}
var compare_1, hasRequiredCompare;
function requireCompare() {
  if (hasRequiredCompare) return compare_1;
  hasRequiredCompare = 1;
  const o = requireSemver$1();
  return compare_1 = (c, y, t) => new o(c, t).compare(new o(y, t)), compare_1;
}
var rcompare_1, hasRequiredRcompare;
function requireRcompare() {
  if (hasRequiredRcompare) return rcompare_1;
  hasRequiredRcompare = 1;
  const o = requireCompare();
  return rcompare_1 = (c, y, t) => o(y, c, t), rcompare_1;
}
var compareLoose_1, hasRequiredCompareLoose;
function requireCompareLoose() {
  if (hasRequiredCompareLoose) return compareLoose_1;
  hasRequiredCompareLoose = 1;
  const o = requireCompare();
  return compareLoose_1 = (c, y) => o(c, y, !0), compareLoose_1;
}
var compareBuild_1, hasRequiredCompareBuild;
function requireCompareBuild() {
  if (hasRequiredCompareBuild) return compareBuild_1;
  hasRequiredCompareBuild = 1;
  const o = requireSemver$1();
  return compareBuild_1 = (c, y, t) => {
    const d = new o(c, t), E = new o(y, t);
    return d.compare(E) || d.compareBuild(E);
  }, compareBuild_1;
}
var sort_1, hasRequiredSort;
function requireSort() {
  if (hasRequiredSort) return sort_1;
  hasRequiredSort = 1;
  const o = requireCompareBuild();
  return sort_1 = (c, y) => c.sort((t, d) => o(t, d, y)), sort_1;
}
var rsort_1, hasRequiredRsort;
function requireRsort() {
  if (hasRequiredRsort) return rsort_1;
  hasRequiredRsort = 1;
  const o = requireCompareBuild();
  return rsort_1 = (c, y) => c.sort((t, d) => o(d, t, y)), rsort_1;
}
var gt_1, hasRequiredGt;
function requireGt() {
  if (hasRequiredGt) return gt_1;
  hasRequiredGt = 1;
  const o = requireCompare();
  return gt_1 = (c, y, t) => o(c, y, t) > 0, gt_1;
}
var lt_1, hasRequiredLt;
function requireLt() {
  if (hasRequiredLt) return lt_1;
  hasRequiredLt = 1;
  const o = requireCompare();
  return lt_1 = (c, y, t) => o(c, y, t) < 0, lt_1;
}
var eq_1, hasRequiredEq;
function requireEq() {
  if (hasRequiredEq) return eq_1;
  hasRequiredEq = 1;
  const o = requireCompare();
  return eq_1 = (c, y, t) => o(c, y, t) === 0, eq_1;
}
var neq_1, hasRequiredNeq;
function requireNeq() {
  if (hasRequiredNeq) return neq_1;
  hasRequiredNeq = 1;
  const o = requireCompare();
  return neq_1 = (c, y, t) => o(c, y, t) !== 0, neq_1;
}
var gte_1, hasRequiredGte;
function requireGte() {
  if (hasRequiredGte) return gte_1;
  hasRequiredGte = 1;
  const o = requireCompare();
  return gte_1 = (c, y, t) => o(c, y, t) >= 0, gte_1;
}
var lte_1, hasRequiredLte;
function requireLte() {
  if (hasRequiredLte) return lte_1;
  hasRequiredLte = 1;
  const o = requireCompare();
  return lte_1 = (c, y, t) => o(c, y, t) <= 0, lte_1;
}
var cmp_1, hasRequiredCmp;
function requireCmp() {
  if (hasRequiredCmp) return cmp_1;
  hasRequiredCmp = 1;
  const o = requireEq(), g = requireNeq(), c = requireGt(), y = requireGte(), t = requireLt(), d = requireLte();
  return cmp_1 = (B, D, x, v) => {
    switch (D) {
      case "===":
        return typeof B == "object" && (B = B.version), typeof x == "object" && (x = x.version), B === x;
      case "!==":
        return typeof B == "object" && (B = B.version), typeof x == "object" && (x = x.version), B !== x;
      case "":
      case "=":
      case "==":
        return o(B, x, v);
      case "!=":
        return g(B, x, v);
      case ">":
        return c(B, x, v);
      case ">=":
        return y(B, x, v);
      case "<":
        return t(B, x, v);
      case "<=":
        return d(B, x, v);
      default:
        throw new TypeError(`Invalid operator: ${D}`);
    }
  }, cmp_1;
}
var coerce_1, hasRequiredCoerce;
function requireCoerce() {
  if (hasRequiredCoerce) return coerce_1;
  hasRequiredCoerce = 1;
  const o = requireSemver$1(), g = requireParse(), { safeRe: c, t: y } = requireRe$1();
  return coerce_1 = (d, E) => {
    if (d instanceof o)
      return d;
    if (typeof d == "number" && (d = String(d)), typeof d != "string")
      return null;
    E = E || {};
    let B = null;
    if (!E.rtl)
      B = d.match(E.includePrerelease ? c[y.COERCEFULL] : c[y.COERCE]);
    else {
      const U = E.includePrerelease ? c[y.COERCERTLFULL] : c[y.COERCERTL];
      let L;
      for (; (L = U.exec(d)) && (!B || B.index + B[0].length !== d.length); )
        (!B || L.index + L[0].length !== B.index + B[0].length) && (B = L), U.lastIndex = L.index + L[1].length + L[2].length;
      U.lastIndex = -1;
    }
    if (B === null)
      return null;
    const D = B[2], x = B[3] || "0", v = B[4] || "0", F = E.includePrerelease && B[5] ? `-${B[5]}` : "", M = E.includePrerelease && B[6] ? `+${B[6]}` : "";
    return g(`${D}.${x}.${v}${F}${M}`, E);
  }, coerce_1;
}
var lrucache, hasRequiredLrucache;
function requireLrucache() {
  if (hasRequiredLrucache) return lrucache;
  hasRequiredLrucache = 1;
  class o {
    constructor() {
      this.max = 1e3, this.map = /* @__PURE__ */ new Map();
    }
    get(c) {
      const y = this.map.get(c);
      if (y !== void 0)
        return this.map.delete(c), this.map.set(c, y), y;
    }
    delete(c) {
      return this.map.delete(c);
    }
    set(c, y) {
      if (!this.delete(c) && y !== void 0) {
        if (this.map.size >= this.max) {
          const d = this.map.keys().next().value;
          this.delete(d);
        }
        this.map.set(c, y);
      }
      return this;
    }
  }
  return lrucache = o, lrucache;
}
var range, hasRequiredRange;
function requireRange() {
  if (hasRequiredRange) return range;
  hasRequiredRange = 1;
  const o = /\s+/g;
  class g {
    constructor(Ne, Et) {
      if (Et = t(Et), Ne instanceof g)
        return Ne.loose === !!Et.loose && Ne.includePrerelease === !!Et.includePrerelease ? Ne : new g(Ne.raw, Et);
      if (Ne instanceof d)
        return this.raw = Ne.value, this.set = [[Ne]], this.formatted = void 0, this;
      if (this.options = Et, this.loose = !!Et.loose, this.includePrerelease = !!Et.includePrerelease, this.raw = Ne.trim().replace(o, " "), this.set = this.raw.split("||").map((st) => this.parseRange(st.trim())).filter((st) => st.length), !this.set.length)
        throw new TypeError(`Invalid SemVer Range: ${this.raw}`);
      if (this.set.length > 1) {
        const st = this.set[0];
        if (this.set = this.set.filter((Dt) => !H(Dt[0])), this.set.length === 0)
          this.set = [st];
        else if (this.set.length > 1) {
          for (const Dt of this.set)
            if (Dt.length === 1 && fe(Dt[0])) {
              this.set = [Dt];
              break;
            }
        }
      }
      this.formatted = void 0;
    }
    get range() {
      if (this.formatted === void 0) {
        this.formatted = "";
        for (let Ne = 0; Ne < this.set.length; Ne++) {
          Ne > 0 && (this.formatted += "||");
          const Et = this.set[Ne];
          for (let st = 0; st < Et.length; st++)
            st > 0 && (this.formatted += " "), this.formatted += Et[st].toString().trim();
        }
      }
      return this.formatted;
    }
    format() {
      return this.range;
    }
    toString() {
      return this.range;
    }
    parseRange(Ne) {
      const st = ((this.options.includePrerelease && U) | (this.options.loose && L)) + ":" + Ne, Dt = y.get(st);
      if (Dt)
        return Dt;
      const er = this.options.loose, xt = er ? D[x.HYPHENRANGELOOSE] : D[x.HYPHENRANGE];
      Ne = Ne.replace(xt, Be(this.options.includePrerelease)), E("hyphen replace", Ne), Ne = Ne.replace(D[x.COMPARATORTRIM], v), E("comparator trim", Ne), Ne = Ne.replace(D[x.TILDETRIM], F), E("tilde trim", Ne), Ne = Ne.replace(D[x.CARETTRIM], M), E("caret trim", Ne);
      let ir = Ne.split(" ").map((qr) => Ie(qr, this.options)).join(" ").split(/\s+/).map((qr) => be(qr, this.options));
      er && (ir = ir.filter((qr) => (E("loose invalid filter", qr, this.options), !!qr.match(D[x.COMPARATORLOOSE])))), E("range list", ir);
      const sr = /* @__PURE__ */ new Map(), yr = ir.map((qr) => new d(qr, this.options));
      for (const qr of yr) {
        if (H(qr))
          return [qr];
        sr.set(qr.value, qr);
      }
      sr.size > 1 && sr.has("") && sr.delete("");
      const wr = [...sr.values()];
      return y.set(st, wr), wr;
    }
    intersects(Ne, Et) {
      if (!(Ne instanceof g))
        throw new TypeError("a Range is required");
      return this.set.some((st) => ge(st, Et) && Ne.set.some((Dt) => ge(Dt, Et) && st.every((er) => Dt.every((xt) => er.intersects(xt, Et)))));
    }
    // if ANY of the sets match ALL of its comparators, then pass
    test(Ne) {
      if (!Ne)
        return !1;
      if (typeof Ne == "string")
        try {
          Ne = new B(Ne, this.options);
        } catch {
          return !1;
        }
      for (let Et = 0; Et < this.set.length; Et++)
        if (ke(this.set[Et], Ne, this.options))
          return !0;
      return !1;
    }
  }
  range = g;
  const c = requireLrucache(), y = new c(), t = requireParseOptions(), d = requireComparator(), E = requireDebug(), B = requireSemver$1(), {
    safeRe: D,
    t: x,
    comparatorTrimReplace: v,
    tildeTrimReplace: F,
    caretTrimReplace: M
  } = requireRe$1(), { FLAG_INCLUDE_PRERELEASE: U, FLAG_LOOSE: L } = requireConstants(), H = (xe) => xe.value === "<0.0.0-0", fe = (xe) => xe.value === "", ge = (xe, Ne) => {
    let Et = !0;
    const st = xe.slice();
    let Dt = st.pop();
    for (; Et && st.length; )
      Et = st.every((er) => Dt.intersects(er, Ne)), Dt = st.pop();
    return Et;
  }, Ie = (xe, Ne) => (E("comp", xe, Ne), xe = He(xe, Ne), E("caret", xe), xe = Se(xe, Ne), E("tildes", xe), xe = De(xe, Ne), E("xrange", xe), xe = Fe(xe, Ne), E("stars", xe), xe), Ee = (xe) => !xe || xe.toLowerCase() === "x" || xe === "*", Se = (xe, Ne) => xe.trim().split(/\s+/).map((Et) => ze(Et, Ne)).join(" "), ze = (xe, Ne) => {
    const Et = Ne.loose ? D[x.TILDELOOSE] : D[x.TILDE];
    return xe.replace(Et, (st, Dt, er, xt, ir) => {
      E("tilde", xe, st, Dt, er, xt, ir);
      let sr;
      return Ee(Dt) ? sr = "" : Ee(er) ? sr = `>=${Dt}.0.0 <${+Dt + 1}.0.0-0` : Ee(xt) ? sr = `>=${Dt}.${er}.0 <${Dt}.${+er + 1}.0-0` : ir ? (E("replaceTilde pr", ir), sr = `>=${Dt}.${er}.${xt}-${ir} <${Dt}.${+er + 1}.0-0`) : sr = `>=${Dt}.${er}.${xt} <${Dt}.${+er + 1}.0-0`, E("tilde return", sr), sr;
    });
  }, He = (xe, Ne) => xe.trim().split(/\s+/).map((Et) => Pe(Et, Ne)).join(" "), Pe = (xe, Ne) => {
    E("caret", xe, Ne);
    const Et = Ne.loose ? D[x.CARETLOOSE] : D[x.CARET], st = Ne.includePrerelease ? "-0" : "";
    return xe.replace(Et, (Dt, er, xt, ir, sr) => {
      E("caret", xe, Dt, er, xt, ir, sr);
      let yr;
      return Ee(er) ? yr = "" : Ee(xt) ? yr = `>=${er}.0.0${st} <${+er + 1}.0.0-0` : Ee(ir) ? er === "0" ? yr = `>=${er}.${xt}.0${st} <${er}.${+xt + 1}.0-0` : yr = `>=${er}.${xt}.0${st} <${+er + 1}.0.0-0` : sr ? (E("replaceCaret pr", sr), er === "0" ? xt === "0" ? yr = `>=${er}.${xt}.${ir}-${sr} <${er}.${xt}.${+ir + 1}-0` : yr = `>=${er}.${xt}.${ir}-${sr} <${er}.${+xt + 1}.0-0` : yr = `>=${er}.${xt}.${ir}-${sr} <${+er + 1}.0.0-0`) : (E("no pr"), er === "0" ? xt === "0" ? yr = `>=${er}.${xt}.${ir}${st} <${er}.${xt}.${+ir + 1}-0` : yr = `>=${er}.${xt}.${ir}${st} <${er}.${+xt + 1}.0-0` : yr = `>=${er}.${xt}.${ir} <${+er + 1}.0.0-0`), E("caret return", yr), yr;
    });
  }, De = (xe, Ne) => (E("replaceXRanges", xe, Ne), xe.split(/\s+/).map((Et) => ve(Et, Ne)).join(" ")), ve = (xe, Ne) => {
    xe = xe.trim();
    const Et = Ne.loose ? D[x.XRANGELOOSE] : D[x.XRANGE];
    return xe.replace(Et, (st, Dt, er, xt, ir, sr) => {
      E("xRange", xe, st, Dt, er, xt, ir, sr);
      const yr = Ee(er), wr = yr || Ee(xt), qr = wr || Ee(ir), Mr = qr;
      return Dt === "=" && Mr && (Dt = ""), sr = Ne.includePrerelease ? "-0" : "", yr ? Dt === ">" || Dt === "<" ? st = "<0.0.0-0" : st = "*" : Dt && Mr ? (wr && (xt = 0), ir = 0, Dt === ">" ? (Dt = ">=", wr ? (er = +er + 1, xt = 0, ir = 0) : (xt = +xt + 1, ir = 0)) : Dt === "<=" && (Dt = "<", wr ? er = +er + 1 : xt = +xt + 1), Dt === "<" && (sr = "-0"), st = `${Dt + er}.${xt}.${ir}${sr}`) : wr ? st = `>=${er}.0.0${sr} <${+er + 1}.0.0-0` : qr && (st = `>=${er}.${xt}.0${sr} <${er}.${+xt + 1}.0-0`), E("xRange return", st), st;
    });
  }, Fe = (xe, Ne) => (E("replaceStars", xe, Ne), xe.trim().replace(D[x.STAR], "")), be = (xe, Ne) => (E("replaceGTE0", xe, Ne), xe.trim().replace(D[Ne.includePrerelease ? x.GTE0PRE : x.GTE0], "")), Be = (xe) => (Ne, Et, st, Dt, er, xt, ir, sr, yr, wr, qr, Mr) => (Ee(st) ? Et = "" : Ee(Dt) ? Et = `>=${st}.0.0${xe ? "-0" : ""}` : Ee(er) ? Et = `>=${st}.${Dt}.0${xe ? "-0" : ""}` : xt ? Et = `>=${Et}` : Et = `>=${Et}${xe ? "-0" : ""}`, Ee(yr) ? sr = "" : Ee(wr) ? sr = `<${+yr + 1}.0.0-0` : Ee(qr) ? sr = `<${yr}.${+wr + 1}.0-0` : Mr ? sr = `<=${yr}.${wr}.${qr}-${Mr}` : xe ? sr = `<${yr}.${wr}.${+qr + 1}-0` : sr = `<=${sr}`, `${Et} ${sr}`.trim()), ke = (xe, Ne, Et) => {
    for (let st = 0; st < xe.length; st++)
      if (!xe[st].test(Ne))
        return !1;
    if (Ne.prerelease.length && !Et.includePrerelease) {
      for (let st = 0; st < xe.length; st++)
        if (E(xe[st].semver), xe[st].semver !== d.ANY && xe[st].semver.prerelease.length > 0) {
          const Dt = xe[st].semver;
          if (Dt.major === Ne.major && Dt.minor === Ne.minor && Dt.patch === Ne.patch)
            return !0;
        }
      return !1;
    }
    return !0;
  };
  return range;
}
var comparator, hasRequiredComparator;
function requireComparator() {
  if (hasRequiredComparator) return comparator;
  hasRequiredComparator = 1;
  const o = Symbol("SemVer ANY");
  class g {
    static get ANY() {
      return o;
    }
    constructor(v, F) {
      if (F = c(F), v instanceof g) {
        if (v.loose === !!F.loose)
          return v;
        v = v.value;
      }
      v = v.trim().split(/\s+/).join(" "), E("comparator", v, F), this.options = F, this.loose = !!F.loose, this.parse(v), this.semver === o ? this.value = "" : this.value = this.operator + this.semver.version, E("comp", this);
    }
    parse(v) {
      const F = this.options.loose ? y[t.COMPARATORLOOSE] : y[t.COMPARATOR], M = v.match(F);
      if (!M)
        throw new TypeError(`Invalid comparator: ${v}`);
      this.operator = M[1] !== void 0 ? M[1] : "", this.operator === "=" && (this.operator = ""), M[2] ? this.semver = new B(M[2], this.options.loose) : this.semver = o;
    }
    toString() {
      return this.value;
    }
    test(v) {
      if (E("Comparator.test", v, this.options.loose), this.semver === o || v === o)
        return !0;
      if (typeof v == "string")
        try {
          v = new B(v, this.options);
        } catch {
          return !1;
        }
      return d(v, this.operator, this.semver, this.options);
    }
    intersects(v, F) {
      if (!(v instanceof g))
        throw new TypeError("a Comparator is required");
      return this.operator === "" ? this.value === "" ? !0 : new D(v.value, F).test(this.value) : v.operator === "" ? v.value === "" ? !0 : new D(this.value, F).test(v.semver) : (F = c(F), F.includePrerelease && (this.value === "<0.0.0-0" || v.value === "<0.0.0-0") || !F.includePrerelease && (this.value.startsWith("<0.0.0") || v.value.startsWith("<0.0.0")) ? !1 : !!(this.operator.startsWith(">") && v.operator.startsWith(">") || this.operator.startsWith("<") && v.operator.startsWith("<") || this.semver.version === v.semver.version && this.operator.includes("=") && v.operator.includes("=") || d(this.semver, "<", v.semver, F) && this.operator.startsWith(">") && v.operator.startsWith("<") || d(this.semver, ">", v.semver, F) && this.operator.startsWith("<") && v.operator.startsWith(">")));
    }
  }
  comparator = g;
  const c = requireParseOptions(), { safeRe: y, t } = requireRe$1(), d = requireCmp(), E = requireDebug(), B = requireSemver$1(), D = requireRange();
  return comparator;
}
var satisfies_1, hasRequiredSatisfies;
function requireSatisfies() {
  if (hasRequiredSatisfies) return satisfies_1;
  hasRequiredSatisfies = 1;
  const o = requireRange();
  return satisfies_1 = (c, y, t) => {
    try {
      y = new o(y, t);
    } catch {
      return !1;
    }
    return y.test(c);
  }, satisfies_1;
}
var toComparators_1, hasRequiredToComparators;
function requireToComparators() {
  if (hasRequiredToComparators) return toComparators_1;
  hasRequiredToComparators = 1;
  const o = requireRange();
  return toComparators_1 = (c, y) => new o(c, y).set.map((t) => t.map((d) => d.value).join(" ").trim().split(" ")), toComparators_1;
}
var maxSatisfying_1, hasRequiredMaxSatisfying;
function requireMaxSatisfying() {
  if (hasRequiredMaxSatisfying) return maxSatisfying_1;
  hasRequiredMaxSatisfying = 1;
  const o = requireSemver$1(), g = requireRange();
  return maxSatisfying_1 = (y, t, d) => {
    let E = null, B = null, D = null;
    try {
      D = new g(t, d);
    } catch {
      return null;
    }
    return y.forEach((x) => {
      D.test(x) && (!E || B.compare(x) === -1) && (E = x, B = new o(E, d));
    }), E;
  }, maxSatisfying_1;
}
var minSatisfying_1, hasRequiredMinSatisfying;
function requireMinSatisfying() {
  if (hasRequiredMinSatisfying) return minSatisfying_1;
  hasRequiredMinSatisfying = 1;
  const o = requireSemver$1(), g = requireRange();
  return minSatisfying_1 = (y, t, d) => {
    let E = null, B = null, D = null;
    try {
      D = new g(t, d);
    } catch {
      return null;
    }
    return y.forEach((x) => {
      D.test(x) && (!E || B.compare(x) === 1) && (E = x, B = new o(E, d));
    }), E;
  }, minSatisfying_1;
}
var minVersion_1, hasRequiredMinVersion;
function requireMinVersion() {
  if (hasRequiredMinVersion) return minVersion_1;
  hasRequiredMinVersion = 1;
  const o = requireSemver$1(), g = requireRange(), c = requireGt();
  return minVersion_1 = (t, d) => {
    t = new g(t, d);
    let E = new o("0.0.0");
    if (t.test(E) || (E = new o("0.0.0-0"), t.test(E)))
      return E;
    E = null;
    for (let B = 0; B < t.set.length; ++B) {
      const D = t.set[B];
      let x = null;
      D.forEach((v) => {
        const F = new o(v.semver.version);
        switch (v.operator) {
          case ">":
            F.prerelease.length === 0 ? F.patch++ : F.prerelease.push(0), F.raw = F.format();
          /* fallthrough */
          case "":
          case ">=":
            (!x || c(F, x)) && (x = F);
            break;
          case "<":
          case "<=":
            break;
          /* istanbul ignore next */
          default:
            throw new Error(`Unexpected operation: ${v.operator}`);
        }
      }), x && (!E || c(E, x)) && (E = x);
    }
    return E && t.test(E) ? E : null;
  }, minVersion_1;
}
var valid, hasRequiredValid;
function requireValid() {
  if (hasRequiredValid) return valid;
  hasRequiredValid = 1;
  const o = requireRange();
  return valid = (c, y) => {
    try {
      return new o(c, y).range || "*";
    } catch {
      return null;
    }
  }, valid;
}
var outside_1, hasRequiredOutside;
function requireOutside() {
  if (hasRequiredOutside) return outside_1;
  hasRequiredOutside = 1;
  const o = requireSemver$1(), g = requireComparator(), { ANY: c } = g, y = requireRange(), t = requireSatisfies(), d = requireGt(), E = requireLt(), B = requireLte(), D = requireGte();
  return outside_1 = (v, F, M, U) => {
    v = new o(v, U), F = new y(F, U);
    let L, H, fe, ge, Ie;
    switch (M) {
      case ">":
        L = d, H = B, fe = E, ge = ">", Ie = ">=";
        break;
      case "<":
        L = E, H = D, fe = d, ge = "<", Ie = "<=";
        break;
      default:
        throw new TypeError('Must provide a hilo val of "<" or ">"');
    }
    if (t(v, F, U))
      return !1;
    for (let Ee = 0; Ee < F.set.length; ++Ee) {
      const Se = F.set[Ee];
      let ze = null, He = null;
      if (Se.forEach((Pe) => {
        Pe.semver === c && (Pe = new g(">=0.0.0")), ze = ze || Pe, He = He || Pe, L(Pe.semver, ze.semver, U) ? ze = Pe : fe(Pe.semver, He.semver, U) && (He = Pe);
      }), ze.operator === ge || ze.operator === Ie || (!He.operator || He.operator === ge) && H(v, He.semver))
        return !1;
      if (He.operator === Ie && fe(v, He.semver))
        return !1;
    }
    return !0;
  }, outside_1;
}
var gtr_1, hasRequiredGtr;
function requireGtr() {
  if (hasRequiredGtr) return gtr_1;
  hasRequiredGtr = 1;
  const o = requireOutside();
  return gtr_1 = (c, y, t) => o(c, y, ">", t), gtr_1;
}
var ltr_1, hasRequiredLtr;
function requireLtr() {
  if (hasRequiredLtr) return ltr_1;
  hasRequiredLtr = 1;
  const o = requireOutside();
  return ltr_1 = (c, y, t) => o(c, y, "<", t), ltr_1;
}
var intersects_1, hasRequiredIntersects;
function requireIntersects() {
  if (hasRequiredIntersects) return intersects_1;
  hasRequiredIntersects = 1;
  const o = requireRange();
  return intersects_1 = (c, y, t) => (c = new o(c, t), y = new o(y, t), c.intersects(y, t)), intersects_1;
}
var simplify, hasRequiredSimplify;
function requireSimplify() {
  if (hasRequiredSimplify) return simplify;
  hasRequiredSimplify = 1;
  const o = requireSatisfies(), g = requireCompare();
  return simplify = (c, y, t) => {
    const d = [];
    let E = null, B = null;
    const D = c.sort((M, U) => g(M, U, t));
    for (const M of D)
      o(M, y, t) ? (B = M, E || (E = M)) : (B && d.push([E, B]), B = null, E = null);
    E && d.push([E, null]);
    const x = [];
    for (const [M, U] of d)
      M === U ? x.push(M) : !U && M === D[0] ? x.push("*") : U ? M === D[0] ? x.push(`<=${U}`) : x.push(`${M} - ${U}`) : x.push(`>=${M}`);
    const v = x.join(" || "), F = typeof y.raw == "string" ? y.raw : String(y);
    return v.length < F.length ? v : y;
  }, simplify;
}
var subset_1, hasRequiredSubset;
function requireSubset() {
  if (hasRequiredSubset) return subset_1;
  hasRequiredSubset = 1;
  const o = requireRange(), g = requireComparator(), { ANY: c } = g, y = requireSatisfies(), t = requireCompare(), d = (F, M, U = {}) => {
    if (F === M)
      return !0;
    F = new o(F, U), M = new o(M, U);
    let L = !1;
    e: for (const H of F.set) {
      for (const fe of M.set) {
        const ge = D(H, fe, U);
        if (L = L || ge !== null, ge)
          continue e;
      }
      if (L)
        return !1;
    }
    return !0;
  }, E = [new g(">=0.0.0-0")], B = [new g(">=0.0.0")], D = (F, M, U) => {
    if (F === M)
      return !0;
    if (F.length === 1 && F[0].semver === c) {
      if (M.length === 1 && M[0].semver === c)
        return !0;
      U.includePrerelease ? F = E : F = B;
    }
    if (M.length === 1 && M[0].semver === c) {
      if (U.includePrerelease)
        return !0;
      M = B;
    }
    const L = /* @__PURE__ */ new Set();
    let H, fe;
    for (const De of F)
      De.operator === ">" || De.operator === ">=" ? H = x(H, De, U) : De.operator === "<" || De.operator === "<=" ? fe = v(fe, De, U) : L.add(De.semver);
    if (L.size > 1)
      return null;
    let ge;
    if (H && fe) {
      if (ge = t(H.semver, fe.semver, U), ge > 0)
        return null;
      if (ge === 0 && (H.operator !== ">=" || fe.operator !== "<="))
        return null;
    }
    for (const De of L) {
      if (H && !y(De, String(H), U) || fe && !y(De, String(fe), U))
        return null;
      for (const ve of M)
        if (!y(De, String(ve), U))
          return !1;
      return !0;
    }
    let Ie, Ee, Se, ze, He = fe && !U.includePrerelease && fe.semver.prerelease.length ? fe.semver : !1, Pe = H && !U.includePrerelease && H.semver.prerelease.length ? H.semver : !1;
    He && He.prerelease.length === 1 && fe.operator === "<" && He.prerelease[0] === 0 && (He = !1);
    for (const De of M) {
      if (ze = ze || De.operator === ">" || De.operator === ">=", Se = Se || De.operator === "<" || De.operator === "<=", H) {
        if (Pe && De.semver.prerelease && De.semver.prerelease.length && De.semver.major === Pe.major && De.semver.minor === Pe.minor && De.semver.patch === Pe.patch && (Pe = !1), De.operator === ">" || De.operator === ">=") {
          if (Ie = x(H, De, U), Ie === De && Ie !== H)
            return !1;
        } else if (H.operator === ">=" && !y(H.semver, String(De), U))
          return !1;
      }
      if (fe) {
        if (He && De.semver.prerelease && De.semver.prerelease.length && De.semver.major === He.major && De.semver.minor === He.minor && De.semver.patch === He.patch && (He = !1), De.operator === "<" || De.operator === "<=") {
          if (Ee = v(fe, De, U), Ee === De && Ee !== fe)
            return !1;
        } else if (fe.operator === "<=" && !y(fe.semver, String(De), U))
          return !1;
      }
      if (!De.operator && (fe || H) && ge !== 0)
        return !1;
    }
    return !(H && Se && !fe && ge !== 0 || fe && ze && !H && ge !== 0 || Pe || He);
  }, x = (F, M, U) => {
    if (!F)
      return M;
    const L = t(F.semver, M.semver, U);
    return L > 0 ? F : L < 0 || M.operator === ">" && F.operator === ">=" ? M : F;
  }, v = (F, M, U) => {
    if (!F)
      return M;
    const L = t(F.semver, M.semver, U);
    return L < 0 ? F : L > 0 || M.operator === "<" && F.operator === "<=" ? M : F;
  };
  return subset_1 = d, subset_1;
}
var semver$1, hasRequiredSemver;
function requireSemver() {
  if (hasRequiredSemver) return semver$1;
  hasRequiredSemver = 1;
  const o = requireRe$1(), g = requireConstants(), c = requireSemver$1(), y = requireIdentifiers(), t = requireParse(), d = requireValid$1(), E = requireClean(), B = requireInc(), D = requireDiff(), x = requireMajor(), v = requireMinor(), F = requirePatch(), M = requirePrerelease(), U = requireCompare(), L = requireRcompare(), H = requireCompareLoose(), fe = requireCompareBuild(), ge = requireSort(), Ie = requireRsort(), Ee = requireGt(), Se = requireLt(), ze = requireEq(), He = requireNeq(), Pe = requireGte(), De = requireLte(), ve = requireCmp(), Fe = requireCoerce(), be = requireComparator(), Be = requireRange(), ke = requireSatisfies(), xe = requireToComparators(), Ne = requireMaxSatisfying(), Et = requireMinSatisfying(), st = requireMinVersion(), Dt = requireValid(), er = requireOutside(), xt = requireGtr(), ir = requireLtr(), sr = requireIntersects(), yr = requireSimplify(), wr = requireSubset();
  return semver$1 = {
    parse: t,
    valid: d,
    clean: E,
    inc: B,
    diff: D,
    major: x,
    minor: v,
    patch: F,
    prerelease: M,
    compare: U,
    rcompare: L,
    compareLoose: H,
    compareBuild: fe,
    sort: ge,
    rsort: Ie,
    gt: Ee,
    lt: Se,
    eq: ze,
    neq: He,
    gte: Pe,
    lte: De,
    cmp: ve,
    coerce: Fe,
    Comparator: be,
    Range: Be,
    satisfies: ke,
    toComparators: xe,
    maxSatisfying: Ne,
    minSatisfying: Et,
    minVersion: st,
    validRange: Dt,
    outside: er,
    gtr: xt,
    ltr: ir,
    intersects: sr,
    simplifyRange: yr,
    subset: wr,
    SemVer: c,
    re: o.re,
    src: o.src,
    tokens: o.t,
    SEMVER_SPEC_VERSION: g.SEMVER_SPEC_VERSION,
    RELEASE_TYPES: g.RELEASE_TYPES,
    compareIdentifiers: y.compareIdentifiers,
    rcompareIdentifiers: y.rcompareIdentifiers
  }, semver$1;
}
var semverExports = requireSemver();
const semver = /* @__PURE__ */ getDefaultExportFromCjs(semverExports);
var DeviceModelId;
(function(o) {
  o.blue = "blue", o.nanoS = "nanoS", o.nanoSP = "nanoSP", o.nanoX = "nanoX", o.stax = "stax", o.europa = "europa", o.apex = "apex";
})(DeviceModelId || (DeviceModelId = {}));
const devices = {
  [DeviceModelId.blue]: {
    id: DeviceModelId.blue,
    productName: "Ledger Blue",
    productIdMM: 0,
    legacyUsbProductId: 0,
    usbOnly: !0,
    memorySize: 480 * 1024,
    masks: [822083584, 822149120],
    getBlockSize: (o) => 4 * 1024
  },
  [DeviceModelId.nanoS]: {
    id: DeviceModelId.nanoS,
    productName: "Ledger Nano S",
    productIdMM: 16,
    legacyUsbProductId: 1,
    usbOnly: !0,
    memorySize: 320 * 1024,
    masks: [823132160],
    getBlockSize: (o) => semver.lt(semver.coerce(o) ?? "", "2.0.0") ? 4 * 1024 : 2 * 1024
  },
  [DeviceModelId.nanoX]: {
    id: DeviceModelId.nanoX,
    productName: "Ledger Nano X",
    productIdMM: 64,
    legacyUsbProductId: 4,
    usbOnly: !1,
    memorySize: 2 * 1024 * 1024,
    masks: [855638016],
    getBlockSize: (o) => 4 * 1024,
    bluetoothSpec: [
      {
        serviceUuid: "13d63400-2c97-0004-0000-4c6564676572",
        notifyUuid: "13d63400-2c97-0004-0001-4c6564676572",
        writeUuid: "13d63400-2c97-0004-0002-4c6564676572",
        writeCmdUuid: "13d63400-2c97-0004-0003-4c6564676572"
      }
    ]
  },
  [DeviceModelId.nanoSP]: {
    id: DeviceModelId.nanoSP,
    productName: "Ledger Nano S Plus",
    productIdMM: 80,
    legacyUsbProductId: 5,
    usbOnly: !0,
    memorySize: 1533 * 1024,
    masks: [856686592],
    getBlockSize: (o) => 32
  },
  [DeviceModelId.apex]: {
    id: DeviceModelId.apex,
    productName: "Ledger Apex",
    productIdMM: 128,
    legacyUsbProductId: 8,
    usbOnly: !1,
    memorySize: 1533 * 1024,
    masks: [859832320],
    getBlockSize: (o) => 32,
    bluetoothSpec: [
      /**
       * 13D63400-2C97-6004-0001-4C6564676572, 13D63400-2C97-6004-0002-4C6564676572, and 13D63400-2C97-6004-0003-4C6564676572 Characteristics for Service 13D63400-2C97-6004-0000-4C6564676572
       */
      {
        serviceUuid: "13d63400-2c97-6004-0000-4c6564676572",
        // WILL CHANGE, for now same as Stax
        notifyUuid: "13d63400-2c97-6004-0001-4c6564676572",
        // WILL CHANGE, for now same as Stax
        writeUuid: "13d63400-2c97-6004-0002-4c6564676572",
        // WILL CHANGE, for now same as Stax
        writeCmdUuid: "13d63400-2c97-6004-0003-4c6564676572"
        // WILL CHANGE, for now same as Stax
      }
    ]
  },
  [DeviceModelId.stax]: {
    id: DeviceModelId.stax,
    productName: "Ledger Stax",
    productIdMM: 96,
    legacyUsbProductId: 6,
    usbOnly: !1,
    memorySize: 1533 * 1024,
    masks: [857735168],
    getBlockSize: (o) => 32,
    bluetoothSpec: [
      {
        serviceUuid: "13d63400-2c97-6004-0000-4c6564676572",
        notifyUuid: "13d63400-2c97-6004-0001-4c6564676572",
        writeUuid: "13d63400-2c97-6004-0002-4c6564676572",
        writeCmdUuid: "13d63400-2c97-6004-0003-4c6564676572"
      }
    ]
  },
  [DeviceModelId.europa]: {
    id: DeviceModelId.europa,
    productName: "Ledger Flex",
    productIdMM: 112,
    legacyUsbProductId: 7,
    usbOnly: !1,
    memorySize: 1533 * 1024,
    masks: [858783744],
    getBlockSize: (o) => 32,
    bluetoothSpec: [
      {
        serviceUuid: "13d63400-2c97-3004-0000-4c6564676572",
        notifyUuid: "13d63400-2c97-3004-0001-4c6564676572",
        writeUuid: "13d63400-2c97-3004-0002-4c6564676572",
        writeCmdUuid: "13d63400-2c97-3004-0003-4c6564676572"
      }
    ]
  }
};
DeviceModelId.blue, DeviceModelId.nanoS, DeviceModelId.nanoSP, DeviceModelId.nanoX, DeviceModelId.stax, DeviceModelId.europa;
const devicesList = Object.values(devices), ledgerUSBVendorId = 11415, identifyUSBProductId = (o) => {
  const g = devicesList.find((t) => t.legacyUsbProductId === o);
  if (g)
    return g;
  const c = o >> 8;
  return devicesList.find((t) => t.productIdMM === c);
}, bluetoothServices = [], serviceUuidToInfos = {};
for (const o in devices) {
  const g = devices[o], { bluetoothSpec: c } = g;
  if (c)
    for (let y = 0; y < c.length; y++) {
      const t = c[y];
      bluetoothServices.push(t.serviceUuid), serviceUuidToInfos[t.serviceUuid] = serviceUuidToInfos[t.serviceUuid.replace(/-/g, "")] = {
        deviceModel: g,
        ...t
      };
    }
}
const ledgerDevices$1 = [
  {
    vendorId: ledgerUSBVendorId
  }
], isSupported$1 = () => Promise.resolve(!!(window.navigator && window.navigator.hid)), getHID = () => {
  const { hid: o } = navigator;
  if (!o)
    throw new TransportError("navigator.hid is not supported", "HIDNotSupported");
  return o;
};
async function requestLedgerDevices() {
  const o = await getHID().requestDevice({
    filters: ledgerDevices$1
  });
  return Array.isArray(o) ? o : [o];
}
async function getLedgerDevices$1() {
  return (await getHID().getDevices()).filter((g) => g.vendorId === ledgerUSBVendorId);
}
async function getFirstLedgerDevice$1() {
  const o = await getLedgerDevices$1();
  return o.length > 0 ? o[0] : (await requestLedgerDevices())[0];
}
const hc = class hc extends Transport {
  constructor(c) {
    super();
    Vi(this, "device");
    Vi(this, "deviceModel");
    Vi(this, "channel", Math.floor(Math.random() * 65535));
    Vi(this, "packetSize", 64);
    Vi(this, "inputs", []);
    Vi(this, "inputCallback");
    Vi(this, "read", () => this.inputs.length ? Promise.resolve(this.inputs.shift()) : new Promise((c) => {
      this.inputCallback = c;
    }));
    Vi(this, "onInputReport", (c) => {
      const y = Buffer.from(c.data.buffer);
      this.inputCallback ? (this.inputCallback(y), this.inputCallback = null) : this.inputs.push(y);
    });
    Vi(this, "_disconnectEmitted", !1);
    Vi(this, "_emitDisconnect", (c) => {
      this._disconnectEmitted || (this._disconnectEmitted = !0, this.emit("disconnect", c));
    });
    /**
     * Exchange with the device using APDU protocol.
     * @param apdu
     * @returns a promise of apdu response
     */
    Vi(this, "exchange", async (c) => await this.exchangeAtomicImpl(async () => {
      const { channel: t, packetSize: d } = this;
      log("apdu", "=> " + c.toString("hex"));
      const E = createHIDframing(t, d), B = E.makeBlocks(c);
      for (let v = 0; v < B.length; v++)
        await this.device.sendReport(0, B[v]);
      let D, x;
      for (; !(D = E.getReducedResult(x)); )
        try {
          const v = await this.read();
          x = E.reduceResponse(x, v);
        } catch (v) {
          if (v instanceof TransportError && v.id === "InvalidChannel")
            continue;
          throw v;
        }
      return log("apdu", "<= " + D.toString("hex")), D;
    }).catch((t) => {
      throw t && t.message && t.message.includes("write") ? (this._emitDisconnect(t), new DisconnectedDeviceDuringOperation(t.message)) : t;
    }));
    this.device = c, this.deviceModel = typeof c.productId == "number" ? identifyUSBProductId(c.productId) : void 0, c.addEventListener("inputreport", this.onInputReport);
  }
  /**
   * Similar to create() except it will always display the device permission (even if some devices are already accepted).
   */
  static async request() {
    const [c] = await requestLedgerDevices();
    return hc.open(c);
  }
  /**
   * Similar to create() except it will never display the device permission (it returns a Promise<?Transport>, null if it fails to find a device).
   */
  static async openConnected() {
    const c = await getLedgerDevices$1();
    return c.length === 0 ? null : hc.open(c[0]);
  }
  /**
   * Create a Ledger transport with a HIDDevice
   */
  static async open(c) {
    await c.open();
    const y = new hc(c), t = (d) => {
      c === d.device && (getHID().removeEventListener("disconnect", t), y._emitDisconnect(new DisconnectedDevice()));
    };
    return getHID().addEventListener("disconnect", t), y;
  }
  /**
   * Release the transport device
   */
  async close() {
    await this.exchangeBusyPromise, this.device.removeEventListener("inputreport", this.onInputReport), await this.device.close();
  }
  setScrambleKey() {
  }
};
/**
 * Check if WebUSB transport is supported.
 */
Vi(hc, "isSupported", isSupported$1), /**
 * List the WebUSB devices that was previously authorized by the user.
 */
Vi(hc, "list", getLedgerDevices$1), /**
 * Actively listen to WebUSB devices and emit ONE device
 * that was either accepted before, if not it will trigger the native permission UI.
 *
 * Important: it must be called in the context of a UI click!
 */
Vi(hc, "listen", (c) => {
  let y = !1;
  getFirstLedgerDevice$1().then((d) => {
    if (!d)
      c.error(new TransportOpenUserCancelled("Access denied to use Ledger device"));
    else if (!y) {
      const E = typeof d.productId == "number" ? identifyUSBProductId(d.productId) : void 0;
      c.next({
        type: "add",
        descriptor: d,
        deviceModel: E
      }), c.complete();
    }
  }, (d) => {
    c.error(new TransportOpenUserCancelled(d.message));
  });
  function t() {
    y = !0;
  }
  return {
    unsubscribe: t
  };
});
let TransportWebHID = hc;
const ledgerDevices = [
  {
    vendorId: ledgerUSBVendorId
  }
];
async function requestLedgerDevice() {
  return await navigator.usb.requestDevice({
    filters: ledgerDevices
  });
}
async function getLedgerDevices() {
  return (await navigator.usb.getDevices()).filter((g) => g.vendorId === ledgerUSBVendorId);
}
async function getFirstLedgerDevice() {
  const o = await getLedgerDevices();
  return o.length > 0 ? o[0] : requestLedgerDevice();
}
const isSupported = () => Promise.resolve(!!navigator && !!navigator.usb && typeof navigator.usb.getDevices == "function"), configurationValue = 1, endpointNumber = 3, Ac = class Ac extends Transport {
  constructor(c, y) {
    super();
    Vi(this, "device");
    Vi(this, "deviceModel");
    Vi(this, "channel", Math.floor(Math.random() * 65535));
    Vi(this, "packetSize", 64);
    Vi(this, "interfaceNumber");
    Vi(this, "_disconnectEmitted", !1);
    Vi(this, "_emitDisconnect", (c) => {
      this._disconnectEmitted || (this._disconnectEmitted = !0, this.emit("disconnect", c));
    });
    this.device = c, this.interfaceNumber = y, this.deviceModel = identifyUSBProductId(c.productId);
  }
  /**
   * Similar to create() except it will always display the device permission (even if some devices are already accepted).
   */
  static async request() {
    const c = await requestLedgerDevice();
    return Ac.open(c);
  }
  /**
   * Similar to create() except it will never display the device permission (it returns a Promise<?Transport>, null if it fails to find a device).
   */
  static async openConnected() {
    const c = await getLedgerDevices();
    return c.length === 0 ? null : Ac.open(c[0]);
  }
  /**
   * Create a Ledger transport with a USBDevice
   */
  static async open(c) {
    await c.open(), c.configuration === null && await c.selectConfiguration(configurationValue), await gracefullyResetDevice(c);
    const y = c.configurations[0].interfaces.find(({ alternates: B }) => B.some((D) => D.interfaceClass === 255));
    if (!y)
      throw new TransportInterfaceNotAvailable("No WebUSB interface found for your Ledger device. Please upgrade firmware or contact techsupport.");
    const t = y.interfaceNumber;
    try {
      await c.claimInterface(t);
    } catch (B) {
      throw await c.close(), new TransportInterfaceNotAvailable(B.message);
    }
    const d = new Ac(c, t), E = (B) => {
      c === B.device && (navigator.usb.removeEventListener("disconnect", E), d._emitDisconnect(new DisconnectedDevice()));
    };
    return navigator.usb.addEventListener("disconnect", E), d;
  }
  /**
   * Release the transport device
   */
  async close() {
    await this.exchangeBusyPromise, await this.device.releaseInterface(this.interfaceNumber), await gracefullyResetDevice(this.device), await this.device.close();
  }
  /**
   * Exchange with the device using APDU protocol.
   * @param apdu
   * @returns a promise of apdu response
   */
  async exchange(c) {
    return await this.exchangeAtomicImpl(async () => {
      const { channel: t, packetSize: d } = this;
      log("apdu", "=> " + c.toString("hex"));
      const E = createHIDframing(t, d), B = E.makeBlocks(c);
      for (let v = 0; v < B.length; v++)
        await this.device.transferOut(endpointNumber, B[v]);
      let D, x;
      for (; !(D = E.getReducedResult(x)); ) {
        const v = await this.device.transferIn(endpointNumber, d), F = Buffer.from(v.data.buffer);
        x = E.reduceResponse(x, F);
      }
      return log("apdu", "<= " + D.toString("hex")), D;
    }).catch((t) => {
      throw t && t.message && t.message.includes("disconnected") ? (this._emitDisconnect(t), new DisconnectedDeviceDuringOperation(t.message)) : t;
    });
  }
  setScrambleKey() {
  }
};
/**
 * Check if WebUSB transport is supported.
 */
Vi(Ac, "isSupported", isSupported), /**
 * List the WebUSB devices that was previously authorized by the user.
 */
Vi(Ac, "list", getLedgerDevices), /**
 * Actively listen to WebUSB devices and emit ONE device
 * that was either accepted before, if not it will trigger the native permission UI.
 *
 * Important: it must be called in the context of a UI click!
 */
Vi(Ac, "listen", (c) => {
  let y = !1;
  getFirstLedgerDevice().then((d) => {
    if (!y) {
      const E = identifyUSBProductId(d.productId);
      c.next({
        type: "add",
        descriptor: d,
        deviceModel: E
      }), c.complete();
    }
  }, (d) => {
    window.DOMException && d instanceof window.DOMException && d.code === 18 ? c.error(new TransportWebUSBGestureRequired(d.message)) : c.error(new TransportOpenUserCancelled(d.message));
  });
  function t() {
    y = !0;
  }
  return {
    unsubscribe: t
  };
});
let TransportWebUSB = Ac;
async function gracefullyResetDevice(o) {
  try {
    await o.reset();
  } catch (g) {
    console.warn(g);
  }
}
const crypto$2 = typeof globalThis == "object" && "crypto" in globalThis ? globalThis.crypto : void 0;
function isBytes$3(o) {
  return o instanceof Uint8Array || ArrayBuffer.isView(o) && o.constructor.name === "Uint8Array";
}
function anumber$1(o) {
  if (!Number.isSafeInteger(o) || o < 0)
    throw new Error("positive integer expected, got " + o);
}
function abytes$1(o, ...g) {
  if (!isBytes$3(o))
    throw new Error("Uint8Array expected");
  if (g.length > 0 && !g.includes(o.length))
    throw new Error("Uint8Array expected of length " + g + ", got length=" + o.length);
}
function ahash(o) {
  if (typeof o != "function" || typeof o.create != "function")
    throw new Error("Hash should be wrapped by utils.createHasher");
  anumber$1(o.outputLen), anumber$1(o.blockLen);
}
function aexists(o, g = !0) {
  if (o.destroyed)
    throw new Error("Hash instance has been destroyed");
  if (g && o.finished)
    throw new Error("Hash#digest() has already been called");
}
function aoutput(o, g) {
  abytes$1(o);
  const c = g.outputLen;
  if (o.length < c)
    throw new Error("digestInto() expects output buffer of length at least " + c);
}
function clean(...o) {
  for (let g = 0; g < o.length; g++)
    o[g].fill(0);
}
function createView$1(o) {
  return new DataView(o.buffer, o.byteOffset, o.byteLength);
}
function rotr(o, g) {
  return o << 32 - g | o >>> g;
}
function rotl(o, g) {
  return o << g | o >>> 32 - g >>> 0;
}
const hasHexBuiltin$1 = /* @ts-ignore */ typeof Uint8Array.from([]).toHex == "function" && typeof Uint8Array.fromHex == "function", hexes = /* @__PURE__ */ Array.from({ length: 256 }, (o, g) => g.toString(16).padStart(2, "0"));
function bytesToHex(o) {
  if (abytes$1(o), hasHexBuiltin$1)
    return o.toHex();
  let g = "";
  for (let c = 0; c < o.length; c++)
    g += hexes[o[c]];
  return g;
}
const asciis = { _0: 48, _9: 57, A: 65, F: 70, a: 97, f: 102 };
function asciiToBase16(o) {
  if (o >= asciis._0 && o <= asciis._9)
    return o - asciis._0;
  if (o >= asciis.A && o <= asciis.F)
    return o - (asciis.A - 10);
  if (o >= asciis.a && o <= asciis.f)
    return o - (asciis.a - 10);
}
function hexToBytes(o) {
  if (typeof o != "string")
    throw new Error("hex string expected, got " + typeof o);
  if (hasHexBuiltin$1)
    return Uint8Array.fromHex(o);
  const g = o.length, c = g / 2;
  if (g % 2)
    throw new Error("hex string expected, got unpadded hex of length " + g);
  const y = new Uint8Array(c);
  for (let t = 0, d = 0; t < c; t++, d += 2) {
    const E = asciiToBase16(o.charCodeAt(d)), B = asciiToBase16(o.charCodeAt(d + 1));
    if (E === void 0 || B === void 0) {
      const D = o[d] + o[d + 1];
      throw new Error('hex string expected, got non-hex character "' + D + '" at index ' + d);
    }
    y[t] = E * 16 + B;
  }
  return y;
}
function utf8ToBytes(o) {
  if (typeof o != "string")
    throw new Error("string expected");
  return new Uint8Array(new TextEncoder().encode(o));
}
function toBytes(o) {
  return typeof o == "string" && (o = utf8ToBytes(o)), abytes$1(o), o;
}
function concatBytes$2(...o) {
  let g = 0;
  for (let y = 0; y < o.length; y++) {
    const t = o[y];
    abytes$1(t), g += t.length;
  }
  const c = new Uint8Array(g);
  for (let y = 0, t = 0; y < o.length; y++) {
    const d = o[y];
    c.set(d, t), t += d.length;
  }
  return c;
}
class Hash {
}
function createHasher(o) {
  const g = (y) => o().update(toBytes(y)).digest(), c = o();
  return g.outputLen = c.outputLen, g.blockLen = c.blockLen, g.create = () => o(), g;
}
function randomBytes(o = 32) {
  if (crypto$2 && typeof crypto$2.getRandomValues == "function")
    return crypto$2.getRandomValues(new Uint8Array(o));
  if (crypto$2 && typeof crypto$2.randomBytes == "function")
    return Uint8Array.from(crypto$2.randomBytes(o));
  throw new Error("crypto.getRandomValues must be defined");
}
function setBigUint64(o, g, c, y) {
  if (typeof o.setBigUint64 == "function")
    return o.setBigUint64(g, c, y);
  const t = BigInt(32), d = BigInt(4294967295), E = Number(c >> t & d), B = Number(c & d), D = y ? 4 : 0, x = y ? 0 : 4;
  o.setUint32(g + D, E, y), o.setUint32(g + x, B, y);
}
function Chi(o, g, c) {
  return o & g ^ ~o & c;
}
function Maj(o, g, c) {
  return o & g ^ o & c ^ g & c;
}
class HashMD extends Hash {
  constructor(g, c, y, t) {
    super(), this.finished = !1, this.length = 0, this.pos = 0, this.destroyed = !1, this.blockLen = g, this.outputLen = c, this.padOffset = y, this.isLE = t, this.buffer = new Uint8Array(g), this.view = createView$1(this.buffer);
  }
  update(g) {
    aexists(this), g = toBytes(g), abytes$1(g);
    const { view: c, buffer: y, blockLen: t } = this, d = g.length;
    for (let E = 0; E < d; ) {
      const B = Math.min(t - this.pos, d - E);
      if (B === t) {
        const D = createView$1(g);
        for (; t <= d - E; E += t)
          this.process(D, E);
        continue;
      }
      y.set(g.subarray(E, E + B), this.pos), this.pos += B, E += B, this.pos === t && (this.process(c, 0), this.pos = 0);
    }
    return this.length += g.length, this.roundClean(), this;
  }
  digestInto(g) {
    aexists(this), aoutput(g, this), this.finished = !0;
    const { buffer: c, view: y, blockLen: t, isLE: d } = this;
    let { pos: E } = this;
    c[E++] = 128, clean(this.buffer.subarray(E)), this.padOffset > t - E && (this.process(y, 0), E = 0);
    for (let F = E; F < t; F++)
      c[F] = 0;
    setBigUint64(y, t - 8, BigInt(this.length * 8), d), this.process(y, 0);
    const B = createView$1(g), D = this.outputLen;
    if (D % 4)
      throw new Error("_sha2: outputLen should be aligned to 32bit");
    const x = D / 4, v = this.get();
    if (x > v.length)
      throw new Error("_sha2: outputLen bigger than state");
    for (let F = 0; F < x; F++)
      B.setUint32(4 * F, v[F], d);
  }
  digest() {
    const { buffer: g, outputLen: c } = this;
    this.digestInto(g);
    const y = g.slice(0, c);
    return this.destroy(), y;
  }
  _cloneInto(g) {
    g || (g = new this.constructor()), g.set(...this.get());
    const { blockLen: c, buffer: y, length: t, finished: d, destroyed: E, pos: B } = this;
    return g.destroyed = E, g.finished = d, g.length = t, g.pos = B, t % c && g.buffer.set(y), g;
  }
  clone() {
    return this._cloneInto();
  }
}
const SHA256_IV = /* @__PURE__ */ Uint32Array.from([
  1779033703,
  3144134277,
  1013904242,
  2773480762,
  1359893119,
  2600822924,
  528734635,
  1541459225
]), SHA256_K = /* @__PURE__ */ Uint32Array.from([
  1116352408,
  1899447441,
  3049323471,
  3921009573,
  961987163,
  1508970993,
  2453635748,
  2870763221,
  3624381080,
  310598401,
  607225278,
  1426881987,
  1925078388,
  2162078206,
  2614888103,
  3248222580,
  3835390401,
  4022224774,
  264347078,
  604807628,
  770255983,
  1249150122,
  1555081692,
  1996064986,
  2554220882,
  2821834349,
  2952996808,
  3210313671,
  3336571891,
  3584528711,
  113926993,
  338241895,
  666307205,
  773529912,
  1294757372,
  1396182291,
  1695183700,
  1986661051,
  2177026350,
  2456956037,
  2730485921,
  2820302411,
  3259730800,
  3345764771,
  3516065817,
  3600352804,
  4094571909,
  275423344,
  430227734,
  506948616,
  659060556,
  883997877,
  958139571,
  1322822218,
  1537002063,
  1747873779,
  1955562222,
  2024104815,
  2227730452,
  2361852424,
  2428436474,
  2756734187,
  3204031479,
  3329325298
]), SHA256_W = /* @__PURE__ */ new Uint32Array(64);
class SHA256 extends HashMD {
  constructor(g = 32) {
    super(64, g, 8, !1), this.A = SHA256_IV[0] | 0, this.B = SHA256_IV[1] | 0, this.C = SHA256_IV[2] | 0, this.D = SHA256_IV[3] | 0, this.E = SHA256_IV[4] | 0, this.F = SHA256_IV[5] | 0, this.G = SHA256_IV[6] | 0, this.H = SHA256_IV[7] | 0;
  }
  get() {
    const { A: g, B: c, C: y, D: t, E: d, F: E, G: B, H: D } = this;
    return [g, c, y, t, d, E, B, D];
  }
  // prettier-ignore
  set(g, c, y, t, d, E, B, D) {
    this.A = g | 0, this.B = c | 0, this.C = y | 0, this.D = t | 0, this.E = d | 0, this.F = E | 0, this.G = B | 0, this.H = D | 0;
  }
  process(g, c) {
    for (let F = 0; F < 16; F++, c += 4)
      SHA256_W[F] = g.getUint32(c, !1);
    for (let F = 16; F < 64; F++) {
      const M = SHA256_W[F - 15], U = SHA256_W[F - 2], L = rotr(M, 7) ^ rotr(M, 18) ^ M >>> 3, H = rotr(U, 17) ^ rotr(U, 19) ^ U >>> 10;
      SHA256_W[F] = H + SHA256_W[F - 7] + L + SHA256_W[F - 16] | 0;
    }
    let { A: y, B: t, C: d, D: E, E: B, F: D, G: x, H: v } = this;
    for (let F = 0; F < 64; F++) {
      const M = rotr(B, 6) ^ rotr(B, 11) ^ rotr(B, 25), U = v + M + Chi(B, D, x) + SHA256_K[F] + SHA256_W[F] | 0, H = (rotr(y, 2) ^ rotr(y, 13) ^ rotr(y, 22)) + Maj(y, t, d) | 0;
      v = x, x = D, D = B, B = E + U | 0, E = d, d = t, t = y, y = U + H | 0;
    }
    y = y + this.A | 0, t = t + this.B | 0, d = d + this.C | 0, E = E + this.D | 0, B = B + this.E | 0, D = D + this.F | 0, x = x + this.G | 0, v = v + this.H | 0, this.set(y, t, d, E, B, D, x, v);
  }
  roundClean() {
    clean(SHA256_W);
  }
  destroy() {
    this.set(0, 0, 0, 0, 0, 0, 0, 0), clean(this.buffer);
  }
}
const sha256 = /* @__PURE__ */ createHasher(() => new SHA256());
class HMAC extends Hash {
  constructor(g, c) {
    super(), this.finished = !1, this.destroyed = !1, ahash(g);
    const y = toBytes(c);
    if (this.iHash = g.create(), typeof this.iHash.update != "function")
      throw new Error("Expected instance of class which extends utils.Hash");
    this.blockLen = this.iHash.blockLen, this.outputLen = this.iHash.outputLen;
    const t = this.blockLen, d = new Uint8Array(t);
    d.set(y.length > t ? g.create().update(y).digest() : y);
    for (let E = 0; E < d.length; E++)
      d[E] ^= 54;
    this.iHash.update(d), this.oHash = g.create();
    for (let E = 0; E < d.length; E++)
      d[E] ^= 106;
    this.oHash.update(d), clean(d);
  }
  update(g) {
    return aexists(this), this.iHash.update(g), this;
  }
  digestInto(g) {
    aexists(this), abytes$1(g, this.outputLen), this.finished = !0, this.iHash.digestInto(g), this.oHash.update(g), this.oHash.digestInto(g), this.destroy();
  }
  digest() {
    const g = new Uint8Array(this.oHash.outputLen);
    return this.digestInto(g), g;
  }
  _cloneInto(g) {
    g || (g = Object.create(Object.getPrototypeOf(this), {}));
    const { oHash: c, iHash: y, finished: t, destroyed: d, blockLen: E, outputLen: B } = this;
    return g = g, g.finished = t, g.destroyed = d, g.blockLen = E, g.outputLen = B, g.oHash = c._cloneInto(g.oHash), g.iHash = y._cloneInto(g.iHash), g;
  }
  clone() {
    return this._cloneInto();
  }
  destroy() {
    this.destroyed = !0, this.oHash.destroy(), this.iHash.destroy();
  }
}
const hmac = (o, g, c) => new HMAC(o, g).update(c).digest();
hmac.create = (o, g) => new HMAC(o, g);
const _0n$4 = /* @__PURE__ */ BigInt(0), _1n$4 = /* @__PURE__ */ BigInt(1);
function _abool2(o, g = "") {
  if (typeof o != "boolean") {
    const c = g && `"${g}"`;
    throw new Error(c + "expected boolean, got type=" + typeof o);
  }
  return o;
}
function _abytes2(o, g, c = "") {
  const y = isBytes$3(o), t = o == null ? void 0 : o.length, d = g !== void 0;
  if (!y || d && t !== g) {
    const E = c && `"${c}" `, B = d ? ` of length ${g}` : "", D = y ? `length=${t}` : `type=${typeof o}`;
    throw new Error(E + "expected Uint8Array" + B + ", got " + D);
  }
  return o;
}
function numberToHexUnpadded(o) {
  const g = o.toString(16);
  return g.length & 1 ? "0" + g : g;
}
function hexToNumber(o) {
  if (typeof o != "string")
    throw new Error("hex string expected, got " + typeof o);
  return o === "" ? _0n$4 : BigInt("0x" + o);
}
function bytesToNumberBE(o) {
  return hexToNumber(bytesToHex(o));
}
function bytesToNumberLE(o) {
  return abytes$1(o), hexToNumber(bytesToHex(Uint8Array.from(o).reverse()));
}
function numberToBytesBE(o, g) {
  return hexToBytes(o.toString(16).padStart(g * 2, "0"));
}
function numberToBytesLE(o, g) {
  return numberToBytesBE(o, g).reverse();
}
function ensureBytes(o, g, c) {
  let y;
  if (typeof g == "string")
    try {
      y = hexToBytes(g);
    } catch (d) {
      throw new Error(o + " must be hex string or Uint8Array, cause: " + d);
    }
  else if (isBytes$3(g))
    y = Uint8Array.from(g);
  else
    throw new Error(o + " must be hex string or Uint8Array");
  const t = y.length;
  if (typeof c == "number" && t !== c)
    throw new Error(o + " of length " + c + " expected, got " + t);
  return y;
}
const isPosBig = (o) => typeof o == "bigint" && _0n$4 <= o;
function inRange(o, g, c) {
  return isPosBig(o) && isPosBig(g) && isPosBig(c) && g <= o && o < c;
}
function aInRange(o, g, c, y) {
  if (!inRange(g, c, y))
    throw new Error("expected valid " + o + ": " + c + " <= n < " + y + ", got " + g);
}
function bitLen(o) {
  let g;
  for (g = 0; o > _0n$4; o >>= _1n$4, g += 1)
    ;
  return g;
}
const bitMask = (o) => (_1n$4 << BigInt(o)) - _1n$4;
function createHmacDrbg(o, g, c) {
  if (typeof o != "number" || o < 2)
    throw new Error("hashLen must be a number");
  if (typeof g != "number" || g < 2)
    throw new Error("qByteLen must be a number");
  if (typeof c != "function")
    throw new Error("hmacFn must be a function");
  const y = (U) => new Uint8Array(U), t = (U) => Uint8Array.of(U);
  let d = y(o), E = y(o), B = 0;
  const D = () => {
    d.fill(1), E.fill(0), B = 0;
  }, x = (...U) => c(E, d, ...U), v = (U = y(0)) => {
    E = x(t(0), U), d = x(), U.length !== 0 && (E = x(t(1), U), d = x());
  }, F = () => {
    if (B++ >= 1e3)
      throw new Error("drbg: tried 1000 values");
    let U = 0;
    const L = [];
    for (; U < g; ) {
      d = x();
      const H = d.slice();
      L.push(H), U += d.length;
    }
    return concatBytes$2(...L);
  };
  return (U, L) => {
    D(), v(U);
    let H;
    for (; !(H = L(F())); )
      v();
    return D(), H;
  };
}
function _validateObject(o, g, c = {}) {
  if (!o || typeof o != "object")
    throw new Error("expected valid options object");
  function y(t, d, E) {
    const B = o[t];
    if (E && B === void 0)
      return;
    const D = typeof B;
    if (D !== d || B === null)
      throw new Error(`param "${t}" is invalid: expected ${d}, got ${D}`);
  }
  Object.entries(g).forEach(([t, d]) => y(t, d, !1)), Object.entries(c).forEach(([t, d]) => y(t, d, !0));
}
function memoized(o) {
  const g = /* @__PURE__ */ new WeakMap();
  return (c, ...y) => {
    const t = g.get(c);
    if (t !== void 0)
      return t;
    const d = o(c, ...y);
    return g.set(c, d), d;
  };
}
const _0n$3 = BigInt(0), _1n$3 = BigInt(1), _2n$2 = /* @__PURE__ */ BigInt(2), _3n$1 = /* @__PURE__ */ BigInt(3), _4n$1 = /* @__PURE__ */ BigInt(4), _5n = /* @__PURE__ */ BigInt(5), _7n = /* @__PURE__ */ BigInt(7), _8n = /* @__PURE__ */ BigInt(8), _9n = /* @__PURE__ */ BigInt(9), _16n = /* @__PURE__ */ BigInt(16);
function mod(o, g) {
  const c = o % g;
  return c >= _0n$3 ? c : g + c;
}
function pow2(o, g, c) {
  let y = o;
  for (; g-- > _0n$3; )
    y *= y, y %= c;
  return y;
}
function invert(o, g) {
  if (o === _0n$3)
    throw new Error("invert: expected non-zero number");
  if (g <= _0n$3)
    throw new Error("invert: expected positive modulus, got " + g);
  let c = mod(o, g), y = g, t = _0n$3, d = _1n$3;
  for (; c !== _0n$3; ) {
    const B = y / c, D = y % c, x = t - d * B;
    y = c, c = D, t = d, d = x;
  }
  if (y !== _1n$3)
    throw new Error("invert: does not exist");
  return mod(t, g);
}
function assertIsSquare(o, g, c) {
  if (!o.eql(o.sqr(g), c))
    throw new Error("Cannot find square root");
}
function sqrt3mod4(o, g) {
  const c = (o.ORDER + _1n$3) / _4n$1, y = o.pow(g, c);
  return assertIsSquare(o, y, g), y;
}
function sqrt5mod8(o, g) {
  const c = (o.ORDER - _5n) / _8n, y = o.mul(g, _2n$2), t = o.pow(y, c), d = o.mul(g, t), E = o.mul(o.mul(d, _2n$2), t), B = o.mul(d, o.sub(E, o.ONE));
  return assertIsSquare(o, B, g), B;
}
function sqrt9mod16(o) {
  const g = Field(o), c = tonelliShanks(o), y = c(g, g.neg(g.ONE)), t = c(g, y), d = c(g, g.neg(y)), E = (o + _7n) / _16n;
  return (B, D) => {
    let x = B.pow(D, E), v = B.mul(x, y);
    const F = B.mul(x, t), M = B.mul(x, d), U = B.eql(B.sqr(v), D), L = B.eql(B.sqr(F), D);
    x = B.cmov(x, v, U), v = B.cmov(M, F, L);
    const H = B.eql(B.sqr(v), D), fe = B.cmov(x, v, H);
    return assertIsSquare(B, fe, D), fe;
  };
}
function tonelliShanks(o) {
  if (o < _3n$1)
    throw new Error("sqrt is not defined for small field");
  let g = o - _1n$3, c = 0;
  for (; g % _2n$2 === _0n$3; )
    g /= _2n$2, c++;
  let y = _2n$2;
  const t = Field(o);
  for (; FpLegendre(t, y) === 1; )
    if (y++ > 1e3)
      throw new Error("Cannot find square root: probably non-prime P");
  if (c === 1)
    return sqrt3mod4;
  let d = t.pow(y, g);
  const E = (g + _1n$3) / _2n$2;
  return function(D, x) {
    if (D.is0(x))
      return x;
    if (FpLegendre(D, x) !== 1)
      throw new Error("Cannot find square root");
    let v = c, F = D.mul(D.ONE, d), M = D.pow(x, g), U = D.pow(x, E);
    for (; !D.eql(M, D.ONE); ) {
      if (D.is0(M))
        return D.ZERO;
      let L = 1, H = D.sqr(M);
      for (; !D.eql(H, D.ONE); )
        if (L++, H = D.sqr(H), L === v)
          throw new Error("Cannot find square root");
      const fe = _1n$3 << BigInt(v - L - 1), ge = D.pow(F, fe);
      v = L, F = D.sqr(ge), M = D.mul(M, F), U = D.mul(U, ge);
    }
    return U;
  };
}
function FpSqrt(o) {
  return o % _4n$1 === _3n$1 ? sqrt3mod4 : o % _8n === _5n ? sqrt5mod8 : o % _16n === _9n ? sqrt9mod16(o) : tonelliShanks(o);
}
const FIELD_FIELDS = [
  "create",
  "isValid",
  "is0",
  "neg",
  "inv",
  "sqrt",
  "sqr",
  "eql",
  "add",
  "sub",
  "mul",
  "pow",
  "div",
  "addN",
  "subN",
  "mulN",
  "sqrN"
];
function validateField(o) {
  const g = {
    ORDER: "bigint",
    MASK: "bigint",
    BYTES: "number",
    BITS: "number"
  }, c = FIELD_FIELDS.reduce((y, t) => (y[t] = "function", y), g);
  return _validateObject(o, c), o;
}
function FpPow(o, g, c) {
  if (c < _0n$3)
    throw new Error("invalid exponent, negatives unsupported");
  if (c === _0n$3)
    return o.ONE;
  if (c === _1n$3)
    return g;
  let y = o.ONE, t = g;
  for (; c > _0n$3; )
    c & _1n$3 && (y = o.mul(y, t)), t = o.sqr(t), c >>= _1n$3;
  return y;
}
function FpInvertBatch(o, g, c = !1) {
  const y = new Array(g.length).fill(c ? o.ZERO : void 0), t = g.reduce((E, B, D) => o.is0(B) ? E : (y[D] = E, o.mul(E, B)), o.ONE), d = o.inv(t);
  return g.reduceRight((E, B, D) => o.is0(B) ? E : (y[D] = o.mul(E, y[D]), o.mul(E, B)), d), y;
}
function FpLegendre(o, g) {
  const c = (o.ORDER - _1n$3) / _2n$2, y = o.pow(g, c), t = o.eql(y, o.ONE), d = o.eql(y, o.ZERO), E = o.eql(y, o.neg(o.ONE));
  if (!t && !d && !E)
    throw new Error("invalid Legendre symbol result");
  return t ? 1 : d ? 0 : -1;
}
function nLength(o, g) {
  g !== void 0 && anumber$1(g);
  const c = g !== void 0 ? g : o.toString(2).length, y = Math.ceil(c / 8);
  return { nBitLength: c, nByteLength: y };
}
function Field(o, g, c = !1, y = {}) {
  if (o <= _0n$3)
    throw new Error("invalid field: expected ORDER > 0, got " + o);
  let t, d, E = !1, B;
  if (typeof g == "object" && g != null) {
    if (y.sqrt || c)
      throw new Error("cannot specify opts in two arguments");
    const M = g;
    M.BITS && (t = M.BITS), M.sqrt && (d = M.sqrt), typeof M.isLE == "boolean" && (c = M.isLE), typeof M.modFromBytes == "boolean" && (E = M.modFromBytes), B = M.allowedLengths;
  } else
    typeof g == "number" && (t = g), y.sqrt && (d = y.sqrt);
  const { nBitLength: D, nByteLength: x } = nLength(o, t);
  if (x > 2048)
    throw new Error("invalid field: expected ORDER of <= 2048 bytes");
  let v;
  const F = Object.freeze({
    ORDER: o,
    isLE: c,
    BITS: D,
    BYTES: x,
    MASK: bitMask(D),
    ZERO: _0n$3,
    ONE: _1n$3,
    allowedLengths: B,
    create: (M) => mod(M, o),
    isValid: (M) => {
      if (typeof M != "bigint")
        throw new Error("invalid field element: expected bigint, got " + typeof M);
      return _0n$3 <= M && M < o;
    },
    is0: (M) => M === _0n$3,
    // is valid and invertible
    isValidNot0: (M) => !F.is0(M) && F.isValid(M),
    isOdd: (M) => (M & _1n$3) === _1n$3,
    neg: (M) => mod(-M, o),
    eql: (M, U) => M === U,
    sqr: (M) => mod(M * M, o),
    add: (M, U) => mod(M + U, o),
    sub: (M, U) => mod(M - U, o),
    mul: (M, U) => mod(M * U, o),
    pow: (M, U) => FpPow(F, M, U),
    div: (M, U) => mod(M * invert(U, o), o),
    // Same as above, but doesn't normalize
    sqrN: (M) => M * M,
    addN: (M, U) => M + U,
    subN: (M, U) => M - U,
    mulN: (M, U) => M * U,
    inv: (M) => invert(M, o),
    sqrt: d || ((M) => (v || (v = FpSqrt(o)), v(F, M))),
    toBytes: (M) => c ? numberToBytesLE(M, x) : numberToBytesBE(M, x),
    fromBytes: (M, U = !0) => {
      if (B) {
        if (!B.includes(M.length) || M.length > x)
          throw new Error("Field.fromBytes: expected " + B + " bytes, got " + M.length);
        const H = new Uint8Array(x);
        H.set(M, c ? 0 : H.length - M.length), M = H;
      }
      if (M.length !== x)
        throw new Error("Field.fromBytes: expected " + x + " bytes, got " + M.length);
      let L = c ? bytesToNumberLE(M) : bytesToNumberBE(M);
      if (E && (L = mod(L, o)), !U && !F.isValid(L))
        throw new Error("invalid field element: outside of range 0..ORDER");
      return L;
    },
    // TODO: we don't need it here, move out to separate fn
    invertBatch: (M) => FpInvertBatch(F, M),
    // We can't move this out because Fp6, Fp12 implement it
    // and it's unclear what to return in there.
    cmov: (M, U, L) => L ? U : M
  });
  return Object.freeze(F);
}
function getFieldBytesLength(o) {
  if (typeof o != "bigint")
    throw new Error("field order must be bigint");
  const g = o.toString(2).length;
  return Math.ceil(g / 8);
}
function getMinHashLength(o) {
  const g = getFieldBytesLength(o);
  return g + Math.ceil(g / 2);
}
function mapHashToField(o, g, c = !1) {
  const y = o.length, t = getFieldBytesLength(g), d = getMinHashLength(g);
  if (y < 16 || y < d || y > 1024)
    throw new Error("expected " + d + "-1024 bytes of input, got " + y);
  const E = c ? bytesToNumberLE(o) : bytesToNumberBE(o), B = mod(E, g - _1n$3) + _1n$3;
  return c ? numberToBytesLE(B, t) : numberToBytesBE(B, t);
}
const _0n$2 = BigInt(0), _1n$2 = BigInt(1);
function negateCt(o, g) {
  const c = g.negate();
  return o ? c : g;
}
function normalizeZ(o, g) {
  const c = FpInvertBatch(o.Fp, g.map((y) => y.Z));
  return g.map((y, t) => o.fromAffine(y.toAffine(c[t])));
}
function validateW(o, g) {
  if (!Number.isSafeInteger(o) || o <= 0 || o > g)
    throw new Error("invalid window size, expected [1.." + g + "], got W=" + o);
}
function calcWOpts(o, g) {
  validateW(o, g);
  const c = Math.ceil(g / o) + 1, y = 2 ** (o - 1), t = 2 ** o, d = bitMask(o), E = BigInt(o);
  return { windows: c, windowSize: y, mask: d, maxNumber: t, shiftBy: E };
}
function calcOffsets(o, g, c) {
  const { windowSize: y, mask: t, maxNumber: d, shiftBy: E } = c;
  let B = Number(o & t), D = o >> E;
  B > y && (B -= d, D += _1n$2);
  const x = g * y, v = x + Math.abs(B) - 1, F = B === 0, M = B < 0, U = g % 2 !== 0;
  return { nextN: D, offset: v, isZero: F, isNeg: M, isNegF: U, offsetF: x };
}
function validateMSMPoints(o, g) {
  if (!Array.isArray(o))
    throw new Error("array expected");
  o.forEach((c, y) => {
    if (!(c instanceof g))
      throw new Error("invalid point at index " + y);
  });
}
function validateMSMScalars(o, g) {
  if (!Array.isArray(o))
    throw new Error("array of scalars expected");
  o.forEach((c, y) => {
    if (!g.isValid(c))
      throw new Error("invalid scalar at index " + y);
  });
}
const pointPrecomputes = /* @__PURE__ */ new WeakMap(), pointWindowSizes = /* @__PURE__ */ new WeakMap();
function getW(o) {
  return pointWindowSizes.get(o) || 1;
}
function assert0(o) {
  if (o !== _0n$2)
    throw new Error("invalid wNAF");
}
class wNAF {
  // Parametrized with a given Point class (not individual point)
  constructor(g, c) {
    this.BASE = g.BASE, this.ZERO = g.ZERO, this.Fn = g.Fn, this.bits = c;
  }
  // non-const time multiplication ladder
  _unsafeLadder(g, c, y = this.ZERO) {
    let t = g;
    for (; c > _0n$2; )
      c & _1n$2 && (y = y.add(t)), t = t.double(), c >>= _1n$2;
    return y;
  }
  /**
   * Creates a wNAF precomputation window. Used for caching.
   * Default window size is set by `utils.precompute()` and is equal to 8.
   * Number of precomputed points depends on the curve size:
   * 2^(𝑊−1) * (Math.ceil(𝑛 / 𝑊) + 1), where:
   * - 𝑊 is the window size
   * - 𝑛 is the bitlength of the curve order.
   * For a 256-bit curve and window size 8, the number of precomputed points is 128 * 33 = 4224.
   * @param point Point instance
   * @param W window size
   * @returns precomputed point tables flattened to a single array
   */
  precomputeWindow(g, c) {
    const { windows: y, windowSize: t } = calcWOpts(c, this.bits), d = [];
    let E = g, B = E;
    for (let D = 0; D < y; D++) {
      B = E, d.push(B);
      for (let x = 1; x < t; x++)
        B = B.add(E), d.push(B);
      E = B.double();
    }
    return d;
  }
  /**
   * Implements ec multiplication using precomputed tables and w-ary non-adjacent form.
   * More compact implementation:
   * https://github.com/paulmillr/noble-secp256k1/blob/47cb1669b6e506ad66b35fe7d76132ae97465da2/index.ts#L502-L541
   * @returns real and fake (for const-time) points
   */
  wNAF(g, c, y) {
    if (!this.Fn.isValid(y))
      throw new Error("invalid scalar");
    let t = this.ZERO, d = this.BASE;
    const E = calcWOpts(g, this.bits);
    for (let B = 0; B < E.windows; B++) {
      const { nextN: D, offset: x, isZero: v, isNeg: F, isNegF: M, offsetF: U } = calcOffsets(y, B, E);
      y = D, v ? d = d.add(negateCt(M, c[U])) : t = t.add(negateCt(F, c[x]));
    }
    return assert0(y), { p: t, f: d };
  }
  /**
   * Implements ec unsafe (non const-time) multiplication using precomputed tables and w-ary non-adjacent form.
   * @param acc accumulator point to add result of multiplication
   * @returns point
   */
  wNAFUnsafe(g, c, y, t = this.ZERO) {
    const d = calcWOpts(g, this.bits);
    for (let E = 0; E < d.windows && y !== _0n$2; E++) {
      const { nextN: B, offset: D, isZero: x, isNeg: v } = calcOffsets(y, E, d);
      if (y = B, !x) {
        const F = c[D];
        t = t.add(v ? F.negate() : F);
      }
    }
    return assert0(y), t;
  }
  getPrecomputes(g, c, y) {
    let t = pointPrecomputes.get(c);
    return t || (t = this.precomputeWindow(c, g), g !== 1 && (typeof y == "function" && (t = y(t)), pointPrecomputes.set(c, t))), t;
  }
  cached(g, c, y) {
    const t = getW(g);
    return this.wNAF(t, this.getPrecomputes(t, g, y), c);
  }
  unsafe(g, c, y, t) {
    const d = getW(g);
    return d === 1 ? this._unsafeLadder(g, c, t) : this.wNAFUnsafe(d, this.getPrecomputes(d, g, y), c, t);
  }
  // We calculate precomputes for elliptic curve point multiplication
  // using windowed method. This specifies window size and
  // stores precomputed values. Usually only base point would be precomputed.
  createCache(g, c) {
    validateW(c, this.bits), pointWindowSizes.set(g, c), pointPrecomputes.delete(g);
  }
  hasCache(g) {
    return getW(g) !== 1;
  }
}
function mulEndoUnsafe(o, g, c, y) {
  let t = g, d = o.ZERO, E = o.ZERO;
  for (; c > _0n$2 || y > _0n$2; )
    c & _1n$2 && (d = d.add(t)), y & _1n$2 && (E = E.add(t)), t = t.double(), c >>= _1n$2, y >>= _1n$2;
  return { p1: d, p2: E };
}
function pippenger(o, g, c, y) {
  validateMSMPoints(c, o), validateMSMScalars(y, g);
  const t = c.length, d = y.length;
  if (t !== d)
    throw new Error("arrays of points and scalars must have equal length");
  const E = o.ZERO, B = bitLen(BigInt(t));
  let D = 1;
  B > 12 ? D = B - 3 : B > 4 ? D = B - 2 : B > 0 && (D = 2);
  const x = bitMask(D), v = new Array(Number(x) + 1).fill(E), F = Math.floor((g.BITS - 1) / D) * D;
  let M = E;
  for (let U = F; U >= 0; U -= D) {
    v.fill(E);
    for (let H = 0; H < d; H++) {
      const fe = y[H], ge = Number(fe >> BigInt(U) & x);
      v[ge] = v[ge].add(c[H]);
    }
    let L = E;
    for (let H = v.length - 1, fe = E; H > 0; H--)
      fe = fe.add(v[H]), L = L.add(fe);
    if (M = M.add(L), U !== 0)
      for (let H = 0; H < D; H++)
        M = M.double();
  }
  return M;
}
function createField(o, g, c) {
  if (g) {
    if (g.ORDER !== o)
      throw new Error("Field.ORDER must match order: Fp == p, Fn == n");
    return validateField(g), g;
  } else
    return Field(o, { isLE: c });
}
function _createCurveFields(o, g, c = {}, y) {
  if (y === void 0 && (y = o === "edwards"), !g || typeof g != "object")
    throw new Error(`expected valid ${o} CURVE object`);
  for (const D of ["p", "n", "h"]) {
    const x = g[D];
    if (!(typeof x == "bigint" && x > _0n$2))
      throw new Error(`CURVE.${D} must be positive bigint`);
  }
  const t = createField(g.p, c.Fp, y), d = createField(g.n, c.Fn, y), B = ["Gx", "Gy", "a", "b"];
  for (const D of B)
    if (!t.isValid(g[D]))
      throw new Error(`CURVE.${D} must be valid field element of CURVE.Fp`);
  return g = Object.freeze(Object.assign({}, g)), { CURVE: g, Fp: t, Fn: d };
}
const divNearest = (o, g) => (o + (o >= 0 ? g : -g) / _2n$1) / g;
function _splitEndoScalar(o, g, c) {
  const [[y, t], [d, E]] = g, B = divNearest(E * o, c), D = divNearest(-t * o, c);
  let x = o - B * y - D * d, v = -B * t - D * E;
  const F = x < _0n$1, M = v < _0n$1;
  F && (x = -x), M && (v = -v);
  const U = bitMask(Math.ceil(bitLen(c) / 2)) + _1n$1;
  if (x < _0n$1 || x >= U || v < _0n$1 || v >= U)
    throw new Error("splitScalar (endomorphism): failed, k=" + o);
  return { k1neg: F, k1: x, k2neg: M, k2: v };
}
function validateSigFormat(o) {
  if (!["compact", "recovered", "der"].includes(o))
    throw new Error('Signature format must be "compact", "recovered", or "der"');
  return o;
}
function validateSigOpts(o, g) {
  const c = {};
  for (let y of Object.keys(g))
    c[y] = o[y] === void 0 ? g[y] : o[y];
  return _abool2(c.lowS, "lowS"), _abool2(c.prehash, "prehash"), c.format !== void 0 && validateSigFormat(c.format), c;
}
class DERErr extends Error {
  constructor(g = "") {
    super(g);
  }
}
const DER = {
  // asn.1 DER encoding utils
  Err: DERErr,
  // Basic building block is TLV (Tag-Length-Value)
  _tlv: {
    encode: (o, g) => {
      const { Err: c } = DER;
      if (o < 0 || o > 256)
        throw new c("tlv.encode: wrong tag");
      if (g.length & 1)
        throw new c("tlv.encode: unpadded data");
      const y = g.length / 2, t = numberToHexUnpadded(y);
      if (t.length / 2 & 128)
        throw new c("tlv.encode: long form length too big");
      const d = y > 127 ? numberToHexUnpadded(t.length / 2 | 128) : "";
      return numberToHexUnpadded(o) + d + t + g;
    },
    // v - value, l - left bytes (unparsed)
    decode(o, g) {
      const { Err: c } = DER;
      let y = 0;
      if (o < 0 || o > 256)
        throw new c("tlv.encode: wrong tag");
      if (g.length < 2 || g[y++] !== o)
        throw new c("tlv.decode: wrong tlv");
      const t = g[y++], d = !!(t & 128);
      let E = 0;
      if (!d)
        E = t;
      else {
        const D = t & 127;
        if (!D)
          throw new c("tlv.decode(long): indefinite length not supported");
        if (D > 4)
          throw new c("tlv.decode(long): byte length is too big");
        const x = g.subarray(y, y + D);
        if (x.length !== D)
          throw new c("tlv.decode: length bytes not complete");
        if (x[0] === 0)
          throw new c("tlv.decode(long): zero leftmost byte");
        for (const v of x)
          E = E << 8 | v;
        if (y += D, E < 128)
          throw new c("tlv.decode(long): not minimal encoding");
      }
      const B = g.subarray(y, y + E);
      if (B.length !== E)
        throw new c("tlv.decode: wrong value length");
      return { v: B, l: g.subarray(y + E) };
    }
  },
  // https://crypto.stackexchange.com/a/57734 Leftmost bit of first byte is 'negative' flag,
  // since we always use positive integers here. It must always be empty:
  // - add zero byte if exists
  // - if next byte doesn't have a flag, leading zero is not allowed (minimal encoding)
  _int: {
    encode(o) {
      const { Err: g } = DER;
      if (o < _0n$1)
        throw new g("integer: negative integers are not allowed");
      let c = numberToHexUnpadded(o);
      if (Number.parseInt(c[0], 16) & 8 && (c = "00" + c), c.length & 1)
        throw new g("unexpected DER parsing assertion: unpadded hex");
      return c;
    },
    decode(o) {
      const { Err: g } = DER;
      if (o[0] & 128)
        throw new g("invalid signature integer: negative");
      if (o[0] === 0 && !(o[1] & 128))
        throw new g("invalid signature integer: unnecessary leading zero");
      return bytesToNumberBE(o);
    }
  },
  toSig(o) {
    const { Err: g, _int: c, _tlv: y } = DER, t = ensureBytes("signature", o), { v: d, l: E } = y.decode(48, t);
    if (E.length)
      throw new g("invalid signature: left bytes after parsing");
    const { v: B, l: D } = y.decode(2, d), { v: x, l: v } = y.decode(2, D);
    if (v.length)
      throw new g("invalid signature: left bytes after parsing");
    return { r: c.decode(B), s: c.decode(x) };
  },
  hexFromSig(o) {
    const { _tlv: g, _int: c } = DER, y = g.encode(2, c.encode(o.r)), t = g.encode(2, c.encode(o.s)), d = y + t;
    return g.encode(48, d);
  }
}, _0n$1 = BigInt(0), _1n$1 = BigInt(1), _2n$1 = BigInt(2), _3n = BigInt(3), _4n = BigInt(4);
function _normFnElement(o, g) {
  const { BYTES: c } = o;
  let y;
  if (typeof g == "bigint")
    y = g;
  else {
    let t = ensureBytes("private key", g);
    try {
      y = o.fromBytes(t);
    } catch {
      throw new Error(`invalid private key: expected ui8a of size ${c}, got ${typeof g}`);
    }
  }
  if (!o.isValidNot0(y))
    throw new Error("invalid private key: out of range [1..N-1]");
  return y;
}
function weierstrassN(o, g = {}) {
  const c = _createCurveFields("weierstrass", o, g), { Fp: y, Fn: t } = c;
  let d = c.CURVE;
  const { h: E, n: B } = d;
  _validateObject(g, {}, {
    allowInfinityPoint: "boolean",
    clearCofactor: "function",
    isTorsionFree: "function",
    fromBytes: "function",
    toBytes: "function",
    endo: "object",
    wrapPrivateKey: "boolean"
  });
  const { endo: D } = g;
  if (D && (!y.is0(d.a) || typeof D.beta != "bigint" || !Array.isArray(D.basises)))
    throw new Error('invalid endo: expected "beta": bigint and "basises": array');
  const x = getWLengths(y, t);
  function v() {
    if (!y.isOdd)
      throw new Error("compression is not supported: Field does not have .isOdd()");
  }
  function F(Be, ke, xe) {
    const { x: Ne, y: Et } = ke.toAffine(), st = y.toBytes(Ne);
    if (_abool2(xe, "isCompressed"), xe) {
      v();
      const Dt = !y.isOdd(Et);
      return concatBytes$2(pprefix(Dt), st);
    } else
      return concatBytes$2(Uint8Array.of(4), st, y.toBytes(Et));
  }
  function M(Be) {
    _abytes2(Be, void 0, "Point");
    const { publicKey: ke, publicKeyUncompressed: xe } = x, Ne = Be.length, Et = Be[0], st = Be.subarray(1);
    if (Ne === ke && (Et === 2 || Et === 3)) {
      const Dt = y.fromBytes(st);
      if (!y.isValid(Dt))
        throw new Error("bad point: is not on curve, wrong x");
      const er = H(Dt);
      let xt;
      try {
        xt = y.sqrt(er);
      } catch (yr) {
        const wr = yr instanceof Error ? ": " + yr.message : "";
        throw new Error("bad point: is not on curve, sqrt error" + wr);
      }
      v();
      const ir = y.isOdd(xt);
      return (Et & 1) === 1 !== ir && (xt = y.neg(xt)), { x: Dt, y: xt };
    } else if (Ne === xe && Et === 4) {
      const Dt = y.BYTES, er = y.fromBytes(st.subarray(0, Dt)), xt = y.fromBytes(st.subarray(Dt, Dt * 2));
      if (!fe(er, xt))
        throw new Error("bad point: is not on curve");
      return { x: er, y: xt };
    } else
      throw new Error(`bad point: got length ${Ne}, expected compressed=${ke} or uncompressed=${xe}`);
  }
  const U = g.toBytes || F, L = g.fromBytes || M;
  function H(Be) {
    const ke = y.sqr(Be), xe = y.mul(ke, Be);
    return y.add(y.add(xe, y.mul(Be, d.a)), d.b);
  }
  function fe(Be, ke) {
    const xe = y.sqr(ke), Ne = H(Be);
    return y.eql(xe, Ne);
  }
  if (!fe(d.Gx, d.Gy))
    throw new Error("bad curve params: generator point");
  const ge = y.mul(y.pow(d.a, _3n), _4n), Ie = y.mul(y.sqr(d.b), BigInt(27));
  if (y.is0(y.add(ge, Ie)))
    throw new Error("bad curve params: a or b");
  function Ee(Be, ke, xe = !1) {
    if (!y.isValid(ke) || xe && y.is0(ke))
      throw new Error(`bad point coordinate ${Be}`);
    return ke;
  }
  function Se(Be) {
    if (!(Be instanceof ve))
      throw new Error("ProjectivePoint expected");
  }
  function ze(Be) {
    if (!D || !D.basises)
      throw new Error("no endo");
    return _splitEndoScalar(Be, D.basises, t.ORDER);
  }
  const He = memoized((Be, ke) => {
    const { X: xe, Y: Ne, Z: Et } = Be;
    if (y.eql(Et, y.ONE))
      return { x: xe, y: Ne };
    const st = Be.is0();
    ke == null && (ke = st ? y.ONE : y.inv(Et));
    const Dt = y.mul(xe, ke), er = y.mul(Ne, ke), xt = y.mul(Et, ke);
    if (st)
      return { x: y.ZERO, y: y.ZERO };
    if (!y.eql(xt, y.ONE))
      throw new Error("invZ was invalid");
    return { x: Dt, y: er };
  }), Pe = memoized((Be) => {
    if (Be.is0()) {
      if (g.allowInfinityPoint && !y.is0(Be.Y))
        return;
      throw new Error("bad point: ZERO");
    }
    const { x: ke, y: xe } = Be.toAffine();
    if (!y.isValid(ke) || !y.isValid(xe))
      throw new Error("bad point: x or y not field elements");
    if (!fe(ke, xe))
      throw new Error("bad point: equation left != right");
    if (!Be.isTorsionFree())
      throw new Error("bad point: not in prime-order subgroup");
    return !0;
  });
  function De(Be, ke, xe, Ne, Et) {
    return xe = new ve(y.mul(xe.X, Be), xe.Y, xe.Z), ke = negateCt(Ne, ke), xe = negateCt(Et, xe), ke.add(xe);
  }
  class ve {
    /** Does NOT validate if the point is valid. Use `.assertValidity()`. */
    constructor(ke, xe, Ne) {
      this.X = Ee("x", ke), this.Y = Ee("y", xe, !0), this.Z = Ee("z", Ne), Object.freeze(this);
    }
    static CURVE() {
      return d;
    }
    /** Does NOT validate if the point is valid. Use `.assertValidity()`. */
    static fromAffine(ke) {
      const { x: xe, y: Ne } = ke || {};
      if (!ke || !y.isValid(xe) || !y.isValid(Ne))
        throw new Error("invalid affine point");
      if (ke instanceof ve)
        throw new Error("projective point not allowed");
      return y.is0(xe) && y.is0(Ne) ? ve.ZERO : new ve(xe, Ne, y.ONE);
    }
    static fromBytes(ke) {
      const xe = ve.fromAffine(L(_abytes2(ke, void 0, "point")));
      return xe.assertValidity(), xe;
    }
    static fromHex(ke) {
      return ve.fromBytes(ensureBytes("pointHex", ke));
    }
    get x() {
      return this.toAffine().x;
    }
    get y() {
      return this.toAffine().y;
    }
    /**
     *
     * @param windowSize
     * @param isLazy true will defer table computation until the first multiplication
     * @returns
     */
    precompute(ke = 8, xe = !0) {
      return be.createCache(this, ke), xe || this.multiply(_3n), this;
    }
    // TODO: return `this`
    /** A point on curve is valid if it conforms to equation. */
    assertValidity() {
      Pe(this);
    }
    hasEvenY() {
      const { y: ke } = this.toAffine();
      if (!y.isOdd)
        throw new Error("Field doesn't support isOdd");
      return !y.isOdd(ke);
    }
    /** Compare one point to another. */
    equals(ke) {
      Se(ke);
      const { X: xe, Y: Ne, Z: Et } = this, { X: st, Y: Dt, Z: er } = ke, xt = y.eql(y.mul(xe, er), y.mul(st, Et)), ir = y.eql(y.mul(Ne, er), y.mul(Dt, Et));
      return xt && ir;
    }
    /** Flips point to one corresponding to (x, -y) in Affine coordinates. */
    negate() {
      return new ve(this.X, y.neg(this.Y), this.Z);
    }
    // Renes-Costello-Batina exception-free doubling formula.
    // There is 30% faster Jacobian formula, but it is not complete.
    // https://eprint.iacr.org/2015/1060, algorithm 3
    // Cost: 8M + 3S + 3*a + 2*b3 + 15add.
    double() {
      const { a: ke, b: xe } = d, Ne = y.mul(xe, _3n), { X: Et, Y: st, Z: Dt } = this;
      let er = y.ZERO, xt = y.ZERO, ir = y.ZERO, sr = y.mul(Et, Et), yr = y.mul(st, st), wr = y.mul(Dt, Dt), qr = y.mul(Et, st);
      return qr = y.add(qr, qr), ir = y.mul(Et, Dt), ir = y.add(ir, ir), er = y.mul(ke, ir), xt = y.mul(Ne, wr), xt = y.add(er, xt), er = y.sub(yr, xt), xt = y.add(yr, xt), xt = y.mul(er, xt), er = y.mul(qr, er), ir = y.mul(Ne, ir), wr = y.mul(ke, wr), qr = y.sub(sr, wr), qr = y.mul(ke, qr), qr = y.add(qr, ir), ir = y.add(sr, sr), sr = y.add(ir, sr), sr = y.add(sr, wr), sr = y.mul(sr, qr), xt = y.add(xt, sr), wr = y.mul(st, Dt), wr = y.add(wr, wr), sr = y.mul(wr, qr), er = y.sub(er, sr), ir = y.mul(wr, yr), ir = y.add(ir, ir), ir = y.add(ir, ir), new ve(er, xt, ir);
    }
    // Renes-Costello-Batina exception-free addition formula.
    // There is 30% faster Jacobian formula, but it is not complete.
    // https://eprint.iacr.org/2015/1060, algorithm 1
    // Cost: 12M + 0S + 3*a + 3*b3 + 23add.
    add(ke) {
      Se(ke);
      const { X: xe, Y: Ne, Z: Et } = this, { X: st, Y: Dt, Z: er } = ke;
      let xt = y.ZERO, ir = y.ZERO, sr = y.ZERO;
      const yr = d.a, wr = y.mul(d.b, _3n);
      let qr = y.mul(xe, st), Mr = y.mul(Ne, Dt), Dr = y.mul(Et, er), Qr = y.add(xe, Ne), Xr = y.add(st, Dt);
      Qr = y.mul(Qr, Xr), Xr = y.add(qr, Mr), Qr = y.sub(Qr, Xr), Xr = y.add(xe, Et);
      let Vr = y.add(st, er);
      return Xr = y.mul(Xr, Vr), Vr = y.add(qr, Dr), Xr = y.sub(Xr, Vr), Vr = y.add(Ne, Et), xt = y.add(Dt, er), Vr = y.mul(Vr, xt), xt = y.add(Mr, Dr), Vr = y.sub(Vr, xt), sr = y.mul(yr, Xr), xt = y.mul(wr, Dr), sr = y.add(xt, sr), xt = y.sub(Mr, sr), sr = y.add(Mr, sr), ir = y.mul(xt, sr), Mr = y.add(qr, qr), Mr = y.add(Mr, qr), Dr = y.mul(yr, Dr), Xr = y.mul(wr, Xr), Mr = y.add(Mr, Dr), Dr = y.sub(qr, Dr), Dr = y.mul(yr, Dr), Xr = y.add(Xr, Dr), qr = y.mul(Mr, Xr), ir = y.add(ir, qr), qr = y.mul(Vr, Xr), xt = y.mul(Qr, xt), xt = y.sub(xt, qr), qr = y.mul(Qr, Mr), sr = y.mul(Vr, sr), sr = y.add(sr, qr), new ve(xt, ir, sr);
    }
    subtract(ke) {
      return this.add(ke.negate());
    }
    is0() {
      return this.equals(ve.ZERO);
    }
    /**
     * Constant time multiplication.
     * Uses wNAF method. Windowed method may be 10% faster,
     * but takes 2x longer to generate and consumes 2x memory.
     * Uses precomputes when available.
     * Uses endomorphism for Koblitz curves.
     * @param scalar by which the point would be multiplied
     * @returns New point
     */
    multiply(ke) {
      const { endo: xe } = g;
      if (!t.isValidNot0(ke))
        throw new Error("invalid scalar: out of range");
      let Ne, Et;
      const st = (Dt) => be.cached(this, Dt, (er) => normalizeZ(ve, er));
      if (xe) {
        const { k1neg: Dt, k1: er, k2neg: xt, k2: ir } = ze(ke), { p: sr, f: yr } = st(er), { p: wr, f: qr } = st(ir);
        Et = yr.add(qr), Ne = De(xe.beta, sr, wr, Dt, xt);
      } else {
        const { p: Dt, f: er } = st(ke);
        Ne = Dt, Et = er;
      }
      return normalizeZ(ve, [Ne, Et])[0];
    }
    /**
     * Non-constant-time multiplication. Uses double-and-add algorithm.
     * It's faster, but should only be used when you don't care about
     * an exposed secret key e.g. sig verification, which works over *public* keys.
     */
    multiplyUnsafe(ke) {
      const { endo: xe } = g, Ne = this;
      if (!t.isValid(ke))
        throw new Error("invalid scalar: out of range");
      if (ke === _0n$1 || Ne.is0())
        return ve.ZERO;
      if (ke === _1n$1)
        return Ne;
      if (be.hasCache(this))
        return this.multiply(ke);
      if (xe) {
        const { k1neg: Et, k1: st, k2neg: Dt, k2: er } = ze(ke), { p1: xt, p2: ir } = mulEndoUnsafe(ve, Ne, st, er);
        return De(xe.beta, xt, ir, Et, Dt);
      } else
        return be.unsafe(Ne, ke);
    }
    multiplyAndAddUnsafe(ke, xe, Ne) {
      const Et = this.multiplyUnsafe(xe).add(ke.multiplyUnsafe(Ne));
      return Et.is0() ? void 0 : Et;
    }
    /**
     * Converts Projective point to affine (x, y) coordinates.
     * @param invertedZ Z^-1 (inverted zero) - optional, precomputation is useful for invertBatch
     */
    toAffine(ke) {
      return He(this, ke);
    }
    /**
     * Checks whether Point is free of torsion elements (is in prime subgroup).
     * Always torsion-free for cofactor=1 curves.
     */
    isTorsionFree() {
      const { isTorsionFree: ke } = g;
      return E === _1n$1 ? !0 : ke ? ke(ve, this) : be.unsafe(this, B).is0();
    }
    clearCofactor() {
      const { clearCofactor: ke } = g;
      return E === _1n$1 ? this : ke ? ke(ve, this) : this.multiplyUnsafe(E);
    }
    isSmallOrder() {
      return this.multiplyUnsafe(E).is0();
    }
    toBytes(ke = !0) {
      return _abool2(ke, "isCompressed"), this.assertValidity(), U(ve, this, ke);
    }
    toHex(ke = !0) {
      return bytesToHex(this.toBytes(ke));
    }
    toString() {
      return `<Point ${this.is0() ? "ZERO" : this.toHex()}>`;
    }
    // TODO: remove
    get px() {
      return this.X;
    }
    get py() {
      return this.X;
    }
    get pz() {
      return this.Z;
    }
    toRawBytes(ke = !0) {
      return this.toBytes(ke);
    }
    _setWindowSize(ke) {
      this.precompute(ke);
    }
    static normalizeZ(ke) {
      return normalizeZ(ve, ke);
    }
    static msm(ke, xe) {
      return pippenger(ve, t, ke, xe);
    }
    static fromPrivateKey(ke) {
      return ve.BASE.multiply(_normFnElement(t, ke));
    }
  }
  ve.BASE = new ve(d.Gx, d.Gy, y.ONE), ve.ZERO = new ve(y.ZERO, y.ONE, y.ZERO), ve.Fp = y, ve.Fn = t;
  const Fe = t.BITS, be = new wNAF(ve, g.endo ? Math.ceil(Fe / 2) : Fe);
  return ve.BASE.precompute(8), ve;
}
function pprefix(o) {
  return Uint8Array.of(o ? 2 : 3);
}
function getWLengths(o, g) {
  return {
    secretKey: g.BYTES,
    publicKey: 1 + o.BYTES,
    publicKeyUncompressed: 1 + 2 * o.BYTES,
    publicKeyHasPrefix: !0,
    signature: 2 * g.BYTES
  };
}
function ecdh(o, g = {}) {
  const { Fn: c } = o, y = g.randomBytes || randomBytes, t = Object.assign(getWLengths(o.Fp, c), { seed: getMinHashLength(c.ORDER) });
  function d(U) {
    try {
      return !!_normFnElement(c, U);
    } catch {
      return !1;
    }
  }
  function E(U, L) {
    const { publicKey: H, publicKeyUncompressed: fe } = t;
    try {
      const ge = U.length;
      return L === !0 && ge !== H || L === !1 && ge !== fe ? !1 : !!o.fromBytes(U);
    } catch {
      return !1;
    }
  }
  function B(U = y(t.seed)) {
    return mapHashToField(_abytes2(U, t.seed, "seed"), c.ORDER);
  }
  function D(U, L = !0) {
    return o.BASE.multiply(_normFnElement(c, U)).toBytes(L);
  }
  function x(U) {
    const L = B(U);
    return { secretKey: L, publicKey: D(L) };
  }
  function v(U) {
    if (typeof U == "bigint")
      return !1;
    if (U instanceof o)
      return !0;
    const { secretKey: L, publicKey: H, publicKeyUncompressed: fe } = t;
    if (c.allowedLengths || L === H)
      return;
    const ge = ensureBytes("key", U).length;
    return ge === H || ge === fe;
  }
  function F(U, L, H = !0) {
    if (v(U) === !0)
      throw new Error("first arg must be private key");
    if (v(L) === !1)
      throw new Error("second arg must be public key");
    const fe = _normFnElement(c, U);
    return o.fromHex(L).multiply(fe).toBytes(H);
  }
  return Object.freeze({ getPublicKey: D, getSharedSecret: F, keygen: x, Point: o, utils: {
    isValidSecretKey: d,
    isValidPublicKey: E,
    randomSecretKey: B,
    // TODO: remove
    isValidPrivateKey: d,
    randomPrivateKey: B,
    normPrivateKeyToScalar: (U) => _normFnElement(c, U),
    precompute(U = 8, L = o.BASE) {
      return L.precompute(U, !1);
    }
  }, lengths: t });
}
function ecdsa(o, g, c = {}) {
  ahash(g), _validateObject(c, {}, {
    hmac: "function",
    lowS: "boolean",
    randomBytes: "function",
    bits2int: "function",
    bits2int_modN: "function"
  });
  const y = c.randomBytes || randomBytes, t = c.hmac || ((xe, ...Ne) => hmac(g, xe, concatBytes$2(...Ne))), { Fp: d, Fn: E } = o, { ORDER: B, BITS: D } = E, { keygen: x, getPublicKey: v, getSharedSecret: F, utils: M, lengths: U } = ecdh(o, c), L = {
    prehash: !1,
    lowS: typeof c.lowS == "boolean" ? c.lowS : !1,
    format: void 0,
    //'compact' as ECDSASigFormat,
    extraEntropy: !1
  }, H = "compact";
  function fe(xe) {
    const Ne = B >> _1n$1;
    return xe > Ne;
  }
  function ge(xe, Ne) {
    if (!E.isValidNot0(Ne))
      throw new Error(`invalid signature ${xe}: out of range 1..Point.Fn.ORDER`);
    return Ne;
  }
  function Ie(xe, Ne) {
    validateSigFormat(Ne);
    const Et = U.signature, st = Ne === "compact" ? Et : Ne === "recovered" ? Et + 1 : void 0;
    return _abytes2(xe, st, `${Ne} signature`);
  }
  class Ee {
    constructor(Ne, Et, st) {
      this.r = ge("r", Ne), this.s = ge("s", Et), st != null && (this.recovery = st), Object.freeze(this);
    }
    static fromBytes(Ne, Et = H) {
      Ie(Ne, Et);
      let st;
      if (Et === "der") {
        const { r: ir, s: sr } = DER.toSig(_abytes2(Ne));
        return new Ee(ir, sr);
      }
      Et === "recovered" && (st = Ne[0], Et = "compact", Ne = Ne.subarray(1));
      const Dt = E.BYTES, er = Ne.subarray(0, Dt), xt = Ne.subarray(Dt, Dt * 2);
      return new Ee(E.fromBytes(er), E.fromBytes(xt), st);
    }
    static fromHex(Ne, Et) {
      return this.fromBytes(hexToBytes(Ne), Et);
    }
    addRecoveryBit(Ne) {
      return new Ee(this.r, this.s, Ne);
    }
    recoverPublicKey(Ne) {
      const Et = d.ORDER, { r: st, s: Dt, recovery: er } = this;
      if (er == null || ![0, 1, 2, 3].includes(er))
        throw new Error("recovery id invalid");
      if (B * _2n$1 < Et && er > 1)
        throw new Error("recovery id is ambiguous for h>1 curve");
      const ir = er === 2 || er === 3 ? st + B : st;
      if (!d.isValid(ir))
        throw new Error("recovery id 2 or 3 invalid");
      const sr = d.toBytes(ir), yr = o.fromBytes(concatBytes$2(pprefix((er & 1) === 0), sr)), wr = E.inv(ir), qr = ze(ensureBytes("msgHash", Ne)), Mr = E.create(-qr * wr), Dr = E.create(Dt * wr), Qr = o.BASE.multiplyUnsafe(Mr).add(yr.multiplyUnsafe(Dr));
      if (Qr.is0())
        throw new Error("point at infinify");
      return Qr.assertValidity(), Qr;
    }
    // Signatures should be low-s, to prevent malleability.
    hasHighS() {
      return fe(this.s);
    }
    toBytes(Ne = H) {
      if (validateSigFormat(Ne), Ne === "der")
        return hexToBytes(DER.hexFromSig(this));
      const Et = E.toBytes(this.r), st = E.toBytes(this.s);
      if (Ne === "recovered") {
        if (this.recovery == null)
          throw new Error("recovery bit must be present");
        return concatBytes$2(Uint8Array.of(this.recovery), Et, st);
      }
      return concatBytes$2(Et, st);
    }
    toHex(Ne) {
      return bytesToHex(this.toBytes(Ne));
    }
    // TODO: remove
    assertValidity() {
    }
    static fromCompact(Ne) {
      return Ee.fromBytes(ensureBytes("sig", Ne), "compact");
    }
    static fromDER(Ne) {
      return Ee.fromBytes(ensureBytes("sig", Ne), "der");
    }
    normalizeS() {
      return this.hasHighS() ? new Ee(this.r, E.neg(this.s), this.recovery) : this;
    }
    toDERRawBytes() {
      return this.toBytes("der");
    }
    toDERHex() {
      return bytesToHex(this.toBytes("der"));
    }
    toCompactRawBytes() {
      return this.toBytes("compact");
    }
    toCompactHex() {
      return bytesToHex(this.toBytes("compact"));
    }
  }
  const Se = c.bits2int || function(Ne) {
    if (Ne.length > 8192)
      throw new Error("input is too large");
    const Et = bytesToNumberBE(Ne), st = Ne.length * 8 - D;
    return st > 0 ? Et >> BigInt(st) : Et;
  }, ze = c.bits2int_modN || function(Ne) {
    return E.create(Se(Ne));
  }, He = bitMask(D);
  function Pe(xe) {
    return aInRange("num < 2^" + D, xe, _0n$1, He), E.toBytes(xe);
  }
  function De(xe, Ne) {
    return _abytes2(xe, void 0, "message"), Ne ? _abytes2(g(xe), void 0, "prehashed message") : xe;
  }
  function ve(xe, Ne, Et) {
    if (["recovered", "canonical"].some((Mr) => Mr in Et))
      throw new Error("sign() legacy options not supported");
    const { lowS: st, prehash: Dt, extraEntropy: er } = validateSigOpts(Et, L);
    xe = De(xe, Dt);
    const xt = ze(xe), ir = _normFnElement(E, Ne), sr = [Pe(ir), Pe(xt)];
    if (er != null && er !== !1) {
      const Mr = er === !0 ? y(U.secretKey) : er;
      sr.push(ensureBytes("extraEntropy", Mr));
    }
    const yr = concatBytes$2(...sr), wr = xt;
    function qr(Mr) {
      const Dr = Se(Mr);
      if (!E.isValidNot0(Dr))
        return;
      const Qr = E.inv(Dr), Xr = o.BASE.multiply(Dr).toAffine(), Vr = E.create(Xr.x);
      if (Vr === _0n$1)
        return;
      const Ur = E.create(Qr * E.create(wr + Vr * ir));
      if (Ur === _0n$1)
        return;
      let Sr = (Xr.x === Vr ? 0 : 2) | Number(Xr.y & _1n$1), Gr = Ur;
      return st && fe(Ur) && (Gr = E.neg(Ur), Sr ^= 1), new Ee(Vr, Gr, Sr);
    }
    return { seed: yr, k2sig: qr };
  }
  function Fe(xe, Ne, Et = {}) {
    xe = ensureBytes("message", xe);
    const { seed: st, k2sig: Dt } = ve(xe, Ne, Et);
    return createHmacDrbg(g.outputLen, E.BYTES, t)(st, Dt);
  }
  function be(xe) {
    let Ne;
    const Et = typeof xe == "string" || isBytes$3(xe), st = !Et && xe !== null && typeof xe == "object" && typeof xe.r == "bigint" && typeof xe.s == "bigint";
    if (!Et && !st)
      throw new Error("invalid signature, expected Uint8Array, hex string or Signature instance");
    if (st)
      Ne = new Ee(xe.r, xe.s);
    else if (Et) {
      try {
        Ne = Ee.fromBytes(ensureBytes("sig", xe), "der");
      } catch (Dt) {
        if (!(Dt instanceof DER.Err))
          throw Dt;
      }
      if (!Ne)
        try {
          Ne = Ee.fromBytes(ensureBytes("sig", xe), "compact");
        } catch {
          return !1;
        }
    }
    return Ne || !1;
  }
  function Be(xe, Ne, Et, st = {}) {
    const { lowS: Dt, prehash: er, format: xt } = validateSigOpts(st, L);
    if (Et = ensureBytes("publicKey", Et), Ne = De(ensureBytes("message", Ne), er), "strict" in st)
      throw new Error("options.strict was renamed to lowS");
    const ir = xt === void 0 ? be(xe) : Ee.fromBytes(ensureBytes("sig", xe), xt);
    if (ir === !1)
      return !1;
    try {
      const sr = o.fromBytes(Et);
      if (Dt && ir.hasHighS())
        return !1;
      const { r: yr, s: wr } = ir, qr = ze(Ne), Mr = E.inv(wr), Dr = E.create(qr * Mr), Qr = E.create(yr * Mr), Xr = o.BASE.multiplyUnsafe(Dr).add(sr.multiplyUnsafe(Qr));
      return Xr.is0() ? !1 : E.create(Xr.x) === yr;
    } catch {
      return !1;
    }
  }
  function ke(xe, Ne, Et = {}) {
    const { prehash: st } = validateSigOpts(Et, L);
    return Ne = De(Ne, st), Ee.fromBytes(xe, "recovered").recoverPublicKey(Ne).toBytes();
  }
  return Object.freeze({
    keygen: x,
    getPublicKey: v,
    getSharedSecret: F,
    utils: M,
    lengths: U,
    Point: o,
    sign: Fe,
    verify: Be,
    recoverPublicKey: ke,
    Signature: Ee,
    hash: g
  });
}
function _weierstrass_legacy_opts_to_new(o) {
  const g = {
    a: o.a,
    b: o.b,
    p: o.Fp.ORDER,
    n: o.n,
    h: o.h,
    Gx: o.Gx,
    Gy: o.Gy
  }, c = o.Fp;
  let y = o.allowedPrivateKeyLengths ? Array.from(new Set(o.allowedPrivateKeyLengths.map((E) => Math.ceil(E / 2)))) : void 0;
  const t = Field(g.n, {
    BITS: o.nBitLength,
    allowedLengths: y,
    modFromBytes: o.wrapPrivateKey
  }), d = {
    Fp: c,
    Fn: t,
    allowInfinityPoint: o.allowInfinityPoint,
    endo: o.endo,
    isTorsionFree: o.isTorsionFree,
    clearCofactor: o.clearCofactor,
    fromBytes: o.fromBytes,
    toBytes: o.toBytes
  };
  return { CURVE: g, curveOpts: d };
}
function _ecdsa_legacy_opts_to_new(o) {
  const { CURVE: g, curveOpts: c } = _weierstrass_legacy_opts_to_new(o), y = {
    hmac: o.hmac,
    randomBytes: o.randomBytes,
    lowS: o.lowS,
    bits2int: o.bits2int,
    bits2int_modN: o.bits2int_modN
  };
  return { CURVE: g, curveOpts: c, hash: o.hash, ecdsaOpts: y };
}
function _ecdsa_new_output_to_legacy(o, g) {
  const c = g.Point;
  return Object.assign({}, g, {
    ProjectivePoint: c,
    CURVE: Object.assign({}, o, nLength(c.Fn.ORDER, c.Fn.BITS))
  });
}
function weierstrass(o) {
  const { CURVE: g, curveOpts: c, hash: y, ecdsaOpts: t } = _ecdsa_legacy_opts_to_new(o), d = weierstrassN(g, c), E = ecdsa(d, y, t);
  return _ecdsa_new_output_to_legacy(o, E);
}
function createCurve(o, g) {
  const c = (y) => weierstrass({ ...o, hash: y });
  return { ...c(g), create: c };
}
const secp256k1_CURVE = {
  p: BigInt("0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f"),
  n: BigInt("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141"),
  h: BigInt(1),
  a: BigInt(0),
  b: BigInt(7),
  Gx: BigInt("0x79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798"),
  Gy: BigInt("0x483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8")
}, secp256k1_ENDO = {
  beta: BigInt("0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee"),
  basises: [
    [BigInt("0x3086d221a7d46bcde86c90e49284eb15"), -BigInt("0xe4437ed6010e88286f547fa90abfe4c3")],
    [BigInt("0x114ca50f7a8e2f3f657c1108d9d44cfd8"), BigInt("0x3086d221a7d46bcde86c90e49284eb15")]
  ]
}, _0n = /* @__PURE__ */ BigInt(0), _1n = /* @__PURE__ */ BigInt(1), _2n = /* @__PURE__ */ BigInt(2);
function sqrtMod(o) {
  const g = secp256k1_CURVE.p, c = BigInt(3), y = BigInt(6), t = BigInt(11), d = BigInt(22), E = BigInt(23), B = BigInt(44), D = BigInt(88), x = o * o * o % g, v = x * x * o % g, F = pow2(v, c, g) * v % g, M = pow2(F, c, g) * v % g, U = pow2(M, _2n, g) * x % g, L = pow2(U, t, g) * U % g, H = pow2(L, d, g) * L % g, fe = pow2(H, B, g) * H % g, ge = pow2(fe, D, g) * fe % g, Ie = pow2(ge, B, g) * H % g, Ee = pow2(Ie, c, g) * v % g, Se = pow2(Ee, E, g) * L % g, ze = pow2(Se, y, g) * x % g, He = pow2(ze, _2n, g);
  if (!Fpk1.eql(Fpk1.sqr(He), o))
    throw new Error("Cannot find square root");
  return He;
}
const Fpk1 = Field(secp256k1_CURVE.p, { sqrt: sqrtMod }), secp256k1 = createCurve({ ...secp256k1_CURVE, Fp: Fpk1, lowS: !0, endo: secp256k1_ENDO }, sha256), TAGGED_HASH_PREFIXES = {};
function taggedHash(o, ...g) {
  let c = TAGGED_HASH_PREFIXES[o];
  if (c === void 0) {
    const y = sha256(utf8ToBytes(o));
    c = concatBytes$2(y, y), TAGGED_HASH_PREFIXES[o] = c;
  }
  return sha256(concatBytes$2(c, ...g));
}
const pointToBytes = (o) => o.toBytes(!0).slice(1), Pointk1 = secp256k1.Point, hasEven = (o) => o % _2n === _0n;
function schnorrGetExtPubKey(o) {
  const { Fn: g, BASE: c } = Pointk1, y = _normFnElement(g, o), t = c.multiply(y);
  return { scalar: hasEven(t.y) ? y : g.neg(y), bytes: pointToBytes(t) };
}
function lift_x(o) {
  const g = Fpk1;
  if (!g.isValidNot0(o))
    throw new Error("invalid x: Fail if x ≥ p");
  const c = g.create(o * o), y = g.create(c * o + BigInt(7));
  let t = g.sqrt(y);
  hasEven(t) || (t = g.neg(t));
  const d = Pointk1.fromAffine({ x: o, y: t });
  return d.assertValidity(), d;
}
const num = bytesToNumberBE;
function challenge(...o) {
  return Pointk1.Fn.create(num(taggedHash("BIP0340/challenge", ...o)));
}
function schnorrGetPublicKey(o) {
  return schnorrGetExtPubKey(o).bytes;
}
function schnorrSign(o, g, c = randomBytes(32)) {
  const { Fn: y } = Pointk1, t = ensureBytes("message", o), { bytes: d, scalar: E } = schnorrGetExtPubKey(g), B = ensureBytes("auxRand", c, 32), D = y.toBytes(E ^ num(taggedHash("BIP0340/aux", B))), x = taggedHash("BIP0340/nonce", D, d, t), { bytes: v, scalar: F } = schnorrGetExtPubKey(x), M = challenge(v, d, t), U = new Uint8Array(64);
  if (U.set(v, 0), U.set(y.toBytes(y.create(F + M * E)), 32), !schnorrVerify(U, t, d))
    throw new Error("sign: Invalid signature produced");
  return U;
}
function schnorrVerify(o, g, c) {
  const { Fn: y, BASE: t } = Pointk1, d = ensureBytes("signature", o, 64), E = ensureBytes("message", g), B = ensureBytes("publicKey", c, 32);
  try {
    const D = lift_x(num(B)), x = num(d.subarray(0, 32));
    if (!inRange(x, _1n, secp256k1_CURVE.p))
      return !1;
    const v = num(d.subarray(32, 64));
    if (!inRange(v, _1n, secp256k1_CURVE.n))
      return !1;
    const F = challenge(y.toBytes(x), pointToBytes(D), E), M = t.multiplyUnsafe(v).add(D.multiplyUnsafe(y.neg(F))), { x: U, y: L } = M.toAffine();
    return !(M.is0() || !hasEven(L) || U !== x);
  } catch {
    return !1;
  }
}
const schnorr = /* @__PURE__ */ (() => {
  const c = (t = randomBytes(48)) => mapHashToField(t, secp256k1_CURVE.n);
  secp256k1.utils.randomSecretKey;
  function y(t) {
    const d = c(t);
    return { secretKey: d, publicKey: schnorrGetPublicKey(d) };
  }
  return {
    keygen: y,
    getPublicKey: schnorrGetPublicKey,
    sign: schnorrSign,
    verify: schnorrVerify,
    Point: Pointk1,
    utils: {
      randomSecretKey: c,
      randomPrivateKey: c,
      taggedHash,
      // TODO: remove
      lift_x,
      pointToBytes,
      numberToBytesBE,
      bytesToNumberBE,
      mod
    },
    lengths: {
      secretKey: 32,
      publicKey: 32,
      publicKeyHasPrefix: !1,
      signature: 64,
      seed: 48
    }
  };
})(), Rho160 = /* @__PURE__ */ Uint8Array.from([
  7,
  4,
  13,
  1,
  10,
  6,
  15,
  3,
  12,
  0,
  9,
  5,
  2,
  14,
  11,
  8
]), Id160 = Uint8Array.from(new Array(16).fill(0).map((o, g) => g)), Pi160 = Id160.map((o) => (9 * o + 5) % 16), idxLR = /* @__PURE__ */ (() => {
  const c = [[Id160], [Pi160]];
  for (let y = 0; y < 4; y++)
    for (let t of c)
      t.push(t[y].map((d) => Rho160[d]));
  return c;
})(), idxL = idxLR[0], idxR = idxLR[1], shifts160 = /* @__PURE__ */ [
  [11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8],
  [12, 13, 11, 15, 6, 9, 9, 7, 12, 15, 11, 13, 7, 8, 7, 7],
  [13, 15, 14, 11, 7, 7, 6, 8, 13, 14, 13, 12, 5, 5, 6, 9],
  [14, 11, 12, 14, 8, 6, 5, 5, 15, 12, 15, 14, 9, 9, 8, 6],
  [15, 12, 13, 13, 9, 5, 8, 6, 14, 11, 12, 11, 8, 6, 5, 5]
].map((o) => Uint8Array.from(o)), shiftsL160 = /* @__PURE__ */ idxL.map((o, g) => o.map((c) => shifts160[g][c])), shiftsR160 = /* @__PURE__ */ idxR.map((o, g) => o.map((c) => shifts160[g][c])), Kl160 = /* @__PURE__ */ Uint32Array.from([
  0,
  1518500249,
  1859775393,
  2400959708,
  2840853838
]), Kr160 = /* @__PURE__ */ Uint32Array.from([
  1352829926,
  1548603684,
  1836072691,
  2053994217,
  0
]);
function ripemd_f(o, g, c, y) {
  return o === 0 ? g ^ c ^ y : o === 1 ? g & c | ~g & y : o === 2 ? (g | ~c) ^ y : o === 3 ? g & y | c & ~y : g ^ (c | ~y);
}
const BUF_160 = /* @__PURE__ */ new Uint32Array(16);
class RIPEMD160 extends HashMD {
  constructor() {
    super(64, 20, 8, !0), this.h0 = 1732584193, this.h1 = -271733879, this.h2 = -1732584194, this.h3 = 271733878, this.h4 = -1009589776;
  }
  get() {
    const { h0: g, h1: c, h2: y, h3: t, h4: d } = this;
    return [g, c, y, t, d];
  }
  set(g, c, y, t, d) {
    this.h0 = g | 0, this.h1 = c | 0, this.h2 = y | 0, this.h3 = t | 0, this.h4 = d | 0;
  }
  process(g, c) {
    for (let U = 0; U < 16; U++, c += 4)
      BUF_160[U] = g.getUint32(c, !0);
    let y = this.h0 | 0, t = y, d = this.h1 | 0, E = d, B = this.h2 | 0, D = B, x = this.h3 | 0, v = x, F = this.h4 | 0, M = F;
    for (let U = 0; U < 5; U++) {
      const L = 4 - U, H = Kl160[U], fe = Kr160[U], ge = idxL[U], Ie = idxR[U], Ee = shiftsL160[U], Se = shiftsR160[U];
      for (let ze = 0; ze < 16; ze++) {
        const He = rotl(y + ripemd_f(U, d, B, x) + BUF_160[ge[ze]] + H, Ee[ze]) + F | 0;
        y = F, F = x, x = rotl(B, 10) | 0, B = d, d = He;
      }
      for (let ze = 0; ze < 16; ze++) {
        const He = rotl(t + ripemd_f(L, E, D, v) + BUF_160[Ie[ze]] + fe, Se[ze]) + M | 0;
        t = M, M = v, v = rotl(D, 10) | 0, D = E, E = He;
      }
    }
    this.set(this.h1 + B + v | 0, this.h2 + x + M | 0, this.h3 + F + t | 0, this.h4 + y + E | 0, this.h0 + d + D | 0);
  }
  roundClean() {
    clean(BUF_160);
  }
  destroy() {
    this.destroyed = !0, clean(this.buffer), this.set(0, 0, 0, 0, 0);
  }
}
const ripemd160 = /* @__PURE__ */ createHasher(() => new RIPEMD160());
function isBytes$2(o) {
  return o instanceof Uint8Array || ArrayBuffer.isView(o) && o.constructor.name === "Uint8Array";
}
function abytes(o, ...g) {
  if (!isBytes$2(o))
    throw new Error("Uint8Array expected");
  if (g.length > 0 && !g.includes(o.length))
    throw new Error("Uint8Array expected of length " + g + ", got length=" + o.length);
}
function isArrayOf(o, g) {
  return Array.isArray(g) ? g.length === 0 ? !0 : o ? g.every((c) => typeof c == "string") : g.every((c) => Number.isSafeInteger(c)) : !1;
}
function afn(o) {
  if (typeof o != "function")
    throw new Error("function expected");
  return !0;
}
function astr(o, g) {
  if (typeof g != "string")
    throw new Error(`${o}: string expected`);
  return !0;
}
function anumber(o) {
  if (!Number.isSafeInteger(o))
    throw new Error(`invalid integer: ${o}`);
}
function aArr(o) {
  if (!Array.isArray(o))
    throw new Error("array expected");
}
function astrArr(o, g) {
  if (!isArrayOf(!0, g))
    throw new Error(`${o}: array of strings expected`);
}
function anumArr(o, g) {
  if (!isArrayOf(!1, g))
    throw new Error(`${o}: array of numbers expected`);
}
// @__NO_SIDE_EFFECTS__
function chain(...o) {
  const g = (d) => d, c = (d, E) => (B) => d(E(B)), y = o.map((d) => d.encode).reduceRight(c, g), t = o.map((d) => d.decode).reduce(c, g);
  return { encode: y, decode: t };
}
// @__NO_SIDE_EFFECTS__
function alphabet(o) {
  const g = typeof o == "string" ? o.split("") : o, c = g.length;
  astrArr("alphabet", g);
  const y = new Map(g.map((t, d) => [t, d]));
  return {
    encode: (t) => (aArr(t), t.map((d) => {
      if (!Number.isSafeInteger(d) || d < 0 || d >= c)
        throw new Error(`alphabet.encode: digit index outside alphabet "${d}". Allowed: ${o}`);
      return g[d];
    })),
    decode: (t) => (aArr(t), t.map((d) => {
      astr("alphabet.decode", d);
      const E = y.get(d);
      if (E === void 0)
        throw new Error(`Unknown letter: "${d}". Allowed: ${o}`);
      return E;
    }))
  };
}
// @__NO_SIDE_EFFECTS__
function join(o = "") {
  return astr("join", o), {
    encode: (g) => (astrArr("join.decode", g), g.join(o)),
    decode: (g) => (astr("join.decode", g), g.split(o))
  };
}
// @__NO_SIDE_EFFECTS__
function normalize(o) {
  return afn(o), { encode: (g) => g, decode: (g) => o(g) };
}
function convertRadix(o, g, c) {
  if (g < 2)
    throw new Error(`convertRadix: invalid from=${g}, base cannot be less than 2`);
  if (c < 2)
    throw new Error(`convertRadix: invalid to=${c}, base cannot be less than 2`);
  if (aArr(o), !o.length)
    return [];
  let y = 0;
  const t = [], d = Array.from(o, (B) => {
    if (anumber(B), B < 0 || B >= g)
      throw new Error(`invalid integer: ${B}`);
    return B;
  }), E = d.length;
  for (; ; ) {
    let B = 0, D = !0;
    for (let x = y; x < E; x++) {
      const v = d[x], F = g * B, M = F + v;
      if (!Number.isSafeInteger(M) || F / g !== B || M - v !== F)
        throw new Error("convertRadix: carry overflow");
      const U = M / c;
      B = M % c;
      const L = Math.floor(U);
      if (d[x] = L, !Number.isSafeInteger(L) || L * c + B !== M)
        throw new Error("convertRadix: carry overflow");
      if (D)
        L ? D = !1 : y = x;
      else continue;
    }
    if (t.push(B), D)
      break;
  }
  for (let B = 0; B < o.length - 1 && o[B] === 0; B++)
    t.push(0);
  return t.reverse();
}
const gcd = (o, g) => g === 0 ? o : gcd(g, o % g), radix2carry = /* @__NO_SIDE_EFFECTS__ */ (o, g) => o + (g - gcd(o, g)), powers = /* @__PURE__ */ (() => {
  let o = [];
  for (let g = 0; g < 40; g++)
    o.push(2 ** g);
  return o;
})();
function convertRadix2(o, g, c, y) {
  if (aArr(o), g <= 0 || g > 32)
    throw new Error(`convertRadix2: wrong from=${g}`);
  if (c <= 0 || c > 32)
    throw new Error(`convertRadix2: wrong to=${c}`);
  if (/* @__PURE__ */ radix2carry(g, c) > 32)
    throw new Error(`convertRadix2: carry overflow from=${g} to=${c} carryBits=${/* @__PURE__ */ radix2carry(g, c)}`);
  let t = 0, d = 0;
  const E = powers[g], B = powers[c] - 1, D = [];
  for (const x of o) {
    if (anumber(x), x >= E)
      throw new Error(`convertRadix2: invalid data word=${x} from=${g}`);
    if (t = t << g | x, d + g > 32)
      throw new Error(`convertRadix2: carry overflow pos=${d} from=${g}`);
    for (d += g; d >= c; d -= c)
      D.push((t >> d - c & B) >>> 0);
    const v = powers[d];
    if (v === void 0)
      throw new Error("invalid carry");
    t &= v - 1;
  }
  if (t = t << c - d & B, !y && d >= g)
    throw new Error("Excess padding");
  if (!y && t > 0)
    throw new Error(`Non-zero padding: ${t}`);
  return y && d > 0 && D.push(t >>> 0), D;
}
// @__NO_SIDE_EFFECTS__
function radix(o) {
  anumber(o);
  const g = 2 ** 8;
  return {
    encode: (c) => {
      if (!isBytes$2(c))
        throw new Error("radix.encode input should be Uint8Array");
      return convertRadix(Array.from(c), g, o);
    },
    decode: (c) => (anumArr("radix.decode", c), Uint8Array.from(convertRadix(c, o, g)))
  };
}
// @__NO_SIDE_EFFECTS__
function radix2(o, g = !1) {
  if (anumber(o), o <= 0 || o > 32)
    throw new Error("radix2: bits should be in (0..32]");
  if (/* @__PURE__ */ radix2carry(8, o) > 32 || /* @__PURE__ */ radix2carry(o, 8) > 32)
    throw new Error("radix2: carry overflow");
  return {
    encode: (c) => {
      if (!isBytes$2(c))
        throw new Error("radix2.encode input should be Uint8Array");
      return convertRadix2(Array.from(c), 8, o, !g);
    },
    decode: (c) => (anumArr("radix2.decode", c), Uint8Array.from(convertRadix2(c, o, 8, g)))
  };
}
function unsafeWrapper(o) {
  return afn(o), function(...g) {
    try {
      return o.apply(null, g);
    } catch {
    }
  };
}
function checksum$1(o, g) {
  return anumber(o), afn(g), {
    encode(c) {
      if (!isBytes$2(c))
        throw new Error("checksum.encode: input should be Uint8Array");
      const y = g(c).slice(0, o), t = new Uint8Array(c.length + o);
      return t.set(c), t.set(y, c.length), t;
    },
    decode(c) {
      if (!isBytes$2(c))
        throw new Error("checksum.decode: input should be Uint8Array");
      const y = c.slice(0, -o), t = c.slice(-o), d = g(y).slice(0, o);
      for (let E = 0; E < o; E++)
        if (d[E] !== t[E])
          throw new Error("Invalid checksum");
      return y;
    }
  };
}
const genBase58 = /* @__NO_SIDE_EFFECTS__ */ (o) => /* @__PURE__ */ chain(/* @__PURE__ */ radix(58), /* @__PURE__ */ alphabet(o), /* @__PURE__ */ join("")), base58 = /* @__PURE__ */ genBase58("123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz"), createBase58check = (o) => /* @__PURE__ */ chain(checksum$1(4, (g) => o(o(g))), base58), BECH_ALPHABET = /* @__PURE__ */ chain(/* @__PURE__ */ alphabet("qpzry9x8gf2tvdw0s3jn54khce6mua7l"), /* @__PURE__ */ join("")), POLYMOD_GENERATORS = [996825010, 642813549, 513874426, 1027748829, 705979059];
function bech32Polymod(o) {
  const g = o >> 25;
  let c = (o & 33554431) << 5;
  for (let y = 0; y < POLYMOD_GENERATORS.length; y++)
    (g >> y & 1) === 1 && (c ^= POLYMOD_GENERATORS[y]);
  return c;
}
function bechChecksum(o, g, c = 1) {
  const y = o.length;
  let t = 1;
  for (let d = 0; d < y; d++) {
    const E = o.charCodeAt(d);
    if (E < 33 || E > 126)
      throw new Error(`Invalid prefix (${o})`);
    t = bech32Polymod(t) ^ E >> 5;
  }
  t = bech32Polymod(t);
  for (let d = 0; d < y; d++)
    t = bech32Polymod(t) ^ o.charCodeAt(d) & 31;
  for (let d of g)
    t = bech32Polymod(t) ^ d;
  for (let d = 0; d < 6; d++)
    t = bech32Polymod(t);
  return t ^= c, BECH_ALPHABET.encode(convertRadix2([t % powers[30]], 30, 5, !1));
}
// @__NO_SIDE_EFFECTS__
function genBech32(o) {
  const g = o === "bech32" ? 1 : 734539939, c = /* @__PURE__ */ radix2(5), y = c.decode, t = c.encode, d = unsafeWrapper(y);
  function E(F, M, U = 90) {
    astr("bech32.encode prefix", F), isBytes$2(M) && (M = Array.from(M)), anumArr("bech32.encode", M);
    const L = F.length;
    if (L === 0)
      throw new TypeError(`Invalid prefix length ${L}`);
    const H = L + 7 + M.length;
    if (U !== !1 && H > U)
      throw new TypeError(`Length ${H} exceeds limit ${U}`);
    const fe = F.toLowerCase(), ge = bechChecksum(fe, M, g);
    return `${fe}1${BECH_ALPHABET.encode(M)}${ge}`;
  }
  function B(F, M = 90) {
    astr("bech32.decode input", F);
    const U = F.length;
    if (U < 8 || M !== !1 && U > M)
      throw new TypeError(`invalid string length: ${U} (${F}). Expected (8..${M})`);
    const L = F.toLowerCase();
    if (F !== L && F !== F.toUpperCase())
      throw new Error("String must be lowercase or uppercase");
    const H = L.lastIndexOf("1");
    if (H === 0 || H === -1)
      throw new Error('Letter "1" must be present between prefix and data only');
    const fe = L.slice(0, H), ge = L.slice(H + 1);
    if (ge.length < 6)
      throw new Error("Data must be at least 6 characters long");
    const Ie = BECH_ALPHABET.decode(ge).slice(0, -6), Ee = bechChecksum(fe, Ie, g);
    if (!ge.endsWith(Ee))
      throw new Error(`Invalid checksum in ${F}: expected "${Ee}"`);
    return { prefix: fe, words: Ie };
  }
  const D = unsafeWrapper(B);
  function x(F) {
    const { prefix: M, words: U } = B(F, !1);
    return { prefix: M, words: U, bytes: y(U) };
  }
  function v(F, M) {
    return E(F, t(M));
  }
  return {
    encode: E,
    decode: B,
    encodeFromBytes: v,
    decodeToBytes: x,
    decodeUnsafe: D,
    fromWords: y,
    fromWordsUnsafe: d,
    toWords: t
  };
}
const bech32$1 = /* @__PURE__ */ genBech32("bech32"), bech32m = /* @__PURE__ */ genBech32("bech32m"), utf8$1 = {
  encode: (o) => new TextDecoder().decode(o),
  decode: (o) => new TextEncoder().encode(o)
}, hasHexBuiltin = typeof Uint8Array.from([]).toHex == "function" && typeof Uint8Array.fromHex == "function", hexBuiltin = {
  encode(o) {
    return abytes(o), o.toHex();
  },
  decode(o) {
    return astr("hex", o), Uint8Array.fromHex(o);
  }
}, hex$1 = hasHexBuiltin ? hexBuiltin : /* @__PURE__ */ chain(/* @__PURE__ */ radix2(4), /* @__PURE__ */ alphabet("0123456789abcdef"), /* @__PURE__ */ join(""), /* @__PURE__ */ normalize((o) => {
  if (typeof o != "string" || o.length % 2 !== 0)
    throw new TypeError(`hex.decode: expected string, got ${typeof o} with length ${o.length}`);
  return o.toLowerCase();
})), EMPTY = /* @__PURE__ */ new Uint8Array(), NULL = /* @__PURE__ */ new Uint8Array([0]);
function equalBytes$1(o, g) {
  if (o.length !== g.length)
    return !1;
  for (let c = 0; c < o.length; c++)
    if (o[c] !== g[c])
      return !1;
  return !0;
}
function isBytes$1(o) {
  return o instanceof Uint8Array || ArrayBuffer.isView(o) && o.constructor.name === "Uint8Array";
}
function concatBytes$1(...o) {
  let g = 0;
  for (let y = 0; y < o.length; y++) {
    const t = o[y];
    if (!isBytes$1(t))
      throw new Error("Uint8Array expected");
    g += t.length;
  }
  const c = new Uint8Array(g);
  for (let y = 0, t = 0; y < o.length; y++) {
    const d = o[y];
    c.set(d, t), t += d.length;
  }
  return c;
}
const createView = (o) => new DataView(o.buffer, o.byteOffset, o.byteLength);
function isPlainObject(o) {
  return Object.prototype.toString.call(o) === "[object Object]";
}
function isNum(o) {
  return Number.isSafeInteger(o);
}
const utils$2 = {
  equalBytes: equalBytes$1,
  isBytes: isBytes$1,
  concatBytes: concatBytes$1
}, lengthCoder = (o) => {
  if (o !== null && typeof o != "string" && !isCoder(o) && !isBytes$1(o) && !isNum(o))
    throw new Error(`lengthCoder: expected null | number | Uint8Array | CoderType, got ${o} (${typeof o})`);
  return {
    encodeStream(g, c) {
      if (o === null)
        return;
      if (isCoder(o))
        return o.encodeStream(g, c);
      let y;
      if (typeof o == "number" ? y = o : typeof o == "string" && (y = Path.resolve(g.stack, o)), typeof y == "bigint" && (y = Number(y)), y === void 0 || y !== c)
        throw g.err(`Wrong length: ${y} len=${o} exp=${c} (${typeof c})`);
    },
    decodeStream(g) {
      let c;
      if (isCoder(o) ? c = Number(o.decodeStream(g)) : typeof o == "number" ? c = o : typeof o == "string" && (c = Path.resolve(g.stack, o)), typeof c == "bigint" && (c = Number(c)), typeof c != "number")
        throw g.err(`Wrong length: ${c}`);
      return c;
    }
  };
}, Bitset = {
  BITS: 32,
  FULL_MASK: -1 >>> 0,
  // 1<<32 will overflow
  len: (o) => Math.ceil(o / 32),
  create: (o) => new Uint32Array(Bitset.len(o)),
  clean: (o) => o.fill(0),
  debug: (o) => Array.from(o).map((g) => (g >>> 0).toString(2).padStart(32, "0")),
  checkLen: (o, g) => {
    if (Bitset.len(g) !== o.length)
      throw new Error(`wrong length=${o.length}. Expected: ${Bitset.len(g)}`);
  },
  chunkLen: (o, g, c) => {
    if (g < 0)
      throw new Error(`wrong pos=${g}`);
    if (g + c > o)
      throw new Error(`wrong range=${g}/${c} of ${o}`);
  },
  set: (o, g, c, y = !0) => !y && (o[g] & c) !== 0 ? !1 : (o[g] |= c, !0),
  pos: (o, g) => ({
    chunk: Math.floor((o + g) / 32),
    mask: 1 << 32 - (o + g) % 32 - 1
  }),
  indices: (o, g, c = !1) => {
    Bitset.checkLen(o, g);
    const { FULL_MASK: y, BITS: t } = Bitset, d = t - g % t, E = d ? y >>> d << d : y, B = [];
    for (let D = 0; D < o.length; D++) {
      let x = o[D];
      if (c && (x = ~x), D === o.length - 1 && (x &= E), x !== 0)
        for (let v = 0; v < t; v++) {
          const F = 1 << t - v - 1;
          x & F && B.push(D * t + v);
        }
    }
    return B;
  },
  range: (o) => {
    const g = [];
    let c;
    for (const y of o)
      c === void 0 || y !== c.pos + c.length ? g.push(c = { pos: y, length: 1 }) : c.length += 1;
    return g;
  },
  rangeDebug: (o, g, c = !1) => `[${Bitset.range(Bitset.indices(o, g, c)).map((y) => `(${y.pos}/${y.length})`).join(", ")}]`,
  setRange: (o, g, c, y, t = !0) => {
    Bitset.chunkLen(g, c, y);
    const { FULL_MASK: d, BITS: E } = Bitset, B = c % E ? Math.floor(c / E) : void 0, D = c + y, x = D % E ? Math.floor(D / E) : void 0;
    if (B !== void 0 && B === x)
      return Bitset.set(o, B, d >>> E - y << E - y - c, t);
    if (B !== void 0 && !Bitset.set(o, B, d >>> c % E, t))
      return !1;
    const v = B !== void 0 ? B + 1 : c / E, F = x !== void 0 ? x : D / E;
    for (let M = v; M < F; M++)
      if (!Bitset.set(o, M, d, t))
        return !1;
    return !(x !== void 0 && B !== x && !Bitset.set(o, x, d << E - D % E, t));
  }
}, Path = {
  /**
   * Internal method for handling stack of paths (debug, errors, dynamic fields via path)
   * This is looks ugly (callback), but allows us to force stack cleaning by construction (.pop always after function).
   * Also, this makes impossible:
   * - pushing field when stack is empty
   * - pushing field inside of field (real bug)
   * NOTE: we don't want to do '.pop' on error!
   */
  pushObj: (o, g, c) => {
    const y = { obj: g };
    o.push(y), c((t, d) => {
      y.field = t, d(), y.field = void 0;
    }), o.pop();
  },
  path: (o) => {
    const g = [];
    for (const c of o)
      c.field !== void 0 && g.push(c.field);
    return g.join("/");
  },
  err: (o, g, c) => {
    const y = new Error(`${o}(${Path.path(g)}): ${typeof c == "string" ? c : c.message}`);
    return c instanceof Error && c.stack && (y.stack = c.stack), y;
  },
  resolve: (o, g) => {
    const c = g.split("/"), y = o.map((E) => E.obj);
    let t = 0;
    for (; t < c.length && c[t] === ".."; t++)
      y.pop();
    let d = y.pop();
    for (; t < c.length; t++) {
      if (!d || d[c[t]] === void 0)
        return;
      d = d[c[t]];
    }
    return d;
  }
};
class _Reader {
  constructor(g, c = {}, y = [], t = void 0, d = 0) {
    this.pos = 0, this.bitBuf = 0, this.bitPos = 0, this.data = g, this.opts = c, this.stack = y, this.parent = t, this.parentOffset = d, this.view = createView(g);
  }
  /** Internal method for pointers. */
  _enablePointers() {
    if (this.parent)
      return this.parent._enablePointers();
    this.bs || (this.bs = Bitset.create(this.data.length), Bitset.setRange(this.bs, this.data.length, 0, this.pos, this.opts.allowMultipleReads));
  }
  markBytesBS(g, c) {
    return this.parent ? this.parent.markBytesBS(this.parentOffset + g, c) : !c || !this.bs ? !0 : Bitset.setRange(this.bs, this.data.length, g, c, !1);
  }
  markBytes(g) {
    const c = this.pos;
    this.pos += g;
    const y = this.markBytesBS(c, g);
    if (!this.opts.allowMultipleReads && !y)
      throw this.err(`multiple read pos=${this.pos} len=${g}`);
    return y;
  }
  pushObj(g, c) {
    return Path.pushObj(this.stack, g, c);
  }
  readView(g, c) {
    if (!Number.isFinite(g))
      throw this.err(`readView: wrong length=${g}`);
    if (this.pos + g > this.data.length)
      throw this.err("readView: Unexpected end of buffer");
    const y = c(this.view, this.pos);
    return this.markBytes(g), y;
  }
  // read bytes by absolute offset
  absBytes(g) {
    if (g > this.data.length)
      throw new Error("Unexpected end of buffer");
    return this.data.subarray(g);
  }
  finish() {
    if (!this.opts.allowUnreadBytes) {
      if (this.bitPos)
        throw this.err(`${this.bitPos} bits left after unpack: ${hex$1.encode(this.data.slice(this.pos))}`);
      if (this.bs && !this.parent) {
        const g = Bitset.indices(this.bs, this.data.length, !0);
        if (g.length) {
          const c = Bitset.range(g).map(({ pos: y, length: t }) => `(${y}/${t})[${hex$1.encode(this.data.subarray(y, y + t))}]`).join(", ");
          throw this.err(`unread byte ranges: ${c} (total=${this.data.length})`);
        } else
          return;
      }
      if (!this.isEnd())
        throw this.err(`${this.leftBytes} bytes ${this.bitPos} bits left after unpack: ${hex$1.encode(this.data.slice(this.pos))}`);
    }
  }
  // User methods
  err(g) {
    return Path.err("Reader", this.stack, g);
  }
  offsetReader(g) {
    if (g > this.data.length)
      throw this.err("offsetReader: Unexpected end of buffer");
    return new _Reader(this.absBytes(g), this.opts, this.stack, this, g);
  }
  bytes(g, c = !1) {
    if (this.bitPos)
      throw this.err("readBytes: bitPos not empty");
    if (!Number.isFinite(g))
      throw this.err(`readBytes: wrong length=${g}`);
    if (this.pos + g > this.data.length)
      throw this.err("readBytes: Unexpected end of buffer");
    const y = this.data.subarray(this.pos, this.pos + g);
    return c || this.markBytes(g), y;
  }
  byte(g = !1) {
    if (this.bitPos)
      throw this.err("readByte: bitPos not empty");
    if (this.pos + 1 > this.data.length)
      throw this.err("readBytes: Unexpected end of buffer");
    const c = this.data[this.pos];
    return g || this.markBytes(1), c;
  }
  get leftBytes() {
    return this.data.length - this.pos;
  }
  get totalBytes() {
    return this.data.length;
  }
  isEnd() {
    return this.pos >= this.data.length && !this.bitPos;
  }
  // bits are read in BE mode (left to right): (0b1000_0000).readBits(1) == 1
  bits(g) {
    if (g > 32)
      throw this.err("BitReader: cannot read more than 32 bits in single call");
    let c = 0;
    for (; g; ) {
      this.bitPos || (this.bitBuf = this.byte(), this.bitPos = 8);
      const y = Math.min(g, this.bitPos);
      this.bitPos -= y, c = c << y | this.bitBuf >> this.bitPos & 2 ** y - 1, this.bitBuf &= 2 ** this.bitPos - 1, g -= y;
    }
    return c >>> 0;
  }
  find(g, c = this.pos) {
    if (!isBytes$1(g))
      throw this.err(`find: needle is not bytes! ${g}`);
    if (this.bitPos)
      throw this.err("findByte: bitPos not empty");
    if (!g.length)
      throw this.err("find: needle is empty");
    for (let y = c; (y = this.data.indexOf(g[0], y)) !== -1; y++) {
      if (y === -1 || this.data.length - y < g.length)
        return;
      if (equalBytes$1(g, this.data.subarray(y, y + g.length)))
        return y;
    }
  }
}
class _Writer {
  constructor(g = []) {
    this.pos = 0, this.buffers = [], this.ptrs = [], this.bitBuf = 0, this.bitPos = 0, this.viewBuf = new Uint8Array(8), this.finished = !1, this.stack = g, this.view = createView(this.viewBuf);
  }
  pushObj(g, c) {
    return Path.pushObj(this.stack, g, c);
  }
  writeView(g, c) {
    if (this.finished)
      throw this.err("buffer: finished");
    if (!isNum(g) || g > 8)
      throw new Error(`wrong writeView length=${g}`);
    c(this.view), this.bytes(this.viewBuf.slice(0, g)), this.viewBuf.fill(0);
  }
  // User methods
  err(g) {
    if (this.finished)
      throw this.err("buffer: finished");
    return Path.err("Reader", this.stack, g);
  }
  bytes(g) {
    if (this.finished)
      throw this.err("buffer: finished");
    if (this.bitPos)
      throw this.err("writeBytes: ends with non-empty bit buffer");
    this.buffers.push(g), this.pos += g.length;
  }
  byte(g) {
    if (this.finished)
      throw this.err("buffer: finished");
    if (this.bitPos)
      throw this.err("writeByte: ends with non-empty bit buffer");
    this.buffers.push(new Uint8Array([g])), this.pos++;
  }
  finish(g = !0) {
    if (this.finished)
      throw this.err("buffer: finished");
    if (this.bitPos)
      throw this.err("buffer: ends with non-empty bit buffer");
    const c = this.buffers.concat(this.ptrs.map((d) => d.buffer)), y = c.map((d) => d.length).reduce((d, E) => d + E, 0), t = new Uint8Array(y);
    for (let d = 0, E = 0; d < c.length; d++) {
      const B = c[d];
      t.set(B, E), E += B.length;
    }
    for (let d = this.pos, E = 0; E < this.ptrs.length; E++) {
      const B = this.ptrs[E];
      t.set(B.ptr.encode(d), B.pos), d += B.buffer.length;
    }
    if (g) {
      this.buffers = [];
      for (const d of this.ptrs)
        d.buffer.fill(0);
      this.ptrs = [], this.finished = !0, this.bitBuf = 0;
    }
    return t;
  }
  bits(g, c) {
    if (c > 32)
      throw this.err("writeBits: cannot write more than 32 bits in single call");
    if (g >= 2 ** c)
      throw this.err(`writeBits: value (${g}) >= 2**bits (${c})`);
    for (; c; ) {
      const y = Math.min(c, 8 - this.bitPos);
      this.bitBuf = this.bitBuf << y | g >> c - y, this.bitPos += y, c -= y, g &= 2 ** c - 1, this.bitPos === 8 && (this.bitPos = 0, this.buffers.push(new Uint8Array([this.bitBuf])), this.pos++);
    }
  }
}
const swapEndianness = (o) => Uint8Array.from(o).reverse();
function checkBounds(o, g, c) {
  if (c) {
    const y = 2n ** (g - 1n);
    if (o < -y || o >= y)
      throw new Error(`value out of signed bounds. Expected ${-y} <= ${o} < ${y}`);
  } else if (0n > o || o >= 2n ** g)
    throw new Error(`value out of unsigned bounds. Expected 0 <= ${o} < ${2n ** g}`);
}
function _wrap(o) {
  return {
    // NOTE: we cannot export validate here, since it is likely mistake.
    encodeStream: o.encodeStream,
    decodeStream: o.decodeStream,
    size: o.size,
    encode: (g) => {
      const c = new _Writer();
      return o.encodeStream(c, g), c.finish();
    },
    decode: (g, c = {}) => {
      const y = new _Reader(g, c), t = o.decodeStream(y);
      return y.finish(), t;
    }
  };
}
function validate(o, g) {
  if (!isCoder(o))
    throw new Error(`validate: invalid inner value ${o}`);
  if (typeof g != "function")
    throw new Error("validate: fn should be function");
  return _wrap({
    size: o.size,
    encodeStream: (c, y) => {
      let t;
      try {
        t = g(y);
      } catch (d) {
        throw c.err(d);
      }
      o.encodeStream(c, t);
    },
    decodeStream: (c) => {
      const y = o.decodeStream(c);
      try {
        return g(y);
      } catch (t) {
        throw c.err(t);
      }
    }
  });
}
const wrap = (o) => {
  const g = _wrap(o);
  return o.validate ? validate(g, o.validate) : g;
}, isBaseCoder = (o) => isPlainObject(o) && typeof o.decode == "function" && typeof o.encode == "function";
function isCoder(o) {
  return isPlainObject(o) && isBaseCoder(o) && typeof o.encodeStream == "function" && typeof o.decodeStream == "function" && (o.size === void 0 || isNum(o.size));
}
function dict() {
  return {
    encode: (o) => {
      if (!Array.isArray(o))
        throw new Error("array expected");
      const g = {};
      for (const c of o) {
        if (!Array.isArray(c) || c.length !== 2)
          throw new Error("array of two elements expected");
        const y = c[0], t = c[1];
        if (g[y] !== void 0)
          throw new Error(`key(${y}) appears twice in struct`);
        g[y] = t;
      }
      return g;
    },
    decode: (o) => {
      if (!isPlainObject(o))
        throw new Error(`expected plain object, got ${o}`);
      return Object.entries(o);
    }
  };
}
const numberBigint = {
  encode: (o) => {
    if (typeof o != "bigint")
      throw new Error(`expected bigint, got ${typeof o}`);
    if (o > BigInt(Number.MAX_SAFE_INTEGER))
      throw new Error(`element bigger than MAX_SAFE_INTEGER=${o}`);
    return Number(o);
  },
  decode: (o) => {
    if (!isNum(o))
      throw new Error("element is not a safe integer");
    return BigInt(o);
  }
};
function tsEnum(o) {
  if (!isPlainObject(o))
    throw new Error("plain object expected");
  return {
    encode: (g) => {
      if (!isNum(g) || !(g in o))
        throw new Error(`wrong value ${g}`);
      return o[g];
    },
    decode: (g) => {
      if (typeof g != "string")
        throw new Error(`wrong value ${typeof g}`);
      return o[g];
    }
  };
}
function decimal(o, g = !1) {
  if (!isNum(o))
    throw new Error(`decimal/precision: wrong value ${o}`);
  if (typeof g != "boolean")
    throw new Error(`decimal/round: expected boolean, got ${typeof g}`);
  const c = 10n ** BigInt(o);
  return {
    encode: (y) => {
      if (typeof y != "bigint")
        throw new Error(`expected bigint, got ${typeof y}`);
      let t = (y < 0n ? -y : y).toString(10), d = t.length - o;
      d < 0 && (t = t.padStart(t.length - d, "0"), d = 0);
      let E = t.length - 1;
      for (; E >= d && t[E] === "0"; E--)
        ;
      let B = t.slice(0, d), D = t.slice(d, E + 1);
      return B || (B = "0"), y < 0n && (B = "-" + B), D ? `${B}.${D}` : B;
    },
    decode: (y) => {
      if (typeof y != "string")
        throw new Error(`expected string, got ${typeof y}`);
      if (y === "-0")
        throw new Error("negative zero is not allowed");
      let t = !1;
      if (y.startsWith("-") && (t = !0, y = y.slice(1)), !/^(0|[1-9]\d*)(\.\d+)?$/.test(y))
        throw new Error(`wrong string value=${y}`);
      let d = y.indexOf(".");
      d = d === -1 ? y.length : d;
      const E = y.slice(0, d), B = y.slice(d + 1).replace(/0+$/, ""), D = BigInt(E) * c;
      if (!g && B.length > o)
        throw new Error(`fractional part cannot be represented with this precision (num=${y}, prec=${o})`);
      const x = Math.min(B.length, o), v = BigInt(B.slice(0, x)) * 10n ** BigInt(o - x), F = D + v;
      return t ? -F : F;
    }
  };
}
function match(o) {
  if (!Array.isArray(o))
    throw new Error(`expected array, got ${typeof o}`);
  for (const g of o)
    if (!isBaseCoder(g))
      throw new Error(`wrong base coder ${g}`);
  return {
    encode: (g) => {
      for (const c of o) {
        const y = c.encode(g);
        if (y !== void 0)
          return y;
      }
      throw new Error(`match/encode: cannot find match in ${g}`);
    },
    decode: (g) => {
      for (const c of o) {
        const y = c.decode(g);
        if (y !== void 0)
          return y;
      }
      throw new Error(`match/decode: cannot find match in ${g}`);
    }
  };
}
const reverse = (o) => {
  if (!isBaseCoder(o))
    throw new Error("BaseCoder expected");
  return { encode: o.decode, decode: o.encode };
}, coders = { dict, numberBigint, tsEnum, decimal, match, reverse }, bigint = (o, g = !1, c = !1, y = !0) => {
  if (!isNum(o))
    throw new Error(`bigint/size: wrong value ${o}`);
  if (typeof g != "boolean")
    throw new Error(`bigint/le: expected boolean, got ${typeof g}`);
  if (typeof c != "boolean")
    throw new Error(`bigint/signed: expected boolean, got ${typeof c}`);
  if (typeof y != "boolean")
    throw new Error(`bigint/sized: expected boolean, got ${typeof y}`);
  const t = BigInt(o), d = 2n ** (8n * t - 1n);
  return wrap({
    size: y ? o : void 0,
    encodeStream: (E, B) => {
      c && B < 0 && (B = B | d);
      const D = [];
      for (let v = 0; v < o; v++)
        D.push(Number(B & 255n)), B >>= 8n;
      let x = new Uint8Array(D).reverse();
      if (!y) {
        let v = 0;
        for (v = 0; v < x.length && x[v] === 0; v++)
          ;
        x = x.subarray(v);
      }
      E.bytes(g ? x.reverse() : x);
    },
    decodeStream: (E) => {
      const B = E.bytes(y ? o : Math.min(o, E.leftBytes)), D = g ? B : swapEndianness(B);
      let x = 0n;
      for (let v = 0; v < D.length; v++)
        x |= BigInt(D[v]) << 8n * BigInt(v);
      return c && x & d && (x = (x ^ d) - d), x;
    },
    validate: (E) => {
      if (typeof E != "bigint")
        throw new Error(`bigint: invalid value: ${E}`);
      return checkBounds(E, 8n * t, !!c), E;
    }
  });
}, U256BE = /* @__PURE__ */ bigint(32, !1), U64LE = /* @__PURE__ */ bigint(8, !0), I64LE = /* @__PURE__ */ bigint(8, !0, !0), view = (o, g) => wrap({
  size: o,
  encodeStream: (c, y) => c.writeView(o, (t) => g.write(t, y)),
  decodeStream: (c) => c.readView(o, g.read),
  validate: (c) => {
    if (typeof c != "number")
      throw new Error(`viewCoder: expected number, got ${typeof c}`);
    return g.validate && g.validate(c), c;
  }
}), intView = (o, g, c) => {
  const y = o * 8, t = 2 ** (y - 1), d = (D) => {
    if (!isNum(D))
      throw new Error(`sintView: value is not safe integer: ${D}`);
    if (D < -t || D >= t)
      throw new Error(`sintView: value out of bounds. Expected ${-t} <= ${D} < ${t}`);
  }, E = 2 ** y, B = (D) => {
    if (!isNum(D))
      throw new Error(`uintView: value is not safe integer: ${D}`);
    if (0 > D || D >= E)
      throw new Error(`uintView: value out of bounds. Expected 0 <= ${D} < ${E}`);
  };
  return view(o, {
    write: c.write,
    read: c.read,
    validate: g ? d : B
  });
}, U32LE = /* @__PURE__ */ intView(4, !1, {
  read: (o, g) => o.getUint32(g, !0),
  write: (o, g) => o.setUint32(0, g, !0)
}), U32BE = /* @__PURE__ */ intView(4, !1, {
  read: (o, g) => o.getUint32(g, !1),
  write: (o, g) => o.setUint32(0, g, !1)
}), I32LE = /* @__PURE__ */ intView(4, !0, {
  read: (o, g) => o.getInt32(g, !0),
  write: (o, g) => o.setInt32(0, g, !0)
}), U16LE = /* @__PURE__ */ intView(2, !1, {
  read: (o, g) => o.getUint16(g, !0),
  write: (o, g) => o.setUint16(0, g, !0)
}), U8 = /* @__PURE__ */ intView(1, !1, {
  read: (o, g) => o.getUint8(g),
  write: (o, g) => o.setUint8(0, g)
}), createBytes = (o, g = !1) => {
  if (typeof g != "boolean")
    throw new Error(`bytes/le: expected boolean, got ${typeof g}`);
  const c = lengthCoder(o), y = isBytes$1(o);
  return wrap({
    size: typeof o == "number" ? o : void 0,
    encodeStream: (t, d) => {
      y || c.encodeStream(t, d.length), t.bytes(g ? swapEndianness(d) : d), y && t.bytes(o);
    },
    decodeStream: (t) => {
      let d;
      if (y) {
        const E = t.find(o);
        if (!E)
          throw t.err("bytes: cannot find terminator");
        d = t.bytes(E - t.pos), t.bytes(o.length);
      } else
        d = t.bytes(o === null ? t.leftBytes : c.decodeStream(t));
      return g ? swapEndianness(d) : d;
    },
    validate: (t) => {
      if (!isBytes$1(t))
        throw new Error(`bytes: invalid value ${t}`);
      return t;
    }
  });
};
function prefix(o, g) {
  if (!isCoder(g))
    throw new Error(`prefix: invalid inner value ${g}`);
  return apply(createBytes(o), reverse(g));
}
const string = (o, g = !1) => validate(apply(createBytes(o, g), utf8$1), (c) => {
  if (typeof c != "string")
    throw new Error(`expected string, got ${typeof c}`);
  return c;
}), createHex = (o, g = { isLE: !1, with0x: !1 }) => {
  let c = apply(createBytes(o, g.isLE), hex$1);
  const y = g.with0x;
  if (typeof y != "boolean")
    throw new Error(`hex/with0x: expected boolean, got ${typeof y}`);
  return y && (c = apply(c, {
    encode: (t) => `0x${t}`,
    decode: (t) => {
      if (!t.startsWith("0x"))
        throw new Error("hex(with0x=true).encode input should start with 0x");
      return t.slice(2);
    }
  })), c;
};
function apply(o, g) {
  if (!isCoder(o))
    throw new Error(`apply: invalid inner value ${o}`);
  if (!isBaseCoder(g))
    throw new Error(`apply: invalid base value ${o}`);
  return wrap({
    size: o.size,
    encodeStream: (c, y) => {
      let t;
      try {
        t = g.decode(y);
      } catch (d) {
        throw c.err("" + d);
      }
      return o.encodeStream(c, t);
    },
    decodeStream: (c) => {
      const y = o.decodeStream(c);
      try {
        return g.encode(y);
      } catch (t) {
        throw c.err("" + t);
      }
    }
  });
}
const flag = (o, g = !1) => {
  if (!isBytes$1(o))
    throw new Error(`flag/flagValue: expected Uint8Array, got ${typeof o}`);
  if (typeof g != "boolean")
    throw new Error(`flag/xor: expected boolean, got ${typeof g}`);
  return wrap({
    size: o.length,
    encodeStream: (c, y) => {
      !!y !== g && c.bytes(o);
    },
    decodeStream: (c) => {
      let y = c.leftBytes >= o.length;
      return y && (y = equalBytes$1(c.bytes(o.length, !0), o), y && c.bytes(o.length)), y !== g;
    },
    validate: (c) => {
      if (c !== void 0 && typeof c != "boolean")
        throw new Error(`flag: expected boolean value or undefined, got ${typeof c}`);
      return c;
    }
  });
};
function flagged(o, g, c) {
  if (!isCoder(g))
    throw new Error(`flagged: invalid inner value ${g}`);
  return wrap({
    encodeStream: (y, t) => {
      Path.resolve(y.stack, o) && g.encodeStream(y, t);
    },
    decodeStream: (y) => {
      let t = !1;
      if (t = !!Path.resolve(y.stack, o), t)
        return g.decodeStream(y);
    }
  });
}
function magic(o, g, c = !0) {
  if (!isCoder(o))
    throw new Error(`magic: invalid inner value ${o}`);
  if (typeof c != "boolean")
    throw new Error(`magic: expected boolean, got ${typeof c}`);
  return wrap({
    size: o.size,
    encodeStream: (y, t) => o.encodeStream(y, g),
    decodeStream: (y) => {
      const t = o.decodeStream(y);
      if (c && typeof t != "object" && t !== g || isBytes$1(g) && !equalBytes$1(g, t))
        throw y.err(`magic: invalid value: ${t} !== ${g}`);
    },
    validate: (y) => {
      if (y !== void 0)
        throw new Error(`magic: wrong value=${typeof y}`);
      return y;
    }
  });
}
function sizeof(o) {
  let g = 0;
  for (const c of o) {
    if (c.size === void 0)
      return;
    if (!isNum(c.size))
      throw new Error(`sizeof: wrong element size=${g}`);
    g += c.size;
  }
  return g;
}
function struct(o) {
  if (!isPlainObject(o))
    throw new Error(`struct: expected plain object, got ${o}`);
  for (const g in o)
    if (!isCoder(o[g]))
      throw new Error(`struct: field ${g} is not CoderType`);
  return wrap({
    size: sizeof(Object.values(o)),
    encodeStream: (g, c) => {
      g.pushObj(c, (y) => {
        for (const t in o)
          y(t, () => o[t].encodeStream(g, c[t]));
      });
    },
    decodeStream: (g) => {
      const c = {};
      return g.pushObj(c, (y) => {
        for (const t in o)
          y(t, () => c[t] = o[t].decodeStream(g));
      }), c;
    },
    validate: (g) => {
      if (typeof g != "object" || g === null)
        throw new Error(`struct: invalid value ${g}`);
      return g;
    }
  });
}
function tuple(o) {
  if (!Array.isArray(o))
    throw new Error(`Packed.Tuple: got ${typeof o} instead of array`);
  for (let g = 0; g < o.length; g++)
    if (!isCoder(o[g]))
      throw new Error(`tuple: field ${g} is not CoderType`);
  return wrap({
    size: sizeof(o),
    encodeStream: (g, c) => {
      if (!Array.isArray(c))
        throw g.err(`tuple: invalid value ${c}`);
      g.pushObj(c, (y) => {
        for (let t = 0; t < o.length; t++)
          y(`${t}`, () => o[t].encodeStream(g, c[t]));
      });
    },
    decodeStream: (g) => {
      const c = [];
      return g.pushObj(c, (y) => {
        for (let t = 0; t < o.length; t++)
          y(`${t}`, () => c.push(o[t].decodeStream(g)));
      }), c;
    },
    validate: (g) => {
      if (!Array.isArray(g))
        throw new Error(`tuple: invalid value ${g}`);
      if (g.length !== o.length)
        throw new Error(`tuple: wrong length=${g.length}, expected ${o.length}`);
      return g;
    }
  });
}
function array(o, g) {
  if (!isCoder(g))
    throw new Error(`array: invalid inner value ${g}`);
  const c = lengthCoder(typeof o == "string" ? `../${o}` : o);
  return wrap({
    size: typeof o == "number" && g.size ? o * g.size : void 0,
    encodeStream: (y, t) => {
      const d = y;
      d.pushObj(t, (E) => {
        isBytes$1(o) || c.encodeStream(y, t.length);
        for (let B = 0; B < t.length; B++)
          E(`${B}`, () => {
            const D = t[B], x = y.pos;
            if (g.encodeStream(y, D), isBytes$1(o)) {
              if (o.length > d.pos - x)
                return;
              const v = d.finish(!1).subarray(x, d.pos);
              if (equalBytes$1(v.subarray(0, o.length), o))
                throw d.err(`array: inner element encoding same as separator. elm=${D} data=${v}`);
            }
          });
      }), isBytes$1(o) && y.bytes(o);
    },
    decodeStream: (y) => {
      const t = [];
      return y.pushObj(t, (d) => {
        if (o === null)
          for (let E = 0; !y.isEnd() && (d(`${E}`, () => t.push(g.decodeStream(y))), !(g.size && y.leftBytes < g.size)); E++)
            ;
        else if (isBytes$1(o))
          for (let E = 0; ; E++) {
            if (equalBytes$1(y.bytes(o.length, !0), o)) {
              y.bytes(o.length);
              break;
            }
            d(`${E}`, () => t.push(g.decodeStream(y)));
          }
        else {
          let E;
          d("arrayLen", () => E = c.decodeStream(y));
          for (let B = 0; B < E; B++)
            d(`${B}`, () => t.push(g.decodeStream(y)));
        }
      }), t;
    },
    validate: (y) => {
      if (!Array.isArray(y))
        throw new Error(`array: invalid value ${y}`);
      return y;
    }
  });
}
const Point = secp256k1.ProjectivePoint, CURVE_ORDER = secp256k1.CURVE.n, isBytes = utils$2.isBytes, concatBytes = utils$2.concatBytes, equalBytes = utils$2.equalBytes, hash160 = (o) => ripemd160(sha256(o)), sha256x2 = (...o) => sha256(sha256(concatBytes(...o))), pubSchnorr = schnorr.getPublicKey, pubECDSA = secp256k1.getPublicKey, hasLowR = (o) => o.r < CURVE_ORDER / 2n;
function signECDSA(o, g, c = !1) {
  let y = secp256k1.sign(o, g);
  if (c && !hasLowR(y)) {
    const t = new Uint8Array(32);
    let d = 0;
    for (; !hasLowR(y); )
      if (t.set(U32LE.encode(d++)), y = secp256k1.sign(o, g, { extraEntropy: t }), d > 4294967295)
        throw new Error("lowR counter overflow: report the error");
  }
  return y.toDERRawBytes();
}
const signSchnorr = schnorr.sign, tagSchnorr = schnorr.utils.taggedHash;
var PubT;
(function(o) {
  o[o.ecdsa = 0] = "ecdsa", o[o.schnorr = 1] = "schnorr";
})(PubT || (PubT = {}));
function validatePubkey(o, g) {
  const c = o.length;
  if (g === PubT.ecdsa) {
    if (c === 32)
      throw new Error("Expected non-Schnorr key");
    return Point.fromHex(o), o;
  } else if (g === PubT.schnorr) {
    if (c !== 32)
      throw new Error("Expected 32-byte Schnorr key");
    return schnorr.utils.lift_x(schnorr.utils.bytesToNumberBE(o)), o;
  } else
    throw new Error("Unknown key type");
}
function tapTweak(o, g) {
  const c = schnorr.utils, y = c.taggedHash("TapTweak", o, g), t = c.bytesToNumberBE(y);
  if (t >= CURVE_ORDER)
    throw new Error("tweak higher than curve order");
  return t;
}
function taprootTweakPrivKey(o, g = Uint8Array.of()) {
  const c = schnorr.utils, y = c.bytesToNumberBE(o), t = Point.fromPrivateKey(y), d = t.hasEvenY() ? y : c.mod(-y, CURVE_ORDER), E = c.pointToBytes(t), B = tapTweak(E, g);
  return c.numberToBytesBE(c.mod(d + B, CURVE_ORDER), 32);
}
function taprootTweakPubkey(o, g) {
  const c = schnorr.utils, y = tapTweak(o, g), d = c.lift_x(c.bytesToNumberBE(o)).add(Point.fromPrivateKey(y)), E = d.hasEvenY() ? 0 : 1;
  return [c.pointToBytes(d), E];
}
sha256(Point.BASE.toRawBytes(!1));
const NETWORK = {
  bech32: "bc",
  pubKeyHash: 0,
  scriptHash: 5,
  wif: 128
};
function compareBytes(o, g) {
  if (!isBytes(o) || !isBytes(g))
    throw new Error(`cmp: wrong type a=${typeof o} b=${typeof g}`);
  const c = Math.min(o.length, g.length);
  for (let y = 0; y < c; y++)
    if (o[y] != g[y])
      return Math.sign(o[y] - g[y]);
  return Math.sign(o.length - g.length);
}
var OP;
(function(o) {
  o[o.OP_0 = 0] = "OP_0", o[o.PUSHDATA1 = 76] = "PUSHDATA1", o[o.PUSHDATA2 = 77] = "PUSHDATA2", o[o.PUSHDATA4 = 78] = "PUSHDATA4", o[o["1NEGATE"] = 79] = "1NEGATE", o[o.RESERVED = 80] = "RESERVED", o[o.OP_1 = 81] = "OP_1", o[o.OP_2 = 82] = "OP_2", o[o.OP_3 = 83] = "OP_3", o[o.OP_4 = 84] = "OP_4", o[o.OP_5 = 85] = "OP_5", o[o.OP_6 = 86] = "OP_6", o[o.OP_7 = 87] = "OP_7", o[o.OP_8 = 88] = "OP_8", o[o.OP_9 = 89] = "OP_9", o[o.OP_10 = 90] = "OP_10", o[o.OP_11 = 91] = "OP_11", o[o.OP_12 = 92] = "OP_12", o[o.OP_13 = 93] = "OP_13", o[o.OP_14 = 94] = "OP_14", o[o.OP_15 = 95] = "OP_15", o[o.OP_16 = 96] = "OP_16", o[o.NOP = 97] = "NOP", o[o.VER = 98] = "VER", o[o.IF = 99] = "IF", o[o.NOTIF = 100] = "NOTIF", o[o.VERIF = 101] = "VERIF", o[o.VERNOTIF = 102] = "VERNOTIF", o[o.ELSE = 103] = "ELSE", o[o.ENDIF = 104] = "ENDIF", o[o.VERIFY = 105] = "VERIFY", o[o.RETURN = 106] = "RETURN", o[o.TOALTSTACK = 107] = "TOALTSTACK", o[o.FROMALTSTACK = 108] = "FROMALTSTACK", o[o["2DROP"] = 109] = "2DROP", o[o["2DUP"] = 110] = "2DUP", o[o["3DUP"] = 111] = "3DUP", o[o["2OVER"] = 112] = "2OVER", o[o["2ROT"] = 113] = "2ROT", o[o["2SWAP"] = 114] = "2SWAP", o[o.IFDUP = 115] = "IFDUP", o[o.DEPTH = 116] = "DEPTH", o[o.DROP = 117] = "DROP", o[o.DUP = 118] = "DUP", o[o.NIP = 119] = "NIP", o[o.OVER = 120] = "OVER", o[o.PICK = 121] = "PICK", o[o.ROLL = 122] = "ROLL", o[o.ROT = 123] = "ROT", o[o.SWAP = 124] = "SWAP", o[o.TUCK = 125] = "TUCK", o[o.CAT = 126] = "CAT", o[o.SUBSTR = 127] = "SUBSTR", o[o.LEFT = 128] = "LEFT", o[o.RIGHT = 129] = "RIGHT", o[o.SIZE = 130] = "SIZE", o[o.INVERT = 131] = "INVERT", o[o.AND = 132] = "AND", o[o.OR = 133] = "OR", o[o.XOR = 134] = "XOR", o[o.EQUAL = 135] = "EQUAL", o[o.EQUALVERIFY = 136] = "EQUALVERIFY", o[o.RESERVED1 = 137] = "RESERVED1", o[o.RESERVED2 = 138] = "RESERVED2", o[o["1ADD"] = 139] = "1ADD", o[o["1SUB"] = 140] = "1SUB", o[o["2MUL"] = 141] = "2MUL", o[o["2DIV"] = 142] = "2DIV", o[o.NEGATE = 143] = "NEGATE", o[o.ABS = 144] = "ABS", o[o.NOT = 145] = "NOT", o[o["0NOTEQUAL"] = 146] = "0NOTEQUAL", o[o.ADD = 147] = "ADD", o[o.SUB = 148] = "SUB", o[o.MUL = 149] = "MUL", o[o.DIV = 150] = "DIV", o[o.MOD = 151] = "MOD", o[o.LSHIFT = 152] = "LSHIFT", o[o.RSHIFT = 153] = "RSHIFT", o[o.BOOLAND = 154] = "BOOLAND", o[o.BOOLOR = 155] = "BOOLOR", o[o.NUMEQUAL = 156] = "NUMEQUAL", o[o.NUMEQUALVERIFY = 157] = "NUMEQUALVERIFY", o[o.NUMNOTEQUAL = 158] = "NUMNOTEQUAL", o[o.LESSTHAN = 159] = "LESSTHAN", o[o.GREATERTHAN = 160] = "GREATERTHAN", o[o.LESSTHANOREQUAL = 161] = "LESSTHANOREQUAL", o[o.GREATERTHANOREQUAL = 162] = "GREATERTHANOREQUAL", o[o.MIN = 163] = "MIN", o[o.MAX = 164] = "MAX", o[o.WITHIN = 165] = "WITHIN", o[o.RIPEMD160 = 166] = "RIPEMD160", o[o.SHA1 = 167] = "SHA1", o[o.SHA256 = 168] = "SHA256", o[o.HASH160 = 169] = "HASH160", o[o.HASH256 = 170] = "HASH256", o[o.CODESEPARATOR = 171] = "CODESEPARATOR", o[o.CHECKSIG = 172] = "CHECKSIG", o[o.CHECKSIGVERIFY = 173] = "CHECKSIGVERIFY", o[o.CHECKMULTISIG = 174] = "CHECKMULTISIG", o[o.CHECKMULTISIGVERIFY = 175] = "CHECKMULTISIGVERIFY", o[o.NOP1 = 176] = "NOP1", o[o.CHECKLOCKTIMEVERIFY = 177] = "CHECKLOCKTIMEVERIFY", o[o.CHECKSEQUENCEVERIFY = 178] = "CHECKSEQUENCEVERIFY", o[o.NOP4 = 179] = "NOP4", o[o.NOP5 = 180] = "NOP5", o[o.NOP6 = 181] = "NOP6", o[o.NOP7 = 182] = "NOP7", o[o.NOP8 = 183] = "NOP8", o[o.NOP9 = 184] = "NOP9", o[o.NOP10 = 185] = "NOP10", o[o.CHECKSIGADD = 186] = "CHECKSIGADD", o[o.INVALID = 255] = "INVALID";
})(OP || (OP = {}));
function ScriptNum(o = 6, g = !1) {
  return wrap({
    encodeStream: (c, y) => {
      if (y === 0n)
        return;
      const t = y < 0, d = BigInt(y), E = [];
      for (let B = t ? -d : d; B; B >>= 8n)
        E.push(Number(B & 0xffn));
      E[E.length - 1] >= 128 ? E.push(t ? 128 : 0) : t && (E[E.length - 1] |= 128), c.bytes(new Uint8Array(E));
    },
    decodeStream: (c) => {
      const y = c.leftBytes;
      if (y > o)
        throw new Error(`ScriptNum: number (${y}) bigger than limit=${o}`);
      if (y === 0)
        return 0n;
      if (g) {
        const E = c.bytes(y, !0);
        if ((E[E.length - 1] & 127) === 0 && (y <= 1 || (E[E.length - 2] & 128) === 0))
          throw new Error("Non-minimally encoded ScriptNum");
      }
      let t = 0, d = 0n;
      for (let E = 0; E < y; ++E)
        t = c.byte(), d |= BigInt(t) << 8n * BigInt(E);
      return t >= 128 && (d &= 2n ** BigInt(y * 8) - 1n >> 1n, d = -d), d;
    }
  });
}
function OpToNum(o, g = 4, c = !0) {
  if (typeof o == "number")
    return o;
  if (isBytes(o))
    try {
      const y = ScriptNum(g, c).decode(o);
      return y > Number.MAX_SAFE_INTEGER ? void 0 : Number(y);
    } catch {
      return;
    }
}
const Script = wrap({
  encodeStream: (o, g) => {
    for (let c of g) {
      if (typeof c == "string") {
        if (OP[c] === void 0)
          throw new Error(`Unknown opcode=${c}`);
        o.byte(OP[c]);
        continue;
      } else if (typeof c == "number") {
        if (c === 0) {
          o.byte(0);
          continue;
        } else if (1 <= c && c <= 16) {
          o.byte(OP.OP_1 - 1 + c);
          continue;
        }
      }
      if (typeof c == "number" && (c = ScriptNum().encode(BigInt(c))), !isBytes(c))
        throw new Error(`Wrong Script OP=${c} (${typeof c})`);
      const y = c.length;
      y < OP.PUSHDATA1 ? o.byte(y) : y <= 255 ? (o.byte(OP.PUSHDATA1), o.byte(y)) : y <= 65535 ? (o.byte(OP.PUSHDATA2), o.bytes(U16LE.encode(y))) : (o.byte(OP.PUSHDATA4), o.bytes(U32LE.encode(y))), o.bytes(c);
    }
  },
  decodeStream: (o) => {
    const g = [];
    for (; !o.isEnd(); ) {
      const c = o.byte();
      if (OP.OP_0 < c && c <= OP.PUSHDATA4) {
        let y;
        if (c < OP.PUSHDATA1)
          y = c;
        else if (c === OP.PUSHDATA1)
          y = U8.decodeStream(o);
        else if (c === OP.PUSHDATA2)
          y = U16LE.decodeStream(o);
        else if (c === OP.PUSHDATA4)
          y = U32LE.decodeStream(o);
        else
          throw new Error("Should be not possible");
        g.push(o.bytes(y));
      } else if (c === 0)
        g.push(0);
      else if (OP.OP_1 <= c && c <= OP.OP_16)
        g.push(c - (OP.OP_1 - 1));
      else {
        const y = OP[c];
        if (y === void 0)
          throw new Error(`Unknown opcode=${c.toString(16)}`);
        g.push(y);
      }
    }
    return g;
  }
}), CSLimits = {
  253: [253, 2, 253n, 65535n],
  254: [254, 4, 65536n, 4294967295n],
  255: [255, 8, 4294967296n, 18446744073709551615n]
}, CompactSize = wrap({
  encodeStream: (o, g) => {
    if (typeof g == "number" && (g = BigInt(g)), 0n <= g && g <= 252n)
      return o.byte(Number(g));
    for (const [c, y, t, d] of Object.values(CSLimits))
      if (!(t > g || g > d)) {
        o.byte(c);
        for (let E = 0; E < y; E++)
          o.byte(Number(g >> 8n * BigInt(E) & 0xffn));
        return;
      }
    throw o.err(`VarInt too big: ${g}`);
  },
  decodeStream: (o) => {
    const g = o.byte();
    if (g <= 252)
      return BigInt(g);
    const [c, y, t] = CSLimits[g];
    let d = 0n;
    for (let E = 0; E < y; E++)
      d |= BigInt(o.byte()) << 8n * BigInt(E);
    if (d < t)
      throw o.err(`Wrong CompactSize(${8 * y})`);
    return d;
  }
}), CompactSizeLen = apply(CompactSize, coders.numberBigint), VarBytes = createBytes(CompactSize), RawWitness = array(CompactSizeLen, VarBytes), BTCArray = (o) => array(CompactSize, o), RawInput = struct({
  txid: createBytes(32, !0),
  // hash(prev_tx),
  index: U32LE,
  // output number of previous tx
  finalScriptSig: VarBytes,
  // btc merges input and output script, executes it. If ok = tx passes
  sequence: U32LE
  // ?
}), RawOutput = struct({ amount: U64LE, script: VarBytes }), _RawTx = struct({
  version: I32LE,
  segwitFlag: flag(new Uint8Array([0, 1])),
  inputs: BTCArray(RawInput),
  outputs: BTCArray(RawOutput),
  witnesses: flagged("segwitFlag", array("inputs/length", RawWitness)),
  // < 500000000	Block number at which this transaction is unlocked
  // >= 500000000	UNIX timestamp at which this transaction is unlocked
  // Handled as part of PSBTv2
  lockTime: U32LE
});
function validateRawTx(o) {
  if (o.segwitFlag && o.witnesses && !o.witnesses.length)
    throw new Error("Segwit flag with empty witnesses array");
  return o;
}
const RawTx = validate(_RawTx, validateRawTx), RawOldTx = struct({
  version: I32LE,
  inputs: BTCArray(RawInput),
  outputs: BTCArray(RawOutput),
  lockTime: U32LE
}), PubKeyECDSA = validate(createBytes(null), (o) => validatePubkey(o, PubT.ecdsa)), PubKeySchnorr = validate(createBytes(32), (o) => validatePubkey(o, PubT.schnorr)), SignatureSchnorr = validate(createBytes(null), (o) => {
  if (o.length !== 64 && o.length !== 65)
    throw new Error("Schnorr signature should be 64 or 65 bytes long");
  return o;
}), BIP32Der = struct({
  fingerprint: U32BE,
  path: array(null, U32LE)
}), TaprootBIP32Der = struct({
  hashes: array(CompactSizeLen, createBytes(32)),
  der: BIP32Der
}), GlobalXPUB = createBytes(78), tapScriptSigKey = struct({ pubKey: PubKeySchnorr, leafHash: createBytes(32) }), _TaprootControlBlock = struct({
  version: U8,
  // With parity :(
  internalKey: createBytes(32),
  merklePath: array(null, createBytes(32))
}), TaprootControlBlock = validate(_TaprootControlBlock, (o) => {
  if (o.merklePath.length > 128)
    throw new Error("TaprootControlBlock: merklePath should be of length 0..128 (inclusive)");
  return o;
}), tapTree = array(null, struct({
  depth: U8,
  version: U8,
  script: VarBytes
})), BytesInf = createBytes(null), Bytes20 = createBytes(20), Bytes32 = createBytes(32), PSBTGlobal = {
  unsignedTx: [0, !1, RawOldTx, [0], [0], !1],
  xpub: [1, GlobalXPUB, BIP32Der, [], [0, 2], !1],
  txVersion: [2, !1, U32LE, [2], [2], !1],
  fallbackLocktime: [3, !1, U32LE, [], [2], !1],
  inputCount: [4, !1, CompactSizeLen, [2], [2], !1],
  outputCount: [5, !1, CompactSizeLen, [2], [2], !1],
  txModifiable: [6, !1, U8, [], [2], !1],
  // TODO: bitfield
  version: [251, !1, U32LE, [], [0, 2], !1],
  proprietary: [252, BytesInf, BytesInf, [], [0, 2], !1]
}, PSBTInput = {
  nonWitnessUtxo: [0, !1, RawTx, [], [0, 2], !1],
  witnessUtxo: [1, !1, RawOutput, [], [0, 2], !1],
  partialSig: [2, PubKeyECDSA, BytesInf, [], [0, 2], !1],
  sighashType: [3, !1, U32LE, [], [0, 2], !1],
  redeemScript: [4, !1, BytesInf, [], [0, 2], !1],
  witnessScript: [5, !1, BytesInf, [], [0, 2], !1],
  bip32Derivation: [6, PubKeyECDSA, BIP32Der, [], [0, 2], !1],
  finalScriptSig: [7, !1, BytesInf, [], [0, 2], !1],
  finalScriptWitness: [8, !1, RawWitness, [], [0, 2], !1],
  porCommitment: [9, !1, BytesInf, [], [0, 2], !1],
  ripemd160: [10, Bytes20, BytesInf, [], [0, 2], !1],
  sha256: [11, Bytes32, BytesInf, [], [0, 2], !1],
  hash160: [12, Bytes20, BytesInf, [], [0, 2], !1],
  hash256: [13, Bytes32, BytesInf, [], [0, 2], !1],
  txid: [14, !1, Bytes32, [2], [2], !0],
  index: [15, !1, U32LE, [2], [2], !0],
  sequence: [16, !1, U32LE, [], [2], !0],
  requiredTimeLocktime: [17, !1, U32LE, [], [2], !1],
  requiredHeightLocktime: [18, !1, U32LE, [], [2], !1],
  tapKeySig: [19, !1, SignatureSchnorr, [], [0, 2], !1],
  tapScriptSig: [20, tapScriptSigKey, SignatureSchnorr, [], [0, 2], !1],
  tapLeafScript: [21, TaprootControlBlock, BytesInf, [], [0, 2], !1],
  tapBip32Derivation: [22, Bytes32, TaprootBIP32Der, [], [0, 2], !1],
  tapInternalKey: [23, !1, PubKeySchnorr, [], [0, 2], !1],
  tapMerkleRoot: [24, !1, Bytes32, [], [0, 2], !1],
  proprietary: [252, BytesInf, BytesInf, [], [0, 2], !1]
}, PSBTInputFinalKeys = [
  "txid",
  "sequence",
  "index",
  "witnessUtxo",
  "nonWitnessUtxo",
  "finalScriptSig",
  "finalScriptWitness",
  "unknown"
], PSBTInputUnsignedKeys = [
  "partialSig",
  "finalScriptSig",
  "finalScriptWitness",
  "tapKeySig",
  "tapScriptSig"
], PSBTOutput = {
  redeemScript: [0, !1, BytesInf, [], [0, 2], !1],
  witnessScript: [1, !1, BytesInf, [], [0, 2], !1],
  bip32Derivation: [2, PubKeyECDSA, BIP32Der, [], [0, 2], !1],
  amount: [3, !1, I64LE, [2], [2], !0],
  script: [4, !1, BytesInf, [2], [2], !0],
  tapInternalKey: [5, !1, PubKeySchnorr, [], [0, 2], !1],
  tapTree: [6, !1, tapTree, [], [0, 2], !1],
  tapBip32Derivation: [7, PubKeySchnorr, TaprootBIP32Der, [], [0, 2], !1],
  proprietary: [252, BytesInf, BytesInf, [], [0, 2], !1]
}, PSBTOutputUnsignedKeys = [], PSBTKeyPair = array(NULL, struct({
  //  <key> := <keylen> <keytype> <keydata> WHERE keylen = len(keytype)+len(keydata)
  key: prefix(CompactSizeLen, struct({ type: CompactSizeLen, key: createBytes(null) })),
  //  <value> := <valuelen> <valuedata>
  value: createBytes(CompactSizeLen)
}));
function PSBTKeyInfo(o) {
  const [g, c, y, t, d, E] = o;
  return { type: g, kc: c, vc: y, reqInc: t, allowInc: d, silentIgnore: E };
}
struct({ type: CompactSizeLen, key: createBytes(null) });
function PSBTKeyMap(o) {
  const g = {};
  for (const c in o) {
    const [y, t, d] = o[c];
    g[y] = [c, t, d];
  }
  return wrap({
    encodeStream: (c, y) => {
      let t = [];
      for (const d in o) {
        const E = y[d];
        if (E === void 0)
          continue;
        const [B, D, x] = o[d];
        if (!D)
          t.push({ key: { type: B, key: EMPTY }, value: x.encode(E) });
        else {
          const v = E.map(([F, M]) => [
            D.encode(F),
            x.encode(M)
          ]);
          v.sort((F, M) => compareBytes(F[0], M[0]));
          for (const [F, M] of v)
            t.push({ key: { key: F, type: B }, value: M });
        }
      }
      if (y.unknown) {
        y.unknown.sort((d, E) => compareBytes(d[0].key, E[0].key));
        for (const [d, E] of y.unknown)
          t.push({ key: d, value: E });
      }
      PSBTKeyPair.encodeStream(c, t);
    },
    decodeStream: (c) => {
      const y = PSBTKeyPair.decodeStream(c), t = {}, d = {};
      for (const E of y) {
        let B = "unknown", D = E.key.key, x = E.value;
        if (g[E.key.type]) {
          const [v, F, M] = g[E.key.type];
          if (B = v, !F && D.length)
            throw new Error(`PSBT: Non-empty key for ${B} (key=${hex$1.encode(D)} value=${hex$1.encode(x)}`);
          if (D = F ? F.decode(D) : void 0, x = M.decode(x), !F) {
            if (t[B])
              throw new Error(`PSBT: Same keys: ${B} (key=${D} value=${x})`);
            t[B] = x, d[B] = !0;
            continue;
          }
        } else
          D = { type: E.key.type, key: E.key.key };
        if (d[B])
          throw new Error(`PSBT: Key type with empty key and no key=${B} val=${x}`);
        t[B] || (t[B] = []), t[B].push([D, x]);
      }
      return t;
    }
  });
}
const PSBTInputCoder = validate(PSBTKeyMap(PSBTInput), (o) => {
  if (o.finalScriptWitness && !o.finalScriptWitness.length)
    throw new Error("validateInput: empty finalScriptWitness");
  if (o.partialSig && !o.partialSig.length)
    throw new Error("Empty partialSig");
  if (o.partialSig)
    for (const [g] of o.partialSig)
      validatePubkey(g, PubT.ecdsa);
  if (o.bip32Derivation)
    for (const [g] of o.bip32Derivation)
      validatePubkey(g, PubT.ecdsa);
  if (o.requiredTimeLocktime !== void 0 && o.requiredTimeLocktime < 5e8)
    throw new Error(`validateInput: wrong timeLocktime=${o.requiredTimeLocktime}`);
  if (o.requiredHeightLocktime !== void 0 && (o.requiredHeightLocktime <= 0 || o.requiredHeightLocktime >= 5e8))
    throw new Error(`validateInput: wrong heighLocktime=${o.requiredHeightLocktime}`);
  if (o.tapLeafScript)
    for (const [g, c] of o.tapLeafScript) {
      if ((g.version & 254) !== c[c.length - 1])
        throw new Error("validateInput: tapLeafScript version mimatch");
      if (c[c.length - 1] & 1)
        throw new Error("validateInput: tapLeafScript version has parity bit!");
    }
  return o;
}), PSBTOutputCoder = validate(PSBTKeyMap(PSBTOutput), (o) => {
  if (o.bip32Derivation)
    for (const [g] of o.bip32Derivation)
      validatePubkey(g, PubT.ecdsa);
  return o;
}), PSBTGlobalCoder = validate(PSBTKeyMap(PSBTGlobal), (o) => {
  if ((o.version || 0) === 0) {
    if (!o.unsignedTx)
      throw new Error("PSBTv0: missing unsignedTx");
    for (const c of o.unsignedTx.inputs)
      if (c.finalScriptSig && c.finalScriptSig.length)
        throw new Error("PSBTv0: input scriptSig found in unsignedTx");
  }
  return o;
}), _RawPSBTV0 = struct({
  magic: magic(string(new Uint8Array([255])), "psbt"),
  global: PSBTGlobalCoder,
  inputs: array("global/unsignedTx/inputs/length", PSBTInputCoder),
  outputs: array(null, PSBTOutputCoder)
}), _RawPSBTV2 = struct({
  magic: magic(string(new Uint8Array([255])), "psbt"),
  global: PSBTGlobalCoder,
  inputs: array("global/inputCount", PSBTInputCoder),
  outputs: array("global/outputCount", PSBTOutputCoder)
});
struct({
  magic: magic(string(new Uint8Array([255])), "psbt"),
  items: array(null, apply(array(NULL, tuple([createHex(CompactSizeLen), createBytes(CompactSize)])), coders.dict()))
});
function validatePSBTFields(o, g, c) {
  for (const y in c) {
    if (y === "unknown" || !g[y])
      continue;
    const { allowInc: t } = PSBTKeyInfo(g[y]);
    if (!t.includes(o))
      throw new Error(`PSBTv${o}: field ${y} is not allowed`);
  }
  for (const y in g) {
    const { reqInc: t } = PSBTKeyInfo(g[y]);
    if (t.includes(o) && c[y] === void 0)
      throw new Error(`PSBTv${o}: missing required field ${y}`);
  }
}
function cleanPSBTFields(o, g, c) {
  const y = {};
  for (const t in c) {
    const d = t;
    if (d !== "unknown") {
      if (!g[d])
        continue;
      const { allowInc: E, silentIgnore: B } = PSBTKeyInfo(g[d]);
      if (!E.includes(o)) {
        if (B)
          continue;
        throw new Error(`Failed to serialize in PSBTv${o}: ${d} but versions allows inclusion=${E}`);
      }
    }
    y[d] = c[d];
  }
  return y;
}
function validatePSBT(o) {
  const g = o && o.global && o.global.version || 0;
  validatePSBTFields(g, PSBTGlobal, o.global);
  for (const E of o.inputs)
    validatePSBTFields(g, PSBTInput, E);
  for (const E of o.outputs)
    validatePSBTFields(g, PSBTOutput, E);
  const c = g ? o.global.inputCount : o.global.unsignedTx.inputs.length;
  if (o.inputs.length < c)
    throw new Error("Not enough inputs");
  const y = o.inputs.slice(c);
  if (y.length > 1 || y.length && Object.keys(y[0]).length)
    throw new Error(`Unexpected inputs left in tx=${y}`);
  const t = g ? o.global.outputCount : o.global.unsignedTx.outputs.length;
  if (o.outputs.length < t)
    throw new Error("Not outputs inputs");
  const d = o.outputs.slice(t);
  if (d.length > 1 || d.length && Object.keys(d[0]).length)
    throw new Error(`Unexpected outputs left in tx=${d}`);
  return o;
}
function mergeKeyMap(o, g, c, y, t) {
  const d = { ...c, ...g };
  for (const E in o) {
    const B = E, [D, x, v] = o[B], F = y && !y.includes(E);
    if (g[E] === void 0 && E in g) {
      if (F)
        throw new Error(`Cannot remove signed field=${E}`);
      delete d[E];
    } else if (x) {
      const M = c && c[E] ? c[E] : [];
      let U = g[B];
      if (U) {
        if (!Array.isArray(U))
          throw new Error(`keyMap(${E}): KV pairs should be [k, v][]`);
        U = U.map((fe) => {
          if (fe.length !== 2)
            throw new Error(`keyMap(${E}): KV pairs should be [k, v][]`);
          return [
            typeof fe[0] == "string" ? x.decode(hex$1.decode(fe[0])) : fe[0],
            typeof fe[1] == "string" ? v.decode(hex$1.decode(fe[1])) : fe[1]
          ];
        });
        const L = {}, H = (fe, ge, Ie) => {
          if (L[fe] === void 0) {
            L[fe] = [ge, Ie];
            return;
          }
          const Ee = hex$1.encode(v.encode(L[fe][1])), Se = hex$1.encode(v.encode(Ie));
          if (Ee !== Se)
            throw new Error(`keyMap(${B}): same key=${fe} oldVal=${Ee} newVal=${Se}`);
        };
        for (const [fe, ge] of M) {
          const Ie = hex$1.encode(x.encode(fe));
          H(Ie, fe, ge);
        }
        for (const [fe, ge] of U) {
          const Ie = hex$1.encode(x.encode(fe));
          if (ge === void 0) {
            if (F)
              throw new Error(`Cannot remove signed field=${B}/${fe}`);
            delete L[Ie];
          } else
            H(Ie, fe, ge);
        }
        d[B] = Object.values(L);
      }
    } else if (typeof d[E] == "string")
      d[E] = v.decode(hex$1.decode(d[E]));
    else if (F && E in g && c && c[E] !== void 0 && !equalBytes(v.encode(g[E]), v.encode(c[E])))
      throw new Error(`Cannot change signed field=${E}`);
  }
  for (const E in d)
    if (!o[E]) {
      if (t && E === "unknown")
        continue;
      delete d[E];
    }
  return d;
}
const RawPSBTV0 = validate(_RawPSBTV0, validatePSBT), RawPSBTV2 = validate(_RawPSBTV2, validatePSBT), OutP2A = {
  encode(o) {
    if (!(o.length !== 2 || o[0] !== 1 || !isBytes(o[1]) || hex$1.encode(o[1]) !== "4e73"))
      return { type: "p2a", script: Script.encode(o) };
  },
  decode: (o) => {
    if (o.type === "p2a")
      return [1, hex$1.decode("4e73")];
  }
};
function isValidPubkey(o, g) {
  try {
    return validatePubkey(o, g), !0;
  } catch {
    return !1;
  }
}
const OutPK = {
  encode(o) {
    if (!(o.length !== 2 || !isBytes(o[0]) || !isValidPubkey(o[0], PubT.ecdsa) || o[1] !== "CHECKSIG"))
      return { type: "pk", pubkey: o[0] };
  },
  decode: (o) => o.type === "pk" ? [o.pubkey, "CHECKSIG"] : void 0
}, OutPKH = {
  encode(o) {
    if (!(o.length !== 5 || o[0] !== "DUP" || o[1] !== "HASH160" || !isBytes(o[2])) && !(o[3] !== "EQUALVERIFY" || o[4] !== "CHECKSIG"))
      return { type: "pkh", hash: o[2] };
  },
  decode: (o) => o.type === "pkh" ? ["DUP", "HASH160", o.hash, "EQUALVERIFY", "CHECKSIG"] : void 0
}, OutSH = {
  encode(o) {
    if (!(o.length !== 3 || o[0] !== "HASH160" || !isBytes(o[1]) || o[2] !== "EQUAL"))
      return { type: "sh", hash: o[1] };
  },
  decode: (o) => o.type === "sh" ? ["HASH160", o.hash, "EQUAL"] : void 0
}, OutWSH = {
  encode(o) {
    if (!(o.length !== 2 || o[0] !== 0 || !isBytes(o[1])) && o[1].length === 32)
      return { type: "wsh", hash: o[1] };
  },
  decode: (o) => o.type === "wsh" ? [0, o.hash] : void 0
}, OutWPKH = {
  encode(o) {
    if (!(o.length !== 2 || o[0] !== 0 || !isBytes(o[1])) && o[1].length === 20)
      return { type: "wpkh", hash: o[1] };
  },
  decode: (o) => o.type === "wpkh" ? [0, o.hash] : void 0
}, OutMS = {
  encode(o) {
    const g = o.length - 1;
    if (o[g] !== "CHECKMULTISIG")
      return;
    const c = o[0], y = o[g - 1];
    if (typeof c != "number" || typeof y != "number")
      return;
    const t = o.slice(1, -2);
    if (y === t.length) {
      for (const d of t)
        if (!isBytes(d))
          return;
      return { type: "ms", m: c, pubkeys: t };
    }
  },
  // checkmultisig(n, ..pubkeys, m)
  decode: (o) => o.type === "ms" ? [o.m, ...o.pubkeys, o.pubkeys.length, "CHECKMULTISIG"] : void 0
}, OutTR = {
  encode(o) {
    if (!(o.length !== 2 || o[0] !== 1 || !isBytes(o[1])))
      return { type: "tr", pubkey: o[1] };
  },
  decode: (o) => o.type === "tr" ? [1, o.pubkey] : void 0
}, OutTRNS = {
  encode(o) {
    const g = o.length - 1;
    if (o[g] !== "CHECKSIG")
      return;
    const c = [];
    for (let y = 0; y < g; y++) {
      const t = o[y];
      if (y & 1) {
        if (t !== "CHECKSIGVERIFY" || y === g - 1)
          return;
        continue;
      }
      if (!isBytes(t))
        return;
      c.push(t);
    }
    return { type: "tr_ns", pubkeys: c };
  },
  decode: (o) => {
    if (o.type !== "tr_ns")
      return;
    const g = [];
    for (let c = 0; c < o.pubkeys.length - 1; c++)
      g.push(o.pubkeys[c], "CHECKSIGVERIFY");
    return g.push(o.pubkeys[o.pubkeys.length - 1], "CHECKSIG"), g;
  }
}, OutTRMS = {
  encode(o) {
    const g = o.length - 1;
    if (o[g] !== "NUMEQUAL" || o[1] !== "CHECKSIG")
      return;
    const c = [], y = OpToNum(o[g - 1]);
    if (typeof y == "number") {
      for (let t = 0; t < g - 1; t++) {
        const d = o[t];
        if (t & 1) {
          if (d !== (t === 1 ? "CHECKSIG" : "CHECKSIGADD"))
            throw new Error("OutScript.encode/tr_ms: wrong element");
          continue;
        }
        if (!isBytes(d))
          throw new Error("OutScript.encode/tr_ms: wrong key element");
        c.push(d);
      }
      return { type: "tr_ms", pubkeys: c, m: y };
    }
  },
  decode: (o) => {
    if (o.type !== "tr_ms")
      return;
    const g = [o.pubkeys[0], "CHECKSIG"];
    for (let c = 1; c < o.pubkeys.length; c++)
      g.push(o.pubkeys[c], "CHECKSIGADD");
    return g.push(o.m, "NUMEQUAL"), g;
  }
}, OutUnknown = {
  encode(o) {
    return { type: "unknown", script: Script.encode(o) };
  },
  decode: (o) => o.type === "unknown" ? Script.decode(o.script) : void 0
}, OutScripts = [
  OutP2A,
  OutPK,
  OutPKH,
  OutSH,
  OutWSH,
  OutWPKH,
  OutMS,
  OutTR,
  OutTRNS,
  OutTRMS,
  OutUnknown
], _OutScript = apply(Script, coders.match(OutScripts)), OutScript = validate(_OutScript, (o) => {
  if (o.type === "pk" && !isValidPubkey(o.pubkey, PubT.ecdsa))
    throw new Error("OutScript/pk: wrong key");
  if ((o.type === "pkh" || o.type === "sh" || o.type === "wpkh") && (!isBytes(o.hash) || o.hash.length !== 20))
    throw new Error(`OutScript/${o.type}: wrong hash`);
  if (o.type === "wsh" && (!isBytes(o.hash) || o.hash.length !== 32))
    throw new Error("OutScript/wsh: wrong hash");
  if (o.type === "tr" && (!isBytes(o.pubkey) || !isValidPubkey(o.pubkey, PubT.schnorr)))
    throw new Error("OutScript/tr: wrong taproot public key");
  if ((o.type === "ms" || o.type === "tr_ns" || o.type === "tr_ms") && !Array.isArray(o.pubkeys))
    throw new Error("OutScript/multisig: wrong pubkeys array");
  if (o.type === "ms") {
    const g = o.pubkeys.length;
    for (const c of o.pubkeys)
      if (!isValidPubkey(c, PubT.ecdsa))
        throw new Error("OutScript/multisig: wrong pubkey");
    if (o.m <= 0 || g > 16 || o.m > g)
      throw new Error("OutScript/multisig: invalid params");
  }
  if (o.type === "tr_ns" || o.type === "tr_ms") {
    for (const g of o.pubkeys)
      if (!isValidPubkey(g, PubT.schnorr))
        throw new Error(`OutScript/${o.type}: wrong pubkey`);
  }
  if (o.type === "tr_ms") {
    const g = o.pubkeys.length;
    if (o.m <= 0 || g > 999 || o.m > g)
      throw new Error("OutScript/tr_ms: invalid params");
  }
  return o;
});
function checkWSH(o, g) {
  if (!equalBytes(o.hash, sha256(g)))
    throw new Error("checkScript: wsh wrong witnessScript hash");
  const c = OutScript.decode(g);
  if (c.type === "tr" || c.type === "tr_ns" || c.type === "tr_ms")
    throw new Error(`checkScript: P2${c.type} cannot be wrapped in P2SH`);
  if (c.type === "wpkh" || c.type === "sh")
    throw new Error(`checkScript: P2${c.type} cannot be wrapped in P2WSH`);
}
function checkScript(o, g, c) {
  if (o) {
    const y = OutScript.decode(o);
    if (y.type === "tr_ns" || y.type === "tr_ms" || y.type === "ms" || y.type == "pk")
      throw new Error(`checkScript: non-wrapped ${y.type}`);
    if (y.type === "sh" && g) {
      if (!equalBytes(y.hash, hash160(g)))
        throw new Error("checkScript: sh wrong redeemScript hash");
      const t = OutScript.decode(g);
      if (t.type === "tr" || t.type === "tr_ns" || t.type === "tr_ms")
        throw new Error(`checkScript: P2${t.type} cannot be wrapped in P2SH`);
      if (t.type === "sh")
        throw new Error("checkScript: P2SH cannot be wrapped in P2SH");
    }
    y.type === "wsh" && c && checkWSH(y, c);
  }
  if (g) {
    const y = OutScript.decode(g);
    y.type === "wsh" && c && checkWSH(y, c);
  }
}
const TAP_LEAF_VERSION = 192, tapLeafHash = (o, g = TAP_LEAF_VERSION) => tagSchnorr("TapLeaf", new Uint8Array([g]), VarBytes.encode(o)), base58check = createBase58check(sha256);
function validateWitness(o, g) {
  if (g.length < 2 || g.length > 40)
    throw new Error("Witness: invalid length");
  if (o > 16)
    throw new Error("Witness: invalid version");
  if (o === 0 && !(g.length === 20 || g.length === 32))
    throw new Error("Witness: invalid length for version");
}
function programToWitness(o, g, c = NETWORK) {
  validateWitness(o, g);
  const y = o === 0 ? bech32$1 : bech32m;
  return y.encode(c.bech32, [o].concat(y.toWords(g)));
}
function formatKey(o, g) {
  return base58check.encode(concatBytes(Uint8Array.from(g), o));
}
function Address(o = NETWORK) {
  return {
    encode(g) {
      const { type: c } = g;
      if (c === "wpkh")
        return programToWitness(0, g.hash, o);
      if (c === "wsh")
        return programToWitness(0, g.hash, o);
      if (c === "tr")
        return programToWitness(1, g.pubkey, o);
      if (c === "pkh")
        return formatKey(g.hash, [o.pubKeyHash]);
      if (c === "sh")
        return formatKey(g.hash, [o.scriptHash]);
      throw new Error(`Unknown address type=${c}`);
    },
    decode(g) {
      if (g.length < 14 || g.length > 74)
        throw new Error("Invalid address length");
      if (o.bech32 && g.toLowerCase().startsWith(`${o.bech32}1`)) {
        let y;
        try {
          if (y = bech32$1.decode(g), y.words[0] !== 0)
            throw new Error(`bech32: wrong version=${y.words[0]}`);
        } catch {
          if (y = bech32m.decode(g), y.words[0] === 0)
            throw new Error(`bech32m: wrong version=${y.words[0]}`);
        }
        if (y.prefix !== o.bech32)
          throw new Error(`wrong bech32 prefix=${y.prefix}`);
        const [t, ...d] = y.words, E = bech32$1.fromWords(d);
        if (validateWitness(t, E), t === 0 && E.length === 32)
          return { type: "wsh", hash: E };
        if (t === 0 && E.length === 20)
          return { type: "wpkh", hash: E };
        if (t === 1 && E.length === 32)
          return { type: "tr", pubkey: E };
        throw new Error("Unknown witness program");
      }
      const c = base58check.decode(g);
      if (c.length !== 21)
        throw new Error("Invalid base58 address");
      if (c[0] === o.pubKeyHash)
        return { type: "pkh", hash: c.slice(1) };
      if (c[0] === o.scriptHash)
        return {
          type: "sh",
          hash: c.slice(1)
        };
      throw new Error(`Invalid address prefix=${c[0]}`);
    }
  };
}
const EMPTY32 = new Uint8Array(32), EMPTY_OUTPUT = {
  amount: 0xffffffffffffffffn,
  script: EMPTY
}, toVsize = (o) => Math.ceil(o / 4), PRECISION = 8, DEFAULT_VERSION = 2, DEFAULT_LOCKTIME = 0, DEFAULT_SEQUENCE = 4294967295;
coders.decimal(PRECISION);
const def = (o, g) => o === void 0 ? g : o;
function cloneDeep(o) {
  if (Array.isArray(o))
    return o.map((g) => cloneDeep(g));
  if (isBytes(o))
    return Uint8Array.from(o);
  if (["number", "bigint", "boolean", "string", "undefined"].includes(typeof o))
    return o;
  if (o === null)
    return o;
  if (typeof o == "object")
    return Object.fromEntries(Object.entries(o).map(([g, c]) => [g, cloneDeep(c)]));
  throw new Error(`cloneDeep: unknown type=${o} (${typeof o})`);
}
var SignatureHash;
(function(o) {
  o[o.DEFAULT = 0] = "DEFAULT", o[o.ALL = 1] = "ALL", o[o.NONE = 2] = "NONE", o[o.SINGLE = 3] = "SINGLE", o[o.ANYONECANPAY = 128] = "ANYONECANPAY";
})(SignatureHash || (SignatureHash = {}));
var SigHash;
(function(o) {
  o[o.DEFAULT = 0] = "DEFAULT", o[o.ALL = 1] = "ALL", o[o.NONE = 2] = "NONE", o[o.SINGLE = 3] = "SINGLE", o[o.DEFAULT_ANYONECANPAY = 128] = "DEFAULT_ANYONECANPAY", o[o.ALL_ANYONECANPAY = 129] = "ALL_ANYONECANPAY", o[o.NONE_ANYONECANPAY = 130] = "NONE_ANYONECANPAY", o[o.SINGLE_ANYONECANPAY = 131] = "SINGLE_ANYONECANPAY";
})(SigHash || (SigHash = {}));
function getTaprootKeys(o, g, c, y = EMPTY) {
  return equalBytes(c, g) && (o = taprootTweakPrivKey(o, y), g = pubSchnorr(o)), { privKey: o, pubKey: g };
}
function outputBeforeSign(o) {
  if (o.script === void 0 || o.amount === void 0)
    throw new Error("Transaction/output: script and amount required");
  return { script: o.script, amount: o.amount };
}
function inputBeforeSign(o) {
  if (o.txid === void 0 || o.index === void 0)
    throw new Error("Transaction/input: txid and index required");
  return {
    txid: o.txid,
    index: o.index,
    sequence: def(o.sequence, DEFAULT_SEQUENCE),
    finalScriptSig: def(o.finalScriptSig, EMPTY)
  };
}
function cleanFinalInput(o) {
  for (const g in o) {
    const c = g;
    PSBTInputFinalKeys.includes(c) || delete o[c];
  }
}
const TxHashIdx = struct({ txid: createBytes(32, !0), index: U32LE });
function validateSigHash(o) {
  if (typeof o != "number" || typeof SigHash[o] != "string")
    throw new Error(`Invalid SigHash=${o}`);
  return o;
}
function unpackSighash(o) {
  const g = o & 31;
  return {
    isAny: !!(o & SignatureHash.ANYONECANPAY),
    isNone: g === SignatureHash.NONE,
    isSingle: g === SignatureHash.SINGLE
  };
}
function validateOpts(o) {
  if (o !== void 0 && {}.toString.call(o) !== "[object Object]")
    throw new Error(`Wrong object type for transaction options: ${o}`);
  const g = {
    ...o,
    // Defaults
    version: def(o.version, DEFAULT_VERSION),
    lockTime: def(o.lockTime, 0),
    PSBTVersion: def(o.PSBTVersion, 0)
  };
  if (typeof g.allowUnknowInput < "u" && (o.allowUnknownInputs = g.allowUnknowInput), typeof g.allowUnknowOutput < "u" && (o.allowUnknownOutputs = g.allowUnknowOutput), typeof g.lockTime != "number")
    throw new Error("Transaction lock time should be number");
  if (U32LE.encode(g.lockTime), g.PSBTVersion !== 0 && g.PSBTVersion !== 2)
    throw new Error(`Unknown PSBT version ${g.PSBTVersion}`);
  for (const c of [
    "allowUnknownVersion",
    "allowUnknownOutputs",
    "allowUnknownInputs",
    "disableScriptCheck",
    "bip174jsCompat",
    "allowLegacyWitnessUtxo",
    "lowR"
  ]) {
    const y = g[c];
    if (y !== void 0 && typeof y != "boolean")
      throw new Error(`Transation options wrong type: ${c}=${y} (${typeof y})`);
  }
  if (g.allowUnknownVersion ? typeof g.version == "number" : ![-1, 0, 1, 2, 3].includes(g.version))
    throw new Error(`Unknown version: ${g.version}`);
  if (g.customScripts !== void 0) {
    const c = g.customScripts;
    if (!Array.isArray(c))
      throw new Error(`wrong custom scripts type (expected array): customScripts=${c} (${typeof c})`);
    for (const y of c) {
      if (typeof y.encode != "function" || typeof y.decode != "function")
        throw new Error(`wrong script=${y} (${typeof y})`);
      if (y.finalizeTaproot !== void 0 && typeof y.finalizeTaproot != "function")
        throw new Error(`wrong script=${y} (${typeof y})`);
    }
  }
  return Object.freeze(g);
}
function validateInput(o) {
  if (o.nonWitnessUtxo && o.index !== void 0) {
    const g = o.nonWitnessUtxo.outputs.length - 1;
    if (o.index > g)
      throw new Error(`validateInput: index(${o.index}) not in nonWitnessUtxo`);
    const c = o.nonWitnessUtxo.outputs[o.index];
    if (o.witnessUtxo && (!equalBytes(o.witnessUtxo.script, c.script) || o.witnessUtxo.amount !== c.amount))
      throw new Error("validateInput: witnessUtxo different from nonWitnessUtxo");
    if (o.txid) {
      if (o.nonWitnessUtxo.outputs.length - 1 < o.index)
        throw new Error("nonWitnessUtxo: incorect output index");
      const t = Transaction.fromRaw(RawTx.encode(o.nonWitnessUtxo), {
        allowUnknownOutputs: !0,
        disableScriptCheck: !0,
        allowUnknownInputs: !0
      }), d = hex$1.encode(o.txid);
      if (t.isFinal && t.id !== d)
        throw new Error(`nonWitnessUtxo: wrong txid, exp=${d} got=${t.id}`);
    }
  }
  return o;
}
function getPrevOut(o) {
  if (o.nonWitnessUtxo) {
    if (o.index === void 0)
      throw new Error("Unknown input index");
    return o.nonWitnessUtxo.outputs[o.index];
  } else {
    if (o.witnessUtxo)
      return o.witnessUtxo;
    throw new Error("Cannot find previous output info");
  }
}
function normalizeInput(o, g, c, y = !1, t = !1) {
  let { nonWitnessUtxo: d, txid: E } = o;
  typeof d == "string" && (d = hex$1.decode(d)), isBytes(d) && (d = RawTx.decode(d)), !("nonWitnessUtxo" in o) && d === void 0 && (d = g == null ? void 0 : g.nonWitnessUtxo), typeof E == "string" && (E = hex$1.decode(E)), E === void 0 && (E = g == null ? void 0 : g.txid);
  let B = { ...g, ...o, nonWitnessUtxo: d, txid: E };
  !("nonWitnessUtxo" in o) && B.nonWitnessUtxo === void 0 && delete B.nonWitnessUtxo, B.sequence === void 0 && (B.sequence = DEFAULT_SEQUENCE), B.tapMerkleRoot === null && delete B.tapMerkleRoot, B = mergeKeyMap(PSBTInput, B, g, c, t), PSBTInputCoder.encode(B);
  let D;
  return B.nonWitnessUtxo && B.index !== void 0 ? D = B.nonWitnessUtxo.outputs[B.index] : B.witnessUtxo && (D = B.witnessUtxo), D && !y && checkScript(D && D.script, B.redeemScript, B.witnessScript), B;
}
function getInputType(o, g = !1) {
  let c = "legacy", y = SignatureHash.ALL;
  const t = getPrevOut(o), d = OutScript.decode(t.script);
  let E = d.type, B = d;
  const D = [d];
  if (d.type === "tr")
    return y = SignatureHash.DEFAULT, {
      txType: "taproot",
      type: "tr",
      last: d,
      lastScript: t.script,
      defaultSighash: y,
      sighash: o.sighashType || y
    };
  {
    if ((d.type === "wpkh" || d.type === "wsh") && (c = "segwit"), d.type === "sh") {
      if (!o.redeemScript)
        throw new Error("inputType: sh without redeemScript");
      let M = OutScript.decode(o.redeemScript);
      (M.type === "wpkh" || M.type === "wsh") && (c = "segwit"), D.push(M), B = M, E += `-${M.type}`;
    }
    if (B.type === "wsh") {
      if (!o.witnessScript)
        throw new Error("inputType: wsh without witnessScript");
      let M = OutScript.decode(o.witnessScript);
      M.type === "wsh" && (c = "segwit"), D.push(M), B = M, E += `-${M.type}`;
    }
    const x = D[D.length - 1];
    if (x.type === "sh" || x.type === "wsh")
      throw new Error("inputType: sh/wsh cannot be terminal type");
    const v = OutScript.encode(x), F = {
      type: E,
      txType: c,
      last: x,
      lastScript: v,
      defaultSighash: y,
      sighash: o.sighashType || y
    };
    if (c === "legacy" && !g && !o.nonWitnessUtxo)
      throw new Error("Transaction/sign: legacy input without nonWitnessUtxo, can result in attack that forces paying higher fees. Pass allowLegacyWitnessUtxo=true, if you sure");
    return F;
  }
}
class Transaction {
  constructor(g = {}) {
    this.global = {}, this.inputs = [], this.outputs = [];
    const c = this.opts = validateOpts(g);
    c.lockTime !== DEFAULT_LOCKTIME && (this.global.fallbackLocktime = c.lockTime), this.global.txVersion = c.version;
  }
  // Import
  static fromRaw(g, c = {}) {
    const y = RawTx.decode(g), t = new Transaction({ ...c, version: y.version, lockTime: y.lockTime });
    for (const d of y.outputs)
      t.addOutput(d);
    if (t.outputs = y.outputs, t.inputs = y.inputs, y.witnesses)
      for (let d = 0; d < y.witnesses.length; d++)
        t.inputs[d].finalScriptWitness = y.witnesses[d];
    return t;
  }
  // PSBT
  static fromPSBT(g, c = {}) {
    let y;
    try {
      y = RawPSBTV0.decode(g);
    } catch (F) {
      try {
        y = RawPSBTV2.decode(g);
      } catch {
        throw F;
      }
    }
    const t = y.global.version || 0;
    if (t !== 0 && t !== 2)
      throw new Error(`Wrong PSBT version=${t}`);
    const d = y.global.unsignedTx, E = t === 0 ? d == null ? void 0 : d.version : y.global.txVersion, B = t === 0 ? d == null ? void 0 : d.lockTime : y.global.fallbackLocktime, D = new Transaction({ ...c, version: E, lockTime: B, PSBTVersion: t }), x = t === 0 ? d == null ? void 0 : d.inputs.length : y.global.inputCount;
    D.inputs = y.inputs.slice(0, x).map((F, M) => {
      var U;
      return validateInput({
        finalScriptSig: EMPTY,
        ...(U = y.global.unsignedTx) == null ? void 0 : U.inputs[M],
        ...F
      });
    });
    const v = t === 0 ? d == null ? void 0 : d.outputs.length : y.global.outputCount;
    return D.outputs = y.outputs.slice(0, v).map((F, M) => {
      var U;
      return {
        ...F,
        ...(U = y.global.unsignedTx) == null ? void 0 : U.outputs[M]
      };
    }), D.global = { ...y.global, txVersion: E }, B !== DEFAULT_LOCKTIME && (D.global.fallbackLocktime = B), D;
  }
  toPSBT(g = this.opts.PSBTVersion) {
    if (g !== 0 && g !== 2)
      throw new Error(`Wrong PSBT version=${g}`);
    const c = this.inputs.map((d) => validateInput(cleanPSBTFields(g, PSBTInput, d)));
    for (const d of c)
      d.partialSig && !d.partialSig.length && delete d.partialSig, d.finalScriptSig && !d.finalScriptSig.length && delete d.finalScriptSig, d.finalScriptWitness && !d.finalScriptWitness.length && delete d.finalScriptWitness;
    const y = this.outputs.map((d) => cleanPSBTFields(g, PSBTOutput, d)), t = { ...this.global };
    return g === 0 ? (t.unsignedTx = RawOldTx.decode(RawOldTx.encode({
      version: this.version,
      lockTime: this.lockTime,
      inputs: this.inputs.map(inputBeforeSign).map((d) => ({
        ...d,
        finalScriptSig: EMPTY
      })),
      outputs: this.outputs.map(outputBeforeSign)
    })), delete t.fallbackLocktime, delete t.txVersion) : (t.version = g, t.txVersion = this.version, t.inputCount = this.inputs.length, t.outputCount = this.outputs.length, t.fallbackLocktime && t.fallbackLocktime === DEFAULT_LOCKTIME && delete t.fallbackLocktime), this.opts.bip174jsCompat && (c.length || c.push({}), y.length || y.push({})), (g === 0 ? RawPSBTV0 : RawPSBTV2).encode({
      global: t,
      inputs: c,
      outputs: y
    });
  }
  // BIP370 lockTime (https://github.com/bitcoin/bips/blob/master/bip-0370.mediawiki#determining-lock-time)
  get lockTime() {
    let g = DEFAULT_LOCKTIME, c = 0, y = DEFAULT_LOCKTIME, t = 0;
    for (const d of this.inputs)
      d.requiredHeightLocktime && (g = Math.max(g, d.requiredHeightLocktime), c++), d.requiredTimeLocktime && (y = Math.max(y, d.requiredTimeLocktime), t++);
    return c && c >= t ? g : y !== DEFAULT_LOCKTIME ? y : this.global.fallbackLocktime || DEFAULT_LOCKTIME;
  }
  get version() {
    if (this.global.txVersion === void 0)
      throw new Error("No global.txVersion");
    return this.global.txVersion;
  }
  inputStatus(g) {
    this.checkInputIdx(g);
    const c = this.inputs[g];
    return c.finalScriptSig && c.finalScriptSig.length || c.finalScriptWitness && c.finalScriptWitness.length ? "finalized" : c.tapKeySig || c.tapScriptSig && c.tapScriptSig.length || c.partialSig && c.partialSig.length ? "signed" : "unsigned";
  }
  // Cannot replace unpackSighash, tests rely on very generic implemenetation with signing inputs outside of range
  // We will lose some vectors -> smaller test coverage of preimages (very important!)
  inputSighash(g) {
    this.checkInputIdx(g);
    const c = this.inputs[g].sighashType, y = c === void 0 ? SignatureHash.DEFAULT : c, t = y === SignatureHash.DEFAULT ? SignatureHash.ALL : y & 3;
    return { sigInputs: y & SignatureHash.ANYONECANPAY, sigOutputs: t };
  }
  // Very nice for debug purposes, but slow. If there is too much inputs/outputs to add, will be quadratic.
  // Some cache will be nice, but there chance to have bugs with cache invalidation
  signStatus() {
    let g = !0, c = !0, y = [], t = [];
    for (let d = 0; d < this.inputs.length; d++) {
      if (this.inputStatus(d) === "unsigned")
        continue;
      const { sigInputs: B, sigOutputs: D } = this.inputSighash(d);
      if (B === SignatureHash.ANYONECANPAY ? y.push(d) : g = !1, D === SignatureHash.ALL)
        c = !1;
      else if (D === SignatureHash.SINGLE)
        t.push(d);
      else if (D !== SignatureHash.NONE) throw new Error(`Wrong signature hash output type: ${D}`);
    }
    return { addInput: g, addOutput: c, inputs: y, outputs: t };
  }
  get isFinal() {
    for (let g = 0; g < this.inputs.length; g++)
      if (this.inputStatus(g) !== "finalized")
        return !1;
    return !0;
  }
  // Info utils
  get hasWitnesses() {
    let g = !1;
    for (const c of this.inputs)
      c.finalScriptWitness && c.finalScriptWitness.length && (g = !0);
    return g;
  }
  // https://en.bitcoin.it/wiki/Weight_units
  get weight() {
    if (!this.isFinal)
      throw new Error("Transaction is not finalized");
    let g = 32;
    const c = this.outputs.map(outputBeforeSign);
    g += 4 * CompactSizeLen.encode(this.outputs.length).length;
    for (const y of c)
      g += 32 + 4 * VarBytes.encode(y.script).length;
    this.hasWitnesses && (g += 2), g += 4 * CompactSizeLen.encode(this.inputs.length).length;
    for (const y of this.inputs)
      g += 160 + 4 * VarBytes.encode(y.finalScriptSig || EMPTY).length, this.hasWitnesses && y.finalScriptWitness && (g += RawWitness.encode(y.finalScriptWitness).length);
    return g;
  }
  get vsize() {
    return toVsize(this.weight);
  }
  toBytes(g = !1, c = !1) {
    return RawTx.encode({
      version: this.version,
      lockTime: this.lockTime,
      inputs: this.inputs.map(inputBeforeSign).map((y) => ({
        ...y,
        finalScriptSig: g && y.finalScriptSig || EMPTY
      })),
      outputs: this.outputs.map(outputBeforeSign),
      witnesses: this.inputs.map((y) => y.finalScriptWitness || []),
      segwitFlag: c && this.hasWitnesses
    });
  }
  get unsignedTx() {
    return this.toBytes(!1, !1);
  }
  get hex() {
    return hex$1.encode(this.toBytes(!0, this.hasWitnesses));
  }
  get hash() {
    if (!this.isFinal)
      throw new Error("Transaction is not finalized");
    return hex$1.encode(sha256x2(this.toBytes(!0)));
  }
  get id() {
    if (!this.isFinal)
      throw new Error("Transaction is not finalized");
    return hex$1.encode(sha256x2(this.toBytes(!0)).reverse());
  }
  // Input stuff
  checkInputIdx(g) {
    if (!Number.isSafeInteger(g) || 0 > g || g >= this.inputs.length)
      throw new Error(`Wrong input index=${g}`);
  }
  getInput(g) {
    return this.checkInputIdx(g), cloneDeep(this.inputs[g]);
  }
  get inputsLength() {
    return this.inputs.length;
  }
  // Modification
  addInput(g, c = !1) {
    if (!c && !this.signStatus().addInput)
      throw new Error("Tx has signed inputs, cannot add new one");
    return this.inputs.push(normalizeInput(g, void 0, void 0, this.opts.disableScriptCheck)), this.inputs.length - 1;
  }
  updateInput(g, c, y = !1) {
    this.checkInputIdx(g);
    let t;
    if (!y) {
      const d = this.signStatus();
      (!d.addInput || d.inputs.includes(g)) && (t = PSBTInputUnsignedKeys);
    }
    this.inputs[g] = normalizeInput(c, this.inputs[g], t, this.opts.disableScriptCheck, this.opts.allowUnknown);
  }
  // Output stuff
  checkOutputIdx(g) {
    if (!Number.isSafeInteger(g) || 0 > g || g >= this.outputs.length)
      throw new Error(`Wrong output index=${g}`);
  }
  getOutput(g) {
    return this.checkOutputIdx(g), cloneDeep(this.outputs[g]);
  }
  getOutputAddress(g, c = NETWORK) {
    const y = this.getOutput(g);
    if (y.script)
      return Address(c).encode(OutScript.decode(y.script));
  }
  get outputsLength() {
    return this.outputs.length;
  }
  normalizeOutput(g, c, y) {
    let { amount: t, script: d } = g;
    if (t === void 0 && (t = c == null ? void 0 : c.amount), typeof t != "bigint")
      throw new Error(`Wrong amount type, should be of type bigint in sats, but got ${t} of type ${typeof t}`);
    typeof d == "string" && (d = hex$1.decode(d)), d === void 0 && (d = c == null ? void 0 : c.script);
    let E = { ...c, ...g, amount: t, script: d };
    if (E.amount === void 0 && delete E.amount, E = mergeKeyMap(PSBTOutput, E, c, y, this.opts.allowUnknown), PSBTOutputCoder.encode(E), E.script && !this.opts.allowUnknownOutputs && OutScript.decode(E.script).type === "unknown")
      throw new Error("Transaction/output: unknown output script type, there is a chance that input is unspendable. Pass allowUnknownOutputs=true, if you sure");
    return this.opts.disableScriptCheck || checkScript(E.script, E.redeemScript, E.witnessScript), E;
  }
  addOutput(g, c = !1) {
    if (!c && !this.signStatus().addOutput)
      throw new Error("Tx has signed outputs, cannot add new one");
    return this.outputs.push(this.normalizeOutput(g)), this.outputs.length - 1;
  }
  updateOutput(g, c, y = !1) {
    this.checkOutputIdx(g);
    let t;
    if (!y) {
      const d = this.signStatus();
      (!d.addOutput || d.outputs.includes(g)) && (t = PSBTOutputUnsignedKeys);
    }
    this.outputs[g] = this.normalizeOutput(c, this.outputs[g], t);
  }
  addOutputAddress(g, c, y = NETWORK) {
    return this.addOutput({ script: OutScript.encode(Address(y).decode(g)), amount: c });
  }
  // Utils
  get fee() {
    let g = 0n;
    for (const y of this.inputs) {
      const t = getPrevOut(y);
      if (!t)
        throw new Error("Empty input amount");
      g += t.amount;
    }
    const c = this.outputs.map(outputBeforeSign);
    for (const y of c)
      g -= y.amount;
    return g;
  }
  // Signing
  // Based on https://github.com/bitcoin/bitcoin/blob/5871b5b5ab57a0caf9b7514eb162c491c83281d5/test/functional/test_framework/script.py#L624
  // There is optimization opportunity to re-use hashes for multiple inputs for witness v0/v1,
  // but we are trying to be less complicated for audit purpose for now.
  preimageLegacy(g, c, y) {
    const { isAny: t, isNone: d, isSingle: E } = unpackSighash(y);
    if (g < 0 || !Number.isSafeInteger(g))
      throw new Error(`Invalid input idx=${g}`);
    if (E && g >= this.outputs.length || g >= this.inputs.length)
      return U256BE.encode(1n);
    c = Script.encode(Script.decode(c).filter((v) => v !== "CODESEPARATOR"));
    let B = this.inputs.map(inputBeforeSign).map((v, F) => ({
      ...v,
      finalScriptSig: F === g ? c : EMPTY
    }));
    t ? B = [B[g]] : (d || E) && (B = B.map((v, F) => ({
      ...v,
      sequence: F === g ? v.sequence : 0
    })));
    let D = this.outputs.map(outputBeforeSign);
    d ? D = [] : E && (D = D.slice(0, g).fill(EMPTY_OUTPUT).concat([D[g]]));
    const x = RawTx.encode({
      lockTime: this.lockTime,
      version: this.version,
      segwitFlag: !1,
      inputs: B,
      outputs: D
    });
    return sha256x2(x, I32LE.encode(y));
  }
  preimageWitnessV0(g, c, y, t) {
    const { isAny: d, isNone: E, isSingle: B } = unpackSighash(y);
    let D = EMPTY32, x = EMPTY32, v = EMPTY32;
    const F = this.inputs.map(inputBeforeSign), M = this.outputs.map(outputBeforeSign);
    d || (D = sha256x2(...F.map(TxHashIdx.encode))), !d && !B && !E && (x = sha256x2(...F.map((L) => U32LE.encode(L.sequence)))), !B && !E ? v = sha256x2(...M.map(RawOutput.encode)) : B && g < M.length && (v = sha256x2(RawOutput.encode(M[g])));
    const U = F[g];
    return sha256x2(I32LE.encode(this.version), D, x, createBytes(32, !0).encode(U.txid), U32LE.encode(U.index), VarBytes.encode(c), U64LE.encode(t), U32LE.encode(U.sequence), v, U32LE.encode(this.lockTime), U32LE.encode(y));
  }
  preimageWitnessV1(g, c, y, t, d = -1, E, B = 192, D) {
    if (!Array.isArray(t) || this.inputs.length !== t.length)
      throw new Error(`Invalid amounts array=${t}`);
    if (!Array.isArray(c) || this.inputs.length !== c.length)
      throw new Error(`Invalid prevOutScript array=${c}`);
    const x = [
      U8.encode(0),
      U8.encode(y),
      // U8 sigHash
      I32LE.encode(this.version),
      U32LE.encode(this.lockTime)
    ], v = y === SignatureHash.DEFAULT ? SignatureHash.ALL : y & 3, F = y & SignatureHash.ANYONECANPAY, M = this.inputs.map(inputBeforeSign), U = this.outputs.map(outputBeforeSign);
    F !== SignatureHash.ANYONECANPAY && x.push(...[
      M.map(TxHashIdx.encode),
      t.map(U64LE.encode),
      c.map(VarBytes.encode),
      M.map((H) => U32LE.encode(H.sequence))
    ].map((H) => sha256(concatBytes(...H)))), v === SignatureHash.ALL && x.push(sha256(concatBytes(...U.map(RawOutput.encode))));
    const L = (D ? 1 : 0) | (E ? 2 : 0);
    if (x.push(new Uint8Array([L])), F === SignatureHash.ANYONECANPAY) {
      const H = M[g];
      x.push(TxHashIdx.encode(H), U64LE.encode(t[g]), VarBytes.encode(c[g]), U32LE.encode(H.sequence));
    } else
      x.push(U32LE.encode(g));
    return L & 1 && x.push(sha256(VarBytes.encode(D || EMPTY))), v === SignatureHash.SINGLE && x.push(g < U.length ? sha256(RawOutput.encode(U[g])) : EMPTY32), E && x.push(tapLeafHash(E, B), U8.encode(0), I32LE.encode(d)), tagSchnorr("TapSighash", ...x);
  }
  // Signer can be privateKey OR instance of bip32 HD stuff
  signIdx(g, c, y, t) {
    this.checkInputIdx(c);
    const d = this.inputs[c], E = getInputType(d, this.opts.allowLegacyWitnessUtxo);
    if (!isBytes(g)) {
      if (!d.bip32Derivation || !d.bip32Derivation.length)
        throw new Error("bip32Derivation: empty");
      const v = d.bip32Derivation.filter((M) => M[1].fingerprint == g.fingerprint).map(([M, { path: U }]) => {
        let L = g;
        for (const H of U)
          L = L.deriveChild(H);
        if (!equalBytes(L.publicKey, M))
          throw new Error("bip32Derivation: wrong pubKey");
        if (!L.privateKey)
          throw new Error("bip32Derivation: no privateKey");
        return L;
      });
      if (!v.length)
        throw new Error(`bip32Derivation: no items with fingerprint=${g.fingerprint}`);
      let F = !1;
      for (const M of v)
        this.signIdx(M.privateKey, c) && (F = !0);
      return F;
    }
    y ? y.forEach(validateSigHash) : y = [E.defaultSighash];
    const B = E.sighash;
    if (!y.includes(B))
      throw new Error(`Input with not allowed sigHash=${B}. Allowed: ${y.join(", ")}`);
    const { sigOutputs: D } = this.inputSighash(c);
    if (D === SignatureHash.SINGLE && c >= this.outputs.length)
      throw new Error(`Input with sighash SINGLE, but there is no output with corresponding index=${c}`);
    const x = getPrevOut(d);
    if (E.txType === "taproot") {
      const v = this.inputs.map(getPrevOut), F = v.map((fe) => fe.script), M = v.map((fe) => fe.amount);
      let U = !1, L = pubSchnorr(g), H = d.tapMerkleRoot || EMPTY;
      if (d.tapInternalKey) {
        const { pubKey: fe, privKey: ge } = getTaprootKeys(g, L, d.tapInternalKey, H), [Ie, Ee] = taprootTweakPubkey(d.tapInternalKey, H);
        if (equalBytes(Ie, fe)) {
          const Se = this.preimageWitnessV1(c, F, B, M), ze = concatBytes(signSchnorr(Se, ge, t), B !== SignatureHash.DEFAULT ? new Uint8Array([B]) : EMPTY);
          this.updateInput(c, { tapKeySig: ze }, !0), U = !0;
        }
      }
      if (d.tapLeafScript) {
        d.tapScriptSig = d.tapScriptSig || [];
        for (const [fe, ge] of d.tapLeafScript) {
          const Ie = ge.subarray(0, -1), Ee = Script.decode(Ie), Se = ge[ge.length - 1], ze = tapLeafHash(Ie, Se);
          if (Ee.findIndex((ve) => isBytes(ve) && equalBytes(ve, L)) === -1)
            continue;
          const Pe = this.preimageWitnessV1(c, F, B, M, void 0, Ie, Se), De = concatBytes(signSchnorr(Pe, g, t), B !== SignatureHash.DEFAULT ? new Uint8Array([B]) : EMPTY);
          this.updateInput(c, { tapScriptSig: [[{ pubKey: L, leafHash: ze }, De]] }, !0), U = !0;
        }
      }
      if (!U)
        throw new Error("No taproot scripts signed");
      return !0;
    } else {
      const v = pubECDSA(g);
      let F = !1;
      const M = hash160(v);
      for (const H of Script.decode(E.lastScript))
        isBytes(H) && (equalBytes(H, v) || equalBytes(H, M)) && (F = !0);
      if (!F)
        throw new Error(`Input script doesn't have pubKey: ${E.lastScript}`);
      let U;
      if (E.txType === "legacy")
        U = this.preimageLegacy(c, E.lastScript, B);
      else if (E.txType === "segwit") {
        let H = E.lastScript;
        E.last.type === "wpkh" && (H = OutScript.encode({ type: "pkh", hash: E.last.hash })), U = this.preimageWitnessV0(c, H, B, x.amount);
      } else
        throw new Error(`Transaction/sign: unknown tx type: ${E.txType}`);
      const L = signECDSA(U, g, this.opts.lowR);
      this.updateInput(c, {
        partialSig: [[v, concatBytes(L, new Uint8Array([B]))]]
      }, !0);
    }
    return !0;
  }
  // This is bad API. Will work if user creates and signs tx, but if
  // there is some complex workflow with exchanging PSBT and signing them,
  // then it is better to validate which output user signs. How could a better API look like?
  // Example: user adds input, sends to another party, then signs received input (mixer etc),
  // another user can add different input for same key and user will sign it.
  // Even worse: another user can add bip32 derivation, and spend money from different address.
  // Better api: signIdx
  sign(g, c, y) {
    let t = 0;
    for (let d = 0; d < this.inputs.length; d++)
      try {
        this.signIdx(g, d, c, y) && t++;
      } catch {
      }
    if (!t)
      throw new Error("No inputs signed");
    return t;
  }
  finalizeIdx(g) {
    if (this.checkInputIdx(g), this.fee < 0n)
      throw new Error("Outputs spends more than inputs amount");
    const c = this.inputs[g], y = getInputType(c, this.opts.allowLegacyWitnessUtxo);
    if (y.txType === "taproot") {
      if (c.tapKeySig)
        c.finalScriptWitness = [c.tapKeySig];
      else if (c.tapLeafScript && c.tapScriptSig) {
        const D = c.tapLeafScript.sort((x, v) => TaprootControlBlock.encode(x[0]).length - TaprootControlBlock.encode(v[0]).length);
        for (const [x, v] of D) {
          const F = v.slice(0, -1), M = v[v.length - 1], U = OutScript.decode(F), L = tapLeafHash(F, M), H = c.tapScriptSig.filter((ge) => equalBytes(ge[0].leafHash, L));
          let fe = [];
          if (U.type === "tr_ms") {
            const ge = U.m, Ie = U.pubkeys;
            let Ee = 0;
            for (const Se of Ie) {
              const ze = H.findIndex((He) => equalBytes(He[0].pubKey, Se));
              if (Ee === ge || ze === -1) {
                fe.push(EMPTY);
                continue;
              }
              fe.push(H[ze][1]), Ee++;
            }
            if (Ee !== ge)
              continue;
          } else if (U.type === "tr_ns") {
            for (const ge of U.pubkeys) {
              const Ie = H.findIndex((Ee) => equalBytes(Ee[0].pubKey, ge));
              Ie !== -1 && fe.push(H[Ie][1]);
            }
            if (fe.length !== U.pubkeys.length)
              continue;
          } else if (U.type === "unknown" && this.opts.allowUnknownInputs) {
            const ge = Script.decode(F);
            if (fe = H.map(([{ pubKey: Ie }, Ee]) => {
              const Se = ge.findIndex((ze) => isBytes(ze) && equalBytes(ze, Ie));
              if (Se === -1)
                throw new Error("finalize/taproot: cannot find position of pubkey in script");
              return { signature: Ee, pos: Se };
            }).sort((Ie, Ee) => Ie.pos - Ee.pos).map((Ie) => Ie.signature), !fe.length)
              continue;
          } else {
            const ge = this.opts.customScripts;
            if (ge)
              for (const Ie of ge) {
                if (!Ie.finalizeTaproot)
                  continue;
                const Ee = Script.decode(F), Se = Ie.encode(Ee);
                if (Se === void 0)
                  continue;
                const ze = Ie.finalizeTaproot(F, Se, H);
                if (ze) {
                  c.finalScriptWitness = ze.concat(TaprootControlBlock.encode(x)), c.finalScriptSig = EMPTY, cleanFinalInput(c);
                  return;
                }
              }
            throw new Error("Finalize: Unknown tapLeafScript");
          }
          c.finalScriptWitness = fe.reverse().concat([F, TaprootControlBlock.encode(x)]);
          break;
        }
        if (!c.finalScriptWitness)
          throw new Error("finalize/taproot: empty witness");
      } else
        throw new Error("finalize/taproot: unknown input");
      c.finalScriptSig = EMPTY, cleanFinalInput(c);
      return;
    }
    if (!c.partialSig || !c.partialSig.length)
      throw new Error("Not enough partial sign");
    let t = EMPTY, d = [];
    if (y.last.type === "ms") {
      const D = y.last.m, x = y.last.pubkeys;
      let v = [];
      for (const F of x) {
        const M = c.partialSig.find((U) => equalBytes(F, U[0]));
        M && v.push(M[1]);
      }
      if (v = v.slice(0, D), v.length !== D)
        throw new Error(`Multisig: wrong signatures count, m=${D} n=${x.length} signatures=${v.length}`);
      t = Script.encode([0, ...v]);
    } else if (y.last.type === "pk")
      t = Script.encode([c.partialSig[0][1]]);
    else if (y.last.type === "pkh")
      t = Script.encode([c.partialSig[0][1], c.partialSig[0][0]]);
    else if (y.last.type === "wpkh")
      t = EMPTY, d = [c.partialSig[0][1], c.partialSig[0][0]];
    else if (y.last.type === "unknown" && !this.opts.allowUnknownInputs)
      throw new Error("Unknown inputs not allowed");
    let E, B;
    if (y.type.includes("wsh-") && (t.length && y.lastScript.length && (d = Script.decode(t).map((D) => {
      if (D === 0)
        return EMPTY;
      if (isBytes(D))
        return D;
      throw new Error(`Wrong witness op=${D}`);
    })), d = d.concat(y.lastScript)), y.txType === "segwit" && (B = d), y.type.startsWith("sh-wsh-") ? E = Script.encode([Script.encode([0, sha256(y.lastScript)])]) : y.type.startsWith("sh-") ? E = Script.encode([...Script.decode(t), y.lastScript]) : y.type.startsWith("wsh-") || y.txType !== "segwit" && (E = t), !E && !B)
      throw new Error("Unknown error finalizing input");
    E && (c.finalScriptSig = E), B && (c.finalScriptWitness = B), cleanFinalInput(c);
  }
  finalize() {
    for (let g = 0; g < this.inputs.length; g++)
      this.finalizeIdx(g);
  }
  extract() {
    if (!this.isFinal)
      throw new Error("Transaction has unfinalized inputs");
    if (!this.outputs.length)
      throw new Error("Transaction has no outputs");
    if (this.fee < 0n)
      throw new Error("Outputs spends more than inputs amount");
    return this.toBytes(!0, !0);
  }
  combine(g) {
    for (const t of ["PSBTVersion", "version", "lockTime"])
      if (this.opts[t] !== g.opts[t])
        throw new Error(`Transaction/combine: different ${t} this=${this.opts[t]} other=${g.opts[t]}`);
    for (const t of ["inputs", "outputs"])
      if (this[t].length !== g[t].length)
        throw new Error(`Transaction/combine: different ${t} length this=${this[t].length} other=${g[t].length}`);
    const c = this.global.unsignedTx ? RawOldTx.encode(this.global.unsignedTx) : EMPTY, y = g.global.unsignedTx ? RawOldTx.encode(g.global.unsignedTx) : EMPTY;
    if (!equalBytes(c, y))
      throw new Error("Transaction/combine: different unsigned tx");
    this.global = mergeKeyMap(PSBTGlobal, this.global, g.global, void 0, this.opts.allowUnknown);
    for (let t = 0; t < this.inputs.length; t++)
      this.updateInput(t, g.inputs[t], !0);
    for (let t = 0; t < this.outputs.length; t++)
      this.updateOutput(t, g.outputs[t], !0);
    return this;
  }
  clone() {
    return Transaction.fromPSBT(this.toPSBT(this.opts.PSBTVersion), this.opts);
  }
}
var main$3 = {}, appClient$2 = {}, dist$1 = {}, descriptors = {};
const require$$1 = /* @__PURE__ */ getAugmentedNamespace(pA);
var src$1 = {}, bip32$3 = {}, crypto$1 = {}, sha512 = {}, hasRequiredSha512;
function requireSha512() {
  if (hasRequiredSha512) return sha512;
  hasRequiredSha512 = 1, Object.defineProperty(sha512, "__esModule", { value: !0 }), sha512.sha512_256 = sha512.SHA512_256 = sha512.sha512_224 = sha512.SHA512_224 = sha512.sha384 = sha512.SHA384 = sha512.sha512 = sha512.SHA512 = void 0;
  const o = /* @__PURE__ */ requireSha2();
  return sha512.SHA512 = o.SHA512, sha512.sha512 = o.sha512, sha512.SHA384 = o.SHA384, sha512.sha384 = o.sha384, sha512.SHA512_224 = o.SHA512_224, sha512.sha512_224 = o.sha512_224, sha512.SHA512_256 = o.SHA512_256, sha512.sha512_256 = o.sha512_256, sha512;
}
var hasRequiredCrypto;
function requireCrypto() {
  if (hasRequiredCrypto) return crypto$1;
  hasRequiredCrypto = 1, Object.defineProperty(crypto$1, "__esModule", { value: !0 }), crypto$1.hmacSHA512 = crypto$1.hash160 = void 0;
  const o = /* @__PURE__ */ requireHmac$3(), g = /* @__PURE__ */ requireRipemd160(), c = /* @__PURE__ */ requireSha256$1(), y = /* @__PURE__ */ requireSha512();
  function t(E) {
    const B = (0, c.sha256)(Uint8Array.from(E));
    return Buffer.from((0, g.ripemd160)(B));
  }
  crypto$1.hash160 = t;
  function d(E, B) {
    return Buffer.from((0, o.hmac)(y.sha512, E, B));
  }
  return crypto$1.hmacSHA512 = d, crypto$1;
}
var testecc$1 = {}, hasRequiredTestecc$1;
function requireTestecc$1() {
  if (hasRequiredTestecc$1) return testecc$1;
  hasRequiredTestecc$1 = 1, Object.defineProperty(testecc$1, "__esModule", { value: !0 }), testecc$1.testEcc = void 0;
  const o = (y) => Buffer.from(y, "hex");
  function g(y) {
    if (c(y.isPoint(o("0279be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798"))), c(!y.isPoint(o("030000000000000000000000000000000000000000000000000000000000000005"))), c(y.isPrivate(o("79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798"))), c(y.isPrivate(o("fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364140"))), c(!y.isPrivate(o("0000000000000000000000000000000000000000000000000000000000000000"))), c(!y.isPrivate(o("fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141"))), c(!y.isPrivate(o("fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364142"))), c(Buffer.from(y.pointFromScalar(o("b1121e4088a66a28f5b6b0f5844943ecd9f610196d7bb83b25214b60452c09af"))).equals(o("02b07ba9dca9523b7ef4bd97703d43d20399eb698e194704791a25ce77a400df99"))), y.xOnlyPointAddTweak) {
      c(y.xOnlyPointAddTweak(o("79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798"), o("fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364140")) === null);
      let t = y.xOnlyPointAddTweak(o("1617d38ed8d8657da4d4761e8057bc396ea9e4b9d29776d4be096016dbd2509b"), o("a8397a935f0dfceba6ba9618f6451ef4d80637abf4e6af2669fbc9de6a8fd2ac"));
      c(Buffer.from(t.xOnlyPubkey).equals(o("e478f99dab91052ab39a33ea35fd5e6e4933f4d28023cd597c9a1f6760346adf")) && t.parity === 1), t = y.xOnlyPointAddTweak(o("2c0b7cf95324a07d05398b240174dc0c2be444d96b159aa6c7f7b1e668680991"), o("823c3cd2142744b075a87eade7e1b8678ba308d566226a0056ca2b7a76f86b47"));
    }
    c(Buffer.from(y.pointAddScalar(o("0379be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798"), o("0000000000000000000000000000000000000000000000000000000000000003"))).equals(o("02c6047f9441ed7d6d3045406e95c07cd85c778e4b8cef3ca7abac09b95c709ee5"))), c(Buffer.from(y.privateAdd(o("fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd036413e"), o("0000000000000000000000000000000000000000000000000000000000000002"))).equals(o("fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364140"))), y.privateNegate && (c(Buffer.from(y.privateNegate(o("0000000000000000000000000000000000000000000000000000000000000001"))).equals(o("fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364140"))), c(Buffer.from(y.privateNegate(o("fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd036413e"))).equals(o("0000000000000000000000000000000000000000000000000000000000000003"))), c(Buffer.from(y.privateNegate(o("b1121e4088a66a28f5b6b0f5844943ecd9f610196d7bb83b25214b60452c09af"))).equals(o("4eede1bf775995d70a494f0a7bb6bc11e0b8cccd41cce8009ab1132c8b0a3792")))), c(Buffer.from(y.sign(o("5e9f0a0d593efdcf78ac923bc3313e4e7d408d574354ee2b3288c0da9fbba6ed"), o("fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364140"))).equals(o("54c4a33c6423d689378f160a7ff8b61330444abb58fb470f96ea16d99d4a2fed07082304410efa6b2943111b6a4e0aaa7b7db55a07e9861d1fb3cb1f421044a5"))), c(y.verify(o("5e9f0a0d593efdcf78ac923bc3313e4e7d408d574354ee2b3288c0da9fbba6ed"), o("0379be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798"), o("54c4a33c6423d689378f160a7ff8b61330444abb58fb470f96ea16d99d4a2fed07082304410efa6b2943111b6a4e0aaa7b7db55a07e9861d1fb3cb1f421044a5"))), y.signSchnorr && c(Buffer.from(y.signSchnorr(o("7e2d58d8b3bcdf1abadec7829054f90dda9805aab56c77333024b9d0a508b75c"), o("c90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b14e5c9"), o("c87aa53824b4d7ae2eb035a2b5bbbccc080e76cdc6d1692c4b0b62d798e6d906"))).equals(o("5831aaeed7b44bb74e5eab94ba9d4294c49bcf2a60728d8b4c200f50dd313c1bab745879a5ad954a72c45a91c3a51d3c7adea98d82f8481e0e1e03674a6f3fb7"))), y.verifySchnorr && c(y.verifySchnorr(o("7e2d58d8b3bcdf1abadec7829054f90dda9805aab56c77333024b9d0a508b75c"), o("dd308afec5777e13121fa72b9cc1b7cc0139715309b086c960e18fd969774eb8"), o("5831aaeed7b44bb74e5eab94ba9d4294c49bcf2a60728d8b4c200f50dd313c1bab745879a5ad954a72c45a91c3a51d3c7adea98d82f8481e0e1e03674a6f3fb7")));
  }
  testecc$1.testEcc = g;
  function c(y) {
    if (!y)
      throw new Error("ecc library invalid");
  }
  return testecc$1;
}
var lib$2 = {}, hasRequiredLib$2;
function requireLib$2() {
  return hasRequiredLib$2 || (hasRequiredLib$2 = 1, function(o) {
    Object.defineProperty(o, "__esModule", { value: !0 }), o.bytes = o.stringToBytes = o.str = o.bytesToString = o.hex = o.utf8 = o.bech32m = o.bech32 = o.base58check = o.createBase58check = o.base58xmr = o.base58xrp = o.base58flickr = o.base58 = o.base64urlnopad = o.base64url = o.base64nopad = o.base64 = o.base32crockford = o.base32hexnopad = o.base32hex = o.base32nopad = o.base32 = o.base16 = o.utils = void 0;
    function g(wr) {
      return wr instanceof Uint8Array || ArrayBuffer.isView(wr) && wr.constructor.name === "Uint8Array";
    }
    function c(wr, ...qr) {
      if (!g(wr))
        throw new Error("Uint8Array expected");
      if (qr.length > 0 && !qr.includes(wr.length))
        throw new Error("Uint8Array expected of length " + qr + ", got length=" + wr.length);
    }
    function y(wr, qr) {
      return Array.isArray(qr) ? qr.length === 0 ? !0 : wr ? qr.every((Mr) => typeof Mr == "string") : qr.every((Mr) => Number.isSafeInteger(Mr)) : !1;
    }
    function t(wr) {
      if (typeof wr != "function")
        throw new Error("function expected");
      return !0;
    }
    function d(wr, qr) {
      if (typeof qr != "string")
        throw new Error(`${wr}: string expected`);
      return !0;
    }
    function E(wr) {
      if (!Number.isSafeInteger(wr))
        throw new Error(`invalid integer: ${wr}`);
    }
    function B(wr) {
      if (!Array.isArray(wr))
        throw new Error("array expected");
    }
    function D(wr, qr) {
      if (!y(!0, qr))
        throw new Error(`${wr}: array of strings expected`);
    }
    function x(wr, qr) {
      if (!y(!1, qr))
        throw new Error(`${wr}: array of numbers expected`);
    }
    // @__NO_SIDE_EFFECTS__
    function v(...wr) {
      const qr = (Xr) => Xr, Mr = (Xr, Vr) => (Ur) => Xr(Vr(Ur)), Dr = wr.map((Xr) => Xr.encode).reduceRight(Mr, qr), Qr = wr.map((Xr) => Xr.decode).reduce(Mr, qr);
      return { encode: Dr, decode: Qr };
    }
    // @__NO_SIDE_EFFECTS__
    function F(wr) {
      const qr = typeof wr == "string" ? wr.split("") : wr, Mr = qr.length;
      D("alphabet", qr);
      const Dr = new Map(qr.map((Qr, Xr) => [Qr, Xr]));
      return {
        encode: (Qr) => (B(Qr), Qr.map((Xr) => {
          if (!Number.isSafeInteger(Xr) || Xr < 0 || Xr >= Mr)
            throw new Error(`alphabet.encode: digit index outside alphabet "${Xr}". Allowed: ${wr}`);
          return qr[Xr];
        })),
        decode: (Qr) => (B(Qr), Qr.map((Xr) => {
          d("alphabet.decode", Xr);
          const Vr = Dr.get(Xr);
          if (Vr === void 0)
            throw new Error(`Unknown letter: "${Xr}". Allowed: ${wr}`);
          return Vr;
        }))
      };
    }
    // @__NO_SIDE_EFFECTS__
    function M(wr = "") {
      return d("join", wr), {
        encode: (qr) => (D("join.decode", qr), qr.join(wr)),
        decode: (qr) => (d("join.decode", qr), qr.split(wr))
      };
    }
    // @__NO_SIDE_EFFECTS__
    function U(wr, qr = "=") {
      return E(wr), d("padding", qr), {
        encode(Mr) {
          for (D("padding.encode", Mr); Mr.length * wr % 8; )
            Mr.push(qr);
          return Mr;
        },
        decode(Mr) {
          D("padding.decode", Mr);
          let Dr = Mr.length;
          if (Dr * wr % 8)
            throw new Error("padding: invalid, string should have whole number of bytes");
          for (; Dr > 0 && Mr[Dr - 1] === qr; Dr--)
            if ((Dr - 1) * wr % 8 === 0)
              throw new Error("padding: invalid, string has too much padding");
          return Mr.slice(0, Dr);
        }
      };
    }
    // @__NO_SIDE_EFFECTS__
    function L(wr) {
      return t(wr), { encode: (qr) => qr, decode: (qr) => wr(qr) };
    }
    function H(wr, qr, Mr) {
      if (qr < 2)
        throw new Error(`convertRadix: invalid from=${qr}, base cannot be less than 2`);
      if (Mr < 2)
        throw new Error(`convertRadix: invalid to=${Mr}, base cannot be less than 2`);
      if (B(wr), !wr.length)
        return [];
      let Dr = 0;
      const Qr = [], Xr = Array.from(wr, (Ur) => {
        if (E(Ur), Ur < 0 || Ur >= qr)
          throw new Error(`invalid integer: ${Ur}`);
        return Ur;
      }), Vr = Xr.length;
      for (; ; ) {
        let Ur = 0, Sr = !0;
        for (let Gr = Dr; Gr < Vr; Gr++) {
          const Fr = Xr[Gr], br = qr * Ur, Ar = br + Fr;
          if (!Number.isSafeInteger(Ar) || br / qr !== Ur || Ar - Fr !== br)
            throw new Error("convertRadix: carry overflow");
          const cr = Ar / Mr;
          Ur = Ar % Mr;
          const hr = Math.floor(cr);
          if (Xr[Gr] = hr, !Number.isSafeInteger(hr) || hr * Mr + Ur !== Ar)
            throw new Error("convertRadix: carry overflow");
          if (Sr)
            hr ? Sr = !1 : Dr = Gr;
          else continue;
        }
        if (Qr.push(Ur), Sr)
          break;
      }
      for (let Ur = 0; Ur < wr.length - 1 && wr[Ur] === 0; Ur++)
        Qr.push(0);
      return Qr.reverse();
    }
    const fe = (wr, qr) => qr === 0 ? wr : fe(qr, wr % qr), ge = /* @__NO_SIDE_EFFECTS__ */ (wr, qr) => wr + (qr - fe(wr, qr)), Ie = /* @__PURE__ */ (() => {
      let wr = [];
      for (let qr = 0; qr < 40; qr++)
        wr.push(2 ** qr);
      return wr;
    })();
    function Ee(wr, qr, Mr, Dr) {
      if (B(wr), qr <= 0 || qr > 32)
        throw new Error(`convertRadix2: wrong from=${qr}`);
      if (Mr <= 0 || Mr > 32)
        throw new Error(`convertRadix2: wrong to=${Mr}`);
      if (/* @__PURE__ */ ge(qr, Mr) > 32)
        throw new Error(`convertRadix2: carry overflow from=${qr} to=${Mr} carryBits=${/* @__PURE__ */ ge(qr, Mr)}`);
      let Qr = 0, Xr = 0;
      const Vr = Ie[qr], Ur = Ie[Mr] - 1, Sr = [];
      for (const Gr of wr) {
        if (E(Gr), Gr >= Vr)
          throw new Error(`convertRadix2: invalid data word=${Gr} from=${qr}`);
        if (Qr = Qr << qr | Gr, Xr + qr > 32)
          throw new Error(`convertRadix2: carry overflow pos=${Xr} from=${qr}`);
        for (Xr += qr; Xr >= Mr; Xr -= Mr)
          Sr.push((Qr >> Xr - Mr & Ur) >>> 0);
        const Fr = Ie[Xr];
        if (Fr === void 0)
          throw new Error("invalid carry");
        Qr &= Fr - 1;
      }
      if (Qr = Qr << Mr - Xr & Ur, !Dr && Xr >= qr)
        throw new Error("Excess padding");
      if (!Dr && Qr > 0)
        throw new Error(`Non-zero padding: ${Qr}`);
      return Dr && Xr > 0 && Sr.push(Qr >>> 0), Sr;
    }
    // @__NO_SIDE_EFFECTS__
    function Se(wr) {
      E(wr);
      const qr = 2 ** 8;
      return {
        encode: (Mr) => {
          if (!g(Mr))
            throw new Error("radix.encode input should be Uint8Array");
          return H(Array.from(Mr), qr, wr);
        },
        decode: (Mr) => (x("radix.decode", Mr), Uint8Array.from(H(Mr, wr, qr)))
      };
    }
    // @__NO_SIDE_EFFECTS__
    function ze(wr, qr = !1) {
      if (E(wr), wr <= 0 || wr > 32)
        throw new Error("radix2: bits should be in (0..32]");
      if (/* @__PURE__ */ ge(8, wr) > 32 || /* @__PURE__ */ ge(wr, 8) > 32)
        throw new Error("radix2: carry overflow");
      return {
        encode: (Mr) => {
          if (!g(Mr))
            throw new Error("radix2.encode input should be Uint8Array");
          return Ee(Array.from(Mr), 8, wr, !qr);
        },
        decode: (Mr) => (x("radix2.decode", Mr), Uint8Array.from(Ee(Mr, wr, 8, qr)))
      };
    }
    function He(wr) {
      return t(wr), function(...qr) {
        try {
          return wr.apply(null, qr);
        } catch {
        }
      };
    }
    function Pe(wr, qr) {
      return E(wr), t(qr), {
        encode(Mr) {
          if (!g(Mr))
            throw new Error("checksum.encode: input should be Uint8Array");
          const Dr = qr(Mr).slice(0, wr), Qr = new Uint8Array(Mr.length + wr);
          return Qr.set(Mr), Qr.set(Dr, Mr.length), Qr;
        },
        decode(Mr) {
          if (!g(Mr))
            throw new Error("checksum.decode: input should be Uint8Array");
          const Dr = Mr.slice(0, -wr), Qr = Mr.slice(-wr), Xr = qr(Dr).slice(0, wr);
          for (let Vr = 0; Vr < wr; Vr++)
            if (Xr[Vr] !== Qr[Vr])
              throw new Error("Invalid checksum");
          return Dr;
        }
      };
    }
    o.utils = {
      alphabet: F,
      chain: v,
      checksum: Pe,
      convertRadix: H,
      convertRadix2: Ee,
      radix: Se,
      radix2: ze,
      join: M,
      padding: U
    }, o.base16 = /* @__PURE__ */ v(/* @__PURE__ */ ze(4), /* @__PURE__ */ F("0123456789ABCDEF"), /* @__PURE__ */ M("")), o.base32 = /* @__PURE__ */ v(/* @__PURE__ */ ze(5), /* @__PURE__ */ F("ABCDEFGHIJKLMNOPQRSTUVWXYZ234567"), /* @__PURE__ */ U(5), /* @__PURE__ */ M("")), o.base32nopad = /* @__PURE__ */ v(/* @__PURE__ */ ze(5), /* @__PURE__ */ F("ABCDEFGHIJKLMNOPQRSTUVWXYZ234567"), /* @__PURE__ */ M("")), o.base32hex = /* @__PURE__ */ v(/* @__PURE__ */ ze(5), /* @__PURE__ */ F("0123456789ABCDEFGHIJKLMNOPQRSTUV"), /* @__PURE__ */ U(5), /* @__PURE__ */ M("")), o.base32hexnopad = /* @__PURE__ */ v(/* @__PURE__ */ ze(5), /* @__PURE__ */ F("0123456789ABCDEFGHIJKLMNOPQRSTUV"), /* @__PURE__ */ M("")), o.base32crockford = /* @__PURE__ */ v(/* @__PURE__ */ ze(5), /* @__PURE__ */ F("0123456789ABCDEFGHJKMNPQRSTVWXYZ"), /* @__PURE__ */ M(""), /* @__PURE__ */ L((wr) => wr.toUpperCase().replace(/O/g, "0").replace(/[IL]/g, "1")));
    const De = typeof Uint8Array.from([]).toBase64 == "function" && typeof Uint8Array.fromBase64 == "function", ve = (wr, qr) => {
      d("base64", wr);
      const Mr = qr ? /^[A-Za-z0-9=_-]+$/ : /^[A-Za-z0-9=+/]+$/, Dr = qr ? "base64url" : "base64";
      if (wr.length > 0 && !Mr.test(wr))
        throw new Error("invalid base64");
      return Uint8Array.fromBase64(wr, { alphabet: Dr, lastChunkHandling: "strict" });
    };
    o.base64 = De ? {
      encode(wr) {
        return c(wr), wr.toBase64();
      },
      decode(wr) {
        return ve(wr, !1);
      }
    } : /* @__PURE__ */ v(/* @__PURE__ */ ze(6), /* @__PURE__ */ F("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/"), /* @__PURE__ */ U(6), /* @__PURE__ */ M("")), o.base64nopad = /* @__PURE__ */ v(/* @__PURE__ */ ze(6), /* @__PURE__ */ F("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/"), /* @__PURE__ */ M("")), o.base64url = De ? {
      encode(wr) {
        return c(wr), wr.toBase64({ alphabet: "base64url" });
      },
      decode(wr) {
        return ve(wr, !0);
      }
    } : /* @__PURE__ */ v(/* @__PURE__ */ ze(6), /* @__PURE__ */ F("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_"), /* @__PURE__ */ U(6), /* @__PURE__ */ M("")), o.base64urlnopad = /* @__PURE__ */ v(/* @__PURE__ */ ze(6), /* @__PURE__ */ F("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_"), /* @__PURE__ */ M(""));
    const Fe = /* @__NO_SIDE_EFFECTS__ */ (wr) => /* @__PURE__ */ v(/* @__PURE__ */ Se(58), /* @__PURE__ */ F(wr), /* @__PURE__ */ M(""));
    o.base58 = /* @__PURE__ */ Fe("123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz"), o.base58flickr = /* @__PURE__ */ Fe("123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ"), o.base58xrp = /* @__PURE__ */ Fe("rpshnaf39wBUDNEGHJKLM4PQRST7VWXYZ2bcdeCg65jkm8oFqi1tuvAxyz");
    const be = [0, 2, 3, 5, 6, 7, 9, 10, 11];
    o.base58xmr = {
      encode(wr) {
        let qr = "";
        for (let Mr = 0; Mr < wr.length; Mr += 8) {
          const Dr = wr.subarray(Mr, Mr + 8);
          qr += o.base58.encode(Dr).padStart(be[Dr.length], "1");
        }
        return qr;
      },
      decode(wr) {
        let qr = [];
        for (let Mr = 0; Mr < wr.length; Mr += 11) {
          const Dr = wr.slice(Mr, Mr + 11), Qr = be.indexOf(Dr.length), Xr = o.base58.decode(Dr);
          for (let Vr = 0; Vr < Xr.length - Qr; Vr++)
            if (Xr[Vr] !== 0)
              throw new Error("base58xmr: wrong padding");
          qr = qr.concat(Array.from(Xr.slice(Xr.length - Qr)));
        }
        return Uint8Array.from(qr);
      }
    };
    const Be = (wr) => /* @__PURE__ */ v(Pe(4, (qr) => wr(wr(qr))), o.base58);
    o.createBase58check = Be, o.base58check = o.createBase58check;
    const ke = /* @__PURE__ */ v(/* @__PURE__ */ F("qpzry9x8gf2tvdw0s3jn54khce6mua7l"), /* @__PURE__ */ M("")), xe = [996825010, 642813549, 513874426, 1027748829, 705979059];
    function Ne(wr) {
      const qr = wr >> 25;
      let Mr = (wr & 33554431) << 5;
      for (let Dr = 0; Dr < xe.length; Dr++)
        (qr >> Dr & 1) === 1 && (Mr ^= xe[Dr]);
      return Mr;
    }
    function Et(wr, qr, Mr = 1) {
      const Dr = wr.length;
      let Qr = 1;
      for (let Xr = 0; Xr < Dr; Xr++) {
        const Vr = wr.charCodeAt(Xr);
        if (Vr < 33 || Vr > 126)
          throw new Error(`Invalid prefix (${wr})`);
        Qr = Ne(Qr) ^ Vr >> 5;
      }
      Qr = Ne(Qr);
      for (let Xr = 0; Xr < Dr; Xr++)
        Qr = Ne(Qr) ^ wr.charCodeAt(Xr) & 31;
      for (let Xr of qr)
        Qr = Ne(Qr) ^ Xr;
      for (let Xr = 0; Xr < 6; Xr++)
        Qr = Ne(Qr);
      return Qr ^= Mr, ke.encode(Ee([Qr % Ie[30]], 30, 5, !1));
    }
    // @__NO_SIDE_EFFECTS__
    function st(wr) {
      const qr = wr === "bech32" ? 1 : 734539939, Mr = /* @__PURE__ */ ze(5), Dr = Mr.decode, Qr = Mr.encode, Xr = He(Dr);
      function Vr(br, Ar, cr = 90) {
        d("bech32.encode prefix", br), g(Ar) && (Ar = Array.from(Ar)), x("bech32.encode", Ar);
        const hr = br.length;
        if (hr === 0)
          throw new TypeError(`Invalid prefix length ${hr}`);
        const Wr = hr + 7 + Ar.length;
        if (cr !== !1 && Wr > cr)
          throw new TypeError(`Length ${Wr} exceeds limit ${cr}`);
        const fi = br.toLowerCase(), Bi = Et(fi, Ar, qr);
        return `${fi}1${ke.encode(Ar)}${Bi}`;
      }
      function Ur(br, Ar = 90) {
        d("bech32.decode input", br);
        const cr = br.length;
        if (cr < 8 || Ar !== !1 && cr > Ar)
          throw new TypeError(`invalid string length: ${cr} (${br}). Expected (8..${Ar})`);
        const hr = br.toLowerCase();
        if (br !== hr && br !== br.toUpperCase())
          throw new Error("String must be lowercase or uppercase");
        const Wr = hr.lastIndexOf("1");
        if (Wr === 0 || Wr === -1)
          throw new Error('Letter "1" must be present between prefix and data only');
        const fi = hr.slice(0, Wr), Bi = hr.slice(Wr + 1);
        if (Bi.length < 6)
          throw new Error("Data must be at least 6 characters long");
        const $r = ke.decode(Bi).slice(0, -6), oi = Et(fi, $r, qr);
        if (!Bi.endsWith(oi))
          throw new Error(`Invalid checksum in ${br}: expected "${oi}"`);
        return { prefix: fi, words: $r };
      }
      const Sr = He(Ur);
      function Gr(br) {
        const { prefix: Ar, words: cr } = Ur(br, !1);
        return { prefix: Ar, words: cr, bytes: Dr(cr) };
      }
      function Fr(br, Ar) {
        return Vr(br, Qr(Ar));
      }
      return {
        encode: Vr,
        decode: Ur,
        encodeFromBytes: Fr,
        decodeToBytes: Gr,
        decodeUnsafe: Sr,
        fromWords: Dr,
        fromWordsUnsafe: Xr,
        toWords: Qr
      };
    }
    o.bech32 = /* @__PURE__ */ st("bech32"), o.bech32m = /* @__PURE__ */ st("bech32m"), o.utf8 = {
      encode: (wr) => new TextDecoder().decode(wr),
      decode: (wr) => new TextEncoder().encode(wr)
    };
    const Dt = typeof Uint8Array.from([]).toHex == "function" && typeof Uint8Array.fromHex == "function", er = {
      encode(wr) {
        return c(wr), wr.toHex();
      },
      decode(wr) {
        return d("hex", wr), Uint8Array.fromHex(wr);
      }
    };
    o.hex = Dt ? er : /* @__PURE__ */ v(/* @__PURE__ */ ze(4), /* @__PURE__ */ F("0123456789abcdef"), /* @__PURE__ */ M(""), /* @__PURE__ */ L((wr) => {
      if (typeof wr != "string" || wr.length % 2 !== 0)
        throw new TypeError(`hex.decode: expected string, got ${typeof wr} with length ${wr.length}`);
      return wr.toLowerCase();
    }));
    const xt = {
      utf8: o.utf8,
      hex: o.hex,
      base16: o.base16,
      base32: o.base32,
      base64: o.base64,
      base64url: o.base64url,
      base58: o.base58,
      base58xmr: o.base58xmr
    }, ir = "Invalid encoding type. Available types: utf8, hex, base16, base32, base64, base64url, base58, base58xmr", sr = (wr, qr) => {
      if (typeof wr != "string" || !xt.hasOwnProperty(wr))
        throw new TypeError(ir);
      if (!g(qr))
        throw new TypeError("bytesToString() expects Uint8Array");
      return xt[wr].encode(qr);
    };
    o.bytesToString = sr, o.str = o.bytesToString;
    const yr = (wr, qr) => {
      if (!xt.hasOwnProperty(wr))
        throw new TypeError(ir);
      if (typeof qr != "string")
        throw new TypeError("stringToBytes() expects string");
      return xt[wr].decode(qr);
    };
    o.stringToBytes = yr, o.bytes = o.stringToBytes;
  }(lib$2)), lib$2;
}
var wif, hasRequiredWif;
function requireWif() {
  if (hasRequiredWif) return wif;
  hasRequiredWif = 1;
  var o = requireBs58check$1();
  function g(d, E) {
    if (E !== void 0 && d[0] !== E) throw new Error("Invalid network version");
    if (d.length === 33)
      return {
        version: d[0],
        privateKey: d.slice(1, 33),
        compressed: !1
      };
    if (d.length !== 34) throw new Error("Invalid WIF length");
    if (d[33] !== 1) throw new Error("Invalid compression flag");
    return {
      version: d[0],
      privateKey: d.slice(1, 33),
      compressed: !0
    };
  }
  function c(d, E, B) {
    var D = new Buffer(B ? 34 : 33);
    return D.writeUInt8(d, 0), E.copy(D, 1), B && (D[33] = 1), D;
  }
  function y(d, E) {
    return g(o.decode(d), E);
  }
  function t(d, E, B) {
    return typeof d == "number" ? o.encode(c(d, E, B)) : o.encode(
      c(
        d.version,
        d.privateKey,
        d.compressed
      )
    );
  }
  return wif = {
    decode: y,
    decodeRaw: g,
    encode: t,
    encodeRaw: c
  }, wif;
}
var hasRequiredBip32$3;
function requireBip32$3() {
  if (hasRequiredBip32$3) return bip32$3;
  hasRequiredBip32$3 = 1, Object.defineProperty(bip32$3, "__esModule", { value: !0 }), bip32$3.BIP32Factory = void 0;
  const o = requireCrypto(), g = requireTestecc$1(), c = /* @__PURE__ */ requireLib$2(), y = /* @__PURE__ */ requireSha256$1(), t = requireTypeforce(), d = requireWif(), E = (0, c.base58check)(y.sha256), B = {
    encode: (x) => E.encode(Uint8Array.from(x)),
    decode: (x) => Buffer.from(E.decode(x))
  };
  function D(x) {
    (0, g.testEcc)(x);
    const v = t.BufferN(32), F = t.compile({
      wif: t.UInt8,
      bip32: {
        public: t.UInt32,
        private: t.UInt32
      }
    }), M = {
      messagePrefix: `Bitcoin Signed Message:
`,
      bech32: "bc",
      bip32: {
        public: 76067358,
        private: 76066276
      },
      pubKeyHash: 0,
      scriptHash: 5,
      wif: 128
    }, U = 2147483648, L = Math.pow(2, 31) - 1;
    function H(Fe) {
      return t.String(Fe) && Fe.match(/^(m\/)?(\d+'?\/)*\d+'?$/) !== null;
    }
    function fe(Fe) {
      return t.UInt32(Fe) && Fe <= L;
    }
    function ge(Fe) {
      return Fe.length === 32 ? Fe : Fe.slice(1, 33);
    }
    class Ie {
      constructor(be, Be) {
        this.__D = be, this.__Q = Be, this.lowR = !1;
      }
      get publicKey() {
        return this.__Q === void 0 && (this.__Q = Buffer.from(x.pointFromScalar(this.__D, !0))), this.__Q;
      }
      get privateKey() {
        return this.__D;
      }
      sign(be, Be) {
        if (!this.privateKey)
          throw new Error("Missing private key");
        if (Be === void 0 && (Be = this.lowR), Be === !1)
          return Buffer.from(x.sign(be, this.privateKey));
        {
          let ke = Buffer.from(x.sign(be, this.privateKey));
          const xe = Buffer.alloc(32, 0);
          let Ne = 0;
          for (; ke[0] > 127; )
            Ne++, xe.writeUIntLE(Ne, 0, 6), ke = Buffer.from(x.sign(be, this.privateKey, xe));
          return ke;
        }
      }
      signSchnorr(be) {
        if (!this.privateKey)
          throw new Error("Missing private key");
        if (!x.signSchnorr)
          throw new Error("signSchnorr not supported by ecc library");
        return Buffer.from(x.signSchnorr(be, this.privateKey));
      }
      verify(be, Be) {
        return x.verify(be, this.publicKey, Be);
      }
      verifySchnorr(be, Be) {
        if (!x.verifySchnorr)
          throw new Error("verifySchnorr not supported by ecc library");
        return x.verifySchnorr(be, this.publicKey.subarray(1, 33), Be);
      }
    }
    class Ee extends Ie {
      constructor(be, Be, ke, xe, Ne = 0, Et = 0, st = 0) {
        super(be, Be), this.chainCode = ke, this.network = xe, this.__DEPTH = Ne, this.__INDEX = Et, this.__PARENT_FINGERPRINT = st, t(F, xe);
      }
      get depth() {
        return this.__DEPTH;
      }
      get index() {
        return this.__INDEX;
      }
      get parentFingerprint() {
        return this.__PARENT_FINGERPRINT;
      }
      get identifier() {
        return o.hash160(this.publicKey);
      }
      get fingerprint() {
        return this.identifier.slice(0, 4);
      }
      get compressed() {
        return !0;
      }
      // Private === not neutered
      // Public === neutered
      isNeutered() {
        return this.__D === void 0;
      }
      neutered() {
        return De(this.publicKey, this.chainCode, this.network, this.depth, this.index, this.parentFingerprint);
      }
      toBase58() {
        const be = this.network, Be = this.isNeutered() ? be.bip32.public : be.bip32.private, ke = Buffer.allocUnsafe(78);
        return ke.writeUInt32BE(Be, 0), ke.writeUInt8(this.depth, 4), ke.writeUInt32BE(this.parentFingerprint, 5), ke.writeUInt32BE(this.index, 9), this.chainCode.copy(ke, 13), this.isNeutered() ? this.publicKey.copy(ke, 45) : (ke.writeUInt8(0, 45), this.privateKey.copy(ke, 46)), B.encode(ke);
      }
      toWIF() {
        if (!this.privateKey)
          throw new TypeError("Missing private key");
        return d.encode(this.network.wif, this.privateKey, !0);
      }
      // https://github.com/bitcoin/bips/blob/master/bip-0032.mediawiki#child-key-derivation-ckd-functions
      derive(be) {
        t(t.UInt32, be);
        const Be = be >= U, ke = Buffer.allocUnsafe(37);
        if (Be) {
          if (this.isNeutered())
            throw new TypeError("Missing private key for hardened child key");
          ke[0] = 0, this.privateKey.copy(ke, 1), ke.writeUInt32BE(be, 33);
        } else
          this.publicKey.copy(ke, 0), ke.writeUInt32BE(be, 33);
        const xe = o.hmacSHA512(this.chainCode, ke), Ne = xe.slice(0, 32), Et = xe.slice(32);
        if (!x.isPrivate(Ne))
          return this.derive(be + 1);
        let st;
        if (this.isNeutered()) {
          const Dt = Buffer.from(x.pointAddScalar(this.publicKey, Ne, !0));
          if (Dt === null)
            return this.derive(be + 1);
          st = De(Dt, Et, this.network, this.depth + 1, be, this.fingerprint.readUInt32BE(0));
        } else {
          const Dt = Buffer.from(x.privateAdd(this.privateKey, Ne));
          if (Dt == null)
            return this.derive(be + 1);
          st = He(Dt, Et, this.network, this.depth + 1, be, this.fingerprint.readUInt32BE(0));
        }
        return st;
      }
      deriveHardened(be) {
        return t(fe, be), this.derive(be + U);
      }
      derivePath(be) {
        t(H, be);
        let Be = be.split("/");
        if (Be[0] === "m") {
          if (this.parentFingerprint)
            throw new TypeError("Expected master, got child");
          Be = Be.slice(1);
        }
        return Be.reduce((ke, xe) => {
          let Ne;
          return xe.slice(-1) === "'" ? (Ne = parseInt(xe.slice(0, -1), 10), ke.deriveHardened(Ne)) : (Ne = parseInt(xe, 10), ke.derive(Ne));
        }, this);
      }
      tweak(be) {
        return this.privateKey ? this.tweakFromPrivateKey(be) : this.tweakFromPublicKey(be);
      }
      tweakFromPublicKey(be) {
        const Be = ge(this.publicKey);
        if (!x.xOnlyPointAddTweak)
          throw new Error("xOnlyPointAddTweak not supported by ecc library");
        const ke = x.xOnlyPointAddTweak(Be, be);
        if (!ke || ke.xOnlyPubkey === null)
          throw new Error("Cannot tweak public key!");
        const xe = Buffer.from([
          ke.parity === 0 ? 2 : 3
        ]), Ne = Buffer.concat([
          xe,
          ke.xOnlyPubkey
        ]);
        return new Ie(void 0, Ne);
      }
      tweakFromPrivateKey(be) {
        const Be = this.publicKey[0] === 3 || this.publicKey[0] === 4 && (this.publicKey[64] & 1) === 1, ke = (() => {
          if (Be) {
            if (x.privateNegate)
              return x.privateNegate(this.privateKey);
            throw new Error("privateNegate not supported by ecc library");
          } else return this.privateKey;
        })(), xe = x.privateAdd(ke, be);
        if (!xe)
          throw new Error("Invalid tweaked private key!");
        return new Ie(Buffer.from(xe), void 0);
      }
    }
    function Se(Fe, be) {
      const Be = B.decode(Fe);
      if (Be.length !== 78)
        throw new TypeError("Invalid buffer length");
      be = be || M;
      const ke = Be.readUInt32BE(0);
      if (ke !== be.bip32.private && ke !== be.bip32.public)
        throw new TypeError("Invalid network version");
      const xe = Be[4], Ne = Be.readUInt32BE(5);
      if (xe === 0 && Ne !== 0)
        throw new TypeError("Invalid parent fingerprint");
      const Et = Be.readUInt32BE(9);
      if (xe === 0 && Et !== 0)
        throw new TypeError("Invalid index");
      const st = Be.slice(13, 45);
      let Dt;
      if (ke === be.bip32.private) {
        if (Be.readUInt8(45) !== 0)
          throw new TypeError("Invalid private key");
        const er = Be.slice(46, 78);
        Dt = He(er, st, be, xe, Et, Ne);
      } else {
        const er = Be.slice(45, 78);
        Dt = De(er, st, be, xe, Et, Ne);
      }
      return Dt;
    }
    function ze(Fe, be, Be) {
      return He(Fe, be, Be);
    }
    function He(Fe, be, Be, ke, xe, Ne) {
      if (t({
        privateKey: v,
        chainCode: v
      }, { privateKey: Fe, chainCode: be }), Be = Be || M, !x.isPrivate(Fe))
        throw new TypeError("Private key not in range [1, n)");
      return new Ee(Fe, void 0, be, Be, ke, xe, Ne);
    }
    function Pe(Fe, be, Be) {
      return De(Fe, be, Be);
    }
    function De(Fe, be, Be, ke, xe, Ne) {
      if (t({
        publicKey: t.BufferN(33),
        chainCode: v
      }, { publicKey: Fe, chainCode: be }), Be = Be || M, !x.isPoint(Fe))
        throw new TypeError("Point is not on the curve");
      return new Ee(void 0, Fe, be, Be, ke, xe, Ne);
    }
    function ve(Fe, be) {
      if (t(t.Buffer, Fe), Fe.length < 16)
        throw new TypeError("Seed should be at least 128 bits");
      if (Fe.length > 64)
        throw new TypeError("Seed should be at most 512 bits");
      be = be || M;
      const Be = o.hmacSHA512(Buffer.from("Bitcoin seed", "utf8"), Fe), ke = Be.slice(0, 32), xe = Be.slice(32);
      return ze(ke, xe, be);
    }
    return {
      fromSeed: ve,
      fromBase58: Se,
      fromPublicKey: Pe,
      fromPrivateKey: ze
    };
  }
  return bip32$3.BIP32Factory = D, bip32$3;
}
var hasRequiredSrc$1;
function requireSrc$1() {
  return hasRequiredSrc$1 || (hasRequiredSrc$1 = 1, function(o) {
    Object.defineProperty(o, "__esModule", { value: !0 }), o.BIP32Factory = o.default = void 0;
    var g = requireBip32$3();
    Object.defineProperty(o, "default", { enumerable: !0, get: function() {
      return g.BIP32Factory;
    } }), Object.defineProperty(o, "BIP32Factory", { enumerable: !0, get: function() {
      return g.BIP32Factory;
    } });
  }(src$1)), src$1;
}
var src = {}, ecpair = {}, networks = {}, hasRequiredNetworks;
function requireNetworks() {
  return hasRequiredNetworks || (hasRequiredNetworks = 1, Object.defineProperty(networks, "__esModule", { value: !0 }), networks.testnet = networks.bitcoin = void 0, networks.bitcoin = {
    messagePrefix: `Bitcoin Signed Message:
`,
    bech32: "bc",
    bip32: {
      public: 76067358,
      private: 76066276
    },
    pubKeyHash: 0,
    scriptHash: 5,
    wif: 128
  }, networks.testnet = {
    messagePrefix: `Bitcoin Signed Message:
`,
    bech32: "tb",
    bip32: {
      public: 70617039,
      private: 70615956
    },
    pubKeyHash: 111,
    scriptHash: 196,
    wif: 239
  }), networks;
}
var types$2 = {}, hasRequiredTypes$2;
function requireTypes$2() {
  return hasRequiredTypes$2 || (hasRequiredTypes$2 = 1, function(o) {
    Object.defineProperty(o, "__esModule", { value: !0 }), o.maybe = o.Boolean = o.Array = o.Buffer256bit = o.Network = o.typeforce = void 0, o.typeforce = requireTypeforce(), o.Network = o.typeforce.compile({
      messagePrefix: o.typeforce.oneOf(
        o.typeforce.Buffer,
        o.typeforce.String
      ),
      bip32: {
        public: o.typeforce.UInt32,
        private: o.typeforce.UInt32
      },
      pubKeyHash: o.typeforce.UInt8,
      scriptHash: o.typeforce.UInt8,
      wif: o.typeforce.UInt8
    }), o.Buffer256bit = o.typeforce.BufferN(32), o.Array = o.typeforce.Array, o.Boolean = o.typeforce.Boolean, o.maybe = o.typeforce.maybe;
  }(types$2)), types$2;
}
var testecc = {}, hasRequiredTestecc;
function requireTestecc() {
  if (hasRequiredTestecc) return testecc;
  hasRequiredTestecc = 1, Object.defineProperty(testecc, "__esModule", { value: !0 }), testecc.testEcc = void 0;
  const o = (y) => Buffer.from(y, "hex");
  function g(y) {
    c(
      y.isPoint(
        o("0279be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798")
      )
    ), c(
      !y.isPoint(
        o("030000000000000000000000000000000000000000000000000000000000000005")
      )
    ), c(
      y.isPrivate(
        o("79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798")
      )
    ), c(
      y.isPrivate(
        o("fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364140")
      )
    ), c(
      !y.isPrivate(
        o("0000000000000000000000000000000000000000000000000000000000000000")
      )
    ), c(
      !y.isPrivate(
        o("fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141")
      )
    ), c(
      !y.isPrivate(
        o("fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364142")
      )
    ), c(
      Buffer.from(
        y.privateAdd(
          o("0000000000000000000000000000000000000000000000000000000000000001"),
          o("0000000000000000000000000000000000000000000000000000000000000000")
        )
      ).equals(
        o("0000000000000000000000000000000000000000000000000000000000000001")
      )
    ), c(
      y.privateAdd(
        o("fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd036413e"),
        o("0000000000000000000000000000000000000000000000000000000000000003")
      ) === null
    ), c(
      Buffer.from(
        y.privateAdd(
          o("e211078564db65c3ce7704f08262b1f38f1ef412ad15b5ac2d76657a63b2c500"),
          o("b51fbb69051255d1becbd683de5848242a89c229348dd72896a87ada94ae8665")
        )
      ).equals(
        o("9730c2ee69edbb958d42db7460bafa18fef9d955325aec99044c81c8282b0a24")
      )
    ), c(
      Buffer.from(
        y.privateNegate(
          o("0000000000000000000000000000000000000000000000000000000000000001")
        )
      ).equals(
        o("fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364140")
      )
    ), c(
      Buffer.from(
        y.privateNegate(
          o("fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd036413e")
        )
      ).equals(
        o("0000000000000000000000000000000000000000000000000000000000000003")
      )
    ), c(
      Buffer.from(
        y.privateNegate(
          o("b1121e4088a66a28f5b6b0f5844943ecd9f610196d7bb83b25214b60452c09af")
        )
      ).equals(
        o("4eede1bf775995d70a494f0a7bb6bc11e0b8cccd41cce8009ab1132c8b0a3792")
      )
    ), c(
      Buffer.from(
        y.pointCompress(
          o(
            "0479be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8"
          ),
          !0
        )
      ).equals(
        o("0279be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798")
      )
    ), c(
      Buffer.from(
        y.pointCompress(
          o(
            "0479be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8"
          ),
          !1
        )
      ).equals(
        o(
          "0479be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8"
        )
      )
    ), c(
      Buffer.from(
        y.pointCompress(
          o("0279be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798"),
          !0
        )
      ).equals(
        o("0279be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798")
      )
    ), c(
      Buffer.from(
        y.pointCompress(
          o("0279be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798"),
          !1
        )
      ).equals(
        o(
          "0479be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8"
        )
      )
    ), c(
      Buffer.from(
        y.pointFromScalar(
          o("b1121e4088a66a28f5b6b0f5844943ecd9f610196d7bb83b25214b60452c09af")
        )
      ).equals(
        o("02b07ba9dca9523b7ef4bd97703d43d20399eb698e194704791a25ce77a400df99")
      )
    ), c(
      y.xOnlyPointAddTweak(
        o("79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798"),
        o("fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364140")
      ) === null
    );
    let t = y.xOnlyPointAddTweak(
      o("1617d38ed8d8657da4d4761e8057bc396ea9e4b9d29776d4be096016dbd2509b"),
      o("a8397a935f0dfceba6ba9618f6451ef4d80637abf4e6af2669fbc9de6a8fd2ac")
    );
    c(
      Buffer.from(t.xOnlyPubkey).equals(
        o("e478f99dab91052ab39a33ea35fd5e6e4933f4d28023cd597c9a1f6760346adf")
      ) && t.parity === 1
    ), t = y.xOnlyPointAddTweak(
      o("2c0b7cf95324a07d05398b240174dc0c2be444d96b159aa6c7f7b1e668680991"),
      o("823c3cd2142744b075a87eade7e1b8678ba308d566226a0056ca2b7a76f86b47")
    ), c(
      Buffer.from(t.xOnlyPubkey).equals(
        o("9534f8dc8c6deda2dc007655981c78b49c5d96c778fbf363462a11ec9dfd948c")
      ) && t.parity === 0
    ), c(
      Buffer.from(
        y.sign(
          o("5e9f0a0d593efdcf78ac923bc3313e4e7d408d574354ee2b3288c0da9fbba6ed"),
          o("fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364140")
        )
      ).equals(
        o(
          "54c4a33c6423d689378f160a7ff8b61330444abb58fb470f96ea16d99d4a2fed07082304410efa6b2943111b6a4e0aaa7b7db55a07e9861d1fb3cb1f421044a5"
        )
      )
    ), c(
      y.verify(
        o("5e9f0a0d593efdcf78ac923bc3313e4e7d408d574354ee2b3288c0da9fbba6ed"),
        o("0379be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798"),
        o(
          "54c4a33c6423d689378f160a7ff8b61330444abb58fb470f96ea16d99d4a2fed07082304410efa6b2943111b6a4e0aaa7b7db55a07e9861d1fb3cb1f421044a5"
        )
      )
    ), y.signSchnorr && c(
      Buffer.from(
        y.signSchnorr(
          o("7e2d58d8b3bcdf1abadec7829054f90dda9805aab56c77333024b9d0a508b75c"),
          o("c90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b14e5c9"),
          o("c87aa53824b4d7ae2eb035a2b5bbbccc080e76cdc6d1692c4b0b62d798e6d906")
        )
      ).equals(
        o(
          "5831aaeed7b44bb74e5eab94ba9d4294c49bcf2a60728d8b4c200f50dd313c1bab745879a5ad954a72c45a91c3a51d3c7adea98d82f8481e0e1e03674a6f3fb7"
        )
      )
    ), y.verifySchnorr && c(
      y.verifySchnorr(
        o("7e2d58d8b3bcdf1abadec7829054f90dda9805aab56c77333024b9d0a508b75c"),
        o("dd308afec5777e13121fa72b9cc1b7cc0139715309b086c960e18fd969774eb8"),
        o(
          "5831aaeed7b44bb74e5eab94ba9d4294c49bcf2a60728d8b4c200f50dd313c1bab745879a5ad954a72c45a91c3a51d3c7adea98d82f8481e0e1e03674a6f3fb7"
        )
      )
    );
  }
  testecc.testEcc = g;
  function c(y) {
    if (!y) throw new Error("ecc library invalid");
  }
  return testecc;
}
var hasRequiredEcpair;
function requireEcpair() {
  if (hasRequiredEcpair) return ecpair;
  hasRequiredEcpair = 1, Object.defineProperty(ecpair, "__esModule", { value: !0 }), ecpair.ECPairFactory = ecpair.networks = void 0;
  const o = requireNetworks();
  ecpair.networks = o;
  const g = requireTypes$2(), c = requireBrowser$9(), y = requireWif(), t = requireTestecc(), d = g.typeforce.maybe(
    g.typeforce.compile({
      compressed: g.maybe(g.Boolean),
      network: g.maybe(g.Network)
    })
  ), E = (D) => D.length === 32 ? D : D.slice(1, 33);
  function B(D) {
    (0, t.testEcc)(D);
    function x(H) {
      return D.isPoint(H);
    }
    function v(H, fe) {
      if (g.typeforce(g.Buffer256bit, H), !D.isPrivate(H))
        throw new TypeError("Private key not in range [1, n)");
      return g.typeforce(d, fe), new L(H, void 0, fe);
    }
    function F(H, fe) {
      return g.typeforce(D.isPoint, H), g.typeforce(d, fe), new L(void 0, H, fe);
    }
    function M(H, fe) {
      const ge = y.decode(H), Ie = ge.version;
      if (g.Array(fe)) {
        if (fe = fe.filter((Ee) => Ie === Ee.wif).pop(), !fe) throw new Error("Unknown network version");
      } else if (fe = fe || o.bitcoin, Ie !== fe.wif) throw new Error("Invalid network version");
      return v(ge.privateKey, {
        compressed: ge.compressed,
        network: fe
      });
    }
    function U(H) {
      g.typeforce(d, H), H === void 0 && (H = {});
      const fe = H.rng || c;
      let ge;
      do
        ge = fe(32), g.typeforce(g.Buffer256bit, ge);
      while (!D.isPrivate(ge));
      return v(ge, H);
    }
    class L {
      constructor(fe, ge, Ie) {
        Vi(this, "__D");
        Vi(this, "__Q");
        Vi(this, "compressed");
        Vi(this, "network");
        Vi(this, "lowR");
        this.__D = fe, this.__Q = ge, this.lowR = !1, Ie === void 0 && (Ie = {}), this.compressed = Ie.compressed === void 0 ? !0 : Ie.compressed, this.network = Ie.network || o.bitcoin, ge !== void 0 && (this.__Q = Buffer.from(D.pointCompress(ge, this.compressed)));
      }
      get privateKey() {
        return this.__D;
      }
      get publicKey() {
        if (!this.__Q) {
          const fe = D.pointFromScalar(this.__D, this.compressed);
          this.__Q = Buffer.from(fe);
        }
        return this.__Q;
      }
      toWIF() {
        if (!this.__D) throw new Error("Missing private key");
        return y.encode(this.network.wif, this.__D, this.compressed);
      }
      tweak(fe) {
        return this.privateKey ? this.tweakFromPrivateKey(fe) : this.tweakFromPublicKey(fe);
      }
      sign(fe, ge) {
        if (!this.__D) throw new Error("Missing private key");
        if (ge === void 0 && (ge = this.lowR), ge === !1)
          return Buffer.from(D.sign(fe, this.__D));
        {
          let Ie = D.sign(fe, this.__D);
          const Ee = Buffer.alloc(32, 0);
          let Se = 0;
          for (; Ie[0] > 127; )
            Se++, Ee.writeUIntLE(Se, 0, 6), Ie = D.sign(fe, this.__D, Ee);
          return Buffer.from(Ie);
        }
      }
      signSchnorr(fe) {
        if (!this.privateKey) throw new Error("Missing private key");
        if (!D.signSchnorr)
          throw new Error("signSchnorr not supported by ecc library");
        return Buffer.from(D.signSchnorr(fe, this.privateKey));
      }
      verify(fe, ge) {
        return D.verify(fe, this.publicKey, ge);
      }
      verifySchnorr(fe, ge) {
        if (!D.verifySchnorr)
          throw new Error("verifySchnorr not supported by ecc library");
        return D.verifySchnorr(fe, this.publicKey.subarray(1, 33), ge);
      }
      tweakFromPublicKey(fe) {
        const ge = E(this.publicKey), Ie = D.xOnlyPointAddTweak(ge, fe);
        if (!Ie || Ie.xOnlyPubkey === null)
          throw new Error("Cannot tweak public key!");
        const Ee = Buffer.from([
          Ie.parity === 0 ? 2 : 3
        ]);
        return F(
          Buffer.concat([Ee, Ie.xOnlyPubkey]),
          { network: this.network, compressed: this.compressed }
        );
      }
      tweakFromPrivateKey(fe) {
        const Ie = this.publicKey[0] === 3 || this.publicKey[0] === 4 && (this.publicKey[64] & 1) === 1 ? D.privateNegate(this.privateKey) : this.privateKey, Ee = D.privateAdd(Ie, fe);
        if (!Ee) throw new Error("Invalid tweaked private key!");
        return v(Buffer.from(Ee), {
          network: this.network,
          compressed: this.compressed
        });
      }
    }
    return {
      isPoint: x,
      fromPrivateKey: v,
      fromPublicKey: F,
      fromWIF: M,
      makeRandom: U
    };
  }
  return ecpair.ECPairFactory = B, ecpair;
}
var hasRequiredSrc;
function requireSrc() {
  return hasRequiredSrc || (hasRequiredSrc = 1, function(o) {
    Object.defineProperty(o, "__esModule", { value: !0 }), o.networks = o.ECPairFactory = o.default = void 0;
    var g = requireEcpair();
    Object.defineProperty(o, "default", {
      enumerable: !0,
      get: function() {
        return g.ECPairFactory;
      }
    }), Object.defineProperty(o, "ECPairFactory", {
      enumerable: !0,
      get: function() {
        return g.ECPairFactory;
      }
    }), Object.defineProperty(o, "networks", {
      enumerable: !0,
      get: function() {
        return g.networks;
      }
    });
  }(src)), src;
}
var psbt$2 = {}, hasRequiredPsbt$2;
function requirePsbt$2() {
  if (hasRequiredPsbt$2) return psbt$2;
  hasRequiredPsbt$2 = 1;
  var o = psbt$2 && psbt$2.__createBinding || (Object.create ? function(x, v, F, M) {
    M === void 0 && (M = F);
    var U = Object.getOwnPropertyDescriptor(v, F);
    (!U || ("get" in U ? !v.__esModule : U.writable || U.configurable)) && (U = { enumerable: !0, get: function() {
      return v[F];
    } }), Object.defineProperty(x, M, U);
  } : function(x, v, F, M) {
    M === void 0 && (M = F), x[M] = v[F];
  }), g = psbt$2 && psbt$2.__setModuleDefault || (Object.create ? function(x, v) {
    Object.defineProperty(x, "default", { enumerable: !0, value: v });
  } : function(x, v) {
    x.default = v;
  }), c = psbt$2 && psbt$2.__importStar || function(x) {
    if (x && x.__esModule) return x;
    var v = {};
    if (x != null) for (var F in x) F !== "default" && Object.prototype.hasOwnProperty.call(x, F) && o(v, x, F);
    return g(v, x), v;
  };
  Object.defineProperty(psbt$2, "__esModule", { value: !0 }), psbt$2.updatePsbt = psbt$2.finalScriptsFuncFactory = void 0;
  const y = require$$1, t = c(requireVarint$3());
  function d(x) {
    if (x.length < 1)
      return x;
    let v = x.length - 1, F = 0;
    for (let M = 0; M < x.length / 2; M++)
      F = x[M], x[M] = x[v], x[v] = F, v--;
    return x;
  }
  function E(x) {
    let v = Buffer.allocUnsafe(0);
    function F(H) {
      v = Buffer.concat([v, Buffer.from(H)]);
    }
    function M(H) {
      const fe = v.length, ge = t.encodingLength(H);
      v = Buffer.concat([v, Buffer.allocUnsafe(ge)]), t.encode(H, v, fe);
    }
    function U(H) {
      M(H.length), F(H);
    }
    function L(H) {
      M(H.length), H.forEach(U);
    }
    return L(x), v;
  }
  function B(x, v) {
    return (M, U, L, H, fe, ge) => {
      let Ie, Ee;
      if (H && !fe) {
        const Se = y.payments.p2wsh({
          redeem: { input: x, output: L },
          network: v
        });
        if (!Se.witness)
          throw new Error("Error: p2wsh failed producing a witness");
        Ie = E(Se.witness);
      } else if (H && fe) {
        const Se = y.payments.p2sh({
          redeem: y.payments.p2wsh({
            redeem: { input: x, output: L },
            network: v
          }),
          network: v
        });
        if (!Se.witness)
          throw new Error("Error: p2sh-p2wsh failed producing a witness");
        Ie = E(Se.witness), Ee = Se.input;
      } else
        Ee = y.payments.p2sh({
          redeem: { input: x, output: L },
          network: v
        }).input;
      return {
        finalScriptWitness: Ie,
        finalScriptSig: Ee
      };
    };
  }
  psbt$2.finalScriptsFuncFactory = B;
  function D({ psbt: x, vout: v, txHex: F, txId: M, value: U, sequence: L, locktime: H, keysInfo: fe, scriptPubKey: ge, isSegwit: Ie, witnessScript: Ee, redeemScript: Se }) {
    var Pe;
    if (!Ie && F === void 0)
      throw new Error("Error: txHex is mandatory for Non-Segwit inputs");
    if (Ie && F === void 0 && (M === void 0 || U === void 0))
      throw new Error("Error: pass txHex or txId+value for Segwit inputs");
    if (F !== void 0) {
      const De = y.Transaction.fromHex(F), ve = (Pe = De == null ? void 0 : De.outs) == null ? void 0 : Pe[v];
      if (!ve)
        throw new Error(`Error: tx ${F} does not have vout ${v}`);
      const Fe = ve.script;
      if (!Fe)
        throw new Error(`Error: could not extract outputScript for txHex ${F} and vout ${v}`);
      if (Buffer.compare(Fe, ge) !== 0)
        throw new Error(`Error: txHex ${F} for vout ${v} does not correspond to scriptPubKey ${ge}`);
      if (M !== void 0) {
        if (De.getId() !== M)
          throw new Error(`Error: txId for ${F} and vout ${v} does not correspond to ${M}`);
      } else
        M = De.getId();
      if (U !== void 0) {
        if (ve.value !== U)
          throw new Error(`Error: value for ${F} and vout ${v} does not correspond to ${U}`);
      } else
        U = ve.value;
    }
    if (M === void 0 || !U)
      throw new Error("Error: txHex+vout required. Alternatively, but ONLY for Segwit inputs, txId+value can also be passed.");
    if (H) {
      if (x.locktime && x.locktime !== H)
        throw new Error(`Error: transaction locktime was already set with a different value: ${H} != ${x.locktime}`);
      if (L === void 0)
        L = 4294967294;
      else if (L > 4294967294)
        throw new Error(`Error: incompatible sequence: ${L} and locktime: ${H}`);
      x.setLocktime(H);
    }
    const ze = {
      hash: d(Buffer.from(M, "hex")),
      index: v
    };
    F !== void 0 && (ze.nonWitnessUtxo = y.Transaction.fromHex(F).toBuffer());
    const He = fe.filter((De) => De.pubkey && De.masterFingerprint && De.path).map((De) => {
      const ve = De.pubkey;
      if (!ve)
        throw new Error(`key ${De.keyExpression} missing pubkey`);
      return {
        masterFingerprint: De.masterFingerprint,
        pubkey: ve,
        path: De.path
      };
    });
    return He.length && (ze.bip32Derivation = He), Ie && F !== void 0 && (ze.witnessUtxo = { script: ge, value: U }), L !== void 0 && (ze.sequence = L), Ee && (ze.witnessScript = Ee), Se && (ze.redeemScript = Se), x.addInput(ze), x.data.inputs.length - 1;
  }
  return psbt$2.updatePsbt = D, psbt$2;
}
var checksum = {}, hasRequiredChecksum;
function requireChecksum() {
  return hasRequiredChecksum || (hasRequiredChecksum = 1, function(o) {
    Object.defineProperty(o, "__esModule", { value: !0 }), o.DescriptorChecksum = o.CHECKSUM_CHARSET = void 0;
    const g = (y, t) => {
      const d = y >> 35n;
      return y = (y & 0x7ffffffffn) << 5n ^ t, d & 1n && (y ^= 0xf5dee51989n), d & 2n && (y ^= 0xa9fdca3312n), d & 4n && (y ^= 0x1bab10e32dn), d & 8n && (y ^= 0x3706b1677an), d & 16n && (y ^= 0x644d626ffdn), y;
    };
    o.CHECKSUM_CHARSET = "qpzry9x8gf2tvdw0s3jn54khce6mua7l";
    const c = (y) => {
      const t = "0123456789()[],'/*abcdefgh@:$%{}IJKLMNOPQRSTUVWXYZ&+-.;<=>?!^_|~ijklmnopqrstuvwxyzABCDEFGH`#\"\\ ";
      let d = 1n, E = 0n, B = 0n;
      for (const x of y) {
        const v = BigInt(t.indexOf(x));
        if (v === -1n)
          return "";
        d = g(d, v & 31n), E = E * 3n + (v >> 5n), ++B === 3n && (d = g(d, E), E = 0n, B = 0n);
      }
      B > 0n && (d = g(d, E));
      for (let x = 0; x < 8; ++x)
        d = g(d, 0n);
      d ^= 1n;
      let D = "";
      for (let x = 0; x < 8; ++x) {
        const v = d >> 5n * (7n - BigInt(x)) & 31n;
        if (v < 0 || v > Number.MAX_SAFE_INTEGER)
          throw new Error(`Error: could not compute checksum, invalid index ${v}`);
        D += o.CHECKSUM_CHARSET[Number(v)];
      }
      return D;
    };
    o.DescriptorChecksum = c;
  }(checksum)), checksum;
}
var keyExpressions = {}, ledger = {}, re = {}, hasRequiredRe;
function requireRe() {
  return hasRequiredRe || (hasRequiredRe = 1, function(o) {
    Object.defineProperty(o, "__esModule", { value: !0 }), o.reWshMiniscriptAnchored = o.reShWshMiniscriptAnchored = o.reShMiniscriptAnchored = o.reShWpkhAnchored = o.reWpkhAnchored = o.rePkhAnchored = o.reAddrAnchored = o.rePkAnchored = o.anchorStartAndEnd = o.reKeyExp = o.reXprvKey = o.reXpubKey = o.rePath = o.reXprv = o.reXpub = o.reWIF = o.rePubKey = o.reChecksum = o.reOrigin = o.reMasterFingerprint = o.reOriginPath = void 0;
    const g = requireChecksum(), c = String.raw`(['hH])`, y = String.raw`(\d+${c}?)`, t = String.raw`(${y}\/)`;
    o.reOriginPath = String.raw`(\/${t}*${y})`, o.reMasterFingerprint = String.raw`[0-9a-fA-F]{8}`, o.reOrigin = String.raw`(\[${o.reMasterFingerprint}(${o.reOriginPath})?\])`, o.reChecksum = String.raw`(#[${g.CHECKSUM_CHARSET}]{8})`;
    const d = String.raw`((02|03)[0-9a-fA-F]{64})`, E = String.raw`(04[0-9a-fA-F]{128})`;
    o.rePubKey = String.raw`(${d}|${E})`, o.reWIF = String.raw`([5KLc9][1-9A-HJ-NP-Za-km-z]{50,51})`, o.reXpub = String.raw`([xXtT]pub[1-9A-HJ-NP-Za-km-z]{79,108})`, o.reXprv = String.raw`([xXtT]prv[1-9A-HJ-NP-Za-km-z]{79,108})`;
    const B = String.raw`(\*(${c})?)`;
    o.rePath = String.raw`(\/(${t})*(${B}|${y}))`, o.reXpubKey = String.raw`(${o.reXpub})(${o.rePath})?`, o.reXprvKey = String.raw`(${o.reXprv})(${o.rePath})?`;
    const D = String.raw`(${o.reXpubKey}|${o.reXprvKey}|${o.rePubKey}|${o.reWIF})`;
    o.reKeyExp = String.raw`(${o.reOrigin})?(${D})`;
    const x = String.raw`pk\((.*?)\)`, v = String.raw`addr\((.*?)\)`, F = String.raw`pkh\(${o.reKeyExp}\)`, M = String.raw`wpkh\(${o.reKeyExp}\)`, U = String.raw`sh\(wpkh\(${o.reKeyExp}\)\)`, L = String.raw`(.*?)`, H = (Se) => String.raw`sh\(${Se}\)`, fe = (Se) => String.raw`wsh\(${Se}\)`, ge = (Se) => H(fe(Se)), Ie = (Se) => String.raw`^${Se}$`;
    o.anchorStartAndEnd = Ie;
    const Ee = (Se) => String.raw`${Se}(${o.reChecksum})?`;
    o.rePkAnchored = (0, o.anchorStartAndEnd)(Ee(x)), o.reAddrAnchored = (0, o.anchorStartAndEnd)(Ee(v)), o.rePkhAnchored = (0, o.anchorStartAndEnd)(Ee(F)), o.reWpkhAnchored = (0, o.anchorStartAndEnd)(Ee(M)), o.reShWpkhAnchored = (0, o.anchorStartAndEnd)(Ee(U)), o.reShMiniscriptAnchored = (0, o.anchorStartAndEnd)(Ee(H(L))), o.reShWshMiniscriptAnchored = (0, o.anchorStartAndEnd)(Ee(ge(L))), o.reWshMiniscriptAnchored = (0, o.anchorStartAndEnd)(Ee(fe(L)));
  }(re)), re;
}
var main$2 = {}, appClient$1 = {}, bip32$2 = {}, bip32Path, hasRequiredBip32Path;
function requireBip32Path() {
  if (hasRequiredBip32Path) return bip32Path;
  hasRequiredBip32Path = 1;
  const o = 2147483648;
  var g = function(c) {
    if (!Array.isArray(c))
      throw new Error("Input must be an Array");
    if (c.length === 0)
      throw new Error("Path must contain at least one level");
    for (var y = 0; y < c.length; y++)
      if (typeof c[y] != "number")
        throw new Error("Path element is not a number");
    this.path = c;
  };
  return g.validatePathArray = function(c) {
    try {
      return g.fromPathArray(c), !0;
    } catch {
      return !1;
    }
  }, g.validateString = function(c, y) {
    try {
      return g.fromString(c, y), !0;
    } catch {
      return !1;
    }
  }, g.fromPathArray = function(c) {
    return new g(c);
  }, g.fromString = function(c, y) {
    if (/^m\//i.test(c))
      c = c.slice(2);
    else if (y)
      throw new Error("Root element is required");
    for (var t = c.split("/"), d = new Array(t.length), E = 0; E < t.length; E++) {
      var B = /(\d+)([hH\']?)/.exec(t[E]);
      if (B === null)
        throw new Error("Invalid input");
      if (d[E] = parseInt(B[1], 10), d[E] >= o)
        throw new Error("Invalid child index");
      if (B[2] === "h" || B[2] === "H" || B[2] === "'")
        d[E] += o;
      else if (B[2].length != 0)
        throw new Error("Invalid modifier");
    }
    return new g(d);
  }, g.prototype.toPathArray = function() {
    return this.path;
  }, g.prototype.toString = function(c, y) {
    for (var t = new Array(this.path.length), d = 0; d < this.path.length; d++) {
      var E = this.path[d];
      E & o ? t[d] = (E & ~o) + (y ? "h" : "'") : t[d] = E;
    }
    return (c ? "" : "m/") + t.join("/");
  }, g.prototype.inspect = function() {
    return "BIPPath <" + this.toString() + ">";
  }, bip32Path = g, bip32Path;
}
var hasRequiredBip32$2;
function requireBip32$2() {
  if (hasRequiredBip32$2) return bip32$2;
  hasRequiredBip32$2 = 1;
  var o = bip32$2 && bip32$2.__importDefault || function(v) {
    return v && v.__esModule ? v : { default: v };
  };
  Object.defineProperty(bip32$2, "__esModule", { value: !0 }), bip32$2.hardenedPathOf = bip32$2.getXpubComponents = bip32$2.pubkeyFromXpub = bip32$2.pathStringToArray = bip32$2.pathArrayToString = bip32$2.bip32asBuffer = bip32$2.pathElementsToBuffer = void 0;
  const g = o(requireBip32Path()), c = o(requireBs58check());
  function y(v) {
    const F = Buffer.alloc(1 + v.length * 4);
    return F[0] = v.length, v.forEach((M, U) => {
      F.writeUInt32BE(M, 1 + 4 * U);
    }), F;
  }
  bip32$2.pathElementsToBuffer = y;
  function t(v) {
    const F = v ? E(v) : [];
    return y(F);
  }
  bip32$2.bip32asBuffer = t;
  function d(v) {
    return v.length == 0 ? "m" : g.default.fromPathArray(v).toString();
  }
  bip32$2.pathArrayToString = d;
  function E(v) {
    return v == "m" || v == "" ? [] : g.default.fromString(v).toPathArray();
  }
  bip32$2.pathStringToArray = E;
  function B(v) {
    const F = c.default.decode(v);
    return F.slice(F.length - 33);
  }
  bip32$2.pubkeyFromXpub = B;
  function D(v) {
    const F = c.default.decode(v);
    return {
      chaincode: F.slice(13, 45),
      pubkey: F.slice(F.length - 33),
      version: F.readUInt32BE(0)
    };
  }
  bip32$2.getXpubComponents = D;
  function x(v) {
    for (let F = v.length - 1; F >= 0; F--)
      if (v[F] >= 2147483648)
        return v.slice(0, F + 1);
    return [];
  }
  return bip32$2.hardenedPathOf = x, bip32$2;
}
var clientCommands$2 = {}, buffertools$2 = {}, varint$2 = {}, hasRequiredVarint$2;
function requireVarint$2() {
  if (hasRequiredVarint$2) return varint$2;
  hasRequiredVarint$2 = 1, Object.defineProperty(varint$2, "__esModule", { value: !0 }), varint$2.createVarint = varint$2.parseVarint = varint$2.sanitizeBigintToNumber = void 0;
  function o(E, B, D, x) {
    for (let v = 0; v < B; v++) {
      if (D[v + x] == null)
        throw Error("Buffer too small");
      D[v + x] = Number(E % BigInt(256)), E = E >> BigInt(8);
    }
  }
  function g(E, B, D) {
    let x = BigInt(0);
    for (let v = 0; v < D; v++) {
      if (E[v + B] == null)
        throw Error("Buffer too small");
      x += BigInt(E[v + B]) << BigInt(v * 8);
    }
    return x;
  }
  function c(E) {
    if (E < 0)
      throw RangeError("Negative bigint is not a valid varint");
    if (E > Number.MAX_SAFE_INTEGER)
      throw RangeError("Too large for a Number");
    return Number(E);
  }
  varint$2.sanitizeBigintToNumber = c;
  function y(E) {
    if (typeof E == "number" && (E = c(E)), E < BigInt(0))
      throw new RangeError("Negative numbers are not supported");
    if (E >= BigInt(1) << BigInt(64))
      throw new RangeError("Too large for a Bitcoin-style varint");
    return E < BigInt(253) ? 1 : E <= BigInt(65535) ? 3 : E <= BigInt(4294967295) ? 5 : 9;
  }
  function t(E, B) {
    if (B < 0)
      throw RangeError("Negative offset is invalid");
    if (E[B] == null)
      throw Error("Buffer too small");
    if (E[B] < 253)
      return [BigInt(E[B]), 1];
    {
      let D;
      return E[B] === 253 ? D = 2 : E[B] === 254 ? D = 4 : D = 8, [g(E, B + 1, D), D + 1];
    }
  }
  varint$2.parseVarint = t;
  function d(E) {
    typeof E == "number" && (E = c(E));
    const B = y(E);
    E = BigInt(E);
    const D = Buffer.alloc(B);
    return B == 1 ? D[0] = Number(E) : (B == 3 ? D[0] = 253 : B === 5 ? D[0] = 254 : D[0] = 255, o(E, B - 1, D, 1)), D;
  }
  return varint$2.createVarint = d, varint$2;
}
var hasRequiredBuffertools$2;
function requireBuffertools$2() {
  if (hasRequiredBuffertools$2) return buffertools$2;
  hasRequiredBuffertools$2 = 1, Object.defineProperty(buffertools$2, "__esModule", { value: !0 }), buffertools$2.BufferReader = buffertools$2.BufferWriter = buffertools$2.unsafeFrom64bitLE = buffertools$2.unsafeTo64bitLE = void 0;
  const o = requireVarint$2();
  function g(d) {
    if (d > Number.MAX_SAFE_INTEGER)
      throw new Error("Can't convert numbers > MAX_SAFE_INT");
    const E = Buffer.alloc(8, 0);
    for (let B = 0; B < E.length; B++) {
      const D = d & 255;
      E[B] = D, d = (d - D) / 256;
    }
    return E;
  }
  buffertools$2.unsafeTo64bitLE = g;
  function c(d) {
    let E = 0;
    if (d.length != 8)
      throw new Error("Expected Bufffer of lenght 8");
    if (d[7] != 0)
      throw new Error("Can't encode numbers > MAX_SAFE_INT");
    if (d[6] > 31)
      throw new Error("Can't encode numbers > MAX_SAFE_INT");
    for (let B = d.length - 1; B >= 0; B--)
      E = E * 256 + d[B];
    return E;
  }
  buffertools$2.unsafeFrom64bitLE = c;
  class y {
    constructor() {
      this.bufs = [];
    }
    write(E, B) {
      const D = Buffer.alloc(E);
      B(D), this.bufs.push(D);
    }
    writeUInt8(E) {
      this.write(1, (B) => B.writeUInt8(E, 0));
    }
    writeInt32(E) {
      this.write(4, (B) => B.writeInt32LE(E, 0));
    }
    writeUInt32(E) {
      this.write(4, (B) => B.writeUInt32LE(E, 0));
    }
    writeUInt64(E) {
      const B = g(E);
      this.writeSlice(B);
    }
    writeVarInt(E) {
      this.bufs.push((0, o.createVarint)(E));
    }
    writeSlice(E) {
      this.bufs.push(Buffer.from(E));
    }
    writeVarSlice(E) {
      this.writeVarInt(E.length), this.writeSlice(E);
    }
    buffer() {
      return Buffer.concat(this.bufs);
    }
  }
  buffertools$2.BufferWriter = y;
  class t {
    constructor(E, B = 0) {
      this.buffer = E, this.offset = B;
    }
    available() {
      return this.buffer.length - this.offset;
    }
    readUInt8() {
      const E = this.buffer.readUInt8(this.offset);
      return this.offset++, E;
    }
    readInt32() {
      const E = this.buffer.readInt32LE(this.offset);
      return this.offset += 4, E;
    }
    readUInt32() {
      const E = this.buffer.readUInt32LE(this.offset);
      return this.offset += 4, E;
    }
    readUInt64() {
      const E = this.readSlice(8);
      return c(E);
    }
    readVarInt() {
      const [E, B] = (0, o.parseVarint)(this.buffer, this.offset);
      return this.offset += B, E;
    }
    readSlice(E) {
      if (this.buffer.length < this.offset + E)
        throw new Error("Cannot read slice out of bounds");
      const B = this.buffer.slice(this.offset, this.offset + E);
      return this.offset += E, B;
    }
    readVarSlice() {
      const E = (0, o.sanitizeBigintToNumber)(this.readVarInt());
      return this.readSlice(E);
    }
    readVector() {
      const E = this.readVarInt(), B = [];
      for (let D = 0; D < E; D++)
        B.push(this.readVarSlice());
      return B;
    }
  }
  return buffertools$2.BufferReader = t, buffertools$2;
}
var merkle$2 = {}, hasRequiredMerkle$2;
function requireMerkle$2() {
  if (hasRequiredMerkle$2) return merkle$2;
  hasRequiredMerkle$2 = 1, Object.defineProperty(merkle$2, "__esModule", { value: !0 }), merkle$2.hashLeaf = merkle$2.Merkle = void 0;
  const o = require$$1;
  class g {
    constructor(x, v = o.crypto.sha256) {
      this.leaves = x, this.h = v;
      const F = this.calculateRoot(x);
      this.rootNode = F.root, this.leafNodes = F.leaves;
    }
    getRoot() {
      return this.rootNode.hash;
    }
    size() {
      return this.leaves.length;
    }
    getLeaves() {
      return this.leaves;
    }
    getLeafHash(x) {
      return this.leafNodes[x].hash;
    }
    getProof(x) {
      if (x >= this.leaves.length)
        throw Error("Index out of bounds");
      return d(this.leafNodes[x]);
    }
    calculateRoot(x) {
      const v = x.length;
      if (v == 0)
        return {
          root: new t(void 0, void 0, Buffer.alloc(32, 0)),
          leaves: []
        };
      if (v == 1) {
        const Ie = new t(void 0, void 0, x[0]);
        return { root: Ie, leaves: [Ie] };
      }
      const F = E(v), M = this.calculateRoot(x.slice(0, F)), U = this.calculateRoot(x.slice(F)), L = M.root, H = U.root, fe = this.hashNode(L.hash, H.hash), ge = new t(L, H, fe);
      return L.parent = ge, H.parent = ge, { root: ge, leaves: M.leaves.concat(U.leaves) };
    }
    hashNode(x, v) {
      return this.h(Buffer.concat([Buffer.from([1]), x, v]));
    }
  }
  merkle$2.Merkle = g;
  function c(D, x = o.crypto.sha256) {
    return y(Buffer.from([0]), D, x);
  }
  merkle$2.hashLeaf = c;
  function y(D, x, v) {
    return v(Buffer.concat([D, x]));
  }
  class t {
    constructor(x, v, F) {
      this.leftChild = x, this.rightChild = v, this.hash = F;
    }
    isLeaf() {
      return this.leftChild == null;
    }
  }
  function d(D) {
    if (!D.parent)
      return [];
    if (D.parent.leftChild == D) {
      if (!D.parent.rightChild)
        throw new Error("Expected right child to exist");
      return [D.parent.rightChild.hash, ...d(D.parent)];
    } else {
      if (!D.parent.leftChild)
        throw new Error("Expected left child to exist");
      return [D.parent.leftChild.hash, ...d(D.parent)];
    }
  }
  function E(D) {
    if (D < 2)
      throw Error("Expected n >= 2");
    return B(D) ? D / 2 : 1 << Math.floor(Math.log2(D));
  }
  function B(D) {
    return (D & D - 1) == 0;
  }
  return merkle$2;
}
var hasRequiredClientCommands$2;
function requireClientCommands$2() {
  if (hasRequiredClientCommands$2) return clientCommands$2;
  hasRequiredClientCommands$2 = 1, Object.defineProperty(clientCommands$2, "__esModule", { value: !0 }), clientCommands$2.ClientCommandInterpreter = clientCommands$2.GetMoreElementsCommand = clientCommands$2.GetMerkleLeafIndexCommand = clientCommands$2.GetMerkleLeafProofCommand = clientCommands$2.GetPreimageCommand = clientCommands$2.YieldCommand = void 0;
  const o = require$$1, g = requireBuffertools$2(), c = requireMerkle$2(), y = requireVarint$2();
  var t;
  (function(M) {
    M[M.YIELD = 16] = "YIELD", M[M.GET_PREIMAGE = 64] = "GET_PREIMAGE", M[M.GET_MERKLE_LEAF_PROOF = 65] = "GET_MERKLE_LEAF_PROOF", M[M.GET_MERKLE_LEAF_INDEX = 66] = "GET_MERKLE_LEAF_INDEX", M[M.GET_MORE_ELEMENTS = 160] = "GET_MORE_ELEMENTS";
  })(t || (t = {}));
  class d {
  }
  class E extends d {
    constructor(U, L) {
      super(), this.progressCallback = L, this.code = t.YIELD, this.results = U;
    }
    execute(U) {
      return this.results.push(Buffer.from(U.subarray(1))), this.progressCallback && this.progressCallback(), Buffer.from("");
    }
  }
  clientCommands$2.YieldCommand = E;
  class B extends d {
    constructor(U, L) {
      super(), this.code = t.GET_PREIMAGE, this.known_preimages = U, this.queue = L;
    }
    execute(U) {
      const L = Buffer.from(U.subarray(1));
      if (L.length != 33)
        throw new Error("Invalid request, unexpected trailing data");
      if (L[0] != 0)
        throw new Error("Unsupported request, the first byte should be 0");
      const H = Buffer.alloc(32);
      for (let Ie = 0; Ie < 32; Ie++)
        H[Ie] = L[1 + Ie];
      const fe = H.toString("hex"), ge = this.known_preimages.get(fe);
      if (ge != null) {
        const Ie = (0, y.createVarint)(ge.length), Ee = 255 - Ie.length - 1, Se = Math.min(Ee, ge.length);
        if (Se < ge.length)
          for (let ze = Se; ze < ge.length; ze++)
            this.queue.push(Buffer.from([ge[ze]]));
        return Buffer.concat([
          Ie,
          Buffer.from([Se]),
          Buffer.from(ge.subarray(0, Se))
        ]);
      }
      throw Error(`Requested unknown preimage for: ${fe}`);
    }
  }
  clientCommands$2.GetPreimageCommand = B;
  class D extends d {
    constructor(U, L) {
      super(), this.code = t.GET_MERKLE_LEAF_PROOF, this.known_trees = U, this.queue = L;
    }
    execute(U) {
      const L = Buffer.from(U.subarray(1));
      if (L.length < 34)
        throw new Error("Invalid request, expected at least 34 bytes");
      const H = new g.BufferReader(L), ge = H.readSlice(32).toString("hex");
      let Ie, Ee;
      try {
        Ie = (0, y.sanitizeBigintToNumber)(H.readVarInt()), Ee = (0, y.sanitizeBigintToNumber)(H.readVarInt());
      } catch {
        throw new Error("Invalid request, couldn't parse tree_size or leaf_index");
      }
      const Se = this.known_trees.get(ge);
      if (!Se)
        throw Error(`Requested Merkle leaf proof for unknown tree: ${ge}`);
      if (Ee >= Ie || Se.size() != Ie)
        throw Error("Invalid index or tree size.");
      if (this.queue.length != 0)
        throw Error("This command should not execute when the queue is not empty.");
      const ze = Se.getProof(Ee), He = Math.min(Math.floor(221 / 32), ze.length), Pe = ze.length - He;
      return Pe > 0 && this.queue.push(...ze.slice(-Pe)), Buffer.concat([
        Se.getLeafHash(Ee),
        Buffer.from([ze.length]),
        Buffer.from([He]),
        ...ze.slice(0, He)
      ]);
    }
  }
  clientCommands$2.GetMerkleLeafProofCommand = D;
  class x extends d {
    constructor(U) {
      super(), this.code = t.GET_MERKLE_LEAF_INDEX, this.known_trees = U;
    }
    execute(U) {
      const L = Buffer.from(U.subarray(1));
      if (L.length != 64)
        throw new Error("Invalid request, unexpected trailing data");
      const H = Buffer.alloc(32);
      for (let He = 0; He < 32; He++)
        H[He] = L.readUInt8(He);
      const fe = H.toString("hex"), ge = Buffer.alloc(32);
      for (let He = 0; He < 32; He++)
        ge[He] = L.readUInt8(32 + He);
      const Ie = ge.toString("hex"), Ee = this.known_trees.get(fe);
      if (!Ee)
        throw Error(`Requested Merkle leaf index for unknown root: ${fe}`);
      let Se = 0, ze = 0;
      for (let He = 0; He < Ee.size(); He++)
        if (Ee.getLeafHash(He).toString("hex") == Ie) {
          ze = 1, Se = He;
          break;
        }
      return Buffer.concat([Buffer.from([ze]), (0, y.createVarint)(Se)]);
    }
  }
  clientCommands$2.GetMerkleLeafIndexCommand = x;
  class v extends d {
    constructor(U) {
      super(), this.code = t.GET_MORE_ELEMENTS, this.queue = U;
    }
    execute(U) {
      if (U.length != 1)
        throw new Error("Invalid request, unexpected trailing data");
      if (this.queue.length === 0)
        throw new Error("No elements to get");
      const L = this.queue[0].length;
      if (this.queue.some((Ie) => Ie.length != L))
        throw new Error("The queue contains elements with different byte length, which is not expected");
      const H = Math.floor(253 / L), fe = Math.min(H, this.queue.length), ge = this.queue.splice(0, fe);
      return Buffer.concat([
        Buffer.from([fe]),
        Buffer.from([L]),
        ...ge
      ]);
    }
  }
  clientCommands$2.GetMoreElementsCommand = v;
  class F {
    constructor(U) {
      this.roots = /* @__PURE__ */ new Map(), this.preimages = /* @__PURE__ */ new Map(), this.yielded = [], this.queue = [], this.commands = /* @__PURE__ */ new Map();
      const L = [
        new E(this.yielded, U),
        new B(this.preimages, this.queue),
        new x(this.roots),
        new D(this.roots, this.queue),
        new v(this.queue)
      ];
      for (const H of L) {
        if (this.commands.has(H.code))
          throw new Error(`Multiple commands with code ${H.code}`);
        this.commands.set(H.code, H);
      }
    }
    getYielded() {
      return this.yielded;
    }
    addKnownPreimage(U) {
      this.preimages.set(o.crypto.sha256(U).toString("hex"), U);
    }
    addKnownList(U) {
      for (const H of U) {
        const fe = Buffer.concat([Buffer.from([0]), H]);
        this.addKnownPreimage(fe);
      }
      const L = new c.Merkle(U.map((H) => (0, c.hashLeaf)(H)));
      this.roots.set(L.getRoot().toString("hex"), L);
    }
    addKnownMapping(U) {
      this.addKnownList(U.keys), this.addKnownList(U.values);
    }
    addKnownWalletPolicy(U) {
      this.addKnownPreimage(U.serialize()), this.addKnownList(U.keys.map((L) => Buffer.from(L, "ascii"))), this.addKnownPreimage(Buffer.from(U.descriptorTemplate));
    }
    execute(U) {
      if (U.length == 0)
        throw new Error("Unexpected empty command");
      const L = U[0], H = this.commands.get(L);
      if (!H)
        throw new Error(`Unexpected command code ${L}`);
      return H.execute(U);
    }
  }
  return clientCommands$2.ClientCommandInterpreter = F, clientCommands$2;
}
var merkelizedPsbt$2 = {}, merkleMap$2 = {}, hasRequiredMerkleMap$2;
function requireMerkleMap$2() {
  if (hasRequiredMerkleMap$2) return merkleMap$2;
  hasRequiredMerkleMap$2 = 1, Object.defineProperty(merkleMap$2, "__esModule", { value: !0 }), merkleMap$2.MerkleMap = void 0;
  const o = requireMerkle$2(), g = requireVarint$2();
  class c {
    /**
     * @param keys Sorted list of (unhashed) keys
     * @param values values, in corresponding order as the keys, and of equal length
     */
    constructor(t, d) {
      if (t.length != d.length)
        throw new Error("keys and values should have the same length");
      for (let E = 0; E < t.length - 1; E++)
        if (t[E].toString("hex") >= t[E + 1].toString("hex"))
          throw new Error("keys must be in strictly increasing order");
      this.keys = t, this.keysTree = new o.Merkle(t.map((E) => (0, o.hashLeaf)(E))), this.values = d, this.valuesTree = new o.Merkle(d.map((E) => (0, o.hashLeaf)(E)));
    }
    commitment() {
      return Buffer.concat([
        (0, g.createVarint)(this.keys.length),
        this.keysTree.getRoot(),
        this.valuesTree.getRoot()
      ]);
    }
  }
  return merkleMap$2.MerkleMap = c, merkleMap$2;
}
var psbtv2$2 = {}, hasRequiredPsbtv2$2;
function requirePsbtv2$2() {
  return hasRequiredPsbtv2$2 || (hasRequiredPsbtv2$2 = 1, function(o) {
    var g = psbtv2$2 && psbtv2$2.__createBinding || (Object.create ? function(De, ve, Fe, be) {
      be === void 0 && (be = Fe);
      var Be = Object.getOwnPropertyDescriptor(ve, Fe);
      (!Be || ("get" in Be ? !ve.__esModule : Be.writable || Be.configurable)) && (Be = { enumerable: !0, get: function() {
        return ve[Fe];
      } }), Object.defineProperty(De, be, Be);
    } : function(De, ve, Fe, be) {
      be === void 0 && (be = Fe), De[be] = ve[Fe];
    }), c = psbtv2$2 && psbtv2$2.__setModuleDefault || (Object.create ? function(De, ve) {
      Object.defineProperty(De, "default", { enumerable: !0, value: ve });
    } : function(De, ve) {
      De.default = ve;
    }), y = psbtv2$2 && psbtv2$2.__importStar || function(De) {
      if (De && De.__esModule) return De;
      var ve = {};
      if (De != null) for (var Fe in De) Fe !== "default" && Object.prototype.hasOwnProperty.call(De, Fe) && g(ve, De, Fe);
      return c(ve, De), ve;
    };
    Object.defineProperty(o, "__esModule", { value: !0 }), o.PsbtV2 = o.NoSuchEntry = o.psbtOut = o.psbtIn = o.psbtGlobal = void 0;
    const t = y(require$$1), d = requireBuffertools$2(), E = requireVarint$2();
    var B;
    (function(De) {
      De[De.UNSIGNED_TX = 0] = "UNSIGNED_TX", De[De.XPUB = 1] = "XPUB", De[De.TX_VERSION = 2] = "TX_VERSION", De[De.FALLBACK_LOCKTIME = 3] = "FALLBACK_LOCKTIME", De[De.INPUT_COUNT = 4] = "INPUT_COUNT", De[De.OUTPUT_COUNT = 5] = "OUTPUT_COUNT", De[De.TX_MODIFIABLE = 6] = "TX_MODIFIABLE", De[De.VERSION = 251] = "VERSION";
    })(B = o.psbtGlobal || (o.psbtGlobal = {}));
    var D;
    (function(De) {
      De[De.NON_WITNESS_UTXO = 0] = "NON_WITNESS_UTXO", De[De.WITNESS_UTXO = 1] = "WITNESS_UTXO", De[De.PARTIAL_SIG = 2] = "PARTIAL_SIG", De[De.SIGHASH_TYPE = 3] = "SIGHASH_TYPE", De[De.REDEEM_SCRIPT = 4] = "REDEEM_SCRIPT", De[De.WITNESS_SCRIPT = 5] = "WITNESS_SCRIPT", De[De.BIP32_DERIVATION = 6] = "BIP32_DERIVATION", De[De.FINAL_SCRIPTSIG = 7] = "FINAL_SCRIPTSIG", De[De.FINAL_SCRIPTWITNESS = 8] = "FINAL_SCRIPTWITNESS", De[De.PREVIOUS_TXID = 14] = "PREVIOUS_TXID", De[De.OUTPUT_INDEX = 15] = "OUTPUT_INDEX", De[De.SEQUENCE = 16] = "SEQUENCE", De[De.TAP_KEY_SIG = 19] = "TAP_KEY_SIG", De[De.TAP_BIP32_DERIVATION = 22] = "TAP_BIP32_DERIVATION";
    })(D = o.psbtIn || (o.psbtIn = {}));
    var x;
    (function(De) {
      De[De.REDEEM_SCRIPT = 0] = "REDEEM_SCRIPT", De[De.WITNESS_SCRIPT = 1] = "WITNESS_SCRIPT", De[De.BIP_32_DERIVATION = 2] = "BIP_32_DERIVATION", De[De.AMOUNT = 3] = "AMOUNT", De[De.SCRIPT = 4] = "SCRIPT", De[De.TAP_BIP32_DERIVATION = 7] = "TAP_BIP32_DERIVATION";
    })(x = o.psbtOut || (o.psbtOut = {}));
    const v = Buffer.from([112, 115, 98, 116, 255]);
    class F extends Error {
    }
    o.NoSuchEntry = F;
    class M {
      constructor() {
        this.globalMap = /* @__PURE__ */ new Map(), this.inputMaps = [], this.outputMaps = [];
      }
      setGlobalTxVersion(ve) {
        this.setGlobal(B.TX_VERSION, Se(ve));
      }
      getGlobalTxVersion() {
        return this.getGlobal(B.TX_VERSION).readUInt32LE(0);
      }
      setGlobalFallbackLocktime(ve) {
        this.setGlobal(B.FALLBACK_LOCKTIME, Se(ve));
      }
      getGlobalFallbackLocktime() {
        var ve;
        return (ve = this.getGlobalOptional(B.FALLBACK_LOCKTIME)) === null || ve === void 0 ? void 0 : ve.readUInt32LE(0);
      }
      setGlobalInputCount(ve) {
        this.setGlobal(B.INPUT_COUNT, He(ve));
      }
      getGlobalInputCount() {
        return Pe(this.getGlobal(B.INPUT_COUNT));
      }
      setGlobalOutputCount(ve) {
        this.setGlobal(B.OUTPUT_COUNT, He(ve));
      }
      getGlobalOutputCount() {
        return Pe(this.getGlobal(B.OUTPUT_COUNT));
      }
      setGlobalTxModifiable(ve) {
        this.setGlobal(B.TX_MODIFIABLE, ve);
      }
      getGlobalTxModifiable() {
        return this.getGlobalOptional(B.TX_MODIFIABLE);
      }
      setGlobalPsbtVersion(ve) {
        this.setGlobal(B.VERSION, Se(ve));
      }
      getGlobalPsbtVersion() {
        return this.getGlobal(B.VERSION).readUInt32LE(0);
      }
      setInputNonWitnessUtxo(ve, Fe) {
        this.setInput(ve, D.NON_WITNESS_UTXO, Ie(), Fe);
      }
      getInputNonWitnessUtxo(ve) {
        return this.getInputOptional(ve, D.NON_WITNESS_UTXO, Ie());
      }
      setInputWitnessUtxo(ve, Fe, be) {
        const Be = new d.BufferWriter();
        Be.writeSlice(ze(Fe)), Be.writeVarSlice(be), this.setInput(ve, D.WITNESS_UTXO, Ie(), Be.buffer());
      }
      getInputWitnessUtxo(ve) {
        const Fe = this.getInputOptional(ve, D.WITNESS_UTXO, Ie());
        if (!Fe)
          return;
        const be = new d.BufferReader(Fe);
        return {
          amount: (0, d.unsafeFrom64bitLE)(be.readSlice(8)),
          scriptPubKey: be.readVarSlice()
        };
      }
      setInputPartialSig(ve, Fe, be) {
        this.setInput(ve, D.PARTIAL_SIG, Fe, be);
      }
      getInputPartialSig(ve, Fe) {
        return this.getInputOptional(ve, D.PARTIAL_SIG, Fe);
      }
      setInputSighashType(ve, Fe) {
        this.setInput(ve, D.SIGHASH_TYPE, Ie(), Se(Fe));
      }
      getInputSighashType(ve) {
        const Fe = this.getInputOptional(ve, D.SIGHASH_TYPE, Ie());
        if (Fe)
          return Fe.readUInt32LE(0);
      }
      setInputRedeemScript(ve, Fe) {
        this.setInput(ve, D.REDEEM_SCRIPT, Ie(), Fe);
      }
      getInputRedeemScript(ve) {
        return this.getInputOptional(ve, D.REDEEM_SCRIPT, Ie());
      }
      setInputWitnessScript(ve, Fe) {
        this.setInput(ve, D.WITNESS_SCRIPT, Ie(), Fe);
      }
      getInputWitnessScript(ve) {
        return this.getInputOptional(ve, D.WITNESS_SCRIPT, Ie());
      }
      setInputBip32Derivation(ve, Fe, be, Be) {
        if (Fe.length != 33)
          throw new Error("Invalid pubkey length: " + Fe.length);
        this.setInput(ve, D.BIP32_DERIVATION, Fe, this.encodeBip32Derivation(be, Be));
      }
      getInputBip32Derivation(ve, Fe) {
        const be = this.getInputOptional(ve, D.BIP32_DERIVATION, Fe);
        if (be)
          return this.decodeBip32Derivation(be);
      }
      setInputFinalScriptsig(ve, Fe) {
        this.setInput(ve, D.FINAL_SCRIPTSIG, Ie(), Fe);
      }
      getInputFinalScriptsig(ve) {
        return this.getInputOptional(ve, D.FINAL_SCRIPTSIG, Ie());
      }
      setInputFinalScriptwitness(ve, Fe) {
        this.setInput(ve, D.FINAL_SCRIPTWITNESS, Ie(), Fe);
      }
      getInputFinalScriptwitness(ve) {
        return this.getInput(ve, D.FINAL_SCRIPTWITNESS, Ie());
      }
      setInputPreviousTxId(ve, Fe) {
        this.setInput(ve, D.PREVIOUS_TXID, Ie(), Fe);
      }
      getInputPreviousTxid(ve) {
        return this.getInput(ve, D.PREVIOUS_TXID, Ie());
      }
      setInputOutputIndex(ve, Fe) {
        this.setInput(ve, D.OUTPUT_INDEX, Ie(), Se(Fe));
      }
      getInputOutputIndex(ve) {
        return this.getInput(ve, D.OUTPUT_INDEX, Ie()).readUInt32LE(0);
      }
      setInputSequence(ve, Fe) {
        this.setInput(ve, D.SEQUENCE, Ie(), Se(Fe));
      }
      getInputSequence(ve) {
        var Fe, be;
        return (be = (Fe = this.getInputOptional(ve, D.SEQUENCE, Ie())) === null || Fe === void 0 ? void 0 : Fe.readUInt32LE(0)) !== null && be !== void 0 ? be : 4294967295;
      }
      setInputTapKeySig(ve, Fe) {
        this.setInput(ve, D.TAP_KEY_SIG, Ie(), Fe);
      }
      getInputTapKeySig(ve) {
        return this.getInputOptional(ve, D.TAP_KEY_SIG, Ie());
      }
      setInputTapBip32Derivation(ve, Fe, be, Be, ke) {
        if (Fe.length != 32)
          throw new Error("Invalid pubkey length: " + Fe.length);
        const xe = this.encodeTapBip32Derivation(be, Be, ke);
        this.setInput(ve, D.TAP_BIP32_DERIVATION, Fe, xe);
      }
      getInputTapBip32Derivation(ve, Fe) {
        const be = this.getInput(ve, D.TAP_BIP32_DERIVATION, Fe);
        return this.decodeTapBip32Derivation(be);
      }
      getInputKeyDatas(ve, Fe) {
        return this.getKeyDatas(this.inputMaps[ve], Fe);
      }
      setOutputRedeemScript(ve, Fe) {
        this.setOutput(ve, x.REDEEM_SCRIPT, Ie(), Fe);
      }
      getOutputRedeemScript(ve) {
        return this.getOutput(ve, x.REDEEM_SCRIPT, Ie());
      }
      setOutputBip32Derivation(ve, Fe, be, Be) {
        this.setOutput(ve, x.BIP_32_DERIVATION, Fe, this.encodeBip32Derivation(be, Be));
      }
      getOutputBip32Derivation(ve, Fe) {
        const be = this.getOutput(ve, x.BIP_32_DERIVATION, Fe);
        return this.decodeBip32Derivation(be);
      }
      setOutputAmount(ve, Fe) {
        this.setOutput(ve, x.AMOUNT, Ie(), ze(Fe));
      }
      getOutputAmount(ve) {
        const Fe = this.getOutput(ve, x.AMOUNT, Ie());
        return (0, d.unsafeFrom64bitLE)(Fe);
      }
      setOutputScript(ve, Fe) {
        this.setOutput(ve, x.SCRIPT, Ie(), Fe);
      }
      getOutputScript(ve) {
        return this.getOutput(ve, x.SCRIPT, Ie());
      }
      setOutputTapBip32Derivation(ve, Fe, be, Be, ke) {
        const xe = this.encodeTapBip32Derivation(be, Be, ke);
        this.setOutput(ve, x.TAP_BIP32_DERIVATION, Fe, xe);
      }
      getOutputTapBip32Derivation(ve, Fe) {
        const be = this.getOutput(ve, x.TAP_BIP32_DERIVATION, Fe);
        return this.decodeTapBip32Derivation(be);
      }
      deleteInputEntries(ve, Fe) {
        this.inputMaps[ve].forEach((Be, ke, xe) => {
          this.isKeyType(ke, Fe) && xe.delete(ke);
        });
      }
      copy(ve) {
        this.copyMap(this.globalMap, ve.globalMap), this.copyMaps(this.inputMaps, ve.inputMaps), this.copyMaps(this.outputMaps, ve.outputMaps);
      }
      copyMaps(ve, Fe) {
        ve.forEach((be, Be) => {
          const ke = /* @__PURE__ */ new Map();
          this.copyMap(be, ke), Fe[Be] = ke;
        });
      }
      copyMap(ve, Fe) {
        ve.forEach((be, Be) => Fe.set(Be, Buffer.from(be)));
      }
      serialize() {
        const ve = new d.BufferWriter();
        return ve.writeSlice(Buffer.from([112, 115, 98, 116, 255])), ge(ve, this.globalMap), this.inputMaps.forEach((Fe) => {
          ge(ve, Fe);
        }), this.outputMaps.forEach((Fe) => {
          ge(ve, Fe);
        }), ve.buffer();
      }
      deserialize(ve) {
        const Fe = new d.BufferReader(ve);
        if (!Fe.readSlice(5).equals(v))
          throw new Error("Invalid magic bytes");
        for (; this.readKeyPair(this.globalMap, Fe); )
          ;
        let be;
        try {
          be = this.getGlobalPsbtVersion();
        } catch {
          be = 0;
        }
        if (be !== 0 && be !== 2)
          throw new Error("Only PSBTs of version 0 or 2 are supported");
        let Be, ke;
        if (be == 0) {
          const xe = this.getGlobal(B.UNSIGNED_TX), Ne = t.Transaction.fromBuffer(xe);
          Be = Ne.ins.length, ke = Ne.outs.length;
        } else
          Be = this.getGlobalInputCount(), ke = this.getGlobalOutputCount();
        for (let xe = 0; xe < Be; xe++)
          for (this.inputMaps[xe] = /* @__PURE__ */ new Map(); this.readKeyPair(this.inputMaps[xe], Fe); )
            ;
        for (let xe = 0; xe < ke; xe++)
          for (this.outputMaps[xe] = /* @__PURE__ */ new Map(); this.readKeyPair(this.outputMaps[xe], Fe); )
            ;
        this.normalizeToV2();
      }
      normalizeToV2() {
        var ve;
        const Fe = (ve = this.getGlobalOptional(B.VERSION)) === null || ve === void 0 ? void 0 : ve.readInt32LE(0);
        if (Fe === 2)
          return;
        if (Fe !== void 0)
          throw new Error("Invalid or unsupported value for PSBT_GLOBAL_VERSION");
        const be = this.getGlobal(B.UNSIGNED_TX), Be = t.Transaction.fromBuffer(be);
        this.setGlobalPsbtVersion(2), this.setGlobalTxVersion(Be.version), this.setGlobalFallbackLocktime(Be.locktime), this.setGlobalInputCount(Be.ins.length), this.setGlobalOutputCount(Be.outs.length);
        for (let ke = 0; ke < Be.ins.length; ke++)
          this.setInputPreviousTxId(ke, Be.ins[ke].hash), this.setInputOutputIndex(ke, Be.ins[ke].index), this.setInputSequence(ke, Be.ins[ke].sequence);
        for (let ke = 0; ke < Be.outs.length; ke++)
          this.setOutputAmount(ke, Be.outs[ke].value), this.setOutputScript(ke, Be.outs[ke].script);
        this.globalMap.delete(B.UNSIGNED_TX.toString(16).padStart(2, "0"));
      }
      /**
       * Imports a BitcoinJS (bitcoinjs-lib) Psbt object.
       * https://github.com/bitcoinjs/bitcoinjs-lib/blob/master/ts_src/psbt.ts
       *
       * Prepares the fields required for signing a Psbt on a Ledger
       * device. It should be used exclusively before calling
       * `appClient.signPsbt()` and not as a general Psbt conversion method.
       *
       * Note: This method supports all the policies that the Ledger is able to
       * sign, with the exception of taproot: tr(@0).
       */
      fromBitcoinJS(ve) {
        function Fe(be) {
          let Be;
          try {
            t.payments.p2tr({ output: be.witnessUtxo.script }), Be = !0;
          } catch {
            Be = !1;
          }
          return be && !!(be.tapInternalKey || be.tapMerkleRoot || be.tapLeafScript && be.tapLeafScript.length || be.tapBip32Derivation && be.tapBip32Derivation.length || Be);
        }
        return this.setGlobalPsbtVersion(2), this.setGlobalTxVersion(ve.version), this.setGlobalInputCount(ve.data.inputs.length), this.setGlobalOutputCount(ve.txOutputs.length), ve.locktime !== void 0 && this.setGlobalFallbackLocktime(ve.locktime), ve.data.inputs.forEach((be, Be) => {
          if (Fe(be))
            throw new Error("Taproot inputs not supported");
          this.setInputPreviousTxId(Be, ve.txInputs[Be].hash), ve.txInputs[Be].sequence !== void 0 && this.setInputSequence(Be, ve.txInputs[Be].sequence), this.setInputOutputIndex(Be, ve.txInputs[Be].index), be.sighashType !== void 0 && this.setInputSighashType(Be, be.sighashType), be.nonWitnessUtxo && this.setInputNonWitnessUtxo(Be, be.nonWitnessUtxo), be.witnessUtxo && this.setInputWitnessUtxo(Be, be.witnessUtxo.value, be.witnessUtxo.script), be.witnessScript && this.setInputWitnessScript(Be, be.witnessScript), be.redeemScript && this.setInputRedeemScript(Be, be.redeemScript), ve.data.inputs[Be].bip32Derivation.forEach((ke) => {
            if (!/^m\//i.test(ke.path))
              throw new Error("Invalid input bip32 derivation");
            const xe = ke.path.replace(/m\//i, "").split("/").map((Ne) => Ne.match(/['h]/i) ? parseInt(Ne) + 2147483648 : Number(Ne));
            this.setInputBip32Derivation(Be, ke.pubkey, ke.masterFingerprint, xe);
          });
        }), ve.txOutputs.forEach((be, Be) => {
          this.setOutputAmount(Be, be.value), this.setOutputScript(Be, be.script);
        }), this;
      }
      readKeyPair(ve, Fe) {
        const be = (0, E.sanitizeBigintToNumber)(Fe.readVarInt());
        if (be == 0)
          return !1;
        const Be = Fe.readUInt8(), ke = Fe.readSlice(be - 1), xe = Fe.readVarSlice();
        return Ee(ve, Be, ke, xe), !0;
      }
      getKeyDatas(ve, Fe) {
        const be = [];
        return ve.forEach((Be, ke) => {
          this.isKeyType(ke, [Fe]) && be.push(Buffer.from(ke.substring(2), "hex"));
        }), be;
      }
      isKeyType(ve, Fe) {
        const be = Buffer.from(ve.substring(0, 2), "hex").readUInt8(0);
        return Fe.some((Be) => Be == be);
      }
      setGlobal(ve, Fe) {
        const be = new L(ve, Buffer.from([]));
        this.globalMap.set(be.toString(), Fe);
      }
      getGlobal(ve) {
        return U(this.globalMap, ve, Ie(), !1);
      }
      getGlobalOptional(ve) {
        return U(this.globalMap, ve, Ie(), !0);
      }
      setInput(ve, Fe, be, Be) {
        Ee(this.getMap(ve, this.inputMaps), Fe, be, Be);
      }
      getInput(ve, Fe, be) {
        return U(this.inputMaps[ve], Fe, be, !1);
      }
      getInputOptional(ve, Fe, be) {
        return U(this.inputMaps[ve], Fe, be, !0);
      }
      setOutput(ve, Fe, be, Be) {
        Ee(this.getMap(ve, this.outputMaps), Fe, be, Be);
      }
      getOutput(ve, Fe, be) {
        return U(this.outputMaps[ve], Fe, be, !1);
      }
      getMap(ve, Fe) {
        return Fe[ve] ? Fe[ve] : Fe[ve] = /* @__PURE__ */ new Map();
      }
      encodeBip32Derivation(ve, Fe) {
        const be = new d.BufferWriter();
        return this.writeBip32Derivation(be, ve, Fe), be.buffer();
      }
      decodeBip32Derivation(ve) {
        const Fe = new d.BufferReader(ve);
        return this.readBip32Derivation(Fe);
      }
      writeBip32Derivation(ve, Fe, be) {
        ve.writeSlice(Fe), be.forEach((Be) => {
          ve.writeUInt32(Be);
        });
      }
      readBip32Derivation(ve) {
        const Fe = ve.readSlice(4), be = [];
        for (; ve.offset < ve.buffer.length; )
          be.push(ve.readUInt32());
        return { masterFingerprint: Fe, path: be };
      }
      encodeTapBip32Derivation(ve, Fe, be) {
        const Be = new d.BufferWriter();
        return Be.writeVarInt(ve.length), ve.forEach((ke) => {
          Be.writeSlice(ke);
        }), this.writeBip32Derivation(Be, Fe, be), Be.buffer();
      }
      decodeTapBip32Derivation(ve) {
        const Fe = new d.BufferReader(ve), be = (0, E.sanitizeBigintToNumber)(Fe.readVarInt()), Be = [];
        for (let xe = 0; xe < be; xe++)
          Be.push(Fe.readSlice(32));
        const ke = this.readBip32Derivation(Fe);
        return Object.assign({ hashes: Be }, ke);
      }
    }
    o.PsbtV2 = M;
    function U(De, ve, Fe, be) {
      if (!De)
        throw Error("No such map");
      const Be = new L(ve, Fe), ke = De.get(Be.toString());
      if (!ke) {
        if (be)
          return;
        throw new F(Be.toString());
      }
      return Buffer.from(ke);
    }
    class L {
      constructor(ve, Fe) {
        this.keyType = ve, this.keyData = Fe;
      }
      toString() {
        const ve = new d.BufferWriter();
        return this.toBuffer(ve), ve.buffer().toString("hex");
      }
      serialize(ve) {
        ve.writeVarInt(1 + this.keyData.length), this.toBuffer(ve);
      }
      toBuffer(ve) {
        ve.writeUInt8(this.keyType), ve.writeSlice(this.keyData);
      }
    }
    class H {
      constructor(ve, Fe) {
        this.key = ve, this.value = Fe;
      }
      serialize(ve) {
        this.key.serialize(ve), ve.writeVarSlice(this.value);
      }
    }
    function fe(De) {
      return new L(De.readUInt8(0), De.slice(1));
    }
    function ge(De, ve) {
      for (let [Fe, be] of [...ve].sort(([Be], [ke]) => Be.localeCompare(ke)))
        new H(fe(Buffer.from(Fe, "hex")), be).serialize(De);
      De.writeUInt8(0);
    }
    function Ie() {
      return Buffer.from([]);
    }
    function Ee(De, ve, Fe, be) {
      const Be = new L(ve, Fe);
      De.set(Be.toString(), be);
    }
    function Se(De) {
      const ve = Buffer.alloc(4);
      return ve.writeUInt32LE(De, 0), ve;
    }
    function ze(De) {
      return (0, d.unsafeTo64bitLE)(De);
    }
    function He(De) {
      const ve = new d.BufferWriter();
      return ve.writeVarInt(De), ve.buffer();
    }
    function Pe(De) {
      return (0, E.sanitizeBigintToNumber)(new d.BufferReader(De).readVarInt());
    }
  }(psbtv2$2)), psbtv2$2;
}
var hasRequiredMerkelizedPsbt$2;
function requireMerkelizedPsbt$2() {
  if (hasRequiredMerkelizedPsbt$2) return merkelizedPsbt$2;
  hasRequiredMerkelizedPsbt$2 = 1, Object.defineProperty(merkelizedPsbt$2, "__esModule", { value: !0 }), merkelizedPsbt$2.MerkelizedPsbt = void 0;
  const o = requireMerkleMap$2(), g = requirePsbtv2$2();
  class c extends g.PsbtV2 {
    constructor(t) {
      super(), this.inputMerkleMaps = [], this.outputMerkleMaps = [], t.copy(this), this.globalMerkleMap = c.createMerkleMap(this.globalMap);
      for (let d = 0; d < this.getGlobalInputCount(); d++)
        this.inputMerkleMaps.push(c.createMerkleMap(this.inputMaps[d]));
      this.inputMapCommitments = [...this.inputMerkleMaps.values()].map((d) => d.commitment());
      for (let d = 0; d < this.getGlobalOutputCount(); d++)
        this.outputMerkleMaps.push(c.createMerkleMap(this.outputMaps[d]));
      this.outputMapCommitments = [...this.outputMerkleMaps.values()].map((d) => d.commitment());
    }
    // These public functions are for MerkelizedPsbt.
    getGlobalSize() {
      return this.globalMap.size;
    }
    getGlobalKeysValuesRoot() {
      return this.globalMerkleMap.commitment();
    }
    static createMerkleMap(t) {
      const d = [...t.keys()].sort(), E = d.map((D) => {
        const x = t.get(D);
        if (!x)
          throw new Error("No value for key " + D);
        return x;
      }), B = d.map((D) => Buffer.from(D, "hex"));
      return new o.MerkleMap(B, E);
    }
  }
  return merkelizedPsbt$2.MerkelizedPsbt = c, merkelizedPsbt$2;
}
var hasRequiredAppClient$2;
function requireAppClient$2() {
  if (hasRequiredAppClient$2) return appClient$1;
  hasRequiredAppClient$2 = 1, Object.defineProperty(appClient$1, "__esModule", { value: !0 }), appClient$1.AppClient = appClient$1.PartialSignature = void 0;
  const o = requireBip32$2(), g = requireClientCommands$2(), c = requireMerkelizedPsbt$2(), y = requireMerkle$2(), t = requirePsbtv2$2(), d = requireVarint$2(), E = 225, B = 248, D = 1;
  var x;
  (function(H) {
    H[H.GET_PUBKEY = 0] = "GET_PUBKEY", H[H.REGISTER_WALLET = 2] = "REGISTER_WALLET", H[H.GET_WALLET_ADDRESS = 3] = "GET_WALLET_ADDRESS", H[H.SIGN_PSBT = 4] = "SIGN_PSBT", H[H.GET_MASTER_FINGERPRINT = 5] = "GET_MASTER_FINGERPRINT", H[H.SIGN_MESSAGE = 16] = "SIGN_MESSAGE";
  })(x || (x = {}));
  var v;
  (function(H) {
    H[H.CONTINUE_INTERRUPTED = 1] = "CONTINUE_INTERRUPTED";
  })(v || (v = {}));
  class F {
    constructor(fe, ge, Ie) {
      this.pubkey = fe, this.signature = ge, this.tapleafHash = Ie;
    }
  }
  appClient$1.PartialSignature = F;
  function M(H, fe) {
    if (H.length == 64)
      return new F(H.slice(0, 32), fe, H.slice(32, 64));
    if (H.length == 32 || H.length == 33)
      return new F(H, fe);
    throw new Error(`Invalid length for pubkeyAugm: ${H.length} bytes.`);
  }
  function U(H) {
    return (H.match(/[asctdvjnlu]+:/g) || []).some((ge) => ge.includes("a"));
  }
  class L {
    constructor(fe) {
      this.transport = fe;
    }
    async makeRequest(fe, ge, Ie) {
      let Ee = await this.transport.send(E, fe, 0, D, ge, [36864, 57344]);
      for (; Ee.readUInt16BE(Ee.length - 2) === 57344; ) {
        if (!Ie)
          throw new Error("Unexpected SW_INTERRUPTED_EXECUTION");
        const Se = Ee.slice(0, -2), ze = Ie.execute(Se);
        Ee = await this.transport.send(B, v.CONTINUE_INTERRUPTED, 0, 0, ze, [36864, 57344]);
      }
      return Ee.slice(0, -2);
    }
    /**
     * Returns an object containing the currently running app's name, version and the device status flags.
     *
     * @returns an object with app name, version and device status flags.
     */
    async getAppAndVersion() {
      const fe = await this.transport.send(176, 1, 0, 0);
      let ge = 0;
      if (fe[ge++] !== 1)
        throw new Error("Unexpected response");
      const Ee = fe[ge++], Se = fe.slice(ge, ge += Ee).toString("ascii"), ze = fe[ge++], He = fe.slice(ge, ge += ze).toString("ascii"), Pe = fe[ge++], De = fe.slice(ge, ge += Pe);
      return {
        name: Se,
        version: He,
        flags: De
      };
    }
    /**
     * Requests the BIP-32 extended pubkey to the hardware wallet.
     * If `display` is `false`, only standard paths will be accepted; an error is returned if an unusual path is
     * requested.
     * If `display` is `true`, the requested path is shown on screen for user verification; unusual paths can be
     * requested, and a warning is shown to the user in that case.
     *
     * @param path the requested BIP-32 path as a string
     * @param display `false` to silently retrieve a pubkey for a standard path, `true` to display the path on screen
     * @returns the base58-encoded serialized extended pubkey (xpub)
     */
    async getExtendedPubkey(fe, ge = !1) {
      const Ie = (0, o.pathStringToArray)(fe);
      if (Ie.length > 6)
        throw new Error("Path too long. At most 6 levels allowed.");
      return (await this.makeRequest(x.GET_PUBKEY, Buffer.concat([
        Buffer.from(ge ? [1] : [0]),
        (0, o.pathElementsToBuffer)(Ie)
      ]))).toString("ascii");
    }
    /**
     * Registers a `WalletPolicy`, after interactive verification from the user.
     * On success, after user's approval, this function returns the id (which is the same that can be computed with
     * `walletPolicy.getid()`), followed by the 32-byte hmac. The client should store the hmac to use it for future
     * requests to `getWalletAddress` or `signPsbt` using this `WalletPolicy`.
     *
     * @param walletPolicy the `WalletPolicy` to register
     * @returns a pair of two 32-byte arrays: the id of the Wallet Policy, followed by the policy hmac
     */
    async registerWallet(fe) {
      await this.validatePolicy(fe);
      const ge = new g.ClientCommandInterpreter();
      ge.addKnownWalletPolicy(fe);
      const Ie = fe.serialize(), Ee = await this.makeRequest(x.REGISTER_WALLET, Buffer.concat([
        (0, d.createVarint)(Ie.length),
        Ie
      ]), ge);
      if (Ee.length != 64)
        throw Error(`Invalid response length. Expected 64 bytes, got ${Ee.length}`);
      return [Ee.subarray(0, 32), Ee.subarray(32)];
    }
    /**
     * Returns the address of `walletPolicy` for the given `change` and `addressIndex`.
     *
     * @param walletPolicy the `WalletPolicy` to use
     * @param walletHMAC the 32-byte hmac returned during wallet registration for a registered policy; otherwise
     * `null` for a standard policy
     * @param change `0` for a normal receive address, `1` for a change address
     * @param addressIndex the address index to retrieve
     * @param display `True` to show the address on screen, `False` to retrieve it silently
     * @returns the address, as an ascii string.
     */
    async getWalletAddress(fe, ge, Ie, Ee, Se) {
      if (Ie !== 0 && Ie !== 1)
        throw new Error("Change can only be 0 or 1");
      if (Ee < 0 || !Number.isInteger(Ee))
        throw new Error("Invalid address index");
      if (ge != null && ge.length != 32)
        throw new Error("Invalid HMAC length");
      await this.validatePolicy(fe);
      const ze = new g.ClientCommandInterpreter();
      ze.addKnownWalletPolicy(fe);
      const He = Buffer.alloc(4);
      return He.writeUInt32BE(Ee, 0), (await this.makeRequest(x.GET_WALLET_ADDRESS, Buffer.concat([
        Buffer.from(Se ? [1] : [0]),
        fe.getId(),
        ge || Buffer.alloc(32, 0),
        Buffer.from([Ie]),
        He
      ]), ze)).toString("ascii");
    }
    /**
     * Signs a psbt using a (standard or registered) `WalletPolicy`. This is an interactive command, as user validation
     * is necessary using the device's secure screen.
     * On success, a map of input indexes and signatures is returned.
     * @param psbt a base64-encoded string, or a psbt in a binary Buffer. Using the `PsbtV2` type is deprecated.
     * @param walletPolicy the `WalletPolicy` to use for signing
     * @param walletHMAC the 32-byte hmac obtained during wallet policy registration, or `null` for a standard policy
     * @param progressCallback optionally, a callback that will be called every time a signature is produced during
     * the signing process. The callback does not receive any argument, but can be used to track progress.
     * @returns an array of of tuples with 2 elements containing:
     *    - the index of the input being signed;
     *    - an instance of PartialSignature
     */
    async signPsbt(fe, ge, Ie, Ee) {
      if (await this.validatePolicy(ge), typeof fe == "string" && (fe = Buffer.from(fe, "base64")), Buffer.isBuffer(fe)) {
        const Fe = new t.PsbtV2();
        Fe.deserialize(fe), fe = Fe;
      }
      const Se = new c.MerkelizedPsbt(fe);
      if (Ie != null && Ie.length != 32)
        throw new Error("Invalid HMAC length");
      const ze = new g.ClientCommandInterpreter(Ee);
      ze.addKnownWalletPolicy(ge), ze.addKnownMapping(Se.globalMerkleMap);
      for (const Fe of Se.inputMerkleMaps)
        ze.addKnownMapping(Fe);
      for (const Fe of Se.outputMerkleMaps)
        ze.addKnownMapping(Fe);
      ze.addKnownList(Se.inputMapCommitments);
      const He = new y.Merkle(Se.inputMapCommitments.map((Fe) => (0, y.hashLeaf)(Fe))).getRoot();
      ze.addKnownList(Se.outputMapCommitments);
      const Pe = new y.Merkle(Se.outputMapCommitments.map((Fe) => (0, y.hashLeaf)(Fe))).getRoot();
      await this.makeRequest(x.SIGN_PSBT, Buffer.concat([
        Se.getGlobalKeysValuesRoot(),
        (0, d.createVarint)(Se.getGlobalInputCount()),
        He,
        (0, d.createVarint)(Se.getGlobalOutputCount()),
        Pe,
        ge.getId(),
        Ie || Buffer.alloc(32, 0)
      ]), ze);
      const De = ze.getYielded(), ve = [];
      for (const Fe of De) {
        const [be, Be] = (0, d.parseVarint)(Fe, 0), ke = Fe[Be], xe = Fe.subarray(Be + 1, Be + 1 + ke), Ne = Fe.subarray(Be + 1 + ke), Et = M(xe, Ne);
        ve.push([Number(be), Et]);
      }
      return ve;
    }
    /**
     * Returns the fingerprint of the master public key, as per BIP-32 standard.
     * @returns the master key fingerprint as a string of 8 hexadecimal digits.
     */
    async getMasterFingerprint() {
      return (await this.makeRequest(x.GET_MASTER_FINGERPRINT, Buffer.from([]))).toString("hex");
    }
    /**
     * Signs a message using the legacy Bitcoin Message Signing standard. The signed message is
     * the double-sha256 hash of the concatenation of:
     * - "\x18Bitcoin Signed Message:\n";
     * - the length of `message`, encoded as a Bitcoin-style variable length integer;
     * - `message`.
     *
     * @param message the serialized message to sign
     * @param path the BIP-32 path of the key used to sign the message
     * @returns base64-encoded signature of the message.
     */
    async signMessage(fe, ge) {
      const Ie = (0, o.pathStringToArray)(ge), Ee = new g.ClientCommandInterpreter(), Se = Math.ceil(fe.length / 64), ze = [];
      for (let De = 0; De < Se; De++)
        ze.push(fe.subarray(64 * De, 64 * De + 64));
      Ee.addKnownList(ze);
      const He = new y.Merkle(ze.map((De) => (0, y.hashLeaf)(De))).getRoot();
      return (await this.makeRequest(x.SIGN_MESSAGE, Buffer.concat([
        (0, o.pathElementsToBuffer)(Ie),
        (0, d.createVarint)(fe.length),
        He
      ]), Ee)).toString("base64");
    }
    /* Performs any additional checks on the policy before using it.*/
    async validatePolicy(fe) {
      if (U(fe.descriptorTemplate)) {
        const ge = await this.getAppAndVersion();
        if (["2.1.0", "2.1.1"].includes(ge.version))
          throw new Error("Please update your Ledger Bitcoin app.");
      }
    }
  }
  return appClient$1.AppClient = L, appClient$1.default = L, appClient$1;
}
var policy$2 = {}, hasRequiredPolicy$2;
function requirePolicy$2() {
  if (hasRequiredPolicy$2) return policy$2;
  hasRequiredPolicy$2 = 1, Object.defineProperty(policy$2, "__esModule", { value: !0 }), policy$2.DefaultWalletPolicy = policy$2.WalletPolicy = void 0;
  const o = require$$1, g = requireBuffertools$2(), c = requireMerkle$2(), y = 2;
  class t {
    /**
     * Creates and instance of a wallet policy.
     * @param name an ascii string, up to 16 bytes long; it must be an empty string for default wallet policies
     * @param descriptorTemplate the wallet policy template
     * @param keys and array of the keys, with the key derivation information
     */
    constructor(B, D, x) {
      this.name = B, this.descriptorTemplate = D, this.keys = x;
    }
    /**
     * Returns the unique 32-bytes id of this wallet policy.
     */
    getId() {
      return o.crypto.sha256(this.serialize());
    }
    /**
     * Serializes the wallet policy for transmission via the hardware wallet protocol.
     * @returns the serialized wallet policy
     */
    serialize() {
      const B = this.keys.map((v) => Buffer.from(v, "ascii")), D = new c.Merkle(B.map((v) => (0, c.hashLeaf)(v))), x = new g.BufferWriter();
      return x.writeUInt8(y), x.writeVarSlice(Buffer.from(this.name, "ascii")), x.writeVarInt(this.descriptorTemplate.length), x.writeSlice(o.crypto.sha256(Buffer.from(this.descriptorTemplate))), x.writeVarInt(this.keys.length), x.writeSlice(D.getRoot()), x.buffer();
    }
  }
  policy$2.WalletPolicy = t;
  class d extends t {
    constructor(B, D) {
      super("", B, [D]);
    }
  }
  return policy$2.DefaultWalletPolicy = d, policy$2;
}
var hasRequiredMain$3;
function requireMain$3() {
  return hasRequiredMain$3 || (hasRequiredMain$3 = 1, function(o) {
    var g = main$2 && main$2.__importDefault || function(d) {
      return d && d.__esModule ? d : { default: d };
    };
    Object.defineProperty(o, "__esModule", { value: !0 }), o.WalletPolicy = o.DefaultWalletPolicy = o.PsbtV2 = o.AppClient = void 0;
    const c = g(requireAppClient$2());
    o.AppClient = c.default;
    const y = requirePolicy$2();
    Object.defineProperty(o, "DefaultWalletPolicy", { enumerable: !0, get: function() {
      return y.DefaultWalletPolicy;
    } }), Object.defineProperty(o, "WalletPolicy", { enumerable: !0, get: function() {
      return y.WalletPolicy;
    } });
    const t = requirePsbtv2$2();
    Object.defineProperty(o, "PsbtV2", { enumerable: !0, get: function() {
      return t.PsbtV2;
    } }), o.default = c.default;
  }(main$2)), main$2;
}
var hasRequiredLedger;
function requireLedger() {
  if (hasRequiredLedger) return ledger;
  hasRequiredLedger = 1, Object.defineProperty(ledger, "__esModule", { value: !0 }), ledger.ledgerPolicyFromState = ledger.comparePolicies = ledger.ledgerPolicyFromStandard = ledger.registerLedgerWallet = ledger.descriptorToLedgerFormat = ledger.getLedgerXpub = ledger.getLedgerMasterFingerPrint = ledger.assertLedgerApp = ledger.importAndValidateLedgerBitcoin = void 0;
  const o = require$$1, g = requireRe();
  async function c(L) {
    let H;
    try {
      H = requireMain$3();
    } catch {
      throw new Error('Could not import "ledger-bitcoin". This is a peer dependency and needs to be installed explicitly. Please run "npm install ledger-bitcoin" to use Ledger Hardware Wallet functionality.');
    }
    const { AppClient: fe } = H;
    if (L !== void 0 && !(L instanceof fe))
      throw new Error("Error: invalid AppClient instance");
    return H;
  }
  ledger.importAndValidateLedgerBitcoin = c;
  async function y(L) {
    const H = await L.send(176, 1, 0, 0);
    let fe = 0;
    const ge = H[fe++], Ie = H[fe++], Ee = H.slice(fe, fe += Ie).toString("ascii"), Se = H[fe++], ze = H.slice(fe, fe += Se).toString("ascii"), He = H[fe++], Pe = H.slice(fe, fe += He);
    return { name: Ee, version: ze, flags: Pe, format: ge };
  }
  async function t({ transport: L, name: H, minVersion: fe }) {
    const { name: ge, version: Ie } = await y(L);
    if (ge !== H)
      throw new Error(`Open the ${H} app and try again`);
    {
      const [Ee, Se, ze] = fe.split(".").map(Number), [He, Pe, De] = Ie.split(".").map(Number);
      if (Ee === void 0 || Se === void 0 || ze === void 0)
        throw new Error("Pass a minVersion using semver notation: major.minor.patch");
      if (He < Ee || He === Ee && Pe < Se || He === Ee && Pe === Se && De < ze)
        throw new Error(`Error: please upgrade ${H} to version ${fe}`);
    }
  }
  ledger.assertLedgerApp = t;
  function d({ ledgerTemplate: L, keyRoots: H, network: fe = o.networks.bitcoin }) {
    var Ie, Ee;
    if (H.length !== 1)
      return !1;
    const ge = (Ee = (Ie = H[0]) == null ? void 0 : Ie.match(g.reOriginPath)) == null ? void 0 : Ee[1];
    return !ge || ge[5] !== (fe === o.networks.bitcoin ? "0" : "1") ? !1 : !!(L === "pkh(@0/**)" && ge.match(/^\/44'\/[01]'\/(\d+)'$/) || L === "wpkh(@0/**)" && ge.match(/^\/84'\/[01]'\/(\d+)'$/) || L === "sh(wpkh(@0/**))" && ge.match(/^\/49'\/[01]'\/(\d+)'$/) || L === "tr(@0/**)" && ge.match(/^\/86'\/[01]'\/(\d+)'$/));
  }
  async function E({ ledgerClient: L, ledgerState: H }) {
    const { AppClient: fe } = await c(L);
    if (!(L instanceof fe))
      throw new Error("Error: pass a valid ledgerClient");
    let ge = H.masterFingerprint;
    return ge || (ge = Buffer.from(await L.getMasterFingerprint(), "hex"), H.masterFingerprint = ge), ge;
  }
  ledger.getLedgerMasterFingerPrint = E;
  async function B({ originPath: L, ledgerClient: H, ledgerState: fe }) {
    const { AppClient: ge } = await c(H);
    if (!(H instanceof ge))
      throw new Error("Error: pass a valid ledgerClient");
    fe.xpubs || (fe.xpubs = {});
    let Ie = fe.xpubs[L];
    if (!Ie) {
      try {
        Ie = await H.getExtendedPubkey(`m${L}`, !1);
      } catch {
        Ie = await H.getExtendedPubkey(`m${L}`, !0);
      }
      if (typeof Ie != "string")
        throw new Error("Error: ledgerClient did not return a valid xpub");
      fe.xpubs[L] = Ie;
    }
    return Ie;
  }
  ledger.getLedgerXpub = B;
  async function D({ descriptor: L, ledgerClient: H, ledgerState: fe }) {
    const ge = L.expand().expandedExpression, Ie = L.expand().expansionMap;
    if (!ge || !Ie)
      throw new Error("Error: invalid descriptor");
    const Ee = await E({
      ledgerClient: H,
      ledgerState: fe
    }), Se = Object.keys(Ie).sort(), ze = Se.filter((ke) => {
      var Ne;
      const xe = (Ne = Ie[ke]) == null ? void 0 : Ne.masterFingerprint;
      return xe && Buffer.compare(xe, Ee) === 0;
    });
    if (ze.length === 0)
      return null;
    if (ze.length > 1)
      throw new Error(`Error: descriptor ${ge} does not contain exactly 1 ledger key`);
    const He = ze[0], Pe = Ie[He].masterFingerprint, De = Ie[He].originPath, ve = Ie[He].keyPath, Fe = Ie[He].bip32;
    if (!Pe || !De || !ve || !Fe)
      throw new Error(`Error: Ledger key expression must have a valid masterFingerprint: ${Pe}, originPath: ${De}, keyPath: ${ve} and a valid bip32 node`);
    if (!/^\/[01]\/\d+$/.test(ve))
      throw new Error("Error: key paths must be /<1;0>/index, where change is 1 or 0 and index >= 0");
    const be = [];
    let Be = ge;
    return Se.forEach((ke) => {
      var Ne, Et, st;
      if (ke !== He) {
        const Dt = Ie[ke];
        if (!Dt.bip32)
          throw new Error("Error: ledger only allows xpub-type key expressions");
        if (Dt.originPath && Dt.originPath !== De)
          throw new Error(`Error: all originPaths must be the same for Ledger being able to sign. On the other hand, you can leave the origin info empty for external keys: ${Dt.originPath} !== ${De}`);
        if (Dt.keyPath !== ve)
          throw new Error(`Error: all keyPaths must be the same for Ledger being able to sign: ${Dt.keyPath} !== ${ve}`);
      }
      Be = Be.replaceAll(ke, `@${be.length}/**`);
      const xe = Ie[ke];
      xe.masterFingerprint && xe.originPath ? be.push(`[${(Ne = xe.masterFingerprint) == null ? void 0 : Ne.toString("hex")}${xe.originPath}]${(Et = xe == null ? void 0 : xe.bip32) == null ? void 0 : Et.neutered().toBase58()}`) : be.push(`${(st = xe == null ? void 0 : xe.bip32) == null ? void 0 : st.neutered().toBase58()}`);
    }), { ledgerTemplate: Be, keyRoots: be };
  }
  ledger.descriptorToLedgerFormat = D;
  async function x({ descriptor: L, ledgerClient: H, ledgerState: fe, policyName: ge }) {
    const { WalletPolicy: Ie, AppClient: Ee } = await c(H);
    if (!(H instanceof Ee))
      throw new Error("Error: pass a valid ledgerClient");
    const Se = await D({
      descriptor: L,
      ledgerClient: H,
      ledgerState: fe
    });
    if (await v({ descriptor: L, ledgerClient: H, ledgerState: fe }))
      return;
    if (!Se)
      throw new Error("Error: descriptor does not have a ledger input");
    const { ledgerTemplate: ze, keyRoots: He } = Se;
    fe.policies || (fe.policies = []);
    let Pe, De;
    const ve = await U({
      descriptor: L,
      ledgerClient: H,
      ledgerState: fe
    });
    if (ve) {
      if (ve.policyName !== ge)
        throw new Error(`Error: policy was already registered with a different name: ${ve.policyName}`);
    } else {
      Pe = new Ie(ge, ze, He);
      let Fe;
      [Fe, De] = await H.registerWallet(Pe);
      const be = {
        policyName: ge,
        ledgerTemplate: ze,
        keyRoots: He,
        policyId: Fe,
        policyHmac: De
      };
      fe.policies.push(be);
    }
  }
  ledger.registerLedgerWallet = x;
  async function v({ descriptor: L, ledgerClient: H, ledgerState: fe }) {
    const ge = await D({
      descriptor: L,
      ledgerClient: H,
      ledgerState: fe
    });
    if (!ge)
      throw new Error("Error: descriptor does not have a ledger input");
    const { ledgerTemplate: Ie, keyRoots: Ee } = ge;
    return d({
      ledgerTemplate: Ie,
      keyRoots: Ee,
      network: L.getNetwork()
    }) ? { ledgerTemplate: Ie, keyRoots: Ee } : null;
  }
  ledger.ledgerPolicyFromStandard = v;
  function F(L, H) {
    if (L.length !== H.length)
      return !1;
    for (let fe = 0; fe < L.length; fe++)
      if (L[fe] !== H[fe])
        return !1;
    return !0;
  }
  function M(L, H) {
    return F(L.keyRoots, H.keyRoots) && L.ledgerTemplate === H.ledgerTemplate;
  }
  ledger.comparePolicies = M;
  async function U({ descriptor: L, ledgerClient: H, ledgerState: fe }) {
    const ge = await D({
      descriptor: L,
      ledgerClient: H,
      ledgerState: fe
    });
    if (!ge)
      throw new Error("Error: descriptor does not have a ledger input");
    const { ledgerTemplate: Ie, keyRoots: Ee } = ge;
    fe.policies || (fe.policies = []);
    const Se = fe.policies.filter((ze) => M(ze, { ledgerTemplate: Ie, keyRoots: Ee }));
    if (Se.length > 1)
      throw new Error("Error: duplicated policy");
    return Se.length === 1 ? Se[0] : null;
  }
  return ledger.ledgerPolicyFromState = U, ledger;
}
var hasRequiredKeyExpressions;
function requireKeyExpressions() {
  if (hasRequiredKeyExpressions) return keyExpressions;
  hasRequiredKeyExpressions = 1;
  var o = keyExpressions && keyExpressions.__createBinding || (Object.create ? function(F, M, U, L) {
    L === void 0 && (L = U);
    var H = Object.getOwnPropertyDescriptor(M, U);
    (!H || ("get" in H ? !M.__esModule : H.writable || H.configurable)) && (H = { enumerable: !0, get: function() {
      return M[U];
    } }), Object.defineProperty(F, L, H);
  } : function(F, M, U, L) {
    L === void 0 && (L = U), F[L] = M[U];
  }), g = keyExpressions && keyExpressions.__setModuleDefault || (Object.create ? function(F, M) {
    Object.defineProperty(F, "default", { enumerable: !0, value: M });
  } : function(F, M) {
    F.default = M;
  }), c = keyExpressions && keyExpressions.__importStar || function(F) {
    if (F && F.__esModule) return F;
    var M = {};
    if (F != null) for (var U in F) U !== "default" && Object.prototype.hasOwnProperty.call(F, U) && o(M, F, U);
    return g(M, F), M;
  };
  Object.defineProperty(keyExpressions, "__esModule", { value: !0 }), keyExpressions.keyExpressionBIP32 = keyExpressions.keyExpressionLedger = keyExpressions.parseKeyExpression = void 0;
  const y = require$$1, t = requireLedger(), d = c(requireRe()), E = (F, M) => {
    if (typeof M != "string")
      throw new Error(`Error: invalid derivation path ${M}`);
    const U = M.replaceAll("H", "'").replaceAll("h", "'").slice(1), L = U.split("/");
    for (const H of L) {
      const fe = H.endsWith("'") ? H.slice(0, -1) : H;
      if (!Number.isInteger(Number(fe)) || Number(fe) >= 2147483648)
        throw new Error("Error: BIP 32 path element overflow");
    }
    return F.derivePath(U);
  };
  function B({ keyExpression: F, isSegwit: M, ECPair: U, BIP32: L, network: H = y.networks.bitcoin }) {
    var Et, st, Dt, er;
    let fe, ge, Ie, Ee, Se, ze, He;
    const Pe = F.indexOf("*") !== -1, De = F.match(d.reKeyExp);
    if (De === null || De[0] !== F)
      throw new Error(`Error: expected a keyExpression but got ${F}`);
    const ve = RegExp(String.raw`^(${d.reOrigin})?`), Fe = F.match(ve);
    if (Fe) {
      const xt = Fe[0].replace(/[[\]]/g, ""), ir = String.raw`^(${d.reMasterFingerprint})`, sr = xt.match(ir), yr = sr ? sr[0] : "";
      if (Se = xt.replace(yr, ""), yr.length > 0) {
        if (yr.length !== 8)
          throw new Error(`Error: masterFingerprint ${yr} invalid for keyExpression: ${F}`);
        Ee = Buffer.from(yr, "hex");
      }
    }
    const be = F.replace(ve, "");
    let Be, ke, xe, Ne;
    if ((Be = be.match(d.anchorStartAndEnd(d.rePubKey))) !== null) {
      if (fe = Buffer.from(Be[0], "hex"), ge = U.fromPublicKey(fe, { network: H }), !U.isPoint(fe) || !(fe.length === 33 || fe.length === 65))
        throw new Error("Error: invalid pubkey");
      if (typeof M == "boolean" && M && fe.length !== 33)
        throw new Error("Error: invalid pubkey");
    } else if ((ke = be.match(d.anchorStartAndEnd(d.reWIF))) !== null)
      ge = U.fromWIF(ke[0], H), fe = ge.publicKey;
    else if ((xe = be.match(d.anchorStartAndEnd(d.reXpubKey))) !== null) {
      const xt = xe[0], ir = (Et = xt.match(d.reXpub)) == null ? void 0 : Et[0];
      if (!ir)
        throw new Error("Error: xpub could not be matched");
      if (Ie = L.fromBase58(ir, H), xt.match(d.rePath) !== null) {
        if (ze = (st = xt.match(d.rePath)) == null ? void 0 : st[0], !ze)
          throw new Error("Error: could not extract a path");
        Pe || (fe = E(Ie, ze).publicKey);
      } else
        fe = Ie.publicKey;
    } else if ((Ne = be.match(d.anchorStartAndEnd(d.reXprvKey))) !== null) {
      const xt = Ne[0], ir = (Dt = xt.match(d.reXprv)) == null ? void 0 : Dt[0];
      if (!ir)
        throw new Error("Error: xprv could not be matched");
      if (Ie = L.fromBase58(ir, H), xt.match(d.rePath) !== null) {
        if (ze = (er = xt.match(d.rePath)) == null ? void 0 : er[0], !ze)
          throw new Error("Error: could not extract a path");
        Pe || (fe = E(Ie, ze).publicKey);
      } else
        fe = Ie.publicKey;
    } else
      throw new Error(`Error: could not get pubkey for keyExpression ${F}`);
    return (Se || ze) && (He = `m${Se ?? ""}${ze ?? ""}`), {
      keyExpression: F,
      ...fe !== void 0 ? { pubkey: fe } : {},
      ...ge !== void 0 ? { ecpair: ge } : {},
      ...Ie !== void 0 ? { bip32: Ie } : {},
      ...Ee !== void 0 ? { masterFingerprint: Ee } : {},
      ...Se !== void 0 && Se !== "" ? { originPath: Se } : {},
      ...ze !== void 0 && ze !== "" ? { keyPath: ze } : {},
      ...He !== void 0 ? { path: He } : {}
    };
  }
  keyExpressions.parseKeyExpression = B;
  function D({ change: F, index: M, keyPath: U }) {
    if (!(F === void 0 && M === void 0 || F !== void 0 && M !== void 0))
      throw new Error("Error: Pass change and index or neither");
    if (F !== void 0 == (U !== void 0))
      throw new Error("Error: Pass either change and index or a keyPath");
  }
  async function x({ ledgerClient: F, ledgerState: M, originPath: U, keyPath: L, change: H, index: fe }) {
    D({ change: H, index: fe, keyPath: L });
    const Ie = `[${(await (0, t.getLedgerMasterFingerPrint)({
      ledgerClient: F,
      ledgerState: M
    })).toString("hex")}${U}]`, Ee = await (0, t.getLedgerXpub)({ originPath: U, ledgerClient: F, ledgerState: M }), Se = `${Ie}${Ee}`;
    return L !== void 0 ? `${Se}${L}` : `${Se}/${H}/${fe}`;
  }
  keyExpressions.keyExpressionLedger = x;
  function v({ masterNode: F, originPath: M, keyPath: U, change: L, index: H, isPublic: fe = !0 }) {
    D({ change: L, index: H, keyPath: U });
    const Ie = `[${F.fingerprint.toString("hex")}${M}]`, Ee = fe ? F.derivePath(`m${M}`).neutered().toBase58().toString() : F.derivePath(`m${M}`).toBase58().toString(), Se = `${Ie}${Ee}`;
    return U !== void 0 ? `${Se}${U}` : `${Se}/${L}/${H}`;
  }
  return keyExpressions.keyExpressionBIP32 = v, keyExpressions;
}
var miniscript = {}, dist = {}, bip68, hasRequiredBip68;
function requireBip68() {
  if (hasRequiredBip68) return bip68;
  hasRequiredBip68 = 1;
  const o = 4294967295, g = 1 << 31, c = 9, y = 65535, t = 1 << 22, d = y, E = 1 << c, B = y << c;
  function D(v) {
    return v & g ? {} : v & t ? {
      seconds: (v & y) << c
    } : {
      blocks: v & y
    };
  }
  function x({ blocks: v, seconds: F }) {
    if (v !== void 0 && F !== void 0) throw new TypeError("Cannot encode blocks AND seconds");
    if (v === void 0 && F === void 0) return o;
    if (F !== void 0) {
      if (!Number.isFinite(F)) throw new TypeError("Expected Number seconds");
      if (F > B) throw new TypeError("Expected Number seconds <= " + B);
      if (F % E !== 0) throw new TypeError("Expected Number seconds as a multiple of " + E);
      return t | F >> c;
    }
    if (!Number.isFinite(v)) throw new TypeError("Expected Number blocks");
    if (v > y) throw new TypeError("Expected Number blocks <= " + d);
    return v;
  }
  return bip68 = { decode: D, encode: x }, bip68;
}
var hasRequiredDist$1;
function requireDist$1() {
  if (hasRequiredDist$1) return dist;
  hasRequiredDist$1 = 1;
  var o = requireBip68();
  const g = "ABSOLUTE", c = "RELATIVE";
  function y(Ee, Se, ze) {
    if (typeof Ee > "u" && typeof Se > "u")
      return;
    if (typeof ze > "u")
      throw new Error("lockType must be specified");
    if (ze !== g && ze !== c)
      throw new Error('lockType must be either "ABSOLUTE" or "RELATIVE"');
    function He(Pe) {
      return !!(!isNaN(Pe) && !isNaN(parseFloat(Pe)) && Number.isInteger(Number(Pe)));
    }
    if (typeof Ee < "u") {
      if (He(Ee) === !1)
        throw new Error("nSequence/nLockTime must be an integer: " + Ee);
      if (Ee = Number(Ee), ze === c && !o.decode(Ee).hasOwnProperty("seconds") && !o.decode(Ee).hasOwnProperty("blocks"))
        throw new Error("Invalid bip68 encoded a value: " + Ee);
    }
    if (typeof Se < "u") {
      if (He(Se) === !1)
        throw new Error("nSequence/nLockTime must be an integer: " + Se);
      if (Se = Number(Se), ze === c && !o.decode(Se).hasOwnProperty("seconds") && !o.decode(Se).hasOwnProperty("blocks"))
        throw new Error("Invalid bip68 encoded b value: " + Se);
    }
    if (typeof Ee < "u" && typeof Se < "u") {
      if (ze === g) {
        if (Ee < 5e8 && Se >= 5e8 || Ee >= 5e8 && Se < 5e8)
          throw new Error(
            "nLockTime values must be either below 500000000 or both above or equal 500000000"
          );
      } else {
        const Pe = o.decode(Ee), De = o.decode(Se);
        if (Pe.hasOwnProperty("seconds") !== De.hasOwnProperty("seconds"))
          throw new Error(
            "a and b must both be either represent seconds or block height"
          );
      }
      return Math.max(Ee, Se);
    }
    if (typeof Ee < "u") return Ee;
    if (typeof Se < "u") return Se;
  }
  function t(Ee, Se) {
    const ze = /d?sat\(([^\(]*)\)/, He = Ee.match(ze);
    if (He && He.length) {
      const Pe = [], De = He[0], ve = Ee.split(De)[0], Fe = Ee.slice(De.length + ve.length), be = He[1], Be = De[0] === "d" ? "dsats" : "sats";
      if (typeof Se[be] != "object")
        throw new Error(
          `satisfactionsMap does not provide sats/dsats solutions for argument ${be}, evaluating: ${Ee}`
        );
      const ke = Se[be][Be] || [];
      for (const xe of ke)
        if (Fe.match(ze)) {
          const Ne = t(Fe, Se);
          for (const Et of Ne)
            Pe.push({
              nSequence: y(
                xe.nSequence,
                Et.nSequence,
                c
              ),
              nLockTime: y(
                xe.nLockTime,
                Et.nLockTime,
                g
              ),
              asm: `${ve}${xe.asm}${Et.asm}`
            });
        } else
          Pe.push({
            ...xe,
            asm: `${ve}${xe.asm}${Fe}`
          });
      return Pe;
    }
    throw new Error("Invalid solutionTemplate: " + Ee);
  }
  const d = {
    0: () => ({
      dsats: [{ asm: "" }]
    }),
    1: () => ({
      sats: [{ asm: "" }]
    }),
    pk_k: (Ee) => ({
      dsats: [{ asm: "0" }],
      sats: [{ asm: `<sig(${Ee})>` }]
    }),
    pk_h: (Ee) => ({
      dsats: [{ asm: `0 <${Ee}>` }],
      sats: [{ asm: `<sig(${Ee})> <${Ee}>` }]
    }),
    older: (Ee) => ({
      sats: [{ asm: "", nSequence: Ee }]
    }),
    after: (Ee) => ({
      sats: [{ asm: "", nLockTime: Ee }]
    }),
    sha256: (Ee) => ({
      sats: [{ asm: `<sha256_preimage(${Ee})>` }],
      dsats: [{ asm: "<random_preimage()>" }]
    }),
    ripemd160: (Ee) => ({
      sats: [{ asm: `<ripemd160_preimage(${Ee})>` }],
      dsats: [{ asm: "<random_preimage()>" }]
    }),
    hash256: (Ee) => ({
      sats: [{ asm: `<hash256_preimage(${Ee})>` }],
      dsats: [{ asm: "<random_preimage()>" }]
    }),
    hash160: (Ee) => ({
      sats: [{ asm: `<hash160_preimage(${Ee})>` }],
      dsats: [{ asm: "<random_preimage()>" }]
    }),
    andor: (Ee, Se, ze) => ({
      dsats: [
        ...t("dsat(Z) dsat(X)", { X: Ee, Y: Se, Z: ze }),
        ...t("dsat(Y) sat(X)", { X: Ee, Y: Se, Z: ze })
      ],
      sats: [
        ...t("sat(Y) sat(X)", { X: Ee, Y: Se, Z: ze }),
        ...t("sat(Z) dsat(X)", { X: Ee, Y: Se, Z: ze })
      ]
    }),
    and_v: (Ee, Se) => ({
      dsats: [...t("dsat(Y) sat(X)", { X: Ee, Y: Se })],
      sats: [...t("sat(Y) sat(X)", { X: Ee, Y: Se })]
    }),
    and_b: (Ee, Se) => ({
      dsats: [
        ...t("dsat(Y) dsat(X)", { X: Ee, Y: Se }),
        //https://bitcoin.sipa.be/miniscript/
        //The non-canonical options for and_b, or_b, and thresh are always
        //overcomplete (reason 3), so instead use DONTUSE there
        ...t("sat(Y) dsat(X)", { X: Ee, Y: Se }),
        ...t("dsat(Y) sat(X)", { X: Ee, Y: Se })
      ],
      sats: [...t("sat(Y) sat(X)", { Y: Se, X: Ee })]
    }),
    or_b: (Ee, Se) => ({
      dsats: [...t("dsat(Z) dsat(X)", { X: Ee, Z: Se })],
      sats: [
        ...t("dsat(Z) sat(X)", { X: Ee, Z: Se }),
        ...t("sat(Z) dsat(X)", { X: Ee, Z: Se }),
        //https://bitcoin.sipa.be/miniscript/
        //The non-canonical options for and_b, or_b, and thresh are always
        //overcomplete (reason 3), so instead use DONTUSE there
        ...t("sat(Z) sat(X)", { X: Ee, Z: Se })
      ]
    }),
    or_c: (Ee, Se) => ({
      sats: [
        ...t("sat(X)", { X: Ee, Z: Se }),
        ...t("sat(Z) dsat(X)", { X: Ee, Z: Se })
      ]
    }),
    or_d: (Ee, Se) => ({
      dsats: [...t("dsat(Z) dsat(X)", { X: Ee, Z: Se })],
      sats: [
        ...t("sat(X)", { X: Ee, Z: Se }),
        ...t("sat(Z) dsat(X)", { X: Ee, Z: Se })
      ]
    }),
    or_i: (Ee, Se) => ({
      dsats: [
        ...t("dsat(X) 1", { X: Ee, Z: Se }),
        ...t("dsat(Z) 0", { X: Ee, Z: Se })
      ],
      sats: [...t("sat(X) 1", { X: Ee, Z: Se }), ...t("sat(Z) 0", { X: Ee, Z: Se })]
    }),
    /*
     * This is not entirely trivial from the docs
     * (https://bitcoin.sipa.be/miniscript/),
     *  but solution templates for thresh must be written in reverse order.
     *  For example the first dsat, which is "All dsats", corresponds to:
     *  "<DSAT_N> <DSAT_N-1> ... <DSAT_1>" (note the reverse order in N)
     *  While this is not entirely trivial by reading the document
     *  it can be deduced by analyzing the script:
     *  thresh(k,X1,...,Xn)	[X1] [X2] ADD ... [Xn] ADD ... <k> EQUAL
     */
    thresh: (Ee, ...Se) => {
      if (Number.isInteger(Number(Ee)) && Number(Ee) > 0) Ee = Number(Ee);
      else throw new Error(`k must be positive number: ${Ee}`);
      const ze = {}, He = Se.length;
      Se.map((be, Be) => {
        ze[Be] = be;
      });
      const Pe = [], De = [];
      Pe.push(
        ...t(
          Object.keys(ze).map((be) => `dsat(${be})`).reverse().join(" "),
          ze
        )
      );
      const ve = [], Fe = [];
      for (let be = 1; be < 1 << He; be++) {
        const Be = [];
        let ke = 0;
        for (let xe = 0; xe < He; xe++)
          be & 1 << xe && ke++, Be.push(be & 1 << xe ? `sat(${xe})` : `dsat(${xe})`);
        ke !== Ee ? ve.push(Be.reverse().join(" ")) : Fe.push(Be.reverse().join(" "));
      }
      for (const be of ve)
        Pe.push(...t(be, ze));
      for (const be of Fe)
        De.push(...t(be, ze));
      return { dsats: Pe, sats: De };
    },
    multi: (Ee, ...Se) => {
      if (Number.isInteger(Number(Ee)) && Number(Ee) > 0) Ee = Number(Ee);
      else throw new Error(`k must be positive number: ${Ee}`);
      if (typeof Ee != "number") throw new Error("k must be a number:" + Ee);
      if (Ee === 0) throw new Error("k cannot be 0");
      const ze = [{ asm: "0 ".repeat(Ee + 1).trim() }];
      function He(Fe, be) {
        if (be === 0)
          return [[]];
        const Be = [];
        for (let ke = 0; ke < Fe.length; ke++) {
          const xe = Fe.slice(ke + 1);
          He(xe, be - 1).forEach((Et) => {
            Be.push([Fe[ke], ...Et]);
          });
        }
        return Be;
      }
      const Pe = [];
      He(Se, Ee).forEach((Fe) => {
        let be = "0";
        Fe.forEach((Be) => {
          be += ` <sig(${Be})>`;
        }), Pe.push(be);
      });
      let De = "0";
      for (let Fe = 0; Fe < Ee; Fe++)
        De += ` <sig(${Se[Fe]})>`;
      return { sats: Pe.map((Fe) => ({ asm: Fe })), dsats: ze };
    },
    a: (Ee) => ({
      dsats: [...t("dsat(X)", { X: Ee })],
      sats: [...t("sat(X)", { X: Ee })]
    }),
    s: (Ee) => ({
      dsats: [...t("dsat(X)", { X: Ee })],
      sats: [...t("sat(X)", { X: Ee })]
    }),
    c: (Ee) => ({
      dsats: [...t("dsat(X)", { X: Ee })],
      sats: [...t("sat(X)", { X: Ee })]
    }),
    d: (Ee) => ({
      dsats: [{ asm: "0" }],
      sats: [...t("sat(X) 1", { X: Ee })]
    }),
    v: (Ee) => ({
      sats: [...t("sat(X)", { X: Ee })]
    }),
    /**
    	   * j:X corresponds to SIZE 0NOTEQUAL IF [X] ENDIF
    	   *
    	   * By definition, this: "dsat(X) X" produces a zero.
    	   *
    	   *
    	   * A dsat needs to make this "dsat(X) X" return zero.
    
    	   * The easiest dsat for j:X is using 0:
    	   * 0 SIZE 0NOTEQUAL IF [X] ENDIF
    	   * 0 0 0NOTEQUAL IF [X] ENDIF
    	   * 0 0 IF [X] ENDIF
    	   * 0
    
    	   * Now let's do the case where dsat(X) finishes with a 0: "... 0"
    	   * ... 0 SIZE 0NOTEQUAL IF [X] ENDIF
    	   * ... 0 0 0NOTEQUAL IF [X] ENDIF
    	   * ... 0 0 IF [X] ENDIF 
    	   * ... 0
    	   * DSAT(X)
    	   * The final expression is "DSAT(X)".
    	   * It should have either been "0" or "DSAT(X) X"
    	   * Thus, this is not a valid dsat.
    
    	   * Now let's do the case where dsat(X) is this: "... <nonzero>"
    	   * ... <nonzero> SIZE 0NOTEQUAL IF [X] ENDIF
    	   * ... <nonzero> <length_is_nonzero> 0NOTEQUAL IF [X] ENDIF
    	   * ... <nonzero> 1 IF [X] ENDIF
    	   * ... <nonzero> [X]
    	   * DSAT(X) [X]
    
    	   * DSAT(X) X is a good dsat
    	   */
    j: (Ee) => {
      const Se = [];
      Se.push({ asm: "0" });
      const ze = Ee.dsats.filter(
        //The top stack corresponds to the last element pushed to the stack,
        //that is, the last element in the produced witness
        (He) => He.asm.trim().split(" ").pop() !== "0"
      );
      return Se.push(...ze), { dsats: Se, sats: [...t("sat(X)", { X: Ee })] };
    },
    n: (Ee) => ({
      dsats: [...t("dsat(X)", { X: Ee })],
      sats: [...t("sat(X)", { X: Ee })]
    })
  };
  function E(Ee, Se) {
    return Se = { exports: {} }, Ee(Se, Se.exports), Se.exports;
  }
  var B = E(function(Ee, Se) {
    var ze = (() => {
      var He = typeof document < "u" && document.currentScript ? document.currentScript.src : void 0;
      return function(Pe = {}) {
        var De = Pe, ve, Fe;
        De.ready = new Promise((Yi, En) => {
          ve = Yi, Fe = En;
        });
        var be = Object.assign({}, De), Be = "./this.program", ke = "";
        function xe(Yi) {
          return De.locateFile ? De.locateFile(Yi, ke) : ke + Yi;
        }
        typeof document < "u" && document.currentScript && (ke = document.currentScript.src), He && (ke = He), ke.indexOf("blob:") !== 0 ? ke = ke.substr(0, ke.replace(/[?#].*/, "").lastIndexOf("/") + 1) : ke = "", De.print || console.log.bind(console);
        var Ne = De.printErr || console.error.bind(console);
        Object.assign(De, be), be = null, De.arguments && De.arguments, De.thisProgram && (Be = De.thisProgram), De.quit && De.quit;
        var Et;
        De.wasmBinary && (Et = De.wasmBinary), De.noExitRuntime;
        var st = { Memory: function(Yi) {
          this.buffer = new ArrayBuffer(Yi.initial * 65536);
        }, Module: function(Yi) {
        }, Instance: function(Yi, En) {
          this.exports = // EMSCRIPTEN_START_ASM
          function(Xn) {
            function ls(Ko) {
              return Ko.set = function(js, gu) {
                this[js] = gu;
              }, Ko.get = function(js) {
                return this[js];
              }, Ko;
            }
            for (var Yn, cs = new Uint8Array(123), ks = 25; ks >= 0; --ks)
              cs[48 + ks] = 52 + ks, cs[65 + ks] = ks, cs[97 + ks] = 26 + ks;
            cs[43] = 62, cs[47] = 63;
            function ws(Ko, js, gu) {
              for (var iu, _, Zs = 0, e = js, me = gu.length, Ia = js + (me * 3 >> 2) - (gu[me - 2] == "=") - (gu[me - 1] == "="); Zs < me; Zs += 4)
                iu = cs[gu.charCodeAt(Zs + 1)], _ = cs[gu.charCodeAt(Zs + 2)], Ko[e++] = cs[gu.charCodeAt(Zs)] << 2 | iu >> 4, e < Ia && (Ko[e++] = iu << 4 | _ >> 2), e < Ia && (Ko[e++] = _ << 6 | cs[gu.charCodeAt(Zs + 3)]);
            }
            function Ro(Ko) {
              ws(Yn, 1024, "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"), ws(Yn, 5584, "////////////////////////////////////////////////////////////////AAECAwQFBgcICf////////8KCwwNDg///////////////////////////////////woLDA0OD/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////4QAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADEDwAAgw8AAFcPAADcDwAAtw0AAFQQAACtDwAAdA8AAGUPAABNDwAAQg8AABMPAAALDwAA+w4AALIQAADZDwAAoA8AAGcPAABkDwAATA8AAEEPAADFCwAAfAsAAB8NAAAlDQAAOg0AAC4NAABeDQAAQw0AADUKAADvCwAA0gwAAOAMAAC8CwAArAsAAKQLAACLCwAA/woAANsLAACbCwAA8AwAALQLAACUCwAAzAsAAIMLAADKDAAAWQwAAPgKAADTCwAAwgwAADMLAABKCwAAKwsAAA4LAABMDQAA7goAAKUNAABUCwAAWgsAAGgMAAA/CgAAtw8AAHYPAADKDQAA3w0AADYMAADmCgAAVA0AADoLAAAHCwAAgAwAAMMNAADYDQAALwwAAN8KAACeDQAAIQsAABcLAACsDQAAcgsAALYMAABOCgAAcQwAAA4MAAAaDAAAjQwAAKAMAAD5CwAA0goAAAAMAABzEAAA0Q8AADcPAABoEAAALA8AAGELAAD+DAAAYAoAAAoNAAByCgAArw8AAIkKAACgCgAATw8AAEQPAAAVDwAADQ8AAP0OAAC2DgAArBAAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAOQLAADkCwAA5AsAAI0NAAAEXwAABF8AAARfAAAEXwAABF8AAARfAAAEXwAABF8AAARfAAAEXwAAFF8AACRfAAA0XwAARF8AAFRfAABkXwAAdF8AAIRfAACUXwAApF8AAMRfAAC0XwAA1F8AAORfAAAEXwAABF8="), ws(Yn, 6976, "MDEyMzQ1Njc4OWFiY2RlZgAAAAAAAAAAJAEAACUBAAAmAQAAJwEAACgBAAAAAAAAGQAKABkZGQAAAAAFAAAAAAAACQAAAAALAAAAAAAAAAAZABEKGRkZAwoHAAEACQsYAAAJBgsAAAsABhkAAAAZGRk="), ws(Yn, 7105, "DgAAAAAAAAAAGQAKDRkZGQANAAACAAkOAAAACQAOAAAO"), ws(Yn, 7163, "DA=="), ws(Yn, 7175, "EwAAAAATAAAAAAkMAAAAAAAMAAAM"), ws(Yn, 7221, "EA=="), ws(Yn, 7233, "DwAAAAQPAAAAAAkQAAAAAAAQAAAQ"), ws(Yn, 7279, "Eg=="), ws(Yn, 7291, "EQAAAAARAAAAAAkSAAAAAAASAAASAAAaAAAAGhoa"), ws(Yn, 7346, "GgAAABoaGgAAAAAAAAk="), ws(Yn, 7395, "FA=="), ws(Yn, 7407, "FwAAAAAXAAAAAAkUAAAAAAAUAAAU"), ws(Yn, 7453, "Fg=="), ws(Yn, 7465, "FQAAAAAVAAAAAAkWAAAAAAAWAAAWAAAwMTIzNDU2Nzg5QUJDREVGAAAAAAIAAAADAAAABQAAAAcAAAALAAAADQAAABEAAAATAAAAFwAAAB0AAAAfAAAAJQAAACkAAAArAAAALwAAADUAAAA7AAAAPQAAAEMAAABHAAAASQAAAE8AAABTAAAAWQAAAGEAAABlAAAAZwAAAGsAAABtAAAAcQAAAH8AAACDAAAAiQAAAIsAAACVAAAAlwAAAJ0AAACjAAAApwAAAK0AAACzAAAAtQAAAL8AAADBAAAAxQAAAMcAAADTAAAAAQAAAAsAAAANAAAAEQAAABMAAAAXAAAAHQAAAB8AAAAlAAAAKQAAACsAAAAvAAAANQAAADsAAAA9AAAAQwAAAEcAAABJAAAATwAAAFMAAABZAAAAYQAAAGUAAABnAAAAawAAAG0AAABxAAAAeQAAAH8AAACDAAAAiQAAAIsAAACPAAAAlQAAAJcAAACdAAAAowAAAKcAAACpAAAArQAAALMAAAC1AAAAuwAAAL8AAADBAAAAxQAAAMcAAADRAAAAAAAAALwfAAApAQAAKgEAACsBAAAsAQAALQEAAC4BAAAvAQAAMAEAADEBAAAyAQAAMwEAADQBAAA1AQAANgEAAAAAAABQIAAANwEAADgBAAArAQAALAEAADkBAAA6AQAALwEAADABAAAxAQAAOwEAADMBAAA8AQAANQEAAD0BAABOU3QzX18yOWJhc2ljX2lvc0ljTlNfMTFjaGFyX3RyYWl0c0ljRUVFRQAAACRZAABQHwAAXCEAAE5TdDNfXzIxNWJhc2ljX3N0cmVhbWJ1ZkljTlNfMTFjaGFyX3RyYWl0c0ljRUVFRQAAAADkWAAAiB8AAE5TdDNfXzIxM2Jhc2ljX29zdHJlYW1JY05TXzExY2hhcl90cmFpdHNJY0VFRUUAAABXAADEHwAAAAAAAAEAAAB8HwAAA/T//05TdDNfXzIxNWJhc2ljX3N0cmluZ2J1ZkljTlNfMTFjaGFyX3RyYWl0c0ljRUVOU185YWxsb2NhdG9ySWNFRUVFAAAAJFkAAAwgAAC8HwAAOAAAAAAAAAD0IAAAPgEAAD8BAADI////yP////QgAABAAQAAQQEAADgAAAAAAAAA9B8AAEIBAABDAQAAyP///8j////0HwAARAEAAEUBAABOU3QzX18yMTliYXNpY19vc3RyaW5nc3RyZWFtSWNOU18xMWNoYXJfdHJhaXRzSWNFRU5TXzlhbGxvY2F0b3JJY0VFRUUAAAAkWQAArCAAAPQfAAAAAAAArCEAAEYBAABHAQAASAEAAEkBAABKAQAASwEAAEwBAAAAAAAAgCEAALEAAABNAQAATgEAAAAAAABcIQAATwEAAFABAABOU3QzX18yOGlvc19iYXNlRQAAAORYAABIIQAATlN0M19fMjhpb3NfYmFzZTdmYWlsdXJlRQAAACRZAABkIQAAlFUAAE5TdDNfXzIxOV9faW9zdHJlYW1fY2F0ZWdvcnlFAAAAJFkAAIwhAADkVQ=="), ws(Yn, 8640, "/////////////////////////////////////////////////////////////////wABAgMEBQYHCAn/////////CgsMDQ4PEBESExQVFhcYGRobHB0eHyAhIiP///////8KCwwNDg8QERITFBUWFxgZGhscHR4fICEiI/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////8AAQIEBwMGBQAAAAAAAADRdJ4AV529KoBwUg///z4nCgAAAGQAAADoAwAAECcAAKCGAQBAQg8AgJaYAADh9QUYAAAANQAAAHEAAABr////zvv//5K///8AAAAAAAAAAN4SBJUAAAAA////////////////"), ws(Yn, 9024, "TENfQ1RZUEUAAAAATENfTlVNRVJJQwAATENfVElNRQAAAAAATENfQ09MTEFURQAATENfTU9ORVRBUlkATENfTUVTU0FHRVMAICMAABQAAABDLlVURi04"), ws(Yn, 9652, "AQAAAAIAAAADAAAABAAAAAUAAAAGAAAABwAAAAgAAAAJAAAACgAAAAsAAAAMAAAADQAAAA4AAAAPAAAAEAAAABEAAAASAAAAEwAAABQAAAAVAAAAFgAAABcAAAAYAAAAGQAAABoAAAAbAAAAHAAAAB0AAAAeAAAAHwAAACAAAAAhAAAAIgAAACMAAAAkAAAAJQAAACYAAAAnAAAAKAAAACkAAAAqAAAAKwAAACwAAAAtAAAALgAAAC8AAAAwAAAAMQAAADIAAAAzAAAANAAAADUAAAA2AAAANwAAADgAAAA5AAAAOgAAADsAAAA8AAAAPQAAAD4AAAA/AAAAQAAAAGEAAABiAAAAYwAAAGQAAABlAAAAZgAAAGcAAABoAAAAaQAAAGoAAABrAAAAbAAAAG0AAABuAAAAbwAAAHAAAABxAAAAcgAAAHMAAAB0AAAAdQAAAHYAAAB3AAAAeAAAAHkAAAB6AAAAWwAAAFwAAABdAAAAXgAAAF8AAABgAAAAYQAAAGIAAABjAAAAZAAAAGUAAABmAAAAZwAAAGgAAABpAAAAagAAAGsAAABsAAAAbQAAAG4AAABvAAAAcAAAAHEAAAByAAAAcwAAAHQAAAB1AAAAdgAAAHcAAAB4AAAAeQAAAHoAAAB7AAAAfAAAAH0AAAB+AAAAfw=="), ws(Yn, 11188, "AQAAAAIAAAADAAAABAAAAAUAAAAGAAAABwAAAAgAAAAJAAAACgAAAAsAAAAMAAAADQAAAA4AAAAPAAAAEAAAABEAAAASAAAAEwAAABQAAAAVAAAAFgAAABcAAAAYAAAAGQAAABoAAAAbAAAAHAAAAB0AAAAeAAAAHwAAACAAAAAhAAAAIgAAACMAAAAkAAAAJQAAACYAAAAnAAAAKAAAACkAAAAqAAAAKwAAACwAAAAtAAAALgAAAC8AAAAwAAAAMQAAADIAAAAzAAAANAAAADUAAAA2AAAANwAAADgAAAA5AAAAOgAAADsAAAA8AAAAPQAAAD4AAAA/AAAAQAAAAEEAAABCAAAAQwAAAEQAAABFAAAARgAAAEcAAABIAAAASQAAAEoAAABLAAAATAAAAE0AAABOAAAATwAAAFAAAABRAAAAUgAAAFMAAABUAAAAVQAAAFYAAABXAAAAWAAAAFkAAABaAAAAWwAAAFwAAABdAAAAXgAAAF8AAABgAAAAQQAAAEIAAABDAAAARAAAAEUAAABGAAAARwAAAEgAAABJAAAASgAAAEsAAABMAAAATQAAAE4AAABPAAAAUAAAAFEAAABSAAAAUwAAAFQAAABVAAAAVgAAAFcAAABYAAAAWQAAAFoAAAB7AAAAfAAAAH0AAAB+AAAAfw=="), ws(Yn, 12208, "AgAAwAMAAMAEAADABQAAwAYAAMAHAADACAAAwAkAAMAKAADACwAAwAwAAMANAADADgAAwA8AAMAQAADAEQAAwBIAAMATAADAFAAAwBUAAMAWAADAFwAAwBgAAMAZAADAGgAAwBsAAMAcAADAHQAAwB4AAMAfAADAAAAAswEAAMMCAADDAwAAwwQAAMMFAADDBgAAwwcAAMMIAADDCQAAwwoAAMMLAADDDAAAww0AANMOAADDDwAAwwAADLsBAAzDAgAMwwMADMMEAAzbAAAAADAxMjM0NTY3ODlhYmNkZWZBQkNERUZ4WCstcFBpSW5OACVJOiVNOiVTICVwJUg6JU0="), ws(Yn, 12480, "JQAAAG0AAAAvAAAAJQAAAGQAAAAvAAAAJQAAAHkAAAAlAAAAWQAAAC0AAAAlAAAAbQAAAC0AAAAlAAAAZAAAACUAAABJAAAAOgAAACUAAABNAAAAOgAAACUAAABTAAAAIAAAACUAAABwAAAAAAAAACUAAABIAAAAOgAAACUAAABN"), ws(Yn, 12624, "JQAAAEgAAAA6AAAAJQAAAE0AAAA6AAAAJQAAAFMAAAAAAAAAxDoAAFEBAABSAQAAUwEAAAAAAAAkOwAAVAEAAFUBAABTAQAAVgEAAFcBAABYAQAAWQEAAFoBAABbAQAAXAEAAF0B"), ws(Yn, 12736, "BAAAAAQAAAAEAAAABAAAAAQAAAAEAAAABAAAAAQAAAAEAAAABQIAAAUAAAAFAAAABQAAAAUAAAAEAAAABAAAAAQAAAAEAAAABAAAAAQAAAAEAAAABAAAAAQAAAAEAAAABAAAAAQAAAAEAAAABAAAAAQAAAAEAAAABAAAAAQAAAADAgAAggAAAIIAAACCAAAAggAAAIIAAACCAAAAggAAAIIAAACCAAAAggAAAIIAAACCAAAAggAAAIIAAACCAAAAQgEAAEIBAABCAQAAQgEAAEIBAABCAQAAQgEAAEIBAABCAQAAQgEAAIIAAACCAAAAggAAAIIAAACCAAAAggAAAIIAAAAqAQAAKgEAACoBAAAqAQAAKgEAACoBAAAqAAAAKgAAACoAAAAqAAAAKgAAACoAAAAqAAAAKgAAACoAAAAqAAAAKgAAACoAAAAqAAAAKgAAACoAAAAqAAAAKgAAACoAAAAqAAAAKgAAAIIAAACCAAAAggAAAIIAAACCAAAAggAAADIBAAAyAQAAMgEAADIBAAAyAQAAMgEAADIAAAAyAAAAMgAAADIAAAAyAAAAMgAAADIAAAAyAAAAMgAAADIAAAAyAAAAMgAAADIAAAAyAAAAMgAAADIAAAAyAAAAMgAAADIAAAAyAAAAggAAAIIAAACCAAAAggAAAAQ="), ws(Yn, 13764, "jDoAAF4BAABfAQAAUwEAAGABAABhAQAAYgEAAGMBAABkAQAAZQEAAGYBAAAAAAAAXDsAAGcBAABoAQAAUwEAAGkBAABqAQAAawEAAGwBAABtAQAAAAAAAIA7AABuAQAAbwEAAFMBAABwAQAAcQEAAHIBAABzAQAAdAEAAHQAAAByAAAAdQAAAGUAAAAAAAAAZgAAAGEAAABsAAAAcwAAAGUAAAAAAAAAJQAAAG0AAAAvAAAAJQAAAGQAAAAvAAAAJQAAAHkAAAAAAAAAJQAAAEgAAAA6AAAAJQAAAE0AAAA6AAAAJQAAAFMAAAAAAAAAJQAAAGEAAAAgAAAAJQAAAGIAAAAgAAAAJQAAAGQAAAAgAAAAJQAAAEgAAAA6AAAAJQAAAE0AAAA6AAAAJQAAAFMAAAAgAAAAJQAAAFkAAAAAAAAAJQAAAEkAAAA6AAAAJQAAAE0AAAA6AAAAJQAAAFMAAAAgAAAAJQAAAHA="), ws(Yn, 14140, "ZDcAAHUBAAB2AQAAUwEAAE5TdDNfXzI2bG9jYWxlNWZhY2V0RQAAACRZAABMNwAA3FUAAAAAAADkNwAAdQEAAHcBAABTAQAAeAEAAHkBAAB6AQAAewEAAHwBAAB9AQAAfgEAAH8BAACAAQAAgQEAAIIBAACDAQAATlN0M19fMjVjdHlwZUl3RUUATlN0M19fMjEwY3R5cGVfYmFzZUUAAORYAADGNwAAAFcAALQ3AAAAAAAAAgAAAGQ3AAACAAAA3DcAAAIAAAAAAAAAeDgAAHUBAACEAQAAUwEAAIUBAACGAQAAhwEAAIgBAACJAQAAigEAAIsBAABOU3QzX18yN2NvZGVjdnRJY2MxMV9fbWJzdGF0ZV90RUUATlN0M19fMjEyY29kZWN2dF9iYXNlRQAAAADkWAAAVjgAAABXAAA0OAAAAAAAAAIAAABkNwAAAgAAAHA4AAACAAAAAAAAAOw4AAB1AQAAjAEAAFMBAACNAQAAjgEAAI8BAACQAQAAkQEAAJIBAACTAQAATlN0M19fMjdjb2RlY3Z0SURzYzExX19tYnN0YXRlX3RFRQAAAFcAAMg4AAAAAAAAAgAAAGQ3AAACAAAAcDgAAAIAAAAAAAAAYDkAAHUBAACUAQAAUwEAAJUBAACWAQAAlwEAAJgBAACZAQAAmgEAAJsBAABOU3QzX18yN2NvZGVjdnRJRHNEdTExX19tYnN0YXRlX3RFRQAAVwAAPDkAAAAAAAACAAAAZDcAAAIAAABwOAAAAgAAAAAAAADUOQAAdQEAAJwBAABTAQAAnQEAAJ4BAACfAQAAoAEAAKEBAACiAQAAowEAAE5TdDNfXzI3Y29kZWN2dElEaWMxMV9fbWJzdGF0ZV90RUUAAABXAACwOQAAAAAAAAIAAABkNwAAAgAAAHA4AAACAAAAAAAAAEg6AAB1AQAApAEAAFMBAAClAQAApgEAAKcBAACoAQAAqQEAAKoBAACrAQAATlN0M19fMjdjb2RlY3Z0SURpRHUxMV9fbWJzdGF0ZV90RUUAAFcAACQ6AAAAAAAAAgAAAGQ3AAACAAAAcDgAAAIAAABOU3QzX18yN2NvZGVjdnRJd2MxMV9fbWJzdGF0ZV90RUUAAAAAVwAAaDoAAAAAAAACAAAAZDcAAAIAAABwOAAAAgAAAE5TdDNfXzI2bG9jYWxlNV9faW1wRQAAACRZAACsOgAAZDcAAE5TdDNfXzI3Y29sbGF0ZUljRUUAJFkAANA6AABkNwAATlN0M19fMjdjb2xsYXRlSXdFRQAkWQAA8DoAAGQ3AABOU3QzX18yNWN0eXBlSWNFRQAAAABXAAAQOwAAAAAAAAIAAABkNwAAAgAAANw3AAACAAAATlN0M19fMjhudW1wdW5jdEljRUUAAAAAJFkAAEQ7AABkNwAATlN0M19fMjhudW1wdW5jdEl3RUUAAAAAJFkAAGg7AABkNwAAAAAAAOQ6AACsAQAArQEAAFMBAACuAQAArwEAALABAAAAAAAABDsAALEBAACyAQAAUwEAALMBAAC0AQAAtQEAAAAAAACgPAAAdQEAALYBAABTAQAAtwEAALgBAAC5AQAAugEAALsBAAC8AQAAvQEAAL4BAAC/AQAAwAEAAMEBAABOU3QzX18yN251bV9nZXRJY05TXzE5aXN0cmVhbWJ1Zl9pdGVyYXRvckljTlNfMTFjaGFyX3RyYWl0c0ljRUVFRUVFAE5TdDNfXzI5X19udW1fZ2V0SWNFRQBOU3QzX18yMTRfX251bV9nZXRfYmFzZUUAAORYAABmPAAAAFcAAFA8AAAAAAAAAQAAAIA8AAAAAAAAAFcAAAw8AAAAAAAAAgAAAGQ3AAACAAAAiDw="), ws(Yn, 15556, "dD0AAHUBAADCAQAAUwEAAMMBAADEAQAAxQEAAMYBAADHAQAAyAEAAMkBAADKAQAAywEAAMwBAADNAQAATlN0M19fMjdudW1fZ2V0SXdOU18xOWlzdHJlYW1idWZfaXRlcmF0b3JJd05TXzExY2hhcl90cmFpdHNJd0VFRUVFRQBOU3QzX18yOV9fbnVtX2dldEl3RUUAAAAAVwAARD0AAAAAAAABAAAAgDwAAAAAAAAAVwAAAD0AAAAAAAACAAAAZDcAAAIAAABcPQ=="), ws(Yn, 15768, "XD4AAHUBAADOAQAAUwEAAM8BAADQAQAA0QEAANIBAADTAQAA1AEAANUBAADWAQAATlN0M19fMjdudW1fcHV0SWNOU18xOW9zdHJlYW1idWZfaXRlcmF0b3JJY05TXzExY2hhcl90cmFpdHNJY0VFRUVFRQBOU3QzX18yOV9fbnVtX3B1dEljRUUATlN0M19fMjE0X19udW1fcHV0X2Jhc2VFAADkWAAAIj4AAABXAAAMPgAAAAAAAAEAAAA8PgAAAAAAAABXAADIPQAAAAAAAAIAAABkNwAAAgAAAEQ+"), ws(Yn, 16e3, "JD8AAHUBAADXAQAAUwEAANgBAADZAQAA2gEAANsBAADcAQAA3QEAAN4BAADfAQAATlN0M19fMjdudW1fcHV0SXdOU18xOW9zdHJlYW1idWZfaXRlcmF0b3JJd05TXzExY2hhcl90cmFpdHNJd0VFRUVFRQBOU3QzX18yOV9fbnVtX3B1dEl3RUUAAAAAVwAA9D4AAAAAAAABAAAAPD4AAAAAAAAAVwAAsD4AAAAAAAACAAAAZDcAAAIAAAAMPw=="), ws(Yn, 16200, "JEAAAOABAADhAQAAUwEAAOIBAADjAQAA5AEAAOUBAADmAQAA5wEAAOgBAAD4////JEAAAOkBAADqAQAA6wEAAOwBAADtAQAA7gEAAO8BAABOU3QzX18yOHRpbWVfZ2V0SWNOU18xOWlzdHJlYW1idWZfaXRlcmF0b3JJY05TXzExY2hhcl90cmFpdHNJY0VFRUVFRQBOU3QzX18yOXRpbWVfYmFzZUUA5FgAAN0/AABOU3QzX18yMjBfX3RpbWVfZ2V0X2Nfc3RvcmFnZUljRUUAAADkWAAA+D8AAABXAACYPwAAAAAAAAMAAABkNwAAAgAAAPA/AAACAAAAHEAAAAAIAAAAAAAAEEEAAPABAADxAQAAUwEAAPIBAADzAQAA9AEAAPUBAAD2AQAA9wEAAPgBAAD4////EEEAAPkBAAD6AQAA+wEAAPwBAAD9AQAA/gEAAP8BAABOU3QzX18yOHRpbWVfZ2V0SXdOU18xOWlzdHJlYW1idWZfaXRlcmF0b3JJd05TXzExY2hhcl90cmFpdHNJd0VFRUVFRQBOU3QzX18yMjBfX3RpbWVfZ2V0X2Nfc3RvcmFnZUl3RUUAAORYAADlQAAAAFcAAKBAAAAAAAAAAwAAAGQ3AAACAAAA8D8AAAIAAAAIQQAAAAgAAAAAAAC0QQAAAAIAAAECAABTAQAAAgIAAE5TdDNfXzI4dGltZV9wdXRJY05TXzE5b3N0cmVhbWJ1Zl9pdGVyYXRvckljTlNfMTFjaGFyX3RyYWl0c0ljRUVFRUVFAE5TdDNfXzIxMF9fdGltZV9wdXRFAAAA5FgAAJVBAAAAVwAAUEEAAAAAAAACAAAAZDcAAAIAAACsQQAAAAgAAAAAAAA0QgAAAwIAAAQCAABTAQAABQIAAE5TdDNfXzI4dGltZV9wdXRJd05TXzE5b3N0cmVhbWJ1Zl9pdGVyYXRvckl3TlNfMTFjaGFyX3RyYWl0c0l3RUVFRUVFAAAAAABXAADsQQAAAAAAAAIAAABkNwAAAgAAAKxBAAAACAAAAAAAAMhCAAB1AQAABgIAAFMBAAAHAgAACAIAAAkCAAAKAgAACwIAAAwCAAANAgAADgIAAA8CAABOU3QzX18yMTBtb25leXB1bmN0SWNMYjBFRUUATlN0M19fMjEwbW9uZXlfYmFzZUUAAAAA5FgAAKhCAAAAVwAAjEIAAAAAAAACAAAAZDcAAAIAAADAQgAAAgAAAAAAAAA8QwAAdQEAABACAABTAQAAEQIAABICAAATAgAAFAIAABUCAAAWAgAAFwIAABgCAAAZAgAATlN0M19fMjEwbW9uZXlwdW5jdEljTGIxRUVFAABXAAAgQwAAAAAAAAIAAABkNwAAAgAAAMBCAAACAAAAAAAAALBDAAB1AQAAGgIAAFMBAAAbAgAAHAIAAB0CAAAeAgAAHwIAACACAAAhAgAAIgIAACMCAABOU3QzX18yMTBtb25leXB1bmN0SXdMYjBFRUUAAFcAAJRDAAAAAAAAAgAAAGQ3AAACAAAAwEIAAAIAAAAAAAAAJEQAAHUBAAAkAgAAUwEAACUCAAAmAgAAJwIAACgCAAApAgAAKgIAACsCAAAsAgAALQIAAE5TdDNfXzIxMG1vbmV5cHVuY3RJd0xiMUVFRQAAVwAACEQAAAAAAAACAAAAZDcAAAIAAADAQgAAAgAAAAAAAADIRAAAdQEAAC4CAABTAQAALwIAADACAABOU3QzX18yOW1vbmV5X2dldEljTlNfMTlpc3RyZWFtYnVmX2l0ZXJhdG9ySWNOU18xMWNoYXJfdHJhaXRzSWNFRUVFRUUATlN0M19fMjExX19tb25leV9nZXRJY0VFAADkWAAApkQAAABXAABgRAAAAAAAAAIAAABkNwAAAgAAAMBE"), ws(Yn, 17644, "bEUAAHUBAAAxAgAAUwEAADICAAAzAgAATlN0M19fMjltb25leV9nZXRJd05TXzE5aXN0cmVhbWJ1Zl9pdGVyYXRvckl3TlNfMTFjaGFyX3RyYWl0c0l3RUVFRUVFAE5TdDNfXzIxMV9fbW9uZXlfZ2V0SXdFRQAA5FgAAEpFAAAAVwAABEUAAAAAAAACAAAAZDcAAAIAAABkRQ=="), ws(Yn, 17808, "EEYAAHUBAAA0AgAAUwEAADUCAAA2AgAATlN0M19fMjltb25leV9wdXRJY05TXzE5b3N0cmVhbWJ1Zl9pdGVyYXRvckljTlNfMTFjaGFyX3RyYWl0c0ljRUVFRUVFAE5TdDNfXzIxMV9fbW9uZXlfcHV0SWNFRQAA5FgAAO5FAAAAVwAAqEUAAAAAAAACAAAAZDcAAAIAAAAIRg=="), ws(Yn, 17972, "tEYAAHUBAAA3AgAAUwEAADgCAAA5AgAATlN0M19fMjltb25leV9wdXRJd05TXzE5b3N0cmVhbWJ1Zl9pdGVyYXRvckl3TlNfMTFjaGFyX3RyYWl0c0l3RUVFRUVFAE5TdDNfXzIxMV9fbW9uZXlfcHV0SXdFRQAA5FgAAJJGAAAAVwAATEYAAAAAAAACAAAAZDcAAAIAAACsRg=="), ws(Yn, 18136, "LEcAAHUBAAA6AgAAUwEAADsCAAA8AgAAPQIAAE5TdDNfXzI4bWVzc2FnZXNJY0VFAE5TdDNfXzIxM21lc3NhZ2VzX2Jhc2VFAAAAAORYAAAJRwAAAFcAAPRGAAAAAAAAAgAAAGQ3AAACAAAAJEcAAAIAAAAAAAAAhEcAAHUBAAA+AgAAUwEAAD8CAABAAgAAQQIAAE5TdDNfXzI4bWVzc2FnZXNJd0VFAAAAAABXAABsRwAAAAAAAAIAAABkNwAAAgAAACRHAAACAAAAUwAAAHUAAABuAAAAZAAAAGEAAAB5AAAAAAAAAE0AAABvAAAAbgAAAGQAAABhAAAAeQAAAAAAAABUAAAAdQAAAGUAAABzAAAAZAAAAGEAAAB5AAAAAAAAAFcAAABlAAAAZAAAAG4AAABlAAAAcwAAAGQAAABhAAAAeQAAAAAAAABUAAAAaAAAAHUAAAByAAAAcwAAAGQAAABhAAAAeQAAAAAAAABGAAAAcgAAAGkAAABkAAAAYQAAAHkAAAAAAAAAUwAAAGEAAAB0AAAAdQAAAHIAAABkAAAAYQAAAHkAAAAAAAAAUwAAAHUAAABuAAAAAAAAAE0AAABvAAAAbgAAAAAAAABUAAAAdQAAAGUAAAAAAAAAVwAAAGUAAABkAAAAAAAAAFQAAABoAAAAdQAAAAAAAABGAAAAcgAAAGkAAAAAAAAAUwAAAGEAAAB0AAAAAAAAAEoAAABhAAAAbgAAAHUAAABhAAAAcgAAAHkAAAAAAAAARgAAAGUAAABiAAAAcgAAAHUAAABhAAAAcgAAAHkAAAAAAAAATQAAAGEAAAByAAAAYwAAAGgAAAAAAAAAQQAAAHAAAAByAAAAaQAAAGwAAAAAAAAATQAAAGEAAAB5AAAAAAAAAEoAAAB1AAAAbgAAAGUAAAAAAAAASgAAAHUAAABsAAAAeQAAAAAAAABBAAAAdQAAAGcAAAB1AAAAcwAAAHQAAAAAAAAAUwAAAGUAAABwAAAAdAAAAGUAAABtAAAAYgAAAGUAAAByAAAAAAAAAE8AAABjAAAAdAAAAG8AAABiAAAAZQAAAHIAAAAAAAAATgAAAG8AAAB2AAAAZQAAAG0AAABiAAAAZQAAAHIAAAAAAAAARAAAAGUAAABjAAAAZQAAAG0AAABiAAAAZQAAAHIAAAAAAAAASgAAAGEAAABuAAAAAAAAAEYAAABlAAAAYgAAAAAAAABNAAAAYQAAAHIAAAAAAAAAQQAAAHAAAAByAAAAAAAAAEoAAAB1AAAAbgAAAAAAAABKAAAAdQAAAGwAAAAAAAAAQQAAAHUAAABnAAAAAAAAAFMAAABlAAAAcAAAAAAAAABPAAAAYwAAAHQAAAAAAAAATgAAAG8AAAB2AAAAAAAAAEQAAABlAAAAYwAAAAAAAABBAAAATQAAAAAAAABQAAAATQ=="), ws(Yn, 19228, "HEAAAOkBAADqAQAA6wEAAOwBAADtAQAA7gEAAO8BAAAAAAAACEEAAPkBAAD6AQAA+wEAAPwBAAD9AQAA/gEAAP8BAABOU3QzX18yMTRfX3NoYXJlZF9jb3VudEU="), ws(Yn, 19348, "iCM="), ws(Yn, 19372, "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"), ws(Yn, 21298, "pQJbAPABtQWMBSUBgwYdA5QE/wDHAzEDCwa8AY8BfwPKBCsA2gavAEIDTgPcAQ4EFQChBg0BlAILAjgGZAK8Av8CXQPnBAsHzwLLBe8F2wXhAh4GRQKFAIICbANvBPEA8wMYBdkA2gNMBlQCewGdA70EAABRABUCuwCzA20A/wGFBC8F+QQ4AGUBRgGfALcGqAFzAlMB"), ws(Yn, 21496, "IQQAAAAAAAAAAC8C"), ws(Yn, 21528, "NQRHBFYE"), ws(Yn, 21550, "oAQ="), ws(Yn, 21570, "RgVgBW4FYQYAAM8BAAAAAAAAAADJBukG+QYeBzkHSQdeBw=="), ws(Yn, 21620, "CgAAAGQAAADoAwAAECcAAKCGAQBAQg8AgJaYAADh9QUAypo7AAAAAAAAAAAwMDAxMDIwMzA0MDUwNjA3MDgwOTEwMTExMjEzMTQxNTE2MTcxODE5MjAyMTIyMjMyNDI1MjYyNzI4MjkzMDMxMzIzMzM0MzUzNjM3MzgzOTQwNDE0MjQzNDQ0NTQ2NDc0ODQ5NTA1MTUyNTM1NDU1NTY1NzU4NTk2MDYxNjI2MzY0NjU2NjY3Njg2OTcwNzE3MjczNzQ3NTc2Nzc3ODc5ODA4MTgyODM4NDg1ODY4Nzg4ODk5MDkxOTI5Mzk0OTU5Njk3OTg5OQAAAACUVQAAQgIAAEMCAABOAQAATlN0M19fMjEyc3lzdGVtX2Vycm9yRQAAJFkAAHxVAACIWAAATlN0M19fMjE0ZXJyb3JfY2F0ZWdvcnlFAAAAAORYAACgVQAATlN0M19fMjEyX19kb19tZXNzYWdlRQAA5FgAAGBLAAAkWQAAxFUAALxVAAAAAAAA3FUAAEQCAABFAgAARgIAAE4xMF9fY3h4YWJpdjExNl9fc2hpbV90eXBlX2luZm9FAAAAACRZAAAEVgAAFFkAAE4xMF9fY3h4YWJpdjExN19fY2xhc3NfdHlwZV9pbmZvRQAAACRZAAA0VgAAKFYAAE4xMF9fY3h4YWJpdjExN19fcGJhc2VfdHlwZV9pbmZvRQAAACRZAABkVgAAKFYAAE4xMF9fY3h4YWJpdjExOV9fcG9pbnRlcl90eXBlX2luZm9FACRZAACUVgAAiFYAAE4xMF9fY3h4YWJpdjEyMF9fc2lfY2xhc3NfdHlwZV9pbmZvRQAAAAAkWQAAxFYAAFhWAAAAAAAASFcAAEgCAABJAgAASgIAAEsCAABMAgAATQIAAE4CAABPAgAATjEwX19jeHhhYml2MTIxX192bWlfY2xhc3NfdHlwZV9pbmZvRQAAACRZAAAgVwAAWFYAAAAAAACwVwAABQAAAFACAABRAgAAAAAAALxXAAAFAAAAUgIAAFMCAABTdDlleGNlcHRpb24AU3QyMGJhZF9hcnJheV9uZXdfbGVuZ3RoAFN0OWJhZF9hbGxvYwAAJFkAAKJXAABQWQAAJFkAAIlXAACwVwAAAAAAAABYAAAHAAAAVAIAAFUCAAAAAAAAiFgAAFwAAABWAgAATgEAAFN0MTFsb2dpY19lcnJvcgAkWQAA8FcAAFBZAAAAAAAANFgAAAcAAABXAgAAVQIAAFN0MTJsZW5ndGhfZXJyb3IAAAAAJFkAACBYAAAAWAAAAAAAAGhYAAAHAAAAWAIAAFUCAABTdDEyb3V0X29mX3JhbmdlAAAAACRZAABUWAAAAFgAAFN0MTNydW50aW1lX2Vycm9yAAAAJFkAAHRYAABQWQAAAAAAALxYAABcAAAAWQIAAE4BAABTdDE0b3ZlcmZsb3dfZXJyb3IAACRZAACoWAAAiFgAAAAAAABYWQAArQAAAFoCAABbAgAAAAAAAFhWAABIAgAAXAIAAEoCAABLAgAATAIAAF0CAABeAgAAXwIAAFN0OXR5cGVfaW5mbwAAAADkWAAABFkAAAAAAADsVgAASAIAAGACAABKAgAASwIAAEwCAABhAgAAYgIAAGMCAABTdDhiYWRfY2FzdADkWAAAfFcAACRZAABEWQAAUFkAAAAAAABQWQAABQAAAGQCAABlAg=="), ws(Yn, 22904, "0GoBAAghAABHAg==");
            }
            var jo = new ArrayBuffer(16), Yo = new Int32Array(jo), Mo = new Float32Array(jo), No = new Float64Array(jo);
            function _s(Ko) {
              return Yo[Ko];
            }
            function Zo(Ko, js) {
              Yo[Ko] = js;
            }
            function ru() {
              return No[0];
            }
            function Ca(Ko) {
              No[0] = Ko;
            }
            function Oi() {
              throw new Error("abort");
            }
            function ho() {
              return Mo[2];
            }
            function $o(Ko) {
              Mo[2] = Ko;
            }
            function Oa(Ko) {
              var js = Ko.a, gu = js.a, iu = gu.buffer, _ = new Int8Array(iu), Zs = new Int16Array(iu), e = new Int32Array(iu), me = new Uint8Array(iu), Ia = new Uint16Array(iu), Ls = new Uint32Array(iu), gc = new Float32Array(iu), jn = new Float64Array(iu), Sn = Math.imul, ma = Math.fround, $d = Math.abs, Fo = Math.clz32, eh = Math.ceil, Hr = js.b, pi = js.c, Mi = js.d, ji = js.e, xn = js.f, Nn = js.g, Jn = js.h, gs = js.i, Os = js.j, Vs = js.k, qo = js.l, wa = js.m, Qa = js.n, za = js.o, ga = js.p, au = js.q, Ua = js.r, uu = js.s, Cu = js.t, Cf = js.u, ef = js.v, Uf = js.w, _c = js.x, pc = js.y, yc = js.z, Ml = js.A, Fl = js.B, Zc = js.C, $c = js.D, th = js.E, el = js.F, Ll = js.G, rh = js.H, Vu = js.I, Gu = js.J, F1 = js.K, L1 = js.L, Hl = js.M, H1 = js.N, ih = js.O, K1 = js.P, V1 = js.Q, G1 = js.R, q4 = js.S, Vl = js.T, Gl = js.U, ku = js.V, O4 = js.W, j1 = js.X, Jr = 92880, yo = 0, Ds = 0;
              function W1(r, s) {
                r = r | 0, s = s | 0;
                var u = 0, A = 0, m = 0, p = 0, N = 0, W = 0, Te = 0, Xe = 0, fr = 0, ar = 0, vr = 0;
                m = Jr - 352 | 0, Jr = m, e[m + 328 >> 2] = 0, e[m + 320 >> 2] = 0, e[m + 324 >> 2] = 0, e[5996] = 0, e[m + 316 >> 2] = 0, e[m + 308 >> 2] = 0, e[m + 312 >> 2] = 0, p = Mi(3, 24) | 0, A = e[5996], e[5996] = 0;
                e: {
                  t: {
                    r: {
                      if ((A | 0) != 1) {
                        e[p + 8 >> 2] = -1, e[p + 12 >> 2] = -1, e[p >> 2] = 0, e[p + 16 >> 2] = -1, e[p + 20 >> 2] = -1, u = p + 24 | 0, e[m + 328 >> 2] = u, e[m + 320 >> 2] = p, vr = m + 296 | 0;
                        i: {
                          n: {
                            s: {
                              a: {
                                o: {
                                  l: {
                                    c: {
                                      d: {
                                        f: {
                                          for (; ; ) {
                                            A = u - 24 | 0, N = e[A + 20 >> 2], e[vr >> 2] = e[A + 16 >> 2], e[vr + 4 >> 2] = N, N = e[A + 12 >> 2], e[m + 288 >> 2] = e[A + 8 >> 2], e[m + 292 >> 2] = N, W = e[A + 4 >> 2], N = e[A >> 2], e[m + 280 >> 2] = N, e[m + 284 >> 2] = W, e[m + 324 >> 2] = A, ar = 18;
                                            u: {
                                              g: {
                                                A: {
                                                  p: {
                                                    m: {
                                                      k: {
                                                        N: {
                                                          S: {
                                                            T: {
                                                              v: {
                                                                w: {
                                                                  E: {
                                                                    h: {
                                                                      R:
                                                                        switch (N | 0) {
                                                                          case 0:
                                                                            u = e[s + 4 >> 2];
                                                                            I: {
                                                                              if ((u | 0) < 2) {
                                                                                p = -1;
                                                                                break I;
                                                                              }
                                                                              for (N = e[s >> 2], p = 1; ; ) {
                                                                                if (W = me[p + N | 0], (W | 0) == 58) {
                                                                                  ar = 0;
                                                                                  B: {
                                                                                    x: {
                                                                                      b: {
                                                                                        C: {
                                                                                          for (; ; ) {
                                                                                            y: {
                                                                                              D:
                                                                                                switch (me[e[s >> 2] + ar | 0] - 97 | 0) {
                                                                                                  case 0:
                                                                                                    if (A = e[m + 324 >> 2], W = e[m + 328 >> 2], A >>> 0 < W >>> 0) {
                                                                                                      e[A + 8 >> 2] = -1, e[A + 12 >> 2] = -1, e[A >> 2] = 3, e[A + 16 >> 2] = -1, e[A + 20 >> 2] = -1, e[m + 324 >> 2] = A + 24;
                                                                                                      break y;
                                                                                                    }
                                                                                                    P: {
                                                                                                      q: {
                                                                                                        O: {
                                                                                                          N = e[m + 320 >> 2], Xe = (A - N | 0) / 24 | 0, u = Xe + 1 | 0;
                                                                                                          Q: {
                                                                                                            if (u >>> 0 >= 178956971) {
                                                                                                              if (e[5996] = 0, Nn(142), r = e[5996], e[5996] = 0, (r | 0) == 1)
                                                                                                                break Q;
                                                                                                              break e;
                                                                                                            }
                                                                                                            if (W = (W - N | 0) / 24 | 0, Te = W << 1, W = W >>> 0 >= 89478485 ? 178956970 : u >>> 0 < Te >>> 0 ? Te : u, !W) {
                                                                                                              Te = 0;
                                                                                                              break q;
                                                                                                            }
                                                                                                            if (W >>> 0 < 178956971)
                                                                                                              break O;
                                                                                                            if (e[5996] = 0, Nn(35), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                                                              break e;
                                                                                                          }
                                                                                                          s = Hr() | 0;
                                                                                                          break t;
                                                                                                        }
                                                                                                        if (e[5996] = 0, Te = Mi(3, Sn(W, 24) | 0) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1)
                                                                                                          break P;
                                                                                                      }
                                                                                                      if (u = Sn(Xe, 24) + Te | 0, e[u + 8 >> 2] = -1, e[u + 12 >> 2] = -1, e[u >> 2] = 3, e[u + 16 >> 2] = -1, e[u + 20 >> 2] = -1, Xe = u + 24 | 0, (A | 0) != (N | 0)) {
                                                                                                        for (; A = A - 24 | 0, fr = e[A + 4 >> 2], u = u - 24 | 0, e[u >> 2] = e[A >> 2], e[u + 4 >> 2] = fr, fr = e[A + 20 >> 2], e[u + 16 >> 2] = e[A + 16 >> 2], e[u + 20 >> 2] = fr, fr = e[A + 12 >> 2], e[u + 8 >> 2] = e[A + 8 >> 2], e[u + 12 >> 2] = fr, (A | 0) != (N | 0); )
                                                                                                          ;
                                                                                                        A = N;
                                                                                                      }
                                                                                                      if (e[m + 328 >> 2] = Sn(W, 24) + Te, e[m + 324 >> 2] = Xe, e[m + 320 >> 2] = u, !A)
                                                                                                        break y;
                                                                                                      Br(A);
                                                                                                      break y;
                                                                                                    }
                                                                                                    s = Hr() | 0;
                                                                                                    break t;
                                                                                                  case 18:
                                                                                                    if (A = e[m + 324 >> 2], W = e[m + 328 >> 2], A >>> 0 < W >>> 0) {
                                                                                                      e[A + 8 >> 2] = -1, e[A + 12 >> 2] = -1, e[A >> 2] = 2, e[A + 16 >> 2] = -1, e[A + 20 >> 2] = -1, e[m + 324 >> 2] = A + 24;
                                                                                                      break y;
                                                                                                    }
                                                                                                    P: {
                                                                                                      q: {
                                                                                                        O: {
                                                                                                          N = e[m + 320 >> 2], Xe = (A - N | 0) / 24 | 0, u = Xe + 1 | 0;
                                                                                                          Q: {
                                                                                                            if (u >>> 0 >= 178956971) {
                                                                                                              e[5996] = 0, Nn(142);
                                                                                                              break Q;
                                                                                                            }
                                                                                                            if (W = (W - N | 0) / 24 | 0, Te = W << 1, W = W >>> 0 >= 89478485 ? 178956970 : u >>> 0 < Te >>> 0 ? Te : u, !W) {
                                                                                                              Te = 0;
                                                                                                              break q;
                                                                                                            }
                                                                                                            if (W >>> 0 < 178956971)
                                                                                                              break O;
                                                                                                            e[5996] = 0, Nn(35);
                                                                                                          }
                                                                                                          if (r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                                                            break e;
                                                                                                          s = Hr() | 0;
                                                                                                          break t;
                                                                                                        }
                                                                                                        if (e[5996] = 0, Te = Mi(3, Sn(W, 24) | 0) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1)
                                                                                                          break P;
                                                                                                      }
                                                                                                      if (u = Sn(Xe, 24) + Te | 0, e[u + 8 >> 2] = -1, e[u + 12 >> 2] = -1, e[u >> 2] = 2, e[u + 16 >> 2] = -1, e[u + 20 >> 2] = -1, Xe = u + 24 | 0, (A | 0) != (N | 0)) {
                                                                                                        for (; A = A - 24 | 0, fr = e[A + 4 >> 2], u = u - 24 | 0, e[u >> 2] = e[A >> 2], e[u + 4 >> 2] = fr, fr = e[A + 20 >> 2], e[u + 16 >> 2] = e[A + 16 >> 2], e[u + 20 >> 2] = fr, fr = e[A + 12 >> 2], e[u + 8 >> 2] = e[A + 8 >> 2], e[u + 12 >> 2] = fr, (A | 0) != (N | 0); )
                                                                                                          ;
                                                                                                        A = N;
                                                                                                      }
                                                                                                      if (e[m + 328 >> 2] = Sn(W, 24) + Te, e[m + 324 >> 2] = Xe, e[m + 320 >> 2] = u, !A)
                                                                                                        break y;
                                                                                                      Br(A);
                                                                                                      break y;
                                                                                                    }
                                                                                                    s = Hr() | 0;
                                                                                                    break t;
                                                                                                  case 2:
                                                                                                    if (A = e[m + 324 >> 2], W = e[m + 328 >> 2], A >>> 0 < W >>> 0) {
                                                                                                      e[A + 8 >> 2] = -1, e[A + 12 >> 2] = -1, e[A >> 2] = 4, e[A + 16 >> 2] = -1, e[A + 20 >> 2] = -1, e[m + 324 >> 2] = A + 24;
                                                                                                      break y;
                                                                                                    }
                                                                                                    P: {
                                                                                                      q: {
                                                                                                        O: {
                                                                                                          N = e[m + 320 >> 2], Xe = (A - N | 0) / 24 | 0, u = Xe + 1 | 0;
                                                                                                          Q: {
                                                                                                            if (u >>> 0 >= 178956971) {
                                                                                                              e[5996] = 0, Nn(142);
                                                                                                              break Q;
                                                                                                            }
                                                                                                            if (W = (W - N | 0) / 24 | 0, Te = W << 1, W = W >>> 0 >= 89478485 ? 178956970 : u >>> 0 < Te >>> 0 ? Te : u, !W) {
                                                                                                              Te = 0;
                                                                                                              break q;
                                                                                                            }
                                                                                                            if (W >>> 0 < 178956971)
                                                                                                              break O;
                                                                                                            e[5996] = 0, Nn(35);
                                                                                                          }
                                                                                                          if (r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                                                            break e;
                                                                                                          s = Hr() | 0;
                                                                                                          break t;
                                                                                                        }
                                                                                                        if (e[5996] = 0, Te = Mi(3, Sn(W, 24) | 0) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1)
                                                                                                          break P;
                                                                                                      }
                                                                                                      if (u = Sn(Xe, 24) + Te | 0, e[u + 8 >> 2] = -1, e[u + 12 >> 2] = -1, e[u >> 2] = 4, e[u + 16 >> 2] = -1, e[u + 20 >> 2] = -1, Xe = u + 24 | 0, (A | 0) != (N | 0)) {
                                                                                                        for (; A = A - 24 | 0, fr = e[A + 4 >> 2], u = u - 24 | 0, e[u >> 2] = e[A >> 2], e[u + 4 >> 2] = fr, fr = e[A + 20 >> 2], e[u + 16 >> 2] = e[A + 16 >> 2], e[u + 20 >> 2] = fr, fr = e[A + 12 >> 2], e[u + 8 >> 2] = e[A + 8 >> 2], e[u + 12 >> 2] = fr, (A | 0) != (N | 0); )
                                                                                                          ;
                                                                                                        A = N;
                                                                                                      }
                                                                                                      if (e[m + 328 >> 2] = Sn(W, 24) + Te, e[m + 324 >> 2] = Xe, e[m + 320 >> 2] = u, !A)
                                                                                                        break y;
                                                                                                      Br(A);
                                                                                                      break y;
                                                                                                    }
                                                                                                    s = Hr() | 0;
                                                                                                    break t;
                                                                                                  case 3:
                                                                                                    if (A = e[m + 324 >> 2], W = e[m + 328 >> 2], A >>> 0 < W >>> 0) {
                                                                                                      e[A + 8 >> 2] = -1, e[A + 12 >> 2] = -1, e[A >> 2] = 5, e[A + 16 >> 2] = -1, e[A + 20 >> 2] = -1, e[m + 324 >> 2] = A + 24;
                                                                                                      break y;
                                                                                                    }
                                                                                                    P: {
                                                                                                      q: {
                                                                                                        O: {
                                                                                                          N = e[m + 320 >> 2], Xe = (A - N | 0) / 24 | 0, u = Xe + 1 | 0;
                                                                                                          Q: {
                                                                                                            if (u >>> 0 >= 178956971) {
                                                                                                              e[5996] = 0, Nn(142);
                                                                                                              break Q;
                                                                                                            }
                                                                                                            if (W = (W - N | 0) / 24 | 0, Te = W << 1, W = W >>> 0 >= 89478485 ? 178956970 : u >>> 0 < Te >>> 0 ? Te : u, !W) {
                                                                                                              Te = 0;
                                                                                                              break q;
                                                                                                            }
                                                                                                            if (W >>> 0 < 178956971)
                                                                                                              break O;
                                                                                                            e[5996] = 0, Nn(35);
                                                                                                          }
                                                                                                          if (r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                                                            break e;
                                                                                                          s = Hr() | 0;
                                                                                                          break t;
                                                                                                        }
                                                                                                        if (e[5996] = 0, Te = Mi(3, Sn(W, 24) | 0) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1)
                                                                                                          break P;
                                                                                                      }
                                                                                                      if (u = Sn(Xe, 24) + Te | 0, e[u + 8 >> 2] = -1, e[u + 12 >> 2] = -1, e[u >> 2] = 5, e[u + 16 >> 2] = -1, e[u + 20 >> 2] = -1, Xe = u + 24 | 0, (A | 0) != (N | 0)) {
                                                                                                        for (; A = A - 24 | 0, fr = e[A + 4 >> 2], u = u - 24 | 0, e[u >> 2] = e[A >> 2], e[u + 4 >> 2] = fr, fr = e[A + 20 >> 2], e[u + 16 >> 2] = e[A + 16 >> 2], e[u + 20 >> 2] = fr, fr = e[A + 12 >> 2], e[u + 8 >> 2] = e[A + 8 >> 2], e[u + 12 >> 2] = fr, (A | 0) != (N | 0); )
                                                                                                          ;
                                                                                                        A = N;
                                                                                                      }
                                                                                                      if (e[m + 328 >> 2] = Sn(W, 24) + Te, e[m + 324 >> 2] = Xe, e[m + 320 >> 2] = u, !A)
                                                                                                        break y;
                                                                                                      Br(A);
                                                                                                      break y;
                                                                                                    }
                                                                                                    s = Hr() | 0;
                                                                                                    break t;
                                                                                                  case 9:
                                                                                                    if (A = e[m + 324 >> 2], W = e[m + 328 >> 2], A >>> 0 < W >>> 0) {
                                                                                                      e[A + 8 >> 2] = -1, e[A + 12 >> 2] = -1, e[A >> 2] = 7, e[A + 16 >> 2] = -1, e[A + 20 >> 2] = -1, e[m + 324 >> 2] = A + 24;
                                                                                                      break y;
                                                                                                    }
                                                                                                    P: {
                                                                                                      q: {
                                                                                                        O: {
                                                                                                          N = e[m + 320 >> 2], Xe = (A - N | 0) / 24 | 0, u = Xe + 1 | 0;
                                                                                                          Q: {
                                                                                                            if (u >>> 0 >= 178956971) {
                                                                                                              e[5996] = 0, Nn(142);
                                                                                                              break Q;
                                                                                                            }
                                                                                                            if (W = (W - N | 0) / 24 | 0, Te = W << 1, W = W >>> 0 >= 89478485 ? 178956970 : u >>> 0 < Te >>> 0 ? Te : u, !W) {
                                                                                                              Te = 0;
                                                                                                              break q;
                                                                                                            }
                                                                                                            if (W >>> 0 < 178956971)
                                                                                                              break O;
                                                                                                            e[5996] = 0, Nn(35);
                                                                                                          }
                                                                                                          if (r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                                                            break e;
                                                                                                          s = Hr() | 0;
                                                                                                          break t;
                                                                                                        }
                                                                                                        if (e[5996] = 0, Te = Mi(3, Sn(W, 24) | 0) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1)
                                                                                                          break P;
                                                                                                      }
                                                                                                      if (u = Sn(Xe, 24) + Te | 0, e[u + 8 >> 2] = -1, e[u + 12 >> 2] = -1, e[u >> 2] = 7, e[u + 16 >> 2] = -1, e[u + 20 >> 2] = -1, Xe = u + 24 | 0, (A | 0) != (N | 0)) {
                                                                                                        for (; A = A - 24 | 0, fr = e[A + 4 >> 2], u = u - 24 | 0, e[u >> 2] = e[A >> 2], e[u + 4 >> 2] = fr, fr = e[A + 20 >> 2], e[u + 16 >> 2] = e[A + 16 >> 2], e[u + 20 >> 2] = fr, fr = e[A + 12 >> 2], e[u + 8 >> 2] = e[A + 8 >> 2], e[u + 12 >> 2] = fr, (A | 0) != (N | 0); )
                                                                                                          ;
                                                                                                        A = N;
                                                                                                      }
                                                                                                      if (e[m + 328 >> 2] = Sn(W, 24) + Te, e[m + 324 >> 2] = Xe, e[m + 320 >> 2] = u, !A)
                                                                                                        break y;
                                                                                                      Br(A);
                                                                                                      break y;
                                                                                                    }
                                                                                                    s = Hr() | 0;
                                                                                                    break t;
                                                                                                  case 13:
                                                                                                    if (A = e[m + 324 >> 2], W = e[m + 328 >> 2], A >>> 0 < W >>> 0) {
                                                                                                      e[A + 8 >> 2] = -1, e[A + 12 >> 2] = -1, e[A >> 2] = 8, e[A + 16 >> 2] = -1, e[A + 20 >> 2] = -1, e[m + 324 >> 2] = A + 24;
                                                                                                      break y;
                                                                                                    }
                                                                                                    P: {
                                                                                                      q: {
                                                                                                        O: {
                                                                                                          N = e[m + 320 >> 2], Xe = (A - N | 0) / 24 | 0, u = Xe + 1 | 0;
                                                                                                          Q: {
                                                                                                            if (u >>> 0 >= 178956971) {
                                                                                                              e[5996] = 0, Nn(142);
                                                                                                              break Q;
                                                                                                            }
                                                                                                            if (W = (W - N | 0) / 24 | 0, Te = W << 1, W = W >>> 0 >= 89478485 ? 178956970 : u >>> 0 < Te >>> 0 ? Te : u, !W) {
                                                                                                              Te = 0;
                                                                                                              break q;
                                                                                                            }
                                                                                                            if (W >>> 0 < 178956971)
                                                                                                              break O;
                                                                                                            e[5996] = 0, Nn(35);
                                                                                                          }
                                                                                                          if (r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                                                            break e;
                                                                                                          s = Hr() | 0;
                                                                                                          break t;
                                                                                                        }
                                                                                                        if (e[5996] = 0, Te = Mi(3, Sn(W, 24) | 0) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1)
                                                                                                          break P;
                                                                                                      }
                                                                                                      if (u = Sn(Xe, 24) + Te | 0, e[u + 8 >> 2] = -1, e[u + 12 >> 2] = -1, e[u >> 2] = 8, e[u + 16 >> 2] = -1, e[u + 20 >> 2] = -1, Xe = u + 24 | 0, (A | 0) != (N | 0)) {
                                                                                                        for (; A = A - 24 | 0, fr = e[A + 4 >> 2], u = u - 24 | 0, e[u >> 2] = e[A >> 2], e[u + 4 >> 2] = fr, fr = e[A + 20 >> 2], e[u + 16 >> 2] = e[A + 16 >> 2], e[u + 20 >> 2] = fr, fr = e[A + 12 >> 2], e[u + 8 >> 2] = e[A + 8 >> 2], e[u + 12 >> 2] = fr, (A | 0) != (N | 0); )
                                                                                                          ;
                                                                                                        A = N;
                                                                                                      }
                                                                                                      if (e[m + 328 >> 2] = Sn(W, 24) + Te, e[m + 324 >> 2] = Xe, e[m + 320 >> 2] = u, !A)
                                                                                                        break y;
                                                                                                      Br(A);
                                                                                                      break y;
                                                                                                    }
                                                                                                    s = Hr() | 0;
                                                                                                    break t;
                                                                                                  case 21:
                                                                                                    if (A = e[m + 324 >> 2], W = e[m + 328 >> 2], A >>> 0 < W >>> 0) {
                                                                                                      e[A + 8 >> 2] = -1, e[A + 12 >> 2] = -1, e[A >> 2] = 6, e[A + 16 >> 2] = -1, e[A + 20 >> 2] = -1, e[m + 324 >> 2] = A + 24;
                                                                                                      break y;
                                                                                                    }
                                                                                                    P: {
                                                                                                      q: {
                                                                                                        O: {
                                                                                                          N = e[m + 320 >> 2], Xe = (A - N | 0) / 24 | 0, u = Xe + 1 | 0;
                                                                                                          Q: {
                                                                                                            if (u >>> 0 >= 178956971) {
                                                                                                              e[5996] = 0, Nn(142);
                                                                                                              break Q;
                                                                                                            }
                                                                                                            if (W = (W - N | 0) / 24 | 0, Te = W << 1, W = W >>> 0 >= 89478485 ? 178956970 : u >>> 0 < Te >>> 0 ? Te : u, !W) {
                                                                                                              Te = 0;
                                                                                                              break q;
                                                                                                            }
                                                                                                            if (W >>> 0 < 178956971)
                                                                                                              break O;
                                                                                                            e[5996] = 0, Nn(35);
                                                                                                          }
                                                                                                          if (r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                                                            break e;
                                                                                                          s = Hr() | 0;
                                                                                                          break t;
                                                                                                        }
                                                                                                        if (e[5996] = 0, Te = Mi(3, Sn(W, 24) | 0) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1)
                                                                                                          break P;
                                                                                                      }
                                                                                                      if (u = Sn(Xe, 24) + Te | 0, e[u + 8 >> 2] = -1, e[u + 12 >> 2] = -1, e[u >> 2] = 6, e[u + 16 >> 2] = -1, e[u + 20 >> 2] = -1, Xe = u + 24 | 0, (A | 0) != (N | 0)) {
                                                                                                        for (; A = A - 24 | 0, fr = e[A + 4 >> 2], u = u - 24 | 0, e[u >> 2] = e[A >> 2], e[u + 4 >> 2] = fr, fr = e[A + 20 >> 2], e[u + 16 >> 2] = e[A + 16 >> 2], e[u + 20 >> 2] = fr, fr = e[A + 12 >> 2], e[u + 8 >> 2] = e[A + 8 >> 2], e[u + 12 >> 2] = fr, (A | 0) != (N | 0); )
                                                                                                          ;
                                                                                                        A = N;
                                                                                                      }
                                                                                                      if (e[m + 328 >> 2] = Sn(W, 24) + Te, e[m + 324 >> 2] = Xe, e[m + 320 >> 2] = u, !A)
                                                                                                        break y;
                                                                                                      Br(A);
                                                                                                      break y;
                                                                                                    }
                                                                                                    s = Hr() | 0;
                                                                                                    break t;
                                                                                                  case 20:
                                                                                                    if (A = e[m + 324 >> 2], W = e[m + 328 >> 2], A >>> 0 < W >>> 0) {
                                                                                                      e[A + 8 >> 2] = -1, e[A + 12 >> 2] = -1, e[A >> 2] = 9, e[A + 16 >> 2] = -1, e[A + 20 >> 2] = -1, e[m + 324 >> 2] = A + 24;
                                                                                                      break y;
                                                                                                    }
                                                                                                    P: {
                                                                                                      q: {
                                                                                                        O: {
                                                                                                          N = e[m + 320 >> 2], Xe = (A - N | 0) / 24 | 0, u = Xe + 1 | 0;
                                                                                                          Q: {
                                                                                                            if (u >>> 0 >= 178956971) {
                                                                                                              e[5996] = 0, Nn(142);
                                                                                                              break Q;
                                                                                                            }
                                                                                                            if (W = (W - N | 0) / 24 | 0, Te = W << 1, W = W >>> 0 >= 89478485 ? 178956970 : u >>> 0 < Te >>> 0 ? Te : u, !W) {
                                                                                                              Te = 0;
                                                                                                              break q;
                                                                                                            }
                                                                                                            if (W >>> 0 < 178956971)
                                                                                                              break O;
                                                                                                            e[5996] = 0, Nn(35);
                                                                                                          }
                                                                                                          if (r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                                                            break e;
                                                                                                          s = Hr() | 0;
                                                                                                          break t;
                                                                                                        }
                                                                                                        if (e[5996] = 0, Te = Mi(3, Sn(W, 24) | 0) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1)
                                                                                                          break P;
                                                                                                      }
                                                                                                      if (u = Sn(Xe, 24) + Te | 0, e[u + 8 >> 2] = -1, e[u + 12 >> 2] = -1, e[u >> 2] = 9, e[u + 16 >> 2] = -1, e[u + 20 >> 2] = -1, Xe = u + 24 | 0, (A | 0) != (N | 0)) {
                                                                                                        for (; A = A - 24 | 0, fr = e[A + 4 >> 2], u = u - 24 | 0, e[u >> 2] = e[A >> 2], e[u + 4 >> 2] = fr, fr = e[A + 20 >> 2], e[u + 16 >> 2] = e[A + 16 >> 2], e[u + 20 >> 2] = fr, fr = e[A + 12 >> 2], e[u + 8 >> 2] = e[A + 8 >> 2], e[u + 12 >> 2] = fr, (A | 0) != (N | 0); )
                                                                                                          ;
                                                                                                        A = N;
                                                                                                      }
                                                                                                      if (e[m + 328 >> 2] = Sn(W, 24) + Te, e[m + 324 >> 2] = Xe, e[m + 320 >> 2] = u, !A)
                                                                                                        break y;
                                                                                                      Br(A);
                                                                                                      break y;
                                                                                                    }
                                                                                                    s = Hr() | 0;
                                                                                                    break t;
                                                                                                  case 19:
                                                                                                    if (A = e[m + 324 >> 2], W = e[m + 328 >> 2], A >>> 0 < W >>> 0) {
                                                                                                      e[A + 8 >> 2] = -1, e[A + 12 >> 2] = -1, e[A >> 2] = 10, e[A + 16 >> 2] = -1, e[A + 20 >> 2] = -1, e[m + 324 >> 2] = A + 24;
                                                                                                      break y;
                                                                                                    }
                                                                                                    P: {
                                                                                                      q: {
                                                                                                        O: {
                                                                                                          N = e[m + 320 >> 2], Xe = (A - N | 0) / 24 | 0, u = Xe + 1 | 0;
                                                                                                          Q: {
                                                                                                            if (u >>> 0 >= 178956971) {
                                                                                                              e[5996] = 0, Nn(142);
                                                                                                              break Q;
                                                                                                            }
                                                                                                            if (W = (W - N | 0) / 24 | 0, Te = W << 1, W = W >>> 0 >= 89478485 ? 178956970 : u >>> 0 < Te >>> 0 ? Te : u, !W) {
                                                                                                              Te = 0;
                                                                                                              break q;
                                                                                                            }
                                                                                                            if (W >>> 0 < 178956971)
                                                                                                              break O;
                                                                                                            e[5996] = 0, Nn(35);
                                                                                                          }
                                                                                                          if (r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                                                            break e;
                                                                                                          s = Hr() | 0;
                                                                                                          break t;
                                                                                                        }
                                                                                                        if (e[5996] = 0, Te = Mi(3, Sn(W, 24) | 0) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1)
                                                                                                          break P;
                                                                                                      }
                                                                                                      if (u = Sn(Xe, 24) + Te | 0, e[u + 8 >> 2] = -1, e[u + 12 >> 2] = -1, e[u >> 2] = 10, e[u + 16 >> 2] = -1, e[u + 20 >> 2] = -1, Xe = u + 24 | 0, (A | 0) != (N | 0)) {
                                                                                                        for (; A = A - 24 | 0, fr = e[A + 4 >> 2], u = u - 24 | 0, e[u >> 2] = e[A >> 2], e[u + 4 >> 2] = fr, fr = e[A + 20 >> 2], e[u + 16 >> 2] = e[A + 16 >> 2], e[u + 20 >> 2] = fr, fr = e[A + 12 >> 2], e[u + 8 >> 2] = e[A + 8 >> 2], e[u + 12 >> 2] = fr, (A | 0) != (N | 0); )
                                                                                                          ;
                                                                                                        A = N;
                                                                                                      }
                                                                                                      if (e[m + 328 >> 2] = Sn(W, 24) + Te, e[m + 324 >> 2] = Xe, e[m + 320 >> 2] = u, !A)
                                                                                                        break y;
                                                                                                      Br(A);
                                                                                                      break y;
                                                                                                    }
                                                                                                    s = Hr() | 0;
                                                                                                    break t;
                                                                                                  case 11:
                                                                                                    break D;
                                                                                                  default:
                                                                                                    break B;
                                                                                                }
                                                                                              if (e[5996] = 0, A = Mi(3, 104) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1)
                                                                                                break C;
                                                                                              if (e[A >> 2] = 7e3, e[A + 4 >> 2] = 0, e[A + 8 >> 2] = 0, e[5996] = 0, N = xn(143, A + 12 | 0, 0, 0) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1) {
                                                                                                s = Hr() | 0, Br(A);
                                                                                                break t;
                                                                                              }
                                                                                              e[m + 244 >> 2] = A, e[m + 240 >> 2] = N, u = e[m + 312 >> 2];
                                                                                              D: {
                                                                                                if (u >>> 0 < Ls[m + 316 >> 2]) {
                                                                                                  e[u + 4 >> 2] = A, e[u >> 2] = N, e[m + 312 >> 2] = u + 8;
                                                                                                  break D;
                                                                                                }
                                                                                                if (e[5996] = 0, ji(144, m + 308 | 0, m + 240 | 0), A = e[5996], e[5996] = 0, (A | 0) == 1)
                                                                                                  break b;
                                                                                                if (A = e[m + 244 >> 2], !A || (u = e[A + 4 >> 2], e[A + 4 >> 2] = u - 1, u))
                                                                                                  break D;
                                                                                                xi[e[e[A >> 2] + 8 >> 2]](A), ys(A);
                                                                                              }
                                                                                              if (A = e[m + 324 >> 2], W = e[m + 328 >> 2], A >>> 0 < W >>> 0) {
                                                                                                e[A + 8 >> 2] = -1, e[A + 12 >> 2] = -1, e[A >> 2] = 18, e[A + 16 >> 2] = -1, e[A + 20 >> 2] = -1, e[m + 324 >> 2] = A + 24;
                                                                                                break y;
                                                                                              }
                                                                                              D: {
                                                                                                P: {
                                                                                                  N = e[m + 320 >> 2], Xe = (A - N | 0) / 24 | 0, u = Xe + 1 | 0;
                                                                                                  q: {
                                                                                                    if (u >>> 0 >= 178956971) {
                                                                                                      e[5996] = 0, Nn(142);
                                                                                                      break q;
                                                                                                    }
                                                                                                    if (W = (W - N | 0) / 24 | 0, Te = W << 1, W = W >>> 0 >= 89478485 ? 178956970 : u >>> 0 < Te >>> 0 ? Te : u, !W) {
                                                                                                      Te = 0;
                                                                                                      break D;
                                                                                                    }
                                                                                                    if (W >>> 0 < 178956971)
                                                                                                      break P;
                                                                                                    e[5996] = 0, Nn(35);
                                                                                                  }
                                                                                                  if (r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                                                    break e;
                                                                                                  s = Hr() | 0;
                                                                                                  break t;
                                                                                                }
                                                                                                if (e[5996] = 0, Te = Mi(3, Sn(W, 24) | 0) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1)
                                                                                                  break x;
                                                                                              }
                                                                                              if (u = Sn(Xe, 24) + Te | 0, e[u + 8 >> 2] = -1, e[u + 12 >> 2] = -1, e[u >> 2] = 18, e[u + 16 >> 2] = -1, e[u + 20 >> 2] = -1, Xe = u + 24 | 0, (A | 0) != (N | 0)) {
                                                                                                for (; A = A - 24 | 0, fr = e[A + 4 >> 2], u = u - 24 | 0, e[u >> 2] = e[A >> 2], e[u + 4 >> 2] = fr, fr = e[A + 20 >> 2], e[u + 16 >> 2] = e[A + 16 >> 2], e[u + 20 >> 2] = fr, fr = e[A + 12 >> 2], e[u + 8 >> 2] = e[A + 8 >> 2], e[u + 12 >> 2] = fr, (A | 0) != (N | 0); )
                                                                                                  ;
                                                                                                A = N;
                                                                                              }
                                                                                              if (e[m + 328 >> 2] = Sn(W, 24) + Te, e[m + 324 >> 2] = Xe, e[m + 320 >> 2] = u, !A)
                                                                                                break y;
                                                                                              Br(A);
                                                                                            }
                                                                                            if (ar = ar + 1 | 0, (ar | 0) == (p | 0))
                                                                                              break;
                                                                                          }
                                                                                          A = e[m + 324 >> 2];
                                                                                          break I;
                                                                                        }
                                                                                        s = Hr() | 0;
                                                                                        break t;
                                                                                      }
                                                                                      s = Hr() | 0, Lo(m + 240 | 0);
                                                                                      break t;
                                                                                    }
                                                                                    s = Hr() | 0;
                                                                                    break t;
                                                                                  }
                                                                                  e[r >> 2] = 0, e[r + 4 >> 2] = 0;
                                                                                  break f;
                                                                                }
                                                                                if ((W - 97 & 255) >>> 0 > 25) {
                                                                                  p = -1;
                                                                                  break I;
                                                                                }
                                                                                if (p = p + 1 | 0, !((u | 0) > (p | 0)))
                                                                                  break;
                                                                              }
                                                                              p = -1;
                                                                            }
                                                                            I: {
                                                                              W = e[m + 328 >> 2];
                                                                              B: {
                                                                                if (W >>> 0 > A >>> 0) {
                                                                                  e[A + 8 >> 2] = -1, e[A + 12 >> 2] = -1, e[A >> 2] = 1, e[A + 16 >> 2] = -1, e[A + 20 >> 2] = -1, e[m + 324 >> 2] = A + 24;
                                                                                  break B;
                                                                                }
                                                                                x: {
                                                                                  b: {
                                                                                    N = e[m + 320 >> 2], ar = (A - N | 0) / 24 | 0, u = ar + 1 | 0;
                                                                                    C: {
                                                                                      if (u >>> 0 >= 178956971) {
                                                                                        e[5996] = 0, Nn(142);
                                                                                        break C;
                                                                                      }
                                                                                      if (W = (W - N | 0) / 24 | 0, Te = W << 1, W = W >>> 0 >= 89478485 ? 178956970 : u >>> 0 < Te >>> 0 ? Te : u, !W) {
                                                                                        Te = 0;
                                                                                        break x;
                                                                                      }
                                                                                      if (W >>> 0 < 178956971)
                                                                                        break b;
                                                                                      e[5996] = 0, Nn(35);
                                                                                    }
                                                                                    if (r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                                      break e;
                                                                                    s = Hr() | 0;
                                                                                    break t;
                                                                                  }
                                                                                  if (e[5996] = 0, Te = Mi(3, Sn(W, 24) | 0) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1)
                                                                                    break I;
                                                                                }
                                                                                if (u = Sn(ar, 24) + Te | 0, e[u + 8 >> 2] = -1, e[u + 12 >> 2] = -1, e[u >> 2] = 1, e[u + 16 >> 2] = -1, e[u + 20 >> 2] = -1, ar = u + 24 | 0, (A | 0) != (N | 0)) {
                                                                                  for (; A = A - 24 | 0, Xe = e[A + 4 >> 2], u = u - 24 | 0, e[u >> 2] = e[A >> 2], e[u + 4 >> 2] = Xe, Xe = e[A + 20 >> 2], e[u + 16 >> 2] = e[A + 16 >> 2], e[u + 20 >> 2] = Xe, Xe = e[A + 12 >> 2], e[u + 8 >> 2] = e[A + 8 >> 2], e[u + 12 >> 2] = Xe, (A | 0) != (N | 0); )
                                                                                    ;
                                                                                  A = N;
                                                                                }
                                                                                if (e[m + 328 >> 2] = Sn(W, 24) + Te, e[m + 324 >> 2] = ar, e[m + 320 >> 2] = u, !A)
                                                                                  break B;
                                                                                Br(A);
                                                                              }
                                                                              A = p + 1 | 0, e[s + 4 >> 2] = e[s + 4 >> 2] - A, e[s >> 2] = A + e[s >> 2];
                                                                              break u;
                                                                            }
                                                                            s = Hr() | 0;
                                                                            break t;
                                                                          case 21:
                                                                            I: {
                                                                              if (A = e[s + 4 >> 2], A && (u = e[s >> 2], me[u | 0] == 41))
                                                                                break I;
                                                                              e[r >> 2] = 0, e[r + 4 >> 2] = 0;
                                                                              break f;
                                                                            }
                                                                            e[s + 4 >> 2] = A - 1, e[s >> 2] = u + 1;
                                                                            break u;
                                                                          case 20:
                                                                            I: {
                                                                              if (A = e[s + 4 >> 2], A && (u = e[s >> 2], me[u | 0] == 44))
                                                                                break I;
                                                                              e[r >> 2] = 0, e[r + 4 >> 2] = 0;
                                                                              break f;
                                                                            }
                                                                            e[s + 4 >> 2] = A - 1, e[s >> 2] = u + 1;
                                                                            break u;
                                                                          case 19:
                                                                            if (N = e[s + 4 >> 2], !N) {
                                                                              e[r >> 2] = 0, e[r + 4 >> 2] = 0;
                                                                              break f;
                                                                            }
                                                                            I: {
                                                                              B: {
                                                                                x: {
                                                                                  b: {
                                                                                    C: {
                                                                                      y:
                                                                                        switch (W = e[s >> 2], me[W | 0] - 41 | 0) {
                                                                                          case 0:
                                                                                            break C;
                                                                                          case 3:
                                                                                            break y;
                                                                                          default:
                                                                                            break b;
                                                                                        }
                                                                                      e[s + 4 >> 2] = N - 1, e[s >> 2] = W + 1, N = e[m + 292 >> 2], W = e[m + 288 >> 2] + 1 | 0, N = W ? N : N + 1 | 0;
                                                                                      y: {
                                                                                        D: {
                                                                                          Te = e[m + 328 >> 2];
                                                                                          P: {
                                                                                            if (Te >>> 0 > A >>> 0) {
                                                                                              e[A >> 2] = 19, e[A + 8 >> 2] = W, e[A + 12 >> 2] = N, p = e[m + 300 >> 2], e[A + 16 >> 2] = e[m + 296 >> 2], e[A + 20 >> 2] = p, e[m + 324 >> 2] = u;
                                                                                              break P;
                                                                                            }
                                                                                            q: {
                                                                                              O: {
                                                                                                ar = (A - p | 0) / 24 | 0, u = ar + 1 | 0;
                                                                                                Q: {
                                                                                                  if (u >>> 0 >= 178956971) {
                                                                                                    e[5996] = 0, Nn(142);
                                                                                                    break Q;
                                                                                                  }
                                                                                                  if (Te = (Te - p | 0) / 24 | 0, Xe = Te << 1, u = Te >>> 0 >= 89478485 ? 178956970 : u >>> 0 < Xe >>> 0 ? Xe : u, !u) {
                                                                                                    Te = 0;
                                                                                                    break q;
                                                                                                  }
                                                                                                  if (u >>> 0 < 178956971)
                                                                                                    break O;
                                                                                                  e[5996] = 0, Nn(35);
                                                                                                }
                                                                                                if (r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                                                  break e;
                                                                                                s = Hr() | 0;
                                                                                                break t;
                                                                                              }
                                                                                              if (e[5996] = 0, Te = Mi(3, Sn(u, 24) | 0) | 0, Xe = e[5996], e[5996] = 0, (Xe | 0) == 1)
                                                                                                break D;
                                                                                            }
                                                                                            ar = Sn(ar, 24) + Te | 0, e[ar + 8 >> 2] = W, e[ar + 12 >> 2] = N, e[ar >> 2] = 19, N = e[m + 300 >> 2], e[ar + 16 >> 2] = e[m + 296 >> 2], e[ar + 20 >> 2] = N, Te = Sn(u, 24) + Te | 0, u = ar + 24 | 0;
                                                                                            q: {
                                                                                              if ((A | 0) == (p | 0)) {
                                                                                                e[m + 328 >> 2] = Te, e[m + 324 >> 2] = u, e[m + 320 >> 2] = ar;
                                                                                                break q;
                                                                                              }
                                                                                              for (; A = A - 24 | 0, W = e[A + 4 >> 2], ar = ar - 24 | 0, N = ar, e[N >> 2] = e[A >> 2], e[N + 4 >> 2] = W, N = e[A + 20 >> 2], e[ar + 16 >> 2] = e[A + 16 >> 2], e[ar + 20 >> 2] = N, N = e[A + 12 >> 2], e[ar + 8 >> 2] = e[A + 8 >> 2], e[ar + 12 >> 2] = N, (A | 0) != (p | 0); )
                                                                                                ;
                                                                                              if (e[m + 328 >> 2] = Te, e[m + 324 >> 2] = u, e[m + 320 >> 2] = ar, !p)
                                                                                                break P;
                                                                                            }
                                                                                            Br(p), Te = e[m + 328 >> 2], u = e[m + 324 >> 2];
                                                                                          }
                                                                                          if (u >>> 0 < Te >>> 0) {
                                                                                            e[u + 8 >> 2] = -1, e[u + 12 >> 2] = -1, e[u >> 2] = 0, e[u + 16 >> 2] = -1, e[u + 20 >> 2] = -1, e[m + 324 >> 2] = u + 24;
                                                                                            break u;
                                                                                          }
                                                                                          P: {
                                                                                            q: {
                                                                                              p = e[m + 320 >> 2], W = (u - p | 0) / 24 | 0, A = W + 1 | 0;
                                                                                              O: {
                                                                                                if (A >>> 0 >= 178956971) {
                                                                                                  e[5996] = 0, Nn(142);
                                                                                                  break O;
                                                                                                }
                                                                                                if (N = (Te - p | 0) / 24 | 0, Te = N << 1, N = N >>> 0 >= 89478485 ? 178956970 : A >>> 0 < Te >>> 0 ? Te : A, !N) {
                                                                                                  Te = 0;
                                                                                                  break P;
                                                                                                }
                                                                                                if (N >>> 0 < 178956971)
                                                                                                  break q;
                                                                                                e[5996] = 0, Nn(35);
                                                                                              }
                                                                                              if (r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                                                break e;
                                                                                              s = Hr() | 0;
                                                                                              break t;
                                                                                            }
                                                                                            if (e[5996] = 0, Te = Mi(3, Sn(N, 24) | 0) | 0, A = e[5996], e[5996] = 0, (A | 0) == 1)
                                                                                              break y;
                                                                                          }
                                                                                          if (A = Sn(W, 24) + Te | 0, e[A + 8 >> 2] = -1, e[A + 12 >> 2] = -1, e[A >> 2] = 0, e[A + 16 >> 2] = -1, e[A + 20 >> 2] = -1, W = A + 24 | 0, (u | 0) != (p | 0)) {
                                                                                            for (; u = u - 24 | 0, ar = e[u + 4 >> 2], A = A - 24 | 0, e[A >> 2] = e[u >> 2], e[A + 4 >> 2] = ar, ar = e[u + 20 >> 2], e[A + 16 >> 2] = e[u + 16 >> 2], e[A + 20 >> 2] = ar, ar = e[u + 12 >> 2], e[A + 8 >> 2] = e[u + 8 >> 2], e[A + 12 >> 2] = ar, (u | 0) != (p | 0); )
                                                                                              ;
                                                                                            u = p;
                                                                                          }
                                                                                          if (e[m + 328 >> 2] = Sn(N, 24) + Te, e[m + 324 >> 2] = W, e[m + 320 >> 2] = A, !u)
                                                                                            break u;
                                                                                          Br(u);
                                                                                          break u;
                                                                                        }
                                                                                        s = Hr() | 0;
                                                                                        break t;
                                                                                      }
                                                                                      s = Hr() | 0;
                                                                                      break t;
                                                                                    }
                                                                                    if (A = e[m + 288 >> 2], u = e[m + 292 >> 2], p = e[m + 300 >> 2], A >>> 0 < Ls[m + 296 >> 2] & (u | 0) <= (p | 0) | (u | 0) < (p | 0)) {
                                                                                      e[r >> 2] = 0, e[r + 4 >> 2] = 0;
                                                                                      break f;
                                                                                    }
                                                                                    if (e[s + 4 >> 2] = N - 1, e[s >> 2] = W + 1, e[m + 340 >> 2] = 0, e[m + 332 >> 2] = 0, e[m + 336 >> 2] = 0, !A & (u | 0) <= 0 | (u | 0) < 0)
                                                                                      break B;
                                                                                    for (p = 0, u = 0, A = e[m + 312 >> 2]; ; ) {
                                                                                      C: {
                                                                                        N = A - 8 | 0, W = e[m + 336 >> 2];
                                                                                        y: {
                                                                                          if (W >>> 0 < Ls[m + 340 >> 2]) {
                                                                                            e[W >> 2] = e[N >> 2], Te = A - 4 | 0, e[W + 4 >> 2] = e[Te >> 2], e[N >> 2] = 0, e[Te >> 2] = 0, e[m + 336 >> 2] = W + 8;
                                                                                            break y;
                                                                                          }
                                                                                          if (e[5996] = 0, ji(144, m + 332 | 0, N | 0), A = e[5996], e[5996] = 0, (A | 0) == 1)
                                                                                            break C;
                                                                                          if (A = e[m + 312 >> 2], N = e[A - 4 >> 2], !N || (W = e[N + 4 >> 2], e[N + 4 >> 2] = W - 1, W))
                                                                                            break y;
                                                                                          xi[e[e[N >> 2] + 8 >> 2]](N), ys(N);
                                                                                        }
                                                                                        if (A = A - 8 | 0, e[m + 312 >> 2] = A, p = p + 1 | 0, u = p ? u : u + 1 | 0, N = e[m + 292 >> 2], Ls[m + 288 >> 2] > p >>> 0 & (N | 0) >= (u | 0) | (u | 0) < (N | 0))
                                                                                          continue;
                                                                                        break x;
                                                                                      }
                                                                                      break;
                                                                                    }
                                                                                    s = Hr() | 0;
                                                                                    break I;
                                                                                  }
                                                                                  e[r >> 2] = 0, e[r + 4 >> 2] = 0;
                                                                                  break f;
                                                                                }
                                                                                if (A = e[m + 332 >> 2], p = e[m + 336 >> 2], (A | 0) == (p | 0) || (u = p - 8 | 0, u >>> 0 <= A >>> 0))
                                                                                  break B;
                                                                                for (; N = e[A >> 2], e[A >> 2] = e[u >> 2], e[u >> 2] = N, N = e[A + 4 >> 2], p = p - 4 | 0, e[A + 4 >> 2] = e[p >> 2], e[p >> 2] = N, p = u, A = A + 8 | 0, u = u - 8 | 0, A >>> 0 < u >>> 0; )
                                                                                  ;
                                                                              }
                                                                              e[5996] = 0, p = Mi(3, 104) | 0, A = e[5996], e[5996] = 0;
                                                                              B: {
                                                                                x: {
                                                                                  if ((A | 0) != 1) {
                                                                                    if (e[p >> 2] = 7e3, e[p + 4 >> 2] = 0, e[p + 8 >> 2] = 0, e[5996] = 0, e[m + 240 >> 2] = e[m + 332 >> 2], A = e[m + 336 >> 2], u = e[m + 340 >> 2], e[m + 340 >> 2] = 0, e[m + 244 >> 2] = A, e[m + 248 >> 2] = u, e[m + 332 >> 2] = 0, e[m + 336 >> 2] = 0, W = wa(64, p + 12 | 0, 24, m + 240 | 0, e[m + 296 >> 2]) | 0, A = e[5996], e[5996] = 0, (A | 0) == 1)
                                                                                      break B;
                                                                                    if (u = e[m + 240 >> 2], u) {
                                                                                      if (A = e[m + 244 >> 2], (u | 0) != (A | 0)) {
                                                                                        for (; ; ) {
                                                                                          A = A - 8 | 0, N = e[A + 4 >> 2];
                                                                                          b: {
                                                                                            if (!N || (Te = e[N + 4 >> 2], e[N + 4 >> 2] = Te - 1, Te))
                                                                                              break b;
                                                                                            xi[e[e[N >> 2] + 8 >> 2]](N), ys(N);
                                                                                          }
                                                                                          if ((u | 0) == (A | 0))
                                                                                            break;
                                                                                        }
                                                                                        u = e[m + 240 >> 2];
                                                                                      }
                                                                                      Br(u);
                                                                                    }
                                                                                    e[m + 348 >> 2] = p, e[m + 344 >> 2] = W, A = e[m + 312 >> 2];
                                                                                    b: {
                                                                                      if (A >>> 0 < Ls[m + 316 >> 2]) {
                                                                                        e[A + 4 >> 2] = p, e[A >> 2] = W, e[m + 312 >> 2] = A + 8;
                                                                                        break b;
                                                                                      }
                                                                                      if (e[5996] = 0, ji(144, m + 308 | 0, m + 344 | 0), A = e[5996], e[5996] = 0, (A | 0) == 1)
                                                                                        break x;
                                                                                      if (A = e[m + 348 >> 2], !A || (u = e[A + 4 >> 2], e[A + 4 >> 2] = u - 1, u))
                                                                                        break b;
                                                                                      xi[e[e[A >> 2] + 8 >> 2]](A), ys(A);
                                                                                    }
                                                                                    if (u = e[m + 332 >> 2], !u)
                                                                                      break u;
                                                                                    if (A = e[m + 336 >> 2], (u | 0) != (A | 0)) {
                                                                                      for (; ; ) {
                                                                                        A = A - 8 | 0, p = e[A + 4 >> 2];
                                                                                        b: {
                                                                                          if (!p || (N = e[p + 4 >> 2], e[p + 4 >> 2] = N - 1, N))
                                                                                            break b;
                                                                                          xi[e[e[p >> 2] + 8 >> 2]](p), ys(p);
                                                                                        }
                                                                                        if ((u | 0) == (A | 0))
                                                                                          break;
                                                                                      }
                                                                                      u = e[m + 332 >> 2];
                                                                                    }
                                                                                    Br(u);
                                                                                    break u;
                                                                                  }
                                                                                  s = Hr() | 0;
                                                                                  break I;
                                                                                }
                                                                                s = Hr() | 0, Lo(m + 344 | 0);
                                                                                break I;
                                                                              }
                                                                              s = Hr() | 0, Uo(m + 240 | 0), Br(p);
                                                                            }
                                                                            Uo(m + 332 | 0);
                                                                            break t;
                                                                          case 14:
                                                                            u = e[m + 312 >> 2], A = u - 8 | 0, e[m + 332 >> 2] = e[A >> 2], e[m + 336 >> 2] = e[A + 4 >> 2], e[A >> 2] = 0, e[A + 4 >> 2] = 0, A = u - 16 | 0, e[m + 344 >> 2] = e[A >> 2], e[m + 348 >> 2] = e[A + 4 >> 2], e[A >> 2] = 0, e[A + 4 >> 2] = 0, e[m + 312 >> 2] = A, e[5996] = 0, p = m + 240 | 0, Vs(145, p | 0, u - 24 | 0, m + 344 | 0, m + 332 | 0), A = e[5996], e[5996] = 0;
                                                                            I: {
                                                                              B: {
                                                                                x: {
                                                                                  if ((A | 0) != 1) {
                                                                                    if (e[5996] = 0, A = Mi(3, 104) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1)
                                                                                      break x;
                                                                                    if (e[5996] = 0, u = xn(146, A | 0, 23, p | 0) | 0, p = e[5996], e[5996] = 0, (p | 0) == 1) {
                                                                                      s = Hr() | 0, Br(A);
                                                                                      break B;
                                                                                    }
                                                                                    p = e[m + 312 >> 2] - 8 | 0, e[p >> 2] = u + 12, A = e[p + 4 >> 2], e[p + 4 >> 2] = u;
                                                                                    b: {
                                                                                      if (!A || (u = e[A + 4 >> 2], e[A + 4 >> 2] = u - 1, u))
                                                                                        break b;
                                                                                      xi[e[e[A >> 2] + 8 >> 2]](A), ys(A);
                                                                                    }
                                                                                    if (p = e[m + 240 >> 2], p) {
                                                                                      if (A = e[m + 244 >> 2], u = p, (A | 0) != (u | 0)) {
                                                                                        for (; ; ) {
                                                                                          A = A - 8 | 0, u = e[A + 4 >> 2];
                                                                                          b: {
                                                                                            if (!u || (N = e[u + 4 >> 2], e[u + 4 >> 2] = N - 1, N))
                                                                                              break b;
                                                                                            xi[e[e[u >> 2] + 8 >> 2]](u), ys(u);
                                                                                          }
                                                                                          if ((A | 0) == (p | 0))
                                                                                            break;
                                                                                        }
                                                                                        u = e[m + 240 >> 2];
                                                                                      }
                                                                                      e[m + 244 >> 2] = p, Br(u);
                                                                                    }
                                                                                    A = e[m + 348 >> 2];
                                                                                    b: {
                                                                                      if (!A || (u = e[A + 4 >> 2], e[A + 4 >> 2] = u - 1, u))
                                                                                        break b;
                                                                                      xi[e[e[A >> 2] + 8 >> 2]](A), ys(A);
                                                                                    }
                                                                                    if (A = e[m + 336 >> 2], !A || (u = e[A + 4 >> 2], e[A + 4 >> 2] = u - 1, u))
                                                                                      break u;
                                                                                    xi[e[e[A >> 2] + 8 >> 2]](A), ys(A);
                                                                                    break u;
                                                                                  }
                                                                                  s = Hr() | 0;
                                                                                  break I;
                                                                                }
                                                                                s = Hr() | 0;
                                                                              }
                                                                              Uo(m + 240 | 0);
                                                                            }
                                                                            Lo(m + 344 | 0), Lo(m + 332 | 0);
                                                                            break t;
                                                                          case 18:
                                                                            ar = 22;
                                                                            break h;
                                                                          case 17:
                                                                            ar = 21;
                                                                            break h;
                                                                          case 16:
                                                                            ar = 20;
                                                                            break h;
                                                                          case 15:
                                                                            ar = 19;
                                                                            break h;
                                                                          case 1:
                                                                            break g;
                                                                          case 3:
                                                                            break A;
                                                                          case 2:
                                                                            break p;
                                                                          case 4:
                                                                            break m;
                                                                          case 5:
                                                                            break k;
                                                                          case 7:
                                                                            break N;
                                                                          case 8:
                                                                            break S;
                                                                          case 6:
                                                                            break T;
                                                                          case 9:
                                                                            break v;
                                                                          case 10:
                                                                            break w;
                                                                          case 11:
                                                                            break E;
                                                                          case 13:
                                                                            break h;
                                                                          case 12:
                                                                            break R;
                                                                          default:
                                                                            break u;
                                                                        }
                                                                      ar = 17;
                                                                    }
                                                                    p = e[m + 312 >> 2], u = p - 8 | 0, e[m + 344 >> 2] = e[u >> 2], e[m + 348 >> 2] = e[u + 4 >> 2], e[u >> 2] = 0, e[u + 4 >> 2] = 0, e[m + 312 >> 2] = u, e[5996] = 0, e[m + 340 >> 2] = 0, e[m + 332 >> 2] = 0, e[m + 336 >> 2] = 0, A = Mi(3, 16) | 0, N = e[5996], e[5996] = 0;
                                                                    h: {
                                                                      if ((N | 0) == 1) {
                                                                        s = Hr() | 0;
                                                                        break h;
                                                                      }
                                                                      if (e[m + 332 >> 2] = A, N = A + 16 | 0, e[m + 340 >> 2] = N, p = p - 16 | 0, e[A >> 2] = e[p >> 2], e[A + 4 >> 2] = e[p + 4 >> 2], e[p >> 2] = 0, e[p + 4 >> 2] = 0, e[A + 8 >> 2] = e[m + 344 >> 2], e[A + 12 >> 2] = e[m + 348 >> 2], e[m + 336 >> 2] = N, e[m + 344 >> 2] = 0, e[m + 348 >> 2] = 0, e[5996] = 0, p = Mi(3, 104) | 0, W = e[5996], e[5996] = 0, (W | 0) != 1) {
                                                                        if (e[p >> 2] = 7e3, e[p + 4 >> 2] = 0, e[p + 8 >> 2] = 0, e[m + 244 >> 2] = N, e[m + 240 >> 2] = A, e[m + 332 >> 2] = 0, e[m + 336 >> 2] = 0, e[5996] = 0, A = e[m + 340 >> 2], e[m + 340 >> 2] = 0, e[m + 248 >> 2] = A, N = wa(64, p + 12 | 0, ar | 0, m + 240 | 0, 0) | 0, A = e[5996], e[5996] = 0, (A | 0) != 1) {
                                                                          if (ar = e[m + 240 >> 2], ar) {
                                                                            if (A = e[m + 244 >> 2], (ar | 0) != (A | 0)) {
                                                                              for (; ; ) {
                                                                                A = A - 8 | 0, u = e[A + 4 >> 2];
                                                                                R: {
                                                                                  if (!u || (W = e[u + 4 >> 2], e[u + 4 >> 2] = W - 1, W))
                                                                                    break R;
                                                                                  xi[e[e[u >> 2] + 8 >> 2]](u), ys(u);
                                                                                }
                                                                                if ((A | 0) == (ar | 0))
                                                                                  break;
                                                                              }
                                                                              ar = e[m + 240 >> 2], u = e[m + 312 >> 2];
                                                                            }
                                                                            Br(ar);
                                                                          }
                                                                          u = u - 8 | 0, e[u >> 2] = N, A = e[u + 4 >> 2], e[u + 4 >> 2] = p;
                                                                          R: {
                                                                            if (!A || (u = e[A + 4 >> 2], e[A + 4 >> 2] = u - 1, u))
                                                                              break R;
                                                                            xi[e[e[A >> 2] + 8 >> 2]](A), ys(A);
                                                                          }
                                                                          if (u = e[m + 332 >> 2], u) {
                                                                            if (A = e[m + 336 >> 2], (u | 0) != (A | 0)) {
                                                                              for (; ; ) {
                                                                                A = A - 8 | 0, p = e[A + 4 >> 2];
                                                                                R: {
                                                                                  if (!p || (N = e[p + 4 >> 2], e[p + 4 >> 2] = N - 1, N))
                                                                                    break R;
                                                                                  xi[e[e[p >> 2] + 8 >> 2]](p), ys(p);
                                                                                }
                                                                                if ((u | 0) == (A | 0))
                                                                                  break;
                                                                              }
                                                                              u = e[m + 332 >> 2];
                                                                            }
                                                                            Br(u);
                                                                          }
                                                                          if (A = e[m + 348 >> 2], !A || (u = e[A + 4 >> 2], e[A + 4 >> 2] = u - 1, u))
                                                                            break u;
                                                                          xi[e[e[A >> 2] + 8 >> 2]](A), ys(A);
                                                                          break u;
                                                                        }
                                                                        s = Hr() | 0, Uo(m + 240 | 0), Br(p);
                                                                        break h;
                                                                      }
                                                                      s = Hr() | 0;
                                                                    }
                                                                    Uo(m + 332 | 0), Lo(m + 344 | 0);
                                                                    break t;
                                                                  }
                                                                  u = e[m + 312 >> 2], A = u - 8 | 0, e[m + 332 >> 2] = e[A >> 2], e[m + 336 >> 2] = e[A + 4 >> 2], e[A >> 2] = 0, e[A + 4 >> 2] = 0, e[m + 312 >> 2] = A, e[5996] = 0, A = Mi(3, 104) | 0, p = e[5996], e[5996] = 0;
                                                                  E: {
                                                                    h: {
                                                                      R: {
                                                                        I: {
                                                                          B: {
                                                                            if ((p | 0) != 1) {
                                                                              if (e[A >> 2] = 7e3, e[A + 4 >> 2] = 0, e[A + 8 >> 2] = 0, e[5996] = 0, p = xn(143, A + 12 | 0, 0, 0) | 0, N = e[5996], e[5996] = 0, (N | 0) == 1) {
                                                                                s = Hr() | 0, Br(A);
                                                                                break E;
                                                                              }
                                                                              if (e[m + 348 >> 2] = A, e[m + 344 >> 2] = p, e[5996] = 0, p = m + 240 | 0, Vs(145, p | 0, u - 16 | 0, m + 332 | 0, m + 344 | 0), A = e[5996], e[5996] = 0, (A | 0) == 1)
                                                                                break B;
                                                                              if (e[5996] = 0, A = Mi(3, 104) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1)
                                                                                break I;
                                                                              if (e[5996] = 0, u = xn(146, A | 0, 23, p | 0) | 0, p = e[5996], e[5996] = 0, (p | 0) == 1) {
                                                                                s = Hr() | 0, Br(A);
                                                                                break R;
                                                                              }
                                                                              p = e[m + 312 >> 2] - 8 | 0, e[p >> 2] = u + 12, A = e[p + 4 >> 2], e[p + 4 >> 2] = u;
                                                                              x: {
                                                                                if (!A || (u = e[A + 4 >> 2], e[A + 4 >> 2] = u - 1, u))
                                                                                  break x;
                                                                                xi[e[e[A >> 2] + 8 >> 2]](A), ys(A);
                                                                              }
                                                                              if (p = e[m + 240 >> 2], p) {
                                                                                if (A = e[m + 244 >> 2], u = p, (A | 0) != (u | 0)) {
                                                                                  for (; ; ) {
                                                                                    A = A - 8 | 0, u = e[A + 4 >> 2];
                                                                                    x: {
                                                                                      if (!u || (N = e[u + 4 >> 2], e[u + 4 >> 2] = N - 1, N))
                                                                                        break x;
                                                                                      xi[e[e[u >> 2] + 8 >> 2]](u), ys(u);
                                                                                    }
                                                                                    if ((A | 0) == (p | 0))
                                                                                      break;
                                                                                  }
                                                                                  u = e[m + 240 >> 2];
                                                                                }
                                                                                e[m + 244 >> 2] = p, Br(u);
                                                                              }
                                                                              A = e[m + 348 >> 2];
                                                                              x: {
                                                                                if (!A || (u = e[A + 4 >> 2], e[A + 4 >> 2] = u - 1, u))
                                                                                  break x;
                                                                                xi[e[e[A >> 2] + 8 >> 2]](A), ys(A);
                                                                              }
                                                                              if (A = e[m + 336 >> 2], !A || (u = e[A + 4 >> 2], e[A + 4 >> 2] = u - 1, u))
                                                                                break u;
                                                                              xi[e[e[A >> 2] + 8 >> 2]](A), ys(A);
                                                                              break u;
                                                                            }
                                                                            s = Hr() | 0;
                                                                            break E;
                                                                          }
                                                                          s = Hr() | 0;
                                                                          break h;
                                                                        }
                                                                        s = Hr() | 0;
                                                                      }
                                                                      Uo(m + 240 | 0);
                                                                    }
                                                                    Lo(m + 344 | 0);
                                                                  }
                                                                  Lo(m + 332 | 0);
                                                                  break t;
                                                                }
                                                                e[5996] = 0, u = e[m + 312 >> 2], A = Mi(3, 104) | 0, p = e[5996], e[5996] = 0;
                                                                w: {
                                                                  E: {
                                                                    if ((p | 0) != 1) {
                                                                      if (e[A >> 2] = 7e3, e[A + 4 >> 2] = 0, e[A + 8 >> 2] = 0, e[5996] = 0, p = xn(143, A + 12 | 0, 1, 0) | 0, N = e[5996], e[5996] = 0, (N | 0) == 1) {
                                                                        s = Hr() | 0, Br(A);
                                                                        break t;
                                                                      }
                                                                      if (e[m + 336 >> 2] = A, e[m + 332 >> 2] = p, e[m + 248 >> 2] = 0, e[m + 240 >> 2] = 0, e[m + 244 >> 2] = 0, e[5996] = 0, A = Mi(3, 16) | 0, p = e[5996], e[5996] = 0, (p | 0) == 1) {
                                                                        s = Hr() | 0;
                                                                        break w;
                                                                      }
                                                                      if (e[m + 240 >> 2] = A, N = A + 16 | 0, e[m + 248 >> 2] = N, p = u - 8 | 0, e[A >> 2] = e[p >> 2], u = u - 4 | 0, e[A + 4 >> 2] = e[u >> 2], e[p >> 2] = 0, e[u >> 2] = 0, e[A + 8 >> 2] = e[m + 332 >> 2], e[A + 12 >> 2] = e[m + 336 >> 2], e[m + 244 >> 2] = N, e[m + 332 >> 2] = 0, e[m + 336 >> 2] = 0, e[5996] = 0, A = Mi(3, 104) | 0, N = e[5996], e[5996] = 0, (N | 0) == 1)
                                                                        break E;
                                                                      if (e[5996] = 0, N = xn(146, A | 0, 17, m + 240 | 0) | 0, W = e[5996], e[5996] = 0, (W | 0) == 1) {
                                                                        s = Hr() | 0, Br(A);
                                                                        break w;
                                                                      }
                                                                      e[p >> 2] = N + 12, A = e[u >> 2], e[u >> 2] = N;
                                                                      h: {
                                                                        if (!A || (u = e[A + 4 >> 2], e[A + 4 >> 2] = u - 1, u))
                                                                          break h;
                                                                        xi[e[e[A >> 2] + 8 >> 2]](A), ys(A);
                                                                      }
                                                                      if (p = e[m + 240 >> 2], p) {
                                                                        if (A = e[m + 244 >> 2], u = p, (A | 0) != (u | 0)) {
                                                                          for (; ; ) {
                                                                            A = A - 8 | 0, u = e[A + 4 >> 2];
                                                                            h: {
                                                                              if (!u || (N = e[u + 4 >> 2], e[u + 4 >> 2] = N - 1, N))
                                                                                break h;
                                                                              xi[e[e[u >> 2] + 8 >> 2]](u), ys(u);
                                                                            }
                                                                            if ((A | 0) == (p | 0))
                                                                              break;
                                                                          }
                                                                          u = e[m + 240 >> 2];
                                                                        }
                                                                        e[m + 244 >> 2] = p, Br(u);
                                                                      }
                                                                      if (A = e[m + 336 >> 2], !A || (u = e[A + 4 >> 2], e[A + 4 >> 2] = u - 1, u))
                                                                        break u;
                                                                      xi[e[e[A >> 2] + 8 >> 2]](A), ys(A);
                                                                      break u;
                                                                    }
                                                                    s = Hr() | 0;
                                                                    break t;
                                                                  }
                                                                  s = Hr() | 0;
                                                                }
                                                                Uo(m + 240 | 0), Lo(m + 332 | 0);
                                                                break t;
                                                              }
                                                              e[5996] = 0, u = e[m + 312 >> 2], A = Mi(3, 104) | 0, p = e[5996], e[5996] = 0;
                                                              v: {
                                                                w: {
                                                                  if ((p | 0) != 1) {
                                                                    if (e[A >> 2] = 7e3, e[A + 4 >> 2] = 0, e[A + 8 >> 2] = 0, e[5996] = 0, p = xn(143, A + 12 | 0, 0, 0) | 0, N = e[5996], e[5996] = 0, (N | 0) == 1) {
                                                                      s = Hr() | 0, Br(A);
                                                                      break t;
                                                                    }
                                                                    if (e[m + 336 >> 2] = A, e[m + 332 >> 2] = p, e[m + 248 >> 2] = 0, e[m + 240 >> 2] = 0, e[m + 244 >> 2] = 0, e[5996] = 0, A = Mi(3, 16) | 0, p = e[5996], e[5996] = 0, (p | 0) == 1) {
                                                                      s = Hr() | 0;
                                                                      break v;
                                                                    }
                                                                    if (e[m + 240 >> 2] = A, N = A + 16 | 0, e[m + 248 >> 2] = N, p = u - 8 | 0, e[A >> 2] = e[p >> 2], u = u - 4 | 0, e[A + 4 >> 2] = e[u >> 2], e[p >> 2] = 0, e[u >> 2] = 0, e[A + 8 >> 2] = e[m + 332 >> 2], e[A + 12 >> 2] = e[m + 336 >> 2], e[m + 244 >> 2] = N, e[m + 332 >> 2] = 0, e[m + 336 >> 2] = 0, e[5996] = 0, A = Mi(3, 104) | 0, N = e[5996], e[5996] = 0, (N | 0) == 1)
                                                                      break w;
                                                                    if (e[5996] = 0, N = xn(146, A | 0, 22, m + 240 | 0) | 0, W = e[5996], e[5996] = 0, (W | 0) == 1) {
                                                                      s = Hr() | 0, Br(A);
                                                                      break v;
                                                                    }
                                                                    e[p >> 2] = N + 12, A = e[u >> 2], e[u >> 2] = N;
                                                                    E: {
                                                                      if (!A || (u = e[A + 4 >> 2], e[A + 4 >> 2] = u - 1, u))
                                                                        break E;
                                                                      xi[e[e[A >> 2] + 8 >> 2]](A), ys(A);
                                                                    }
                                                                    if (p = e[m + 240 >> 2], p) {
                                                                      if (A = e[m + 244 >> 2], u = p, (A | 0) != (u | 0)) {
                                                                        for (; ; ) {
                                                                          A = A - 8 | 0, u = e[A + 4 >> 2];
                                                                          E: {
                                                                            if (!u || (N = e[u + 4 >> 2], e[u + 4 >> 2] = N - 1, N))
                                                                              break E;
                                                                            xi[e[e[u >> 2] + 8 >> 2]](u), ys(u);
                                                                          }
                                                                          if ((A | 0) == (p | 0))
                                                                            break;
                                                                        }
                                                                        u = e[m + 240 >> 2];
                                                                      }
                                                                      e[m + 244 >> 2] = p, Br(u);
                                                                    }
                                                                    if (A = e[m + 336 >> 2], !A || (u = e[A + 4 >> 2], e[A + 4 >> 2] = u - 1, u))
                                                                      break u;
                                                                    xi[e[e[A >> 2] + 8 >> 2]](A), ys(A);
                                                                    break u;
                                                                  }
                                                                  s = Hr() | 0;
                                                                  break t;
                                                                }
                                                                s = Hr() | 0;
                                                              }
                                                              Uo(m + 240 | 0), Lo(m + 332 | 0);
                                                              break t;
                                                            }
                                                            e[m + 248 >> 2] = 0, e[m + 240 >> 2] = 0, e[m + 244 >> 2] = 0, e[5996] = 0, A = e[m + 312 >> 2], u = Mi(3, 8) | 0, p = e[5996], e[5996] = 0;
                                                            T: {
                                                              if ((p | 0) != 1) {
                                                                if (e[m + 240 >> 2] = u, p = u + 8 | 0, e[m + 248 >> 2] = p, A = A - 8 | 0, e[u >> 2] = e[A >> 2], e[u + 4 >> 2] = e[A + 4 >> 2], e[A >> 2] = 0, e[A + 4 >> 2] = 0, e[5996] = 0, e[m + 244 >> 2] = p, u = Mi(3, 104) | 0, p = e[5996], e[5996] = 0, (p | 0) != 1) {
                                                                  if (e[5996] = 0, p = xn(146, u | 0, 14, m + 240 | 0) | 0, N = e[5996], e[5996] = 0, (N | 0) == 1) {
                                                                    s = Hr() | 0, Br(u);
                                                                    break T;
                                                                  }
                                                                  e[A >> 2] = p + 12, u = e[A + 4 >> 2], e[A + 4 >> 2] = p;
                                                                  v: {
                                                                    if (!u || (A = e[u + 4 >> 2], e[u + 4 >> 2] = A - 1, A))
                                                                      break v;
                                                                    xi[e[e[u >> 2] + 8 >> 2]](u), ys(u);
                                                                  }
                                                                  if (u = e[m + 240 >> 2], !u)
                                                                    break u;
                                                                  if (A = e[m + 244 >> 2], (u | 0) != (A | 0)) {
                                                                    for (; ; ) {
                                                                      A = A - 8 | 0, p = e[A + 4 >> 2];
                                                                      v: {
                                                                        if (!p || (N = e[p + 4 >> 2], e[p + 4 >> 2] = N - 1, N))
                                                                          break v;
                                                                        xi[e[e[p >> 2] + 8 >> 2]](p), ys(p);
                                                                      }
                                                                      if ((u | 0) == (A | 0))
                                                                        break;
                                                                    }
                                                                    u = e[m + 240 >> 2];
                                                                  }
                                                                  Br(u);
                                                                  break u;
                                                                }
                                                                s = Hr() | 0;
                                                                break T;
                                                              }
                                                              s = Hr() | 0;
                                                            }
                                                            Uo(m + 240 | 0);
                                                            break t;
                                                          }
                                                          e[m + 248 >> 2] = 0, e[m + 240 >> 2] = 0, e[m + 244 >> 2] = 0, e[5996] = 0, A = e[m + 312 >> 2], u = Mi(3, 8) | 0, p = e[5996], e[5996] = 0;
                                                          S: {
                                                            if ((p | 0) != 1) {
                                                              if (e[m + 240 >> 2] = u, p = u + 8 | 0, e[m + 248 >> 2] = p, A = A - 8 | 0, e[u >> 2] = e[A >> 2], e[u + 4 >> 2] = e[A + 4 >> 2], e[A >> 2] = 0, e[A + 4 >> 2] = 0, e[5996] = 0, e[m + 244 >> 2] = p, u = Mi(3, 104) | 0, p = e[5996], e[5996] = 0, (p | 0) != 1) {
                                                                if (e[5996] = 0, p = xn(146, u | 0, 16, m + 240 | 0) | 0, N = e[5996], e[5996] = 0, (N | 0) == 1) {
                                                                  s = Hr() | 0, Br(u);
                                                                  break S;
                                                                }
                                                                e[A >> 2] = p + 12, u = e[A + 4 >> 2], e[A + 4 >> 2] = p;
                                                                T: {
                                                                  if (!u || (A = e[u + 4 >> 2], e[u + 4 >> 2] = A - 1, A))
                                                                    break T;
                                                                  xi[e[e[u >> 2] + 8 >> 2]](u), ys(u);
                                                                }
                                                                if (u = e[m + 240 >> 2], !u)
                                                                  break u;
                                                                if (A = e[m + 244 >> 2], (u | 0) != (A | 0)) {
                                                                  for (; ; ) {
                                                                    A = A - 8 | 0, p = e[A + 4 >> 2];
                                                                    T: {
                                                                      if (!p || (N = e[p + 4 >> 2], e[p + 4 >> 2] = N - 1, N))
                                                                        break T;
                                                                      xi[e[e[p >> 2] + 8 >> 2]](p), ys(p);
                                                                    }
                                                                    if ((u | 0) == (A | 0))
                                                                      break;
                                                                  }
                                                                  u = e[m + 240 >> 2];
                                                                }
                                                                Br(u);
                                                                break u;
                                                              }
                                                              s = Hr() | 0;
                                                              break S;
                                                            }
                                                            s = Hr() | 0;
                                                          }
                                                          Uo(m + 240 | 0);
                                                          break t;
                                                        }
                                                        e[m + 248 >> 2] = 0, e[m + 240 >> 2] = 0, e[m + 244 >> 2] = 0, e[5996] = 0, A = e[m + 312 >> 2], u = Mi(3, 8) | 0, p = e[5996], e[5996] = 0;
                                                        N: {
                                                          if ((p | 0) != 1) {
                                                            if (e[m + 240 >> 2] = u, p = u + 8 | 0, e[m + 248 >> 2] = p, A = A - 8 | 0, e[u >> 2] = e[A >> 2], e[u + 4 >> 2] = e[A + 4 >> 2], e[A >> 2] = 0, e[A + 4 >> 2] = 0, e[5996] = 0, e[m + 244 >> 2] = p, u = Mi(3, 104) | 0, p = e[5996], e[5996] = 0, (p | 0) != 1) {
                                                              if (e[5996] = 0, p = xn(146, u | 0, 15, m + 240 | 0) | 0, N = e[5996], e[5996] = 0, (N | 0) == 1) {
                                                                s = Hr() | 0, Br(u);
                                                                break N;
                                                              }
                                                              e[A >> 2] = p + 12, u = e[A + 4 >> 2], e[A + 4 >> 2] = p;
                                                              S: {
                                                                if (!u || (A = e[u + 4 >> 2], e[u + 4 >> 2] = A - 1, A))
                                                                  break S;
                                                                xi[e[e[u >> 2] + 8 >> 2]](u), ys(u);
                                                              }
                                                              if (u = e[m + 240 >> 2], !u)
                                                                break u;
                                                              if (A = e[m + 244 >> 2], (u | 0) != (A | 0)) {
                                                                for (; ; ) {
                                                                  A = A - 8 | 0, p = e[A + 4 >> 2];
                                                                  S: {
                                                                    if (!p || (N = e[p + 4 >> 2], e[p + 4 >> 2] = N - 1, N))
                                                                      break S;
                                                                    xi[e[e[p >> 2] + 8 >> 2]](p), ys(p);
                                                                  }
                                                                  if ((u | 0) == (A | 0))
                                                                    break;
                                                                }
                                                                u = e[m + 240 >> 2];
                                                              }
                                                              Br(u);
                                                              break u;
                                                            }
                                                            s = Hr() | 0;
                                                            break N;
                                                          }
                                                          s = Hr() | 0;
                                                        }
                                                        Uo(m + 240 | 0);
                                                        break t;
                                                      }
                                                      e[m + 248 >> 2] = 0, e[m + 240 >> 2] = 0, e[m + 244 >> 2] = 0, e[5996] = 0, A = e[m + 312 >> 2], u = Mi(3, 8) | 0, p = e[5996], e[5996] = 0;
                                                      k: {
                                                        if ((p | 0) != 1) {
                                                          if (e[m + 240 >> 2] = u, p = u + 8 | 0, e[m + 248 >> 2] = p, A = A - 8 | 0, e[u >> 2] = e[A >> 2], e[u + 4 >> 2] = e[A + 4 >> 2], e[A >> 2] = 0, e[A + 4 >> 2] = 0, e[5996] = 0, e[m + 244 >> 2] = p, u = Mi(3, 104) | 0, p = e[5996], e[5996] = 0, (p | 0) != 1) {
                                                            if (e[5996] = 0, p = xn(146, u | 0, 13, m + 240 | 0) | 0, N = e[5996], e[5996] = 0, (N | 0) == 1) {
                                                              s = Hr() | 0, Br(u);
                                                              break k;
                                                            }
                                                            e[A >> 2] = p + 12, u = e[A + 4 >> 2], e[A + 4 >> 2] = p;
                                                            N: {
                                                              if (!u || (A = e[u + 4 >> 2], e[u + 4 >> 2] = A - 1, A))
                                                                break N;
                                                              xi[e[e[u >> 2] + 8 >> 2]](u), ys(u);
                                                            }
                                                            if (u = e[m + 240 >> 2], !u)
                                                              break u;
                                                            if (A = e[m + 244 >> 2], (u | 0) != (A | 0)) {
                                                              for (; ; ) {
                                                                A = A - 8 | 0, p = e[A + 4 >> 2];
                                                                N: {
                                                                  if (!p || (N = e[p + 4 >> 2], e[p + 4 >> 2] = N - 1, N))
                                                                    break N;
                                                                  xi[e[e[p >> 2] + 8 >> 2]](p), ys(p);
                                                                }
                                                                if ((u | 0) == (A | 0))
                                                                  break;
                                                              }
                                                              u = e[m + 240 >> 2];
                                                            }
                                                            Br(u);
                                                            break u;
                                                          }
                                                          s = Hr() | 0;
                                                          break k;
                                                        }
                                                        s = Hr() | 0;
                                                      }
                                                      Uo(m + 240 | 0);
                                                      break t;
                                                    }
                                                    e[m + 248 >> 2] = 0, e[m + 240 >> 2] = 0, e[m + 244 >> 2] = 0, e[5996] = 0, A = e[m + 312 >> 2], u = Mi(3, 8) | 0, p = e[5996], e[5996] = 0;
                                                    m: {
                                                      if ((p | 0) != 1) {
                                                        if (e[m + 240 >> 2] = u, p = u + 8 | 0, e[m + 248 >> 2] = p, A = A - 8 | 0, e[u >> 2] = e[A >> 2], e[u + 4 >> 2] = e[A + 4 >> 2], e[A >> 2] = 0, e[A + 4 >> 2] = 0, e[5996] = 0, e[m + 244 >> 2] = p, u = Mi(3, 104) | 0, p = e[5996], e[5996] = 0, (p | 0) != 1) {
                                                          if (e[5996] = 0, p = xn(146, u | 0, 12, m + 240 | 0) | 0, N = e[5996], e[5996] = 0, (N | 0) == 1) {
                                                            s = Hr() | 0, Br(u);
                                                            break m;
                                                          }
                                                          e[A >> 2] = p + 12, u = e[A + 4 >> 2], e[A + 4 >> 2] = p;
                                                          k: {
                                                            if (!u || (A = e[u + 4 >> 2], e[u + 4 >> 2] = A - 1, A))
                                                              break k;
                                                            xi[e[e[u >> 2] + 8 >> 2]](u), ys(u);
                                                          }
                                                          if (u = e[m + 240 >> 2], !u)
                                                            break u;
                                                          if (A = e[m + 244 >> 2], (u | 0) != (A | 0)) {
                                                            for (; ; ) {
                                                              A = A - 8 | 0, p = e[A + 4 >> 2];
                                                              k: {
                                                                if (!p || (N = e[p + 4 >> 2], e[p + 4 >> 2] = N - 1, N))
                                                                  break k;
                                                                xi[e[e[p >> 2] + 8 >> 2]](p), ys(p);
                                                              }
                                                              if ((u | 0) == (A | 0))
                                                                break;
                                                            }
                                                            u = e[m + 240 >> 2];
                                                          }
                                                          Br(u);
                                                          break u;
                                                        }
                                                        s = Hr() | 0;
                                                        break m;
                                                      }
                                                      s = Hr() | 0;
                                                    }
                                                    Uo(m + 240 | 0);
                                                    break t;
                                                  }
                                                  e[m + 248 >> 2] = 0, e[m + 240 >> 2] = 0, e[m + 244 >> 2] = 0, e[5996] = 0, A = e[m + 312 >> 2], u = Mi(3, 8) | 0, p = e[5996], e[5996] = 0;
                                                  p: {
                                                    if ((p | 0) != 1) {
                                                      if (e[m + 240 >> 2] = u, p = u + 8 | 0, e[m + 248 >> 2] = p, A = A - 8 | 0, e[u >> 2] = e[A >> 2], e[u + 4 >> 2] = e[A + 4 >> 2], e[A >> 2] = 0, e[A + 4 >> 2] = 0, e[5996] = 0, e[m + 244 >> 2] = p, u = Mi(3, 104) | 0, p = e[5996], e[5996] = 0, (p | 0) != 1) {
                                                        if (e[5996] = 0, p = xn(146, u | 0, 11, m + 240 | 0) | 0, N = e[5996], e[5996] = 0, (N | 0) == 1) {
                                                          s = Hr() | 0, Br(u);
                                                          break p;
                                                        }
                                                        e[A >> 2] = p + 12, u = e[A + 4 >> 2], e[A + 4 >> 2] = p;
                                                        m: {
                                                          if (!u || (A = e[u + 4 >> 2], e[u + 4 >> 2] = A - 1, A))
                                                            break m;
                                                          xi[e[e[u >> 2] + 8 >> 2]](u), ys(u);
                                                        }
                                                        if (u = e[m + 240 >> 2], !u)
                                                          break u;
                                                        if (A = e[m + 244 >> 2], (u | 0) != (A | 0)) {
                                                          for (; ; ) {
                                                            A = A - 8 | 0, p = e[A + 4 >> 2];
                                                            m: {
                                                              if (!p || (N = e[p + 4 >> 2], e[p + 4 >> 2] = N - 1, N))
                                                                break m;
                                                              xi[e[e[p >> 2] + 8 >> 2]](p), ys(p);
                                                            }
                                                            if ((u | 0) == (A | 0))
                                                              break;
                                                          }
                                                          u = e[m + 240 >> 2];
                                                        }
                                                        Br(u);
                                                        break u;
                                                      }
                                                      s = Hr() | 0;
                                                      break p;
                                                    }
                                                    s = Hr() | 0;
                                                  }
                                                  Uo(m + 240 | 0);
                                                  break t;
                                                }
                                                e[m + 248 >> 2] = 0, e[m + 240 >> 2] = 0, e[m + 244 >> 2] = 0, e[5996] = 0, A = e[m + 312 >> 2], u = Mi(3, 8) | 0, p = e[5996], e[5996] = 0;
                                                A: {
                                                  if ((p | 0) != 1) {
                                                    if (e[m + 240 >> 2] = u, p = u + 8 | 0, e[m + 248 >> 2] = p, A = A - 8 | 0, e[u >> 2] = e[A >> 2], e[u + 4 >> 2] = e[A + 4 >> 2], e[A >> 2] = 0, e[A + 4 >> 2] = 0, e[5996] = 0, e[m + 244 >> 2] = p, u = Mi(3, 104) | 0, p = e[5996], e[5996] = 0, (p | 0) != 1) {
                                                      if (e[5996] = 0, p = xn(146, u | 0, 10, m + 240 | 0) | 0, N = e[5996], e[5996] = 0, (N | 0) == 1) {
                                                        s = Hr() | 0, Br(u);
                                                        break A;
                                                      }
                                                      e[A >> 2] = p + 12, u = e[A + 4 >> 2], e[A + 4 >> 2] = p;
                                                      p: {
                                                        if (!u || (A = e[u + 4 >> 2], e[u + 4 >> 2] = A - 1, A))
                                                          break p;
                                                        xi[e[e[u >> 2] + 8 >> 2]](u), ys(u);
                                                      }
                                                      if (u = e[m + 240 >> 2], !u)
                                                        break u;
                                                      if (A = e[m + 244 >> 2], (u | 0) != (A | 0)) {
                                                        for (; ; ) {
                                                          A = A - 8 | 0, p = e[A + 4 >> 2];
                                                          p: {
                                                            if (!p || (N = e[p + 4 >> 2], e[p + 4 >> 2] = N - 1, N))
                                                              break p;
                                                            xi[e[e[p >> 2] + 8 >> 2]](p), ys(p);
                                                          }
                                                          if ((u | 0) == (A | 0))
                                                            break;
                                                        }
                                                        u = e[m + 240 >> 2];
                                                      }
                                                      Br(u);
                                                      break u;
                                                    }
                                                    s = Hr() | 0;
                                                    break A;
                                                  }
                                                  s = Hr() | 0;
                                                }
                                                Uo(m + 240 | 0);
                                                break t;
                                              }
                                              Zs[m + 240 >> 1] = 48, _[m + 251 | 0] = 1;
                                              g: {
                                                A: {
                                                  p: {
                                                    m: {
                                                      if (A = e[s + 4 >> 2], !A) {
                                                        _[m + 251 | 0] = 3, _[m + 243 | 0] = 0, Zs[m + 240 >> 1] = me[5279] | me[5280] << 8, _[m + 242 | 0] = me[5281];
                                                        break m;
                                                      }
                                                      if (u = e[s >> 2], me[m + 240 | 0] == me[u | 0]) {
                                                        e[s + 4 >> 2] = A - 1, e[s >> 2] = u + 1, e[5996] = 0, A = Mi(3, 104) | 0, u = e[5996], e[5996] = 0;
                                                        k: {
                                                          if ((u | 0) != 1) {
                                                            if (e[A >> 2] = 7e3, e[A + 4 >> 2] = 0, e[A + 8 >> 2] = 0, e[5996] = 0, p = xn(143, A + 12 | 0, 0, 0) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1) {
                                                              s = Hr() | 0, Br(A);
                                                              break t;
                                                            }
                                                            if (e[m + 244 >> 2] = A, e[m + 240 >> 2] = p, u = e[m + 312 >> 2], u >>> 0 < Ls[m + 316 >> 2]) {
                                                              e[u + 4 >> 2] = A, e[u >> 2] = p, e[m + 312 >> 2] = u + 8;
                                                              break u;
                                                            }
                                                            if (e[5996] = 0, ji(144, m + 308 | 0, m + 240 | 0), A = e[5996], e[5996] = 0, (A | 0) == 1)
                                                              break k;
                                                            if (A = e[m + 244 >> 2], !A || (u = e[A + 4 >> 2], e[A + 4 >> 2] = u - 1, u))
                                                              break u;
                                                            xi[e[e[A >> 2] + 8 >> 2]](A), ys(A);
                                                            break u;
                                                          }
                                                          s = Hr() | 0;
                                                          break t;
                                                        }
                                                        s = Hr() | 0, Lo(m + 240 | 0);
                                                        break t;
                                                      }
                                                      if (_[m + 251 | 0] = 1, Zs[m + 240 >> 1] = 49, u = e[s >> 2], me[u | 0] == 49) {
                                                        e[s + 4 >> 2] = A - 1, e[s >> 2] = u + 1, e[5996] = 0, A = Mi(3, 104) | 0, u = e[5996], e[5996] = 0;
                                                        k: {
                                                          if ((u | 0) != 1) {
                                                            if (e[A >> 2] = 7e3, e[A + 4 >> 2] = 0, e[A + 8 >> 2] = 0, e[5996] = 0, p = xn(143, A + 12 | 0, 1, 0) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1) {
                                                              s = Hr() | 0, Br(A);
                                                              break t;
                                                            }
                                                            if (e[m + 244 >> 2] = A, e[m + 240 >> 2] = p, u = e[m + 312 >> 2], u >>> 0 < Ls[m + 316 >> 2]) {
                                                              e[u + 4 >> 2] = A, e[u >> 2] = p, e[m + 312 >> 2] = u + 8;
                                                              break u;
                                                            }
                                                            if (e[5996] = 0, ji(144, m + 308 | 0, m + 240 | 0), A = e[5996], e[5996] = 0, (A | 0) == 1)
                                                              break k;
                                                            if (A = e[m + 244 >> 2], !A || (u = e[A + 4 >> 2], e[A + 4 >> 2] = u - 1, u))
                                                              break u;
                                                            xi[e[e[A >> 2] + 8 >> 2]](A), ys(A);
                                                            break u;
                                                          }
                                                          s = Hr() | 0;
                                                          break t;
                                                        }
                                                        s = Hr() | 0, Lo(m + 240 | 0);
                                                        break t;
                                                      }
                                                      if (_[m + 243 | 0] = 0, Zs[m + 240 >> 1] = me[5279] | me[5280] << 8, _[m + 242 | 0] = me[5281], _[m + 251 | 0] = 3, A >>> 0 < 3)
                                                        break m;
                                                      k: {
                                                        N: {
                                                          S: {
                                                            T: {
                                                              v: {
                                                                w: {
                                                                  E: {
                                                                    h: {
                                                                      R: {
                                                                        I: {
                                                                          B: {
                                                                            x: {
                                                                              b: {
                                                                                if (u = e[s >> 2], !(me[m + 240 | 0] != me[u | 0] | me[m + 241 | 0] != me[u + 1 | 0] | me[m + 242 | 0] != me[u + 2 | 0])) {
                                                                                  if (N = A - 3 | 0, e[s + 4 >> 2] = N, e[s >> 2] = u + 3, (N | 0) <= 0)
                                                                                    break k;
                                                                                  for (p = e[s >> 2], u = e[s >> 2], A = 0; ; ) {
                                                                                    if (me[u + A | 0] != 41) {
                                                                                      if (A = A + 1 | 0, (N | 0) != (A | 0))
                                                                                        continue;
                                                                                      break k;
                                                                                    }
                                                                                    break;
                                                                                  }
                                                                                  if (A - 18 >>> 0 < 4294967279)
                                                                                    break k;
                                                                                  C: {
                                                                                    if (A >>> 0 <= 10) {
                                                                                      _[m + 251 | 0] = A, u = m + 240 | 0;
                                                                                      break C;
                                                                                    }
                                                                                    if (e[5996] = 0, N = (A | 15) + 1 | 0, u = Mi(3, N | 0) | 0, W = e[5996], e[5996] = 0, (W | 0) == 1)
                                                                                      break b;
                                                                                    e[m + 240 >> 2] = u, e[m + 244 >> 2] = A, e[m + 248 >> 2] = N | -2147483648;
                                                                                  }
                                                                                  if (_[so(u, p, A) + A | 0] = 0, e[m + 272 >> 2] = e[m + 244 >> 2], u = me[m + 247 | 0] | me[m + 248 | 0] << 8 | (me[m + 249 | 0] << 16 | me[m + 250 | 0] << 24), _[m + 275 | 0] = u, _[m + 276 | 0] = u >>> 8, _[m + 277 | 0] = u >>> 16, _[m + 278 | 0] = u >>> 24, e[5996] = 0, p = e[m + 240 >> 2], N = _[m + 251 | 0], e[m + 340 >> 2] = 0, e[m + 332 >> 2] = 0, e[m + 336 >> 2] = 0, u = Mi(3, 12) | 0, W = e[5996], e[5996] = 0, (W | 0) != 1) {
                                                                                    e[m + 332 >> 2] = u, W = u + 12 | 0, e[m + 340 >> 2] = W, e[u >> 2] = p, e[u + 4 >> 2] = e[m + 272 >> 2], p = me[m + 275 | 0] | me[m + 276 | 0] << 8 | (me[m + 277 | 0] << 16 | me[m + 278 | 0] << 24), _[u + 7 | 0] = p, _[u + 8 | 0] = p >>> 8, _[u + 9 | 0] = p >>> 16, _[u + 10 | 0] = p >>> 24, _[u + 11 | 0] = N, _[m + 275 | 0] = 0, _[m + 276 | 0] = 0, _[m + 277 | 0] = 0, _[m + 278 | 0] = 0, e[m + 272 >> 2] = 0, e[m + 336 >> 2] = W, e[5996] = 0, u = Mi(3, 104) | 0, p = e[5996], e[5996] = 0;
                                                                                    C: {
                                                                                      y: {
                                                                                        if ((p | 0) != 1) {
                                                                                          if (e[5996] = 0, p = xn(147, u | 0, 2, m + 332 | 0) | 0, N = e[5996], e[5996] = 0, (N | 0) == 1) {
                                                                                            s = Hr() | 0, Br(u);
                                                                                            break N;
                                                                                          }
                                                                                          if (e[m + 248 >> 2] = 0, e[m + 240 >> 2] = 0, e[m + 244 >> 2] = 0, e[5996] = 0, e[m + 268 >> 2] = p, N = p + 12 | 0, e[m + 264 >> 2] = N, u = Mi(3, 8) | 0, W = e[5996], e[5996] = 0, (W | 0) == 1)
                                                                                            break x;
                                                                                          if (e[m + 240 >> 2] = u, W = u + 8 | 0, e[m + 248 >> 2] = W, e[u + 4 >> 2] = p, e[u >> 2] = N, e[m + 244 >> 2] = W, e[m + 264 >> 2] = 0, e[m + 268 >> 2] = 0, e[5996] = 0, p = Mi(3, 104) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1)
                                                                                            break y;
                                                                                          if (e[5996] = 0, u = xn(146, p | 0, 12, m + 240 | 0) | 0, N = e[5996], e[5996] = 0, (N | 0) == 1) {
                                                                                            s = Hr() | 0, Br(p);
                                                                                            break S;
                                                                                          }
                                                                                          e[m + 348 >> 2] = u, N = u + 12 | 0, e[m + 344 >> 2] = N, p = e[m + 312 >> 2];
                                                                                          D: {
                                                                                            if (p >>> 0 < Ls[m + 316 >> 2]) {
                                                                                              e[p + 4 >> 2] = u, e[p >> 2] = N, e[m + 312 >> 2] = p + 8, e[m + 344 >> 2] = 0, e[m + 348 >> 2] = 0;
                                                                                              break D;
                                                                                            }
                                                                                            if (e[5996] = 0, ji(144, m + 308 | 0, m + 344 | 0), u = e[5996], e[5996] = 0, (u | 0) == 1)
                                                                                              break C;
                                                                                            if (u = e[m + 348 >> 2], !u || (p = e[u + 4 >> 2], e[u + 4 >> 2] = p - 1, p))
                                                                                              break D;
                                                                                            xi[e[e[u >> 2] + 8 >> 2]](u), ys(u);
                                                                                          }
                                                                                          if (N = e[m + 240 >> 2], N) {
                                                                                            if (u = e[m + 244 >> 2], p = N, (u | 0) != (p | 0)) {
                                                                                              for (; ; ) {
                                                                                                u = u - 8 | 0, p = e[u + 4 >> 2];
                                                                                                D: {
                                                                                                  if (!p || (W = e[p + 4 >> 2], e[p + 4 >> 2] = W - 1, W))
                                                                                                    break D;
                                                                                                  xi[e[e[p >> 2] + 8 >> 2]](p), ys(p);
                                                                                                }
                                                                                                if ((u | 0) == (N | 0))
                                                                                                  break;
                                                                                              }
                                                                                              p = e[m + 240 >> 2];
                                                                                            }
                                                                                            e[m + 244 >> 2] = N, Br(p);
                                                                                          }
                                                                                          u = e[m + 268 >> 2];
                                                                                          D: {
                                                                                            if (!u || (p = e[u + 4 >> 2], e[u + 4 >> 2] = p - 1, p))
                                                                                              break D;
                                                                                            xi[e[e[u >> 2] + 8 >> 2]](u), ys(u);
                                                                                          }
                                                                                          if (N = e[m + 332 >> 2], N) {
                                                                                            if (p = e[m + 336 >> 2], (N | 0) != (p | 0))
                                                                                              for (; u = p - 12 | 0, _[p - 1 | 0] < 0 && Br(e[u >> 2]), p = u, (u | 0) != (N | 0); )
                                                                                                ;
                                                                                            e[m + 336 >> 2] = N, Br(N);
                                                                                          }
                                                                                          A = A + 1 | 0, e[s + 4 >> 2] = e[s + 4 >> 2] - A, e[s >> 2] = A + e[s >> 2];
                                                                                          break u;
                                                                                        }
                                                                                        s = Hr() | 0;
                                                                                        break N;
                                                                                      }
                                                                                      s = Hr() | 0;
                                                                                      break S;
                                                                                    }
                                                                                    s = Hr() | 0, Lo(m + 344 | 0);
                                                                                    break S;
                                                                                  }
                                                                                  if (s = Hr() | 0, ea(m + 332 | 0), (N | 0) >= 0)
                                                                                    break t;
                                                                                  Br(p);
                                                                                  break t;
                                                                                }
                                                                                if (_[m + 244 | 0] = 0, e[m + 240 >> 2] = 677931888, _[m + 251 | 0] = 4, A >>> 0 < 4)
                                                                                  break p;
                                                                                if (u = e[s >> 2], !(me[m + 240 | 0] != me[u | 0] | me[m + 241 | 0] != me[u + 1 | 0] | (me[m + 242 | 0] != me[u + 2 | 0] | me[m + 243 | 0] != me[u + 3 | 0]))) {
                                                                                  if (N = A - 4 | 0, e[s + 4 >> 2] = N, e[s >> 2] = u + 4, (N | 0) <= 0)
                                                                                    break T;
                                                                                  for (p = e[s >> 2], u = e[s >> 2], A = 0; ; ) {
                                                                                    if (me[u + A | 0] != 41) {
                                                                                      if (A = A + 1 | 0, (N | 0) != (A | 0))
                                                                                        continue;
                                                                                      break T;
                                                                                    }
                                                                                    break;
                                                                                  }
                                                                                  if (A - 18 >>> 0 < 4294967279)
                                                                                    break T;
                                                                                  C: {
                                                                                    if (A >>> 0 <= 10) {
                                                                                      _[m + 251 | 0] = A, u = m + 240 | 0;
                                                                                      break C;
                                                                                    }
                                                                                    if (e[5996] = 0, N = (A | 15) + 1 | 0, u = Mi(3, N | 0) | 0, W = e[5996], e[5996] = 0, (W | 0) == 1)
                                                                                      break B;
                                                                                    e[m + 240 >> 2] = u, e[m + 244 >> 2] = A, e[m + 248 >> 2] = N | -2147483648;
                                                                                  }
                                                                                  if (_[so(u, p, A) + A | 0] = 0, e[m + 272 >> 2] = e[m + 244 >> 2], u = me[m + 247 | 0] | me[m + 248 | 0] << 8 | (me[m + 249 | 0] << 16 | me[m + 250 | 0] << 24), _[m + 275 | 0] = u, _[m + 276 | 0] = u >>> 8, _[m + 277 | 0] = u >>> 16, _[m + 278 | 0] = u >>> 24, e[5996] = 0, p = e[m + 240 >> 2], N = _[m + 251 | 0], e[m + 340 >> 2] = 0, e[m + 332 >> 2] = 0, e[m + 336 >> 2] = 0, u = Mi(3, 12) | 0, W = e[5996], e[5996] = 0, (W | 0) != 1) {
                                                                                    e[m + 332 >> 2] = u, W = u + 12 | 0, e[m + 340 >> 2] = W, e[u >> 2] = p, e[u + 4 >> 2] = e[m + 272 >> 2], p = me[m + 275 | 0] | me[m + 276 | 0] << 8 | (me[m + 277 | 0] << 16 | me[m + 278 | 0] << 24), _[u + 7 | 0] = p, _[u + 8 | 0] = p >>> 8, _[u + 9 | 0] = p >>> 16, _[u + 10 | 0] = p >>> 24, _[u + 11 | 0] = N, _[m + 275 | 0] = 0, _[m + 276 | 0] = 0, _[m + 277 | 0] = 0, _[m + 278 | 0] = 0, e[m + 272 >> 2] = 0, e[m + 336 >> 2] = W, e[5996] = 0, u = Mi(3, 104) | 0, p = e[5996], e[5996] = 0;
                                                                                    C: {
                                                                                      y: {
                                                                                        if ((p | 0) != 1) {
                                                                                          if (e[5996] = 0, p = xn(147, u | 0, 3, m + 332 | 0) | 0, N = e[5996], e[5996] = 0, (N | 0) == 1) {
                                                                                            s = Hr() | 0, Br(u);
                                                                                            break v;
                                                                                          }
                                                                                          if (e[m + 248 >> 2] = 0, e[m + 240 >> 2] = 0, e[m + 244 >> 2] = 0, e[5996] = 0, e[m + 268 >> 2] = p, N = p + 12 | 0, e[m + 264 >> 2] = N, u = Mi(3, 8) | 0, W = e[5996], e[5996] = 0, (W | 0) == 1)
                                                                                            break I;
                                                                                          if (e[m + 240 >> 2] = u, W = u + 8 | 0, e[m + 248 >> 2] = W, e[u + 4 >> 2] = p, e[u >> 2] = N, e[m + 244 >> 2] = W, e[m + 264 >> 2] = 0, e[m + 268 >> 2] = 0, e[5996] = 0, p = Mi(3, 104) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1)
                                                                                            break y;
                                                                                          if (e[5996] = 0, u = xn(146, p | 0, 12, m + 240 | 0) | 0, N = e[5996], e[5996] = 0, (N | 0) == 1) {
                                                                                            s = Hr() | 0, Br(p);
                                                                                            break w;
                                                                                          }
                                                                                          e[m + 348 >> 2] = u, N = u + 12 | 0, e[m + 344 >> 2] = N, p = e[m + 312 >> 2];
                                                                                          D: {
                                                                                            if (p >>> 0 < Ls[m + 316 >> 2]) {
                                                                                              e[p + 4 >> 2] = u, e[p >> 2] = N, e[m + 312 >> 2] = p + 8, e[m + 344 >> 2] = 0, e[m + 348 >> 2] = 0;
                                                                                              break D;
                                                                                            }
                                                                                            if (e[5996] = 0, ji(144, m + 308 | 0, m + 344 | 0), u = e[5996], e[5996] = 0, (u | 0) == 1)
                                                                                              break C;
                                                                                            if (u = e[m + 348 >> 2], !u || (p = e[u + 4 >> 2], e[u + 4 >> 2] = p - 1, p))
                                                                                              break D;
                                                                                            xi[e[e[u >> 2] + 8 >> 2]](u), ys(u);
                                                                                          }
                                                                                          if (N = e[m + 240 >> 2], N) {
                                                                                            if (u = e[m + 244 >> 2], p = N, (u | 0) != (p | 0)) {
                                                                                              for (; ; ) {
                                                                                                u = u - 8 | 0, p = e[u + 4 >> 2];
                                                                                                D: {
                                                                                                  if (!p || (W = e[p + 4 >> 2], e[p + 4 >> 2] = W - 1, W))
                                                                                                    break D;
                                                                                                  xi[e[e[p >> 2] + 8 >> 2]](p), ys(p);
                                                                                                }
                                                                                                if ((u | 0) == (N | 0))
                                                                                                  break;
                                                                                              }
                                                                                              p = e[m + 240 >> 2];
                                                                                            }
                                                                                            e[m + 244 >> 2] = N, Br(p);
                                                                                          }
                                                                                          u = e[m + 268 >> 2];
                                                                                          D: {
                                                                                            if (!u || (p = e[u + 4 >> 2], e[u + 4 >> 2] = p - 1, p))
                                                                                              break D;
                                                                                            xi[e[e[u >> 2] + 8 >> 2]](u), ys(u);
                                                                                          }
                                                                                          if (N = e[m + 332 >> 2], N) {
                                                                                            if (p = e[m + 336 >> 2], (N | 0) != (p | 0))
                                                                                              for (; u = p - 12 | 0, _[p - 1 | 0] < 0 && Br(e[u >> 2]), p = u, (u | 0) != (N | 0); )
                                                                                                ;
                                                                                            e[m + 336 >> 2] = N, Br(N);
                                                                                          }
                                                                                          A = A + 1 | 0, e[s + 4 >> 2] = e[s + 4 >> 2] - A, e[s >> 2] = A + e[s >> 2];
                                                                                          break u;
                                                                                        }
                                                                                        s = Hr() | 0;
                                                                                        break v;
                                                                                      }
                                                                                      s = Hr() | 0;
                                                                                      break w;
                                                                                    }
                                                                                    s = Hr() | 0, Lo(m + 344 | 0);
                                                                                    break w;
                                                                                  }
                                                                                  if (s = Hr() | 0, ea(m + 332 | 0), (N | 0) >= 0)
                                                                                    break t;
                                                                                  Br(p);
                                                                                  break t;
                                                                                }
                                                                                if (_[m + 245 | 0] = 0, _[m + 244 | 0] = me[5287], e[m + 240 >> 2] = me[5283] | me[5284] << 8 | (me[5285] << 16 | me[5286] << 24), _[m + 251 | 0] = 5, A >>> 0 < 5)
                                                                                  break A;
                                                                                C: {
                                                                                  if (u = e[s >> 2], me[m + 240 | 0] != me[u | 0] | me[m + 241 | 0] != me[u + 1 | 0] | (me[m + 242 | 0] != me[u + 2 | 0] | me[m + 243 | 0] != me[u + 3 | 0]) || me[m + 244 | 0] != me[u + 4 | 0])
                                                                                    break C;
                                                                                  if (N = A - 5 | 0, e[s + 4 >> 2] = N, e[s >> 2] = u + 5, (N | 0) <= 0)
                                                                                    break E;
                                                                                  for (p = e[s >> 2], u = e[s >> 2], A = 0; ; ) {
                                                                                    if (me[u + A | 0] != 41) {
                                                                                      if (A = A + 1 | 0, (N | 0) != (A | 0))
                                                                                        continue;
                                                                                      break E;
                                                                                    }
                                                                                    break;
                                                                                  }
                                                                                  if (A - 18 >>> 0 < 4294967279)
                                                                                    break E;
                                                                                  y: {
                                                                                    if (A >>> 0 <= 10) {
                                                                                      _[m + 251 | 0] = A, u = m + 240 | 0;
                                                                                      break y;
                                                                                    }
                                                                                    if (e[5996] = 0, N = (A | 15) + 1 | 0, u = Mi(3, N | 0) | 0, W = e[5996], e[5996] = 0, (W | 0) == 1)
                                                                                      break R;
                                                                                    e[m + 240 >> 2] = u, e[m + 244 >> 2] = A, e[m + 248 >> 2] = N | -2147483648;
                                                                                  }
                                                                                  if (_[so(u, p, A) + A | 0] = 0, e[m + 344 >> 2] = e[m + 244 >> 2], u = me[m + 247 | 0] | me[m + 248 | 0] << 8 | (me[m + 249 | 0] << 16 | me[m + 250 | 0] << 24), _[m + 347 | 0] = u, _[m + 348 | 0] = u >>> 8, _[m + 349 | 0] = u >>> 16, _[m + 350 | 0] = u >>> 24, e[5996] = 0, p = e[m + 240 >> 2], N = _[m + 251 | 0], e[m + 248 >> 2] = 0, e[m + 240 >> 2] = 0, e[m + 244 >> 2] = 0, u = Mi(3, 12) | 0, W = e[5996], e[5996] = 0, (W | 0) != 1) {
                                                                                    e[m + 240 >> 2] = u, W = u + 12 | 0, e[m + 248 >> 2] = W, e[u >> 2] = p, e[u + 4 >> 2] = e[m + 344 >> 2], p = me[m + 347 | 0] | me[m + 348 | 0] << 8 | (me[m + 349 | 0] << 16 | me[m + 350 | 0] << 24), _[u + 7 | 0] = p, _[u + 8 | 0] = p >>> 8, _[u + 9 | 0] = p >>> 16, _[u + 10 | 0] = p >>> 24, _[u + 11 | 0] = N, _[m + 347 | 0] = 0, _[m + 348 | 0] = 0, _[m + 349 | 0] = 0, _[m + 350 | 0] = 0, e[m + 344 >> 2] = 0, e[m + 244 >> 2] = W, e[5996] = 0, p = Mi(3, 104) | 0, u = e[5996], e[5996] = 0;
                                                                                    y: {
                                                                                      D: {
                                                                                        if ((u | 0) != 1) {
                                                                                          if (e[5996] = 0, u = xn(147, p | 0, 2, m + 240 | 0) | 0, N = e[5996], e[5996] = 0, (N | 0) == 1) {
                                                                                            s = Hr() | 0, Br(p);
                                                                                            break y;
                                                                                          }
                                                                                          e[m + 336 >> 2] = u, N = u + 12 | 0, e[m + 332 >> 2] = N, p = e[m + 312 >> 2];
                                                                                          P: {
                                                                                            if (p >>> 0 < Ls[m + 316 >> 2]) {
                                                                                              e[p + 4 >> 2] = u, e[p >> 2] = N, e[m + 312 >> 2] = p + 8, e[m + 332 >> 2] = 0, e[m + 336 >> 2] = 0;
                                                                                              break P;
                                                                                            }
                                                                                            if (e[5996] = 0, ji(144, m + 308 | 0, m + 332 | 0), u = e[5996], e[5996] = 0, (u | 0) == 1)
                                                                                              break D;
                                                                                            if (u = e[m + 336 >> 2], !u || (p = e[u + 4 >> 2], e[u + 4 >> 2] = p - 1, p))
                                                                                              break P;
                                                                                            xi[e[e[u >> 2] + 8 >> 2]](u), ys(u);
                                                                                          }
                                                                                          if (N = e[m + 240 >> 2], N) {
                                                                                            if (p = e[m + 244 >> 2], (N | 0) != (p | 0))
                                                                                              for (; u = p - 12 | 0, _[p - 1 | 0] < 0 && Br(e[u >> 2]), p = u, (u | 0) != (N | 0); )
                                                                                                ;
                                                                                            e[m + 244 >> 2] = N, Br(N);
                                                                                          }
                                                                                          A = A + 1 | 0, e[s + 4 >> 2] = e[s + 4 >> 2] - A, e[s >> 2] = A + e[s >> 2];
                                                                                          break u;
                                                                                        }
                                                                                        s = Hr() | 0;
                                                                                        break y;
                                                                                      }
                                                                                      s = Hr() | 0, Lo(m + 332 | 0);
                                                                                    }
                                                                                    ea(m + 240 | 0);
                                                                                    break t;
                                                                                  }
                                                                                  if (s = Hr() | 0, ea(m + 240 | 0), (N | 0) >= 0)
                                                                                    break t;
                                                                                  Br(p);
                                                                                  break t;
                                                                                }
                                                                                if (_[m + 245 | 0] = 0, _[m + 244 | 0] = me[5319], _[m + 251 | 0] = 5, p = me[5315] | me[5316] << 8 | (me[5317] << 16 | me[5318] << 24), e[m + 240 >> 2] = p, u = e[s >> 2], me[u | 0] != (p & 255) | me[m + 241 | 0] != me[u + 1 | 0] | (me[m + 242 | 0] != me[u + 2 | 0] | me[m + 243 | 0] != me[u + 3 | 0]) || me[m + 244 | 0] != me[u + 4 | 0])
                                                                                  break g;
                                                                                if (e[s + 4 >> 2] = A - 5, e[s >> 2] = u + 5, A = e[s >> 2], u = e[s + 4 >> 2], e[5996] = 0, p = m + 240 | 0, G1(148, p | 0, A | 0, u | 0), A = e[5996], e[5996] = 0, (A | 0) == 1)
                                                                                  break h;
                                                                                C: {
                                                                                  y: {
                                                                                    D: {
                                                                                      P: {
                                                                                        q: {
                                                                                          if (me[m + 256 | 0]) {
                                                                                            if (e[5996] = 0, A = m + 332 | 0, ji(149, A | 0, p | 0), u = e[5996], e[5996] = 0, (u | 0) == 1)
                                                                                              break q;
                                                                                            if (e[5996] = 0, u = m + 344 | 0, gs(150, u | 0, 3, A | 0), p = e[5996], e[5996] = 0, (p | 0) == 1)
                                                                                              break P;
                                                                                            if (e[5996] = 0, ji(151, m + 308 | 0, u | 0), p = e[5996], e[5996] = 0, (p | 0) == 1)
                                                                                              break D;
                                                                                            if (Lo(u), ea(A), A = e[m + 252 >> 2] + 1 | 0, e[s + 4 >> 2] = e[s + 4 >> 2] - A, e[s >> 2] = A + e[s >> 2], !me[m + 256 | 0] | _[m + 251 | 0] >= 0)
                                                                                              break u;
                                                                                            Br(e[m + 240 >> 2]);
                                                                                            break u;
                                                                                          }
                                                                                          e[r >> 2] = 0, e[r + 4 >> 2] = 0;
                                                                                          break f;
                                                                                        }
                                                                                        s = Hr() | 0;
                                                                                        break C;
                                                                                      }
                                                                                      s = Hr() | 0;
                                                                                      break y;
                                                                                    }
                                                                                    s = Hr() | 0, Lo(m + 344 | 0);
                                                                                  }
                                                                                  ea(m + 332 | 0);
                                                                                }
                                                                                if (!me[m + 256 | 0] | _[m + 251 | 0] >= 0)
                                                                                  break t;
                                                                                Br(e[m + 240 >> 2]);
                                                                                break t;
                                                                              }
                                                                              s = Hr() | 0;
                                                                              break t;
                                                                            }
                                                                            s = Hr() | 0;
                                                                            break S;
                                                                          }
                                                                          s = Hr() | 0;
                                                                          break t;
                                                                        }
                                                                        s = Hr() | 0;
                                                                        break w;
                                                                      }
                                                                      s = Hr() | 0;
                                                                      break t;
                                                                    }
                                                                    s = Hr() | 0;
                                                                    break t;
                                                                  }
                                                                  e[r >> 2] = 0, e[r + 4 >> 2] = 0;
                                                                  break f;
                                                                }
                                                                Uo(m + 240 | 0), Lo(m + 264 | 0);
                                                              }
                                                              ea(m + 332 | 0);
                                                              break t;
                                                            }
                                                            e[r >> 2] = 0, e[r + 4 >> 2] = 0;
                                                            break f;
                                                          }
                                                          Uo(m + 240 | 0), Lo(m + 264 | 0);
                                                        }
                                                        ea(m + 332 | 0);
                                                        break t;
                                                      }
                                                      e[r >> 2] = 0, e[r + 4 >> 2] = 0;
                                                      break f;
                                                    }
                                                    _[m + 244 | 0] = 0, e[m + 240 >> 2] = 677931888, _[m + 251 | 0] = 4;
                                                  }
                                                  _[m + 245 | 0] = 0, _[m + 244 | 0] = me[5287], _[m + 251 | 0] = 5, e[m + 240 >> 2] = me[5283] | me[5284] << 8 | (me[5285] << 16 | me[5286] << 24);
                                                }
                                                _[m + 245 | 0] = 0, _[m + 244 | 0] = me[5319], _[m + 251 | 0] = 5, e[m + 240 >> 2] = me[5315] | me[5316] << 8 | (me[5317] << 16 | me[5318] << 24);
                                              }
                                              e[5996] = 0, A = pi(30, m + 228 | 0, 5355) | 0, u = e[5996], e[5996] = 0;
                                              g: {
                                                A: {
                                                  p: {
                                                    if ((u | 0) != 1) {
                                                      if (u = Ba(A, s), _[m + 239 | 0] < 0 && Br(e[A >> 2]), !u)
                                                        break g;
                                                      if (A = e[s >> 2], u = e[s + 4 >> 2], e[5996] = 0, q1(m + 240 | 0, A, u, 32), A = e[5996], e[5996] = 0, (A | 0) == 1)
                                                        break p;
                                                      if (me[m + 256 | 0])
                                                        break A;
                                                      e[r >> 2] = 0, e[r + 4 >> 2] = 0;
                                                      break f;
                                                    }
                                                    s = Hr() | 0;
                                                    break t;
                                                  }
                                                  s = Hr() | 0;
                                                  break t;
                                                }
                                                e[5996] = 0, A = m + 332 | 0, gs(153, A | 0, 6, m + 240 | 0), u = e[5996], e[5996] = 0;
                                                A: {
                                                  p: {
                                                    if ((u | 0) != 1) {
                                                      if (e[5996] = 0, ji(151, m + 308 | 0, A | 0), u = e[5996], e[5996] = 0, (u | 0) == 1)
                                                        break p;
                                                      if (Lo(A), A = e[m + 252 >> 2] + 1 | 0, e[s + 4 >> 2] = e[s + 4 >> 2] - A, e[s >> 2] = A + e[s >> 2], !me[m + 256 | 0] || (A = e[m + 240 >> 2], !A))
                                                        break u;
                                                      Br(A);
                                                      break u;
                                                    }
                                                    s = Hr() | 0;
                                                    break A;
                                                  }
                                                  s = Hr() | 0, Lo(m + 332 | 0);
                                                }
                                                if (!me[m + 256 | 0] || (r = e[m + 240 >> 2], !r))
                                                  break t;
                                                Br(r);
                                                break t;
                                              }
                                              e[5996] = 0, A = pi(30, m + 216 | 0, 5372) | 0, u = e[5996], e[5996] = 0;
                                              g: {
                                                A: {
                                                  p: {
                                                    if ((u | 0) != 1) {
                                                      if (u = Ba(A, s), _[m + 227 | 0] < 0 && Br(e[A >> 2]), !u)
                                                        break g;
                                                      if (A = e[s >> 2], u = e[s + 4 >> 2], e[5996] = 0, q1(m + 240 | 0, A, u, 20), A = e[5996], e[5996] = 0, (A | 0) == 1)
                                                        break p;
                                                      if (me[m + 256 | 0])
                                                        break A;
                                                      e[r >> 2] = 0, e[r + 4 >> 2] = 0;
                                                      break f;
                                                    }
                                                    s = Hr() | 0;
                                                    break t;
                                                  }
                                                  s = Hr() | 0;
                                                  break t;
                                                }
                                                e[5996] = 0, A = m + 332 | 0, gs(153, A | 0, 8, m + 240 | 0), u = e[5996], e[5996] = 0;
                                                A: {
                                                  p: {
                                                    if ((u | 0) != 1) {
                                                      if (e[5996] = 0, ji(151, m + 308 | 0, A | 0), u = e[5996], e[5996] = 0, (u | 0) == 1)
                                                        break p;
                                                      if (Lo(A), A = e[m + 252 >> 2] + 1 | 0, e[s + 4 >> 2] = e[s + 4 >> 2] - A, e[s >> 2] = A + e[s >> 2], !me[m + 256 | 0] || (A = e[m + 240 >> 2], !A))
                                                        break u;
                                                      Br(A);
                                                      break u;
                                                    }
                                                    s = Hr() | 0;
                                                    break A;
                                                  }
                                                  s = Hr() | 0, Lo(m + 332 | 0);
                                                }
                                                if (!me[m + 256 | 0] || (r = e[m + 240 >> 2], !r))
                                                  break t;
                                                Br(r);
                                                break t;
                                              }
                                              e[5996] = 0, A = pi(30, m + 204 | 0, 5346) | 0, u = e[5996], e[5996] = 0;
                                              g: {
                                                A: {
                                                  p: {
                                                    if ((u | 0) != 1) {
                                                      if (u = Ba(A, s), _[m + 215 | 0] < 0 && Br(e[A >> 2]), !u)
                                                        break g;
                                                      if (A = e[s >> 2], u = e[s + 4 >> 2], e[5996] = 0, q1(m + 240 | 0, A, u, 32), A = e[5996], e[5996] = 0, (A | 0) == 1)
                                                        break p;
                                                      if (me[m + 256 | 0])
                                                        break A;
                                                      e[r >> 2] = 0, e[r + 4 >> 2] = 0;
                                                      break f;
                                                    }
                                                    s = Hr() | 0;
                                                    break t;
                                                  }
                                                  s = Hr() | 0;
                                                  break t;
                                                }
                                                e[5996] = 0, A = m + 332 | 0, gs(153, A | 0, 7, m + 240 | 0), u = e[5996], e[5996] = 0;
                                                A: {
                                                  p: {
                                                    if ((u | 0) != 1) {
                                                      if (e[5996] = 0, ji(151, m + 308 | 0, A | 0), u = e[5996], e[5996] = 0, (u | 0) == 1)
                                                        break p;
                                                      if (Lo(A), A = e[m + 252 >> 2] + 1 | 0, e[s + 4 >> 2] = e[s + 4 >> 2] - A, e[s >> 2] = A + e[s >> 2], !me[m + 256 | 0] || (A = e[m + 240 >> 2], !A))
                                                        break u;
                                                      Br(A);
                                                      break u;
                                                    }
                                                    s = Hr() | 0;
                                                    break A;
                                                  }
                                                  s = Hr() | 0, Lo(m + 332 | 0);
                                                }
                                                if (!me[m + 256 | 0] || (r = e[m + 240 >> 2], !r))
                                                  break t;
                                                Br(r);
                                                break t;
                                              }
                                              e[5996] = 0, A = pi(30, m + 192 | 0, 5363) | 0, u = e[5996], e[5996] = 0;
                                              g: {
                                                A: {
                                                  p: {
                                                    if ((u | 0) != 1) {
                                                      if (u = Ba(A, s), _[m + 203 | 0] < 0 && Br(e[A >> 2]), !u)
                                                        break g;
                                                      if (A = e[s >> 2], u = e[s + 4 >> 2], e[5996] = 0, q1(m + 240 | 0, A, u, 20), A = e[5996], e[5996] = 0, (A | 0) == 1)
                                                        break p;
                                                      if (me[m + 256 | 0])
                                                        break A;
                                                      e[r >> 2] = 0, e[r + 4 >> 2] = 0;
                                                      break f;
                                                    }
                                                    s = Hr() | 0;
                                                    break t;
                                                  }
                                                  s = Hr() | 0;
                                                  break t;
                                                }
                                                e[5996] = 0, A = m + 332 | 0, gs(153, A | 0, 9, m + 240 | 0), u = e[5996], e[5996] = 0;
                                                A: {
                                                  p: {
                                                    if ((u | 0) != 1) {
                                                      if (e[5996] = 0, ji(151, m + 308 | 0, A | 0), u = e[5996], e[5996] = 0, (u | 0) == 1)
                                                        break p;
                                                      if (Lo(A), A = e[m + 252 >> 2] + 1 | 0, e[s + 4 >> 2] = e[s + 4 >> 2] - A, e[s >> 2] = A + e[s >> 2], !me[m + 256 | 0] || (A = e[m + 240 >> 2], !A))
                                                        break u;
                                                      Br(A);
                                                      break u;
                                                    }
                                                    s = Hr() | 0;
                                                    break A;
                                                  }
                                                  s = Hr() | 0, Lo(m + 332 | 0);
                                                }
                                                if (!me[m + 256 | 0] || (r = e[m + 240 >> 2], !r))
                                                  break t;
                                                Br(r);
                                                break t;
                                              }
                                              e[5996] = 0, A = pi(30, m + 180 | 0, 5258) | 0, u = e[5996], e[5996] = 0;
                                              g: {
                                                A: {
                                                  p: {
                                                    m: {
                                                      k: {
                                                        if ((u | 0) != 1) {
                                                          if (u = Ba(A, s), _[m + 191 | 0] < 0 && Br(e[A >> 2]), !u)
                                                            break m;
                                                          p = e[s + 4 >> 2];
                                                          N: {
                                                            if ((p | 0) <= 0)
                                                              break N;
                                                            for (u = e[s >> 2], A = 0; ; ) {
                                                              if (N = u + A | 0, me[N | 0] != 41) {
                                                                if (A = A + 1 | 0, (p | 0) != (A | 0))
                                                                  continue;
                                                                break N;
                                                              }
                                                              break;
                                                            }
                                                            if (A)
                                                              break k;
                                                          }
                                                          e[r >> 2] = 0, e[r + 4 >> 2] = 0;
                                                          break f;
                                                        }
                                                        s = Hr() | 0;
                                                        break t;
                                                      }
                                                      if (e[5996] = 0, u = xn(154, m + 168 | 0, u | 0, N | 0) | 0, p = e[5996], e[5996] = 0, (p | 0) == 1)
                                                        break A;
                                                      if (p = Dc(u, m + 240 | 0), _[m + 179 | 0] < 0 && Br(e[u >> 2]), !p || (p = e[m + 244 >> 2], N = p, u = e[m + 240 >> 2], W = u - -2147483648 | 0, p = p - (u >>> 0 < 2147483648) | 0, (p | 0) == -1 & W >>> 0 < 2147483649 | (p | 0) != -1))
                                                        break p;
                                                      e[5996] = 0, p = m + 332 | 0, c6(p, 5, u, N), u = e[5996], e[5996] = 0;
                                                      k: {
                                                        if ((u | 0) != 1) {
                                                          if (e[5996] = 0, ji(151, m + 308 | 0, p | 0), u = e[5996], e[5996] = 0, (u | 0) == 1)
                                                            break k;
                                                          Lo(p), A = A + 1 | 0, e[s + 4 >> 2] = e[s + 4 >> 2] - A, e[s >> 2] = A + e[s >> 2];
                                                          break u;
                                                        }
                                                        s = Hr() | 0;
                                                        break t;
                                                      }
                                                      s = Hr() | 0, Lo(m + 332 | 0);
                                                      break t;
                                                    }
                                                    e[5996] = 0, A = pi(30, m + 156 | 0, 5265) | 0, u = e[5996], e[5996] = 0;
                                                    m: {
                                                      k: {
                                                        N: {
                                                          S: {
                                                            if ((u | 0) != 1) {
                                                              if (u = Ba(A, s), _[m + 167 | 0] < 0 && Br(e[A >> 2]), !u)
                                                                break N;
                                                              p = e[s + 4 >> 2];
                                                              T: {
                                                                if ((p | 0) <= 0)
                                                                  break T;
                                                                for (u = e[s >> 2], A = 0; ; ) {
                                                                  if (N = u + A | 0, me[N | 0] != 41) {
                                                                    if (A = A + 1 | 0, (p | 0) != (A | 0))
                                                                      continue;
                                                                    break T;
                                                                  }
                                                                  break;
                                                                }
                                                                if (A)
                                                                  break S;
                                                              }
                                                              e[r >> 2] = 0, e[r + 4 >> 2] = 0;
                                                              break f;
                                                            }
                                                            s = Hr() | 0;
                                                            break t;
                                                          }
                                                          if (e[5996] = 0, u = xn(154, m + 144 | 0, u | 0, N | 0) | 0, p = e[5996], e[5996] = 0, (p | 0) == 1)
                                                            break m;
                                                          if (p = Dc(u, m + 240 | 0), _[m + 155 | 0] < 0 && Br(e[u >> 2]), !p || (p = e[m + 244 >> 2], N = p, u = e[m + 240 >> 2], W = u - -2147483648 | 0, p = p - (u >>> 0 < 2147483648) | 0, (p | 0) == -1 & W >>> 0 < 2147483649 | (p | 0) != -1))
                                                            break k;
                                                          e[5996] = 0, p = m + 332 | 0, c6(p, 4, u, N), u = e[5996], e[5996] = 0;
                                                          S: {
                                                            if ((u | 0) != 1) {
                                                              if (e[5996] = 0, ji(151, m + 308 | 0, p | 0), u = e[5996], e[5996] = 0, (u | 0) == 1)
                                                                break S;
                                                              Lo(p), A = A + 1 | 0, e[s + 4 >> 2] = e[s + 4 >> 2] - A, e[s >> 2] = A + e[s >> 2];
                                                              break u;
                                                            }
                                                            s = Hr() | 0;
                                                            break t;
                                                          }
                                                          s = Hr() | 0, Lo(m + 332 | 0);
                                                          break t;
                                                        }
                                                        e[5996] = 0, A = pi(30, m + 132 | 0, 5289) | 0, u = e[5996], e[5996] = 0;
                                                        N: {
                                                          if ((u | 0) != 1) {
                                                            if (u = Ba(A, s), _[m + 143 | 0] < 0 && Br(e[A >> 2]), !u)
                                                              break g;
                                                            p = e[s + 4 >> 2];
                                                            S: {
                                                              if ((p | 0) <= 0)
                                                                break S;
                                                              for (u = e[s >> 2], A = 0; ; ) {
                                                                if (N = u + A | 0, W = me[N | 0], (W | 0) != 44) {
                                                                  if ((W | 0) == 41)
                                                                    break S;
                                                                  if (A = A + 1 | 0, (p | 0) > (A | 0))
                                                                    continue;
                                                                  break S;
                                                                }
                                                                break;
                                                              }
                                                              if (A)
                                                                break N;
                                                            }
                                                            e[r >> 2] = 0, e[r + 4 >> 2] = 0;
                                                            break f;
                                                          }
                                                          s = Hr() | 0;
                                                          break t;
                                                        }
                                                        e[5996] = 0, u = xn(154, m + 120 | 0, u | 0, N | 0) | 0, p = e[5996], e[5996] = 0;
                                                        N: {
                                                          if ((p | 0) != 1) {
                                                            if (p = Dc(u, vr), _[m + 131 | 0] < 0 && Br(e[u >> 2]), p)
                                                              break N;
                                                            e[r >> 2] = 0, e[r + 4 >> 2] = 0;
                                                            break f;
                                                          }
                                                          s = Hr() | 0;
                                                          break t;
                                                        }
                                                        A = A + 1 | 0, ar = e[s + 4 >> 2] - A | 0, e[s + 4 >> 2] = ar, p = A + e[s >> 2] | 0, e[s >> 2] = p, e[m + 340 >> 2] = 0, e[m + 332 >> 2] = 0, e[m + 336 >> 2] = 0;
                                                        N: {
                                                          S: {
                                                            T: {
                                                              v: {
                                                                w: {
                                                                  E: {
                                                                    for (; ; ) {
                                                                      if (A = 0, N = (ar | 0) <= 0, N)
                                                                        break v;
                                                                      h: {
                                                                        for (; ; ) {
                                                                          if (u = me[A + p | 0], (u | 0) == 44) {
                                                                            u = A;
                                                                            break h;
                                                                          }
                                                                          if (!((u | 0) != 41 && (A = A + 1 | 0, (ar | 0) > (A | 0))))
                                                                            break;
                                                                        }
                                                                        if (u = 0, N)
                                                                          break v;
                                                                        for (; ; ) {
                                                                          if (me[u + p | 0] == 41) {
                                                                            A = -1;
                                                                            break h;
                                                                          }
                                                                          if (u = u + 1 | 0, (ar | 0) == (u | 0))
                                                                            break;
                                                                        }
                                                                        break v;
                                                                      }
                                                                      if ((u | 0) <= 0)
                                                                        break v;
                                                                      if (e[5996] = 0, gs(156, m + 240 | 0, p | 0, u + p | 0), p = e[5996], e[5996] = 0, (p | 0) == 1)
                                                                        break N;
                                                                      if (!me[m + 252 | 0])
                                                                        break v;
                                                                      p = e[m + 336 >> 2];
                                                                      h: {
                                                                        if (p >>> 0 < Ls[m + 340 >> 2]) {
                                                                          N = e[m + 244 >> 2], e[p >> 2] = e[m + 240 >> 2], e[p + 4 >> 2] = N, e[p + 8 >> 2] = e[m + 248 >> 2], e[m + 248 >> 2] = 0, e[m + 240 >> 2] = 0, e[m + 244 >> 2] = 0, e[m + 336 >> 2] = p + 12, ar = 1, N = 0;
                                                                          break h;
                                                                        }
                                                                        if (e[5996] = 0, ji(157, m + 332 | 0, m + 240 | 0), p = e[5996], e[5996] = 0, (p | 0) == 1)
                                                                          break E;
                                                                        ar = me[m + 252 | 0], N = me[m + 251 | 0];
                                                                      }
                                                                      if (u = u + 1 | 0, e[s + 4 >> 2] = e[s + 4 >> 2] - u, p = u + e[s >> 2] | 0, e[s >> 2] = p, !(ar & 255) | N << 24 >> 24 >= 0 || (Br(e[m + 240 >> 2]), p = e[s >> 2]), (A | 0) != -1) {
                                                                        ar = e[s + 4 >> 2];
                                                                        continue;
                                                                      }
                                                                      break;
                                                                    }
                                                                    if (A = e[m + 336 >> 2], u = e[m + 332 >> 2], p = (A - u | 0) / 12 | 0, (u | 0) != (A | 0) & p >>> 0 < 21)
                                                                      break w;
                                                                    break v;
                                                                  }
                                                                  if (s = Hr() | 0, !me[m + 252 | 0] | _[m + 251 | 0] >= 0)
                                                                    break r;
                                                                  Br(e[m + 240 >> 2]);
                                                                  break r;
                                                                }
                                                                if (A = e[m + 296 >> 2], u = e[m + 300 >> 2], !((!!A & (u | 0) >= 0 | (u | 0) > 0) & (!u & A >>> 0 <= p >>> 0)))
                                                                  break v;
                                                                if (e[5996] = 0, p = m + 240 | 0, N = m + 332 | 0, ih(158, p | 0, 25, N | 0, A | 0, u | 0), A = e[5996], e[5996] = 0, (A | 0) == 1)
                                                                  break T;
                                                                if (e[5996] = 0, ji(151, m + 308 | 0, p | 0), A = e[5996], e[5996] = 0, (A | 0) == 1)
                                                                  break S;
                                                                Lo(p), ea(N);
                                                                break u;
                                                              }
                                                              e[r >> 2] = 0, e[r + 4 >> 2] = 0, ea(m + 332 | 0);
                                                              break f;
                                                            }
                                                            s = Hr() | 0;
                                                            break r;
                                                          }
                                                          s = Hr() | 0, Lo(m + 240 | 0);
                                                          break r;
                                                        }
                                                        s = Hr() | 0;
                                                        break r;
                                                      }
                                                      e[r >> 2] = 0, e[r + 4 >> 2] = 0;
                                                      break f;
                                                    }
                                                    s = Hr() | 0;
                                                    break t;
                                                  }
                                                  e[r >> 2] = 0, e[r + 4 >> 2] = 0;
                                                  break f;
                                                }
                                                s = Hr() | 0;
                                                break t;
                                              }
                                              e[5996] = 0, A = pi(30, m + 108 | 0, 5302) | 0, u = e[5996], e[5996] = 0;
                                              g: {
                                                A: {
                                                  if ((u | 0) != 1) {
                                                    if (u = Ba(A, s), _[m + 119 | 0] < 0 && Br(e[A >> 2]), !u)
                                                      break g;
                                                    p = e[s + 4 >> 2];
                                                    p: {
                                                      if ((p | 0) <= 0)
                                                        break p;
                                                      for (u = e[s >> 2], A = 0; ; ) {
                                                        if (N = u + A | 0, W = me[N | 0], (W | 0) != 44) {
                                                          if ((W | 0) == 41)
                                                            break p;
                                                          if (A = A + 1 | 0, (p | 0) > (A | 0))
                                                            continue;
                                                          break p;
                                                        }
                                                        break;
                                                      }
                                                      if (A)
                                                        break A;
                                                    }
                                                    e[r >> 2] = 0, e[r + 4 >> 2] = 0;
                                                    break f;
                                                  }
                                                  s = Hr() | 0;
                                                  break t;
                                                }
                                                e[5996] = 0, u = xn(154, m + 96 | 0, u | 0, N | 0) | 0, p = e[5996], e[5996] = 0;
                                                A: {
                                                  if ((p | 0) != 1) {
                                                    if (p = Dc(u, vr), _[m + 107 | 0] < 0 && Br(e[u >> 2]), p)
                                                      break A;
                                                    e[r >> 2] = 0, e[r + 4 >> 2] = 0;
                                                    break f;
                                                  }
                                                  s = Hr() | 0;
                                                  break t;
                                                }
                                                if (u = e[m + 300 >> 2], !e[m + 296 >> 2] & (u | 0) <= 0 | (u | 0) < 0) {
                                                  e[r >> 2] = 0, e[r + 4 >> 2] = 0;
                                                  break f;
                                                }
                                                if (A = A + 1 | 0, e[s + 4 >> 2] = e[s + 4 >> 2] - A, e[s >> 2] = A + e[s >> 2], e[5996] = 0, A = m + 320 | 0, Vs(159, A | 0, 19, 1, vr | 0), u = e[5996], e[5996] = 0, (u | 0) == 1)
                                                  break d;
                                                if (e[5996] = 0, Vs(160, A | 0, 0, -1, -1), A = e[5996], e[5996] = 0, (A | 0) != 1)
                                                  break u;
                                                s = Hr() | 0;
                                                break t;
                                              }
                                              e[5996] = 0, A = pi(30, m + 84 | 0, 5251) | 0, u = e[5996], e[5996] = 0;
                                              g: {
                                                A: {
                                                  p: {
                                                    m: {
                                                      k: {
                                                        N: {
                                                          S: {
                                                            if ((u | 0) != 1) {
                                                              if (u = Ba(A, s), _[m + 95 | 0] < 0 && Br(e[A >> 2]), !u)
                                                                break g;
                                                              if (e[5996] = 0, A = m + 320 | 0, Vs(160, A | 0, 14, -1, -1), u = e[5996], e[5996] = 0, (u | 0) == 1)
                                                                break S;
                                                              if (e[5996] = 0, Vs(160, A | 0, 21, -1, -1), u = e[5996], e[5996] = 0, (u | 0) == 1)
                                                                break N;
                                                              if (e[5996] = 0, Vs(160, A | 0, 0, -1, -1), u = e[5996], e[5996] = 0, (u | 0) == 1)
                                                                break k;
                                                              if (e[5996] = 0, Vs(160, A | 0, 20, -1, -1), u = e[5996], e[5996] = 0, (u | 0) == 1)
                                                                break m;
                                                              if (e[5996] = 0, Vs(160, A | 0, 0, -1, -1), u = e[5996], e[5996] = 0, (u | 0) == 1)
                                                                break p;
                                                              if (e[5996] = 0, Vs(160, A | 0, 20, -1, -1), u = e[5996], e[5996] = 0, (u | 0) == 1)
                                                                break A;
                                                              if (e[5996] = 0, Vs(160, A | 0, 0, -1, -1), A = e[5996], e[5996] = 0, (A | 0) != 1)
                                                                break u;
                                                              s = Hr() | 0;
                                                              break t;
                                                            }
                                                            s = Hr() | 0;
                                                            break t;
                                                          }
                                                          s = Hr() | 0;
                                                          break t;
                                                        }
                                                        s = Hr() | 0;
                                                        break t;
                                                      }
                                                      s = Hr() | 0;
                                                      break t;
                                                    }
                                                    s = Hr() | 0;
                                                    break t;
                                                  }
                                                  s = Hr() | 0;
                                                  break t;
                                                }
                                                s = Hr() | 0;
                                                break t;
                                              }
                                              if (e[5996] = 0, A = pi(30, m + 72 | 0, 5272) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1)
                                                break c;
                                              u = Ba(A, s), _[m + 83 | 0] < 0 && Br(e[A >> 2]);
                                              g: {
                                                if (u) {
                                                  if (e[5996] = 0, Vs(160, m + 320 | 0, 11, -1, -1), A = e[5996], e[5996] = 0, (A | 0) != 1)
                                                    break g;
                                                  s = Hr() | 0;
                                                  break t;
                                                }
                                                if (e[5996] = 0, A = pi(30, m + 60 | 0, 5339) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1)
                                                  break l;
                                                if (u = Ba(A, s), _[m + 71 | 0] < 0 && Br(e[A >> 2]), u) {
                                                  if (e[5996] = 0, Vs(160, m + 320 | 0, 13, -1, -1), A = e[5996], e[5996] = 0, (A | 0) != 1)
                                                    break g;
                                                  s = Hr() | 0;
                                                  break t;
                                                }
                                                if (e[5996] = 0, A = pi(30, m + 48 | 0, 5244) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1)
                                                  break o;
                                                if (u = Ba(A, s), _[m + 59 | 0] < 0 && Br(e[A >> 2]), u) {
                                                  if (e[5996] = 0, Vs(160, m + 320 | 0, 12, -1, -1), A = e[5996], e[5996] = 0, (A | 0) != 1)
                                                    break g;
                                                  s = Hr() | 0;
                                                  break t;
                                                }
                                                if (e[5996] = 0, A = pi(30, m + 36 | 0, 5333) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1)
                                                  break a;
                                                if (u = Ba(A, s), _[m + 47 | 0] < 0 && Br(e[A >> 2]), u) {
                                                  if (e[5996] = 0, Vs(160, m + 320 | 0, 15, -1, -1), A = e[5996], e[5996] = 0, (A | 0) != 1)
                                                    break g;
                                                  s = Hr() | 0;
                                                  break t;
                                                }
                                                if (e[5996] = 0, A = pi(30, m + 24 | 0, 5327) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1)
                                                  break s;
                                                if (u = Ba(A, s), _[m + 35 | 0] < 0 && Br(e[A >> 2]), u) {
                                                  if (e[5996] = 0, Vs(160, m + 320 | 0, 16, -1, -1), A = e[5996], e[5996] = 0, (A | 0) != 1)
                                                    break g;
                                                  s = Hr() | 0;
                                                  break t;
                                                }
                                                if (e[5996] = 0, A = pi(30, m + 12 | 0, 5321) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1)
                                                  break n;
                                                if (u = Ba(A, s), _[m + 23 | 0] < 0 && Br(e[A >> 2]), u) {
                                                  if (e[5996] = 0, Vs(160, m + 320 | 0, 17, -1, -1), A = e[5996], e[5996] = 0, (A | 0) != 1)
                                                    break g;
                                                  s = Hr() | 0;
                                                  break t;
                                                }
                                                if (e[5996] = 0, A = pi(30, m | 0, 5296) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1)
                                                  break i;
                                                if (u = Ba(A, s), _[m + 11 | 0] < 0 && Br(e[A >> 2]), u) {
                                                  if (e[5996] = 0, Vs(160, m + 320 | 0, 18, -1, -1), A = e[5996], e[5996] = 0, (A | 0) != 1)
                                                    break g;
                                                  s = Hr() | 0;
                                                  break t;
                                                }
                                                e[r >> 2] = 0, e[r + 4 >> 2] = 0;
                                                break f;
                                              }
                                              e[5996] = 0, A = m + 320 | 0, Vs(160, A | 0, 21, -1, -1), u = e[5996], e[5996] = 0;
                                              g: {
                                                A: {
                                                  if ((u | 0) != 1) {
                                                    if (e[5996] = 0, Vs(160, A | 0, 0, -1, -1), u = e[5996], e[5996] = 0, (u | 0) == 1)
                                                      break A;
                                                    if (e[5996] = 0, Vs(160, A | 0, 20, -1, -1), u = e[5996], e[5996] = 0, (u | 0) == 1)
                                                      break g;
                                                    if (e[5996] = 0, Vs(160, A | 0, 0, -1, -1), A = e[5996], e[5996] = 0, (A | 0) != 1)
                                                      break u;
                                                    s = Hr() | 0;
                                                    break t;
                                                  }
                                                  s = Hr() | 0;
                                                  break t;
                                                }
                                                s = Hr() | 0;
                                                break t;
                                              }
                                              s = Hr() | 0;
                                              break t;
                                            }
                                            if (u = e[m + 324 >> 2], p = e[m + 320 >> 2], (u | 0) == (p | 0))
                                              break;
                                          }
                                          if (A = e[m + 308 >> 2], (e[m + 312 >> 2] - A | 0) != 8) {
                                            if (e[5996] = 0, Vs(44, 4122, 2210, 1561, 2344), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                              break e;
                                            s = Hr() | 0;
                                            break t;
                                          }
                                          if (e[s + 4 >> 2]) {
                                            e[r >> 2] = 0, e[r + 4 >> 2] = 0;
                                            break f;
                                          }
                                          e[r >> 2] = e[A >> 2], e[r + 4 >> 2] = e[A + 4 >> 2], e[A >> 2] = 0, e[A + 4 >> 2] = 0;
                                        }
                                        if (r = e[m + 308 >> 2], r) {
                                          if (A = e[m + 312 >> 2], (r | 0) != (A | 0)) {
                                            for (; ; ) {
                                              A = A - 8 | 0, s = e[A + 4 >> 2];
                                              f: {
                                                if (!s || (u = e[s + 4 >> 2], e[s + 4 >> 2] = u - 1, u))
                                                  break f;
                                                xi[e[e[s >> 2] + 8 >> 2]](s), ys(s);
                                              }
                                              if ((r | 0) == (A | 0))
                                                break;
                                            }
                                            r = e[m + 308 >> 2];
                                          }
                                          Br(r);
                                        }
                                        r = e[m + 320 >> 2], r && (e[m + 324 >> 2] = r, Br(r)), Jr = m + 352 | 0;
                                        return;
                                      }
                                      s = Hr() | 0;
                                      break t;
                                    }
                                    s = Hr() | 0;
                                    break t;
                                  }
                                  s = Hr() | 0;
                                  break t;
                                }
                                s = Hr() | 0;
                                break t;
                              }
                              s = Hr() | 0;
                              break t;
                            }
                            s = Hr() | 0;
                            break t;
                          }
                          s = Hr() | 0;
                          break t;
                        }
                        s = Hr() | 0;
                        break t;
                      }
                      s = Hr() | 0;
                      break t;
                    }
                    ea(m + 332 | 0);
                  }
                  Uo(m + 308 | 0), r = e[m + 320 >> 2], r && (e[m + 324 >> 2] = r, Br(r)), Jn(s | 0), Oi();
                }
                Oi();
              }
              function z1(r, s, u, A, m) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0, m = m | 0;
                var p = 0, N = 0, W = 0, Te = 0, Xe = 0, fr = 0;
                p = Jr - 128 | 0, Jr = p, _[p + 127 | 0] = s, N = p + 116 | 0, so(N, s ? 3764 : 5575, s), _[s | N] = 0;
                e: {
                  t: {
                    r: {
                      i: {
                        n: {
                          s: {
                            a: {
                              o: {
                                l: {
                                  c: {
                                    d: {
                                      f: {
                                        u: {
                                          g: {
                                            A: {
                                              p: {
                                                m: {
                                                  k: {
                                                    N: {
                                                      S: {
                                                        T: {
                                                          v: {
                                                            w: {
                                                              E: {
                                                                h: {
                                                                  R: {
                                                                    I: {
                                                                      B: {
                                                                        x: {
                                                                          b:
                                                                            switch (e[u >> 2]) {
                                                                              case 10:
                                                                                if (e[5996] = 0, s = xn(99, A | 0, 0, 2553) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1)
                                                                                  break T;
                                                                                A = e[s >> 2], e[p + 96 >> 2] = e[s + 4 >> 2], u = me[s + 7 | 0] | me[s + 8 | 0] << 8 | (me[s + 9 | 0] << 16 | me[s + 10 | 0] << 24), _[p + 99 | 0] = u, _[p + 100 | 0] = u >>> 8, _[p + 101 | 0] = u >>> 16, _[p + 102 | 0] = u >>> 24, e[s >> 2] = 0, e[s + 4 >> 2] = 0, u = me[s + 11 | 0], e[s + 8 >> 2] = 0, e[r >> 2] = A, e[r + 4 >> 2] = e[p + 96 >> 2], s = me[p + 99 | 0] | me[p + 100 | 0] << 8 | (me[p + 101 | 0] << 16 | me[p + 102 | 0] << 24), _[r + 7 | 0] = s, _[r + 8 | 0] = s >>> 8, _[r + 9 | 0] = s >>> 16, _[r + 10 | 0] = s >>> 24, _[r + 12 | 0] = 1, _[r + 11 | 0] = u;
                                                                                break t;
                                                                              case 11:
                                                                                if (e[5996] = 0, s = xn(99, A | 0, 0, 1681) | 0, u = e[5996], e[5996] = 0, (u | 0) != 1) {
                                                                                  A = e[s >> 2], e[p + 96 >> 2] = e[s + 4 >> 2], u = me[s + 7 | 0] | me[s + 8 | 0] << 8 | (me[s + 9 | 0] << 16 | me[s + 10 | 0] << 24), _[p + 99 | 0] = u, _[p + 100 | 0] = u >>> 8, _[p + 101 | 0] = u >>> 16, _[p + 102 | 0] = u >>> 24, e[s >> 2] = 0, e[s + 4 >> 2] = 0, u = me[s + 11 | 0], e[s + 8 >> 2] = 0, e[r >> 2] = A, e[r + 4 >> 2] = e[p + 96 >> 2], s = me[p + 99 | 0] | me[p + 100 | 0] << 8 | (me[p + 101 | 0] << 16 | me[p + 102 | 0] << 24), _[r + 7 | 0] = s, _[r + 8 | 0] = s >>> 8, _[r + 9 | 0] = s >>> 16, _[r + 10 | 0] = s >>> 24, _[r + 12 | 0] = 1, _[r + 11 | 0] = u;
                                                                                  break t;
                                                                                }
                                                                                r = Hr() | 0;
                                                                                break e;
                                                                              case 12:
                                                                                C: {
                                                                                  y: {
                                                                                    D:
                                                                                      switch (s = e[e[u + 32 >> 2] >> 2], e[s >> 2] - 2 | 0) {
                                                                                        case 1:
                                                                                          break y;
                                                                                        case 0:
                                                                                          break D;
                                                                                        default:
                                                                                          break C;
                                                                                      }
                                                                                    if (s = e[s + 8 >> 2], _[s + 11 | 0] >= 0) {
                                                                                      e[p + 104 >> 2] = e[s + 8 >> 2], u = e[s + 4 >> 2], e[p + 96 >> 2] = e[s >> 2], e[p + 100 >> 2] = u;
                                                                                      break r;
                                                                                    }
                                                                                    if (u = e[s + 4 >> 2], s = e[s >> 2], e[5996] = 0, gs(40, p + 96 | 0, s | 0, u | 0), s = e[5996], e[5996] = 0, (s | 0) != 1)
                                                                                      break r;
                                                                                    r = Hr() | 0;
                                                                                    break e;
                                                                                  }
                                                                                  if (s = e[s + 8 >> 2], _[s + 11 | 0] >= 0) {
                                                                                    e[p + 104 >> 2] = e[s + 8 >> 2], u = e[s + 4 >> 2], e[p + 96 >> 2] = e[s >> 2], e[p + 100 >> 2] = u;
                                                                                    break i;
                                                                                  }
                                                                                  if (u = e[s + 4 >> 2], s = e[s >> 2], e[5996] = 0, gs(40, p + 96 | 0, s | 0, u | 0), s = e[5996], e[5996] = 0, (s | 0) != 1)
                                                                                    break i;
                                                                                  r = Hr() | 0;
                                                                                  break e;
                                                                                }
                                                                                if (e[5996] = 0, s = xn(99, A | 0, 0, 2541) | 0, u = e[5996], e[5996] = 0, (u | 0) != 1) {
                                                                                  A = e[s >> 2], e[p + 96 >> 2] = e[s + 4 >> 2], u = me[s + 7 | 0] | me[s + 8 | 0] << 8 | (me[s + 9 | 0] << 16 | me[s + 10 | 0] << 24), _[p + 99 | 0] = u, _[p + 100 | 0] = u >>> 8, _[p + 101 | 0] = u >>> 16, _[p + 102 | 0] = u >>> 24, e[s >> 2] = 0, e[s + 4 >> 2] = 0, u = me[s + 11 | 0], e[s + 8 >> 2] = 0, e[r >> 2] = A, e[r + 4 >> 2] = e[p + 96 >> 2], s = me[p + 99 | 0] | me[p + 100 | 0] << 8 | (me[p + 101 | 0] << 16 | me[p + 102 | 0] << 24), _[r + 7 | 0] = s, _[r + 8 | 0] = s >>> 8, _[r + 9 | 0] = s >>> 16, _[r + 10 | 0] = s >>> 24, _[r + 12 | 0] = 1, _[r + 11 | 0] = u;
                                                                                  break t;
                                                                                }
                                                                                r = Hr() | 0;
                                                                                break e;
                                                                              case 13:
                                                                                if (e[5996] = 0, s = xn(99, A | 0, 0, 2522) | 0, u = e[5996], e[5996] = 0, (u | 0) != 1) {
                                                                                  A = e[s >> 2], e[p + 96 >> 2] = e[s + 4 >> 2], u = me[s + 7 | 0] | me[s + 8 | 0] << 8 | (me[s + 9 | 0] << 16 | me[s + 10 | 0] << 24), _[p + 99 | 0] = u, _[p + 100 | 0] = u >>> 8, _[p + 101 | 0] = u >>> 16, _[p + 102 | 0] = u >>> 24, e[s >> 2] = 0, e[s + 4 >> 2] = 0, u = me[s + 11 | 0], e[s + 8 >> 2] = 0, e[r >> 2] = A, e[r + 4 >> 2] = e[p + 96 >> 2], s = me[p + 99 | 0] | me[p + 100 | 0] << 8 | (me[p + 101 | 0] << 16 | me[p + 102 | 0] << 24), _[r + 7 | 0] = s, _[r + 8 | 0] = s >>> 8, _[r + 9 | 0] = s >>> 16, _[r + 10 | 0] = s >>> 24, _[r + 12 | 0] = 1, _[r + 11 | 0] = u;
                                                                                  break t;
                                                                                }
                                                                                r = Hr() | 0;
                                                                                break e;
                                                                              case 14:
                                                                                if (e[5996] = 0, s = xn(99, A | 0, 0, 1271) | 0, u = e[5996], e[5996] = 0, (u | 0) != 1) {
                                                                                  A = e[s >> 2], e[p + 96 >> 2] = e[s + 4 >> 2], u = me[s + 7 | 0] | me[s + 8 | 0] << 8 | (me[s + 9 | 0] << 16 | me[s + 10 | 0] << 24), _[p + 99 | 0] = u, _[p + 100 | 0] = u >>> 8, _[p + 101 | 0] = u >>> 16, _[p + 102 | 0] = u >>> 24, e[s >> 2] = 0, e[s + 4 >> 2] = 0, u = me[s + 11 | 0], e[s + 8 >> 2] = 0, e[r >> 2] = A, e[r + 4 >> 2] = e[p + 96 >> 2], s = me[p + 99 | 0] | me[p + 100 | 0] << 8 | (me[p + 101 | 0] << 16 | me[p + 102 | 0] << 24), _[r + 7 | 0] = s, _[r + 8 | 0] = s >>> 8, _[r + 9 | 0] = s >>> 16, _[r + 10 | 0] = s >>> 24, _[r + 12 | 0] = 1, _[r + 11 | 0] = u;
                                                                                  break t;
                                                                                }
                                                                                r = Hr() | 0;
                                                                                break e;
                                                                              case 15:
                                                                                if (e[5996] = 0, s = xn(99, A | 0, 0, 2170) | 0, u = e[5996], e[5996] = 0, (u | 0) != 1) {
                                                                                  A = e[s >> 2], e[p + 96 >> 2] = e[s + 4 >> 2], u = me[s + 7 | 0] | me[s + 8 | 0] << 8 | (me[s + 9 | 0] << 16 | me[s + 10 | 0] << 24), _[p + 99 | 0] = u, _[p + 100 | 0] = u >>> 8, _[p + 101 | 0] = u >>> 16, _[p + 102 | 0] = u >>> 24, e[s >> 2] = 0, e[s + 4 >> 2] = 0, u = me[s + 11 | 0], e[s + 8 >> 2] = 0, e[r >> 2] = A, e[r + 4 >> 2] = e[p + 96 >> 2], s = me[p + 99 | 0] | me[p + 100 | 0] << 8 | (me[p + 101 | 0] << 16 | me[p + 102 | 0] << 24), _[r + 7 | 0] = s, _[r + 8 | 0] = s >>> 8, _[r + 9 | 0] = s >>> 16, _[r + 10 | 0] = s >>> 24, _[r + 12 | 0] = 1, _[r + 11 | 0] = u;
                                                                                  break t;
                                                                                }
                                                                                r = Hr() | 0;
                                                                                break e;
                                                                              case 16:
                                                                                if (e[5996] = 0, s = xn(99, A | 0, 0, 2029) | 0, u = e[5996], e[5996] = 0, (u | 0) != 1) {
                                                                                  A = e[s >> 2], e[p + 96 >> 2] = e[s + 4 >> 2], u = me[s + 7 | 0] | me[s + 8 | 0] << 8 | (me[s + 9 | 0] << 16 | me[s + 10 | 0] << 24), _[p + 99 | 0] = u, _[p + 100 | 0] = u >>> 8, _[p + 101 | 0] = u >>> 16, _[p + 102 | 0] = u >>> 24, e[s >> 2] = 0, e[s + 4 >> 2] = 0, u = me[s + 11 | 0], e[s + 8 >> 2] = 0, e[r >> 2] = A, e[r + 4 >> 2] = e[p + 96 >> 2], s = me[p + 99 | 0] | me[p + 100 | 0] << 8 | (me[p + 101 | 0] << 16 | me[p + 102 | 0] << 24), _[r + 7 | 0] = s, _[r + 8 | 0] = s >>> 8, _[r + 9 | 0] = s >>> 16, _[r + 10 | 0] = s >>> 24, _[r + 12 | 0] = 1, _[r + 11 | 0] = u;
                                                                                  break t;
                                                                                }
                                                                                r = Hr() | 0;
                                                                                break e;
                                                                              case 17:
                                                                                if (e[e[e[u + 32 >> 2] + 8 >> 2] >> 2] != 1)
                                                                                  break x;
                                                                                if (e[5996] = 0, s = xn(99, A | 0, 0, 1392) | 0, u = e[5996], e[5996] = 0, (u | 0) != 1) {
                                                                                  A = e[s >> 2], e[p + 96 >> 2] = e[s + 4 >> 2], u = me[s + 7 | 0] | me[s + 8 | 0] << 8 | (me[s + 9 | 0] << 16 | me[s + 10 | 0] << 24), _[p + 99 | 0] = u, _[p + 100 | 0] = u >>> 8, _[p + 101 | 0] = u >>> 16, _[p + 102 | 0] = u >>> 24, e[s >> 2] = 0, e[s + 4 >> 2] = 0, u = me[s + 11 | 0], e[s + 8 >> 2] = 0, e[r >> 2] = A, e[r + 4 >> 2] = e[p + 96 >> 2], s = me[p + 99 | 0] | me[p + 100 | 0] << 8 | (me[p + 101 | 0] << 16 | me[p + 102 | 0] << 24), _[r + 7 | 0] = s, _[r + 8 | 0] = s >>> 8, _[r + 9 | 0] = s >>> 16, _[r + 10 | 0] = s >>> 24, _[r + 12 | 0] = 1, _[r + 11 | 0] = u;
                                                                                  break t;
                                                                                }
                                                                                r = Hr() | 0;
                                                                                break e;
                                                                              case 22:
                                                                                if (s = e[u + 32 >> 2], !e[e[s >> 2] >> 2]) {
                                                                                  if (e[5996] = 0, s = xn(99, A + 12 | 0, 0, 2096) | 0, u = e[5996], e[5996] = 0, (u | 0) != 1) {
                                                                                    m = e[s >> 2], u = me[A + 19 | 0] | me[A + 20 | 0] << 8 | (me[A + 21 | 0] << 16 | me[A + 22 | 0] << 24), _[p + 99 | 0] = u, _[p + 100 | 0] = u >>> 8, _[p + 101 | 0] = u >>> 16, _[p + 102 | 0] = u >>> 24, e[p + 96 >> 2] = e[A + 16 >> 2], u = me[A + 23 | 0], e[s + 8 >> 2] = 0, e[s >> 2] = 0, e[s + 4 >> 2] = 0, e[r >> 2] = m, e[r + 4 >> 2] = e[p + 96 >> 2], s = me[p + 99 | 0] | me[p + 100 | 0] << 8 | (me[p + 101 | 0] << 16 | me[p + 102 | 0] << 24), _[r + 7 | 0] = s, _[r + 8 | 0] = s >>> 8, _[r + 9 | 0] = s >>> 16, _[r + 10 | 0] = s >>> 24, _[r + 12 | 0] = 1, _[r + 11 | 0] = u;
                                                                                    break t;
                                                                                  }
                                                                                  r = Hr() | 0;
                                                                                  break e;
                                                                                }
                                                                                if (e[e[s + 8 >> 2] >> 2])
                                                                                  break E;
                                                                                if (e[5996] = 0, s = xn(99, A | 0, 0, 1295) | 0, u = e[5996], e[5996] = 0, (u | 0) != 1) {
                                                                                  A = e[s >> 2], e[p + 96 >> 2] = e[s + 4 >> 2], u = me[s + 7 | 0] | me[s + 8 | 0] << 8 | (me[s + 9 | 0] << 16 | me[s + 10 | 0] << 24), _[p + 99 | 0] = u, _[p + 100 | 0] = u >>> 8, _[p + 101 | 0] = u >>> 16, _[p + 102 | 0] = u >>> 24, e[s >> 2] = 0, e[s + 4 >> 2] = 0, u = me[s + 11 | 0], e[s + 8 >> 2] = 0, e[r >> 2] = A, e[r + 4 >> 2] = e[p + 96 >> 2], s = me[p + 99 | 0] | me[p + 100 | 0] << 8 | (me[p + 101 | 0] << 16 | me[p + 102 | 0] << 24), _[r + 7 | 0] = s, _[r + 8 | 0] = s >>> 8, _[r + 9 | 0] = s >>> 16, _[r + 10 | 0] = s >>> 24, _[r + 12 | 0] = 1, _[r + 11 | 0] = u;
                                                                                  break t;
                                                                                }
                                                                                r = Hr() | 0;
                                                                                break e;
                                                                              case 2:
                                                                                if (s = e[u + 8 >> 2], _[s + 11 | 0] >= 0) {
                                                                                  e[p + 104 >> 2] = e[s + 8 >> 2], u = e[s + 4 >> 2], e[p + 96 >> 2] = e[s >> 2], e[p + 100 >> 2] = u;
                                                                                  break n;
                                                                                }
                                                                                if (u = e[s + 4 >> 2], s = e[s >> 2], e[5996] = 0, gs(40, p + 96 | 0, s | 0, u | 0), s = e[5996], e[5996] = 0, (s | 0) != 1)
                                                                                  break n;
                                                                                r = Hr() | 0;
                                                                                break e;
                                                                              case 3:
                                                                                if (s = e[u + 8 >> 2], _[s + 11 | 0] >= 0) {
                                                                                  e[p + 104 >> 2] = e[s + 8 >> 2], u = e[s + 4 >> 2], e[p + 96 >> 2] = e[s >> 2], e[p + 100 >> 2] = u;
                                                                                  break s;
                                                                                }
                                                                                if (u = e[s + 4 >> 2], s = e[s >> 2], e[5996] = 0, gs(40, p + 96 | 0, s | 0, u | 0), s = e[5996], e[5996] = 0, (s | 0) != 1)
                                                                                  break s;
                                                                                r = Hr() | 0;
                                                                                break e;
                                                                              case 5:
                                                                                e[5996] = 0, s = pi(97, p + 116 | 0, 5258) | 0, A = e[5996], e[5996] = 0;
                                                                                C: {
                                                                                  y: {
                                                                                    D: {
                                                                                      P: {
                                                                                        q: {
                                                                                          if ((A | 0) != 1) {
                                                                                            if (e[p + 88 >> 2] = e[s + 8 >> 2], A = e[s + 4 >> 2], e[p + 80 >> 2] = e[s >> 2], e[p + 84 >> 2] = A, e[s >> 2] = 0, e[s + 4 >> 2] = 0, e[s + 8 >> 2] = 0, e[5996] = 0, s = p - -64 | 0, ji(119, s | 0, u + 4 | 0), u = e[5996], e[5996] = 0, (u | 0) == 1)
                                                                                              break q;
                                                                                            if (e[5996] = 0, A = s, s = me[p + 75 | 0], u = s << 24 >> 24 < 0, u = xn(100, p + 80 | 0, (u ? e[p + 64 >> 2] : A) | 0, (u ? e[p + 68 >> 2] : s) | 0) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1)
                                                                                              break P;
                                                                                            if (e[p + 104 >> 2] = e[u + 8 >> 2], s = e[u + 4 >> 2], e[p + 96 >> 2] = e[u >> 2], e[p + 100 >> 2] = s, e[u >> 2] = 0, e[u + 4 >> 2] = 0, e[u + 8 >> 2] = 0, e[5996] = 0, s = pi(97, p + 96 | 0, 5242) | 0, A = e[5996], e[5996] = 0, (A | 0) == 1)
                                                                                              break D;
                                                                                            if (m = e[s >> 2], e[p + 48 >> 2] = e[s + 4 >> 2], A = me[s + 7 | 0] | me[s + 8 | 0] << 8 | (me[s + 9 | 0] << 16 | me[s + 10 | 0] << 24), _[p + 51 | 0] = A, _[p + 52 | 0] = A >>> 8, _[p + 53 | 0] = A >>> 16, _[p + 54 | 0] = A >>> 24, e[s >> 2] = 0, e[s + 4 >> 2] = 0, A = me[s + 11 | 0], e[s + 8 >> 2] = 0, e[r >> 2] = m, e[r + 4 >> 2] = e[p + 48 >> 2], s = me[p + 51 | 0] | me[p + 52 | 0] << 8 | (me[p + 53 | 0] << 16 | me[p + 54 | 0] << 24), _[r + 7 | 0] = s, _[r + 8 | 0] = s >>> 8, _[r + 9 | 0] = s >>> 16, _[r + 10 | 0] = s >>> 24, _[r + 12 | 0] = 1, _[r + 11 | 0] = A, _[p + 75 | 0] < 0 && Br(e[p + 64 >> 2]), _[u + 11 | 0] >= 0)
                                                                                              break t;
                                                                                            Br(e[u >> 2]);
                                                                                            break t;
                                                                                          }
                                                                                          r = Hr() | 0;
                                                                                          break e;
                                                                                        }
                                                                                        r = Hr() | 0;
                                                                                        break C;
                                                                                      }
                                                                                      r = Hr() | 0;
                                                                                      break y;
                                                                                    }
                                                                                    if (r = Hr() | 0, _[p + 107 | 0] >= 0)
                                                                                      break y;
                                                                                    Br(e[p + 96 >> 2]);
                                                                                  }
                                                                                  if (_[p + 75 | 0] >= 0)
                                                                                    break C;
                                                                                  Br(e[p + 64 >> 2]);
                                                                                }
                                                                                if (_[p + 91 | 0] >= 0)
                                                                                  break e;
                                                                                Br(e[p + 80 >> 2]);
                                                                                break e;
                                                                              case 4:
                                                                                e[5996] = 0, s = pi(97, p + 116 | 0, 5265) | 0, A = e[5996], e[5996] = 0;
                                                                                C: {
                                                                                  y: {
                                                                                    D: {
                                                                                      P: {
                                                                                        q: {
                                                                                          if ((A | 0) != 1) {
                                                                                            if (e[p + 88 >> 2] = e[s + 8 >> 2], A = e[s + 4 >> 2], e[p + 80 >> 2] = e[s >> 2], e[p + 84 >> 2] = A, e[s >> 2] = 0, e[s + 4 >> 2] = 0, e[s + 8 >> 2] = 0, e[5996] = 0, s = p - -64 | 0, ji(119, s | 0, u + 4 | 0), u = e[5996], e[5996] = 0, (u | 0) == 1)
                                                                                              break q;
                                                                                            if (e[5996] = 0, A = s, s = me[p + 75 | 0], u = s << 24 >> 24 < 0, u = xn(100, p + 80 | 0, (u ? e[p + 64 >> 2] : A) | 0, (u ? e[p + 68 >> 2] : s) | 0) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1)
                                                                                              break P;
                                                                                            if (e[p + 104 >> 2] = e[u + 8 >> 2], s = e[u + 4 >> 2], e[p + 96 >> 2] = e[u >> 2], e[p + 100 >> 2] = s, e[u >> 2] = 0, e[u + 4 >> 2] = 0, e[u + 8 >> 2] = 0, e[5996] = 0, s = pi(97, p + 96 | 0, 5242) | 0, A = e[5996], e[5996] = 0, (A | 0) == 1)
                                                                                              break D;
                                                                                            if (m = e[s >> 2], e[p + 48 >> 2] = e[s + 4 >> 2], A = me[s + 7 | 0] | me[s + 8 | 0] << 8 | (me[s + 9 | 0] << 16 | me[s + 10 | 0] << 24), _[p + 51 | 0] = A, _[p + 52 | 0] = A >>> 8, _[p + 53 | 0] = A >>> 16, _[p + 54 | 0] = A >>> 24, e[s >> 2] = 0, e[s + 4 >> 2] = 0, A = me[s + 11 | 0], e[s + 8 >> 2] = 0, e[r >> 2] = m, e[r + 4 >> 2] = e[p + 48 >> 2], s = me[p + 51 | 0] | me[p + 52 | 0] << 8 | (me[p + 53 | 0] << 16 | me[p + 54 | 0] << 24), _[r + 7 | 0] = s, _[r + 8 | 0] = s >>> 8, _[r + 9 | 0] = s >>> 16, _[r + 10 | 0] = s >>> 24, _[r + 12 | 0] = 1, _[r + 11 | 0] = A, _[p + 75 | 0] < 0 && Br(e[p + 64 >> 2]), _[u + 11 | 0] >= 0)
                                                                                              break t;
                                                                                            Br(e[u >> 2]);
                                                                                            break t;
                                                                                          }
                                                                                          r = Hr() | 0;
                                                                                          break e;
                                                                                        }
                                                                                        r = Hr() | 0;
                                                                                        break C;
                                                                                      }
                                                                                      r = Hr() | 0;
                                                                                      break y;
                                                                                    }
                                                                                    if (r = Hr() | 0, _[p + 107 | 0] >= 0)
                                                                                      break y;
                                                                                    Br(e[p + 96 >> 2]);
                                                                                  }
                                                                                  if (_[p + 75 | 0] >= 0)
                                                                                    break C;
                                                                                  Br(e[p + 64 >> 2]);
                                                                                }
                                                                                if (_[p + 91 | 0] >= 0)
                                                                                  break e;
                                                                                Br(e[p + 80 >> 2]);
                                                                                break e;
                                                                              case 7:
                                                                                e[5996] = 0, s = pi(97, p + 116 | 0, 5346) | 0, A = e[5996], e[5996] = 0;
                                                                                C: {
                                                                                  y: {
                                                                                    D: {
                                                                                      if ((A | 0) != 1) {
                                                                                        if (e[p + 88 >> 2] = e[s + 8 >> 2], A = e[s + 4 >> 2], e[p + 80 >> 2] = e[s >> 2], e[p + 84 >> 2] = A, e[s >> 2] = 0, e[s + 4 >> 2] = 0, e[s + 8 >> 2] = 0, A = e[u + 24 >> 2], s = e[u + 20 >> 2], e[p + 72 >> 2] = 0, e[p + 64 >> 2] = 0, e[p + 68 >> 2] = 0, e[5996] = 0, u = A - s | 0, ji(101, p - -64 | 0, u << 1), m = e[5996], e[5996] = 0, (m | 0) == 1)
                                                                                          break o;
                                                                                        P: {
                                                                                          if (s >>> 0 < A >>> 0)
                                                                                            for (A = s + u | 0; ; ) {
                                                                                              if (u = me[s | 0], e[5996] = 0, m = p - -64 | 0, ji(98, m | 0, _[(u >>> 4 | 0) + 6976 | 0]), N = e[5996], e[5996] = 0, (N | 0) == 1 || (e[5996] = 0, ji(98, m | 0, _[(u & 15) + 6976 | 0]), u = e[5996], e[5996] = 0, (u | 0) == 1))
                                                                                                break P;
                                                                                              if (s = s + 1 | 0, (A | 0) == (s | 0))
                                                                                                break;
                                                                                            }
                                                                                          if (e[5996] = 0, s = me[p + 75 | 0], u = s << 24 >> 24 < 0, u = xn(100, p + 80 | 0, (u ? e[p + 64 >> 2] : p - -64 | 0) | 0, (u ? e[p + 68 >> 2] : s) | 0) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1)
                                                                                            break D;
                                                                                          if (e[p + 104 >> 2] = e[u + 8 >> 2], s = e[u + 4 >> 2], e[p + 96 >> 2] = e[u >> 2], e[p + 100 >> 2] = s, e[u >> 2] = 0, e[u + 4 >> 2] = 0, e[u + 8 >> 2] = 0, e[5996] = 0, s = pi(97, p + 96 | 0, 5242) | 0, A = e[5996], e[5996] = 0, (A | 0) == 1)
                                                                                            break y;
                                                                                          if (m = e[s >> 2], e[p + 48 >> 2] = e[s + 4 >> 2], A = me[s + 7 | 0] | me[s + 8 | 0] << 8 | (me[s + 9 | 0] << 16 | me[s + 10 | 0] << 24), _[p + 51 | 0] = A, _[p + 52 | 0] = A >>> 8, _[p + 53 | 0] = A >>> 16, _[p + 54 | 0] = A >>> 24, e[s >> 2] = 0, e[s + 4 >> 2] = 0, A = me[s + 11 | 0], e[s + 8 >> 2] = 0, e[r >> 2] = m, e[r + 4 >> 2] = e[p + 48 >> 2], s = me[p + 51 | 0] | me[p + 52 | 0] << 8 | (me[p + 53 | 0] << 16 | me[p + 54 | 0] << 24), _[r + 7 | 0] = s, _[r + 8 | 0] = s >>> 8, _[r + 9 | 0] = s >>> 16, _[r + 10 | 0] = s >>> 24, _[r + 12 | 0] = 1, _[r + 11 | 0] = A, _[p + 75 | 0] < 0 && Br(e[p + 64 >> 2]), _[u + 11 | 0] >= 0)
                                                                                            break t;
                                                                                          Br(e[u >> 2]);
                                                                                          break t;
                                                                                        }
                                                                                        break o;
                                                                                      }
                                                                                      r = Hr() | 0;
                                                                                      break e;
                                                                                    }
                                                                                    r = Hr() | 0;
                                                                                    break C;
                                                                                  }
                                                                                  if (r = Hr() | 0, _[p + 107 | 0] >= 0)
                                                                                    break C;
                                                                                  Br(e[p + 96 >> 2]);
                                                                                }
                                                                                break a;
                                                                              case 9:
                                                                                e[5996] = 0, s = pi(97, p + 116 | 0, 5363) | 0, A = e[5996], e[5996] = 0;
                                                                                C: {
                                                                                  y: {
                                                                                    D: {
                                                                                      if ((A | 0) != 1) {
                                                                                        if (e[p + 88 >> 2] = e[s + 8 >> 2], A = e[s + 4 >> 2], e[p + 80 >> 2] = e[s >> 2], e[p + 84 >> 2] = A, e[s >> 2] = 0, e[s + 4 >> 2] = 0, e[s + 8 >> 2] = 0, A = e[u + 24 >> 2], s = e[u + 20 >> 2], e[p + 72 >> 2] = 0, e[p + 64 >> 2] = 0, e[p + 68 >> 2] = 0, e[5996] = 0, u = A - s | 0, ji(101, p - -64 | 0, u << 1), m = e[5996], e[5996] = 0, (m | 0) == 1)
                                                                                          break c;
                                                                                        P: {
                                                                                          if (s >>> 0 < A >>> 0)
                                                                                            for (A = s + u | 0; ; ) {
                                                                                              if (u = me[s | 0], e[5996] = 0, m = p - -64 | 0, ji(98, m | 0, _[(u >>> 4 | 0) + 6976 | 0]), N = e[5996], e[5996] = 0, (N | 0) == 1 || (e[5996] = 0, ji(98, m | 0, _[(u & 15) + 6976 | 0]), u = e[5996], e[5996] = 0, (u | 0) == 1))
                                                                                                break P;
                                                                                              if (s = s + 1 | 0, (A | 0) == (s | 0))
                                                                                                break;
                                                                                            }
                                                                                          if (e[5996] = 0, s = me[p + 75 | 0], u = s << 24 >> 24 < 0, u = xn(100, p + 80 | 0, (u ? e[p + 64 >> 2] : p - -64 | 0) | 0, (u ? e[p + 68 >> 2] : s) | 0) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1)
                                                                                            break D;
                                                                                          if (e[p + 104 >> 2] = e[u + 8 >> 2], s = e[u + 4 >> 2], e[p + 96 >> 2] = e[u >> 2], e[p + 100 >> 2] = s, e[u >> 2] = 0, e[u + 4 >> 2] = 0, e[u + 8 >> 2] = 0, e[5996] = 0, s = pi(97, p + 96 | 0, 5242) | 0, A = e[5996], e[5996] = 0, (A | 0) == 1)
                                                                                            break y;
                                                                                          if (m = e[s >> 2], e[p + 48 >> 2] = e[s + 4 >> 2], A = me[s + 7 | 0] | me[s + 8 | 0] << 8 | (me[s + 9 | 0] << 16 | me[s + 10 | 0] << 24), _[p + 51 | 0] = A, _[p + 52 | 0] = A >>> 8, _[p + 53 | 0] = A >>> 16, _[p + 54 | 0] = A >>> 24, e[s >> 2] = 0, e[s + 4 >> 2] = 0, A = me[s + 11 | 0], e[s + 8 >> 2] = 0, e[r >> 2] = m, e[r + 4 >> 2] = e[p + 48 >> 2], s = me[p + 51 | 0] | me[p + 52 | 0] << 8 | (me[p + 53 | 0] << 16 | me[p + 54 | 0] << 24), _[r + 7 | 0] = s, _[r + 8 | 0] = s >>> 8, _[r + 9 | 0] = s >>> 16, _[r + 10 | 0] = s >>> 24, _[r + 12 | 0] = 1, _[r + 11 | 0] = A, _[p + 75 | 0] < 0 && Br(e[p + 64 >> 2]), _[u + 11 | 0] >= 0)
                                                                                            break t;
                                                                                          Br(e[u >> 2]);
                                                                                          break t;
                                                                                        }
                                                                                        break c;
                                                                                      }
                                                                                      r = Hr() | 0;
                                                                                      break e;
                                                                                    }
                                                                                    r = Hr() | 0;
                                                                                    break C;
                                                                                  }
                                                                                  if (r = Hr() | 0, _[p + 107 | 0] >= 0)
                                                                                    break C;
                                                                                  Br(e[p + 96 >> 2]);
                                                                                }
                                                                                break l;
                                                                              case 6:
                                                                                e[5996] = 0, s = pi(97, p + 116 | 0, 5355) | 0, A = e[5996], e[5996] = 0;
                                                                                C: {
                                                                                  y: {
                                                                                    D: {
                                                                                      if ((A | 0) != 1) {
                                                                                        if (e[p + 88 >> 2] = e[s + 8 >> 2], A = e[s + 4 >> 2], e[p + 80 >> 2] = e[s >> 2], e[p + 84 >> 2] = A, e[s >> 2] = 0, e[s + 4 >> 2] = 0, e[s + 8 >> 2] = 0, A = e[u + 24 >> 2], s = e[u + 20 >> 2], e[p + 72 >> 2] = 0, e[p + 64 >> 2] = 0, e[p + 68 >> 2] = 0, e[5996] = 0, u = A - s | 0, ji(101, p - -64 | 0, u << 1), m = e[5996], e[5996] = 0, (m | 0) == 1)
                                                                                          break f;
                                                                                        P: {
                                                                                          if (s >>> 0 < A >>> 0)
                                                                                            for (A = s + u | 0; ; ) {
                                                                                              if (u = me[s | 0], e[5996] = 0, m = p - -64 | 0, ji(98, m | 0, _[(u >>> 4 | 0) + 6976 | 0]), N = e[5996], e[5996] = 0, (N | 0) == 1 || (e[5996] = 0, ji(98, m | 0, _[(u & 15) + 6976 | 0]), u = e[5996], e[5996] = 0, (u | 0) == 1))
                                                                                                break P;
                                                                                              if (s = s + 1 | 0, (A | 0) == (s | 0))
                                                                                                break;
                                                                                            }
                                                                                          if (e[5996] = 0, s = me[p + 75 | 0], u = s << 24 >> 24 < 0, u = xn(100, p + 80 | 0, (u ? e[p + 64 >> 2] : p - -64 | 0) | 0, (u ? e[p + 68 >> 2] : s) | 0) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1)
                                                                                            break D;
                                                                                          if (e[p + 104 >> 2] = e[u + 8 >> 2], s = e[u + 4 >> 2], e[p + 96 >> 2] = e[u >> 2], e[p + 100 >> 2] = s, e[u >> 2] = 0, e[u + 4 >> 2] = 0, e[u + 8 >> 2] = 0, e[5996] = 0, s = pi(97, p + 96 | 0, 5242) | 0, A = e[5996], e[5996] = 0, (A | 0) == 1)
                                                                                            break y;
                                                                                          if (m = e[s >> 2], e[p + 48 >> 2] = e[s + 4 >> 2], A = me[s + 7 | 0] | me[s + 8 | 0] << 8 | (me[s + 9 | 0] << 16 | me[s + 10 | 0] << 24), _[p + 51 | 0] = A, _[p + 52 | 0] = A >>> 8, _[p + 53 | 0] = A >>> 16, _[p + 54 | 0] = A >>> 24, e[s >> 2] = 0, e[s + 4 >> 2] = 0, A = me[s + 11 | 0], e[s + 8 >> 2] = 0, e[r >> 2] = m, e[r + 4 >> 2] = e[p + 48 >> 2], s = me[p + 51 | 0] | me[p + 52 | 0] << 8 | (me[p + 53 | 0] << 16 | me[p + 54 | 0] << 24), _[r + 7 | 0] = s, _[r + 8 | 0] = s >>> 8, _[r + 9 | 0] = s >>> 16, _[r + 10 | 0] = s >>> 24, _[r + 12 | 0] = 1, _[r + 11 | 0] = A, _[p + 75 | 0] < 0 && Br(e[p + 64 >> 2]), _[u + 11 | 0] >= 0)
                                                                                            break t;
                                                                                          Br(e[u >> 2]);
                                                                                          break t;
                                                                                        }
                                                                                        break f;
                                                                                      }
                                                                                      r = Hr() | 0;
                                                                                      break e;
                                                                                    }
                                                                                    r = Hr() | 0;
                                                                                    break C;
                                                                                  }
                                                                                  if (r = Hr() | 0, _[p + 107 | 0] >= 0)
                                                                                    break C;
                                                                                  Br(e[p + 96 >> 2]);
                                                                                }
                                                                                break d;
                                                                              case 8:
                                                                                e[5996] = 0, s = pi(97, p + 116 | 0, 5372) | 0, A = e[5996], e[5996] = 0;
                                                                                C: {
                                                                                  y: {
                                                                                    D: {
                                                                                      if ((A | 0) != 1) {
                                                                                        if (e[p + 88 >> 2] = e[s + 8 >> 2], A = e[s + 4 >> 2], e[p + 80 >> 2] = e[s >> 2], e[p + 84 >> 2] = A, e[s >> 2] = 0, e[s + 4 >> 2] = 0, e[s + 8 >> 2] = 0, A = e[u + 24 >> 2], s = e[u + 20 >> 2], e[p + 72 >> 2] = 0, e[p + 64 >> 2] = 0, e[p + 68 >> 2] = 0, e[5996] = 0, u = A - s | 0, ji(101, p - -64 | 0, u << 1), m = e[5996], e[5996] = 0, (m | 0) == 1)
                                                                                          break g;
                                                                                        P: {
                                                                                          if (s >>> 0 < A >>> 0)
                                                                                            for (A = s + u | 0; ; ) {
                                                                                              if (u = me[s | 0], e[5996] = 0, m = p - -64 | 0, ji(98, m | 0, _[(u >>> 4 | 0) + 6976 | 0]), N = e[5996], e[5996] = 0, (N | 0) == 1 || (e[5996] = 0, ji(98, m | 0, _[(u & 15) + 6976 | 0]), u = e[5996], e[5996] = 0, (u | 0) == 1))
                                                                                                break P;
                                                                                              if (s = s + 1 | 0, (A | 0) == (s | 0))
                                                                                                break;
                                                                                            }
                                                                                          if (e[5996] = 0, s = me[p + 75 | 0], u = s << 24 >> 24 < 0, u = xn(100, p + 80 | 0, (u ? e[p + 64 >> 2] : p - -64 | 0) | 0, (u ? e[p + 68 >> 2] : s) | 0) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1)
                                                                                            break D;
                                                                                          if (e[p + 104 >> 2] = e[u + 8 >> 2], s = e[u + 4 >> 2], e[p + 96 >> 2] = e[u >> 2], e[p + 100 >> 2] = s, e[u >> 2] = 0, e[u + 4 >> 2] = 0, e[u + 8 >> 2] = 0, e[5996] = 0, s = pi(97, p + 96 | 0, 5242) | 0, A = e[5996], e[5996] = 0, (A | 0) == 1)
                                                                                            break y;
                                                                                          if (m = e[s >> 2], e[p + 48 >> 2] = e[s + 4 >> 2], A = me[s + 7 | 0] | me[s + 8 | 0] << 8 | (me[s + 9 | 0] << 16 | me[s + 10 | 0] << 24), _[p + 51 | 0] = A, _[p + 52 | 0] = A >>> 8, _[p + 53 | 0] = A >>> 16, _[p + 54 | 0] = A >>> 24, e[s >> 2] = 0, e[s + 4 >> 2] = 0, A = me[s + 11 | 0], e[s + 8 >> 2] = 0, e[r >> 2] = m, e[r + 4 >> 2] = e[p + 48 >> 2], s = me[p + 51 | 0] | me[p + 52 | 0] << 8 | (me[p + 53 | 0] << 16 | me[p + 54 | 0] << 24), _[r + 7 | 0] = s, _[r + 8 | 0] = s >>> 8, _[r + 9 | 0] = s >>> 16, _[r + 10 | 0] = s >>> 24, _[r + 12 | 0] = 1, _[r + 11 | 0] = A, _[p + 75 | 0] < 0 && Br(e[p + 64 >> 2]), _[u + 11 | 0] >= 0)
                                                                                            break t;
                                                                                          Br(e[u >> 2]);
                                                                                          break t;
                                                                                        }
                                                                                        break g;
                                                                                      }
                                                                                      r = Hr() | 0;
                                                                                      break e;
                                                                                    }
                                                                                    r = Hr() | 0;
                                                                                    break C;
                                                                                  }
                                                                                  if (r = Hr() | 0, _[p + 107 | 0] >= 0)
                                                                                    break C;
                                                                                  Br(e[p + 96 >> 2]);
                                                                                }
                                                                                break u;
                                                                              case 1:
                                                                                if (e[5996] = 0, s = pi(97, p + 116 | 0, 4180) | 0, u = e[5996], e[5996] = 0, (u | 0) != 1) {
                                                                                  A = e[s >> 2], e[p + 96 >> 2] = e[s + 4 >> 2], u = me[s + 7 | 0] | me[s + 8 | 0] << 8 | (me[s + 9 | 0] << 16 | me[s + 10 | 0] << 24), _[p + 99 | 0] = u, _[p + 100 | 0] = u >>> 8, _[p + 101 | 0] = u >>> 16, _[p + 102 | 0] = u >>> 24, u = me[p + 127 | 0], e[s >> 2] = 0, e[s + 4 >> 2] = 0, e[s + 8 >> 2] = 0, e[r >> 2] = A, e[r + 4 >> 2] = e[p + 96 >> 2], s = me[p + 99 | 0] | me[p + 100 | 0] << 8 | (me[p + 101 | 0] << 16 | me[p + 102 | 0] << 24), _[r + 7 | 0] = s, _[r + 8 | 0] = s >>> 8, _[r + 9 | 0] = s >>> 16, _[r + 10 | 0] = s >>> 24, _[r + 12 | 0] = 1, _[r + 11 | 0] = u;
                                                                                  break t;
                                                                                }
                                                                                r = Hr() | 0;
                                                                                break e;
                                                                              case 24:
                                                                                break N;
                                                                              case 25:
                                                                                break v;
                                                                              case 23:
                                                                                break w;
                                                                              case 20:
                                                                                break h;
                                                                              case 21:
                                                                                break R;
                                                                              case 19:
                                                                                break I;
                                                                              case 18:
                                                                                break B;
                                                                              case 0:
                                                                                break b;
                                                                              default:
                                                                                break S;
                                                                            }
                                                                          if (e[5996] = 0, s = pi(97, p + 116 | 0, 4350) | 0, u = e[5996], e[5996] = 0, (u | 0) != 1) {
                                                                            A = e[s >> 2], e[p + 96 >> 2] = e[s + 4 >> 2], u = me[s + 7 | 0] | me[s + 8 | 0] << 8 | (me[s + 9 | 0] << 16 | me[s + 10 | 0] << 24), _[p + 99 | 0] = u, _[p + 100 | 0] = u >>> 8, _[p + 101 | 0] = u >>> 16, _[p + 102 | 0] = u >>> 24, u = me[p + 127 | 0], e[s >> 2] = 0, e[s + 4 >> 2] = 0, e[s + 8 >> 2] = 0, e[r >> 2] = A, e[r + 4 >> 2] = e[p + 96 >> 2], s = me[p + 99 | 0] | me[p + 100 | 0] << 8 | (me[p + 101 | 0] << 16 | me[p + 102 | 0] << 24), _[r + 7 | 0] = s, _[r + 8 | 0] = s >>> 8, _[r + 9 | 0] = s >>> 16, _[r + 10 | 0] = s >>> 24, _[r + 12 | 0] = 1, _[r + 11 | 0] = u;
                                                                            break t;
                                                                          }
                                                                          r = Hr() | 0;
                                                                          break e;
                                                                        }
                                                                        e[5996] = 0, s = pi(97, p + 116 | 0, 5244) | 0, u = e[5996], e[5996] = 0;
                                                                        x: {
                                                                          b: {
                                                                            C: {
                                                                              y: {
                                                                                D: {
                                                                                  P: {
                                                                                    q: {
                                                                                      if ((u | 0) != 1) {
                                                                                        if (e[p + 56 >> 2] = e[s + 8 >> 2], u = e[s + 4 >> 2], e[p + 48 >> 2] = e[s >> 2], e[p + 52 >> 2] = u, e[s >> 2] = 0, e[s + 4 >> 2] = 0, e[s + 8 >> 2] = 0, u = e[A >> 2], m = e[A + 4 >> 2], s = me[A + 11 | 0], e[5996] = 0, W = u, u = s << 24 >> 24 < 0, u = xn(100, p + 48 | 0, (u ? W : A) | 0, (u ? m : s) | 0) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1)
                                                                                          break q;
                                                                                        if (e[p + 72 >> 2] = e[u + 8 >> 2], s = e[u + 4 >> 2], e[p + 64 >> 2] = e[u >> 2], e[p + 68 >> 2] = s, e[u >> 2] = 0, e[u + 4 >> 2] = 0, e[u + 8 >> 2] = 0, e[5996] = 0, m = pi(97, p - -64 | 0, 4354) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1)
                                                                                          break P;
                                                                                        if (e[p + 88 >> 2] = e[m + 8 >> 2], s = e[m + 4 >> 2], e[p + 80 >> 2] = e[m >> 2], e[p + 84 >> 2] = s, e[m >> 2] = 0, e[m + 4 >> 2] = 0, e[m + 8 >> 2] = 0, N = e[A + 16 >> 2], W = e[A + 12 >> 2], s = me[A + 23 | 0], e[5996] = 0, Te = A + 12 | 0, A = s << 24 >> 24 < 0, A = xn(100, p + 80 | 0, (A ? W : Te) | 0, (A ? N : s) | 0) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1)
                                                                                          break D;
                                                                                        if (e[p + 104 >> 2] = e[A + 8 >> 2], s = e[A + 4 >> 2], e[p + 96 >> 2] = e[A >> 2], e[p + 100 >> 2] = s, e[A >> 2] = 0, e[A + 4 >> 2] = 0, e[A + 8 >> 2] = 0, e[5996] = 0, s = pi(97, p + 96 | 0, 5242) | 0, N = e[5996], e[5996] = 0, (N | 0) == 1)
                                                                                          break y;
                                                                                        if (W = e[s >> 2], e[p + 24 >> 2] = e[s + 4 >> 2], N = me[s + 7 | 0] | me[s + 8 | 0] << 8 | (me[s + 9 | 0] << 16 | me[s + 10 | 0] << 24), _[p + 27 | 0] = N, _[p + 28 | 0] = N >>> 8, _[p + 29 | 0] = N >>> 16, _[p + 30 | 0] = N >>> 24, e[s >> 2] = 0, e[s + 4 >> 2] = 0, N = me[s + 11 | 0], e[s + 8 >> 2] = 0, e[r >> 2] = W, e[r + 4 >> 2] = e[p + 24 >> 2], s = me[p + 27 | 0] | me[p + 28 | 0] << 8 | (me[p + 29 | 0] << 16 | me[p + 30 | 0] << 24), _[r + 7 | 0] = s, _[r + 8 | 0] = s >>> 8, _[r + 9 | 0] = s >>> 16, _[r + 10 | 0] = s >>> 24, _[r + 12 | 0] = 1, _[r + 11 | 0] = N, _[A + 11 | 0] < 0 && Br(e[A >> 2]), _[m + 11 | 0] < 0 && Br(e[m >> 2]), _[u + 11 | 0] >= 0)
                                                                                          break t;
                                                                                        Br(e[u >> 2]);
                                                                                        break t;
                                                                                      }
                                                                                      r = Hr() | 0;
                                                                                      break e;
                                                                                    }
                                                                                    r = Hr() | 0;
                                                                                    break x;
                                                                                  }
                                                                                  r = Hr() | 0;
                                                                                  break b;
                                                                                }
                                                                                r = Hr() | 0;
                                                                                break C;
                                                                              }
                                                                              if (r = Hr() | 0, _[p + 107 | 0] >= 0)
                                                                                break C;
                                                                              Br(e[p + 96 >> 2]);
                                                                            }
                                                                            if (_[p + 91 | 0] >= 0)
                                                                              break b;
                                                                            Br(e[p + 80 >> 2]);
                                                                          }
                                                                          if (_[p + 75 | 0] >= 0)
                                                                            break x;
                                                                          Br(e[p + 64 >> 2]);
                                                                        }
                                                                        if (_[p + 59 | 0] >= 0)
                                                                          break e;
                                                                        Br(e[p + 48 >> 2]);
                                                                        break e;
                                                                      }
                                                                      e[5996] = 0, s = pi(97, p + 116 | 0, 5339) | 0, u = e[5996], e[5996] = 0;
                                                                      B: {
                                                                        x: {
                                                                          b: {
                                                                            C: {
                                                                              y: {
                                                                                D: {
                                                                                  P: {
                                                                                    if ((u | 0) != 1) {
                                                                                      if (e[p + 56 >> 2] = e[s + 8 >> 2], u = e[s + 4 >> 2], e[p + 48 >> 2] = e[s >> 2], e[p + 52 >> 2] = u, e[s >> 2] = 0, e[s + 4 >> 2] = 0, e[s + 8 >> 2] = 0, u = e[A >> 2], m = e[A + 4 >> 2], s = me[A + 11 | 0], e[5996] = 0, W = u, u = s << 24 >> 24 < 0, u = xn(100, p + 48 | 0, (u ? W : A) | 0, (u ? m : s) | 0) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1)
                                                                                        break P;
                                                                                      if (e[p + 72 >> 2] = e[u + 8 >> 2], s = e[u + 4 >> 2], e[p + 64 >> 2] = e[u >> 2], e[p + 68 >> 2] = s, e[u >> 2] = 0, e[u + 4 >> 2] = 0, e[u + 8 >> 2] = 0, e[5996] = 0, m = pi(97, p - -64 | 0, 4354) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1)
                                                                                        break D;
                                                                                      if (e[p + 88 >> 2] = e[m + 8 >> 2], s = e[m + 4 >> 2], e[p + 80 >> 2] = e[m >> 2], e[p + 84 >> 2] = s, e[m >> 2] = 0, e[m + 4 >> 2] = 0, e[m + 8 >> 2] = 0, N = e[A + 16 >> 2], W = e[A + 12 >> 2], s = me[A + 23 | 0], e[5996] = 0, Te = A + 12 | 0, A = s << 24 >> 24 < 0, A = xn(100, p + 80 | 0, (A ? W : Te) | 0, (A ? N : s) | 0) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1)
                                                                                        break y;
                                                                                      if (e[p + 104 >> 2] = e[A + 8 >> 2], s = e[A + 4 >> 2], e[p + 96 >> 2] = e[A >> 2], e[p + 100 >> 2] = s, e[A >> 2] = 0, e[A + 4 >> 2] = 0, e[A + 8 >> 2] = 0, e[5996] = 0, s = pi(97, p + 96 | 0, 5242) | 0, N = e[5996], e[5996] = 0, (N | 0) == 1)
                                                                                        break C;
                                                                                      if (W = e[s >> 2], e[p + 24 >> 2] = e[s + 4 >> 2], N = me[s + 7 | 0] | me[s + 8 | 0] << 8 | (me[s + 9 | 0] << 16 | me[s + 10 | 0] << 24), _[p + 27 | 0] = N, _[p + 28 | 0] = N >>> 8, _[p + 29 | 0] = N >>> 16, _[p + 30 | 0] = N >>> 24, e[s >> 2] = 0, e[s + 4 >> 2] = 0, N = me[s + 11 | 0], e[s + 8 >> 2] = 0, e[r >> 2] = W, e[r + 4 >> 2] = e[p + 24 >> 2], s = me[p + 27 | 0] | me[p + 28 | 0] << 8 | (me[p + 29 | 0] << 16 | me[p + 30 | 0] << 24), _[r + 7 | 0] = s, _[r + 8 | 0] = s >>> 8, _[r + 9 | 0] = s >>> 16, _[r + 10 | 0] = s >>> 24, _[r + 12 | 0] = 1, _[r + 11 | 0] = N, _[A + 11 | 0] < 0 && Br(e[A >> 2]), _[m + 11 | 0] < 0 && Br(e[m >> 2]), _[u + 11 | 0] >= 0)
                                                                                        break t;
                                                                                      Br(e[u >> 2]);
                                                                                      break t;
                                                                                    }
                                                                                    r = Hr() | 0;
                                                                                    break e;
                                                                                  }
                                                                                  r = Hr() | 0;
                                                                                  break B;
                                                                                }
                                                                                r = Hr() | 0;
                                                                                break x;
                                                                              }
                                                                              r = Hr() | 0;
                                                                              break b;
                                                                            }
                                                                            if (r = Hr() | 0, _[p + 107 | 0] >= 0)
                                                                              break b;
                                                                            Br(e[p + 96 >> 2]);
                                                                          }
                                                                          if (_[p + 91 | 0] >= 0)
                                                                            break x;
                                                                          Br(e[p + 80 >> 2]);
                                                                        }
                                                                        if (_[p + 75 | 0] >= 0)
                                                                          break B;
                                                                        Br(e[p + 64 >> 2]);
                                                                      }
                                                                      if (_[p + 59 | 0] >= 0)
                                                                        break e;
                                                                      Br(e[p + 48 >> 2]);
                                                                      break e;
                                                                    }
                                                                    e[5996] = 0, s = pi(97, p + 116 | 0, 5333) | 0, u = e[5996], e[5996] = 0;
                                                                    I: {
                                                                      B: {
                                                                        x: {
                                                                          b: {
                                                                            C: {
                                                                              y: {
                                                                                D: {
                                                                                  if ((u | 0) != 1) {
                                                                                    if (e[p + 56 >> 2] = e[s + 8 >> 2], u = e[s + 4 >> 2], e[p + 48 >> 2] = e[s >> 2], e[p + 52 >> 2] = u, e[s >> 2] = 0, e[s + 4 >> 2] = 0, e[s + 8 >> 2] = 0, u = e[A >> 2], m = e[A + 4 >> 2], s = me[A + 11 | 0], e[5996] = 0, W = u, u = s << 24 >> 24 < 0, u = xn(100, p + 48 | 0, (u ? W : A) | 0, (u ? m : s) | 0) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1)
                                                                                      break D;
                                                                                    if (e[p + 72 >> 2] = e[u + 8 >> 2], s = e[u + 4 >> 2], e[p + 64 >> 2] = e[u >> 2], e[p + 68 >> 2] = s, e[u >> 2] = 0, e[u + 4 >> 2] = 0, e[u + 8 >> 2] = 0, e[5996] = 0, m = pi(97, p - -64 | 0, 4354) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1)
                                                                                      break y;
                                                                                    if (e[p + 88 >> 2] = e[m + 8 >> 2], s = e[m + 4 >> 2], e[p + 80 >> 2] = e[m >> 2], e[p + 84 >> 2] = s, e[m >> 2] = 0, e[m + 4 >> 2] = 0, e[m + 8 >> 2] = 0, N = e[A + 16 >> 2], W = e[A + 12 >> 2], s = me[A + 23 | 0], e[5996] = 0, Te = A + 12 | 0, A = s << 24 >> 24 < 0, A = xn(100, p + 80 | 0, (A ? W : Te) | 0, (A ? N : s) | 0) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1)
                                                                                      break C;
                                                                                    if (e[p + 104 >> 2] = e[A + 8 >> 2], s = e[A + 4 >> 2], e[p + 96 >> 2] = e[A >> 2], e[p + 100 >> 2] = s, e[A >> 2] = 0, e[A + 4 >> 2] = 0, e[A + 8 >> 2] = 0, e[5996] = 0, s = pi(97, p + 96 | 0, 5242) | 0, N = e[5996], e[5996] = 0, (N | 0) == 1)
                                                                                      break b;
                                                                                    if (W = e[s >> 2], e[p + 24 >> 2] = e[s + 4 >> 2], N = me[s + 7 | 0] | me[s + 8 | 0] << 8 | (me[s + 9 | 0] << 16 | me[s + 10 | 0] << 24), _[p + 27 | 0] = N, _[p + 28 | 0] = N >>> 8, _[p + 29 | 0] = N >>> 16, _[p + 30 | 0] = N >>> 24, e[s >> 2] = 0, e[s + 4 >> 2] = 0, N = me[s + 11 | 0], e[s + 8 >> 2] = 0, e[r >> 2] = W, e[r + 4 >> 2] = e[p + 24 >> 2], s = me[p + 27 | 0] | me[p + 28 | 0] << 8 | (me[p + 29 | 0] << 16 | me[p + 30 | 0] << 24), _[r + 7 | 0] = s, _[r + 8 | 0] = s >>> 8, _[r + 9 | 0] = s >>> 16, _[r + 10 | 0] = s >>> 24, _[r + 12 | 0] = 1, _[r + 11 | 0] = N, _[A + 11 | 0] < 0 && Br(e[A >> 2]), _[m + 11 | 0] < 0 && Br(e[m >> 2]), _[u + 11 | 0] >= 0)
                                                                                      break t;
                                                                                    Br(e[u >> 2]);
                                                                                    break t;
                                                                                  }
                                                                                  r = Hr() | 0;
                                                                                  break e;
                                                                                }
                                                                                r = Hr() | 0;
                                                                                break I;
                                                                              }
                                                                              r = Hr() | 0;
                                                                              break B;
                                                                            }
                                                                            r = Hr() | 0;
                                                                            break x;
                                                                          }
                                                                          if (r = Hr() | 0, _[p + 107 | 0] >= 0)
                                                                            break x;
                                                                          Br(e[p + 96 >> 2]);
                                                                        }
                                                                        if (_[p + 91 | 0] >= 0)
                                                                          break B;
                                                                        Br(e[p + 80 >> 2]);
                                                                      }
                                                                      if (_[p + 75 | 0] >= 0)
                                                                        break I;
                                                                      Br(e[p + 64 >> 2]);
                                                                    }
                                                                    if (_[p + 59 | 0] >= 0)
                                                                      break e;
                                                                    Br(e[p + 48 >> 2]);
                                                                    break e;
                                                                  }
                                                                  e[5996] = 0, s = pi(97, p + 116 | 0, 5321) | 0, u = e[5996], e[5996] = 0;
                                                                  R: {
                                                                    I: {
                                                                      B: {
                                                                        x: {
                                                                          b: {
                                                                            C: {
                                                                              y: {
                                                                                if ((u | 0) != 1) {
                                                                                  if (e[p + 56 >> 2] = e[s + 8 >> 2], u = e[s + 4 >> 2], e[p + 48 >> 2] = e[s >> 2], e[p + 52 >> 2] = u, e[s >> 2] = 0, e[s + 4 >> 2] = 0, e[s + 8 >> 2] = 0, u = e[A >> 2], m = e[A + 4 >> 2], s = me[A + 11 | 0], e[5996] = 0, W = u, u = s << 24 >> 24 < 0, u = xn(100, p + 48 | 0, (u ? W : A) | 0, (u ? m : s) | 0) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1)
                                                                                    break y;
                                                                                  if (e[p + 72 >> 2] = e[u + 8 >> 2], s = e[u + 4 >> 2], e[p + 64 >> 2] = e[u >> 2], e[p + 68 >> 2] = s, e[u >> 2] = 0, e[u + 4 >> 2] = 0, e[u + 8 >> 2] = 0, e[5996] = 0, m = pi(97, p - -64 | 0, 4354) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1)
                                                                                    break C;
                                                                                  if (e[p + 88 >> 2] = e[m + 8 >> 2], s = e[m + 4 >> 2], e[p + 80 >> 2] = e[m >> 2], e[p + 84 >> 2] = s, e[m >> 2] = 0, e[m + 4 >> 2] = 0, e[m + 8 >> 2] = 0, N = e[A + 16 >> 2], W = e[A + 12 >> 2], s = me[A + 23 | 0], e[5996] = 0, Te = A + 12 | 0, A = s << 24 >> 24 < 0, A = xn(100, p + 80 | 0, (A ? W : Te) | 0, (A ? N : s) | 0) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1)
                                                                                    break b;
                                                                                  if (e[p + 104 >> 2] = e[A + 8 >> 2], s = e[A + 4 >> 2], e[p + 96 >> 2] = e[A >> 2], e[p + 100 >> 2] = s, e[A >> 2] = 0, e[A + 4 >> 2] = 0, e[A + 8 >> 2] = 0, e[5996] = 0, s = pi(97, p + 96 | 0, 5242) | 0, N = e[5996], e[5996] = 0, (N | 0) == 1)
                                                                                    break x;
                                                                                  if (W = e[s >> 2], e[p + 24 >> 2] = e[s + 4 >> 2], N = me[s + 7 | 0] | me[s + 8 | 0] << 8 | (me[s + 9 | 0] << 16 | me[s + 10 | 0] << 24), _[p + 27 | 0] = N, _[p + 28 | 0] = N >>> 8, _[p + 29 | 0] = N >>> 16, _[p + 30 | 0] = N >>> 24, e[s >> 2] = 0, e[s + 4 >> 2] = 0, N = me[s + 11 | 0], e[s + 8 >> 2] = 0, e[r >> 2] = W, e[r + 4 >> 2] = e[p + 24 >> 2], s = me[p + 27 | 0] | me[p + 28 | 0] << 8 | (me[p + 29 | 0] << 16 | me[p + 30 | 0] << 24), _[r + 7 | 0] = s, _[r + 8 | 0] = s >>> 8, _[r + 9 | 0] = s >>> 16, _[r + 10 | 0] = s >>> 24, _[r + 12 | 0] = 1, _[r + 11 | 0] = N, _[A + 11 | 0] < 0 && Br(e[A >> 2]), _[m + 11 | 0] < 0 && Br(e[m >> 2]), _[u + 11 | 0] >= 0)
                                                                                    break t;
                                                                                  Br(e[u >> 2]);
                                                                                  break t;
                                                                                }
                                                                                r = Hr() | 0;
                                                                                break e;
                                                                              }
                                                                              r = Hr() | 0;
                                                                              break R;
                                                                            }
                                                                            r = Hr() | 0;
                                                                            break I;
                                                                          }
                                                                          r = Hr() | 0;
                                                                          break B;
                                                                        }
                                                                        if (r = Hr() | 0, _[p + 107 | 0] >= 0)
                                                                          break B;
                                                                        Br(e[p + 96 >> 2]);
                                                                      }
                                                                      if (_[p + 91 | 0] >= 0)
                                                                        break I;
                                                                      Br(e[p + 80 >> 2]);
                                                                    }
                                                                    if (_[p + 75 | 0] >= 0)
                                                                      break R;
                                                                    Br(e[p + 64 >> 2]);
                                                                  }
                                                                  if (_[p + 59 | 0] >= 0)
                                                                    break e;
                                                                  Br(e[p + 48 >> 2]);
                                                                  break e;
                                                                }
                                                                e[5996] = 0, s = pi(97, p + 116 | 0, 5327) | 0, u = e[5996], e[5996] = 0;
                                                                h: {
                                                                  R: {
                                                                    I: {
                                                                      B: {
                                                                        x: {
                                                                          b: {
                                                                            C: {
                                                                              if ((u | 0) != 1) {
                                                                                if (e[p + 56 >> 2] = e[s + 8 >> 2], u = e[s + 4 >> 2], e[p + 48 >> 2] = e[s >> 2], e[p + 52 >> 2] = u, e[s >> 2] = 0, e[s + 4 >> 2] = 0, e[s + 8 >> 2] = 0, u = e[A >> 2], m = e[A + 4 >> 2], s = me[A + 11 | 0], e[5996] = 0, W = u, u = s << 24 >> 24 < 0, u = xn(100, p + 48 | 0, (u ? W : A) | 0, (u ? m : s) | 0) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1)
                                                                                  break C;
                                                                                if (e[p + 72 >> 2] = e[u + 8 >> 2], s = e[u + 4 >> 2], e[p + 64 >> 2] = e[u >> 2], e[p + 68 >> 2] = s, e[u >> 2] = 0, e[u + 4 >> 2] = 0, e[u + 8 >> 2] = 0, e[5996] = 0, m = pi(97, p - -64 | 0, 4354) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1)
                                                                                  break b;
                                                                                if (e[p + 88 >> 2] = e[m + 8 >> 2], s = e[m + 4 >> 2], e[p + 80 >> 2] = e[m >> 2], e[p + 84 >> 2] = s, e[m >> 2] = 0, e[m + 4 >> 2] = 0, e[m + 8 >> 2] = 0, N = e[A + 16 >> 2], W = e[A + 12 >> 2], s = me[A + 23 | 0], e[5996] = 0, Te = A + 12 | 0, A = s << 24 >> 24 < 0, A = xn(100, p + 80 | 0, (A ? W : Te) | 0, (A ? N : s) | 0) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1)
                                                                                  break x;
                                                                                if (e[p + 104 >> 2] = e[A + 8 >> 2], s = e[A + 4 >> 2], e[p + 96 >> 2] = e[A >> 2], e[p + 100 >> 2] = s, e[A >> 2] = 0, e[A + 4 >> 2] = 0, e[A + 8 >> 2] = 0, e[5996] = 0, s = pi(97, p + 96 | 0, 5242) | 0, N = e[5996], e[5996] = 0, (N | 0) == 1)
                                                                                  break B;
                                                                                if (W = e[s >> 2], e[p + 24 >> 2] = e[s + 4 >> 2], N = me[s + 7 | 0] | me[s + 8 | 0] << 8 | (me[s + 9 | 0] << 16 | me[s + 10 | 0] << 24), _[p + 27 | 0] = N, _[p + 28 | 0] = N >>> 8, _[p + 29 | 0] = N >>> 16, _[p + 30 | 0] = N >>> 24, e[s >> 2] = 0, e[s + 4 >> 2] = 0, N = me[s + 11 | 0], e[s + 8 >> 2] = 0, e[r >> 2] = W, e[r + 4 >> 2] = e[p + 24 >> 2], s = me[p + 27 | 0] | me[p + 28 | 0] << 8 | (me[p + 29 | 0] << 16 | me[p + 30 | 0] << 24), _[r + 7 | 0] = s, _[r + 8 | 0] = s >>> 8, _[r + 9 | 0] = s >>> 16, _[r + 10 | 0] = s >>> 24, _[r + 12 | 0] = 1, _[r + 11 | 0] = N, _[A + 11 | 0] < 0 && Br(e[A >> 2]), _[m + 11 | 0] < 0 && Br(e[m >> 2]), _[u + 11 | 0] >= 0)
                                                                                  break t;
                                                                                Br(e[u >> 2]);
                                                                                break t;
                                                                              }
                                                                              r = Hr() | 0;
                                                                              break e;
                                                                            }
                                                                            r = Hr() | 0;
                                                                            break h;
                                                                          }
                                                                          r = Hr() | 0;
                                                                          break R;
                                                                        }
                                                                        r = Hr() | 0;
                                                                        break I;
                                                                      }
                                                                      if (r = Hr() | 0, _[p + 107 | 0] >= 0)
                                                                        break I;
                                                                      Br(e[p + 96 >> 2]);
                                                                    }
                                                                    if (_[p + 91 | 0] >= 0)
                                                                      break R;
                                                                    Br(e[p + 80 >> 2]);
                                                                  }
                                                                  if (_[p + 75 | 0] >= 0)
                                                                    break h;
                                                                  Br(e[p + 64 >> 2]);
                                                                }
                                                                if (_[p + 59 | 0] >= 0)
                                                                  break e;
                                                                Br(e[p + 48 >> 2]);
                                                                break e;
                                                              }
                                                              e[5996] = 0, s = pi(97, p + 116 | 0, 5296) | 0, u = e[5996], e[5996] = 0;
                                                              E: {
                                                                h: {
                                                                  R: {
                                                                    I: {
                                                                      B: {
                                                                        x: {
                                                                          b: {
                                                                            if ((u | 0) != 1) {
                                                                              if (e[p + 56 >> 2] = e[s + 8 >> 2], u = e[s + 4 >> 2], e[p + 48 >> 2] = e[s >> 2], e[p + 52 >> 2] = u, e[s >> 2] = 0, e[s + 4 >> 2] = 0, e[s + 8 >> 2] = 0, u = e[A >> 2], m = e[A + 4 >> 2], s = me[A + 11 | 0], e[5996] = 0, W = u, u = s << 24 >> 24 < 0, u = xn(100, p + 48 | 0, (u ? W : A) | 0, (u ? m : s) | 0) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1)
                                                                                break b;
                                                                              if (e[p + 72 >> 2] = e[u + 8 >> 2], s = e[u + 4 >> 2], e[p + 64 >> 2] = e[u >> 2], e[p + 68 >> 2] = s, e[u >> 2] = 0, e[u + 4 >> 2] = 0, e[u + 8 >> 2] = 0, e[5996] = 0, m = pi(97, p - -64 | 0, 4354) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1)
                                                                                break x;
                                                                              if (e[p + 88 >> 2] = e[m + 8 >> 2], s = e[m + 4 >> 2], e[p + 80 >> 2] = e[m >> 2], e[p + 84 >> 2] = s, e[m >> 2] = 0, e[m + 4 >> 2] = 0, e[m + 8 >> 2] = 0, N = e[A + 16 >> 2], W = e[A + 12 >> 2], s = me[A + 23 | 0], e[5996] = 0, Te = A + 12 | 0, A = s << 24 >> 24 < 0, A = xn(100, p + 80 | 0, (A ? W : Te) | 0, (A ? N : s) | 0) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1)
                                                                                break B;
                                                                              if (e[p + 104 >> 2] = e[A + 8 >> 2], s = e[A + 4 >> 2], e[p + 96 >> 2] = e[A >> 2], e[p + 100 >> 2] = s, e[A >> 2] = 0, e[A + 4 >> 2] = 0, e[A + 8 >> 2] = 0, e[5996] = 0, s = pi(97, p + 96 | 0, 5242) | 0, N = e[5996], e[5996] = 0, (N | 0) == 1)
                                                                                break I;
                                                                              if (W = e[s >> 2], e[p + 24 >> 2] = e[s + 4 >> 2], N = me[s + 7 | 0] | me[s + 8 | 0] << 8 | (me[s + 9 | 0] << 16 | me[s + 10 | 0] << 24), _[p + 27 | 0] = N, _[p + 28 | 0] = N >>> 8, _[p + 29 | 0] = N >>> 16, _[p + 30 | 0] = N >>> 24, e[s >> 2] = 0, e[s + 4 >> 2] = 0, N = me[s + 11 | 0], e[s + 8 >> 2] = 0, e[r >> 2] = W, e[r + 4 >> 2] = e[p + 24 >> 2], s = me[p + 27 | 0] | me[p + 28 | 0] << 8 | (me[p + 29 | 0] << 16 | me[p + 30 | 0] << 24), _[r + 7 | 0] = s, _[r + 8 | 0] = s >>> 8, _[r + 9 | 0] = s >>> 16, _[r + 10 | 0] = s >>> 24, _[r + 12 | 0] = 1, _[r + 11 | 0] = N, _[A + 11 | 0] < 0 && Br(e[A >> 2]), _[m + 11 | 0] < 0 && Br(e[m >> 2]), _[u + 11 | 0] >= 0)
                                                                                break t;
                                                                              Br(e[u >> 2]);
                                                                              break t;
                                                                            }
                                                                            r = Hr() | 0;
                                                                            break e;
                                                                          }
                                                                          r = Hr() | 0;
                                                                          break E;
                                                                        }
                                                                        r = Hr() | 0;
                                                                        break h;
                                                                      }
                                                                      r = Hr() | 0;
                                                                      break R;
                                                                    }
                                                                    if (r = Hr() | 0, _[p + 107 | 0] >= 0)
                                                                      break R;
                                                                    Br(e[p + 96 >> 2]);
                                                                  }
                                                                  if (_[p + 91 | 0] >= 0)
                                                                    break h;
                                                                  Br(e[p + 80 >> 2]);
                                                                }
                                                                if (_[p + 75 | 0] >= 0)
                                                                  break E;
                                                                Br(e[p + 64 >> 2]);
                                                              }
                                                              if (_[p + 59 | 0] >= 0)
                                                                break e;
                                                              Br(e[p + 48 >> 2]);
                                                              break e;
                                                            }
                                                            if (!e[e[e[u + 32 >> 2] + 16 >> 2] >> 2]) {
                                                              e[5996] = 0, s = pi(97, p + 116 | 0, 5272) | 0, u = e[5996], e[5996] = 0;
                                                              w: {
                                                                E: {
                                                                  h: {
                                                                    R: {
                                                                      I: {
                                                                        B: {
                                                                          x: {
                                                                            if ((u | 0) != 1) {
                                                                              if (e[p + 56 >> 2] = e[s + 8 >> 2], u = e[s + 4 >> 2], e[p + 48 >> 2] = e[s >> 2], e[p + 52 >> 2] = u, e[s >> 2] = 0, e[s + 4 >> 2] = 0, e[s + 8 >> 2] = 0, u = e[A >> 2], m = e[A + 4 >> 2], s = me[A + 11 | 0], e[5996] = 0, W = u, u = s << 24 >> 24 < 0, u = xn(100, p + 48 | 0, (u ? W : A) | 0, (u ? m : s) | 0) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1)
                                                                                break x;
                                                                              if (e[p + 72 >> 2] = e[u + 8 >> 2], s = e[u + 4 >> 2], e[p + 64 >> 2] = e[u >> 2], e[p + 68 >> 2] = s, e[u >> 2] = 0, e[u + 4 >> 2] = 0, e[u + 8 >> 2] = 0, e[5996] = 0, m = pi(97, p - -64 | 0, 4354) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1)
                                                                                break B;
                                                                              if (e[p + 88 >> 2] = e[m + 8 >> 2], s = e[m + 4 >> 2], e[p + 80 >> 2] = e[m >> 2], e[p + 84 >> 2] = s, e[m >> 2] = 0, e[m + 4 >> 2] = 0, e[m + 8 >> 2] = 0, N = e[A + 16 >> 2], W = e[A + 12 >> 2], s = me[A + 23 | 0], e[5996] = 0, Te = A + 12 | 0, A = s << 24 >> 24 < 0, A = xn(100, p + 80 | 0, (A ? W : Te) | 0, (A ? N : s) | 0) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1)
                                                                                break I;
                                                                              if (e[p + 104 >> 2] = e[A + 8 >> 2], s = e[A + 4 >> 2], e[p + 96 >> 2] = e[A >> 2], e[p + 100 >> 2] = s, e[A >> 2] = 0, e[A + 4 >> 2] = 0, e[A + 8 >> 2] = 0, e[5996] = 0, s = pi(97, p + 96 | 0, 5242) | 0, N = e[5996], e[5996] = 0, (N | 0) == 1)
                                                                                break R;
                                                                              if (W = e[s >> 2], e[p + 24 >> 2] = e[s + 4 >> 2], N = me[s + 7 | 0] | me[s + 8 | 0] << 8 | (me[s + 9 | 0] << 16 | me[s + 10 | 0] << 24), _[p + 27 | 0] = N, _[p + 28 | 0] = N >>> 8, _[p + 29 | 0] = N >>> 16, _[p + 30 | 0] = N >>> 24, e[s >> 2] = 0, e[s + 4 >> 2] = 0, N = me[s + 11 | 0], e[s + 8 >> 2] = 0, e[r >> 2] = W, e[r + 4 >> 2] = e[p + 24 >> 2], s = me[p + 27 | 0] | me[p + 28 | 0] << 8 | (me[p + 29 | 0] << 16 | me[p + 30 | 0] << 24), _[r + 7 | 0] = s, _[r + 8 | 0] = s >>> 8, _[r + 9 | 0] = s >>> 16, _[r + 10 | 0] = s >>> 24, _[r + 12 | 0] = 1, _[r + 11 | 0] = N, _[A + 11 | 0] < 0 && Br(e[A >> 2]), _[m + 11 | 0] < 0 && Br(e[m >> 2]), _[u + 11 | 0] >= 0)
                                                                                break t;
                                                                              Br(e[u >> 2]);
                                                                              break t;
                                                                            }
                                                                            r = Hr() | 0;
                                                                            break e;
                                                                          }
                                                                          r = Hr() | 0;
                                                                          break w;
                                                                        }
                                                                        r = Hr() | 0;
                                                                        break E;
                                                                      }
                                                                      r = Hr() | 0;
                                                                      break h;
                                                                    }
                                                                    if (r = Hr() | 0, _[p + 107 | 0] >= 0)
                                                                      break h;
                                                                    Br(e[p + 96 >> 2]);
                                                                  }
                                                                  if (_[p + 91 | 0] >= 0)
                                                                    break E;
                                                                  Br(e[p + 80 >> 2]);
                                                                }
                                                                if (_[p + 75 | 0] >= 0)
                                                                  break w;
                                                                Br(e[p + 64 >> 2]);
                                                              }
                                                              if (_[p + 59 | 0] >= 0)
                                                                break e;
                                                              Br(e[p + 48 >> 2]);
                                                              break e;
                                                            }
                                                            e[5996] = 0, s = pi(97, p + 116 | 0, 5251) | 0, u = e[5996], e[5996] = 0;
                                                            w: {
                                                              E: {
                                                                h: {
                                                                  R: {
                                                                    I: {
                                                                      B: {
                                                                        x: {
                                                                          b: {
                                                                            C: {
                                                                              y: {
                                                                                D: {
                                                                                  if ((u | 0) != 1) {
                                                                                    if (e[p + 16 >> 2] = e[s + 8 >> 2], u = e[s + 4 >> 2], e[p + 8 >> 2] = e[s >> 2], e[p + 12 >> 2] = u, e[s >> 2] = 0, e[s + 4 >> 2] = 0, e[s + 8 >> 2] = 0, u = e[A >> 2], m = e[A + 4 >> 2], s = me[A + 11 | 0], e[5996] = 0, W = u, u = s << 24 >> 24 < 0, u = xn(100, p + 8 | 0, (u ? W : A) | 0, (u ? m : s) | 0) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1)
                                                                                      break D;
                                                                                    if (e[p + 32 >> 2] = e[u + 8 >> 2], s = e[u + 4 >> 2], e[p + 24 >> 2] = e[u >> 2], e[p + 28 >> 2] = s, e[u >> 2] = 0, e[u + 4 >> 2] = 0, e[u + 8 >> 2] = 0, e[5996] = 0, m = pi(97, p + 24 | 0, 4354) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1)
                                                                                      break y;
                                                                                    if (e[p + 56 >> 2] = e[m + 8 >> 2], s = e[m + 4 >> 2], e[p + 48 >> 2] = e[m >> 2], e[p + 52 >> 2] = s, e[m >> 2] = 0, e[m + 4 >> 2] = 0, e[m + 8 >> 2] = 0, N = e[A + 16 >> 2], W = e[A + 12 >> 2], s = me[A + 23 | 0], e[5996] = 0, Te = W, W = s << 24 >> 24 < 0, N = xn(100, p + 48 | 0, (W ? Te : A + 12 | 0) | 0, (W ? N : s) | 0) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1)
                                                                                      break C;
                                                                                    if (e[p + 72 >> 2] = e[N + 8 >> 2], s = e[N + 4 >> 2], e[p + 64 >> 2] = e[N >> 2], e[p + 68 >> 2] = s, e[N >> 2] = 0, e[N + 4 >> 2] = 0, e[N + 8 >> 2] = 0, e[5996] = 0, W = pi(97, p - -64 | 0, 4354) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1)
                                                                                      break b;
                                                                                    if (e[p + 88 >> 2] = e[W + 8 >> 2], s = e[W + 4 >> 2], e[p + 80 >> 2] = e[W >> 2], e[p + 84 >> 2] = s, e[W >> 2] = 0, e[W + 4 >> 2] = 0, e[W + 8 >> 2] = 0, Te = e[A + 28 >> 2], Xe = e[A + 24 >> 2], s = me[A + 35 | 0], e[5996] = 0, fr = A + 24 | 0, A = s << 24 >> 24 < 0, A = xn(100, p + 80 | 0, (A ? Xe : fr) | 0, (A ? Te : s) | 0) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1)
                                                                                      break x;
                                                                                    if (e[p + 104 >> 2] = e[A + 8 >> 2], s = e[A + 4 >> 2], e[p + 96 >> 2] = e[A >> 2], e[p + 100 >> 2] = s, e[A >> 2] = 0, e[A + 4 >> 2] = 0, e[A + 8 >> 2] = 0, e[5996] = 0, s = pi(97, p + 96 | 0, 5242) | 0, Te = e[5996], e[5996] = 0, (Te | 0) == 1)
                                                                                      break B;
                                                                                    if (Xe = e[s >> 2], e[p + 40 >> 2] = e[s + 4 >> 2], Te = me[s + 7 | 0] | me[s + 8 | 0] << 8 | (me[s + 9 | 0] << 16 | me[s + 10 | 0] << 24), _[p + 43 | 0] = Te, _[p + 44 | 0] = Te >>> 8, _[p + 45 | 0] = Te >>> 16, _[p + 46 | 0] = Te >>> 24, e[s >> 2] = 0, e[s + 4 >> 2] = 0, Te = me[s + 11 | 0], e[s + 8 >> 2] = 0, e[r >> 2] = Xe, e[r + 4 >> 2] = e[p + 40 >> 2], s = me[p + 43 | 0] | me[p + 44 | 0] << 8 | (me[p + 45 | 0] << 16 | me[p + 46 | 0] << 24), _[r + 7 | 0] = s, _[r + 8 | 0] = s >>> 8, _[r + 9 | 0] = s >>> 16, _[r + 10 | 0] = s >>> 24, _[r + 12 | 0] = 1, _[r + 11 | 0] = Te, _[A + 11 | 0] < 0 && Br(e[A >> 2]), _[W + 11 | 0] < 0 && Br(e[W >> 2]), _[N + 11 | 0] < 0 && Br(e[N >> 2]), _[m + 11 | 0] < 0 && Br(e[m >> 2]), _[u + 11 | 0] >= 0)
                                                                                      break t;
                                                                                    Br(e[u >> 2]);
                                                                                    break t;
                                                                                  }
                                                                                  r = Hr() | 0;
                                                                                  break e;
                                                                                }
                                                                                r = Hr() | 0;
                                                                                break w;
                                                                              }
                                                                              r = Hr() | 0;
                                                                              break E;
                                                                            }
                                                                            r = Hr() | 0;
                                                                            break h;
                                                                          }
                                                                          r = Hr() | 0;
                                                                          break R;
                                                                        }
                                                                        r = Hr() | 0;
                                                                        break I;
                                                                      }
                                                                      if (r = Hr() | 0, _[p + 107 | 0] >= 0)
                                                                        break I;
                                                                      Br(e[p + 96 >> 2]);
                                                                    }
                                                                    if (_[p + 91 | 0] >= 0)
                                                                      break R;
                                                                    Br(e[p + 80 >> 2]);
                                                                  }
                                                                  if (_[p + 75 | 0] >= 0)
                                                                    break h;
                                                                  Br(e[p + 64 >> 2]);
                                                                }
                                                                if (_[p + 59 | 0] >= 0)
                                                                  break E;
                                                                Br(e[p + 48 >> 2]);
                                                              }
                                                              if (_[p + 35 | 0] >= 0)
                                                                break w;
                                                              Br(e[p + 24 >> 2]);
                                                            }
                                                            if (_[p + 19 | 0] >= 0)
                                                              break e;
                                                            Br(e[p + 8 >> 2]);
                                                            break e;
                                                          }
                                                          if (e[5996] = 0, s = pi(97, p + 116 | 0, 5289) | 0, A = e[5996], e[5996] = 0, (A | 0) == 1)
                                                            break A;
                                                          if (e[p + 72 >> 2] = e[s + 8 >> 2], A = e[s + 4 >> 2], e[p + 64 >> 2] = e[s >> 2], e[p + 68 >> 2] = A, e[s >> 2] = 0, e[s + 4 >> 2] = 0, e[s + 8 >> 2] = 0, e[5996] = 0, s = p + 96 | 0, ji(119, s | 0, u + 4 | 0), A = e[5996], e[5996] = 0, (A | 0) == 1)
                                                            break m;
                                                          if (e[5996] = 0, m = s, s = me[p + 107 | 0], A = s << 24 >> 24 < 0, s = xn(100, p - -64 | 0, (A ? e[p + 96 >> 2] : m) | 0, (A ? e[p + 100 >> 2] : s) | 0) | 0, A = e[5996], e[5996] = 0, (A | 0) == 1)
                                                            break k;
                                                          e[p + 88 >> 2] = e[s + 8 >> 2], A = e[s + 4 >> 2], e[p + 80 >> 2] = e[s >> 2], e[p + 84 >> 2] = A, e[s >> 2] = 0, e[s + 4 >> 2] = 0, e[s + 8 >> 2] = 0;
                                                          v: {
                                                            if (_[p + 107 | 0] >= 0 || (Br(e[p + 96 >> 2]), _[s + 11 | 0] >= 0))
                                                              break v;
                                                            Br(e[s >> 2]);
                                                          }
                                                          v: {
                                                            w: {
                                                              E: {
                                                                h: {
                                                                  R: {
                                                                    if (s = e[u + 8 >> 2], A = e[u + 12 >> 2], (s | 0) != (A | 0))
                                                                      for (; ; ) {
                                                                        I: {
                                                                          if (_[s + 11 | 0] >= 0) {
                                                                            e[p + 104 >> 2] = e[s + 8 >> 2], u = e[s + 4 >> 2], e[p + 96 >> 2] = e[s >> 2], e[p + 100 >> 2] = u;
                                                                            break I;
                                                                          }
                                                                          if (u = e[s + 4 >> 2], m = e[s >> 2], e[5996] = 0, gs(40, p + 96 | 0, m | 0, u | 0), u = e[5996], e[5996] = 0, (u | 0) != 1)
                                                                            break I;
                                                                          r = Hr() | 0;
                                                                          break w;
                                                                        }
                                                                        if (e[5996] = 0, _[p + 108 | 0] = 1, u = xn(99, p + 96 | 0, 0, 4354) | 0, m = e[5996], e[5996] = 0, (m | 0) == 1)
                                                                          break R;
                                                                        if (e[p + 56 >> 2] = e[u + 8 >> 2], m = e[u + 4 >> 2], e[p + 48 >> 2] = e[u >> 2], e[p + 52 >> 2] = m, e[u >> 2] = 0, e[u + 4 >> 2] = 0, e[u + 8 >> 2] = 0, e[5996] = 0, m = me[p + 59 | 0], N = m << 24 >> 24 < 0, xn(100, p + 80 | 0, (N ? e[p + 48 >> 2] : p + 48 | 0) | 0, (N ? e[p + 52 >> 2] : m) | 0) | 0, m = e[5996], e[5996] = 0, (m | 0) == 1)
                                                                          break h;
                                                                        if (_[p + 59 | 0] < 0 && Br(e[p + 48 >> 2]), !me[p + 108 | 0] | _[p + 107 | 0] >= 0 || Br(e[u >> 2]), s = s + 12 | 0, (A | 0) == (s | 0))
                                                                          break;
                                                                      }
                                                                    if (e[5996] = 0, s = pi(97, p + 80 | 0, 5242) | 0, u = e[5996], e[5996] = 0, (u | 0) != 1)
                                                                      break v;
                                                                    r = Hr() | 0;
                                                                    break w;
                                                                  }
                                                                  r = Hr() | 0;
                                                                  break E;
                                                                }
                                                                if (r = Hr() | 0, _[p + 59 | 0] >= 0)
                                                                  break E;
                                                                Br(e[p + 48 >> 2]);
                                                              }
                                                              if (!me[p + 108 | 0] | _[p + 107 | 0] >= 0)
                                                                break w;
                                                              Br(e[p + 96 >> 2]);
                                                            }
                                                            if (_[p + 91 | 0] >= 0)
                                                              break e;
                                                            Br(e[p + 80 >> 2]);
                                                            break e;
                                                          }
                                                          A = e[s >> 2], e[p + 48 >> 2] = e[s + 4 >> 2], u = me[s + 7 | 0] | me[s + 8 | 0] << 8 | (me[s + 9 | 0] << 16 | me[s + 10 | 0] << 24), _[p + 51 | 0] = u, _[p + 52 | 0] = u >>> 8, _[p + 53 | 0] = u >>> 16, _[p + 54 | 0] = u >>> 24, e[s >> 2] = 0, e[s + 4 >> 2] = 0, u = me[s + 11 | 0], e[s + 8 >> 2] = 0, e[r >> 2] = A, e[r + 4 >> 2] = e[p + 48 >> 2], s = me[p + 51 | 0] | me[p + 52 | 0] << 8 | (me[p + 53 | 0] << 16 | me[p + 54 | 0] << 24), _[r + 7 | 0] = s, _[r + 8 | 0] = s >>> 8, _[r + 9 | 0] = s >>> 16, _[r + 10 | 0] = s >>> 24, _[r + 12 | 0] = 1, _[r + 11 | 0] = u;
                                                          break t;
                                                        }
                                                        r = Hr() | 0;
                                                        break e;
                                                      }
                                                      if (e[5996] = 0, Vs(44, 2350, 2210, 725, 5107), r = e[5996], e[5996] = 0, (r | 0) == 1) {
                                                        r = Hr() | 0;
                                                        break e;
                                                      }
                                                      Oi();
                                                    }
                                                    e[5996] = 0, s = pi(97, p + 116 | 0, 5302) | 0, N = e[5996], e[5996] = 0;
                                                    N: {
                                                      S: {
                                                        T: {
                                                          v: {
                                                            w: {
                                                              E: {
                                                                h: {
                                                                  if ((N | 0) != 1) {
                                                                    if (e[p + 88 >> 2] = e[s + 8 >> 2], N = e[s + 4 >> 2], e[p + 80 >> 2] = e[s >> 2], e[p + 84 >> 2] = N, e[s >> 2] = 0, e[s + 4 >> 2] = 0, e[s + 8 >> 2] = 0, e[5996] = 0, s = p - -64 | 0, ji(119, s | 0, u + 4 | 0), u = e[5996], e[5996] = 0, (u | 0) == 1)
                                                                      break h;
                                                                    if (e[5996] = 0, W = s, s = me[p + 75 | 0], u = s << 24 >> 24 < 0, s = xn(100, p + 80 | 0, (u ? e[p + 64 >> 2] : W) | 0, (u ? e[p + 68 >> 2] : s) | 0) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1)
                                                                      break E;
                                                                    e[p + 104 >> 2] = e[s + 8 >> 2], u = e[s + 4 >> 2], e[p + 96 >> 2] = e[s >> 2], e[p + 100 >> 2] = u, e[s >> 2] = 0, e[s + 4 >> 2] = 0, e[s + 8 >> 2] = 0;
                                                                    R: {
                                                                      if (_[p + 75 | 0] >= 0 || (Br(e[p + 64 >> 2]), _[s + 11 | 0] >= 0))
                                                                        break R;
                                                                      Br(e[s >> 2]);
                                                                    }
                                                                    if (m)
                                                                      for (u = Sn(m, 12) + A | 0; ; ) {
                                                                        if (e[5996] = 0, s = xn(99, A | 0, 0, 4354) | 0, A = e[5996], e[5996] = 0, (A | 0) == 1)
                                                                          break v;
                                                                        if (e[p + 72 >> 2] = e[s + 8 >> 2], A = e[s + 4 >> 2], e[p + 64 >> 2] = e[s >> 2], e[p + 68 >> 2] = A, e[s >> 2] = 0, e[s + 4 >> 2] = 0, e[s + 8 >> 2] = 0, e[5996] = 0, A = me[p + 75 | 0], m = A << 24 >> 24 < 0, xn(100, p + 96 | 0, (m ? e[p + 64 >> 2] : p - -64 | 0) | 0, (m ? e[p + 68 >> 2] : A) | 0) | 0, A = e[5996], e[5996] = 0, (A | 0) == 1)
                                                                          break T;
                                                                        if (_[p + 75 | 0] < 0 && Br(e[p + 64 >> 2]), A = s + 12 | 0, (u | 0) == (A | 0))
                                                                          break;
                                                                      }
                                                                    if (e[5996] = 0, s = pi(97, p + 96 | 0, 5242) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1)
                                                                      break S;
                                                                    A = e[s >> 2], e[p + 64 >> 2] = e[s + 4 >> 2], u = me[s + 7 | 0] | me[s + 8 | 0] << 8 | (me[s + 9 | 0] << 16 | me[s + 10 | 0] << 24), _[p + 67 | 0] = u, _[p + 68 | 0] = u >>> 8, _[p + 69 | 0] = u >>> 16, _[p + 70 | 0] = u >>> 24, e[s >> 2] = 0, e[s + 4 >> 2] = 0, u = me[s + 11 | 0], e[s + 8 >> 2] = 0, e[r >> 2] = A, e[r + 4 >> 2] = e[p + 64 >> 2], s = me[p + 67 | 0] | me[p + 68 | 0] << 8 | (me[p + 69 | 0] << 16 | me[p + 70 | 0] << 24), _[r + 7 | 0] = s, _[r + 8 | 0] = s >>> 8, _[r + 9 | 0] = s >>> 16, _[r + 10 | 0] = s >>> 24, _[r + 12 | 0] = 1, _[r + 11 | 0] = u;
                                                                    break t;
                                                                  }
                                                                  r = Hr() | 0;
                                                                  break e;
                                                                }
                                                                r = Hr() | 0;
                                                                break w;
                                                              }
                                                              if (r = Hr() | 0, _[p + 75 | 0] >= 0)
                                                                break w;
                                                              Br(e[p + 64 >> 2]);
                                                            }
                                                            if (_[p + 91 | 0] >= 0)
                                                              break e;
                                                            Br(e[p + 80 >> 2]);
                                                            break e;
                                                          }
                                                          r = Hr() | 0;
                                                          break N;
                                                        }
                                                        if (r = Hr() | 0, _[p + 75 | 0] >= 0)
                                                          break N;
                                                        Br(e[p + 64 >> 2]);
                                                        break N;
                                                      }
                                                      r = Hr() | 0;
                                                    }
                                                    if (_[p + 107 | 0] >= 0)
                                                      break e;
                                                    Br(e[p + 96 >> 2]);
                                                    break e;
                                                  }
                                                  if (r = Hr() | 0, _[p + 107 | 0] >= 0)
                                                    break p;
                                                  Br(e[p + 96 >> 2]);
                                                  break p;
                                                }
                                                r = Hr() | 0;
                                              }
                                              if (_[p + 75 | 0] >= 0)
                                                break e;
                                              Br(e[p + 64 >> 2]);
                                              break e;
                                            }
                                            r = Hr() | 0;
                                            break e;
                                          }
                                          r = Hr() | 0;
                                        }
                                        if (_[p + 75 | 0] < 0 && Br(e[p + 64 >> 2]), _[p + 91 | 0] >= 0)
                                          break e;
                                        Br(e[p + 80 >> 2]);
                                        break e;
                                      }
                                      r = Hr() | 0;
                                    }
                                    if (_[p + 75 | 0] < 0 && Br(e[p + 64 >> 2]), _[p + 91 | 0] >= 0)
                                      break e;
                                    Br(e[p + 80 >> 2]);
                                    break e;
                                  }
                                  r = Hr() | 0;
                                }
                                if (_[p + 75 | 0] < 0 && Br(e[p + 64 >> 2]), _[p + 91 | 0] >= 0)
                                  break e;
                                Br(e[p + 80 >> 2]);
                                break e;
                              }
                              r = Hr() | 0;
                            }
                            if (_[p + 75 | 0] < 0 && Br(e[p + 64 >> 2]), _[p + 91 | 0] >= 0)
                              break e;
                            Br(e[p + 80 >> 2]);
                            break e;
                          }
                          e[5996] = 0, _[p + 108 | 0] = 1, s = pi(97, p + 116 | 0, 5315) | 0, u = e[5996], e[5996] = 0;
                          s: {
                            a: {
                              o: {
                                l: {
                                  if ((u | 0) != 1) {
                                    if (e[p + 72 >> 2] = e[s + 8 >> 2], u = e[s + 4 >> 2], e[p + 64 >> 2] = e[s >> 2], e[p + 68 >> 2] = u, e[s >> 2] = 0, e[s + 4 >> 2] = 0, e[s + 8 >> 2] = 0, e[5996] = 0, s = me[p + 107 | 0], u = s << 24 >> 24 < 0, u = xn(100, p - -64 | 0, (u ? e[p + 96 >> 2] : p + 96 | 0) | 0, (u ? e[p + 100 >> 2] : s) | 0) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1)
                                      break l;
                                    if (e[p + 88 >> 2] = e[u + 8 >> 2], s = e[u + 4 >> 2], e[p + 80 >> 2] = e[u >> 2], e[p + 84 >> 2] = s, e[u >> 2] = 0, e[u + 4 >> 2] = 0, e[u + 8 >> 2] = 0, e[5996] = 0, s = pi(97, p + 80 | 0, 5242) | 0, A = e[5996], e[5996] = 0, (A | 0) == 1)
                                      break o;
                                    if (m = e[s >> 2], e[p + 48 >> 2] = e[s + 4 >> 2], A = me[s + 7 | 0] | me[s + 8 | 0] << 8 | (me[s + 9 | 0] << 16 | me[s + 10 | 0] << 24), _[p + 51 | 0] = A, _[p + 52 | 0] = A >>> 8, _[p + 53 | 0] = A >>> 16, _[p + 54 | 0] = A >>> 24, e[s >> 2] = 0, e[s + 4 >> 2] = 0, A = me[s + 11 | 0], e[s + 8 >> 2] = 0, e[r >> 2] = m, e[r + 4 >> 2] = e[p + 48 >> 2], s = me[p + 51 | 0] | me[p + 52 | 0] << 8 | (me[p + 53 | 0] << 16 | me[p + 54 | 0] << 24), _[r + 7 | 0] = s, _[r + 8 | 0] = s >>> 8, _[r + 9 | 0] = s >>> 16, _[r + 10 | 0] = s >>> 24, _[r + 12 | 0] = 1, _[r + 11 | 0] = A, _[u + 11 | 0] < 0 && Br(e[u >> 2]), !me[p + 108 | 0] | _[p + 107 | 0] >= 0)
                                      break t;
                                    Br(e[p + 96 >> 2]);
                                    break t;
                                  }
                                  r = Hr() | 0;
                                  break s;
                                }
                                r = Hr() | 0;
                                break a;
                              }
                              if (r = Hr() | 0, _[p + 91 | 0] >= 0)
                                break a;
                              Br(e[p + 80 >> 2]);
                            }
                            if (_[p + 75 | 0] >= 0)
                              break s;
                            Br(e[p + 64 >> 2]);
                          }
                          if (!me[p + 108 | 0] | _[p + 107 | 0] >= 0)
                            break e;
                          Br(e[p + 96 >> 2]);
                          break e;
                        }
                        e[5996] = 0, _[p + 108 | 0] = 1, s = pi(97, p + 116 | 0, 5283) | 0, u = e[5996], e[5996] = 0;
                        n: {
                          s: {
                            a: {
                              o: {
                                if ((u | 0) != 1) {
                                  if (e[p + 72 >> 2] = e[s + 8 >> 2], u = e[s + 4 >> 2], e[p + 64 >> 2] = e[s >> 2], e[p + 68 >> 2] = u, e[s >> 2] = 0, e[s + 4 >> 2] = 0, e[s + 8 >> 2] = 0, e[5996] = 0, s = me[p + 107 | 0], u = s << 24 >> 24 < 0, u = xn(100, p - -64 | 0, (u ? e[p + 96 >> 2] : p + 96 | 0) | 0, (u ? e[p + 100 >> 2] : s) | 0) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1)
                                    break o;
                                  if (e[p + 88 >> 2] = e[u + 8 >> 2], s = e[u + 4 >> 2], e[p + 80 >> 2] = e[u >> 2], e[p + 84 >> 2] = s, e[u >> 2] = 0, e[u + 4 >> 2] = 0, e[u + 8 >> 2] = 0, e[5996] = 0, s = pi(97, p + 80 | 0, 5242) | 0, A = e[5996], e[5996] = 0, (A | 0) == 1)
                                    break a;
                                  if (m = e[s >> 2], e[p + 48 >> 2] = e[s + 4 >> 2], A = me[s + 7 | 0] | me[s + 8 | 0] << 8 | (me[s + 9 | 0] << 16 | me[s + 10 | 0] << 24), _[p + 51 | 0] = A, _[p + 52 | 0] = A >>> 8, _[p + 53 | 0] = A >>> 16, _[p + 54 | 0] = A >>> 24, e[s >> 2] = 0, e[s + 4 >> 2] = 0, A = me[s + 11 | 0], e[s + 8 >> 2] = 0, e[r >> 2] = m, e[r + 4 >> 2] = e[p + 48 >> 2], s = me[p + 51 | 0] | me[p + 52 | 0] << 8 | (me[p + 53 | 0] << 16 | me[p + 54 | 0] << 24), _[r + 7 | 0] = s, _[r + 8 | 0] = s >>> 8, _[r + 9 | 0] = s >>> 16, _[r + 10 | 0] = s >>> 24, _[r + 12 | 0] = 1, _[r + 11 | 0] = A, _[u + 11 | 0] < 0 && Br(e[u >> 2]), !me[p + 108 | 0] | _[p + 107 | 0] >= 0)
                                    break t;
                                  Br(e[p + 96 >> 2]);
                                  break t;
                                }
                                r = Hr() | 0;
                                break n;
                              }
                              r = Hr() | 0;
                              break s;
                            }
                            if (r = Hr() | 0, _[p + 91 | 0] >= 0)
                              break s;
                            Br(e[p + 80 >> 2]);
                          }
                          if (_[p + 75 | 0] >= 0)
                            break n;
                          Br(e[p + 64 >> 2]);
                        }
                        if (!me[p + 108 | 0] | _[p + 107 | 0] >= 0)
                          break e;
                        Br(e[p + 96 >> 2]);
                        break e;
                      }
                      e[5996] = 0, _[p + 108 | 0] = 1, s = pi(97, p + 116 | 0, 5310) | 0, u = e[5996], e[5996] = 0;
                      i: {
                        n: {
                          s: {
                            a: {
                              if ((u | 0) != 1) {
                                if (e[p + 72 >> 2] = e[s + 8 >> 2], u = e[s + 4 >> 2], e[p + 64 >> 2] = e[s >> 2], e[p + 68 >> 2] = u, e[s >> 2] = 0, e[s + 4 >> 2] = 0, e[s + 8 >> 2] = 0, e[5996] = 0, s = me[p + 107 | 0], u = s << 24 >> 24 < 0, u = xn(100, p - -64 | 0, (u ? e[p + 96 >> 2] : p + 96 | 0) | 0, (u ? e[p + 100 >> 2] : s) | 0) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1)
                                  break a;
                                if (e[p + 88 >> 2] = e[u + 8 >> 2], s = e[u + 4 >> 2], e[p + 80 >> 2] = e[u >> 2], e[p + 84 >> 2] = s, e[u >> 2] = 0, e[u + 4 >> 2] = 0, e[u + 8 >> 2] = 0, e[5996] = 0, s = pi(97, p + 80 | 0, 5242) | 0, A = e[5996], e[5996] = 0, (A | 0) == 1)
                                  break s;
                                if (m = e[s >> 2], e[p + 48 >> 2] = e[s + 4 >> 2], A = me[s + 7 | 0] | me[s + 8 | 0] << 8 | (me[s + 9 | 0] << 16 | me[s + 10 | 0] << 24), _[p + 51 | 0] = A, _[p + 52 | 0] = A >>> 8, _[p + 53 | 0] = A >>> 16, _[p + 54 | 0] = A >>> 24, e[s >> 2] = 0, e[s + 4 >> 2] = 0, A = me[s + 11 | 0], e[s + 8 >> 2] = 0, e[r >> 2] = m, e[r + 4 >> 2] = e[p + 48 >> 2], s = me[p + 51 | 0] | me[p + 52 | 0] << 8 | (me[p + 53 | 0] << 16 | me[p + 54 | 0] << 24), _[r + 7 | 0] = s, _[r + 8 | 0] = s >>> 8, _[r + 9 | 0] = s >>> 16, _[r + 10 | 0] = s >>> 24, _[r + 12 | 0] = 1, _[r + 11 | 0] = A, _[u + 11 | 0] < 0 && Br(e[u >> 2]), !me[p + 108 | 0] | _[p + 107 | 0] >= 0)
                                  break t;
                                Br(e[p + 96 >> 2]);
                                break t;
                              }
                              r = Hr() | 0;
                              break i;
                            }
                            r = Hr() | 0;
                            break n;
                          }
                          if (r = Hr() | 0, _[p + 91 | 0] >= 0)
                            break n;
                          Br(e[p + 80 >> 2]);
                        }
                        if (_[p + 75 | 0] >= 0)
                          break i;
                        Br(e[p + 64 >> 2]);
                      }
                      if (!me[p + 108 | 0] | _[p + 107 | 0] >= 0)
                        break e;
                      Br(e[p + 96 >> 2]);
                      break e;
                    }
                    e[5996] = 0, _[p + 108 | 0] = 1, s = pi(97, p + 116 | 0, 5279) | 0, u = e[5996], e[5996] = 0;
                    r: {
                      i: {
                        n: {
                          s: {
                            if ((u | 0) != 1) {
                              if (e[p + 72 >> 2] = e[s + 8 >> 2], u = e[s + 4 >> 2], e[p + 64 >> 2] = e[s >> 2], e[p + 68 >> 2] = u, e[s >> 2] = 0, e[s + 4 >> 2] = 0, e[s + 8 >> 2] = 0, e[5996] = 0, s = me[p + 107 | 0], u = s << 24 >> 24 < 0, u = xn(100, p - -64 | 0, (u ? e[p + 96 >> 2] : p + 96 | 0) | 0, (u ? e[p + 100 >> 2] : s) | 0) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1)
                                break s;
                              if (e[p + 88 >> 2] = e[u + 8 >> 2], s = e[u + 4 >> 2], e[p + 80 >> 2] = e[u >> 2], e[p + 84 >> 2] = s, e[u >> 2] = 0, e[u + 4 >> 2] = 0, e[u + 8 >> 2] = 0, e[5996] = 0, s = pi(97, p + 80 | 0, 5242) | 0, A = e[5996], e[5996] = 0, (A | 0) == 1)
                                break n;
                              if (m = e[s >> 2], e[p + 48 >> 2] = e[s + 4 >> 2], A = me[s + 7 | 0] | me[s + 8 | 0] << 8 | (me[s + 9 | 0] << 16 | me[s + 10 | 0] << 24), _[p + 51 | 0] = A, _[p + 52 | 0] = A >>> 8, _[p + 53 | 0] = A >>> 16, _[p + 54 | 0] = A >>> 24, e[s >> 2] = 0, e[s + 4 >> 2] = 0, A = me[s + 11 | 0], e[s + 8 >> 2] = 0, e[r >> 2] = m, e[r + 4 >> 2] = e[p + 48 >> 2], s = me[p + 51 | 0] | me[p + 52 | 0] << 8 | (me[p + 53 | 0] << 16 | me[p + 54 | 0] << 24), _[r + 7 | 0] = s, _[r + 8 | 0] = s >>> 8, _[r + 9 | 0] = s >>> 16, _[r + 10 | 0] = s >>> 24, _[r + 12 | 0] = 1, _[r + 11 | 0] = A, _[u + 11 | 0] < 0 && Br(e[u >> 2]), !me[p + 108 | 0] | _[p + 107 | 0] >= 0)
                                break t;
                              Br(e[p + 96 >> 2]);
                              break t;
                            }
                            r = Hr() | 0;
                            break r;
                          }
                          r = Hr() | 0;
                          break i;
                        }
                        if (r = Hr() | 0, _[p + 91 | 0] >= 0)
                          break i;
                        Br(e[p + 80 >> 2]);
                      }
                      if (_[p + 75 | 0] >= 0)
                        break r;
                      Br(e[p + 64 >> 2]);
                    }
                    if (!me[p + 108 | 0] | _[p + 107 | 0] >= 0)
                      break e;
                    Br(e[p + 96 >> 2]);
                    break e;
                  }
                  _[p + 127 | 0] < 0 && Br(e[p + 116 >> 2]), Jr = p + 128 | 0;
                  return;
                }
                _[p + 127 | 0] < 0 && Br(e[p + 116 >> 2]), Jn(r | 0), Oi();
              }
              function J1(r, s, u, A, m) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0, m = m | 0;
                var p = 0, N = 0, W = 0, Te = 0, Xe = 0, fr = 0, ar = 0, vr = 0, _r = 0, hi = 0, mi = 0;
                W = Jr - 112 | 0, Jr = W;
                e: {
                  t: {
                    r: {
                      i: {
                        n: {
                          s: {
                            a: {
                              o: {
                                l: {
                                  c:
                                    switch (e[u >> 2]) {
                                      case 2:
                                        if (p = e[u + 8 >> 2], u = Qs(4), e[W + 48 >> 2] = u, s = u + 4 | 0, e[W + 56 >> 2] = s, _[u | 0] = 2, _[u + 1 | 0] = 80, _[u + 2 | 0] = 75, _[u + 3 | 0] = 98, e[W + 52 >> 2] = s, e[5996] = 0, _[W + 16 | 0] = 0, A = W + 48 | 0, gs(126, A | 0, 29, W + 16 | 0), s = e[5996], e[5996] = 0, (s | 0) == 1)
                                          break r;
                                        if (m = e[W + 48 >> 2], u = me[p + 11 | 0], s = u << 24 >> 24 < 0, Ys(m + 4 | 0, s ? e[p >> 2] : p, s ? e[p + 4 >> 2] : u), _[r + 24 | 0] = 0, _[r + 25 | 0] = 0, _[r + 26 | 0] = 0, _[r + 27 | 0] = 0, _[r + 28 | 0] = 0, _[r + 29 | 0] = 0, _[r + 30 | 0] = 0, _[r + 31 | 0] = 0, _[r + 16 | 0] = 0, _[r + 17 | 0] = 0, _[r + 18 | 0] = 0, _[r + 19 | 0] = 0, _[r + 20 | 0] = 0, _[r + 21 | 0] = 0, _[r + 22 | 0] = 0, _[r + 23 | 0] = 0, _[r + 8 | 0] = 0, _[r + 9 | 0] = 0, _[r + 10 | 0] = 0, _[r + 11 | 0] = 0, _[r + 12 | 0] = 0, _[r + 13 | 0] = 0, _[r + 14 | 0] = 0, _[r + 15 | 0] = 0, _[r | 0] = 0, _[r + 1 | 0] = 0, _[r + 2 | 0] = 0, _[r + 3 | 0] = 0, _[r + 4 | 0] = 0, _[r + 5 | 0] = 0, _[r + 6 | 0] = 0, _[r + 7 | 0] = 0, e[5996] = 0, pi(19, r | 0, A | 0) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1) {
                                          if (N = Hr() | 0, (me[r | 0] | me[r + 1 | 0] << 8 | (me[r + 2 | 0] << 16 | me[r + 3 | 0] << 24)) >>> 0 >= 29 && (Br(me[r + 8 | 0] | me[r + 9 | 0] << 8 | (me[r + 10 | 0] << 16 | me[r + 11 | 0] << 24)), _[r + 8 | 0] = 0, _[r + 9 | 0] = 0, _[r + 10 | 0] = 0, _[r + 11 | 0] = 0), !m)
                                            break e;
                                          Br(m);
                                          break e;
                                        }
                                        if (!m)
                                          break i;
                                        Br(m);
                                        break i;
                                      case 3:
                                        if (A = e[u + 8 >> 2], u = Qs(3), e[W + 48 >> 2] = u, s = u + 3 | 0, e[W + 56 >> 2] = s, _[u + 2 | 0] = 104, _[u | 0] = 80, _[u + 1 | 0] = 75, e[W + 52 >> 2] = s, e[5996] = 0, _[W + 16 | 0] = 0, gs(126, W + 48 | 0, 17, W + 16 | 0), s = e[5996], e[5996] = 0, (s | 0) == 1) {
                                          if (N = Hr() | 0, r = e[W + 48 >> 2], !r)
                                            break e;
                                          Br(r);
                                          break e;
                                        }
                                        if (p = e[W + 48 >> 2], u = me[A + 11 | 0], s = u << 24 >> 24 < 0, Ys(p + 3 | 0, s ? e[A >> 2] : A, s ? e[A + 4 >> 2] : u), _[r + 5 | 0] = 0, _[r + 6 | 0] = 0, _[r + 7 | 0] = 0, _[r + 8 | 0] = 0, _[r + 9 | 0] = 0, _[r + 10 | 0] = 0, _[r + 11 | 0] = 0, _[r + 12 | 0] = 0, _[r + 28 | 0] = 0, _[r + 29 | 0] = 0, _[r + 30 | 0] = 0, _[r + 31 | 0] = 0, _[r + 21 | 0] = 0, _[r + 22 | 0] = 0, _[r + 23 | 0] = 0, _[r + 24 | 0] = 0, _[r + 25 | 0] = 0, _[r + 26 | 0] = 0, _[r + 27 | 0] = 0, _[r + 28 | 0] = 0, _[r + 13 | 0] = 0, _[r + 14 | 0] = 0, _[r + 15 | 0] = 0, _[r + 16 | 0] = 0, _[r + 17 | 0] = 0, _[r + 18 | 0] = 0, _[r + 19 | 0] = 0, _[r + 20 | 0] = 0, _[r | 0] = 2, _[r + 1 | 0] = 0, _[r + 2 | 0] = 0, _[r + 3 | 0] = 0, _[r + 4 | 0] = 118, _[r + 5 | 0] = 169, e[5996] = 0, Te = pi(19, r | 0, W + 48 | 0) | 0, s = e[5996], e[5996] = 0, (s | 0) != 1)
                                          d: {
                                            if (N = me[Te | 0] | me[Te + 1 | 0] << 8 | (me[Te + 2 | 0] << 16 | me[Te + 3 | 0] << 24), m = N - 29 | 0, u = N >>> 0 < 29 ? N : m, s = u + 1 | 0, A = r + 4 | 0, s >>> 0 > (N >>> 0 <= 28 ? 28 : me[A | 0] | me[A + 1 | 0] << 8 | (me[A + 2 | 0] << 16 | me[A + 3 | 0] << 24)) >>> 0) {
                                              if (e[5996] = 0, ji(124, Te | 0, s + (s >>> 1 | 0) | 0), s = e[5996], e[5996] = 0, (s | 0) == 1)
                                                break d;
                                              N = me[Te | 0] | me[Te + 1 | 0] << 8 | (me[Te + 2 | 0] << 16 | me[Te + 3 | 0] << 24), m = N - 29 | 0;
                                            }
                                            if (s = me[r + 8 | 0] | me[r + 9 | 0] << 8 | (me[r + 10 | 0] << 16 | me[r + 11 | 0] << 24), r = N >>> 0 < 29, s = u + (r ? A : s) | 0, Ys(s + 1 | 0, s, (r ? N : m) - u | 0), r = (me[Te | 0] | me[Te + 1 | 0] << 8 | (me[Te + 2 | 0] << 16 | me[Te + 3 | 0] << 24)) + 1 | 0, _[Te | 0] = r, _[Te + 1 | 0] = r >>> 8, _[Te + 2 | 0] = r >>> 16, _[Te + 3 | 0] = r >>> 24, _[s | 0] = 136, !p)
                                              break i;
                                            Br(p);
                                            break i;
                                          }
                                        if (N = Hr() | 0, (me[r | 0] | me[r + 1 | 0] << 8 | (me[r + 2 | 0] << 16 | me[r + 3 | 0] << 24)) >>> 0 >= 29 && (Br(me[r + 8 | 0] | me[r + 9 | 0] << 8 | (me[r + 10 | 0] << 16 | me[r + 11 | 0] << 24)), _[r + 8 | 0] = 0, _[r + 9 | 0] = 0, _[r + 10 | 0] = 0, _[r + 11 | 0] = 0), !p)
                                          break e;
                                        Br(p);
                                        break e;
                                      case 4:
                                        if (_[r | 0] = 0, _[r + 1 | 0] = 0, _[r + 2 | 0] = 0, _[r + 3 | 0] = 0, _[r + 4 | 0] = 0, _[r + 5 | 0] = 0, _[r + 6 | 0] = 0, _[r + 7 | 0] = 0, _[r + 24 | 0] = 0, _[r + 25 | 0] = 0, _[r + 26 | 0] = 0, _[r + 27 | 0] = 0, _[r + 28 | 0] = 0, _[r + 29 | 0] = 0, _[r + 30 | 0] = 0, _[r + 31 | 0] = 0, _[r + 16 | 0] = 0, _[r + 17 | 0] = 0, _[r + 18 | 0] = 0, _[r + 19 | 0] = 0, _[r + 20 | 0] = 0, _[r + 21 | 0] = 0, _[r + 22 | 0] = 0, _[r + 23 | 0] = 0, _[r + 8 | 0] = 0, _[r + 9 | 0] = 0, _[r + 10 | 0] = 0, _[r + 11 | 0] = 0, _[r + 12 | 0] = 0, _[r + 13 | 0] = 0, _[r + 14 | 0] = 0, _[r + 15 | 0] = 0, s = e[u + 4 >> 2], e[5996] = 0, m = uc(r, s, 0), s = e[5996], e[5996] = 0, (s | 0) != 1)
                                          d: {
                                            if (p = me[m | 0] | me[m + 1 | 0] << 8 | (me[m + 2 | 0] << 16 | me[m + 3 | 0] << 24), s = p - 29 | 0, A = p >>> 0 < 29 ? p : s, u = A + 1 | 0, u >>> 0 > (p >>> 0 <= 28 ? 28 : me[m + 4 | 0] | me[m + 5 | 0] << 8 | (me[m + 6 | 0] << 16 | me[m + 7 | 0] << 24)) >>> 0) {
                                              if (e[5996] = 0, ji(124, m | 0, u + (u >>> 1 | 0) | 0), s = e[5996], e[5996] = 0, (s | 0) == 1)
                                                break d;
                                              p = me[m | 0] | me[m + 1 | 0] << 8 | (me[m + 2 | 0] << 16 | me[m + 3 | 0] << 24), s = p - 29 | 0;
                                            }
                                            r = p >>> 0 < 29, u = A + (r ? m + 4 | 0 : me[m + 8 | 0] | me[m + 9 | 0] << 8 | (me[m + 10 | 0] << 16 | me[m + 11 | 0] << 24)) | 0, Ys(u + 1 | 0, u, (r ? p : s) - A | 0), r = (me[m | 0] | me[m + 1 | 0] << 8 | (me[m + 2 | 0] << 16 | me[m + 3 | 0] << 24)) + 1 | 0, _[m | 0] = r, _[m + 1 | 0] = r >>> 8, _[m + 2 | 0] = r >>> 16, _[m + 3 | 0] = r >>> 24, _[u | 0] = 178;
                                            break i;
                                          }
                                        break t;
                                      case 5:
                                        if (_[r | 0] = 0, _[r + 1 | 0] = 0, _[r + 2 | 0] = 0, _[r + 3 | 0] = 0, _[r + 4 | 0] = 0, _[r + 5 | 0] = 0, _[r + 6 | 0] = 0, _[r + 7 | 0] = 0, _[r + 24 | 0] = 0, _[r + 25 | 0] = 0, _[r + 26 | 0] = 0, _[r + 27 | 0] = 0, _[r + 28 | 0] = 0, _[r + 29 | 0] = 0, _[r + 30 | 0] = 0, _[r + 31 | 0] = 0, _[r + 16 | 0] = 0, _[r + 17 | 0] = 0, _[r + 18 | 0] = 0, _[r + 19 | 0] = 0, _[r + 20 | 0] = 0, _[r + 21 | 0] = 0, _[r + 22 | 0] = 0, _[r + 23 | 0] = 0, _[r + 8 | 0] = 0, _[r + 9 | 0] = 0, _[r + 10 | 0] = 0, _[r + 11 | 0] = 0, _[r + 12 | 0] = 0, _[r + 13 | 0] = 0, _[r + 14 | 0] = 0, _[r + 15 | 0] = 0, s = e[u + 4 >> 2], e[5996] = 0, m = uc(r, s, 0), s = e[5996], e[5996] = 0, (s | 0) != 1)
                                          d: {
                                            if (p = me[m | 0] | me[m + 1 | 0] << 8 | (me[m + 2 | 0] << 16 | me[m + 3 | 0] << 24), s = p - 29 | 0, A = p >>> 0 < 29 ? p : s, u = A + 1 | 0, u >>> 0 > (p >>> 0 <= 28 ? 28 : me[m + 4 | 0] | me[m + 5 | 0] << 8 | (me[m + 6 | 0] << 16 | me[m + 7 | 0] << 24)) >>> 0) {
                                              if (e[5996] = 0, ji(124, m | 0, u + (u >>> 1 | 0) | 0), s = e[5996], e[5996] = 0, (s | 0) == 1)
                                                break d;
                                              p = me[m | 0] | me[m + 1 | 0] << 8 | (me[m + 2 | 0] << 16 | me[m + 3 | 0] << 24), s = p - 29 | 0;
                                            }
                                            r = p >>> 0 < 29, u = A + (r ? m + 4 | 0 : me[m + 8 | 0] | me[m + 9 | 0] << 8 | (me[m + 10 | 0] << 16 | me[m + 11 | 0] << 24)) | 0, Ys(u + 1 | 0, u, (r ? p : s) - A | 0), r = (me[m | 0] | me[m + 1 | 0] << 8 | (me[m + 2 | 0] << 16 | me[m + 3 | 0] << 24)) + 1 | 0, _[m | 0] = r, _[m + 1 | 0] = r >>> 8, _[m + 2 | 0] = r >>> 16, _[m + 3 | 0] = r >>> 24, _[u | 0] = 177;
                                            break i;
                                          }
                                        break t;
                                      case 8:
                                        e[W + 48 >> 2] = 32, e[W + 16 >> 2] = 136, e[W + 80 >> 2] = 166, e[W + 4 >> 2] = s ? 136 : 135, sl(r, W + 48 | 0, W + 16 | 0, W + 80 | 0, u + 20 | 0, W + 4 | 0);
                                        break i;
                                      case 7:
                                        e[W + 48 >> 2] = 32, e[W + 16 >> 2] = 136, e[W + 80 >> 2] = 170, e[W + 4 >> 2] = s ? 136 : 135, sl(r, W + 48 | 0, W + 16 | 0, W + 80 | 0, u + 20 | 0, W + 4 | 0);
                                        break i;
                                      case 9:
                                        e[W + 48 >> 2] = 32, e[W + 16 >> 2] = 136, e[W + 80 >> 2] = 169, e[W + 4 >> 2] = s ? 136 : 135, sl(r, W + 48 | 0, W + 16 | 0, W + 80 | 0, u + 20 | 0, W + 4 | 0);
                                        break i;
                                      case 10:
                                        _[r + 5 | 0] = 0, _[r + 6 | 0] = 0, _[r + 7 | 0] = 0, _[r + 8 | 0] = 0, _[r + 9 | 0] = 0, _[r + 10 | 0] = 0, _[r + 11 | 0] = 0, _[r + 12 | 0] = 0, _[r + 4 | 0] = 107, _[r | 0] = 1, _[r + 1 | 0] = 0, _[r + 2 | 0] = 0, _[r + 3 | 0] = 0, _[r + 28 | 0] = 0, _[r + 29 | 0] = 0, _[r + 30 | 0] = 0, _[r + 31 | 0] = 0, _[r + 21 | 0] = 0, _[r + 22 | 0] = 0, _[r + 23 | 0] = 0, _[r + 24 | 0] = 0, _[r + 25 | 0] = 0, _[r + 26 | 0] = 0, _[r + 27 | 0] = 0, _[r + 28 | 0] = 0, _[r + 13 | 0] = 0, _[r + 14 | 0] = 0, _[r + 15 | 0] = 0, _[r + 16 | 0] = 0, _[r + 17 | 0] = 0, _[r + 18 | 0] = 0, _[r + 19 | 0] = 0, _[r + 20 | 0] = 0, u = me[A + 8 | 0] | me[A + 9 | 0] << 8 | (me[A + 10 | 0] << 16 | me[A + 11 | 0] << 24), m = -28, p = 1, s = me[A | 0] | me[A + 1 | 0] << 8 | (me[A + 2 | 0] << 16 | me[A + 3 | 0] << 24), ar = s >>> 0 < 29;
                                        d: {
                                          if (Xe = ar ? s : s - 29 | 0, s = Xe + 1 | 0, s >>> 0 >= 29) {
                                            if (e[5996] = 0, ji(124, r | 0, s + (s >>> 1 | 0) | 0), s = e[5996], e[5996] = 0, (s | 0) == 1)
                                              break d;
                                            _r = me[r + 8 | 0] | me[r + 9 | 0] << 8 | (me[r + 10 | 0] << 16 | me[r + 11 | 0] << 24), p = me[r | 0] | me[r + 1 | 0] << 8 | (me[r + 2 | 0] << 16 | me[r + 3 | 0] << 24), m = p - 29 | 0;
                                          }
                                          Te = r + 4 | 0, s = p >>> 0 < 29, N = (s ? Te : _r) + 1 | 0, Ys(Xe + N | 0, N, (s ? p : m) - 1 | 0), s = Xe + (me[r | 0] | me[r + 1 | 0] << 8 | (me[r + 2 | 0] << 16 | me[r + 3 | 0] << 24)) | 0, _[r | 0] = s, _[r + 1 | 0] = s >>> 8, _[r + 2 | 0] = s >>> 16, _[r + 3 | 0] = s >>> 24;
                                          f: {
                                            if (!Xe)
                                              break f;
                                            s = ar ? A + 4 | 0 : u, u = Xe & 7;
                                            u: {
                                              if (!u) {
                                                p = s;
                                                break u;
                                              }
                                              for (A = 0, p = s; _[N | 0] = me[p | 0], p = p + 1 | 0, N = N + 1 | 0, A = A + 1 | 0, (u | 0) != (A | 0); )
                                                ;
                                            }
                                            if (Xe >>> 0 < 8)
                                              break f;
                                            for (s = s + Xe | 0; _[N | 0] = me[p | 0], _[N + 1 | 0] = me[p + 1 | 0], _[N + 2 | 0] = me[p + 2 | 0], _[N + 3 | 0] = me[p + 3 | 0], _[N + 4 | 0] = me[p + 4 | 0], _[N + 5 | 0] = me[p + 5 | 0], _[N + 6 | 0] = me[p + 6 | 0], _[N + 7 | 0] = me[p + 7 | 0], N = N + 8 | 0, p = p + 8 | 0, (s | 0) != (p | 0); )
                                              ;
                                          }
                                          if (N = me[r | 0] | me[r + 1 | 0] << 8 | (me[r + 2 | 0] << 16 | me[r + 3 | 0] << 24), _r = N - 29 | 0, A = N >>> 0 < 29 ? N : _r, s = A + 1 | 0, s >>> 0 > (N >>> 0 <= 28 ? 28 : me[r + 4 | 0] | me[r + 5 | 0] << 8 | (me[r + 6 | 0] << 16 | me[r + 7 | 0] << 24)) >>> 0) {
                                            if (e[5996] = 0, ji(124, r | 0, s + (s >>> 1 | 0) | 0), s = e[5996], e[5996] = 0, (s | 0) == 1)
                                              break d;
                                            N = me[r | 0] | me[r + 1 | 0] << 8 | (me[r + 2 | 0] << 16 | me[r + 3 | 0] << 24), _r = N - 29 | 0;
                                          }
                                          s = N >>> 0 < 29, u = A + (s ? Te : me[r + 8 | 0] | me[r + 9 | 0] << 8 | (me[r + 10 | 0] << 16 | me[r + 11 | 0] << 24)) | 0, Ys(u + 1 | 0, u, (s ? N : _r) - A | 0), s = (me[r | 0] | me[r + 1 | 0] << 8 | (me[r + 2 | 0] << 16 | me[r + 3 | 0] << 24)) + 1 | 0, _[r | 0] = s, _[r + 1 | 0] = s >>> 8, _[r + 2 | 0] = s >>> 16, _[r + 3 | 0] = s >>> 24, _[u | 0] = 108;
                                          break i;
                                        }
                                        break t;
                                      case 11:
                                        _[r + 5 | 0] = 0, _[r + 6 | 0] = 0, _[r + 7 | 0] = 0, _[r + 8 | 0] = 0, _[r + 9 | 0] = 0, _[r + 10 | 0] = 0, _[r + 11 | 0] = 0, _[r + 12 | 0] = 0, _[r + 4 | 0] = 124, _[r | 0] = 1, _[r + 1 | 0] = 0, _[r + 2 | 0] = 0, _[r + 3 | 0] = 0, _[r + 28 | 0] = 0, _[r + 29 | 0] = 0, _[r + 30 | 0] = 0, _[r + 31 | 0] = 0, _[r + 21 | 0] = 0, _[r + 22 | 0] = 0, _[r + 23 | 0] = 0, _[r + 24 | 0] = 0, _[r + 25 | 0] = 0, _[r + 26 | 0] = 0, _[r + 27 | 0] = 0, _[r + 28 | 0] = 0, _[r + 13 | 0] = 0, _[r + 14 | 0] = 0, _[r + 15 | 0] = 0, _[r + 16 | 0] = 0, _[r + 17 | 0] = 0, _[r + 18 | 0] = 0, _[r + 19 | 0] = 0, _[r + 20 | 0] = 0, u = me[A + 8 | 0] | me[A + 9 | 0] << 8 | (me[A + 10 | 0] << 16 | me[A + 11 | 0] << 24), m = -28, p = 1, s = me[A | 0] | me[A + 1 | 0] << 8 | (me[A + 2 | 0] << 16 | me[A + 3 | 0] << 24), Te = s >>> 0 < 29;
                                        d: {
                                          if (ar = Te ? s : s - 29 | 0, s = ar + 1 | 0, s >>> 0 >= 29) {
                                            if (e[5996] = 0, ji(124, r | 0, s + (s >>> 1 | 0) | 0), s = e[5996], e[5996] = 0, (s | 0) == 1)
                                              break d;
                                            _r = me[r + 8 | 0] | me[r + 9 | 0] << 8 | (me[r + 10 | 0] << 16 | me[r + 11 | 0] << 24), p = me[r | 0] | me[r + 1 | 0] << 8 | (me[r + 2 | 0] << 16 | me[r + 3 | 0] << 24), m = p - 29 | 0;
                                          }
                                          if (s = p >>> 0 < 29, N = (s ? r + 4 | 0 : _r) + 1 | 0, Ys(ar + N | 0, N, (s ? p : m) - 1 | 0), s = ar + (me[r | 0] | me[r + 1 | 0] << 8 | (me[r + 2 | 0] << 16 | me[r + 3 | 0] << 24)) | 0, _[r | 0] = s, _[r + 1 | 0] = s >>> 8, _[r + 2 | 0] = s >>> 16, _[r + 3 | 0] = s >>> 24, !ar)
                                            break i;
                                          r = Te ? A + 4 | 0 : u, s = ar & 7;
                                          f: {
                                            if (!s) {
                                              p = r;
                                              break f;
                                            }
                                            for (A = 0, p = r; _[N | 0] = me[p | 0], p = p + 1 | 0, N = N + 1 | 0, A = A + 1 | 0, (s | 0) != (A | 0); )
                                              ;
                                          }
                                          if (ar >>> 0 < 8)
                                            break i;
                                          for (r = r + ar | 0; _[N | 0] = me[p | 0], _[N + 1 | 0] = me[p + 1 | 0], _[N + 2 | 0] = me[p + 2 | 0], _[N + 3 | 0] = me[p + 3 | 0], _[N + 4 | 0] = me[p + 4 | 0], _[N + 5 | 0] = me[p + 5 | 0], _[N + 6 | 0] = me[p + 6 | 0], _[N + 7 | 0] = me[p + 7 | 0], N = N + 8 | 0, p = p + 8 | 0, (r | 0) != (p | 0); )
                                            ;
                                          break i;
                                        }
                                        break t;
                                      case 12:
                                        e[W + 48 >> 2] = s ? 173 : 172, ed(r, A, W + 48 | 0);
                                        break i;
                                      case 13:
                                        _[r + 5 | 0] = 0, _[r + 6 | 0] = 0, _[r + 7 | 0] = 0, _[r + 8 | 0] = 0, _[r + 9 | 0] = 0, _[r + 10 | 0] = 0, _[r + 11 | 0] = 0, _[r + 12 | 0] = 0, _[r | 0] = 2, _[r + 1 | 0] = 0, _[r + 2 | 0] = 0, _[r + 3 | 0] = 0, _[r + 4 | 0] = 118, _[r + 28 | 0] = 0, _[r + 29 | 0] = 0, _[r + 30 | 0] = 0, _[r + 31 | 0] = 0, _[r + 21 | 0] = 0, _[r + 22 | 0] = 0, _[r + 23 | 0] = 0, _[r + 24 | 0] = 0, _[r + 25 | 0] = 0, _[r + 26 | 0] = 0, _[r + 27 | 0] = 0, _[r + 28 | 0] = 0, _[r + 13 | 0] = 0, _[r + 14 | 0] = 0, _[r + 15 | 0] = 0, _[r + 16 | 0] = 0, _[r + 17 | 0] = 0, _[r + 18 | 0] = 0, _[r + 19 | 0] = 0, _[r + 20 | 0] = 0, _[r + 5 | 0] = 99, u = me[A + 8 | 0] | me[A + 9 | 0] << 8 | (me[A + 10 | 0] << 16 | me[A + 11 | 0] << 24), m = -27, p = 2, s = me[A | 0] | me[A + 1 | 0] << 8 | (me[A + 2 | 0] << 16 | me[A + 3 | 0] << 24), ar = s >>> 0 < 29;
                                        d: {
                                          if (Xe = ar ? s : s - 29 | 0, s = Xe + 2 | 0, s >>> 0 >= 29) {
                                            if (e[5996] = 0, ji(124, r | 0, s + (s >>> 1 | 0) | 0), s = e[5996], e[5996] = 0, (s | 0) == 1)
                                              break d;
                                            _r = me[r + 8 | 0] | me[r + 9 | 0] << 8 | (me[r + 10 | 0] << 16 | me[r + 11 | 0] << 24), p = me[r | 0] | me[r + 1 | 0] << 8 | (me[r + 2 | 0] << 16 | me[r + 3 | 0] << 24), m = p - 29 | 0;
                                          }
                                          Te = r + 4 | 0, s = p >>> 0 < 29, N = (s ? Te : _r) + 2 | 0, Ys(Xe + N | 0, N, (s ? p : m) - 2 | 0), s = Xe + (me[r | 0] | me[r + 1 | 0] << 8 | (me[r + 2 | 0] << 16 | me[r + 3 | 0] << 24)) | 0, _[r | 0] = s, _[r + 1 | 0] = s >>> 8, _[r + 2 | 0] = s >>> 16, _[r + 3 | 0] = s >>> 24;
                                          f: {
                                            if (!Xe)
                                              break f;
                                            s = ar ? A + 4 | 0 : u, u = Xe & 7;
                                            u: {
                                              if (!u) {
                                                p = s;
                                                break u;
                                              }
                                              for (A = 0, p = s; _[N | 0] = me[p | 0], p = p + 1 | 0, N = N + 1 | 0, A = A + 1 | 0, (u | 0) != (A | 0); )
                                                ;
                                            }
                                            if (Xe >>> 0 < 8)
                                              break f;
                                            for (s = s + Xe | 0; _[N | 0] = me[p | 0], _[N + 1 | 0] = me[p + 1 | 0], _[N + 2 | 0] = me[p + 2 | 0], _[N + 3 | 0] = me[p + 3 | 0], _[N + 4 | 0] = me[p + 4 | 0], _[N + 5 | 0] = me[p + 5 | 0], _[N + 6 | 0] = me[p + 6 | 0], _[N + 7 | 0] = me[p + 7 | 0], N = N + 8 | 0, p = p + 8 | 0, (s | 0) != (p | 0); )
                                              ;
                                          }
                                          if (N = me[r | 0] | me[r + 1 | 0] << 8 | (me[r + 2 | 0] << 16 | me[r + 3 | 0] << 24), _r = N - 29 | 0, A = N >>> 0 < 29 ? N : _r, s = A + 1 | 0, s >>> 0 > (N >>> 0 <= 28 ? 28 : me[r + 4 | 0] | me[r + 5 | 0] << 8 | (me[r + 6 | 0] << 16 | me[r + 7 | 0] << 24)) >>> 0) {
                                            if (e[5996] = 0, ji(124, r | 0, s + (s >>> 1 | 0) | 0), s = e[5996], e[5996] = 0, (s | 0) == 1)
                                              break d;
                                            N = me[r | 0] | me[r + 1 | 0] << 8 | (me[r + 2 | 0] << 16 | me[r + 3 | 0] << 24), _r = N - 29 | 0;
                                          }
                                          s = N >>> 0 < 29, u = A + (s ? Te : me[r + 8 | 0] | me[r + 9 | 0] << 8 | (me[r + 10 | 0] << 16 | me[r + 11 | 0] << 24)) | 0, Ys(u + 1 | 0, u, (s ? N : _r) - A | 0), s = (me[r | 0] | me[r + 1 | 0] << 8 | (me[r + 2 | 0] << 16 | me[r + 3 | 0] << 24)) + 1 | 0, _[r | 0] = s, _[r + 1 | 0] = s >>> 8, _[r + 2 | 0] = s >>> 16, _[r + 3 | 0] = s >>> 24, _[u | 0] = 104;
                                          break i;
                                        }
                                        break t;
                                      case 14:
                                        if (s = e[e[e[u + 32 >> 2] >> 2] + 80 >> 2], !(pu(1239, 1) & (s ^ -1))) {
                                          e[W + 48 >> 2] = 105, ed(r, A, W + 48 | 0);
                                          break i;
                                        }
                                        _[r | 0] = 0, _[r + 1 | 0] = 0, _[r + 2 | 0] = 0, _[r + 3 | 0] = 0, _[r + 4 | 0] = 0, _[r + 5 | 0] = 0, _[r + 6 | 0] = 0, _[r + 7 | 0] = 0, _[r + 24 | 0] = 0, _[r + 25 | 0] = 0, _[r + 26 | 0] = 0, _[r + 27 | 0] = 0, _[r + 28 | 0] = 0, _[r + 29 | 0] = 0, _[r + 30 | 0] = 0, _[r + 31 | 0] = 0, _[r + 16 | 0] = 0, _[r + 17 | 0] = 0, _[r + 18 | 0] = 0, _[r + 19 | 0] = 0, _[r + 20 | 0] = 0, _[r + 21 | 0] = 0, _[r + 22 | 0] = 0, _[r + 23 | 0] = 0, _[r + 8 | 0] = 0, _[r + 9 | 0] = 0, _[r + 10 | 0] = 0, _[r + 11 | 0] = 0, _[r + 12 | 0] = 0, _[r + 13 | 0] = 0, _[r + 14 | 0] = 0, _[r + 15 | 0] = 0, e[W + 72 >> 2] = me[r + 28 | 0] | me[r + 29 | 0] << 8 | (me[r + 30 | 0] << 16 | me[r + 31 | 0] << 24), s = me[r + 24 | 0] | me[r + 25 | 0] << 8 | (me[r + 26 | 0] << 16 | me[r + 27 | 0] << 24), u = W - -64 | 0, e[u >> 2] = me[r + 20 | 0] | me[r + 21 | 0] << 8 | (me[r + 22 | 0] << 16 | me[r + 23 | 0] << 24), e[u + 4 >> 2] = s, s = me[r + 16 | 0] | me[r + 17 | 0] << 8 | (me[r + 18 | 0] << 16 | me[r + 19 | 0] << 24), e[W + 56 >> 2] = me[r + 12 | 0] | me[r + 13 | 0] << 8 | (me[r + 14 | 0] << 16 | me[r + 15 | 0] << 24), e[W + 60 >> 2] = s, s = me[r + 8 | 0] | me[r + 9 | 0] << 8 | (me[r + 10 | 0] << 16 | me[r + 11 | 0] << 24), e[W + 48 >> 2] = me[r + 4 | 0] | me[r + 5 | 0] << 8 | (me[r + 6 | 0] << 16 | me[r + 7 | 0] << 24), e[W + 52 >> 2] = s, s = me[A + 28 | 0] | me[A + 29 | 0] << 8 | (me[A + 30 | 0] << 16 | me[A + 31 | 0] << 24), _[r + 28 | 0] = s, _[r + 29 | 0] = s >>> 8, _[r + 30 | 0] = s >>> 16, _[r + 31 | 0] = s >>> 24, m = me[A + 24 | 0] | me[A + 25 | 0] << 8 | (me[A + 26 | 0] << 16 | me[A + 27 | 0] << 24), s = me[A + 20 | 0] | me[A + 21 | 0] << 8 | (me[A + 22 | 0] << 16 | me[A + 23 | 0] << 24), _[r + 20 | 0] = s, _[r + 21 | 0] = s >>> 8, _[r + 22 | 0] = s >>> 16, _[r + 23 | 0] = s >>> 24, _[r + 24 | 0] = m, _[r + 25 | 0] = m >>> 8, _[r + 26 | 0] = m >>> 16, _[r + 27 | 0] = m >>> 24, m = me[A + 16 | 0] | me[A + 17 | 0] << 8 | (me[A + 18 | 0] << 16 | me[A + 19 | 0] << 24), s = me[A + 12 | 0] | me[A + 13 | 0] << 8 | (me[A + 14 | 0] << 16 | me[A + 15 | 0] << 24), _[r + 12 | 0] = s, _[r + 13 | 0] = s >>> 8, _[r + 14 | 0] = s >>> 16, _[r + 15 | 0] = s >>> 24, _[r + 16 | 0] = m, _[r + 17 | 0] = m >>> 8, _[r + 18 | 0] = m >>> 16, _[r + 19 | 0] = m >>> 24, m = me[A + 8 | 0] | me[A + 9 | 0] << 8 | (me[A + 10 | 0] << 16 | me[A + 11 | 0] << 24), s = me[A + 4 | 0] | me[A + 5 | 0] << 8 | (me[A + 6 | 0] << 16 | me[A + 7 | 0] << 24), _[r + 4 | 0] = s, _[r + 5 | 0] = s >>> 8, _[r + 6 | 0] = s >>> 16, _[r + 7 | 0] = s >>> 24, _[r + 8 | 0] = m, _[r + 9 | 0] = m >>> 8, _[r + 10 | 0] = m >>> 16, _[r + 11 | 0] = m >>> 24, s = e[W + 72 >> 2], _[A + 28 | 0] = s, _[A + 29 | 0] = s >>> 8, _[A + 30 | 0] = s >>> 16, _[A + 31 | 0] = s >>> 24, m = e[u + 4 >> 2], s = e[u >> 2], _[A + 20 | 0] = s, _[A + 21 | 0] = s >>> 8, _[A + 22 | 0] = s >>> 16, _[A + 23 | 0] = s >>> 24, _[A + 24 | 0] = m, _[A + 25 | 0] = m >>> 8, _[A + 26 | 0] = m >>> 16, _[A + 27 | 0] = m >>> 24, u = e[W + 60 >> 2], s = e[W + 56 >> 2], _[A + 12 | 0] = s, _[A + 13 | 0] = s >>> 8, _[A + 14 | 0] = s >>> 16, _[A + 15 | 0] = s >>> 24, _[A + 16 | 0] = u, _[A + 17 | 0] = u >>> 8, _[A + 18 | 0] = u >>> 16, _[A + 19 | 0] = u >>> 24, u = e[W + 52 >> 2], s = e[W + 48 >> 2], _[A + 4 | 0] = s, _[A + 5 | 0] = s >>> 8, _[A + 6 | 0] = s >>> 16, _[A + 7 | 0] = s >>> 24, _[A + 8 | 0] = u, _[A + 9 | 0] = u >>> 8, _[A + 10 | 0] = u >>> 16, _[A + 11 | 0] = u >>> 24, e[r >> 2] = e[A >> 2], e[A >> 2] = 0;
                                        break i;
                                      case 15:
                                        if (_[r | 0] = 0, _[r + 1 | 0] = 0, _[r + 2 | 0] = 0, _[r + 3 | 0] = 0, _[r + 4 | 0] = 0, _[r + 5 | 0] = 0, _[r + 6 | 0] = 0, _[r + 7 | 0] = 0, _[r + 24 | 0] = 0, _[r + 25 | 0] = 0, _[r + 26 | 0] = 0, _[r + 27 | 0] = 0, _[r + 28 | 0] = 0, _[r + 29 | 0] = 0, _[r + 30 | 0] = 0, _[r + 31 | 0] = 0, _[r + 16 | 0] = 0, _[r + 17 | 0] = 0, _[r + 18 | 0] = 0, _[r + 19 | 0] = 0, _[r + 20 | 0] = 0, _[r + 21 | 0] = 0, _[r + 22 | 0] = 0, _[r + 23 | 0] = 0, _[r + 8 | 0] = 0, _[r + 9 | 0] = 0, _[r + 10 | 0] = 0, _[r + 11 | 0] = 0, _[r + 12 | 0] = 0, _[r + 13 | 0] = 0, _[r + 14 | 0] = 0, _[r + 15 | 0] = 0, e[5996] = 0, u = pi(127, r | 0, 130) | 0, s = e[5996], e[5996] = 0, (s | 0) != 1)
                                          d: {
                                            if (e[5996] = 0, u = pi(127, u | 0, 146) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1 || (e[5996] = 0, fr = pi(127, u | 0, 99) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1))
                                              break d;
                                            if (m = me[A + 8 | 0] | me[A + 9 | 0] << 8 | (me[A + 10 | 0] << 16 | me[A + 11 | 0] << 24), u = me[A | 0] | me[A + 1 | 0] << 8 | (me[A + 2 | 0] << 16 | me[A + 3 | 0] << 24), ar = u >>> 0 < 29, p = me[fr | 0] | me[fr + 1 | 0] << 8 | (me[fr + 2 | 0] << 16 | me[fr + 3 | 0] << 24), s = p - 29 | 0, Xe = ar ? u : u - 29 | 0, Te = p >>> 0 < 29 ? p : s, u = Xe + Te | 0, u >>> 0 > (p >>> 0 <= 28 ? 28 : me[fr + 4 | 0] | me[fr + 5 | 0] << 8 | (me[fr + 6 | 0] << 16 | me[fr + 7 | 0] << 24)) >>> 0) {
                                              if (e[5996] = 0, ji(124, fr | 0, u + (u >>> 1 | 0) | 0), s = e[5996], e[5996] = 0, (s | 0) == 1)
                                                break d;
                                              p = me[fr | 0] | me[fr + 1 | 0] << 8 | (me[fr + 2 | 0] << 16 | me[fr + 3 | 0] << 24), s = p - 29 | 0;
                                            }
                                            u = p >>> 0 < 29, N = Te + (u ? fr + 4 | 0 : me[fr + 8 | 0] | me[fr + 9 | 0] << 8 | (me[fr + 10 | 0] << 16 | me[fr + 11 | 0] << 24)) | 0, Ys(Xe + N | 0, N, (u ? p : s) - Te | 0), s = Xe + (me[fr | 0] | me[fr + 1 | 0] << 8 | (me[fr + 2 | 0] << 16 | me[fr + 3 | 0] << 24)) | 0, _[fr | 0] = s, _[fr + 1 | 0] = s >>> 8, _[fr + 2 | 0] = s >>> 16, _[fr + 3 | 0] = s >>> 24;
                                            f: {
                                              if (!Xe)
                                                break f;
                                              s = ar ? A + 4 | 0 : m, u = Xe & 7;
                                              u: {
                                                if (!u) {
                                                  p = s;
                                                  break u;
                                                }
                                                for (A = 0, p = s; _[N | 0] = me[p | 0], p = p + 1 | 0, N = N + 1 | 0, A = A + 1 | 0, (u | 0) != (A | 0); )
                                                  ;
                                              }
                                              if (Xe >>> 0 < 8)
                                                break f;
                                              for (s = s + Xe | 0; _[N | 0] = me[p | 0], _[N + 1 | 0] = me[p + 1 | 0], _[N + 2 | 0] = me[p + 2 | 0], _[N + 3 | 0] = me[p + 3 | 0], _[N + 4 | 0] = me[p + 4 | 0], _[N + 5 | 0] = me[p + 5 | 0], _[N + 6 | 0] = me[p + 6 | 0], _[N + 7 | 0] = me[p + 7 | 0], N = N + 8 | 0, p = p + 8 | 0, (s | 0) != (p | 0); )
                                                ;
                                            }
                                            if (e[5996] = 0, pi(127, fr | 0, 104) | 0, s = e[5996], e[5996] = 0, (s | 0) != 1)
                                              break i;
                                          }
                                        break t;
                                      case 16:
                                        e[W + 48 >> 2] = 146, ed(r, A, W + 48 | 0);
                                        break i;
                                      case 1:
                                        _[r + 5 | 0] = 0, _[r + 6 | 0] = 0, _[r + 7 | 0] = 0, _[r + 8 | 0] = 0, _[r + 9 | 0] = 0, _[r + 10 | 0] = 0, _[r + 11 | 0] = 0, _[r + 12 | 0] = 0, _[r + 4 | 0] = 81, _[r | 0] = 1, _[r + 1 | 0] = 0, _[r + 2 | 0] = 0, _[r + 3 | 0] = 0, _[r + 28 | 0] = 0, _[r + 29 | 0] = 0, _[r + 30 | 0] = 0, _[r + 31 | 0] = 0, _[r + 21 | 0] = 0, _[r + 22 | 0] = 0, _[r + 23 | 0] = 0, _[r + 24 | 0] = 0, _[r + 25 | 0] = 0, _[r + 26 | 0] = 0, _[r + 27 | 0] = 0, _[r + 28 | 0] = 0, _[r + 13 | 0] = 0, _[r + 14 | 0] = 0, _[r + 15 | 0] = 0, _[r + 16 | 0] = 0, _[r + 17 | 0] = 0, _[r + 18 | 0] = 0, _[r + 19 | 0] = 0, _[r + 20 | 0] = 0;
                                        break i;
                                      case 0:
                                        _[r + 5 | 0] = 0, _[r + 6 | 0] = 0, _[r + 7 | 0] = 0, _[r + 8 | 0] = 0, _[r + 9 | 0] = 0, _[r + 10 | 0] = 0, _[r + 11 | 0] = 0, _[r + 12 | 0] = 0, _[r + 4 | 0] = 0, _[r | 0] = 1, _[r + 1 | 0] = 0, _[r + 2 | 0] = 0, _[r + 3 | 0] = 0, _[r + 28 | 0] = 0, _[r + 29 | 0] = 0, _[r + 30 | 0] = 0, _[r + 31 | 0] = 0, _[r + 21 | 0] = 0, _[r + 22 | 0] = 0, _[r + 23 | 0] = 0, _[r + 24 | 0] = 0, _[r + 25 | 0] = 0, _[r + 26 | 0] = 0, _[r + 27 | 0] = 0, _[r + 28 | 0] = 0, _[r + 13 | 0] = 0, _[r + 14 | 0] = 0, _[r + 15 | 0] = 0, _[r + 16 | 0] = 0, _[r + 17 | 0] = 0, _[r + 18 | 0] = 0, _[r + 19 | 0] = 0, _[r + 20 | 0] = 0;
                                        break i;
                                      case 17:
                                        _[r | 0] = 0, _[r + 1 | 0] = 0, _[r + 2 | 0] = 0, _[r + 3 | 0] = 0, _[r + 4 | 0] = 0, _[r + 5 | 0] = 0, _[r + 6 | 0] = 0, _[r + 7 | 0] = 0, _[r + 24 | 0] = 0, _[r + 25 | 0] = 0, _[r + 26 | 0] = 0, _[r + 27 | 0] = 0, _[r + 28 | 0] = 0, _[r + 29 | 0] = 0, _[r + 30 | 0] = 0, _[r + 31 | 0] = 0, _[r + 16 | 0] = 0, _[r + 17 | 0] = 0, _[r + 18 | 0] = 0, _[r + 19 | 0] = 0, _[r + 20 | 0] = 0, _[r + 21 | 0] = 0, _[r + 22 | 0] = 0, _[r + 23 | 0] = 0, _[r + 8 | 0] = 0, _[r + 9 | 0] = 0, _[r + 10 | 0] = 0, _[r + 11 | 0] = 0, _[r + 12 | 0] = 0, _[r + 13 | 0] = 0, _[r + 14 | 0] = 0, _[r + 15 | 0] = 0, u = me[A + 8 | 0] | me[A + 9 | 0] << 8 | (me[A + 10 | 0] << 16 | me[A + 11 | 0] << 24), _r = -29, s = 0, Te = me[A | 0] | me[A + 1 | 0] << 8 | (me[A + 2 | 0] << 16 | me[A + 3 | 0] << 24), m = Te >>> 0 < 29;
                                        d: {
                                          if (ar = m ? Te : Te - 29 | 0, ar >>> 0 >= 29) {
                                            if (e[5996] = 0, ji(124, r | 0, ar + (ar >>> 1 | 0) | 0), s = e[5996], e[5996] = 0, (s | 0) == 1)
                                              break d;
                                            p = me[r | 0] | me[r + 1 | 0] << 8 | (me[r + 2 | 0] << 16 | me[r + 3 | 0] << 24), _r = p - 29 | 0, s = me[r + 8 | 0] | me[r + 9 | 0] << 8 | (me[r + 10 | 0] << 16 | me[r + 11 | 0] << 24);
                                          }
                                          Te = r + 4 | 0, fr = s, s = p >>> 0 < 29, N = s ? Te : fr, Ys(ar + N | 0, N, s ? p : _r), s = ar + (me[r | 0] | me[r + 1 | 0] << 8 | (me[r + 2 | 0] << 16 | me[r + 3 | 0] << 24)) | 0, _[r | 0] = s, _[r + 1 | 0] = s >>> 8, _[r + 2 | 0] = s >>> 16, _[r + 3 | 0] = s >>> 24;
                                          f: {
                                            if (!ar)
                                              break f;
                                            s = m ? A + 4 | 0 : u, u = ar & 7;
                                            u: {
                                              if (!u) {
                                                p = s;
                                                break u;
                                              }
                                              for (_r = 0, p = s; _[N | 0] = me[p | 0], p = p + 1 | 0, N = N + 1 | 0, _r = _r + 1 | 0, (u | 0) != (_r | 0); )
                                                ;
                                            }
                                            if (ar >>> 0 < 8)
                                              break f;
                                            for (s = s + ar | 0; _[N | 0] = me[p | 0], _[N + 1 | 0] = me[p + 1 | 0], _[N + 2 | 0] = me[p + 2 | 0], _[N + 3 | 0] = me[p + 3 | 0], _[N + 4 | 0] = me[p + 4 | 0], _[N + 5 | 0] = me[p + 5 | 0], _[N + 6 | 0] = me[p + 6 | 0], _[N + 7 | 0] = me[p + 7 | 0], N = N + 8 | 0, p = p + 8 | 0, (s | 0) != (p | 0); )
                                              ;
                                          }
                                          if (u = me[A + 40 | 0] | me[A + 41 | 0] << 8 | (me[A + 42 | 0] << 16 | me[A + 43 | 0] << 24), s = me[A + 32 | 0] | me[A + 33 | 0] << 8 | (me[A + 34 | 0] << 16 | me[A + 35 | 0] << 24), Xe = s >>> 0 < 29, p = me[r | 0] | me[r + 1 | 0] << 8 | (me[r + 2 | 0] << 16 | me[r + 3 | 0] << 24), m = p - 29 | 0, fr = Xe ? s : s - 29 | 0, ar = p >>> 0 < 29 ? p : m, s = fr + ar | 0, s >>> 0 > (p >>> 0 <= 28 ? 28 : me[r + 4 | 0] | me[r + 5 | 0] << 8 | (me[r + 6 | 0] << 16 | me[r + 7 | 0] << 24)) >>> 0) {
                                            if (e[5996] = 0, ji(124, r | 0, s + (s >>> 1 | 0) | 0), s = e[5996], e[5996] = 0, (s | 0) == 1)
                                              break d;
                                            p = me[r | 0] | me[r + 1 | 0] << 8 | (me[r + 2 | 0] << 16 | me[r + 3 | 0] << 24), m = p - 29 | 0;
                                          }
                                          if (s = p >>> 0 < 29, N = ar + (s ? Te : me[r + 8 | 0] | me[r + 9 | 0] << 8 | (me[r + 10 | 0] << 16 | me[r + 11 | 0] << 24)) | 0, Ys(fr + N | 0, N, (s ? p : m) - ar | 0), s = fr + (me[r | 0] | me[r + 1 | 0] << 8 | (me[r + 2 | 0] << 16 | me[r + 3 | 0] << 24)) | 0, _[r | 0] = s, _[r + 1 | 0] = s >>> 8, _[r + 2 | 0] = s >>> 16, _[r + 3 | 0] = s >>> 24, !fr)
                                            break i;
                                          r = Xe ? A + 36 | 0 : u, s = fr & 7;
                                          f: {
                                            if (!s) {
                                              p = r;
                                              break f;
                                            }
                                            for (A = 0, p = r; _[N | 0] = me[p | 0], p = p + 1 | 0, N = N + 1 | 0, A = A + 1 | 0, (s | 0) != (A | 0); )
                                              ;
                                          }
                                          if (fr >>> 0 < 8)
                                            break i;
                                          for (r = r + fr | 0; _[N | 0] = me[p | 0], _[N + 1 | 0] = me[p + 1 | 0], _[N + 2 | 0] = me[p + 2 | 0], _[N + 3 | 0] = me[p + 3 | 0], _[N + 4 | 0] = me[p + 4 | 0], _[N + 5 | 0] = me[p + 5 | 0], _[N + 6 | 0] = me[p + 6 | 0], _[N + 7 | 0] = me[p + 7 | 0], N = N + 8 | 0, p = p + 8 | 0, (r | 0) != (p | 0); )
                                            ;
                                          break i;
                                        }
                                        break t;
                                      case 18:
                                        e[W + 48 >> 2] = 154, tl(r, A, A + 32 | 0, W + 48 | 0);
                                        break i;
                                      case 19:
                                        e[W + 48 >> 2] = 155, tl(r, A, A + 32 | 0, W + 48 | 0);
                                        break i;
                                      case 21:
                                        _[r | 0] = 0, _[r + 1 | 0] = 0, _[r + 2 | 0] = 0, _[r + 3 | 0] = 0, _[r + 4 | 0] = 0, _[r + 5 | 0] = 0, _[r + 6 | 0] = 0, _[r + 7 | 0] = 0, _[r + 24 | 0] = 0, _[r + 25 | 0] = 0, _[r + 26 | 0] = 0, _[r + 27 | 0] = 0, _[r + 28 | 0] = 0, _[r + 29 | 0] = 0, _[r + 30 | 0] = 0, _[r + 31 | 0] = 0, _[r + 16 | 0] = 0, _[r + 17 | 0] = 0, _[r + 18 | 0] = 0, _[r + 19 | 0] = 0, _[r + 20 | 0] = 0, _[r + 21 | 0] = 0, _[r + 22 | 0] = 0, _[r + 23 | 0] = 0, _[r + 8 | 0] = 0, _[r + 9 | 0] = 0, _[r + 10 | 0] = 0, _[r + 11 | 0] = 0, _[r + 12 | 0] = 0, _[r + 13 | 0] = 0, _[r + 14 | 0] = 0, _[r + 15 | 0] = 0, u = me[A + 8 | 0] | me[A + 9 | 0] << 8 | (me[A + 10 | 0] << 16 | me[A + 11 | 0] << 24), _r = -29, s = 0, Te = me[A | 0] | me[A + 1 | 0] << 8 | (me[A + 2 | 0] << 16 | me[A + 3 | 0] << 24), m = Te >>> 0 < 29, Te = m ? Te : Te - 29 | 0;
                                        d: {
                                          if (Te >>> 0 >= 29) {
                                            if (e[5996] = 0, ji(124, r | 0, Te + (Te >>> 1 | 0) | 0), s = e[5996], e[5996] = 0, (s | 0) == 1)
                                              break d;
                                            p = me[r | 0] | me[r + 1 | 0] << 8 | (me[r + 2 | 0] << 16 | me[r + 3 | 0] << 24), _r = p - 29 | 0, s = me[r + 8 | 0] | me[r + 9 | 0] << 8 | (me[r + 10 | 0] << 16 | me[r + 11 | 0] << 24);
                                          }
                                          Xe = r + 4 | 0, fr = s, s = p >>> 0 < 29, N = s ? Xe : fr, Ys(Te + N | 0, N, s ? p : _r), s = Te + (me[r | 0] | me[r + 1 | 0] << 8 | (me[r + 2 | 0] << 16 | me[r + 3 | 0] << 24)) | 0, _[r | 0] = s, _[r + 1 | 0] = s >>> 8, _[r + 2 | 0] = s >>> 16, _[r + 3 | 0] = s >>> 24;
                                          f: {
                                            if (!Te)
                                              break f;
                                            s = m ? A + 4 | 0 : u, u = Te & 7;
                                            u: {
                                              if (!u) {
                                                p = s;
                                                break u;
                                              }
                                              for (_r = 0, p = s; _[N | 0] = me[p | 0], p = p + 1 | 0, N = N + 1 | 0, _r = _r + 1 | 0, (u | 0) != (_r | 0); )
                                                ;
                                            }
                                            if (Te >>> 0 < 8)
                                              break f;
                                            for (s = s + Te | 0; _[N | 0] = me[p | 0], _[N + 1 | 0] = me[p + 1 | 0], _[N + 2 | 0] = me[p + 2 | 0], _[N + 3 | 0] = me[p + 3 | 0], _[N + 4 | 0] = me[p + 4 | 0], _[N + 5 | 0] = me[p + 5 | 0], _[N + 6 | 0] = me[p + 6 | 0], _[N + 7 | 0] = me[p + 7 | 0], N = N + 8 | 0, p = p + 8 | 0, (s | 0) != (p | 0); )
                                              ;
                                          }
                                          if (e[5996] = 0, u = pi(127, r | 0, 115) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1 || (e[5996] = 0, vr = pi(127, u | 0, 100) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1))
                                            break d;
                                          if (m = me[A + 40 | 0] | me[A + 41 | 0] << 8 | (me[A + 42 | 0] << 16 | me[A + 43 | 0] << 24), u = me[A + 32 | 0] | me[A + 33 | 0] << 8 | (me[A + 34 | 0] << 16 | me[A + 35 | 0] << 24), ar = u >>> 0 < 29, p = me[vr | 0] | me[vr + 1 | 0] << 8 | (me[vr + 2 | 0] << 16 | me[vr + 3 | 0] << 24), s = p - 29 | 0, fr = ar ? u : u - 29 | 0, Te = p >>> 0 < 29 ? p : s, u = fr + Te | 0, u >>> 0 > (p >>> 0 <= 28 ? 28 : me[Xe | 0] | me[Xe + 1 | 0] << 8 | (me[Xe + 2 | 0] << 16 | me[Xe + 3 | 0] << 24)) >>> 0) {
                                            if (e[5996] = 0, ji(124, vr | 0, u + (u >>> 1 | 0) | 0), s = e[5996], e[5996] = 0, (s | 0) == 1)
                                              break d;
                                            p = me[vr | 0] | me[vr + 1 | 0] << 8 | (me[vr + 2 | 0] << 16 | me[vr + 3 | 0] << 24), s = p - 29 | 0;
                                          }
                                          u = p >>> 0 < 29, N = Te + (u ? Xe : me[r + 8 | 0] | me[r + 9 | 0] << 8 | (me[r + 10 | 0] << 16 | me[r + 11 | 0] << 24)) | 0, Ys(fr + N | 0, N, (u ? p : s) - Te | 0), s = fr + (me[vr | 0] | me[vr + 1 | 0] << 8 | (me[vr + 2 | 0] << 16 | me[vr + 3 | 0] << 24)) | 0, _[vr | 0] = s, _[vr + 1 | 0] = s >>> 8, _[vr + 2 | 0] = s >>> 16, _[vr + 3 | 0] = s >>> 24;
                                          f: {
                                            if (!fr)
                                              break f;
                                            s = ar ? A + 36 | 0 : m, u = fr & 7;
                                            u: {
                                              if (!u) {
                                                p = s;
                                                break u;
                                              }
                                              for (A = 0, p = s; _[N | 0] = me[p | 0], p = p + 1 | 0, N = N + 1 | 0, A = A + 1 | 0, (u | 0) != (A | 0); )
                                                ;
                                            }
                                            if (fr >>> 0 < 8)
                                              break f;
                                            for (s = s + fr | 0; _[N | 0] = me[p | 0], _[N + 1 | 0] = me[p + 1 | 0], _[N + 2 | 0] = me[p + 2 | 0], _[N + 3 | 0] = me[p + 3 | 0], _[N + 4 | 0] = me[p + 4 | 0], _[N + 5 | 0] = me[p + 5 | 0], _[N + 6 | 0] = me[p + 6 | 0], _[N + 7 | 0] = me[p + 7 | 0], N = N + 8 | 0, p = p + 8 | 0, (s | 0) != (p | 0); )
                                              ;
                                          }
                                          if (e[5996] = 0, pi(127, vr | 0, 104) | 0, s = e[5996], e[5996] = 0, (s | 0) != 1)
                                            break i;
                                        }
                                        break t;
                                      case 20:
                                        _[r | 0] = 0, _[r + 1 | 0] = 0, _[r + 2 | 0] = 0, _[r + 3 | 0] = 0, _[r + 4 | 0] = 0, _[r + 5 | 0] = 0, _[r + 6 | 0] = 0, _[r + 7 | 0] = 0, _[r + 24 | 0] = 0, _[r + 25 | 0] = 0, _[r + 26 | 0] = 0, _[r + 27 | 0] = 0, _[r + 28 | 0] = 0, _[r + 29 | 0] = 0, _[r + 30 | 0] = 0, _[r + 31 | 0] = 0, _[r + 16 | 0] = 0, _[r + 17 | 0] = 0, _[r + 18 | 0] = 0, _[r + 19 | 0] = 0, _[r + 20 | 0] = 0, _[r + 21 | 0] = 0, _[r + 22 | 0] = 0, _[r + 23 | 0] = 0, _[r + 8 | 0] = 0, _[r + 9 | 0] = 0, _[r + 10 | 0] = 0, _[r + 11 | 0] = 0, _[r + 12 | 0] = 0, _[r + 13 | 0] = 0, _[r + 14 | 0] = 0, _[r + 15 | 0] = 0, u = me[A + 8 | 0] | me[A + 9 | 0] << 8 | (me[A + 10 | 0] << 16 | me[A + 11 | 0] << 24), _r = -29, s = 0, Te = me[A | 0] | me[A + 1 | 0] << 8 | (me[A + 2 | 0] << 16 | me[A + 3 | 0] << 24), m = Te >>> 0 < 29, Te = m ? Te : Te - 29 | 0;
                                        d: {
                                          if (Te >>> 0 >= 29) {
                                            if (e[5996] = 0, ji(124, r | 0, Te + (Te >>> 1 | 0) | 0), s = e[5996], e[5996] = 0, (s | 0) == 1)
                                              break d;
                                            p = me[r | 0] | me[r + 1 | 0] << 8 | (me[r + 2 | 0] << 16 | me[r + 3 | 0] << 24), _r = p - 29 | 0, s = me[r + 8 | 0] | me[r + 9 | 0] << 8 | (me[r + 10 | 0] << 16 | me[r + 11 | 0] << 24);
                                          }
                                          Xe = r + 4 | 0, fr = s, s = p >>> 0 < 29, N = s ? Xe : fr, Ys(Te + N | 0, N, s ? p : _r), s = Te + (me[r | 0] | me[r + 1 | 0] << 8 | (me[r + 2 | 0] << 16 | me[r + 3 | 0] << 24)) | 0, _[r | 0] = s, _[r + 1 | 0] = s >>> 8, _[r + 2 | 0] = s >>> 16, _[r + 3 | 0] = s >>> 24;
                                          f: {
                                            if (!Te)
                                              break f;
                                            s = m ? A + 4 | 0 : u, u = Te & 7;
                                            u: {
                                              if (!u) {
                                                p = s;
                                                break u;
                                              }
                                              for (_r = 0, p = s; _[N | 0] = me[p | 0], p = p + 1 | 0, N = N + 1 | 0, _r = _r + 1 | 0, (u | 0) != (_r | 0); )
                                                ;
                                            }
                                            if (Te >>> 0 < 8)
                                              break f;
                                            for (s = s + Te | 0; _[N | 0] = me[p | 0], _[N + 1 | 0] = me[p + 1 | 0], _[N + 2 | 0] = me[p + 2 | 0], _[N + 3 | 0] = me[p + 3 | 0], _[N + 4 | 0] = me[p + 4 | 0], _[N + 5 | 0] = me[p + 5 | 0], _[N + 6 | 0] = me[p + 6 | 0], _[N + 7 | 0] = me[p + 7 | 0], N = N + 8 | 0, p = p + 8 | 0, (s | 0) != (p | 0); )
                                              ;
                                          }
                                          if (e[5996] = 0, vr = pi(127, r | 0, 100) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1)
                                            break d;
                                          if (m = me[A + 40 | 0] | me[A + 41 | 0] << 8 | (me[A + 42 | 0] << 16 | me[A + 43 | 0] << 24), u = me[A + 32 | 0] | me[A + 33 | 0] << 8 | (me[A + 34 | 0] << 16 | me[A + 35 | 0] << 24), ar = u >>> 0 < 29, p = me[vr | 0] | me[vr + 1 | 0] << 8 | (me[vr + 2 | 0] << 16 | me[vr + 3 | 0] << 24), s = p - 29 | 0, fr = ar ? u : u - 29 | 0, Te = p >>> 0 < 29 ? p : s, u = fr + Te | 0, u >>> 0 > (p >>> 0 <= 28 ? 28 : me[Xe | 0] | me[Xe + 1 | 0] << 8 | (me[Xe + 2 | 0] << 16 | me[Xe + 3 | 0] << 24)) >>> 0) {
                                            if (e[5996] = 0, ji(124, vr | 0, u + (u >>> 1 | 0) | 0), s = e[5996], e[5996] = 0, (s | 0) == 1)
                                              break d;
                                            p = me[vr | 0] | me[vr + 1 | 0] << 8 | (me[vr + 2 | 0] << 16 | me[vr + 3 | 0] << 24), s = p - 29 | 0;
                                          }
                                          u = p >>> 0 < 29, N = Te + (u ? Xe : me[r + 8 | 0] | me[r + 9 | 0] << 8 | (me[r + 10 | 0] << 16 | me[r + 11 | 0] << 24)) | 0, Ys(fr + N | 0, N, (u ? p : s) - Te | 0), s = fr + (me[vr | 0] | me[vr + 1 | 0] << 8 | (me[vr + 2 | 0] << 16 | me[vr + 3 | 0] << 24)) | 0, _[vr | 0] = s, _[vr + 1 | 0] = s >>> 8, _[vr + 2 | 0] = s >>> 16, _[vr + 3 | 0] = s >>> 24;
                                          f: {
                                            if (!fr)
                                              break f;
                                            s = ar ? A + 36 | 0 : m, u = fr & 7;
                                            u: {
                                              if (!u) {
                                                p = s;
                                                break u;
                                              }
                                              for (A = 0, p = s; _[N | 0] = me[p | 0], p = p + 1 | 0, N = N + 1 | 0, A = A + 1 | 0, (u | 0) != (A | 0); )
                                                ;
                                            }
                                            if (fr >>> 0 < 8)
                                              break f;
                                            for (s = s + fr | 0; _[N | 0] = me[p | 0], _[N + 1 | 0] = me[p + 1 | 0], _[N + 2 | 0] = me[p + 2 | 0], _[N + 3 | 0] = me[p + 3 | 0], _[N + 4 | 0] = me[p + 4 | 0], _[N + 5 | 0] = me[p + 5 | 0], _[N + 6 | 0] = me[p + 6 | 0], _[N + 7 | 0] = me[p + 7 | 0], N = N + 8 | 0, p = p + 8 | 0, (s | 0) != (p | 0); )
                                              ;
                                          }
                                          if (e[5996] = 0, pi(127, vr | 0, 104) | 0, s = e[5996], e[5996] = 0, (s | 0) != 1)
                                            break i;
                                        }
                                        break t;
                                      case 22:
                                        if (_[r | 0] = 0, _[r + 1 | 0] = 0, _[r + 2 | 0] = 0, _[r + 3 | 0] = 0, _[r + 4 | 0] = 0, _[r + 5 | 0] = 0, _[r + 6 | 0] = 0, _[r + 7 | 0] = 0, _[r + 24 | 0] = 0, _[r + 25 | 0] = 0, _[r + 26 | 0] = 0, _[r + 27 | 0] = 0, _[r + 28 | 0] = 0, _[r + 29 | 0] = 0, _[r + 30 | 0] = 0, _[r + 31 | 0] = 0, _[r + 16 | 0] = 0, _[r + 17 | 0] = 0, _[r + 18 | 0] = 0, _[r + 19 | 0] = 0, _[r + 20 | 0] = 0, _[r + 21 | 0] = 0, _[r + 22 | 0] = 0, _[r + 23 | 0] = 0, _[r + 8 | 0] = 0, _[r + 9 | 0] = 0, _[r + 10 | 0] = 0, _[r + 11 | 0] = 0, _[r + 12 | 0] = 0, _[r + 13 | 0] = 0, _[r + 14 | 0] = 0, _[r + 15 | 0] = 0, e[5996] = 0, fr = pi(127, r | 0, 99) | 0, s = e[5996], e[5996] = 0, (s | 0) != 1)
                                          d: {
                                            if (m = me[A + 8 | 0] | me[A + 9 | 0] << 8 | (me[A + 10 | 0] << 16 | me[A + 11 | 0] << 24), u = me[A | 0] | me[A + 1 | 0] << 8 | (me[A + 2 | 0] << 16 | me[A + 3 | 0] << 24), ar = u >>> 0 < 29, p = me[fr | 0] | me[fr + 1 | 0] << 8 | (me[fr + 2 | 0] << 16 | me[fr + 3 | 0] << 24), s = p - 29 | 0, Xe = ar ? u : u - 29 | 0, Te = p >>> 0 < 29 ? p : s, u = Xe + Te | 0, u >>> 0 > (p >>> 0 <= 28 ? 28 : me[fr + 4 | 0] | me[fr + 5 | 0] << 8 | (me[fr + 6 | 0] << 16 | me[fr + 7 | 0] << 24)) >>> 0) {
                                              if (e[5996] = 0, ji(124, fr | 0, u + (u >>> 1 | 0) | 0), s = e[5996], e[5996] = 0, (s | 0) == 1)
                                                break d;
                                              p = me[fr | 0] | me[fr + 1 | 0] << 8 | (me[fr + 2 | 0] << 16 | me[fr + 3 | 0] << 24), s = p - 29 | 0;
                                            }
                                            u = p >>> 0 < 29, N = Te + (u ? fr + 4 | 0 : me[fr + 8 | 0] | me[fr + 9 | 0] << 8 | (me[fr + 10 | 0] << 16 | me[fr + 11 | 0] << 24)) | 0, Ys(Xe + N | 0, N, (u ? p : s) - Te | 0), s = Xe + (me[fr | 0] | me[fr + 1 | 0] << 8 | (me[fr + 2 | 0] << 16 | me[fr + 3 | 0] << 24)) | 0, _[fr | 0] = s, _[fr + 1 | 0] = s >>> 8, _[fr + 2 | 0] = s >>> 16, _[fr + 3 | 0] = s >>> 24;
                                            f: {
                                              if (!Xe)
                                                break f;
                                              s = ar ? A + 4 | 0 : m, u = Xe & 7;
                                              u: {
                                                if (!u) {
                                                  p = s;
                                                  break u;
                                                }
                                                for (p = s; _[N | 0] = me[p | 0], p = p + 1 | 0, N = N + 1 | 0, _r = _r + 1 | 0, (u | 0) != (_r | 0); )
                                                  ;
                                              }
                                              if (Xe >>> 0 < 8)
                                                break f;
                                              for (s = s + Xe | 0; _[N | 0] = me[p | 0], _[N + 1 | 0] = me[p + 1 | 0], _[N + 2 | 0] = me[p + 2 | 0], _[N + 3 | 0] = me[p + 3 | 0], _[N + 4 | 0] = me[p + 4 | 0], _[N + 5 | 0] = me[p + 5 | 0], _[N + 6 | 0] = me[p + 6 | 0], _[N + 7 | 0] = me[p + 7 | 0], N = N + 8 | 0, p = p + 8 | 0, (s | 0) != (p | 0); )
                                                ;
                                            }
                                            if (e[5996] = 0, fr = pi(127, fr | 0, 103) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1)
                                              break d;
                                            if (m = me[A + 40 | 0] | me[A + 41 | 0] << 8 | (me[A + 42 | 0] << 16 | me[A + 43 | 0] << 24), u = me[A + 32 | 0] | me[A + 33 | 0] << 8 | (me[A + 34 | 0] << 16 | me[A + 35 | 0] << 24), ar = u >>> 0 < 29, p = me[fr | 0] | me[fr + 1 | 0] << 8 | (me[fr + 2 | 0] << 16 | me[fr + 3 | 0] << 24), s = p - 29 | 0, Xe = ar ? u : u - 29 | 0, Te = p >>> 0 < 29 ? p : s, u = Xe + Te | 0, u >>> 0 > (p >>> 0 <= 28 ? 28 : me[fr + 4 | 0] | me[fr + 5 | 0] << 8 | (me[fr + 6 | 0] << 16 | me[fr + 7 | 0] << 24)) >>> 0) {
                                              if (e[5996] = 0, ji(124, fr | 0, u + (u >>> 1 | 0) | 0), s = e[5996], e[5996] = 0, (s | 0) == 1)
                                                break d;
                                              p = me[fr | 0] | me[fr + 1 | 0] << 8 | (me[fr + 2 | 0] << 16 | me[fr + 3 | 0] << 24), s = p - 29 | 0;
                                            }
                                            u = p >>> 0 < 29, N = Te + (u ? fr + 4 | 0 : me[fr + 8 | 0] | me[fr + 9 | 0] << 8 | (me[fr + 10 | 0] << 16 | me[fr + 11 | 0] << 24)) | 0, Ys(Xe + N | 0, N, (u ? p : s) - Te | 0), s = Xe + (me[fr | 0] | me[fr + 1 | 0] << 8 | (me[fr + 2 | 0] << 16 | me[fr + 3 | 0] << 24)) | 0, _[fr | 0] = s, _[fr + 1 | 0] = s >>> 8, _[fr + 2 | 0] = s >>> 16, _[fr + 3 | 0] = s >>> 24;
                                            f: {
                                              if (!Xe)
                                                break f;
                                              s = ar ? A + 36 | 0 : m, u = Xe & 7;
                                              u: {
                                                if (!u) {
                                                  p = s;
                                                  break u;
                                                }
                                                for (A = 0, p = s; _[N | 0] = me[p | 0], p = p + 1 | 0, N = N + 1 | 0, A = A + 1 | 0, (u | 0) != (A | 0); )
                                                  ;
                                              }
                                              if (Xe >>> 0 < 8)
                                                break f;
                                              for (s = s + Xe | 0; _[N | 0] = me[p | 0], _[N + 1 | 0] = me[p + 1 | 0], _[N + 2 | 0] = me[p + 2 | 0], _[N + 3 | 0] = me[p + 3 | 0], _[N + 4 | 0] = me[p + 4 | 0], _[N + 5 | 0] = me[p + 5 | 0], _[N + 6 | 0] = me[p + 6 | 0], _[N + 7 | 0] = me[p + 7 | 0], N = N + 8 | 0, p = p + 8 | 0, (s | 0) != (p | 0); )
                                                ;
                                            }
                                            if (e[5996] = 0, pi(127, fr | 0, 104) | 0, s = e[5996], e[5996] = 0, (s | 0) != 1)
                                              break i;
                                          }
                                        break t;
                                      case 23:
                                        _[r | 0] = 0, _[r + 1 | 0] = 0, _[r + 2 | 0] = 0, _[r + 3 | 0] = 0, _[r + 4 | 0] = 0, _[r + 5 | 0] = 0, _[r + 6 | 0] = 0, _[r + 7 | 0] = 0, _[r + 24 | 0] = 0, _[r + 25 | 0] = 0, _[r + 26 | 0] = 0, _[r + 27 | 0] = 0, _[r + 28 | 0] = 0, _[r + 29 | 0] = 0, _[r + 30 | 0] = 0, _[r + 31 | 0] = 0, _[r + 16 | 0] = 0, _[r + 17 | 0] = 0, _[r + 18 | 0] = 0, _[r + 19 | 0] = 0, _[r + 20 | 0] = 0, _[r + 21 | 0] = 0, _[r + 22 | 0] = 0, _[r + 23 | 0] = 0, _[r + 8 | 0] = 0, _[r + 9 | 0] = 0, _[r + 10 | 0] = 0, _[r + 11 | 0] = 0, _[r + 12 | 0] = 0, _[r + 13 | 0] = 0, _[r + 14 | 0] = 0, _[r + 15 | 0] = 0, u = me[A + 8 | 0] | me[A + 9 | 0] << 8 | (me[A + 10 | 0] << 16 | me[A + 11 | 0] << 24), _r = -29, s = 0, Te = me[A | 0] | me[A + 1 | 0] << 8 | (me[A + 2 | 0] << 16 | me[A + 3 | 0] << 24), m = Te >>> 0 < 29, Te = m ? Te : Te - 29 | 0;
                                        d: {
                                          if (Te >>> 0 >= 29) {
                                            if (e[5996] = 0, ji(124, r | 0, Te + (Te >>> 1 | 0) | 0), s = e[5996], e[5996] = 0, (s | 0) == 1)
                                              break d;
                                            p = me[r | 0] | me[r + 1 | 0] << 8 | (me[r + 2 | 0] << 16 | me[r + 3 | 0] << 24), _r = p - 29 | 0, s = me[r + 8 | 0] | me[r + 9 | 0] << 8 | (me[r + 10 | 0] << 16 | me[r + 11 | 0] << 24);
                                          }
                                          fr = r + 4 | 0, vr = s, s = p >>> 0 < 29, N = s ? fr : vr, Ys(Te + N | 0, N, s ? p : _r), s = Te + (me[r | 0] | me[r + 1 | 0] << 8 | (me[r + 2 | 0] << 16 | me[r + 3 | 0] << 24)) | 0, _[r | 0] = s, _[r + 1 | 0] = s >>> 8, _[r + 2 | 0] = s >>> 16, _[r + 3 | 0] = s >>> 24;
                                          f: {
                                            if (!Te)
                                              break f;
                                            s = m ? A + 4 | 0 : u, u = Te & 7;
                                            u: {
                                              if (!u) {
                                                p = s;
                                                break u;
                                              }
                                              for (_r = 0, p = s; _[N | 0] = me[p | 0], p = p + 1 | 0, N = N + 1 | 0, _r = _r + 1 | 0, (u | 0) != (_r | 0); )
                                                ;
                                            }
                                            if (Te >>> 0 < 8)
                                              break f;
                                            for (s = s + Te | 0; _[N | 0] = me[p | 0], _[N + 1 | 0] = me[p + 1 | 0], _[N + 2 | 0] = me[p + 2 | 0], _[N + 3 | 0] = me[p + 3 | 0], _[N + 4 | 0] = me[p + 4 | 0], _[N + 5 | 0] = me[p + 5 | 0], _[N + 6 | 0] = me[p + 6 | 0], _[N + 7 | 0] = me[p + 7 | 0], N = N + 8 | 0, p = p + 8 | 0, (s | 0) != (p | 0); )
                                              ;
                                          }
                                          if (e[5996] = 0, vr = pi(127, r | 0, 100) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1)
                                            break d;
                                          if (m = me[A + 72 | 0] | me[A + 73 | 0] << 8 | (me[A + 74 | 0] << 16 | me[A + 75 | 0] << 24), u = me[A + 64 | 0] | me[A + 65 | 0] << 8 | (me[A + 66 | 0] << 16 | me[A + 67 | 0] << 24), ar = u >>> 0 < 29, p = me[vr | 0] | me[vr + 1 | 0] << 8 | (me[vr + 2 | 0] << 16 | me[vr + 3 | 0] << 24), s = p - 29 | 0, Xe = ar ? u : u - 29 | 0, Te = p >>> 0 < 29 ? p : s, u = Xe + Te | 0, u >>> 0 > (p >>> 0 <= 28 ? 28 : me[fr | 0] | me[fr + 1 | 0] << 8 | (me[fr + 2 | 0] << 16 | me[fr + 3 | 0] << 24)) >>> 0) {
                                            if (e[5996] = 0, ji(124, vr | 0, u + (u >>> 1 | 0) | 0), s = e[5996], e[5996] = 0, (s | 0) == 1)
                                              break d;
                                            p = me[vr | 0] | me[vr + 1 | 0] << 8 | (me[vr + 2 | 0] << 16 | me[vr + 3 | 0] << 24), s = p - 29 | 0;
                                          }
                                          u = p >>> 0 < 29, N = Te + (u ? fr : me[r + 8 | 0] | me[r + 9 | 0] << 8 | (me[r + 10 | 0] << 16 | me[r + 11 | 0] << 24)) | 0, Ys(Xe + N | 0, N, (u ? p : s) - Te | 0), s = Xe + (me[vr | 0] | me[vr + 1 | 0] << 8 | (me[vr + 2 | 0] << 16 | me[vr + 3 | 0] << 24)) | 0, _[vr | 0] = s, _[vr + 1 | 0] = s >>> 8, _[vr + 2 | 0] = s >>> 16, _[vr + 3 | 0] = s >>> 24;
                                          f: {
                                            if (!Xe)
                                              break f;
                                            s = ar ? A + 68 | 0 : m, u = Xe & 7;
                                            u: {
                                              if (!u) {
                                                p = s;
                                                break u;
                                              }
                                              for (_r = 0, p = s; _[N | 0] = me[p | 0], p = p + 1 | 0, N = N + 1 | 0, _r = _r + 1 | 0, (u | 0) != (_r | 0); )
                                                ;
                                            }
                                            if (Xe >>> 0 < 8)
                                              break f;
                                            for (s = s + Xe | 0; _[N | 0] = me[p | 0], _[N + 1 | 0] = me[p + 1 | 0], _[N + 2 | 0] = me[p + 2 | 0], _[N + 3 | 0] = me[p + 3 | 0], _[N + 4 | 0] = me[p + 4 | 0], _[N + 5 | 0] = me[p + 5 | 0], _[N + 6 | 0] = me[p + 6 | 0], _[N + 7 | 0] = me[p + 7 | 0], N = N + 8 | 0, p = p + 8 | 0, (s | 0) != (p | 0); )
                                              ;
                                          }
                                          if (e[5996] = 0, vr = pi(127, vr | 0, 103) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1)
                                            break d;
                                          if (m = me[A + 40 | 0] | me[A + 41 | 0] << 8 | (me[A + 42 | 0] << 16 | me[A + 43 | 0] << 24), u = me[A + 32 | 0] | me[A + 33 | 0] << 8 | (me[A + 34 | 0] << 16 | me[A + 35 | 0] << 24), ar = u >>> 0 < 29, p = me[vr | 0] | me[vr + 1 | 0] << 8 | (me[vr + 2 | 0] << 16 | me[vr + 3 | 0] << 24), s = p - 29 | 0, Xe = ar ? u : u - 29 | 0, Te = p >>> 0 < 29 ? p : s, u = Xe + Te | 0, u >>> 0 > (p >>> 0 <= 28 ? 28 : me[fr | 0] | me[fr + 1 | 0] << 8 | (me[fr + 2 | 0] << 16 | me[fr + 3 | 0] << 24)) >>> 0) {
                                            if (e[5996] = 0, ji(124, vr | 0, u + (u >>> 1 | 0) | 0), s = e[5996], e[5996] = 0, (s | 0) == 1)
                                              break d;
                                            p = me[vr | 0] | me[vr + 1 | 0] << 8 | (me[vr + 2 | 0] << 16 | me[vr + 3 | 0] << 24), s = p - 29 | 0;
                                          }
                                          u = p >>> 0 < 29, N = Te + (u ? fr : me[r + 8 | 0] | me[r + 9 | 0] << 8 | (me[r + 10 | 0] << 16 | me[r + 11 | 0] << 24)) | 0, Ys(Xe + N | 0, N, (u ? p : s) - Te | 0), s = Xe + (me[vr | 0] | me[vr + 1 | 0] << 8 | (me[vr + 2 | 0] << 16 | me[vr + 3 | 0] << 24)) | 0, _[vr | 0] = s, _[vr + 1 | 0] = s >>> 8, _[vr + 2 | 0] = s >>> 16, _[vr + 3 | 0] = s >>> 24;
                                          f: {
                                            if (!Xe)
                                              break f;
                                            s = ar ? A + 36 | 0 : m, u = Xe & 7;
                                            u: {
                                              if (!u) {
                                                p = s;
                                                break u;
                                              }
                                              for (A = 0, p = s; _[N | 0] = me[p | 0], p = p + 1 | 0, N = N + 1 | 0, A = A + 1 | 0, (u | 0) != (A | 0); )
                                                ;
                                            }
                                            if (Xe >>> 0 < 8)
                                              break f;
                                            for (s = s + Xe | 0; _[N | 0] = me[p | 0], _[N + 1 | 0] = me[p + 1 | 0], _[N + 2 | 0] = me[p + 2 | 0], _[N + 3 | 0] = me[p + 3 | 0], _[N + 4 | 0] = me[p + 4 | 0], _[N + 5 | 0] = me[p + 5 | 0], _[N + 6 | 0] = me[p + 6 | 0], _[N + 7 | 0] = me[p + 7 | 0], N = N + 8 | 0, p = p + 8 | 0, (s | 0) != (p | 0); )
                                              ;
                                          }
                                          if (e[5996] = 0, pi(127, vr | 0, 104) | 0, s = e[5996], e[5996] = 0, (s | 0) != 1)
                                            break i;
                                        }
                                        break t;
                                      case 25:
                                        if (e[W + 72 >> 2] = 0, e[W + 76 >> 2] = 0, A = W - -64 | 0, e[A >> 2] = 0, e[A + 4 >> 2] = 0, e[W + 56 >> 2] = 0, e[W + 60 >> 2] = 0, e[W + 48 >> 2] = 0, e[W + 52 >> 2] = 0, A = e[u + 4 >> 2], e[5996] = 0, hi = uc(W + 48 | 0, A, 0), A = e[5996], e[5996] = 0, (A | 0) == 1) {
                                          if (N = Hr() | 0, Ls[W + 48 >> 2] < 29)
                                            break e;
                                          Br(e[W + 56 >> 2]);
                                          break e;
                                        }
                                        if (m = e[u + 8 >> 2], vr = e[u + 12 >> 2], (m | 0) == (vr | 0)) {
                                          u = m;
                                          break a;
                                        }
                                        for (ar = hi + 4 | 0, Te = W + 20 | 0; ; ) {
                                          d: {
                                            if (e[5996] = 0, p = Mi(3, 4) | 0, A = e[5996], e[5996] = 0, (A | 0) == 1)
                                              break d;
                                            if (e[W + 4 >> 2] = p, A = p + 4 | 0, e[W + 12 >> 2] = A, _[p | 0] = 2, _[p + 1 | 0] = 80, _[p + 2 | 0] = 75, _[p + 3 | 0] = 98, e[W + 8 >> 2] = A, e[5996] = 0, _[W + 80 | 0] = 0, gs(126, W + 4 | 0, 29, W + 80 | 0), A = e[5996], e[5996] = 0, (A | 0) == 1) {
                                              if (N = Hr() | 0, r = e[W + 4 >> 2], !r)
                                                break s;
                                              Br(r);
                                              break s;
                                            }
                                            if (A = 0, Xe = me[m + 11 | 0], p = Xe << 24 >> 24 < 0, Ys(e[W + 4 >> 2] + 4 | 0, p ? e[m >> 2] : m, p ? e[m + 4 >> 2] : Xe), e[W + 40 >> 2] = 0, e[W + 44 >> 2] = 0, e[W + 32 >> 2] = 0, e[W + 36 >> 2] = 0, e[W + 24 >> 2] = 0, e[W + 28 >> 2] = 0, e[W + 16 >> 2] = 0, e[W + 20 >> 2] = 0, _r = -29, Xe = e[hi + 8 >> 2], p = 0, mi = e[hi >> 2], fr = mi >>> 0 < 29, mi = fr ? mi : mi - 29 | 0, mi >>> 0 >= 29) {
                                              if (e[5996] = 0, ji(124, W + 16 | 0, mi + (mi >>> 1 | 0) | 0), A = e[5996], e[5996] = 0, (A | 0) == 1)
                                                break l;
                                              p = e[W + 16 >> 2], _r = p - 29 | 0, N = e[W + 24 >> 2];
                                            } else
                                              N = A;
                                            A = p >>> 0 < 29, N = A ? Te : N, Ys(N + mi | 0, N, A ? p : _r), e[W + 16 >> 2] = mi + e[W + 16 >> 2];
                                            f: {
                                              if (!mi)
                                                break f;
                                              if (A = 0, fr = fr ? ar : Xe, p = fr, Xe = mi & 7, Xe)
                                                for (; _[N | 0] = me[p | 0], p = p + 1 | 0, N = N + 1 | 0, A = A + 1 | 0, (Xe | 0) != (A | 0); )
                                                  ;
                                              if (mi >>> 0 < 8)
                                                break f;
                                              for (A = fr + mi | 0; _[N | 0] = me[p | 0], _[N + 1 | 0] = me[p + 1 | 0], _[N + 2 | 0] = me[p + 2 | 0], _[N + 3 | 0] = me[p + 3 | 0], _[N + 4 | 0] = me[p + 4 | 0], _[N + 5 | 0] = me[p + 5 | 0], _[N + 6 | 0] = me[p + 6 | 0], _[N + 7 | 0] = me[p + 7 | 0], N = N + 8 | 0, p = p + 8 | 0, (A | 0) != (p | 0); )
                                                ;
                                            }
                                            if (e[5996] = 0, p = pi(19, W + 16 | 0, W + 4 | 0) | 0, A = e[5996], e[5996] = 0, (A | 0) == 1)
                                              break l;
                                            if (e[W + 104 >> 2] = me[ar + 24 | 0] | me[ar + 25 | 0] << 8 | (me[ar + 26 | 0] << 16 | me[ar + 27 | 0] << 24), A = me[ar + 20 | 0] | me[ar + 21 | 0] << 8 | (me[ar + 22 | 0] << 16 | me[ar + 23 | 0] << 24), e[W + 96 >> 2] = me[ar + 16 | 0] | me[ar + 17 | 0] << 8 | (me[ar + 18 | 0] << 16 | me[ar + 19 | 0] << 24), e[W + 100 >> 2] = A, A = me[ar + 12 | 0] | me[ar + 13 | 0] << 8 | (me[ar + 14 | 0] << 16 | me[ar + 15 | 0] << 24), e[W + 88 >> 2] = me[ar + 8 | 0] | me[ar + 9 | 0] << 8 | (me[ar + 10 | 0] << 16 | me[ar + 11 | 0] << 24), e[W + 92 >> 2] = A, A = me[ar + 4 | 0] | me[ar + 5 | 0] << 8 | (me[ar + 6 | 0] << 16 | me[ar + 7 | 0] << 24), e[W + 80 >> 2] = me[ar | 0] | me[ar + 1 | 0] << 8 | (me[ar + 2 | 0] << 16 | me[ar + 3 | 0] << 24), e[W + 84 >> 2] = A, e[ar + 24 >> 2] = e[Te + 24 >> 2], A = e[Te + 20 >> 2], e[ar + 16 >> 2] = e[Te + 16 >> 2], e[ar + 20 >> 2] = A, A = e[Te + 12 >> 2], e[ar + 8 >> 2] = e[Te + 8 >> 2], e[ar + 12 >> 2] = A, A = e[Te + 4 >> 2], e[ar >> 2] = e[Te >> 2], e[ar + 4 >> 2] = A, A = e[W + 104 >> 2], _[Te + 24 | 0] = A, _[Te + 25 | 0] = A >>> 8, _[Te + 26 | 0] = A >>> 16, _[Te + 27 | 0] = A >>> 24, Xe = e[W + 100 >> 2], A = e[W + 96 >> 2], _[Te + 16 | 0] = A, _[Te + 17 | 0] = A >>> 8, _[Te + 18 | 0] = A >>> 16, _[Te + 19 | 0] = A >>> 24, _[Te + 20 | 0] = Xe, _[Te + 21 | 0] = Xe >>> 8, _[Te + 22 | 0] = Xe >>> 16, _[Te + 23 | 0] = Xe >>> 24, Xe = e[W + 92 >> 2], A = e[W + 88 >> 2], _[Te + 8 | 0] = A, _[Te + 9 | 0] = A >>> 8, _[Te + 10 | 0] = A >>> 16, _[Te + 11 | 0] = A >>> 24, _[Te + 12 | 0] = Xe, _[Te + 13 | 0] = Xe >>> 8, _[Te + 14 | 0] = Xe >>> 16, _[Te + 15 | 0] = Xe >>> 24, Xe = e[W + 84 >> 2], A = e[W + 80 >> 2], _[Te | 0] = A, _[Te + 1 | 0] = A >>> 8, _[Te + 2 | 0] = A >>> 16, _[Te + 3 | 0] = A >>> 24, _[Te + 4 | 0] = Xe, _[Te + 5 | 0] = Xe >>> 8, _[Te + 6 | 0] = Xe >>> 16, _[Te + 7 | 0] = Xe >>> 24, A = e[hi >> 2], e[hi >> 2] = e[p >> 2], e[p >> 2] = A, A >>> 0 >= 29 && (Br(e[W + 24 >> 2]), e[W + 24 >> 2] = 0), A = e[W + 4 >> 2], A && Br(A), m = m + 12 | 0, (vr | 0) != (m | 0))
                                              continue;
                                            break o;
                                          }
                                          break;
                                        }
                                        N = Hr() | 0;
                                        break s;
                                      case 24:
                                        e[W + 72 >> 2] = 0, e[W + 76 >> 2] = 0, p = W - -64 | 0, e[p >> 2] = 0, e[p + 4 >> 2] = 0, e[W + 56 >> 2] = 0, e[W + 60 >> 2] = 0, e[W + 48 >> 2] = 0, e[W + 52 >> 2] = 0, _r = e[W + 76 >> 2], e[W + 40 >> 2] = _r, fr = e[W + 72 >> 2], p = e[W + 68 >> 2], vr = p, e[W + 32 >> 2] = p, e[W + 36 >> 2] = fr, Xe = e[W + 64 >> 2], Te = e[W + 60 >> 2], e[W + 24 >> 2] = Te, e[W + 28 >> 2] = Xe, ar = e[W + 56 >> 2], p = e[W + 52 >> 2], e[W + 16 >> 2] = p, e[W + 20 >> 2] = ar, e[W + 76 >> 2] = me[A + 28 | 0] | me[A + 29 | 0] << 8 | (me[A + 30 | 0] << 16 | me[A + 31 | 0] << 24), hi = me[A + 24 | 0] | me[A + 25 | 0] << 8 | (me[A + 26 | 0] << 16 | me[A + 27 | 0] << 24), e[W + 68 >> 2] = me[A + 20 | 0] | me[A + 21 | 0] << 8 | (me[A + 22 | 0] << 16 | me[A + 23 | 0] << 24), e[W + 72 >> 2] = hi, hi = me[A + 16 | 0] | me[A + 17 | 0] << 8 | (me[A + 18 | 0] << 16 | me[A + 19 | 0] << 24), e[W + 60 >> 2] = me[A + 12 | 0] | me[A + 13 | 0] << 8 | (me[A + 14 | 0] << 16 | me[A + 15 | 0] << 24), e[W + 64 >> 2] = hi, hi = me[A + 8 | 0] | me[A + 9 | 0] << 8 | (me[A + 10 | 0] << 16 | me[A + 11 | 0] << 24), e[W + 52 >> 2] = me[A + 4 | 0] | me[A + 5 | 0] << 8 | (me[A + 6 | 0] << 16 | me[A + 7 | 0] << 24), e[W + 56 >> 2] = hi, _[A + 28 | 0] = _r, _[A + 29 | 0] = _r >>> 8, _[A + 30 | 0] = _r >>> 16, _[A + 31 | 0] = _r >>> 24, _[A + 20 | 0] = vr, _[A + 21 | 0] = vr >>> 8, _[A + 22 | 0] = vr >>> 16, _[A + 23 | 0] = vr >>> 24, _[A + 24 | 0] = fr, _[A + 25 | 0] = fr >>> 8, _[A + 26 | 0] = fr >>> 16, _[A + 27 | 0] = fr >>> 24, _[A + 12 | 0] = Te, _[A + 13 | 0] = Te >>> 8, _[A + 14 | 0] = Te >>> 16, _[A + 15 | 0] = Te >>> 24, _[A + 16 | 0] = Xe, _[A + 17 | 0] = Xe >>> 8, _[A + 18 | 0] = Xe >>> 16, _[A + 19 | 0] = Xe >>> 24, _[A + 4 | 0] = p, _[A + 5 | 0] = p >>> 8, _[A + 6 | 0] = p >>> 16, _[A + 7 | 0] = p >>> 24, _[A + 8 | 0] = ar, _[A + 9 | 0] = ar >>> 8, _[A + 10 | 0] = ar >>> 16, _[A + 11 | 0] = ar >>> 24, N = e[A >> 2], e[W + 48 >> 2] = N, e[A >> 2] = 0, Xe = W + 48 | 4;
                                        d: {
                                          f: {
                                            if (m >>> 0 >= 2) {
                                              for (_r = 1; ; ) {
                                                if (e[5996] = 0, e[W + 4 >> 2] = 147, Vs(128, W + 16 | 0, W + 48 | 0, (_r << 5) + A | 0, W + 4 | 0), p = e[5996], e[5996] = 0, (p | 0) == 1)
                                                  break f;
                                                if (e[W + 104 >> 2] = me[Xe + 24 | 0] | me[Xe + 25 | 0] << 8 | (me[Xe + 26 | 0] << 16 | me[Xe + 27 | 0] << 24), p = me[Xe + 20 | 0] | me[Xe + 21 | 0] << 8 | (me[Xe + 22 | 0] << 16 | me[Xe + 23 | 0] << 24), e[W + 96 >> 2] = me[Xe + 16 | 0] | me[Xe + 17 | 0] << 8 | (me[Xe + 18 | 0] << 16 | me[Xe + 19 | 0] << 24), e[W + 100 >> 2] = p, p = me[Xe + 12 | 0] | me[Xe + 13 | 0] << 8 | (me[Xe + 14 | 0] << 16 | me[Xe + 15 | 0] << 24), e[W + 88 >> 2] = me[Xe + 8 | 0] | me[Xe + 9 | 0] << 8 | (me[Xe + 10 | 0] << 16 | me[Xe + 11 | 0] << 24), e[W + 92 >> 2] = p, p = me[Xe + 4 | 0] | me[Xe + 5 | 0] << 8 | (me[Xe + 6 | 0] << 16 | me[Xe + 7 | 0] << 24), e[W + 80 >> 2] = me[Xe | 0] | me[Xe + 1 | 0] << 8 | (me[Xe + 2 | 0] << 16 | me[Xe + 3 | 0] << 24), e[W + 84 >> 2] = p, e[Xe + 24 >> 2] = e[W + 44 >> 2], p = e[W + 40 >> 2], e[Xe + 16 >> 2] = e[W + 36 >> 2], e[Xe + 20 >> 2] = p, p = e[W + 32 >> 2], e[Xe + 8 >> 2] = e[W + 28 >> 2], e[Xe + 12 >> 2] = p, p = e[W + 24 >> 2], e[Xe >> 2] = e[W + 20 >> 2], e[Xe + 4 >> 2] = p, p = e[W + 104 >> 2], _[W + 44 | 0] = p, _[W + 45 | 0] = p >>> 8, _[W + 46 | 0] = p >>> 16, _[W + 47 | 0] = p >>> 24, Te = e[W + 100 >> 2], p = e[W + 96 >> 2], _[W + 36 | 0] = p, _[W + 37 | 0] = p >>> 8, _[W + 38 | 0] = p >>> 16, _[W + 39 | 0] = p >>> 24, _[W + 40 | 0] = Te, _[W + 41 | 0] = Te >>> 8, _[W + 42 | 0] = Te >>> 16, _[W + 43 | 0] = Te >>> 24, Te = e[W + 92 >> 2], p = e[W + 88 >> 2], _[W + 28 | 0] = p, _[W + 29 | 0] = p >>> 8, _[W + 30 | 0] = p >>> 16, _[W + 31 | 0] = p >>> 24, _[W + 32 | 0] = Te, _[W + 33 | 0] = Te >>> 8, _[W + 34 | 0] = Te >>> 16, _[W + 35 | 0] = Te >>> 24, Te = e[W + 84 >> 2], p = e[W + 80 >> 2], _[W + 20 | 0] = p, _[W + 21 | 0] = p >>> 8, _[W + 22 | 0] = p >>> 16, _[W + 23 | 0] = p >>> 24, _[W + 24 | 0] = Te, _[W + 25 | 0] = Te >>> 8, _[W + 26 | 0] = Te >>> 16, _[W + 27 | 0] = Te >>> 24, p = e[W + 48 >> 2], e[W + 48 >> 2] = e[W + 16 >> 2], e[W + 16 >> 2] = p, p >>> 0 >= 29 && Br(e[W + 24 >> 2]), _r = _r + 1 | 0, (_r | 0) == (m | 0))
                                                  break;
                                              }
                                              N = e[W + 48 >> 2];
                                            }
                                            _[r | 0] = 0, _[r + 1 | 0] = 0, _[r + 2 | 0] = 0, _[r + 3 | 0] = 0, _[r + 4 | 0] = 0, _[r + 5 | 0] = 0, _[r + 6 | 0] = 0, _[r + 7 | 0] = 0, _[r + 24 | 0] = 0, _[r + 25 | 0] = 0, _[r + 26 | 0] = 0, _[r + 27 | 0] = 0, _[r + 28 | 0] = 0, _[r + 29 | 0] = 0, _[r + 30 | 0] = 0, _[r + 31 | 0] = 0, _[r + 16 | 0] = 0, _[r + 17 | 0] = 0, _[r + 18 | 0] = 0, _[r + 19 | 0] = 0, _[r + 20 | 0] = 0, _[r + 21 | 0] = 0, _[r + 22 | 0] = 0, _[r + 23 | 0] = 0, _[r + 8 | 0] = 0, _[r + 9 | 0] = 0, _[r + 10 | 0] = 0, _[r + 11 | 0] = 0, _[r + 12 | 0] = 0, _[r + 13 | 0] = 0, _[r + 14 | 0] = 0, _[r + 15 | 0] = 0, _r = -29, Te = e[W + 56 >> 2], A = 0;
                                            u: {
                                              fr = r + 4 | 0, p = N >>> 0 < 29, ar = p ? N : N - 29 | 0;
                                              g: {
                                                if (ar >>> 0 >= 29) {
                                                  if (e[5996] = 0, ji(124, r | 0, ar + (ar >>> 1 | 0) | 0), A = e[5996], e[5996] = 0, (A | 0) == 1)
                                                    break g;
                                                  A = me[r | 0] | me[r + 1 | 0] << 8 | (me[r + 2 | 0] << 16 | me[r + 3 | 0] << 24), _r = A - 29 | 0, mi = me[r + 8 | 0] | me[r + 9 | 0] << 8 | (me[r + 10 | 0] << 16 | me[r + 11 | 0] << 24);
                                                }
                                                m = A >>> 0 < 29, N = m ? fr : mi, Ys(N + ar | 0, N, m ? A : _r), A = ar + (me[r | 0] | me[r + 1 | 0] << 8 | (me[r + 2 | 0] << 16 | me[r + 3 | 0] << 24)) | 0, _[r | 0] = A, _[r + 1 | 0] = A >>> 8, _[r + 2 | 0] = A >>> 16, _[r + 3 | 0] = A >>> 24;
                                                A: {
                                                  if (!ar)
                                                    break A;
                                                  m = p ? Xe : Te, Te = ar & 7;
                                                  p: {
                                                    if (!Te) {
                                                      p = m;
                                                      break p;
                                                    }
                                                    for (A = 0, p = m; _[N | 0] = me[p | 0], p = p + 1 | 0, N = N + 1 | 0, A = A + 1 | 0, (Te | 0) != (A | 0); )
                                                      ;
                                                  }
                                                  if (ar >>> 0 < 8)
                                                    break A;
                                                  for (A = m + ar | 0; _[N | 0] = me[p | 0], _[N + 1 | 0] = me[p + 1 | 0], _[N + 2 | 0] = me[p + 2 | 0], _[N + 3 | 0] = me[p + 3 | 0], _[N + 4 | 0] = me[p + 4 | 0], _[N + 5 | 0] = me[p + 5 | 0], _[N + 6 | 0] = me[p + 6 | 0], _[N + 7 | 0] = me[p + 7 | 0], N = N + 8 | 0, p = p + 8 | 0, (A | 0) != (p | 0); )
                                                    ;
                                                }
                                                if (u = e[u + 4 >> 2], e[5996] = 0, A = uc(r, u, 0), u = e[5996], e[5996] = 0, (u | 0) == 1)
                                                  break g;
                                                if (e[5996] = 0, pi(127, A | 0, (s ? 136 : 135) | 0) | 0, s = e[5996], e[5996] = 0, (s | 0) != 1)
                                                  break u;
                                              }
                                              if (N = Hr() | 0, (me[r | 0] | me[r + 1 | 0] << 8 | (me[r + 2 | 0] << 16 | me[r + 3 | 0] << 24)) >>> 0 < 29)
                                                break d;
                                              Br(me[r + 8 | 0] | me[r + 9 | 0] << 8 | (me[r + 10 | 0] << 16 | me[r + 11 | 0] << 24)), _[r + 8 | 0] = 0, _[r + 9 | 0] = 0, _[r + 10 | 0] = 0, _[r + 11 | 0] = 0;
                                              break d;
                                            }
                                            if (Ls[W + 48 >> 2] < 29)
                                              break i;
                                            Br(e[W + 56 >> 2]);
                                            break i;
                                          }
                                          N = Hr() | 0;
                                        }
                                        if (Ls[W + 48 >> 2] < 29)
                                          break e;
                                        Br(e[W + 56 >> 2]);
                                        break e;
                                      default:
                                        ga(2350, 2210, 624, 5107), Oi();
                                      case 6:
                                        break c;
                                    }
                                  e[W + 48 >> 2] = 32, e[W + 16 >> 2] = 136, e[W + 80 >> 2] = 168, e[W + 4 >> 2] = s ? 136 : 135, sl(r, W + 48 | 0, W + 16 | 0, W + 80 | 0, u + 20 | 0, W + 4 | 0);
                                  break i;
                                }
                                if (N = Hr() | 0, Ls[W + 16 >> 2] >= 29 && (Br(e[W + 24 >> 2]), e[W + 24 >> 2] = 0), r = e[W + 4 >> 2], !r)
                                  break s;
                                Br(r);
                                break s;
                              }
                              m = e[u + 8 >> 2], u = e[u + 12 >> 2];
                            }
                            _[r | 0] = 0, _[r + 1 | 0] = 0, _[r + 2 | 0] = 0, _[r + 3 | 0] = 0, _[r + 4 | 0] = 0, _[r + 5 | 0] = 0, _[r + 6 | 0] = 0, _[r + 7 | 0] = 0, _[r + 24 | 0] = 0, _[r + 25 | 0] = 0, _[r + 26 | 0] = 0, _[r + 27 | 0] = 0, _[r + 28 | 0] = 0, _[r + 29 | 0] = 0, _[r + 30 | 0] = 0, _[r + 31 | 0] = 0, _[r + 16 | 0] = 0, _[r + 17 | 0] = 0, _[r + 18 | 0] = 0, _[r + 19 | 0] = 0, _[r + 20 | 0] = 0, _[r + 21 | 0] = 0, _[r + 22 | 0] = 0, _[r + 23 | 0] = 0, _[r + 8 | 0] = 0, _[r + 9 | 0] = 0, _[r + 10 | 0] = 0, _[r + 11 | 0] = 0, _[r + 12 | 0] = 0, _[r + 13 | 0] = 0, _[r + 14 | 0] = 0, _[r + 15 | 0] = 0, ar = e[hi + 8 >> 2], A = -29, Te = (u - m | 0) / 12 | 0, _r = 0, p = 0, u = e[hi >> 2], m = u >>> 0 < 29, Xe = m ? u : u - 29 | 0;
                            a: {
                              if (Xe >>> 0 >= 29) {
                                if (e[5996] = 0, ji(124, r | 0, Xe + (Xe >>> 1 | 0) | 0), u = e[5996], e[5996] = 0, (u | 0) == 1)
                                  break a;
                                _r = me[r + 8 | 0] | me[r + 9 | 0] << 8 | (me[r + 10 | 0] << 16 | me[r + 11 | 0] << 24), p = me[r | 0] | me[r + 1 | 0] << 8 | (me[r + 2 | 0] << 16 | me[r + 3 | 0] << 24), A = p - 29 | 0;
                              }
                              u = p >>> 0 < 29, N = u ? r + 4 | 0 : _r, Ys(Xe + N | 0, N, u ? p : A), u = Xe + (me[r | 0] | me[r + 1 | 0] << 8 | (me[r + 2 | 0] << 16 | me[r + 3 | 0] << 24)) | 0, _[r | 0] = u, _[r + 1 | 0] = u >>> 8, _[r + 2 | 0] = u >>> 16, _[r + 3 | 0] = u >>> 24;
                              o: {
                                if (!Xe)
                                  break o;
                                u = m ? hi + 4 | 0 : ar, m = Xe & 7;
                                l: {
                                  if (!m) {
                                    p = u;
                                    break l;
                                  }
                                  for (A = 0, p = u; _[N | 0] = me[p | 0], p = p + 1 | 0, N = N + 1 | 0, A = A + 1 | 0, (m | 0) != (A | 0); )
                                    ;
                                }
                                if (Xe >>> 0 < 8)
                                  break o;
                                for (u = u + Xe | 0; _[N | 0] = me[p | 0], _[N + 1 | 0] = me[p + 1 | 0], _[N + 2 | 0] = me[p + 2 | 0], _[N + 3 | 0] = me[p + 3 | 0], _[N + 4 | 0] = me[p + 4 | 0], _[N + 5 | 0] = me[p + 5 | 0], _[N + 6 | 0] = me[p + 6 | 0], _[N + 7 | 0] = me[p + 7 | 0], N = N + 8 | 0, p = p + 8 | 0, (u | 0) != (p | 0); )
                                  ;
                              }
                              if (e[5996] = 0, A = uc(r, Te, 0), u = e[5996], e[5996] = 0, (u | 0) == 1)
                                break a;
                              if (e[5996] = 0, pi(127, A | 0, (s ? 175 : 174) | 0) | 0, s = e[5996], e[5996] = 0, (s | 0) != 1)
                                break n;
                            }
                            if (N = Hr() | 0, (me[r | 0] | me[r + 1 | 0] << 8 | (me[r + 2 | 0] << 16 | me[r + 3 | 0] << 24)) >>> 0 < 29)
                              break s;
                            Br(me[r + 8 | 0] | me[r + 9 | 0] << 8 | (me[r + 10 | 0] << 16 | me[r + 11 | 0] << 24)), _[r + 8 | 0] = 0, _[r + 9 | 0] = 0, _[r + 10 | 0] = 0, _[r + 11 | 0] = 0;
                          }
                          if (Ls[hi >> 2] < 29)
                            break e;
                          Br(e[hi + 8 >> 2]);
                          break e;
                        }
                        if (Ls[hi >> 2] < 29)
                          break i;
                        Br(e[hi + 8 >> 2]);
                      }
                      Jr = W + 112 | 0;
                      return;
                    }
                    if (N = Hr() | 0, r = e[W + 48 >> 2], !r)
                      break e;
                    Br(r);
                    break e;
                  }
                  if (N = Hr() | 0, (me[r | 0] | me[r + 1 | 0] << 8 | (me[r + 2 | 0] << 16 | me[r + 3 | 0] << 24)) >>> 0 < 29)
                    break e;
                  Br(me[r + 8 | 0] | me[r + 9 | 0] << 8 | (me[r + 10 | 0] << 16 | me[r + 11 | 0] << 24)), _[r + 8 | 0] = 0, _[r + 9 | 0] = 0, _[r + 10 | 0] = 0, _[r + 11 | 0] = 0;
                }
                Jn(N | 0), Oi();
              }
              function Y1(r, s) {
                r = r | 0, s = s | 0;
                var u = 0, A = 0, m = 0, p = 0, N = 0, W = 0, Te = 0, Xe = 0;
                u = Jr - 496 | 0, Jr = u;
                e: {
                  t: {
                    r: {
                      i: {
                        n: {
                          s: {
                            a: {
                              o: {
                                l: {
                                  c: {
                                    d: {
                                      f: {
                                        u: {
                                          g: {
                                            A: {
                                              p: {
                                                m: {
                                                  k: {
                                                    N: {
                                                      S: {
                                                        T: {
                                                          v: {
                                                            w: {
                                                              E: {
                                                                h: {
                                                                  R: {
                                                                    I: {
                                                                      B: {
                                                                        x: {
                                                                          b: {
                                                                            C: {
                                                                              y: {
                                                                                D: {
                                                                                  P: {
                                                                                    q: {
                                                                                      O: {
                                                                                        Q: {
                                                                                          U: {
                                                                                            F: {
                                                                                              M: {
                                                                                                L: {
                                                                                                  H: {
                                                                                                    K: {
                                                                                                      W: {
                                                                                                        V: {
                                                                                                          j: {
                                                                                                            z: {
                                                                                                              G: {
                                                                                                                X: {
                                                                                                                  Y: {
                                                                                                                    J:
                                                                                                                      switch (m = e[s >> 2], e[m >> 2] - 1 | 0) {
                                                                                                                        case 23:
                                                                                                                          break R;
                                                                                                                        case 22:
                                                                                                                          break I;
                                                                                                                        case 21:
                                                                                                                          break B;
                                                                                                                        case 20:
                                                                                                                          break x;
                                                                                                                        case 19:
                                                                                                                          break b;
                                                                                                                        case 18:
                                                                                                                          break C;
                                                                                                                        case 17:
                                                                                                                          break y;
                                                                                                                        case 16:
                                                                                                                          break D;
                                                                                                                        case 14:
                                                                                                                          break P;
                                                                                                                        case 15:
                                                                                                                          break q;
                                                                                                                        case 13:
                                                                                                                          break O;
                                                                                                                        case 12:
                                                                                                                          break Q;
                                                                                                                        case 11:
                                                                                                                          break U;
                                                                                                                        case 10:
                                                                                                                          break F;
                                                                                                                        case 9:
                                                                                                                          break M;
                                                                                                                        case 0:
                                                                                                                          break L;
                                                                                                                        case 8:
                                                                                                                          break K;
                                                                                                                        case 6:
                                                                                                                          break W;
                                                                                                                        case 7:
                                                                                                                          break V;
                                                                                                                        case 5:
                                                                                                                          break j;
                                                                                                                        case 3:
                                                                                                                          break z;
                                                                                                                        case 4:
                                                                                                                          break G;
                                                                                                                        case 24:
                                                                                                                          break X;
                                                                                                                        case 2:
                                                                                                                          break Y;
                                                                                                                        case 1:
                                                                                                                          break J;
                                                                                                                        default:
                                                                                                                          break H;
                                                                                                                      }
                                                                                                                    m = e[m + 8 >> 2];
                                                                                                                    J: {
                                                                                                                      if (_[m + 11 | 0] >= 0) {
                                                                                                                        e[u + 456 >> 2] = e[m + 8 >> 2], A = e[m + 4 >> 2], e[u + 448 >> 2] = e[m >> 2], e[u + 452 >> 2] = A;
                                                                                                                        break J;
                                                                                                                      }
                                                                                                                      Il(u + 448 | 0, e[m >> 2], e[m + 4 >> 2]);
                                                                                                                    }
                                                                                                                    e[5996] = 0, _[u + 460 | 0] = 1, m = xn(99, u + 448 | 0, 0, 5283) | 0, A = e[5996], e[5996] = 0;
                                                                                                                    J: {
                                                                                                                      _: {
                                                                                                                        Z: {
                                                                                                                          $: {
                                                                                                                            if ((A | 0) != 1) {
                                                                                                                              if (e[u + 472 >> 2] = e[m + 8 >> 2], A = e[m + 4 >> 2], e[u + 464 >> 2] = e[m >> 2], e[u + 468 >> 2] = A, e[m >> 2] = 0, e[m + 4 >> 2] = 0, e[m + 8 >> 2] = 0, e[5996] = 0, A = pi(97, u + 464 | 0, 5242) | 0, p = e[5996], e[5996] = 0, (p | 0) == 1)
                                                                                                                                break $;
                                                                                                                              if (e[u + 488 >> 2] = e[A + 8 >> 2], p = e[A + 4 >> 2], e[u + 480 >> 2] = e[A >> 2], e[u + 484 >> 2] = p, e[A >> 2] = 0, e[A + 4 >> 2] = 0, e[A + 8 >> 2] = 0, e[5996] = 0, gs(161, r | 0, s | 0, u + 480 | 0), r = e[5996], e[5996] = 0, (r | 0) == 1)
                                                                                                                                break Z;
                                                                                                                              if (_[u + 491 | 0] < 0 && Br(e[u + 480 >> 2]), _[A + 11 | 0] < 0 && Br(e[A >> 2]), !me[u + 460 | 0] | _[m + 11 | 0] >= 0)
                                                                                                                                break h;
                                                                                                                              Br(e[m >> 2]);
                                                                                                                              break h;
                                                                                                                            }
                                                                                                                            s = Hr() | 0;
                                                                                                                            break J;
                                                                                                                          }
                                                                                                                          s = Hr() | 0;
                                                                                                                          break _;
                                                                                                                        }
                                                                                                                        if (s = Hr() | 0, _[u + 491 | 0] >= 0)
                                                                                                                          break _;
                                                                                                                        Br(e[u + 480 >> 2]);
                                                                                                                      }
                                                                                                                      if (_[u + 475 | 0] >= 0)
                                                                                                                        break J;
                                                                                                                      Br(e[u + 464 >> 2]);
                                                                                                                    }
                                                                                                                    break r;
                                                                                                                  }
                                                                                                                  m = e[m + 8 >> 2];
                                                                                                                  Y: {
                                                                                                                    if (_[m + 11 | 0] >= 0) {
                                                                                                                      e[u + 456 >> 2] = e[m + 8 >> 2], A = e[m + 4 >> 2], e[u + 448 >> 2] = e[m >> 2], e[u + 452 >> 2] = A;
                                                                                                                      break Y;
                                                                                                                    }
                                                                                                                    Il(u + 448 | 0, e[m >> 2], e[m + 4 >> 2]);
                                                                                                                  }
                                                                                                                  e[5996] = 0, _[u + 460 | 0] = 1, m = xn(99, u + 448 | 0, 0, 5315) | 0, A = e[5996], e[5996] = 0;
                                                                                                                  Y: {
                                                                                                                    J: {
                                                                                                                      _: {
                                                                                                                        Z: {
                                                                                                                          if ((A | 0) != 1) {
                                                                                                                            if (e[u + 472 >> 2] = e[m + 8 >> 2], A = e[m + 4 >> 2], e[u + 464 >> 2] = e[m >> 2], e[u + 468 >> 2] = A, e[m >> 2] = 0, e[m + 4 >> 2] = 0, e[m + 8 >> 2] = 0, e[5996] = 0, A = pi(97, u + 464 | 0, 5242) | 0, p = e[5996], e[5996] = 0, (p | 0) == 1)
                                                                                                                              break Z;
                                                                                                                            if (e[u + 440 >> 2] = e[A + 8 >> 2], p = e[A + 4 >> 2], e[u + 432 >> 2] = e[A >> 2], e[u + 436 >> 2] = p, e[A >> 2] = 0, e[A + 4 >> 2] = 0, e[A + 8 >> 2] = 0, e[5996] = 0, gs(161, r | 0, s | 0, u + 432 | 0), r = e[5996], e[5996] = 0, (r | 0) == 1)
                                                                                                                              break _;
                                                                                                                            if (_[u + 443 | 0] < 0 && Br(e[u + 432 >> 2]), _[A + 11 | 0] < 0 && Br(e[A >> 2]), !me[u + 460 | 0] | _[m + 11 | 0] >= 0)
                                                                                                                              break h;
                                                                                                                            Br(e[m >> 2]);
                                                                                                                            break h;
                                                                                                                          }
                                                                                                                          s = Hr() | 0;
                                                                                                                          break Y;
                                                                                                                        }
                                                                                                                        s = Hr() | 0;
                                                                                                                        break J;
                                                                                                                      }
                                                                                                                      if (s = Hr() | 0, _[u + 443 | 0] >= 0)
                                                                                                                        break J;
                                                                                                                      Br(e[u + 432 >> 2]);
                                                                                                                    }
                                                                                                                    if (_[u + 475 | 0] >= 0)
                                                                                                                      break Y;
                                                                                                                    Br(e[u + 464 >> 2]);
                                                                                                                  }
                                                                                                                  break r;
                                                                                                                }
                                                                                                                A = u + 384 | 0, Lf(A, e[m + 4 >> 2]), e[5996] = 0, m = xn(99, A | 0, 0, 5289) | 0, A = e[5996], e[5996] = 0;
                                                                                                                X: {
                                                                                                                  Y: {
                                                                                                                    J: {
                                                                                                                      _: {
                                                                                                                        Z: {
                                                                                                                          $: {
                                                                                                                            ee: {
                                                                                                                              te: {
                                                                                                                                re: {
                                                                                                                                  ie: {
                                                                                                                                    if ((A | 0) != 1) {
                                                                                                                                      if (e[u + 408 >> 2] = e[m + 8 >> 2], A = e[m + 4 >> 2], e[u + 400 >> 2] = e[m >> 2], e[u + 404 >> 2] = A, e[m >> 2] = 0, e[m + 4 >> 2] = 0, e[m + 8 >> 2] = 0, e[5996] = 0, A = pi(97, u + 400 | 0, 5417) | 0, p = e[5996], e[5996] = 0, (p | 0) == 1)
                                                                                                                                        break ie;
                                                                                                                                      if (e[u + 472 >> 2] = e[A + 8 >> 2], p = e[A + 4 >> 2], e[u + 464 >> 2] = e[A >> 2], e[u + 468 >> 2] = p, e[A >> 2] = 0, e[A + 4 >> 2] = 0, e[A + 8 >> 2] = 0, p = e[s >> 2], N = e[p + 12 >> 2], p = e[p + 8 >> 2], e[5996] = 0, W = u + 368 | 0, ji(115, W | 0, (N - p | 0) / 12 | 0), p = e[5996], e[5996] = 0, (p | 0) == 1)
                                                                                                                                        break re;
                                                                                                                                      if (e[5996] = 0, p = me[u + 379 | 0], N = p << 24 >> 24 < 0, p = xn(100, u + 464 | 0, (N ? e[u + 368 >> 2] : W) | 0, (N ? e[u + 372 >> 2] : p) | 0) | 0, N = e[5996], e[5996] = 0, (N | 0) == 1)
                                                                                                                                        break te;
                                                                                                                                      if (e[u + 456 >> 2] = e[p + 8 >> 2], N = e[p + 4 >> 2], e[u + 448 >> 2] = e[p >> 2], e[u + 452 >> 2] = N, e[p >> 2] = 0, e[p + 4 >> 2] = 0, e[p + 8 >> 2] = 0, e[5996] = 0, N = pi(97, u + 448 | 0, 5242) | 0, W = e[5996], e[5996] = 0, (W | 0) == 1)
                                                                                                                                        break ee;
                                                                                                                                      if (e[u + 424 >> 2] = e[N + 8 >> 2], W = e[N + 4 >> 2], e[u + 416 >> 2] = e[N >> 2], e[u + 420 >> 2] = W, e[N >> 2] = 0, e[N + 4 >> 2] = 0, e[N + 8 >> 2] = 0, e[5996] = 0, gs(161, r | 0, s | 0, u + 416 | 0), r = e[5996], e[5996] = 0, (r | 0) == 1)
                                                                                                                                        break $;
                                                                                                                                      if (_[u + 427 | 0] < 0 && Br(e[u + 416 >> 2]), _[N + 11 | 0] < 0 && Br(e[N >> 2]), _[u + 379 | 0] < 0 && Br(e[u + 368 >> 2]), _[p + 11 | 0] < 0 && Br(e[p >> 2]), _[A + 11 | 0] < 0 && Br(e[A >> 2]), _[m + 11 | 0] >= 0)
                                                                                                                                        break h;
                                                                                                                                      Br(e[m >> 2]);
                                                                                                                                      break h;
                                                                                                                                    }
                                                                                                                                    s = Hr() | 0;
                                                                                                                                    break X;
                                                                                                                                  }
                                                                                                                                  s = Hr() | 0;
                                                                                                                                  break Y;
                                                                                                                                }
                                                                                                                                s = Hr() | 0;
                                                                                                                                break J;
                                                                                                                              }
                                                                                                                              s = Hr() | 0;
                                                                                                                              break _;
                                                                                                                            }
                                                                                                                            s = Hr() | 0;
                                                                                                                            break Z;
                                                                                                                          }
                                                                                                                          if (s = Hr() | 0, _[u + 427 | 0] >= 0)
                                                                                                                            break Z;
                                                                                                                          Br(e[u + 416 >> 2]);
                                                                                                                        }
                                                                                                                        if (_[u + 459 | 0] >= 0)
                                                                                                                          break _;
                                                                                                                        Br(e[u + 448 >> 2]);
                                                                                                                      }
                                                                                                                      if (_[u + 379 | 0] >= 0)
                                                                                                                        break J;
                                                                                                                      Br(e[u + 368 >> 2]);
                                                                                                                    }
                                                                                                                    if (_[u + 475 | 0] >= 0)
                                                                                                                      break Y;
                                                                                                                    Br(e[u + 464 >> 2]);
                                                                                                                  }
                                                                                                                  if (_[u + 411 | 0] >= 0)
                                                                                                                    break X;
                                                                                                                  Br(e[u + 400 >> 2]);
                                                                                                                }
                                                                                                                if (_[u + 395 | 0] >= 0)
                                                                                                                  break e;
                                                                                                                Br(e[u + 384 >> 2]);
                                                                                                                break e;
                                                                                                              }
                                                                                                              A = u + 464 | 0, Lf(A, e[m + 4 >> 2]), e[5996] = 0, m = xn(99, A | 0, 0, 5258) | 0, A = e[5996], e[5996] = 0;
                                                                                                              G: {
                                                                                                                X: {
                                                                                                                  Y: {
                                                                                                                    J: {
                                                                                                                      if ((A | 0) != 1) {
                                                                                                                        if (e[u + 456 >> 2] = e[m + 8 >> 2], A = e[m + 4 >> 2], e[u + 448 >> 2] = e[m >> 2], e[u + 452 >> 2] = A, e[m >> 2] = 0, e[m + 4 >> 2] = 0, e[m + 8 >> 2] = 0, e[5996] = 0, A = pi(97, u + 448 | 0, 5242) | 0, p = e[5996], e[5996] = 0, (p | 0) == 1)
                                                                                                                          break J;
                                                                                                                        if (e[u + 360 >> 2] = e[A + 8 >> 2], p = e[A + 4 >> 2], e[u + 352 >> 2] = e[A >> 2], e[u + 356 >> 2] = p, e[A >> 2] = 0, e[A + 4 >> 2] = 0, e[A + 8 >> 2] = 0, e[5996] = 0, gs(161, r | 0, s | 0, u + 352 | 0), r = e[5996], e[5996] = 0, (r | 0) == 1)
                                                                                                                          break Y;
                                                                                                                        if (_[u + 363 | 0] < 0 && Br(e[u + 352 >> 2]), _[A + 11 | 0] < 0 && Br(e[A >> 2]), _[m + 11 | 0] >= 0)
                                                                                                                          break h;
                                                                                                                        Br(e[m >> 2]);
                                                                                                                        break h;
                                                                                                                      }
                                                                                                                      s = Hr() | 0;
                                                                                                                      break G;
                                                                                                                    }
                                                                                                                    s = Hr() | 0;
                                                                                                                    break X;
                                                                                                                  }
                                                                                                                  if (s = Hr() | 0, _[u + 363 | 0] >= 0)
                                                                                                                    break X;
                                                                                                                  Br(e[u + 352 >> 2]);
                                                                                                                }
                                                                                                                if (_[u + 459 | 0] >= 0)
                                                                                                                  break G;
                                                                                                                Br(e[u + 448 >> 2]);
                                                                                                              }
                                                                                                              break t;
                                                                                                            }
                                                                                                            A = u + 464 | 0, Lf(A, e[m + 4 >> 2]), e[5996] = 0, m = xn(99, A | 0, 0, 5265) | 0, A = e[5996], e[5996] = 0;
                                                                                                            z: {
                                                                                                              G: {
                                                                                                                X: {
                                                                                                                  Y: {
                                                                                                                    if ((A | 0) != 1) {
                                                                                                                      if (e[u + 456 >> 2] = e[m + 8 >> 2], A = e[m + 4 >> 2], e[u + 448 >> 2] = e[m >> 2], e[u + 452 >> 2] = A, e[m >> 2] = 0, e[m + 4 >> 2] = 0, e[m + 8 >> 2] = 0, e[5996] = 0, A = pi(97, u + 448 | 0, 5242) | 0, p = e[5996], e[5996] = 0, (p | 0) == 1)
                                                                                                                        break Y;
                                                                                                                      if (e[u + 344 >> 2] = e[A + 8 >> 2], p = e[A + 4 >> 2], e[u + 336 >> 2] = e[A >> 2], e[u + 340 >> 2] = p, e[A >> 2] = 0, e[A + 4 >> 2] = 0, e[A + 8 >> 2] = 0, e[5996] = 0, gs(161, r | 0, s | 0, u + 336 | 0), r = e[5996], e[5996] = 0, (r | 0) == 1)
                                                                                                                        break X;
                                                                                                                      if (_[u + 347 | 0] < 0 && Br(e[u + 336 >> 2]), _[A + 11 | 0] < 0 && Br(e[A >> 2]), _[m + 11 | 0] >= 0)
                                                                                                                        break h;
                                                                                                                      Br(e[m >> 2]);
                                                                                                                      break h;
                                                                                                                    }
                                                                                                                    s = Hr() | 0;
                                                                                                                    break z;
                                                                                                                  }
                                                                                                                  s = Hr() | 0;
                                                                                                                  break G;
                                                                                                                }
                                                                                                                if (s = Hr() | 0, _[u + 347 | 0] >= 0)
                                                                                                                  break G;
                                                                                                                Br(e[u + 336 >> 2]);
                                                                                                              }
                                                                                                              if (_[u + 459 | 0] >= 0)
                                                                                                                break z;
                                                                                                              Br(e[u + 448 >> 2]);
                                                                                                            }
                                                                                                            break t;
                                                                                                          }
                                                                                                          if (_[u + 328 | 0] = 0, e[u + 320 >> 2] = 845244531, e[u + 324 >> 2] = 690501173, _[u + 331 | 0] = 8, e[5996] = 0, gs(161, r | 0, s | 0, u + 320 | 0), r = e[5996], e[5996] = 0, (r | 0) != 1) {
                                                                                                            if (_[u + 331 | 0] >= 0)
                                                                                                              break h;
                                                                                                            Br(e[u + 320 >> 2]);
                                                                                                            break h;
                                                                                                          }
                                                                                                          if (s = Hr() | 0, _[u + 331 | 0] >= 0)
                                                                                                            break e;
                                                                                                          Br(e[u + 320 >> 2]);
                                                                                                          break e;
                                                                                                        }
                                                                                                        if (m = Qs(16), e[u + 308 >> 2] = m, e[u + 312 >> 2] = 11, e[u + 316 >> 2] = -2147483632, A = me[5239] | me[5240] << 8 | (me[5241] << 16 | me[5242] << 24), _[m + 7 | 0] = A, _[m + 8 | 0] = A >>> 8, _[m + 9 | 0] = A >>> 16, _[m + 10 | 0] = A >>> 24, A = me[5236] | me[5237] << 8 | (me[5238] << 16 | me[5239] << 24), p = me[5232] | me[5233] << 8 | (me[5234] << 16 | me[5235] << 24), _[m | 0] = p, _[m + 1 | 0] = p >>> 8, _[m + 2 | 0] = p >>> 16, _[m + 3 | 0] = p >>> 24, _[m + 4 | 0] = A, _[m + 5 | 0] = A >>> 8, _[m + 6 | 0] = A >>> 16, _[m + 7 | 0] = A >>> 24, _[m + 11 | 0] = 0, e[5996] = 0, gs(161, r | 0, s | 0, u + 308 | 0), r = e[5996], e[5996] = 0, (r | 0) != 1) {
                                                                                                          if (_[u + 319 | 0] >= 0)
                                                                                                            break h;
                                                                                                          Br(e[u + 308 >> 2]);
                                                                                                          break h;
                                                                                                        }
                                                                                                        if (s = Hr() | 0, _[u + 319 | 0] >= 0)
                                                                                                          break e;
                                                                                                        Br(e[u + 308 >> 2]);
                                                                                                        break e;
                                                                                                      }
                                                                                                      if (_[u + 304 | 0] = me[5220], _[u + 307 | 0] = 9, _[u + 305 | 0] = 0, e[5996] = 0, m = me[5216] | me[5217] << 8 | (me[5218] << 16 | me[5219] << 24), e[u + 296 >> 2] = me[5212] | me[5213] << 8 | (me[5214] << 16 | me[5215] << 24), e[u + 300 >> 2] = m, gs(161, r | 0, s | 0, u + 296 | 0), r = e[5996], e[5996] = 0, (r | 0) != 1) {
                                                                                                        if (_[u + 307 | 0] >= 0)
                                                                                                          break h;
                                                                                                        Br(e[u + 296 >> 2]);
                                                                                                        break h;
                                                                                                      }
                                                                                                      if (s = Hr() | 0, _[u + 307 | 0] >= 0)
                                                                                                        break e;
                                                                                                      Br(e[u + 296 >> 2]);
                                                                                                      break e;
                                                                                                    }
                                                                                                    if (_[u + 288 | 0] = me[5230], _[u + 291 | 0] = 9, _[u + 289 | 0] = 0, e[5996] = 0, m = me[5226] | me[5227] << 8 | (me[5228] << 16 | me[5229] << 24), e[u + 280 >> 2] = me[5222] | me[5223] << 8 | (me[5224] << 16 | me[5225] << 24), e[u + 284 >> 2] = m, gs(161, r | 0, s | 0, u + 280 | 0), r = e[5996], e[5996] = 0, (r | 0) != 1) {
                                                                                                      if (_[u + 291 | 0] >= 0)
                                                                                                        break h;
                                                                                                      Br(e[u + 280 >> 2]);
                                                                                                      break h;
                                                                                                    }
                                                                                                    if (s = Hr() | 0, _[u + 291 | 0] >= 0)
                                                                                                      break e;
                                                                                                    Br(e[u + 280 >> 2]);
                                                                                                    break e;
                                                                                                  }
                                                                                                  if (_[u + 272 | 0] = me[2354], _[u + 279 | 0] = 5, _[u + 273 | 0] = 0, e[5996] = 0, e[u + 268 >> 2] = me[2350] | me[2351] << 8 | (me[2352] << 16 | me[2353] << 24), gs(161, r | 0, s | 0, u + 268 | 0), r = e[5996], e[5996] = 0, (r | 0) != 1) {
                                                                                                    if (_[u + 279 | 0] >= 0)
                                                                                                      break h;
                                                                                                    Br(e[u + 268 >> 2]);
                                                                                                    break h;
                                                                                                  }
                                                                                                  if (s = Hr() | 0, _[u + 279 | 0] >= 0)
                                                                                                    break e;
                                                                                                  Br(e[u + 268 >> 2]);
                                                                                                  break e;
                                                                                                }
                                                                                                if (_[u + 260 | 0] = 0, e[u + 256 >> 2] = 1702195828, _[u + 267 | 0] = 4, e[5996] = 0, gs(161, r | 0, s | 0, u + 256 | 0), r = e[5996], e[5996] = 0, (r | 0) != 1) {
                                                                                                  if (_[u + 267 | 0] >= 0)
                                                                                                    break h;
                                                                                                  Br(e[u + 256 >> 2]);
                                                                                                  break h;
                                                                                                }
                                                                                                if (s = Hr() | 0, _[u + 267 | 0] >= 0)
                                                                                                  break e;
                                                                                                Br(e[u + 256 >> 2]);
                                                                                                break e;
                                                                                              }
                                                                                              _[u + 255 | 0] = 2, _[u + 246 | 0] = 0, Zs[u + 244 >> 1] = 14945, e[5996] = 0, m = u + 464 | 0, gs(161, m | 0, s | 0, u + 244 | 0), A = e[5996], e[5996] = 0;
                                                                                              M: {
                                                                                                L: {
                                                                                                  H: {
                                                                                                    K: {
                                                                                                      W: {
                                                                                                        V: {
                                                                                                          if ((A | 0) != 1) {
                                                                                                            if (e[5996] = 0, m = pi(97, m | 0, 5574) | 0, A = e[5996], e[5996] = 0, (A | 0) == 1)
                                                                                                              break V;
                                                                                                            if (e[u + 456 >> 2] = e[m + 8 >> 2], A = e[m + 4 >> 2], e[u + 448 >> 2] = e[m >> 2], e[u + 452 >> 2] = A, e[m >> 2] = 0, e[m + 4 >> 2] = 0, e[m + 8 >> 2] = 0, s = e[e[s >> 2] + 32 >> 2], e[5996] = 0, A = u + 400 | 0, ji(141, A | 0, s | 0), s = e[5996], e[5996] = 0, (s | 0) == 1)
                                                                                                              break W;
                                                                                                            if (e[5996] = 0, p = A, s = me[u + 411 | 0], A = s << 24 >> 24 < 0, s = xn(100, u + 448 | 0, (A ? e[u + 400 >> 2] : p) | 0, (A ? e[u + 404 >> 2] : s) | 0) | 0, A = e[5996], e[5996] = 0, (A | 0) == 1)
                                                                                                              break K;
                                                                                                            A = e[s + 4 >> 2], e[r >> 2] = e[s >> 2], e[r + 4 >> 2] = A, e[r + 8 >> 2] = e[s + 8 >> 2], e[s >> 2] = 0, e[s + 4 >> 2] = 0, e[s + 8 >> 2] = 0;
                                                                                                            j: {
                                                                                                              if (_[u + 411 | 0] >= 0 || (Br(e[u + 400 >> 2]), _[s + 11 | 0] >= 0))
                                                                                                                break j;
                                                                                                              Br(e[s >> 2]);
                                                                                                            }
                                                                                                            if (_[m + 11 | 0] < 0 && Br(e[m >> 2]), _[u + 255 | 0] >= 0)
                                                                                                              break h;
                                                                                                            Br(e[u + 244 >> 2]);
                                                                                                            break h;
                                                                                                          }
                                                                                                          s = Hr() | 0;
                                                                                                          break M;
                                                                                                        }
                                                                                                        s = Hr() | 0;
                                                                                                        break L;
                                                                                                      }
                                                                                                      s = Hr() | 0;
                                                                                                      break H;
                                                                                                    }
                                                                                                    if (s = Hr() | 0, _[u + 411 | 0] >= 0)
                                                                                                      break H;
                                                                                                    Br(e[u + 400 >> 2]);
                                                                                                  }
                                                                                                  if (_[u + 459 | 0] >= 0)
                                                                                                    break L;
                                                                                                  Br(e[u + 448 >> 2]);
                                                                                                }
                                                                                                if (_[u + 475 | 0] >= 0)
                                                                                                  break M;
                                                                                                Br(e[u + 464 >> 2]);
                                                                                              }
                                                                                              if (_[u + 255 | 0] >= 0)
                                                                                                break e;
                                                                                              Br(e[u + 244 >> 2]);
                                                                                              break e;
                                                                                            }
                                                                                            _[u + 243 | 0] = 2, _[u + 234 | 0] = 0, Zs[u + 232 >> 1] = 14963, e[5996] = 0, m = u + 464 | 0, gs(161, m | 0, s | 0, u + 232 | 0), A = e[5996], e[5996] = 0;
                                                                                            F: {
                                                                                              M: {
                                                                                                L: {
                                                                                                  H: {
                                                                                                    K: {
                                                                                                      W: {
                                                                                                        if ((A | 0) != 1) {
                                                                                                          if (e[5996] = 0, m = pi(97, m | 0, 5574) | 0, A = e[5996], e[5996] = 0, (A | 0) == 1)
                                                                                                            break W;
                                                                                                          if (e[u + 456 >> 2] = e[m + 8 >> 2], A = e[m + 4 >> 2], e[u + 448 >> 2] = e[m >> 2], e[u + 452 >> 2] = A, e[m >> 2] = 0, e[m + 4 >> 2] = 0, e[m + 8 >> 2] = 0, s = e[e[s >> 2] + 32 >> 2], e[5996] = 0, A = u + 400 | 0, ji(141, A | 0, s | 0), s = e[5996], e[5996] = 0, (s | 0) == 1)
                                                                                                            break K;
                                                                                                          if (e[5996] = 0, p = A, s = me[u + 411 | 0], A = s << 24 >> 24 < 0, s = xn(100, u + 448 | 0, (A ? e[u + 400 >> 2] : p) | 0, (A ? e[u + 404 >> 2] : s) | 0) | 0, A = e[5996], e[5996] = 0, (A | 0) == 1)
                                                                                                            break H;
                                                                                                          A = e[s + 4 >> 2], e[r >> 2] = e[s >> 2], e[r + 4 >> 2] = A, e[r + 8 >> 2] = e[s + 8 >> 2], e[s >> 2] = 0, e[s + 4 >> 2] = 0, e[s + 8 >> 2] = 0;
                                                                                                          V: {
                                                                                                            if (_[u + 411 | 0] >= 0 || (Br(e[u + 400 >> 2]), _[s + 11 | 0] >= 0))
                                                                                                              break V;
                                                                                                            Br(e[s >> 2]);
                                                                                                          }
                                                                                                          if (_[m + 11 | 0] < 0 && Br(e[m >> 2]), _[u + 243 | 0] >= 0)
                                                                                                            break h;
                                                                                                          Br(e[u + 232 >> 2]);
                                                                                                          break h;
                                                                                                        }
                                                                                                        s = Hr() | 0;
                                                                                                        break F;
                                                                                                      }
                                                                                                      s = Hr() | 0;
                                                                                                      break M;
                                                                                                    }
                                                                                                    s = Hr() | 0;
                                                                                                    break L;
                                                                                                  }
                                                                                                  if (s = Hr() | 0, _[u + 411 | 0] >= 0)
                                                                                                    break L;
                                                                                                  Br(e[u + 400 >> 2]);
                                                                                                }
                                                                                                if (_[u + 459 | 0] >= 0)
                                                                                                  break M;
                                                                                                Br(e[u + 448 >> 2]);
                                                                                              }
                                                                                              if (_[u + 475 | 0] >= 0)
                                                                                                break F;
                                                                                              Br(e[u + 464 >> 2]);
                                                                                            }
                                                                                            if (_[u + 243 | 0] >= 0)
                                                                                              break e;
                                                                                            Br(e[u + 232 >> 2]);
                                                                                            break e;
                                                                                          }
                                                                                          _[u + 231 | 0] = 2, _[u + 222 | 0] = 0, Zs[u + 220 >> 1] = 14947, e[5996] = 0, m = u + 464 | 0, gs(161, m | 0, s | 0, u + 220 | 0), A = e[5996], e[5996] = 0;
                                                                                          U: {
                                                                                            F: {
                                                                                              M: {
                                                                                                L: {
                                                                                                  H: {
                                                                                                    K: {
                                                                                                      if ((A | 0) != 1) {
                                                                                                        if (e[5996] = 0, m = pi(97, m | 0, 5574) | 0, A = e[5996], e[5996] = 0, (A | 0) == 1)
                                                                                                          break K;
                                                                                                        if (e[u + 456 >> 2] = e[m + 8 >> 2], A = e[m + 4 >> 2], e[u + 448 >> 2] = e[m >> 2], e[u + 452 >> 2] = A, e[m >> 2] = 0, e[m + 4 >> 2] = 0, e[m + 8 >> 2] = 0, s = e[e[s >> 2] + 32 >> 2], e[5996] = 0, A = u + 400 | 0, ji(141, A | 0, s | 0), s = e[5996], e[5996] = 0, (s | 0) == 1)
                                                                                                          break H;
                                                                                                        if (e[5996] = 0, p = A, s = me[u + 411 | 0], A = s << 24 >> 24 < 0, s = xn(100, u + 448 | 0, (A ? e[u + 400 >> 2] : p) | 0, (A ? e[u + 404 >> 2] : s) | 0) | 0, A = e[5996], e[5996] = 0, (A | 0) == 1)
                                                                                                          break L;
                                                                                                        A = e[s + 4 >> 2], e[r >> 2] = e[s >> 2], e[r + 4 >> 2] = A, e[r + 8 >> 2] = e[s + 8 >> 2], e[s >> 2] = 0, e[s + 4 >> 2] = 0, e[s + 8 >> 2] = 0;
                                                                                                        W: {
                                                                                                          if (_[u + 411 | 0] >= 0 || (Br(e[u + 400 >> 2]), _[s + 11 | 0] >= 0))
                                                                                                            break W;
                                                                                                          Br(e[s >> 2]);
                                                                                                        }
                                                                                                        if (_[m + 11 | 0] < 0 && Br(e[m >> 2]), _[u + 231 | 0] >= 0)
                                                                                                          break h;
                                                                                                        Br(e[u + 220 >> 2]);
                                                                                                        break h;
                                                                                                      }
                                                                                                      s = Hr() | 0;
                                                                                                      break U;
                                                                                                    }
                                                                                                    s = Hr() | 0;
                                                                                                    break F;
                                                                                                  }
                                                                                                  s = Hr() | 0;
                                                                                                  break M;
                                                                                                }
                                                                                                if (s = Hr() | 0, _[u + 411 | 0] >= 0)
                                                                                                  break M;
                                                                                                Br(e[u + 400 >> 2]);
                                                                                              }
                                                                                              if (_[u + 459 | 0] >= 0)
                                                                                                break F;
                                                                                              Br(e[u + 448 >> 2]);
                                                                                            }
                                                                                            if (_[u + 475 | 0] >= 0)
                                                                                              break U;
                                                                                            Br(e[u + 464 >> 2]);
                                                                                          }
                                                                                          if (_[u + 231 | 0] >= 0)
                                                                                            break e;
                                                                                          Br(e[u + 220 >> 2]);
                                                                                          break e;
                                                                                        }
                                                                                        _[u + 219 | 0] = 2, _[u + 210 | 0] = 0, Zs[u + 208 >> 1] = 14948, e[5996] = 0, m = u + 464 | 0, gs(161, m | 0, s | 0, u + 208 | 0), A = e[5996], e[5996] = 0;
                                                                                        Q: {
                                                                                          U: {
                                                                                            F: {
                                                                                              M: {
                                                                                                L: {
                                                                                                  H: {
                                                                                                    if ((A | 0) != 1) {
                                                                                                      if (e[5996] = 0, m = pi(97, m | 0, 5574) | 0, A = e[5996], e[5996] = 0, (A | 0) == 1)
                                                                                                        break H;
                                                                                                      if (e[u + 456 >> 2] = e[m + 8 >> 2], A = e[m + 4 >> 2], e[u + 448 >> 2] = e[m >> 2], e[u + 452 >> 2] = A, e[m >> 2] = 0, e[m + 4 >> 2] = 0, e[m + 8 >> 2] = 0, s = e[e[s >> 2] + 32 >> 2], e[5996] = 0, A = u + 400 | 0, ji(141, A | 0, s | 0), s = e[5996], e[5996] = 0, (s | 0) == 1)
                                                                                                        break L;
                                                                                                      if (e[5996] = 0, p = A, s = me[u + 411 | 0], A = s << 24 >> 24 < 0, s = xn(100, u + 448 | 0, (A ? e[u + 400 >> 2] : p) | 0, (A ? e[u + 404 >> 2] : s) | 0) | 0, A = e[5996], e[5996] = 0, (A | 0) == 1)
                                                                                                        break M;
                                                                                                      A = e[s + 4 >> 2], e[r >> 2] = e[s >> 2], e[r + 4 >> 2] = A, e[r + 8 >> 2] = e[s + 8 >> 2], e[s >> 2] = 0, e[s + 4 >> 2] = 0, e[s + 8 >> 2] = 0;
                                                                                                      K: {
                                                                                                        if (_[u + 411 | 0] >= 0 || (Br(e[u + 400 >> 2]), _[s + 11 | 0] >= 0))
                                                                                                          break K;
                                                                                                        Br(e[s >> 2]);
                                                                                                      }
                                                                                                      if (_[m + 11 | 0] < 0 && Br(e[m >> 2]), _[u + 219 | 0] >= 0)
                                                                                                        break h;
                                                                                                      Br(e[u + 208 >> 2]);
                                                                                                      break h;
                                                                                                    }
                                                                                                    s = Hr() | 0;
                                                                                                    break Q;
                                                                                                  }
                                                                                                  s = Hr() | 0;
                                                                                                  break U;
                                                                                                }
                                                                                                s = Hr() | 0;
                                                                                                break F;
                                                                                              }
                                                                                              if (s = Hr() | 0, _[u + 411 | 0] >= 0)
                                                                                                break F;
                                                                                              Br(e[u + 400 >> 2]);
                                                                                            }
                                                                                            if (_[u + 459 | 0] >= 0)
                                                                                              break U;
                                                                                            Br(e[u + 448 >> 2]);
                                                                                          }
                                                                                          if (_[u + 475 | 0] >= 0)
                                                                                            break Q;
                                                                                          Br(e[u + 464 >> 2]);
                                                                                        }
                                                                                        if (_[u + 219 | 0] >= 0)
                                                                                          break e;
                                                                                        Br(e[u + 208 >> 2]);
                                                                                        break e;
                                                                                      }
                                                                                      _[u + 207 | 0] = 2, _[u + 198 | 0] = 0, Zs[u + 196 >> 1] = 14966, e[5996] = 0, m = u + 464 | 0, gs(161, m | 0, s | 0, u + 196 | 0), A = e[5996], e[5996] = 0;
                                                                                      O: {
                                                                                        Q: {
                                                                                          U: {
                                                                                            F: {
                                                                                              M: {
                                                                                                L: {
                                                                                                  if ((A | 0) != 1) {
                                                                                                    if (e[5996] = 0, m = pi(97, m | 0, 5574) | 0, A = e[5996], e[5996] = 0, (A | 0) == 1)
                                                                                                      break L;
                                                                                                    if (e[u + 456 >> 2] = e[m + 8 >> 2], A = e[m + 4 >> 2], e[u + 448 >> 2] = e[m >> 2], e[u + 452 >> 2] = A, e[m >> 2] = 0, e[m + 4 >> 2] = 0, e[m + 8 >> 2] = 0, s = e[e[s >> 2] + 32 >> 2], e[5996] = 0, A = u + 400 | 0, ji(141, A | 0, s | 0), s = e[5996], e[5996] = 0, (s | 0) == 1)
                                                                                                      break M;
                                                                                                    if (e[5996] = 0, p = A, s = me[u + 411 | 0], A = s << 24 >> 24 < 0, s = xn(100, u + 448 | 0, (A ? e[u + 400 >> 2] : p) | 0, (A ? e[u + 404 >> 2] : s) | 0) | 0, A = e[5996], e[5996] = 0, (A | 0) == 1)
                                                                                                      break F;
                                                                                                    A = e[s + 4 >> 2], e[r >> 2] = e[s >> 2], e[r + 4 >> 2] = A, e[r + 8 >> 2] = e[s + 8 >> 2], e[s >> 2] = 0, e[s + 4 >> 2] = 0, e[s + 8 >> 2] = 0;
                                                                                                    H: {
                                                                                                      if (_[u + 411 | 0] >= 0 || (Br(e[u + 400 >> 2]), _[s + 11 | 0] >= 0))
                                                                                                        break H;
                                                                                                      Br(e[s >> 2]);
                                                                                                    }
                                                                                                    if (_[m + 11 | 0] < 0 && Br(e[m >> 2]), _[u + 207 | 0] >= 0)
                                                                                                      break h;
                                                                                                    Br(e[u + 196 >> 2]);
                                                                                                    break h;
                                                                                                  }
                                                                                                  s = Hr() | 0;
                                                                                                  break O;
                                                                                                }
                                                                                                s = Hr() | 0;
                                                                                                break Q;
                                                                                              }
                                                                                              s = Hr() | 0;
                                                                                              break U;
                                                                                            }
                                                                                            if (s = Hr() | 0, _[u + 411 | 0] >= 0)
                                                                                              break U;
                                                                                            Br(e[u + 400 >> 2]);
                                                                                          }
                                                                                          if (_[u + 459 | 0] >= 0)
                                                                                            break Q;
                                                                                          Br(e[u + 448 >> 2]);
                                                                                        }
                                                                                        if (_[u + 475 | 0] >= 0)
                                                                                          break O;
                                                                                        Br(e[u + 464 >> 2]);
                                                                                      }
                                                                                      if (_[u + 207 | 0] >= 0)
                                                                                        break e;
                                                                                      Br(e[u + 196 >> 2]);
                                                                                      break e;
                                                                                    }
                                                                                    _[u + 195 | 0] = 2, _[u + 186 | 0] = 0, Zs[u + 184 >> 1] = 14958, e[5996] = 0, m = u + 464 | 0, gs(161, m | 0, s | 0, u + 184 | 0), A = e[5996], e[5996] = 0;
                                                                                    q: {
                                                                                      O: {
                                                                                        Q: {
                                                                                          U: {
                                                                                            F: {
                                                                                              M: {
                                                                                                if ((A | 0) != 1) {
                                                                                                  if (e[5996] = 0, m = pi(97, m | 0, 5574) | 0, A = e[5996], e[5996] = 0, (A | 0) == 1)
                                                                                                    break M;
                                                                                                  if (e[u + 456 >> 2] = e[m + 8 >> 2], A = e[m + 4 >> 2], e[u + 448 >> 2] = e[m >> 2], e[u + 452 >> 2] = A, e[m >> 2] = 0, e[m + 4 >> 2] = 0, e[m + 8 >> 2] = 0, s = e[e[s >> 2] + 32 >> 2], e[5996] = 0, A = u + 400 | 0, ji(141, A | 0, s | 0), s = e[5996], e[5996] = 0, (s | 0) == 1)
                                                                                                    break F;
                                                                                                  if (e[5996] = 0, p = A, s = me[u + 411 | 0], A = s << 24 >> 24 < 0, s = xn(100, u + 448 | 0, (A ? e[u + 400 >> 2] : p) | 0, (A ? e[u + 404 >> 2] : s) | 0) | 0, A = e[5996], e[5996] = 0, (A | 0) == 1)
                                                                                                    break U;
                                                                                                  A = e[s + 4 >> 2], e[r >> 2] = e[s >> 2], e[r + 4 >> 2] = A, e[r + 8 >> 2] = e[s + 8 >> 2], e[s >> 2] = 0, e[s + 4 >> 2] = 0, e[s + 8 >> 2] = 0;
                                                                                                  L: {
                                                                                                    if (_[u + 411 | 0] >= 0 || (Br(e[u + 400 >> 2]), _[s + 11 | 0] >= 0))
                                                                                                      break L;
                                                                                                    Br(e[s >> 2]);
                                                                                                  }
                                                                                                  if (_[m + 11 | 0] < 0 && Br(e[m >> 2]), _[u + 195 | 0] >= 0)
                                                                                                    break h;
                                                                                                  Br(e[u + 184 >> 2]);
                                                                                                  break h;
                                                                                                }
                                                                                                s = Hr() | 0;
                                                                                                break q;
                                                                                              }
                                                                                              s = Hr() | 0;
                                                                                              break O;
                                                                                            }
                                                                                            s = Hr() | 0;
                                                                                            break Q;
                                                                                          }
                                                                                          if (s = Hr() | 0, _[u + 411 | 0] >= 0)
                                                                                            break Q;
                                                                                          Br(e[u + 400 >> 2]);
                                                                                        }
                                                                                        if (_[u + 459 | 0] >= 0)
                                                                                          break O;
                                                                                        Br(e[u + 448 >> 2]);
                                                                                      }
                                                                                      if (_[u + 475 | 0] >= 0)
                                                                                        break q;
                                                                                      Br(e[u + 464 >> 2]);
                                                                                    }
                                                                                    if (_[u + 195 | 0] >= 0)
                                                                                      break e;
                                                                                    Br(e[u + 184 >> 2]);
                                                                                    break e;
                                                                                  }
                                                                                  _[u + 183 | 0] = 2, _[u + 174 | 0] = 0, Zs[u + 172 >> 1] = 14954, e[5996] = 0, m = u + 464 | 0, gs(161, m | 0, s | 0, u + 172 | 0), A = e[5996], e[5996] = 0;
                                                                                  P: {
                                                                                    q: {
                                                                                      O: {
                                                                                        Q: {
                                                                                          U: {
                                                                                            F: {
                                                                                              if ((A | 0) != 1) {
                                                                                                if (e[5996] = 0, m = pi(97, m | 0, 5574) | 0, A = e[5996], e[5996] = 0, (A | 0) == 1)
                                                                                                  break F;
                                                                                                if (e[u + 456 >> 2] = e[m + 8 >> 2], A = e[m + 4 >> 2], e[u + 448 >> 2] = e[m >> 2], e[u + 452 >> 2] = A, e[m >> 2] = 0, e[m + 4 >> 2] = 0, e[m + 8 >> 2] = 0, s = e[e[s >> 2] + 32 >> 2], e[5996] = 0, A = u + 400 | 0, ji(141, A | 0, s | 0), s = e[5996], e[5996] = 0, (s | 0) == 1)
                                                                                                  break U;
                                                                                                if (e[5996] = 0, p = A, s = me[u + 411 | 0], A = s << 24 >> 24 < 0, s = xn(100, u + 448 | 0, (A ? e[u + 400 >> 2] : p) | 0, (A ? e[u + 404 >> 2] : s) | 0) | 0, A = e[5996], e[5996] = 0, (A | 0) == 1)
                                                                                                  break Q;
                                                                                                A = e[s + 4 >> 2], e[r >> 2] = e[s >> 2], e[r + 4 >> 2] = A, e[r + 8 >> 2] = e[s + 8 >> 2], e[s >> 2] = 0, e[s + 4 >> 2] = 0, e[s + 8 >> 2] = 0;
                                                                                                M: {
                                                                                                  if (_[u + 411 | 0] >= 0 || (Br(e[u + 400 >> 2]), _[s + 11 | 0] >= 0))
                                                                                                    break M;
                                                                                                  Br(e[s >> 2]);
                                                                                                }
                                                                                                if (_[m + 11 | 0] < 0 && Br(e[m >> 2]), _[u + 183 | 0] >= 0)
                                                                                                  break h;
                                                                                                Br(e[u + 172 >> 2]);
                                                                                                break h;
                                                                                              }
                                                                                              s = Hr() | 0;
                                                                                              break P;
                                                                                            }
                                                                                            s = Hr() | 0;
                                                                                            break q;
                                                                                          }
                                                                                          s = Hr() | 0;
                                                                                          break O;
                                                                                        }
                                                                                        if (s = Hr() | 0, _[u + 411 | 0] >= 0)
                                                                                          break O;
                                                                                        Br(e[u + 400 >> 2]);
                                                                                      }
                                                                                      if (_[u + 459 | 0] >= 0)
                                                                                        break q;
                                                                                      Br(e[u + 448 >> 2]);
                                                                                    }
                                                                                    if (_[u + 475 | 0] >= 0)
                                                                                      break P;
                                                                                    Br(e[u + 464 >> 2]);
                                                                                  }
                                                                                  if (_[u + 183 | 0] >= 0)
                                                                                    break e;
                                                                                  Br(e[u + 172 >> 2]);
                                                                                  break e;
                                                                                }
                                                                                _[u + 164 | 0] = me[1271], _[u + 171 | 0] = 5, _[u + 165 | 0] = 0, e[5996] = 0, e[u + 160 >> 2] = me[1267] | me[1268] << 8 | (me[1269] << 16 | me[1270] << 24), m = u + 368 | 0, gs(161, m | 0, s | 0, u + 160 | 0), A = e[5996], e[5996] = 0;
                                                                                D: {
                                                                                  P: {
                                                                                    q: {
                                                                                      O: {
                                                                                        Q: {
                                                                                          U: {
                                                                                            F: {
                                                                                              M: {
                                                                                                L: {
                                                                                                  H: {
                                                                                                    K: {
                                                                                                      W: {
                                                                                                        V: {
                                                                                                          j: {
                                                                                                            if ((A | 0) != 1) {
                                                                                                              if (e[5996] = 0, m = pi(97, m | 0, 3673) | 0, A = e[5996], e[5996] = 0, (A | 0) == 1)
                                                                                                                break j;
                                                                                                              if (e[u + 392 >> 2] = e[m + 8 >> 2], A = e[m + 4 >> 2], e[u + 384 >> 2] = e[m >> 2], e[u + 388 >> 2] = A, e[m >> 2] = 0, e[m + 4 >> 2] = 0, e[m + 8 >> 2] = 0, A = e[e[s >> 2] + 32 >> 2], e[5996] = 0, p = u + 144 | 0, ji(141, p | 0, A | 0), A = e[5996], e[5996] = 0, (A | 0) == 1)
                                                                                                                break V;
                                                                                                              if (e[5996] = 0, N = p, A = me[u + 155 | 0], p = A << 24 >> 24 < 0, A = xn(100, u + 384 | 0, (p ? e[u + 144 >> 2] : N) | 0, (p ? e[u + 148 >> 2] : A) | 0) | 0, p = e[5996], e[5996] = 0, (p | 0) == 1)
                                                                                                                break W;
                                                                                                              if (e[u + 408 >> 2] = e[A + 8 >> 2], p = e[A + 4 >> 2], e[u + 400 >> 2] = e[A >> 2], e[u + 404 >> 2] = p, e[A >> 2] = 0, e[A + 4 >> 2] = 0, e[A + 8 >> 2] = 0, e[5996] = 0, p = pi(97, u + 400 | 0, 3613) | 0, N = e[5996], e[5996] = 0, (N | 0) == 1)
                                                                                                                break K;
                                                                                                              if (e[u + 472 >> 2] = e[p + 8 >> 2], N = e[p + 4 >> 2], e[u + 464 >> 2] = e[p >> 2], e[u + 468 >> 2] = N, e[p >> 2] = 0, e[p + 4 >> 2] = 0, e[p + 8 >> 2] = 0, s = e[e[s >> 2] + 32 >> 2], e[5996] = 0, N = u + 128 | 0, ji(141, N | 0, s + 8 | 0), s = e[5996], e[5996] = 0, (s | 0) == 1)
                                                                                                                break H;
                                                                                                              if (e[5996] = 0, W = N, s = me[u + 139 | 0], N = s << 24 >> 24 < 0, N = xn(100, u + 464 | 0, (N ? e[u + 128 >> 2] : W) | 0, (N ? e[u + 132 >> 2] : s) | 0) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1)
                                                                                                                break L;
                                                                                                              if (e[u + 456 >> 2] = e[N + 8 >> 2], s = e[N + 4 >> 2], e[u + 448 >> 2] = e[N >> 2], e[u + 452 >> 2] = s, e[N >> 2] = 0, e[N + 4 >> 2] = 0, e[N + 8 >> 2] = 0, e[5996] = 0, s = pi(97, u + 448 | 0, 3570) | 0, W = e[5996], e[5996] = 0, (W | 0) == 1)
                                                                                                                break M;
                                                                                                              if (W = e[s + 4 >> 2], e[r >> 2] = e[s >> 2], e[r + 4 >> 2] = W, e[r + 8 >> 2] = e[s + 8 >> 2], e[s >> 2] = 0, e[s + 4 >> 2] = 0, e[s + 8 >> 2] = 0, _[u + 139 | 0] < 0 && Br(e[u + 128 >> 2]), _[N + 11 | 0] < 0 && Br(e[N >> 2]), _[p + 11 | 0] < 0 && Br(e[p >> 2]), _[u + 155 | 0] < 0 && Br(e[u + 144 >> 2]), _[A + 11 | 0] < 0 && Br(e[A >> 2]), _[m + 11 | 0] < 0 && Br(e[m >> 2]), _[u + 171 | 0] >= 0)
                                                                                                                break h;
                                                                                                              Br(e[u + 160 >> 2]);
                                                                                                              break h;
                                                                                                            }
                                                                                                            s = Hr() | 0;
                                                                                                            break D;
                                                                                                          }
                                                                                                          s = Hr() | 0;
                                                                                                          break P;
                                                                                                        }
                                                                                                        s = Hr() | 0;
                                                                                                        break q;
                                                                                                      }
                                                                                                      s = Hr() | 0;
                                                                                                      break O;
                                                                                                    }
                                                                                                    s = Hr() | 0;
                                                                                                    break Q;
                                                                                                  }
                                                                                                  s = Hr() | 0;
                                                                                                  break U;
                                                                                                }
                                                                                                s = Hr() | 0;
                                                                                                break F;
                                                                                              }
                                                                                              if (s = Hr() | 0, _[u + 459 | 0] >= 0)
                                                                                                break F;
                                                                                              Br(e[u + 448 >> 2]);
                                                                                            }
                                                                                            if (_[u + 139 | 0] >= 0)
                                                                                              break U;
                                                                                            Br(e[u + 128 >> 2]);
                                                                                          }
                                                                                          if (_[u + 475 | 0] >= 0)
                                                                                            break Q;
                                                                                          Br(e[u + 464 >> 2]);
                                                                                        }
                                                                                        if (_[u + 411 | 0] >= 0)
                                                                                          break O;
                                                                                        Br(e[u + 400 >> 2]);
                                                                                      }
                                                                                      if (_[u + 155 | 0] >= 0)
                                                                                        break q;
                                                                                      Br(e[u + 144 >> 2]);
                                                                                    }
                                                                                    if (_[u + 395 | 0] >= 0)
                                                                                      break P;
                                                                                    Br(e[u + 384 >> 2]);
                                                                                  }
                                                                                  if (_[u + 379 | 0] >= 0)
                                                                                    break D;
                                                                                  Br(e[u + 368 >> 2]);
                                                                                }
                                                                                if (_[u + 171 | 0] >= 0)
                                                                                  break e;
                                                                                Br(e[u + 160 >> 2]);
                                                                                break e;
                                                                              }
                                                                              _[u + 120 | 0] = me[2551], _[u + 127 | 0] = 5, _[u + 121 | 0] = 0, e[5996] = 0, e[u + 116 >> 2] = me[2547] | me[2548] << 8 | (me[2549] << 16 | me[2550] << 24), m = u + 368 | 0, gs(161, m | 0, s | 0, u + 116 | 0), A = e[5996], e[5996] = 0;
                                                                              y: {
                                                                                D: {
                                                                                  P: {
                                                                                    q: {
                                                                                      O: {
                                                                                        Q: {
                                                                                          U: {
                                                                                            F: {
                                                                                              M: {
                                                                                                L: {
                                                                                                  H: {
                                                                                                    K: {
                                                                                                      W: {
                                                                                                        V: {
                                                                                                          if ((A | 0) != 1) {
                                                                                                            if (e[5996] = 0, m = pi(97, m | 0, 3673) | 0, A = e[5996], e[5996] = 0, (A | 0) == 1)
                                                                                                              break V;
                                                                                                            if (e[u + 392 >> 2] = e[m + 8 >> 2], A = e[m + 4 >> 2], e[u + 384 >> 2] = e[m >> 2], e[u + 388 >> 2] = A, e[m >> 2] = 0, e[m + 4 >> 2] = 0, e[m + 8 >> 2] = 0, A = e[e[s >> 2] + 32 >> 2], e[5996] = 0, p = u + 144 | 0, ji(141, p | 0, A | 0), A = e[5996], e[5996] = 0, (A | 0) == 1)
                                                                                                              break W;
                                                                                                            if (e[5996] = 0, N = p, A = me[u + 155 | 0], p = A << 24 >> 24 < 0, A = xn(100, u + 384 | 0, (p ? e[u + 144 >> 2] : N) | 0, (p ? e[u + 148 >> 2] : A) | 0) | 0, p = e[5996], e[5996] = 0, (p | 0) == 1)
                                                                                                              break K;
                                                                                                            if (e[u + 408 >> 2] = e[A + 8 >> 2], p = e[A + 4 >> 2], e[u + 400 >> 2] = e[A >> 2], e[u + 404 >> 2] = p, e[A >> 2] = 0, e[A + 4 >> 2] = 0, e[A + 8 >> 2] = 0, e[5996] = 0, p = pi(97, u + 400 | 0, 3613) | 0, N = e[5996], e[5996] = 0, (N | 0) == 1)
                                                                                                              break H;
                                                                                                            if (e[u + 472 >> 2] = e[p + 8 >> 2], N = e[p + 4 >> 2], e[u + 464 >> 2] = e[p >> 2], e[u + 468 >> 2] = N, e[p >> 2] = 0, e[p + 4 >> 2] = 0, e[p + 8 >> 2] = 0, s = e[e[s >> 2] + 32 >> 2], e[5996] = 0, N = u + 128 | 0, ji(141, N | 0, s + 8 | 0), s = e[5996], e[5996] = 0, (s | 0) == 1)
                                                                                                              break L;
                                                                                                            if (e[5996] = 0, W = N, s = me[u + 139 | 0], N = s << 24 >> 24 < 0, N = xn(100, u + 464 | 0, (N ? e[u + 128 >> 2] : W) | 0, (N ? e[u + 132 >> 2] : s) | 0) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1)
                                                                                                              break M;
                                                                                                            if (e[u + 456 >> 2] = e[N + 8 >> 2], s = e[N + 4 >> 2], e[u + 448 >> 2] = e[N >> 2], e[u + 452 >> 2] = s, e[N >> 2] = 0, e[N + 4 >> 2] = 0, e[N + 8 >> 2] = 0, e[5996] = 0, s = pi(97, u + 448 | 0, 3570) | 0, W = e[5996], e[5996] = 0, (W | 0) == 1)
                                                                                                              break F;
                                                                                                            if (W = e[s + 4 >> 2], e[r >> 2] = e[s >> 2], e[r + 4 >> 2] = W, e[r + 8 >> 2] = e[s + 8 >> 2], e[s >> 2] = 0, e[s + 4 >> 2] = 0, e[s + 8 >> 2] = 0, _[u + 139 | 0] < 0 && Br(e[u + 128 >> 2]), _[N + 11 | 0] < 0 && Br(e[N >> 2]), _[p + 11 | 0] < 0 && Br(e[p >> 2]), _[u + 155 | 0] < 0 && Br(e[u + 144 >> 2]), _[A + 11 | 0] < 0 && Br(e[A >> 2]), _[m + 11 | 0] < 0 && Br(e[m >> 2]), _[u + 127 | 0] >= 0)
                                                                                                              break h;
                                                                                                            Br(e[u + 116 >> 2]);
                                                                                                            break h;
                                                                                                          }
                                                                                                          s = Hr() | 0;
                                                                                                          break y;
                                                                                                        }
                                                                                                        s = Hr() | 0;
                                                                                                        break D;
                                                                                                      }
                                                                                                      s = Hr() | 0;
                                                                                                      break P;
                                                                                                    }
                                                                                                    s = Hr() | 0;
                                                                                                    break q;
                                                                                                  }
                                                                                                  s = Hr() | 0;
                                                                                                  break O;
                                                                                                }
                                                                                                s = Hr() | 0;
                                                                                                break Q;
                                                                                              }
                                                                                              s = Hr() | 0;
                                                                                              break U;
                                                                                            }
                                                                                            if (s = Hr() | 0, _[u + 459 | 0] >= 0)
                                                                                              break U;
                                                                                            Br(e[u + 448 >> 2]);
                                                                                          }
                                                                                          if (_[u + 139 | 0] >= 0)
                                                                                            break Q;
                                                                                          Br(e[u + 128 >> 2]);
                                                                                        }
                                                                                        if (_[u + 475 | 0] >= 0)
                                                                                          break O;
                                                                                        Br(e[u + 464 >> 2]);
                                                                                      }
                                                                                      if (_[u + 411 | 0] >= 0)
                                                                                        break q;
                                                                                      Br(e[u + 400 >> 2]);
                                                                                    }
                                                                                    if (_[u + 155 | 0] >= 0)
                                                                                      break P;
                                                                                    Br(e[u + 144 >> 2]);
                                                                                  }
                                                                                  if (_[u + 395 | 0] >= 0)
                                                                                    break D;
                                                                                  Br(e[u + 384 >> 2]);
                                                                                }
                                                                                if (_[u + 379 | 0] >= 0)
                                                                                  break y;
                                                                                Br(e[u + 368 >> 2]);
                                                                              }
                                                                              if (_[u + 127 | 0] >= 0)
                                                                                break e;
                                                                              Br(e[u + 116 >> 2]);
                                                                              break e;
                                                                            }
                                                                            _[u + 115 | 0] = 4, _[u + 108 | 0] = 0, e[u + 104 >> 2] = 1650422383, e[5996] = 0, m = u + 368 | 0, gs(161, m | 0, s | 0, u + 104 | 0), A = e[5996], e[5996] = 0;
                                                                            C: {
                                                                              y: {
                                                                                D: {
                                                                                  P: {
                                                                                    q: {
                                                                                      O: {
                                                                                        Q: {
                                                                                          U: {
                                                                                            F: {
                                                                                              M: {
                                                                                                L: {
                                                                                                  H: {
                                                                                                    K: {
                                                                                                      W: {
                                                                                                        if ((A | 0) != 1) {
                                                                                                          if (e[5996] = 0, m = pi(97, m | 0, 3673) | 0, A = e[5996], e[5996] = 0, (A | 0) == 1)
                                                                                                            break W;
                                                                                                          if (e[u + 392 >> 2] = e[m + 8 >> 2], A = e[m + 4 >> 2], e[u + 384 >> 2] = e[m >> 2], e[u + 388 >> 2] = A, e[m >> 2] = 0, e[m + 4 >> 2] = 0, e[m + 8 >> 2] = 0, A = e[e[s >> 2] + 32 >> 2], e[5996] = 0, p = u + 144 | 0, ji(141, p | 0, A | 0), A = e[5996], e[5996] = 0, (A | 0) == 1)
                                                                                                            break K;
                                                                                                          if (e[5996] = 0, N = p, A = me[u + 155 | 0], p = A << 24 >> 24 < 0, A = xn(100, u + 384 | 0, (p ? e[u + 144 >> 2] : N) | 0, (p ? e[u + 148 >> 2] : A) | 0) | 0, p = e[5996], e[5996] = 0, (p | 0) == 1)
                                                                                                            break H;
                                                                                                          if (e[u + 408 >> 2] = e[A + 8 >> 2], p = e[A + 4 >> 2], e[u + 400 >> 2] = e[A >> 2], e[u + 404 >> 2] = p, e[A >> 2] = 0, e[A + 4 >> 2] = 0, e[A + 8 >> 2] = 0, e[5996] = 0, p = pi(97, u + 400 | 0, 3613) | 0, N = e[5996], e[5996] = 0, (N | 0) == 1)
                                                                                                            break L;
                                                                                                          if (e[u + 472 >> 2] = e[p + 8 >> 2], N = e[p + 4 >> 2], e[u + 464 >> 2] = e[p >> 2], e[u + 468 >> 2] = N, e[p >> 2] = 0, e[p + 4 >> 2] = 0, e[p + 8 >> 2] = 0, s = e[e[s >> 2] + 32 >> 2], e[5996] = 0, N = u + 128 | 0, ji(141, N | 0, s + 8 | 0), s = e[5996], e[5996] = 0, (s | 0) == 1)
                                                                                                            break M;
                                                                                                          if (e[5996] = 0, W = N, s = me[u + 139 | 0], N = s << 24 >> 24 < 0, N = xn(100, u + 464 | 0, (N ? e[u + 128 >> 2] : W) | 0, (N ? e[u + 132 >> 2] : s) | 0) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1)
                                                                                                            break F;
                                                                                                          if (e[u + 456 >> 2] = e[N + 8 >> 2], s = e[N + 4 >> 2], e[u + 448 >> 2] = e[N >> 2], e[u + 452 >> 2] = s, e[N >> 2] = 0, e[N + 4 >> 2] = 0, e[N + 8 >> 2] = 0, e[5996] = 0, s = pi(97, u + 448 | 0, 3570) | 0, W = e[5996], e[5996] = 0, (W | 0) == 1)
                                                                                                            break U;
                                                                                                          if (W = e[s + 4 >> 2], e[r >> 2] = e[s >> 2], e[r + 4 >> 2] = W, e[r + 8 >> 2] = e[s + 8 >> 2], e[s >> 2] = 0, e[s + 4 >> 2] = 0, e[s + 8 >> 2] = 0, _[u + 139 | 0] < 0 && Br(e[u + 128 >> 2]), _[N + 11 | 0] < 0 && Br(e[N >> 2]), _[p + 11 | 0] < 0 && Br(e[p >> 2]), _[u + 155 | 0] < 0 && Br(e[u + 144 >> 2]), _[A + 11 | 0] < 0 && Br(e[A >> 2]), _[m + 11 | 0] < 0 && Br(e[m >> 2]), _[u + 115 | 0] >= 0)
                                                                                                            break h;
                                                                                                          Br(e[u + 104 >> 2]);
                                                                                                          break h;
                                                                                                        }
                                                                                                        s = Hr() | 0;
                                                                                                        break C;
                                                                                                      }
                                                                                                      s = Hr() | 0;
                                                                                                      break y;
                                                                                                    }
                                                                                                    s = Hr() | 0;
                                                                                                    break D;
                                                                                                  }
                                                                                                  s = Hr() | 0;
                                                                                                  break P;
                                                                                                }
                                                                                                s = Hr() | 0;
                                                                                                break q;
                                                                                              }
                                                                                              s = Hr() | 0;
                                                                                              break O;
                                                                                            }
                                                                                            s = Hr() | 0;
                                                                                            break Q;
                                                                                          }
                                                                                          if (s = Hr() | 0, _[u + 459 | 0] >= 0)
                                                                                            break Q;
                                                                                          Br(e[u + 448 >> 2]);
                                                                                        }
                                                                                        if (_[u + 139 | 0] >= 0)
                                                                                          break O;
                                                                                        Br(e[u + 128 >> 2]);
                                                                                      }
                                                                                      if (_[u + 475 | 0] >= 0)
                                                                                        break q;
                                                                                      Br(e[u + 464 >> 2]);
                                                                                    }
                                                                                    if (_[u + 411 | 0] >= 0)
                                                                                      break P;
                                                                                    Br(e[u + 400 >> 2]);
                                                                                  }
                                                                                  if (_[u + 155 | 0] >= 0)
                                                                                    break D;
                                                                                  Br(e[u + 144 >> 2]);
                                                                                }
                                                                                if (_[u + 395 | 0] >= 0)
                                                                                  break y;
                                                                                Br(e[u + 384 >> 2]);
                                                                              }
                                                                              if (_[u + 379 | 0] >= 0)
                                                                                break C;
                                                                              Br(e[u + 368 >> 2]);
                                                                            }
                                                                            if (_[u + 115 | 0] >= 0)
                                                                              break e;
                                                                            Br(e[u + 104 >> 2]);
                                                                            break e;
                                                                          }
                                                                          _[u + 103 | 0] = 4, _[u + 96 | 0] = 0, e[u + 92 >> 2] = 1667199599, e[5996] = 0, m = u + 368 | 0, gs(161, m | 0, s | 0, u + 92 | 0), A = e[5996], e[5996] = 0;
                                                                          b: {
                                                                            C: {
                                                                              y: {
                                                                                D: {
                                                                                  P: {
                                                                                    q: {
                                                                                      O: {
                                                                                        Q: {
                                                                                          U: {
                                                                                            F: {
                                                                                              M: {
                                                                                                L: {
                                                                                                  H: {
                                                                                                    K: {
                                                                                                      if ((A | 0) != 1) {
                                                                                                        if (e[5996] = 0, m = pi(97, m | 0, 3673) | 0, A = e[5996], e[5996] = 0, (A | 0) == 1)
                                                                                                          break K;
                                                                                                        if (e[u + 392 >> 2] = e[m + 8 >> 2], A = e[m + 4 >> 2], e[u + 384 >> 2] = e[m >> 2], e[u + 388 >> 2] = A, e[m >> 2] = 0, e[m + 4 >> 2] = 0, e[m + 8 >> 2] = 0, A = e[e[s >> 2] + 32 >> 2], e[5996] = 0, p = u + 144 | 0, ji(141, p | 0, A | 0), A = e[5996], e[5996] = 0, (A | 0) == 1)
                                                                                                          break H;
                                                                                                        if (e[5996] = 0, N = p, A = me[u + 155 | 0], p = A << 24 >> 24 < 0, A = xn(100, u + 384 | 0, (p ? e[u + 144 >> 2] : N) | 0, (p ? e[u + 148 >> 2] : A) | 0) | 0, p = e[5996], e[5996] = 0, (p | 0) == 1)
                                                                                                          break L;
                                                                                                        if (e[u + 408 >> 2] = e[A + 8 >> 2], p = e[A + 4 >> 2], e[u + 400 >> 2] = e[A >> 2], e[u + 404 >> 2] = p, e[A >> 2] = 0, e[A + 4 >> 2] = 0, e[A + 8 >> 2] = 0, e[5996] = 0, p = pi(97, u + 400 | 0, 3613) | 0, N = e[5996], e[5996] = 0, (N | 0) == 1)
                                                                                                          break M;
                                                                                                        if (e[u + 472 >> 2] = e[p + 8 >> 2], N = e[p + 4 >> 2], e[u + 464 >> 2] = e[p >> 2], e[u + 468 >> 2] = N, e[p >> 2] = 0, e[p + 4 >> 2] = 0, e[p + 8 >> 2] = 0, s = e[e[s >> 2] + 32 >> 2], e[5996] = 0, N = u + 128 | 0, ji(141, N | 0, s + 8 | 0), s = e[5996], e[5996] = 0, (s | 0) == 1)
                                                                                                          break F;
                                                                                                        if (e[5996] = 0, W = N, s = me[u + 139 | 0], N = s << 24 >> 24 < 0, N = xn(100, u + 464 | 0, (N ? e[u + 128 >> 2] : W) | 0, (N ? e[u + 132 >> 2] : s) | 0) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1)
                                                                                                          break U;
                                                                                                        if (e[u + 456 >> 2] = e[N + 8 >> 2], s = e[N + 4 >> 2], e[u + 448 >> 2] = e[N >> 2], e[u + 452 >> 2] = s, e[N >> 2] = 0, e[N + 4 >> 2] = 0, e[N + 8 >> 2] = 0, e[5996] = 0, s = pi(97, u + 448 | 0, 3570) | 0, W = e[5996], e[5996] = 0, (W | 0) == 1)
                                                                                                          break Q;
                                                                                                        if (W = e[s + 4 >> 2], e[r >> 2] = e[s >> 2], e[r + 4 >> 2] = W, e[r + 8 >> 2] = e[s + 8 >> 2], e[s >> 2] = 0, e[s + 4 >> 2] = 0, e[s + 8 >> 2] = 0, _[u + 139 | 0] < 0 && Br(e[u + 128 >> 2]), _[N + 11 | 0] < 0 && Br(e[N >> 2]), _[p + 11 | 0] < 0 && Br(e[p >> 2]), _[u + 155 | 0] < 0 && Br(e[u + 144 >> 2]), _[A + 11 | 0] < 0 && Br(e[A >> 2]), _[m + 11 | 0] < 0 && Br(e[m >> 2]), _[u + 103 | 0] >= 0)
                                                                                                          break h;
                                                                                                        Br(e[u + 92 >> 2]);
                                                                                                        break h;
                                                                                                      }
                                                                                                      s = Hr() | 0;
                                                                                                      break b;
                                                                                                    }
                                                                                                    s = Hr() | 0;
                                                                                                    break C;
                                                                                                  }
                                                                                                  s = Hr() | 0;
                                                                                                  break y;
                                                                                                }
                                                                                                s = Hr() | 0;
                                                                                                break D;
                                                                                              }
                                                                                              s = Hr() | 0;
                                                                                              break P;
                                                                                            }
                                                                                            s = Hr() | 0;
                                                                                            break q;
                                                                                          }
                                                                                          s = Hr() | 0;
                                                                                          break O;
                                                                                        }
                                                                                        if (s = Hr() | 0, _[u + 459 | 0] >= 0)
                                                                                          break O;
                                                                                        Br(e[u + 448 >> 2]);
                                                                                      }
                                                                                      if (_[u + 139 | 0] >= 0)
                                                                                        break q;
                                                                                      Br(e[u + 128 >> 2]);
                                                                                    }
                                                                                    if (_[u + 475 | 0] >= 0)
                                                                                      break P;
                                                                                    Br(e[u + 464 >> 2]);
                                                                                  }
                                                                                  if (_[u + 411 | 0] >= 0)
                                                                                    break D;
                                                                                  Br(e[u + 400 >> 2]);
                                                                                }
                                                                                if (_[u + 155 | 0] >= 0)
                                                                                  break y;
                                                                                Br(e[u + 144 >> 2]);
                                                                              }
                                                                              if (_[u + 395 | 0] >= 0)
                                                                                break C;
                                                                              Br(e[u + 384 >> 2]);
                                                                            }
                                                                            if (_[u + 379 | 0] >= 0)
                                                                              break b;
                                                                            Br(e[u + 368 >> 2]);
                                                                          }
                                                                          if (_[u + 103 | 0] >= 0)
                                                                            break e;
                                                                          Br(e[u + 92 >> 2]);
                                                                          break e;
                                                                        }
                                                                        _[u + 91 | 0] = 4, _[u + 84 | 0] = 0, e[u + 80 >> 2] = 1683976815, e[5996] = 0, m = u + 368 | 0, gs(161, m | 0, s | 0, u + 80 | 0), A = e[5996], e[5996] = 0;
                                                                        x: {
                                                                          b: {
                                                                            C: {
                                                                              y: {
                                                                                D: {
                                                                                  P: {
                                                                                    q: {
                                                                                      O: {
                                                                                        Q: {
                                                                                          U: {
                                                                                            F: {
                                                                                              M: {
                                                                                                L: {
                                                                                                  H: {
                                                                                                    if ((A | 0) != 1) {
                                                                                                      if (e[5996] = 0, m = pi(97, m | 0, 3673) | 0, A = e[5996], e[5996] = 0, (A | 0) == 1)
                                                                                                        break H;
                                                                                                      if (e[u + 392 >> 2] = e[m + 8 >> 2], A = e[m + 4 >> 2], e[u + 384 >> 2] = e[m >> 2], e[u + 388 >> 2] = A, e[m >> 2] = 0, e[m + 4 >> 2] = 0, e[m + 8 >> 2] = 0, A = e[e[s >> 2] + 32 >> 2], e[5996] = 0, p = u + 144 | 0, ji(141, p | 0, A | 0), A = e[5996], e[5996] = 0, (A | 0) == 1)
                                                                                                        break L;
                                                                                                      if (e[5996] = 0, N = p, A = me[u + 155 | 0], p = A << 24 >> 24 < 0, A = xn(100, u + 384 | 0, (p ? e[u + 144 >> 2] : N) | 0, (p ? e[u + 148 >> 2] : A) | 0) | 0, p = e[5996], e[5996] = 0, (p | 0) == 1)
                                                                                                        break M;
                                                                                                      if (e[u + 408 >> 2] = e[A + 8 >> 2], p = e[A + 4 >> 2], e[u + 400 >> 2] = e[A >> 2], e[u + 404 >> 2] = p, e[A >> 2] = 0, e[A + 4 >> 2] = 0, e[A + 8 >> 2] = 0, e[5996] = 0, p = pi(97, u + 400 | 0, 3613) | 0, N = e[5996], e[5996] = 0, (N | 0) == 1)
                                                                                                        break F;
                                                                                                      if (e[u + 472 >> 2] = e[p + 8 >> 2], N = e[p + 4 >> 2], e[u + 464 >> 2] = e[p >> 2], e[u + 468 >> 2] = N, e[p >> 2] = 0, e[p + 4 >> 2] = 0, e[p + 8 >> 2] = 0, s = e[e[s >> 2] + 32 >> 2], e[5996] = 0, N = u + 128 | 0, ji(141, N | 0, s + 8 | 0), s = e[5996], e[5996] = 0, (s | 0) == 1)
                                                                                                        break U;
                                                                                                      if (e[5996] = 0, W = N, s = me[u + 139 | 0], N = s << 24 >> 24 < 0, N = xn(100, u + 464 | 0, (N ? e[u + 128 >> 2] : W) | 0, (N ? e[u + 132 >> 2] : s) | 0) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1)
                                                                                                        break Q;
                                                                                                      if (e[u + 456 >> 2] = e[N + 8 >> 2], s = e[N + 4 >> 2], e[u + 448 >> 2] = e[N >> 2], e[u + 452 >> 2] = s, e[N >> 2] = 0, e[N + 4 >> 2] = 0, e[N + 8 >> 2] = 0, e[5996] = 0, s = pi(97, u + 448 | 0, 3570) | 0, W = e[5996], e[5996] = 0, (W | 0) == 1)
                                                                                                        break O;
                                                                                                      if (W = e[s + 4 >> 2], e[r >> 2] = e[s >> 2], e[r + 4 >> 2] = W, e[r + 8 >> 2] = e[s + 8 >> 2], e[s >> 2] = 0, e[s + 4 >> 2] = 0, e[s + 8 >> 2] = 0, _[u + 139 | 0] < 0 && Br(e[u + 128 >> 2]), _[N + 11 | 0] < 0 && Br(e[N >> 2]), _[p + 11 | 0] < 0 && Br(e[p >> 2]), _[u + 155 | 0] < 0 && Br(e[u + 144 >> 2]), _[A + 11 | 0] < 0 && Br(e[A >> 2]), _[m + 11 | 0] < 0 && Br(e[m >> 2]), _[u + 91 | 0] >= 0)
                                                                                                        break h;
                                                                                                      Br(e[u + 80 >> 2]);
                                                                                                      break h;
                                                                                                    }
                                                                                                    s = Hr() | 0;
                                                                                                    break x;
                                                                                                  }
                                                                                                  s = Hr() | 0;
                                                                                                  break b;
                                                                                                }
                                                                                                s = Hr() | 0;
                                                                                                break C;
                                                                                              }
                                                                                              s = Hr() | 0;
                                                                                              break y;
                                                                                            }
                                                                                            s = Hr() | 0;
                                                                                            break D;
                                                                                          }
                                                                                          s = Hr() | 0;
                                                                                          break P;
                                                                                        }
                                                                                        s = Hr() | 0;
                                                                                        break q;
                                                                                      }
                                                                                      if (s = Hr() | 0, _[u + 459 | 0] >= 0)
                                                                                        break q;
                                                                                      Br(e[u + 448 >> 2]);
                                                                                    }
                                                                                    if (_[u + 139 | 0] >= 0)
                                                                                      break P;
                                                                                    Br(e[u + 128 >> 2]);
                                                                                  }
                                                                                  if (_[u + 475 | 0] >= 0)
                                                                                    break D;
                                                                                  Br(e[u + 464 >> 2]);
                                                                                }
                                                                                if (_[u + 411 | 0] >= 0)
                                                                                  break y;
                                                                                Br(e[u + 400 >> 2]);
                                                                              }
                                                                              if (_[u + 155 | 0] >= 0)
                                                                                break C;
                                                                              Br(e[u + 144 >> 2]);
                                                                            }
                                                                            if (_[u + 395 | 0] >= 0)
                                                                              break b;
                                                                            Br(e[u + 384 >> 2]);
                                                                          }
                                                                          if (_[u + 379 | 0] >= 0)
                                                                            break x;
                                                                          Br(e[u + 368 >> 2]);
                                                                        }
                                                                        if (_[u + 91 | 0] >= 0)
                                                                          break e;
                                                                        Br(e[u + 80 >> 2]);
                                                                        break e;
                                                                      }
                                                                      _[u + 79 | 0] = 4, _[u + 72 | 0] = 0, e[u + 68 >> 2] = 1767862895, e[5996] = 0, m = u + 368 | 0, gs(161, m | 0, s | 0, u + 68 | 0), A = e[5996], e[5996] = 0;
                                                                      B: {
                                                                        x: {
                                                                          b: {
                                                                            C: {
                                                                              y: {
                                                                                D: {
                                                                                  P: {
                                                                                    q: {
                                                                                      O: {
                                                                                        Q: {
                                                                                          U: {
                                                                                            F: {
                                                                                              M: {
                                                                                                L: {
                                                                                                  if ((A | 0) != 1) {
                                                                                                    if (e[5996] = 0, m = pi(97, m | 0, 3673) | 0, A = e[5996], e[5996] = 0, (A | 0) == 1)
                                                                                                      break L;
                                                                                                    if (e[u + 392 >> 2] = e[m + 8 >> 2], A = e[m + 4 >> 2], e[u + 384 >> 2] = e[m >> 2], e[u + 388 >> 2] = A, e[m >> 2] = 0, e[m + 4 >> 2] = 0, e[m + 8 >> 2] = 0, A = e[e[s >> 2] + 32 >> 2], e[5996] = 0, p = u + 144 | 0, ji(141, p | 0, A | 0), A = e[5996], e[5996] = 0, (A | 0) == 1)
                                                                                                      break M;
                                                                                                    if (e[5996] = 0, N = p, A = me[u + 155 | 0], p = A << 24 >> 24 < 0, A = xn(100, u + 384 | 0, (p ? e[u + 144 >> 2] : N) | 0, (p ? e[u + 148 >> 2] : A) | 0) | 0, p = e[5996], e[5996] = 0, (p | 0) == 1)
                                                                                                      break F;
                                                                                                    if (e[u + 408 >> 2] = e[A + 8 >> 2], p = e[A + 4 >> 2], e[u + 400 >> 2] = e[A >> 2], e[u + 404 >> 2] = p, e[A >> 2] = 0, e[A + 4 >> 2] = 0, e[A + 8 >> 2] = 0, e[5996] = 0, p = pi(97, u + 400 | 0, 3613) | 0, N = e[5996], e[5996] = 0, (N | 0) == 1)
                                                                                                      break U;
                                                                                                    if (e[u + 472 >> 2] = e[p + 8 >> 2], N = e[p + 4 >> 2], e[u + 464 >> 2] = e[p >> 2], e[u + 468 >> 2] = N, e[p >> 2] = 0, e[p + 4 >> 2] = 0, e[p + 8 >> 2] = 0, s = e[e[s >> 2] + 32 >> 2], e[5996] = 0, N = u + 128 | 0, ji(141, N | 0, s + 8 | 0), s = e[5996], e[5996] = 0, (s | 0) == 1)
                                                                                                      break Q;
                                                                                                    if (e[5996] = 0, W = N, s = me[u + 139 | 0], N = s << 24 >> 24 < 0, N = xn(100, u + 464 | 0, (N ? e[u + 128 >> 2] : W) | 0, (N ? e[u + 132 >> 2] : s) | 0) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1)
                                                                                                      break O;
                                                                                                    if (e[u + 456 >> 2] = e[N + 8 >> 2], s = e[N + 4 >> 2], e[u + 448 >> 2] = e[N >> 2], e[u + 452 >> 2] = s, e[N >> 2] = 0, e[N + 4 >> 2] = 0, e[N + 8 >> 2] = 0, e[5996] = 0, s = pi(97, u + 448 | 0, 3570) | 0, W = e[5996], e[5996] = 0, (W | 0) == 1)
                                                                                                      break q;
                                                                                                    if (W = e[s + 4 >> 2], e[r >> 2] = e[s >> 2], e[r + 4 >> 2] = W, e[r + 8 >> 2] = e[s + 8 >> 2], e[s >> 2] = 0, e[s + 4 >> 2] = 0, e[s + 8 >> 2] = 0, _[u + 139 | 0] < 0 && Br(e[u + 128 >> 2]), _[N + 11 | 0] < 0 && Br(e[N >> 2]), _[p + 11 | 0] < 0 && Br(e[p >> 2]), _[u + 155 | 0] < 0 && Br(e[u + 144 >> 2]), _[A + 11 | 0] < 0 && Br(e[A >> 2]), _[m + 11 | 0] < 0 && Br(e[m >> 2]), _[u + 79 | 0] >= 0)
                                                                                                      break h;
                                                                                                    Br(e[u + 68 >> 2]);
                                                                                                    break h;
                                                                                                  }
                                                                                                  s = Hr() | 0;
                                                                                                  break B;
                                                                                                }
                                                                                                s = Hr() | 0;
                                                                                                break x;
                                                                                              }
                                                                                              s = Hr() | 0;
                                                                                              break b;
                                                                                            }
                                                                                            s = Hr() | 0;
                                                                                            break C;
                                                                                          }
                                                                                          s = Hr() | 0;
                                                                                          break y;
                                                                                        }
                                                                                        s = Hr() | 0;
                                                                                        break D;
                                                                                      }
                                                                                      s = Hr() | 0;
                                                                                      break P;
                                                                                    }
                                                                                    if (s = Hr() | 0, _[u + 459 | 0] >= 0)
                                                                                      break P;
                                                                                    Br(e[u + 448 >> 2]);
                                                                                  }
                                                                                  if (_[u + 139 | 0] >= 0)
                                                                                    break D;
                                                                                  Br(e[u + 128 >> 2]);
                                                                                }
                                                                                if (_[u + 475 | 0] >= 0)
                                                                                  break y;
                                                                                Br(e[u + 464 >> 2]);
                                                                              }
                                                                              if (_[u + 411 | 0] >= 0)
                                                                                break C;
                                                                              Br(e[u + 400 >> 2]);
                                                                            }
                                                                            if (_[u + 155 | 0] >= 0)
                                                                              break b;
                                                                            Br(e[u + 144 >> 2]);
                                                                          }
                                                                          if (_[u + 395 | 0] >= 0)
                                                                            break x;
                                                                          Br(e[u + 384 >> 2]);
                                                                        }
                                                                        if (_[u + 379 | 0] >= 0)
                                                                          break B;
                                                                        Br(e[u + 368 >> 2]);
                                                                      }
                                                                      if (_[u + 79 | 0] >= 0)
                                                                        break e;
                                                                      Br(e[u + 68 >> 2]);
                                                                      break e;
                                                                    }
                                                                    Zs[u - -64 >> 1] = me[2600] | me[2601] << 8, Zs[u + 66 >> 1] = 2560, e[5996] = 0, m = me[2596] | me[2597] << 8 | (me[2598] << 16 | me[2599] << 24), e[u + 56 >> 2] = me[2592] | me[2593] << 8 | (me[2594] << 16 | me[2595] << 24), e[u + 60 >> 2] = m, m = u + 128 | 0, gs(161, m | 0, s | 0, u + 56 | 0), A = e[5996], e[5996] = 0;
                                                                    I: {
                                                                      B: {
                                                                        x: {
                                                                          b: {
                                                                            C: {
                                                                              y: {
                                                                                D: {
                                                                                  P: {
                                                                                    q: {
                                                                                      O: {
                                                                                        Q: {
                                                                                          U: {
                                                                                            F: {
                                                                                              M: {
                                                                                                L: {
                                                                                                  H: {
                                                                                                    K: {
                                                                                                      W: {
                                                                                                        V: {
                                                                                                          j: {
                                                                                                            if ((A | 0) != 1) {
                                                                                                              if (e[5996] = 0, m = pi(97, m | 0, 3623) | 0, A = e[5996], e[5996] = 0, (A | 0) == 1)
                                                                                                                break j;
                                                                                                              if (e[u + 152 >> 2] = e[m + 8 >> 2], A = e[m + 4 >> 2], e[u + 144 >> 2] = e[m >> 2], e[u + 148 >> 2] = A, e[m >> 2] = 0, e[m + 4 >> 2] = 0, e[m + 8 >> 2] = 0, A = e[e[s >> 2] + 32 >> 2], e[5996] = 0, p = u + 40 | 0, ji(141, p | 0, A | 0), A = e[5996], e[5996] = 0, (A | 0) == 1)
                                                                                                                break V;
                                                                                                              if (e[5996] = 0, N = p, A = me[u + 51 | 0], p = A << 24 >> 24 < 0, A = xn(100, u + 144 | 0, (p ? e[u + 40 >> 2] : N) | 0, (p ? e[u + 44 >> 2] : A) | 0) | 0, p = e[5996], e[5996] = 0, (p | 0) == 1)
                                                                                                                break W;
                                                                                                              if (e[u + 376 >> 2] = e[A + 8 >> 2], p = e[A + 4 >> 2], e[u + 368 >> 2] = e[A >> 2], e[u + 372 >> 2] = p, e[A >> 2] = 0, e[A + 4 >> 2] = 0, e[A + 8 >> 2] = 0, e[5996] = 0, p = pi(97, u + 368 | 0, 3613) | 0, N = e[5996], e[5996] = 0, (N | 0) == 1)
                                                                                                                break K;
                                                                                                              if (e[u + 392 >> 2] = e[p + 8 >> 2], N = e[p + 4 >> 2], e[u + 384 >> 2] = e[p >> 2], e[u + 388 >> 2] = N, e[p >> 2] = 0, e[p + 4 >> 2] = 0, e[p + 8 >> 2] = 0, N = e[e[s >> 2] + 32 >> 2], e[5996] = 0, W = u + 28 | 0, ji(141, W | 0, N + 8 | 0), N = e[5996], e[5996] = 0, (N | 0) == 1)
                                                                                                                break H;
                                                                                                              if (e[5996] = 0, Te = W, N = me[u + 39 | 0], W = N << 24 >> 24 < 0, N = xn(100, u + 384 | 0, (W ? e[u + 28 >> 2] : Te) | 0, (W ? e[u + 32 >> 2] : N) | 0) | 0, W = e[5996], e[5996] = 0, (W | 0) == 1)
                                                                                                                break L;
                                                                                                              if (e[u + 408 >> 2] = e[N + 8 >> 2], W = e[N + 4 >> 2], e[u + 400 >> 2] = e[N >> 2], e[u + 404 >> 2] = W, e[N >> 2] = 0, e[N + 4 >> 2] = 0, e[N + 8 >> 2] = 0, e[5996] = 0, W = pi(97, u + 400 | 0, 3603) | 0, Te = e[5996], e[5996] = 0, (Te | 0) == 1)
                                                                                                                break M;
                                                                                                              if (e[u + 472 >> 2] = e[W + 8 >> 2], Te = e[W + 4 >> 2], e[u + 464 >> 2] = e[W >> 2], e[u + 468 >> 2] = Te, e[W >> 2] = 0, e[W + 4 >> 2] = 0, e[W + 8 >> 2] = 0, s = e[e[s >> 2] + 32 >> 2], e[5996] = 0, Te = u + 16 | 0, ji(141, Te | 0, s + 16 | 0), s = e[5996], e[5996] = 0, (s | 0) == 1)
                                                                                                                break F;
                                                                                                              if (e[5996] = 0, Xe = Te, s = me[u + 27 | 0], Te = s << 24 >> 24 < 0, Te = xn(100, u + 464 | 0, (Te ? e[u + 16 >> 2] : Xe) | 0, (Te ? e[u + 20 >> 2] : s) | 0) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1)
                                                                                                                break U;
                                                                                                              if (e[u + 456 >> 2] = e[Te + 8 >> 2], s = e[Te + 4 >> 2], e[u + 448 >> 2] = e[Te >> 2], e[u + 452 >> 2] = s, e[Te >> 2] = 0, e[Te + 4 >> 2] = 0, e[Te + 8 >> 2] = 0, e[5996] = 0, s = pi(97, u + 448 | 0, 3570) | 0, Xe = e[5996], e[5996] = 0, (Xe | 0) == 1)
                                                                                                                break Q;
                                                                                                              if (Xe = e[s + 4 >> 2], e[r >> 2] = e[s >> 2], e[r + 4 >> 2] = Xe, e[r + 8 >> 2] = e[s + 8 >> 2], e[s >> 2] = 0, e[s + 4 >> 2] = 0, e[s + 8 >> 2] = 0, _[u + 27 | 0] < 0 && Br(e[u + 16 >> 2]), _[Te + 11 | 0] < 0 && Br(e[Te >> 2]), _[W + 11 | 0] < 0 && Br(e[W >> 2]), _[u + 39 | 0] < 0 && Br(e[u + 28 >> 2]), _[N + 11 | 0] < 0 && Br(e[N >> 2]), _[p + 11 | 0] < 0 && Br(e[p >> 2]), _[u + 51 | 0] < 0 && Br(e[u + 40 >> 2]), _[A + 11 | 0] < 0 && Br(e[A >> 2]), _[m + 11 | 0] < 0 && Br(e[m >> 2]), _[u + 67 | 0] >= 0)
                                                                                                                break h;
                                                                                                              Br(e[u + 56 >> 2]);
                                                                                                              break h;
                                                                                                            }
                                                                                                            s = Hr() | 0;
                                                                                                            break I;
                                                                                                          }
                                                                                                          s = Hr() | 0;
                                                                                                          break B;
                                                                                                        }
                                                                                                        s = Hr() | 0;
                                                                                                        break x;
                                                                                                      }
                                                                                                      s = Hr() | 0;
                                                                                                      break b;
                                                                                                    }
                                                                                                    s = Hr() | 0;
                                                                                                    break C;
                                                                                                  }
                                                                                                  s = Hr() | 0;
                                                                                                  break y;
                                                                                                }
                                                                                                s = Hr() | 0;
                                                                                                break D;
                                                                                              }
                                                                                              s = Hr() | 0;
                                                                                              break P;
                                                                                            }
                                                                                            s = Hr() | 0;
                                                                                            break q;
                                                                                          }
                                                                                          s = Hr() | 0;
                                                                                          break O;
                                                                                        }
                                                                                        if (s = Hr() | 0, _[u + 459 | 0] >= 0)
                                                                                          break O;
                                                                                        Br(e[u + 448 >> 2]);
                                                                                      }
                                                                                      if (_[u + 27 | 0] >= 0)
                                                                                        break q;
                                                                                      Br(e[u + 16 >> 2]);
                                                                                    }
                                                                                    if (_[u + 475 | 0] >= 0)
                                                                                      break P;
                                                                                    Br(e[u + 464 >> 2]);
                                                                                  }
                                                                                  if (_[u + 411 | 0] >= 0)
                                                                                    break D;
                                                                                  Br(e[u + 400 >> 2]);
                                                                                }
                                                                                if (_[u + 39 | 0] >= 0)
                                                                                  break y;
                                                                                Br(e[u + 28 >> 2]);
                                                                              }
                                                                              if (_[u + 395 | 0] >= 0)
                                                                                break C;
                                                                              Br(e[u + 384 >> 2]);
                                                                            }
                                                                            if (_[u + 379 | 0] >= 0)
                                                                              break b;
                                                                            Br(e[u + 368 >> 2]);
                                                                          }
                                                                          if (_[u + 51 | 0] >= 0)
                                                                            break x;
                                                                          Br(e[u + 40 >> 2]);
                                                                        }
                                                                        if (_[u + 155 | 0] >= 0)
                                                                          break B;
                                                                        Br(e[u + 144 >> 2]);
                                                                      }
                                                                      if (_[u + 139 | 0] >= 0)
                                                                        break I;
                                                                      Br(e[u + 128 >> 2]);
                                                                    }
                                                                    if (_[u + 67 | 0] >= 0)
                                                                      break e;
                                                                    Br(e[u + 56 >> 2]);
                                                                    break e;
                                                                  }
                                                                  if (A = u + 144 | 0, Lf(A, e[m + 4 >> 2]), e[5996] = 0, m = xn(99, A | 0, 0, 5302) | 0, A = e[5996], e[5996] = 0, (A | 0) == 1)
                                                                    break E;
                                                                  if (e[u + 376 >> 2] = e[m + 8 >> 2], A = e[m + 4 >> 2], e[u + 368 >> 2] = e[m >> 2], e[u + 372 >> 2] = A, e[m >> 2] = 0, e[m + 4 >> 2] = 0, e[m + 8 >> 2] = 0, e[5996] = 0, A = pi(97, u + 368 | 0, 5417) | 0, p = e[5996], e[5996] = 0, (p | 0) == 1)
                                                                    break w;
                                                                  if (e[u + 392 >> 2] = e[A + 8 >> 2], p = e[A + 4 >> 2], e[u + 384 >> 2] = e[A >> 2], e[u + 388 >> 2] = p, e[A >> 2] = 0, e[A + 4 >> 2] = 0, e[A + 8 >> 2] = 0, p = e[s >> 2], N = e[p + 36 >> 2], p = e[p + 32 >> 2], e[5996] = 0, W = u + 128 | 0, ji(115, W | 0, N - p >> 3), p = e[5996], e[5996] = 0, (p | 0) == 1)
                                                                    break v;
                                                                  if (e[5996] = 0, p = me[u + 139 | 0], N = p << 24 >> 24 < 0, p = xn(100, u + 384 | 0, (N ? e[u + 128 >> 2] : W) | 0, (N ? e[u + 132 >> 2] : p) | 0) | 0, N = e[5996], e[5996] = 0, (N | 0) == 1)
                                                                    break T;
                                                                  if (e[u + 408 >> 2] = e[p + 8 >> 2], N = e[p + 4 >> 2], e[u + 400 >> 2] = e[p >> 2], e[u + 404 >> 2] = N, e[p >> 2] = 0, e[p + 4 >> 2] = 0, e[p + 8 >> 2] = 0, e[5996] = 0, N = pi(97, u + 400 | 0, 5242) | 0, W = e[5996], e[5996] = 0, (W | 0) == 1)
                                                                    break S;
                                                                  if (e[u + 8 >> 2] = e[N + 8 >> 2], W = e[N + 4 >> 2], e[u >> 2] = e[N >> 2], e[u + 4 >> 2] = W, e[N >> 2] = 0, e[N + 4 >> 2] = 0, e[N + 8 >> 2] = 0, e[5996] = 0, W = u + 464 | 0, gs(161, W | 0, s | 0, u | 0), Te = e[5996], e[5996] = 0, (Te | 0) == 1)
                                                                    break N;
                                                                  if (e[5996] = 0, W = pi(97, W | 0, 3726) | 0, Te = e[5996], e[5996] = 0, (Te | 0) == 1)
                                                                    break k;
                                                                  if (e[u + 456 >> 2] = e[W + 8 >> 2], Te = e[W + 4 >> 2], e[u + 448 >> 2] = e[W >> 2], e[u + 452 >> 2] = Te, e[W >> 2] = 0, e[W + 4 >> 2] = 0, e[W + 8 >> 2] = 0, _[u + 11 | 0] < 0 && Br(e[u >> 2]), _[N + 11 | 0] < 0 && Br(e[N >> 2]), _[u + 139 | 0] < 0 && Br(e[u + 128 >> 2]), _[p + 11 | 0] < 0 && Br(e[p >> 2]), _[A + 11 | 0] < 0 && Br(e[A >> 2]), _[m + 11 | 0] < 0 && Br(e[m >> 2]), s = e[s >> 2], A = e[s + 32 >> 2], p = e[s + 36 >> 2], (A | 0) != (p | 0))
                                                                    for (; ; ) {
                                                                      if (e[5996] = 0, s = u + 28 | 0, ji(141, s | 0, A | 0), m = e[5996], e[5996] = 0, (m | 0) == 1)
                                                                        break d;
                                                                      if (e[5996] = 0, s = xn(99, s | 0, 0, 3708) | 0, m = e[5996], e[5996] = 0, (m | 0) == 1)
                                                                        break c;
                                                                      if (e[u + 48 >> 2] = e[s + 8 >> 2], m = e[s + 4 >> 2], e[u + 40 >> 2] = e[s >> 2], e[u + 44 >> 2] = m, e[s >> 2] = 0, e[s + 4 >> 2] = 0, e[s + 8 >> 2] = 0, e[5996] = 0, m = pi(97, u + 40 | 0, 3713) | 0, N = e[5996], e[5996] = 0, (N | 0) == 1)
                                                                        break l;
                                                                      if (e[u + 136 >> 2] = e[m + 8 >> 2], N = e[m + 4 >> 2], e[u + 128 >> 2] = e[m >> 2], e[u + 132 >> 2] = N, e[m >> 2] = 0, e[m + 4 >> 2] = 0, e[m + 8 >> 2] = 0, e[5996] = 0, N = me[u + 139 | 0], W = N << 24 >> 24 < 0, xn(100, u + 448 | 0, (W ? e[u + 128 >> 2] : u + 128 | 0) | 0, (W ? e[u + 132 >> 2] : N) | 0) | 0, N = e[5996], e[5996] = 0, (N | 0) == 1)
                                                                        break o;
                                                                      if (_[u + 139 | 0] < 0 && Br(e[u + 128 >> 2]), _[u + 51 | 0] < 0 && Br(e[m >> 2]), _[u + 39 | 0] < 0 && Br(e[s >> 2]), A = A + 8 | 0, (p | 0) == (A | 0))
                                                                        break;
                                                                    }
                                                                  if (e[5996] = 0, s = pi(97, u + 448 | 0, 3575) | 0, m = e[5996], e[5996] = 0, (m | 0) == 1)
                                                                    break n;
                                                                  m = e[s + 4 >> 2], e[r >> 2] = e[s >> 2], e[r + 4 >> 2] = m, e[r + 8 >> 2] = e[s + 8 >> 2], e[s >> 2] = 0, e[s + 4 >> 2] = 0, e[s + 8 >> 2] = 0;
                                                                }
                                                                Jr = u + 496 | 0;
                                                                return;
                                                              }
                                                              s = Hr() | 0;
                                                              break f;
                                                            }
                                                            s = Hr() | 0;
                                                            break u;
                                                          }
                                                          s = Hr() | 0;
                                                          break g;
                                                        }
                                                        s = Hr() | 0;
                                                        break A;
                                                      }
                                                      s = Hr() | 0;
                                                      break p;
                                                    }
                                                    s = Hr() | 0;
                                                    break m;
                                                  }
                                                  if (s = Hr() | 0, _[u + 475 | 0] >= 0)
                                                    break m;
                                                  Br(e[u + 464 >> 2]);
                                                }
                                                if (_[u + 11 | 0] >= 0)
                                                  break p;
                                                Br(e[u >> 2]);
                                              }
                                              if (_[u + 411 | 0] >= 0)
                                                break A;
                                              Br(e[u + 400 >> 2]);
                                            }
                                            if (_[u + 139 | 0] >= 0)
                                              break g;
                                            Br(e[u + 128 >> 2]);
                                          }
                                          if (_[u + 395 | 0] >= 0)
                                            break u;
                                          Br(e[u + 384 >> 2]);
                                        }
                                        if (_[u + 379 | 0] >= 0)
                                          break f;
                                        Br(e[u + 368 >> 2]);
                                      }
                                      if (_[u + 155 | 0] >= 0)
                                        break e;
                                      Br(e[u + 144 >> 2]);
                                      break e;
                                    }
                                    s = Hr() | 0;
                                    break i;
                                  }
                                  s = Hr() | 0;
                                  break s;
                                }
                                s = Hr() | 0;
                                break a;
                              }
                              if (s = Hr() | 0, _[u + 139 | 0] >= 0)
                                break a;
                              Br(e[u + 128 >> 2]);
                            }
                            if (_[u + 51 | 0] >= 0)
                              break s;
                            Br(e[u + 40 >> 2]);
                          }
                          if (_[u + 39 | 0] >= 0)
                            break i;
                          Br(e[u + 28 >> 2]);
                          break i;
                        }
                        s = Hr() | 0;
                      }
                      if (_[u + 459 | 0] >= 0)
                        break e;
                      Br(e[u + 448 >> 2]);
                      break e;
                    }
                    if (!me[u + 460 | 0] | _[u + 459 | 0] >= 0)
                      break e;
                    Br(e[u + 448 >> 2]);
                    break e;
                  }
                  if (_[u + 475 | 0] >= 0)
                    break e;
                  Br(e[u + 464 >> 2]);
                }
                Jn(s | 0), Oi();
              }
              function nh(r, s, u) {
                r = r | 0, s = s | 0, u = u | 0;
                var A = 0, m = 0, p = 0, N = 0, W = 0, Te = 0, Xe = 0, fr = 0, ar = 0, vr = 0, _r = 0, hi = 0, mi = 0, Ni = 0;
                W = Jr - 48 | 0, Jr = W, e[W + 24 >> 2] = 0, e[W + 16 >> 2] = 0, e[W + 20 >> 2] = 0;
                e: {
                  t: {
                    r: {
                      i: {
                        n: {
                          s: {
                            a: {
                              o: {
                                l: {
                                  c: {
                                    d: {
                                      f: {
                                        u: {
                                          g: {
                                            A: {
                                              p: {
                                                m: {
                                                  k: {
                                                    N: {
                                                      S: {
                                                        T: {
                                                          v:
                                                            switch (e[r >> 2]) {
                                                              case 1:
                                                                if (e[5996] = 0, s = Mi(3, 56) | 0, A = e[5996], e[5996] = 0, (A | 0) == 1)
                                                                  break i;
                                                                if (e[5996] = 0, r = pi(32, W + 28 | 0, r + 28 | 0) | 0, A = e[5996], e[5996] = 0, (A | 0) == 1)
                                                                  break T;
                                                                if (e[s + 4 >> 2] = 0, e[s + 8 >> 2] = 0, e[s >> 2] = 2, e[s + 12 >> 2] = 0, e[s + 16 >> 2] = e[r >> 2], e[s + 20 >> 2] = e[r + 4 >> 2], e[s + 24 >> 2] = e[r + 8 >> 2], e[r + 8 >> 2] = 0, e[r >> 2] = 0, e[r + 4 >> 2] = 0, e[s + 44 >> 2] = 0, e[s + 36 >> 2] = 0, e[s + 40 >> 2] = 0, e[s + 28 >> 2] = 0, e[s + 32 >> 2] = 0, e[5996] = 0, ji(33, u | 0, s | 0), r = e[5996], e[5996] = 0, (r | 0) == 1)
                                                                  break i;
                                                                if (A = e[W + 20 >> 2], p = e[W + 24 >> 2], A >>> 0 < p >>> 0) {
                                                                  e[A >> 2] = s, e[W + 20 >> 2] = A + 4;
                                                                  break A;
                                                                }
                                                                if (r = e[W + 16 >> 2], m = A - r >> 2, N = m + 1 | 0, N >>> 0 >= 1073741824) {
                                                                  if (e[5996] = 0, Nn(34), r = e[5996], e[5996] = 0, (r | 0) == 1)
                                                                    break i;
                                                                  break e;
                                                                }
                                                                if (p = p - r | 0, Te = p >> 1, N = p >>> 0 >= 2147483644 ? 1073741823 : N >>> 0 < Te >>> 0 ? Te : N, N) {
                                                                  if (N >>> 0 >= 1073741824) {
                                                                    if (e[5996] = 0, Nn(35), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                      break e;
                                                                    break i;
                                                                  }
                                                                  if (e[5996] = 0, Xe = Mi(3, N << 2) | 0, p = e[5996], e[5996] = 0, (p | 0) == 1)
                                                                    break i;
                                                                }
                                                                if (m = (m << 2) + Xe | 0, e[m >> 2] = s, p = m + 4 | 0, (r | 0) != (A | 0)) {
                                                                  for (; m = m - 4 | 0, A = A - 4 | 0, e[m >> 2] = e[A >> 2], (r | 0) != (A | 0); )
                                                                    ;
                                                                  A = e[W + 16 >> 2];
                                                                }
                                                                if (e[W + 24 >> 2] = (N << 2) + Xe, e[W + 20 >> 2] = p, e[W + 16 >> 2] = m, !A)
                                                                  break g;
                                                                Br(A);
                                                                break A;
                                                              case 2:
                                                                if (r = e[r + 52 >> 2], e[5996] = 0, s = Mi(3, 56) | 0, A = e[5996], e[5996] = 0, (A | 0) == 1 || (e[s + 4 >> 2] = 0, e[s + 8 >> 2] = 0, e[s >> 2] = 4, e[s + 40 >> 2] = r, e[s + 44 >> 2] = 0, e[s + 12 >> 2] = 0, e[s + 16 >> 2] = 0, e[s + 20 >> 2] = 0, e[s + 24 >> 2] = 0, e[s + 28 >> 2] = 0, e[s + 32 >> 2] = 0, e[s + 36 >> 2] = 0, e[5996] = 0, ji(33, u | 0, s | 0), r = e[5996], e[5996] = 0, (r | 0) == 1))
                                                                  break n;
                                                                if (A = e[W + 20 >> 2], p = e[W + 24 >> 2], A >>> 0 < p >>> 0) {
                                                                  e[A >> 2] = s, e[W + 20 >> 2] = A + 4;
                                                                  break A;
                                                                }
                                                                if (r = e[W + 16 >> 2], m = A - r >> 2, N = m + 1 | 0, N >>> 0 >= 1073741824) {
                                                                  if (e[5996] = 0, Nn(34), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                    break e;
                                                                  break n;
                                                                }
                                                                if (p = p - r | 0, Te = p >> 1, N = p >>> 0 >= 2147483644 ? 1073741823 : N >>> 0 < Te >>> 0 ? Te : N, N) {
                                                                  if (N >>> 0 >= 1073741824) {
                                                                    if (e[5996] = 0, Nn(35), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                      break e;
                                                                    break n;
                                                                  }
                                                                  if (e[5996] = 0, Xe = Mi(3, N << 2) | 0, p = e[5996], e[5996] = 0, (p | 0) == 1)
                                                                    break n;
                                                                }
                                                                if (m = (m << 2) + Xe | 0, e[m >> 2] = s, p = m + 4 | 0, (r | 0) != (A | 0)) {
                                                                  for (; m = m - 4 | 0, A = A - 4 | 0, e[m >> 2] = e[A >> 2], (r | 0) != (A | 0); )
                                                                    ;
                                                                  A = e[W + 16 >> 2];
                                                                }
                                                                if (e[W + 24 >> 2] = (N << 2) + Xe, e[W + 20 >> 2] = p, e[W + 16 >> 2] = m, !A)
                                                                  break g;
                                                                Br(A);
                                                                break A;
                                                              case 3:
                                                                if (r = e[r + 52 >> 2], e[5996] = 0, s = Mi(3, 56) | 0, A = e[5996], e[5996] = 0, (A | 0) == 1 || (e[s + 4 >> 2] = 0, e[s + 8 >> 2] = 0, e[s >> 2] = 5, e[s + 40 >> 2] = r, e[s + 44 >> 2] = 0, e[s + 12 >> 2] = 0, e[s + 16 >> 2] = 0, e[s + 20 >> 2] = 0, e[s + 24 >> 2] = 0, e[s + 28 >> 2] = 0, e[s + 32 >> 2] = 0, e[s + 36 >> 2] = 0, e[5996] = 0, ji(33, u | 0, s | 0), r = e[5996], e[5996] = 0, (r | 0) == 1))
                                                                  break s;
                                                                if (A = e[W + 20 >> 2], p = e[W + 24 >> 2], A >>> 0 < p >>> 0) {
                                                                  e[A >> 2] = s, e[W + 20 >> 2] = A + 4;
                                                                  break A;
                                                                }
                                                                if (r = e[W + 16 >> 2], m = A - r >> 2, N = m + 1 | 0, N >>> 0 >= 1073741824) {
                                                                  if (e[5996] = 0, Nn(34), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                    break e;
                                                                  break s;
                                                                }
                                                                if (p = p - r | 0, Te = p >> 1, N = p >>> 0 >= 2147483644 ? 1073741823 : N >>> 0 < Te >>> 0 ? Te : N, N) {
                                                                  if (N >>> 0 >= 1073741824) {
                                                                    if (e[5996] = 0, Nn(35), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                      break e;
                                                                    break s;
                                                                  }
                                                                  if (e[5996] = 0, Xe = Mi(3, N << 2) | 0, p = e[5996], e[5996] = 0, (p | 0) == 1)
                                                                    break s;
                                                                }
                                                                if (m = (m << 2) + Xe | 0, e[m >> 2] = s, p = m + 4 | 0, (r | 0) != (A | 0)) {
                                                                  for (; m = m - 4 | 0, A = A - 4 | 0, e[m >> 2] = e[A >> 2], (r | 0) != (A | 0); )
                                                                    ;
                                                                  A = e[W + 16 >> 2];
                                                                }
                                                                if (e[W + 24 >> 2] = (N << 2) + Xe, e[W + 20 >> 2] = p, e[W + 16 >> 2] = m, !A)
                                                                  break g;
                                                                Br(A);
                                                                break A;
                                                              case 5:
                                                                if (s = e[r + 20 >> 2], r = e[r + 16 >> 2], e[5996] = 0, N = wa(36, u | 0, 7, r | 0, s | 0) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1)
                                                                  break a;
                                                                if (A = e[W + 20 >> 2], p = e[W + 24 >> 2], A >>> 0 < p >>> 0) {
                                                                  e[A >> 2] = N, e[W + 20 >> 2] = A + 4;
                                                                  break A;
                                                                }
                                                                if (r = e[W + 16 >> 2], m = A - r >> 2, s = m + 1 | 0, s >>> 0 >= 1073741824) {
                                                                  if (e[5996] = 0, Nn(34), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                    break e;
                                                                  break a;
                                                                }
                                                                if (p = p - r | 0, Te = p >> 1, s = p >>> 0 >= 2147483644 ? 1073741823 : s >>> 0 < Te >>> 0 ? Te : s, s) {
                                                                  if (s >>> 0 >= 1073741824) {
                                                                    if (e[5996] = 0, Nn(35), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                      break e;
                                                                    break a;
                                                                  }
                                                                  if (e[5996] = 0, Xe = Mi(3, s << 2) | 0, p = e[5996], e[5996] = 0, (p | 0) == 1)
                                                                    break a;
                                                                }
                                                                if (m = (m << 2) + Xe | 0, e[m >> 2] = N, p = m + 4 | 0, (r | 0) != (A | 0)) {
                                                                  for (; m = m - 4 | 0, A = A - 4 | 0, e[m >> 2] = e[A >> 2], (r | 0) != (A | 0); )
                                                                    ;
                                                                  A = e[W + 16 >> 2];
                                                                }
                                                                if (e[W + 24 >> 2] = (s << 2) + Xe, e[W + 20 >> 2] = p, e[W + 16 >> 2] = m, !A)
                                                                  break g;
                                                                Br(A);
                                                                break A;
                                                              case 4:
                                                                if (s = e[r + 20 >> 2], r = e[r + 16 >> 2], e[5996] = 0, N = wa(36, u | 0, 6, r | 0, s | 0) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1)
                                                                  break o;
                                                                if (A = e[W + 20 >> 2], p = e[W + 24 >> 2], A >>> 0 < p >>> 0) {
                                                                  e[A >> 2] = N, e[W + 20 >> 2] = A + 4;
                                                                  break A;
                                                                }
                                                                if (r = e[W + 16 >> 2], m = A - r >> 2, s = m + 1 | 0, s >>> 0 >= 1073741824) {
                                                                  if (e[5996] = 0, Nn(34), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                    break e;
                                                                  break o;
                                                                }
                                                                if (p = p - r | 0, Te = p >> 1, s = p >>> 0 >= 2147483644 ? 1073741823 : s >>> 0 < Te >>> 0 ? Te : s, s) {
                                                                  if (s >>> 0 >= 1073741824) {
                                                                    if (e[5996] = 0, Nn(35), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                      break e;
                                                                    break o;
                                                                  }
                                                                  if (e[5996] = 0, Xe = Mi(3, s << 2) | 0, p = e[5996], e[5996] = 0, (p | 0) == 1)
                                                                    break o;
                                                                }
                                                                if (m = (m << 2) + Xe | 0, e[m >> 2] = N, p = m + 4 | 0, (r | 0) != (A | 0)) {
                                                                  for (; m = m - 4 | 0, A = A - 4 | 0, e[m >> 2] = e[A >> 2], (r | 0) != (A | 0); )
                                                                    ;
                                                                  A = e[W + 16 >> 2];
                                                                }
                                                                if (e[W + 24 >> 2] = (s << 2) + Xe, e[W + 20 >> 2] = p, e[W + 16 >> 2] = m, !A)
                                                                  break g;
                                                                Br(A);
                                                                break A;
                                                              case 7:
                                                                if (s = e[r + 20 >> 2], r = e[r + 16 >> 2], e[5996] = 0, N = wa(36, u | 0, 8, r | 0, s | 0) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1)
                                                                  break l;
                                                                if (A = e[W + 20 >> 2], p = e[W + 24 >> 2], A >>> 0 < p >>> 0) {
                                                                  e[A >> 2] = N, e[W + 20 >> 2] = A + 4;
                                                                  break A;
                                                                }
                                                                if (r = e[W + 16 >> 2], m = A - r >> 2, s = m + 1 | 0, s >>> 0 >= 1073741824) {
                                                                  if (e[5996] = 0, Nn(34), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                    break e;
                                                                  break l;
                                                                }
                                                                if (p = p - r | 0, Te = p >> 1, s = p >>> 0 >= 2147483644 ? 1073741823 : s >>> 0 < Te >>> 0 ? Te : s, s) {
                                                                  if (s >>> 0 >= 1073741824) {
                                                                    if (e[5996] = 0, Nn(35), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                      break e;
                                                                    break l;
                                                                  }
                                                                  if (e[5996] = 0, Xe = Mi(3, s << 2) | 0, p = e[5996], e[5996] = 0, (p | 0) == 1)
                                                                    break l;
                                                                }
                                                                if (m = (m << 2) + Xe | 0, e[m >> 2] = N, p = m + 4 | 0, (r | 0) != (A | 0)) {
                                                                  for (; m = m - 4 | 0, A = A - 4 | 0, e[m >> 2] = e[A >> 2], (r | 0) != (A | 0); )
                                                                    ;
                                                                  A = e[W + 16 >> 2];
                                                                }
                                                                if (e[W + 24 >> 2] = (s << 2) + Xe, e[W + 20 >> 2] = p, e[W + 16 >> 2] = m, !A)
                                                                  break g;
                                                                Br(A);
                                                                break A;
                                                              case 6:
                                                                if (s = e[r + 20 >> 2], r = e[r + 16 >> 2], e[5996] = 0, N = wa(36, u | 0, 9, r | 0, s | 0) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1)
                                                                  break c;
                                                                if (A = e[W + 20 >> 2], p = e[W + 24 >> 2], A >>> 0 < p >>> 0) {
                                                                  e[A >> 2] = N, e[W + 20 >> 2] = A + 4;
                                                                  break A;
                                                                }
                                                                if (r = e[W + 16 >> 2], m = A - r >> 2, s = m + 1 | 0, s >>> 0 >= 1073741824) {
                                                                  if (e[5996] = 0, Nn(34), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                    break e;
                                                                  break c;
                                                                }
                                                                if (p = p - r | 0, Te = p >> 1, s = p >>> 0 >= 2147483644 ? 1073741823 : s >>> 0 < Te >>> 0 ? Te : s, s) {
                                                                  if (s >>> 0 >= 1073741824) {
                                                                    if (e[5996] = 0, Nn(35), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                      break e;
                                                                    break c;
                                                                  }
                                                                  if (e[5996] = 0, Xe = Mi(3, s << 2) | 0, p = e[5996], e[5996] = 0, (p | 0) == 1)
                                                                    break c;
                                                                }
                                                                if (m = (m << 2) + Xe | 0, e[m >> 2] = N, p = m + 4 | 0, (r | 0) != (A | 0)) {
                                                                  for (; m = m - 4 | 0, A = A - 4 | 0, e[m >> 2] = e[A >> 2], (r | 0) != (A | 0); )
                                                                    ;
                                                                  A = e[W + 16 >> 2];
                                                                }
                                                                if (e[W + 24 >> 2] = (s << 2) + Xe, e[W + 20 >> 2] = p, e[W + 16 >> 2] = m, !A)
                                                                  break g;
                                                                Br(A);
                                                                break A;
                                                              case 8:
                                                                if (A = e[r + 4 >> 2], (e[r + 8 >> 2] - A | 0) != 112)
                                                                  break u;
                                                                e[5996] = 0, N = xn(37, A | 0, s | 0, u | 0) | 0, A = e[5996], e[5996] = 0;
                                                                w: {
                                                                  E: {
                                                                    h: {
                                                                      R: {
                                                                        I: {
                                                                          B: {
                                                                            x: {
                                                                              if ((A | 0) != 1) {
                                                                                if (r = e[r + 4 >> 2], e[5996] = 0, p = xn(37, r + 56 | 0, s | 0, u | 0) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1)
                                                                                  break x;
                                                                                if (!N | !p)
                                                                                  break u;
                                                                                if (e[5996] = 0, r = Mi(3, 8) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1)
                                                                                  break R;
                                                                                if (e[r + 4 >> 2] = p, e[r >> 2] = N, e[5996] = 0, s = Mi(3, 56) | 0, A = e[5996], e[5996] = 0, (A | 0) == 1)
                                                                                  break h;
                                                                                if (e[s + 16 >> 2] = 0, e[s + 20 >> 2] = 0, e[s + 4 >> 2] = r, e[s >> 2] = 10, r = r + 8 | 0, e[s + 12 >> 2] = r, e[s + 8 >> 2] = r, e[s + 24 >> 2] = 0, e[s + 28 >> 2] = 0, e[s + 32 >> 2] = 0, e[s + 36 >> 2] = 0, e[s + 40 >> 2] = 0, e[s + 44 >> 2] = 0, e[5996] = 0, ji(33, u | 0, s | 0), r = e[5996], e[5996] = 0, (r | 0) == 1)
                                                                                  break d;
                                                                                if (m = e[W + 20 >> 2], A = e[W + 24 >> 2], m >>> 0 >= A >>> 0)
                                                                                  break B;
                                                                                e[m >> 2] = s, e[W + 20 >> 2] = m + 4;
                                                                                break I;
                                                                              }
                                                                              u = Hr() | 0;
                                                                              break r;
                                                                            }
                                                                            u = Hr() | 0;
                                                                            break r;
                                                                          }
                                                                          if (Te = e[W + 16 >> 2], fr = m - Te >> 2, r = fr + 1 | 0, r >>> 0 >= 1073741824) {
                                                                            if (e[5996] = 0, Nn(34), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                              break e;
                                                                            break d;
                                                                          }
                                                                          A = A - Te | 0, Xe = A >> 1, Xe = A >>> 0 >= 2147483644 ? 1073741823 : r >>> 0 < Xe >>> 0 ? Xe : r;
                                                                          B: {
                                                                            if (!Xe) {
                                                                              r = 0;
                                                                              break B;
                                                                            }
                                                                            if (Xe >>> 0 >= 1073741824) {
                                                                              if (e[5996] = 0, Nn(35), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                                break e;
                                                                              break d;
                                                                            }
                                                                            if (e[5996] = 0, r = Mi(3, Xe << 2) | 0, A = e[5996], e[5996] = 0, (A | 0) == 1)
                                                                              break d;
                                                                          }
                                                                          if (A = (fr << 2) + r | 0, e[A >> 2] = s, s = A + 4 | 0, (m | 0) != (Te | 0)) {
                                                                            for (; A = A - 4 | 0, m = m - 4 | 0, e[A >> 2] = e[m >> 2], (m | 0) != (Te | 0); )
                                                                              ;
                                                                            m = e[W + 16 >> 2];
                                                                          }
                                                                          if (e[W + 24 >> 2] = (Xe << 2) + r, e[W + 20 >> 2] = s, e[W + 16 >> 2] = A, !m)
                                                                            break I;
                                                                          Br(m);
                                                                        }
                                                                        if (e[5996] = 0, s = Mi(3, 12) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1)
                                                                          break E;
                                                                        if (e[s + 4 >> 2] = p, e[s >> 2] = N, e[s + 8 >> 2] = e[6079], e[5996] = 0, r = Mi(3, 56) | 0, A = e[5996], e[5996] = 0, (A | 0) == 1)
                                                                          break w;
                                                                        if (e[r + 16 >> 2] = 0, e[r + 20 >> 2] = 0, e[r + 4 >> 2] = s, e[r >> 2] = 12, e[r + 48 >> 2] = 0, e[r + 52 >> 2] = 1072693248, s = s + 12 | 0, e[r + 12 >> 2] = s, e[r + 8 >> 2] = s, e[r + 24 >> 2] = 0, e[r + 28 >> 2] = 0, e[r + 32 >> 2] = 0, e[r + 36 >> 2] = 0, e[r + 40 >> 2] = 0, e[r + 44 >> 2] = 0, e[5996] = 0, ji(33, u | 0, r | 0), s = e[5996], e[5996] = 0, (s | 0) == 1)
                                                                          break f;
                                                                        if (A = e[W + 20 >> 2], p = e[W + 24 >> 2], A >>> 0 < p >>> 0) {
                                                                          e[A >> 2] = r, e[W + 20 >> 2] = A + 4;
                                                                          break A;
                                                                        }
                                                                        if (s = e[W + 16 >> 2], m = A - s >> 2, N = m + 1 | 0, N >>> 0 >= 1073741824) {
                                                                          if (e[5996] = 0, Nn(34), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                            break e;
                                                                          break f;
                                                                        }
                                                                        p = p - s | 0, Te = p >> 1, N = p >>> 0 >= 2147483644 ? 1073741823 : N >>> 0 < Te >>> 0 ? Te : N;
                                                                        I: {
                                                                          if (!N) {
                                                                            Xe = 0;
                                                                            break I;
                                                                          }
                                                                          if (N >>> 0 >= 1073741824) {
                                                                            if (e[5996] = 0, Nn(35), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                              break e;
                                                                            break f;
                                                                          }
                                                                          if (e[5996] = 0, Xe = Mi(3, N << 2) | 0, p = e[5996], e[5996] = 0, (p | 0) == 1)
                                                                            break f;
                                                                        }
                                                                        if (m = (m << 2) + Xe | 0, e[m >> 2] = r, p = m + 4 | 0, (s | 0) != (A | 0)) {
                                                                          for (; m = m - 4 | 0, A = A - 4 | 0, e[m >> 2] = e[A >> 2], (s | 0) != (A | 0); )
                                                                            ;
                                                                          A = e[W + 16 >> 2];
                                                                        }
                                                                        if (e[W + 24 >> 2] = (N << 2) + Xe, e[W + 20 >> 2] = p, e[W + 16 >> 2] = m, !A)
                                                                          break g;
                                                                        Br(A);
                                                                        break A;
                                                                      }
                                                                      u = Hr() | 0;
                                                                      break r;
                                                                    }
                                                                    u = Hr() | 0, Br(r);
                                                                    break r;
                                                                  }
                                                                  u = Hr() | 0;
                                                                  break r;
                                                                }
                                                                u = Hr() | 0, Br(s);
                                                                break r;
                                                              case 9:
                                                                if (A = e[r + 4 >> 2], (e[r + 8 >> 2] - A | 0) != 112 || (N = e[r + 40 >> 2], p = e[N + 4 >> 2], Te = e[N >> 2], Xe = Te + p | 0, p >>> 0 > Xe >>> 0))
                                                                  break u;
                                                                e[5996] = 0, N = xn(37, A | 0, s | 0, u | 0) | 0, A = e[5996], e[5996] = 0;
                                                                w: {
                                                                  E: {
                                                                    if ((A | 0) != 1) {
                                                                      if (A = e[r + 4 >> 2], e[5996] = 0, p = xn(37, A + 56 | 0, s | 0, u | 0) | 0, A = e[5996], e[5996] = 0, (A | 0) == 1)
                                                                        break E;
                                                                      if (!N | !p)
                                                                        break u;
                                                                      if (hi = +(Te >>> 0) / +(Xe >>> 0), m = e[r + 4 >> 2], e[m >> 2] != 8)
                                                                        break p;
                                                                      if (A = e[m + 4 >> 2], (e[m + 8 >> 2] - A | 0) == 112)
                                                                        break w;
                                                                      break p;
                                                                    }
                                                                    u = Hr() | 0;
                                                                    break r;
                                                                  }
                                                                  u = Hr() | 0;
                                                                  break r;
                                                                }
                                                                e[5996] = 0, Te = xn(37, A | 0, s | 0, u | 0) | 0, A = e[5996], e[5996] = 0;
                                                                w: {
                                                                  E: {
                                                                    h: {
                                                                      if ((A | 0) != 1) {
                                                                        if (A = e[e[r + 4 >> 2] + 4 >> 2], e[5996] = 0, Xe = xn(37, A + 56 | 0, s | 0, u | 0) | 0, A = e[5996], e[5996] = 0, (A | 0) == 1)
                                                                          break h;
                                                                        if (m = 0, !Te | !Xe)
                                                                          break u;
                                                                        if (e[5996] = 0, A = Mi(3, 12) | 0, m = e[5996], e[5996] = 0, (m | 0) == 1)
                                                                          break E;
                                                                        if (e[W + 28 >> 2] = A, m = A + 12 | 0, e[W + 36 >> 2] = m, e[A + 8 >> 2] = p, e[A + 4 >> 2] = Xe, e[A >> 2] = Te, e[5996] = 0, e[W + 32 >> 2] = m, A = Zc(38, u | 0, 12, W + 28 | 0, +hi) | 0, m = e[5996], e[5996] = 0, (m | 0) == 1 || (e[5996] = 0, ji(39, W + 16 | 0, A | 0), A = e[5996], e[5996] = 0, (A | 0) == 1))
                                                                          break w;
                                                                        A = e[W + 28 >> 2], A && Br(A), m = e[r + 4 >> 2];
                                                                        break p;
                                                                      }
                                                                      u = Hr() | 0;
                                                                      break r;
                                                                    }
                                                                    u = Hr() | 0;
                                                                    break r;
                                                                  }
                                                                  u = Hr() | 0;
                                                                  break r;
                                                                }
                                                                if (u = Hr() | 0, r = e[W + 28 >> 2], !r)
                                                                  break r;
                                                                Br(r);
                                                                break r;
                                                              case 0:
                                                                break u;
                                                              case 10:
                                                                break v;
                                                              default:
                                                                break A;
                                                            }
                                                          if (N = e[r + 4 >> 2], ar = e[r + 8 >> 2], (N | 0) == (ar | 0))
                                                            break N;
                                                          for (; ; ) {
                                                            v: {
                                                              if (e[5996] = 0, A = xn(37, N | 0, s | 0, u | 0) | 0, Te = e[5996], e[5996] = 0, (Te | 0) == 1)
                                                                break v;
                                                              w: {
                                                                if (m >>> 0 < Xe >>> 0) {
                                                                  e[m >> 2] = A, m = m + 4 | 0;
                                                                  break w;
                                                                }
                                                                if (_r = m - p >> 2, Te = _r + 1 | 0, Te >>> 0 >= 1073741824) {
                                                                  if (e[5996] = 0, Nn(34), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                    break e;
                                                                  break k;
                                                                }
                                                                Xe = Xe - p | 0, fr = Xe >> 1, fr = Xe >>> 0 >= 2147483644 ? 1073741823 : Te >>> 0 < fr >>> 0 ? fr : Te;
                                                                E: {
                                                                  if (!fr) {
                                                                    Xe = 0;
                                                                    break E;
                                                                  }
                                                                  if (fr >>> 0 >= 1073741824) {
                                                                    if (e[5996] = 0, Nn(35), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                      break e;
                                                                    break k;
                                                                  }
                                                                  if (e[5996] = 0, Xe = Mi(3, fr << 2) | 0, Te = e[5996], e[5996] = 0, (Te | 0) == 1)
                                                                    break v;
                                                                }
                                                                if (Te = (_r << 2) + Xe | 0, e[Te >> 2] = A, A = Te, (m | 0) != (p | 0))
                                                                  for (; A = A - 4 | 0, m = m - 4 | 0, e[A >> 2] = e[m >> 2], (m | 0) != (p | 0); )
                                                                    ;
                                                                Xe = (fr << 2) + Xe | 0, m = Te + 4 | 0, p && Br(p), p = A;
                                                              }
                                                              if (N = N + 56 | 0, (ar | 0) != (N | 0))
                                                                continue;
                                                              break S;
                                                            }
                                                            break;
                                                          }
                                                          u = Hr() | 0;
                                                          break m;
                                                        }
                                                        u = Hr() | 0, Br(s);
                                                        break r;
                                                      }
                                                      if ((m | 0) == (p | 0)) {
                                                        p = m;
                                                        break N;
                                                      }
                                                      for (A = p; ; ) {
                                                        if (e[A >> 2]) {
                                                          if (A = A + 4 | 0, (m | 0) != (A | 0))
                                                            continue;
                                                          break N;
                                                        }
                                                        break;
                                                      }
                                                      if (m = 0, !p)
                                                        break u;
                                                      Br(p);
                                                      break u;
                                                    }
                                                    N: {
                                                      S: {
                                                        _r = e[r + 8 >> 2], Te = e[r + 4 >> 2];
                                                        T: {
                                                          if ((_r - Te | 0) / 56 >>> 0 > 20)
                                                            break T;
                                                          v: {
                                                            w: {
                                                              if ((Te | 0) != (_r | 0)) {
                                                                for (A = Te; ; ) {
                                                                  if (e[A >> 2] != 1)
                                                                    break T;
                                                                  if (A = A + 56 | 0, (_r | 0) == (A | 0))
                                                                    break;
                                                                }
                                                                break w;
                                                              }
                                                              e[W + 12 >> 2] = 0, e[W + 4 >> 2] = 0, e[W + 8 >> 2] = 0;
                                                              break v;
                                                            }
                                                            for (e[W + 12 >> 2] = 0, e[W + 4 >> 2] = 0, e[W + 8 >> 2] = 0, Ni = W + 12 | 0; ; ) {
                                                              s = e[Te + 28 >> 2];
                                                              w: {
                                                                E: {
                                                                  if (A = e[W + 8 >> 2], (A | 0) != e[W + 12 >> 2]) {
                                                                    if (_[s + 11 | 0] >= 0) {
                                                                      N = e[s + 4 >> 2], e[A >> 2] = e[s >> 2], e[A + 4 >> 2] = N, e[A + 8 >> 2] = e[s + 8 >> 2];
                                                                      break E;
                                                                    }
                                                                    if (N = e[s + 4 >> 2], s = e[s >> 2], e[5996] = 0, gs(40, A | 0, s | 0, N | 0), s = e[5996], e[5996] = 0, (s | 0) != 1)
                                                                      break E;
                                                                    u = Hr() | 0, e[W + 8 >> 2] = A;
                                                                    break N;
                                                                  }
                                                                  h: {
                                                                    R: {
                                                                      I: {
                                                                        B: {
                                                                          N = e[W + 4 >> 2], fr = (A - N | 0) / 12 | 0, ar = fr + 1 | 0;
                                                                          x: {
                                                                            if (ar >>> 0 >= 357913942) {
                                                                              e[5996] = 0, Nn(41);
                                                                              break x;
                                                                            }
                                                                            if (e[W + 44 >> 2] = Ni, vr = fr << 1, vr = fr >>> 0 >= 178956970 ? 357913941 : ar >>> 0 < vr >>> 0 ? vr : ar, !vr) {
                                                                              ar = 0;
                                                                              break I;
                                                                            }
                                                                            if (vr >>> 0 < 357913942)
                                                                              break B;
                                                                            e[5996] = 0, Nn(35);
                                                                          }
                                                                          if (r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                            break e;
                                                                          u = Hr() | 0;
                                                                          break N;
                                                                        }
                                                                        if (e[5996] = 0, ar = Mi(3, Sn(vr, 12) | 0) | 0, mi = e[5996], e[5996] = 0, (mi | 0) == 1)
                                                                          break R;
                                                                      }
                                                                      e[W + 28 >> 2] = ar, fr = Sn(fr, 12) + ar | 0, e[W + 36 >> 2] = fr, ar = Sn(vr, 12) + ar | 0, e[W + 40 >> 2] = ar, e[W + 32 >> 2] = fr;
                                                                      I: {
                                                                        if (_[s + 11 | 0] >= 0) {
                                                                          vr = e[s + 4 >> 2], e[fr >> 2] = e[s >> 2], e[fr + 4 >> 2] = vr, e[fr + 8 >> 2] = e[s + 8 >> 2];
                                                                          break I;
                                                                        }
                                                                        if (A = e[s + 4 >> 2], s = e[s >> 2], e[5996] = 0, gs(40, fr | 0, s | 0, A | 0), s = e[5996], e[5996] = 0, (s | 0) == 1)
                                                                          break h;
                                                                        N = e[W + 4 >> 2], A = e[W + 8 >> 2];
                                                                      }
                                                                      if (vr = fr + 12 | 0, (A | 0) == (N | 0))
                                                                        s = N;
                                                                      else {
                                                                        for (; A = A - 12 | 0, mi = e[A + 4 >> 2], fr = fr - 12 | 0, s = fr, e[s >> 2] = e[A >> 2], e[s + 4 >> 2] = mi, e[s + 8 >> 2] = e[A + 8 >> 2], e[A >> 2] = 0, e[A + 4 >> 2] = 0, e[A + 8 >> 2] = 0, (A | 0) != (N | 0); )
                                                                          ;
                                                                        N = e[W + 8 >> 2], s = e[W + 4 >> 2];
                                                                      }
                                                                      if (e[W + 32 >> 2] = s, e[W + 4 >> 2] = fr, e[W + 8 >> 2] = vr, A = e[W + 12 >> 2], e[W + 12 >> 2] = ar, e[W + 40 >> 2] = A, e[W + 28 >> 2] = s, (s | 0) != (N | 0)) {
                                                                        for (; A = N - 12 | 0, e[W + 36 >> 2] = A, _[N - 1 | 0] < 0 && Br(e[A >> 2]), N = A, (A | 0) != (s | 0); )
                                                                          ;
                                                                        N = s;
                                                                      }
                                                                      if (!N)
                                                                        break w;
                                                                      Br(N);
                                                                      break w;
                                                                    }
                                                                    u = Hr() | 0;
                                                                    break N;
                                                                  }
                                                                  if (u = Hr() | 0, r = e[W + 36 >> 2], A = e[W + 32 >> 2], (r | 0) != (A | 0))
                                                                    for (; s = r - 12 | 0, e[W + 36 >> 2] = s, _[r - 1 | 0] >= 0 ? r = s : (Br(e[s >> 2]), r = e[W + 36 >> 2]), (A | 0) != (r | 0); )
                                                                      ;
                                                                  r = e[W + 28 >> 2], r && Br(r);
                                                                  break N;
                                                                }
                                                                e[W + 8 >> 2] = A + 12;
                                                              }
                                                              if (Te = Te + 56 | 0, (_r | 0) == (Te | 0))
                                                                break;
                                                            }
                                                          }
                                                          if (s = e[r + 52 >> 2], e[5996] = 0, Te = Mi(3, 56) | 0, A = e[5996], e[5996] = 0, (A | 0) == 1 || (A = e[W + 12 >> 2], e[W + 12 >> 2] = 0, N = e[W + 4 >> 2], fr = e[W + 8 >> 2], e[W + 4 >> 2] = 0, e[W + 8 >> 2] = 0, e[Te + 4 >> 2] = 0, e[Te + 8 >> 2] = 0, e[Te >> 2] = 3, e[Te + 12 >> 2] = 0, e[Te + 40 >> 2] = s, e[Te + 44 >> 2] = 0, e[Te + 36 >> 2] = 0, e[Te + 28 >> 2] = 0, e[Te + 32 >> 2] = 0, e[Te + 24 >> 2] = A, e[Te + 16 >> 2] = N, e[Te + 20 >> 2] = fr, e[5996] = 0, ji(33, u | 0, Te | 0), s = e[5996], e[5996] = 0, (s | 0) == 1))
                                                            break S;
                                                          A = e[W + 20 >> 2], fr = e[W + 24 >> 2];
                                                          v: {
                                                            if (A >>> 0 < fr >>> 0) {
                                                              e[A >> 2] = Te, e[W + 20 >> 2] = A + 4;
                                                              break v;
                                                            }
                                                            if (s = e[W + 16 >> 2], _r = A - s >> 2, N = _r + 1 | 0, N >>> 0 >= 1073741824) {
                                                              if (e[5996] = 0, Nn(34), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                break e;
                                                              break S;
                                                            }
                                                            fr = fr - s | 0, ar = fr >> 1, fr = fr >>> 0 >= 2147483644 ? 1073741823 : N >>> 0 < ar >>> 0 ? ar : N;
                                                            w: {
                                                              if (!fr) {
                                                                ar = 0;
                                                                break w;
                                                              }
                                                              if (fr >>> 0 >= 1073741824) {
                                                                if (e[5996] = 0, Nn(35), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                  break e;
                                                                break S;
                                                              }
                                                              if (e[5996] = 0, ar = Mi(3, fr << 2) | 0, N = e[5996], e[5996] = 0, (N | 0) == 1)
                                                                break S;
                                                            }
                                                            if (N = (_r << 2) + ar | 0, e[N >> 2] = Te, Te = N + 4 | 0, (s | 0) != (A | 0)) {
                                                              for (; N = N - 4 | 0, A = A - 4 | 0, e[N >> 2] = e[A >> 2], (s | 0) != (A | 0); )
                                                                ;
                                                              A = e[W + 16 >> 2];
                                                            }
                                                            if (e[W + 24 >> 2] = (fr << 2) + ar, e[W + 20 >> 2] = Te, e[W + 16 >> 2] = N, !A)
                                                              break v;
                                                            Br(A);
                                                          }
                                                          if (s = e[W + 4 >> 2], !s)
                                                            break T;
                                                          if (A = s, N = e[W + 8 >> 2], (A | 0) != (N | 0)) {
                                                            for (; A = N - 12 | 0, _[N - 1 | 0] < 0 && Br(e[A >> 2]), N = A, (A | 0) != (s | 0); )
                                                              ;
                                                            A = e[W + 4 >> 2];
                                                          }
                                                          e[W + 8 >> 2] = s, Br(A);
                                                        }
                                                        s = e[r + 52 >> 2];
                                                        T: {
                                                          if ((s | 0) != 1 & (s | 0) != ((e[r + 8 >> 2] - e[r + 4 >> 2] | 0) / 56 | 0))
                                                            break T;
                                                          v: {
                                                            w: {
                                                              E: {
                                                                h: {
                                                                  R: {
                                                                    I: {
                                                                      if (s = m - p | 0, s >>> 0 >= 5)
                                                                        for (; ; ) {
                                                                          if (fr = e[r + 52 >> 2], e[5996] = 0, Te = Mi(3, 8) | 0, A = e[5996], e[5996] = 0, (A | 0) == 1)
                                                                            break I;
                                                                          if (A = m - 8 | 0, e[Te >> 2] = e[A >> 2], m = m - 4 | 0, e[Te + 4 >> 2] = e[m >> 2], e[5996] = 0, N = Mi(3, 56) | 0, ar = e[5996], e[5996] = 0, (ar | 0) == 1)
                                                                            break R;
                                                                          if (e[N + 16 >> 2] = 0, e[N + 20 >> 2] = 0, e[N + 4 >> 2] = Te, e[N >> 2] = (fr | 0) == 1 ? 11 : 10, Te = Te + 8 | 0, e[N + 12 >> 2] = Te, e[N + 8 >> 2] = Te, e[N + 24 >> 2] = 0, e[N + 28 >> 2] = 0, e[N + 32 >> 2] = 0, e[N + 36 >> 2] = 0, e[N + 40 >> 2] = 0, e[N + 44 >> 2] = 0, jn[N + 48 >> 3] = 1 / +(s >> 2 >>> 0), e[5996] = 0, ji(33, u | 0, N | 0), s = e[5996], e[5996] = 0, (s | 0) == 1) {
                                                                            u = Hr() | 0;
                                                                            break m;
                                                                          }
                                                                          if (e[5996] = 0, Te = Mi(3, 4) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1)
                                                                            break h;
                                                                          if (e[Te >> 2] = N, e[5996] = 0, s = Mi(3, 56) | 0, N = e[5996], e[5996] = 0, (N | 0) == 1)
                                                                            break w;
                                                                          if (e[s + 16 >> 2] = 0, e[s + 20 >> 2] = 0, e[s + 4 >> 2] = Te, e[s >> 2] = 21, N = Te + 4 | 0, e[s + 12 >> 2] = N, e[s + 8 >> 2] = N, e[s + 24 >> 2] = 0, e[s + 28 >> 2] = 0, e[s + 32 >> 2] = 0, e[s + 36 >> 2] = 0, e[s + 40 >> 2] = 0, e[s + 44 >> 2] = 0, e[5996] = 0, ji(33, u | 0, s | 0), N = e[5996], e[5996] = 0, (N | 0) == 1)
                                                                            break E;
                                                                          B: {
                                                                            if (A >>> 0 < Xe >>> 0) {
                                                                              e[A >> 2] = s;
                                                                              break B;
                                                                            }
                                                                            x: {
                                                                              b: {
                                                                                Te = A - p >> 2, N = Te + 1 | 0;
                                                                                C: {
                                                                                  if (N >>> 0 >= 1073741824) {
                                                                                    e[5996] = 0, Nn(34);
                                                                                    break C;
                                                                                  }
                                                                                  if (m = Xe - p | 0, Xe = m >> 1, m = m >>> 0 >= 2147483644 ? 1073741823 : N >>> 0 < Xe >>> 0 ? Xe : N, !m) {
                                                                                    Xe = 0;
                                                                                    break x;
                                                                                  }
                                                                                  if (m >>> 0 < 1073741824)
                                                                                    break b;
                                                                                  e[5996] = 0, Nn(35);
                                                                                }
                                                                                if (r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                                  break e;
                                                                                u = Hr() | 0;
                                                                                break m;
                                                                              }
                                                                              if (e[5996] = 0, Xe = Mi(3, m << 2) | 0, N = e[5996], e[5996] = 0, (N | 0) == 1)
                                                                                break E;
                                                                            }
                                                                            N = (Te << 2) + Xe | 0, e[N >> 2] = s, Xe = (m << 2) + Xe | 0, m = N + 4 | 0;
                                                                            x: {
                                                                              if ((A | 0) != (p | 0)) {
                                                                                for (; N = N - 4 | 0, A = A - 4 | 0, e[N >> 2] = e[A >> 2], (A | 0) != (p | 0); )
                                                                                  ;
                                                                                if (!p)
                                                                                  break x;
                                                                              }
                                                                              Br(p);
                                                                            }
                                                                            p = N;
                                                                          }
                                                                          if (s = m - p | 0, !(s >>> 0 > 4))
                                                                            break;
                                                                        }
                                                                      if (Xe = e[p >> 2], A = e[W + 20 >> 2], (A | 0) == e[W + 24 >> 2])
                                                                        break v;
                                                                      e[A >> 2] = Xe, e[W + 20 >> 2] = A + 4;
                                                                      break T;
                                                                    }
                                                                    u = Hr() | 0;
                                                                    break m;
                                                                  }
                                                                  u = Hr() | 0, Br(Te);
                                                                  break m;
                                                                }
                                                                u = Hr() | 0;
                                                                break m;
                                                              }
                                                              u = Hr() | 0;
                                                              break m;
                                                            }
                                                            u = Hr() | 0, Br(Te);
                                                            break m;
                                                          }
                                                          if (fr = e[W + 16 >> 2], s = A - fr | 0, ar = s >> 2, N = ar + 1 | 0, N >>> 0 >= 1073741824) {
                                                            if (e[5996] = 0, Nn(34), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                              break e;
                                                            break k;
                                                          }
                                                          Te = s >> 1, s = s >>> 0 >= 2147483644 ? 1073741823 : N >>> 0 < Te >>> 0 ? Te : N;
                                                          v: {
                                                            if (!s) {
                                                              Te = 0;
                                                              break v;
                                                            }
                                                            if (s >>> 0 >= 1073741824) {
                                                              if (e[5996] = 0, Nn(35), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                break e;
                                                              break k;
                                                            }
                                                            if (e[5996] = 0, Te = Mi(3, s << 2) | 0, N = e[5996], e[5996] = 0, (N | 0) == 1)
                                                              break k;
                                                          }
                                                          if (N = (ar << 2) + Te | 0, e[N >> 2] = Xe, Xe = N + 4 | 0, (A | 0) != (fr | 0)) {
                                                            for (; N = N - 4 | 0, A = A - 4 | 0, e[N >> 2] = e[A >> 2], (A | 0) != (fr | 0); )
                                                              ;
                                                            A = e[W + 16 >> 2];
                                                          }
                                                          if (e[W + 24 >> 2] = (s << 2) + Te, e[W + 20 >> 2] = Xe, e[W + 16 >> 2] = N, !A)
                                                            break T;
                                                          Br(A);
                                                        }
                                                        Xe = e[r + 52 >> 2], s = 0, e[5996] = 0, r = Mi(3, 56) | 0, A = e[5996], e[5996] = 0;
                                                        T: {
                                                          v: {
                                                            if ((A | 0) == 1)
                                                              break v;
                                                            if (N = m - p | 0, fr = N >> 2, Te = 0, A = 0, (m | 0) != (p | 0)) {
                                                              if ((N | 0) < 0) {
                                                                if (e[5996] = 0, Nn(34), s = e[5996], e[5996] = 0, (s | 0) != 1)
                                                                  break e;
                                                                break T;
                                                              }
                                                              if (e[5996] = 0, A = Mi(3, N | 0) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1)
                                                                break T;
                                                              N = (N - 4 & -4) + 4 | 0, m = so(A, p, N), s = m + (fr << 2) | 0, Te = m + N | 0;
                                                            }
                                                            if (e[r + 16 >> 2] = 0, e[r + 20 >> 2] = 0, e[r + 4 >> 2] = A, e[r >> 2] = 13, jn[r + 48 >> 3] = +(Xe >>> 0) / +(fr >>> 0), e[r + 12 >> 2] = s, e[r + 8 >> 2] = Te, e[r + 24 >> 2] = 0, e[r + 28 >> 2] = 0, e[r + 32 >> 2] = 0, e[r + 36 >> 2] = 0, e[r + 40 >> 2] = Xe, e[r + 44 >> 2] = 0, e[5996] = 0, ji(33, u | 0, r | 0), s = e[5996], e[5996] = 0, (s | 0) == 1)
                                                              break v;
                                                            m = e[W + 20 >> 2], A = e[W + 24 >> 2];
                                                            w: {
                                                              if (m >>> 0 < A >>> 0) {
                                                                e[m >> 2] = r, e[W + 20 >> 2] = m + 4;
                                                                break w;
                                                              }
                                                              if (N = e[W + 16 >> 2], Xe = m - N >> 2, s = Xe + 1 | 0, s >>> 0 >= 1073741824) {
                                                                if (e[5996] = 0, Nn(34), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                  break e;
                                                                break v;
                                                              }
                                                              A = A - N | 0, Te = A >> 1, Te = A >>> 0 >= 2147483644 ? 1073741823 : s >>> 0 < Te >>> 0 ? Te : s;
                                                              E: {
                                                                if (!Te) {
                                                                  s = 0;
                                                                  break E;
                                                                }
                                                                if (Te >>> 0 >= 1073741824) {
                                                                  if (e[5996] = 0, Nn(35), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                    break e;
                                                                  break v;
                                                                }
                                                                if (e[5996] = 0, s = Mi(3, Te << 2) | 0, A = e[5996], e[5996] = 0, (A | 0) == 1)
                                                                  break v;
                                                              }
                                                              if (A = (Xe << 2) + s | 0, e[A >> 2] = r, r = A + 4 | 0, (m | 0) != (N | 0)) {
                                                                for (; A = A - 4 | 0, m = m - 4 | 0, e[A >> 2] = e[m >> 2], (m | 0) != (N | 0); )
                                                                  ;
                                                                m = e[W + 16 >> 2];
                                                              }
                                                              if (e[W + 24 >> 2] = (Te << 2) + s, e[W + 20 >> 2] = r, e[W + 16 >> 2] = A, !m)
                                                                break w;
                                                              Br(m);
                                                            }
                                                            if (!p)
                                                              break A;
                                                            Br(p);
                                                            break A;
                                                          }
                                                          u = Hr() | 0;
                                                          break m;
                                                        }
                                                        u = Hr() | 0, Br(r);
                                                        break m;
                                                      }
                                                      u = Hr() | 0;
                                                    }
                                                    ea(W + 4 | 0);
                                                    break m;
                                                  }
                                                  u = Hr() | 0;
                                                }
                                                if (!p)
                                                  break r;
                                                Br(p);
                                                break r;
                                              }
                                              p: {
                                                m: {
                                                  k: {
                                                    N: {
                                                      S: {
                                                        T: {
                                                          v: {
                                                            w: {
                                                              E: {
                                                                if (e[m + 56 >> 2] != 8 || (A = e[m + 60 >> 2], (e[m - -64 >> 2] - A | 0) != 112))
                                                                  break E;
                                                                if (e[5996] = 0, A = xn(37, A | 0, s | 0, u | 0) | 0, m = e[5996], e[5996] = 0, (m | 0) == 1)
                                                                  break w;
                                                                if (r = e[e[r + 4 >> 2] + 60 >> 2], e[5996] = 0, s = xn(37, r + 56 | 0, s | 0, u | 0) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1)
                                                                  break v;
                                                                if (m = 0, !A | !s)
                                                                  break u;
                                                                if (e[5996] = 0, r = Mi(3, 12) | 0, m = e[5996], e[5996] = 0, (m | 0) == 1)
                                                                  break T;
                                                                if (e[W + 28 >> 2] = r, m = r + 12 | 0, e[W + 36 >> 2] = m, e[r + 8 >> 2] = N, e[r + 4 >> 2] = s, e[r >> 2] = A, e[5996] = 0, e[W + 32 >> 2] = m, r = O4(42, u | 0, W + 28 | 0, +(1 - hi)) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1 || (e[5996] = 0, ji(39, W + 16 | 0, r | 0), r = e[5996], e[5996] = 0, (r | 0) == 1))
                                                                  break S;
                                                                if (r = e[W + 28 >> 2], !r)
                                                                  break E;
                                                                Br(r);
                                                              }
                                                              if (e[5996] = 0, r = Mi(3, 12) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1)
                                                                break N;
                                                              if (e[W + 28 >> 2] = r, s = r + 12 | 0, e[W + 36 >> 2] = s, e[r >> 2] = N, A = e[6080], e[r + 8 >> 2] = p, e[r + 4 >> 2] = A, e[5996] = 0, e[W + 32 >> 2] = s, r = Zc(38, u | 0, 12, W + 28 | 0, +hi) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1 || (e[5996] = 0, ji(39, W + 16 | 0, r | 0), r = e[5996], e[5996] = 0, (r | 0) == 1))
                                                                break k;
                                                              if (r = e[W + 28 >> 2], r && Br(r), e[5996] = 0, r = Mi(3, 8) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1)
                                                                break m;
                                                              if (e[W + 28 >> 2] = r, s = r + 8 | 0, e[W + 36 >> 2] = s, e[r + 4 >> 2] = p, e[r >> 2] = N, e[5996] = 0, e[W + 32 >> 2] = s, r = Zc(38, u | 0, 11, W + 28 | 0, +hi) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1 || (e[5996] = 0, ji(39, W + 16 | 0, r | 0), r = e[5996], e[5996] = 0, (r | 0) == 1))
                                                                break p;
                                                              if (r = e[W + 28 >> 2], !r)
                                                                break A;
                                                              Br(r);
                                                              break A;
                                                            }
                                                            u = Hr() | 0;
                                                            break r;
                                                          }
                                                          u = Hr() | 0;
                                                          break r;
                                                        }
                                                        u = Hr() | 0;
                                                        break r;
                                                      }
                                                      if (u = Hr() | 0, r = e[W + 28 >> 2], !r)
                                                        break r;
                                                      Br(r);
                                                      break r;
                                                    }
                                                    u = Hr() | 0;
                                                    break r;
                                                  }
                                                  if (u = Hr() | 0, r = e[W + 28 >> 2], !r)
                                                    break r;
                                                  Br(r);
                                                  break r;
                                                }
                                                u = Hr() | 0;
                                                break r;
                                              }
                                              if (u = Hr() | 0, r = e[W + 28 >> 2], !r)
                                                break r;
                                              Br(r);
                                              break r;
                                            }
                                            p = e[W + 20 >> 2], m = e[W + 16 >> 2];
                                          }
                                          g: {
                                            A: {
                                              p: {
                                                m: {
                                                  if ((p - m | 0) == 4)
                                                    break m;
                                                  if (s = e[W + 24 >> 2], e[W + 24 >> 2] = 0, e[W + 16 >> 2] = 0, e[W + 20 >> 2] = 0, e[5996] = 0, r = Mi(3, 56) | 0, A = e[5996], e[5996] = 0, (A | 0) == 1)
                                                    break p;
                                                  if (e[r + 16 >> 2] = 0, e[r + 20 >> 2] = 0, e[r + 4 >> 2] = m, e[r >> 2] = 20, e[r + 12 >> 2] = s, e[r + 8 >> 2] = p, e[r + 24 >> 2] = 0, e[r + 28 >> 2] = 0, e[r + 32 >> 2] = 0, e[r + 36 >> 2] = 0, e[r + 40 >> 2] = 0, e[r + 44 >> 2] = 0, e[5996] = 0, ji(33, u | 0, r | 0), s = e[5996], e[5996] = 0, (s | 0) == 1)
                                                    break g;
                                                  if (m = e[W + 20 >> 2], N = e[W + 24 >> 2], m >>> 0 < N >>> 0) {
                                                    e[m >> 2] = r, e[W + 20 >> 2] = m + 4;
                                                    break m;
                                                  }
                                                  if (s = e[W + 16 >> 2], p = m - s >> 2, A = p + 1 | 0, A >>> 0 >= 1073741824) {
                                                    if (e[5996] = 0, Nn(34), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                      break e;
                                                    break g;
                                                  }
                                                  N = N - s | 0, Te = N >> 1, N = N >>> 0 >= 2147483644 ? 1073741823 : A >>> 0 < Te >>> 0 ? Te : A;
                                                  k: {
                                                    if (!N) {
                                                      Xe = 0;
                                                      break k;
                                                    }
                                                    if (N >>> 0 >= 1073741824) {
                                                      if (e[5996] = 0, Nn(35), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                        break e;
                                                      break g;
                                                    }
                                                    if (e[5996] = 0, Xe = Mi(3, N << 2) | 0, A = e[5996], e[5996] = 0, (A | 0) == 1)
                                                      break g;
                                                  }
                                                  if (A = (p << 2) + Xe | 0, e[A >> 2] = r, r = A + 4 | 0, (s | 0) != (m | 0)) {
                                                    for (; A = A - 4 | 0, m = m - 4 | 0, e[A >> 2] = e[m >> 2], (s | 0) != (m | 0); )
                                                      ;
                                                    m = e[W + 16 >> 2];
                                                  }
                                                  if (e[W + 24 >> 2] = (N << 2) + Xe, e[W + 20 >> 2] = r, e[W + 16 >> 2] = A, !m)
                                                    break m;
                                                  Br(m);
                                                }
                                                if (e[5996] = 0, m = Mi(3, 56) | 0, r = e[5996], e[5996] = 0, (r | 0) != 1 && (r = e[W + 24 >> 2], e[W + 24 >> 2] = 0, s = e[W + 16 >> 2], A = e[W + 20 >> 2], e[W + 16 >> 2] = 0, e[W + 20 >> 2] = 0, e[m + 16 >> 2] = 0, e[m + 20 >> 2] = 0, e[m + 12 >> 2] = r, e[m + 4 >> 2] = s, e[m + 8 >> 2] = A, e[m >> 2] = 21, e[m + 24 >> 2] = 0, e[m + 28 >> 2] = 0, e[m + 32 >> 2] = 0, e[m + 36 >> 2] = 0, e[m + 40 >> 2] = 0, e[m + 44 >> 2] = 0, e[5996] = 0, ji(33, u | 0, m | 0), r = e[5996], e[5996] = 0, (r | 0) != 1))
                                                  break A;
                                                u = Hr() | 0;
                                                break r;
                                              }
                                              if (u = Hr() | 0, !m)
                                                break t;
                                              Br(m);
                                              break r;
                                            }
                                            if (e[5996] = 0, s = Mi(3, 4) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1) {
                                              u = Hr() | 0;
                                              break r;
                                            }
                                            e[s >> 2] = m, e[5996] = 0, r = Mi(3, 56) | 0, A = e[5996], e[5996] = 0;
                                            A: {
                                              p: {
                                                m: {
                                                  k: {
                                                    N: {
                                                      S: {
                                                        T: {
                                                          v: {
                                                            w: {
                                                              E: {
                                                                h: {
                                                                  R: {
                                                                    I: {
                                                                      B: {
                                                                        x: {
                                                                          if ((A | 0) != 1) {
                                                                            if (e[r + 16 >> 2] = 0, e[r + 20 >> 2] = 0, e[r + 4 >> 2] = s, e[r >> 2] = 15, s = s + 4 | 0, e[r + 12 >> 2] = s, e[r + 8 >> 2] = s, e[r + 24 >> 2] = 0, e[r + 28 >> 2] = 0, e[r + 32 >> 2] = 0, e[r + 36 >> 2] = 0, e[r + 40 >> 2] = 0, e[r + 44 >> 2] = 0, e[5996] = 0, ji(33, u | 0, r | 0), s = e[5996], e[5996] = 0, (s | 0) == 1)
                                                                              break A;
                                                                            A = e[m + 8 >> 2], p = e[m + 12 >> 2];
                                                                            b: {
                                                                              if (A >>> 0 < p >>> 0) {
                                                                                e[A >> 2] = r, e[m + 8 >> 2] = A + 4;
                                                                                break b;
                                                                              }
                                                                              if (N = e[m + 4 >> 2], Xe = A - N >> 2, s = Xe + 1 | 0, s >>> 0 >= 1073741824) {
                                                                                if (e[5996] = 0, Nn(34), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                                  break e;
                                                                                break A;
                                                                              }
                                                                              p = p - N | 0, Te = p >> 1, Te = p >>> 0 >= 2147483644 ? 1073741823 : s >>> 0 < Te >>> 0 ? Te : s;
                                                                              C: {
                                                                                if (!Te) {
                                                                                  s = 0;
                                                                                  break C;
                                                                                }
                                                                                if (Te >>> 0 >= 1073741824) {
                                                                                  if (e[5996] = 0, Nn(35), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                                    break e;
                                                                                  break A;
                                                                                }
                                                                                if (e[5996] = 0, s = Mi(3, Te << 2) | 0, p = e[5996], e[5996] = 0, (p | 0) == 1)
                                                                                  break A;
                                                                              }
                                                                              if (p = (Xe << 2) + s | 0, e[p >> 2] = r, r = p + 4 | 0, (A | 0) != (N | 0)) {
                                                                                for (; p = p - 4 | 0, A = A - 4 | 0, e[p >> 2] = e[A >> 2], (A | 0) != (N | 0); )
                                                                                  ;
                                                                                A = e[m + 4 >> 2];
                                                                              }
                                                                              if (e[m + 12 >> 2] = (Te << 2) + s, e[m + 8 >> 2] = r, e[m + 4 >> 2] = p, !A)
                                                                                break b;
                                                                              Br(A);
                                                                            }
                                                                            if (e[5996] = 0, s = Mi(3, 4) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1) {
                                                                              u = Hr() | 0;
                                                                              break r;
                                                                            }
                                                                            if (e[s >> 2] = m, e[5996] = 0, r = Mi(3, 56) | 0, A = e[5996], e[5996] = 0, (A | 0) == 1)
                                                                              break x;
                                                                            if (e[r + 16 >> 2] = 0, e[r + 20 >> 2] = 0, e[r + 4 >> 2] = s, e[r >> 2] = 17, s = s + 4 | 0, e[r + 12 >> 2] = s, e[r + 8 >> 2] = s, e[r + 24 >> 2] = 0, e[r + 28 >> 2] = 0, e[r + 32 >> 2] = 0, e[r + 36 >> 2] = 0, e[r + 40 >> 2] = 0, e[r + 44 >> 2] = 0, e[5996] = 0, ji(33, u | 0, r | 0), s = e[5996], e[5996] = 0, (s | 0) == 1)
                                                                              break p;
                                                                            A = e[m + 8 >> 2], p = e[m + 12 >> 2];
                                                                            b: {
                                                                              if (A >>> 0 < p >>> 0) {
                                                                                e[A >> 2] = r, e[m + 8 >> 2] = A + 4;
                                                                                break b;
                                                                              }
                                                                              if (N = e[m + 4 >> 2], Xe = A - N >> 2, s = Xe + 1 | 0, s >>> 0 >= 1073741824) {
                                                                                if (e[5996] = 0, Nn(34), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                                  break e;
                                                                                break p;
                                                                              }
                                                                              p = p - N | 0, Te = p >> 1, Te = p >>> 0 >= 2147483644 ? 1073741823 : s >>> 0 < Te >>> 0 ? Te : s;
                                                                              C: {
                                                                                if (!Te) {
                                                                                  s = 0;
                                                                                  break C;
                                                                                }
                                                                                if (Te >>> 0 >= 1073741824) {
                                                                                  if (e[5996] = 0, Nn(35), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                                    break e;
                                                                                  break p;
                                                                                }
                                                                                if (e[5996] = 0, s = Mi(3, Te << 2) | 0, p = e[5996], e[5996] = 0, (p | 0) == 1)
                                                                                  break p;
                                                                              }
                                                                              if (p = (Xe << 2) + s | 0, e[p >> 2] = r, r = p + 4 | 0, (A | 0) != (N | 0)) {
                                                                                for (; p = p - 4 | 0, A = A - 4 | 0, e[p >> 2] = e[A >> 2], (A | 0) != (N | 0); )
                                                                                  ;
                                                                                A = e[m + 4 >> 2];
                                                                              }
                                                                              if (e[m + 12 >> 2] = (Te << 2) + s, e[m + 8 >> 2] = r, e[m + 4 >> 2] = p, !A)
                                                                                break b;
                                                                              Br(A);
                                                                            }
                                                                            if (e[5996] = 0, r = e[6080], s = Mi(3, 8) | 0, A = e[5996], e[5996] = 0, (A | 0) == 1) {
                                                                              u = Hr() | 0;
                                                                              break r;
                                                                            }
                                                                            if (e[s + 4 >> 2] = r, e[s >> 2] = m, e[5996] = 0, r = Mi(3, 56) | 0, A = e[5996], e[5996] = 0, (A | 0) == 1)
                                                                              break B;
                                                                            if (e[r + 16 >> 2] = 0, e[r + 20 >> 2] = 0, e[r + 4 >> 2] = s, e[r >> 2] = 10, s = s + 8 | 0, e[r + 12 >> 2] = s, e[r + 8 >> 2] = s, e[r + 24 >> 2] = 0, e[r + 28 >> 2] = 0, e[r + 32 >> 2] = 0, e[r + 36 >> 2] = 0, e[r + 40 >> 2] = 0, e[r + 44 >> 2] = 0, e[5996] = 0, ji(33, u | 0, r | 0), s = e[5996], e[5996] = 0, (s | 0) == 1)
                                                                              break m;
                                                                            A = e[m + 8 >> 2], p = e[m + 12 >> 2];
                                                                            b: {
                                                                              if (A >>> 0 < p >>> 0) {
                                                                                e[A >> 2] = r, e[m + 8 >> 2] = A + 4;
                                                                                break b;
                                                                              }
                                                                              if (N = e[m + 4 >> 2], Xe = A - N >> 2, s = Xe + 1 | 0, s >>> 0 >= 1073741824) {
                                                                                if (e[5996] = 0, Nn(34), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                                  break e;
                                                                                break m;
                                                                              }
                                                                              p = p - N | 0, Te = p >> 1, Te = p >>> 0 >= 2147483644 ? 1073741823 : s >>> 0 < Te >>> 0 ? Te : s;
                                                                              C: {
                                                                                if (!Te) {
                                                                                  s = 0;
                                                                                  break C;
                                                                                }
                                                                                if (Te >>> 0 >= 1073741824) {
                                                                                  if (e[5996] = 0, Nn(35), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                                    break e;
                                                                                  break m;
                                                                                }
                                                                                if (e[5996] = 0, s = Mi(3, Te << 2) | 0, p = e[5996], e[5996] = 0, (p | 0) == 1)
                                                                                  break m;
                                                                              }
                                                                              if (p = (Xe << 2) + s | 0, e[p >> 2] = r, r = p + 4 | 0, (A | 0) != (N | 0)) {
                                                                                for (; p = p - 4 | 0, A = A - 4 | 0, e[p >> 2] = e[A >> 2], (A | 0) != (N | 0); )
                                                                                  ;
                                                                                A = e[m + 4 >> 2];
                                                                              }
                                                                              if (e[m + 12 >> 2] = (Te << 2) + s, e[m + 8 >> 2] = r, e[m + 4 >> 2] = p, !A)
                                                                                break b;
                                                                              Br(A);
                                                                            }
                                                                            if (e[5996] = 0, s = Mi(3, 4) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1) {
                                                                              u = Hr() | 0;
                                                                              break r;
                                                                            }
                                                                            if (e[s >> 2] = m, e[5996] = 0, r = Mi(3, 56) | 0, A = e[5996], e[5996] = 0, (A | 0) == 1)
                                                                              break I;
                                                                            if (e[r + 16 >> 2] = 0, e[r + 20 >> 2] = 0, e[r + 4 >> 2] = s, e[r >> 2] = 19, s = s + 4 | 0, e[r + 12 >> 2] = s, e[r + 8 >> 2] = s, e[r + 24 >> 2] = 0, e[r + 28 >> 2] = 0, e[r + 32 >> 2] = 0, e[r + 36 >> 2] = 0, e[r + 40 >> 2] = 0, e[r + 44 >> 2] = 0, e[5996] = 0, ji(33, u | 0, r | 0), s = e[5996], e[5996] = 0, (s | 0) == 1)
                                                                              break k;
                                                                            A = e[m + 8 >> 2], p = e[m + 12 >> 2];
                                                                            b: {
                                                                              if (A >>> 0 < p >>> 0) {
                                                                                e[A >> 2] = r, e[m + 8 >> 2] = A + 4;
                                                                                break b;
                                                                              }
                                                                              if (N = e[m + 4 >> 2], Xe = A - N >> 2, s = Xe + 1 | 0, s >>> 0 >= 1073741824) {
                                                                                if (e[5996] = 0, Nn(34), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                                  break e;
                                                                                break k;
                                                                              }
                                                                              p = p - N | 0, Te = p >> 1, Te = p >>> 0 >= 2147483644 ? 1073741823 : s >>> 0 < Te >>> 0 ? Te : s;
                                                                              C: {
                                                                                if (!Te) {
                                                                                  s = 0;
                                                                                  break C;
                                                                                }
                                                                                if (Te >>> 0 >= 1073741824) {
                                                                                  if (e[5996] = 0, Nn(35), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                                    break e;
                                                                                  break k;
                                                                                }
                                                                                if (e[5996] = 0, s = Mi(3, Te << 2) | 0, p = e[5996], e[5996] = 0, (p | 0) == 1)
                                                                                  break k;
                                                                              }
                                                                              if (p = (Xe << 2) + s | 0, e[p >> 2] = r, r = p + 4 | 0, (A | 0) != (N | 0)) {
                                                                                for (; p = p - 4 | 0, A = A - 4 | 0, e[p >> 2] = e[A >> 2], (A | 0) != (N | 0); )
                                                                                  ;
                                                                                A = e[m + 4 >> 2];
                                                                              }
                                                                              if (e[m + 12 >> 2] = (Te << 2) + s, e[m + 8 >> 2] = r, e[m + 4 >> 2] = p, !A)
                                                                                break b;
                                                                              Br(A);
                                                                            }
                                                                            if (e[5996] = 0, s = Mi(3, 4) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1) {
                                                                              u = Hr() | 0;
                                                                              break r;
                                                                            }
                                                                            if (e[s >> 2] = m, e[5996] = 0, r = Mi(3, 56) | 0, A = e[5996], e[5996] = 0, (A | 0) == 1)
                                                                              break R;
                                                                            if (e[r + 16 >> 2] = 0, e[r + 20 >> 2] = 0, e[r + 4 >> 2] = s, e[r >> 2] = 16, s = s + 4 | 0, e[r + 12 >> 2] = s, e[r + 8 >> 2] = s, e[r + 24 >> 2] = 0, e[r + 28 >> 2] = 0, e[r + 32 >> 2] = 0, e[r + 36 >> 2] = 0, e[r + 40 >> 2] = 0, e[r + 44 >> 2] = 0, e[5996] = 0, ji(33, u | 0, r | 0), s = e[5996], e[5996] = 0, (s | 0) == 1)
                                                                              break N;
                                                                            A = e[m + 8 >> 2], p = e[m + 12 >> 2];
                                                                            b: {
                                                                              if (A >>> 0 < p >>> 0) {
                                                                                e[A >> 2] = r, e[m + 8 >> 2] = A + 4;
                                                                                break b;
                                                                              }
                                                                              if (N = e[m + 4 >> 2], Xe = A - N >> 2, s = Xe + 1 | 0, s >>> 0 >= 1073741824) {
                                                                                if (e[5996] = 0, Nn(34), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                                  break e;
                                                                                break N;
                                                                              }
                                                                              p = p - N | 0, Te = p >> 1, Te = p >>> 0 >= 2147483644 ? 1073741823 : s >>> 0 < Te >>> 0 ? Te : s;
                                                                              C: {
                                                                                if (!Te) {
                                                                                  s = 0;
                                                                                  break C;
                                                                                }
                                                                                if (Te >>> 0 >= 1073741824) {
                                                                                  if (e[5996] = 0, Nn(35), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                                    break e;
                                                                                  break N;
                                                                                }
                                                                                if (e[5996] = 0, s = Mi(3, Te << 2) | 0, p = e[5996], e[5996] = 0, (p | 0) == 1)
                                                                                  break N;
                                                                              }
                                                                              if (p = (Xe << 2) + s | 0, e[p >> 2] = r, r = p + 4 | 0, (A | 0) != (N | 0)) {
                                                                                for (; p = p - 4 | 0, A = A - 4 | 0, e[p >> 2] = e[A >> 2], (A | 0) != (N | 0); )
                                                                                  ;
                                                                                A = e[m + 4 >> 2];
                                                                              }
                                                                              if (e[m + 12 >> 2] = (Te << 2) + s, e[m + 8 >> 2] = r, e[m + 4 >> 2] = p, !A)
                                                                                break b;
                                                                              Br(A);
                                                                            }
                                                                            if (e[5996] = 0, s = Mi(3, 4) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1) {
                                                                              u = Hr() | 0;
                                                                              break r;
                                                                            }
                                                                            if (e[s >> 2] = m, e[5996] = 0, r = Mi(3, 56) | 0, A = e[5996], e[5996] = 0, (A | 0) == 1)
                                                                              break h;
                                                                            if (e[r + 16 >> 2] = 0, e[r + 20 >> 2] = 0, e[r + 4 >> 2] = s, e[r >> 2] = 18, s = s + 4 | 0, e[r + 12 >> 2] = s, e[r + 8 >> 2] = s, e[r + 24 >> 2] = 0, e[r + 28 >> 2] = 0, e[r + 32 >> 2] = 0, e[r + 36 >> 2] = 0, e[r + 40 >> 2] = 0, e[r + 44 >> 2] = 0, e[5996] = 0, ji(33, u | 0, r | 0), s = e[5996], e[5996] = 0, (s | 0) == 1)
                                                                              break S;
                                                                            A = e[m + 8 >> 2], p = e[m + 12 >> 2];
                                                                            b: {
                                                                              if (A >>> 0 < p >>> 0) {
                                                                                e[A >> 2] = r, e[m + 8 >> 2] = A + 4;
                                                                                break b;
                                                                              }
                                                                              if (N = e[m + 4 >> 2], Xe = A - N >> 2, s = Xe + 1 | 0, s >>> 0 >= 1073741824) {
                                                                                if (e[5996] = 0, Nn(34), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                                  break e;
                                                                                break S;
                                                                              }
                                                                              p = p - N | 0, Te = p >> 1, Te = p >>> 0 >= 2147483644 ? 1073741823 : s >>> 0 < Te >>> 0 ? Te : s;
                                                                              C: {
                                                                                if (!Te) {
                                                                                  s = 0;
                                                                                  break C;
                                                                                }
                                                                                if (Te >>> 0 >= 1073741824) {
                                                                                  if (e[5996] = 0, Nn(35), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                                    break e;
                                                                                  break S;
                                                                                }
                                                                                if (e[5996] = 0, s = Mi(3, Te << 2) | 0, p = e[5996], e[5996] = 0, (p | 0) == 1)
                                                                                  break S;
                                                                              }
                                                                              if (p = (Xe << 2) + s | 0, e[p >> 2] = r, r = p + 4 | 0, (A | 0) != (N | 0)) {
                                                                                for (; p = p - 4 | 0, A = A - 4 | 0, e[p >> 2] = e[A >> 2], (A | 0) != (N | 0); )
                                                                                  ;
                                                                                A = e[m + 4 >> 2];
                                                                              }
                                                                              if (e[m + 12 >> 2] = (Te << 2) + s, e[m + 8 >> 2] = r, e[m + 4 >> 2] = p, !A)
                                                                                break b;
                                                                              Br(A);
                                                                            }
                                                                            if (e[5996] = 0, r = e[6079], s = Mi(3, 8) | 0, A = e[5996], e[5996] = 0, (A | 0) == 1) {
                                                                              u = Hr() | 0;
                                                                              break r;
                                                                            }
                                                                            if (e[s + 4 >> 2] = r, e[s >> 2] = m, e[5996] = 0, r = Mi(3, 56) | 0, A = e[5996], e[5996] = 0, (A | 0) == 1)
                                                                              break E;
                                                                            if (e[r + 16 >> 2] = 0, e[r + 20 >> 2] = 0, e[r + 4 >> 2] = s, e[r >> 2] = 11, e[r + 48 >> 2] = 0, e[r + 52 >> 2] = 1072693248, s = s + 8 | 0, e[r + 12 >> 2] = s, e[r + 8 >> 2] = s, e[r + 24 >> 2] = 0, e[r + 28 >> 2] = 0, e[r + 32 >> 2] = 0, e[r + 36 >> 2] = 0, e[r + 40 >> 2] = 0, e[r + 44 >> 2] = 0, e[5996] = 0, ji(33, u | 0, r | 0), s = e[5996], e[5996] = 0, (s | 0) == 1)
                                                                              break T;
                                                                            A = e[m + 8 >> 2], p = e[m + 12 >> 2];
                                                                            b: {
                                                                              if (A >>> 0 < p >>> 0) {
                                                                                e[A >> 2] = r, e[m + 8 >> 2] = A + 4;
                                                                                break b;
                                                                              }
                                                                              if (N = e[m + 4 >> 2], Xe = A - N >> 2, s = Xe + 1 | 0, s >>> 0 >= 1073741824) {
                                                                                if (e[5996] = 0, Nn(34), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                                  break e;
                                                                                break T;
                                                                              }
                                                                              p = p - N | 0, Te = p >> 1, Te = p >>> 0 >= 2147483644 ? 1073741823 : s >>> 0 < Te >>> 0 ? Te : s;
                                                                              C: {
                                                                                if (!Te) {
                                                                                  s = 0;
                                                                                  break C;
                                                                                }
                                                                                if (Te >>> 0 >= 1073741824) {
                                                                                  if (e[5996] = 0, Nn(35), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                                    break e;
                                                                                  break T;
                                                                                }
                                                                                if (e[5996] = 0, s = Mi(3, Te << 2) | 0, p = e[5996], e[5996] = 0, (p | 0) == 1)
                                                                                  break T;
                                                                              }
                                                                              if (p = (Xe << 2) + s | 0, e[p >> 2] = r, r = p + 4 | 0, (A | 0) != (N | 0)) {
                                                                                for (; p = p - 4 | 0, A = A - 4 | 0, e[p >> 2] = e[A >> 2], (A | 0) != (N | 0); )
                                                                                  ;
                                                                                A = e[m + 4 >> 2];
                                                                              }
                                                                              if (e[m + 12 >> 2] = (Te << 2) + s, e[m + 8 >> 2] = r, e[m + 4 >> 2] = p, !A)
                                                                                break b;
                                                                              Br(A);
                                                                            }
                                                                            if (e[5996] = 0, s = Mi(3, 4) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1) {
                                                                              u = Hr() | 0;
                                                                              break r;
                                                                            }
                                                                            if (e[s >> 2] = m, e[5996] = 0, r = Mi(3, 56) | 0, A = e[5996], e[5996] = 0, (A | 0) == 1)
                                                                              break w;
                                                                            if (e[r + 16 >> 2] = 0, e[r + 20 >> 2] = 0, e[r + 4 >> 2] = s, e[r >> 2] = 14, s = s + 4 | 0, e[r + 12 >> 2] = s, e[r + 8 >> 2] = s, e[r + 24 >> 2] = 0, e[r + 28 >> 2] = 0, e[r + 32 >> 2] = 0, e[r + 36 >> 2] = 0, e[r + 40 >> 2] = 0, e[r + 44 >> 2] = 0, e[5996] = 0, ji(33, u | 0, r | 0), s = e[5996], e[5996] = 0, (s | 0) == 1)
                                                                              break v;
                                                                            if (A = e[m + 8 >> 2], N = e[m + 12 >> 2], A >>> 0 < N >>> 0) {
                                                                              e[A >> 2] = r, e[m + 8 >> 2] = A + 4;
                                                                              break u;
                                                                            }
                                                                            if (s = e[m + 4 >> 2], p = A - s >> 2, u = p + 1 | 0, u >>> 0 >= 1073741824) {
                                                                              if (e[5996] = 0, Nn(34), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                                break e;
                                                                              break v;
                                                                            }
                                                                            N = N - s | 0, Te = N >> 1, u = N >>> 0 >= 2147483644 ? 1073741823 : u >>> 0 < Te >>> 0 ? Te : u;
                                                                            b: {
                                                                              if (!u) {
                                                                                Xe = 0;
                                                                                break b;
                                                                              }
                                                                              if (u >>> 0 >= 1073741824) {
                                                                                if (e[5996] = 0, Nn(35), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                                  break e;
                                                                                break v;
                                                                              }
                                                                              if (e[5996] = 0, Xe = Mi(3, u << 2) | 0, N = e[5996], e[5996] = 0, (N | 0) == 1)
                                                                                break v;
                                                                            }
                                                                            if (p = (p << 2) + Xe | 0, e[p >> 2] = r, r = p + 4 | 0, (s | 0) != (A | 0)) {
                                                                              for (; p = p - 4 | 0, A = A - 4 | 0, e[p >> 2] = e[A >> 2], (s | 0) != (A | 0); )
                                                                                ;
                                                                              A = e[m + 4 >> 2];
                                                                            }
                                                                            if (e[m + 12 >> 2] = (u << 2) + Xe, e[m + 8 >> 2] = r, e[m + 4 >> 2] = p, !A)
                                                                              break u;
                                                                            Br(A);
                                                                            break u;
                                                                          }
                                                                          u = Hr() | 0, Br(s);
                                                                          break r;
                                                                        }
                                                                        u = Hr() | 0, Br(s);
                                                                        break r;
                                                                      }
                                                                      u = Hr() | 0, Br(s);
                                                                      break r;
                                                                    }
                                                                    u = Hr() | 0, Br(s);
                                                                    break r;
                                                                  }
                                                                  u = Hr() | 0, Br(s);
                                                                  break r;
                                                                }
                                                                u = Hr() | 0, Br(s);
                                                                break r;
                                                              }
                                                              u = Hr() | 0, Br(s);
                                                              break r;
                                                            }
                                                            u = Hr() | 0, Br(s);
                                                            break r;
                                                          }
                                                          u = Hr() | 0;
                                                          break r;
                                                        }
                                                        u = Hr() | 0;
                                                        break r;
                                                      }
                                                      u = Hr() | 0;
                                                      break r;
                                                    }
                                                    u = Hr() | 0;
                                                    break r;
                                                  }
                                                  u = Hr() | 0;
                                                  break r;
                                                }
                                                u = Hr() | 0;
                                                break r;
                                              }
                                              u = Hr() | 0;
                                              break r;
                                            }
                                            u = Hr() | 0;
                                            break r;
                                          }
                                          u = Hr() | 0;
                                          break r;
                                        }
                                        return r = e[W + 16 >> 2], r && (e[W + 20 >> 2] = r, Br(r)), Jr = W + 48 | 0, m | 0;
                                      }
                                      u = Hr() | 0;
                                      break r;
                                    }
                                    u = Hr() | 0;
                                    break r;
                                  }
                                  u = Hr() | 0;
                                  break r;
                                }
                                u = Hr() | 0;
                                break r;
                              }
                              u = Hr() | 0;
                              break r;
                            }
                            u = Hr() | 0;
                            break r;
                          }
                          u = Hr() | 0;
                          break r;
                        }
                        u = Hr() | 0;
                        break r;
                      }
                      u = Hr() | 0;
                    }
                    if (r = e[W + 16 >> 2], !r)
                      break t;
                    e[W + 20 >> 2] = r, Br(r);
                  }
                  Jn(u | 0), Oi();
                }
                Oi();
              }
              function tf(r) {
                r = r | 0;
                var s = 0, u = 0, A = 0, m = 0, p = 0, N = 0, W = 0, Te = 0, Xe = 0, fr = 0, ar = 0, vr = 0, _r = 0, hi = 0, mi = 0, Ni = 0, Hi = 0, Ji = 0, Ln = 0, _n = 0, hs = 0, bs = 0, Us = 0, go = 0;
                e: {
                  t: {
                    r: {
                      if (e[r >> 2] != 24 || (u = e[r + 32 >> 2], N = e[r + 36 >> 2], (u | 0) == (N | 0)))
                        break r;
                      for (; ; ) {
                        Xe = e[e[u >> 2] + 80 >> 2];
                        i: {
                          if (p >>> 0 > Te >>> 0) {
                            e[Te >> 2] = Xe, Te = Te + 4 | 0;
                            break i;
                          }
                          if (W = Te - s >> 2, A = W + 1 | 0, A >>> 0 >= 1073741824) {
                            if (e[5996] = 0, Nn(94), r = e[5996], e[5996] = 0, (r | 0) == 1)
                              break t;
                            break e;
                          }
                          m = p - s | 0, p = m >> 1, p = m >>> 0 >= 2147483644 ? 1073741823 : A >>> 0 < p >>> 0 ? p : A;
                          n: {
                            if (!p) {
                              m = 0;
                              break n;
                            }
                            if (p >>> 0 >= 1073741824) {
                              if (e[5996] = 0, Nn(35), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                break e;
                              break t;
                            }
                            if (e[5996] = 0, m = Mi(3, p << 2) | 0, A = e[5996], e[5996] = 0, (A | 0) == 1)
                              break t;
                          }
                          if (A = (W << 2) + m | 0, e[A >> 2] = Xe, hs = A, (s | 0) != (Te | 0))
                            for (; hs = hs - 4 | 0, Te = Te - 4 | 0, e[hs >> 2] = e[Te >> 2], (s | 0) != (Te | 0); )
                              ;
                          p = (p << 2) + m | 0, Te = A + 4 | 0, s && Br(s), s = hs;
                        }
                        if (u = u + 8 | 0, (N | 0) == (u | 0))
                          break;
                      }
                    }
                    Xe = e[r + 36 >> 2], p = e[r + 32 >> 2], u = Xe - p | 0;
                    r: {
                      if ((p | 0) == (Xe | 0)) {
                        A = 0, W = 0;
                        break r;
                      }
                      if (W = e[e[p >> 2] + 80 >> 2], u >>> 0 < 9) {
                        A = 0;
                        break r;
                      }
                      if (A = e[e[p + 8 >> 2] + 80 >> 2], u >>> 0 < 17)
                        break r;
                      vr = e[e[p + 16 >> 2] + 80 >> 2];
                    }
                    Ji = u >> 3, fr = e[r + 24 >> 2], hi = e[r + 20 >> 2], m = fr - hi | 0, _n = e[r + 12 >> 2], bs = e[r + 8 >> 2], Us = _n - bs | 0, N = (Us | 0) / 12 | 0, _r = e[r + 4 >> 2];
                    r: {
                      i: {
                        n: {
                          s: {
                            a: {
                              o: {
                                l: {
                                  c: {
                                    d: {
                                      f: {
                                        u: {
                                          g: {
                                            A: {
                                              p: {
                                                m:
                                                  switch (s = e[r >> 2], r = s & -2, r - 6 | 0) {
                                                    case 2:
                                                      break p;
                                                    case 0:
                                                      break m;
                                                    default:
                                                      break A;
                                                  }
                                                if ((m | 0) == 32)
                                                  break g;
                                                m = 2369, r = 39, N = 3984;
                                                break i;
                                              }
                                              if ((m | 0) == 20)
                                                break g;
                                              m = 2369, r = 41, N = 4224;
                                              break i;
                                            }
                                            if (m = 2369, (fr | 0) != (hi | 0)) {
                                              r = 43, N = 4337;
                                              break i;
                                            }
                                            if ((r | 0) != 4)
                                              break g;
                                            if ((_r | 0) > 0)
                                              break u;
                                            r = 47, N = 3134;
                                            break i;
                                          }
                                          g:
                                            switch (s - 24 | 0) {
                                              case 1:
                                                if (N >>> 0 > _r - 1 >>> 0)
                                                  break f;
                                                m = 2369, r = 49, N = 1397;
                                                break i;
                                              case 0:
                                                if (Ji >>> 0 > _r - 1 >>> 0)
                                                  break c;
                                                m = 2369, r = 51, N = 1654;
                                                break i;
                                              default:
                                                break g;
                                            }
                                          if (m = 2369, _r) {
                                            r = 53, N = 4330;
                                            break i;
                                          }
                                          if (s - 17 >>> 0 > 5)
                                            break u;
                                          if ((u | 0) == 16)
                                            break d;
                                          r = 58, N = 4003;
                                          break i;
                                        }
                                        if (s - 10 >>> 0 >= 7) {
                                          if ((s | 0) != 23)
                                            break f;
                                          if ((u | 0) == 24)
                                            break c;
                                          r = 60, N = 3946;
                                          break i;
                                        }
                                        if ((u | 0) == 8)
                                          break c;
                                        r = 64, N = 4090;
                                        break i;
                                      }
                                      if ((s | 0) == 24 | (p | 0) == (Xe | 0))
                                        break d;
                                      m = 2369, r = 66, N = 4311;
                                      break i;
                                    }
                                    if ((r | 0) == 2) {
                                      if ((Us | 0) == 12)
                                        break l;
                                      m = 2369, r = 70, N = 4063;
                                      break i;
                                    }
                                    if ((s | 0) != 25)
                                      break c;
                                    if (N - 1 >>> 0 < 20)
                                      break o;
                                    m = 2369, r = 72, N = 4240;
                                    break i;
                                  }
                                  if ((_n | 0) == (bs | 0))
                                    break l;
                                  m = 2369, r = 74, N = 4299;
                                  break i;
                                }
                                u = 10, p = 2108, m = 2369, r = 247, N = 2350;
                                l:
                                  switch (s | 0) {
                                    case 3:
                                      u = 9, p = 2119;
                                      break a;
                                    case 4:
                                      if (e[5996] = 0, r = pi(54, 2295, 1) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1 || (e[5996] = 0, s = pi(54, 2278, 1) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1) || (e[5996] = 0, u = pi(54, 2129, 6) | 0, A = e[5996], e[5996] = 0, (A | 0) == 1))
                                        break r;
                                      s = u | (_r & 4194304 ? r : s);
                                      break n;
                                    case 5:
                                      if (e[5996] = 0, r = pi(54, 2174, 1) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1 || (e[5996] = 0, s = pi(54, 2170, 1) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1) || (e[5996] = 0, u = pi(54, 2129, 6) | 0, A = e[5996], e[5996] = 0, (A | 0) == 1))
                                        break r;
                                      s = u | ((_r >>> 0 < 5e8 ? s : 0) | (_r >>> 0 > 499999999 ? r : 0));
                                      break n;
                                    case 6:
                                    case 7:
                                    case 8:
                                    case 9:
                                      u = 7, p = 2153;
                                      break a;
                                    case 1:
                                      u = 7, p = 2136;
                                      break a;
                                    case 0:
                                      u = 9, p = 2098;
                                      break a;
                                    case 10:
                                      if (e[5996] = 0, r = pi(54, 2777, 1) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1 || (e[5996] = 0, s = pi(54, 3557, 1) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1) || (e[5996] = 0, u = pi(54, 2161, 5) | 0, A = e[5996], e[5996] = 0, (A | 0) == 1) || (e[5996] = 0, A = pi(54, 1600, 6) | 0, m = e[5996], e[5996] = 0, (m | 0) == 1) || (e[5996] = 0, m = pi(54, 1239, 1) | 0, p = e[5996], e[5996] = 0, (p | 0) == 1))
                                        break r;
                                      s = (u | A) & W | (m | (s & (W ^ -1) ? 0 : r));
                                      break n;
                                    case 11:
                                      if (e[5996] = 0, r = pi(54, 2777, 1) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1 || (e[5996] = 0, s = pi(54, 1958, 2) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1) || (e[5996] = 0, u = pi(54, 2161, 5) | 0, A = e[5996], e[5996] = 0, (A | 0) == 1) || (e[5996] = 0, A = pi(54, 1197, 7) | 0, m = e[5996], e[5996] = 0, (m | 0) == 1))
                                        break r;
                                      s = (u | A) & W | (s & (W ^ -1) ? 0 : r);
                                      break n;
                                    case 12:
                                      if (e[5996] = 0, r = pi(54, 3557, 1) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1 || (e[5996] = 0, s = pi(54, 3310, 1) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1) || (e[5996] = 0, u = pi(54, 2161, 5) | 0, A = e[5996], e[5996] = 0, (A | 0) == 1) || (e[5996] = 0, A = pi(54, 2035, 6) | 0, m = e[5996], e[5996] = 0, (m | 0) == 1) || (e[5996] = 0, m = pi(54, 1419, 2) | 0, p = e[5996], e[5996] = 0, (p | 0) == 1))
                                        break r;
                                      s = (u | A) & W | (m | (s & (W ^ -1) ? 0 : r));
                                      break n;
                                    case 13:
                                      if (e[5996] = 0, s = pi(54, 3557, 1) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1 || (e[5996] = 0, u = pi(54, 1028, 2) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[5996] = 0, r = pi(54, 1959, 1) | 0, A = e[5996], e[5996] = 0, (A | 0) == 1) || (e[5996] = 0, A = pi(54, 1029, 1) | 0, m = e[5996], e[5996] = 0, (m | 0) == 1) || (e[5996] = 0, m = pi(54, 2451, 1) | 0, p = e[5996], e[5996] = 0, (p | 0) == 1) || (e[5996] = 0, p = pi(54, 2315, 1) | 0, Xe = e[5996], e[5996] = 0, (Xe | 0) == 1) || (e[5996] = 0, Xe = pi(54, 2161, 5) | 0, N = e[5996], e[5996] = 0, (N | 0) == 1) || (e[5996] = 0, N = pi(54, 1640, 2) | 0, Te = e[5996], e[5996] = 0, (Te | 0) == 1) || (e[5996] = 0, Te = pi(54, 1208, 3) | 0, _r = e[5996], e[5996] = 0, (_r | 0) == 1))
                                        break r;
                                      fr = r, r = W ^ -1, s = (N | Xe) & W | (Te | ((r & A ? 0 : fr) | (r & u ? 0 : s) | (r & p ? 0 : m)));
                                      break n;
                                    case 14:
                                      if (e[5996] = 0, r = pi(54, 2796, 1) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1 || (e[5996] = 0, s = pi(54, 3557, 1) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1) || (e[5996] = 0, u = pi(54, 2161, 5) | 0, A = e[5996], e[5996] = 0, (A | 0) == 1) || (e[5996] = 0, A = pi(54, 1486, 5) | 0, m = e[5996], e[5996] = 0, (m | 0) == 1) || (e[5996] = 0, m = pi(54, 1205, 2) | 0, p = e[5996], e[5996] = 0, (p | 0) == 1))
                                        break r;
                                      s = (u | A) & W | (m | (s & (W ^ -1) ? 0 : r));
                                      break n;
                                    case 15:
                                      if (e[5996] = 0, r = pi(54, 3557, 1) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1 || (e[5996] = 0, s = pi(54, 2028, 2) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1) || (e[5996] = 0, u = pi(54, 2451, 1) | 0, A = e[5996], e[5996] = 0, (A | 0) == 1) || (e[5996] = 0, A = pi(54, 2315, 1) | 0, m = e[5996], e[5996] = 0, (m | 0) == 1) || (e[5996] = 0, m = pi(54, 2161, 5) | 0, p = e[5996], e[5996] = 0, (p | 0) == 1) || (e[5996] = 0, p = pi(54, 1430, 4) | 0, Xe = e[5996], e[5996] = 0, (Xe | 0) == 1) || (e[5996] = 0, Xe = pi(54, 1208, 3) | 0, N = e[5996], e[5996] = 0, (N | 0) == 1))
                                        break r;
                                      N = u, u = W ^ -1, s = (m | p) & W | (Xe | ((u & A ? 0 : N) | (s & u ? 0 : r)));
                                      break n;
                                    case 16:
                                      if (e[5996] = 0, r = pi(54, 2161, 5) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1 || (e[5996] = 0, s = pi(54, 1607, 9) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1) || (e[5996] = 0, u = pi(54, 1149, 2) | 0, A = e[5996], e[5996] = 0, (A | 0) == 1))
                                        break r;
                                      s = u | (r | s) & W;
                                      break n;
                                    case 17:
                                      if (e[5996] = 0, Xe = pi(54, 3540, 3) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1 || (e[5996] = 0, N = pi(54, 2796, 1) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[5996] = 0, Te = pi(54, 2029, 1) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[5996] = 0, _r = pi(54, 2029, 1) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[5996] = 0, vr = pi(54, 1029, 1) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[5996] = 0, Ji = pi(54, 1959, 1) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[5996] = 0, fr = pi(54, 1029, 1) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[5996] = 0, hi = pi(54, 1024, 3) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[5996] = 0, _n = pi(54, 1681, 1) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[5996] = 0, r = pi(54, 2315, 1) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1) || (e[5996] = 0, s = pi(54, 2315, 1) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1))
                                        break r;
                                      m = W ^ -1, p = A ^ -1;
                                      c: {
                                        if (p & s) {
                                          if (u = 0, e[5996] = 0, s = pi(54, 1681, 1) | 0, bs = e[5996], e[5996] = 0, (bs | 0) == 1)
                                            break r;
                                          if (s & m)
                                            break c;
                                        }
                                        u = r;
                                      }
                                      if (e[5996] = 0, bs = pi(54, 1149, 2) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1 || (e[5996] = 0, Us = pi(54, 2167, 4) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[5996] = 0, r = pi(54, 2165, 1) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1) || (e[5996] = 0, Ni = pi(54, 2165, 1) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1))
                                        break r;
                                      s = 0, mi = A & W;
                                      c: {
                                        if (Ni & (mi ^ -1))
                                          break c;
                                        if (e[5996] = 0, s = pi(54, 2295, 1) | 0, Ni = e[5996], e[5996] = 0, (Ni | 0) == 1)
                                          break r;
                                        if (!(s & m)) {
                                          if (s = 0, e[5996] = 0, Ni = pi(54, 2278, 1) | 0, Hi = e[5996], e[5996] = 0, (Hi | 0) == 1)
                                            break r;
                                          if (!(p & Ni))
                                            break c;
                                        }
                                        if (e[5996] = 0, s = pi(54, 2278, 1) | 0, Ni = e[5996], e[5996] = 0, (Ni | 0) == 1)
                                          break r;
                                        if (!(s & m)) {
                                          if (s = 0, e[5996] = 0, Ni = pi(54, 2295, 1) | 0, Hi = e[5996], e[5996] = 0, (Hi | 0) == 1)
                                            break r;
                                          if (!(p & Ni))
                                            break c;
                                        }
                                        if (e[5996] = 0, s = pi(54, 2174, 1) | 0, Ni = e[5996], e[5996] = 0, (Ni | 0) == 1)
                                          break r;
                                        if (!(s & m)) {
                                          if (s = 0, e[5996] = 0, Ni = pi(54, 2170, 1) | 0, Hi = e[5996], e[5996] = 0, (Hi | 0) == 1)
                                            break r;
                                          if (!(p & Ni))
                                            break c;
                                        }
                                        if (e[5996] = 0, s = pi(54, 2170, 1) | 0, Ni = e[5996], e[5996] = 0, (Ni | 0) == 1)
                                          break r;
                                        if (!(s & m)) {
                                          if (s = 0, e[5996] = 0, Ni = pi(54, 2174, 1) | 0, Hi = e[5996], e[5996] = 0, (Hi | 0) == 1)
                                            break r;
                                          if (!(p & Ni))
                                            break c;
                                        }
                                        s = r;
                                      }
                                      r = A | W, s = A & bs | (hi & mi | (W & Te | (m & N ? 0 : A & Xe) | (m & vr ? 0 : A & _r)) | (fr & (r ^ -1) ? 0 : r & Ji) | r & _n | u) | r & Us | s;
                                      break n;
                                    case 18:
                                      if (e[5996] = 0, Te = pi(54, 3557, 1) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1 || (e[5996] = 0, _r = pi(54, 2777, 1) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[5996] = 0, vr = pi(54, 1959, 1) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[5996] = 0, Ji = pi(54, 1029, 1) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[5996] = 0, fr = pi(54, 2029, 1) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[5996] = 0, hi = pi(54, 2029, 1) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[5996] = 0, _n = pi(54, 1029, 1) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[5996] = 0, bs = pi(54, 2451, 1) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[5996] = 0, Us = pi(54, 1681, 1) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[5996] = 0, Ni = pi(54, 2031, 3) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[5996] = 0, r = pi(54, 2315, 1) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1) || (e[5996] = 0, m = pi(54, 2315, 1) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1))
                                        break r;
                                      s = A ^ -1, u = W ^ -1, p = A & W, N = p ^ -1;
                                      c: {
                                        d: {
                                          if (!(N & m))
                                            break d;
                                          if (e[5996] = 0, m = pi(54, 2297, 2) | 0, Xe = e[5996], e[5996] = 0, (Xe | 0) == 1)
                                            break r;
                                          if (!(u & m))
                                            break d;
                                          if (Xe = 0, e[5996] = 0, m = pi(54, 2297, 2) | 0, mi = e[5996], e[5996] = 0, (mi | 0) == 1)
                                            break r;
                                          if (s & m)
                                            break c;
                                        }
                                        Xe = r;
                                      }
                                      if (e[5996] = 0, mi = pi(54, 1681, 1) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1 || (e[5996] = 0, Hi = pi(54, 1149, 2) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[5996] = 0, go = pi(54, 2167, 4) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[5996] = 0, r = pi(54, 2165, 1) | 0, m = e[5996], e[5996] = 0, (m | 0) == 1) || (m = 0, e[5996] = 0, ar = pi(54, 2165, 1) | 0, Ln = e[5996], e[5996] = 0, (Ln | 0) == 1))
                                        break r;
                                      c: {
                                        if (N & ar)
                                          break c;
                                        if (e[5996] = 0, m = pi(54, 2295, 1) | 0, ar = e[5996], e[5996] = 0, (ar | 0) == 1)
                                          break r;
                                        if (!(u & m)) {
                                          if (m = 0, e[5996] = 0, ar = pi(54, 2278, 1) | 0, Ln = e[5996], e[5996] = 0, (Ln | 0) == 1)
                                            break r;
                                          if (!(s & ar))
                                            break c;
                                        }
                                        if (e[5996] = 0, m = pi(54, 2278, 1) | 0, ar = e[5996], e[5996] = 0, (ar | 0) == 1)
                                          break r;
                                        if (!(u & m)) {
                                          if (m = 0, e[5996] = 0, ar = pi(54, 2295, 1) | 0, Ln = e[5996], e[5996] = 0, (Ln | 0) == 1)
                                            break r;
                                          if (!(s & ar))
                                            break c;
                                        }
                                        if (e[5996] = 0, m = pi(54, 2174, 1) | 0, ar = e[5996], e[5996] = 0, (ar | 0) == 1)
                                          break r;
                                        if (!(u & m)) {
                                          if (m = 0, e[5996] = 0, ar = pi(54, 2170, 1) | 0, Ln = e[5996], e[5996] = 0, (Ln | 0) == 1)
                                            break r;
                                          if (!(s & ar))
                                            break c;
                                        }
                                        if (e[5996] = 0, m = pi(54, 2170, 1) | 0, ar = e[5996], e[5996] = 0, (ar | 0) == 1)
                                          break r;
                                        if (!(u & m)) {
                                          if (m = 0, e[5996] = 0, ar = pi(54, 2174, 1) | 0, Ln = e[5996], e[5996] = 0, (Ln | 0) == 1)
                                            break r;
                                          if (!(s & ar))
                                            break c;
                                        }
                                        m = r;
                                      }
                                      r = A | W, s = Hi | (p & Ni | (W & fr | (s & _r ? 0 : W & Te) | (Ji & (r ^ -1) ? 0 : r & vr) | (u & _n ? 0 : A & hi)) | (N & Us ? 0 : p & bs) | Xe | r & mi) | r & go | m;
                                      break n;
                                    case 19:
                                      if (e[5996] = 0, r = pi(54, 3557, 1) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1 || (e[5996] = 0, s = pi(54, 2504, 2) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1))
                                        break r;
                                      if (u = 0, !((W ^ -1) & s)) {
                                        if (e[5996] = 0, s = pi(54, 2501, 2) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1)
                                          break r;
                                        u = s & (A ^ -1) ? 0 : r;
                                      }
                                      if (e[5996] = 0, m = pi(54, 1959, 1) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1 || (e[5996] = 0, Xe = pi(54, 1029, 1) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[5996] = 0, N = pi(54, 2049, 1) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1) || (p = 0, e[5996] = 0, s = pi(54, 1681, 1) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1))
                                        break r;
                                      if (r = A & W, fr = s, s = A | W, A = s ^ -1, !(fr & A)) {
                                        if (e[5996] = 0, p = pi(54, 2451, 1) | 0, W = e[5996], e[5996] = 0, (W | 0) == 1)
                                          break r;
                                        p = p & (r ^ -1) ? 0 : r & N;
                                      }
                                      if (e[5996] = 0, N = pi(54, 2340, 3) | 0, W = e[5996], e[5996] = 0, (W | 0) == 1 || (e[5996] = 0, W = pi(54, 1148, 3) | 0, Te = e[5996], e[5996] = 0, (Te | 0) == 1) || (e[5996] = 0, Te = pi(54, 2167, 4) | 0, _r = e[5996], e[5996] = 0, (_r | 0) == 1) || (e[5996] = 0, _r = pi(54, 2165, 1) | 0, vr = e[5996], e[5996] = 0, (vr | 0) == 1))
                                        break r;
                                      s = r & _r | (s & Te | (W | (r & N | ((A & Xe ? 0 : s & m) | u | p))));
                                      break n;
                                    case 21:
                                      if (e[5996] = 0, m = pi(54, 3557, 1) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1 || (e[5996] = 0, p = pi(54, 1293, 3) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[5996] = 0, Xe = pi(54, 1959, 1) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[5996] = 0, N = pi(54, 1029, 1) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[5996] = 0, r = pi(54, 2049, 1) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1) || (e[5996] = 0, u = pi(54, 2451, 1) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1))
                                        break r;
                                      s = A & W, Te = W ^ -1;
                                      c: {
                                        if (Te & u) {
                                          r = A | W, u = 0;
                                          break c;
                                        }
                                        if (e[5996] = 0, u = pi(54, 1681, 1) | 0, _r = e[5996], e[5996] = 0, (_r | 0) == 1)
                                          break r;
                                        fr = r & s, r = A | W, u = u & (r ^ -1) ? 0 : fr;
                                      }
                                      if (e[5996] = 0, _r = pi(54, 1650, 3) | 0, vr = e[5996], e[5996] = 0, (vr | 0) == 1 || (e[5996] = 0, vr = pi(54, 2468, 3) | 0, Ji = e[5996], e[5996] = 0, (Ji | 0) == 1) || (e[5996] = 0, Ji = pi(54, 1239, 1) | 0, fr = e[5996], e[5996] = 0, (fr | 0) == 1) || (e[5996] = 0, fr = pi(54, 2167, 4) | 0, hi = e[5996], e[5996] = 0, (hi | 0) == 1) || (e[5996] = 0, hi = pi(54, 2165, 1) | 0, _n = e[5996], e[5996] = 0, (_n | 0) == 1))
                                        break r;
                                      s = s & hi | (r & fr | (Ji | (A & vr | (s & _r | (u | ((N & (A ^ -1) ? 0 : W & Xe) | (p & Te ? 0 : A & m)))))));
                                      break n;
                                    case 20:
                                      if (e[5996] = 0, m = pi(54, 2796, 1) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1 || (e[5996] = 0, p = pi(54, 1293, 3) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[5996] = 0, Xe = pi(54, 1959, 1) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[5996] = 0, N = pi(54, 1029, 1) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[5996] = 0, r = pi(54, 2049, 1) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1) || (e[5996] = 0, u = pi(54, 2451, 1) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1))
                                        break r;
                                      s = A & W, Te = W ^ -1;
                                      c: {
                                        if (Te & u) {
                                          r = A | W, u = 0;
                                          break c;
                                        }
                                        if (e[5996] = 0, u = pi(54, 1681, 1) | 0, _r = e[5996], e[5996] = 0, (_r | 0) == 1)
                                          break r;
                                        fr = r & s, r = A | W, u = u & (r ^ -1) ? 0 : fr;
                                      }
                                      if (e[5996] = 0, _r = pi(54, 1394, 2) | 0, vr = e[5996], e[5996] = 0, (vr | 0) == 1 || (e[5996] = 0, vr = pi(54, 1205, 2) | 0, Ji = e[5996], e[5996] = 0, (Ji | 0) == 1) || (e[5996] = 0, Ji = pi(54, 2167, 4) | 0, fr = e[5996], e[5996] = 0, (fr | 0) == 1) || (e[5996] = 0, fr = pi(54, 2165, 1) | 0, hi = e[5996], e[5996] = 0, (hi | 0) == 1))
                                        break r;
                                      s = s & fr | (r & Ji | (vr | (s & _r | (u | ((N & (A ^ -1) ? 0 : W & Xe) | (p & Te ? 0 : A & m))))));
                                      break n;
                                    case 22:
                                      if (e[5996] = 0, m = pi(54, 1643, 6) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1 || (e[5996] = 0, s = pi(54, 1959, 1) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[5996] = 0, p = pi(54, 1029, 1) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[5996] = 0, Xe = pi(54, 2451, 1) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[5996] = 0, N = pi(54, 2315, 1) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[5996] = 0, Te = pi(54, 2049, 1) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[5996] = 0, _r = pi(54, 1681, 1) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[5996] = 0, vr = pi(54, 2522, 1) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[5996] = 0, Ji = pi(54, 1239, 1) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[5996] = 0, fr = pi(54, 2167, 4) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[5996] = 0, hi = pi(54, 2165, 1) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1))
                                        break r;
                                      r = A | W, u = r ^ -1, ar = s, s = A & W, s = r & fr | (Ji | (r & vr | ((p & (s ^ -1) ? 0 : ar) | s & m | (u & N ? 0 : r & Xe))) | (u & _r ? 0 : s & Te)) | s & hi;
                                      break n;
                                    case 24:
                                      break s;
                                    case 2:
                                      break a;
                                    case 25:
                                      break o;
                                    case 23:
                                      break l;
                                    default:
                                      break i;
                                  }
                                if (e[5996] = 0, Ji = pi(54, 2779, 3) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1 || (e[5996] = 0, fr = pi(54, 1293, 3) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[5996] = 0, hi = pi(54, 1029, 1) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[5996] = 0, _n = pi(54, 1959, 1) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[5996] = 0, bs = pi(54, 1029, 1) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[5996] = 0, Us = pi(54, 1295, 1) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[5996] = 0, r = pi(54, 2315, 1) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1) || (e[5996] = 0, s = pi(54, 1681, 1) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1))
                                  break r;
                                u = W ^ -1;
                                l: {
                                  if (u & s) {
                                    if (m = 0, e[5996] = 0, s = pi(54, 2315, 1) | 0, p = e[5996], e[5996] = 0, (p | 0) == 1)
                                      break r;
                                    if ((A ^ -1) & s)
                                      break l;
                                  }
                                  m = r & vr;
                                }
                                if (e[5996] = 0, Ni = pi(54, 2522, 1) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1 || (e[5996] = 0, r = pi(54, 2451, 1) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1) || (e[5996] = 0, s = pi(54, 1681, 1) | 0, p = e[5996], e[5996] = 0, (p | 0) == 1))
                                  break r;
                                l: {
                                  if (s & u) {
                                    if (Xe = 0, e[5996] = 0, s = pi(54, 2315, 1) | 0, p = e[5996], e[5996] = 0, (p | 0) == 1)
                                      break r;
                                    if ((A ^ -1) & s)
                                      break l;
                                  }
                                  Xe = r & W & vr;
                                }
                                if (e[5996] = 0, r = pi(54, 2049, 1) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1 || (e[5996] = 0, s = pi(54, 2451, 1) | 0, p = e[5996], e[5996] = 0, (p | 0) == 1))
                                  break r;
                                _r = A & W & vr;
                                l: {
                                  if (s & u) {
                                    N = A | W, Te = vr | N, r = 0;
                                    break l;
                                  }
                                  if (e[5996] = 0, s = pi(54, 1681, 1) | 0, p = e[5996], e[5996] = 0, (p | 0) == 1)
                                    break r;
                                  N = A | W, Te = vr | N, r = s & (Te ^ -1) ? 0 : r & _r;
                                }
                                if (e[5996] = 0, mi = pi(54, 1681, 1) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1 || (e[5996] = 0, Hi = pi(54, 1239, 1) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1) || (e[5996] = 0, go = pi(54, 2167, 4) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1) || (e[5996] = 0, s = pi(54, 2165, 1) | 0, p = e[5996], e[5996] = 0, (p | 0) == 1) || (p = 0, e[5996] = 0, ar = pi(54, 2165, 1) | 0, Ln = e[5996], e[5996] = 0, (Ln | 0) == 1))
                                  break r;
                                l: {
                                  if (ar & (_r ^ -1))
                                    break l;
                                  if (e[5996] = 0, p = pi(54, 2295, 1) | 0, ar = e[5996], e[5996] = 0, (ar | 0) == 1)
                                    break r;
                                  if (!(u & p)) {
                                    if (p = 0, e[5996] = 0, ar = pi(54, 2278, 1) | 0, Ln = e[5996], e[5996] = 0, (Ln | 0) == 1)
                                      break r;
                                    if (!((A ^ -1) & ar))
                                      break l;
                                  }
                                  if (e[5996] = 0, p = pi(54, 2278, 1) | 0, ar = e[5996], e[5996] = 0, (ar | 0) == 1)
                                    break r;
                                  if (!(u & p)) {
                                    if (p = 0, e[5996] = 0, ar = pi(54, 2295, 1) | 0, Ln = e[5996], e[5996] = 0, (Ln | 0) == 1)
                                      break r;
                                    if (!((A ^ -1) & ar))
                                      break l;
                                  }
                                  if (e[5996] = 0, p = pi(54, 2174, 1) | 0, ar = e[5996], e[5996] = 0, (ar | 0) == 1)
                                    break r;
                                  if (!(u & p)) {
                                    if (p = 0, e[5996] = 0, ar = pi(54, 2170, 1) | 0, Ln = e[5996], e[5996] = 0, (Ln | 0) == 1)
                                      break r;
                                    if (!((A ^ -1) & ar))
                                      break l;
                                  }
                                  if (e[5996] = 0, p = pi(54, 2170, 1) | 0, ar = e[5996], e[5996] = 0, (ar | 0) == 1)
                                    break r;
                                  if (!(u & p)) {
                                    if (p = 0, e[5996] = 0, ar = pi(54, 2174, 1) | 0, Ln = e[5996], e[5996] = 0, (Ln | 0) == 1)
                                      break r;
                                    if (!((A ^ -1) & ar))
                                      break l;
                                  }
                                  p = s;
                                }
                                s = A & vr, A = s | W, s = Te & go | (N & mi & vr | (Hi | (r | (vr & Ni | (s & Us | (_r & hi | (u & fr ? 0 : s & Ji)) | (bs & (A ^ -1) ? 0 : A & _n) | m) | Xe)))) | p;
                                break n;
                              }
                              u = 8, p = 2144;
                            }
                            if (e[5996] = 0, s = pi(54, p | 0, u | 0) | 0, r = e[5996], e[5996] = 0, (r | 0) != 1)
                              break n;
                            break r;
                          }
                          if (p = 0, e[5996] = 0, Xe = 1, u = pi(54, 2165, 1) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1)
                            break r;
                          s: {
                            if ((Te | 0) == (hs | 0)) {
                              r = 1, W = 0;
                              break s;
                            }
                            if (m = e[hs >> 2], s = 0, e[5996] = 0, r = pi(54, 1293, 3) | 0, A = e[5996], e[5996] = 0, (A | 0) == 1)
                              break r;
                            if (A = m ^ -1, A & r)
                              break n;
                            if (e[5996] = 0, N = pi(54, 2451, 1) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1 || (e[5996] = 0, W = pi(54, 2049, 1) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[5996] = 0, vr = pi(54, 1681, 1) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[5996] = 0, r = pi(54, 1029, 1) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1))
                              break r;
                            if (r & A) {
                              if (e[5996] = 0, r = pi(54, 1959, 1) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1)
                                break r;
                              p = r & A ? 2 : 1;
                            }
                            if (e[5996] = 0, fr = pi(54, 2167, 4) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1 || (e[5996] = 0, r = pi(54, 2165, 1) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1) || (e[5996] = 0, Xe = pi(54, 2165, 1) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1))
                              break r;
                            s = 0;
                            a: {
                              if (Xe & (u & m ^ -1))
                                break a;
                              o: {
                                if (_r >>> 0 < 2)
                                  break o;
                                if (e[5996] = 0, s = pi(54, 2295, 1) | 0, Xe = e[5996], e[5996] = 0, (Xe | 0) == 1)
                                  break r;
                                if (Xe = u ^ -1, !(Xe & s)) {
                                  if (s = 0, e[5996] = 0, hi = pi(54, 2278, 1) | 0, _n = e[5996], e[5996] = 0, (_n | 0) == 1)
                                    break r;
                                  if (!(A & hi))
                                    break a;
                                }
                                if (e[5996] = 0, s = pi(54, 2278, 1) | 0, hi = e[5996], e[5996] = 0, (hi | 0) == 1)
                                  break r;
                                if (!(s & Xe)) {
                                  if (s = 0, e[5996] = 0, hi = pi(54, 2295, 1) | 0, _n = e[5996], e[5996] = 0, (_n | 0) == 1)
                                    break r;
                                  if (!(A & hi))
                                    break a;
                                }
                                if (e[5996] = 0, s = pi(54, 2174, 1) | 0, hi = e[5996], e[5996] = 0, (hi | 0) == 1)
                                  break r;
                                if (!(s & Xe)) {
                                  if (s = 0, e[5996] = 0, hi = pi(54, 2170, 1) | 0, _n = e[5996], e[5996] = 0, (_n | 0) == 1)
                                    break r;
                                  if (!(A & hi))
                                    break a;
                                }
                                if (e[5996] = 0, s = pi(54, 2170, 1) | 0, hi = e[5996], e[5996] = 0, (hi | 0) == 1)
                                  break r;
                                if (s & Xe)
                                  break o;
                                if (s = 0, e[5996] = 0, Xe = pi(54, 2174, 1) | 0, hi = e[5996], e[5996] = 0, (hi | 0) == 1)
                                  break r;
                                if (!(A & Xe))
                                  break a;
                              }
                              s = r;
                            }
                            if (r = !(A & N), Xe = !(A & W), W = !(A & vr), u = fr & (u | m) | s, s = Te - hs | 0, s >>> 0 < 5)
                              break s;
                            for (s = s >> 2, hi = s >>> 0 <= 2 ? 2 : s, m = 1; ; ) {
                              if (vr = e[(m << 2) + hs >> 2], e[5996] = 0, s = pi(54, 1289, 3) | 0, A = e[5996], e[5996] = 0, (A | 0) == 1)
                                break t;
                              if (Te = vr ^ -1, Te & s) {
                                s = 0;
                                break n;
                              }
                              if (e[5996] = 0, _n = pi(54, 2451, 1) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1 || (e[5996] = 0, bs = pi(54, 2049, 1) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1) || (e[5996] = 0, Us = pi(54, 1681, 1) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1) || (e[5996] = 0, s = pi(54, 1029, 1) | 0, A = e[5996], e[5996] = 0, (A | 0) == 1))
                                break t;
                              if (s & Te) {
                                if (e[5996] = 0, s = pi(54, 1959, 1) | 0, A = e[5996], e[5996] = 0, (A | 0) == 1)
                                  break t;
                                s = s & Te ? 2 : 1;
                              } else
                                s = 0;
                              if (e[5996] = 0, Ni = pi(54, 2167, 4) | 0, A = e[5996], e[5996] = 0, (A | 0) == 1 || (e[5996] = 0, N = pi(54, 2165, 1) | 0, A = e[5996], e[5996] = 0, (A | 0) == 1) || (e[5996] = 0, fr = pi(54, 2165, 1) | 0, A = e[5996], e[5996] = 0, (A | 0) == 1))
                                break t;
                              A = 0;
                              a: {
                                if (fr & (u & vr ^ -1))
                                  break a;
                                o: {
                                  if (_r >>> 0 < 2)
                                    break o;
                                  if (e[5996] = 0, fr = pi(54, 2295, 1) | 0, mi = e[5996], e[5996] = 0, (mi | 0) == 1)
                                    break t;
                                  if (ar = fr, fr = u ^ -1, !(ar & fr)) {
                                    if (e[5996] = 0, mi = pi(54, 2278, 1) | 0, Hi = e[5996], e[5996] = 0, (Hi | 0) == 1)
                                      break t;
                                    if (!(Te & mi))
                                      break a;
                                  }
                                  if (e[5996] = 0, mi = pi(54, 2278, 1) | 0, Hi = e[5996], e[5996] = 0, (Hi | 0) == 1)
                                    break t;
                                  if (!(fr & mi)) {
                                    if (e[5996] = 0, mi = pi(54, 2295, 1) | 0, Hi = e[5996], e[5996] = 0, (Hi | 0) == 1)
                                      break t;
                                    if (!(Te & mi))
                                      break a;
                                  }
                                  if (e[5996] = 0, mi = pi(54, 2174, 1) | 0, Hi = e[5996], e[5996] = 0, (Hi | 0) == 1)
                                    break t;
                                  if (!(fr & mi)) {
                                    if (e[5996] = 0, mi = pi(54, 2170, 1) | 0, Hi = e[5996], e[5996] = 0, (Hi | 0) == 1)
                                      break t;
                                    if (!(Te & mi))
                                      break a;
                                  }
                                  if (e[5996] = 0, mi = pi(54, 2170, 1) | 0, Hi = e[5996], e[5996] = 0, (Hi | 0) == 1)
                                    break t;
                                  if (fr & mi)
                                    break o;
                                  if (e[5996] = 0, fr = pi(54, 2174, 1) | 0, mi = e[5996], e[5996] = 0, (mi | 0) == 1)
                                    break t;
                                  if (!(Te & fr))
                                    break a;
                                }
                                A = N;
                              }
                              if (r = !(Te & _n) & r, Xe = !(Te & bs) & Xe, W = !(Te & Us) + W | 0, p = s + p | 0, u = Ni & (u | vr) | A, m = m + 1 | 0, (hi | 0) == (m | 0))
                                break;
                            }
                          }
                          if (e[5996] = 0, s = pi(54, 1293, 3) | 0, A = e[5996], e[5996] = 0, (A | 0) == 1 || (e[5996] = 0, A = pi(54, 1029, 1) | 0, m = e[5996], e[5996] = 0, (m | 0) == 1) || (e[5996] = 0, m = pi(54, 1959, 1) | 0, N = e[5996], e[5996] = 0, (N | 0) == 1) || (e[5996] = 0, N = pi(54, 2451, 1) | 0, Te = e[5996], e[5996] = 0, (Te | 0) == 1) || (e[5996] = 0, Te = pi(54, 2049, 1) | 0, vr = e[5996], e[5996] = 0, (vr | 0) == 1) || (e[5996] = 0, vr = pi(54, 1681, 1) | 0, fr = e[5996], e[5996] = 0, (fr | 0) == 1))
                            break r;
                          s = s | u | (p ? 0 : A) | ((p | 0) == 1 ? m : 0) | (r && (W | 0) == (Ji | 0) ? N : 0), u = r & Xe ? Te : 0, r = Ji - _r | 0, s = s | (r >>> 0 <= W >>> 0 ? u : 0) | (r + 1 >>> 0 <= W >>> 0 ? vr : 0);
                        }
                        if (e[5996] = 0, u = pi(54, 3310, 1) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1 || (e[5996] = 0, A = pi(54, 2796, 1) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[5996] = 0, p = pi(54, 3557, 1) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[5996] = 0, Xe = pi(54, 2777, 1) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1))
                          break r;
                        m = 2356, r = 19, N = 4075;
                        n: {
                          s:
                            switch (fr = A, A = s ^ -1, u = ((!(fr & A) + !(u & A) | 0) + !(A & p) | 0) + !(A & Xe) | 0, u | 0) {
                              case 0:
                                break n;
                              case 1:
                                break s;
                              default:
                                break i;
                            }
                          if (e[5996] = 0, r = pi(54, 1029, 1) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1)
                            break r;
                          s: {
                            if (r & A)
                              break s;
                            if (e[5996] = 0, r = pi(54, 1959, 1) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1)
                              break r;
                            if (r & A)
                              break s;
                            r = 20, N = 4494;
                            break i;
                          }
                          if (e[5996] = 0, r = pi(54, 2029, 1) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1)
                            break r;
                          s: {
                            if (r & A)
                              break s;
                            if (e[5996] = 0, r = pi(54, 1029, 1) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1)
                              break r;
                            if (r & A)
                              break s;
                            r = 21, N = 4356;
                            break i;
                          }
                          if (e[5996] = 0, r = pi(54, 2029, 1) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1)
                            break r;
                          s: {
                            if (r & A)
                              break s;
                            if (e[5996] = 0, r = pi(54, 2777, 1) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1)
                              break r;
                            if (r & A)
                              break s;
                            r = 22, N = 4771;
                            break i;
                          }
                          if (e[5996] = 0, r = pi(54, 2796, 1) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1)
                            break r;
                          s: {
                            if (r & A)
                              break s;
                            if (e[5996] = 0, r = pi(54, 2522, 1) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1)
                              break r;
                            if (r & A)
                              break s;
                            r = 23, N = 4702;
                            break i;
                          }
                          if (e[5996] = 0, r = pi(54, 3310, 1) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1)
                            break r;
                          s: {
                            if (r & A)
                              break s;
                            if (e[5996] = 0, r = pi(54, 1295, 1) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1)
                              break r;
                            if (!(r & A))
                              break s;
                            r = 24, N = 4426;
                            break i;
                          }
                          if (e[5996] = 0, r = pi(54, 2796, 1) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1)
                            break r;
                          s: {
                            if (r & A)
                              break s;
                            if (e[5996] = 0, r = pi(54, 1295, 1) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1)
                              break r;
                            if (r & A)
                              break s;
                            r = 25, N = 4391;
                            break i;
                          }
                          if (e[5996] = 0, r = pi(54, 2451, 1) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1)
                            break r;
                          s: {
                            if (r & A)
                              break s;
                            if (e[5996] = 0, r = pi(54, 2315, 1) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1)
                              break r;
                            if (r & A)
                              break s;
                            r = 26, N = 4563;
                            break i;
                          }
                          if (e[5996] = 0, r = pi(54, 2451, 1) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1)
                            break r;
                          s: {
                            if (r & A)
                              break s;
                            if (e[5996] = 0, r = pi(54, 2522, 1) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1)
                              break r;
                            if (!(r & A))
                              break s;
                            r = 27, N = 4737;
                            break i;
                          }
                          if (e[5996] = 0, r = pi(54, 2796, 1) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1)
                            break r;
                          s: {
                            if (r & A)
                              break s;
                            if (e[5996] = 0, r = pi(54, 2451, 1) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1)
                              break r;
                            if (r & A)
                              break s;
                            r = 28, N = 4667;
                            break i;
                          }
                          if (e[5996] = 0, r = pi(54, 2522, 1) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1)
                            break r;
                          s: {
                            if (r & A)
                              break s;
                            if (e[5996] = 0, r = pi(54, 2315, 1) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1)
                              break r;
                            if (r & A)
                              break s;
                            r = 29, N = 4598;
                            break i;
                          }
                          if (e[5996] = 0, r = pi(54, 2796, 1) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1)
                            break r;
                          s: {
                            if (r & A)
                              break s;
                            if (e[5996] = 0, r = pi(54, 2315, 1) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1)
                              break r;
                            if (!(r & A))
                              break s;
                            r = 30, N = 4633;
                            break i;
                          }
                          if (e[5996] = 0, r = pi(54, 3310, 1) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1)
                            break r;
                          s: {
                            if (r & A)
                              break s;
                            if (e[5996] = 0, r = pi(54, 1681, 1) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1)
                              break r;
                            if (!(r & A))
                              break s;
                            r = 31, N = 4460;
                            break i;
                          }
                          if (e[5996] = 0, r = pi(54, 1029, 1) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1)
                            break r;
                          if (r & A) {
                            u = s;
                            break n;
                          }
                          if (e[5996] = 0, r = pi(54, 2049, 1) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1)
                            break r;
                          if (u = s, !(r & A))
                            break n;
                          r = 32, N = 4529;
                          break i;
                        }
                        return hs && Br(hs), u | 0;
                      }
                      if (e[5996] = 0, Vs(44, N | 0, 1859, r | 0, m | 0), r = e[5996], e[5996] = 0, (r | 0) != 1)
                        break e;
                    }
                  }
                  r = Hr() | 0, hs && Br(hs), Jn(r | 0), Oi();
                }
                Oi();
              }
              function rf(r, s, u, A, m, p, N, W, Te, Xe, fr) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0, m = m | 0, p = p | 0, N = N | 0, W = W | 0, Te = Te | 0, Xe = Xe | 0, fr = fr | 0;
                var ar = 0, vr = 0, _r = 0, hi = 0, mi = 0, Ni = 0, Hi = 0, Ji = 0, Ln = 0, _n = 0, hs = 0;
                ar = Jr - 304 | 0, Jr = ar;
                e: {
                  t: {
                    r: {
                      i: {
                        n: {
                          s: {
                            a: {
                              o: {
                                l: {
                                  c: {
                                    d: {
                                      f: {
                                        u: {
                                          g: {
                                            A: {
                                              p: {
                                                m: {
                                                  k: {
                                                    N: {
                                                      if (vr = Fa(r), vr >>> 0 >= 2147483632) {
                                                        if (e[5996] = 0, Nn(2), r = e[5996], e[5996] = 0, (r | 0) == 1)
                                                          break N;
                                                        break e;
                                                      }
                                                      S: {
                                                        if (vr >>> 0 <= 10) {
                                                          _[ar + 155 | 0] = vr, _r = ar + 144 | 0;
                                                          break S;
                                                        }
                                                        if (e[5996] = 0, hi = (vr | 15) + 1 | 0, _r = Mi(3, hi | 0) | 0, mi = e[5996], e[5996] = 0, (mi | 0) == 1)
                                                          break N;
                                                        e[ar + 144 >> 2] = _r, e[ar + 148 >> 2] = vr, e[ar + 152 >> 2] = hi | -2147483648;
                                                      }
                                                      _[so(_r, r, vr) + vr | 0] = 0, Ni = e[ar + 144 >> 2], r = me[ar + 155 | 0], Hi = r << 24 >> 24, vr = (Hi | 0) < 0, mi = vr ? Ni : ar + 144 | 0, Ji = vr ? e[ar + 148 >> 2] : r, vr = mi + Ji | 0, _r = -1;
                                                      S: {
                                                        for (; ; ) {
                                                          if ((vr | 0) == (mi | 0))
                                                            break S;
                                                          if (vr = vr - 1 | 0, hi = me[vr | 0], hs = hi >>> 0 <= 63, r = hi & 31, (hi & 63) >>> 0 >= 32 ? (hi = 1 << r, Ln = 0) : (Ln = 1 << r, hi = Ln - 1 & 1 >>> 32 - r), r = Ln & 9728, !(hs & (hi & 1 | (r | 0) != 0)))
                                                            break;
                                                        }
                                                        _r = vr - mi | 0;
                                                      }
                                                      if (r = _r + 1 | 0, r >>> 0 > Ji >>> 0) {
                                                        if (e[5996] = 0, Nn(108), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                          break e;
                                                        vr = Os(22864) | 0, r = yo;
                                                        break u;
                                                      }
                                                      S: {
                                                        if ((Hi | 0) < 0) {
                                                          e[ar + 148 >> 2] = r;
                                                          break S;
                                                        }
                                                        _[ar + 155 | 0] = r, Ni = ar + 144 | 0;
                                                      }
                                                      _[r + Ni | 0] = 0, e[ar + 12 >> 2] = 0, e[ar + 16 >> 2] = 0;
                                                      S: {
                                                        if (_[ar + 155 | 0] >= 0) {
                                                          e[ar + 120 >> 2] = e[ar + 152 >> 2], r = e[ar + 148 >> 2], e[ar + 112 >> 2] = e[ar + 144 >> 2], e[ar + 116 >> 2] = r;
                                                          break S;
                                                        }
                                                        if (e[5996] = 0, gs(40, ar + 112 | 0, e[ar + 144 >> 2], e[ar + 148 >> 2]), r = e[5996], e[5996] = 0, (r | 0) == 1)
                                                          break k;
                                                      }
                                                      if (e[5996] = 0, vr = ar + 128 | 0, ji(109, vr | 0, ar + 112 | 0), r = e[5996], e[5996] = 0, (r | 0) == 1)
                                                        break m;
                                                      _r = _[ar + 139 | 0], r = (_r | 0) < 0, e[ar + 180 >> 2] = r ? e[ar + 132 >> 2] : _r & 255, e[ar + 176 >> 2] = r ? e[ar + 128 >> 2] : vr, e[5996] = 0, ji(29, ar + 248 | 0, ar + 176 | 0), r = e[5996], e[5996] = 0;
                                                      S: {
                                                        T: {
                                                          v: {
                                                            w: {
                                                              if ((r | 0) != 1) {
                                                                if (!e[ar + 180 >> 2])
                                                                  break w;
                                                                e[ar + 240 >> 2] = 0, e[ar + 244 >> 2] = 0, e[ar + 232 >> 2] = 0, e[ar + 236 >> 2] = 0, e[ar + 224 >> 2] = 0, e[ar + 228 >> 2] = 0, e[ar + 216 >> 2] = 0, e[ar + 220 >> 2] = 0, e[ar + 208 >> 2] = 0, e[ar + 212 >> 2] = 0, e[ar + 200 >> 2] = 0, e[ar + 204 >> 2] = 0, e[ar + 192 >> 2] = 0, e[ar + 196 >> 2] = 0;
                                                                break v;
                                                              }
                                                              if (vr = ku(22528, 22864) | 0, r = yo, (r | 0) != (Ml(22528) | 0))
                                                                break S;
                                                              if (Cu(vr | 0) | 0, e[ar + 240 >> 2] = 0, e[ar + 244 >> 2] = 0, e[ar + 232 >> 2] = 0, e[ar + 236 >> 2] = 0, e[ar + 224 >> 2] = 0, e[ar + 228 >> 2] = 0, e[ar + 216 >> 2] = 0, e[ar + 220 >> 2] = 0, e[ar + 208 >> 2] = 0, e[ar + 212 >> 2] = 0, e[ar + 200 >> 2] = 0, e[ar + 204 >> 2] = 0, e[ar + 192 >> 2] = 0, e[ar + 196 >> 2] = 0, e[5996] = 0, Nn(110), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                break T;
                                                              vr = Os(22864) | 0, r = yo;
                                                              break S;
                                                            }
                                                            r = e[ar + 260 >> 2], vr = e[ar + 264 >> 2], e[ar + 260 >> 2] = 0, e[ar + 264 >> 2] = 0, e[ar + 204 >> 2] = r, e[ar + 208 >> 2] = vr, r = e[ar + 268 >> 2], vr = e[ar + 272 >> 2], e[ar + 268 >> 2] = 0, e[ar + 272 >> 2] = 0, e[ar + 212 >> 2] = r, e[ar + 216 >> 2] = vr, e[ar + 228 >> 2] = e[ar + 284 >> 2], r = e[ar + 288 >> 2], e[ar + 284 >> 2] = 0, e[ar + 288 >> 2] = 0, e[ar + 192 >> 2] = e[ar + 248 >> 2], vr = e[ar + 252 >> 2], _r = e[ar + 256 >> 2], e[ar + 252 >> 2] = 0, e[ar + 256 >> 2] = 0, e[ar + 196 >> 2] = vr, e[ar + 200 >> 2] = _r, vr = e[ar + 280 >> 2], e[ar + 220 >> 2] = e[ar + 276 >> 2], e[ar + 224 >> 2] = vr, e[ar + 276 >> 2] = 0, e[ar + 280 >> 2] = 0, e[ar + 232 >> 2] = r, e[ar + 236 >> 2] = e[ar + 292 >> 2], e[ar + 292 >> 2] = 0, r = e[ar + 296 >> 2], e[ar + 296 >> 2] = 0, e[ar + 240 >> 2] = r, e[ar + 244 >> 2] = e[ar + 300 >> 2];
                                                          }
                                                          Ma(ar + 248 | 0);
                                                        }
                                                        if (!e[ar + 192 >> 2]) {
                                                          _r = 0;
                                                          break A;
                                                        }
                                                        e[ar + 184 >> 2] = 0, e[ar + 176 >> 2] = 0, e[ar + 180 >> 2] = 0, e[ar + 256 >> 2] = 0, e[ar + 260 >> 2] = 0, e[5996] = 0, e[ar + 248 >> 2] = 0, e[ar + 252 >> 2] = 0, e[ar + 264 >> 2] = 1065353216, hi = xn(111, ar + 192 | 0, ar + 248 | 0, ar + 176 | 0) | 0, r = e[5996], e[5996] = 0;
                                                        T: {
                                                          if ((r | 0) != 1) {
                                                            if (vr = e[ar + 256 >> 2], vr)
                                                              for (; r = e[vr >> 2], Br(vr), vr = r, !!r; )
                                                                ;
                                                            r = e[ar + 248 >> 2], _r = 0, e[ar + 248 >> 2] = 0, r && Br(r);
                                                            v: {
                                                              w: {
                                                                if (hi) {
                                                                  if (e[ar + 252 >> 2] = 0, e[ar + 256 >> 2] = 0, e[5996] = 0, e[ar + 248 >> 2] = ar + 252, r = Cf(50, hi | 0, 1, 0, ar + 248 | 0) | 0, vr = e[5996], e[5996] = 0, (vr | 0) == 1)
                                                                    break w;
                                                                  e[5996] = 0, vr = pi(54, 1639, 3) | 0, _r = e[5996], e[5996] = 0;
                                                                  E: {
                                                                    h: {
                                                                      R: {
                                                                        I: {
                                                                          if ((_r | 0) == 1 || (_r = e[r >> 2], r = e[r + 4 >> 2], e[5996] = 0, uu(51, ar + 160 | 0, _r | 0, r | 0, vr | 0, 0), r = e[5996], e[5996] = 0, (r | 0) == 1))
                                                                            break I;
                                                                          if (vr = e[ar + 164 >> 2], _r = e[ar + 160 >> 2], hi = vr - _r | 0, (hi | 0) != 32)
                                                                            break R;
                                                                          vr = e[_r >> 2], mi = e[_r + 4 >> 2], e[_r >> 2] = 0, e[_r + 4 >> 2] = 0, r = e[ar + 16 >> 2], e[ar + 12 >> 2] = vr, e[ar + 16 >> 2] = mi;
                                                                          B: {
                                                                            if (!r || (vr = e[r + 4 >> 2], e[r + 4 >> 2] = vr - 1, vr))
                                                                              break B;
                                                                            xi[e[e[r >> 2] + 8 >> 2]](r), ys(r);
                                                                          }
                                                                          _r = e[ar + 160 >> 2], _n = jn[_r + 8 >> 3], vr = e[ar + 164 >> 2];
                                                                          break h;
                                                                        }
                                                                        vr = Os(22864) | 0;
                                                                        break v;
                                                                      }
                                                                      if (!_r)
                                                                        break E;
                                                                    }
                                                                    if ((vr | 0) != (_r | 0)) {
                                                                      for (; ; ) {
                                                                        vr = vr - 32 | 0, r = e[vr + 4 >> 2];
                                                                        h: {
                                                                          if (!r || (mi = e[r + 4 >> 2], e[r + 4 >> 2] = mi - 1, mi))
                                                                            break h;
                                                                          xi[e[e[r >> 2] + 8 >> 2]](r), ys(r);
                                                                        }
                                                                        if ((vr | 0) == (_r | 0))
                                                                          break;
                                                                      }
                                                                      vr = e[ar + 160 >> 2];
                                                                    }
                                                                    e[ar + 164 >> 2] = _r, Br(vr);
                                                                  }
                                                                  ml(e[ar + 252 >> 2]), _r = (hi | 0) == 32;
                                                                }
                                                                if (r = e[ar + 176 >> 2], !r)
                                                                  break A;
                                                                if (vr = e[ar + 180 >> 2], (r | 0) != (vr | 0)) {
                                                                  for (; vr = vr - 4 | 0, wl(vr), (r | 0) != (vr | 0); )
                                                                    ;
                                                                  r = e[ar + 176 >> 2];
                                                                }
                                                                Br(r);
                                                                break A;
                                                              }
                                                              vr = Os(22864) | 0;
                                                            }
                                                            r = yo, ml(e[ar + 252 >> 2]);
                                                            break T;
                                                          }
                                                          if (vr = Os(22864) | 0, r = yo, W = e[ar + 256 >> 2], W)
                                                            for (; Te = e[W >> 2], Br(W), W = Te, !!W; )
                                                              ;
                                                          W = e[ar + 248 >> 2], e[ar + 248 >> 2] = 0, W && Br(W);
                                                        }
                                                        if (W = e[ar + 176 >> 2], W) {
                                                          if (Xe = e[ar + 180 >> 2], Te = W, (Xe | 0) != (W | 0)) {
                                                            for (; Xe = Xe - 4 | 0, wl(Xe), (W | 0) != (Xe | 0); )
                                                              ;
                                                            Te = e[ar + 176 >> 2];
                                                          }
                                                          e[ar + 180 >> 2] = W, Br(Te);
                                                        }
                                                        Ma(ar + 192 | 0);
                                                      }
                                                      if (_[ar + 139 | 0] >= 0)
                                                        break p;
                                                      Br(e[ar + 128 >> 2]);
                                                      break p;
                                                    }
                                                    vr = Os(22864) | 0, r = yo;
                                                    break f;
                                                  }
                                                  vr = Os(22864) | 0, r = yo;
                                                  break g;
                                                }
                                                vr = Os(22864) | 0, r = yo;
                                              }
                                              if (_[ar + 123 | 0] >= 0)
                                                break g;
                                              Br(e[ar + 112 >> 2]);
                                              break g;
                                            }
                                            Ma(ar + 192 | 0), _[ar + 139 | 0] < 0 && Br(e[ar + 128 >> 2]), _[ar + 123 | 0] < 0 && Br(e[ar + 112 >> 2]);
                                            A: {
                                              p: {
                                                m: {
                                                  k: {
                                                    N: {
                                                      S: {
                                                        T: {
                                                          v: {
                                                            if (!_r) {
                                                              e[5996] = 0, r = Mi(3, 16) | 0, W = e[5996], e[5996] = 0;
                                                              w: {
                                                                E: {
                                                                  if ((W | 0) != 1) {
                                                                    if (_[r + 15 | 0] = 0, W = me[2587] | me[2588] << 8 | (me[2589] << 16 | me[2590] << 24), Te = me[2583] | me[2584] << 8 | (me[2585] << 16 | me[2586] << 24), _[r + 7 | 0] = Te, _[r + 8 | 0] = Te >>> 8, _[r + 9 | 0] = Te >>> 16, _[r + 10 | 0] = Te >>> 24, _[r + 11 | 0] = W, _[r + 12 | 0] = W >>> 8, _[r + 13 | 0] = W >>> 16, _[r + 14 | 0] = W >>> 24, W = me[2580] | me[2581] << 8 | (me[2582] << 16 | me[2583] << 24), Te = me[2576] | me[2577] << 8 | (me[2578] << 16 | me[2579] << 24), _[r | 0] = Te, _[r + 1 | 0] = Te >>> 8, _[r + 2 | 0] = Te >>> 16, _[r + 3 | 0] = Te >>> 24, _[r + 4 | 0] = W, _[r + 5 | 0] = W >>> 8, _[r + 6 | 0] = W >>> 16, _[r + 7 | 0] = W >>> 24, W = ((u | 0) >= 16 ? 16 : u) - 1 | 0, _[so(s, r, W) + W | 0] = 0, Br(r), e[5996] = 0, fr = Mi(3, 16) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1)
                                                                      break E;
                                                                    if (_[fr + 15 | 0] = 0, W = me[2587] | me[2588] << 8 | (me[2589] << 16 | me[2590] << 24), Te = W, r = me[2583] | me[2584] << 8 | (me[2585] << 16 | me[2586] << 24), _[fr + 7 | 0] = r, _r = r >>> 8 | 0, _[fr + 8 | 0] = _r, hi = r >>> 16 | 0, _[fr + 9 | 0] = hi, mi = r >>> 24 | 0, _[fr + 10 | 0] = mi, _[fr + 11 | 0] = W, _[fr + 12 | 0] = W >>> 8, _[fr + 13 | 0] = W >>> 16, _[fr + 14 | 0] = W >>> 24, Xe = me[2580] | me[2581] << 8 | (me[2582] << 16 | me[2583] << 24), W = me[2576] | me[2577] << 8 | (me[2578] << 16 | me[2579] << 24), _[fr | 0] = W, _[fr + 1 | 0] = W >>> 8, _[fr + 2 | 0] = W >>> 16, _[fr + 3 | 0] = W >>> 24, _[fr + 4 | 0] = Xe, _[fr + 5 | 0] = Xe >>> 8, _[fr + 6 | 0] = Xe >>> 16, _[fr + 7 | 0] = Xe >>> 24, vr = ((m | 0) >= 16 ? 16 : m) - 1 | 0, _[so(A, fr, vr) + vr | 0] = 0, Br(fr), e[5996] = 0, fr = Mi(3, 16) | 0, vr = e[5996], e[5996] = 0, (vr | 0) == 1)
                                                                      break w;
                                                                    _[fr + 15 | 0] = 0, _[fr + 7 | 0] = r, _[fr + 8 | 0] = _r, _[fr + 9 | 0] = hi, _[fr + 10 | 0] = mi, r = Te, _[fr + 11 | 0] = r, _[fr + 12 | 0] = r >>> 8, _[fr + 13 | 0] = r >>> 16, _[fr + 14 | 0] = r >>> 24, _[fr | 0] = W, _[fr + 1 | 0] = W >>> 8, _[fr + 2 | 0] = W >>> 16, _[fr + 3 | 0] = W >>> 24, r = Xe, _[fr + 4 | 0] = r, _[fr + 5 | 0] = r >>> 8, _[fr + 6 | 0] = r >>> 16, _[fr + 7 | 0] = r >>> 24, r = ((N | 0) >= 16 ? 16 : N) - 1 | 0, _[so(p, fr, r) + r | 0] = 0, Br(fr);
                                                                    break v;
                                                                  }
                                                                  vr = Os(22864) | 0, r = yo;
                                                                  break g;
                                                                }
                                                                vr = Os(22864) | 0, r = yo;
                                                                break g;
                                                              }
                                                              vr = Os(22864) | 0, r = yo;
                                                              break g;
                                                            }
                                                            if (e[5996] = 0, r = e[ar + 12 >> 2], e[ar + 200 >> 2] = 0, e[ar + 192 >> 2] = 0, e[ar + 196 >> 2] = 0, mi = Mi(3, 12) | 0, vr = e[5996], e[5996] = 0, (vr | 0) == 1)
                                                              break A;
                                                            _[mi + 8 | 0] = 0, e[mi + 4 >> 2] = 0, e[mi >> 2] = r, vr = mi + 12 | 0, Ln = vr;
                                                            w: {
                                                              E: {
                                                                h: {
                                                                  for (; ; ) {
                                                                    R: {
                                                                      Hi = vr - 12 | 0, hi = e[Hi + 4 >> 2], r = e[Hi >> 2], _r = e[r + 32 >> 2], Ji = e[r + 36 >> 2] - _r >> 3;
                                                                      I: {
                                                                        if (Ji >>> 0 > hi >>> 0) {
                                                                          Ji = 1, e[Hi + 4 >> 2] = hi + 1, r = e[r >> 2];
                                                                          B: {
                                                                            if (r - 10 >>> 0 < 7)
                                                                              break B;
                                                                            x:
                                                                              switch (r - 17 | 0) {
                                                                                case 0:
                                                                                  Ji = e[e[_r + 8 >> 2] >> 2] == 1;
                                                                                  break B;
                                                                                case 5:
                                                                                  if (!e[e[_r >> 2] >> 2])
                                                                                    break B;
                                                                                  Ji = !e[e[_r + 8 >> 2] >> 2];
                                                                                  break B;
                                                                                default:
                                                                                  break x;
                                                                              }
                                                                            Ji = 0;
                                                                          }
                                                                          if (r = e[_r + (hi << 3) >> 2], vr >>> 0 < Ln >>> 0) {
                                                                            _[vr + 8 | 0] = Ji, e[vr + 4 >> 2] = 0, e[vr >> 2] = r, vr = vr + 12 | 0;
                                                                            break I;
                                                                          }
                                                                          B: {
                                                                            Hi = (vr - mi | 0) / 12 | 0, _r = Hi + 1 | 0;
                                                                            x: {
                                                                              if (_r >>> 0 >= 357913942) {
                                                                                e[5996] = 0, Nn(112);
                                                                                break x;
                                                                              }
                                                                              if (hi = (Ln - mi | 0) / 12 | 0, Ni = hi << 1, _r = hi >>> 0 >= 178956970 ? 357913941 : _r >>> 0 < Ni >>> 0 ? Ni : _r, _r >>> 0 < 357913942)
                                                                                break B;
                                                                              e[5996] = 0, Nn(35);
                                                                            }
                                                                            if (r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                              break e;
                                                                            vr = Os(22864) | 0;
                                                                            break m;
                                                                          }
                                                                          if (e[5996] = 0, Ni = Sn(_r, 12), hi = Mi(3, Ni | 0) | 0, _r = e[5996], e[5996] = 0, (_r | 0) == 1)
                                                                            break k;
                                                                          if (_r = hi + Sn(Hi, 12) | 0, _[_r + 8 | 0] = Ji, e[_r + 4 >> 2] = 0, e[_r >> 2] = r, r = _r, (vr | 0) != (mi | 0))
                                                                            for (; vr = vr - 12 | 0, Hi = e[vr + 4 >> 2], r = r - 12 | 0, e[r >> 2] = e[vr >> 2], e[r + 4 >> 2] = Hi, e[r + 8 >> 2] = e[vr + 8 >> 2], (vr | 0) != (mi | 0); )
                                                                              ;
                                                                          Ln = hi + Ni | 0, vr = _r + 12 | 0, mi && Br(mi), mi = r;
                                                                          break I;
                                                                        }
                                                                        if (Ni = e[ar + 192 >> 2], _r = (e[ar + 196 >> 2] - Ni | 0) / 12 | 0, _r >>> 0 < Ji >>> 0) {
                                                                          if (e[5996] = 0, Vs(44, 5135, 2210, 439, 2439), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                            break e;
                                                                          vr = Os(22864) | 0;
                                                                          break m;
                                                                        }
                                                                        vr = me[vr - 4 | 0], e[5996] = 0, uu(113, ar + 248 | 0, vr | 0, r | 0, (Sn(_r, 12) + Ni | 0) + Sn(Ji, -12) | 0, Ji | 0), vr = e[5996], e[5996] = 0;
                                                                        B: {
                                                                          if ((vr | 0) != 1) {
                                                                            if (me[ar + 260 | 0])
                                                                              break B;
                                                                            Ji = 0;
                                                                            break w;
                                                                          }
                                                                          vr = Os(22864) | 0;
                                                                          break m;
                                                                        }
                                                                        _r = e[ar + 196 >> 2], vr = e[r + 36 >> 2] - e[r + 32 >> 2] >> 3, r = e[ar + 192 >> 2], hi = ((_r + Sn(vr, -12) | 0) - r | 0) / 12 | 0;
                                                                        B: {
                                                                          if (!Sn(vr, -12)) {
                                                                            vr = _r;
                                                                            break B;
                                                                          }
                                                                          if (hi = r + Sn(hi, 12) | 0, r = hi, vr = r + Sn((Sn(vr, 12) | 0) / 12 | 0, 12) | 0, (_r | 0) != (vr | 0)) {
                                                                            for (; _[r + 11 | 0] < 0 && Br(e[r >> 2]), Ni = e[vr + 4 >> 2], e[r >> 2] = e[vr >> 2], e[r + 4 >> 2] = Ni, e[r + 8 >> 2] = e[vr + 8 >> 2], _[vr + 11 | 0] = 0, _[vr | 0] = 0, r = r + 12 | 0, vr = vr + 12 | 0, (_r | 0) != (vr | 0); )
                                                                              ;
                                                                            _r = e[ar + 196 >> 2];
                                                                          }
                                                                          if (vr = hi + Sn((r - hi | 0) / 12 | 0, 12) | 0, (_r | 0) != (vr | 0))
                                                                            for (; r = _r - 12 | 0, _[_r - 1 | 0] < 0 && Br(e[r >> 2]), _r = r, (r | 0) != (vr | 0); )
                                                                              ;
                                                                          e[ar + 196 >> 2] = vr;
                                                                        }
                                                                        hi = e[ar + 200 >> 2];
                                                                        B: {
                                                                          if (hi >>> 0 > vr >>> 0) {
                                                                            r = e[ar + 252 >> 2], e[vr >> 2] = e[ar + 248 >> 2], e[vr + 4 >> 2] = r, e[vr + 8 >> 2] = e[ar + 256 >> 2], e[ar + 256 >> 2] = 0, e[ar + 248 >> 2] = 0, e[ar + 252 >> 2] = 0, e[ar + 196 >> 2] = vr + 12;
                                                                            break B;
                                                                          }
                                                                          x: {
                                                                            b: {
                                                                              _r = e[ar + 192 >> 2], Ji = (vr - _r | 0) / 12 | 0, r = Ji + 1 | 0;
                                                                              C: {
                                                                                if (r >>> 0 >= 357913942) {
                                                                                  e[5996] = 0, Nn(41);
                                                                                  break C;
                                                                                }
                                                                                if (hi = (hi - _r | 0) / 12 | 0, Ni = hi << 1, Ni = hi >>> 0 >= 178956970 ? 357913941 : r >>> 0 < Ni >>> 0 ? Ni : r, !Ni) {
                                                                                  hi = 0;
                                                                                  break x;
                                                                                }
                                                                                if (Ni >>> 0 < 357913942)
                                                                                  break b;
                                                                                e[5996] = 0, Nn(35);
                                                                              }
                                                                              if (r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                                break e;
                                                                              vr = Os(22864) | 0;
                                                                              break h;
                                                                            }
                                                                            if (e[5996] = 0, hi = Mi(3, Sn(Ni, 12) | 0) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1)
                                                                              break R;
                                                                          }
                                                                          r = Sn(Ji, 12) + hi | 0, Ji = e[ar + 252 >> 2], e[r >> 2] = e[ar + 248 >> 2], e[r + 4 >> 2] = Ji, e[r + 8 >> 2] = e[ar + 256 >> 2], e[ar + 256 >> 2] = 0, e[ar + 248 >> 2] = 0, e[ar + 252 >> 2] = 0, hi = Sn(Ni, 12) + hi | 0, Ni = r + 12 | 0;
                                                                          x: {
                                                                            if ((vr | 0) == (_r | 0)) {
                                                                              e[ar + 200 >> 2] = hi, e[ar + 196 >> 2] = Ni, e[ar + 192 >> 2] = r;
                                                                              break x;
                                                                            }
                                                                            for (; vr = vr - 12 | 0, Ji = e[vr + 4 >> 2], r = r - 12 | 0, e[r >> 2] = e[vr >> 2], e[r + 4 >> 2] = Ji, e[r + 8 >> 2] = e[vr + 8 >> 2], e[vr >> 2] = 0, e[vr + 4 >> 2] = 0, e[vr + 8 >> 2] = 0, (vr | 0) != (_r | 0); )
                                                                              ;
                                                                            if (e[ar + 200 >> 2] = hi, _r = e[ar + 196 >> 2], e[ar + 196 >> 2] = Ni, vr = e[ar + 192 >> 2], e[ar + 192 >> 2] = r, (vr | 0) == (_r | 0))
                                                                              break x;
                                                                            for (; r = _r - 12 | 0, _[_r - 1 | 0] < 0 && Br(e[r >> 2]), _r = r, (r | 0) != (vr | 0); )
                                                                              ;
                                                                          }
                                                                          if (!vr)
                                                                            break B;
                                                                          Br(vr);
                                                                        }
                                                                        !me[ar + 260 | 0] | _[ar + 259 | 0] >= 0 || Br(e[ar + 248 >> 2]), vr = Hi;
                                                                      }
                                                                      if ((vr | 0) != (mi | 0))
                                                                        continue;
                                                                      break E;
                                                                    }
                                                                    break;
                                                                  }
                                                                  vr = Os(22864) | 0;
                                                                }
                                                                if (r = yo, !me[ar + 260 | 0] | _[ar + 259 | 0] >= 0)
                                                                  break p;
                                                                Br(e[ar + 248 >> 2]);
                                                                break p;
                                                              }
                                                              if (r = e[ar + 192 >> 2], (e[ar + 196 >> 2] - r | 0) != 12) {
                                                                if (e[5996] = 0, Vs(44, 4102, 2210, 450, 2439), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                  break e;
                                                                vr = Os(22864) | 0;
                                                                break m;
                                                              }
                                                              Ji = e[r >> 2], e[ar + 160 >> 2] = e[r + 4 >> 2], vr = me[r + 7 | 0] | me[r + 8 | 0] << 8 | (me[r + 9 | 0] << 16 | me[r + 10 | 0] << 24), _[ar + 163 | 0] = vr, _[ar + 164 | 0] = vr >>> 8, _[ar + 165 | 0] = vr >>> 16, _[ar + 166 | 0] = vr >>> 24, e[r >> 2] = 0, e[r + 4 >> 2] = 0, Ni = me[r + 11 | 0], e[r + 8 >> 2] = 0;
                                                            }
                                                            if (_r = e[ar + 192 >> 2], _r) {
                                                              if (r = e[ar + 196 >> 2], vr = _r, (r | 0) != (vr | 0)) {
                                                                for (; vr = r - 12 | 0, _[r - 1 | 0] < 0 && Br(e[vr >> 2]), r = vr, (_r | 0) != (r | 0); )
                                                                  ;
                                                                vr = e[ar + 192 >> 2];
                                                              }
                                                              e[ar + 196 >> 2] = _r, Br(vr);
                                                            }
                                                            mi && Br(mi), r = me[ar + 163 | 0] | me[ar + 164 | 0] << 8 | (me[ar + 165 | 0] << 16 | me[ar + 166 | 0] << 24), _[ar + 103 | 0] = r, _[ar + 104 | 0] = r >>> 8, _[ar + 105 | 0] = r >>> 16, _[ar + 106 | 0] = r >>> 24, e[ar + 100 >> 2] = e[ar + 160 >> 2], e[ar + 96 >> 2] = Ji, e[ar + 160 >> 2] = 0, _[ar + 163 | 0] = 0, _[ar + 164 | 0] = 0, _[ar + 165 | 0] = 0, _[ar + 166 | 0] = 0, _[ar + 107 | 0] = Ni;
                                                            w: {
                                                              E: {
                                                                h: {
                                                                  R: {
                                                                    I: {
                                                                      B: {
                                                                        x: {
                                                                          b: {
                                                                            C: {
                                                                              y: {
                                                                                D: {
                                                                                  P: {
                                                                                    q: {
                                                                                      O: {
                                                                                        Q: {
                                                                                          U: {
                                                                                            F: {
                                                                                              M: {
                                                                                                L: {
                                                                                                  H: {
                                                                                                    K: {
                                                                                                      W: {
                                                                                                        mi = e[ar + 100 >> 2], r = Ni << 24 >> 24 < 0, vr = r ? mi : Ni & 255;
                                                                                                        V: {
                                                                                                          if ((vr | 0) < 72)
                                                                                                            break V;
                                                                                                          for (hi = r ? Ji : ar + 96 | 0, _r = hi + vr | 0; ; ) {
                                                                                                            for (r = hi; ; ) {
                                                                                                              if (r = lu(r, 115, vr - 71 | 0), !r)
                                                                                                                break V;
                                                                                                              if (va(r, 5034, 72)) {
                                                                                                                if (r = r + 1 | 0, vr = _r - r | 0, (vr | 0) >= 72)
                                                                                                                  continue;
                                                                                                                break V;
                                                                                                              }
                                                                                                              break;
                                                                                                            }
                                                                                                            if ((r | 0) == (_r | 0) || (r = r - hi | 0, (r | 0) == -1))
                                                                                                              break V;
                                                                                                            if (e[5996] = 0, vr = ar + 96 | 0, Vs(114, vr | 0, r | 0, 72, 4824), r = e[5996], e[5996] = 0, (r | 0) == 1)
                                                                                                              break W;
                                                                                                            if (Ji = e[ar + 96 >> 2], _r = vr, r = me[ar + 107 | 0], Ni = r << 24 >> 24, vr = (Ni | 0) < 0, hi = vr ? Ji : _r, mi = e[ar + 100 >> 2], vr = vr ? mi : r, _r = hi + vr | 0, !((vr | 0) > 71))
                                                                                                              break;
                                                                                                          }
                                                                                                        }
                                                                                                        V: {
                                                                                                          r = Ni << 24 >> 24, vr = (r | 0) < 0 ? mi : Ni & 255;
                                                                                                          j: {
                                                                                                            if ((vr | 0) < 73)
                                                                                                              break j;
                                                                                                            for (hi = (r | 0) < 0 ? Ji : ar + 96 | 0, _r = hi + vr | 0; ; ) {
                                                                                                              for (r = hi; ; ) {
                                                                                                                if (r = lu(r, 104, vr - 72 | 0), !r)
                                                                                                                  break j;
                                                                                                                if (va(r, 4960, 73)) {
                                                                                                                  if (r = r + 1 | 0, vr = _r - r | 0, (vr | 0) >= 73)
                                                                                                                    continue;
                                                                                                                  break j;
                                                                                                                }
                                                                                                                break;
                                                                                                              }
                                                                                                              if ((r | 0) == (_r | 0) || (r = r - hi | 0, (r | 0) == -1))
                                                                                                                break j;
                                                                                                              if (e[5996] = 0, vr = ar + 96 | 0, Vs(114, vr | 0, r | 0, 73, 4813), r = e[5996], e[5996] = 0, (r | 0) == 1)
                                                                                                                break V;
                                                                                                              if (Ji = e[ar + 96 >> 2], _r = vr, r = me[ar + 107 | 0], Ni = r << 24 >> 24, vr = (Ni | 0) < 0, hi = vr ? Ji : _r, mi = e[ar + 100 >> 2], vr = vr ? mi : r, _r = hi + vr | 0, !((vr | 0) > 72))
                                                                                                                break;
                                                                                                            }
                                                                                                          }
                                                                                                          j: {
                                                                                                            r = Ni << 24 >> 24 < 0, vr = r ? mi : Ni & 255;
                                                                                                            z: {
                                                                                                              if ((vr | 0) < 51)
                                                                                                                break z;
                                                                                                              for (hi = r ? Ji : ar + 96 | 0, _r = hi + vr | 0; ; ) {
                                                                                                                for (r = hi; ; ) {
                                                                                                                  if (r = lu(r, 114, vr - 50 | 0), !r)
                                                                                                                    break z;
                                                                                                                  if (va(r, 4908, 51)) {
                                                                                                                    if (r = r + 1 | 0, vr = _r - r | 0, (vr | 0) >= 51)
                                                                                                                      continue;
                                                                                                                    break z;
                                                                                                                  }
                                                                                                                  break;
                                                                                                                }
                                                                                                                if ((r | 0) == (_r | 0) || (r = r - hi | 0, (r | 0) == -1))
                                                                                                                  break z;
                                                                                                                if (e[5996] = 0, vr = ar + 96 | 0, Vs(114, vr | 0, r | 0, 51, 4845), r = e[5996], e[5996] = 0, (r | 0) == 1)
                                                                                                                  break j;
                                                                                                                if (Ji = e[ar + 96 >> 2], _r = vr, r = me[ar + 107 | 0], Ni = r << 24 >> 24, vr = (Ni | 0) < 0, hi = vr ? Ji : _r, mi = e[ar + 100 >> 2], vr = vr ? mi : r, _r = hi + vr | 0, !((vr | 0) > 50))
                                                                                                                  break;
                                                                                                              }
                                                                                                            }
                                                                                                            z: {
                                                                                                              r = Ni << 24 >> 24, vr = (r | 0) < 0 ? mi : Ni & 255;
                                                                                                              G: {
                                                                                                                if ((vr | 0) < 49)
                                                                                                                  break G;
                                                                                                                for (mi = (r | 0) < 0 ? Ji : ar + 96 | 0, _r = mi + vr | 0; ; ) {
                                                                                                                  for (r = mi; ; ) {
                                                                                                                    if (r = lu(r, 104, vr - 48 | 0), !r)
                                                                                                                      break G;
                                                                                                                    if (va(r, 4858, 49)) {
                                                                                                                      if (r = r + 1 | 0, vr = _r - r | 0, (vr | 0) >= 49)
                                                                                                                        continue;
                                                                                                                      break G;
                                                                                                                    }
                                                                                                                    break;
                                                                                                                  }
                                                                                                                  if ((r | 0) == (_r | 0) || (r = r - mi | 0, (r | 0) == -1))
                                                                                                                    break G;
                                                                                                                  if (e[5996] = 0, vr = ar + 96 | 0, Vs(114, vr | 0, r | 0, 49, 4834), r = e[5996], e[5996] = 0, (r | 0) == 1)
                                                                                                                    break z;
                                                                                                                  if (_r = vr, r = me[ar + 107 | 0], vr = r << 24 >> 24 < 0, mi = vr ? e[ar + 96 >> 2] : _r, vr = vr ? e[ar + 100 >> 2] : r, _r = mi + vr | 0, !((vr | 0) > 48))
                                                                                                                    break;
                                                                                                                }
                                                                                                              }
                                                                                                              e[ar + 184 >> 2] = e[ar + 104 >> 2], e[ar + 104 >> 2] = 0, vr = e[ar + 100 >> 2], r = e[ar + 96 >> 2], e[ar + 176 >> 2] = r, e[ar + 180 >> 2] = vr, e[ar + 96 >> 2] = 0, e[ar + 100 >> 2] = 0, vr = me[ar + 187 | 0], _r = vr << 24 >> 24, hi = (_r | 0) < 0, mi = hi ? r : ar + 176 | 0, vr = hi ? e[ar + 180 >> 2] : vr, hi = u - 1 | 0, vr = (vr | 0) < (hi | 0) ? vr : hi, _[so(s, mi, vr) + vr | 0] = 0;
                                                                                                              G: {
                                                                                                                if ((_r | 0) >= 0 || (Br(r), _[ar + 107 | 0] >= 0))
                                                                                                                  break G;
                                                                                                                Br(e[ar + 96 >> 2]);
                                                                                                              }
                                                                                                              if (r = e[e[ar + 12 >> 2] + 84 >> 2], e[5996] = 0, vr = ar + 36 | 0, ji(115, vr | 0, r | 0), r = e[5996], e[5996] = 0, (r | 0) == 1)
                                                                                                                break H;
                                                                                                              if (e[5996] = 0, r = xn(99, vr | 0, 0, 5442) | 0, vr = e[5996], e[5996] = 0, (vr | 0) == 1)
                                                                                                                break L;
                                                                                                              if (e[ar + 56 >> 2] = e[r + 8 >> 2], vr = e[r + 4 >> 2], e[ar + 48 >> 2] = e[r >> 2], e[ar + 52 >> 2] = vr, e[r >> 2] = 0, e[r + 4 >> 2] = 0, e[r + 8 >> 2] = 0, e[5996] = 0, vr = pi(97, ar + 48 | 0, 5422) | 0, _r = e[5996], e[5996] = 0, (_r | 0) == 1)
                                                                                                                break M;
                                                                                                              if (e[ar + 72 >> 2] = e[vr + 8 >> 2], _r = e[vr + 4 >> 2], e[ar + 64 >> 2] = e[vr >> 2], e[ar + 68 >> 2] = _r, e[vr >> 2] = 0, e[vr + 4 >> 2] = 0, e[vr + 8 >> 2] = 0, e[5996] = 0, _r = ar + 248 | 0, rh(116, _r | 0, +_n), hi = e[5996], e[5996] = 0, (hi | 0) == 1)
                                                                                                                break F;
                                                                                                              if (e[5996] = 0, mi = _r, _r = me[ar + 259 | 0], hi = _r << 24 >> 24 < 0, _r = xn(100, ar - -64 | 0, (hi ? e[ar + 248 >> 2] : mi) | 0, (hi ? e[ar + 252 >> 2] : _r) | 0) | 0, hi = e[5996], e[5996] = 0, (hi | 0) == 1)
                                                                                                                break U;
                                                                                                              if (e[ar + 88 >> 2] = e[_r + 8 >> 2], hi = e[_r + 4 >> 2], e[ar + 80 >> 2] = e[_r >> 2], e[ar + 84 >> 2] = hi, e[_r >> 2] = 0, e[_r + 4 >> 2] = 0, e[_r + 8 >> 2] = 0, e[5996] = 0, hi = pi(97, ar + 80 | 0, 5504) | 0, mi = e[5996], e[5996] = 0, (mi | 0) == 1)
                                                                                                                break Q;
                                                                                                              if (e[ar + 136 >> 2] = e[hi + 8 >> 2], mi = e[hi + 4 >> 2], e[ar + 128 >> 2] = e[hi >> 2], e[ar + 132 >> 2] = mi, e[hi >> 2] = 0, e[hi + 4 >> 2] = 0, e[hi + 8 >> 2] = 0, mi = e[e[ar + 12 >> 2] + 84 >> 2], e[5996] = 0, Hi = ar + 192 | 0, rh(116, Hi | 0, +(_n + +(mi >>> 0))), mi = e[5996], e[5996] = 0, (mi | 0) == 1)
                                                                                                                break O;
                                                                                                              if (e[5996] = 0, Ln = Hi, mi = me[ar + 203 | 0], Hi = mi << 24 >> 24 < 0, mi = xn(100, ar + 128 | 0, (Hi ? e[ar + 192 >> 2] : Ln) | 0, (Hi ? e[ar + 196 >> 2] : mi) | 0) | 0, Hi = e[5996], e[5996] = 0, (Hi | 0) == 1)
                                                                                                                break q;
                                                                                                              if (e[ar + 168 >> 2] = e[mi + 8 >> 2], Hi = e[mi + 4 >> 2], e[ar + 160 >> 2] = e[mi >> 2], e[ar + 164 >> 2] = Hi, e[mi >> 2] = 0, e[mi + 4 >> 2] = 0, e[mi + 8 >> 2] = 0, e[5996] = 0, Hi = pi(97, ar + 160 | 0, 3567) | 0, Ni = e[5996], e[5996] = 0, (Ni | 0) == 1)
                                                                                                                break P;
                                                                                                              if (e[ar + 184 >> 2] = e[Hi + 8 >> 2], Ni = e[Hi + 4 >> 2], e[ar + 176 >> 2] = e[Hi >> 2], e[ar + 180 >> 2] = Ni, e[Hi >> 2] = 0, e[Hi + 4 >> 2] = 0, e[Hi + 8 >> 2] = 0, _[ar + 203 | 0] < 0 && Br(e[ar + 192 >> 2]), _[mi + 11 | 0] < 0 && Br(e[mi >> 2]), _[hi + 11 | 0] < 0 && Br(e[hi >> 2]), _[ar + 259 | 0] < 0 && Br(e[ar + 248 >> 2]), _[_r + 11 | 0] < 0 && Br(e[_r >> 2]), _[vr + 11 | 0] < 0 && Br(e[vr >> 2]), _[r + 11 | 0] < 0 && Br(e[r >> 2]), _r = e[ar + 176 >> 2], r = me[ar + 187 | 0], hi = r << 24 >> 24, vr = (hi | 0) < 0, mi = vr ? _r : ar + 176 | 0, r = vr ? e[ar + 180 >> 2] : r, vr = m - 1 | 0, r = (r | 0) < (vr | 0) ? r : vr, _[so(A, mi, r) + r | 0] = 0, e[5996] = 0, vr = ar + 248 | 0, ji(117, vr | 0, e[ar + 12 >> 2]), r = e[5996], e[5996] = 0, (r | 0) == 1)
                                                                                                                break R;
                                                                                                              if (e[ar + 220 >> 2] = e[ar + 276 >> 2], r = e[ar + 272 >> 2], e[ar + 212 >> 2] = e[ar + 268 >> 2], e[ar + 216 >> 2] = r, r = e[ar + 264 >> 2], e[ar + 204 >> 2] = e[ar + 260 >> 2], e[ar + 208 >> 2] = r, r = e[ar + 256 >> 2], e[ar + 196 >> 2] = e[ar + 252 >> 2], e[ar + 200 >> 2] = r, r = e[ar + 248 >> 2], e[ar + 192 >> 2] = r, e[5996] = 0, mi = r >>> 0 < 29, Hi = mi ? ar + 196 | 0 : e[ar + 200 >> 2], e[ar + 248 >> 2] = Hi, Ni = ar + 24 | 0, Vs(102, Ni | 0, vr | 0, Hi + (mi ? r : r - 29 | 0) | 0, 0), r = e[5996], e[5996] = 0, (r | 0) == 1)
                                                                                                                break h;
                                                                                                              if (r = e[ar + 24 >> 2], vr = me[ar + 35 | 0], mi = vr << 24 >> 24, Hi = (mi | 0) < 0, Ln = Hi ? r : Ni, vr = Hi ? e[ar + 28 >> 2] : vr, Hi = N - 1 | 0, vr = (vr | 0) < (Hi | 0) ? vr : Hi, _[so(p, Ln, vr) + vr | 0] = 0, (mi | 0) < 0 && Br(r), Ls[ar + 192 >> 2] >= 29 && Br(e[ar + 200 >> 2]), r = e[ar + 12 >> 2], vr = e[r + 80 >> 2], !vr | Ls[r + 84 >> 2] > 3600 | (e[r + 52 >> 2] + e[r + 44 >> 2] >>> 0 > 201 | Ls[r + 68 >> 2] > 100))
                                                                                                                break E;
                                                                                                              if (e[5996] = 0, mi = pi(54, 2049, 1) | 0, Hi = e[5996], e[5996] = 0, (Hi | 0) == 1)
                                                                                                                break T;
                                                                                                              if ((vr ^ -1) & mi)
                                                                                                                break E;
                                                                                                              if (vr = e[r + 80 >> 2], e[5996] = 0, mi = pi(54, 2165, 1) | 0, Hi = e[5996], e[5996] = 0, (Hi | 0) == 1)
                                                                                                                break T;
                                                                                                              if (me[r + 88 | 0] | (vr ^ -1) & mi)
                                                                                                                break E;
                                                                                                              _[ar + 252 | 0] = 0, e[ar + 248 >> 2] = 1702195828, _[ar + 259 | 0] = 4, r = ((fr | 0) >= 5 ? 5 : fr) - 1 | 0, _[so(Xe, ar + 248 | 0, r) + r | 0] = 0;
                                                                                                              break w;
                                                                                                            }
                                                                                                            vr = Os(22864) | 0;
                                                                                                            break K;
                                                                                                          }
                                                                                                          vr = Os(22864) | 0;
                                                                                                          break K;
                                                                                                        }
                                                                                                        vr = Os(22864) | 0;
                                                                                                        break K;
                                                                                                      }
                                                                                                      vr = Os(22864) | 0;
                                                                                                    }
                                                                                                    if (r = yo, _[ar + 107 | 0] >= 0)
                                                                                                      break g;
                                                                                                    Br(e[ar + 96 >> 2]);
                                                                                                    break g;
                                                                                                  }
                                                                                                  vr = Os(22864) | 0, r = yo;
                                                                                                  break g;
                                                                                                }
                                                                                                vr = Os(22864) | 0, r = yo;
                                                                                                break I;
                                                                                              }
                                                                                              vr = Os(22864) | 0, r = yo;
                                                                                              break B;
                                                                                            }
                                                                                            vr = Os(22864) | 0, r = yo;
                                                                                            break x;
                                                                                          }
                                                                                          vr = Os(22864) | 0, r = yo;
                                                                                          break b;
                                                                                        }
                                                                                        vr = Os(22864) | 0, r = yo;
                                                                                        break C;
                                                                                      }
                                                                                      vr = Os(22864) | 0, r = yo;
                                                                                      break y;
                                                                                    }
                                                                                    vr = Os(22864) | 0, r = yo;
                                                                                    break D;
                                                                                  }
                                                                                  if (vr = Os(22864) | 0, r = yo, _[ar + 171 | 0] >= 0)
                                                                                    break D;
                                                                                  Br(e[ar + 160 >> 2]);
                                                                                }
                                                                                if (_[ar + 203 | 0] >= 0)
                                                                                  break y;
                                                                                Br(e[ar + 192 >> 2]);
                                                                              }
                                                                              if (_[ar + 139 | 0] >= 0)
                                                                                break C;
                                                                              Br(e[ar + 128 >> 2]);
                                                                            }
                                                                            if (_[ar + 91 | 0] >= 0)
                                                                              break b;
                                                                            Br(e[ar + 80 >> 2]);
                                                                          }
                                                                          if (_[ar + 259 | 0] >= 0)
                                                                            break x;
                                                                          Br(e[ar + 248 >> 2]);
                                                                        }
                                                                        if (_[ar + 75 | 0] >= 0)
                                                                          break B;
                                                                        Br(e[ar + 64 >> 2]);
                                                                      }
                                                                      if (_[ar + 59 | 0] >= 0)
                                                                        break I;
                                                                      Br(e[ar + 48 >> 2]);
                                                                    }
                                                                    if (_[ar + 47 | 0] >= 0)
                                                                      break g;
                                                                    Br(e[ar + 36 >> 2]);
                                                                    break g;
                                                                  }
                                                                  vr = Os(22864) | 0;
                                                                  break S;
                                                                }
                                                                if (vr = Os(22864) | 0, r = yo, Ls[ar + 192 >> 2] < 29)
                                                                  break N;
                                                                Br(e[ar + 200 >> 2]);
                                                                break N;
                                                              }
                                                              _[ar + 252 | 0] = me[2354], _[ar + 259 | 0] = 5, _[ar + 253 | 0] = 0, e[ar + 248 >> 2] = me[2350] | me[2351] << 8 | (me[2352] << 16 | me[2353] << 24), r = ((fr | 0) >= 6 ? 6 : fr) - 1 | 0, _[so(Xe, ar + 248 | 0, r) + r | 0] = 0;
                                                            }
                                                            if (e[5996] = 0, r = Mi(118, e[ar + 12 >> 2]) | 0, Xe = e[5996], e[5996] = 0, (Xe | 0) == 1)
                                                              break T;
                                                            w: {
                                                              if (r) {
                                                                _[ar + 252 | 0] = 0, e[ar + 248 >> 2] = 1702195828, _[ar + 259 | 0] = 4, r = ((Te | 0) >= 5 ? 5 : Te) - 1 | 0, _[so(W, ar + 248 | 0, r) + r | 0] = 0;
                                                                break w;
                                                              }
                                                              _[ar + 252 | 0] = me[2354], _[ar + 259 | 0] = 5, _[ar + 253 | 0] = 0, e[ar + 248 >> 2] = me[2350] | me[2351] << 8 | (me[2352] << 16 | me[2353] << 24), r = ((Te | 0) >= 6 ? 6 : Te) - 1 | 0, _[so(W, ar + 248 | 0, r) + r | 0] = 0;
                                                            }
                                                            if ((hi | 0) >= 0)
                                                              break v;
                                                            Br(_r);
                                                          }
                                                          r = e[ar + 16 >> 2];
                                                          v: {
                                                            if (!r || (s = e[r + 4 >> 2], e[r + 4 >> 2] = s - 1, s))
                                                              break v;
                                                            xi[e[e[r >> 2] + 8 >> 2]](r), ys(r);
                                                          }
                                                          if (_[ar + 155 | 0] >= 0)
                                                            break d;
                                                          Br(e[ar + 144 >> 2]);
                                                          break d;
                                                        }
                                                        vr = Os(22864) | 0;
                                                      }
                                                      r = yo;
                                                    }
                                                    if ((hi | 0) >= 0)
                                                      break g;
                                                    Br(_r);
                                                    break g;
                                                  }
                                                  vr = Os(22864) | 0;
                                                }
                                                r = yo;
                                              }
                                              if (ea(ar + 192 | 0), !mi)
                                                break g;
                                              Br(mi);
                                              break g;
                                            }
                                            vr = Os(22864) | 0, r = yo, ea(ar + 192 | 0);
                                          }
                                          Lo(ar + 12 | 0);
                                        }
                                        if (_[ar + 155 | 0] >= 0)
                                          break f;
                                        Br(e[ar + 144 >> 2]);
                                      }
                                      if ((Ml(22864) | 0) != (r | 0))
                                        break r;
                                      if (r = Cu(vr | 0) | 0, r = xi[e[e[r >> 2] + 8 >> 2]](r) | 0, e[5996] = 0, Te = pi(30, ar + 24 | 0, r | 0) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1)
                                        break c;
                                      if (e[5996] = 0, r = xn(99, Te | 0, 0, 5474) | 0, W = e[5996], e[5996] = 0, (W | 0) == 1)
                                        break l;
                                      if (e[ar + 152 >> 2] = e[r + 8 >> 2], W = e[r + 4 >> 2], e[ar + 144 >> 2] = e[r >> 2], e[ar + 148 >> 2] = W, e[r >> 2] = 0, e[r + 4 >> 2] = 0, e[r + 8 >> 2] = 0, e[5996] = 0, W = pi(97, ar + 144 | 0, 2611) | 0, Xe = e[5996], e[5996] = 0, (Xe | 0) == 1)
                                        break o;
                                      e[ar + 184 >> 2] = e[W + 8 >> 2], Te = e[W + 4 >> 2], e[ar + 176 >> 2] = e[W >> 2], e[ar + 180 >> 2] = Te, e[W >> 2] = 0, e[W + 4 >> 2] = 0, e[W + 8 >> 2] = 0, vr = s, s = e[ar + 176 >> 2], Te = me[ar + 187 | 0], Xe = Te << 24 >> 24, fr = (Xe | 0) < 0, Te = fr ? e[ar + 180 >> 2] : Te, u = u - 1 | 0, u = (u | 0) > (Te | 0) ? Te : u, _[so(vr, fr ? s : ar + 176 | 0, u) + u | 0] = 0;
                                      f: {
                                        if ((Xe | 0) >= 0 || (Br(s), _[W + 11 | 0] >= 0))
                                          break f;
                                        Br(e[W >> 2]);
                                      }
                                      if (_[r + 11 | 0] < 0 && Br(e[r >> 2]), e[5996] = 0, r = pi(30, ar + 176 | 0, 5575) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1)
                                        break s;
                                      if (Te = A, s = e[r >> 2], u = me[r + 11 | 0], A = u << 24 >> 24, W = (A | 0) < 0, Xe = W ? s : r, r = W ? e[r + 4 >> 2] : u, u = m - 1 | 0, r = (r | 0) < (u | 0) ? r : u, _[so(Te, Xe, r) + r | 0] = 0, (A | 0) < 0 && Br(s), e[5996] = 0, r = pi(30, ar + 12 | 0, 5575) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1)
                                        break n;
                                      s = e[r >> 2], u = me[r + 11 | 0], A = u << 24 >> 24, m = (A | 0) < 0, W = m ? s : r, r = m ? e[r + 4 >> 2] : u, u = N - 1 | 0, r = (r | 0) < (u | 0) ? r : u, _[so(p, W, r) + r | 0] = 0, (A | 0) < 0 && Br(s), ef();
                                    }
                                    Jr = ar + 304 | 0;
                                    return;
                                  }
                                  vr = Hr() | 0;
                                  break i;
                                }
                                vr = Hr() | 0;
                                break a;
                              }
                              if (vr = Hr() | 0, _[ar + 155 | 0] >= 0)
                                break a;
                              Br(e[ar + 144 >> 2]);
                            }
                            if (_[Te + 11 | 0] >= 0)
                              break i;
                            Br(e[Te >> 2]);
                            break i;
                          }
                          vr = Hr() | 0;
                          break i;
                        }
                        vr = Hr() | 0;
                      }
                      if (e[5996] = 0, Nn(110), r = e[5996], e[5996] = 0, (r | 0) == 1)
                        break t;
                    }
                    Jn(vr | 0), Oi();
                  }
                  Os(0) | 0, Na(), Oi();
                }
                Oi();
              }
              function jl(r, s, u) {
                r = r | 0, s = s | 0, u = u | 0;
                var A = 0, m = 0, p = 0, N = 0, W = 0, Te = 0, Xe = 0, fr = 0, ar = 0, vr = 0, _r = 0, hi = 0, mi = 0, Ni = 0, Hi = 0, Ji = 0, Ln = 0, _n = 0, hs = 0;
                p = Jr - 144 | 0, Jr = p, ar = jn[s + 24 >> 3], vr = jn[s + 16 >> 3];
                e: {
                  t: {
                    r: {
                      i: {
                        n: {
                          s: {
                            a: {
                              o: {
                                l: {
                                  c: {
                                    d: {
                                      f: {
                                        u: {
                                          g: {
                                            A: {
                                              p: {
                                                m: {
                                                  k: {
                                                    N: {
                                                      S: {
                                                        T: {
                                                          v: {
                                                            w: {
                                                              E: {
                                                                h: {
                                                                  R: {
                                                                    I: {
                                                                      B:
                                                                        switch (m = e[r >> 2], m | 0) {
                                                                          case 9:
                                                                            break c;
                                                                          case 8:
                                                                            break d;
                                                                          case 2:
                                                                            break f;
                                                                          case 3:
                                                                            break u;
                                                                          case 14:
                                                                            break g;
                                                                          case 15:
                                                                            break A;
                                                                          case 16:
                                                                            break p;
                                                                          case 19:
                                                                            break m;
                                                                          case 18:
                                                                            break k;
                                                                          case 17:
                                                                            break N;
                                                                          case 10:
                                                                            break S;
                                                                          case 11:
                                                                            break T;
                                                                          case 12:
                                                                            break v;
                                                                          case 13:
                                                                            break w;
                                                                          case 0:
                                                                            break E;
                                                                          case 4:
                                                                          case 5:
                                                                            break h;
                                                                          case 1:
                                                                            break R;
                                                                          case 21:
                                                                            break I;
                                                                          case 20:
                                                                            break B;
                                                                          case 6:
                                                                            break o;
                                                                          case 7:
                                                                            break l;
                                                                          default:
                                                                            break a;
                                                                        }
                                                                      if (A = e[r + 4 >> 2], r = e[r + 8 >> 2], (A | 0) == (r | 0))
                                                                        break a;
                                                                      for (; jl(e[A >> 2], s, u), A = A + 4 | 0, (r | 0) != (A | 0); )
                                                                        ;
                                                                      break a;
                                                                    }
                                                                    if (r = Xl(r, vr, ar, u), A = e[r >> 2], u = e[r + 4 >> 2], (A | 0) == (u | 0))
                                                                      break a;
                                                                    for (; e[p + 56 >> 2] = e[A >> 2], r = e[A + 4 >> 2], e[p + 60 >> 2] = r, r && (e[r + 4 >> 2] = e[r + 4 >> 2] + 1), r = e[p + 60 >> 2], e[p >> 2] = e[p + 56 >> 2], e[p + 4 >> 2] = r, lh(s, A + 8 | 0, p), A = A + 32 | 0, (u | 0) != (A | 0); )
                                                                      ;
                                                                    break a;
                                                                  }
                                                                  Su(s, u, 1, r + 4 | 0, 0, 0);
                                                                  break a;
                                                                }
                                                                if (_r = (m | 0) == 4 ? 4 : 5, Mf(p + 56 | 0, _r, vr, ar, 0, 0), e[5996] = 0, A = Mi(46, _r | 0) | 0, m = e[5996], e[5996] = 0, (m | 0) == 1)
                                                                  break s;
                                                                if (e[p + 88 >> 2] = 0, e[p + 80 >> 2] = 0, e[p + 84 >> 2] = 0, _[p + 136 | 0] = 0, e[p + 132 >> 2] = p + 80, m = e[A + 4 >> 2], W = e[A >> 2], fr = m - W | 0, N = (fr | 0) / 12 | 0, (m | 0) != (W | 0)) {
                                                                  h: {
                                                                    R: {
                                                                      I: {
                                                                        if (N >>> 0 >= 357913942) {
                                                                          if (e[5996] = 0, Nn(47), r = e[5996], e[5996] = 0, (r | 0) == 1)
                                                                            break I;
                                                                          break i;
                                                                        }
                                                                        if (e[5996] = 0, m = Mi(3, fr | 0) | 0, W = e[5996], e[5996] = 0, (W | 0) == 1)
                                                                          break I;
                                                                        if (e[p + 84 >> 2] = m, e[p + 80 >> 2] = m, e[p + 88 >> 2] = m + Sn(N, 12), N = e[A + 4 >> 2], A = e[A >> 2], e[5996] = 0, A = wa(48, p + 88 | 0, A | 0, N | 0, m | 0) | 0, N = e[5996], e[5996] = 0, (N | 0) != 1)
                                                                          break h;
                                                                        A = Hr() | 0, e[p + 84 >> 2] = m;
                                                                        break R;
                                                                      }
                                                                      A = Hr() | 0;
                                                                    }
                                                                    ff(p + 132 | 0);
                                                                    break r;
                                                                  }
                                                                  e[p + 84 >> 2] = A;
                                                                }
                                                                if (e[p + 140 >> 2] = 0, e[p + 132 >> 2] = 0, e[p + 136 >> 2] = 0, m = e[r + 8 >> 2], A = e[r + 4 >> 2], e[5996] = 0, ji(49, p + 132 | 0, m - A >> 2), m = e[5996], e[5996] = 0, (m | 0) != 1) {
                                                                  if (A = e[p + 84 >> 2], m = e[p + 80 >> 2], (A | 0) != (m | 0))
                                                                    for (_n = r + 40 | 0, A = m; ; ) {
                                                                      e[p + 128 >> 2] = 0, e[p + 120 >> 2] = 0, e[p + 124 >> 2] = 0;
                                                                      h: {
                                                                        R: {
                                                                          I: {
                                                                            B: {
                                                                              if (N = e[r + 8 >> 2], m = e[r + 4 >> 2], Ni = Sn(Ji, 12), A = Ni + A | 0, N - m >> 2 == e[A + 4 >> 2] - e[A >> 2] >> 3) {
                                                                                if (W = 0, hi = 1, Xe = 0, (m | 0) != (N | 0))
                                                                                  break B;
                                                                                break I;
                                                                              }
                                                                              if (e[5996] = 0, Vs(44, 5170, 1900, 642, 2497), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                                break i;
                                                                              A = Hr() | 0;
                                                                              break R;
                                                                            }
                                                                            B: {
                                                                              x: {
                                                                                for (; ; ) {
                                                                                  b: {
                                                                                    if (A = Xe << 3, ar = jn[A + e[p + 68 >> 2] >> 3], vr = jn[A + e[p + 56 >> 2] >> 3], m = e[(Xe << 2) + m >> 2], e[5996] = 0, m = Cf(50, m | 0, +vr, +ar, u | 0) | 0, N = e[5996], e[5996] = 0, (N | 0) == 1)
                                                                                      break b;
                                                                                    if (A = A + e[Ni + e[p + 80 >> 2] >> 2] | 0, N = e[A >> 2], A = e[A + 4 >> 2], fr = e[m + 4 >> 2], m = e[m >> 2], e[5996] = 0, uu(51, p + 100 | 0, m | 0, fr | 0, N | 0, A | 0), m = e[5996], e[5996] = 0, (m | 0) == 1)
                                                                                      break x;
                                                                                    N = e[p + 128 >> 2];
                                                                                    C: {
                                                                                      if (N >>> 0 > W >>> 0) {
                                                                                        e[W + 8 >> 2] = 0, e[W >> 2] = 0, e[W + 4 >> 2] = 0, e[W >> 2] = e[p + 100 >> 2], e[W + 4 >> 2] = e[p + 104 >> 2], e[W + 8 >> 2] = e[p + 108 >> 2], e[p + 124 >> 2] = W + 12;
                                                                                        break C;
                                                                                      }
                                                                                      y: {
                                                                                        m = e[p + 120 >> 2], fr = (W - m | 0) / 12 | 0, A = fr + 1 | 0;
                                                                                        D: {
                                                                                          if (A >>> 0 >= 357913942) {
                                                                                            e[5996] = 0, Nn(52);
                                                                                            break D;
                                                                                          }
                                                                                          if (N = (N - m | 0) / 12 | 0, Te = N << 1, A = N >>> 0 >= 178956970 ? 357913941 : A >>> 0 < Te >>> 0 ? Te : A, A >>> 0 < 357913942)
                                                                                            break y;
                                                                                          e[5996] = 0, Nn(35);
                                                                                        }
                                                                                        if (r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                                          break i;
                                                                                        break B;
                                                                                      }
                                                                                      if (e[5996] = 0, Te = Sn(A, 12), N = Mi(3, Te | 0) | 0, A = e[5996], e[5996] = 0, (A | 0) == 1)
                                                                                        break B;
                                                                                      A = N + Sn(fr, 12) | 0, e[A >> 2] = e[p + 100 >> 2], e[A + 4 >> 2] = e[p + 104 >> 2], e[A + 8 >> 2] = e[p + 108 >> 2], e[p + 108 >> 2] = 0, e[p + 100 >> 2] = 0, e[p + 104 >> 2] = 0, N = N + Te | 0, fr = A + 12 | 0;
                                                                                      y: {
                                                                                        if ((m | 0) == (W | 0)) {
                                                                                          e[p + 128 >> 2] = N, e[p + 124 >> 2] = fr, e[p + 120 >> 2] = A;
                                                                                          break y;
                                                                                        }
                                                                                        for (; A = A - 12 | 0, W = W - 12 | 0, e[A >> 2] = e[W >> 2], e[A + 4 >> 2] = e[W + 4 >> 2], e[A + 8 >> 2] = e[W + 8 >> 2], e[W + 8 >> 2] = 0, e[W >> 2] = 0, e[W + 4 >> 2] = 0, (m | 0) != (W | 0); )
                                                                                          ;
                                                                                        if (e[p + 128 >> 2] = N, m = e[p + 124 >> 2], e[p + 124 >> 2] = fr, W = e[p + 120 >> 2], e[p + 120 >> 2] = A, (m | 0) == (W | 0))
                                                                                          break y;
                                                                                        for (; ; ) {
                                                                                          if (Te = m - 12 | 0, fr = e[Te >> 2], fr) {
                                                                                            if (Hi = m - 8 | 0, A = e[Hi >> 2], N = fr, (A | 0) != (N | 0)) {
                                                                                              for (; ; ) {
                                                                                                A = A - 32 | 0, m = e[A + 4 >> 2];
                                                                                                D: {
                                                                                                  if (!m || (N = e[m + 4 >> 2], e[m + 4 >> 2] = N - 1, N))
                                                                                                    break D;
                                                                                                  xi[e[e[m >> 2] + 8 >> 2]](m), ys(m);
                                                                                                }
                                                                                                if ((A | 0) == (fr | 0))
                                                                                                  break;
                                                                                              }
                                                                                              N = e[Te >> 2];
                                                                                            }
                                                                                            e[Hi >> 2] = fr, Br(N);
                                                                                          }
                                                                                          if (m = Te, (W | 0) == (m | 0))
                                                                                            break;
                                                                                        }
                                                                                      }
                                                                                      if (W && Br(W), N = e[p + 100 >> 2], !N)
                                                                                        break C;
                                                                                      if (m = N, A = e[p + 104 >> 2], (m | 0) != (A | 0)) {
                                                                                        for (; ; ) {
                                                                                          A = A - 32 | 0, m = e[A + 4 >> 2];
                                                                                          y: {
                                                                                            if (!m || (W = e[m + 4 >> 2], e[m + 4 >> 2] = W - 1, W))
                                                                                              break y;
                                                                                            xi[e[e[m >> 2] + 8 >> 2]](m), ys(m);
                                                                                          }
                                                                                          if ((A | 0) == (N | 0))
                                                                                            break;
                                                                                        }
                                                                                        m = e[p + 100 >> 2];
                                                                                      }
                                                                                      e[p + 104 >> 2] = N, Br(m);
                                                                                    }
                                                                                    if (W = e[p + 124 >> 2], m = W - 12 | 0, hi = Sn(e[m + 4 >> 2] - e[m >> 2] >> 5, hi), Xe = Xe + 1 | 0, m = e[r + 4 >> 2], Xe >>> 0 < e[r + 8 >> 2] - m >> 2 >>> 0)
                                                                                      continue;
                                                                                    break I;
                                                                                  }
                                                                                  break;
                                                                                }
                                                                                A = Hr() | 0;
                                                                                break R;
                                                                              }
                                                                              A = Hr() | 0;
                                                                              break R;
                                                                            }
                                                                            A = Hr() | 0, mu(p + 100 | 0);
                                                                            break R;
                                                                          }
                                                                          for (W = 0, fr = e[p + 132 >> 2]; ; ) {
                                                                            if ((W | 0) == (hi | 0))
                                                                              break h;
                                                                            if (e[r + 8 >> 2] != e[r + 4 >> 2])
                                                                              for (A = 0, N = e[p + 120 >> 2], m = W; Te = Sn(A, 12), Xe = Te + N | 0, N = e[Xe >> 2], e[fr + (A << 2) >> 2] = N + ((m >>> 0) % (e[Xe + 4 >> 2] - N >> 5 >>> 0) << 5), Xe = m, N = e[p + 120 >> 2], m = Te + N | 0, m = (Xe >>> 0) / (e[m + 4 >> 2] - e[m >> 2] >> 5 >>> 0) | 0, A = A + 1 | 0, A >>> 0 < e[r + 8 >> 2] - e[r + 4 >> 2] >> 2 >>> 0; )
                                                                                ;
                                                                            if (e[5996] = 0, Vu(53, s | 0, _r | 0, p + 132 | 0, 0, _n | 0), m = e[5996], e[5996] = 0, W = W + 1 | 0, (m | 0) == 1)
                                                                              break;
                                                                          }
                                                                          A = Hr() | 0;
                                                                        }
                                                                        Nc(p + 120 | 0);
                                                                        break n;
                                                                      }
                                                                      if (N = e[p + 120 >> 2], N) {
                                                                        if (A = e[p + 124 >> 2], (N | 0) != (A | 0)) {
                                                                          for (; ; ) {
                                                                            if (fr = A - 12 | 0, W = e[fr >> 2], W) {
                                                                              if (m = W, Te = A - 8 | 0, A = e[Te >> 2], (m | 0) != (A | 0)) {
                                                                                for (; ; ) {
                                                                                  A = A - 32 | 0, m = e[A + 4 >> 2];
                                                                                  h: {
                                                                                    if (!m || (Xe = e[m + 4 >> 2], e[m + 4 >> 2] = Xe - 1, Xe))
                                                                                      break h;
                                                                                    xi[e[e[m >> 2] + 8 >> 2]](m), ys(m);
                                                                                  }
                                                                                  if ((A | 0) == (W | 0))
                                                                                    break;
                                                                                }
                                                                                m = e[fr >> 2];
                                                                              }
                                                                              e[Te >> 2] = W, Br(m);
                                                                            }
                                                                            if (A = fr, (N | 0) == (A | 0))
                                                                              break;
                                                                          }
                                                                          N = e[p + 120 >> 2];
                                                                        }
                                                                        Br(N);
                                                                      }
                                                                      if (Ji = Ji + 1 | 0, A = e[p + 80 >> 2], !(Ji >>> 0 < (e[p + 84 >> 2] - A | 0) / 12 >>> 0))
                                                                        break;
                                                                    }
                                                                  if (r = e[p + 132 >> 2], r && (Br(r), A = e[p + 80 >> 2]), A) {
                                                                    if (m = A, N = e[p + 84 >> 2], (m | 0) != (N | 0)) {
                                                                      for (; r = N - 12 | 0, s = e[r >> 2], s && (e[N - 8 >> 2] = s, Br(s)), N = r, (r | 0) != (A | 0); )
                                                                        ;
                                                                      m = e[p + 80 >> 2];
                                                                    }
                                                                    e[p + 84 >> 2] = A, Br(m);
                                                                  }
                                                                  if (r = e[p + 68 >> 2], r && (e[p + 72 >> 2] = r, Br(r)), r = e[p + 56 >> 2], !r)
                                                                    break a;
                                                                  e[p + 60 >> 2] = r, Br(r);
                                                                  break a;
                                                                }
                                                                A = Hr() | 0;
                                                                break n;
                                                              }
                                                              Su(s, u, 0, r + 4 | 0, 0, 0);
                                                              break a;
                                                            }
                                                            Mf(p + 56 | 0, 24, vr, ar, jn[r + 48 >> 3], e[r + 8 >> 2] - e[r + 4 >> 2] >> 2), e[p + 88 >> 2] = 0, e[p + 80 >> 2] = 0, e[p + 84 >> 2] = 0, e[p + 140 >> 2] = 0, e[p + 132 >> 2] = 0, e[p + 136 >> 2] = 0;
                                                            w: {
                                                              E: {
                                                                h: {
                                                                  R: {
                                                                    I: {
                                                                      B: {
                                                                        x: {
                                                                          b: {
                                                                            C: {
                                                                              N = e[r + 4 >> 2];
                                                                              y: {
                                                                                if ((N | 0) == e[r + 8 >> 2]) {
                                                                                  fr = -1, m = N, A = 0;
                                                                                  break y;
                                                                                }
                                                                                ar = -1, m = N, fr = -1;
                                                                                D: {
                                                                                  for (; ; ) {
                                                                                    if (A = W << 3, vr = jn[A + e[p + 68 >> 2] >> 3], mi = jn[A + e[p + 56 >> 2] >> 3], m = e[(W << 2) + m >> 2], e[5996] = 0, m = Cf(50, m | 0, +mi, +vr, u | 0) | 0, A = e[5996], e[5996] = 0, (A | 0) == 1)
                                                                                      break C;
                                                                                    e[5996] = 0, A = pi(54, 1283, 5) | 0, N = e[5996], e[5996] = 0;
                                                                                    P: {
                                                                                      q: {
                                                                                        O: {
                                                                                          Q: {
                                                                                            U: {
                                                                                              if ((N | 0) == 1 || (N = e[m >> 2], Te = e[m + 4 >> 2], e[5996] = 0, uu(51, p + 120 | 0, N | 0, Te | 0, A | 0, 0), A = e[5996], e[5996] = 0, (A | 0) == 1))
                                                                                                break U;
                                                                                              switch (Te = 1, N = e[p + 120 >> 2], e[p + 124 >> 2] - N >> 5) {
                                                                                                case 0:
                                                                                                  break q;
                                                                                                case 1:
                                                                                                  break O;
                                                                                                default:
                                                                                                  break Q;
                                                                                              }
                                                                                            }
                                                                                            A = Hr() | 0;
                                                                                            break w;
                                                                                          }
                                                                                          if (e[5996] = 0, Vs(44, 4164, 1900, 807, 2386), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                                            break i;
                                                                                          A = Hr() | 0;
                                                                                          break E;
                                                                                        }
                                                                                        if (e[5996] = 0, ji(55, p + 80 | 0, N | 0), A = e[5996], e[5996] = 0, (A | 0) == 1)
                                                                                          break b;
                                                                                        if (e[5996] = 0, A = pi(54, 1277, 5) | 0, N = e[5996], e[5996] = 0, (N | 0) == 1 || (N = e[m >> 2], m = e[m + 4 >> 2], e[5996] = 0, uu(51, p + 100 | 0, N | 0, m | 0, A | 0, 0), m = e[5996], e[5996] = 0, (m | 0) == 1))
                                                                                          break P;
                                                                                        O: {
                                                                                          Q: {
                                                                                            U:
                                                                                              switch (m = e[p + 100 >> 2], e[p + 104 >> 2] - m >> 5) {
                                                                                                case 0:
                                                                                                  break O;
                                                                                                case 1:
                                                                                                  break Q;
                                                                                                default:
                                                                                                  break U;
                                                                                              }
                                                                                            if (e[5996] = 0, Vs(44, 4146, 1900, 811, 2386), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                                              break i;
                                                                                            break h;
                                                                                          }
                                                                                          if (e[5996] = 0, ji(55, p + 132 | 0, m | 0), m = e[5996], e[5996] = 0, (m | 0) == 1)
                                                                                            break h;
                                                                                          if (Te = 0, vr = jn[e[p + 136 >> 2] - 8 >> 3] - jn[e[p + 84 >> 2] - 8 >> 3], !(vr > ar))
                                                                                            break O;
                                                                                          fr = W, ar = vr;
                                                                                        }
                                                                                        if (N = e[p + 100 >> 2], N) {
                                                                                          if (m = N, A = e[p + 104 >> 2], (m | 0) != (A | 0)) {
                                                                                            for (; ; ) {
                                                                                              A = A - 32 | 0, m = e[A + 4 >> 2];
                                                                                              O: {
                                                                                                if (!m || (Xe = e[m + 4 >> 2], e[m + 4 >> 2] = Xe - 1, Xe))
                                                                                                  break O;
                                                                                                xi[e[e[m >> 2] + 8 >> 2]](m), ys(m);
                                                                                              }
                                                                                              if ((A | 0) == (N | 0))
                                                                                                break;
                                                                                            }
                                                                                            m = e[p + 100 >> 2];
                                                                                          }
                                                                                          e[p + 104 >> 2] = N, Br(m);
                                                                                        }
                                                                                        N = e[p + 120 >> 2];
                                                                                      }
                                                                                      if (N) {
                                                                                        if (m = N, A = e[p + 124 >> 2], (m | 0) != (A | 0)) {
                                                                                          for (; ; ) {
                                                                                            A = A - 32 | 0, m = e[A + 4 >> 2];
                                                                                            q: {
                                                                                              if (!m || (Xe = e[m + 4 >> 2], e[m + 4 >> 2] = Xe - 1, Xe))
                                                                                                break q;
                                                                                              xi[e[e[m >> 2] + 8 >> 2]](m), ys(m);
                                                                                            }
                                                                                            if ((A | 0) == (N | 0))
                                                                                              break;
                                                                                          }
                                                                                          m = e[p + 120 >> 2];
                                                                                        }
                                                                                        e[p + 124 >> 2] = N, Br(m);
                                                                                      }
                                                                                      if (Te)
                                                                                        break R;
                                                                                      if (W = W + 1 | 0, N = e[r + 8 >> 2], m = e[r + 4 >> 2], W >>> 0 >= N - m >> 2 >>> 0)
                                                                                        break D;
                                                                                      continue;
                                                                                    }
                                                                                    break;
                                                                                  }
                                                                                  A = Hr() | 0;
                                                                                  break E;
                                                                                }
                                                                                A = e[p + 80 >> 2];
                                                                              }
                                                                              if (e[5996] = 0, u = Mi(3, 4) | 0, W = e[5996], e[5996] = 0, (W | 0) == 1)
                                                                                break x;
                                                                              if (e[u >> 2] = A + (fr << 5), A = u + 4 | 0, e[p + 128 >> 2] = A, e[p + 124 >> 2] = A, e[p + 120 >> 2] = u, (m | 0) != (N | 0))
                                                                                for (W = 0; ; ) {
                                                                                  y: {
                                                                                    if ((W | 0) == (fr | 0))
                                                                                      break y;
                                                                                    if (u = e[p + 132 >> 2] + (W << 5) | 0, Te = e[p + 128 >> 2], Te >>> 0 > A >>> 0) {
                                                                                      e[A >> 2] = u, A = A + 4 | 0, e[p + 124 >> 2] = A;
                                                                                      break y;
                                                                                    }
                                                                                    D: {
                                                                                      P: {
                                                                                        N = e[p + 120 >> 2], hi = A - N >> 2, m = hi + 1 | 0;
                                                                                        q: {
                                                                                          if (m >>> 0 >= 1073741824) {
                                                                                            e[5996] = 0, Nn(56);
                                                                                            break q;
                                                                                          }
                                                                                          if (Te = Te - N | 0, Xe = Te >> 1, Te = Te >>> 0 >= 2147483644 ? 1073741823 : m >>> 0 < Xe >>> 0 ? Xe : m, !Te) {
                                                                                            Xe = 0;
                                                                                            break D;
                                                                                          }
                                                                                          if (Te >>> 0 < 1073741824)
                                                                                            break P;
                                                                                          e[5996] = 0, Nn(35);
                                                                                        }
                                                                                        if (r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                                          break i;
                                                                                        A = Hr() | 0;
                                                                                        break I;
                                                                                      }
                                                                                      if (e[5996] = 0, Xe = Mi(3, Te << 2) | 0, m = e[5996], e[5996] = 0, (m | 0) == 1)
                                                                                        break B;
                                                                                    }
                                                                                    if (m = (hi << 2) + Xe | 0, e[m >> 2] = u, u = m + 4 | 0, (A | 0) != (N | 0)) {
                                                                                      for (; m = m - 4 | 0, A = A - 4 | 0, e[m >> 2] = e[A >> 2], (A | 0) != (N | 0); )
                                                                                        ;
                                                                                      A = e[p + 120 >> 2];
                                                                                    }
                                                                                    e[p + 128 >> 2] = (Te << 2) + Xe, e[p + 124 >> 2] = u, e[p + 120 >> 2] = m, A && Br(A), A = u;
                                                                                  }
                                                                                  if (W = W + 1 | 0, !(W >>> 0 < e[r + 8 >> 2] - e[r + 4 >> 2] >> 2 >>> 0))
                                                                                    break;
                                                                                }
                                                                              if (ar = jn[r + 48 >> 3], e[5996] = 0, Vu(53, s | 0, 24, p + 120 | 0, +ar, r + 40 | 0), r = e[5996], e[5996] = 0, (r | 0) != 1) {
                                                                                if (r = e[p + 120 >> 2], !r)
                                                                                  break R;
                                                                                Br(r);
                                                                                break R;
                                                                              }
                                                                              A = Hr() | 0, N = e[p + 120 >> 2];
                                                                              break I;
                                                                            }
                                                                            A = Hr() | 0;
                                                                            break w;
                                                                          }
                                                                          A = Hr() | 0;
                                                                          break E;
                                                                        }
                                                                        A = Hr() | 0;
                                                                        break w;
                                                                      }
                                                                      A = Hr() | 0;
                                                                    }
                                                                    if (!N)
                                                                      break w;
                                                                    Br(N);
                                                                    break w;
                                                                  }
                                                                  if (r = e[p + 132 >> 2], r) {
                                                                    if (A = e[p + 136 >> 2], (r | 0) != (A | 0)) {
                                                                      for (; ; ) {
                                                                        A = A - 32 | 0, s = e[A + 4 >> 2];
                                                                        R: {
                                                                          if (!s || (u = e[s + 4 >> 2], e[s + 4 >> 2] = u - 1, u))
                                                                            break R;
                                                                          xi[e[e[s >> 2] + 8 >> 2]](s), ys(s);
                                                                        }
                                                                        if ((r | 0) == (A | 0))
                                                                          break;
                                                                      }
                                                                      r = e[p + 132 >> 2];
                                                                    }
                                                                    Br(r);
                                                                  }
                                                                  if (r = e[p + 80 >> 2], r) {
                                                                    if (A = e[p + 84 >> 2], (r | 0) != (A | 0)) {
                                                                      for (; ; ) {
                                                                        A = A - 32 | 0, s = e[A + 4 >> 2];
                                                                        R: {
                                                                          if (!s || (u = e[s + 4 >> 2], e[s + 4 >> 2] = u - 1, u))
                                                                            break R;
                                                                          xi[e[e[s >> 2] + 8 >> 2]](s), ys(s);
                                                                        }
                                                                        if ((r | 0) == (A | 0))
                                                                          break;
                                                                      }
                                                                      r = e[p + 80 >> 2];
                                                                    }
                                                                    Br(r);
                                                                  }
                                                                  if (r = e[p + 68 >> 2], r && (e[p + 72 >> 2] = r, Br(r)), r = e[p + 56 >> 2], !r)
                                                                    break a;
                                                                  e[p + 60 >> 2] = r, Br(r);
                                                                  break a;
                                                                }
                                                                A = Hr() | 0, mu(p + 100 | 0);
                                                              }
                                                              mu(p + 120 | 0);
                                                            }
                                                            mu(p + 132 | 0), mu(p + 80 | 0);
                                                            break r;
                                                          }
                                                          m = e[r + 4 >> 2], A = e[m + 4 >> 2], N = e[m >> 2], W = e[m + 8 >> 2], m = Qs(12), e[p + 56 >> 2] = m, fr = m + 12 | 0, e[p + 64 >> 2] = fr, e[m + 8 >> 2] = W, e[m + 4 >> 2] = N, e[m >> 2] = A, e[p + 60 >> 2] = fr, ar = jn[r + 48 >> 3], e[5996] = 0, Qa(57, s | 0, u | 0, 23, r + 4 | 0, +ar, 0), r = e[5996], e[5996] = 0;
                                                          v: {
                                                            if ((r | 0) == 1 || (e[5996] = 0, Qa(57, s | 0, u | 0, 23, p + 56 | 0, +ar, 0), r = e[5996], e[5996] = 0, (r | 0) == 1))
                                                              break v;
                                                            Br(m);
                                                            break a;
                                                          }
                                                          break e;
                                                        }
                                                        m = e[r + 4 >> 2], A = e[m >> 2], N = e[m + 4 >> 2], m = Qs(8), e[p + 56 >> 2] = m, W = m + 8 | 0, e[p + 64 >> 2] = W, e[m >> 2] = Td(A, N, 32), e[m + 4 >> 2] = Ds, e[p + 60 >> 2] = W, A = r + 4 | 0, vr = jn[r + 48 >> 3], mi = 1 - vr;
                                                        T: {
                                                          if (ar == 0 && (e[5996] = 0, Qa(57, s | 0, u | 0, 20, A | 0, +vr, 0), r = e[5996], e[5996] = 0, (r | 0) == 1 || (e[5996] = 0, Qa(57, s | 0, u | 0, 20, p + 56 | 0, +mi, 0), r = e[5996], e[5996] = 0, (r | 0) == 1)) || (e[5996] = 0, Qa(57, s | 0, u | 0, 19, A | 0, +vr, 0), r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[5996] = 0, r = p + 56 | 0, Qa(57, s | 0, u | 0, 19, r | 0, +mi, 0), N = e[5996], e[5996] = 0, (N | 0) == 1) || (e[5996] = 0, Qa(57, s | 0, u | 0, 21, A | 0, +vr, 0), N = e[5996], e[5996] = 0, (N | 0) == 1) || (e[5996] = 0, Qa(57, s | 0, u | 0, 21, r | 0, +mi, 0), N = e[5996], e[5996] = 0, (N | 0) == 1) || (e[5996] = 0, Qa(57, s | 0, u | 0, 22, A | 0, +vr, 0), N = e[5996], e[5996] = 0, (N | 0) == 1) || (e[5996] = 0, Qa(57, s | 0, u | 0, 22, r | 0, +mi, 0), N = e[5996], e[5996] = 0, (N | 0) == 1) || (e[5996] = 0, Qa(57, s | 0, u | 0, 22, A | 0, +vr, 1), A = e[5996], e[5996] = 0, (A | 0) == 1) || (e[5996] = 0, Qa(57, s | 0, u | 0, 22, r | 0, +mi, 1), r = e[5996], e[5996] = 0, (r | 0) == 1))
                                                            break T;
                                                          Br(m);
                                                          break a;
                                                        }
                                                        break e;
                                                      }
                                                      m = e[r + 4 >> 2], A = e[m >> 2], N = e[m + 4 >> 2], m = Qs(8), e[p + 56 >> 2] = m, W = m + 8 | 0, e[p + 64 >> 2] = W, e[m >> 2] = Td(A, N, 32), e[m + 4 >> 2] = Ds, e[p + 60 >> 2] = W, r = r + 4 | 0;
                                                      S: {
                                                        if (ar == 0 && (e[5996] = 0, Qa(57, s | 0, u | 0, 17, r | 0, 0, 0), A = e[5996], e[5996] = 0, (A | 0) == 1 || (e[5996] = 0, Qa(57, s | 0, u | 0, 17, p + 56 | 0, 0, 0), A = e[5996], e[5996] = 0, (A | 0) == 1)) || (e[5996] = 0, Qa(57, s | 0, u | 0, 18, r | 0, 0, 0), r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[5996] = 0, Qa(57, s | 0, u | 0, 18, p + 56 | 0, 0, 0), r = e[5996], e[5996] = 0, (r | 0) == 1))
                                                          break S;
                                                        Br(m);
                                                        break a;
                                                      }
                                                      break e;
                                                    }
                                                    Su(s, u, 14, r + 4 | 0, 0, 0);
                                                    break a;
                                                  }
                                                  Su(s, u, 15, r + 4 | 0, 0, 0);
                                                  break a;
                                                }
                                                Su(s, u, 16, r + 4 | 0, 0, 0);
                                                break a;
                                              }
                                              Su(s, u, 13, r + 4 | 0, 0, 0);
                                              break a;
                                            }
                                            Su(s, u, 12, r + 4 | 0, 0, 0);
                                            break a;
                                          }
                                          r = r + 4 | 0, Su(s, u, 10, r, 0, 0), Su(s, u, 11, r, 0, 0);
                                          break a;
                                        }
                                        m = e[r + 40 >> 2], fr = e[r + 44 >> 2], me[24588] || (e[6145] = 0, e[6146] = 0, e[6143] = 0, e[6144] = 0, e[6141] = 0, e[6142] = 0, _[24588] = 1), _r = vc(p + 56 | 0), e[5996] = 0, A = Mi(46, 25) | 0, N = e[5996], e[5996] = 0;
                                        u: {
                                          g: {
                                            if ((N | 0) != 1) {
                                              if (e[p + 52 >> 2] = 0, e[p + 44 >> 2] = 0, e[p + 48 >> 2] = 0, _[p + 84 | 0] = 0, e[p + 80 >> 2] = p + 44, N = e[A + 4 >> 2], Te = e[A >> 2], Xe = N - Te | 0, W = (Xe | 0) / 12 | 0, (N | 0) != (Te | 0)) {
                                                if (W >>> 0 >= 357913942) {
                                                  if (e[5996] = 0, Nn(47), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                    break i;
                                                  break g;
                                                }
                                                if (e[5996] = 0, N = Mi(3, Xe | 0) | 0, Te = e[5996], e[5996] = 0, (Te | 0) == 1)
                                                  break g;
                                                if (e[p + 48 >> 2] = N, e[p + 44 >> 2] = N, e[p + 52 >> 2] = N + Sn(W, 12), W = e[A + 4 >> 2], A = e[A >> 2], e[5996] = 0, A = wa(48, p + 52 | 0, A | 0, W | 0, N | 0) | 0, W = e[5996], e[5996] = 0, (W | 0) == 1) {
                                                  A = Hr() | 0, e[p + 48 >> 2] = N;
                                                  break u;
                                                }
                                                e[p + 48 >> 2] = A;
                                              }
                                              e[p + 40 >> 2] = 0, e[p + 32 >> 2] = 0, e[p + 36 >> 2] = 0, A = e[r + 8 >> 2], N = e[r + 4 >> 2], e[5996] = 0, ji(49, p + 32 | 0, A - N >> 2), A = e[5996], e[5996] = 0;
                                              A: {
                                                if ((A | 0) != 1) {
                                                  p: {
                                                    m: {
                                                      if (A = e[p + 48 >> 2], N = e[p + 44 >> 2], (A | 0) != (N | 0))
                                                        for (_n = r + 16 | 0, ar = +(m >>> 0) + +(fr | 0) * 4294967296, vr = ar + 1, ar = ar * 73 + 1, A = N; ; ) {
                                                          if (e[p + 28 >> 2] = 0, e[p + 20 >> 2] = 0, e[p + 24 >> 2] = 0, N = e[r + 8 >> 2], m = e[r + 4 >> 2], Ni = Sn(Ji, 12), A = Ni + A | 0, N - m >> 2 != e[A + 4 >> 2] - e[A >> 2] >> 3)
                                                            break m;
                                                          W = 0, hi = 1, Xe = 0;
                                                          k: {
                                                            if ((m | 0) != (N | 0)) {
                                                              N: {
                                                                S: {
                                                                  T: {
                                                                    for (; ; ) {
                                                                      if (A = Xe << 3, mi = jn[A + e[_r + 12 >> 2] >> 3], hs = jn[A + e[_r >> 2] >> 3], m = e[(Xe << 2) + m >> 2], e[5996] = 0, m = Cf(50, m | 0, +hs, +mi, u | 0) | 0, N = e[5996], e[5996] = 0, (N | 0) == 1)
                                                                        break S;
                                                                      if (A = A + e[Ni + e[p + 44 >> 2] >> 2] | 0, N = e[A >> 2], A = e[A + 4 >> 2], fr = e[m + 4 >> 2], m = e[m >> 2], e[5996] = 0, uu(51, p + 80 | 0, m | 0, fr | 0, N | 0, A | 0), m = e[5996], e[5996] = 0, (m | 0) != 1) {
                                                                        N = e[p + 28 >> 2];
                                                                        v: {
                                                                          if (N >>> 0 > W >>> 0) {
                                                                            e[W + 8 >> 2] = 0, e[W >> 2] = 0, e[W + 4 >> 2] = 0, e[W >> 2] = e[p + 80 >> 2], e[W + 4 >> 2] = e[p + 84 >> 2], e[W + 8 >> 2] = e[p + 88 >> 2], e[p + 24 >> 2] = W + 12;
                                                                            break v;
                                                                          }
                                                                          w: {
                                                                            m = e[p + 20 >> 2], fr = (W - m | 0) / 12 | 0, A = fr + 1 | 0;
                                                                            E: {
                                                                              if (A >>> 0 >= 357913942) {
                                                                                e[5996] = 0, Nn(52);
                                                                                break E;
                                                                              }
                                                                              if (N = (N - m | 0) / 12 | 0, Te = N << 1, A = N >>> 0 >= 178956970 ? 357913941 : A >>> 0 < Te >>> 0 ? Te : A, A >>> 0 < 357913942)
                                                                                break w;
                                                                              e[5996] = 0, Nn(35);
                                                                            }
                                                                            if (r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                              break i;
                                                                            break T;
                                                                          }
                                                                          if (e[5996] = 0, Te = Sn(A, 12), N = Mi(3, Te | 0) | 0, A = e[5996], e[5996] = 0, (A | 0) == 1)
                                                                            break T;
                                                                          A = N + Sn(fr, 12) | 0, e[A >> 2] = e[p + 80 >> 2], e[A + 4 >> 2] = e[p + 84 >> 2], e[A + 8 >> 2] = e[p + 88 >> 2], e[p + 88 >> 2] = 0, e[p + 80 >> 2] = 0, e[p + 84 >> 2] = 0, N = N + Te | 0, fr = A + 12 | 0;
                                                                          w: {
                                                                            if ((m | 0) == (W | 0)) {
                                                                              e[p + 28 >> 2] = N, e[p + 24 >> 2] = fr, e[p + 20 >> 2] = A;
                                                                              break w;
                                                                            }
                                                                            for (; A = A - 12 | 0, W = W - 12 | 0, e[A >> 2] = e[W >> 2], e[A + 4 >> 2] = e[W + 4 >> 2], e[A + 8 >> 2] = e[W + 8 >> 2], e[W + 8 >> 2] = 0, e[W >> 2] = 0, e[W + 4 >> 2] = 0, (m | 0) != (W | 0); )
                                                                              ;
                                                                            if (e[p + 28 >> 2] = N, m = e[p + 24 >> 2], e[p + 24 >> 2] = fr, W = e[p + 20 >> 2], e[p + 20 >> 2] = A, (m | 0) == (W | 0))
                                                                              break w;
                                                                            for (; ; ) {
                                                                              if (Te = m - 12 | 0, fr = e[Te >> 2], fr) {
                                                                                if (Hi = m - 8 | 0, A = e[Hi >> 2], N = fr, (A | 0) != (N | 0)) {
                                                                                  for (; ; ) {
                                                                                    A = A - 32 | 0, m = e[A + 4 >> 2];
                                                                                    E: {
                                                                                      if (!m || (N = e[m + 4 >> 2], e[m + 4 >> 2] = N - 1, N))
                                                                                        break E;
                                                                                      xi[e[e[m >> 2] + 8 >> 2]](m), ys(m);
                                                                                    }
                                                                                    if ((A | 0) == (fr | 0))
                                                                                      break;
                                                                                  }
                                                                                  N = e[Te >> 2];
                                                                                }
                                                                                e[Hi >> 2] = fr, Br(N);
                                                                              }
                                                                              if (m = Te, (W | 0) == (m | 0))
                                                                                break;
                                                                            }
                                                                          }
                                                                          if (W && Br(W), N = e[p + 80 >> 2], !N)
                                                                            break v;
                                                                          if (m = N, A = e[p + 84 >> 2], (m | 0) != (A | 0)) {
                                                                            for (; ; ) {
                                                                              A = A - 32 | 0, m = e[A + 4 >> 2];
                                                                              w: {
                                                                                if (!m || (W = e[m + 4 >> 2], e[m + 4 >> 2] = W - 1, W))
                                                                                  break w;
                                                                                xi[e[e[m >> 2] + 8 >> 2]](m), ys(m);
                                                                              }
                                                                              if ((A | 0) == (N | 0))
                                                                                break;
                                                                            }
                                                                            m = e[p + 80 >> 2];
                                                                          }
                                                                          e[p + 84 >> 2] = N, Br(m);
                                                                        }
                                                                        if (W = e[p + 24 >> 2], m = W - 12 | 0, hi = Sn(e[m + 4 >> 2] - e[m >> 2] >> 5, hi), Xe = Xe + 1 | 0, m = e[r + 4 >> 2], Xe >>> 0 >= e[r + 8 >> 2] - m >> 2 >>> 0)
                                                                          break N;
                                                                        continue;
                                                                      }
                                                                      break;
                                                                    }
                                                                    A = Hr() | 0;
                                                                    break p;
                                                                  }
                                                                  A = Hr() | 0, mu(p + 80 | 0);
                                                                  break p;
                                                                }
                                                                A = Hr() | 0;
                                                                break p;
                                                              }
                                                              if (!hi)
                                                                break k;
                                                            }
                                                            fr = 0;
                                                            N: {
                                                              S: {
                                                                T: {
                                                                  v: {
                                                                    for (; ; ) {
                                                                      if (W = e[p + 32 >> 2], e[r + 8 >> 2] != e[r + 4 >> 2])
                                                                        for (A = 0, N = e[p + 20 >> 2], m = fr; Te = Sn(A, 12), Xe = Te + N | 0, N = e[Xe >> 2], e[(A << 2) + W >> 2] = N + ((m >>> 0) % (e[Xe + 4 >> 2] - N >> 5 >>> 0) << 5), Xe = m, N = e[p + 20 >> 2], m = Te + N | 0, m = (Xe >>> 0) / (e[m + 4 >> 2] - e[m >> 2] >> 5 >>> 0) | 0, A = A + 1 | 0, A >>> 0 < e[r + 8 >> 2] - e[r + 4 >> 2] >> 2 >>> 0; )
                                                                          ;
                                                                      e[p + 108 >> 2] = 0, e[p + 100 >> 2] = 0, e[p + 104 >> 2] = 0;
                                                                      w: {
                                                                        E: {
                                                                          if (Ni = e[p + 36 >> 2], (Ni | 0) != (W | 0))
                                                                            for (; ; ) {
                                                                              Te = e[W >> 2], A = e[p + 104 >> 2];
                                                                              h: {
                                                                                if ((A | 0) != e[p + 108 >> 2]) {
                                                                                  e[A >> 2] = e[Te >> 2], m = e[Te + 4 >> 2], e[A + 4 >> 2] = m, m && (e[m + 4 >> 2] = e[m + 4 >> 2] + 1), e[p + 104 >> 2] = A + 8;
                                                                                  break h;
                                                                                }
                                                                                R: {
                                                                                  N = e[p + 100 >> 2], m = A - N | 0, Hi = m >> 3, Xe = Hi + 1 | 0;
                                                                                  I: {
                                                                                    if (Xe >>> 0 >= 536870912) {
                                                                                      e[5996] = 0, Nn(59);
                                                                                      break I;
                                                                                    }
                                                                                    if (Ln = m >> 2, m = m >>> 0 >= 2147483640 ? 536870911 : Xe >>> 0 < Ln >>> 0 ? Ln : Xe, m >>> 0 < 536870912)
                                                                                      break R;
                                                                                    e[5996] = 0, Nn(35);
                                                                                  }
                                                                                  if (r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                                    break i;
                                                                                  A = Hr() | 0;
                                                                                  break N;
                                                                                }
                                                                                if (e[5996] = 0, Ln = m << 3, Xe = Mi(3, Ln | 0) | 0, m = e[5996], e[5996] = 0, (m | 0) == 1)
                                                                                  break E;
                                                                                m = Xe + (Hi << 3) | 0, e[m >> 2] = e[Te >> 2], Te = e[Te + 4 >> 2], e[m + 4 >> 2] = Te, Te && (e[Te + 4 >> 2] = e[Te + 4 >> 2] + 1, A = e[p + 104 >> 2]), Te = Xe + Ln | 0, Xe = m + 8 | 0;
                                                                                R: {
                                                                                  if ((A | 0) == (N | 0)) {
                                                                                    e[p + 108 >> 2] = Te, e[p + 104 >> 2] = Xe, e[p + 100 >> 2] = m;
                                                                                    break R;
                                                                                  }
                                                                                  for (; m = m - 8 | 0, A = A - 8 | 0, e[m >> 2] = e[A >> 2], e[m + 4 >> 2] = e[A + 4 >> 2], e[A >> 2] = 0, e[A + 4 >> 2] = 0, (A | 0) != (N | 0); )
                                                                                    ;
                                                                                  if (e[p + 108 >> 2] = Te, A = e[p + 104 >> 2], e[p + 104 >> 2] = Xe, N = e[p + 100 >> 2], e[p + 100 >> 2] = m, (A | 0) == (N | 0))
                                                                                    break R;
                                                                                  for (; ; ) {
                                                                                    A = A - 8 | 0, m = e[A + 4 >> 2];
                                                                                    I: {
                                                                                      if (!m || (Te = e[m + 4 >> 2], e[m + 4 >> 2] = Te - 1, Te))
                                                                                        break I;
                                                                                      xi[e[e[m >> 2] + 8 >> 2]](m), ys(m);
                                                                                    }
                                                                                    if ((A | 0) == (N | 0))
                                                                                      break;
                                                                                  }
                                                                                }
                                                                                if (!N)
                                                                                  break h;
                                                                                Br(N);
                                                                              }
                                                                              if (W = W + 4 | 0, (Ni | 0) == (W | 0))
                                                                                break;
                                                                            }
                                                                          if (jn[p + 88 >> 3] = vr, jn[p + 80 >> 3] = ar, e[5996] = 0, W = Mi(3, 104) | 0, m = e[5996], e[5996] = 0, (m | 0) != 1)
                                                                            break w;
                                                                          break S;
                                                                        }
                                                                        A = Hr() | 0;
                                                                        break N;
                                                                      }
                                                                      if (e[W >> 2] = 7e3, e[W + 4 >> 2] = 0, e[W + 8 >> 2] = 0, e[5996] = 0, e[p + 132 >> 2] = e[p + 100 >> 2], m = e[p + 104 >> 2], A = e[p + 108 >> 2], e[p + 108 >> 2] = 0, e[p + 136 >> 2] = m, e[p + 140 >> 2] = A, e[p + 100 >> 2] = 0, e[p + 104 >> 2] = 0, Te = pi(32, p + 120 | 0, _n | 0) | 0, m = e[5996], e[5996] = 0, (m | 0) != 1) {
                                                                        if (m = e[r + 40 >> 2], e[5996] = 0, Xe = Fl(60, W + 12 | 0, 25, p + 132 | 0, Te | 0, m | 0) | 0, m = e[5996], e[5996] = 0, (m | 0) == 1)
                                                                          break v;
                                                                        if (N = e[Te >> 2], N) {
                                                                          if (m = e[p + 124 >> 2], A = N, (m | 0) != (A | 0)) {
                                                                            for (; A = m - 12 | 0, _[m - 1 | 0] < 0 && Br(e[A >> 2]), m = A, (m | 0) != (N | 0); )
                                                                              ;
                                                                            A = e[Te >> 2];
                                                                          }
                                                                          e[p + 124 >> 2] = N, Br(A);
                                                                        }
                                                                        if (m = e[p + 132 >> 2], m) {
                                                                          if (A = e[p + 136 >> 2], (m | 0) != (A | 0)) {
                                                                            for (; ; ) {
                                                                              A = A - 8 | 0, N = e[A + 4 >> 2];
                                                                              w: {
                                                                                if (!N || (Te = e[N + 4 >> 2], e[N + 4 >> 2] = Te - 1, Te))
                                                                                  break w;
                                                                                xi[e[e[N >> 2] + 8 >> 2]](N), ys(N);
                                                                              }
                                                                              if ((A | 0) == (m | 0))
                                                                                break;
                                                                            }
                                                                            m = e[p + 132 >> 2];
                                                                          }
                                                                          Br(m);
                                                                        }
                                                                        if (e[p + 116 >> 2] = W, e[p + 112 >> 2] = Xe, e[5996] = 0, m = e[p + 116 >> 2], e[p + 8 >> 2] = e[p + 112 >> 2], e[p + 12 >> 2] = m, gs(61, s | 0, p + 80 | 0, p + 8 | 0), m = e[5996], e[5996] = 0, (m | 0) == 1)
                                                                          break S;
                                                                        if (m = e[p + 100 >> 2], m) {
                                                                          if (A = e[p + 104 >> 2], (m | 0) != (A | 0)) {
                                                                            for (; ; ) {
                                                                              A = A - 8 | 0, N = e[A + 4 >> 2];
                                                                              w: {
                                                                                if (!N || (W = e[N + 4 >> 2], e[N + 4 >> 2] = W - 1, W))
                                                                                  break w;
                                                                                xi[e[e[N >> 2] + 8 >> 2]](N), ys(N);
                                                                              }
                                                                              if ((A | 0) == (m | 0))
                                                                                break;
                                                                            }
                                                                            m = e[p + 100 >> 2];
                                                                          }
                                                                          Br(m);
                                                                        }
                                                                        if (fr = fr + 1 | 0, (hi | 0) != (fr | 0))
                                                                          continue;
                                                                        break k;
                                                                      }
                                                                      break;
                                                                    }
                                                                    A = Hr() | 0;
                                                                    break T;
                                                                  }
                                                                  A = Hr() | 0, ea(Te);
                                                                }
                                                                Uo(p + 132 | 0), Br(W);
                                                                break N;
                                                              }
                                                              A = Hr() | 0;
                                                            }
                                                            Uo(p + 100 | 0);
                                                            break p;
                                                          }
                                                          if (N = e[p + 20 >> 2], N) {
                                                            if (A = e[p + 24 >> 2], (N | 0) != (A | 0)) {
                                                              for (; ; ) {
                                                                if (fr = A - 12 | 0, W = e[fr >> 2], W) {
                                                                  if (m = W, Te = A - 8 | 0, A = e[Te >> 2], (m | 0) != (A | 0)) {
                                                                    for (; ; ) {
                                                                      A = A - 32 | 0, m = e[A + 4 >> 2];
                                                                      k: {
                                                                        if (!m || (Xe = e[m + 4 >> 2], e[m + 4 >> 2] = Xe - 1, Xe))
                                                                          break k;
                                                                        xi[e[e[m >> 2] + 8 >> 2]](m), ys(m);
                                                                      }
                                                                      if ((A | 0) == (W | 0))
                                                                        break;
                                                                    }
                                                                    m = e[fr >> 2];
                                                                  }
                                                                  e[Te >> 2] = W, Br(m);
                                                                }
                                                                if (A = fr, (N | 0) == (A | 0))
                                                                  break;
                                                              }
                                                              N = e[p + 20 >> 2];
                                                            }
                                                            Br(N);
                                                          }
                                                          if (Ji = Ji + 1 | 0, A = e[p + 44 >> 2], !(Ji >>> 0 < (e[p + 48 >> 2] - A | 0) / 12 >>> 0))
                                                            break;
                                                        }
                                                      if (r = e[p + 32 >> 2], r && (Br(r), A = e[p + 44 >> 2]), A) {
                                                        if (m = A, N = e[p + 48 >> 2], (m | 0) != (N | 0)) {
                                                          for (; r = N - 12 | 0, s = e[r >> 2], s && (e[N - 8 >> 2] = s, Br(s)), N = r, (r | 0) != (A | 0); )
                                                            ;
                                                          m = e[p + 44 >> 2];
                                                        }
                                                        e[p + 48 >> 2] = A, Br(m);
                                                      }
                                                      if (r = e[_r + 12 >> 2], r && (e[_r + 16 >> 2] = r, Br(r)), r = e[_r >> 2], !r)
                                                        break a;
                                                      e[_r + 4 >> 2] = r, Br(r);
                                                      break a;
                                                    }
                                                    if (e[5996] = 0, Vs(44, 5170, 1900, 642, 2497), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                      break i;
                                                    A = Hr() | 0;
                                                  }
                                                  Nc(p + 20 | 0);
                                                  break A;
                                                }
                                                A = Hr() | 0;
                                              }
                                              r = e[p + 32 >> 2], r && Br(r), Xf(p + 44 | 0);
                                              break t;
                                            }
                                            r = Hr() | 0, ya(_r), Jn(r | 0), Oi();
                                          }
                                          A = Hr() | 0;
                                        }
                                        ff(p + 80 | 0);
                                        break t;
                                      }
                                      m = r + 4 | 0, r = r + 16 | 0, ah(s, u, 2, m, r), ah(s, u, 3, m, r);
                                      break a;
                                    }
                                    mc(s, u, 6, r + 4 | 0, r + 28 | 0);
                                    break a;
                                  }
                                  mc(s, u, 8, r + 4 | 0, r + 28 | 0);
                                  break a;
                                }
                                mc(s, u, 7, r + 4 | 0, r + 28 | 0);
                                break a;
                              }
                              mc(s, u, 9, r + 4 | 0, r + 28 | 0);
                            }
                            Jr = p + 144 | 0;
                            return;
                          }
                          A = Hr() | 0;
                          break r;
                        }
                        r = e[p + 132 >> 2], r && Br(r), Xf(p + 80 | 0);
                        break r;
                      }
                      Oi();
                    }
                    ya(p + 56 | 0), Jn(A | 0), Oi();
                  }
                  ya(_r), Jn(A | 0), Oi();
                }
                r = Hr() | 0, Br(m), Jn(r | 0), Oi();
              }
              function sh(r, s, u, A) {
                var m = 0, p = 0, N = 0, W = 0, Te = 0, Xe = 0, fr = 0, ar = 0, vr = 0, _r = 0, hi = 0, mi = 0, Ni = 0, Hi = 0, Ji = 0, Ln = 0, _n = 0, hs = 0, bs = 0, Us = 0, go = 0, _o = 0, ra = 0, fa = 0, ha = 0, xa = 0, tu = 0;
                Ni = Jr - 48 | 0, Jr = Ni;
                e: {
                  if (u >>> 0 <= 2) {
                    for (u = u << 2, _o = e[u + 8972 >> 2], ra = e[u + 8960 >> 2]; ; ) {
                      u = e[s + 4 >> 2];
                      t: {
                        if ((u | 0) != e[s + 104 >> 2]) {
                          e[s + 4 >> 2] = u + 1, u = me[u | 0];
                          break t;
                        }
                        u = Bo(s);
                      }
                      if (!((u | 0) == 32 | u - 9 >>> 0 < 5))
                        break;
                    }
                    Ln = 1;
                    t: {
                      r:
                        switch (u - 43 | 0) {
                          case 0:
                          case 2:
                            break r;
                          default:
                            break t;
                        }
                      if (Ln = (u | 0) == 45 ? -1 : 1, u = e[s + 4 >> 2], (u | 0) != e[s + 104 >> 2]) {
                        e[s + 4 >> 2] = u + 1, u = me[u | 0];
                        break t;
                      }
                      u = Bo(s);
                    }
                    t: {
                      r: {
                        for (; ; ) {
                          if (_[N + 1031 | 0] == (u | 32)) {
                            i: {
                              if (N >>> 0 > 6)
                                break i;
                              if (u = e[s + 4 >> 2], (u | 0) != e[s + 104 >> 2]) {
                                e[s + 4 >> 2] = u + 1, u = me[u | 0];
                                break i;
                              }
                              u = Bo(s);
                            }
                            if (N = N + 1 | 0, (N | 0) != 8)
                              continue;
                            break r;
                          }
                          break;
                        }
                        if ((N | 0) != 3) {
                          if (vr = (N | 0) == 8, vr)
                            break r;
                          if (!A | N >>> 0 < 4)
                            break t;
                          if (vr)
                            break r;
                        }
                        if (u = e[s + 116 >> 2], (u | 0) > 0 | (u | 0) >= 0 && (e[s + 4 >> 2] = e[s + 4 >> 2] - 1), !A | N >>> 0 < 4)
                          break r;
                        for (u = (u | 0) < 0; u || (e[s + 4 >> 2] = e[s + 4 >> 2] - 1), N = N - 1 | 0, N >>> 0 > 3; )
                          ;
                      }
                      ar = Jr - 16 | 0, Jr = ar, W = ($o(ma(ma(Ln | 0) * ma(1 / 0))), _s(2)), s = W & 2147483647;
                      r: {
                        if (s - 8388608 >>> 0 <= 2130706431) {
                          u = s, s = s >>> 7 | 0, u = u << 25, A = s + 1065353216 | 0;
                          break r;
                        }
                        if (u = W << 25, A = W >>> 7 | 2147418112, s >>> 0 >= 2139095040 || (u = 0, A = 0, !s))
                          break r;
                        u = s, s = Fo(s), Ea(ar, u, 0, 0, 0, s + 81 | 0), Xe = e[ar >> 2], Te = e[ar + 4 >> 2], u = e[ar + 8 >> 2], A = e[ar + 12 >> 2] ^ 65536 | 16265 - s << 16;
                      }
                      e[Ni >> 2] = Xe, e[Ni + 4 >> 2] = Te, e[Ni + 8 >> 2] = u, e[Ni + 12 >> 2] = W & -2147483648 | A, Jr = ar + 16 | 0, Xe = e[Ni + 8 >> 2], Te = e[Ni + 12 >> 2], W = e[Ni >> 2], fr = e[Ni + 4 >> 2];
                      break e;
                    }
                    t: {
                      r: {
                        i: {
                          if (N)
                            break i;
                          for (N = 0; ; ) {
                            if (_[N + 2020 | 0] != (u | 32))
                              break i;
                            n: {
                              if (N >>> 0 > 1)
                                break n;
                              if (u = e[s + 4 >> 2], (u | 0) != e[s + 104 >> 2]) {
                                e[s + 4 >> 2] = u + 1, u = me[u | 0];
                                break n;
                              }
                              u = Bo(s);
                            }
                            if (N = N + 1 | 0, (N | 0) == 3)
                              break;
                          }
                          break r;
                        }
                        i:
                          switch (N | 0) {
                            case 0:
                              n: {
                                if ((u | 0) != 48)
                                  break n;
                                N = e[s + 4 >> 2];
                                s: {
                                  if ((N | 0) != e[s + 104 >> 2]) {
                                    e[s + 4 >> 2] = N + 1, N = me[N | 0];
                                    break s;
                                  }
                                  N = Bo(s);
                                }
                                if ((N & -33) == 88) {
                                  vr = 0, p = Jr - 432 | 0, Jr = p, u = e[s + 4 >> 2];
                                  s: {
                                    if ((u | 0) != e[s + 104 >> 2]) {
                                      e[s + 4 >> 2] = u + 1, N = me[u | 0];
                                      break s;
                                    }
                                    N = Bo(s);
                                  }
                                  s: {
                                    a: {
                                      for (; ; ) {
                                        if ((N | 0) != 48)
                                          o: {
                                            if ((N | 0) != 46)
                                              break s;
                                            if (u = e[s + 4 >> 2], (u | 0) == e[s + 104 >> 2])
                                              break o;
                                            e[s + 4 >> 2] = u + 1, N = me[u | 0];
                                            break a;
                                          }
                                        else {
                                          u = e[s + 4 >> 2], (u | 0) != e[s + 104 >> 2] ? (m = 1, e[s + 4 >> 2] = u + 1, N = me[u | 0]) : (m = 1, N = Bo(s));
                                          continue;
                                        }
                                        break;
                                      }
                                      N = Bo(s);
                                    }
                                    if (mi = 1, (N | 0) != 48)
                                      break s;
                                    for (; ; ) {
                                      u = Hi, Hi = u - 1 | 0, Ji = Ji - !u | 0, u = e[s + 4 >> 2];
                                      a: {
                                        if ((u | 0) != e[s + 104 >> 2]) {
                                          e[s + 4 >> 2] = u + 1, N = me[u | 0];
                                          break a;
                                        }
                                        N = Bo(s);
                                      }
                                      if ((N | 0) != 48)
                                        break;
                                    }
                                    m = 1;
                                  }
                                  fr = 1073676288;
                                  s: {
                                    for (; ; ) {
                                      a: {
                                        u = N | 32;
                                        o: {
                                          l: {
                                            if (ha = N - 48 | 0, ha >>> 0 < 10)
                                              break l;
                                            if (xa = (N | 0) != 46, xa & u - 97 >>> 0 > 5)
                                              break s;
                                            if (xa)
                                              break l;
                                            if (mi)
                                              break a;
                                            mi = 1, Hi = Xe, Ji = Te;
                                            break o;
                                          }
                                          u = (N | 0) > 57 ? u - 87 | 0 : ha;
                                          l: {
                                            if ((Te | 0) <= 0 & Xe >>> 0 <= 7 | (Te | 0) < 0) {
                                              vr = u + (vr << 4) | 0;
                                              break l;
                                            }
                                            if (!Te & Xe >>> 0 <= 28) {
                                              Ya(p + 48 | 0, u), Qo(p + 32 | 0, Us, go, W, fr, 0, 0, 0, 1073414144), Us = e[p + 32 >> 2], go = e[p + 36 >> 2], W = e[p + 40 >> 2], fr = e[p + 44 >> 2], Qo(p + 16 | 0, e[p + 48 >> 2], e[p + 52 >> 2], e[p + 56 >> 2], e[p + 60 >> 2], Us, go, W, fr), Ka(p, e[p + 16 >> 2], e[p + 20 >> 2], e[p + 24 >> 2], e[p + 28 >> 2], ar, hi, hs, bs), hs = e[p + 8 >> 2], bs = e[p + 12 >> 2], ar = e[p >> 2], hi = e[p + 4 >> 2];
                                              break l;
                                            }
                                            if (fa | !u)
                                              break l;
                                            Qo(p + 80 | 0, Us, go, W, fr, 0, 0, 0, 1073610752), Ka(p - -64 | 0, e[p + 80 >> 2], e[p + 84 >> 2], e[p + 88 >> 2], e[p + 92 >> 2], ar, hi, hs, bs), hs = e[p + 72 >> 2], bs = e[p + 76 >> 2], fa = 1, ar = e[p + 64 >> 2], hi = e[p + 68 >> 2];
                                          }
                                          Xe = Xe + 1 | 0, Te = Xe ? Te : Te + 1 | 0, m = 1;
                                        }
                                        u = e[s + 4 >> 2], (u | 0) != e[s + 104 >> 2] ? (e[s + 4 >> 2] = u + 1, N = me[u | 0]) : N = Bo(s);
                                        continue;
                                      }
                                      break;
                                    }
                                    N = 46;
                                  }
                                  s: {
                                    if (!m) {
                                      u = e[s + 116 >> 2];
                                      a: {
                                        o: {
                                          if ((u | 0) > 0 | (u | 0) >= 0) {
                                            if (u = e[s + 4 >> 2], e[s + 4 >> 2] = u - 1, !A)
                                              break o;
                                            if (e[s + 4 >> 2] = u - 2, !mi)
                                              break a;
                                            e[s + 4 >> 2] = u - 3;
                                            break a;
                                          }
                                          if (A)
                                            break a;
                                        }
                                        wu(s, 0, 0);
                                      }
                                      Nu(p + 96 | 0, +(Ln | 0) * 0), ar = e[p + 96 >> 2], hi = e[p + 100 >> 2], u = e[p + 108 >> 2], s = e[p + 104 >> 2];
                                      break s;
                                    }
                                    if ((Te | 0) <= 0 & Xe >>> 0 <= 7 | (Te | 0) < 0)
                                      for (W = Xe, fr = Te; vr = vr << 4, W = W + 1 | 0, fr = W ? fr : fr + 1 | 0, !!((W | 0) != 8 | fr); )
                                        ;
                                    a: {
                                      o: {
                                        l: {
                                          if ((N & -33) == 80) {
                                            if (W = Tu(s, A), u = Ds, fr = u, W | (u | 0) != -2147483648)
                                              break a;
                                            if (A) {
                                              if (u = e[s + 116 >> 2], (u | 0) > 0 | (u | 0) >= 0)
                                                break l;
                                              break o;
                                            }
                                            ar = 0, hi = 0, wu(s, 0, 0), u = 0, s = 0;
                                            break s;
                                          }
                                          if (W = 0, fr = 0, e[s + 116 >> 2] < 0)
                                            break a;
                                        }
                                        e[s + 4 >> 2] = e[s + 4 >> 2] - 1;
                                      }
                                      W = 0, fr = 0;
                                    }
                                    if (!vr) {
                                      Nu(p + 112 | 0, +(Ln | 0) * 0), ar = e[p + 112 >> 2], hi = e[p + 116 >> 2], u = e[p + 124 >> 2], s = e[p + 120 >> 2];
                                      break s;
                                    }
                                    if (s = mi ? Hi : Xe, Te = (mi ? Ji : Te) << 2 | s >>> 30, u = W + (s << 2) | 0, s = Te + fr | 0, Xe = u - 32 | 0, Te = (u >>> 0 < W >>> 0 ? s + 1 | 0 : s) - (u >>> 0 < 32) | 0, s = Te, Xe >>> 0 > 0 - _o >>> 0 & (s | 0) >= 0 | (s | 0) > 0) {
                                      e[5732] = 68, Ya(p + 160 | 0, Ln), Qo(p + 144 | 0, e[p + 160 >> 2], e[p + 164 >> 2], e[p + 168 >> 2], e[p + 172 >> 2], -1, -1, -1, 2147418111), Qo(p + 128 | 0, e[p + 144 >> 2], e[p + 148 >> 2], e[p + 152 >> 2], e[p + 156 >> 2], -1, -1, -1, 2147418111), ar = e[p + 128 >> 2], hi = e[p + 132 >> 2], u = e[p + 140 >> 2], s = e[p + 136 >> 2];
                                      break s;
                                    }
                                    if (s = _o - 226 | 0, u = s >> 31, (Te | 0) >= (u | 0) & s >>> 0 <= Xe >>> 0 | (u | 0) < (Te | 0)) {
                                      if ((vr | 0) >= 0)
                                        for (; Ka(p + 416 | 0, ar, hi, hs, bs, 0, 0, 0, -1073807360), s = jh(ar, hi, hs, bs, 1073610752), u = (s | 0) >= 0, s = u, Ka(p + 400 | 0, ar, hi, hs, bs, s ? e[p + 416 >> 2] : ar, s ? e[p + 420 >> 2] : hi, s ? e[p + 424 >> 2] : hs, s ? e[p + 428 >> 2] : bs), s = Xe, Xe = s - 1 | 0, Te = Te - !s | 0, hs = e[p + 408 >> 2], bs = e[p + 412 >> 2], ar = e[p + 400 >> 2], hi = e[p + 404 >> 2], vr = u | vr << 1, (vr | 0) >= 0; )
                                          ;
                                      s = Te - ((_o >> 31) + (Xe >>> 0 < _o >>> 0) | 0) | 0, u = (Xe - _o | 0) + 32 | 0, s = u >>> 0 < 32 ? s + 1 | 0 : s, u = u >>> 0 < ra >>> 0 & (s | 0) <= 0 | (s | 0) < 0 ? (u | 0) > 0 ? u : 0 : ra;
                                      a: {
                                        if ((u | 0) >= 113) {
                                          Ya(p + 384 | 0, Ln), Hi = e[p + 392 >> 2], Ji = e[p + 396 >> 2], Us = e[p + 384 >> 2], go = e[p + 388 >> 2], W = 0, s = 0;
                                          break a;
                                        }
                                        Nu(p + 352 | 0, Pd(144 - u | 0)), Ya(p + 336 | 0, Ln), Us = e[p + 336 >> 2], go = e[p + 340 >> 2], Hi = e[p + 344 >> 2], Ji = e[p + 348 >> 2], b1(p + 368 | 0, e[p + 352 >> 2], e[p + 356 >> 2], e[p + 360 >> 2], e[p + 364 >> 2], Us, go, Hi, Ji), _r = e[p + 376 >> 2], _n = e[p + 380 >> 2], W = e[p + 372 >> 2], s = e[p + 368 >> 2];
                                      }
                                      A = !(vr & 1) & ((Ju(ar, hi, hs, bs, 0, 0, 0, 0) | 0) != 0 & (u | 0) < 32), Yf(p + 320 | 0, A + vr | 0), Qo(p + 304 | 0, Us, go, Hi, Ji, e[p + 320 >> 2], e[p + 324 >> 2], e[p + 328 >> 2], e[p + 332 >> 2]), u = s, Ka(p + 272 | 0, e[p + 304 >> 2], e[p + 308 >> 2], e[p + 312 >> 2], e[p + 316 >> 2], s, W, _r, _n), s = A, Qo(p + 288 | 0, Us, go, Hi, Ji, s ? 0 : ar, s ? 0 : hi, s ? 0 : hs, s ? 0 : bs), Ka(p + 256 | 0, e[p + 288 >> 2], e[p + 292 >> 2], e[p + 296 >> 2], e[p + 300 >> 2], e[p + 272 >> 2], e[p + 276 >> 2], e[p + 280 >> 2], e[p + 284 >> 2]), $s(p + 240 | 0, e[p + 256 >> 2], e[p + 260 >> 2], e[p + 264 >> 2], e[p + 268 >> 2], u, W, _r, _n), s = e[p + 240 >> 2], A = e[p + 244 >> 2], u = e[p + 248 >> 2], W = e[p + 252 >> 2], Ju(s, A, u, W, 0, 0, 0, 0) || (e[5732] = 68), Th(p + 224 | 0, s, A, u, W, Xe), ar = e[p + 224 >> 2], hi = e[p + 228 >> 2], u = e[p + 236 >> 2], s = e[p + 232 >> 2];
                                      break s;
                                    }
                                    e[5732] = 68, Ya(p + 208 | 0, Ln), Qo(p + 192 | 0, e[p + 208 >> 2], e[p + 212 >> 2], e[p + 216 >> 2], e[p + 220 >> 2], 0, 0, 0, 65536), Qo(p + 176 | 0, e[p + 192 >> 2], e[p + 196 >> 2], e[p + 200 >> 2], e[p + 204 >> 2], 0, 0, 0, 65536), ar = e[p + 176 >> 2], hi = e[p + 180 >> 2], u = e[p + 188 >> 2], s = e[p + 184 >> 2];
                                  }
                                  e[Ni + 16 >> 2] = ar, e[Ni + 20 >> 2] = hi, e[Ni + 24 >> 2] = s, e[Ni + 28 >> 2] = u, Jr = p + 432 | 0, Xe = e[Ni + 24 >> 2], Te = e[Ni + 28 >> 2], W = e[Ni + 16 >> 2], fr = e[Ni + 20 >> 2];
                                  break e;
                                }
                                if (e[s + 116 >> 2] < 0)
                                  break n;
                                e[s + 4 >> 2] = e[s + 4 >> 2] - 1;
                              }
                              N = s, vr = u, p = A, A = 0, m = Jr - 8976 | 0, Jr = m, xa = 0 - _o | 0, ha = xa - ra | 0;
                              n: {
                                s: {
                                  for (; ; ) {
                                    if ((vr | 0) != 48)
                                      a: {
                                        if ((vr | 0) != 46)
                                          break n;
                                        if (s = e[N + 4 >> 2], (s | 0) == e[N + 104 >> 2])
                                          break a;
                                        e[N + 4 >> 2] = s + 1, vr = me[s | 0];
                                        break s;
                                      }
                                    else {
                                      s = e[N + 4 >> 2], (s | 0) != e[N + 104 >> 2] ? (e[N + 4 >> 2] = s + 1, vr = me[s | 0]) : vr = Bo(N), A = 1;
                                      continue;
                                    }
                                    break;
                                  }
                                  vr = Bo(N);
                                }
                                if (fa = 1, (vr | 0) != 48)
                                  break n;
                                for (; ; ) {
                                  s = Xe, Xe = s - 1 | 0, Te = Te - !s | 0, s = e[N + 4 >> 2];
                                  s: {
                                    if ((s | 0) != e[N + 104 >> 2]) {
                                      e[N + 4 >> 2] = s + 1, vr = me[s | 0];
                                      break s;
                                    }
                                    vr = Bo(N);
                                  }
                                  if ((vr | 0) != 48)
                                    break;
                                }
                                A = 1;
                              }
                              e[m + 784 >> 2] = 0;
                              n: {
                                s: {
                                  s = (vr | 0) == 46, u = vr - 48 | 0;
                                  a: {
                                    o: {
                                      l: {
                                        if (s | u >>> 0 <= 9)
                                          for (; ; ) {
                                            c: {
                                              if (s & 1) {
                                                if (!fa) {
                                                  Xe = W, Te = fr, fa = 1;
                                                  break c;
                                                }
                                                s = !A;
                                                break l;
                                              }
                                              if (W = W + 1 | 0, fr = W ? fr : fr + 1 | 0, (mi | 0) <= 2044) {
                                                _n = (vr | 0) == 48 ? _n : W, s = (m + 784 | 0) + (mi << 2) | 0, _r && (u = (Sn(e[s >> 2], 10) + vr | 0) - 48 | 0), e[s >> 2] = u, A = 1, u = _r + 1 | 0, s = (u | 0) == 9, _r = s ? 0 : u, mi = s + mi | 0;
                                                break c;
                                              }
                                              if ((vr | 0) == 48)
                                                break c;
                                              e[m + 8960 >> 2] = e[m + 8960 >> 2] | 1, _n = 18396;
                                            }
                                            s = e[N + 4 >> 2];
                                            c: {
                                              if ((s | 0) != e[N + 104 >> 2]) {
                                                e[N + 4 >> 2] = s + 1, vr = me[s | 0];
                                                break c;
                                              }
                                              vr = Bo(N);
                                            }
                                            if (s = (vr | 0) == 46, u = vr - 48 | 0, !(s | u >>> 0 < 10))
                                              break;
                                          }
                                        if (Xe = fa ? Xe : W, Te = fa ? Te : fr, !(!A | (vr & -33) != 69)) {
                                          ar = Tu(N, p), s = Ds, hi = s;
                                          c: {
                                            if (ar | (s | 0) != -2147483648)
                                              break c;
                                            if (!p)
                                              break a;
                                            if (ar = 0, hi = 0, e[N + 116 >> 2] < 0)
                                              break c;
                                            e[N + 4 >> 2] = e[N + 4 >> 2] - 1;
                                          }
                                          Te = Te + hi | 0, Xe = Xe + ar | 0, Te = Xe >>> 0 < ar >>> 0 ? Te + 1 | 0 : Te;
                                          break s;
                                        }
                                        if (s = !A, (vr | 0) < 0)
                                          break o;
                                      }
                                      if (e[N + 116 >> 2] < 0)
                                        break o;
                                      e[N + 4 >> 2] = e[N + 4 >> 2] - 1;
                                    }
                                    if (!s)
                                      break s;
                                    e[5732] = 28;
                                  }
                                  W = 0, fr = 0, wu(N, 0, 0), u = 0, s = 0;
                                  break n;
                                }
                                if (s = e[m + 784 >> 2], !s) {
                                  Nu(m, +(Ln | 0) * 0), W = e[m >> 2], fr = e[m + 4 >> 2], u = e[m + 12 >> 2], s = e[m + 8 >> 2];
                                  break n;
                                }
                                if (!(W >>> 0 > 9 & (fr | 0) >= 0 | (fr | 0) > 0 | ((W | 0) != (Xe | 0) | (Te | 0) != (fr | 0)) | (s >>> ra | 0 ? (ra | 0) <= 30 : 0))) {
                                  Ya(m + 48 | 0, Ln), Yf(m + 32 | 0, s), Qo(m + 16 | 0, e[m + 48 >> 2], e[m + 52 >> 2], e[m + 56 >> 2], e[m + 60 >> 2], e[m + 32 >> 2], e[m + 36 >> 2], e[m + 40 >> 2], e[m + 44 >> 2]), W = e[m + 16 >> 2], fr = e[m + 20 >> 2], u = e[m + 28 >> 2], s = e[m + 24 >> 2];
                                  break n;
                                }
                                if (Xe >>> 0 > xa >>> 1 >>> 0 & (Te | 0) >= 0 | (Te | 0) > 0) {
                                  e[5732] = 68, Ya(m + 96 | 0, Ln), Qo(m + 80 | 0, e[m + 96 >> 2], e[m + 100 >> 2], e[m + 104 >> 2], e[m + 108 >> 2], -1, -1, -1, 2147418111), Qo(m - -64 | 0, e[m + 80 >> 2], e[m + 84 >> 2], e[m + 88 >> 2], e[m + 92 >> 2], -1, -1, -1, 2147418111), W = e[m + 64 >> 2], fr = e[m + 68 >> 2], u = e[m + 76 >> 2], s = e[m + 72 >> 2];
                                  break n;
                                }
                                if (s = _o - 226 | 0, u = Xe >>> 0 < s >>> 0, s = s >> 31, u & (Te | 0) <= (s | 0) | (s | 0) > (Te | 0)) {
                                  e[5732] = 68, Ya(m + 144 | 0, Ln), Qo(m + 128 | 0, e[m + 144 >> 2], e[m + 148 >> 2], e[m + 152 >> 2], e[m + 156 >> 2], 0, 0, 0, 65536), Qo(m + 112 | 0, e[m + 128 >> 2], e[m + 132 >> 2], e[m + 136 >> 2], e[m + 140 >> 2], 0, 0, 0, 65536), W = e[m + 112 >> 2], fr = e[m + 116 >> 2], u = e[m + 124 >> 2], s = e[m + 120 >> 2];
                                  break n;
                                }
                                if (_r) {
                                  if ((_r | 0) <= 8) {
                                    for (s = (m + 784 | 0) + (mi << 2) | 0, N = e[s >> 2]; N = Sn(N, 10), _r = _r + 1 | 0, (_r | 0) != 9; )
                                      ;
                                    e[s >> 2] = N;
                                  }
                                  mi = mi + 1 | 0;
                                }
                                _r = Xe;
                                s: {
                                  if ((Xe | 0) < (_n | 0) | (_n | 0) >= 9 | (Xe | 0) > 17)
                                    break s;
                                  if ((Xe | 0) == 9) {
                                    Ya(m + 192 | 0, Ln), Yf(m + 176 | 0, e[m + 784 >> 2]), Qo(m + 160 | 0, e[m + 192 >> 2], e[m + 196 >> 2], e[m + 200 >> 2], e[m + 204 >> 2], e[m + 176 >> 2], e[m + 180 >> 2], e[m + 184 >> 2], e[m + 188 >> 2]), W = e[m + 160 >> 2], fr = e[m + 164 >> 2], u = e[m + 172 >> 2], s = e[m + 168 >> 2];
                                    break n;
                                  }
                                  if ((_r | 0) <= 8) {
                                    Ya(m + 272 | 0, Ln), Yf(m + 256 | 0, e[m + 784 >> 2]), Qo(m + 240 | 0, e[m + 272 >> 2], e[m + 276 >> 2], e[m + 280 >> 2], e[m + 284 >> 2], e[m + 256 >> 2], e[m + 260 >> 2], e[m + 264 >> 2], e[m + 268 >> 2]), Ya(m + 224 | 0, e[(0 - _r << 2) + 8960 >> 2]), Wl(m + 208 | 0, e[m + 240 >> 2], e[m + 244 >> 2], e[m + 248 >> 2], e[m + 252 >> 2], e[m + 224 >> 2], e[m + 228 >> 2], e[m + 232 >> 2], e[m + 236 >> 2]), W = e[m + 208 >> 2], fr = e[m + 212 >> 2], u = e[m + 220 >> 2], s = e[m + 216 >> 2];
                                    break n;
                                  }
                                  if (s = (Sn(_r, -3) + ra | 0) + 27 | 0, u = e[m + 784 >> 2], u >>> s | 0 && (s | 0) <= 30)
                                    break s;
                                  Ya(m + 352 | 0, Ln), Yf(m + 336 | 0, u), Qo(m + 320 | 0, e[m + 352 >> 2], e[m + 356 >> 2], e[m + 360 >> 2], e[m + 364 >> 2], e[m + 336 >> 2], e[m + 340 >> 2], e[m + 344 >> 2], e[m + 348 >> 2]), Ya(m + 304 | 0, e[(_r << 2) + 8888 >> 2]), Qo(m + 288 | 0, e[m + 320 >> 2], e[m + 324 >> 2], e[m + 328 >> 2], e[m + 332 >> 2], e[m + 304 >> 2], e[m + 308 >> 2], e[m + 312 >> 2], e[m + 316 >> 2]), W = e[m + 288 >> 2], fr = e[m + 292 >> 2], u = e[m + 300 >> 2], s = e[m + 296 >> 2];
                                  break n;
                                }
                                for (; s = mi, mi = s - 1 | 0, !e[(m + 784 | 0) + (mi << 2) >> 2]; )
                                  ;
                                _n = 0, A = (_r | 0) % 9 | 0;
                                s: {
                                  if (!A) {
                                    u = 0;
                                    break s;
                                  }
                                  u = 0, A = (_r | 0) < 0 ? A + 9 | 0 : A;
                                  a: {
                                    if (!s) {
                                      s = 0;
                                      break a;
                                    }
                                    for (Xe = e[(0 - A << 2) + 8960 >> 2], ar = 1e9 / (Xe | 0) | 0, vr = 0, N = 0; W = vr, Te = m + 784 | 0, fr = Te + (N << 2) | 0, vr = e[fr >> 2], mi = (vr >>> 0) / (Xe >>> 0) | 0, W = W + mi | 0, e[fr >> 2] = W, W = !W & (u | 0) == (N | 0), u = W ? u + 1 & 2047 : u, _r = W ? _r - 9 | 0 : _r, vr = Sn(ar, vr - Sn(Xe, mi) | 0), N = N + 1 | 0, (N | 0) != (s | 0); )
                                      ;
                                    if (!vr)
                                      break a;
                                    e[Te + (s << 2) >> 2] = vr, s = s + 1 | 0;
                                  }
                                  _r = (_r - A | 0) + 9 | 0;
                                }
                                for (; ; ) {
                                  N = (m + 784 | 0) + (u << 2) | 0;
                                  s: {
                                    for (; ; ) {
                                      a: {
                                        if ((_r | 0) < 36)
                                          break a;
                                        if ((_r | 0) != 36)
                                          break s;
                                        if (Ls[N >> 2] <= 10384592)
                                          break a;
                                        _r = 36;
                                        break s;
                                      }
                                      for (mi = s + 2047 | 0, A = 0; W = s, ar = mi & 2047, vr = (m + 784 | 0) + (ar << 2) | 0, s = e[vr >> 2], fr = s >>> 3 | 0, Xe = A, A = s << 29, Xe = Xe + A | 0, s = fr, Te = A >>> 0 > Xe >>> 0 ? s + 1 | 0 : s, !Te & Xe >>> 0 < 1000000001 ? A = 0 : (A = dd(Xe, Te, 1e9), s = Ao(A, Ds, -1e9, -1), Xe = s + Xe | 0), e[vr >> 2] = Xe, s = (u | 0) == (ar | 0) || Xe ? W : ar, Xe = W - 1 & 2047, s = (Xe | 0) != (ar | 0) ? W : s, mi = ar - 1 | 0, (u | 0) != (ar | 0); )
                                        ;
                                      if (_n = _n - 29 | 0, s = W, !!A)
                                        break;
                                    }
                                    u = u - 1 & 2047, (u | 0) == (s | 0) && (N = (s + 2046 & 2047) << 2, s = m + 784 | 0, W = N + s | 0, e[W >> 2] = e[W >> 2] | e[s + (Xe << 2) >> 2], s = Xe), _r = _r + 9 | 0, e[(m + 784 | 0) + (u << 2) >> 2] = A;
                                    continue;
                                  }
                                  break;
                                }
                                s: {
                                  a: for (; ; ) {
                                    for (Xe = s + 1 & 2047, ar = (m + 784 | 0) + ((s - 1 & 2047) << 2) | 0; ; ) {
                                      W = (_r | 0) > 45 ? 9 : 1;
                                      o: {
                                        for (; ; ) {
                                          A = u, N = 0;
                                          l: {
                                            for (; ; ) {
                                              c: {
                                                if (u = A + N & 2047, (u | 0) == (s | 0) || (u = e[(m + 784 | 0) + (u << 2) >> 2], Te = e[(N << 2) + 8912 >> 2], u >>> 0 < Te >>> 0))
                                                  break c;
                                                if (u >>> 0 > Te >>> 0)
                                                  break l;
                                                if (N = N + 1 | 0, (N | 0) != 4)
                                                  continue;
                                              }
                                              break;
                                            }
                                            if ((_r | 0) != 36)
                                              break l;
                                            for (N = 0, Xe = 0, Te = 0, W = 0, fr = 0; u = A + N & 2047, (u | 0) == (s | 0) && (s = s + 1 & 2047, e[(m + (s << 2) | 0) + 780 >> 2] = 0), Yf(m + 768 | 0, e[(m + 784 | 0) + (u << 2) >> 2]), Qo(m + 752 | 0, Xe, Te, W, fr, 0, 0, 1342177280, 1075633366), Ka(m + 736 | 0, e[m + 752 >> 2], e[m + 756 >> 2], e[m + 760 >> 2], e[m + 764 >> 2], e[m + 768 >> 2], e[m + 772 >> 2], e[m + 776 >> 2], e[m + 780 >> 2]), W = e[m + 744 >> 2], fr = e[m + 748 >> 2], Xe = e[m + 736 >> 2], Te = e[m + 740 >> 2], N = N + 1 | 0, (N | 0) != 4; )
                                              ;
                                            if (Ya(m + 720 | 0, Ln), Qo(m + 704 | 0, Xe, Te, W, fr, e[m + 720 >> 2], e[m + 724 >> 2], e[m + 728 >> 2], e[m + 732 >> 2]), W = e[m + 712 >> 2], fr = e[m + 716 >> 2], Xe = 0, Te = 0, ar = e[m + 704 >> 2], hi = e[m + 708 >> 2], mi = _n + 113 | 0, N = mi - _o | 0, vr = (N | 0) < (ra | 0), u = vr ? (N | 0) > 0 ? N : 0 : ra, (u | 0) <= 112)
                                              break o;
                                            break s;
                                          }
                                          if (_n = W + _n | 0, u = s, (s | 0) != (A | 0))
                                            break;
                                        }
                                        for (fr = 1e9 >>> W | 0, vr = -1 << W ^ -1, N = 0, u = A; Te = N, mi = m + 784 | 0, N = mi + (A << 2) | 0, p = e[N >> 2], Te = Te + (p >>> W | 0) | 0, e[N >> 2] = Te, Te = !Te & (u | 0) == (A | 0), u = Te ? u + 1 & 2047 : u, _r = Te ? _r - 9 | 0 : _r, N = Sn(fr, p & vr), A = A + 1 & 2047, (A | 0) != (s | 0); )
                                          ;
                                        if (!N)
                                          continue;
                                        if ((u | 0) != (Xe | 0)) {
                                          e[mi + (s << 2) >> 2] = N, s = Xe;
                                          continue a;
                                        }
                                        e[ar >> 2] = e[ar >> 2] | 1;
                                        continue;
                                      }
                                      break;
                                    }
                                    break;
                                  }
                                  Nu(m + 656 | 0, Pd(225 - u | 0)), b1(m + 688 | 0, e[m + 656 >> 2], e[m + 660 >> 2], e[m + 664 >> 2], e[m + 668 >> 2], ar, hi, W, fr), Us = e[m + 696 >> 2], go = e[m + 700 >> 2], hs = e[m + 688 >> 2], bs = e[m + 692 >> 2], Nu(m + 640 | 0, Pd(113 - u | 0)), _l(m + 672 | 0, ar, hi, W, fr, e[m + 640 >> 2], e[m + 644 >> 2], e[m + 648 >> 2], e[m + 652 >> 2]), Xe = e[m + 672 >> 2], Te = e[m + 676 >> 2], Hi = e[m + 680 >> 2], Ji = e[m + 684 >> 2], $s(m + 624 | 0, ar, hi, W, fr, Xe, Te, Hi, Ji), Ka(m + 608 | 0, hs, bs, Us, go, e[m + 624 >> 2], e[m + 628 >> 2], e[m + 632 >> 2], e[m + 636 >> 2]), W = e[m + 616 >> 2], fr = e[m + 620 >> 2], ar = e[m + 608 >> 2], hi = e[m + 612 >> 2];
                                }
                                _r = A + 4 & 2047;
                                s: {
                                  if ((_r | 0) == (s | 0))
                                    break s;
                                  _r = e[(m + 784 | 0) + (_r << 2) >> 2];
                                  a: {
                                    if (_r >>> 0 <= 499999999) {
                                      if (!_r & (A + 5 & 2047) == (s | 0))
                                        break a;
                                      Nu(m + 496 | 0, +(Ln | 0) * 0.25), Ka(m + 480 | 0, Xe, Te, Hi, Ji, e[m + 496 >> 2], e[m + 500 >> 2], e[m + 504 >> 2], e[m + 508 >> 2]), Hi = e[m + 488 >> 2], Ji = e[m + 492 >> 2], Xe = e[m + 480 >> 2], Te = e[m + 484 >> 2];
                                      break a;
                                    }
                                    if ((_r | 0) != 5e8) {
                                      Nu(m + 592 | 0, +(Ln | 0) * 0.75), Ka(m + 576 | 0, Xe, Te, Hi, Ji, e[m + 592 >> 2], e[m + 596 >> 2], e[m + 600 >> 2], e[m + 604 >> 2]), Hi = e[m + 584 >> 2], Ji = e[m + 588 >> 2], Xe = e[m + 576 >> 2], Te = e[m + 580 >> 2];
                                      break a;
                                    }
                                    if (tu = +(Ln | 0), (A + 5 & 2047) == (s | 0)) {
                                      Nu(m + 528 | 0, tu * 0.5), Ka(m + 512 | 0, Xe, Te, Hi, Ji, e[m + 528 >> 2], e[m + 532 >> 2], e[m + 536 >> 2], e[m + 540 >> 2]), Hi = e[m + 520 >> 2], Ji = e[m + 524 >> 2], Xe = e[m + 512 >> 2], Te = e[m + 516 >> 2];
                                      break a;
                                    }
                                    Nu(m + 560 | 0, tu * 0.75), Ka(m + 544 | 0, Xe, Te, Hi, Ji, e[m + 560 >> 2], e[m + 564 >> 2], e[m + 568 >> 2], e[m + 572 >> 2]), Hi = e[m + 552 >> 2], Ji = e[m + 556 >> 2], Xe = e[m + 544 >> 2], Te = e[m + 548 >> 2];
                                  }
                                  if ((u | 0) > 111 || (_l(m + 464 | 0, Xe, Te, Hi, Ji, 0, 0, 0, 1073676288), Ju(e[m + 464 >> 2], e[m + 468 >> 2], e[m + 472 >> 2], e[m + 476 >> 2], 0, 0, 0, 0)))
                                    break s;
                                  Ka(m + 448 | 0, Xe, Te, Hi, Ji, 0, 0, 0, 1073676288), Hi = e[m + 456 >> 2], Ji = e[m + 460 >> 2], Xe = e[m + 448 >> 2], Te = e[m + 452 >> 2];
                                }
                                Ka(m + 432 | 0, ar, hi, W, fr, Xe, Te, Hi, Ji), $s(m + 416 | 0, e[m + 432 >> 2], e[m + 436 >> 2], e[m + 440 >> 2], e[m + 444 >> 2], hs, bs, Us, go), W = e[m + 424 >> 2], fr = e[m + 428 >> 2], ar = e[m + 416 >> 2], hi = e[m + 420 >> 2];
                                s: {
                                  if ((ha - 2 | 0) >= (mi & 2147483647) || (e[m + 408 >> 2] = W, e[m + 412 >> 2] = fr & 2147483647, e[m + 400 >> 2] = ar, e[m + 404 >> 2] = hi, Qo(m + 384 | 0, ar, hi, W, fr, 0, 0, 0, 1073610752), A = jh(e[m + 400 >> 2], e[m + 404 >> 2], e[m + 408 >> 2], e[m + 412 >> 2], 1081081856), s = (A | 0) >= 0, W = s ? e[m + 392 >> 2] : W, fr = s ? e[m + 396 >> 2] : fr, ar = s ? e[m + 384 >> 2] : ar, hi = s ? e[m + 388 >> 2] : hi, _n = s + _n | 0, !(vr & ((u | 0) != (N | 0) | (A | 0) < 0) & (Ju(Xe, Te, Hi, Ji, 0, 0, 0, 0) | 0) != 0) & (_n + 110 | 0) <= (ha | 0)))
                                    break s;
                                  e[5732] = 68;
                                }
                                Th(m + 368 | 0, ar, hi, W, fr, _n), W = e[m + 368 >> 2], fr = e[m + 372 >> 2], u = e[m + 380 >> 2], s = e[m + 376 >> 2];
                              }
                              e[Ni + 40 >> 2] = s, e[Ni + 44 >> 2] = u, e[Ni + 32 >> 2] = W, e[Ni + 36 >> 2] = fr, Jr = m + 8976 | 0, Xe = e[Ni + 40 >> 2], Te = e[Ni + 44 >> 2], W = e[Ni + 32 >> 2], fr = e[Ni + 36 >> 2];
                              break e;
                            case 3:
                              break r;
                            default:
                              break i;
                          }
                        u = e[s + 116 >> 2], (u | 0) > 0 | (u | 0) >= 0 && (e[s + 4 >> 2] = e[s + 4 >> 2] - 1);
                        break t;
                      }
                      r: {
                        u = e[s + 4 >> 2];
                        i: {
                          if ((u | 0) != e[s + 104 >> 2]) {
                            e[s + 4 >> 2] = u + 1, u = me[u | 0];
                            break i;
                          }
                          u = Bo(s);
                        }
                        if ((u | 0) == 40) {
                          N = 1;
                          break r;
                        }
                        if (Te = 2147450880, e[s + 116 >> 2] < 0)
                          break e;
                        e[s + 4 >> 2] = e[s + 4 >> 2] - 1;
                        break e;
                      }
                      for (; ; ) {
                        r: {
                          u = e[s + 4 >> 2];
                          i: {
                            if ((u | 0) != e[s + 104 >> 2]) {
                              e[s + 4 >> 2] = u + 1, u = me[u | 0];
                              break i;
                            }
                            u = Bo(s);
                          }
                          if (!(u - 48 >>> 0 < 10 | u - 65 >>> 0 < 26 | (u | 0) == 95) && u - 97 >>> 0 >= 26)
                            break r;
                          N = N + 1 | 0;
                          continue;
                        }
                        break;
                      }
                      if (Te = 2147450880, (u | 0) == 41)
                        break e;
                      u = e[s + 116 >> 2], (u | 0) > 0 | (u | 0) >= 0 && (e[s + 4 >> 2] = e[s + 4 >> 2] - 1);
                      r: {
                        if (A) {
                          if (N)
                            break r;
                          break e;
                        }
                        break t;
                      }
                      for (; (u | 0) > 0 | (u | 0) >= 0 && (e[s + 4 >> 2] = e[s + 4 >> 2] - 1), N = N - 1 | 0, !!N; )
                        ;
                      break e;
                    }
                    e[5732] = 28, wu(s, 0, 0);
                  }
                  Te = 0;
                }
                e[r >> 2] = W, e[r + 4 >> 2] = fr, e[r + 8 >> 2] = Xe, e[r + 12 >> 2] = Te, Jr = Ni + 48 | 0;
              }
              function Ic(r, s) {
                r = r | 0, s = s | 0;
                var u = 0, A = 0, m = 0, p = 0, N = 0, W = 0, Te = 0, Xe = 0;
                u = Jr - 112 | 0, Jr = u, p = e[s >> 2], m = p, Te = e[s + 4 >> 2];
                e: {
                  if (!Te)
                    break e;
                  for (A = p + Te | 0; ; ) {
                    N = me[m | 0];
                    t: {
                      if (!((N | 0) != 123 & (N | 0) != 40)) {
                        W = W + 1 | 0;
                        break t;
                      }
                      if (W) {
                        if ((N | 0) != 125 & (N | 0) != 41)
                          break t;
                        W = W - 1 | 0;
                        break t;
                      }
                      W = 0;
                      r:
                        switch (N - 41 | 0) {
                          case 0:
                          case 3:
                            break e;
                          case 1:
                          case 2:
                            break t;
                          default:
                            break r;
                        }
                      if ((N | 0) == 125)
                        break e;
                    }
                    if (m = m + 1 | 0, (A | 0) == (m | 0))
                      break;
                  }
                  m = A;
                }
                e[u + 104 >> 2] = p, A = m - p | 0, e[u + 108 >> 2] = A, e[s + 4 >> 2] = Te - A, e[s >> 2] = m, _[u + 18 | 0] = 0, Zs[u + 16 >> 1] = 27504, _[u + 27 | 0] = 2;
                e: {
                  t: {
                    r: {
                      i: {
                        n: {
                          s: {
                            a: {
                              o: {
                                if (me[p + 2 | 0] != 40 | A >>> 0 < 4 | (me[(A + p | 0) - 1 | 0] != 41 | me[u + 16 | 0] != me[p | 0]) || me[u + 17 | 0] != me[p + 1 | 0])
                                  break o;
                                if (s = A - 4 | 0, e[u + 108 >> 2] = s, A = p + 3 | 0, e[u + 104 >> 2] = A, !(!s | (s | 0) > 17)) {
                                  if (s >>> 0 >= 2147483632)
                                    break i;
                                  l: {
                                    if (s >>> 0 <= 10) {
                                      _[u + 27 | 0] = s, W = u + 16 | 0;
                                      break l;
                                    }
                                    m = (s | 15) + 1 | 0, W = Qs(m), e[u + 24 >> 2] = m | -2147483648, e[u + 16 >> 2] = W, e[u + 20 >> 2] = s;
                                  }
                                  if (_[so(W, A, s) + s | 0] = 0, e[u + 88 >> 2] = e[u + 20 >> 2], s = me[u + 23 | 0] | me[u + 24 | 0] << 8 | (me[u + 25 | 0] << 16 | me[u + 26 | 0] << 24), _[u + 91 | 0] = s, _[u + 92 | 0] = s >>> 8, _[u + 93 | 0] = s >>> 16, _[u + 94 | 0] = s >>> 24, e[5996] = 0, A = e[u + 16 >> 2], p = _[u + 27 | 0], e[u + 24 >> 2] = 0, e[u + 16 >> 2] = 0, e[u + 20 >> 2] = 0, s = Mi(3, 12) | 0, m = e[5996], e[5996] = 0, (m | 0) != 1) {
                                    e[s >> 2] = A, e[s + 4 >> 2] = e[u + 88 >> 2], A = me[u + 91 | 0] | me[u + 92 | 0] << 8 | (me[u + 93 | 0] << 16 | me[u + 94 | 0] << 24), _[s + 7 | 0] = A, _[s + 8 | 0] = A >>> 8, _[s + 9 | 0] = A >>> 16, _[s + 10 | 0] = A >>> 24, _[s + 11 | 0] = p, e[r + 4 >> 2] = 0, e[r + 8 >> 2] = 0, e[r >> 2] = 1, e[r + 12 >> 2] = 0, e[r + 16 >> 2] = 0, e[r + 20 >> 2] = 0, e[r + 24 >> 2] = 0, e[r + 40 >> 2] = 0, e[r + 44 >> 2] = 0, A = s + 12 | 0, e[r + 36 >> 2] = A, e[r + 32 >> 2] = A, e[r + 28 >> 2] = s, e[r + 48 >> 2] = 0, e[r + 52 >> 2] = 0;
                                    break n;
                                  }
                                  if (m = Hr() | 0, ea(u + 16 | 0), (p | 0) >= 0)
                                    break a;
                                  Br(A), Jn(m | 0), Oi();
                                }
                                e[r >> 2] = 0, e[r + 4 >> 2] = 0, e[r + 48 >> 2] = 0, e[r + 52 >> 2] = 0, e[r + 40 >> 2] = 0, e[r + 44 >> 2] = 0, e[r + 32 >> 2] = 0, e[r + 36 >> 2] = 0, e[r + 24 >> 2] = 0, e[r + 28 >> 2] = 0, e[r + 16 >> 2] = 0, e[r + 20 >> 2] = 0, e[r + 8 >> 2] = 0, e[r + 12 >> 2] = 0;
                                break n;
                              }
                              _[u + 21 | 0] = 0, _[u + 20 | 0] = me[1777], _[u + 27 | 0] = 5, e[u + 16 >> 2] = me[1773] | me[1774] << 8 | (me[1775] << 16 | me[1776] << 24);
                              o: {
                                if (s = A >>> 0 < 7, s | me[p + 5 | 0] != 40 | (me[(A + p | 0) - 1 | 0] != 41 | me[u + 16 | 0] != me[p | 0]) || me[u + 17 | 0] != me[p + 1 | 0] | me[u + 18 | 0] != me[p + 2 | 0] | (me[u + 19 | 0] != me[p + 3 | 0] | me[u + 20 | 0] != me[p + 4 | 0]))
                                  break o;
                                if (N = A - 7 | 0, e[u + 108 >> 2] = N, A = p + 6 | 0, e[u + 104 >> 2] = A, N >>> 0 >= 2147483632)
                                  break i;
                                l: {
                                  c: {
                                    if (N >>> 0 >= 11) {
                                      s = (N | 15) + 1 | 0, m = Qs(s), e[u + 24 >> 2] = s | -2147483648, e[u + 16 >> 2] = m, e[u + 20 >> 2] = N;
                                      break c;
                                    }
                                    if (_[u + 27 | 0] = N, m = u + 16 | 0, !N)
                                      break l;
                                  }
                                  p = N - 1 | 0, Te = N & 7;
                                  c: {
                                    if (!Te) {
                                      s = A;
                                      break c;
                                    }
                                    for (W = 0, s = A; _[m | 0] = me[s | 0], m = m + 1 | 0, s = s + 1 | 0, W = W + 1 | 0, (Te | 0) != (W | 0); )
                                      ;
                                  }
                                  if (p >>> 0 < 7)
                                    break l;
                                  for (A = A + N | 0; _[m | 0] = me[s | 0], _[m + 1 | 0] = me[s + 1 | 0], _[m + 2 | 0] = me[s + 2 | 0], _[m + 3 | 0] = me[s + 3 | 0], _[m + 4 | 0] = me[s + 4 | 0], _[m + 5 | 0] = me[s + 5 | 0], _[m + 6 | 0] = me[s + 6 | 0], _[m + 7 | 0] = me[s + 7 | 0], m = m + 8 | 0, s = s + 8 | 0, (A | 0) != (s | 0); )
                                    ;
                                }
                                if (_[m | 0] = 0, s = Bd(u + 16 | 0, u + 88 | 0), _[u + 27 | 0] < 0 && Br(e[u + 16 >> 2]), !s) {
                                  e[r >> 2] = 0, e[r + 4 >> 2] = 0, e[r + 48 >> 2] = 0, e[r + 52 >> 2] = 0, e[r + 40 >> 2] = 0, e[r + 44 >> 2] = 0, e[r + 32 >> 2] = 0, e[r + 36 >> 2] = 0, e[r + 24 >> 2] = 0, e[r + 28 >> 2] = 0, e[r + 16 >> 2] = 0, e[r + 20 >> 2] = 0, e[r + 8 >> 2] = 0, e[r + 12 >> 2] = 0;
                                  break n;
                                }
                                if (s = e[u + 88 >> 2], A = s - 1 | 0, e[u + 92 >> 2] == (!s | 0) & A >>> 0 <= 2147483646) {
                                  e[r + 4 >> 2] = 0, e[r + 8 >> 2] = 0, e[r >> 2] = 3, e[r + 52 >> 2] = s, e[r + 12 >> 2] = 0, e[r + 16 >> 2] = 0, e[r + 20 >> 2] = 0, e[r + 24 >> 2] = 0, e[r + 28 >> 2] = 0, e[r + 32 >> 2] = 0, e[r + 36 >> 2] = 0, e[r + 40 >> 2] = 0, e[r + 44 >> 2] = 0, e[r + 48 >> 2] = 0;
                                  break n;
                                }
                                e[r >> 2] = 0, e[r + 4 >> 2] = 0, e[r + 48 >> 2] = 0, e[r + 52 >> 2] = 0, e[r + 40 >> 2] = 0, e[r + 44 >> 2] = 0, e[r + 32 >> 2] = 0, e[r + 36 >> 2] = 0, e[r + 24 >> 2] = 0, e[r + 28 >> 2] = 0, e[r + 16 >> 2] = 0, e[r + 20 >> 2] = 0, e[r + 8 >> 2] = 0, e[r + 12 >> 2] = 0;
                                break n;
                              }
                              _[u + 21 | 0] = 0, _[u + 20 | 0] = me[1783], _[u + 27 | 0] = 5, e[u + 16 >> 2] = me[1779] | me[1780] << 8 | (me[1781] << 16 | me[1782] << 24);
                              o: {
                                if (me[p + 5 | 0] != 40 | s | (me[(A + p | 0) - 1 | 0] != 41 | me[u + 16 | 0] != me[p | 0]) || me[u + 17 | 0] != me[p + 1 | 0] | me[u + 18 | 0] != me[p + 2 | 0] | (me[u + 19 | 0] != me[p + 3 | 0] | me[u + 20 | 0] != me[p + 4 | 0]))
                                  break o;
                                if (N = A - 7 | 0, e[u + 108 >> 2] = N, A = p + 6 | 0, e[u + 104 >> 2] = A, N >>> 0 >= 2147483632)
                                  break i;
                                l: {
                                  c: {
                                    if (N >>> 0 >= 11) {
                                      s = (N | 15) + 1 | 0, m = Qs(s), e[u + 24 >> 2] = s | -2147483648, e[u + 16 >> 2] = m, e[u + 20 >> 2] = N;
                                      break c;
                                    }
                                    if (_[u + 27 | 0] = N, m = u + 16 | 0, !N)
                                      break l;
                                  }
                                  p = N - 1 | 0, Te = N & 7;
                                  c: {
                                    if (!Te) {
                                      s = A;
                                      break c;
                                    }
                                    for (W = 0, s = A; _[m | 0] = me[s | 0], m = m + 1 | 0, s = s + 1 | 0, W = W + 1 | 0, (Te | 0) != (W | 0); )
                                      ;
                                  }
                                  if (p >>> 0 < 7)
                                    break l;
                                  for (A = A + N | 0; _[m | 0] = me[s | 0], _[m + 1 | 0] = me[s + 1 | 0], _[m + 2 | 0] = me[s + 2 | 0], _[m + 3 | 0] = me[s + 3 | 0], _[m + 4 | 0] = me[s + 4 | 0], _[m + 5 | 0] = me[s + 5 | 0], _[m + 6 | 0] = me[s + 6 | 0], _[m + 7 | 0] = me[s + 7 | 0], m = m + 8 | 0, s = s + 8 | 0, (A | 0) != (s | 0); )
                                    ;
                                }
                                if (_[m | 0] = 0, s = Bd(u + 16 | 0, u + 88 | 0), _[u + 27 | 0] < 0 && Br(e[u + 16 >> 2]), !s) {
                                  e[r >> 2] = 0, e[r + 4 >> 2] = 0, e[r + 48 >> 2] = 0, e[r + 52 >> 2] = 0, e[r + 40 >> 2] = 0, e[r + 44 >> 2] = 0, e[r + 32 >> 2] = 0, e[r + 36 >> 2] = 0, e[r + 24 >> 2] = 0, e[r + 28 >> 2] = 0, e[r + 16 >> 2] = 0, e[r + 20 >> 2] = 0, e[r + 8 >> 2] = 0, e[r + 12 >> 2] = 0;
                                  break n;
                                }
                                if (s = e[u + 88 >> 2], A = s - 1 | 0, e[u + 92 >> 2] == (!s | 0) & A >>> 0 <= 2147483646) {
                                  e[r + 4 >> 2] = 0, e[r + 8 >> 2] = 0, e[r >> 2] = 2, e[r + 52 >> 2] = s, e[r + 12 >> 2] = 0, e[r + 16 >> 2] = 0, e[r + 20 >> 2] = 0, e[r + 24 >> 2] = 0, e[r + 28 >> 2] = 0, e[r + 32 >> 2] = 0, e[r + 36 >> 2] = 0, e[r + 40 >> 2] = 0, e[r + 44 >> 2] = 0, e[r + 48 >> 2] = 0;
                                  break n;
                                }
                                e[r >> 2] = 0, e[r + 4 >> 2] = 0, e[r + 48 >> 2] = 0, e[r + 52 >> 2] = 0, e[r + 40 >> 2] = 0, e[r + 44 >> 2] = 0, e[r + 32 >> 2] = 0, e[r + 36 >> 2] = 0, e[r + 24 >> 2] = 0, e[r + 28 >> 2] = 0, e[r + 16 >> 2] = 0, e[r + 20 >> 2] = 0, e[r + 8 >> 2] = 0, e[r + 12 >> 2] = 0;
                                break n;
                              }
                              _[u + 22 | 0] = 0, Zs[u + 20 >> 1] = me[3881] | me[3882] << 8, _[u + 27 | 0] = 6, e[u + 16 >> 2] = me[3877] | me[3878] << 8 | (me[3879] << 16 | me[3880] << 24);
                              o: {
                                if (me[p + 6 | 0] != 40 | A >>> 0 < 8 | (me[(A + p | 0) - 1 | 0] != 41 | me[u + 16 | 0] != me[p | 0]) || me[u + 17 | 0] != me[p + 1 | 0] | me[u + 18 | 0] != me[p + 2 | 0] | (me[u + 19 | 0] != me[p + 3 | 0] | me[u + 20 | 0] != me[p + 4 | 0]) || me[u + 21 | 0] != me[p + 5 | 0])
                                  break o;
                                if (s = A - 8 | 0, e[u + 108 >> 2] = s, A = p + 7 | 0, e[u + 104 >> 2] = A, Tc(u + 16 | 0, A, s, 32), s = e[u + 20 >> 2], A = e[u + 16 >> 2], (s | 0) != (A | 0)) {
                                  e[r + 4 >> 2] = 0, e[r + 8 >> 2] = 0, e[r >> 2] = 7, e[r + 16 >> 2] = A, e[r + 12 >> 2] = 0, e[r + 20 >> 2] = s, s = e[u + 24 >> 2], e[r + 28 >> 2] = 0, e[r + 32 >> 2] = 0, e[r + 24 >> 2] = s, e[r + 36 >> 2] = 0, e[r + 40 >> 2] = 0, e[r + 44 >> 2] = 0, e[r + 48 >> 2] = 0, e[r + 52 >> 2] = 0;
                                  break n;
                                }
                                if (e[r >> 2] = 0, e[r + 4 >> 2] = 0, e[r + 48 >> 2] = 0, e[r + 52 >> 2] = 0, e[r + 40 >> 2] = 0, e[r + 44 >> 2] = 0, e[r + 32 >> 2] = 0, e[r + 36 >> 2] = 0, e[r + 24 >> 2] = 0, e[r + 28 >> 2] = 0, e[r + 16 >> 2] = 0, e[r + 20 >> 2] = 0, e[r + 8 >> 2] = 0, e[r + 12 >> 2] = 0, !s)
                                  break n;
                                Br(s);
                                break n;
                              }
                              _[u + 25 | 0] = 0, _[u + 24 | 0] = me[4198], _[u + 27 | 0] = 9, s = me[4194] | me[4195] << 8 | (me[4196] << 16 | me[4197] << 24), e[u + 16 >> 2] = me[4190] | me[4191] << 8 | (me[4192] << 16 | me[4193] << 24), e[u + 20 >> 2] = s;
                              o: {
                                if (me[p + 9 | 0] != 40 | A >>> 0 < 11 | (me[(A + p | 0) - 1 | 0] != 41 | me[u + 16 | 0] != me[p | 0]) || me[u + 17 | 0] != me[p + 1 | 0] | me[u + 18 | 0] != me[p + 2 | 0] | (me[u + 19 | 0] != me[p + 3 | 0] | me[u + 20 | 0] != me[p + 4 | 0]) || me[u + 21 | 0] != me[p + 5 | 0] | me[u + 22 | 0] != me[p + 6 | 0] | (me[u + 23 | 0] != me[p + 7 | 0] | me[u + 24 | 0] != me[p + 8 | 0]))
                                  break o;
                                if (s = A - 11 | 0, e[u + 108 >> 2] = s, A = p + 10 | 0, e[u + 104 >> 2] = A, Tc(u + 16 | 0, A, s, 20), s = e[u + 20 >> 2], A = e[u + 16 >> 2], (s | 0) != (A | 0)) {
                                  e[r + 4 >> 2] = 0, e[r + 8 >> 2] = 0, e[r >> 2] = 6, e[r + 16 >> 2] = A, e[r + 12 >> 2] = 0, e[r + 20 >> 2] = s, s = e[u + 24 >> 2], e[r + 28 >> 2] = 0, e[r + 32 >> 2] = 0, e[r + 24 >> 2] = s, e[r + 36 >> 2] = 0, e[r + 40 >> 2] = 0, e[r + 44 >> 2] = 0, e[r + 48 >> 2] = 0, e[r + 52 >> 2] = 0;
                                  break n;
                                }
                                if (e[r >> 2] = 0, e[r + 4 >> 2] = 0, e[r + 48 >> 2] = 0, e[r + 52 >> 2] = 0, e[r + 40 >> 2] = 0, e[r + 44 >> 2] = 0, e[r + 32 >> 2] = 0, e[r + 36 >> 2] = 0, e[r + 24 >> 2] = 0, e[r + 28 >> 2] = 0, e[r + 16 >> 2] = 0, e[r + 20 >> 2] = 0, e[r + 8 >> 2] = 0, e[r + 12 >> 2] = 0, !s)
                                  break n;
                                Br(s);
                                break n;
                              }
                              _[u + 27 | 0] = 7, _[u + 23 | 0] = 0, e[u + 16 >> 2] = me[3869] | me[3870] << 8 | (me[3871] << 16 | me[3872] << 24), s = me[3872] | me[3873] << 8 | (me[3874] << 16 | me[3875] << 24), _[u + 19 | 0] = s, _[u + 20 | 0] = s >>> 8, _[u + 21 | 0] = s >>> 16, _[u + 22 | 0] = s >>> 24;
                              o: {
                                if (me[p + 7 | 0] != 40 | A >>> 0 < 9 | (me[(A + p | 0) - 1 | 0] != 41 | me[u + 16 | 0] != me[p | 0]) || me[u + 17 | 0] != me[p + 1 | 0] | me[u + 18 | 0] != me[p + 2 | 0] | (me[u + 19 | 0] != me[p + 3 | 0] | me[u + 20 | 0] != me[p + 4 | 0]) || me[u + 21 | 0] != me[p + 5 | 0] | me[u + 22 | 0] != me[p + 6 | 0])
                                  break o;
                                if (s = A - 9 | 0, e[u + 108 >> 2] = s, A = p + 8 | 0, e[u + 104 >> 2] = A, Tc(u + 16 | 0, A, s, 32), s = e[u + 20 >> 2], A = e[u + 16 >> 2], (s | 0) != (A | 0)) {
                                  e[r + 4 >> 2] = 0, e[r + 8 >> 2] = 0, e[r >> 2] = 5, e[r + 16 >> 2] = A, e[r + 12 >> 2] = 0, e[r + 20 >> 2] = s, s = e[u + 24 >> 2], e[r + 28 >> 2] = 0, e[r + 32 >> 2] = 0, e[r + 24 >> 2] = s, e[r + 36 >> 2] = 0, e[r + 40 >> 2] = 0, e[r + 44 >> 2] = 0, e[r + 48 >> 2] = 0, e[r + 52 >> 2] = 0;
                                  break n;
                                }
                                if (e[r >> 2] = 0, e[r + 4 >> 2] = 0, e[r + 48 >> 2] = 0, e[r + 52 >> 2] = 0, e[r + 40 >> 2] = 0, e[r + 44 >> 2] = 0, e[r + 32 >> 2] = 0, e[r + 36 >> 2] = 0, e[r + 24 >> 2] = 0, e[r + 28 >> 2] = 0, e[r + 16 >> 2] = 0, e[r + 20 >> 2] = 0, e[r + 8 >> 2] = 0, e[r + 12 >> 2] = 0, !s)
                                  break n;
                                Br(s);
                                break n;
                              }
                              if (s = Za(u + 16 | 0, 4182), A = yl(s, u + 104 | 0), _[s + 11 | 0] < 0 && Br(e[s >> 2]), A) {
                                if (Tc(u + 16 | 0, e[u + 104 >> 2], e[u + 108 >> 2], 20), s = e[u + 20 >> 2], A = e[u + 16 >> 2], (s | 0) != (A | 0)) {
                                  e[r + 4 >> 2] = 0, e[r + 8 >> 2] = 0, e[r >> 2] = 4, e[r + 16 >> 2] = A, e[r + 12 >> 2] = 0, e[r + 20 >> 2] = s, s = e[u + 24 >> 2], e[r + 28 >> 2] = 0, e[r + 32 >> 2] = 0, e[r + 24 >> 2] = s, e[r + 36 >> 2] = 0, e[r + 40 >> 2] = 0, e[r + 44 >> 2] = 0, e[r + 48 >> 2] = 0, e[r + 52 >> 2] = 0;
                                  break n;
                                }
                                if (e[r >> 2] = 0, e[r + 4 >> 2] = 0, e[r + 48 >> 2] = 0, e[r + 52 >> 2] = 0, e[r + 40 >> 2] = 0, e[r + 44 >> 2] = 0, e[r + 32 >> 2] = 0, e[r + 36 >> 2] = 0, e[r + 24 >> 2] = 0, e[r + 28 >> 2] = 0, e[r + 16 >> 2] = 0, e[r + 20 >> 2] = 0, e[r + 8 >> 2] = 0, e[r + 12 >> 2] = 0, !s)
                                  break n;
                                Br(s);
                                break n;
                              }
                              if (s = Za(u + 16 | 0, 1743), A = yl(s, u + 104 | 0), _[s + 11 | 0] < 0 && Br(e[s >> 2]), A) {
                                if (e[u + 96 >> 2] = 0, e[u + 88 >> 2] = 0, e[u + 92 >> 2] = 0, e[u + 84 >> 2] = 0, e[u + 76 >> 2] = 0, e[u + 80 >> 2] = 0, e[5996] = 0, s = u + 16 | 0, gs(26, s | 0, u + 104 | 0, u + 8 | 0), A = e[5996], e[5996] = 0, (A | 0) != 1) {
                                  e[5996] = 0, ji(27, u + 88 | 0, s | 0), A = e[5996], e[5996] = 0;
                                  o: {
                                    l: {
                                      if ((A | 0) != 1) {
                                        if (Ma(s), s = e[u + 92 >> 2], e[s - 56 >> 2])
                                          break l;
                                        e[r >> 2] = 0, e[r + 4 >> 2] = 0, e[r + 48 >> 2] = 0, e[r + 52 >> 2] = 0, e[r + 40 >> 2] = 0, e[r + 44 >> 2] = 0, e[r + 32 >> 2] = 0, e[r + 36 >> 2] = 0, e[r + 24 >> 2] = 0, e[r + 28 >> 2] = 0, e[r + 16 >> 2] = 0, e[r + 20 >> 2] = 0, e[r + 8 >> 2] = 0, e[r + 12 >> 2] = 0;
                                        break o;
                                      }
                                      m = Hr() | 0, Ma(u + 16 | 0);
                                      break t;
                                    }
                                    if (e[5996] = 0, ji(28, u + 76 | 0, e[u + 8 >> 2]), A = e[5996], e[5996] = 0, (A | 0) == 1)
                                      break r;
                                    l: {
                                      c: {
                                        if (!e[u + 108 >> 2])
                                          break c;
                                        d: {
                                          f: {
                                            for (; ; ) {
                                              if (Zs[u + 16 >> 1] = 44, _[u + 27 | 0] = 1, s = u + 16 | 0, A = u + 104 | 0, !Ba(s, A))
                                                break l;
                                              if (e[5996] = 0, gs(26, s | 0, A | 0, u + 8 | 0), A = e[5996], e[5996] = 0, (A | 0) == 1)
                                                break f;
                                              if (e[5996] = 0, ji(27, u + 88 | 0, s | 0), A = e[5996], e[5996] = 0, (A | 0) == 1)
                                                break d;
                                              if (Ma(s), s = e[u + 92 >> 2], !e[s - 56 >> 2])
                                                break l;
                                              if (e[5996] = 0, ji(28, u + 76 | 0, e[u + 8 >> 2]), A = e[5996], e[5996] = 0, (A | 0) != 1) {
                                                if (!e[u + 108 >> 2])
                                                  break c;
                                                continue;
                                              }
                                              break;
                                            }
                                            m = Hr() | 0;
                                            break t;
                                          }
                                          m = Hr() | 0;
                                          break t;
                                        }
                                        m = Hr() | 0, Ma(u + 16 | 0);
                                        break t;
                                      }
                                      e[r >> 2] = 9, A = e[u + 88 >> 2], e[r + 8 >> 2] = s, e[r + 4 >> 2] = A, e[r + 12 >> 2] = e[u + 96 >> 2], e[u + 96 >> 2] = 0, e[u + 88 >> 2] = 0, e[u + 92 >> 2] = 0, e[r + 32 >> 2] = 0, e[r + 36 >> 2] = 0, e[r + 24 >> 2] = 0, e[r + 28 >> 2] = 0, e[r + 16 >> 2] = 0, e[r + 20 >> 2] = 0, e[r + 40 >> 2] = e[u + 76 >> 2], e[r + 44 >> 2] = e[u + 80 >> 2], s = e[u + 84 >> 2], e[r + 52 >> 2] = 0, e[r + 48 >> 2] = s;
                                      break o;
                                    }
                                    if (s = e[u + 76 >> 2], e[r >> 2] = 0, e[r + 4 >> 2] = 0, e[r + 48 >> 2] = 0, e[r + 52 >> 2] = 0, e[r + 40 >> 2] = 0, e[r + 44 >> 2] = 0, e[r + 32 >> 2] = 0, e[r + 36 >> 2] = 0, e[r + 24 >> 2] = 0, e[r + 28 >> 2] = 0, e[r + 16 >> 2] = 0, e[r + 20 >> 2] = 0, e[r + 8 >> 2] = 0, e[r + 12 >> 2] = 0, !s)
                                      break o;
                                    Br(s);
                                  }
                                  Va(u + 88 | 0);
                                  break n;
                                }
                                m = Hr() | 0;
                                break t;
                              }
                              if (s = Za(u + 16 | 0, 2464), A = yl(s, u + 104 | 0), _[s + 11 | 0] < 0 && Br(e[s >> 2]), A) {
                                e[u + 96 >> 2] = 0, e[u + 88 >> 2] = 0, e[u + 92 >> 2] = 0, e[5996] = 0, s = u + 16 | 0, ji(29, s | 0, u + 104 | 0), A = e[5996], e[5996] = 0;
                                o: {
                                  if ((A | 0) != 1) {
                                    e[5996] = 0, ji(27, u + 88 | 0, s | 0), A = e[5996], e[5996] = 0;
                                    l: {
                                      c: {
                                        d: {
                                          if ((A | 0) != 1) {
                                            if (Ma(s), m = e[u + 92 >> 2], e[m - 56 >> 2]) {
                                              if (!e[u + 108 >> 2])
                                                break c;
                                              break d;
                                            }
                                            e[r >> 2] = 0, e[r + 4 >> 2] = 0, e[r + 48 >> 2] = 0, e[r + 52 >> 2] = 0, e[r + 40 >> 2] = 0, e[r + 44 >> 2] = 0, e[r + 32 >> 2] = 0, e[r + 36 >> 2] = 0, e[r + 24 >> 2] = 0, e[r + 28 >> 2] = 0, e[r + 16 >> 2] = 0, e[r + 20 >> 2] = 0, e[r + 8 >> 2] = 0, e[r + 12 >> 2] = 0;
                                            break l;
                                          }
                                          m = Hr() | 0, Ma(u + 16 | 0);
                                          break o;
                                        }
                                        d: {
                                          f: {
                                            for (; ; ) {
                                              e[5996] = 0, s = pi(30, u + 76 | 0, 4354) | 0, A = e[5996], e[5996] = 0;
                                              u: {
                                                if ((A | 0) != 1) {
                                                  if (A = Ba(s, u + 104 | 0), _[u + 87 | 0] < 0 && Br(e[s >> 2]), A)
                                                    break u;
                                                  e[r >> 2] = 0, e[r + 4 >> 2] = 0, e[r + 48 >> 2] = 0, e[r + 52 >> 2] = 0, e[r + 40 >> 2] = 0, e[r + 44 >> 2] = 0, e[r + 32 >> 2] = 0, e[r + 36 >> 2] = 0, e[r + 24 >> 2] = 0, e[r + 28 >> 2] = 0, e[r + 16 >> 2] = 0, e[r + 20 >> 2] = 0, e[r + 8 >> 2] = 0, e[r + 12 >> 2] = 0;
                                                  break l;
                                                }
                                                m = Hr() | 0;
                                                break o;
                                              }
                                              if (e[5996] = 0, s = u + 16 | 0, ji(29, s | 0, u + 104 | 0), A = e[5996], e[5996] = 0, (A | 0) == 1)
                                                break f;
                                              if (e[5996] = 0, ji(27, u + 88 | 0, s | 0), A = e[5996], e[5996] = 0, (A | 0) == 1)
                                                break d;
                                              if (Ma(s), m = e[u + 92 >> 2], e[m - 56 >> 2]) {
                                                if (!e[u + 108 >> 2])
                                                  break c;
                                                continue;
                                              }
                                              break;
                                            }
                                            e[r >> 2] = 0, e[r + 4 >> 2] = 0, e[r + 48 >> 2] = 0, e[r + 52 >> 2] = 0, e[r + 40 >> 2] = 0, e[r + 44 >> 2] = 0, e[r + 32 >> 2] = 0, e[r + 36 >> 2] = 0, e[r + 24 >> 2] = 0, e[r + 28 >> 2] = 0, e[r + 16 >> 2] = 0, e[r + 20 >> 2] = 0, e[r + 8 >> 2] = 0, e[r + 12 >> 2] = 0;
                                            break l;
                                          }
                                          m = Hr() | 0;
                                          break o;
                                        }
                                        m = Hr() | 0, Ma(u + 16 | 0);
                                        break o;
                                      }
                                      e[r >> 2] = 8, s = e[u + 88 >> 2], e[r + 8 >> 2] = m, e[r + 4 >> 2] = s, e[r + 12 >> 2] = e[u + 96 >> 2], e[u + 96 >> 2] = 0, e[u + 88 >> 2] = 0, e[u + 92 >> 2] = 0, e[r + 48 >> 2] = 0, e[r + 52 >> 2] = 0, e[r + 40 >> 2] = 0, e[r + 44 >> 2] = 0, e[r + 32 >> 2] = 0, e[r + 36 >> 2] = 0, e[r + 24 >> 2] = 0, e[r + 28 >> 2] = 0, e[r + 16 >> 2] = 0, e[r + 20 >> 2] = 0;
                                    }
                                    Va(u + 88 | 0);
                                    break n;
                                  }
                                  m = Hr() | 0;
                                }
                                break e;
                              }
                              if (s = Za(u + 16 | 0, 2197), A = yl(s, u + 104 | 0), _[s + 11 | 0] < 0 && Br(e[s >> 2]), !A)
                                break s;
                              m = 0, W = e[u + 104 >> 2], s = W, N = e[u + 108 >> 2];
                              o: {
                                if (!N)
                                  break o;
                                for (A = s + N | 0; ; ) {
                                  p = me[s | 0];
                                  l: {
                                    if (!((p | 0) != 123 & (p | 0) != 40)) {
                                      m = m + 1 | 0;
                                      break l;
                                    }
                                    if (m) {
                                      if ((p | 0) != 125 & (p | 0) != 41)
                                        break l;
                                      m = m - 1 | 0;
                                      break l;
                                    }
                                    m = 0;
                                    c:
                                      switch (p - 41 | 0) {
                                        case 0:
                                        case 3:
                                          break o;
                                        case 1:
                                        case 2:
                                          break l;
                                        default:
                                          break c;
                                      }
                                    if ((p | 0) == 125)
                                      break o;
                                  }
                                  if (s = s + 1 | 0, (A | 0) == (s | 0))
                                    break;
                                }
                                s = A;
                              }
                              e[u + 8 >> 2] = W, A = s - W | 0, e[u + 12 >> 2] = A, e[u + 108 >> 2] = N - A, e[u + 104 >> 2] = s, s = e[u + 8 >> 2], A = wd(u + 16 | 0, s, s + e[u + 12 >> 2] | 0), p = u + 4 | 0, s = 0, m = Jr - 16 | 0, Jr = m, N = me[A + 11 | 0], W = N << 24 >> 24, W = (W | 0) < 0, N = W ? e[A + 4 >> 2] : N;
                              o: {
                                if (!N || (W = W ? e[A >> 2] : A, Te = me[W | 0], Xe = Te - 9 & 255, Xe >>> 0 < 24 & (8388639 >>> Xe & 1)) || (Xe = me[(N + W | 0) - 1 | 0] - 9 | 0, (Xe & 255) >>> 0 < 24 & (8388639 >>> Xe & 1)) || (Te | 0) == 45 | (Fa(W) | 0) != (N | 0) || (e[m + 12 >> 2] = 0, e[5732] = 0, W = ud(_[A + 11 | 0] < 0 ? e[A >> 2] : A, m + 12 | 0, 10, -1, 0), p && (e[p >> 2] = W), p = e[m + 12 >> 2], !p | me[p | 0]))
                                  break o;
                                s = !e[5732];
                              }
                              if (Jr = m + 16 | 0, _[A + 11 | 0] < 0 && Br(e[A >> 2]), !s) {
                                e[r >> 2] = 0, e[r + 4 >> 2] = 0, e[r + 48 >> 2] = 0, e[r + 52 >> 2] = 0, e[r + 40 >> 2] = 0, e[r + 44 >> 2] = 0, e[r + 32 >> 2] = 0, e[r + 36 >> 2] = 0, e[r + 24 >> 2] = 0, e[r + 28 >> 2] = 0, e[r + 16 >> 2] = 0, e[r + 20 >> 2] = 0, e[r + 8 >> 2] = 0, e[r + 12 >> 2] = 0;
                                break n;
                              }
                              if (!e[u + 4 >> 2]) {
                                e[r >> 2] = 0, e[r + 4 >> 2] = 0, e[r + 48 >> 2] = 0, e[r + 52 >> 2] = 0, e[r + 40 >> 2] = 0, e[r + 44 >> 2] = 0, e[r + 32 >> 2] = 0, e[r + 36 >> 2] = 0, e[r + 24 >> 2] = 0, e[r + 28 >> 2] = 0, e[r + 16 >> 2] = 0, e[r + 20 >> 2] = 0, e[r + 8 >> 2] = 0, e[r + 12 >> 2] = 0;
                                break n;
                              }
                              s = 0, e[u + 96 >> 2] = 0, e[u + 88 >> 2] = 0, e[u + 92 >> 2] = 0, m = 0;
                              o: {
                                l: {
                                  c: {
                                    if (e[u + 108 >> 2]) {
                                      d: {
                                        f: {
                                          u: {
                                            for (; ; ) {
                                              if (e[5996] = 0, s = pi(30, u + 76 | 0, 4354) | 0, A = e[5996], e[5996] = 0, (A | 0) == 1)
                                                break l;
                                              if (A = Ba(s, u + 104 | 0), _[u + 87 | 0] < 0 && Br(e[s >> 2]), !A) {
                                                e[r >> 2] = 0, e[r + 4 >> 2] = 0, e[r + 48 >> 2] = 0, e[r + 52 >> 2] = 0, e[r + 40 >> 2] = 0, e[r + 44 >> 2] = 0, e[r + 32 >> 2] = 0, e[r + 36 >> 2] = 0, e[r + 24 >> 2] = 0, e[r + 28 >> 2] = 0, e[r + 16 >> 2] = 0, e[r + 20 >> 2] = 0, e[r + 8 >> 2] = 0, e[r + 12 >> 2] = 0;
                                                break c;
                                              }
                                              if (e[5996] = 0, s = u + 16 | 0, ji(29, s | 0, u + 104 | 0), A = e[5996], e[5996] = 0, (A | 0) == 1)
                                                break u;
                                              if (e[5996] = 0, ji(27, u + 88 | 0, s | 0), A = e[5996], e[5996] = 0, (A | 0) == 1)
                                                break f;
                                              if (Ma(s), m = e[u + 92 >> 2], e[m - 56 >> 2]) {
                                                if (!e[u + 108 >> 2])
                                                  break d;
                                                continue;
                                              }
                                              break;
                                            }
                                            e[r >> 2] = 0, e[r + 4 >> 2] = 0, e[r + 48 >> 2] = 0, e[r + 52 >> 2] = 0, e[r + 40 >> 2] = 0, e[r + 44 >> 2] = 0, e[r + 32 >> 2] = 0, e[r + 36 >> 2] = 0, e[r + 24 >> 2] = 0, e[r + 28 >> 2] = 0, e[r + 16 >> 2] = 0, e[r + 20 >> 2] = 0, e[r + 8 >> 2] = 0, e[r + 12 >> 2] = 0;
                                            break c;
                                          }
                                          m = Hr() | 0;
                                          break o;
                                        }
                                        m = Hr() | 0, Ma(u + 16 | 0);
                                        break o;
                                      }
                                      s = e[u + 88 >> 2];
                                    }
                                    d: {
                                      if (A = (m - s | 0) / 56 | 0, A >>> 0 <= 100 && (p = A, A = e[u + 4 >> 2], p >>> 0 >= A >>> 0))
                                        break d;
                                      e[r >> 2] = 0, e[r + 4 >> 2] = 0, e[r + 48 >> 2] = 0, e[r + 52 >> 2] = 0, e[r + 40 >> 2] = 0, e[r + 44 >> 2] = 0, e[r + 32 >> 2] = 0, e[r + 36 >> 2] = 0, e[r + 24 >> 2] = 0, e[r + 28 >> 2] = 0, e[r + 16 >> 2] = 0, e[r + 20 >> 2] = 0, e[r + 8 >> 2] = 0, e[r + 12 >> 2] = 0;
                                      break c;
                                    }
                                    e[r + 4 >> 2] = s, e[r >> 2] = 10, e[r + 8 >> 2] = m, e[r + 12 >> 2] = e[u + 96 >> 2], e[u + 96 >> 2] = 0, e[u + 88 >> 2] = 0, e[u + 92 >> 2] = 0, e[r + 48 >> 2] = 0, e[r + 40 >> 2] = 0, e[r + 44 >> 2] = 0, e[r + 32 >> 2] = 0, e[r + 36 >> 2] = 0, e[r + 24 >> 2] = 0, e[r + 28 >> 2] = 0, e[r + 16 >> 2] = 0, e[r + 20 >> 2] = 0, e[r + 52 >> 2] = A;
                                  }
                                  Va(u + 88 | 0);
                                  break n;
                                }
                                m = Hr() | 0;
                              }
                              Va(u + 88 | 0);
                            }
                            Jn(m | 0), Oi();
                          }
                          e[r >> 2] = 0, e[r + 4 >> 2] = 0, e[r + 48 >> 2] = 0, e[r + 52 >> 2] = 0, e[r + 40 >> 2] = 0, e[r + 44 >> 2] = 0, e[r + 32 >> 2] = 0, e[r + 36 >> 2] = 0, e[r + 24 >> 2] = 0, e[r + 28 >> 2] = 0, e[r + 16 >> 2] = 0, e[r + 20 >> 2] = 0, e[r + 8 >> 2] = 0, e[r + 12 >> 2] = 0;
                        }
                        Jr = u + 112 | 0;
                        return;
                      }
                      Ra(), Oi();
                    }
                    m = Hr() | 0;
                  }
                  r = e[u + 76 >> 2], r && Br(r);
                }
                Va(u + 88 | 0), Jn(m | 0), Oi();
              }
              function X1(r, s, u, A) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0;
                var m = 0, p = 0, N = 0, W = 0, Te = 0, Xe = 0, fr = 0, ar = 0, vr = 0, _r = 0, hi = 0, mi = 0, Ni = 0, Hi = 0;
                p = Jr - 160 | 0, Jr = p, e[p + 152 >> 2] = 0, e[p + 144 >> 2] = 0, e[p + 148 >> 2] = 0, hi = A + 1 | 0, ar = 1;
                e: {
                  t: {
                    r: {
                      i: {
                        n: {
                          s: {
                            a: {
                              o: {
                                l: {
                                  c: {
                                    for (; ; ) {
                                      if (m = me[s | 0] | me[s + 1 | 0] << 8 | (me[s + 2 | 0] << 16 | me[s + 3 | 0] << 24), (m | 0) == (u | 0))
                                        break c;
                                      d: {
                                        f: {
                                          u: {
                                            g: {
                                              A: {
                                                p: {
                                                  m: {
                                                    k: {
                                                      N: {
                                                        S: {
                                                          T: {
                                                            v: {
                                                              w: {
                                                                E: {
                                                                  h: {
                                                                    R: {
                                                                      I: {
                                                                        if ((u - m | 0) <= 0 | u >>> 0 <= m >>> 0)
                                                                          break I;
                                                                        W = m + 1 | 0, N = 0, fr = me[m | 0];
                                                                        B: {
                                                                          if (fr >>> 0 > 78) {
                                                                            Te = 0;
                                                                            break B;
                                                                          }
                                                                          Te = fr;
                                                                          x: {
                                                                            if (Te >>> 0 < 76)
                                                                              break x;
                                                                            b:
                                                                              switch (Te - 76 | 0) {
                                                                                case 0:
                                                                                  if ((u - W | 0) <= 0)
                                                                                    break I;
                                                                                  W = m + 2 | 0, Te = me[m + 1 | 0];
                                                                                  break x;
                                                                                case 1:
                                                                                  if ((u - W | 0) < 2)
                                                                                    break I;
                                                                                  W = m + 3 | 0, Te = me[m + 1 | 0] | me[m + 2 | 0] << 8;
                                                                                  break x;
                                                                                default:
                                                                                  break b;
                                                                              }
                                                                            if ((u - W | 0) < 4)
                                                                              break I;
                                                                            W = m + 5 | 0, Te = me[m + 1 | 0] | me[m + 2 | 0] << 8 | (me[m + 3 | 0] << 16 | me[m + 4 | 0] << 24);
                                                                          }
                                                                          if (N = u - W | 0, (N | 0) < 0 || (m = Te, N >>> 0 < m >>> 0))
                                                                            break I;
                                                                          x: {
                                                                            if (!m) {
                                                                              Te = 0, N = 0;
                                                                              break x;
                                                                            }
                                                                            if ((m | 0) < 0) {
                                                                              if (e[5996] = 0, Nn(8), r = e[5996], e[5996] = 0, (r | 0) == 1)
                                                                                break R;
                                                                              break e;
                                                                            }
                                                                            if (e[5996] = 0, Te = Mi(3, m | 0) | 0, Xe = e[5996], e[5996] = 0, N = 0, (Xe | 0) == 1)
                                                                              break s;
                                                                            N = so(Te, W, m) + m | 0;
                                                                          }
                                                                          W = m + W | 0;
                                                                        }
                                                                        if (m = 3, fr - 103 >>> 0 < 2)
                                                                          break d;
                                                                        if (_[s | 0] = W, _[s + 1 | 0] = W >>> 8, _[s + 2 | 0] = W >>> 16, _[s + 3 | 0] = W >>> 24, !ar)
                                                                          break h;
                                                                        if (m = 0, (A | 0) <= 0)
                                                                          break E;
                                                                        for (; ; ) {
                                                                          if (e[5996] = 0, pi(97, p + 144 | 0, 5573) | 0, W = e[5996], e[5996] = 0, (W | 0) == 1)
                                                                            break w;
                                                                          if (m = m + 1 | 0, (m | 0) == (A | 0))
                                                                            break;
                                                                        }
                                                                        break E;
                                                                      }
                                                                      if (s = me[p + 155 | 0], A = s << 24 >> 24, Te = (A | 0) < 0 ? e[p + 148 >> 2] : s, u = Te + 8 | 0, u >>> 0 >= 2147483632) {
                                                                        if (e[5996] = 0, Nn(2), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                          break e;
                                                                        m = Hr() | 0;
                                                                        break i;
                                                                      }
                                                                      I: {
                                                                        if (u >>> 0 <= 10) {
                                                                          e[r + 8 >> 2] = 0, e[r >> 2] = 0, e[r + 4 >> 2] = 0, _[r + 11 | 0] = u;
                                                                          break I;
                                                                        }
                                                                        if (e[5996] = 0, m = (u | 15) + 1 | 0, s = Mi(3, m | 0) | 0, W = e[5996], e[5996] = 0, N = 0, (W | 0) == 1)
                                                                          break s;
                                                                        e[r + 4 >> 2] = u, e[r >> 2] = s, e[r + 8 >> 2] = m | -2147483648, r = s;
                                                                      }
                                                                      r = Ys(r, (A | 0) < 0 ? e[p + 144 >> 2] : p + 144 | 0, Te) + Te | 0, _[r + 8 | 0] = 0, _[r | 0] = 32, _[r + 1 | 0] = 91, _[r + 2 | 0] = 101, _[r + 3 | 0] = 114, _[r + 4 | 0] = 114, _[r + 5 | 0] = 111, _[r + 6 | 0] = 114, _[r + 7 | 0] = 93;
                                                                      break r;
                                                                    }
                                                                    m = Hr() | 0;
                                                                    break i;
                                                                  }
                                                                  if (e[5996] = 0, ji(98, p + 144 | 0, 32), m = e[5996], e[5996] = 0, (m | 0) == 1)
                                                                    break a;
                                                                  m = me[p + 155 | 0], mi = (m << 24 >> 24 < 0 ? e[p + 148 >> 2] : m) - 1 | 0;
                                                                }
                                                                E: {
                                                                  h: {
                                                                    R: {
                                                                      I: {
                                                                        B:
                                                                          switch (vr = N - Te | 0, vr | 0) {
                                                                            case 0:
                                                                              break E;
                                                                            case 33:
                                                                              break R;
                                                                            case 32:
                                                                              break I;
                                                                            case 20:
                                                                              break B;
                                                                            default:
                                                                              break h;
                                                                          }
                                                                        if (e[5996] = 0, Xe = Mi(3, 20) | 0, m = e[5996], e[5996] = 0, (m | 0) == 1) {
                                                                          m = Hr() | 0;
                                                                          break o;
                                                                        }
                                                                        if (m = Xe, _[m | 0] = 153, _[m + 1 | 0] = 153, _[m + 2 | 0] = 153, _[m + 3 | 0] = 153, _[m + 4 | 0] = 153, _[m + 5 | 0] = 153, _[m + 6 | 0] = 153, _[m + 7 | 0] = 153, _[m + 16 | 0] = 153, _[m + 17 | 0] = 153, _[m + 18 | 0] = 153, _[m + 19 | 0] = 153, _[m + 8 | 0] = 153, _[m + 9 | 0] = 153, _[m + 10 | 0] = 153, _[m + 11 | 0] = 153, _[m + 12 | 0] = 153, _[m + 13 | 0] = 153, _[m + 14 | 0] = 153, _[m + 15 | 0] = 153, W = Te, (N | 0) == (W | 0))
                                                                          break p;
                                                                        for (; ; ) {
                                                                          if (me[W | 0] == me[m | 0]) {
                                                                            if (m = m + 1 | 0, W = W + 1 | 0, (N | 0) != (W | 0))
                                                                              continue;
                                                                            break p;
                                                                          }
                                                                          break;
                                                                        }
                                                                        if (Br(Xe), !(me[Te | 0] != 80 | me[Te + 1 | 0] != 75 | me[Te + 2 | 0] != 104)) {
                                                                          B: {
                                                                            x: {
                                                                              for (; ; ) {
                                                                                if (m = N - 1 | 0, !me[m | 0]) {
                                                                                  if (N = m, (m | 0) != (Te | 0))
                                                                                    continue;
                                                                                  break x;
                                                                                }
                                                                                break;
                                                                              }
                                                                              if (N = (N - Te | 0) - 3 | 0, N >>> 0 < 2147483632)
                                                                                break B;
                                                                            }
                                                                            if (e[5996] = 0, Nn(2), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                              break e;
                                                                            m = Hr() | 0;
                                                                            break o;
                                                                          }
                                                                          B: {
                                                                            x: {
                                                                              b: {
                                                                                C: {
                                                                                  y: {
                                                                                    D: {
                                                                                      P: {
                                                                                        if (N >>> 0 <= 10) {
                                                                                          _[p + 111 | 0] = N, W = p + 100 | 0;
                                                                                          break P;
                                                                                        }
                                                                                        if (e[5996] = 0, m = (N | 15) + 1 | 0, W = Mi(3, m | 0) | 0, Xe = e[5996], e[5996] = 0, (Xe | 0) == 1)
                                                                                          break D;
                                                                                        e[p + 100 >> 2] = W, e[p + 104 >> 2] = N, e[p + 108 >> 2] = m | -2147483648;
                                                                                      }
                                                                                      if (_[Ys(W, Te + 3 | 0, N) + N | 0] = 0, e[5996] = 0, N = xn(99, p + 100 | 0, 0, 5383) | 0, m = e[5996], e[5996] = 0, (m | 0) == 1)
                                                                                        break y;
                                                                                      if (e[p + 120 >> 2] = e[N + 8 >> 2], m = e[N + 4 >> 2], e[p + 112 >> 2] = e[N >> 2], e[p + 116 >> 2] = m, e[N >> 2] = 0, e[N + 4 >> 2] = 0, e[N + 8 >> 2] = 0, e[5996] = 0, m = pi(97, p + 112 | 0, 3723) | 0, W = e[5996], e[5996] = 0, (W | 0) == 1)
                                                                                        break C;
                                                                                      if (e[p + 136 >> 2] = e[m + 8 >> 2], W = e[m + 4 >> 2], e[p + 128 >> 2] = e[m >> 2], e[p + 132 >> 2] = W, e[m >> 2] = 0, e[m + 4 >> 2] = 0, e[m + 8 >> 2] = 0, e[5996] = 0, W = me[p + 139 | 0], Xe = W << 24 >> 24 < 0, xn(100, p + 144 | 0, (Xe ? e[p + 128 >> 2] : p + 128 | 0) | 0, (Xe ? e[p + 132 >> 2] : W) | 0) | 0, W = e[5996], e[5996] = 0, (W | 0) == 1)
                                                                                        break b;
                                                                                      if (_[p + 139 | 0] < 0 && Br(e[p + 128 >> 2]), _[p + 123 | 0] < 0 && Br(e[m >> 2]), _[p + 111 | 0] < 0 && Br(e[N >> 2]), !ar)
                                                                                        break u;
                                                                                      break f;
                                                                                    }
                                                                                    m = Hr() | 0;
                                                                                    break o;
                                                                                  }
                                                                                  m = Hr() | 0;
                                                                                  break B;
                                                                                }
                                                                                m = Hr() | 0;
                                                                                break x;
                                                                              }
                                                                              if (m = Hr() | 0, _[p + 139 | 0] >= 0)
                                                                                break x;
                                                                              Br(e[p + 128 >> 2]);
                                                                            }
                                                                            if (_[p + 123 | 0] >= 0)
                                                                              break B;
                                                                            Br(e[p + 112 >> 2]);
                                                                          }
                                                                          if (_[p + 111 | 0] >= 0)
                                                                            break o;
                                                                          Br(e[p + 100 >> 2]);
                                                                          break o;
                                                                        }
                                                                        if (e[p + 80 >> 2] = 0, e[5996] = 0, e[p + 72 >> 2] = 0, e[p + 76 >> 2] = 0, ji(101, p + 72 | 0, 40), m = e[5996], e[5996] = 0, (m | 0) == 1)
                                                                          break k;
                                                                        if (N >>> 0 > Te >>> 0)
                                                                          for (W = Te + 20 | 0, m = Te; ; ) {
                                                                            if (N = me[m | 0], e[5996] = 0, Xe = p + 72 | 0, ji(98, Xe | 0, _[(N >>> 4 | 0) + 6976 | 0]), fr = e[5996], e[5996] = 0, (fr | 0) == 1 || (e[5996] = 0, ji(98, Xe | 0, _[(N & 15) + 6976 | 0]), N = e[5996], e[5996] = 0, (N | 0) == 1))
                                                                              break k;
                                                                            if (m = m + 1 | 0, (W | 0) == (m | 0))
                                                                              break;
                                                                          }
                                                                        e[5996] = 0, N = xn(99, p + 72 | 0, 0, 3762) | 0, m = e[5996], e[5996] = 0;
                                                                        B: {
                                                                          x: {
                                                                            b: {
                                                                              C: {
                                                                                if ((m | 0) != 1) {
                                                                                  if (e[p + 96 >> 2] = e[N + 8 >> 2], m = e[N + 4 >> 2], e[p + 88 >> 2] = e[N >> 2], e[p + 92 >> 2] = m, e[N >> 2] = 0, e[N + 4 >> 2] = 0, e[N + 8 >> 2] = 0, e[5996] = 0, m = pi(97, p + 88 | 0, 3760) | 0, W = e[5996], e[5996] = 0, (W | 0) == 1)
                                                                                    break C;
                                                                                  if (e[p + 136 >> 2] = e[m + 8 >> 2], W = e[m + 4 >> 2], e[p + 128 >> 2] = e[m >> 2], e[p + 132 >> 2] = W, e[m >> 2] = 0, e[m + 4 >> 2] = 0, e[m + 8 >> 2] = 0, e[5996] = 0, W = me[p + 139 | 0], Xe = W << 24 >> 24 < 0, xn(100, p + 144 | 0, (Xe ? e[p + 128 >> 2] : p + 128 | 0) | 0, (Xe ? e[p + 132 >> 2] : W) | 0) | 0, W = e[5996], e[5996] = 0, (W | 0) == 1)
                                                                                    break b;
                                                                                  if (_[p + 139 | 0] < 0 && Br(e[p + 128 >> 2]), _[p + 99 | 0] < 0 && Br(e[m >> 2]), _[p + 83 | 0] < 0 && Br(e[N >> 2]), !ar)
                                                                                    break u;
                                                                                  break f;
                                                                                }
                                                                                m = Hr() | 0;
                                                                                break B;
                                                                              }
                                                                              m = Hr() | 0;
                                                                              break x;
                                                                            }
                                                                            if (m = Hr() | 0, _[p + 139 | 0] >= 0)
                                                                              break x;
                                                                            Br(e[p + 128 >> 2]);
                                                                          }
                                                                          if (_[p + 99 | 0] >= 0)
                                                                            break B;
                                                                          Br(e[p + 88 >> 2]);
                                                                        }
                                                                        break m;
                                                                      }
                                                                      if (e[5996] = 0, Xe = Mi(3, 32) | 0, m = e[5996], e[5996] = 0, (m | 0) == 1) {
                                                                        m = Hr() | 0;
                                                                        break o;
                                                                      }
                                                                      if (m = Xe, _[m | 0] = 136, _[m + 1 | 0] = 136, _[m + 2 | 0] = 136, _[m + 3 | 0] = 136, _[m + 4 | 0] = 136, _[m + 5 | 0] = 136, _[m + 6 | 0] = 136, _[m + 7 | 0] = 136, _[m + 24 | 0] = 136, _[m + 25 | 0] = 136, _[m + 26 | 0] = 136, _[m + 27 | 0] = 136, _[m + 28 | 0] = 136, _[m + 29 | 0] = 136, _[m + 30 | 0] = 136, _[m + 31 | 0] = 136, _[m + 16 | 0] = 136, _[m + 17 | 0] = 136, _[m + 18 | 0] = 136, _[m + 19 | 0] = 136, _[m + 20 | 0] = 136, _[m + 21 | 0] = 136, _[m + 22 | 0] = 136, _[m + 23 | 0] = 136, _[m + 8 | 0] = 136, _[m + 9 | 0] = 136, _[m + 10 | 0] = 136, _[m + 11 | 0] = 136, _[m + 12 | 0] = 136, _[m + 13 | 0] = 136, _[m + 14 | 0] = 136, _[m + 15 | 0] = 136, W = Te, (N | 0) == (W | 0))
                                                                        break p;
                                                                      for (; Ni = me[W | 0], Hi = me[m | 0], (Ni | 0) == (Hi | 0) && (m = m + 1 | 0, W = W + 1 | 0, (N | 0) != (W | 0)); )
                                                                        ;
                                                                      if (Br(Xe), (Ni | 0) == (Hi | 0))
                                                                        break A;
                                                                      if (!vr)
                                                                        break E;
                                                                      if ((vr | 0) != 33)
                                                                        break h;
                                                                    }
                                                                    if (me[Te | 0] != 2 | me[Te + 1 | 0] != 80 | (me[Te + 2 | 0] != 75 | me[Te + 3 | 0] != 98))
                                                                      break h;
                                                                    R: {
                                                                      if ((N | 0) != (Te | 0)) {
                                                                        I: {
                                                                          for (; ; ) {
                                                                            if (m = N - 1 | 0, !me[m | 0]) {
                                                                              if (N = m, (m | 0) != (Te | 0))
                                                                                continue;
                                                                              break I;
                                                                            }
                                                                            break;
                                                                          }
                                                                          if (N = (N - Te | 0) - 4 | 0, N >>> 0 < 2147483632)
                                                                            break R;
                                                                        }
                                                                        N = Te;
                                                                      }
                                                                      if (e[5996] = 0, Nn(2), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                        break e;
                                                                      m = Hr() | 0;
                                                                      break n;
                                                                    }
                                                                    R: {
                                                                      I: {
                                                                        B: {
                                                                          x: {
                                                                            b: {
                                                                              C: {
                                                                                y: {
                                                                                  if (N >>> 0 <= 10) {
                                                                                    _[p + 55 | 0] = N, W = p + 44 | 0;
                                                                                    break y;
                                                                                  }
                                                                                  if (e[5996] = 0, m = (N | 15) + 1 | 0, W = Mi(3, m | 0) | 0, Xe = e[5996], e[5996] = 0, (Xe | 0) == 1)
                                                                                    break C;
                                                                                  e[p + 44 >> 2] = W, e[p + 48 >> 2] = N, e[p + 52 >> 2] = m | -2147483648;
                                                                                }
                                                                                if (_[Ys(W, Te + 4 | 0, N) + N | 0] = 0, e[5996] = 0, N = xn(99, p + 44 | 0, 0, 3762) | 0, m = e[5996], e[5996] = 0, (m | 0) == 1)
                                                                                  break b;
                                                                                if (e[p - -64 >> 2] = e[N + 8 >> 2], m = e[N + 4 >> 2], e[p + 56 >> 2] = e[N >> 2], e[p + 60 >> 2] = m, e[N >> 2] = 0, e[N + 4 >> 2] = 0, e[N + 8 >> 2] = 0, e[5996] = 0, m = pi(97, p + 56 | 0, 3760) | 0, W = e[5996], e[5996] = 0, (W | 0) == 1)
                                                                                  break x;
                                                                                if (e[p + 136 >> 2] = e[m + 8 >> 2], W = e[m + 4 >> 2], e[p + 128 >> 2] = e[m >> 2], e[p + 132 >> 2] = W, e[m >> 2] = 0, e[m + 4 >> 2] = 0, e[m + 8 >> 2] = 0, e[5996] = 0, W = me[p + 139 | 0], Xe = W << 24 >> 24 < 0, xn(100, p + 144 | 0, (Xe ? e[p + 128 >> 2] : p + 128 | 0) | 0, (Xe ? e[p + 132 >> 2] : W) | 0) | 0, W = e[5996], e[5996] = 0, (W | 0) == 1)
                                                                                  break B;
                                                                                if (_[p + 139 | 0] < 0 && Br(e[p + 128 >> 2]), _[p + 67 | 0] < 0 && Br(e[m >> 2]), _[p + 55 | 0] < 0 && Br(e[N >> 2]), ar)
                                                                                  break f;
                                                                                break u;
                                                                              }
                                                                              m = Hr() | 0;
                                                                              break o;
                                                                            }
                                                                            m = Hr() | 0;
                                                                            break R;
                                                                          }
                                                                          m = Hr() | 0;
                                                                          break I;
                                                                        }
                                                                        if (m = Hr() | 0, _[p + 139 | 0] >= 0)
                                                                          break I;
                                                                        Br(e[p + 128 >> 2]);
                                                                      }
                                                                      if (_[p + 67 | 0] >= 0)
                                                                        break R;
                                                                      Br(e[p + 56 >> 2]);
                                                                    }
                                                                    if (_[p + 55 | 0] >= 0)
                                                                      break o;
                                                                    Br(e[p + 44 >> 2]);
                                                                    break o;
                                                                  }
                                                                  if (e[p + 24 >> 2] = 0, e[5996] = 0, e[p + 16 >> 2] = 0, e[p + 20 >> 2] = 0, ji(101, p + 16 | 0, vr << 1), m = e[5996], e[5996] = 0, (m | 0) == 1)
                                                                    break S;
                                                                  if (N >>> 0 > Te >>> 0)
                                                                    for (W = Te + vr | 0, m = Te; ; ) {
                                                                      if (N = me[m | 0], e[5996] = 0, Xe = p + 16 | 0, ji(98, Xe | 0, _[(N >>> 4 | 0) + 6976 | 0]), fr = e[5996], e[5996] = 0, (fr | 0) == 1 || (e[5996] = 0, ji(98, Xe | 0, _[(N & 15) + 6976 | 0]), N = e[5996], e[5996] = 0, (N | 0) == 1))
                                                                        break S;
                                                                      if (m = m + 1 | 0, (W | 0) == (m | 0))
                                                                        break;
                                                                    }
                                                                  e[5996] = 0, N = xn(99, p + 16 | 0, 0, 3762) | 0, m = e[5996], e[5996] = 0;
                                                                  h: {
                                                                    R: {
                                                                      I: {
                                                                        B: {
                                                                          if ((m | 0) != 1) {
                                                                            if (e[p + 40 >> 2] = e[N + 8 >> 2], m = e[N + 4 >> 2], e[p + 32 >> 2] = e[N >> 2], e[p + 36 >> 2] = m, e[N >> 2] = 0, e[N + 4 >> 2] = 0, e[N + 8 >> 2] = 0, e[5996] = 0, m = pi(97, p + 32 | 0, 3760) | 0, W = e[5996], e[5996] = 0, (W | 0) == 1)
                                                                              break B;
                                                                            if (e[p + 136 >> 2] = e[m + 8 >> 2], W = e[m + 4 >> 2], e[p + 128 >> 2] = e[m >> 2], e[p + 132 >> 2] = W, e[m >> 2] = 0, e[m + 4 >> 2] = 0, e[m + 8 >> 2] = 0, e[5996] = 0, W = me[p + 139 | 0], Xe = W << 24 >> 24 < 0, xn(100, p + 144 | 0, (Xe ? e[p + 128 >> 2] : p + 128 | 0) | 0, (Xe ? e[p + 132 >> 2] : W) | 0) | 0, W = e[5996], e[5996] = 0, (W | 0) == 1)
                                                                              break I;
                                                                            if (_[p + 139 | 0] < 0 && Br(e[p + 128 >> 2]), _[p + 43 | 0] < 0 && Br(e[m >> 2]), _[p + 27 | 0] < 0 && Br(e[N >> 2]), !ar)
                                                                              break u;
                                                                            break f;
                                                                          }
                                                                          m = Hr() | 0;
                                                                          break h;
                                                                        }
                                                                        m = Hr() | 0;
                                                                        break R;
                                                                      }
                                                                      if (m = Hr() | 0, _[p + 139 | 0] >= 0)
                                                                        break R;
                                                                      Br(e[p + 128 >> 2]);
                                                                    }
                                                                    if (_[p + 43 | 0] >= 0)
                                                                      break h;
                                                                    Br(e[p + 32 >> 2]);
                                                                  }
                                                                  break N;
                                                                }
                                                                if (m = e[(fr << 2) + 5840 >> 2], N = Fa(m), N >>> 0 >= 2147483632) {
                                                                  if (e[5996] = 0, Nn(2), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                    break e;
                                                                  m = Hr() | 0;
                                                                  break o;
                                                                }
                                                                E: {
                                                                  h: {
                                                                    R: {
                                                                      I: {
                                                                        B: {
                                                                          x: {
                                                                            b: {
                                                                              C: {
                                                                                y: {
                                                                                  D: {
                                                                                    P: {
                                                                                      q: {
                                                                                        O: {
                                                                                          Q: {
                                                                                            U: {
                                                                                              F: {
                                                                                                M: {
                                                                                                  L: {
                                                                                                    H: {
                                                                                                      if (N >>> 0 <= 10) {
                                                                                                        _[p + 139 | 0] = N, W = p + 128 | 0;
                                                                                                        break H;
                                                                                                      }
                                                                                                      if (e[5996] = 0, Xe = (N | 15) + 1 | 0, W = Mi(3, Xe | 0) | 0, vr = e[5996], e[5996] = 0, (vr | 0) == 1)
                                                                                                        break L;
                                                                                                      e[p + 128 >> 2] = W, e[p + 132 >> 2] = N, e[p + 136 >> 2] = Xe | -2147483648;
                                                                                                    }
                                                                                                    if (_[Ys(W, m, N) + N | 0] = 0, e[5996] = 0, N = me[p + 139 | 0], m = N << 24 >> 24 < 0, N = xn(100, p + 144 | 0, (m ? e[p + 128 >> 2] : p + 128 | 0) | 0, (m ? e[p + 132 >> 2] : N) | 0) | 0, m = e[5996], e[5996] = 0, (m | 0) == 1)
                                                                                                      break M;
                                                                                                    if (_[p + 139 | 0] < 0 && Br(e[p + 128 >> 2]), fr - 99 >>> 0 > 1)
                                                                                                      break g;
                                                                                                    if (e[5996] = 0, ji(98, N | 0, 10), m = e[5996], e[5996] = 0, (m | 0) == 1)
                                                                                                      break a;
                                                                                                    if (e[5996] = 0, m = p + 128 | 0, Vs(102, m | 0, s | 0, u | 0, hi | 0), W = e[5996], e[5996] = 0, (W | 0) == 1)
                                                                                                      break F;
                                                                                                    if (e[5996] = 0, Xe = N, W = m, N = me[p + 139 | 0], m = N << 24 >> 24 < 0, Xe = xn(100, Xe | 0, (m ? e[p + 128 >> 2] : W) | 0, (m ? e[p + 132 >> 2] : N) | 0) | 0, N = e[5996], e[5996] = 0, (N | 0) == 1)
                                                                                                      break U;
                                                                                                    if (_[p + 139 | 0] < 0 && Br(e[p + 128 >> 2]), W = me[s | 0] | me[s + 1 | 0] << 8 | (me[s + 2 | 0] << 16 | me[s + 3 | 0] << 24), (W | 0) == (u | 0))
                                                                                                      break B;
                                                                                                    if (me[W | 0] != 103)
                                                                                                      break O;
                                                                                                    if (m = 0, (A | 0) > 0) {
                                                                                                      for (; ; ) {
                                                                                                        if (e[5996] = 0, pi(97, Xe | 0, 5573) | 0, N = e[5996], e[5996] = 0, (N | 0) == 1)
                                                                                                          break v;
                                                                                                        if (m = m + 1 | 0, (m | 0) == (A | 0))
                                                                                                          break;
                                                                                                      }
                                                                                                      W = me[s | 0] | me[s + 1 | 0] << 8 | (me[s + 2 | 0] << 16 | me[s + 3 | 0] << 24);
                                                                                                    }
                                                                                                    if (N = W + 1 | 0, _[s | 0] = N, _[s + 1 | 0] = N >>> 8, _[s + 2 | 0] = N >>> 16, _[s + 3 | 0] = N >>> 24, m = e[(me[W | 0] << 2) + 5840 >> 2], N = Fa(m), N >>> 0 < 2147483632)
                                                                                                      break Q;
                                                                                                    if (e[5996] = 0, Nn(2), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                                                      break e;
                                                                                                    m = Hr() | 0;
                                                                                                    break o;
                                                                                                  }
                                                                                                  m = Hr() | 0;
                                                                                                  break o;
                                                                                                }
                                                                                                if (m = Hr() | 0, _[p + 139 | 0] >= 0)
                                                                                                  break o;
                                                                                                Br(e[p + 128 >> 2]);
                                                                                                break o;
                                                                                              }
                                                                                              m = Hr() | 0;
                                                                                              break o;
                                                                                            }
                                                                                            if (m = Hr() | 0, _[p + 139 | 0] >= 0)
                                                                                              break o;
                                                                                            Br(e[p + 128 >> 2]);
                                                                                            break o;
                                                                                          }
                                                                                          Q: {
                                                                                            if (N >>> 0 <= 10) {
                                                                                              _[p + 11 | 0] = N, W = p;
                                                                                              break Q;
                                                                                            }
                                                                                            if (e[5996] = 0, fr = (N | 15) + 1 | 0, W = Mi(3, fr | 0) | 0, ar = e[5996], e[5996] = 0, (ar | 0) == 1)
                                                                                              break q;
                                                                                            e[p >> 2] = W, e[p + 4 >> 2] = N, e[p + 8 >> 2] = fr | -2147483648;
                                                                                          }
                                                                                          if (_[Ys(W, m, N) + N | 0] = 0, e[5996] = 0, ji(98, p | 0, 10), N = e[5996], e[5996] = 0, (N | 0) == 1)
                                                                                            break P;
                                                                                          if (e[p + 136 >> 2] = e[p + 8 >> 2], e[p + 8 >> 2] = 0, m = e[p + 4 >> 2], N = e[p >> 2], e[p + 128 >> 2] = N, e[p + 132 >> 2] = m, e[p >> 2] = 0, e[p + 4 >> 2] = 0, e[5996] = 0, W = N, N = _[p + 139 | 0], m = (N | 0) < 0, N = xn(100, Xe | 0, (m ? W : p + 128 | 0) | 0, (m ? e[p + 132 >> 2] : N & 255) | 0) | 0, m = e[5996], e[5996] = 0, (m | 0) == 1)
                                                                                            break D;
                                                                                          if (_[p + 139 | 0] < 0 && Br(e[p + 128 >> 2]), _[p + 11 | 0] < 0 && Br(e[p >> 2]), e[5996] = 0, m = p + 128 | 0, Vs(102, m | 0, s | 0, u | 0, hi | 0), W = e[5996], e[5996] = 0, (W | 0) == 1)
                                                                                            break C;
                                                                                          if (e[5996] = 0, fr = N, W = m, N = me[p + 139 | 0], m = N << 24 >> 24 < 0, xn(100, fr | 0, (m ? e[p + 128 >> 2] : W) | 0, (m ? e[p + 132 >> 2] : N) | 0) | 0, N = e[5996], e[5996] = 0, (N | 0) == 1)
                                                                                            break b;
                                                                                          _[p + 139 | 0] < 0 && Br(e[p + 128 >> 2]), W = me[s | 0] | me[s + 1 | 0] << 8 | (me[s + 2 | 0] << 16 | me[s + 3 | 0] << 24);
                                                                                        }
                                                                                        if ((u | 0) == (W | 0) | me[W | 0] != 104)
                                                                                          break B;
                                                                                        if (m = 0, (A | 0) > 0) {
                                                                                          for (; ; ) {
                                                                                            if (e[5996] = 0, pi(97, Xe | 0, 5573) | 0, N = e[5996], e[5996] = 0, (N | 0) == 1)
                                                                                              break T;
                                                                                            if (m = m + 1 | 0, (m | 0) == (A | 0))
                                                                                              break;
                                                                                          }
                                                                                          W = me[s | 0] | me[s + 1 | 0] << 8 | (me[s + 2 | 0] << 16 | me[s + 3 | 0] << 24);
                                                                                        }
                                                                                        if (N = W + 1 | 0, _[s | 0] = N, _[s + 1 | 0] = N >>> 8, _[s + 2 | 0] = N >>> 16, _[s + 3 | 0] = N >>> 24, m = e[(me[W | 0] << 2) + 5840 >> 2], N = Fa(m), N >>> 0 < 2147483632)
                                                                                          break x;
                                                                                        if (e[5996] = 0, Nn(2), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                                          break e;
                                                                                        m = Hr() | 0;
                                                                                        break o;
                                                                                      }
                                                                                      m = Hr() | 0;
                                                                                      break o;
                                                                                    }
                                                                                    m = Hr() | 0;
                                                                                    break y;
                                                                                  }
                                                                                  if (m = Hr() | 0, _[p + 139 | 0] >= 0)
                                                                                    break y;
                                                                                  Br(e[p + 128 >> 2]);
                                                                                }
                                                                                if (_[p + 11 | 0] >= 0)
                                                                                  break o;
                                                                                Br(e[p >> 2]);
                                                                                break o;
                                                                              }
                                                                              m = Hr() | 0;
                                                                              break o;
                                                                            }
                                                                            if (m = Hr() | 0, _[p + 139 | 0] >= 0)
                                                                              break o;
                                                                            Br(e[p + 128 >> 2]);
                                                                            break o;
                                                                          }
                                                                          x: {
                                                                            if (N >>> 0 <= 10) {
                                                                              _[p + 11 | 0] = N, W = p;
                                                                              break x;
                                                                            }
                                                                            if (e[5996] = 0, fr = (N | 15) + 1 | 0, W = Mi(3, fr | 0) | 0, ar = e[5996], e[5996] = 0, (ar | 0) == 1)
                                                                              break I;
                                                                            e[p >> 2] = W, e[p + 4 >> 2] = N, e[p + 8 >> 2] = fr | -2147483648;
                                                                          }
                                                                          if (_[Ys(W, m, N) + N | 0] = 0, e[5996] = 0, ji(98, p | 0, 10), N = e[5996], e[5996] = 0, (N | 0) == 1)
                                                                            break R;
                                                                          if (e[p + 136 >> 2] = e[p + 8 >> 2], e[p + 8 >> 2] = 0, m = e[p + 4 >> 2], N = e[p >> 2], e[p + 128 >> 2] = N, e[p + 132 >> 2] = m, e[p >> 2] = 0, e[p + 4 >> 2] = 0, e[5996] = 0, W = N, N = _[p + 139 | 0], m = (N | 0) < 0, xn(100, Xe | 0, (m ? W : p + 128 | 0) | 0, (m ? e[p + 132 >> 2] : N & 255) | 0) | 0, N = e[5996], e[5996] = 0, (N | 0) == 1)
                                                                            break h;
                                                                          if (_[p + 139 | 0] < 0 && Br(e[p + 128 >> 2]), _[p + 11 | 0] >= 0)
                                                                            break B;
                                                                          Br(e[p >> 2]);
                                                                        }
                                                                        N = me[p + 155 | 0], _r = N << 24 >> 24 < 0 ? e[p + 148 >> 2] : N;
                                                                        break f;
                                                                      }
                                                                      m = Hr() | 0;
                                                                      break o;
                                                                    }
                                                                    m = Hr() | 0;
                                                                    break E;
                                                                  }
                                                                  if (m = Hr() | 0, _[p + 139 | 0] >= 0)
                                                                    break E;
                                                                  Br(e[p + 128 >> 2]);
                                                                }
                                                                if (_[p + 11 | 0] >= 0)
                                                                  break o;
                                                                Br(e[p >> 2]);
                                                                break o;
                                                              }
                                                              m = Hr() | 0;
                                                              break o;
                                                            }
                                                            m = Hr() | 0;
                                                            break o;
                                                          }
                                                          m = Hr() | 0;
                                                          break o;
                                                        }
                                                        m = Hr() | 0;
                                                      }
                                                      if (_[p + 27 | 0] >= 0)
                                                        break o;
                                                      Br(e[p + 16 >> 2]);
                                                      break o;
                                                    }
                                                    m = Hr() | 0;
                                                  }
                                                  if (_[p + 83 | 0] >= 0)
                                                    break o;
                                                  Br(e[p + 72 >> 2]);
                                                  break o;
                                                }
                                                Br(Xe);
                                              }
                                              if (e[5996] = 0, pi(97, p + 144 | 0, 3719) | 0, N = e[5996], e[5996] = 0, (N | 0) == 1)
                                                break a;
                                            }
                                            if (ar)
                                              break f;
                                          }
                                          if (m = me[p + 155 | 0], N = m << 24 >> 24, W = (N | 0) < 0, (W ? e[p + 148 >> 2] : m) - _r >>> 0 < 81 || (m = 0, _[(W ? e[p + 144 >> 2] : p + 144 | 0) + mi | 0] = 10, _r = mi + 1 | 0, (A | 0) <= 0))
                                            break f;
                                          for (; ; ) {
                                            if (e[5996] = 0, xn(99, p + 144 | 0, _r | 0, 5573) | 0, N = e[5996], e[5996] = 0, (N | 0) == 1)
                                              break l;
                                            if (m = m + 1 | 0, (m | 0) == (A | 0))
                                              break;
                                          }
                                        }
                                        N = me[p + 155 | 0], ar = ((N << 24 >> 24 < 0 ? e[p + 148 >> 2] : N) | 0) == (_r | 0), m = 0;
                                      }
                                      if (Te && Br(Te), !!m)
                                        break;
                                    }
                                    if ((m | 0) != 3)
                                      break r;
                                  }
                                  c: {
                                    if (!ar && (e[5996] = 0, ji(98, p + 144 | 0, 10), s = e[5996], e[5996] = 0, (s | 0) == 1))
                                      break c;
                                    s = e[p + 148 >> 2], e[r >> 2] = e[p + 144 >> 2], e[r + 4 >> 2] = s, e[r + 8 >> 2] = e[p + 152 >> 2];
                                    break t;
                                  }
                                  m = Hr() | 0;
                                  break i;
                                }
                                m = Hr() | 0;
                              }
                              N = Te;
                              break n;
                            }
                            N = Te;
                          }
                          m = Hr() | 0;
                        }
                        if (!N)
                          break i;
                        Br(N);
                      }
                      _[p + 155 | 0] < 0 && Br(e[p + 144 >> 2]), Jn(m | 0), Oi();
                    }
                    if (_[p + 155 | 0] >= 0)
                      break t;
                    Br(e[p + 144 >> 2]);
                  }
                  Jr = p + 160 | 0;
                  return;
                }
                Oi();
              }
              function Z1() {
                for (var r = 0, s = 0, u = 0, A = 0, m = 0, p = 0, N = 0; s = r << 4, u = s + 22944 | 0, e[s + 22948 >> 2] = u, e[s + 22952 >> 2] = u, r = r + 1 | 0, (r | 0) != 64; )
                  ;
                al(48), r = Jr - 16 | 0, Jr = r;
                e: {
                  if (F1(r + 12 | 0, r + 8 | 0) | 0 || (s = da((e[r + 12 >> 2] << 2) + 4 | 0), e[6181] = s, !s) || (s = da(e[r + 8 >> 2]), s && (u = e[6181], e[u + (e[r + 12 >> 2] << 2) >> 2] = 0, !(Gu(u | 0, s | 0) | 0))))
                    break e;
                  e[6181] = 0;
                }
                Jr = r + 16 | 0, r = Qs(64), e[5998] = r, e[5999] = 62, e[6e3] = -2147483584, s = me[3832] | me[3833] << 8 | (me[3834] << 16 | me[3835] << 24), u = me[3828] | me[3829] << 8 | (me[3830] << 16 | me[3831] << 24), _[r + 54 | 0] = u, _[r + 55 | 0] = u >>> 8, _[r + 56 | 0] = u >>> 16, _[r + 57 | 0] = u >>> 24, _[r + 58 | 0] = s, _[r + 59 | 0] = s >>> 8, _[r + 60 | 0] = s >>> 16, _[r + 61 | 0] = s >>> 24, s = me[3826] | me[3827] << 8 | (me[3828] << 16 | me[3829] << 24), u = me[3822] | me[3823] << 8 | (me[3824] << 16 | me[3825] << 24), _[r + 48 | 0] = u, _[r + 49 | 0] = u >>> 8, _[r + 50 | 0] = u >>> 16, _[r + 51 | 0] = u >>> 24, _[r + 52 | 0] = s, _[r + 53 | 0] = s >>> 8, _[r + 54 | 0] = s >>> 16, _[r + 55 | 0] = s >>> 24, s = me[3818] | me[3819] << 8 | (me[3820] << 16 | me[3821] << 24), u = me[3814] | me[3815] << 8 | (me[3816] << 16 | me[3817] << 24), _[r + 40 | 0] = u, _[r + 41 | 0] = u >>> 8, _[r + 42 | 0] = u >>> 16, _[r + 43 | 0] = u >>> 24, _[r + 44 | 0] = s, _[r + 45 | 0] = s >>> 8, _[r + 46 | 0] = s >>> 16, _[r + 47 | 0] = s >>> 24, s = me[3810] | me[3811] << 8 | (me[3812] << 16 | me[3813] << 24), u = me[3806] | me[3807] << 8 | (me[3808] << 16 | me[3809] << 24), _[r + 32 | 0] = u, _[r + 33 | 0] = u >>> 8, _[r + 34 | 0] = u >>> 16, _[r + 35 | 0] = u >>> 24, _[r + 36 | 0] = s, _[r + 37 | 0] = s >>> 8, _[r + 38 | 0] = s >>> 16, _[r + 39 | 0] = s >>> 24, s = me[3802] | me[3803] << 8 | (me[3804] << 16 | me[3805] << 24), u = me[3798] | me[3799] << 8 | (me[3800] << 16 | me[3801] << 24), _[r + 24 | 0] = u, _[r + 25 | 0] = u >>> 8, _[r + 26 | 0] = u >>> 16, _[r + 27 | 0] = u >>> 24, _[r + 28 | 0] = s, _[r + 29 | 0] = s >>> 8, _[r + 30 | 0] = s >>> 16, _[r + 31 | 0] = s >>> 24, s = me[3794] | me[3795] << 8 | (me[3796] << 16 | me[3797] << 24), u = me[3790] | me[3791] << 8 | (me[3792] << 16 | me[3793] << 24), _[r + 16 | 0] = u, _[r + 17 | 0] = u >>> 8, _[r + 18 | 0] = u >>> 16, _[r + 19 | 0] = u >>> 24, _[r + 20 | 0] = s, _[r + 21 | 0] = s >>> 8, _[r + 22 | 0] = s >>> 16, _[r + 23 | 0] = s >>> 24, s = me[3786] | me[3787] << 8 | (me[3788] << 16 | me[3789] << 24), u = me[3782] | me[3783] << 8 | (me[3784] << 16 | me[3785] << 24), _[r + 8 | 0] = u, _[r + 9 | 0] = u >>> 8, _[r + 10 | 0] = u >>> 16, _[r + 11 | 0] = u >>> 24, _[r + 12 | 0] = s, _[r + 13 | 0] = s >>> 8, _[r + 14 | 0] = s >>> 16, _[r + 15 | 0] = s >>> 24, s = me[3778] | me[3779] << 8 | (me[3780] << 16 | me[3781] << 24), u = me[3774] | me[3775] << 8 | (me[3776] << 16 | me[3777] << 24), _[r | 0] = u, _[r + 1 | 0] = u >>> 8, _[r + 2 | 0] = u >>> 16, _[r + 3 | 0] = u >>> 24, _[r + 4 | 0] = s, _[r + 5 | 0] = s >>> 8, _[r + 6 | 0] = s >>> 16, _[r + 7 | 0] = s >>> 24, _[r + 62 | 0] = 0, r = me[24003], s = r << 24 >> 24;
                e: {
                  t: {
                    if (A = (s | 0) < 0 ? e[5999] : r, r = A + 12 | 0, r >>> 0 < 2147483632) {
                      r: {
                        if (r >>> 0 <= 10) {
                          e[6004] = 0, e[6005] = 0, e[6006] = 0, _[24027] = r, u = 24016;
                          break r;
                        }
                        m = (r | 15) + 1 | 0, u = Qs(m), e[6005] = r, e[6004] = u, e[6006] = m | -2147483648;
                      }
                      r = u, u = (s | 0) >= 0 ? 23992 : e[5998], r = Ys(r, u, A) + A | 0, _[r + 12 | 0] = 0, s = me[5207] | me[5208] << 8 | (me[5209] << 16 | me[5210] << 24), _[r + 8 | 0] = s, _[r + 9 | 0] = s >>> 8, _[r + 10 | 0] = s >>> 16, _[r + 11 | 0] = s >>> 24, s = me[5203] | me[5204] << 8 | (me[5205] << 16 | me[5206] << 24), m = me[5199] | me[5200] << 8 | (me[5201] << 16 | me[5202] << 24), _[r | 0] = m, _[r + 1 | 0] = m >>> 8, _[r + 2 | 0] = m >>> 16, _[r + 3 | 0] = m >>> 24, _[r + 4 | 0] = s, _[r + 5 | 0] = s >>> 8, _[r + 6 | 0] = s >>> 16, _[r + 7 | 0] = s >>> 24;
                      r: {
                        r = A + 8 | 0;
                        i: {
                          if (r >>> 0 >= 2147483632) {
                            if (e[5996] = 0, Nn(2), s = e[5996], e[5996] = 0, r = 24028, (s | 0) == 1)
                              break i;
                            break t;
                          }
                          n: {
                            if (r >>> 0 <= 10) {
                              e[6007] = 0, e[6008] = 0, e[6009] = 0, _[24039] = r, s = 24028;
                              break n;
                            }
                            if (e[5996] = 0, m = (r | 15) + 1 | 0, s = Mi(3, m | 0) | 0, p = e[5996], e[5996] = 0, (p | 0) == 1) {
                              r = 24028;
                              break i;
                            }
                            e[6008] = r, e[6007] = s, e[6009] = m | -2147483648;
                          }
                          if (r = Ys(s, u, A) + A | 0, _[r + 8 | 0] = 0, _[r | 0] = 32, _[r + 1 | 0] = 46, _[r + 2 | 0] = 44, _[r + 3 | 0] = 59, _[r + 4 | 0] = 45, _[r + 5 | 0] = 95, _[r + 6 | 0] = 63, _[r + 7 | 0] = 64, r = A + 3 | 0, r >>> 0 >= 2147483632) {
                            if (e[5996] = 0, Nn(2), s = e[5996], e[5996] = 0, r = 24040, (s | 0) != 1)
                              break t;
                            break i;
                          }
                          n: {
                            if (r >>> 0 <= 10) {
                              e[6010] = 0, e[6011] = 0, e[6012] = 0, _[24051] = r, s = 24040;
                              break n;
                            }
                            if (e[5996] = 0, m = (r | 15) + 1 | 0, s = Mi(3, m | 0) | 0, p = e[5996], e[5996] = 0, (p | 0) == 1) {
                              r = 24040;
                              break i;
                            }
                            e[6011] = r, e[6010] = s, e[6012] = m | -2147483648;
                          }
                          if (r = Ys(s, u, A) + A | 0, _[r + 3 | 0] = 0, _[r + 2 | 0] = me[2557], s = me[2555] | me[2556] << 8, _[r | 0] = s, _[r + 1 | 0] = s >>> 8, r = A + 23 | 0, r >>> 0 >= 2147483632) {
                            if (e[5996] = 0, Nn(2), s = e[5996], e[5996] = 0, r = 24052, (s | 0) != 1)
                              break t;
                            break i;
                          }
                          if (e[5996] = 0, m = (r | 15) + 1 | 0, s = Mi(3, m | 0) | 0, p = e[5996], e[5996] = 0, (p | 0) != 1)
                            break r;
                          r = 24052;
                        }
                        for (u = Hr() | 0; s = r - 12 | 0, _[r - 1 | 0] < 0 && Br(e[s >> 2]), r = s, (r | 0) != 24016; )
                          ;
                        Jn(u | 0), Oi();
                      }
                      e[6014] = r, e[6013] = s, e[6015] = m | -2147483648, r = Ys(s, u, A) + A | 0, _[r + 23 | 0] = 0, s = me[5412] | me[5413] << 8 | (me[5414] << 16 | me[5415] << 24), u = me[5408] | me[5409] << 8 | (me[5410] << 16 | me[5411] << 24), _[r + 15 | 0] = u, _[r + 16 | 0] = u >>> 8, _[r + 17 | 0] = u >>> 16, _[r + 18 | 0] = u >>> 24, _[r + 19 | 0] = s, _[r + 20 | 0] = s >>> 8, _[r + 21 | 0] = s >>> 16, _[r + 22 | 0] = s >>> 24, s = me[5405] | me[5406] << 8 | (me[5407] << 16 | me[5408] << 24), u = me[5401] | me[5402] << 8 | (me[5403] << 16 | me[5404] << 24), _[r + 8 | 0] = u, _[r + 9 | 0] = u >>> 8, _[r + 10 | 0] = u >>> 16, _[r + 11 | 0] = u >>> 24, _[r + 12 | 0] = s, _[r + 13 | 0] = s >>> 8, _[r + 14 | 0] = s >>> 16, _[r + 15 | 0] = s >>> 24, s = me[5397] | me[5398] << 8 | (me[5399] << 16 | me[5400] << 24), u = me[5393] | me[5394] << 8 | (me[5395] << 16 | me[5396] << 24), _[r | 0] = u, _[r + 1 | 0] = u >>> 8, _[r + 2 | 0] = u >>> 16, _[r + 3 | 0] = u >>> 24, _[r + 4 | 0] = s, _[r + 5 | 0] = s >>> 8, _[r + 6 | 0] = s >>> 16, _[r + 7 | 0] = s >>> 24;
                      break e;
                    }
                    Ra(), Oi();
                  }
                  Oi();
                }
                A = Jr - 48 | 0, Jr = A, e[A + 20 >> 2] = 0, e[A + 12 >> 2] = 0, e[A + 16 >> 2] = 0, e[5996] = 0, pi(9, 24064, A + 12 | 0) | 0, r = e[5996], e[5996] = 0;
                e: {
                  t: {
                    r: {
                      i: {
                        n: {
                          s: {
                            a: {
                              o: {
                                l: {
                                  c: {
                                    if ((r | 0) != 1) {
                                      if (r = e[A + 12 >> 2], r && Br(r), r = Qs(32), e[A + 36 >> 2] = r, s = r + 32 | 0, e[A + 44 >> 2] = s, _[r + 24 | 0] = 0, _[r + 25 | 0] = 0, _[r + 26 | 0] = 0, _[r + 27 | 0] = 0, _[r + 28 | 0] = 0, _[r + 29 | 0] = 0, _[r + 30 | 0] = 0, _[r + 31 | 0] = 0, _[r + 16 | 0] = 0, _[r + 17 | 0] = 0, _[r + 18 | 0] = 0, _[r + 19 | 0] = 0, _[r + 20 | 0] = 0, _[r + 21 | 0] = 0, _[r + 22 | 0] = 0, _[r + 23 | 0] = 0, _[r + 8 | 0] = 0, _[r + 9 | 0] = 0, _[r + 10 | 0] = 0, _[r + 11 | 0] = 0, _[r + 12 | 0] = 0, _[r + 13 | 0] = 0, _[r + 14 | 0] = 0, _[r + 15 | 0] = 0, _[r | 0] = 0, _[r + 1 | 0] = 0, _[r + 2 | 0] = 0, _[r + 3 | 0] = 0, _[r + 4 | 0] = 0, _[r + 5 | 0] = 0, _[r + 6 | 0] = 0, _[r + 7 | 0] = 0, e[5996] = 0, e[A + 40 >> 2] = s, p = pi(9, A + 12 | 0, A + 36 | 0) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1)
                                        break n;
                                      if (_[p + 5 | 0] = 1, e[6024] = e[p + 8 >> 2], r = e[p + 4 >> 2], e[6022] = e[p >> 2], e[6023] = r, e[6025] = 0, e[6026] = 0, e[6027] = 0, u = e[p + 16 >> 2], s = e[p + 12 >> 2], r = u - s | 0, m = (r | 0) / 12 | 0, (s | 0) == (u | 0))
                                        break s;
                                      if (m >>> 0 < 357913942)
                                        break c;
                                      if (e[5996] = 0, Nn(11), r = e[5996], e[5996] = 0, (r | 0) == 1)
                                        break l;
                                      Oi();
                                    }
                                    if (m = Hr() | 0, r = e[A + 12 >> 2], !r)
                                      break e;
                                    Br(r);
                                    break e;
                                  }
                                  if (e[5996] = 0, r = Mi(3, r | 0) | 0, N = e[5996], e[5996] = 0, (N | 0) == 1)
                                    break l;
                                  if (e[6026] = r, e[6025] = r, e[6027] = r + Sn(m, 12), e[5996] = 0, s = wa(12, 24108, s | 0, u | 0, r | 0) | 0, u = e[5996], e[5996] = 0, (u | 0) != 1)
                                    break a;
                                  m = Hr() | 0, e[6026] = r;
                                  break o;
                                }
                                m = Hr() | 0;
                              }
                              if (u = e[6025], u) {
                                if (r = e[6026], s = u, (r | 0) != (s | 0)) {
                                  for (; s = r - 12 | 0, N = e[s >> 2], N && (e[r - 8 >> 2] = N, Br(N)), r = s, (u | 0) != (r | 0); )
                                    ;
                                  s = e[6025];
                                }
                                e[6026] = u, Br(s);
                              }
                              if (u = e[p + 12 >> 2], !u)
                                break t;
                              if (r = e[p + 16 >> 2], s = u, (r | 0) != (s | 0)) {
                                for (; s = r - 12 | 0, N = e[s >> 2], N && (e[r - 8 >> 2] = N, Br(N)), r = s, (u | 0) != (r | 0); )
                                  ;
                                s = e[p + 12 >> 2];
                              }
                              e[p + 16 >> 2] = u, Br(s);
                              break t;
                            }
                            e[6026] = s, u = e[p + 12 >> 2];
                          }
                          if (u) {
                            if (r = e[p + 16 >> 2], s = u, (r | 0) != (s | 0)) {
                              for (; s = r - 12 | 0, m = e[s >> 2], m && (e[r - 8 >> 2] = m, Br(m)), r = s, (u | 0) != (r | 0); )
                                ;
                              s = e[p + 12 >> 2];
                            }
                            e[p + 16 >> 2] = u, Br(s);
                          }
                          if (r = e[A + 36 >> 2], r && Br(r), r = Qs(1), e[A + 36 >> 2] = r, s = r + 1 | 0, e[A + 44 >> 2] = s, _[r | 0] = 1, e[5996] = 0, e[A + 40 >> 2] = s, pi(9, 24112, A + 36 | 0) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1)
                            break i;
                          r = e[A + 36 >> 2], r && Br(r), e[6036] = 0, e[6037] = 0, e[6034] = 1, e[6038] = 0, e[6039] = 0, _[24142] = 0, Zs[12070] = 0, e[6044] = 0, e[6045] = 0, e[6042] = -1, e[6043] = 0, _[24163] = 0, _[24164] = 0, _[24165] = 0, _[24166] = 0, e[6040] = 0, Jr = A + 48 | 0;
                          break r;
                        }
                        m = Hr() | 0;
                        break t;
                      }
                      m = Hr() | 0;
                      break t;
                    }
                    A = Jr - 48 | 0, Jr = A, e[A + 20 >> 2] = 0, e[A + 12 >> 2] = 0, e[A + 16 >> 2] = 0, e[5996] = 0, pi(9, 24184, A + 12 | 0) | 0, r = e[5996], e[5996] = 0;
                    r: {
                      i: {
                        n: {
                          s: {
                            a: {
                              o: {
                                l: {
                                  c: {
                                    d: {
                                      f: {
                                        if ((r | 0) != 1) {
                                          if (r = e[A + 12 >> 2], r && Br(r), r = Qs(32), e[A + 36 >> 2] = r, s = r + 32 | 0, e[A + 44 >> 2] = s, _[r + 24 | 0] = 0, _[r + 25 | 0] = 0, _[r + 26 | 0] = 0, _[r + 27 | 0] = 0, _[r + 28 | 0] = 0, _[r + 29 | 0] = 0, _[r + 30 | 0] = 0, _[r + 31 | 0] = 0, _[r + 16 | 0] = 0, _[r + 17 | 0] = 0, _[r + 18 | 0] = 0, _[r + 19 | 0] = 0, _[r + 20 | 0] = 0, _[r + 21 | 0] = 0, _[r + 22 | 0] = 0, _[r + 23 | 0] = 0, _[r + 8 | 0] = 0, _[r + 9 | 0] = 0, _[r + 10 | 0] = 0, _[r + 11 | 0] = 0, _[r + 12 | 0] = 0, _[r + 13 | 0] = 0, _[r + 14 | 0] = 0, _[r + 15 | 0] = 0, _[r | 0] = 0, _[r + 1 | 0] = 0, _[r + 2 | 0] = 0, _[r + 3 | 0] = 0, _[r + 4 | 0] = 0, _[r + 5 | 0] = 0, _[r + 6 | 0] = 0, _[r + 7 | 0] = 0, e[5996] = 0, e[A + 40 >> 2] = s, p = pi(9, A + 12 | 0, A + 36 | 0) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1)
                                            break a;
                                          if (_[p + 5 | 0] = 1, e[6054] = e[p + 8 >> 2], r = e[p + 4 >> 2], e[6052] = e[p >> 2], e[6053] = r, e[6055] = 0, e[6056] = 0, e[6057] = 0, u = e[p + 16 >> 2], s = e[p + 12 >> 2], r = u - s | 0, m = (r | 0) / 12 | 0, (s | 0) == (u | 0))
                                            break o;
                                          if (m >>> 0 < 357913942)
                                            break f;
                                          if (e[5996] = 0, Nn(11), r = e[5996], e[5996] = 0, (r | 0) == 1)
                                            break d;
                                          Oi();
                                        }
                                        if (m = Hr() | 0, r = e[A + 12 >> 2], !r)
                                          break e;
                                        Br(r);
                                        break e;
                                      }
                                      if (e[5996] = 0, r = Mi(3, r | 0) | 0, N = e[5996], e[5996] = 0, (N | 0) == 1)
                                        break d;
                                      if (e[6056] = r, e[6055] = r, e[6057] = r + Sn(m, 12), e[5996] = 0, s = wa(12, 24228, s | 0, u | 0, r | 0) | 0, u = e[5996], e[5996] = 0, (u | 0) != 1)
                                        break l;
                                      m = Hr() | 0, e[6056] = r;
                                      break c;
                                    }
                                    m = Hr() | 0;
                                  }
                                  if (u = e[6055], u) {
                                    if (r = u, s = e[6056], (r | 0) != (s | 0)) {
                                      for (; r = s - 12 | 0, N = e[r >> 2], N && (e[s - 8 >> 2] = N, Br(N)), s = r, (r | 0) != (u | 0); )
                                        ;
                                      r = e[6055];
                                    }
                                    e[6056] = u, Br(r);
                                  }
                                  if (u = e[p + 12 >> 2], !u)
                                    break t;
                                  if (r = u, s = e[p + 16 >> 2], (r | 0) != (s | 0)) {
                                    for (; r = s - 12 | 0, N = e[r >> 2], N && (e[s - 8 >> 2] = N, Br(N)), s = r, (r | 0) != (u | 0); )
                                      ;
                                    r = e[p + 12 >> 2];
                                  }
                                  e[p + 16 >> 2] = u, Br(r);
                                  break t;
                                }
                                e[6056] = s, u = e[p + 12 >> 2];
                              }
                              if (u) {
                                if (r = u, s = e[p + 16 >> 2], (r | 0) != (s | 0)) {
                                  for (; r = s - 12 | 0, m = e[r >> 2], m && (e[s - 8 >> 2] = m, Br(m)), s = r, (r | 0) != (u | 0); )
                                    ;
                                  r = e[p + 12 >> 2];
                                }
                                e[p + 16 >> 2] = u, Br(r);
                              }
                              if (r = e[A + 36 >> 2], r && Br(r), r = Qs(1), e[A + 36 >> 2] = r, s = r + 1 | 0, e[A + 44 >> 2] = s, _[r | 0] = 1, e[5996] = 0, e[A + 40 >> 2] = s, pi(9, 24232, A + 36 | 0) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1)
                                break s;
                              if (r = e[A + 36 >> 2], r && Br(r), e[6066] = 0, e[6067] = 0, e[6064] = 1, e[6068] = 0, e[6069] = 0, _[24262] = 0, Zs[12130] = 0, e[6074] = 0, e[6075] = 0, e[6072] = -1, e[6073] = 0, _[24283] = 0, _[24284] = 0, _[24285] = 0, _[24286] = 0, e[6070] = 0, e[6076] = 0, e[6077] = 0, e[6078] = 0, s = Qs(56), e[s >> 2] = 0, e[s + 4 >> 2] = 0, e[s + 40 >> 2] = 0, e[s + 44 >> 2] = 0, e[s + 32 >> 2] = 0, e[s + 36 >> 2] = 0, e[s + 24 >> 2] = 0, e[s + 28 >> 2] = 0, e[s + 16 >> 2] = 0, e[s + 20 >> 2] = 0, e[s + 8 >> 2] = 0, e[s + 12 >> 2] = 0, of(24304, s), r = Qs(4), e[r >> 2] = s, e[5996] = 0, s = Mi(3, 56) | 0, u = e[5996], e[5996] = 0, (u | 0) != 1)
                                break n;
                              break i;
                            }
                            m = Hr() | 0;
                            break t;
                          }
                          m = Hr() | 0;
                          break t;
                        }
                        if (e[s + 16 >> 2] = 0, e[s + 20 >> 2] = 0, e[s + 4 >> 2] = r, e[s >> 2] = 21, r = r + 4 | 0, e[s + 12 >> 2] = r, e[s + 8 >> 2] = r, e[s + 24 >> 2] = 0, e[s + 28 >> 2] = 0, e[s + 32 >> 2] = 0, e[s + 36 >> 2] = 0, e[s + 40 >> 2] = 0, e[s + 44 >> 2] = 0, of(24304, s), e[6079] = s, s = Qs(56), e[s + 4 >> 2] = 0, e[s + 8 >> 2] = 0, e[s >> 2] = 1, e[s + 12 >> 2] = 0, e[s + 16 >> 2] = 0, e[s + 20 >> 2] = 0, e[s + 24 >> 2] = 0, e[s + 28 >> 2] = 0, e[s + 32 >> 2] = 0, e[s + 36 >> 2] = 0, e[s + 40 >> 2] = 0, e[s + 44 >> 2] = 0, of(24304, s), r = Qs(4), e[r >> 2] = s, e[5996] = 0, s = Mi(3, 56) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1)
                          break i;
                        e[s + 16 >> 2] = 0, e[s + 20 >> 2] = 0, e[s + 4 >> 2] = r, e[s >> 2] = 21, r = r + 4 | 0, e[s + 12 >> 2] = r, e[s + 8 >> 2] = r, e[s + 24 >> 2] = 0, e[s + 28 >> 2] = 0, e[s + 32 >> 2] = 0, e[s + 36 >> 2] = 0, e[s + 40 >> 2] = 0, e[s + 44 >> 2] = 0, of(24304, s), e[6080] = s, Jr = A + 48 | 0;
                        break r;
                      }
                      s = Hr() | 0, Br(r), Jn(s | 0), Oi();
                    }
                    A = Jr - 48 | 0, Jr = A, e[A + 20 >> 2] = 0, e[A + 12 >> 2] = 0, e[A + 16 >> 2] = 0, e[5996] = 0, pi(9, 24592, A + 12 | 0) | 0, r = e[5996], e[5996] = 0;
                    r: {
                      i: {
                        n: {
                          s: {
                            a: {
                              o: {
                                l: {
                                  c: {
                                    if ((r | 0) != 1) {
                                      if (r = e[A + 12 >> 2], r && Br(r), r = Qs(32), e[A + 36 >> 2] = r, s = r + 32 | 0, e[A + 44 >> 2] = s, _[r + 24 | 0] = 0, _[r + 25 | 0] = 0, _[r + 26 | 0] = 0, _[r + 27 | 0] = 0, _[r + 28 | 0] = 0, _[r + 29 | 0] = 0, _[r + 30 | 0] = 0, _[r + 31 | 0] = 0, _[r + 16 | 0] = 0, _[r + 17 | 0] = 0, _[r + 18 | 0] = 0, _[r + 19 | 0] = 0, _[r + 20 | 0] = 0, _[r + 21 | 0] = 0, _[r + 22 | 0] = 0, _[r + 23 | 0] = 0, _[r + 8 | 0] = 0, _[r + 9 | 0] = 0, _[r + 10 | 0] = 0, _[r + 11 | 0] = 0, _[r + 12 | 0] = 0, _[r + 13 | 0] = 0, _[r + 14 | 0] = 0, _[r + 15 | 0] = 0, _[r | 0] = 0, _[r + 1 | 0] = 0, _[r + 2 | 0] = 0, _[r + 3 | 0] = 0, _[r + 4 | 0] = 0, _[r + 5 | 0] = 0, _[r + 6 | 0] = 0, _[r + 7 | 0] = 0, e[5996] = 0, e[A + 40 >> 2] = s, p = pi(9, A + 12 | 0, A + 36 | 0) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1)
                                        break n;
                                      if (_[p + 5 | 0] = 1, e[6156] = e[p + 8 >> 2], r = e[p + 4 >> 2], e[6154] = e[p >> 2], e[6155] = r, e[6157] = 0, e[6158] = 0, e[6159] = 0, u = e[p + 16 >> 2], s = e[p + 12 >> 2], r = u - s | 0, m = (r | 0) / 12 | 0, (s | 0) == (u | 0))
                                        break s;
                                      if (m >>> 0 < 357913942)
                                        break c;
                                      if (e[5996] = 0, Nn(11), r = e[5996], e[5996] = 0, (r | 0) == 1)
                                        break l;
                                      Oi();
                                    }
                                    if (m = Hr() | 0, r = e[A + 12 >> 2], !r)
                                      break e;
                                    Br(r);
                                    break e;
                                  }
                                  if (e[5996] = 0, r = Mi(3, r | 0) | 0, N = e[5996], e[5996] = 0, (N | 0) == 1)
                                    break l;
                                  if (e[6158] = r, e[6157] = r, e[6159] = r + Sn(m, 12), e[5996] = 0, s = wa(12, 24636, s | 0, u | 0, r | 0) | 0, u = e[5996], e[5996] = 0, (u | 0) != 1)
                                    break a;
                                  m = Hr() | 0, e[6158] = r;
                                  break o;
                                }
                                m = Hr() | 0;
                              }
                              if (u = e[6157], u) {
                                if (r = e[6158], s = u, (r | 0) != (s | 0)) {
                                  for (; s = r - 12 | 0, N = e[s >> 2], N && (e[r - 8 >> 2] = N, Br(N)), r = s, (u | 0) != (r | 0); )
                                    ;
                                  s = e[6157];
                                }
                                e[6158] = u, Br(s);
                              }
                              if (u = e[p + 12 >> 2], !u)
                                break t;
                              if (r = e[p + 16 >> 2], s = u, (r | 0) != (s | 0)) {
                                for (; s = r - 12 | 0, N = e[s >> 2], N && (e[r - 8 >> 2] = N, Br(N)), r = s, (u | 0) != (r | 0); )
                                  ;
                                s = e[p + 12 >> 2];
                              }
                              e[p + 16 >> 2] = u, Br(s);
                              break t;
                            }
                            e[6158] = s, u = e[p + 12 >> 2];
                          }
                          if (u) {
                            if (r = e[p + 16 >> 2], s = u, (r | 0) != (s | 0)) {
                              for (; s = r - 12 | 0, m = e[s >> 2], m && (e[r - 8 >> 2] = m, Br(m)), r = s, (u | 0) != (r | 0); )
                                ;
                              s = e[p + 12 >> 2];
                            }
                            e[p + 16 >> 2] = u, Br(s);
                          }
                          if (r = e[A + 36 >> 2], r && Br(r), r = Qs(1), e[A + 36 >> 2] = r, s = r + 1 | 0, e[A + 44 >> 2] = s, _[r | 0] = 1, e[5996] = 0, e[A + 40 >> 2] = s, pi(9, 24640, A + 36 | 0) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1)
                            break i;
                          r = e[A + 36 >> 2], r && Br(r), e[6168] = 0, e[6169] = 0, e[6166] = 1, e[6170] = 0, e[6171] = 0, _[24670] = 0, Zs[12334] = 0, e[6176] = 0, e[6177] = 0, e[6174] = -1, e[6175] = 0, _[24691] = 0, _[24692] = 0, _[24693] = 0, _[24694] = 0, e[6172] = 0, Jr = A + 48 | 0;
                          break r;
                        }
                        m = Hr() | 0;
                        break t;
                      }
                      m = Hr() | 0;
                      break t;
                    }
                    e[6178] = 24816;
                    return;
                  }
                  if (r = e[A + 36 >> 2], !r)
                    break e;
                  Br(r);
                }
                Jn(m | 0), Oi();
              }
              function $1(r, s) {
                r = r | 0, s = s | 0;
                var u = 0, A = 0, m = 0, p = 0, N = 0, W = 0, Te = 0, Xe = 0, fr = 0, ar = 0, vr = 0, _r = 0, hi = 0, mi = 0, Ni = 0, Hi = 0;
                N = Jr - 96 | 0, Jr = N, e[N + 36 >> 2] = 0, e[N + 28 >> 2] = 0, e[N + 32 >> 2] = 0, e[5996] = 0, fr = Mi(3, 12) | 0, u = e[5996], e[5996] = 0;
                e: {
                  if ((u | 0) != 1) {
                    Hi = N + 36 | 0, _[fr + 8 | 0] = 0, e[fr + 4 >> 2] = 0, e[fr >> 2] = s, p = fr + 12 | 0, Ni = p;
                    t: {
                      for (; ; ) {
                        Te = p - 12 | 0, u = Te, Xe = e[u + 4 >> 2], _r = e[u >> 2], A = e[_r + 32 >> 2];
                        r: {
                          i: {
                            n: {
                              if (W = e[_r + 36 >> 2] - A >> 3, W >>> 0 > Xe >>> 0) {
                                s = 1, e[u + 4 >> 2] = Xe + 1, m = me[p - 4 | 0];
                                s: {
                                  a: {
                                    o:
                                      switch (u = e[_r >> 2], u - 11 | 0) {
                                        case 0:
                                          break a;
                                        case 3:
                                          break s;
                                        default:
                                          break o;
                                      }
                                    if (s = 0, (Xe | 0) != 1 | (u | 0) != 17)
                                      break s;
                                  }
                                  s = (m | 0) != 0;
                                }
                                if (Xe = e[A + (Xe << 3) >> 2], p >>> 0 < Ni >>> 0) {
                                  _[p + 8 | 0] = s, e[p + 4 >> 2] = 0, e[p >> 2] = Xe, p = p + 12 | 0;
                                  break r;
                                }
                                s: {
                                  A = (p - fr | 0) / 12 | 0, Te = A + 1 | 0;
                                  a: {
                                    if (Te >>> 0 >= 357913942) {
                                      if (e[5996] = 0, Nn(121), r = e[5996], e[5996] = 0, (r | 0) == 1)
                                        break a;
                                      break e;
                                    }
                                    if (m = (Ni - fr | 0) / 12 | 0, u = m << 1, u = m >>> 0 >= 178956970 ? 357913941 : u >>> 0 > Te >>> 0 ? u : Te, u >>> 0 < 357913942)
                                      break s;
                                    if (e[5996] = 0, Nn(35), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                      break e;
                                  }
                                  ar = Hr() | 0;
                                  break t;
                                }
                                if (e[5996] = 0, Te = Sn(u, 12), W = Mi(3, Te | 0) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1)
                                  break n;
                                if (u = W + Sn(A, 12) | 0, _[u + 8 | 0] = s, e[u + 4 >> 2] = 0, e[u >> 2] = Xe, s = u, (p | 0) != (fr | 0))
                                  for (; p = p - 12 | 0, A = p, m = e[A + 4 >> 2], s = s - 12 | 0, e[s >> 2] = e[A >> 2], e[s + 4 >> 2] = m, e[s + 8 >> 2] = e[A + 8 >> 2], (A | 0) != (fr | 0); )
                                    ;
                                Ni = W + Te | 0, p = u + 12 | 0, fr && Br(fr), fr = s;
                                break r;
                              }
                              if (m = e[N + 28 >> 2], u = e[N + 32 >> 2] - m >> 5, u >>> 0 < W >>> 0) {
                                if (e[5996] = 0, Vs(44, 5135, 2210, 439, 2439), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                  break e;
                                ar = Hr() | 0;
                                break t;
                              }
                              if (s = me[p - 4 | 0], e[5996] = 0, uu(122, N + 40 | 0, s | 0, _r | 0, (m + (u << 5) | 0) - (W << 5) | 0, W | 0), s = e[5996], e[5996] = 0, (s | 0) == 1) {
                                ar = Hr() | 0;
                                break t;
                              }
                              s = e[N + 64 >> 2], e[N + 16 >> 2] = e[N + 60 >> 2], e[N + 20 >> 2] = s, e[N + 24 >> 2] = e[N + 68 >> 2], s = e[N + 56 >> 2], e[N + 8 >> 2] = e[N + 52 >> 2], e[N + 12 >> 2] = s, hi = e[N + 48 >> 2], vr = e[N + 44 >> 2], Xe = e[N + 40 >> 2], s = e[N + 32 >> 2], m = e[_r + 36 >> 2], u = e[_r + 32 >> 2];
                              s: {
                                if ((m | 0) == (u | 0)) {
                                  u = s;
                                  break s;
                                }
                                if (m = m - u << 2, u = s - m | 0, p = u + (m & -32) | 0, (p | 0) != (s | 0))
                                  for (; A = N - -64 | 0, e[A >> 2] = me[u + 28 | 0] | me[u + 29 | 0] << 8 | (me[u + 30 | 0] << 16 | me[u + 31 | 0] << 24), m = me[u + 24 | 0] | me[u + 25 | 0] << 8 | (me[u + 26 | 0] << 16 | me[u + 27 | 0] << 24), e[N + 56 >> 2] = me[u + 20 | 0] | me[u + 21 | 0] << 8 | (me[u + 22 | 0] << 16 | me[u + 23 | 0] << 24), e[N + 60 >> 2] = m, m = me[u + 16 | 0] | me[u + 17 | 0] << 8 | (me[u + 18 | 0] << 16 | me[u + 19 | 0] << 24), e[N + 48 >> 2] = me[u + 12 | 0] | me[u + 13 | 0] << 8 | (me[u + 14 | 0] << 16 | me[u + 15 | 0] << 24), e[N + 52 >> 2] = m, m = me[u + 8 | 0] | me[u + 9 | 0] << 8 | (me[u + 10 | 0] << 16 | me[u + 11 | 0] << 24), e[N + 40 >> 2] = me[u + 4 | 0] | me[u + 5 | 0] << 8 | (me[u + 6 | 0] << 16 | me[u + 7 | 0] << 24), e[N + 44 >> 2] = m, m = me[p + 28 | 0] | me[p + 29 | 0] << 8 | (me[p + 30 | 0] << 16 | me[p + 31 | 0] << 24), _[u + 28 | 0] = m, _[u + 29 | 0] = m >>> 8, _[u + 30 | 0] = m >>> 16, _[u + 31 | 0] = m >>> 24, W = me[p + 24 | 0] | me[p + 25 | 0] << 8 | (me[p + 26 | 0] << 16 | me[p + 27 | 0] << 24), m = me[p + 20 | 0] | me[p + 21 | 0] << 8 | (me[p + 22 | 0] << 16 | me[p + 23 | 0] << 24), _[u + 20 | 0] = m, _[u + 21 | 0] = m >>> 8, _[u + 22 | 0] = m >>> 16, _[u + 23 | 0] = m >>> 24, _[u + 24 | 0] = W, _[u + 25 | 0] = W >>> 8, _[u + 26 | 0] = W >>> 16, _[u + 27 | 0] = W >>> 24, W = me[p + 16 | 0] | me[p + 17 | 0] << 8 | (me[p + 18 | 0] << 16 | me[p + 19 | 0] << 24), m = me[p + 12 | 0] | me[p + 13 | 0] << 8 | (me[p + 14 | 0] << 16 | me[p + 15 | 0] << 24), _[u + 12 | 0] = m, _[u + 13 | 0] = m >>> 8, _[u + 14 | 0] = m >>> 16, _[u + 15 | 0] = m >>> 24, _[u + 16 | 0] = W, _[u + 17 | 0] = W >>> 8, _[u + 18 | 0] = W >>> 16, _[u + 19 | 0] = W >>> 24, W = me[p + 8 | 0] | me[p + 9 | 0] << 8 | (me[p + 10 | 0] << 16 | me[p + 11 | 0] << 24), m = me[p + 4 | 0] | me[p + 5 | 0] << 8 | (me[p + 6 | 0] << 16 | me[p + 7 | 0] << 24), _[u + 4 | 0] = m, _[u + 5 | 0] = m >>> 8, _[u + 6 | 0] = m >>> 16, _[u + 7 | 0] = m >>> 24, _[u + 8 | 0] = W, _[u + 9 | 0] = W >>> 8, _[u + 10 | 0] = W >>> 16, _[u + 11 | 0] = W >>> 24, m = e[A >> 2], _[p + 28 | 0] = m, _[p + 29 | 0] = m >>> 8, _[p + 30 | 0] = m >>> 16, _[p + 31 | 0] = m >>> 24, A = e[N + 60 >> 2], m = e[N + 56 >> 2], _[p + 20 | 0] = m, _[p + 21 | 0] = m >>> 8, _[p + 22 | 0] = m >>> 16, _[p + 23 | 0] = m >>> 24, _[p + 24 | 0] = A, _[p + 25 | 0] = A >>> 8, _[p + 26 | 0] = A >>> 16, _[p + 27 | 0] = A >>> 24, A = e[N + 52 >> 2], m = e[N + 48 >> 2], _[p + 12 | 0] = m, _[p + 13 | 0] = m >>> 8, _[p + 14 | 0] = m >>> 16, _[p + 15 | 0] = m >>> 24, _[p + 16 | 0] = A, _[p + 17 | 0] = A >>> 8, _[p + 18 | 0] = A >>> 16, _[p + 19 | 0] = A >>> 24, A = e[N + 44 >> 2], m = e[N + 40 >> 2], _[p + 4 | 0] = m, _[p + 5 | 0] = m >>> 8, _[p + 6 | 0] = m >>> 16, _[p + 7 | 0] = m >>> 24, _[p + 8 | 0] = A, _[p + 9 | 0] = A >>> 8, _[p + 10 | 0] = A >>> 16, _[p + 11 | 0] = A >>> 24, m = e[u >> 2], e[u >> 2] = e[p >> 2], e[p >> 2] = m, u = u + 32 | 0, p = p + 32 | 0, (p | 0) != (s | 0); )
                                    ;
                                if ((s | 0) != (u | 0))
                                  for (; m = s - 32 | 0, (me[m | 0] | me[m + 1 | 0] << 8 | (me[m + 2 | 0] << 16 | me[m + 3 | 0] << 24)) >>> 0 >= 29 && (s = s - 24 | 0, Br(me[s | 0] | me[s + 1 | 0] << 8 | (me[s + 2 | 0] << 16 | me[s + 3 | 0] << 24)), _[s | 0] = 0, _[s + 1 | 0] = 0, _[s + 2 | 0] = 0, _[s + 3 | 0] = 0), s = m, (u | 0) != (s | 0); )
                                    ;
                                e[N + 32 >> 2] = u;
                              }
                              if (p = e[N + 36 >> 2], p >>> 0 > u >>> 0) {
                                _[u + 4 | 0] = 0, _[u + 5 | 0] = 0, _[u + 6 | 0] = 0, _[u + 7 | 0] = 0, _[u + 8 | 0] = 0, _[u + 9 | 0] = 0, _[u + 10 | 0] = 0, _[u + 11 | 0] = 0, _[u + 28 | 0] = 0, _[u + 29 | 0] = 0, _[u + 30 | 0] = 0, _[u + 31 | 0] = 0, _[u + 20 | 0] = 0, _[u + 21 | 0] = 0, _[u + 22 | 0] = 0, _[u + 23 | 0] = 0, _[u + 24 | 0] = 0, _[u + 25 | 0] = 0, _[u + 26 | 0] = 0, _[u + 27 | 0] = 0, _[u + 12 | 0] = 0, _[u + 13 | 0] = 0, _[u + 14 | 0] = 0, _[u + 15 | 0] = 0, _[u + 16 | 0] = 0, _[u + 17 | 0] = 0, _[u + 18 | 0] = 0, _[u + 19 | 0] = 0, _[u + 8 | 0] = hi, _[u + 9 | 0] = hi >>> 8, _[u + 10 | 0] = hi >>> 16, _[u + 11 | 0] = hi >>> 24, _[u + 4 | 0] = vr, _[u + 5 | 0] = vr >>> 8, _[u + 6 | 0] = vr >>> 16, _[u + 7 | 0] = vr >>> 24, m = e[N + 12 >> 2], s = e[N + 8 >> 2], _[u + 12 | 0] = s, _[u + 13 | 0] = s >>> 8, _[u + 14 | 0] = s >>> 16, _[u + 15 | 0] = s >>> 24, _[u + 16 | 0] = m, _[u + 17 | 0] = m >>> 8, _[u + 18 | 0] = m >>> 16, _[u + 19 | 0] = m >>> 24, m = e[N + 20 >> 2], s = e[N + 16 >> 2], _[u + 20 | 0] = s, _[u + 21 | 0] = s >>> 8, _[u + 22 | 0] = s >>> 16, _[u + 23 | 0] = s >>> 24, _[u + 24 | 0] = m, _[u + 25 | 0] = m >>> 8, _[u + 26 | 0] = m >>> 16, _[u + 27 | 0] = m >>> 24, s = e[N + 24 >> 2], _[u + 28 | 0] = s, _[u + 29 | 0] = s >>> 8, _[u + 30 | 0] = s >>> 16, _[u + 31 | 0] = s >>> 24, e[u >> 2] = Xe, e[N + 32 >> 2] = u + 32;
                                break i;
                              }
                              s: {
                                a: {
                                  o: {
                                    mi = e[N + 28 >> 2], A = u - mi >> 5, W = A + 1 | 0;
                                    l: {
                                      if (W >>> 0 >= 134217728) {
                                        e[5996] = 0, Nn(123);
                                        break l;
                                      }
                                      if (e[N + 92 >> 2] = Hi, m = p - mi | 0, s = m >> 4, W = m >>> 0 >= 2147483616 ? 134217727 : s >>> 0 > W >>> 0 ? s : W, !W) {
                                        s = 0;
                                        break a;
                                      }
                                      if (W >>> 0 < 134217728)
                                        break o;
                                      e[5996] = 0, Nn(35);
                                    }
                                    if (r = e[5996], e[5996] = 0, (r | 0) != 1)
                                      break e;
                                    break s;
                                  }
                                  if (e[5996] = 0, s = Mi(3, W << 5) | 0, m = e[5996], e[5996] = 0, (m | 0) == 1)
                                    break s;
                                }
                                e[N + 76 >> 2] = s, ar = (W << 5) + s | 0, e[N + 88 >> 2] = ar, W = (A << 5) + s | 0, e[N + 80 >> 2] = W, A = W, _[A + 24 | 0] = 0, _[A + 25 | 0] = 0, _[A + 26 | 0] = 0, _[A + 27 | 0] = 0, _[A + 28 | 0] = 0, _[A + 29 | 0] = 0, _[A + 30 | 0] = 0, _[A + 31 | 0] = 0, _[A + 16 | 0] = 0, _[A + 17 | 0] = 0, _[A + 18 | 0] = 0, _[A + 19 | 0] = 0, _[A + 20 | 0] = 0, _[A + 21 | 0] = 0, _[A + 22 | 0] = 0, _[A + 23 | 0] = 0, _[A + 8 | 0] = 0, _[A + 9 | 0] = 0, _[A + 10 | 0] = 0, _[A + 11 | 0] = 0, _[A + 12 | 0] = 0, _[A + 13 | 0] = 0, _[A + 14 | 0] = 0, _[A + 15 | 0] = 0, _[A | 0] = 0, _[A + 1 | 0] = 0, _[A + 2 | 0] = 0, _[A + 3 | 0] = 0, _[A + 4 | 0] = 0, _[A + 5 | 0] = 0, _[A + 6 | 0] = 0, _[A + 7 | 0] = 0, e[N + 56 >> 2] = me[A + 28 | 0] | me[A + 29 | 0] << 8 | (me[A + 30 | 0] << 16 | me[A + 31 | 0] << 24), s = me[A + 24 | 0] | me[A + 25 | 0] << 8 | (me[A + 26 | 0] << 16 | me[A + 27 | 0] << 24), e[N + 48 >> 2] = me[A + 20 | 0] | me[A + 21 | 0] << 8 | (me[A + 22 | 0] << 16 | me[A + 23 | 0] << 24), e[N + 52 >> 2] = s, s = me[A + 16 | 0] | me[A + 17 | 0] << 8 | (me[A + 18 | 0] << 16 | me[A + 19 | 0] << 24), e[N + 40 >> 2] = me[A + 12 | 0] | me[A + 13 | 0] << 8 | (me[A + 14 | 0] << 16 | me[A + 15 | 0] << 24), e[N + 44 >> 2] = s, _[A + 8 | 0] = hi, _[A + 9 | 0] = hi >>> 8, _[A + 10 | 0] = hi >>> 16, _[A + 11 | 0] = hi >>> 24, _[A + 4 | 0] = vr, _[A + 5 | 0] = vr >>> 8, _[A + 6 | 0] = vr >>> 16, _[A + 7 | 0] = vr >>> 24, s = e[N + 24 >> 2], _[A + 28 | 0] = s, _[A + 29 | 0] = s >>> 8, _[A + 30 | 0] = s >>> 16, _[A + 31 | 0] = s >>> 24, m = e[N + 20 >> 2], s = e[N + 16 >> 2], _[A + 20 | 0] = s, _[A + 21 | 0] = s >>> 8, _[A + 22 | 0] = s >>> 16, _[A + 23 | 0] = s >>> 24, _[A + 24 | 0] = m, _[A + 25 | 0] = m >>> 8, _[A + 26 | 0] = m >>> 16, _[A + 27 | 0] = m >>> 24, m = e[N + 12 >> 2], s = e[N + 8 >> 2], _[A + 12 | 0] = s, _[A + 13 | 0] = s >>> 8, _[A + 14 | 0] = s >>> 16, _[A + 15 | 0] = s >>> 24, _[A + 16 | 0] = m, _[A + 17 | 0] = m >>> 8, _[A + 18 | 0] = m >>> 16, _[A + 19 | 0] = m >>> 24, s = e[N + 52 >> 2], e[N + 16 >> 2] = e[N + 48 >> 2], e[N + 20 >> 2] = s, e[N + 24 >> 2] = e[N + 56 >> 2], s = e[N + 44 >> 2], e[N + 8 >> 2] = e[N + 40 >> 2], e[N + 12 >> 2] = s, e[A >> 2] = Xe, s = A + 32 | 0, e[N + 84 >> 2] = s;
                                a: {
                                  if ((u | 0) == (mi | 0))
                                    m = u;
                                  else {
                                    for (; ; ) {
                                      if (s = A, A = A - 32 | 0, _[A | 0] = 0, _[A + 1 | 0] = 0, _[A + 2 | 0] = 0, _[A + 3 | 0] = 0, _[A + 4 | 0] = 0, _[A + 5 | 0] = 0, _[A + 6 | 0] = 0, _[A + 7 | 0] = 0, _[A + 24 | 0] = 0, _[A + 25 | 0] = 0, _[A + 26 | 0] = 0, _[A + 27 | 0] = 0, _[A + 28 | 0] = 0, _[A + 29 | 0] = 0, _[A + 30 | 0] = 0, _[A + 31 | 0] = 0, _[A + 16 | 0] = 0, _[A + 17 | 0] = 0, _[A + 18 | 0] = 0, _[A + 19 | 0] = 0, _[A + 20 | 0] = 0, _[A + 21 | 0] = 0, _[A + 22 | 0] = 0, _[A + 23 | 0] = 0, _[A + 8 | 0] = 0, _[A + 9 | 0] = 0, _[A + 10 | 0] = 0, _[A + 11 | 0] = 0, _[A + 12 | 0] = 0, _[A + 13 | 0] = 0, _[A + 14 | 0] = 0, _[A + 15 | 0] = 0, m = u, u = u - 32 | 0, p = me[u | 0] | me[u + 1 | 0] << 8 | (me[u + 2 | 0] << 16 | me[u + 3 | 0] << 24), e[5996] = 0, Xe = p >>> 0 < 29 ? p : p - 29 | 0, ji(124, A | 0, Xe | 0), p = e[5996], e[5996] = 0, (p | 0) == 1)
                                        break a;
                                      vr = Xe + (me[A | 0] | me[A + 1 | 0] << 8 | (me[A + 2 | 0] << 16 | me[A + 3 | 0] << 24)) | 0, _[A | 0] = vr, _[A + 1 | 0] = vr >>> 8, _[A + 2 | 0] = vr >>> 16, _[A + 3 | 0] = vr >>> 24, p = me[u | 0] | me[u + 1 | 0] << 8 | (me[u + 2 | 0] << 16 | me[u + 3 | 0] << 24), Xe = p >>> 0 < 29, _r = Xe ? p : p - 29 | 0;
                                      o: {
                                        if (!_r)
                                          break o;
                                        if (p = s - 28 | 0, s = s - 24 | 0, p = vr >>> 0 < 29 ? p : me[s | 0] | me[s + 1 | 0] << 8 | (me[s + 2 | 0] << 16 | me[s + 3 | 0] << 24), ar = 0, s = m - 24 | 0, Xe = Xe ? m - 28 | 0 : me[s | 0] | me[s + 1 | 0] << 8 | (me[s + 2 | 0] << 16 | me[s + 3 | 0] << 24), s = Xe, m = _r & 7, m)
                                          for (; _[p | 0] = me[s | 0], s = s + 1 | 0, p = p + 1 | 0, ar = ar + 1 | 0, (m | 0) != (ar | 0); )
                                            ;
                                        if (_r >>> 0 < 8)
                                          break o;
                                        for (m = Xe + _r | 0; _[p | 0] = me[s | 0], _[p + 1 | 0] = me[s + 1 | 0], _[p + 2 | 0] = me[s + 2 | 0], _[p + 3 | 0] = me[s + 3 | 0], _[p + 4 | 0] = me[s + 4 | 0], _[p + 5 | 0] = me[s + 5 | 0], _[p + 6 | 0] = me[s + 6 | 0], _[p + 7 | 0] = me[s + 7 | 0], p = p + 8 | 0, s = s + 8 | 0, (m | 0) != (s | 0); )
                                          ;
                                      }
                                      if ((u | 0) == (mi | 0))
                                        break;
                                    }
                                    ar = e[N + 88 >> 2], p = e[N + 36 >> 2], s = e[N + 84 >> 2], u = e[N + 32 >> 2], m = e[N + 28 >> 2];
                                  }
                                  if (e[N + 80 >> 2] = m, e[N + 28 >> 2] = A, e[N + 32 >> 2] = s, e[N + 36 >> 2] = ar, e[N + 88 >> 2] = p, e[N + 76 >> 2] = m, e[N + 84 >> 2] = u, (u | 0) != (m | 0)) {
                                    for (; s = u - 32 | 0, e[N + 84 >> 2] = s, (me[s | 0] | me[s + 1 | 0] << 8 | (me[s + 2 | 0] << 16 | me[s + 3 | 0] << 24)) >>> 0 >= 29 && (s = u - 24 | 0, Br(me[s | 0] | me[s + 1 | 0] << 8 | (me[s + 2 | 0] << 16 | me[s + 3 | 0] << 24)), _[s | 0] = 0, _[s + 1 | 0] = 0, _[s + 2 | 0] = 0, _[s + 3 | 0] = 0, s = e[N + 84 >> 2]), u = s, (m | 0) != (u | 0); )
                                      ;
                                    u = e[N + 76 >> 2];
                                  }
                                  if (!u)
                                    break i;
                                  Br(u), p = Te;
                                  break r;
                                }
                                if (ar = Hr() | 0, (s | 0) != (W | 0))
                                  for (; (me[s | 0] | me[s + 1 | 0] << 8 | (me[s + 2 | 0] << 16 | me[s + 3 | 0] << 24)) >>> 0 >= 29 && (Br(me[s + 8 | 0] | me[s + 9 | 0] << 8 | (me[s + 10 | 0] << 16 | me[s + 11 | 0] << 24)), _[s + 8 | 0] = 0, _[s + 9 | 0] = 0, _[s + 10 | 0] = 0, _[s + 11 | 0] = 0), s = s + 32 | 0, (W | 0) != (s | 0); )
                                    ;
                                if (s = e[N + 84 >> 2], u = e[N + 80 >> 2], (s | 0) != (u | 0))
                                  for (; r = s - 32 | 0, e[N + 84 >> 2] = r, (me[r | 0] | me[r + 1 | 0] << 8 | (me[r + 2 | 0] << 16 | me[r + 3 | 0] << 24)) >>> 0 >= 29 && (r = s - 24 | 0, Br(me[r | 0] | me[r + 1 | 0] << 8 | (me[r + 2 | 0] << 16 | me[r + 3 | 0] << 24)), _[r | 0] = 0, _[r + 1 | 0] = 0, _[r + 2 | 0] = 0, _[r + 3 | 0] = 0, r = e[N + 84 >> 2]), s = r, (u | 0) != (s | 0); )
                                    ;
                                r = e[N + 76 >> 2], r && Br(r);
                                break t;
                              }
                              if (ar = Hr() | 0, Xe >>> 0 < 29)
                                break t;
                              Br(hi);
                              break t;
                            }
                            ar = Hr() | 0;
                            break t;
                          }
                          p = Te;
                        }
                        if ((p | 0) == (fr | 0))
                          break;
                      }
                      if (s = e[N + 32 >> 2], u = e[N + 28 >> 2], (s - u | 0) != 32) {
                        if (e[5996] = 0, Vs(44, 4102, 2210, 450, 2439), r = e[5996], e[5996] = 0, (r | 0) != 1)
                          break e;
                        ar = Hr() | 0;
                        break t;
                      }
                      if (_[r | 0] = 0, _[r + 1 | 0] = 0, _[r + 2 | 0] = 0, _[r + 3 | 0] = 0, _[r + 4 | 0] = 0, _[r + 5 | 0] = 0, _[r + 6 | 0] = 0, _[r + 7 | 0] = 0, _[r + 24 | 0] = 0, _[r + 25 | 0] = 0, _[r + 26 | 0] = 0, _[r + 27 | 0] = 0, _[r + 28 | 0] = 0, _[r + 29 | 0] = 0, _[r + 30 | 0] = 0, _[r + 31 | 0] = 0, _[r + 16 | 0] = 0, _[r + 17 | 0] = 0, _[r + 18 | 0] = 0, _[r + 19 | 0] = 0, _[r + 20 | 0] = 0, _[r + 21 | 0] = 0, _[r + 22 | 0] = 0, _[r + 23 | 0] = 0, _[r + 8 | 0] = 0, _[r + 9 | 0] = 0, _[r + 10 | 0] = 0, _[r + 11 | 0] = 0, _[r + 12 | 0] = 0, _[r + 13 | 0] = 0, _[r + 14 | 0] = 0, _[r + 15 | 0] = 0, Te = N - -64 | 0, e[Te >> 2] = me[r + 28 | 0] | me[r + 29 | 0] << 8 | (me[r + 30 | 0] << 16 | me[r + 31 | 0] << 24), m = me[r + 24 | 0] | me[r + 25 | 0] << 8 | (me[r + 26 | 0] << 16 | me[r + 27 | 0] << 24), e[N + 56 >> 2] = me[r + 20 | 0] | me[r + 21 | 0] << 8 | (me[r + 22 | 0] << 16 | me[r + 23 | 0] << 24), e[N + 60 >> 2] = m, m = me[r + 16 | 0] | me[r + 17 | 0] << 8 | (me[r + 18 | 0] << 16 | me[r + 19 | 0] << 24), e[N + 48 >> 2] = me[r + 12 | 0] | me[r + 13 | 0] << 8 | (me[r + 14 | 0] << 16 | me[r + 15 | 0] << 24), e[N + 52 >> 2] = m, m = me[r + 8 | 0] | me[r + 9 | 0] << 8 | (me[r + 10 | 0] << 16 | me[r + 11 | 0] << 24), e[N + 40 >> 2] = me[r + 4 | 0] | me[r + 5 | 0] << 8 | (me[r + 6 | 0] << 16 | me[r + 7 | 0] << 24), e[N + 44 >> 2] = m, m = me[u + 28 | 0] | me[u + 29 | 0] << 8 | (me[u + 30 | 0] << 16 | me[u + 31 | 0] << 24), _[r + 28 | 0] = m, _[r + 29 | 0] = m >>> 8, _[r + 30 | 0] = m >>> 16, _[r + 31 | 0] = m >>> 24, A = me[u + 24 | 0] | me[u + 25 | 0] << 8 | (me[u + 26 | 0] << 16 | me[u + 27 | 0] << 24), m = me[u + 20 | 0] | me[u + 21 | 0] << 8 | (me[u + 22 | 0] << 16 | me[u + 23 | 0] << 24), _[r + 20 | 0] = m, _[r + 21 | 0] = m >>> 8, _[r + 22 | 0] = m >>> 16, _[r + 23 | 0] = m >>> 24, _[r + 24 | 0] = A, _[r + 25 | 0] = A >>> 8, _[r + 26 | 0] = A >>> 16, _[r + 27 | 0] = A >>> 24, A = me[u + 16 | 0] | me[u + 17 | 0] << 8 | (me[u + 18 | 0] << 16 | me[u + 19 | 0] << 24), m = me[u + 12 | 0] | me[u + 13 | 0] << 8 | (me[u + 14 | 0] << 16 | me[u + 15 | 0] << 24), _[r + 12 | 0] = m, _[r + 13 | 0] = m >>> 8, _[r + 14 | 0] = m >>> 16, _[r + 15 | 0] = m >>> 24, _[r + 16 | 0] = A, _[r + 17 | 0] = A >>> 8, _[r + 18 | 0] = A >>> 16, _[r + 19 | 0] = A >>> 24, A = me[u + 8 | 0] | me[u + 9 | 0] << 8 | (me[u + 10 | 0] << 16 | me[u + 11 | 0] << 24), m = me[u + 4 | 0] | me[u + 5 | 0] << 8 | (me[u + 6 | 0] << 16 | me[u + 7 | 0] << 24), _[r + 4 | 0] = m, _[r + 5 | 0] = m >>> 8, _[r + 6 | 0] = m >>> 16, _[r + 7 | 0] = m >>> 24, _[r + 8 | 0] = A, _[r + 9 | 0] = A >>> 8, _[r + 10 | 0] = A >>> 16, _[r + 11 | 0] = A >>> 24, m = e[Te >> 2], _[u + 28 | 0] = m, _[u + 29 | 0] = m >>> 8, _[u + 30 | 0] = m >>> 16, _[u + 31 | 0] = m >>> 24, Te = e[N + 60 >> 2], m = e[N + 56 >> 2], _[u + 20 | 0] = m, _[u + 21 | 0] = m >>> 8, _[u + 22 | 0] = m >>> 16, _[u + 23 | 0] = m >>> 24, _[u + 24 | 0] = Te, _[u + 25 | 0] = Te >>> 8, _[u + 26 | 0] = Te >>> 16, _[u + 27 | 0] = Te >>> 24, Te = e[N + 52 >> 2], m = e[N + 48 >> 2], _[u + 12 | 0] = m, _[u + 13 | 0] = m >>> 8, _[u + 14 | 0] = m >>> 16, _[u + 15 | 0] = m >>> 24, _[u + 16 | 0] = Te, _[u + 17 | 0] = Te >>> 8, _[u + 18 | 0] = Te >>> 16, _[u + 19 | 0] = Te >>> 24, Te = e[N + 44 >> 2], m = e[N + 40 >> 2], _[u + 4 | 0] = m, _[u + 5 | 0] = m >>> 8, _[u + 6 | 0] = m >>> 16, _[u + 7 | 0] = m >>> 24, _[u + 8 | 0] = Te, _[u + 9 | 0] = Te >>> 8, _[u + 10 | 0] = Te >>> 16, _[u + 11 | 0] = Te >>> 24, e[r >> 2] = e[u >> 2], e[u >> 2] = 0, _[r + 32 | 0] = 1, (s | 0) != (u | 0)) {
                        for (; r = s - 32 | 0, (me[r | 0] | me[r + 1 | 0] << 8 | (me[r + 2 | 0] << 16 | me[r + 3 | 0] << 24)) >>> 0 >= 29 && (s = s - 24 | 0, Br(me[s | 0] | me[s + 1 | 0] << 8 | (me[s + 2 | 0] << 16 | me[s + 3 | 0] << 24)), _[s | 0] = 0, _[s + 1 | 0] = 0, _[s + 2 | 0] = 0, _[s + 3 | 0] = 0), s = r, (u | 0) != (s | 0); )
                          ;
                        s = e[N + 28 >> 2];
                      }
                      e[N + 32 >> 2] = u, Br(s), fr && Br(fr), Jr = N + 96 | 0;
                      return;
                    }
                    Ja(N + 28 | 0), fr && Br(fr), Jn(ar | 0), Oi();
                  }
                  r = Hr() | 0, Ja(N + 28 | 0), Jn(r | 0), Oi();
                }
                Oi();
              }
              function eg(r, s, u) {
                r = r | 0, s = s | 0, u = u | 0;
                var A = 0, m = 0, p = 0, N = 0, W = 0, Te = 0, Xe = 0, fr = 0, ar = 0, vr = 0, _r = 0, hi = 0, mi = 0, Ni = 0, Hi = 0, Ji = 0, Ln = 0, _n = 0, hs = 0, bs = 0, Us = 0, go = 0, _o = 0, ra = 0, fa = 0, ha = 0;
                N = Jr - 48 | 0, Jr = N, e[N + 32 >> 2] = 0, e[N + 24 >> 2] = 0, e[N + 28 >> 2] = 0, e[5996] = 0, hi = Mi(3, 12) | 0, A = e[5996], e[5996] = 0;
                e: {
                  if ((A | 0) != 1) {
                    e[hi + 4 >> 2] = 0, e[hi >> 2] = s, Hi = N + 40 | 0, Us = N + 12 | 0, go = hi + 12 | 0, p = go;
                    t: {
                      r: {
                        i: {
                          for (; ; ) {
                            n: {
                              ha = p - 12 | 0, s = ha, A = e[s + 4 >> 2];
                              s: {
                                a: {
                                  o: {
                                    l: {
                                      c: {
                                        if (Ji = e[s >> 2], _r = e[Ji + 36 >> 2], _o = e[Ji + 32 >> 2], ra = _r - _o >> 3, A >>> 0 < ra >>> 0) {
                                          if (e[s + 4 >> 2] = A + 1, Te = e[(A << 3) + _o >> 2], p >>> 0 < go >>> 0) {
                                            e[p + 4 >> 2] = 0, e[p >> 2] = Te, p = p + 12 | 0;
                                            break s;
                                          }
                                          d: {
                                            m = (p - hi | 0) / 12 | 0, W = m + 1 | 0;
                                            f: {
                                              if (W >>> 0 >= 357913942) {
                                                if (e[5996] = 0, Nn(95), r = e[5996], e[5996] = 0, (r | 0) == 1)
                                                  break f;
                                                break e;
                                              }
                                              if (A = (go - hi | 0) / 12 | 0, s = A << 1, s = A >>> 0 >= 178956970 ? 357913941 : s >>> 0 > W >>> 0 ? s : W, s >>> 0 < 357913942)
                                                break d;
                                              if (e[5996] = 0, Nn(35), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                break e;
                                            }
                                            s = Hr() | 0;
                                            break t;
                                          }
                                          if (e[5996] = 0, W = Sn(s, 12), Xe = Mi(3, W | 0) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1)
                                            break c;
                                          if (A = Xe + Sn(m, 12) | 0, e[A + 4 >> 2] = 0, e[A >> 2] = Te, s = A, (p | 0) != (hi | 0))
                                            for (; p = p - 12 | 0, m = e[p + 4 >> 2], s = s - 12 | 0, e[s >> 2] = e[p >> 2], e[s + 4 >> 2] = m, e[s + 8 >> 2] = e[p + 8 >> 2], (p | 0) != (hi | 0); )
                                              ;
                                          go = W + Xe | 0, p = A + 12 | 0, hi && Br(hi), hi = s;
                                          break s;
                                        }
                                        if (fr = e[N + 24 >> 2], Xe = (e[N + 28 >> 2] - fr | 0) / 12 | 0, Xe >>> 0 < ra >>> 0) {
                                          if (e[5996] = 0, Vs(44, 5135, 2210, 439, 2439), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                            break e;
                                          s = Hr() | 0;
                                          break t;
                                        }
                                        if (me[Ji + 88 | 0] && e[u >> 2] != (Ji | 0))
                                          break o;
                                        if (fa = e[Ji + 12 >> 2], ar = e[Ji + 8 >> 2], e[N + 36 >> 2] = Hi, e[N + 40 >> 2] = 0, e[N + 44 >> 2] = 0, hs = (fa - ar | 0) / 12 | 0, vr = 0, s = Hi, m = 0, (ar | 0) == (fa | 0))
                                          break l;
                                        for (; ; ) {
                                          d: {
                                            f: {
                                              u: {
                                                g: {
                                                  p = Hi;
                                                  A: {
                                                    if ((p | 0) == (s | 0))
                                                      break A;
                                                    A = p, s = m;
                                                    p: {
                                                      if (m) {
                                                        for (; ; )
                                                          if (p = s, s = e[s + 4 >> 2], !s)
                                                            break p;
                                                      }
                                                      for (; p = e[A + 8 >> 2], s = e[p >> 2] == (A | 0), A = p, !!s; )
                                                        ;
                                                    }
                                                    bs = e[ar >> 2], mi = me[ar + 11 | 0], W = mi << 24 >> 24, Ln = (W | 0) < 0, s = me[p + 27 | 0], _n = s << 24 >> 24 < 0;
                                                    p: {
                                                      if (A = e[ar + 4 >> 2], Ni = Ln ? A : mi, Te = _n ? e[p + 20 >> 2] : s, s = Te >>> 0 > Ni >>> 0 ? Ni : Te, s && (s = va(_n ? e[p + 16 >> 2] : p + 16 | 0, Ln ? bs : ar, s), s))
                                                        break p;
                                                      if (Te >>> 0 < Ni >>> 0)
                                                        break A;
                                                      break g;
                                                    }
                                                    if ((s | 0) >= 0)
                                                      break g;
                                                  }
                                                  s = m ? p : Hi, Te = m ? p + 4 | 0 : Hi;
                                                  break u;
                                                }
                                                if (s = Hi, Te = s, !m)
                                                  break u;
                                                for (s = (W | 0) >= 0, Ln = s ? ar : bs, bs = s ? mi : A, A = m; ; ) {
                                                  s = A, p = me[A + 27 | 0], _n = p << 24 >> 24 < 0, mi = _n ? e[A + 20 >> 2] : p, Ni = mi >>> 0 < bs >>> 0;
                                                  g: {
                                                    A: {
                                                      p: {
                                                        m: {
                                                          W = Ni ? mi : bs;
                                                          k: {
                                                            if (W) {
                                                              if (p = _n ? e[A + 16 >> 2] : A + 16 | 0, A = va(Ln, p, W), !A) {
                                                                if (mi >>> 0 > bs >>> 0)
                                                                  break k;
                                                                break m;
                                                              }
                                                              if ((A | 0) >= 0)
                                                                break m;
                                                              break k;
                                                            }
                                                            if (mi >>> 0 <= bs >>> 0)
                                                              break p;
                                                          }
                                                          if (Te = s, A = e[s >> 2], A)
                                                            continue;
                                                          break f;
                                                        }
                                                        if (A = va(p, Ln, W), A)
                                                          break A;
                                                      }
                                                      if (!Ni)
                                                        break u;
                                                      break g;
                                                    }
                                                    if ((A | 0) >= 0)
                                                      break u;
                                                  }
                                                  if (Te = s + 4 | 0, A = e[s + 4 >> 2], !A)
                                                    break;
                                                }
                                                break f;
                                              }
                                              if (e[Te >> 2])
                                                break d;
                                            }
                                            e[5996] = 0, p = Mi(3, 28) | 0, A = e[5996], e[5996] = 0;
                                            f: {
                                              if ((A | 0) != 1) {
                                                if (W = p + 16 | 0, _[ar + 11 | 0] >= 0) {
                                                  A = e[ar + 4 >> 2], e[W >> 2] = e[ar >> 2], e[W + 4 >> 2] = A, e[W + 8 >> 2] = e[ar + 8 >> 2];
                                                  break f;
                                                }
                                                if (m = e[ar + 4 >> 2], A = e[ar >> 2], e[5996] = 0, gs(40, W | 0, A | 0, m | 0), A = e[5996], e[5996] = 0, (A | 0) != 1)
                                                  break f;
                                                s = Hr() | 0, Br(p), ft(e[N + 40 >> 2]);
                                                break t;
                                              }
                                              s = Hr() | 0, ft(m);
                                              break t;
                                            }
                                            e[p + 8 >> 2] = s, e[p >> 2] = 0, e[p + 4 >> 2] = 0, e[Te >> 2] = p, s = e[e[N + 36 >> 2] >> 2], s && (e[N + 36 >> 2] = s, p = e[Te >> 2]), Ff(e[N + 40 >> 2], p), vr = e[N + 44 >> 2] + 1 | 0, e[N + 44 >> 2] = vr;
                                          }
                                          if (ar = ar + 12 | 0, (fa | 0) == (ar | 0))
                                            break l;
                                          s = e[N + 36 >> 2], m = e[N + 40 >> 2];
                                        }
                                      }
                                      s = Hr() | 0;
                                      break t;
                                    }
                                    l: {
                                      c: {
                                        if ((vr | 0) != (hs | 0))
                                          break c;
                                        if ((_r | 0) != (_o | 0))
                                          for (Ln = fr + Sn(Xe, 12) | 0, vr = Ln + Sn(ra, -12) | 0; ; ) {
                                            if (A = e[vr + 8 >> 2], A >>> 0 > hs >>> 0 && (s = e[N + 36 >> 2], e[N + 36 >> 2] = e[vr >> 2], e[vr >> 2] = s, s = e[N + 40 >> 2], e[N + 40 >> 2] = e[vr + 4 >> 2], e[vr + 4 >> 2] = s, s = e[N + 44 >> 2], e[N + 44 >> 2] = A, e[vr + 8 >> 2] = s, e[(e[N + 44 >> 2] ? e[N + 40 >> 2] + 8 | 0 : N + 36 | 0) >> 2] = Hi, e[(s ? e[vr + 4 >> 2] + 8 | 0 : vr) >> 2] = vr + 4), hs = A + hs | 0, Xe = e[vr >> 2], _n = vr + 4 | 0, (Xe | 0) != (_n | 0))
                                              for (; ; ) {
                                                W = 0, A = e[N + 40 >> 2];
                                                d: {
                                                  if (!A) {
                                                    p = Hi, ar = p;
                                                    break d;
                                                  }
                                                  for (m = me[Xe + 27 | 0], s = m << 24 >> 24 >= 0, _r = s ? Xe + 16 | 0 : e[Xe + 16 >> 2], mi = s ? m : e[Xe + 20 >> 2], ar = Hi; ; ) {
                                                    p = A, s = me[A + 27 | 0], fr = s << 24 >> 24 < 0, Ni = fr ? e[A + 20 >> 2] : s, Te = Ni >>> 0 < mi >>> 0;
                                                    f: {
                                                      u: {
                                                        g: {
                                                          A: {
                                                            m = Te ? Ni : mi;
                                                            p: {
                                                              if (m) {
                                                                if (A = fr ? e[A + 16 >> 2] : A + 16 | 0, s = va(_r, A, m), !s) {
                                                                  if (mi >>> 0 < Ni >>> 0)
                                                                    break p;
                                                                  break A;
                                                                }
                                                                if ((s | 0) >= 0)
                                                                  break A;
                                                                break p;
                                                              }
                                                              if (mi >>> 0 >= Ni >>> 0)
                                                                break g;
                                                            }
                                                            if (ar = p, A = e[p >> 2], A)
                                                              continue;
                                                            break d;
                                                          }
                                                          if (s = va(A, _r, m), s)
                                                            break u;
                                                        }
                                                        if (Te)
                                                          break f;
                                                        W = p;
                                                        break d;
                                                      }
                                                      if ((s | 0) < 0)
                                                        break f;
                                                      W = p;
                                                      break d;
                                                    }
                                                    if (ar = p + 4 | 0, A = e[p + 4 >> 2], !A)
                                                      break;
                                                  }
                                                }
                                                m = Xe, Te = e[m + 4 >> 2], A = Te;
                                                d: {
                                                  if (A) {
                                                    for (; ; )
                                                      if (s = A, A = e[A >> 2], !A)
                                                        break d;
                                                  }
                                                  for (; s = e[m + 8 >> 2], A = e[s >> 2] != (m | 0), m = s, !!A; )
                                                    ;
                                                }
                                                if (!W) {
                                                  m = Xe;
                                                  d: {
                                                    if (Te) {
                                                      for (; ; )
                                                        if (A = Te, Te = e[A >> 2], !Te)
                                                          break d;
                                                    }
                                                    for (; A = e[m + 8 >> 2], W = e[A >> 2] != (m | 0), m = A, !!W; )
                                                      ;
                                                  }
                                                  e[vr >> 2] == (Xe | 0) && (e[vr >> 2] = A), e[vr + 8 >> 2] = e[vr + 8 >> 2] - 1, Te = e[vr + 4 >> 2];
                                                  d: {
                                                    f: {
                                                      if (m = Xe, W = e[m >> 2], W) {
                                                        if (A = e[m + 4 >> 2], !A)
                                                          break f;
                                                        for (; m = A, A = e[A >> 2], !!A; )
                                                          ;
                                                      }
                                                      if (W = e[m + 4 >> 2], W)
                                                        break f;
                                                      W = 0, fr = 1;
                                                      break d;
                                                    }
                                                    e[W + 8 >> 2] = e[m + 8 >> 2], fr = 0;
                                                  }
                                                  _r = e[m + 8 >> 2], A = e[_r >> 2];
                                                  d: {
                                                    if ((m | 0) == (A | 0)) {
                                                      if (e[_r >> 2] = W, (m | 0) == (Te | 0)) {
                                                        A = 0, Te = W;
                                                        break d;
                                                      }
                                                      A = e[_r + 4 >> 2];
                                                      break d;
                                                    }
                                                    e[_r + 4 >> 2] = W;
                                                  }
                                                  mi = !me[m + 12 | 0], (m | 0) != (Xe | 0) && (_r = e[Xe + 8 >> 2], e[m + 8 >> 2] = _r, e[_r + ((e[e[Xe + 8 >> 2] >> 2] != (Xe | 0)) << 2) >> 2] = m, _r = e[Xe >> 2], e[m >> 2] = _r, e[_r + 8 >> 2] = m, _r = e[Xe + 4 >> 2], e[m + 4 >> 2] = _r, _r && (e[_r + 8 >> 2] = m), _[m + 12 | 0] = me[Xe + 12 | 0], Te = (Te | 0) == (Xe | 0) ? m : Te);
                                                  d: {
                                                    if (mi | !Te)
                                                      break d;
                                                    if (!fr) {
                                                      _[W + 12 | 0] = 1;
                                                      break d;
                                                    }
                                                    f: {
                                                      u: {
                                                        for (; ; ) {
                                                          g: {
                                                            m = me[A + 12 | 0], fr = e[A + 8 >> 2];
                                                            A: {
                                                              if (e[fr >> 2] != (A | 0)) {
                                                                m || (_[A + 12 | 0] = 1, _[fr + 12 | 0] = 0, W = e[fr + 4 >> 2], m = e[W >> 2], e[fr + 4 >> 2] = m, m && (e[m + 8 >> 2] = fr), e[W + 8 >> 2] = e[fr + 8 >> 2], m = e[fr + 8 >> 2], e[(((fr | 0) != e[m >> 2]) << 2) + m >> 2] = W, e[W >> 2] = fr, e[fr + 8 >> 2] = W, m = A, A = e[A >> 2], Te = (A | 0) == (Te | 0) ? m : Te, A = e[A + 4 >> 2]), m = e[A >> 2];
                                                                p: {
                                                                  if (!(!me[m + 12 | 0] && m)) {
                                                                    if (W = e[A + 4 >> 2], !(!W | me[W + 12 | 0])) {
                                                                      m = A;
                                                                      break p;
                                                                    }
                                                                    if (_[A + 12 | 0] = 0, A = e[A + 8 >> 2], (Te | 0) == (A | 0)) {
                                                                      _[Te + 12 | 0] = 1;
                                                                      break d;
                                                                    }
                                                                    if (me[A + 12 | 0])
                                                                      break A;
                                                                    _[A + 12 | 0] = 1;
                                                                    break d;
                                                                  }
                                                                  if (W = e[A + 4 >> 2], !(!W | me[W + 12 | 0])) {
                                                                    m = A;
                                                                    break p;
                                                                  }
                                                                  _[m + 12 | 0] = 1, _[A + 12 | 0] = 0, W = e[m + 4 >> 2], e[A >> 2] = W, W && (e[W + 8 >> 2] = A), e[m + 8 >> 2] = e[A + 8 >> 2], W = e[A + 8 >> 2], e[((e[W >> 2] != (A | 0)) << 2) + W >> 2] = m, e[m + 4 >> 2] = A, e[A + 8 >> 2] = m, W = A;
                                                                }
                                                                Te = e[m + 8 >> 2], _[m + 12 | 0] = me[Te + 12 | 0], _[Te + 12 | 0] = 1, _[W + 12 | 0] = 1, m = e[Te + 4 >> 2], A = e[m >> 2], e[Te + 4 >> 2] = A, A && (e[A + 8 >> 2] = Te), e[m + 8 >> 2] = e[Te + 8 >> 2], A = e[Te + 8 >> 2], e[(((Te | 0) != e[A >> 2]) << 2) + A >> 2] = m, e[m >> 2] = Te, e[Te + 8 >> 2] = m;
                                                                break d;
                                                              }
                                                              if (m || (_[A + 12 | 0] = 1, _[fr + 12 | 0] = 0, m = e[A + 4 >> 2], e[fr >> 2] = m, m && (e[m + 8 >> 2] = fr), e[A + 8 >> 2] = e[fr + 8 >> 2], m = e[fr + 8 >> 2], e[(((fr | 0) != e[m >> 2]) << 2) + m >> 2] = A, e[A + 4 >> 2] = fr, e[fr + 8 >> 2] = A, Te = (Te | 0) == (fr | 0) ? A : Te, A = e[fr >> 2]), W = e[A >> 2], !(!W | me[W + 12 | 0])) {
                                                                m = A;
                                                                break f;
                                                              }
                                                              if (m = e[A + 4 >> 2], !me[m + 12 | 0] && m)
                                                                break u;
                                                              if (_[A + 12 | 0] = 0, A = e[A + 8 >> 2], !me[A + 12 | 0] | (A | 0) == (Te | 0))
                                                                break g;
                                                            }
                                                            m = A, A = e[A + 8 >> 2], A = e[(((m | 0) == e[A >> 2]) << 2) + A >> 2];
                                                            continue;
                                                          }
                                                          break;
                                                        }
                                                        _[A + 12 | 0] = 1;
                                                        break d;
                                                      }
                                                      if (!(me[W + 12 | 0] | !W)) {
                                                        m = A;
                                                        break f;
                                                      }
                                                      _[m + 12 | 0] = 1, _[A + 12 | 0] = 0, W = e[m >> 2], e[A + 4 >> 2] = W, W && (e[W + 8 >> 2] = A), e[m + 8 >> 2] = e[A + 8 >> 2], W = e[A + 8 >> 2], e[((e[W >> 2] != (A | 0)) << 2) + W >> 2] = m, e[m >> 2] = A, e[A + 8 >> 2] = m, W = A;
                                                    }
                                                    Te = e[m + 8 >> 2], _[m + 12 | 0] = me[Te + 12 | 0], _[Te + 12 | 0] = 1, _[W + 12 | 0] = 1, m = e[Te >> 2], A = e[m + 4 >> 2], e[Te >> 2] = A, A && (e[A + 8 >> 2] = Te), e[m + 8 >> 2] = e[Te + 8 >> 2], A = e[Te + 8 >> 2], e[(((Te | 0) != e[A >> 2]) << 2) + A >> 2] = m, e[m + 4 >> 2] = Te, e[Te + 8 >> 2] = m;
                                                  }
                                                  e[Xe + 8 >> 2] = p, e[Xe >> 2] = 0, e[Xe + 4 >> 2] = 0, e[ar >> 2] = Xe, A = e[e[N + 36 >> 2] >> 2], A && (e[N + 36 >> 2] = A, Xe = e[ar >> 2]), Ff(e[N + 40 >> 2], Xe), e[N + 44 >> 2] = e[N + 44 >> 2] + 1;
                                                }
                                                if (Xe = s, (s | 0) == (_n | 0))
                                                  break;
                                              }
                                            if (e[N + 44 >> 2] != (hs | 0))
                                              break c;
                                            if (vr = vr + 12 | 0, (Ln | 0) == (vr | 0))
                                              break;
                                          }
                                        e[N + 8 >> 2] = e[N + 36 >> 2], e[N + 16 >> 2] = hs, s = e[N + 40 >> 2], e[N + 12 >> 2] = s;
                                        d: {
                                          if (!hs) {
                                            e[N + 8 >> 2] = Us;
                                            break d;
                                          }
                                          e[s + 8 >> 2] = Us, e[N + 40 >> 2] = 0, e[N + 44 >> 2] = 0, e[N + 36 >> 2] = Hi;
                                        }
                                        s = 1;
                                        break l;
                                      }
                                      _[N + 8 | 0] = 0, s = 0;
                                    }
                                    if (_[N + 20 | 0] = s, ft(e[N + 40 >> 2]), me[N + 20 | 0])
                                      break a;
                                  }
                                  _[r + 12 | 0] = 0, _[r | 0] = 0;
                                  break r;
                                }
                                A = e[N + 28 >> 2], W = e[Ji + 36 >> 2] - e[Ji + 32 >> 2] >> 3, m = e[N + 24 >> 2], s = ((A + Sn(W, -12) | 0) - m | 0) / 12 | 0;
                                a: {
                                  if (!Sn(W, -12)) {
                                    p = A;
                                    break a;
                                  }
                                  if (Te = m + Sn(s, 12) | 0, p = Te, s = p + Sn((Sn(W, 12) | 0) / 12 | 0, 12) | 0, (A | 0) != (s | 0)) {
                                    for (; ; ) {
                                      ft(e[p + 4 >> 2]), e[p >> 2] = e[s >> 2], W = e[s + 4 >> 2], e[p + 4 >> 2] = W, m = e[s + 8 >> 2], e[p + 8 >> 2] = m, Xe = p + 4 | 0;
                                      o: {
                                        if (!m) {
                                          e[p >> 2] = Xe;
                                          break o;
                                        }
                                        e[W + 8 >> 2] = Xe, e[s + 4 >> 2] = 0, e[s + 8 >> 2] = 0, e[s >> 2] = s + 4;
                                      }
                                      if (p = p + 12 | 0, s = s + 12 | 0, (A | 0) == (s | 0))
                                        break;
                                    }
                                    A = e[N + 28 >> 2];
                                  }
                                  if (p = Te + Sn((p - Te | 0) / 12 | 0, 12) | 0, (p | 0) != (A | 0))
                                    for (; A = A - 12 | 0, ft(e[A + 4 >> 2]), (A | 0) != (p | 0); )
                                      ;
                                  e[N + 28 >> 2] = p;
                                }
                                s = e[N + 32 >> 2];
                                a: {
                                  if (s >>> 0 > p >>> 0) {
                                    e[p >> 2] = e[N + 8 >> 2], A = e[N + 12 >> 2], e[p + 4 >> 2] = A, s = e[N + 16 >> 2], e[p + 8 >> 2] = s, m = p + 4 | 0;
                                    o: {
                                      if (!s) {
                                        e[p >> 2] = m;
                                        break o;
                                      }
                                      e[A + 8 >> 2] = m, e[N + 12 >> 2] = 0, e[N + 16 >> 2] = 0, e[N + 8 >> 2] = Us;
                                    }
                                    e[N + 28 >> 2] = p + 12;
                                    break a;
                                  }
                                  o: {
                                    l: {
                                      fr = e[N + 24 >> 2], W = (p - fr | 0) / 12 | 0, m = W + 1 | 0;
                                      c: {
                                        if (m >>> 0 >= 357913942) {
                                          e[5996] = 0, Nn(96);
                                          break c;
                                        }
                                        if (A = (s - fr | 0) / 12 | 0, s = A << 1, A = A >>> 0 >= 178956970 ? 357913941 : s >>> 0 > m >>> 0 ? s : m, !A) {
                                          m = 0;
                                          break o;
                                        }
                                        if (A >>> 0 < 357913942)
                                          break l;
                                        e[5996] = 0, Nn(35);
                                      }
                                      if (r = e[5996], e[5996] = 0, (r | 0) != 1)
                                        break e;
                                      break n;
                                    }
                                    if (e[5996] = 0, m = Mi(3, Sn(A, 12) | 0) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1)
                                      break n;
                                  }
                                  s = Sn(W, 12) + m | 0, e[s >> 2] = e[N + 8 >> 2], Xe = e[N + 12 >> 2], e[s + 4 >> 2] = Xe, W = e[N + 16 >> 2], e[s + 8 >> 2] = W, A = Sn(A, 12), Te = s + 4 | 0;
                                  o: {
                                    if (!W) {
                                      e[s >> 2] = Te;
                                      break o;
                                    }
                                    e[Xe + 8 >> 2] = Te, e[N + 12 >> 2] = 0, e[N + 16 >> 2] = 0, e[N + 8 >> 2] = Us;
                                  }
                                  ar = A + m | 0, Te = s + 12 | 0;
                                  o: {
                                    if ((p | 0) == (fr | 0)) {
                                      e[N + 32 >> 2] = ar, e[N + 28 >> 2] = Te, e[N + 24 >> 2] = s;
                                      break o;
                                    }
                                    for (; ; ) {
                                      s = s - 12 | 0, p = p - 12 | 0, e[s >> 2] = e[p >> 2], Xe = s + 4 | 0, W = p + 4 | 0, m = e[W >> 2], e[Xe >> 2] = m, A = e[p + 8 >> 2], e[s + 8 >> 2] = A;
                                      l: {
                                        if (!A) {
                                          e[s >> 2] = Xe;
                                          break l;
                                        }
                                        e[m + 8 >> 2] = Xe, e[p >> 2] = W, e[p + 4 >> 2] = 0, e[p + 8 >> 2] = 0;
                                      }
                                      if ((p | 0) == (fr | 0))
                                        break;
                                    }
                                    if (e[N + 32 >> 2] = ar, A = e[N + 28 >> 2], e[N + 28 >> 2] = Te, p = e[N + 24 >> 2], e[N + 24 >> 2] = s, (A | 0) == (p | 0))
                                      break o;
                                    for (; A = A - 12 | 0, ft(e[A + 4 >> 2]), (A | 0) != (p | 0); )
                                      ;
                                  }
                                  if (!p)
                                    break a;
                                  Br(p);
                                }
                                me[N + 20 | 0] && ft(e[N + 12 >> 2]), p = ha;
                              }
                              if ((p | 0) != (hi | 0))
                                continue;
                              break i;
                            }
                            break;
                          }
                          if (s = Hr() | 0, !me[N + 20 | 0])
                            break t;
                          ft(e[N + 12 >> 2]);
                          break t;
                        }
                        if (m = e[N + 24 >> 2], (e[N + 28 >> 2] - m | 0) != 12) {
                          if (e[5996] = 0, Vs(44, 4102, 2210, 450, 2439), r = e[5996], e[5996] = 0, (r | 0) != 1)
                            break e;
                          s = Hr() | 0;
                          break t;
                        }
                        e[r >> 2] = e[m >> 2], u = e[m + 4 >> 2], e[r + 4 >> 2] = u, s = e[m + 8 >> 2], e[r + 8 >> 2] = s, A = r + 4 | 0;
                        i: {
                          if (!s) {
                            e[r >> 2] = A;
                            break i;
                          }
                          e[u + 8 >> 2] = A, e[m + 4 >> 2] = 0, e[m + 8 >> 2] = 0, e[m >> 2] = m + 4;
                        }
                        _[r + 12 | 0] = 1;
                      }
                      if (r = e[N + 24 >> 2], r) {
                        if (p = e[N + 28 >> 2], (r | 0) != (p | 0))
                          for (; p = p - 12 | 0, ft(e[p + 4 >> 2]), (r | 0) != (p | 0); )
                            ;
                        Br(r);
                      }
                      hi && Br(hi), Jr = N + 48 | 0;
                      return;
                    }
                    d1(N + 24 | 0), hi && Br(hi), Jn(s | 0), Oi();
                  }
                  r = Hr() | 0, d1(N + 24 | 0), Jn(r | 0), Oi();
                }
                Oi();
              }
              function oh(r, s, u) {
                var A = 0, m = 0, p = 0, N = 0, W = 0, Te = 0, Xe = 0, fr = 0, ar = 0, vr = 0, _r = 0, hi = 0, mi = 0, Ni = 0, Hi = 0, Ji = 0, Ln = 0, _n = 0, hs = 0, bs = 0, Us = 0;
                m = Jr - 144 | 0, Jr = m, A = nu(m, 0, 144), e[A + 76 >> 2] = -1, e[A + 44 >> 2] = r, e[A + 32 >> 2] = 178, e[A + 84 >> 2] = r, Ji = u, r = 0, Xe = Jr - 304 | 0, Jr = Xe;
                e: {
                  t: {
                    r: {
                      i: {
                        if (e[A + 4 >> 2] || (cA(A), e[A + 4 >> 2]))
                          break i;
                        break r;
                      }
                      if (W = me[s | 0], !W)
                        break e;
                      i: {
                        n: {
                          s: {
                            a: {
                              for (; ; ) {
                                o: {
                                  u = W & 255;
                                  l: {
                                    if ((u | 0) == 32 | u - 9 >>> 0 < 5) {
                                      for (; W = s, s = s + 1 | 0, u = me[W + 1 | 0], !!((u | 0) == 32 | u - 9 >>> 0 < 5); )
                                        ;
                                      for (wu(A, 0, 0); ; ) {
                                        s = e[A + 4 >> 2];
                                        c: {
                                          if ((s | 0) != e[A + 104 >> 2]) {
                                            e[A + 4 >> 2] = s + 1, s = me[s | 0];
                                            break c;
                                          }
                                          s = Bo(A);
                                        }
                                        if (!((s | 0) == 32 | s - 9 >>> 0 < 5))
                                          break;
                                      }
                                      s = e[A + 4 >> 2], u = e[A + 116 >> 2], (u | 0) > 0 | (u | 0) >= 0 && (s = s - 1 | 0, e[A + 4 >> 2] = s), s = s - e[A + 44 >> 2] | 0, m = s, Te = hi + e[A + 124 >> 2] | 0, u = s >> 31, s = vr + e[A + 120 >> 2] | 0, Te = u + (s >>> 0 < vr >>> 0 ? Te + 1 | 0 : Te) | 0, vr = s + m | 0, hi = vr >>> 0 < s >>> 0 ? Te + 1 | 0 : Te;
                                      break l;
                                    }
                                    c: {
                                      d: {
                                        f: {
                                          if ((u | 0) == 37) {
                                            if (u = me[s + 1 | 0], (u | 0) == 42)
                                              break f;
                                            if ((u | 0) != 37)
                                              break d;
                                          }
                                          wu(A, 0, 0);
                                          u: {
                                            if (me[s | 0] == 37) {
                                              for (; ; ) {
                                                u = e[A + 4 >> 2];
                                                g: {
                                                  if ((u | 0) != e[A + 104 >> 2]) {
                                                    e[A + 4 >> 2] = u + 1, W = me[u | 0];
                                                    break g;
                                                  }
                                                  W = Bo(A);
                                                }
                                                if (!((W | 0) == 32 | W - 9 >>> 0 < 5))
                                                  break;
                                              }
                                              s = s + 1 | 0;
                                              break u;
                                            }
                                            if (u = e[A + 4 >> 2], (u | 0) != e[A + 104 >> 2]) {
                                              e[A + 4 >> 2] = u + 1, W = me[u | 0];
                                              break u;
                                            }
                                            W = Bo(A);
                                          }
                                          if (me[s | 0] != (W | 0)) {
                                            if (s = e[A + 116 >> 2], (s | 0) > 0 | (s | 0) >= 0 && (e[A + 4 >> 2] = e[A + 4 >> 2] - 1), (W | 0) >= 0 || (N = 0, Ln))
                                              break e;
                                            break r;
                                          }
                                          u = e[A + 4 >> 2] - e[A + 44 >> 2] | 0, W = u, p = hi + e[A + 124 >> 2] | 0, m = u >> 31, u = vr + e[A + 120 >> 2] | 0, N = m + (u >>> 0 < vr >>> 0 ? p + 1 | 0 : p) | 0, vr = u + W | 0, hi = vr >>> 0 < u >>> 0 ? N + 1 | 0 : N, W = s;
                                          break l;
                                        }
                                        ar = 0, s = s + 2 | 0;
                                        break c;
                                      }
                                      if (m = u - 48 | 0, !(me[s + 2 | 0] != 36 | m >>> 0 >= 10)) {
                                        u = Jr - 16 | 0, e[u + 12 >> 2] = Ji, p = u, u = (m >>> 0 > 1 ? (m << 2) - 4 | 0 : 0) + Ji | 0, e[p + 8 >> 2] = u + 4, ar = e[u >> 2], s = s + 3 | 0;
                                        break c;
                                      }
                                      ar = e[Ji >> 2], Ji = Ji + 4 | 0, s = s + 1 | 0;
                                    }
                                    for (u = 0; ; ) {
                                      if (p = me[s | 0], p - 48 >>> 0 < 10) {
                                        s = s + 1 | 0, u = (Sn(u, 10) + p | 0) - 48 | 0;
                                        continue;
                                      }
                                      break;
                                    }
                                    Hi = 0, (p | 0) == 109 && (mi = 0, Hi = (ar | 0) != 0, p = me[s + 1 | 0], s = s + 1 | 0, r = 0), W = s + 1 | 0, fr = 3, N = Hi;
                                    c: {
                                      d:
                                        switch ((p & 255) - 65 | 0) {
                                          case 39:
                                            m = s + 2 | 0, s = me[s + 1 | 0] == 104, W = s ? m : W, fr = s ? -2 : -1;
                                            break c;
                                          case 43:
                                            m = s + 2 | 0, s = me[s + 1 | 0] == 108, W = s ? m : W, fr = s ? 3 : 1;
                                            break c;
                                          case 51:
                                          case 57:
                                            fr = 1;
                                            break c;
                                          case 11:
                                            fr = 2;
                                            break c;
                                          case 41:
                                            break c;
                                          case 0:
                                          case 2:
                                          case 4:
                                          case 5:
                                          case 6:
                                          case 18:
                                          case 23:
                                          case 26:
                                          case 32:
                                          case 34:
                                          case 35:
                                          case 36:
                                          case 37:
                                          case 38:
                                          case 40:
                                          case 45:
                                          case 46:
                                          case 47:
                                          case 50:
                                          case 52:
                                          case 55:
                                            break d;
                                          default:
                                            break i;
                                        }
                                      fr = 0, W = s;
                                    }
                                    m = me[W | 0], s = (m & 47) == 3, _n = s ? 1 : fr, Ni = s ? m | 32 : m;
                                    c: {
                                      if ((Ni | 0) == 91)
                                        break c;
                                      d: {
                                        if ((Ni | 0) != 110) {
                                          if ((Ni | 0) != 99)
                                            break d;
                                          u = (u | 0) <= 1 ? 1 : u;
                                          break c;
                                        }
                                        Uc(ar, _n, vr, hi);
                                        break l;
                                      }
                                      for (wu(A, 0, 0); ; ) {
                                        s = e[A + 4 >> 2];
                                        d: {
                                          if ((s | 0) != e[A + 104 >> 2]) {
                                            e[A + 4 >> 2] = s + 1, s = me[s | 0];
                                            break d;
                                          }
                                          s = Bo(A);
                                        }
                                        if (!((s | 0) == 32 | s - 9 >>> 0 < 5))
                                          break;
                                      }
                                      s = e[A + 4 >> 2], m = e[A + 116 >> 2], (m | 0) > 0 | (m | 0) >= 0 && (s = s - 1 | 0, e[A + 4 >> 2] = s), s = s - e[A + 44 >> 2] | 0, p = s, Te = hi + e[A + 124 >> 2] | 0, m = s >> 31, s = vr + e[A + 120 >> 2] | 0, hi = m + (s >>> 0 < vr >>> 0 ? Te + 1 | 0 : Te) | 0, vr = s + p | 0, hi = vr >>> 0 < s >>> 0 ? hi + 1 | 0 : hi;
                                    }
                                    Te = u, _r = u >> 31, wu(A, u, _r), s = e[A + 4 >> 2];
                                    c: {
                                      if ((s | 0) != e[A + 104 >> 2]) {
                                        e[A + 4 >> 2] = s + 1;
                                        break c;
                                      }
                                      if ((Bo(A) | 0) < 0)
                                        break n;
                                    }
                                    s = e[A + 116 >> 2], (s | 0) > 0 | (s | 0) >= 0 && (e[A + 4 >> 2] = e[A + 4 >> 2] - 1), s = 16;
                                    c: {
                                      d: {
                                        f: {
                                          u: {
                                            g:
                                              switch (Ni - 88 | 0) {
                                                default:
                                                  if (s = Ni - 65 | 0, s >>> 0 > 6 | !(1 << s & 113))
                                                    break c;
                                                case 9:
                                                case 13:
                                                case 14:
                                                case 15:
                                                  if (sh(Xe + 8 | 0, A, _n, 0), u = e[A + 4 >> 2] - e[A + 44 >> 2] | 0, e[A + 120 >> 2] != (0 - u | 0) | e[A + 124 >> 2] != (0 - ((u >> 31) + ((u | 0) != 0) | 0) | 0))
                                                    break f;
                                                  break s;
                                                case 3:
                                                case 11:
                                                case 27:
                                                  if ((Ni | 16) == 115) {
                                                    if (nu(Xe + 32 | 0, -1, 257), _[Xe + 32 | 0] = 0, (Ni | 0) != 115)
                                                      break d;
                                                    _[Xe + 65 | 0] = 0, _[Xe + 46 | 0] = 0, Zs[Xe + 42 >> 1] = 0, Zs[Xe + 44 >> 1] = 0;
                                                    break d;
                                                  }
                                                  p = me[W + 1 | 0], m = (p | 0) == 94, nu(Xe + 32 | 0, m, 257), _[Xe + 32 | 0] = 0, s = m ? W + 2 | 0 : W + 1 | 0;
                                                  A: {
                                                    p: {
                                                      m: {
                                                        if (m = me[(m ? 2 : 1) + W | 0], (m | 0) != 45) {
                                                          if ((m | 0) == 93)
                                                            break m;
                                                          fr = (p | 0) != 94;
                                                          break A;
                                                        }
                                                        fr = (p | 0) != 94, _[Xe + 78 | 0] = fr;
                                                        break p;
                                                      }
                                                      fr = (p | 0) != 94, _[Xe + 126 | 0] = fr;
                                                    }
                                                    s = s + 1 | 0;
                                                  }
                                                  for (W = s; ; ) {
                                                    p = me[W | 0];
                                                    A: {
                                                      if ((p | 0) != 45) {
                                                        if (!p)
                                                          break n;
                                                        if ((p | 0) == 93)
                                                          break d;
                                                        break A;
                                                      }
                                                      if (p = 45, N = me[W + 1 | 0], !N | (N | 0) == 93)
                                                        break A;
                                                      m = W + 1 | 0, s = me[W - 1 | 0];
                                                      p: {
                                                        if (N >>> 0 <= s >>> 0) {
                                                          p = N;
                                                          break p;
                                                        }
                                                        for (; s = s + 1 | 0, _[s + (Xe + 32 | 0) | 0] = fr, p = me[m | 0], p >>> 0 > s >>> 0; )
                                                          ;
                                                      }
                                                      W = m;
                                                    }
                                                    _[(p + Xe | 0) + 33 | 0] = fr, W = W + 1 | 0;
                                                  }
                                                case 23:
                                                  s = 8;
                                                  break u;
                                                case 12:
                                                case 29:
                                                  s = 10;
                                                  break u;
                                                case 1:
                                                case 2:
                                                case 4:
                                                case 5:
                                                case 6:
                                                case 7:
                                                case 8:
                                                case 10:
                                                case 16:
                                                case 18:
                                                case 19:
                                                case 20:
                                                case 21:
                                                case 22:
                                                case 25:
                                                case 26:
                                                case 28:
                                                case 30:
                                                case 31:
                                                  break c;
                                                case 0:
                                                case 24:
                                                case 32:
                                                  break u;
                                                case 17:
                                                  break g;
                                              }
                                            s = 0;
                                          }
                                          m = 0, Te = 0, p = 0, N = 0, bs = 0, hs = Jr - 16 | 0, Jr = hs;
                                          u: {
                                            if ((s | 0) == 1) {
                                              e[5732] = 28;
                                              break u;
                                            }
                                            for (; ; ) {
                                              u = e[A + 4 >> 2];
                                              g: {
                                                if ((u | 0) != e[A + 104 >> 2]) {
                                                  e[A + 4 >> 2] = u + 1, u = me[u | 0];
                                                  break g;
                                                }
                                                u = Bo(A);
                                              }
                                              if (!((u | 0) == 32 | u - 9 >>> 0 < 5))
                                                break;
                                            }
                                            g: {
                                              A:
                                                switch (u - 43 | 0) {
                                                  case 0:
                                                  case 2:
                                                    break A;
                                                  default:
                                                    break g;
                                                }
                                              if (bs = (u | 0) == 45 ? -1 : 0, u = e[A + 4 >> 2], (u | 0) != e[A + 104 >> 2]) {
                                                e[A + 4 >> 2] = u + 1, u = me[u | 0];
                                                break g;
                                              }
                                              u = Bo(A);
                                            }
                                            g: {
                                              A: {
                                                p: {
                                                  m: {
                                                    if (!((s | 0) != 0 & (s | 0) != 16 | (u | 0) != 48)) {
                                                      u = e[A + 4 >> 2];
                                                      k: {
                                                        if ((u | 0) != e[A + 104 >> 2]) {
                                                          e[A + 4 >> 2] = u + 1, u = me[u | 0];
                                                          break k;
                                                        }
                                                        u = Bo(A);
                                                      }
                                                      if ((u & -33) == 88) {
                                                        s = 16, u = e[A + 4 >> 2];
                                                        k: {
                                                          if ((u | 0) != e[A + 104 >> 2]) {
                                                            e[A + 4 >> 2] = u + 1, u = me[u | 0];
                                                            break k;
                                                          }
                                                          u = Bo(A);
                                                        }
                                                        if (me[u + 8641 | 0] < 16)
                                                          break p;
                                                        s = e[A + 116 >> 2], (s | 0) > 0 | (s | 0) >= 0 && (e[A + 4 >> 2] = e[A + 4 >> 2] - 1), wu(A, 0, 0);
                                                        break u;
                                                      }
                                                      if (s)
                                                        break m;
                                                      s = 8;
                                                      break p;
                                                    }
                                                    if (s = s || 10, s >>> 0 > me[u + 8641 | 0])
                                                      break m;
                                                    s = e[A + 116 >> 2], (s | 0) > 0 | (s | 0) >= 0 && (e[A + 4 >> 2] = e[A + 4 >> 2] - 1), wu(A, 0, 0), e[5732] = 28;
                                                    break u;
                                                  }
                                                  if ((s | 0) != 10)
                                                    break p;
                                                  if (p = u - 48 | 0, p >>> 0 <= 9) {
                                                    for (u = 0; ; ) {
                                                      u = Sn(u, 10) + p | 0, N = u >>> 0 < 429496729, m = e[A + 4 >> 2];
                                                      m: {
                                                        if ((m | 0) != e[A + 104 >> 2]) {
                                                          e[A + 4 >> 2] = m + 1, s = me[m | 0];
                                                          break m;
                                                        }
                                                        s = Bo(A);
                                                      }
                                                      if (p = s - 48 | 0, !(N & p >>> 0 <= 9))
                                                        break;
                                                    }
                                                    m = u;
                                                  }
                                                  if (p >>> 0 > 9)
                                                    break g;
                                                  for (s = Ao(m, 0, 10, 0), N = Ds; ; ) {
                                                    m = s + p | 0, Te = m >>> 0 < p >>> 0 ? N + 1 | 0 : N, s = (Te | 0) == 429496729 & m >>> 0 < 2576980378 | Te >>> 0 < 429496729, u = e[A + 4 >> 2];
                                                    m: {
                                                      if ((u | 0) != e[A + 104 >> 2]) {
                                                        e[A + 4 >> 2] = u + 1, u = me[u | 0];
                                                        break m;
                                                      }
                                                      u = Bo(A);
                                                    }
                                                    if (fr = u - 48 | 0, !(s & fr >>> 0 <= 9)) {
                                                      if (s = 10, fr >>> 0 <= 9)
                                                        break A;
                                                      break g;
                                                    }
                                                    if (s = Ao(m, Te, 10, 0), N = Ds, p = fr, !((N | 0) == -1 & (p ^ -1) >>> 0 >= s >>> 0 | (N | 0) != -1))
                                                      break;
                                                  }
                                                  s = 10;
                                                  break A;
                                                }
                                                if (s - 1 & s) {
                                                  if (N = me[u + 8641 | 0], N >>> 0 < s >>> 0) {
                                                    for (; ; ) {
                                                      p = Sn(s, p) + N | 0, m = p >>> 0 < 119304647, u = e[A + 4 >> 2];
                                                      p: {
                                                        if ((u | 0) != e[A + 104 >> 2]) {
                                                          e[A + 4 >> 2] = u + 1, u = me[u | 0];
                                                          break p;
                                                        }
                                                        u = Bo(A);
                                                      }
                                                      if (N = me[u + 8641 | 0], !(m & N >>> 0 < s >>> 0))
                                                        break;
                                                    }
                                                    m = p;
                                                  }
                                                  if (s >>> 0 <= N >>> 0)
                                                    break A;
                                                  for (_r = s; ; ) {
                                                    if (p = Ao(m, Te, _r, 0), fr = Ds, N = N & 255, (fr | 0) == -1 & (N ^ -1) >>> 0 < p >>> 0)
                                                      break A;
                                                    Te = fr, m = p + N | 0, Te = m >>> 0 < N >>> 0 ? Te + 1 | 0 : Te, u = e[A + 4 >> 2];
                                                    p: {
                                                      if ((u | 0) != e[A + 104 >> 2]) {
                                                        e[A + 4 >> 2] = u + 1, u = me[u | 0];
                                                        break p;
                                                      }
                                                      u = Bo(A);
                                                    }
                                                    if (N = me[u + 8641 | 0], s >>> 0 <= N >>> 0)
                                                      break A;
                                                    if (Aa(hs, _r, 0, 0, 0, m, Te, 0, 0), !!(e[hs + 8 >> 2] | e[hs + 12 >> 2]))
                                                      break;
                                                  }
                                                  break A;
                                                }
                                                if (fr = _[(Sn(s, 23) >>> 5 & 7) + 8897 | 0], p = me[u + 8641 | 0], p >>> 0 < s >>> 0) {
                                                  for (; ; ) {
                                                    N = N << fr | p, m = N >>> 0 < 134217728, u = e[A + 4 >> 2];
                                                    p: {
                                                      if ((u | 0) != e[A + 104 >> 2]) {
                                                        e[A + 4 >> 2] = u + 1, u = me[u | 0];
                                                        break p;
                                                      }
                                                      u = Bo(A);
                                                    }
                                                    if (p = me[u + 8641 | 0], !(m & p >>> 0 < s >>> 0))
                                                      break;
                                                  }
                                                  m = N;
                                                }
                                                if (s >>> 0 <= p >>> 0 || (_r = fr & 31, (fr & 63) >>> 0 >= 32 ? (N = 0, _r = -1 >>> _r | 0) : (N = -1 >>> _r | 0, _r = N | (1 << _r) - 1 << 32 - _r), !N & m >>> 0 > _r >>> 0))
                                                  break A;
                                                for (; ; ) {
                                                  Us = p & 255, u = m, p = fr & 31, (fr & 63) >>> 0 >= 32 ? (Te = u << p, u = 0) : (Te = (1 << p) - 1 & u >>> 32 - p | Te << p, u = u << p), m = Us | u, u = e[A + 4 >> 2];
                                                  p: {
                                                    if ((u | 0) != e[A + 104 >> 2]) {
                                                      e[A + 4 >> 2] = u + 1, u = me[u | 0];
                                                      break p;
                                                    }
                                                    u = Bo(A);
                                                  }
                                                  if (p = me[u + 8641 | 0], s >>> 0 <= p >>> 0)
                                                    break A;
                                                  if (!((N | 0) == (Te | 0) & m >>> 0 <= _r >>> 0 | N >>> 0 > Te >>> 0))
                                                    break;
                                                }
                                              }
                                              if (me[u + 8641 | 0] >= s >>> 0)
                                                break g;
                                              for (; ; ) {
                                                u = e[A + 4 >> 2];
                                                A: {
                                                  if ((u | 0) != e[A + 104 >> 2]) {
                                                    e[A + 4 >> 2] = u + 1, u = me[u | 0];
                                                    break A;
                                                  }
                                                  u = Bo(A);
                                                }
                                                if (!(me[u + 8641 | 0] < s >>> 0))
                                                  break;
                                              }
                                              e[5732] = 68, m = -1, Te = -1, bs = 0;
                                            }
                                            s = e[A + 116 >> 2], (s | 0) > 0 | (s | 0) >= 0 && (e[A + 4 >> 2] = e[A + 4 >> 2] - 1), s = bs, p = s ^ m, m = p - s | 0, u = s >> 31, Te = (u ^ Te) - ((s >>> 0 > p >>> 0) + u | 0) | 0;
                                          }
                                          if (Jr = hs + 16 | 0, u = e[A + 4 >> 2] - e[A + 44 >> 2] | 0, e[A + 120 >> 2] == (0 - u | 0) & e[A + 124 >> 2] == (0 - ((u >> 31) + ((u | 0) != 0) | 0) | 0))
                                            break s;
                                          if (!(!ar | (Ni | 0) != 112)) {
                                            e[ar >> 2] = m;
                                            break c;
                                          }
                                          Uc(ar, _n, m, Te);
                                          break c;
                                        }
                                        if (!ar)
                                          break c;
                                        u = e[Xe + 16 >> 2], p = e[Xe + 20 >> 2], s = e[Xe + 8 >> 2], m = e[Xe + 12 >> 2];
                                        f:
                                          switch (_n | 0) {
                                            case 0:
                                              gc[ar >> 2] = kh(s, m, u, p);
                                              break c;
                                            case 1:
                                              jn[ar >> 3] = xu(s, m, u, p);
                                              break c;
                                            case 2:
                                              break f;
                                            default:
                                              break c;
                                          }
                                        e[ar >> 2] = s, e[ar + 4 >> 2] = m, e[ar + 8 >> 2] = u, e[ar + 12 >> 2] = p;
                                        break c;
                                      }
                                      fr = (Ni | 0) != 99, u = fr ? 31 : u + 1 | 0;
                                      d: {
                                        if ((_n | 0) == 1) {
                                          if (p = ar, Hi && (p = da(u << 2), !p))
                                            break a;
                                          for (e[Xe + 296 >> 2] = 0, e[Xe + 300 >> 2] = 0, s = 0; ; ) {
                                            r = p;
                                            f: {
                                              for (; ; ) {
                                                m = e[A + 4 >> 2];
                                                u: {
                                                  if ((m | 0) != e[A + 104 >> 2]) {
                                                    e[A + 4 >> 2] = m + 1, m = me[m | 0];
                                                    break u;
                                                  }
                                                  m = Bo(A);
                                                }
                                                if (!me[(m + Xe | 0) + 33 | 0])
                                                  break f;
                                                if (_[Xe + 27 | 0] = m, m = dl(Xe + 28 | 0, Xe + 27 | 0, 1, Xe + 296 | 0), (m | 0) != -2) {
                                                  if (mi = 0, (m | 0) == -1)
                                                    break n;
                                                  if (r && (e[(s << 2) + r >> 2] = e[Xe + 28 >> 2], s = s + 1 | 0), !(!Hi | (s | 0) != (u | 0)))
                                                    break;
                                                }
                                              }
                                              if (N = 1, s = u, u = s << 1 | 1, p = wc(r, u << 2), p)
                                                continue;
                                              break i;
                                            }
                                            break;
                                          }
                                          if (mi = 0, u = r, Xe + 296 | 0 && e[Xe + 296 >> 2])
                                            break n;
                                          break d;
                                        }
                                        if (Hi) {
                                          if (s = 0, p = da(u), !p)
                                            break a;
                                          for (; ; ) {
                                            for (r = p; ; ) {
                                              m = e[A + 4 >> 2];
                                              f: {
                                                if ((m | 0) != e[A + 104 >> 2]) {
                                                  e[A + 4 >> 2] = m + 1, m = me[m | 0];
                                                  break f;
                                                }
                                                m = Bo(A);
                                              }
                                              if (!me[(m + Xe | 0) + 33 | 0]) {
                                                u = 0, mi = r;
                                                break d;
                                              }
                                              if (_[r + s | 0] = m, s = s + 1 | 0, (u | 0) == (s | 0))
                                                break;
                                            }
                                            if (N = 1, s = u, u = s << 1 | 1, p = wc(r, u), !p)
                                              break;
                                          }
                                          mi = r, r = 0;
                                          break i;
                                        }
                                        if (s = 0, ar)
                                          for (; ; ) {
                                            r = e[A + 4 >> 2];
                                            f: {
                                              if ((r | 0) != e[A + 104 >> 2]) {
                                                e[A + 4 >> 2] = r + 1, r = me[r | 0];
                                                break f;
                                              }
                                              r = Bo(A);
                                            }
                                            if (me[(r + Xe | 0) + 33 | 0]) {
                                              _[s + ar | 0] = r, s = s + 1 | 0;
                                              continue;
                                            } else {
                                              u = 0, r = ar, mi = r;
                                              break d;
                                            }
                                          }
                                        for (; ; ) {
                                          r = e[A + 4 >> 2];
                                          f: {
                                            if ((r | 0) != e[A + 104 >> 2]) {
                                              e[A + 4 >> 2] = r + 1, r = me[r | 0];
                                              break f;
                                            }
                                            r = Bo(A);
                                          }
                                          if (!me[(r + Xe | 0) + 33 | 0])
                                            break;
                                        }
                                        r = 0, mi = 0, u = 0;
                                      }
                                      if (p = e[A + 4 >> 2], m = e[A + 116 >> 2], (m | 0) > 0 | (m | 0) >= 0 && (p = p - 1 | 0, e[A + 4 >> 2] = p), m = p - e[A + 44 >> 2] | 0, p = m + e[A + 120 >> 2] | 0, N = e[A + 124 >> 2] + (m >> 31) | 0, N = p >>> 0 < m >>> 0 ? N + 1 | 0 : N, !(N | p) | !(fr | (p | 0) == (Te | 0) & (N | 0) == (_r | 0)))
                                        break o;
                                      Hi && (e[ar >> 2] = r);
                                      d: {
                                        if ((Ni | 0) == 99)
                                          break d;
                                        if (u && (e[(s << 2) + u >> 2] = 0), !mi) {
                                          mi = 0;
                                          break d;
                                        }
                                        _[s + mi | 0] = 0;
                                      }
                                      r = u;
                                    }
                                    s = e[A + 4 >> 2] - e[A + 44 >> 2] | 0, m = s, p = hi + e[A + 124 >> 2] | 0, u = s >> 31, s = vr + e[A + 120 >> 2] | 0, Te = u + (s >>> 0 < vr >>> 0 ? p + 1 | 0 : p) | 0, vr = s + m | 0, hi = vr >>> 0 < s >>> 0 ? Te + 1 | 0 : Te, Ln = ((ar | 0) != 0) + Ln | 0;
                                  }
                                  if (s = W + 1 | 0, W = me[W + 1 | 0], W)
                                    continue;
                                  break e;
                                }
                                break;
                              }
                              r = u;
                              break s;
                            }
                            N = 1, mi = 0, r = 0;
                            break i;
                          }
                          N = Hi;
                          break t;
                        }
                        N = Hi;
                      }
                      if (Ln)
                        break t;
                    }
                    Ln = -1;
                  }
                  if (!N)
                    break e;
                  Br(mi), Br(r);
                }
                return Jr = Xe + 304 | 0, Jr = A + 144 | 0, Ln;
              }
              function tg(r) {
                r = r | 0;
                var s = 0, u = 0, A = 0, m = 0, p = 0, N = 0;
                A = Jr - 320 | 0, Jr = A;
                e: {
                  t: {
                    r: {
                      i: {
                        n: {
                          s: {
                            a: {
                              o: {
                                l: {
                                  c: {
                                    d: {
                                      f: {
                                        u: {
                                          g: {
                                            A: {
                                              p: {
                                                m: {
                                                  k: {
                                                    N: {
                                                      S: {
                                                        T: {
                                                          v: {
                                                            w: {
                                                              if (!me[24336]) {
                                                                if (e[A + 208 >> 2] = 0, e[A + 200 >> 2] = 0, e[A + 204 >> 2] = 0, e[5996] = 0, xn(66, 24324, A + 200 | 0, 1) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1)
                                                                  break w;
                                                                s = e[A + 200 >> 2], s && (e[A + 204 >> 2] = s, Br(s)), _[24336] = 1;
                                                              }
                                                              if (!me[24352]) {
                                                                if (e[5996] = 0, s = A + 200 | 0, gs(68, s | 0, 1598, 8), u = e[5996], e[5996] = 0, (u | 0) == 1 || (e[5996] = 0, s = xn(69, A + 308 | 0, s | 0, 1) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1))
                                                                  break r;
                                                                if (e[5996] = 0, xn(66, 24340, s | 0, 1) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1)
                                                                  break v;
                                                                u = e[s >> 2], u && (e[s + 4 >> 2] = u, Br(u)), _[24352] = 1;
                                                              }
                                                              if (!me[24368]) {
                                                                if (e[5996] = 0, s = A + 200 | 0, gs(68, s | 0, 1194, 10), u = e[5996], e[5996] = 0, (u | 0) == 1 || (e[5996] = 0, s = xn(69, A + 296 | 0, s | 0, 1) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1))
                                                                  break r;
                                                                if (e[5996] = 0, xn(66, 24356, s | 0, 1) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1)
                                                                  break T;
                                                                u = e[s >> 2], u && (e[s + 4 >> 2] = u, Br(u)), _[24368] = 1;
                                                              }
                                                              if (!me[24384]) {
                                                                if (e[5996] = 0, s = A + 200 | 0, gs(68, s | 0, 2432, 6), u = e[5996], e[5996] = 0, (u | 0) == 1 || (e[5996] = 0, s = xn(69, A + 284 | 0, s | 0, 1) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1))
                                                                  break r;
                                                                if (e[5996] = 0, xn(66, 24372, s | 0, 1) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1)
                                                                  break S;
                                                                u = e[s >> 2], u && (e[s + 4 >> 2] = u, Br(u)), _[24384] = 1;
                                                              }
                                                              if (!me[24400]) {
                                                                if (e[5996] = 0, s = A + 200 | 0, gs(68, s | 0, 1492, 6), u = e[5996], e[5996] = 0, (u | 0) == 1 || (e[5996] = 0, s = xn(69, A + 272 | 0, s | 0, 1) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1))
                                                                  break r;
                                                                if (e[5996] = 0, xn(66, 24388, s | 0, 1) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1)
                                                                  break N;
                                                                u = e[s >> 2], u && (e[s + 4 >> 2] = u, Br(u)), _[24400] = 1;
                                                              }
                                                              if (!me[24416]) {
                                                                if (e[5996] = 0, s = A + 200 | 0, gs(68, s | 0, 1152, 8), u = e[5996], e[5996] = 0, (u | 0) == 1 || (e[5996] = 0, s = xn(69, A + 260 | 0, s | 0, 1) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1))
                                                                  break r;
                                                                if (e[5996] = 0, xn(66, 24404, s | 0, 1) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1)
                                                                  break k;
                                                                u = e[s >> 2], u && (e[s + 4 >> 2] = u, Br(u)), _[24416] = 1;
                                                              }
                                                              if (!me[24432]) {
                                                                if (e[5996] = 0, s = A + 200 | 0, gs(68, s | 0, 1526, 8), u = e[5996], e[5996] = 0, (u | 0) == 1 || (e[5996] = 0, s = xn(69, A + 248 | 0, s | 0, 1) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1))
                                                                  break r;
                                                                if (e[5996] = 0, xn(66, 24420, s | 0, 1) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1)
                                                                  break m;
                                                                u = e[s >> 2], u && (e[s + 4 >> 2] = u, Br(u)), _[24432] = 1;
                                                              }
                                                              if (!me[24448]) {
                                                                if (e[5996] = 0, s = A + 200 | 0, gs(68, s | 0, 1628, 10), u = e[5996], e[5996] = 0, (u | 0) == 1 || (e[5996] = 0, s = xn(69, A + 236 | 0, s | 0, 1) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1))
                                                                  break r;
                                                                if (e[5996] = 0, xn(66, 24436, s | 0, 1) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1)
                                                                  break p;
                                                                u = e[s >> 2], u && (e[s + 4 >> 2] = u, Br(u)), _[24448] = 1;
                                                              }
                                                              if (!me[24464]) {
                                                                if (e[5996] = 0, s = A + 116 | 0, gs(68, s | 0, 1435, 7), u = e[5996], e[5996] = 0, (u | 0) == 1 || (e[5996] = 0, gs(68, A + 124 | 0, 1183, 10), u = e[5996], e[5996] = 0, (u | 0) == 1) || (e[5996] = 0, u = xn(69, A + 200 | 0, s | 0, 2) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1))
                                                                  break r;
                                                                if (e[5996] = 0, m = A + 80 | 0, gs(68, m | 0, 1478, 7), p = e[5996], e[5996] = 0, s = u + 12 | 0, (p | 0) == 1 || (e[5996] = 0, gs(68, A + 88 | 0, 1172, 10), p = e[5996], e[5996] = 0, (p | 0) == 1) || (e[5996] = 0, p = xn(69, s | 0, m | 0, 2) | 0, m = e[5996], e[5996] = 0, (m | 0) == 1) || (e[5996] = 0, m = A + 56 | 0, gs(68, m | 0, 1435, 7), N = e[5996], e[5996] = 0, s = u + 24 | 0, (N | 0) == 1) || (e[5996] = 0, gs(68, A - -64 | 0, 1161, 10), N = e[5996], e[5996] = 0, (N | 0) == 1) || (e[5996] = 0, N = xn(69, s | 0, m | 0, 2) | 0, m = e[5996], e[5996] = 0, (m | 0) == 1))
                                                                  break g;
                                                                if (e[5996] = 0, xn(66, 24452, u | 0, 3) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1)
                                                                  break A;
                                                                s = e[N >> 2], s && (e[u + 28 >> 2] = s, Br(s)), s = e[p >> 2], s && (e[u + 16 >> 2] = s, Br(s)), s = e[u >> 2], s && (e[u + 4 >> 2] = s, Br(s)), _[24464] = 1;
                                                              }
                                                              if (!me[24480]) {
                                                                if (e[5996] = 0, s = A + 116 | 0, gs(68, s | 0, 1628, 10), u = e[5996], e[5996] = 0, (u | 0) == 1 || (e[5996] = 0, gs(68, A + 124 | 0, 1617, 10), u = e[5996], e[5996] = 0, (u | 0) == 1) || (e[5996] = 0, s = xn(69, A + 188 | 0, s | 0, 2) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1))
                                                                  break r;
                                                                if (e[5996] = 0, xn(66, 24468, s | 0, 1) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1)
                                                                  break u;
                                                                u = e[s >> 2], u && (e[s + 4 >> 2] = u, Br(u)), _[24480] = 1;
                                                              }
                                                              if (!me[24496]) {
                                                                if (e[5996] = 0, s = A + 116 | 0, gs(68, s | 0, 1462, 8), u = e[5996], e[5996] = 0, (u | 0) == 1 || (e[5996] = 0, gs(68, A + 124 | 0, 1453, 8), u = e[5996], e[5996] = 0, (u | 0) == 1) || (e[5996] = 0, s = xn(69, A + 176 | 0, s | 0, 2) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1))
                                                                  break r;
                                                                if (e[5996] = 0, xn(66, 24484, s | 0, 1) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1)
                                                                  break f;
                                                                u = e[s >> 2], u && (e[s + 4 >> 2] = u, Br(u)), _[24496] = 1;
                                                              }
                                                              if (!me[24512]) {
                                                                if (e[5996] = 0, s = A + 116 | 0, gs(68, s | 0, 1443, 9), u = e[5996], e[5996] = 0, (u | 0) == 1 || (e[5996] = 0, gs(68, A + 124 | 0, 1587, 10), u = e[5996], e[5996] = 0, (u | 0) == 1) || (e[5996] = 0, s = xn(69, A + 164 | 0, s | 0, 2) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1))
                                                                  break r;
                                                                if (e[5996] = 0, xn(66, 24500, s | 0, 1) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1)
                                                                  break d;
                                                                u = e[s >> 2], u && (e[s + 4 >> 2] = u, Br(u)), _[24512] = 1;
                                                              }
                                                              if (!me[24528]) {
                                                                if (e[5996] = 0, s = A + 116 | 0, gs(68, s | 0, 1443, 9), u = e[5996], e[5996] = 0, (u | 0) == 1 || (e[5996] = 0, gs(68, A + 124 | 0, 1471, 6), u = e[5996], e[5996] = 0, (u | 0) == 1) || (e[5996] = 0, s = xn(69, A + 152 | 0, s | 0, 2) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1))
                                                                  break r;
                                                                if (e[5996] = 0, xn(66, 24516, s | 0, 1) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1)
                                                                  break c;
                                                                u = e[s >> 2], u && (e[s + 4 >> 2] = u, Br(u)), _[24528] = 1;
                                                              }
                                                              if (!me[24544]) {
                                                                if (e[5996] = 0, s = A + 80 | 0, gs(68, s | 0, 1535, 9), u = e[5996], e[5996] = 0, (u | 0) == 1 || (e[5996] = 0, gs(68, A + 88 | 0, 1535, 9), u = e[5996], e[5996] = 0, (u | 0) == 1) || (e[5996] = 0, u = xn(69, A + 116 | 0, s | 0, 2) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1))
                                                                  break r;
                                                                if (e[5996] = 0, m = A + 56 | 0, gs(68, m | 0, 1555, 9), p = e[5996], e[5996] = 0, s = u + 12 | 0, (p | 0) == 1 || (e[5996] = 0, gs(68, A - -64 | 0, 1555, 9), p = e[5996], e[5996] = 0, (p | 0) == 1) || (e[5996] = 0, p = xn(69, s | 0, m | 0, 2) | 0, m = e[5996], e[5996] = 0, (m | 0) == 1) || (e[5996] = 0, m = A + 32 | 0, gs(68, m | 0, 1545, 9), N = e[5996], e[5996] = 0, s = u + 24 | 0, (N | 0) == 1) || (e[5996] = 0, gs(68, A + 40 | 0, 1545, 9), N = e[5996], e[5996] = 0, (N | 0) == 1) || (e[5996] = 0, N = xn(69, s | 0, m | 0, 2) | 0, m = e[5996], e[5996] = 0, (m | 0) == 1))
                                                                  break o;
                                                                if (e[5996] = 0, xn(66, 24532, u | 0, 3) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1)
                                                                  break l;
                                                                s = e[N >> 2], s && (e[u + 28 >> 2] = s, Br(s)), s = e[p >> 2], s && (e[u + 16 >> 2] = s, Br(s)), s = e[u >> 2], s && (e[u + 4 >> 2] = s, Br(s)), _[24544] = 1;
                                                              }
                                                              if (!me[24560]) {
                                                                if (e[5996] = 0, s = A + 56 | 0, gs(68, s | 0, 1443, 9), u = e[5996], e[5996] = 0, (u | 0) == 1 || (e[5996] = 0, gs(68, A - -64 | 0, 1517, 8), u = e[5996], e[5996] = 0, (u | 0) == 1) || (e[5996] = 0, gs(68, A + 72 | 0, 1587, 10), u = e[5996], e[5996] = 0, (u | 0) == 1) || (e[5996] = 0, u = xn(69, A + 80 | 0, s | 0, 3) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1))
                                                                  break r;
                                                                if (e[5996] = 0, m = A + 32 | 0, gs(68, m | 0, 1443, 9), p = e[5996], e[5996] = 0, s = u + 12 | 0, (p | 0) == 1 || (e[5996] = 0, gs(68, A + 40 | 0, 1508, 8), p = e[5996], e[5996] = 0, (p | 0) == 1) || (e[5996] = 0, gs(68, A + 48 | 0, 1576, 10), p = e[5996], e[5996] = 0, (p | 0) == 1) || (e[5996] = 0, p = xn(69, s | 0, m | 0, 3) | 0, m = e[5996], e[5996] = 0, (m | 0) == 1) || (e[5996] = 0, m = A + 8 | 0, gs(68, m | 0, 1443, 9), N = e[5996], e[5996] = 0, s = u + 24 | 0, (N | 0) == 1) || (e[5996] = 0, gs(68, A + 16 | 0, 1499, 8), N = e[5996], e[5996] = 0, (N | 0) == 1) || (e[5996] = 0, gs(68, A + 24 | 0, 1565, 10), N = e[5996], e[5996] = 0, (N | 0) == 1) || (e[5996] = 0, N = xn(69, s | 0, m | 0, 3) | 0, m = e[5996], e[5996] = 0, (m | 0) == 1))
                                                                  break s;
                                                                if (e[5996] = 0, xn(66, 24548, u | 0, 3) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1)
                                                                  break a;
                                                                s = e[N >> 2], s && (e[u + 28 >> 2] = s, Br(s)), s = e[p >> 2], s && (e[u + 16 >> 2] = s, Br(s)), s = e[u >> 2], s && (e[u + 4 >> 2] = s, Br(s)), _[24560] = 1;
                                                              }
                                                              if (!(50331647 >>> r & 1))
                                                                break n;
                                                              return Jr = A + 320 | 0, e[(r << 2) + 6864 >> 2];
                                                            }
                                                            if (m = Hr() | 0, r = e[A + 200 >> 2], !r)
                                                              break i;
                                                            e[A + 204 >> 2] = r, Br(r);
                                                            break i;
                                                          }
                                                          if (m = Hr() | 0, r = e[s >> 2], !r)
                                                            break i;
                                                          break t;
                                                        }
                                                        if (m = Hr() | 0, r = e[s >> 2], !r)
                                                          break i;
                                                        break t;
                                                      }
                                                      if (m = Hr() | 0, r = e[s >> 2], !r)
                                                        break i;
                                                      break t;
                                                    }
                                                    if (m = Hr() | 0, r = e[s >> 2], !r)
                                                      break i;
                                                    break t;
                                                  }
                                                  if (m = Hr() | 0, r = e[s >> 2], !r)
                                                    break i;
                                                  break t;
                                                }
                                                if (m = Hr() | 0, r = e[s >> 2], !r)
                                                  break i;
                                                break t;
                                              }
                                              if (m = Hr() | 0, r = e[s >> 2], !r)
                                                break i;
                                              break t;
                                            }
                                            if (m = Hr() | 0, r = e[N >> 2], r && (e[u + 28 >> 2] = r, Br(r)), r = e[p >> 2], r && (e[u + 16 >> 2] = r, Br(r)), r = e[u >> 2], !r)
                                              break i;
                                            break e;
                                          }
                                          for (m = Hr() | 0; r = s - 12 | 0, A = e[r >> 2], A && (e[s - 8 >> 2] = A, Br(A)), s = r, (s | 0) != (u | 0); )
                                            ;
                                          break i;
                                        }
                                        if (m = Hr() | 0, r = e[s >> 2], !r)
                                          break i;
                                        break t;
                                      }
                                      if (m = Hr() | 0, r = e[s >> 2], !r)
                                        break i;
                                      break t;
                                    }
                                    if (m = Hr() | 0, r = e[s >> 2], !r)
                                      break i;
                                    break t;
                                  }
                                  if (m = Hr() | 0, r = e[s >> 2], !r)
                                    break i;
                                  break t;
                                }
                                if (m = Hr() | 0, r = e[N >> 2], r && (e[u + 28 >> 2] = r, Br(r)), r = e[p >> 2], r && (e[u + 16 >> 2] = r, Br(r)), r = e[u >> 2], !r)
                                  break i;
                                break e;
                              }
                              for (m = Hr() | 0; r = s - 12 | 0, A = e[r >> 2], A && (e[s - 8 >> 2] = A, Br(A)), s = r, (s | 0) != (u | 0); )
                                ;
                              break i;
                            }
                            if (m = Hr() | 0, r = e[N >> 2], r && (e[u + 28 >> 2] = r, Br(r)), r = e[p >> 2], r && (e[u + 16 >> 2] = r, Br(r)), r = e[u >> 2], !r)
                              break i;
                            break e;
                          }
                          for (m = Hr() | 0; r = s - 12 | 0, A = e[r >> 2], A && (e[s - 8 >> 2] = A, Br(A)), s = r, (s | 0) != (u | 0); )
                            ;
                          break i;
                        }
                        ga(2350, 1900, 622, 1759), Oi();
                      }
                      Jn(m | 0), Oi();
                    }
                    Jn(Hr() | 0), Oi();
                  }
                  e[s + 4 >> 2] = r, Br(r), Jn(m | 0), Oi();
                }
                e[u + 4 >> 2] = r, Br(r), Jn(m | 0), Oi();
              }
              function mc(r, s, u, A, m) {
                var p = 0, N = 0, W = 0, Te = 0, Xe = 0, fr = 0, ar = 0, vr = 0, _r = 0, hi = 0, mi = 0, Ni = 0, Hi = 0, Ji = 0, Ln = 0, _n = 0, hs = 0, bs = 0;
                W = Jr - 144 | 0, Jr = W, Mf(W + 56 | 0, u, jn[r + 16 >> 3], jn[r + 24 >> 3], 0, 0), e[5996] = 0, p = Mi(46, u | 0) | 0, N = e[5996], e[5996] = 0;
                e: {
                  t: {
                    r: {
                      if ((N | 0) != 1) {
                        if (e[W + 52 >> 2] = 0, e[W + 44 >> 2] = 0, e[W + 48 >> 2] = 0, _[W + 128 | 0] = 0, e[W + 124 >> 2] = W + 44, N = e[p + 4 >> 2], Xe = e[p >> 2], fr = N - Xe | 0, Te = (fr | 0) / 12 | 0, (N | 0) != (Xe | 0)) {
                          i: {
                            n: {
                              s: {
                                if (Te >>> 0 >= 357913942) {
                                  if (e[5996] = 0, Nn(47), r = e[5996], e[5996] = 0, (r | 0) == 1)
                                    break s;
                                  break e;
                                }
                                if (e[5996] = 0, N = Mi(3, fr | 0) | 0, Xe = e[5996], e[5996] = 0, (Xe | 0) == 1)
                                  break s;
                                if (e[W + 48 >> 2] = N, e[W + 44 >> 2] = N, e[W + 52 >> 2] = N + Sn(Te, 12), Te = e[p + 4 >> 2], p = e[p >> 2], e[5996] = 0, p = wa(48, W + 52 | 0, p | 0, Te | 0, N | 0) | 0, Te = e[5996], e[5996] = 0, (Te | 0) != 1)
                                  break i;
                                p = Hr() | 0, e[W + 48 >> 2] = N;
                                break n;
                              }
                              p = Hr() | 0;
                            }
                            ff(W + 124 | 0);
                            break r;
                          }
                          e[W + 48 >> 2] = p;
                        }
                        e[W + 40 >> 2] = 0, e[W + 32 >> 2] = 0, e[W + 36 >> 2] = 0, p = e[A + 4 >> 2], N = e[A >> 2], e[5996] = 0, ji(49, W + 32 | 0, p - N >> 2), p = e[5996], e[5996] = 0;
                        i: {
                          if ((p | 0) != 1) {
                            if (p = e[W + 48 >> 2], N = e[W + 44 >> 2], (p | 0) == (N | 0))
                              break t;
                            p = N;
                            n: {
                              for (; ; ) {
                                s: {
                                  if (e[W + 28 >> 2] = 0, e[W + 20 >> 2] = 0, e[W + 24 >> 2] = 0, Te = e[A + 4 >> 2], N = e[A >> 2], _r = Sn(Ji, 12), p = _r + p | 0, Te - N >> 2 != e[p + 4 >> 2] - e[p >> 2] >> 3)
                                    break s;
                                  Xe = 0, Hi = 1, fr = 0;
                                  a: {
                                    if ((N | 0) != (Te | 0)) {
                                      o: {
                                        l: {
                                          c: {
                                            for (; ; ) {
                                              if (p = fr << 3, hs = jn[p + e[W + 68 >> 2] >> 3], bs = jn[p + e[W + 56 >> 2] >> 3], N = e[(fr << 2) + N >> 2], e[5996] = 0, N = Cf(50, N | 0, +bs, +hs, s | 0) | 0, Te = e[5996], e[5996] = 0, (Te | 0) == 1)
                                                break l;
                                              if (p = p + e[_r + e[W + 44 >> 2] >> 2] | 0, Te = e[p >> 2], p = e[p + 4 >> 2], vr = e[N + 4 >> 2], N = e[N >> 2], e[5996] = 0, uu(51, W + 124 | 0, N | 0, vr | 0, Te | 0, p | 0), p = e[5996], e[5996] = 0, (p | 0) != 1) {
                                                Te = e[W + 28 >> 2];
                                                d: {
                                                  if (Te >>> 0 > Xe >>> 0) {
                                                    e[Xe + 8 >> 2] = 0, e[Xe >> 2] = 0, e[Xe + 4 >> 2] = 0, e[Xe >> 2] = e[W + 124 >> 2], e[Xe + 4 >> 2] = e[W + 128 >> 2], e[Xe + 8 >> 2] = e[W + 132 >> 2], e[W + 24 >> 2] = Xe + 12;
                                                    break d;
                                                  }
                                                  f: {
                                                    N = e[W + 20 >> 2], vr = (Xe - N | 0) / 12 | 0, p = vr + 1 | 0;
                                                    u: {
                                                      if (p >>> 0 >= 357913942) {
                                                        e[5996] = 0, Nn(52);
                                                        break u;
                                                      }
                                                      if (Te = (Te - N | 0) / 12 | 0, ar = Te << 1, p = Te >>> 0 >= 178956970 ? 357913941 : p >>> 0 < ar >>> 0 ? ar : p, p >>> 0 < 357913942)
                                                        break f;
                                                      e[5996] = 0, Nn(35);
                                                    }
                                                    if (r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                      break e;
                                                    break c;
                                                  }
                                                  if (e[5996] = 0, ar = Sn(p, 12), Te = Mi(3, ar | 0) | 0, p = e[5996], e[5996] = 0, (p | 0) == 1)
                                                    break c;
                                                  p = Te + Sn(vr, 12) | 0, e[p >> 2] = e[W + 124 >> 2], e[p + 4 >> 2] = e[W + 128 >> 2], e[p + 8 >> 2] = e[W + 132 >> 2], e[W + 132 >> 2] = 0, e[W + 124 >> 2] = 0, e[W + 128 >> 2] = 0, Te = Te + ar | 0, vr = p + 12 | 0;
                                                  f: {
                                                    if ((N | 0) == (Xe | 0)) {
                                                      e[W + 28 >> 2] = Te, e[W + 24 >> 2] = vr, e[W + 20 >> 2] = p;
                                                      break f;
                                                    }
                                                    for (; p = p - 12 | 0, Xe = Xe - 12 | 0, e[p >> 2] = e[Xe >> 2], e[p + 4 >> 2] = e[Xe + 4 >> 2], e[p + 8 >> 2] = e[Xe + 8 >> 2], e[Xe + 8 >> 2] = 0, e[Xe >> 2] = 0, e[Xe + 4 >> 2] = 0, (N | 0) != (Xe | 0); )
                                                      ;
                                                    if (e[W + 28 >> 2] = Te, N = e[W + 24 >> 2], e[W + 24 >> 2] = vr, Xe = e[W + 20 >> 2], e[W + 20 >> 2] = p, (N | 0) == (Xe | 0))
                                                      break f;
                                                    for (; ; ) {
                                                      if (ar = N - 12 | 0, vr = e[ar >> 2], vr) {
                                                        if (hi = N - 8 | 0, p = e[hi >> 2], Te = vr, (p | 0) != (Te | 0)) {
                                                          for (; ; ) {
                                                            p = p - 32 | 0, N = e[p + 4 >> 2];
                                                            u: {
                                                              if (!N || (Te = e[N + 4 >> 2], e[N + 4 >> 2] = Te - 1, Te))
                                                                break u;
                                                              xi[e[e[N >> 2] + 8 >> 2]](N), ys(N);
                                                            }
                                                            if ((p | 0) == (vr | 0))
                                                              break;
                                                          }
                                                          Te = e[ar >> 2];
                                                        }
                                                        e[hi >> 2] = vr, Br(Te);
                                                      }
                                                      if (N = ar, (Xe | 0) == (N | 0))
                                                        break;
                                                    }
                                                  }
                                                  if (Xe && Br(Xe), Te = e[W + 124 >> 2], !Te)
                                                    break d;
                                                  if (p = e[W + 128 >> 2], N = Te, (p | 0) != (N | 0)) {
                                                    for (; ; ) {
                                                      p = p - 32 | 0, N = e[p + 4 >> 2];
                                                      f: {
                                                        if (!N || (Xe = e[N + 4 >> 2], e[N + 4 >> 2] = Xe - 1, Xe))
                                                          break f;
                                                        xi[e[e[N >> 2] + 8 >> 2]](N), ys(N);
                                                      }
                                                      if ((p | 0) == (Te | 0))
                                                        break;
                                                    }
                                                    N = e[W + 124 >> 2];
                                                  }
                                                  e[W + 128 >> 2] = Te, Br(N);
                                                }
                                                if (Xe = e[W + 24 >> 2], p = Xe - 12 | 0, Hi = Sn(e[p + 4 >> 2] - e[p >> 2] >> 5, Hi), fr = fr + 1 | 0, N = e[A >> 2], fr >>> 0 >= e[A + 4 >> 2] - N >> 2 >>> 0)
                                                  break o;
                                                continue;
                                              }
                                              break;
                                            }
                                            p = Hr() | 0;
                                            break n;
                                          }
                                          p = Hr() | 0, mu(W + 124 | 0);
                                          break n;
                                        }
                                        p = Hr() | 0;
                                        break n;
                                      }
                                      if (!Hi)
                                        break a;
                                    }
                                    vr = 0;
                                    o: {
                                      l: {
                                        c: {
                                          d: {
                                            for (; ; ) {
                                              if (Xe = e[W + 32 >> 2], e[A + 4 >> 2] != e[A >> 2])
                                                for (p = 0, Te = e[W + 20 >> 2], N = vr; fr = Sn(p, 12), ar = fr + Te | 0, Te = e[ar >> 2], e[(p << 2) + Xe >> 2] = Te + ((N >>> 0) % (e[ar + 4 >> 2] - Te >> 5 >>> 0) << 5), ar = N, Te = e[W + 20 >> 2], N = fr + Te | 0, N = (ar >>> 0) / (e[N + 4 >> 2] - e[N >> 2] >> 5 >>> 0) | 0, p = p + 1 | 0, p >>> 0 < e[A + 4 >> 2] - e[A >> 2] >> 2 >>> 0; )
                                                  ;
                                              if (e[W + 108 >> 2] = 0, e[W + 100 >> 2] = 0, e[W + 104 >> 2] = 0, p = Xe, _r = e[W + 36 >> 2], (p | 0) != (_r | 0)) {
                                                f: {
                                                  for (; ; ) {
                                                    u: {
                                                      fr = e[Xe >> 2], p = e[W + 104 >> 2];
                                                      g: {
                                                        if ((p | 0) != e[W + 108 >> 2]) {
                                                          e[p >> 2] = e[fr >> 2], N = e[fr + 4 >> 2], e[p + 4 >> 2] = N, N && (e[N + 4 >> 2] = e[N + 4 >> 2] + 1), e[W + 104 >> 2] = p + 8;
                                                          break g;
                                                        }
                                                        A: {
                                                          Te = e[W + 100 >> 2], N = p - Te | 0, hi = N >> 3, ar = hi + 1 | 0;
                                                          p: {
                                                            if (ar >>> 0 >= 536870912) {
                                                              e[5996] = 0, Nn(59);
                                                              break p;
                                                            }
                                                            if (mi = N >> 2, N = N >>> 0 >= 2147483640 ? 536870911 : ar >>> 0 < mi >>> 0 ? mi : ar, N >>> 0 < 536870912)
                                                              break A;
                                                            e[5996] = 0, Nn(35);
                                                          }
                                                          if (r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                            break e;
                                                          p = Hr() | 0;
                                                          break o;
                                                        }
                                                        if (e[5996] = 0, mi = N << 3, ar = Mi(3, mi | 0) | 0, N = e[5996], e[5996] = 0, (N | 0) == 1)
                                                          break u;
                                                        N = ar + (hi << 3) | 0, e[N >> 2] = e[fr >> 2], fr = e[fr + 4 >> 2], e[N + 4 >> 2] = fr, fr && (e[fr + 4 >> 2] = e[fr + 4 >> 2] + 1, p = e[W + 104 >> 2]), fr = ar + mi | 0, ar = N + 8 | 0;
                                                        A: {
                                                          if ((p | 0) == (Te | 0)) {
                                                            e[W + 108 >> 2] = fr, e[W + 104 >> 2] = ar, e[W + 100 >> 2] = N;
                                                            break A;
                                                          }
                                                          for (; N = N - 8 | 0, p = p - 8 | 0, e[N >> 2] = e[p >> 2], e[N + 4 >> 2] = e[p + 4 >> 2], e[p >> 2] = 0, e[p + 4 >> 2] = 0, (p | 0) != (Te | 0); )
                                                            ;
                                                          if (e[W + 108 >> 2] = fr, p = e[W + 104 >> 2], e[W + 104 >> 2] = ar, Te = e[W + 100 >> 2], e[W + 100 >> 2] = N, (p | 0) == (Te | 0))
                                                            break A;
                                                          for (; ; ) {
                                                            p = p - 8 | 0, N = e[p + 4 >> 2];
                                                            p: {
                                                              if (!N || (fr = e[N + 4 >> 2], e[N + 4 >> 2] = fr - 1, fr))
                                                                break p;
                                                              xi[e[e[N >> 2] + 8 >> 2]](N), ys(N);
                                                            }
                                                            if ((p | 0) == (Te | 0))
                                                              break;
                                                          }
                                                        }
                                                        if (!Te)
                                                          break g;
                                                        Br(Te);
                                                      }
                                                      if (Xe = Xe + 4 | 0, (_r | 0) != (Xe | 0))
                                                        continue;
                                                      break f;
                                                    }
                                                    break;
                                                  }
                                                  p = Hr() | 0;
                                                  break o;
                                                }
                                                Xe = e[W + 36 >> 2], p = e[W + 32 >> 2];
                                              }
                                              if (e[5996] = 0, yc(63, W + 80 | 0, u | 0, p | 0, Xe | 0, 0), p = e[5996], e[5996] = 0, (p | 0) == 1 || (e[5996] = 0, Xe = Mi(3, 104) | 0, p = e[5996], e[5996] = 0, (p | 0) == 1))
                                                break l;
                                              e[Xe >> 2] = 7e3, e[Xe + 4 >> 2] = 0, e[Xe + 8 >> 2] = 0, mi = e[W + 100 >> 2], e[W + 112 >> 2] = mi, Ni = e[W + 104 >> 2], e[W + 116 >> 2] = Ni, ar = e[W + 108 >> 2], p = 0, e[W + 108 >> 2] = 0, e[W + 120 >> 2] = ar, e[W + 100 >> 2] = 0, e[W + 104 >> 2] = 0, N = e[m >> 2], _r = e[m + 4 >> 2];
                                              f: {
                                                if ((N | 0) == (_r | 0)) {
                                                  fr = 0, Te = 0;
                                                  break f;
                                                }
                                                if (hi = _r - N | 0, (hi | 0) < 0) {
                                                  if (e[5996] = 0, Nn(8), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                    break e;
                                                  p = Hr() | 0;
                                                  break c;
                                                }
                                                if (e[5996] = 0, fr = Mi(3, hi | 0) | 0, p = e[5996], e[5996] = 0, (p | 0) == 1)
                                                  break d;
                                                if (Ln = _r + (N ^ -1) | 0, Te = 0, p = fr, _n = hi & 7, _n)
                                                  for (; _[p | 0] = me[N | 0], p = p + 1 | 0, N = N + 1 | 0, Te = Te + 1 | 0, (_n | 0) != (Te | 0); )
                                                    ;
                                                if (Te = fr + hi | 0, Ln >>> 0 < 7)
                                                  break f;
                                                for (; _[p | 0] = me[N | 0], _[p + 1 | 0] = me[N + 1 | 0], _[p + 2 | 0] = me[N + 2 | 0], _[p + 3 | 0] = me[N + 3 | 0], _[p + 4 | 0] = me[N + 4 | 0], _[p + 5 | 0] = me[N + 5 | 0], _[p + 6 | 0] = me[N + 6 | 0], _[p + 7 | 0] = me[N + 7 | 0], p = p + 8 | 0, N = N + 8 | 0, (_r | 0) != (N | 0); )
                                                  ;
                                                ar = e[W + 120 >> 2], Ni = e[W + 116 >> 2], mi = e[W + 112 >> 2];
                                              }
                                              e[Xe + 12 >> 2] = u, e[Xe + 16 >> 2] = 0, e[Xe + 20 >> 2] = 0, e[Xe + 24 >> 2] = 0, e[Xe + 28 >> 2] = 0, e[Xe + 52 >> 2] = ar, e[Xe + 48 >> 2] = Ni, hi = Xe + 44 | 0, e[hi >> 2] = mi, e[Xe + 40 >> 2] = Te, e[Xe + 36 >> 2] = p, e[Xe + 32 >> 2] = fr, e[W + 120 >> 2] = 0, e[W + 112 >> 2] = 0, e[W + 116 >> 2] = 0, e[5996] = 0, Te = Xe + 12 | 0, ji(86, Xe + 56 | 0, Te | 0), p = e[5996], e[5996] = 0;
                                              f: {
                                                if ((p | 0) == 1 || (e[5996] = 0, ji(87, Xe + 76 | 0, Te | 0), p = e[5996], e[5996] = 0, (p | 0) == 1) || (e[5996] = 0, p = Mi(88, Te | 0) | 0, N = e[5996], e[5996] = 0, (N | 0) == 1))
                                                  break f;
                                                if (e[Xe + 92 >> 2] = p, N = 0, ar = 0, fr = e[Xe + 44 >> 2], p = fr, _r = e[Xe + 48 >> 2], (p | 0) != (_r | 0)) {
                                                  for (; N = e[e[p >> 2] + 84 >> 2] + N | 0, p = p + 8 | 0, (_r | 0) != (p | 0); )
                                                    ;
                                                  ar = e[e[fr >> 2] + 80 >> 2];
                                                }
                                                if (p = e[Xe + 16 >> 2], mi = e[Xe + 12 >> 2], Ni = e[Xe + 20 >> 2], Ln = e[Xe + 24 >> 2], e[5996] = 0, p = za(89, mi | 0, ar | 0, N | 0, p | 0, _r - fr >> 3, (Ln - Ni | 0) / 12 | 0) | 0, N = e[5996], e[5996] = 0, (N | 0) == 1 || (e[Xe + 96 >> 2] = p, e[5996] = 0, e[W + 140 >> 2] = Te, gs(90, W + 124 | 0, Te | 0, W + 140 | 0), p = e[5996], e[5996] = 0, (p | 0) == 1))
                                                  break f;
                                                if (p = me[W + 136 | 0], p && ft(e[W + 128 >> 2]), _[Xe + 100 | 0] = p ^ 1, e[W + 128 >> 2] = Xe, e[W + 124 >> 2] = Te, e[5996] = 0, p = e[W + 128 >> 2], e[W + 8 >> 2] = e[W + 124 >> 2], e[W + 12 >> 2] = p, gs(61, r | 0, W + 80 | 0, W + 8 | 0), p = e[5996], e[5996] = 0, (p | 0) == 1)
                                                  break l;
                                                if (N = e[W + 100 >> 2], N) {
                                                  if (p = e[W + 104 >> 2], (N | 0) != (p | 0)) {
                                                    for (; ; ) {
                                                      p = p - 8 | 0, Te = e[p + 4 >> 2];
                                                      u: {
                                                        if (!Te || (Xe = e[Te + 4 >> 2], e[Te + 4 >> 2] = Xe - 1, Xe))
                                                          break u;
                                                        xi[e[e[Te >> 2] + 8 >> 2]](Te), ys(Te);
                                                      }
                                                      if ((p | 0) == (N | 0))
                                                        break;
                                                    }
                                                    N = e[W + 100 >> 2];
                                                  }
                                                  Br(N);
                                                }
                                                if (vr = vr + 1 | 0, (Hi | 0) != (vr | 0))
                                                  continue;
                                                break a;
                                              }
                                              break;
                                            }
                                            p = Hr() | 0, Uo(hi), r = e[Xe + 32 >> 2], r && (e[Xe + 36 >> 2] = r, Br(r)), ea(Xe + 20 | 0);
                                            break c;
                                          }
                                          p = Hr() | 0;
                                        }
                                        Uo(W + 112 | 0), Br(Xe);
                                        break o;
                                      }
                                      p = Hr() | 0;
                                    }
                                    Uo(W + 100 | 0);
                                    break n;
                                  }
                                  if (Te = e[W + 20 >> 2], Te) {
                                    if (p = e[W + 24 >> 2], (Te | 0) != (p | 0)) {
                                      for (; ; ) {
                                        if (fr = p - 12 | 0, Xe = e[fr >> 2], Xe) {
                                          if (vr = p - 8 | 0, p = e[vr >> 2], N = Xe, (p | 0) != (N | 0)) {
                                            for (; ; ) {
                                              p = p - 32 | 0, N = e[p + 4 >> 2];
                                              a: {
                                                if (!N || (ar = e[N + 4 >> 2], e[N + 4 >> 2] = ar - 1, ar))
                                                  break a;
                                                xi[e[e[N >> 2] + 8 >> 2]](N), ys(N);
                                              }
                                              if ((p | 0) == (Xe | 0))
                                                break;
                                            }
                                            N = e[fr >> 2];
                                          }
                                          e[vr >> 2] = Xe, Br(N);
                                        }
                                        if (p = fr, (Te | 0) == (p | 0))
                                          break;
                                      }
                                      Te = e[W + 20 >> 2];
                                    }
                                    Br(Te);
                                  }
                                  if (Ji = Ji + 1 | 0, p = e[W + 44 >> 2], Ji >>> 0 < (e[W + 48 >> 2] - p | 0) / 12 >>> 0)
                                    continue;
                                  break t;
                                }
                                break;
                              }
                              if (e[5996] = 0, Vs(44, 5170, 1900, 642, 2497), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                break e;
                              p = Hr() | 0;
                            }
                            Nc(W + 20 | 0);
                            break i;
                          }
                          p = Hr() | 0;
                        }
                        r = e[W + 32 >> 2], r && Br(r), Xf(W + 44 | 0);
                        break r;
                      }
                      p = Hr() | 0;
                    }
                    ya(W + 56 | 0), Jn(p | 0), Oi();
                  }
                  if (r = e[W + 32 >> 2], r && (Br(r), p = e[W + 44 >> 2]), p) {
                    if (N = p, Te = e[W + 48 >> 2], (Te | 0) != (p | 0)) {
                      for (; r = Te - 12 | 0, s = e[r >> 2], s && (e[Te - 8 >> 2] = s, Br(s)), Te = r, (Te | 0) != (p | 0); )
                        ;
                      N = e[W + 44 >> 2];
                    }
                    e[W + 48 >> 2] = p, Br(N);
                  }
                  r = e[W + 68 >> 2], r && (e[W + 72 >> 2] = r, Br(r)), r = e[W + 56 >> 2], r && (e[W + 60 >> 2] = r, Br(r)), Jr = W + 144 | 0;
                  return;
                }
                Oi();
              }
              function rg(r, s, u, A, m, p, N, W, Te) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0, m = m | 0, p = p | 0, N = N | 0, W = W | 0, Te = Te | 0;
                var Xe = 0, fr = 0, ar = 0, vr = 0, _r = 0, hi = 0, mi = 0, Ni = 0, Hi = 0, Ji = 0;
                Xe = Jr - 208 | 0, Jr = Xe;
                e: {
                  t: {
                    r: {
                      i: {
                        n: {
                          s: {
                            a: {
                              o: {
                                l: {
                                  c: {
                                    d: {
                                      f: {
                                        u: {
                                          g: {
                                            A: {
                                              p: {
                                                m: {
                                                  k: {
                                                    N: {
                                                      S: {
                                                        T: {
                                                          v: {
                                                            w: {
                                                              E: {
                                                                h: {
                                                                  R: {
                                                                    if (fr = Fa(r), fr >>> 0 >= 2147483632) {
                                                                      if (e[5996] = 0, Nn(2), r = e[5996], e[5996] = 0, (r | 0) == 1)
                                                                        break R;
                                                                      break e;
                                                                    }
                                                                    I: {
                                                                      if (fr >>> 0 <= 10) {
                                                                        _[Xe + 171 | 0] = fr, _r = Xe + 160 | 0;
                                                                        break I;
                                                                      }
                                                                      if (e[5996] = 0, vr = (fr | 15) + 1 | 0, _r = Mi(3, vr | 0) | 0, ar = e[5996], e[5996] = 0, (ar | 0) == 1)
                                                                        break R;
                                                                      e[Xe + 160 >> 2] = _r, e[Xe + 164 >> 2] = fr, e[Xe + 168 >> 2] = vr | -2147483648;
                                                                    }
                                                                    _[so(_r, r, fr) + fr | 0] = 0, ar = e[Xe + 160 >> 2], r = me[Xe + 171 | 0], mi = r << 24 >> 24, fr = (mi | 0) < 0, hi = fr ? ar : Xe + 160 | 0, Hi = fr ? e[Xe + 164 >> 2] : r, fr = hi + Hi | 0, _r = -1;
                                                                    I: {
                                                                      for (; ; ) {
                                                                        if ((fr | 0) == (hi | 0))
                                                                          break I;
                                                                        if (fr = fr - 1 | 0, vr = me[fr | 0], Ji = vr >>> 0 <= 63, r = vr & 31, (vr & 63) >>> 0 >= 32 ? (vr = 1 << r, r = 0) : (Ni = 1 << r, vr = Ni - 1 & 1 >>> 32 - r, r = Ni), r = r & 9728, !(Ji & (vr & 1 | (r | 0) != 0)))
                                                                          break;
                                                                      }
                                                                      _r = fr - hi | 0;
                                                                    }
                                                                    if (r = _r + 1 | 0, r >>> 0 > Hi >>> 0) {
                                                                      if (e[5996] = 0, Nn(108), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                        break e;
                                                                      fr = Os(22864) | 0, r = yo;
                                                                      break f;
                                                                    }
                                                                    I: {
                                                                      if ((mi | 0) < 0) {
                                                                        e[Xe + 164 >> 2] = r;
                                                                        break I;
                                                                      }
                                                                      _[Xe + 171 | 0] = r, ar = Xe + 160 | 0;
                                                                    }
                                                                    _[r + ar | 0] = 0, e[Xe + 152 >> 2] = 0, e[Xe + 156 >> 2] = 0;
                                                                    I: {
                                                                      if (_[Xe + 171 | 0] >= 0) {
                                                                        e[Xe + 144 >> 2] = e[Xe + 168 >> 2], r = e[Xe + 164 >> 2], e[Xe + 136 >> 2] = e[Xe + 160 >> 2], e[Xe + 140 >> 2] = r;
                                                                        break I;
                                                                      }
                                                                      if (e[5996] = 0, gs(40, Xe + 136 | 0, e[Xe + 160 >> 2], e[Xe + 164 >> 2]), r = e[5996], e[5996] = 0, (r | 0) == 1)
                                                                        break h;
                                                                    }
                                                                    if (e[5996] = 0, r = Xe + 172 | 0, ji(109, r | 0, Xe + 136 | 0), fr = e[5996], e[5996] = 0, (fr | 0) == 1)
                                                                      break E;
                                                                    if (vr = r, r = _[Xe + 183 | 0], fr = (r | 0) < 0, e[Xe + 104 >> 2] = fr ? e[Xe + 172 >> 2] : vr, e[Xe + 108 >> 2] = fr ? e[Xe + 176 >> 2] : r & 255, e[5996] = 0, r = e[Xe + 108 >> 2], e[Xe + 8 >> 2] = e[Xe + 104 >> 2], e[Xe + 12 >> 2] = r, ji(140, Xe + 16 | 0, Xe + 8 | 0), r = e[5996], e[5996] = 0, (r | 0) == 1)
                                                                      break w;
                                                                    r = e[Xe + 20 >> 2], e[Xe + 156 >> 2] = r, fr = e[Xe + 16 >> 2], e[Xe + 152 >> 2] = fr, _[Xe + 183 | 0] < 0 && Br(e[Xe + 172 >> 2]), _[Xe + 147 | 0] < 0 && Br(e[Xe + 136 >> 2]);
                                                                    I: {
                                                                      if (!fr || (_r = e[fr + 80 >> 2], !_r | Ls[fr + 84 >> 2] > 3600))
                                                                        break I;
                                                                      if (e[5996] = 0, vr = pi(54, 3557, 1) | 0, ar = e[5996], e[5996] = 0, (ar | 0) == 1)
                                                                        break T;
                                                                      if (!((_r ^ -1) & vr))
                                                                        break k;
                                                                    }
                                                                    if (e[5996] = 0, p = Mi(3, 32) | 0, N = e[5996], e[5996] = 0, (N | 0) == 1)
                                                                      break S;
                                                                    if (_[p + 16 | 0] = 0, N = me[2571] | me[2572] << 8 | (me[2573] << 16 | me[2574] << 24), W = me[2567] | me[2568] << 8 | (me[2569] << 16 | me[2570] << 24), _[p + 8 | 0] = W, _[p + 9 | 0] = W >>> 8, _[p + 10 | 0] = W >>> 16, _[p + 11 | 0] = W >>> 24, _[p + 12 | 0] = N, _[p + 13 | 0] = N >>> 8, _[p + 14 | 0] = N >>> 16, _[p + 15 | 0] = N >>> 24, N = me[2563] | me[2564] << 8 | (me[2565] << 16 | me[2566] << 24), W = me[2559] | me[2560] << 8 | (me[2561] << 16 | me[2562] << 24), _[p | 0] = W, _[p + 1 | 0] = W >>> 8, _[p + 2 | 0] = W >>> 16, _[p + 3 | 0] = W >>> 24, _[p + 4 | 0] = N, _[p + 5 | 0] = N >>> 8, _[p + 6 | 0] = N >>> 16, _[p + 7 | 0] = N >>> 24, N = ((u | 0) >= 17 ? 17 : u) - 1 | 0, _[so(s, p, N) + N | 0] = 0, Br(p), e[5996] = 0, p = Mi(3, 32) | 0, N = e[5996], e[5996] = 0, (N | 0) == 1)
                                                                      break N;
                                                                    _[p + 16 | 0] = 0, u = me[2571] | me[2572] << 8 | (me[2573] << 16 | me[2574] << 24), s = p, p = me[2567] | me[2568] << 8 | (me[2569] << 16 | me[2570] << 24), _[s + 8 | 0] = p, _[s + 9 | 0] = p >>> 8, _[s + 10 | 0] = p >>> 16, _[s + 11 | 0] = p >>> 24, _[s + 12 | 0] = u, _[s + 13 | 0] = u >>> 8, _[s + 14 | 0] = u >>> 16, _[s + 15 | 0] = u >>> 24, u = me[2563] | me[2564] << 8 | (me[2565] << 16 | me[2566] << 24), p = me[2559] | me[2560] << 8 | (me[2561] << 16 | me[2562] << 24), _[s | 0] = p, _[s + 1 | 0] = p >>> 8, _[s + 2 | 0] = p >>> 16, _[s + 3 | 0] = p >>> 24, _[s + 4 | 0] = u, _[s + 5 | 0] = u >>> 8, _[s + 6 | 0] = u >>> 16, _[s + 7 | 0] = u >>> 24, u = ((m | 0) >= 17 ? 17 : m) - 1 | 0, _[so(A, s, u) + u | 0] = 0, Br(s);
                                                                    break m;
                                                                  }
                                                                  fr = Os(22864) | 0, r = yo;
                                                                  break d;
                                                                }
                                                                fr = Os(22864) | 0, r = yo;
                                                                break u;
                                                              }
                                                              fr = Os(22864) | 0, r = yo;
                                                              break v;
                                                            }
                                                            if (fr = Os(22864) | 0, r = yo, _[Xe + 183 | 0] >= 0)
                                                              break v;
                                                            Br(e[Xe + 172 >> 2]);
                                                          }
                                                          if (_[Xe + 147 | 0] >= 0)
                                                            break u;
                                                          Br(e[Xe + 136 >> 2]);
                                                          break u;
                                                        }
                                                        fr = Os(22864) | 0, r = yo;
                                                        break u;
                                                      }
                                                      fr = Os(22864) | 0, r = yo;
                                                      break u;
                                                    }
                                                    fr = Os(22864) | 0, r = yo;
                                                    break u;
                                                  }
                                                  r = e[fr + 84 >> 2], e[5996] = 0, _r = Xe + 60 | 0, ji(115, _r | 0, r | 0), r = e[5996], e[5996] = 0;
                                                  k: {
                                                    N: {
                                                      S: {
                                                        T: {
                                                          v: {
                                                            w: {
                                                              E: {
                                                                h: {
                                                                  R: {
                                                                    I: {
                                                                      B: {
                                                                        x: {
                                                                          b: {
                                                                            if ((r | 0) != 1) {
                                                                              if (e[5996] = 0, r = xn(99, _r | 0, 0, 5546) | 0, _r = e[5996], e[5996] = 0, (_r | 0) == 1)
                                                                                break b;
                                                                              if (e[Xe + 80 >> 2] = e[r + 8 >> 2], _r = e[r + 4 >> 2], e[Xe + 72 >> 2] = e[r >> 2], e[Xe + 76 >> 2] = _r, e[r >> 2] = 0, e[r + 4 >> 2] = 0, e[r + 8 >> 2] = 0, e[5996] = 0, _r = pi(97, Xe + 72 | 0, 3581) | 0, vr = e[5996], e[5996] = 0, (vr | 0) == 1)
                                                                                break x;
                                                                              if (e[Xe + 96 >> 2] = e[_r + 8 >> 2], vr = e[_r + 4 >> 2], e[Xe + 88 >> 2] = e[_r >> 2], e[Xe + 92 >> 2] = vr, e[_r >> 2] = 0, e[_r + 4 >> 2] = 0, e[_r + 8 >> 2] = 0, e[5996] = 0, vr = Xe + 172 | 0, ji(141, vr | 0, Xe + 152 | 0), ar = e[5996], e[5996] = 0, (ar | 0) == 1)
                                                                                break B;
                                                                              if (e[5996] = 0, Ni = vr, vr = me[Xe + 183 | 0], ar = vr << 24 >> 24 < 0, vr = xn(100, Xe + 88 | 0, (ar ? e[Xe + 172 >> 2] : Ni) | 0, (ar ? e[Xe + 176 >> 2] : vr) | 0) | 0, ar = e[5996], e[5996] = 0, (ar | 0) == 1)
                                                                                break I;
                                                                              if (e[Xe + 112 >> 2] = e[vr + 8 >> 2], ar = e[vr + 4 >> 2], e[Xe + 104 >> 2] = e[vr >> 2], e[Xe + 108 >> 2] = ar, e[vr >> 2] = 0, e[vr + 4 >> 2] = 0, e[vr + 8 >> 2] = 0, e[5996] = 0, ar = pi(97, Xe + 104 | 0, 3570) | 0, hi = e[5996], e[5996] = 0, (hi | 0) == 1)
                                                                                break R;
                                                                              if (e[Xe + 128 >> 2] = e[ar + 8 >> 2], hi = e[ar + 4 >> 2], e[Xe + 120 >> 2] = e[ar >> 2], e[Xe + 124 >> 2] = hi, e[ar >> 2] = 0, e[ar + 4 >> 2] = 0, e[ar + 8 >> 2] = 0, _[Xe + 183 | 0] < 0 && Br(e[Xe + 172 >> 2]), _[vr + 11 | 0] < 0 && Br(e[vr >> 2]), _[_r + 11 | 0] < 0 && Br(e[_r >> 2]), _[r + 11 | 0] < 0 && Br(e[r >> 2]), _r = e[Xe + 120 >> 2], r = me[Xe + 131 | 0], vr = r << 24 >> 24, ar = (vr | 0) < 0, Ni = ar ? _r : Xe + 120 | 0, r = ar ? e[Xe + 124 >> 2] : r, ar = u - 1 | 0, r = (r | 0) < (ar | 0) ? r : ar, _[so(s, Ni, r) + r | 0] = 0, e[5996] = 0, ar = Xe + 172 | 0, ji(117, ar | 0, fr | 0), r = e[5996], e[5996] = 0, (r | 0) == 1)
                                                                                break T;
                                                                              if (e[Xe + 44 >> 2] = e[Xe + 200 >> 2], r = e[Xe + 196 >> 2], e[Xe + 36 >> 2] = e[Xe + 192 >> 2], e[Xe + 40 >> 2] = r, r = e[Xe + 188 >> 2], e[Xe + 28 >> 2] = e[Xe + 184 >> 2], e[Xe + 32 >> 2] = r, r = e[Xe + 180 >> 2], e[Xe + 20 >> 2] = e[Xe + 176 >> 2], e[Xe + 24 >> 2] = r, r = e[Xe + 172 >> 2], e[Xe + 16 >> 2] = r, e[5996] = 0, hi = r >>> 0 < 29, mi = hi ? Xe + 20 | 0 : e[Xe + 24 >> 2], e[Xe + 172 >> 2] = mi, Hi = Xe + 48 | 0, Vs(102, Hi | 0, ar | 0, mi + (hi ? r : r - 29 | 0) | 0, 0), r = e[5996], e[5996] = 0, (r | 0) == 1)
                                                                                break S;
                                                                              if (r = e[Xe + 48 >> 2], ar = me[Xe + 59 | 0], hi = ar << 24 >> 24, mi = (hi | 0) < 0, Ni = mi ? r : Hi, ar = mi ? e[Xe + 52 >> 2] : ar, mi = m - 1 | 0, ar = (ar | 0) < (mi | 0) ? ar : mi, _[so(A, Ni, ar) + ar | 0] = 0, (hi | 0) < 0 && Br(r), Ls[Xe + 16 >> 2] >= 29 && (Br(e[Xe + 24 >> 2]), fr = e[Xe + 152 >> 2]), r = e[fr + 80 >> 2], !r | Ls[fr + 84 >> 2] > 3600 | (e[fr + 52 >> 2] + e[fr + 44 >> 2] >>> 0 > 201 | Ls[fr + 68 >> 2] > 100))
                                                                                break N;
                                                                              if (e[5996] = 0, ar = pi(54, 2049, 1) | 0, hi = e[5996], e[5996] = 0, (hi | 0) == 1)
                                                                                break p;
                                                                              if ((r ^ -1) & ar)
                                                                                break N;
                                                                              if (r = e[fr + 80 >> 2], e[5996] = 0, ar = pi(54, 2165, 1) | 0, hi = e[5996], e[5996] = 0, (hi | 0) == 1)
                                                                                break p;
                                                                              if (me[fr + 88 | 0] | (r ^ -1) & ar)
                                                                                break N;
                                                                              _[Xe + 176 | 0] = 0, e[Xe + 172 >> 2] = 1702195828, _[Xe + 183 | 0] = 4, r = ((Te | 0) >= 5 ? 5 : Te) - 1 | 0, _[so(W, Xe + 172 | 0, r) + r | 0] = 0;
                                                                              break k;
                                                                            }
                                                                            fr = Os(22864) | 0, r = yo;
                                                                            break u;
                                                                          }
                                                                          fr = Os(22864) | 0, r = yo;
                                                                          break v;
                                                                        }
                                                                        fr = Os(22864) | 0, r = yo;
                                                                        break w;
                                                                      }
                                                                      fr = Os(22864) | 0, r = yo;
                                                                      break E;
                                                                    }
                                                                    fr = Os(22864) | 0, r = yo;
                                                                    break h;
                                                                  }
                                                                  if (fr = Os(22864) | 0, r = yo, _[Xe + 115 | 0] >= 0)
                                                                    break h;
                                                                  Br(e[Xe + 104 >> 2]);
                                                                }
                                                                if (_[Xe + 183 | 0] >= 0)
                                                                  break E;
                                                                Br(e[Xe + 172 >> 2]);
                                                              }
                                                              if (_[Xe + 99 | 0] >= 0)
                                                                break w;
                                                              Br(e[Xe + 88 >> 2]);
                                                            }
                                                            if (_[Xe + 83 | 0] >= 0)
                                                              break v;
                                                            Br(e[Xe + 72 >> 2]);
                                                          }
                                                          if (_[Xe + 71 | 0] >= 0)
                                                            break u;
                                                          Br(e[Xe + 60 >> 2]);
                                                          break u;
                                                        }
                                                        fr = Os(22864) | 0;
                                                        break A;
                                                      }
                                                      if (fr = Os(22864) | 0, r = yo, Ls[Xe + 16 >> 2] < 29)
                                                        break g;
                                                      Br(e[Xe + 24 >> 2]);
                                                      break g;
                                                    }
                                                    _[Xe + 176 | 0] = me[2354], _[Xe + 183 | 0] = 5, _[Xe + 177 | 0] = 0, e[Xe + 172 >> 2] = me[2350] | me[2351] << 8 | (me[2352] << 16 | me[2353] << 24), r = ((Te | 0) >= 6 ? 6 : Te) - 1 | 0, _[so(W, Xe + 172 | 0, r) + r | 0] = 0;
                                                  }
                                                  if (e[5996] = 0, r = Mi(118, fr | 0) | 0, W = e[5996], e[5996] = 0, (W | 0) == 1)
                                                    break p;
                                                  k: {
                                                    if (r) {
                                                      _[Xe + 176 | 0] = 0, e[Xe + 172 >> 2] = 1702195828, _[Xe + 183 | 0] = 4, r = ((N | 0) >= 5 ? 5 : N) - 1 | 0, _[so(p, Xe + 172 | 0, r) + r | 0] = 0;
                                                      break k;
                                                    }
                                                    _[Xe + 176 | 0] = me[2354], _[Xe + 183 | 0] = 5, _[Xe + 177 | 0] = 0, e[Xe + 172 >> 2] = me[2350] | me[2351] << 8 | (me[2352] << 16 | me[2353] << 24), r = ((N | 0) >= 6 ? 6 : N) - 1 | 0, _[so(p, Xe + 172 | 0, r) + r | 0] = 0;
                                                  }
                                                  (vr | 0) < 0 && Br(_r), r = e[Xe + 156 >> 2];
                                                }
                                                m: {
                                                  if (!r || (s = e[r + 4 >> 2], e[r + 4 >> 2] = s - 1, s))
                                                    break m;
                                                  xi[e[e[r >> 2] + 8 >> 2]](r), ys(r);
                                                }
                                                if (_[Xe + 171 | 0] >= 0)
                                                  break c;
                                                Br(e[Xe + 160 >> 2]);
                                                break c;
                                              }
                                              fr = Os(22864) | 0;
                                            }
                                            r = yo;
                                          }
                                          if ((vr | 0) >= 0)
                                            break u;
                                          Br(_r);
                                        }
                                        Lo(Xe + 152 | 0);
                                      }
                                      if (_[Xe + 171 | 0] >= 0)
                                        break d;
                                      Br(e[Xe + 160 >> 2]);
                                    }
                                    if ((Ml(22864) | 0) != (r | 0))
                                      break r;
                                    if (r = Cu(fr | 0) | 0, r = xi[e[e[r >> 2] + 8 >> 2]](r) | 0, e[5996] = 0, N = pi(30, Xe + 120 | 0, r | 0) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1)
                                      break l;
                                    if (e[5996] = 0, r = xn(99, N | 0, 0, 5474) | 0, p = e[5996], e[5996] = 0, (p | 0) == 1)
                                      break o;
                                    if (e[Xe + 168 >> 2] = e[r + 8 >> 2], p = e[r + 4 >> 2], e[Xe + 160 >> 2] = e[r >> 2], e[Xe + 164 >> 2] = p, e[r >> 2] = 0, e[r + 4 >> 2] = 0, e[r + 8 >> 2] = 0, e[5996] = 0, p = pi(97, Xe + 160 | 0, 2611) | 0, W = e[5996], e[5996] = 0, (W | 0) == 1)
                                      break a;
                                    e[Xe + 24 >> 2] = e[p + 8 >> 2], N = e[p + 4 >> 2], e[Xe + 16 >> 2] = e[p >> 2], e[Xe + 20 >> 2] = N, e[p >> 2] = 0, e[p + 4 >> 2] = 0, e[p + 8 >> 2] = 0, fr = s, s = e[Xe + 16 >> 2], N = me[Xe + 27 | 0], W = N << 24 >> 24, Te = (W | 0) < 0, N = Te ? e[Xe + 20 >> 2] : N, u = u - 1 | 0, u = (u | 0) > (N | 0) ? N : u, _[so(fr, Te ? s : Xe + 16 | 0, u) + u | 0] = 0;
                                    d: {
                                      if ((W | 0) >= 0 || (Br(s), _[p + 11 | 0] >= 0))
                                        break d;
                                      Br(e[p >> 2]);
                                    }
                                    if (_[r + 11 | 0] < 0 && Br(e[r >> 2]), e[5996] = 0, r = pi(30, Xe + 16 | 0, 5575) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1)
                                      break n;
                                    N = A, s = e[r >> 2], u = me[r + 11 | 0], A = u << 24 >> 24, p = (A | 0) < 0, W = p ? s : r, r = p ? e[r + 4 >> 2] : u, u = m - 1 | 0, r = (r | 0) < (u | 0) ? r : u, _[so(N, W, r) + r | 0] = 0, (A | 0) < 0 && Br(s), ef();
                                  }
                                  Jr = Xe + 208 | 0;
                                  return;
                                }
                                fr = Hr() | 0;
                                break i;
                              }
                              fr = Hr() | 0;
                              break s;
                            }
                            if (fr = Hr() | 0, _[Xe + 171 | 0] >= 0)
                              break s;
                            Br(e[Xe + 160 >> 2]);
                          }
                          if (_[N + 11 | 0] >= 0)
                            break i;
                          Br(e[N >> 2]);
                          break i;
                        }
                        fr = Hr() | 0;
                      }
                      if (e[5996] = 0, Nn(110), r = e[5996], e[5996] = 0, (r | 0) == 1)
                        break t;
                    }
                    Jn(fr | 0), Oi();
                  }
                  Os(0) | 0, Na(), Oi();
                }
                Oi();
              }
              function ah(r, s, u, A, m) {
                var p = 0, N = 0, W = 0, Te = 0, Xe = 0, fr = 0, ar = 0, vr = 0, _r = 0, hi = 0, mi = 0, Ni = 0, Hi = 0, Ji = 0, Ln = 0, _n = 0;
                W = Jr - 160 | 0, Jr = W, Mf(W + 48 | 0, u, jn[r + 16 >> 3], jn[r + 24 >> 3], 0, 0), e[5996] = 0, N = Mi(46, u | 0) | 0, p = e[5996], e[5996] = 0;
                e: {
                  t: {
                    r: {
                      if ((p | 0) != 1) {
                        if (e[W + 44 >> 2] = 0, e[W + 36 >> 2] = 0, e[W + 40 >> 2] = 0, _[W + 140 | 0] = 0, e[W + 136 >> 2] = W + 36, p = e[N + 4 >> 2], Xe = e[N >> 2], vr = p - Xe | 0, Te = (vr | 0) / 12 | 0, (p | 0) != (Xe | 0)) {
                          i: {
                            n: {
                              s: {
                                if (Te >>> 0 >= 357913942) {
                                  if (e[5996] = 0, Nn(47), r = e[5996], e[5996] = 0, (r | 0) == 1)
                                    break s;
                                  break e;
                                }
                                if (e[5996] = 0, p = Mi(3, vr | 0) | 0, Xe = e[5996], e[5996] = 0, (Xe | 0) == 1)
                                  break s;
                                if (e[W + 40 >> 2] = p, e[W + 36 >> 2] = p, e[W + 44 >> 2] = p + Sn(Te, 12), Te = e[N + 4 >> 2], N = e[N >> 2], e[5996] = 0, N = wa(48, W + 44 | 0, N | 0, Te | 0, p | 0) | 0, Te = e[5996], e[5996] = 0, (Te | 0) != 1)
                                  break i;
                                N = Hr() | 0, e[W + 40 >> 2] = p;
                                break n;
                              }
                              N = Hr() | 0;
                            }
                            ff(W + 136 | 0);
                            break r;
                          }
                          e[W + 40 >> 2] = N;
                        }
                        e[W + 32 >> 2] = 0, e[W + 24 >> 2] = 0, e[W + 28 >> 2] = 0, p = e[A + 4 >> 2], N = e[A >> 2], e[5996] = 0, ji(49, W + 24 | 0, p - N >> 2), p = e[5996], e[5996] = 0;
                        i: {
                          if ((p | 0) != 1) {
                            if (N = e[W + 40 >> 2], p = e[W + 36 >> 2], (N | 0) == (p | 0))
                              break t;
                            Ji = W + 112 | 0, N = p;
                            n: {
                              for (; ; ) {
                                s: {
                                  if (e[W + 20 >> 2] = 0, e[W + 12 >> 2] = 0, e[W + 16 >> 2] = 0, Te = e[A + 4 >> 2], p = e[A >> 2], _r = Sn(Hi, 12), N = _r + N | 0, Te - p >> 2 != e[N + 4 >> 2] - e[N >> 2] >> 3)
                                    break s;
                                  Xe = 0, hi = 1, ar = 0;
                                  a: {
                                    if ((p | 0) != (Te | 0)) {
                                      o: {
                                        l: {
                                          c: {
                                            for (; ; ) {
                                              if (N = ar << 3, Ln = jn[N + e[W + 60 >> 2] >> 3], _n = jn[N + e[W + 48 >> 2] >> 3], p = e[(ar << 2) + p >> 2], e[5996] = 0, p = Cf(50, p | 0, +_n, +Ln, s | 0) | 0, Te = e[5996], e[5996] = 0, (Te | 0) == 1)
                                                break l;
                                              if (N = N + e[_r + e[W + 36 >> 2] >> 2] | 0, Te = e[N >> 2], N = e[N + 4 >> 2], vr = e[p + 4 >> 2], p = e[p >> 2], e[5996] = 0, uu(51, W + 136 | 0, p | 0, vr | 0, Te | 0, N | 0), p = e[5996], e[5996] = 0, (p | 0) != 1) {
                                                Te = e[W + 20 >> 2];
                                                d: {
                                                  if (Te >>> 0 > Xe >>> 0) {
                                                    e[Xe + 8 >> 2] = 0, e[Xe >> 2] = 0, e[Xe + 4 >> 2] = 0, e[Xe >> 2] = e[W + 136 >> 2], e[Xe + 4 >> 2] = e[W + 140 >> 2], e[Xe + 8 >> 2] = e[W + 144 >> 2], e[W + 16 >> 2] = Xe + 12;
                                                    break d;
                                                  }
                                                  f: {
                                                    p = e[W + 12 >> 2], vr = (Xe - p | 0) / 12 | 0, N = vr + 1 | 0;
                                                    u: {
                                                      if (N >>> 0 >= 357913942) {
                                                        e[5996] = 0, Nn(52);
                                                        break u;
                                                      }
                                                      if (Te = (Te - p | 0) / 12 | 0, fr = Te << 1, N = Te >>> 0 >= 178956970 ? 357913941 : N >>> 0 < fr >>> 0 ? fr : N, N >>> 0 < 357913942)
                                                        break f;
                                                      e[5996] = 0, Nn(35);
                                                    }
                                                    if (r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                      break e;
                                                    break c;
                                                  }
                                                  if (e[5996] = 0, fr = Sn(N, 12), Te = Mi(3, fr | 0) | 0, N = e[5996], e[5996] = 0, (N | 0) == 1)
                                                    break c;
                                                  N = Te + Sn(vr, 12) | 0, e[N >> 2] = e[W + 136 >> 2], e[N + 4 >> 2] = e[W + 140 >> 2], e[N + 8 >> 2] = e[W + 144 >> 2], e[W + 144 >> 2] = 0, e[W + 136 >> 2] = 0, e[W + 140 >> 2] = 0, Te = Te + fr | 0, vr = N + 12 | 0;
                                                  f: {
                                                    if ((p | 0) == (Xe | 0)) {
                                                      e[W + 20 >> 2] = Te, e[W + 16 >> 2] = vr, e[W + 12 >> 2] = N;
                                                      break f;
                                                    }
                                                    for (; N = N - 12 | 0, Xe = Xe - 12 | 0, e[N >> 2] = e[Xe >> 2], e[N + 4 >> 2] = e[Xe + 4 >> 2], e[N + 8 >> 2] = e[Xe + 8 >> 2], e[Xe + 8 >> 2] = 0, e[Xe >> 2] = 0, e[Xe + 4 >> 2] = 0, (p | 0) != (Xe | 0); )
                                                      ;
                                                    if (e[W + 20 >> 2] = Te, p = e[W + 16 >> 2], e[W + 16 >> 2] = vr, Xe = e[W + 12 >> 2], e[W + 12 >> 2] = N, (p | 0) == (Xe | 0))
                                                      break f;
                                                    for (; ; ) {
                                                      if (fr = p - 12 | 0, vr = e[fr >> 2], vr) {
                                                        if (mi = p - 8 | 0, N = e[mi >> 2], Te = vr, (N | 0) != (Te | 0)) {
                                                          for (; ; ) {
                                                            N = N - 32 | 0, p = e[N + 4 >> 2];
                                                            u: {
                                                              if (!p || (Te = e[p + 4 >> 2], e[p + 4 >> 2] = Te - 1, Te))
                                                                break u;
                                                              xi[e[e[p >> 2] + 8 >> 2]](p), ys(p);
                                                            }
                                                            if ((N | 0) == (vr | 0))
                                                              break;
                                                          }
                                                          Te = e[fr >> 2];
                                                        }
                                                        e[mi >> 2] = vr, Br(Te);
                                                      }
                                                      if (p = fr, (Xe | 0) == (p | 0))
                                                        break;
                                                    }
                                                  }
                                                  if (Xe && Br(Xe), Te = e[W + 136 >> 2], !Te)
                                                    break d;
                                                  if (p = Te, N = e[W + 140 >> 2], (p | 0) != (N | 0)) {
                                                    for (; ; ) {
                                                      N = N - 32 | 0, p = e[N + 4 >> 2];
                                                      f: {
                                                        if (!p || (Xe = e[p + 4 >> 2], e[p + 4 >> 2] = Xe - 1, Xe))
                                                          break f;
                                                        xi[e[e[p >> 2] + 8 >> 2]](p), ys(p);
                                                      }
                                                      if ((N | 0) == (Te | 0))
                                                        break;
                                                    }
                                                    p = e[W + 136 >> 2];
                                                  }
                                                  e[W + 140 >> 2] = Te, Br(p);
                                                }
                                                if (Xe = e[W + 16 >> 2], p = Xe - 12 | 0, hi = Sn(e[p + 4 >> 2] - e[p >> 2] >> 5, hi), ar = ar + 1 | 0, p = e[A >> 2], ar >>> 0 >= e[A + 4 >> 2] - p >> 2 >>> 0)
                                                  break o;
                                                continue;
                                              }
                                              break;
                                            }
                                            N = Hr() | 0;
                                            break n;
                                          }
                                          N = Hr() | 0, mu(W + 136 | 0);
                                          break n;
                                        }
                                        N = Hr() | 0;
                                        break n;
                                      }
                                      if (!hi)
                                        break a;
                                    }
                                    vr = 0;
                                    o: {
                                      l: {
                                        c: {
                                          d: {
                                            f: {
                                              u: {
                                                for (; ; ) {
                                                  if (Xe = e[W + 24 >> 2], e[A + 4 >> 2] != e[A >> 2])
                                                    for (N = 0, Te = e[W + 12 >> 2], p = vr; fr = Sn(N, 12), ar = fr + Te | 0, Te = e[ar >> 2], e[(N << 2) + Xe >> 2] = Te + ((p >>> 0) % (e[ar + 4 >> 2] - Te >> 5 >>> 0) << 5), ar = p, Te = e[W + 12 >> 2], p = fr + Te | 0, p = (ar >>> 0) / (e[p + 4 >> 2] - e[p >> 2] >> 5 >>> 0) | 0, N = N + 1 | 0, N >>> 0 < e[A + 4 >> 2] - e[A >> 2] >> 2 >>> 0; )
                                                      ;
                                                  if (e[W + 100 >> 2] = 0, e[W + 92 >> 2] = 0, e[W + 96 >> 2] = 0, N = Xe, _r = e[W + 28 >> 2], (N | 0) != (_r | 0)) {
                                                    g: {
                                                      for (; ; ) {
                                                        A: {
                                                          fr = e[Xe >> 2], N = e[W + 96 >> 2];
                                                          p: {
                                                            if ((N | 0) != e[W + 100 >> 2]) {
                                                              e[N >> 2] = e[fr >> 2], p = e[fr + 4 >> 2], e[N + 4 >> 2] = p, p && (e[p + 4 >> 2] = e[p + 4 >> 2] + 1), e[W + 96 >> 2] = N + 8;
                                                              break p;
                                                            }
                                                            m: {
                                                              Te = e[W + 92 >> 2], p = N - Te | 0, mi = p >> 3, ar = mi + 1 | 0;
                                                              k: {
                                                                if (ar >>> 0 >= 536870912) {
                                                                  e[5996] = 0, Nn(59);
                                                                  break k;
                                                                }
                                                                if (Ni = p >> 2, p = p >>> 0 >= 2147483640 ? 536870911 : ar >>> 0 < Ni >>> 0 ? Ni : ar, p >>> 0 < 536870912)
                                                                  break m;
                                                                e[5996] = 0, Nn(35);
                                                              }
                                                              if (r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                                break e;
                                                              N = Hr() | 0;
                                                              break o;
                                                            }
                                                            if (e[5996] = 0, Ni = p << 3, ar = Mi(3, Ni | 0) | 0, p = e[5996], e[5996] = 0, (p | 0) == 1)
                                                              break A;
                                                            p = ar + (mi << 3) | 0, e[p >> 2] = e[fr >> 2], fr = e[fr + 4 >> 2], e[p + 4 >> 2] = fr, fr && (e[fr + 4 >> 2] = e[fr + 4 >> 2] + 1, N = e[W + 96 >> 2]), fr = ar + Ni | 0, ar = p + 8 | 0;
                                                            m: {
                                                              if ((N | 0) == (Te | 0)) {
                                                                e[W + 100 >> 2] = fr, e[W + 96 >> 2] = ar, e[W + 92 >> 2] = p;
                                                                break m;
                                                              }
                                                              for (; p = p - 8 | 0, N = N - 8 | 0, e[p >> 2] = e[N >> 2], e[p + 4 >> 2] = e[N + 4 >> 2], e[N >> 2] = 0, e[N + 4 >> 2] = 0, (N | 0) != (Te | 0); )
                                                                ;
                                                              if (e[W + 100 >> 2] = fr, N = e[W + 96 >> 2], e[W + 96 >> 2] = ar, Te = e[W + 92 >> 2], e[W + 92 >> 2] = p, (N | 0) == (Te | 0))
                                                                break m;
                                                              for (; ; ) {
                                                                N = N - 8 | 0, p = e[N + 4 >> 2];
                                                                k: {
                                                                  if (!p || (fr = e[p + 4 >> 2], e[p + 4 >> 2] = fr - 1, fr))
                                                                    break k;
                                                                  xi[e[e[p >> 2] + 8 >> 2]](p), ys(p);
                                                                }
                                                                if ((N | 0) == (Te | 0))
                                                                  break;
                                                              }
                                                            }
                                                            if (!Te)
                                                              break p;
                                                            Br(Te);
                                                          }
                                                          if (Xe = Xe + 4 | 0, (_r | 0) != (Xe | 0))
                                                            continue;
                                                          break g;
                                                        }
                                                        break;
                                                      }
                                                      N = Hr() | 0;
                                                      break o;
                                                    }
                                                    Xe = e[W + 28 >> 2], N = e[W + 24 >> 2];
                                                  }
                                                  if (e[5996] = 0, yc(63, W + 72 | 0, u | 0, N | 0, Xe | 0, 0), p = e[5996], e[5996] = 0, (p | 0) == 1 || (e[5996] = 0, Xe = Mi(3, 104) | 0, p = e[5996], e[5996] = 0, (p | 0) == 1))
                                                    break f;
                                                  e[Xe >> 2] = 7e3, e[Xe + 4 >> 2] = 0, e[Xe + 8 >> 2] = 0, e[W + 112 >> 2] = 0, e[W + 104 >> 2] = 0, e[W + 108 >> 2] = 0, e[W + 116 >> 2] = e[W + 92 >> 2], p = e[W + 100 >> 2], N = e[W + 96 >> 2], e[W + 100 >> 2] = 0, e[W + 120 >> 2] = N, e[W + 124 >> 2] = p, e[W + 92 >> 2] = 0, e[W + 96 >> 2] = 0, _[W + 132 | 0] = 0, e[W + 128 >> 2] = W + 104, fr = e[m + 4 >> 2], N = e[m >> 2], Te = fr - N | 0, p = (Te | 0) / 12 | 0;
                                                  g: {
                                                    if ((N | 0) != (fr | 0)) {
                                                      if (p >>> 0 >= 357913942) {
                                                        if (e[5996] = 0, Nn(41), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                          break e;
                                                        N = Hr() | 0;
                                                        break c;
                                                      }
                                                      if (e[5996] = 0, Te = Mi(3, Te | 0) | 0, ar = e[5996], e[5996] = 0, (ar | 0) == 1)
                                                        break g;
                                                      for (e[W + 108 >> 2] = Te, e[W + 104 >> 2] = Te, e[W + 112 >> 2] = Te + Sn(p, 12), e[W + 156 >> 2] = Te, e[W + 152 >> 2] = Te, _[W + 148 | 0] = 0, e[W + 136 >> 2] = Ji, e[W + 144 >> 2] = W + 156, e[W + 140 >> 2] = W + 152, p = Te; ; ) {
                                                        A: {
                                                          if (_[N + 11 | 0] >= 0) {
                                                            ar = e[N + 4 >> 2], e[p >> 2] = e[N >> 2], e[p + 4 >> 2] = ar, e[p + 8 >> 2] = e[N + 8 >> 2];
                                                            break A;
                                                          }
                                                          if (ar = e[N + 4 >> 2], _r = e[N >> 2], e[5996] = 0, gs(40, p | 0, _r | 0, ar | 0), p = e[5996], e[5996] = 0, (p | 0) == 1)
                                                            break d;
                                                          p = e[W + 156 >> 2];
                                                        }
                                                        if (p = p + 12 | 0, e[W + 156 >> 2] = p, N = N + 12 | 0, (fr | 0) == (N | 0))
                                                          break;
                                                      }
                                                      e[W + 108 >> 2] = p;
                                                    }
                                                    if (e[5996] = 0, fr = Fl(60, Xe + 12 | 0, u | 0, W + 116 | 0, W + 104 | 0, 0) | 0, p = e[5996], e[5996] = 0, (p | 0) == 1)
                                                      break u;
                                                    if (Te = e[W + 104 >> 2], Te) {
                                                      if (p = e[W + 108 >> 2], N = Te, (p | 0) != (N | 0)) {
                                                        for (; N = p - 12 | 0, _[p - 1 | 0] < 0 && Br(e[N >> 2]), p = N, (Te | 0) != (p | 0); )
                                                          ;
                                                        N = e[W + 104 >> 2];
                                                      }
                                                      e[W + 108 >> 2] = Te, Br(N);
                                                    }
                                                    if (p = e[W + 116 >> 2], p) {
                                                      if (N = e[W + 120 >> 2], (p | 0) != (N | 0)) {
                                                        for (; ; ) {
                                                          N = N - 8 | 0, Te = e[N + 4 >> 2];
                                                          A: {
                                                            if (!Te || (ar = e[Te + 4 >> 2], e[Te + 4 >> 2] = ar - 1, ar))
                                                              break A;
                                                            xi[e[e[Te >> 2] + 8 >> 2]](Te), ys(Te);
                                                          }
                                                          if ((p | 0) == (N | 0))
                                                            break;
                                                        }
                                                        p = e[W + 116 >> 2];
                                                      }
                                                      Br(p);
                                                    }
                                                    if (e[W + 140 >> 2] = Xe, e[W + 136 >> 2] = fr, e[5996] = 0, p = e[W + 140 >> 2], e[W >> 2] = e[W + 136 >> 2], e[W + 4 >> 2] = p, gs(61, r | 0, W + 72 | 0, W | 0), p = e[5996], e[5996] = 0, (p | 0) == 1)
                                                      break f;
                                                    if (p = e[W + 92 >> 2], p) {
                                                      if (N = e[W + 96 >> 2], (p | 0) != (N | 0)) {
                                                        for (; ; ) {
                                                          N = N - 8 | 0, Te = e[N + 4 >> 2];
                                                          A: {
                                                            if (!Te || (Xe = e[Te + 4 >> 2], e[Te + 4 >> 2] = Xe - 1, Xe))
                                                              break A;
                                                            xi[e[e[Te >> 2] + 8 >> 2]](Te), ys(Te);
                                                          }
                                                          if ((p | 0) == (N | 0))
                                                            break;
                                                        }
                                                        p = e[W + 92 >> 2];
                                                      }
                                                      Br(p);
                                                    }
                                                    if (vr = vr + 1 | 0, (hi | 0) != (vr | 0))
                                                      continue;
                                                    break a;
                                                  }
                                                  break;
                                                }
                                                N = Hr() | 0;
                                                break c;
                                              }
                                              N = Hr() | 0, ea(W + 104 | 0);
                                              break l;
                                            }
                                            N = Hr() | 0;
                                            break o;
                                          }
                                          N = Hr() | 0, Ha(W + 136 | 0), e[W + 108 >> 2] = Te;
                                        }
                                        AA(W + 128 | 0);
                                      }
                                      Uo(W + 116 | 0), Br(Xe);
                                    }
                                    Uo(W + 92 | 0);
                                    break n;
                                  }
                                  if (Te = e[W + 12 >> 2], Te) {
                                    if (N = e[W + 16 >> 2], (Te | 0) != (N | 0)) {
                                      for (; ; ) {
                                        if (vr = N - 12 | 0, Xe = e[vr >> 2], Xe) {
                                          if (p = Xe, fr = N - 8 | 0, N = e[fr >> 2], (p | 0) != (N | 0)) {
                                            for (; ; ) {
                                              N = N - 32 | 0, p = e[N + 4 >> 2];
                                              a: {
                                                if (!p || (hi = e[p + 4 >> 2], e[p + 4 >> 2] = hi - 1, hi))
                                                  break a;
                                                xi[e[e[p >> 2] + 8 >> 2]](p), ys(p);
                                              }
                                              if ((N | 0) == (Xe | 0))
                                                break;
                                            }
                                            p = e[vr >> 2];
                                          }
                                          e[fr >> 2] = Xe, Br(p);
                                        }
                                        if (N = vr, (Te | 0) == (N | 0))
                                          break;
                                      }
                                      Te = e[W + 12 >> 2];
                                    }
                                    Br(Te);
                                  }
                                  if (Hi = Hi + 1 | 0, N = e[W + 36 >> 2], Hi >>> 0 < (e[W + 40 >> 2] - N | 0) / 12 >>> 0)
                                    continue;
                                  break t;
                                }
                                break;
                              }
                              if (e[5996] = 0, Vs(44, 5170, 1900, 642, 2497), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                break e;
                              N = Hr() | 0;
                            }
                            Nc(W + 12 | 0);
                            break i;
                          }
                          N = Hr() | 0;
                        }
                        r = e[W + 24 >> 2], r && Br(r), Xf(W + 36 | 0);
                        break r;
                      }
                      N = Hr() | 0;
                    }
                    ya(W + 48 | 0), Jn(N | 0), Oi();
                  }
                  if (r = e[W + 24 >> 2], r && (Br(r), N = e[W + 36 >> 2]), N) {
                    if (p = N, Te = e[W + 40 >> 2], (p | 0) != (Te | 0)) {
                      for (; r = Te - 12 | 0, s = e[r >> 2], s && (e[Te - 8 >> 2] = s, Br(s)), Te = r, (Te | 0) != (N | 0); )
                        ;
                      p = e[W + 36 >> 2];
                    }
                    e[W + 40 >> 2] = N, Br(p);
                  }
                  r = e[W + 60 >> 2], r && (e[W - -64 >> 2] = r, Br(r)), r = e[W + 48 >> 2], r && (e[W + 52 >> 2] = r, Br(r)), Jr = W + 160 | 0;
                  return;
                }
                Oi();
              }
              function Wl(r, s, u, A, m, p, N, W, Te) {
                var Xe = 0, fr = 0, ar = 0, vr = 0, _r = 0, hi = 0, mi = 0, Ni = 0, Hi = 0, Ji = 0, Ln = 0, _n = 0, hs = 0, bs = 0, Us = 0, go = 0, _o = 0, ra = 0, fa = 0, ha = 0, xa = 0, tu = 0, Ku = 0, $u = 0, vf = 0, Qf = 0, cc = 0, lc = 0, dc = 0, Jc = 0, Yc = 0, Xc = 0;
                fr = Jr - 336 | 0, Jr = fr, vr = W, _r = Te & 65535, hi = A, mi = m & 65535, Ln = (m ^ Te) & -2147483648, Hi = Te >>> 16 & 32767, Ji = m >>> 16 & 32767;
                e: {
                  t: {
                    if (Hi - 32767 >>> 0 > 4294934529 & Ji - 32767 >>> 0 >= 4294934530)
                      break t;
                    if (Xe = m & 2147483647, !(!A & (Xe | 0) == 2147418112 ? !(s | u) : Xe >>> 0 < 2147418112)) {
                      Ni = A, Ln = m | 32768;
                      break e;
                    }
                    if (m = Te & 2147483647, !(!W & (m | 0) == 2147418112 ? !(p | N) : m >>> 0 < 2147418112)) {
                      Ni = W, Ln = Te | 32768, s = p, u = N;
                      break e;
                    }
                    if (!(s | A | (Xe ^ 2147418112 | u))) {
                      if (!(p | W | (m ^ 2147418112 | N))) {
                        s = 0, u = 0, Ln = 2147450880;
                        break e;
                      }
                      Ln = Ln | 2147418112, s = 0, u = 0;
                      break e;
                    }
                    if (!(p | W | (m ^ 2147418112 | N))) {
                      s = 0, u = 0;
                      break e;
                    }
                    if (!(s | A | (u | Xe))) {
                      s = !(p | W | (m | N)), Ni = s ? 0 : Ni, Ln = s ? 2147450880 : Ln, s = 0, u = 0;
                      break e;
                    }
                    if (!(p | W | (m | N))) {
                      Ln = Ln | 2147418112, s = 0, u = 0;
                      break e;
                    }
                    if ((Xe | 0) == 65535 | Xe >>> 0 < 65535 && (A = !(hi | mi), Te = A, Xe = A ? s : hi, A = A << 6, Te = Fo(Te ? u : mi), A = A + ((Te | 0) == 32 ? Fo(Xe) + 32 | 0 : Te) | 0, Ea(fr + 320 | 0, s, u, hi, mi, A - 15 | 0), _n = 16 - A | 0, hi = e[fr + 328 >> 2], mi = e[fr + 332 >> 2], u = e[fr + 324 >> 2], s = e[fr + 320 >> 2]), m >>> 0 > 65535)
                      break t;
                    A = !(_r | vr), W = A, Te = A ? p : vr, A = A << 6, W = Fo(W ? N : _r), A = A + ((W | 0) == 32 ? Fo(Te) + 32 | 0 : W) | 0, Ea(fr + 304 | 0, p, N, vr, _r, A - 15 | 0), _n = (A + _n | 0) - 16 | 0, vr = e[fr + 312 >> 2], _r = e[fr + 316 >> 2], p = e[fr + 304 >> 2], N = e[fr + 308 >> 2];
                  }
                  m = _r | 65536, _o = m, ra = vr, A = vr, Xe = m << 15 | A >>> 17, m = A << 15 | N >>> 17, A = m, Te = 0 - A | 0, W = Xe, Xe = 1963258675 - (Xe + ((A | 0) != 0) | 0) | 0, Aa(fr + 288 | 0, A, W, 0, 0, Te, Xe, 0, 0), A = e[fr + 296 >> 2], Aa(fr + 272 | 0, 0 - A | 0, 0 - (e[fr + 300 >> 2] + ((A | 0) != 0) | 0) | 0, 0, 0, Te, Xe, 0, 0), A = e[fr + 280 >> 2], Te = A << 1 | e[fr + 276 >> 2] >>> 31, A = e[fr + 284 >> 2] << 1 | A >>> 31, Aa(fr + 256 | 0, Te, A, 0, 0, m, W, 0, 0), Xe = e[fr + 264 >> 2], Aa(fr + 240 | 0, Te, A, 0, 0, 0 - Xe | 0, 0 - (e[fr + 268 >> 2] + ((Xe | 0) != 0) | 0) | 0, 0, 0), Te = e[fr + 248 >> 2], Xe = Te << 1 | e[fr + 244 >> 2] >>> 31, A = e[fr + 252 >> 2] << 1 | Te >>> 31, Aa(fr + 224 | 0, Xe, A, 0, 0, m, W, 0, 0), Te = e[fr + 232 >> 2], Aa(fr + 208 | 0, Xe, A, 0, 0, 0 - Te | 0, 0 - (e[fr + 236 >> 2] + ((Te | 0) != 0) | 0) | 0, 0, 0), A = e[fr + 216 >> 2], Te = A << 1 | e[fr + 212 >> 2] >>> 31, A = e[fr + 220 >> 2] << 1 | A >>> 31, Aa(fr + 192 | 0, Te, A, 0, 0, m, W, 0, 0), Xe = e[fr + 200 >> 2], Aa(fr + 176 | 0, Te, A, 0, 0, 0 - Xe | 0, 0 - (e[fr + 204 >> 2] + ((Xe | 0) != 0) | 0) | 0, 0, 0), Te = m, m = e[fr + 184 >> 2], A = W, vr = m << 1 | e[fr + 180 >> 2] >>> 31, W = vr - 1 | 0, m = (e[fr + 188 >> 2] << 1 | m >>> 31) - !vr | 0, Aa(fr + 160 | 0, Te, A, 0, 0, W, m, 0, 0), A = W, Aa(fr + 144 | 0, p << 15, N << 15 | p >>> 17, 0, 0, A, m, 0, 0), bs = fr + 112 | 0, Us = e[fr + 168 >> 2], W = e[fr + 172 >> 2], vr = e[fr + 160 >> 2], Te = e[fr + 152 >> 2], ar = vr + Te | 0, _r = e[fr + 164 >> 2], Xe = _r + e[fr + 156 >> 2] | 0, Xe = Te >>> 0 > ar >>> 0 ? Xe + 1 | 0 : Xe, Te = Xe, Xe = (_r | 0) == (Xe | 0) & ar >>> 0 < vr >>> 0 | Xe >>> 0 < _r >>> 0, _r = Xe + Us | 0, Xe = Xe >>> 0 > _r >>> 0 ? W + 1 | 0 : W, vr = !Te & ar >>> 0 > 1 | (Te | 0) != 0, W = _r + vr | 0, Xe = vr >>> 0 > W >>> 0 ? Xe + 1 | 0 : Xe, Aa(bs, A, m, 0, 0, 0 - W | 0, 0 - (((W | 0) != 0) + Xe | 0) | 0, 0, 0), Aa(fr + 128 | 0, 1 - ar | 0, 0 - ((ar >>> 0 > 1) + Te | 0) | 0, 0, 0, A, m, 0, 0), Qf = (Ji - Hi | 0) + _n | 0, m = e[fr + 116 >> 2], bs = m, A = e[fr + 112 >> 2], Xe = m << 1 | A >>> 31, Te = A << 1, _r = Xe, A = Xe, W = e[fr + 140 >> 2], go = W, m = e[fr + 136 >> 2], Xe = W << 1 | m >>> 31, ar = m << 1 | e[fr + 132 >> 2] >>> 31, W = ar + Te | 0, A = A + Xe | 0, A = W >>> 0 < ar >>> 0 ? A + 1 | 0 : A, m = A, A = A - (W >>> 0 < 13927) | 0, hs = A, Us = A, ar = 0, Xe = mi | 65536, cc = Xe, lc = hi, A = hi, Xe = Xe << 1 | A >>> 31, Jc = A << 1, Yc = Xe, tu = Xe, A = Ao(hs, ar, Xe, 0), Xe = Ds, fa = A, ha = Xe, _n = s << 1, A = u << 1 | s >>> 31, Hi = A, Xe = 0, Ji = Xe, vr = W - 13927 | 0, hs = (m | 0) == (hs | 0) & vr >>> 0 < W >>> 0 | m >>> 0 > hs >>> 0, m = (m | 0) == (_r | 0) & W >>> 0 < Te >>> 0 | m >>> 0 < _r >>> 0, A = e[fr + 120 >> 2], W = e[fr + 124 >> 2] << 1 | A >>> 31, A = A << 1 | bs >>> 31, ar = go >>> 31 | 0, A = ar + A | 0, Xe = W, Xe = A >>> 0 < ar >>> 0 ? Xe + 1 | 0 : Xe, W = A, A = A + m | 0, Xe = W >>> 0 > A >>> 0 ? Xe + 1 | 0 : Xe, m = A, A = A + hs | 0, ar = m >>> 0 > A >>> 0 ? Xe + 1 | 0 : Xe, m = A - 1 | 0, xa = ar - !A | 0, go = 0, Te = Ao(Hi, Ji, xa, go), A = Te + fa | 0, W = Ds + ha | 0, W = A >>> 0 < Te >>> 0 ? W + 1 | 0 : W, _r = (ha | 0) == (W | 0) & A >>> 0 < fa >>> 0 | W >>> 0 < ha >>> 0, fa = m, dc = u >>> 31 | 0, $u = dc | hi << 1, hs = 0, m = Ao(m, 0, $u, hs), hi = m + A | 0, Xe = Ds + W | 0, ar = 0, Xe = m >>> 0 > hi >>> 0 ? Xe + 1 | 0 : Xe, mi = Xe, A = (Xe | 0) == (W | 0) & A >>> 0 > hi >>> 0 | W >>> 0 > Xe >>> 0, m = A, A = A + _r | 0, ar = m >>> 0 > A >>> 0 ? 1 : ar, m = Ao(tu, Ji, xa, go), A = m + A | 0, Xe = Ds + ar | 0, _r = A, A = A >>> 0 < m >>> 0 ? Xe + 1 | 0 : Xe, m = Ao(tu, Ji, fa, hs), ar = Ds, W = m, m = Ao($u, hs, xa, go), Te = W + m | 0, Xe = Ds + ar | 0, Xe = m >>> 0 > Te >>> 0 ? Xe + 1 | 0 : Xe, m = Xe, Xe = (ar | 0) == (Xe | 0) & W >>> 0 > Te >>> 0 | Xe >>> 0 < ar >>> 0, ar = _r + m | 0, A = A + Xe | 0, A = ar >>> 0 < m >>> 0 ? A + 1 | 0 : A, _r = ar, ar = A, m = 0, A = m + hi | 0, Xe = Te + mi | 0, Xe = A >>> 0 < m >>> 0 ? Xe + 1 | 0 : Xe, m = Xe, W = (Xe | 0) == (mi | 0) & A >>> 0 < hi >>> 0 | Xe >>> 0 < mi >>> 0, Xe = ar, Te = W, W = W + _r | 0, Xe = Te >>> 0 > W >>> 0 ? Xe + 1 | 0 : Xe, Ku = W, ar = Xe, bs = A, hi = A, ha = vr, A = Ao(vr, 0, $u, hs), Te = Ds, W = A, vr = Ao(Us, Ni, Hi, Ni), A = A + vr | 0, Xe = Ds + Te | 0, Xe = A >>> 0 < vr >>> 0 ? Xe + 1 | 0 : Xe, vr = (Te | 0) == (Xe | 0) & A >>> 0 < W >>> 0 | Te >>> 0 > Xe >>> 0, W = Xe, vf = _n & -2, Te = Ao(fa, hs, vf, 0), mi = Te + A | 0, Xe = Ds + Xe | 0, Xe = Te >>> 0 > mi >>> 0 ? Xe + 1 | 0 : Xe, Te = Xe, A = (Xe | 0) == (W | 0) & A >>> 0 > mi >>> 0 | W >>> 0 > Xe >>> 0, W = 0, Xe = A + vr | 0, A = (Xe >>> 0 < A >>> 0 ? 1 : W) + m | 0, _r = Xe + hi | 0, A = _r >>> 0 < Xe >>> 0 ? A + 1 | 0 : A, Xe = ar, hi = A, A = (A | 0) == (m | 0) & _r >>> 0 < bs >>> 0 | A >>> 0 < m >>> 0, m = A, A = A + Ku | 0, Xe = m >>> 0 > A >>> 0 ? Xe + 1 | 0 : Xe, Xc = A, bs = Xe, A = Ao(tu, Ji, ha, Ni), Ku = Ds, tu = A, m = Ao(xa, go, vf, Ni), A = A + m | 0, Xe = Ds + Ku | 0, Xe = A >>> 0 < m >>> 0 ? Xe + 1 | 0 : Xe, vr = A, ar = Ao(Us, Ni, $u, hs), m = A + ar | 0, W = Xe, A = Xe + Ds | 0, A = m >>> 0 < ar >>> 0 ? A + 1 | 0 : A, Ji = m, Xe = Ao(Hi, Ni, fa, hs), m = m + Xe | 0, ar = Ds + A | 0, ar = m >>> 0 < Xe >>> 0 ? ar + 1 | 0 : ar, xa = (A | 0) == (ar | 0) & m >>> 0 < Ji >>> 0 | A >>> 0 > ar >>> 0, Xe = (W | 0) == (Ku | 0) & vr >>> 0 < tu >>> 0 | W >>> 0 < Ku >>> 0, A = (A | 0) == (W | 0) & vr >>> 0 > Ji >>> 0 | A >>> 0 < W >>> 0, A = A + Xe | 0, A = A + xa | 0, W = ar, Ji = W + _r | 0, Xe = (A | go) + hi | 0, Xe = W >>> 0 > Ji >>> 0 ? Xe + 1 | 0 : Xe, vr = Xe, A = (hi | 0) == (Xe | 0) & _r >>> 0 > Ji >>> 0 | Xe >>> 0 < hi >>> 0, Xe = bs, W = A, A = A + Xc | 0, Xe = W >>> 0 > A >>> 0 ? Xe + 1 | 0 : Xe, go = A, hi = Xe, A = Ao(Us, Ni, vf, Ni), Us = Ds, _r = A, W = Ao(Hi, Ni, ha, Ni), A = A + W | 0, Xe = Ds + Us | 0, Xe = A >>> 0 < W >>> 0 ? Xe + 1 | 0 : Xe, bs = 0, W = (Xe | 0) == (Us | 0) & A >>> 0 < _r >>> 0 | Xe >>> 0 < Us >>> 0, _r = Xe, A = Xe + mi | 0, Xe = (W | bs) + Te | 0, Xe = A >>> 0 < _r >>> 0 ? Xe + 1 | 0 : Xe, Te = (Te | 0) == (Xe | 0) & A >>> 0 < mi >>> 0 | Te >>> 0 > Xe >>> 0, W = Xe, Xe = m, mi = 0, m = mi + A | 0, ar = W + Xe | 0, Xe = 0, ar = m >>> 0 < mi >>> 0 ? ar + 1 | 0 : ar, A = (W | 0) == (ar | 0) & A >>> 0 > m >>> 0 | W >>> 0 > ar >>> 0, m = A, A = A + Te | 0, Xe = (m >>> 0 > A >>> 0 ? 1 : Xe) + vr | 0, ar = hi, m = A, A = A + Ji | 0, Xe = m >>> 0 > A >>> 0 ? Xe + 1 | 0 : Xe, m = Xe, W = (vr | 0) == (Xe | 0) & A >>> 0 < Ji >>> 0 | Xe >>> 0 < vr >>> 0, Te = W, W = W + go | 0, ar = Te >>> 0 > W >>> 0 ? ar + 1 | 0 : ar, Te = ar;
                  t: {
                    if ((ar | 0) == 131071 | ar >>> 0 < 131071) {
                      lc = Jc | dc, cc = hs | Yc, Aa(fr + 80 | 0, A, Xe, W, ar, p, N, ra, _o), ar = e[fr + 84 >> 2], _r = ar, Xe = s << 17, vr = 0, mi = e[fr + 88 >> 2], u = vr - mi | 0, s = e[fr + 80 >> 2], ar = (ar | s) != 0, hi = u - ar | 0, mi = (Xe - (e[fr + 92 >> 2] + (vr >>> 0 < mi >>> 0) | 0) | 0) - (u >>> 0 < ar >>> 0) | 0, vr = 0 - s | 0, _r = 0 - (((s | 0) != 0) + _r | 0) | 0, s = Qf + 16382 | 0;
                      break t;
                    }
                    A = (m & 1) << 31 | A >>> 1, m = W << 31 | m >>> 1, W = (Te & 1) << 31 | W >>> 1, Te = Te >>> 1 | 0, Aa(fr + 96 | 0, A, m, W, Te, p, N, ra, _o), hi = e[fr + 100 >> 2], Hi = hi, _r = 0, _n = e[fr + 104 >> 2], vr = _r - _n | 0, ar = e[fr + 96 >> 2], mi = (hi | ar) != 0, hi = vr - mi | 0, mi = ((s << 16) - (e[fr + 108 >> 2] + (_r >>> 0 < _n >>> 0) | 0) | 0) - (vr >>> 0 < mi >>> 0) | 0, vr = 0 - ar | 0, _r = 0 - (((ar | 0) != 0) + Hi | 0) | 0, _n = s, Hi = u, s = Qf + 16383 | 0;
                  }
                  if ((s | 0) >= 32767) {
                    Ln = Ln | 2147418112, s = 0, u = 0;
                    break e;
                  }
                  t: {
                    if ((s | 0) > 0) {
                      ar = mi << 1 | hi >>> 31, hi = hi << 1 | _r >>> 31, mi = ar, _n = W, Hi = Te & 65535 | s << 16, ar = _r << 1 | vr >>> 31, Te = vr << 1;
                      break t;
                    }
                    if ((s | 0) <= -113) {
                      s = 0, u = 0;
                      break e;
                    }
                    Tf(fr - -64 | 0, A, m, W, Te, 1 - s | 0), Ea(fr + 48 | 0, _n, Hi, lc, cc, s + 112 | 0), A = e[fr + 64 >> 2], m = e[fr + 68 >> 2], _n = e[fr + 72 >> 2], Hi = e[fr + 76 >> 2], Aa(fr + 32 | 0, p, N, ra, _o, A, m, _n, Hi), s = e[fr + 40 >> 2], u = e[fr + 56 >> 2], ar = e[fr + 36 >> 2], hi = s << 1 | ar >>> 31, vr = u - hi | 0, mi = e[fr + 60 >> 2] - ((e[fr + 44 >> 2] << 1 | s >>> 31) + (u >>> 0 < hi >>> 0) | 0) | 0, s = e[fr + 32 >> 2], W = ar << 1 | s >>> 31, Xe = s << 1, Te = e[fr + 52 >> 2], u = e[fr + 48 >> 2], s = (W | 0) == (Te | 0) & Xe >>> 0 > u >>> 0 | W >>> 0 > Te >>> 0, hi = vr - s | 0, mi = mi - (s >>> 0 > vr >>> 0) | 0, ar = Te - ((u >>> 0 < Xe >>> 0) + W | 0) | 0, Te = u - Xe | 0;
                  }
                  s = Te, Aa(fr + 16 | 0, p, N, ra, _o, 3, 0, 0, 0), Aa(fr, p, N, ra, _o, 5, 0, 0, 0), u = 0, W = ar + u | 0, Xe = A & 1, s = s + Xe | 0, W = Te >>> 0 > s >>> 0 ? W + 1 | 0 : W, Te = s, N = (W | 0) == (N | 0) & p >>> 0 < Te >>> 0 | N >>> 0 < W >>> 0, ar = mi, s = (u | 0) == (W | 0) & Te >>> 0 < Xe >>> 0 | u >>> 0 > W >>> 0, p = s + hi | 0, ar = s >>> 0 > p >>> 0 ? ar + 1 | 0 : ar, Xe = m, s = (ar | 0) == (_o | 0), s = s & (p | 0) == (ra | 0) ? N : s & p >>> 0 > ra >>> 0 | ar >>> 0 > _o >>> 0, u = s, s = s + A | 0, Xe = u >>> 0 > s >>> 0 ? Xe + 1 | 0 : Xe, u = Xe, A = (m | 0) == (Xe | 0) & s >>> 0 < A >>> 0 | m >>> 0 > Xe >>> 0, Xe = Hi, m = A, A = A + _n | 0, Xe = m >>> 0 > A >>> 0 ? Xe + 1 | 0 : Xe, N = A, m = e[fr + 20 >> 2], _r = (m | 0) == (W | 0) & Ls[fr + 16 >> 2] < Te >>> 0 | m >>> 0 < W >>> 0, m = e[fr + 28 >> 2], A = e[fr + 24 >> 2], m = Xe >>> 0 < 2147418112 & ((A | 0) == (p | 0) & (m | 0) == (ar | 0) ? _r : (m | 0) == (ar | 0) & A >>> 0 < p >>> 0 | m >>> 0 < ar >>> 0), A = u, _r = m, m = s + m | 0, A = _r >>> 0 > m >>> 0 ? A + 1 | 0 : A, s = (u | 0) == (A | 0) & s >>> 0 > m >>> 0 | u >>> 0 > A >>> 0, u = s, s = s + N | 0, Xe = u >>> 0 > s >>> 0 ? Xe + 1 | 0 : Xe, N = s, u = e[fr + 4 >> 2], W = (u | 0) == (W | 0) & Ls[fr >> 2] < Te >>> 0 | u >>> 0 < W >>> 0, u = e[fr + 12 >> 2], s = e[fr + 8 >> 2], s = Xe >>> 0 < 2147418112 & ((s | 0) == (p | 0) & (u | 0) == (ar | 0) ? W : (u | 0) == (ar | 0) & s >>> 0 < p >>> 0 | u >>> 0 < ar >>> 0), u = s, s = s + m | 0, ar = u >>> 0 > s >>> 0 ? A + 1 | 0 : A, u = ar, m = (A | 0) == (ar | 0) & s >>> 0 < m >>> 0 | A >>> 0 > ar >>> 0, A = Xe, p = m, m = m + N | 0, A = p >>> 0 > m >>> 0 ? A + 1 | 0 : A, Ni = m | Ni, Ln = A | Ln;
                }
                e[r >> 2] = s, e[r + 4 >> 2] = u, e[r + 8 >> 2] = Ni, e[r + 12 >> 2] = Ln, Jr = fr + 336 | 0;
              }
              function Su(r, s, u, A, m, p) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0, m = +m, p = p | 0;
                var N = 0, W = 0, Te = 0, Xe = 0, fr = 0, ar = 0, vr = 0, _r = 0, hi = 0, mi = 0, Ni = 0, Hi = 0, Ji = 0, Ln = 0;
                W = Jr - 128 | 0, Jr = W, Mf(W + 56 | 0, u, jn[r + 16 >> 3], jn[r + 24 >> 3], m, p), e[5996] = 0, p = Mi(46, u | 0) | 0, N = e[5996], e[5996] = 0;
                e: {
                  t: {
                    r: {
                      if ((N | 0) != 1) {
                        if (e[W + 52 >> 2] = 0, e[W + 44 >> 2] = 0, e[W + 48 >> 2] = 0, _[W + 84 | 0] = 0, e[W + 80 >> 2] = W + 44, N = e[p + 4 >> 2], Xe = e[p >> 2], ar = N - Xe | 0, Te = (ar | 0) / 12 | 0, (N | 0) != (Xe | 0)) {
                          i: {
                            n: {
                              s: {
                                if (Te >>> 0 >= 357913942) {
                                  if (e[5996] = 0, Nn(47), r = e[5996], e[5996] = 0, (r | 0) == 1)
                                    break s;
                                  break e;
                                }
                                if (e[5996] = 0, N = Mi(3, ar | 0) | 0, Xe = e[5996], e[5996] = 0, (Xe | 0) == 1)
                                  break s;
                                if (e[W + 48 >> 2] = N, e[W + 44 >> 2] = N, e[W + 52 >> 2] = N + Sn(Te, 12), Te = e[p + 4 >> 2], p = e[p >> 2], e[5996] = 0, p = wa(48, W + 52 | 0, p | 0, Te | 0, N | 0) | 0, Te = e[5996], e[5996] = 0, (Te | 0) != 1)
                                  break i;
                                p = Hr() | 0, e[W + 48 >> 2] = N;
                                break n;
                              }
                              p = Hr() | 0;
                            }
                            ff(W + 80 | 0);
                            break r;
                          }
                          e[W + 48 >> 2] = p;
                        }
                        e[W + 40 >> 2] = 0, e[W + 32 >> 2] = 0, e[W + 36 >> 2] = 0, p = e[A + 4 >> 2], N = e[A >> 2], e[5996] = 0, ji(49, W + 32 | 0, p - N >> 2), p = e[5996], e[5996] = 0;
                        i: {
                          if ((p | 0) != 1) {
                            if (p = e[W + 48 >> 2], N = e[W + 44 >> 2], (p | 0) == (N | 0))
                              break t;
                            p = N;
                            n: {
                              for (; ; ) {
                                s: {
                                  if (e[W + 28 >> 2] = 0, e[W + 20 >> 2] = 0, e[W + 24 >> 2] = 0, Te = e[A + 4 >> 2], N = e[A >> 2], hi = Sn(Hi, 12), p = hi + p | 0, Te - N >> 2 != e[p + 4 >> 2] - e[p >> 2] >> 3)
                                    break s;
                                  Xe = 0, _r = 1, vr = 0;
                                  a: {
                                    if ((N | 0) != (Te | 0)) {
                                      o: {
                                        l: {
                                          c: {
                                            for (; ; ) {
                                              if (p = vr << 3, Ji = jn[p + e[W + 68 >> 2] >> 3], Ln = jn[p + e[W + 56 >> 2] >> 3], N = e[(vr << 2) + N >> 2], e[5996] = 0, N = Cf(50, N | 0, +Ln, +Ji, s | 0) | 0, Te = e[5996], e[5996] = 0, (Te | 0) == 1)
                                                break l;
                                              if (p = p + e[hi + e[W + 44 >> 2] >> 2] | 0, Te = e[p >> 2], p = e[p + 4 >> 2], ar = e[N + 4 >> 2], N = e[N >> 2], e[5996] = 0, uu(51, W + 80 | 0, N | 0, ar | 0, Te | 0, p | 0), p = e[5996], e[5996] = 0, (p | 0) != 1) {
                                                Te = e[W + 28 >> 2];
                                                d: {
                                                  if (Te >>> 0 > Xe >>> 0) {
                                                    e[Xe + 8 >> 2] = 0, e[Xe >> 2] = 0, e[Xe + 4 >> 2] = 0, e[Xe >> 2] = e[W + 80 >> 2], e[Xe + 4 >> 2] = e[W + 84 >> 2], e[Xe + 8 >> 2] = e[W + 88 >> 2], e[W + 24 >> 2] = Xe + 12;
                                                    break d;
                                                  }
                                                  f: {
                                                    N = e[W + 20 >> 2], ar = (Xe - N | 0) / 12 | 0, p = ar + 1 | 0;
                                                    u: {
                                                      if (p >>> 0 >= 357913942) {
                                                        e[5996] = 0, Nn(52);
                                                        break u;
                                                      }
                                                      if (Te = (Te - N | 0) / 12 | 0, fr = Te << 1, p = Te >>> 0 >= 178956970 ? 357913941 : p >>> 0 < fr >>> 0 ? fr : p, p >>> 0 < 357913942)
                                                        break f;
                                                      e[5996] = 0, Nn(35);
                                                    }
                                                    if (r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                      break e;
                                                    break c;
                                                  }
                                                  if (e[5996] = 0, fr = Sn(p, 12), Te = Mi(3, fr | 0) | 0, p = e[5996], e[5996] = 0, (p | 0) == 1)
                                                    break c;
                                                  p = Te + Sn(ar, 12) | 0, e[p >> 2] = e[W + 80 >> 2], e[p + 4 >> 2] = e[W + 84 >> 2], e[p + 8 >> 2] = e[W + 88 >> 2], e[W + 88 >> 2] = 0, e[W + 80 >> 2] = 0, e[W + 84 >> 2] = 0, Te = Te + fr | 0, ar = p + 12 | 0;
                                                  f: {
                                                    if ((N | 0) == (Xe | 0)) {
                                                      e[W + 28 >> 2] = Te, e[W + 24 >> 2] = ar, e[W + 20 >> 2] = p;
                                                      break f;
                                                    }
                                                    for (; p = p - 12 | 0, Xe = Xe - 12 | 0, e[p >> 2] = e[Xe >> 2], e[p + 4 >> 2] = e[Xe + 4 >> 2], e[p + 8 >> 2] = e[Xe + 8 >> 2], e[Xe + 8 >> 2] = 0, e[Xe >> 2] = 0, e[Xe + 4 >> 2] = 0, (N | 0) != (Xe | 0); )
                                                      ;
                                                    if (e[W + 28 >> 2] = Te, N = e[W + 24 >> 2], e[W + 24 >> 2] = ar, Xe = e[W + 20 >> 2], e[W + 20 >> 2] = p, (N | 0) == (Xe | 0))
                                                      break f;
                                                    for (; ; ) {
                                                      if (fr = N - 12 | 0, ar = e[fr >> 2], ar) {
                                                        if (mi = N - 8 | 0, p = e[mi >> 2], Te = ar, (p | 0) != (Te | 0)) {
                                                          for (; ; ) {
                                                            p = p - 32 | 0, N = e[p + 4 >> 2];
                                                            u: {
                                                              if (!N || (Te = e[N + 4 >> 2], e[N + 4 >> 2] = Te - 1, Te))
                                                                break u;
                                                              xi[e[e[N >> 2] + 8 >> 2]](N), ys(N);
                                                            }
                                                            if ((p | 0) == (ar | 0))
                                                              break;
                                                          }
                                                          Te = e[fr >> 2];
                                                        }
                                                        e[mi >> 2] = ar, Br(Te);
                                                      }
                                                      if (N = fr, (Xe | 0) == (N | 0))
                                                        break;
                                                    }
                                                  }
                                                  if (Xe && Br(Xe), Te = e[W + 80 >> 2], !Te)
                                                    break d;
                                                  if (p = e[W + 84 >> 2], N = Te, (p | 0) != (N | 0)) {
                                                    for (; ; ) {
                                                      p = p - 32 | 0, N = e[p + 4 >> 2];
                                                      f: {
                                                        if (!N || (Xe = e[N + 4 >> 2], e[N + 4 >> 2] = Xe - 1, Xe))
                                                          break f;
                                                        xi[e[e[N >> 2] + 8 >> 2]](N), ys(N);
                                                      }
                                                      if ((p | 0) == (Te | 0))
                                                        break;
                                                    }
                                                    N = e[W + 80 >> 2];
                                                  }
                                                  e[W + 84 >> 2] = Te, Br(N);
                                                }
                                                if (Xe = e[W + 24 >> 2], p = Xe - 12 | 0, _r = Sn(e[p + 4 >> 2] - e[p >> 2] >> 5, _r), vr = vr + 1 | 0, N = e[A >> 2], vr >>> 0 >= e[A + 4 >> 2] - N >> 2 >>> 0)
                                                  break o;
                                                continue;
                                              }
                                              break;
                                            }
                                            p = Hr() | 0;
                                            break n;
                                          }
                                          p = Hr() | 0, mu(W + 80 | 0);
                                          break n;
                                        }
                                        p = Hr() | 0;
                                        break n;
                                      }
                                      if (!_r)
                                        break a;
                                    }
                                    ar = 0;
                                    o: {
                                      l: {
                                        for (; ; ) {
                                          if (Xe = e[W + 32 >> 2], e[A + 4 >> 2] != e[A >> 2])
                                            for (p = 0, Te = e[W + 20 >> 2], N = ar; fr = Sn(p, 12), vr = fr + Te | 0, Te = e[vr >> 2], e[(p << 2) + Xe >> 2] = Te + ((N >>> 0) % (e[vr + 4 >> 2] - Te >> 5 >>> 0) << 5), vr = N, Te = e[W + 20 >> 2], N = fr + Te | 0, N = (vr >>> 0) / (e[N + 4 >> 2] - e[N >> 2] >> 5 >>> 0) | 0, p = p + 1 | 0, p >>> 0 < e[A + 4 >> 2] - e[A >> 2] >> 2 >>> 0; )
                                              ;
                                          if (e[W + 104 >> 2] = 0, e[W + 96 >> 2] = 0, e[W + 100 >> 2] = 0, p = Xe, hi = e[W + 36 >> 2], (p | 0) != (hi | 0)) {
                                            c: {
                                              for (; ; ) {
                                                d: {
                                                  fr = e[Xe >> 2], p = e[W + 100 >> 2];
                                                  f: {
                                                    if ((p | 0) != e[W + 104 >> 2]) {
                                                      e[p >> 2] = e[fr >> 2], N = e[fr + 4 >> 2], e[p + 4 >> 2] = N, N && (e[N + 4 >> 2] = e[N + 4 >> 2] + 1), e[W + 100 >> 2] = p + 8;
                                                      break f;
                                                    }
                                                    u: {
                                                      Te = e[W + 96 >> 2], N = p - Te | 0, mi = N >> 3, vr = mi + 1 | 0;
                                                      g: {
                                                        if (vr >>> 0 >= 536870912) {
                                                          e[5996] = 0, Nn(59);
                                                          break g;
                                                        }
                                                        if (Ni = N >> 2, N = N >>> 0 >= 2147483640 ? 536870911 : vr >>> 0 < Ni >>> 0 ? Ni : vr, N >>> 0 < 536870912)
                                                          break u;
                                                        e[5996] = 0, Nn(35);
                                                      }
                                                      if (r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                        break e;
                                                      p = Hr() | 0;
                                                      break o;
                                                    }
                                                    if (e[5996] = 0, Ni = N << 3, vr = Mi(3, Ni | 0) | 0, N = e[5996], e[5996] = 0, (N | 0) == 1)
                                                      break d;
                                                    N = vr + (mi << 3) | 0, e[N >> 2] = e[fr >> 2], fr = e[fr + 4 >> 2], e[N + 4 >> 2] = fr, fr && (e[fr + 4 >> 2] = e[fr + 4 >> 2] + 1, p = e[W + 100 >> 2]), fr = vr + Ni | 0, vr = N + 8 | 0;
                                                    u: {
                                                      if ((p | 0) == (Te | 0)) {
                                                        e[W + 104 >> 2] = fr, e[W + 100 >> 2] = vr, e[W + 96 >> 2] = N;
                                                        break u;
                                                      }
                                                      for (; N = N - 8 | 0, p = p - 8 | 0, e[N >> 2] = e[p >> 2], e[N + 4 >> 2] = e[p + 4 >> 2], e[p >> 2] = 0, e[p + 4 >> 2] = 0, (p | 0) != (Te | 0); )
                                                        ;
                                                      if (e[W + 104 >> 2] = fr, p = e[W + 100 >> 2], e[W + 100 >> 2] = vr, Te = e[W + 96 >> 2], e[W + 96 >> 2] = N, (p | 0) == (Te | 0))
                                                        break u;
                                                      for (; ; ) {
                                                        p = p - 8 | 0, N = e[p + 4 >> 2];
                                                        g: {
                                                          if (!N || (fr = e[N + 4 >> 2], e[N + 4 >> 2] = fr - 1, fr))
                                                            break g;
                                                          xi[e[e[N >> 2] + 8 >> 2]](N), ys(N);
                                                        }
                                                        if ((p | 0) == (Te | 0))
                                                          break;
                                                      }
                                                    }
                                                    if (!Te)
                                                      break f;
                                                    Br(Te);
                                                  }
                                                  if (Xe = Xe + 4 | 0, (hi | 0) != (Xe | 0))
                                                    continue;
                                                  break c;
                                                }
                                                break;
                                              }
                                              p = Hr() | 0;
                                              break o;
                                            }
                                            Xe = e[W + 36 >> 2], p = e[W + 32 >> 2];
                                          }
                                          if (e[5996] = 0, yc(63, W + 80 | 0, u | 0, p | 0, Xe | 0, +m), p = e[5996], e[5996] = 0, (p | 0) == 1 || (e[5996] = 0, Te = Mi(3, 104) | 0, p = e[5996], e[5996] = 0, (p | 0) == 1))
                                            break l;
                                          if (e[Te >> 2] = 7e3, e[Te + 4 >> 2] = 0, e[Te + 8 >> 2] = 0, e[5996] = 0, e[W + 116 >> 2] = e[W + 96 >> 2], p = e[W + 104 >> 2], N = e[W + 100 >> 2], e[W + 104 >> 2] = 0, e[W + 120 >> 2] = N, e[W + 124 >> 2] = p, e[W + 96 >> 2] = 0, e[W + 100 >> 2] = 0, fr = wa(64, Te + 12 | 0, u | 0, W + 116 | 0, 0) | 0, p = e[5996], e[5996] = 0, (p | 0) != 1) {
                                            if (N = e[W + 116 >> 2], N) {
                                              if (p = e[W + 120 >> 2], (N | 0) != (p | 0)) {
                                                for (; ; ) {
                                                  p = p - 8 | 0, Xe = e[p + 4 >> 2];
                                                  c: {
                                                    if (!Xe || (vr = e[Xe + 4 >> 2], e[Xe + 4 >> 2] = vr - 1, vr))
                                                      break c;
                                                    xi[e[e[Xe >> 2] + 8 >> 2]](Xe), ys(Xe);
                                                  }
                                                  if ((p | 0) == (N | 0))
                                                    break;
                                                }
                                                N = e[W + 116 >> 2];
                                              }
                                              Br(N);
                                            }
                                            if (e[W + 112 >> 2] = Te, e[W + 108 >> 2] = fr, e[5996] = 0, p = e[W + 112 >> 2], e[W + 8 >> 2] = e[W + 108 >> 2], e[W + 12 >> 2] = p, gs(61, r | 0, W + 80 | 0, W + 8 | 0), p = e[5996], e[5996] = 0, (p | 0) == 1)
                                              break l;
                                            if (N = e[W + 96 >> 2], N) {
                                              if (p = e[W + 100 >> 2], (N | 0) != (p | 0)) {
                                                for (; ; ) {
                                                  p = p - 8 | 0, Te = e[p + 4 >> 2];
                                                  c: {
                                                    if (!Te || (Xe = e[Te + 4 >> 2], e[Te + 4 >> 2] = Xe - 1, Xe))
                                                      break c;
                                                    xi[e[e[Te >> 2] + 8 >> 2]](Te), ys(Te);
                                                  }
                                                  if ((p | 0) == (N | 0))
                                                    break;
                                                }
                                                N = e[W + 96 >> 2];
                                              }
                                              Br(N);
                                            }
                                            if (ar = ar + 1 | 0, (_r | 0) != (ar | 0))
                                              continue;
                                            break a;
                                          }
                                          break;
                                        }
                                        p = Hr() | 0, Uo(W + 116 | 0), Br(Te);
                                        break o;
                                      }
                                      p = Hr() | 0;
                                    }
                                    Uo(W + 96 | 0);
                                    break n;
                                  }
                                  if (Te = e[W + 20 >> 2], Te) {
                                    if (p = e[W + 24 >> 2], (Te | 0) != (p | 0)) {
                                      for (; ; ) {
                                        if (ar = p - 12 | 0, Xe = e[ar >> 2], Xe) {
                                          if (fr = p - 8 | 0, p = e[fr >> 2], N = Xe, (p | 0) != (N | 0)) {
                                            for (; ; ) {
                                              p = p - 32 | 0, N = e[p + 4 >> 2];
                                              a: {
                                                if (!N || (_r = e[N + 4 >> 2], e[N + 4 >> 2] = _r - 1, _r))
                                                  break a;
                                                xi[e[e[N >> 2] + 8 >> 2]](N), ys(N);
                                              }
                                              if ((p | 0) == (Xe | 0))
                                                break;
                                            }
                                            N = e[ar >> 2];
                                          }
                                          e[fr >> 2] = Xe, Br(N);
                                        }
                                        if (p = ar, (Te | 0) == (p | 0))
                                          break;
                                      }
                                      Te = e[W + 20 >> 2];
                                    }
                                    Br(Te);
                                  }
                                  if (Hi = Hi + 1 | 0, p = e[W + 44 >> 2], Hi >>> 0 < (e[W + 48 >> 2] - p | 0) / 12 >>> 0)
                                    continue;
                                  break t;
                                }
                                break;
                              }
                              if (e[5996] = 0, Vs(44, 5170, 1900, 642, 2497), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                break e;
                              p = Hr() | 0;
                            }
                            Nc(W + 20 | 0);
                            break i;
                          }
                          p = Hr() | 0;
                        }
                        r = e[W + 32 >> 2], r && Br(r), Xf(W + 44 | 0);
                        break r;
                      }
                      p = Hr() | 0;
                    }
                    ya(W + 56 | 0), Jn(p | 0), Oi();
                  }
                  if (r = e[W + 32 >> 2], r && (Br(r), p = e[W + 44 >> 2]), p) {
                    if (N = p, Te = e[W + 48 >> 2], (Te | 0) != (p | 0)) {
                      for (; r = Te - 12 | 0, s = e[r >> 2], s && (e[Te - 8 >> 2] = s, Br(s)), Te = r, (Te | 0) != (p | 0); )
                        ;
                      N = e[W + 44 >> 2];
                    }
                    e[W + 48 >> 2] = p, Br(N);
                  }
                  r = e[W + 68 >> 2], r && (e[W + 72 >> 2] = r, Br(r)), r = e[W + 56 >> 2], r && (e[W + 60 >> 2] = r, Br(r)), Jr = W + 128 | 0;
                  return;
                }
                Oi();
              }
              function ig(r, s, u, A, m, p, N, W, Te, Xe, fr) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0, m = m | 0, p = p | 0, N = N | 0, W = W | 0, Te = Te | 0, Xe = Xe | 0, fr = fr | 0;
                var ar = 0, vr = 0, _r = 0, hi = 0, mi = 0, Ni = 0, Hi = 0, Ji = 0, Ln = 0, _n = 0, hs = 0, bs = 0, Us = 0;
                ar = Jr - 528 | 0, Jr = ar, e[ar + 520 >> 2] = fr, e[ar + 524 >> 2] = s;
                e: {
                  t: {
                    if (Hu(r, ar + 524 | 0)) {
                      e[p >> 2] = e[p >> 2] | 4, r = 0;
                      break t;
                    }
                    if (e[ar + 72 >> 2] = 220, Ln = ar + 104 | 0, e[Ln >> 2] = ar + 112, Ji = ar + 72 | 0, e[Ln + 4 >> 2] = e[Ji >> 2], hi = e[Ln >> 2], e[ar + 100 >> 2] = hi, e[ar + 96 >> 2] = hi + 400, e[Ji >> 2] = 0, e[Ji + 4 >> 2] = 0, e[Ji + 8 >> 2] = 0, mi = ar + 60 | 0, e[mi >> 2] = 0, e[mi + 4 >> 2] = 0, e[mi + 8 >> 2] = 0, vr = ar + 48 | 0, e[vr >> 2] = 0, e[vr + 4 >> 2] = 0, e[vr + 8 >> 2] = 0, _r = ar + 36 | 0, e[_r >> 2] = 0, e[_r + 4 >> 2] = 0, e[_r + 8 >> 2] = 0, Ni = ar + 24 | 0, e[Ni >> 2] = 0, e[Ni + 4 >> 2] = 0, e[Ni + 8 >> 2] = 0, s = e[A >> 2], e[5996] = 0, Uf(229, u | 0, s | 0, ar + 92 | 0, ar + 88 | 0, ar + 84 | 0, Ji | 0, mi | 0, vr | 0, _r | 0, ar + 20 | 0), s = e[5996], e[5996] = 0, (s | 0) != 1)
                      for (e[Xe >> 2] = e[Te >> 2], hs = m & 512, _n = e[ar + 20 >> 2], m = 0; ; ) {
                        r: {
                          i: {
                            n: {
                              s: {
                                a: {
                                  if ((m | 0) == 4)
                                    break a;
                                  if (e[5996] = 0, s = pi(202, r | 0, ar + 524 | 0) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1)
                                    break e;
                                  if (s)
                                    break a;
                                  o: {
                                    l: {
                                      c: {
                                        d: {
                                          f:
                                            switch (_[(ar + 92 | 0) + m | 0]) {
                                              case 1:
                                                if ((m | 0) == 3)
                                                  break r;
                                                if (s = e[r >> 2], e[5996] = 0, s = Mi(203, s | 0) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1 || (e[5996] = 0, s = xn(230, W | 0, 1, s | 0) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1))
                                                  break e;
                                                if (s) {
                                                  if (e[5996] = 0, ji(231, ar + 12 | 0, r | 0), s = e[5996], e[5996] = 0, (s | 0) != 1 && (e[5996] = 0, ji(232, Ni | 0, e[ar + 12 >> 2]), s = e[5996], e[5996] = 0, (s | 0) != 1))
                                                    break d;
                                                  break e;
                                                }
                                                e[p >> 2] = e[p >> 2] | 4, r = 0;
                                                break i;
                                              case 4:
                                                break o;
                                              case 2:
                                                break l;
                                              case 3:
                                                break c;
                                              case 0:
                                                break f;
                                              default:
                                                break r;
                                            }
                                          if ((m | 0) == 3)
                                            break r;
                                        }
                                        for (; ; ) {
                                          if (e[5996] = 0, s = pi(202, r | 0, ar + 524 | 0) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1)
                                            break e;
                                          if (s)
                                            break r;
                                          if (s = e[r >> 2], e[5996] = 0, s = Mi(203, s | 0) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1 || (e[5996] = 0, s = xn(230, W | 0, 1, s | 0) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1))
                                            break e;
                                          if (!s)
                                            break r;
                                          if (e[5996] = 0, ji(231, ar + 12 | 0, r | 0), s = e[5996], e[5996] = 0, !((s | 0) != 1 && (e[5996] = 0, ji(232, Ni | 0, e[ar + 12 >> 2]), s = e[5996], e[5996] = 0, (s | 0) != 1)))
                                            break;
                                        }
                                        break e;
                                      }
                                      c: {
                                        if (s = me[vr + 11 | 0], !((s & 128) >>> 7 | 0 ? e[vr + 4 >> 2] : s & 127))
                                          break c;
                                        if (s = e[r >> 2], e[5996] = 0, s = Mi(203, s | 0) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1)
                                          break e;
                                        if (e[((me[vr + 11 | 0] & 128) >>> 7 | 0 ? e[vr >> 2] : vr) >> 2] != (s | 0))
                                          break c;
                                        if (e[5996] = 0, Mi(205, r | 0) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1)
                                          break e;
                                        _[N | 0] = 0, s = me[vr + 11 | 0], Hi = ((s & 128) >>> 7 | 0 ? e[vr + 4 >> 2] : s & 127) >>> 0 > 1 ? vr : Hi;
                                        break r;
                                      }
                                      c: {
                                        d: {
                                          if (fr = e[_r + 4 >> 2], s = me[_r + 11 | 0], (s & 128) >>> 7 | 0 ? fr : s & 127) {
                                            if (s = e[r >> 2], e[5996] = 0, s = Mi(203, s | 0) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1)
                                              break e;
                                            if (e[((me[_r + 11 | 0] & 128) >>> 7 | 0 ? e[_r >> 2] : _r) >> 2] == (s | 0))
                                              break d;
                                            fr = e[_r + 4 >> 2], s = me[_r + 11 | 0];
                                          }
                                          if (u = me[vr + 11 | 0], u = (u & 128) >>> 7 | 0 ? e[vr + 4 >> 2] : u & 127, !u | !((s & 128) >>> 7 | 0 ? fr : s & 127))
                                            break c;
                                          e[p >> 2] = e[p >> 2] | 4, r = 0;
                                          break i;
                                        }
                                        if (e[5996] = 0, Mi(205, r | 0) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1)
                                          break e;
                                        _[N | 0] = 1, s = me[_r + 11 | 0], Hi = ((s & 128) >>> 7 | 0 ? e[_r + 4 >> 2] : s & 127) >>> 0 > 1 ? _r : Hi;
                                        break r;
                                      }
                                      if (s = (s & 128) >>> 7 | 0 ? fr : s & 127, !(s | u))
                                        break r;
                                      _[N | 0] = !s;
                                      break r;
                                    }
                                    if (!(Hi | m >>> 0 < 2 | ((m | 0) == 2 & me[ar + 95 | 0] != 0 | hs))) {
                                      Hi = 0;
                                      break r;
                                    }
                                    e[ar + 12 >> 2] = Ga(mi);
                                    l: {
                                      if (!m | me[(m + ar | 0) + 91 | 0] > 1)
                                        break l;
                                      c: {
                                        for (; ; ) {
                                          if (u = Sa(mi), s = e[ar + 12 >> 2], (u | 0) == (s | 0))
                                            break c;
                                          if (s = e[s >> 2], e[5996] = 0, s = xn(230, W | 0, 1, s | 0) | 0, u = e[5996], e[5996] = 0, (u | 0) != 1) {
                                            if (!s)
                                              break c;
                                            e[ar + 12 >> 2] = e[ar + 12 >> 2] + 4;
                                            continue;
                                          }
                                          break;
                                        }
                                        break e;
                                      }
                                      if (s = Ga(mi), s = e[ar + 12 >> 2] - s >> 2, u = me[Ni + 11 | 0], s >>> 0 <= ((u & 128) >>> 7 | 0 ? e[Ni + 4 >> 2] : u & 127) >>> 0) {
                                        for (u = zd(Sa(Ni), 0 - s | 0), A = Sa(Ni), fr = Ga(mi), s = Jr - 16 | 0, Jr = s, e[s + 8 >> 2] = fr, e[s + 12 >> 2] = u; ; ) {
                                          if (fr = (u | 0) != (A | 0), !(!fr | e[u >> 2] != e[e[s + 8 >> 2] >> 2])) {
                                            e[s + 12 >> 2] = e[s + 12 >> 2] + 4, e[s + 8 >> 2] = e[s + 8 >> 2] + 4, u = e[s + 12 >> 2];
                                            continue;
                                          }
                                          break;
                                        }
                                        if (Jr = s + 16 | 0, !fr)
                                          break l;
                                      }
                                      e[ar + 8 >> 2] = Ga(mi), e[ar + 12 >> 2] = e[ar + 8 >> 2];
                                    }
                                    e[ar + 8 >> 2] = e[ar + 12 >> 2];
                                    l: {
                                      for (; ; ) {
                                        if ((Sa(mi) | 0) == e[ar + 8 >> 2])
                                          break l;
                                        e[5996] = 0, s = pi(202, r | 0, ar + 524 | 0) | 0, u = e[5996], e[5996] = 0;
                                        c: {
                                          if ((u | 0) == 1)
                                            break c;
                                          if (s)
                                            break l;
                                          if (s = e[r >> 2], e[5996] = 0, s = Mi(203, s | 0) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1)
                                            break c;
                                          if (e[e[ar + 8 >> 2] >> 2] != (s | 0))
                                            break l;
                                          if (e[5996] = 0, Mi(205, r | 0) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1)
                                            break e;
                                          e[ar + 8 >> 2] = e[ar + 8 >> 2] + 4;
                                          continue;
                                        }
                                        break;
                                      }
                                      break e;
                                    }
                                    if (!hs || (Sa(mi) | 0) == e[ar + 8 >> 2])
                                      break r;
                                    e[p >> 2] = e[p >> 2] | 4, r = 0;
                                    break i;
                                  }
                                  s = 0, bs = e[ar + 84 >> 2], u = hi;
                                  o: {
                                    for (; ; ) {
                                      l: {
                                        if (e[5996] = 0, A = pi(202, r | 0, ar + 524 | 0) | 0, fr = e[5996], e[5996] = 0, (fr | 0) == 1)
                                          break l;
                                        if (A)
                                          break o;
                                        if (A = e[r >> 2], e[5996] = 0, fr = Mi(203, A | 0) | 0, A = e[5996], e[5996] = 0, (A | 0) == 1 || (e[5996] = 0, A = xn(230, W | 0, 64, fr | 0) | 0, Us = e[5996], e[5996] = 0, (Us | 0) == 1))
                                          break e;
                                        c: {
                                          if (A) {
                                            if (A = e[Xe >> 2], (A | 0) == e[ar + 520 >> 2]) {
                                              if (e[5996] = 0, gs(233, Te | 0, Xe | 0, ar + 520 | 0), A = e[5996], e[5996] = 0, (A | 0) == 1)
                                                break e;
                                              A = e[Xe >> 2];
                                            }
                                            e[Xe >> 2] = A + 4, e[A >> 2] = fr, s = s + 1 | 0;
                                            break c;
                                          }
                                          if (A = me[Ji + 11 | 0], !((A & 128) >>> 7 | 0 ? e[Ji + 4 >> 2] : A & 127) | !s | (fr | 0) != (bs | 0))
                                            break o;
                                          if (e[ar + 96 >> 2] == (hi | 0)) {
                                            if (e[5996] = 0, gs(226, Ln | 0, ar + 100 | 0, ar + 96 | 0), u = e[5996], e[5996] = 0, (u | 0) == 1)
                                              break e;
                                            hi = e[ar + 100 >> 2];
                                          }
                                          u = hi + 4 | 0, e[ar + 100 >> 2] = u, e[hi >> 2] = s, hi = u, s = 0;
                                        }
                                        if (e[5996] = 0, Mi(205, r | 0) | 0, A = e[5996], e[5996] = 0, (A | 0) != 1)
                                          continue;
                                      }
                                      break;
                                    }
                                    break e;
                                  }
                                  if (!s | e[Ln >> 2] == (u | 0))
                                    break s;
                                  if (e[ar + 96 >> 2] == (u | 0)) {
                                    if (e[5996] = 0, gs(226, Ln | 0, ar + 100 | 0, ar + 96 | 0), u = e[5996], e[5996] = 0, (u | 0) == 1)
                                      break e;
                                    u = e[ar + 100 >> 2];
                                  }
                                  hi = u + 4 | 0, e[ar + 100 >> 2] = hi, e[u >> 2] = s;
                                  break n;
                                }
                                e[ar + 20 >> 2] = _n;
                                a: {
                                  if (!Hi)
                                    break a;
                                  for (fr = 1; ; ) {
                                    if (s = me[Hi + 11 | 0], ((s & 128) >>> 7 | 0 ? e[Hi + 4 >> 2] : s & 127) >>> 0 <= fr >>> 0)
                                      break a;
                                    e[5996] = 0, s = pi(202, r | 0, ar + 524 | 0) | 0, u = e[5996], e[5996] = 0;
                                    o: {
                                      if ((u | 0) == 1)
                                        break o;
                                      l: {
                                        if (!s) {
                                          if (s = e[r >> 2], e[5996] = 0, s = Mi(203, s | 0) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1)
                                            break o;
                                          if (e[(fr << 2) + ((me[Hi + 11 | 0] & 128) >>> 7 | 0 ? e[Hi >> 2] : Hi) >> 2] == (s | 0))
                                            break l;
                                        }
                                        e[p >> 2] = e[p >> 2] | 4, r = 0;
                                        break i;
                                      }
                                      if (e[5996] = 0, Mi(205, r | 0) | 0, s = e[5996], e[5996] = 0, fr = fr + 1 | 0, (s | 0) != 1)
                                        continue;
                                    }
                                    break;
                                  }
                                  break e;
                                }
                                if (r = 1, s = e[Ln >> 2], (s | 0) == (hi | 0))
                                  break i;
                                if (r = 0, e[ar + 12 >> 2] = 0, ka(Ji, s, hi, ar + 12 | 0), e[ar + 12 >> 2]) {
                                  e[p >> 2] = e[p >> 2] | 4;
                                  break i;
                                }
                                r = 1;
                                break i;
                              }
                              hi = u;
                            }
                            n: {
                              if ((_n | 0) <= 0)
                                break n;
                              if (e[5996] = 0, s = pi(202, r | 0, ar + 524 | 0) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1)
                                break e;
                              s: {
                                if (!s) {
                                  if (s = e[r >> 2], e[5996] = 0, s = Mi(203, s | 0) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1)
                                    break e;
                                  if (e[ar + 88 >> 2] == (s | 0))
                                    break s;
                                }
                                e[p >> 2] = e[p >> 2] | 4, r = 0;
                                break i;
                              }
                              if (e[5996] = 0, s = Mi(205, r | 0) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1)
                                break e;
                              for (; ; ) {
                                if ((_n | 0) <= 0) {
                                  _n = 0;
                                  break n;
                                }
                                e[5996] = 0, u = pi(202, s | 0, ar + 524 | 0) | 0, A = e[5996], e[5996] = 0;
                                s: {
                                  if ((A | 0) == 1)
                                    break s;
                                  a: {
                                    if (!u) {
                                      if (u = e[s >> 2], e[5996] = 0, u = Mi(203, u | 0) | 0, A = e[5996], e[5996] = 0, (A | 0) == 1 || (e[5996] = 0, u = xn(230, W | 0, 64, u | 0) | 0, A = e[5996], e[5996] = 0, (A | 0) == 1))
                                        break s;
                                      if (u)
                                        break a;
                                    }
                                    e[p >> 2] = e[p >> 2] | 4, r = 0;
                                    break i;
                                  }
                                  if (e[Xe >> 2] == e[ar + 520 >> 2] && (e[5996] = 0, gs(233, Te | 0, Xe | 0, ar + 520 | 0), u = e[5996], e[5996] = 0, (u | 0) == 1) || (u = e[s >> 2], e[5996] = 0, u = Mi(203, u | 0) | 0, A = e[5996], e[5996] = 0, (A | 0) == 1))
                                    break s;
                                  if (A = e[Xe >> 2], e[Xe >> 2] = A + 4, e[A >> 2] = u, e[5996] = 0, Mi(205, s | 0) | 0, u = e[5996], e[5996] = 0, _n = _n - 1 | 0, (u | 0) != 1)
                                    continue;
                                }
                                break;
                              }
                              break e;
                            }
                            if (e[Xe >> 2] != e[Te >> 2])
                              break r;
                            e[p >> 2] = e[p >> 2] | 4, r = 0;
                          }
                          Qn(Ni), Qn(_r), Qn(vr), Qn(mi), Qn(Ji), to(Ln);
                          break t;
                        }
                        m = m + 1 | 0;
                      }
                    break e;
                  }
                  return Jr = ar + 528 | 0, r | 0;
                }
                r = Hr() | 0, Qn(Ni), Qn(_r), Qn(vr), Qn(mi), Qn(Ji), to(Ln), Jn(r | 0), Oi();
              }
              function uh(r, s, u, A, m, p, N, W, Te, Xe, fr) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0, m = m | 0, p = p | 0, N = N | 0, W = W | 0, Te = Te | 0, Xe = Xe | 0, fr = fr | 0;
                var ar = 0, vr = 0, _r = 0, hi = 0, mi = 0, Ni = 0, Hi = 0, Ji = 0, Ln = 0, _n = 0, hs = 0, bs = 0, Us = 0, go = 0, _o = 0;
                ar = Jr - 528 | 0, Jr = ar, e[ar + 520 >> 2] = fr, e[ar + 524 >> 2] = s;
                e: {
                  t: {
                    if (Lu(r, ar + 524 | 0)) {
                      e[p >> 2] = e[p >> 2] | 4, r = 0;
                      break t;
                    }
                    if (e[ar + 76 >> 2] = 220, Ln = ar + 104 | 0, e[Ln >> 2] = ar + 112, Ji = ar + 76 | 0, e[Ln + 4 >> 2] = e[Ji >> 2], hi = e[Ln >> 2], e[ar + 100 >> 2] = hi, e[ar + 96 >> 2] = hi + 400, e[Ji >> 2] = 0, e[Ji + 4 >> 2] = 0, e[Ji + 8 >> 2] = 0, mi = ar - -64 | 0, e[mi >> 2] = 0, e[mi + 4 >> 2] = 0, e[mi + 8 >> 2] = 0, vr = ar + 52 | 0, e[vr >> 2] = 0, e[vr + 4 >> 2] = 0, e[vr + 8 >> 2] = 0, _r = ar + 40 | 0, e[_r >> 2] = 0, e[_r + 4 >> 2] = 0, e[_r + 8 >> 2] = 0, Ni = ar + 28 | 0, e[Ni >> 2] = 0, e[Ni + 4 >> 2] = 0, e[Ni + 8 >> 2] = 0, s = e[A >> 2], e[5996] = 0, Uf(223, u | 0, s | 0, ar + 92 | 0, ar + 91 | 0, ar + 90 | 0, Ji | 0, mi | 0, vr | 0, _r | 0, ar + 24 | 0), s = e[5996], e[5996] = 0, (s | 0) != 1)
                      for (e[Xe >> 2] = e[Te >> 2], bs = m & 512, _n = e[ar + 24 >> 2], Us = me[ar + 95 | 0], go = me[ar + 91 | 0], _o = me[ar + 90 | 0], A = hi, m = 0; ; ) {
                        r: {
                          i: {
                            n: {
                              s: {
                                if ((m | 0) == 4)
                                  break s;
                                if (e[5996] = 0, s = pi(186, r | 0, ar + 524 | 0) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1)
                                  break e;
                                if (s)
                                  break s;
                                s = 0;
                                a: {
                                  o: {
                                    l: {
                                      c: {
                                        d:
                                          switch (_[(ar + 92 | 0) + m | 0]) {
                                            case 1:
                                              if ((m | 0) == 3)
                                                break r;
                                              if (s = e[r >> 2], e[5996] = 0, s = Mi(187, s | 0) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1)
                                                break e;
                                              if (u = e[W + 8 >> 2], e[u + ((s & 255) << 2) >> 2] & 1 & (s | 0) >= 0) {
                                                if (e[5996] = 0, ji(224, ar + 16 | 0, r | 0), s = e[5996], e[5996] = 0, (s | 0) != 1 && (e[5996] = 0, ji(98, Ni | 0, _[ar + 16 | 0]), s = e[5996], e[5996] = 0, (s | 0) != 1))
                                                  break c;
                                                break e;
                                              }
                                              e[p >> 2] = e[p >> 2] | 4, r = 0;
                                              break i;
                                            case 4:
                                              break a;
                                            case 2:
                                              break o;
                                            case 3:
                                              break l;
                                            case 0:
                                              break d;
                                            default:
                                              break r;
                                          }
                                        if ((m | 0) == 3)
                                          break r;
                                      }
                                      for (; ; ) {
                                        if (e[5996] = 0, s = pi(186, r | 0, ar + 524 | 0) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1)
                                          break e;
                                        if (s)
                                          break r;
                                        if (s = e[r >> 2], e[5996] = 0, s = Mi(187, s | 0) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1)
                                          break e;
                                        if (u = e[W + 8 >> 2], !(e[u + ((s & 255) << 2) >> 2] & 1 & (s | 0) >= 0))
                                          break r;
                                        if (e[5996] = 0, ji(224, ar + 16 | 0, r | 0), s = e[5996], e[5996] = 0, !((s | 0) != 1 && (e[5996] = 0, ji(98, Ni | 0, _[ar + 16 | 0]), s = e[5996], e[5996] = 0, (s | 0) != 1)))
                                          break;
                                      }
                                      break e;
                                    }
                                    l: {
                                      if (s = me[vr + 11 | 0], !((s & 128) >>> 7 | 0 ? e[vr + 4 >> 2] : s & 127))
                                        break l;
                                      if (s = e[r >> 2], e[5996] = 0, s = Mi(187, s | 0) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1)
                                        break e;
                                      if (me[((me[vr + 11 | 0] & 128) >>> 7 | 0 ? e[vr >> 2] : vr) | 0] != (s & 255))
                                        break l;
                                      if (e[5996] = 0, Mi(189, r | 0) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1)
                                        break e;
                                      _[N | 0] = 0, s = me[vr + 11 | 0], Hi = ((s & 128) >>> 7 | 0 ? e[vr + 4 >> 2] : s & 127) >>> 0 > 1 ? vr : Hi;
                                      break r;
                                    }
                                    l: {
                                      c: {
                                        if (fr = e[_r + 4 >> 2], s = me[_r + 11 | 0], (s & 128) >>> 7 | 0 ? fr : s & 127) {
                                          if (s = e[r >> 2], e[5996] = 0, s = Mi(187, s | 0) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1)
                                            break e;
                                          if (me[((me[_r + 11 | 0] & 128) >>> 7 | 0 ? e[_r >> 2] : _r) | 0] == (s & 255))
                                            break c;
                                          fr = e[_r + 4 >> 2], s = me[_r + 11 | 0];
                                        }
                                        if (u = me[vr + 11 | 0], u = (u & 128) >>> 7 | 0 ? e[vr + 4 >> 2] : u & 127, !u | !((s & 128) >>> 7 | 0 ? fr : s & 127))
                                          break l;
                                        e[p >> 2] = e[p >> 2] | 4, r = 0;
                                        break i;
                                      }
                                      if (e[5996] = 0, Mi(189, r | 0) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1)
                                        break e;
                                      _[N | 0] = 1, s = me[_r + 11 | 0], Hi = ((s & 128) >>> 7 | 0 ? e[_r + 4 >> 2] : s & 127) >>> 0 > 1 ? _r : Hi;
                                      break r;
                                    }
                                    if (s = (s & 128) >>> 7 | 0 ? fr : s & 127, !(s | u))
                                      break r;
                                    _[N | 0] = !s;
                                    break r;
                                  }
                                  if (!(Hi | m >>> 0 < 2 | ((m | 0) == 2 & (Us | 0) != 0 | bs))) {
                                    Hi = 0;
                                    break r;
                                  }
                                  e[ar + 16 >> 2] = Ga(mi);
                                  o: {
                                    if (!m | me[(m + ar | 0) + 91 | 0] > 1)
                                      break o;
                                    for (; ; ) {
                                      l: {
                                        if (u = Bu(mi), s = e[ar + 16 >> 2], (u | 0) == (s | 0) || (u = e[W + 8 >> 2], s = _[s | 0], (s | 0) >= 0 ? s = e[u + ((s & 255) << 2) >> 2] & 1 : s = 0, !s))
                                          break l;
                                        e[ar + 16 >> 2] = e[ar + 16 >> 2] + 1;
                                        continue;
                                      }
                                      break;
                                    }
                                    if (s = Ga(mi), s = e[ar + 16 >> 2] - s | 0, u = me[Ni + 11 | 0], s >>> 0 <= ((u & 128) >>> 7 | 0 ? e[Ni + 4 >> 2] : u & 127) >>> 0) {
                                      for (u = Jd(Bu(Ni), 0 - s | 0), fr = Bu(Ni), hs = Ga(mi), s = Jr - 16 | 0, Jr = s, e[s + 8 >> 2] = hs, e[s + 12 >> 2] = u; ; ) {
                                        if (hs = (u | 0) != (fr | 0), !(!hs | me[u | 0] != me[e[s + 8 >> 2]])) {
                                          e[s + 12 >> 2] = e[s + 12 >> 2] + 1, e[s + 8 >> 2] = e[s + 8 >> 2] + 1, u = e[s + 12 >> 2];
                                          continue;
                                        }
                                        break;
                                      }
                                      if (Jr = s + 16 | 0, !hs)
                                        break o;
                                    }
                                    e[ar + 12 >> 2] = Ga(mi), e[ar + 16 >> 2] = e[ar + 12 >> 2];
                                  }
                                  e[ar + 12 >> 2] = e[ar + 16 >> 2];
                                  o: {
                                    for (; ; ) {
                                      if ((Bu(mi) | 0) == e[ar + 12 >> 2])
                                        break o;
                                      e[5996] = 0, s = pi(186, r | 0, ar + 524 | 0) | 0, u = e[5996], e[5996] = 0;
                                      l: {
                                        if ((u | 0) == 1)
                                          break l;
                                        if (s)
                                          break o;
                                        if (s = e[r >> 2], e[5996] = 0, s = Mi(187, s | 0) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1)
                                          break l;
                                        if (me[e[ar + 12 >> 2]] != (s & 255))
                                          break o;
                                        if (e[5996] = 0, Mi(189, r | 0) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1)
                                          break e;
                                        e[ar + 12 >> 2] = e[ar + 12 >> 2] + 1;
                                        continue;
                                      }
                                      break;
                                    }
                                    break e;
                                  }
                                  if (!bs || (Bu(mi) | 0) == e[ar + 12 >> 2])
                                    break r;
                                  e[p >> 2] = e[p >> 2] | 4, r = 0;
                                  break i;
                                }
                                a: {
                                  for (; ; ) {
                                    o: {
                                      if (e[5996] = 0, u = pi(186, r | 0, ar + 524 | 0) | 0, fr = e[5996], e[5996] = 0, (fr | 0) == 1)
                                        break o;
                                      if (u)
                                        break a;
                                      if (u = e[r >> 2], e[5996] = 0, fr = Mi(187, u | 0) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1)
                                        break e;
                                      u = e[W + 8 >> 2];
                                      l: {
                                        if ((fr | 0) >= 0 && e[u + ((fr & 255) << 2) >> 2] & 64) {
                                          if (u = e[Xe >> 2], (u | 0) == e[ar + 520 >> 2]) {
                                            if (e[5996] = 0, gs(225, Te | 0, Xe | 0, ar + 520 | 0), u = e[5996], e[5996] = 0, (u | 0) == 1)
                                              break e;
                                            u = e[Xe >> 2];
                                          }
                                          e[Xe >> 2] = u + 1, _[u | 0] = fr, s = s + 1 | 0;
                                          break l;
                                        }
                                        if (u = me[Ji + 11 | 0], !((u & 128) >>> 7 | 0 ? e[Ji + 4 >> 2] : u & 127) | !s | (fr & 255) != (_o | 0))
                                          break a;
                                        if (e[ar + 96 >> 2] == (A | 0)) {
                                          if (e[5996] = 0, gs(226, Ln | 0, ar + 100 | 0, ar + 96 | 0), u = e[5996], e[5996] = 0, (u | 0) == 1)
                                            break e;
                                          A = e[ar + 100 >> 2];
                                        }
                                        hi = A + 4 | 0, e[ar + 100 >> 2] = hi, e[A >> 2] = s, A = hi, s = 0;
                                      }
                                      if (e[5996] = 0, Mi(189, r | 0) | 0, u = e[5996], e[5996] = 0, (u | 0) != 1)
                                        continue;
                                    }
                                    break;
                                  }
                                  break e;
                                }
                                if (!(!s | e[Ln >> 2] == (hi | 0))) {
                                  if (e[ar + 96 >> 2] == (hi | 0)) {
                                    if (e[5996] = 0, gs(226, Ln | 0, ar + 100 | 0, ar + 96 | 0), u = e[5996], e[5996] = 0, (u | 0) == 1)
                                      break e;
                                    hi = e[ar + 100 >> 2];
                                  }
                                  u = hi + 4 | 0, e[ar + 100 >> 2] = u, e[hi >> 2] = s, hi = u;
                                }
                                if ((_n | 0) <= 0)
                                  break n;
                                if (e[5996] = 0, s = pi(186, r | 0, ar + 524 | 0) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1)
                                  break e;
                                a: {
                                  if (!s) {
                                    if (s = e[r >> 2], e[5996] = 0, s = Mi(187, s | 0) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1)
                                      break e;
                                    if ((s & 255) == (go | 0))
                                      break a;
                                  }
                                  e[p >> 2] = e[p >> 2] | 4, r = 0;
                                  break i;
                                }
                                if (e[5996] = 0, s = Mi(189, r | 0) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1)
                                  break e;
                                for (; ; ) {
                                  if ((_n | 0) <= 0) {
                                    _n = 0;
                                    break n;
                                  }
                                  e[5996] = 0, u = pi(186, s | 0, ar + 524 | 0) | 0, A = e[5996], e[5996] = 0;
                                  a: {
                                    if ((A | 0) == 1)
                                      break a;
                                    o: {
                                      if (!u) {
                                        if (u = e[s >> 2], e[5996] = 0, u = Mi(187, u | 0) | 0, A = e[5996], e[5996] = 0, (A | 0) == 1)
                                          break a;
                                        if (A = e[W + 8 >> 2], (u | 0) >= 0 && e[A + ((u & 255) << 2) >> 2] & 64)
                                          break o;
                                      }
                                      e[p >> 2] = e[p >> 2] | 4, r = 0;
                                      break i;
                                    }
                                    if (e[Xe >> 2] == e[ar + 520 >> 2] && (e[5996] = 0, gs(225, Te | 0, Xe | 0, ar + 520 | 0), u = e[5996], e[5996] = 0, (u | 0) == 1) || (u = e[s >> 2], e[5996] = 0, u = Mi(187, u | 0) | 0, A = e[5996], e[5996] = 0, (A | 0) == 1))
                                      break a;
                                    if (A = e[Xe >> 2], e[Xe >> 2] = A + 1, _[A | 0] = u, e[5996] = 0, Mi(189, s | 0) | 0, u = e[5996], e[5996] = 0, _n = _n - 1 | 0, (u | 0) != 1)
                                      continue;
                                  }
                                  break;
                                }
                                break e;
                              }
                              e[ar + 24 >> 2] = _n;
                              s: {
                                if (!Hi)
                                  break s;
                                for (fr = 1; ; ) {
                                  if (s = me[Hi + 11 | 0], ((s & 128) >>> 7 | 0 ? e[Hi + 4 >> 2] : s & 127) >>> 0 <= fr >>> 0)
                                    break s;
                                  e[5996] = 0, s = pi(186, r | 0, ar + 524 | 0) | 0, u = e[5996], e[5996] = 0;
                                  a: {
                                    if ((u | 0) == 1)
                                      break a;
                                    o: {
                                      if (!s) {
                                        if (s = e[r >> 2], e[5996] = 0, s = Mi(187, s | 0) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1)
                                          break a;
                                        if (me[((me[Hi + 11 | 0] & 128) >>> 7 | 0 ? e[Hi >> 2] : Hi) + fr | 0] == (s & 255))
                                          break o;
                                      }
                                      e[p >> 2] = e[p >> 2] | 4, r = 0;
                                      break i;
                                    }
                                    if (e[5996] = 0, Mi(189, r | 0) | 0, s = e[5996], e[5996] = 0, fr = fr + 1 | 0, (s | 0) != 1)
                                      continue;
                                  }
                                  break;
                                }
                                break e;
                              }
                              if (r = 1, s = e[Ln >> 2], (s | 0) == (hi | 0))
                                break i;
                              if (r = 0, e[ar + 16 >> 2] = 0, ka(Ji, s, hi, ar + 16 | 0), e[ar + 16 >> 2]) {
                                e[p >> 2] = e[p >> 2] | 4;
                                break i;
                              }
                              r = 1;
                              break i;
                            }
                            if (A = hi, e[Xe >> 2] != e[Te >> 2])
                              break r;
                            e[p >> 2] = e[p >> 2] | 4, r = 0;
                          }
                          Qn(Ni), Qn(_r), Qn(vr), Qn(mi), Qn(Ji), to(Ln);
                          break t;
                        }
                        m = m + 1 | 0;
                      }
                    break e;
                  }
                  return Jr = ar + 528 | 0, r | 0;
                }
                r = Hr() | 0, Qn(Ni), Qn(_r), Qn(vr), Qn(mi), Qn(Ji), to(Ln), Jn(r | 0), Oi();
              }
              function ng(r, s) {
                r = r | 0, s = s | 0;
                var u = 0, A = 0, m = 0, p = 0, N = 0, W = 0, Te = 0, Xe = 0, fr = 0, ar = 0, vr = 0, _r = 0, hi = 0, mi = 0, Ni = 0, Hi = 0, Ji = 0;
                e: {
                  t: {
                    r: {
                      i: {
                        n: {
                          s: {
                            a:
                              switch (e[s >> 2]) {
                                case 0:
                                  e[r + 12 >> 2] = 1, e[r + 16 >> 2] = 0, e[r + 4 >> 2] = 0, e[r + 8 >> 2] = 0, e[r >> 2] = 0;
                                  return;
                                case 2:
                                  e[r + 12 >> 2] = 1, e[r + 16 >> 2] = 0;
                                  break t;
                                case 3:
                                  e[r + 12 >> 2] = 1, e[r + 16 >> 2] = 0, e[r + 4 >> 2] = 1, e[r + 8 >> 2] = 0, e[r >> 2] = 3;
                                  return;
                                case 4:
                                case 5:
                                  e[r + 12 >> 2] = 0, e[r + 16 >> 2] = 0, e[r + 4 >> 2] = 1, e[r + 8 >> 2] = 0, e[r >> 2] = 1;
                                  return;
                                case 6:
                                case 7:
                                case 8:
                                case 9:
                                  e[r + 12 >> 2] = 0, e[r + 16 >> 2] = 0, e[r + 4 >> 2] = 1, e[r + 8 >> 2] = 0, e[r >> 2] = 4;
                                  return;
                                case 17:
                                  s = e[s + 32 >> 2], u = e[s + 8 >> 2], W = e[u + 52 >> 2], s = e[s >> 2], p = e[s + 52 >> 2], m = me[s + 48 | 0], N = me[u + 48 | 0], u = e[u + 44 >> 2], s = e[s + 44 >> 2], e[r + 12 >> 2] = 0, e[r + 16 >> 2] = 0, e[r >> 2] = s + u;
                                  break e;
                                case 18:
                                  s = e[s + 32 >> 2], vr = e[s + 8 >> 2], W = e[vr + 52 >> 2], Xe = e[s >> 2], p = e[Xe + 52 >> 2], m = me[Xe + 48 | 0], N = me[vr + 48 | 0], Te = e[vr + 60 >> 2], A = e[Xe + 60 >> 2], u = me[Xe + 56 | 0], s = me[vr + 56 | 0], e[r >> 2] = (e[Xe + 44 >> 2] + e[vr + 44 >> 2] | 0) + 1, u = (u | 0) != 0 & (s | 0) != 0, s = u & 0, e[r + 12 >> 2] = s | u, e[r + 16 >> 2] = u ? A + Te | 0 : 0;
                                  break e;
                                case 19:
                                  s = e[s + 32 >> 2], W = e[s >> 2], N = e[W + 60 >> 2], p = me[W + 56 | 0] != 0, u = e[s + 8 >> 2], ar = p & me[u + 48 | 0] != 0, m = ar ? N + e[u + 52 >> 2] | 0 : 0, s = (e[W + 44 >> 2] + e[u + 44 >> 2] | 0) + 1 | 0, Te = e[u + 60 >> 2], A = me[u + 56 | 0], !me[W + 48 | 0] | !A || (u = Te + e[W + 52 >> 2] | 0, m = ar ? u >>> 0 > m >>> 0 ? u : m : u, ar = 1), e[r >> 2] = s, e[r + 4 >> 2] = ar, e[r + 8 >> 2] = m, m = p & (A | 0) != 0, s = m & 0, e[r + 12 >> 2] = s | m, e[r + 16 >> 2] = m ? N + Te | 0 : 0;
                                  return;
                                case 21:
                                  s = e[s + 32 >> 2], u = e[s >> 2], Xe = e[u + 60 >> 2], vr = e[s + 8 >> 2], m = Xe + e[vr + 52 >> 2] | 0, W = me[u + 56 | 0], s = me[vr + 48 | 0] != 0 & (W | 0) != 0, N = (e[u + 44 >> 2] + e[vr + 44 >> 2] | 0) + 3 | 0, A = s ? m : 0;
                                  o: {
                                    if (!me[u + 48 | 0])
                                      break o;
                                    if (!s) {
                                      s = e[u + 48 >> 2], p = s & -256, A = e[u + 52 >> 2];
                                      break o;
                                    }
                                    s = 1, u = e[u + 52 >> 2], A = u >>> 0 > m >>> 0 ? u : m;
                                  }
                                  Te = e[vr + 60 >> 2], m = me[vr + 56 | 0], e[r >> 2] = N, u = s & 255, s = 0, e[r + 4 >> 2] = u | (p | s), e[r + 8 >> 2] = A | mi, u = (W | 0) != 0 & (m | 0) != 0, s = u ? s : 0, e[r + 12 >> 2] = s | u, e[r + 16 >> 2] = u ? Te + Xe | 0 : 0;
                                  return;
                                case 20:
                                  s = e[s + 32 >> 2], Te = e[s >> 2], u = e[s + 8 >> 2], A = e[Te + 60 >> 2] + e[u + 52 >> 2] | 0, s = me[u + 48 | 0] != 0 & me[Te + 56 | 0] != 0, m = (e[Te + 44 >> 2] + e[u + 44 >> 2] | 0) + 2 | 0, u = s ? A : 0;
                                  o: {
                                    if (!me[Te + 48 | 0])
                                      break o;
                                    if (!s) {
                                      s = e[Te + 48 >> 2], p = s & -256, u = e[Te + 52 >> 2];
                                      break o;
                                    }
                                    s = 1, u = e[Te + 52 >> 2], u = u >>> 0 > A >>> 0 ? u : A;
                                  }
                                  e[r + 12 >> 2] = 0, e[r + 16 >> 2] = 0, e[r >> 2] = m, e[r + 4 >> 2] = p | s & 255, e[r + 8 >> 2] = u | mi;
                                  return;
                                case 22:
                                  s = e[s + 32 >> 2], A = e[s >> 2], Xe = e[s + 8 >> 2], p = e[A + 44 >> 2] + e[Xe + 44 >> 2] | 0;
                                  o: {
                                    if (!me[A + 48 | 0]) {
                                      s = e[Xe + 48 >> 2], W = s & -256, m = e[Xe + 52 >> 2];
                                      break o;
                                    }
                                    if (!me[Xe + 48 | 0]) {
                                      s = e[A + 48 >> 2], W = s & -256, m = e[A + 52 >> 2];
                                      break o;
                                    }
                                    s = 1, m = e[A + 52 >> 2], u = e[Xe + 52 >> 2], m = u >>> 0 < m >>> 0 ? m : u;
                                  }
                                  Te = p + 3 | 0;
                                  o: {
                                    if (!me[A + 56 | 0]) {
                                      p = e[Xe + 56 >> 2], N = p & -256, u = e[Xe + 60 >> 2];
                                      break o;
                                    }
                                    if (!me[Xe + 56 | 0]) {
                                      p = e[A + 56 >> 2], N = p & -256, u = e[A + 60 >> 2];
                                      break o;
                                    }
                                    p = 1, A = e[A + 60 >> 2], u = e[Xe + 60 >> 2], u = u >>> 0 < A >>> 0 ? A : u;
                                  }
                                  e[r >> 2] = Te, e[r + 12 >> 2] = p & 255 | N & -256, A = 0, e[r + 16 >> 2] = A | (u | A), e[r + 4 >> 2] = s & 255 | W & -256, p = 0, e[r + 8 >> 2] = p | (m | p);
                                  return;
                                case 23:
                                  s = e[s + 32 >> 2], W = e[s + 16 >> 2], p = e[s >> 2], N = e[p + 60 >> 2], Te = me[p + 56 | 0] != 0, A = Te & me[W + 48 | 0] != 0, m = A ? e[W + 52 >> 2] + N | 0 : 0, s = e[s + 8 >> 2], u = (e[W + 44 >> 2] + (e[p + 44 >> 2] + e[s + 44 >> 2] | 0) | 0) + 3 | 0, !me[s + 48 | 0] | !me[p + 48 | 0] || (s = e[p + 52 >> 2] + e[s + 52 >> 2] | 0, m = A ? s >>> 0 > m >>> 0 ? s : m : s, A = 1), p = e[W + 60 >> 2], s = me[W + 56 | 0], e[r >> 2] = u, e[r + 4 >> 2] = A, e[r + 8 >> 2] = m, m = Te & (s | 0) != 0, s = m & 0, e[r + 12 >> 2] = s | m, e[r + 16 >> 2] = m ? p + N | 0 : 0;
                                  return;
                                case 25:
                                  u = e[s + 12 >> 2], s = e[s + 8 >> 2], e[r >> 2] = 1, s = (u - s | 0) / 12 | 0, u = 1, e[r + 12 >> 2] = u, e[r + 16 >> 2] = s, e[r + 4 >> 2] = u, e[r + 8 >> 2] = s;
                                  return;
                                case 11:
                                case 12:
                                case 16:
                                  A = e[e[s + 32 >> 2] >> 2], p = e[A + 48 >> 2], m = e[A + 52 >> 2], u = e[A + 44 >> 2], s = e[A + 60 >> 2], e[r + 12 >> 2] = e[A + 56 >> 2], e[r + 16 >> 2] = s, e[r + 4 >> 2] = p, e[r + 8 >> 2] = m, e[r >> 2] = u + 1;
                                  return;
                                case 10:
                                  A = e[e[s + 32 >> 2] >> 2], p = e[A + 48 >> 2], m = e[A + 52 >> 2], u = e[A + 44 >> 2], s = e[A + 60 >> 2], e[r + 12 >> 2] = e[A + 56 >> 2], e[r + 16 >> 2] = s, e[r + 4 >> 2] = p, e[r + 8 >> 2] = m, e[r >> 2] = u + 2;
                                  return;
                                case 13:
                                  s = e[e[s + 32 >> 2] >> 2], m = e[s + 48 >> 2], u = e[s + 52 >> 2], s = e[s + 44 >> 2], e[r + 12 >> 2] = 1, e[r + 16 >> 2] = 0, e[r + 4 >> 2] = m, e[r + 8 >> 2] = u, e[r >> 2] = s + 3;
                                  return;
                                case 15:
                                  s = e[e[s + 32 >> 2] >> 2], m = e[s + 48 >> 2], u = e[s + 52 >> 2], s = e[s + 44 >> 2], e[r + 12 >> 2] = 1, e[r + 16 >> 2] = 0, e[r + 4 >> 2] = m, e[r + 8 >> 2] = u, e[r >> 2] = s + 4;
                                  return;
                                case 14:
                                  u = e[e[s + 32 >> 2] >> 2], A = e[u + 44 >> 2], p = e[u + 80 >> 2], m = pu(1239, 1), s = e[e[s + 32 >> 2] >> 2], u = e[s + 48 >> 2], s = e[s + 52 >> 2], e[r + 12 >> 2] = 0, e[r + 16 >> 2] = 0, e[r + 4 >> 2] = u, e[r + 8 >> 2] = s, e[r >> 2] = A + !(m & (p ^ -1));
                                  return;
                                case 24:
                                  if (u = Qs(8), e[u >> 2] = 1, e[u + 4 >> 2] = 0, ar = u + 8 | 0, _r = e[s + 32 >> 2], mi = e[s + 36 >> 2], (_r | 0) != (mi | 0))
                                    for (; ; ) {
                                      m = e[_r >> 2], W = e[m + 60 >> 2], N = me[m + 56 | 0], A = e[u + 4 >> 2], Te = u, p = me[u | 0], vr = e[m + 44 >> 2], e[5996] = 0, m = Mi(3, 8) | 0, u = e[5996], e[5996] = 0;
                                      o: {
                                        l: {
                                          if ((u | 0) != 1) {
                                            if (u = A + W | 0, A = (p | 0) != 0 & (N | 0) != 0, p = A & 0, e[m >> 2] = A | p, e[m + 4 >> 2] = A ? u : 0, N = m + 8 | 0, u = ar - Te | 0, Hi = u >> 3, u >>> 0 >= 9)
                                              break l;
                                            p = N;
                                            break o;
                                          }
                                          p = Hr() | 0, u = Te;
                                          break n;
                                        }
                                        for (Xe = Hi >>> 0 <= 2 ? 2 : Hi, ar = 1, p = N; ; ) {
                                          Ni = e[_r >> 2], u = Te + (ar << 3) | 0, fr = e[Ni + 60 >> 2] + e[u + 4 >> 2] | 0, A = u - 8 | 0, hi = me[A | 0] != 0 & me[Ni + 48 | 0] != 0, W = me[u | 0] != 0 & me[Ni + 56 | 0] != 0, u = W ? fr : 0, A = hi ? e[Ni + 52 >> 2] + e[A + 4 >> 2] | 0 : 0, u = W ? hi ? u >>> 0 > A >>> 0 ? u : A : fr : A, hi = W | hi;
                                          l: {
                                            if (p >>> 0 < N >>> 0) {
                                              e[p >> 2] = hi, e[p + 4 >> 2] = u, A = p;
                                              break l;
                                            }
                                            if (W = p - m >> 3, fr = W + 1 | 0, fr >>> 0 >= 536870912) {
                                              if (e[5996] = 0, Nn(93), r = e[5996], e[5996] = 0, (r | 0) == 1)
                                                break s;
                                              break r;
                                            }
                                            N = N - m | 0, A = N >> 2, fr = N >>> 0 >= 2147483640 ? 536870911 : A >>> 0 > fr >>> 0 ? A : fr;
                                            c: {
                                              if (!fr) {
                                                N = 0;
                                                break c;
                                              }
                                              if (fr >>> 0 >= 536870912) {
                                                if (e[5996] = 0, Nn(35), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                  break r;
                                                break s;
                                              }
                                              if (e[5996] = 0, N = Mi(3, fr << 3) | 0, A = e[5996], e[5996] = 0, (A | 0) == 1)
                                                break s;
                                            }
                                            A = (W << 3) + N | 0, e[A >> 2] = hi, e[A + 4 >> 2] = u, N = (fr << 3) + N | 0, u = A;
                                            c: {
                                              if ((m | 0) != (p | 0)) {
                                                for (; p = p - 8 | 0, W = e[p + 4 >> 2], u = u - 8 | 0, e[u >> 2] = e[p >> 2], e[u + 4 >> 2] = W, (m | 0) != (p | 0); )
                                                  ;
                                                if (!m)
                                                  break c;
                                              }
                                              Br(m);
                                            }
                                            m = u;
                                          }
                                          if (p = A + 8 | 0, ar = ar + 1 | 0, (Xe | 0) == (ar | 0))
                                            break;
                                        }
                                      }
                                      A = (Te + (Hi << 3) | 0) - 8 | 0, u = e[_r >> 2], fr = me[A | 0] != 0 & me[u + 48 | 0] != 0, A = fr ? e[u + 52 >> 2] + e[A + 4 >> 2] | 0 : 0;
                                      o: {
                                        if (p >>> 0 < N >>> 0) {
                                          e[p >> 2] = fr, e[p + 4 >> 2] = A, ar = p + 8 | 0, u = m;
                                          break o;
                                        }
                                        l: {
                                          c: {
                                            W = p - m >> 3, Xe = W + 1 | 0;
                                            d: {
                                              if (Xe >>> 0 >= 536870912) {
                                                e[5996] = 0, Nn(93);
                                                break d;
                                              }
                                              if (N = N - m | 0, u = N >> 2, u = N >>> 0 >= 2147483640 ? 536870911 : u >>> 0 > Xe >>> 0 ? u : Xe, !u) {
                                                u = 0;
                                                break l;
                                              }
                                              if (u >>> 0 < 536870912)
                                                break c;
                                              e[5996] = 0, Nn(35);
                                            }
                                            if (r = e[5996], e[5996] = 0, (r | 0) != 1)
                                              break r;
                                            break s;
                                          }
                                          if (e[5996] = 0, u = Mi(3, u << 3) | 0, N = e[5996], e[5996] = 0, (N | 0) == 1)
                                            break s;
                                        }
                                        if (u = (W << 3) + u | 0, e[u >> 2] = fr, e[u + 4 >> 2] = A, ar = u + 8 | 0, (m | 0) != (p | 0)) {
                                          for (; p = p - 8 | 0, A = e[p + 4 >> 2], u = u - 8 | 0, e[u >> 2] = e[p >> 2], e[u + 4 >> 2] = A, (m | 0) != (p | 0); )
                                            ;
                                          if (!m)
                                            break o;
                                        }
                                        Br(m);
                                      }
                                      if (Ji = (vr + Ji | 0) + 1 | 0, Br(Te), _r = _r + 8 | 0, (mi | 0) == (_r | 0))
                                        break;
                                    }
                                  if (s = e[s + 4 >> 2], s >>> 0 <= ar - u >> 3 >>> 0) {
                                    s = (s << 3) + u | 0, p = e[s >> 2], m = e[s + 4 >> 2], s = e[u + 4 >> 2], e[r + 12 >> 2] = e[u >> 2], e[r + 16 >> 2] = s, e[r + 4 >> 2] = p, e[r + 8 >> 2] = m, e[r >> 2] = Ji, Br(u);
                                    return;
                                  }
                                  if (e[5996] = 0, Vs(44, 5118, 2210, 799, 1422), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                    break r;
                                  if (p = Hr() | 0, !u)
                                    break i;
                                  break n;
                                default:
                                  ga(2350, 2210, 803, 1422), Oi();
                                case 1:
                                  break a;
                              }
                            e[r + 12 >> 2] = 0, e[r + 16 >> 2] = 0;
                            break t;
                          }
                          if (p = Hr() | 0, !m) {
                            u = Te;
                            break n;
                          }
                          Br(m), u = Te;
                        }
                        Br(u);
                      }
                      Jn(p | 0), Oi();
                    }
                    Oi();
                  }
                  e[r + 4 >> 2] = 1, e[r + 8 >> 2] = 0, e[r >> 2] = 0;
                  return;
                }
                m = (m | 0) != 0 & (N | 0) != 0, s = m & 0, e[r + 4 >> 2] = s | m, e[r + 8 >> 2] = m ? p + W | 0 : 0;
              }
              function sg(r, s, u) {
                r = r | 0, s = s | 0, u = u | 0;
                var A = 0, m = 0, p = 0, N = 0, W = 0;
                m = Jr - 80 | 0, Jr = m, A = Qs(32), e[m + 68 >> 2] = A, e[m + 72 >> 2] = 19, e[m + 76 >> 2] = -2147483616, p = me[5568] | me[5569] << 8 | (me[5570] << 16 | me[5571] << 24), _[A + 15 | 0] = p, _[A + 16 | 0] = p >>> 8, _[A + 17 | 0] = p >>> 16, _[A + 18 | 0] = p >>> 24, p = me[5565] | me[5566] << 8 | (me[5567] << 16 | me[5568] << 24), N = me[5561] | me[5562] << 8 | (me[5563] << 16 | me[5564] << 24), _[A + 8 | 0] = N, _[A + 9 | 0] = N >>> 8, _[A + 10 | 0] = N >>> 16, _[A + 11 | 0] = N >>> 24, _[A + 12 | 0] = p, _[A + 13 | 0] = p >>> 8, _[A + 14 | 0] = p >>> 16, _[A + 15 | 0] = p >>> 24, p = me[5557] | me[5558] << 8 | (me[5559] << 16 | me[5560] << 24), N = me[5553] | me[5554] << 8 | (me[5555] << 16 | me[5556] << 24), _[A | 0] = N, _[A + 1 | 0] = N >>> 8, _[A + 2 | 0] = N >>> 16, _[A + 3 | 0] = N >>> 24, _[A + 4 | 0] = p, _[A + 5 | 0] = p >>> 8, _[A + 6 | 0] = p >>> 16, _[A + 7 | 0] = p >>> 24, _[A + 19 | 0] = 0;
                e: {
                  t: {
                    r: {
                      i: {
                        n: {
                          s: {
                            a: {
                              o: {
                                l: {
                                  c: {
                                    d: {
                                      f: {
                                        u: {
                                          g: {
                                            A: {
                                              p: {
                                                A = e[e[s >> 2] + 80 >> 2];
                                                m: {
                                                  if (!A) {
                                                    if (e[5996] = 0, pi(97, m + 68 | 0, 2603) | 0, A = e[5996], e[5996] = 0, (A | 0) != 1)
                                                      break m;
                                                    break t;
                                                  }
                                                  if (e[5996] = 0, p = pi(54, 3557, 1) | 0, N = e[5996], e[5996] = 0, (N | 0) == 1)
                                                    break p;
                                                  if (!((A ^ -1) & p) && (e[5996] = 0, ji(98, m + 68 | 0, 66), A = e[5996], e[5996] = 0, (A | 0) == 1))
                                                    break t;
                                                  if (A = e[e[s >> 2] + 80 >> 2], e[5996] = 0, p = pi(54, 2796, 1) | 0, N = e[5996], e[5996] = 0, (N | 0) == 1)
                                                    break A;
                                                  if (!((A ^ -1) & p) && (e[5996] = 0, ji(98, m + 68 | 0, 86), A = e[5996], e[5996] = 0, (A | 0) == 1))
                                                    break t;
                                                  if (A = e[e[s >> 2] + 80 >> 2], e[5996] = 0, p = pi(54, 2777, 1) | 0, N = e[5996], e[5996] = 0, (N | 0) == 1)
                                                    break g;
                                                  if (!((A ^ -1) & p) && (e[5996] = 0, ji(98, m + 68 | 0, 87), A = e[5996], e[5996] = 0, (A | 0) == 1))
                                                    break t;
                                                  if (A = e[e[s >> 2] + 80 >> 2], e[5996] = 0, p = pi(54, 3310, 1) | 0, N = e[5996], e[5996] = 0, (N | 0) == 1)
                                                    break u;
                                                  if (!((A ^ -1) & p) && (e[5996] = 0, ji(98, m + 68 | 0, 75), A = e[5996], e[5996] = 0, (A | 0) == 1))
                                                    break t;
                                                  if (A = e[e[s >> 2] + 80 >> 2], e[5996] = 0, p = pi(54, 1029, 1) | 0, N = e[5996], e[5996] = 0, (N | 0) == 1)
                                                    break f;
                                                  if (!((A ^ -1) & p) && (e[5996] = 0, ji(98, m + 68 | 0, 122), A = e[5996], e[5996] = 0, (A | 0) == 1))
                                                    break t;
                                                  if (A = e[e[s >> 2] + 80 >> 2], e[5996] = 0, p = pi(54, 1959, 1) | 0, N = e[5996], e[5996] = 0, (N | 0) == 1)
                                                    break d;
                                                  if (!((A ^ -1) & p) && (e[5996] = 0, ji(98, m + 68 | 0, 111), A = e[5996], e[5996] = 0, (A | 0) == 1))
                                                    break t;
                                                  if (A = e[e[s >> 2] + 80 >> 2], e[5996] = 0, p = pi(54, 2029, 1) | 0, N = e[5996], e[5996] = 0, (N | 0) == 1)
                                                    break c;
                                                  if (!((A ^ -1) & p) && (e[5996] = 0, ji(98, m + 68 | 0, 110), A = e[5996], e[5996] = 0, (A | 0) == 1))
                                                    break t;
                                                  if (A = e[e[s >> 2] + 80 >> 2], e[5996] = 0, p = pi(54, 2522, 1) | 0, N = e[5996], e[5996] = 0, (N | 0) == 1)
                                                    break l;
                                                  if (!((A ^ -1) & p) && (e[5996] = 0, ji(98, m + 68 | 0, 100), A = e[5996], e[5996] = 0, (A | 0) == 1))
                                                    break t;
                                                  if (A = e[e[s >> 2] + 80 >> 2], e[5996] = 0, p = pi(54, 2315, 1) | 0, N = e[5996], e[5996] = 0, (N | 0) == 1)
                                                    break o;
                                                  if (!((A ^ -1) & p) && (e[5996] = 0, ji(98, m + 68 | 0, 102), A = e[5996], e[5996] = 0, (A | 0) == 1))
                                                    break t;
                                                  if (A = e[e[s >> 2] + 80 >> 2], e[5996] = 0, p = pi(54, 2451, 1) | 0, N = e[5996], e[5996] = 0, (N | 0) == 1)
                                                    break a;
                                                  if (!((A ^ -1) & p) && (e[5996] = 0, ji(98, m + 68 | 0, 101), A = e[5996], e[5996] = 0, (A | 0) == 1))
                                                    break t;
                                                  if (A = e[e[s >> 2] + 80 >> 2], e[5996] = 0, p = pi(54, 2049, 1) | 0, N = e[5996], e[5996] = 0, (N | 0) == 1)
                                                    break s;
                                                  if (!((A ^ -1) & p) && (e[5996] = 0, ji(98, m + 68 | 0, 109), A = e[5996], e[5996] = 0, (A | 0) == 1))
                                                    break t;
                                                  if (A = e[e[s >> 2] + 80 >> 2], e[5996] = 0, p = pi(54, 1295, 1) | 0, N = e[5996], e[5996] = 0, (N | 0) == 1)
                                                    break n;
                                                  if (!((A ^ -1) & p) && (e[5996] = 0, ji(98, m + 68 | 0, 117), A = e[5996], e[5996] = 0, (A | 0) == 1))
                                                    break t;
                                                  if (A = e[e[s >> 2] + 80 >> 2], e[5996] = 0, p = pi(54, 1681, 1) | 0, N = e[5996], e[5996] = 0, (N | 0) == 1)
                                                    break i;
                                                  if (!((A ^ -1) & p) && (e[5996] = 0, ji(98, m + 68 | 0, 115), A = e[5996], e[5996] = 0, (A | 0) == 1))
                                                    break t;
                                                  if (A = e[e[s >> 2] + 80 >> 2], e[5996] = 0, p = pi(54, 2165, 1) | 0, N = e[5996], e[5996] = 0, (N | 0) == 1)
                                                    break r;
                                                  if ((A ^ -1) & p)
                                                    break m;
                                                  if (e[5996] = 0, ji(98, m + 68 | 0, 107), A = e[5996], e[5996] = 0, (A | 0) == 1)
                                                    break t;
                                                }
                                                A = e[e[s >> 2] + 84 >> 2], e[5996] = 0, p = m + 44 | 0, ji(115, p | 0, A | 0), A = e[5996], e[5996] = 0;
                                                m: {
                                                  k: {
                                                    N: {
                                                      S: {
                                                        T: {
                                                          v: {
                                                            w: {
                                                              E: {
                                                                h: {
                                                                  R: {
                                                                    I: {
                                                                      B: {
                                                                        x: {
                                                                          b: {
                                                                            C: {
                                                                              if ((A | 0) != 1) {
                                                                                if (e[5996] = 0, A = xn(99, p | 0, 0, 5487) | 0, p = e[5996], e[5996] = 0, (p | 0) == 1)
                                                                                  break C;
                                                                                if (e[m - -64 >> 2] = e[A + 8 >> 2], p = e[A + 4 >> 2], e[m + 56 >> 2] = e[A >> 2], e[m + 60 >> 2] = p, e[A >> 2] = 0, e[A + 4 >> 2] = 0, e[A + 8 >> 2] = 0, e[5996] = 0, p = me[m + 67 | 0], N = p << 24 >> 24 < 0, p = xn(100, m + 68 | 0, (N ? e[m + 56 >> 2] : m + 56 | 0) | 0, (N ? e[m + 60 >> 2] : p) | 0) | 0, N = e[5996], e[5996] = 0, (N | 0) == 1)
                                                                                  break b;
                                                                                if (_[m + 67 | 0] < 0 && Br(e[m + 56 >> 2]), _[A + 11 | 0] < 0 && Br(e[A >> 2]), A = e[s >> 2], N = e[A + 52 >> 2], A = e[A + 44 >> 2], e[5996] = 0, W = m + 32 | 0, ji(164, W | 0, A + N | 0), A = e[5996], e[5996] = 0, (A | 0) == 1)
                                                                                  break B;
                                                                                if (e[5996] = 0, A = xn(99, W | 0, 0, 5459) | 0, N = e[5996], e[5996] = 0, (N | 0) == 1)
                                                                                  break I;
                                                                                if (e[m - -64 >> 2] = e[A + 8 >> 2], N = e[A + 4 >> 2], e[m + 56 >> 2] = e[A >> 2], e[m + 60 >> 2] = N, e[A >> 2] = 0, e[A + 4 >> 2] = 0, e[A + 8 >> 2] = 0, e[5996] = 0, W = p, p = me[m + 67 | 0], N = p << 24 >> 24 < 0, p = xn(100, W | 0, (N ? e[m + 56 >> 2] : m + 56 | 0) | 0, (N ? e[m + 60 >> 2] : p) | 0) | 0, N = e[5996], e[5996] = 0, (N | 0) == 1)
                                                                                  break R;
                                                                                if (_[m + 67 | 0] < 0 && Br(e[m + 56 >> 2]), _[A + 11 | 0] < 0 && Br(e[A >> 2]), s = e[e[s >> 2] + 68 >> 2], e[5996] = 0, A = m + 20 | 0, ji(164, A | 0, s + 1 | 0), s = e[5996], e[5996] = 0, (s | 0) == 1)
                                                                                  break E;
                                                                                if (e[5996] = 0, s = xn(99, A | 0, 0, 5524) | 0, A = e[5996], e[5996] = 0, (A | 0) == 1)
                                                                                  break w;
                                                                                if (e[m - -64 >> 2] = e[s + 8 >> 2], A = e[s + 4 >> 2], e[m + 56 >> 2] = e[s >> 2], e[m + 60 >> 2] = A, e[s >> 2] = 0, e[s + 4 >> 2] = 0, e[s + 8 >> 2] = 0, e[5996] = 0, W = p, A = me[m + 67 | 0], p = A << 24 >> 24 < 0, A = xn(100, W | 0, (p ? e[m + 56 >> 2] : m + 56 | 0) | 0, (p ? e[m + 60 >> 2] : A) | 0) | 0, p = e[5996], e[5996] = 0, (p | 0) == 1)
                                                                                  break v;
                                                                                if (_[m + 67 | 0] < 0 && Br(e[m + 56 >> 2]), _[s + 11 | 0] < 0 && Br(e[s >> 2]), e[5996] = 0, A = pi(97, A | 0, 3759) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1)
                                                                                  break S;
                                                                                if (e[m + 16 >> 2] = e[A + 8 >> 2], s = e[A + 4 >> 2], e[m + 8 >> 2] = e[A >> 2], e[m + 12 >> 2] = s, e[A >> 2] = 0, e[A + 4 >> 2] = 0, e[A + 8 >> 2] = 0, p = e[u >> 2], N = e[u + 4 >> 2], s = me[u + 11 | 0], e[5996] = 0, W = u, u = s << 24 >> 24 < 0, s = xn(100, m + 8 | 0, (u ? p : W) | 0, (u ? N : s) | 0) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1)
                                                                                  break N;
                                                                                if (e[m - -64 >> 2] = e[s + 8 >> 2], u = e[s + 4 >> 2], e[m + 56 >> 2] = e[s >> 2], e[m + 60 >> 2] = u, e[s >> 2] = 0, e[s + 4 >> 2] = 0, e[s + 8 >> 2] = 0, e[5996] = 0, u = pi(97, m + 56 | 0, 3559) | 0, p = e[5996], e[5996] = 0, (p | 0) == 1)
                                                                                  break k;
                                                                                p = e[u + 4 >> 2], e[r >> 2] = e[u >> 2], e[r + 4 >> 2] = p, e[r + 8 >> 2] = e[u + 8 >> 2], e[u >> 2] = 0, e[u + 4 >> 2] = 0, e[u + 8 >> 2] = 0, _[s + 11 | 0] < 0 && Br(e[s >> 2]), _[A + 11 | 0] < 0 && Br(e[A >> 2]), Jr = m + 80 | 0;
                                                                                return;
                                                                              }
                                                                              s = Hr() | 0;
                                                                              break e;
                                                                            }
                                                                            s = Hr() | 0;
                                                                            break x;
                                                                          }
                                                                          if (s = Hr() | 0, _[m + 67 | 0] >= 0)
                                                                            break x;
                                                                          Br(e[m + 56 >> 2]);
                                                                        }
                                                                        if (_[m + 55 | 0] >= 0)
                                                                          break e;
                                                                        Br(e[m + 44 >> 2]);
                                                                        break e;
                                                                      }
                                                                      s = Hr() | 0;
                                                                      break e;
                                                                    }
                                                                    s = Hr() | 0;
                                                                    break h;
                                                                  }
                                                                  if (s = Hr() | 0, _[m + 67 | 0] >= 0)
                                                                    break h;
                                                                  Br(e[m + 56 >> 2]);
                                                                }
                                                                if (_[m + 43 | 0] >= 0)
                                                                  break e;
                                                                Br(e[m + 32 >> 2]);
                                                                break e;
                                                              }
                                                              s = Hr() | 0;
                                                              break e;
                                                            }
                                                            s = Hr() | 0;
                                                            break T;
                                                          }
                                                          if (s = Hr() | 0, _[m + 67 | 0] >= 0)
                                                            break T;
                                                          Br(e[m + 56 >> 2]);
                                                        }
                                                        if (_[m + 31 | 0] >= 0)
                                                          break e;
                                                        Br(e[m + 20 >> 2]);
                                                        break e;
                                                      }
                                                      s = Hr() | 0;
                                                      break e;
                                                    }
                                                    s = Hr() | 0;
                                                    break m;
                                                  }
                                                  if (s = Hr() | 0, _[m + 67 | 0] >= 0)
                                                    break m;
                                                  Br(e[m + 56 >> 2]);
                                                }
                                                if (_[m + 19 | 0] >= 0)
                                                  break e;
                                                Br(e[m + 8 >> 2]);
                                                break e;
                                              }
                                              s = Hr() | 0;
                                              break e;
                                            }
                                            s = Hr() | 0;
                                            break e;
                                          }
                                          s = Hr() | 0;
                                          break e;
                                        }
                                        s = Hr() | 0;
                                        break e;
                                      }
                                      s = Hr() | 0;
                                      break e;
                                    }
                                    s = Hr() | 0;
                                    break e;
                                  }
                                  s = Hr() | 0;
                                  break e;
                                }
                                s = Hr() | 0;
                                break e;
                              }
                              s = Hr() | 0;
                              break e;
                            }
                            s = Hr() | 0;
                            break e;
                          }
                          s = Hr() | 0;
                          break e;
                        }
                        s = Hr() | 0;
                        break e;
                      }
                      s = Hr() | 0;
                      break e;
                    }
                    s = Hr() | 0;
                    break e;
                  }
                  s = Hr() | 0;
                }
                _[m + 79 | 0] < 0 && Br(e[m + 68 >> 2]), Jn(s | 0), Oi();
              }
              function zl(r, s, u, A, m, p) {
                r = r | 0, s = +s, u = u | 0, A = A | 0, m = m | 0, p = p | 0;
                var N = 0, W = 0, Te = 0, Xe = 0, fr = 0, ar = 0, vr = 0, _r = 0, hi = 0, mi = 0, Ni = 0, Hi = 0, Ji = 0, Ln = 0, _n = 0, hs = 0, bs = 0, Us = 0, go = 0;
                vr = Jr - 560 | 0, Jr = vr, e[vr + 44 >> 2] = 0, Ca(+s), N = _s(1) | 0, _s(0) | 0;
                e: {
                  if ((N | 0) < 0) {
                    Ji = 1, bs = 1222, s = -s, Ca(+s), N = _s(1) | 0, _s(0) | 0;
                    break e;
                  }
                  if (m & 2048) {
                    Ji = 1, bs = 1225;
                    break e;
                  }
                  Ji = m & 1, bs = Ji ? 1228 : 1223, go = !Ji;
                }
                e: {
                  if ((N & 2146435072) == 2146435072) {
                    N = Ji + 3 | 0, pa(r, 32, u, N, m & -65537), ba(r, bs, Ji), A = p & 32, ba(r, s != s ? A ? 2020 : 3082 : A ? 2300 : 3355, 3), pa(r, 32, u, N, m ^ 8192), hi = (u | 0) < (N | 0) ? N : u;
                    break e;
                  }
                  _n = vr + 16 | 0;
                  t: {
                    r: {
                      i: {
                        if (s = Oc(s, vr + 44 | 0), s = s + s, s != 0) {
                          if (N = e[vr + 44 >> 2], e[vr + 44 >> 2] = N - 1, hs = p | 32, (hs | 0) != 97)
                            break i;
                          break t;
                        }
                        if (hs = p | 32, (hs | 0) == 97)
                          break t;
                        Xe = e[vr + 44 >> 2], ar = (A | 0) < 0 ? 6 : A;
                        break r;
                      }
                      Xe = N - 29 | 0, e[vr + 44 >> 2] = Xe, s = s * 268435456, ar = (A | 0) < 0 ? 6 : A;
                    }
                    for (Ni = (vr + 48 | 0) + ((Xe | 0) >= 0 ? 288 : 0) | 0, W = Ni; s < 4294967296 & s >= 0 ? A = ~~s >>> 0 : A = 0, e[W >> 2] = A, W = W + 4 | 0, s = (s - +(A >>> 0)) * 1e9, s != 0; )
                      ;
                    r: {
                      if ((Xe | 0) <= 0) {
                        A = Xe, N = W, Te = Ni;
                        break r;
                      }
                      for (Te = Ni, A = Xe; ; ) {
                        fr = (A | 0) >= 29 ? 29 : A, N = W - 4 | 0;
                        i: {
                          if (Te >>> 0 > N >>> 0)
                            break i;
                          for (_r = 0; A = e[N >> 2], hi = fr & 31, Us = _r, (fr & 63) >>> 0 >= 32 ? (_r = A << hi, A = 0) : (_r = (1 << hi) - 1 & A >>> 32 - hi, A = A << hi), hi = Us + A | 0, _r = _r + mi | 0, _r = dd(hi, A >>> 0 > hi >>> 0 ? _r + 1 | 0 : _r, 1e9), A = Ao(_r, Ds, -1e9, 0) + hi | 0, e[N >> 2] = A, N = N - 4 | 0, Te >>> 0 <= N >>> 0; )
                            ;
                          if (!_r)
                            break i;
                          Te = Te - 4 | 0, e[Te >> 2] = _r;
                        }
                        for (; N = W, Te >>> 0 < N >>> 0 && (W = N - 4 | 0, !e[W >> 2]); )
                          ;
                        if (A = e[vr + 44 >> 2] - fr | 0, e[vr + 44 >> 2] = A, W = N, !((A | 0) > 0))
                          break;
                      }
                    }
                    if ((A | 0) < 0)
                      for (Ln = ((ar + 25 >>> 0) / 9 | 0) + 1 | 0, mi = (hs | 0) == 102; ; ) {
                        A = 0 - A | 0, hi = (A | 0) >= 9 ? 9 : A;
                        r: {
                          if (N >>> 0 <= Te >>> 0) {
                            W = e[Te >> 2];
                            break r;
                          }
                          for (_r = 1e9 >>> hi | 0, fr = -1 << hi ^ -1, A = 0, W = Te; Us = A, A = e[W >> 2], e[W >> 2] = Us + (A >>> hi | 0), A = Sn(_r, A & fr), W = W + 4 | 0, W >>> 0 < N >>> 0; )
                            ;
                          if (W = e[Te >> 2], !A)
                            break r;
                          e[N >> 2] = A, N = N + 4 | 0;
                        }
                        if (A = hi + e[vr + 44 >> 2] | 0, e[vr + 44 >> 2] = A, Te = (!W << 2) + Te | 0, W = mi ? Ni : Te, N = N - W >> 2 > (Ln | 0) ? W + (Ln << 2) | 0 : N, !((A | 0) < 0))
                          break;
                      }
                    A = 0;
                    r: {
                      if (N >>> 0 <= Te >>> 0 || (A = Sn(Ni - Te >> 2, 9), W = 10, fr = e[Te >> 2], fr >>> 0 < 10))
                        break r;
                      for (; A = A + 1 | 0, W = Sn(W, 10), fr >>> 0 >= W >>> 0; )
                        ;
                    }
                    if (W = (ar - ((hs | 0) != 102 ? A : 0) | 0) - ((hs | 0) == 103 & (ar | 0) != 0) | 0, (W | 0) < (Sn(N - Ni >> 2, 9) - 9 | 0)) {
                      if (_r = W + 9216 | 0, fr = (_r | 0) / 9 | 0, Xe = ((((Xe | 0) < 0 ? 4 : 292) + vr | 0) + (fr << 2) | 0) - 4048 | 0, W = 10, hi = _r + Sn(fr, -9) | 0, (hi | 0) <= 7)
                        for (; W = Sn(W, 10), hi = hi + 1 | 0, (hi | 0) != 8; )
                          ;
                      _r = e[Xe >> 2], Ln = (_r >>> 0) / (W >>> 0) | 0, mi = Sn(Ln, W), fr = Xe + 4 | 0;
                      r: {
                        if ((_r | 0) == (mi | 0) & (fr | 0) == (N | 0))
                          break r;
                        _r = _r - mi | 0;
                        i: {
                          if (!(Ln & 1) && (s = 9007199254740992, !(_[Xe - 4 | 0] & 1) | ((W | 0) != 1e9 | Te >>> 0 >= Xe >>> 0)))
                            break i;
                          s = 9007199254740994;
                        }
                        if (Hi = (N | 0) == (fr | 0) ? 1 : 1.5, fr = W >>> 1 | 0, Hi = fr >>> 0 > _r >>> 0 ? 0.5 : (fr | 0) == (_r | 0) ? Hi : 1.5, me[bs | 0] != 45 | go || (Hi = -Hi, s = -s), e[Xe >> 2] = mi, s + Hi == s)
                          break r;
                        if (A = W + mi | 0, e[Xe >> 2] = A, A >>> 0 >= 1e9)
                          for (; e[Xe >> 2] = 0, Xe = Xe - 4 | 0, Xe >>> 0 < Te >>> 0 && (Te = Te - 4 | 0, e[Te >> 2] = 0), A = e[Xe >> 2] + 1 | 0, e[Xe >> 2] = A, A >>> 0 > 999999999; )
                            ;
                        if (A = Sn(Ni - Te >> 2, 9), W = 10, fr = e[Te >> 2], fr >>> 0 < 10)
                          break r;
                        for (; A = A + 1 | 0, W = Sn(W, 10), fr >>> 0 >= W >>> 0; )
                          ;
                      }
                      W = Xe + 4 | 0, N = N >>> 0 > W >>> 0 ? W : N;
                    }
                    for (; fr = N, _r = N >>> 0 <= Te >>> 0, !_r && (N = N - 4 | 0, !e[N >> 2]); )
                      ;
                    r: {
                      if ((hs | 0) != 103) {
                        Xe = m & 8;
                        break r;
                      }
                      if (W = ar || 1, N = (W | 0) > (A | 0) & (A | 0) > -5, ar = (N ? A ^ -1 : -1) + W | 0, p = (N ? -1 : -2) + p | 0, Xe = m & 8, Xe)
                        break r;
                      N = -9;
                      i: {
                        if (_r || (Xe = e[fr - 4 >> 2], !Xe) || (hi = 10, N = 0, (Xe >>> 0) % 10 | 0))
                          break i;
                        for (; W = N, N = N + 1 | 0, hi = Sn(hi, 10), !((Xe >>> 0) % (hi >>> 0) | 0); )
                          ;
                        N = W ^ -1;
                      }
                      if (W = Sn(fr - Ni >> 2, 9), (p & -33) == 70) {
                        Xe = 0, N = (N + W | 0) - 9 | 0, N = (N | 0) > 0 ? N : 0, ar = (N | 0) > (ar | 0) ? ar : N;
                        break r;
                      }
                      Xe = 0, N = ((A + W | 0) + N | 0) - 9 | 0, N = (N | 0) > 0 ? N : 0, ar = (N | 0) > (ar | 0) ? ar : N;
                    }
                    if (hi = -1, _r = Xe | ar, ((_r ? 2147483645 : 2147483646) | 0) < (ar | 0))
                      break e;
                    mi = (((_r | 0) != 0) + ar | 0) + 1 | 0, W = p & -33;
                    r: {
                      if ((W | 0) == 70) {
                        if ((mi ^ 2147483647) < (A | 0))
                          break e;
                        N = (A | 0) > 0 ? A : 0;
                        break r;
                      }
                      if (N = A >> 31, N = Jf((N ^ A) - N | 0, 0, _n), (_n - N | 0) <= 1)
                        for (; N = N - 1 | 0, _[N | 0] = 48, (_n - N | 0) < 2; )
                          ;
                      if (Ln = N - 2 | 0, _[Ln | 0] = p, _[N - 1 | 0] = (A | 0) < 0 ? 45 : 43, N = _n - Ln | 0, (N | 0) > (mi ^ 2147483647))
                        break e;
                    }
                    if (A = N + mi | 0, (A | 0) > (Ji ^ 2147483647))
                      break e;
                    mi = A + Ji | 0, pa(r, 32, u, mi, m), ba(r, bs, Ji), pa(r, 48, u, mi, m ^ 65536);
                    r: {
                      i: {
                        n: {
                          if ((W | 0) == 70) {
                            for (p = vr + 16 | 0, A = p | 8, Xe = p | 9, W = Te >>> 0 > Ni >>> 0 ? Ni : Te, Te = W; ; ) {
                              N = Jf(e[Te >> 2], 0, Xe);
                              s: {
                                if ((W | 0) != (Te | 0)) {
                                  if (vr + 16 >>> 0 >= N >>> 0)
                                    break s;
                                  for (; N = N - 1 | 0, _[N | 0] = 48, vr + 16 >>> 0 < N >>> 0; )
                                    ;
                                  break s;
                                }
                                if ((N | 0) != (Xe | 0))
                                  break s;
                                _[vr + 24 | 0] = 48, N = A;
                              }
                              if (ba(r, N, Xe - N | 0), Te = Te + 4 | 0, !(Ni >>> 0 >= Te >>> 0))
                                break;
                            }
                            if (_r && ba(r, 4352, 1), (ar | 0) <= 0 | Te >>> 0 >= fr >>> 0)
                              break n;
                            for (; ; ) {
                              if (N = Jf(e[Te >> 2], 0, Xe), N >>> 0 > vr + 16 >>> 0)
                                for (; N = N - 1 | 0, _[N | 0] = 48, vr + 16 >>> 0 < N >>> 0; )
                                  ;
                              if (ba(r, N, (ar | 0) >= 9 ? 9 : ar), N = ar - 9 | 0, Te = Te + 4 | 0, fr >>> 0 <= Te >>> 0)
                                break i;
                              if (A = (ar | 0) > 9, ar = N, !A)
                                break;
                            }
                            break i;
                          }
                          s: {
                            if ((ar | 0) < 0)
                              break s;
                            for (Ni = Te >>> 0 < fr >>> 0 ? fr : Te + 4 | 0, p = vr + 16 | 0, A = p | 8, fr = p | 9, W = Te; ; ) {
                              N = Jf(e[W >> 2], 0, fr), (fr | 0) == (N | 0) && (_[vr + 24 | 0] = 48, N = A);
                              a: {
                                if ((W | 0) != (Te | 0)) {
                                  if (vr + 16 >>> 0 >= N >>> 0)
                                    break a;
                                  for (; N = N - 1 | 0, _[N | 0] = 48, vr + 16 >>> 0 < N >>> 0; )
                                    ;
                                  break a;
                                }
                                if (ba(r, N, 1), N = N + 1 | 0, !(Xe | ar))
                                  break a;
                                ba(r, 4352, 1);
                              }
                              if (p = fr - N | 0, ba(r, N, (p | 0) < (ar | 0) ? p : ar), ar = ar - p | 0, W = W + 4 | 0, Ni >>> 0 <= W >>> 0)
                                break s;
                              if (!((ar | 0) >= 0))
                                break;
                            }
                          }
                          pa(r, 48, ar + 18 | 0, 18, 0), ba(r, Ln, _n - Ln | 0);
                          break r;
                        }
                        N = ar;
                      }
                      pa(r, 48, N + 9 | 0, 9, 0);
                    }
                    pa(r, 32, u, mi, m ^ 8192), hi = (u | 0) < (mi | 0) ? mi : u;
                    break e;
                  }
                  Xe = (p << 26 >> 31 & 9) + bs | 0;
                  t: {
                    if (A >>> 0 > 11)
                      break t;
                    for (N = 12 - A | 0, Hi = 16; Hi = Hi * 16, N = N - 1 | 0, !!N; )
                      ;
                    if (me[Xe | 0] == 45) {
                      s = -(Hi + (-s - Hi));
                      break t;
                    }
                    s = s + Hi - Hi;
                  }
                  for (Ni = Ji | 2, Te = p & 32, W = e[vr + 44 >> 2], N = W >> 31, N = Jf((N ^ W) - N | 0, 0, _n), (_n | 0) == (N | 0) && (_[vr + 15 | 0] = 48, N = vr + 15 | 0), ar = N - 2 | 0, _[ar | 0] = p + 15, _[N - 1 | 0] = (W | 0) < 0 ? 45 : 43, N = m & 8, W = vr + 16 | 0; p = W, $d(s) < 2147483648 ? fr = ~~s : fr = -2147483648, _[W | 0] = Te | me[fr + 7488 | 0], s = (s - +(fr | 0)) * 16, W = p + 1 | 0, !((A | 0) > 0 | N) & s == 0 | (W - (vr + 16 | 0) | 0) != 1 || (_[p + 1 | 0] = 46, W = p + 2 | 0), s != 0; )
                    ;
                  if (hi = -1, N = _n - ar | 0, p = N + Ni | 0, (2147483645 - p | 0) < (A | 0))
                    break e;
                  fr = p, p = vr + 16 | 0, Te = W - p | 0, A = A && (Te - 2 | 0) < (A | 0) ? A + 2 | 0 : Te, W = fr + A | 0, pa(r, 32, u, W, m), ba(r, Xe, Ni), pa(r, 48, u, W, m ^ 65536), ba(r, p, Te), pa(r, 48, A - Te | 0, 0, 0), ba(r, ar, N), pa(r, 32, u, W, m ^ 8192), hi = (u | 0) < (W | 0) ? W : u;
                }
                return Jr = vr + 560 | 0, hi | 0;
              }
              function fh(r, s) {
                r = r | 0, s = s | 0;
                var u = 0, A = 0, m = 0, p = 0, N = 0, W = 0, Te = 0, Xe = 0, fr = 0, ar = 0, vr = 0, _r = 0, hi = 0, mi = 0, Ni = 0;
                e: {
                  t: {
                    r: {
                      i: {
                        n: {
                          s: {
                            a:
                              switch (e[s >> 2]) {
                                case 1:
                                case 4:
                                case 5:
                                  e[r + 8 >> 2] = 0, e[r + 12 >> 2] = 0, e[r >> 2] = 1, e[r + 4 >> 2] = 0;
                                  return;
                                case 2:
                                  e[r + 8 >> 2] = 1, e[r + 12 >> 2] = 1;
                                  break e;
                                case 3:
                                  e[r + 8 >> 2] = 1, e[r + 12 >> 2] = 2, e[r >> 2] = 1, e[r + 4 >> 2] = 2;
                                  return;
                                case 6:
                                case 7:
                                case 8:
                                case 9:
                                  e[r + 8 >> 2] = 0, e[r + 12 >> 2] = 0;
                                  break e;
                                case 23:
                                  A = e[s + 32 >> 2], s = e[A + 16 >> 2], u = e[A >> 2], m = e[u + 76 >> 2], Xe = me[u + 72 | 0] != 0, Te = Xe & me[s + 64 | 0] != 0, p = Te ? e[s + 68 >> 2] + m | 0 : 0;
                                  o: {
                                    if (!me[u + 64 | 0] || (A = e[A + 8 >> 2], !me[A + 64 | 0]))
                                      break o;
                                    u = e[A + 68 >> 2] + e[u + 68 >> 2] | 0, p = Te ? u >>> 0 > p >>> 0 ? u : p : u, Te = 1;
                                  }
                                  A = e[s + 76 >> 2], s = me[s + 72 | 0], e[r >> 2] = Te, e[r + 4 >> 2] = p, s = Xe & (s | 0) != 0, u = s & 0, e[r + 8 >> 2] = s | u, e[r + 12 >> 2] = s ? A + m | 0 : 0;
                                  return;
                                case 17:
                                  s = e[s + 32 >> 2], u = e[s + 8 >> 2], A = e[u + 68 >> 2], s = e[s >> 2], p = e[s + 68 >> 2], s = me[s + 64 | 0], m = me[u + 64 | 0], e[r + 8 >> 2] = 0, e[r + 12 >> 2] = 0, u = A + p | 0, s = (s | 0) != 0 & (m | 0) != 0, A = s & 0, e[r >> 2] = s | A, e[r + 4 >> 2] = s ? u : 0;
                                  return;
                                case 18:
                                  u = e[s + 32 >> 2], s = e[u + 8 >> 2], p = e[s + 68 >> 2], A = e[u >> 2], m = e[A + 68 >> 2], Xe = me[A + 64 | 0], N = me[s + 64 | 0], u = e[s + 76 >> 2] + e[A + 76 >> 2] | 0, s = me[A + 72 | 0] != 0 & me[s + 72 | 0] != 0, A = s & 0, e[r + 8 >> 2] = s | A, e[r + 12 >> 2] = s ? u : 0, s = (Xe | 0) != 0 & (N | 0) != 0, A = s & 0, e[r >> 2] = s | A, e[r + 4 >> 2] = s ? m + p | 0 : 0;
                                  return;
                                case 19:
                                  u = e[s + 32 >> 2], s = e[u + 8 >> 2], p = e[s + 76 >> 2], Xe = me[s + 72 | 0] != 0, A = e[u >> 2], Te = Xe & me[A + 64 | 0] != 0, u = Te ? p + e[A + 68 >> 2] | 0 : 0, m = e[A + 76 >> 2], N = me[A + 72 | 0], !N | !me[s + 64 | 0] || (s = m + e[s + 68 >> 2] | 0, u = Te ? s >>> 0 > u >>> 0 ? s : u : s, Te = 1), e[r >> 2] = Te, e[r + 4 >> 2] = u, s = Xe & (N | 0) != 0, A = s & 0, e[r + 8 >> 2] = s | A, e[r + 12 >> 2] = s ? m + p | 0 : 0;
                                  return;
                                case 20:
                                  s = e[s + 32 >> 2], m = e[s + 8 >> 2], u = e[s >> 2], A = e[m + 68 >> 2] + e[u + 76 >> 2] | 0, s = me[u + 72 | 0] != 0 & me[m + 64 | 0] != 0, m = s ? A : 0;
                                  o: {
                                    if (!me[u + 64 | 0])
                                      break o;
                                    if (!s) {
                                      s = e[u + 64 >> 2], p = s & -256, m = e[u + 68 >> 2];
                                      break o;
                                    }
                                    s = 1, u = e[u + 68 >> 2], m = u >>> 0 > A >>> 0 ? u : A;
                                  }
                                  u = m, e[r + 8 >> 2] = 0, e[r + 12 >> 2] = 0, e[r >> 2] = p | s & 255, e[r + 4 >> 2] = u | Xe;
                                  return;
                                case 21:
                                  s = e[s + 32 >> 2], A = e[s + 8 >> 2], u = e[s >> 2], N = e[u + 76 >> 2], m = e[A + 68 >> 2] + N | 0, Te = me[u + 72 | 0], s = (Te | 0) != 0 & me[A + 64 | 0] != 0, W = s ? m : 0;
                                  o: {
                                    if (!me[u + 64 | 0])
                                      break o;
                                    if (!s) {
                                      s = e[u + 64 >> 2], p = s & -256, W = e[u + 68 >> 2];
                                      break o;
                                    }
                                    s = 1, u = e[u + 68 >> 2], W = u >>> 0 > m >>> 0 ? u : m;
                                  }
                                  m = W, u = e[A + 76 >> 2], A = me[A + 72 | 0], W = s & 255, s = 0, e[r >> 2] = W | (p | s), e[r + 4 >> 2] = m | Xe, m = u + N | 0, u = s, s = (Te | 0) != 0 & (A | 0) != 0, u = s ? u : 0, e[r + 8 >> 2] = s | u, e[r + 12 >> 2] = s ? m : 0;
                                  return;
                                case 22:
                                  A = e[s + 32 >> 2], s = e[A + 8 >> 2], p = me[s + 64 | 0], u = p ? e[s + 68 >> 2] + 1 | 0 : 0, m = e[A >> 2], me[m + 64 | 0] && (A = e[m + 68 >> 2] + 1 | 0, u = p ? u >>> 0 < A >>> 0 ? A : u : A, p = 1), Xe = e[s + 76 >> 2] + 1 | 0, s = me[s + 72 | 0], A = s ? Xe : 0, me[m + 72 | 0] && (m = e[m + 76 >> 2] + 1 | 0, A = s ? A >>> 0 < m >>> 0 ? m : A : m, s = 1), Xe = s, s = 0, e[r + 8 >> 2] = Xe | s, e[r + 12 >> 2] = A, e[r >> 2] = s | p, e[r + 4 >> 2] = u;
                                  return;
                                case 25:
                                  u = e[s + 4 >> 2] + 1 | 0, s = 1, e[r + 8 >> 2] = s, e[r + 12 >> 2] = u;
                                  break t;
                                case 10:
                                case 11:
                                case 12:
                                case 16:
                                  s = e[e[s + 32 >> 2] >> 2], u = e[s + 68 >> 2], e[r >> 2] = e[s + 64 >> 2], e[r + 4 >> 2] = u, u = e[s + 76 >> 2], e[r + 8 >> 2] = e[s + 72 >> 2], e[r + 12 >> 2] = u;
                                  return;
                                case 13:
                                  s = e[e[s + 32 >> 2] >> 2], u = e[s + 68 >> 2], s = me[s + 64 | 0], e[r + 8 >> 2] = 1, e[r + 12 >> 2] = 1, Xe = s, s = !s, e[r >> 2] = Xe | s & 0, e[r + 4 >> 2] = s ? 0 : u + 1 | 0;
                                  return;
                                case 14:
                                  u = e[e[s + 32 >> 2] >> 2], s = e[u + 64 >> 2], u = e[u + 68 >> 2], e[r + 8 >> 2] = 0, e[r + 12 >> 2] = 0;
                                  break t;
                                case 15:
                                  u = e[e[s + 32 >> 2] >> 2], s = e[u + 64 >> 2], u = e[u + 68 >> 2], e[r + 8 >> 2] = 1, e[r + 12 >> 2] = 1;
                                  break t;
                                case 24:
                                  if (u = Qs(8), e[u >> 2] = 1, e[u + 4 >> 2] = 0, Te = u + 8 | 0, ar = e[s + 32 >> 2], hi = e[s + 36 >> 2], (ar | 0) != (hi | 0))
                                    for (; ; ) {
                                      A = e[ar >> 2], m = e[A + 76 >> 2], A = me[A + 72 | 0], N = e[u + 4 >> 2], Xe = u, fr = me[u | 0], e[5996] = 0, p = Mi(3, 8) | 0, u = e[5996], e[5996] = 0;
                                      o: {
                                        l: {
                                          if ((u | 0) != 1) {
                                            if (u = m + N | 0, A = (fr | 0) != 0 & (A | 0) != 0, m = A & 0, e[p >> 2] = A | m, e[p + 4 >> 2] = A ? u : 0, N = p + 8 | 0, u = Te - Xe | 0, fr = u >> 3, u >>> 0 >= 9)
                                              break l;
                                            A = N;
                                            break o;
                                          }
                                          A = Hr() | 0, u = Xe;
                                          break n;
                                        }
                                        for (Ni = fr >>> 0 <= 2 ? 2 : fr, Te = 1, A = N; ; ) {
                                          u = e[ar >> 2], W = Xe + (Te << 3) | 0, vr = e[u + 76 >> 2] + e[W + 4 >> 2] | 0, _r = W - 8 | 0, m = me[_r | 0] != 0 & me[u + 64 | 0] != 0, W = me[W | 0] != 0 & me[u + 72 | 0] != 0, mi = W ? vr : 0, u = m ? e[u + 68 >> 2] + e[_r + 4 >> 2] | 0 : 0, u = W ? m ? u >>> 0 < mi >>> 0 ? mi : u : vr : u, vr = m | W;
                                          l: {
                                            if (A >>> 0 < N >>> 0) {
                                              e[A >> 2] = vr, e[A + 4 >> 2] = u, m = A;
                                              break l;
                                            }
                                            if (_r = A - p >> 3, m = _r + 1 | 0, m >>> 0 >= 536870912) {
                                              if (e[5996] = 0, Nn(93), r = e[5996], e[5996] = 0, (r | 0) == 1)
                                                break s;
                                              break r;
                                            }
                                            N = N - p | 0, W = N >> 2, W = N >>> 0 >= 2147483640 ? 536870911 : m >>> 0 < W >>> 0 ? W : m;
                                            c: {
                                              if (!W) {
                                                N = 0;
                                                break c;
                                              }
                                              if (W >>> 0 >= 536870912) {
                                                if (e[5996] = 0, Nn(35), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                                  break r;
                                                break s;
                                              }
                                              if (e[5996] = 0, N = Mi(3, W << 3) | 0, m = e[5996], e[5996] = 0, (m | 0) == 1)
                                                break s;
                                            }
                                            m = (_r << 3) + N | 0, e[m >> 2] = vr, e[m + 4 >> 2] = u, N = (W << 3) + N | 0, u = m;
                                            c: {
                                              if ((A | 0) != (p | 0)) {
                                                for (; A = A - 8 | 0, W = e[A + 4 >> 2], u = u - 8 | 0, e[u >> 2] = e[A >> 2], e[u + 4 >> 2] = W, (A | 0) != (p | 0); )
                                                  ;
                                                if (!p)
                                                  break c;
                                              }
                                              Br(p);
                                            }
                                            p = u;
                                          }
                                          if (A = m + 8 | 0, Te = Te + 1 | 0, (Ni | 0) == (Te | 0))
                                            break;
                                        }
                                      }
                                      u = (Xe + (fr << 3) | 0) - 8 | 0, m = e[ar >> 2], Te = me[u | 0] != 0 & me[m + 64 | 0] != 0, m = Te ? e[m + 68 >> 2] + e[u + 4 >> 2] | 0 : 0;
                                      o: {
                                        if (A >>> 0 < N >>> 0) {
                                          e[A >> 2] = Te, e[A + 4 >> 2] = m, Te = A + 8 | 0, u = p;
                                          break o;
                                        }
                                        l: {
                                          c: {
                                            fr = A - p >> 3, u = fr + 1 | 0;
                                            d: {
                                              if (u >>> 0 >= 536870912) {
                                                e[5996] = 0, Nn(93);
                                                break d;
                                              }
                                              if (N = N - p | 0, W = N >> 2, u = N >>> 0 >= 2147483640 ? 536870911 : u >>> 0 < W >>> 0 ? W : u, !u) {
                                                u = 0;
                                                break l;
                                              }
                                              if (u >>> 0 < 536870912)
                                                break c;
                                              e[5996] = 0, Nn(35);
                                            }
                                            if (r = e[5996], e[5996] = 0, (r | 0) != 1)
                                              break r;
                                            break s;
                                          }
                                          if (e[5996] = 0, u = Mi(3, u << 3) | 0, N = e[5996], e[5996] = 0, (N | 0) == 1)
                                            break s;
                                        }
                                        if (u = (fr << 3) + u | 0, e[u >> 2] = Te, e[u + 4 >> 2] = m, Te = u + 8 | 0, (A | 0) != (p | 0)) {
                                          for (; A = A - 8 | 0, m = e[A + 4 >> 2], u = u - 8 | 0, e[u >> 2] = e[A >> 2], e[u + 4 >> 2] = m, (A | 0) != (p | 0); )
                                            ;
                                          if (!p)
                                            break o;
                                        }
                                        Br(p);
                                      }
                                      if (Br(Xe), ar = ar + 8 | 0, (hi | 0) == (ar | 0))
                                        break;
                                    }
                                  if (s = e[s + 4 >> 2], s >>> 0 <= Te - u >> 3 >>> 0) {
                                    s = (s << 3) + u | 0, A = e[s >> 2], s = e[s + 4 >> 2], p = e[u + 4 >> 2], e[r + 8 >> 2] = e[u >> 2], e[r + 12 >> 2] = p, e[r >> 2] = A, e[r + 4 >> 2] = s, Br(u);
                                    return;
                                  }
                                  if (e[5996] = 0, Vs(44, 5118, 2210, 850, 2317), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                    break r;
                                  if (A = Hr() | 0, !u)
                                    break i;
                                  break n;
                                default:
                                  ga(2350, 2210, 854, 2317), Oi();
                                case 0:
                                  break a;
                              }
                            e[r + 8 >> 2] = 1, e[r + 12 >> 2] = 0, e[r >> 2] = 0, e[r + 4 >> 2] = 0;
                            return;
                          }
                          if (A = Hr() | 0, !p) {
                            u = Xe;
                            break n;
                          }
                          Br(p), u = Xe;
                        }
                        Br(u);
                      }
                      Jn(A | 0), Oi();
                    }
                    Oi();
                  }
                  e[r >> 2] = s, e[r + 4 >> 2] = u;
                  return;
                }
                e[r >> 2] = 1, e[r + 4 >> 2] = 1;
              }
              function Jl(r, s, u, A, m) {
                var p = 0, N = 0, W = 0, Te = 0, Xe = 0, fr = 0, ar = 0, vr = 0, _r = 0, hi = 0, mi = 0, Ni = 0, Hi = 0, Ji = 0, Ln = 0, _n = 0, hs = 0, bs = 0, Us = 0;
                W = Jr - 80 | 0, Jr = W, e[W + 76 >> 2] = s, Us = W + 55 | 0, Ni = W + 56 | 0;
                e: {
                  t: {
                    r: {
                      i: for (; ; ) {
                        p = 0;
                        n: for (; ; ) {
                          if (fr = s, (mi ^ 2147483647) < (p | 0))
                            break r;
                          mi = p + mi | 0;
                          s: {
                            a: {
                              o: {
                                if (p = s, N = me[p | 0], N)
                                  for (; ; ) {
                                    l: {
                                      s = N & 255;
                                      c: {
                                        if (!s) {
                                          s = p;
                                          break c;
                                        }
                                        if ((s | 0) != 37)
                                          break l;
                                        for (N = p; ; ) {
                                          if (me[N + 1 | 0] != 37) {
                                            s = N;
                                            break c;
                                          }
                                          if (p = p + 1 | 0, ar = me[N + 2 | 0], s = N + 2 | 0, N = s, (ar | 0) != 37)
                                            break;
                                        }
                                      }
                                      if (p = p - fr | 0, bs = mi ^ 2147483647, (p | 0) > (bs | 0))
                                        break r;
                                      if (r && ba(r, fr, p), p)
                                        continue n;
                                      e[W + 76 >> 2] = s, p = s + 1 | 0, hi = -1, N = _[s + 1 | 0], me[s + 2 | 0] != 36 | N - 48 >>> 0 >= 10 || (hi = N - 48 | 0, Hi = 1, p = s + 3 | 0), e[W + 76 >> 2] = p, vr = 0, N = _[p | 0], s = N - 32 | 0;
                                      c: {
                                        if (s >>> 0 > 31) {
                                          ar = p;
                                          break c;
                                        }
                                        if (ar = p, s = 1 << s, !(s & 75913))
                                          break c;
                                        for (; ; ) {
                                          if (ar = p + 1 | 0, e[W + 76 >> 2] = ar, vr = s | vr, N = _[p + 1 | 0], s = N - 32 | 0, s >>> 0 >= 32)
                                            break c;
                                          if (p = ar, s = 1 << s, !(s & 75913))
                                            break;
                                        }
                                      }
                                      c: {
                                        if ((N | 0) == 42) {
                                          s = _[ar + 1 | 0];
                                          d: {
                                            if (!(me[ar + 2 | 0] != 36 | s - 48 >>> 0 >= 10)) {
                                              s = s - 48 | 0;
                                              f: {
                                                if (!r) {
                                                  e[(s << 2) + m >> 2] = 10, _r = 0;
                                                  break f;
                                                }
                                                _r = e[(s << 3) + A >> 2];
                                              }
                                              s = ar + 3 | 0, Hi = 1;
                                              break d;
                                            }
                                            if (Hi)
                                              break o;
                                            if (s = ar + 1 | 0, !r) {
                                              e[W + 76 >> 2] = s, Hi = 0, _r = 0;
                                              break c;
                                            }
                                            p = e[u >> 2], e[u >> 2] = p + 4, _r = e[p >> 2], Hi = 0;
                                          }
                                          if (e[W + 76 >> 2] = s, (_r | 0) >= 0)
                                            break c;
                                          _r = 0 - _r | 0, vr = vr | 8192;
                                          break c;
                                        }
                                        if (_r = Fd(W + 76 | 0), (_r | 0) < 0)
                                          break r;
                                        s = e[W + 76 >> 2];
                                      }
                                      p = 0, Te = -1, N = 0;
                                      c: {
                                        if (me[s | 0] != 46)
                                          break c;
                                        if (me[s + 1 | 0] == 42) {
                                          N = _[s + 2 | 0];
                                          d: {
                                            if (!(me[s + 3 | 0] != 36 | N - 48 >>> 0 >= 10)) {
                                              N = N - 48 | 0, s = s + 4 | 0;
                                              f: {
                                                if (!r) {
                                                  e[(N << 2) + m >> 2] = 10, Te = 0;
                                                  break f;
                                                }
                                                Te = e[(N << 3) + A >> 2];
                                              }
                                              break d;
                                            }
                                            if (Hi)
                                              break o;
                                            if (s = s + 2 | 0, Te = 0, !r)
                                              break d;
                                            N = e[u >> 2], e[u >> 2] = N + 4, Te = e[N >> 2];
                                          }
                                          e[W + 76 >> 2] = s, N = (Te ^ -1) >>> 31 | 0;
                                          break c;
                                        }
                                        e[W + 76 >> 2] = s + 1, Te = Fd(W + 76 | 0), s = e[W + 76 >> 2], N = 1;
                                      }
                                      for (Ln = N; ; ) {
                                        if (Ji = p, Xe = 28, _n = s, N = _[s | 0], N - 123 >>> 0 < 4294967238)
                                          break t;
                                        if (s = s + 1 | 0, p = me[(N + Sn(p, 58) | 0) + 6959 | 0], !(p - 1 >>> 0 < 8))
                                          break;
                                      }
                                      e[W + 76 >> 2] = s;
                                      c: {
                                        if ((p | 0) != 27) {
                                          if (!p)
                                            break t;
                                          if ((hi | 0) >= 0) {
                                            if (!r) {
                                              e[(hi << 2) + m >> 2] = p;
                                              continue i;
                                            }
                                            p = (hi << 3) + A | 0, N = e[p + 4 >> 2], e[W + 64 >> 2] = e[p >> 2], e[W + 68 >> 2] = N;
                                            break c;
                                          }
                                          if (!r)
                                            break s;
                                          Sc(W - -64 | 0, p, u);
                                          break c;
                                        }
                                        if ((hi | 0) >= 0)
                                          break t;
                                        if (p = 0, !r)
                                          continue n;
                                      }
                                      if (Xe = -1, me[r | 0] & 32)
                                        break e;
                                      N = vr & -65537, vr = vr & 8192 ? N : vr, hi = 0, hs = 1212, ar = Ni;
                                      c: {
                                        d: {
                                          f: {
                                            u: {
                                              g: {
                                                A: {
                                                  p: {
                                                    m: {
                                                      k: {
                                                        N: {
                                                          S: {
                                                            T: {
                                                              v: {
                                                                w: {
                                                                  E: {
                                                                    h:
                                                                      switch (p = _[_n | 0], p = Ji && (p & 15) == 3 ? p & -33 : p, p - 88 | 0) {
                                                                        case 11:
                                                                          break c;
                                                                        case 9:
                                                                        case 13:
                                                                        case 14:
                                                                        case 15:
                                                                          break d;
                                                                        case 27:
                                                                          break p;
                                                                        case 12:
                                                                        case 17:
                                                                          break N;
                                                                        case 23:
                                                                          break S;
                                                                        case 0:
                                                                        case 32:
                                                                          break T;
                                                                        case 24:
                                                                          break v;
                                                                        case 22:
                                                                          break w;
                                                                        case 29:
                                                                          break E;
                                                                        case 1:
                                                                        case 2:
                                                                        case 3:
                                                                        case 4:
                                                                        case 5:
                                                                        case 6:
                                                                        case 7:
                                                                        case 8:
                                                                        case 10:
                                                                        case 16:
                                                                        case 18:
                                                                        case 19:
                                                                        case 20:
                                                                        case 21:
                                                                        case 25:
                                                                        case 26:
                                                                        case 28:
                                                                        case 30:
                                                                        case 31:
                                                                          break a;
                                                                        default:
                                                                          break h;
                                                                      }
                                                                    h:
                                                                      switch (p - 65 | 0) {
                                                                        case 0:
                                                                        case 4:
                                                                        case 5:
                                                                        case 6:
                                                                          break d;
                                                                        case 2:
                                                                          break g;
                                                                        case 1:
                                                                        case 3:
                                                                          break a;
                                                                        default:
                                                                          break h;
                                                                      }
                                                                    if ((p | 0) == 83)
                                                                      break A;
                                                                    break a;
                                                                  }
                                                                  N = e[W + 64 >> 2], Xe = e[W + 68 >> 2], p = 1212;
                                                                  break k;
                                                                }
                                                                p = 0;
                                                                w:
                                                                  switch (Ji & 255) {
                                                                    case 0:
                                                                      e[e[W + 64 >> 2] >> 2] = mi;
                                                                      continue n;
                                                                    case 1:
                                                                      e[e[W + 64 >> 2] >> 2] = mi;
                                                                      continue n;
                                                                    case 2:
                                                                      N = e[W + 64 >> 2], e[N >> 2] = mi, e[N + 4 >> 2] = mi >> 31;
                                                                      continue n;
                                                                    case 3:
                                                                      Zs[e[W + 64 >> 2] >> 1] = mi;
                                                                      continue n;
                                                                    case 4:
                                                                      _[e[W + 64 >> 2]] = mi;
                                                                      continue n;
                                                                    case 6:
                                                                      e[e[W + 64 >> 2] >> 2] = mi;
                                                                      continue n;
                                                                    case 7:
                                                                      break w;
                                                                    default:
                                                                      continue n;
                                                                  }
                                                                N = e[W + 64 >> 2], e[N >> 2] = mi, e[N + 4 >> 2] = mi >> 31;
                                                                continue n;
                                                              }
                                                              Te = Te >>> 0 <= 8 ? 8 : Te, vr = vr | 8, p = 120;
                                                            }
                                                            if (fr = Ni, _n = p & 32, N = e[W + 64 >> 2], Xe = e[W + 68 >> 2], N | Xe)
                                                              for (; fr = fr - 1 | 0, _[fr | 0] = _n | me[(N & 15) + 7488 | 0], Ji = !Xe & N >>> 0 > 15 | (Xe | 0) != 0, N = (Xe & 15) << 28 | N >>> 4, Xe = Xe >>> 4 | 0, !!Ji; )
                                                                ;
                                                            if (!(e[W + 64 >> 2] | e[W + 68 >> 2]) | !(vr & 8))
                                                              break m;
                                                            hs = (p >>> 4 | 0) + 1212 | 0, hi = 2;
                                                            break m;
                                                          }
                                                          if (p = Ni, fr = e[W + 68 >> 2], Xe = fr, N = e[W + 64 >> 2], fr | N)
                                                            for (; p = p - 1 | 0, _[p | 0] = N & 7 | 48, Ji = !Xe & N >>> 0 > 7 | (Xe | 0) != 0, N = (Xe & 7) << 29 | N >>> 3, Xe = Xe >>> 3 | 0, !!Ji; )
                                                              ;
                                                          if (fr = p, !(vr & 8))
                                                            break m;
                                                          p = Ni - p | 0, Te = (p | 0) < (Te | 0) ? Te : p + 1 | 0;
                                                          break m;
                                                        }
                                                        if (N = e[W + 64 >> 2], p = e[W + 68 >> 2], Xe = p, (p | 0) < 0) {
                                                          fr = 0 - (p + ((N | 0) != 0) | 0) | 0, Xe = fr, N = 0 - N | 0, e[W + 64 >> 2] = N, e[W + 68 >> 2] = fr, hi = 1, p = 1212;
                                                          break k;
                                                        }
                                                        if (vr & 2048) {
                                                          hi = 1, p = 1213;
                                                          break k;
                                                        }
                                                        hi = vr & 1, p = hi ? 1214 : 1212;
                                                      }
                                                      hs = p, fr = Jf(N, Xe, Ni);
                                                    }
                                                    if ((Te | 0) < 0 && Ln)
                                                      break r;
                                                    if (vr = Ln ? vr & -65537 : vr, p = e[W + 64 >> 2], N = e[W + 68 >> 2], !(Te | (p | N) != 0)) {
                                                      fr = Ni, Te = 0;
                                                      break a;
                                                    }
                                                    p = !(p | N) + (Ni - fr | 0) | 0, Te = (p | 0) < (Te | 0) ? Te : p;
                                                    break a;
                                                  }
                                                  if (p = e[W + 64 >> 2], fr = p || 4806, p = fr, ar = Te >>> 0 >= 2147483647 ? 2147483647 : Te, Xe = lu(p, 0, ar), p = Xe ? Xe - p | 0 : ar, ar = p + fr | 0, (Te | 0) >= 0) {
                                                    vr = N, Te = p;
                                                    break a;
                                                  }
                                                  if (vr = N, Te = p, me[ar | 0])
                                                    break r;
                                                  break a;
                                                }
                                                if (Te) {
                                                  N = e[W + 64 >> 2];
                                                  break u;
                                                }
                                                p = 0, pa(r, 32, _r, 0, vr);
                                                break f;
                                              }
                                              e[W + 12 >> 2] = 0, e[W + 8 >> 2] = e[W + 64 >> 2], N = W + 8 | 0, e[W + 64 >> 2] = N, Te = -1;
                                            }
                                            p = 0;
                                            u: {
                                              for (; ; ) {
                                                if (fr = e[N >> 2], !fr)
                                                  break u;
                                                if (fr = a6(W + 4 | 0, fr), ar = (fr | 0) < 0, !(ar | fr >>> 0 > Te - p >>> 0)) {
                                                  if (N = N + 4 | 0, p = p + fr | 0, Te >>> 0 > p >>> 0)
                                                    continue;
                                                  break u;
                                                }
                                                break;
                                              }
                                              if (ar)
                                                break e;
                                            }
                                            if (Xe = 61, (p | 0) < 0)
                                              break t;
                                            if (pa(r, 32, _r, p, vr), !p) {
                                              p = 0;
                                              break f;
                                            }
                                            for (ar = 0, N = e[W + 64 >> 2]; ; ) {
                                              if (fr = e[N >> 2], !fr || (Xe = W + 4 | 0, fr = a6(Xe, fr), ar = fr + ar | 0, ar >>> 0 > p >>> 0))
                                                break f;
                                              if (ba(r, Xe, fr), N = N + 4 | 0, !(p >>> 0 > ar >>> 0))
                                                break;
                                            }
                                          }
                                          pa(r, 32, _r, p, vr ^ 8192), p = (p | 0) < (_r | 0) ? _r : p;
                                          continue n;
                                        }
                                        if ((Te | 0) < 0 && Ln)
                                          break r;
                                        if (Xe = 61, p = zl(r, jn[W + 64 >> 3], _r, Te, vr, p), (p | 0) >= 0)
                                          continue n;
                                        break t;
                                      }
                                      _[W + 55 | 0] = e[W + 64 >> 2], Te = 1, fr = Us, vr = N;
                                      break a;
                                    }
                                    N = me[p + 1 | 0], p = p + 1 | 0;
                                  }
                                if (Xe = mi, r)
                                  break e;
                                if (!Hi)
                                  break s;
                                for (p = 1; ; ) {
                                  if (r = e[(p << 2) + m >> 2], r) {
                                    if (Sc((p << 3) + A | 0, r, u), Xe = 1, p = p + 1 | 0, (p | 0) != 10)
                                      continue;
                                    break e;
                                  }
                                  break;
                                }
                                if (Xe = 1, p >>> 0 >= 10)
                                  break e;
                                for (; ; ) {
                                  if (e[(p << 2) + m >> 2])
                                    break o;
                                  if (p = p + 1 | 0, (p | 0) == 10)
                                    break;
                                }
                                break e;
                              }
                              Xe = 28;
                              break t;
                            }
                            if (ar = ar - fr | 0, Te = (Te | 0) > (ar | 0) ? Te : ar, (Te | 0) > (hi ^ 2147483647))
                              break r;
                            if (Xe = 61, N = Te + hi | 0, p = (N | 0) < (_r | 0) ? _r : N, (bs | 0) < (p | 0))
                              break t;
                            pa(r, 32, p, N, vr), ba(r, hs, hi), pa(r, 48, p, N, vr ^ 65536), pa(r, 48, Te, ar, 0), ba(r, fr, ar), pa(r, 32, p, N, vr ^ 8192);
                            continue;
                          }
                          break;
                        }
                        break;
                      }
                      Xe = 0;
                      break e;
                    }
                    Xe = 61;
                  }
                  e[5732] = Xe, Xe = -1;
                }
                return Jr = W + 80 | 0, Xe;
              }
              function og(r) {
                r = r | 0;
                var s = 0, u = 0, A = 0, m = 0, p = 0;
                e: {
                  if (r >>> 0 <= 211) {
                    A = e[t1(7504, 7696, r) >> 2];
                    break e;
                  }
                  for (r >>> 0 >= 4294967292 && (r = cu(8), e[5996] = 0, A = Mi(167, r | 0) | 0, m = e[5996], e[5996] = 0, (m | 0) != 1 && (Ua(A | 0, 22716, 92), Oi()), A = Hr() | 0, Xu(r), Jn(A | 0), Oi()), p = (r >>> 0) / 210 | 0, A = Sn(p, 210), m = t1(7696, 7888, r - A | 0) - 7696 >> 2; ; ) {
                    for (A = e[(m << 2) + 7696 >> 2] + A | 0, r = 5; ; ) {
                      t: {
                        if ((r | 0) == 47) {
                          for (r = 211; ; ) {
                            if (s = (A >>> 0) / (r >>> 0) | 0, s >>> 0 < r >>> 0)
                              break e;
                            if ((Sn(r, s) | 0) == (A | 0))
                              break t;
                            if (s = r + 10 | 0, u = (A >>> 0) / (s >>> 0) | 0, s >>> 0 > u >>> 0)
                              break e;
                            if ((Sn(s, u) | 0) == (A | 0))
                              break t;
                            if (s = r + 12 | 0, u = (A >>> 0) / (s >>> 0) | 0, s >>> 0 > u >>> 0)
                              break e;
                            if ((Sn(s, u) | 0) == (A | 0))
                              break t;
                            if (s = r + 16 | 0, u = (A >>> 0) / (s >>> 0) | 0, s >>> 0 > u >>> 0)
                              break e;
                            if ((Sn(s, u) | 0) == (A | 0))
                              break t;
                            if (s = r + 18 | 0, u = (A >>> 0) / (s >>> 0) | 0, s >>> 0 > u >>> 0)
                              break e;
                            if ((Sn(s, u) | 0) == (A | 0))
                              break t;
                            if (s = r + 22 | 0, u = (A >>> 0) / (s >>> 0) | 0, s >>> 0 > u >>> 0)
                              break e;
                            if ((Sn(s, u) | 0) == (A | 0))
                              break t;
                            if (s = r + 28 | 0, u = (A >>> 0) / (s >>> 0) | 0, s >>> 0 > u >>> 0)
                              break e;
                            if ((Sn(s, u) | 0) == (A | 0))
                              break t;
                            if (s = r + 30 | 0, u = (A >>> 0) / (s >>> 0) | 0, s >>> 0 > u >>> 0)
                              break e;
                            if ((Sn(s, u) | 0) == (A | 0))
                              break t;
                            if (s = r + 36 | 0, u = (A >>> 0) / (s >>> 0) | 0, s >>> 0 > u >>> 0)
                              break e;
                            if ((Sn(s, u) | 0) == (A | 0))
                              break t;
                            if (s = r + 40 | 0, u = (A >>> 0) / (s >>> 0) | 0, s >>> 0 > u >>> 0)
                              break e;
                            if ((Sn(s, u) | 0) == (A | 0))
                              break t;
                            if (s = r + 42 | 0, u = (A >>> 0) / (s >>> 0) | 0, s >>> 0 > u >>> 0)
                              break e;
                            if ((Sn(s, u) | 0) == (A | 0))
                              break t;
                            if (s = r + 46 | 0, u = (A >>> 0) / (s >>> 0) | 0, s >>> 0 > u >>> 0)
                              break e;
                            if ((Sn(s, u) | 0) == (A | 0))
                              break t;
                            if (s = r + 52 | 0, u = (A >>> 0) / (s >>> 0) | 0, s >>> 0 > u >>> 0)
                              break e;
                            if ((Sn(s, u) | 0) == (A | 0))
                              break t;
                            if (s = r + 58 | 0, u = (A >>> 0) / (s >>> 0) | 0, s >>> 0 > u >>> 0)
                              break e;
                            if ((Sn(s, u) | 0) == (A | 0))
                              break t;
                            if (s = r + 60 | 0, u = (A >>> 0) / (s >>> 0) | 0, s >>> 0 > u >>> 0)
                              break e;
                            if ((Sn(s, u) | 0) == (A | 0))
                              break t;
                            if (s = r + 66 | 0, u = (A >>> 0) / (s >>> 0) | 0, s >>> 0 > u >>> 0)
                              break e;
                            if ((Sn(s, u) | 0) == (A | 0))
                              break t;
                            if (s = r + 70 | 0, u = (A >>> 0) / (s >>> 0) | 0, s >>> 0 > u >>> 0)
                              break e;
                            if ((Sn(s, u) | 0) == (A | 0))
                              break t;
                            if (s = r + 72 | 0, u = (A >>> 0) / (s >>> 0) | 0, s >>> 0 > u >>> 0)
                              break e;
                            if ((Sn(s, u) | 0) == (A | 0))
                              break t;
                            if (s = r + 78 | 0, u = (A >>> 0) / (s >>> 0) | 0, s >>> 0 > u >>> 0)
                              break e;
                            if ((Sn(s, u) | 0) == (A | 0))
                              break t;
                            if (s = r + 82 | 0, u = (A >>> 0) / (s >>> 0) | 0, s >>> 0 > u >>> 0)
                              break e;
                            if ((Sn(s, u) | 0) == (A | 0))
                              break t;
                            if (s = r + 88 | 0, u = (A >>> 0) / (s >>> 0) | 0, s >>> 0 > u >>> 0)
                              break e;
                            if ((Sn(s, u) | 0) == (A | 0))
                              break t;
                            if (s = r + 96 | 0, u = (A >>> 0) / (s >>> 0) | 0, s >>> 0 > u >>> 0)
                              break e;
                            if ((Sn(s, u) | 0) == (A | 0))
                              break t;
                            if (s = r + 100 | 0, u = (A >>> 0) / (s >>> 0) | 0, s >>> 0 > u >>> 0)
                              break e;
                            if ((Sn(s, u) | 0) == (A | 0))
                              break t;
                            if (s = r + 102 | 0, u = (A >>> 0) / (s >>> 0) | 0, s >>> 0 > u >>> 0)
                              break e;
                            if ((Sn(s, u) | 0) == (A | 0))
                              break t;
                            if (s = r + 106 | 0, u = (A >>> 0) / (s >>> 0) | 0, s >>> 0 > u >>> 0)
                              break e;
                            if ((Sn(s, u) | 0) == (A | 0))
                              break t;
                            if (s = r + 108 | 0, u = (A >>> 0) / (s >>> 0) | 0, s >>> 0 > u >>> 0)
                              break e;
                            if ((Sn(s, u) | 0) == (A | 0))
                              break t;
                            if (s = r + 112 | 0, u = (A >>> 0) / (s >>> 0) | 0, s >>> 0 > u >>> 0)
                              break e;
                            if ((Sn(s, u) | 0) == (A | 0))
                              break t;
                            if (s = r + 120 | 0, u = (A >>> 0) / (s >>> 0) | 0, s >>> 0 > u >>> 0)
                              break e;
                            if ((Sn(s, u) | 0) == (A | 0))
                              break t;
                            if (s = r + 126 | 0, u = (A >>> 0) / (s >>> 0) | 0, s >>> 0 > u >>> 0)
                              break e;
                            if ((Sn(s, u) | 0) == (A | 0))
                              break t;
                            if (s = r + 130 | 0, u = (A >>> 0) / (s >>> 0) | 0, s >>> 0 > u >>> 0)
                              break e;
                            if ((Sn(s, u) | 0) == (A | 0))
                              break t;
                            if (s = r + 136 | 0, u = (A >>> 0) / (s >>> 0) | 0, s >>> 0 > u >>> 0)
                              break e;
                            if ((Sn(s, u) | 0) == (A | 0))
                              break t;
                            if (s = r + 138 | 0, u = (A >>> 0) / (s >>> 0) | 0, s >>> 0 > u >>> 0)
                              break e;
                            if ((Sn(s, u) | 0) == (A | 0))
                              break t;
                            if (s = r + 142 | 0, u = (A >>> 0) / (s >>> 0) | 0, s >>> 0 > u >>> 0)
                              break e;
                            if ((Sn(s, u) | 0) == (A | 0))
                              break t;
                            if (s = r + 148 | 0, u = (A >>> 0) / (s >>> 0) | 0, s >>> 0 > u >>> 0)
                              break e;
                            if ((Sn(s, u) | 0) == (A | 0))
                              break t;
                            if (s = r + 150 | 0, u = (A >>> 0) / (s >>> 0) | 0, s >>> 0 > u >>> 0)
                              break e;
                            if ((Sn(s, u) | 0) == (A | 0))
                              break t;
                            if (s = r + 156 | 0, u = (A >>> 0) / (s >>> 0) | 0, s >>> 0 > u >>> 0)
                              break e;
                            if ((Sn(s, u) | 0) == (A | 0))
                              break t;
                            if (s = r + 162 | 0, u = (A >>> 0) / (s >>> 0) | 0, s >>> 0 > u >>> 0)
                              break e;
                            if ((Sn(s, u) | 0) == (A | 0))
                              break t;
                            if (s = r + 166 | 0, u = (A >>> 0) / (s >>> 0) | 0, s >>> 0 > u >>> 0)
                              break e;
                            if ((Sn(s, u) | 0) == (A | 0))
                              break t;
                            if (s = r + 168 | 0, u = (A >>> 0) / (s >>> 0) | 0, s >>> 0 > u >>> 0)
                              break e;
                            if ((Sn(s, u) | 0) == (A | 0))
                              break t;
                            if (s = r + 172 | 0, u = (A >>> 0) / (s >>> 0) | 0, s >>> 0 > u >>> 0)
                              break e;
                            if ((Sn(s, u) | 0) == (A | 0))
                              break t;
                            if (s = r + 178 | 0, u = (A >>> 0) / (s >>> 0) | 0, s >>> 0 > u >>> 0)
                              break e;
                            if ((Sn(s, u) | 0) == (A | 0))
                              break t;
                            if (s = r + 180 | 0, u = (A >>> 0) / (s >>> 0) | 0, s >>> 0 > u >>> 0)
                              break e;
                            if ((Sn(s, u) | 0) == (A | 0))
                              break t;
                            if (s = r + 186 | 0, u = (A >>> 0) / (s >>> 0) | 0, s >>> 0 > u >>> 0)
                              break e;
                            if ((Sn(s, u) | 0) == (A | 0))
                              break t;
                            if (s = r + 190 | 0, u = (A >>> 0) / (s >>> 0) | 0, s >>> 0 > u >>> 0)
                              break e;
                            if ((Sn(s, u) | 0) == (A | 0))
                              break t;
                            if (s = r + 192 | 0, u = (A >>> 0) / (s >>> 0) | 0, s >>> 0 > u >>> 0)
                              break e;
                            if ((Sn(s, u) | 0) == (A | 0))
                              break t;
                            if (s = r + 196 | 0, u = (A >>> 0) / (s >>> 0) | 0, s >>> 0 > u >>> 0)
                              break e;
                            if ((Sn(s, u) | 0) == (A | 0))
                              break t;
                            if (s = r + 198 | 0, u = (A >>> 0) / (s >>> 0) | 0, s >>> 0 > u >>> 0)
                              break e;
                            if ((Sn(s, u) | 0) == (A | 0))
                              break t;
                            if (s = r + 208 | 0, u = (A >>> 0) / (s >>> 0) | 0, s >>> 0 > u >>> 0)
                              break e;
                            if (r = r + 210 | 0, (Sn(s, u) | 0) == (A | 0))
                              break;
                          }
                          break t;
                        }
                        if (s = e[(r << 2) + 7504 >> 2], u = (A >>> 0) / (s >>> 0) | 0, s >>> 0 > u >>> 0)
                          break e;
                        if (r = r + 1 | 0, (Sn(s, u) | 0) != (A | 0))
                          continue;
                      }
                      break;
                    }
                    A = m + 1 | 0, r = (A | 0) == 48, m = r ? 0 : A, p = r + p | 0, A = Sn(p, 210);
                  }
                }
                return A | 0;
              }
              function Qo(r, s, u, A, m, p, N, W, Te) {
                var Xe = 0, fr = 0, ar = 0, vr = 0, _r = 0, hi = 0, mi = 0, Ni = 0, Hi = 0, Ji = 0, Ln = 0, _n = 0, hs = 0, bs = 0, Us = 0, go = 0, _o = 0, ra = 0, fa = 0, ha = 0, xa = 0, tu = 0, Ku = 0, $u = 0, vf = 0, Qf = 0, cc = 0, lc = 0, dc = 0, Jc = 0, Yc = 0, Xc = 0, N4 = 0, P4 = 0;
                fr = Jr - 96 | 0, Jr = fr, _n = Te & 65535, hi = (m ^ Te) & -2147483648, Hi = m & 65535, go = Hi, N4 = Te >>> 16 & 32767, P4 = m >>> 16 & 32767;
                e: {
                  t: {
                    if (N4 - 32767 >>> 0 > 4294934529 & P4 - 32767 >>> 0 >= 4294934530)
                      break t;
                    if (Ji = m & 2147483647, Ni = Ji, Xe = A, !(!A & (Ni | 0) == 2147418112 ? !(s | u) : Ni >>> 0 < 2147418112)) {
                      vr = A, hi = m | 32768;
                      break e;
                    }
                    if (Ji = Te & 2147483647, mi = Ji, m = W, !(!m & (mi | 0) == 2147418112 ? !(p | N) : mi >>> 0 < 2147418112)) {
                      vr = m, hi = Te | 32768, s = p, u = N;
                      break e;
                    }
                    if (!(s | Xe | (Ni ^ 2147418112 | u))) {
                      if (!(m | p | (N | mi))) {
                        hi = 2147450880, s = 0, u = 0;
                        break e;
                      }
                      hi = hi | 2147418112, s = 0, u = 0;
                      break e;
                    }
                    if (!(m | p | (mi ^ 2147418112 | N))) {
                      if (m = s | Xe, A = u | Ni, s = 0, u = 0, !(A | m)) {
                        hi = 2147450880;
                        break e;
                      }
                      hi = hi | 2147418112;
                      break e;
                    }
                    if (!(s | Xe | (u | Ni))) {
                      s = 0, u = 0;
                      break e;
                    }
                    if (!(m | p | (N | mi))) {
                      s = 0, u = 0;
                      break e;
                    }
                    if ((Ni | 0) == 65535 | Ni >>> 0 < 65535 && (Xe = !(A | Hi), Te = Xe ? s : A, Ji = Xe << 6, m = Fo(Te) + 32 | 0, Te = Fo(Xe ? u : Hi), Te = Ji + ((Te | 0) == 32 ? m : Te) | 0, Ea(fr + 80 | 0, s, u, A, Hi, Te - 15 | 0), Ln = 16 - Te | 0, A = e[fr + 88 >> 2], go = e[fr + 92 >> 2], u = e[fr + 84 >> 2], s = e[fr + 80 >> 2]), mi >>> 0 > 65535)
                      break t;
                    Te = !(W | _n), m = Te ? p : W, Hi = Te << 6, Xe = Fo(m) + 32 | 0, m = Fo(Te ? N : _n), m = Hi + ((m | 0) == 32 ? Xe : m) | 0, Ea(fr - -64 | 0, p, N, W, _n, m - 15 | 0), Ln = (Ln - m | 0) + 16 | 0, W = e[fr + 72 >> 2], _n = e[fr + 76 >> 2], p = e[fr + 64 >> 2], N = e[fr + 68 >> 2];
                  }
                  m = p, p = N << 15 | p >>> 17, Te = m << 15, m = 0, hs = Te & -32768, cc = u, Ji = Ao(hs, m, u, 0), m = Ds, _o = m, lc = p, Ni = s, u = Ao(p, 0, s, 0), s = u + Ji | 0, p = Ds + m | 0, Te = s, u = s >>> 0 < u >>> 0 ? p + 1 | 0 : p, p = s, Xe = 0, s = Ao(Ni, ar, hs, ar), mi = Xe + s | 0, m = Ds + p | 0, m = s >>> 0 > mi >>> 0 ? m + 1 | 0 : m, Hi = m, dc = (p | 0) == (m | 0) & Xe >>> 0 > mi >>> 0 | m >>> 0 < p >>> 0, Jc = A, bs = Ao(hs, ar, A, 0), Yc = Ds, s = Ao(cc, ar, lc, ar), Us = s + bs | 0, Xe = Ds + Yc | 0, Xe = s >>> 0 > Us >>> 0 ? Xe + 1 | 0 : Xe, s = _n << 15 | W >>> 17, ra = W << 15 | N >>> 17, A = Ao(ra, 0, Ni, ar), fa = A + Us | 0, p = Ds + Xe | 0, p = A >>> 0 > fa >>> 0 ? p + 1 | 0 : p, ha = p, A = (u | 0) == (_o | 0) & Te >>> 0 < Ji >>> 0 | u >>> 0 < _o >>> 0, xa = u + fa | 0, p = A + p | 0, p = u >>> 0 > xa >>> 0 ? p + 1 | 0 : p, _n = p, N = xa, u = p, tu = go | 65536, go = Ao(hs, ar, tu, _r), Xc = Ds, A = Ao(Jc, vr, lc, ar), Ku = A + go | 0, m = Ds + Xc | 0, m = A >>> 0 > Ku >>> 0 ? m + 1 | 0 : m, Te = m, $u = s | -2147483648, s = Ao($u, 0, Ni, ar), vf = s + Ku | 0, p = Ds + m | 0, p = s >>> 0 > vf >>> 0 ? p + 1 | 0 : p, A = Ao(ra, vr, cc, ar), s = A + vf | 0, Qf = p, p = p + Ds | 0, _o = s, Ji = s >>> 0 < A >>> 0 ? p + 1 | 0 : p, p = s, s = 0, Ni = s + N | 0, m = u + p | 0, m = s >>> 0 > Ni >>> 0 ? m + 1 | 0 : m, hs = m, p = m, s = Ni + dc | 0, u = s >>> 0 < Ni >>> 0 ? p + 1 | 0 : p, Ln = ((P4 + N4 | 0) + Ln | 0) - 16383 | 0, A = Ao($u, vr, cc, ar), W = Ds, m = Ao(tu, vr, lc, ar), N = m + A | 0, p = Ds + W | 0, p = m >>> 0 > N >>> 0 ? p + 1 | 0 : p, _r = (W | 0) == (p | 0) & A >>> 0 > N >>> 0 | p >>> 0 < W >>> 0, W = p, m = Ao(ra, vr, Jc, vr), A = m + N | 0, p = Ds + p | 0, p = A >>> 0 < m >>> 0 ? p + 1 | 0 : p, m = p, N = (p | 0) == (W | 0) & A >>> 0 < N >>> 0 | p >>> 0 < W >>> 0, p = 0, W = N, N = N + _r | 0, p = W >>> 0 > N >>> 0 ? 1 : p, W = N, N = Ao($u, vr, tu, vr), W = W + N | 0, p = Ds + p | 0, dc = W, N = N >>> 0 > W >>> 0 ? p + 1 | 0 : p, W = A, ar = m, m = (Xe | 0) == (Yc | 0) & bs >>> 0 > Us >>> 0 | Xe >>> 0 < Yc >>> 0, p = 0, Xe = (Xe | 0) == (ha | 0) & Us >>> 0 > fa >>> 0 | Xe >>> 0 > ha >>> 0, _r = Xe, Xe = m + Xe | 0, m = (_r >>> 0 > Xe >>> 0 ? 1 : p) + ar | 0, p = N, A = A + Xe | 0, m = A >>> 0 < Xe >>> 0 ? m + 1 | 0 : m, _r = m, bs = A, A = (m | 0) == (ar | 0) & A >>> 0 < W >>> 0 | m >>> 0 < ar >>> 0, m = A, A = A + dc | 0, p = m >>> 0 > A >>> 0 ? p + 1 | 0 : p, Xe = A, W = p, m = Ao(ra, vr, tu, vr), ar = Ds, N = Ao($u, vr, Jc, vr), A = N + m | 0, p = Ds + ar | 0, p = A >>> 0 < N >>> 0 ? p + 1 | 0 : p, N = p, p = (ar | 0) == (p | 0) & A >>> 0 < m >>> 0 | p >>> 0 < ar >>> 0, Us = N + Xe | 0, m = p + W | 0, m = N >>> 0 > Us >>> 0 ? m + 1 | 0 : m, ar = Us, W = m, Xe = A, m = 0, A = m + bs | 0, p = Xe + _r | 0, p = A >>> 0 < m >>> 0 ? p + 1 | 0 : p, m = p, N = (_r | 0) == (p | 0) & A >>> 0 < bs >>> 0 | p >>> 0 < _r >>> 0, p = W, W = N, N = N + ar | 0, p = W >>> 0 > N >>> 0 ? p + 1 | 0 : p, bs = N, N = p, W = A, Xe = m, m = (Ji | 0) == (Qf | 0) & _o >>> 0 < vf >>> 0 | Ji >>> 0 < Qf >>> 0, A = (Te | 0) == (Xc | 0) & go >>> 0 > Ku >>> 0 | Te >>> 0 < Xc >>> 0, Te = (Te | 0) == (Qf | 0) & Ku >>> 0 > vf >>> 0 | Te >>> 0 > Qf >>> 0, A = A + Te | 0, A = A + m | 0, _r = Ji, Te = _r + W | 0, m = A + Xe | 0, p = N, A = Te, m = A >>> 0 < _r >>> 0 ? m + 1 | 0 : m, W = (m | 0) == (Xe | 0) & W >>> 0 > A >>> 0 | m >>> 0 < Xe >>> 0, N = W + bs | 0, p = W >>> 0 > N >>> 0 ? p + 1 | 0 : p, Xe = N, N = p, W = A, p = 0, Te = m, _r = (_n | 0) == (hs | 0) & Ni >>> 0 < xa >>> 0 | _n >>> 0 > hs >>> 0, ar = _r, _r = _r + ((_n | 0) == (ha | 0) & fa >>> 0 > xa >>> 0 | _n >>> 0 < ha >>> 0) | 0, m = m + (ar >>> 0 > _r >>> 0 ? 1 : p) | 0, p = N, A = A + _r | 0, m = A >>> 0 < _r >>> 0 ? m + 1 | 0 : m, W = (m | 0) == (Te | 0) & A >>> 0 < W >>> 0 | m >>> 0 < Te >>> 0, N = W, W = W + Xe | 0, p = N >>> 0 > W >>> 0 ? p + 1 | 0 : p, Te = p;
                  t: {
                    if (p & 65536) {
                      Ln = Ln + 1 | 0;
                      break t;
                    }
                    Xe = Hi >>> 31 | 0, N = 0, p = Te << 1 | W >>> 31, W = W << 1 | m >>> 31, Te = p, p = m << 1 | A >>> 31, A = A << 1 | u >>> 31, m = p, p = Hi << 1 | mi >>> 31, mi = mi << 1, Hi = p, p = u << 1 | s >>> 31, s = s << 1 | Xe, u = p | N;
                  }
                  if ((Ln | 0) >= 32767) {
                    hi = hi | 2147418112, s = 0, u = 0;
                    break e;
                  }
                  t: {
                    if ((Ln | 0) <= 0) {
                      if (N = 1 - Ln | 0, N >>> 0 <= 127) {
                        p = Ln + 127 | 0, Ea(fr + 48 | 0, mi, Hi, s, u, p), Ea(fr + 32 | 0, A, m, W, Te, p), Tf(fr + 16 | 0, mi, Hi, s, u, N), Tf(fr, A, m, W, Te, N), mi = e[fr + 32 >> 2] | e[fr + 16 >> 2] | (e[fr + 48 >> 2] | e[fr + 56 >> 2] | (e[fr + 52 >> 2] | e[fr + 60 >> 2])) != 0, Hi = e[fr + 36 >> 2] | e[fr + 20 >> 2], s = e[fr + 40 >> 2] | e[fr + 24 >> 2], u = e[fr + 44 >> 2] | e[fr + 28 >> 2], A = e[fr >> 2], m = e[fr + 4 >> 2], N = e[fr + 8 >> 2], p = e[fr + 12 >> 2];
                        break t;
                      }
                      s = 0, u = 0;
                      break e;
                    }
                    N = W, p = Te & 65535 | Ln << 16;
                  }
                  if (vr = N | vr, hi = p | hi, !(!s & (u | 0) == -2147483648 ? !(mi | Hi) : (u | 0) > 0 | (u | 0) >= 0)) {
                    s = A + 1 | 0, Xe = s ? m : m + 1 | 0, m = hi, u = Xe, A = !(Xe | s), vr = A + vr | 0, hi = A >>> 0 > vr >>> 0 ? m + 1 | 0 : m;
                    break e;
                  }
                  if (s | mi | (u ^ -2147483648 | Hi)) {
                    s = A, u = m;
                    break e;
                  }
                  p = m, s = A & 1, u = s, s = s + A | 0, u = u >>> 0 > s >>> 0 ? p + 1 | 0 : p, A = (p | 0) == (u | 0) & s >>> 0 < A >>> 0 | u >>> 0 < p >>> 0, p = hi, vr = A + vr | 0, hi = vr >>> 0 < A >>> 0 ? p + 1 | 0 : p;
                }
                e[r >> 2] = s, e[r + 4 >> 2] = u, e[r + 8 >> 2] = vr, e[r + 12 >> 2] = hi, Jr = fr + 96 | 0;
              }
              function Yl() {
                var r = 0, s = 0, u = 0;
                if (me[25020])
                  return e[6254];
                e[6663] = 0, e[6662] = 22008, e[6662] = 14144, e[6662] = 12664, r = Jr - 16 | 0, Jr = r, e[6664] = 0, e[6665] = 0, e[6666] = 0, _[26792] = 0, e[r + 4 >> 2] = 26656, u = e[r + 4 >> 2], s = r + 8 | 0, _[s + 4 | 0] = 0, e[s >> 2] = u, e[5996] = 0, qo(273, 26656), u = e[5996], e[5996] = 0;
                e: {
                  if ((u | 0) != 1) {
                    Od(26656, 30), _[s + 4 | 0] = 1, y6(s), Jr = r + 16 | 0;
                    break e;
                  }
                  s = Hr() | 0, y6(r + 8 | 0), Jn(s | 0), Oi();
                }
                e[5996] = 0, s = pi(30, 26800, 3538) | 0, r = e[5996], e[5996] = 0;
                e: {
                  t: {
                    r: {
                      if ((r | 0) != 1) {
                        if (S6(26656), e[6581] = 0, e[6580] = 22008, e[6580] = 14144, e[6580] = 15252, e[5996] = 0, qo(240, 26648), r = e[5996], e[5996] = 0, (r | 0) == 1 || (e[6583] = 0, e[6582] = 22008, e[6582] = 14144, e[6582] = 15284, e[5996] = 0, qo(241, 26648), r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[6585] = 0, e[6584] = 22008, e[6584] = 14144, _[26348] = 0, e[6586] = 0, e[6584] = 12684, e[6586] = 12736, e[5996] = 0, qo(242, 26648), r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[6589] = 0, e[6588] = 22008, e[6588] = 14144, e[6588] = 14200, e[5996] = 0, qo(243, 26648), r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[6591] = 0, e[6590] = 22008, e[6590] = 14144, e[6590] = 14348, e[5996] = 0, qo(244, 26648), r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[5996] = 0, Nn(245), r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[5996] = 0, qo(246, 26648), r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[6597] = 0, e[6596] = 22008, e[6596] = 14144, e[6596] = 14496, e[5996] = 0, qo(247, 26648), r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[6599] = 0, e[6598] = 22008, e[6598] = 14144, e[6598] = 14728, e[5996] = 0, qo(248, 26648), r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[6601] = 0, e[6600] = 22008, e[6600] = 14144, e[6600] = 14612, e[5996] = 0, qo(249, 26648), r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[6603] = 0, e[6602] = 22008, e[6602] = 14144, e[6602] = 14844, e[5996] = 0, qo(250, 26648), r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[6605] = 0, e[6604] = 22008, e[6604] = 14144, Zs[13212] = 11310, e[6604] = 13816, e[6607] = 0, e[6608] = 0, e[6609] = 0, e[5996] = 0, qo(251, 26648), r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[6611] = 0, e[6610] = 22008, e[6610] = 14144, e[6612] = 46, e[6613] = 44, e[6610] = 13856, e[6614] = 0, e[6615] = 0, e[6616] = 0, e[5996] = 0, qo(252, 26648), r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[6619] = 0, e[6618] = 22008, e[6618] = 14144, e[6618] = 15316, e[5996] = 0, qo(253, 26648), r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[6621] = 0, e[6620] = 22008, e[6620] = 14144, e[6620] = 15560, e[5996] = 0, qo(254, 26648), r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[6623] = 0, e[6622] = 22008, e[6622] = 14144, e[6622] = 15772, e[5996] = 0, qo(255, 26648), r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[6625] = 0, e[6624] = 22008, e[6624] = 14144, e[6624] = 16004, e[5996] = 0, qo(256, 26648), r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[6627] = 0, e[6626] = 22008, e[6626] = 14144, e[6626] = 16988, e[5996] = 0, qo(257, 26648), r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[6629] = 0, e[6628] = 22008, e[6628] = 14144, e[6628] = 17136, e[5996] = 0, qo(258, 26648), r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[6631] = 0, e[6630] = 22008, e[6630] = 14144, e[6630] = 17252, e[5996] = 0, qo(259, 26648), r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[6633] = 0, e[6632] = 22008, e[6632] = 14144, e[6632] = 17368, e[5996] = 0, qo(260, 26648), r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[6635] = 0, e[6634] = 22008, e[6634] = 14144, e[6634] = 17484, e[5996] = 0, qo(261, 26648), r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[6637] = 0, e[6636] = 22008, e[6636] = 14144, e[6636] = 17648, e[5996] = 0, qo(262, 26648), r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[6639] = 0, e[6638] = 22008, e[6638] = 14144, e[6638] = 17812, e[5996] = 0, qo(263, 26648), r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[6641] = 0, e[6640] = 22008, e[6640] = 14144, e[6640] = 17976, e[5996] = 0, qo(264, 26648), r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[6643] = 0, e[6642] = 22008, e[6642] = 14144, e[6644] = 19232, e[6644] = 16252, e[6642] = 16204, e[5996] = 0, qo(265, 26648), r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[6647] = 0, e[6646] = 22008, e[6646] = 14144, e[6648] = 19268, e[6648] = 16516, e[6646] = 16468, e[5996] = 0, qo(266, 26648), r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[5996] = 0, Nn(267), r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[5996] = 0, qo(268, 26648), r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[5996] = 0, Nn(269), r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[5996] = 0, qo(270, 26648), r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[6659] = 0, e[6658] = 22008, e[6658] = 14144, e[6658] = 18140, e[5996] = 0, qo(271, 26648), r = e[5996], e[5996] = 0, (r | 0) == 1) || (e[6661] = 0, e[6660] = 22008, e[6660] = 14144, e[6660] = 18260, e[5996] = 0, qo(272, 26648), r = e[5996], e[5996] = 0, (r | 0) == 1))
                          break r;
                        break e;
                      }
                      r = Hr() | 0;
                      break t;
                    }
                    r = Hr() | 0, Qn(s);
                  }
                  Xo(26656), Jn(r | 0), Oi();
                }
                return e[6253] = 26648, _[25020] = 1, e[6254] = 25012, 25012;
              }
              function ch(r, s, u, A, m, p, N, W) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0, m = m | 0, p = p | 0, N = N | 0, W = W | 0;
                var Te = 0, Xe = 0, fr = 0;
                W = Jr - 48 | 0, Jr = W, e[W + 44 >> 2] = s, e[m >> 2] = 0, Te = e[A + 28 >> 2], e[W >> 2] = Te, e[Te + 4 >> 2] = e[Te + 4 >> 2] + 1, e[5996] = 0, Te = Mi(197, e[W >> 2]) | 0, Xe = e[5996], e[5996] = 0;
                e: {
                  t: {
                    r: {
                      i: {
                        n: {
                          s: {
                            a: {
                              o: {
                                l: {
                                  c: {
                                    d: {
                                      f: {
                                        u: {
                                          g: {
                                            A: {
                                              p: {
                                                m: {
                                                  k: {
                                                    N: {
                                                      S: {
                                                        T: {
                                                          v: {
                                                            w: {
                                                              E: {
                                                                h: {
                                                                  R: {
                                                                    I: {
                                                                      if ((Xe | 0) != 1)
                                                                        switch (Xe = e[W >> 2], fr = e[Xe + 4 >> 2] - 1 | 0, e[Xe + 4 >> 2] = fr, (fr | 0) == -1 && xi[e[e[Xe >> 2] + 8 >> 2]](Xe), N - 65 | 0) {
                                                                          case 54:
                                                                            break c;
                                                                          case 19:
                                                                            break d;
                                                                          case 18:
                                                                            break f;
                                                                          case 17:
                                                                            break u;
                                                                          case 49:
                                                                            break g;
                                                                          case 47:
                                                                            break A;
                                                                          case 45:
                                                                          case 51:
                                                                            break p;
                                                                          case 12:
                                                                            break m;
                                                                          case 44:
                                                                            break k;
                                                                          case 41:
                                                                            break N;
                                                                          case 8:
                                                                            break S;
                                                                          case 7:
                                                                            break T;
                                                                          case 5:
                                                                            break v;
                                                                          case 3:
                                                                            break w;
                                                                          case 35:
                                                                          case 36:
                                                                            break E;
                                                                          case 34:
                                                                            break h;
                                                                          case 1:
                                                                          case 33:
                                                                          case 39:
                                                                            break R;
                                                                          case 0:
                                                                          case 32:
                                                                            break I;
                                                                          case 2:
                                                                          case 4:
                                                                          case 6:
                                                                          case 9:
                                                                          case 10:
                                                                          case 11:
                                                                          case 13:
                                                                          case 14:
                                                                          case 15:
                                                                          case 16:
                                                                          case 20:
                                                                          case 21:
                                                                          case 22:
                                                                          case 25:
                                                                          case 26:
                                                                          case 27:
                                                                          case 28:
                                                                          case 29:
                                                                          case 30:
                                                                          case 31:
                                                                          case 37:
                                                                          case 38:
                                                                          case 40:
                                                                          case 42:
                                                                          case 43:
                                                                          case 46:
                                                                          case 48:
                                                                          case 50:
                                                                          case 52:
                                                                          case 53:
                                                                            break i;
                                                                          case 24:
                                                                            break s;
                                                                          case 56:
                                                                            break a;
                                                                          case 23:
                                                                            break o;
                                                                          case 55:
                                                                            break l;
                                                                          default:
                                                                            break n;
                                                                        }
                                                                      u = Hr() | 0, r = e[W >> 2], s = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = s, (s | 0) == -1 && xi[e[e[r >> 2] + 8 >> 2]](r), Jn(u | 0), Oi();
                                                                    }
                                                                    I1(r, p + 24 | 0, W + 44 | 0, u, m, Te);
                                                                    break t;
                                                                  }
                                                                  g1(r, p + 16 | 0, W + 44 | 0, u, m, Te);
                                                                  break t;
                                                                }
                                                                N = xi[e[e[r + 8 >> 2] + 12 >> 2]](r + 8 | 0) | 0, Te = me[N + 11 | 0], Xe = r, fr = s, s = (Te & 128) >>> 7 | 0, r = s ? e[N >> 2] : N, e[W + 44 >> 2] = Wu(Xe, fr, u, A, m, p, r, r + ((s ? e[N + 4 >> 2] : Te & 127) << 2) | 0);
                                                                break t;
                                                              }
                                                              r = yu(W + 44 | 0, u, m, Te, 2), s = e[m >> 2];
                                                              E: {
                                                                if (!(r - 1 >>> 0 > 30 | s & 4)) {
                                                                  e[p + 12 >> 2] = r;
                                                                  break E;
                                                                }
                                                                e[m >> 2] = s | 4;
                                                              }
                                                              break t;
                                                            }
                                                            N = e[3127], e[W + 24 >> 2] = e[3126], e[W + 28 >> 2] = N, N = e[3125], e[W + 16 >> 2] = e[3124], e[W + 20 >> 2] = N, N = e[3123], e[W + 8 >> 2] = e[3122], e[W + 12 >> 2] = N, N = e[3121], e[W >> 2] = e[3120], e[W + 4 >> 2] = N, e[W + 44 >> 2] = Wu(r, s, u, A, m, p, W, W + 32 | 0);
                                                            break t;
                                                          }
                                                          N = e[3135], e[W + 24 >> 2] = e[3134], e[W + 28 >> 2] = N, N = e[3133], e[W + 16 >> 2] = e[3132], e[W + 20 >> 2] = N, N = e[3131], e[W + 8 >> 2] = e[3130], e[W + 12 >> 2] = N, N = e[3129], e[W >> 2] = e[3128], e[W + 4 >> 2] = N, e[W + 44 >> 2] = Wu(r, s, u, A, m, p, W, W + 32 | 0);
                                                          break t;
                                                        }
                                                        r = yu(W + 44 | 0, u, m, Te, 2), s = e[m >> 2];
                                                        T: {
                                                          if (!((r | 0) > 23 | s & 4)) {
                                                            e[p + 8 >> 2] = r;
                                                            break T;
                                                          }
                                                          e[m >> 2] = s | 4;
                                                        }
                                                        break t;
                                                      }
                                                      r = yu(W + 44 | 0, u, m, Te, 2), s = e[m >> 2];
                                                      S: {
                                                        if (!(r - 1 >>> 0 > 11 | s & 4)) {
                                                          e[p + 8 >> 2] = r;
                                                          break S;
                                                        }
                                                        e[m >> 2] = s | 4;
                                                      }
                                                      break t;
                                                    }
                                                    r = yu(W + 44 | 0, u, m, Te, 3), s = e[m >> 2];
                                                    N: {
                                                      if (!((r | 0) > 365 | s & 4)) {
                                                        e[p + 28 >> 2] = r;
                                                        break N;
                                                      }
                                                      e[m >> 2] = s | 4;
                                                    }
                                                    break t;
                                                  }
                                                  s = yu(W + 44 | 0, u, m, Te, 2) - 1 | 0, r = e[m >> 2];
                                                  k: {
                                                    if (!(s >>> 0 > 11 | r & 4)) {
                                                      e[p + 16 >> 2] = s;
                                                      break k;
                                                    }
                                                    e[m >> 2] = r | 4;
                                                  }
                                                  break t;
                                                }
                                                r = yu(W + 44 | 0, u, m, Te, 2), s = e[m >> 2];
                                                m: {
                                                  if (!((r | 0) > 59 | s & 4)) {
                                                    e[p + 4 >> 2] = r;
                                                    break m;
                                                  }
                                                  e[m >> 2] = s | 4;
                                                }
                                                break t;
                                              }
                                              for (r = W + 44 | 0, s = Jr - 16 | 0, Jr = s, e[s + 12 >> 2] = u; ; ) {
                                                p: {
                                                  if (Hu(r, s + 12 | 0))
                                                    break p;
                                                  u = e[r >> 2], A = e[u + 12 >> 2];
                                                  m: {
                                                    if ((A | 0) == e[u + 16 >> 2]) {
                                                      u = xi[e[e[u >> 2] + 36 >> 2]](u) | 0;
                                                      break m;
                                                    }
                                                    u = e[A >> 2];
                                                  }
                                                  if (!(xi[e[e[Te >> 2] + 12 >> 2]](Te, 1, u) | 0))
                                                    break p;
                                                  Ul(r);
                                                  continue;
                                                }
                                                break;
                                              }
                                              Hu(r, s + 12 | 0) && (e[m >> 2] = e[m >> 2] | 2), Jr = s + 16 | 0;
                                              break t;
                                            }
                                            A = W + 44 | 0, r = xi[e[e[r + 8 >> 2] + 8 >> 2]](r + 8 | 0) | 0, s = me[r + 11 | 0], N = (s & 128) >>> 7 | 0 ? e[r + 4 >> 2] : s & 127, s = me[r + 23 | 0];
                                            A: {
                                              if ((N | 0) == (0 - ((s & 128) >>> 7 | 0 ? e[r + 16 >> 2] : s & 127) | 0)) {
                                                e[m >> 2] = e[m >> 2] | 4;
                                                break A;
                                              }
                                              if (u = il(A, u, r, r + 24 | 0, Te, m, 0), s = e[p + 8 >> 2], !((u | 0) != (r | 0) | (s | 0) != 12)) {
                                                e[p + 8 >> 2] = 0;
                                                break A;
                                              }
                                              (u - r | 0) != 12 | (s | 0) > 11 || (e[p + 8 >> 2] = s + 12);
                                            }
                                            break t;
                                          }
                                          N = so(W, 12544, 44), e[N + 44 >> 2] = Wu(r, s, u, A, m, p, N, N + 44 | 0);
                                          break t;
                                        }
                                        e[W + 16 >> 2] = e[3152], N = e[3151], e[W + 8 >> 2] = e[3150], e[W + 12 >> 2] = N, N = e[3149], e[W >> 2] = e[3148], e[W + 4 >> 2] = N, e[W + 44 >> 2] = Wu(r, s, u, A, m, p, W, W + 20 | 0);
                                        break t;
                                      }
                                      r = yu(W + 44 | 0, u, m, Te, 2), s = e[m >> 2];
                                      f: {
                                        if (!((r | 0) > 60 | s & 4)) {
                                          e[p >> 2] = r;
                                          break f;
                                        }
                                        e[m >> 2] = s | 4;
                                      }
                                      break t;
                                    }
                                    N = e[3163], e[W + 24 >> 2] = e[3162], e[W + 28 >> 2] = N, N = e[3161], e[W + 16 >> 2] = e[3160], e[W + 20 >> 2] = N, N = e[3159], e[W + 8 >> 2] = e[3158], e[W + 12 >> 2] = N, N = e[3157], e[W >> 2] = e[3156], e[W + 4 >> 2] = N, e[W + 44 >> 2] = Wu(r, s, u, A, m, p, W, W + 32 | 0);
                                    break t;
                                  }
                                  r = yu(W + 44 | 0, u, m, Te, 1), s = e[m >> 2];
                                  c: {
                                    if (!((r | 0) > 6 | s & 4)) {
                                      e[p + 24 >> 2] = r;
                                      break c;
                                    }
                                    e[m >> 2] = s | 4;
                                  }
                                  break t;
                                }
                                r = xi[e[e[r >> 2] + 20 >> 2]](r, s, u, A, m, p) | 0;
                                break e;
                              }
                              N = xi[e[e[r + 8 >> 2] + 24 >> 2]](r + 8 | 0) | 0, Te = me[N + 11 | 0], Xe = r, fr = s, s = (Te & 128) >>> 7 | 0, r = s ? e[N >> 2] : N, e[W + 44 >> 2] = Wu(Xe, fr, u, A, m, p, r, r + ((s ? e[N + 4 >> 2] : Te & 127) << 2) | 0);
                              break t;
                            }
                            k1(p + 20 | 0, W + 44 | 0, u, m, Te);
                            break t;
                          }
                          r = yu(W + 44 | 0, u, m, Te, 4), me[m | 0] & 4 || (e[p + 20 >> 2] = r - 1900);
                          break t;
                        }
                        if ((N | 0) == 37)
                          break r;
                      }
                      e[m >> 2] = e[m >> 2] | 4;
                      break t;
                    }
                    r = Jr - 16 | 0, Jr = r, e[r + 12 >> 2] = u, s = 6, A = W + 44 | 0, N = r + 12 | 0;
                    r: {
                      i: {
                        if (Hu(A, N))
                          break i;
                        s = 4, u = e[A >> 2], p = e[u + 12 >> 2];
                        n: {
                          if ((p | 0) == e[u + 16 >> 2]) {
                            u = xi[e[e[u >> 2] + 36 >> 2]](u) | 0;
                            break n;
                          }
                          u = e[p >> 2];
                        }
                        if ((xi[e[e[Te >> 2] + 52 >> 2]](Te, u, 0) | 0) != 37)
                          break i;
                        if (s = 2, !Hu(Ul(A), N))
                          break r;
                      }
                      e[m >> 2] = e[m >> 2] | s;
                    }
                    Jr = r + 16 | 0;
                  }
                  r = e[W + 44 >> 2];
                }
                return Jr = W + 48 | 0, r | 0;
              }
              function ag(r, s) {
                r = r | 0, s = s | 0;
                var u = 0, A = 0, m = 0, p = 0, N = 0, W = 0, Te = 0;
                N = e[s + 4 >> 2] - e[s >> 2] | 0;
                e: {
                  if (N >>> 0 <= 75) {
                    u = me[r | 0] | me[r + 1 | 0] << 8 | (me[r + 2 | 0] << 16 | me[r + 3 | 0] << 24), A = u - 29 | 0, m = u >>> 0 < 29 ? u : A, p = m + 1 | 0, p >>> 0 > (u >>> 0 <= 28 ? 28 : me[r + 4 | 0] | me[r + 5 | 0] << 8 | (me[r + 6 | 0] << 16 | me[r + 7 | 0] << 24)) >>> 0 && (fu(r, p + (p >>> 1 | 0) | 0), u = me[r | 0] | me[r + 1 | 0] << 8 | (me[r + 2 | 0] << 16 | me[r + 3 | 0] << 24), A = u - 29 | 0), W = u >>> 0 < 29, p = m + (W ? r + 4 | 0 : me[r + 8 | 0] | me[r + 9 | 0] << 8 | (me[r + 10 | 0] << 16 | me[r + 11 | 0] << 24)) | 0, Ys(p + 1 | 0, p, (W ? u : A) - m | 0), u = (me[r | 0] | me[r + 1 | 0] << 8 | (me[r + 2 | 0] << 16 | me[r + 3 | 0] << 24)) + 1 | 0, _[r | 0] = u, _[r + 1 | 0] = u >>> 8, _[r + 2 | 0] = u >>> 16, _[r + 3 | 0] = u >>> 24, _[p | 0] = N;
                    break e;
                  }
                  if (N >>> 0 <= 255) {
                    u = me[r | 0] | me[r + 1 | 0] << 8 | (me[r + 2 | 0] << 16 | me[r + 3 | 0] << 24), A = u - 29 | 0, m = u >>> 0 < 29 ? u : A, p = m + 1 | 0, p >>> 0 > (u >>> 0 <= 28 ? 28 : me[r + 4 | 0] | me[r + 5 | 0] << 8 | (me[r + 6 | 0] << 16 | me[r + 7 | 0] << 24)) >>> 0 && (fu(r, p + (p >>> 1 | 0) | 0), u = me[r | 0] | me[r + 1 | 0] << 8 | (me[r + 2 | 0] << 16 | me[r + 3 | 0] << 24), A = u - 29 | 0), W = r + 4 | 0, N = u >>> 0 < 29, p = m + (N ? W : me[r + 8 | 0] | me[r + 9 | 0] << 8 | (me[r + 10 | 0] << 16 | me[r + 11 | 0] << 24)) | 0, Ys(p + 1 | 0, p, (N ? u : A) - m | 0), u = (me[r | 0] | me[r + 1 | 0] << 8 | (me[r + 2 | 0] << 16 | me[r + 3 | 0] << 24)) + 1 | 0, _[r | 0] = u, _[r + 1 | 0] = u >>> 8, _[r + 2 | 0] = u >>> 16, _[r + 3 | 0] = u >>> 24, _[p | 0] = 76, N = e[s + 4 >> 2] - e[s >> 2] | 0, u = me[r | 0] | me[r + 1 | 0] << 8 | (me[r + 2 | 0] << 16 | me[r + 3 | 0] << 24), A = u - 29 | 0, m = u >>> 0 < 29 ? u : A, p = m + 1 | 0, p >>> 0 > (u >>> 0 <= 28 ? 28 : me[r + 4 | 0] | me[r + 5 | 0] << 8 | (me[r + 6 | 0] << 16 | me[r + 7 | 0] << 24)) >>> 0 && (fu(r, p + (p >>> 1 | 0) | 0), u = me[r | 0] | me[r + 1 | 0] << 8 | (me[r + 2 | 0] << 16 | me[r + 3 | 0] << 24), A = u - 29 | 0), Te = W, W = u >>> 0 < 29, p = m + (W ? Te : me[r + 8 | 0] | me[r + 9 | 0] << 8 | (me[r + 10 | 0] << 16 | me[r + 11 | 0] << 24)) | 0, Ys(p + 1 | 0, p, (W ? u : A) - m | 0), u = (me[r | 0] | me[r + 1 | 0] << 8 | (me[r + 2 | 0] << 16 | me[r + 3 | 0] << 24)) + 1 | 0, _[r | 0] = u, _[r + 1 | 0] = u >>> 8, _[r + 2 | 0] = u >>> 16, _[r + 3 | 0] = u >>> 24, _[p | 0] = N;
                    break e;
                  }
                  if (u = me[r | 0] | me[r + 1 | 0] << 8 | (me[r + 2 | 0] << 16 | me[r + 3 | 0] << 24), m = u - 29 | 0, p = u >>> 0 < 29 ? u : m, A = p + 1 | 0, Te = u >>> 0 <= 28 ? 28 : me[r + 4 | 0] | me[r + 5 | 0] << 8 | (me[r + 6 | 0] << 16 | me[r + 7 | 0] << 24), W = r + 4 | 0, N >>> 0 <= 65535) {
                    A >>> 0 > Te >>> 0 && (fu(r, A + (A >>> 1 | 0) | 0), u = me[r | 0] | me[r + 1 | 0] << 8 | (me[r + 2 | 0] << 16 | me[r + 3 | 0] << 24), m = u - 29 | 0), N = u >>> 0 < 29, A = p + (N ? W : me[r + 8 | 0] | me[r + 9 | 0] << 8 | (me[r + 10 | 0] << 16 | me[r + 11 | 0] << 24)) | 0, Ys(A + 1 | 0, A, (N ? u : m) - p | 0), u = (me[r | 0] | me[r + 1 | 0] << 8 | (me[r + 2 | 0] << 16 | me[r + 3 | 0] << 24)) + 1 | 0, _[r | 0] = u, _[r + 1 | 0] = u >>> 8, _[r + 2 | 0] = u >>> 16, _[r + 3 | 0] = u >>> 24, _[A | 0] = 77, p = e[s + 4 >> 2] - e[s >> 2] | 0, u = me[r | 0] | me[r + 1 | 0] << 8 | (me[r + 2 | 0] << 16 | me[r + 3 | 0] << 24), A = u - 29 | 0, N = u >>> 0 < 29 ? u : A, m = N + 2 | 0, m >>> 0 > (u >>> 0 <= 28 ? 28 : me[r + 4 | 0] | me[r + 5 | 0] << 8 | (me[r + 6 | 0] << 16 | me[r + 7 | 0] << 24)) >>> 0 && (fu(r, m + (m >>> 1 | 0) | 0), u = me[r | 0] | me[r + 1 | 0] << 8 | (me[r + 2 | 0] << 16 | me[r + 3 | 0] << 24), A = u - 29 | 0), Te = W, W = u >>> 0 < 29, m = N + (W ? Te : me[r + 8 | 0] | me[r + 9 | 0] << 8 | (me[r + 10 | 0] << 16 | me[r + 11 | 0] << 24)) | 0, Ys(m + 2 | 0, m, (W ? u : A) - N | 0), u = (me[r | 0] | me[r + 1 | 0] << 8 | (me[r + 2 | 0] << 16 | me[r + 3 | 0] << 24)) + 2 | 0, _[r | 0] = u, _[r + 1 | 0] = u >>> 8, _[r + 2 | 0] = u >>> 16, _[r + 3 | 0] = u >>> 24, _[m | 0] = p, _[m + 1 | 0] = p >>> 8;
                    break e;
                  }
                  A >>> 0 > Te >>> 0 && (fu(r, A + (A >>> 1 | 0) | 0), u = me[r | 0] | me[r + 1 | 0] << 8 | (me[r + 2 | 0] << 16 | me[r + 3 | 0] << 24), m = u - 29 | 0), N = u >>> 0 < 29, A = p + (N ? W : me[r + 8 | 0] | me[r + 9 | 0] << 8 | (me[r + 10 | 0] << 16 | me[r + 11 | 0] << 24)) | 0, Ys(A + 1 | 0, A, (N ? u : m) - p | 0), u = (me[r | 0] | me[r + 1 | 0] << 8 | (me[r + 2 | 0] << 16 | me[r + 3 | 0] << 24)) + 1 | 0, _[r | 0] = u, _[r + 1 | 0] = u >>> 8, _[r + 2 | 0] = u >>> 16, _[r + 3 | 0] = u >>> 24, _[A | 0] = 78, p = e[s + 4 >> 2] - e[s >> 2] | 0, u = me[r | 0] | me[r + 1 | 0] << 8 | (me[r + 2 | 0] << 16 | me[r + 3 | 0] << 24), A = u - 29 | 0, N = u >>> 0 < 29 ? u : A, m = N + 4 | 0, m >>> 0 > (u >>> 0 <= 28 ? 28 : me[r + 4 | 0] | me[r + 5 | 0] << 8 | (me[r + 6 | 0] << 16 | me[r + 7 | 0] << 24)) >>> 0 && (fu(r, m + (m >>> 1 | 0) | 0), u = me[r | 0] | me[r + 1 | 0] << 8 | (me[r + 2 | 0] << 16 | me[r + 3 | 0] << 24), A = u - 29 | 0), Te = W, W = u >>> 0 < 29, m = N + (W ? Te : me[r + 8 | 0] | me[r + 9 | 0] << 8 | (me[r + 10 | 0] << 16 | me[r + 11 | 0] << 24)) | 0, Ys(m + 4 | 0, m, (W ? u : A) - N | 0), u = (me[r | 0] | me[r + 1 | 0] << 8 | (me[r + 2 | 0] << 16 | me[r + 3 | 0] << 24)) + 4 | 0, _[r | 0] = u, _[r + 1 | 0] = u >>> 8, _[r + 2 | 0] = u >>> 16, _[r + 3 | 0] = u >>> 24, _[m | 0] = p, _[m + 1 | 0] = p >>> 8, _[m + 2 | 0] = p >>> 16, _[m + 3 | 0] = p >>> 24;
                }
                A = me[r | 0] | me[r + 1 | 0] << 8 | (me[r + 2 | 0] << 16 | me[r + 3 | 0] << 24), m = A - 29 | 0, p = e[s + 4 >> 2], s = e[s >> 2], W = p - s | 0, N = A >>> 0 < 29 ? A : m, u = W + N | 0, u >>> 0 > (A >>> 0 <= 28 ? 28 : me[r + 4 | 0] | me[r + 5 | 0] << 8 | (me[r + 6 | 0] << 16 | me[r + 7 | 0] << 24)) >>> 0 && (fu(r, u + (u >>> 1 | 0) | 0), A = me[r | 0] | me[r + 1 | 0] << 8 | (me[r + 2 | 0] << 16 | me[r + 3 | 0] << 24), m = A - 29 | 0), Te = A >>> 0 < 29, u = N + (Te ? r + 4 | 0 : me[r + 8 | 0] | me[r + 9 | 0] << 8 | (me[r + 10 | 0] << 16 | me[r + 11 | 0] << 24)) | 0, Ys(W + u | 0, u, (Te ? A : m) - N | 0), A = W + (me[r | 0] | me[r + 1 | 0] << 8 | (me[r + 2 | 0] << 16 | me[r + 3 | 0] << 24)) | 0, _[r | 0] = A, _[r + 1 | 0] = A >>> 8, _[r + 2 | 0] = A >>> 16, _[r + 3 | 0] = A >>> 24;
                e: {
                  if ((s | 0) == (p | 0))
                    break e;
                  if (m = p + (s ^ -1) | 0, W = W & 7, W)
                    for (A = 0; _[u | 0] = me[s | 0], s = s + 1 | 0, u = u + 1 | 0, A = A + 1 | 0, (W | 0) != (A | 0); )
                      ;
                  if (m >>> 0 < 7)
                    break e;
                  for (; _[u | 0] = me[s | 0], _[u + 1 | 0] = me[s + 1 | 0], _[u + 2 | 0] = me[s + 2 | 0], _[u + 3 | 0] = me[s + 3 | 0], _[u + 4 | 0] = me[s + 4 | 0], _[u + 5 | 0] = me[s + 5 | 0], _[u + 6 | 0] = me[s + 6 | 0], _[u + 7 | 0] = me[s + 7 | 0], u = u + 8 | 0, s = s + 8 | 0, (p | 0) != (s | 0); )
                    ;
                }
                return r | 0;
              }
              function ug(r, s, u, A, m, p, N, W) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0, m = m | 0, p = p | 0, N = N | 0, W = W | 0;
                var Te = 0, Xe = 0, fr = 0;
                W = Jr - 16 | 0, Jr = W, e[W + 12 >> 2] = s, e[m >> 2] = 0, Te = e[A + 28 >> 2], e[W >> 2] = Te, e[Te + 4 >> 2] = e[Te + 4 >> 2] + 1, e[5996] = 0, Te = Mi(170, e[W >> 2]) | 0, Xe = e[5996], e[5996] = 0;
                e: {
                  t: {
                    r: {
                      i: {
                        n: {
                          s: {
                            a: {
                              o: {
                                l: {
                                  c: {
                                    d: {
                                      f: {
                                        u: {
                                          g: {
                                            A: {
                                              p: {
                                                m: {
                                                  k: {
                                                    N: {
                                                      S: {
                                                        T: {
                                                          v: {
                                                            w: {
                                                              E: {
                                                                h: {
                                                                  R: {
                                                                    I: {
                                                                      if ((Xe | 0) != 1)
                                                                        switch (Xe = e[W >> 2], fr = e[Xe + 4 >> 2] - 1 | 0, e[Xe + 4 >> 2] = fr, (fr | 0) == -1 && xi[e[e[Xe >> 2] + 8 >> 2]](Xe), N - 65 | 0) {
                                                                          case 54:
                                                                            break c;
                                                                          case 19:
                                                                            break d;
                                                                          case 18:
                                                                            break f;
                                                                          case 17:
                                                                            break u;
                                                                          case 49:
                                                                            break g;
                                                                          case 47:
                                                                            break A;
                                                                          case 45:
                                                                          case 51:
                                                                            break p;
                                                                          case 12:
                                                                            break m;
                                                                          case 44:
                                                                            break k;
                                                                          case 41:
                                                                            break N;
                                                                          case 8:
                                                                            break S;
                                                                          case 7:
                                                                            break T;
                                                                          case 5:
                                                                            break v;
                                                                          case 3:
                                                                            break w;
                                                                          case 35:
                                                                          case 36:
                                                                            break E;
                                                                          case 34:
                                                                            break h;
                                                                          case 1:
                                                                          case 33:
                                                                          case 39:
                                                                            break R;
                                                                          case 0:
                                                                          case 32:
                                                                            break I;
                                                                          case 2:
                                                                          case 4:
                                                                          case 6:
                                                                          case 9:
                                                                          case 10:
                                                                          case 11:
                                                                          case 13:
                                                                          case 14:
                                                                          case 15:
                                                                          case 16:
                                                                          case 20:
                                                                          case 21:
                                                                          case 22:
                                                                          case 25:
                                                                          case 26:
                                                                          case 27:
                                                                          case 28:
                                                                          case 29:
                                                                          case 30:
                                                                          case 31:
                                                                          case 37:
                                                                          case 38:
                                                                          case 40:
                                                                          case 42:
                                                                          case 43:
                                                                          case 46:
                                                                          case 48:
                                                                          case 50:
                                                                          case 52:
                                                                          case 53:
                                                                            break i;
                                                                          case 24:
                                                                            break s;
                                                                          case 56:
                                                                            break a;
                                                                          case 23:
                                                                            break o;
                                                                          case 55:
                                                                            break l;
                                                                          default:
                                                                            break n;
                                                                        }
                                                                      u = Hr() | 0, r = e[W >> 2], s = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = s, (s | 0) == -1 && xi[e[e[r >> 2] + 8 >> 2]](r), Jn(u | 0), Oi();
                                                                    }
                                                                    y1(r, p + 24 | 0, W + 12 | 0, u, m, Te);
                                                                    break t;
                                                                  }
                                                                  Hd(r, p + 16 | 0, W + 12 | 0, u, m, Te);
                                                                  break t;
                                                                }
                                                                N = xi[e[e[r + 8 >> 2] + 12 >> 2]](r + 8 | 0) | 0, Te = me[N + 11 | 0], Xe = r, fr = s, s = (Te & 128) >>> 7 | 0, r = s ? e[N >> 2] : N, e[W + 12 >> 2] = ju(Xe, fr, u, A, m, p, r, r + (s ? e[N + 4 >> 2] : Te & 127) | 0);
                                                                break t;
                                                              }
                                                              r = Du(W + 12 | 0, u, m, Te, 2), s = e[m >> 2];
                                                              E: {
                                                                if (!(r - 1 >>> 0 > 30 | s & 4)) {
                                                                  e[p + 12 >> 2] = r;
                                                                  break E;
                                                                }
                                                                e[m >> 2] = s | 4;
                                                              }
                                                              break t;
                                                            }
                                                            e[W >> 2] = 623865125, e[W + 4 >> 2] = 2032480100, e[W + 12 >> 2] = ju(r, s, u, A, m, p, W, W + 8 | 0);
                                                            break t;
                                                          }
                                                          e[W >> 2] = 623728933, e[W + 4 >> 2] = 1680158061, e[W + 12 >> 2] = ju(r, s, u, A, m, p, W, W + 8 | 0);
                                                          break t;
                                                        }
                                                        r = Du(W + 12 | 0, u, m, Te, 2), s = e[m >> 2];
                                                        T: {
                                                          if (!((r | 0) > 23 | s & 4)) {
                                                            e[p + 8 >> 2] = r;
                                                            break T;
                                                          }
                                                          e[m >> 2] = s | 4;
                                                        }
                                                        break t;
                                                      }
                                                      r = Du(W + 12 | 0, u, m, Te, 2), s = e[m >> 2];
                                                      S: {
                                                        if (!(r - 1 >>> 0 > 11 | s & 4)) {
                                                          e[p + 8 >> 2] = r;
                                                          break S;
                                                        }
                                                        e[m >> 2] = s | 4;
                                                      }
                                                      break t;
                                                    }
                                                    r = Du(W + 12 | 0, u, m, Te, 3), s = e[m >> 2];
                                                    N: {
                                                      if (!((r | 0) > 365 | s & 4)) {
                                                        e[p + 28 >> 2] = r;
                                                        break N;
                                                      }
                                                      e[m >> 2] = s | 4;
                                                    }
                                                    break t;
                                                  }
                                                  s = Du(W + 12 | 0, u, m, Te, 2) - 1 | 0, r = e[m >> 2];
                                                  k: {
                                                    if (!(s >>> 0 > 11 | r & 4)) {
                                                      e[p + 16 >> 2] = s;
                                                      break k;
                                                    }
                                                    e[m >> 2] = r | 4;
                                                  }
                                                  break t;
                                                }
                                                r = Du(W + 12 | 0, u, m, Te, 2), s = e[m >> 2];
                                                m: {
                                                  if (!((r | 0) > 59 | s & 4)) {
                                                    e[p + 4 >> 2] = r;
                                                    break m;
                                                  }
                                                  e[m >> 2] = s | 4;
                                                }
                                                break t;
                                              }
                                              for (r = W + 12 | 0, s = Jr - 16 | 0, Jr = s, e[s + 12 >> 2] = u; ; ) {
                                                p: {
                                                  if (Lu(r, s + 12 | 0))
                                                    break p;
                                                  u = e[r >> 2], A = e[u + 12 >> 2];
                                                  m: {
                                                    if ((A | 0) == e[u + 16 >> 2]) {
                                                      u = xi[e[e[u >> 2] + 36 >> 2]](u) | 0;
                                                      break m;
                                                    }
                                                    u = me[A | 0];
                                                  }
                                                  if (A = e[Te + 8 >> 2], u = u << 24 >> 24, (u | 0) >= 0 ? u = e[A + ((u & 255) << 2) >> 2] & 1 : u = 0, !u)
                                                    break p;
                                                  Ql(r);
                                                  continue;
                                                }
                                                break;
                                              }
                                              Lu(r, s + 12 | 0) && (e[m >> 2] = e[m >> 2] | 2), Jr = s + 16 | 0;
                                              break t;
                                            }
                                            A = W + 12 | 0, r = xi[e[e[r + 8 >> 2] + 8 >> 2]](r + 8 | 0) | 0, s = me[r + 11 | 0], N = (s & 128) >>> 7 | 0 ? e[r + 4 >> 2] : s & 127, s = me[r + 23 | 0];
                                            A: {
                                              if ((N | 0) == (0 - ((s & 128) >>> 7 | 0 ? e[r + 16 >> 2] : s & 127) | 0)) {
                                                e[m >> 2] = e[m >> 2] | 4;
                                                break A;
                                              }
                                              if (u = rl(A, u, r, r + 24 | 0, Te, m, 0), s = e[p + 8 >> 2], !((u | 0) != (r | 0) | (s | 0) != 12)) {
                                                e[p + 8 >> 2] = 0;
                                                break A;
                                              }
                                              (u - r | 0) != 12 | (s | 0) > 11 || (e[p + 8 >> 2] = s + 12);
                                            }
                                            break t;
                                          }
                                          N = me[12456] | me[12457] << 8 | (me[12458] << 16 | me[12459] << 24), _[W + 7 | 0] = N, _[W + 8 | 0] = N >>> 8, _[W + 9 | 0] = N >>> 16, _[W + 10 | 0] = N >>> 24, N = me[12453] | me[12454] << 8 | (me[12455] << 16 | me[12456] << 24), e[W >> 2] = me[12449] | me[12450] << 8 | (me[12451] << 16 | me[12452] << 24), e[W + 4 >> 2] = N, e[W + 12 >> 2] = ju(r, s, u, A, m, p, W, W + 11 | 0);
                                          break t;
                                        }
                                        _[W + 4 | 0] = me[12464], e[W >> 2] = me[12460] | me[12461] << 8 | (me[12462] << 16 | me[12463] << 24), e[W + 12 >> 2] = ju(r, s, u, A, m, p, W, W + 5 | 0);
                                        break t;
                                      }
                                      r = Du(W + 12 | 0, u, m, Te, 2), s = e[m >> 2];
                                      f: {
                                        if (!((r | 0) > 60 | s & 4)) {
                                          e[p >> 2] = r;
                                          break f;
                                        }
                                        e[m >> 2] = s | 4;
                                      }
                                      break t;
                                    }
                                    e[W >> 2] = 624576549, e[W + 4 >> 2] = 1394948685, e[W + 12 >> 2] = ju(r, s, u, A, m, p, W, W + 8 | 0);
                                    break t;
                                  }
                                  r = Du(W + 12 | 0, u, m, Te, 1), s = e[m >> 2];
                                  c: {
                                    if (!((r | 0) > 6 | s & 4)) {
                                      e[p + 24 >> 2] = r;
                                      break c;
                                    }
                                    e[m >> 2] = s | 4;
                                  }
                                  break t;
                                }
                                r = xi[e[e[r >> 2] + 20 >> 2]](r, s, u, A, m, p) | 0;
                                break e;
                              }
                              N = xi[e[e[r + 8 >> 2] + 24 >> 2]](r + 8 | 0) | 0, Te = me[N + 11 | 0], Xe = r, fr = s, s = (Te & 128) >>> 7 | 0, r = s ? e[N >> 2] : N, e[W + 12 >> 2] = ju(Xe, fr, u, A, m, p, r, r + (s ? e[N + 4 >> 2] : Te & 127) | 0);
                              break t;
                            }
                            S1(p + 20 | 0, W + 12 | 0, u, m, Te);
                            break t;
                          }
                          r = Du(W + 12 | 0, u, m, Te, 4), me[m | 0] & 4 || (e[p + 20 >> 2] = r - 1900);
                          break t;
                        }
                        if ((N | 0) == 37)
                          break r;
                      }
                      e[m >> 2] = e[m >> 2] | 4;
                      break t;
                    }
                    r = Jr - 16 | 0, Jr = r, e[r + 12 >> 2] = u, s = 6, A = W + 12 | 0, N = r + 12 | 0;
                    r: {
                      i: {
                        if (Lu(A, N))
                          break i;
                        s = 4, u = e[A >> 2], p = e[u + 12 >> 2];
                        n: {
                          if ((p | 0) == e[u + 16 >> 2]) {
                            u = xi[e[e[u >> 2] + 36 >> 2]](u) | 0;
                            break n;
                          }
                          u = me[p | 0];
                        }
                        if ((xi[e[e[Te >> 2] + 36 >> 2]](Te, u << 24 >> 24, 0) | 0) != 37)
                          break i;
                        if (s = 2, !Lu(Ql(A), N))
                          break r;
                      }
                      e[m >> 2] = e[m >> 2] | s;
                    }
                    Jr = r + 16 | 0;
                  }
                  r = e[W + 12 >> 2];
                }
                return Jr = W + 16 | 0, r | 0;
              }
              function Mf(r, s, u, A, m, p) {
                var N = 0, W = 0, Te = 0, Xe = 0, fr = 0, ar = 0, vr = 0, _r = 0;
                N = Jr - 32 | 0, Jr = N, me[24588] || (e[6145] = 0, e[6146] = 0, e[6143] = 0, e[6144] = 0, e[6141] = 0, e[6142] = 0, _[24588] = 1), Te = 1 - m;
                e: {
                  t: {
                    r: {
                      i: {
                        n: {
                          s:
                            switch (s | 0) {
                              case 10:
                              case 11:
                              case 12:
                              case 16:
                                if (s = Qs(8), e[N + 20 >> 2] = s, p = s + 8 | 0, e[N + 28 >> 2] = p, jn[s >> 3] = u, e[N + 24 >> 2] = p, e[5996] = 0, p = Mi(3, 8) | 0, W = e[5996], e[5996] = 0, (W | 0) == 1)
                                  break t;
                                if (e[N + 8 >> 2] = p, W = p + 8 | 0, e[N + 16 >> 2] = W, jn[p >> 3] = A, e[5996] = 0, e[N + 12 >> 2] = W, xn(65, r | 0, N + 20 | 0, N + 8 | 0) | 0, r = e[5996], e[5996] = 0, (r | 0) != 1) {
                                  Br(p), Br(s);
                                  break n;
                                }
                                break r;
                              case 13:
                              case 14:
                              case 15:
                                if (s = Qs(8), e[N + 20 >> 2] = s, p = s + 8 | 0, e[N + 28 >> 2] = p, jn[s >> 3] = u, e[N + 24 >> 2] = p, e[5996] = 0, p = Mi(3, 8) | 0, W = e[5996], e[5996] = 0, (W | 0) == 1)
                                  break t;
                                if (e[N + 8 >> 2] = p, W = p + 8 | 0, e[N + 16 >> 2] = W, e[p >> 2] = 0, e[p + 4 >> 2] = 0, e[5996] = 0, e[N + 12 >> 2] = W, xn(65, r | 0, N + 20 | 0, N + 8 | 0) | 0, r = e[5996], e[5996] = 0, (r | 0) != 1) {
                                  Br(p), Br(s);
                                  break n;
                                }
                                break r;
                              case 17:
                              case 18:
                                if (s = Qs(16), e[N + 20 >> 2] = s, p = s + 16 | 0, e[N + 28 >> 2] = p, jn[s + 8 >> 3] = u, jn[s >> 3] = u, e[N + 24 >> 2] = p, e[5996] = 0, p = Mi(3, 16) | 0, W = e[5996], e[5996] = 0, (W | 0) == 1)
                                  break t;
                                if (e[N + 8 >> 2] = p, W = p + 16 | 0, e[N + 16 >> 2] = W, jn[p + 8 >> 3] = A, jn[p >> 3] = A, e[5996] = 0, e[N + 12 >> 2] = W, xn(65, r | 0, N + 20 | 0, N + 8 | 0) | 0, r = e[5996], e[5996] = 0, (r | 0) != 1) {
                                  Br(p), Br(s);
                                  break n;
                                }
                                break r;
                              case 19:
                                if (s = Qs(16), e[N + 20 >> 2] = s, p = s + 16 | 0, e[N + 28 >> 2] = p, Te = Te * u, jn[s + 8 >> 3] = Te, u = u * m, jn[s >> 3] = u, e[N + 24 >> 2] = p, e[5996] = 0, p = Mi(3, 16) | 0, W = e[5996], e[5996] = 0, (W | 0) == 1)
                                  break t;
                                if (e[N + 8 >> 2] = p, W = p + 16 | 0, e[N + 16 >> 2] = W, jn[p + 8 >> 3] = u + A, jn[p >> 3] = Te + A, e[5996] = 0, e[N + 12 >> 2] = W, xn(65, r | 0, N + 20 | 0, N + 8 | 0) | 0, r = e[5996], e[5996] = 0, (r | 0) != 1) {
                                  Br(p), Br(s);
                                  break n;
                                }
                                break r;
                              case 21:
                                if (s = Qs(16), e[N + 20 >> 2] = s, p = s + 16 | 0, e[N + 28 >> 2] = p, Te = Te * u, jn[s + 8 >> 3] = Te, jn[s >> 3] = u * m, e[N + 24 >> 2] = p, e[5996] = 0, p = Mi(3, 16) | 0, W = e[5996], e[5996] = 0, (W | 0) == 1)
                                  break t;
                                if (e[N + 8 >> 2] = p, W = p + 16 | 0, e[N + 16 >> 2] = W, jn[p + 8 >> 3] = A, jn[p >> 3] = Te + A, e[5996] = 0, e[N + 12 >> 2] = W, xn(65, r | 0, N + 20 | 0, N + 8 | 0) | 0, r = e[5996], e[5996] = 0, (r | 0) != 1) {
                                  Br(p), Br(s);
                                  break n;
                                }
                                break r;
                              case 20:
                                if (s = Qs(16), e[N + 20 >> 2] = s, p = s + 16 | 0, e[N + 28 >> 2] = p, A = Te * u, jn[s + 8 >> 3] = A, jn[s >> 3] = u * m, e[N + 24 >> 2] = p, e[5996] = 0, p = Mi(3, 16) | 0, W = e[5996], e[5996] = 0, (W | 0) == 1)
                                  break t;
                                if (e[N + 8 >> 2] = p, W = p + 16 | 0, e[N + 16 >> 2] = W, e[p + 8 >> 2] = 0, e[p + 12 >> 2] = 0, jn[p >> 3] = A, e[5996] = 0, e[N + 12 >> 2] = W, xn(65, r | 0, N + 20 | 0, N + 8 | 0) | 0, r = e[5996], e[5996] = 0, (r | 0) != 1) {
                                  Br(p), Br(s);
                                  break n;
                                }
                                break r;
                              case 22:
                                if (s = Qs(16), e[N + 20 >> 2] = s, W = s + 16 | 0, e[N + 28 >> 2] = W, jn[s + 8 >> 3] = Te * u, jn[s >> 3] = u * m, e[N + 24 >> 2] = W, e[5996] = 0, W = Mi(3, 16) | 0, Xe = e[5996], e[5996] = 0, (Xe | 0) == 1)
                                  break t;
                                if (e[N + 8 >> 2] = W, Xe = W + 16 | 0, e[N + 16 >> 2] = Xe, jn[W + 8 >> 3] = (p | 0) == 1 ? A : 0, jn[W >> 3] = p ? 0 : A, e[5996] = 0, e[N + 12 >> 2] = Xe, xn(65, r | 0, N + 20 | 0, N + 8 | 0) | 0, r = e[5996], e[5996] = 0, (r | 0) != 1) {
                                  Br(W), Br(s);
                                  break n;
                                }
                                r = Hr() | 0, Br(W);
                                break e;
                              case 23:
                                if (s = Qs(24), e[N + 20 >> 2] = s, p = s + 24 | 0, e[N + 28 >> 2] = p, Te = Te * u, jn[s + 16 >> 3] = Te, u = u * m, jn[s + 8 >> 3] = u, jn[s >> 3] = u, e[N + 24 >> 2] = p, e[5996] = 0, p = Mi(3, 24) | 0, W = e[5996], e[5996] = 0, (W | 0) == 1)
                                  break t;
                                if (e[N + 8 >> 2] = p, W = p + 24 | 0, e[N + 16 >> 2] = W, jn[p + 16 >> 3] = A, e[p + 8 >> 2] = 0, e[p + 12 >> 2] = 0, jn[p >> 3] = Te + A, e[5996] = 0, e[N + 12 >> 2] = W, xn(65, r | 0, N + 20 | 0, N + 8 | 0) | 0, r = e[5996], e[5996] = 0, (r | 0) != 1) {
                                  Br(p), Br(s);
                                  break n;
                                }
                                break r;
                              case 24:
                                a: {
                                  o: {
                                    if (!p) {
                                      p = 0;
                                      break o;
                                    }
                                    if (p >>> 0 >= 536870912)
                                      break i;
                                    if (m = u * m, W = p << 3, fr = Qs(W), s = fr, ar = p & 7, ar)
                                      for (; jn[s >> 3] = m, s = s + 8 | 0, Xe = Xe + 1 | 0, (ar | 0) != (Xe | 0); )
                                        ;
                                    if (vr = W + fr | 0, _r = p - 1 & 536870911, _r >>> 0 >= 7)
                                      for (; jn[s + 56 >> 3] = m, jn[s + 48 >> 3] = m, jn[s + 40 >> 3] = m, jn[s + 32 >> 3] = m, jn[s + 24 >> 3] = m, jn[s + 16 >> 3] = m, jn[s + 8 >> 3] = m, jn[s >> 3] = m, s = s - -64 | 0, (vr | 0) != (s | 0); )
                                        ;
                                    if (Xe = 0, e[5996] = 0, W = Mi(3, W | 0) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1)
                                      break a;
                                    if (u = u * Te + A, s = W, ar)
                                      for (; jn[s >> 3] = u, s = s + 8 | 0, Xe = Xe + 1 | 0, (ar | 0) != (Xe | 0); )
                                        ;
                                    if (p = (p << 3) + W | 0, _r >>> 0 < 7)
                                      break o;
                                    for (; jn[s + 56 >> 3] = u, jn[s + 48 >> 3] = u, jn[s + 40 >> 3] = u, jn[s + 32 >> 3] = u, jn[s + 24 >> 3] = u, jn[s + 16 >> 3] = u, jn[s + 8 >> 3] = u, jn[s >> 3] = u, s = s - -64 | 0, (p | 0) != (s | 0); )
                                      ;
                                  }
                                  e[r + 12 >> 2] = W, e[r + 8 >> 2] = vr, e[r + 4 >> 2] = vr, e[r >> 2] = fr, e[r + 20 >> 2] = p, e[r + 16 >> 2] = p;
                                  break n;
                                }
                                r = Hr() | 0, Br(fr), Jn(r | 0), Oi();
                              default:
                                ga(2350, 1900, 558, 1676), Oi();
                              case 0:
                              case 1:
                              case 2:
                              case 3:
                              case 4:
                              case 5:
                              case 6:
                              case 7:
                              case 8:
                              case 9:
                              case 25:
                                break s;
                            }
                          vc(r);
                        }
                        Jr = N + 32 | 0;
                        return;
                      }
                      Jo(), Oi();
                    }
                    r = Hr() | 0, Br(p);
                    break e;
                  }
                  r = Hr() | 0;
                }
                Br(s), Jn(r | 0), Oi();
              }
              function lh(r, s, u) {
                r = r | 0, s = s | 0, u = u | 0;
                var A = 0, m = 0, p = 0, N = 0, W = 0, Te = 0, Xe = 0, fr = 0, ar = 0;
                e: {
                  t: {
                    m = e[u >> 2], A = e[m + 80 >> 2];
                    r: {
                      if (!A | Ls[m + 84 >> 2] > 3600 | (e[m + 52 >> 2] + e[m + 44 >> 2] >>> 0 > 201 | Ls[m + 68 >> 2] > 100))
                        break r;
                      if (e[5996] = 0, W = pi(54, 2049, 1) | 0, p = e[5996], e[5996] = 0, (p | 0) == 1)
                        break t;
                      if ((A ^ -1) & W)
                        break r;
                      if (A = e[m + 80 >> 2], e[5996] = 0, W = pi(54, 2165, 1) | 0, p = e[5996], e[5996] = 0, (p | 0) == 1)
                        break t;
                      if (me[m + 88 | 0] | (A ^ -1) & W || (Te = jn[r + 24 >> 3], fr = Te == 0 ? 0 : Te * jn[s + 8 >> 3], Te = jn[r + 16 >> 3], N = e[m + 84 >> 2], Te = fr + ((Te == 0 ? 0 : Te * jn[s >> 3]) + +(N >>> 0)), Te > 1e4))
                        break r;
                      p = e[m + 80 >> 2];
                      i: {
                        n: {
                          if (A = e[r >> 2], W = e[r + 4 >> 2], (A | 0) == (W | 0))
                            break n;
                          for (m = A; ; ) {
                            Xe = e[m >> 2];
                            s: {
                              if (p & (e[Xe + 80 >> 2] ^ -1))
                                break s;
                              if (fr = jn[m + 24 >> 3], fr < Te)
                                break r;
                              if (Te < fr)
                                break s;
                              if (N >>> 0 <= Ls[Xe + 84 >> 2])
                                break r;
                            }
                            if (m = m + 32 | 0, (W | 0) == (m | 0))
                              break;
                          }
                          for (m = p ^ -1; ; ) {
                            Xe = e[A >> 2];
                            s: {
                              if (m & e[Xe + 80 >> 2] || (fr = jn[A + 24 >> 3], fr < Te))
                                break s;
                              if (N >>> 0 >= Ls[Xe + 84 >> 2] | Te < fr)
                                break n;
                            }
                            if (A = A + 32 | 0, (W | 0) == (A | 0))
                              break;
                          }
                          m = W;
                          break i;
                        }
                        if ((A | 0) == (W | 0)) {
                          m = W;
                          break i;
                        }
                        N = A + 32 | 0;
                        n: {
                          if ((N | 0) == (W | 0)) {
                            m = A;
                            break n;
                          }
                          for (Xe = p ^ -1, m = A; ; ) {
                            p = A, A = N, N = e[p + 32 >> 2];
                            s: {
                              a: {
                                if (Xe & e[N + 80 >> 2] || (fr = jn[p + 56 >> 3], fr < Te))
                                  break a;
                                if (Ls[N + 84 >> 2] <= Ls[e[u >> 2] + 84 >> 2] | Te < fr)
                                  break s;
                              }
                              ar = e[p + 36 >> 2], e[A >> 2] = 0, e[p + 36 >> 2] = 0, e[m >> 2] = N, N = e[m + 4 >> 2], e[m + 4 >> 2] = ar;
                              a: {
                                if (!N || (ar = e[N + 4 >> 2], e[N + 4 >> 2] = ar - 1, ar))
                                  break a;
                                xi[e[e[N >> 2] + 8 >> 2]](N), ys(N);
                              }
                              N = e[p + 60 >> 2], e[m + 24 >> 2] = e[p + 56 >> 2], e[m + 28 >> 2] = N, N = e[p + 52 >> 2], e[m + 16 >> 2] = e[p + 48 >> 2], e[m + 20 >> 2] = N, N = e[p + 44 >> 2], e[m + 8 >> 2] = e[p + 40 >> 2], e[m + 12 >> 2] = N, m = m + 32 | 0;
                            }
                            if (N = A + 32 | 0, (N | 0) == (W | 0))
                              break;
                          }
                          W = e[r + 4 >> 2];
                        }
                        if ((m | 0) == (W | 0)) {
                          m = W;
                          break i;
                        }
                        if (A = (W - m | 0) + m | 0, (W | 0) != (A | 0)) {
                          for (; ; ) {
                            N = e[A >> 2], Xe = e[A + 4 >> 2], e[A >> 2] = 0, e[A + 4 >> 2] = 0, p = e[m + 4 >> 2], e[m >> 2] = N, e[m + 4 >> 2] = Xe;
                            n: {
                              if (!p || (N = e[p + 4 >> 2], e[p + 4 >> 2] = N - 1, N))
                                break n;
                              xi[e[e[p >> 2] + 8 >> 2]](p), ys(p);
                            }
                            if (p = e[A + 12 >> 2], e[m + 8 >> 2] = e[A + 8 >> 2], e[m + 12 >> 2] = p, p = e[A + 28 >> 2], e[m + 24 >> 2] = e[A + 24 >> 2], e[m + 28 >> 2] = p, p = e[A + 20 >> 2], e[m + 16 >> 2] = e[A + 16 >> 2], e[m + 20 >> 2] = p, m = m + 32 | 0, A = A + 32 | 0, (W | 0) == (A | 0))
                              break;
                          }
                          W = e[r + 4 >> 2];
                        }
                        if ((m | 0) != (W | 0))
                          for (; ; ) {
                            W = W - 32 | 0, A = e[W + 4 >> 2];
                            n: {
                              if (!A || (p = e[A + 4 >> 2], e[A + 4 >> 2] = p - 1, p))
                                break n;
                              xi[e[e[A >> 2] + 8 >> 2]](A), ys(A);
                            }
                            if ((m | 0) == (W | 0))
                              break;
                          }
                        e[r + 4 >> 2] = m;
                      }
                      p = e[r + 8 >> 2];
                      i: {
                        if (p >>> 0 > m >>> 0) {
                          e[m >> 2] = e[u >> 2], e[m + 4 >> 2] = e[u + 4 >> 2], e[u >> 2] = 0, e[u + 4 >> 2] = 0, A = e[s + 12 >> 2], e[m + 16 >> 2] = e[s + 8 >> 2], e[m + 20 >> 2] = A, A = e[s + 4 >> 2], e[m + 8 >> 2] = e[s >> 2], e[m + 12 >> 2] = A, jn[m + 24 >> 3] = Te, e[r + 4 >> 2] = m + 32;
                          break i;
                        }
                        if (W = e[r >> 2], N = m - W >> 5, A = N + 1 | 0, A >>> 0 >= 134217728) {
                          if (e[5996] = 0, Nn(62), r = e[5996], e[5996] = 0, (r | 0) == 1)
                            break t;
                          break e;
                        }
                        if (p = p - W | 0, Xe = p >> 4, A = p >>> 0 >= 2147483616 ? 134217727 : A >>> 0 < Xe >>> 0 ? Xe : A, A >>> 0 >= 134217728) {
                          if (e[5996] = 0, Nn(35), r = e[5996], e[5996] = 0, (r | 0) != 1)
                            break e;
                          break t;
                        }
                        if (e[5996] = 0, Xe = A << 5, p = Mi(3, Xe | 0) | 0, A = e[5996], e[5996] = 0, (A | 0) == 1)
                          break t;
                        A = p + (N << 5) | 0, e[A >> 2] = e[u >> 2], e[A + 4 >> 2] = e[u + 4 >> 2], e[u >> 2] = 0, e[u + 4 >> 2] = 0, N = e[s + 12 >> 2], e[A + 16 >> 2] = e[s + 8 >> 2], e[A + 20 >> 2] = N, N = e[s + 4 >> 2], e[A + 8 >> 2] = e[s >> 2], e[A + 12 >> 2] = N, jn[A + 24 >> 3] = Te, s = p + Xe | 0, p = A + 32 | 0;
                        n: {
                          if ((m | 0) != (W | 0)) {
                            for (; A = A - 32 | 0, m = m - 32 | 0, e[A >> 2] = e[m >> 2], e[A + 4 >> 2] = e[m + 4 >> 2], e[m >> 2] = 0, e[m + 4 >> 2] = 0, N = e[m + 28 >> 2], e[A + 24 >> 2] = e[m + 24 >> 2], e[A + 28 >> 2] = N, N = e[m + 20 >> 2], e[A + 16 >> 2] = e[m + 16 >> 2], e[A + 20 >> 2] = N, N = e[m + 12 >> 2], e[A + 8 >> 2] = e[m + 8 >> 2], e[A + 12 >> 2] = N, (m | 0) != (W | 0); )
                              ;
                            if (e[r + 8 >> 2] = s, s = e[r + 4 >> 2], e[r + 4 >> 2] = p, m = e[r >> 2], e[r >> 2] = A, (s | 0) == (m | 0))
                              break n;
                            for (; ; ) {
                              s = s - 32 | 0, A = e[s + 4 >> 2];
                              s: {
                                if (!A || (W = e[A + 4 >> 2], e[A + 4 >> 2] = W - 1, W))
                                  break s;
                                xi[e[e[A >> 2] + 8 >> 2]](A), ys(A);
                              }
                              if ((s | 0) == (m | 0))
                                break;
                            }
                            break n;
                          }
                          e[r + 8 >> 2] = s, e[r + 4 >> 2] = p, e[r >> 2] = A;
                        }
                        if (!m)
                          break i;
                        Br(m);
                      }
                      e[r + 32 >> 2] = e[r + 32 >> 2] + 1;
                    }
                    r = e[u + 4 >> 2];
                    r: {
                      if (!r || (s = e[r + 4 >> 2], e[r + 4 >> 2] = s - 1, s))
                        break r;
                      xi[e[e[r >> 2] + 8 >> 2]](r), ys(r);
                    }
                    return;
                  }
                  r = Hr() | 0, Lo(u), Jn(r | 0), Oi();
                }
                Oi();
              }
              function hh(r, s, u) {
                r = r | 0, s = s | 0, u = u | 0;
                var A = 0, m = 0, p = 0, N = 0, W = 0, Te = ma(0), Xe = 0, fr = 0, ar = 0, vr = 0, _r = ma(0), hi = 0;
                A = Sn(r, 1540483477), A = Sn(A >>> 24 ^ A, 1540483477) ^ 1866966612, A = Sn(A >>> 13 ^ A, 1540483477), N = A >>> 15 ^ A;
                e: {
                  t: {
                    r: {
                      i: {
                        W = e[s + 4 >> 2];
                        n: {
                          if (!W)
                            break n;
                          m = e[s >> 2], fr = Ns(W), A = W - 1 & N;
                          s: {
                            if (fr >>> 0 <= 1 || (A = N, A >>> 0 < W >>> 0))
                              break s;
                            A = (A >>> 0) % (W >>> 0) | 0;
                          }
                          if (p = A, A = e[m + (p << 2) >> 2], !A || (A = e[A >> 2], !A))
                            break n;
                          if (fr >>> 0 <= 1) {
                            for (m = W - 1 | 0; ; ) {
                              W = e[A + 4 >> 2];
                              s: {
                                if ((W | 0) != (N | 0)) {
                                  if ((p | 0) == (m & W))
                                    break s;
                                  break n;
                                }
                                if (e[A + 8 >> 2] == (r | 0))
                                  break i;
                              }
                              if (A = e[A >> 2], !A)
                                break;
                            }
                            break n;
                          }
                          for (; ; ) {
                            m = e[A + 4 >> 2];
                            s: {
                              if ((m | 0) != (N | 0)) {
                                if (m >>> 0 >= W >>> 0 && (m = (m >>> 0) % (W >>> 0) | 0), (m | 0) == (p | 0))
                                  break s;
                                break n;
                              }
                              if (e[A + 8 >> 2] == (r | 0))
                                break i;
                            }
                            if (A = e[A >> 2], !A)
                              break;
                          }
                        }
                        if (vr = nh(r, s, u), !vr)
                          return 0;
                        if (A = e[s + 4 >> 2], !A)
                          break r;
                        if (m = A - 1 | 0, m & A) {
                          if (u = A >>> 0 <= N >>> 0 ? (N >>> 0) % (A >>> 0) | 0 : N, p = e[e[s >> 2] + (u << 2) >> 2], !p)
                            break r;
                          for (; ; ) {
                            if (p = e[p >> 2], !p || (m = e[p + 4 >> 2], (m | 0) != (N | 0) && (A >>> 0 <= m >>> 0 && (m = (m >>> 0) % (A >>> 0) | 0), (u | 0) != (m | 0))))
                              break r;
                            if (e[p + 8 >> 2] == (r | 0))
                              break;
                          }
                          break t;
                        }
                        if (u = m & N, p = e[e[s >> 2] + (u << 2) >> 2], !p)
                          break r;
                        for (; ; ) {
                          if (p = e[p >> 2], !p || (W = e[p + 4 >> 2], (W | 0) != (N | 0) & (m & W) != (u | 0)))
                            break r;
                          if (e[p + 8 >> 2] == (r | 0))
                            break;
                        }
                        break t;
                      }
                      return e[A + 12 >> 2];
                    }
                    W = Qs(16), e[W + 8 >> 2] = r, e[W + 4 >> 2] = N, e[W >> 2] = 0, e[W + 12 >> 2] = vr, fr = s + 8 | 0, _r = ma(e[s + 12 >> 2] + 1 >>> 0), Te = gc[s + 16 >> 2];
                    r: {
                      if (!(!A | _r > ma(Te * ma(A >>> 0)))) {
                        N = u;
                        break r;
                      }
                      m = 2, u = (A - 1 & A) != 0 | A >>> 0 < 3 | A << 1, Te = ma(eh(ma(_r / Te)));
                      i: {
                        if (Te < ma(4294967296) & Te >= ma(0)) {
                          r = ~~Te >>> 0;
                          break i;
                        }
                        r = 0;
                      }
                      r = r >>> 0 < u >>> 0 ? u : r;
                      i: {
                        if ((r | 0) == 1)
                          break i;
                        if (!(r & r - 1)) {
                          m = r;
                          break i;
                        }
                        if (e[5996] = 0, m = Mi(43, r | 0) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1)
                          break e;
                        A = e[s + 4 >> 2];
                      }
                      i: {
                        n: {
                          if (A >>> 0 >= m >>> 0) {
                            if (A >>> 0 <= m >>> 0)
                              break i;
                            u = A >>> 0 < 3, Te = ma(eh(ma(ma(Ls[s + 12 >> 2]) / gc[s + 16 >> 2])));
                            s: {
                              if (Te < ma(4294967296) & Te >= ma(0)) {
                                r = ~~Te >>> 0;
                                break s;
                              }
                              r = 0;
                            }
                            s: {
                              a: {
                                if (u || Ns(A) >>> 0 > 1)
                                  break a;
                                r = r >>> 0 < 2 ? r : 1 << 32 - Fo(r - 1 | 0);
                                break s;
                              }
                              if (e[5996] = 0, r = Mi(43, r | 0) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1)
                                break e;
                            }
                            if (m = r >>> 0 < m >>> 0 ? m : r, m >>> 0 >= A >>> 0) {
                              A = e[s + 4 >> 2];
                              break i;
                            }
                            if (!m)
                              break n;
                          }
                          if (m >>> 0 >= 1073741824) {
                            if (e[5996] = 0, Nn(35), r = e[5996], e[5996] = 0, (r | 0) == 1)
                              break e;
                            Oi();
                          }
                          if (e[5996] = 0, u = Mi(3, m << 2) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1)
                            break e;
                          if (r = e[s >> 2], e[s >> 2] = u, r && Br(r), e[s + 4 >> 2] = m, p = 0, A = 0, Xe = m - 1 | 0, Xe >>> 0 >= 3)
                            for (u = m & -4; r = A << 2, e[r + e[s >> 2] >> 2] = 0, e[e[s >> 2] + (r | 4) >> 2] = 0, e[e[s >> 2] + (r | 8) >> 2] = 0, e[e[s >> 2] + (r | 12) >> 2] = 0, A = A + 4 | 0, (u | 0) != (A | 0); )
                              ;
                          if (r = m & 3, r)
                            for (; e[e[s >> 2] + (A << 2) >> 2] = 0, A = A + 1 | 0, p = p + 1 | 0, (r | 0) != (p | 0); )
                              ;
                          if (A = e[s + 8 >> 2], !A) {
                            A = m;
                            break i;
                          }
                          u = e[A + 4 >> 2];
                          s: {
                            if (m - 1 & m) {
                              if (u = u >>> 0 >= m >>> 0 ? (u >>> 0) % (m >>> 0) | 0 : u, e[e[s >> 2] + (u << 2) >> 2] = fr, p = e[A >> 2], p)
                                break s;
                              A = m;
                              break i;
                            }
                            if (u = u & Xe, e[e[s >> 2] + (u << 2) >> 2] = fr, r = e[A >> 2], !r) {
                              A = m;
                              break i;
                            }
                            for (; ; ) {
                              p = Xe & e[r + 4 >> 2];
                              a: {
                                if ((p | 0) == (u | 0)) {
                                  A = r;
                                  break a;
                                }
                                if (ar = p << 2, hi = ar + e[s >> 2] | 0, e[hi >> 2]) {
                                  e[A >> 2] = e[r >> 2], e[r >> 2] = e[e[ar + e[s >> 2] >> 2] >> 2], e[e[ar + e[s >> 2] >> 2] >> 2] = r;
                                  break a;
                                }
                                e[hi >> 2] = A, A = r, u = p;
                              }
                              if (r = e[A >> 2], !r)
                                break;
                            }
                            A = m;
                            break i;
                          }
                          for (; ; ) {
                            r = e[p + 4 >> 2], m >>> 0 <= r >>> 0 && (r = (r >>> 0) % (m >>> 0) | 0);
                            s: {
                              if ((r | 0) == (u | 0)) {
                                A = p;
                                break s;
                              }
                              if (Xe = r << 2, ar = Xe + e[s >> 2] | 0, !e[ar >> 2]) {
                                e[ar >> 2] = A, A = p, u = r;
                                break s;
                              }
                              e[A >> 2] = e[p >> 2], e[p >> 2] = e[e[Xe + e[s >> 2] >> 2] >> 2], e[e[Xe + e[s >> 2] >> 2] >> 2] = p;
                            }
                            if (p = e[A >> 2], !p)
                              break;
                          }
                          A = m;
                          break i;
                        }
                        r = e[s >> 2], A = 0, e[s >> 2] = 0, r && Br(r), e[s + 4 >> 2] = 0;
                      }
                      if (r = A - 1 | 0, !(r & A)) {
                        N = r & N;
                        break r;
                      }
                      if (A >>> 0 > N >>> 0)
                        break r;
                      N = (N >>> 0) % (A >>> 0) | 0;
                    }
                    r = e[s >> 2] + (N << 2) | 0, N = e[r >> 2];
                    r: {
                      i: {
                        if (!N) {
                          if (e[W >> 2] = e[s + 8 >> 2], e[s + 8 >> 2] = W, e[r >> 2] = fr, r = e[W >> 2], !r)
                            break r;
                          N = e[r + 4 >> 2], r = A - 1 | 0;
                          n: {
                            if (!(r & A)) {
                              N = r & N;
                              break n;
                            }
                            if (A >>> 0 > N >>> 0)
                              break n;
                            N = (N >>> 0) % (A >>> 0) | 0;
                          }
                          N = e[s >> 2] + (N << 2) | 0;
                          break i;
                        }
                        e[W >> 2] = e[N >> 2];
                      }
                      e[N >> 2] = W;
                    }
                    e[s + 12 >> 2] = e[s + 12 >> 2] + 1;
                  }
                  return vr | 0;
                }
                r = Hr() | 0, Br(W), Jn(r | 0), Oi();
              }
              function fg(r, s, u, A, m) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0, m = m | 0;
                var p = 0, N = 0, W = 0, Te = 0, Xe = 0, fr = 0, ar = 0, vr = 0, _r = 0, hi = 0, mi = 0;
                Te = Jr - 16 | 0, Jr = Te, e[Te + 8 >> 2] = 0, e[Te + 12 >> 2] = 0, fr = Te + 8 | 0, e[Te + 4 >> 2] = fr;
                e: {
                  t: {
                    r: {
                      i: {
                        n: {
                          if ((s | 0) != (u | 0))
                            for (; ; ) {
                              Xe = e[s >> 2], N = e[Xe + 80 >> 2];
                              s: {
                                if ((N ^ -1) & A)
                                  break s;
                                ar = m & N, W = fr, N = W;
                                a: {
                                  vr = e[Te + 8 >> 2], p = vr;
                                  o: {
                                    if (!p)
                                      break o;
                                    for (; ; ) {
                                      if (N = p, p = e[N + 16 >> 2], p >>> 0 > ar >>> 0) {
                                        if (W = N, p = e[N >> 2], p)
                                          continue;
                                        break o;
                                      }
                                      if (p >>> 0 >= ar >>> 0)
                                        break a;
                                      if (p = e[N + 4 >> 2], !p)
                                        break;
                                    }
                                    W = N + 4 | 0;
                                  }
                                  if (e[5996] = 0, p = Mi(3, 56) | 0, mi = e[5996], e[5996] = 0, (mi | 0) == 1)
                                    break n;
                                  e[p + 16 >> 2] = ar, e[p + 24 >> 2] = Xe, Xe = e[s + 4 >> 2], e[p + 28 >> 2] = Xe, Xe && (e[Xe + 4 >> 2] = e[Xe + 4 >> 2] + 1), Xe = e[s + 12 >> 2], e[p + 32 >> 2] = e[s + 8 >> 2], e[p + 36 >> 2] = Xe, Xe = e[s + 28 >> 2], e[p + 48 >> 2] = e[s + 24 >> 2], e[p + 52 >> 2] = Xe, Xe = e[s + 20 >> 2], e[p + 40 >> 2] = e[s + 16 >> 2], e[p + 44 >> 2] = Xe, e[p + 8 >> 2] = N, e[p >> 2] = 0, e[p + 4 >> 2] = 0, e[W >> 2] = p, N = e[e[Te + 4 >> 2] >> 2], N && (e[Te + 4 >> 2] = N, p = e[W >> 2]), Ff(e[Te + 8 >> 2], p), e[Te + 12 >> 2] = e[Te + 12 >> 2] + 1;
                                  break s;
                                }
                                if (_r = jn[s + 24 >> 3], hi = jn[N + 48 >> 3], !(_r < hi) & (Ls[Xe + 84 >> 2] <= Ls[e[N + 24 >> 2] + 84 >> 2] | _r > hi))
                                  break s;
                                W = e[s + 4 >> 2], W && (e[W + 4 >> 2] = e[W + 4 >> 2] + 1), e[N + 24 >> 2] = Xe, p = e[N + 28 >> 2], e[N + 28 >> 2] = W;
                                a: {
                                  if (!p || (W = e[p + 4 >> 2], e[p + 4 >> 2] = W - 1, W))
                                    break a;
                                  xi[e[e[p >> 2] + 8 >> 2]](p), ys(p);
                                }
                                p = e[s + 12 >> 2], e[N + 32 >> 2] = e[s + 8 >> 2], e[N + 36 >> 2] = p, p = e[s + 28 >> 2], e[N + 48 >> 2] = e[s + 24 >> 2], e[N + 52 >> 2] = p, p = e[s + 20 >> 2], e[N + 40 >> 2] = e[s + 16 >> 2], e[N + 44 >> 2] = p;
                              }
                              if (s = s + 32 | 0, (u | 0) == (s | 0))
                                break i;
                            }
                          e[r + 8 >> 2] = 0, e[r >> 2] = 0, e[r + 4 >> 2] = 0;
                          break e;
                        }
                        N = Hr() | 0;
                        break r;
                      }
                      if (A = e[Te + 4 >> 2], e[r + 8 >> 2] = 0, e[r >> 2] = 0, e[r + 4 >> 2] = 0, (A | 0) == (fr | 0))
                        break e;
                      for (; ; ) {
                        i: {
                          N = e[r + 4 >> 2];
                          n: {
                            if ((N | 0) != e[r + 8 >> 2]) {
                              e[N >> 2] = e[A + 24 >> 2], s = e[A + 28 >> 2], e[N + 4 >> 2] = s, s && (e[s + 4 >> 2] = e[s + 4 >> 2] + 1), s = e[A + 52 >> 2], e[N + 24 >> 2] = e[A + 48 >> 2], e[N + 28 >> 2] = s, s = e[A + 44 >> 2], e[N + 16 >> 2] = e[A + 40 >> 2], e[N + 20 >> 2] = s, s = e[A + 36 >> 2], e[N + 8 >> 2] = e[A + 32 >> 2], e[N + 12 >> 2] = s, e[r + 4 >> 2] = N + 32;
                              break n;
                            }
                            if (s = e[r >> 2], u = N - s | 0, p = u >> 5, m = p + 1 | 0, m >>> 0 >= 134217728) {
                              if (e[5996] = 0, Nn(62), s = e[5996], e[5996] = 0, (s | 0) == 1)
                                break i;
                              break t;
                            }
                            W = u >> 4, m = u >>> 0 >= 2147483616 ? 134217727 : m >>> 0 < W >>> 0 ? W : m;
                            s: {
                              if (!m) {
                                u = 0;
                                break s;
                              }
                              if (m >>> 0 >= 134217728) {
                                if (e[5996] = 0, Nn(35), s = e[5996], e[5996] = 0, (s | 0) != 1)
                                  break t;
                                break i;
                              }
                              if (e[5996] = 0, u = Mi(3, m << 5) | 0, W = e[5996], e[5996] = 0, (W | 0) == 1)
                                break i;
                            }
                            p = (p << 5) + u | 0, e[p >> 2] = e[A + 24 >> 2], W = e[A + 28 >> 2], e[p + 4 >> 2] = W, W && (e[W + 4 >> 2] = e[W + 4 >> 2] + 1, N = e[r + 4 >> 2], s = e[r >> 2]), u = (m << 5) + u | 0, m = e[A + 36 >> 2], e[p + 8 >> 2] = e[A + 32 >> 2], e[p + 12 >> 2] = m, m = e[A + 52 >> 2], e[p + 24 >> 2] = e[A + 48 >> 2], e[p + 28 >> 2] = m, m = e[A + 44 >> 2], e[p + 16 >> 2] = e[A + 40 >> 2], e[p + 20 >> 2] = m, m = p + 32 | 0;
                            s: {
                              if ((s | 0) == (N | 0)) {
                                e[r + 8 >> 2] = u, e[r + 4 >> 2] = m, e[r >> 2] = p;
                                break s;
                              }
                              for (; p = p - 32 | 0, N = N - 32 | 0, e[p >> 2] = e[N >> 2], e[p + 4 >> 2] = e[N + 4 >> 2], e[N >> 2] = 0, e[N + 4 >> 2] = 0, W = e[N + 28 >> 2], e[p + 24 >> 2] = e[N + 24 >> 2], e[p + 28 >> 2] = W, W = e[N + 20 >> 2], e[p + 16 >> 2] = e[N + 16 >> 2], e[p + 20 >> 2] = W, W = e[N + 12 >> 2], e[p + 8 >> 2] = e[N + 8 >> 2], e[p + 12 >> 2] = W, (s | 0) != (N | 0); )
                                ;
                              if (e[r + 8 >> 2] = u, N = e[r + 4 >> 2], e[r + 4 >> 2] = m, s = e[r >> 2], e[r >> 2] = p, (s | 0) == (N | 0))
                                break s;
                              for (; ; ) {
                                N = N - 32 | 0, u = e[N + 4 >> 2];
                                a: {
                                  if (!u || (m = e[u + 4 >> 2], e[u + 4 >> 2] = m - 1, m))
                                    break a;
                                  xi[e[e[u >> 2] + 8 >> 2]](u), ys(u);
                                }
                                if ((s | 0) == (N | 0))
                                  break;
                              }
                            }
                            if (!s)
                              break n;
                            Br(s);
                          }
                          p = e[A + 4 >> 2];
                          n: {
                            if (p) {
                              for (; ; )
                                if (N = p, p = e[N >> 2], !p)
                                  break n;
                            }
                            for (; N = e[A + 8 >> 2], s = e[N >> 2] != (A | 0), A = N, !!s; )
                              ;
                          }
                          if (A = N, (N | 0) != (fr | 0))
                            continue;
                          break e;
                        }
                        break;
                      }
                      N = Hr() | 0, mu(r), vr = e[Te + 8 >> 2];
                    }
                    kl(vr), Jn(N | 0), Oi();
                  }
                  Oi();
                }
                kl(e[Te + 8 >> 2]), Jr = Te + 16 | 0;
              }
              function Ka(r, s, u, A, m, p, N, W, Te) {
                var Xe = 0, fr = 0, ar = 0, vr = 0, _r = 0, hi = 0, mi = 0, Ni = 0, Hi = 0, Ji = 0, Ln = 0;
                Xe = Jr - 112 | 0, Jr = Xe, fr = Te & 2147483647;
                e: {
                  t: {
                    if (vr = m & 2147483647, ar = 2147418112, _r = !(s | u), !(A | vr ? vr - ar >>> 0 < 2147549184 : _r) && (mi = fr - ar | 0, !W & (mi | 0) == -2147418112 ? p | N : (mi | 0) == -2147418112 & (W | 0) != 0 | mi >>> 0 > 2147549184))
                      break t;
                    if (!(!A & (vr | 0) == 2147418112 ? _r : vr >>> 0 < 2147418112)) {
                      W = A, Te = m | 32768, p = s, N = u;
                      break e;
                    }
                    if (!(!W & (fr | 0) == 2147418112 ? !(p | N) : fr >>> 0 < 2147418112)) {
                      Te = Te | 32768;
                      break e;
                    }
                    if (!(s | A | (vr ^ 2147418112 | u))) {
                      ar = A, A = !(s ^ p | A ^ W | (u ^ N | m ^ Te ^ -2147483648)), W = A ? 0 : ar, Te = A ? 2147450880 : m, p = A ? 0 : s, N = A ? 0 : u;
                      break e;
                    }
                    if (ar = p | W, !(ar | (fr ^ 2147418112 | N)))
                      break e;
                    if (!(s | A | (u | vr))) {
                      if (N | fr | ar)
                        break e;
                      p = s & p, N = u & N, W = A & W, Te = m & Te;
                      break e;
                    }
                    if (p | W | (N | fr))
                      break t;
                    p = s, N = u, W = A, Te = m;
                    break e;
                  }
                  ar = (fr | 0) == (vr | 0), Ji = ar & (A | 0) == (W | 0) ? (u | 0) == (N | 0) & s >>> 0 < p >>> 0 | u >>> 0 < N >>> 0 : ar & A >>> 0 < W >>> 0 | fr >>> 0 > vr >>> 0, _r = Ji, vr = _r ? p : s, mi = _r ? N : u, ar = _r ? Te : m, Ln = ar, _r = _r ? W : A, Ni = ar & 65535, A = Ji ? A : W, m = Ji ? m : Te, Hi = m, ar = m >>> 16 & 32767, hi = Ln >>> 16 & 32767, hi || (m = !(_r | Ni), Te = m, fr = m ? vr : _r, m = m << 6, Te = Fo(Te ? mi : Ni), m = m + ((Te | 0) == 32 ? Fo(fr) + 32 | 0 : Te) | 0, Ea(Xe + 96 | 0, vr, mi, _r, Ni, m - 15 | 0), _r = e[Xe + 104 >> 2], Ni = e[Xe + 108 >> 2], mi = e[Xe + 100 >> 2], hi = 16 - m | 0, vr = e[Xe + 96 >> 2]), p = Ji ? s : p, N = Ji ? u : N, W = A, Te = Hi & 65535, ar || (s = !(A | Te), m = s, fr = s ? p : A, s = s << 6, m = Fo(m ? N : Te), s = s + ((m | 0) == 32 ? Fo(fr) + 32 | 0 : m) | 0, Ea(Xe + 80 | 0, p, N, A, Te, s - 15 | 0), ar = 16 - s | 0, W = e[Xe + 88 >> 2], Te = e[Xe + 92 >> 2], N = e[Xe + 84 >> 2], p = e[Xe + 80 >> 2]), u = Te << 3 | W >>> 29, s = W << 3 | N >>> 29, u = u | 524288, m = Ni << 3 | _r >>> 29, Ni = _r << 3 | mi >>> 29, W = m, Te = Hi ^ Ln, fr = N << 3 | p >>> 29, A = p << 3;
                  t: {
                    if ((ar | 0) == (hi | 0))
                      break t;
                    if (m = hi - ar | 0, m >>> 0 > 127) {
                      s = 0, u = 0, fr = 0, A = 1;
                      break t;
                    }
                    Ea(Xe - -64 | 0, A, fr, s, u, 128 - m | 0), Tf(Xe + 48 | 0, A, fr, s, u, m), s = e[Xe + 56 >> 2], u = e[Xe + 60 >> 2], fr = e[Xe + 52 >> 2], A = e[Xe + 48 >> 2] | (e[Xe + 64 >> 2] | e[Xe + 72 >> 2] | (e[Xe + 68 >> 2] | e[Xe + 76 >> 2])) != 0;
                  }
                  _r = A, ar = fr, Hi = W | 524288, fr = mi << 3 | vr >>> 29, vr = vr << 3;
                  t: {
                    if ((Te | 0) < 0) {
                      if (p = 0, N = 0, W = 0, Te = 0, !(vr ^ _r | s ^ Ni | (fr ^ ar | u ^ Hi)))
                        break e;
                      if (A = vr - _r | 0, m = fr - ((vr >>> 0 < _r >>> 0) + ar | 0) | 0, p = Ni - s | 0, N = (fr | 0) == (ar | 0) & vr >>> 0 < _r >>> 0 | fr >>> 0 < ar >>> 0, W = p - N | 0, s = (Hi - ((s >>> 0 > Ni >>> 0) + u | 0) | 0) - (p >>> 0 < N >>> 0) | 0, Te = s, s >>> 0 > 524287)
                        break t;
                      u = !(s | W), N = u, Te = N ? A : W, u = N << 6, N = Fo(N ? m : s), u = u + ((N | 0) == 32 ? Fo(Te) + 32 | 0 : N) | 0, p = s, s = u - 12 | 0, Ea(Xe + 32 | 0, A, m, W, p, s), hi = hi - s | 0, W = e[Xe + 40 >> 2], Te = e[Xe + 44 >> 2], A = e[Xe + 32 >> 2], m = e[Xe + 36 >> 2];
                      break t;
                    }
                    if (fr = fr + ar | 0, A = vr + _r | 0, m = A >>> 0 < vr >>> 0 ? fr + 1 | 0 : fr, p = (ar | 0) == (m | 0) & A >>> 0 < _r >>> 0 | m >>> 0 < ar >>> 0, fr = u + Hi | 0, s = s + Ni | 0, fr = s >>> 0 < Ni >>> 0 ? fr + 1 | 0 : fr, W = s + p | 0, Te = W >>> 0 < s >>> 0 ? fr + 1 | 0 : fr, !(Te & 1048576))
                      break t;
                    A = _r & 1 | ((m & 1) << 31 | A >>> 1), m = W << 31 | m >>> 1, hi = hi + 1 | 0, W = (Te & 1) << 31 | W >>> 1, Te = Te >>> 1 | 0;
                  }
                  if (u = 0, s = Ln & -2147483648, mi = s, (hi | 0) >= 32767) {
                    W = u, Te = s | 2147418112, p = 0, N = 0;
                    break e;
                  }
                  ar = 0;
                  t: {
                    if ((hi | 0) > 0) {
                      ar = hi;
                      break t;
                    }
                    Ea(Xe + 16 | 0, A, m, W, Te, hi + 127 | 0), Tf(Xe, A, m, W, Te, 1 - hi | 0), A = e[Xe >> 2] | (e[Xe + 16 >> 2] | e[Xe + 24 >> 2] | (e[Xe + 20 >> 2] | e[Xe + 28 >> 2])) != 0, m = e[Xe + 4 >> 2], W = e[Xe + 8 >> 2], Te = e[Xe + 12 >> 2];
                  }
                  vr = A & 7, A = (m & 7) << 29 | A >>> 3, p = (vr >>> 0 > 4) + A | 0, s = W << 29 | m >>> 3, N = A >>> 0 > p >>> 0 ? s + 1 | 0 : s, A = (s | 0) == (N | 0) & A >>> 0 > p >>> 0 | s >>> 0 > N >>> 0, s = u | ((Te & 7) << 29 | W >>> 3), W = A + s | 0, Te = mi | (Te >>> 3 & 65535 | ar << 16), Te = s >>> 0 > W >>> 0 ? Te + 1 | 0 : Te;
                  t: {
                    if ((vr | 0) == 4) {
                      s = 0, fr = N + s | 0, A = p, u = p & 1, p = p + u | 0, N = A >>> 0 > p >>> 0 ? fr + 1 | 0 : fr, s = (s | 0) == (N | 0) & u >>> 0 > p >>> 0 | s >>> 0 > N >>> 0, W = s + W | 0, Te = s >>> 0 > W >>> 0 ? Te + 1 | 0 : Te;
                      break t;
                    }
                    if (!vr)
                      break e;
                  }
                }
                e[r >> 2] = p, e[r + 4 >> 2] = N, e[r + 8 >> 2] = W, e[r + 12 >> 2] = Te, Jr = Xe + 112 | 0;
              }
              function cg(r, s, u) {
                r = r | 0, s = s | 0, u = u | 0;
                var A = 0, m = 0, p = 0, N = 0, W = 0, Te = 0, Xe = 0, fr = 0, ar = 0, vr = 0, _r = 0, hi = 0;
                N = Jr - 16 | 0, Jr = N;
                e: {
                  if (p = u - !s | 0, !((!p & s - 1 >>> 0 > 15 | (p | 0) != 0) & (s & u) != -1)) {
                    A = me[r | 0] | me[r + 1 | 0] << 8 | (me[r + 2 | 0] << 16 | me[r + 3 | 0] << 24), m = A - 29 | 0, u = (A >>> 0 < 29 ? A : m) + 1 | 0, u >>> 0 > (A >>> 0 <= 28 ? 28 : me[r + 4 | 0] | me[r + 5 | 0] << 8 | (me[r + 6 | 0] << 16 | me[r + 7 | 0] << 24)) >>> 0 && (fu(r, u + (u >>> 1 | 0) | 0), A = me[r | 0] | me[r + 1 | 0] << 8 | (me[r + 2 | 0] << 16 | me[r + 3 | 0] << 24), m = A - 29 | 0), u = A >>> 0 < 29, _[(u ? r + 4 | 0 : me[r + 8 | 0] | me[r + 9 | 0] << 8 | (me[r + 10 | 0] << 16 | me[r + 11 | 0] << 24)) + (u ? A : m) | 0] = s + 80, s = (me[r | 0] | me[r + 1 | 0] << 8 | (me[r + 2 | 0] << 16 | me[r + 3 | 0] << 24)) + 1 | 0, _[r | 0] = s, _[r + 1 | 0] = s >>> 8, _[r + 2 | 0] = s >>> 16, _[r + 3 | 0] = s >>> 24;
                    break e;
                  }
                  if (!(s | u)) {
                    A = me[r | 0] | me[r + 1 | 0] << 8 | (me[r + 2 | 0] << 16 | me[r + 3 | 0] << 24), m = A - 29 | 0, s = (A >>> 0 < 29 ? A : m) + 1 | 0, s >>> 0 > (A >>> 0 <= 28 ? 28 : me[r + 4 | 0] | me[r + 5 | 0] << 8 | (me[r + 6 | 0] << 16 | me[r + 7 | 0] << 24)) >>> 0 && (fu(r, s + (s >>> 1 | 0) | 0), A = me[r | 0] | me[r + 1 | 0] << 8 | (me[r + 2 | 0] << 16 | me[r + 3 | 0] << 24), m = A - 29 | 0), s = A >>> 0 < 29, _[(s ? r + 4 | 0 : me[r + 8 | 0] | me[r + 9 | 0] << 8 | (me[r + 10 | 0] << 16 | me[r + 11 | 0] << 24)) + (s ? A : m) | 0] = 0, s = (me[r | 0] | me[r + 1 | 0] << 8 | (me[r + 2 | 0] << 16 | me[r + 3 | 0] << 24)) + 1 | 0, _[r | 0] = s, _[r + 1 | 0] = s >>> 8, _[r + 2 | 0] = s >>> 16, _[r + 3 | 0] = s >>> 24;
                    break e;
                  }
                  e[N + 12 >> 2] = 0, e[N + 4 >> 2] = 0, e[N + 8 >> 2] = 0, p = s, s = u >> 31, p = p ^ s, W = p - s | 0, s = (s ^ u) - ((p >>> 0 < s >>> 0) + s | 0) | 0;
                  t: {
                    r: {
                      i: {
                        for (; ; ) {
                          Xe = s, fr = W;
                          n: {
                            if (A >>> 0 < m >>> 0) {
                              _[A | 0] = W, p = A;
                              break n;
                            }
                            if (vr = A - Te | 0, W = vr + 1 | 0, (W | 0) < 0) {
                              if (e[5996] = 0, Nn(8), r = e[5996], e[5996] = 0, (r | 0) == 1)
                                break i;
                              break t;
                            }
                            p = m - Te | 0, s = p << 1, _r = p >>> 0 >= 1073741823 ? 2147483647 : s >>> 0 > W >>> 0 ? s : W;
                            s: {
                              if (!_r) {
                                W = 0;
                                break s;
                              }
                              if (e[5996] = 0, W = Mi(3, _r | 0) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1)
                                break i;
                            }
                            if (p = W + vr | 0, _[p | 0] = fr, (A | 0) == (Te | 0))
                              s = p;
                            else {
                              if (hi = (Te ^ -1) + A | 0, ar = 0, m = p, s = vr & 3, s)
                                for (; m = m - 1 | 0, A = A - 1 | 0, _[m | 0] = me[A | 0], ar = ar + 1 | 0, (s | 0) != (ar | 0); )
                                  ;
                              if (hi >>> 0 >= 3)
                                for (; _[m - 1 | 0] = me[A - 1 | 0], _[m - 2 | 0] = me[A - 2 | 0], _[m - 3 | 0] = me[A - 3 | 0], m = m - 4 | 0, A = A - 4 | 0, _[m | 0] = me[A | 0], (A | 0) != (Te | 0); )
                                  ;
                              A = Te, s = W;
                            }
                            if (Te = s, m = W + _r | 0, !A)
                              break n;
                            Br(A);
                          }
                          if (s = Xe >>> 8 | 0, W = (Xe & 255) << 24 | fr >>> 8, A = p + 1 | 0, !(!Xe & fr >>> 0 >= 256 | Xe))
                            break;
                        }
                        e[N + 8 >> 2] = A, e[N + 4 >> 2] = Te, e[N + 12 >> 2] = m;
                        n: {
                          s: {
                            a: {
                              if (s = _[p | 0], (s | 0) < 0) {
                                if (W = u >>> 24 & 128, A >>> 0 < m >>> 0) {
                                  _[p + 1 | 0] = W, e[N + 8 >> 2] = p + 2;
                                  break n;
                                }
                                if (fr = A - Te | 0, p = fr + 1 | 0, (p | 0) < 0) {
                                  if (e[5996] = 0, Nn(8), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                    break t;
                                  break i;
                                }
                                u = m - Te | 0, s = u << 1, u = u >>> 0 >= 1073741823 ? 2147483647 : s >>> 0 > p >>> 0 ? s : p;
                                o: {
                                  if (!u) {
                                    p = 0;
                                    break o;
                                  }
                                  if (e[5996] = 0, p = Mi(3, u | 0) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1)
                                    break i;
                                }
                                if (m = p + fr | 0, _[m | 0] = W, Xe = u + p | 0, W = m + 1 | 0, (A | 0) == (Te | 0))
                                  break a;
                                if (u = (Te ^ -1) + A | 0, s = fr & 3, s)
                                  for (ar = 0; m = m - 1 | 0, A = A - 1 | 0, _[m | 0] = me[A | 0], ar = ar + 1 | 0, (s | 0) != (ar | 0); )
                                    ;
                                if (u >>> 0 >= 3)
                                  for (; _[m - 1 | 0] = me[A - 1 | 0], _[m - 2 | 0] = me[A - 2 | 0], _[m - 3 | 0] = me[A - 3 | 0], m = m - 4 | 0, A = A - 4 | 0, _[m | 0] = me[A | 0], (A | 0) != (Te | 0); )
                                    ;
                                if (e[N + 12 >> 2] = Xe, e[N + 8 >> 2] = W, e[N + 4 >> 2] = p, !Te)
                                  break n;
                                break s;
                              }
                              if ((u | 0) > 0 | (u | 0) >= 0)
                                break n;
                              _[p | 0] = s | 128;
                              break n;
                            }
                            e[N + 12 >> 2] = Xe, e[N + 8 >> 2] = W, e[N + 4 >> 2] = m;
                          }
                          Br(Te);
                        }
                        if (e[5996] = 0, pi(19, r | 0, N + 4 | 0) | 0, s = e[5996], e[5996] = 0, (s | 0) != 1) {
                          if (s = e[N + 4 >> 2], !s)
                            break e;
                          Br(s);
                          break e;
                        }
                        if (A = Hr() | 0, r = e[N + 4 >> 2], !r)
                          break r;
                        Br(r), Jn(A | 0), Oi();
                      }
                      if (A = Hr() | 0, !Te)
                        break r;
                      Br(Te);
                    }
                    Jn(A | 0), Oi();
                  }
                  Oi();
                }
                return Jr = N + 16 | 0, r | 0;
              }
              function tl(r, s, u, A) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0;
                var m = 0, p = 0, N = 0, W = 0, Te = 0, Xe = 0, fr = 0, ar = 0;
                _[r | 0] = 0, _[r + 1 | 0] = 0, _[r + 2 | 0] = 0, _[r + 3 | 0] = 0, _[r + 4 | 0] = 0, _[r + 5 | 0] = 0, _[r + 6 | 0] = 0, _[r + 7 | 0] = 0, _[r + 24 | 0] = 0, _[r + 25 | 0] = 0, _[r + 26 | 0] = 0, _[r + 27 | 0] = 0, _[r + 28 | 0] = 0, _[r + 29 | 0] = 0, _[r + 30 | 0] = 0, _[r + 31 | 0] = 0, _[r + 16 | 0] = 0, _[r + 17 | 0] = 0, _[r + 18 | 0] = 0, _[r + 19 | 0] = 0, _[r + 20 | 0] = 0, _[r + 21 | 0] = 0, _[r + 22 | 0] = 0, _[r + 23 | 0] = 0, _[r + 8 | 0] = 0, _[r + 9 | 0] = 0, _[r + 10 | 0] = 0, _[r + 11 | 0] = 0, _[r + 12 | 0] = 0, _[r + 13 | 0] = 0, _[r + 14 | 0] = 0, _[r + 15 | 0] = 0, fr = me[s + 8 | 0] | me[s + 9 | 0] << 8 | (me[s + 10 | 0] << 16 | me[s + 11 | 0] << 24), p = -29, N = me[s | 0] | me[s + 1 | 0] << 8 | (me[s + 2 | 0] << 16 | me[s + 3 | 0] << 24), Te = N >>> 0 < 29;
                e: {
                  if (N = Te ? N : N - 29 | 0, N >>> 0 >= 29) {
                    if (e[5996] = 0, ji(124, r | 0, N + (N >>> 1 | 0) | 0), p = e[5996], e[5996] = 0, (p | 0) == 1)
                      break e;
                    m = me[r + 8 | 0] | me[r + 9 | 0] << 8 | (me[r + 10 | 0] << 16 | me[r + 11 | 0] << 24), W = me[r | 0] | me[r + 1 | 0] << 8 | (me[r + 2 | 0] << 16 | me[r + 3 | 0] << 24), p = W - 29 | 0;
                  }
                  Xe = r + 4 | 0, ar = W >>> 0 < 29, m = ar ? Xe : m, Ys(N + m | 0, m, ar ? W : p), p = N + (me[r | 0] | me[r + 1 | 0] << 8 | (me[r + 2 | 0] << 16 | me[r + 3 | 0] << 24)) | 0, _[r | 0] = p, _[r + 1 | 0] = p >>> 8, _[r + 2 | 0] = p >>> 16, _[r + 3 | 0] = p >>> 24;
                  t: {
                    if (!N)
                      break t;
                    p = Te ? s + 4 | 0 : fr, Te = N & 7;
                    r: {
                      if (!Te) {
                        s = p;
                        break r;
                      }
                      for (W = 0, s = p; _[m | 0] = me[s | 0], s = s + 1 | 0, m = m + 1 | 0, W = W + 1 | 0, (Te | 0) != (W | 0); )
                        ;
                    }
                    if (N >>> 0 < 8)
                      break t;
                    for (p = p + N | 0; _[m | 0] = me[s | 0], _[m + 1 | 0] = me[s + 1 | 0], _[m + 2 | 0] = me[s + 2 | 0], _[m + 3 | 0] = me[s + 3 | 0], _[m + 4 | 0] = me[s + 4 | 0], _[m + 5 | 0] = me[s + 5 | 0], _[m + 6 | 0] = me[s + 6 | 0], _[m + 7 | 0] = me[s + 7 | 0], m = m + 8 | 0, s = s + 8 | 0, (p | 0) != (s | 0); )
                      ;
                  }
                  if (fr = me[u + 8 | 0] | me[u + 9 | 0] << 8 | (me[u + 10 | 0] << 16 | me[u + 11 | 0] << 24), m = me[u | 0] | me[u + 1 | 0] << 8 | (me[u + 2 | 0] << 16 | me[u + 3 | 0] << 24), W = m >>> 0 < 29, s = me[r | 0] | me[r + 1 | 0] << 8 | (me[r + 2 | 0] << 16 | me[r + 3 | 0] << 24), p = s - 29 | 0, N = W ? m : m - 29 | 0, Te = s >>> 0 < 29 ? s : p, m = N + Te | 0, m >>> 0 > (s >>> 0 <= 28 ? 28 : me[r + 4 | 0] | me[r + 5 | 0] << 8 | (me[r + 6 | 0] << 16 | me[r + 7 | 0] << 24)) >>> 0) {
                    if (e[5996] = 0, ji(124, r | 0, m + (m >>> 1 | 0) | 0), s = e[5996], e[5996] = 0, (s | 0) == 1)
                      break e;
                    s = me[r | 0] | me[r + 1 | 0] << 8 | (me[r + 2 | 0] << 16 | me[r + 3 | 0] << 24), p = s - 29 | 0;
                  }
                  m = Xe, Xe = s >>> 0 < 29, m = Te + (Xe ? m : me[r + 8 | 0] | me[r + 9 | 0] << 8 | (me[r + 10 | 0] << 16 | me[r + 11 | 0] << 24)) | 0, Ys(N + m | 0, m, (Xe ? s : p) - Te | 0), s = N + (me[r | 0] | me[r + 1 | 0] << 8 | (me[r + 2 | 0] << 16 | me[r + 3 | 0] << 24)) | 0, _[r | 0] = s, _[r + 1 | 0] = s >>> 8, _[r + 2 | 0] = s >>> 16, _[r + 3 | 0] = s >>> 24;
                  t: {
                    if (!N)
                      break t;
                    u = W ? u + 4 | 0 : fr, p = N & 7;
                    r: {
                      if (!p) {
                        s = u;
                        break r;
                      }
                      for (W = 0, s = u; _[m | 0] = me[s | 0], s = s + 1 | 0, m = m + 1 | 0, W = W + 1 | 0, (p | 0) != (W | 0); )
                        ;
                    }
                    if (N >>> 0 < 8)
                      break t;
                    for (u = u + N | 0; _[m | 0] = me[s | 0], _[m + 1 | 0] = me[s + 1 | 0], _[m + 2 | 0] = me[s + 2 | 0], _[m + 3 | 0] = me[s + 3 | 0], _[m + 4 | 0] = me[s + 4 | 0], _[m + 5 | 0] = me[s + 5 | 0], _[m + 6 | 0] = me[s + 6 | 0], _[m + 7 | 0] = me[s + 7 | 0], m = m + 8 | 0, s = s + 8 | 0, (u | 0) != (s | 0); )
                      ;
                  }
                  if (s = e[A >> 2], e[5996] = 0, pi(127, r | 0, s | 0) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1)
                    break e;
                  return;
                }
                s = Hr() | 0, (me[r | 0] | me[r + 1 | 0] << 8 | (me[r + 2 | 0] << 16 | me[r + 3 | 0] << 24)) >>> 0 >= 29 && (Br(me[r + 8 | 0] | me[r + 9 | 0] << 8 | (me[r + 10 | 0] << 16 | me[r + 11 | 0] << 24)), _[r + 8 | 0] = 0, _[r + 9 | 0] = 0, _[r + 10 | 0] = 0, _[r + 11 | 0] = 0), Jn(s | 0), Oi();
              }
              function lg(r, s, u, A, m) {
                r = r | 0, s = s | 0, u = u | 0, A = +A, m = m | 0;
                var p = 0, N = 0, W = 0, Te = 0, Xe = 0, fr = 0, ar = 0, vr = 0, _r = 0, hi = 0;
                p = Jr + -64 | 0, Jr = p, e[p + 40 >> 2] = 0, e[p + 32 >> 2] = 0, e[p + 36 >> 2] = 0, fr = e[u >> 2], _r = e[u + 4 >> 2];
                e: {
                  t: {
                    if ((fr | 0) == (_r | 0)) {
                      u = fr;
                      break t;
                    }
                    r: {
                      i: {
                        for (; ; ) {
                          n: {
                            Xe = e[fr >> 2], N = e[p + 36 >> 2];
                            s: {
                              if ((N | 0) != e[p + 40 >> 2]) {
                                e[N >> 2] = e[Xe >> 2], Te = e[Xe + 4 >> 2], e[N + 4 >> 2] = Te, Te && (e[Te + 4 >> 2] = e[Te + 4 >> 2] + 1), e[p + 36 >> 2] = N + 8;
                                break s;
                              }
                              a: {
                                Te = e[p + 32 >> 2], W = N - Te | 0, hi = W >> 3, ar = hi + 1 | 0;
                                o: {
                                  if (ar >>> 0 >= 536870912) {
                                    if (e[5996] = 0, Nn(59), r = e[5996], e[5996] = 0, (r | 0) == 1)
                                      break o;
                                    break i;
                                  }
                                  if (vr = W >> 2, W = W >>> 0 >= 2147483640 ? 536870911 : ar >>> 0 < vr >>> 0 ? vr : ar, W >>> 0 < 536870912)
                                    break a;
                                  if (e[5996] = 0, Nn(35), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                    break i;
                                }
                                N = Hr() | 0;
                                break e;
                              }
                              if (e[5996] = 0, vr = W << 3, ar = Mi(3, vr | 0) | 0, W = e[5996], e[5996] = 0, (W | 0) == 1)
                                break n;
                              W = ar + (hi << 3) | 0, e[W >> 2] = e[Xe >> 2], Xe = e[Xe + 4 >> 2], e[W + 4 >> 2] = Xe, Xe && (e[Xe + 4 >> 2] = e[Xe + 4 >> 2] + 1, N = e[p + 36 >> 2]), Xe = ar + vr | 0, ar = W + 8 | 0;
                              a: {
                                if ((N | 0) == (Te | 0)) {
                                  e[p + 40 >> 2] = Xe, e[p + 36 >> 2] = ar, e[p + 32 >> 2] = W;
                                  break a;
                                }
                                for (; W = W - 8 | 0, N = N - 8 | 0, e[W >> 2] = e[N >> 2], e[W + 4 >> 2] = e[N + 4 >> 2], e[N >> 2] = 0, e[N + 4 >> 2] = 0, (N | 0) != (Te | 0); )
                                  ;
                                if (e[p + 40 >> 2] = Xe, N = e[p + 36 >> 2], e[p + 36 >> 2] = ar, Te = e[p + 32 >> 2], e[p + 32 >> 2] = W, (N | 0) == (Te | 0))
                                  break a;
                                for (; ; ) {
                                  N = N - 8 | 0, W = e[N + 4 >> 2];
                                  o: {
                                    if (!W || (Xe = e[W + 4 >> 2], e[W + 4 >> 2] = Xe - 1, Xe))
                                      break o;
                                    xi[e[e[W >> 2] + 8 >> 2]](W), ys(W);
                                  }
                                  if ((N | 0) == (Te | 0))
                                    break;
                                }
                              }
                              if (!Te)
                                break s;
                              Br(Te);
                            }
                            if (fr = fr + 4 | 0, (_r | 0) != (fr | 0))
                              continue;
                            break r;
                          }
                          break;
                        }
                        N = Hr() | 0;
                        break e;
                      }
                      Oi();
                    }
                    fr = e[u + 4 >> 2], u = e[u >> 2];
                  }
                  e[5996] = 0, yc(63, p + 16 | 0, s | 0, u | 0, fr | 0, +A), u = e[5996], e[5996] = 0;
                  t: {
                    if ((u | 0) == 1 || (e[5996] = 0, u = Mi(3, 104) | 0, fr = e[5996], e[5996] = 0, (fr | 0) == 1))
                      break t;
                    if (e[u >> 2] = 7e3, e[u + 4 >> 2] = 0, e[u + 8 >> 2] = 0, e[p + 52 >> 2] = e[p + 32 >> 2], fr = e[p + 40 >> 2], N = e[p + 36 >> 2], e[p + 40 >> 2] = 0, e[p + 56 >> 2] = N, e[p + 60 >> 2] = fr, e[p + 32 >> 2] = 0, e[p + 36 >> 2] = 0, m = e[m >> 2], e[5996] = 0, fr = wa(64, u + 12 | 0, s | 0, p + 52 | 0, m | 0) | 0, s = e[5996], e[5996] = 0, (s | 0) != 1) {
                      if (s = e[p + 52 >> 2], s) {
                        if (N = e[p + 56 >> 2], (s | 0) != (N | 0)) {
                          for (; ; ) {
                            N = N - 8 | 0, m = e[N + 4 >> 2];
                            r: {
                              if (!m || (Te = e[m + 4 >> 2], e[m + 4 >> 2] = Te - 1, Te))
                                break r;
                              xi[e[e[m >> 2] + 8 >> 2]](m), ys(m);
                            }
                            if ((s | 0) == (N | 0))
                              break;
                          }
                          s = e[p + 52 >> 2];
                        }
                        Br(s);
                      }
                      if (e[p + 48 >> 2] = u, e[p + 44 >> 2] = fr, e[5996] = 0, s = e[p + 48 >> 2], e[p + 8 >> 2] = e[p + 44 >> 2], e[p + 12 >> 2] = s, gs(61, r | 0, p + 16 | 0, p + 8 | 0), r = e[5996], e[5996] = 0, (r | 0) == 1)
                        break t;
                      if (r = e[p + 32 >> 2], r) {
                        if (N = e[p + 36 >> 2], (r | 0) != (N | 0)) {
                          for (; ; ) {
                            N = N - 8 | 0, s = e[N + 4 >> 2];
                            r: {
                              if (!s || (u = e[s + 4 >> 2], e[s + 4 >> 2] = u - 1, u))
                                break r;
                              xi[e[e[s >> 2] + 8 >> 2]](s), ys(s);
                            }
                            if ((r | 0) == (N | 0))
                              break;
                          }
                          r = e[p + 32 >> 2];
                        }
                        Br(r);
                      }
                      Jr = p - -64 | 0;
                      return;
                    }
                    N = Hr() | 0, Uo(p + 52 | 0), Br(u);
                    break e;
                  }
                  N = Hr() | 0;
                }
                Uo(p + 32 | 0), Jn(N | 0), Oi();
              }
              function Xl(r, s, u, A) {
                r = r | 0, s = +s, u = +u, A = A | 0;
                var m = 0, p = 0, N = 0, W = 0, Te = 0, Xe = 0, fr = 0, ar = 0;
                N = Jr - 48 | 0, Jr = N;
                e: {
                  t: {
                    if (e[r >> 2] == 21) {
                      Xe = A + 4 | 0;
                      r: {
                        i: {
                          n: {
                            s: {
                              if (m = e[A + 4 >> 2], !m)
                                break s;
                              for (p = Xe; ; ) {
                                a: {
                                  o: {
                                    l: {
                                      if (Te = e[m + 16 >> 2], Te >>> 0 < r >>> 0)
                                        break l;
                                      if (r >>> 0 < Te >>> 0)
                                        break o;
                                      if (fr = jn[m + 24 >> 3], fr < s)
                                        break l;
                                      if (s < fr)
                                        break o;
                                      W = jn[m + 32 >> 3] < u, Te = W ? m + 4 | 0 : m, p = W ? p : m;
                                      break a;
                                    }
                                    Te = m + 4 | 0;
                                    break a;
                                  }
                                  Te = m, p = m;
                                }
                                if (m = e[Te >> 2], !m)
                                  break;
                              }
                              if ((p | 0) == (Xe | 0) || (m = e[p + 16 >> 2], m >>> 0 > r >>> 0))
                                break s;
                              a: {
                                if (r >>> 0 > m >>> 0)
                                  break a;
                                if (fr = jn[p + 24 >> 3], fr > s)
                                  break s;
                                if (s > fr)
                                  break a;
                                if (jn[p + 32 >> 3] > u)
                                  break s;
                              }
                              if (jn[p + 56 >> 3] != s)
                                break n;
                              if (jn[p - -64 >> 3] != u)
                                break i;
                              ar = p + 40 | 0;
                              break e;
                            }
                            if (e[N + 40 >> 2] = 0, jn[N + 32 >> 3] = u, jn[N + 24 >> 3] = s, e[N + 16 >> 2] = 0, e[N + 8 >> 2] = 0, e[N + 12 >> 2] = 0, m = e[r + 4 >> 2], (m | 0) == e[r + 8 >> 2]) {
                              if (e[5996] = 0, Vs(44, 4277, 1900, 673, 1984), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                break r;
                              break t;
                            }
                            if (m = e[m >> 2], e[5996] = 0, gs(45, m | 0, N + 8 | 0, A | 0), m = e[5996], e[5996] = 0, (m | 0) == 1)
                              break t;
                            s: {
                              a: {
                                m = Xe, Te = e[m >> 2];
                                o: {
                                  if (!Te)
                                    break o;
                                  for (; ; ) {
                                    l: {
                                      c: {
                                        m = Te, p = e[m + 16 >> 2];
                                        d: {
                                          if (p >>> 0 > r >>> 0)
                                            break d;
                                          if (r >>> 0 > p >>> 0)
                                            break l;
                                          if (fr = jn[m + 24 >> 3], fr > s)
                                            break d;
                                          if (s > fr)
                                            break l;
                                          if (fr = jn[m + 32 >> 3], !(fr > u))
                                            break c;
                                        }
                                        if (Xe = m, Te = e[m >> 2], Te)
                                          continue;
                                        break o;
                                      }
                                      if (!(u > fr))
                                        break a;
                                    }
                                    if (Te = e[m + 4 >> 2], !Te)
                                      break;
                                  }
                                  Xe = m + 4 | 0;
                                }
                                if (e[5996] = 0, W = Mi(3, 80) | 0, p = e[5996], e[5996] = 0, (p | 0) == 1)
                                  break t;
                                if (e[W + 16 >> 2] = r, jn[W + 32 >> 3] = u, jn[W + 24 >> 3] = s, ar = W + 40 | 0, e[ar >> 2] = e[N + 8 >> 2], e[W + 44 >> 2] = e[N + 12 >> 2], e[W + 48 >> 2] = e[N + 16 >> 2], e[N + 16 >> 2] = 0, e[N + 8 >> 2] = 0, e[N + 12 >> 2] = 0, e[W + 72 >> 2] = e[N + 40 >> 2], Te = e[N + 36 >> 2], p = W - -64 | 0, e[p >> 2] = e[N + 32 >> 2], e[p + 4 >> 2] = Te, p = e[N + 28 >> 2], e[W + 56 >> 2] = e[N + 24 >> 2], e[W + 60 >> 2] = p, e[W + 8 >> 2] = m, e[W >> 2] = 0, e[W + 4 >> 2] = 0, e[Xe >> 2] = W, m = W, p = e[e[A >> 2] >> 2], p && (e[A >> 2] = p, m = e[Xe >> 2]), Ff(e[A + 4 >> 2], m), e[A + 8 >> 2] = e[A + 8 >> 2] + 1, Xe = e[r + 4 >> 2], e[r + 8 >> 2] - Xe >>> 0 >= 5)
                                  for (p = e[W + 72 >> 2], Te = 1, m = 1; ; ) {
                                    if (Xe = e[(m << 2) + Xe >> 2], e[5996] = 0, gs(45, Xe | 0, ar | 0, A | 0), Xe = e[5996], e[5996] = 0, (Xe | 0) == 1)
                                      break s;
                                    if (Xe = p, p = e[W + 72 >> 2], Te = (Xe | 0) == (p | 0) ? Te : m, m = m + 1 | 0, Xe = e[r + 4 >> 2], m = (m | 0) == e[r + 8 >> 2] - Xe >> 2 ? 1 : m, (Te | 0) == (m | 0))
                                      break;
                                  }
                                if (A = e[N + 8 >> 2], !A)
                                  break e;
                                if (r = e[N + 12 >> 2], (A | 0) != (r | 0)) {
                                  for (; ; ) {
                                    r = r - 32 | 0, m = e[r + 4 >> 2];
                                    o: {
                                      if (!m || (p = e[m + 4 >> 2], e[m + 4 >> 2] = p - 1, p))
                                        break o;
                                      xi[e[e[m >> 2] + 8 >> 2]](m), ys(m);
                                    }
                                    if ((r | 0) == (A | 0))
                                      break;
                                  }
                                  A = e[N + 8 >> 2];
                                }
                                Br(A);
                                break e;
                              }
                              if (e[5996] = 0, Vs(44, 2453, 1900, 676, 1984), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                break r;
                              break t;
                            }
                            break t;
                          }
                          ga(1940, 1900, 668, 1984), Oi();
                        }
                        ga(1841, 1900, 669, 1984);
                      }
                      Oi();
                    }
                    ga(3430, 1900, 664, 1984), Oi();
                  }
                  r = Hr() | 0, mu(N + 8 | 0), Jn(r | 0), Oi();
                }
                return Jr = N + 48 | 0, ar | 0;
              }
              function Ah(r, s, u, A, m, p, N, W, Te) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0, m = m | 0, p = p | 0, N = N | 0, W = W | 0, Te = Te | 0;
                var Xe = 0, fr = 0, ar = 0, vr = 0, _r = 0, hi = 0, mi = 0, Ni = 0, Hi = 0;
                Xe = Jr - 1056 | 0, Jr = Xe, e[Xe + 16 >> 2] = p, e[Xe + 20 >> 2] = N, e[Xe + 24 >> 2] = W, e[Xe + 28 >> 2] = Te, r = Xe + 944 | 0, e[Xe + 940 >> 2] = r, ar = ql(r, 100, 2304, Xe + 16 | 0), e[Xe + 48 >> 2] = 184, _r = Xe + 520 | 0, e[_r >> 2] = 0, e[_r + 4 >> 2] = e[Xe + 48 >> 2], e[Xe + 48 >> 2] = 184, vr = Xe + 512 | 0, e[vr >> 2] = 0, e[vr + 4 >> 2] = e[Xe + 48 >> 2];
                e: {
                  t: {
                    r: {
                      i: {
                        if (ar >>> 0 < 100) {
                          W = Xe + 528 | 0;
                          break i;
                        }
                        if (r = ko(), e[Xe >> 2] = p, e[Xe + 4 >> 2] = N, e[Xe + 8 >> 2] = W, e[Xe + 12 >> 2] = Te, ar = Iu(Xe + 940 | 0, r, 2304, Xe), (ar | 0) != -1 && (r = e[Xe + 940 >> 2], ia(_r, r), ia(vr, da(ar << 2)), W = e[vr >> 2], W))
                          break i;
                        if (e[5996] = 0, Nn(185), r = e[5996], e[5996] = 0, (r | 0) != 1)
                          break e;
                        ar = Hr() | 0;
                        break r;
                      }
                      p = e[A + 28 >> 2], e[Xe + 508 >> 2] = p, e[p + 4 >> 2] = e[p + 4 >> 2] + 1, e[5996] = 0, Hi = Mi(197, e[Xe + 508 >> 2]) | 0, p = e[5996], e[5996] = 0;
                      i: {
                        n: {
                          s: {
                            a: {
                              o: {
                                l: {
                                  if ((p | 0) == 1 || (e[5996] = 0, Vs(208, Hi | 0, r | 0, r + ar | 0, W | 0), p = e[5996], e[5996] = 0, (p | 0) == 1))
                                    break l;
                                  if (mi = (ar | 0) > 0 ? me[r | 0] == 45 : mi, N = Xe + 484 | 0, e[N >> 2] = 0, e[N + 4 >> 2] = 0, e[N + 8 >> 2] = 0, r = Xe + 472 | 0, e[r >> 2] = 0, e[r + 4 >> 2] = 0, e[r + 8 >> 2] = 0, p = Xe + 460 | 0, e[p >> 2] = 0, e[p + 4 >> 2] = 0, e[p + 8 >> 2] = 0, e[5996] = 0, Uf(238, u | 0, mi | 0, e[Xe + 508 >> 2], Xe + 504 | 0, Xe + 500 | 0, Xe + 496 | 0, N | 0, r | 0, p | 0, Xe + 456 | 0), u = e[5996], e[5996] = 0, (u | 0) == 1)
                                    break o;
                                  e[Xe + 36 >> 2] = 184, u = Xe + 40 | 0, e[u >> 2] = 0, e[u + 4 >> 2] = e[Xe + 36 >> 2], Te = Xe + 48 | 0, hi = e[Xe + 456 >> 2];
                                  c: {
                                    if ((hi | 0) < (ar | 0)) {
                                      fr = me[p + 11 | 0], Ni = (ar - hi << 1) + ((fr & 128) >>> 7 | 0 ? e[p + 4 >> 2] : fr & 127) | 0, fr = me[r + 11 | 0], fr = (Ni + ((fr & 128) >>> 7 | 0 ? e[r + 4 >> 2] : fr & 127) | 0) + 1 | 0;
                                      break c;
                                    }
                                    fr = me[p + 11 | 0], Ni = (fr & 128) >>> 7 | 0 ? e[p + 4 >> 2] : fr & 127, fr = me[r + 11 | 0], fr = (Ni + ((fr & 128) >>> 7 | 0 ? e[r + 4 >> 2] : fr & 127) | 0) + 2 | 0;
                                  }
                                  if (fr = fr + hi | 0, fr >>> 0 < 101 || (ia(u, da(fr << 2)), Te = e[u >> 2], Te))
                                    break a;
                                  if (e[5996] = 0, Nn(185), s = e[5996], e[5996] = 0, (s | 0) != 1)
                                    break e;
                                  break s;
                                }
                                ar = Hr() | 0;
                                break i;
                              }
                              ar = Hr() | 0;
                              break n;
                            }
                            if (fr = e[A + 4 >> 2], e[5996] = 0, _c(239, Te | 0, Xe + 36 | 0, Xe + 32 | 0, fr | 0, W | 0, (ar << 2) + W | 0, Hi | 0, mi | 0, Xe + 504 | 0, e[Xe + 500 >> 2], e[Xe + 496 >> 2], N | 0, r | 0, p | 0, hi | 0), W = e[5996], e[5996] = 0, (W | 0) != 1 && (e[5996] = 0, A = za(219, s | 0, Te | 0, e[Xe + 36 >> 2], e[Xe + 32 >> 2], A | 0, m | 0) | 0, s = e[5996], e[5996] = 0, (s | 0) != 1))
                              break t;
                          }
                          ar = Hr() | 0, to(u);
                        }
                        Qn(p), Qn(r), Qn(N);
                      }
                      r = e[Xe + 508 >> 2], s = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = s, (s | 0) == -1 && xi[e[e[r >> 2] + 8 >> 2]](r);
                    }
                    to(vr), to(_r), Jn(ar | 0), Oi();
                  }
                  return to(u), Qn(p), Qn(r), Qn(N), r = e[Xe + 508 >> 2], s = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = s, (s | 0) == -1 && xi[e[e[r >> 2] + 8 >> 2]](r), to(vr), to(_r), Jr = Xe + 1056 | 0, A | 0;
                }
                Oi();
              }
              function gh(r, s) {
                r = r | 0, s = s | 0;
                var u = 0, A = 0, m = 0, p = 0;
                if (u = e[r + 4 >> 2], A = e[r + 8 >> 2], u >>> 0 < A >>> 0) {
                  A = e[s >> 2], e[u + 12 >> 2] = 0, e[u + 4 >> 2] = 0, e[u + 8 >> 2] = 0, e[u >> 2] = A, e[u + 4 >> 2] = e[s + 4 >> 2], e[u + 8 >> 2] = e[s + 8 >> 2], e[u + 12 >> 2] = e[s + 12 >> 2], e[s + 12 >> 2] = 0, e[s + 4 >> 2] = 0, e[s + 8 >> 2] = 0, e[u + 24 >> 2] = 0, e[u + 16 >> 2] = 0, e[u + 20 >> 2] = 0, e[u + 16 >> 2] = e[s + 16 >> 2], e[u + 20 >> 2] = e[s + 20 >> 2], e[u + 24 >> 2] = e[s + 24 >> 2], e[s + 24 >> 2] = 0, e[s + 16 >> 2] = 0, e[s + 20 >> 2] = 0, e[u + 36 >> 2] = 0, e[u + 28 >> 2] = 0, e[u + 32 >> 2] = 0, e[u + 28 >> 2] = e[s + 28 >> 2], e[u + 32 >> 2] = e[s + 32 >> 2], e[u + 36 >> 2] = e[s + 36 >> 2], e[s + 36 >> 2] = 0, e[s + 28 >> 2] = 0, e[s + 32 >> 2] = 0, e[u + 48 >> 2] = 0, e[u + 40 >> 2] = 0, e[u + 44 >> 2] = 0, e[u + 40 >> 2] = e[s + 40 >> 2], e[u + 44 >> 2] = e[s + 44 >> 2], e[u + 48 >> 2] = e[s + 48 >> 2], e[s + 48 >> 2] = 0, e[s + 40 >> 2] = 0, e[s + 44 >> 2] = 0, e[u + 52 >> 2] = e[s + 52 >> 2], e[r + 4 >> 2] = u + 56;
                  return;
                }
                e: {
                  t: {
                    r: {
                      if (m = e[r >> 2], p = (u - m | 0) / 56 | 0, u = p + 1 | 0, u >>> 0 < 76695845) {
                        if (A = (A - m | 0) / 56 | 0, m = A << 1, u = A >>> 0 >= 38347922 ? 76695844 : u >>> 0 < m >>> 0 ? m : u, u >>> 0 >= 76695845)
                          break r;
                        if (A = Sn(u, 56), m = Qs(A), u = m + Sn(p, 56) | 0, e[u >> 2] = e[s >> 2], e[u + 4 >> 2] = e[s + 4 >> 2], e[u + 8 >> 2] = e[s + 8 >> 2], e[u + 12 >> 2] = e[s + 12 >> 2], e[s + 12 >> 2] = 0, e[s + 4 >> 2] = 0, e[s + 8 >> 2] = 0, e[u + 16 >> 2] = e[s + 16 >> 2], e[u + 20 >> 2] = e[s + 20 >> 2], e[u + 24 >> 2] = e[s + 24 >> 2], e[s + 24 >> 2] = 0, e[s + 16 >> 2] = 0, e[s + 20 >> 2] = 0, e[u + 28 >> 2] = e[s + 28 >> 2], e[u + 32 >> 2] = e[s + 32 >> 2], e[u + 36 >> 2] = e[s + 36 >> 2], e[s + 36 >> 2] = 0, e[s + 28 >> 2] = 0, e[s + 32 >> 2] = 0, e[u + 40 >> 2] = e[s + 40 >> 2], e[u + 44 >> 2] = e[s + 44 >> 2], e[u + 48 >> 2] = e[s + 48 >> 2], e[s + 48 >> 2] = 0, e[s + 40 >> 2] = 0, e[s + 44 >> 2] = 0, e[u + 52 >> 2] = e[s + 52 >> 2], A = A + m | 0, m = u + 56 | 0, s = e[r + 4 >> 2], p = e[r >> 2], (s | 0) == (p | 0))
                          break t;
                        for (; u = u - 56 | 0, s = s - 56 | 0, e[u >> 2] = e[s >> 2], e[u + 4 >> 2] = e[s + 4 >> 2], e[u + 8 >> 2] = e[s + 8 >> 2], e[u + 12 >> 2] = e[s + 12 >> 2], e[s + 12 >> 2] = 0, e[s + 4 >> 2] = 0, e[s + 8 >> 2] = 0, e[u + 16 >> 2] = e[s + 16 >> 2], e[u + 20 >> 2] = e[s + 20 >> 2], e[u + 24 >> 2] = e[s + 24 >> 2], e[s + 24 >> 2] = 0, e[s + 16 >> 2] = 0, e[s + 20 >> 2] = 0, e[u + 28 >> 2] = e[s + 28 >> 2], e[u + 32 >> 2] = e[s + 32 >> 2], e[u + 36 >> 2] = e[s + 36 >> 2], e[s + 36 >> 2] = 0, e[s + 28 >> 2] = 0, e[s + 32 >> 2] = 0, e[u + 40 >> 2] = e[s + 40 >> 2], e[u + 44 >> 2] = e[s + 44 >> 2], e[u + 48 >> 2] = e[s + 48 >> 2], e[s + 48 >> 2] = 0, e[s + 40 >> 2] = 0, e[s + 44 >> 2] = 0, e[u + 52 >> 2] = e[s + 52 >> 2], (s | 0) != (p | 0); )
                          ;
                        if (e[r + 8 >> 2] = A, A = e[r + 4 >> 2], e[r + 4 >> 2] = m, s = e[r >> 2], e[r >> 2] = u, (s | 0) == (A | 0))
                          break e;
                        for (; A = Ma(A - 56 | 0), (A | 0) != (s | 0); )
                          ;
                        break e;
                      }
                      Jo(), Oi();
                    }
                    hu(), Oi();
                  }
                  e[r + 8 >> 2] = A, e[r + 4 >> 2] = m, e[r >> 2] = u;
                }
                s && Br(s);
              }
              function dg(r, s, u, A, m, p, N, W, Te) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0, m = m | 0, p = p | 0, N = N | 0, W = W | 0, Te = Te | 0;
                var Xe = 0, fr = 0, ar = 0, vr = 0, _r = 0, hi = 0, mi = 0, Ni = 0, Hi = 0;
                Xe = Jr - 448 | 0, Jr = Xe, e[Xe + 16 >> 2] = p, e[Xe + 20 >> 2] = N, e[Xe + 24 >> 2] = W, e[Xe + 28 >> 2] = Te, r = Xe + 336 | 0, e[Xe + 332 >> 2] = r, ar = ql(r, 100, 2304, Xe + 16 | 0), e[Xe + 48 >> 2] = 184, _r = Xe + 216 | 0, e[_r >> 2] = 0, e[_r + 4 >> 2] = e[Xe + 48 >> 2], e[Xe + 48 >> 2] = 184, vr = Xe + 208 | 0, e[vr >> 2] = 0, e[vr + 4 >> 2] = e[Xe + 48 >> 2];
                e: {
                  t: {
                    r: {
                      i: {
                        if (ar >>> 0 < 100) {
                          W = Xe + 224 | 0;
                          break i;
                        }
                        if (r = ko(), e[Xe >> 2] = p, e[Xe + 4 >> 2] = N, e[Xe + 8 >> 2] = W, e[Xe + 12 >> 2] = Te, ar = Iu(Xe + 332 | 0, r, 2304, Xe), (ar | 0) != -1 && (r = e[Xe + 332 >> 2], ia(_r, r), ia(vr, da(ar)), W = e[vr >> 2], W))
                          break i;
                        if (e[5996] = 0, Nn(185), r = e[5996], e[5996] = 0, (r | 0) != 1)
                          break e;
                        ar = Hr() | 0;
                        break r;
                      }
                      p = e[A + 28 >> 2], e[Xe + 204 >> 2] = p, e[p + 4 >> 2] = e[p + 4 >> 2] + 1, e[5996] = 0, Hi = Mi(170, e[Xe + 204 >> 2]) | 0, p = e[5996], e[5996] = 0;
                      i: {
                        n: {
                          s: {
                            a: {
                              o: {
                                l: {
                                  if ((p | 0) == 1 || (e[5996] = 0, Vs(195, Hi | 0, r | 0, r + ar | 0, W | 0), p = e[5996], e[5996] = 0, (p | 0) == 1))
                                    break l;
                                  if (mi = (ar | 0) > 0 ? me[r | 0] == 45 : mi, N = Xe + 184 | 0, e[N >> 2] = 0, e[N + 4 >> 2] = 0, e[N + 8 >> 2] = 0, r = Xe + 172 | 0, e[r >> 2] = 0, e[r + 4 >> 2] = 0, e[r + 8 >> 2] = 0, p = Xe + 160 | 0, e[p >> 2] = 0, e[p + 4 >> 2] = 0, e[p + 8 >> 2] = 0, e[5996] = 0, Uf(236, u | 0, mi | 0, e[Xe + 204 >> 2], Xe + 200 | 0, Xe + 199 | 0, Xe + 198 | 0, N | 0, r | 0, p | 0, Xe + 156 | 0), u = e[5996], e[5996] = 0, (u | 0) == 1)
                                    break o;
                                  e[Xe + 36 >> 2] = 184, u = Xe + 40 | 0, e[u >> 2] = 0, e[u + 4 >> 2] = e[Xe + 36 >> 2], Te = Xe + 48 | 0, hi = e[Xe + 156 >> 2];
                                  c: {
                                    if ((hi | 0) < (ar | 0)) {
                                      fr = me[p + 11 | 0], Ni = (ar - hi << 1) + ((fr & 128) >>> 7 | 0 ? e[p + 4 >> 2] : fr & 127) | 0, fr = me[r + 11 | 0], fr = (Ni + ((fr & 128) >>> 7 | 0 ? e[r + 4 >> 2] : fr & 127) | 0) + 1 | 0;
                                      break c;
                                    }
                                    fr = me[p + 11 | 0], Ni = (fr & 128) >>> 7 | 0 ? e[p + 4 >> 2] : fr & 127, fr = me[r + 11 | 0], fr = (Ni + ((fr & 128) >>> 7 | 0 ? e[r + 4 >> 2] : fr & 127) | 0) + 2 | 0;
                                  }
                                  if (fr = fr + hi | 0, fr >>> 0 < 101 || (ia(u, da(fr)), Te = e[u >> 2], Te))
                                    break a;
                                  if (e[5996] = 0, Nn(185), s = e[5996], e[5996] = 0, (s | 0) != 1)
                                    break e;
                                  break s;
                                }
                                ar = Hr() | 0;
                                break i;
                              }
                              ar = Hr() | 0;
                              break n;
                            }
                            if (fr = e[A + 4 >> 2], e[5996] = 0, _c(237, Te | 0, Xe + 36 | 0, Xe + 32 | 0, fr | 0, W | 0, W + ar | 0, Hi | 0, mi | 0, Xe + 200 | 0, _[Xe + 199 | 0], _[Xe + 198 | 0], N | 0, r | 0, p | 0, hi | 0), W = e[5996], e[5996] = 0, (W | 0) != 1 && (e[5996] = 0, A = za(213, s | 0, Te | 0, e[Xe + 36 >> 2], e[Xe + 32 >> 2], A | 0, m | 0) | 0, s = e[5996], e[5996] = 0, (s | 0) != 1))
                              break t;
                          }
                          ar = Hr() | 0, to(u);
                        }
                        Qn(p), Qn(r), Qn(N);
                      }
                      r = e[Xe + 204 >> 2], s = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = s, (s | 0) == -1 && xi[e[e[r >> 2] + 8 >> 2]](r);
                    }
                    to(vr), to(_r), Jn(ar | 0), Oi();
                  }
                  return to(u), Qn(p), Qn(r), Qn(N), r = e[Xe + 204 >> 2], s = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = s, (s | 0) == -1 && xi[e[e[r >> 2] + 8 >> 2]](r), to(vr), to(_r), Jr = Xe + 448 | 0, A | 0;
                }
                Oi();
              }
              function ph(r, s, u, A, m) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0, m = +m;
                var p = 0, N = 0, W = 0, Te = 0, Xe = 0;
                e: {
                  t: {
                    if (!(s - 19 >>> 0 >= 7 & m != 0)) {
                      p = 1 - m;
                      r:
                        switch (s | 0) {
                          case 24:
                            if ((u | 0) != (A | 0))
                              for (; s = e[u >> 2], W = W + jn[s + 8 >> 3], N = N + jn[s + 16 >> 3], u = u + 4 | 0, (A | 0) != (u | 0); )
                                ;
                            jn[r + 8 >> 3] = N, jn[r >> 3] = (p == 0 ? 0 : p * N) + (m == 0 ? 0 : W * m);
                            return;
                          case 3:
                            e[r + 8 >> 2] = 0, e[r + 12 >> 2] = 1078034432, e[r >> 2] = 0, e[r + 4 >> 2] = 1079689216;
                            return;
                          case 6:
                          case 7:
                          case 8:
                          case 9:
                            e[r + 8 >> 2] = 0, e[r + 12 >> 2] = 1077968896, e[r >> 2] = 0, e[r + 4 >> 2] = 1077968896;
                            return;
                          case 10:
                          case 11:
                          case 12:
                          case 16:
                            s = e[u >> 2], u = e[s + 12 >> 2], e[r >> 2] = e[s + 8 >> 2], e[r + 4 >> 2] = u, u = e[s + 20 >> 2], e[r + 8 >> 2] = e[s + 16 >> 2], e[r + 12 >> 2] = u;
                            return;
                          case 13:
                            m = jn[e[u >> 2] + 8 >> 3], e[r + 8 >> 2] = 0, e[r + 12 >> 2] = 1072693248, jn[r >> 3] = m + 2;
                            return;
                          case 14:
                            m = jn[e[u >> 2] + 8 >> 3], e[r + 8 >> 2] = 0, e[r + 12 >> 2] = 2146435072, jn[r >> 3] = m;
                            return;
                          case 15:
                            m = jn[e[u >> 2] + 8 >> 3], e[r + 8 >> 2] = 0, e[r + 12 >> 2] = 1072693248, jn[r >> 3] = m;
                            return;
                          case 0:
                            e[r + 8 >> 2] = 0, e[r + 12 >> 2] = 0, e[r >> 2] = 0, e[r + 4 >> 2] = 2146435072;
                            return;
                          case 17:
                            m = jn[e[u + 4 >> 2] + 8 >> 3], p = jn[e[u >> 2] + 8 >> 3], e[r + 8 >> 2] = 0, e[r + 12 >> 2] = 2146435072, jn[r >> 3] = p + m;
                            return;
                          case 18:
                            s = e[u + 4 >> 2], m = jn[s + 16 >> 3], u = e[u >> 2], p = jn[u + 16 >> 3], jn[r >> 3] = jn[u + 8 >> 3] + jn[s + 8 >> 3], jn[r + 8 >> 3] = p + m;
                            return;
                          case 19:
                            s = e[u >> 2], N = jn[s + 8 >> 3], u = e[u + 4 >> 2], W = jn[u + 8 >> 3], Te = jn[u + 16 >> 3], Xe = jn[s + 16 >> 3], jn[r + 8 >> 3] = Te + Xe, jn[r >> 3] = (m == 0 ? 0 : (N + Te) * m) + (p == 0 ? 0 : p * (Xe + W));
                            return;
                          case 20:
                          case 21:
                            s = e[u + 4 >> 2], N = jn[s + 8 >> 3], u = e[u >> 2], W = jn[u + 8 >> 3], Te = jn[u + 16 >> 3], jn[r + 8 >> 3] = Te + jn[s + 16 >> 3], jn[r >> 3] = (m == 0 ? 0 : W * m) + (p == 0 ? 0 : p * (Te + N));
                            return;
                          case 22:
                            s = e[u >> 2], N = jn[s + 8 >> 3], u = e[u + 4 >> 2], W = jn[u + 8 >> 3], Te = jn[u + 16 >> 3] + 1, Xe = jn[s + 16 >> 3] + 2, jn[r + 8 >> 3] = Te < Xe ? Te : Xe, jn[r >> 3] = (m == 0 ? 0 : (N + 2) * m) + (p == 0 ? 0 : p * (W + 1));
                            return;
                          case 23:
                            s = e[u + 8 >> 2], N = jn[s + 8 >> 3], W = jn[e[u + 4 >> 2] + 8 >> 3], u = e[u >> 2], Te = jn[u + 8 >> 3], Xe = jn[u + 16 >> 3], jn[r + 8 >> 3] = Xe + jn[s + 16 >> 3], jn[r >> 3] = (m == 0 ? 0 : (Te + W) * m) + (p == 0 ? 0 : p * (Xe + N));
                            return;
                          default:
                            if (r = cu(8), e[5996] = 0, s = pi(91, r | 0, 1318) | 0, u = e[5996], e[5996] = 0, (u | 0) != 1)
                              break t;
                            s = Hr() | 0, Xu(r), Jn(s | 0), Oi();
                          case 1:
                          case 4:
                          case 5:
                            break e;
                          case 2:
                            break r;
                        }
                      e[r + 8 >> 2] = 0, e[r + 12 >> 2] = 1072693248, e[r >> 2] = 0, e[r + 4 >> 2] = 1079132160;
                      return;
                    }
                    ga(4323, 1900, 476, 1746), Oi();
                  }
                  Ua(s | 0, 22664, 92), Oi();
                }
                e[r + 8 >> 2] = 0, e[r + 12 >> 2] = 2146435072, e[r >> 2] = 0, e[r + 4 >> 2] = 0;
              }
              function _l(r, s, u, A, m, p, N, W, Te) {
                var Xe = 0, fr = 0, ar = 0, vr = 0, _r = 0, hi = 0, mi = 0, Ni = 0, Hi = 0, Ji = 0, Ln = 0;
                Xe = Jr - 128 | 0, Jr = Xe;
                e: {
                  t: {
                    r: {
                      if (!Ju(p, N, W, Te, 0, 0, 0, 0))
                        break r;
                      fr = Te & 65535, _r = Te >>> 16 & 32767;
                      i:
                        n: {
                          if ((_r | 0) != 32767) {
                            if (ar = 4, _r)
                              break n;
                            ar = p | W | (N | fr) ? 3 : 2;
                            break i;
                          }
                          ar = !(p | W | (N | fr));
                        }
                      if (Ji = m >>> 16 | 0, hi = Ji & 32767, (hi | 0) == 32767)
                        break r;
                      if (ar)
                        break t;
                    }
                    Qo(Xe + 16 | 0, s, u, A, m, p, N, W, Te), s = e[Xe + 16 >> 2], A = e[Xe + 20 >> 2], m = e[Xe + 24 >> 2], u = e[Xe + 28 >> 2], Wl(Xe, s, A, m, u, s, A, m, u), A = e[Xe + 8 >> 2], m = e[Xe + 12 >> 2], W = e[Xe >> 2], Te = e[Xe + 4 >> 2];
                    break e;
                  }
                  if (ar = A, mi = m & 2147483647, fr = mi, _r = W, vr = Te & 2147483647, (Ju(s, u, ar, fr, p, N, W, vr) | 0) <= 0) {
                    if (Ju(s, u, ar, fr, p, N, W, vr)) {
                      W = s, Te = u;
                      break e;
                    }
                    Qo(Xe + 112 | 0, s, u, A, m, 0, 0, 0, 0), A = e[Xe + 120 >> 2], m = e[Xe + 124 >> 2], W = e[Xe + 112 >> 2], Te = e[Xe + 116 >> 2];
                    break e;
                  }
                  if (Ni = Te >>> 16 & 32767, hi ? (Te = u, W = s) : (Qo(Xe + 96 | 0, s, u, ar, mi, 0, 0, 0, 1081540608), ar = e[Xe + 104 >> 2], W = e[Xe + 108 >> 2], mi = W, hi = (W >>> 16 | 0) - 120 | 0, Te = e[Xe + 100 >> 2], W = e[Xe + 96 >> 2]), Ni || (Qo(Xe + 80 | 0, p, N, _r, vr, 0, 0, 0, 1081540608), _r = e[Xe + 88 >> 2], p = e[Xe + 92 >> 2], vr = p, Ni = (p >>> 16 | 0) - 120 | 0, N = e[Xe + 84 >> 2], p = e[Xe + 80 >> 2]), Hi = _r, Ln = vr & 65535 | 65536, mi = mi & 65535 | 65536, (hi | 0) > (Ni | 0)) {
                    for (; ; ) {
                      vr = ar - Hi | 0, fr = (N | 0) == (Te | 0) & p >>> 0 > W >>> 0 | N >>> 0 > Te >>> 0, _r = vr - fr | 0, fr = (mi - ((ar >>> 0 < Hi >>> 0) + Ln | 0) | 0) - (fr >>> 0 > vr >>> 0) | 0;
                      t: {
                        if ((fr | 0) > 0 | (fr | 0) >= 0) {
                          if (ar = W, W = W - p | 0, Te = Te - ((p >>> 0 > ar >>> 0) + N | 0) | 0, !(W | _r | (Te | fr))) {
                            Qo(Xe + 32 | 0, s, u, A, m, 0, 0, 0, 0), A = e[Xe + 40 >> 2], m = e[Xe + 44 >> 2], W = e[Xe + 32 >> 2], Te = e[Xe + 36 >> 2];
                            break e;
                          }
                          fr = fr << 1 | _r >>> 31, ar = _r << 1 | Te >>> 31;
                          break t;
                        }
                        fr = mi << 1 | ar >>> 31, ar = ar << 1 | Te >>> 31;
                      }
                      if (mi = fr, fr = Te << 1 | W >>> 31, W = W << 1, Te = fr, hi = hi - 1 | 0, !((hi | 0) > (Ni | 0)))
                        break;
                    }
                    hi = Ni;
                  }
                  vr = ar - Hi | 0, fr = (N | 0) == (Te | 0) & p >>> 0 > W >>> 0 | N >>> 0 > Te >>> 0, _r = vr - fr | 0, fr = (mi - ((ar >>> 0 < Hi >>> 0) + Ln | 0) | 0) - (fr >>> 0 > vr >>> 0) | 0, vr = fr;
                  t: {
                    if ((fr | 0) < 0) {
                      _r = ar, vr = mi;
                      break t;
                    }
                    if (ar = W, W = W - p | 0, Te = Te - ((p >>> 0 > ar >>> 0) + N | 0) | 0, W | _r | (Te | vr))
                      break t;
                    Qo(Xe + 48 | 0, s, u, A, m, 0, 0, 0, 0), A = e[Xe + 56 >> 2], m = e[Xe + 60 >> 2], W = e[Xe + 48 >> 2], Te = e[Xe + 52 >> 2];
                    break e;
                  }
                  if ((vr | 0) == 65535 | vr >>> 0 < 65535)
                    for (; s = Te >>> 31 | 0, hi = hi - 1 | 0, mi = Te << 1 | W >>> 31, W = W << 1, Te = mi, u = s, s = vr << 1 | _r >>> 31, _r = u | _r << 1, vr = s, s >>> 0 < 65536; )
                      ;
                  if (s = Ji & 32768, (hi | 0) <= 0) {
                    Qo(Xe - -64 | 0, W, Te, _r, vr & 65535 | (s | hi + 120) << 16, 0, 0, 0, 1065811968), A = e[Xe + 72 >> 2], m = e[Xe + 76 >> 2], W = e[Xe + 64 >> 2], Te = e[Xe + 68 >> 2];
                    break e;
                  }
                  A = _r, m = vr & 65535 | (s | hi) << 16;
                }
                e[r >> 2] = W, e[r + 4 >> 2] = Te, e[r + 8 >> 2] = A, e[r + 12 >> 2] = m, Jr = Xe + 128 | 0;
              }
              function yh(r, s) {
                r = r | 0, s = s | 0;
                var u = 0, A = 0, m = 0, p = 0, N = 0, W = 0, Te = 0;
                W = e[s >> 2], p = me[s + 11 | 0], N = p << 24 >> 24, u = (N | 0) < 0, Te = e[s + 4 >> 2], A = u ? Te : p;
                e: {
                  if ((A | 0) < 9)
                    break e;
                  for (p = u ? W : s, m = p + A | 0; ; ) {
                    for (u = p; ; ) {
                      if (u = lu(u, 115, A - 8 | 0), !u)
                        break e;
                      if (va(u, 4824, 9)) {
                        if (u = u + 1 | 0, A = m - u | 0, (A | 0) >= 9)
                          continue;
                        break e;
                      }
                      break;
                    }
                    if ((u | 0) == (m | 0) || (u = u - p | 0, (u | 0) == -1))
                      break e;
                    if (kc(s, u, 9, 5034), W = e[s >> 2], u = me[s + 11 | 0], N = u << 24 >> 24, m = (N | 0) < 0, p = m ? W : s, Te = e[s + 4 >> 2], A = m ? Te : u, m = p + A | 0, !((A | 0) > 8))
                      break;
                  }
                }
                u = N << 24 >> 24, A = (u | 0) < 0 ? Te : N & 255;
                e: {
                  if ((A | 0) < 10)
                    break e;
                  for (p = (u | 0) < 0 ? W : s, m = p + A | 0; ; ) {
                    for (u = p; ; ) {
                      if (u = lu(u, 104, A - 9 | 0), !u)
                        break e;
                      if (va(u, 4813, 10)) {
                        if (u = u + 1 | 0, A = m - u | 0, (A | 0) >= 10)
                          continue;
                        break e;
                      }
                      break;
                    }
                    if ((u | 0) == (m | 0) || (u = u - p | 0, (u | 0) == -1))
                      break e;
                    if (kc(s, u, 10, 4960), W = e[s >> 2], u = me[s + 11 | 0], N = u << 24 >> 24, m = (N | 0) < 0, p = m ? W : s, Te = e[s + 4 >> 2], A = m ? Te : u, m = p + A | 0, !((A | 0) > 9))
                      break;
                  }
                }
                u = N << 24 >> 24 < 0, A = u ? Te : N & 255;
                e: {
                  if ((A | 0) < 12)
                    break e;
                  for (p = u ? W : s, m = p + A | 0; ; ) {
                    for (u = p; ; ) {
                      if (u = lu(u, 114, A - 11 | 0), !u)
                        break e;
                      if (va(u, 4845, 12)) {
                        if (u = u + 1 | 0, A = m - u | 0, (A | 0) >= 12)
                          continue;
                        break e;
                      }
                      break;
                    }
                    if ((u | 0) == (m | 0) || (u = u - p | 0, (u | 0) == -1))
                      break e;
                    if (kc(s, u, 12, 4908), W = e[s >> 2], u = me[s + 11 | 0], N = u << 24 >> 24, m = (N | 0) < 0, p = m ? W : s, Te = e[s + 4 >> 2], A = m ? Te : u, m = p + A | 0, !((A | 0) > 11))
                      break;
                  }
                }
                u = N << 24 >> 24, A = (u | 0) < 0 ? Te : N & 255;
                e: {
                  if ((A | 0) < 10)
                    break e;
                  for (p = (u | 0) < 0 ? W : s, m = p + A | 0; ; ) {
                    for (u = p; ; ) {
                      if (u = lu(u, 104, A - 9 | 0), !u)
                        break e;
                      if (va(u, 4834, 10)) {
                        if (u = u + 1 | 0, A = m - u | 0, (A | 0) >= 10)
                          continue;
                        break e;
                      }
                      break;
                    }
                    if ((u | 0) == (m | 0) || (u = u - p | 0, (u | 0) == -1))
                      break e;
                    if (kc(s, u, 10, 4858), W = e[s >> 2], u = me[s + 11 | 0], N = u << 24 >> 24, m = (N | 0) < 0, p = m ? W : s, Te = e[s + 4 >> 2], A = m ? Te : u, m = p + A | 0, !((A | 0) > 9))
                      break;
                  }
                }
                u = N << 24 >> 24 < 0, A = u ? Te : N & 255;
                e: {
                  if ((A | 0) <= 0)
                    break e;
                  for (m = u ? W : s, N = m + A | 0; ; ) {
                    for (u = m; ; ) {
                      if (u = lu(u, 32, A), !u)
                        break e;
                      if (me[u | 0] != 32) {
                        if (u = u + 1 | 0, A = N - u | 0, (A | 0) > 0)
                          continue;
                        break e;
                      }
                      break;
                    }
                    if ((u | 0) == (N | 0) || (u = u - m | 0, (u | 0) == -1))
                      break e;
                    if (kc(s, u, 1, 5575), u = me[s + 11 | 0], p = u << 24 >> 24 < 0, m = p ? e[s >> 2] : s, A = p ? e[s + 4 >> 2] : u, N = m + A | 0, !((A | 0) > 0))
                      break;
                  }
                }
                u = e[s + 4 >> 2], e[r >> 2] = e[s >> 2], e[r + 4 >> 2] = u, e[r + 8 >> 2] = e[s + 8 >> 2], e[s >> 2] = 0, e[s + 4 >> 2] = 0, e[s + 8 >> 2] = 0;
              }
              function Ih(r, s, u, A, m, p, N) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0, m = m | 0, p = p | 0, N = N | 0;
                var W = 0, Te = 0, Xe = 0, fr = 0, ar = 0, vr = 0, _r = 0, hi = 0, mi = 0, Ni = 0;
                fr = Jr - 16 | 0, Jr = fr, ar = b4(e[N >> 2]), hi = C4(e[N >> 2]), N = hi, xi[e[e[N >> 2] + 20 >> 2]](fr + 4 | 0, N), e[p >> 2] = A;
                e: {
                  t: {
                    r:
                      switch (Te = r, N = me[Te | 0], N - 43 | 0) {
                        case 0:
                        case 2:
                          break r;
                        default:
                          break t;
                      }
                    if (e[5996] = 0, N = pi(216, ar | 0, N << 24 >> 24) | 0, Te = e[5996], e[5996] = 0, (Te | 0) == 1)
                      break e;
                    Te = e[p >> 2], e[p >> 2] = Te + 4, e[Te >> 2] = N, Te = r + 1 | 0;
                  }
                  t: {
                    if (N = Te, !((u - N | 0) <= 1 | me[N | 0] != 48 | (me[N + 1 | 0] | 32) != 120)) {
                      if (e[5996] = 0, Te = pi(216, ar | 0, 48) | 0, W = e[5996], e[5996] = 0, (W | 0) == 1 || (W = e[p >> 2], e[p >> 2] = W + 4, e[W >> 2] = Te, Te = _[N + 1 | 0], e[5996] = 0, Te = pi(216, ar | 0, Te | 0) | 0, W = e[5996], e[5996] = 0, (W | 0) == 1))
                        break e;
                      for (W = e[p >> 2], e[p >> 2] = W + 4, e[W >> 2] = Te, Te = N + 2 | 0, N = Te; ; ) {
                        if (u >>> 0 <= N >>> 0 || (W = _[N | 0], ko(), !(W - 48 >>> 0 < 10 | (W | 32) - 97 >>> 0 < 6)))
                          break t;
                        N = N + 1 | 0;
                      }
                    }
                    for (; ; ) {
                      if (u >>> 0 <= N >>> 0 || (W = _[N | 0], ko(), W - 48 >>> 0 >= 10))
                        break t;
                      N = N + 1 | 0;
                    }
                  }
                  t: {
                    if (W = me[fr + 15 | 0], !((W & 128) >>> 7 | 0 ? e[fr + 8 >> 2] : W & 127)) {
                      if (W = e[p >> 2], e[5996] = 0, Vs(208, ar | 0, Te | 0, N | 0, W | 0), W = e[5996], e[5996] = 0, (W | 0) == 1)
                        break e;
                      e[p >> 2] = e[p >> 2] + (N - Te << 2);
                      break t;
                    }
                    if (du(Te, N), e[5996] = 0, Ni = Mi(206, hi | 0) | 0, W = e[5996], e[5996] = 0, (W | 0) == 1)
                      break e;
                    for (W = Te; ; ) {
                      if (N >>> 0 <= W >>> 0) {
                        hf((Te - r << 2) + A | 0, e[p >> 2]);
                        break t;
                      }
                      if (Xe = fr + 4 | 0, vr = (me[Xe + 11 | 0] & 128) >>> 7 | 0, _[(vr ? e[Xe >> 2] : Xe) + _r | 0] <= 0 | _[(vr ? e[Xe >> 2] : Xe) + _r | 0] != (mi | 0) || (Xe = e[p >> 2], e[p >> 2] = Xe + 4, e[Xe >> 2] = Ni, mi = 0, Xe = me[fr + 15 | 0], _r = (((Xe & 128) >>> 7 | 0 ? e[fr + 8 >> 2] : Xe & 127) - 1 >>> 0 > _r >>> 0) + _r | 0), Xe = _[W | 0], e[5996] = 0, Xe = pi(216, ar | 0, Xe | 0) | 0, vr = e[5996], e[5996] = 0, (vr | 0) != 1) {
                        vr = e[p >> 2], e[p >> 2] = vr + 4, e[vr >> 2] = Xe, W = W + 1 | 0, mi = mi + 1 | 0;
                        continue;
                      }
                      break;
                    }
                    break e;
                  }
                  t: {
                    for (; ; ) {
                      if (u >>> 0 > N >>> 0) {
                        if (Te = me[N | 0], (Te | 0) == 46) {
                          if (e[5996] = 0, Te = Mi(209, hi | 0) | 0, W = e[5996], e[5996] = 0, (W | 0) == 1)
                            break e;
                          Xe = e[p >> 2], W = Xe + 4 | 0, e[p >> 2] = W, e[Xe >> 2] = Te, N = N + 1 | 0;
                          break t;
                        }
                        if (e[5996] = 0, Te = pi(216, ar | 0, Te << 24 >> 24) | 0, W = e[5996], e[5996] = 0, (W | 0) == 1)
                          break e;
                        W = e[p >> 2], e[p >> 2] = W + 4, e[W >> 2] = Te, N = N + 1 | 0;
                        continue;
                      }
                      break;
                    }
                    W = e[p >> 2];
                  }
                  if (e[5996] = 0, Vs(208, ar | 0, N | 0, u | 0, W | 0), Te = e[5996], e[5996] = 0, (Te | 0) == 1)
                    break e;
                  Te = p, p = e[p >> 2] + (u - N << 2) | 0, e[Te >> 2] = p, e[m >> 2] = (s | 0) == (u | 0) ? p : (s - r << 2) + A | 0, Qn(fr + 4 | 0), Jr = fr + 16 | 0;
                  return;
                }
                r = Hr() | 0, Qn(fr + 4 | 0), Jn(r | 0), Oi();
              }
              function hg(r, s, u, A, m, p, N) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0, m = m | 0, p = p | 0, N = N | 0;
                var W = 0, Te = 0, Xe = 0, fr = 0, ar = 0, vr = 0, _r = 0, hi = 0, mi = 0, Ni = 0;
                fr = Jr - 16 | 0, Jr = fr, ar = w4(e[N >> 2]), hi = B4(e[N >> 2]), N = hi, xi[e[e[N >> 2] + 20 >> 2]](fr + 4 | 0, N), e[p >> 2] = A;
                e: {
                  t: {
                    r:
                      switch (Te = r, N = me[Te | 0], N - 43 | 0) {
                        case 0:
                        case 2:
                          break r;
                        default:
                          break t;
                      }
                    if (e[5996] = 0, N = pi(171, ar | 0, N << 24 >> 24) | 0, Te = e[5996], e[5996] = 0, (Te | 0) == 1)
                      break e;
                    Te = e[p >> 2], e[p >> 2] = Te + 1, _[Te | 0] = N, Te = r + 1 | 0;
                  }
                  t: {
                    if (N = Te, !((u - N | 0) <= 1 | me[N | 0] != 48 | (me[N + 1 | 0] | 32) != 120)) {
                      if (e[5996] = 0, Te = pi(171, ar | 0, 48) | 0, W = e[5996], e[5996] = 0, (W | 0) == 1 || (W = e[p >> 2], e[p >> 2] = W + 1, _[W | 0] = Te, Te = _[N + 1 | 0], e[5996] = 0, Te = pi(171, ar | 0, Te | 0) | 0, W = e[5996], e[5996] = 0, (W | 0) == 1))
                        break e;
                      for (W = e[p >> 2], e[p >> 2] = W + 1, _[W | 0] = Te, Te = N + 2 | 0, N = Te; ; ) {
                        if (u >>> 0 <= N >>> 0 || (W = _[N | 0], ko(), !(W - 48 >>> 0 < 10 | (W | 32) - 97 >>> 0 < 6)))
                          break t;
                        N = N + 1 | 0;
                      }
                    }
                    for (; ; ) {
                      if (u >>> 0 <= N >>> 0 || (W = _[N | 0], ko(), W - 48 >>> 0 >= 10))
                        break t;
                      N = N + 1 | 0;
                    }
                  }
                  t: {
                    if (W = me[fr + 15 | 0], !((W & 128) >>> 7 | 0 ? e[fr + 8 >> 2] : W & 127)) {
                      if (W = e[p >> 2], e[5996] = 0, Vs(195, ar | 0, Te | 0, N | 0, W | 0), W = e[5996], e[5996] = 0, (W | 0) == 1)
                        break e;
                      e[p >> 2] = e[p >> 2] + (N - Te | 0);
                      break t;
                    }
                    if (du(Te, N), e[5996] = 0, Ni = Mi(193, hi | 0) | 0, W = e[5996], e[5996] = 0, (W | 0) == 1)
                      break e;
                    for (W = Te; ; ) {
                      if (N >>> 0 <= W >>> 0) {
                        du((Te - r | 0) + A | 0, e[p >> 2]);
                        break t;
                      }
                      if (Xe = fr + 4 | 0, vr = (me[Xe + 11 | 0] & 128) >>> 7 | 0, _[(vr ? e[Xe >> 2] : Xe) + _r | 0] <= 0 | _[(vr ? e[Xe >> 2] : Xe) + _r | 0] != (mi | 0) || (Xe = e[p >> 2], e[p >> 2] = Xe + 1, _[Xe | 0] = Ni, mi = 0, Xe = me[fr + 15 | 0], _r = (((Xe & 128) >>> 7 | 0 ? e[fr + 8 >> 2] : Xe & 127) - 1 >>> 0 > _r >>> 0) + _r | 0), Xe = _[W | 0], e[5996] = 0, Xe = pi(171, ar | 0, Xe | 0) | 0, vr = e[5996], e[5996] = 0, (vr | 0) != 1) {
                        vr = e[p >> 2], e[p >> 2] = vr + 1, _[vr | 0] = Xe, W = W + 1 | 0, mi = mi + 1 | 0;
                        continue;
                      }
                      break;
                    }
                    break e;
                  }
                  for (; ; ) {
                    t: {
                      if (u >>> 0 > N >>> 0) {
                        if (Te = me[N | 0], (Te | 0) != 46)
                          break t;
                        if (e[5996] = 0, Te = Mi(196, hi | 0) | 0, W = e[5996], e[5996] = 0, (W | 0) == 1)
                          break e;
                        W = e[p >> 2], e[p >> 2] = W + 1, _[W | 0] = Te, N = N + 1 | 0;
                      }
                      if (Te = e[p >> 2], e[5996] = 0, Vs(195, ar | 0, N | 0, u | 0, Te | 0), Te = e[5996], e[5996] = 0, (Te | 0) == 1)
                        break e;
                      Te = p, p = e[p >> 2] + (u - N | 0) | 0, e[Te >> 2] = p, e[m >> 2] = (s | 0) == (u | 0) ? p : (s - r | 0) + A | 0, Qn(fr + 4 | 0), Jr = fr + 16 | 0;
                      return;
                    }
                    if (e[5996] = 0, Te = pi(171, ar | 0, Te << 24 >> 24) | 0, W = e[5996], e[5996] = 0, (W | 0) == 1)
                      break e;
                    W = e[p >> 2], e[p >> 2] = W + 1, _[W | 0] = Te, N = N + 1 | 0;
                  }
                }
                r = Hr() | 0, Qn(fr + 4 | 0), Jn(r | 0), Oi();
              }
              function mh(r, s, u, A) {
                var m = 0, p = 0, N = 0, W = 0, Te = 0;
                m = e[s >> 2];
                e: {
                  t: {
                    r: {
                      i: {
                        n: {
                          s: {
                            a: {
                              o: {
                                l: {
                                  c: {
                                    d: {
                                      f: {
                                        if (!A || (N = e[A >> 2], !N))
                                          break f;
                                        if (!r) {
                                          A = u;
                                          break c;
                                        }
                                        e[A >> 2] = 0, A = u;
                                        break d;
                                      }
                                      f: {
                                        if (!e[e[6178] >> 2]) {
                                          if (!r)
                                            break f;
                                          if (!u)
                                            break e;
                                          for (N = u; ; ) {
                                            if (A = _[m | 0], A) {
                                              if (e[r >> 2] = A & 57343, r = r + 4 | 0, m = m + 1 | 0, N = N - 1 | 0, N)
                                                continue;
                                              break e;
                                            }
                                            break;
                                          }
                                          return e[r >> 2] = 0, e[s >> 2] = 0, u - N | 0;
                                        }
                                        if (A = u, !r)
                                          break l;
                                        break a;
                                      }
                                      return Fa(m);
                                    }
                                    p = 1;
                                    break a;
                                  }
                                  p = 0;
                                  break o;
                                }
                                p = 1;
                              }
                              for (; ; ) {
                                if (!p) {
                                  if (p = me[m | 0] >>> 3 | 0, (p - 16 | p + (N >> 26)) >>> 0 > 7)
                                    break s;
                                  p = m + 1 | 0;
                                  o: {
                                    if (!(N & 33554432))
                                      break o;
                                    if ((me[p | 0] & 192) != 128) {
                                      m = m - 1 | 0;
                                      break i;
                                    }
                                    if (p = m + 2 | 0, !(N & 524288))
                                      break o;
                                    if ((me[p | 0] & 192) != 128) {
                                      m = m - 1 | 0;
                                      break i;
                                    }
                                    p = m + 3 | 0;
                                  }
                                  m = p, A = A - 1 | 0, p = 1;
                                  continue;
                                }
                                for (; ; ) {
                                  N = me[m | 0];
                                  o: {
                                    if (m & 3 | N - 1 >>> 0 > 126 || (N = e[m >> 2], (N | N - 16843009) & -2139062144))
                                      break o;
                                    for (; A = A - 4 | 0, N = e[m + 4 >> 2], m = m + 4 | 0, !((N - 16843009 | N) & -2139062144); )
                                      ;
                                  }
                                  if (p = N & 255, p - 1 >>> 0 <= 126) {
                                    A = A - 1 | 0, m = m + 1 | 0;
                                    continue;
                                  }
                                  break;
                                }
                                if (p = p - 194 | 0, p >>> 0 > 50)
                                  break n;
                                m = m + 1 | 0, N = e[(p << 2) + 12208 >> 2], p = 0;
                              }
                            }
                            for (; ; ) {
                              if (!p) {
                                if (!A)
                                  break e;
                                for (; ; ) {
                                  a: {
                                    p = me[m | 0], W = p - 1 | 0;
                                    o: {
                                      l: {
                                        if (W >>> 0 > 126) {
                                          N = p;
                                          break l;
                                        }
                                        if (m & 3 | A >>> 0 < 5)
                                          break o;
                                        c: {
                                          for (; ; ) {
                                            if (N = e[m >> 2], (N | N - 16843009) & -2139062144)
                                              break c;
                                            if (e[r >> 2] = N & 255, e[r + 4 >> 2] = me[m + 1 | 0], e[r + 8 >> 2] = me[m + 2 | 0], e[r + 12 >> 2] = me[m + 3 | 0], r = r + 16 | 0, m = m + 4 | 0, A = A - 4 | 0, !(A >>> 0 > 4))
                                              break;
                                          }
                                          N = me[m | 0];
                                        }
                                        p = N & 255, W = p - 1 | 0;
                                      }
                                      if (W >>> 0 > 126)
                                        break a;
                                    }
                                    if (e[r >> 2] = p, r = r + 4 | 0, m = m + 1 | 0, A = A - 1 | 0, A)
                                      continue;
                                    break e;
                                  }
                                  break;
                                }
                                if (p = p - 194 | 0, p >>> 0 > 50)
                                  break n;
                                m = m + 1 | 0, N = e[(p << 2) + 12208 >> 2], p = 1;
                                continue;
                              }
                              if (Te = me[m | 0], p = Te >>> 3 | 0, (p - 16 | p + (N >> 26)) >>> 0 > 7)
                                break s;
                              a: {
                                o: {
                                  W = m + 1 | 0, p = Te - 128 | N << 6;
                                  l: {
                                    if ((p | 0) >= 0)
                                      break l;
                                    if (Te = me[W | 0] - 128 | 0, Te >>> 0 > 63)
                                      break o;
                                    if (W = m + 2 | 0, p = Te | p << 6, (p | 0) >= 0)
                                      break l;
                                    if (W = me[W | 0] - 128 | 0, W >>> 0 > 63)
                                      break o;
                                    p = W | p << 6, W = m + 3 | 0;
                                  }
                                  m = W, e[r >> 2] = p, A = A - 1 | 0, r = r + 4 | 0;
                                  break a;
                                }
                                e[5732] = 25, m = m - 1 | 0;
                                break r;
                              }
                              p = 0;
                            }
                          }
                          if (m = m - 1 | 0, N)
                            break i;
                          N = me[m | 0];
                        }
                        if (N & 255)
                          break i;
                        return r && (e[r >> 2] = 0, e[s >> 2] = 0), u - A | 0;
                      }
                      if (e[5732] = 25, !r)
                        break t;
                    }
                    e[s >> 2] = m;
                  }
                  return -1;
                }
                return e[s >> 2] = m, u;
              }
              function wh(r, s, u, A, m, p) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0, m = m | 0, p = p | 0;
                var N = 0, W = 0;
                r = Jr - 256 | 0, Jr = r, e[r + 248 >> 2] = u, e[r + 252 >> 2] = s, W = r + 196 | 0, e[W >> 2] = 0, e[W + 4 >> 2] = 0, e[W + 8 >> 2] = 0, N = r + 16 | 0, s = e[A + 28 >> 2], e[N >> 2] = s, e[s + 4 >> 2] = e[s + 4 >> 2] + 1, e[5996] = 0, s = Mi(170, e[r + 16 >> 2]) | 0, u = e[5996], e[5996] = 0;
                e: {
                  t: {
                    if ((u | 0) == 1 || (e[5996] = 0, Vs(195, s | 0, 12416, 12442, r + 208 | 0), s = e[5996], e[5996] = 0, (s | 0) == 1))
                      break t;
                    if (s = e[r + 16 >> 2], u = e[s + 4 >> 2] - 1 | 0, e[s + 4 >> 2] = u, (u | 0) == -1 && xi[e[e[s >> 2] + 8 >> 2]](s), u = r + 184 | 0, e[u >> 2] = 0, e[u + 4 >> 2] = 0, e[u + 8 >> 2] = 0, s = (me[u + 11 | 0] & 128) >>> 7 | 0 ? (e[u + 8 >> 2] & 2147483647) - 1 | 0 : 10, e[5996] = 0, ji(172, u | 0, s | 0), s = e[5996], e[5996] = 0, (s | 0) != 1)
                      r:
                        for (s = (me[u + 11 | 0] & 128) >>> 7 | 0 ? e[u >> 2] : u, e[r + 180 >> 2] = s, e[r + 12 >> 2] = N, e[r + 8 >> 2] = 0; ; ) {
                          i: {
                            if (e[5996] = 0, N = pi(186, r + 252 | 0, r + 248 | 0) | 0, A = e[5996], e[5996] = 0, (A | 0) == 1)
                              break i;
                            A = e[r + 180 >> 2];
                            n: {
                              if (!N) {
                                if (N = A, A = me[u + 11 | 0], A = (A & 128) >>> 7 | 0 ? e[u + 4 >> 2] : A & 127, (N | 0) == (A + s | 0)) {
                                  if (e[5996] = 0, ji(172, u | 0, A << 1), s = e[5996], e[5996] = 0, (s | 0) == 1 || (s = (me[u + 11 | 0] & 128) >>> 7 | 0 ? (e[u + 8 >> 2] & 2147483647) - 1 | 0 : 10, e[5996] = 0, ji(172, u | 0, s | 0), s = e[5996], e[5996] = 0, (s | 0) == 1))
                                    break r;
                                  s = (me[u + 11 | 0] & 128) >>> 7 | 0 ? e[u >> 2] : u, e[r + 180 >> 2] = A + s;
                                }
                                if (e[5996] = 0, A = Mi(187, e[r + 252 >> 2]) | 0, N = e[5996], e[5996] = 0, (N | 0) == 1)
                                  break i;
                                if (!Kf(A, 16, s, r + 180 | 0, r + 8 | 0, 0, e[W + 4 >> 2], me[W + 11 | 0], r + 16 | 0, r + 12 | 0, r + 208 | 0))
                                  break n;
                                A = e[r + 180 >> 2];
                              }
                              if (e[5996] = 0, ji(172, u | 0, A - s | 0), s = e[5996], e[5996] = 0, (s | 0) == 1 || (s = e[u >> 2], A = (me[u + 11 | 0] & 128) >>> 7 | 0, N = ko(), e[r >> 2] = p, (Nf(A ? s : u, N, r) | 0) != 1 && (e[m >> 2] = 4), e[5996] = 0, s = pi(186, r + 252 | 0, r + 248 | 0) | 0, A = e[5996], e[5996] = 0, (A | 0) == 1))
                                break i;
                              return s && (e[m >> 2] = e[m >> 2] | 2), s = e[r + 252 >> 2], Qn(u), Qn(W), Jr = r + 256 | 0, s | 0;
                            }
                            if (e[5996] = 0, Mi(189, r + 252 | 0) | 0, A = e[5996], e[5996] = 0, (A | 0) != 1)
                              continue;
                          }
                          break;
                        }
                    s = Hr() | 0, Qn(u);
                    break e;
                  }
                  s = Hr() | 0, r = e[r + 16 >> 2], u = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = u, (u | 0) == -1 && xi[e[e[r >> 2] + 8 >> 2]](r);
                }
                Qn(W), Jn(s | 0), Oi();
              }
              function Ag(r, s, u, A, m, p) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0, m = m | 0, p = p | 0;
                var N = 0, W = 0;
                r = Jr - 320 | 0, Jr = r, e[r + 312 >> 2] = u, e[r + 316 >> 2] = s, W = r + 196 | 0, e[W >> 2] = 0, e[W + 4 >> 2] = 0, e[W + 8 >> 2] = 0, N = r + 16 | 0, s = e[A + 28 >> 2], e[N >> 2] = s, e[s + 4 >> 2] = e[s + 4 >> 2] + 1, e[5996] = 0, s = Mi(197, e[r + 16 >> 2]) | 0, u = e[5996], e[5996] = 0;
                e: {
                  t: {
                    if ((u | 0) == 1 || (e[5996] = 0, Vs(208, s | 0, 12416, 12442, r + 208 | 0), s = e[5996], e[5996] = 0, (s | 0) == 1))
                      break t;
                    if (s = e[r + 16 >> 2], u = e[s + 4 >> 2] - 1 | 0, e[s + 4 >> 2] = u, (u | 0) == -1 && xi[e[e[s >> 2] + 8 >> 2]](s), u = r + 184 | 0, e[u >> 2] = 0, e[u + 4 >> 2] = 0, e[u + 8 >> 2] = 0, s = (me[u + 11 | 0] & 128) >>> 7 | 0 ? (e[u + 8 >> 2] & 2147483647) - 1 | 0 : 10, e[5996] = 0, ji(172, u | 0, s | 0), s = e[5996], e[5996] = 0, (s | 0) != 1)
                      r:
                        for (s = (me[u + 11 | 0] & 128) >>> 7 | 0 ? e[u >> 2] : u, e[r + 180 >> 2] = s, e[r + 12 >> 2] = N, e[r + 8 >> 2] = 0; ; ) {
                          i: {
                            if (e[5996] = 0, N = pi(202, r + 316 | 0, r + 312 | 0) | 0, A = e[5996], e[5996] = 0, (A | 0) == 1)
                              break i;
                            A = e[r + 180 >> 2];
                            n: {
                              if (!N) {
                                if (N = A, A = me[u + 11 | 0], A = (A & 128) >>> 7 | 0 ? e[u + 4 >> 2] : A & 127, (N | 0) == (A + s | 0)) {
                                  if (e[5996] = 0, ji(172, u | 0, A << 1), s = e[5996], e[5996] = 0, (s | 0) == 1 || (s = (me[u + 11 | 0] & 128) >>> 7 | 0 ? (e[u + 8 >> 2] & 2147483647) - 1 | 0 : 10, e[5996] = 0, ji(172, u | 0, s | 0), s = e[5996], e[5996] = 0, (s | 0) == 1))
                                    break r;
                                  s = (me[u + 11 | 0] & 128) >>> 7 | 0 ? e[u >> 2] : u, e[r + 180 >> 2] = A + s;
                                }
                                if (e[5996] = 0, A = Mi(203, e[r + 316 >> 2]) | 0, N = e[5996], e[5996] = 0, (N | 0) == 1)
                                  break i;
                                if (!Vf(A, 16, s, r + 180 | 0, r + 8 | 0, 0, e[W + 4 >> 2], me[W + 11 | 0], r + 16 | 0, r + 12 | 0, r + 208 | 0))
                                  break n;
                                A = e[r + 180 >> 2];
                              }
                              if (e[5996] = 0, ji(172, u | 0, A - s | 0), s = e[5996], e[5996] = 0, (s | 0) == 1 || (s = e[u >> 2], A = (me[u + 11 | 0] & 128) >>> 7 | 0, N = ko(), e[r >> 2] = p, (Nf(A ? s : u, N, r) | 0) != 1 && (e[m >> 2] = 4), e[5996] = 0, s = pi(202, r + 316 | 0, r + 312 | 0) | 0, A = e[5996], e[5996] = 0, (A | 0) == 1))
                                break i;
                              return s && (e[m >> 2] = e[m >> 2] | 2), s = e[r + 316 >> 2], Qn(u), Qn(W), Jr = r + 320 | 0, s | 0;
                            }
                            if (e[5996] = 0, Mi(205, r + 316 | 0) | 0, A = e[5996], e[5996] = 0, (A | 0) != 1)
                              continue;
                          }
                          break;
                        }
                    s = Hr() | 0, Qn(u);
                    break e;
                  }
                  s = Hr() | 0, r = e[r + 16 >> 2], u = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = u, (u | 0) == -1 && xi[e[e[r >> 2] + 8 >> 2]](r);
                }
                Qn(W), Jn(s | 0), Oi();
              }
              function gg(r, s, u, A, m, p) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0, m = m | 0, p = p | 0;
                var N = 0, W = 0, Te = 0, Xe = 0, fr = 0, ar = 0, vr = 0, _r = 0, hi = 0, mi = 0;
                r = Jr - 480 | 0, Jr = r, N = e[A + 28 >> 2], e[r + 476 >> 2] = N, e[N + 4 >> 2] = e[N + 4 >> 2] + 1, e[5996] = 0, hi = Mi(197, e[r + 476 >> 2]) | 0, N = e[5996], e[5996] = 0;
                e: {
                  t: {
                    r: {
                      i: {
                        n: {
                          if ((N | 0) != 1) {
                            if (Te = me[p + 11 | 0], N = (Te & 128) >>> 7 | 0, N ? e[p + 4 >> 2] : Te & 127) {
                              if (N = e[(N ? e[p >> 2] : p) >> 2], e[5996] = 0, Te = pi(216, hi | 0, 45) | 0, fr = e[5996], e[5996] = 0, (fr | 0) == 1)
                                break n;
                              mi = (N | 0) == (Te | 0);
                            }
                            if (fr = r + 452 | 0, e[fr >> 2] = 0, e[fr + 4 >> 2] = 0, e[fr + 8 >> 2] = 0, N = r + 440 | 0, e[N >> 2] = 0, e[N + 4 >> 2] = 0, e[N + 8 >> 2] = 0, Te = r + 428 | 0, e[Te >> 2] = 0, e[Te + 4 >> 2] = 0, e[Te + 8 >> 2] = 0, e[5996] = 0, Uf(238, u | 0, mi | 0, e[r + 476 >> 2], r + 472 | 0, r + 468 | 0, r + 464 | 0, fr | 0, N | 0, Te | 0, r + 424 | 0), u = e[5996], e[5996] = 0, (u | 0) == 1)
                              break i;
                            e[r + 4 >> 2] = 184, ar = r + 8 | 0, e[ar >> 2] = 0, e[ar + 4 >> 2] = e[r + 4 >> 2], u = r + 16 | 0, Xe = me[p + 11 | 0], Xe = (Xe & 128) >>> 7 | 0 ? e[p + 4 >> 2] : Xe & 127, vr = e[r + 424 >> 2];
                            s: {
                              if ((Xe | 0) > (vr | 0)) {
                                W = me[Te + 11 | 0], _r = (Xe - vr << 1) + ((W & 128) >>> 7 | 0 ? e[Te + 4 >> 2] : W & 127) | 0, W = me[N + 11 | 0], W = (_r + ((W & 128) >>> 7 | 0 ? e[N + 4 >> 2] : W & 127) | 0) + 1 | 0;
                                break s;
                              }
                              W = me[Te + 11 | 0], _r = (W & 128) >>> 7 | 0 ? e[Te + 4 >> 2] : W & 127, W = me[N + 11 | 0], W = (_r + ((W & 128) >>> 7 | 0 ? e[N + 4 >> 2] : W & 127) | 0) + 2 | 0;
                            }
                            s: {
                              if (W = W + vr | 0, W >>> 0 >= 101) {
                                if (ia(ar, da(W << 2)), u = e[ar >> 2], !u)
                                  break s;
                                Xe = me[p + 11 | 0], Xe = (Xe & 128) >>> 7 | 0 ? e[p + 4 >> 2] : Xe & 127;
                              }
                              if (W = e[A + 4 >> 2], p = (me[p + 11 | 0] & 128) >>> 7 | 0 ? e[p >> 2] : p, e[5996] = 0, _c(239, u | 0, r + 4 | 0, r | 0, W | 0, p | 0, p + (Xe << 2) | 0, hi | 0, mi | 0, r + 472 | 0, e[r + 468 >> 2], e[r + 464 >> 2], fr | 0, N | 0, Te | 0, vr | 0), p = e[5996], e[5996] = 0, (p | 0) == 1 || (e[5996] = 0, A = za(219, s | 0, u | 0, e[r + 4 >> 2], e[r >> 2], A | 0, m | 0) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1))
                                break r;
                              return to(ar), Qn(Te), Qn(N), Qn(fr), s = e[r + 476 >> 2], u = e[s + 4 >> 2] - 1 | 0, e[s + 4 >> 2] = u, (u | 0) == -1 && xi[e[e[s >> 2] + 8 >> 2]](s), Jr = r + 480 | 0, A | 0;
                            }
                            if (e[5996] = 0, Nn(185), s = e[5996], e[5996] = 0, (s | 0) == 1)
                              break r;
                            Oi();
                          }
                          p = Hr() | 0;
                          break e;
                        }
                        p = Hr() | 0;
                        break e;
                      }
                      p = Hr() | 0;
                      break t;
                    }
                    p = Hr() | 0, to(ar);
                  }
                  Qn(Te), Qn(N), Qn(fr);
                }
                r = e[r + 476 >> 2], s = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = s, (s | 0) == -1 && xi[e[e[r >> 2] + 8 >> 2]](r), Jn(p | 0), Oi();
              }
              function pg(r, s, u, A, m, p) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0, m = m | 0, p = p | 0;
                var N = 0, W = 0, Te = 0, Xe = 0, fr = 0, ar = 0, vr = 0, _r = 0, hi = 0, mi = 0;
                r = Jr - 176 | 0, Jr = r, N = e[A + 28 >> 2], e[r + 172 >> 2] = N, e[N + 4 >> 2] = e[N + 4 >> 2] + 1, e[5996] = 0, hi = Mi(170, e[r + 172 >> 2]) | 0, N = e[5996], e[5996] = 0;
                e: {
                  t: {
                    r: {
                      i: {
                        n: {
                          if ((N | 0) != 1) {
                            if (Te = me[p + 11 | 0], N = (Te & 128) >>> 7 | 0, N ? e[p + 4 >> 2] : Te & 127) {
                              if (N = me[(N ? e[p >> 2] : p) | 0], e[5996] = 0, Te = pi(171, hi | 0, 45) | 0, fr = e[5996], e[5996] = 0, (fr | 0) == 1)
                                break n;
                              mi = (Te & 255) == (N | 0);
                            }
                            if (fr = r + 152 | 0, e[fr >> 2] = 0, e[fr + 4 >> 2] = 0, e[fr + 8 >> 2] = 0, N = r + 140 | 0, e[N >> 2] = 0, e[N + 4 >> 2] = 0, e[N + 8 >> 2] = 0, Te = r + 128 | 0, e[Te >> 2] = 0, e[Te + 4 >> 2] = 0, e[Te + 8 >> 2] = 0, e[5996] = 0, Uf(236, u | 0, mi | 0, e[r + 172 >> 2], r + 168 | 0, r + 167 | 0, r + 166 | 0, fr | 0, N | 0, Te | 0, r + 124 | 0), u = e[5996], e[5996] = 0, (u | 0) == 1)
                              break i;
                            e[r + 4 >> 2] = 184, ar = r + 8 | 0, e[ar >> 2] = 0, e[ar + 4 >> 2] = e[r + 4 >> 2], u = r + 16 | 0, Xe = me[p + 11 | 0], Xe = (Xe & 128) >>> 7 | 0 ? e[p + 4 >> 2] : Xe & 127, vr = e[r + 124 >> 2];
                            s: {
                              if ((Xe | 0) > (vr | 0)) {
                                W = me[Te + 11 | 0], _r = (Xe - vr << 1) + ((W & 128) >>> 7 | 0 ? e[Te + 4 >> 2] : W & 127) | 0, W = me[N + 11 | 0], W = (_r + ((W & 128) >>> 7 | 0 ? e[N + 4 >> 2] : W & 127) | 0) + 1 | 0;
                                break s;
                              }
                              W = me[Te + 11 | 0], _r = (W & 128) >>> 7 | 0 ? e[Te + 4 >> 2] : W & 127, W = me[N + 11 | 0], W = (_r + ((W & 128) >>> 7 | 0 ? e[N + 4 >> 2] : W & 127) | 0) + 2 | 0;
                            }
                            s: {
                              if (W = W + vr | 0, W >>> 0 >= 101) {
                                if (ia(ar, da(W)), u = e[ar >> 2], !u)
                                  break s;
                                Xe = me[p + 11 | 0], Xe = (Xe & 128) >>> 7 | 0 ? e[p + 4 >> 2] : Xe & 127;
                              }
                              if (W = e[A + 4 >> 2], p = (me[p + 11 | 0] & 128) >>> 7 | 0 ? e[p >> 2] : p, e[5996] = 0, _c(237, u | 0, r + 4 | 0, r | 0, W | 0, p | 0, p + Xe | 0, hi | 0, mi | 0, r + 168 | 0, _[r + 167 | 0], _[r + 166 | 0], fr | 0, N | 0, Te | 0, vr | 0), p = e[5996], e[5996] = 0, (p | 0) == 1 || (e[5996] = 0, A = za(213, s | 0, u | 0, e[r + 4 >> 2], e[r >> 2], A | 0, m | 0) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1))
                                break r;
                              return to(ar), Qn(Te), Qn(N), Qn(fr), s = e[r + 172 >> 2], u = e[s + 4 >> 2] - 1 | 0, e[s + 4 >> 2] = u, (u | 0) == -1 && xi[e[e[s >> 2] + 8 >> 2]](s), Jr = r + 176 | 0, A | 0;
                            }
                            if (e[5996] = 0, Nn(185), s = e[5996], e[5996] = 0, (s | 0) == 1)
                              break r;
                            Oi();
                          }
                          p = Hr() | 0;
                          break e;
                        }
                        p = Hr() | 0;
                        break e;
                      }
                      p = Hr() | 0;
                      break t;
                    }
                    p = Hr() | 0, to(ar);
                  }
                  Qn(Te), Qn(N), Qn(fr);
                }
                r = e[r + 172 >> 2], s = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = s, (s | 0) == -1 && xi[e[e[r >> 2] + 8 >> 2]](r), Jn(p | 0), Oi();
              }
              function yg(r, s, u, A, m, p, N, W, Te, Xe, fr, ar, vr, _r, hi) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0, m = m | 0, p = p | 0, N = N | 0, W = W | 0, Te = Te | 0, Xe = Xe | 0, fr = fr | 0, ar = ar | 0, vr = vr | 0, _r = _r | 0, hi = hi | 0;
                var mi = 0, Ni = 0, Hi = 0, Ji = 0, Ln = 0, _n = 0, hs = 0, bs = 0, Us = 0;
                for (e[u >> 2] = r, hs = A & 512, bs = W << 2; ; ) {
                  if ((_n | 0) == 4)
                    m = me[_r + 11 | 0], ((m & 128) >>> 7 | 0 ? e[_r + 4 >> 2] : m & 127) >>> 0 > 1 && (e[u >> 2] = oA(zd(Ga(_r), 1), Sa(_r), e[u >> 2])), A = A & 176, (A | 0) != 16 && ((A | 0) == 32 && (r = e[u >> 2]), e[s >> 2] = r);
                  else {
                    e: {
                      t:
                        switch (_[Te + _n | 0]) {
                          case 0:
                            e[s >> 2] = e[u >> 2];
                            break e;
                          case 1:
                            e[s >> 2] = e[u >> 2], W = xi[e[e[N >> 2] + 44 >> 2]](N, 32) | 0, mi = e[u >> 2], e[u >> 2] = mi + 4, e[mi >> 2] = W;
                            break e;
                          case 3:
                            if (W = me[_r + 11 | 0], Hi = W & 127, W = (W & 128) >>> 7 | 0, !(W ? e[_r + 4 >> 2] : Hi))
                              break e;
                            W = e[(W ? e[_r >> 2] : _r) >> 2], mi = e[u >> 2], e[u >> 2] = mi + 4, e[mi >> 2] = W;
                            break e;
                          case 2:
                            if (!hs || (W = me[vr + 11 | 0], !((W & 128) >>> 7 | 0 ? e[vr + 4 >> 2] : W & 127)))
                              break e;
                            e[u >> 2] = oA(Ga(vr), Sa(vr), e[u >> 2]);
                            break e;
                          case 4:
                            break t;
                          default:
                            break e;
                        }
                      for (Us = e[u >> 2], m = m + bs | 0, W = m; ; ) {
                        t: {
                          if (p >>> 0 <= W >>> 0 || !(xi[e[e[N >> 2] + 12 >> 2]](N, 64, e[W >> 2]) | 0))
                            break t;
                          W = W + 4 | 0;
                          continue;
                        }
                        break;
                      }
                      if ((hi | 0) > 0) {
                        for (mi = e[u >> 2], Ni = hi; ; ) {
                          if (!(!Ni | m >>> 0 >= W >>> 0)) {
                            Ni = Ni - 1 | 0, W = W - 4 | 0, Ji = e[W >> 2], Hi = mi + 4 | 0, e[u >> 2] = Hi, e[mi >> 2] = Ji, mi = Hi;
                            continue;
                          }
                          break;
                        }
                        t: {
                          if (!Ni) {
                            Ji = 0;
                            break t;
                          }
                          Ji = xi[e[e[N >> 2] + 44 >> 2]](N, 48) | 0, mi = e[u >> 2];
                        }
                        for (; ; ) {
                          if (Hi = mi + 4 | 0, (Ni | 0) > 0) {
                            e[mi >> 2] = Ji, Ni = Ni - 1 | 0, mi = Hi;
                            continue;
                          }
                          break;
                        }
                        e[u >> 2] = Hi, e[mi >> 2] = Xe;
                      }
                      t: {
                        if ((m | 0) == (W | 0)) {
                          mi = xi[e[e[N >> 2] + 44 >> 2]](N, 48) | 0, Ni = e[u >> 2], W = Ni + 4 | 0, e[u >> 2] = W, e[Ni >> 2] = mi;
                          break t;
                        }
                        for (Ji = -1, mi = me[ar + 11 | 0], Hi = (mi & 128) >>> 7 | 0, (Hi ? e[ar + 4 >> 2] : mi & 127) && (Ji = _[(Hi ? e[ar >> 2] : ar) | 0]), Ni = 0, Ln = 0; ; ) {
                          if ((m | 0) != (W | 0)) {
                            Hi = e[u >> 2];
                            r: {
                              if ((Ni | 0) != (Ji | 0)) {
                                mi = Hi, Hi = Ni;
                                break r;
                              }
                              if (mi = Hi + 4 | 0, e[u >> 2] = mi, e[Hi >> 2] = fr, Hi = 0, Ln = Ln + 1 | 0, Ji = me[ar + 11 | 0], Ln >>> 0 >= ((Ji & 128) >>> 7 | 0 ? e[ar + 4 >> 2] : Ji & 127) >>> 0) {
                                Ji = Ni;
                                break r;
                              }
                              if (Ji = -1, Ni = ((me[ar + 11 | 0] & 128) >>> 7 | 0 ? e[ar >> 2] : ar) + Ln | 0, me[Ni | 0] == 127)
                                break r;
                              Ji = _[Ni | 0];
                            }
                            W = W - 4 | 0, Ni = e[W >> 2], e[u >> 2] = mi + 4, e[mi >> 2] = Ni, Ni = Hi + 1 | 0;
                            continue;
                          }
                          break;
                        }
                        W = e[u >> 2];
                      }
                      hf(Us, W);
                    }
                    _n = _n + 1 | 0;
                    continue;
                  }
                  break;
                }
              }
              function Ig(r, s, u, A, m, p, N, W, Te, Xe, fr, ar, vr, _r, hi) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0, m = m | 0, p = p | 0, N = N | 0, W = W | 0, Te = Te | 0, Xe = Xe | 0, fr = fr | 0, ar = ar | 0, vr = vr | 0, _r = _r | 0, hi = hi | 0;
                var mi = 0, Ni = 0, Hi = 0, Ji = 0, Ln = 0, _n = 0, hs = 0, bs = 0, Us = 0;
                for (e[u >> 2] = r, bs = A & 512; ; ) {
                  if ((_n | 0) == 4)
                    m = me[_r + 11 | 0], ((m & 128) >>> 7 | 0 ? e[_r + 4 >> 2] : m & 127) >>> 0 > 1 && (e[u >> 2] = aA(Jd(Ga(_r), 1), Bu(_r), e[u >> 2])), A = A & 176, (A | 0) != 16 && ((A | 0) == 32 && (r = e[u >> 2]), e[s >> 2] = r);
                  else {
                    e: {
                      t:
                        switch (_[Te + _n | 0]) {
                          case 0:
                            e[s >> 2] = e[u >> 2];
                            break e;
                          case 1:
                            e[s >> 2] = e[u >> 2], mi = xi[e[e[N >> 2] + 28 >> 2]](N, 32) | 0, Ni = e[u >> 2], e[u >> 2] = Ni + 1, _[Ni | 0] = mi;
                            break e;
                          case 3:
                            if (mi = me[_r + 11 | 0], Ni = (mi & 128) >>> 7 | 0, !(Ni ? e[_r + 4 >> 2] : mi & 127))
                              break e;
                            mi = me[(Ni ? e[_r >> 2] : _r) | 0], Ni = e[u >> 2], e[u >> 2] = Ni + 1, _[Ni | 0] = mi;
                            break e;
                          case 2:
                            if (!bs || (mi = me[vr + 11 | 0], !((mi & 128) >>> 7 | 0 ? e[vr + 4 >> 2] : mi & 127)))
                              break e;
                            e[u >> 2] = aA(Ga(vr), Bu(vr), e[u >> 2]);
                            break e;
                          case 4:
                            break t;
                          default:
                            break e;
                        }
                      for (Ni = e[N + 8 >> 2], Us = e[u >> 2], m = m + W | 0, Hi = m; ; ) {
                        t: {
                          if (p >>> 0 <= Hi >>> 0 || (mi = _[Hi | 0], (mi | 0) >= 0 ? mi = (e[Ni + ((mi & 255) << 2) >> 2] & 64) != 0 : mi = 0, !mi))
                            break t;
                          Hi = Hi + 1 | 0;
                          continue;
                        }
                        break;
                      }
                      if (mi = hi, (mi | 0) > 0) {
                        for (; ; ) {
                          if (!(!mi | m >>> 0 >= Hi >>> 0)) {
                            mi = mi - 1 | 0, Hi = Hi - 1 | 0, Ni = me[Hi | 0], Ji = e[u >> 2], e[u >> 2] = Ji + 1, _[Ji | 0] = Ni;
                            continue;
                          }
                          break;
                        }
                        for (mi ? Ni = xi[e[e[N >> 2] + 28 >> 2]](N, 48) | 0 : Ni = 0; ; ) {
                          if (Ji = e[u >> 2], e[u >> 2] = Ji + 1, (mi | 0) > 0) {
                            _[Ji | 0] = Ni, mi = mi - 1 | 0;
                            continue;
                          }
                          break;
                        }
                        _[Ji | 0] = Xe;
                      }
                      t: {
                        if ((m | 0) == (Hi | 0)) {
                          mi = xi[e[e[N >> 2] + 28 >> 2]](N, 48) | 0, Ni = e[u >> 2], e[u >> 2] = Ni + 1, _[Ni | 0] = mi;
                          break t;
                        }
                        for (Ni = -1, mi = me[ar + 11 | 0], Ji = mi & 127, mi = (mi & 128) >>> 7 | 0, (mi ? e[ar + 4 >> 2] : Ji) && (Ni = _[(mi ? e[ar >> 2] : ar) | 0]), mi = 0, Ln = 0; ; ) {
                          if ((m | 0) == (Hi | 0))
                            break t;
                          r: {
                            if ((mi | 0) != (Ni | 0)) {
                              Ji = mi;
                              break r;
                            }
                            if (Ni = e[u >> 2], e[u >> 2] = Ni + 1, _[Ni | 0] = fr, Ji = 0, Ln = Ln + 1 | 0, Ni = me[ar + 11 | 0], Ln >>> 0 >= ((Ni & 128) >>> 7 | 0 ? e[ar + 4 >> 2] : Ni & 127) >>> 0) {
                              Ni = mi;
                              break r;
                            }
                            if (Ni = -1, mi = ((me[ar + 11 | 0] & 128) >>> 7 | 0 ? e[ar >> 2] : ar) + Ln | 0, me[mi | 0] == 127)
                              break r;
                            Ni = _[mi | 0];
                          }
                          Hi = Hi - 1 | 0, mi = me[Hi | 0], hs = e[u >> 2], e[u >> 2] = hs + 1, _[hs | 0] = mi, mi = Ji + 1 | 0;
                        }
                      }
                      du(Us, e[u >> 2]);
                    }
                    _n = _n + 1 | 0;
                    continue;
                  }
                  break;
                }
              }
              function mg(r, s, u, A, m, p, N, W) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0, m = m | 0, p = p | 0, N = N | 0, W = W | 0;
                var Te = 0, Xe = 0, fr = 0, ar = 0, vr = 0, _r = 0, hi = 0, mi = 0, Ni = 0, Hi = 0, Ji = 0, Ln = 0, _n = 0, hs = 0;
                for (Hi = Jr - 16 | 0, Jr = Hi, Xe = u; ; ) {
                  e: {
                    if ((A | 0) == (Xe | 0)) {
                      Xe = A;
                      break e;
                    }
                    if (!me[Xe | 0])
                      break e;
                    Xe = Xe + 1 | 0;
                    continue;
                  }
                  break;
                }
                for (e[W >> 2] = p, e[m >> 2] = u; ; ) {
                  e: {
                    t: {
                      r: {
                        if ((u | 0) == (A | 0) | (p | 0) == (N | 0))
                          break r;
                        Te = e[s + 4 >> 2], e[Hi + 8 >> 2] = e[s >> 2], e[Hi + 12 >> 2] = Te, Ji = Jr - 16 | 0, Jr = Ji, hs = Uu(Ji + 12 | 0, e[r + 8 >> 2]), vr = Xe - u | 0, fr = 0, _r = 0, hi = Jr - 1040 | 0, Jr = hi, Ni = e[m >> 2], e[hi + 12 >> 2] = Ni, mi = p || hi + 16 | 0, ar = p ? N - p >> 2 : 256;
                        i: {
                          n: {
                            s: {
                              if (!(!Ni | !ar)) {
                                for (; ; ) {
                                  if (Te = vr >>> 2 | 0, !(vr >>> 0 > 131 | Te >>> 0 >= ar >>> 0)) {
                                    Te = Ni;
                                    break n;
                                  }
                                  if (Ln = mh(mi, hi + 12 | 0, Te >>> 0 < ar >>> 0 ? Te : ar, s), Te = e[hi + 12 >> 2], (Ln | 0) == -1) {
                                    ar = 0, fr = -1;
                                    break s;
                                  }
                                  if (_n = (hi + 16 | 0) != (mi | 0) ? Ln : 0, ar = ar - _n | 0, mi = (_n << 2) + mi | 0, vr = Te ? (vr + Ni | 0) - Te | 0 : 0, fr = fr + Ln | 0, !Te)
                                    break s;
                                  if (Ni = Te, !ar)
                                    break;
                                }
                                break s;
                              }
                              Te = Ni;
                            }
                            if (!Te)
                              break i;
                          }
                          if (!(!ar | !vr)) {
                            for (_r = Te, Te = fr; ; ) {
                              n: {
                                fr = dl(mi, _r, vr, s);
                                s: {
                                  if (fr + 2 >>> 0 <= 2) {
                                    a:
                                      switch (fr + 1 | 0) {
                                        case 1:
                                          _r = 0;
                                          break s;
                                        case 0:
                                          break i;
                                        default:
                                          break a;
                                      }
                                    e[s >> 2] = 0;
                                    break s;
                                  }
                                  if (_r = fr + _r | 0, e[hi + 12 >> 2] = _r, Te = Te + 1 | 0, ar = ar - 1 | 0, ar)
                                    break n;
                                }
                                fr = Te;
                                break i;
                              }
                              if (mi = mi + 4 | 0, vr = vr - fr | 0, fr = Te, !vr)
                                break;
                            }
                            break i;
                          }
                          _r = Te;
                        }
                        p && (e[m >> 2] = _r), Jr = hi + 1040 | 0, Te = e[hs >> 2], Te && (e[6178] = (Te | 0) == -1 ? 24816 : Te), Jr = Ji + 16 | 0;
                        i: {
                          n: {
                            s: {
                              a: {
                                if ((fr | 0) == -1) {
                                  for (; ; ) {
                                    o: {
                                      if (e[W >> 2] = p, e[m >> 2] == (u | 0))
                                        break o;
                                      N = 1;
                                      l: {
                                        c: {
                                          d:
                                            switch (s = h1(p, u, Xe - u | 0, Hi + 8 | 0, e[r + 8 >> 2]), s + 2 | 0) {
                                              case 0:
                                                break n;
                                              case 2:
                                                break l;
                                              case 1:
                                                break d;
                                              default:
                                                break c;
                                            }
                                          e[m >> 2] = u;
                                          break a;
                                        }
                                        N = s;
                                      }
                                      u = u + N | 0, p = e[W >> 2] + 4 | 0;
                                      continue;
                                    }
                                    break;
                                  }
                                  e[m >> 2] = u;
                                  break r;
                                }
                                if (p = e[W >> 2] + (fr << 2) | 0, e[W >> 2] = p, (p | 0) == (N | 0))
                                  break i;
                                if (u = e[m >> 2], (A | 0) == (Xe | 0)) {
                                  Xe = A;
                                  continue;
                                }
                                if (!h1(p, u, 1, s, e[r + 8 >> 2]))
                                  break s;
                              }
                              r = 2;
                              break t;
                            }
                            for (e[W >> 2] = e[W >> 2] + 4, u = e[m >> 2] + 1 | 0, e[m >> 2] = u, Xe = u; ; ) {
                              if ((A | 0) == (Xe | 0)) {
                                Xe = A;
                                break e;
                              }
                              if (!me[Xe | 0])
                                break e;
                              Xe = Xe + 1 | 0;
                            }
                          }
                          e[m >> 2] = u, r = 1;
                          break t;
                        }
                        u = e[m >> 2];
                      }
                      r = (u | 0) != (A | 0);
                    }
                    return Jr = Hi + 16 | 0, r | 0;
                  }
                  p = e[W >> 2];
                }
              }
              function rl(r, s, u, A, m, p, N) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0, m = m | 0, p = p | 0, N = N | 0;
                var W = 0, Te = 0, Xe = 0, fr = 0, ar = 0, vr = 0, _r = 0, hi = 0, mi = 0, Ni = 0, Hi = 0, Ji = 0;
                Xe = Jr - 128 | 0, Jr = Xe, e[Xe + 124 >> 2] = s, e[Xe + 4 >> 2] = 184, s = Xe + 8 | 0, e[s >> 2] = 0, e[s + 4 >> 2] = e[Xe + 4 >> 2], hi = s, fr = Xe + 16 | 0, ar = (A - u | 0) / 12 | 0;
                e: {
                  t: {
                    if (ar >>> 0 >= 101) {
                      if (fr = da(ar), !fr) {
                        if (e[5996] = 0, Nn(185), r = e[5996], e[5996] = 0, (r | 0) != 1)
                          break e;
                        break t;
                      }
                      ia(hi, fr);
                    }
                    W = fr, s = u;
                    r: {
                      i: {
                        for (; ; ) {
                          if ((s | 0) == (A | 0))
                            n: for (; ; ) {
                              s: {
                                if (e[5996] = 0, W = pi(186, r | 0, Xe + 124 | 0) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1)
                                  break s;
                                if ((!ar | W) == 1) {
                                  if (e[5996] = 0, s = pi(186, r | 0, Xe + 124 | 0) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1)
                                    break r;
                                  if (!s)
                                    break i;
                                  e[p >> 2] = e[p >> 2] | 2;
                                  break i;
                                }
                                s = e[r >> 2], e[5996] = 0, mi = Mi(187, s | 0) | 0, s = e[5996], e[5996] = 0;
                                a: {
                                  if ((s | 0) != 1 && (N || (e[5996] = 0, mi = pi(188, m | 0, mi | 0) | 0, s = e[5996], e[5996] = 0, (s | 0) != 1)))
                                    break a;
                                  break t;
                                }
                                for (Te = Ni + 1 | 0, Ji = 0, W = fr, s = u; ; ) {
                                  if ((s | 0) == (A | 0)) {
                                    if (Ni = Te, !Ji)
                                      continue n;
                                    if (e[5996] = 0, Mi(189, r | 0) | 0, s = e[5996], e[5996] = 0, (s | 0) != 1) {
                                      if (W = fr, s = u, ar + vr >>> 0 < 2)
                                        continue n;
                                      for (; ; ) {
                                        if ((s | 0) == (A | 0))
                                          continue n;
                                        a: {
                                          if (me[W | 0] != 2 || (Te = me[s + 11 | 0], (((Te & 128) >>> 7 | 0 ? e[s + 4 >> 2] : Te & 127) | 0) == (Ni | 0)))
                                            break a;
                                          _[W | 0] = 0, vr = vr - 1 | 0;
                                        }
                                        W = W + 1 | 0, s = s + 12 | 0;
                                      }
                                    }
                                    break t;
                                  }
                                  a: {
                                    if (me[W | 0] != 1)
                                      break a;
                                    Hi = me[((me[s + 11 | 0] & 128) >>> 7 | 0 ? e[s >> 2] : s) + Ni | 0];
                                    o: {
                                      if (N || (e[5996] = 0, Hi = pi(188, m | 0, Hi << 24 >> 24) | 0, _r = e[5996], e[5996] = 0, (_r | 0) != 1))
                                        break o;
                                      break t;
                                    }
                                    o: {
                                      if ((mi & 255) == (Hi & 255)) {
                                        if (Ji = 1, _r = me[s + 11 | 0], (Te | 0) != (((_r & 128) >>> 7 | 0 ? e[s + 4 >> 2] : _r & 127) | 0))
                                          break a;
                                        _[W | 0] = 2, vr = vr + 1 | 0;
                                        break o;
                                      }
                                      _[W | 0] = 0;
                                    }
                                    ar = ar - 1 | 0;
                                  }
                                  W = W + 1 | 0, s = s + 12 | 0;
                                }
                              }
                              break;
                            }
                          else {
                            Te = me[s + 11 | 0], Te = !((Te & 128) >>> 7 | 0 ? e[s + 4 >> 2] : Te & 127), _[W | 0] = Te ? 2 : 1, vr = Te + vr | 0, ar = ar - Te | 0, W = W + 1 | 0, s = s + 12 | 0;
                            continue;
                          }
                          break;
                        }
                        break t;
                      }
                      i: {
                        n: {
                          for (; ; ) {
                            if ((u | 0) == (A | 0))
                              break n;
                            if (me[fr | 0] != 2) {
                              fr = fr + 1 | 0, u = u + 12 | 0;
                              continue;
                            }
                            break;
                          }
                          A = u;
                          break i;
                        }
                        e[p >> 2] = e[p >> 2] | 4;
                      }
                      return to(hi), Jr = Xe + 128 | 0, A | 0;
                    }
                  }
                  r = Hr() | 0, to(hi), Jn(r | 0);
                }
                Oi();
              }
              function il(r, s, u, A, m, p, N) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0, m = m | 0, p = p | 0, N = N | 0;
                var W = 0, Te = 0, Xe = 0, fr = 0, ar = 0, vr = 0, _r = 0, hi = 0, mi = 0, Ni = 0, Hi = 0, Ji = 0;
                Xe = Jr - 128 | 0, Jr = Xe, e[Xe + 124 >> 2] = s, e[Xe + 4 >> 2] = 184, s = Xe + 8 | 0, e[s >> 2] = 0, e[s + 4 >> 2] = e[Xe + 4 >> 2], hi = s, fr = Xe + 16 | 0, ar = (A - u | 0) / 12 | 0;
                e: {
                  t: {
                    if (ar >>> 0 >= 101) {
                      if (fr = da(ar), !fr) {
                        if (e[5996] = 0, Nn(185), r = e[5996], e[5996] = 0, (r | 0) != 1)
                          break e;
                        break t;
                      }
                      ia(hi, fr);
                    }
                    W = fr, s = u;
                    r: {
                      i: {
                        for (; ; ) {
                          if ((s | 0) == (A | 0))
                            n: for (; ; ) {
                              s: {
                                if (e[5996] = 0, W = pi(202, r | 0, Xe + 124 | 0) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1)
                                  break s;
                                if ((!ar | W) == 1) {
                                  if (e[5996] = 0, s = pi(202, r | 0, Xe + 124 | 0) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1)
                                    break r;
                                  if (!s)
                                    break i;
                                  e[p >> 2] = e[p >> 2] | 2;
                                  break i;
                                }
                                s = e[r >> 2], e[5996] = 0, mi = Mi(203, s | 0) | 0, s = e[5996], e[5996] = 0;
                                a: {
                                  if ((s | 0) != 1 && (N || (e[5996] = 0, mi = pi(204, m | 0, mi | 0) | 0, s = e[5996], e[5996] = 0, (s | 0) != 1)))
                                    break a;
                                  break t;
                                }
                                for (Te = Ni + 1 | 0, Ji = 0, W = fr, s = u; ; ) {
                                  if ((s | 0) == (A | 0)) {
                                    if (Ni = Te, !Ji)
                                      continue n;
                                    if (e[5996] = 0, Mi(205, r | 0) | 0, s = e[5996], e[5996] = 0, (s | 0) != 1) {
                                      if (W = fr, s = u, ar + vr >>> 0 < 2)
                                        continue n;
                                      for (; ; ) {
                                        if ((s | 0) == (A | 0))
                                          continue n;
                                        a: {
                                          if (me[W | 0] != 2 || (Te = me[s + 11 | 0], (((Te & 128) >>> 7 | 0 ? e[s + 4 >> 2] : Te & 127) | 0) == (Ni | 0)))
                                            break a;
                                          _[W | 0] = 0, vr = vr - 1 | 0;
                                        }
                                        W = W + 1 | 0, s = s + 12 | 0;
                                      }
                                    }
                                    break t;
                                  }
                                  a: {
                                    if (me[W | 0] != 1)
                                      break a;
                                    Hi = e[(Ni << 2) + ((me[s + 11 | 0] & 128) >>> 7 | 0 ? e[s >> 2] : s) >> 2];
                                    o: {
                                      if (N || (e[5996] = 0, Hi = pi(204, m | 0, Hi | 0) | 0, _r = e[5996], e[5996] = 0, (_r | 0) != 1))
                                        break o;
                                      break t;
                                    }
                                    o: {
                                      if ((mi | 0) == (Hi | 0)) {
                                        if (Ji = 1, _r = me[s + 11 | 0], (Te | 0) != (((_r & 128) >>> 7 | 0 ? e[s + 4 >> 2] : _r & 127) | 0))
                                          break a;
                                        _[W | 0] = 2, vr = vr + 1 | 0;
                                        break o;
                                      }
                                      _[W | 0] = 0;
                                    }
                                    ar = ar - 1 | 0;
                                  }
                                  W = W + 1 | 0, s = s + 12 | 0;
                                }
                              }
                              break;
                            }
                          else {
                            Te = me[s + 11 | 0], Te = !((Te & 128) >>> 7 | 0 ? e[s + 4 >> 2] : Te & 127), _[W | 0] = Te ? 2 : 1, vr = Te + vr | 0, ar = ar - Te | 0, W = W + 1 | 0, s = s + 12 | 0;
                            continue;
                          }
                          break;
                        }
                        break t;
                      }
                      i: {
                        n: {
                          for (; ; ) {
                            if ((u | 0) == (A | 0))
                              break n;
                            if (me[fr | 0] != 2) {
                              fr = fr + 1 | 0, u = u + 12 | 0;
                              continue;
                            }
                            break;
                          }
                          A = u;
                          break i;
                        }
                        e[p >> 2] = e[p >> 2] | 4;
                      }
                      return to(hi), Jr = Xe + 128 | 0, A | 0;
                    }
                  }
                  r = Hr() | 0, to(hi), Jn(r | 0);
                }
                Oi();
              }
              function wg(r, s, u, A, m, p, N) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0, m = m | 0, p = p | 0, N = N | 0;
                var W = 0, Te = 0, Xe = 0, fr = 0;
                W = Jr - 624 | 0, Jr = W, e[W + 616 >> 2] = u, e[W + 620 >> 2] = s, e[W + 16 >> 2] = 220, Te = W + 200 | 0, e[Te >> 2] = W + 208, r = W + 16 | 0, e[Te + 4 >> 2] = e[r >> 2], Xe = W + 192 | 0, s = e[m + 28 >> 2], e[Xe >> 2] = s, e[s + 4 >> 2] = e[s + 4 >> 2] + 1, e[5996] = 0, fr = Mi(197, e[W + 192 >> 2]) | 0, s = e[5996], e[5996] = 0;
                e: {
                  t: {
                    r: {
                      i: {
                        n: {
                          s: {
                            a: {
                              if ((s | 0) != 1) {
                                if (_[W + 191 | 0] = 0, s = e[m + 4 >> 2], e[5996] = 0, s = pc(228, W + 620 | 0, u | 0, A | 0, Xe | 0, s | 0, p | 0, W + 191 | 0, fr | 0, Te | 0, W + 196 | 0, W + 608 | 0) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1)
                                  break i;
                                if (!s)
                                  break n;
                                if (s = me[3833] | me[3834] << 8 | (me[3835] << 16 | me[3836] << 24), _[W + 183 | 0] = s, _[W + 184 | 0] = s >>> 8, _[W + 185 | 0] = s >>> 16, _[W + 186 | 0] = s >>> 24, s = me[3830] | me[3831] << 8 | (me[3832] << 16 | me[3833] << 24), e[W + 176 >> 2] = me[3826] | me[3827] << 8 | (me[3828] << 16 | me[3829] << 24), e[W + 180 >> 2] = s, e[5996] = 0, Vs(208, fr | 0, W + 176 | 0, W + 186 | 0, W + 128 | 0), s = e[5996], e[5996] = 0, (s | 0) == 1)
                                  break a;
                                if (e[W + 4 >> 2] = 184, A = W + 8 | 0, e[A >> 2] = 0, e[A + 4 >> 2] = e[W + 4 >> 2], m = r, s = e[W + 196 >> 2], r = s - e[Te >> 2] | 0, (r | 0) < 393 || (ia(A, da((r >> 2) + 2 | 0)), m = e[A >> 2], m))
                                  break s;
                                if (e[5996] = 0, Nn(185), r = e[5996], e[5996] = 0, (r | 0) == 1)
                                  break r;
                                break e;
                              }
                              u = Hr() | 0;
                              break t;
                            }
                            u = Hr() | 0;
                            break t;
                          }
                          for (me[W + 191 | 0] && (_[m | 0] = 45, m = m + 1 | 0), u = e[Te >> 2]; ; ) {
                            if (s >>> 0 <= u >>> 0) {
                              if (_[m | 0] = 0, e[W >> 2] = N, (Xd(W + 16 | 0, W) | 0) != 1) {
                                if (e[5996] = 0, qo(222, 1730), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                  break e;
                                break r;
                              }
                              to(A);
                            } else {
                              r = W + 128 | 0, _[m | 0] = me[(W + 176 | 0) + (Gd(r, r + 40 | 0, e[u >> 2]) - r >> 2) | 0], m = m + 1 | 0, u = u + 4 | 0, s = e[W + 196 >> 2];
                              continue;
                            }
                            break;
                          }
                        }
                        if (e[5996] = 0, r = pi(202, W + 620 | 0, W + 616 | 0) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1)
                          break i;
                        return r && (e[p >> 2] = e[p >> 2] | 2), u = e[W + 620 >> 2], r = e[W + 192 >> 2], s = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = s, (s | 0) == -1 && xi[e[e[r >> 2] + 8 >> 2]](r), to(Te), Jr = W + 624 | 0, u | 0;
                      }
                      u = Hr() | 0;
                      break t;
                    }
                    u = Hr() | 0, to(A);
                  }
                  r = e[W + 192 >> 2], s = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = s, (s | 0) == -1 && xi[e[e[r >> 2] + 8 >> 2]](r), to(Te), Jn(u | 0), Oi();
                }
                Oi();
              }
              function Eg(r, s) {
                r = r | 0, s = s | 0;
                var u = 0, A = 0, m = 0, p = 0, N = 0, W = 0, Te = 0, Xe = 0;
                if (m = e[r + 4 >> 2], u = e[r >> 2], A = m - u >> 2, A >>> 0 < s >>> 0) {
                  W = Jr - 32 | 0, Jr = W, p = s - A | 0;
                  e: {
                    if (p >>> 0 <= e[r + 8 >> 2] - m >> 2 >>> 0) {
                      Od(r, p);
                      break e;
                    }
                    N = r + 16 | 0, A = W + 12 | 0, u = Jr - 16 | 0, Jr = u, m = p + (m - e[r >> 2] >> 2) | 0, e[u + 12 >> 2] = m;
                    t: {
                      if (s = $f(), m >>> 0 <= s >>> 0) {
                        m = e[r + 8 >> 2] - e[r >> 2] >> 2, m >>> 0 < s >>> 1 >>> 0 && (e[u + 8 >> 2] = m << 1, s = e[(Ls[u + 8 >> 2] < Ls[u + 12 >> 2] ? u + 12 | 0 : u + 8 | 0) >> 2]), Jr = u + 16 | 0;
                        break t;
                      }
                      Jo(), Oi();
                    }
                    Te = e[r + 4 >> 2] - e[r >> 2] >> 2, m = Jr - 16 | 0, Jr = m, e[A + 12 >> 2] = 0, e[A + 16 >> 2] = N;
                    t: {
                      if (!s) {
                        u = 0, s = 0;
                        break t;
                      }
                      p4(m + 8 | 0, e[A + 16 >> 2], s), u = e[m + 8 >> 2], s = e[m + 12 >> 2];
                    }
                    for (e[A >> 2] = u, N = u + (Te << 2) | 0, e[A + 8 >> 2] = N, e[A + 4 >> 2] = N, e[A + 12 >> 2] = u + (s << 2), Jr = m + 16 | 0, u = Jr - 16 | 0, Jr = u, e[u + 4 >> 2] = e[A + 8 >> 2], s = e[A + 8 >> 2], e[u + 12 >> 2] = A + 8, e[u + 8 >> 2] = s + (p << 2), s = e[u + 4 >> 2]; ; ) {
                      if (e[u + 8 >> 2] != (s | 0)) {
                        e[s >> 2] = 0, s = e[u + 4 >> 2] + 4 | 0, e[u + 4 >> 2] = s;
                        continue;
                      }
                      break;
                    }
                    for (e[e[u + 12 >> 2] >> 2] = e[u + 4 >> 2], Jr = u + 16 | 0, m = Jr - 16 | 0, Jr = m, e[m + 12 >> 2] = e[r + 4 >> 2], e[m + 8 >> 2] = e[r >> 2], e[m + 4 >> 2] = e[A + 4 >> 2], p = e[m + 12 >> 2], Te = e[m + 4 >> 2], N = Jr - 16 | 0, Jr = N, s = Jr - 32 | 0, Jr = s, u = Jr - 16 | 0, Jr = u, e[u + 12 >> 2] = e[m + 8 >> 2], e[s + 24 >> 2] = p, e[s + 28 >> 2] = e[u + 12 >> 2], Jr = u + 16 | 0, p = e[s + 24 >> 2], Xe = e[s + 28 >> 2], u = Jr - 16 | 0, Jr = u, e[u + 8 >> 2] = Te, e[u + 12 >> 2] = p; ; ) {
                      if ((p | 0) != (Xe | 0)) {
                        e[e[u + 8 >> 2] - 4 >> 2] = e[p - 4 >> 2], e[u + 12 >> 2] = e[u + 12 >> 2] - 4, e[u + 8 >> 2] = e[u + 8 >> 2] - 4, p = e[u + 12 >> 2];
                        continue;
                      }
                      break;
                    }
                    for (e[s + 16 >> 2] = p, e[s + 20 >> 2] = e[u + 8 >> 2], Jr = u + 16 | 0, u = e[s + 16 >> 2], e[s + 12 >> 2] = e[s + 20 >> 2], e[N + 8 >> 2] = u, e[N + 12 >> 2] = e[s + 12 >> 2], Jr = s + 32 | 0, Jr = N + 16 | 0, e[A + 4 >> 2] = e[N + 12 >> 2], s = e[r >> 2], e[r >> 2] = e[A + 4 >> 2], e[A + 4 >> 2] = s, s = e[r + 4 >> 2], e[r + 4 >> 2] = e[A + 8 >> 2], e[A + 8 >> 2] = s, s = e[r + 8 >> 2], e[r + 8 >> 2] = e[A + 12 >> 2], e[A + 12 >> 2] = s, e[A >> 2] = e[A + 4 >> 2], Jr = m + 16 | 0, s = e[A + 4 >> 2], r = e[A + 8 >> 2]; ; ) {
                      if ((r | 0) != (s | 0)) {
                        r = r - 4 | 0, e[A + 8 >> 2] = r;
                        continue;
                      }
                      break;
                    }
                    r = e[A >> 2], r && Zd(e[A + 16 >> 2], r);
                  }
                  Jr = W + 32 | 0;
                  return;
                }
                s >>> 0 < A >>> 0 && y4(r, u + (s << 2) | 0);
              }
              function Zl(r, s, u, A, m, p, N) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0, m = m | 0, p = p | 0, N = N | 0;
                var W = 0, Te = 0, Xe = 0, fr = 0;
                W = Jr - 272 | 0, Jr = W, e[W + 264 >> 2] = u, e[W + 268 >> 2] = s, e[W + 16 >> 2] = 220, Te = W + 152 | 0, e[Te >> 2] = W + 160, r = W + 16 | 0, e[Te + 4 >> 2] = e[r >> 2], Xe = W + 144 | 0, s = e[m + 28 >> 2], e[Xe >> 2] = s, e[s + 4 >> 2] = e[s + 4 >> 2] + 1, e[5996] = 0, fr = Mi(170, e[W + 144 >> 2]) | 0, s = e[5996], e[5996] = 0;
                e: {
                  t: {
                    r: {
                      i: {
                        n: {
                          s: {
                            a: {
                              if ((s | 0) != 1) {
                                if (_[W + 143 | 0] = 0, s = e[m + 4 >> 2], e[5996] = 0, s = pc(221, W + 268 | 0, u | 0, A | 0, Xe | 0, s | 0, p | 0, W + 143 | 0, fr | 0, Te | 0, W + 148 | 0, W + 260 | 0) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1)
                                  break i;
                                if (!s)
                                  break n;
                                if (s = me[3833] | me[3834] << 8 | (me[3835] << 16 | me[3836] << 24), _[W + 135 | 0] = s, _[W + 136 | 0] = s >>> 8, _[W + 137 | 0] = s >>> 16, _[W + 138 | 0] = s >>> 24, s = me[3830] | me[3831] << 8 | (me[3832] << 16 | me[3833] << 24), e[W + 128 >> 2] = me[3826] | me[3827] << 8 | (me[3828] << 16 | me[3829] << 24), e[W + 132 >> 2] = s, e[5996] = 0, Vs(195, fr | 0, W + 128 | 0, W + 138 | 0, W + 118 | 0), s = e[5996], e[5996] = 0, (s | 0) == 1)
                                  break a;
                                if (e[W + 4 >> 2] = 184, A = W + 8 | 0, e[A >> 2] = 0, e[A + 4 >> 2] = e[W + 4 >> 2], m = r, s = e[W + 148 >> 2], r = s - e[Te >> 2] | 0, (r | 0) < 99 || (ia(A, da(r + 2 | 0)), m = e[A >> 2], m))
                                  break s;
                                if (e[5996] = 0, Nn(185), r = e[5996], e[5996] = 0, (r | 0) == 1)
                                  break r;
                                break e;
                              }
                              u = Hr() | 0;
                              break t;
                            }
                            u = Hr() | 0;
                            break t;
                          }
                          for (me[W + 143 | 0] && (_[m | 0] = 45, m = m + 1 | 0), u = e[Te >> 2]; ; ) {
                            if (s >>> 0 <= u >>> 0) {
                              if (_[m | 0] = 0, e[W >> 2] = N, (Xd(W + 16 | 0, W) | 0) != 1) {
                                if (e[5996] = 0, qo(222, 1730), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                  break e;
                                break r;
                              }
                              to(A);
                            } else {
                              r = W + 118 | 0, _[m | 0] = me[((Vd(r, r + 10 | 0, me[u | 0]) - W | 0) + W | 0) + 10 | 0], m = m + 1 | 0, u = u + 1 | 0, s = e[W + 148 >> 2];
                              continue;
                            }
                            break;
                          }
                        }
                        if (e[5996] = 0, r = pi(186, W + 268 | 0, W + 264 | 0) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1)
                          break i;
                        return r && (e[p >> 2] = e[p >> 2] | 2), u = e[W + 268 >> 2], r = e[W + 144 >> 2], s = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = s, (s | 0) == -1 && xi[e[e[r >> 2] + 8 >> 2]](r), to(Te), Jr = W + 272 | 0, u | 0;
                      }
                      u = Hr() | 0;
                      break t;
                    }
                    u = Hr() | 0, to(A);
                  }
                  r = e[W + 144 >> 2], s = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = s, (s | 0) == -1 && xi[e[e[r >> 2] + 8 >> 2]](r), to(Te), Jn(u | 0), Oi();
                }
                Oi();
              }
              function $l(r, s, u, A, m, p) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0, m = m | 0, p = p | 0;
                var N = 0, W = 0, Te = 0;
                A = e[A + 28 >> 2], r = Jr - 272 | 0, Jr = r, e[r + 264 >> 2] = u, e[r + 268 >> 2] = s, pd(r + 208 | 0, A, r + 224 | 0, r + 223 | 0, r + 222 | 0), A = r + 196 | 0, e[A >> 2] = 0, e[A + 4 >> 2] = 0, e[A + 8 >> 2] = 0, s = (me[A + 11 | 0] & 128) >>> 7 | 0 ? (e[A + 8 >> 2] & 2147483647) - 1 | 0 : 10, e[5996] = 0, ji(172, A | 0, s | 0), s = e[5996], e[5996] = 0;
                e: {
                  t: {
                    r: {
                      if ((s | 0) != 1) {
                        for (u = (me[A + 11 | 0] & 128) >>> 7 | 0 ? e[A >> 2] : A, e[r + 192 >> 2] = u, e[r + 28 >> 2] = r + 32, e[r + 24 >> 2] = 0, _[r + 23 | 0] = 1, _[r + 22 | 0] = 69, N = me[r + 222 | 0] << 24 >> 24, Te = me[r + 223 | 0] << 24 >> 24; ; ) {
                          i: {
                            if (e[5996] = 0, s = pi(186, r + 268 | 0, r + 264 | 0) | 0, W = e[5996], e[5996] = 0, (W | 0) == 1)
                              break i;
                            if (s)
                              break r;
                            if (s = me[A + 11 | 0], s = (s & 128) >>> 7 | 0 ? e[A + 4 >> 2] : s & 127, e[r + 192 >> 2] == (s + u | 0)) {
                              if (e[5996] = 0, ji(172, A | 0, s << 1), u = e[5996], e[5996] = 0, (u | 0) == 1 || (u = (me[A + 11 | 0] & 128) >>> 7 | 0 ? (e[A + 8 >> 2] & 2147483647) - 1 | 0 : 10, e[5996] = 0, ji(172, A | 0, u | 0), u = e[5996], e[5996] = 0, (u | 0) == 1))
                                break t;
                              u = (me[A + 11 | 0] & 128) >>> 7 | 0 ? e[A >> 2] : A, e[r + 192 >> 2] = s + u;
                            }
                            if (e[5996] = 0, s = Mi(187, e[r + 268 >> 2]) | 0, W = e[5996], e[5996] = 0, (W | 0) == 1)
                              break i;
                            if (Bc(s, r + 23 | 0, r + 22 | 0, u, r + 192 | 0, Te, N, r + 208 | 0, r + 32 | 0, r + 28 | 0, r + 24 | 0, r + 224 | 0))
                              break r;
                            if (e[5996] = 0, Mi(189, r + 268 | 0) | 0, s = e[5996], e[5996] = 0, (s | 0) != 1)
                              continue;
                          }
                          break;
                        }
                        break t;
                      }
                      break t;
                    }
                    s = me[r + 219 | 0];
                    r: {
                      if (!((s & 128) >>> 7 | 0 ? e[r + 212 >> 2] : s & 127) | !me[r + 23 | 0] || (s = e[r + 28 >> 2], (s - (r + 32 | 0) | 0) > 159))
                        break r;
                      e[r + 28 >> 2] = s + 4, e[s >> 2] = e[r + 24 >> 2];
                    }
                    if (Sh(r, u, e[r + 192 >> 2], m), s = e[r >> 2], u = e[r + 4 >> 2], N = e[r + 12 >> 2], e[p + 8 >> 2] = e[r + 8 >> 2], e[p + 12 >> 2] = N, e[p >> 2] = s, e[p + 4 >> 2] = u, ka(r + 208 | 0, r + 32 | 0, e[r + 28 >> 2], m), e[5996] = 0, s = pi(186, r + 268 | 0, r + 264 | 0) | 0, u = e[5996], e[5996] = 0, (u | 0) != 1) {
                      s && (e[m >> 2] = e[m >> 2] | 2), s = e[r + 268 >> 2], Qn(A), Qn(r + 208 | 0), Jr = r + 272 | 0;
                      break e;
                    }
                  }
                  s = Hr() | 0, Qn(A), Qn(r + 208 | 0), Jn(s | 0), Oi();
                }
                return s | 0;
              }
              function bg(r, s, u, A, m, p) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0, m = m | 0, p = p | 0;
                var N = 0, W = 0, Te = 0;
                A = e[A + 28 >> 2], r = Jr - 384 | 0, Jr = r, e[r + 376 >> 2] = u, e[r + 380 >> 2] = s, gd(r + 220 | 0, A, r + 240 | 0, r + 236 | 0, r + 232 | 0), A = r + 208 | 0, e[A >> 2] = 0, e[A + 4 >> 2] = 0, e[A + 8 >> 2] = 0, s = (me[A + 11 | 0] & 128) >>> 7 | 0 ? (e[A + 8 >> 2] & 2147483647) - 1 | 0 : 10, e[5996] = 0, ji(172, A | 0, s | 0), s = e[5996], e[5996] = 0;
                e: {
                  t: {
                    r: {
                      if ((s | 0) != 1) {
                        for (u = (me[A + 11 | 0] & 128) >>> 7 | 0 ? e[A >> 2] : A, e[r + 204 >> 2] = u, e[r + 28 >> 2] = r + 32, e[r + 24 >> 2] = 0, _[r + 23 | 0] = 1, _[r + 22 | 0] = 69, N = e[r + 232 >> 2], Te = e[r + 236 >> 2]; ; ) {
                          i: {
                            if (e[5996] = 0, s = pi(202, r + 380 | 0, r + 376 | 0) | 0, W = e[5996], e[5996] = 0, (W | 0) == 1)
                              break i;
                            if (s)
                              break r;
                            if (s = me[A + 11 | 0], s = (s & 128) >>> 7 | 0 ? e[A + 4 >> 2] : s & 127, e[r + 204 >> 2] == (s + u | 0)) {
                              if (e[5996] = 0, ji(172, A | 0, s << 1), u = e[5996], e[5996] = 0, (u | 0) == 1 || (u = (me[A + 11 | 0] & 128) >>> 7 | 0 ? (e[A + 8 >> 2] & 2147483647) - 1 | 0 : 10, e[5996] = 0, ji(172, A | 0, u | 0), u = e[5996], e[5996] = 0, (u | 0) == 1))
                                break t;
                              u = (me[A + 11 | 0] & 128) >>> 7 | 0 ? e[A >> 2] : A, e[r + 204 >> 2] = s + u;
                            }
                            if (e[5996] = 0, s = Mi(203, e[r + 380 >> 2]) | 0, W = e[5996], e[5996] = 0, (W | 0) == 1)
                              break i;
                            if (ol(s, r + 23 | 0, r + 22 | 0, u, r + 204 | 0, Te, N, r + 220 | 0, r + 32 | 0, r + 28 | 0, r + 24 | 0, r + 240 | 0))
                              break r;
                            if (e[5996] = 0, Mi(205, r + 380 | 0) | 0, s = e[5996], e[5996] = 0, (s | 0) != 1)
                              continue;
                          }
                          break;
                        }
                        break t;
                      }
                      break t;
                    }
                    s = me[r + 231 | 0];
                    r: {
                      if (!((s & 128) >>> 7 | 0 ? e[r + 224 >> 2] : s & 127) | !me[r + 23 | 0] || (s = e[r + 28 >> 2], (s - (r + 32 | 0) | 0) > 159))
                        break r;
                      e[r + 28 >> 2] = s + 4, e[s >> 2] = e[r + 24 >> 2];
                    }
                    if (Sh(r, u, e[r + 204 >> 2], m), s = e[r >> 2], u = e[r + 4 >> 2], N = e[r + 12 >> 2], e[p + 8 >> 2] = e[r + 8 >> 2], e[p + 12 >> 2] = N, e[p >> 2] = s, e[p + 4 >> 2] = u, ka(r + 220 | 0, r + 32 | 0, e[r + 28 >> 2], m), e[5996] = 0, s = pi(202, r + 380 | 0, r + 376 | 0) | 0, u = e[5996], e[5996] = 0, (u | 0) != 1) {
                      s && (e[m >> 2] = e[m >> 2] | 2), s = e[r + 380 >> 2], Qn(A), Qn(r + 220 | 0), Jr = r + 384 | 0;
                      break e;
                    }
                  }
                  s = Hr() | 0, Qn(A), Qn(r + 220 | 0), Jn(s | 0), Oi();
                }
                return s | 0;
              }
              function Bg(r, s, u, A, m, p, N, W) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0, m = m | 0, p = p | 0, N = N | 0, W = W | 0;
                var Te = 0, Xe = 0, fr = 0, ar = 0, vr = 0, _r = 0;
                _r = s, Te = Jr - 256 | 0, Jr = Te, e[Te + 248 >> 2] = 37, e[Te + 252 >> 2] = 0, s = Te + 248 | 0, ar = Pc(s | 1, 3264, e[u + 4 >> 2]), Xe = Te + 208 | 0, e[Te + 204 >> 2] = Xe, r = ko();
                e: {
                  if (ar) {
                    fr = e[u + 8 >> 2], vr = Te - -64 | 0, e[vr >> 2] = N, e[vr + 4 >> 2] = W, e[Te + 56 >> 2] = m, e[Te + 60 >> 2] = p, e[Te + 48 >> 2] = fr, Xe = oa(Xe, 30, r, s, Te + 48 | 0);
                    break e;
                  }
                  e[Te + 80 >> 2] = m, e[Te + 84 >> 2] = p, e[Te + 88 >> 2] = N, e[Te + 92 >> 2] = W, Xe = oa(Te + 208 | 0, 30, r, Te + 248 | 0, Te + 80 | 0);
                }
                e[Te + 128 >> 2] = 184, fr = Te + 196 | 0, e[fr >> 2] = 0, e[fr + 4 >> 2] = e[Te + 128 >> 2], s = Te + 208 | 0, r = s;
                e: {
                  t: {
                    r: {
                      i: {
                        if ((Xe | 0) >= 30) {
                          r = ko();
                          n: {
                            if (ar) {
                              Xe = e[u + 8 >> 2], e[Te + 16 >> 2] = N, e[Te + 20 >> 2] = W, e[Te + 8 >> 2] = m, e[Te + 12 >> 2] = p, e[Te >> 2] = Xe, Xe = Iu(Te + 204 | 0, r, Te + 248 | 0, Te);
                              break n;
                            }
                            e[Te + 32 >> 2] = m, e[Te + 36 >> 2] = p, e[Te + 40 >> 2] = N, e[Te + 44 >> 2] = W, Xe = Iu(Te + 204 | 0, r, Te + 248 | 0, Te + 32 | 0);
                          }
                          if ((Xe | 0) == -1) {
                            if (e[5996] = 0, Nn(185), r = e[5996], e[5996] = 0, (r | 0) == 1)
                              break r;
                            break i;
                          }
                          r = e[Te + 204 >> 2], ia(fr, r);
                        }
                        N = r + Xe | 0, W = Xa(r, N, e[u + 4 >> 2]), e[Te + 116 >> 2] = 184, m = Te + 120 | 0, e[m >> 2] = 0, e[m + 4 >> 2] = e[Te + 116 >> 2];
                        n: {
                          s: {
                            if ((Te + 208 | 0) == (r | 0)) {
                              Xe = Te + 128 | 0;
                              break s;
                            }
                            if (Xe = da(Xe << 1), !Xe) {
                              if (e[5996] = 0, Nn(185), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                break i;
                              r = Hr() | 0;
                              break n;
                            }
                            ia(m, Xe), s = r;
                          }
                          r = Te + 108 | 0, p = e[u + 28 >> 2], e[r >> 2] = p, e[p + 4 >> 2] = e[p + 4 >> 2] + 1, e[5996] = 0, au(212, s | 0, W | 0, N | 0, Xe | 0, Te + 116 | 0, Te + 112 | 0, r | 0), s = e[5996], e[5996] = 0;
                          s: {
                            if ((s | 0) != 1) {
                              if (r = e[r >> 2], s = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = s, (s | 0) == -1 && xi[e[e[r >> 2] + 8 >> 2]](r), e[5996] = 0, r = za(213, _r | 0, Xe | 0, e[Te + 116 >> 2], e[Te + 112 >> 2], u | 0, A | 0) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1)
                                break s;
                              to(m), to(fr), Jr = Te + 256 | 0;
                              break e;
                            }
                            r = Hr() | 0, s = e[Te + 108 >> 2], u = e[s + 4 >> 2] - 1 | 0, e[s + 4 >> 2] = u, (u | 0) == -1 && xi[e[e[s >> 2] + 8 >> 2]](s);
                            break n;
                          }
                          r = Hr() | 0;
                        }
                        to(m);
                        break t;
                      }
                      Oi();
                    }
                    r = Hr() | 0;
                  }
                  to(fr), Jn(r | 0), Oi();
                }
                return r | 0;
              }
              function vg(r, s, u, A, m, p, N, W) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0, m = m | 0, p = p | 0, N = N | 0, W = W | 0;
                var Te = 0, Xe = 0, fr = 0, ar = 0, vr = 0, _r = 0;
                _r = s, Te = Jr - 416 | 0, Jr = Te, e[Te + 408 >> 2] = 37, e[Te + 412 >> 2] = 0, s = Te + 408 | 0, ar = Pc(s | 1, 3264, e[u + 4 >> 2]), Xe = Te + 368 | 0, e[Te + 364 >> 2] = Xe, r = ko();
                e: {
                  if (ar) {
                    fr = e[u + 8 >> 2], vr = Te - -64 | 0, e[vr >> 2] = N, e[vr + 4 >> 2] = W, e[Te + 56 >> 2] = m, e[Te + 60 >> 2] = p, e[Te + 48 >> 2] = fr, Xe = oa(Xe, 30, r, s, Te + 48 | 0);
                    break e;
                  }
                  e[Te + 80 >> 2] = m, e[Te + 84 >> 2] = p, e[Te + 88 >> 2] = N, e[Te + 92 >> 2] = W, Xe = oa(Te + 368 | 0, 30, r, Te + 408 | 0, Te + 80 | 0);
                }
                e[Te + 128 >> 2] = 184, fr = Te + 356 | 0, e[fr >> 2] = 0, e[fr + 4 >> 2] = e[Te + 128 >> 2], s = Te + 368 | 0, r = s;
                e: {
                  t: {
                    r: {
                      i: {
                        if ((Xe | 0) >= 30) {
                          r = ko();
                          n: {
                            if (ar) {
                              Xe = e[u + 8 >> 2], e[Te + 16 >> 2] = N, e[Te + 20 >> 2] = W, e[Te + 8 >> 2] = m, e[Te + 12 >> 2] = p, e[Te >> 2] = Xe, Xe = Iu(Te + 364 | 0, r, Te + 408 | 0, Te);
                              break n;
                            }
                            e[Te + 32 >> 2] = m, e[Te + 36 >> 2] = p, e[Te + 40 >> 2] = N, e[Te + 44 >> 2] = W, Xe = Iu(Te + 364 | 0, r, Te + 408 | 0, Te + 32 | 0);
                          }
                          if ((Xe | 0) == -1) {
                            if (e[5996] = 0, Nn(185), r = e[5996], e[5996] = 0, (r | 0) == 1)
                              break r;
                            break i;
                          }
                          r = e[Te + 364 >> 2], ia(fr, r);
                        }
                        N = r + Xe | 0, W = Xa(r, N, e[u + 4 >> 2]), e[Te + 116 >> 2] = 184, m = Te + 120 | 0, e[m >> 2] = 0, e[m + 4 >> 2] = e[Te + 116 >> 2];
                        n: {
                          s: {
                            if ((Te + 368 | 0) == (r | 0)) {
                              Xe = Te + 128 | 0;
                              break s;
                            }
                            if (Xe = da(Xe << 3), !Xe) {
                              if (e[5996] = 0, Nn(185), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                break i;
                              r = Hr() | 0;
                              break n;
                            }
                            ia(m, Xe), s = r;
                          }
                          r = Te + 108 | 0, p = e[u + 28 >> 2], e[r >> 2] = p, e[p + 4 >> 2] = e[p + 4 >> 2] + 1, e[5996] = 0, au(218, s | 0, W | 0, N | 0, Xe | 0, Te + 116 | 0, Te + 112 | 0, r | 0), s = e[5996], e[5996] = 0;
                          s: {
                            if ((s | 0) != 1) {
                              if (r = e[r >> 2], s = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = s, (s | 0) == -1 && xi[e[e[r >> 2] + 8 >> 2]](r), e[5996] = 0, r = za(219, _r | 0, Xe | 0, e[Te + 116 >> 2], e[Te + 112 >> 2], u | 0, A | 0) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1)
                                break s;
                              to(m), to(fr), Jr = Te + 416 | 0;
                              break e;
                            }
                            r = Hr() | 0, s = e[Te + 108 >> 2], u = e[s + 4 >> 2] - 1 | 0, e[s + 4 >> 2] = u, (u | 0) == -1 && xi[e[e[s >> 2] + 8 >> 2]](s);
                            break n;
                          }
                          r = Hr() | 0;
                        }
                        to(m);
                        break t;
                      }
                      Oi();
                    }
                    r = Hr() | 0;
                  }
                  to(fr), Jn(r | 0), Oi();
                }
                return r | 0;
              }
              function ed(r, s, u) {
                var A = 0, m = 0, p = 0, N = 0, W = 0, Te = 0, Xe = 0;
                _[r | 0] = 0, _[r + 1 | 0] = 0, _[r + 2 | 0] = 0, _[r + 3 | 0] = 0, _[r + 4 | 0] = 0, _[r + 5 | 0] = 0, _[r + 6 | 0] = 0, _[r + 7 | 0] = 0, _[r + 24 | 0] = 0, _[r + 25 | 0] = 0, _[r + 26 | 0] = 0, _[r + 27 | 0] = 0, _[r + 28 | 0] = 0, _[r + 29 | 0] = 0, _[r + 30 | 0] = 0, _[r + 31 | 0] = 0, _[r + 16 | 0] = 0, _[r + 17 | 0] = 0, _[r + 18 | 0] = 0, _[r + 19 | 0] = 0, _[r + 20 | 0] = 0, _[r + 21 | 0] = 0, _[r + 22 | 0] = 0, _[r + 23 | 0] = 0, _[r + 8 | 0] = 0, _[r + 9 | 0] = 0, _[r + 10 | 0] = 0, _[r + 11 | 0] = 0, _[r + 12 | 0] = 0, _[r + 13 | 0] = 0, _[r + 14 | 0] = 0, _[r + 15 | 0] = 0, Xe = me[s + 8 | 0] | me[s + 9 | 0] << 8 | (me[s + 10 | 0] << 16 | me[s + 11 | 0] << 24), m = -29, p = me[s | 0] | me[s + 1 | 0] << 8 | (me[s + 2 | 0] << 16 | me[s + 3 | 0] << 24), W = p >>> 0 < 29;
                e: {
                  if (p = W ? p : p - 29 | 0, p >>> 0 >= 29) {
                    if (e[5996] = 0, ji(124, r | 0, p + (p >>> 1 | 0) | 0), m = e[5996], e[5996] = 0, (m | 0) == 1)
                      break e;
                    A = me[r + 8 | 0] | me[r + 9 | 0] << 8 | (me[r + 10 | 0] << 16 | me[r + 11 | 0] << 24), N = me[r | 0] | me[r + 1 | 0] << 8 | (me[r + 2 | 0] << 16 | me[r + 3 | 0] << 24), m = N - 29 | 0;
                  }
                  Te = N >>> 0 < 29, A = Te ? r + 4 | 0 : A, Ys(p + A | 0, A, Te ? N : m), m = p + (me[r | 0] | me[r + 1 | 0] << 8 | (me[r + 2 | 0] << 16 | me[r + 3 | 0] << 24)) | 0, _[r | 0] = m, _[r + 1 | 0] = m >>> 8, _[r + 2 | 0] = m >>> 16, _[r + 3 | 0] = m >>> 24;
                  t: {
                    if (!p)
                      break t;
                    m = W ? s + 4 | 0 : Xe, W = p & 7;
                    r: {
                      if (!W) {
                        s = m;
                        break r;
                      }
                      for (N = 0, s = m; _[A | 0] = me[s | 0], s = s + 1 | 0, A = A + 1 | 0, N = N + 1 | 0, (W | 0) != (N | 0); )
                        ;
                    }
                    if (p >>> 0 < 8)
                      break t;
                    for (m = m + p | 0; _[A | 0] = me[s | 0], _[A + 1 | 0] = me[s + 1 | 0], _[A + 2 | 0] = me[s + 2 | 0], _[A + 3 | 0] = me[s + 3 | 0], _[A + 4 | 0] = me[s + 4 | 0], _[A + 5 | 0] = me[s + 5 | 0], _[A + 6 | 0] = me[s + 6 | 0], _[A + 7 | 0] = me[s + 7 | 0], A = A + 8 | 0, s = s + 8 | 0, (m | 0) != (s | 0); )
                      ;
                  }
                  if (s = e[u >> 2], e[5996] = 0, pi(127, r | 0, s | 0) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1)
                    break e;
                  return;
                }
                s = Hr() | 0, (me[r | 0] | me[r + 1 | 0] << 8 | (me[r + 2 | 0] << 16 | me[r + 3 | 0] << 24)) >>> 0 >= 29 && (Br(me[r + 8 | 0] | me[r + 9 | 0] << 8 | (me[r + 10 | 0] << 16 | me[r + 11 | 0] << 24)), _[r + 8 | 0] = 0, _[r + 9 | 0] = 0, _[r + 10 | 0] = 0, _[r + 11 | 0] = 0), Jn(s | 0), Oi();
              }
              function Cg(r, s, u, A, m, p) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0, m = m | 0, p = p | 0;
                var N = 0, W = 0, Te = 0;
                A = e[A + 28 >> 2], r = Jr - 256 | 0, Jr = r, e[r + 248 >> 2] = u, e[r + 252 >> 2] = s, pd(r + 192 | 0, A, r + 208 | 0, r + 207 | 0, r + 206 | 0), A = r + 180 | 0, e[A >> 2] = 0, e[A + 4 >> 2] = 0, e[A + 8 >> 2] = 0, s = (me[A + 11 | 0] & 128) >>> 7 | 0 ? (e[A + 8 >> 2] & 2147483647) - 1 | 0 : 10, e[5996] = 0, ji(172, A | 0, s | 0), s = e[5996], e[5996] = 0;
                e: {
                  t: {
                    r: {
                      if ((s | 0) != 1) {
                        for (u = (me[A + 11 | 0] & 128) >>> 7 | 0 ? e[A >> 2] : A, e[r + 176 >> 2] = u, e[r + 12 >> 2] = r + 16, e[r + 8 >> 2] = 0, _[r + 7 | 0] = 1, _[r + 6 | 0] = 69, W = me[r + 206 | 0] << 24 >> 24, Te = me[r + 207 | 0] << 24 >> 24; ; ) {
                          i: {
                            if (e[5996] = 0, s = pi(186, r + 252 | 0, r + 248 | 0) | 0, N = e[5996], e[5996] = 0, (N | 0) == 1)
                              break i;
                            if (s)
                              break r;
                            if (s = me[A + 11 | 0], s = (s & 128) >>> 7 | 0 ? e[A + 4 >> 2] : s & 127, e[r + 176 >> 2] == (s + u | 0)) {
                              if (e[5996] = 0, ji(172, A | 0, s << 1), u = e[5996], e[5996] = 0, (u | 0) == 1 || (u = (me[A + 11 | 0] & 128) >>> 7 | 0 ? (e[A + 8 >> 2] & 2147483647) - 1 | 0 : 10, e[5996] = 0, ji(172, A | 0, u | 0), u = e[5996], e[5996] = 0, (u | 0) == 1))
                                break t;
                              u = (me[A + 11 | 0] & 128) >>> 7 | 0 ? e[A >> 2] : A, e[r + 176 >> 2] = s + u;
                            }
                            if (e[5996] = 0, s = Mi(187, e[r + 252 >> 2]) | 0, N = e[5996], e[5996] = 0, (N | 0) == 1)
                              break i;
                            if (Bc(s, r + 7 | 0, r + 6 | 0, u, r + 176 | 0, Te, W, r + 192 | 0, r + 16 | 0, r + 12 | 0, r + 8 | 0, r + 208 | 0))
                              break r;
                            if (e[5996] = 0, Mi(189, r + 252 | 0) | 0, s = e[5996], e[5996] = 0, (s | 0) != 1)
                              continue;
                          }
                          break;
                        }
                        break t;
                      }
                      break t;
                    }
                    s = me[r + 203 | 0];
                    r: {
                      if (!((s & 128) >>> 7 | 0 ? e[r + 196 >> 2] : s & 127) | !me[r + 7 | 0] || (s = e[r + 12 >> 2], (s - (r + 16 | 0) | 0) > 159))
                        break r;
                      e[r + 12 >> 2] = s + 4, e[s >> 2] = e[r + 8 >> 2];
                    }
                    if (gc[p >> 2] = Jh(u, e[r + 176 >> 2], m), ka(r + 192 | 0, r + 16 | 0, e[r + 12 >> 2], m), e[5996] = 0, s = pi(186, r + 252 | 0, r + 248 | 0) | 0, u = e[5996], e[5996] = 0, (u | 0) != 1) {
                      s && (e[m >> 2] = e[m >> 2] | 2), s = e[r + 252 >> 2], Qn(A), Qn(r + 192 | 0), Jr = r + 256 | 0;
                      break e;
                    }
                  }
                  s = Hr() | 0, Qn(A), Qn(r + 192 | 0), Jn(s | 0), Oi();
                }
                return s | 0;
              }
              function lo(r, s, u, A, m, p) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0, m = m | 0, p = p | 0;
                var N = 0, W = 0, Te = 0;
                A = e[A + 28 >> 2], r = Jr - 256 | 0, Jr = r, e[r + 248 >> 2] = u, e[r + 252 >> 2] = s, pd(r + 192 | 0, A, r + 208 | 0, r + 207 | 0, r + 206 | 0), A = r + 180 | 0, e[A >> 2] = 0, e[A + 4 >> 2] = 0, e[A + 8 >> 2] = 0, s = (me[A + 11 | 0] & 128) >>> 7 | 0 ? (e[A + 8 >> 2] & 2147483647) - 1 | 0 : 10, e[5996] = 0, ji(172, A | 0, s | 0), s = e[5996], e[5996] = 0;
                e: {
                  t: {
                    r: {
                      if ((s | 0) != 1) {
                        for (u = (me[A + 11 | 0] & 128) >>> 7 | 0 ? e[A >> 2] : A, e[r + 176 >> 2] = u, e[r + 12 >> 2] = r + 16, e[r + 8 >> 2] = 0, _[r + 7 | 0] = 1, _[r + 6 | 0] = 69, W = me[r + 206 | 0] << 24 >> 24, Te = me[r + 207 | 0] << 24 >> 24; ; ) {
                          i: {
                            if (e[5996] = 0, s = pi(186, r + 252 | 0, r + 248 | 0) | 0, N = e[5996], e[5996] = 0, (N | 0) == 1)
                              break i;
                            if (s)
                              break r;
                            if (s = me[A + 11 | 0], s = (s & 128) >>> 7 | 0 ? e[A + 4 >> 2] : s & 127, e[r + 176 >> 2] == (s + u | 0)) {
                              if (e[5996] = 0, ji(172, A | 0, s << 1), u = e[5996], e[5996] = 0, (u | 0) == 1 || (u = (me[A + 11 | 0] & 128) >>> 7 | 0 ? (e[A + 8 >> 2] & 2147483647) - 1 | 0 : 10, e[5996] = 0, ji(172, A | 0, u | 0), u = e[5996], e[5996] = 0, (u | 0) == 1))
                                break t;
                              u = (me[A + 11 | 0] & 128) >>> 7 | 0 ? e[A >> 2] : A, e[r + 176 >> 2] = s + u;
                            }
                            if (e[5996] = 0, s = Mi(187, e[r + 252 >> 2]) | 0, N = e[5996], e[5996] = 0, (N | 0) == 1)
                              break i;
                            if (Bc(s, r + 7 | 0, r + 6 | 0, u, r + 176 | 0, Te, W, r + 192 | 0, r + 16 | 0, r + 12 | 0, r + 8 | 0, r + 208 | 0))
                              break r;
                            if (e[5996] = 0, Mi(189, r + 252 | 0) | 0, s = e[5996], e[5996] = 0, (s | 0) != 1)
                              continue;
                          }
                          break;
                        }
                        break t;
                      }
                      break t;
                    }
                    s = me[r + 203 | 0];
                    r: {
                      if (!((s & 128) >>> 7 | 0 ? e[r + 196 >> 2] : s & 127) | !me[r + 7 | 0] || (s = e[r + 12 >> 2], (s - (r + 16 | 0) | 0) > 159))
                        break r;
                      e[r + 12 >> 2] = s + 4, e[s >> 2] = e[r + 8 >> 2];
                    }
                    if (jn[p >> 3] = Yh(u, e[r + 176 >> 2], m), ka(r + 192 | 0, r + 16 | 0, e[r + 12 >> 2], m), e[5996] = 0, s = pi(186, r + 252 | 0, r + 248 | 0) | 0, u = e[5996], e[5996] = 0, (u | 0) != 1) {
                      s && (e[m >> 2] = e[m >> 2] | 2), s = e[r + 252 >> 2], Qn(A), Qn(r + 192 | 0), Jr = r + 256 | 0;
                      break e;
                    }
                  }
                  s = Hr() | 0, Qn(A), Qn(r + 192 | 0), Jn(s | 0), Oi();
                }
                return s | 0;
              }
              function ju(r, s, u, A, m, p, N, W) {
                var Te = 0, Xe = 0, fr = 0;
                if (Te = Jr - 16 | 0, Jr = Te, e[Te + 8 >> 2] = u, e[Te + 12 >> 2] = s, s = e[A + 28 >> 2], e[Te + 4 >> 2] = s, e[s + 4 >> 2] = e[s + 4 >> 2] + 1, u = 0, e[5996] = 0, Xe = Mi(170, e[Te + 4 >> 2]) | 0, s = e[5996], e[5996] = 0, (s | 0) != 1) {
                  s = e[Te + 4 >> 2], fr = e[s + 4 >> 2] - 1 | 0, e[s + 4 >> 2] = fr, (fr | 0) == -1 && xi[e[e[s >> 2] + 8 >> 2]](s), e[m >> 2] = 0;
                  e: {
                    for (; ; ) {
                      if (u | (N | 0) == (W | 0))
                        break e;
                      t: {
                        if (Lu(Te + 12 | 0, Te + 8 | 0))
                          break t;
                        r: {
                          if ((xi[e[e[Xe >> 2] + 36 >> 2]](Xe, _[N | 0], 0) | 0) == 37) {
                            if ((N + 1 | 0) == (W | 0))
                              break t;
                            u = xi[e[e[Xe >> 2] + 36 >> 2]](Xe, _[N + 1 | 0], 0) | 0;
                            i: {
                              if (!((u | 0) == 69 | (u & 255) == 48)) {
                                s = 0, fr = 1;
                                break i;
                              }
                              if ((N + 2 | 0) == (W | 0))
                                break t;
                              s = u, u = xi[e[e[Xe >> 2] + 36 >> 2]](Xe, _[N + 2 | 0], 0) | 0, fr = 2;
                            }
                            e[Te + 12 >> 2] = xi[e[e[r >> 2] + 36 >> 2]](r, e[Te + 12 >> 2], e[Te + 8 >> 2], A, m, p, u, s), N = (N + fr | 0) + 1 | 0;
                            break r;
                          }
                          if (s = e[Xe + 8 >> 2], u = _[N | 0], (u | 0) >= 0 ? u = e[s + ((u & 255) << 2) >> 2] & 1 : u = 0, u) {
                            for (; ; ) {
                              i: {
                                if (N = N + 1 | 0, (W | 0) == (N | 0)) {
                                  N = W;
                                  break i;
                                }
                                if (u = _[N | 0], (u | 0) >= 0 ? u = e[s + ((u & 255) << 2) >> 2] & 1 : u = 0, u)
                                  continue;
                              }
                              break;
                            }
                            for (; ; ) {
                              if (fr = Te + 12 | 0, Lu(fr, Te + 8 | 0))
                                break r;
                              s = e[Te + 12 >> 2], u = e[s + 12 >> 2];
                              i: {
                                if ((u | 0) == e[s + 16 >> 2]) {
                                  s = xi[e[e[s >> 2] + 36 >> 2]](s) | 0;
                                  break i;
                                }
                                s = me[u | 0];
                              }
                              if (u = e[Xe + 8 >> 2], s = s << 24 >> 24, (s | 0) >= 0 ? s = e[u + ((s & 255) << 2) >> 2] & 1 : s = 0, !s)
                                break r;
                              Ql(fr);
                            }
                          }
                          s = e[Te + 12 >> 2], u = e[s + 12 >> 2];
                          i: {
                            if ((u | 0) == e[s + 16 >> 2]) {
                              s = xi[e[e[s >> 2] + 36 >> 2]](s) | 0;
                              break i;
                            }
                            s = me[u | 0];
                          }
                          if ((xi[e[e[Xe >> 2] + 12 >> 2]](Xe, s << 24 >> 24) | 0) == (xi[e[e[Xe >> 2] + 12 >> 2]](Xe, _[N | 0]) | 0)) {
                            N = N + 1 | 0, Ql(Te + 12 | 0);
                            break r;
                          }
                          e[m >> 2] = 4;
                        }
                        u = e[m >> 2];
                        continue;
                      }
                      break;
                    }
                    e[m >> 2] = 4;
                  }
                  return Lu(Te + 12 | 0, Te + 8 | 0) && (e[m >> 2] = e[m >> 2] | 2), Jr = Te + 16 | 0, e[Te + 12 >> 2];
                }
                u = Hr() | 0, r = e[Te + 4 >> 2], s = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = s, (s | 0) == -1 && xi[e[e[r >> 2] + 8 >> 2]](r), Jn(u | 0), Oi();
              }
              function kg(r, s, u, A, m, p) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0, m = m | 0, p = p | 0;
                var N = 0, W = 0, Te = 0;
                A = e[A + 28 >> 2], r = Jr - 368 | 0, Jr = r, e[r + 360 >> 2] = u, e[r + 364 >> 2] = s, gd(r + 204 | 0, A, r + 224 | 0, r + 220 | 0, r + 216 | 0), A = r + 192 | 0, e[A >> 2] = 0, e[A + 4 >> 2] = 0, e[A + 8 >> 2] = 0, s = (me[A + 11 | 0] & 128) >>> 7 | 0 ? (e[A + 8 >> 2] & 2147483647) - 1 | 0 : 10, e[5996] = 0, ji(172, A | 0, s | 0), s = e[5996], e[5996] = 0;
                e: {
                  t: {
                    r: {
                      if ((s | 0) != 1) {
                        for (u = (me[A + 11 | 0] & 128) >>> 7 | 0 ? e[A >> 2] : A, e[r + 188 >> 2] = u, e[r + 12 >> 2] = r + 16, e[r + 8 >> 2] = 0, _[r + 7 | 0] = 1, _[r + 6 | 0] = 69, W = e[r + 216 >> 2], Te = e[r + 220 >> 2]; ; ) {
                          i: {
                            if (e[5996] = 0, s = pi(202, r + 364 | 0, r + 360 | 0) | 0, N = e[5996], e[5996] = 0, (N | 0) == 1)
                              break i;
                            if (s)
                              break r;
                            if (s = me[A + 11 | 0], s = (s & 128) >>> 7 | 0 ? e[A + 4 >> 2] : s & 127, e[r + 188 >> 2] == (s + u | 0)) {
                              if (e[5996] = 0, ji(172, A | 0, s << 1), u = e[5996], e[5996] = 0, (u | 0) == 1 || (u = (me[A + 11 | 0] & 128) >>> 7 | 0 ? (e[A + 8 >> 2] & 2147483647) - 1 | 0 : 10, e[5996] = 0, ji(172, A | 0, u | 0), u = e[5996], e[5996] = 0, (u | 0) == 1))
                                break t;
                              u = (me[A + 11 | 0] & 128) >>> 7 | 0 ? e[A >> 2] : A, e[r + 188 >> 2] = s + u;
                            }
                            if (e[5996] = 0, s = Mi(203, e[r + 364 >> 2]) | 0, N = e[5996], e[5996] = 0, (N | 0) == 1)
                              break i;
                            if (ol(s, r + 7 | 0, r + 6 | 0, u, r + 188 | 0, Te, W, r + 204 | 0, r + 16 | 0, r + 12 | 0, r + 8 | 0, r + 224 | 0))
                              break r;
                            if (e[5996] = 0, Mi(205, r + 364 | 0) | 0, s = e[5996], e[5996] = 0, (s | 0) != 1)
                              continue;
                          }
                          break;
                        }
                        break t;
                      }
                      break t;
                    }
                    s = me[r + 215 | 0];
                    r: {
                      if (!((s & 128) >>> 7 | 0 ? e[r + 208 >> 2] : s & 127) | !me[r + 7 | 0] || (s = e[r + 12 >> 2], (s - (r + 16 | 0) | 0) > 159))
                        break r;
                      e[r + 12 >> 2] = s + 4, e[s >> 2] = e[r + 8 >> 2];
                    }
                    if (gc[p >> 2] = Jh(u, e[r + 188 >> 2], m), ka(r + 204 | 0, r + 16 | 0, e[r + 12 >> 2], m), e[5996] = 0, s = pi(202, r + 364 | 0, r + 360 | 0) | 0, u = e[5996], e[5996] = 0, (u | 0) != 1) {
                      s && (e[m >> 2] = e[m >> 2] | 2), s = e[r + 364 >> 2], Qn(A), Qn(r + 204 | 0), Jr = r + 368 | 0;
                      break e;
                    }
                  }
                  s = Hr() | 0, Qn(A), Qn(r + 204 | 0), Jn(s | 0), Oi();
                }
                return s | 0;
              }
              function Sg(r, s, u, A, m, p) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0, m = m | 0, p = p | 0;
                var N = 0, W = 0, Te = 0;
                A = e[A + 28 >> 2], r = Jr - 368 | 0, Jr = r, e[r + 360 >> 2] = u, e[r + 364 >> 2] = s, gd(r + 204 | 0, A, r + 224 | 0, r + 220 | 0, r + 216 | 0), A = r + 192 | 0, e[A >> 2] = 0, e[A + 4 >> 2] = 0, e[A + 8 >> 2] = 0, s = (me[A + 11 | 0] & 128) >>> 7 | 0 ? (e[A + 8 >> 2] & 2147483647) - 1 | 0 : 10, e[5996] = 0, ji(172, A | 0, s | 0), s = e[5996], e[5996] = 0;
                e: {
                  t: {
                    r: {
                      if ((s | 0) != 1) {
                        for (u = (me[A + 11 | 0] & 128) >>> 7 | 0 ? e[A >> 2] : A, e[r + 188 >> 2] = u, e[r + 12 >> 2] = r + 16, e[r + 8 >> 2] = 0, _[r + 7 | 0] = 1, _[r + 6 | 0] = 69, W = e[r + 216 >> 2], Te = e[r + 220 >> 2]; ; ) {
                          i: {
                            if (e[5996] = 0, s = pi(202, r + 364 | 0, r + 360 | 0) | 0, N = e[5996], e[5996] = 0, (N | 0) == 1)
                              break i;
                            if (s)
                              break r;
                            if (s = me[A + 11 | 0], s = (s & 128) >>> 7 | 0 ? e[A + 4 >> 2] : s & 127, e[r + 188 >> 2] == (s + u | 0)) {
                              if (e[5996] = 0, ji(172, A | 0, s << 1), u = e[5996], e[5996] = 0, (u | 0) == 1 || (u = (me[A + 11 | 0] & 128) >>> 7 | 0 ? (e[A + 8 >> 2] & 2147483647) - 1 | 0 : 10, e[5996] = 0, ji(172, A | 0, u | 0), u = e[5996], e[5996] = 0, (u | 0) == 1))
                                break t;
                              u = (me[A + 11 | 0] & 128) >>> 7 | 0 ? e[A >> 2] : A, e[r + 188 >> 2] = s + u;
                            }
                            if (e[5996] = 0, s = Mi(203, e[r + 364 >> 2]) | 0, N = e[5996], e[5996] = 0, (N | 0) == 1)
                              break i;
                            if (ol(s, r + 7 | 0, r + 6 | 0, u, r + 188 | 0, Te, W, r + 204 | 0, r + 16 | 0, r + 12 | 0, r + 8 | 0, r + 224 | 0))
                              break r;
                            if (e[5996] = 0, Mi(205, r + 364 | 0) | 0, s = e[5996], e[5996] = 0, (s | 0) != 1)
                              continue;
                          }
                          break;
                        }
                        break t;
                      }
                      break t;
                    }
                    s = me[r + 215 | 0];
                    r: {
                      if (!((s & 128) >>> 7 | 0 ? e[r + 208 >> 2] : s & 127) | !me[r + 7 | 0] || (s = e[r + 12 >> 2], (s - (r + 16 | 0) | 0) > 159))
                        break r;
                      e[r + 12 >> 2] = s + 4, e[s >> 2] = e[r + 8 >> 2];
                    }
                    if (jn[p >> 3] = Yh(u, e[r + 188 >> 2], m), ka(r + 204 | 0, r + 16 | 0, e[r + 12 >> 2], m), e[5996] = 0, s = pi(202, r + 364 | 0, r + 360 | 0) | 0, u = e[5996], e[5996] = 0, (u | 0) != 1) {
                      s && (e[m >> 2] = e[m >> 2] | 2), s = e[r + 364 >> 2], Qn(A), Qn(r + 204 | 0), Jr = r + 368 | 0;
                      break e;
                    }
                  }
                  s = Hr() | 0, Qn(A), Qn(r + 204 | 0), Jn(s | 0), Oi();
                }
                return s | 0;
              }
              function nl(r, s) {
                var u = 0, A = 0, m = 0, p = 0, N = 0, W = 0, Te = 0;
                e: {
                  t: {
                    if (r - 1 & r | s >>> 0 > 4294967239)
                      break t;
                    for (; ; ) {
                      r = r >>> 0 <= 8 ? 8 : r, m = e[5995], p = e[5994], s = s >>> 0 <= 8 ? 8 : s + 3 & -4;
                      r: {
                        if (s >>> 0 <= 127) {
                          N = (s >>> 3 | 0) - 1 | 0;
                          break r;
                        }
                        if (A = Fo(s), N = ((s >>> 29 - A ^ 4) - (A << 2) | 0) + 110 | 0, s >>> 0 <= 4095)
                          break r;
                        A = ((s >>> 30 - A ^ 2) - (A << 1) | 0) + 71 | 0, N = A >>> 0 >= 63 ? 63 : A;
                      }
                      if (u = N & 31, (N & 63) >>> 0 >= 32 ? (A = 0, u = m >>> u | 0) : (A = m >>> u | 0, u = ((1 << u) - 1 & m) << 32 - u | p >>> u), u | A) {
                        for (; ; ) {
                          m = u;
                          r: {
                            if (A | m) {
                              p = A - 1 | 0, W = p + 1 | 0, u = p, p = m - 1 | 0, W = (p | 0) != -1 ? W : u, u = Fo(A ^ W), u = (u | 0) == 32 ? Fo(m ^ p) + 32 | 0 : u, p = 63 - u | 0, Ds = 0 - (u >>> 0 > 63) | 0;
                              break r;
                            }
                            Ds = 0, p = 64;
                          }
                          W = p, p = W & 31, (W & 63) >>> 0 >= 32 ? (u = 0, p = A >>> p | 0) : (u = A >>> p | 0, p = ((1 << p) - 1 & A) << 32 - p | m >>> p), A = u, N = N + W | 0, W = N << 4, m = e[W + 22952 >> 2], Te = W + 22944 | 0;
                          r: {
                            if ((m | 0) != (Te | 0)) {
                              if (u = Ad(m, r, s), u)
                                break t;
                              u = e[m + 4 >> 2], e[u + 8 >> 2] = e[m + 8 >> 2], e[e[m + 8 >> 2] + 4 >> 2] = u, e[m + 8 >> 2] = Te, u = W + 22948 | 0, e[m + 4 >> 2] = e[u >> 2], e[u >> 2] = m, e[e[m + 4 >> 2] + 8 >> 2] = m, N = N + 1 | 0, u = (A & 1) << 31 | p >>> 1, A = A >>> 1 | 0;
                              break r;
                            }
                            u = e[5995], e[5994] = e[5994] & Td(-2, -1, N), e[5995] = Ds & u, u = p ^ 1;
                          }
                          if (!(A | u))
                            break;
                        }
                        p = e[5994], m = e[5995];
                      }
                      r: {
                        if (m | p) {
                          A = Fo(m), W = 63 - ((A | 0) == 32 ? Fo(p) + 32 | 0 : A) | 0, u = W << 4, A = e[u + 22952 >> 2];
                          i: {
                            if (!m & p >>> 0 < 1073741824 || (N = 99, m = u + 22944 | 0, (m | 0) == (A | 0)))
                              break i;
                            for (; ; ) {
                              if (!N)
                                break i;
                              if (u = Ad(A, r, s), u)
                                break t;
                              if (N = N - 1 | 0, A = e[A + 8 >> 2], (m | 0) == (A | 0))
                                break;
                            }
                            A = m;
                          }
                          if (al(s + 48 | 0))
                            break r;
                          if (!A || (m = (W << 4) + 22944 | 0, (m | 0) == (A | 0)))
                            break e;
                          for (; ; ) {
                            if (u = Ad(A, r, s), u)
                              break t;
                            if (A = e[A + 8 >> 2], (m | 0) == (A | 0))
                              break;
                          }
                          break e;
                        }
                        if (!al(s + 48 | 0))
                          break e;
                      }
                      if (u = 0, r - 1 & r)
                        break t;
                      if (!(s >>> 0 <= 4294967239))
                        break;
                    }
                  }
                  return u;
                }
                return 0;
              }
              function Tg(r, s, u, A, m, p) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0, m = m | 0, p = p | 0;
                var N = 0, W = 0, Te = 0;
                r = Jr - 336 | 0, Jr = r, e[r + 328 >> 2] = u, e[r + 332 >> 2] = s, s = _u(e[A + 4 >> 2]), Te = jf(e[A + 28 >> 2], r + 208 | 0), Rc(r + 196 | 0, e[A + 28 >> 2], r + 324 | 0), A = r + 184 | 0, e[A >> 2] = 0, e[A + 4 >> 2] = 0, e[A + 8 >> 2] = 0, u = (me[A + 11 | 0] & 128) >>> 7 | 0 ? (e[A + 8 >> 2] & 2147483647) - 1 | 0 : 10, e[5996] = 0, ji(172, A | 0, u | 0), u = e[5996], e[5996] = 0;
                e: {
                  t: {
                    r: {
                      if ((u | 0) != 1) {
                        for (u = (me[A + 11 | 0] & 128) >>> 7 | 0 ? e[A >> 2] : A, e[r + 180 >> 2] = u, e[r + 12 >> 2] = r + 16, e[r + 8 >> 2] = 0; ; ) {
                          i: {
                            if (e[5996] = 0, N = pi(202, r + 332 | 0, r + 328 | 0) | 0, W = e[5996], e[5996] = 0, (W | 0) == 1)
                              break i;
                            if (N)
                              break r;
                            if (N = me[A + 11 | 0], N = (N & 128) >>> 7 | 0 ? e[A + 4 >> 2] : N & 127, e[r + 180 >> 2] == (N + u | 0)) {
                              if (e[5996] = 0, ji(172, A | 0, N << 1), u = e[5996], e[5996] = 0, (u | 0) == 1 || (u = (me[A + 11 | 0] & 128) >>> 7 | 0 ? (e[A + 8 >> 2] & 2147483647) - 1 | 0 : 10, e[5996] = 0, ji(172, A | 0, u | 0), u = e[5996], e[5996] = 0, (u | 0) == 1))
                                break t;
                              u = (me[A + 11 | 0] & 128) >>> 7 | 0 ? e[A >> 2] : A, e[r + 180 >> 2] = N + u;
                            }
                            if (e[5996] = 0, N = Mi(203, e[r + 332 >> 2]) | 0, W = e[5996], e[5996] = 0, (W | 0) == 1)
                              break i;
                            if (Vf(N, s, u, r + 180 | 0, r + 8 | 0, e[r + 324 >> 2], e[r + 200 >> 2], me[r + 207 | 0], r + 16 | 0, r + 12 | 0, Te))
                              break r;
                            if (e[5996] = 0, Mi(205, r + 332 | 0) | 0, N = e[5996], e[5996] = 0, (N | 0) != 1)
                              continue;
                          }
                          break;
                        }
                        break t;
                      }
                      break t;
                    }
                    N = me[r + 207 | 0];
                    r: {
                      if (!((N & 128) >>> 7 | 0 ? e[r + 200 >> 2] : N & 127) || (N = e[r + 12 >> 2], (N - (r + 16 | 0) | 0) > 159))
                        break r;
                      e[r + 12 >> 2] = N + 4, e[N >> 2] = e[r + 8 >> 2];
                    }
                    if (e[p >> 2] = Zh(u, e[r + 180 >> 2], m, s), e[p + 4 >> 2] = Ds, ka(r + 196 | 0, r + 16 | 0, e[r + 12 >> 2], m), e[5996] = 0, s = pi(202, r + 332 | 0, r + 328 | 0) | 0, u = e[5996], e[5996] = 0, (u | 0) != 1) {
                      s && (e[m >> 2] = e[m >> 2] | 2), s = e[r + 332 >> 2], Qn(A), Qn(r + 196 | 0), Jr = r + 336 | 0;
                      break e;
                    }
                  }
                  s = Hr() | 0, Qn(A), Qn(r + 196 | 0), Jn(s | 0), Oi();
                }
                return s | 0;
              }
              function Rg(r, s, u, A, m, p) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0, m = m | 0, p = p | 0;
                var N = 0, W = 0, Te = 0;
                r = Jr - 336 | 0, Jr = r, e[r + 328 >> 2] = u, e[r + 332 >> 2] = s, s = _u(e[A + 4 >> 2]), Te = jf(e[A + 28 >> 2], r + 208 | 0), Rc(r + 196 | 0, e[A + 28 >> 2], r + 324 | 0), A = r + 184 | 0, e[A >> 2] = 0, e[A + 4 >> 2] = 0, e[A + 8 >> 2] = 0, u = (me[A + 11 | 0] & 128) >>> 7 | 0 ? (e[A + 8 >> 2] & 2147483647) - 1 | 0 : 10, e[5996] = 0, ji(172, A | 0, u | 0), u = e[5996], e[5996] = 0;
                e: {
                  t: {
                    r: {
                      if ((u | 0) != 1) {
                        for (u = (me[A + 11 | 0] & 128) >>> 7 | 0 ? e[A >> 2] : A, e[r + 180 >> 2] = u, e[r + 12 >> 2] = r + 16, e[r + 8 >> 2] = 0; ; ) {
                          i: {
                            if (e[5996] = 0, N = pi(202, r + 332 | 0, r + 328 | 0) | 0, W = e[5996], e[5996] = 0, (W | 0) == 1)
                              break i;
                            if (N)
                              break r;
                            if (N = me[A + 11 | 0], N = (N & 128) >>> 7 | 0 ? e[A + 4 >> 2] : N & 127, e[r + 180 >> 2] == (N + u | 0)) {
                              if (e[5996] = 0, ji(172, A | 0, N << 1), u = e[5996], e[5996] = 0, (u | 0) == 1 || (u = (me[A + 11 | 0] & 128) >>> 7 | 0 ? (e[A + 8 >> 2] & 2147483647) - 1 | 0 : 10, e[5996] = 0, ji(172, A | 0, u | 0), u = e[5996], e[5996] = 0, (u | 0) == 1))
                                break t;
                              u = (me[A + 11 | 0] & 128) >>> 7 | 0 ? e[A >> 2] : A, e[r + 180 >> 2] = N + u;
                            }
                            if (e[5996] = 0, N = Mi(203, e[r + 332 >> 2]) | 0, W = e[5996], e[5996] = 0, (W | 0) == 1)
                              break i;
                            if (Vf(N, s, u, r + 180 | 0, r + 8 | 0, e[r + 324 >> 2], e[r + 200 >> 2], me[r + 207 | 0], r + 16 | 0, r + 12 | 0, Te))
                              break r;
                            if (e[5996] = 0, Mi(205, r + 332 | 0) | 0, N = e[5996], e[5996] = 0, (N | 0) != 1)
                              continue;
                          }
                          break;
                        }
                        break t;
                      }
                      break t;
                    }
                    N = me[r + 207 | 0];
                    r: {
                      if (!((N & 128) >>> 7 | 0 ? e[r + 200 >> 2] : N & 127) || (N = e[r + 12 >> 2], (N - (r + 16 | 0) | 0) > 159))
                        break r;
                      e[r + 12 >> 2] = N + 4, e[N >> 2] = e[r + 8 >> 2];
                    }
                    if (e[p >> 2] = af(u, e[r + 180 >> 2], m, s), e[p + 4 >> 2] = Ds, ka(r + 196 | 0, r + 16 | 0, e[r + 12 >> 2], m), e[5996] = 0, s = pi(202, r + 332 | 0, r + 328 | 0) | 0, u = e[5996], e[5996] = 0, (u | 0) != 1) {
                      s && (e[m >> 2] = e[m >> 2] | 2), s = e[r + 332 >> 2], Qn(A), Qn(r + 196 | 0), Jr = r + 336 | 0;
                      break e;
                    }
                  }
                  s = Hr() | 0, Qn(A), Qn(r + 196 | 0), Jn(s | 0), Oi();
                }
                return s | 0;
              }
              function xg(r, s, u, A, m, p) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0, m = m | 0, p = p | 0;
                var N = 0, W = 0, Te = 0;
                r = Jr - 336 | 0, Jr = r, e[r + 328 >> 2] = u, e[r + 332 >> 2] = s, s = _u(e[A + 4 >> 2]), Te = jf(e[A + 28 >> 2], r + 208 | 0), Rc(r + 196 | 0, e[A + 28 >> 2], r + 324 | 0), A = r + 184 | 0, e[A >> 2] = 0, e[A + 4 >> 2] = 0, e[A + 8 >> 2] = 0, u = (me[A + 11 | 0] & 128) >>> 7 | 0 ? (e[A + 8 >> 2] & 2147483647) - 1 | 0 : 10, e[5996] = 0, ji(172, A | 0, u | 0), u = e[5996], e[5996] = 0;
                e: {
                  t: {
                    r: {
                      if ((u | 0) != 1) {
                        for (u = (me[A + 11 | 0] & 128) >>> 7 | 0 ? e[A >> 2] : A, e[r + 180 >> 2] = u, e[r + 12 >> 2] = r + 16, e[r + 8 >> 2] = 0; ; ) {
                          i: {
                            if (e[5996] = 0, N = pi(202, r + 332 | 0, r + 328 | 0) | 0, W = e[5996], e[5996] = 0, (W | 0) == 1)
                              break i;
                            if (N)
                              break r;
                            if (N = me[A + 11 | 0], N = (N & 128) >>> 7 | 0 ? e[A + 4 >> 2] : N & 127, e[r + 180 >> 2] == (N + u | 0)) {
                              if (e[5996] = 0, ji(172, A | 0, N << 1), u = e[5996], e[5996] = 0, (u | 0) == 1 || (u = (me[A + 11 | 0] & 128) >>> 7 | 0 ? (e[A + 8 >> 2] & 2147483647) - 1 | 0 : 10, e[5996] = 0, ji(172, A | 0, u | 0), u = e[5996], e[5996] = 0, (u | 0) == 1))
                                break t;
                              u = (me[A + 11 | 0] & 128) >>> 7 | 0 ? e[A >> 2] : A, e[r + 180 >> 2] = N + u;
                            }
                            if (e[5996] = 0, N = Mi(203, e[r + 332 >> 2]) | 0, W = e[5996], e[5996] = 0, (W | 0) == 1)
                              break i;
                            if (Vf(N, s, u, r + 180 | 0, r + 8 | 0, e[r + 324 >> 2], e[r + 200 >> 2], me[r + 207 | 0], r + 16 | 0, r + 12 | 0, Te))
                              break r;
                            if (e[5996] = 0, Mi(205, r + 332 | 0) | 0, N = e[5996], e[5996] = 0, (N | 0) != 1)
                              continue;
                          }
                          break;
                        }
                        break t;
                      }
                      break t;
                    }
                    N = me[r + 207 | 0];
                    r: {
                      if (!((N & 128) >>> 7 | 0 ? e[r + 200 >> 2] : N & 127) || (N = e[r + 12 >> 2], (N - (r + 16 | 0) | 0) > 159))
                        break r;
                      e[r + 12 >> 2] = N + 4, e[N >> 2] = e[r + 8 >> 2];
                    }
                    if (e[p >> 2] = Ed(u, e[r + 180 >> 2], m, s), ka(r + 196 | 0, r + 16 | 0, e[r + 12 >> 2], m), e[5996] = 0, s = pi(202, r + 332 | 0, r + 328 | 0) | 0, u = e[5996], e[5996] = 0, (u | 0) != 1) {
                      s && (e[m >> 2] = e[m >> 2] | 2), s = e[r + 332 >> 2], Qn(A), Qn(r + 196 | 0), Jr = r + 336 | 0;
                      break e;
                    }
                  }
                  s = Hr() | 0, Qn(A), Qn(r + 196 | 0), Jn(s | 0), Oi();
                }
                return s | 0;
              }
              function Dg(r, s, u, A, m, p) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0, m = m | 0, p = p | 0;
                var N = 0, W = 0, Te = 0;
                r = Jr - 336 | 0, Jr = r, e[r + 328 >> 2] = u, e[r + 332 >> 2] = s, s = _u(e[A + 4 >> 2]), Te = jf(e[A + 28 >> 2], r + 208 | 0), Rc(r + 196 | 0, e[A + 28 >> 2], r + 324 | 0), A = r + 184 | 0, e[A >> 2] = 0, e[A + 4 >> 2] = 0, e[A + 8 >> 2] = 0, u = (me[A + 11 | 0] & 128) >>> 7 | 0 ? (e[A + 8 >> 2] & 2147483647) - 1 | 0 : 10, e[5996] = 0, ji(172, A | 0, u | 0), u = e[5996], e[5996] = 0;
                e: {
                  t: {
                    r: {
                      if ((u | 0) != 1) {
                        for (u = (me[A + 11 | 0] & 128) >>> 7 | 0 ? e[A >> 2] : A, e[r + 180 >> 2] = u, e[r + 12 >> 2] = r + 16, e[r + 8 >> 2] = 0; ; ) {
                          i: {
                            if (e[5996] = 0, N = pi(202, r + 332 | 0, r + 328 | 0) | 0, W = e[5996], e[5996] = 0, (W | 0) == 1)
                              break i;
                            if (N)
                              break r;
                            if (N = me[A + 11 | 0], N = (N & 128) >>> 7 | 0 ? e[A + 4 >> 2] : N & 127, e[r + 180 >> 2] == (N + u | 0)) {
                              if (e[5996] = 0, ji(172, A | 0, N << 1), u = e[5996], e[5996] = 0, (u | 0) == 1 || (u = (me[A + 11 | 0] & 128) >>> 7 | 0 ? (e[A + 8 >> 2] & 2147483647) - 1 | 0 : 10, e[5996] = 0, ji(172, A | 0, u | 0), u = e[5996], e[5996] = 0, (u | 0) == 1))
                                break t;
                              u = (me[A + 11 | 0] & 128) >>> 7 | 0 ? e[A >> 2] : A, e[r + 180 >> 2] = N + u;
                            }
                            if (e[5996] = 0, N = Mi(203, e[r + 332 >> 2]) | 0, W = e[5996], e[5996] = 0, (W | 0) == 1)
                              break i;
                            if (Vf(N, s, u, r + 180 | 0, r + 8 | 0, e[r + 324 >> 2], e[r + 200 >> 2], me[r + 207 | 0], r + 16 | 0, r + 12 | 0, Te))
                              break r;
                            if (e[5996] = 0, Mi(205, r + 332 | 0) | 0, N = e[5996], e[5996] = 0, (N | 0) != 1)
                              continue;
                          }
                          break;
                        }
                        break t;
                      }
                      break t;
                    }
                    N = me[r + 207 | 0];
                    r: {
                      if (!((N & 128) >>> 7 | 0 ? e[r + 200 >> 2] : N & 127) || (N = e[r + 12 >> 2], (N - (r + 16 | 0) | 0) > 159))
                        break r;
                      e[r + 12 >> 2] = N + 4, e[N >> 2] = e[r + 8 >> 2];
                    }
                    if (Zs[p >> 1] = Vh(u, e[r + 180 >> 2], m, s), ka(r + 196 | 0, r + 16 | 0, e[r + 12 >> 2], m), e[5996] = 0, s = pi(202, r + 332 | 0, r + 328 | 0) | 0, u = e[5996], e[5996] = 0, (u | 0) != 1) {
                      s && (e[m >> 2] = e[m >> 2] | 2), s = e[r + 332 >> 2], Qn(A), Qn(r + 196 | 0), Jr = r + 336 | 0;
                      break e;
                    }
                  }
                  s = Hr() | 0, Qn(A), Qn(r + 196 | 0), Jn(s | 0), Oi();
                }
                return s | 0;
              }
              function Eh(r, s, u, A, m, p) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0, m = m | 0, p = p | 0;
                var N = 0, W = 0, Te = 0;
                r = Jr - 336 | 0, Jr = r, e[r + 328 >> 2] = u, e[r + 332 >> 2] = s, s = _u(e[A + 4 >> 2]), Te = jf(e[A + 28 >> 2], r + 208 | 0), Rc(r + 196 | 0, e[A + 28 >> 2], r + 324 | 0), A = r + 184 | 0, e[A >> 2] = 0, e[A + 4 >> 2] = 0, e[A + 8 >> 2] = 0, u = (me[A + 11 | 0] & 128) >>> 7 | 0 ? (e[A + 8 >> 2] & 2147483647) - 1 | 0 : 10, e[5996] = 0, ji(172, A | 0, u | 0), u = e[5996], e[5996] = 0;
                e: {
                  t: {
                    r: {
                      if ((u | 0) != 1) {
                        for (u = (me[A + 11 | 0] & 128) >>> 7 | 0 ? e[A >> 2] : A, e[r + 180 >> 2] = u, e[r + 12 >> 2] = r + 16, e[r + 8 >> 2] = 0; ; ) {
                          i: {
                            if (e[5996] = 0, N = pi(202, r + 332 | 0, r + 328 | 0) | 0, W = e[5996], e[5996] = 0, (W | 0) == 1)
                              break i;
                            if (N)
                              break r;
                            if (N = me[A + 11 | 0], N = (N & 128) >>> 7 | 0 ? e[A + 4 >> 2] : N & 127, e[r + 180 >> 2] == (N + u | 0)) {
                              if (e[5996] = 0, ji(172, A | 0, N << 1), u = e[5996], e[5996] = 0, (u | 0) == 1 || (u = (me[A + 11 | 0] & 128) >>> 7 | 0 ? (e[A + 8 >> 2] & 2147483647) - 1 | 0 : 10, e[5996] = 0, ji(172, A | 0, u | 0), u = e[5996], e[5996] = 0, (u | 0) == 1))
                                break t;
                              u = (me[A + 11 | 0] & 128) >>> 7 | 0 ? e[A >> 2] : A, e[r + 180 >> 2] = N + u;
                            }
                            if (e[5996] = 0, N = Mi(203, e[r + 332 >> 2]) | 0, W = e[5996], e[5996] = 0, (W | 0) == 1)
                              break i;
                            if (Vf(N, s, u, r + 180 | 0, r + 8 | 0, e[r + 324 >> 2], e[r + 200 >> 2], me[r + 207 | 0], r + 16 | 0, r + 12 | 0, Te))
                              break r;
                            if (e[5996] = 0, Mi(205, r + 332 | 0) | 0, N = e[5996], e[5996] = 0, (N | 0) != 1)
                              continue;
                          }
                          break;
                        }
                        break t;
                      }
                      break t;
                    }
                    N = me[r + 207 | 0];
                    r: {
                      if (!((N & 128) >>> 7 | 0 ? e[r + 200 >> 2] : N & 127) || (N = e[r + 12 >> 2], (N - (r + 16 | 0) | 0) > 159))
                        break r;
                      e[r + 12 >> 2] = N + 4, e[N >> 2] = e[r + 8 >> 2];
                    }
                    if (e[p >> 2] = zf(u, e[r + 180 >> 2], m, s), ka(r + 196 | 0, r + 16 | 0, e[r + 12 >> 2], m), e[5996] = 0, s = pi(202, r + 332 | 0, r + 328 | 0) | 0, u = e[5996], e[5996] = 0, (u | 0) != 1) {
                      s && (e[m >> 2] = e[m >> 2] | 2), s = e[r + 332 >> 2], Qn(A), Qn(r + 196 | 0), Jr = r + 336 | 0;
                      break e;
                    }
                  }
                  s = Hr() | 0, Qn(A), Qn(r + 196 | 0), Jn(s | 0), Oi();
                }
                return s | 0;
              }
              function Ng(r, s, u, A, m, p) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0, m = m | 0, p = p | 0;
                var N = 0, W = 0;
                N = e[A + 4 >> 2], A = e[A + 28 >> 2], r = Jr - 224 | 0, Jr = r, e[r + 216 >> 2] = u, e[r + 220 >> 2] = s, s = _u(N), xc(r + 200 | 0, A, r + 215 | 0), A = r + 188 | 0, e[A >> 2] = 0, e[A + 4 >> 2] = 0, e[A + 8 >> 2] = 0, u = (me[A + 11 | 0] & 128) >>> 7 | 0 ? (e[A + 8 >> 2] & 2147483647) - 1 | 0 : 10, e[5996] = 0, ji(172, A | 0, u | 0), u = e[5996], e[5996] = 0;
                e: {
                  t: {
                    r: {
                      if ((u | 0) != 1) {
                        for (u = (me[A + 11 | 0] & 128) >>> 7 | 0 ? e[A >> 2] : A, e[r + 184 >> 2] = u, e[r + 12 >> 2] = r + 16, e[r + 8 >> 2] = 0; ; ) {
                          i: {
                            if (e[5996] = 0, N = pi(186, r + 220 | 0, r + 216 | 0) | 0, W = e[5996], e[5996] = 0, (W | 0) == 1)
                              break i;
                            if (N)
                              break r;
                            if (N = me[A + 11 | 0], N = (N & 128) >>> 7 | 0 ? e[A + 4 >> 2] : N & 127, e[r + 184 >> 2] == (N + u | 0)) {
                              if (e[5996] = 0, ji(172, A | 0, N << 1), u = e[5996], e[5996] = 0, (u | 0) == 1 || (u = (me[A + 11 | 0] & 128) >>> 7 | 0 ? (e[A + 8 >> 2] & 2147483647) - 1 | 0 : 10, e[5996] = 0, ji(172, A | 0, u | 0), u = e[5996], e[5996] = 0, (u | 0) == 1))
                                break t;
                              u = (me[A + 11 | 0] & 128) >>> 7 | 0 ? e[A >> 2] : A, e[r + 184 >> 2] = N + u;
                            }
                            if (e[5996] = 0, N = Mi(187, e[r + 220 >> 2]) | 0, W = e[5996], e[5996] = 0, (W | 0) == 1)
                              break i;
                            if (Kf(N, s, u, r + 184 | 0, r + 8 | 0, _[r + 215 | 0], e[r + 204 >> 2], me[r + 211 | 0], r + 16 | 0, r + 12 | 0, 12416))
                              break r;
                            if (e[5996] = 0, Mi(189, r + 220 | 0) | 0, N = e[5996], e[5996] = 0, (N | 0) != 1)
                              continue;
                          }
                          break;
                        }
                        break t;
                      }
                      break t;
                    }
                    N = me[r + 211 | 0];
                    r: {
                      if (!((N & 128) >>> 7 | 0 ? e[r + 204 >> 2] : N & 127) || (N = e[r + 12 >> 2], (N - (r + 16 | 0) | 0) > 159))
                        break r;
                      e[r + 12 >> 2] = N + 4, e[N >> 2] = e[r + 8 >> 2];
                    }
                    if (e[p >> 2] = Zh(u, e[r + 184 >> 2], m, s), e[p + 4 >> 2] = Ds, ka(r + 200 | 0, r + 16 | 0, e[r + 12 >> 2], m), e[5996] = 0, s = pi(186, r + 220 | 0, r + 216 | 0) | 0, u = e[5996], e[5996] = 0, (u | 0) != 1) {
                      s && (e[m >> 2] = e[m >> 2] | 2), s = e[r + 220 >> 2], Qn(A), Qn(r + 200 | 0), Jr = r + 224 | 0;
                      break e;
                    }
                  }
                  s = Hr() | 0, Qn(A), Qn(r + 200 | 0), Jn(s | 0), Oi();
                }
                return s | 0;
              }
              function Pg(r, s, u, A, m, p) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0, m = m | 0, p = p | 0;
                var N = 0, W = 0;
                N = e[A + 4 >> 2], A = e[A + 28 >> 2], r = Jr - 224 | 0, Jr = r, e[r + 216 >> 2] = u, e[r + 220 >> 2] = s, s = _u(N), xc(r + 200 | 0, A, r + 215 | 0), A = r + 188 | 0, e[A >> 2] = 0, e[A + 4 >> 2] = 0, e[A + 8 >> 2] = 0, u = (me[A + 11 | 0] & 128) >>> 7 | 0 ? (e[A + 8 >> 2] & 2147483647) - 1 | 0 : 10, e[5996] = 0, ji(172, A | 0, u | 0), u = e[5996], e[5996] = 0;
                e: {
                  t: {
                    r: {
                      if ((u | 0) != 1) {
                        for (u = (me[A + 11 | 0] & 128) >>> 7 | 0 ? e[A >> 2] : A, e[r + 184 >> 2] = u, e[r + 12 >> 2] = r + 16, e[r + 8 >> 2] = 0; ; ) {
                          i: {
                            if (e[5996] = 0, N = pi(186, r + 220 | 0, r + 216 | 0) | 0, W = e[5996], e[5996] = 0, (W | 0) == 1)
                              break i;
                            if (N)
                              break r;
                            if (N = me[A + 11 | 0], N = (N & 128) >>> 7 | 0 ? e[A + 4 >> 2] : N & 127, e[r + 184 >> 2] == (N + u | 0)) {
                              if (e[5996] = 0, ji(172, A | 0, N << 1), u = e[5996], e[5996] = 0, (u | 0) == 1 || (u = (me[A + 11 | 0] & 128) >>> 7 | 0 ? (e[A + 8 >> 2] & 2147483647) - 1 | 0 : 10, e[5996] = 0, ji(172, A | 0, u | 0), u = e[5996], e[5996] = 0, (u | 0) == 1))
                                break t;
                              u = (me[A + 11 | 0] & 128) >>> 7 | 0 ? e[A >> 2] : A, e[r + 184 >> 2] = N + u;
                            }
                            if (e[5996] = 0, N = Mi(187, e[r + 220 >> 2]) | 0, W = e[5996], e[5996] = 0, (W | 0) == 1)
                              break i;
                            if (Kf(N, s, u, r + 184 | 0, r + 8 | 0, _[r + 215 | 0], e[r + 204 >> 2], me[r + 211 | 0], r + 16 | 0, r + 12 | 0, 12416))
                              break r;
                            if (e[5996] = 0, Mi(189, r + 220 | 0) | 0, N = e[5996], e[5996] = 0, (N | 0) != 1)
                              continue;
                          }
                          break;
                        }
                        break t;
                      }
                      break t;
                    }
                    N = me[r + 211 | 0];
                    r: {
                      if (!((N & 128) >>> 7 | 0 ? e[r + 204 >> 2] : N & 127) || (N = e[r + 12 >> 2], (N - (r + 16 | 0) | 0) > 159))
                        break r;
                      e[r + 12 >> 2] = N + 4, e[N >> 2] = e[r + 8 >> 2];
                    }
                    if (e[p >> 2] = af(u, e[r + 184 >> 2], m, s), e[p + 4 >> 2] = Ds, ka(r + 200 | 0, r + 16 | 0, e[r + 12 >> 2], m), e[5996] = 0, s = pi(186, r + 220 | 0, r + 216 | 0) | 0, u = e[5996], e[5996] = 0, (u | 0) != 1) {
                      s && (e[m >> 2] = e[m >> 2] | 2), s = e[r + 220 >> 2], Qn(A), Qn(r + 200 | 0), Jr = r + 224 | 0;
                      break e;
                    }
                  }
                  s = Hr() | 0, Qn(A), Qn(r + 200 | 0), Jn(s | 0), Oi();
                }
                return s | 0;
              }
              function wc(r, s) {
                var u = 0, A = 0, m = 0, p = 0, N = 0, W = 0, Te = 0, Xe = 0, fr = 0;
                e: {
                  if (!r) {
                    r = nl(8, s);
                    break e;
                  }
                  if (!s) {
                    Br(r), r = 0;
                    break e;
                  }
                  t: {
                    if (s >>> 0 > 4294967239)
                      break t;
                    W = s >>> 0 <= 8 ? 8 : s + 3 & -4, s = W + 8 | 0;
                    r: {
                      i: {
                        fr = r - 4 | 0, p = fr, m = e[p >> 2], u = m + p | 0, Xe = e[u >> 2], N = Xe + u | 0;
                        n: {
                          s: {
                            if (e[N - 4 >> 2] != (Xe | 0)) {
                              if (A = s + p | 0, A + 16 >>> 0 <= N >>> 0) {
                                m = e[u + 4 >> 2], e[m + 8 >> 2] = e[u + 8 >> 2], e[e[u + 8 >> 2] + 4 >> 2] = m, u = N - A | 0, e[A >> 2] = u, e[(A + (u & -4) | 0) - 4 >> 2] = u | 1, m = e[A >> 2] - 8 | 0;
                                a: {
                                  if (m >>> 0 <= 127) {
                                    u = (m >>> 3 | 0) - 1 | 0;
                                    break a;
                                  }
                                  if (N = Fo(m), u = ((m >>> 29 - N ^ 4) - (N << 2) | 0) + 110 | 0, m >>> 0 <= 4095)
                                    break a;
                                  u = ((m >>> 30 - N ^ 2) - (N << 1) | 0) + 71 | 0, u = u >>> 0 >= 63 ? 63 : u;
                                }
                                m = u << 4, e[A + 4 >> 2] = m + 22944, m = m + 22952 | 0, e[A + 8 >> 2] = e[m >> 2], e[m >> 2] = A, e[e[A + 8 >> 2] + 4 >> 2] = A, m = e[5995], A = u & 31, (u & 63) >>> 0 >= 32 ? (u = 1 << A, N = 0) : (N = 1 << A, u = N - 1 & 1 >>> 32 - A), e[5994] = N | e[5994], e[5995] = u | m, e[p >> 2] = s;
                                break i;
                              }
                              if (A >>> 0 > N >>> 0)
                                break s;
                              s = e[u + 4 >> 2], e[s + 8 >> 2] = e[u + 8 >> 2], e[e[u + 8 >> 2] + 4 >> 2] = s, s = m + Xe | 0, e[p >> 2] = s;
                              break i;
                            }
                            if (m >>> 0 >= s + 16 >>> 0) {
                              e[p >> 2] = s, e[(p + (s & -4) | 0) - 4 >> 2] = s, A = s + p | 0, s = m - s | 0, e[A >> 2] = s, e[(A + (s & -4) | 0) - 4 >> 2] = s | 1, u = e[A >> 2] - 8 | 0;
                              a: {
                                if (u >>> 0 <= 127) {
                                  s = (u >>> 3 | 0) - 1 | 0;
                                  break a;
                                }
                                if (p = Fo(u), s = ((u >>> 29 - p ^ 4) - (p << 2) | 0) + 110 | 0, u >>> 0 <= 4095)
                                  break a;
                                s = ((u >>> 30 - p ^ 2) - (p << 1) | 0) + 71 | 0, s = s >>> 0 >= 63 ? 63 : s;
                              }
                              u = s << 4, e[A + 4 >> 2] = u + 22944, u = u + 22952 | 0, e[A + 8 >> 2] = e[u >> 2], e[u >> 2] = A, e[e[A + 8 >> 2] + 4 >> 2] = A, u = e[5995], A = s & 31, (s & 63) >>> 0 >= 32 ? (s = 1 << A, m = 0) : (m = 1 << A, s = m - 1 & 1 >>> 32 - A), e[5994] = m | e[5994], e[5995] = s | u, A = 1;
                              break r;
                            }
                            if (A = 1, s >>> 0 <= m >>> 0)
                              break n;
                          }
                          A = 0;
                        }
                        break r;
                      }
                      e[(p + (s & -4) | 0) - 4 >> 2] = s, A = 1;
                    }
                    if (A)
                      break e;
                    if (s = nl(8, W), !s)
                      break t;
                    Te = e[fr >> 2] - 8 | 0, so(s, r, W >>> 0 < Te >>> 0 ? W : Te), Br(r), Te = s;
                  }
                  r = Te;
                }
                return r;
              }
              function qg(r, s) {
                r = r | 0, s = s | 0;
                var u = 0, A = 0, m = 0, p = 0, N = 0, W = 0, Te = 0;
                A = Jr - 160 | 0, Jr = A, e[A + 72 >> 2] = 8356, e[A + 16 >> 2] = 8336, W = A + 72 | 0, u = W, e[u + 20 >> 2] = 0, m = A + 20 | 0, e[u + 24 >> 2] = m, e[u + 12 >> 2] = 0, e[u + 4 >> 2] = 4098, e[u + 8 >> 2] = 6, e[u + 16 >> 2] = !m, nu(u + 32 | 0, 0, 40), qu(u + 28 | 0), e[A + 72 >> 2] = 8316, e[A + 16 >> 2] = 8296, e[A + 144 >> 2] = 0, e[A + 148 >> 2] = -1, e[m >> 2] = 7896, qu(m + 4 | 0), e[m + 24 >> 2] = 0, e[m + 28 >> 2] = 0, e[m + 16 >> 2] = 0, e[m + 20 >> 2] = 0, e[m + 8 >> 2] = 0, e[m + 12 >> 2] = 0, e[m >> 2] = 7960, e[A + 60 >> 2] = 0, e[A + 64 >> 2] = 0, e[A + 52 >> 2] = 0, e[A + 56 >> 2] = 0, e[A + 68 >> 2] = 16, u = e[e[A + 16 >> 2] - 12 >> 2], e[5996] = 0, N = Ll(129) | 0, p = e[5996], e[5996] = 0;
                e: {
                  t: {
                    if ((p | 0) == 1)
                      break t;
                    p = u + (A + 16 | 0) | 0, u = e[p + 28 >> 2], e[A + 12 >> 2] = u, e[u + 4 >> 2] = e[u + 4 >> 2] + 1, e[5996] = 0, gs(130, A + 156 | 0, p | 0, N | 0), u = e[5996], e[5996] = 0;
                    r: {
                      if ((u | 0) == 1)
                        break r;
                      if (u = e[A + 156 >> 2], Te = e[u + 4 >> 2] - 1 | 0, e[u + 4 >> 2] = Te, (Te | 0) == -1 && xi[e[e[u >> 2] + 8 >> 2]](u), u = e[p + 24 >> 2], u) {
                        if (p = e[e[u >> 2] + 8 >> 2], e[5996] = 0, ji(p | 0, u | 0, N | 0), p = e[5996], e[5996] = 0, (p | 0) == 1)
                          break r;
                        p = e[u + 4 >> 2], e[A + 152 >> 2] = p, e[p + 4 >> 2] = e[p + 4 >> 2] + 1, aa(u + 4 | 0, N), u = e[A + 152 >> 2], N = e[u + 4 >> 2] - 1 | 0, e[u + 4 >> 2] = N, (N | 0) == -1 && xi[e[e[u >> 2] + 8 >> 2]](u);
                      }
                      if (u = e[A + 12 >> 2], N = e[u + 4 >> 2] - 1 | 0, e[u + 4 >> 2] = N, (N | 0) == -1 && xi[e[e[u >> 2] + 8 >> 2]](u), s = e[s >> 2], e[5996] = 0, s = pi(131, A + 16 | 0, s | 0) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1 || (e[5996] = 0, ji(132, r | 0, m | 0), r = e[5996], e[5996] = 0, (r | 0) == 1))
                        break t;
                      e[s >> 2] = 8296, e[A + 72 >> 2] = 8316, e[m >> 2] = 7960, _[s + 47 | 0] < 0 && Br(e[A + 52 >> 2]), rc(m), x4(W), Jr = A + 160 | 0;
                      return;
                    }
                    r = Hr() | 0, s = e[A + 12 >> 2], m = e[s + 4 >> 2] - 1 | 0, e[s + 4 >> 2] = m, (m | 0) == -1 && xi[e[e[s >> 2] + 8 >> 2]](s);
                    break e;
                  }
                  r = Hr() | 0;
                }
                Dl(A + 16 | 0), Jn(r | 0), Oi();
              }
              function Ec(r, s, u, A, m, p) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0, m = m | 0, p = p | 0;
                var N = 0, W = 0;
                N = e[A + 4 >> 2], A = e[A + 28 >> 2], r = Jr - 224 | 0, Jr = r, e[r + 216 >> 2] = u, e[r + 220 >> 2] = s, s = _u(N), xc(r + 200 | 0, A, r + 215 | 0), A = r + 188 | 0, e[A >> 2] = 0, e[A + 4 >> 2] = 0, e[A + 8 >> 2] = 0, u = (me[A + 11 | 0] & 128) >>> 7 | 0 ? (e[A + 8 >> 2] & 2147483647) - 1 | 0 : 10, e[5996] = 0, ji(172, A | 0, u | 0), u = e[5996], e[5996] = 0;
                e: {
                  t: {
                    r: {
                      if ((u | 0) != 1) {
                        for (u = (me[A + 11 | 0] & 128) >>> 7 | 0 ? e[A >> 2] : A, e[r + 184 >> 2] = u, e[r + 12 >> 2] = r + 16, e[r + 8 >> 2] = 0; ; ) {
                          i: {
                            if (e[5996] = 0, N = pi(186, r + 220 | 0, r + 216 | 0) | 0, W = e[5996], e[5996] = 0, (W | 0) == 1)
                              break i;
                            if (N)
                              break r;
                            if (N = me[A + 11 | 0], N = (N & 128) >>> 7 | 0 ? e[A + 4 >> 2] : N & 127, e[r + 184 >> 2] == (N + u | 0)) {
                              if (e[5996] = 0, ji(172, A | 0, N << 1), u = e[5996], e[5996] = 0, (u | 0) == 1 || (u = (me[A + 11 | 0] & 128) >>> 7 | 0 ? (e[A + 8 >> 2] & 2147483647) - 1 | 0 : 10, e[5996] = 0, ji(172, A | 0, u | 0), u = e[5996], e[5996] = 0, (u | 0) == 1))
                                break t;
                              u = (me[A + 11 | 0] & 128) >>> 7 | 0 ? e[A >> 2] : A, e[r + 184 >> 2] = N + u;
                            }
                            if (e[5996] = 0, N = Mi(187, e[r + 220 >> 2]) | 0, W = e[5996], e[5996] = 0, (W | 0) == 1)
                              break i;
                            if (Kf(N, s, u, r + 184 | 0, r + 8 | 0, _[r + 215 | 0], e[r + 204 >> 2], me[r + 211 | 0], r + 16 | 0, r + 12 | 0, 12416))
                              break r;
                            if (e[5996] = 0, Mi(189, r + 220 | 0) | 0, N = e[5996], e[5996] = 0, (N | 0) != 1)
                              continue;
                          }
                          break;
                        }
                        break t;
                      }
                      break t;
                    }
                    N = me[r + 211 | 0];
                    r: {
                      if (!((N & 128) >>> 7 | 0 ? e[r + 204 >> 2] : N & 127) || (N = e[r + 12 >> 2], (N - (r + 16 | 0) | 0) > 159))
                        break r;
                      e[r + 12 >> 2] = N + 4, e[N >> 2] = e[r + 8 >> 2];
                    }
                    if (e[p >> 2] = zf(u, e[r + 184 >> 2], m, s), ka(r + 200 | 0, r + 16 | 0, e[r + 12 >> 2], m), e[5996] = 0, s = pi(186, r + 220 | 0, r + 216 | 0) | 0, u = e[5996], e[5996] = 0, (u | 0) != 1) {
                      s && (e[m >> 2] = e[m >> 2] | 2), s = e[r + 220 >> 2], Qn(A), Qn(r + 200 | 0), Jr = r + 224 | 0;
                      break e;
                    }
                  }
                  s = Hr() | 0, Qn(A), Qn(r + 200 | 0), Jn(s | 0), Oi();
                }
                return s | 0;
              }
              function td(r, s, u, A, m, p) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0, m = m | 0, p = p | 0;
                var N = 0, W = 0;
                N = e[A + 4 >> 2], A = e[A + 28 >> 2], r = Jr - 224 | 0, Jr = r, e[r + 216 >> 2] = u, e[r + 220 >> 2] = s, s = _u(N), xc(r + 200 | 0, A, r + 215 | 0), A = r + 188 | 0, e[A >> 2] = 0, e[A + 4 >> 2] = 0, e[A + 8 >> 2] = 0, u = (me[A + 11 | 0] & 128) >>> 7 | 0 ? (e[A + 8 >> 2] & 2147483647) - 1 | 0 : 10, e[5996] = 0, ji(172, A | 0, u | 0), u = e[5996], e[5996] = 0;
                e: {
                  t: {
                    r: {
                      if ((u | 0) != 1) {
                        for (u = (me[A + 11 | 0] & 128) >>> 7 | 0 ? e[A >> 2] : A, e[r + 184 >> 2] = u, e[r + 12 >> 2] = r + 16, e[r + 8 >> 2] = 0; ; ) {
                          i: {
                            if (e[5996] = 0, N = pi(186, r + 220 | 0, r + 216 | 0) | 0, W = e[5996], e[5996] = 0, (W | 0) == 1)
                              break i;
                            if (N)
                              break r;
                            if (N = me[A + 11 | 0], N = (N & 128) >>> 7 | 0 ? e[A + 4 >> 2] : N & 127, e[r + 184 >> 2] == (N + u | 0)) {
                              if (e[5996] = 0, ji(172, A | 0, N << 1), u = e[5996], e[5996] = 0, (u | 0) == 1 || (u = (me[A + 11 | 0] & 128) >>> 7 | 0 ? (e[A + 8 >> 2] & 2147483647) - 1 | 0 : 10, e[5996] = 0, ji(172, A | 0, u | 0), u = e[5996], e[5996] = 0, (u | 0) == 1))
                                break t;
                              u = (me[A + 11 | 0] & 128) >>> 7 | 0 ? e[A >> 2] : A, e[r + 184 >> 2] = N + u;
                            }
                            if (e[5996] = 0, N = Mi(187, e[r + 220 >> 2]) | 0, W = e[5996], e[5996] = 0, (W | 0) == 1)
                              break i;
                            if (Kf(N, s, u, r + 184 | 0, r + 8 | 0, _[r + 215 | 0], e[r + 204 >> 2], me[r + 211 | 0], r + 16 | 0, r + 12 | 0, 12416))
                              break r;
                            if (e[5996] = 0, Mi(189, r + 220 | 0) | 0, N = e[5996], e[5996] = 0, (N | 0) != 1)
                              continue;
                          }
                          break;
                        }
                        break t;
                      }
                      break t;
                    }
                    N = me[r + 211 | 0];
                    r: {
                      if (!((N & 128) >>> 7 | 0 ? e[r + 204 >> 2] : N & 127) || (N = e[r + 12 >> 2], (N - (r + 16 | 0) | 0) > 159))
                        break r;
                      e[r + 12 >> 2] = N + 4, e[N >> 2] = e[r + 8 >> 2];
                    }
                    if (e[p >> 2] = Ed(u, e[r + 184 >> 2], m, s), ka(r + 200 | 0, r + 16 | 0, e[r + 12 >> 2], m), e[5996] = 0, s = pi(186, r + 220 | 0, r + 216 | 0) | 0, u = e[5996], e[5996] = 0, (u | 0) != 1) {
                      s && (e[m >> 2] = e[m >> 2] | 2), s = e[r + 220 >> 2], Qn(A), Qn(r + 200 | 0), Jr = r + 224 | 0;
                      break e;
                    }
                  }
                  s = Hr() | 0, Qn(A), Qn(r + 200 | 0), Jn(s | 0), Oi();
                }
                return s | 0;
              }
              function Og(r, s, u, A, m, p) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0, m = m | 0, p = p | 0;
                var N = 0, W = 0;
                N = e[A + 4 >> 2], A = e[A + 28 >> 2], r = Jr - 224 | 0, Jr = r, e[r + 216 >> 2] = u, e[r + 220 >> 2] = s, s = _u(N), xc(r + 200 | 0, A, r + 215 | 0), A = r + 188 | 0, e[A >> 2] = 0, e[A + 4 >> 2] = 0, e[A + 8 >> 2] = 0, u = (me[A + 11 | 0] & 128) >>> 7 | 0 ? (e[A + 8 >> 2] & 2147483647) - 1 | 0 : 10, e[5996] = 0, ji(172, A | 0, u | 0), u = e[5996], e[5996] = 0;
                e: {
                  t: {
                    r: {
                      if ((u | 0) != 1) {
                        for (u = (me[A + 11 | 0] & 128) >>> 7 | 0 ? e[A >> 2] : A, e[r + 184 >> 2] = u, e[r + 12 >> 2] = r + 16, e[r + 8 >> 2] = 0; ; ) {
                          i: {
                            if (e[5996] = 0, N = pi(186, r + 220 | 0, r + 216 | 0) | 0, W = e[5996], e[5996] = 0, (W | 0) == 1)
                              break i;
                            if (N)
                              break r;
                            if (N = me[A + 11 | 0], N = (N & 128) >>> 7 | 0 ? e[A + 4 >> 2] : N & 127, e[r + 184 >> 2] == (N + u | 0)) {
                              if (e[5996] = 0, ji(172, A | 0, N << 1), u = e[5996], e[5996] = 0, (u | 0) == 1 || (u = (me[A + 11 | 0] & 128) >>> 7 | 0 ? (e[A + 8 >> 2] & 2147483647) - 1 | 0 : 10, e[5996] = 0, ji(172, A | 0, u | 0), u = e[5996], e[5996] = 0, (u | 0) == 1))
                                break t;
                              u = (me[A + 11 | 0] & 128) >>> 7 | 0 ? e[A >> 2] : A, e[r + 184 >> 2] = N + u;
                            }
                            if (e[5996] = 0, N = Mi(187, e[r + 220 >> 2]) | 0, W = e[5996], e[5996] = 0, (W | 0) == 1)
                              break i;
                            if (Kf(N, s, u, r + 184 | 0, r + 8 | 0, _[r + 215 | 0], e[r + 204 >> 2], me[r + 211 | 0], r + 16 | 0, r + 12 | 0, 12416))
                              break r;
                            if (e[5996] = 0, Mi(189, r + 220 | 0) | 0, N = e[5996], e[5996] = 0, (N | 0) != 1)
                              continue;
                          }
                          break;
                        }
                        break t;
                      }
                      break t;
                    }
                    N = me[r + 211 | 0];
                    r: {
                      if (!((N & 128) >>> 7 | 0 ? e[r + 204 >> 2] : N & 127) || (N = e[r + 12 >> 2], (N - (r + 16 | 0) | 0) > 159))
                        break r;
                      e[r + 12 >> 2] = N + 4, e[N >> 2] = e[r + 8 >> 2];
                    }
                    if (Zs[p >> 1] = Vh(u, e[r + 184 >> 2], m, s), ka(r + 200 | 0, r + 16 | 0, e[r + 12 >> 2], m), e[5996] = 0, s = pi(186, r + 220 | 0, r + 216 | 0) | 0, u = e[5996], e[5996] = 0, (u | 0) != 1) {
                      s && (e[m >> 2] = e[m >> 2] | 2), s = e[r + 220 >> 2], Qn(A), Qn(r + 200 | 0), Jr = r + 224 | 0;
                      break e;
                    }
                  }
                  s = Hr() | 0, Qn(A), Qn(r + 200 | 0), Jn(s | 0), Oi();
                }
                return s | 0;
              }
              function Wu(r, s, u, A, m, p, N, W) {
                var Te = 0, Xe = 0, fr = 0;
                if (Te = Jr - 16 | 0, Jr = Te, e[Te + 8 >> 2] = u, e[Te + 12 >> 2] = s, s = e[A + 28 >> 2], e[Te + 4 >> 2] = s, e[s + 4 >> 2] = e[s + 4 >> 2] + 1, s = 0, e[5996] = 0, Xe = Mi(197, e[Te + 4 >> 2]) | 0, u = e[5996], e[5996] = 0, (u | 0) != 1) {
                  u = e[Te + 4 >> 2], fr = e[u + 4 >> 2] - 1 | 0, e[u + 4 >> 2] = fr, (fr | 0) == -1 && xi[e[e[u >> 2] + 8 >> 2]](u), e[m >> 2] = 0;
                  e: {
                    for (; ; ) {
                      if (s | (N | 0) == (W | 0))
                        break e;
                      t: {
                        if (Hu(Te + 12 | 0, Te + 8 | 0))
                          break t;
                        r: {
                          if ((xi[e[e[Xe >> 2] + 52 >> 2]](Xe, e[N >> 2], 0) | 0) == 37) {
                            if ((N + 4 | 0) == (W | 0))
                              break t;
                            s = xi[e[e[Xe >> 2] + 52 >> 2]](Xe, e[N + 4 >> 2], 0) | 0;
                            i: {
                              if (!((s | 0) == 69 | (s & 255) == 48)) {
                                u = 0, fr = 1;
                                break i;
                              }
                              if ((N + 8 | 0) == (W | 0))
                                break t;
                              u = s, s = xi[e[e[Xe >> 2] + 52 >> 2]](Xe, e[N + 8 >> 2], 0) | 0, fr = 2;
                            }
                            e[Te + 12 >> 2] = xi[e[e[r >> 2] + 36 >> 2]](r, e[Te + 12 >> 2], e[Te + 8 >> 2], A, m, p, s, u), N = ((fr << 2) + N | 0) + 4 | 0;
                            break r;
                          }
                          if (xi[e[e[Xe >> 2] + 12 >> 2]](Xe, 1, e[N >> 2]) | 0) {
                            for (; ; ) {
                              i: {
                                if (N = N + 4 | 0, (W | 0) == (N | 0)) {
                                  N = W;
                                  break i;
                                }
                                if (xi[e[e[Xe >> 2] + 12 >> 2]](Xe, 1, e[N >> 2]) | 0)
                                  continue;
                              }
                              break;
                            }
                            for (; ; ) {
                              if (fr = Te + 12 | 0, Hu(fr, Te + 8 | 0))
                                break r;
                              s = e[Te + 12 >> 2], u = e[s + 12 >> 2];
                              i: {
                                if ((u | 0) == e[s + 16 >> 2]) {
                                  s = xi[e[e[s >> 2] + 36 >> 2]](s) | 0;
                                  break i;
                                }
                                s = e[u >> 2];
                              }
                              if (!(xi[e[e[Xe >> 2] + 12 >> 2]](Xe, 1, s) | 0))
                                break r;
                              Ul(fr);
                            }
                          }
                          s = e[Te + 12 >> 2], u = e[s + 12 >> 2];
                          i: {
                            if ((u | 0) == e[s + 16 >> 2]) {
                              s = xi[e[e[s >> 2] + 36 >> 2]](s) | 0;
                              break i;
                            }
                            s = e[u >> 2];
                          }
                          if ((xi[e[e[Xe >> 2] + 28 >> 2]](Xe, s) | 0) == (xi[e[e[Xe >> 2] + 28 >> 2]](Xe, e[N >> 2]) | 0)) {
                            N = N + 4 | 0, Ul(Te + 12 | 0);
                            break r;
                          }
                          e[m >> 2] = 4;
                        }
                        s = e[m >> 2];
                        continue;
                      }
                      break;
                    }
                    e[m >> 2] = 4;
                  }
                  return Hu(Te + 12 | 0, Te + 8 | 0) && (e[m >> 2] = e[m >> 2] | 2), Jr = Te + 16 | 0, e[Te + 12 >> 2];
                }
                u = Hr() | 0, r = e[Te + 4 >> 2], s = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = s, (s | 0) == -1 && xi[e[e[r >> 2] + 8 >> 2]](r), Jn(u | 0), Oi();
              }
              function Qg(r, s, u, A, m) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0, m = +m;
                var p = 0, N = 0, W = 0, Te = 0, Xe = 0, fr = 0, ar = 0, vr = 0;
                ar = s, p = Jr - 208 | 0, Jr = p, e[p + 200 >> 2] = 37, e[p + 204 >> 2] = 0, s = p + 200 | 0, W = Pc(s | 1, 5575, e[u + 4 >> 2]), N = p + 160 | 0, e[p + 156 >> 2] = N, r = ko();
                e: {
                  if (W) {
                    Te = e[u + 8 >> 2], jn[p + 40 >> 3] = m, e[p + 32 >> 2] = Te, N = oa(N, 30, r, s, p + 32 | 0);
                    break e;
                  }
                  jn[p + 48 >> 3] = m, N = oa(p + 160 | 0, 30, r, p + 200 | 0, p + 48 | 0);
                }
                e[p + 80 >> 2] = 184, Te = p + 148 | 0, e[Te >> 2] = 0, e[Te + 4 >> 2] = e[p + 80 >> 2], s = p + 160 | 0, r = s;
                e: {
                  t: {
                    r: {
                      i: {
                        if ((N | 0) >= 30) {
                          r = ko();
                          n: {
                            if (W) {
                              N = e[u + 8 >> 2], jn[p + 8 >> 3] = m, e[p >> 2] = N, N = Iu(p + 156 | 0, r, p + 200 | 0, p);
                              break n;
                            }
                            jn[p + 16 >> 3] = m, N = Iu(p + 156 | 0, r, p + 200 | 0, p + 16 | 0);
                          }
                          if ((N | 0) == -1) {
                            if (e[5996] = 0, Nn(185), r = e[5996], e[5996] = 0, (r | 0) == 1)
                              break r;
                            break i;
                          }
                          r = e[p + 156 >> 2], ia(Te, r);
                        }
                        fr = r + N | 0, vr = Xa(r, fr, e[u + 4 >> 2]), e[p + 68 >> 2] = 184, W = p + 72 | 0, e[W >> 2] = 0, e[W + 4 >> 2] = e[p + 68 >> 2];
                        n: {
                          s: {
                            if ((p + 160 | 0) == (r | 0)) {
                              N = p + 80 | 0;
                              break s;
                            }
                            if (N = da(N << 1), !N) {
                              if (e[5996] = 0, Nn(185), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                break i;
                              r = Hr() | 0;
                              break n;
                            }
                            ia(W, N), s = r;
                          }
                          r = p + 60 | 0, Xe = e[u + 28 >> 2], e[r >> 2] = Xe, e[Xe + 4 >> 2] = e[Xe + 4 >> 2] + 1, e[5996] = 0, au(212, s | 0, vr | 0, fr | 0, N | 0, p + 68 | 0, p - -64 | 0, r | 0), s = e[5996], e[5996] = 0;
                          s: {
                            if ((s | 0) != 1) {
                              if (r = e[r >> 2], s = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = s, (s | 0) == -1 && xi[e[e[r >> 2] + 8 >> 2]](r), e[5996] = 0, r = za(213, ar | 0, N | 0, e[p + 68 >> 2], e[p + 64 >> 2], u | 0, A | 0) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1)
                                break s;
                              to(W), to(Te), Jr = p + 208 | 0;
                              break e;
                            }
                            r = Hr() | 0, s = e[p + 60 >> 2], u = e[s + 4 >> 2] - 1 | 0, e[s + 4 >> 2] = u, (u | 0) == -1 && xi[e[e[s >> 2] + 8 >> 2]](s);
                            break n;
                          }
                          r = Hr() | 0;
                        }
                        to(W);
                        break t;
                      }
                      Oi();
                    }
                    r = Hr() | 0;
                  }
                  to(Te), Jn(r | 0), Oi();
                }
                return r | 0;
              }
              function rd(r, s, u, A, m) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0, m = +m;
                var p = 0, N = 0, W = 0, Te = 0, Xe = 0, fr = 0, ar = 0, vr = 0;
                ar = s, p = Jr - 368 | 0, Jr = p, e[p + 360 >> 2] = 37, e[p + 364 >> 2] = 0, s = p + 360 | 0, W = Pc(s | 1, 5575, e[u + 4 >> 2]), N = p + 320 | 0, e[p + 316 >> 2] = N, r = ko();
                e: {
                  if (W) {
                    Te = e[u + 8 >> 2], jn[p + 40 >> 3] = m, e[p + 32 >> 2] = Te, N = oa(N, 30, r, s, p + 32 | 0);
                    break e;
                  }
                  jn[p + 48 >> 3] = m, N = oa(p + 320 | 0, 30, r, p + 360 | 0, p + 48 | 0);
                }
                e[p + 80 >> 2] = 184, Te = p + 308 | 0, e[Te >> 2] = 0, e[Te + 4 >> 2] = e[p + 80 >> 2], s = p + 320 | 0, r = s;
                e: {
                  t: {
                    r: {
                      i: {
                        if ((N | 0) >= 30) {
                          r = ko();
                          n: {
                            if (W) {
                              N = e[u + 8 >> 2], jn[p + 8 >> 3] = m, e[p >> 2] = N, N = Iu(p + 316 | 0, r, p + 360 | 0, p);
                              break n;
                            }
                            jn[p + 16 >> 3] = m, N = Iu(p + 316 | 0, r, p + 360 | 0, p + 16 | 0);
                          }
                          if ((N | 0) == -1) {
                            if (e[5996] = 0, Nn(185), r = e[5996], e[5996] = 0, (r | 0) == 1)
                              break r;
                            break i;
                          }
                          r = e[p + 316 >> 2], ia(Te, r);
                        }
                        fr = r + N | 0, vr = Xa(r, fr, e[u + 4 >> 2]), e[p + 68 >> 2] = 184, W = p + 72 | 0, e[W >> 2] = 0, e[W + 4 >> 2] = e[p + 68 >> 2];
                        n: {
                          s: {
                            if ((p + 320 | 0) == (r | 0)) {
                              N = p + 80 | 0;
                              break s;
                            }
                            if (N = da(N << 3), !N) {
                              if (e[5996] = 0, Nn(185), r = e[5996], e[5996] = 0, (r | 0) != 1)
                                break i;
                              r = Hr() | 0;
                              break n;
                            }
                            ia(W, N), s = r;
                          }
                          r = p + 60 | 0, Xe = e[u + 28 >> 2], e[r >> 2] = Xe, e[Xe + 4 >> 2] = e[Xe + 4 >> 2] + 1, e[5996] = 0, au(218, s | 0, vr | 0, fr | 0, N | 0, p + 68 | 0, p - -64 | 0, r | 0), s = e[5996], e[5996] = 0;
                          s: {
                            if ((s | 0) != 1) {
                              if (r = e[r >> 2], s = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = s, (s | 0) == -1 && xi[e[e[r >> 2] + 8 >> 2]](r), e[5996] = 0, r = za(219, ar | 0, N | 0, e[p + 68 >> 2], e[p + 64 >> 2], u | 0, A | 0) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1)
                                break s;
                              to(W), to(Te), Jr = p + 368 | 0;
                              break e;
                            }
                            r = Hr() | 0, s = e[p + 60 >> 2], u = e[s + 4 >> 2] - 1 | 0, e[s + 4 >> 2] = u, (u | 0) == -1 && xi[e[e[s >> 2] + 8 >> 2]](s);
                            break n;
                          }
                          r = Hr() | 0;
                        }
                        to(W);
                        break t;
                      }
                      Oi();
                    }
                    r = Hr() | 0;
                  }
                  to(Te), Jn(r | 0), Oi();
                }
                return r | 0;
              }
              function bc(r, s, u, A, m, p, N, W) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0, m = m | 0, p = p | 0, N = N | 0, W = W | 0;
                var Te = 0, Xe = 0, fr = 0, ar = 0, vr = 0, _r = 0, hi = 0, mi = 0, Ni = 0, Hi = 0, Ji = 0;
                for (_r = Jr - 16 | 0, Jr = _r, s = u; ; ) {
                  e: {
                    if ((s | 0) == (A | 0)) {
                      s = A;
                      break e;
                    }
                    if (!e[s >> 2])
                      break e;
                    s = s + 4 | 0;
                    continue;
                  }
                  break;
                }
                for (e[W >> 2] = p, e[m >> 2] = u; ; ) {
                  e: {
                    t: {
                      if (!((u | 0) == (A | 0) | (p | 0) == (N | 0))) {
                        Ni = 1, Hi = Jr - 16 | 0, Jr = Hi, Ji = Uu(Hi + 12 | 0, e[r + 8 >> 2]), Te = p, Xe = N - Te | 0, vr = 0, hi = Jr - 16 | 0, Jr = hi, fr = e[m >> 2], mi = s - u >> 2;
                        r: {
                          if (!fr | !mi)
                            break r;
                          for (Xe = Te ? Xe : 0; ; ) {
                            if (ar = vd(Xe >>> 0 < 4 ? hi + 12 | 0 : Te, e[fr >> 2]), (ar | 0) == -1) {
                              vr = -1;
                              break r;
                            }
                            if (Te) {
                              if (Xe >>> 0 <= 3) {
                                if (Xe >>> 0 < ar >>> 0)
                                  break r;
                                so(Te, hi + 12 | 0, ar);
                              }
                              Xe = Xe - ar | 0, Te = Te + ar | 0;
                            } else
                              Te = 0;
                            if (!e[fr >> 2]) {
                              fr = 0;
                              break r;
                            }
                            if (vr = vr + ar | 0, fr = fr + 4 | 0, mi = mi - 1 | 0, !mi)
                              break;
                          }
                        }
                        Te && (e[m >> 2] = fr), Jr = hi + 16 | 0, Te = e[Ji >> 2], Te && (e[6178] = (Te | 0) == -1 ? 24816 : Te), Jr = Hi + 16 | 0;
                        r: {
                          i: {
                            n: {
                              s:
                                switch (vr + 1 | 0) {
                                  case 0:
                                    for (e[W >> 2] = p; ; ) {
                                      a: {
                                        if (e[m >> 2] == (u | 0) || (s = Nl(p, e[u >> 2], e[r + 8 >> 2]), (s | 0) == -1))
                                          break a;
                                        p = s + e[W >> 2] | 0, e[W >> 2] = p, u = u + 4 | 0;
                                        continue;
                                      }
                                      break;
                                    }
                                    e[m >> 2] = u;
                                    break n;
                                  case 1:
                                    break t;
                                  default:
                                    break s;
                                }
                              if (p = vr + e[W >> 2] | 0, e[W >> 2] = p, (p | 0) == (N | 0))
                                break r;
                              if ((s | 0) == (A | 0)) {
                                u = e[m >> 2], s = A;
                                continue;
                              }
                              if (s = Nl(_r + 12 | 0, 0, e[r + 8 >> 2]), (s | 0) != -1)
                                break i;
                            }
                            Ni = 2;
                            break t;
                          }
                          if (u = _r + 12 | 0, N - e[W >> 2] >>> 0 < s >>> 0)
                            break t;
                          for (; ; ) {
                            if (s) {
                              p = me[u | 0], Te = e[W >> 2], e[W >> 2] = Te + 1, _[Te | 0] = p, s = s - 1 | 0, u = u + 1 | 0;
                              continue;
                            }
                            break;
                          }
                          for (u = e[m >> 2] + 4 | 0, e[m >> 2] = u, s = u; ; ) {
                            if ((s | 0) == (A | 0)) {
                              s = A;
                              break e;
                            }
                            if (!e[s >> 2])
                              break e;
                            s = s + 4 | 0;
                          }
                        }
                        u = e[m >> 2];
                      }
                      Ni = (u | 0) != (A | 0);
                    }
                    return Jr = _r + 16 | 0, Ni | 0;
                  }
                  p = e[W >> 2];
                }
              }
              function bh(r, s, u, A, m, p, N) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0, m = m | 0, p = p | 0, N = N | 0;
                var W = 0, Te = 0, Xe = 0, fr = 0, ar = 0, vr = 0, _r = 0, hi = 0;
                fr = Jr - 16 | 0, Jr = fr, vr = b4(e[N >> 2]), N = C4(e[N >> 2]), xi[e[e[N >> 2] + 20 >> 2]](fr + 4 | 0, N);
                e: {
                  Xe = me[fr + 15 | 0];
                  t: {
                    if (!((Xe & 128) >>> 7 | 0 ? e[fr + 8 >> 2] : Xe & 127)) {
                      if (e[5996] = 0, Vs(208, vr | 0, r | 0, u | 0, A | 0), N = e[5996], e[5996] = 0, (N | 0) == 1)
                        break t;
                      N = (u - r << 2) + A | 0, e[p >> 2] = N;
                      break e;
                    }
                    e[p >> 2] = A;
                    r: {
                      i:
                        switch (Xe = r, Te = me[Xe | 0], Te - 43 | 0) {
                          case 0:
                          case 2:
                            break i;
                          default:
                            break r;
                        }
                      if (e[5996] = 0, Xe = pi(216, vr | 0, Te << 24 >> 24) | 0, Te = e[5996], e[5996] = 0, (Te | 0) == 1)
                        break t;
                      Te = e[p >> 2], e[p >> 2] = Te + 4, e[Te >> 2] = Xe, Xe = r + 1 | 0;
                    }
                    if (!(me[Xe | 0] != 48 | (u - Xe | 0) < 2 | (me[Xe + 1 | 0] | 32) != 120)) {
                      if (e[5996] = 0, Te = pi(216, vr | 0, 48) | 0, W = e[5996], e[5996] = 0, (W | 0) == 1 || (W = e[p >> 2], e[p >> 2] = W + 4, e[W >> 2] = Te, Te = _[Xe + 1 | 0], e[5996] = 0, Te = pi(216, vr | 0, Te | 0) | 0, W = e[5996], e[5996] = 0, (W | 0) == 1))
                        break t;
                      W = e[p >> 2], e[p >> 2] = W + 4, e[W >> 2] = Te, Xe = Xe + 2 | 0;
                    }
                    if (du(Xe, u), e[5996] = 0, hi = Mi(206, N | 0) | 0, N = e[5996], e[5996] = 0, (N | 0) == 1)
                      break t;
                    for (Te = 0, N = Xe; ; ) {
                      if (u >>> 0 <= N >>> 0) {
                        hf((Xe - r << 2) + A | 0, e[p >> 2]), N = e[p >> 2];
                        break e;
                      }
                      if (W = fr + 4 | 0, ar = (me[W + 11 | 0] & 128) >>> 7 | 0, !me[(ar ? e[W >> 2] : W) + Te | 0] | _[(ar ? e[W >> 2] : W) + Te | 0] != (_r | 0) || (W = e[p >> 2], e[p >> 2] = W + 4, e[W >> 2] = hi, _r = 0, ar = Te, Te = me[fr + 15 | 0], Te = ar + (ar >>> 0 < ((Te & 128) >>> 7 | 0 ? e[fr + 8 >> 2] : Te & 127) - 1 >>> 0) | 0), W = _[N | 0], e[5996] = 0, W = pi(216, vr | 0, W | 0) | 0, ar = e[5996], e[5996] = 0, (ar | 0) != 1) {
                        ar = e[p >> 2], e[p >> 2] = ar + 4, e[ar >> 2] = W, N = N + 1 | 0, _r = _r + 1 | 0;
                        continue;
                      }
                      break;
                    }
                  }
                  r = Hr() | 0, Qn(fr + 4 | 0), Jn(r | 0), Oi();
                }
                e[m >> 2] = (s | 0) == (u | 0) ? N : (s - r << 2) + A | 0, Qn(fr + 4 | 0), Jr = fr + 16 | 0;
              }
              function nd(r, s, u, A, m, p, N) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0, m = m | 0, p = p | 0, N = N | 0;
                var W = 0, Te = 0, Xe = 0, fr = 0, ar = 0, vr = 0, _r = 0, hi = 0;
                fr = Jr - 16 | 0, Jr = fr, vr = w4(e[N >> 2]), N = B4(e[N >> 2]), xi[e[e[N >> 2] + 20 >> 2]](fr + 4 | 0, N);
                e: {
                  Xe = me[fr + 15 | 0];
                  t: {
                    if (!((Xe & 128) >>> 7 | 0 ? e[fr + 8 >> 2] : Xe & 127)) {
                      if (e[5996] = 0, Vs(195, vr | 0, r | 0, u | 0, A | 0), N = e[5996], e[5996] = 0, (N | 0) == 1)
                        break t;
                      N = (u - r | 0) + A | 0, e[p >> 2] = N;
                      break e;
                    }
                    e[p >> 2] = A;
                    r: {
                      i:
                        switch (Xe = r, Te = me[Xe | 0], Te - 43 | 0) {
                          case 0:
                          case 2:
                            break i;
                          default:
                            break r;
                        }
                      if (e[5996] = 0, Xe = pi(171, vr | 0, Te << 24 >> 24) | 0, Te = e[5996], e[5996] = 0, (Te | 0) == 1)
                        break t;
                      Te = e[p >> 2], e[p >> 2] = Te + 1, _[Te | 0] = Xe, Xe = r + 1 | 0;
                    }
                    if (!(me[Xe | 0] != 48 | (u - Xe | 0) < 2 | (me[Xe + 1 | 0] | 32) != 120)) {
                      if (e[5996] = 0, Te = pi(171, vr | 0, 48) | 0, W = e[5996], e[5996] = 0, (W | 0) == 1 || (W = e[p >> 2], e[p >> 2] = W + 1, _[W | 0] = Te, Te = _[Xe + 1 | 0], e[5996] = 0, Te = pi(171, vr | 0, Te | 0) | 0, W = e[5996], e[5996] = 0, (W | 0) == 1))
                        break t;
                      W = e[p >> 2], e[p >> 2] = W + 1, _[W | 0] = Te, Xe = Xe + 2 | 0;
                    }
                    if (du(Xe, u), e[5996] = 0, hi = Mi(193, N | 0) | 0, N = e[5996], e[5996] = 0, (N | 0) == 1)
                      break t;
                    for (Te = 0, N = Xe; ; ) {
                      if (u >>> 0 <= N >>> 0) {
                        du((Xe - r | 0) + A | 0, e[p >> 2]), N = e[p >> 2];
                        break e;
                      }
                      if (W = fr + 4 | 0, ar = (me[W + 11 | 0] & 128) >>> 7 | 0, !me[(ar ? e[W >> 2] : W) + Te | 0] | _[(ar ? e[W >> 2] : W) + Te | 0] != (_r | 0) || (W = e[p >> 2], e[p >> 2] = W + 1, _[W | 0] = hi, _r = 0, ar = Te, Te = me[fr + 15 | 0], Te = ar + (ar >>> 0 < ((Te & 128) >>> 7 | 0 ? e[fr + 8 >> 2] : Te & 127) - 1 >>> 0) | 0), W = _[N | 0], e[5996] = 0, W = pi(171, vr | 0, W | 0) | 0, ar = e[5996], e[5996] = 0, (ar | 0) != 1) {
                        ar = e[p >> 2], e[p >> 2] = ar + 1, _[ar | 0] = W, N = N + 1 | 0, _r = _r + 1 | 0;
                        continue;
                      }
                      break;
                    }
                  }
                  r = Hr() | 0, Qn(fr + 4 | 0), Jn(r | 0), Oi();
                }
                e[m >> 2] = (s | 0) == (u | 0) ? N : (s - r | 0) + A | 0, Qn(fr + 4 | 0), Jr = fr + 16 | 0;
              }
              function sd(r, s, u, A, m, p, N, W) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0, m = m | 0, p = p | 0, N = N | 0, W = W | 0;
                var Te = 0, Xe = 0, fr = 0;
                r = Jr - 16 | 0, Jr = r, e[r + 12 >> 2] = u, e[r + 8 >> 2] = p, e[r + 12 >> 2] = u, e[r + 8 >> 2] = p;
                e: {
                  t: {
                    r: {
                      for (; ; ) {
                        if (u = e[r + 12 >> 2], !(u >>> 0 >= A >>> 0 | p >>> 0 >= N >>> 0)) {
                          Te = _[u | 0], Xe = Te & 255;
                          i: {
                            if ((Te | 0) >= 0) {
                              Zs[p >> 1] = Xe, s = u + 1 | 0;
                              break i;
                            }
                            if (s = 2, Te >>> 0 < 4294967234)
                              break t;
                            if (Te >>> 0 <= 4294967263) {
                              if ((A - u | 0) < 2)
                                break r;
                              if (Te = me[u + 1 | 0], (Te & 192) != 128)
                                break e;
                              Zs[p >> 1] = Te & 63 | Xe << 6 & 1984, s = u + 2 | 0;
                              break i;
                            }
                            if (Te >>> 0 <= 4294967279) {
                              if ((A - u | 0) < 3)
                                break r;
                              fr = me[u + 2 | 0], Te = me[u + 1 | 0];
                              n: {
                                s: {
                                  if ((Xe | 0) != 237) {
                                    if ((Xe | 0) != 224)
                                      break s;
                                    if ((Te & 224) == 160)
                                      break n;
                                    break e;
                                  }
                                  if ((Te & 224) == 128)
                                    break n;
                                  break e;
                                }
                                if ((Te & 192) != 128)
                                  break e;
                              }
                              if ((fr & 192) != 128)
                                break e;
                              Zs[p >> 1] = fr & 63 | ((Te & 63) << 6 | Xe << 12), s = u + 3 | 0;
                              break i;
                            }
                            if (Te >>> 0 > 4294967284)
                              break t;
                            if (s = 1, (A - u | 0) < 4)
                              break e;
                            fr = me[u + 3 | 0], Te = me[u + 2 | 0], u = me[u + 1 | 0];
                            n: {
                              s:
                                switch (Xe - 240 | 0) {
                                  case 0:
                                    if ((u + 112 & 255) >>> 0 >= 48)
                                      break t;
                                    break n;
                                  case 4:
                                    if ((u & 240) != 128)
                                      break t;
                                    break n;
                                  default:
                                    break s;
                                }
                              if ((u & 192) != 128)
                                break t;
                            }
                            if ((Te & 192) != 128 | (fr & 192) != 128)
                              break t;
                            if ((N - p | 0) < 4 || (s = 2, Xe = Xe & 7, (u << 12 & 196608 | Xe << 18) >>> 0 > 1114111))
                              break e;
                            s = u << 2, Zs[p >> 1] = (Te >>> 4 & 3 | (s & 192 | Xe << 8 | s & 60)) + 16320 | 55296, e[r + 8 >> 2] = p + 2, Zs[p + 2 >> 1] = Te << 6 & 960 | fr & 63 | 56320, s = e[r + 12 >> 2] + 4 | 0;
                          }
                          e[r + 12 >> 2] = s, p = e[r + 8 >> 2] + 2 | 0, e[r + 8 >> 2] = p;
                          continue;
                        }
                        break;
                      }
                      s = u >>> 0 < A >>> 0;
                      break e;
                    }
                    s = 1;
                    break e;
                  }
                  s = 2;
                }
                return e[m >> 2] = e[r + 12 >> 2], e[W >> 2] = e[r + 8 >> 2], Jr = r + 16 | 0, s | 0;
              }
              function Ug(r, s, u, A, m, p) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0, m = m | 0, p = p | 0;
                var N = 0, W = 0;
                N = Jr - 32 | 0, Jr = N, e[N + 28 >> 2] = s;
                e: {
                  t: {
                    if (!(_[A + 4 | 0] & 1)) {
                      e[N >> 2] = -1, s = xi[e[e[r >> 2] + 16 >> 2]](r, s, u, A, m, N) | 0;
                      r:
                        switch (e[N >> 2]) {
                          case 1:
                            _[p | 0] = 1;
                            break e;
                          case 0:
                            break t;
                          default:
                            break r;
                        }
                      _[p | 0] = 1, e[m >> 2] = 4;
                      break e;
                    }
                    r = e[A + 28 >> 2], e[N >> 2] = r, e[r + 4 >> 2] = e[r + 4 >> 2] + 1, e[5996] = 0, W = Mi(197, e[N >> 2]) | 0, r = e[5996], e[5996] = 0;
                    r: {
                      i: {
                        n: {
                          s: {
                            if ((r | 0) != 1) {
                              if (r = e[N >> 2], s = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = s, (s | 0) == -1 && xi[e[e[r >> 2] + 8 >> 2]](r), r = e[A + 28 >> 2], e[N >> 2] = r, e[r + 4 >> 2] = e[r + 4 >> 2] + 1, e[5996] = 0, s = Mi(198, e[N >> 2]) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1)
                                break s;
                              if (r = e[N >> 2], A = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = A, (A | 0) == -1 && xi[e[e[r >> 2] + 8 >> 2]](r), e[5996] = 0, ji(199, N | 0, s | 0), r = e[5996], e[5996] = 0, (r | 0) == 1) {
                                s = Hr() | 0;
                                break r;
                              }
                              if (e[5996] = 0, ji(200, N | 12, s | 0), r = e[5996], e[5996] = 0, (r | 0) == 1)
                                break n;
                              if (e[5996] = 0, A = N + 24 | 0, r = el(201, N + 28 | 0, u | 0, N | 0, A | 0, W | 0, m | 0, 1) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1)
                                break i;
                              for (_[p | 0] = (r | 0) == (N | 0), s = e[N + 28 >> 2]; A = Qn(A - 12 | 0), (N | 0) != (A | 0); )
                                ;
                              break e;
                            }
                            s = Hr() | 0, r = e[N >> 2], u = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = u, (u | 0) == -1 && xi[e[e[r >> 2] + 8 >> 2]](r);
                            break r;
                          }
                          s = Hr() | 0, r = e[N >> 2], u = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = u, (u | 0) == -1 && xi[e[e[r >> 2] + 8 >> 2]](r);
                          break r;
                        }
                        s = Hr() | 0, Qn(N);
                        break r;
                      }
                      for (s = Hr() | 0; A = Qn(A - 12 | 0), (N | 0) != (A | 0); )
                        ;
                    }
                    Jn(s | 0), Oi();
                  }
                  _[p | 0] = 0;
                }
                return Jr = N + 32 | 0, s | 0;
              }
              function Mg(r, s, u, A, m, p) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0, m = m | 0, p = p | 0;
                var N = 0, W = 0;
                N = Jr - 32 | 0, Jr = N, e[N + 28 >> 2] = s;
                e: {
                  t: {
                    if (!(_[A + 4 | 0] & 1)) {
                      e[N >> 2] = -1, s = xi[e[e[r >> 2] + 16 >> 2]](r, s, u, A, m, N) | 0;
                      r:
                        switch (e[N >> 2]) {
                          case 1:
                            _[p | 0] = 1;
                            break e;
                          case 0:
                            break t;
                          default:
                            break r;
                        }
                      _[p | 0] = 1, e[m >> 2] = 4;
                      break e;
                    }
                    r = e[A + 28 >> 2], e[N >> 2] = r, e[r + 4 >> 2] = e[r + 4 >> 2] + 1, e[5996] = 0, W = Mi(170, e[N >> 2]) | 0, r = e[5996], e[5996] = 0;
                    r: {
                      i: {
                        n: {
                          s: {
                            if ((r | 0) != 1) {
                              if (r = e[N >> 2], s = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = s, (s | 0) == -1 && xi[e[e[r >> 2] + 8 >> 2]](r), r = e[A + 28 >> 2], e[N >> 2] = r, e[r + 4 >> 2] = e[r + 4 >> 2] + 1, e[5996] = 0, s = Mi(180, e[N >> 2]) | 0, r = e[5996], e[5996] = 0, (r | 0) == 1)
                                break s;
                              if (r = e[N >> 2], A = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = A, (A | 0) == -1 && xi[e[e[r >> 2] + 8 >> 2]](r), e[5996] = 0, ji(181, N | 0, s | 0), r = e[5996], e[5996] = 0, (r | 0) == 1) {
                                s = Hr() | 0;
                                break r;
                              }
                              if (e[5996] = 0, ji(182, N | 12, s | 0), r = e[5996], e[5996] = 0, (r | 0) == 1)
                                break n;
                              if (e[5996] = 0, A = N + 24 | 0, r = el(183, N + 28 | 0, u | 0, N | 0, A | 0, W | 0, m | 0, 1) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1)
                                break i;
                              for (_[p | 0] = (r | 0) == (N | 0), s = e[N + 28 >> 2]; A = Qn(A - 12 | 0), (N | 0) != (A | 0); )
                                ;
                              break e;
                            }
                            s = Hr() | 0, r = e[N >> 2], u = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = u, (u | 0) == -1 && xi[e[e[r >> 2] + 8 >> 2]](r);
                            break r;
                          }
                          s = Hr() | 0, r = e[N >> 2], u = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = u, (u | 0) == -1 && xi[e[e[r >> 2] + 8 >> 2]](r);
                          break r;
                        }
                        s = Hr() | 0, Qn(N);
                        break r;
                      }
                      for (s = Hr() | 0; A = Qn(A - 12 | 0), (N | 0) != (A | 0); )
                        ;
                    }
                    Jn(s | 0), Oi();
                  }
                  _[p | 0] = 0;
                }
                return Jr = N + 32 | 0, s | 0;
              }
              function Fg(r, s, u, A) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0;
                var m = 0, p = 0, N = 0, W = 0, Te = 0;
                m = Jr - 32 | 0, Jr = m;
                e: {
                  t: {
                    r: {
                      if ((u | 0) <= 0)
                        break r;
                      for (; ; ) {
                        if (W = s + N | 0, me[W | 0] != 41) {
                          if (N = N + 1 | 0, (u | 0) != (N | 0))
                            continue;
                          break r;
                        }
                        break;
                      }
                      if (N)
                        break t;
                    }
                    _[r + 16 | 0] = 0, _[r | 0] = 0;
                    break e;
                  }
                  if (N >>> 0 < 2147483632) {
                    t: {
                      if (N >>> 0 <= 10) {
                        _[m + 31 | 0] = N, u = m + 20 | 0;
                        break t;
                      }
                      p = (N | 15) + 1 | 0, u = Qs(p), e[m + 28 >> 2] = p | -2147483648, e[m + 20 >> 2] = u, e[m + 24 >> 2] = N;
                    }
                    if (Te = N & 7, Te)
                      for (p = 0; _[u | 0] = me[s | 0], u = u + 1 | 0, s = s + 1 | 0, p = p + 1 | 0, (Te | 0) != (p | 0); )
                        ;
                    if (N >>> 0 >= 8)
                      for (; _[u | 0] = me[s | 0], _[u + 1 | 0] = me[s + 1 | 0], _[u + 2 | 0] = me[s + 2 | 0], _[u + 3 | 0] = me[s + 3 | 0], _[u + 4 | 0] = me[s + 4 | 0], _[u + 5 | 0] = me[s + 5 | 0], _[u + 6 | 0] = me[s + 6 | 0], _[u + 7 | 0] = me[s + 7 | 0], u = u + 8 | 0, s = s + 8 | 0, (W | 0) != (s | 0); )
                        ;
                    _[u | 0] = 0, p = me[m + 31 | 0], u = p << 24 >> 24, s = (u | 0) < 0;
                    t: {
                      r: {
                        i: {
                          p = s ? e[m + 24 >> 2] : p;
                          n: {
                            if (!p)
                              break n;
                            for (s = s ? e[m + 20 >> 2] : m + 20 | 0, W = p + s | 0; ; ) {
                              if (_[me[s | 0] + 5584 | 0] < 0)
                                break n;
                              if (s = s + 1 | 0, (W | 0) == (s | 0))
                                break;
                            }
                            if (!(p & 1))
                              break i;
                          }
                          _[r + 16 | 0] = 0, _[r | 0] = 0;
                          break r;
                        }
                        if (e[5996] = 0, ji(31, m + 8 | 0, m + 20 | 0), s = e[5996], e[5996] = 0, (s | 0) == 1)
                          break t;
                        u = e[m + 12 >> 2], s = e[m + 8 >> 2];
                        i: {
                          if ((u - s | 0) == (A | 0)) {
                            A = e[m + 16 >> 2], _[r + 16 | 0] = 1, e[r + 12 >> 2] = N, e[r + 8 >> 2] = A, e[r + 4 >> 2] = u, e[r >> 2] = s;
                            break i;
                          }
                          if (_[r + 16 | 0] = 0, _[r | 0] = 0, !s)
                            break i;
                          Br(s);
                        }
                        u = me[m + 31 | 0];
                      }
                      if (u << 24 >> 24 >= 0)
                        break e;
                      Br(e[m + 20 >> 2]);
                      break e;
                    }
                    r = Hr() | 0, _[m + 31 | 0] < 0 && Br(e[m + 20 >> 2]), Jn(r | 0), Oi();
                  }
                  Ra(), Oi();
                }
                Jr = m + 32 | 0;
              }
              function Lg(r, s, u, A, m, p, N) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0, m = m | 0, p = p | 0, N = N | 0;
                var W = 0, Te = 0, Xe = 0, fr = 0;
                if (r = Jr - 144 | 0, Jr = r, e[r + 136 >> 2] = u, e[r + 140 >> 2] = s, e[r + 20 >> 2] = 220, s = r + 24 | 0, e[s >> 2] = r + 32, Te = r + 20 | 0, e[s + 4 >> 2] = e[Te >> 2], Xe = r + 16 | 0, W = e[m + 28 >> 2], e[Xe >> 2] = W, e[W + 4 >> 2] = e[W + 4 >> 2] + 1, e[5996] = 0, W = Mi(170, e[r + 16 >> 2]) | 0, fr = e[5996], e[5996] = 0, (fr | 0) != 1)
                  e: {
                    if (_[r + 15 | 0] = 0, m = e[m + 4 >> 2], e[5996] = 0, u = pc(221, r + 140 | 0, u | 0, A | 0, Xe | 0, m | 0, p | 0, r + 15 | 0, W | 0, s | 0, Te | 0, r + 132 | 0) | 0, A = e[5996], e[5996] = 0, (A | 0) == 1)
                      break e;
                    t: {
                      r: {
                        if (!u)
                          break r;
                        i: {
                          if ((me[N + 11 | 0] & 128) >>> 7 | 0) {
                            _[e[N >> 2]] = 0, e[N + 4 >> 2] = 0;
                            break i;
                          }
                          _[N | 0] = 0, _[N + 11 | 0] = 0;
                        }
                        if (me[r + 15 | 0] && (e[5996] = 0, u = pi(171, W | 0, 45) | 0, A = e[5996], e[5996] = 0, (A | 0) == 1 || (e[5996] = 0, ji(98, N | 0, u | 0), u = e[5996], e[5996] = 0, (u | 0) == 1)))
                          break e;
                        if (e[5996] = 0, A = pi(171, W | 0, 48) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1)
                          break t;
                        for (m = e[r + 20 >> 2], W = m - 1 | 0, u = e[s >> 2], A = A & 255; ; ) {
                          if (!((A | 0) != me[u | 0] | u >>> 0 >= W >>> 0)) {
                            u = u + 1 | 0;
                            continue;
                          }
                          break;
                        }
                        if (e[5996] = 0, xn(227, N | 0, u | 0, m | 0) | 0, u = e[5996], e[5996] = 0, (u | 0) != 1)
                          break r;
                        break e;
                      }
                      if (e[5996] = 0, u = pi(186, r + 140 | 0, r + 136 | 0) | 0, A = e[5996], e[5996] = 0, (A | 0) == 1)
                        break e;
                      return u && (e[p >> 2] = e[p >> 2] | 2), m = e[r + 140 >> 2], u = e[r + 16 >> 2], A = e[u + 4 >> 2] - 1 | 0, e[u + 4 >> 2] = A, (A | 0) == -1 && xi[e[e[u >> 2] + 8 >> 2]](u), to(s), Jr = r + 144 | 0, m | 0;
                    }
                  }
                A = Hr() | 0, r = e[r + 16 >> 2], u = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = u, (u | 0) == -1 && xi[e[e[r >> 2] + 8 >> 2]](r), to(s), Jn(A | 0), Oi();
              }
              function Hg(r, s, u, A, m, p, N) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0, m = m | 0, p = p | 0, N = N | 0;
                var W = 0, Te = 0, Xe = 0, fr = 0;
                if (r = Jr - 448 | 0, Jr = r, e[r + 440 >> 2] = u, e[r + 444 >> 2] = s, e[r + 20 >> 2] = 220, s = r + 24 | 0, e[s >> 2] = r + 32, Te = r + 20 | 0, e[s + 4 >> 2] = e[Te >> 2], Xe = r + 16 | 0, W = e[m + 28 >> 2], e[Xe >> 2] = W, e[W + 4 >> 2] = e[W + 4 >> 2] + 1, e[5996] = 0, W = Mi(197, e[r + 16 >> 2]) | 0, fr = e[5996], e[5996] = 0, (fr | 0) != 1)
                  e: {
                    if (_[r + 15 | 0] = 0, m = e[m + 4 >> 2], e[5996] = 0, u = pc(228, r + 444 | 0, u | 0, A | 0, Xe | 0, m | 0, p | 0, r + 15 | 0, W | 0, s | 0, Te | 0, r + 432 | 0) | 0, A = e[5996], e[5996] = 0, (A | 0) == 1)
                      break e;
                    t: {
                      r: {
                        if (!u)
                          break r;
                        i: {
                          if ((me[N + 11 | 0] & 128) >>> 7 | 0) {
                            e[e[N >> 2] >> 2] = 0, e[N + 4 >> 2] = 0;
                            break i;
                          }
                          e[N >> 2] = 0, _[N + 11 | 0] = 0;
                        }
                        if (me[r + 15 | 0] && (e[5996] = 0, u = pi(216, W | 0, 45) | 0, A = e[5996], e[5996] = 0, (A | 0) == 1 || (e[5996] = 0, ji(232, N | 0, u | 0), u = e[5996], e[5996] = 0, (u | 0) == 1)))
                          break e;
                        if (e[5996] = 0, A = pi(216, W | 0, 48) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1)
                          break t;
                        for (m = e[r + 20 >> 2], W = m - 4 | 0, u = e[s >> 2]; ; ) {
                          if (!((A | 0) != e[u >> 2] | u >>> 0 >= W >>> 0)) {
                            u = u + 4 | 0;
                            continue;
                          }
                          break;
                        }
                        if (e[5996] = 0, xn(234, N | 0, u | 0, m | 0) | 0, u = e[5996], e[5996] = 0, (u | 0) != 1)
                          break r;
                        break e;
                      }
                      if (e[5996] = 0, u = pi(202, r + 444 | 0, r + 440 | 0) | 0, A = e[5996], e[5996] = 0, (A | 0) == 1)
                        break e;
                      return u && (e[p >> 2] = e[p >> 2] | 2), m = e[r + 444 >> 2], u = e[r + 16 >> 2], A = e[u + 4 >> 2] - 1 | 0, e[u + 4 >> 2] = A, (A | 0) == -1 && xi[e[e[u >> 2] + 8 >> 2]](u), to(s), Jr = r + 448 | 0, m | 0;
                    }
                  }
                A = Hr() | 0, r = e[r + 16 >> 2], u = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = u, (u | 0) == -1 && xi[e[e[r >> 2] + 8 >> 2]](r), to(s), Jn(A | 0), Oi();
              }
              function Kg(r, s, u, A, m) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0, m = m | 0;
                var p = 0, N = 0, W = 0;
                if (eu(r, e[s + 8 >> 2], m)) {
                  e[s + 28 >> 2] == 1 | e[s + 4 >> 2] != (u | 0) || (e[s + 28 >> 2] = A);
                  return;
                }
                e: {
                  if (eu(r, e[s >> 2], m)) {
                    if (!(e[s + 16 >> 2] != (u | 0) & e[s + 20 >> 2] != (u | 0))) {
                      if ((A | 0) != 1)
                        break e;
                      e[s + 32 >> 2] = 1;
                      return;
                    }
                    e[s + 32 >> 2] = A;
                    t: {
                      if (e[s + 44 >> 2] == 4)
                        break t;
                      p = r + 16 | 0, W = p + (e[r + 12 >> 2] << 3) | 0, A = 0;
                      r: {
                        i: {
                          for (; ; ) {
                            n: {
                              if (p >>> 0 >= W >>> 0 || (Zs[s + 52 >> 1] = 0, jd(e[p >> 2], e[p + 4 >> 2], s, u, u, 1, m), me[s + 54 | 0]))
                                break n;
                              s: {
                                if (!me[s + 53 | 0])
                                  break s;
                                if (me[s + 52 | 0]) {
                                  if (e[s + 24 >> 2] != 1 && (A = 1, N = 1, me[r + 8 | 0] & 2))
                                    break s;
                                  e[s + 44 >> 2] = 3;
                                  return;
                                }
                                if (A = 1, !(_[r + 8 | 0] & 1))
                                  break i;
                              }
                              p = p + 8 | 0;
                              continue;
                            }
                            break;
                          }
                          if (!A)
                            break r;
                        }
                        if (e[s + 44 >> 2] = 3, !N)
                          break t;
                        break e;
                      }
                      if (e[s + 44 >> 2] = 4, N)
                        break e;
                    }
                    if (e[s + 20 >> 2] = u, e[s + 40 >> 2] = e[s + 40 >> 2] + 1, e[s + 36 >> 2] != 1 | e[s + 24 >> 2] != 2)
                      break e;
                    _[s + 54 | 0] = 1;
                    return;
                  }
                  if (N = e[r + 12 >> 2], Pl(e[r + 16 >> 2], e[r + 20 >> 2], s, u, A, m), p = r + 24 | 0, N = (r + 16 | 0) + (N << 3) | 0, p >>> 0 >= N >>> 0)
                    break e;
                  if (r = e[r + 8 >> 2], !(!(r & 2) & e[s + 36 >> 2] != 1)) {
                    for (; ; ) {
                      if (me[s + 54 | 0])
                        break e;
                      if (Pl(e[p >> 2], e[p + 4 >> 2], s, u, A, m), p = p + 8 | 0, !(N >>> 0 > p >>> 0))
                        break;
                    }
                    break e;
                  }
                  if (!(r & 1))
                    for (; ; ) {
                      if (me[s + 54 | 0] | e[s + 36 >> 2] == 1)
                        break e;
                      if (Pl(e[p >> 2], e[p + 4 >> 2], s, u, A, m), p = p + 8 | 0, !(N >>> 0 > p >>> 0))
                        break e;
                    }
                  for (; ; ) {
                    if (me[s + 54 | 0] | e[s + 36 >> 2] == 1 & e[s + 24 >> 2] == 1)
                      break e;
                    if (Pl(e[p >> 2], e[p + 4 >> 2], s, u, A, m), p = p + 8 | 0, !(N >>> 0 > p >>> 0))
                      break;
                  }
                }
              }
              function od(r, s, u, A, m, p, N, W) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0, m = m | 0, p = p | 0, N = N | 0, W = W | 0;
                var Te = 0;
                r = Jr - 16 | 0, Jr = r, e[r + 12 >> 2] = u, e[r + 8 >> 2] = p, e[r + 12 >> 2] = u, e[r + 8 >> 2] = p, u = e[r + 12 >> 2];
                e: {
                  for (; ; ) {
                    if (u >>> 0 >= A >>> 0) {
                      p = 0;
                      break e;
                    }
                    t: {
                      s = Ia[u >> 1];
                      r: {
                        if (s >>> 0 <= 127) {
                          if (p = 1, u = e[r + 8 >> 2], (N - u | 0) <= 0)
                            break e;
                          e[r + 8 >> 2] = u + 1, _[u | 0] = s;
                          break r;
                        }
                        if (s >>> 0 <= 2047) {
                          if (u = e[r + 8 >> 2], (N - u | 0) < 2)
                            break t;
                          e[r + 8 >> 2] = u + 1, _[u | 0] = s >>> 6 | 192, u = e[r + 8 >> 2], e[r + 8 >> 2] = u + 1, _[u | 0] = s & 63 | 128;
                          break r;
                        }
                        if (s >>> 0 <= 55295) {
                          if (u = e[r + 8 >> 2], (N - u | 0) < 3)
                            break t;
                          e[r + 8 >> 2] = u + 1, _[u | 0] = s >>> 12 | 224, u = e[r + 8 >> 2], e[r + 8 >> 2] = u + 1, _[u | 0] = s >>> 6 & 63 | 128, u = e[r + 8 >> 2], e[r + 8 >> 2] = u + 1, _[u | 0] = s & 63 | 128;
                          break r;
                        }
                        i: {
                          n: {
                            if (s >>> 0 <= 56319) {
                              if (p = 1, (A - u | 0) < 4)
                                break e;
                              if (Te = Ia[u + 2 >> 1], (Te & 64512) != 56320)
                                break n;
                              if ((N - e[r + 8 >> 2] | 0) < 4)
                                break e;
                              e[r + 12 >> 2] = u + 2, u = e[r + 8 >> 2], e[r + 8 >> 2] = u + 1, p = u, u = (s >>> 6 & 15) + 1 | 0, _[p | 0] = u >>> 2 | 240, p = e[r + 8 >> 2], e[r + 8 >> 2] = p + 1, _[p | 0] = u << 4 & 48 | s >>> 2 & 15 | 128, u = e[r + 8 >> 2], e[r + 8 >> 2] = u + 1, _[u | 0] = Te >>> 6 & 15 | s << 4 & 48 | 128, s = e[r + 8 >> 2], e[r + 8 >> 2] = s + 1, _[s | 0] = Te & 63 | 128;
                              break r;
                            }
                            if (s >>> 0 >= 57344)
                              break i;
                          }
                          p = 2;
                          break e;
                        }
                        if (u = e[r + 8 >> 2], (N - u | 0) < 3)
                          break t;
                        e[r + 8 >> 2] = u + 1, _[u | 0] = s >>> 12 | 224, u = e[r + 8 >> 2], e[r + 8 >> 2] = u + 1, _[u | 0] = s >>> 6 & 63 | 128, u = e[r + 8 >> 2], e[r + 8 >> 2] = u + 1, _[u | 0] = s & 63 | 128;
                      }
                      u = e[r + 12 >> 2] + 2 | 0, e[r + 12 >> 2] = u;
                      continue;
                    }
                    break;
                  }
                  p = 1;
                }
                return e[m >> 2] = e[r + 12 >> 2], e[W >> 2] = e[r + 8 >> 2], Jr = r + 16 | 0, p | 0;
              }
              function Da(r, s) {
                r = r | 0, s = s | 0;
                var u = 0, A = 0, m = 0, p = 0, N = 0, W = 0;
                if (u = e[r + 4 >> 2], A = e[r + 8 >> 2], u >>> 0 < A >>> 0) {
                  e[u >> 2] = e[s >> 2], e[u + 4 >> 2] = e[s + 4 >> 2], e[s >> 2] = 0, e[s + 4 >> 2] = 0, m = e[s + 28 >> 2], e[u + 24 >> 2] = e[s + 24 >> 2], e[u + 28 >> 2] = m, m = e[s + 20 >> 2], e[u + 16 >> 2] = e[s + 16 >> 2], e[u + 20 >> 2] = m, m = e[s + 12 >> 2], e[u + 8 >> 2] = e[s + 8 >> 2], e[u + 12 >> 2] = m, e[r + 4 >> 2] = u + 32;
                  return;
                }
                e: {
                  if (W = e[r >> 2], p = u - W >> 5, m = p + 1 | 0, m >>> 0 < 134217728) {
                    if (A = A - W | 0, N = A >> 4, N = A >>> 0 >= 2147483616 ? 134217727 : m >>> 0 < N >>> 0 ? N : m, N) {
                      if (N >>> 0 >= 134217728)
                        break e;
                      m = Qs(N << 5);
                    } else
                      m = 0;
                    if (A = m + (p << 5) | 0, e[A >> 2] = e[s >> 2], e[A + 4 >> 2] = e[s + 4 >> 2], e[s >> 2] = 0, e[s + 4 >> 2] = 0, p = e[s + 28 >> 2], e[A + 24 >> 2] = e[s + 24 >> 2], e[A + 28 >> 2] = p, p = e[s + 20 >> 2], e[A + 16 >> 2] = e[s + 16 >> 2], e[A + 20 >> 2] = p, p = e[s + 12 >> 2], e[A + 8 >> 2] = e[s + 8 >> 2], e[A + 12 >> 2] = p, p = A + 32 | 0, (u | 0) != (W | 0))
                      for (; A = A - 32 | 0, u = u - 32 | 0, e[A >> 2] = e[u >> 2], e[A + 4 >> 2] = e[u + 4 >> 2], e[u >> 2] = 0, e[u + 4 >> 2] = 0, s = e[u + 28 >> 2], e[A + 24 >> 2] = e[u + 24 >> 2], e[A + 28 >> 2] = s, s = e[u + 20 >> 2], e[A + 16 >> 2] = e[u + 16 >> 2], e[A + 20 >> 2] = s, s = e[u + 12 >> 2], e[A + 8 >> 2] = e[u + 8 >> 2], e[A + 12 >> 2] = s, (u | 0) != (W | 0); )
                        ;
                    if (e[r + 8 >> 2] = m + (N << 5), s = e[r >> 2], e[r >> 2] = A, u = e[r + 4 >> 2], e[r + 4 >> 2] = p, (s | 0) != (u | 0))
                      for (; ; ) {
                        u = u - 32 | 0, r = e[u + 4 >> 2];
                        t: {
                          if (!r || (m = e[r + 4 >> 2], e[r + 4 >> 2] = m - 1, m))
                            break t;
                          xi[e[e[r >> 2] + 8 >> 2]](r), ys(r);
                        }
                        if ((s | 0) == (u | 0))
                          break;
                      }
                    s && Br(s);
                    return;
                  }
                  Jo(), Oi();
                }
                hu(), Oi();
              }
              function Tu(r, s) {
                var u = 0, A = 0, m = 0, p = 0, N = 0;
                e: {
                  t: {
                    r: {
                      i: {
                        n: {
                          s: {
                            u = e[r + 4 >> 2];
                            a: {
                              if ((u | 0) != e[r + 104 >> 2]) {
                                e[r + 4 >> 2] = u + 1, u = me[u | 0];
                                break a;
                              }
                              u = Bo(r);
                            }
                            switch (u - 43 | 0) {
                              case 0:
                              case 2:
                                break s;
                              default:
                                break n;
                            }
                          }
                          N = (u | 0) == 45, s = !s, u = e[r + 4 >> 2];
                          s: {
                            if ((u | 0) != e[r + 104 >> 2]) {
                              e[r + 4 >> 2] = u + 1, u = me[u | 0];
                              break s;
                            }
                            u = Bo(r);
                          }
                          if (A = u - 58 | 0, s | A >>> 0 > 4294967285)
                            break i;
                          if (s = e[r + 116 >> 2], (s | 0) > 0 | (s | 0) >= 0)
                            break r;
                          break e;
                        }
                        A = u - 58 | 0;
                      }
                      if (A >>> 0 <= 4294967285) {
                        if (e[r + 116 >> 2] < 0)
                          break e;
                        break t;
                      }
                      i: {
                        if (u - 48 >>> 0 >= 10)
                          break i;
                        for (; ; ) {
                          m = (Sn(m, 10) + u | 0) - 48 | 0, p = (m | 0) < 214748364, u = e[r + 4 >> 2];
                          n: {
                            if ((u | 0) != e[r + 104 >> 2]) {
                              e[r + 4 >> 2] = u + 1, u = me[u | 0];
                              break n;
                            }
                            u = Bo(r);
                          }
                          if (s = u - 48 | 0, !(p & s >>> 0 <= 9))
                            break;
                        }
                        if (p = m >> 31, s >>> 0 >= 10)
                          break i;
                        for (; ; ) {
                          s = u, u = Ao(m, p, 10, 0), A = s + u | 0, s = Ds, m = A - 48 | 0, A = (u >>> 0 > A >>> 0 ? s + 1 | 0 : s) - (A >>> 0 < 48) | 0, p = A, A = m >>> 0 < 2061584302 & (A | 0) <= 21474836 | (A | 0) < 21474836, u = e[r + 4 >> 2];
                          n: {
                            if ((u | 0) != e[r + 104 >> 2]) {
                              e[r + 4 >> 2] = u + 1, u = me[u | 0];
                              break n;
                            }
                            u = Bo(r);
                          }
                          if (s = u - 48 | 0, !(A & s >>> 0 <= 9))
                            break;
                        }
                        if (s >>> 0 >= 10)
                          break i;
                        for (; ; ) {
                          s = e[r + 4 >> 2];
                          n: {
                            if ((s | 0) != e[r + 104 >> 2]) {
                              e[r + 4 >> 2] = s + 1, s = me[s | 0];
                              break n;
                            }
                            s = Bo(r);
                          }
                          if (!(s - 48 >>> 0 < 10))
                            break;
                        }
                      }
                      return s = e[r + 116 >> 2], (s | 0) > 0 | (s | 0) >= 0 && (e[r + 4 >> 2] = e[r + 4 >> 2] - 1), Ds = N ? 0 - (((m | 0) != 0) + p | 0) | 0 : p, N ? 0 - m | 0 : m;
                    }
                    e[r + 4 >> 2] = e[r + 4 >> 2] - 1;
                  }
                  e[r + 4 >> 2] = e[r + 4 >> 2] - 1;
                }
                return Ds = -2147483648, 0;
              }
              function Bh(r, s, u, A, m, p, N, W) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0, m = m | 0, p = p | 0, N = N | 0, W = W | 0;
                var Te = 0, Xe = 0, fr = 0, ar = 0, vr = 0;
                r = Jr - 16 | 0, Jr = r, e[r + 12 >> 2] = u, e[r + 8 >> 2] = p, e[r + 12 >> 2] = u, e[r + 8 >> 2] = p;
                e: {
                  t: {
                    for (; ; ) {
                      if (s = e[r + 12 >> 2], !(A >>> 0 <= s >>> 0 | p >>> 0 >= N >>> 0)) {
                        Te = _[s | 0], u = Te & 255;
                        r: {
                          if ((Te | 0) >= 0) {
                            Te = 1;
                            break r;
                          }
                          if (fr = 2, Te >>> 0 < 4294967234)
                            break e;
                          if (Te >>> 0 <= 4294967263) {
                            if ((A - s | 0) < 2)
                              break t;
                            if (Te = me[s + 1 | 0], (Te & 192) != 128)
                              break e;
                            u = Te & 63 | u << 6 & 1984, Te = 2;
                            break r;
                          }
                          if (Te >>> 0 <= 4294967279) {
                            if ((A - s | 0) < 3)
                              break t;
                            Xe = me[s + 2 | 0], Te = me[s + 1 | 0];
                            i: {
                              n: {
                                if ((u | 0) != 237) {
                                  if ((u | 0) != 224)
                                    break n;
                                  if ((Te & 224) == 160)
                                    break i;
                                  break e;
                                }
                                if ((Te & 224) == 128)
                                  break i;
                                break e;
                              }
                              if ((Te & 192) != 128)
                                break e;
                            }
                            if ((Xe & 192) != 128)
                              break e;
                            u = Xe & 63 | (u << 12 & 61440 | (Te & 63) << 6), Te = 3;
                            break r;
                          }
                          if (Te >>> 0 > 4294967284)
                            break e;
                          if ((A - s | 0) < 4)
                            break t;
                          ar = me[s + 3 | 0], vr = me[s + 2 | 0], Xe = me[s + 1 | 0];
                          i: {
                            n:
                              switch (u - 240 | 0) {
                                case 0:
                                  if ((Xe + 112 & 255) >>> 0 < 48)
                                    break i;
                                  break e;
                                case 4:
                                  if ((Xe & 240) == 128)
                                    break i;
                                  break e;
                                default:
                                  break n;
                              }
                            if ((Xe & 192) != 128)
                              break e;
                          }
                          if ((vr & 192) != 128 | (ar & 192) != 128 || (Te = 4, u = ar & 63 | (vr << 6 & 4032 | (u << 18 & 1835008 | (Xe & 63) << 12)), u >>> 0 > 1114111))
                            break e;
                        }
                        e[p >> 2] = u, e[r + 12 >> 2] = s + Te, p = e[r + 8 >> 2] + 4 | 0, e[r + 8 >> 2] = p;
                        continue;
                      }
                      break;
                    }
                    fr = s >>> 0 < A >>> 0;
                    break e;
                  }
                  fr = 1;
                }
                return e[m >> 2] = e[r + 12 >> 2], e[W >> 2] = e[r + 8 >> 2], Jr = r + 16 | 0, fr | 0;
              }
              function Vg(r, s, u, A, m) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0, m = m | 0;
                var p = 0, N = 0, W = 0, Te = 0, Xe = 0;
                p = Jr - 32 | 0, Jr = p, e[r + 8 >> 2] = 0, e[r + 12 >> 2] = 0, e[r + 4 >> 2] = m, e[r >> 2] = s, e[r + 16 >> 2] = 0, e[r + 8 >> 2] = e[A >> 2], e[r + 12 >> 2] = e[A + 4 >> 2], e[r + 16 >> 2] = e[A + 8 >> 2], e[A + 8 >> 2] = 0, e[A >> 2] = 0, e[A + 4 >> 2] = 0, e[r + 36 >> 2] = 0, e[r + 40 >> 2] = 0, e[r + 28 >> 2] = 0, e[r + 32 >> 2] = 0, e[r + 20 >> 2] = 0, e[r + 24 >> 2] = 0, e[r + 32 >> 2] = e[u >> 2], e[r + 36 >> 2] = e[u + 4 >> 2], e[r + 40 >> 2] = e[u + 8 >> 2], e[u + 8 >> 2] = 0, e[u >> 2] = 0, e[u + 4 >> 2] = 0, e[5996] = 0, ji(86, r + 44 | 0, r | 0), s = e[5996], e[5996] = 0;
                e: {
                  if ((s | 0) == 1 || (e[5996] = 0, ji(87, r - -64 | 0, r | 0), s = e[5996], e[5996] = 0, (s | 0) == 1) || (u = 0, e[5996] = 0, s = Mi(88, r | 0) | 0, A = e[5996], e[5996] = 0, (A | 0) == 1))
                    break e;
                  if (e[r + 80 >> 2] = s, s = e[r + 32 >> 2], m = e[r + 36 >> 2], (s | 0) == (m | 0))
                    A = 0;
                  else {
                    for (A = s; u = e[e[A >> 2] + 84 >> 2] + u | 0, A = A + 8 | 0, (m | 0) != (A | 0); )
                      ;
                    A = e[e[s >> 2] + 80 >> 2];
                  }
                  if (N = e[r + 4 >> 2], W = e[r >> 2], Te = e[r + 8 >> 2], Xe = e[r + 12 >> 2], e[5996] = 0, s = za(89, W | 0, A | 0, u | 0, N | 0, m - s >> 3, (Xe - Te | 0) / 12 | 0) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1 || (e[r + 84 >> 2] = s, e[5996] = 0, e[p + 28 >> 2] = r, gs(90, p + 12 | 0, r | 0, p + 28 | 0), s = e[5996], e[5996] = 0, (s | 0) == 1))
                    break e;
                  return s = me[p + 24 | 0], s && ft(e[p + 16 >> 2]), _[r + 88 | 0] = s ^ 1, Jr = p + 32 | 0, r | 0;
                }
                u = Hr() | 0, Uo(r + 32 | 0), s = e[r + 20 >> 2], s && (e[r + 24 >> 2] = s, Br(s)), ea(r + 8 | 0), Jn(u | 0), Oi();
              }
              function ad(r, s, u) {
                r = r | 0, s = s | 0, u = u | 0;
                var A = 0, m = 0, p = 0, N = 0, W = 0, Te = 0, Xe = 0, fr = 0, ar = 0, vr = 0;
                N = Jr - 32 | 0, Jr = N, A = Qs(104), e[A >> 2] = 7e3, e[A + 4 >> 2] = 0, e[A + 8 >> 2] = 0, m = e[u + 8 >> 2], e[u + 8 >> 2] = 0, p = e[u >> 2], W = e[u + 4 >> 2], e[u >> 2] = 0, e[u + 4 >> 2] = 0, e[A + 16 >> 2] = 0, e[A + 20 >> 2] = 0, e[A + 12 >> 2] = s, e[A + 24 >> 2] = 0, e[A + 28 >> 2] = 0, e[A + 52 >> 2] = 0, Te = A + 44 | 0, s = Te, e[s >> 2] = 0, e[s + 4 >> 2] = 0, e[A + 40 >> 2] = m, e[A + 32 >> 2] = p, e[A + 36 >> 2] = W, e[5996] = 0, p = A + 12 | 0, ji(86, A + 56 | 0, p | 0), s = e[5996], e[5996] = 0;
                e: {
                  if ((s | 0) == 1 || (e[5996] = 0, ji(87, A + 76 | 0, p | 0), s = e[5996], e[5996] = 0, (s | 0) == 1) || (s = 0, e[5996] = 0, u = Mi(88, p | 0) | 0, m = e[5996], e[5996] = 0, (m | 0) == 1))
                    break e;
                  if (e[A + 92 >> 2] = u, W = e[A + 48 >> 2], m = e[A + 44 >> 2], (W | 0) == (m | 0))
                    u = 0;
                  else {
                    for (u = m; s = e[e[u >> 2] + 84 >> 2] + s | 0, u = u + 8 | 0, (W | 0) != (u | 0); )
                      ;
                    u = e[e[m >> 2] + 80 >> 2];
                  }
                  if (Xe = e[A + 16 >> 2], fr = e[A + 12 >> 2], ar = e[A + 20 >> 2], vr = e[A + 24 >> 2], e[5996] = 0, s = za(89, fr | 0, u | 0, s | 0, Xe | 0, W - m >> 3, (vr - ar | 0) / 12 | 0) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1 || (e[A + 96 >> 2] = s, e[5996] = 0, e[N + 28 >> 2] = p, gs(90, N + 12 | 0, p | 0, N + 28 | 0), s = e[5996], e[5996] = 0, (s | 0) == 1))
                    break e;
                  s = me[N + 24 | 0], s && ft(e[N + 16 >> 2]), _[A + 100 | 0] = s ^ 1, e[r + 4 >> 2] = A, e[r >> 2] = p, Jr = N + 32 | 0;
                  return;
                }
                s = Hr() | 0, Uo(Te), r = e[A + 32 >> 2], r && (e[A + 36 >> 2] = r, Br(r)), ea(A + 20 | 0), Br(A), Jn(s | 0), Oi();
              }
              function Gg(r, s, u, A, m, p) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0, m = m | 0, p = p | 0;
                var N = 0, W = 0;
                N = Jr - 32 | 0, Jr = N, W = 1;
                e: {
                  t: {
                    r: {
                      i:
                        switch (r | 0) {
                          case 3:
                            W = 24;
                            break r;
                          case 4:
                          case 5:
                            if (e[N + 24 >> 2] = 0, e[N + 28 >> 2] = 0, e[N + 16 >> 2] = 0, e[N + 20 >> 2] = 0, e[N + 8 >> 2] = 0, e[N + 12 >> 2] = 0, e[N >> 2] = 0, e[N + 4 >> 2] = 0, e[5996] = 0, r = uc(N, A, 0), s = e[5996], e[5996] = 0, (s | 0) == 1) {
                              if (W = Hr() | 0, Ls[N >> 2] < 29)
                                break e;
                              break t;
                            }
                            if (r = e[r >> 2], s = r >>> 0 < 29, W = (s ? r : r - 29 | 0) + 1 | 0, s)
                              break r;
                            Br(e[N + 8 >> 2]);
                            break r;
                          case 6:
                          case 7:
                            W = 39;
                            break r;
                          case 8:
                          case 9:
                            W = 27;
                            break r;
                          case 25:
                            W = (Sn(p, 34) | A >>> 0 > 16) + (p >>> 0 > 16 ? 4 : 3) | 0;
                            break r;
                          case 17:
                            W = u;
                            break r;
                          case 14:
                            W = !(pu(1239, 1) & (s ^ -1)) + u | 0;
                            break r;
                          case 11:
                          case 12:
                          case 16:
                          case 18:
                          case 19:
                            W = u + 1 | 0;
                            break r;
                          case 10:
                          case 20:
                            W = u + 2 | 0;
                            break r;
                          case 13:
                          case 21:
                          case 22:
                          case 23:
                            W = u + 3 | 0;
                            break r;
                          case 15:
                            W = u + 4 | 0;
                            break r;
                          case 24:
                            if (e[N + 24 >> 2] = 0, e[N + 28 >> 2] = 0, e[N + 16 >> 2] = 0, e[N + 20 >> 2] = 0, e[N + 8 >> 2] = 0, e[N + 12 >> 2] = 0, e[N >> 2] = 0, e[N + 4 >> 2] = 0, e[5996] = 0, r = uc(N, A, 0), s = e[5996], e[5996] = 0, (s | 0) == 1) {
                              if (W = Hr() | 0, Ls[N >> 2] >= 29)
                                break t;
                              break e;
                            }
                            if (r = e[r >> 2], s = r >>> 0 < 29, W = (u + m | 0) + (s ? r : r - 29 | 0) | 0, s)
                              break r;
                            Br(e[N + 8 >> 2]);
                            break r;
                          default:
                            ga(2350, 1859, 280, 2003), Oi();
                          case 0:
                          case 1:
                            break r;
                          case 2:
                            break i;
                        }
                      W = 34;
                    }
                    return Jr = N + 32 | 0, W | 0;
                  }
                  Br(e[N + 8 >> 2]);
                }
                Jn(W | 0), Oi();
              }
              function vh(r, s, u) {
                r = r | 0, s = s | 0, u = u | 0;
                var A = 0, m = 0, p = 0, N = 0, W = 0, Te = 0, Xe = 0;
                if (N = e[r + 8 >> 2], m = e[r + 4 >> 2], N - m >>> 0 >= s >>> 0) {
                  if (A = m, W = s & 7, W)
                    for (; _[A | 0] = me[u | 0], A = A + 1 | 0, p = p + 1 | 0, (W | 0) != (p | 0); )
                      ;
                  for (s = s + m | 0; _[A | 0] = me[u | 0], _[A + 1 | 0] = me[u | 0], _[A + 2 | 0] = me[u | 0], _[A + 3 | 0] = me[u | 0], _[A + 4 | 0] = me[u | 0], _[A + 5 | 0] = me[u | 0], _[A + 6 | 0] = me[u | 0], _[A + 7 | 0] = me[u | 0], A = A + 8 | 0, (s | 0) != (A | 0); )
                    ;
                  e[r + 4 >> 2] = s;
                  return;
                }
                if (A = e[r >> 2], p = m - A | 0, Te = p + s | 0, (Te | 0) >= 0) {
                  if (N = N - A | 0, A = N << 1, Te = N >>> 0 >= 1073741823 ? 2147483647 : A >>> 0 > Te >>> 0 ? A : Te, Te && (Xe = Qs(Te)), p = p + Xe | 0, A = p, N = s & 7, N)
                    for (; _[A | 0] = me[u | 0], A = A + 1 | 0, W = W + 1 | 0, (N | 0) != (W | 0); )
                      ;
                  for (W = s + p | 0; _[A | 0] = me[u | 0], _[A + 1 | 0] = me[u | 0], _[A + 2 | 0] = me[u | 0], _[A + 3 | 0] = me[u | 0], _[A + 4 | 0] = me[u | 0], _[A + 5 | 0] = me[u | 0], _[A + 6 | 0] = me[u | 0], _[A + 7 | 0] = me[u | 0], A = A + 8 | 0, (W | 0) != (A | 0); )
                    ;
                  if (N = e[r >> 2], (N | 0) != (m | 0)) {
                    if (A = (N ^ -1) + m | 0, s = m - N & 3, s)
                      for (u = 0; p = p - 1 | 0, m = m - 1 | 0, _[p | 0] = me[m | 0], u = u + 1 | 0, (s | 0) != (u | 0); )
                        ;
                    if (A >>> 0 >= 3)
                      for (; _[p - 1 | 0] = me[m - 1 | 0], _[p - 2 | 0] = me[m - 2 | 0], _[p - 3 | 0] = me[m - 3 | 0], p = p - 4 | 0, m = m - 4 | 0, _[p | 0] = me[m | 0], (m | 0) != (N | 0); )
                        ;
                    m = e[r >> 2];
                  }
                  e[r + 8 >> 2] = Te + Xe, e[r + 4 >> 2] = W, e[r >> 2] = p, m && Br(m);
                  return;
                }
                Jo(), Oi();
              }
              function ud(r, s, u, A, m) {
                var p = 0, N = 0, W = 0, Te = 0, Xe = 0, fr = 0, ar = 0, vr = 0, _r = 0, hi = 0, mi = 0;
                vr = Jr - 16 | 0, Jr = vr, N = me[r | 0];
                e: {
                  if (!N) {
                    p = r;
                    break e;
                  }
                  p = r;
                  t: {
                    for (; ; ) {
                      if (Te = N << 24 >> 24, !((Te | 0) == 32 | Te - 9 >>> 0 < 5))
                        break t;
                      if (N = me[p + 1 | 0], p = p + 1 | 0, !N)
                        break;
                    }
                    break e;
                  }
                  t:
                    switch (N = N & 255, N - 43 | 0) {
                      case 0:
                      case 2:
                        break t;
                      default:
                        break e;
                    }
                  Xe = (N | 0) == 45 ? -1 : 0, p = p + 1 | 0;
                }
                e: {
                  if (!((u | 16) != 16 | me[p | 0] != 48)) {
                    if (hi = 1, (me[p + 1 | 0] & 223) == 88) {
                      p = p + 2 | 0, Te = 16;
                      break e;
                    }
                    p = p + 1 | 0, Te = u || 8;
                    break e;
                  }
                  Te = u || 10;
                }
                for (u = 0; ; ) {
                  e: {
                    N = -48, fr = _[p | 0];
                    t: {
                      if ((fr - 48 & 255) >>> 0 < 10 || (N = -87, (fr - 97 & 255) >>> 0 < 26))
                        break t;
                      if (N = -55, (fr - 65 & 255) >>> 0 > 25)
                        break e;
                    }
                    if (_r = N + fr | 0, (_r | 0) >= (Te | 0))
                      break e;
                    Aa(vr, Te, 0, 0, 0, ar, W, 0, 0), N = 1;
                    t: {
                      if (e[vr + 8 >> 2] | e[vr + 12 >> 2] || (mi = Ao(ar, W, Te, 0), fr = Ds, (fr | 0) == -1 & (_r ^ -1) >>> 0 < mi >>> 0))
                        break t;
                      W = fr, ar = _r + mi | 0, W = ar >>> 0 < _r >>> 0 ? W + 1 | 0 : W, hi = 1, N = u;
                    }
                    p = p + 1 | 0, u = N;
                    continue;
                  }
                  break;
                }
                s && (e[s >> 2] = hi ? p : r);
                e: {
                  t: {
                    r: {
                      if (u) {
                        e[5732] = 68, r = A & 1, Xe = r ? 0 : Xe, ar = A, W = m;
                        break r;
                      }
                      if ((m | 0) == (W | 0) & A >>> 0 > ar >>> 0 | m >>> 0 > W >>> 0)
                        break t;
                      r = A & 1;
                    }
                    if (!(r | Xe)) {
                      e[5732] = 68, r = A, A = r - 1 | 0, m = m - !r | 0;
                      break e;
                    }
                    if ((m | 0) == (W | 0) & A >>> 0 >= ar >>> 0 | m >>> 0 > W >>> 0)
                      break t;
                    e[5732] = 68;
                    break e;
                  }
                  r = Xe ^ ar, A = r - Xe | 0, s = Xe >> 31, m = (s ^ W) - ((r >>> 0 < Xe >>> 0) + s | 0) | 0;
                }
                return Jr = vr + 16 | 0, Ds = m, A;
              }
              function jg(r, s, u, A, m, p, N, W, Te, Xe) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0, m = m | 0, p = p | 0, N = N | 0, W = W | 0, Te = Te | 0, Xe = Xe | 0;
                var fr = 0;
                fr = Jr - 16 | 0, Jr = fr;
                e: {
                  if (r) {
                    r = w6(u);
                    t: {
                      if (s) {
                        s = fr + 4 | 0, xi[e[e[r >> 2] + 44 >> 2]](s, r), u = e[fr + 4 >> 2], _[A | 0] = u, _[A + 1 | 0] = u >>> 8, _[A + 2 | 0] = u >>> 16, _[A + 3 | 0] = u >>> 24, xi[e[e[r >> 2] + 32 >> 2]](s, r);
                        break t;
                      }
                      s = fr + 4 | 0, xi[e[e[r >> 2] + 40 >> 2]](s, r), u = e[fr + 4 >> 2], _[A | 0] = u, _[A + 1 | 0] = u >>> 8, _[A + 2 | 0] = u >>> 16, _[A + 3 | 0] = u >>> 24, xi[e[e[r >> 2] + 28 >> 2]](s, r);
                    }
                    $a(Te, s), Qn(s), e[m >> 2] = xi[e[e[r >> 2] + 12 >> 2]](r), e[p >> 2] = xi[e[e[r >> 2] + 16 >> 2]](r), s = fr + 4 | 0, xi[e[e[r >> 2] + 20 >> 2]](s, r), ca(N, s), Qn(s), xi[e[e[r >> 2] + 24 >> 2]](s, r), $a(W, s), Qn(s), r = xi[e[e[r >> 2] + 36 >> 2]](r) | 0;
                    break e;
                  }
                  r = E6(u);
                  t: {
                    if (s) {
                      s = fr + 4 | 0, xi[e[e[r >> 2] + 44 >> 2]](s, r), u = e[fr + 4 >> 2], _[A | 0] = u, _[A + 1 | 0] = u >>> 8, _[A + 2 | 0] = u >>> 16, _[A + 3 | 0] = u >>> 24, xi[e[e[r >> 2] + 32 >> 2]](s, r);
                      break t;
                    }
                    s = fr + 4 | 0, xi[e[e[r >> 2] + 40 >> 2]](s, r), u = e[fr + 4 >> 2], _[A | 0] = u, _[A + 1 | 0] = u >>> 8, _[A + 2 | 0] = u >>> 16, _[A + 3 | 0] = u >>> 24, xi[e[e[r >> 2] + 28 >> 2]](s, r);
                  }
                  $a(Te, s), Qn(s), e[m >> 2] = xi[e[e[r >> 2] + 12 >> 2]](r), e[p >> 2] = xi[e[e[r >> 2] + 16 >> 2]](r), s = fr + 4 | 0, xi[e[e[r >> 2] + 20 >> 2]](s, r), ca(N, s), Qn(s), xi[e[e[r >> 2] + 24 >> 2]](s, r), $a(W, s), Qn(s), r = xi[e[e[r >> 2] + 36 >> 2]](r) | 0;
                }
                e[Xe >> 2] = r, Jr = fr + 16 | 0;
              }
              function so(r, s, u) {
                var A = 0, m = 0, p = 0;
                if (u >>> 0 >= 512)
                  return Hl(r | 0, s | 0, u | 0), r;
                m = r + u | 0;
                e: {
                  if (!((r ^ s) & 3)) {
                    t: {
                      if (!(r & 3)) {
                        u = r;
                        break t;
                      }
                      if (!u) {
                        u = r;
                        break t;
                      }
                      for (u = r; ; ) {
                        if (_[u | 0] = me[s | 0], s = s + 1 | 0, u = u + 1 | 0, !(u & 3))
                          break t;
                        if (!(u >>> 0 < m >>> 0))
                          break;
                      }
                    }
                    A = m & -4;
                    t: {
                      if (A >>> 0 < 64 || (p = A + -64 | 0, p >>> 0 < u >>> 0))
                        break t;
                      for (; e[u >> 2] = e[s >> 2], e[u + 4 >> 2] = e[s + 4 >> 2], e[u + 8 >> 2] = e[s + 8 >> 2], e[u + 12 >> 2] = e[s + 12 >> 2], e[u + 16 >> 2] = e[s + 16 >> 2], e[u + 20 >> 2] = e[s + 20 >> 2], e[u + 24 >> 2] = e[s + 24 >> 2], e[u + 28 >> 2] = e[s + 28 >> 2], e[u + 32 >> 2] = e[s + 32 >> 2], e[u + 36 >> 2] = e[s + 36 >> 2], e[u + 40 >> 2] = e[s + 40 >> 2], e[u + 44 >> 2] = e[s + 44 >> 2], e[u + 48 >> 2] = e[s + 48 >> 2], e[u + 52 >> 2] = e[s + 52 >> 2], e[u + 56 >> 2] = e[s + 56 >> 2], e[u + 60 >> 2] = e[s + 60 >> 2], s = s - -64 | 0, u = u - -64 | 0, p >>> 0 >= u >>> 0; )
                        ;
                    }
                    if (u >>> 0 >= A >>> 0)
                      break e;
                    for (; e[u >> 2] = e[s >> 2], s = s + 4 | 0, u = u + 4 | 0, A >>> 0 > u >>> 0; )
                      ;
                    break e;
                  }
                  if (m >>> 0 < 4) {
                    u = r;
                    break e;
                  }
                  if (A = m - 4 | 0, A >>> 0 < r >>> 0) {
                    u = r;
                    break e;
                  }
                  for (u = r; _[u | 0] = me[s | 0], _[u + 1 | 0] = me[s + 1 | 0], _[u + 2 | 0] = me[s + 2 | 0], _[u + 3 | 0] = me[s + 3 | 0], s = s + 4 | 0, u = u + 4 | 0, A >>> 0 >= u >>> 0; )
                    ;
                }
                if (u >>> 0 < m >>> 0)
                  for (; _[u | 0] = me[s | 0], s = s + 1 | 0, u = u + 1 | 0, (m | 0) != (u | 0); )
                    ;
                return r;
              }
              function Q4(r, s, u, A, m, p, N, W, Te, Xe) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0, m = m | 0, p = p | 0, N = N | 0, W = W | 0, Te = Te | 0, Xe = Xe | 0;
                var fr = 0;
                fr = Jr - 16 | 0, Jr = fr;
                e: {
                  if (r) {
                    r = I6(u);
                    t: {
                      if (s) {
                        s = fr + 4 | 0, xi[e[e[r >> 2] + 44 >> 2]](s, r), u = e[fr + 4 >> 2], _[A | 0] = u, _[A + 1 | 0] = u >>> 8, _[A + 2 | 0] = u >>> 16, _[A + 3 | 0] = u >>> 24, xi[e[e[r >> 2] + 32 >> 2]](s, r);
                        break t;
                      }
                      s = fr + 4 | 0, xi[e[e[r >> 2] + 40 >> 2]](s, r), u = e[fr + 4 >> 2], _[A | 0] = u, _[A + 1 | 0] = u >>> 8, _[A + 2 | 0] = u >>> 16, _[A + 3 | 0] = u >>> 24, xi[e[e[r >> 2] + 28 >> 2]](s, r);
                    }
                    ca(Te, s), Qn(s), _[m | 0] = xi[e[e[r >> 2] + 12 >> 2]](r), _[p | 0] = xi[e[e[r >> 2] + 16 >> 2]](r), s = fr + 4 | 0, xi[e[e[r >> 2] + 20 >> 2]](s, r), ca(N, s), Qn(s), xi[e[e[r >> 2] + 24 >> 2]](s, r), ca(W, s), Qn(s), r = xi[e[e[r >> 2] + 36 >> 2]](r) | 0;
                    break e;
                  }
                  r = m6(u);
                  t: {
                    if (s) {
                      s = fr + 4 | 0, xi[e[e[r >> 2] + 44 >> 2]](s, r), u = e[fr + 4 >> 2], _[A | 0] = u, _[A + 1 | 0] = u >>> 8, _[A + 2 | 0] = u >>> 16, _[A + 3 | 0] = u >>> 24, xi[e[e[r >> 2] + 32 >> 2]](s, r);
                      break t;
                    }
                    s = fr + 4 | 0, xi[e[e[r >> 2] + 40 >> 2]](s, r), u = e[fr + 4 >> 2], _[A | 0] = u, _[A + 1 | 0] = u >>> 8, _[A + 2 | 0] = u >>> 16, _[A + 3 | 0] = u >>> 24, xi[e[e[r >> 2] + 28 >> 2]](s, r);
                  }
                  ca(Te, s), Qn(s), _[m | 0] = xi[e[e[r >> 2] + 12 >> 2]](r), _[p | 0] = xi[e[e[r >> 2] + 16 >> 2]](r), s = fr + 4 | 0, xi[e[e[r >> 2] + 20 >> 2]](s, r), ca(N, s), Qn(s), xi[e[e[r >> 2] + 24 >> 2]](s, r), ca(W, s), Qn(s), r = xi[e[e[r >> 2] + 36 >> 2]](r) | 0;
                }
                e[Xe >> 2] = r, Jr = fr + 16 | 0;
              }
              function kf(r, s, u, A) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0;
                var m = 0, p = 0, N = 0, W = 0, Te = 0, Xe = 0, fr = 0;
                m = Jr - 32 | 0, Jr = m, e[r + 8 >> 2] = 0, e[r + 12 >> 2] = 0, e[r + 4 >> 2] = A, e[r >> 2] = s, e[r + 16 >> 2] = 0, e[r + 20 >> 2] = 0, e[r + 24 >> 2] = 0, e[r + 28 >> 2] = 0, N = r + 32 | 0, s = N, e[s >> 2] = 0, e[s + 4 >> 2] = 0, e[r + 40 >> 2] = 0, e[s >> 2] = e[u >> 2], e[r + 36 >> 2] = e[u + 4 >> 2], e[r + 40 >> 2] = e[u + 8 >> 2], e[u + 8 >> 2] = 0, e[u >> 2] = 0, e[u + 4 >> 2] = 0, e[5996] = 0, ji(86, r + 44 | 0, r | 0), s = e[5996], e[5996] = 0;
                e: {
                  if ((s | 0) == 1 || (e[5996] = 0, ji(87, r - -64 | 0, r | 0), s = e[5996], e[5996] = 0, (s | 0) == 1) || (A = 0, e[5996] = 0, s = Mi(88, r | 0) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1))
                    break e;
                  if (e[r + 80 >> 2] = s, p = e[r + 36 >> 2], s = e[r + 32 >> 2], (p | 0) == (s | 0))
                    u = 0;
                  else {
                    for (u = s; A = e[e[u >> 2] + 84 >> 2] + A | 0, u = u + 8 | 0, (p | 0) != (u | 0); )
                      ;
                    u = e[e[s >> 2] + 80 >> 2];
                  }
                  if (W = e[r + 4 >> 2], Te = e[r >> 2], Xe = e[r + 8 >> 2], fr = e[r + 12 >> 2], e[5996] = 0, s = za(89, Te | 0, u | 0, A | 0, W | 0, p - s >> 3, (fr - Xe | 0) / 12 | 0) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1 || (e[r + 84 >> 2] = s, e[5996] = 0, e[m + 28 >> 2] = r, gs(90, m + 12 | 0, r | 0, m + 28 | 0), s = e[5996], e[5996] = 0, (s | 0) == 1))
                    break e;
                  return s = me[m + 24 | 0], s && ft(e[m + 16 >> 2]), _[r + 88 | 0] = s ^ 1, Jr = m + 32 | 0, r | 0;
                }
                u = Hr() | 0, Uo(N), s = e[r + 20 >> 2], s && (e[r + 24 >> 2] = s, Br(s)), ea(r + 8 | 0), Jn(u | 0), Oi();
              }
              function Wg(r, s, u, A) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0;
                var m = 0, p = 0, N = 0, W = 0, Te = 0, Xe = 0;
                m = Jr - 32 | 0, Jr = m, e[r + 8 >> 2] = 0, e[r + 12 >> 2] = 0, e[r + 4 >> 2] = A, e[r >> 2] = s, e[r + 16 >> 2] = 0, e[r + 8 >> 2] = e[u >> 2], e[r + 12 >> 2] = e[u + 4 >> 2], e[r + 16 >> 2] = e[u + 8 >> 2], e[u + 8 >> 2] = 0, e[u >> 2] = 0, e[u + 4 >> 2] = 0, e[r + 36 >> 2] = 0, e[r + 40 >> 2] = 0, e[r + 28 >> 2] = 0, e[r + 32 >> 2] = 0, e[r + 20 >> 2] = 0, e[r + 24 >> 2] = 0, e[5996] = 0, ji(86, r + 44 | 0, r | 0), s = e[5996], e[5996] = 0;
                e: {
                  if ((s | 0) == 1 || (e[5996] = 0, ji(87, r - -64 | 0, r | 0), s = e[5996], e[5996] = 0, (s | 0) == 1) || (A = 0, e[5996] = 0, s = Mi(88, r | 0) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1))
                    break e;
                  if (e[r + 80 >> 2] = s, p = e[r + 36 >> 2], s = e[r + 32 >> 2], (p | 0) == (s | 0))
                    u = 0;
                  else {
                    for (u = s; A = e[e[u >> 2] + 84 >> 2] + A | 0, u = u + 8 | 0, (p | 0) != (u | 0); )
                      ;
                    u = e[e[s >> 2] + 80 >> 2];
                  }
                  if (N = e[r + 4 >> 2], W = e[r >> 2], Te = e[r + 8 >> 2], Xe = e[r + 12 >> 2], e[5996] = 0, s = za(89, W | 0, u | 0, A | 0, N | 0, p - s >> 3, (Xe - Te | 0) / 12 | 0) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1 || (e[r + 84 >> 2] = s, e[5996] = 0, e[m + 28 >> 2] = r, gs(90, m + 12 | 0, r | 0, m + 28 | 0), s = e[5996], e[5996] = 0, (s | 0) == 1))
                    break e;
                  return s = me[m + 24 | 0], s && ft(e[m + 16 >> 2]), _[r + 88 | 0] = s ^ 1, Jr = m + 32 | 0, r | 0;
                }
                u = Hr() | 0, Uo(r + 32 | 0), s = e[r + 20 >> 2], s && (e[r + 24 >> 2] = s, Br(s)), ea(r + 8 | 0), Jn(u | 0), Oi();
              }
              function fd(r, s) {
                r = r | 0, s = s | 0;
                var u = 0, A = 0, m = 0, p = 0, N = 0, W = 0;
                A = Jr - 16 | 0, Jr = A, e[5996] = 0, p = pi(134, A + 8 | 0, r | 0) | 0, u = e[5996], e[5996] = 0;
                e: {
                  t: {
                    r: {
                      if ((u | 0) != 1) {
                        i: {
                          if (!me[p | 0])
                            break i;
                          u = e[(e[e[r >> 2] - 12 >> 2] + r | 0) + 28 >> 2], e[A + 4 >> 2] = u, e[u + 4 >> 2] = e[u + 4 >> 2] + 1, e[5996] = 0, W = Mi(135, e[A + 4 >> 2]) | 0, u = e[5996], e[5996] = 0;
                          n: {
                            s: {
                              if ((u | 0) != 1) {
                                if (u = e[A + 4 >> 2], m = e[u + 4 >> 2] - 1 | 0, e[u + 4 >> 2] = m, (m | 0) == -1 && xi[e[e[u >> 2] + 8 >> 2]](u), e[A + 4 >> 2] = e[(e[e[r >> 2] - 12 >> 2] + r | 0) + 24 >> 2], u = e[e[r >> 2] - 12 >> 2], e[5996] = 0, u = r + u | 0, m = Mi(136, u | 0) | 0, N = e[5996], e[5996] = 0, (N | 0) == 1 || (N = e[A + 4 >> 2], e[5996] = 0, s = Fl(137, W | 0, N | 0, u | 0, m | 0, s | 0) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1))
                                  break s;
                                if (s || (s = e[e[r >> 2] - 12 >> 2], e[5996] = 0, ji(138, r + s | 0, 5), s = e[5996], e[5996] = 0, (s | 0) != 1))
                                  break i;
                                s = Os(0) | 0;
                                break n;
                              }
                              s = Os(0) | 0, u = e[A + 4 >> 2], m = e[u + 4 >> 2] - 1 | 0, e[u + 4 >> 2] = m, (m | 0) == -1 && xi[e[e[u >> 2] + 8 >> 2]](u);
                              break n;
                            }
                            s = Os(0) | 0;
                          }
                          gl(p);
                          break r;
                        }
                        gl(p);
                        break t;
                      }
                      s = Os(0) | 0;
                    }
                    if (Cu(s | 0) | 0, s = e[e[r >> 2] - 12 >> 2], e[5996] = 0, qo(139, r + s | 0), s = e[5996], e[5996] = 0, (s | 0) == 1)
                      break e;
                    ef();
                  }
                  return Jr = A + 16 | 0, r | 0;
                }
                r = Hr() | 0, e[5996] = 0, Nn(110), s = e[5996], e[5996] = 0, (s | 0) != 1 && (Jn(r | 0), Oi()), Os(0) | 0, Na(), Oi();
              }
              function Ru(r, s, u) {
                r = r | 0, s = s | 0, u = u | 0;
                var A = 0, m = 0, p = 0, N = 0, W = 0, Te = 0, Xe = 0;
                m = Jr - 32 | 0, Jr = m, e[r + 8 >> 2] = 0, e[r >> 2] = 0, e[r + 4 >> 2] = 0, _[m + 4 | 0] = 0, e[m >> 2] = r;
                e: {
                  t: {
                    r: {
                      i: {
                        n: {
                          if (u) {
                            if (u >>> 0 >= 357913942) {
                              if (e[5996] = 0, Nn(47), r = e[5996], e[5996] = 0, (r | 0) == 1)
                                break r;
                              break e;
                            }
                            if (e[5996] = 0, u = Sn(u, 12), N = Mi(3, u | 0) | 0, A = e[5996], e[5996] = 0, (A | 0) == 1)
                              break r;
                            for (e[r + 4 >> 2] = N, e[r >> 2] = N, e[r + 8 >> 2] = u + N, e[m + 24 >> 2] = N, _[m + 20 | 0] = 0, e[m + 8 >> 2] = r + 8, Xe = s + u | 0, e[m + 16 >> 2] = m + 28, e[m + 12 >> 2] = m + 24, A = N; ; ) {
                              if (e[A + 8 >> 2] = 0, e[A >> 2] = 0, e[A + 4 >> 2] = 0, p = e[s >> 2], u = e[s + 4 >> 2], (p | 0) != (u | 0)) {
                                if (W = u - p | 0, (W | 0) < 0) {
                                  if (e[5996] = 0, e[m + 28 >> 2] = A, Nn(84), s = e[5996], e[5996] = 0, (s | 0) != 1)
                                    break e;
                                  if (u = Hr() | 0, s = e[A >> 2], !s)
                                    break i;
                                  e[A + 4 >> 2] = s, Br(s);
                                  break i;
                                }
                                if (e[5996] = 0, u = Mi(3, W | 0) | 0, Te = e[5996], e[5996] = 0, (Te | 0) == 1)
                                  break n;
                                if (e[A + 4 >> 2] = u, e[A >> 2] = u, e[A + 8 >> 2] = (W & -8) + u, W = e[s + 4 >> 2], (W | 0) != (p | 0))
                                  for (; Te = e[p + 4 >> 2], e[u >> 2] = e[p >> 2], e[u + 4 >> 2] = Te, u = u + 8 | 0, p = p + 8 | 0, (W | 0) != (p | 0); )
                                    ;
                                e[A + 4 >> 2] = u;
                              }
                              if (A = A + 12 | 0, s = s + 12 | 0, (Xe | 0) == (s | 0))
                                break;
                            }
                            e[r + 4 >> 2] = A;
                          }
                          return Jr = m + 32 | 0, r | 0;
                        }
                        u = Hr() | 0, e[m + 28 >> 2] = A;
                      }
                      Qd(m + 8 | 0), e[r + 4 >> 2] = N;
                      break t;
                    }
                    u = Hr() | 0;
                  }
                  ff(m), Jn(u | 0), Oi();
                }
                Oi();
              }
              function U4(r, s) {
                r = r | 0, s = s | 0;
                var u = 0, A = 0, m = 0, p = 0, N = 0, W = 0, Te = 0, Xe = 0, fr = 0;
                W = e[s >> 2], u = _[s + 11 | 0], e[r + 8 >> 2] = 0, e[r >> 2] = 0, e[r + 4 >> 2] = 0, s = (u | 0) < 0 ? W : s, u = 0, W = 0;
                e: {
                  t: {
                    r: {
                      for (; ; ) {
                        for (m = A, N = u, p = W; ; ) {
                          if (u = me[s | 0], !(u - 9 >>> 0 >= 5 & (u | 0) != 32)) {
                            s = s + 1 | 0;
                            continue;
                          }
                          if (A = me[u + 5584 | 0], (A | 0) == 255 || (u = me[me[s + 1 | 0] + 5584 | 0], (u | 0) == 255))
                            break e;
                          if (s = s + 2 | 0, W = u | A << 4, (m | 0) != (p | 0)) {
                            _[p | 0] = W, p = p + 1 | 0, e[r + 4 >> 2] = p;
                            continue;
                          }
                          break;
                        }
                        if (Te = p - N | 0, A = Te + 1 | 0, (A | 0) < 0) {
                          if (e[5996] = 0, Nn(8), s = e[5996], e[5996] = 0, (s | 0) == 1)
                            break r;
                          Oi();
                        }
                        i: {
                          u = Te << 1, A = Te >>> 0 >= 1073741823 ? 2147483647 : u >>> 0 > A >>> 0 ? u : A;
                          n: {
                            if (!A) {
                              Xe = 0;
                              break n;
                            }
                            if (e[5996] = 0, Xe = Mi(3, A | 0) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1)
                              break i;
                          }
                          if (u = Te + Xe | 0, _[u | 0] = W, A = A + Xe | 0, W = u + 1 | 0, (m | 0) != (N | 0)) {
                            if (fr = (N ^ -1) + p | 0, p = 0, Te = Te & 3, Te)
                              for (; u = u - 1 | 0, m = m - 1 | 0, _[u | 0] = me[m | 0], p = p + 1 | 0, (Te | 0) != (p | 0); )
                                ;
                            if (fr >>> 0 >= 3)
                              for (; _[u - 1 | 0] = me[m - 1 | 0], _[u - 2 | 0] = me[m - 2 | 0], _[u - 3 | 0] = me[m - 3 | 0], u = u - 4 | 0, m = m - 4 | 0, _[u | 0] = me[m | 0], (m | 0) != (N | 0); )
                                ;
                            u = Xe;
                          }
                          if (e[r + 8 >> 2] = A, e[r + 4 >> 2] = W, e[r >> 2] = u, !N)
                            continue;
                          Br(N);
                          continue;
                        }
                        break;
                      }
                      s = Hr() | 0;
                      break t;
                    }
                    s = Hr() | 0, N = e[r >> 2];
                  }
                  N && (e[r + 4 >> 2] = N, Br(N)), Jn(s | 0), Oi();
                }
              }
              function sl(r, s, u, A, m, p) {
                var N = 0, W = 0;
                if (_[r | 0] = 0, _[r + 1 | 0] = 0, _[r + 2 | 0] = 0, _[r + 3 | 0] = 0, _[r + 4 | 0] = 0, _[r + 5 | 0] = 0, _[r + 6 | 0] = 0, _[r + 7 | 0] = 0, _[r + 24 | 0] = 0, _[r + 25 | 0] = 0, _[r + 26 | 0] = 0, _[r + 27 | 0] = 0, _[r + 28 | 0] = 0, _[r + 29 | 0] = 0, _[r + 30 | 0] = 0, _[r + 31 | 0] = 0, _[r + 16 | 0] = 0, _[r + 17 | 0] = 0, _[r + 18 | 0] = 0, _[r + 19 | 0] = 0, _[r + 20 | 0] = 0, _[r + 21 | 0] = 0, _[r + 22 | 0] = 0, _[r + 23 | 0] = 0, _[r + 8 | 0] = 0, _[r + 9 | 0] = 0, _[r + 10 | 0] = 0, _[r + 11 | 0] = 0, _[r + 12 | 0] = 0, _[r + 13 | 0] = 0, _[r + 14 | 0] = 0, _[r + 15 | 0] = 0, e[5996] = 0, N = pi(127, r | 0, 130) | 0, W = e[5996], e[5996] = 0, (W | 0) != 1)
                  e: {
                    if (s = e[s >> 2], e[5996] = 0, s = uc(N, s, s >> 31), N = e[5996], e[5996] = 0, (N | 0) == 1 || (u = e[u >> 2], e[5996] = 0, s = pi(127, s | 0, u | 0) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1) || (u = e[A >> 2], e[5996] = 0, s = pi(127, s | 0, u | 0) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1) || (e[5996] = 0, s = pi(19, s | 0, m | 0) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1) || (u = e[p >> 2], e[5996] = 0, pi(127, s | 0, u | 0) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1))
                      break e;
                    return;
                  }
                s = Hr() | 0, (me[r | 0] | me[r + 1 | 0] << 8 | (me[r + 2 | 0] << 16 | me[r + 3 | 0] << 24)) >>> 0 >= 29 && (Br(me[r + 8 | 0] | me[r + 9 | 0] << 8 | (me[r + 10 | 0] << 16 | me[r + 11 | 0] << 24)), _[r + 8 | 0] = 0, _[r + 9 | 0] = 0, _[r + 10 | 0] = 0, _[r + 11 | 0] = 0), Jn(s | 0), Oi();
              }
              function Bc(r, s, u, A, m, p, N, W, Te, Xe, fr, ar) {
                e: {
                  t: {
                    if ((r | 0) == (p | 0)) {
                      if (!me[s | 0])
                        break e;
                      if (p = 0, _[s | 0] = 0, r = e[m >> 2], e[m >> 2] = r + 1, _[r | 0] = 46, r = me[W + 11 | 0], !((r & 128) >>> 7 | 0 ? e[W + 4 >> 2] : r & 127) || (r = e[Xe >> 2], (r - Te | 0) > 159))
                        break t;
                      return s = e[fr >> 2], e[Xe >> 2] = r + 4, e[r >> 2] = s, 0;
                    }
                    r: {
                      if ((r | 0) != (N | 0) || (p = me[W + 11 | 0], !((p & 128) >>> 7 | 0 ? e[W + 4 >> 2] : p & 127)))
                        break r;
                      if (!me[s | 0])
                        break e;
                      if (p = 0, r = e[Xe >> 2], (r - Te | 0) > 159)
                        break t;
                      return s = e[fr >> 2], e[Xe >> 2] = r + 4, e[r >> 2] = s, e[fr >> 2] = 0, 0;
                    }
                    if (p = -1, N = Vd(ar, ar + 32 | 0, r) - ar | 0, (N | 0) > 31)
                      break t;
                    r = _[N + 12416 | 0];
                    r: {
                      i:
                        switch ((N & -2) - 22 | 0) {
                          case 2:
                            if (s = e[m >> 2], (s | 0) != (A | 0) && (A = _[s - 1 | 0], u = _[u | 0], ((A - 97 >>> 0 < 26 ? A & 95 : A) | 0) != ((u - 97 >>> 0 < 26 ? u & 95 : u) | 0)))
                              break t;
                            return e[m >> 2] = s + 1, _[s | 0] = r, 0;
                          case 0:
                            _[u | 0] = 80;
                            break r;
                          default:
                            break i;
                        }
                      if (A = r - 97 >>> 0 < 26 ? r & 95 : r, (A | 0) != _[u | 0] || (_[u | 0] = A - 65 >>> 0 < 26 ? A | 32 : A, !me[s | 0]) || (_[s | 0] = 0, s = me[W + 11 | 0], !((s & 128) >>> 7 | 0 ? e[W + 4 >> 2] : s & 127)) || (s = e[Xe >> 2], (s - Te | 0) > 159))
                        break r;
                      u = e[fr >> 2], e[Xe >> 2] = s + 4, e[s >> 2] = u;
                    }
                    if (s = e[m >> 2], e[m >> 2] = s + 1, _[s | 0] = r, p = 0, (N | 0) > 21)
                      break t;
                    e[fr >> 2] = e[fr >> 2] + 1;
                  }
                  return p;
                }
                return -1;
              }
              function ol(r, s, u, A, m, p, N, W, Te, Xe, fr, ar) {
                e: {
                  t: {
                    if ((r | 0) == (p | 0)) {
                      if (!me[s | 0])
                        break e;
                      if (p = 0, _[s | 0] = 0, r = e[m >> 2], e[m >> 2] = r + 1, _[r | 0] = 46, r = me[W + 11 | 0], !((r & 128) >>> 7 | 0 ? e[W + 4 >> 2] : r & 127) || (r = e[Xe >> 2], (r - Te | 0) > 159))
                        break t;
                      return s = e[fr >> 2], e[Xe >> 2] = r + 4, e[r >> 2] = s, 0;
                    }
                    r: {
                      if ((r | 0) != (N | 0) || (p = me[W + 11 | 0], !((p & 128) >>> 7 | 0 ? e[W + 4 >> 2] : p & 127)))
                        break r;
                      if (!me[s | 0])
                        break e;
                      if (p = 0, r = e[Xe >> 2], (r - Te | 0) > 159)
                        break t;
                      return s = e[fr >> 2], e[Xe >> 2] = r + 4, e[r >> 2] = s, e[fr >> 2] = 0, 0;
                    }
                    if (p = -1, N = Gd(ar, ar + 128 | 0, r) - ar | 0, (N | 0) > 124)
                      break t;
                    r = _[(N >> 2) + 12416 | 0];
                    r: {
                      i: {
                        if (ar = N & -5, (ar | 0) != 88) {
                          if ((ar | 0) != 96)
                            break i;
                          if (s = e[m >> 2], (s | 0) != (A | 0) && (A = _[s - 1 | 0], u = _[u | 0], ((A - 97 >>> 0 < 26 ? A & 95 : A) | 0) != ((u - 97 >>> 0 < 26 ? u & 95 : u) | 0)))
                            break t;
                          return e[m >> 2] = s + 1, _[s | 0] = r, 0;
                        }
                        _[u | 0] = 80;
                        break r;
                      }
                      if (A = r - 97 >>> 0 < 26 ? r & 95 : r, (A | 0) != _[u | 0] || (_[u | 0] = A - 65 >>> 0 < 26 ? A | 32 : A, !me[s | 0]) || (_[s | 0] = 0, s = me[W + 11 | 0], !((s & 128) >>> 7 | 0 ? e[W + 4 >> 2] : s & 127)) || (s = e[Xe >> 2], (s - Te | 0) > 159))
                        break r;
                      u = e[fr >> 2], e[Xe >> 2] = s + 4, e[s >> 2] = u;
                    }
                    if (s = e[m >> 2], e[m >> 2] = s + 1, _[s | 0] = r, p = 0, (N | 0) > 84)
                      break t;
                    e[fr >> 2] = e[fr >> 2] + 1;
                  }
                  return p;
                }
                return -1;
              }
              function Sf(r, s, u) {
                r = r | 0, s = s | 0, u = u | 0;
                var A = 0, m = 0, p = 0, N = 0, W = 0, Te = 0, Xe = 0, fr = 0, ar = 0, vr = 0, _r = 0, hi = 0, mi = 0, Ni = 0, Hi = 0, Ji = 0;
                if ((u | 0) != 1) {
                  ar = Jr - 1040 | 0, Jr = ar, Ni = e[5732];
                  e: {
                    t: {
                      if (N = ar + 16 | 0, _r = Ia[((u >>> 0 <= 153 ? u : 0) << 1) + 21296 >> 1] + 19372 | 0, s = e[e[6178] + 20 >> 2], s) {
                        W = e[s + 4 >> 2], A = e[s >> 2], p = e[A >> 2] + 1794895138 | 0, Te = qa(e[A + 8 >> 2], p), Xe = qa(e[A + 12 >> 2], p), m = qa(e[A + 16 >> 2], p);
                        r: {
                          if (W >>> 2 >>> 0 <= Te >>> 0 || (s = W - (Te << 2) | 0, (m | Xe) & 3 | (s >>> 0 <= Xe >>> 0 | s >>> 0 <= m >>> 0)))
                            break r;
                          for (Hi = m >>> 2 | 0, Ji = Xe >>> 2 | 0; ; ) {
                            if (vr = Te >>> 1 | 0, Xe = vr + hi | 0, m = Xe << 1, s = A + (m + Ji << 2) | 0, mi = qa(e[s >> 2], p), s = qa(e[s + 4 >> 2], p), s >>> 0 >= W >>> 0 | W - s >>> 0 <= mi >>> 0 | me[A + (s + mi | 0) | 0])
                              break r;
                            if (s = _f(_r, s + A | 0), !s) {
                              if (s = A + (m + Hi << 2) | 0, m = qa(e[s >> 2], p), s = qa(e[s + 4 >> 2], p), s >>> 0 >= W >>> 0 | m >>> 0 >= W - s >>> 0)
                                break r;
                              fr = me[A + (s + m | 0) | 0] ? 0 : s + A | 0;
                              break r;
                            }
                            if ((Te | 0) == 1)
                              break r;
                            s = (s | 0) < 0, Te = s ? vr : Te - vr | 0, hi = s ? hi : Xe;
                          }
                        }
                      }
                      fr = fr || _r, s = Fa(fr);
                      r: {
                        if (s >>> 0 >= 1024) {
                          so(N, fr, 1023), _[N + 1023 | 0] = 0, s = 68;
                          break r;
                        }
                        so(N, fr, s + 1 | 0), s = 0;
                      }
                      if (s) {
                        if ((s | 0) != 28)
                          break t;
                        s = 5575;
                      } else
                        s = N;
                      break e;
                    }
                    $c(), Oi();
                  }
                  me[s | 0] || (e[ar >> 2] = u, ql(N, 1024, 2507, ar), s = N), e[5732] = Ni, Za(r, s), Jr = ar + 1040 | 0;
                  return;
                }
                Za(r, 1694);
              }
              function zg(r, s, u, A) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0;
                var m = 0, p = 0, N = 0, W = 0, Te = 0, Xe = 0;
                p = Jr - 32 | 0, Jr = p, e[p + 28 >> 2] = A, e[p + 24 >> 2] = A, _[p + 20 | 0] = 0, e[p + 8 >> 2] = r, e[p + 16 >> 2] = p + 28, e[p + 12 >> 2] = p + 24;
                e: {
                  t: {
                    r: {
                      if ((s | 0) != (u | 0))
                        for (; ; ) {
                          if (e[A + 8 >> 2] = 0, e[A >> 2] = 0, e[A + 4 >> 2] = 0, r = e[s + 4 >> 2], m = e[s >> 2], (r | 0) != (m | 0)) {
                            if (m = r - m | 0, (m | 0) < 0) {
                              if (e[5996] = 0, Nn(8), r = e[5996], e[5996] = 0, (r | 0) == 1)
                                break r;
                              Oi();
                            }
                            if (e[5996] = 0, r = Mi(3, m | 0) | 0, N = e[5996], e[5996] = 0, (N | 0) == 1)
                              break t;
                            e[A + 4 >> 2] = r, e[A >> 2] = r, e[A + 8 >> 2] = r + m, m = e[s >> 2], N = e[s + 4 >> 2];
                            i: {
                              if ((m | 0) == (N | 0))
                                break i;
                              if (Xe = (m ^ -1) + N | 0, W = 0, Te = N - m & 7, Te)
                                for (; _[r | 0] = me[m | 0], r = r + 1 | 0, m = m + 1 | 0, W = W + 1 | 0, (Te | 0) != (W | 0); )
                                  ;
                              if (Xe >>> 0 < 7)
                                break i;
                              for (; _[r | 0] = me[m | 0], _[r + 1 | 0] = me[m + 1 | 0], _[r + 2 | 0] = me[m + 2 | 0], _[r + 3 | 0] = me[m + 3 | 0], _[r + 4 | 0] = me[m + 4 | 0], _[r + 5 | 0] = me[m + 5 | 0], _[r + 6 | 0] = me[m + 6 | 0], _[r + 7 | 0] = me[m + 7 | 0], r = r + 8 | 0, m = m + 8 | 0, (N | 0) != (m | 0); )
                                ;
                            }
                            e[A + 4 >> 2] = r;
                          }
                          if (A = A + 12 | 0, e[p + 28 >> 2] = A, s = s + 12 | 0, (u | 0) == (s | 0))
                            break;
                        }
                      return Jr = p + 32 | 0, A | 0;
                    }
                    if (r = Hr() | 0, s = e[A >> 2], !s)
                      break e;
                    e[A + 4 >> 2] = s, Br(s);
                    break e;
                  }
                  r = Hr() | 0;
                }
                Qd(p + 8 | 0), Jn(r | 0), Oi();
              }
              function Ff(r, s) {
                var u = 0, A = 0, m = 0;
                u = (r | 0) == (s | 0), _[s + 12 | 0] = u;
                e: {
                  if (u)
                    break e;
                  for (; ; ) {
                    if (A = e[s + 8 >> 2], me[A + 12 | 0])
                      break e;
                    t: {
                      if (u = e[A + 8 >> 2], m = e[u >> 2], (m | 0) == (A | 0)) {
                        if (m = e[u + 4 >> 2], !(!m | me[m + 12 | 0]))
                          break t;
                        r: {
                          if (e[A >> 2] == (s | 0)) {
                            s = A;
                            break r;
                          }
                          s = e[A + 4 >> 2], r = e[s >> 2], e[A + 4 >> 2] = r, r && (e[r + 8 >> 2] = A, u = e[A + 8 >> 2]), e[s + 8 >> 2] = u, r = e[A + 8 >> 2], e[((e[r >> 2] != (A | 0)) << 2) + r >> 2] = s, e[s >> 2] = A, e[A + 8 >> 2] = s, u = e[s + 8 >> 2], A = e[u >> 2];
                        }
                        _[s + 12 | 0] = 1, _[u + 12 | 0] = 0, r = e[A + 4 >> 2], e[u >> 2] = r, r && (e[r + 8 >> 2] = u), e[A + 8 >> 2] = e[u + 8 >> 2], r = e[u + 8 >> 2], e[((e[r >> 2] != (u | 0)) << 2) + r >> 2] = A, e[A + 4 >> 2] = u, e[u + 8 >> 2] = A;
                        return;
                      }
                      if (!(me[m + 12 | 0] | !m))
                        break t;
                      r: {
                        if (e[A >> 2] != (s | 0)) {
                          s = A;
                          break r;
                        }
                        r = e[s + 4 >> 2], e[A >> 2] = r, r && (e[r + 8 >> 2] = A, u = e[A + 8 >> 2]), e[s + 8 >> 2] = u, r = e[A + 8 >> 2], e[((e[r >> 2] != (A | 0)) << 2) + r >> 2] = s, e[s + 4 >> 2] = A, e[A + 8 >> 2] = s, u = e[s + 8 >> 2];
                      }
                      _[s + 12 | 0] = 1, _[u + 12 | 0] = 0, r = e[u + 4 >> 2], s = e[r >> 2], e[u + 4 >> 2] = s, s && (e[s + 8 >> 2] = u), e[r + 8 >> 2] = e[u + 8 >> 2], s = e[u + 8 >> 2], e[((e[s >> 2] != (u | 0)) << 2) + s >> 2] = r, e[r >> 2] = u, e[u + 8 >> 2] = r;
                      break e;
                    }
                    if (_[A + 12 | 0] = 1, _[u + 12 | 0] = (r | 0) == (u | 0), _[m + 12 | 0] = 1, s = u, (r | 0) == (u | 0))
                      break;
                  }
                }
              }
              function Jg(r, s, u) {
                r = r | 0, s = s | 0, u = u | 0;
                var A = 0, m = 0, p = 0;
                e[r + 8 >> 2] = 0, e[r >> 2] = 0, e[r + 4 >> 2] = 0;
                e: {
                  t: {
                    r: {
                      i: {
                        n: {
                          s: {
                            if (m = e[s + 4 >> 2], A = e[s >> 2], (m | 0) != (A | 0)) {
                              if (A = m - A | 0, (A | 0) < 0) {
                                if (e[5996] = 0, Nn(85), s = e[5996], e[5996] = 0, (s | 0) == 1)
                                  break s;
                                break e;
                              }
                              if (e[5996] = 0, m = Mi(3, A | 0) | 0, p = e[5996], e[5996] = 0, (p | 0) == 1)
                                break s;
                              if (e[r + 4 >> 2] = m, e[r >> 2] = m, e[r + 8 >> 2] = (A & -8) + m, A = e[s >> 2], s = e[s + 4 >> 2], (A | 0) != (s | 0))
                                for (; jn[m >> 3] = jn[A >> 3], m = m + 8 | 0, A = A + 8 | 0, (s | 0) != (A | 0); )
                                  ;
                              e[r + 4 >> 2] = m;
                            }
                            if (e[r + 12 >> 2] = 0, e[r + 16 >> 2] = 0, e[r + 20 >> 2] = 0, s = e[u + 4 >> 2], m = e[u >> 2], (s | 0) == (m | 0))
                              break i;
                            if (s = s - m | 0, (s | 0) >= 0)
                              break n;
                            if (e[5996] = 0, Nn(85), s = e[5996], e[5996] = 0, (s | 0) != 1)
                              break e;
                            break r;
                          }
                          A = Hr() | 0;
                          break t;
                        }
                        if (e[5996] = 0, m = Mi(3, s | 0) | 0, A = e[5996], e[5996] = 0, (A | 0) == 1)
                          break r;
                        if (e[r + 16 >> 2] = m, e[r + 12 >> 2] = m, e[r + 20 >> 2] = (s & -8) + m, A = e[u >> 2], s = e[u + 4 >> 2], (A | 0) != (s | 0))
                          for (; jn[m >> 3] = jn[A >> 3], m = m + 8 | 0, A = A + 8 | 0, (s | 0) != (A | 0); )
                            ;
                        e[r + 16 >> 2] = m;
                      }
                      return r | 0;
                    }
                    if (A = Hr() | 0, s = e[r + 12 >> 2], !s)
                      break t;
                    e[r + 16 >> 2] = s, Br(s);
                  }
                  s = e[r >> 2], s && (e[r + 4 >> 2] = s, Br(s)), Jn(A | 0), Oi();
                }
                Oi();
              }
              function Yg(r, s, u) {
                r = r | 0, s = s | 0, u = u | 0;
                var A = 0, m = 0, p = 0, N = 0, W = 0, Te = 0, Xe = 0, fr = 0;
                A = Jr - 32 | 0, Jr = A, e[r + 8 >> 2] = 0, e[r + 12 >> 2] = 0, e[r + 4 >> 2] = u, e[r >> 2] = s, e[r + 16 >> 2] = 0, e[r + 20 >> 2] = 0, e[r + 24 >> 2] = 0, e[r + 28 >> 2] = 0, p = r + 32 | 0, e[p >> 2] = 0, e[p + 4 >> 2] = 0, e[r + 40 >> 2] = 0, e[5996] = 0, ji(86, r + 44 | 0, r | 0), s = e[5996], e[5996] = 0;
                e: {
                  if ((s | 0) == 1 || (e[5996] = 0, ji(87, r - -64 | 0, r | 0), s = e[5996], e[5996] = 0, (s | 0) == 1) || (s = 0, e[5996] = 0, u = Mi(88, r | 0) | 0, m = e[5996], e[5996] = 0, (m | 0) == 1))
                    break e;
                  if (e[r + 80 >> 2] = u, m = e[r + 32 >> 2], N = e[r + 36 >> 2], (m | 0) == (N | 0))
                    u = 0;
                  else {
                    for (u = m; s = e[e[u >> 2] + 84 >> 2] + s | 0, u = u + 8 | 0, (N | 0) != (u | 0); )
                      ;
                    u = e[e[m >> 2] + 80 >> 2];
                  }
                  if (W = e[r + 4 >> 2], Te = e[r >> 2], Xe = e[r + 8 >> 2], fr = e[r + 12 >> 2], e[5996] = 0, s = za(89, Te | 0, u | 0, s | 0, W | 0, N - m >> 3, (fr - Xe | 0) / 12 | 0) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1 || (e[r + 84 >> 2] = s, e[5996] = 0, e[A + 28 >> 2] = r, gs(90, A + 12 | 0, r | 0, A + 28 | 0), s = e[5996], e[5996] = 0, (s | 0) == 1))
                    break e;
                  return s = me[A + 24 | 0], s && ft(e[A + 16 >> 2]), _[r + 88 | 0] = s ^ 1, Jr = A + 32 | 0, r | 0;
                }
                u = Hr() | 0, Uo(p), s = e[r + 20 >> 2], s && (e[r + 24 >> 2] = s, Br(s)), ea(r + 8 | 0), Jn(u | 0), Oi();
              }
              function Xg(r, s, u) {
                r = r | 0, s = s | 0, u = u | 0;
                var A = 0, m = 0, p = 0, N = 0, W = 0, Te = 0;
                e[r + 8 >> 2] = 0, e[r >> 2] = 0, e[r + 4 >> 2] = 0;
                e: {
                  if (u) {
                    if (u >>> 0 >= 536870912) {
                      if (e[5996] = 0, Nn(84), s = e[5996], e[5996] = 0, (s | 0) == 1)
                        break e;
                      Oi();
                    }
                    if (e[5996] = 0, m = u << 3, A = Mi(3, m | 0) | 0, p = e[5996], e[5996] = 0, (p | 0) == 1)
                      break e;
                    e[r + 4 >> 2] = A, e[r >> 2] = A, e[r + 8 >> 2] = A + m, p = u - 1 & 536870911, N = u & 7;
                    t: {
                      if (!N) {
                        u = s;
                        break t;
                      }
                      for (u = s; Te = e[u + 4 >> 2], e[A >> 2] = e[u >> 2], e[A + 4 >> 2] = Te, A = A + 8 | 0, u = u + 8 | 0, W = W + 1 | 0, (W | 0) != (N | 0); )
                        ;
                    }
                    if (p >>> 0 >= 7)
                      for (s = s + m | 0; m = e[u + 4 >> 2], e[A >> 2] = e[u >> 2], e[A + 4 >> 2] = m, m = e[u + 12 >> 2], e[A + 8 >> 2] = e[u + 8 >> 2], e[A + 12 >> 2] = m, m = e[u + 20 >> 2], e[A + 16 >> 2] = e[u + 16 >> 2], e[A + 20 >> 2] = m, m = e[u + 28 >> 2], e[A + 24 >> 2] = e[u + 24 >> 2], e[A + 28 >> 2] = m, m = e[u + 36 >> 2], e[A + 32 >> 2] = e[u + 32 >> 2], e[A + 36 >> 2] = m, m = e[u + 44 >> 2], e[A + 40 >> 2] = e[u + 40 >> 2], e[A + 44 >> 2] = m, m = e[u + 52 >> 2], e[A + 48 >> 2] = e[u + 48 >> 2], e[A + 52 >> 2] = m, m = e[u + 60 >> 2], e[A + 56 >> 2] = e[u + 56 >> 2], e[A + 60 >> 2] = m, A = A - -64 | 0, u = u - -64 | 0, (s | 0) != (u | 0); )
                        ;
                    e[r + 4 >> 2] = A;
                  }
                  return r | 0;
                }
                u = Hr() | 0, s = e[r >> 2], s && (e[r + 4 >> 2] = s, Br(s)), Jn(u | 0), Oi();
              }
              function xu(r, s, u, A) {
                var m = 0, p = 0, N = 0, W = 0;
                N = Jr - 32 | 0, Jr = N, m = A & 2147483647, W = m, p = m - 1006698496 | 0, m = m - 1140785152 | 0;
                e: {
                  if ((p | 0) == (m | 0) & 0 | m >>> 0 > p >>> 0) {
                    if (m = u << 4 | s >>> 28, u = A << 4 | u >>> 28, s = s & 268435455, (s | 0) == 134217728 & (r | 0) != 0 | s >>> 0 > 134217728) {
                      p = u + 1073741824 | 0, m = m + 1 | 0, p = m ? p : p + 1 | 0;
                      break e;
                    }
                    if (p = u + 1073741824 | 0, r | (s | 0) != 134217728)
                      break e;
                    r = m & 1, m = r + m | 0, p = r >>> 0 > m >>> 0 ? p + 1 | 0 : p;
                    break e;
                  }
                  if (!(!u & (W | 0) == 2147418112 ? !(r | s) : W >>> 0 < 2147418112)) {
                    r = A << 4 | u >>> 28, m = u << 4 | s >>> 28, p = r & 524287 | 2146959360;
                    break e;
                  }
                  if (m = 0, p = 2146435072, W >>> 0 > 1140785151 || (p = 0, W = W >>> 16 | 0, W >>> 0 < 15249))
                    break e;
                  if (m = A & 65535 | 65536, Ea(N + 16 | 0, r, s, u, m, W - 15233 | 0), Tf(N, r, s, u, m, 15361 - W | 0), s = e[N + 8 >> 2], m = s << 4, s = e[N + 12 >> 2] << 4 | s >>> 28, u = e[N >> 2], p = e[N + 4 >> 2], W = p, m = p >>> 28 | m, p = s, r = W & 268435455, s = u | (e[N + 16 >> 2] | e[N + 24 >> 2] | (e[N + 20 >> 2] | e[N + 28 >> 2])) != 0, (r | 0) == 134217728 & (s | 0) != 0 | r >>> 0 > 134217728) {
                    m = m + 1 | 0, p = m ? p : p + 1 | 0;
                    break e;
                  }
                  if (s | (r | 0) != 134217728)
                    break e;
                  r = m, m = m + (m & 1) | 0, p = r >>> 0 > m >>> 0 ? p + 1 | 0 : p;
                }
                return Jr = N + 32 | 0, Zo(0, m | 0), Zo(1, A & -2147483648 | p), +ru();
              }
              function nf(r, s) {
                r = r | 0, s = s | 0;
                var u = 0, A = 0, m = 0, p = 0, N = 0, W = 0, Te = 0, Xe = 0;
                if (A = Jr - 16 | 0, Jr = A, e[A + 12 >> 2] = s, s >>> 0 < 2147483632) {
                  e: {
                    if (((me[r + 11 | 0] & 128) >>> 7 | 0 ? (e[r + 8 >> 2] & 2147483647) - 1 | 0 : 10) >>> 0 >= s >>> 0 || (s = me[r + 11 | 0], e[A + 8 >> 2] = (s & 128) >>> 7 | 0 ? e[r + 4 >> 2] : s & 127, u = e[(Ls[A + 12 >> 2] < Ls[A + 8 >> 2] ? A + 8 | 0 : A + 12 | 0) >> 2], u >>> 0 >= 11 ? (u = u + 16 & -16, m = u - 1 | 0, u = (m | 0) == 11 ? u : m) : u = 10, (u | 0) == (((me[r + 11 | 0] & 128) >>> 7 | 0 ? (e[r + 8 >> 2] & 2147483647) - 1 | 0 : 10) | 0)))
                      break e;
                    p = Jr - 16 | 0, Jr = p, s = me[r + 11 | 0], m = (s & 128) >>> 7 | 0 ? e[r + 4 >> 2] : s & 127;
                    t: {
                      r: {
                        Te = u >>> 0 < 11;
                        i: {
                          if (Te) {
                            Xe = 1, N = u + 1 | 0, W = e[r >> 2], u = m, s = r;
                            break i;
                          }
                          N = u + 1 | 0;
                          n: {
                            if (u >>> 0 > ((me[r + 11 | 0] & 128) >>> 7 | 0 ? (e[r + 8 >> 2] & 2147483647) - 1 | 0 : 10) >>> 0) {
                              Of(p + 8 | 0, N);
                              break n;
                            }
                            if (e[5996] = 0, ji(289, p + 8 | 0, N | 0), s = e[5996], e[5996] = 0, (s | 0) == 1)
                              break r;
                          }
                          N = e[p + 12 >> 2], u = me[r + 11 | 0], s = (u & 128) >>> 7 | 0, Xe = s, W = s ? e[r >> 2] : r, u = s ? e[r + 4 >> 2] : u & 127, s = e[p + 8 >> 2];
                        }
                        if (s = bf(s, W, u + 1 | 0), Xe && Br(W), !Te) {
                          e[r + 8 >> 2] = N | -2147483648, e[r + 4 >> 2] = m, e[r >> 2] = s;
                          break t;
                        }
                        _[r + 11 | 0] = m;
                        break t;
                      }
                      Cu(Os(0) | 0) | 0, ef();
                    }
                    Jr = p + 16 | 0;
                  }
                  Jr = A + 16 | 0;
                  return;
                }
                Ra(), Oi();
              }
              function al(r) {
                var s = 0, u = 0, A = 0, m = 0, p = 0;
                A = e[5726], u = r + 7 & -8, s = A + u | 0;
                e: {
                  t: {
                    if (s >>> 0 <= A >>> 0 && u || s >>> 0 > y8() << 16 >>> 0 && !(Gl(s | 0) | 0))
                      break t;
                    e[5726] = s;
                    break e;
                  }
                  e[5732] = 48, A = -1;
                }
                if ((A | 0) != -1) {
                  r = r + A | 0, e[r - 4 >> 2] = 16, u = r - 16 | 0, e[u >> 2] = 16, s = e[5992], s ? p = e[s + 8 >> 2] : p = 0;
                  e: {
                    t: {
                      if ((p | 0) == (A | 0)) {
                        if (m = A - (e[A - 4 >> 2] & -2) | 0, p = e[m - 4 >> 2], e[s + 8 >> 2] = r, r = m - (p & -2) | 0, s = -16, !(_[(r + e[r >> 2] | 0) - 4 | 0] & 1))
                          break t;
                        s = e[r + 4 >> 2], e[s + 8 >> 2] = e[r + 8 >> 2], e[e[r + 8 >> 2] + 4 >> 2] = s, s = u - r | 0, e[r >> 2] = s;
                        break e;
                      }
                      e[A + 12 >> 2] = 16, e[A >> 2] = 16, e[A + 8 >> 2] = r, e[A + 4 >> 2] = s, e[5992] = A, s = 16;
                    }
                    r = s + A | 0, s = u - r | 0, e[r >> 2] = s;
                  }
                  e[((s & -4) + r | 0) - 4 >> 2] = s | 1, u = e[r >> 2] - 8 | 0;
                  e: {
                    if (u >>> 0 <= 127) {
                      s = (u >>> 3 | 0) - 1 | 0;
                      break e;
                    }
                    if (m = Fo(u), s = ((u >>> 29 - m ^ 4) - (m << 2) | 0) + 110 | 0, u >>> 0 <= 4095)
                      break e;
                    s = ((u >>> 30 - m ^ 2) - (m << 1) | 0) + 71 | 0, s = s >>> 0 >= 63 ? 63 : s;
                  }
                  u = s << 4, e[r + 4 >> 2] = u + 22944, u = u + 22952 | 0, e[r + 8 >> 2] = e[u >> 2], e[u >> 2] = r, e[e[r + 8 >> 2] + 4 >> 2] = r, u = e[5994], m = e[5995], r = s & 31, (s & 63) >>> 0 >= 32 ? (s = 1 << r, p = 0) : (p = 1 << r, s = p - 1 & 1 >>> 32 - r), e[5994] = p | u, e[5995] = s | m;
                }
                return (A | 0) != -1;
              }
              function Ch(r, s, u, A, m, p, N, W) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0, m = m | 0, p = p | 0, N = N | 0, W = W | 0, r = Jr - 16 | 0, Jr = r, e[r + 12 >> 2] = u, e[r + 8 >> 2] = p, e[r + 12 >> 2] = u, e[r + 8 >> 2] = p, s = e[r + 12 >> 2];
                e: {
                  for (; ; ) {
                    if (s >>> 0 >= A >>> 0) {
                      u = 0;
                      break e;
                    }
                    if (u = 2, s = e[s >> 2], s >>> 0 > 1114111 | (s & -2048) == 55296)
                      break e;
                    t: {
                      r: {
                        if (s >>> 0 <= 127) {
                          if (u = 1, p = e[r + 8 >> 2], (N - p | 0) <= 0)
                            break e;
                          e[r + 8 >> 2] = p + 1, _[p | 0] = s;
                          break r;
                        }
                        if (s >>> 0 <= 2047) {
                          if (u = e[r + 8 >> 2], (N - u | 0) < 2)
                            break t;
                          e[r + 8 >> 2] = u + 1, _[u | 0] = s >>> 6 | 192, u = e[r + 8 >> 2], e[r + 8 >> 2] = u + 1, _[u | 0] = s & 63 | 128;
                          break r;
                        }
                        if (u = e[r + 8 >> 2], p = N - u | 0, s >>> 0 <= 65535) {
                          if ((p | 0) < 3)
                            break t;
                          e[r + 8 >> 2] = u + 1, _[u | 0] = s >>> 12 | 224, u = e[r + 8 >> 2], e[r + 8 >> 2] = u + 1, _[u | 0] = s >>> 6 & 63 | 128, u = e[r + 8 >> 2], e[r + 8 >> 2] = u + 1, _[u | 0] = s & 63 | 128;
                          break r;
                        }
                        if ((p | 0) < 4)
                          break t;
                        e[r + 8 >> 2] = u + 1, _[u | 0] = s >>> 18 | 240, u = e[r + 8 >> 2], e[r + 8 >> 2] = u + 1, _[u | 0] = s >>> 12 & 63 | 128, u = e[r + 8 >> 2], e[r + 8 >> 2] = u + 1, _[u | 0] = s >>> 6 & 63 | 128, u = e[r + 8 >> 2], e[r + 8 >> 2] = u + 1, _[u | 0] = s & 63 | 128;
                      }
                      s = e[r + 12 >> 2] + 4 | 0, e[r + 12 >> 2] = s;
                      continue;
                    }
                    break;
                  }
                  u = 1;
                }
                return e[m >> 2] = e[r + 12 >> 2], e[W >> 2] = e[r + 8 >> 2], Jr = r + 16 | 0, u | 0;
              }
              function vc(r) {
                var s = 0, u = 0, A = 0, m = 0, p = 0;
                e[r + 8 >> 2] = 0, e[r >> 2] = 0, e[r + 4 >> 2] = 0;
                e: {
                  t: {
                    r: {
                      i: {
                        n: {
                          s: {
                            if (u = e[6141], A = e[6142], (u | 0) != (A | 0)) {
                              if (m = A - u | 0, (m | 0) < 0) {
                                if (e[5996] = 0, Nn(85), s = e[5996], e[5996] = 0, (s | 0) == 1)
                                  break s;
                                break e;
                              }
                              if (e[5996] = 0, s = Mi(3, m | 0) | 0, p = e[5996], e[5996] = 0, (p | 0) == 1)
                                break s;
                              for (e[r + 4 >> 2] = s, e[r >> 2] = s, e[r + 8 >> 2] = (m & -8) + s; jn[s >> 3] = jn[u >> 3], s = s + 8 | 0, u = u + 8 | 0, (A | 0) != (u | 0); )
                                ;
                              e[r + 4 >> 2] = s;
                            }
                            if (e[r + 12 >> 2] = 0, e[r + 16 >> 2] = 0, e[r + 20 >> 2] = 0, u = e[6144], A = e[6145], (u | 0) == (A | 0))
                              break i;
                            if (m = A - u | 0, (m | 0) >= 0)
                              break n;
                            if (e[5996] = 0, Nn(85), s = e[5996], e[5996] = 0, (s | 0) != 1)
                              break e;
                            break r;
                          }
                          u = Hr() | 0;
                          break t;
                        }
                        if (e[5996] = 0, s = Mi(3, m | 0) | 0, p = e[5996], e[5996] = 0, (p | 0) == 1)
                          break r;
                        for (e[r + 16 >> 2] = s, e[r + 12 >> 2] = s, e[r + 20 >> 2] = (m & -8) + s; jn[s >> 3] = jn[u >> 3], s = s + 8 | 0, u = u + 8 | 0, (A | 0) != (u | 0); )
                          ;
                        e[r + 16 >> 2] = s;
                      }
                      return r;
                    }
                    if (u = Hr() | 0, s = e[r + 12 >> 2], !s)
                      break t;
                    e[r + 16 >> 2] = s, Br(s);
                  }
                  s = e[r >> 2], s && (e[r + 4 >> 2] = s, Br(s)), Jn(u | 0), Oi();
                }
                Oi();
              }
              function Cc(r, s, u, A, m) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0, m = m | 0;
                var p = 0, N = 0, W = 0, Te = 0;
                for (s = 0, r = u; ; ) {
                  e: {
                    if (r >>> 0 >= A >>> 0 | s >>> 0 >= m >>> 0)
                      break e;
                    N = 1, p = _[r | 0];
                    t: {
                      if ((p | 0) >= 0)
                        break t;
                      if (p >>> 0 < 4294967234)
                        break e;
                      if (p >>> 0 <= 4294967263) {
                        if ((A - r | 0) < 2 || (N = 2, (me[r + 1 | 0] & 192) != 128))
                          break e;
                        break t;
                      }
                      if (N = p & 255, p >>> 0 <= 4294967279) {
                        if ((A - r | 0) < 3)
                          break e;
                        W = me[r + 2 | 0], p = me[r + 1 | 0];
                        r: {
                          i: {
                            if ((N | 0) != 237) {
                              if ((N | 0) != 224)
                                break i;
                              if ((p & 224) == 160)
                                break r;
                              break e;
                            }
                            if ((p & 224) != 128)
                              break e;
                            break r;
                          }
                          if ((p & 192) != 128)
                            break e;
                        }
                        if (N = 3, (W & 192) != 128)
                          break e;
                        break t;
                      }
                      if ((A - r | 0) < 4 | p >>> 0 > 4294967284 | m - s >>> 0 < 2)
                        break e;
                      W = me[r + 3 | 0], Te = me[r + 2 | 0], p = me[r + 1 | 0];
                      r: {
                        i:
                          switch (N - 240 | 0) {
                            case 0:
                              if ((p + 112 & 255) >>> 0 >= 48)
                                break e;
                              break r;
                            case 4:
                              if ((p & 240) != 128)
                                break e;
                              break r;
                            default:
                              break i;
                          }
                        if ((p & 192) != 128)
                          break e;
                      }
                      if ((Te & 192) != 128 | (W & 192) != 128 | (N << 18 & 1835008 | (p & 48) << 12) >>> 0 > 1114111)
                        break e;
                      s = s + 1 | 0, N = 4;
                    }
                    s = s + 1 | 0, r = r + N | 0;
                    continue;
                  }
                  break;
                }
                return r - u | 0;
              }
              function cd(r, s) {
                r = r | 0, s = s | 0;
                var u = 0, A = 0, m = 0, p = 0, N = 0, W = 0;
                u = Jr - 32 | 0, Jr = u, e[r + 8 >> 2] = 0, e[r >> 2] = 0, e[r + 4 >> 2] = 0, _[u + 4 | 0] = 0, e[u >> 2] = r, m = e[s + 4 >> 2], p = e[s >> 2], N = m - p | 0, A = (N | 0) / 12 | 0;
                e: {
                  t: {
                    r: {
                      if ((m | 0) != (p | 0)) {
                        if (A >>> 0 >= 357913942) {
                          if (e[5996] = 0, Nn(41), r = e[5996], e[5996] = 0, (r | 0) == 1)
                            break r;
                          Oi();
                        }
                        if (e[5996] = 0, m = Mi(3, N | 0) | 0, p = e[5996], e[5996] = 0, (p | 0) == 1)
                          break r;
                        e[r + 4 >> 2] = m, e[r >> 2] = m, e[r + 8 >> 2] = m + Sn(A, 12), p = e[s + 4 >> 2], s = e[s >> 2], e[u + 28 >> 2] = m, e[u + 24 >> 2] = m, _[u + 20 | 0] = 0, e[u + 8 >> 2] = r + 8, e[u + 16 >> 2] = u + 28, e[u + 12 >> 2] = u + 24;
                        i: {
                          if ((s | 0) == (p | 0)) {
                            A = m;
                            break i;
                          }
                          for (A = m; ; ) {
                            n: {
                              if (_[s + 11 | 0] >= 0) {
                                N = e[s + 4 >> 2], e[A >> 2] = e[s >> 2], e[A + 4 >> 2] = N, e[A + 8 >> 2] = e[s + 8 >> 2];
                                break n;
                              }
                              if (N = e[s + 4 >> 2], W = e[s >> 2], e[5996] = 0, gs(40, A | 0, W | 0, N | 0), A = e[5996], e[5996] = 0, (A | 0) == 1)
                                break t;
                              A = e[u + 28 >> 2];
                            }
                            if (A = A + 12 | 0, e[u + 28 >> 2] = A, s = s + 12 | 0, (p | 0) == (s | 0))
                              break;
                          }
                        }
                        e[r + 4 >> 2] = A;
                      }
                      return Jr = u + 32 | 0, r | 0;
                    }
                    s = Hr() | 0;
                    break e;
                  }
                  s = Hr() | 0, Ha(u + 8 | 0), e[r + 4 >> 2] = m;
                }
                AA(u), Jn(s | 0), Oi();
              }
              function ld(r, s, u, A, m) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0, m = m | 0;
                var p = 0, N = 0, W = 0, Te = 0;
                for (r = u; ; ) {
                  e: {
                    if (m >>> 0 <= Te >>> 0 | r >>> 0 >= A >>> 0)
                      break e;
                    p = 1, s = _[r | 0];
                    t: {
                      if ((s | 0) >= 0)
                        break t;
                      if (s >>> 0 < 4294967234)
                        break e;
                      if (s >>> 0 <= 4294967263) {
                        if ((A - r | 0) < 2 || (p = 2, (me[r + 1 | 0] & 192) != 128))
                          break e;
                        break t;
                      }
                      if (N = s & 255, s >>> 0 <= 4294967279) {
                        if ((A - r | 0) < 3)
                          break e;
                        W = me[r + 2 | 0], s = me[r + 1 | 0];
                        r: {
                          i: {
                            if ((N | 0) != 237) {
                              if ((N | 0) != 224)
                                break i;
                              if ((s & 224) == 160)
                                break r;
                              break e;
                            }
                            if ((s & 224) != 128)
                              break e;
                            break r;
                          }
                          if ((s & 192) != 128)
                            break e;
                        }
                        if (p = 3, (W & 192) != 128)
                          break e;
                        break t;
                      }
                      if ((A - r | 0) < 4 | s >>> 0 > 4294967284)
                        break e;
                      p = me[r + 3 | 0], W = me[r + 2 | 0], s = me[r + 1 | 0];
                      r: {
                        i:
                          switch (N - 240 | 0) {
                            case 0:
                              if ((s + 112 & 255) >>> 0 >= 48)
                                break e;
                              break r;
                            case 4:
                              if ((s & 240) != 128)
                                break e;
                              break r;
                            default:
                              break i;
                          }
                        if ((s & 192) != 128)
                          break e;
                      }
                      if ((W & 192) != 128 | (p & 192) != 128 || (p = 4, (N << 18 & 1835008 | (s & 48) << 12) >>> 0 > 1114111))
                        break e;
                    }
                    Te = Te + 1 | 0, r = r + p | 0;
                    continue;
                  }
                  break;
                }
                return r - u | 0;
              }
              function _g(r, s, u, A, m, p, N, W, Te, Xe) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0, m = m | 0, p = p | 0, N = N | 0, W = W | 0, Te = Te | 0, Xe = Xe | 0;
                var fr = 0, ar = 0;
                fr = Jr - 16 | 0, Jr = fr, ar = Xe;
                e: {
                  if (r) {
                    Xe = fr + 4 | 0, r = I6(s), xi[e[e[r >> 2] + 44 >> 2]](Xe, r), s = e[fr + 4 >> 2], _[u | 0] = s, _[u + 1 | 0] = s >>> 8, _[u + 2 | 0] = s >>> 16, _[u + 3 | 0] = s >>> 24, xi[e[e[r >> 2] + 32 >> 2]](Xe, r), ca(Te, Xe), Qn(Xe), xi[e[e[r >> 2] + 28 >> 2]](Xe, r), ca(W, Xe), Qn(Xe), _[A | 0] = xi[e[e[r >> 2] + 12 >> 2]](r), _[m | 0] = xi[e[e[r >> 2] + 16 >> 2]](r), xi[e[e[r >> 2] + 20 >> 2]](Xe, r), ca(p, Xe), Qn(Xe), xi[e[e[r >> 2] + 24 >> 2]](Xe, r), ca(N, Xe), Qn(fr + 4 | 0), r = xi[e[e[r >> 2] + 36 >> 2]](r) | 0;
                    break e;
                  }
                  Xe = fr + 4 | 0, r = m6(s), xi[e[e[r >> 2] + 44 >> 2]](Xe, r), s = e[fr + 4 >> 2], _[u | 0] = s, _[u + 1 | 0] = s >>> 8, _[u + 2 | 0] = s >>> 16, _[u + 3 | 0] = s >>> 24, xi[e[e[r >> 2] + 32 >> 2]](Xe, r), ca(Te, Xe), Qn(Xe), xi[e[e[r >> 2] + 28 >> 2]](Xe, r), ca(W, Xe), Qn(Xe), _[A | 0] = xi[e[e[r >> 2] + 12 >> 2]](r), _[m | 0] = xi[e[e[r >> 2] + 16 >> 2]](r), xi[e[e[r >> 2] + 20 >> 2]](Xe, r), ca(p, Xe), Qn(Xe), xi[e[e[r >> 2] + 24 >> 2]](Xe, r), ca(N, Xe), Qn(fr + 4 | 0), r = xi[e[e[r >> 2] + 36 >> 2]](r) | 0;
                }
                e[ar >> 2] = r, Jr = fr + 16 | 0;
              }
              function Zg(r, s, u, A, m, p, N, W, Te, Xe) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0, m = m | 0, p = p | 0, N = N | 0, W = W | 0, Te = Te | 0, Xe = Xe | 0;
                var fr = 0, ar = 0;
                fr = Jr - 16 | 0, Jr = fr, ar = Xe;
                e: {
                  if (r) {
                    Xe = fr + 4 | 0, r = w6(s), xi[e[e[r >> 2] + 44 >> 2]](Xe, r), s = e[fr + 4 >> 2], _[u | 0] = s, _[u + 1 | 0] = s >>> 8, _[u + 2 | 0] = s >>> 16, _[u + 3 | 0] = s >>> 24, xi[e[e[r >> 2] + 32 >> 2]](Xe, r), $a(Te, Xe), Qn(Xe), xi[e[e[r >> 2] + 28 >> 2]](Xe, r), $a(W, Xe), Qn(Xe), e[A >> 2] = xi[e[e[r >> 2] + 12 >> 2]](r), e[m >> 2] = xi[e[e[r >> 2] + 16 >> 2]](r), xi[e[e[r >> 2] + 20 >> 2]](Xe, r), ca(p, Xe), Qn(Xe), xi[e[e[r >> 2] + 24 >> 2]](Xe, r), $a(N, Xe), Qn(Xe), r = xi[e[e[r >> 2] + 36 >> 2]](r) | 0;
                    break e;
                  }
                  Xe = fr + 4 | 0, r = E6(s), xi[e[e[r >> 2] + 44 >> 2]](Xe, r), s = e[fr + 4 >> 2], _[u | 0] = s, _[u + 1 | 0] = s >>> 8, _[u + 2 | 0] = s >>> 16, _[u + 3 | 0] = s >>> 24, xi[e[e[r >> 2] + 32 >> 2]](Xe, r), $a(Te, Xe), Qn(Xe), xi[e[e[r >> 2] + 28 >> 2]](Xe, r), $a(W, Xe), Qn(Xe), e[A >> 2] = xi[e[e[r >> 2] + 12 >> 2]](r), e[m >> 2] = xi[e[e[r >> 2] + 16 >> 2]](r), xi[e[e[r >> 2] + 20 >> 2]](Xe, r), ca(p, Xe), Qn(Xe), xi[e[e[r >> 2] + 24 >> 2]](Xe, r), $a(N, Xe), Qn(Xe), r = xi[e[e[r >> 2] + 36 >> 2]](r) | 0;
                }
                e[ar >> 2] = r, Jr = fr + 16 | 0;
              }
              function Bo(r) {
                var s = 0, u = 0, A = 0, m = 0, p = 0, N = 0, W = 0, Te = 0, Xe = 0;
                s = e[r + 112 >> 2], A = e[r + 116 >> 2], N = (s | A) != 0, W = s, u = e[r + 4 >> 2], p = e[r + 44 >> 2], s = u - p | 0, Te = s, m = s + e[r + 120 >> 2] | 0, s = e[r + 124 >> 2] + (s >> 31) | 0;
                e: {
                  if (s = m >>> 0 < Te >>> 0 ? s + 1 | 0 : s, !(((s | 0) >= (A | 0) & m >>> 0 >= W >>> 0 | (s | 0) > (A | 0)) & N)) {
                    A = Jr - 16 | 0, Jr = A, u = -1;
                    t: {
                      if (cA(r) || (xi[e[r + 32 >> 2]](r, A + 15 | 0, 1) | 0) != 1)
                        break t;
                      u = me[A + 15 | 0];
                    }
                    if (Jr = A + 16 | 0, A = u, (u | 0) >= 0)
                      break e;
                    p = e[r + 44 >> 2], u = e[r + 4 >> 2];
                  }
                  return e[r + 112 >> 2] = -1, e[r + 116 >> 2] = -1, e[r + 104 >> 2] = u, A = p - u | 0, u = A + m | 0, s = (A >> 31) + s | 0, e[r + 120 >> 2] = u, e[r + 124 >> 2] = u >>> 0 < A >>> 0 ? s + 1 | 0 : s, -1;
                }
                u = m + 1 | 0, s = u ? s : s + 1 | 0, W = e[r + 4 >> 2], p = e[r + 8 >> 2], m = e[r + 116 >> 2], Te = m, N = e[r + 112 >> 2];
                e: {
                  if (!(m | N) || (m = N - u | 0, N = Te - (s + (u >>> 0 > N >>> 0) | 0) | 0, Xe = p - W | 0, Te = Xe >> 31, (N | 0) >= (Te | 0) & m >>> 0 >= Xe >>> 0 | (N | 0) > (Te | 0)))
                    break e;
                  p = m + W | 0;
                }
                return e[r + 104 >> 2] = p, m = e[r + 44 >> 2], p = m - W | 0, u = p + u | 0, s = (p >> 31) + s | 0, e[r + 120 >> 2] = u, e[r + 124 >> 2] = u >>> 0 < p >>> 0 ? s + 1 | 0 : s, m >>> 0 >= W >>> 0 && (_[W - 1 | 0] = A), A;
              }
              function $g(r, s) {
                r = r | 0, s = s | 0;
                var u = 0, A = 0, m = 0, p = 0, N = 0, W = 0, Te = 0, Xe = 0, fr = 0;
                N = Jr - 16 | 0, Jr = N;
                e: {
                  t: {
                    if ((s | 0) != -1) {
                      if (Te = e[r + 8 >> 2], Xe = e[r + 12 >> 2], A = e[r + 24 >> 2], (A | 0) == e[r + 28 >> 2]) {
                        if (m = -1, !(me[r + 48 | 0] & 16))
                          break e;
                        if (fr = e[r + 44 >> 2], W = e[r + 20 >> 2], e[5996] = 0, u = r + 32 | 0, ji(98, u | 0, 0), p = e[5996], e[5996] = 0, (p | 0) == 1 || (p = (me[u + 11 | 0] & 128) >>> 7 | 0 ? (e[u + 8 >> 2] & 2147483647) - 1 | 0 : 10, e[5996] = 0, ji(172, u | 0, p | 0), p = e[5996], e[5996] = 0, (p | 0) == 1))
                          break t;
                        u = (me[u + 11 | 0] & 128) >>> 7 | 0 ? e[u >> 2] : u, m = me[r + 43 | 0], e[r + 28 >> 2] = u + ((m & 128) >>> 7 | 0 ? e[r + 36 >> 2] : m & 127), e[r + 20 >> 2] = u, e[r + 24 >> 2] = u, e[r + 24 >> 2] = e[r + 24 >> 2] + (A - W | 0), e[r + 44 >> 2] = e[r + 20 >> 2] + (fr - W | 0), A = e[r + 24 >> 2];
                      }
                      e[N + 12 >> 2] = A + 1, A = r + 44 | 0, u = N + 12 | 0, u = e[(Ls[u >> 2] < Ls[A >> 2] ? A : u) >> 2], e[r + 44 >> 2] = u, me[r + 48 | 0] & 8 && (A = r + 32 | 0, A = (me[A + 11 | 0] & 128) >>> 7 | 0 ? e[A >> 2] : A, e[r + 16 >> 2] = u, e[r + 12 >> 2] = A + (Xe - Te | 0), e[r + 8 >> 2] = A), m = jc(r, s << 24 >> 24);
                      break e;
                    }
                    m = (s | 0) != -1 ? s : 0;
                    break e;
                  }
                  Cu(Os(0) | 0) | 0, ef();
                }
                return Jr = N + 16 | 0, m | 0;
              }
              function kh(r, s, u, A) {
                var m = 0, p = 0, N = 0, W = 0;
                N = Jr - 32 | 0, Jr = N, p = A & 2147483647, m = p - 1065418752 | 0, W = p - 1082064896 | 0;
                e: {
                  if ((m | 0) == (W | 0) & 0 | m >>> 0 < W >>> 0) {
                    if (p = (A & 33554431) << 7 | u >>> 25, m = 0, W = m, u = u & 33554431, !(!m & (u | 0) == 16777216 ? !(r | s) : !m & u >>> 0 < 16777216)) {
                      m = p + 1073741825 | 0;
                      break e;
                    }
                    if (m = p + 1073741824 | 0, u ^ 16777216 | r | (s | W))
                      break e;
                    m = (p & 1) + m | 0;
                    break e;
                  }
                  if (!(!u & (p | 0) == 2147418112 ? !(r | s) : p >>> 0 < 2147418112)) {
                    m = ((A & 33554431) << 7 | u >>> 25) & 4194303 | 2143289344;
                    break e;
                  }
                  if (m = 2139095040, p >>> 0 > 1082064895 || (m = 0, p = p >>> 16 | 0, p >>> 0 < 16145))
                    break e;
                  if (m = A & 65535 | 65536, Ea(N + 16 | 0, r, s, u, m, p - 16129 | 0), Tf(N, r, s, u, m, 16257 - p | 0), r = e[N + 8 >> 2], m = (e[N + 12 >> 2] & 33554431) << 7 | r >>> 25, u = e[N >> 2] | (e[N + 16 >> 2] | e[N + 24 >> 2] | (e[N + 20 >> 2] | e[N + 28 >> 2])) != 0, p = e[N + 4 >> 2], s = 0, r = r & 33554431, !(!s & (r | 0) == 16777216 ? !(u | p) : !s & r >>> 0 < 16777216)) {
                    m = m + 1 | 0;
                    break e;
                  }
                  if (r ^ 16777216 | u | (s | p))
                    break e;
                  m = (m & 1) + m | 0;
                }
                return Jr = N + 32 | 0, Zo(2, A & -2147483648 | m), ho();
              }
              function dd(r, s, u) {
                var A = 0, m = 0, p = 0, N = 0, W = 0, Te = 0, Xe = 0, fr = 0, ar = 0;
                e: {
                  t: {
                    r: {
                      i: {
                        n: {
                          s: {
                            a: {
                              o: {
                                l: {
                                  c: {
                                    if (s) {
                                      if (!u)
                                        break c;
                                      break l;
                                    }
                                    Ds = 0, r = (r >>> 0) / (u >>> 0) | 0;
                                    break e;
                                  }
                                  if (!r)
                                    break o;
                                  break a;
                                }
                                if (!(u - 1 & u))
                                  break s;
                                p = (Fo(u) + 33 | 0) - Fo(s) | 0, N = 0 - p | 0;
                                break i;
                              }
                              Ds = 0, r = (s >>> 0) / 0 | 0;
                              break e;
                            }
                            if (A = 32 - Fo(s) | 0, A >>> 0 < 31)
                              break n;
                            break r;
                          }
                          if ((u | 0) == 1)
                            break t;
                          p = u ? 31 - Fo(u - 1 ^ u) | 0 : 32, u = p & 31, (p & 63) >>> 0 >= 32 ? r = s >>> u | 0 : (A = s >>> u | 0, r = ((1 << u) - 1 & s) << 32 - u | r >>> u), Ds = A;
                          break e;
                        }
                        p = A + 1 | 0, N = 63 - A | 0;
                      }
                      if (A = p & 63, m = A & 31, A >>> 0 >= 32 ? (A = 0, W = s >>> m | 0) : (A = s >>> m | 0, W = ((1 << m) - 1 & s) << 32 - m | r >>> m), N = N & 63, m = N & 31, N >>> 0 >= 32 ? (s = r << m, r = 0) : (s = (1 << m) - 1 & r >>> 32 - m | s << m, r = r << m), p)
                        for (N = u - 1 | 0, ar = (N | 0) == -1 ? -1 : 0; Te = A << 1 | W >>> 31, A = W << 1 | s >>> 31, m = ar - (Te + (A >>> 0 > N >>> 0) | 0) >> 31, Xe = u & m, W = A - Xe | 0, A = Te - (A >>> 0 < Xe >>> 0) | 0, s = s << 1 | r >>> 31, r = fr | r << 1, fr = m & 1, p = p - 1 | 0, !!p; )
                          ;
                      Ds = s << 1 | r >>> 31, r = fr | r << 1;
                      break e;
                    }
                    r = 0, s = 0;
                  }
                  Ds = s;
                }
                return r;
              }
              function ep(r, s, u, A, m, p) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0, m = m | 0, p = p | 0;
                var N = 0, W = 0, Te = 0, Xe = 0, fr = 0, ar = 0, vr = 0, _r = 0, hi = 0;
                Te = e[s + 44 >> 2], Xe = e[s + 24 >> 2], Te >>> 0 < Xe >>> 0 && (e[s + 44 >> 2] = Xe, Te = Xe), vr = -1, _r = -1, hi = p & 24;
                e: {
                  if (!hi | (m | 0) == 1 & (hi | 0) == 24)
                    break e;
                  Te && (N = s + 32 | 0, N = Te - ((me[N + 11 | 0] & 128) >>> 7 | 0 ? e[N >> 2] : N) | 0, fr = N >> 31);
                  t: {
                    r:
                      switch (m | 0) {
                        case 1:
                          if (p & 8) {
                            W = e[s + 12 >> 2] - e[s + 8 >> 2] | 0, ar = W >> 31;
                            break t;
                          }
                          W = Xe - e[s + 20 >> 2] | 0, ar = W >> 31;
                          break t;
                        case 0:
                          break t;
                        case 2:
                          break r;
                        default:
                          break e;
                      }
                    W = N, ar = fr;
                  }
                  if (A = A + ar | 0, u = u + W | 0, A = W >>> 0 > u >>> 0 ? A + 1 | 0 : A, (A | 0) < 0 | (u >>> 0 > N >>> 0 & (A | 0) >= (fr | 0) | (A | 0) > (fr | 0)))
                    break e;
                  m = p & 8;
                  t: {
                    if (!(u | A))
                      break t;
                    if (!e[s + 12 >> 2] && m)
                      break e;
                    if (!(p & 16))
                      break t;
                    if (!Xe)
                      break e;
                  }
                  m && (m = e[s + 8 >> 2], e[s + 16 >> 2] = Te, e[s + 12 >> 2] = u + m, e[s + 8 >> 2] = m), p & 16 && (m = e[s + 20 >> 2], e[s + 28 >> 2] = e[s + 28 >> 2], e[s + 20 >> 2] = m, e[s + 24 >> 2] = m, e[s + 24 >> 2] = u + e[s + 24 >> 2]), vr = u, _r = A;
                }
                e[r + 8 >> 2] = vr, e[r + 12 >> 2] = _r, e[r >> 2] = 0, e[r + 4 >> 2] = 0;
              }
              function hd(r) {
                var s = 0, u = 0, A = 0, m = 0, p = 0, N = 0, W = 0, Te = 0, Xe = 0;
                s = r;
                e: {
                  if (s & 3)
                    for (; ; ) {
                      if (u = me[s | 0], !u | (u | 0) == 61)
                        break e;
                      if (s = s + 1 | 0, !(s & 3))
                        break;
                    }
                  u = e[s >> 2];
                  t: {
                    if ((u ^ -1) & u - 16843009 & -2139062144)
                      break t;
                    for (; ; ) {
                      if ((u ^ 1027423549) - 16843009 & (u ^ -1) & -2139062144)
                        break t;
                      if (u = e[s + 4 >> 2], s = s + 4 | 0, !!(u - 16843009 & (u ^ -1) & -2139062144))
                        break;
                    }
                  }
                  for (; u = s, A = me[s | 0], !!((A | 0) != 61 && (s = s + 1 | 0, A)); )
                    ;
                  s = u;
                }
                if ((r | 0) == (s | 0))
                  return 0;
                p = s - r | 0;
                e: {
                  if (me[p + r | 0] || (m = e[6181], !m) || (s = e[m >> 2], !s))
                    break e;
                  for (; ; ) {
                    t: {
                      N = r, u = s, W = p, A = 0;
                      r: {
                        if (!p)
                          break r;
                        if (A = me[r | 0], A)
                          i: {
                            for (; ; ) {
                              if (Te = me[u | 0], (Te | 0) != (A | 0) | !Te || (W = W - 1 | 0, !W))
                                break i;
                              if (u = u + 1 | 0, A = me[N + 1 | 0], N = N + 1 | 0, !A)
                                break;
                            }
                            A = 0;
                          }
                        else
                          A = 0;
                        A = A - me[u | 0] | 0;
                      }
                      if (!A && (s = s + p | 0, me[s | 0] == 61))
                        break t;
                      if (s = e[m + 4 >> 2], m = m + 4 | 0, s)
                        continue;
                      break e;
                    }
                    break;
                  }
                  Xe = s + 1 | 0;
                }
                return Xe;
              }
              function fu(r, s) {
                r = r | 0, s = s | 0;
                var u = 0, A = 0;
                A = me[r | 0] | me[r + 1 | 0] << 8 | (me[r + 2 | 0] << 16 | me[r + 3 | 0] << 24);
                e: {
                  t: {
                    r: {
                      if (s >>> 0 <= 28) {
                        if (A >>> 0 < 29)
                          break r;
                        s = me[r + 8 | 0] | me[r + 9 | 0] << 8 | (me[r + 10 | 0] << 16 | me[r + 11 | 0] << 24), so(r + 4 | 0, s, A - 29 | 0), Br(s), s = (me[r | 0] | me[r + 1 | 0] << 8 | (me[r + 2 | 0] << 16 | me[r + 3 | 0] << 24)) - 29 | 0, _[r | 0] = s, _[r + 1 | 0] = s >>> 8, _[r + 2 | 0] = s >>> 16, _[r + 3 | 0] = s >>> 24;
                        return;
                      }
                      if (A >>> 0 >= 29) {
                        if (u = wc(me[r + 8 | 0] | me[r + 9 | 0] << 8 | (me[r + 10 | 0] << 16 | me[r + 11 | 0] << 24), s), _[r + 8 | 0] = u, _[r + 9 | 0] = u >>> 8, _[r + 10 | 0] = u >>> 16, _[r + 11 | 0] = u >>> 24, !u)
                          break t;
                        _[r + 4 | 0] = s, _[r + 5 | 0] = s >>> 8, _[r + 6 | 0] = s >>> 16, _[r + 7 | 0] = s >>> 24;
                        return;
                      }
                      if (u = da(s), !u)
                        break e;
                      u = so(u, r + 4 | 0, A), _[r + 4 | 0] = s, _[r + 5 | 0] = s >>> 8, _[r + 6 | 0] = s >>> 16, _[r + 7 | 0] = s >>> 24, _[r + 8 | 0] = u, _[r + 9 | 0] = u >>> 8, _[r + 10 | 0] = u >>> 16, _[r + 11 | 0] = u >>> 24, s = A + 29 | 0, _[r | 0] = s, _[r + 1 | 0] = s >>> 8, _[r + 2 | 0] = s >>> 16, _[r + 3 | 0] = s >>> 24;
                    }
                    return;
                  }
                  ga(1370, 2249, 181, 1040), Oi();
                }
                ga(1357, 2249, 185, 1040), Oi();
              }
              function ul(r, s, u, A) {
                var m = 0, p = 0, N = 0;
                m = Jr - 160 | 0, Jr = m, p = s ? r : m + 158 | 0, e[m + 148 >> 2] = p, r = -1, N = s - 1 | 0, e[m + 152 >> 2] = s >>> 0 >= N >>> 0 ? N : 0, m = nu(m, 0, 144), e[m + 76 >> 2] = -1, e[m + 36 >> 2] = 179, e[m + 80 >> 2] = -1, e[m + 44 >> 2] = m + 159, e[m + 84 >> 2] = m + 148;
                e: {
                  if ((s | 0) < 0) {
                    e[5732] = 61;
                    break e;
                  }
                  _[p | 0] = 0, p = 0, s = Jr - 208 | 0, Jr = s, e[s + 204 >> 2] = A, r = s + 160 | 0, nu(r, 0, 40), e[s + 200 >> 2] = e[s + 204 >> 2];
                  t: {
                    if ((Jl(0, u, s + 200 | 0, s + 80 | 0, r) | 0) < 0) {
                      r = -1;
                      break t;
                    }
                    A = e[m + 76 >> 2] >= 0, N = e[m >> 2], e[m >> 2] = N & -33;
                    r: {
                      i: {
                        n: {
                          if (!e[m + 48 >> 2]) {
                            e[m + 48 >> 2] = 80, e[m + 28 >> 2] = 0, e[m + 16 >> 2] = 0, e[m + 20 >> 2] = 0, p = e[m + 44 >> 2], e[m + 44 >> 2] = s;
                            break n;
                          }
                          if (e[m + 16 >> 2])
                            break i;
                        }
                        if (r = -1, Mc(m))
                          break r;
                      }
                      r = Jl(m, u, s + 200 | 0, s + 80 | 0, s + 160 | 0);
                    }
                    if (u = r, p && (xi[e[m + 36 >> 2]](m, 0, 0) | 0, e[m + 48 >> 2] = 0, e[m + 44 >> 2] = p, e[m + 28 >> 2] = 0, r = e[m + 20 >> 2], e[m + 16 >> 2] = 0, e[m + 20 >> 2] = 0, u = r ? u : -1), r = e[m >> 2], e[m >> 2] = r | N & 32, r = r & 32 ? -1 : u, !A)
                      break t;
                  }
                  Jr = s + 208 | 0;
                }
                return Jr = m + 160 | 0, r;
              }
              function tp(r, s, u, A, m, p, N) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0, m = m | 0, p = p | 0, N = N | 0;
                var W = 0, Te = 0;
                for (W = Jr - 416 | 0, Jr = W, A = W + 416 | 0, e[W + 12 >> 2] = A, u = Jr - 144 | 0, Jr = u, e[u + 28 >> 2] = u + 132, Te = u + 32 | 0, Wp(e[r + 8 >> 2], Te, u + 28 | 0, m, p, N), e[u + 16 >> 2] = 0, e[u + 20 >> 2] = 0, e[u + 12 >> 2] = Te, m = W + 16 | 0, N = e[W + 12 >> 2] - m >> 2, p = Jr - 16 | 0, Jr = p, r = Uu(p + 12 | 0, e[r + 8 >> 2]), N = mh(m, u + 12 | 0, N, u + 16 | 0), r = e[r >> 2], r && (e[6178] = (r | 0) == -1 ? 24816 : r), Jr = p + 16 | 0, (N | 0) == -1 && (Hc(2472), Oi()), e[W + 12 >> 2] = m + (N << 2), Jr = u + 144 | 0, u = Jr - 16 | 0, Jr = u, r = Jr - 32 | 0, Jr = r, p = Jr - 16 | 0, Jr = p, e[p + 12 >> 2] = e[W + 12 >> 2], e[r + 24 >> 2] = m, e[r + 28 >> 2] = e[p + 12 >> 2], Jr = p + 16 | 0, p = e[r + 24 >> 2], N = e[r + 28 >> 2], m = Jr - 16 | 0, Jr = m, e[m + 12 >> 2] = s; ; ) {
                  if ((p | 0) != (N | 0)) {
                    bl(m + 12 | 0, e[p >> 2]), p = p + 4 | 0;
                    continue;
                  }
                  break;
                }
                return e[r + 16 >> 2] = N, e[r + 20 >> 2] = e[m + 12 >> 2], Jr = m + 16 | 0, s = e[r + 16 >> 2], e[r + 12 >> 2] = e[r + 20 >> 2], e[u + 8 >> 2] = s, e[u + 12 >> 2] = e[r + 12 >> 2], Jr = r + 32 | 0, Jr = u + 16 | 0, Jr = A, e[u + 12 >> 2];
              }
              function Lf(r, s) {
                r = r | 0, s = s | 0;
                var u = 0, A = 0, m = 0, p = 0, N = 0, W = 0, Te = 0;
                m = Jr - 32 | 0, Jr = m, W = m + 32 | 0, u = W, A = m + 21 | 0, p = u - A | 0;
                e: {
                  if ((p | 0) <= 9 && (Te = p, p = Sn(32 - Fo(s | 1) | 0, 1233) >>> 12 | 0, N = 61, (Te | 0) < ((Ls[(p << 2) + 21616 >> 2] <= s >>> 0) + p | 0)))
                    break e;
                  t: {
                    if (s >>> 0 <= 999999) {
                      if (s >>> 0 <= 9999) {
                        if (s >>> 0 <= 99) {
                          if (s >>> 0 <= 9) {
                            _[A | 0] = s + 48, u = A + 1 | 0;
                            break t;
                          }
                          u = zc(A, s);
                          break t;
                        }
                        if (s >>> 0 <= 999) {
                          u = (s >>> 0) / 100 | 0, _[A | 0] = u + 48, u = zc(A + 1 | 0, Sn(u, -100) + s | 0);
                          break t;
                        }
                        u = Ws(A, s);
                        break t;
                      }
                      if (s >>> 0 <= 99999) {
                        u = (s >>> 0) / 1e4 | 0, _[A | 0] = u + 48, u = Ws(A + 1 | 0, Sn(u, -1e4) + s | 0);
                        break t;
                      }
                      u = Ks(A, s);
                      break t;
                    }
                    if (s >>> 0 <= 99999999) {
                      if (s >>> 0 <= 9999999) {
                        u = (s >>> 0) / 1e6 | 0, _[A | 0] = u + 48, u = Ks(A + 1 | 0, Sn(u, -1e6) + s | 0);
                        break t;
                      }
                      u = Js(A, s);
                      break t;
                    }
                    if (s >>> 0 <= 999999999) {
                      u = (s >>> 0) / 1e8 | 0, _[A | 0] = u + 48, u = Js(A + 1 | 0, Sn(u, -1e8) + s | 0);
                      break t;
                    }
                    u = (s >>> 0) / 1e8 | 0, u = Js(zc(A, u), Sn(u, -1e8) + s | 0);
                  }
                  N = 0;
                }
                e[m + 16 >> 2] = N, e[m + 12 >> 2] = u, pl(r, A, e[m + 12 >> 2]), Jr = W;
              }
              function Ad(r, s, u) {
                var A = 0, m = 0, p = 0, N = 0;
                if (A = r + 4 | 0, m = (A + s | 0) - 1 & 0 - s, s = e[r >> 2], m + u >>> 0 <= (s + r | 0) - 4 >>> 0) {
                  p = e[r + 4 >> 2], e[p + 8 >> 2] = e[r + 8 >> 2], e[e[r + 8 >> 2] + 4 >> 2] = p, (A | 0) != (m | 0) && (m = m - A | 0, p = r - (e[r - 4 >> 2] & -2) | 0, A = m + e[p >> 2] | 0, e[p >> 2] = A, e[(p + (A & -4) | 0) - 4 >> 2] = A, r = r + m | 0, s = s - m | 0, e[r >> 2] = s);
                  e: {
                    if (u + 24 >>> 0 <= s >>> 0) {
                      A = (r + u | 0) + 8 | 0, s = (s - u | 0) - 8 | 0, e[A >> 2] = s, e[(A + (s & -4) | 0) - 4 >> 2] = s | 1, m = e[A >> 2] - 8 | 0;
                      t: {
                        if (m >>> 0 <= 127) {
                          s = (m >>> 3 | 0) - 1 | 0;
                          break t;
                        }
                        if (p = Fo(m), s = ((m >>> 29 - p ^ 4) - (p << 2) | 0) + 110 | 0, m >>> 0 <= 4095)
                          break t;
                        s = ((m >>> 30 - p ^ 2) - (p << 1) | 0) + 71 | 0, s = s >>> 0 >= 63 ? 63 : s;
                      }
                      m = s << 4, e[A + 4 >> 2] = m + 22944, m = m + 22952 | 0, e[A + 8 >> 2] = e[m >> 2], e[m >> 2] = A, e[e[A + 8 >> 2] + 4 >> 2] = A, m = e[5994], p = e[5995], A = s & 31, (s & 63) >>> 0 >= 32 ? (s = 1 << A, A = 0) : (N = 1 << A, s = N - 1 & 1 >>> 32 - A, A = N), e[5994] = A | m, e[5995] = s | p, s = u + 8 | 0, e[r >> 2] = s, e[((s & -4) + r | 0) - 4 >> 2] = s;
                      break e;
                    }
                    e[(r + s | 0) - 4 >> 2] = s;
                  }
                  r = r + 4 | 0;
                } else
                  r = 0;
                return r;
              }
              function rp(r, s) {
                r = r | 0, s = s | 0;
                var u = 0, A = 0, m = 0, p = 0, N = 0;
                e: {
                  t: {
                    r: {
                      if (A = e[r >> 2], p = (e[r + 4 >> 2] - A | 0) / 12 | 0, u = p + 1 | 0, u >>> 0 < 357913942) {
                        if (A = (e[r + 8 >> 2] - A | 0) / 12 | 0, N = A << 1, A = A >>> 0 >= 178956970 ? 357913941 : u >>> 0 < N >>> 0 ? N : u, A) {
                          if (A >>> 0 >= 357913942)
                            break r;
                          m = Qs(Sn(A, 12));
                        }
                        if (u = Sn(p, 12) + m | 0, p = e[s + 4 >> 2], e[u >> 2] = e[s >> 2], e[u + 4 >> 2] = p, e[u + 8 >> 2] = e[s + 8 >> 2], e[s >> 2] = 0, e[s + 4 >> 2] = 0, e[s + 8 >> 2] = 0, m = Sn(A, 12) + m | 0, A = u + 12 | 0, s = e[r + 4 >> 2], p = e[r >> 2], (s | 0) == (p | 0))
                          break t;
                        for (; s = s - 12 | 0, N = e[s + 4 >> 2], u = u - 12 | 0, e[u >> 2] = e[s >> 2], e[u + 4 >> 2] = N, e[u + 8 >> 2] = e[s + 8 >> 2], e[s >> 2] = 0, e[s + 4 >> 2] = 0, e[s + 8 >> 2] = 0, (s | 0) != (p | 0); )
                          ;
                        if (e[r + 8 >> 2] = m, m = e[r + 4 >> 2], e[r + 4 >> 2] = A, s = e[r >> 2], e[r >> 2] = u, (s | 0) == (m | 0))
                          break e;
                        for (; r = m - 12 | 0, _[m - 1 | 0] < 0 && Br(e[r >> 2]), m = r, (r | 0) != (s | 0); )
                          ;
                        break e;
                      }
                      Jo(), Oi();
                    }
                    hu(), Oi();
                  }
                  e[r + 8 >> 2] = m, e[r + 4 >> 2] = A, e[r >> 2] = u;
                }
                s && Br(s);
              }
              function Sh(r, s, u, A) {
                var m = 0, p = 0, N = 0, W = 0, Te = 0, Xe = 0, fr = 0, ar = 0, vr = 0, _r = 0, hi = 0;
                Te = Jr - 32 | 0, Jr = Te;
                e: {
                  t: {
                    r: {
                      if ((s | 0) != (u | 0)) {
                        if (fr = e[5732], e[5732] = 0, N = Jr - 16 | 0, Jr = N, ko(), p = Jr - 16 | 0, Jr = p, m = Jr - 16 | 0, Jr = m, qd(m, s, Te + 28 | 0, 2), W = e[m >> 2], Xe = e[m + 4 >> 2], s = p, p = e[m + 12 >> 2], e[s + 8 >> 2] = e[m + 8 >> 2], e[s + 12 >> 2] = p, e[s >> 2] = W, e[s + 4 >> 2] = Xe, Jr = m + 16 | 0, p = e[s >> 2], W = e[s + 4 >> 2], m = N, N = e[s + 12 >> 2], e[m + 8 >> 2] = e[s + 8 >> 2], e[m + 12 >> 2] = N, e[m >> 2] = p, e[m + 4 >> 2] = W, Jr = s + 16 | 0, N = e[m >> 2], p = e[m + 4 >> 2], W = e[m + 12 >> 2], s = Te, e[s + 16 >> 2] = e[m + 8 >> 2], e[s + 20 >> 2] = W, e[s + 8 >> 2] = N, e[s + 12 >> 2] = p, Jr = m + 16 | 0, m = e[s + 16 >> 2], p = e[s + 20 >> 2], N = e[s + 8 >> 2], W = e[s + 12 >> 2], Xe = e[5732], !Xe)
                          break r;
                        if (e[s + 28 >> 2] != (u | 0))
                          break t;
                        if (ar = N, vr = W, _r = m, hi = p, (Xe | 0) != 68)
                          break e;
                        break t;
                      }
                      e[A >> 2] = 4;
                      break e;
                    }
                    if (e[5732] = fr, e[Te + 28 >> 2] == (u | 0))
                      break e;
                  }
                  e[A >> 2] = 4, N = ar, W = vr, m = _r, p = hi;
                }
                e[r >> 2] = N, e[r + 4 >> 2] = W, e[r + 8 >> 2] = m, e[r + 12 >> 2] = p, Jr = Te + 32 | 0;
              }
              function M4(r, s, u, A) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0;
                var m = 0, p = 0, N = 0, W = 0, Te = 0, Xe = 0;
                if (p = e[r + 4 >> 2], m = e[r + 8 >> 2], p >>> 0 < m >>> 0) {
                  e[p >> 2] = s, e[p + 8 >> 2] = u, e[p + 12 >> 2] = u >> 31, s = e[A + 4 >> 2], e[p + 16 >> 2] = e[A >> 2], e[p + 20 >> 2] = s, e[r + 4 >> 2] = p + 24;
                  return;
                }
                e: {
                  if (Te = e[r >> 2], N = (p - Te | 0) / 24 | 0, W = N + 1 | 0, W >>> 0 < 178956971) {
                    if (Xe = Sn(N, 24), m = (m - Te | 0) / 24 | 0, N = m << 1, N = m >>> 0 >= 89478485 ? 178956970 : N >>> 0 > W >>> 0 ? N : W, N) {
                      if (N >>> 0 >= 178956971)
                        break e;
                      W = Qs(Sn(N, 24));
                    } else
                      W = 0;
                    if (m = Xe + W | 0, e[m + 8 >> 2] = u, e[m + 12 >> 2] = u >> 31, e[m >> 2] = s, s = e[A + 4 >> 2], e[m + 16 >> 2] = e[A >> 2], e[m + 20 >> 2] = s, s = m + 24 | 0, (p | 0) != (Te | 0)) {
                      for (; p = p - 24 | 0, A = e[p + 4 >> 2], m = m - 24 | 0, e[m >> 2] = e[p >> 2], e[m + 4 >> 2] = A, u = e[p + 20 >> 2], e[m + 16 >> 2] = e[p + 16 >> 2], e[m + 20 >> 2] = u, u = e[p + 12 >> 2], e[m + 8 >> 2] = e[p + 8 >> 2], e[m + 12 >> 2] = u, (p | 0) != (Te | 0); )
                        ;
                      p = e[r >> 2];
                    }
                    e[r + 8 >> 2] = W + Sn(N, 24), e[r + 4 >> 2] = s, e[r >> 2] = m, p && Br(p);
                    return;
                  }
                  Jo(), Oi();
                }
                hu(), Oi();
              }
              function F4(r, s, u, A, m) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0, m = m | 0;
                var p = 0;
                p = Jr - 32 | 0, Jr = p, e[p + 28 >> 2] = s;
                e: {
                  if (!(_[u + 4 | 0] & 1)) {
                    u = xi[e[e[r >> 2] + 24 >> 2]](r, s, u, A, m) | 0;
                    break e;
                  }
                  A = p + 16 | 0, r = e[u + 28 >> 2], e[A >> 2] = r, e[r + 4 >> 2] = e[r + 4 >> 2] + 1, e[5996] = 0, r = Mi(198, e[p + 16 >> 2]) | 0, s = e[5996], e[5996] = 0;
                  t: {
                    if ((s | 0) != 1) {
                      s = e[A >> 2], u = e[s + 4 >> 2] - 1 | 0, e[s + 4 >> 2] = u, (u | 0) == -1 && xi[e[e[s >> 2] + 8 >> 2]](s);
                      r: {
                        if (m) {
                          xi[e[e[r >> 2] + 24 >> 2]](A, r);
                          break r;
                        }
                        xi[e[e[r >> 2] + 28 >> 2]](p + 16 | 0, r);
                      }
                      for (e[p + 12 >> 2] = Ga(p + 16 | 0); ; ) {
                        if (r = p + 16 | 0, u = Sa(r), s = e[p + 12 >> 2], (u | 0) == (s | 0)) {
                          u = e[p + 28 >> 2], Qn(r);
                          break e;
                        }
                        if (r = e[s >> 2], e[5996] = 0, pi(214, p + 28 | 0, r | 0) | 0, r = e[5996], e[5996] = 0, (r | 0) != 1) {
                          e[p + 12 >> 2] = e[p + 12 >> 2] + 4;
                          continue;
                        }
                        break;
                      }
                      u = Hr() | 0, Qn(p + 16 | 0);
                      break t;
                    }
                    u = Hr() | 0, r = e[p + 16 >> 2], s = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = s, (s | 0) == -1 && xi[e[e[r >> 2] + 8 >> 2]](r);
                  }
                  Jn(u | 0), Oi();
                }
                return Jr = p + 32 | 0, u | 0;
              }
              function L4(r, s, u, A, m) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0, m = m | 0;
                var p = 0;
                p = Jr - 32 | 0, Jr = p, e[p + 28 >> 2] = s;
                e: {
                  if (!(_[u + 4 | 0] & 1)) {
                    u = xi[e[e[r >> 2] + 24 >> 2]](r, s, u, A, m) | 0;
                    break e;
                  }
                  A = p + 16 | 0, r = e[u + 28 >> 2], e[A >> 2] = r, e[r + 4 >> 2] = e[r + 4 >> 2] + 1, e[5996] = 0, r = Mi(180, e[p + 16 >> 2]) | 0, s = e[5996], e[5996] = 0;
                  t: {
                    if ((s | 0) != 1) {
                      s = e[A >> 2], u = e[s + 4 >> 2] - 1 | 0, e[s + 4 >> 2] = u, (u | 0) == -1 && xi[e[e[s >> 2] + 8 >> 2]](s);
                      r: {
                        if (m) {
                          xi[e[e[r >> 2] + 24 >> 2]](A, r);
                          break r;
                        }
                        xi[e[e[r >> 2] + 28 >> 2]](p + 16 | 0, r);
                      }
                      for (e[p + 12 >> 2] = Ga(p + 16 | 0); ; ) {
                        if (r = p + 16 | 0, u = Bu(r), s = e[p + 12 >> 2], (u | 0) == (s | 0)) {
                          u = e[p + 28 >> 2], Qn(r);
                          break e;
                        }
                        if (r = _[s | 0], e[5996] = 0, pi(210, p + 28 | 0, r | 0) | 0, r = e[5996], e[5996] = 0, (r | 0) != 1) {
                          e[p + 12 >> 2] = e[p + 12 >> 2] + 1;
                          continue;
                        }
                        break;
                      }
                      u = Hr() | 0, Qn(p + 16 | 0);
                      break t;
                    }
                    u = Hr() | 0, r = e[p + 16 >> 2], s = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = s, (s | 0) == -1 && xi[e[e[r >> 2] + 8 >> 2]](r);
                  }
                  Jn(u | 0), Oi();
                }
                return Jr = p + 32 | 0, u | 0;
              }
              function H4(r, s, u, A) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0;
                var m = 0, p = 0, N = 0, W = 0;
                p = Jr - 32 | 0, Jr = p, e[p + 24 >> 2] = A, _[p + 20 | 0] = 0, e[p + 8 >> 2] = r, e[p + 16 >> 2] = p + 28, e[p + 12 >> 2] = p + 24;
                e: {
                  t: {
                    r: {
                      if ((s | 0) != (u | 0))
                        for (; ; ) {
                          if (e[A + 8 >> 2] = 0, e[A >> 2] = 0, e[A + 4 >> 2] = 0, r = e[s + 4 >> 2], m = e[s >> 2], (r | 0) != (m | 0)) {
                            if (m = r - m | 0, (m | 0) < 0) {
                              if (e[5996] = 0, e[p + 28 >> 2] = A, Nn(84), r = e[5996], e[5996] = 0, (r | 0) == 1)
                                break r;
                              Oi();
                            }
                            if (e[5996] = 0, r = Mi(3, m | 0) | 0, N = e[5996], e[5996] = 0, (N | 0) == 1)
                              break t;
                            if (e[A + 4 >> 2] = r, e[A >> 2] = r, e[A + 8 >> 2] = (m & -8) + r, m = e[s >> 2], N = e[s + 4 >> 2], (m | 0) != (N | 0))
                              for (; W = e[m + 4 >> 2], e[r >> 2] = e[m >> 2], e[r + 4 >> 2] = W, r = r + 8 | 0, m = m + 8 | 0, (N | 0) != (m | 0); )
                                ;
                            e[A + 4 >> 2] = r;
                          }
                          if (A = A + 12 | 0, s = s + 12 | 0, (u | 0) == (s | 0))
                            break;
                        }
                      return Jr = p + 32 | 0, A | 0;
                    }
                    if (r = Hr() | 0, s = e[A >> 2], !s)
                      break e;
                    e[A + 4 >> 2] = s, Br(s);
                    break e;
                  }
                  r = Hr() | 0, e[p + 28 >> 2] = A;
                }
                Qd(p + 8 | 0), Jn(r | 0), Oi();
              }
              function K4(r, s, u, A) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0;
                var m = 0, p = 0, N = 0, W = 0, Te = 0, Xe = 0;
                if (p = e[r + 4 >> 2], m = e[r + 8 >> 2], p >>> 0 < m >>> 0) {
                  e[p >> 2] = s, e[p + 16 >> 2] = A, e[p + 20 >> 2] = A >> 31, e[p + 8 >> 2] = u, e[p + 12 >> 2] = u >> 31, e[r + 4 >> 2] = p + 24;
                  return;
                }
                e: {
                  if (Te = e[r >> 2], N = (p - Te | 0) / 24 | 0, W = N + 1 | 0, W >>> 0 < 178956971) {
                    if (Xe = Sn(N, 24), m = (m - Te | 0) / 24 | 0, N = m << 1, N = m >>> 0 >= 89478485 ? 178956970 : N >>> 0 > W >>> 0 ? N : W, N) {
                      if (N >>> 0 >= 178956971)
                        break e;
                      W = Qs(Sn(N, 24));
                    } else
                      W = 0;
                    if (m = Xe + W | 0, e[m + 16 >> 2] = A, e[m + 20 >> 2] = A >> 31, e[m + 8 >> 2] = u, e[m + 12 >> 2] = u >> 31, e[m >> 2] = s, s = m + 24 | 0, (p | 0) != (Te | 0)) {
                      for (; p = p - 24 | 0, A = e[p + 4 >> 2], m = m - 24 | 0, e[m >> 2] = e[p >> 2], e[m + 4 >> 2] = A, u = e[p + 20 >> 2], e[m + 16 >> 2] = e[p + 16 >> 2], e[m + 20 >> 2] = u, u = e[p + 12 >> 2], e[m + 8 >> 2] = e[p + 8 >> 2], e[m + 12 >> 2] = u, (p | 0) != (Te | 0); )
                        ;
                      p = e[r >> 2];
                    }
                    e[r + 8 >> 2] = W + Sn(N, 24), e[r + 4 >> 2] = s, e[r >> 2] = m, p && Br(p);
                    return;
                  }
                  Jo(), Oi();
                }
                hu(), Oi();
              }
              function kc(r, s, u, A) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0;
                var m = 0, p = 0, N = 0, W = 0, Te = 0, Xe = 0;
                N = A, A = Fa(A), Te = Jr - 16 | 0, Jr = Te, e[Te + 12 >> 2] = u, u = r;
                e: {
                  t: {
                    if (m = e[r + 4 >> 2], r = me[r + 11 | 0], W = (r & 128) >>> 7 | 0 ? m : r & 127, W >>> 0 >= s >>> 0) {
                      if (m = W - s | 0, e[Te + 8 >> 2] = m, r = Te + 8 | 0, p = Te + 12 | 0, r = e[(Ls[r >> 2] < Ls[p >> 2] ? r : p) >> 2], p = (me[u + 11 | 0] & 128) >>> 7 | 0 ? (e[u + 8 >> 2] & 2147483647) - 1 | 0 : 10, r + (p - W | 0) >>> 0 >= A >>> 0) {
                        p = (me[u + 11 | 0] & 128) >>> 7 | 0 ? e[u >> 2] : u;
                        r: {
                          if ((r | 0) == (A | 0)) {
                            r = A;
                            break r;
                          }
                          if ((r | 0) == (m | 0)) {
                            r = m;
                            break r;
                          }
                          if (Xe = m - r | 0, m = s + p | 0, r >>> 0 > A >>> 0)
                            break t;
                          i: {
                            if (p + W >>> 0 <= N >>> 0 | m >>> 0 >= N >>> 0)
                              break i;
                            if (r + m >>> 0 <= N >>> 0) {
                              N = (A - r | 0) + N | 0;
                              break i;
                            }
                            fc(m, N, r), m = A - r | 0, N = A + N | 0, s = r + s | 0, r = 0, A = m;
                          }
                          m = s + p | 0, fc(m + A | 0, r + m | 0, Xe);
                        }
                        fc(s + p | 0, N, A), nc(u, p, (A + W | 0) - r | 0);
                        break e;
                      }
                      Gf(u, p, A + W - (r + p) | 0, W, s, r, A, N);
                      break e;
                    }
                    gf(), Oi();
                  }
                  s = fc(m, N, A), fc(s + A | 0, r + s | 0, Xe), nc(u, p, (A + W | 0) - r | 0);
                }
                Jr = Te + 16 | 0;
              }
              function V4(r, s, u) {
                r = r | 0, s = s | 0, u = u | 0;
                var A = 0, m = 0, p = 0, N = 0, W = 0, Te = 0;
                W = Jr - 16 | 0, Jr = W, A = me[r + 11 | 0], m = A & 127, A = (A & 128) >>> 7 | 0, m = A ? e[r + 4 >> 2] : m, A = A ? (e[r + 8 >> 2] & 2147483647) - 1 | 0 : 1, p = u - s >> 2;
                e: {
                  if (!p)
                    break e;
                  t: {
                    if (N = me[r + 11 | 0], Te = (N & 128) >>> 7 | 0 ? e[r >> 2] : r, Te >>> 0 <= s >>> 0 ? N = (((N & 128) >>> 7 | 0 ? e[r + 4 >> 2] : N & 127) << 2) + Te >>> 0 >= s >>> 0 : N = 0, !N)
                      for (A - m >>> 0 < p >>> 0 && Hh(r, A, (m - A | 0) + p | 0, m, m), A = (m << 2) + ((me[r + 11 | 0] & 128) >>> 7 | 0 ? e[r >> 2] : r) | 0; ; ) {
                        if ((s | 0) == (u | 0))
                          break t;
                        e[A >> 2] = e[s >> 2], s = s + 4 | 0, A = A + 4 | 0;
                      }
                    if (s = zh(W + 4 | 0, s, u), u = me[s + 11 | 0], p = (u & 128) >>> 7 | 0, A = p ? e[s >> 2] : s, m = e[s + 4 >> 2], e[5996] = 0, xn(235, r | 0, A | 0, (p ? m : u & 127) | 0) | 0, u = e[5996], e[5996] = 0, (u | 0) != 1) {
                      Qn(s);
                      break e;
                    }
                    r = Hr() | 0, Qn(s), Jn(r | 0), Oi();
                  }
                  e[A >> 2] = 0, s = m + p | 0;
                  t: {
                    if ((me[r + 11 | 0] & 128) >>> 7 | 0) {
                      e[r + 4 >> 2] = s;
                      break t;
                    }
                    _[r + 11 | 0] = s;
                  }
                }
                return Jr = W + 16 | 0, r | 0;
              }
              function Co(r, s) {
                r = r | 0, s = s | 0;
                var u = 0, A = 0, m = 0, p = 0;
                if (e[r + 4 >> 2] = s, _[r | 0] = 0, s = e[e[s >> 2] - 12 >> 2] + s | 0, !e[s + 16 >> 2]) {
                  if (s = e[s + 72 >> 2], s)
                    e: {
                      m = Jr - 16 | 0, Jr = m;
                      t: {
                        r: {
                          if (!e[(s + e[e[s >> 2] - 12 >> 2] | 0) + 24 >> 2])
                            break r;
                          e[5996] = 0, A = pi(134, m + 8 | 0, s | 0) | 0, u = e[5996], e[5996] = 0;
                          i: {
                            if ((u | 0) != 1) {
                              n: {
                                if (!me[A | 0] || (u = e[(s + e[e[s >> 2] - 12 >> 2] | 0) + 24 >> 2], e[5996] = 0, u = Mi(169, u | 0) | 0, p = e[5996], e[5996] = 0, (p | 0) != 1 && ((u | 0) != -1 || (u = e[e[s >> 2] - 12 >> 2], e[5996] = 0, ji(138, s + u | 0, 1), u = e[5996], e[5996] = 0, (u | 0) != 1))))
                                  break n;
                                u = Os(0) | 0, gl(A);
                                break i;
                              }
                              gl(A);
                              break r;
                            }
                            u = Os(0) | 0;
                          }
                          if (Cu(u | 0) | 0, A = e[e[s >> 2] - 12 >> 2], e[5996] = 0, qo(139, s + A | 0), s = e[5996], e[5996] = 0, (s | 0) == 1)
                            break t;
                          ef();
                        }
                        Jr = m + 16 | 0;
                        break e;
                      }
                      r = Hr() | 0, e[5996] = 0, Nn(110), s = e[5996], e[5996] = 0, (s | 0) != 1 && (Jn(r | 0), Oi()), Os(0) | 0, Na(), Oi();
                    }
                  _[r | 0] = 1;
                }
                return r | 0;
              }
              function ip(r, s, u) {
                r = r | 0, s = s | 0, u = u | 0;
                var A = 0, m = 0, p = 0;
                A = Jr - 32 | 0, Jr = A;
                e: {
                  t: {
                    r: {
                      if ((u | 0) <= 0)
                        break r;
                      for (; ; ) {
                        if (me[s + m | 0] != 41) {
                          if (m = m + 1 | 0, (u | 0) != (m | 0))
                            continue;
                          break r;
                        }
                        break;
                      }
                      if (m)
                        break t;
                    }
                    _[r + 16 | 0] = 0, _[r | 0] = 0;
                    break e;
                  }
                  t: {
                    r: {
                      if (m >>> 0 <= 17) {
                        if (m >>> 0 > 10)
                          break r;
                        _[A + 31 | 0] = m, u = A + 20 | 0;
                        break t;
                      }
                      _[r + 16 | 0] = 0, _[r | 0] = 0;
                      break e;
                    }
                    p = (m | 15) + 1 | 0, u = Qs(p), e[A + 28 >> 2] = p | -2147483648, e[A + 20 >> 2] = u, e[A + 24 >> 2] = m;
                  }
                  _[so(u, s, m) + m | 0] = 0, u = e[A + 20 >> 2], s = me[A + 27 | 0] | me[A + 28 | 0] << 8 | (me[A + 29 | 0] << 16 | me[A + 30 | 0] << 24), _[A + 15 | 0] = s, _[A + 16 | 0] = s >>> 8, _[A + 17 | 0] = s >>> 16, _[A + 18 | 0] = s >>> 24, e[A + 12 >> 2] = e[A + 24 >> 2], p = me[A + 31 | 0], e[r >> 2] = u, e[r + 4 >> 2] = e[A + 12 >> 2], s = me[A + 15 | 0] | me[A + 16 | 0] << 8 | (me[A + 17 | 0] << 16 | me[A + 18 | 0] << 24), _[r + 7 | 0] = s, _[r + 8 | 0] = s >>> 8, _[r + 9 | 0] = s >>> 16, _[r + 10 | 0] = s >>> 24, _[r + 16 | 0] = 1, e[r + 12 >> 2] = m, _[r + 11 | 0] = p;
                }
                Jr = A + 32 | 0;
              }
              function Hf(r, s, u, A, m, p) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0, m = m | 0, p = p | 0;
                var N = 0, W = 0, Te = 0, Xe = 0;
                N = Jr - 16 | 0, Jr = N;
                e: {
                  t: {
                    r: {
                      if (!r || (Te = e[m + 12 >> 2], Xe = u - s | 0, (Xe | 0) > 0 && (xi[e[e[r >> 2] + 48 >> 2]](r, s, Xe) | 0) != (Xe | 0)))
                        break r;
                      if (s = A - s | 0, s = (s | 0) < (Te | 0) ? Te - s | 0 : 0, (s | 0) > 0) {
                        if (s >>> 0 >= 2147483632)
                          break e;
                        i: {
                          if (s >>> 0 >= 11) {
                            Te = (s | 15) + 1 | 0, W = Qs(Te), e[N + 12 >> 2] = Te | -2147483648, e[N + 4 >> 2] = W, e[N + 8 >> 2] = s;
                            break i;
                          }
                          _[N + 15 | 0] = s, W = N + 4 | 0;
                        }
                        if (_[nu(W, p, s) + s | 0] = 0, p = e[e[r >> 2] + 48 >> 2], e[5996] = 0, p = xn(p | 0, r | 0, (_[N + 15 | 0] < 0 ? e[N + 4 >> 2] : N + 4 | 0) | 0, s | 0) | 0, W = e[5996], e[5996] = 0, (W | 0) == 1)
                          break t;
                        if (_[N + 15 | 0] < 0 && Br(e[N + 4 >> 2]), W = 0, (s | 0) != (p | 0))
                          break r;
                      }
                      if (s = A - u | 0, (s | 0) > 0 && (xi[e[e[r >> 2] + 48 >> 2]](r, u, s) | 0) != (s | 0))
                        break r;
                      e[m + 12 >> 2] = 0, W = r;
                    }
                    return Jr = N + 16 | 0, W | 0;
                  }
                  r = Hr() | 0, _[N + 15 | 0] < 0 && Br(e[N + 4 >> 2]), Jn(r | 0), Oi();
                }
                Ra(), Oi();
              }
              function sf(r, s, u) {
                r = r | 0, s = s | 0, u = u | 0;
                var A = 0, m = 0, p = 0, N = 0, W = 0, Te = 0;
                W = Jr - 16 | 0, Jr = W, A = me[r + 11 | 0], m = A & 127, A = (A & 128) >>> 7 | 0, m = A ? e[r + 4 >> 2] : m, A = A ? (e[r + 8 >> 2] & 2147483647) - 1 | 0 : 10, p = u - s | 0;
                e: {
                  if (!p)
                    break e;
                  t: {
                    if (N = me[r + 11 | 0], Te = (N & 128) >>> 7 | 0 ? e[r >> 2] : r, Te >>> 0 <= s >>> 0 ? N = ((N & 128) >>> 7 | 0 ? e[r + 4 >> 2] : N & 127) + Te >>> 0 >= s >>> 0 : N = 0, !N)
                      for (A - m >>> 0 < p >>> 0 && Al(r, A, (m - A | 0) + p | 0, m, m), A = m + ((me[r + 11 | 0] & 128) >>> 7 | 0 ? e[r >> 2] : r) | 0; ; ) {
                        if ((s | 0) == (u | 0))
                          break t;
                        _[A | 0] = me[s | 0], s = s + 1 | 0, A = A + 1 | 0;
                      }
                    if (s = pl(W + 4 | 0, s, u), u = me[s + 11 | 0], p = (u & 128) >>> 7 | 0, A = p ? e[s >> 2] : s, m = e[s + 4 >> 2], e[5996] = 0, xn(100, r | 0, A | 0, (p ? m : u & 127) | 0) | 0, u = e[5996], e[5996] = 0, (u | 0) != 1) {
                      Qn(s);
                      break e;
                    }
                    r = Hr() | 0, Qn(s), Jn(r | 0), Oi();
                  }
                  _[A | 0] = 0, s = m + p | 0;
                  t: {
                    if ((me[r + 11 | 0] & 128) >>> 7 | 0) {
                      e[r + 4 >> 2] = s;
                      break t;
                    }
                    _[r + 11 | 0] = s;
                  }
                }
                return Jr = W + 16 | 0, r | 0;
              }
              function Ys(r, s, u) {
                var A = 0, m = 0;
                e: {
                  if ((r | 0) == (s | 0))
                    break e;
                  if (m = r + u | 0, s - m >>> 0 <= 0 - (u << 1) >>> 0)
                    return so(r, s, u);
                  A = (r ^ s) & 3;
                  t: {
                    r: {
                      if (r >>> 0 < s >>> 0) {
                        if (A) {
                          A = r;
                          break t;
                        }
                        if (!(r & 3)) {
                          A = r;
                          break r;
                        }
                        for (A = r; ; ) {
                          if (!u)
                            break e;
                          if (_[A | 0] = me[s | 0], s = s + 1 | 0, u = u - 1 | 0, A = A + 1 | 0, !(A & 3))
                            break;
                        }
                        break r;
                      }
                      i: {
                        if (A)
                          break i;
                        if (m & 3)
                          for (; ; ) {
                            if (!u)
                              break e;
                            if (u = u - 1 | 0, A = u + r | 0, _[A | 0] = me[s + u | 0], !(A & 3))
                              break;
                          }
                        if (u >>> 0 <= 3)
                          break i;
                        for (; u = u - 4 | 0, e[u + r >> 2] = e[s + u >> 2], u >>> 0 > 3; )
                          ;
                      }
                      if (!u)
                        break e;
                      for (; u = u - 1 | 0, _[u + r | 0] = me[s + u | 0], !!u; )
                        ;
                      break e;
                    }
                    if (u >>> 0 <= 3)
                      break t;
                    for (; e[A >> 2] = e[s >> 2], s = s + 4 | 0, A = A + 4 | 0, u = u - 4 | 0, u >>> 0 > 3; )
                      ;
                  }
                  if (!u)
                    break e;
                  for (; _[A | 0] = me[s | 0], A = A + 1 | 0, s = s + 1 | 0, u = u - 1 | 0, !!u; )
                    ;
                }
                return r;
              }
              function Sc(r, s, u) {
                e:
                  switch (s - 9 | 0) {
                    case 0:
                      s = e[u >> 2], e[u >> 2] = s + 4, e[r >> 2] = e[s >> 2];
                      return;
                    case 6:
                      s = e[u >> 2], e[u >> 2] = s + 4, s = Zs[s >> 1], e[r >> 2] = s, e[r + 4 >> 2] = s >> 31;
                      return;
                    case 7:
                      s = e[u >> 2], e[u >> 2] = s + 4, e[r >> 2] = Ia[s >> 1], e[r + 4 >> 2] = 0;
                      return;
                    case 8:
                      s = e[u >> 2], e[u >> 2] = s + 4, s = _[s | 0], e[r >> 2] = s, e[r + 4 >> 2] = s >> 31;
                      return;
                    case 9:
                      s = e[u >> 2], e[u >> 2] = s + 4, e[r >> 2] = me[s | 0], e[r + 4 >> 2] = 0;
                      return;
                    case 16:
                      s = e[u >> 2] + 7 & -8, e[u >> 2] = s + 8, jn[r >> 3] = jn[s >> 3];
                      return;
                    case 17:
                      E1(r, u);
                    default:
                      return;
                    case 1:
                    case 4:
                    case 14:
                      s = e[u >> 2], e[u >> 2] = s + 4, s = e[s >> 2], e[r >> 2] = s, e[r + 4 >> 2] = s >> 31;
                      return;
                    case 2:
                    case 5:
                    case 11:
                    case 15:
                      s = e[u >> 2], e[u >> 2] = s + 4, e[r >> 2] = e[s >> 2], e[r + 4 >> 2] = 0;
                      return;
                    case 3:
                    case 10:
                    case 12:
                    case 13:
                      break e;
                  }
                s = e[u >> 2] + 7 & -8, e[u >> 2] = s + 8, u = e[s + 4 >> 2], e[r >> 2] = e[s >> 2], e[r + 4 >> 2] = u;
              }
              function gd(r, s, u, A, m) {
                var p = 0, N = 0;
                p = Jr - 16 | 0, Jr = p, e[p + 12 >> 2] = s, e[s + 4 >> 2] = e[s + 4 >> 2] + 1, e[5996] = 0, s = Mi(197, e[p + 12 >> 2]) | 0, N = e[5996], e[5996] = 0;
                e: {
                  if ((N | 0) == 1 || (e[5996] = 0, Vs(208, s | 0, 12416, 12448, u | 0), s = e[5996], e[5996] = 0, (s | 0) == 1) || (e[5996] = 0, s = Mi(198, e[p + 12 >> 2]) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1) || (e[5996] = 0, u = Mi(209, s | 0) | 0, N = e[5996], e[5996] = 0, (N | 0) == 1) || (e[A >> 2] = u, e[5996] = 0, u = Mi(206, s | 0) | 0, A = e[5996], e[5996] = 0, (A | 0) == 1) || (e[m >> 2] = u, e[5996] = 0, ji(207, r | 0, s | 0), r = e[5996], e[5996] = 0, (r | 0) == 1))
                    break e;
                  r = e[p + 12 >> 2], s = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = s, (s | 0) == -1 && xi[e[e[r >> 2] + 8 >> 2]](r), Jr = p + 16 | 0;
                  return;
                }
                u = Hr() | 0, r = e[p + 12 >> 2], s = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = s, (s | 0) == -1 && xi[e[e[r >> 2] + 8 >> 2]](r), Jn(u | 0), Oi();
              }
              function pd(r, s, u, A, m) {
                var p = 0, N = 0;
                p = Jr - 16 | 0, Jr = p, e[p + 12 >> 2] = s, e[s + 4 >> 2] = e[s + 4 >> 2] + 1, e[5996] = 0, s = Mi(170, e[p + 12 >> 2]) | 0, N = e[5996], e[5996] = 0;
                e: {
                  if ((N | 0) == 1 || (e[5996] = 0, Vs(195, s | 0, 12416, 12448, u | 0), s = e[5996], e[5996] = 0, (s | 0) == 1) || (e[5996] = 0, s = Mi(180, e[p + 12 >> 2]) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1) || (e[5996] = 0, u = Mi(196, s | 0) | 0, N = e[5996], e[5996] = 0, (N | 0) == 1) || (_[A | 0] = u, e[5996] = 0, u = Mi(193, s | 0) | 0, A = e[5996], e[5996] = 0, (A | 0) == 1) || (_[m | 0] = u, e[5996] = 0, ji(194, r | 0, s | 0), r = e[5996], e[5996] = 0, (r | 0) == 1))
                    break e;
                  r = e[p + 12 >> 2], s = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = s, (s | 0) == -1 && xi[e[e[r >> 2] + 8 >> 2]](r), Jr = p + 16 | 0;
                  return;
                }
                u = Hr() | 0, r = e[p + 12 >> 2], s = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = s, (s | 0) == -1 && xi[e[e[r >> 2] + 8 >> 2]](r), Jn(u | 0), Oi();
              }
              function Th(r, s, u, A, m, p) {
                var N = 0;
                N = Jr - 80 | 0, Jr = N;
                e: {
                  if ((p | 0) >= 16384) {
                    if (Qo(N + 32 | 0, s, u, A, m, 0, 0, 0, 2147352576), A = e[N + 40 >> 2], m = e[N + 44 >> 2], s = e[N + 32 >> 2], u = e[N + 36 >> 2], p >>> 0 < 32767) {
                      p = p - 16383 | 0;
                      break e;
                    }
                    Qo(N + 16 | 0, s, u, A, m, 0, 0, 0, 2147352576), p = ((p | 0) >= 49149 ? 49149 : p) - 32766 | 0, A = e[N + 24 >> 2], m = e[N + 28 >> 2], s = e[N + 16 >> 2], u = e[N + 20 >> 2];
                    break e;
                  }
                  if ((p | 0) > -16383)
                    break e;
                  if (Qo(N - -64 | 0, s, u, A, m, 0, 0, 0, 7471104), A = e[N + 72 >> 2], m = e[N + 76 >> 2], s = e[N + 64 >> 2], u = e[N + 68 >> 2], p >>> 0 > 4294934644) {
                    p = p + 16269 | 0;
                    break e;
                  }
                  Qo(N + 48 | 0, s, u, A, m, 0, 0, 0, 7471104), p = ((p | 0) <= -48920 ? -48920 : p) + 32538 | 0, A = e[N + 56 >> 2], m = e[N + 60 >> 2], s = e[N + 48 >> 2], u = e[N + 52 >> 2];
                }
                Qo(N, s, u, A, m, 0, 0, 0, p + 16383 << 16), s = e[N + 12 >> 2], e[r + 8 >> 2] = e[N + 8 >> 2], e[r + 12 >> 2] = s, s = e[N + 4 >> 2], e[r >> 2] = e[N >> 2], e[r + 4 >> 2] = s, Jr = N + 80 | 0;
              }
              function Du(r, s, u, A, m) {
                var p = 0, N = 0, W = 0, Te = 0;
                W = Jr - 16 | 0, Jr = W, e[W + 12 >> 2] = s, s = 0, N = 6;
                e: {
                  t: {
                    if (Lu(r, W + 12 | 0))
                      break t;
                    N = e[r >> 2], p = e[N + 12 >> 2];
                    r: {
                      if ((p | 0) == e[N + 16 >> 2]) {
                        p = xi[e[e[N >> 2] + 36 >> 2]](N) | 0;
                        break r;
                      }
                      p = me[p | 0];
                    }
                    if (N = 4, Te = e[A + 8 >> 2], p = p << 24 >> 24, (p | 0) >= 0 ? Te = (e[((p & 255) << 2) + Te >> 2] & 64) != 0 : Te = 0, !Te)
                      break t;
                    for (s = xi[e[e[A >> 2] + 36 >> 2]](A, p, 0) | 0; ; ) {
                      r: {
                        if (s = s - 48 | 0, p = Ql(r), Lu(p, W + 12 | 0) | (m | 0) < 2)
                          break r;
                        N = e[p >> 2], p = e[N + 12 >> 2];
                        i: {
                          if ((p | 0) == e[N + 16 >> 2]) {
                            N = xi[e[e[N >> 2] + 36 >> 2]](N) | 0;
                            break i;
                          }
                          N = me[p | 0];
                        }
                        if (p = e[A + 8 >> 2], N = N << 24 >> 24, (N | 0) >= 0 ? p = (e[p + ((N & 255) << 2) >> 2] & 64) != 0 : p = 0, !p)
                          break e;
                        m = m - 1 | 0, s = (xi[e[e[A >> 2] + 36 >> 2]](A, N, 0) | 0) + Sn(s, 10) | 0;
                        continue;
                      }
                      break;
                    }
                    if (N = 2, !Lu(p, W + 12 | 0))
                      break e;
                  }
                  e[u >> 2] = e[u >> 2] | N;
                }
                return Jr = W + 16 | 0, s;
              }
              function pu(r, s) {
                r = r | 0, s = s | 0;
                var u = 0, A = 0;
                e: {
                  if ((s | 0) > 0)
                    for (A = r + s | 0; ; ) {
                      s = 1;
                      t: {
                        r:
                          switch (me[r | 0] - 66 | 0) {
                            default:
                              if (r = cu(8), e[5996] = 0, s = pi(17, r | 0, 2064) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1)
                                break e;
                              Ua(s | 0, 22528, 7), Oi();
                            case 20:
                              s = 2;
                              break t;
                            case 9:
                              s = 4;
                              break t;
                            case 21:
                              s = 8;
                              break t;
                            case 56:
                              s = 16;
                              break t;
                            case 45:
                              s = 32;
                              break t;
                            case 44:
                              s = 64;
                              break t;
                            case 34:
                              s = 128;
                              break t;
                            case 51:
                              s = 256;
                              break t;
                            case 35:
                              s = 512;
                              break t;
                            case 36:
                              s = 1024;
                              break t;
                            case 49:
                              s = 2048;
                              break t;
                            case 43:
                              s = 4096;
                              break t;
                            case 54:
                              s = 8192;
                              break t;
                            case 37:
                              s = 16384;
                              break t;
                            case 38:
                              s = 32768;
                              break t;
                            case 39:
                              s = 65536;
                              break t;
                            case 40:
                              s = 131072;
                              break t;
                            case 0:
                              break t;
                            case 41:
                              break r;
                          }
                        s = 262144;
                      }
                      if (u = s | u, r = r + 1 | 0, !(A >>> 0 > r >>> 0))
                        break;
                    }
                  return u | 0;
                }
                s = Hr() | 0, Xu(r), Jn(s | 0), Oi();
              }
              function nu(r, s, u) {
                var A = 0, m = 0, p = 0, N = 0;
                e: {
                  if (!u || (_[r | 0] = s, A = r + u | 0, _[A - 1 | 0] = s, u >>> 0 < 3) || (_[r + 2 | 0] = s, _[r + 1 | 0] = s, _[A - 3 | 0] = s, _[A - 2 | 0] = s, u >>> 0 < 7) || (_[r + 3 | 0] = s, _[A - 4 | 0] = s, u >>> 0 < 9) || (A = 0 - r & 3, m = A + r | 0, s = Sn(s & 255, 16843009), e[m >> 2] = s, A = u - A & -4, u = A + m | 0, e[u - 4 >> 2] = s, A >>> 0 < 9) || (e[m + 8 >> 2] = s, e[m + 4 >> 2] = s, e[u - 8 >> 2] = s, e[u - 12 >> 2] = s, A >>> 0 < 25) || (e[m + 24 >> 2] = s, e[m + 20 >> 2] = s, e[m + 16 >> 2] = s, e[m + 12 >> 2] = s, e[u - 16 >> 2] = s, e[u - 20 >> 2] = s, e[u - 24 >> 2] = s, e[u - 28 >> 2] = s, N = m & 4 | 24, u = A - N | 0, u >>> 0 < 32))
                    break e;
                  for (A = Ao(s, 0, 1, 1), p = Ds, s = m + N | 0; e[s + 24 >> 2] = A, e[s + 28 >> 2] = p, e[s + 16 >> 2] = A, e[s + 20 >> 2] = p, e[s + 8 >> 2] = A, e[s + 12 >> 2] = p, e[s >> 2] = A, e[s + 4 >> 2] = p, s = s + 32 | 0, u = u - 32 | 0, u >>> 0 > 31; )
                    ;
                }
                return r;
              }
              function yd(r, s) {
                r = r | 0, s = s | 0;
                var u = 0, A = 0, m = 0, p = 0, N = 0, W = 0;
                e: {
                  if (A = e[r + 4 >> 2], W = e[r >> 2], p = A - W >> 3, u = p + 1 | 0, u >>> 0 < 536870912) {
                    if (N = e[r + 8 >> 2] - W | 0, m = N >> 2, u = N >>> 0 >= 2147483640 ? 536870911 : u >>> 0 < m >>> 0 ? m : u, u >>> 0 >= 536870912)
                      break e;
                    if (m = p << 3, p = u << 3, N = Qs(p), u = m + N | 0, e[u >> 2] = e[s >> 2], e[u + 4 >> 2] = e[s + 4 >> 2], e[s >> 2] = 0, e[s + 4 >> 2] = 0, m = u + 8 | 0, (A | 0) != (W | 0))
                      for (; u = u - 8 | 0, A = A - 8 | 0, e[u >> 2] = e[A >> 2], e[u + 4 >> 2] = e[A + 4 >> 2], e[A >> 2] = 0, e[A + 4 >> 2] = 0, (A | 0) != (W | 0); )
                        ;
                    if (e[r + 8 >> 2] = p + N, s = e[r >> 2], e[r >> 2] = u, A = e[r + 4 >> 2], e[r + 4 >> 2] = m, (s | 0) != (A | 0))
                      for (; ; ) {
                        A = A - 8 | 0, r = e[A + 4 >> 2];
                        t: {
                          if (!r || (u = e[r + 4 >> 2], e[r + 4 >> 2] = u - 1, u))
                            break t;
                          xi[e[e[r >> 2] + 8 >> 2]](r), ys(r);
                        }
                        if ((s | 0) == (A | 0))
                          break;
                      }
                    s && Br(s);
                    return;
                  }
                  Jo(), Oi();
                }
                hu(), Oi();
              }
              function ko() {
                var r = 0, s = 0, u = 0, A = 0;
                if (me[25008])
                  return e[6251];
                u = Jr - 32 | 0, Jr = u;
                e: {
                  t: {
                    for (; ; ) {
                      if (s = u + 8 | 0, A = md(r, 1 << r & 2147483647 ? 3538 : 5575), e[s + (r << 2) >> 2] = A, (A | 0) == -1)
                        break t;
                      if (r = r + 1 | 0, (r | 0) == 6)
                        break;
                    }
                    if (r = 19324, !va(s, 19324, 24) || (r = 19348, !va(s, 19348, 24)))
                      break e;
                    if (r = 0, !me[24780]) {
                      for (; e[(r << 2) + 24732 >> 2] = md(r, 5575), r = r + 1 | 0, (r | 0) != 6; )
                        ;
                      _[24780] = 1, e[6189] = e[6183];
                    }
                    if (r = 24732, s = u + 8 | 0, !va(s, 24732, 24) || (r = 24756, !va(s, 24756, 24)))
                      break e;
                    if (r = da(24), !r)
                      break t;
                    s = e[u + 12 >> 2], e[r >> 2] = e[u + 8 >> 2], e[r + 4 >> 2] = s, s = e[u + 28 >> 2], e[r + 16 >> 2] = e[u + 24 >> 2], e[r + 20 >> 2] = s, s = e[u + 20 >> 2], e[r + 8 >> 2] = e[u + 16 >> 2], e[r + 12 >> 2] = s;
                    break e;
                  }
                  r = 0;
                }
                return Jr = u + 32 | 0, _[25008] = 1, e[6251] = r, r;
              }
              function fl(r, s) {
                var u = 0, A = 0, m = 0, p = 0;
                u = Jr + -64 | 0, Jr = u, A = e[r >> 2], m = e[A - 4 >> 2], p = e[A - 8 >> 2], e[u + 28 >> 2] = 0, e[u + 32 >> 2] = 0, e[u + 36 >> 2] = 0, e[u + 40 >> 2] = 0, e[u + 44 >> 2] = 0, e[u + 48 >> 2] = 0, e[u + 52 >> 2] = 0, e[u + 56 >> 2] = 0, A = 0, _[u + 59 | 0] = 0, _[u + 60 | 0] = 0, _[u + 61 | 0] = 0, _[u + 62 | 0] = 0, e[u + 20 >> 2] = 0, e[u + 24 >> 2] = 0, e[u + 16 >> 2] = 22056, e[u + 12 >> 2] = r, e[u + 8 >> 2] = s, r = r + p | 0;
                e: {
                  if (eu(m, s, 0)) {
                    e[u + 56 >> 2] = 1, xi[e[e[m >> 2] + 20 >> 2]](m, u + 8 | 0, r, r, 1, 0), A = e[u + 32 >> 2] == 1 ? r : 0;
                    break e;
                  }
                  xi[e[e[m >> 2] + 24 >> 2]](m, u + 8 | 0, r, 1, 0);
                  t:
                    switch (e[u + 44 >> 2]) {
                      case 0:
                        A = e[u + 48 >> 2] == 1 && e[u + 36 >> 2] == 1 && e[u + 40 >> 2] == 1 ? e[u + 28 >> 2] : 0;
                        break e;
                      case 1:
                        break t;
                      default:
                        break e;
                    }
                  if (e[u + 32 >> 2] != 1 && e[u + 48 >> 2] | e[u + 36 >> 2] != 1 | e[u + 40 >> 2] != 1)
                    break e;
                  A = e[u + 24 >> 2];
                }
                return Jr = u - -64 | 0, A;
              }
              function md(r, s) {
                var u = 0, A = 0, m = 0;
                e: {
                  if (me[s | 0] || (s = hd(3169), me[s | 0] && s) || (s = hd(Sn(r, 12) + 9024 | 0), me[s | 0] && s) || (s = hd(3321), me[s | 0] && s))
                    break e;
                  s = 3845;
                }
                e: {
                  for (; ; ) {
                    if (A = me[s + u | 0], !(!A | (A | 0) == 47)) {
                      if (A = 23, u = u + 1 | 0, (u | 0) != 23)
                        continue;
                      break e;
                    }
                    break;
                  }
                  A = u;
                }
                m = 3845;
                e: {
                  t: {
                    u = me[s | 0];
                    r: {
                      i: {
                        if (!(me[s + A | 0] | (u | 0) == 46) && (m = s, (u | 0) != 67))
                          break i;
                        if (!me[m + 1 | 0])
                          break r;
                      }
                      if (!_f(m, 3845))
                        break r;
                      if (_f(m, 2764))
                        break t;
                    }
                    if (!r && (u = 9096, me[m + 1 | 0] == 46))
                      break e;
                    return 0;
                  }
                  if (u = e[6182], u)
                    for (; ; ) {
                      if (!_f(m, u + 8 | 0))
                        break e;
                      if (u = e[u + 32 >> 2], !u)
                        break;
                    }
                  u = da(36), u && (e[u + 4 >> 2] = 20, e[u >> 2] = 8992, s = u + 8 | 0, so(s, m, A), _[s + A | 0] = 0, e[u + 32 >> 2] = e[6182], e[6182] = u), u = r | u ? u : 9096;
                }
                return u;
              }
              function Br(r) {
                var s = 0, u = 0, A = 0, m = 0, p = 0;
                if (r) {
                  s = r - 4 | 0, m = e[s >> 2], A = m, u = s, p = e[r - 8 >> 2], r = p & -2, (r | 0) != (p | 0) && (u = s - r | 0, p = e[u + 4 >> 2], e[p + 8 >> 2] = e[u + 8 >> 2], e[e[u + 8 >> 2] + 4 >> 2] = p, A = r + A | 0), r = s + m | 0, s = e[r >> 2], (s | 0) != e[(r + s | 0) - 4 >> 2] && (m = e[r + 4 >> 2], e[m + 8 >> 2] = e[r + 8 >> 2], e[e[r + 8 >> 2] + 4 >> 2] = m, A = s + A | 0), e[u >> 2] = A, e[((A & -4) + u | 0) - 4 >> 2] = A | 1, s = e[u >> 2] - 8 | 0;
                  e: {
                    if (s >>> 0 <= 127) {
                      r = (s >>> 3 | 0) - 1 | 0;
                      break e;
                    }
                    if (A = Fo(s), r = ((s >>> 29 - A ^ 4) - (A << 2) | 0) + 110 | 0, s >>> 0 <= 4095)
                      break e;
                    r = ((s >>> 30 - A ^ 2) - (A << 1) | 0) + 71 | 0, r = r >>> 0 >= 63 ? 63 : r;
                  }
                  s = r << 4, e[u + 4 >> 2] = s + 22944, s = s + 22952 | 0, e[u + 8 >> 2] = e[s >> 2], e[s >> 2] = u, e[e[u + 8 >> 2] + 4 >> 2] = u, s = e[5994], A = e[5995], u = r & 31, (r & 63) >>> 0 >= 32 ? (r = 1 << u, m = 0) : (m = 1 << u, r = m - 1 & 1 >>> 32 - u), e[5994] = m | s, e[5995] = r | A;
                }
              }
              function Kf(r, s, u, A, m, p, N, W, Te, Xe, fr) {
                var ar = 0, vr = 0, _r = 0;
                e: {
                  t: {
                    if (ar = e[A >> 2], (ar | 0) != (u | 0) || (vr = 43, _r = r & 255, (_r | 0) != me[fr + 24 | 0] && (vr = 45, me[fr + 25 | 0] != (_r | 0))))
                      break t;
                    e[A >> 2] = u + 1, _[u | 0] = vr;
                    break e;
                  }
                  t: {
                    if (!(!((W & 128) >>> 7 | 0 ? N : W & 127) | (r | 0) != (p | 0))) {
                      if (W = 0, r = e[Xe >> 2], (r - Te | 0) > 159)
                        break t;
                      s = e[m >> 2], e[Xe >> 2] = r + 4, e[r >> 2] = s;
                      break e;
                    }
                    if (W = -1, r = Vd(fr, fr + 26 | 0, r) - fr | 0, (r | 0) > 23)
                      break t;
                    r: {
                      i:
                        switch (s - 8 | 0) {
                          case 0:
                          case 2:
                            if ((r | 0) < (s | 0))
                              break r;
                            break t;
                          case 1:
                            break r;
                          default:
                            break i;
                        }
                      if ((s | 0) != 16 | (r | 0) < 22)
                        break r;
                      if ((u | 0) == (ar | 0) | (ar - u | 0) > 2 | me[ar - 1 | 0] != 48)
                        break t;
                      return e[m >> 2] = 0, e[A >> 2] = ar + 1, _[ar | 0] = me[r + 12416 | 0], 0;
                    }
                    e[A >> 2] = ar + 1, _[ar | 0] = me[r + 12416 | 0], e[m >> 2] = e[m >> 2] + 1, W = 0;
                  }
                  return W;
                }
                return e[m >> 2] = 0, 0;
              }
              function Vf(r, s, u, A, m, p, N, W, Te, Xe, fr) {
                var ar = 0, vr = 0;
                e: {
                  t: {
                    if (ar = e[A >> 2], (ar | 0) != (u | 0) || (vr = 43, e[fr + 96 >> 2] != (r | 0) && (vr = 45, e[fr + 100 >> 2] != (r | 0))))
                      break t;
                    e[A >> 2] = u + 1, _[u | 0] = vr;
                    break e;
                  }
                  t: {
                    if (!(!((W & 128) >>> 7 | 0 ? N : W & 127) | (r | 0) != (p | 0))) {
                      if (W = 0, r = e[Xe >> 2], (r - Te | 0) > 159)
                        break t;
                      s = e[m >> 2], e[Xe >> 2] = r + 4, e[r >> 2] = s;
                      break e;
                    }
                    if (W = -1, p = Gd(fr, fr + 104 | 0, r) - fr | 0, (p | 0) > 92)
                      break t;
                    r = p >> 2;
                    r: {
                      i:
                        switch (s - 8 | 0) {
                          case 0:
                          case 2:
                            if ((r | 0) < (s | 0))
                              break r;
                            break t;
                          case 1:
                            break r;
                          default:
                            break i;
                        }
                      if ((s | 0) != 16 | (p | 0) < 88)
                        break r;
                      if ((u | 0) == (ar | 0) | (ar - u | 0) > 2 | me[ar - 1 | 0] != 48)
                        break t;
                      return e[m >> 2] = 0, e[A >> 2] = ar + 1, _[ar | 0] = me[r + 12416 | 0], 0;
                    }
                    e[A >> 2] = ar + 1, _[ar | 0] = me[r + 12416 | 0], e[m >> 2] = e[m >> 2] + 1, W = 0;
                  }
                  return W;
                }
                return e[m >> 2] = 0, 0;
              }
              function of(r, s) {
                r = r | 0, s = s | 0;
                var u = 0, A = 0, m = 0, p = 0, N = 0, W = 0;
                if (u = e[r + 4 >> 2], A = e[r + 8 >> 2], u >>> 0 < A >>> 0) {
                  e[u >> 2] = s, e[r + 4 >> 2] = u + 4;
                  return;
                }
                e: {
                  t: {
                    r: {
                      if (N = e[r >> 2], m = u - N >> 2, p = m + 1 | 0, p >>> 0 < 1073741824) {
                        if (W = m << 2, A = A - N | 0, m = A >> 1, A = A >>> 0 >= 2147483644 ? 1073741823 : p >>> 0 < m >>> 0 ? m : p, A) {
                          if (A >>> 0 >= 1073741824)
                            break r;
                          m = Qs(A << 2);
                        } else
                          m = 0;
                        if (p = W + m | 0, e[p >> 2] = s, s = m + (A << 2) | 0, A = p + 4 | 0, (u | 0) == (N | 0))
                          break t;
                        for (; u = u - 4 | 0, m = e[u >> 2], e[u >> 2] = 0, p = p - 4 | 0, e[p >> 2] = m, (u | 0) != (N | 0); )
                          ;
                        if (e[r + 8 >> 2] = s, s = e[r + 4 >> 2], e[r + 4 >> 2] = A, u = e[r >> 2], e[r >> 2] = p, (s | 0) == (u | 0))
                          break e;
                        for (; s = s - 4 | 0, wl(s), (s | 0) != (u | 0); )
                          ;
                        break e;
                      }
                      Jo(), Oi();
                    }
                    hu(), Oi();
                  }
                  e[r + 8 >> 2] = s, e[r + 4 >> 2] = A, e[r >> 2] = p;
                }
                u && Br(u);
              }
              function cl(r, s) {
                r = r | 0, s = s | 0;
                var u = 0, A = 0, m = 0, p = 0, N = 0;
                e: {
                  if (s >>> 0 >= 256) {
                    if (r = cu(8), e[5996] = 0, s = pi(91, r | 0, 2394) | 0, u = e[5996], e[5996] = 0, (u | 0) != 1)
                      break e;
                    s = Hr() | 0, Xu(r), Jn(s | 0), Oi();
                  }
                  return u = me[r | 0] | me[r + 1 | 0] << 8 | (me[r + 2 | 0] << 16 | me[r + 3 | 0] << 24), m = u - 29 | 0, p = u >>> 0 < 29 ? u : m, A = p + 1 | 0, A >>> 0 > (u >>> 0 <= 28 ? 28 : me[r + 4 | 0] | me[r + 5 | 0] << 8 | (me[r + 6 | 0] << 16 | me[r + 7 | 0] << 24)) >>> 0 && (fu(r, A + (A >>> 1 | 0) | 0), u = me[r | 0] | me[r + 1 | 0] << 8 | (me[r + 2 | 0] << 16 | me[r + 3 | 0] << 24), m = u - 29 | 0), N = u >>> 0 < 29, A = (N ? r + 4 | 0 : me[r + 8 | 0] | me[r + 9 | 0] << 8 | (me[r + 10 | 0] << 16 | me[r + 11 | 0] << 24)) + p | 0, Ys(A + 1 | 0, A, (N ? u : m) - p | 0), u = (me[r | 0] | me[r + 1 | 0] << 8 | (me[r + 2 | 0] << 16 | me[r + 3 | 0] << 24)) + 1 | 0, _[r | 0] = u, _[r + 1 | 0] = u >>> 8, _[r + 2 | 0] = u >>> 16, _[r + 3 | 0] = u >>> 24, _[A | 0] = s, r | 0;
                }
                Ua(s | 0, 22664, 92), Oi();
              }
              function Rh(r, s, u, A, m, p) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0, m = m | 0, p = p | 0;
                var N = 0, W = 0, Te = 0;
                N = Jr - 256 | 0, Jr = N, e[N + 248 >> 2] = 37, e[N + 252 >> 2] = 0, W = N + 248 | 0, Pu(W | 1, 2055, 1, e[u + 4 >> 2]), Te = ko(), e[N >> 2] = m, e[N + 4 >> 2] = p, r = N + 224 | 0, m = oa(r, 24, Te, W, N) + r | 0, Te = Xa(r, m, e[u + 4 >> 2]), p = N + 20 | 0, W = e[u + 28 >> 2], e[p >> 2] = W, e[W + 4 >> 2] = e[W + 4 >> 2] + 1, e[5996] = 0, W = N + 32 | 0, au(215, r | 0, Te | 0, m | 0, W | 0, N + 28 | 0, N + 24 | 0, p | 0), r = e[5996], e[5996] = 0;
                e: {
                  if ((r | 0) != 1) {
                    r = e[p >> 2], m = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = m, (m | 0) == -1 && xi[e[e[r >> 2] + 8 >> 2]](r), r = Yu(s, W, e[N + 28 >> 2], e[N + 24 >> 2], u, A), Jr = N + 256 | 0;
                    break e;
                  }
                  u = Hr() | 0, r = e[N + 20 >> 2], s = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = s, (s | 0) == -1 && xi[e[e[r >> 2] + 8 >> 2]](r), Jn(u | 0), Oi();
                }
                return r | 0;
              }
              function ll(r, s, u, A, m, p) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0, m = m | 0, p = p | 0;
                var N = 0, W = 0, Te = 0;
                N = Jr - 256 | 0, Jr = N, e[N + 248 >> 2] = 37, e[N + 252 >> 2] = 0, W = N + 248 | 0, Pu(W | 1, 2055, 0, e[u + 4 >> 2]), Te = ko(), e[N >> 2] = m, e[N + 4 >> 2] = p, r = N + 224 | 0, m = oa(r, 24, Te, W, N) + r | 0, Te = Xa(r, m, e[u + 4 >> 2]), p = N + 20 | 0, W = e[u + 28 >> 2], e[p >> 2] = W, e[W + 4 >> 2] = e[W + 4 >> 2] + 1, e[5996] = 0, W = N + 32 | 0, au(215, r | 0, Te | 0, m | 0, W | 0, N + 28 | 0, N + 24 | 0, p | 0), r = e[5996], e[5996] = 0;
                e: {
                  if ((r | 0) != 1) {
                    r = e[p >> 2], m = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = m, (m | 0) == -1 && xi[e[e[r >> 2] + 8 >> 2]](r), r = Yu(s, W, e[N + 28 >> 2], e[N + 24 >> 2], u, A), Jr = N + 256 | 0;
                    break e;
                  }
                  u = Hr() | 0, r = e[N + 20 >> 2], s = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = s, (s | 0) == -1 && xi[e[e[r >> 2] + 8 >> 2]](r), Jn(u | 0), Oi();
                }
                return r | 0;
              }
              function np(r, s, u, A, m, p) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0, m = m | 0, p = p | 0;
                var N = 0, W = 0, Te = 0;
                N = Jr - 112 | 0, Jr = N, e[N + 104 >> 2] = 37, e[N + 108 >> 2] = 0, W = N + 104 | 0, Pu(W | 1, 2055, 1, e[u + 4 >> 2]), Te = ko(), e[N >> 2] = m, e[N + 4 >> 2] = p, r = N + 80 | 0, m = oa(r, 24, Te, W, N) + r | 0, Te = Xa(r, m, e[u + 4 >> 2]), p = N + 20 | 0, W = e[u + 28 >> 2], e[p >> 2] = W, e[W + 4 >> 2] = e[W + 4 >> 2] + 1, e[5996] = 0, W = N + 32 | 0, au(211, r | 0, Te | 0, m | 0, W | 0, N + 28 | 0, N + 24 | 0, p | 0), r = e[5996], e[5996] = 0;
                e: {
                  if ((r | 0) != 1) {
                    r = e[p >> 2], m = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = m, (m | 0) == -1 && xi[e[e[r >> 2] + 8 >> 2]](r), r = Hf(s, W, e[N + 28 >> 2], e[N + 24 >> 2], u, A), Jr = N + 112 | 0;
                    break e;
                  }
                  u = Hr() | 0, r = e[N + 20 >> 2], s = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = s, (s | 0) == -1 && xi[e[e[r >> 2] + 8 >> 2]](r), Jn(u | 0), Oi();
                }
                return r | 0;
              }
              function sp(r, s, u, A, m, p) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0, m = m | 0, p = p | 0;
                var N = 0, W = 0, Te = 0;
                N = Jr - 112 | 0, Jr = N, e[N + 104 >> 2] = 37, e[N + 108 >> 2] = 0, W = N + 104 | 0, Pu(W | 1, 2055, 0, e[u + 4 >> 2]), Te = ko(), e[N >> 2] = m, e[N + 4 >> 2] = p, r = N + 80 | 0, m = oa(r, 24, Te, W, N) + r | 0, Te = Xa(r, m, e[u + 4 >> 2]), p = N + 20 | 0, W = e[u + 28 >> 2], e[p >> 2] = W, e[W + 4 >> 2] = e[W + 4 >> 2] + 1, e[5996] = 0, W = N + 32 | 0, au(211, r | 0, Te | 0, m | 0, W | 0, N + 28 | 0, N + 24 | 0, p | 0), r = e[5996], e[5996] = 0;
                e: {
                  if ((r | 0) != 1) {
                    r = e[p >> 2], m = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = m, (m | 0) == -1 && xi[e[e[r >> 2] + 8 >> 2]](r), r = Hf(s, W, e[N + 28 >> 2], e[N + 24 >> 2], u, A), Jr = N + 112 | 0;
                    break e;
                  }
                  u = Hr() | 0, r = e[N + 20 >> 2], s = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = s, (s | 0) == -1 && xi[e[e[r >> 2] + 8 >> 2]](r), Jn(u | 0), Oi();
                }
                return r | 0;
              }
              function xh(r, s, u, A, m, p) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0, m = m | 0, p = p | 0;
                var N = 0, W = 0, Te = 0, Xe = 0, fr = 0, ar = 0;
                if (eu(r, e[s + 8 >> 2], p)) {
                  Dd(s, u, A, m);
                  return;
                }
                N = me[s + 53 | 0], Te = e[r + 12 >> 2], _[s + 53 | 0] = 0, W = me[s + 52 | 0], _[s + 52 | 0] = 0, jd(e[r + 16 >> 2], e[r + 20 >> 2], s, u, A, m, p), Xe = me[s + 52 | 0], W = (W | Xe) != 0, fr = me[s + 53 | 0], ar = (N | fr) != 0, N = r + 24 | 0, Te = (r + 16 | 0) + (Te << 3) | 0;
                e: {
                  if (N >>> 0 >= Te >>> 0)
                    break e;
                  for (; ; ) {
                    if (me[s + 54 | 0])
                      break e;
                    t: {
                      if (Xe) {
                        if (e[s + 24 >> 2] == 1)
                          break e;
                        if (me[r + 8 | 0] & 2)
                          break t;
                        break e;
                      }
                      if (!fr)
                        break t;
                      if (!(_[r + 8 | 0] & 1))
                        break e;
                    }
                    if (Zs[s + 52 >> 1] = 0, jd(e[N >> 2], e[N + 4 >> 2], s, u, A, m, p), fr = me[s + 53 | 0], ar = (fr | ar) != 0, Xe = me[s + 52 | 0], W = (Xe | W) != 0, N = N + 8 | 0, !(Te >>> 0 > N >>> 0))
                      break;
                  }
                }
                _[s + 53 | 0] = ar, _[s + 52 | 0] = W;
              }
              function yu(r, s, u, A, m) {
                var p = 0, N = 0, W = 0, Te = 0;
                W = Jr - 16 | 0, Jr = W, e[W + 12 >> 2] = s, s = 0, N = 6;
                e: {
                  t: {
                    if (Hu(r, W + 12 | 0))
                      break t;
                    N = 4, p = e[r >> 2], Te = e[p + 12 >> 2];
                    r: {
                      if ((Te | 0) == e[p + 16 >> 2]) {
                        p = xi[e[e[p >> 2] + 36 >> 2]](p) | 0;
                        break r;
                      }
                      p = e[Te >> 2];
                    }
                    if (!(xi[e[e[A >> 2] + 12 >> 2]](A, 64, p) | 0))
                      break t;
                    for (s = xi[e[e[A >> 2] + 52 >> 2]](A, p, 0) | 0; ; ) {
                      r: {
                        if (s = s - 48 | 0, p = Ul(r), Hu(p, W + 12 | 0) | (m | 0) < 2)
                          break r;
                        N = e[p >> 2], p = e[N + 12 >> 2];
                        i: {
                          if ((p | 0) == e[N + 16 >> 2]) {
                            N = xi[e[e[N >> 2] + 36 >> 2]](N) | 0;
                            break i;
                          }
                          N = e[p >> 2];
                        }
                        if (!(xi[e[e[A >> 2] + 12 >> 2]](A, 64, N) | 0))
                          break e;
                        m = m - 1 | 0, s = (xi[e[e[A >> 2] + 52 >> 2]](A, N, 0) | 0) + Sn(s, 10) | 0;
                        continue;
                      }
                      break;
                    }
                    if (N = 2, !Hu(p, W + 12 | 0))
                      break e;
                  }
                  e[u >> 2] = e[u >> 2] | N;
                }
                return Jr = W + 16 | 0, s;
              }
              function dl(r, s, u, A) {
                var m = 0, p = 0, N = 0, W = 0;
                N = A || 24720, A = e[N >> 2];
                e: {
                  t: {
                    r: {
                      if (!s) {
                        if (A)
                          break r;
                        return 0;
                      }
                      if (m = -2, !u)
                        break t;
                      i: {
                        if (A) {
                          m = u;
                          break i;
                        }
                        if (A = me[s | 0], p = A << 24 >> 24, (p | 0) >= 0)
                          return r && (e[r >> 2] = A), (p | 0) != 0;
                        if (!e[e[6178] >> 2]) {
                          if (m = 1, !r)
                            break t;
                          return e[r >> 2] = p & 57343, 1;
                        }
                        if (A = A - 194 | 0, A >>> 0 > 50)
                          break r;
                        if (A = e[(A << 2) + 12208 >> 2], m = u - 1 | 0, !m)
                          break e;
                        s = s + 1 | 0;
                      }
                      if (p = me[s | 0], W = p >>> 3 | 0, (W - 16 | (A >> 26) + W) >>> 0 > 7)
                        break r;
                      for (; ; ) {
                        if (m = m - 1 | 0, A = p - 128 | A << 6, (A | 0) >= 0)
                          return e[N >> 2] = 0, r && (e[r >> 2] = A), u - m | 0;
                        if (!m)
                          break e;
                        if (s = s + 1 | 0, p = me[s | 0], (p & 192) != 128)
                          break;
                      }
                    }
                    e[N >> 2] = 0, e[5732] = 25, m = -1;
                  }
                  return m;
                }
                return e[N >> 2] = A, -2;
              }
              function zu(r, s, u, A, m) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0, m = m | 0;
                var p = 0, N = 0, W = 0, Te = 0;
                p = Jr - 144 | 0, Jr = p, e[p + 136 >> 2] = 37, e[p + 140 >> 2] = 0, W = p + 136 | 0, Pu(W | 1, 2096, 1, e[u + 4 >> 2]), N = ko(), e[p >> 2] = m, r = p + 123 | 0, m = oa(r, 13, N, W, p) + r | 0, Te = Xa(r, m, e[u + 4 >> 2]), W = p + 4 | 0, N = e[u + 28 >> 2], e[W >> 2] = N, e[N + 4 >> 2] = e[N + 4 >> 2] + 1, e[5996] = 0, N = p + 16 | 0, au(215, r | 0, Te | 0, m | 0, N | 0, p + 12 | 0, p + 8 | 0, W | 0), r = e[5996], e[5996] = 0;
                e: {
                  if ((r | 0) != 1) {
                    r = e[W >> 2], m = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = m, (m | 0) == -1 && xi[e[e[r >> 2] + 8 >> 2]](r), r = Yu(s, N, e[p + 12 >> 2], e[p + 8 >> 2], u, A), Jr = p + 144 | 0;
                    break e;
                  }
                  u = Hr() | 0, r = e[p + 4 >> 2], s = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = s, (s | 0) == -1 && xi[e[e[r >> 2] + 8 >> 2]](r), Jn(u | 0), Oi();
                }
                return r | 0;
              }
              function hl(r, s, u, A, m) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0, m = m | 0;
                var p = 0, N = 0, W = 0, Te = 0;
                p = Jr - 144 | 0, Jr = p, e[p + 136 >> 2] = 37, e[p + 140 >> 2] = 0, W = p + 136 | 0, Pu(W | 1, 2096, 0, e[u + 4 >> 2]), N = ko(), e[p >> 2] = m, r = p + 123 | 0, m = oa(r, 13, N, W, p) + r | 0, Te = Xa(r, m, e[u + 4 >> 2]), W = p + 4 | 0, N = e[u + 28 >> 2], e[W >> 2] = N, e[N + 4 >> 2] = e[N + 4 >> 2] + 1, e[5996] = 0, N = p + 16 | 0, au(215, r | 0, Te | 0, m | 0, N | 0, p + 12 | 0, p + 8 | 0, W | 0), r = e[5996], e[5996] = 0;
                e: {
                  if ((r | 0) != 1) {
                    r = e[W >> 2], m = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = m, (m | 0) == -1 && xi[e[e[r >> 2] + 8 >> 2]](r), r = Yu(s, N, e[p + 12 >> 2], e[p + 8 >> 2], u, A), Jr = p + 144 | 0;
                    break e;
                  }
                  u = Hr() | 0, r = e[p + 4 >> 2], s = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = s, (s | 0) == -1 && xi[e[e[r >> 2] + 8 >> 2]](r), Jn(u | 0), Oi();
                }
                return r | 0;
              }
              function op(r, s, u, A, m) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0, m = m | 0;
                var p = 0, N = 0, W = 0, Te = 0;
                p = Jr + -64 | 0, Jr = p, e[p + 56 >> 2] = 37, e[p + 60 >> 2] = 0, W = p + 56 | 0, Pu(W | 1, 2096, 1, e[u + 4 >> 2]), N = ko(), e[p >> 2] = m, r = p + 43 | 0, m = oa(r, 13, N, W, p) + r | 0, Te = Xa(r, m, e[u + 4 >> 2]), W = p + 4 | 0, N = e[u + 28 >> 2], e[W >> 2] = N, e[N + 4 >> 2] = e[N + 4 >> 2] + 1, e[5996] = 0, N = p + 16 | 0, au(211, r | 0, Te | 0, m | 0, N | 0, p + 12 | 0, p + 8 | 0, W | 0), r = e[5996], e[5996] = 0;
                e: {
                  if ((r | 0) != 1) {
                    r = e[W >> 2], m = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = m, (m | 0) == -1 && xi[e[e[r >> 2] + 8 >> 2]](r), r = Hf(s, N, e[p + 12 >> 2], e[p + 8 >> 2], u, A), Jr = p - -64 | 0;
                    break e;
                  }
                  u = Hr() | 0, r = e[p + 4 >> 2], s = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = s, (s | 0) == -1 && xi[e[e[r >> 2] + 8 >> 2]](r), Jn(u | 0), Oi();
                }
                return r | 0;
              }
              function ap(r, s, u, A, m) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0, m = m | 0;
                var p = 0, N = 0, W = 0, Te = 0;
                p = Jr + -64 | 0, Jr = p, e[p + 56 >> 2] = 37, e[p + 60 >> 2] = 0, W = p + 56 | 0, Pu(W | 1, 2096, 0, e[u + 4 >> 2]), N = ko(), e[p >> 2] = m, r = p + 43 | 0, m = oa(r, 13, N, W, p) + r | 0, Te = Xa(r, m, e[u + 4 >> 2]), W = p + 4 | 0, N = e[u + 28 >> 2], e[W >> 2] = N, e[N + 4 >> 2] = e[N + 4 >> 2] + 1, e[5996] = 0, N = p + 16 | 0, au(211, r | 0, Te | 0, m | 0, N | 0, p + 12 | 0, p + 8 | 0, W | 0), r = e[5996], e[5996] = 0;
                e: {
                  if ((r | 0) != 1) {
                    r = e[W >> 2], m = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = m, (m | 0) == -1 && xi[e[e[r >> 2] + 8 >> 2]](r), r = Hf(s, N, e[p + 12 >> 2], e[p + 8 >> 2], u, A), Jr = p - -64 | 0;
                    break e;
                  }
                  u = Hr() | 0, r = e[p + 4 >> 2], s = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = s, (s | 0) == -1 && xi[e[e[r >> 2] + 8 >> 2]](r), Jn(u | 0), Oi();
                }
                return r | 0;
              }
              function up(r, s, u) {
                r = r | 0, s = s | 0, u = u | 0;
                var A = 0, m = 0, p = 0, N = 0;
                e[u >> 2] = 0;
                e: {
                  if (m = e[s + 4 >> 2], !m)
                    break e;
                  p = e[s >> 2];
                  t: {
                    r: {
                      i: {
                        for (; ; ) {
                          if (A = _[p | 0], N = e[u >> 2], (A | 0) < ((N ? 48 : 49) | 0) | (A | 0) > 57)
                            break i;
                          if (A = (A + Sn(N, 10) | 0) - 48 | 0, e[u >> 2] = A >>> 0 >= 65535 ? 65535 : A, m = m - 1 | 0, e[s + 4 >> 2] = m, p = p + 1 | 0, e[s >> 2] = p, !m)
                            break;
                        }
                        if (e[u >> 2])
                          break r;
                        break e;
                      }
                      if (!N)
                        break e;
                      if ((A | 0) == 64)
                        break t;
                    }
                    e[r >> 2] = 0, e[r + 4 >> 2] = 0, e[r + 48 >> 2] = 0, e[r + 52 >> 2] = 0, e[r + 40 >> 2] = 0, e[r + 44 >> 2] = 0, e[r + 32 >> 2] = 0, e[r + 36 >> 2] = 0, e[r + 24 >> 2] = 0, e[r + 28 >> 2] = 0, e[r + 16 >> 2] = 0, e[r + 20 >> 2] = 0, e[r + 8 >> 2] = 0, e[r + 12 >> 2] = 0;
                    return;
                  }
                  e[s + 4 >> 2] = m - 1, e[s >> 2] = p + 1, Ic(r, s);
                  return;
                }
                e[u >> 2] = 1, Ic(r, s);
              }
              function Ju(r, s, u, A, m, p, N, W) {
                var Te = 0, Xe = 0, fr = 0, ar = 0;
                Xe = 1, Te = A & 2147483647, ar = Te, fr = (Te | 0) == 2147418112;
                e: {
                  if ((fr & !u ? r | s : fr & (u | 0) != 0 | Te >>> 0 > 2147418112) || (Te = W & 2147483647, !N & (Te | 0) == 2147418112 ? m | p : (Te | 0) == 2147418112 & (N | 0) != 0 | Te >>> 0 > 2147418112))
                    break e;
                  if (!(r | m | (u | N) | (s | p | (Te | ar))))
                    return 0;
                  if (Xe = A & W, (Xe | 0) > 0 | (Xe | 0) >= 0) {
                    if (Xe = -1, (u | 0) == (N | 0) & (A | 0) == (W | 0) ? (s | 0) == (p | 0) & r >>> 0 < m >>> 0 | s >>> 0 < p >>> 0 : u >>> 0 < N >>> 0 & (A | 0) <= (W | 0) | (A | 0) < (W | 0))
                      break e;
                    return (r ^ m | u ^ N | (s ^ p | A ^ W)) != 0;
                  }
                  if (Xe = -1, (u | 0) == (N | 0) & (A | 0) == (W | 0) ? (s | 0) == (p | 0) & r >>> 0 > m >>> 0 | s >>> 0 > p >>> 0 : u >>> 0 > N >>> 0 & (A | 0) >= (W | 0) | (A | 0) > (W | 0))
                    break e;
                  Xe = (r ^ m | u ^ N | (s ^ p | A ^ W)) != 0;
                }
                return Xe;
              }
              function Dh(r, s) {
                r = r | 0, s = s | 0;
                var u = 0, A = 0, m = 0, p = 0, N = 0, W = 0;
                e: {
                  t: {
                    m = e[r + 4 >> 2], p = e[r >> 2], A = m - p >> 2;
                    r: {
                      if (A >>> 0 < s >>> 0) {
                        if (N = s - A | 0, u = e[r + 8 >> 2], N >>> 0 <= u - m >> 2 >>> 0) {
                          s = r, r = N << 2, e[s + 4 >> 2] = nu(m, 0, r) + r;
                          return;
                        }
                        if (s >>> 0 >= 1073741824)
                          break t;
                        if (u = u - p | 0, W = u >> 1, s = u >>> 0 >= 2147483644 ? 1073741823 : s >>> 0 < W >>> 0 ? W : s, s >>> 0 >= 1073741824)
                          break e;
                        if (u = s << 2, s = Qs(u), u = s + u | 0, s = s + (A << 2) | 0, A = N << 2, A = nu(s, 0, A) + A | 0, (m | 0) != (p | 0))
                          for (; s = s - 4 | 0, m = m - 4 | 0, e[s >> 2] = e[m >> 2], (m | 0) != (p | 0); )
                            ;
                        if (e[r + 8 >> 2] = u, e[r + 4 >> 2] = A, e[r >> 2] = s, !p)
                          break r;
                        Br(p);
                        return;
                      }
                      if (s >>> 0 >= A >>> 0)
                        break r;
                      e[r + 4 >> 2] = (s << 2) + p;
                    }
                    return;
                  }
                  Jo(), Oi();
                }
                hu(), Oi();
              }
              function Nh(r, s, u, A, m) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0, m = m | 0;
                var p = 0, N = 0, W = 0, Te = 0, Xe = 0, fr = 0;
                if (r = Jr - 208 | 0, Jr = r, N = ko(), e[r >> 2] = m, m = r + 176 | 0, W = oa(m, 20, N, 1937, r), N = W + m | 0, Te = Xa(m, N, e[u + 4 >> 2]), p = e[u + 28 >> 2], e[r + 12 >> 2] = p, e[p + 4 >> 2] = e[p + 4 >> 2] + 1, e[5996] = 0, Xe = Mi(197, e[r + 12 >> 2]) | 0, p = e[5996], e[5996] = 0, (p | 0) != 1)
                  return p = e[r + 12 >> 2], fr = e[p + 4 >> 2] - 1 | 0, e[p + 4 >> 2] = fr, (fr | 0) == -1 && xi[e[e[p >> 2] + 8 >> 2]](p), p = m, m = r + 16 | 0, xi[e[e[Xe >> 2] + 48 >> 2]](Xe, p, N, m) | 0, p = s, s = m + (W << 2) | 0, s = Yu(p, m, (N | 0) == (Te | 0) ? s : (r + (Te - r << 2) | 0) - 688 | 0, s, u, A), Jr = r + 208 | 0, s | 0;
                u = Hr() | 0, r = e[r + 12 >> 2], s = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = s, (s | 0) == -1 && xi[e[e[r >> 2] + 8 >> 2]](r), Jn(u | 0), Oi();
              }
              function cu(r) {
                var s = 0, u = 0, A = 0, m = 0, p = 0;
                if (p = r + 27 & -4, r = p, s = r >>> 0 <= 1 ? 1 : r, r = s, u = r + 15 & -16, r = r >>> 0 < u >>> 0 ? u : r, r & 15 ? r = 0 : r = nl(16, r), !r)
                  e:
                    for (u = 0, r = e[6705], r || (e[6705] = 26844, Zs[13423] = 125, Zs[13422] = 128, r = e[6705]), A = (s + 3 >>> 2 | 0) + 1 | 0; ; ) {
                      s = 0;
                      t: {
                        if (!r | (r | 0) == 27344)
                          r = s;
                        else {
                          if (s = Ia[r + 2 >> 1], m = A + (s >>> 0 > A >>> 0 ? s - A & 3 : 0) | 0, m >>> 0 < s >>> 0) {
                            u = s - m | 0, Zs[r + 2 >> 1] = u, r = ((u & 65535) << 2) + r | 0, Zs[r + 2 >> 1] = m, Zs[r >> 1] = 0, r = r + 4 | 0;
                            break e;
                          }
                          if (s >>> 0 < A >>> 0)
                            break t;
                          s = Ia[r >> 1];
                          r: {
                            if (!u) {
                              e[6705] = (s << 2) + 26832;
                              break r;
                            }
                            Zs[u >> 1] = s;
                          }
                          Zs[r >> 1] = 0, r = r + 4 | 0;
                        }
                        break e;
                      }
                      u = r, r = (Ia[r >> 1] << 2) + 26832 | 0;
                    }
                return r || (Na(), Oi()), nu(r, 0, p) + 24 | 0;
              }
              function fp(r, s, u, A, m) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0, m = m | 0;
                var p = 0, N = 0, W = 0, Te = 0, Xe = 0, fr = 0;
                if (r = Jr - 96 | 0, Jr = r, N = ko(), e[r >> 2] = m, m = r - -64 | 0, W = oa(m, 20, N, 1937, r), N = W + m | 0, Te = Xa(m, N, e[u + 4 >> 2]), p = e[u + 28 >> 2], e[r + 12 >> 2] = p, e[p + 4 >> 2] = e[p + 4 >> 2] + 1, e[5996] = 0, Xe = Mi(170, e[r + 12 >> 2]) | 0, p = e[5996], e[5996] = 0, (p | 0) != 1)
                  return p = e[r + 12 >> 2], fr = e[p + 4 >> 2] - 1 | 0, e[p + 4 >> 2] = fr, (fr | 0) == -1 && xi[e[e[p >> 2] + 8 >> 2]](p), p = m, m = r + 16 | 0, xi[e[e[Xe >> 2] + 32 >> 2]](Xe, p, N, m) | 0, p = s, s = m + W | 0, s = Hf(p, m, (N | 0) == (Te | 0) ? s : (r + (Te - r | 0) | 0) - 48 | 0, s, u, A), Jr = r + 96 | 0, s | 0;
                u = Hr() | 0, r = e[r + 12 >> 2], s = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = s, (s | 0) == -1 && xi[e[e[r >> 2] + 8 >> 2]](r), Jn(u | 0), Oi();
              }
              function Ph(r, s, u, A, m, p, N, W) {
                var Te = 0, Xe = 0, fr = 0, ar = 0;
                if (Te = Jr - 16 | 0, Jr = Te, 1073741806 - s >>> 0 >= u >>> 0) {
                  fr = (me[r + 11 | 0] & 128) >>> 7 | 0 ? e[r >> 2] : r, Xe = Te + 4 | 0, ar = Xe, s >>> 0 <= 536870886 ? (e[Te + 12 >> 2] = s << 1, e[Te + 4 >> 2] = s + u, u = e[(Ls[Xe >> 2] < Ls[Te + 12 >> 2] ? Te + 12 | 0 : Xe) >> 2], u >>> 0 >= 2 ? (Xe = u + 4 & -4, u = Xe - 1 | 0, u = (u | 0) == 2 ? Xe : u) : u = 1, u = u + 1 | 0) : u = 1073741807, Ol(ar, u), u = e[Te + 4 >> 2], m && yf(u, fr, m), N && yf(u + (m << 2) | 0, W, N), Xe = m + p | 0, W = A - Xe | 0, (A | 0) != (Xe | 0) && (A = m << 2, yf((A + u | 0) + (N << 2) | 0, (A + fr | 0) + (p << 2) | 0, W)), (s | 0) != 1 && Br(fr), e[r >> 2] = u, e[r + 8 >> 2] = e[Te + 8 >> 2] | -2147483648, s = r, r = W + (m + N | 0) | 0, e[s + 4 >> 2] = r, e[u + (r << 2) >> 2] = 0, Jr = Te + 16 | 0;
                  return;
                }
                Ra(), Oi();
              }
              function wd(r, s, u) {
                r = r | 0, s = s | 0, u = u | 0;
                var A = 0, m = 0, p = 0, N = 0;
                if (m = u - s | 0, m >>> 0 < 2147483632) {
                  e: {
                    if (m >>> 0 <= 10) {
                      _[r + 11 | 0] = m, A = r;
                      break e;
                    }
                    p = (m | 15) + 1 | 0, A = Qs(p), e[r + 8 >> 2] = p | -2147483648, e[r >> 2] = A, e[r + 4 >> 2] = m;
                  }
                  e: {
                    if ((s | 0) == (u | 0))
                      break e;
                    if (p = (s ^ -1) + u | 0, N = m & 7, N)
                      for (m = 0; _[A | 0] = me[s | 0], A = A + 1 | 0, s = s + 1 | 0, m = m + 1 | 0, (N | 0) != (m | 0); )
                        ;
                    if (p >>> 0 < 7)
                      break e;
                    for (; _[A | 0] = me[s | 0], _[A + 1 | 0] = me[s + 1 | 0], _[A + 2 | 0] = me[s + 2 | 0], _[A + 3 | 0] = me[s + 3 | 0], _[A + 4 | 0] = me[s + 4 | 0], _[A + 5 | 0] = me[s + 5 | 0], _[A + 6 | 0] = me[s + 6 | 0], _[A + 7 | 0] = me[s + 7 | 0], A = A + 8 | 0, s = s + 8 | 0, (u | 0) != (s | 0); )
                      ;
                  }
                  return _[A | 0] = 0, r | 0;
                }
                Ra(), Oi();
              }
              function Tc(r, s, u, A) {
                var m = 0, p = 0, N = 0;
                if (m = Jr - 32 | 0, Jr = m, u >>> 0 < 2147483632) {
                  e: {
                    t: {
                      if (u >>> 0 >= 11) {
                        N = (u | 15) + 1 | 0, p = Qs(N), e[m + 16 >> 2] = N | -2147483648, e[m + 8 >> 2] = p, e[m + 12 >> 2] = u;
                        break t;
                      }
                      if (_[m + 19 | 0] = u, p = m + 8 | 0, !u)
                        break e;
                    }
                    p = so(p, s, u) + u | 0;
                  }
                  _[p | 0] = 0, e[5996] = 0, ji(31, m + 20 | 0, m + 8 | 0), s = e[5996], e[5996] = 0;
                  e: {
                    t: {
                      if ((s | 0) != 1) {
                        if (_[m + 19 | 0] < 0 && Br(e[m + 8 >> 2]), u = e[m + 24 >> 2], s = e[m + 20 >> 2], (u - s | 0) != (A | 0))
                          break t;
                        e[r + 4 >> 2] = u, e[r >> 2] = s, e[r + 8 >> 2] = e[m + 28 >> 2];
                        break e;
                      }
                      r = Hr() | 0, _[m + 19 | 0] < 0 && Br(e[m + 8 >> 2]), Jn(r | 0), Oi();
                    }
                    if (e[r + 8 >> 2] = 0, e[r >> 2] = 0, e[r + 4 >> 2] = 0, !s)
                      break e;
                    Br(s);
                  }
                  Jr = m + 32 | 0;
                  return;
                }
                Ra(), Oi();
              }
              function Gf(r, s, u, A, m, p, N, W) {
                var Te = 0, Xe = 0, fr = 0, ar = 0;
                if (Te = Jr - 16 | 0, Jr = Te, 2147483630 - s >>> 0 >= u >>> 0) {
                  fr = (me[r + 11 | 0] & 128) >>> 7 | 0 ? e[r >> 2] : r, Xe = Te + 4 | 0, ar = Xe, s >>> 0 <= 1073741798 ? (e[Te + 12 >> 2] = s << 1, e[Te + 4 >> 2] = s + u, u = e[(Ls[Xe >> 2] < Ls[Te + 12 >> 2] ? Te + 12 | 0 : Xe) >> 2], u >>> 0 >= 11 ? (Xe = u + 16 & -16, u = Xe - 1 | 0, u = (u | 0) == 11 ? Xe : u) : u = 10, u = u + 1 | 0) : u = 2147483631, Of(ar, u), u = e[Te + 4 >> 2], m && bf(u, fr, m), N && bf(u + m | 0, W, N), Xe = m + p | 0, W = A - Xe | 0, (A | 0) != (Xe | 0) && bf((u + m | 0) + N | 0, (m + fr | 0) + p | 0, W), (s | 0) != 10 && Br(fr), e[r >> 2] = u, e[r + 8 >> 2] = e[Te + 8 >> 2] | -2147483648, s = r, r = W + (m + N | 0) | 0, e[s + 4 >> 2] = r, _[r + u | 0] = 0, Jr = Te + 16 | 0;
                  return;
                }
                Ra(), Oi();
              }
              function Yu(r, s, u, A, m, p) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0, m = m | 0, p = p | 0;
                var N = 0, W = 0, Te = 0, Xe = 0;
                Te = Jr - 16 | 0, Jr = Te;
                e: {
                  t: {
                    if (!r || (N = e[m + 12 >> 2], W = u - s | 0, (W | 0) > 0 && (W = W >>> 2 | 0, (xi[e[e[r >> 2] + 48 >> 2]](r, s, W) | 0) != (W | 0))))
                      break t;
                    if (s = A - s >> 2, N = (s | 0) < (N | 0) ? N - s | 0 : 0, (N | 0) > 0) {
                      if (s = Wh(Te + 4 | 0, N, p), p = (me[s + 11 | 0] & 128) >>> 7 | 0 ? e[s >> 2] : s, e[5996] = 0, p = xn(217, r | 0, p | 0, N | 0) | 0, W = e[5996], e[5996] = 0, (W | 0) == 1)
                        break e;
                      if (Qn(s), (p | 0) != (N | 0))
                        break t;
                    }
                    if (s = A - u | 0, (s | 0) > 0 && (s = s >>> 2 | 0, (xi[e[e[r >> 2] + 48 >> 2]](r, u, s) | 0) != (s | 0)))
                      break t;
                    e[m + 12 >> 2] = 0, Xe = r;
                  }
                  return Jr = Te + 16 | 0, Xe | 0;
                }
                r = Hr() | 0, Qn(s), Jn(r | 0), Oi();
              }
              function qh(r, s, u, A, m) {
                if (r = r | 0, s = s | 0, u = u | 0, A = A | 0, m = m | 0, eu(r, e[s + 8 >> 2], m)) {
                  e[s + 28 >> 2] == 1 | e[s + 4 >> 2] != (u | 0) || (e[s + 28 >> 2] = A);
                  return;
                }
                e: {
                  if (eu(r, e[s >> 2], m)) {
                    if (!(e[s + 16 >> 2] != (u | 0) & e[s + 20 >> 2] != (u | 0))) {
                      if ((A | 0) != 1)
                        break e;
                      e[s + 32 >> 2] = 1;
                      return;
                    }
                    e[s + 32 >> 2] = A;
                    t: {
                      if (e[s + 44 >> 2] == 4)
                        break t;
                      if (Zs[s + 52 >> 1] = 0, r = e[r + 8 >> 2], xi[e[e[r >> 2] + 20 >> 2]](r, s, u, u, 1, m), me[s + 53 | 0]) {
                        if (e[s + 44 >> 2] = 3, !me[s + 52 | 0])
                          break t;
                        break e;
                      }
                      e[s + 44 >> 2] = 4;
                    }
                    if (e[s + 20 >> 2] = u, e[s + 40 >> 2] = e[s + 40 >> 2] + 1, e[s + 36 >> 2] != 1 | e[s + 24 >> 2] != 2)
                      break e;
                    _[s + 54 | 0] = 1;
                    return;
                  }
                  r = e[r + 8 >> 2], xi[e[e[r >> 2] + 24 >> 2]](r, s, u, A, m);
                }
              }
              function Wo(r) {
                var s = 0, u = 0, A = 0, m = 0;
                if (m = Jr - 16 | 0, Jr = m, s = m + 4 | 0, e[s + 4 >> 2] = 190, e[s >> 2] = r, e[s + 8 >> 2] = 0, A = Jr - 16 | 0, Jr = A, e[r >> 2] != -1)
                  e: {
                    for (u = A + 12 | 0, e[u >> 2] = s, s = A + 8 | 0, e[s >> 2] = u; u = e[r >> 2], (u | 0) == 1; )
                      ;
                    t: {
                      if (!u) {
                        if (e[r >> 2] = 1, s = e[e[s >> 2] >> 2], e[5996] = 0, qo(191, s | 0), s = e[5996], e[5996] = 0, (s | 0) == 1)
                          break t;
                        e[r >> 2] = -1;
                      }
                      break e;
                    }
                    Cu(Os(0) | 0) | 0, e[r >> 2] = 0, e[5996] = 0, Nn(192), r = e[5996], e[5996] = 0;
                    t: {
                      if ((r | 0) == 1) {
                        if (r = Hr() | 0, e[5996] = 0, Nn(110), s = e[5996], e[5996] = 0, (s | 0) != 1)
                          break t;
                        Os(0) | 0, Na();
                      }
                      Oi();
                    }
                    Jn(r | 0), Oi();
                  }
                return Jr = A + 16 | 0, Jr = m + 16 | 0, e[r + 4 >> 2] - 1 | 0;
              }
              function Oh(r, s, u, A, m, p, N) {
                for (r = r | 0, s = s | 0, u = u | 0, A = A | 0, m = m | 0, p = p | 0, N = N | 0, u = Jr - 128 | 0, Jr = u, e[u + 12 >> 2] = u + 116, A = e[r + 8 >> 2], r = u + 16 | 0, Wp(A, r, u + 12 | 0, m, p, N), m = Jr - 16 | 0, Jr = m, N = Jr - 32 | 0, Jr = N, A = Jr - 16 | 0, Jr = A, e[A + 12 >> 2] = e[u + 12 >> 2], e[N + 24 >> 2] = r, e[N + 28 >> 2] = e[A + 12 >> 2], Jr = A + 16 | 0, p = e[N + 24 >> 2], r = e[N + 28 >> 2], A = Jr - 16 | 0, Jr = A, e[A + 12 >> 2] = s; ; ) {
                  if ((r | 0) != (p | 0)) {
                    C1(A + 12 | 0, _[p | 0]), p = p + 1 | 0;
                    continue;
                  }
                  break;
                }
                return e[N + 16 >> 2] = r, e[N + 20 >> 2] = e[A + 12 >> 2], Jr = A + 16 | 0, r = e[N + 16 >> 2], e[N + 12 >> 2] = e[N + 20 >> 2], e[m + 8 >> 2] = r, e[m + 12 >> 2] = e[N + 12 >> 2], Jr = N + 32 | 0, Jr = m + 16 | 0, Jr = u + 128 | 0, e[m + 12 >> 2];
              }
              function Qh(r, s, u, A) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0;
                var m = 0, p = 0;
                e[r + 8 >> 2] = 0, e[r >> 2] = 0, e[r + 4 >> 2] = 0, e[5996] = 0, m = Mi(3, 24) | 0, p = e[5996], e[5996] = 0;
                e: {
                  if ((p | 0) != 1) {
                    if (e[r + 4 >> 2] = m, e[r >> 2] = m, p = m + 24 | 0, e[r + 8 >> 2] = p, e[m >> 2] = e[s >> 2], e[m + 4 >> 2] = e[s + 4 >> 2], e[s >> 2] = 0, e[s + 4 >> 2] = 0, e[r + 4 >> 2] = m + 8, e[m + 8 >> 2] = e[u >> 2], e[m + 12 >> 2] = e[u + 4 >> 2], e[u >> 2] = 0, e[u + 4 >> 2] = 0, s = m + 16 | 0, e[r + 4 >> 2] = s, s >>> 0 < p >>> 0) {
                      e[s >> 2] = e[A >> 2], e[s + 4 >> 2] = e[A + 4 >> 2], e[A >> 2] = 0, e[A + 4 >> 2] = 0, e[r + 4 >> 2] = s + 8;
                      break e;
                    }
                    if (e[5996] = 0, ji(162, r | 0, A | 0), s = e[5996], e[5996] = 0, (s | 0) != 1)
                      break e;
                  }
                  s = Hr() | 0, Uo(r), Jn(s | 0), Oi();
                }
              }
              function cp(r, s, u) {
                r = r | 0, s = s | 0, u = u | 0;
                var A = 0, m = 0, p = 0;
                if (A = Jr - 16 | 0, Jr = A, e[r >> 2] = 7e3, e[r + 4 >> 2] = 0, e[r + 8 >> 2] = 0, e[A + 4 >> 2] = e[u >> 2], e[A + 8 >> 2] = e[u + 4 >> 2], e[A + 12 >> 2] = e[u + 8 >> 2], e[u + 8 >> 2] = 0, e[u >> 2] = 0, e[u + 4 >> 2] = 0, e[5996] = 0, wa(64, r + 12 | 0, s | 0, A + 4 | 0, 0) | 0, s = e[5996], e[5996] = 0, (s | 0) != 1) {
                  if (s = e[A + 4 >> 2], s) {
                    if (u = e[A + 8 >> 2], (s | 0) != (u | 0)) {
                      for (; ; ) {
                        u = u - 8 | 0, m = e[u + 4 >> 2];
                        e: {
                          if (!m || (p = e[m + 4 >> 2], e[m + 4 >> 2] = p - 1, p))
                            break e;
                          xi[e[e[m >> 2] + 8 >> 2]](m), ys(m);
                        }
                        if ((s | 0) == (u | 0))
                          break;
                      }
                      s = e[A + 4 >> 2];
                    }
                    Br(s);
                  }
                  return Jr = A + 16 | 0, r | 0;
                }
                r = Hr() | 0, Uo(A + 4 | 0), Jn(r | 0), Oi();
              }
              function Nu(r, s) {
                var u = 0, A = 0, m = 0, p = 0, N = 0, W = 0, Te = 0;
                m = Jr - 16 | 0, Jr = m, Ca(+s), N = _s(1) | 0, u = _s(0) | 0, A = N & 2147483647, p = A + -1048576 | 0;
                e: {
                  if ((p | 0) == 2145386495 | p >>> 0 < 2145386495) {
                    W = u << 28, u = (A & 15) << 28 | u >>> 4, A = (A >>> 4 | 0) + 1006632960 | 0;
                    break e;
                  }
                  if ((A | 0) == 2146435072 | A >>> 0 > 2146435072) {
                    W = u << 28, u = (N & 15) << 28 | u >>> 4, A = N >>> 4 | 2147418112;
                    break e;
                  }
                  if (!(u | A)) {
                    u = 0, A = 0;
                    break e;
                  }
                  p = u, u = A ? Fo(A) : Fo(u) + 32 | 0, Ea(m, p, A, 0, 0, u + 49 | 0), Te = e[m >> 2], W = e[m + 4 >> 2], p = 15372 - u << 16, u = e[m + 8 >> 2], A = p | e[m + 12 >> 2] ^ 65536;
                }
                e[r >> 2] = Te, e[r + 4 >> 2] = W, e[r + 8 >> 2] = u, e[r + 12 >> 2] = N & -2147483648 | A, Jr = m + 16 | 0;
              }
              function lp(r) {
                r = r | 0;
                var s = 0, u = 0, A = 0, m = 0;
                if (u = e[r + 76 >> 2], (u | 0) == -1) {
                  u = r, A = Jr - 16 | 0, Jr = A, r = e[r + 28 >> 2], e[A + 12 >> 2] = r, e[r + 4 >> 2] = e[r + 4 >> 2] + 1, e[5996] = 0, r = Mi(170, e[A + 12 >> 2]) | 0, s = e[5996], e[5996] = 0;
                  e: {
                    t: {
                      if ((s | 0) == 1 || (e[5996] = 0, r = pi(171, r | 0, 32) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1))
                        break t;
                      s = e[A + 12 >> 2], m = e[s + 4 >> 2] - 1 | 0, e[s + 4 >> 2] = m, (m | 0) == -1 && xi[e[e[s >> 2] + 8 >> 2]](s), Jr = A + 16 | 0;
                      break e;
                    }
                    s = Hr() | 0, r = e[A + 12 >> 2], u = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = u, (u | 0) == -1 && xi[e[e[r >> 2] + 8 >> 2]](r), Jn(s | 0), Oi();
                  }
                  s = u, u = r, e[s + 76 >> 2] = r;
                }
                return u << 24 >> 24;
              }
              function Uh(r, s) {
                r = r | 0, s = s | 0;
                var u = 0, A = 0, m = 0, p = 0, N = 0, W = 0;
                if (u = e[r + 4 >> 2], A = e[r + 8 >> 2], u >>> 0 < A >>> 0) {
                  e[u >> 2] = s, e[r + 4 >> 2] = u + 4;
                  return;
                }
                e: {
                  if (N = e[r >> 2], m = u - N >> 2, p = m + 1 | 0, p >>> 0 < 1073741824) {
                    if (W = m << 2, A = A - N | 0, m = A >> 1, m = A >>> 0 >= 2147483644 ? 1073741823 : m >>> 0 > p >>> 0 ? m : p, m) {
                      if (m >>> 0 >= 1073741824)
                        break e;
                      p = Qs(m << 2);
                    } else
                      p = 0;
                    if (A = W + p | 0, e[A >> 2] = s, s = A + 4 | 0, (u | 0) != (N | 0)) {
                      for (; A = A - 4 | 0, u = u - 4 | 0, e[A >> 2] = e[u >> 2], (u | 0) != (N | 0); )
                        ;
                      u = e[r >> 2];
                    }
                    e[r + 8 >> 2] = p + (m << 2), e[r + 4 >> 2] = s, e[r >> 2] = A, u && Br(u);
                    return;
                  }
                  Jo(), Oi();
                }
                hu(), Oi();
              }
              function Mh(r, s, u, A, m) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0, m = m | 0;
                var p = 0, N = 0;
                if (m = Jr - 16 | 0, Jr = m, p = Qs(104), e[p >> 2] = 7e3, e[p + 4 >> 2] = 0, e[p + 8 >> 2] = 0, e[m + 4 >> 2] = e[u >> 2], e[m + 8 >> 2] = e[u + 4 >> 2], e[m + 12 >> 2] = e[u + 8 >> 2], e[u + 8 >> 2] = 0, e[u >> 2] = 0, e[u + 4 >> 2] = 0, e[5996] = 0, N = wa(163, p + 12 | 0, s | 0, m + 4 | 0, A | 0) | 0, s = e[5996], e[5996] = 0, (s | 0) != 1) {
                  if (A = e[m + 4 >> 2], A) {
                    if (s = e[m + 8 >> 2], (A | 0) != (s | 0))
                      for (; u = s - 12 | 0, _[s - 1 | 0] < 0 && Br(e[u >> 2]), s = u, (u | 0) != (A | 0); )
                        ;
                    Br(A);
                  }
                  e[r + 4 >> 2] = p, e[r >> 2] = N, Jr = m + 16 | 0;
                  return;
                }
                r = Hr() | 0, ea(m + 4 | 0), Br(p), Jn(r | 0), Oi();
              }
              function Ed(r, s, u, A) {
                var m = 0, p = 0, N = 0;
                m = Jr - 16 | 0, Jr = m;
                e: {
                  t: {
                    if ((r | 0) != (s | 0))
                      r: {
                        N = e[5732], e[5732] = 0, ko(), r = h6(r, m + 12 | 0, A), A = Ds;
                        i: {
                          if (p = e[5732], p) {
                            if (e[m + 12 >> 2] != (s | 0))
                              break r;
                            if ((p | 0) != 68)
                              break i;
                            if (e[u >> 2] = 4, s = 2147483647, !!r & (A | 0) >= 0 | (A | 0) > 0)
                              break e;
                            break t;
                          }
                          if (e[5732] = N, e[m + 12 >> 2] == (s | 0))
                            break i;
                          break r;
                        }
                        if ((A | 0) < 0 & r >>> 0 <= 2147483647 | (A | 0) < -1) {
                          e[u >> 2] = 4;
                          break t;
                        }
                        if ((A | 0) >= 0 & r >>> 0 >= 2147483648 | (A | 0) > 0) {
                          e[u >> 2] = 4, s = 2147483647;
                          break e;
                        }
                        s = r;
                        break e;
                      }
                    e[u >> 2] = 4, s = 0;
                    break e;
                  }
                  s = -2147483648;
                }
                return Jr = m + 16 | 0, s;
              }
              function Tf(r, s, u, A, m, p) {
                var N = 0, W = 0, Te = 0, Xe = 0;
                e: {
                  if (p & 64) {
                    u = p + -64 | 0, s = u & 31, (u & 63) >>> 0 >= 32 ? (u = 0, s = m >>> s | 0) : (u = m >>> s | 0, s = ((1 << s) - 1 & m) << 32 - s | A >>> s), A = 0, m = 0;
                    break e;
                  }
                  if (!p)
                    break e;
                  Te = A, W = 64 - p | 0, N = W & 31, (W & 63) >>> 0 >= 32 ? (W = A << N, Xe = 0) : (W = (1 << N) - 1 & Te >>> 32 - N | m << N, Xe = Te << N), Te = s, s = p & 31, (p & 63) >>> 0 >= 32 ? (N = 0, s = u >>> s | 0) : (N = u >>> s | 0, s = ((1 << s) - 1 & u) << 32 - s | Te >>> s), s = Xe | s, u = N | W, N = A, A = p & 31, (p & 63) >>> 0 >= 32 ? (W = 0, A = m >>> A | 0) : (W = m >>> A | 0, A = ((1 << A) - 1 & m) << 32 - A | N >>> A), m = W;
                }
                e[r >> 2] = s, e[r + 4 >> 2] = u, e[r + 8 >> 2] = A, e[r + 12 >> 2] = m;
              }
              function Rc(r, s, u) {
                var A = 0, m = 0, p = 0;
                A = Jr - 16 | 0, Jr = A, e[A + 12 >> 2] = s, e[s + 4 >> 2] = e[s + 4 >> 2] + 1, e[5996] = 0, s = Mi(198, e[A + 12 >> 2]) | 0, m = e[5996], e[5996] = 0;
                e: {
                  if ((m | 0) == 1 || (e[5996] = 0, m = Mi(206, s | 0) | 0, p = e[5996], e[5996] = 0, (p | 0) == 1) || (e[u >> 2] = m, e[5996] = 0, ji(207, r | 0, s | 0), r = e[5996], e[5996] = 0, (r | 0) == 1))
                    break e;
                  r = e[A + 12 >> 2], s = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = s, (s | 0) == -1 && xi[e[e[r >> 2] + 8 >> 2]](r), Jr = A + 16 | 0;
                  return;
                }
                u = Hr() | 0, r = e[A + 12 >> 2], s = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = s, (s | 0) == -1 && xi[e[e[r >> 2] + 8 >> 2]](r), Jn(u | 0), Oi();
              }
              function xc(r, s, u) {
                var A = 0, m = 0, p = 0;
                A = Jr - 16 | 0, Jr = A, e[A + 12 >> 2] = s, e[s + 4 >> 2] = e[s + 4 >> 2] + 1, e[5996] = 0, s = Mi(180, e[A + 12 >> 2]) | 0, m = e[5996], e[5996] = 0;
                e: {
                  if ((m | 0) == 1 || (e[5996] = 0, m = Mi(193, s | 0) | 0, p = e[5996], e[5996] = 0, (p | 0) == 1) || (_[u | 0] = m, e[5996] = 0, ji(194, r | 0, s | 0), r = e[5996], e[5996] = 0, (r | 0) == 1))
                    break e;
                  r = e[A + 12 >> 2], s = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = s, (s | 0) == -1 && xi[e[e[r >> 2] + 8 >> 2]](r), Jr = A + 16 | 0;
                  return;
                }
                u = Hr() | 0, r = e[A + 12 >> 2], s = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = s, (s | 0) == -1 && xi[e[e[r >> 2] + 8 >> 2]](r), Jn(u | 0), Oi();
              }
              function Fh(r) {
                return me[25148] ? e[6286] : (me[26240] || (_[26240] = 1), So(25952, 18680), So(25964, 18712), So(25976, 18748), So(25988, 18772), So(26e3, 18796), So(26012, 18812), So(26024, 18832), So(26036, 18852), So(26048, 18880), So(26060, 18920), So(26072, 18952), So(26084, 18988), So(26096, 19024), So(26108, 19040), So(26120, 19056), So(26132, 19072), So(26144, 18796), So(26156, 19088), So(26168, 19104), So(26180, 19120), So(26192, 19136), So(26204, 19152), So(26216, 19168), So(26228, 19184), _[25148] = 1, e[6286] = 25952, 25952);
              }
              function bd(r, s, u) {
                r = r | 0, s = s | 0, u = u | 0;
                var A = 0, m = 0, p = 0, N = 0, W = 0;
                p = Fa(u);
                e: {
                  if (A = me[r + 11 | 0], m = A & 127, A = (A & 128) >>> 7 | 0, m = A ? e[r + 4 >> 2] : m, m >>> 0 >= s >>> 0) {
                    if (A = A ? (e[r + 8 >> 2] & 2147483647) - 1 | 0 : 10, A - m >>> 0 >= p >>> 0) {
                      if (!p)
                        break e;
                      A = (me[r + 11 | 0] & 128) >>> 7 | 0 ? e[r >> 2] : r, W = A + s | 0, (s | 0) != (m | 0) && (N = s + A | 0, fc(N + p | 0, N, m - s | 0), u = (u >>> 0 >= N >>> 0 && A + m >>> 0 > u >>> 0 ? p : 0) + u | 0), fc(W, u, p), s = p + m | 0;
                      t: {
                        if ((me[r + 11 | 0] & 128) >>> 7 | 0) {
                          e[r + 4 >> 2] = s;
                          break t;
                        }
                        _[r + 11 | 0] = s;
                      }
                      _[s + A | 0] = 0;
                      break e;
                    }
                    Gf(r, A, (p + m | 0) - A | 0, m, s, 0, p, u);
                    break e;
                  }
                  gf(), Oi();
                }
                return r | 0;
              }
              function dp(r, s) {
                r = r | 0, s = s | 0;
                var u = 0, A = 0, m = 0, p = 0, N = 0, W = 0;
                if (m = e[r + 4 >> 2], (m | 0) != e[r + 8 >> 2]) {
                  e[m >> 2] = s, e[r + 4 >> 2] = m + 4;
                  return;
                }
                e: {
                  if (N = e[r >> 2], p = m - N | 0, u = p >> 2, A = u + 1 | 0, A >>> 0 < 1073741824) {
                    if (W = u << 2, u = p >> 1, u = p >>> 0 >= 2147483644 ? 1073741823 : u >>> 0 > A >>> 0 ? u : A, u) {
                      if (u >>> 0 >= 1073741824)
                        break e;
                      p = Qs(u << 2);
                    } else
                      p = 0;
                    if (A = W + p | 0, e[A >> 2] = s, s = A + 4 | 0, (m | 0) != (N | 0))
                      for (; A = A - 4 | 0, m = m - 4 | 0, e[A >> 2] = e[m >> 2], (m | 0) != (N | 0); )
                        ;
                    e[r + 8 >> 2] = p + (u << 2), e[r + 4 >> 2] = s, e[r >> 2] = A, N && Br(N);
                    return;
                  }
                  Jo(), Oi();
                }
                hu(), Oi();
              }
              function Ea(r, s, u, A, m, p) {
                var N = 0, W = 0, Te = 0;
                e: {
                  if (p & 64) {
                    m = p + -64 | 0, p = s, A = m & 31, (m & 63) >>> 0 >= 32 ? (m = p << A, A = 0) : (m = (1 << A) - 1 & p >>> 32 - A | u << A, A = p << A), s = 0, u = 0;
                    break e;
                  }
                  if (!p)
                    break e;
                  W = A, N = p & 31, (p & 63) >>> 0 >= 32 ? (Te = A << N, W = 0) : (Te = (1 << N) - 1 & W >>> 32 - N | m << N, W = W << N), N = s, m = 64 - p | 0, A = m & 31, (m & 63) >>> 0 >= 32 ? (m = 0, A = u >>> A | 0) : (m = u >>> A | 0, A = ((1 << A) - 1 & u) << 32 - A | N >>> A), A = W | A, m = m | Te, W = s, N = p & 31, (p & 63) >>> 0 >= 32 ? (Te = s << N, s = 0) : (Te = (1 << N) - 1 & W >>> 32 - N | u << N, s = W << N), u = Te;
                }
                e[r >> 2] = s, e[r + 4 >> 2] = u, e[r + 8 >> 2] = A, e[r + 12 >> 2] = m;
              }
              function Lh(r) {
                r = r | 0;
                var s = 0, u = 0, A = 0, m = 0;
                if (m = e[r + 44 >> 2], m) {
                  if (s = m, A = e[r + 48 >> 2], (s | 0) != (A | 0)) {
                    for (; ; ) {
                      A = A - 8 | 0, u = e[A + 4 >> 2];
                      e: {
                        if (!u || (s = e[u + 4 >> 2], e[u + 4 >> 2] = s - 1, s))
                          break e;
                        xi[e[e[u >> 2] + 8 >> 2]](u), ys(u);
                      }
                      if ((A | 0) == (m | 0))
                        break;
                    }
                    s = e[r + 44 >> 2];
                  }
                  e[r + 48 >> 2] = m, Br(s);
                }
                if (s = e[r + 32 >> 2], s && (e[r + 36 >> 2] = s, Br(s)), u = e[r + 20 >> 2], u) {
                  if (A = u, s = e[r + 24 >> 2], (u | 0) != (s | 0)) {
                    for (; m = s - 12 | 0, _[s - 1 | 0] < 0 && Br(e[m >> 2]), s = m, (u | 0) != (s | 0); )
                      ;
                    A = e[r + 20 >> 2];
                  }
                  e[r + 24 >> 2] = u, Br(A);
                }
              }
              function hp(r, s, u, A) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0;
                var m = 0, p = 0;
                m = Jr - 16 | 0, Jr = m, e[m >> 2] = u, e[m + 4 >> 2] = A, e[m + 8 >> 2] = u, e[m + 12 >> 2] = A, u = Jr - 32 | 0, Jr = u, s = Za(u + 8 | 0, s), e[5996] = 0, A = u + 20 | 0, gs(174, A | 0, m | 0, s | 0), p = e[5996], e[5996] = 0;
                e: {
                  t: {
                    r: {
                      if ((p | 0) != 1) {
                        if (e[5996] = 0, r = pi(175, r | 0, A | 0) | 0, p = e[5996], e[5996] = 0, (p | 0) == 1)
                          break r;
                        Qn(A), Qn(s), e[r >> 2] = 21872, s = e[m + 4 >> 2], e[r + 8 >> 2] = e[m >> 2], e[r + 12 >> 2] = s, Jr = u + 32 | 0;
                        break e;
                      }
                      r = Hr() | 0;
                      break t;
                    }
                    r = Hr() | 0, Qn(u + 20 | 0);
                  }
                  Qn(s), Jn(r | 0), Oi();
                }
                return e[r >> 2] = 8492, Jr = m + 16 | 0, r | 0;
              }
              function Ap(r) {
                return me[25140] ? e[6284] : (me[25936] || (_[25936] = 1), wo(25648, 1065), wo(25660, 1056), wo(25672, 2204), wo(25684, 2058), wo(25696, 1135), wo(25708, 2381), wo(25720, 1073), wo(25732, 1297), wo(25744, 1802), wo(25756, 1785), wo(25768, 1793), wo(25780, 1812), wo(25792, 2024), wo(25804, 2543), wo(25816, 1837), wo(25828, 1683), wo(25840, 1135), wo(25852, 1965), wo(25864, 2051), wo(25876, 2280), wo(25888, 1924), wo(25900, 1386), wo(25912, 1263), wo(25924, 2539), _[25140] = 1, e[6284] = 25648, 25648);
              }
              function Hh(r, s, u, A, m) {
                var p = 0, N = 0, W = 0, Te = 0;
                if (p = Jr - 16 | 0, Jr = p, 1073741807 - s >>> 0 >= u >>> 0) {
                  W = (me[r + 11 | 0] & 128) >>> 7 | 0 ? e[r >> 2] : r, N = p + 4 | 0, Te = N, s >>> 0 <= 536870886 ? (e[p + 12 >> 2] = s << 1, e[p + 4 >> 2] = s + u, u = e[(Ls[N >> 2] < Ls[p + 12 >> 2] ? p + 12 | 0 : N) >> 2], u >>> 0 >= 2 ? (N = u + 4 & -4, u = N - 1 | 0, u = (u | 0) == 2 ? N : u) : u = 1, u = u + 1 | 0) : u = 1073741807, Ol(Te, u), u = e[p + 4 >> 2], m && yf(u, W, m), (A | 0) != (m | 0) && (N = m << 2, yf(N + u | 0, N + W | 0, A - m | 0)), (s | 0) != 1 && Br(W), e[r >> 2] = u, e[r + 8 >> 2] = e[p + 8 >> 2] | -2147483648, Jr = p + 16 | 0;
                  return;
                }
                Ra(), Oi();
              }
              function Al(r, s, u, A, m) {
                var p = 0, N = 0, W = 0, Te = 0;
                if (p = Jr - 16 | 0, Jr = p, 2147483631 - s >>> 0 >= u >>> 0) {
                  W = (me[r + 11 | 0] & 128) >>> 7 | 0 ? e[r >> 2] : r, N = p + 4 | 0, Te = N, s >>> 0 <= 1073741798 ? (e[p + 12 >> 2] = s << 1, e[p + 4 >> 2] = s + u, u = e[(Ls[N >> 2] < Ls[p + 12 >> 2] ? p + 12 | 0 : N) >> 2], u >>> 0 >= 11 ? (N = u + 16 & -16, u = N - 1 | 0, u = (u | 0) == 11 ? N : u) : u = 10, u = u + 1 | 0) : u = 2147483631, Of(Te, u), u = e[p + 4 >> 2], m && bf(u, W, m), (A | 0) != (m | 0) && bf(u + m | 0, m + W | 0, A - m | 0), (s | 0) != 10 && Br(W), e[r >> 2] = u, e[r + 8 >> 2] = e[p + 8 >> 2] | -2147483648, Jr = p + 16 | 0;
                  return;
                }
                Ra(), Oi();
              }
              function gp(r, s, u) {
                r = r | 0, s = s | 0, u = u | 0;
                var A = 0, m = 0, p = 0, N = 0, W = 0;
                for (m = Jr - 16 | 0, Jr = m; ; ) {
                  e: {
                    if ((u | 0) <= (p | 0))
                      break e;
                    N = e[r + 16 >> 2], A = e[r + 12 >> 2];
                    t: {
                      if (N >>> 0 > A >>> 0) {
                        e[m + 12 >> 2] = 2147483647, e[m + 8 >> 2] = N - A, e[m + 4 >> 2] = u - p, W = s, N = A, s = m + 4 | 0, A = m + 8 | 0, s = e[s >> 2] < e[A >> 2] ? s : A, A = m + 12 | 0, A = e[(e[s >> 2] < e[A >> 2] ? s : A) >> 2], s = bf(W, N, A), e[r + 12 >> 2] = e[r + 12 >> 2] + A, s = s + A | 0;
                        break t;
                      }
                      if (A = xi[e[e[r >> 2] + 40 >> 2]](r) | 0, (A | 0) == -1)
                        break e;
                      _[s | 0] = A << 24 >> 24, A = 1, s = s + 1 | 0;
                    }
                    p = A + p | 0;
                    continue;
                  }
                  break;
                }
                return Jr = m + 16 | 0, p | 0;
              }
              function Kh(r, s, u, A) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0;
                var m = 0, p = 0, N = 0;
                m = Qs(56);
                e: {
                  t: {
                    if ((u | 0) == (A | 0)) {
                      A = 0, u = 0;
                      break t;
                    }
                    if (p = A - u | 0, (p | 0) < 0) {
                      if (e[5996] = 0, Nn(8), r = e[5996], e[5996] = 0, (r | 0) == 1)
                        break e;
                      Oi();
                    }
                    if (e[5996] = 0, A = Mi(3, p | 0) | 0, N = e[5996], e[5996] = 0, (N | 0) == 1)
                      break e;
                    u = so(A, u, p) + p | 0;
                  }
                  return e[m + 4 >> 2] = 0, e[m + 8 >> 2] = 0, e[m >> 2] = s, e[m + 40 >> 2] = 0, e[m + 44 >> 2] = 0, e[m + 28 >> 2] = A, e[m + 12 >> 2] = 0, e[m + 16 >> 2] = 0, e[m + 20 >> 2] = 0, e[m + 24 >> 2] = 0, e[m + 36 >> 2] = u, e[m + 32 >> 2] = u, of(r, m), m | 0;
                }
                r = Hr() | 0, Br(m), Jn(r | 0), Oi();
              }
              function lu(r, s, u) {
                var A = 0, m = 0;
                A = (u | 0) != 0;
                e: {
                  t: {
                    r: {
                      if (!(r & 3) | !u)
                        break r;
                      for (m = s & 255; ; ) {
                        if ((m | 0) == me[r | 0])
                          break t;
                        if (u = u - 1 | 0, A = (u | 0) != 0, r = r + 1 | 0, !(r & 3))
                          break r;
                        if (!u)
                          break;
                      }
                    }
                    if (!A)
                      break e;
                    if (A = s & 255, !((A | 0) == me[r | 0] | u >>> 0 < 4))
                      for (A = Sn(A, 16843009); ; ) {
                        if (m = A ^ e[r >> 2], (m ^ -1) & m - 16843009 & -2139062144)
                          break t;
                        if (r = r + 4 | 0, u = u - 4 | 0, !(u >>> 0 > 3))
                          break;
                      }
                    if (!u)
                      break e;
                  }
                  for (s = s & 255; ; ) {
                    if ((s | 0) == me[r | 0])
                      return r;
                    if (r = r + 1 | 0, u = u - 1 | 0, !u)
                      break;
                  }
                }
                return 0;
              }
              function pp(r, s, u, A, m, p) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0, m = m | 0, p = p | 0;
                var N = 0;
                e: {
                  if (!((me[p + 11 | 0] & 128) >>> 7 | 0)) {
                    s = e[p + 4 >> 2], e[r >> 2] = e[p >> 2], e[r + 4 >> 2] = s, e[r + 8 >> 2] = e[p + 8 >> 2];
                    break e;
                  }
                  m = e[p >> 2], A = Jr - 16 | 0, Jr = A;
                  t: {
                    r: {
                      u = e[p + 4 >> 2];
                      i: {
                        if (u >>> 0 < 2) {
                          _[r + 11 | 0] = u;
                          break i;
                        }
                        if (u >>> 0 >= 1073741808)
                          break r;
                        N = A + 8 | 0, u >>> 0 >= 2 ? (p = u + 4 & -4, s = p - 1 | 0, s = (s | 0) == 2 ? p : s) : s = 1, Ol(N, s + 1 | 0), s = e[A + 8 >> 2], e[r >> 2] = s, e[r + 8 >> 2] = e[A + 12 >> 2] | -2147483648, e[r + 4 >> 2] = u, r = s;
                      }
                      yf(r, m, u + 1 | 0), Jr = A + 16 | 0;
                      break t;
                    }
                    Ra(), Oi();
                  }
                }
              }
              function gl(r) {
                var s = 0, u = 0;
                e: {
                  s = e[r + 4 >> 2], s = e[e[s >> 2] - 12 >> 2] + s | 0;
                  t: {
                    if (!e[s + 24 >> 2] | e[s + 16 >> 2] | !(me[s + 5 | 0] & 32) || (L1() | 0) > 0 || (s = e[r + 4 >> 2], s = e[(e[e[s >> 2] - 12 >> 2] + s | 0) + 24 >> 2], e[5996] = 0, s = Mi(169, s | 0) | 0, u = e[5996], e[5996] = 0, (u | 0) != 1 && ((s | 0) != -1 || (r = e[r + 4 >> 2], s = e[e[r >> 2] - 12 >> 2], e[5996] = 0, ji(138, r + s | 0, 1), r = e[5996], e[5996] = 0, (r | 0) != 1))))
                      break t;
                    if (Cu(Os(0) | 0) | 0, e[5996] = 0, Nn(110), r = e[5996], e[5996] = 0, (r | 0) == 1)
                      break e;
                  }
                  return;
                }
                Os(0) | 0, Na(), Oi();
              }
              function Vh(r, s, u, A) {
                var m = 0, p = 0, N = 0, W = 0;
                m = Jr - 16 | 0, Jr = m;
                e: {
                  t: {
                    if ((r | 0) != (s | 0))
                      r: {
                        i: {
                          if (p = me[r | 0], (p | 0) != 45 || (r = r + 1 | 0, (s | 0) != (r | 0)))
                            break i;
                          break r;
                        }
                        W = e[5732], e[5732] = 0, ko(), r = k4(r, m + 12 | 0, A), A = Ds, N = e[5732];
                        i: {
                          if (N) {
                            if (e[m + 12 >> 2] != (s | 0))
                              break r;
                            if (!A & r >>> 0 > 65535 | A | (N | 0) == 68)
                              break i;
                            break t;
                          }
                          if (e[5732] = W, e[m + 12 >> 2] != (s | 0))
                            break r;
                          if (!A & r >>> 0 < 65536)
                            break t;
                        }
                        e[u >> 2] = 4, r = 65535;
                        break e;
                      }
                    e[u >> 2] = 4, r = 0;
                    break e;
                  }
                  r = (p | 0) == 45 ? 0 - r | 0 : r;
                }
                return Jr = m + 16 | 0, r & 65535;
              }
              function Bd(r, s) {
                var u = 0, A = 0, m = 0, p = 0, N = 0, W = 0;
                m = Jr - 16 | 0, Jr = m, A = me[r + 11 | 0], u = A << 24 >> 24, u = (u | 0) < 0, A = u ? e[r + 4 >> 2] : A;
                e: {
                  if (!A || (u = u ? e[r >> 2] : r, N = me[u | 0], p = N - 9 & 255, p >>> 0 < 24 & (8388639 >>> p & 1)) || (p = me[(u + A | 0) - 1 | 0] - 9 | 0, (p & 255) >>> 0 < 24 & (8388639 >>> p & 1)) || (N | 0) == 45 | (Fa(u) | 0) != (A | 0) || (e[m + 12 >> 2] = 0, e[5732] = 0, r = f6(_[r + 11 | 0] < 0 ? e[r >> 2] : r, m + 12 | 0, 10), u = Ds, s && (e[s >> 2] = r, e[s + 4 >> 2] = u), r = e[m + 12 >> 2], !r | me[r | 0]))
                    break e;
                  W = !e[5732];
                }
                return Jr = m + 16 | 0, W;
              }
              function af(r, s, u, A) {
                var m = 0, p = 0, N = 0, W = 0;
                m = Jr - 16 | 0, Jr = m;
                e: {
                  if ((r | 0) != (s | 0))
                    t: {
                      r: {
                        if (p = me[r | 0], (p | 0) != 45 || (r = r + 1 | 0, (s | 0) != (r | 0)))
                          break r;
                        break t;
                      }
                      W = e[5732], e[5732] = 0, ko(), r = k4(r, m + 12 | 0, A), A = Ds;
                      r: {
                        if (N = e[5732], N) {
                          if (e[m + 12 >> 2] != (s | 0))
                            break t;
                          if ((N | 0) != 68)
                            break r;
                          e[u >> 2] = 4, r = -1, s = -1;
                          break e;
                        }
                        if (e[5732] = W, e[m + 12 >> 2] == (s | 0))
                          break r;
                        break t;
                      }
                      s = r, u = (p | 0) == 45, r = u ? 0 - s | 0 : s, s = u ? 0 - (A + ((s | 0) != 0) | 0) | 0 : A;
                      break e;
                    }
                  e[u >> 2] = 4, r = 0, s = 0;
                }
                return Jr = m + 16 | 0, Ds = s, r;
              }
              function yp(r, s, u) {
                r = r | 0, s = s | 0, u = u | 0;
                var A = 0, m = 0;
                if (A = Jr - 16 | 0, Jr = A, e[r >> 2] = 7e3, e[r + 4 >> 2] = 0, e[r + 8 >> 2] = 0, e[A + 4 >> 2] = e[u >> 2], e[A + 8 >> 2] = e[u + 4 >> 2], e[A + 12 >> 2] = e[u + 8 >> 2], e[u + 8 >> 2] = 0, e[u >> 2] = 0, e[u + 4 >> 2] = 0, e[5996] = 0, wa(163, r + 12 | 0, s | 0, A + 4 | 0, 0) | 0, s = e[5996], e[5996] = 0, (s | 0) != 1) {
                  if (m = e[A + 4 >> 2], m) {
                    if (s = e[A + 8 >> 2], (m | 0) != (s | 0))
                      for (; u = s - 12 | 0, _[s - 1 | 0] < 0 && Br(e[u >> 2]), s = u, (u | 0) != (m | 0); )
                        ;
                    Br(m);
                  }
                  return Jr = A + 16 | 0, r | 0;
                }
                r = Hr() | 0, ea(A + 4 | 0), Jn(r | 0), Oi();
              }
              function Dc(r, s) {
                var u = 0, A = 0, m = 0, p = 0, N = 0;
                m = Jr - 16 | 0, Jr = m, A = me[r + 11 | 0], u = A << 24 >> 24, u = (u | 0) < 0, A = u ? e[r + 4 >> 2] : A;
                e: {
                  if (!A || (u = u ? e[r >> 2] : r, p = me[u | 0] - 9 & 255, p >>> 0 < 24 & (8388639 >>> p & 1)) || (p = me[(u + A | 0) - 1 | 0] - 9 | 0, (p & 255) >>> 0 < 24 & (8388639 >>> p & 1)) || (Fa(u) | 0) != (A | 0) || (e[m + 12 >> 2] = 0, e[5732] = 0, r = i6(_[r + 11 | 0] < 0 ? e[r >> 2] : r, m + 12 | 0, 10), u = Ds, s && (e[s >> 2] = r, e[s + 4 >> 2] = u), r = e[m + 12 >> 2], !r | me[r | 0]))
                    break e;
                  N = !e[5732];
                }
                return Jr = m + 16 | 0, N;
              }
              function jf(r, s) {
                var u = 0, A = 0;
                u = Jr - 16 | 0, Jr = u, e[u + 12 >> 2] = r, e[r + 4 >> 2] = e[r + 4 >> 2] + 1, e[5996] = 0, r = Mi(197, e[u + 12 >> 2]) | 0, A = e[5996], e[5996] = 0;
                e: {
                  t: {
                    if ((A | 0) == 1 || (e[5996] = 0, Vs(208, r | 0, 12416, 12442, s | 0), r = e[5996], e[5996] = 0, (r | 0) == 1))
                      break t;
                    r = e[u + 12 >> 2], A = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = A, (A | 0) == -1 && xi[e[e[r >> 2] + 8 >> 2]](r), Jr = u + 16 | 0;
                    break e;
                  }
                  A = Hr() | 0, r = e[u + 12 >> 2], s = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = s, (s | 0) == -1 && xi[e[e[r >> 2] + 8 >> 2]](r), Jn(A | 0), Oi();
                }
                return s;
              }
              function Ip(r, s, u, A, m, p) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0, m = m | 0, p = p | 0;
                var N = 0, W = 0;
                if (N = Jr - 16 | 0, Jr = N, e[N + 12 >> 2] = s, s = e[A + 28 >> 2], e[N + 8 >> 2] = s, e[s + 4 >> 2] = e[s + 4 >> 2] + 1, e[5996] = 0, W = Mi(170, e[N + 8 >> 2]) | 0, s = e[5996], e[5996] = 0, (s | 0) != 1)
                  return s = e[N + 8 >> 2], A = e[s + 4 >> 2] - 1 | 0, e[s + 4 >> 2] = A, (A | 0) == -1 && xi[e[e[s >> 2] + 8 >> 2]](s), y1(r, p + 24 | 0, N + 12 | 0, u, m, W), Jr = N + 16 | 0, e[N + 12 >> 2];
                u = Hr() | 0, r = e[N + 8 >> 2], s = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = s, (s | 0) == -1 && xi[e[e[r >> 2] + 8 >> 2]](r), Jn(u | 0), Oi();
              }
              function mp(r, s, u, A, m, p) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0, m = m | 0, p = p | 0;
                var N = 0, W = 0;
                if (N = Jr - 16 | 0, Jr = N, e[N + 12 >> 2] = s, s = e[A + 28 >> 2], e[N + 8 >> 2] = s, e[s + 4 >> 2] = e[s + 4 >> 2] + 1, e[5996] = 0, W = Mi(170, e[N + 8 >> 2]) | 0, s = e[5996], e[5996] = 0, (s | 0) != 1)
                  return s = e[N + 8 >> 2], A = e[s + 4 >> 2] - 1 | 0, e[s + 4 >> 2] = A, (A | 0) == -1 && xi[e[e[s >> 2] + 8 >> 2]](s), Hd(r, p + 16 | 0, N + 12 | 0, u, m, W), Jr = N + 16 | 0, e[N + 12 >> 2];
                u = Hr() | 0, r = e[N + 8 >> 2], s = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = s, (s | 0) == -1 && xi[e[e[r >> 2] + 8 >> 2]](r), Jn(u | 0), Oi();
              }
              function wp(r, s, u, A, m, p) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0, m = m | 0, p = p | 0;
                var N = 0, W = 0;
                if (N = Jr - 16 | 0, Jr = N, e[N + 12 >> 2] = s, s = e[A + 28 >> 2], e[N + 8 >> 2] = s, e[s + 4 >> 2] = e[s + 4 >> 2] + 1, e[5996] = 0, W = Mi(197, e[N + 8 >> 2]) | 0, s = e[5996], e[5996] = 0, (s | 0) != 1)
                  return s = e[N + 8 >> 2], A = e[s + 4 >> 2] - 1 | 0, e[s + 4 >> 2] = A, (A | 0) == -1 && xi[e[e[s >> 2] + 8 >> 2]](s), I1(r, p + 24 | 0, N + 12 | 0, u, m, W), Jr = N + 16 | 0, e[N + 12 >> 2];
                u = Hr() | 0, r = e[N + 8 >> 2], s = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = s, (s | 0) == -1 && xi[e[e[r >> 2] + 8 >> 2]](r), Jn(u | 0), Oi();
              }
              function Gh(r, s, u, A, m, p) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0, m = m | 0, p = p | 0;
                var N = 0, W = 0;
                if (N = Jr - 16 | 0, Jr = N, e[N + 12 >> 2] = s, s = e[A + 28 >> 2], e[N + 8 >> 2] = s, e[s + 4 >> 2] = e[s + 4 >> 2] + 1, e[5996] = 0, W = Mi(197, e[N + 8 >> 2]) | 0, s = e[5996], e[5996] = 0, (s | 0) != 1)
                  return s = e[N + 8 >> 2], A = e[s + 4 >> 2] - 1 | 0, e[s + 4 >> 2] = A, (A | 0) == -1 && xi[e[e[s >> 2] + 8 >> 2]](s), g1(r, p + 16 | 0, N + 12 | 0, u, m, W), Jr = N + 16 | 0, e[N + 12 >> 2];
                u = Hr() | 0, r = e[N + 8 >> 2], s = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = s, (s | 0) == -1 && xi[e[e[r >> 2] + 8 >> 2]](r), Jn(u | 0), Oi();
              }
              function vd(r, s) {
                e: {
                  if (r) {
                    if (s >>> 0 <= 127)
                      break e;
                    t: {
                      if (!e[e[6178] >> 2]) {
                        if ((s & -128) == 57216)
                          break e;
                        break t;
                      }
                      if (s >>> 0 <= 2047)
                        return _[r + 1 | 0] = s & 63 | 128, _[r | 0] = s >>> 6 | 192, 2;
                      if (!((s & -8192) != 57344 & s >>> 0 >= 55296))
                        return _[r + 2 | 0] = s & 63 | 128, _[r | 0] = s >>> 12 | 224, _[r + 1 | 0] = s >>> 6 & 63 | 128, 3;
                      if (s - 65536 >>> 0 <= 1048575)
                        return _[r + 3 | 0] = s & 63 | 128, _[r | 0] = s >>> 18 | 240, _[r + 2 | 0] = s >>> 6 & 63 | 128, _[r + 1 | 0] = s >>> 12 & 63 | 128, 4;
                    }
                    e[5732] = 25, r = -1;
                  } else
                    r = 1;
                  return r;
                }
                return _[r | 0] = s, 1;
              }
              function Xu(r) {
                var s = 0, u = 0, A = 0, m = 0, p = 0;
                e: {
                  if (A = r - 24 | 0, r = A, r >>> 0 < 27344 & r >>> 0 >= 26832) {
                    for (s = r - 4 | 0, m = e[6705], u = m; ; ) {
                      if (r = u, !(!r | (r | 0) == 27344)) {
                        if (u = Ia[r + 2 >> 1], (r + (u << 2) | 0) == (s | 0)) {
                          Zs[r + 2 >> 1] = u + Ia[A - 2 >> 1];
                          break e;
                        }
                        if ((r | 0) == ((Ia[s + 2 >> 1] << 2) + s | 0)) {
                          if (u = A - 2 | 0, Zs[u >> 1] = Ia[r + 2 >> 1] + Ia[u >> 1], !p) {
                            e[6705] = s, Zs[s >> 1] = Ia[r >> 1];
                            break e;
                          }
                          Zs[p >> 1] = s - 26832 >>> 2;
                          break e;
                        } else {
                          u = (Ia[r >> 1] << 2) + 26832 | 0, p = r;
                          continue;
                        }
                      }
                      break;
                    }
                    Zs[s >> 1] = m - 26832 >>> 2, e[6705] = s;
                    break e;
                  }
                  Br(A);
                }
              }
              function jh(r, s, u, A, m) {
                var p = 0, N = 0, W = 0;
                W = -1, N = A & 2147483647, p = (N | 0) == 2147418112;
                e: {
                  if ((p & !u ? r | s : p & (u | 0) != 0 | N >>> 0 > 2147418112) || (p = m & 2147483647, ((p | 0) == 2147418112 & 0 | p >>> 0 > 2147418112) & (p | 0) != 2147418112))
                    break e;
                  if (!(r | u | (p | N | s)))
                    return 0;
                  if (p = A & m, (p | 0) > 0 | (p | 0) >= 0) {
                    if (((u | 0) != 0 | (A | 0) != (m | 0)) & (A | 0) < (m | 0))
                      break e;
                    return (r | u | (A ^ m | s)) != 0;
                  }
                  if (!u & (A | 0) == (m | 0) ? r | s : (u | 0) != 0 & (A | 0) >= (m | 0) | (A | 0) > (m | 0))
                    break e;
                  W = (r | u | (A ^ m | s)) != 0;
                }
                return W;
              }
              function Cd(r, s, u, A, m, p) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0, m = m | 0, p = p | 0;
                var N = 0;
                if (r = Jr - 16 | 0, Jr = r, e[r + 12 >> 2] = s, s = e[A + 28 >> 2], e[r + 8 >> 2] = s, e[s + 4 >> 2] = e[s + 4 >> 2] + 1, e[5996] = 0, N = Mi(170, e[r + 8 >> 2]) | 0, s = e[5996], e[5996] = 0, (s | 0) != 1)
                  return s = e[r + 8 >> 2], A = e[s + 4 >> 2] - 1 | 0, e[s + 4 >> 2] = A, (A | 0) == -1 && xi[e[e[s >> 2] + 8 >> 2]](s), S1(p + 20 | 0, r + 12 | 0, u, m, N), Jr = r + 16 | 0, e[r + 12 >> 2];
                u = Hr() | 0, r = e[r + 8 >> 2], s = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = s, (s | 0) == -1 && xi[e[e[r >> 2] + 8 >> 2]](r), Jn(u | 0), Oi();
              }
              function Wf(r, s, u, A, m, p) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0, m = m | 0, p = p | 0;
                var N = 0;
                if (r = Jr - 16 | 0, Jr = r, e[r + 12 >> 2] = s, s = e[A + 28 >> 2], e[r + 8 >> 2] = s, e[s + 4 >> 2] = e[s + 4 >> 2] + 1, e[5996] = 0, N = Mi(197, e[r + 8 >> 2]) | 0, s = e[5996], e[5996] = 0, (s | 0) != 1)
                  return s = e[r + 8 >> 2], A = e[s + 4 >> 2] - 1 | 0, e[s + 4 >> 2] = A, (A | 0) == -1 && xi[e[e[s >> 2] + 8 >> 2]](s), k1(p + 20 | 0, r + 12 | 0, u, m, N), Jr = r + 16 | 0, e[r + 12 >> 2];
                u = Hr() | 0, r = e[r + 8 >> 2], s = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = s, (s | 0) == -1 && xi[e[e[r >> 2] + 8 >> 2]](r), Jn(u | 0), Oi();
              }
              function Wh(r, s, u) {
                var A = 0, m = 0, p = 0, N = 0, W = 0;
                m = r, N = Jr - 16 | 0, Jr = N;
                e: {
                  if (s >>> 0 < 1073741808) {
                    t: {
                      if (s >>> 0 < 2) {
                        _[m + 11 | 0] = s;
                        break t;
                      }
                      W = N + 8 | 0, s >>> 0 >= 2 ? (p = s + 4 & -4, A = p - 1 | 0, A = (A | 0) == 2 ? p : A) : A = 1, Ol(W, A + 1 | 0), A = e[N + 8 >> 2], e[m >> 2] = A, e[m + 8 >> 2] = e[N + 12 >> 2] | -2147483648, e[m + 4 >> 2] = s, m = A;
                    }
                    for (p = Jr - 16 | 0, Jr = p, e[p + 12 >> 2] = u, u = m, A = s; ; ) {
                      if (A) {
                        e[u >> 2] = e[p + 12 >> 2], A = A - 1 | 0, u = u + 4 | 0;
                        continue;
                      }
                      break;
                    }
                    Jr = p + 16 | 0, e[(s << 2) + m >> 2] = 0, Jr = N + 16 | 0;
                    break e;
                  }
                  Ra(), Oi();
                }
                return r;
              }
              function Aa(r, s, u, A, m, p, N, W, Te) {
                var Xe = 0, fr = 0, ar = 0, vr = 0;
                Te = Ao(s, u, W, Te), W = Ds, m = Ao(A, m, p, N), Te = m + Te | 0, A = Ds + W | 0, W = m >>> 0 > Te >>> 0 ? A + 1 | 0 : A, Xe = N, m = 0, fr = u, A = 0, u = Ao(N, m, u, A), N = u + Te | 0, Te = Ds + W | 0, ar = N, u = u >>> 0 > N >>> 0 ? Te + 1 | 0 : Te, N = Ao(p, 0, s, 0), W = Ds, Te = 0, A = Ao(p, Te, fr, A), W = W + A | 0, p = Ds + Te | 0, p = A >>> 0 > W >>> 0 ? p + 1 | 0 : p, Te = p + ar | 0, A = u, p = p >>> 0 > Te >>> 0 ? A + 1 | 0 : A, s = Ao(s, vr, Xe, m) + W | 0, m = Ds, m = s >>> 0 < W >>> 0 ? m + 1 | 0 : m, W = m + Te | 0, Te = p, e[r + 8 >> 2] = W, e[r + 12 >> 2] = m >>> 0 > W >>> 0 ? Te + 1 | 0 : Te, e[r >> 2] = N, e[r + 4 >> 2] = s;
              }
              function zf(r, s, u, A) {
                var m = 0, p = 0, N = 0, W = 0;
                m = Jr - 16 | 0, Jr = m;
                e: {
                  t: {
                    if ((r | 0) != (s | 0))
                      r: {
                        i: {
                          if (p = me[r | 0], (p | 0) != 45 || (r = r + 1 | 0, (s | 0) != (r | 0)))
                            break i;
                          break r;
                        }
                        W = e[5732], e[5732] = 0, ko(), r = k4(r, m + 12 | 0, A), A = Ds, N = e[5732];
                        i: {
                          if (N) {
                            if (e[m + 12 >> 2] != (s | 0))
                              break r;
                            if ((N | 0) == 68 | A)
                              break i;
                            break t;
                          }
                          if (e[5732] = W, e[m + 12 >> 2] != (s | 0))
                            break r;
                          if (!A)
                            break t;
                        }
                        e[u >> 2] = 4, r = -1;
                        break e;
                      }
                    e[u >> 2] = 4, r = 0;
                    break e;
                  }
                  r = (p | 0) == 45 ? 0 - r | 0 : r;
                }
                return Jr = m + 16 | 0, r;
              }
              function Rf(r, s) {
                r = r | 0, s = s | 0;
                var u = 0, A = 0;
                e: {
                  if (A = me[r + 11 | 0], u = A & 127, A = (A & 128) >>> 7 | 0, u = A ? e[r + 4 >> 2] : u, u >>> 0 < s >>> 0) {
                    if (s = s - u | 0, s) {
                      A = A ? (e[r + 8 >> 2] & 2147483647) - 1 | 0 : 10, u = me[r + 11 | 0], u = (u & 128) >>> 7 | 0 ? e[r + 4 >> 2] : u & 127, A - u >>> 0 < s >>> 0 && Al(r, A, u + (s - A | 0) | 0, u, u), A = (me[r + 11 | 0] & 128) >>> 7 | 0 ? e[r >> 2] : r, tc(A + u | 0, s, 0), s = s + u | 0;
                      t: {
                        if ((me[r + 11 | 0] & 128) >>> 7 | 0) {
                          e[r + 4 >> 2] = s;
                          break t;
                        }
                        _[r + 11 | 0] = s;
                      }
                      _[s + A | 0] = 0;
                    }
                    break e;
                  }
                  nc(r, (me[r + 11 | 0] & 128) >>> 7 | 0 ? e[r >> 2] : r, s);
                }
              }
              function Vo(r, s, u) {
                var A = 0, m = 0, p = 0;
                m = Jr - 16 | 0, Jr = m, e[s + 4 >> 2] = e[s + 4 >> 2] + 1, p = r + 8 | 0, A = m + 12 | 0, e[A >> 2] = s;
                e: {
                  if (s = e[r + 12 >> 2], r = e[r + 8 >> 2], s - r >> 2 >>> 0 <= u >>> 0) {
                    if (e[5996] = 0, ji(274, p | 0, u + 1 | 0), r = e[5996], e[5996] = 0, (r | 0) == 1)
                      break e;
                    r = e[p >> 2];
                  }
                  r = (u << 2) + r | 0, s = e[r >> 2], s && (r = e[s + 4 >> 2] - 1 | 0, e[s + 4 >> 2] = r, (r | 0) == -1 && xi[e[e[s >> 2] + 8 >> 2]](s), r = e[p >> 2] + (u << 2) | 0), s = e[A >> 2], e[A >> 2] = 0, e[r >> 2] = s, B1(A), Jr = m + 16 | 0;
                  return;
                }
                r = Hr() | 0, B1(A), Jn(r | 0), Oi();
              }
              function Ep(r, s, u) {
                r = r | 0, s = s | 0, u = u | 0;
                var A = 0, m = 0, p = 0;
                A = Jr - 16 | 0, Jr = A;
                e: {
                  t: {
                    r: {
                      if ((s | 0) != (u | 0) && (u = u - s | 0, (u | 0) < 18))
                        break r;
                      _[r + 12 | 0] = 0, _[r | 0] = 0;
                      break t;
                    }
                    if (u >>> 0 >= 2147483632)
                      break e;
                    r: {
                      if (u >>> 0 <= 10) {
                        _[A + 15 | 0] = u, m = A + 4 | 0;
                        break r;
                      }
                      p = (u | 15) + 1 | 0, m = Qs(p), e[A + 12 >> 2] = p | -2147483648, e[A + 4 >> 2] = m, e[A + 8 >> 2] = u;
                    }
                    _[so(m, s, u) + u | 0] = 0, e[r + 8 >> 2] = e[A + 12 >> 2], s = e[A + 8 >> 2], e[r >> 2] = e[A + 4 >> 2], e[r + 4 >> 2] = s, _[r + 12 | 0] = 1;
                  }
                  Jr = A + 16 | 0;
                  return;
                }
                Ra(), Oi();
              }
              function uf(r, s, u) {
                r = r | 0, s = s | 0, u = u | 0;
                var A = 0, m = 0, p = 0;
                m = Jr - 16 | 0, Jr = m;
                e: {
                  if (p = e[s >> 2], p) {
                    if (A = me[u + 11 | 0], ((A & 128) >>> 7 | 0 ? e[u + 4 >> 2] : A & 127) && (o6(u, 5570), p = e[s >> 2]), A = m + 4 | 0, s = e[s + 4 >> 2], xi[e[e[s >> 2] + 24 >> 2]](A, s, p), e[5996] = 0, pi(290, u | 0, A | 0) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1)
                      break e;
                    Qn(A);
                  }
                  s = e[u + 4 >> 2], e[r >> 2] = e[u >> 2], e[r + 4 >> 2] = s, e[r + 8 >> 2] = e[u + 8 >> 2], e[u >> 2] = 0, e[u + 4 >> 2] = 0, e[u + 8 >> 2] = 0, Jr = m + 16 | 0;
                  return;
                }
                r = Hr() | 0, Qn(m + 4 | 0), Jn(r | 0), Oi();
              }
              function Ma(r) {
                var s = 0, u = 0, A = 0;
                if (s = e[r + 40 >> 2], s && (e[r + 44 >> 2] = s, Br(s)), u = e[r + 28 >> 2], u) {
                  if (A = u, s = e[r + 32 >> 2], (u | 0) != (s | 0)) {
                    for (; A = s - 12 | 0, _[s - 1 | 0] < 0 && Br(e[A >> 2]), s = A, (u | 0) != (s | 0); )
                      ;
                    A = e[r + 28 >> 2];
                  }
                  e[r + 32 >> 2] = u, Br(A);
                }
                if (s = e[r + 16 >> 2], s && (e[r + 20 >> 2] = s, Br(s)), u = e[r + 4 >> 2], u) {
                  if (s = u, A = e[r + 8 >> 2], (s | 0) != (A | 0)) {
                    for (; A = Ma(A - 56 | 0), (u | 0) != (A | 0); )
                      ;
                    s = e[r + 4 >> 2];
                  }
                  e[r + 8 >> 2] = u, Br(s);
                }
                return r;
              }
              function ka(r, s, u, A) {
                var m = 0, p = 0, N = 0;
                e: {
                  if (m = me[r + 11 | 0], !((m & 128) >>> 7 | 0 ? e[r + 4 >> 2] : m & 127) | (u - s | 0) < 5)
                    break e;
                  hf(s, u), m = u - 4 | 0, u = (me[r + 11 | 0] & 128) >>> 7 | 0 ? e[r >> 2] : r, p = e[r + 4 >> 2], r = me[r + 11 | 0], N = u + ((r & 128) >>> 7 | 0 ? p : r & 127) | 0;
                  t: {
                    for (; ; ) {
                      r: {
                        if (r = _[u | 0], p = r - 127 | 0, s >>> 0 >= m >>> 0)
                          break r;
                        if ((r | 0) != e[s >> 2] & (p & 255) >>> 0 >= 130)
                          break t;
                        s = s + 4 | 0, u = ((N - u | 0) > 1) + u | 0;
                        continue;
                      }
                      break;
                    }
                    if ((p & 255) >>> 0 < 130 | r >>> 0 > e[m >> 2] - 1 >>> 0)
                      break e;
                  }
                  e[A >> 2] = 4;
                }
              }
              function Nc(r) {
                var s = 0, u = 0, A = 0, m = 0, p = 0, N = 0, W = 0;
                if (A = e[r >> 2], A) {
                  if (s = A, u = e[r + 4 >> 2], (s | 0) != (u | 0)) {
                    for (; ; ) {
                      if (p = u - 12 | 0, m = e[p >> 2], m) {
                        if (s = m, N = u - 8 | 0, u = e[N >> 2], (s | 0) != (u | 0)) {
                          for (; ; ) {
                            u = u - 32 | 0, s = e[u + 4 >> 2];
                            e: {
                              if (!s || (W = e[s + 4 >> 2], e[s + 4 >> 2] = W - 1, W))
                                break e;
                              xi[e[e[s >> 2] + 8 >> 2]](s), ys(s);
                            }
                            if ((u | 0) == (m | 0))
                              break;
                          }
                          s = e[p >> 2];
                        }
                        e[N >> 2] = m, Br(s);
                      }
                      if (u = p, (A | 0) == (u | 0))
                        break;
                    }
                    s = e[r >> 2];
                  }
                  e[r + 4 >> 2] = A, Br(s);
                }
              }
              function pl(r, s, u) {
                var A = 0, m = 0, p = 0, N = 0, W = 0, Te = 0;
                A = r, N = Jr - 16 | 0, Jr = N;
                e: {
                  if (p = u - s | 0, p >>> 0 < 2147483632) {
                    t: {
                      if (p >>> 0 < 11) {
                        _[A + 11 | 0] = p;
                        break t;
                      }
                      Te = N + 8 | 0, p >>> 0 >= 11 ? (W = p + 16 & -16, m = W - 1 | 0, m = (m | 0) == 11 ? W : m) : m = 10, Of(Te, m + 1 | 0), m = e[N + 8 >> 2], e[A >> 2] = m, e[A + 8 >> 2] = e[N + 12 >> 2] | -2147483648, e[A + 4 >> 2] = p, A = m;
                    }
                    for (; ; ) {
                      if ((s | 0) != (u | 0)) {
                        _[A | 0] = me[s | 0], A = A + 1 | 0, s = s + 1 | 0;
                        continue;
                      }
                      break;
                    }
                    _[A | 0] = 0, Jr = N + 16 | 0;
                    break e;
                  }
                  Ra(), Oi();
                }
                return r;
              }
              function zh(r, s, u) {
                var A = 0, m = 0, p = 0, N = 0, W = 0, Te = 0;
                A = r, N = Jr - 16 | 0, Jr = N;
                e: {
                  if (p = u - s >> 2, p >>> 0 < 1073741808) {
                    t: {
                      if (p >>> 0 < 2) {
                        _[A + 11 | 0] = p;
                        break t;
                      }
                      Te = N + 8 | 0, p >>> 0 >= 2 ? (W = p + 4 & -4, m = W - 1 | 0, m = (m | 0) == 2 ? W : m) : m = 1, Ol(Te, m + 1 | 0), m = e[N + 8 >> 2], e[A >> 2] = m, e[A + 8 >> 2] = e[N + 12 >> 2] | -2147483648, e[A + 4 >> 2] = p, A = m;
                    }
                    for (; ; ) {
                      if ((s | 0) != (u | 0)) {
                        e[A >> 2] = e[s >> 2], A = A + 4 | 0, s = s + 4 | 0;
                        continue;
                      }
                      break;
                    }
                    e[A >> 2] = 0, Jr = N + 16 | 0;
                    break e;
                  }
                  Ra(), Oi();
                }
                return r;
              }
              function kd(r, s) {
                r = r | 0, s = s | 0;
                var u = 0, A = 0;
                s = !e[r + 24 >> 2] | (e[r + 16 >> 2] | s), e[r + 16 >> 2] = s, s & e[r + 20 >> 2] && (r = Jr - 16 | 0, Jr = r, u = cu(16), r = r + 8 | 0, s = Jr - 16 | 0, Jr = s, me[24716] || (_[24716] = 1), e[s + 12 >> 2] = 22908, e[s + 8 >> 2] = 1, A = e[s + 12 >> 2], e[r >> 2] = e[s + 8 >> 2], e[r + 4 >> 2] = A, Jr = s + 16 | 0, s = e[r + 4 >> 2], r = e[r >> 2], e[5996] = 0, r = H1(176, u | 0, 1821, r | 0, s | 0) | 0, s = e[5996], e[5996] = 0, (s | 0) != 1 && (Ua(r | 0, 8576, 177), Oi()), r = Hr() | 0, Xu(u), Jn(r | 0), Oi());
              }
              function Sd(r, s, u) {
                r = r | 0, s = s | 0, u = u | 0;
                var A = 0, m = 0, p = 0, N = 0, W = 0;
                for (m = Jr - 16 | 0, Jr = m; ; ) {
                  e: {
                    if ((u | 0) <= (p | 0))
                      break e;
                    if (A = e[r + 24 >> 2], N = e[r + 28 >> 2], A >>> 0 >= N >>> 0) {
                      if ((xi[e[e[r >> 2] + 52 >> 2]](r, me[s | 0]) | 0) == -1)
                        break e;
                      p = p + 1 | 0, s = s + 1 | 0;
                    } else
                      e[m + 12 >> 2] = N - A, e[m + 8 >> 2] = u - p, W = A, A = m + 8 | 0, N = m + 12 | 0, A = e[(e[A >> 2] < e[N >> 2] ? A : N) >> 2], bf(W, s, A), e[r + 24 >> 2] = A + e[r + 24 >> 2], p = A + p | 0, s = s + A | 0;
                    continue;
                  }
                  break;
                }
                return Jr = m + 16 | 0, p | 0;
              }
              function Td(r, s, u) {
                var A = 0, m = 0, p = 0, N = 0;
                return N = u & 63, p = N, m = p & 31, p >>> 0 >= 32 ? p = -1 >>> m | 0 : (A = -1 >>> m | 0, p = A | (1 << m) - 1 << 32 - m), p = p & r, A = s & A, m = N & 31, N >>> 0 >= 32 ? (A = p << m, N = 0) : (A = (1 << m) - 1 & p >>> 32 - m | A << m, N = p << m), p = A, m = 0 - u & 63, A = m & 31, m >>> 0 >= 32 ? (A = -1 << A, u = 0) : (u = -1 << A, A = u | (1 << A) - 1 & -1 >>> 32 - A), r = u & r, s = s & A, A = m & 31, m >>> 0 >= 32 ? (u = 0, r = s >>> A | 0) : (u = s >>> A | 0, r = ((1 << A) - 1 & s) << 32 - A | r >>> A), r = r | N, Ds = u | p, r;
              }
              function ba(r, s, u) {
                var A = 0, m = 0, p = 0;
                if (!(me[r | 0] & 32))
                  e: {
                    A = s, s = r, r = e[s + 16 >> 2];
                    t: {
                      if (!r) {
                        if (Mc(s))
                          break t;
                        r = e[s + 16 >> 2];
                      }
                      if (p = e[s + 20 >> 2], r - p >>> 0 < u >>> 0) {
                        xi[e[s + 36 >> 2]](s, A, u) | 0;
                        break e;
                      }
                      r: {
                        if (e[s + 80 >> 2] < 0)
                          break r;
                        for (r = u; ; ) {
                          if (m = r, !r)
                            break r;
                          if (r = r - 1 | 0, me[A + r | 0] == 10)
                            break;
                        }
                        if (xi[e[s + 36 >> 2]](s, A, m) >>> 0 < m >>> 0)
                          break t;
                        A = A + m | 0, u = u - m | 0, p = e[s + 20 >> 2];
                      }
                      so(p, A, u), e[s + 20 >> 2] = e[s + 20 >> 2] + u;
                    }
                  }
              }
              function bp(r, s) {
                r = r | 0, s = s | 0;
                var u = 0, A = 0, m = 0, p = 0, N = 0;
                m = e[r + 44 >> 2], u = e[r + 24 >> 2], m >>> 0 < u >>> 0 && (e[r + 44 >> 2] = u, m = u), u = e[r + 12 >> 2], p = e[r + 8 >> 2], A = -1;
                e: {
                  if (u >>> 0 <= p >>> 0)
                    break e;
                  if ((s | 0) == -1)
                    return e[r + 16 >> 2] = m, e[r + 12 >> 2] = u - 1, e[r + 8 >> 2] = p, ((s | 0) != -1 ? s : 0) | 0;
                  if (N = s << 24 >> 24, !(e[r + 48 >> 2] & 16) && (A = -1, (N | 0) != _[u - 1 | 0]))
                    break e;
                  e[r + 16 >> 2] = m, e[r + 12 >> 2] = u - 1, e[r + 8 >> 2] = p, _[e[r + 12 >> 2]] = N, A = s;
                }
                return A | 0;
              }
              function Bp(r, s, u) {
                r = r | 0, s = s | 0, u = +u;
                var A = 0, m = 0, p = 0;
                for (p = Jr - 16 | 0, Jr = p, A = me[s + 11 | 0], A = (A & 128) >>> 7 | 0 ? e[s + 4 >> 2] : A & 127; ; ) {
                  e: {
                    m = (me[s + 11 | 0] & 128) >>> 7 | 0 ? e[s >> 2] : s, jn[p >> 3] = u, m = ql(m, A + 1 | 0, 2314, p);
                    t: {
                      if ((m | 0) >= 0) {
                        if (A >>> 0 >= m >>> 0)
                          break e;
                        A = m;
                        break t;
                      }
                      A = A << 1 | 1;
                    }
                    Rf(s, A);
                    continue;
                  }
                  break;
                }
                Rf(s, m), A = e[s + 4 >> 2], e[r >> 2] = e[s >> 2], e[r + 4 >> 2] = A, e[r + 8 >> 2] = e[s + 8 >> 2], e[s >> 2] = 0, e[s + 4 >> 2] = 0, e[s + 8 >> 2] = 0, Jr = p + 16 | 0;
              }
              function Jh(r, s, u) {
                var A = 0, m = 0, p = ma(0), N = 0, W = ma(0);
                m = Jr - 16 | 0, Jr = m;
                e: {
                  t: {
                    r: {
                      if ((r | 0) != (s | 0)) {
                        if (N = e[5732], e[5732] = 0, ko(), A = Jr - 16 | 0, Jr = A, qd(A, r, m + 12 | 0, 0), p = kh(e[A >> 2], e[A + 4 >> 2], e[A + 8 >> 2], e[A + 12 >> 2]), Jr = A + 16 | 0, r = e[5732], !r)
                          break r;
                        if (e[m + 12 >> 2] != (s | 0))
                          break t;
                        if (W = p, (r | 0) != 68)
                          break e;
                        break t;
                      }
                      e[u >> 2] = 4;
                      break e;
                    }
                    if (e[5732] = N, e[m + 12 >> 2] == (s | 0))
                      break e;
                  }
                  e[u >> 2] = 4, p = W;
                }
                return Jr = m + 16 | 0, p;
              }
              function Yh(r, s, u) {
                var A = 0, m = 0, p = 0, N = 0, W = 0;
                m = Jr - 16 | 0, Jr = m;
                e: {
                  t: {
                    r: {
                      if ((r | 0) != (s | 0)) {
                        if (N = e[5732], e[5732] = 0, ko(), A = Jr - 16 | 0, Jr = A, qd(A, r, m + 12 | 0, 1), p = xu(e[A >> 2], e[A + 4 >> 2], e[A + 8 >> 2], e[A + 12 >> 2]), Jr = A + 16 | 0, r = e[5732], !r)
                          break r;
                        if (e[m + 12 >> 2] != (s | 0))
                          break t;
                        if (W = p, (r | 0) != 68)
                          break e;
                        break t;
                      }
                      e[u >> 2] = 4;
                      break e;
                    }
                    if (e[5732] = N, e[m + 12 >> 2] == (s | 0))
                      break e;
                  }
                  e[u >> 2] = 4, p = W;
                }
                return Jr = m + 16 | 0, p;
              }
              function vp(r, s, u) {
                r = r | 0, s = s | 0, u = u | 0;
                var A = 0, m = 0, p = 0;
                m = (me[r + 11 | 0] & 128) >>> 7 | 0 ? (e[r + 8 >> 2] & 2147483647) - 1 | 0 : 1, p = me[r + 11 | 0], A = p, A = (A & 128) >>> 7 | 0 ? e[r + 4 >> 2] : A & 127;
                e: {
                  if (m - A >>> 0 >= u >>> 0) {
                    if (!u)
                      break e;
                    m = (p & 128) >>> 7 | 0 ? e[r >> 2] : r, yf(m + (A << 2) | 0, s, u), s = u + A | 0;
                    t: {
                      if ((me[r + 11 | 0] & 128) >>> 7 | 0) {
                        e[r + 4 >> 2] = s;
                        break t;
                      }
                      _[r + 11 | 0] = s;
                    }
                    return e[m + (s << 2) >> 2] = 0, r | 0;
                  }
                  Ph(r, m, A + (u - m | 0) | 0, A, A, 0, u, s);
                }
                return r | 0;
              }
              function Xh(r, s, u, A, m) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0, m = m | 0;
                for (var p = 0, N = 0, W = 0, Te = 0, Xe = 0, fr = 0; ; ) {
                  e: {
                    if ((u | 0) == (A | 0) | m >>> 0 <= Te >>> 0)
                      break e;
                    N = 1, W = Jr - 16 | 0, Jr = W, p = Uu(W + 12 | 0, e[r + 8 >> 2]), Xe = dl(0, u, A - u | 0, s || 24840), p = e[p >> 2], p && (e[6178] = (p | 0) == -1 ? 24816 : p), Jr = W + 16 | 0;
                    t:
                      switch (Xe + 2 | 0) {
                        default:
                          N = Xe;
                          break;
                        case 0:
                        case 1:
                          break e;
                        case 2:
                          break t;
                      }
                    Te = Te + 1 | 0, fr = N + fr | 0, u = u + N | 0;
                    continue;
                  }
                  break;
                }
                return fr | 0;
              }
              function Pc(r, s, u) {
                var A = 0, m = 0;
                for (u & 2048 && (_[r | 0] = 43, r = r + 1 | 0), u & 1024 && (_[r | 0] = 35, r = r + 1 | 0), A = u & 260, (A | 0) != 260 && (_[r | 0] = 46, _[r + 1 | 0] = 42, r = r + 2 | 0), u = u & 16384; ; ) {
                  if (m = me[s | 0], m) {
                    _[r | 0] = m, r = r + 1 | 0, s = s + 1 | 0;
                    continue;
                  }
                  break;
                }
                e: {
                  t: {
                    if ((A | 0) != 256) {
                      if ((A | 0) != 4)
                        break t;
                      s = u ? 70 : 102;
                      break e;
                    }
                    s = u ? 69 : 101;
                    break e;
                  }
                  if (s = u ? 65 : 97, (A | 0) == 260)
                    break e;
                  s = u ? 71 : 103;
                }
                return _[r | 0] = s, (A | 0) != 260;
              }
              function Rd(r, s, u) {
                r = r | 0, s = s | 0, u = u | 0;
                var A = 0, m = 0, p = 0;
                m = (me[r + 11 | 0] & 128) >>> 7 | 0 ? (e[r + 8 >> 2] & 2147483647) - 1 | 0 : 10, p = me[r + 11 | 0], A = p, A = (A & 128) >>> 7 | 0 ? e[r + 4 >> 2] : A & 127;
                e: {
                  if (m - A >>> 0 >= u >>> 0) {
                    if (!u)
                      break e;
                    m = (p & 128) >>> 7 | 0 ? e[r >> 2] : r, bf(m + A | 0, s, u), s = u + A | 0;
                    t: {
                      if ((me[r + 11 | 0] & 128) >>> 7 | 0) {
                        e[r + 4 >> 2] = s;
                        break t;
                      }
                      _[r + 11 | 0] = s;
                    }
                    return _[s + m | 0] = 0, r | 0;
                  }
                  Gf(r, m, A + (u - m | 0) | 0, A, A, 0, u, s);
                }
                return r | 0;
              }
              function Cp(r, s, u, A, m) {
                if (r = r | 0, s = s | 0, u = u | 0, A = A | 0, m = m | 0, eu(r, e[s + 8 >> 2], m)) {
                  e[s + 28 >> 2] == 1 | e[s + 4 >> 2] != (u | 0) || (e[s + 28 >> 2] = A);
                  return;
                }
                e: {
                  if (!eu(r, e[s >> 2], m))
                    break e;
                  if (!(e[s + 16 >> 2] != (u | 0) & e[s + 20 >> 2] != (u | 0))) {
                    if ((A | 0) != 1)
                      break e;
                    e[s + 32 >> 2] = 1;
                    return;
                  }
                  e[s + 20 >> 2] = u, e[s + 32 >> 2] = A, e[s + 40 >> 2] = e[s + 40 >> 2] + 1, e[s + 36 >> 2] != 1 | e[s + 24 >> 2] != 2 || (_[s + 54 | 0] = 1), e[s + 44 >> 2] = 4;
                }
              }
              function _h(r, s, u) {
                r = r | 0, s = s | 0, u = u | 0;
                var A = 0, m = 0, p = 0, N = 0, W = 0, Te = 0;
                if (m = Jr - 16 | 0, Jr = m, Te = e[s >> 2], A = e[u >> 2], N = e[r >> 2], p = A - N | 0, p = p >>> 0 >= 2147483647 ? -1 : (A | 0) == (N | 0) ? 4 : p << 1, A = e[r + 4 >> 2] == 220, W = wc(A ? 0 : N, p), W) {
                  A || (e[r >> 2] = 0), e[m + 4 >> 2] = 184, A = m + 8 | 0, e[A >> 2] = W, e[A + 4 >> 2] = e[m + 4 >> 2], r = Gi(r, A), to(A), e[s >> 2] = e[r >> 2] + (Te - N | 0), e[u >> 2] = e[r >> 2] + (p & -4), Jr = m + 16 | 0;
                  return;
                }
                Ts(), Oi();
              }
              function xd(r, s) {
                r = r | 0, s = +s;
                var u = 0, A = 0, m = 0;
                if (A = Jr - 16 | 0, Jr = A, u = A + 4 | 0, e[u >> 2] = 0, e[u + 4 >> 2] = 0, e[u + 8 >> 2] = 0, m = (me[u + 11 | 0] & 128) >>> 7 | 0 ? (e[u + 8 >> 2] & 2147483647) - 1 | 0 : 10, e[5996] = 0, ji(172, u | 0, m | 0), m = e[5996], e[5996] = 0, (m | 0) == 1 && (r = Hr() | 0, Qn(u), Jn(r | 0), Oi()), e[5996] = 0, Vl(120, r | 0, u | 0, +s), r = e[5996], e[5996] = 0, (r | 0) != 1) {
                  Qn(u), Jr = A + 16 | 0;
                  return;
                }
                r = Hr() | 0, Qn(A + 4 | 0), Jn(r | 0), Oi();
              }
              function yl(r, s) {
                var u = 0, A = 0, m = 0, p = 0, N = 0, W = 0;
                u = me[r + 11 | 0], A = u << 24 >> 24, p = e[s + 4 >> 2], A = (A | 0) < 0, u = A ? e[r + 4 >> 2] : u;
                e: {
                  if (p >>> 0 < u + 2 >>> 0 || (m = e[s >> 2], N = u + m | 0, me[N | 0] != 40 | me[(m + p | 0) - 1 | 0] != 41))
                    break e;
                  if (u)
                    for (r = A ? e[r >> 2] : r, A = u + r | 0; ; ) {
                      if (me[r | 0] != me[m | 0])
                        return 0;
                      if (m = m + 1 | 0, r = r + 1 | 0, (A | 0) == (r | 0))
                        break;
                    }
                  e[s + 4 >> 2] = (p - u | 0) - 2, W = 1, e[s >> 2] = N + 1;
                }
                return W;
              }
              function Zh(r, s, u, A) {
                var m = 0, p = 0, N = 0;
                m = Jr - 16 | 0, Jr = m;
                e: {
                  if ((r | 0) != (s | 0)) {
                    N = e[5732], e[5732] = 0, ko(), r = h6(r, m + 12 | 0, A), A = Ds, p = e[5732];
                    t: {
                      if (p) {
                        if (e[m + 12 >> 2] != (s | 0))
                          break t;
                        if ((p | 0) != 68)
                          break e;
                        e[u >> 2] = 4, s = !!r & (A | 0) >= 0 | (A | 0) > 0, r = s ? -1 : 0, A = s ? 2147483647 : -2147483648;
                        break e;
                      }
                      if (e[5732] = N, e[m + 12 >> 2] == (s | 0))
                        break e;
                    }
                  }
                  e[u >> 2] = 4, r = 0, A = 0;
                }
                return Jr = m + 16 | 0, Ds = A, r;
              }
              function kp(r, s, u) {
                r = r | 0, s = s | 0, u = u | 0;
                var A = 0, m = 0, p = 0, N = 0, W = 0;
                return m = e[r + 84 >> 2], p = e[m >> 2], A = e[m + 4 >> 2], W = e[r + 28 >> 2], N = e[r + 20 >> 2] - W | 0, N = A >>> 0 < N >>> 0 ? A : N, N && (so(p, W, N), p = N + e[m >> 2] | 0, e[m >> 2] = p, A = e[m + 4 >> 2] - N | 0, e[m + 4 >> 2] = A), A = u >>> 0 > A >>> 0 ? A : u, A && (so(p, s, A), p = A + e[m >> 2] | 0, e[m >> 2] = p, e[m + 4 >> 2] = e[m + 4 >> 2] - A), _[p | 0] = 0, s = e[r + 44 >> 2], e[r + 28 >> 2] = s, e[r + 20 >> 2] = s, u | 0;
              }
              function Sp(r, s, u) {
                r = r | 0, s = s | 0, u = u | 0;
                var A = 0, m = 0, p = 0, N = 0, W = 0, Te = 0;
                if (m = Jr - 16 | 0, Jr = m, Te = e[s >> 2], N = e[r >> 2], A = e[u >> 2] - N | 0, p = A << 1, p = A >>> 0 >= 2147483647 ? -1 : p >>> 0 <= 1 ? 1 : p, A = e[r + 4 >> 2] == 220, W = wc(A ? 0 : N, p), W) {
                  A || (e[r >> 2] = 0), e[m + 4 >> 2] = 184, A = m + 8 | 0, e[A >> 2] = W, e[A + 4 >> 2] = e[m + 4 >> 2], r = Gi(r, A), to(A), e[s >> 2] = e[r >> 2] + (Te - N | 0), e[u >> 2] = p + e[r >> 2], Jr = m + 16 | 0;
                  return;
                }
                Ts(), Oi();
              }
              function Dd(r, s, u, A) {
                _[r + 53 | 0] = 1;
                e: {
                  if (e[r + 4 >> 2] != (u | 0))
                    break e;
                  _[r + 52 | 0] = 1, u = e[r + 16 >> 2];
                  t: {
                    if (!u) {
                      if (e[r + 36 >> 2] = 1, e[r + 24 >> 2] = A, e[r + 16 >> 2] = s, (A | 0) != 1)
                        break e;
                      if (e[r + 48 >> 2] == 1)
                        break t;
                      break e;
                    }
                    if ((s | 0) == (u | 0)) {
                      if (u = e[r + 24 >> 2], (u | 0) == 2 && (e[r + 24 >> 2] = A, u = A), e[r + 48 >> 2] != 1)
                        break e;
                      if ((u | 0) == 1)
                        break t;
                      break e;
                    }
                    e[r + 36 >> 2] = e[r + 36 >> 2] + 1;
                  }
                  _[r + 54 | 0] = 1;
                }
              }
              function Tp(r, s, u) {
                r = r | 0, s = s | 0, u = u | 0;
                var A = 0, m = 0;
                A = Jr + -64 | 0, Jr = A, m = 1;
                e: {
                  if (eu(r, s, 0) || (m = 0, !s) || (s = fl(s, 22104), m = 0, !s))
                    break e;
                  nu(A + 12 | 0, 0, 52), e[A + 56 >> 2] = 1, e[A + 20 >> 2] = -1, e[A + 16 >> 2] = r, e[A + 8 >> 2] = s, xi[e[e[s >> 2] + 28 >> 2]](s, A + 8 | 0, e[u >> 2], 1), r = e[A + 32 >> 2], (r | 0) == 1 && (e[u >> 2] = e[A + 24 >> 2]), m = (r | 0) == 1;
                }
                return r = m, Jr = A - -64 | 0, r | 0;
              }
              function $h(r) {
                return me[25132] ? e[6282] : (me[25640] || (_[25640] = 1), So(25472, 18340), So(25484, 18368), So(25496, 18396), So(25508, 18428), So(25520, 18468), So(25532, 18504), So(25544, 18532), So(25556, 18568), So(25568, 18584), So(25580, 18600), So(25592, 18616), So(25604, 18632), So(25616, 18648), So(25628, 18664), _[25132] = 1, e[6282] = 25472, 25472);
              }
              function Nd(r) {
                r = r | 0;
                var s = 0, u = 0;
                s = e[r + 80 >> 2];
                e: {
                  if (!s | Ls[r + 84 >> 2] > 3600 || pu(3557, 1) & (s ^ -1) || (s = e[r + 80 >> 2], !s | Ls[r + 84 >> 2] > 3600 | (e[r + 52 >> 2] + e[r + 44 >> 2] >>> 0 > 201 | Ls[r + 68 >> 2] > 100)) || pu(2049, 1) & (s ^ -1) || (s = e[r + 80 >> 2], pu(2165, 1) & (s ^ -1) | me[r + 88 | 0]))
                    break e;
                  r = e[r + 80 >> 2], u = !(pu(1681, 1) & (r ^ -1));
                }
                return u | 0;
              }
              function Il(r, s, u) {
                r = r | 0, s = s | 0, u = u | 0;
                var A = 0, m = 0, p = 0, N = 0;
                m = Jr - 16 | 0, Jr = m;
                e: {
                  t: {
                    if (u >>> 0 < 11) {
                      _[r + 11 | 0] = u;
                      break t;
                    }
                    if (u >>> 0 >= 2147483632)
                      break e;
                    N = m + 8 | 0, u >>> 0 >= 11 ? (p = u + 16 & -16, A = p - 1 | 0, A = (A | 0) == 11 ? p : A) : A = 10, Of(N, A + 1 | 0), A = e[m + 8 >> 2], e[r >> 2] = A, e[r + 8 >> 2] = e[m + 12 >> 2] | -2147483648, e[r + 4 >> 2] = u, r = A;
                  }
                  bf(r, s, u + 1 | 0), Jr = m + 16 | 0;
                  return;
                }
                Ra(), Oi();
              }
              function So(r, s) {
                var u = 0, A = 0, m = 0, p = 0;
                e: {
                  if (u = x1(s), A = (me[r + 11 | 0] & 128) >>> 7 | 0 ? (e[r + 8 >> 2] & 2147483647) - 1 | 0 : 1, u >>> 0 <= A >>> 0) {
                    s = Ys((me[r + 11 | 0] & 128) >>> 7 | 0 ? e[r >> 2] : r, s, u << 2);
                    t: {
                      if ((me[r + 11 | 0] & 128) >>> 7 | 0) {
                        e[r + 4 >> 2] = u;
                        break t;
                      }
                      _[r + 11 | 0] = u;
                    }
                    e[(u << 2) + s >> 2] = 0;
                    break e;
                  }
                  m = r, p = e[r + 4 >> 2], r = me[r + 11 | 0], r = (r & 128) >>> 7 | 0 ? p : r & 127, Ph(m, A, u - A | 0, r, 0, r, u, s);
                }
              }
              function Ja(r) {
                var s = 0, u = 0, A = 0;
                if (A = e[r >> 2], A) {
                  if (s = e[r + 4 >> 2], u = A, (s | 0) != (u | 0)) {
                    for (; u = s - 32 | 0, (me[u | 0] | me[u + 1 | 0] << 8 | (me[u + 2 | 0] << 16 | me[u + 3 | 0] << 24)) >>> 0 >= 29 && (s = s - 24 | 0, Br(me[s | 0] | me[s + 1 | 0] << 8 | (me[s + 2 | 0] << 16 | me[s + 3 | 0] << 24)), _[s | 0] = 0, _[s + 1 | 0] = 0, _[s + 2 | 0] = 0, _[s + 3 | 0] = 0), s = u, (A | 0) != (s | 0); )
                      ;
                    u = e[r >> 2];
                  }
                  e[r + 4 >> 2] = A, Br(u);
                }
              }
              function Rp(r, s) {
                r = r | 0, s = s | 0;
                var u = 0, A = 0;
                return _[r + 6 | 0] = 0, Zs[r + 4 >> 1] = 0, e[r >> 2] = 1, u = e[s >> 2], A = e[s + 4 >> 2], e[r + 20 >> 2] = 0, e[r + 12 >> 2] = 0, e[r + 16 >> 2] = 0, e[r + 8 >> 2] = (A - u | 0) + 1, u = Qs(12), e[r + 16 >> 2] = u, e[r + 12 >> 2] = u, A = u + 12 | 0, e[r + 20 >> 2] = A, e[u >> 2] = e[s >> 2], e[u + 4 >> 2] = e[s + 4 >> 2], e[u + 8 >> 2] = e[s + 8 >> 2], e[s + 8 >> 2] = 0, e[s >> 2] = 0, e[s + 4 >> 2] = 0, e[r + 16 >> 2] = A, r | 0;
              }
              function xp(r, s, u, A) {
                r = r | 0, s = s | 0, u = u | 0, A = +A;
                var m = 0, p = 0, N = 0, W = 0;
                return m = Qs(56), p = e[u + 8 >> 2], e[u + 8 >> 2] = 0, N = e[u >> 2], W = e[u + 4 >> 2], e[u >> 2] = 0, e[u + 4 >> 2] = 0, e[m + 16 >> 2] = 0, e[m + 20 >> 2] = 0, e[m + 12 >> 2] = p, e[m + 4 >> 2] = N, e[m + 8 >> 2] = W, e[m >> 2] = s, e[m + 24 >> 2] = 0, e[m + 28 >> 2] = 0, e[m + 32 >> 2] = 0, e[m + 36 >> 2] = 0, e[m + 40 >> 2] = 0, e[m + 44 >> 2] = 0, jn[m + 48 >> 3] = A, of(r, m), m | 0;
              }
              function Dp(r) {
                return me[25124] ? e[6280] : (me[25464] || (_[25464] = 1), wo(25296, 1114), wo(25308, 1121), wo(25320, 1087), wo(25332, 1095), wo(25344, 1078), wo(25356, 1128), wo(25368, 1105), wo(25380, 1961), wo(25392, 1999), wo(25404, 2336), wo(25416, 2493), wo(25428, 1273), wo(25440, 2172), wo(25452, 1390), _[25124] = 1, e[6280] = 25296, 25296);
              }
              function xf(r, s) {
                var u = 0, A = 0, m = 0, p = 0, N = 0;
                e: {
                  if (u = x1(s), m = Jr - 16 | 0, Jr = m, u >>> 0 < 1073741808) {
                    t: {
                      if (u >>> 0 < 2) {
                        _[r + 11 | 0] = u;
                        break t;
                      }
                      N = m + 8 | 0, u >>> 0 >= 2 ? (p = u + 4 & -4, A = p - 1 | 0, A = (A | 0) == 2 ? p : A) : A = 1, Ol(N, A + 1 | 0), A = e[m + 8 >> 2], e[r >> 2] = A, e[r + 8 >> 2] = e[m + 12 >> 2] | -2147483648, e[r + 4 >> 2] = u, r = A;
                    }
                    e[yf(r, s, u) + (u << 2) >> 2] = 0, Jr = m + 16 | 0;
                    break e;
                  }
                  Ra(), Oi();
                }
              }
              function Iu(r, s, u, A) {
                var m = 0, p = 0, N = 0, W = 0;
                m = Jr - 16 | 0, Jr = m, e[m + 12 >> 2] = A, N = Uu(m + 8 | 0, s), s = Jr - 16 | 0, Jr = s, A = e[m + 12 >> 2], e[s + 12 >> 2] = A, e[s + 8 >> 2] = A, p = -1, A = ul(0, 0, u, A);
                e: {
                  if ((A | 0) < 0 || (W = r, A = A + 1 | 0, r = da(A), e[W >> 2] = r, !r))
                    break e;
                  p = ul(r, A, u, e[s + 12 >> 2]);
                }
                return Jr = s + 16 | 0, r = e[N >> 2], r && (e[6178] = (r | 0) == -1 ? 24816 : r), Jr = m + 16 | 0, p;
              }
              function Np(r, s, u) {
                r = r | 0, s = s | 0, u = +u;
                var A = 0, m = 0, p = 0, N = 0;
                return A = Qs(56), m = e[s + 8 >> 2], e[s + 8 >> 2] = 0, p = e[s >> 2], N = e[s + 4 >> 2], e[s >> 2] = 0, e[s + 4 >> 2] = 0, e[A + 16 >> 2] = 0, e[A + 20 >> 2] = 0, e[A + 12 >> 2] = m, e[A + 4 >> 2] = p, e[A + 8 >> 2] = N, e[A >> 2] = 12, e[A + 24 >> 2] = 0, e[A + 28 >> 2] = 0, e[A + 32 >> 2] = 0, e[A + 36 >> 2] = 0, e[A + 40 >> 2] = 0, e[A + 44 >> 2] = 0, jn[A + 48 >> 3] = u, of(r, A), A | 0;
              }
              function Pd(r) {
                var s = 0;
                s = 1;
                e: {
                  if ((r | 0) >= 1024) {
                    if (s = 898846567431158e293, r >>> 0 < 2047) {
                      r = r - 1023 | 0;
                      break e;
                    }
                    s = 1 / 0, r = ((r | 0) >= 3069 ? 3069 : r) - 2046 | 0;
                    break e;
                  }
                  if ((r | 0) > -1023)
                    break e;
                  if (s = 2004168360008973e-307, r >>> 0 > 4294965304) {
                    r = r + 969 | 0;
                    break e;
                  }
                  s = 0, r = ((r | 0) <= -2960 ? -2960 : r) + 1938 | 0;
                }
                return Zo(0, 0), Zo(1, r + 1023 << 20), s * +ru();
              }
              function ml(r) {
                var s = 0, u = 0, A = 0, m = 0;
                if (r) {
                  if (ml(e[r >> 2]), ml(e[r + 4 >> 2]), A = e[r + 40 >> 2], A) {
                    if (s = A, u = e[r + 44 >> 2], (s | 0) != (u | 0)) {
                      for (; ; ) {
                        u = u - 32 | 0, s = e[u + 4 >> 2];
                        e: {
                          if (!s || (m = e[s + 4 >> 2], e[s + 4 >> 2] = m - 1, m))
                            break e;
                          xi[e[e[s >> 2] + 8 >> 2]](s), ys(s);
                        }
                        if ((A | 0) == (u | 0))
                          break;
                      }
                      s = e[r + 40 >> 2];
                    }
                    e[r + 44 >> 2] = A, Br(s);
                  }
                  Br(r);
                }
              }
              function Pp(r, s, u, A, m) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0, m = m | 0;
                var p = 0, N = 0;
                N = Jr - 16 | 0, Jr = N, e[m >> 2] = u, s = N + 12 | 0, r = Nl(s, 0, e[r + 8 >> 2]), p = 2;
                e: {
                  if (r + 1 >>> 0 < 2 || (u = r - 1 | 0, p = 1, u >>> 0 > A - e[m >> 2] >>> 0))
                    break e;
                  for (; ; ) {
                    if (u) {
                      r = me[s | 0], A = e[m >> 2], e[m >> 2] = A + 1, _[A | 0] = r, u = u - 1 | 0, s = s + 1 | 0;
                      continue;
                    }
                    break;
                  }
                  p = 0;
                }
                return r = p, Jr = N + 16 | 0, r | 0;
              }
              function Pu(r, s, u, A) {
                var m = 0;
                e: {
                  if (!(A & 2048) || (m = A & 74, !u | ((m | 0) == 8 | (m | 0) == 64)))
                    break e;
                  _[r | 0] = 43, r = r + 1 | 0;
                }
                for (A & 512 && (_[r | 0] = 35, r = r + 1 | 0); ; ) {
                  if (m = me[s | 0], m) {
                    _[r | 0] = m, r = r + 1 | 0, s = s + 1 | 0;
                    continue;
                  }
                  break;
                }
                m = A & 74, s = 111;
                e: {
                  if ((m | 0) == 64 || (s = A & 16384 ? 88 : 120, (m | 0) == 8))
                    break e;
                  s = u ? 100 : 117;
                }
                _[r | 0] = s;
              }
              function wl(r) {
                var s = 0, u = 0, A = 0;
                if (s = e[r >> 2], e[r >> 2] = 0, s) {
                  if (r = e[s + 28 >> 2], r && (e[s + 32 >> 2] = r, Br(r)), u = e[s + 16 >> 2], u) {
                    if (r = u, A = e[s + 20 >> 2], (r | 0) != (A | 0)) {
                      for (; r = A - 12 | 0, _[A - 1 | 0] < 0 && Br(e[r >> 2]), A = r, (r | 0) != (u | 0); )
                        ;
                      r = e[s + 16 >> 2];
                    }
                    e[s + 20 >> 2] = u, Br(r);
                  }
                  r = e[s + 4 >> 2], r && (e[s + 8 >> 2] = r, Br(r)), Br(s);
                }
              }
              function qp(r, s) {
                r = r | 0, s = s | 0;
                var u = 0, A = 0, m = 0;
                if (e[r + 8 >> 2] = 0, e[r >> 2] = 0, e[r + 4 >> 2] = 0, e[5996] = 0, u = Mi(3, 12) | 0, A = e[5996], e[5996] = 0, (A | 0) != 1) {
                  e[r >> 2] = u, A = u + 12 | 0, e[r + 8 >> 2] = A, e[u + 8 >> 2] = e[s + 8 >> 2], m = e[s + 4 >> 2], e[u >> 2] = e[s >> 2], e[u + 4 >> 2] = m, e[s >> 2] = 0, e[s + 4 >> 2] = 0, e[s + 8 >> 2] = 0, e[r + 4 >> 2] = A;
                  return;
                }
                s = Hr() | 0, ea(r), Jn(s | 0), Oi();
              }
              function Op(r, s, u, A, m, p) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0, m = m | 0, p = p | 0;
                var N = 0, W = 0;
                return N = Jr - 32 | 0, Jr = N, W = e[3163], e[N + 24 >> 2] = e[3162], e[N + 28 >> 2] = W, W = e[3161], e[N + 16 >> 2] = e[3160], e[N + 20 >> 2] = W, W = e[3159], e[N + 8 >> 2] = e[3158], e[N + 12 >> 2] = W, W = e[3157], e[N >> 2] = e[3156], e[N + 4 >> 2] = W, W = r, r = N + 32 | 0, s = Wu(W, s, u, A, m, p, N, r), Jr = r, s | 0;
              }
              function Qp(r) {
                r = r | 0;
                var s = 0, u = 0, A = 0, m = 0;
                u = e[r + 44 >> 2], s = e[r + 24 >> 2], u >>> 0 < s >>> 0 && (e[r + 44 >> 2] = s, u = s), A = -1;
                e: {
                  if (!(me[r + 48 | 0] & 8) || (s = e[r + 16 >> 2], s >>> 0 < u >>> 0 && (m = e[r + 8 >> 2], s = e[r + 12 >> 2], e[r + 16 >> 2] = u, e[r + 12 >> 2] = s, e[r + 8 >> 2] = m, s = e[r + 16 >> 2]), r = e[r + 12 >> 2], r >>> 0 >= s >>> 0))
                    break e;
                  A = me[r | 0];
                }
                return A | 0;
              }
              function Up(r, s, u, A) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0;
                var m = 0, p = 0;
                if (eu(r, e[s + 8 >> 2], 0)) {
                  Bl(s, u, A);
                  return;
                }
                p = e[r + 12 >> 2], pf(e[r + 16 >> 2], e[r + 20 >> 2], s, u, A), m = r + 24 | 0, r = (r + 16 | 0) + (p << 3) | 0;
                e: {
                  if (m >>> 0 >= r >>> 0)
                    break e;
                  for (; ; ) {
                    if (pf(e[m >> 2], e[m + 4 >> 2], s, u, A), me[s + 54 | 0])
                      break e;
                    if (m = m + 8 | 0, !(r >>> 0 > m >>> 0))
                      break;
                  }
                }
              }
              function Ba(r, s) {
                var u = 0, A = 0, m = 0, p = 0, N = 0;
                if (A = me[r + 11 | 0], u = A << 24 >> 24, u = (u | 0) < 0, m = u ? e[r + 4 >> 2] : A, p = e[s + 4 >> 2], m >>> 0 <= p >>> 0) {
                  if (A = e[s >> 2], m)
                    for (r = u ? e[r >> 2] : r, N = m + r | 0, u = A; ; ) {
                      if (me[r | 0] != me[u | 0])
                        return 0;
                      if (u = u + 1 | 0, r = r + 1 | 0, (N | 0) == (r | 0))
                        break;
                    }
                  e[s + 4 >> 2] = p - m, e[s >> 2] = A + m, r = 1;
                } else
                  r = 0;
                return r;
              }
              function Fa(r) {
                var s = 0, u = 0, A = 0;
                e: {
                  t: {
                    if (s = r, !(s & 3))
                      break t;
                    if (!me[s | 0])
                      return 0;
                    for (; ; ) {
                      if (s = s + 1 | 0, !(s & 3))
                        break t;
                      if (!me[s | 0])
                        break;
                    }
                    break e;
                  }
                  for (; u = s, s = s + 4 | 0, A = e[u >> 2], !((A ^ -1) & A - 16843009 & -2139062144); )
                    ;
                  for (; s = u, u = s + 1 | 0, !!me[s | 0]; )
                    ;
                }
                return s - r | 0;
              }
              function va(r, s, u) {
                var A = 0, m = 0;
                e: {
                  t: {
                    if (u >>> 0 >= 4) {
                      if ((r | s) & 3)
                        break t;
                      for (; ; ) {
                        if (e[r >> 2] != e[s >> 2])
                          break t;
                        if (s = s + 4 | 0, r = r + 4 | 0, u = u - 4 | 0, !(u >>> 0 > 3))
                          break;
                      }
                    }
                    if (!u)
                      break e;
                  }
                  for (; ; ) {
                    if (A = me[r | 0], m = me[s | 0], (A | 0) == (m | 0)) {
                      if (s = s + 1 | 0, r = r + 1 | 0, u = u - 1 | 0, u)
                        continue;
                      break e;
                    }
                    break;
                  }
                  return A - m | 0;
                }
                return 0;
              }
              function Mp(r, s) {
                r = r | 0, s = s | 0;
                var u = 0, A = 0;
                e: {
                  t: {
                    u = me[r + 11 | 0];
                    r: {
                      i: {
                        if ((u & 128) >>> 7 | 0) {
                          if (A = (e[r + 8 >> 2] & 2147483647) - 1 | 0, u = e[r + 4 >> 2], (A | 0) == (u | 0))
                            break i;
                          break r;
                        }
                        if (A = 1, u = u & 127, (u | 0) != 1)
                          break t;
                      }
                      Hh(r, A, 1, A, A), u = A;
                    }
                    A = e[r >> 2], e[r + 4 >> 2] = u + 1;
                    break e;
                  }
                  _[r + 11 | 0] = u + 1, A = r;
                }
                r = (u << 2) + A | 0, e[r >> 2] = s, e[r + 4 >> 2] = 0;
              }
              function Ya(r, s) {
                var u = 0, A = 0, m = 0, p = 0;
                A = Jr - 16 | 0, Jr = A;
                e: {
                  if (!s) {
                    s = 0;
                    break e;
                  }
                  u = s >> 31, m = (u ^ s) - u | 0, u = Fo(m), Ea(A, m, 0, 0, 0, u + 81 | 0), m = 0 + e[A + 8 >> 2] | 0, u = (e[A + 12 >> 2] ^ 65536) + (16414 - u << 16) | 0, u = m >>> 0 < p >>> 0 ? u + 1 | 0 : u, p = s & -2147483648 | u, u = e[A + 4 >> 2], s = e[A >> 2];
                }
                e[r >> 2] = s, e[r + 4 >> 2] = u, e[r + 8 >> 2] = m, e[r + 12 >> 2] = p, Jr = A + 16 | 0;
              }
              function oA(r, s, u) {
                var A = 0, m = 0, p = 0;
                return m = Jr - 16 | 0, Jr = m, A = Jr - 32 | 0, Jr = A, p = Jr - 16 | 0, Jr = p, e[p + 12 >> 2] = s, e[A + 24 >> 2] = r, e[A + 28 >> 2] = e[p + 12 >> 2], Jr = p + 16 | 0, Kd(A + 16 | 0, e[A + 24 >> 2], e[A + 28 >> 2], u), r = zd(r, e[A + 16 >> 2] - r >> 2), e[A + 12 >> 2] = e[A + 20 >> 2], e[m + 8 >> 2] = r, e[m + 12 >> 2] = e[A + 12 >> 2], Jr = A + 32 | 0, Jr = m + 16 | 0, e[m + 12 >> 2];
              }
              function qd(r, s, u, A) {
                var m = 0, p = 0, N = 0, W = 0;
                m = Jr - 160 | 0, Jr = m, e[m + 60 >> 2] = s, e[m + 20 >> 2] = s, e[m + 24 >> 2] = -1, p = m + 16 | 0, wu(p, 0, 0), sh(m, p, A, 1), A = e[m + 8 >> 2], N = e[m + 12 >> 2], p = e[m >> 2], W = e[m + 4 >> 2], u && (e[u >> 2] = ((e[m + 20 >> 2] + e[m + 136 >> 2] | 0) - e[m + 60 >> 2] | 0) + s), e[r + 8 >> 2] = A, e[r + 12 >> 2] = N, e[r >> 2] = p, e[r + 4 >> 2] = W, Jr = m + 160 | 0;
              }
              function aA(r, s, u) {
                var A = 0, m = 0, p = 0;
                return m = Jr - 16 | 0, Jr = m, A = Jr - 32 | 0, Jr = A, p = Jr - 16 | 0, Jr = p, e[p + 12 >> 2] = s, e[A + 24 >> 2] = r, e[A + 28 >> 2] = e[p + 12 >> 2], Jr = p + 16 | 0, Kd(A + 16 | 0, e[A + 24 >> 2], e[A + 28 >> 2], u), r = Jd(r, e[A + 16 >> 2] - r | 0), e[A + 12 >> 2] = e[A + 20 >> 2], e[m + 8 >> 2] = r, e[m + 12 >> 2] = e[A + 12 >> 2], Jr = A + 32 | 0, Jr = m + 16 | 0, e[m + 12 >> 2];
              }
              function Lp(r, s) {
                r = r | 0, s = s | 0;
                var u = 0, A = 0;
                e: {
                  t: {
                    u = me[r + 11 | 0];
                    r: {
                      i: {
                        if ((u & 128) >>> 7 | 0) {
                          if (A = (e[r + 8 >> 2] & 2147483647) - 1 | 0, u = e[r + 4 >> 2], (A | 0) == (u | 0))
                            break i;
                          break r;
                        }
                        if (A = 10, u = u & 127, (u | 0) != 10)
                          break t;
                      }
                      Al(r, A, 1, A, A), u = A;
                    }
                    A = e[r >> 2], e[r + 4 >> 2] = u + 1;
                    break e;
                  }
                  _[r + 11 | 0] = u + 1, A = r;
                }
                r = A + u | 0, _[r | 0] = s, _[r + 1 | 0] = 0;
              }
              function Hp(r, s, u, A, m) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0, m = m | 0;
                var p = 0, N = 0, W = 0;
                W = (m - A | 0) + s | 0;
                e: {
                  for (; ; ) {
                    if ((A | 0) != (m | 0)) {
                      if (r = -1, (s | 0) == (u | 0) || (p = _[s | 0], N = _[A | 0], (p | 0) < (N | 0)))
                        break e;
                      if ((p | 0) > (N | 0))
                        return 1;
                      A = A + 1 | 0, s = s + 1 | 0;
                      continue;
                    }
                    break;
                  }
                  r = (u | 0) != (W | 0);
                }
                return r | 0;
              }
              function El(r) {
                r = r | 0;
                var s = 0, u = 0;
                if (e[r >> 2] = 8512, e[5996] = 0, ji(133, r | 0, 0), s = e[5996], e[5996] = 0, (s | 0) != 1)
                  return s = e[r + 28 >> 2], u = e[s + 4 >> 2] - 1 | 0, e[s + 4 >> 2] = u, (u | 0) == -1 && xi[e[e[s >> 2] + 8 >> 2]](s), Br(e[r + 32 >> 2]), Br(e[r + 36 >> 2]), Br(e[r + 48 >> 2]), Br(e[r + 60 >> 2]), r | 0;
                Os(0) | 0, Na(), Oi();
              }
              function Jf(r, s, u) {
                var A = 0, m = 0, p = 0;
                e: {
                  if (!s) {
                    A = r;
                    break e;
                  }
                  for (; A = dd(r, s, 10), m = Ds, r = Ao(A, m, 246, 0) + r | 0, u = u - 1 | 0, _[u | 0] = r | 48, p = s >>> 0 > 9, r = A, s = m, !!p; )
                    ;
                }
                if (A)
                  for (; u = u - 1 | 0, r = (A >>> 0) / 10 | 0, _[u | 0] = Sn(r, 246) + A | 48, s = A >>> 0 > 9, A = r, !!s; )
                    ;
                return u;
              }
              function mu(r) {
                var s = 0, u = 0, A = 0, m = 0;
                if (A = e[r >> 2], A) {
                  if (s = A, u = e[r + 4 >> 2], (s | 0) != (u | 0)) {
                    for (; ; ) {
                      u = u - 32 | 0, s = e[u + 4 >> 2];
                      e: {
                        if (!s || (m = e[s + 4 >> 2], e[s + 4 >> 2] = m - 1, m))
                          break e;
                        xi[e[e[s >> 2] + 8 >> 2]](s), ys(s);
                      }
                      if ((A | 0) == (u | 0))
                        break;
                    }
                    s = e[r >> 2];
                  }
                  e[r + 4 >> 2] = A, Br(s);
                }
              }
              function Uo(r) {
                var s = 0, u = 0, A = 0, m = 0;
                if (A = e[r >> 2], A) {
                  if (s = A, u = e[r + 4 >> 2], (s | 0) != (u | 0)) {
                    for (; ; ) {
                      u = u - 8 | 0, s = e[u + 4 >> 2];
                      e: {
                        if (!s || (m = e[s + 4 >> 2], e[s + 4 >> 2] = m - 1, m))
                          break e;
                        xi[e[e[s >> 2] + 8 >> 2]](s), ys(s);
                      }
                      if ((A | 0) == (u | 0))
                        break;
                    }
                    s = e[r >> 2];
                  }
                  e[r + 4 >> 2] = A, Br(s);
                }
              }
              function Yf(r, s) {
                var u = 0, A = 0, m = 0, p = 0;
                u = Jr - 16 | 0, Jr = u;
                e: {
                  if (!s) {
                    s = 0;
                    break e;
                  }
                  A = s, s = Fo(s), Ea(u, A, 0, 0, 0, s + 81 | 0), A = 0 + e[u + 8 >> 2] | 0, s = (e[u + 12 >> 2] ^ 65536) + (16414 - s << 16) | 0, p = m >>> 0 > A >>> 0 ? s + 1 | 0 : s, m = e[u + 4 >> 2], s = e[u >> 2];
                }
                e[r >> 2] = s, e[r + 4 >> 2] = m, e[r + 8 >> 2] = A, e[r + 12 >> 2] = p, Jr = u + 16 | 0;
              }
              function Kp(r, s, u) {
                r = r | 0, s = s | 0, u = u | 0;
                var A = 0;
                A = e[s + 28 >> 2], e[r >> 2] = A, e[A + 4 >> 2] = e[A + 4 >> 2] + 1, aa(s + 28 | 0, u), e[5996] = 0, ji(133, s | 0, 1), s = e[5996], e[5996] = 0, (s | 0) == 1 && (u = Hr() | 0, r = e[r >> 2], s = e[r + 4 >> 2] - 1 | 0, e[r + 4 >> 2] = s, (s | 0) == -1 && xi[e[e[r >> 2] + 8 >> 2]](r), Jn(u | 0), Oi());
              }
              function Vp(r, s, u, A, m) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0, m = m | 0;
                var p = 0, N = 0;
                e: {
                  for (; ; ) {
                    if ((A | 0) != (m | 0)) {
                      if (r = -1, (s | 0) == (u | 0) || (p = e[s >> 2], N = e[A >> 2], (p | 0) < (N | 0)))
                        break e;
                      if ((p | 0) > (N | 0))
                        return 1;
                      A = A + 4 | 0, s = s + 4 | 0;
                      continue;
                    }
                    break;
                  }
                  r = (s | 0) != (u | 0);
                }
                return r | 0;
              }
              function qc(r) {
                r = r | 0;
                var s = 0, u = 0, A = 0, m = 0;
                for (e[r >> 2] = 12664, m = r + 8 | 0; ; ) {
                  if (s = e[r + 8 >> 2], e[r + 12 >> 2] - s >> 2 >>> 0 > u >>> 0) {
                    s = e[s + (u << 2) >> 2], s && (A = e[s + 4 >> 2] - 1 | 0, e[s + 4 >> 2] = A, (A | 0) == -1 && xi[e[e[s >> 2] + 8 >> 2]](s)), u = u + 1 | 0;
                    continue;
                  }
                  break;
                }
                return Qn(r + 152 | 0), Xo(m), r | 0;
              }
              function ff(r) {
                var s = 0, u = 0, A = 0, m = 0, p = 0;
                e: {
                  if (me[r + 4 | 0] || (m = e[r >> 2], s = e[m >> 2], !s))
                    break e;
                  if (u = s, A = e[m + 4 >> 2], (A | 0) != (s | 0)) {
                    for (; u = A - 12 | 0, p = e[u >> 2], p && (e[A - 8 >> 2] = p, Br(p)), A = u, (A | 0) != (s | 0); )
                      ;
                    u = e[e[r >> 2] >> 2];
                  }
                  e[m + 4 >> 2] = s, Br(u);
                }
              }
              function cA(r) {
                var s = 0, u = 0;
                return s = e[r + 72 >> 2], e[r + 72 >> 2] = s - 1 | s, e[r + 20 >> 2] != e[r + 28 >> 2] && xi[e[r + 36 >> 2]](r, 0, 0) | 0, e[r + 28 >> 2] = 0, e[r + 16 >> 2] = 0, e[r + 20 >> 2] = 0, s = e[r >> 2], s & 4 ? (e[r >> 2] = s | 32, -1) : (u = e[r + 44 >> 2] + e[r + 48 >> 2] | 0, e[r + 8 >> 2] = u, e[r + 4 >> 2] = u, s << 27 >> 31);
              }
              function wo(r, s) {
                var u = 0, A = 0, m = 0, p = 0;
                e: {
                  if (u = Fa(s), A = (me[r + 11 | 0] & 128) >>> 7 | 0 ? (e[r + 8 >> 2] & 2147483647) - 1 | 0 : 10, u >>> 0 <= A >>> 0) {
                    nc(r, fc((me[r + 11 | 0] & 128) >>> 7 | 0 ? e[r >> 2] : r, s, u), u);
                    break e;
                  }
                  m = r, p = e[r + 4 >> 2], r = me[r + 11 | 0], r = (r & 128) >>> 7 | 0 ? p : r & 127, Gf(m, A, u - A | 0, r, 0, r, u, s);
                }
              }
              function wu(r, s, u) {
                var A = 0, m = 0, p = 0, N = 0;
                e[r + 112 >> 2] = s, e[r + 116 >> 2] = u, m = e[r + 4 >> 2], A = e[r + 44 >> 2] - m | 0, e[r + 120 >> 2] = A, e[r + 124 >> 2] = A >> 31, A = e[r + 8 >> 2];
                e: {
                  if (!(s | u) || (p = A - m | 0, N = p >> 31, (u | 0) >= (N | 0) & s >>> 0 >= p >>> 0 | (u | 0) > (N | 0)))
                    break e;
                  A = s + m | 0;
                }
                e[r + 104 >> 2] = A;
              }
              function Oc(r, s) {
                var u = 0, A = 0, m = 0;
                if (Ca(+r), A = _s(1) | 0, m = _s(0) | 0, u = A >>> 20 & 2047, (u | 0) != 2047) {
                  if (!u)
                    return r == 0 ? u = 0 : (r = Oc(r * 18446744073709552e3, s), u = e[s >> 2] + -64 | 0), e[s >> 2] = u, r;
                  e[s >> 2] = u - 1022, Zo(0, m | 0), Zo(1, A & -2146435073 | 1071644672), r = +ru();
                }
                return r;
              }
              function AA(r) {
                var s = 0, u = 0, A = 0, m = 0;
                e: {
                  if (me[r + 4 | 0] || (m = e[r >> 2], s = e[m >> 2], !s))
                    break e;
                  if (u = s, A = e[m + 4 >> 2], (s | 0) != (A | 0)) {
                    for (; u = A - 12 | 0, _[A - 1 | 0] < 0 && Br(e[u >> 2]), A = u, (A | 0) != (s | 0); )
                      ;
                    u = e[e[r >> 2] >> 2];
                  }
                  e[m + 4 >> 2] = s, Br(u);
                }
              }
              function Od(r, s) {
                var u = 0, A = 0;
                for (A = Jr - 16 | 0, Jr = A, u = A + 4 | 0, e[u >> 2] = r, r = e[r + 4 >> 2], e[u + 4 >> 2] = r, e[u + 8 >> 2] = r + (s << 2), s = e[u + 4 >> 2], r = e[u + 8 >> 2]; ; ) {
                  if ((r | 0) == (s | 0))
                    e[e[u >> 2] + 4 >> 2] = e[u + 4 >> 2], Jr = A + 16 | 0;
                  else {
                    e[s >> 2] = 0, s = s + 4 | 0, e[u + 4 >> 2] = s;
                    continue;
                  }
                  break;
                }
              }
              function Na() {
                var r = 0;
                r = e[5728], e[5996] = 0, Nn(r | 0), r = e[5996], e[5996] = 0;
                e: {
                  if ((r | 0) != 1 && (e[5996] = 0, Nn(291), r = e[5996], e[5996] = 0, (r | 0) != 1) || (Cu(Os(0) | 0) | 0, e[5996] = 0, Nn(291), r = e[5996], e[5996] = 0, (r | 0) != 1))
                    break e;
                  Os(0) | 0, Na();
                }
                Oi();
              }
              function wA(r, s, u, A) {
                var m = 0, p = 0;
                m = Jr - 32 | 0, Jr = m, p = Jr - 16 | 0, Jr = p, e[p + 12 >> 2] = u, e[m + 24 >> 2] = s, e[m + 28 >> 2] = e[p + 12 >> 2], Jr = p + 16 | 0, Kd(m + 16 | 0, e[m + 24 >> 2], e[m + 28 >> 2], A), s = e[m + 16 >> 2], e[m + 12 >> 2] = e[m + 20 >> 2], e[r >> 2] = s, e[r + 4 >> 2] = e[m + 12 >> 2], Jr = m + 32 | 0;
              }
              function Xa(r, s, u) {
                if (u = u & 176, (u | 0) == 32)
                  return s;
                e: {
                  if ((u | 0) != 16)
                    break e;
                  t: {
                    r:
                      switch (u = me[r | 0], u - 43 | 0) {
                        case 0:
                        case 2:
                          break r;
                        default:
                          break t;
                      }
                    return r + 1 | 0;
                  }
                  if ((u | 0) != 48 | (s - r | 0) < 2 | (me[r + 1 | 0] | 32) != 120)
                    break e;
                  r = r + 2 | 0;
                }
                return r;
              }
              function bA(r, s) {
                r = r | 0, s = s | 0;
                var u = 0, A = 0;
                if (u = e[s + 48 >> 2], u & 16) {
                  A = e[s + 44 >> 2], u = e[s + 24 >> 2], A >>> 0 < u >>> 0 && (e[s + 44 >> 2] = u, A = u), pl(r, e[s + 20 >> 2], A);
                  return;
                }
                if (u & 8) {
                  pl(r, e[s + 8 >> 2], e[s + 16 >> 2]);
                  return;
                }
                e[r >> 2] = 0, e[r + 4 >> 2] = 0, e[r + 8 >> 2] = 0;
              }
              function e1(r) {
                r = r | 0;
                var s = 0, u = 0;
                e: {
                  t: {
                    if (!r || (s = r - 24 | 0, u = e[s >> 2] - 1 | 0, e[s >> 2] = u, me[s + 13 | 0] | u))
                      break t;
                    if (s = e[s + 8 >> 2], s && (e[5996] = 0, Mi(s | 0, r | 0) | 0, s = e[5996], e[5996] = 0, (s | 0) == 1))
                      break e;
                    Xu(r);
                  }
                  return;
                }
                Os(0) | 0, Na(), Oi();
              }
              function t1(r, s, u) {
                var A = 0, m = 0, p = 0, N = 0;
                for (A = Jr - 16 | 0, Jr = A, s = s - r >> 2; ; ) {
                  if (s) {
                    e[A + 12 >> 2] = r, m = s >>> 1 | 0, e[A + 12 >> 2] = e[A + 12 >> 2] + (m << 2), p = e[A + 12 >> 2], N = Ls[p >> 2] < u >>> 0, r = N ? p + 4 | 0 : r, s = N ? (m ^ -1) + s | 0 : m;
                    continue;
                  }
                  break;
                }
                return Jr = A + 16 | 0, r;
              }
              function Za(r, s) {
                r = r | 0, s = s | 0;
                var u = 0, A = 0, m = 0;
                if (u = Fa(s), u >>> 0 < 2147483632) {
                  e: {
                    if (u >>> 0 <= 10) {
                      _[r + 11 | 0] = u, A = r;
                      break e;
                    }
                    m = (u | 15) + 1 | 0, A = Qs(m), e[r + 8 >> 2] = m | -2147483648, e[r >> 2] = A, e[r + 4 >> 2] = u;
                  }
                  return _[Ys(A, s, u) + u | 0] = 0, r | 0;
                }
                Ra(), Oi();
              }
              function Gp(r, s, u, A, m, p) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0, m = m | 0, p = p | 0;
                var N = 0, W = 0, Te = 0, Xe = 0;
                return N = xi[e[e[r + 8 >> 2] + 20 >> 2]](r + 8 | 0) | 0, W = me[N + 11 | 0], Te = r, Xe = s, s = (W & 128) >>> 7 | 0, r = s ? e[N >> 2] : N, Wu(Te, Xe, u, A, m, p, r, r + ((s ? e[N + 4 >> 2] : W & 127) << 2) | 0) | 0;
              }
              function jp(r, s, u) {
                r = r | 0, s = s | 0, u = u | 0;
                var A = 0, m = 0;
                e: {
                  if (me[s | 0] != 47)
                    for (; ; ) {
                      if ((u | 0) == (A | 0)) {
                        m = pu(s, u), s = 0;
                        break e;
                      }
                      if (A = A + 1 | 0, me[A + s | 0] == 47)
                        break;
                    }
                  m = pu(s, A), s = pu((s + A | 0) + 1 | 0, (A ^ -1) + u | 0);
                }
                e[r + 4 >> 2] = s, e[r >> 2] = m;
              }
              function Ao(r, s, u, A) {
                var m = 0, p = 0, N = 0, W = 0, Te = 0, Xe = 0;
                return m = u >>> 16 | 0, p = r >>> 16 | 0, Xe = Sn(m, p), N = u & 65535, W = r & 65535, Te = Sn(N, W), p = (Te >>> 16 | 0) + Sn(p, N) | 0, m = (p & 65535) + Sn(m, W) | 0, Ds = (Sn(s, u) + Xe | 0) + Sn(r, A) + (p >>> 16) + (m >>> 16) | 0, Te & 65535 | m << 16;
              }
              function r1(r, s, u, A, m, p) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0, m = m | 0, p = p | 0;
                var N = 0, W = 0, Te = 0, Xe = 0;
                return N = xi[e[e[r + 8 >> 2] + 20 >> 2]](r + 8 | 0) | 0, W = me[N + 11 | 0], Te = r, Xe = s, s = (W & 128) >>> 7 | 0, r = s ? e[N >> 2] : N, ju(Te, Xe, u, A, m, p, r, r + (s ? e[N + 4 >> 2] : W & 127) | 0) | 0;
              }
              function bl(r, s) {
                r = r | 0, s = s | 0;
                var u = 0, A = 0;
                u = e[r >> 2];
                e: {
                  if (!u)
                    break e;
                  A = e[u + 24 >> 2];
                  t: {
                    if ((A | 0) == e[u + 28 >> 2]) {
                      s = xi[e[e[u >> 2] + 52 >> 2]](u, s) | 0;
                      break t;
                    }
                    e[u + 24 >> 2] = A + 4, e[A >> 2] = s;
                  }
                  if ((s | 0) != -1)
                    break e;
                  e[r >> 2] = 0;
                }
                return r | 0;
              }
              function i1(r, s, u, A) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0, A = Qs(104), e[A >> 2] = 7e3, e[A + 4 >> 2] = 0, e[A + 8 >> 2] = 0, e[5996] = 0, s = xn(143, A + 12 | 0, s | 0, u | 0) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1 && (r = Hr() | 0, Br(A), Jn(r | 0), Oi()), e[r + 4 >> 2] = A, e[r >> 2] = s;
              }
              function Bl(r, s, u) {
                var A = 0;
                if (A = e[r + 16 >> 2], !A) {
                  e[r + 36 >> 2] = 1, e[r + 24 >> 2] = u, e[r + 16 >> 2] = s;
                  return;
                }
                e: {
                  if ((s | 0) == (A | 0)) {
                    if (e[r + 24 >> 2] != 2)
                      break e;
                    e[r + 24 >> 2] = u;
                    return;
                  }
                  _[r + 54 | 0] = 1, e[r + 24 >> 2] = 2, e[r + 36 >> 2] = e[r + 36 >> 2] + 1;
                }
              }
              function Qd(r) {
                var s = 0, u = 0, A = 0;
                e: {
                  if (me[r + 12 | 0] || (s = e[e[r + 8 >> 2] >> 2], A = e[e[r + 4 >> 2] >> 2], (s | 0) == (A | 0)))
                    break e;
                  for (; r = s - 12 | 0, u = e[r >> 2], u && (e[s - 8 >> 2] = u, Br(u)), s = r, (r | 0) != (A | 0); )
                    ;
                }
              }
              function Wp(r, s, u, A, m, p) {
                var N = 0;
                N = Jr - 16 | 0, Jr = N, _[N + 15 | 0] = 0, _[N + 14 | 0] = p, _[N + 13 | 0] = m, _[N + 12 | 0] = 37, p && (m = me[N + 13 | 0], _[N + 13 | 0] = me[N + 14 | 0], _[N + 14 | 0] = m), e[u >> 2] = (j1(s | 0, e[u >> 2] - s | 0, N + 12 | 0, A | 0, r | 0) | 0) + s, Jr = N + 16 | 0;
              }
              function pa(r, s, u, A, m) {
                var p = 0;
                if (p = Jr - 256 | 0, Jr = p, !(m & 73728 | (u | 0) <= (A | 0))) {
                  if (A = u - A | 0, u = A >>> 0 < 256, nu(p, s & 255, u ? A : 256), !u)
                    for (; ba(r, p, 256), A = A - 256 | 0, A >>> 0 > 255; )
                      ;
                  ba(r, p, A);
                }
                Jr = p + 256 | 0;
              }
              function Xf(r) {
                var s = 0, u = 0, A = 0, m = 0;
                if (s = e[r >> 2], s) {
                  if (u = s, A = e[r + 4 >> 2], (A | 0) != (s | 0)) {
                    for (; u = A - 12 | 0, m = e[u >> 2], m && (e[A - 8 >> 2] = m, Br(m)), A = u, (A | 0) != (s | 0); )
                      ;
                    u = e[r >> 2];
                  }
                  e[r + 4 >> 2] = s, Br(u);
                }
              }
              function G4(r) {
                r = r | 0;
                var s = 0, u = 0, A = 0;
                if (r = e[6019], r) {
                  if (s = r, u = e[6020], (u | 0) != (r | 0)) {
                    for (; s = u - 12 | 0, A = e[s >> 2], A && (e[u - 8 >> 2] = A, Br(A)), u = s, (u | 0) != (r | 0); )
                      ;
                    s = e[6019];
                  }
                  e[6020] = r, Br(s);
                }
              }
              function j4(r) {
                r = r | 0;
                var s = 0, u = 0, A = 0;
                if (r = e[6049], r) {
                  if (s = r, u = e[6050], (u | 0) != (r | 0)) {
                    for (; s = u - 12 | 0, A = e[s >> 2], A && (e[u - 8 >> 2] = A, Br(A)), u = s, (u | 0) != (r | 0); )
                      ;
                    s = e[6049];
                  }
                  e[6050] = r, Br(s);
                }
              }
              function zp(r) {
                r = r | 0;
                var s = 0, u = 0, A = 0;
                if (r = e[6151], r) {
                  if (s = r, u = e[6152], (u | 0) != (r | 0)) {
                    for (; s = u - 12 | 0, A = e[s >> 2], A && (e[u - 8 >> 2] = A, Br(A)), u = s, (u | 0) != (r | 0); )
                      ;
                    s = e[6151];
                  }
                  e[6152] = r, Br(s);
                }
              }
              function n1(r) {
                r = r | 0;
                var s = 0, u = 0, A = 0;
                if (r = e[6055], r) {
                  if (s = r, u = e[6056], (u | 0) != (r | 0)) {
                    for (; s = u - 12 | 0, A = e[s >> 2], A && (e[u - 8 >> 2] = A, Br(A)), u = s, (u | 0) != (r | 0); )
                      ;
                    s = e[6055];
                  }
                  e[6056] = r, Br(s);
                }
              }
              function s1(r) {
                r = r | 0;
                var s = 0, u = 0, A = 0;
                if (r = e[6157], r) {
                  if (s = r, u = e[6158], (u | 0) != (r | 0)) {
                    for (; s = u - 12 | 0, A = e[s >> 2], A && (e[u - 8 >> 2] = A, Br(A)), u = s, (u | 0) != (r | 0); )
                      ;
                    s = e[6157];
                  }
                  e[6158] = r, Br(s);
                }
              }
              function Jp(r) {
                r = r | 0;
                var s = 0, u = 0, A = 0;
                if (r = e[6061], r) {
                  if (s = r, u = e[6062], (u | 0) != (r | 0)) {
                    for (; s = u - 12 | 0, A = e[s >> 2], A && (e[u - 8 >> 2] = A, Br(A)), u = s, (u | 0) != (r | 0); )
                      ;
                    s = e[6061];
                  }
                  e[6062] = r, Br(s);
                }
              }
              function Df(r) {
                r = r | 0;
                var s = 0, u = 0, A = 0;
                if (r = e[6163], r) {
                  if (s = r, u = e[6164], (u | 0) != (r | 0)) {
                    for (; s = u - 12 | 0, A = e[s >> 2], A && (e[u - 8 >> 2] = A, Br(A)), u = s, (u | 0) != (r | 0); )
                      ;
                    s = e[6163];
                  }
                  e[6164] = r, Br(s);
                }
              }
              function Yp(r) {
                r = r | 0;
                var s = 0, u = 0, A = 0;
                if (r = e[6067], r) {
                  if (s = r, u = e[6068], (u | 0) != (r | 0)) {
                    for (; s = u - 12 | 0, A = e[s >> 2], A && (e[u - 8 >> 2] = A, Br(A)), u = s, (u | 0) != (r | 0); )
                      ;
                    s = e[6067];
                  }
                  e[6068] = r, Br(s);
                }
              }
              function o1(r) {
                r = r | 0;
                var s = 0, u = 0, A = 0;
                if (r = e[6169], r) {
                  if (s = r, u = e[6170], (u | 0) != (r | 0)) {
                    for (; s = u - 12 | 0, A = e[s >> 2], A && (e[u - 8 >> 2] = A, Br(A)), u = s, (u | 0) != (r | 0); )
                      ;
                    s = e[6169];
                  }
                  e[6170] = r, Br(s);
                }
              }
              function Ud(r) {
                r = r | 0;
                var s = 0, u = 0, A = 0;
                if (r = e[6073], r) {
                  if (s = r, u = e[6074], (u | 0) != (r | 0)) {
                    for (; s = u - 12 | 0, A = e[s >> 2], A && (e[u - 8 >> 2] = A, Br(A)), u = s, (u | 0) != (r | 0); )
                      ;
                    s = e[6073];
                  }
                  e[6074] = r, Br(s);
                }
              }
              function a1(r) {
                r = r | 0;
                var s = 0, u = 0, A = 0;
                if (r = e[6175], r) {
                  if (s = r, u = e[6176], (u | 0) != (r | 0)) {
                    for (; s = u - 12 | 0, A = e[s >> 2], A && (e[u - 8 >> 2] = A, Br(A)), u = s, (u | 0) != (r | 0); )
                      ;
                    s = e[6175];
                  }
                  e[6176] = r, Br(s);
                }
              }
              function u1(r) {
                r = r | 0;
                var s = 0, u = 0, A = 0;
                if (r = e[6025], r) {
                  if (s = r, u = e[6026], (u | 0) != (r | 0)) {
                    for (; s = u - 12 | 0, A = e[s >> 2], A && (e[u - 8 >> 2] = A, Br(A)), u = s, (u | 0) != (r | 0); )
                      ;
                    s = e[6025];
                  }
                  e[6026] = r, Br(s);
                }
              }
              function Xp(r) {
                r = r | 0;
                var s = 0, u = 0, A = 0;
                if (r = e[6031], r) {
                  if (s = r, u = e[6032], (u | 0) != (r | 0)) {
                    for (; s = u - 12 | 0, A = e[s >> 2], A && (e[u - 8 >> 2] = A, Br(A)), u = s, (u | 0) != (r | 0); )
                      ;
                    s = e[6031];
                  }
                  e[6032] = r, Br(s);
                }
              }
              function _p(r) {
                r = r | 0;
                var s = 0, u = 0, A = 0;
                if (r = e[6081], r) {
                  if (s = r, u = e[6082], (u | 0) != (r | 0)) {
                    for (; s = u - 12 | 0, A = e[s >> 2], A && (e[u - 8 >> 2] = A, Br(A)), u = s, (u | 0) != (r | 0); )
                      ;
                    s = e[6081];
                  }
                  e[6082] = r, Br(s);
                }
              }
              function zo(r) {
                r = r | 0;
                var s = 0, u = 0, A = 0;
                if (r = e[6037], r) {
                  if (s = r, u = e[6038], (u | 0) != (r | 0)) {
                    for (; s = u - 12 | 0, A = e[s >> 2], A && (e[u - 8 >> 2] = A, Br(A)), u = s, (u | 0) != (r | 0); )
                      ;
                    s = e[6037];
                  }
                  e[6038] = r, Br(s);
                }
              }
              function Md(r) {
                r = r | 0;
                var s = 0, u = 0, A = 0;
                if (r = e[6085], r) {
                  if (s = r, u = e[6086], (u | 0) != (r | 0)) {
                    for (; s = u - 12 | 0, A = e[s >> 2], A && (e[u - 8 >> 2] = A, Br(A)), u = s, (u | 0) != (r | 0); )
                      ;
                    s = e[6085];
                  }
                  e[6086] = r, Br(s);
                }
              }
              function Ms(r) {
                r = r | 0;
                var s = 0, u = 0, A = 0;
                if (r = e[6089], r) {
                  if (s = r, u = e[6090], (u | 0) != (r | 0)) {
                    for (; s = u - 12 | 0, A = e[s >> 2], A && (e[u - 8 >> 2] = A, Br(A)), u = s, (u | 0) != (r | 0); )
                      ;
                    s = e[6089];
                  }
                  e[6090] = r, Br(s);
                }
              }
              function cf(r) {
                r = r | 0;
                var s = 0, u = 0, A = 0;
                if (r = e[6093], r) {
                  if (s = r, u = e[6094], (u | 0) != (r | 0)) {
                    for (; s = u - 12 | 0, A = e[s >> 2], A && (e[u - 8 >> 2] = A, Br(A)), u = s, (u | 0) != (r | 0); )
                      ;
                    s = e[6093];
                  }
                  e[6094] = r, Br(s);
                }
              }
              function Cs(r) {
                r = r | 0;
                var s = 0, u = 0, A = 0;
                if (r = e[6097], r) {
                  if (s = r, u = e[6098], (u | 0) != (r | 0)) {
                    for (; s = u - 12 | 0, A = e[s >> 2], A && (e[u - 8 >> 2] = A, Br(A)), u = s, (u | 0) != (r | 0); )
                      ;
                    s = e[6097];
                  }
                  e[6098] = r, Br(s);
                }
              }
              function Zp(r) {
                r = r | 0;
                var s = 0, u = 0, A = 0;
                if (r = e[6101], r) {
                  if (s = r, u = e[6102], (u | 0) != (r | 0)) {
                    for (; s = u - 12 | 0, A = e[s >> 2], A && (e[u - 8 >> 2] = A, Br(A)), u = s, (u | 0) != (r | 0); )
                      ;
                    s = e[6101];
                  }
                  e[6102] = r, Br(s);
                }
              }
              function Eu(r) {
                r = r | 0;
                var s = 0, u = 0, A = 0;
                if (r = e[6105], r) {
                  if (s = r, u = e[6106], (u | 0) != (r | 0)) {
                    for (; s = u - 12 | 0, A = e[s >> 2], A && (e[u - 8 >> 2] = A, Br(A)), u = s, (u | 0) != (r | 0); )
                      ;
                    s = e[6105];
                  }
                  e[6106] = r, Br(s);
                }
              }
              function Qc(r) {
                r = r | 0;
                var s = 0, u = 0, A = 0;
                if (r = e[6043], r) {
                  if (s = r, u = e[6044], (u | 0) != (r | 0)) {
                    for (; s = u - 12 | 0, A = e[s >> 2], A && (e[u - 8 >> 2] = A, Br(A)), u = s, (u | 0) != (r | 0); )
                      ;
                    s = e[6043];
                  }
                  e[6044] = r, Br(s);
                }
              }
              function Fd(r) {
                var s = 0, u = 0, A = 0;
                for (A = e[r >> 2]; ; ) {
                  if (u = _[A | 0], u - 48 >>> 0 < 10) {
                    A = A + 1 | 0, e[r >> 2] = A, s >>> 0 <= 214748364 ? (u = u - 48 | 0, s = Sn(s, 10), s = (u | 0) > (s ^ 2147483647) ? -1 : u + s | 0) : s = -1;
                    continue;
                  }
                  break;
                }
                return s;
              }
              function $p(r) {
                r = r | 0;
                var s = 0, u = 0, A = 0;
                if (r = e[6109], r) {
                  if (s = r, u = e[6110], (u | 0) != (r | 0)) {
                    for (; s = u - 12 | 0, A = e[s >> 2], A && (e[u - 8 >> 2] = A, Br(A)), u = s, (u | 0) != (r | 0); )
                      ;
                    s = e[6109];
                  }
                  e[6110] = r, Br(s);
                }
              }
              function vl(r) {
                r = r | 0;
                var s = 0, u = 0, A = 0;
                if (r = e[6113], r) {
                  if (s = r, u = e[6114], (u | 0) != (r | 0)) {
                    for (; s = u - 12 | 0, A = e[s >> 2], A && (e[u - 8 >> 2] = A, Br(A)), u = s, (u | 0) != (r | 0); )
                      ;
                    s = e[6113];
                  }
                  e[6114] = r, Br(s);
                }
              }
              function Cl(r) {
                r = r | 0;
                var s = 0, u = 0, A = 0;
                if (r = e[6117], r) {
                  if (s = r, u = e[6118], (u | 0) != (r | 0)) {
                    for (; s = u - 12 | 0, A = e[s >> 2], A && (e[u - 8 >> 2] = A, Br(A)), u = s, (u | 0) != (r | 0); )
                      ;
                    s = e[6117];
                  }
                  e[6118] = r, Br(s);
                }
              }
              function e4(r) {
                r = r | 0;
                var s = 0, u = 0, A = 0;
                if (r = e[6121], r) {
                  if (s = r, u = e[6122], (u | 0) != (r | 0)) {
                    for (; s = u - 12 | 0, A = e[s >> 2], A && (e[u - 8 >> 2] = A, Br(A)), u = s, (u | 0) != (r | 0); )
                      ;
                    s = e[6121];
                  }
                  e[6122] = r, Br(s);
                }
              }
              function Hs(r) {
                r = r | 0;
                var s = 0, u = 0, A = 0;
                if (r = e[6125], r) {
                  if (s = r, u = e[6126], (u | 0) != (r | 0)) {
                    for (; s = u - 12 | 0, A = e[s >> 2], A && (e[u - 8 >> 2] = A, Br(A)), u = s, (u | 0) != (r | 0); )
                      ;
                    s = e[6125];
                  }
                  e[6126] = r, Br(s);
                }
              }
              function La(r) {
                r = r | 0;
                var s = 0, u = 0, A = 0;
                if (r = e[6129], r) {
                  if (s = r, u = e[6130], (u | 0) != (r | 0)) {
                    for (; s = u - 12 | 0, A = e[s >> 2], A && (e[u - 8 >> 2] = A, Br(A)), u = s, (u | 0) != (r | 0); )
                      ;
                    s = e[6129];
                  }
                  e[6130] = r, Br(s);
                }
              }
              function po(r) {
                r = r | 0;
                var s = 0, u = 0, A = 0;
                if (r = e[6133], r) {
                  if (s = r, u = e[6134], (u | 0) != (r | 0)) {
                    for (; s = u - 12 | 0, A = e[s >> 2], A && (e[u - 8 >> 2] = A, Br(A)), u = s, (u | 0) != (r | 0); )
                      ;
                    s = e[6133];
                  }
                  e[6134] = r, Br(s);
                }
              }
              function f1(r) {
                r = r | 0;
                var s = 0, u = 0, A = 0;
                if (r = e[6137], r) {
                  if (s = r, u = e[6138], (u | 0) != (r | 0)) {
                    for (; s = u - 12 | 0, A = e[s >> 2], A && (e[u - 8 >> 2] = A, Br(A)), u = s, (u | 0) != (r | 0); )
                      ;
                    s = e[6137];
                  }
                  e[6138] = r, Br(s);
                }
              }
              function Ha(r) {
                var s = 0, u = 0;
                e: {
                  if (me[r + 12 | 0] || (s = e[e[r + 8 >> 2] >> 2], u = e[e[r + 4 >> 2] >> 2], (s | 0) == (u | 0)))
                    break e;
                  for (; r = s - 12 | 0, _[s - 1 | 0] < 0 && Br(e[r >> 2]), s = r, (r | 0) != (u | 0); )
                    ;
                }
              }
              function bu(r, s) {
                var u = 0;
                return s = Wo(s), u = e[r + 12 >> 2], r = e[r + 8 >> 2], s >>> 0 < u - r >> 2 >>> 0 ? u = e[r + (s << 2) >> 2] != 0 : u = 0, u || (r = cu(4), e[r >> 2] = 22892, e[r >> 2] = 22736, Ua(r | 0, 22872, 173), Oi()), e[r + (s << 2) >> 2];
              }
              function ea(r) {
                var s = 0, u = 0, A = 0;
                if (s = e[r >> 2], s) {
                  if (u = s, A = e[r + 4 >> 2], (s | 0) != (A | 0)) {
                    for (; u = A - 12 | 0, _[A - 1 | 0] < 0 && Br(e[u >> 2]), A = u, (A | 0) != (s | 0); )
                      ;
                    u = e[r >> 2];
                  }
                  e[r + 4 >> 2] = s, Br(u);
                }
              }
              function Uc(r, s, u, A) {
                e: {
                  if (!r)
                    break e;
                  t:
                    switch (s + 2 | 0) {
                      case 0:
                        _[r | 0] = u;
                        return;
                      case 1:
                        Zs[r >> 1] = u;
                        return;
                      case 2:
                      case 3:
                        e[r >> 2] = u;
                        return;
                      case 5:
                        break t;
                      default:
                        break e;
                    }
                  e[r >> 2] = u, e[r + 4 >> 2] = A;
                }
              }
              function Mc(r) {
                var s = 0;
                return s = e[r + 72 >> 2], e[r + 72 >> 2] = s - 1 | s, s = e[r >> 2], s & 8 ? (e[r >> 2] = s | 32, -1) : (e[r + 4 >> 2] = 0, e[r + 8 >> 2] = 0, s = e[r + 44 >> 2], e[r + 28 >> 2] = s, e[r + 20 >> 2] = s, e[r + 16 >> 2] = s + e[r + 48 >> 2], 0);
              }
              function $s(r, s, u, A, m, p, N, W, Te) {
                var Xe = 0;
                Xe = Jr - 16 | 0, Jr = Xe, Ka(Xe, s, u, A, m, p, N, W, Te ^ -2147483648), A = e[Xe >> 2], u = e[Xe + 4 >> 2], s = e[Xe + 12 >> 2], e[r + 8 >> 2] = e[Xe + 8 >> 2], e[r + 12 >> 2] = s, e[r >> 2] = A, e[r + 4 >> 2] = u, Jr = Xe + 16 | 0;
              }
              function Qs(r) {
                r = r | 0;
                var s = 0;
                r = r >>> 0 <= 1 ? 1 : r;
                e: {
                  for (; ; ) {
                    if (s = da(r), s)
                      break e;
                    if (s = e[6704], s) {
                      xi[s | 0]();
                      continue;
                    }
                    break;
                  }
                  r = cu(4), e[r >> 2] = 22892, e[r >> 2] = 22364, Ua(r | 0, 22448, 5), Oi();
                }
                return s | 0;
              }
              function _f(r, s) {
                var u = 0, A = 0;
                u = me[r | 0], A = me[s | 0];
                e: {
                  if (!u | (u | 0) != (A | 0))
                    break e;
                  for (; ; ) {
                    if (A = me[s + 1 | 0], u = me[r + 1 | 0], !u)
                      break e;
                    if (s = s + 1 | 0, r = r + 1 | 0, (u | 0) != (A | 0))
                      break;
                  }
                }
                return u - A | 0;
              }
              function vo(r, s, u) {
                r = r | 0, s = s | 0, u = u | 0;
                var A = 0, m = 0, p = 0;
                return m = e[r + 84 >> 2], A = u + 256 | 0, p = lu(m, 0, A), A = p ? p - m | 0 : A, u = u >>> 0 > A >>> 0 ? A : u, so(s, m, u), s = m + A | 0, e[r + 84 >> 2] = s, e[r + 8 >> 2] = s, e[r + 4 >> 2] = u + m, u | 0;
              }
              function xo(r, s, u, A, m, p) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0, m = m | 0, p = p | 0;
                var N = 0, W = 0;
                return N = Jr - 16 | 0, Jr = N, e[N + 8 >> 2] = 624576549, e[N + 12 >> 2] = 1394948685, W = r, r = N + 16 | 0, s = ju(W, s, u, A, m, p, N + 8 | 0, r), Jr = r, s | 0;
              }
              function t4(r, s, u, A) {
                for (r = r | 0, s = s | 0, u = u | 0, A = A | 0; ; ) {
                  if ((s | 0) != (u | 0)) {
                    r = e[s >> 2], r >>> 0 <= 127 ? r = e[(r << 2) + 12736 >> 2] : r = 0, e[A >> 2] = r, A = A + 4 | 0, s = s + 4 | 0;
                    continue;
                  }
                  break;
                }
                return u | 0;
              }
              function c1(r) {
                var s = 0, u = 0;
                if (s = e[r >> 2], s) {
                  u = e[s + 12 >> 2];
                  e: {
                    if ((u | 0) == e[s + 16 >> 2]) {
                      s = xi[e[e[s >> 2] + 36 >> 2]](s) | 0;
                      break e;
                    }
                    s = e[u >> 2];
                  }
                  if ((s | 0) != -1)
                    return !e[r >> 2];
                  e[r >> 2] = 0;
                }
                return 1;
              }
              function l1(r) {
                var s = 0, u = 0;
                if (s = e[r >> 2], s) {
                  u = e[s + 12 >> 2];
                  e: {
                    if ((u | 0) == e[s + 16 >> 2]) {
                      s = xi[e[e[s >> 2] + 36 >> 2]](s) | 0;
                      break e;
                    }
                    s = me[u | 0];
                  }
                  if ((s | 0) != -1)
                    return !e[r >> 2];
                  e[r >> 2] = 0;
                }
                return 1;
              }
              function d1(r) {
                var s = 0, u = 0, A = 0;
                if (s = e[r >> 2], s) {
                  if (A = s, u = e[r + 4 >> 2], (u | 0) != (s | 0)) {
                    for (; u = u - 12 | 0, ft(e[u + 4 >> 2]), (s | 0) != (u | 0); )
                      ;
                    A = e[r >> 2];
                  }
                  e[r + 4 >> 2] = s, Br(A);
                }
              }
              function r4(r, s, u) {
                r = r | 0, s = s | 0, u = u | 0;
                var A = 0;
                A = Qs(104), e[5996] = 0, s = xn(147, A | 0, s | 0, u | 0) | 0, u = e[5996], e[5996] = 0, (u | 0) == 1 && (r = Hr() | 0, Br(A), Jn(r | 0), Oi()), e[r + 4 >> 2] = s, e[r >> 2] = s + 12;
              }
              function i4(r, s, u, A) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0;
                e: {
                  for (; ; ) {
                    if ((u | 0) == (A | 0))
                      break e;
                    if (r = e[u >> 2], !(r >>> 0 > 127 | !(e[(r << 2) + 12736 >> 2] & s))) {
                      u = u + 4 | 0;
                      continue;
                    }
                    break;
                  }
                  A = u;
                }
                return A | 0;
              }
              function n4(r, s, u, A) {
                for (r = r | 0, s = s | 0, u = u | 0, A = A | 0; ; ) {
                  e: {
                    if ((u | 0) != (A | 0)) {
                      if (r = e[u >> 2], r >>> 0 > 127 | !(e[(r << 2) + 12736 >> 2] & s))
                        break e;
                    } else
                      u = A;
                    return u | 0;
                  }
                  u = u + 4 | 0;
                }
              }
              function s4(r) {
                r = r | 0;
                var s = 0, u = 0;
                return s = Jr - 16 | 0, Jr = s, u = e[Uu(s + 12 | 0, e[r + 8 >> 2]) >> 2], u && (e[6178] = (u | 0) == -1 ? 24816 : u), Jr = s + 16 | 0, r = e[r + 8 >> 2], r ? (Gc(r) | 0) == 1 | 0 : 1;
              }
              function kl(r) {
                var s = 0, u = 0;
                if (r) {
                  kl(e[r >> 2]), kl(e[r + 4 >> 2]), s = e[r + 28 >> 2];
                  e: {
                    if (!s || (u = e[s + 4 >> 2], e[s + 4 >> 2] = u - 1, u))
                      break e;
                    xi[e[e[s >> 2] + 8 >> 2]](s), ys(s);
                  }
                  Br(r);
                }
              }
              function o4(r) {
                r = r | 0;
                var s = 0, u = 0;
                s = Jr - 16 | 0, Jr = s, $f() >>> 0 <= 29 && (Jo(), Oi()), p4(s + 8 | 0, r + 16 | 0, 30), u = e[s + 8 >> 2], e[r + 4 >> 2] = u, e[r >> 2] = u, e[r + 8 >> 2] = (e[s + 12 >> 2] << 2) + u, Jr = s + 16 | 0;
              }
              function Va(r) {
                var s = 0, u = 0, A = 0;
                if (s = e[r >> 2], s) {
                  if (A = s, u = e[r + 4 >> 2], (u | 0) != (s | 0)) {
                    for (; u = Ma(u - 56 | 0), (u | 0) != (s | 0); )
                      ;
                    A = e[r >> 2];
                  }
                  e[r + 4 >> 2] = s, Br(A);
                }
              }
              function a4(r) {
                r = r | 0;
                var s = 0, u = 0;
                if (r = e[6076], r) {
                  if (u = r, s = e[6077], (s | 0) != (r | 0)) {
                    for (; s = s - 4 | 0, wl(s), (r | 0) != (s | 0); )
                      ;
                    u = e[6076];
                  }
                  e[6077] = r, Br(u);
                }
              }
              function lf(r, s, u) {
                r = r | 0, s = s | 0, u = u | 0;
                var A = 0;
                return A = Jr - 16 | 0, Jr = A, e[A + 12 >> 2] = e[u >> 2], r = xi[e[e[r >> 2] + 16 >> 2]](r, s, A + 12 | 0) | 0, r && (e[u >> 2] = e[A + 12 >> 2]), Jr = A + 16 | 0, r | 0;
              }
              function df(r, s, u) {
                r = r | 0, s = s | 0, u = u | 0;
                var A = 0;
                for (r = 0; ; ) {
                  if ((s | 0) != (u | 0)) {
                    r = e[s >> 2] + (r << 4) | 0, A = r & -268435456, r = (A | A >>> 24) ^ r, s = s + 4 | 0;
                    continue;
                  }
                  break;
                }
                return r | 0;
              }
              function Fc(r, s, u, A, m) {
                return r = r | 0, s = s | 0, u = u | 0, A = A | 0, m = m | 0, r = Jr - 16 | 0, Jr = r, e[r + 12 >> 2] = m, e[r + 8 >> 2] = A - u, Jr = r + 16 | 0, s = r + 8 | 0, r = r + 12 | 0, e[(Ls[s >> 2] < Ls[r >> 2] ? s : r) >> 2];
              }
              function oa(r, s, u, A, m) {
                var p = 0;
                return p = Jr - 16 | 0, Jr = p, e[p + 12 >> 2] = m, u = Uu(p + 8 | 0, u), s = ul(r, s, A, e[p + 12 >> 2]), r = e[u >> 2], r && (e[6178] = (r | 0) == -1 ? 24816 : r), Jr = p + 16 | 0, s;
              }
              function Sl(r, s, u) {
                r = r | 0, s = s | 0, u = u | 0;
                var A = 0;
                for (r = 0; ; ) {
                  if ((s | 0) != (u | 0)) {
                    r = _[s | 0] + (r << 4) | 0, A = r & -268435456, r = (A | A >>> 24) ^ r, s = s + 1 | 0;
                    continue;
                  }
                  break;
                }
                return r | 0;
              }
              function Lc(r, s) {
                r = r | 0, s = s | 0;
                var u = 0;
                if (u = e[r + 4 >> 2], u >>> 0 < Ls[r + 8 >> 2]) {
                  e[u >> 2] = e[s >> 2], e[u + 4 >> 2] = e[s + 4 >> 2], e[s >> 2] = 0, e[s + 4 >> 2] = 0, e[r + 4 >> 2] = u + 8;
                  return;
                }
                yd(r, s);
              }
              function ia(r, s) {
                var u = 0;
                u = e[r >> 2], e[r >> 2] = s;
                e: {
                  if (u && (r = e[r + 4 >> 2], e[5996] = 0, qo(r | 0, u | 0), r = e[5996], e[5996] = 0, (r | 0) == 1))
                    break e;
                  return;
                }
                Os(0) | 0, Na(), Oi();
              }
              function Nf(r, s, u) {
                var A = 0;
                return A = Jr - 16 | 0, Jr = A, e[A + 12 >> 2] = u, s = Uu(A + 8 | 0, s), u = oh(r, 1937, e[A + 12 >> 2]), r = e[s >> 2], r && (e[6178] = (r | 0) == -1 ? 24816 : r), Jr = A + 16 | 0, u;
              }
              function Pf(r, s, u) {
                for (r = r | 0, s = s | 0, u = u | 0; ; ) {
                  if ((s | 0) != (u | 0)) {
                    r = e[s >> 2], r >>> 0 <= 127 && (r = e[(r << 2) + 11184 >> 2]), e[s >> 2] = r, s = s + 4 | 0;
                    continue;
                  }
                  break;
                }
                return u | 0;
              }
              function qu(r) {
                var s = 0, u = 0;
                if (e[5996] = 0, u = Ll(168) | 0, s = e[5996], e[5996] = 0, (s | 0) != 1) {
                  s = r, r = e[u >> 2], e[s >> 2] = r, e[r + 4 >> 2] = e[r + 4 >> 2] + 1;
                  return;
                }
                Os(0) | 0, Na(), Oi();
              }
              function Tl(r, s, u) {
                for (r = r | 0, s = s | 0, u = u | 0; ; ) {
                  if ((s | 0) != (u | 0)) {
                    r = e[s >> 2], r >>> 0 <= 127 && (r = e[(r << 2) + 9648 >> 2]), e[s >> 2] = r, s = s + 4 | 0;
                    continue;
                  }
                  break;
                }
                return u | 0;
              }
              function Sa(r) {
                var s = 0, u = 0, A = 0;
                return s = Jr - 16 | 0, Jr = s, u = me[r + 11 | 0], A = (u & 128) >>> 7 | 0, e[s + 12 >> 2] = (A ? e[r >> 2] : r) + ((A ? e[r + 4 >> 2] : u & 127) << 2), Jr = s + 16 | 0, e[s + 12 >> 2];
              }
              function Zf(r, s, u, A, m) {
                for (r = r | 0, s = s | 0, u = u | 0, A = A | 0, m = m | 0; ; ) {
                  if ((s | 0) != (u | 0)) {
                    r = e[s >> 2], _[m | 0] = r >>> 0 < 128 ? r : A, m = m + 1 | 0, s = s + 4 | 0;
                    continue;
                  }
                  break;
                }
                return u | 0;
              }
              function aa(r, s) {
                var u = 0, A = 0;
                u = e[s >> 2], e[u + 4 >> 2] = e[u + 4 >> 2] + 1, u = e[r >> 2], A = e[u + 4 >> 2] - 1 | 0, e[u + 4 >> 2] = A, (A | 0) == -1 && xi[e[e[u >> 2] + 8 >> 2]](u), e[r >> 2] = e[s >> 2];
              }
              function hf(r, s) {
                var u = 0;
                e: {
                  if ((r | 0) == (s | 0))
                    break e;
                  for (; ; ) {
                    if (s = s - 4 | 0, s >>> 0 <= r >>> 0)
                      break e;
                    u = e[r >> 2], e[r >> 2] = e[s >> 2], e[s >> 2] = u, r = r + 4 | 0;
                  }
                }
              }
              function Rl(r, s, u) {
                r = r | 0, s = s | 0, u = u | 0;
                var A = 0;
                return A = Jr - 16 | 0, Jr = A, xi[e[e[r >> 2] + 12 >> 2]](A + 8 | 0, r, s), Jr = A + 16 | 0, e[A + 12 >> 2] == e[u + 4 >> 2] & e[A + 8 >> 2] == e[u >> 2];
              }
              function Hc(r) {
                r = r | 0;
                var s = 0, u = 0;
                s = cu(8), e[5996] = 0, r = pi(91, s | 0, r | 0) | 0, u = e[5996], e[5996] = 0, (u | 0) != 1 && (Ua(r | 0, 22664, 92), Oi()), r = Hr() | 0, Xu(s), Jn(r | 0), Oi();
              }
              function Ld(r, s, u) {
                for (r = r | 0, s = s | 0, u = u | 0; ; ) {
                  if ((s | 0) != (u | 0)) {
                    r = _[s | 0], (r | 0) >= 0 && (r = e[(r << 2) + 11184 >> 2]), _[s | 0] = r, s = s + 1 | 0;
                    continue;
                  }
                  break;
                }
                return u | 0;
              }
              function Kc(r, s, u, A, m) {
                for (r = r | 0, s = s | 0, u = u | 0, A = A | 0, m = m | 0; ; ) {
                  if ((s | 0) != (u | 0)) {
                    r = _[s | 0], _[m | 0] = (r | 0) < 0 ? A : r, m = m + 1 | 0, s = s + 1 | 0;
                    continue;
                  }
                  break;
                }
                return u | 0;
              }
              function Ou(r, s, u) {
                for (r = r | 0, s = s | 0, u = u | 0; ; ) {
                  if ((s | 0) != (u | 0)) {
                    r = _[s | 0], (r | 0) >= 0 && (r = e[(r << 2) + 9648 >> 2]), _[s | 0] = r, s = s + 1 | 0;
                    continue;
                  }
                  break;
                }
                return u | 0;
              }
              function Vc(r, s, u, A, m, p) {
                if (r = r | 0, s = s | 0, u = u | 0, A = A | 0, m = m | 0, p = p | 0, eu(r, e[s + 8 >> 2], p)) {
                  Dd(s, u, A, m);
                  return;
                }
                r = e[r + 8 >> 2], xi[e[e[r >> 2] + 20 >> 2]](r, s, u, A, m, p);
              }
              function Bu(r) {
                var s = 0, u = 0, A = 0;
                return s = Jr - 16 | 0, Jr = s, u = me[r + 11 | 0], A = (u & 128) >>> 7 | 0, e[s + 12 >> 2] = (A ? e[r >> 2] : r) + (A ? e[r + 4 >> 2] : u & 127), Jr = s + 16 | 0, e[s + 12 >> 2];
              }
              function qf(r, s) {
                r = r | 0, s = s | 0;
                var u = 0, A = 0;
                for (u = e[r + 40 >> 2]; ; ) {
                  if (u) {
                    u = u - 1 | 0, A = u << 2, xi[e[e[r + 32 >> 2] + A >> 2]](s, r, e[A + e[r + 36 >> 2] >> 2]);
                    continue;
                  }
                  break;
                }
              }
              function du(r, s) {
                var u = 0;
                e: {
                  if ((r | 0) == (s | 0))
                    break e;
                  for (; ; ) {
                    if (s = s - 1 | 0, s >>> 0 <= r >>> 0)
                      break e;
                    u = me[r | 0], _[r | 0] = me[s | 0], _[s | 0] = u, r = r + 1 | 0;
                  }
                }
              }
              function $f() {
                var r = 0, s = 0;
                return r = Jr - 16 | 0, Jr = r, e[r + 12 >> 2] = 1073741823, e[r + 8 >> 2] = 2147483647, Jr = r + 16 | 0, s = r + 8 | 0, r = r + 12 | 0, e[(Ls[s >> 2] < Ls[r >> 2] ? s : r) >> 2];
              }
              function $a(r, s) {
                var u = 0;
                (me[r + 11 | 0] & 128) >>> 7 | 0 && Br(e[r >> 2]), u = e[s + 4 >> 2], e[r >> 2] = e[s >> 2], e[r + 4 >> 2] = u, e[r + 8 >> 2] = e[s + 8 >> 2], _[s + 11 | 0] = 0, e[s >> 2] = 0;
              }
              function xl(r, s) {
                var u = 0;
                if (!((me[s + 11 | 0] & 128) >>> 7 | 0)) {
                  u = e[s + 4 >> 2], e[r >> 2] = e[s >> 2], e[r + 4 >> 2] = u, e[r + 8 >> 2] = e[s + 8 >> 2];
                  return;
                }
                Il(r, e[s >> 2], e[s + 4 >> 2]);
              }
              function Af(r) {
                return me[25164] ? e[6290] : (me[26312] || (_[26312] = 1), So(26288, 19200), So(26300, 19212), _[25164] = 1, e[6290] = 26288, 26288);
              }
              function ca(r, s) {
                var u = 0;
                (me[r + 11 | 0] & 128) >>> 7 | 0 && Br(e[r >> 2]), u = e[s + 4 >> 2], e[r >> 2] = e[s >> 2], e[r + 4 >> 2] = u, e[r + 8 >> 2] = e[s + 8 >> 2], _[s + 11 | 0] = 0, _[s | 0] = 0;
              }
              function gf() {
                var r = 0, s = 0, u = 0;
                s = cu(8), e[5996] = 0, r = Mi(125, s | 0) | 0, u = e[5996], e[5996] = 0, (u | 0) != 1 && (Ua(r | 0, 22632, 7), Oi()), r = Hr() | 0, Xu(s), Jn(r | 0), Oi();
              }
              function vu(r) {
                return me[25156] ? e[6288] : (me[26280] || (_[26280] = 1), wo(26256, 3116), wo(26268, 3113), _[25156] = 1, e[6288] = 26256, 26256);
              }
              function Qu(r) {
                var s = 0, u = 0;
                s = cu(8), e[5996] = 0, r = pi(6, s | 0, r | 0) | 0, u = e[5996], e[5996] = 0, (u | 0) != 1 && (Ua(r | 0, 22580, 7), Oi()), r = Hr() | 0, Xu(s), Jn(r | 0), Oi();
              }
              function pf(r, s, u, A, m) {
                var p = 0;
                p = u, u = 0;
                e: {
                  if (!A || (u = s >> 8, !(s & 1)))
                    break e;
                  u = e[u + e[A >> 2] >> 2];
                }
                xi[e[e[r >> 2] + 28 >> 2]](r, p, u + A | 0, s & 2 ? m : 2);
              }
              function tc(r, s, u) {
                var A = 0;
                for (A = Jr - 16 | 0, Jr = A, _[A + 15 | 0] = u, u = r; ; ) {
                  if (s) {
                    _[u | 0] = me[A + 15 | 0], s = s - 1 | 0, u = u + 1 | 0;
                    continue;
                  }
                  break;
                }
                return Jr = A + 16 | 0, r;
              }
              function Gc(r) {
                var s = 0, u = 0;
                return s = Jr - 16 | 0, Jr = s, r = Uu(s + 12 | 0, r), u = e[e[6178] >> 2] ? 4 : 1, r = e[r >> 2], r && (e[6178] = (r | 0) == -1 ? 24816 : r), Jr = s + 16 | 0, u;
              }
              function jc(r, s) {
                var u = 0;
                return u = e[r + 24 >> 2], (u | 0) == e[r + 28 >> 2] ? xi[e[e[r >> 2] + 52 >> 2]](r, s & 255) | 0 : (e[r + 24 >> 2] = u + 1, _[u | 0] = s, s & 255);
              }
              function h1(r, s, u, A, m) {
                var p = 0;
                return p = Jr - 16 | 0, Jr = p, m = Uu(p + 12 | 0, m), s = dl(r, s, u, A), r = e[m >> 2], r && (e[6178] = (r | 0) == -1 ? 24816 : r), Jr = p + 16 | 0, s;
              }
              function rc(r) {
                r = r | 0;
                var s = 0, u = 0;
                return e[r >> 2] = 7896, s = e[r + 4 >> 2], u = e[s + 4 >> 2] - 1 | 0, e[s + 4 >> 2] = u, (u | 0) == -1 && xi[e[e[s >> 2] + 8 >> 2]](s), r | 0;
              }
              function Wc() {
                var r = 0;
                return me[25032] ? e[6257] : (r = e[Yl() >> 2], e[6256] = r, e[r + 4 >> 2] = e[r + 4 >> 2] + 1, _[25032] = 1, e[6257] = 25024, 25024);
              }
              function A1(r) {
                _[24063] < 0 && Br(e[6013]), _[24051] < 0 && Br(e[6010]), _[24039] < 0 && Br(e[6007]), _[24027] < 0 && Br(e[6004]);
              }
              function u4(r) {
                r = r | 0;
                var s = 0;
                s = e[r + 12 >> 2];
                e: {
                  if ((s | 0) == e[r + 16 >> 2]) {
                    r = xi[e[e[r >> 2] + 36 >> 2]](r) | 0;
                    break e;
                  }
                  r = me[s | 0];
                }
                return r << 24 >> 24;
              }
              function uo(r, s, u, A) {
                for (s = s | 0, u = u | 0, A = A | 0; ; ) {
                  if ((s | 0) != (u | 0)) {
                    e[A >> 2] = _[s | 0], A = A + 4 | 0, s = s + 1 | 0;
                    continue;
                  }
                  break;
                }
                return u | 0;
              }
              function Dl(r) {
                return r = r | 0, e[r + 56 >> 2] = 8316, e[r >> 2] = 8296, e[r + 4 >> 2] = 7960, _[r + 47 | 0] < 0 && Br(e[r + 36 >> 2]), rc(r + 4 | 0), x4(r + 56 | 0), r | 0;
              }
              function Nl(r, s, u) {
                var A = 0;
                return A = Jr - 16 | 0, Jr = A, u = Uu(A + 12 | 0, u), s = vd(r, s), r = e[u >> 2], r && (e[6178] = (r | 0) == -1 ? 24816 : r), Jr = A + 16 | 0, s;
              }
              function Hd(r, s, u, A, m, p) {
                r = xi[e[e[r + 8 >> 2] + 4 >> 2]](r + 8 | 0) | 0, r = rl(u, A, r, r + 288 | 0, p, m, 0) - r | 0, (r | 0) <= 287 && (e[s >> 2] = ((r | 0) / 12 | 0) % 12);
              }
              function g1(r, s, u, A, m, p) {
                r = xi[e[e[r + 8 >> 2] + 4 >> 2]](r + 8 | 0) | 0, r = il(u, A, r, r + 288 | 0, p, m, 0) - r | 0, (r | 0) <= 287 && (e[s >> 2] = ((r | 0) / 12 | 0) % 12);
              }
              function f4(r) {
                r = r | 0;
                var s = 0;
                return (xi[e[e[r >> 2] + 36 >> 2]](r) | 0) != -1 ? (s = r, r = e[r + 12 >> 2], e[s + 12 >> 2] = r + 1, r = me[r | 0]) : r = -1, r | 0;
              }
              function p1(r, s, u, A) {
                for (s = s | 0, u = u | 0, A = A | 0; ; ) {
                  if ((s | 0) != (u | 0)) {
                    _[A | 0] = me[s | 0], A = A + 1 | 0, s = s + 1 | 0;
                    continue;
                  }
                  break;
                }
                return u | 0;
              }
              function ys(r) {
                var s = 0, u = 0;
                e: {
                  if (s = r + 8 | 0, e[s >> 2] && (u = s, s = e[s >> 2] - 1 | 0, e[u >> 2] = s, (s | 0) != -1))
                    break e;
                  xi[e[e[r >> 2] + 16 >> 2]](r);
                }
              }
              function c4(r, s, u, A) {
                if (r = r | 0, s = s | 0, u = u | 0, A = A | 0, eu(r, e[s + 8 >> 2], 0)) {
                  Bl(s, u, A);
                  return;
                }
                r = e[r + 8 >> 2], xi[e[e[r >> 2] + 28 >> 2]](r, s, u, A);
              }
              function y1(r, s, u, A, m, p) {
                r = xi[e[e[r + 8 >> 2] >> 2]](r + 8 | 0) | 0, r = rl(u, A, r, r + 168 | 0, p, m, 0) - r | 0, (r | 0) <= 167 && (e[s >> 2] = ((r | 0) / 12 | 0) % 7);
              }
              function I1(r, s, u, A, m, p) {
                r = xi[e[e[r + 8 >> 2] >> 2]](r + 8 | 0) | 0, r = il(u, A, r, r + 168 | 0, p, m, 0) - r | 0, (r | 0) <= 167 && (e[s >> 2] = ((r | 0) / 12 | 0) % 7);
              }
              function Kd(r, s, u, A) {
                var m = 0, p = 0;
                m = Jr - 16 | 0, Jr = m, p = s, s = u - s | 0, e[m + 12 >> 2] = Ys(A, p, s) + s, e[r >> 2] = u, e[r + 4 >> 2] = e[m + 12 >> 2], Jr = m + 16 | 0;
              }
              function l4(r) {
                r = r | 0;
                var s = 0;
                s = e[r + 12 >> 2];
                e: {
                  if ((s | 0) == e[r + 16 >> 2]) {
                    r = xi[e[e[r >> 2] + 36 >> 2]](r) | 0;
                    break e;
                  }
                  r = e[s >> 2];
                }
                return r | 0;
              }
              function Lo(r) {
                var s = 0;
                e: {
                  if (r = e[r + 4 >> 2], !r || (s = e[r + 4 >> 2], e[r + 4 >> 2] = s - 1, s))
                    break e;
                  xi[e[e[r >> 2] + 8 >> 2]](r), ys(r);
                }
              }
              function d4(r, s) {
                r = r | 0, s = s | 0;
                var u = 0;
                return u = r, r = me[s + 11 | 0], Rd(u, (r & 128) >>> 7 | 0 ? e[s >> 2] : s, (r & 128) >>> 7 | 0 ? e[s + 4 >> 2] : r & 127) | 0;
              }
              function m1(r) {
                var s = 0;
                return s = e[r + 12 >> 2], (s | 0) == e[r + 16 >> 2] ? xi[e[e[r >> 2] + 40 >> 2]](r) | 0 : (e[r + 12 >> 2] = s + 4, e[s >> 2]);
              }
              function w1(r) {
                var s = 0;
                return s = e[r + 12 >> 2], (s | 0) == e[r + 16 >> 2] ? xi[e[e[r >> 2] + 40 >> 2]](r) | 0 : (e[r + 12 >> 2] = s + 1, me[s | 0]);
              }
              function E1(r, s) {
                r = r | 0, s = s | 0;
                var u = 0;
                u = s, s = e[s >> 2] + 7 & -8, e[u >> 2] = s + 16, jn[r >> 3] = xu(e[s >> 2], e[s + 4 >> 2], e[s + 8 >> 2], e[s + 12 >> 2]);
              }
              function Vd(r, s, u) {
                for (u = u & 255; ; ) {
                  e: {
                    if ((r | 0) != (s | 0)) {
                      if ((u | 0) != me[r | 0])
                        break e;
                    } else
                      r = s;
                    return r;
                  }
                  r = r + 1 | 0;
                }
              }
              function h4(r) {
                r = r | 0;
                var s = 0, u = 0;
                u = e[r + 4 >> 2], s = e[r >> 2], r = e[r + 8 >> 2], s = s + (r >> 1) | 0, r & 1 && (u = e[u + e[s >> 2] >> 2]), xi[u | 0](s);
              }
              function b1(r, s, u, A, m, p, N, W, Te) {
                e[r >> 2] = s, e[r + 4 >> 2] = u, e[r + 8 >> 2] = A, e[r + 12 >> 2] = m & 65535 | (Te >>> 16 & 32768 | m >>> 16 & 32767) << 16;
              }
              function B1(r) {
                var s = 0;
                s = e[r >> 2], e[r >> 2] = 0, s && (r = e[s + 4 >> 2] - 1 | 0, e[s + 4 >> 2] = r, (r | 0) == -1 && xi[e[e[s >> 2] + 8 >> 2]](s));
              }
              function C1(r, s) {
                r = r | 0, s = s | 0;
                var u = 0;
                u = e[r >> 2];
                e: {
                  if (!u || (jc(u, s) | 0) != -1)
                    break e;
                  e[r >> 2] = 0;
                }
                return r | 0;
              }
              function Gd(r, s, u) {
                for (; ; ) {
                  e: {
                    if ((r | 0) != (s | 0)) {
                      if (e[r >> 2] != (u | 0))
                        break e;
                    } else
                      r = s;
                    return r;
                  }
                  r = r + 4 | 0;
                }
              }
              function jd(r, s, u, A, m, p, N) {
                var W = 0;
                W = s >> 8, s & 1 && (W = e[e[m >> 2] + W >> 2]), xi[e[e[r >> 2] + 20 >> 2]](r, u, A, m + W | 0, s & 2 ? p : 2, N);
              }
              function Wd(r, s) {
                var u = 0, A = 0;
                u = Fa(s), A = Qs(u + 13 | 0), e[A + 8 >> 2] = 0, e[A + 4 >> 2] = u, e[A >> 2] = u, e[r >> 2] = so(A + 12 | 0, s, u + 1 | 0);
              }
              function eu(r, s, u) {
                return u ? (r | 0) == (s | 0) ? 1 : !_f(e[r + 4 >> 2], e[s + 4 >> 2]) : e[r + 4 >> 2] == e[s + 4 >> 2];
              }
              function A4(r, s, u, A, m, p) {
                r = r | 0, e[r + 8 >> 2] = -1, e[r + 12 >> 2] = -1, e[r >> 2] = 0, e[r + 4 >> 2] = 0;
              }
              function g4(r, s) {
                return r = r | 0, s = s | 0, e[r >> 2] = 22892, e[r >> 2] = 22500, Wd(r + 4 | 0, (me[s + 11 | 0] & 128) >>> 7 | 0 ? e[s >> 2] : s), r | 0;
              }
              function zd(r, s) {
                var u = 0;
                return u = Jr - 16 | 0, Jr = u, e[u + 12 >> 2] = r, r = u + 12 | 0, e[r >> 2] = e[r >> 2] + (s << 2), Jr = u + 16 | 0, e[r >> 2];
              }
              function k1(r, s, u, A, m) {
                s = yu(s, u, A, m, 4), me[A | 0] & 4 || (e[r >> 2] = ((s | 0) < 69 ? s + 2e3 | 0 : (s | 0) < 100 ? s + 1900 | 0 : s) - 1900);
              }
              function Ga(r) {
                var s = 0;
                return s = Jr - 16 | 0, Jr = s, e[s + 12 >> 2] = (me[r + 11 | 0] & 128) >>> 7 | 0 ? e[r >> 2] : r, Jr = s + 16 | 0, e[s + 12 >> 2];
              }
              function S1(r, s, u, A, m) {
                s = Du(s, u, A, m, 4), me[A | 0] & 4 || (e[r >> 2] = ((s | 0) < 69 ? s + 2e3 | 0 : (s | 0) < 100 ? s + 1900 | 0 : s) - 1900);
              }
              function Pl(r, s, u, A, m, p) {
                var N = 0;
                N = s >> 8, s & 1 && (N = e[e[A >> 2] + N >> 2]), xi[e[e[r >> 2] + 24 >> 2]](r, u, A + N | 0, s & 2 ? m : 2, p);
              }
              function T1(r, s, u, A, m, p, N, W) {
                return u = u | 0, m = m | 0, p = p | 0, W = W | 0, e[m >> 2] = u, e[W >> 2] = p, 3;
              }
              function Jd(r, s) {
                var u = 0;
                return u = Jr - 16 | 0, Jr = u, e[u + 12 >> 2] = r, r = u + 12 | 0, e[r >> 2] = e[r >> 2] + s, Jr = u + 16 | 0, e[r >> 2];
              }
              function _u(r) {
                e: {
                  if (r = r & 74, r) {
                    if ((r | 0) == 64)
                      return 8;
                    if ((r | 0) != 8)
                      break e;
                    return 16;
                  }
                  return 0;
                }
                return 10;
              }
              function Uu(r, s) {
                var u = 0;
                return u = e[6178], s && (e[6178] = (s | 0) == -1 ? 24816 : s), e[r >> 2] = (u | 0) == 24816 ? -1 : u, r;
              }
              function p4(r, s, u) {
                e: {
                  if (!(me[s + 120 | 0] | u >>> 0 > 30)) {
                    _[s + 120 | 0] = 1;
                    break e;
                  }
                  s = Y4(u);
                }
                e[r + 4 >> 2] = u, e[r >> 2] = s;
              }
              function y4(r, s) {
                e[r + 4 >> 2], e[r + 4 >> 2] = s;
              }
              function W4(r, s, u, A) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0, xi[e[e[s >> 2] + 16 >> 2]](r, s, e[u + 8 >> 2], e[u + 12 >> 2], 0, A);
              }
              function ya(r) {
                var s = 0;
                s = e[r + 12 >> 2], s && (e[r + 16 >> 2] = s, Br(s)), s = e[r >> 2], s && (e[r + 4 >> 2] = s, Br(s));
              }
              function R1(r, s, u, A, m, p) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0, m = m | 0, p = p | 0, eu(r, e[s + 8 >> 2], p) && Dd(s, u, A, m);
              }
              function I4(r, s, u, A) {
                r = r | 0, e[r + 8 >> 2] = -1, e[r + 12 >> 2] = -1, e[r >> 2] = 0, e[r + 4 >> 2] = 0;
              }
              function ic(r, s, u, A, m) {
                return r = r | 0, s = s | 0, u = u | 0, A = A | 0, m = m | 0, xi[e[e[r >> 2] + 24 >> 2]](r, s, u, A, m) | 0;
              }
              function x1(r) {
                var s = 0, u = 0;
                for (u = r; s = u, u = s + 4 | 0, !!e[s >> 2]; )
                  ;
                return s - r >> 2;
              }
              function Yd(r) {
                r = r | 0;
                var s = 0;
                return e[r >> 2] = 12684, s = e[r + 8 >> 2], !s | !me[r + 12 | 0] || Br(s), r | 0;
              }
              function hu() {
                var r = 0;
                r = cu(4), e[r >> 2] = 22892, e[r >> 2] = 22364, e[r >> 2] = 22384, Ua(r | 0, 22460, 5), Oi();
              }
              function nc(r, s, u) {
                e: {
                  if ((me[r + 11 | 0] & 128) >>> 7 | 0) {
                    e[r + 4 >> 2] = u;
                    break e;
                  }
                  _[r + 11 | 0] = u;
                }
                _[s + u | 0] = 0;
              }
              function ql(r, s, u, A) {
                var m = 0;
                return m = Jr - 16 | 0, Jr = m, e[m + 12 >> 2] = A, r = ul(r, s, u, A), Jr = m + 16 | 0, r;
              }
              function Xd(r, s) {
                var u = 0;
                return u = Jr - 16 | 0, Jr = u, e[u + 12 >> 2] = s, r = oh(r, 2310, s), Jr = u + 16 | 0, r;
              }
              function D1(r) {
                (r | 0) != 0 & (r | 0) != 19324 & (r | 0) != 19348 & (r | 0) != 24732 & (r | 0) != 24756 && Br(r);
              }
              function z4(r, s) {
                r = r | 0, s = s | 0;
                var u = 0;
                u = w1(e[s >> 2]), e[r + 4 >> 2] = e[s >> 2], _[r | 0] = u << 24 >> 24;
              }
              function N1(r, s) {
                r = r | 0, s = s | 0, s = Jr - 16 | 0, Jr = s, _[r + 11 | 0] = 1, _[tc(r, 1, 45) + 1 | 0] = 0, Jr = s + 16 | 0;
              }
              function yf(r, s, u) {
                var A = 0;
                return A = Jr - 16 | 0, Jr = A, wA(A + 8 | 0, s, (u << 2) + s | 0, r), Jr = A + 16 | 0, r;
              }
              function Eo(r, s) {
                return s = s | 0, (s | 0) >= 0 && (s = e[((s & 255) << 2) + 11184 >> 2]), s << 24 >> 24;
              }
              function Do(r) {
                r = r | 0, r = e[6144], r && (e[6145] = r, Br(r)), r = e[6141], r && (e[6142] = r, Br(r));
              }
              function la(r, s, u) {
                var A = 0;
                return A = Jr - 16 | 0, Jr = A, wA(A + 8 | 0, r, s, u), Jr = A + 16 | 0, e[A + 12 >> 2];
              }
              function ua(r, s) {
                return s = s | 0, (s | 0) >= 0 && (s = e[((s & 255) << 2) + 9648 >> 2]), s << 24 >> 24;
              }
              function rr(r) {
                var s = 0;
                r = e[r >> 2] - 12 | 0, s = e[r + 8 >> 2] - 1 | 0, e[r + 8 >> 2] = s, (s | 0) < 0 && Br(r);
              }
              function ft(r) {
                r && (ft(e[r >> 2]), ft(e[r + 4 >> 2]), _[r + 27 | 0] < 0 && Br(e[r + 16 >> 2]), Br(r));
              }
              function dr(r) {
                for (r = r | 0, r = 26312; r = Qn(r - 12 | 0), (r | 0) != 26288; )
                  ;
              }
              function Or(r) {
                for (r = r | 0, r = 26240; r = Qn(r - 12 | 0), (r | 0) != 25952; )
                  ;
              }
              function Zr(r) {
                for (r = r | 0, r = 25640; r = Qn(r - 12 | 0), (r | 0) != 25472; )
                  ;
              }
              function ni(r) {
                for (r = r | 0, r = 26280; r = Qn(r - 12 | 0), (r | 0) != 26256; )
                  ;
              }
              function gi(r) {
                for (r = r | 0, r = 25936; r = Qn(r - 12 | 0), (r | 0) != 25648; )
                  ;
              }
              function vi(r) {
                for (r = r | 0, r = 25464; r = Qn(r - 12 | 0), (r | 0) != 25296; )
                  ;
              }
              function Fi(r) {
                return r = r | 0, e[r >> 2] = 13768, e[r + 8 >> 2] != (ko() | 0) && D1(e[r + 8 >> 2]), r | 0;
              }
              function Gi(r, s) {
                var u = 0;
                return u = e[s >> 2], e[s >> 2] = 0, ia(r, u), e[r + 4 >> 2] = e[s + 4 >> 2], r;
              }
              function Pn(r) {
                var s = 0;
                s = e[r >> 2], e[s >> 2] && (S6(s), r = e[r >> 2], Zd(r + 16 | 0, e[r >> 2]));
              }
              function Zi(r, s, u) {
                return s = s | 0, u = u | 0, (e[(u << 2) + 12736 >> 2] & s) != 0 & u >>> 0 <= 127;
              }
              function ds(r, s, u, A, m, p) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0, m = m | 0, p = p | 0, xi[r | 0](s, u, A, m, p);
              }
              function us(r, s) {
                return r = r | 0, s = s | 0, e[r >> 2] = 22892, e[r >> 2] = 22480, Wd(r + 4 | 0, s), r | 0;
              }
              function Is(r, s) {
                return r = r | 0, s = s | 0, e[r >> 2] = 22892, e[r >> 2] = 22500, Wd(r + 4 | 0, s), r | 0;
              }
              function $n(r, s, u, A, m) {
                return r = r | 0, s = s | 0, u = u | 0, A = A | 0, m = m | 0, xi[r | 0](s, u, A, m) | 0;
              }
              function As(r, s) {
                r = r | 0, s = s | 0;
                var u = 0;
                u = m1(e[s >> 2]), e[r + 4 >> 2] = e[s >> 2], e[r >> 2] = u;
              }
              function ms() {
                e[6593] = 0, e[6592] = 22008, e[6592] = 14144, e[6592] = 13768, e[6594] = ko();
              }
              function Ns(r) {
                for (var s = 0; ; ) {
                  if (r) {
                    r = r - 1 & r, s = s + 1 | 0;
                    continue;
                  }
                  break;
                }
                return s;
              }
              function Ts() {
                var r = 0;
                r = cu(4), e[r >> 2] = 22892, e[r >> 2] = 22364, Ua(r | 0, 22448, 5), Oi();
              }
              function oo(r, s, u, A) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0, eu(r, e[s + 8 >> 2], 0) && Bl(s, u, A);
              }
              function Ws(r, s) {
                var u = 0;
                return u = r, r = (s >>> 0) / 100 | 0, zc(zc(u, r), Sn(r, -100) + s | 0);
              }
              function Ks(r, s) {
                var u = 0;
                return u = r, r = (s >>> 0) / 1e4 | 0, Ws(zc(u, r), Sn(r, -1e4) + s | 0);
              }
              function Js(r, s) {
                var u = 0;
                return u = r, r = (s >>> 0) / 1e6 | 0, Ks(zc(u, r), Sn(r, -1e6) + s | 0);
              }
              function io(r, s, u, A) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0, xi[e[e[r >> 2] + 32 >> 2]](r, s, u, A) | 0;
              }
              function na(r, s, u, A) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0, xi[e[e[r >> 2] + 48 >> 2]](r, s, u, A) | 0;
              }
              function Xo(r) {
                var s = 0, u = 0;
                s = Jr - 16 | 0, Jr = s, u = s + 12 | 0, e[u >> 2] = r, Pn(u), Jr = s + 16 | 0;
              }
              function Go(r, s) {
                return s = s | 0, s >>> 0 <= 127 && (s = e[(s << 2) + 11184 >> 2]), s | 0;
              }
              function Ta(r, s, u) {
                return r = r | 0, s = s | 0, u = u | 0, e[s + 4 >> 2] == (r | 0) & e[s >> 2] == (u | 0);
              }
              function Pa() {
                e[6651] = 0, e[6650] = 22008, e[6650] = 14144, T6(26608), e[6650] = 16704;
              }
              function Mu() {
                e[6655] = 0, e[6654] = 22008, e[6654] = 14144, T6(26624), e[6654] = 16860;
              }
              function qs(r, s) {
                return s = s | 0, s >>> 0 <= 127 && (s = e[(s << 2) + 9648 >> 2]), s | 0;
              }
              function zs(r) {
                return me[25260] || (xf(25248, 14004), _[25260] = 1), 25248;
              }
              function Oo(r) {
                return me[25292] || (xf(25280, 14088), _[25292] = 1), 25280;
              }
              function sa(r) {
                return me[25196] || (xf(25184, 13932), _[25196] = 1), 25184;
              }
              function ta(r) {
                return me[25228] || (xf(25216, 13968), _[25228] = 1), 25216;
              }
              function ja(r, s, u) {
                return r = r | 0, s = s | 0, u = u | 0, xi[e[e[r >> 2] + 12 >> 2]](r, s, u) | 0;
              }
              function Au(r, s, u) {
                return r = r | 0, s = s | 0, u = u | 0, xi[e[e[r >> 2] + 48 >> 2]](r, s, u) | 0;
              }
              function su(r) {
                return me[25244] || (Za(25232, 2743), _[25244] = 1), 25232;
              }
              function If(r) {
                return me[25276] || (Za(25264, 1928), _[25276] = 1), 25264;
              }
              function mf(r) {
                return me[25180] || (Za(25168, 1139), _[25180] = 1), 25168;
              }
              function sc(r) {
                return me[25212] || (Za(25200, 2881), _[25212] = 1), 25200;
              }
              function Zu(r, s, u, A, m) {
                return u = u | 0, m = m | 0, e[m >> 2] = u, 3;
              }
              function Wa(r, s) {
                r = r | 0, _[r | 0] = 2, _[r + 1 | 0] = 3, _[r + 2 | 0] = 0, _[r + 3 | 0] = 4;
              }
              function _d(r) {
                r = r | 0, e[r + 16 >> 2] = e[r + 16 >> 2] | 1, _[r + 20 | 0] & 1 && (th(), Oi());
              }
              function wf(r, s, u, A, m) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0, m = m | 0, xi[r | 0](s, u, A, m);
              }
              function Ef(r) {
                return r = r | 0, e[r + 8 >> 2] != (ko() | 0) && D1(e[r + 8 >> 2]), r | 0;
              }
              function P1(r, s, u, A) {
                return r = r | 0, s = s | 0, u = u | 0, A = A | 0, xi[r | 0](s, u, A) | 0;
              }
              function oc(r, s, u, A, m, p) {
                r = r | 0, p = p | 0, xl(r, p);
              }
              function qa(r, s) {
                return s ? r << 24 | (r & 65280) << 8 | (r >>> 8 & 65280 | r >>> 24) : r;
              }
              function ac(r, s, u) {
                return s = s | 0, u = u | 0, (s >>> 0 < 128 ? s : u) << 24 >> 24;
              }
              function Of(r, s) {
                r = r | 0, s = s | 0;
                var u = 0;
                u = Qs(s), e[r + 4 >> 2] = s, e[r >> 2] = u;
              }
              function Zd(r, s) {
                e: {
                  if ((r | 0) == (s | 0)) {
                    _[s + 120 | 0] = 0;
                    break e;
                  }
                  Br(s);
                }
              }
              function D6(r) {
                r = r | 0;
                var s = 0;
                s = e[6259] + 1 | 0, e[6259] = s, e[r + 4 >> 2] = s;
              }
              function J4(r, s) {
                return r = r | 0, s = s | 0, xi[e[e[r >> 2] + 28 >> 2]](r, s) | 0;
              }
              function N6(r, s) {
                return r = r | 0, s = s | 0, r = us(r, s), e[r >> 2] = 22548, r | 0;
              }
              function P6(r, s) {
                return r = r | 0, s = s | 0, xi[e[e[r >> 2] + 44 >> 2]](r, s) | 0;
              }
              function q6(r, s) {
                return r = r | 0, s = s | 0, xi[e[e[r >> 2] + 12 >> 2]](r, s) | 0;
              }
              function O6(r) {
                return r = r | 0, r ? (fl(r, 22200) | 0) != 0 | 0 : 0;
              }
              function Q6(r) {
                return r = r | 0, r = e[r + 8 >> 2], r ? Gc(r) | 0 : 1;
              }
              function U6(r, s) {
                r = r | 0, s = s | 0, e[5996] || (e[5996] = r, e[5997] = s);
              }
              function Fu(r, s) {
                r = r | 0, e[r >> 2] = 0, e[r + 4 >> 2] = 0, e[r + 8 >> 2] = 0;
              }
              function Qn(r) {
                return (me[r + 11 | 0] & 128) >>> 7 | 0 && Br(e[r >> 2]), r;
              }
              function Y4(r) {
                return r >>> 0 >= 1073741824 && (hu(), Oi()), Qs(r << 2);
              }
              function M6(r, s, u, A) {
                r = r | 0, s = s | 0, u = u | 0, A = A | 0, xi[r | 0](s, u, A);
              }
              function X4(r) {
                return r = r | 0, e[r >> 2] = 7960, Qn(r + 32 | 0), rc(r) | 0;
              }
              function F6(r, s, u) {
                return s = s | 0, u = u | 0, ((s | 0) < 0 ? u : s) | 0;
              }
              function L6(r) {
                return r = r | 0, r = us(r, 2284), e[r >> 2] = 22600, r | 0;
              }
              function H6(r, s, u) {
                r = r | 0, s = s | 0, u = u | 0, e[r + 4 >> 2] = s, e[r >> 2] = u;
              }
              function K6(r) {
                return r = r | 0, r = Is(r, 1241), e[r >> 2] = 22684, r | 0;
              }
              function _4(r) {
                return r = r | 0, e[r >> 2] = 13856, Qn(r + 16 | 0), r | 0;
              }
              function Z4(r) {
                return r = r | 0, e[r >> 2] = 13816, Qn(r + 12 | 0), r | 0;
              }
              function m4(r) {
                return r = r | 0, e[r >> 2] = 22500, rr(r + 4 | 0), r | 0;
              }
              function $4(r) {
                return r = r | 0, e[r >> 2] = 22480, rr(r + 4 | 0), r | 0;
              }
              function zc(r, s) {
                return s = (s << 1) + 21664 | 0, la(s, s + 2 | 0, r);
              }
              function V6(r) {
                return r = r | 0, E4(e[e[r >> 2] - 12 >> 2] + r | 0) | 0;
              }
              function e6(r, s) {
                r = r | 0, s = s | 0, xi[e[e[s >> 2] + 24 >> 2]](r, s);
              }
              function t6(r, s) {
                r = r | 0, s = s | 0, xi[e[e[s >> 2] + 28 >> 2]](r, s);
              }
              function G6(r) {
                return r = r | 0, Dl(e[e[r >> 2] - 12 >> 2] + r | 0) | 0;
              }
              function r6(r, s) {
                r = r | 0, s = s | 0, xi[e[e[s >> 2] + 20 >> 2]](r, s);
              }
              function j6(r) {
                r = r | 0, r && (r = r - 24 | 0, e[r >> 2] = e[r >> 2] + 1);
              }
              function W6(r, s, u, A) {
                r = r | 0, u = u | 0, A = A | 0, wd(r, u, A);
              }
              function z6(r, s, u, A) {
                r = r | 0, u = u | 0, A = A | 0, zh(r, u, A);
              }
              function Ol(r, s) {
                var u = 0;
                u = Y4(s), e[r + 4 >> 2] = s, e[r >> 2] = u;
              }
              function J6(r) {
                return r = r | 0, xi[e[e[r >> 2] + 24 >> 2]](r) | 0;
              }
              function i6(r, s, u) {
                return r = ud(r, s, u, 0, -2147483648), r;
              }
              function n6(r) {
                return r = r | 0, xi[e[e[r >> 2] + 16 >> 2]](r) | 0;
              }
              function s6(r) {
                return r = r | 0, xi[e[e[r >> 2] + 12 >> 2]](r) | 0;
              }
              function o6(r, s) {
                return r = r | 0, s = s | 0, Rd(r, s, Fa(s)) | 0;
              }
              function Lu(r, s) {
                return r = r | 0, s = s | 0, l1(r) ^ l1(s) ^ 1;
              }
              function Hu(r, s) {
                return r = r | 0, s = s | 0, c1(r) ^ c1(s) ^ 1;
              }
              function Y6(r) {
                _[24003] < 0 && Br(e[5998]);
              }
              function X6(r) {
                return r = r | 0, r = Jr - r & -16, Jr = r, r | 0;
              }
              function a6(r, s) {
                return r ? vd(r, s) : 0;
              }
              function _6(r, s, u) {
                return r = r | 0, r | 0;
              }
              function uc(r, s, u) {
                return q4(18, r | 0, s | 0, u | 0) | 0;
              }
              function u6(r, s, u) {
                return -1;
              }
              function Z6(r) {
                r = r | 0, b6(e[e[r >> 2] - 12 >> 2] + r | 0);
              }
              function f6(r, s, u) {
                return r = ud(r, s, u, -1, -1), r;
              }
              function $6(r) {
                r = r | 0, B6(e[e[r >> 2] - 12 >> 2] + r | 0);
              }
              function q1(r, s, u, A) {
                V1(152, r | 0, s | 0, u | 0, A | 0);
              }
              function c6(r, s, u, A) {
                K1(155, r | 0, s | 0, u | 0, A | 0);
              }
              function ey(r) {
                return r = r | 0, e[r >> 2] = 7e3, r | 0;
              }
              function ty(r) {
                r = r | 0, xi[e[e[r >> 2] + 4 >> 2]](r);
              }
              function Ql(r) {
                return r = r | 0, w1(e[r >> 2]), r | 0;
              }
              function Ul(r) {
                return r = r | 0, m1(e[r >> 2]), r | 0;
              }
              function ry(r) {
                r = r | 0, Vo(r, 26616, Wo(24916));
              }
              function iy(r) {
                r = r | 0, Vo(r, 26632, Wo(24988));
              }
              function ny(r) {
                r = r | 0, Vo(r, 26640, Wo(24996));
              }
              function sy(r) {
                r = r | 0, Vo(r, 26320, Wo(24844));
              }
              function oy(r) {
                r = r | 0, Vo(r, 26328, Wo(24852));
              }
              function ay(r) {
                r = r | 0, Vo(r, 26352, Wo(25040));
              }
              function uy(r) {
                r = r | 0, Vo(r, 26360, Wo(25056));
              }
              function fy(r) {
                r = r | 0, Vo(r, 26368, Wo(25064));
              }
              function cy(r) {
                r = r | 0, Vo(r, 26384, Wo(25072));
              }
              function ly(r) {
                r = r | 0, Vo(r, 26392, Wo(25088));
              }
              function dy(r) {
                r = r | 0, Vo(r, 26400, Wo(25080));
              }
              function hy(r) {
                r = r | 0, Vo(r, 26408, Wo(25096));
              }
              function Ay(r) {
                r = r | 0, Vo(r, 26416, Wo(25104));
              }
              function gy(r) {
                r = r | 0, Vo(r, 26440, Wo(25112));
              }
              function py(r) {
                r = r | 0, Vo(r, 26472, Wo(24860));
              }
              function yy(r) {
                r = r | 0, Vo(r, 26480, Wo(24868));
              }
              function Iy(r) {
                r = r | 0, Vo(r, 26488, Wo(24876));
              }
              function my(r) {
                r = r | 0, Vo(r, 26496, Wo(24884));
              }
              function wy(r) {
                r = r | 0, Vo(r, 26504, Wo(24924));
              }
              function Ey(r) {
                r = r | 0, Vo(r, 26512, Wo(24932));
              }
              function by(r) {
                r = r | 0, Vo(r, 26520, Wo(24940));
              }
              function By(r) {
                r = r | 0, Vo(r, 26528, Wo(24948));
              }
              function vy(r) {
                r = r | 0, Vo(r, 26536, Wo(24956));
              }
              function Cy(r) {
                r = r | 0, Vo(r, 26544, Wo(24964));
              }
              function ky(r) {
                r = r | 0, Vo(r, 26552, Wo(24972));
              }
              function Sy(r) {
                r = r | 0, Vo(r, 26560, Wo(24980));
              }
              function Ty(r) {
                r = r | 0, Vo(r, 26568, Wo(24892));
              }
              function Ry(r) {
                r = r | 0, Vo(r, 26584, Wo(24900));
              }
              function xy(r) {
                r = r | 0, Vo(r, 26600, Wo(24908));
              }
              function Dy(r) {
                r = r | 0, Vo(r, 26336, Wo(25048));
              }
              function w4(r) {
                return r = r | 0, bu(r, 25048) | 0;
              }
              function E4(r) {
                return r = r | 0, x4(r + 4 | 0), r | 0;
              }
              function b4(r) {
                return r = r | 0, bu(r, 25040) | 0;
              }
              function Ny(r) {
                return r = r | 0, bu(r, 24876) | 0;
              }
              function bf(r, s, u) {
                return la(s, s + u | 0, r), r;
              }
              function B4(r) {
                return r = r | 0, bu(r, 25104) | 0;
              }
              function C4(r) {
                return r = r | 0, bu(r, 25112) | 0;
              }
              function Py(r, s) {
                r = r | 0, s = s | 0, xl(r, s + 16 | 0);
              }
              function qy(r, s) {
                r = r | 0, s = s | 0, xl(r, s + 12 | 0);
              }
              function Oy(r, s) {
                r = r | 0, xf(r, 13888);
              }
              function Qy(r, s) {
                r = r | 0, xf(r, 13908);
              }
              function l6(r, s) {
                return s = s | 0, s | 0;
              }
              function d6(r, s) {
                r = r | 0, Wh(r, 1, 45);
              }
              function k4(r, s, u) {
                return r = f6(r, s, u), r;
              }
              function h6(r, s, u) {
                return r = i6(r, s, u), r;
              }
              function Uy(r, s) {
                r = r | 0, Za(r, 2331);
              }
              function My(r, s) {
                r = r | 0, Za(r, 2350);
              }
              function O1(r) {
                return 2147483647;
              }
              function Fy(r) {
                return r = r | 0, e[r + 12 >> 2];
              }
              function da(r) {
                return r = r | 0, nl(8, r) | 0;
              }
              function Ly(r) {
                return r = r | 0, e[r + 8 >> 2];
              }
              function A6(r, s) {
                return -1;
              }
              function g6(r) {
                return r = r | 0, e[r + 4 >> 2];
              }
              function Hy(r, s) {
                return 0;
              }
              function Ky(r) {
                return r = r | 0, _[r + 8 | 0];
              }
              function Vy(r) {
                return r = r | 0, _[r + 9 | 0];
              }
              function fc(r, s, u) {
                return Ys(r, s, u);
              }
              function p6(r) {
                return r = r | 0, m4(r) | 0;
              }
              function y6(r) {
                me[r + 4 | 0] || Pn(r);
              }
              function I6(r) {
                return bu(r, 24932);
              }
              function m6(r) {
                return bu(r, 24924);
              }
              function w6(r) {
                return bu(r, 24948);
              }
              function E6(r) {
                return bu(r, 24940);
              }
              function Gy(r) {
                return 2176;
              }
              function jy(r) {
                return 1304;
              }
              function Wy(r) {
                return 2042;
              }
              function zy(r) {
                return 1969;
              }
              function Jy(r) {
                return 2524;
              }
              function Q1(r) {
                return 127;
              }
              function Bf(r) {
                return r = r | 0, r | 0;
              }
              function b6(r) {
                r = r | 0, Br(E4(r));
              }
              function U1(r) {
                r = r | 0, Br(m4(r));
              }
              function Yy(r) {
                Qn(25248);
              }
              function Xy(r) {
                Qn(25280);
              }
              function _y(r) {
                r = r | 0, Br(Yd(r));
              }
              function B6(r) {
                r = r | 0, Br(Dl(r));
              }
              function Zy(r) {
                Qn(25184);
              }
              function $y(r) {
                Qn(25216);
              }
              function e8(r) {
                r = r | 0, Br(qc(r));
              }
              function t8(r) {
                Qn(25232);
              }
              function r8(r) {
                r = r | 0, Br(X4(r));
              }
              function i8(r) {
                Qn(25168);
              }
              function n8(r) {
                Qn(25200);
              }
              function C6(r) {
                r = r | 0, Br(Ef(r));
              }
              function s8(r) {
                r = r | 0, Br(_4(r));
              }
              function o8(r) {
                r = r | 0, Br(El(r));
              }
              function a8(r) {
                r = r | 0, Br(Z4(r));
              }
              function u8(r) {
                r = r | 0, Br(Fi(r));
              }
              function S4(r) {
                r = r | 0, Br($4(r));
              }
              function f8(r) {
                r = r | 0, Br(rc(r));
              }
              function c8(r) {
                Qn(25264);
              }
              function l8(r) {
                return -1;
              }
              function M1(r) {
                return 4;
              }
              function T4(r) {
                return 1;
              }
              function ou(r) {
                return 0;
              }
              function k6(r) {
                return 2;
              }
              function R4(r, s) {
              }
              function S6(r) {
                y4(r, e[r >> 2]);
              }
              function T6(r) {
                e[r >> 2] = ko();
              }
              function Ra() {
                Qu(2284), Oi();
              }
              function Jo() {
                Qu(1687), Oi();
              }
              function Ho(r) {
                r = r | 0, Br(r);
              }
              function d8(r) {
                r = r | 0, yo = r;
              }
              function h8() {
                return Jr | 0;
              }
              function A8(r) {
                r = r | 0, Jr = r;
              }
              function g8(r) {
                Oi();
              }
              function to(r) {
                ia(r, 0);
              }
              function p8() {
                R6(), Oi();
              }
              function R6() {
                $c(), Oi();
              }
              function x4(r) {
                El(r);
              }
              function D4(r) {
              }
              Yn = me, Ro();
              var xi = ls([null, Y6, Ra, Qs, A1, Bf, N6, $4, Jo, Rp, G4, Jo, zg, u1, Xp, zo, Qc, us, cg, ag, j4, n1, Jp, Yp, Ud, a4, up, gh, dp, Ic, Za, U4, cd, of, Jo, hu, Kh, hh, xp, Uh, Il, Jo, Np, og, ga, jl, tg, Jo, H4, Dh, Xl, fg, Jo, lg, pu, Da, Jo, Su, Do, Jo, Vg, lh, Jo, ph, kf, Jg, Ru, _p, jp, Xg, Md, Ms, cf, Cs, Zp, Eu, $p, vl, Cl, e4, Hs, La, po, f1, Jo, Jo, ng, fh, tf, Gg, eg, Is, m4, Jo, Jo, Jo, Jo, o6, Lp, bd, Rd, nf, X1, zp, s1, Df, o1, a1, gf, yh, ef, nh, Jo, z1, kc, Lf, xd, $1, Nd, qg, Bp, Jo, J1, Jo, fu, L6, vh, cl, tl, Yl, Kp, fd, bA, qf, Co, Ny, lp, ic, kd, _d, W1, Y1, Jo, Yg, yd, Qh, cp, yp, ip, qp, r4, Lc, Fg, ad, wd, i1, Ep, rp, Mh, M4, K4, sg, yd, Wg, Lf, zl, E1, K6, Wc, J6, w4, J4, Rf, Bf, uf, g4, hp, p6, vo, kp, B4, e6, t6, rl, Ho, Ts, Lu, u4, q6, Ql, D6, h4, th, n6, r6, io, s6, b4, C4, e6, t6, il, Hu, l4, J4, Ul, n6, r6, na, s6, C1, nd, hg, Hf, bl, bh, P6, Au, Ih, Yu, D4, uh, Hc, _g, z4, Sp, _h, sf, ig, Zg, ja, As, Mp, _h, V4, vp, Q4, Ig, jg, yg, sy, oy, Dy, ay, uy, ms, fy, cy, ly, dy, hy, Ay, gy, py, yy, Iy, my, wy, Ey, by, By, vy, Cy, ky, Sy, Ty, Ry, Pa, xy, Mu, ry, iy, ny, o4, Eg, Zr, Or, dr, Yy, Xy, Zy, $y, vi, gi, ni, t8, c8, i8, n8, Of, d4, R6, ey, Ho, Lh, Hy, Ho, rc, f8, R4, _6, A4, I4, ou, ou, gp, l8, f4, A6, Sd, A6, X4, r8, ep, W4, Qp, bp, $g, Dl, B6, G6, $6, E4, b6, V6, Z6, Bf, Ho, Wy, H6, Rl, Ta, Sf, U1, g6, El, o8, qc, e8, ty, Yd, _y, Eo, Ld, ua, Ou, l6, p1, F6, Kc, Fi, u8, bc, mg, Pp, s4, ou, Xh, Q6, Z4, a8, Ky, Vy, qy, Uy, My, _4, s8, Ly, Fy, Py, Oy, Qy, Bf, Ho, Ho, Zi, t4, n4, i4, Go, Pf, qs, Tl, l6, uo, ac, Zf, Ho, T1, T1, Zu, T4, T4, Fc, T4, Ho, od, sd, Zu, ou, ou, Cc, M1, Ho, od, sd, Zu, ou, ou, Cc, M1, Ho, Ch, Bh, Zu, ou, ou, ld, M1, Ho, Ch, Bh, Zu, ou, ou, ld, M1, Bf, Ho, Hp, W6, Sl, Bf, Ho, Vp, z6, df, Ho, Mg, td, Ng, Og, Ec, Ec, Pg, Cg, lo, $l, wh, Ho, Ug, xg, Tg, Dg, Eh, Eh, Rg, kg, Sg, bg, Ag, Ho, L4, op, np, ap, sp, Qg, Bg, fp, Ho, F4, zu, Rh, hl, ll, rd, vg, Nh, Bf, Ho, k6, xo, r1, Ip, mp, Cd, ug, Dp, Ap, vu, su, If, mf, sc, Bf, Ho, k6, Op, Gp, wp, Gh, Wf, ch, $h, Fh, Af, zs, Oo, sa, ta, Ef, C6, Oh, Ef, C6, tp, Ho, Q1, Q1, Fu, Fu, Fu, N1, ou, Wa, Wa, Ho, Q1, Q1, Fu, Fu, Fu, N1, ou, Wa, Wa, Ho, O1, O1, Fu, Fu, Fu, d6, ou, Wa, Wa, Ho, O1, O1, Fu, Fu, Fu, d6, ou, Wa, Wa, Ho, Zl, Lg, Ho, wg, Hg, Ho, dg, pg, Ho, Ah, gg, Ho, u6, oc, R4, Ho, u6, pp, R4, p6, U1, Bf, g8, p8, $c, Bf, Ho, D4, D4, Tp, xh, Kg, Up, Ho, Jy, Ho, Gy, S4, g6, U1, S4, S4, U1, Ho, jy, Ho, R1, Cp, oo, Ho, Vc, qh, c4, Ho, zy]);
              function y8() {
                return iu.byteLength / 65536 | 0;
              }
              return { Y: Z1, Z: Ho, _: da, $: rf, aa: rg, ba: xi, ca: U6, da: d8, ea: h8, fa: A8, ga: X6, ha: e1, ia: j6, ja: lf, ka: O6, la: P1, ma: M6, na: wf, oa: wf, pa: ds, qa: $n };
            }
            return Oa(Xn);
          }(En);
        }, RuntimeError: Error };
        Et = [], typeof st != "object" && Bi("no native wasm support detected");
        var Dt, er = !1;
        function xt(Yi, En) {
          Yi || Bi(En);
        }
        var ir, sr, yr, wr;
        function qr() {
          var Yi = Dt.buffer;
          De.HEAP8 = ir = new Int8Array(Yi), De.HEAP16 = new Int16Array(Yi), De.HEAPU8 = sr = new Uint8Array(Yi), De.HEAPU16 = new Uint16Array(Yi), De.HEAP32 = yr = new Int32Array(Yi), De.HEAPU32 = wr = new Uint32Array(Yi), De.HEAPF32 = new Float32Array(Yi), De.HEAPF64 = new Float64Array(Yi);
        }
        var Mr = De.INITIAL_MEMORY || 16777216;
        xt(Mr >= 65536, "INITIAL_MEMORY should be larger than STACK_SIZE, was " + Mr + "! (STACK_SIZE=65536)"), De.wasmMemory ? Dt = De.wasmMemory : Dt = new st.Memory({ initial: Mr / 65536, maximum: Mr / 65536 }), qr(), Mr = Dt.buffer.byteLength;
        var Dr, Qr = [], Xr = [], Vr = [];
        function Ur() {
          if (De.preRun)
            for (typeof De.preRun == "function" && (De.preRun = [De.preRun]); De.preRun.length; )
              Fr(De.preRun.shift());
          Ir(Qr);
        }
        function Sr() {
          Ir(Xr);
        }
        function Gr() {
          if (De.postRun)
            for (typeof De.postRun == "function" && (De.postRun = [De.postRun]); De.postRun.length; )
              Ar(De.postRun.shift());
          Ir(Vr);
        }
        function Fr(Yi) {
          Qr.unshift(Yi);
        }
        function br(Yi) {
          Xr.unshift(Yi);
        }
        function Ar(Yi) {
          Vr.unshift(Yi);
        }
        var cr = 0, hr = null;
        function Wr(Yi) {
          cr++, De.monitorRunDependencies && De.monitorRunDependencies(cr);
        }
        function fi(Yi) {
          if (cr--, De.monitorRunDependencies && De.monitorRunDependencies(cr), cr == 0 && hr) {
            var En = hr;
            hr = null, En();
          }
        }
        function Bi(Yi) {
          De.onAbort && De.onAbort(Yi), Yi = "Aborted(" + Yi + ")", Ne(Yi), er = !0, Yi += ". Build with -sASSERTIONS for more info.";
          var En = new st.RuntimeError(Yi);
          throw Fe(En), En;
        }
        var $r = "data:application/octet-stream;base64,";
        function oi(Yi) {
          return Yi.startsWith($r);
        }
        var zr;
        zr = "bindings.wasm", oi(zr) || (zr = xe(zr));
        function ti(Yi) {
          if (Yi == zr && Et)
            return new Uint8Array(Et);
          var En = Po(Yi);
          if (En)
            return En;
          throw "sync fetching of the wasm failed: you can preload it to Module['wasmBinary'] manually, or emcc.py will do that for you when generating HTML (but not JS)";
        }
        function Lr(Yi, En) {
          var On, Xn = ti(Yi);
          On = new st.Module(Xn);
          var ls = new st.Instance(On, En);
          return [ls, On];
        }
        function Rr() {
          var Yi = { a: Ce };
          function En(Xn, ls) {
            var Yn = Xn.exports;
            return Me = Yn, Dr = Me.ba, br(Me.Y), fi(), Yn;
          }
          if (Wr(), De.instantiateWasm)
            try {
              return De.instantiateWasm(Yi, En);
            } catch (Xn) {
              Ne(`Module.instantiateWasm callback failed with error: ${Xn}`), Fe(Xn);
            }
          var On = Lr(zr, Yi);
          return En(On[0]);
        }
        var Ir = (Yi) => {
          for (; Yi.length > 0; )
            Yi.shift()(De);
        }, pr = typeof TextDecoder < "u" ? new TextDecoder("utf8") : void 0, Cr = (Yi, En, On) => {
          for (var Xn = En + On, ls = En; Yi[ls] && !(ls >= Xn); ) ++ls;
          if (ls - En > 16 && Yi.buffer && pr)
            return pr.decode(Yi.subarray(En, ls));
          for (var Yn = ""; En < ls; ) {
            var cs = Yi[En++];
            if (!(cs & 128)) {
              Yn += String.fromCharCode(cs);
              continue;
            }
            var ks = Yi[En++] & 63;
            if ((cs & 224) == 192) {
              Yn += String.fromCharCode((cs & 31) << 6 | ks);
              continue;
            }
            var ws = Yi[En++] & 63;
            if ((cs & 240) == 224 ? cs = (cs & 15) << 12 | ks << 6 | ws : cs = (cs & 7) << 18 | ks << 12 | ws << 6 | Yi[En++] & 63, cs < 65536)
              Yn += String.fromCharCode(cs);
            else {
              var Ro = cs - 65536;
              Yn += String.fromCharCode(55296 | Ro >> 10, 56320 | Ro & 1023);
            }
          }
          return Yn;
        }, Er = (Yi, En) => Yi ? Cr(sr, Yi, En) : "", xr = (Yi, En, On, Xn) => {
          Bi(`Assertion failed: ${Er(Yi)}, at: ` + [En ? Er(En) : "unknown filename", On, Xn ? Er(Xn) : "unknown function"]);
        }, si = [], Ci = 0, bi = (Yi) => {
          var En = new zi(Yi);
          return En.get_caught() || (En.set_caught(!0), Ci--), En.set_rethrown(!1), si.push(En), kr(En.excPtr), En.get_exception_ptr();
        }, Ri = 0, li = () => {
          Tt(0, 0);
          var Yi = si.pop();
          gr(Yi.excPtr), Ri = 0;
        };
        function zi(Yi) {
          this.excPtr = Yi, this.ptr = Yi - 24, this.set_type = function(En) {
            wr[this.ptr + 4 >> 2] = En;
          }, this.get_type = function() {
            return wr[this.ptr + 4 >> 2];
          }, this.set_destructor = function(En) {
            wr[this.ptr + 8 >> 2] = En;
          }, this.get_destructor = function() {
            return wr[this.ptr + 8 >> 2];
          }, this.set_caught = function(En) {
            En = En ? 1 : 0, ir[this.ptr + 12 >> 0] = En;
          }, this.get_caught = function() {
            return ir[this.ptr + 12 >> 0] != 0;
          }, this.set_rethrown = function(En) {
            En = En ? 1 : 0, ir[this.ptr + 13 >> 0] = En;
          }, this.get_rethrown = function() {
            return ir[this.ptr + 13 >> 0] != 0;
          }, this.init = function(En, On) {
            this.set_adjusted_ptr(0), this.set_type(En), this.set_destructor(On);
          }, this.set_adjusted_ptr = function(En) {
            wr[this.ptr + 16 >> 2] = En;
          }, this.get_adjusted_ptr = function() {
            return wr[this.ptr + 16 >> 2];
          }, this.get_exception_ptr = function() {
            var En = jr(this.get_type());
            if (En)
              return wr[this.excPtr >> 2];
            var On = this.get_adjusted_ptr();
            return On !== 0 ? On : this.excPtr;
          };
        }
        var Kn = (Yi) => {
          throw Ri || (Ri = Yi), Ri;
        }, Hn = (Yi) => {
          var En = Ri;
          if (!En)
            return tr(0), 0;
          var On = new zi(En);
          On.set_adjusted_ptr(En);
          var Xn = On.get_type();
          if (!Xn)
            return tr(0), En;
          for (var ls in Yi) {
            var Yn = Yi[ls];
            if (Yn === 0 || Yn === Xn)
              break;
            var cs = On.ptr + 16;
            if (Nr(Yn, Xn, cs))
              return tr(Yn), En;
          }
          return tr(Xn), En;
        }, os = () => Hn([]), ts = (Yi) => Hn([Yi]), Gs = (Yi, En) => Hn([Yi, En]), Wn = () => {
          var Yi = si.pop();
          Yi || Bi("no exception to throw");
          var En = Yi.excPtr;
          throw Yi.get_rethrown() || (si.push(Yi), Yi.set_rethrown(!0), Yi.set_caught(!1), Ci++), Ri = En, Ri;
        }, Gn = (Yi, En, On) => {
          var Xn = new zi(Yi);
          throw Xn.init(En, On), Ri = Yi, Ci++, Ri;
        }, ro = () => Ci, Fs = () => {
          Bi("");
        }, ii = (Yi, En, On) => sr.copyWithin(Yi, En, En + On), Ai = (Yi) => {
          Bi("OOM");
        }, ci = (Yi) => {
          sr.length, Ai();
        }, Si = {}, Ui = () => Be || "./this.program", _i = () => {
          if (!_i.strings) {
            var Yi = (typeof navigator == "object" && navigator.languages && navigator.languages[0] || "C").replace("-", "_") + ".UTF-8", En = { USER: "web_user", LOGNAME: "web_user", PATH: "/", PWD: "/", HOME: "/home/web_user", LANG: Yi, _: Ui() };
            for (var On in Si)
              Si[On] === void 0 ? delete En[On] : En[On] = Si[On];
            var Xn = [];
            for (var On in En)
              Xn.push(`${On}=${En[On]}`);
            _i.strings = Xn;
          }
          return _i.strings;
        }, Tn = (Yi, En) => {
          for (var On = 0; On < Yi.length; ++On)
            ir[En++ >> 0] = Yi.charCodeAt(On);
          ir[En >> 0] = 0;
        }, Fn = (Yi, En) => {
          var On = 0;
          return _i().forEach((Xn, ls) => {
            var Yn = En + On;
            wr[Yi + ls * 4 >> 2] = Yn, Tn(Xn, Yn), On += Xn.length + 1;
          }), 0;
        }, ss = (Yi, En) => {
          var On = _i();
          wr[Yi >> 2] = On.length;
          var Xn = 0;
          return On.forEach((ls) => Xn += ls.length + 1), wr[En >> 2] = Xn, 0;
        }, rs = (Yi) => Yi, is = (Yi) => Yi % 4 === 0 && (Yi % 100 !== 0 || Yi % 400 === 0), Pr = (Yi, En) => {
          for (var On = 0, Xn = 0; Xn <= En; On += Yi[Xn++])
            ;
          return On;
        }, as = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], Rs = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], ri = (Yi, En) => {
          for (var On = new Date(Yi.getTime()); En > 0; ) {
            var Xn = is(On.getFullYear()), ls = On.getMonth(), Yn = (Xn ? as : Rs)[ls];
            if (En > Yn - On.getDate())
              En -= Yn - On.getDate() + 1, On.setDate(1), ls < 11 ? On.setMonth(ls + 1) : (On.setMonth(0), On.setFullYear(On.getFullYear() + 1));
            else
              return On.setDate(On.getDate() + En), On;
          }
          return On;
        }, Tr = (Yi) => {
          for (var En = 0, On = 0; On < Yi.length; ++On) {
            var Xn = Yi.charCodeAt(On);
            Xn <= 127 ? En++ : Xn <= 2047 ? En += 2 : Xn >= 55296 && Xn <= 57343 ? (En += 4, ++On) : En += 3;
          }
          return En;
        }, yi = (Yi, En, On, Xn) => {
          if (!(Xn > 0)) return 0;
          for (var ls = On, Yn = On + Xn - 1, cs = 0; cs < Yi.length; ++cs) {
            var ks = Yi.charCodeAt(cs);
            if (ks >= 55296 && ks <= 57343) {
              var ws = Yi.charCodeAt(++cs);
              ks = 65536 + ((ks & 1023) << 10) | ws & 1023;
            }
            if (ks <= 127) {
              if (On >= Yn) break;
              En[On++] = ks;
            } else if (ks <= 2047) {
              if (On + 1 >= Yn) break;
              En[On++] = 192 | ks >> 6, En[On++] = 128 | ks & 63;
            } else if (ks <= 65535) {
              if (On + 2 >= Yn) break;
              En[On++] = 224 | ks >> 12, En[On++] = 128 | ks >> 6 & 63, En[On++] = 128 | ks & 63;
            } else {
              if (On + 3 >= Yn) break;
              En[On++] = 240 | ks >> 18, En[On++] = 128 | ks >> 12 & 63, En[On++] = 128 | ks >> 6 & 63, En[On++] = 128 | ks & 63;
            }
          }
          return En[On] = 0, On - ls;
        };
        function ki(Yi, En, On) {
          var Xn = Tr(Yi) + 1, ls = new Array(Xn);
          return yi(Yi, ls, 0, ls.length), ls;
        }
        var qi = (Yi, En) => {
          ir.set(Yi, En);
        }, C = (Yi, En, On, Xn) => {
          var ls = wr[Xn + 40 >> 2], Yn = { tm_sec: yr[Xn >> 2], tm_min: yr[Xn + 4 >> 2], tm_hour: yr[Xn + 8 >> 2], tm_mday: yr[Xn + 12 >> 2], tm_mon: yr[Xn + 16 >> 2], tm_year: yr[Xn + 20 >> 2], tm_wday: yr[Xn + 24 >> 2], tm_yday: yr[Xn + 28 >> 2], tm_isdst: yr[Xn + 32 >> 2], tm_gmtoff: yr[Xn + 36 >> 2], tm_zone: ls ? Er(ls) : "" }, cs = Er(On), ks = { "%c": "%a %b %d %H:%M:%S %Y", "%D": "%m/%d/%y", "%F": "%Y-%m-%d", "%h": "%b", "%r": "%I:%M:%S %p", "%R": "%H:%M", "%T": "%H:%M:%S", "%x": "%m/%d/%y", "%X": "%H:%M:%S", "%Ec": "%c", "%EC": "%C", "%Ex": "%m/%d/%y", "%EX": "%H:%M:%S", "%Ey": "%y", "%EY": "%Y", "%Od": "%d", "%Oe": "%e", "%OH": "%H", "%OI": "%I", "%Om": "%m", "%OM": "%M", "%OS": "%S", "%Ou": "%u", "%OU": "%U", "%OV": "%V", "%Ow": "%w", "%OW": "%W", "%Oy": "%y" };
          for (var ws in ks)
            cs = cs.replace(new RegExp(ws, "g"), ks[ws]);
          var Ro = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"], jo = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
          function Yo(Oi, ho, $o) {
            for (var Oa = typeof Oi == "number" ? Oi.toString() : Oi || ""; Oa.length < ho; )
              Oa = $o[0] + Oa;
            return Oa;
          }
          function Mo(Oi, ho) {
            return Yo(Oi, ho, "0");
          }
          function No(Oi, ho) {
            function $o(Ko) {
              return Ko < 0 ? -1 : Ko > 0 ? 1 : 0;
            }
            var Oa;
            return (Oa = $o(Oi.getFullYear() - ho.getFullYear())) === 0 && (Oa = $o(Oi.getMonth() - ho.getMonth())) === 0 && (Oa = $o(Oi.getDate() - ho.getDate())), Oa;
          }
          function _s(Oi) {
            switch (Oi.getDay()) {
              case 0:
                return new Date(Oi.getFullYear() - 1, 11, 29);
              case 1:
                return Oi;
              case 2:
                return new Date(Oi.getFullYear(), 0, 3);
              case 3:
                return new Date(Oi.getFullYear(), 0, 2);
              case 4:
                return new Date(Oi.getFullYear(), 0, 1);
              case 5:
                return new Date(Oi.getFullYear() - 1, 11, 31);
              case 6:
                return new Date(Oi.getFullYear() - 1, 11, 30);
            }
          }
          function Zo(Oi) {
            var ho = ri(new Date(Oi.tm_year + 1900, 0, 1), Oi.tm_yday), $o = new Date(ho.getFullYear(), 0, 4), Oa = new Date(ho.getFullYear() + 1, 0, 4), Ko = _s($o), js = _s(Oa);
            return No(Ko, ho) <= 0 ? No(js, ho) <= 0 ? ho.getFullYear() + 1 : ho.getFullYear() : ho.getFullYear() - 1;
          }
          var ru = { "%a": (Oi) => Ro[Oi.tm_wday].substring(0, 3), "%A": (Oi) => Ro[Oi.tm_wday], "%b": (Oi) => jo[Oi.tm_mon].substring(0, 3), "%B": (Oi) => jo[Oi.tm_mon], "%C": (Oi) => {
            var ho = Oi.tm_year + 1900;
            return Mo(ho / 100 | 0, 2);
          }, "%d": (Oi) => Mo(Oi.tm_mday, 2), "%e": (Oi) => Yo(Oi.tm_mday, 2, " "), "%g": (Oi) => Zo(Oi).toString().substring(2), "%G": (Oi) => Zo(Oi), "%H": (Oi) => Mo(Oi.tm_hour, 2), "%I": (Oi) => {
            var ho = Oi.tm_hour;
            return ho == 0 ? ho = 12 : ho > 12 && (ho -= 12), Mo(ho, 2);
          }, "%j": (Oi) => Mo(Oi.tm_mday + Pr(is(Oi.tm_year + 1900) ? as : Rs, Oi.tm_mon - 1), 3), "%m": (Oi) => Mo(Oi.tm_mon + 1, 2), "%M": (Oi) => Mo(Oi.tm_min, 2), "%n": () => `
`, "%p": (Oi) => Oi.tm_hour >= 0 && Oi.tm_hour < 12 ? "AM" : "PM", "%S": (Oi) => Mo(Oi.tm_sec, 2), "%t": () => "	", "%u": (Oi) => Oi.tm_wday || 7, "%U": (Oi) => {
            var ho = Oi.tm_yday + 7 - Oi.tm_wday;
            return Mo(Math.floor(ho / 7), 2);
          }, "%V": (Oi) => {
            var ho = Math.floor((Oi.tm_yday + 7 - (Oi.tm_wday + 6) % 7) / 7);
            if ((Oi.tm_wday + 371 - Oi.tm_yday - 2) % 7 <= 2 && ho++, ho) {
              if (ho == 53) {
                var Oa = (Oi.tm_wday + 371 - Oi.tm_yday) % 7;
                Oa != 4 && (Oa != 3 || !is(Oi.tm_year)) && (ho = 1);
              }
            } else {
              ho = 52;
              var $o = (Oi.tm_wday + 7 - Oi.tm_yday - 1) % 7;
              ($o == 4 || $o == 5 && is(Oi.tm_year % 400 - 1)) && ho++;
            }
            return Mo(ho, 2);
          }, "%w": (Oi) => Oi.tm_wday, "%W": (Oi) => {
            var ho = Oi.tm_yday + 7 - (Oi.tm_wday + 6) % 7;
            return Mo(Math.floor(ho / 7), 2);
          }, "%y": (Oi) => (Oi.tm_year + 1900).toString().substring(2), "%Y": (Oi) => Oi.tm_year + 1900, "%z": (Oi) => {
            var ho = Oi.tm_gmtoff, $o = ho >= 0;
            return ho = Math.abs(ho) / 60, ho = ho / 60 * 100 + ho % 60, ($o ? "+" : "-") + ("0000" + ho).slice(-4);
          }, "%Z": (Oi) => Oi.tm_zone, "%%": () => "%" };
          cs = cs.replace(/%%/g, "\0\0");
          for (var ws in ru)
            cs.includes(ws) && (cs = cs.replace(new RegExp(ws, "g"), ru[ws](Yn)));
          cs = cs.replace(/\0\0/g, "%");
          var Ca = ki(cs);
          return Ca.length > En ? 0 : (qi(Ca, Yi), Ca.length - 1);
        }, l = (Yi, En, On, Xn, ls) => C(Yi, En, On, Xn), w = [], n = (Yi) => {
          var En = w[Yi];
          return En || (Yi >= w.length && (w.length = Yi + 1), w[Yi] = En = Dr.get(Yi)), En;
        }, a = (Yi) => {
          var En = De["_" + Yi];
          return En;
        }, b = (Yi, En, On) => yi(Yi, sr, En, On), P = (Yi) => {
          var En = Tr(Yi) + 1, On = lr(En);
          return b(Yi, On, En), On;
        }, K = (Yi, En, On, Xn, ls) => {
          var Yn = { string: (_s) => {
            var Zo = 0;
            return _s != null && _s !== 0 && (Zo = P(_s)), Zo;
          }, array: (_s) => {
            var Zo = lr(_s.length);
            return qi(_s, Zo), Zo;
          } };
          function cs(_s) {
            return En === "string" ? Er(_s) : En === "boolean" ? !!_s : _s;
          }
          var ks = a(Yi), ws = [], Ro = 0;
          if (Xn)
            for (var jo = 0; jo < Xn.length; jo++) {
              var Yo = Yn[On[jo]];
              Yo ? (Ro === 0 && (Ro = nr()), ws[jo] = Yo(Xn[jo])) : ws[jo] = Xn[jo];
            }
          var Mo = ks.apply(null, ws);
          function No(_s) {
            return Ro !== 0 && or(Ro), cs(_s);
          }
          return Mo = No(Mo), Mo;
        }, pe = (Yi, En, On, Xn) => {
          var ls = !On || On.every((cs) => cs === "number" || cs === "boolean"), Yn = En !== "string";
          return Yn && ls && !Xn ? a(Yi) : function() {
            return K(Yi, En, On, arguments);
          };
        }, Ce = { p: xr, t: bi, v: li, b: os, j: ts, V: Gs, E: Wn, r: Gn, L: ro, h: Kn, D: Fs, M: ii, U: ci, J: Fn, K: ss, G: ps, d: Ei, u: In, c: Ti, W: Xi, f: Di, C: Wi, m: Qi, B: zn, o: ns, F: Ss, y: xs, N: bo, S: Xs, g: wi, l: Es, H: fs, e: Ki, T: eo, i: Li, I: Dn, k: $i, z: es, n: Mn, s: kn, q: Ps, w: Bs, x: vs, O: no, P: ao, R: fo, Q: co, A: rs, a: Dt, X: l }, Me = Rr();
        Me.Y, Me.__errno_location, Me.__cxa_free_exception, De._free = Me.Z, De._malloc = Me._, De._miniscript_compile = Me.$, De._miniscript_analyze = Me.aa;
        var Tt = Me.ca, tr = Me.da, nr = Me.ea, or = Me.fa, lr = Me.ga, gr = Me.ha, kr = Me.ia, Nr = Me.ja, jr = Me.ka, Yr = De.dynCall_iij = Me.la, ei = De.dynCall_vij = Me.ma, ai = De.dynCall_viji = Me.na, ui = De.dynCall_viij = Me.oa, di = De.dynCall_viiij = Me.pa, Ii = De.dynCall_iiij = Me.qa;
        function wi(Yi) {
          var En = nr();
          try {
            n(Yi)();
          } catch (On) {
            if (or(En), On !== On + 0) throw On;
            Tt(1, 0);
          }
        }
        function Ei(Yi, En) {
          var On = nr();
          try {
            return n(Yi)(En);
          } catch (Xn) {
            if (or(On), Xn !== Xn + 0) throw Xn;
            Tt(1, 0);
          }
        }
        function Ti(Yi, En, On) {
          var Xn = nr();
          try {
            return n(Yi)(En, On);
          } catch (ls) {
            if (or(Xn), ls !== ls + 0) throw ls;
            Tt(1, 0);
          }
        }
        function Di(Yi, En, On, Xn) {
          var ls = nr();
          try {
            return n(Yi)(En, On, Xn);
          } catch (Yn) {
            if (or(ls), Yn !== Yn + 0) throw Yn;
            Tt(1, 0);
          }
        }
        function Qi(Yi, En, On, Xn, ls) {
          var Yn = nr();
          try {
            return n(Yi)(En, On, Xn, ls);
          } catch (cs) {
            if (or(Yn), cs !== cs + 0) throw cs;
            Tt(1, 0);
          }
        }
        function Li(Yi, En, On, Xn) {
          var ls = nr();
          try {
            n(Yi)(En, On, Xn);
          } catch (Yn) {
            if (or(ls), Yn !== Yn + 0) throw Yn;
            Tt(1, 0);
          }
        }
        function Ki(Yi, En, On) {
          var Xn = nr();
          try {
            n(Yi)(En, On);
          } catch (ls) {
            if (or(Xn), ls !== ls + 0) throw ls;
            Tt(1, 0);
          }
        }
        function Wi(Yi, En, On, Xn, ls) {
          var Yn = nr();
          try {
            return n(Yi)(En, On, Xn, ls);
          } catch (cs) {
            if (or(Yn), cs !== cs + 0) throw cs;
            Tt(1, 0);
          }
        }
        function Xi(Yi, En, On, Xn) {
          var ls = nr();
          try {
            return n(Yi)(En, On, Xn);
          } catch (Yn) {
            if (or(ls), Yn !== Yn + 0) throw Yn;
            Tt(1, 0);
          }
        }
        function $i(Yi, En, On, Xn, ls) {
          var Yn = nr();
          try {
            n(Yi)(En, On, Xn, ls);
          } catch (cs) {
            if (or(Yn), cs !== cs + 0) throw cs;
            Tt(1, 0);
          }
        }
        function In(Yi, En, On, Xn, ls) {
          var Yn = nr();
          try {
            return n(Yi)(En, On, Xn, ls);
          } catch (cs) {
            if (or(Yn), cs !== cs + 0) throw cs;
            Tt(1, 0);
          }
        }
        function kn(Yi, En, On, Xn, ls, Yn) {
          var cs = nr();
          try {
            n(Yi)(En, On, Xn, ls, Yn);
          } catch (ks) {
            if (or(cs), ks !== ks + 0) throw ks;
            Tt(1, 0);
          }
        }
        function Dn(Yi, En, On, Xn, ls, Yn) {
          var cs = nr();
          try {
            n(Yi)(En, On, Xn, ls, Yn);
          } catch (ks) {
            if (or(cs), ks !== ks + 0) throw ks;
            Tt(1, 0);
          }
        }
        function Mn(Yi, En, On, Xn, ls, Yn, cs) {
          var ks = nr();
          try {
            n(Yi)(En, On, Xn, ls, Yn, cs);
          } catch (ws) {
            if (or(ks), ws !== ws + 0) throw ws;
            Tt(1, 0);
          }
        }
        function zn(Yi, En, On, Xn, ls, Yn) {
          var cs = nr();
          try {
            return n(Yi)(En, On, Xn, ls, Yn);
          } catch (ks) {
            if (or(cs), ks !== ks + 0) throw ks;
            Tt(1, 0);
          }
        }
        function es(Yi, En, On, Xn, ls, Yn) {
          var cs = nr();
          try {
            n(Yi)(En, On, Xn, ls, Yn);
          } catch (ks) {
            if (or(cs), ks !== ks + 0) throw ks;
            Tt(1, 0);
          }
        }
        function ns(Yi, En, On, Xn, ls, Yn, cs) {
          var ks = nr();
          try {
            return n(Yi)(En, On, Xn, ls, Yn, cs);
          } catch (ws) {
            if (or(ks), ws !== ws + 0) throw ws;
            Tt(1, 0);
          }
        }
        function fs(Yi, En, On) {
          var Xn = nr();
          try {
            n(Yi)(En, On);
          } catch (ls) {
            if (or(Xn), ls !== ls + 0) throw ls;
            Tt(1, 0);
          }
        }
        function ps(Yi) {
          var En = nr();
          try {
            return n(Yi)();
          } catch (On) {
            if (or(En), On !== On + 0) throw On;
            Tt(1, 0);
          }
        }
        function Es(Yi, En) {
          var On = nr();
          try {
            n(Yi)(En);
          } catch (Xn) {
            if (or(On), Xn !== Xn + 0) throw Xn;
            Tt(1, 0);
          }
        }
        function Ss(Yi, En, On, Xn, ls, Yn, cs, ks) {
          var ws = nr();
          try {
            return n(Yi)(En, On, Xn, ls, Yn, cs, ks);
          } catch (Ro) {
            if (or(ws), Ro !== Ro + 0) throw Ro;
            Tt(1, 0);
          }
        }
        function Ps(Yi, En, On, Xn, ls, Yn, cs, ks) {
          var ws = nr();
          try {
            n(Yi)(En, On, Xn, ls, Yn, cs, ks);
          } catch (Ro) {
            if (or(ws), Ro !== Ro + 0) throw Ro;
            Tt(1, 0);
          }
        }
        function xs(Yi, En, On, Xn, ls, Yn, cs, ks, ws, Ro, jo, Yo) {
          var Mo = nr();
          try {
            return n(Yi)(En, On, Xn, ls, Yn, cs, ks, ws, Ro, jo, Yo);
          } catch (No) {
            if (or(Mo), No !== No + 0) throw No;
            Tt(1, 0);
          }
        }
        function Bs(Yi, En, On, Xn, ls, Yn, cs, ks, ws, Ro, jo) {
          var Yo = nr();
          try {
            n(Yi)(En, On, Xn, ls, Yn, cs, ks, ws, Ro, jo);
          } catch (Mo) {
            if (or(Yo), Mo !== Mo + 0) throw Mo;
            Tt(1, 0);
          }
        }
        function vs(Yi, En, On, Xn, ls, Yn, cs, ks, ws, Ro, jo, Yo, Mo, No, _s, Zo) {
          var ru = nr();
          try {
            n(Yi)(En, On, Xn, ls, Yn, cs, ks, ws, Ro, jo, Yo, Mo, No, _s, Zo);
          } catch (Ca) {
            if (or(ru), Ca !== Ca + 0) throw Ca;
            Tt(1, 0);
          }
        }
        function eo(Yi, En, On, Xn) {
          var ls = nr();
          try {
            n(Yi)(En, On, Xn);
          } catch (Yn) {
            if (or(ls), Yn !== Yn + 0) throw Yn;
            Tt(1, 0);
          }
        }
        function Xs(Yi, En, On, Xn) {
          var ls = nr();
          try {
            return Yr(Yi, En, On, Xn);
          } catch (Yn) {
            if (or(ls), Yn !== Yn + 0) throw Yn;
            Tt(1, 0);
          }
        }
        function fo(Yi, En, On, Xn) {
          var ls = nr();
          try {
            ei(Yi, En, On, Xn);
          } catch (Yn) {
            if (or(ls), Yn !== Yn + 0) throw Yn;
            Tt(1, 0);
          }
        }
        function co(Yi, En, On, Xn, ls) {
          var Yn = nr();
          try {
            ai(Yi, En, On, Xn, ls);
          } catch (cs) {
            if (or(Yn), cs !== cs + 0) throw cs;
            Tt(1, 0);
          }
        }
        function ao(Yi, En, On, Xn, ls) {
          var Yn = nr();
          try {
            ui(Yi, En, On, Xn, ls);
          } catch (cs) {
            if (or(Yn), cs !== cs + 0) throw cs;
            Tt(1, 0);
          }
        }
        function no(Yi, En, On, Xn, ls, Yn) {
          var cs = nr();
          try {
            di(Yi, En, On, Xn, ls, Yn);
          } catch (ks) {
            if (or(cs), ks !== ks + 0) throw ks;
            Tt(1, 0);
          }
        }
        function bo(Yi, En, On, Xn, ls) {
          var Yn = nr();
          try {
            return Ii(Yi, En, On, Xn, ls);
          } catch (cs) {
            if (or(Yn), cs !== cs + 0) throw cs;
            Tt(1, 0);
          }
        }
        function Io(Yi) {
          try {
            for (var En = atob(Yi), On = new Uint8Array(En.length), Xn = 0; Xn < En.length; ++Xn)
              On[Xn] = En.charCodeAt(Xn);
            return On;
          } catch {
            throw new Error("Converting base64 string to bytes failed.");
          }
        }
        function Po(Yi) {
          if (oi(Yi))
            return Io(Yi.slice($r.length));
        }
        De.cwrap = pe, De.UTF8ToString = Er;
        var To;
        hr = function Yi() {
          To || mo(), To || (hr = Yi);
        };
        function mo() {
          if (cr > 0 || (Ur(), cr > 0))
            return;
          function Yi() {
            To || (To = !0, De.calledRun = !0, !er && (Sr(), ve(De), De.onRuntimeInitialized && De.onRuntimeInitialized(), Gr()));
          }
          De.setStatus ? (De.setStatus("Running..."), setTimeout(function() {
            setTimeout(function() {
              De.setStatus("");
            }, 1), Yi();
          }, 1)) : Yi();
        }
        if (De.preInit)
          for (typeof De.preInit == "function" && (De.preInit = [De.preInit]); De.preInit.length > 0; )
            De.preInit.pop()();
        return mo(), Pe;
      };
    })();
    Ee.exports = ze;
  });
  const D = B(), x = D.cwrap("miniscript_compile", "none", [
    "string",
    "number",
    "number",
    "number",
    "number",
    "number",
    "number"
  ]), v = D.cwrap("miniscript_analyze", "none", [
    "string",
    "number",
    "number",
    "number",
    "number"
  ]), F = (Ee) => Ee.trim().replace(/\n/g, " ").replace(/ +(?= )/g, ""), M = (Ee) => {
    const Se = D._malloc(1e4), ze = D._malloc(500), He = D._malloc(1e5), Pe = D._malloc(10), De = D._malloc(10);
    x(
      Ee,
      Se,
      1e4,
      ze,
      500,
      He,
      1e5,
      Pe,
      10,
      De,
      10
    );
    const ve = {
      miniscript: D.UTF8ToString(Se),
      asm: F(D.UTF8ToString(He)),
      issane: D.UTF8ToString(Pe) === "true",
      issanesublevel: D.UTF8ToString(De) === "true"
    };
    return D._free(Se), D._free(ze), D._free(He), D._free(Pe), D._free(De), ve;
  }, U = (Ee) => {
    const Se = D._malloc(5e4), ze = D._malloc(1e5), He = D._malloc(10), Pe = D._malloc(10);
    v(
      Ee,
      Se,
      5e4,
      ze,
      1e5,
      He,
      10,
      Pe,
      10
    );
    const De = D.UTF8ToString(ze), ve = D.UTF8ToString(He), Fe = D.UTF8ToString(Pe);
    return D._free(Se), D._free(ze), D._free(He), D._free(Pe), {
      asm: F(De),
      issane: ve === "true",
      issanesublevel: Fe === "true"
    };
  };
  function L(Ee) {
    const Se = Ee.split(" ");
    let ze = 0;
    for (const He of Se)
      if (He !== "") if (He.startsWith("<sig"))
        ze += 74;
      else if (He.startsWith("<sha256_preimage(") || He.startsWith("<hash256_preimage(") || He.startsWith("<ripemd160_preimage(") || He.startsWith("<hash160_preimage(") || He.startsWith("<random_preimage()>"))
        ze += 33;
      else if (He.startsWith("<"))
        ze += 34;
      else if (He === "1" || He === "0")
        ze += 1;
      else
        throw new Error(`Invalid witness substring ${He}`);
    return ze;
  }
  function H(Ee) {
    Ee = Ee.map((He) => (He = { ...He }, He.signatures = He.asm.split(" ").filter((Pe) => Pe.startsWith("<sig")), He.signatures.length === 0 && (He.dontuse = !0), He.asm.includes("<random_preimage()>") && (He.dontuse = !0), He)).sort((He, Pe) => L(He.asm) - L(Pe.asm));
    for (const He of Ee)
      for (const Pe of Ee)
        Pe !== He && //for the same nLockTime and nSequence
        Pe.nLockTime === He.nLockTime && Pe.nSequence === He.nSequence && //is otherSat.signatures equal or a subset of sat.signatures?
        Pe.signatures.every((De) => He.signatures.includes(De)) && (He.dontuse = !0);
    const Se = Ee.filter((He) => !He.dontuse), ze = Ee.filter((He) => He.dontuse);
    for (const He of [Se, ze])
      He.forEach((Pe) => {
        delete Pe.signatures, delete Pe.dontuse;
      });
    return { nonMalleableSats: Se, malleableSats: ze };
  }
  function fe(Ee, Se) {
    switch (Ee) {
      case "pk_k":
      case "pk_h":
      case "older":
      case "after":
      case "sha256":
      case "ripemd160":
      case "hash256":
      case "hash160":
      case "multi":
        return !0;
      case "thresh":
        if (Se === 0) return !0;
    }
    return !1;
  }
  const ge = (Ee) => {
    if (typeof Ee != "string")
      throw new Error("Invalid expression: " + Ee);
    for (; Ee.match(/^[a-z]{2,}:/); )
      Ee = Ee.replace(
        /^[a-z]{2,}:/,
        (ve) => ve.replace(ve[0], ve[0] + ":")
      );
    Ee = Ee.replace(/^pk\(/, "c:pk_k(").replace(/^pkh\(/, "c:pk_h(").replace(
      /^and_n\(.*\)/,
      (ve) => ve.replace("and_n", "andor").replace(/\)$/, ",0)")
    ).replace(/^t:(.*)/, (ve) => ve.replace("t:", "and_v(") + ",1)").replace(/^l:(.*)/, (ve) => ve.replace("l:", "or_i(0,") + ")").replace(/^u:(.*)/, (ve) => ve.replace("u:", "or_i(") + ",0)");
    const Se = String.raw`([^\(:]*)`, ze = Ee.match(Se);
    if (!ze) throw new Error("Invalid expression: " + Ee);
    const He = ze[0];
    if (typeof d[He] != "function")
      throw new Error(He + " not implemented");
    let Pe;
    Ee[He.length] === "(" ? Pe = Ee.substring(He.length + 1, Ee.length - 1) : Ee[He.length] === ":" && (Pe = Ee.substring(He.length + 1));
    const De = [];
    if (Pe) {
      let ve = -1, Fe = 0, be = 0;
      for (let Be = 0; Be < Pe.length; Be++)
        if (Pe[Be] === "(" && Fe++, Pe[Be] === ")" && Fe--, Fe === 0) {
          let ke;
          Pe[Be] === "," ? (ke = Pe.substring(ve + 1, Be), ve = Be) : Be === Pe.length - 1 && (ke = Pe.substring(ve + 1)), ke && (fe(He, be) ? De.push(ke) : De.push(ge(ke)), be++);
        }
    }
    return d[He](...De);
  }, Ie = (Ee, Se = {}) => {
    let { unknowns: ze, knowns: He } = Se;
    const { issane: Pe, issanesublevel: De } = U(Ee);
    if (!Pe)
      throw new Error(`Miniscript ${Ee} is not sane.`);
    if (typeof ze > "u" && typeof He > "u")
      ze = [];
    else {
      if (typeof ze < "u" && typeof He < "u")
        throw new Error("Cannot pass both knowns and unknowns");
      if (He && !Array.isArray(He) || ze && !Array.isArray(ze))
        throw new Error("Incorrect types for unknowns / knowns");
    }
    const ve = [], Fe = [];
    return (ge(Ee).sats || []).map((Be) => {
      typeof Be.nSequence > "u" && delete Be.nSequence, typeof Be.nLockTime > "u" && delete Be.nLockTime, Be.asm = Be.asm.replace(/  +/g, " ").trim(), ze ? ze.some((ke) => Be.asm.includes(ke)) ? Fe.push(Be) : ve.push(Be) : He.reduce(
        (xe, Ne) => xe.replace(Ne, ""),
        Be.asm
      ).match(
        /<sig\(|<sha256_preimage\(|<hash256_preimage\(|<ripemd160_preimage\(|<hash160_preimage\(/
      ) ? Fe.push(Be) : ve.push(Be);
    }), { ...H(ve), unknownSats: Fe };
  };
  return dist.compileMiniscript = U, dist.compilePolicy = M, dist.satisfier = Ie, dist;
}
var hasRequiredMiniscript;
function requireMiniscript() {
  if (hasRequiredMiniscript) return miniscript;
  hasRequiredMiniscript = 1;
  var o = miniscript && miniscript.__createBinding || (Object.create ? function(M, U, L, H) {
    H === void 0 && (H = L);
    var fe = Object.getOwnPropertyDescriptor(U, L);
    (!fe || ("get" in fe ? !U.__esModule : fe.writable || fe.configurable)) && (fe = { enumerable: !0, get: function() {
      return U[L];
    } }), Object.defineProperty(M, H, fe);
  } : function(M, U, L, H) {
    H === void 0 && (H = L), M[H] = U[L];
  }), g = miniscript && miniscript.__setModuleDefault || (Object.create ? function(M, U) {
    Object.defineProperty(M, "default", { enumerable: !0, value: U });
  } : function(M, U) {
    M.default = U;
  }), c = miniscript && miniscript.__importStar || function(M) {
    if (M && M.__esModule) return M;
    var U = {};
    if (M != null) for (var L in M) L !== "default" && Object.prototype.hasOwnProperty.call(M, L) && o(U, M, L);
    return g(U, M), U;
  };
  Object.defineProperty(miniscript, "__esModule", { value: !0 }), miniscript.numberEncodeAsm = miniscript.satisfyMiniscript = miniscript.miniscript2Script = miniscript.expandMiniscript = void 0;
  const y = require$$1, t = requireKeyExpressions(), d = c(requireRe()), E = requireDist$1();
  function B({ miniscript: M, isSegwit: U, network: L = y.networks.bitcoin, ECPair: H, BIP32: fe }) {
    const ge = {}, Ie = M.replace(RegExp(d.reKeyExp, "g"), (Se) => {
      const ze = "@" + Object.keys(ge).length;
      return ge[ze] = (0, t.parseKeyExpression)({
        keyExpression: Se,
        isSegwit: U,
        network: L,
        ECPair: H,
        BIP32: fe
      }), ze;
    }), Ee = Object.values(ge).filter((Se) => Se.keyExpression.indexOf("*") === -1).map((Se) => {
      if (!Se.pubkey)
        throw new Error(`Error: keyExpression ${Se.keyExpression} does not have a pubkey`);
      return Se.pubkey.toString("hex");
    });
    if (new Set(Ee).size !== Ee.length)
      throw new Error(`Error: miniscript ${M} is not sane: contains duplicate public keys.`);
    return { expandedMiniscript: Ie, expansionMap: ge };
  }
  miniscript.expandMiniscript = B;
  function D({ expandedAsm: M, expansionMap: U }) {
    let L = Object.keys(U).reduce((H, fe) => {
      var Ie;
      const ge = (Ie = U[fe]) == null ? void 0 : Ie.pubkey;
      if (!ge)
        throw new Error(`Error: invalid expansionMap for ${fe}`);
      return H.replaceAll(`<${fe}>`, `<${ge.toString("hex")}>`).replaceAll(`<HASH160(${fe})>`, `<${y.crypto.hash160(ge).toString("hex")}>`);
    }, M);
    return L = L.trim().replace(/\s+/g, " ").replace(/(<\d+>)|\b\d+\b/g, (H) => H.startsWith("<") ? H : F(Number(H))).replace(/[<>]/g, ""), L;
  }
  function x({ expandedMiniscript: M, expansionMap: U }) {
    const L = (0, E.compileMiniscript)(M);
    if (L.issane !== !0)
      throw new Error(`Error: Miniscript ${M} is not sane`);
    return y.script.fromASM(D({ expandedAsm: L.asm, expansionMap: U }));
  }
  miniscript.miniscript2Script = x;
  function v({ expandedMiniscript: M, expansionMap: U, signatures: L = [], preimages: H = [], timeConstraints: fe }) {
    const ge = {};
    H.forEach((ve) => {
      ge["<" + ve.digest.replace("(", "_preimage(") + ">"] = "<" + ve.preimage + ">";
    });
    const Ie = {};
    L.forEach((ve) => {
      const Fe = ve.pubkey.toString("hex"), be = Object.keys(U).find((Be) => {
        var ke, xe;
        return ((xe = (ke = U[Be]) == null ? void 0 : ke.pubkey) == null ? void 0 : xe.toString("hex")) === Fe;
      });
      Ie["<sig(" + be + ")>"] = "<" + ve.signature.toString("hex") + ">";
    });
    const Ee = { ...ge, ...Ie }, Se = Object.keys(Ee), { nonMalleableSats: ze } = (0, E.satisfier)(M, { knowns: Se });
    if (!Array.isArray(ze) || !ze[0])
      throw new Error(`Error: unresolvable miniscript ${M}`);
    let He;
    if (!fe)
      He = ze[0];
    else if (He = ze.find((ve) => ve.nSequence === fe.nSequence && ve.nLockTime === fe.nLockTime), He === void 0)
      throw new Error(`Error: unresolvable miniscript ${M}. Could not find solutions for sequence ${fe.nSequence} & locktime=${fe.nLockTime}. Signatures are applied to a hash that depends on sequence and locktime. Did you provide all the signatures wrt the signers keys declared and include all preimages?`);
    let Pe = He.asm;
    for (const ve in Ee) {
      const Fe = Ee[ve];
      if (!Fe || Fe === "<>")
        throw new Error("Error: invalid expandedKnownsMap");
      Pe = Pe.replaceAll(ve, Fe);
    }
    return {
      scriptSatisfaction: y.script.fromASM(D({ expandedAsm: Pe, expansionMap: U })),
      nLockTime: He.nLockTime,
      nSequence: He.nSequence
    };
  }
  miniscript.satisfyMiniscript = v;
  function F(M) {
    if (Number.isSafeInteger(M) === !1)
      throw new Error(`Error: invalid number ${M}`);
    return M === 0 ? "OP_0" : y.script.number.encode(M).toString("hex");
  }
  return miniscript.numberEncodeAsm = F, miniscript;
}
var hasRequiredDescriptors;
function requireDescriptors() {
  if (hasRequiredDescriptors) return descriptors;
  hasRequiredDescriptors = 1;
  var o = descriptors && descriptors.__createBinding || (Object.create ? function(ve, Fe, be, Be) {
    Be === void 0 && (Be = be);
    var ke = Object.getOwnPropertyDescriptor(Fe, be);
    (!ke || ("get" in ke ? !Fe.__esModule : ke.writable || ke.configurable)) && (ke = { enumerable: !0, get: function() {
      return Fe[be];
    } }), Object.defineProperty(ve, Be, ke);
  } : function(ve, Fe, be, Be) {
    Be === void 0 && (Be = be), ve[Be] = Fe[be];
  }), g = descriptors && descriptors.__setModuleDefault || (Object.create ? function(ve, Fe) {
    Object.defineProperty(ve, "default", { enumerable: !0, value: Fe });
  } : function(ve, Fe) {
    ve.default = Fe;
  }), c = descriptors && descriptors.__importStar || function(ve) {
    if (ve && ve.__esModule) return ve;
    var Fe = {};
    if (ve != null) for (var be in ve) be !== "default" && Object.prototype.hasOwnProperty.call(ve, be) && o(Fe, ve, be);
    return g(Fe, ve), Fe;
  }, y = descriptors && descriptors.__classPrivateFieldSet || function(ve, Fe, be, Be, ke) {
    if (Be === "m") throw new TypeError("Private method is not writable");
    if (Be === "a" && !ke) throw new TypeError("Private accessor was defined without a setter");
    if (typeof Fe == "function" ? ve !== Fe || !ke : !Fe.has(ve)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return Be === "a" ? ke.call(ve, be) : ke ? ke.value = be : Fe.set(ve, be), be;
  }, t = descriptors && descriptors.__classPrivateFieldGet || function(ve, Fe, be, Be) {
    if (be === "a" && !Be) throw new TypeError("Private accessor was defined without a getter");
    if (typeof Fe == "function" ? ve !== Fe || !Be : !Fe.has(ve)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return be === "m" ? Be : be === "a" ? Be.call(ve) : Be ? Be.value : Fe.get(ve);
  };
  Object.defineProperty(descriptors, "__esModule", { value: !0 }), descriptors.DescriptorsFactory = void 0;
  const d = require$$1, { p2sh: E, p2wpkh: B, p2pkh: D, p2pk: x, p2wsh: v, p2tr: F } = d.payments, M = requireSrc$1(), U = requireSrc(), L = requirePsbt$2(), H = requireChecksum(), fe = requireKeyExpressions(), ge = c(requireRe()), Ie = requireMiniscript(), Ee = 520, Se = 3600, ze = 201;
  function He(ve) {
    const Fe = d.script.decompile(ve);
    if (!Fe)
      throw new Error(`Error: cound not decompile ${ve}`);
    return Fe.filter((be) => typeof be == "number" && be > d.script.OPS.OP_16).length;
  }
  function Pe({ expression: ve, checksumRequired: Fe, index: be }) {
    const Be = ve.match(String.raw`(${ge.reChecksum})$`);
    if (Be === null && Fe === !0)
      throw new Error(`Error: descriptor ${ve} has not checksum`);
    let ke = ve;
    if (Be !== null) {
      const xe = Be[0].substring(1);
      if (ke = ve.substring(0, ve.length - Be[0].length), xe !== (0, H.DescriptorChecksum)(ke))
        throw new Error(`Error: invalid descriptor checksum for ${ve}`);
    }
    if (be !== void 0) {
      const xe = ke.match(/\*/g);
      if (xe && xe.length > 0)
        ke = ke.replaceAll("*", be.toString());
      else
        throw new Error(`Error: index passed for non-ranged descriptor: ${ve}`);
    }
    return ke;
  }
  function De(ve) {
    var Fe, be, Be, ke, xe, Ne, Et, st, Dt, er, xt, ir, sr, yr;
    const wr = (0, M.BIP32Factory)(ve), qr = (0, U.ECPairFactory)(ve), Mr = (Ur, Sr, Gr) => qr.fromPublicKey(Ur).verify(Sr, Gr), Dr = ({ keyExpression: Ur, isSegwit: Sr, network: Gr = d.networks.bitcoin }) => (0, fe.parseKeyExpression)({
      keyExpression: Ur,
      network: Gr,
      ...typeof Sr == "boolean" ? { isSegwit: Sr } : {},
      ECPair: qr,
      BIP32: wr
    }), Qr = ({ expression: Ur, index: Sr, checksumRequired: Gr = !1, network: Fr = d.networks.bitcoin, allowMiniscriptInP2SH: br = !1 }) => {
      var Rr, Ir, pr, Cr, Er, xr, si, Ci, bi, Ri;
      let Ar, cr, hr, Wr, fi, Bi, $r, oi;
      const zr = Ur.indexOf("*") !== -1;
      if (Sr !== void 0 && (!Number.isInteger(Sr) || Sr < 0))
        throw new Error(`Error: invalid index ${Sr}`);
      const ti = Pe({
        expression: Ur,
        ...Sr !== void 0 ? { index: Sr } : {},
        checksumRequired: Gr
      }), Lr = ti.indexOf("*") !== -1;
      if (ti.match(ge.reAddrAnchored)) {
        if (zr)
          throw new Error("Error: addr() cannot be ranged");
        const li = (Rr = ti.match(ge.reAddrAnchored)) == null ? void 0 : Rr[1];
        if (!li)
          throw new Error(`Error: could not get an address in ${Ur}`);
        let zi;
        try {
          zi = d.address.toOutputScript(li, Fr);
        } catch {
          throw new Error(`Error: invalid address ${li}`);
        }
        try {
          Bi = D({ output: zi, network: Fr });
        } catch {
        }
        try {
          Bi = E({ output: zi, network: Fr });
        } catch {
        }
        try {
          Bi = B({ output: zi, network: Fr });
        } catch {
        }
        try {
          Bi = v({ output: zi, network: Fr });
        } catch {
        }
        try {
          Bi = F({ output: zi, network: Fr });
        } catch {
        }
        if (!Bi)
          throw new Error(`Error: invalid address ${li}`);
      } else if (ti.match(ge.rePkAnchored)) {
        Wr = !1;
        const li = (Ir = ti.match(ge.reKeyExp)) == null ? void 0 : Ir[0];
        if (!li)
          throw new Error("Error: keyExpression could not me extracted");
        if (ti !== `pk(${li})`)
          throw new Error(`Error: invalid expression ${Ur}`);
        Ar = "pk(@0)";
        const zi = Dr({ keyExpression: li, network: Fr, isSegwit: Wr });
        if (hr = { "@0": zi }, !Lr) {
          const Kn = zi.pubkey;
          if (!Kn)
            throw new Error(`Error: could not extract a pubkey from ${Ur}`);
          Bi = x({ pubkey: Kn, network: Fr });
        }
      } else if (ti.match(ge.rePkhAnchored)) {
        Wr = !1;
        const li = (pr = ti.match(ge.reKeyExp)) == null ? void 0 : pr[0];
        if (!li)
          throw new Error("Error: keyExpression could not me extracted");
        if (ti !== `pkh(${li})`)
          throw new Error(`Error: invalid expression ${Ur}`);
        Ar = "pkh(@0)";
        const zi = Dr({ keyExpression: li, network: Fr, isSegwit: Wr });
        if (hr = { "@0": zi }, !Lr) {
          const Kn = zi.pubkey;
          if (!Kn)
            throw new Error(`Error: could not extract a pubkey from ${Ur}`);
          Bi = D({ pubkey: Kn, network: Fr });
        }
      } else if (ti.match(ge.reShWpkhAnchored)) {
        Wr = !0;
        const li = (Cr = ti.match(ge.reKeyExp)) == null ? void 0 : Cr[0];
        if (!li)
          throw new Error("Error: keyExpression could not me extracted");
        if (ti !== `sh(wpkh(${li}))`)
          throw new Error(`Error: invalid expression ${Ur}`);
        Ar = "sh(wpkh(@0))";
        const zi = Dr({ keyExpression: li, network: Fr, isSegwit: Wr });
        if (hr = { "@0": zi }, !Lr) {
          const Kn = zi.pubkey;
          if (!Kn)
            throw new Error(`Error: could not extract a pubkey from ${Ur}`);
          if (Bi = E({ redeem: B({ pubkey: Kn, network: Fr }), network: Fr }), oi = (Er = Bi.redeem) == null ? void 0 : Er.output, !oi)
            throw new Error(`Error: could not calculate redeemScript for ${Ur}`);
        }
      } else if (ti.match(ge.reWpkhAnchored)) {
        Wr = !0;
        const li = (xr = ti.match(ge.reKeyExp)) == null ? void 0 : xr[0];
        if (!li)
          throw new Error("Error: keyExpression could not me extracted");
        if (ti !== `wpkh(${li})`)
          throw new Error(`Error: invalid expression ${Ur}`);
        Ar = "wpkh(@0)";
        const zi = Dr({ keyExpression: li, network: Fr, isSegwit: Wr });
        if (hr = { "@0": zi }, !Lr) {
          const Kn = zi.pubkey;
          if (!Kn)
            throw new Error(`Error: could not extract a pubkey from ${Ur}`);
          Bi = B({ pubkey: Kn, network: Fr });
        }
      } else if (ti.match(ge.reShWshMiniscriptAnchored)) {
        if (Wr = !0, cr = (si = ti.match(ge.reShWshMiniscriptAnchored)) == null ? void 0 : si[1], !cr)
          throw new Error(`Error: could not get miniscript in ${Ur}`);
        if ({ expandedMiniscript: fi, expansionMap: hr } = Xr({
          miniscript: cr,
          isSegwit: Wr,
          network: Fr
        }), Ar = `sh(wsh(${fi}))`, !Lr) {
          const li = (0, Ie.miniscript2Script)({ expandedMiniscript: fi, expansionMap: hr });
          if ($r = li, li.byteLength > Se)
            throw new Error(`Error: script is too large, ${li.byteLength} bytes is larger than ${Se} bytes`);
          const zi = He(li);
          if (zi > ze)
            throw new Error(`Error: too many non-push ops, ${zi} non-push ops is larger than ${ze}`);
          if (Bi = E({
            redeem: v({ redeem: { output: li, network: Fr }, network: Fr }),
            network: Fr
          }), oi = (Ci = Bi.redeem) == null ? void 0 : Ci.output, !oi)
            throw new Error(`Error: could not calculate redeemScript for ${Ur}`);
        }
      } else if (ti.match(ge.reShMiniscriptAnchored)) {
        if (Wr = !1, cr = (bi = ti.match(ge.reShMiniscriptAnchored)) == null ? void 0 : bi[1], !cr)
          throw new Error(`Error: could not get miniscript in ${Ur}`);
        if (br === !1 && //These top-level expressions within sh are allowed within sh.
        //They can be parsed with miniscript2Script, but first we must make sure
        //that other expressions are not accepted (unless forced with allowMiniscriptInP2SH).
        cr.search(/^(pk\(|pkh\(|wpkh\(|combo\(|multi\(|sortedmulti\(|multi_a\(|sortedmulti_a\()/) !== 0)
          throw new Error("Error: Miniscript expressions can only be used in wsh");
        if ({ expandedMiniscript: fi, expansionMap: hr } = Xr({
          miniscript: cr,
          isSegwit: Wr,
          network: Fr
        }), Ar = `sh(${fi})`, !Lr) {
          const li = (0, Ie.miniscript2Script)({ expandedMiniscript: fi, expansionMap: hr });
          if (oi = li, li.byteLength > Ee)
            throw new Error(`Error: P2SH script is too large, ${li.byteLength} bytes is larger than ${Ee} bytes`);
          const zi = He(li);
          if (zi > ze)
            throw new Error(`Error: too many non-push ops, ${zi} non-push ops is larger than ${ze}`);
          Bi = E({ redeem: { output: li, network: Fr }, network: Fr });
        }
      } else if (ti.match(ge.reWshMiniscriptAnchored)) {
        if (Wr = !0, cr = (Ri = ti.match(ge.reWshMiniscriptAnchored)) == null ? void 0 : Ri[1], !cr)
          throw new Error(`Error: could not get miniscript in ${Ur}`);
        if ({ expandedMiniscript: fi, expansionMap: hr } = Xr({
          miniscript: cr,
          isSegwit: Wr,
          network: Fr
        }), Ar = `wsh(${fi})`, !Lr) {
          const li = (0, Ie.miniscript2Script)({ expandedMiniscript: fi, expansionMap: hr });
          if ($r = li, li.byteLength > Se)
            throw new Error(`Error: script is too large, ${li.byteLength} bytes is larger than ${Se} bytes`);
          const zi = He(li);
          if (zi > ze)
            throw new Error(`Error: too many non-push ops, ${zi} non-push ops is larger than ${ze}`);
          Bi = v({ redeem: { output: li, network: Fr }, network: Fr });
        }
      } else
        throw new Error(`Error: Could not parse descriptor ${Ur}`);
      return {
        ...Bi !== void 0 ? { payment: Bi } : {},
        ...Ar !== void 0 ? { expandedExpression: Ar } : {},
        ...cr !== void 0 ? { miniscript: cr } : {},
        ...hr !== void 0 ? { expansionMap: hr } : {},
        ...Wr !== void 0 ? { isSegwit: Wr } : {},
        ...fi !== void 0 ? { expandedMiniscript: fi } : {},
        ...oi !== void 0 ? { redeemScript: oi } : {},
        ...$r !== void 0 ? { witnessScript: $r } : {},
        isRanged: zr,
        canonicalExpression: ti
      };
    };
    function Xr({ miniscript: Ur, isSegwit: Sr, network: Gr = d.networks.bitcoin }) {
      return (0, Ie.expandMiniscript)({
        miniscript: Ur,
        isSegwit: Sr,
        network: Gr,
        BIP32: wr,
        ECPair: qr
      });
    }
    class Vr {
      /**
       * @param options
       * @throws {Error} - when descriptor is invalid
       */
      constructor({ expression: Sr, index: Gr, checksumRequired: Fr = !1, allowMiniscriptInP2SH: br = !1, network: Ar = d.networks.bitcoin, preimages: cr = [], signersPubKeys: hr }) {
        if (Fe.add(this), be.set(this, void 0), Be.set(this, []), ke.set(this, void 0), xe.set(this, void 0), Ne.set(this, void 0), Et.set(this, void 0), st.set(this, void 0), Dt.set(this, void 0), er.set(this, void 0), xt.set(this, void 0), ir.set(this, void 0), y(this, ir, Ar, "f"), y(this, Be, cr, "f"), typeof Sr != "string")
          throw new Error("Error: invalid descriptor type");
        const Wr = Qr({
          expression: Sr,
          ...Gr !== void 0 ? { index: Gr } : {},
          checksumRequired: Fr,
          network: Ar,
          allowMiniscriptInP2SH: br
        });
        if (Wr.isRanged && Gr === void 0)
          throw new Error("Error: index was not provided for ranged descriptor");
        if (!Wr.payment)
          throw new Error(`Error: could not extract a payment from ${Sr}`);
        if (y(this, be, Wr.payment, "f"), Wr.expandedExpression !== void 0 && y(this, Dt, Wr.expandedExpression, "f"), Wr.miniscript !== void 0 && y(this, xe, Wr.miniscript, "f"), Wr.expansionMap !== void 0 && y(this, xt, Wr.expansionMap, "f"), Wr.isSegwit !== void 0 && y(this, st, Wr.isSegwit, "f"), Wr.expandedMiniscript !== void 0 && y(this, er, Wr.expandedMiniscript, "f"), Wr.redeemScript !== void 0 && y(this, Et, Wr.redeemScript, "f"), Wr.witnessScript !== void 0 && y(this, Ne, Wr.witnessScript, "f"), hr)
          y(this, ke, hr, "f");
        else if (t(this, xt, "f"))
          y(this, ke, Object.values(t(this, xt, "f")).map((fi) => {
            const Bi = fi.pubkey;
            if (!Bi)
              throw new Error(`Error: could not extract a pubkey from ${Sr}`);
            return Bi;
          }), "f");
        else {
          if (!Wr.canonicalExpression.match(ge.reAddrAnchored))
            throw new Error(`Error: expansionMap not available for expression ${Sr} that is not an address`);
          y(this, ke, [this.getScriptPubKey()], "f");
        }
      }
      getPayment() {
        return t(this, be, "f");
      }
      /**
       * Returns the Bitcoin Address
       */
      getAddress() {
        if (!t(this, be, "f").address)
          throw new Error("Error: could extract an address from the payment");
        return t(this, be, "f").address;
      }
      getScriptPubKey() {
        if (!t(this, be, "f").output)
          throw new Error("Error: could extract output.script from the payment");
        return t(this, be, "f").output;
      }
      /**
       * Returns the compiled script satisfaction
       * @param {PartialSig[]} signatures An array of signatures using this format: `interface PartialSig { pubkey: Buffer; signature: Buffer; }`
       * @returns {Buffer}
       */
      getScriptSatisfaction(Sr) {
        const Gr = t(this, xe, "f"), Fr = t(this, er, "f"), br = t(this, xt, "f");
        if (Gr === void 0 || Fr === void 0 || br === void 0)
          throw new Error(`Error: cannot get satisfaction from not expanded miniscript ${Gr}`);
        const Ar = (0, Ie.satisfyMiniscript)({
          expandedMiniscript: Fr,
          expansionMap: br,
          signatures: Sr,
          preimages: t(this, Be, "f"),
          //Here we pass the TimeConstraints obtained using signersPubKeys to
          //verify that the solutions found using the final signatures have not
          //changed
          timeConstraints: {
            nLockTime: this.getLockTime(),
            nSequence: this.getSequence()
          }
        }).scriptSatisfaction;
        if (!Ar)
          throw new Error("Error: could not produce a valid satisfaction");
        return Ar;
      }
      getSequence() {
        var Sr;
        return (Sr = t(this, Fe, "m", sr).call(this)) == null ? void 0 : Sr.nSequence;
      }
      getLockTime() {
        var Sr;
        return (Sr = t(this, Fe, "m", sr).call(this)) == null ? void 0 : Sr.nLockTime;
      }
      getWitnessScript() {
        return t(this, Ne, "f");
      }
      getRedeemScript() {
        return t(this, Et, "f");
      }
      getNetwork() {
        return t(this, ir, "f");
      }
      isSegwit() {
        return t(this, st, "f");
      }
      /**
       * Updates a Psbt where the descriptor describes an utxo.
       * The txHex (nonWitnessUtxo) and vout of the utxo must be passed.
       *
       * updatePsbt adds an input to the psbt and updates the tx locktime if needed.
       * It also adds a new input to the Psbt based on txHex
       * It returns the number of the input that is added.
       * psbt and vout are mandatory. Also pass txHex.
       *
       * The following is not recommended but, alternatively, ONLY for Segwit inputs,
       * you can pass txId and value, instead of txHex.
       * If you do so, it is your responsibility to make sure that `value` is
       * correct to avoid possible fee vulnerability attacks:
       * https://github.com/bitcoinjs/bitcoinjs-lib/issues/1625
       * Note that HW wallets require the full txHex also for Segwit anyways:
       * https://blog.trezor.io/details-of-firmware-updates-for-trezor-one-version-1-9-1-and-trezor-model-t-version-2-3-1-1eba8f60f2dd
       *
       * In doubt, simply pass txHex (and you can skip passing txId and value) and
       * you shall be fine.
       */
      updatePsbt({
        psbt: Sr,
        txHex: Gr,
        txId: Fr,
        value: br,
        vout: Ar
        //vector output index
      }) {
        Gr === void 0 && console.warn("Warning: missing txHex may allow fee attacks");
        const cr = this.isSegwit();
        if (cr === void 0)
          throw new Error("Error: could not determine whether this is a segwit descriptor");
        return (0, L.updatePsbt)({
          psbt: Sr,
          vout: Ar,
          ...Gr !== void 0 ? { txHex: Gr } : {},
          ...Fr !== void 0 ? { txId: Fr } : {},
          ...br !== void 0 ? { value: br } : {},
          sequence: this.getSequence(),
          locktime: this.getLockTime(),
          keysInfo: t(this, xt, "f") ? Object.values(t(this, xt, "f")) : [],
          scriptPubKey: this.getScriptPubKey(),
          isSegwit: cr,
          witnessScript: this.getWitnessScript(),
          redeemScript: this.getRedeemScript()
        });
      }
      finalizePsbtInput({ index: Sr, psbt: Gr, validate: Fr = !0 }) {
        var Ar;
        if (Fr && !Gr.validateSignaturesOfInput(Sr, Mr))
          throw new Error(`Error: invalid signatures on input ${Sr}`);
        const br = (Ar = Gr.data.inputs[Sr]) == null ? void 0 : Ar.partialSig;
        if (!br)
          throw new Error("Error: cannot finalize without signatures");
        if (t(this, Fe, "m", yr).call(this, { index: Sr, psbt: Gr }), !t(this, xe, "f"))
          Gr.finalizeInput(Sr);
        else {
          const cr = this.getScriptSatisfaction(br);
          Gr.finalizeInput(Sr, (0, L.finalScriptsFuncFactory)(cr, t(this, ir, "f")));
        }
      }
      expand() {
        return {
          ...t(this, Dt, "f") !== void 0 ? { expandedExpression: t(this, Dt, "f") } : {},
          ...t(this, xe, "f") !== void 0 ? { miniscript: t(this, xe, "f") } : {},
          ...t(this, er, "f") !== void 0 ? { expandedMiniscript: t(this, er, "f") } : {},
          ...t(this, xt, "f") !== void 0 ? { expansionMap: t(this, xt, "f") } : {}
        };
      }
    }
    return be = /* @__PURE__ */ new WeakMap(), Be = /* @__PURE__ */ new WeakMap(), ke = /* @__PURE__ */ new WeakMap(), xe = /* @__PURE__ */ new WeakMap(), Ne = /* @__PURE__ */ new WeakMap(), Et = /* @__PURE__ */ new WeakMap(), st = /* @__PURE__ */ new WeakMap(), Dt = /* @__PURE__ */ new WeakMap(), er = /* @__PURE__ */ new WeakMap(), xt = /* @__PURE__ */ new WeakMap(), ir = /* @__PURE__ */ new WeakMap(), Fe = /* @__PURE__ */ new WeakSet(), sr = function() {
      const Sr = t(this, xe, "f"), Gr = t(this, Be, "f"), Fr = t(this, er, "f"), br = t(this, xt, "f"), Ar = t(this, ke, "f");
      if (Sr) {
        if (Fr === void 0 || br === void 0)
          throw new Error(`Error: cannot get time constraints from not expanded miniscript ${Sr}`);
        const cr = Ar.map((fi) => ({
          pubkey: fi,
          signature: Buffer.alloc(64, 0)
        })), { nLockTime: hr, nSequence: Wr } = (0, Ie.satisfyMiniscript)({
          expandedMiniscript: Fr,
          expansionMap: br,
          signatures: cr,
          preimages: Gr
        });
        return { nLockTime: hr, nSequence: Wr };
      } else
        return;
    }, yr = function({ psbt: Sr, index: Gr }) {
      const Fr = Sr.data.inputs[Gr], br = Sr.txInputs[Gr];
      if (!Fr || !br)
        throw new Error("Error: invalid input or txInput");
      const { sequence: Ar, index: cr } = br;
      let hr;
      if (Fr.witnessUtxo)
        hr = Fr.witnessUtxo.script;
      else {
        if (!Fr.nonWitnessUtxo)
          throw new Error("Error: input should have either witnessUtxo or nonWitnessUtxo");
        const $r = d.Transaction.fromBuffer(Fr.nonWitnessUtxo).outs[cr];
        if (!$r)
          throw new Error("Error: utxo should exist");
        hr = $r.script;
      }
      const Wr = this.getLockTime() || 0;
      let fi = this.getSequence();
      if (fi === void 0 && Wr !== 0 && (fi = 4294967294), fi === void 0 && Wr === 0 && (fi = 4294967295), Buffer.compare(hr, this.getScriptPubKey()) !== 0 || fi !== Ar || Wr !== Sr.locktime || this.getWitnessScript() !== Fr.witnessScript || this.getRedeemScript() !== Fr.redeemScript)
        throw new Error(`Error: cannot finalize psbt index ${Gr} since it does not correspond to this descriptor`);
    }, { Descriptor: Vr, parseKeyExpression: Dr, expand: Qr, ECPair: qr, BIP32: wr };
  }
  return descriptors.DescriptorsFactory = De, descriptors;
}
var signers = {}, hasRequiredSigners;
function requireSigners() {
  if (hasRequiredSigners) return signers;
  hasRequiredSigners = 1, Object.defineProperty(signers, "__esModule", { value: !0 }), signers.signLedger = signers.signInputLedger = signers.signBIP32 = signers.signInputBIP32 = signers.signECPair = signers.signInputECPair = void 0;
  const o = requireLedger();
  function g({ psbt: D, index: x, ecpair: v }) {
    D.signInput(x, v);
  }
  signers.signInputECPair = g;
  function c({ psbt: D, ecpair: x }) {
    D.signAllInputs(x);
  }
  signers.signECPair = c;
  function y({ psbt: D, index: x, node: v }) {
    D.signInputHD(x, v);
  }
  signers.signInputBIP32 = y;
  function t({ psbt: D, masterNode: x }) {
    D.signAllInputsHD(x);
  }
  signers.signBIP32 = t;
  const d = (D, x) => x.filter(([v]) => v === D).map(([v, F]) => ({
    pubkey: F.pubkey,
    signature: F.signature
  }));
  async function E({ psbt: D, index: x, descriptor: v, ledgerClient: F, ledgerState: M }) {
    const { PsbtV2: U, DefaultWalletPolicy: L, WalletPolicy: H, AppClient: fe } = await (0, o.importAndValidateLedgerBitcoin)(F);
    if (!(F instanceof fe))
      throw new Error("Error: pass a valid ledgerClient");
    const ge = await (0, o.descriptorToLedgerFormat)({
      descriptor: v,
      ledgerClient: F,
      ledgerState: M
    });
    if (!ge)
      throw new Error("Error: descriptor does not have a ledger input");
    const { ledgerTemplate: Ie, keyRoots: Ee } = ge;
    let Se;
    if (await (0, o.ledgerPolicyFromStandard)({
      descriptor: v,
      ledgerClient: F,
      ledgerState: M
    }))
      Se = await F.signPsbt(new U().fromBitcoinJS(D), new L(Ie, Ee[0]), null);
    else {
      const He = await (0, o.ledgerPolicyFromState)({
        descriptor: v,
        ledgerClient: F,
        ledgerState: M
      });
      if (!He || !He.policyName || !He.policyHmac)
        throw new Error("Error: the descriptor's policy is not registered");
      const Pe = new H(He.policyName, Ie, Ee);
      Se = await F.signPsbt(new U().fromBitcoinJS(D), Pe, He.policyHmac);
    }
    D.updateInput(x, {
      partialSig: d(x, Se)
    });
  }
  signers.signInputLedger = E;
  async function B({ psbt: D, descriptors: x, ledgerClient: v, ledgerState: F }) {
    const { PsbtV2: M, DefaultWalletPolicy: U, WalletPolicy: L, AppClient: H } = await (0, o.importAndValidateLedgerBitcoin)(v);
    if (!(v instanceof H))
      throw new Error("Error: pass a valid ledgerClient");
    const fe = [];
    for (const Ie of x) {
      const Ee = await (0, o.ledgerPolicyFromState)({
        descriptor: Ie,
        ledgerClient: v,
        ledgerState: F
      }) || await (0, o.ledgerPolicyFromStandard)({
        descriptor: Ie,
        ledgerClient: v,
        ledgerState: F
      });
      Ee && fe.push(Ee);
    }
    if (fe.length === 0)
      throw new Error("Error: there are no inputs which could be signed");
    const ge = [];
    for (const Ie of fe)
      ge.find((Ee) => (0, o.comparePolicies)(Ee, Ie)) || ge.push(Ie);
    for (const Ie of ge) {
      let Ee;
      if (Ie.policyName && Ie.policyHmac && Ie.policyId) {
        const Se = new L(Ie.policyName, Ie.ledgerTemplate, Ie.keyRoots);
        Ee = await v.signPsbt(new M().fromBitcoinJS(D), Se, Ie.policyHmac);
      } else
        Ee = await v.signPsbt(new M().fromBitcoinJS(D), new U(Ie.ledgerTemplate, Ie.keyRoots[0]), null);
      for (const [Se, ,] of Ee)
        D.updateInput(Se, {
          partialSig: d(Se, Ee)
        });
    }
  }
  return signers.signLedger = B, signers;
}
var scriptExpressions = {}, hasRequiredScriptExpressions;
function requireScriptExpressions() {
  if (hasRequiredScriptExpressions) return scriptExpressions;
  hasRequiredScriptExpressions = 1, Object.defineProperty(scriptExpressions, "__esModule", { value: !0 }), scriptExpressions.wpkhLedger = scriptExpressions.shWpkhLedger = scriptExpressions.pkhLedger = scriptExpressions.wpkhBIP32 = scriptExpressions.shWpkhBIP32 = scriptExpressions.pkhBIP32 = void 0;
  const o = require$$1, g = requireKeyExpressions();
  function c(d) {
    if (!/^\/[01]\/(\d+|\*)$/.test(d))
      throw new Error("Error: Key path must be in the format '/change/index', where change is either 0 or 1 and index is a non-negative integer.");
  }
  function y(d, E) {
    function B({ masterNode: D, network: x = o.networks.bitcoin, keyPath: v, account: F, change: M, index: U, isPublic: L = !0 }) {
      const H = `/${d}'/${x === o.networks.bitcoin ? 0 : 1}'/${F}'`;
      v !== void 0 && c(v);
      const fe = (0, g.keyExpressionBIP32)({
        masterNode: D,
        originPath: H,
        keyPath: v,
        change: M,
        index: U,
        isPublic: L
      });
      return E.replace("KEYEXPRESSION", fe);
    }
    return B;
  }
  scriptExpressions.pkhBIP32 = y(44, "pkh(KEYEXPRESSION)"), scriptExpressions.shWpkhBIP32 = y(49, "sh(wpkh(KEYEXPRESSION))"), scriptExpressions.wpkhBIP32 = y(84, "wpkh(KEYEXPRESSION)");
  function t(d, E) {
    async function B({ ledgerClient: D, ledgerState: x, network: v = o.networks.bitcoin, account: F, keyPath: M, change: U, index: L }) {
      const H = `/${d}'/${v === o.networks.bitcoin ? 0 : 1}'/${F}'`;
      M !== void 0 && c(M);
      const fe = await (0, g.keyExpressionLedger)({
        ledgerClient: D,
        ledgerState: x,
        originPath: H,
        keyPath: M,
        change: U,
        index: L
      });
      return E.replace("KEYEXPRESSION", fe);
    }
    return B;
  }
  return scriptExpressions.pkhLedger = t(44, "pkh(KEYEXPRESSION)"), scriptExpressions.shWpkhLedger = t(49, "sh(wpkh(KEYEXPRESSION))"), scriptExpressions.wpkhLedger = t(84, "wpkh(KEYEXPRESSION)"), scriptExpressions;
}
var hasRequiredDist;
function requireDist() {
  return hasRequiredDist || (hasRequiredDist = 1, function(o) {
    var g = dist$1 && dist$1.__createBinding || (Object.create ? function(F, M, U, L) {
      L === void 0 && (L = U);
      var H = Object.getOwnPropertyDescriptor(M, U);
      (!H || ("get" in H ? !M.__esModule : H.writable || H.configurable)) && (H = { enumerable: !0, get: function() {
        return M[U];
      } }), Object.defineProperty(F, L, H);
    } : function(F, M, U, L) {
      L === void 0 && (L = U), F[L] = M[U];
    }), c = dist$1 && dist$1.__setModuleDefault || (Object.create ? function(F, M) {
      Object.defineProperty(F, "default", { enumerable: !0, value: M });
    } : function(F, M) {
      F.default = M;
    }), y = dist$1 && dist$1.__importStar || function(F) {
      if (F && F.__esModule) return F;
      var M = {};
      if (F != null) for (var U in F) U !== "default" && Object.prototype.hasOwnProperty.call(F, U) && g(M, F, U);
      return c(M, F), M;
    };
    Object.defineProperty(o, "__esModule", { value: !0 }), o.ledger = o.scriptExpressions = o.keyExpressionLedger = o.keyExpressionBIP32 = o.finalizePsbt = o.signers = o.checksum = o.DescriptorsFactory = void 0;
    var t = requireDescriptors();
    Object.defineProperty(o, "DescriptorsFactory", { enumerable: !0, get: function() {
      return t.DescriptorsFactory;
    } });
    var d = requireChecksum();
    Object.defineProperty(o, "checksum", { enumerable: !0, get: function() {
      return d.DescriptorChecksum;
    } });
    const E = y(requireSigners());
    o.signers = E;
    function B({ psbt: F, descriptors: M, validate: U = !0 }) {
      M.forEach((L, H) => L.finalizePsbtInput({ index: H, psbt: F, validate: U }));
    }
    o.finalizePsbt = B;
    var D = requireKeyExpressions();
    Object.defineProperty(o, "keyExpressionBIP32", { enumerable: !0, get: function() {
      return D.keyExpressionBIP32;
    } }), Object.defineProperty(o, "keyExpressionLedger", { enumerable: !0, get: function() {
      return D.keyExpressionLedger;
    } });
    const x = y(requireScriptExpressions());
    o.scriptExpressions = x;
    const v = requireLedger();
    o.ledger = {
      getLedgerMasterFingerPrint: v.getLedgerMasterFingerPrint,
      getLedgerXpub: v.getLedgerXpub,
      registerLedgerWallet: v.registerLedgerWallet,
      assertLedgerApp: v.assertLedgerApp
    };
  }(dist$1)), dist$1;
}
var bip32$1 = {}, hasRequiredBip32$1;
function requireBip32$1() {
  if (hasRequiredBip32$1) return bip32$1;
  hasRequiredBip32$1 = 1;
  var o = bip32$1 && bip32$1.__importDefault || function(v) {
    return v && v.__esModule ? v : { default: v };
  };
  Object.defineProperty(bip32$1, "__esModule", { value: !0 }), bip32$1.hardenedPathOf = bip32$1.getXpubComponents = bip32$1.pubkeyFromXpub = bip32$1.pathStringToArray = bip32$1.pathArrayToString = bip32$1.bip32asBuffer = bip32$1.pathElementsToBuffer = void 0;
  const g = o(requireBip32Path()), c = o(requireBs58check());
  function y(v) {
    const F = Buffer.alloc(1 + v.length * 4);
    return F[0] = v.length, v.forEach((M, U) => {
      F.writeUInt32BE(M, 1 + 4 * U);
    }), F;
  }
  bip32$1.pathElementsToBuffer = y;
  function t(v) {
    const F = v ? E(v) : [];
    return y(F);
  }
  bip32$1.bip32asBuffer = t;
  function d(v) {
    return v.length == 0 ? "m" : g.default.fromPathArray(v).toString();
  }
  bip32$1.pathArrayToString = d;
  function E(v) {
    return v == "m" || v == "" ? [] : g.default.fromString(v).toPathArray();
  }
  bip32$1.pathStringToArray = E;
  function B(v) {
    const F = Buffer.from(c.default.decode(v));
    return F.slice(F.length - 33);
  }
  bip32$1.pubkeyFromXpub = B;
  function D(v) {
    const F = Buffer.from(c.default.decode(v));
    return {
      chaincode: F.slice(13, 45),
      pubkey: F.slice(F.length - 33),
      version: F.readUInt32BE(0)
    };
  }
  bip32$1.getXpubComponents = D;
  function x(v) {
    for (let F = v.length - 1; F >= 0; F--)
      if (v[F] >= 2147483648)
        return v.slice(0, F + 1);
    return [];
  }
  return bip32$1.hardenedPathOf = x, bip32$1;
}
var clientCommands$1 = {}, buffertools$1 = {}, varint$1 = {}, hasRequiredVarint$1;
function requireVarint$1() {
  if (hasRequiredVarint$1) return varint$1;
  hasRequiredVarint$1 = 1, Object.defineProperty(varint$1, "__esModule", { value: !0 }), varint$1.createVarint = varint$1.parseVarint = varint$1.sanitizeBigintToNumber = void 0;
  function o(E, B, D, x) {
    for (let v = 0; v < B; v++) {
      if (D[v + x] == null)
        throw Error("Buffer too small");
      D[v + x] = Number(E % BigInt(256)), E = E >> BigInt(8);
    }
  }
  function g(E, B, D) {
    let x = BigInt(0);
    for (let v = 0; v < D; v++) {
      if (E[v + B] == null)
        throw Error("Buffer too small");
      x += BigInt(E[v + B]) << BigInt(v * 8);
    }
    return x;
  }
  function c(E) {
    if (E < 0)
      throw RangeError("Negative bigint is not a valid varint");
    if (E > Number.MAX_SAFE_INTEGER)
      throw RangeError("Too large for a Number");
    return Number(E);
  }
  varint$1.sanitizeBigintToNumber = c;
  function y(E) {
    if (typeof E == "number" && (E = c(E)), E < BigInt(0))
      throw new RangeError("Negative numbers are not supported");
    if (E >= BigInt(1) << BigInt(64))
      throw new RangeError("Too large for a Bitcoin-style varint");
    return E < BigInt(253) ? 1 : E <= BigInt(65535) ? 3 : E <= BigInt(4294967295) ? 5 : 9;
  }
  function t(E, B) {
    if (B < 0)
      throw RangeError("Negative offset is invalid");
    if (E[B] == null)
      throw Error("Buffer too small");
    if (E[B] < 253)
      return [BigInt(E[B]), 1];
    {
      let D;
      return E[B] === 253 ? D = 2 : E[B] === 254 ? D = 4 : D = 8, [g(E, B + 1, D), D + 1];
    }
  }
  varint$1.parseVarint = t;
  function d(E) {
    typeof E == "number" && (E = c(E));
    const B = y(E);
    E = BigInt(E);
    const D = Buffer.alloc(B);
    return B == 1 ? D[0] = Number(E) : (B == 3 ? D[0] = 253 : B === 5 ? D[0] = 254 : D[0] = 255, o(E, B - 1, D, 1)), D;
  }
  return varint$1.createVarint = d, varint$1;
}
var hasRequiredBuffertools$1;
function requireBuffertools$1() {
  if (hasRequiredBuffertools$1) return buffertools$1;
  hasRequiredBuffertools$1 = 1, Object.defineProperty(buffertools$1, "__esModule", { value: !0 }), buffertools$1.BufferReader = buffertools$1.BufferWriter = buffertools$1.numberToLE = buffertools$1.unsafeFrom64bitLE = buffertools$1.unsafeTo64bitLE = void 0;
  const o = requireVarint$1();
  function g(E) {
    if (E > Number.MAX_SAFE_INTEGER)
      throw new Error("Can't convert numbers > MAX_SAFE_INT");
    const B = Buffer.alloc(8, 0);
    for (let D = 0; D < B.length; D++) {
      const x = E & 255;
      B[D] = x, E = (E - x) / 256;
    }
    return B;
  }
  buffertools$1.unsafeTo64bitLE = g;
  function c(E) {
    let B = 0;
    if (E.length != 8)
      throw new Error("Expected Bufffer of lenght 8");
    if (E[7] != 0)
      throw new Error("Can't encode numbers > MAX_SAFE_INT");
    if (E[6] > 31)
      throw new Error("Can't encode numbers > MAX_SAFE_INT");
    for (let D = E.length - 1; D >= 0; D--)
      B = B * 256 + E[D];
    return B;
  }
  buffertools$1.unsafeFrom64bitLE = c;
  function y(E, B = 32) {
    if (!Number.isInteger(E) || E < 0)
      throw new RangeError("value must be a non-negative integer");
    if (!Number.isInteger(B) || B < 1)
      throw new RangeError("byteLen must be a positive integer");
    const D = Math.pow(256, B);
    if (E >= D)
      throw new RangeError(`value too large to fit in ${B} bytes (max ${D - 1})`);
    const x = Buffer.alloc(B);
    let v = E;
    for (let F = 0; F < B; F++)
      x[F] = v % 256, v = Math.floor(v / 256);
    return x;
  }
  buffertools$1.numberToLE = y;
  class t {
    constructor() {
      this.bufs = [];
    }
    write(B, D) {
      const x = Buffer.alloc(B);
      D(x), this.bufs.push(x);
    }
    writeUInt8(B) {
      this.write(1, (D) => D.writeUInt8(B, 0));
    }
    writeInt32(B) {
      this.write(4, (D) => D.writeInt32LE(B, 0));
    }
    writeUInt32(B) {
      this.write(4, (D) => D.writeUInt32LE(B, 0));
    }
    writeUInt64(B) {
      const D = g(B);
      this.writeSlice(D);
    }
    writeVarInt(B) {
      this.bufs.push((0, o.createVarint)(B));
    }
    writeSlice(B) {
      this.bufs.push(Buffer.from(B));
    }
    writeVarSlice(B) {
      this.writeVarInt(B.length), this.writeSlice(B);
    }
    buffer() {
      return Buffer.concat(this.bufs);
    }
  }
  buffertools$1.BufferWriter = t;
  class d {
    constructor(B, D = 0) {
      this.buffer = B, this.offset = D;
    }
    available() {
      return this.buffer.length - this.offset;
    }
    readUInt8() {
      const B = this.buffer.readUInt8(this.offset);
      return this.offset++, B;
    }
    readInt32() {
      const B = this.buffer.readInt32LE(this.offset);
      return this.offset += 4, B;
    }
    readUInt32() {
      const B = this.buffer.readUInt32LE(this.offset);
      return this.offset += 4, B;
    }
    readUInt64() {
      const B = this.readSlice(8);
      return c(B);
    }
    readVarInt() {
      const [B, D] = (0, o.parseVarint)(this.buffer, this.offset);
      return this.offset += D, B;
    }
    readSlice(B) {
      if (this.buffer.length < this.offset + B)
        throw new Error("Cannot read slice out of bounds");
      const D = this.buffer.slice(this.offset, this.offset + B);
      return this.offset += B, D;
    }
    readVarSlice() {
      const B = (0, o.sanitizeBigintToNumber)(this.readVarInt());
      return this.readSlice(B);
    }
    readVector() {
      const B = this.readVarInt(), D = [];
      for (let x = 0; x < B; x++)
        D.push(this.readVarSlice());
      return D;
    }
  }
  return buffertools$1.BufferReader = d, buffertools$1;
}
var merkle$1 = {}, hasRequiredMerkle$1;
function requireMerkle$1() {
  if (hasRequiredMerkle$1) return merkle$1;
  hasRequiredMerkle$1 = 1, Object.defineProperty(merkle$1, "__esModule", { value: !0 }), merkle$1.hashLeaf = merkle$1.Merkle = void 0;
  const o = require$$1;
  class g {
    constructor(x, v = o.crypto.sha256) {
      this.leaves = x, this.h = v;
      const F = this.calculateRoot(x);
      this.rootNode = F.root, this.leafNodes = F.leaves;
    }
    getRoot() {
      return this.rootNode.hash;
    }
    size() {
      return this.leaves.length;
    }
    getLeaves() {
      return this.leaves;
    }
    getLeafHash(x) {
      return this.leafNodes[x].hash;
    }
    getProof(x) {
      if (x >= this.leaves.length)
        throw Error("Index out of bounds");
      return d(this.leafNodes[x]);
    }
    calculateRoot(x) {
      const v = x.length;
      if (v == 0)
        return {
          root: new t(void 0, void 0, Buffer.alloc(32, 0)),
          leaves: []
        };
      if (v == 1) {
        const Ie = new t(void 0, void 0, x[0]);
        return { root: Ie, leaves: [Ie] };
      }
      const F = E(v), M = this.calculateRoot(x.slice(0, F)), U = this.calculateRoot(x.slice(F)), L = M.root, H = U.root, fe = this.hashNode(L.hash, H.hash), ge = new t(L, H, fe);
      return L.parent = ge, H.parent = ge, { root: ge, leaves: M.leaves.concat(U.leaves) };
    }
    hashNode(x, v) {
      return this.h(Buffer.concat([Buffer.from([1]), x, v]));
    }
  }
  merkle$1.Merkle = g;
  function c(D, x = o.crypto.sha256) {
    return y(Buffer.from([0]), D, x);
  }
  merkle$1.hashLeaf = c;
  function y(D, x, v) {
    return v(Buffer.concat([D, x]));
  }
  class t {
    constructor(x, v, F) {
      this.leftChild = x, this.rightChild = v, this.hash = F;
    }
    isLeaf() {
      return this.leftChild == null;
    }
  }
  function d(D) {
    if (!D.parent)
      return [];
    if (D.parent.leftChild == D) {
      if (!D.parent.rightChild)
        throw new Error("Expected right child to exist");
      return [D.parent.rightChild.hash, ...d(D.parent)];
    } else {
      if (!D.parent.leftChild)
        throw new Error("Expected left child to exist");
      return [D.parent.leftChild.hash, ...d(D.parent)];
    }
  }
  function E(D) {
    if (D < 2)
      throw Error("Expected n >= 2");
    return B(D) ? D / 2 : 1 << Math.floor(Math.log2(D));
  }
  function B(D) {
    return (D & D - 1) == 0;
  }
  return merkle$1;
}
var hasRequiredClientCommands$1;
function requireClientCommands$1() {
  if (hasRequiredClientCommands$1) return clientCommands$1;
  hasRequiredClientCommands$1 = 1, Object.defineProperty(clientCommands$1, "__esModule", { value: !0 }), clientCommands$1.ClientCommandInterpreter = clientCommands$1.GetMoreElementsCommand = clientCommands$1.GetMerkleLeafIndexCommand = clientCommands$1.GetMerkleLeafProofCommand = clientCommands$1.GetPreimageCommand = clientCommands$1.YieldCommand = void 0;
  const o = require$$1, g = requireBuffertools$1(), c = requireMerkle$1(), y = requireVarint$1();
  var t;
  (function(M) {
    M[M.YIELD = 16] = "YIELD", M[M.GET_PREIMAGE = 64] = "GET_PREIMAGE", M[M.GET_MERKLE_LEAF_PROOF = 65] = "GET_MERKLE_LEAF_PROOF", M[M.GET_MERKLE_LEAF_INDEX = 66] = "GET_MERKLE_LEAF_INDEX", M[M.GET_MORE_ELEMENTS = 160] = "GET_MORE_ELEMENTS";
  })(t || (t = {}));
  class d {
  }
  class E extends d {
    constructor(U, L) {
      super(), this.progressCallback = L, this.code = t.YIELD, this.results = U;
    }
    execute(U) {
      return this.results.push(Buffer.from(U.subarray(1))), this.progressCallback && this.progressCallback(), Buffer.from("");
    }
  }
  clientCommands$1.YieldCommand = E;
  class B extends d {
    constructor(U, L) {
      super(), this.code = t.GET_PREIMAGE, this.known_preimages = U, this.queue = L;
    }
    execute(U) {
      const L = Buffer.from(U.subarray(1));
      if (L.length != 33)
        throw new Error("Invalid request, unexpected trailing data");
      if (L[0] != 0)
        throw new Error("Unsupported request, the first byte should be 0");
      const H = Buffer.alloc(32);
      for (let Ie = 0; Ie < 32; Ie++)
        H[Ie] = L[1 + Ie];
      const fe = H.toString("hex"), ge = this.known_preimages.get(fe);
      if (ge != null) {
        const Ie = (0, y.createVarint)(ge.length), Ee = 255 - Ie.length - 1, Se = Math.min(Ee, ge.length);
        if (Se < ge.length)
          for (let ze = Se; ze < ge.length; ze++)
            this.queue.push(Buffer.from([ge[ze]]));
        return Buffer.concat([
          Ie,
          Buffer.from([Se]),
          Buffer.from(ge.subarray(0, Se))
        ]);
      }
      throw Error(`Requested unknown preimage for: ${fe}`);
    }
  }
  clientCommands$1.GetPreimageCommand = B;
  class D extends d {
    constructor(U, L) {
      super(), this.code = t.GET_MERKLE_LEAF_PROOF, this.known_trees = U, this.queue = L;
    }
    execute(U) {
      const L = Buffer.from(U.subarray(1));
      if (L.length < 34)
        throw new Error("Invalid request, expected at least 34 bytes");
      const H = new g.BufferReader(L), ge = H.readSlice(32).toString("hex");
      let Ie, Ee;
      try {
        Ie = (0, y.sanitizeBigintToNumber)(H.readVarInt()), Ee = (0, y.sanitizeBigintToNumber)(H.readVarInt());
      } catch {
        throw new Error("Invalid request, couldn't parse tree_size or leaf_index");
      }
      const Se = this.known_trees.get(ge);
      if (!Se)
        throw Error(`Requested Merkle leaf proof for unknown tree: ${ge}`);
      if (Ee >= Ie || Se.size() != Ie)
        throw Error("Invalid index or tree size.");
      if (this.queue.length != 0)
        throw Error("This command should not execute when the queue is not empty.");
      const ze = Se.getProof(Ee), He = Math.min(Math.floor(221 / 32), ze.length), Pe = ze.length - He;
      return Pe > 0 && this.queue.push(...ze.slice(-Pe)), Buffer.concat([
        Se.getLeafHash(Ee),
        Buffer.from([ze.length]),
        Buffer.from([He]),
        ...ze.slice(0, He)
      ]);
    }
  }
  clientCommands$1.GetMerkleLeafProofCommand = D;
  class x extends d {
    constructor(U) {
      super(), this.code = t.GET_MERKLE_LEAF_INDEX, this.known_trees = U;
    }
    execute(U) {
      const L = Buffer.from(U.subarray(1));
      if (L.length != 64)
        throw new Error("Invalid request, unexpected trailing data");
      const H = Buffer.alloc(32);
      for (let He = 0; He < 32; He++)
        H[He] = L.readUInt8(He);
      const fe = H.toString("hex"), ge = Buffer.alloc(32);
      for (let He = 0; He < 32; He++)
        ge[He] = L.readUInt8(32 + He);
      const Ie = ge.toString("hex"), Ee = this.known_trees.get(fe);
      if (!Ee)
        throw Error(`Requested Merkle leaf index for unknown root: ${fe}`);
      let Se = 0, ze = 0;
      for (let He = 0; He < Ee.size(); He++)
        if (Ee.getLeafHash(He).toString("hex") == Ie) {
          ze = 1, Se = He;
          break;
        }
      return Buffer.concat([Buffer.from([ze]), (0, y.createVarint)(Se)]);
    }
  }
  clientCommands$1.GetMerkleLeafIndexCommand = x;
  class v extends d {
    constructor(U) {
      super(), this.code = t.GET_MORE_ELEMENTS, this.queue = U;
    }
    execute(U) {
      if (U.length != 1)
        throw new Error("Invalid request, unexpected trailing data");
      if (this.queue.length === 0)
        throw new Error("No elements to get");
      const L = this.queue[0].length;
      if (this.queue.some((Ie) => Ie.length != L))
        throw new Error("The queue contains elements with different byte length, which is not expected");
      const H = Math.floor(253 / L), fe = Math.min(H, this.queue.length), ge = this.queue.splice(0, fe);
      return Buffer.concat([
        Buffer.from([fe]),
        Buffer.from([L]),
        ...ge
      ]);
    }
  }
  clientCommands$1.GetMoreElementsCommand = v;
  class F {
    constructor(U) {
      this.roots = /* @__PURE__ */ new Map(), this.preimages = /* @__PURE__ */ new Map(), this.yielded = [], this.queue = [], this.commands = /* @__PURE__ */ new Map();
      const L = [
        new E(this.yielded, U),
        new B(this.preimages, this.queue),
        new x(this.roots),
        new D(this.roots, this.queue),
        new v(this.queue)
      ];
      for (const H of L) {
        if (this.commands.has(H.code))
          throw new Error(`Multiple commands with code ${H.code}`);
        this.commands.set(H.code, H);
      }
    }
    getYielded() {
      return this.yielded;
    }
    addKnownPreimage(U) {
      this.preimages.set(o.crypto.sha256(U).toString("hex"), U);
    }
    addKnownList(U) {
      for (const H of U) {
        const fe = Buffer.concat([Buffer.from([0]), H]);
        this.addKnownPreimage(fe);
      }
      const L = new c.Merkle(U.map((H) => (0, c.hashLeaf)(H)));
      this.roots.set(L.getRoot().toString("hex"), L);
    }
    addKnownMapping(U) {
      this.addKnownList(U.keys), this.addKnownList(U.values);
    }
    addKnownWalletPolicy(U) {
      this.addKnownPreimage(U.serialize()), this.addKnownList(U.keys.map((L) => Buffer.from(L, "ascii"))), this.addKnownPreimage(Buffer.from(U.descriptorTemplate));
    }
    execute(U) {
      if (U.length == 0)
        throw new Error("Unexpected empty command");
      const L = U[0], H = this.commands.get(L);
      if (!H)
        throw new Error(`Unexpected command code ${L}`);
      return H.execute(U);
    }
  }
  return clientCommands$1.ClientCommandInterpreter = F, clientCommands$1;
}
var merkelizedPsbt$1 = {}, merkleMap$1 = {}, hasRequiredMerkleMap$1;
function requireMerkleMap$1() {
  if (hasRequiredMerkleMap$1) return merkleMap$1;
  hasRequiredMerkleMap$1 = 1, Object.defineProperty(merkleMap$1, "__esModule", { value: !0 }), merkleMap$1.MerkleMap = void 0;
  const o = requireMerkle$1(), g = requireVarint$1();
  class c {
    /**
     * @param keys Sorted list of (unhashed) keys
     * @param values values, in corresponding order as the keys, and of equal length
     */
    constructor(t, d) {
      if (t.length != d.length)
        throw new Error("keys and values should have the same length");
      for (let E = 0; E < t.length - 1; E++)
        if (t[E].toString("hex") >= t[E + 1].toString("hex"))
          throw new Error("keys must be in strictly increasing order");
      this.keys = t, this.keysTree = new o.Merkle(t.map((E) => (0, o.hashLeaf)(E))), this.values = d, this.valuesTree = new o.Merkle(d.map((E) => (0, o.hashLeaf)(E)));
    }
    commitment() {
      return Buffer.concat([
        (0, g.createVarint)(this.keys.length),
        this.keysTree.getRoot(),
        this.valuesTree.getRoot()
      ]);
    }
  }
  return merkleMap$1.MerkleMap = c, merkleMap$1;
}
var psbtv2$1 = {}, hasRequiredPsbtv2$1;
function requirePsbtv2$1() {
  return hasRequiredPsbtv2$1 || (hasRequiredPsbtv2$1 = 1, function(o) {
    var g = psbtv2$1 && psbtv2$1.__createBinding || (Object.create ? function(De, ve, Fe, be) {
      be === void 0 && (be = Fe);
      var Be = Object.getOwnPropertyDescriptor(ve, Fe);
      (!Be || ("get" in Be ? !ve.__esModule : Be.writable || Be.configurable)) && (Be = { enumerable: !0, get: function() {
        return ve[Fe];
      } }), Object.defineProperty(De, be, Be);
    } : function(De, ve, Fe, be) {
      be === void 0 && (be = Fe), De[be] = ve[Fe];
    }), c = psbtv2$1 && psbtv2$1.__setModuleDefault || (Object.create ? function(De, ve) {
      Object.defineProperty(De, "default", { enumerable: !0, value: ve });
    } : function(De, ve) {
      De.default = ve;
    }), y = psbtv2$1 && psbtv2$1.__importStar || function(De) {
      if (De && De.__esModule) return De;
      var ve = {};
      if (De != null) for (var Fe in De) Fe !== "default" && Object.prototype.hasOwnProperty.call(De, Fe) && g(ve, De, Fe);
      return c(ve, De), ve;
    };
    Object.defineProperty(o, "__esModule", { value: !0 }), o.PsbtV2 = o.NoSuchEntry = o.psbtOut = o.psbtIn = o.psbtGlobal = void 0;
    const t = y(require$$1), d = requireBuffertools$1(), E = requireVarint$1();
    var B;
    (function(De) {
      De[De.UNSIGNED_TX = 0] = "UNSIGNED_TX", De[De.XPUB = 1] = "XPUB", De[De.TX_VERSION = 2] = "TX_VERSION", De[De.FALLBACK_LOCKTIME = 3] = "FALLBACK_LOCKTIME", De[De.INPUT_COUNT = 4] = "INPUT_COUNT", De[De.OUTPUT_COUNT = 5] = "OUTPUT_COUNT", De[De.TX_MODIFIABLE = 6] = "TX_MODIFIABLE", De[De.VERSION = 251] = "VERSION";
    })(B = o.psbtGlobal || (o.psbtGlobal = {}));
    var D;
    (function(De) {
      De[De.NON_WITNESS_UTXO = 0] = "NON_WITNESS_UTXO", De[De.WITNESS_UTXO = 1] = "WITNESS_UTXO", De[De.PARTIAL_SIG = 2] = "PARTIAL_SIG", De[De.SIGHASH_TYPE = 3] = "SIGHASH_TYPE", De[De.REDEEM_SCRIPT = 4] = "REDEEM_SCRIPT", De[De.WITNESS_SCRIPT = 5] = "WITNESS_SCRIPT", De[De.BIP32_DERIVATION = 6] = "BIP32_DERIVATION", De[De.FINAL_SCRIPTSIG = 7] = "FINAL_SCRIPTSIG", De[De.FINAL_SCRIPTWITNESS = 8] = "FINAL_SCRIPTWITNESS", De[De.PREVIOUS_TXID = 14] = "PREVIOUS_TXID", De[De.OUTPUT_INDEX = 15] = "OUTPUT_INDEX", De[De.SEQUENCE = 16] = "SEQUENCE", De[De.TAP_KEY_SIG = 19] = "TAP_KEY_SIG", De[De.TAP_BIP32_DERIVATION = 22] = "TAP_BIP32_DERIVATION";
    })(D = o.psbtIn || (o.psbtIn = {}));
    var x;
    (function(De) {
      De[De.REDEEM_SCRIPT = 0] = "REDEEM_SCRIPT", De[De.WITNESS_SCRIPT = 1] = "WITNESS_SCRIPT", De[De.BIP_32_DERIVATION = 2] = "BIP_32_DERIVATION", De[De.AMOUNT = 3] = "AMOUNT", De[De.SCRIPT = 4] = "SCRIPT", De[De.TAP_BIP32_DERIVATION = 7] = "TAP_BIP32_DERIVATION";
    })(x = o.psbtOut || (o.psbtOut = {}));
    const v = Buffer.from([112, 115, 98, 116, 255]);
    class F extends Error {
    }
    o.NoSuchEntry = F;
    class M {
      constructor() {
        this.globalMap = /* @__PURE__ */ new Map(), this.inputMaps = [], this.outputMaps = [];
      }
      setGlobalTxVersion(ve) {
        this.setGlobal(B.TX_VERSION, Se(ve));
      }
      getGlobalTxVersion() {
        return this.getGlobal(B.TX_VERSION).readUInt32LE(0);
      }
      setGlobalFallbackLocktime(ve) {
        this.setGlobal(B.FALLBACK_LOCKTIME, Se(ve));
      }
      getGlobalFallbackLocktime() {
        var ve;
        return (ve = this.getGlobalOptional(B.FALLBACK_LOCKTIME)) === null || ve === void 0 ? void 0 : ve.readUInt32LE(0);
      }
      setGlobalInputCount(ve) {
        this.setGlobal(B.INPUT_COUNT, He(ve));
      }
      getGlobalInputCount() {
        return Pe(this.getGlobal(B.INPUT_COUNT));
      }
      setGlobalOutputCount(ve) {
        this.setGlobal(B.OUTPUT_COUNT, He(ve));
      }
      getGlobalOutputCount() {
        return Pe(this.getGlobal(B.OUTPUT_COUNT));
      }
      setGlobalTxModifiable(ve) {
        this.setGlobal(B.TX_MODIFIABLE, ve);
      }
      getGlobalTxModifiable() {
        return this.getGlobalOptional(B.TX_MODIFIABLE);
      }
      setGlobalPsbtVersion(ve) {
        this.setGlobal(B.VERSION, Se(ve));
      }
      getGlobalPsbtVersion() {
        return this.getGlobal(B.VERSION).readUInt32LE(0);
      }
      setInputNonWitnessUtxo(ve, Fe) {
        this.setInput(ve, D.NON_WITNESS_UTXO, Ie(), Fe);
      }
      getInputNonWitnessUtxo(ve) {
        return this.getInputOptional(ve, D.NON_WITNESS_UTXO, Ie());
      }
      setInputWitnessUtxo(ve, Fe, be) {
        const Be = new d.BufferWriter();
        Be.writeSlice(ze(Fe)), Be.writeVarSlice(be), this.setInput(ve, D.WITNESS_UTXO, Ie(), Be.buffer());
      }
      getInputWitnessUtxo(ve) {
        const Fe = this.getInputOptional(ve, D.WITNESS_UTXO, Ie());
        if (!Fe)
          return;
        const be = new d.BufferReader(Fe);
        return {
          amount: (0, d.unsafeFrom64bitLE)(be.readSlice(8)),
          scriptPubKey: be.readVarSlice()
        };
      }
      setInputPartialSig(ve, Fe, be) {
        this.setInput(ve, D.PARTIAL_SIG, Fe, be);
      }
      getInputPartialSig(ve, Fe) {
        return this.getInputOptional(ve, D.PARTIAL_SIG, Fe);
      }
      setInputSighashType(ve, Fe) {
        this.setInput(ve, D.SIGHASH_TYPE, Ie(), Se(Fe));
      }
      getInputSighashType(ve) {
        const Fe = this.getInputOptional(ve, D.SIGHASH_TYPE, Ie());
        if (Fe)
          return Fe.readUInt32LE(0);
      }
      setInputRedeemScript(ve, Fe) {
        this.setInput(ve, D.REDEEM_SCRIPT, Ie(), Fe);
      }
      getInputRedeemScript(ve) {
        return this.getInputOptional(ve, D.REDEEM_SCRIPT, Ie());
      }
      setInputWitnessScript(ve, Fe) {
        this.setInput(ve, D.WITNESS_SCRIPT, Ie(), Fe);
      }
      getInputWitnessScript(ve) {
        return this.getInputOptional(ve, D.WITNESS_SCRIPT, Ie());
      }
      setInputBip32Derivation(ve, Fe, be, Be) {
        if (Fe.length != 33)
          throw new Error("Invalid pubkey length: " + Fe.length);
        this.setInput(ve, D.BIP32_DERIVATION, Fe, this.encodeBip32Derivation(be, Be));
      }
      getInputBip32Derivation(ve, Fe) {
        const be = this.getInputOptional(ve, D.BIP32_DERIVATION, Fe);
        if (be)
          return this.decodeBip32Derivation(be);
      }
      setInputFinalScriptsig(ve, Fe) {
        this.setInput(ve, D.FINAL_SCRIPTSIG, Ie(), Fe);
      }
      getInputFinalScriptsig(ve) {
        return this.getInputOptional(ve, D.FINAL_SCRIPTSIG, Ie());
      }
      setInputFinalScriptwitness(ve, Fe) {
        this.setInput(ve, D.FINAL_SCRIPTWITNESS, Ie(), Fe);
      }
      getInputFinalScriptwitness(ve) {
        return this.getInput(ve, D.FINAL_SCRIPTWITNESS, Ie());
      }
      setInputPreviousTxId(ve, Fe) {
        this.setInput(ve, D.PREVIOUS_TXID, Ie(), Fe);
      }
      getInputPreviousTxid(ve) {
        return this.getInput(ve, D.PREVIOUS_TXID, Ie());
      }
      setInputOutputIndex(ve, Fe) {
        this.setInput(ve, D.OUTPUT_INDEX, Ie(), Se(Fe));
      }
      getInputOutputIndex(ve) {
        return this.getInput(ve, D.OUTPUT_INDEX, Ie()).readUInt32LE(0);
      }
      setInputSequence(ve, Fe) {
        this.setInput(ve, D.SEQUENCE, Ie(), Se(Fe));
      }
      getInputSequence(ve) {
        var Fe, be;
        return (be = (Fe = this.getInputOptional(ve, D.SEQUENCE, Ie())) === null || Fe === void 0 ? void 0 : Fe.readUInt32LE(0)) !== null && be !== void 0 ? be : 4294967295;
      }
      setInputTapKeySig(ve, Fe) {
        this.setInput(ve, D.TAP_KEY_SIG, Ie(), Fe);
      }
      getInputTapKeySig(ve) {
        return this.getInputOptional(ve, D.TAP_KEY_SIG, Ie());
      }
      setInputTapBip32Derivation(ve, Fe, be, Be, ke) {
        if (Fe.length != 32)
          throw new Error("Invalid pubkey length: " + Fe.length);
        const xe = this.encodeTapBip32Derivation(be, Be, ke);
        this.setInput(ve, D.TAP_BIP32_DERIVATION, Fe, xe);
      }
      getInputTapBip32Derivation(ve, Fe) {
        const be = this.getInput(ve, D.TAP_BIP32_DERIVATION, Fe);
        return this.decodeTapBip32Derivation(be);
      }
      getInputKeyDatas(ve, Fe) {
        return this.getKeyDatas(this.inputMaps[ve], Fe);
      }
      setOutputRedeemScript(ve, Fe) {
        this.setOutput(ve, x.REDEEM_SCRIPT, Ie(), Fe);
      }
      getOutputRedeemScript(ve) {
        return this.getOutput(ve, x.REDEEM_SCRIPT, Ie());
      }
      setOutputBip32Derivation(ve, Fe, be, Be) {
        this.setOutput(ve, x.BIP_32_DERIVATION, Fe, this.encodeBip32Derivation(be, Be));
      }
      getOutputBip32Derivation(ve, Fe) {
        const be = this.getOutput(ve, x.BIP_32_DERIVATION, Fe);
        return this.decodeBip32Derivation(be);
      }
      setOutputAmount(ve, Fe) {
        this.setOutput(ve, x.AMOUNT, Ie(), ze(Fe));
      }
      getOutputAmount(ve) {
        const Fe = this.getOutput(ve, x.AMOUNT, Ie());
        return (0, d.unsafeFrom64bitLE)(Fe);
      }
      setOutputScript(ve, Fe) {
        this.setOutput(ve, x.SCRIPT, Ie(), Fe);
      }
      getOutputScript(ve) {
        return this.getOutput(ve, x.SCRIPT, Ie());
      }
      setOutputTapBip32Derivation(ve, Fe, be, Be, ke) {
        const xe = this.encodeTapBip32Derivation(be, Be, ke);
        this.setOutput(ve, x.TAP_BIP32_DERIVATION, Fe, xe);
      }
      getOutputTapBip32Derivation(ve, Fe) {
        const be = this.getOutput(ve, x.TAP_BIP32_DERIVATION, Fe);
        return this.decodeTapBip32Derivation(be);
      }
      deleteInputEntries(ve, Fe) {
        this.inputMaps[ve].forEach((Be, ke, xe) => {
          this.isKeyType(ke, Fe) && xe.delete(ke);
        });
      }
      copy(ve) {
        this.copyMap(this.globalMap, ve.globalMap), this.copyMaps(this.inputMaps, ve.inputMaps), this.copyMaps(this.outputMaps, ve.outputMaps);
      }
      copyMaps(ve, Fe) {
        ve.forEach((be, Be) => {
          const ke = /* @__PURE__ */ new Map();
          this.copyMap(be, ke), Fe[Be] = ke;
        });
      }
      copyMap(ve, Fe) {
        ve.forEach((be, Be) => Fe.set(Be, Buffer.from(be)));
      }
      serialize() {
        const ve = new d.BufferWriter();
        return ve.writeSlice(v), ge(ve, this.globalMap), this.inputMaps.forEach((Fe) => {
          ge(ve, Fe);
        }), this.outputMaps.forEach((Fe) => {
          ge(ve, Fe);
        }), ve.buffer();
      }
      deserialize(ve) {
        const Fe = new d.BufferReader(ve);
        if (!Fe.readSlice(5).equals(v))
          throw new Error("Invalid magic bytes");
        for (; this.readKeyPair(this.globalMap, Fe); )
          ;
        let be;
        try {
          be = this.getGlobalPsbtVersion();
        } catch {
          be = 0;
        }
        if (be !== 0 && be !== 2)
          throw new Error("Only PSBTs of version 0 or 2 are supported");
        let Be, ke;
        if (be == 0) {
          const xe = this.getGlobal(B.UNSIGNED_TX), Ne = t.Transaction.fromBuffer(xe);
          Be = Ne.ins.length, ke = Ne.outs.length;
        } else
          Be = this.getGlobalInputCount(), ke = this.getGlobalOutputCount();
        for (let xe = 0; xe < Be; xe++)
          for (this.inputMaps[xe] = /* @__PURE__ */ new Map(); this.readKeyPair(this.inputMaps[xe], Fe); )
            ;
        for (let xe = 0; xe < ke; xe++)
          for (this.outputMaps[xe] = /* @__PURE__ */ new Map(); this.readKeyPair(this.outputMaps[xe], Fe); )
            ;
        this.normalizeToV2();
      }
      normalizeToV2() {
        var ve;
        const Fe = (ve = this.getGlobalOptional(B.VERSION)) === null || ve === void 0 ? void 0 : ve.readInt32LE(0);
        if (Fe === 2)
          return;
        if (Fe !== void 0)
          throw new Error("Invalid or unsupported value for PSBT_GLOBAL_VERSION");
        const be = this.getGlobal(B.UNSIGNED_TX), Be = t.Transaction.fromBuffer(be);
        this.setGlobalPsbtVersion(2), this.setGlobalTxVersion(Be.version), this.setGlobalFallbackLocktime(Be.locktime), this.setGlobalInputCount(Be.ins.length), this.setGlobalOutputCount(Be.outs.length);
        for (let ke = 0; ke < Be.ins.length; ke++)
          this.setInputPreviousTxId(ke, Be.ins[ke].hash), this.setInputOutputIndex(ke, Be.ins[ke].index), this.setInputSequence(ke, Be.ins[ke].sequence);
        for (let ke = 0; ke < Be.outs.length; ke++)
          this.setOutputAmount(ke, Be.outs[ke].value), this.setOutputScript(ke, Be.outs[ke].script);
        this.globalMap.delete(B.UNSIGNED_TX.toString(16).padStart(2, "0"));
      }
      /**
       * Imports a BitcoinJS (bitcoinjs-lib) Psbt object.
       * https://github.com/bitcoinjs/bitcoinjs-lib/blob/master/ts_src/psbt.ts
       *
       * Prepares the fields required for signing a Psbt on a Ledger
       * device. It should be used exclusively before calling
       * `appClient.signPsbt()` and not as a general Psbt conversion method.
       *
       * Note: This method supports all the policies that the Ledger is able to
       * sign, with the exception of taproot: tr(@0).
       */
      fromBitcoinJS(ve) {
        function Fe(be) {
          let Be;
          try {
            t.payments.p2tr({ output: be.witnessUtxo.script }), Be = !0;
          } catch {
            Be = !1;
          }
          return be && !!(be.tapInternalKey || be.tapMerkleRoot || be.tapLeafScript && be.tapLeafScript.length || be.tapBip32Derivation && be.tapBip32Derivation.length || Be);
        }
        return this.setGlobalPsbtVersion(2), this.setGlobalTxVersion(ve.version), this.setGlobalInputCount(ve.data.inputs.length), this.setGlobalOutputCount(ve.txOutputs.length), ve.locktime !== void 0 && this.setGlobalFallbackLocktime(ve.locktime), ve.data.inputs.forEach((be, Be) => {
          if (Fe(be))
            throw new Error("Taproot inputs not supported");
          this.setInputPreviousTxId(Be, ve.txInputs[Be].hash), ve.txInputs[Be].sequence !== void 0 && this.setInputSequence(Be, ve.txInputs[Be].sequence), this.setInputOutputIndex(Be, ve.txInputs[Be].index), be.sighashType !== void 0 && this.setInputSighashType(Be, be.sighashType), be.nonWitnessUtxo && this.setInputNonWitnessUtxo(Be, be.nonWitnessUtxo), be.witnessUtxo && this.setInputWitnessUtxo(Be, be.witnessUtxo.value, be.witnessUtxo.script), be.witnessScript && this.setInputWitnessScript(Be, be.witnessScript), be.redeemScript && this.setInputRedeemScript(Be, be.redeemScript), ve.data.inputs[Be].bip32Derivation.forEach((ke) => {
            if (!/^m\//i.test(ke.path))
              throw new Error("Invalid input bip32 derivation");
            const xe = ke.path.replace(/m\//i, "").split("/").map((Ne) => Ne.match(/['h]/i) ? parseInt(Ne) + 2147483648 : Number(Ne));
            this.setInputBip32Derivation(Be, ke.pubkey, ke.masterFingerprint, xe);
          });
        }), ve.txOutputs.forEach((be, Be) => {
          this.setOutputAmount(Be, be.value), this.setOutputScript(Be, be.script);
        }), this;
      }
      readKeyPair(ve, Fe) {
        const be = (0, E.sanitizeBigintToNumber)(Fe.readVarInt());
        if (be == 0)
          return !1;
        const Be = Fe.readUInt8(), ke = Fe.readSlice(be - 1), xe = Fe.readVarSlice();
        return Ee(ve, Be, ke, xe), !0;
      }
      getKeyDatas(ve, Fe) {
        const be = [];
        return ve.forEach((Be, ke) => {
          this.isKeyType(ke, [Fe]) && be.push(Buffer.from(ke.substring(2), "hex"));
        }), be;
      }
      isKeyType(ve, Fe) {
        const be = Buffer.from(ve.substring(0, 2), "hex").readUInt8(0);
        return Fe.some((Be) => Be == be);
      }
      setGlobal(ve, Fe) {
        const be = new L(ve, Buffer.from([]));
        this.globalMap.set(be.toString(), Fe);
      }
      getGlobal(ve) {
        return U(this.globalMap, ve, Ie(), !1);
      }
      getGlobalOptional(ve) {
        return U(this.globalMap, ve, Ie(), !0);
      }
      setInput(ve, Fe, be, Be) {
        Ee(this.getMap(ve, this.inputMaps), Fe, be, Be);
      }
      getInput(ve, Fe, be) {
        return U(this.inputMaps[ve], Fe, be, !1);
      }
      getInputOptional(ve, Fe, be) {
        return U(this.inputMaps[ve], Fe, be, !0);
      }
      setOutput(ve, Fe, be, Be) {
        Ee(this.getMap(ve, this.outputMaps), Fe, be, Be);
      }
      getOutput(ve, Fe, be) {
        return U(this.outputMaps[ve], Fe, be, !1);
      }
      getMap(ve, Fe) {
        return Fe[ve] ? Fe[ve] : Fe[ve] = /* @__PURE__ */ new Map();
      }
      encodeBip32Derivation(ve, Fe) {
        const be = new d.BufferWriter();
        return this.writeBip32Derivation(be, ve, Fe), be.buffer();
      }
      decodeBip32Derivation(ve) {
        const Fe = new d.BufferReader(ve);
        return this.readBip32Derivation(Fe);
      }
      writeBip32Derivation(ve, Fe, be) {
        ve.writeSlice(Fe), be.forEach((Be) => {
          ve.writeUInt32(Be);
        });
      }
      readBip32Derivation(ve) {
        const Fe = ve.readSlice(4), be = [];
        for (; ve.offset < ve.buffer.length; )
          be.push(ve.readUInt32());
        return { masterFingerprint: Fe, path: be };
      }
      encodeTapBip32Derivation(ve, Fe, be) {
        const Be = new d.BufferWriter();
        return Be.writeVarInt(ve.length), ve.forEach((ke) => {
          Be.writeSlice(ke);
        }), this.writeBip32Derivation(Be, Fe, be), Be.buffer();
      }
      decodeTapBip32Derivation(ve) {
        const Fe = new d.BufferReader(ve), be = (0, E.sanitizeBigintToNumber)(Fe.readVarInt()), Be = [];
        for (let xe = 0; xe < be; xe++)
          Be.push(Fe.readSlice(32));
        const ke = this.readBip32Derivation(Fe);
        return Object.assign({ hashes: Be }, ke);
      }
    }
    o.PsbtV2 = M;
    function U(De, ve, Fe, be) {
      if (!De)
        throw Error("No such map");
      const Be = new L(ve, Fe), ke = De.get(Be.toString());
      if (!ke) {
        if (be)
          return;
        throw new F(Be.toString());
      }
      return Buffer.from(ke);
    }
    class L {
      constructor(ve, Fe) {
        this.keyType = ve, this.keyData = Fe;
      }
      toString() {
        const ve = new d.BufferWriter();
        return this.toBuffer(ve), ve.buffer().toString("hex");
      }
      serialize(ve) {
        ve.writeVarInt(1 + this.keyData.length), this.toBuffer(ve);
      }
      toBuffer(ve) {
        ve.writeUInt8(this.keyType), ve.writeSlice(this.keyData);
      }
    }
    class H {
      constructor(ve, Fe) {
        this.key = ve, this.value = Fe;
      }
      serialize(ve) {
        this.key.serialize(ve), ve.writeVarSlice(this.value);
      }
    }
    function fe(De) {
      return new L(De.readUInt8(0), De.slice(1));
    }
    function ge(De, ve) {
      for (let [Fe, be] of [...ve].sort(([Be], [ke]) => Be.localeCompare(ke)))
        new H(fe(Buffer.from(Fe, "hex")), be).serialize(De);
      De.writeUInt8(0);
    }
    function Ie() {
      return Buffer.from([]);
    }
    function Ee(De, ve, Fe, be) {
      const Be = new L(ve, Fe);
      De.set(Be.toString(), be);
    }
    function Se(De) {
      const ve = Buffer.alloc(4);
      return ve.writeUInt32LE(De, 0), ve;
    }
    function ze(De) {
      return (0, d.unsafeTo64bitLE)(De);
    }
    function He(De) {
      const ve = new d.BufferWriter();
      return ve.writeVarInt(De), ve.buffer();
    }
    function Pe(De) {
      return (0, E.sanitizeBigintToNumber)(new d.BufferReader(De).readVarInt());
    }
  }(psbtv2$1)), psbtv2$1;
}
var hasRequiredMerkelizedPsbt$1;
function requireMerkelizedPsbt$1() {
  if (hasRequiredMerkelizedPsbt$1) return merkelizedPsbt$1;
  hasRequiredMerkelizedPsbt$1 = 1, Object.defineProperty(merkelizedPsbt$1, "__esModule", { value: !0 }), merkelizedPsbt$1.MerkelizedPsbt = void 0;
  const o = requireMerkleMap$1(), g = requirePsbtv2$1();
  class c extends g.PsbtV2 {
    constructor(t) {
      super(), this.inputMerkleMaps = [], this.outputMerkleMaps = [], t.copy(this), this.globalMerkleMap = c.createMerkleMap(this.globalMap);
      for (let d = 0; d < this.getGlobalInputCount(); d++)
        this.inputMerkleMaps.push(c.createMerkleMap(this.inputMaps[d]));
      this.inputMapCommitments = [...this.inputMerkleMaps.values()].map((d) => d.commitment());
      for (let d = 0; d < this.getGlobalOutputCount(); d++)
        this.outputMerkleMaps.push(c.createMerkleMap(this.outputMaps[d]));
      this.outputMapCommitments = [...this.outputMerkleMaps.values()].map((d) => d.commitment());
    }
    // These public functions are for MerkelizedPsbt.
    getGlobalSize() {
      return this.globalMap.size;
    }
    getGlobalKeysValuesRoot() {
      return this.globalMerkleMap.commitment();
    }
    static createMerkleMap(t) {
      const d = [...t.keys()].sort(), E = d.map((D) => {
        const x = t.get(D);
        if (!x)
          throw new Error("No value for key " + D);
        return x;
      }), B = d.map((D) => Buffer.from(D, "hex"));
      return new o.MerkleMap(B, E);
    }
  }
  return merkelizedPsbt$1.MerkelizedPsbt = c, merkelizedPsbt$1;
}
var hasRequiredAppClient$1;
function requireAppClient$1() {
  if (hasRequiredAppClient$1) return appClient$2;
  hasRequiredAppClient$1 = 1;
  var o = appClient$2 && appClient$2.__createBinding || (Object.create ? function(ze, He, Pe, De) {
    De === void 0 && (De = Pe);
    var ve = Object.getOwnPropertyDescriptor(He, Pe);
    (!ve || ("get" in ve ? !He.__esModule : ve.writable || ve.configurable)) && (ve = { enumerable: !0, get: function() {
      return He[Pe];
    } }), Object.defineProperty(ze, De, ve);
  } : function(ze, He, Pe, De) {
    De === void 0 && (De = Pe), ze[De] = He[Pe];
  }), g = appClient$2 && appClient$2.__setModuleDefault || (Object.create ? function(ze, He) {
    Object.defineProperty(ze, "default", { enumerable: !0, value: He });
  } : function(ze, He) {
    ze.default = He;
  }), c = appClient$2 && appClient$2.__importStar || function(ze) {
    if (ze && ze.__esModule) return ze;
    var He = {};
    if (ze != null) for (var Pe in ze) Pe !== "default" && Object.prototype.hasOwnProperty.call(ze, Pe) && o(He, ze, Pe);
    return g(He, ze), He;
  };
  Object.defineProperty(appClient$2, "__esModule", { value: !0 }), appClient$2.AppClient = appClient$2.PartialSignature = void 0;
  const y = c(requireDist()), t = c(requireDist$q()), { Descriptor: d } = y.DescriptorsFactory(t), E = require$$1, B = requireBip32$1(), D = requireClientCommands$1(), x = requireMerkelizedPsbt$1(), v = requireMerkle$1(), F = requirePsbtv2$1(), M = requireVarint$1(), U = 225, L = 248, H = 1;
  var fe;
  (function(ze) {
    ze[ze.GET_PUBKEY = 0] = "GET_PUBKEY", ze[ze.REGISTER_WALLET = 2] = "REGISTER_WALLET", ze[ze.GET_WALLET_ADDRESS = 3] = "GET_WALLET_ADDRESS", ze[ze.SIGN_PSBT = 4] = "SIGN_PSBT", ze[ze.GET_MASTER_FINGERPRINT = 5] = "GET_MASTER_FINGERPRINT", ze[ze.SIGN_MESSAGE = 16] = "SIGN_MESSAGE";
  })(fe || (fe = {}));
  var ge;
  (function(ze) {
    ze[ze.CONTINUE_INTERRUPTED = 1] = "CONTINUE_INTERRUPTED";
  })(ge || (ge = {}));
  class Ie {
    constructor(He, Pe, De) {
      this.pubkey = He, this.signature = Pe, this.tapleafHash = De;
    }
  }
  appClient$2.PartialSignature = Ie;
  function Ee(ze, He) {
    if (ze.length == 64)
      return new Ie(ze.slice(0, 32), He, ze.slice(32, 64));
    if (ze.length == 32 || ze.length == 33)
      return new Ie(ze, He);
    throw new Error(`Invalid length for pubkeyAugm: ${ze.length} bytes.`);
  }
  class Se {
    constructor(He) {
      this.transport = He;
    }
    async makeRequest(He, Pe, De) {
      let ve = await this.transport.send(U, He, 0, H, Pe, [36864, 57344]);
      for (; ve.readUInt16BE(ve.length - 2) === 57344; ) {
        if (!De)
          throw new Error("Unexpected SW_INTERRUPTED_EXECUTION");
        const Fe = ve.slice(0, -2), be = De.execute(Fe);
        ve = await this.transport.send(L, ge.CONTINUE_INTERRUPTED, 0, 0, be, [36864, 57344]);
      }
      return ve.slice(0, -2);
    }
    /**
     * Returns an object containing the currently running app's name, version and the device status flags.
     *
     * @returns an object with app name, version and device status flags.
     */
    async getAppAndVersion() {
      const He = await this.transport.send(176, 1, 0, 0);
      let Pe = 0;
      if (He[Pe++] !== 1)
        throw new Error("Unexpected response");
      const ve = He[Pe++], Fe = He.slice(Pe, Pe += ve).toString("ascii"), be = He[Pe++], Be = He.slice(Pe, Pe += be).toString("ascii"), ke = He[Pe++], xe = He.slice(Pe, Pe += ke);
      return {
        name: Fe,
        version: Be,
        flags: xe
      };
    }
    /**
     * Requests the BIP-32 extended pubkey to the hardware wallet.
     * If `display` is `false`, only standard paths will be accepted; an error is returned if an unusual path is
     * requested.
     * If `display` is `true`, the requested path is shown on screen for user verification; unusual paths can be
     * requested, and a warning is shown to the user in that case.
     *
     * @param path the requested BIP-32 path as a string
     * @param display `false` to silently retrieve a pubkey for a standard path, `true` to display the path on screen
     * @returns the base58-encoded serialized extended pubkey (xpub)
     */
    async getExtendedPubkey(He, Pe = !1) {
      const De = (0, B.pathStringToArray)(He);
      if (De.length > 6)
        throw new Error("Path too long. At most 6 levels allowed.");
      return (await this.makeRequest(fe.GET_PUBKEY, Buffer.concat([
        Buffer.from(Pe ? [1] : [0]),
        (0, B.pathElementsToBuffer)(De)
      ]))).toString("ascii");
    }
    /**
     * Registers a `WalletPolicy`, after interactive verification from the user.
     * On success, after user's approval, this function returns the id (which is the same that can be computed with
     * `walletPolicy.getid()`), followed by the 32-byte hmac. The client should store the hmac to use it for future
     * requests to `getWalletAddress` or `signPsbt` using this `WalletPolicy`.
     *
     * @param walletPolicy the `WalletPolicy` to register
     * @returns a pair of two 32-byte arrays: the id of the Wallet Policy, followed by the policy hmac
     */
    async registerWallet(He) {
      const Pe = new D.ClientCommandInterpreter();
      Pe.addKnownWalletPolicy(He);
      const De = He.serialize(), ve = await this.makeRequest(fe.REGISTER_WALLET, Buffer.concat([
        (0, M.createVarint)(De.length),
        De
      ]), Pe);
      if (ve.length != 64)
        throw Error(`Invalid response length. Expected 64 bytes, got ${ve.length}`);
      const Fe = ve.subarray(0, 32), be = ve.subarray(32), Be = await this.getWalletAddress(He, be, 0, 0, !1);
      return await this.validateAddress(Be, He, 0, 0), [Fe, be];
    }
    /**
     * Returns the address of `walletPolicy` for the given `change` and `addressIndex`.
     *
     * @param walletPolicy the `WalletPolicy` to use
     * @param walletHMAC the 32-byte hmac returned during wallet registration for a registered policy; otherwise
     * `null` for a standard policy
     * @param change `0` for a normal receive address, `1` for a change address
     * @param addressIndex the address index to retrieve
     * @param display `True` to show the address on screen, `False` to retrieve it silently
     * @returns the address, as an ascii string.
     */
    async getWalletAddress(He, Pe, De, ve, Fe) {
      if (De !== 0 && De !== 1)
        throw new Error("Change can only be 0 or 1");
      if (ve < 0 || !Number.isInteger(ve))
        throw new Error("Invalid address index");
      if (Pe != null && Pe.length != 32)
        throw new Error("Invalid HMAC length");
      const be = new D.ClientCommandInterpreter();
      be.addKnownWalletPolicy(He);
      const Be = Buffer.alloc(4);
      Be.writeUInt32BE(ve, 0);
      const xe = (await this.makeRequest(fe.GET_WALLET_ADDRESS, Buffer.concat([
        Buffer.from(Fe ? [1] : [0]),
        He.getId(),
        Pe || Buffer.alloc(32, 0),
        Buffer.from([De]),
        Be
      ]), be)).toString("ascii");
      return await this.validateAddress(xe, He, De, ve), xe;
    }
    /**
     * Signs a psbt using a (standard or registered) `WalletPolicy`. This is an interactive command, as user validation
     * is necessary using the device's secure screen.
     * On success, a map of input indexes and signatures is returned.
     * @param psbt a base64-encoded string, or a psbt in a binary Buffer. Using the `PsbtV2` type is deprecated.
     * @param walletPolicy the `WalletPolicy` to use for signing
     * @param walletHMAC the 32-byte hmac obtained during wallet policy registration, or `null` for a standard policy
     * @param progressCallback optionally, a callback that will be called every time a signature is produced during
     * the signing process. The callback does not receive any argument, but can be used to track progress.
     * @returns an array of of tuples with 2 elements containing:
     *    - the index of the input being signed;
     *    - an instance of PartialSignature
     */
    async signPsbt(He, Pe, De, ve) {
      if (typeof He == "string" && (He = Buffer.from(He, "base64")), Buffer.isBuffer(He)) {
        const Et = new F.PsbtV2();
        Et.deserialize(He), He = Et;
      }
      const Fe = new x.MerkelizedPsbt(He);
      if (De != null && De.length != 32)
        throw new Error("Invalid HMAC length");
      const be = new D.ClientCommandInterpreter(ve);
      be.addKnownWalletPolicy(Pe), be.addKnownMapping(Fe.globalMerkleMap);
      for (const Et of Fe.inputMerkleMaps)
        be.addKnownMapping(Et);
      for (const Et of Fe.outputMerkleMaps)
        be.addKnownMapping(Et);
      be.addKnownList(Fe.inputMapCommitments);
      const Be = new v.Merkle(Fe.inputMapCommitments.map((Et) => (0, v.hashLeaf)(Et))).getRoot();
      be.addKnownList(Fe.outputMapCommitments);
      const ke = new v.Merkle(Fe.outputMapCommitments.map((Et) => (0, v.hashLeaf)(Et))).getRoot();
      await this.makeRequest(fe.SIGN_PSBT, Buffer.concat([
        Fe.getGlobalKeysValuesRoot(),
        (0, M.createVarint)(Fe.getGlobalInputCount()),
        Be,
        (0, M.createVarint)(Fe.getGlobalOutputCount()),
        ke,
        Pe.getId(),
        De || Buffer.alloc(32, 0)
      ]), be);
      const xe = be.getYielded(), Ne = [];
      for (const Et of xe) {
        const [st, Dt] = (0, M.parseVarint)(Et, 0), er = Et[Dt], xt = Et.subarray(Dt + 1, Dt + 1 + er), ir = Et.subarray(Dt + 1 + er), sr = Ee(xt, ir);
        Ne.push([Number(st), sr]);
      }
      return Ne;
    }
    /**
     * Returns the fingerprint of the master public key, as per BIP-32 standard.
     * @returns the master key fingerprint as a string of 8 hexadecimal digits.
     */
    async getMasterFingerprint() {
      return (await this.makeRequest(fe.GET_MASTER_FINGERPRINT, Buffer.from([]))).toString("hex");
    }
    /**
     * Signs a message using the legacy Bitcoin Message Signing standard. The signed message is
     * the double-sha256 hash of the concatenation of:
     * - "\x18Bitcoin Signed Message:\n";
     * - the length of `message`, encoded as a Bitcoin-style variable length integer;
     * - `message`.
     *
     * @param message the serialized message to sign
     * @param path the BIP-32 path of the key used to sign the message
     * @returns base64-encoded signature of the message.
     */
    async signMessage(He, Pe) {
      const De = (0, B.pathStringToArray)(Pe), ve = new D.ClientCommandInterpreter(), Fe = Math.ceil(He.length / 64), be = [];
      for (let xe = 0; xe < Fe; xe++)
        be.push(He.subarray(64 * xe, 64 * xe + 64));
      ve.addKnownList(be);
      const Be = new v.Merkle(be.map((xe) => (0, v.hashLeaf)(xe))).getRoot();
      return (await this.makeRequest(fe.SIGN_MESSAGE, Buffer.concat([
        (0, B.pathElementsToBuffer)(De),
        (0, M.createVarint)(He.length),
        Be
      ]), ve)).toString("base64");
    }
    /* Performs any additional check on the generated address before returning it.*/
    async validateAddress(He, Pe, De, ve) {
      if (De !== 0 && De !== 1)
        throw new Error("Change can only be 0 or 1");
      const Fe = De === 1;
      if (ve < 0 || !Number.isInteger(ve))
        throw new Error("Invalid address index");
      const be = await this.getAppAndVersion();
      let Be;
      if (be.name === "Babylon BTC Test")
        Be = E.networks.testnet;
      else if (be.name === "Babylon BTC Staking")
        Be = E.networks.bitcoin;
      else
        throw new Error(`Invalid app: ${be.name}. Expected 'Babylon BTC Test' or 'Babylon BTC Staking'.`);
      let ke = Pe.descriptorTemplate;
      ke = ke.replace(/\/\*\*/g, "/<0;1>/*");
      const xe = new RegExp("/<(\\d+);(\\d+)>", "g");
      let Ne;
      for (; (Ne = xe.exec(ke)) !== null; ) {
        const [Dt, er] = [parseInt(Ne[1], 10), parseInt(Ne[2], 10)];
        ke = ke.replace(`/<${Dt};${er}>`, `/${Fe ? er : Dt}`);
      }
      ke = ke.replace(/\/\*/g, `/${ve}`);
      for (let Dt = Pe.keys.length - 1; Dt >= 0; Dt--)
        ke = ke.replace(new RegExp(`@${Dt}`, "g"), Pe.keys[Dt]);
      let Et = !0, st;
      try {
        st = new d({
          expression: ke,
          network: Be
        }).getAddress();
      } catch {
        Et = !1;
      }
      if (Et && He !== st)
        throw new Error(`Third party address validation mismatch: ${He} != ${st}`);
    }
  }
  return appClient$2.AppClient = Se, appClient$2.default = Se, appClient$2;
}
var policy$1 = {}, hasRequiredPolicy$1;
function requirePolicy$1() {
  if (hasRequiredPolicy$1) return policy$1;
  hasRequiredPolicy$1 = 1, Object.defineProperty(policy$1, "__esModule", { value: !0 }), policy$1.DefaultWalletPolicy = policy$1.WalletPolicy = void 0;
  const o = require$$1, g = requireBuffertools$1(), c = requireMerkle$1(), y = 2;
  class t {
    /**
     * Creates and instance of a wallet policy.
     * @param name an ascii string, up to 16 bytes long; it must be an empty string for default wallet policies
     * @param descriptorTemplate the wallet policy template
     * @param keys and array of the keys, with the key derivation information
     */
    constructor(B, D, x) {
      this.name = B, this.descriptorTemplate = D, this.keys = x;
    }
    /**
     * Returns the unique 32-bytes id of this wallet policy.
     */
    getId() {
      return o.crypto.sha256(this.serialize());
    }
    /**
     * Serializes the wallet policy for transmission via the hardware wallet protocol.
     * @returns the serialized wallet policy
     */
    serialize() {
      const B = this.keys.map((v) => Buffer.from(v, "ascii")), D = new c.Merkle(B.map((v) => (0, c.hashLeaf)(v))), x = new g.BufferWriter();
      return x.writeUInt8(y), x.writeVarSlice(Buffer.from(this.name, "ascii")), x.writeVarInt(this.descriptorTemplate.length), x.writeSlice(o.crypto.sha256(Buffer.from(this.descriptorTemplate))), x.writeVarInt(this.keys.length), x.writeSlice(D.getRoot()), x.buffer();
    }
  }
  policy$1.WalletPolicy = t;
  class d extends t {
    constructor(B, D) {
      super("", B, [D]);
    }
  }
  return policy$1.DefaultWalletPolicy = d, policy$1;
}
var babylon$1 = {}, main$1 = {}, hasRequiredMain$2;
function requireMain$2() {
  var Eo;
  if (hasRequiredMain$2) return main$1;
  hasRequiredMain$2 = 1;
  function o(rr) {
    if (!Number.isSafeInteger(rr) || rr < 0)
      throw new Error(`Wrong positive integer: ${rr}`);
  }
  function g(rr) {
    if (typeof rr != "boolean")
      throw new Error(`Expected boolean, not ${rr}`);
  }
  function c(rr, ...ft) {
    if (!(rr instanceof Uint8Array))
      throw new TypeError("Expected Uint8Array");
    if (ft.length > 0 && !ft.includes(rr.length))
      throw new TypeError(`Expected Uint8Array of length ${ft}, not of length=${rr.length}`);
  }
  function y(rr) {
    if (typeof rr != "function" || typeof rr.create != "function")
      throw new Error("Hash should be wrapped by utils.wrapConstructor");
    o(rr.outputLen), o(rr.blockLen);
  }
  function t(rr, ft = !0) {
    if (rr.destroyed)
      throw new Error("Hash instance has been destroyed");
    if (ft && rr.finished)
      throw new Error("Hash#digest() has already been called");
  }
  function d(rr, ft) {
    c(rr);
    const dr = ft.outputLen;
    if (rr.length < dr)
      throw new Error(`digestInto() expects output buffer of length at least ${dr}`);
  }
  var B = {
    number: o,
    bool: g,
    bytes: c,
    hash: y,
    exists: t,
    output: d
  };
  const D = (rr) => new DataView(rr.buffer, rr.byteOffset, rr.byteLength), x = (rr, ft) => rr << 32 - ft | rr >>> ft;
  if (!(new Uint8Array(new Uint32Array([287454020]).buffer)[0] === 68))
    throw new Error("Non little-endian hardware is not supported");
  Array.from({ length: 256 }, (rr, ft) => ft.toString(16).padStart(2, "0"));
  function F(rr) {
    if (typeof rr != "string")
      throw new TypeError(`utf8ToBytes expected string, got ${typeof rr}`);
    return new TextEncoder().encode(rr);
  }
  function M(rr) {
    if (typeof rr == "string" && (rr = F(rr)), !(rr instanceof Uint8Array))
      throw new TypeError(`Expected input type is Uint8Array (got ${typeof rr})`);
    return rr;
  }
  let U = class {
    // Safe version that clones internal state
    clone() {
      return this._cloneInto();
    }
  };
  function L(rr) {
    const ft = (Or) => rr().update(M(Or)).digest(), dr = rr();
    return ft.outputLen = dr.outputLen, ft.blockLen = dr.blockLen, ft.create = () => rr(), ft;
  }
  function H(rr, ft, dr, Or) {
    if (typeof rr.setBigUint64 == "function")
      return rr.setBigUint64(ft, dr, Or);
    const Zr = BigInt(32), ni = BigInt(4294967295), gi = Number(dr >> Zr & ni), vi = Number(dr & ni), Fi = Or ? 4 : 0, Gi = Or ? 0 : 4;
    rr.setUint32(ft + Fi, gi, Or), rr.setUint32(ft + Gi, vi, Or);
  }
  let fe = class extends U {
    constructor(ft, dr, Or, Zr) {
      super(), this.blockLen = ft, this.outputLen = dr, this.padOffset = Or, this.isLE = Zr, this.finished = !1, this.length = 0, this.pos = 0, this.destroyed = !1, this.buffer = new Uint8Array(ft), this.view = D(this.buffer);
    }
    update(ft) {
      B.exists(this);
      const { view: dr, buffer: Or, blockLen: Zr } = this;
      ft = M(ft);
      const ni = ft.length;
      for (let gi = 0; gi < ni; ) {
        const vi = Math.min(Zr - this.pos, ni - gi);
        if (vi === Zr) {
          const Fi = D(ft);
          for (; Zr <= ni - gi; gi += Zr)
            this.process(Fi, gi);
          continue;
        }
        Or.set(ft.subarray(gi, gi + vi), this.pos), this.pos += vi, gi += vi, this.pos === Zr && (this.process(dr, 0), this.pos = 0);
      }
      return this.length += ft.length, this.roundClean(), this;
    }
    digestInto(ft) {
      B.exists(this), B.output(ft, this), this.finished = !0;
      const { buffer: dr, view: Or, blockLen: Zr, isLE: ni } = this;
      let { pos: gi } = this;
      dr[gi++] = 128, this.buffer.subarray(gi).fill(0), this.padOffset > Zr - gi && (this.process(Or, 0), gi = 0);
      for (let Zi = gi; Zi < Zr; Zi++)
        dr[Zi] = 0;
      H(Or, Zr - 8, BigInt(this.length * 8), ni), this.process(Or, 0);
      const vi = D(ft), Fi = this.outputLen;
      if (Fi % 4)
        throw new Error("_sha2: outputLen should be aligned to 32bit");
      const Gi = Fi / 4, Pn = this.get();
      if (Gi > Pn.length)
        throw new Error("_sha2: outputLen bigger than state");
      for (let Zi = 0; Zi < Gi; Zi++)
        vi.setUint32(4 * Zi, Pn[Zi], ni);
    }
    digest() {
      const { buffer: ft, outputLen: dr } = this;
      this.digestInto(ft);
      const Or = ft.slice(0, dr);
      return this.destroy(), Or;
    }
    _cloneInto(ft) {
      ft || (ft = new this.constructor()), ft.set(...this.get());
      const { blockLen: dr, buffer: Or, length: Zr, finished: ni, destroyed: gi, pos: vi } = this;
      return ft.length = Zr, ft.pos = vi, ft.finished = ni, ft.destroyed = gi, Zr % dr && ft.buffer.set(Or), ft;
    }
  };
  const ge = (rr, ft, dr) => rr & ft ^ ~rr & dr, Ie = (rr, ft, dr) => rr & ft ^ rr & dr ^ ft & dr, Ee = new Uint32Array([
    1116352408,
    1899447441,
    3049323471,
    3921009573,
    961987163,
    1508970993,
    2453635748,
    2870763221,
    3624381080,
    310598401,
    607225278,
    1426881987,
    1925078388,
    2162078206,
    2614888103,
    3248222580,
    3835390401,
    4022224774,
    264347078,
    604807628,
    770255983,
    1249150122,
    1555081692,
    1996064986,
    2554220882,
    2821834349,
    2952996808,
    3210313671,
    3336571891,
    3584528711,
    113926993,
    338241895,
    666307205,
    773529912,
    1294757372,
    1396182291,
    1695183700,
    1986661051,
    2177026350,
    2456956037,
    2730485921,
    2820302411,
    3259730800,
    3345764771,
    3516065817,
    3600352804,
    4094571909,
    275423344,
    430227734,
    506948616,
    659060556,
    883997877,
    958139571,
    1322822218,
    1537002063,
    1747873779,
    1955562222,
    2024104815,
    2227730452,
    2361852424,
    2428436474,
    2756734187,
    3204031479,
    3329325298
  ]), Se = new Uint32Array([
    1779033703,
    3144134277,
    1013904242,
    2773480762,
    1359893119,
    2600822924,
    528734635,
    1541459225
  ]), ze = new Uint32Array(64);
  let He = class extends fe {
    constructor() {
      super(64, 32, 8, !1), this.A = Se[0] | 0, this.B = Se[1] | 0, this.C = Se[2] | 0, this.D = Se[3] | 0, this.E = Se[4] | 0, this.F = Se[5] | 0, this.G = Se[6] | 0, this.H = Se[7] | 0;
    }
    get() {
      const { A: ft, B: dr, C: Or, D: Zr, E: ni, F: gi, G: vi, H: Fi } = this;
      return [ft, dr, Or, Zr, ni, gi, vi, Fi];
    }
    // prettier-ignore
    set(ft, dr, Or, Zr, ni, gi, vi, Fi) {
      this.A = ft | 0, this.B = dr | 0, this.C = Or | 0, this.D = Zr | 0, this.E = ni | 0, this.F = gi | 0, this.G = vi | 0, this.H = Fi | 0;
    }
    process(ft, dr) {
      for (let Zi = 0; Zi < 16; Zi++, dr += 4)
        ze[Zi] = ft.getUint32(dr, !1);
      for (let Zi = 16; Zi < 64; Zi++) {
        const ds = ze[Zi - 15], us = ze[Zi - 2], Is = x(ds, 7) ^ x(ds, 18) ^ ds >>> 3, $n = x(us, 17) ^ x(us, 19) ^ us >>> 10;
        ze[Zi] = $n + ze[Zi - 7] + Is + ze[Zi - 16] | 0;
      }
      let { A: Or, B: Zr, C: ni, D: gi, E: vi, F: Fi, G: Gi, H: Pn } = this;
      for (let Zi = 0; Zi < 64; Zi++) {
        const ds = x(vi, 6) ^ x(vi, 11) ^ x(vi, 25), us = Pn + ds + ge(vi, Fi, Gi) + Ee[Zi] + ze[Zi] | 0, $n = (x(Or, 2) ^ x(Or, 13) ^ x(Or, 22)) + Ie(Or, Zr, ni) | 0;
        Pn = Gi, Gi = Fi, Fi = vi, vi = gi + us | 0, gi = ni, ni = Zr, Zr = Or, Or = us + $n | 0;
      }
      Or = Or + this.A | 0, Zr = Zr + this.B | 0, ni = ni + this.C | 0, gi = gi + this.D | 0, vi = vi + this.E | 0, Fi = Fi + this.F | 0, Gi = Gi + this.G | 0, Pn = Pn + this.H | 0, this.set(Or, Zr, ni, gi, vi, Fi, Gi, Pn);
    }
    roundClean() {
      ze.fill(0);
    }
    destroy() {
      this.set(0, 0, 0, 0, 0, 0, 0, 0), this.buffer.fill(0);
    }
  }, Pe = class extends He {
    constructor() {
      super(), this.A = -1056596264, this.B = 914150663, this.C = 812702999, this.D = -150054599, this.E = -4191439, this.F = 1750603025, this.G = 1694076839, this.H = -1090891868, this.outputLen = 28;
    }
  };
  const De = L(() => new He());
  L(() => new Pe());
  function ve(rr, ft) {
    if (rr.length > ft)
      throw new TypeError(`Data is larger than array size: ${rr.length} > ${ft}`);
  }
  function Fe(rr) {
    if (rr.match(/[^a-fA-f0-9]/) !== null)
      throw new TypeError("Invalid characters in hex string: " + rr);
    if (rr.length % 2 !== 0)
      throw new Error(`Length of hex string is invalid: ${rr.length}`);
  }
  function be(rr) {
    if (rr > Number.MAX_SAFE_INTEGER)
      throw new TypeError("Number exceeds safe bounds!");
  }
  const { getRandomValues: Be } = crypto ?? globalThis.crypto ?? window.crypto;
  function ke(rr = 32) {
    if (typeof Be == "function")
      return crypto.getRandomValues(new Uint8Array(rr));
    throw new Error("Crypto module missing getRandomValues!");
  }
  function xe(rr, ft, dr = "be") {
    ft === void 0 && (ft = rr.length), ve(rr, ft);
    const Or = new Uint8Array(ft).fill(0), Zr = dr === "be" ? 0 : ft - rr.length;
    return Or.set(rr, Zr), Or;
  }
  function Ne(rr) {
    let ft, dr = 0;
    const Or = rr.reduce((ni, gi) => ni + gi.length, 0), Zr = new Uint8Array(Or);
    for (ft = 0; ft < rr.length; ft++) {
      const ni = rr[ft];
      Zr.set(ni, dr), dr += ni.length;
    }
    return Zr;
  }
  const Et = new TextEncoder(), st = [
    {
      name: "base58",
      charset: "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz"
    }
  ];
  function Dt(rr) {
    for (const ft of st)
      if (ft.name === rr)
        return ft.charset;
    throw TypeError("Charset does not exist: " + rr);
  }
  function er(rr, ft, dr = !1) {
    typeof rr == "string" && (rr = Et.encode(rr));
    const Or = Dt(ft), Zr = Or.length, ni = [];
    let gi = "", vi, Fi = 0, Gi, Pn;
    for (vi = 0; vi < rr.length; vi++)
      for (Fi = 0, Gi = rr[vi], gi += Gi > 0 || (gi.length ^ vi) > 0 ? "" : "1"; Fi in ni || Gi > 0; )
        Pn = ni[Fi], Pn = Pn > 0 ? Pn * 256 + Gi : Gi, Gi = Pn / Zr | 0, ni[Fi] = Pn % Zr, Fi++;
    for (; Fi-- > 0; )
      gi += Or[ni[Fi]];
    return dr && gi.length % 4 > 0 ? gi + "=".repeat(4 - gi.length % 4) : gi;
  }
  function xt(rr, ft) {
    const dr = Dt(ft), Or = dr.length, Zr = [], ni = [];
    rr = rr.replace("=", "");
    let gi, vi = 0, Fi, Gi;
    for (gi = 0; gi < rr.length; gi++) {
      if (vi = 0, Fi = dr.indexOf(rr[gi]), Fi < 0)
        throw new Error(`Character range out of bounds: ${Fi}`);
      for (Fi > 0 || (ni.length ^ gi) > 0 || ni.push(0); vi in Zr || Fi > 0; )
        Gi = Zr[vi], Gi = Gi > 0 ? Gi * Or + Fi : Fi, Fi = Gi >> 8, Zr[vi] = Gi % 256, vi++;
    }
    for (; vi-- > 0; )
      ni.push(Zr[vi]);
    return new Uint8Array(ni);
  }
  function ir(rr) {
    return De(De(rr));
  }
  function sr(rr) {
    const ft = ir(rr);
    return Ne([rr, ft.slice(0, 4)]);
  }
  function yr(rr) {
    const ft = rr.slice(0, -4), dr = rr.slice(-4);
    if (ir(ft).slice(0, 4).toString() !== dr.toString())
      throw new Error("Invalid checksum!");
    return ft;
  }
  const wr = {
    encode: er,
    decode: xt
  }, qr = {
    encode: (rr) => {
      const ft = sr(rr);
      return wr.encode(ft, "base58");
    },
    decode: (rr) => {
      const ft = wr.decode(rr, "base58");
      return yr(ft);
    }
  }, Mr = "qpzry9x8gf2tvdw0s3jn54khce6mua7l", Dr = [996825010, 642813549, 513874426, 1027748829, 705979059], Qr = [
    { version: 0, name: "bech32", const: 1 },
    { version: 1, name: "bech32m", const: 734539939 }
  ];
  function Xr(rr) {
    let ft = 1;
    for (let dr = 0; dr < rr.length; ++dr) {
      const Or = ft >> 25;
      ft = (ft & 33554431) << 5 ^ rr[dr];
      for (let Zr = 0; Zr < 5; ++Zr)
        (Or >> Zr & 1) !== 0 && (ft ^= Dr[Zr]);
    }
    return ft;
  }
  function Vr(rr) {
    const ft = [];
    let dr;
    for (dr = 0; dr < rr.length; ++dr)
      ft.push(rr.charCodeAt(dr) >> 5);
    for (ft.push(0), dr = 0; dr < rr.length; ++dr)
      ft.push(rr.charCodeAt(dr) & 31);
    return ft;
  }
  function Ur(rr, ft, dr) {
    const Or = Vr(rr).concat(ft);
    return Xr(Or) === dr.const;
  }
  function Sr(rr, ft, dr) {
    const Or = Vr(rr).concat(ft).concat([0, 0, 0, 0, 0, 0]), Zr = Xr(Or) ^ dr.const, ni = [];
    for (let gi = 0; gi < 6; ++gi)
      ni.push(Zr >> 5 * (5 - gi) & 31);
    return ni;
  }
  function Gr(rr, ft, dr, Or = !0) {
    const Zr = [];
    let ni = 0, gi = 0;
    const vi = (1 << dr) - 1, Fi = (1 << ft + dr - 1) - 1;
    for (const Gi of rr) {
      if (Gi < 0 || Gi >> ft > 0)
        throw new Error("Failed to perform base conversion. Invalid value: " + String(Gi));
      for (ni = (ni << ft | Gi) & Fi, gi += ft; gi >= dr; )
        gi -= dr, Zr.push(ni >> gi & vi);
    }
    if (Or)
      gi > 0 && Zr.push(ni << dr - gi & vi);
    else if (gi >= ft || (ni << dr - gi & vi) > 0)
      throw new Error("Failed to perform base conversion. Invalid Size!");
    return Zr;
  }
  function Fr(rr, ft, dr) {
    const Or = ft.concat(Sr(rr, ft, dr));
    let Zr = rr + "1";
    for (let ni = 0; ni < Or.length; ++ni)
      Zr += Mr.charAt(Or[ni]);
    return Zr;
  }
  function br(rr) {
    if (!Ar(rr))
      throw new Error("Encoded string goes out of bounds!");
    if (rr = rr.toLowerCase(), !cr(rr))
      throw new Error("Encoded string has invalid separator!");
    const ft = [], dr = rr.lastIndexOf("1"), Or = rr.substring(0, dr);
    for (let ni = dr + 1; ni < rr.length; ++ni) {
      const gi = Mr.indexOf(rr.charAt(ni));
      if (gi === -1)
        throw new Error("Character idx out of bounds: " + String(ni));
      ft.push(gi);
    }
    const Zr = Qr.find((ni) => ni.version === ft[0]) ?? Qr[0];
    if (!Ur(Or, ft, Zr))
      throw new Error("Checksum verification failed!");
    return [Or, ft.slice(0, ft.length - 6)];
  }
  function Ar(rr) {
    let ft, dr, Or = !1, Zr = !1;
    for (ft = 0; ft < rr.length; ++ft) {
      if (dr = rr.charCodeAt(ft), dr < 33 || dr > 126)
        return !1;
      dr >= 97 && dr <= 122 && (Or = !0), dr >= 65 && dr <= 90 && (Zr = !0);
    }
    return !(Or && Zr);
  }
  function cr(rr) {
    const ft = rr.lastIndexOf("1");
    return !(ft < 1 || ft + 7 > rr.length || rr.length > 90);
  }
  function hr(rr, ft = "bc", dr = 0) {
    const Or = [dr, ...Gr([...rr], 8, 5)], Zr = Qr.find((gi) => gi.version === dr) ?? Qr[0], ni = Fr(ft, Or, Zr);
    return Wr(ni), ni;
  }
  function Wr(rr) {
    rr = rr.toLowerCase();
    const ft = rr.split("1", 1)[0], [dr, Or] = br(rr), Zr = Gr(Or.slice(1), 5, 8, !1), ni = Zr.length;
    switch (!0) {
      case ft !== dr:
        throw new Error("Returned hrp string is invalid.");
      case (Zr === null || ni < 2 || ni > 40):
        throw new Error("Decoded string is invalid or out of spec.");
      case Or[0] > 16:
        throw new Error("Returned version bit is out of range.");
      default:
        return Uint8Array.from(Zr);
    }
  }
  function fi(rr) {
    rr = rr.toLowerCase();
    const [ft, dr] = br(rr);
    return dr[0];
  }
  const Bi = {
    encode: hr,
    decode: Wr,
    version: fi
  }, $r = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", oi = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_", zr = new TextEncoder();
  function ti(rr, ft = !1, dr = !0) {
    typeof rr == "string" && (rr = zr.encode(rr));
    const Or = ft ? oi : $r;
    let Zr = "", ni = 0, gi = 0;
    for (let vi = 0; vi < rr.length; vi++)
      for (gi = gi << 8 | rr[vi], ni += 8; ni >= 6; )
        ni -= 6, Zr += Or[gi >> ni & 63];
    if (ni > 0)
      for (gi <<= 6 - ni, Zr += Or[gi & 63]; ni < 6; )
        Zr += dr ? "=" : "", ni += 2;
    return Zr;
  }
  function Lr(rr, ft = !1) {
    const dr = ft || rr.includes("-") || rr.includes("_") ? oi.split("") : $r.split("");
    rr = rr.replace(/=+$/, "");
    const Or = rr.split("");
    let Zr = 0, ni = 0;
    const gi = [];
    for (let vi = 0; vi < Or.length; vi++) {
      const Fi = Or[vi], Gi = dr.indexOf(Fi);
      if (Gi === -1)
        throw new Error("Invalid character: " + Fi);
      Zr += 6, ni <<= 6, ni |= Gi, Zr >= 8 && (Zr -= 8, gi.push(ni >>> Zr & 255));
    }
    return new Uint8Array(gi);
  }
  const Rr = {
    encode: ti,
    decode: Lr
  }, Ir = {
    encode: (rr) => ti(rr, !0, !1),
    decode: (rr) => Lr(rr, !0)
  }, pr = BigInt(0), Cr = BigInt(255), Er = BigInt(256);
  function xr(rr) {
    if (rr <= 0xffn)
      return 1;
    if (rr <= 0xffffn)
      return 2;
    if (rr <= 0xffffffffn)
      return 4;
    if (rr <= 0xffffffffffffffffn)
      return 8;
    if (rr <= 0xffffffffffffffffffffffffffffffffn)
      return 16;
    if (rr <= 0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffn)
      return 32;
    throw new TypeError("Must specify a fixed buffer size for bigints greater than 32 bytes.");
  }
  function si(rr, ft, dr = "be") {
    ft === void 0 && (ft = xr(rr));
    const Or = dr === "le", Zr = new ArrayBuffer(ft), ni = new DataView(Zr);
    let gi = Or ? 0 : ft - 1;
    for (; rr > pr; ) {
      const vi = rr & Cr, Fi = Number(vi);
      Or ? ni.setUint8(gi++, Fi) : ni.setUint8(gi--, Fi), rr = (rr - vi) / Er;
    }
    return new Uint8Array(Zr);
  }
  function Ci(rr) {
    let ft = BigInt(0);
    for (let dr = rr.length - 1; dr >= 0; dr--)
      ft = ft * Er + BigInt(rr[dr]);
    return BigInt(ft);
  }
  function bi(rr) {
    const ft = rr.split("").map(Number);
    if (ft.length % 8 !== 0)
      throw new Error(`Binary array is invalid length: ${rr.length}`);
    const dr = new Uint8Array(ft.length / 8);
    for (let Or = 0, Zr = 0; Or < ft.length; Or += 8, Zr++) {
      let ni = 0;
      for (let gi = 0; gi < 8; gi++)
        ni |= ft[Or + gi] << 7 - gi;
      dr[Zr] = ni;
    }
    return dr;
  }
  function Ri(rr) {
    const ft = new Array(rr.length * 8);
    let dr = 0;
    for (const Or of rr) {
      if (Or > 255)
        throw new Error(`Invalid byte value: ${Or}. Byte values must be between 0 and 255.`);
      for (let Zr = 7; Zr >= 0; Zr--, dr++)
        ft[dr] = Or >> Zr & 1;
    }
    return ft.join("");
  }
  function li(rr) {
    if (rr <= 255)
      return 1;
    if (rr <= 65535)
      return 2;
    if (rr <= 4294967295)
      return 4;
    throw new TypeError("Numbers larger than 4 bytes must specify a fixed size!");
  }
  function zi(rr, ft, dr = "be") {
    ft === void 0 && (ft = li(rr));
    const Or = dr === "le", Zr = new ArrayBuffer(ft), ni = new DataView(Zr);
    let gi = Or ? 0 : ft - 1;
    for (; rr > 0; ) {
      const vi = rr & 255;
      Or ? ni.setUint8(gi++, rr) : ni.setUint8(gi--, rr), rr = (rr - vi) / 256;
    }
    return new Uint8Array(Zr);
  }
  function Kn(rr) {
    let ft = 0;
    for (let dr = rr.length - 1; dr >= 0; dr--)
      ft = ft * 256 + rr[dr], be(ft);
    return ft;
  }
  const Hn = new TextEncoder(), os = new TextDecoder();
  function ts(rr) {
    return Hn.encode(rr);
  }
  function Gs(rr) {
    return os.decode(rr);
  }
  function Wn(rr, ft) {
    Fe(rr);
    const dr = rr.length / 2;
    if (ft === void 0 && (ft = dr), dr > ft)
      throw new TypeError(`Hex string is larger than array size: ${dr} > ${ft}`);
    return ft;
  }
  function Gn(rr, ft, dr = "le") {
    ft = Wn(rr, ft);
    const Or = dr === "le", Zr = new ArrayBuffer(ft), ni = new DataView(Zr);
    let gi = Or ? 0 : ft - 1;
    for (let vi = 0; vi < rr.length; vi += 2) {
      const Fi = rr.substring(vi, vi + 2), Gi = parseInt(Fi, 16);
      Or ? ni.setUint8(gi++, Gi) : ni.setUint8(gi--, Gi);
    }
    return new Uint8Array(Zr);
  }
  function ro(rr) {
    let ft = "";
    for (let dr = 0; dr < rr.length; dr++)
      ft += rr[dr].toString(16).padStart(2, "0");
    return ft;
  }
  function Fs(rr) {
    const ft = JSON.stringify(rr, (dr, Or) => typeof Or == "bigint" ? `${Or}n` : Or);
    return ts(ft);
  }
  function ii(rr, ft, dr) {
    if (rr instanceof ArrayBuffer)
      return new Uint8Array(rr);
    if (rr instanceof Uint8Array)
      return xe(rr, ft, dr);
    if (typeof rr == "string")
      return Gn(rr, ft, dr);
    if (typeof rr == "bigint")
      return si(rr, ft, dr);
    if (typeof rr == "number")
      return zi(rr, ft, dr);
    if (typeof rr == "boolean")
      return Uint8Array.of(rr ? 1 : 0);
    throw TypeError("Unsupported format:" + typeof rr);
  }
  let Ai = (Eo = class extends Uint8Array {
    static random(ft = 32) {
      const dr = ke(ft);
      return new Eo(dr, ft);
    }
    constructor(ft, dr, Or) {
      const Zr = ii(ft, dr, Or);
      super(Zr);
    }
    get arr() {
      return [...this];
    }
    get num() {
      return this.toNum();
    }
    get big() {
      return this.toBig();
    }
    get str() {
      return this.toStr();
    }
    get hex() {
      return this.toHex();
    }
    get raw() {
      return new Uint8Array(this);
    }
    get bin() {
      return this.toBin();
    }
    get b58chk() {
      return this.tob58chk();
    }
    get base64() {
      return this.toBase64();
    }
    get b64url() {
      return this.toB64url();
    }
    get digest() {
      return this.toHash();
    }
    get id() {
      return this.toHash().hex;
    }
    get stream() {
      return new ri(this);
    }
    toNum(ft = "be") {
      const dr = ft === "be" ? this.reverse() : this;
      return Kn(dr);
    }
    toBin() {
      return Ri(this);
    }
    toBig(ft = "be") {
      const dr = ft === "be" ? this.reverse() : this;
      return Ci(dr);
    }
    toHash() {
      const ft = De(this);
      return new Eo(ft);
    }
    toJson() {
      const ft = Gs(this);
      return JSON.parse(ft);
    }
    toBech32(ft, dr = 0) {
      return Bi.encode(this, ft, dr);
    }
    toStr() {
      return Gs(this);
    }
    toHex() {
      return ro(this);
    }
    toBytes() {
      return new Uint8Array(this);
    }
    tob58chk() {
      return qr.encode(this);
    }
    toBase64() {
      return Rr.encode(this);
    }
    toB64url() {
      return Ir.encode(this);
    }
    prepend(ft) {
      return Eo.join([Eo.bytes(ft), this]);
    }
    append(ft) {
      return Eo.join([this, Eo.bytes(ft)]);
    }
    slice(ft, dr) {
      const Or = new Uint8Array(this).slice(ft, dr);
      return new Eo(Or);
    }
    subarray(ft, dr) {
      const Or = new Uint8Array(this).subarray(ft, dr);
      return new Eo(Or);
    }
    reverse() {
      const ft = new Uint8Array(this).reverse();
      return new Eo(ft);
    }
    write(ft, dr) {
      const Or = Eo.bytes(ft);
      this.set(Or, dr);
    }
    prefixSize(ft) {
      const dr = Eo.varInt(this.length, ft);
      return Eo.join([dr, this]);
    }
    static from(ft) {
      return new Eo(Uint8Array.from(ft));
    }
    static of(...ft) {
      return new Eo(Uint8Array.of(...ft));
    }
    static join(ft) {
      const dr = ft.map((Zr) => Eo.bytes(Zr)), Or = Ne(dr);
      return new Eo(Or);
    }
    static varInt(ft, dr) {
      if (ft < 253)
        return Eo.num(ft, 1);
      if (ft < 65536)
        return Eo.of(253, ...Eo.num(ft, 2, dr));
      if (ft < 4294967296)
        return Eo.of(254, ...Eo.num(ft, 4, dr));
      if (BigInt(ft) < 0x10000000000000000n)
        return Eo.of(255, ...Eo.num(ft, 8, dr));
      throw new Error(`Value is too large: ${ft}`);
    }
  }, Eo.num = ci, Eo.big = Ui, Eo.bin = Si, Eo.raw = _i, Eo.str = Tn, Eo.hex = Fn, Eo.bytes = ss, Eo.json = rs, Eo.base64 = is, Eo.b64url = Pr, Eo.bech32 = as, Eo.b58chk = Rs, Eo.encode = ts, Eo.decode = Gs, Eo);
  function ci(rr, ft, dr) {
    return new Ai(rr, ft, dr);
  }
  function Si(rr, ft, dr) {
    return new Ai(bi(rr), ft, dr);
  }
  function Ui(rr, ft, dr) {
    return new Ai(rr, ft, dr);
  }
  function _i(rr, ft, dr) {
    return new Ai(rr, ft, dr);
  }
  function Tn(rr, ft, dr) {
    return new Ai(ts(rr), ft, dr);
  }
  function Fn(rr, ft, dr) {
    return new Ai(rr, ft, dr);
  }
  function ss(rr, ft, dr) {
    return new Ai(rr, ft, dr);
  }
  function rs(rr) {
    return new Ai(Fs(rr));
  }
  function is(rr) {
    return new Ai(Rr.decode(rr));
  }
  function Pr(rr) {
    return new Ai(Ir.decode(rr));
  }
  function as(rr) {
    return new Ai(Bi.decode(rr));
  }
  function Rs(rr) {
    return new Ai(qr.decode(rr));
  }
  let ri = class {
    constructor(ft) {
      this.data = Ai.bytes(ft), this.size = this.data.length;
    }
    peek(ft) {
      if (ft > this.size)
        throw new Error(`Size greater than stream: ${ft} > ${this.size}`);
      return new Ai(this.data.slice(0, ft));
    }
    read(ft) {
      ft = ft ?? this.readSize();
      const dr = this.peek(ft);
      return this.data = this.data.slice(ft), this.size = this.data.length, dr;
    }
    readSize(ft) {
      const dr = this.read(1).num;
      switch (!0) {
        case (dr >= 0 && dr < 253):
          return dr;
        case dr === 253:
          return this.read(2).toNum(ft);
        case dr === 254:
          return this.read(4).toNum(ft);
        case dr === 255:
          return this.read(8).toNum(ft);
        default:
          throw new Error(`Varint is out of range: ${dr}`);
      }
    }
  };
  function Tr(rr, ft) {
    const dr = Ai.bytes(rr);
    if (dr.length !== ft)
      throw new Error(`Invalid input size: ${dr.hex} !== ${ft}`);
  }
  function yi(rr, ft) {
    if (ft)
      throw new Error(rr);
    return !1;
  }
  function ki(rr, ...ft) {
    const dr = Ai.str(rr).digest.raw, Or = ft.map((Zr) => Ai.bytes(Zr));
    return Ai.join([dr, dr, Ai.join(Or)]).digest;
  }
  const qi = {
    OP_0: 0,
    OP_PUSHDATA1: 76,
    OP_PUSHDATA2: 77,
    OP_PUSHDATA4: 78,
    OP_1NEGATE: 79,
    OP_SUCCESS80: 80,
    OP_1: 81,
    OP_2: 82,
    OP_3: 83,
    OP_4: 84,
    OP_5: 85,
    OP_6: 86,
    OP_7: 87,
    OP_8: 88,
    OP_9: 89,
    OP_10: 90,
    OP_11: 91,
    OP_12: 92,
    OP_13: 93,
    OP_14: 94,
    OP_15: 95,
    OP_16: 96,
    OP_NOP: 97,
    OP_SUCCESS98: 98,
    OP_IF: 99,
    OP_NOTIF: 100,
    OP_ELSE: 103,
    OP_ENDIF: 104,
    OP_VERIFY: 105,
    OP_RETURN: 106,
    OP_TOALTSTACK: 107,
    OP_FROMALTSTACK: 108,
    OP_2DROP: 109,
    OP_2DUP: 110,
    OP_3DUP: 111,
    OP_2OVER: 112,
    OP_2ROT: 113,
    OP_2SWAP: 114,
    OP_IFDUP: 115,
    OP_DEPTH: 116,
    OP_DROP: 117,
    OP_DUP: 118,
    OP_NIP: 119,
    OP_OVER: 120,
    OP_PICK: 121,
    OP_ROLL: 122,
    OP_ROT: 123,
    OP_SWAP: 124,
    OP_TUCK: 125,
    OP_SUCCESS126: 126,
    OP_SUCCESS127: 127,
    OP_SUCCESS128: 128,
    OP_SUCCESS129: 129,
    OP_SIZE: 130,
    OP_SUCCESS131: 131,
    OP_SUCCESS132: 132,
    OP_SUCCESS133: 133,
    OP_SUCCESS134: 134,
    OP_EQUAL: 135,
    OP_EQUALVERIFY: 136,
    OP_SUCCESS137: 137,
    OP_SUCCESS138: 138,
    OP_1ADD: 139,
    OP_1SUB: 140,
    OP_SUCCESS141: 141,
    OP_SUCCESS142: 142,
    OP_NEGATE: 143,
    OP_ABS: 144,
    OP_NOT: 145,
    OP_0NOTEQUAL: 146,
    OP_ADD: 147,
    OP_SUB: 148,
    OP_SUCCESS149: 149,
    OP_SUCCESS150: 150,
    OP_SUCCESS151: 151,
    OP_SUCCESS152: 152,
    OP_SUCCESS153: 153,
    OP_BOOLAND: 154,
    OP_BOOLOR: 155,
    OP_NUMEQUAL: 156,
    OP_NUMEQUALVERIFY: 157,
    OP_NUMNOTEQUAL: 158,
    OP_LESSTHAN: 159,
    OP_GREATERTHAN: 160,
    OP_LESSTHANOREQUAL: 161,
    OP_GREATERTHANOREQUAL: 162,
    OP_MIN: 163,
    OP_MAX: 164,
    OP_WITHIN: 165,
    OP_RIPEMD160: 166,
    OP_SHA1: 167,
    OP_SHA256: 168,
    OP_HASH160: 169,
    OP_HASH256: 170,
    OP_CODESEPARATOR: 171,
    OP_CHECKSIG: 172,
    OP_CHECKSIGVERIFY: 173,
    OP_CHECKMULTISIG: 174,
    OP_CHECKMULTISIGVERIFY: 175,
    OP_NOP1: 176,
    OP_CHECKLOCKTIMEVERIFY: 177,
    OP_CHECKSEQUENCEVERIFY: 178,
    OP_NOP4: 179,
    OP_NOP5: 180,
    OP_NOP6: 181,
    OP_NOP7: 182,
    OP_NOP8: 183,
    OP_NOP9: 184,
    OP_NOP10: 185,
    OP_CHECKSIGADD: 186,
    OP_SUCCESS187: 187,
    OP_SUCCESS188: 188,
    OP_SUCCESS189: 189,
    OP_SUCCESS190: 190,
    OP_SUCCESS191: 191,
    OP_SUCCESS192: 192,
    OP_SUCCESS193: 193,
    OP_SUCCESS194: 194,
    OP_SUCCESS195: 195,
    OP_SUCCESS196: 196,
    OP_SUCCESS197: 197,
    OP_SUCCESS198: 198,
    OP_SUCCESS199: 199,
    OP_SUCCESS200: 200,
    OP_SUCCESS201: 201,
    OP_SUCCESS202: 202,
    OP_SUCCESS203: 203,
    OP_SUCCESS204: 204,
    OP_SUCCESS205: 205,
    OP_SUCCESS206: 206,
    OP_SUCCESS207: 207,
    OP_SUCCESS208: 208,
    OP_SUCCESS209: 209,
    OP_SUCCESS210: 210,
    OP_SUCCESS211: 211,
    OP_SUCCESS212: 212,
    OP_SUCCESS213: 213,
    OP_SUCCESS214: 214,
    OP_SUCCESS215: 215,
    OP_SUCCESS216: 216,
    OP_SUCCESS217: 217,
    OP_SUCCESS218: 218,
    OP_SUCCESS219: 219,
    OP_SUCCESS220: 220,
    OP_SUCCESS221: 221,
    OP_SUCCESS222: 222,
    OP_SUCCESS223: 223,
    OP_SUCCESS224: 224,
    OP_SUCCESS225: 225,
    OP_SUCCESS226: 226,
    OP_SUCCESS227: 227,
    OP_SUCCESS228: 228,
    OP_SUCCESS229: 229,
    OP_SUCCESS230: 230,
    OP_SUCCESS231: 231,
    OP_SUCCESS232: 232,
    OP_SUCCESS233: 233,
    OP_SUCCESS234: 234,
    OP_SUCCESS235: 235,
    OP_SUCCESS236: 236,
    OP_SUCCESS237: 237,
    OP_SUCCESS238: 238,
    OP_SUCCESS239: 239,
    OP_SUCCESS240: 240,
    OP_SUCCESS241: 241,
    OP_SUCCESS242: 242,
    OP_SUCCESS243: 243,
    OP_SUCCESS244: 244,
    OP_SUCCESS245: 245,
    OP_SUCCESS246: 246,
    OP_SUCCESS247: 247,
    OP_SUCCESS248: 248,
    OP_SUCCESS249: 249,
    OP_SUCCESS250: 250,
    OP_SUCCESS251: 251,
    OP_SUCCESS252: 252,
    OP_SUCCESS253: 253,
    OP_SUCCESS254: 254
  };
  function C(rr) {
    if (rr > 186 && rr < 255)
      return "OP_SUCCESS" + String(rr);
    for (const [ft, dr] of Object.entries(qi))
      if (dr === rr)
        return ft;
    throw new Error("OPCODE not found:" + String(rr));
  }
  function l(rr) {
    for (const [ft, dr] of Object.entries(qi))
      if (ft === rr)
        return Number(dr);
    throw new Error("OPCODE not found:" + rr);
  }
  function w(rr) {
    switch (!0) {
      case rr === 0:
        return "opcode";
      case (rr >= 1 && rr <= 75):
        return "varint";
      case rr === 76:
        return "pushdata1";
      case rr === 77:
        return "pushdata2";
      case rr === 78:
        return "pushdata4";
      case rr <= 254:
        return "opcode";
      default:
        throw new Error(`Invalid word range: ${rr}`);
    }
  }
  function n(rr) {
    const Or = [];
    switch (!0) {
      case typeof rr != "number":
        return !1;
      case rr === 0:
        return !0;
      case Or.includes(rr):
        return !1;
      case (75 < rr && rr < 254):
        return !0;
      default:
        return !1;
    }
  }
  function a(rr) {
    return typeof rr == "string" && rr.length % 2 === 0 && /[0-9a-fA-F]/.test(rr);
  }
  function b(rr) {
    return a(rr) || rr instanceof Uint8Array;
  }
  const P = 520;
  function K(rr = [], ft = !0) {
    let dr = Ai.num(0);
    return Array.isArray(rr) && (dr = Ai.raw(pe(rr))), a(rr) && (dr = Ai.hex(rr)), rr instanceof Uint8Array && (dr = Ai.raw(rr)), ft && (dr = dr.prefixSize("le")), dr;
  }
  function pe(rr) {
    const ft = [];
    for (const dr of rr)
      ft.push(Ce(dr));
    return ft.length > 0 ? Ai.join(ft) : new Uint8Array();
  }
  function Ce(rr) {
    let ft = new Uint8Array();
    if (typeof rr == "string") {
      if (rr.startsWith("OP_"))
        return Ai.num(l(rr), 1);
      a(rr) ? ft = Ai.hex(rr) : ft = Ai.str(rr);
    } else
      ft = Ai.bytes(rr);
    if (ft.length === 1)
      return ft[0] !== 0 && ft[0] <= 16 ? (ft[0] += 80, ft) : (ft[0] > 128 && ft[0] <= 255 && (ft = new Uint8Array([ft[0], 0])), Ai.join([Me(ft.length), ft]));
    if (ft.length > P) {
      const dr = Tt(ft);
      return pe(dr);
    } else
      return Ai.join([Me(ft.length), ft]);
  }
  function Me(rr) {
    const ft = Ai.num(76, 1), dr = Ai.num(77, 1);
    switch (!0) {
      case rr <= 75:
        return Ai.num(rr);
      case (rr > 75 && rr < 256):
        return Ai.join([ft, Ai.num(rr, 1, "le")]);
      case (rr >= 256 && rr <= P):
        return Ai.join([dr, Ai.num(rr, 2, "le")]);
      default:
        throw new Error("Invalid word size:" + rr.toString());
    }
  }
  function Tt(rr) {
    const ft = [], dr = new ri(rr);
    for (; dr.size > P; )
      ft.push(dr.read(P));
    return ft.push(dr.read(dr.size)), ft;
  }
  function tr(rr, ft = !1) {
    let dr = Ai.bytes(rr);
    if (ft) {
      const Zr = dr.stream.readSize("le");
      if (dr = dr.slice(1), dr.length !== Zr)
        throw new Error(`Varint does not match stream size: ${Zr} !== ${dr.length}`);
    }
    return nr(dr);
  }
  function nr(rr) {
    const ft = new ri(rr), dr = [], Or = ft.size;
    let Zr, ni, gi, vi = 0;
    for (; vi < Or; )
      switch (Zr = ft.read(1).num, ni = w(Zr), vi++, ni) {
        case "varint":
          dr.push(ft.read(Zr).hex), vi += Zr;
          break;
        case "pushdata1":
          gi = ft.read(1).reverse().num, dr.push(ft.read(gi).hex), vi += gi + 1;
          break;
        case "pushdata2":
          gi = ft.read(2).reverse().num, dr.push(ft.read(gi).hex), vi += gi + 2;
          break;
        case "pushdata4":
          gi = ft.read(4).reverse().num, dr.push(ft.read(gi).hex), vi += gi + 4;
          break;
        case "opcode":
          if (!n(Zr))
            throw new Error(`Invalid OPCODE: ${Zr}`);
          dr.push(C(Zr));
          break;
        default:
          throw new Error(`Word type undefined: ${Zr}`);
      }
    return dr;
  }
  function or(rr, ft) {
    if (Array.isArray(rr) && (rr = K(rr, ft)), rr instanceof Uint8Array || a(rr))
      return tr(rr, ft);
    throw new Error("Invalid format: " + typeof rr);
  }
  function lr(rr, ft) {
    if ((rr instanceof Uint8Array || a(rr)) && (rr = tr(rr, ft)), Array.isArray(rr))
      return K(rr, ft);
    throw new Error("Invalid format: " + typeof rr);
  }
  function gr(rr) {
    if (!Array.isArray(rr))
      return Ai.bytes(rr);
    throw new Error("Invalid format: " + typeof rr);
  }
  const Nr = {
    encode: K,
    decode: tr,
    fmt: {
      toAsm: or,
      toBytes: lr,
      toParam: gr
    }
  };
  function jr(rr) {
    if (!Number.isSafeInteger(rr) || rr < 0)
      throw new Error(`Wrong positive integer: ${rr}`);
  }
  function Yr(rr) {
    if (typeof rr != "boolean")
      throw new Error(`Expected boolean, not ${rr}`);
  }
  function ei(rr, ...ft) {
    if (!(rr instanceof Uint8Array))
      throw new TypeError("Expected Uint8Array");
    if (ft.length > 0 && !ft.includes(rr.length))
      throw new TypeError(`Expected Uint8Array of length ${ft}, not of length=${rr.length}`);
  }
  function ai(rr) {
    if (typeof rr != "function" || typeof rr.create != "function")
      throw new Error("Hash should be wrapped by utils.wrapConstructor");
    jr(rr.outputLen), jr(rr.blockLen);
  }
  function ui(rr, ft = !0) {
    if (rr.destroyed)
      throw new Error("Hash instance has been destroyed");
    if (ft && rr.finished)
      throw new Error("Hash#digest() has already been called");
  }
  function di(rr, ft) {
    ei(rr);
    const dr = ft.outputLen;
    if (rr.length < dr)
      throw new Error(`digestInto() expects output buffer of length at least ${dr}`);
  }
  var wi = {
    number: jr,
    bool: Yr,
    bytes: ei,
    hash: ai,
    exists: ui,
    output: di
  };
  const Ei = typeof globalThis == "object" && "crypto" in globalThis ? globalThis.crypto : void 0;
  const Ti = (rr) => new DataView(rr.buffer, rr.byteOffset, rr.byteLength), Di = (rr, ft) => rr << 32 - ft | rr >>> ft;
  if (!(new Uint8Array(new Uint32Array([287454020]).buffer)[0] === 68))
    throw new Error("Non little-endian hardware is not supported");
  Array.from({ length: 256 }, (rr, ft) => ft.toString(16).padStart(2, "0"));
  function Li(rr) {
    if (typeof rr != "string")
      throw new TypeError(`utf8ToBytes expected string, got ${typeof rr}`);
    return new TextEncoder().encode(rr);
  }
  function Ki(rr) {
    if (typeof rr == "string" && (rr = Li(rr)), !(rr instanceof Uint8Array))
      throw new TypeError(`Expected input type is Uint8Array (got ${typeof rr})`);
    return rr;
  }
  function Wi(...rr) {
    if (!rr.every((Or) => Or instanceof Uint8Array))
      throw new Error("Uint8Array list expected");
    if (rr.length === 1)
      return rr[0];
    const ft = rr.reduce((Or, Zr) => Or + Zr.length, 0), dr = new Uint8Array(ft);
    for (let Or = 0, Zr = 0; Or < rr.length; Or++) {
      const ni = rr[Or];
      dr.set(ni, Zr), Zr += ni.length;
    }
    return dr;
  }
  let Xi = class {
    // Safe version that clones internal state
    clone() {
      return this._cloneInto();
    }
  };
  function $i(rr) {
    const ft = (Or) => rr().update(Ki(Or)).digest(), dr = rr();
    return ft.outputLen = dr.outputLen, ft.blockLen = dr.blockLen, ft.create = () => rr(), ft;
  }
  function In(rr = 32) {
    if (Ei && typeof Ei.getRandomValues == "function")
      return Ei.getRandomValues(new Uint8Array(rr));
    throw new Error("crypto.getRandomValues must be defined");
  }
  function kn(rr, ft, dr, Or) {
    if (typeof rr.setBigUint64 == "function")
      return rr.setBigUint64(ft, dr, Or);
    const Zr = BigInt(32), ni = BigInt(4294967295), gi = Number(dr >> Zr & ni), vi = Number(dr & ni), Fi = Or ? 4 : 0, Gi = Or ? 0 : 4;
    rr.setUint32(ft + Fi, gi, Or), rr.setUint32(ft + Gi, vi, Or);
  }
  let Dn = class extends Xi {
    constructor(ft, dr, Or, Zr) {
      super(), this.blockLen = ft, this.outputLen = dr, this.padOffset = Or, this.isLE = Zr, this.finished = !1, this.length = 0, this.pos = 0, this.destroyed = !1, this.buffer = new Uint8Array(ft), this.view = Ti(this.buffer);
    }
    update(ft) {
      wi.exists(this);
      const { view: dr, buffer: Or, blockLen: Zr } = this;
      ft = Ki(ft);
      const ni = ft.length;
      for (let gi = 0; gi < ni; ) {
        const vi = Math.min(Zr - this.pos, ni - gi);
        if (vi === Zr) {
          const Fi = Ti(ft);
          for (; Zr <= ni - gi; gi += Zr)
            this.process(Fi, gi);
          continue;
        }
        Or.set(ft.subarray(gi, gi + vi), this.pos), this.pos += vi, gi += vi, this.pos === Zr && (this.process(dr, 0), this.pos = 0);
      }
      return this.length += ft.length, this.roundClean(), this;
    }
    digestInto(ft) {
      wi.exists(this), wi.output(ft, this), this.finished = !0;
      const { buffer: dr, view: Or, blockLen: Zr, isLE: ni } = this;
      let { pos: gi } = this;
      dr[gi++] = 128, this.buffer.subarray(gi).fill(0), this.padOffset > Zr - gi && (this.process(Or, 0), gi = 0);
      for (let Zi = gi; Zi < Zr; Zi++)
        dr[Zi] = 0;
      kn(Or, Zr - 8, BigInt(this.length * 8), ni), this.process(Or, 0);
      const vi = Ti(ft), Fi = this.outputLen;
      if (Fi % 4)
        throw new Error("_sha2: outputLen should be aligned to 32bit");
      const Gi = Fi / 4, Pn = this.get();
      if (Gi > Pn.length)
        throw new Error("_sha2: outputLen bigger than state");
      for (let Zi = 0; Zi < Gi; Zi++)
        vi.setUint32(4 * Zi, Pn[Zi], ni);
    }
    digest() {
      const { buffer: ft, outputLen: dr } = this;
      this.digestInto(ft);
      const Or = ft.slice(0, dr);
      return this.destroy(), Or;
    }
    _cloneInto(ft) {
      ft || (ft = new this.constructor()), ft.set(...this.get());
      const { blockLen: dr, buffer: Or, length: Zr, finished: ni, destroyed: gi, pos: vi } = this;
      return ft.length = Zr, ft.pos = vi, ft.finished = ni, ft.destroyed = gi, Zr % dr && ft.buffer.set(Or), ft;
    }
  };
  const Mn = (rr, ft, dr) => rr & ft ^ ~rr & dr, zn = (rr, ft, dr) => rr & ft ^ rr & dr ^ ft & dr, es = new Uint32Array([
    1116352408,
    1899447441,
    3049323471,
    3921009573,
    961987163,
    1508970993,
    2453635748,
    2870763221,
    3624381080,
    310598401,
    607225278,
    1426881987,
    1925078388,
    2162078206,
    2614888103,
    3248222580,
    3835390401,
    4022224774,
    264347078,
    604807628,
    770255983,
    1249150122,
    1555081692,
    1996064986,
    2554220882,
    2821834349,
    2952996808,
    3210313671,
    3336571891,
    3584528711,
    113926993,
    338241895,
    666307205,
    773529912,
    1294757372,
    1396182291,
    1695183700,
    1986661051,
    2177026350,
    2456956037,
    2730485921,
    2820302411,
    3259730800,
    3345764771,
    3516065817,
    3600352804,
    4094571909,
    275423344,
    430227734,
    506948616,
    659060556,
    883997877,
    958139571,
    1322822218,
    1537002063,
    1747873779,
    1955562222,
    2024104815,
    2227730452,
    2361852424,
    2428436474,
    2756734187,
    3204031479,
    3329325298
  ]), ns = new Uint32Array([
    1779033703,
    3144134277,
    1013904242,
    2773480762,
    1359893119,
    2600822924,
    528734635,
    1541459225
  ]), fs = new Uint32Array(64);
  let ps = class extends Dn {
    constructor() {
      super(64, 32, 8, !1), this.A = ns[0] | 0, this.B = ns[1] | 0, this.C = ns[2] | 0, this.D = ns[3] | 0, this.E = ns[4] | 0, this.F = ns[5] | 0, this.G = ns[6] | 0, this.H = ns[7] | 0;
    }
    get() {
      const { A: ft, B: dr, C: Or, D: Zr, E: ni, F: gi, G: vi, H: Fi } = this;
      return [ft, dr, Or, Zr, ni, gi, vi, Fi];
    }
    // prettier-ignore
    set(ft, dr, Or, Zr, ni, gi, vi, Fi) {
      this.A = ft | 0, this.B = dr | 0, this.C = Or | 0, this.D = Zr | 0, this.E = ni | 0, this.F = gi | 0, this.G = vi | 0, this.H = Fi | 0;
    }
    process(ft, dr) {
      for (let Zi = 0; Zi < 16; Zi++, dr += 4)
        fs[Zi] = ft.getUint32(dr, !1);
      for (let Zi = 16; Zi < 64; Zi++) {
        const ds = fs[Zi - 15], us = fs[Zi - 2], Is = Di(ds, 7) ^ Di(ds, 18) ^ ds >>> 3, $n = Di(us, 17) ^ Di(us, 19) ^ us >>> 10;
        fs[Zi] = $n + fs[Zi - 7] + Is + fs[Zi - 16] | 0;
      }
      let { A: Or, B: Zr, C: ni, D: gi, E: vi, F: Fi, G: Gi, H: Pn } = this;
      for (let Zi = 0; Zi < 64; Zi++) {
        const ds = Di(vi, 6) ^ Di(vi, 11) ^ Di(vi, 25), us = Pn + ds + Mn(vi, Fi, Gi) + es[Zi] + fs[Zi] | 0, $n = (Di(Or, 2) ^ Di(Or, 13) ^ Di(Or, 22)) + zn(Or, Zr, ni) | 0;
        Pn = Gi, Gi = Fi, Fi = vi, vi = gi + us | 0, gi = ni, ni = Zr, Zr = Or, Or = us + $n | 0;
      }
      Or = Or + this.A | 0, Zr = Zr + this.B | 0, ni = ni + this.C | 0, gi = gi + this.D | 0, vi = vi + this.E | 0, Fi = Fi + this.F | 0, Gi = Gi + this.G | 0, Pn = Pn + this.H | 0, this.set(Or, Zr, ni, gi, vi, Fi, Gi, Pn);
    }
    roundClean() {
      fs.fill(0);
    }
    destroy() {
      this.set(0, 0, 0, 0, 0, 0, 0, 0), this.buffer.fill(0);
    }
  }, Es = class extends ps {
    constructor() {
      super(), this.A = -1056596264, this.B = 914150663, this.C = 812702999, this.D = -150054599, this.E = -4191439, this.F = 1750603025, this.G = 1694076839, this.H = -1090891868, this.outputLen = 28;
    }
  };
  const Ss = $i(() => new ps());
  $i(() => new Es());
  const Ps = BigInt(0), xs = BigInt(1), Bs = BigInt(2), vs = (rr) => rr instanceof Uint8Array, eo = Array.from({ length: 256 }, (rr, ft) => ft.toString(16).padStart(2, "0"));
  function Xs(rr) {
    if (!vs(rr))
      throw new Error("Uint8Array expected");
    let ft = "";
    for (let dr = 0; dr < rr.length; dr++)
      ft += eo[rr[dr]];
    return ft;
  }
  function fo(rr) {
    const ft = rr.toString(16);
    return ft.length & 1 ? `0${ft}` : ft;
  }
  function co(rr) {
    if (typeof rr != "string")
      throw new Error("hex string expected, got " + typeof rr);
    return BigInt(rr === "" ? "0" : `0x${rr}`);
  }
  function ao(rr) {
    if (typeof rr != "string")
      throw new Error("hex string expected, got " + typeof rr);
    if (rr.length % 2)
      throw new Error("hex string is invalid: unpadded " + rr.length);
    const ft = new Uint8Array(rr.length / 2);
    for (let dr = 0; dr < ft.length; dr++) {
      const Or = dr * 2, Zr = rr.slice(Or, Or + 2), ni = Number.parseInt(Zr, 16);
      if (Number.isNaN(ni) || ni < 0)
        throw new Error("invalid byte sequence");
      ft[dr] = ni;
    }
    return ft;
  }
  function no(rr) {
    return co(Xs(rr));
  }
  function bo(rr) {
    if (!vs(rr))
      throw new Error("Uint8Array expected");
    return co(Xs(Uint8Array.from(rr).reverse()));
  }
  const Io = (rr, ft) => ao(rr.toString(16).padStart(ft * 2, "0")), Po = (rr, ft) => Io(rr, ft).reverse(), To = (rr) => ao(fo(rr));
  function mo(rr, ft, dr) {
    let Or;
    if (typeof ft == "string")
      try {
        Or = ao(ft);
      } catch (ni) {
        throw new Error(`${rr} must be valid hex string, got "${ft}". Cause: ${ni}`);
      }
    else if (vs(ft))
      Or = Uint8Array.from(ft);
    else
      throw new Error(`${rr} must be hex string or Uint8Array`);
    const Zr = Or.length;
    if (typeof dr == "number" && Zr !== dr)
      throw new Error(`${rr} expected ${dr} bytes, got ${Zr}`);
    return Or;
  }
  function Yi(...rr) {
    const ft = new Uint8Array(rr.reduce((Or, Zr) => Or + Zr.length, 0));
    let dr = 0;
    return rr.forEach((Or) => {
      if (!vs(Or))
        throw new Error("Uint8Array expected");
      ft.set(Or, dr), dr += Or.length;
    }), ft;
  }
  function En(rr, ft) {
    if (rr.length !== ft.length)
      return !1;
    for (let dr = 0; dr < rr.length; dr++)
      if (rr[dr] !== ft[dr])
        return !1;
    return !0;
  }
  function On(rr) {
    if (typeof rr != "string")
      throw new Error(`utf8ToBytes expected string, got ${typeof rr}`);
    return new TextEncoder().encode(rr);
  }
  function Xn(rr) {
    let ft;
    for (ft = 0; rr > 0n; rr >>= xs, ft += 1)
      ;
    return ft;
  }
  const ls = (rr, ft) => rr >> BigInt(ft) & 1n, Yn = (rr, ft, dr) => rr | (dr ? xs : Ps) << BigInt(ft), cs = (rr) => (Bs << BigInt(rr - 1)) - xs, ks = (rr) => new Uint8Array(rr), ws = (rr) => Uint8Array.from(rr);
  function Ro(rr, ft, dr) {
    if (typeof rr != "number" || rr < 2)
      throw new Error("hashLen must be a number");
    if (typeof ft != "number" || ft < 2)
      throw new Error("qByteLen must be a number");
    if (typeof dr != "function")
      throw new Error("hmacFn must be a function");
    let Or = ks(rr), Zr = ks(rr), ni = 0;
    const gi = () => {
      Or.fill(1), Zr.fill(0), ni = 0;
    }, vi = (...Zi) => dr(Zr, Or, ...Zi), Fi = (Zi = ks()) => {
      Zr = vi(ws([0]), Zi), Or = vi(), Zi.length !== 0 && (Zr = vi(ws([1]), Zi), Or = vi());
    }, Gi = () => {
      if (ni++ >= 1e3)
        throw new Error("drbg: tried 1000 values");
      let Zi = 0;
      const ds = [];
      for (; Zi < ft; ) {
        Or = vi();
        const us = Or.slice();
        ds.push(us), Zi += Or.length;
      }
      return Yi(...ds);
    };
    return (Zi, ds) => {
      gi(), Fi(Zi);
      let us;
      for (; !(us = ds(Gi())); )
        Fi();
      return gi(), us;
    };
  }
  const jo = {
    bigint: (rr) => typeof rr == "bigint",
    function: (rr) => typeof rr == "function",
    boolean: (rr) => typeof rr == "boolean",
    string: (rr) => typeof rr == "string",
    isSafeInteger: (rr) => Number.isSafeInteger(rr),
    array: (rr) => Array.isArray(rr),
    field: (rr, ft) => ft.Fp.isValid(rr),
    hash: (rr) => typeof rr == "function" && Number.isSafeInteger(rr.outputLen)
  };
  function Yo(rr, ft, dr = {}) {
    const Or = (Zr, ni, gi) => {
      const vi = jo[ni];
      if (typeof vi != "function")
        throw new Error(`Invalid validator "${ni}", expected function`);
      const Fi = rr[Zr];
      if (!(gi && Fi === void 0) && !vi(Fi, rr))
        throw new Error(`Invalid param ${String(Zr)}=${Fi} (${typeof Fi}), expected ${ni}`);
    };
    for (const [Zr, ni] of Object.entries(ft))
      Or(Zr, ni, !1);
    for (const [Zr, ni] of Object.entries(dr))
      Or(Zr, ni, !0);
    return rr;
  }
  var Mo = /* @__PURE__ */ Object.freeze({
    __proto__: null,
    bitGet: ls,
    bitLen: Xn,
    bitMask: cs,
    bitSet: Yn,
    bytesToHex: Xs,
    bytesToNumberBE: no,
    bytesToNumberLE: bo,
    concatBytes: Yi,
    createHmacDrbg: Ro,
    ensureBytes: mo,
    equalBytes: En,
    hexToBytes: ao,
    hexToNumber: co,
    numberToBytesBE: Io,
    numberToBytesLE: Po,
    numberToHexUnpadded: fo,
    numberToVarBytesBE: To,
    utf8ToBytes: On,
    validateObject: Yo
  });
  const No = BigInt(0), _s = BigInt(1), Zo = BigInt(2), ru = BigInt(3), Ca = BigInt(4), Oi = BigInt(5), ho = BigInt(8);
  BigInt(9), BigInt(16);
  function $o(rr, ft) {
    const dr = rr % ft;
    return dr >= No ? dr : ft + dr;
  }
  function Oa(rr, ft, dr) {
    if (dr <= No || ft < No)
      throw new Error("Expected power/modulo > 0");
    if (dr === _s)
      return No;
    let Or = _s;
    for (; ft > No; )
      ft & _s && (Or = Or * rr % dr), rr = rr * rr % dr, ft >>= _s;
    return Or;
  }
  function Ko(rr, ft, dr) {
    let Or = rr;
    for (; ft-- > No; )
      Or *= Or, Or %= dr;
    return Or;
  }
  function js(rr, ft) {
    if (rr === No || ft <= No)
      throw new Error(`invert: expected positive integers, got n=${rr} mod=${ft}`);
    let dr = $o(rr, ft), Or = ft, Zr = No, ni = _s;
    for (; dr !== No; ) {
      const vi = Or / dr, Fi = Or % dr, Gi = Zr - ni * vi;
      Or = dr, dr = Fi, Zr = ni, ni = Gi;
    }
    if (Or !== _s)
      throw new Error("invert: does not exist");
    return $o(Zr, ft);
  }
  function gu(rr) {
    const ft = (rr - _s) / Zo;
    let dr, Or, Zr;
    for (dr = rr - _s, Or = 0; dr % Zo === No; dr /= Zo, Or++)
      ;
    for (Zr = Zo; Zr < rr && Oa(Zr, ft, rr) !== rr - _s; Zr++)
      ;
    if (Or === 1) {
      const gi = (rr + _s) / Ca;
      return function(Fi, Gi) {
        const Pn = Fi.pow(Gi, gi);
        if (!Fi.eql(Fi.sqr(Pn), Gi))
          throw new Error("Cannot find square root");
        return Pn;
      };
    }
    const ni = (dr + _s) / Zo;
    return function(vi, Fi) {
      if (vi.pow(Fi, ft) === vi.neg(vi.ONE))
        throw new Error("Cannot find square root");
      let Gi = Or, Pn = vi.pow(vi.mul(vi.ONE, Zr), dr), Zi = vi.pow(Fi, ni), ds = vi.pow(Fi, dr);
      for (; !vi.eql(ds, vi.ONE); ) {
        if (vi.eql(ds, vi.ZERO))
          return vi.ZERO;
        let us = 1;
        for (let $n = vi.sqr(ds); us < Gi && !vi.eql($n, vi.ONE); us++)
          $n = vi.sqr($n);
        const Is = vi.pow(Pn, _s << BigInt(Gi - us - 1));
        Pn = vi.sqr(Is), Zi = vi.mul(Zi, Is), ds = vi.mul(ds, Pn), Gi = us;
      }
      return Zi;
    };
  }
  function iu(rr) {
    if (rr % Ca === ru) {
      const ft = (rr + _s) / Ca;
      return function(Or, Zr) {
        const ni = Or.pow(Zr, ft);
        if (!Or.eql(Or.sqr(ni), Zr))
          throw new Error("Cannot find square root");
        return ni;
      };
    }
    if (rr % ho === Oi) {
      const ft = (rr - Oi) / ho;
      return function(Or, Zr) {
        const ni = Or.mul(Zr, Zo), gi = Or.pow(ni, ft), vi = Or.mul(Zr, gi), Fi = Or.mul(Or.mul(vi, Zo), gi), Gi = Or.mul(vi, Or.sub(Fi, Or.ONE));
        if (!Or.eql(Or.sqr(Gi), Zr))
          throw new Error("Cannot find square root");
        return Gi;
      };
    }
    return gu(rr);
  }
  const _ = [
    "create",
    "isValid",
    "is0",
    "neg",
    "inv",
    "sqrt",
    "sqr",
    "eql",
    "add",
    "sub",
    "mul",
    "pow",
    "div",
    "addN",
    "subN",
    "mulN",
    "sqrN"
  ];
  function Zs(rr) {
    const ft = {
      ORDER: "bigint",
      MASK: "bigint",
      BYTES: "isSafeInteger",
      BITS: "isSafeInteger"
    }, dr = _.reduce((Or, Zr) => (Or[Zr] = "function", Or), ft);
    return Yo(rr, dr);
  }
  function e(rr, ft, dr) {
    if (dr < No)
      throw new Error("Expected power > 0");
    if (dr === No)
      return rr.ONE;
    if (dr === _s)
      return ft;
    let Or = rr.ONE, Zr = ft;
    for (; dr > No; )
      dr & _s && (Or = rr.mul(Or, Zr)), Zr = rr.sqr(Zr), dr >>= _s;
    return Or;
  }
  function me(rr, ft) {
    const dr = new Array(ft.length), Or = ft.reduce((ni, gi, vi) => rr.is0(gi) ? ni : (dr[vi] = ni, rr.mul(ni, gi)), rr.ONE), Zr = rr.inv(Or);
    return ft.reduceRight((ni, gi, vi) => rr.is0(gi) ? ni : (dr[vi] = rr.mul(ni, dr[vi]), rr.mul(ni, gi)), Zr), dr;
  }
  function Ia(rr, ft) {
    const dr = ft !== void 0 ? ft : rr.toString(2).length, Or = Math.ceil(dr / 8);
    return { nBitLength: dr, nByteLength: Or };
  }
  function Ls(rr, ft, dr = !1, Or = {}) {
    if (rr <= No)
      throw new Error(`Expected Fp ORDER > 0, got ${rr}`);
    const { nBitLength: Zr, nByteLength: ni } = Ia(rr, ft);
    if (ni > 2048)
      throw new Error("Field lengths over 2048 bytes are not supported");
    const gi = iu(rr), vi = Object.freeze({
      ORDER: rr,
      BITS: Zr,
      BYTES: ni,
      MASK: cs(Zr),
      ZERO: No,
      ONE: _s,
      create: (Fi) => $o(Fi, rr),
      isValid: (Fi) => {
        if (typeof Fi != "bigint")
          throw new Error(`Invalid field element: expected bigint, got ${typeof Fi}`);
        return No <= Fi && Fi < rr;
      },
      is0: (Fi) => Fi === No,
      isOdd: (Fi) => (Fi & _s) === _s,
      neg: (Fi) => $o(-Fi, rr),
      eql: (Fi, Gi) => Fi === Gi,
      sqr: (Fi) => $o(Fi * Fi, rr),
      add: (Fi, Gi) => $o(Fi + Gi, rr),
      sub: (Fi, Gi) => $o(Fi - Gi, rr),
      mul: (Fi, Gi) => $o(Fi * Gi, rr),
      pow: (Fi, Gi) => e(vi, Fi, Gi),
      div: (Fi, Gi) => $o(Fi * js(Gi, rr), rr),
      // Same as above, but doesn't normalize
      sqrN: (Fi) => Fi * Fi,
      addN: (Fi, Gi) => Fi + Gi,
      subN: (Fi, Gi) => Fi - Gi,
      mulN: (Fi, Gi) => Fi * Gi,
      inv: (Fi) => js(Fi, rr),
      sqrt: Or.sqrt || ((Fi) => gi(vi, Fi)),
      invertBatch: (Fi) => me(vi, Fi),
      // TODO: do we really need constant cmov?
      // We don't have const-time bigints anyway, so probably will be not very useful
      cmov: (Fi, Gi, Pn) => Pn ? Gi : Fi,
      toBytes: (Fi) => dr ? Po(Fi, ni) : Io(Fi, ni),
      fromBytes: (Fi) => {
        if (Fi.length !== ni)
          throw new Error(`Fp.fromBytes: expected ${ni}, got ${Fi.length}`);
        return dr ? bo(Fi) : no(Fi);
      }
    });
    return Object.freeze(vi);
  }
  function gc(rr, ft, dr = !1) {
    rr = mo("privateHash", rr);
    const Or = rr.length, Zr = Ia(ft).nByteLength + 8;
    if (Zr < 24 || Or < Zr || Or > 1024)
      throw new Error(`hashToPrivateScalar: expected ${Zr}-1024 bytes of input, got ${Or}`);
    const ni = dr ? bo(rr) : no(rr);
    return $o(ni, ft - _s) + _s;
  }
  const jn = BigInt(0), Sn = BigInt(1);
  function ma(rr, ft) {
    const dr = (Zr, ni) => {
      const gi = ni.negate();
      return Zr ? gi : ni;
    }, Or = (Zr) => {
      const ni = Math.ceil(ft / Zr) + 1, gi = 2 ** (Zr - 1);
      return { windows: ni, windowSize: gi };
    };
    return {
      constTimeNegate: dr,
      // non-const time multiplication ladder
      unsafeLadder(Zr, ni) {
        let gi = rr.ZERO, vi = Zr;
        for (; ni > jn; )
          ni & Sn && (gi = gi.add(vi)), vi = vi.double(), ni >>= Sn;
        return gi;
      },
      /**
       * Creates a wNAF precomputation window. Used for caching.
       * Default window size is set by `utils.precompute()` and is equal to 8.
       * Number of precomputed points depends on the curve size:
       * 2^(𝑊−1) * (Math.ceil(𝑛 / 𝑊) + 1), where:
       * - 𝑊 is the window size
       * - 𝑛 is the bitlength of the curve order.
       * For a 256-bit curve and window size 8, the number of precomputed points is 128 * 33 = 4224.
       * @returns precomputed point tables flattened to a single array
       */
      precomputeWindow(Zr, ni) {
        const { windows: gi, windowSize: vi } = Or(ni), Fi = [];
        let Gi = Zr, Pn = Gi;
        for (let Zi = 0; Zi < gi; Zi++) {
          Pn = Gi, Fi.push(Pn);
          for (let ds = 1; ds < vi; ds++)
            Pn = Pn.add(Gi), Fi.push(Pn);
          Gi = Pn.double();
        }
        return Fi;
      },
      /**
       * Implements ec multiplication using precomputed tables and w-ary non-adjacent form.
       * @param W window size
       * @param precomputes precomputed tables
       * @param n scalar (we don't check here, but should be less than curve order)
       * @returns real and fake (for const-time) points
       */
      wNAF(Zr, ni, gi) {
        const { windows: vi, windowSize: Fi } = Or(Zr);
        let Gi = rr.ZERO, Pn = rr.BASE;
        const Zi = BigInt(2 ** Zr - 1), ds = 2 ** Zr, us = BigInt(Zr);
        for (let Is = 0; Is < vi; Is++) {
          const $n = Is * Fi;
          let As = Number(gi & Zi);
          gi >>= us, As > Fi && (As -= ds, gi += Sn);
          const ms = $n, Ns = $n + Math.abs(As) - 1, Ts = Is % 2 !== 0, oo = As < 0;
          As === 0 ? Pn = Pn.add(dr(Ts, ni[ms])) : Gi = Gi.add(dr(oo, ni[Ns]));
        }
        return { p: Gi, f: Pn };
      },
      wNAFCached(Zr, ni, gi, vi) {
        const Fi = Zr._WINDOW_SIZE || 1;
        let Gi = ni.get(Zr);
        return Gi || (Gi = this.precomputeWindow(Zr, Fi), Fi !== 1 && ni.set(Zr, vi(Gi))), this.wNAF(Fi, Gi, gi);
      }
    };
  }
  function $d(rr) {
    return Zs(rr.Fp), Yo(rr, {
      n: "bigint",
      h: "bigint",
      Gx: "field",
      Gy: "field"
    }, {
      nBitLength: "isSafeInteger",
      nByteLength: "isSafeInteger"
    }), Object.freeze({
      ...Ia(rr.n, rr.nBitLength),
      ...rr,
      p: rr.Fp.ORDER
    });
  }
  function Fo(rr) {
    const ft = $d(rr);
    Yo(ft, {
      a: "field",
      b: "field"
    }, {
      allowedPrivateKeyLengths: "array",
      wrapPrivateKey: "boolean",
      isTorsionFree: "function",
      clearCofactor: "function",
      allowInfinityPoint: "boolean",
      fromBytes: "function",
      toBytes: "function"
    });
    const { endo: dr, Fp: Or, a: Zr } = ft;
    if (dr) {
      if (!Or.eql(Zr, Or.ZERO))
        throw new Error("Endomorphism can only be defined for Koblitz curves that have a=0");
      if (typeof dr != "object" || typeof dr.beta != "bigint" || typeof dr.splitScalar != "function")
        throw new Error("Expected endomorphism with beta: bigint and splitScalar: function");
    }
    return Object.freeze({ ...ft });
  }
  const { bytesToNumberBE: eh, hexToBytes: Hr } = Mo, pi = {
    // asn.1 DER encoding utils
    Err: class extends Error {
      constructor(ft = "") {
        super(ft);
      }
    },
    _parseInt(rr) {
      const { Err: ft } = pi;
      if (rr.length < 2 || rr[0] !== 2)
        throw new ft("Invalid signature integer tag");
      const dr = rr[1], Or = rr.subarray(2, dr + 2);
      if (!dr || Or.length !== dr)
        throw new ft("Invalid signature integer: wrong length");
      if (Or[0] === 0 && Or[1] <= 127)
        throw new ft("Invalid signature integer: trailing length");
      return { d: eh(Or), l: rr.subarray(dr + 2) };
    },
    toSig(rr) {
      const { Err: ft } = pi, dr = typeof rr == "string" ? Hr(rr) : rr;
      if (!(dr instanceof Uint8Array))
        throw new Error("ui8a expected");
      let Or = dr.length;
      if (Or < 2 || dr[0] != 48)
        throw new ft("Invalid signature tag");
      if (dr[1] !== Or - 2)
        throw new ft("Invalid signature: incorrect length");
      const { d: Zr, l: ni } = pi._parseInt(dr.subarray(2)), { d: gi, l: vi } = pi._parseInt(ni);
      if (vi.length)
        throw new ft("Invalid signature: left bytes after parsing");
      return { r: Zr, s: gi };
    },
    hexFromSig(rr) {
      const ft = (Gi) => Number.parseInt(Gi[0], 16) >= 8 ? "00" + Gi : Gi, dr = (Gi) => {
        const Pn = Gi.toString(16);
        return Pn.length & 1 ? `0${Pn}` : Pn;
      }, Or = ft(dr(rr.s)), Zr = ft(dr(rr.r)), ni = Or.length / 2, gi = Zr.length / 2, vi = dr(ni), Fi = dr(gi);
      return `30${dr(gi + ni + 4)}02${Fi}${Zr}02${vi}${Or}`;
    }
  }, Mi = BigInt(0), ji = BigInt(1), xn = BigInt(2), Nn = BigInt(3), Jn = BigInt(4);
  function gs(rr) {
    const ft = Fo(rr), { Fp: dr } = ft, Or = ft.toBytes || ((Is, $n, As) => {
      const ms = $n.toAffine();
      return Yi(Uint8Array.from([4]), dr.toBytes(ms.x), dr.toBytes(ms.y));
    }), Zr = ft.fromBytes || ((Is) => {
      const $n = Is.subarray(1), As = dr.fromBytes($n.subarray(0, dr.BYTES)), ms = dr.fromBytes($n.subarray(dr.BYTES, 2 * dr.BYTES));
      return { x: As, y: ms };
    });
    function ni(Is) {
      const { a: $n, b: As } = ft, ms = dr.sqr(Is), Ns = dr.mul(ms, Is);
      return dr.add(dr.add(Ns, dr.mul(Is, $n)), As);
    }
    function gi(Is) {
      return typeof Is == "bigint" && Mi < Is && Is < ft.n;
    }
    function vi(Is) {
      if (!gi(Is))
        throw new Error("Expected valid bigint: 0 < bigint < curve.n");
    }
    function Fi(Is) {
      const { allowedPrivateKeyLengths: $n, nByteLength: As, wrapPrivateKey: ms, n: Ns } = ft;
      if ($n && typeof Is != "bigint") {
        if (Is instanceof Uint8Array && (Is = Xs(Is)), typeof Is != "string" || !$n.includes(Is.length))
          throw new Error("Invalid key");
        Is = Is.padStart(As * 2, "0");
      }
      let Ts;
      try {
        Ts = typeof Is == "bigint" ? Is : no(mo("private key", Is, As));
      } catch {
        throw new Error(`private key must be ${As} bytes, hex or bigint, not ${typeof Is}`);
      }
      return ms && (Ts = $o(Ts, Ns)), vi(Ts), Ts;
    }
    const Gi = /* @__PURE__ */ new Map();
    function Pn(Is) {
      if (!(Is instanceof Zi))
        throw new Error("ProjectivePoint expected");
    }
    class Zi {
      constructor($n, As, ms) {
        if (this.px = $n, this.py = As, this.pz = ms, $n == null || !dr.isValid($n))
          throw new Error("x required");
        if (As == null || !dr.isValid(As))
          throw new Error("y required");
        if (ms == null || !dr.isValid(ms))
          throw new Error("z required");
      }
      // Does not validate if the point is on-curve.
      // Use fromHex instead, or call assertValidity() later.
      static fromAffine($n) {
        const { x: As, y: ms } = $n || {};
        if (!$n || !dr.isValid(As) || !dr.isValid(ms))
          throw new Error("invalid affine point");
        if ($n instanceof Zi)
          throw new Error("projective point not allowed");
        const Ns = (Ts) => dr.eql(Ts, dr.ZERO);
        return Ns(As) && Ns(ms) ? Zi.ZERO : new Zi(As, ms, dr.ONE);
      }
      get x() {
        return this.toAffine().x;
      }
      get y() {
        return this.toAffine().y;
      }
      /**
       * Takes a bunch of Projective Points but executes only one
       * inversion on all of them. Inversion is very slow operation,
       * so this improves performance massively.
       * Optimization: converts a list of projective points to a list of identical points with Z=1.
       */
      static normalizeZ($n) {
        const As = dr.invertBatch($n.map((ms) => ms.pz));
        return $n.map((ms, Ns) => ms.toAffine(As[Ns])).map(Zi.fromAffine);
      }
      /**
       * Converts hash string or Uint8Array to Point.
       * @param hex short/long ECDSA hex
       */
      static fromHex($n) {
        const As = Zi.fromAffine(Zr(mo("pointHex", $n)));
        return As.assertValidity(), As;
      }
      // Multiplies generator point by privateKey.
      static fromPrivateKey($n) {
        return Zi.BASE.multiply(Fi($n));
      }
      // "Private method", don't use it directly
      _setWindowSize($n) {
        this._WINDOW_SIZE = $n, Gi.delete(this);
      }
      // A point on curve is valid if it conforms to equation.
      assertValidity() {
        if (this.is0()) {
          if (ft.allowInfinityPoint)
            return;
          throw new Error("bad point: ZERO");
        }
        const { x: $n, y: As } = this.toAffine();
        if (!dr.isValid($n) || !dr.isValid(As))
          throw new Error("bad point: x or y not FE");
        const ms = dr.sqr(As), Ns = ni($n);
        if (!dr.eql(ms, Ns))
          throw new Error("bad point: equation left != right");
        if (!this.isTorsionFree())
          throw new Error("bad point: not in prime-order subgroup");
      }
      hasEvenY() {
        const { y: $n } = this.toAffine();
        if (dr.isOdd)
          return !dr.isOdd($n);
        throw new Error("Field doesn't support isOdd");
      }
      /**
       * Compare one point to another.
       */
      equals($n) {
        Pn($n);
        const { px: As, py: ms, pz: Ns } = this, { px: Ts, py: oo, pz: Ws } = $n, Ks = dr.eql(dr.mul(As, Ws), dr.mul(Ts, Ns)), Js = dr.eql(dr.mul(ms, Ws), dr.mul(oo, Ns));
        return Ks && Js;
      }
      /**
       * Flips point to one corresponding to (x, -y) in Affine coordinates.
       */
      negate() {
        return new Zi(this.px, dr.neg(this.py), this.pz);
      }
      // Renes-Costello-Batina exception-free doubling formula.
      // There is 30% faster Jacobian formula, but it is not complete.
      // https://eprint.iacr.org/2015/1060, algorithm 3
      // Cost: 8M + 3S + 3*a + 2*b3 + 15add.
      double() {
        const { a: $n, b: As } = ft, ms = dr.mul(As, Nn), { px: Ns, py: Ts, pz: oo } = this;
        let Ws = dr.ZERO, Ks = dr.ZERO, Js = dr.ZERO, io = dr.mul(Ns, Ns), na = dr.mul(Ts, Ts), Xo = dr.mul(oo, oo), Go = dr.mul(Ns, Ts);
        return Go = dr.add(Go, Go), Js = dr.mul(Ns, oo), Js = dr.add(Js, Js), Ws = dr.mul($n, Js), Ks = dr.mul(ms, Xo), Ks = dr.add(Ws, Ks), Ws = dr.sub(na, Ks), Ks = dr.add(na, Ks), Ks = dr.mul(Ws, Ks), Ws = dr.mul(Go, Ws), Js = dr.mul(ms, Js), Xo = dr.mul($n, Xo), Go = dr.sub(io, Xo), Go = dr.mul($n, Go), Go = dr.add(Go, Js), Js = dr.add(io, io), io = dr.add(Js, io), io = dr.add(io, Xo), io = dr.mul(io, Go), Ks = dr.add(Ks, io), Xo = dr.mul(Ts, oo), Xo = dr.add(Xo, Xo), io = dr.mul(Xo, Go), Ws = dr.sub(Ws, io), Js = dr.mul(Xo, na), Js = dr.add(Js, Js), Js = dr.add(Js, Js), new Zi(Ws, Ks, Js);
      }
      // Renes-Costello-Batina exception-free addition formula.
      // There is 30% faster Jacobian formula, but it is not complete.
      // https://eprint.iacr.org/2015/1060, algorithm 1
      // Cost: 12M + 0S + 3*a + 3*b3 + 23add.
      add($n) {
        Pn($n);
        const { px: As, py: ms, pz: Ns } = this, { px: Ts, py: oo, pz: Ws } = $n;
        let Ks = dr.ZERO, Js = dr.ZERO, io = dr.ZERO;
        const na = ft.a, Xo = dr.mul(ft.b, Nn);
        let Go = dr.mul(As, Ts), Ta = dr.mul(ms, oo), Pa = dr.mul(Ns, Ws), Mu = dr.add(As, ms), qs = dr.add(Ts, oo);
        Mu = dr.mul(Mu, qs), qs = dr.add(Go, Ta), Mu = dr.sub(Mu, qs), qs = dr.add(As, Ns);
        let zs = dr.add(Ts, Ws);
        return qs = dr.mul(qs, zs), zs = dr.add(Go, Pa), qs = dr.sub(qs, zs), zs = dr.add(ms, Ns), Ks = dr.add(oo, Ws), zs = dr.mul(zs, Ks), Ks = dr.add(Ta, Pa), zs = dr.sub(zs, Ks), io = dr.mul(na, qs), Ks = dr.mul(Xo, Pa), io = dr.add(Ks, io), Ks = dr.sub(Ta, io), io = dr.add(Ta, io), Js = dr.mul(Ks, io), Ta = dr.add(Go, Go), Ta = dr.add(Ta, Go), Pa = dr.mul(na, Pa), qs = dr.mul(Xo, qs), Ta = dr.add(Ta, Pa), Pa = dr.sub(Go, Pa), Pa = dr.mul(na, Pa), qs = dr.add(qs, Pa), Go = dr.mul(Ta, qs), Js = dr.add(Js, Go), Go = dr.mul(zs, qs), Ks = dr.mul(Mu, Ks), Ks = dr.sub(Ks, Go), Go = dr.mul(Mu, Ta), io = dr.mul(zs, io), io = dr.add(io, Go), new Zi(Ks, Js, io);
      }
      subtract($n) {
        return this.add($n.negate());
      }
      is0() {
        return this.equals(Zi.ZERO);
      }
      wNAF($n) {
        return us.wNAFCached(this, Gi, $n, (As) => {
          const ms = dr.invertBatch(As.map((Ns) => Ns.pz));
          return As.map((Ns, Ts) => Ns.toAffine(ms[Ts])).map(Zi.fromAffine);
        });
      }
      /**
       * Non-constant-time multiplication. Uses double-and-add algorithm.
       * It's faster, but should only be used when you don't care about
       * an exposed private key e.g. sig verification, which works over *public* keys.
       */
      multiplyUnsafe($n) {
        const As = Zi.ZERO;
        if ($n === Mi)
          return As;
        if (vi($n), $n === ji)
          return this;
        const { endo: ms } = ft;
        if (!ms)
          return us.unsafeLadder(this, $n);
        let { k1neg: Ns, k1: Ts, k2neg: oo, k2: Ws } = ms.splitScalar($n), Ks = As, Js = As, io = this;
        for (; Ts > Mi || Ws > Mi; )
          Ts & ji && (Ks = Ks.add(io)), Ws & ji && (Js = Js.add(io)), io = io.double(), Ts >>= ji, Ws >>= ji;
        return Ns && (Ks = Ks.negate()), oo && (Js = Js.negate()), Js = new Zi(dr.mul(Js.px, ms.beta), Js.py, Js.pz), Ks.add(Js);
      }
      /**
       * Constant time multiplication.
       * Uses wNAF method. Windowed method may be 10% faster,
       * but takes 2x longer to generate and consumes 2x memory.
       * Uses precomputes when available.
       * Uses endomorphism for Koblitz curves.
       * @param scalar by which the point would be multiplied
       * @returns New point
       */
      multiply($n) {
        vi($n);
        let As = $n, ms, Ns;
        const { endo: Ts } = ft;
        if (Ts) {
          const { k1neg: oo, k1: Ws, k2neg: Ks, k2: Js } = Ts.splitScalar(As);
          let { p: io, f: na } = this.wNAF(Ws), { p: Xo, f: Go } = this.wNAF(Js);
          io = us.constTimeNegate(oo, io), Xo = us.constTimeNegate(Ks, Xo), Xo = new Zi(dr.mul(Xo.px, Ts.beta), Xo.py, Xo.pz), ms = io.add(Xo), Ns = na.add(Go);
        } else {
          const { p: oo, f: Ws } = this.wNAF(As);
          ms = oo, Ns = Ws;
        }
        return Zi.normalizeZ([ms, Ns])[0];
      }
      /**
       * Efficiently calculate `aP + bQ`. Unsafe, can expose private key, if used incorrectly.
       * Not using Strauss-Shamir trick: precomputation tables are faster.
       * The trick could be useful if both P and Q are not G (not in our case).
       * @returns non-zero affine point
       */
      multiplyAndAddUnsafe($n, As, ms) {
        const Ns = Zi.BASE, Ts = (Ws, Ks) => Ks === Mi || Ks === ji || !Ws.equals(Ns) ? Ws.multiplyUnsafe(Ks) : Ws.multiply(Ks), oo = Ts(this, As).add(Ts($n, ms));
        return oo.is0() ? void 0 : oo;
      }
      // Converts Projective point to affine (x, y) coordinates.
      // Can accept precomputed Z^-1 - for example, from invertBatch.
      // (x, y, z) ∋ (x=x/z, y=y/z)
      toAffine($n) {
        const { px: As, py: ms, pz: Ns } = this, Ts = this.is0();
        $n == null && ($n = Ts ? dr.ONE : dr.inv(Ns));
        const oo = dr.mul(As, $n), Ws = dr.mul(ms, $n), Ks = dr.mul(Ns, $n);
        if (Ts)
          return { x: dr.ZERO, y: dr.ZERO };
        if (!dr.eql(Ks, dr.ONE))
          throw new Error("invZ was invalid");
        return { x: oo, y: Ws };
      }
      isTorsionFree() {
        const { h: $n, isTorsionFree: As } = ft;
        if ($n === ji)
          return !0;
        if (As)
          return As(Zi, this);
        throw new Error("isTorsionFree() has not been declared for the elliptic curve");
      }
      clearCofactor() {
        const { h: $n, clearCofactor: As } = ft;
        return $n === ji ? this : As ? As(Zi, this) : this.multiplyUnsafe(ft.h);
      }
      toRawBytes($n = !0) {
        return this.assertValidity(), Or(Zi, this, $n);
      }
      toHex($n = !0) {
        return Xs(this.toRawBytes($n));
      }
    }
    Zi.BASE = new Zi(ft.Gx, ft.Gy, dr.ONE), Zi.ZERO = new Zi(dr.ZERO, dr.ONE, dr.ZERO);
    const ds = ft.nBitLength, us = ma(Zi, ft.endo ? Math.ceil(ds / 2) : ds);
    return {
      CURVE: ft,
      ProjectivePoint: Zi,
      normPrivateKeyToScalar: Fi,
      weierstrassEquation: ni,
      isWithinCurveOrder: gi
    };
  }
  function Os(rr) {
    const ft = $d(rr);
    return Yo(ft, {
      hash: "hash",
      hmac: "function",
      randomBytes: "function"
    }, {
      bits2int: "function",
      bits2int_modN: "function",
      lowS: "boolean"
    }), Object.freeze({ lowS: !0, ...ft });
  }
  function Vs(rr) {
    const ft = Os(rr), { Fp: dr, n: Or } = ft, Zr = dr.BYTES + 1, ni = 2 * dr.BYTES + 1;
    function gi(qs) {
      return Mi < qs && qs < dr.ORDER;
    }
    function vi(qs) {
      return $o(qs, Or);
    }
    function Fi(qs) {
      return js(qs, Or);
    }
    const { ProjectivePoint: Gi, normPrivateKeyToScalar: Pn, weierstrassEquation: Zi, isWithinCurveOrder: ds } = gs({
      ...ft,
      toBytes(qs, zs, Oo) {
        const sa = zs.toAffine(), ta = dr.toBytes(sa.x), ja = Yi;
        return Oo ? ja(Uint8Array.from([zs.hasEvenY() ? 2 : 3]), ta) : ja(Uint8Array.from([4]), ta, dr.toBytes(sa.y));
      },
      fromBytes(qs) {
        const zs = qs.length, Oo = qs[0], sa = qs.subarray(1);
        if (zs === Zr && (Oo === 2 || Oo === 3)) {
          const ta = no(sa);
          if (!gi(ta))
            throw new Error("Point is not on curve");
          const ja = Zi(ta);
          let Au = dr.sqrt(ja);
          const su = (Au & ji) === ji;
          return (Oo & 1) === 1 !== su && (Au = dr.neg(Au)), { x: ta, y: Au };
        } else if (zs === ni && Oo === 4) {
          const ta = dr.fromBytes(sa.subarray(0, dr.BYTES)), ja = dr.fromBytes(sa.subarray(dr.BYTES, 2 * dr.BYTES));
          return { x: ta, y: ja };
        } else
          throw new Error(`Point of length ${zs} was invalid. Expected ${Zr} compressed bytes or ${ni} uncompressed bytes`);
      }
    }), us = (qs) => Xs(Io(qs, ft.nByteLength));
    function Is(qs) {
      const zs = Or >> ji;
      return qs > zs;
    }
    function $n(qs) {
      return Is(qs) ? vi(-qs) : qs;
    }
    const As = (qs, zs, Oo) => no(qs.slice(zs, Oo));
    class ms {
      constructor(zs, Oo, sa) {
        this.r = zs, this.s = Oo, this.recovery = sa, this.assertValidity();
      }
      // pair (bytes of r, bytes of s)
      static fromCompact(zs) {
        const Oo = ft.nByteLength;
        return zs = mo("compactSignature", zs, Oo * 2), new ms(As(zs, 0, Oo), As(zs, Oo, 2 * Oo));
      }
      // DER encoded ECDSA signature
      // https://bitcoin.stackexchange.com/questions/57644/what-are-the-parts-of-a-bitcoin-transaction-input-script
      static fromDER(zs) {
        const { r: Oo, s: sa } = pi.toSig(mo("DER", zs));
        return new ms(Oo, sa);
      }
      assertValidity() {
        if (!ds(this.r))
          throw new Error("r must be 0 < r < CURVE.n");
        if (!ds(this.s))
          throw new Error("s must be 0 < s < CURVE.n");
      }
      addRecoveryBit(zs) {
        return new ms(this.r, this.s, zs);
      }
      recoverPublicKey(zs) {
        const { r: Oo, s: sa, recovery: ta } = this, ja = Js(mo("msgHash", zs));
        if (ta == null || ![0, 1, 2, 3].includes(ta))
          throw new Error("recovery id invalid");
        const Au = ta === 2 || ta === 3 ? Oo + ft.n : Oo;
        if (Au >= dr.ORDER)
          throw new Error("recovery id 2 or 3 invalid");
        const su = (ta & 1) === 0 ? "02" : "03", If = Gi.fromHex(su + us(Au)), mf = Fi(Au), sc = vi(-ja * mf), Zu = vi(sa * mf), Wa = Gi.BASE.multiplyAndAddUnsafe(If, sc, Zu);
        if (!Wa)
          throw new Error("point at infinify");
        return Wa.assertValidity(), Wa;
      }
      // Signatures should be low-s, to prevent malleability.
      hasHighS() {
        return Is(this.s);
      }
      normalizeS() {
        return this.hasHighS() ? new ms(this.r, vi(-this.s), this.recovery) : this;
      }
      // DER-encoded
      toDERRawBytes() {
        return ao(this.toDERHex());
      }
      toDERHex() {
        return pi.hexFromSig({ r: this.r, s: this.s });
      }
      // padded bytes of r, then padded bytes of s
      toCompactRawBytes() {
        return ao(this.toCompactHex());
      }
      toCompactHex() {
        return us(this.r) + us(this.s);
      }
    }
    const Ns = {
      isValidPrivateKey(qs) {
        try {
          return Pn(qs), !0;
        } catch {
          return !1;
        }
      },
      normPrivateKeyToScalar: Pn,
      /**
       * Produces cryptographically secure private key from random of size (nBitLength+64)
       * as per FIPS 186 B.4.1 with modulo bias being neglible.
       */
      randomPrivateKey: () => {
        const qs = ft.randomBytes(dr.BYTES + 8), zs = gc(qs, Or);
        return Io(zs, ft.nByteLength);
      },
      /**
       * Creates precompute table for an arbitrary EC point. Makes point "cached".
       * Allows to massively speed-up `point.multiply(scalar)`.
       * @returns cached point
       * @example
       * const fast = utils.precompute(8, ProjectivePoint.fromHex(someonesPubKey));
       * fast.multiply(privKey); // much faster ECDH now
       */
      precompute(qs = 8, zs = Gi.BASE) {
        return zs._setWindowSize(qs), zs.multiply(BigInt(3)), zs;
      }
    };
    function Ts(qs, zs = !0) {
      return Gi.fromPrivateKey(qs).toRawBytes(zs);
    }
    function oo(qs) {
      const zs = qs instanceof Uint8Array, Oo = typeof qs == "string", sa = (zs || Oo) && qs.length;
      return zs ? sa === Zr || sa === ni : Oo ? sa === 2 * Zr || sa === 2 * ni : qs instanceof Gi;
    }
    function Ws(qs, zs, Oo = !0) {
      if (oo(qs))
        throw new Error("first arg must be private key");
      if (!oo(zs))
        throw new Error("second arg must be public key");
      return Gi.fromHex(zs).multiply(Pn(qs)).toRawBytes(Oo);
    }
    const Ks = ft.bits2int || function(qs) {
      const zs = no(qs), Oo = qs.length * 8 - ft.nBitLength;
      return Oo > 0 ? zs >> BigInt(Oo) : zs;
    }, Js = ft.bits2int_modN || function(qs) {
      return vi(Ks(qs));
    }, io = cs(ft.nBitLength);
    function na(qs) {
      if (typeof qs != "bigint")
        throw new Error("bigint expected");
      if (!(Mi <= qs && qs < io))
        throw new Error(`bigint expected < 2^${ft.nBitLength}`);
      return Io(qs, ft.nByteLength);
    }
    function Xo(qs, zs, Oo = Go) {
      if (["recovered", "canonical"].some((wf) => wf in Oo))
        throw new Error("sign() legacy options not supported");
      const { hash: sa, randomBytes: ta } = ft;
      let { lowS: ja, prehash: Au, extraEntropy: su } = Oo;
      ja == null && (ja = !0), qs = mo("msgHash", qs), Au && (qs = mo("prehashed msgHash", sa(qs)));
      const If = Js(qs), mf = Pn(zs), sc = [na(mf), na(If)];
      if (su != null) {
        const wf = su === !0 ? ta(dr.BYTES) : su;
        sc.push(mo("extraEntropy", wf, dr.BYTES));
      }
      const Zu = Yi(...sc), Wa = If;
      function _d(wf) {
        const Ef = Ks(wf);
        if (!ds(Ef))
          return;
        const P1 = Fi(Ef), oc = Gi.BASE.multiply(Ef).toAffine(), qa = vi(oc.x);
        if (qa === Mi)
          return;
        const ac = vi(P1 * vi(Wa + qa * mf));
        if (ac === Mi)
          return;
        let Of = (oc.x === qa ? 0 : 2) | Number(oc.y & ji), Zd = ac;
        return ja && Is(ac) && (Zd = $n(ac), Of ^= 1), new ms(qa, Zd, Of);
      }
      return { seed: Zu, k2sig: _d };
    }
    const Go = { lowS: ft.lowS, prehash: !1 }, Ta = { lowS: ft.lowS, prehash: !1 };
    function Pa(qs, zs, Oo = Go) {
      const { seed: sa, k2sig: ta } = Xo(qs, zs, Oo);
      return Ro(ft.hash.outputLen, ft.nByteLength, ft.hmac)(sa, ta);
    }
    Gi.BASE._setWindowSize(8);
    function Mu(qs, zs, Oo, sa = Ta) {
      var oc;
      const ta = qs;
      if (zs = mo("msgHash", zs), Oo = mo("publicKey", Oo), "strict" in sa)
        throw new Error("options.strict was renamed to lowS");
      const { lowS: ja, prehash: Au } = sa;
      let su, If;
      try {
        if (typeof ta == "string" || ta instanceof Uint8Array)
          try {
            su = ms.fromDER(ta);
          } catch (qa) {
            if (!(qa instanceof pi.Err))
              throw qa;
            su = ms.fromCompact(ta);
          }
        else if (typeof ta == "object" && typeof ta.r == "bigint" && typeof ta.s == "bigint") {
          const { r: qa, s: ac } = ta;
          su = new ms(qa, ac);
        } else
          throw new Error("PARSE");
        If = Gi.fromHex(Oo);
      } catch (qa) {
        if (qa.message === "PARSE")
          throw new Error("signature must be Signature instance, Uint8Array or hex string");
        return !1;
      }
      if (ja && su.hasHighS())
        return !1;
      Au && (zs = ft.hash(zs));
      const { r: mf, s: sc } = su, Zu = Js(zs), Wa = Fi(sc), _d = vi(Zu * Wa), wf = vi(mf * Wa), Ef = (oc = Gi.BASE.multiplyAndAddUnsafe(If, _d, wf)) == null ? void 0 : oc.toAffine();
      return Ef ? vi(Ef.x) === mf : !1;
    }
    return {
      CURVE: ft,
      getPublicKey: Ts,
      getSharedSecret: Ws,
      sign: Pa,
      verify: Mu,
      ProjectivePoint: Gi,
      Signature: ms,
      utils: Ns
    };
  }
  function qo(rr, ft) {
    const dr = rr.ORDER;
    let Or = Mi;
    for (let ds = dr - ji; ds % xn === Mi; ds /= xn)
      Or += ji;
    const Zr = Or, ni = (dr - ji) / xn ** Zr, gi = (ni - ji) / xn, vi = xn ** Zr - ji, Fi = xn ** (Zr - ji), Gi = rr.pow(ft, ni), Pn = rr.pow(ft, (ni + ji) / xn);
    let Zi = (ds, us) => {
      let Is = Gi, $n = rr.pow(us, vi), As = rr.sqr($n);
      As = rr.mul(As, us);
      let ms = rr.mul(ds, As);
      ms = rr.pow(ms, gi), ms = rr.mul(ms, $n), $n = rr.mul(ms, us), As = rr.mul(ms, ds);
      let Ns = rr.mul(As, $n);
      ms = rr.pow(Ns, Fi);
      let Ts = rr.eql(ms, rr.ONE);
      $n = rr.mul(As, Pn), ms = rr.mul(Ns, Is), As = rr.cmov($n, As, Ts), Ns = rr.cmov(ms, Ns, Ts);
      for (let oo = Zr; oo > 1; oo--) {
        let Ws = xn ** (oo - xn), Ks = rr.pow(Ns, Ws);
        const Js = rr.eql(Ks, rr.ONE);
        $n = rr.mul(As, Is), Is = rr.mul(Is, Is), Ks = rr.mul(Ns, Is), As = rr.cmov($n, As, Js), Ns = rr.cmov(Ks, Ns, Js);
      }
      return { isValid: Ts, value: As };
    };
    if (rr.ORDER % Jn === Nn) {
      const ds = (rr.ORDER - Nn) / Jn, us = rr.sqrt(rr.neg(ft));
      Zi = (Is, $n) => {
        let As = rr.sqr($n);
        const ms = rr.mul(Is, $n);
        As = rr.mul(As, ms);
        let Ns = rr.pow(As, ds);
        Ns = rr.mul(Ns, ms);
        const Ts = rr.mul(Ns, us), oo = rr.mul(rr.sqr(Ns), $n), Ws = rr.eql(oo, Is);
        let Ks = rr.cmov(Ts, Ns, Ws);
        return { isValid: Ws, value: Ks };
      };
    }
    return Zi;
  }
  function wa(rr, ft) {
    if (Zs(rr), !rr.isValid(ft.A) || !rr.isValid(ft.B) || !rr.isValid(ft.Z))
      throw new Error("mapToCurveSimpleSWU: invalid opts");
    const dr = qo(rr, ft.Z);
    if (!rr.isOdd)
      throw new Error("Fp.isOdd is not implemented!");
    return (Or) => {
      let Zr, ni, gi, vi, Fi, Gi, Pn, Zi;
      Zr = rr.sqr(Or), Zr = rr.mul(Zr, ft.Z), ni = rr.sqr(Zr), ni = rr.add(ni, Zr), gi = rr.add(ni, rr.ONE), gi = rr.mul(gi, ft.B), vi = rr.cmov(ft.Z, rr.neg(ni), !rr.eql(ni, rr.ZERO)), vi = rr.mul(vi, ft.A), ni = rr.sqr(gi), Gi = rr.sqr(vi), Fi = rr.mul(Gi, ft.A), ni = rr.add(ni, Fi), ni = rr.mul(ni, gi), Gi = rr.mul(Gi, vi), Fi = rr.mul(Gi, ft.B), ni = rr.add(ni, Fi), Pn = rr.mul(Zr, gi);
      const { isValid: ds, value: us } = dr(ni, Gi);
      Zi = rr.mul(Zr, Or), Zi = rr.mul(Zi, us), Pn = rr.cmov(Pn, gi, ds), Zi = rr.cmov(Zi, us, ds);
      const Is = rr.isOdd(Or) === rr.isOdd(Zi);
      return Zi = rr.cmov(rr.neg(Zi), Zi, Is), Pn = rr.div(Pn, vi), { x: Pn, y: Zi };
    };
  }
  function Qa(rr) {
    if (rr instanceof Uint8Array)
      return rr;
    if (typeof rr == "string")
      return On(rr);
    throw new Error("DST must be Uint8Array or string");
  }
  const za = no;
  function ga(rr, ft) {
    if (rr < 0 || rr >= 1 << 8 * ft)
      throw new Error(`bad I2OSP call: value=${rr} length=${ft}`);
    const dr = Array.from({ length: ft }).fill(0);
    for (let Or = ft - 1; Or >= 0; Or--)
      dr[Or] = rr & 255, rr >>>= 8;
    return new Uint8Array(dr);
  }
  function au(rr, ft) {
    const dr = new Uint8Array(rr.length);
    for (let Or = 0; Or < rr.length; Or++)
      dr[Or] = rr[Or] ^ ft[Or];
    return dr;
  }
  function Ua(rr) {
    if (!(rr instanceof Uint8Array))
      throw new Error("Uint8Array expected");
  }
  function uu(rr) {
    if (!Number.isSafeInteger(rr))
      throw new Error("number expected");
  }
  function Cu(rr, ft, dr, Or) {
    Ua(rr), Ua(ft), uu(dr), ft.length > 255 && (ft = Or(Yi(On("H2C-OVERSIZE-DST-"), ft)));
    const { outputLen: Zr, blockLen: ni } = Or, gi = Math.ceil(dr / Zr);
    if (gi > 255)
      throw new Error("Invalid xmd length");
    const vi = Yi(ft, ga(ft.length, 1)), Fi = ga(0, ni), Gi = ga(dr, 2), Pn = new Array(gi), Zi = Or(Yi(Fi, rr, Gi, ga(0, 1), vi));
    Pn[0] = Or(Yi(Zi, ga(1, 1), vi));
    for (let us = 1; us <= gi; us++) {
      const Is = [au(Zi, Pn[us - 1]), ga(us + 1, 1), vi];
      Pn[us] = Or(Yi(...Is));
    }
    return Yi(...Pn).slice(0, dr);
  }
  function Cf(rr, ft, dr, Or, Zr) {
    if (Ua(rr), Ua(ft), uu(dr), ft.length > 255) {
      const ni = Math.ceil(2 * Or / 8);
      ft = Zr.create({ dkLen: ni }).update(On("H2C-OVERSIZE-DST-")).update(ft).digest();
    }
    if (dr > 65535 || ft.length > 255)
      throw new Error("expand_message_xof: invalid lenInBytes");
    return Zr.create({ dkLen: dr }).update(rr).update(ga(dr, 2)).update(ft).update(ga(ft.length, 1)).digest();
  }
  function ef(rr, ft, dr) {
    Yo(dr, {
      DST: "string",
      p: "bigint",
      m: "isSafeInteger",
      k: "isSafeInteger",
      hash: "hash"
    });
    const { p: Or, k: Zr, m: ni, hash: gi, expand: vi, DST: Fi } = dr;
    Ua(rr), uu(ft);
    const Gi = Qa(Fi), Pn = Or.toString(2).length, Zi = Math.ceil((Pn + Zr) / 8), ds = ft * ni * Zi;
    let us;
    if (vi === "xmd")
      us = Cu(rr, Gi, ds, gi);
    else if (vi === "xof")
      us = Cf(rr, Gi, ds, Zr, gi);
    else if (vi === void 0)
      us = rr;
    else
      throw new Error('expand must be "xmd", "xof" or undefined');
    const Is = new Array(ft);
    for (let $n = 0; $n < ft; $n++) {
      const As = new Array(ni);
      for (let ms = 0; ms < ni; ms++) {
        const Ns = Zi * (ms + $n * ni), Ts = us.subarray(Ns, Ns + Zi);
        As[ms] = $o(za(Ts), Or);
      }
      Is[$n] = As;
    }
    return Is;
  }
  function Uf(rr, ft) {
    const dr = ft.map((Or) => Array.from(Or).reverse());
    return (Or, Zr) => {
      const [ni, gi, vi, Fi] = dr.map((Gi) => Gi.reduce((Pn, Zi) => rr.add(rr.mul(Pn, Or), Zi)));
      return Or = rr.div(ni, gi), Zr = rr.mul(Zr, rr.div(vi, Fi)), { x: Or, y: Zr };
    };
  }
  function _c(rr, ft, dr) {
    if (typeof ft != "function")
      throw new Error("mapToCurve() must be defined");
    return {
      // Encodes byte string to elliptic curve
      // https://datatracker.ietf.org/doc/html/draft-irtf-cfrg-hash-to-curve-16#section-3
      hashToCurve(Or, Zr) {
        const ni = ef(Or, 2, { ...dr, DST: dr.DST, ...Zr }), gi = rr.fromAffine(ft(ni[0])), vi = rr.fromAffine(ft(ni[1])), Fi = gi.add(vi).clearCofactor();
        return Fi.assertValidity(), Fi;
      },
      // https://datatracker.ietf.org/doc/html/draft-irtf-cfrg-hash-to-curve-16#section-3
      encodeToCurve(Or, Zr) {
        const ni = ef(Or, 1, { ...dr, DST: dr.encodeDST, ...Zr }), gi = rr.fromAffine(ft(ni[0])).clearCofactor();
        return gi.assertValidity(), gi;
      }
    };
  }
  let pc = class extends Xi {
    constructor(ft, dr) {
      super(), this.finished = !1, this.destroyed = !1, wi.hash(ft);
      const Or = Ki(dr);
      if (this.iHash = ft.create(), typeof this.iHash.update != "function")
        throw new TypeError("Expected instance of class which extends utils.Hash");
      this.blockLen = this.iHash.blockLen, this.outputLen = this.iHash.outputLen;
      const Zr = this.blockLen, ni = new Uint8Array(Zr);
      ni.set(Or.length > Zr ? ft.create().update(Or).digest() : Or);
      for (let gi = 0; gi < ni.length; gi++)
        ni[gi] ^= 54;
      this.iHash.update(ni), this.oHash = ft.create();
      for (let gi = 0; gi < ni.length; gi++)
        ni[gi] ^= 106;
      this.oHash.update(ni), ni.fill(0);
    }
    update(ft) {
      return wi.exists(this), this.iHash.update(ft), this;
    }
    digestInto(ft) {
      wi.exists(this), wi.bytes(ft, this.outputLen), this.finished = !0, this.iHash.digestInto(ft), this.oHash.update(ft), this.oHash.digestInto(ft), this.destroy();
    }
    digest() {
      const ft = new Uint8Array(this.oHash.outputLen);
      return this.digestInto(ft), ft;
    }
    _cloneInto(ft) {
      ft || (ft = Object.create(Object.getPrototypeOf(this), {}));
      const { oHash: dr, iHash: Or, finished: Zr, destroyed: ni, blockLen: gi, outputLen: vi } = this;
      return ft = ft, ft.finished = Zr, ft.destroyed = ni, ft.blockLen = gi, ft.outputLen = vi, ft.oHash = dr._cloneInto(ft.oHash), ft.iHash = Or._cloneInto(ft.iHash), ft;
    }
    destroy() {
      this.destroyed = !0, this.oHash.destroy(), this.iHash.destroy();
    }
  };
  const yc = (rr, ft, dr) => new pc(rr, ft).update(dr).digest();
  yc.create = (rr, ft) => new pc(rr, ft);
  function Ml(rr) {
    return {
      hash: rr,
      hmac: (ft, ...dr) => yc(rr, ft, Wi(...dr)),
      randomBytes: In
    };
  }
  function Fl(rr, ft) {
    const dr = (Or) => Vs({ ...rr, ...Ml(Or) });
    return Object.freeze({ ...dr(ft), create: dr });
  }
  const Zc = BigInt("0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f"), $c = BigInt("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141"), th = BigInt(1), el = BigInt(2), Ll = (rr, ft) => (rr + ft / el) / ft;
  function rh(rr) {
    const ft = Zc, dr = BigInt(3), Or = BigInt(6), Zr = BigInt(11), ni = BigInt(22), gi = BigInt(23), vi = BigInt(44), Fi = BigInt(88), Gi = rr * rr * rr % ft, Pn = Gi * Gi * rr % ft, Zi = Ko(Pn, dr, ft) * Pn % ft, ds = Ko(Zi, dr, ft) * Pn % ft, us = Ko(ds, el, ft) * Gi % ft, Is = Ko(us, Zr, ft) * us % ft, $n = Ko(Is, ni, ft) * Is % ft, As = Ko($n, vi, ft) * $n % ft, ms = Ko(As, Fi, ft) * As % ft, Ns = Ko(ms, vi, ft) * $n % ft, Ts = Ko(Ns, dr, ft) * Pn % ft, oo = Ko(Ts, gi, ft) * Is % ft, Ws = Ko(oo, Or, ft) * Gi % ft, Ks = Ko(Ws, el, ft);
    if (!Vu.eql(Vu.sqr(Ks), rr))
      throw new Error("Cannot find square root");
    return Ks;
  }
  const Vu = Ls(Zc, void 0, void 0, { sqrt: rh }), Gu = Fl({
    a: BigInt(0),
    b: BigInt(7),
    Fp: Vu,
    n: $c,
    // Base point (x, y) aka generator point
    Gx: BigInt("55066263022277343669578718895168534326250603453777594175500187360389116729240"),
    Gy: BigInt("32670510020758816978083085130507043184471273380659243275938904335757337482424"),
    h: BigInt(1),
    lowS: !0,
    /**
     * secp256k1 belongs to Koblitz curves: it has efficiently computable endomorphism.
     * Endomorphism uses 2x less RAM, speeds up precomputation by 2x and ECDH / key recovery by 20%.
     * For precomputed wNAF it trades off 1/2 init time & 1/3 ram for 20% perf hit.
     * Explanation: https://gist.github.com/paulmillr/eb670806793e84df628a7c434a873066
     */
    endo: {
      beta: BigInt("0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee"),
      splitScalar: (rr) => {
        const ft = $c, dr = BigInt("0x3086d221a7d46bcde86c90e49284eb15"), Or = -th * BigInt("0xe4437ed6010e88286f547fa90abfe4c3"), Zr = BigInt("0x114ca50f7a8e2f3f657c1108d9d44cfd8"), ni = dr, gi = BigInt("0x100000000000000000000000000000000"), vi = Ll(ni * rr, ft), Fi = Ll(-Or * rr, ft);
        let Gi = $o(rr - vi * dr - Fi * Zr, ft), Pn = $o(-vi * Or - Fi * ni, ft);
        const Zi = Gi > gi, ds = Pn > gi;
        if (Zi && (Gi = ft - Gi), ds && (Pn = ft - Pn), Gi > gi || Pn > gi)
          throw new Error("splitScalar: Endomorphism failed, k=" + rr);
        return { k1neg: Zi, k1: Gi, k2neg: ds, k2: Pn };
      }
    }
  }, Ss);
  BigInt(0), Gu.ProjectivePoint, Gu.utils.randomPrivateKey;
  const F1 = Uf(Vu, [
    // xNum
    [
      "0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa8c7",
      "0x7d3d4c80bc321d5b9f315cea7fd44c5d595d2fc0bf63b92dfff1044f17c6581",
      "0x534c328d23f234e6e2a413deca25caece4506144037c40314ecbd0b53d9dd262",
      "0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa88c"
    ],
    // xDen
    [
      "0xd35771193d94918a9ca34ccbb7b640dd86cd409542f8487d9fe6b745781eb49b",
      "0xedadc6f64383dc1df7c4b2d51b54225406d36b641f5e41bbc52a56612a8c6d14",
      "0x0000000000000000000000000000000000000000000000000000000000000001"
      // LAST 1
    ],
    // yNum
    [
      "0x4bda12f684bda12f684bda12f684bda12f684bda12f684bda12f684b8e38e23c",
      "0xc75e0c32d5cb7c0fa9d0a54b12a0a6d5647ab046d686da6fdffc90fc201d71a3",
      "0x29a6194691f91a73715209ef6512e576722830a201be2018a765e85a9ecee931",
      "0x2f684bda12f684bda12f684bda12f684bda12f684bda12f684bda12f38e38d84"
    ],
    // yDen
    [
      "0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffff93b",
      "0x7a06534bb8bdb49fd5e9e6632722c2989467c1bfc8e8d978dfb425d2685c2573",
      "0x6484aa716545ca2cf3a70c3fa8fe337e0a3d21162f0d6299a7bf8192bfd2a76f",
      "0x0000000000000000000000000000000000000000000000000000000000000001"
      // LAST 1
    ]
  ].map((rr) => rr.map((ft) => BigInt(ft)))), L1 = wa(Vu, {
    A: BigInt("0x3f8731abdd661adca08a5558f0f5d272e953d363cb6f0e5d405447c01a444533"),
    B: BigInt("1771"),
    Z: Vu.create(BigInt("-11"))
  });
  _c(Gu.ProjectivePoint, (rr) => {
    const { x: ft, y: dr } = L1(Vu.create(rr[0]));
    return F1(ft, dr);
  }, {
    DST: "secp256k1_XMD:SHA-256_SSWU_RO_",
    encodeDST: "secp256k1_XMD:SHA-256_SSWU_NU_",
    p: Vu.ORDER,
    m: 1,
    k: 128,
    expand: "xmd",
    hash: Ss
  });
  function Hl(rr) {
    if (!Number.isSafeInteger(rr) || rr < 0)
      throw new Error(`Wrong positive integer: ${rr}`);
  }
  function H1(rr) {
    if (typeof rr != "boolean")
      throw new Error(`Expected boolean, not ${rr}`);
  }
  function ih(rr, ...ft) {
    if (!(rr instanceof Uint8Array))
      throw new TypeError("Expected Uint8Array");
    if (ft.length > 0 && !ft.includes(rr.length))
      throw new TypeError(`Expected Uint8Array of length ${ft}, not of length=${rr.length}`);
  }
  function K1(rr) {
    if (typeof rr != "function" || typeof rr.create != "function")
      throw new Error("Hash should be wrapped by utils.wrapConstructor");
    Hl(rr.outputLen), Hl(rr.blockLen);
  }
  function V1(rr, ft = !0) {
    if (rr.destroyed)
      throw new Error("Hash instance has been destroyed");
    if (ft && rr.finished)
      throw new Error("Hash#digest() has already been called");
  }
  function G1(rr, ft) {
    ih(rr);
    const dr = ft.outputLen;
    if (rr.length < dr)
      throw new Error(`digestInto() expects output buffer of length at least ${dr}`);
  }
  var Vl = {
    number: Hl,
    bool: H1,
    bytes: ih,
    hash: K1,
    exists: V1,
    output: G1
  };
  const Gl = (rr) => new DataView(rr.buffer, rr.byteOffset, rr.byteLength), ku = (rr, ft) => rr << 32 - ft | rr >>> ft;
  if (!(new Uint8Array(new Uint32Array([287454020]).buffer)[0] === 68))
    throw new Error("Non little-endian hardware is not supported");
  Array.from({ length: 256 }, (rr, ft) => ft.toString(16).padStart(2, "0"));
  function j1(rr) {
    if (typeof rr != "string")
      throw new TypeError(`utf8ToBytes expected string, got ${typeof rr}`);
    return new TextEncoder().encode(rr);
  }
  function Jr(rr) {
    if (typeof rr == "string" && (rr = j1(rr)), !(rr instanceof Uint8Array))
      throw new TypeError(`Expected input type is Uint8Array (got ${typeof rr})`);
    return rr;
  }
  let yo = class {
    // Safe version that clones internal state
    clone() {
      return this._cloneInto();
    }
  };
  function Ds(rr) {
    const ft = (Or) => rr().update(Jr(Or)).digest(), dr = rr();
    return ft.outputLen = dr.outputLen, ft.blockLen = dr.blockLen, ft.create = () => rr(), ft;
  }
  function W1(rr, ft, dr, Or) {
    if (typeof rr.setBigUint64 == "function")
      return rr.setBigUint64(ft, dr, Or);
    const Zr = BigInt(32), ni = BigInt(4294967295), gi = Number(dr >> Zr & ni), vi = Number(dr & ni), Fi = Or ? 4 : 0, Gi = Or ? 0 : 4;
    rr.setUint32(ft + Fi, gi, Or), rr.setUint32(ft + Gi, vi, Or);
  }
  let z1 = class extends yo {
    constructor(ft, dr, Or, Zr) {
      super(), this.blockLen = ft, this.outputLen = dr, this.padOffset = Or, this.isLE = Zr, this.finished = !1, this.length = 0, this.pos = 0, this.destroyed = !1, this.buffer = new Uint8Array(ft), this.view = Gl(this.buffer);
    }
    update(ft) {
      Vl.exists(this);
      const { view: dr, buffer: Or, blockLen: Zr } = this;
      ft = Jr(ft);
      const ni = ft.length;
      for (let gi = 0; gi < ni; ) {
        const vi = Math.min(Zr - this.pos, ni - gi);
        if (vi === Zr) {
          const Fi = Gl(ft);
          for (; Zr <= ni - gi; gi += Zr)
            this.process(Fi, gi);
          continue;
        }
        Or.set(ft.subarray(gi, gi + vi), this.pos), this.pos += vi, gi += vi, this.pos === Zr && (this.process(dr, 0), this.pos = 0);
      }
      return this.length += ft.length, this.roundClean(), this;
    }
    digestInto(ft) {
      Vl.exists(this), Vl.output(ft, this), this.finished = !0;
      const { buffer: dr, view: Or, blockLen: Zr, isLE: ni } = this;
      let { pos: gi } = this;
      dr[gi++] = 128, this.buffer.subarray(gi).fill(0), this.padOffset > Zr - gi && (this.process(Or, 0), gi = 0);
      for (let Zi = gi; Zi < Zr; Zi++)
        dr[Zi] = 0;
      W1(Or, Zr - 8, BigInt(this.length * 8), ni), this.process(Or, 0);
      const vi = Gl(ft), Fi = this.outputLen;
      if (Fi % 4)
        throw new Error("_sha2: outputLen should be aligned to 32bit");
      const Gi = Fi / 4, Pn = this.get();
      if (Gi > Pn.length)
        throw new Error("_sha2: outputLen bigger than state");
      for (let Zi = 0; Zi < Gi; Zi++)
        vi.setUint32(4 * Zi, Pn[Zi], ni);
    }
    digest() {
      const { buffer: ft, outputLen: dr } = this;
      this.digestInto(ft);
      const Or = ft.slice(0, dr);
      return this.destroy(), Or;
    }
    _cloneInto(ft) {
      ft || (ft = new this.constructor()), ft.set(...this.get());
      const { blockLen: dr, buffer: Or, length: Zr, finished: ni, destroyed: gi, pos: vi } = this;
      return ft.length = Zr, ft.pos = vi, ft.finished = ni, ft.destroyed = gi, Zr % dr && ft.buffer.set(Or), ft;
    }
  };
  const J1 = (rr, ft, dr) => rr & ft ^ ~rr & dr, Y1 = (rr, ft, dr) => rr & ft ^ rr & dr ^ ft & dr, nh = new Uint32Array([
    1116352408,
    1899447441,
    3049323471,
    3921009573,
    961987163,
    1508970993,
    2453635748,
    2870763221,
    3624381080,
    310598401,
    607225278,
    1426881987,
    1925078388,
    2162078206,
    2614888103,
    3248222580,
    3835390401,
    4022224774,
    264347078,
    604807628,
    770255983,
    1249150122,
    1555081692,
    1996064986,
    2554220882,
    2821834349,
    2952996808,
    3210313671,
    3336571891,
    3584528711,
    113926993,
    338241895,
    666307205,
    773529912,
    1294757372,
    1396182291,
    1695183700,
    1986661051,
    2177026350,
    2456956037,
    2730485921,
    2820302411,
    3259730800,
    3345764771,
    3516065817,
    3600352804,
    4094571909,
    275423344,
    430227734,
    506948616,
    659060556,
    883997877,
    958139571,
    1322822218,
    1537002063,
    1747873779,
    1955562222,
    2024104815,
    2227730452,
    2361852424,
    2428436474,
    2756734187,
    3204031479,
    3329325298
  ]), tf = new Uint32Array([
    1779033703,
    3144134277,
    1013904242,
    2773480762,
    1359893119,
    2600822924,
    528734635,
    1541459225
  ]), rf = new Uint32Array(64);
  let jl = class extends z1 {
    constructor() {
      super(64, 32, 8, !1), this.A = tf[0] | 0, this.B = tf[1] | 0, this.C = tf[2] | 0, this.D = tf[3] | 0, this.E = tf[4] | 0, this.F = tf[5] | 0, this.G = tf[6] | 0, this.H = tf[7] | 0;
    }
    get() {
      const { A: ft, B: dr, C: Or, D: Zr, E: ni, F: gi, G: vi, H: Fi } = this;
      return [ft, dr, Or, Zr, ni, gi, vi, Fi];
    }
    // prettier-ignore
    set(ft, dr, Or, Zr, ni, gi, vi, Fi) {
      this.A = ft | 0, this.B = dr | 0, this.C = Or | 0, this.D = Zr | 0, this.E = ni | 0, this.F = gi | 0, this.G = vi | 0, this.H = Fi | 0;
    }
    process(ft, dr) {
      for (let Zi = 0; Zi < 16; Zi++, dr += 4)
        rf[Zi] = ft.getUint32(dr, !1);
      for (let Zi = 16; Zi < 64; Zi++) {
        const ds = rf[Zi - 15], us = rf[Zi - 2], Is = ku(ds, 7) ^ ku(ds, 18) ^ ds >>> 3, $n = ku(us, 17) ^ ku(us, 19) ^ us >>> 10;
        rf[Zi] = $n + rf[Zi - 7] + Is + rf[Zi - 16] | 0;
      }
      let { A: Or, B: Zr, C: ni, D: gi, E: vi, F: Fi, G: Gi, H: Pn } = this;
      for (let Zi = 0; Zi < 64; Zi++) {
        const ds = ku(vi, 6) ^ ku(vi, 11) ^ ku(vi, 25), us = Pn + ds + J1(vi, Fi, Gi) + nh[Zi] + rf[Zi] | 0, $n = (ku(Or, 2) ^ ku(Or, 13) ^ ku(Or, 22)) + Y1(Or, Zr, ni) | 0;
        Pn = Gi, Gi = Fi, Fi = vi, vi = gi + us | 0, gi = ni, ni = Zr, Zr = Or, Or = us + $n | 0;
      }
      Or = Or + this.A | 0, Zr = Zr + this.B | 0, ni = ni + this.C | 0, gi = gi + this.D | 0, vi = vi + this.E | 0, Fi = Fi + this.F | 0, Gi = Gi + this.G | 0, Pn = Pn + this.H | 0, this.set(Or, Zr, ni, gi, vi, Fi, Gi, Pn);
    }
    roundClean() {
      rf.fill(0);
    }
    destroy() {
      this.set(0, 0, 0, 0, 0, 0, 0, 0), this.buffer.fill(0);
    }
  }, sh = class extends jl {
    constructor() {
      super(), this.A = -1056596264, this.B = 914150663, this.C = 812702999, this.D = -150054599, this.E = -4191439, this.F = 1750603025, this.G = 1694076839, this.H = -1090891868, this.outputLen = 28;
    }
  };
  const Ic = Ds(() => new jl());
  Ds(() => new sh());
  function X1(rr, ft) {
    if (rr.length > ft)
      throw new TypeError(`Data is larger than array size: ${rr.length} > ${ft}`);
  }
  function Z1(rr) {
    if (rr.match(/[^a-fA-f0-9]/) !== null)
      throw new TypeError("Invalid characters in hex string: " + rr);
    if (rr.length % 2 !== 0)
      throw new Error(`Length of hex string is invalid: ${rr.length}`);
  }
  function $1(rr) {
    if (rr > Number.MAX_SAFE_INTEGER)
      throw new TypeError("Number exceeds safe bounds!");
  }
  const { getRandomValues: eg } = crypto ?? globalThis.crypto ?? window.crypto;
  function oh(rr = 32) {
    if (typeof eg == "function")
      return crypto.getRandomValues(new Uint8Array(rr));
    throw new Error("Crypto module missing getRandomValues!");
  }
  function tg(rr, ft, dr = "be") {
    ft === void 0 && (ft = rr.length), X1(rr, ft);
    const Or = new Uint8Array(ft).fill(0), Zr = dr === "be" ? 0 : ft - rr.length;
    return Or.set(rr, Zr), Or;
  }
  function mc(rr) {
    let ft, dr = 0;
    const Or = rr.reduce((ni, gi) => ni + gi.length, 0), Zr = new Uint8Array(Or);
    for (ft = 0; ft < rr.length; ft++) {
      const ni = rr[ft];
      Zr.set(ni, dr), dr += ni.length;
    }
    return Zr;
  }
  const rg = new TextEncoder(), ah = [
    {
      name: "base58",
      charset: "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz"
    }
  ];
  function Wl(rr) {
    for (const ft of ah)
      if (ft.name === rr)
        return ft.charset;
    throw TypeError("Charset does not exist: " + rr);
  }
  function Su(rr, ft, dr = !1) {
    typeof rr == "string" && (rr = rg.encode(rr));
    const Or = Wl(ft), Zr = Or.length, ni = [];
    let gi = "", vi, Fi = 0, Gi, Pn;
    for (vi = 0; vi < rr.length; vi++)
      for (Fi = 0, Gi = rr[vi], gi += Gi > 0 || (gi.length ^ vi) > 0 ? "" : "1"; Fi in ni || Gi > 0; )
        Pn = ni[Fi], Pn = Pn > 0 ? Pn * 256 + Gi : Gi, Gi = Pn / Zr | 0, ni[Fi] = Pn % Zr, Fi++;
    for (; Fi-- > 0; )
      gi += Or[ni[Fi]];
    return dr && gi.length % 4 > 0 ? gi + "=".repeat(4 - gi.length % 4) : gi;
  }
  function ig(rr, ft) {
    const dr = Wl(ft), Or = dr.length, Zr = [], ni = [];
    rr = rr.replace("=", "");
    let gi, vi = 0, Fi, Gi;
    for (gi = 0; gi < rr.length; gi++) {
      if (vi = 0, Fi = dr.indexOf(rr[gi]), Fi < 0)
        throw new Error(`Character range out of bounds: ${Fi}`);
      for (Fi > 0 || (ni.length ^ gi) > 0 || ni.push(0); vi in Zr || Fi > 0; )
        Gi = Zr[vi], Gi = Gi > 0 ? Gi * Or + Fi : Fi, Fi = Gi >> 8, Zr[vi] = Gi % 256, vi++;
    }
    for (; vi-- > 0; )
      ni.push(Zr[vi]);
    return new Uint8Array(ni);
  }
  function uh(rr) {
    return Ic(Ic(rr));
  }
  function ng(rr) {
    const ft = uh(rr);
    return mc([rr, ft.slice(0, 4)]);
  }
  function sg(rr) {
    const ft = rr.slice(0, -4), dr = rr.slice(-4);
    if (uh(ft).slice(0, 4).toString() !== dr.toString())
      throw new Error("Invalid checksum!");
    return ft;
  }
  const zl = {
    encode: Su,
    decode: ig
  }, fh = {
    encode: (rr) => {
      const ft = ng(rr);
      return zl.encode(ft, "base58");
    },
    decode: (rr) => {
      const ft = zl.decode(rr, "base58");
      return sg(ft);
    }
  }, Jl = "qpzry9x8gf2tvdw0s3jn54khce6mua7l", og = [996825010, 642813549, 513874426, 1027748829, 705979059], Qo = [
    { version: 0, name: "bech32", const: 1 },
    { version: 1, name: "bech32m", const: 734539939 }
  ];
  function Yl(rr) {
    let ft = 1;
    for (let dr = 0; dr < rr.length; ++dr) {
      const Or = ft >> 25;
      ft = (ft & 33554431) << 5 ^ rr[dr];
      for (let Zr = 0; Zr < 5; ++Zr)
        (Or >> Zr & 1) !== 0 && (ft ^= og[Zr]);
    }
    return ft;
  }
  function ch(rr) {
    const ft = [];
    let dr;
    for (dr = 0; dr < rr.length; ++dr)
      ft.push(rr.charCodeAt(dr) >> 5);
    for (ft.push(0), dr = 0; dr < rr.length; ++dr)
      ft.push(rr.charCodeAt(dr) & 31);
    return ft;
  }
  function ag(rr, ft, dr) {
    const Or = ch(rr).concat(ft);
    return Yl(Or) === dr.const;
  }
  function ug(rr, ft, dr) {
    const Or = ch(rr).concat(ft).concat([0, 0, 0, 0, 0, 0]), Zr = Yl(Or) ^ dr.const, ni = [];
    for (let gi = 0; gi < 6; ++gi)
      ni.push(Zr >> 5 * (5 - gi) & 31);
    return ni;
  }
  function Mf(rr, ft, dr, Or = !0) {
    const Zr = [];
    let ni = 0, gi = 0;
    const vi = (1 << dr) - 1, Fi = (1 << ft + dr - 1) - 1;
    for (const Gi of rr) {
      if (Gi < 0 || Gi >> ft > 0)
        throw new Error("Failed to perform base conversion. Invalid value: " + String(Gi));
      for (ni = (ni << ft | Gi) & Fi, gi += ft; gi >= dr; )
        gi -= dr, Zr.push(ni >> gi & vi);
    }
    if (Or)
      gi > 0 && Zr.push(ni << dr - gi & vi);
    else if (gi >= ft || (ni << dr - gi & vi) > 0)
      throw new Error("Failed to perform base conversion. Invalid Size!");
    return Zr;
  }
  function lh(rr, ft, dr) {
    const Or = ft.concat(ug(rr, ft, dr));
    let Zr = rr + "1";
    for (let ni = 0; ni < Or.length; ++ni)
      Zr += Jl.charAt(Or[ni]);
    return Zr;
  }
  function hh(rr) {
    if (!fg(rr))
      throw new Error("Encoded string goes out of bounds!");
    if (rr = rr.toLowerCase(), !Ka(rr))
      throw new Error("Encoded string has invalid separator!");
    const ft = [], dr = rr.lastIndexOf("1"), Or = rr.substring(0, dr);
    for (let ni = dr + 1; ni < rr.length; ++ni) {
      const gi = Jl.indexOf(rr.charAt(ni));
      if (gi === -1)
        throw new Error("Character idx out of bounds: " + String(ni));
      ft.push(gi);
    }
    const Zr = Qo.find((ni) => ni.version === ft[0]) ?? Qo[0];
    if (!ag(Or, ft, Zr))
      throw new Error("Checksum verification failed!");
    return [Or, ft.slice(0, ft.length - 6)];
  }
  function fg(rr) {
    let ft, dr, Or = !1, Zr = !1;
    for (ft = 0; ft < rr.length; ++ft) {
      if (dr = rr.charCodeAt(ft), dr < 33 || dr > 126)
        return !1;
      dr >= 97 && dr <= 122 && (Or = !0), dr >= 65 && dr <= 90 && (Zr = !0);
    }
    return !(Or && Zr);
  }
  function Ka(rr) {
    const ft = rr.lastIndexOf("1");
    return !(ft < 1 || ft + 7 > rr.length || rr.length > 90);
  }
  function cg(rr, ft = "bc", dr = 0) {
    const Or = [dr, ...Mf([...rr], 8, 5)], Zr = Qo.find((gi) => gi.version === dr) ?? Qo[0], ni = lh(ft, Or, Zr);
    return tl(ni), ni;
  }
  function tl(rr) {
    rr = rr.toLowerCase();
    const ft = rr.split("1", 1)[0], [dr, Or] = hh(rr), Zr = Mf(Or.slice(1), 5, 8, !1), ni = Zr.length;
    switch (!0) {
      case ft !== dr:
        throw new Error("Returned hrp string is invalid.");
      case (Zr === null || ni < 2 || ni > 40):
        throw new Error("Decoded string is invalid or out of spec.");
      case Or[0] > 16:
        throw new Error("Returned version bit is out of range.");
      default:
        return Uint8Array.from(Zr);
    }
  }
  function lg(rr) {
    rr = rr.toLowerCase();
    const [ft, dr] = hh(rr);
    return dr[0];
  }
  const Xl = {
    encode: cg,
    decode: tl,
    version: lg
  }, Ah = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", gh = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_", dg = new TextEncoder();
  function ph(rr, ft = !1, dr = !0) {
    typeof rr == "string" && (rr = dg.encode(rr));
    const Or = ft ? gh : Ah;
    let Zr = "", ni = 0, gi = 0;
    for (let vi = 0; vi < rr.length; vi++)
      for (gi = gi << 8 | rr[vi], ni += 8; ni >= 6; )
        ni -= 6, Zr += Or[gi >> ni & 63];
    if (ni > 0)
      for (gi <<= 6 - ni, Zr += Or[gi & 63]; ni < 6; )
        Zr += dr ? "=" : "", ni += 2;
    return Zr;
  }
  function _l(rr, ft = !1) {
    const dr = ft || rr.includes("-") || rr.includes("_") ? gh.split("") : Ah.split("");
    rr = rr.replace(/=+$/, "");
    const Or = rr.split("");
    let Zr = 0, ni = 0;
    const gi = [];
    for (let vi = 0; vi < Or.length; vi++) {
      const Fi = Or[vi], Gi = dr.indexOf(Fi);
      if (Gi === -1)
        throw new Error("Invalid character: " + Fi);
      Zr += 6, ni <<= 6, ni |= Gi, Zr >= 8 && (Zr -= 8, gi.push(ni >>> Zr & 255));
    }
    return new Uint8Array(gi);
  }
  const yh = {
    encode: ph,
    decode: _l
  }, Ih = {
    encode: (rr) => ph(rr, !0, !1),
    decode: (rr) => _l(rr, !0)
  }, hg = BigInt(0), mh = BigInt(255), wh = BigInt(256);
  function Ag(rr) {
    if (rr <= 0xffn)
      return 1;
    if (rr <= 0xffffn)
      return 2;
    if (rr <= 0xffffffffn)
      return 4;
    if (rr <= 0xffffffffffffffffn)
      return 8;
    if (rr <= 0xffffffffffffffffffffffffffffffffn)
      return 16;
    if (rr <= 0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffn)
      return 32;
    throw new TypeError("Must specify a fixed buffer size for bigints greater than 32 bytes.");
  }
  function gg(rr, ft, dr = "be") {
    ft === void 0 && (ft = Ag(rr));
    const Or = dr === "le", Zr = new ArrayBuffer(ft), ni = new DataView(Zr);
    let gi = Or ? 0 : ft - 1;
    for (; rr > hg; ) {
      const vi = rr & mh, Fi = Number(vi);
      Or ? ni.setUint8(gi++, Fi) : ni.setUint8(gi--, Fi), rr = (rr - vi) / wh;
    }
    return new Uint8Array(Zr);
  }
  function pg(rr) {
    let ft = BigInt(0);
    for (let dr = rr.length - 1; dr >= 0; dr--)
      ft = ft * wh + BigInt(rr[dr]);
    return BigInt(ft);
  }
  function yg(rr) {
    const ft = rr.split("").map(Number);
    if (ft.length % 8 !== 0)
      throw new Error(`Binary array is invalid length: ${rr.length}`);
    const dr = new Uint8Array(ft.length / 8);
    for (let Or = 0, Zr = 0; Or < ft.length; Or += 8, Zr++) {
      let ni = 0;
      for (let gi = 0; gi < 8; gi++)
        ni |= ft[Or + gi] << 7 - gi;
      dr[Zr] = ni;
    }
    return dr;
  }
  function Ig(rr) {
    const ft = new Array(rr.length * 8);
    let dr = 0;
    for (const Or of rr) {
      if (Or > 255)
        throw new Error(`Invalid byte value: ${Or}. Byte values must be between 0 and 255.`);
      for (let Zr = 7; Zr >= 0; Zr--, dr++)
        ft[dr] = Or >> Zr & 1;
    }
    return ft.join("");
  }
  function mg(rr) {
    if (rr <= 255)
      return 1;
    if (rr <= 65535)
      return 2;
    if (rr <= 4294967295)
      return 4;
    throw new TypeError("Numbers larger than 4 bytes must specify a fixed size!");
  }
  function rl(rr, ft, dr = "be") {
    ft === void 0 && (ft = mg(rr));
    const Or = dr === "le", Zr = new ArrayBuffer(ft), ni = new DataView(Zr);
    let gi = Or ? 0 : ft - 1;
    for (; rr > 0; ) {
      const vi = rr & 255;
      Or ? ni.setUint8(gi++, rr) : ni.setUint8(gi--, rr), rr = (rr - vi) / 256;
    }
    return new Uint8Array(Zr);
  }
  function il(rr) {
    let ft = 0;
    for (let dr = rr.length - 1; dr >= 0; dr--)
      ft = ft * 256 + rr[dr], $1(ft);
    return ft;
  }
  const wg = new TextEncoder(), Eg = new TextDecoder();
  function Zl(rr) {
    return wg.encode(rr);
  }
  function $l(rr) {
    return Eg.decode(rr);
  }
  function bg(rr, ft) {
    Z1(rr);
    const dr = rr.length / 2;
    if (ft === void 0 && (ft = dr), dr > ft)
      throw new TypeError(`Hex string is larger than array size: ${dr} > ${ft}`);
    return ft;
  }
  function Bg(rr, ft, dr = "le") {
    ft = bg(rr, ft);
    const Or = dr === "le", Zr = new ArrayBuffer(ft), ni = new DataView(Zr);
    let gi = Or ? 0 : ft - 1;
    for (let vi = 0; vi < rr.length; vi += 2) {
      const Fi = rr.substring(vi, vi + 2), Gi = parseInt(Fi, 16);
      Or ? ni.setUint8(gi++, Gi) : ni.setUint8(gi--, Gi);
    }
    return new Uint8Array(Zr);
  }
  function vg(rr) {
    let ft = "";
    for (let dr = 0; dr < rr.length; dr++)
      ft += rr[dr].toString(16).padStart(2, "0");
    return ft;
  }
  function ed(rr) {
    const ft = JSON.stringify(rr, (dr, Or) => typeof Or == "bigint" ? `${Or}n` : Or);
    return Zl(ft);
  }
  function Cg(rr, ft, dr) {
    if (rr instanceof ArrayBuffer)
      return new Uint8Array(rr);
    if (rr instanceof Uint8Array)
      return tg(rr, ft, dr);
    if (typeof rr == "string")
      return Bg(rr, ft, dr);
    if (typeof rr == "bigint")
      return gg(rr, ft, dr);
    if (typeof rr == "number")
      return rl(rr, ft, dr);
    if (typeof rr == "boolean")
      return Uint8Array.of(rr ? 1 : 0);
    throw TypeError("Unsupported format:" + typeof rr);
  }
  const Do = class Do extends Uint8Array {
    static random(ft = 32) {
      const dr = oh(ft);
      return new Do(dr, ft);
    }
    constructor(ft, dr, Or) {
      const Zr = Cg(ft, dr, Or);
      super(Zr);
    }
    get arr() {
      return [...this];
    }
    get num() {
      return this.toNum();
    }
    get big() {
      return this.toBig();
    }
    get str() {
      return this.toStr();
    }
    get hex() {
      return this.toHex();
    }
    get raw() {
      return new Uint8Array(this);
    }
    get bin() {
      return this.toBin();
    }
    get b58chk() {
      return this.tob58chk();
    }
    get base64() {
      return this.toBase64();
    }
    get b64url() {
      return this.toB64url();
    }
    get digest() {
      return this.toHash();
    }
    get id() {
      return this.toHash().hex;
    }
    get stream() {
      return new qg(this);
    }
    toNum(ft = "be") {
      const dr = ft === "be" ? this.reverse() : this;
      return il(dr);
    }
    toBin() {
      return Ig(this);
    }
    toBig(ft = "be") {
      const dr = ft === "be" ? this.reverse() : this;
      return pg(dr);
    }
    toHash() {
      const ft = Ic(this);
      return new Do(ft);
    }
    toJson() {
      const ft = $l(this);
      return JSON.parse(ft);
    }
    toBech32(ft, dr = 0) {
      return Xl.encode(this, ft, dr);
    }
    toStr() {
      return $l(this);
    }
    toHex() {
      return vg(this);
    }
    toBytes() {
      return new Uint8Array(this);
    }
    tob58chk() {
      return fh.encode(this);
    }
    toBase64() {
      return yh.encode(this);
    }
    toB64url() {
      return Ih.encode(this);
    }
    prepend(ft) {
      return Do.join([Do.bytes(ft), this]);
    }
    append(ft) {
      return Do.join([this, Do.bytes(ft)]);
    }
    slice(ft, dr) {
      const Or = new Uint8Array(this).slice(ft, dr);
      return new Do(Or);
    }
    subarray(ft, dr) {
      const Or = new Uint8Array(this).subarray(ft, dr);
      return new Do(Or);
    }
    reverse() {
      const ft = new Uint8Array(this).reverse();
      return new Do(ft);
    }
    write(ft, dr) {
      const Or = Do.bytes(ft);
      this.set(Or, dr);
    }
    prefixSize(ft) {
      const dr = Do.varInt(this.length, ft);
      return Do.join([dr, this]);
    }
    static from(ft) {
      return new Do(Uint8Array.from(ft));
    }
    static of(...ft) {
      return new Do(Uint8Array.of(...ft));
    }
    static join(ft) {
      const dr = ft.map((Zr) => Do.bytes(Zr)), Or = mc(dr);
      return new Do(Or);
    }
    static varInt(ft, dr) {
      if (ft < 253)
        return Do.num(ft, 1);
      if (ft < 65536)
        return Do.of(253, ...Do.num(ft, 2, dr));
      if (ft < 4294967296)
        return Do.of(254, ...Do.num(ft, 4, dr));
      if (BigInt(ft) < 0x10000000000000000n)
        return Do.of(255, ...Do.num(ft, 8, dr));
      throw new Error(`Value is too large: ${ft}`);
    }
  };
  Do.num = ju, Do.big = Sg, Do.bin = kg, Do.raw = nl, Do.str = Tg, Do.hex = Rg, Do.bytes = xg, Do.json = Dg, Do.base64 = Eh, Do.b64url = Ng, Do.bech32 = Pg, Do.b58chk = wc, Do.encode = Zl, Do.decode = $l;
  let lo = Do;
  function ju(rr, ft, dr) {
    return new lo(rr, ft, dr);
  }
  function kg(rr, ft, dr) {
    return new lo(yg(rr), ft, dr);
  }
  function Sg(rr, ft, dr) {
    return new lo(rr, ft, dr);
  }
  function nl(rr, ft, dr) {
    return new lo(rr, ft, dr);
  }
  function Tg(rr, ft, dr) {
    return new lo(Zl(rr), ft, dr);
  }
  function Rg(rr, ft, dr) {
    return new lo(rr, ft, dr);
  }
  function xg(rr, ft, dr) {
    return new lo(rr, ft, dr);
  }
  function Dg(rr) {
    return new lo(ed(rr));
  }
  function Eh(rr) {
    return new lo(yh.decode(rr));
  }
  function Ng(rr) {
    return new lo(Ih.decode(rr));
  }
  function Pg(rr) {
    return new lo(Xl.decode(rr));
  }
  function wc(rr) {
    return new lo(fh.decode(rr));
  }
  class qg {
    constructor(ft) {
      this.data = lo.bytes(ft), this.size = this.data.length;
    }
    peek(ft) {
      if (ft > this.size)
        throw new Error(`Size greater than stream: ${ft} > ${this.size}`);
      return new lo(this.data.slice(0, ft));
    }
    read(ft) {
      ft = ft ?? this.readSize();
      const dr = this.peek(ft);
      return this.data = this.data.slice(ft), this.size = this.data.length, dr;
    }
    readSize(ft) {
      const dr = this.read(1).num;
      switch (!0) {
        case (dr >= 0 && dr < 253):
          return dr;
        case dr === 253:
          return this.read(2).toNum(ft);
        case dr === 254:
          return this.read(4).toNum(ft);
        case dr === 255:
          return this.read(8).toNum(ft);
        default:
          throw new Error(`Varint is out of range: ${dr}`);
      }
    }
  }
  const Ec = Gu.CURVE, td = Ec.n, Og = Ec.p, Wu = { x: Ec.Gx, y: Ec.Gy }, Qg = BigInt(0);
  BigInt(1), BigInt(2), BigInt(3), BigInt(4);
  const rd = { N: td, P: Og, G: Wu, _0n: Qg }, bc = Ls(td, 32, !0), bh = (rr) => $o(rr, td);
  function nd(rr, ft = !1) {
    if (ft)
      throw new Error(rr);
    return !1;
  }
  function sd(rr) {
    return lo.random(rr);
  }
  function Ug(rr) {
    const ft = lo.bytes(rr).big;
    return lo.big(bh(ft), 32);
  }
  var Mg = /* @__PURE__ */ Object.freeze({
    __proto__: null,
    fail: nd,
    mod_bytes: Ug,
    random: sd
  });
  const { N: Fg, _0n: Lg } = rd;
  function Hg(rr, ft, dr) {
    const Or = lo.bytes(rr);
    return Or.length !== ft ? nd(`Invalid byte size: ${Or.hex} !== ${ft}`, dr) : !0;
  }
  function Kg(rr, ft) {
    return typeof rr == "bigint" && Lg < rr && rr < Fg || nd("x value is not in the field!", ft), !0;
  }
  const od = Gu.ProjectivePoint, la = class la extends Uint8Array {
    static mod(ft) {
      return new la(ft);
    }
    static is_valid(ft, dr) {
      const Or = lo.bytes(ft, 32).big;
      return Kg(Or, dr);
    }
    constructor(ft) {
      let dr = Bh(ft);
      dr = bh(dr), la.is_valid(dr, !0), super(lo.big(dr, 32), 32);
    }
    get buff() {
      return new lo(this);
    }
    get raw() {
      return this.buff.raw;
    }
    get big() {
      return this.buff.big;
    }
    get hex() {
      return this.buff.hex;
    }
    get point() {
      return this.generate();
    }
    get hasOddY() {
      return this.point.hasOddY;
    }
    get negated() {
      return this.hasOddY ? this.negate() : this;
    }
    gt(ft) {
      return new la(ft).big > this.big;
    }
    lt(ft) {
      return new la(ft).big < this.big;
    }
    eq(ft) {
      return new la(ft).big === this.big;
    }
    ne(ft) {
      return new la(ft).big !== this.big;
    }
    add(ft) {
      const dr = la.mod(ft), Or = bc.add(this.big, dr.big);
      return new la(Or);
    }
    sub(ft) {
      const dr = la.mod(ft), Or = bc.sub(this.big, dr.big);
      return new la(Or);
    }
    mul(ft) {
      const dr = la.mod(ft), Or = bc.mul(this.big, dr.big);
      return new la(Or);
    }
    pow(ft) {
      const dr = la.mod(ft), Or = bc.pow(this.big, dr.big);
      return new la(Or);
    }
    div(ft) {
      const dr = la.mod(ft), Or = bc.div(this.big, dr.big);
      return new la(Or);
    }
    negate() {
      return new la(la.N - this.big);
    }
    generate() {
      const dr = Gu.ProjectivePoint.BASE.multiply(this.big);
      return Tu.import(dr);
    }
  };
  la.N = Gu.CURVE.n;
  let Da = la;
  const ua = class ua {
    static from_x(ft) {
      let dr = Vg(ft);
      dr.length === 32 && (dr = dr.prepend(2)), Hg(dr, 33);
      const Or = od.fromHex(dr.hex);
      return Or.assertValidity(), new ua(Or.x, Or.y);
    }
    static generate(ft) {
      const dr = Da.mod(ft), Or = ua.base.multiply(dr.big);
      return ua.import(Or);
    }
    static import(ft) {
      const dr = ft instanceof ua ? { x: ft.x.big, y: ft.y.big } : { x: ft.x, y: ft.y };
      return new ua(dr.x, dr.y);
    }
    constructor(ft, dr) {
      this._p = new od(ft, dr, 1n), this.p.assertValidity();
    }
    get p() {
      return this._p;
    }
    get x() {
      return lo.big(this.p.x, 32);
    }
    get y() {
      return lo.big(this.p.y, 32);
    }
    get buff() {
      return lo.raw(this.p.toRawBytes(!0));
    }
    get raw() {
      return this.buff.raw;
    }
    get hex() {
      return this.buff.hex;
    }
    get hasEvenY() {
      return this.p.hasEvenY();
    }
    get hasOddY() {
      return !this.p.hasEvenY();
    }
    eq(ft) {
      const dr = ft instanceof ua ? ft : ua.from_x(ft);
      return this.x.big === dr.x.big && this.y.big === dr.y.big;
    }
    add(ft) {
      return ft instanceof ua ? ua.import(this.p.add(ft.p)) : ua.import(this.p.add(ua.generate(ft).p));
    }
    sub(ft) {
      return ft instanceof ua ? ua.import(this.p.subtract(ft.p)) : ua.import(this.p.subtract(ua.generate(ft).p));
    }
    mul(ft) {
      return ft instanceof ua ? ua.import(this.p.multiply(ft.x.big)) : ua.import(this.p.multiply(Da.mod(ft).big));
    }
    negate() {
      return ua.import(this.p.negate());
    }
  };
  ua.P = rd.P, ua.G = rd.G, ua.base = Gu.ProjectivePoint.BASE;
  let Tu = ua;
  function Bh(rr) {
    if (rr instanceof Da)
      return rr.big;
    if (rr instanceof Tu)
      return rr.x.big;
    if (rr instanceof Uint8Array)
      return lo.raw(rr).big;
    if (typeof rr == "string")
      return lo.hex(rr).big;
    if (typeof rr == "number")
      return lo.num(rr).big;
    if (typeof rr == "bigint")
      return BigInt(rr);
    throw TypeError("Invalid input type:" + typeof rr);
  }
  function Vg(rr) {
    if (rr instanceof Da)
      return rr.point.buff;
    if (rr instanceof Tu)
      return rr.buff;
    if (rr instanceof Uint8Array || typeof rr == "string")
      return lo.bytes(rr);
    if (typeof rr == "number" || typeof rr == "bigint")
      return lo.bytes(rr, 32);
    throw new TypeError(`Unknown type: ${typeof rr}`);
  }
  function ad(rr) {
    if (!Number.isSafeInteger(rr) || rr < 0)
      throw new Error(`Wrong positive integer: ${rr}`);
  }
  function Gg(rr) {
    if (typeof rr != "boolean")
      throw new Error(`Expected boolean, not ${rr}`);
  }
  function vh(rr, ...ft) {
    if (!(rr instanceof Uint8Array))
      throw new Error("Expected Uint8Array");
    if (ft.length > 0 && !ft.includes(rr.length))
      throw new Error(`Expected Uint8Array of length ${ft}, not of length=${rr.length}`);
  }
  function ud(rr) {
    if (typeof rr != "function" || typeof rr.create != "function")
      throw new Error("Hash should be wrapped by utils.wrapConstructor");
    ad(rr.outputLen), ad(rr.blockLen);
  }
  function jg(rr, ft = !0) {
    if (rr.destroyed)
      throw new Error("Hash instance has been destroyed");
    if (ft && rr.finished)
      throw new Error("Hash#digest() has already been called");
  }
  function so(rr, ft) {
    vh(rr);
    const dr = ft.outputLen;
    if (rr.length < dr)
      throw new Error(`digestInto() expects output buffer of length at least ${dr}`);
  }
  var kf = {
    number: ad,
    bool: Gg,
    bytes: vh,
    hash: ud,
    exists: jg,
    output: so
  };
  const Wg = (rr) => rr instanceof Uint8Array, fd = (rr) => new DataView(rr.buffer, rr.byteOffset, rr.byteLength), Ru = (rr, ft) => rr << 32 - ft | rr >>> ft;
  if (!(new Uint8Array(new Uint32Array([287454020]).buffer)[0] === 68))
    throw new Error("Non little-endian hardware is not supported");
  Array.from({ length: 256 }, (rr, ft) => ft.toString(16).padStart(2, "0"));
  function sl(rr) {
    if (typeof rr != "string")
      throw new Error(`utf8ToBytes expected string, got ${typeof rr}`);
    return new Uint8Array(new TextEncoder().encode(rr));
  }
  function Bc(rr) {
    if (typeof rr == "string" && (rr = sl(rr)), !Wg(rr))
      throw new Error(`expected Uint8Array, got ${typeof rr}`);
    return rr;
  }
  class ol {
    // Safe version that clones internal state
    clone() {
      return this._cloneInto();
    }
  }
  function Sf(rr) {
    const ft = (Or) => rr().update(Bc(Or)).digest(), dr = rr();
    return ft.outputLen = dr.outputLen, ft.blockLen = dr.blockLen, ft.create = () => rr(), ft;
  }
  function zg(rr, ft, dr, Or) {
    if (typeof rr.setBigUint64 == "function")
      return rr.setBigUint64(ft, dr, Or);
    const Zr = BigInt(32), ni = BigInt(4294967295), gi = Number(dr >> Zr & ni), vi = Number(dr & ni), Fi = Or ? 4 : 0, Gi = Or ? 0 : 4;
    rr.setUint32(ft + Fi, gi, Or), rr.setUint32(ft + Gi, vi, Or);
  }
  class Ff extends ol {
    constructor(ft, dr, Or, Zr) {
      super(), this.blockLen = ft, this.outputLen = dr, this.padOffset = Or, this.isLE = Zr, this.finished = !1, this.length = 0, this.pos = 0, this.destroyed = !1, this.buffer = new Uint8Array(ft), this.view = fd(this.buffer);
    }
    update(ft) {
      kf.exists(this);
      const { view: dr, buffer: Or, blockLen: Zr } = this;
      ft = Bc(ft);
      const ni = ft.length;
      for (let gi = 0; gi < ni; ) {
        const vi = Math.min(Zr - this.pos, ni - gi);
        if (vi === Zr) {
          const Fi = fd(ft);
          for (; Zr <= ni - gi; gi += Zr)
            this.process(Fi, gi);
          continue;
        }
        Or.set(ft.subarray(gi, gi + vi), this.pos), this.pos += vi, gi += vi, this.pos === Zr && (this.process(dr, 0), this.pos = 0);
      }
      return this.length += ft.length, this.roundClean(), this;
    }
    digestInto(ft) {
      kf.exists(this), kf.output(ft, this), this.finished = !0;
      const { buffer: dr, view: Or, blockLen: Zr, isLE: ni } = this;
      let { pos: gi } = this;
      dr[gi++] = 128, this.buffer.subarray(gi).fill(0), this.padOffset > Zr - gi && (this.process(Or, 0), gi = 0);
      for (let Zi = gi; Zi < Zr; Zi++)
        dr[Zi] = 0;
      zg(Or, Zr - 8, BigInt(this.length * 8), ni), this.process(Or, 0);
      const vi = fd(ft), Fi = this.outputLen;
      if (Fi % 4)
        throw new Error("_sha2: outputLen should be aligned to 32bit");
      const Gi = Fi / 4, Pn = this.get();
      if (Gi > Pn.length)
        throw new Error("_sha2: outputLen bigger than state");
      for (let Zi = 0; Zi < Gi; Zi++)
        vi.setUint32(4 * Zi, Pn[Zi], ni);
    }
    digest() {
      const { buffer: ft, outputLen: dr } = this;
      this.digestInto(ft);
      const Or = ft.slice(0, dr);
      return this.destroy(), Or;
    }
    _cloneInto(ft) {
      ft || (ft = new this.constructor()), ft.set(...this.get());
      const { blockLen: dr, buffer: Or, length: Zr, finished: ni, destroyed: gi, pos: vi } = this;
      return ft.length = Zr, ft.pos = vi, ft.finished = ni, ft.destroyed = gi, Zr % dr && ft.buffer.set(Or), ft;
    }
  }
  const Jg = (rr, ft, dr) => rr & ft ^ ~rr & dr, Yg = (rr, ft, dr) => rr & ft ^ rr & dr ^ ft & dr, Xg = new Uint32Array([
    1116352408,
    1899447441,
    3049323471,
    3921009573,
    961987163,
    1508970993,
    2453635748,
    2870763221,
    3624381080,
    310598401,
    607225278,
    1426881987,
    1925078388,
    2162078206,
    2614888103,
    3248222580,
    3835390401,
    4022224774,
    264347078,
    604807628,
    770255983,
    1249150122,
    1555081692,
    1996064986,
    2554220882,
    2821834349,
    2952996808,
    3210313671,
    3336571891,
    3584528711,
    113926993,
    338241895,
    666307205,
    773529912,
    1294757372,
    1396182291,
    1695183700,
    1986661051,
    2177026350,
    2456956037,
    2730485921,
    2820302411,
    3259730800,
    3345764771,
    3516065817,
    3600352804,
    4094571909,
    275423344,
    430227734,
    506948616,
    659060556,
    883997877,
    958139571,
    1322822218,
    1537002063,
    1747873779,
    1955562222,
    2024104815,
    2227730452,
    2361852424,
    2428436474,
    2756734187,
    3204031479,
    3329325298
  ]), xu = new Uint32Array([
    1779033703,
    3144134277,
    1013904242,
    2773480762,
    1359893119,
    2600822924,
    528734635,
    1541459225
  ]), nf = new Uint32Array(64);
  class al extends Ff {
    constructor() {
      super(64, 32, 8, !1), this.A = xu[0] | 0, this.B = xu[1] | 0, this.C = xu[2] | 0, this.D = xu[3] | 0, this.E = xu[4] | 0, this.F = xu[5] | 0, this.G = xu[6] | 0, this.H = xu[7] | 0;
    }
    get() {
      const { A: ft, B: dr, C: Or, D: Zr, E: ni, F: gi, G: vi, H: Fi } = this;
      return [ft, dr, Or, Zr, ni, gi, vi, Fi];
    }
    // prettier-ignore
    set(ft, dr, Or, Zr, ni, gi, vi, Fi) {
      this.A = ft | 0, this.B = dr | 0, this.C = Or | 0, this.D = Zr | 0, this.E = ni | 0, this.F = gi | 0, this.G = vi | 0, this.H = Fi | 0;
    }
    process(ft, dr) {
      for (let Zi = 0; Zi < 16; Zi++, dr += 4)
        nf[Zi] = ft.getUint32(dr, !1);
      for (let Zi = 16; Zi < 64; Zi++) {
        const ds = nf[Zi - 15], us = nf[Zi - 2], Is = Ru(ds, 7) ^ Ru(ds, 18) ^ ds >>> 3, $n = Ru(us, 17) ^ Ru(us, 19) ^ us >>> 10;
        nf[Zi] = $n + nf[Zi - 7] + Is + nf[Zi - 16] | 0;
      }
      let { A: Or, B: Zr, C: ni, D: gi, E: vi, F: Fi, G: Gi, H: Pn } = this;
      for (let Zi = 0; Zi < 64; Zi++) {
        const ds = Ru(vi, 6) ^ Ru(vi, 11) ^ Ru(vi, 25), us = Pn + ds + Jg(vi, Fi, Gi) + Xg[Zi] + nf[Zi] | 0, $n = (Ru(Or, 2) ^ Ru(Or, 13) ^ Ru(Or, 22)) + Yg(Or, Zr, ni) | 0;
        Pn = Gi, Gi = Fi, Fi = vi, vi = gi + us | 0, gi = ni, ni = Zr, Zr = Or, Or = us + $n | 0;
      }
      Or = Or + this.A | 0, Zr = Zr + this.B | 0, ni = ni + this.C | 0, gi = gi + this.D | 0, vi = vi + this.E | 0, Fi = Fi + this.F | 0, Gi = Gi + this.G | 0, Pn = Pn + this.H | 0, this.set(Or, Zr, ni, gi, vi, Fi, Gi, Pn);
    }
    roundClean() {
      nf.fill(0);
    }
    destroy() {
      this.set(0, 0, 0, 0, 0, 0, 0, 0), this.buffer.fill(0);
    }
  }
  class Ch extends al {
    constructor() {
      super(), this.A = -1056596264, this.B = 914150663, this.C = 812702999, this.D = -150054599, this.E = -4191439, this.F = 1750603025, this.G = 1694076839, this.H = -1090891868, this.outputLen = 28;
    }
  }
  const vc = Sf(() => new al());
  Sf(() => new Ch());
  const Cc = BigInt(2 ** 32 - 1), cd = BigInt(32);
  function ld(rr, ft = !1) {
    return ft ? { h: Number(rr & Cc), l: Number(rr >> cd & Cc) } : { h: Number(rr >> cd & Cc) | 0, l: Number(rr & Cc) | 0 };
  }
  function _g(rr, ft = !1) {
    let dr = new Uint32Array(rr.length), Or = new Uint32Array(rr.length);
    for (let Zr = 0; Zr < rr.length; Zr++) {
      const { h: ni, l: gi } = ld(rr[Zr], ft);
      [dr[Zr], Or[Zr]] = [ni, gi];
    }
    return [dr, Or];
  }
  const Zg = (rr, ft) => BigInt(rr >>> 0) << cd | BigInt(ft >>> 0), Bo = (rr, ft, dr) => rr >>> dr, $g = (rr, ft, dr) => rr << 32 - dr | ft >>> dr, kh = (rr, ft, dr) => rr >>> dr | ft << 32 - dr, dd = (rr, ft, dr) => rr << 32 - dr | ft >>> dr, ep = (rr, ft, dr) => rr << 64 - dr | ft >>> dr - 32, hd = (rr, ft, dr) => rr >>> dr - 32 | ft << 64 - dr, fu = (rr, ft) => ft, ul = (rr, ft) => rr, tp = (rr, ft, dr) => rr << dr | ft >>> 32 - dr, Lf = (rr, ft, dr) => ft << dr | rr >>> 32 - dr, Ad = (rr, ft, dr) => ft << dr - 32 | rr >>> 64 - dr, rp = (rr, ft, dr) => rr << dr - 32 | ft >>> 64 - dr;
  function Sh(rr, ft, dr, Or) {
    const Zr = (ft >>> 0) + (Or >>> 0);
    return { h: rr + dr + (Zr / 2 ** 32 | 0) | 0, l: Zr | 0 };
  }
  var Co = {
    fromBig: ld,
    split: _g,
    toBig: Zg,
    shrSH: Bo,
    shrSL: $g,
    rotrSH: kh,
    rotrSL: dd,
    rotrBH: ep,
    rotrBL: hd,
    rotr32H: fu,
    rotr32L: ul,
    rotlSH: tp,
    rotlSL: Lf,
    rotlBH: Ad,
    rotlBL: rp,
    add: Sh,
    add3L: (rr, ft, dr) => (rr >>> 0) + (ft >>> 0) + (dr >>> 0),
    add3H: (rr, ft, dr, Or) => ft + dr + Or + (rr / 2 ** 32 | 0) | 0,
    add4L: (rr, ft, dr, Or) => (rr >>> 0) + (ft >>> 0) + (dr >>> 0) + (Or >>> 0),
    add4H: (rr, ft, dr, Or, Zr) => ft + dr + Or + Zr + (rr / 2 ** 32 | 0) | 0,
    add5H: (rr, ft, dr, Or, Zr, ni) => ft + dr + Or + Zr + ni + (rr / 2 ** 32 | 0) | 0,
    add5L: (rr, ft, dr, Or, Zr) => (rr >>> 0) + (ft >>> 0) + (dr >>> 0) + (Or >>> 0) + (Zr >>> 0)
  };
  const [ip, Hf] = Co.split([
    "0x428a2f98d728ae22",
    "0x7137449123ef65cd",
    "0xb5c0fbcfec4d3b2f",
    "0xe9b5dba58189dbbc",
    "0x3956c25bf348b538",
    "0x59f111f1b605d019",
    "0x923f82a4af194f9b",
    "0xab1c5ed5da6d8118",
    "0xd807aa98a3030242",
    "0x12835b0145706fbe",
    "0x243185be4ee4b28c",
    "0x550c7dc3d5ffb4e2",
    "0x72be5d74f27b896f",
    "0x80deb1fe3b1696b1",
    "0x9bdc06a725c71235",
    "0xc19bf174cf692694",
    "0xe49b69c19ef14ad2",
    "0xefbe4786384f25e3",
    "0x0fc19dc68b8cd5b5",
    "0x240ca1cc77ac9c65",
    "0x2de92c6f592b0275",
    "0x4a7484aa6ea6e483",
    "0x5cb0a9dcbd41fbd4",
    "0x76f988da831153b5",
    "0x983e5152ee66dfab",
    "0xa831c66d2db43210",
    "0xb00327c898fb213f",
    "0xbf597fc7beef0ee4",
    "0xc6e00bf33da88fc2",
    "0xd5a79147930aa725",
    "0x06ca6351e003826f",
    "0x142929670a0e6e70",
    "0x27b70a8546d22ffc",
    "0x2e1b21385c26c926",
    "0x4d2c6dfc5ac42aed",
    "0x53380d139d95b3df",
    "0x650a73548baf63de",
    "0x766a0abb3c77b2a8",
    "0x81c2c92e47edaee6",
    "0x92722c851482353b",
    "0xa2bfe8a14cf10364",
    "0xa81a664bbc423001",
    "0xc24b8b70d0f89791",
    "0xc76c51a30654be30",
    "0xd192e819d6ef5218",
    "0xd69906245565a910",
    "0xf40e35855771202a",
    "0x106aa07032bbd1b8",
    "0x19a4c116b8d2d0c8",
    "0x1e376c085141ab53",
    "0x2748774cdf8eeb99",
    "0x34b0bcb5e19b48a8",
    "0x391c0cb3c5c95a63",
    "0x4ed8aa4ae3418acb",
    "0x5b9cca4f7763e373",
    "0x682e6ff3d6b2b8a3",
    "0x748f82ee5defb2fc",
    "0x78a5636f43172f60",
    "0x84c87814a1f0ab72",
    "0x8cc702081a6439ec",
    "0x90befffa23631e28",
    "0xa4506cebde82bde9",
    "0xbef9a3f7b2c67915",
    "0xc67178f2e372532b",
    "0xca273eceea26619c",
    "0xd186b8c721c0c207",
    "0xeada7dd6cde0eb1e",
    "0xf57d4f7fee6ed178",
    "0x06f067aa72176fba",
    "0x0a637dc5a2c898a6",
    "0x113f9804bef90dae",
    "0x1b710b35131c471b",
    "0x28db77f523047d84",
    "0x32caab7b40c72493",
    "0x3c9ebe0a15c9bebc",
    "0x431d67c49c100d4c",
    "0x4cc5d4becb3e42b6",
    "0x597f299cfc657e2a",
    "0x5fcb6fab3ad6faec",
    "0x6c44198c4a475817"
  ].map((rr) => BigInt(rr))), sf = new Uint32Array(80), Ys = new Uint32Array(80);
  class Sc extends Ff {
    constructor() {
      super(128, 64, 16, !1), this.Ah = 1779033703, this.Al = -205731576, this.Bh = -1150833019, this.Bl = -2067093701, this.Ch = 1013904242, this.Cl = -23791573, this.Dh = -1521486534, this.Dl = 1595750129, this.Eh = 1359893119, this.El = -1377402159, this.Fh = -1694144372, this.Fl = 725511199, this.Gh = 528734635, this.Gl = -79577749, this.Hh = 1541459225, this.Hl = 327033209;
    }
    // prettier-ignore
    get() {
      const { Ah: ft, Al: dr, Bh: Or, Bl: Zr, Ch: ni, Cl: gi, Dh: vi, Dl: Fi, Eh: Gi, El: Pn, Fh: Zi, Fl: ds, Gh: us, Gl: Is, Hh: $n, Hl: As } = this;
      return [ft, dr, Or, Zr, ni, gi, vi, Fi, Gi, Pn, Zi, ds, us, Is, $n, As];
    }
    // prettier-ignore
    set(ft, dr, Or, Zr, ni, gi, vi, Fi, Gi, Pn, Zi, ds, us, Is, $n, As) {
      this.Ah = ft | 0, this.Al = dr | 0, this.Bh = Or | 0, this.Bl = Zr | 0, this.Ch = ni | 0, this.Cl = gi | 0, this.Dh = vi | 0, this.Dl = Fi | 0, this.Eh = Gi | 0, this.El = Pn | 0, this.Fh = Zi | 0, this.Fl = ds | 0, this.Gh = us | 0, this.Gl = Is | 0, this.Hh = $n | 0, this.Hl = As | 0;
    }
    process(ft, dr) {
      for (let Ts = 0; Ts < 16; Ts++, dr += 4)
        sf[Ts] = ft.getUint32(dr), Ys[Ts] = ft.getUint32(dr += 4);
      for (let Ts = 16; Ts < 80; Ts++) {
        const oo = sf[Ts - 15] | 0, Ws = Ys[Ts - 15] | 0, Ks = Co.rotrSH(oo, Ws, 1) ^ Co.rotrSH(oo, Ws, 8) ^ Co.shrSH(oo, Ws, 7), Js = Co.rotrSL(oo, Ws, 1) ^ Co.rotrSL(oo, Ws, 8) ^ Co.shrSL(oo, Ws, 7), io = sf[Ts - 2] | 0, na = Ys[Ts - 2] | 0, Xo = Co.rotrSH(io, na, 19) ^ Co.rotrBH(io, na, 61) ^ Co.shrSH(io, na, 6), Go = Co.rotrSL(io, na, 19) ^ Co.rotrBL(io, na, 61) ^ Co.shrSL(io, na, 6), Ta = Co.add4L(Js, Go, Ys[Ts - 7], Ys[Ts - 16]), Pa = Co.add4H(Ta, Ks, Xo, sf[Ts - 7], sf[Ts - 16]);
        sf[Ts] = Pa | 0, Ys[Ts] = Ta | 0;
      }
      let { Ah: Or, Al: Zr, Bh: ni, Bl: gi, Ch: vi, Cl: Fi, Dh: Gi, Dl: Pn, Eh: Zi, El: ds, Fh: us, Fl: Is, Gh: $n, Gl: As, Hh: ms, Hl: Ns } = this;
      for (let Ts = 0; Ts < 80; Ts++) {
        const oo = Co.rotrSH(Zi, ds, 14) ^ Co.rotrSH(Zi, ds, 18) ^ Co.rotrBH(Zi, ds, 41), Ws = Co.rotrSL(Zi, ds, 14) ^ Co.rotrSL(Zi, ds, 18) ^ Co.rotrBL(Zi, ds, 41), Ks = Zi & us ^ ~Zi & $n, Js = ds & Is ^ ~ds & As, io = Co.add5L(Ns, Ws, Js, Hf[Ts], Ys[Ts]), na = Co.add5H(io, ms, oo, Ks, ip[Ts], sf[Ts]), Xo = io | 0, Go = Co.rotrSH(Or, Zr, 28) ^ Co.rotrBH(Or, Zr, 34) ^ Co.rotrBH(Or, Zr, 39), Ta = Co.rotrSL(Or, Zr, 28) ^ Co.rotrBL(Or, Zr, 34) ^ Co.rotrBL(Or, Zr, 39), Pa = Or & ni ^ Or & vi ^ ni & vi, Mu = Zr & gi ^ Zr & Fi ^ gi & Fi;
        ms = $n | 0, Ns = As | 0, $n = us | 0, As = Is | 0, us = Zi | 0, Is = ds | 0, { h: Zi, l: ds } = Co.add(Gi | 0, Pn | 0, na | 0, Xo | 0), Gi = vi | 0, Pn = Fi | 0, vi = ni | 0, Fi = gi | 0, ni = Or | 0, gi = Zr | 0;
        const qs = Co.add3L(Xo, Ta, Mu);
        Or = Co.add3H(qs, na, Go, Pa), Zr = qs | 0;
      }
      ({ h: Or, l: Zr } = Co.add(this.Ah | 0, this.Al | 0, Or | 0, Zr | 0)), { h: ni, l: gi } = Co.add(this.Bh | 0, this.Bl | 0, ni | 0, gi | 0), { h: vi, l: Fi } = Co.add(this.Ch | 0, this.Cl | 0, vi | 0, Fi | 0), { h: Gi, l: Pn } = Co.add(this.Dh | 0, this.Dl | 0, Gi | 0, Pn | 0), { h: Zi, l: ds } = Co.add(this.Eh | 0, this.El | 0, Zi | 0, ds | 0), { h: us, l: Is } = Co.add(this.Fh | 0, this.Fl | 0, us | 0, Is | 0), { h: $n, l: As } = Co.add(this.Gh | 0, this.Gl | 0, $n | 0, As | 0), { h: ms, l: Ns } = Co.add(this.Hh | 0, this.Hl | 0, ms | 0, Ns | 0), this.set(Or, Zr, ni, gi, vi, Fi, Gi, Pn, Zi, ds, us, Is, $n, As, ms, Ns);
    }
    roundClean() {
      sf.fill(0), Ys.fill(0);
    }
    destroy() {
      this.buffer.fill(0), this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
    }
  }
  class gd extends Sc {
    constructor() {
      super(), this.Ah = -1942145080, this.Al = 424955298, this.Bh = 1944164710, this.Bl = -1982016298, this.Ch = 502970286, this.Cl = 855612546, this.Dh = 1738396948, this.Dl = 1479516111, this.Eh = 258812777, this.El = 2077511080, this.Fh = 2011393907, this.Fl = 79989058, this.Gh = 1067287976, this.Gl = 1780299464, this.Hh = 286451373, this.Hl = -1848208735, this.outputLen = 28;
    }
  }
  class pd extends Sc {
    constructor() {
      super(), this.Ah = 573645204, this.Al = -64227540, this.Bh = -1621794909, this.Bl = -934517566, this.Ch = 596883563, this.Cl = 1867755857, this.Dh = -1774684391, this.Dl = 1497426621, this.Eh = -1775747358, this.El = -1467023389, this.Fh = -1101128155, this.Fl = 1401305490, this.Gh = 721525244, this.Gl = 746961066, this.Hh = 246885852, this.Hl = -2117784414, this.outputLen = 32;
    }
  }
  class Th extends Sc {
    constructor() {
      super(), this.Ah = -876896931, this.Al = -1056596264, this.Bh = 1654270250, this.Bl = 914150663, this.Ch = -1856437926, this.Cl = 812702999, this.Dh = 355462360, this.Dl = -150054599, this.Eh = 1731405415, this.El = -4191439, this.Fh = -1900787065, this.Fl = 1750603025, this.Gh = -619958771, this.Gl = 1694076839, this.Hh = 1203062813, this.Hl = -1090891868, this.outputLen = 48;
    }
  }
  const Du = Sf(() => new Sc());
  Sf(() => new gd()), Sf(() => new pd()), Sf(() => new Th());
  const pu = new Uint8Array([7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8]), nu = Uint8Array.from({ length: 16 }, (rr, ft) => ft), yd = nu.map((rr) => (9 * rr + 5) % 16);
  let ko = [nu], fl = [yd];
  for (let rr = 0; rr < 4; rr++)
    for (let ft of [ko, fl])
      ft.push(ft[rr].map((dr) => pu[dr]));
  const md = [
    [11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8],
    [12, 13, 11, 15, 6, 9, 9, 7, 12, 15, 11, 13, 7, 8, 7, 7],
    [13, 15, 14, 11, 7, 7, 6, 8, 13, 14, 13, 12, 5, 5, 6, 9],
    [14, 11, 12, 14, 8, 6, 5, 5, 15, 12, 15, 14, 9, 9, 8, 6],
    [15, 12, 13, 13, 9, 5, 8, 6, 14, 11, 12, 11, 8, 6, 5, 5]
  ].map((rr) => new Uint8Array(rr)), Br = ko.map((rr, ft) => rr.map((dr) => md[ft][dr])), Kf = fl.map((rr, ft) => rr.map((dr) => md[ft][dr])), Vf = new Uint32Array([0, 1518500249, 1859775393, 2400959708, 2840853838]), of = new Uint32Array([1352829926, 1548603684, 1836072691, 2053994217, 0]), cl = (rr, ft) => rr << ft | rr >>> 32 - ft;
  function Rh(rr, ft, dr, Or) {
    return rr === 0 ? ft ^ dr ^ Or : rr === 1 ? ft & dr | ~ft & Or : rr === 2 ? (ft | ~dr) ^ Or : rr === 3 ? ft & Or | dr & ~Or : ft ^ (dr | ~Or);
  }
  const ll = new Uint32Array(16);
  class np extends Ff {
    constructor() {
      super(64, 20, 8, !0), this.h0 = 1732584193, this.h1 = -271733879, this.h2 = -1732584194, this.h3 = 271733878, this.h4 = -1009589776;
    }
    get() {
      const { h0: ft, h1: dr, h2: Or, h3: Zr, h4: ni } = this;
      return [ft, dr, Or, Zr, ni];
    }
    set(ft, dr, Or, Zr, ni) {
      this.h0 = ft | 0, this.h1 = dr | 0, this.h2 = Or | 0, this.h3 = Zr | 0, this.h4 = ni | 0;
    }
    process(ft, dr) {
      for (let us = 0; us < 16; us++, dr += 4)
        ll[us] = ft.getUint32(dr, !0);
      let Or = this.h0 | 0, Zr = Or, ni = this.h1 | 0, gi = ni, vi = this.h2 | 0, Fi = vi, Gi = this.h3 | 0, Pn = Gi, Zi = this.h4 | 0, ds = Zi;
      for (let us = 0; us < 5; us++) {
        const Is = 4 - us, $n = Vf[us], As = of[us], ms = ko[us], Ns = fl[us], Ts = Br[us], oo = Kf[us];
        for (let Ws = 0; Ws < 16; Ws++) {
          const Ks = cl(Or + Rh(us, ni, vi, Gi) + ll[ms[Ws]] + $n, Ts[Ws]) + Zi | 0;
          Or = Zi, Zi = Gi, Gi = cl(vi, 10) | 0, vi = ni, ni = Ks;
        }
        for (let Ws = 0; Ws < 16; Ws++) {
          const Ks = cl(Zr + Rh(Is, gi, Fi, Pn) + ll[Ns[Ws]] + As, oo[Ws]) + ds | 0;
          Zr = ds, ds = Pn, Pn = cl(Fi, 10) | 0, Fi = gi, gi = Ks;
        }
      }
      this.set(this.h1 + vi + Pn | 0, this.h2 + Gi + ds | 0, this.h3 + Zi + Zr | 0, this.h4 + Or + gi | 0, this.h0 + ni + Fi | 0);
    }
    roundClean() {
      ll.fill(0);
    }
    destroy() {
      this.destroyed = !0, this.buffer.fill(0), this.set(0, 0, 0, 0, 0);
    }
  }
  const sp = Sf(() => new np());
  class xh extends ol {
    constructor(ft, dr) {
      super(), this.finished = !1, this.destroyed = !1, kf.hash(ft);
      const Or = Bc(dr);
      if (this.iHash = ft.create(), typeof this.iHash.update != "function")
        throw new Error("Expected instance of class which extends utils.Hash");
      this.blockLen = this.iHash.blockLen, this.outputLen = this.iHash.outputLen;
      const Zr = this.blockLen, ni = new Uint8Array(Zr);
      ni.set(Or.length > Zr ? ft.create().update(Or).digest() : Or);
      for (let gi = 0; gi < ni.length; gi++)
        ni[gi] ^= 54;
      this.iHash.update(ni), this.oHash = ft.create();
      for (let gi = 0; gi < ni.length; gi++)
        ni[gi] ^= 106;
      this.oHash.update(ni), ni.fill(0);
    }
    update(ft) {
      return kf.exists(this), this.iHash.update(ft), this;
    }
    digestInto(ft) {
      kf.exists(this), kf.bytes(ft, this.outputLen), this.finished = !0, this.iHash.digestInto(ft), this.oHash.update(ft), this.oHash.digestInto(ft), this.destroy();
    }
    digest() {
      const ft = new Uint8Array(this.oHash.outputLen);
      return this.digestInto(ft), ft;
    }
    _cloneInto(ft) {
      ft || (ft = Object.create(Object.getPrototypeOf(this), {}));
      const { oHash: dr, iHash: Or, finished: Zr, destroyed: ni, blockLen: gi, outputLen: vi } = this;
      return ft = ft, ft.finished = Zr, ft.destroyed = ni, ft.blockLen = gi, ft.outputLen = vi, ft.oHash = dr._cloneInto(ft.oHash), ft.iHash = Or._cloneInto(ft.iHash), ft;
    }
    destroy() {
      this.destroyed = !0, this.oHash.destroy(), this.iHash.destroy();
    }
  }
  const yu = (rr, ft, dr) => new xh(rr, ft).update(dr).digest();
  yu.create = (rr, ft) => new xh(rr, ft);
  function dl(rr) {
    const ft = lo.bytes(rr);
    return lo.raw(vc(ft));
  }
  function zu(rr) {
    const ft = lo.bytes(rr);
    return lo.raw(vc(vc(ft)));
  }
  function hl(rr) {
    const ft = lo.bytes(rr);
    return lo.raw(sp(vc(ft)));
  }
  function op(rr, ft) {
    const dr = lo.bytes(rr), Or = lo.bytes(ft);
    return lo.raw(yu(Du, dr, Or));
  }
  function ap(rr) {
    const ft = lo.str(rr).digest;
    return lo.join([ft, ft]);
  }
  function up(rr = 32) {
    return Ju(sd(rr));
  }
  function Ju(rr) {
    return Da.mod(rr).buff;
  }
  function Dh(rr, ft = !1) {
    const dr = Da.mod(rr).point;
    return ft ? dr.x : dr.buff;
  }
  function Nh(rr, ft) {
    const dr = Tu.from_x(ft), Or = Da.mod(rr);
    return dr.mul(Or).buff;
  }
  function cu(rr, ft, dr = "ecdh/code") {
    const Or = ap(dr), Zr = Ju(rr), ni = Dh(Zr), gi = lo.bytes(ft), vi = Nh(Zr, gi), Fi = [ni.hex, gi.hex];
    return Fi.sort(), op(vi, lo.join([Or, ...Fi]));
  }
  function fp(rr) {
    const ft = lo.bytes(rr);
    switch (!0) {
      case ft.length === 32:
        return !0;
      case (ft.length === 33 && ft[0] === 2):
        return !0;
      case (ft.length === 33 && ft[0] === 3):
        return !1;
      default:
        throw new TypeError(`Invalid public key: ${ft.hex}`);
    }
  }
  function Ph(rr) {
    const ft = lo.bytes(rr);
    switch (ft.length) {
      case 32:
        return ft;
      case 33:
        return ft.slice(1, 33);
      default:
        throw new Error(`Invalid key length: ${ft.length}`);
    }
  }
  var wd = /* @__PURE__ */ Object.freeze({
    __proto__: null,
    genSecretKey: up,
    getPublicKey: Dh,
    getSecretKey: Ju,
    getSharedCode: cu,
    getSharedKey: Nh,
    is_even_pub: fp,
    xonly_pub: Ph
  });
  lo.random(32);
  const Tc = { secp: Gu }, Gf = { ...wd, ...Mg };
  function Yu(rr) {
    const ft = Ai.bytes(rr);
    return Tr(ft, 33), hl(ft);
  }
  function qh(rr) {
    const ft = Nr.fmt.toBytes(rr, !1);
    return hl(ft);
  }
  function Wo(rr) {
    const ft = Nr.fmt.toBytes(rr, !1);
    return dl(ft);
  }
  function Oh(rr, ft = "main") {
    const dr = ft === "main" ? ["1"] : ["m", "n"];
    for (const Or of dr)
      if (rr.startsWith(Or))
        return !0;
    return !1;
  }
  function Qh(rr, ft = "main") {
    const dr = Ai.bytes(rr), Or = ft === "main" ? Ai.num(0) : Ai.num(111);
    return Tr(rr, 20), dr.prepend(Or).tob58chk();
  }
  function cp(rr, ft = "main") {
    if (!Oh(rr, ft))
      throw new TypeError("Invalid p2pkh address!");
    return Ai.b58chk(rr).slice(1);
  }
  function Nu(rr) {
    const ft = Ai.bytes(rr);
    return Tr(ft, 20), ["OP_DUP", "OP_HASH160", ft.hex, "OP_EQUALVERIFY", "OP_CHECKSIG"];
  }
  function lp(rr, ft) {
    const dr = Yu(rr);
    return Qh(dr, ft);
  }
  const Uh = { check: Oh, encode: Qh, decode: cp, hash: Yu, scriptPubKey: Nu, fromPubKey: lp };
  function Mh(rr, ft = "main") {
    const dr = ft === "main" ? ["3"] : ["2"];
    for (const Or of dr)
      if (rr.startsWith(Or))
        return !0;
    return !1;
  }
  function Ed(rr, ft = "main") {
    const dr = ft === "main" ? Ai.num(5) : Ai.num(196), Or = Ai.bytes(rr);
    return Tr(Or, 20), Or.prepend(dr).tob58chk();
  }
  function Tf(rr, ft = "main") {
    if (!Mh(rr, ft))
      throw new TypeError(`Invalid p2sh address for network ${ft}:` + rr);
    return Ai.b58chk(rr).slice(1);
  }
  function Rc(rr) {
    return ["OP_HASH160", Ai.bytes(rr).hex, "OP_EQUAL"];
  }
  function xc(rr, ft) {
    const dr = qh(rr);
    return Ed(dr, ft);
  }
  const Fh = { check: Mh, encode: Ed, decode: Tf, hash: qh, scriptPubKey: Rc, fromScript: xc }, bd = {
    main: "bc",
    testnet: "tb",
    signet: "tb",
    regtest: "bcrt"
  }, dp = ["bc1q", "tb1q", "bcrt1q"];
  function Ea(rr) {
    for (const ft of dp)
      if (rr.startsWith(ft))
        return !0;
    return !1;
  }
  function Lh(rr, ft = "main") {
    const dr = bd[ft], Or = Ai.bytes(rr);
    return Tr(Or, 20), Or.toBech32(dr, 0);
  }
  function hp(rr) {
    if (!Ea(rr))
      throw new TypeError("Invalid segwit address!");
    return Ai.bech32(rr);
  }
  function Ap(rr) {
    const ft = Ai.bytes(rr);
    return Tr(ft, 20), ["OP_0", ft.hex];
  }
  function Hh(rr, ft) {
    const dr = Yu(rr);
    return Lh(dr, ft);
  }
  const Al = { check: Ea, encode: Lh, decode: hp, hash: Yu, scriptPubKey: Ap, fromPubKey: Hh }, gp = ["bc1q", "tb1q", "bcrt1q"];
  function Kh(rr) {
    for (const ft of gp)
      if (rr.startsWith(ft))
        return !0;
    return !1;
  }
  function lu(rr, ft = "main") {
    const dr = bd[ft], Or = Ai.bytes(rr);
    return Tr(Or, 32), Or.toBech32(dr, 0);
  }
  function pp(rr) {
    if (!Kh(rr))
      throw new TypeError("Invalid segwit address!");
    return Ai.bech32(rr);
  }
  function gl(rr) {
    const ft = Ai.bytes(rr);
    return Tr(ft, 32), ["OP_0", ft.hex];
  }
  function Vh(rr, ft) {
    const dr = Wo(rr);
    return lu(dr, ft);
  }
  const Bd = { check: Kh, encode: lu, decode: pp, hash: Wo, scriptPubKey: gl, fromScript: Vh };
  function af(rr) {
    const ft = Ai.bytes(rr);
    return ft.length > 32 ? ft.slice(1, 33) : ft;
  }
  const yp = ["bc1p", "tb1p", "bcrt1p"];
  function Dc(rr) {
    for (const ft of yp)
      if (rr.startsWith(ft))
        return !0;
    return !1;
  }
  function jf(rr, ft = "main") {
    const dr = bd[ft], Or = Ai.bytes(rr);
    return Tr(Or, 32), Or.toBech32(dr, 1);
  }
  function Ip(rr) {
    if (!Dc(rr))
      throw new TypeError("Invalid taproot address!");
    return Ai.bech32(rr);
  }
  function mp(rr) {
    const ft = Ai.bytes(rr);
    return Tr(ft, 32), ["OP_1", ft.hex];
  }
  function wp(rr, ft) {
    const dr = af(rr);
    return jf(dr, ft);
  }
  const Gh = { check: Dc, encode: jf, decode: Ip, scriptPubKey: mp, fromPubKey: wp }, vd = {
    version: 2,
    vin: [],
    vout: [],
    locktime: 0
  }, Xu = {
    scriptSig: [],
    sequence: 4294967293,
    witness: []
  }, jh = {
    value: 0n,
    scriptPubKey: []
  };
  function Cd(rr) {
    const ft = { ...vd, ...rr };
    return ft.vin = ft.vin.map((dr) => ({ ...Xu, ...dr })), ft.vout = ft.vout.map((dr) => ({ ...jh, ...dr })), ft;
  }
  function Wf(rr, ft) {
    const { version: dr, vin: Or, vout: Zr, locktime: ni } = Cd(rr), gi = ft !== !0 && Wh(Or), vi = [Aa(dr)];
    gi && vi.push(Ai.hex("0001")), vi.push(Ep(Or)), vi.push(Ma(Zr));
    for (const Fi of Or)
      gi && vi.push(Nc(Fi.witness));
    return vi.push(kd(ni)), Ai.join(vi);
  }
  function Wh(rr) {
    for (const ft of rr) {
      const { witness: dr } = ft;
      if (typeof dr == "string" || dr instanceof Uint8Array || Array.isArray(dr) && dr.length > 0)
        return !0;
    }
    return !1;
  }
  function Aa(rr) {
    return Ai.num(rr, 4).reverse();
  }
  function zf(rr) {
    return Ai.hex(rr, 32).reverse();
  }
  function Rf(rr) {
    return Ai.num(rr, 4).reverse();
  }
  function Vo(rr) {
    if (typeof rr == "string")
      return Ai.hex(rr, 4).reverse();
    if (typeof rr == "number")
      return Ai.num(rr, 4).reverse();
    throw new Error("Unrecognized format: " + String(rr));
  }
  function Ep(rr) {
    const ft = [Ai.varInt(rr.length, "le")];
    for (const dr of rr) {
      const { txid: Or, vout: Zr, scriptSig: ni, sequence: gi } = dr;
      ft.push(zf(Or)), ft.push(Rf(Zr)), ft.push(K(ni, !0)), ft.push(Vo(gi));
    }
    return Ai.join(ft);
  }
  function uf(rr) {
    if (typeof rr == "number") {
      if (rr % 1 !== 0)
        throw new Error("Value must be an integer:" + String(rr));
      return Ai.num(rr, 8).reverse();
    }
    return Ai.big(rr, 8).reverse();
  }
  function Ma(rr) {
    const ft = [Ai.varInt(rr.length, "le")];
    for (const dr of rr)
      ft.push(ka(dr));
    return Ai.join(ft);
  }
  function ka(rr) {
    const { value: ft, scriptPubKey: dr } = rr, Or = [];
    return Or.push(uf(ft)), Or.push(K(dr, !0)), Ai.join(Or);
  }
  function Nc(rr = []) {
    const ft = [];
    if (Array.isArray(rr)) {
      const dr = Ai.varInt(rr.length);
      ft.push(dr);
      for (const Or of rr)
        ft.push(pl(Or));
      return Ai.join(ft);
    } else
      return Ai.bytes(rr);
  }
  function pl(rr) {
    return zh(rr) ? new Ai(0) : K(rr, !0);
  }
  function zh(rr) {
    if (Array.isArray(rr))
      return rr.length === 0;
    if (typeof rr == "string" && rr === "")
      return !0;
    const ft = Ai.bytes(rr);
    return ft.length === 1 && ft[0] === 0;
  }
  function kd(rr) {
    if (typeof rr == "string")
      return Ai.hex(rr, 4);
    if (typeof rr == "number")
      return Ai.num(rr, 4).reverse();
    throw new Error("Unrecognized format: " + String(rr));
  }
  function Sd(rr) {
    typeof rr == "string" && (rr = Ai.hex(rr).raw);
    const ft = new ri(rr), dr = Td(ft), Or = ba(ft), Zr = bp(ft), ni = Jh(ft);
    if (Or)
      for (const vi of Zr)
        vi.witness = vp(ft);
    const gi = Rd(ft);
    return { version: dr, vin: Zr, vout: ni, locktime: gi };
  }
  function Td(rr) {
    return rr.read(4).reverse().toNum();
  }
  function ba(rr) {
    const [ft, dr] = [...rr.peek(2)];
    if (ft === 0) {
      if (rr.read(2), dr === 1)
        return !0;
      throw new Error(`Invalid witness flag: ${dr}`);
    }
    return !1;
  }
  function bp(rr) {
    const ft = [], dr = rr.readSize("le");
    for (let Or = 0; Or < dr; Or++)
      ft.push(Bp(rr));
    return ft;
  }
  function Bp(rr) {
    return {
      txid: rr.read(32).reverse().toHex(),
      vout: rr.read(4).reverse().toNum(),
      scriptSig: Pc(rr),
      sequence: rr.read(4).reverse().toHex(),
      witness: []
    };
  }
  function Jh(rr) {
    const ft = [], dr = rr.readSize("le");
    for (let Or = 0; Or < dr; Or++)
      ft.push(Yh(rr));
    return ft;
  }
  function Yh(rr) {
    return {
      value: rr.read(8).reverse().big,
      scriptPubKey: Pc(rr)
    };
  }
  function vp(rr) {
    const ft = [], dr = rr.readSize();
    for (let Or = 0; Or < dr; Or++) {
      const Zr = Xh(rr);
      ft.push(Zr ?? "");
    }
    return ft;
  }
  function Xh(rr, ft) {
    const dr = rr.readSize("le");
    return dr > 0 ? rr.read(dr).hex : null;
  }
  function Pc(rr, ft) {
    const dr = Xh(rr);
    return dr !== null ? dr : [];
  }
  function Rd(rr) {
    return rr.read(4).reverse().toNum();
  }
  function Cp(rr) {
    if (b(rr))
      return Sd(rr);
    if (typeof rr == "object" && !(rr instanceof Uint8Array))
      return Wf(rr), Cd(rr);
    throw new Error("Invalid format: " + typeof rr);
  }
  function _h(rr) {
    if (b(rr))
      return Sd(rr), Ai.bytes(rr);
    if (typeof rr == "object")
      return Wf(rr);
    throw new Error("Invalid format: " + typeof rr);
  }
  const xd = {
    toBytes: _h,
    toJson: Cp
  }, yl = [
    ["p2pkh", /^76a914(?<hash>\w{40})88ac$/],
    ["p2sh", /^a914(?<hash>\w{40})87$/],
    ["p2w-pkh", /^0014(?<hash>\w{40})$/],
    ["p2w-sh", /^0020(?<hash>\w{64})$/],
    ["p2tr", /^5120(?<hash>\w{64})$/]
  ], Zh = [
    192,
    194,
    196,
    198,
    200,
    202,
    204,
    206,
    208,
    210,
    212,
    214,
    216,
    218,
    220,
    222,
    224,
    226,
    228,
    230,
    232,
    234,
    236,
    238,
    240,
    242,
    244,
    246,
    248,
    250,
    252,
    254,
    102,
    126,
    128,
    132,
    150,
    152,
    186,
    188,
    190
  ];
  function kp(rr) {
    let ft = rr.at(-1);
    return a(ft) && (ft = Ai.hex(ft)), rr.length > 1 && ft instanceof Uint8Array && ft[0] === 80 ? (rr.pop(), Ai.raw(ft)) : null;
  }
  function Sp(rr) {
    let ft = rr.at(-1);
    return a(ft) && (ft = Ai.hex(ft)), rr.length > 1 && ft instanceof Uint8Array && ft.length > 32 && Zh.includes(ft[0] & 254) ? (rr.pop(), Ai.raw(ft)) : null;
  }
  function Dd(rr) {
    if (rr.length > 1) {
      const ft = rr.at(-1);
      try {
        const dr = Nr.fmt.toBytes(ft);
        return rr.pop(), dr;
      } catch {
        return null;
      }
    }
    return null;
  }
  function Tp(rr) {
    const ft = [];
    for (const dr of rr)
      if (a(dr) || dr instanceof Uint8Array || typeof dr == "number")
        ft.push(Ai.bytes(dr));
      else
        throw new Error("unrecognized value: " + String(dr));
    return ft;
  }
  function $h(rr = []) {
    const ft = [...rr], dr = kp(ft), Or = Sp(ft), Zr = Dd(ft), ni = Tp(ft);
    return { annex: dr, cblock: Or, script: Zr, params: ni };
  }
  function Nd(rr) {
    const ft = Nr.fmt.toBytes(rr, !1).hex;
    for (const [dr, Or] of yl) {
      const Zr = dr, { groups: ni } = Or.exec(ft) ?? {}, { hash: gi } = ni ?? {};
      if (a(gi))
        return { type: Zr, data: Ai.hex(gi) };
    }
    return { type: "raw", data: Ai.hex(ft) };
  }
  function Il(rr) {
    const ft = xd.toJson(rr), dr = Wf(ft, !0);
    return zu(dr).reverse().hex;
  }
  function So(rr) {
    const ft = xd.toJson(rr), dr = Wf(ft, !0).length, Or = Wf(ft, !1).length, Zr = dr * 3 + Or, ni = Zr % 4 > 0 ? 1 : 0, gi = Math.floor(Zr / 4) + ni;
    return { size: Or, bsize: dr, vsize: gi, weight: Zr };
  }
  const Ja = {
    create: Cd,
    encode: Wf,
    decode: Sd,
    fmt: xd,
    util: {
      getTxSize: So,
      getTxid: Il,
      readScriptPubKey: Nd,
      readWitness: $h
    }
  }, Rp = [
    ["1", "p2pkh", "main", 20, "base58"],
    ["3", "p2sh", "main", 20, "base58"],
    ["m", "p2pkh", "testnet", 20, "base58"],
    ["n", "p2pkh", "testnet", 20, "base58"],
    ["2", "p2sh", "testnet", 20, "base58"],
    ["bc1q", "p2w-pkh", "main", 20, "bech32"],
    ["tb1q", "p2w-pkh", "testnet", 20, "bech32"],
    ["bcrt1q", "p2w-pkh", "regtest", 20, "bech32"],
    ["bc1q", "p2w-sh", "main", 32, "bech32"],
    ["tb1q", "p2w-sh", "testnet", 32, "bech32"],
    ["bcrt1q", "p2w-sh", "regtest", 32, "bech32"],
    ["bc1p", "p2tr", "main", 32, "bech32m"],
    ["tb1p", "p2tr", "testnet", 32, "bech32m"],
    ["bcrt1p", "p2tr", "regtest", 32, "bech32m"]
  ];
  function xp(rr, ft) {
    switch (ft) {
      case "base58":
        return Ai.b58chk(rr).slice(1);
      case "bech32":
        return Ai.bech32(rr);
      case "bech32m":
        return Ai.bech32(rr);
      default:
        throw new Error("Invalid address format: " + ft);
    }
  }
  function Dp(rr) {
    for (const ft of Rp) {
      const [dr, Or, Zr, ni, gi] = ft;
      if (rr.startsWith(dr) && xp(rr, gi).length === ni)
        return ft;
    }
    throw new Error("Invalid address: " + rr);
  }
  function xf(rr) {
    switch (rr) {
      case "p2pkh":
        return Uh;
      case "p2sh":
        return Fh;
      case "p2w-pkh":
        return Al;
      case "p2w-sh":
        return Bd;
      case "p2tr":
        return Gh;
      default:
        throw new Error("Invalid address type: " + rr);
    }
  }
  function Iu(rr) {
    const [ft, dr, Or] = Dp(rr), Zr = xf(dr), ni = Zr.decode(rr, Or), gi = Zr.scriptPubKey(ni);
    return { prefix: ft, type: dr, network: Or, data: ni, script: gi };
  }
  function Np(rr, ft) {
    const { type: dr, data: Or } = Ja.util.readScriptPubKey(rr);
    return xf(dr).encode(Or, ft);
  }
  function Pd(rr) {
    const { script: ft } = Iu(rr);
    return Nr.fmt.toAsm(ft, !1);
  }
  const ml = {
    p2pkh: Uh,
    p2sh: Fh,
    p2wpkh: Al,
    p2wsh: Bd,
    p2tr: Gh,
    decode: Iu,
    fromScriptPubKey: Np,
    toScriptPubKey: Pd
  }, Pp = [1, 2, 3];
  function Pu(rr, ft, dr = {}) {
    const { sigflag: Or = 1 } = dr, Zr = (Or & 128) === 128, ni = Or % 128;
    if (!Pp.includes(ni))
      throw new Error("Invalid hash type: " + String(Or));
    const gi = Ja.fmt.toJson(rr), { version: vi, vin: Fi, vout: Gi, locktime: Pn } = gi, { txid: Zi, vout: ds, prevout: us, sequence: Is } = Fi[ft], { value: $n } = us ?? {};
    if ($n === void 0)
      throw new Error("Prevout value is empty!");
    let As = dr.script;
    if (As === void 0 && dr.pubkey !== void 0 && (As = `76a914${hl(dr.pubkey).hex}88ac`), As === void 0)
      throw new Error("No pubkey / script has been set!");
    if (Nr.fmt.toAsm(As).includes("OP_CODESEPARATOR"))
      throw new Error("This library does not currently support the use of OP_CODESEPARATOR in segwit scripts.");
    const ms = [
      Aa(vi),
      wl(Fi, Zr),
      qp(Fi, ni, Zr),
      zf(Zi),
      Rf(ds),
      Nr.encode(As, !0),
      uf($n),
      Vo(Is),
      Op(Gi, ft, ni),
      kd(Pn),
      Ai.num(Or, 4).reverse()
    ];
    return zu(Ai.join(ms));
  }
  function wl(rr, ft) {
    if (ft === !0)
      return Ai.num(0, 32);
    const dr = [];
    for (const { txid: Or, vout: Zr } of rr)
      dr.push(zf(Or)), dr.push(Rf(Zr));
    return zu(Ai.join(dr));
  }
  function qp(rr, ft, dr) {
    if (dr || ft !== 1)
      return Ai.num(0, 32);
    const Or = [];
    for (const { sequence: Zr } of rr)
      Or.push(Vo(Zr));
    return zu(Ai.join(Or));
  }
  function Op(rr, ft, dr) {
    const Or = [];
    if (dr === 1) {
      for (const { value: Zr, scriptPubKey: ni } of rr)
        Or.push(uf(Zr)), Or.push(Nr.encode(ni, !0));
      return zu(Ai.join(Or));
    }
    if (dr === 3 && ft < rr.length) {
      const { value: Zr, scriptPubKey: ni } = rr[ft];
      return Or.push(uf(Zr)), Or.push(Nr.encode(ni, !0)), zu(Ai.join(Or));
    }
    return Ai.num(0, 32);
  }
  function Qp(rr, ft, dr, Or = {}) {
    const { sigflag: Zr = 1 } = Or, ni = Pu(ft, dr, Or), gi = Tc.secp.sign(ni, rr).toDERRawBytes(!0);
    return Ai.join([gi, Zr]);
  }
  function Up(rr, ft, dr = {}) {
    const Or = Ja.fmt.toJson(rr), { throws: Zr = !1 } = dr, { witness: ni = [] } = Or.vin[ft], gi = Ja.util.readWitness(ni), { script: vi, params: Fi } = gi;
    let Gi = null;
    if (Fi.length < 1)
      return yi("Invalid witness data: " + String(ni), Zr);
    if (dr.script === void 0 && vi !== null && (dr.script = vi), dr.pubkey !== void 0)
      Gi = Ai.bytes(dr.pubkey);
    else if (Fi.length > 1 && Fi[1].length === 33)
      Gi = Ai.bytes(Fi[1]);
    else
      return yi("No pubkey provided!", Zr);
    const Pn = Nr.fmt.toParam(Fi[0]), Zi = Pn.slice(0, -1), ds = Pn.slice(-1)[0], us = Pu(Or, ft, { ...dr, sigflag: ds });
    return Tc.secp.verify(Zi, us, Gi) ? !0 : yi("Invalid signature!", Zr);
  }
  const Ba = {
    hash: Pu,
    sign: Qp,
    verify: Up
  }, Fa = [0, 1, 2, 3, 129, 130, 131];
  function va(rr, ft, dr = {}) {
    const { extension: Or, sigflag: Zr = 0, extflag: ni = 0, key_version: gi = 0, separator_pos: vi = 4294967295 } = dr, Fi = Ja.fmt.toJson(rr), { version: Gi, vin: Pn, vout: Zi, locktime: ds } = Fi;
    if (ft >= Pn.length)
      throw new Error("Index out of bounds: " + String(ft));
    if (!Fa.includes(Zr))
      throw new Error("Invalid hash type: " + String(Zr));
    if (ni < 0 || ni > 127)
      throw new Error("Extention flag out of range: " + String(ni));
    const { txid: us, vout: Is, sequence: $n, witness: As = [] } = Pn[ft], ms = (Zr & 128) === 128, Ns = Hp(As), Ts = Ns !== void 0 ? 1 : 0, Ws = (ni + (Or !== void 0 ? 1 : 0)) * 2 + Ts, Ks = Ai.str("TapSighash").digest, Js = [
      Ks,
      Ks,
      Ai.num(0, 1),
      Ai.num(Zr, 1),
      Aa(Gi),
      kd(ds)
    ];
    if (!ms) {
      const io = Pn.map((na) => El(na));
      Js.push(Mp(Pn), oA(io), qd(io), Ya(Pn));
    }
    if (((Zr & 3) < 2 || (Zr & 3) > 3) && Js.push(aA(Zi)), Js.push(Ai.num(Ws, 1)), ms) {
      const { value: io, scriptPubKey: na } = El(Pn[ft]);
      Js.push(zf(us), Rf(Is), uf(io), Nr.encode(na, !0), Vo($n));
    } else
      Js.push(Ai.num(ft, 4).reverse());
    return Ns !== void 0 && Js.push(Ns), (Zr & 3) === 3 && Js.push(Lp(Zi[ft])), Or !== void 0 && Js.push(Ai.bytes(Or), Ai.num(gi), Ai.num(vi, 4, "le")), Ai.join(Js).digest;
  }
  function Mp(rr) {
    const ft = [];
    for (const { txid: dr, vout: Or } of rr)
      ft.push(zf(dr)), ft.push(Rf(Or));
    return Ai.join(ft).digest;
  }
  function Ya(rr) {
    const ft = [];
    for (const { sequence: dr } of rr)
      ft.push(Vo(dr));
    return Ai.join(ft).digest;
  }
  function oA(rr) {
    const ft = [];
    for (const { value: dr } of rr)
      ft.push(uf(dr));
    return Ai.join(ft).digest;
  }
  function qd(rr) {
    const ft = [];
    for (const { scriptPubKey: dr } of rr)
      ft.push(K(dr, !0));
    return Ai.join(ft).digest;
  }
  function aA(rr) {
    const ft = [];
    for (const { value: dr, scriptPubKey: Or } of rr)
      ft.push(uf(dr)), ft.push(Nr.encode(Or, !0));
    return Ai.join(ft).digest;
  }
  function Lp(rr) {
    return Ai.join([
      uf(rr.value),
      Nr.encode(rr.scriptPubKey, !0)
    ]).digest;
  }
  function Hp(rr) {
    if (rr === void 0 || rr.length < 2)
      return;
    let ft = rr.at(-1);
    if (typeof ft == "string" && (ft = Ai.hex(ft)), ft instanceof Uint8Array && ft[0] === 80)
      return Ai.raw(ft).prefixSize("be").digest;
  }
  function El(rr) {
    if (rr.prevout === void 0)
      throw new Error("Prevout data missing for input: " + String(rr.txid));
    return rr.prevout;
  }
  const Jf = 0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2fn, mu = 0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141n;
  function Uo(rr, ft, dr, Or = {}) {
    const { sigflag: Zr = 0 } = Or, ni = va(ft, dr, Or), gi = Yf(rr, ni);
    return Zr === 0 ? Ai.raw(gi) : Ai.join([gi, Zr]);
  }
  function Yf(rr, ft, dr = Ai.random(32)) {
    const Or = Ai.bytes(ft), Zr = new Da(rr), ni = Zr.point, gi = ni.hasEvenY ? Zr.big : Zr.negated.big, vi = ki("BIP0340/aux", Ai.bytes(dr)), Fi = gi ^ vi.big, Gi = ki("BIP0340/nonce", Fi, ni.x.raw, Or), Pn = new Da(Gi), Zi = Pn.point, ds = Zi.hasEvenY ? Pn.big : Pn.negated.big, us = new Da(ki("BIP0340/challenge", Zi.x.raw, ni.x.raw, Or)), Is = new Da(ds + us.big * gi);
    return Ai.join([Zi.x.raw, Is.raw]);
  }
  function Kp(rr, ft, dr, Or = !1) {
    const Zr = Tu.from_x(af(dr)), ni = Ai.bytes(ft), gi = Ai.bytes(rr).stream;
    gi.size < 64 && yi("Signature length is too small: " + String(gi.size), Or);
    const vi = gi.read(32);
    vi.big > Jf && yi("Signature r value greater than field size!", Or);
    const Fi = gi.read(32);
    Fi.big > mu && yi("Signature s value greater than curve order!", Or);
    const Gi = new Da(ki("BIP0340/challenge", vi.raw, Zr.x.raw, ni)), Pn = new Da(Fi).point, Zi = Zr.mul(Gi.big), ds = Pn.sub(Zi);
    return ds.hasOddY && yi("Signature R value has odd Y coordinate!", Or), ds.x.big === 0n && yi("Signature R value is infinite!", Or), ds.x.big === vi.big;
  }
  const Vp = 192;
  function qc(rr) {
    const ft = Ai.str(rr).digest;
    return Ai.join([ft, ft]);
  }
  function ff(rr, ft = Vp) {
    return Ai.join([
      qc("TapLeaf"),
      AA(ft),
      Ai.bytes(rr)
    ]).digest.hex;
  }
  function cA(rr, ft) {
    return ff(Nr.fmt.toBytes(rr), ft);
  }
  function wo(rr, ft) {
    return ft < rr && ([rr, ft] = [ft, rr]), Ai.join([
      qc("TapBranch"),
      Ai.hex(rr).raw,
      Ai.hex(ft).raw
    ]).digest.hex;
  }
  function wu(rr) {
    return Ai.hex(Oc(rr)[0]);
  }
  function Oc(rr, ft, dr = []) {
    const Or = [], Zr = [];
    if (rr.length < 1)
      throw new Error("Tree is empty!");
    for (let ni = 0; ni < rr.length; ni++) {
      const gi = rr[ni];
      if (Array.isArray(gi)) {
        const [vi, Fi, Gi] = Oc(gi, ft);
        ft = Fi, Or.push(vi);
        for (const Pn of Gi)
          dr.push(Pn);
      } else
        Or.push(gi);
    }
    if (Or.length === 1)
      return [Or[0], ft, dr];
    Or.sort(), Or.length % 2 !== 0 && Or.push(Or[Or.length - 1]);
    for (let ni = 0; ni < Or.length - 1; ni += 2) {
      const gi = wo(Or[ni], Or[ni + 1]);
      Zr.push(gi), typeof ft == "string" && (ft === Or[ni] ? (dr.push(Or[ni + 1]), ft = gi) : ft === Or[ni + 1] && (dr.push(Or[ni]), ft = gi));
    }
    return Oc(Zr, ft, dr);
  }
  function AA(rr = 192) {
    return rr & 254;
  }
  function Od(rr, ft = new Uint8Array(), dr = !1) {
    const Or = dr ? new Da(rr).point.x.raw : af(rr);
    return Ai.join([qc("TapTweak"), Or, Ai.bytes(ft)]).digest;
  }
  function Na(rr, ft, dr = !1) {
    ft === void 0 && (ft = new Uint8Array());
    const Or = Ai.bytes(rr), Zr = Od(rr, ft, dr);
    return dr ? bA(Or, Zr) : e1(Or, Zr);
  }
  function wA(rr, ft) {
    return Na(rr, ft);
  }
  function Xa(rr, ft) {
    return Na(rr, ft, !0);
  }
  function bA(rr, ft) {
    let dr = new Da(rr);
    return dr.point.hasOddY && (dr = dr.negate()), Ai.raw(dr.add(ft).raw);
  }
  function e1(rr, ft) {
    rr = af(rr);
    const Or = Tu.from_x(rr).add(ft);
    return Ai.raw(Or.raw);
  }
  function t1() {
    const rr = Ai.hex("0479be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8");
    return Tu.from_x(rr.digest).x;
  }
  const Za = t1(), Gp = 192;
  function jp(rr, ft = {}) {
    return r1(rr, { ...ft, isPrivate: !0 });
  }
  function Ao(rr, ft = {}) {
    return r1(rr, { ...ft, isPrivate: !1 });
  }
  function r1(rr, ft = {}) {
    const { isPrivate: dr = !1, tree: Or = [], version: Zr = Gp } = ft, ni = dr ? Gf.getPublicKey(rr, !0) : af(rr);
    let { target: gi } = ft;
    gi !== void 0 && (gi = Ai.bytes(gi).hex);
    let vi, Fi = [];
    if (Or.length > 0) {
      const [us, Is, $n] = Oc(Or, gi);
      Fi = $n, vi = Na(rr, us, dr);
    } else
      gi !== void 0 ? vi = Na(rr, gi, dr) : vi = Na(rr, void 0, dr);
    const Gi = dr ? Gf.getPublicKey(vi)[0] : vi[0], Zi = [Ai.num(Zr + Bl(Gi)), ni];
    Fi.length > 0 && Fi.forEach((us) => Zi.push(Ai.hex(us)));
    const ds = Ai.join(Zi);
    if (gi !== void 0 && !bl(vi, gi, ds, ft))
      throw new Error("Path checking failed! Unable to generate path.");
    return [af(vi).hex, ds.hex];
  }
  function bl(rr, ft, dr, Or = {}) {
    const { isPrivate: Zr = !1, throws: ni = !1 } = Or, { parity: gi, paths: vi, intkey: Fi } = i1(dr), Gi = Zr ? Gf.getPublicKey(rr, !0) : af(rr), Pn = Ai.join([gi, Gi]);
    if (Pn.length !== 33)
      return yi("Invalid tapkey: " + Pn.hex, ni);
    let Zi = Ai.bytes(ft).hex;
    for (const us of vi)
      Zi = wo(Zi, us);
    const ds = Na(Fi, Zi);
    return Ai.raw(ds).hex === Ai.raw(Pn).hex;
  }
  function i1(rr) {
    const ft = new ri(Ai.bytes(rr)), dr = ft.read(1).num, Or = ft.read(32), [Zr, ni] = dr % 2 === 0 ? [dr, 2] : [dr - 1, 3], gi = [];
    for (; ft.size >= 32; )
      gi.push(ft.read(32).hex);
    if (ft.size !== 0)
      throw new Error("Non-empty buffer on control block: " + String(ft));
    return { intkey: Or, paths: gi, parity: ni, version: Zr };
  }
  function Bl(rr = 2) {
    if (rr === 0 || rr === 1)
      return rr;
    if (rr === 2 || rr === "02")
      return 0;
    if (rr === 3 || rr === "03")
      return 1;
    throw new Error("Invalid parity bit: " + String(rr));
  }
  function Qd(rr, ft, dr = {}) {
    const Or = Ja.fmt.toJson(rr), { throws: Zr = !1 } = dr, { prevout: ni, witness: gi = [] } = Or.vin[ft], vi = Ja.util.readWitness(gi), { cblock: Fi, script: Gi, params: Pn } = vi;
    let Zi;
    if (Pn.length < 1)
      return yi("Invalid witness data: " + String(gi), Zr);
    const { scriptPubKey: ds } = ni ?? {};
    if (ds === void 0)
      return yi("Prevout scriptPubKey is empty!", Zr);
    const { type: us, data: Is } = Ja.util.readScriptPubKey(ds);
    if (us !== "p2tr")
      return yi("Prevout script is not a valid taproot output:" + Is.hex, Zr);
    if (Is.length !== 32)
      return yi("Invalid tapkey length: " + String(Is.length), Zr);
    if (Fi !== null && Gi !== null) {
      const Ts = Fi[0] & 254, oo = ff(Gi, Ts);
      if (dr.extension = oo, !bl(Is, oo, Fi, { throws: Zr }))
        return yi("cblock verification failed!", Zr);
    }
    dr.pubkey !== void 0 ? Zi = Ai.bytes(dr.pubkey) : Pn.length > 1 && Pn[1].length === 32 ? Zi = Ai.bytes(Pn[1]) : Zi = Ai.bytes(Is);
    const $n = Nr.fmt.toParam(Pn[0]), As = new ri($n), ms = As.read(64).raw;
    if (As.size === 1 && (dr.sigflag = As.read(1).num, dr.sigflag === 0))
      return yi("0x00 is not a valid appended sigflag!", Zr);
    const Ns = va(Or, ft, dr);
    return Kp(ms, Ns, Zi, Zr) ? !0 : yi("Invalid signature!", Zr);
  }
  const pa = {
    segwit: Ba,
    taproot: {
      hash: va,
      sign: Uo,
      verify: Qd
    }
  }, Xf = {
    getTag: qc,
    getLeaf: ff,
    getBranch: wo,
    getRoot: wu
  }, zp = {
    getPubKey: Ao,
    getSecKey: jp,
    encodeScript: cA,
    checkPath: bl,
    tree: Xf,
    tweak: {
      getPubKey: wA,
      getSecKey: Xa,
      getTweak: Od,
      tweakSecKey: bA,
      tweakPubKey: e1
    },
    util: {
      readCtrlBlock: i1,
      readParityBit: Bl
    },
    SCRIPT_PUBKEY: Za
  };
  class n1 {
    constructor(ft) {
      this._buff = Ai.raw(K(ft));
    }
    get raw() {
      return this._buff.raw;
    }
    get hex() {
      return this._buff.hex;
    }
    get asm() {
      return tr(this._buff);
    }
    getHash(ft, dr) {
      switch (ft) {
        case "p2w":
          return zu(this._buff).hex;
        case "p2sh":
          return hl(this._buff).hex;
        case "p2tr":
          return Xf.getLeaf(this._buff, dr);
        default:
          throw new Error("Unrecognized format: " + ft);
      }
    }
    toJSON() {
      return this.asm ?? [];
    }
  }
  const s1 = 4294967295, Jp = 1 << 31, Df = 512, Yp = 1 << 22;
  class o1 {
    constructor(ft) {
      typeof ft == "string" ? this.value = parseInt(ft, 16) : this.value = ft;
    }
    get isReplaceable() {
      return this.value < s1;
    }
    get isLocked() {
      return !(this.value !== s1 || (this.value & Jp) !== 0);
    }
    get isTimelock() {
      return (this.value & Yp) !== 0;
    }
    get timestamp() {
      return this.isLocked ? this.isTimelock ? this.value * Df : this.value * Df * 600 : 0;
    }
    set timestamp(ft) {
      this.value = Math.ceil(ft / Df);
    }
    get blockheight() {
      return this.isLocked ? this.isTimelock ? Math.ceil(this.value * Df / 600) : this.value : 0;
    }
    set blockheight(ft) {
      this.value = ft;
    }
    get estDate() {
      return this.isTimelock ? new Date(Date.now() + this.value * Df * 1e3) : new Date(Date.now() + this.value * 600 * 1e3);
    }
    set estDate(ft) {
      const dr = ft.getTime() - Date.now();
      this.value = dr > Df * 1e3 ? Math.ceil(dr / 1e3 / Df) : 1;
    }
    toJSON() {
      return this.value;
    }
  }
  let Ud = class {
    constructor(ft) {
      this.value = BigInt(ft.value), this.scriptPubKey = new n1(ft.scriptPubKey);
    }
    get type() {
      const { type: ft } = Nd(this.scriptPubKey.raw);
      return ft;
    }
  };
  class a1 {
    constructor(ft, dr) {
      this._data = ft, this._meta = $h(ft), this.format = dr;
    }
    get length() {
      return this._data.length;
    }
    get annex() {
      const ft = this._meta.annex;
      return ft !== null ? Ai.raw(ft).hex : void 0;
    }
    get cblock() {
      const ft = this._meta.cblock;
      return ft !== null ? Ai.raw(ft).hex : void 0;
    }
    get script() {
      const ft = this._meta.script;
      return ft !== null ? Nr.decode(ft) : void 0;
    }
    get params() {
      return this._meta.params;
    }
    toJSON() {
      return this._data;
    }
  }
  let u1 = class {
    constructor(ft, dr) {
      this._tx = ft, this.idx = dr;
    }
    get data() {
      return this._tx.vin[this.idx];
    }
    get txid() {
      return this.data.txid;
    }
    get vout() {
      return this.data.vout;
    }
    get prevout() {
      return this.data.prevout !== void 0 ? new Ud(this.data.prevout) : void 0;
    }
    get scriptSig() {
      return new n1(this.data.scriptSig);
    }
    get sequence() {
      return new o1(this.data.sequence);
    }
    get witness() {
      return new a1(this.data.witness);
    }
    get type() {
      if (this.prevout !== void 0) {
        const ft = this.prevout.scriptPubKey.raw, { type: dr } = Nd(ft);
        if (dr === "p2sh") {
          const Or = this.scriptSig.asm;
          if (Or[0] === "OP_0") {
            if (Or[1].length === 20)
              return "p2w-p2pkh";
            if (Or[1].length === 32)
              return "p2w-p2sh";
          }
          return "p2sh";
        }
        return dr;
      }
      return "raw";
    }
    sign(ft, dr) {
      if (this.type.startsWith("p2w"))
        return pa.segwit.sign(ft, this._tx, this.idx, dr);
      if (this.type.startsWith("p2tr"))
        return pa.taproot.sign(ft, this._tx, this.idx, dr);
      throw this.type.startsWith("p2pkh") || this.type.startsWith("p2sh") ? new Error("This library does not support signing legacy transactions.") : new Error("Unable to sign this input type:" + String(this.type));
    }
  };
  const Xp = 5e8;
  class _p {
    constructor(ft = 0) {
      this.value = Ai.bytes(ft).num;
    }
    get isTimelock() {
      return this.value > Xp;
    }
    get timestamp() {
      return this.isTimelock ? this.value : this.value * 600;
    }
    set timestamp(ft) {
      this.value = ft;
    }
    get blockheight() {
      return this.isTimelock ? Math.floor(this.value / 600) : this.value;
    }
    set blockheight(ft) {
      this.value = ft;
    }
    get estDate() {
      return this.isTimelock ? new Date(Date.now() + this.value * 1e3) : new Date(Date.now() + this.value * 600 * 1e3);
    }
    set estDate(ft) {
      this.value = Math.floor((ft.getTime() - Date.now()) / 1e3);
    }
    toJSON() {
      return this.value;
    }
  }
  var zo;
  (function(rr) {
    rr.assertEqual = (Zr) => Zr;
    function ft(Zr) {
    }
    rr.assertIs = ft;
    function dr(Zr) {
      throw new Error();
    }
    rr.assertNever = dr, rr.arrayToEnum = (Zr) => {
      const ni = {};
      for (const gi of Zr)
        ni[gi] = gi;
      return ni;
    }, rr.getValidEnumValues = (Zr) => {
      const ni = rr.objectKeys(Zr).filter((vi) => typeof Zr[Zr[vi]] != "number"), gi = {};
      for (const vi of ni)
        gi[vi] = Zr[vi];
      return rr.objectValues(gi);
    }, rr.objectValues = (Zr) => rr.objectKeys(Zr).map(function(ni) {
      return Zr[ni];
    }), rr.objectKeys = typeof Object.keys == "function" ? (Zr) => Object.keys(Zr) : (Zr) => {
      const ni = [];
      for (const gi in Zr)
        Object.prototype.hasOwnProperty.call(Zr, gi) && ni.push(gi);
      return ni;
    }, rr.find = (Zr, ni) => {
      for (const gi of Zr)
        if (ni(gi))
          return gi;
    }, rr.isInteger = typeof Number.isInteger == "function" ? (Zr) => Number.isInteger(Zr) : (Zr) => typeof Zr == "number" && isFinite(Zr) && Math.floor(Zr) === Zr;
    function Or(Zr, ni = " | ") {
      return Zr.map((gi) => typeof gi == "string" ? `'${gi}'` : gi).join(ni);
    }
    rr.joinValues = Or, rr.jsonStringifyReplacer = (Zr, ni) => typeof ni == "bigint" ? ni.toString() : ni;
  })(zo || (zo = {}));
  var Md;
  (function(rr) {
    rr.mergeShapes = (ft, dr) => ({
      ...ft,
      ...dr
      // second overwrites first
    });
  })(Md || (Md = {}));
  const Ms = zo.arrayToEnum([
    "string",
    "nan",
    "number",
    "integer",
    "float",
    "boolean",
    "date",
    "bigint",
    "symbol",
    "function",
    "undefined",
    "null",
    "array",
    "object",
    "unknown",
    "promise",
    "void",
    "never",
    "map",
    "set"
  ]), cf = (rr) => {
    switch (typeof rr) {
      case "undefined":
        return Ms.undefined;
      case "string":
        return Ms.string;
      case "number":
        return isNaN(rr) ? Ms.nan : Ms.number;
      case "boolean":
        return Ms.boolean;
      case "function":
        return Ms.function;
      case "bigint":
        return Ms.bigint;
      case "symbol":
        return Ms.symbol;
      case "object":
        return Array.isArray(rr) ? Ms.array : rr === null ? Ms.null : rr.then && typeof rr.then == "function" && rr.catch && typeof rr.catch == "function" ? Ms.promise : typeof Map < "u" && rr instanceof Map ? Ms.map : typeof Set < "u" && rr instanceof Set ? Ms.set : typeof Date < "u" && rr instanceof Date ? Ms.date : Ms.object;
      default:
        return Ms.unknown;
    }
  }, Cs = zo.arrayToEnum([
    "invalid_type",
    "invalid_literal",
    "custom",
    "invalid_union",
    "invalid_union_discriminator",
    "invalid_enum_value",
    "unrecognized_keys",
    "invalid_arguments",
    "invalid_return_type",
    "invalid_date",
    "invalid_string",
    "too_small",
    "too_big",
    "invalid_intersection_types",
    "not_multiple_of",
    "not_finite"
  ]), Zp = (rr) => JSON.stringify(rr, null, 2).replace(/"([^"]+)":/g, "$1:");
  class Eu extends Error {
    constructor(ft) {
      super(), this.issues = [], this.addIssue = (Or) => {
        this.issues = [...this.issues, Or];
      }, this.addIssues = (Or = []) => {
        this.issues = [...this.issues, ...Or];
      };
      const dr = new.target.prototype;
      Object.setPrototypeOf ? Object.setPrototypeOf(this, dr) : this.__proto__ = dr, this.name = "ZodError", this.issues = ft;
    }
    get errors() {
      return this.issues;
    }
    format(ft) {
      const dr = ft || function(ni) {
        return ni.message;
      }, Or = { _errors: [] }, Zr = (ni) => {
        for (const gi of ni.issues)
          if (gi.code === "invalid_union")
            gi.unionErrors.map(Zr);
          else if (gi.code === "invalid_return_type")
            Zr(gi.returnTypeError);
          else if (gi.code === "invalid_arguments")
            Zr(gi.argumentsError);
          else if (gi.path.length === 0)
            Or._errors.push(dr(gi));
          else {
            let vi = Or, Fi = 0;
            for (; Fi < gi.path.length; ) {
              const Gi = gi.path[Fi];
              Fi === gi.path.length - 1 ? (vi[Gi] = vi[Gi] || { _errors: [] }, vi[Gi]._errors.push(dr(gi))) : vi[Gi] = vi[Gi] || { _errors: [] }, vi = vi[Gi], Fi++;
            }
          }
      };
      return Zr(this), Or;
    }
    toString() {
      return this.message;
    }
    get message() {
      return JSON.stringify(this.issues, zo.jsonStringifyReplacer, 2);
    }
    get isEmpty() {
      return this.issues.length === 0;
    }
    flatten(ft = (dr) => dr.message) {
      const dr = {}, Or = [];
      for (const Zr of this.issues)
        Zr.path.length > 0 ? (dr[Zr.path[0]] = dr[Zr.path[0]] || [], dr[Zr.path[0]].push(ft(Zr))) : Or.push(ft(Zr));
      return { formErrors: Or, fieldErrors: dr };
    }
    get formErrors() {
      return this.flatten();
    }
  }
  Eu.create = (rr) => new Eu(rr);
  const Qc = (rr, ft) => {
    let dr;
    switch (rr.code) {
      case Cs.invalid_type:
        rr.received === Ms.undefined ? dr = "Required" : dr = `Expected ${rr.expected}, received ${rr.received}`;
        break;
      case Cs.invalid_literal:
        dr = `Invalid literal value, expected ${JSON.stringify(rr.expected, zo.jsonStringifyReplacer)}`;
        break;
      case Cs.unrecognized_keys:
        dr = `Unrecognized key(s) in object: ${zo.joinValues(rr.keys, ", ")}`;
        break;
      case Cs.invalid_union:
        dr = "Invalid input";
        break;
      case Cs.invalid_union_discriminator:
        dr = `Invalid discriminator value. Expected ${zo.joinValues(rr.options)}`;
        break;
      case Cs.invalid_enum_value:
        dr = `Invalid enum value. Expected ${zo.joinValues(rr.options)}, received '${rr.received}'`;
        break;
      case Cs.invalid_arguments:
        dr = "Invalid function arguments";
        break;
      case Cs.invalid_return_type:
        dr = "Invalid function return type";
        break;
      case Cs.invalid_date:
        dr = "Invalid date";
        break;
      case Cs.invalid_string:
        typeof rr.validation == "object" ? "includes" in rr.validation ? (dr = `Invalid input: must include "${rr.validation.includes}"`, typeof rr.validation.position == "number" && (dr = `${dr} at one or more positions greater than or equal to ${rr.validation.position}`)) : "startsWith" in rr.validation ? dr = `Invalid input: must start with "${rr.validation.startsWith}"` : "endsWith" in rr.validation ? dr = `Invalid input: must end with "${rr.validation.endsWith}"` : zo.assertNever(rr.validation) : rr.validation !== "regex" ? dr = `Invalid ${rr.validation}` : dr = "Invalid";
        break;
      case Cs.too_small:
        rr.type === "array" ? dr = `Array must contain ${rr.exact ? "exactly" : rr.inclusive ? "at least" : "more than"} ${rr.minimum} element(s)` : rr.type === "string" ? dr = `String must contain ${rr.exact ? "exactly" : rr.inclusive ? "at least" : "over"} ${rr.minimum} character(s)` : rr.type === "number" ? dr = `Number must be ${rr.exact ? "exactly equal to " : rr.inclusive ? "greater than or equal to " : "greater than "}${rr.minimum}` : rr.type === "date" ? dr = `Date must be ${rr.exact ? "exactly equal to " : rr.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(rr.minimum))}` : dr = "Invalid input";
        break;
      case Cs.too_big:
        rr.type === "array" ? dr = `Array must contain ${rr.exact ? "exactly" : rr.inclusive ? "at most" : "less than"} ${rr.maximum} element(s)` : rr.type === "string" ? dr = `String must contain ${rr.exact ? "exactly" : rr.inclusive ? "at most" : "under"} ${rr.maximum} character(s)` : rr.type === "number" ? dr = `Number must be ${rr.exact ? "exactly" : rr.inclusive ? "less than or equal to" : "less than"} ${rr.maximum}` : rr.type === "bigint" ? dr = `BigInt must be ${rr.exact ? "exactly" : rr.inclusive ? "less than or equal to" : "less than"} ${rr.maximum}` : rr.type === "date" ? dr = `Date must be ${rr.exact ? "exactly" : rr.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(rr.maximum))}` : dr = "Invalid input";
        break;
      case Cs.custom:
        dr = "Invalid input";
        break;
      case Cs.invalid_intersection_types:
        dr = "Intersection results could not be merged";
        break;
      case Cs.not_multiple_of:
        dr = `Number must be a multiple of ${rr.multipleOf}`;
        break;
      case Cs.not_finite:
        dr = "Number must be finite";
        break;
      default:
        dr = ft.defaultError, zo.assertNever(rr);
    }
    return { message: dr };
  };
  let Fd = Qc;
  function $p(rr) {
    Fd = rr;
  }
  function vl() {
    return Fd;
  }
  const Cl = (rr) => {
    const { data: ft, path: dr, errorMaps: Or, issueData: Zr } = rr, ni = [...dr, ...Zr.path || []], gi = {
      ...Zr,
      path: ni
    };
    let vi = "";
    const Fi = Or.filter((Gi) => !!Gi).slice().reverse();
    for (const Gi of Fi)
      vi = Gi(gi, { data: ft, defaultError: vi }).message;
    return {
      ...Zr,
      path: ni,
      message: Zr.message || vi
    };
  }, e4 = [];
  function Hs(rr, ft) {
    const dr = Cl({
      issueData: ft,
      data: rr.data,
      path: rr.path,
      errorMaps: [
        rr.common.contextualErrorMap,
        rr.schemaErrorMap,
        vl(),
        Qc
        // then global default map
      ].filter((Or) => !!Or)
    });
    rr.common.issues.push(dr);
  }
  class La {
    constructor() {
      this.value = "valid";
    }
    dirty() {
      this.value === "valid" && (this.value = "dirty");
    }
    abort() {
      this.value !== "aborted" && (this.value = "aborted");
    }
    static mergeArray(ft, dr) {
      const Or = [];
      for (const Zr of dr) {
        if (Zr.status === "aborted")
          return po;
        Zr.status === "dirty" && ft.dirty(), Or.push(Zr.value);
      }
      return { status: ft.value, value: Or };
    }
    static async mergeObjectAsync(ft, dr) {
      const Or = [];
      for (const Zr of dr)
        Or.push({
          key: await Zr.key,
          value: await Zr.value
        });
      return La.mergeObjectSync(ft, Or);
    }
    static mergeObjectSync(ft, dr) {
      const Or = {};
      for (const Zr of dr) {
        const { key: ni, value: gi } = Zr;
        if (ni.status === "aborted" || gi.status === "aborted")
          return po;
        ni.status === "dirty" && ft.dirty(), gi.status === "dirty" && ft.dirty(), (typeof gi.value < "u" || Zr.alwaysSet) && (Or[ni.value] = gi.value);
      }
      return { status: ft.value, value: Or };
    }
  }
  const po = Object.freeze({
    status: "aborted"
  }), f1 = (rr) => ({ status: "dirty", value: rr }), Ha = (rr) => ({ status: "valid", value: rr }), bu = (rr) => rr.status === "aborted", ea = (rr) => rr.status === "dirty", Uc = (rr) => rr.status === "valid", Mc = (rr) => typeof Promise < "u" && rr instanceof Promise;
  var $s;
  (function(rr) {
    rr.errToObj = (ft) => typeof ft == "string" ? { message: ft } : ft || {}, rr.toString = (ft) => typeof ft == "string" ? ft : ft == null ? void 0 : ft.message;
  })($s || ($s = {}));
  class Qs {
    constructor(ft, dr, Or, Zr) {
      this._cachedPath = [], this.parent = ft, this.data = dr, this._path = Or, this._key = Zr;
    }
    get path() {
      return this._cachedPath.length || (this._key instanceof Array ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
    }
  }
  const _f = (rr, ft) => {
    if (Uc(ft))
      return { success: !0, data: ft.value };
    if (!rr.common.issues.length)
      throw new Error("Validation failed but no issues detected.");
    return {
      success: !1,
      get error() {
        if (this._error)
          return this._error;
        const dr = new Eu(rr.common.issues);
        return this._error = dr, this._error;
      }
    };
  };
  function vo(rr) {
    if (!rr)
      return {};
    const { errorMap: ft, invalid_type_error: dr, required_error: Or, description: Zr } = rr;
    if (ft && (dr || Or))
      throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
    return ft ? { errorMap: ft, description: Zr } : { errorMap: (gi, vi) => gi.code !== "invalid_type" ? { message: vi.defaultError } : typeof vi.data > "u" ? { message: Or ?? vi.defaultError } : { message: dr ?? vi.defaultError }, description: Zr };
  }
  class xo {
    constructor(ft) {
      this.spa = this.safeParseAsync, this._def = ft, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this);
    }
    get description() {
      return this._def.description;
    }
    _getType(ft) {
      return cf(ft.data);
    }
    _getOrReturnCtx(ft, dr) {
      return dr || {
        common: ft.parent.common,
        data: ft.data,
        parsedType: cf(ft.data),
        schemaErrorMap: this._def.errorMap,
        path: ft.path,
        parent: ft.parent
      };
    }
    _processInputParams(ft) {
      return {
        status: new La(),
        ctx: {
          common: ft.parent.common,
          data: ft.data,
          parsedType: cf(ft.data),
          schemaErrorMap: this._def.errorMap,
          path: ft.path,
          parent: ft.parent
        }
      };
    }
    _parseSync(ft) {
      const dr = this._parse(ft);
      if (Mc(dr))
        throw new Error("Synchronous parse encountered promise.");
      return dr;
    }
    _parseAsync(ft) {
      const dr = this._parse(ft);
      return Promise.resolve(dr);
    }
    parse(ft, dr) {
      const Or = this.safeParse(ft, dr);
      if (Or.success)
        return Or.data;
      throw Or.error;
    }
    safeParse(ft, dr) {
      var Or;
      const Zr = {
        common: {
          issues: [],
          async: (Or = dr == null ? void 0 : dr.async) !== null && Or !== void 0 ? Or : !1,
          contextualErrorMap: dr == null ? void 0 : dr.errorMap
        },
        path: (dr == null ? void 0 : dr.path) || [],
        schemaErrorMap: this._def.errorMap,
        parent: null,
        data: ft,
        parsedType: cf(ft)
      }, ni = this._parseSync({ data: ft, path: Zr.path, parent: Zr });
      return _f(Zr, ni);
    }
    async parseAsync(ft, dr) {
      const Or = await this.safeParseAsync(ft, dr);
      if (Or.success)
        return Or.data;
      throw Or.error;
    }
    async safeParseAsync(ft, dr) {
      const Or = {
        common: {
          issues: [],
          contextualErrorMap: dr == null ? void 0 : dr.errorMap,
          async: !0
        },
        path: (dr == null ? void 0 : dr.path) || [],
        schemaErrorMap: this._def.errorMap,
        parent: null,
        data: ft,
        parsedType: cf(ft)
      }, Zr = this._parse({ data: ft, path: Or.path, parent: Or }), ni = await (Mc(Zr) ? Zr : Promise.resolve(Zr));
      return _f(Or, ni);
    }
    refine(ft, dr) {
      const Or = (Zr) => typeof dr == "string" || typeof dr > "u" ? { message: dr } : typeof dr == "function" ? dr(Zr) : dr;
      return this._refinement((Zr, ni) => {
        const gi = ft(Zr), vi = () => ni.addIssue({
          code: Cs.custom,
          ...Or(Zr)
        });
        return typeof Promise < "u" && gi instanceof Promise ? gi.then((Fi) => Fi ? !0 : (vi(), !1)) : gi ? !0 : (vi(), !1);
      });
    }
    refinement(ft, dr) {
      return this._refinement((Or, Zr) => ft(Or) ? !0 : (Zr.addIssue(typeof dr == "function" ? dr(Or, Zr) : dr), !1));
    }
    _refinement(ft) {
      return new vu({
        schema: this,
        typeName: uo.ZodEffects,
        effect: { type: "refinement", refinement: ft }
      });
    }
    superRefine(ft) {
      return this._refinement(ft);
    }
    optional() {
      return Qu.create(this, this._def);
    }
    nullable() {
      return pf.create(this, this._def);
    }
    nullish() {
      return this.nullable().optional();
    }
    array() {
      return Sa.create(this, this._def);
    }
    promise() {
      return gf.create(this, this._def);
    }
    or(ft) {
      return hf.create([this, ft], this._def);
    }
    and(ft) {
      return Kc.create(this, ft, this._def);
    }
    transform(ft) {
      return new vu({
        ...vo(this._def),
        schema: this,
        typeName: uo.ZodEffects,
        effect: { type: "transform", transform: ft }
      });
    }
    default(ft) {
      const dr = typeof ft == "function" ? ft : () => ft;
      return new tc({
        ...vo(this._def),
        innerType: this,
        defaultValue: dr,
        typeName: uo.ZodDefault
      });
    }
    brand() {
      return new rc({
        typeName: uo.ZodBranded,
        type: this,
        ...vo(this._def)
      });
    }
    catch(ft) {
      const dr = typeof ft == "function" ? ft : () => ft;
      return new Gc({
        ...vo(this._def),
        innerType: this,
        catchValue: dr,
        typeName: uo.ZodCatch
      });
    }
    describe(ft) {
      const dr = this.constructor;
      return new dr({
        ...this._def,
        description: ft
      });
    }
    pipe(ft) {
      return Wc.create(this, ft);
    }
    isOptional() {
      return this.safeParse(void 0).success;
    }
    isNullable() {
      return this.safeParse(null).success;
    }
  }
  const t4 = /^c[^\s-]{8,}$/i, c1 = /^[a-z][a-z0-9]*$/, l1 = /[0-9A-HJKMNP-TV-Z]{26}/, d1 = /^([a-f0-9]{8}-[a-f0-9]{4}-[1-5][a-f0-9]{3}-[a-f0-9]{4}-[a-f0-9]{12}|00000000-0000-0000-0000-000000000000)$/i, r4 = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\])|(\[IPv6:(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))\])|([A-Za-z0-9]([A-Za-z0-9-]*[A-Za-z0-9])*(\.[A-Za-z]{2,})+))$/, i4 = new RegExp("^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$", "u"), n4 = /^(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))$/, s4 = /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/, kl = (rr) => rr.precision ? rr.offset ? new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${rr.precision}}(([+-]\\d{2}(:?\\d{2})?)|Z)$`) : new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${rr.precision}}Z$`) : rr.precision === 0 ? rr.offset ? new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(([+-]\\d{2}(:?\\d{2})?)|Z)$") : new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}Z$") : rr.offset ? new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?(([+-]\\d{2}(:?\\d{2})?)|Z)$") : new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?Z$");
  function o4(rr, ft) {
    return !!((ft === "v4" || !ft) && n4.test(rr) || (ft === "v6" || !ft) && s4.test(rr));
  }
  class Va extends xo {
    constructor() {
      super(...arguments), this._regex = (ft, dr, Or) => this.refinement((Zr) => ft.test(Zr), {
        validation: dr,
        code: Cs.invalid_string,
        ...$s.errToObj(Or)
      }), this.nonempty = (ft) => this.min(1, $s.errToObj(ft)), this.trim = () => new Va({
        ...this._def,
        checks: [...this._def.checks, { kind: "trim" }]
      }), this.toLowerCase = () => new Va({
        ...this._def,
        checks: [...this._def.checks, { kind: "toLowerCase" }]
      }), this.toUpperCase = () => new Va({
        ...this._def,
        checks: [...this._def.checks, { kind: "toUpperCase" }]
      });
    }
    _parse(ft) {
      if (this._def.coerce && (ft.data = String(ft.data)), this._getType(ft) !== Ms.string) {
        const ni = this._getOrReturnCtx(ft);
        return Hs(
          ni,
          {
            code: Cs.invalid_type,
            expected: Ms.string,
            received: ni.parsedType
          }
          //
        ), po;
      }
      const Or = new La();
      let Zr;
      for (const ni of this._def.checks)
        if (ni.kind === "min")
          ft.data.length < ni.value && (Zr = this._getOrReturnCtx(ft, Zr), Hs(Zr, {
            code: Cs.too_small,
            minimum: ni.value,
            type: "string",
            inclusive: !0,
            exact: !1,
            message: ni.message
          }), Or.dirty());
        else if (ni.kind === "max")
          ft.data.length > ni.value && (Zr = this._getOrReturnCtx(ft, Zr), Hs(Zr, {
            code: Cs.too_big,
            maximum: ni.value,
            type: "string",
            inclusive: !0,
            exact: !1,
            message: ni.message
          }), Or.dirty());
        else if (ni.kind === "length") {
          const gi = ft.data.length > ni.value, vi = ft.data.length < ni.value;
          (gi || vi) && (Zr = this._getOrReturnCtx(ft, Zr), gi ? Hs(Zr, {
            code: Cs.too_big,
            maximum: ni.value,
            type: "string",
            inclusive: !0,
            exact: !0,
            message: ni.message
          }) : vi && Hs(Zr, {
            code: Cs.too_small,
            minimum: ni.value,
            type: "string",
            inclusive: !0,
            exact: !0,
            message: ni.message
          }), Or.dirty());
        } else if (ni.kind === "email")
          r4.test(ft.data) || (Zr = this._getOrReturnCtx(ft, Zr), Hs(Zr, {
            validation: "email",
            code: Cs.invalid_string,
            message: ni.message
          }), Or.dirty());
        else if (ni.kind === "emoji")
          i4.test(ft.data) || (Zr = this._getOrReturnCtx(ft, Zr), Hs(Zr, {
            validation: "emoji",
            code: Cs.invalid_string,
            message: ni.message
          }), Or.dirty());
        else if (ni.kind === "uuid")
          d1.test(ft.data) || (Zr = this._getOrReturnCtx(ft, Zr), Hs(Zr, {
            validation: "uuid",
            code: Cs.invalid_string,
            message: ni.message
          }), Or.dirty());
        else if (ni.kind === "cuid")
          t4.test(ft.data) || (Zr = this._getOrReturnCtx(ft, Zr), Hs(Zr, {
            validation: "cuid",
            code: Cs.invalid_string,
            message: ni.message
          }), Or.dirty());
        else if (ni.kind === "cuid2")
          c1.test(ft.data) || (Zr = this._getOrReturnCtx(ft, Zr), Hs(Zr, {
            validation: "cuid2",
            code: Cs.invalid_string,
            message: ni.message
          }), Or.dirty());
        else if (ni.kind === "ulid")
          l1.test(ft.data) || (Zr = this._getOrReturnCtx(ft, Zr), Hs(Zr, {
            validation: "ulid",
            code: Cs.invalid_string,
            message: ni.message
          }), Or.dirty());
        else if (ni.kind === "url")
          try {
            new URL(ft.data);
          } catch {
            Zr = this._getOrReturnCtx(ft, Zr), Hs(Zr, {
              validation: "url",
              code: Cs.invalid_string,
              message: ni.message
            }), Or.dirty();
          }
        else ni.kind === "regex" ? (ni.regex.lastIndex = 0, ni.regex.test(ft.data) || (Zr = this._getOrReturnCtx(ft, Zr), Hs(Zr, {
          validation: "regex",
          code: Cs.invalid_string,
          message: ni.message
        }), Or.dirty())) : ni.kind === "trim" ? ft.data = ft.data.trim() : ni.kind === "includes" ? ft.data.includes(ni.value, ni.position) || (Zr = this._getOrReturnCtx(ft, Zr), Hs(Zr, {
          code: Cs.invalid_string,
          validation: { includes: ni.value, position: ni.position },
          message: ni.message
        }), Or.dirty()) : ni.kind === "toLowerCase" ? ft.data = ft.data.toLowerCase() : ni.kind === "toUpperCase" ? ft.data = ft.data.toUpperCase() : ni.kind === "startsWith" ? ft.data.startsWith(ni.value) || (Zr = this._getOrReturnCtx(ft, Zr), Hs(Zr, {
          code: Cs.invalid_string,
          validation: { startsWith: ni.value },
          message: ni.message
        }), Or.dirty()) : ni.kind === "endsWith" ? ft.data.endsWith(ni.value) || (Zr = this._getOrReturnCtx(ft, Zr), Hs(Zr, {
          code: Cs.invalid_string,
          validation: { endsWith: ni.value },
          message: ni.message
        }), Or.dirty()) : ni.kind === "datetime" ? kl(ni).test(ft.data) || (Zr = this._getOrReturnCtx(ft, Zr), Hs(Zr, {
          code: Cs.invalid_string,
          validation: "datetime",
          message: ni.message
        }), Or.dirty()) : ni.kind === "ip" ? o4(ft.data, ni.version) || (Zr = this._getOrReturnCtx(ft, Zr), Hs(Zr, {
          validation: "ip",
          code: Cs.invalid_string,
          message: ni.message
        }), Or.dirty()) : zo.assertNever(ni);
      return { status: Or.value, value: ft.data };
    }
    _addCheck(ft) {
      return new Va({
        ...this._def,
        checks: [...this._def.checks, ft]
      });
    }
    email(ft) {
      return this._addCheck({ kind: "email", ...$s.errToObj(ft) });
    }
    url(ft) {
      return this._addCheck({ kind: "url", ...$s.errToObj(ft) });
    }
    emoji(ft) {
      return this._addCheck({ kind: "emoji", ...$s.errToObj(ft) });
    }
    uuid(ft) {
      return this._addCheck({ kind: "uuid", ...$s.errToObj(ft) });
    }
    cuid(ft) {
      return this._addCheck({ kind: "cuid", ...$s.errToObj(ft) });
    }
    cuid2(ft) {
      return this._addCheck({ kind: "cuid2", ...$s.errToObj(ft) });
    }
    ulid(ft) {
      return this._addCheck({ kind: "ulid", ...$s.errToObj(ft) });
    }
    ip(ft) {
      return this._addCheck({ kind: "ip", ...$s.errToObj(ft) });
    }
    datetime(ft) {
      var dr;
      return typeof ft == "string" ? this._addCheck({
        kind: "datetime",
        precision: null,
        offset: !1,
        message: ft
      }) : this._addCheck({
        kind: "datetime",
        precision: typeof (ft == null ? void 0 : ft.precision) > "u" ? null : ft == null ? void 0 : ft.precision,
        offset: (dr = ft == null ? void 0 : ft.offset) !== null && dr !== void 0 ? dr : !1,
        ...$s.errToObj(ft == null ? void 0 : ft.message)
      });
    }
    regex(ft, dr) {
      return this._addCheck({
        kind: "regex",
        regex: ft,
        ...$s.errToObj(dr)
      });
    }
    includes(ft, dr) {
      return this._addCheck({
        kind: "includes",
        value: ft,
        position: dr == null ? void 0 : dr.position,
        ...$s.errToObj(dr == null ? void 0 : dr.message)
      });
    }
    startsWith(ft, dr) {
      return this._addCheck({
        kind: "startsWith",
        value: ft,
        ...$s.errToObj(dr)
      });
    }
    endsWith(ft, dr) {
      return this._addCheck({
        kind: "endsWith",
        value: ft,
        ...$s.errToObj(dr)
      });
    }
    min(ft, dr) {
      return this._addCheck({
        kind: "min",
        value: ft,
        ...$s.errToObj(dr)
      });
    }
    max(ft, dr) {
      return this._addCheck({
        kind: "max",
        value: ft,
        ...$s.errToObj(dr)
      });
    }
    length(ft, dr) {
      return this._addCheck({
        kind: "length",
        value: ft,
        ...$s.errToObj(dr)
      });
    }
    get isDatetime() {
      return !!this._def.checks.find((ft) => ft.kind === "datetime");
    }
    get isEmail() {
      return !!this._def.checks.find((ft) => ft.kind === "email");
    }
    get isURL() {
      return !!this._def.checks.find((ft) => ft.kind === "url");
    }
    get isEmoji() {
      return !!this._def.checks.find((ft) => ft.kind === "emoji");
    }
    get isUUID() {
      return !!this._def.checks.find((ft) => ft.kind === "uuid");
    }
    get isCUID() {
      return !!this._def.checks.find((ft) => ft.kind === "cuid");
    }
    get isCUID2() {
      return !!this._def.checks.find((ft) => ft.kind === "cuid2");
    }
    get isULID() {
      return !!this._def.checks.find((ft) => ft.kind === "ulid");
    }
    get isIP() {
      return !!this._def.checks.find((ft) => ft.kind === "ip");
    }
    get minLength() {
      let ft = null;
      for (const dr of this._def.checks)
        dr.kind === "min" && (ft === null || dr.value > ft) && (ft = dr.value);
      return ft;
    }
    get maxLength() {
      let ft = null;
      for (const dr of this._def.checks)
        dr.kind === "max" && (ft === null || dr.value < ft) && (ft = dr.value);
      return ft;
    }
  }
  Va.create = (rr) => {
    var ft;
    return new Va({
      checks: [],
      typeName: uo.ZodString,
      coerce: (ft = rr == null ? void 0 : rr.coerce) !== null && ft !== void 0 ? ft : !1,
      ...vo(rr)
    });
  };
  function a4(rr, ft) {
    const dr = (rr.toString().split(".")[1] || "").length, Or = (ft.toString().split(".")[1] || "").length, Zr = dr > Or ? dr : Or, ni = parseInt(rr.toFixed(Zr).replace(".", "")), gi = parseInt(ft.toFixed(Zr).replace(".", ""));
    return ni % gi / Math.pow(10, Zr);
  }
  class lf extends xo {
    constructor() {
      super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
    }
    _parse(ft) {
      if (this._def.coerce && (ft.data = Number(ft.data)), this._getType(ft) !== Ms.number) {
        const ni = this._getOrReturnCtx(ft);
        return Hs(ni, {
          code: Cs.invalid_type,
          expected: Ms.number,
          received: ni.parsedType
        }), po;
      }
      let Or;
      const Zr = new La();
      for (const ni of this._def.checks)
        ni.kind === "int" ? zo.isInteger(ft.data) || (Or = this._getOrReturnCtx(ft, Or), Hs(Or, {
          code: Cs.invalid_type,
          expected: "integer",
          received: "float",
          message: ni.message
        }), Zr.dirty()) : ni.kind === "min" ? (ni.inclusive ? ft.data < ni.value : ft.data <= ni.value) && (Or = this._getOrReturnCtx(ft, Or), Hs(Or, {
          code: Cs.too_small,
          minimum: ni.value,
          type: "number",
          inclusive: ni.inclusive,
          exact: !1,
          message: ni.message
        }), Zr.dirty()) : ni.kind === "max" ? (ni.inclusive ? ft.data > ni.value : ft.data >= ni.value) && (Or = this._getOrReturnCtx(ft, Or), Hs(Or, {
          code: Cs.too_big,
          maximum: ni.value,
          type: "number",
          inclusive: ni.inclusive,
          exact: !1,
          message: ni.message
        }), Zr.dirty()) : ni.kind === "multipleOf" ? a4(ft.data, ni.value) !== 0 && (Or = this._getOrReturnCtx(ft, Or), Hs(Or, {
          code: Cs.not_multiple_of,
          multipleOf: ni.value,
          message: ni.message
        }), Zr.dirty()) : ni.kind === "finite" ? Number.isFinite(ft.data) || (Or = this._getOrReturnCtx(ft, Or), Hs(Or, {
          code: Cs.not_finite,
          message: ni.message
        }), Zr.dirty()) : zo.assertNever(ni);
      return { status: Zr.value, value: ft.data };
    }
    gte(ft, dr) {
      return this.setLimit("min", ft, !0, $s.toString(dr));
    }
    gt(ft, dr) {
      return this.setLimit("min", ft, !1, $s.toString(dr));
    }
    lte(ft, dr) {
      return this.setLimit("max", ft, !0, $s.toString(dr));
    }
    lt(ft, dr) {
      return this.setLimit("max", ft, !1, $s.toString(dr));
    }
    setLimit(ft, dr, Or, Zr) {
      return new lf({
        ...this._def,
        checks: [
          ...this._def.checks,
          {
            kind: ft,
            value: dr,
            inclusive: Or,
            message: $s.toString(Zr)
          }
        ]
      });
    }
    _addCheck(ft) {
      return new lf({
        ...this._def,
        checks: [...this._def.checks, ft]
      });
    }
    int(ft) {
      return this._addCheck({
        kind: "int",
        message: $s.toString(ft)
      });
    }
    positive(ft) {
      return this._addCheck({
        kind: "min",
        value: 0,
        inclusive: !1,
        message: $s.toString(ft)
      });
    }
    negative(ft) {
      return this._addCheck({
        kind: "max",
        value: 0,
        inclusive: !1,
        message: $s.toString(ft)
      });
    }
    nonpositive(ft) {
      return this._addCheck({
        kind: "max",
        value: 0,
        inclusive: !0,
        message: $s.toString(ft)
      });
    }
    nonnegative(ft) {
      return this._addCheck({
        kind: "min",
        value: 0,
        inclusive: !0,
        message: $s.toString(ft)
      });
    }
    multipleOf(ft, dr) {
      return this._addCheck({
        kind: "multipleOf",
        value: ft,
        message: $s.toString(dr)
      });
    }
    finite(ft) {
      return this._addCheck({
        kind: "finite",
        message: $s.toString(ft)
      });
    }
    safe(ft) {
      return this._addCheck({
        kind: "min",
        inclusive: !0,
        value: Number.MIN_SAFE_INTEGER,
        message: $s.toString(ft)
      })._addCheck({
        kind: "max",
        inclusive: !0,
        value: Number.MAX_SAFE_INTEGER,
        message: $s.toString(ft)
      });
    }
    get minValue() {
      let ft = null;
      for (const dr of this._def.checks)
        dr.kind === "min" && (ft === null || dr.value > ft) && (ft = dr.value);
      return ft;
    }
    get maxValue() {
      let ft = null;
      for (const dr of this._def.checks)
        dr.kind === "max" && (ft === null || dr.value < ft) && (ft = dr.value);
      return ft;
    }
    get isInt() {
      return !!this._def.checks.find((ft) => ft.kind === "int" || ft.kind === "multipleOf" && zo.isInteger(ft.value));
    }
    get isFinite() {
      let ft = null, dr = null;
      for (const Or of this._def.checks) {
        if (Or.kind === "finite" || Or.kind === "int" || Or.kind === "multipleOf")
          return !0;
        Or.kind === "min" ? (dr === null || Or.value > dr) && (dr = Or.value) : Or.kind === "max" && (ft === null || Or.value < ft) && (ft = Or.value);
      }
      return Number.isFinite(dr) && Number.isFinite(ft);
    }
  }
  lf.create = (rr) => new lf({
    checks: [],
    typeName: uo.ZodNumber,
    coerce: (rr == null ? void 0 : rr.coerce) || !1,
    ...vo(rr)
  });
  class df extends xo {
    constructor() {
      super(...arguments), this.min = this.gte, this.max = this.lte;
    }
    _parse(ft) {
      if (this._def.coerce && (ft.data = BigInt(ft.data)), this._getType(ft) !== Ms.bigint) {
        const ni = this._getOrReturnCtx(ft);
        return Hs(ni, {
          code: Cs.invalid_type,
          expected: Ms.bigint,
          received: ni.parsedType
        }), po;
      }
      let Or;
      const Zr = new La();
      for (const ni of this._def.checks)
        ni.kind === "min" ? (ni.inclusive ? ft.data < ni.value : ft.data <= ni.value) && (Or = this._getOrReturnCtx(ft, Or), Hs(Or, {
          code: Cs.too_small,
          type: "bigint",
          minimum: ni.value,
          inclusive: ni.inclusive,
          message: ni.message
        }), Zr.dirty()) : ni.kind === "max" ? (ni.inclusive ? ft.data > ni.value : ft.data >= ni.value) && (Or = this._getOrReturnCtx(ft, Or), Hs(Or, {
          code: Cs.too_big,
          type: "bigint",
          maximum: ni.value,
          inclusive: ni.inclusive,
          message: ni.message
        }), Zr.dirty()) : ni.kind === "multipleOf" ? ft.data % ni.value !== BigInt(0) && (Or = this._getOrReturnCtx(ft, Or), Hs(Or, {
          code: Cs.not_multiple_of,
          multipleOf: ni.value,
          message: ni.message
        }), Zr.dirty()) : zo.assertNever(ni);
      return { status: Zr.value, value: ft.data };
    }
    gte(ft, dr) {
      return this.setLimit("min", ft, !0, $s.toString(dr));
    }
    gt(ft, dr) {
      return this.setLimit("min", ft, !1, $s.toString(dr));
    }
    lte(ft, dr) {
      return this.setLimit("max", ft, !0, $s.toString(dr));
    }
    lt(ft, dr) {
      return this.setLimit("max", ft, !1, $s.toString(dr));
    }
    setLimit(ft, dr, Or, Zr) {
      return new df({
        ...this._def,
        checks: [
          ...this._def.checks,
          {
            kind: ft,
            value: dr,
            inclusive: Or,
            message: $s.toString(Zr)
          }
        ]
      });
    }
    _addCheck(ft) {
      return new df({
        ...this._def,
        checks: [...this._def.checks, ft]
      });
    }
    positive(ft) {
      return this._addCheck({
        kind: "min",
        value: BigInt(0),
        inclusive: !1,
        message: $s.toString(ft)
      });
    }
    negative(ft) {
      return this._addCheck({
        kind: "max",
        value: BigInt(0),
        inclusive: !1,
        message: $s.toString(ft)
      });
    }
    nonpositive(ft) {
      return this._addCheck({
        kind: "max",
        value: BigInt(0),
        inclusive: !0,
        message: $s.toString(ft)
      });
    }
    nonnegative(ft) {
      return this._addCheck({
        kind: "min",
        value: BigInt(0),
        inclusive: !0,
        message: $s.toString(ft)
      });
    }
    multipleOf(ft, dr) {
      return this._addCheck({
        kind: "multipleOf",
        value: ft,
        message: $s.toString(dr)
      });
    }
    get minValue() {
      let ft = null;
      for (const dr of this._def.checks)
        dr.kind === "min" && (ft === null || dr.value > ft) && (ft = dr.value);
      return ft;
    }
    get maxValue() {
      let ft = null;
      for (const dr of this._def.checks)
        dr.kind === "max" && (ft === null || dr.value < ft) && (ft = dr.value);
      return ft;
    }
  }
  df.create = (rr) => {
    var ft;
    return new df({
      checks: [],
      typeName: uo.ZodBigInt,
      coerce: (ft = rr == null ? void 0 : rr.coerce) !== null && ft !== void 0 ? ft : !1,
      ...vo(rr)
    });
  };
  class Fc extends xo {
    _parse(ft) {
      if (this._def.coerce && (ft.data = !!ft.data), this._getType(ft) !== Ms.boolean) {
        const Or = this._getOrReturnCtx(ft);
        return Hs(Or, {
          code: Cs.invalid_type,
          expected: Ms.boolean,
          received: Or.parsedType
        }), po;
      }
      return Ha(ft.data);
    }
  }
  Fc.create = (rr) => new Fc({
    typeName: uo.ZodBoolean,
    coerce: (rr == null ? void 0 : rr.coerce) || !1,
    ...vo(rr)
  });
  class oa extends xo {
    _parse(ft) {
      if (this._def.coerce && (ft.data = new Date(ft.data)), this._getType(ft) !== Ms.date) {
        const ni = this._getOrReturnCtx(ft);
        return Hs(ni, {
          code: Cs.invalid_type,
          expected: Ms.date,
          received: ni.parsedType
        }), po;
      }
      if (isNaN(ft.data.getTime())) {
        const ni = this._getOrReturnCtx(ft);
        return Hs(ni, {
          code: Cs.invalid_date
        }), po;
      }
      const Or = new La();
      let Zr;
      for (const ni of this._def.checks)
        ni.kind === "min" ? ft.data.getTime() < ni.value && (Zr = this._getOrReturnCtx(ft, Zr), Hs(Zr, {
          code: Cs.too_small,
          message: ni.message,
          inclusive: !0,
          exact: !1,
          minimum: ni.value,
          type: "date"
        }), Or.dirty()) : ni.kind === "max" ? ft.data.getTime() > ni.value && (Zr = this._getOrReturnCtx(ft, Zr), Hs(Zr, {
          code: Cs.too_big,
          message: ni.message,
          inclusive: !0,
          exact: !1,
          maximum: ni.value,
          type: "date"
        }), Or.dirty()) : zo.assertNever(ni);
      return {
        status: Or.value,
        value: new Date(ft.data.getTime())
      };
    }
    _addCheck(ft) {
      return new oa({
        ...this._def,
        checks: [...this._def.checks, ft]
      });
    }
    min(ft, dr) {
      return this._addCheck({
        kind: "min",
        value: ft.getTime(),
        message: $s.toString(dr)
      });
    }
    max(ft, dr) {
      return this._addCheck({
        kind: "max",
        value: ft.getTime(),
        message: $s.toString(dr)
      });
    }
    get minDate() {
      let ft = null;
      for (const dr of this._def.checks)
        dr.kind === "min" && (ft === null || dr.value > ft) && (ft = dr.value);
      return ft != null ? new Date(ft) : null;
    }
    get maxDate() {
      let ft = null;
      for (const dr of this._def.checks)
        dr.kind === "max" && (ft === null || dr.value < ft) && (ft = dr.value);
      return ft != null ? new Date(ft) : null;
    }
  }
  oa.create = (rr) => new oa({
    checks: [],
    coerce: (rr == null ? void 0 : rr.coerce) || !1,
    typeName: uo.ZodDate,
    ...vo(rr)
  });
  class Sl extends xo {
    _parse(ft) {
      if (this._getType(ft) !== Ms.symbol) {
        const Or = this._getOrReturnCtx(ft);
        return Hs(Or, {
          code: Cs.invalid_type,
          expected: Ms.symbol,
          received: Or.parsedType
        }), po;
      }
      return Ha(ft.data);
    }
  }
  Sl.create = (rr) => new Sl({
    typeName: uo.ZodSymbol,
    ...vo(rr)
  });
  class Lc extends xo {
    _parse(ft) {
      if (this._getType(ft) !== Ms.undefined) {
        const Or = this._getOrReturnCtx(ft);
        return Hs(Or, {
          code: Cs.invalid_type,
          expected: Ms.undefined,
          received: Or.parsedType
        }), po;
      }
      return Ha(ft.data);
    }
  }
  Lc.create = (rr) => new Lc({
    typeName: uo.ZodUndefined,
    ...vo(rr)
  });
  class ia extends xo {
    _parse(ft) {
      if (this._getType(ft) !== Ms.null) {
        const Or = this._getOrReturnCtx(ft);
        return Hs(Or, {
          code: Cs.invalid_type,
          expected: Ms.null,
          received: Or.parsedType
        }), po;
      }
      return Ha(ft.data);
    }
  }
  ia.create = (rr) => new ia({
    typeName: uo.ZodNull,
    ...vo(rr)
  });
  class Nf extends xo {
    constructor() {
      super(...arguments), this._any = !0;
    }
    _parse(ft) {
      return Ha(ft.data);
    }
  }
  Nf.create = (rr) => new Nf({
    typeName: uo.ZodAny,
    ...vo(rr)
  });
  class Pf extends xo {
    constructor() {
      super(...arguments), this._unknown = !0;
    }
    _parse(ft) {
      return Ha(ft.data);
    }
  }
  Pf.create = (rr) => new Pf({
    typeName: uo.ZodUnknown,
    ...vo(rr)
  });
  class qu extends xo {
    _parse(ft) {
      const dr = this._getOrReturnCtx(ft);
      return Hs(dr, {
        code: Cs.invalid_type,
        expected: Ms.never,
        received: dr.parsedType
      }), po;
    }
  }
  qu.create = (rr) => new qu({
    typeName: uo.ZodNever,
    ...vo(rr)
  });
  class Tl extends xo {
    _parse(ft) {
      if (this._getType(ft) !== Ms.undefined) {
        const Or = this._getOrReturnCtx(ft);
        return Hs(Or, {
          code: Cs.invalid_type,
          expected: Ms.void,
          received: Or.parsedType
        }), po;
      }
      return Ha(ft.data);
    }
  }
  Tl.create = (rr) => new Tl({
    typeName: uo.ZodVoid,
    ...vo(rr)
  });
  class Sa extends xo {
    _parse(ft) {
      const { ctx: dr, status: Or } = this._processInputParams(ft), Zr = this._def;
      if (dr.parsedType !== Ms.array)
        return Hs(dr, {
          code: Cs.invalid_type,
          expected: Ms.array,
          received: dr.parsedType
        }), po;
      if (Zr.exactLength !== null) {
        const gi = dr.data.length > Zr.exactLength.value, vi = dr.data.length < Zr.exactLength.value;
        (gi || vi) && (Hs(dr, {
          code: gi ? Cs.too_big : Cs.too_small,
          minimum: vi ? Zr.exactLength.value : void 0,
          maximum: gi ? Zr.exactLength.value : void 0,
          type: "array",
          inclusive: !0,
          exact: !0,
          message: Zr.exactLength.message
        }), Or.dirty());
      }
      if (Zr.minLength !== null && dr.data.length < Zr.minLength.value && (Hs(dr, {
        code: Cs.too_small,
        minimum: Zr.minLength.value,
        type: "array",
        inclusive: !0,
        exact: !1,
        message: Zr.minLength.message
      }), Or.dirty()), Zr.maxLength !== null && dr.data.length > Zr.maxLength.value && (Hs(dr, {
        code: Cs.too_big,
        maximum: Zr.maxLength.value,
        type: "array",
        inclusive: !0,
        exact: !1,
        message: Zr.maxLength.message
      }), Or.dirty()), dr.common.async)
        return Promise.all([...dr.data].map((gi, vi) => Zr.type._parseAsync(new Qs(dr, gi, dr.path, vi)))).then((gi) => La.mergeArray(Or, gi));
      const ni = [...dr.data].map((gi, vi) => Zr.type._parseSync(new Qs(dr, gi, dr.path, vi)));
      return La.mergeArray(Or, ni);
    }
    get element() {
      return this._def.type;
    }
    min(ft, dr) {
      return new Sa({
        ...this._def,
        minLength: { value: ft, message: $s.toString(dr) }
      });
    }
    max(ft, dr) {
      return new Sa({
        ...this._def,
        maxLength: { value: ft, message: $s.toString(dr) }
      });
    }
    length(ft, dr) {
      return new Sa({
        ...this._def,
        exactLength: { value: ft, message: $s.toString(dr) }
      });
    }
    nonempty(ft) {
      return this.min(1, ft);
    }
  }
  Sa.create = (rr, ft) => new Sa({
    type: rr,
    minLength: null,
    maxLength: null,
    exactLength: null,
    typeName: uo.ZodArray,
    ...vo(ft)
  });
  function Zf(rr) {
    if (rr instanceof aa) {
      const ft = {};
      for (const dr in rr.shape) {
        const Or = rr.shape[dr];
        ft[dr] = Qu.create(Zf(Or));
      }
      return new aa({
        ...rr._def,
        shape: () => ft
      });
    } else return rr instanceof Sa ? new Sa({
      ...rr._def,
      type: Zf(rr.element)
    }) : rr instanceof Qu ? Qu.create(Zf(rr.unwrap())) : rr instanceof pf ? pf.create(Zf(rr.unwrap())) : rr instanceof Ou ? Ou.create(rr.items.map((ft) => Zf(ft))) : rr;
  }
  class aa extends xo {
    constructor() {
      super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
    }
    _getCached() {
      if (this._cached !== null)
        return this._cached;
      const ft = this._def.shape(), dr = zo.objectKeys(ft);
      return this._cached = { shape: ft, keys: dr };
    }
    _parse(ft) {
      if (this._getType(ft) !== Ms.object) {
        const Gi = this._getOrReturnCtx(ft);
        return Hs(Gi, {
          code: Cs.invalid_type,
          expected: Ms.object,
          received: Gi.parsedType
        }), po;
      }
      const { status: Or, ctx: Zr } = this._processInputParams(ft), { shape: ni, keys: gi } = this._getCached(), vi = [];
      if (!(this._def.catchall instanceof qu && this._def.unknownKeys === "strip"))
        for (const Gi in Zr.data)
          gi.includes(Gi) || vi.push(Gi);
      const Fi = [];
      for (const Gi of gi) {
        const Pn = ni[Gi], Zi = Zr.data[Gi];
        Fi.push({
          key: { status: "valid", value: Gi },
          value: Pn._parse(new Qs(Zr, Zi, Zr.path, Gi)),
          alwaysSet: Gi in Zr.data
        });
      }
      if (this._def.catchall instanceof qu) {
        const Gi = this._def.unknownKeys;
        if (Gi === "passthrough")
          for (const Pn of vi)
            Fi.push({
              key: { status: "valid", value: Pn },
              value: { status: "valid", value: Zr.data[Pn] }
            });
        else if (Gi === "strict")
          vi.length > 0 && (Hs(Zr, {
            code: Cs.unrecognized_keys,
            keys: vi
          }), Or.dirty());
        else if (Gi !== "strip") throw new Error("Internal ZodObject error: invalid unknownKeys value.");
      } else {
        const Gi = this._def.catchall;
        for (const Pn of vi) {
          const Zi = Zr.data[Pn];
          Fi.push({
            key: { status: "valid", value: Pn },
            value: Gi._parse(
              new Qs(Zr, Zi, Zr.path, Pn)
              //, ctx.child(key), value, getParsedType(value)
            ),
            alwaysSet: Pn in Zr.data
          });
        }
      }
      return Zr.common.async ? Promise.resolve().then(async () => {
        const Gi = [];
        for (const Pn of Fi) {
          const Zi = await Pn.key;
          Gi.push({
            key: Zi,
            value: await Pn.value,
            alwaysSet: Pn.alwaysSet
          });
        }
        return Gi;
      }).then((Gi) => La.mergeObjectSync(Or, Gi)) : La.mergeObjectSync(Or, Fi);
    }
    get shape() {
      return this._def.shape();
    }
    strict(ft) {
      return new aa({
        ...this._def,
        unknownKeys: "strict",
        ...ft !== void 0 ? {
          errorMap: (dr, Or) => {
            var Zr, ni, gi, vi;
            const Fi = (gi = (ni = (Zr = this._def).errorMap) === null || ni === void 0 ? void 0 : ni.call(Zr, dr, Or).message) !== null && gi !== void 0 ? gi : Or.defaultError;
            return dr.code === "unrecognized_keys" ? {
              message: (vi = $s.errToObj(ft).message) !== null && vi !== void 0 ? vi : Fi
            } : {
              message: Fi
            };
          }
        } : {}
      });
    }
    strip() {
      return new aa({
        ...this._def,
        unknownKeys: "strip"
      });
    }
    passthrough() {
      return new aa({
        ...this._def,
        unknownKeys: "passthrough"
      });
    }
    // const AugmentFactory =
    //   <Def extends ZodObjectDef>(def: Def) =>
    //   <Augmentation extends ZodRawShape>(
    //     augmentation: Augmentation
    //   ): ZodObject<
    //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
    //     Def["unknownKeys"],
    //     Def["catchall"]
    //   > => {
    //     return new ZodObject({
    //       ...def,
    //       shape: () => ({
    //         ...def.shape(),
    //         ...augmentation,
    //       }),
    //     }) as any;
    //   };
    extend(ft) {
      return new aa({
        ...this._def,
        shape: () => ({
          ...this._def.shape(),
          ...ft
        })
      });
    }
    /**
     * Prior to zod@1.0.12 there was a bug in the
     * inferred type of merged objects. Please
     * upgrade if you are experiencing issues.
     */
    merge(ft) {
      return new aa({
        unknownKeys: ft._def.unknownKeys,
        catchall: ft._def.catchall,
        shape: () => ({
          ...this._def.shape(),
          ...ft._def.shape()
        }),
        typeName: uo.ZodObject
      });
    }
    // merge<
    //   Incoming extends AnyZodObject,
    //   Augmentation extends Incoming["shape"],
    //   NewOutput extends {
    //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
    //       ? Augmentation[k]["_output"]
    //       : k extends keyof Output
    //       ? Output[k]
    //       : never;
    //   },
    //   NewInput extends {
    //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
    //       ? Augmentation[k]["_input"]
    //       : k extends keyof Input
    //       ? Input[k]
    //       : never;
    //   }
    // >(
    //   merging: Incoming
    // ): ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"],
    //   NewOutput,
    //   NewInput
    // > {
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    setKey(ft, dr) {
      return this.augment({ [ft]: dr });
    }
    // merge<Incoming extends AnyZodObject>(
    //   merging: Incoming
    // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
    // ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"]
    // > {
    //   // const mergedShape = objectUtil.mergeShapes(
    //   //   this._def.shape(),
    //   //   merging._def.shape()
    //   // );
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    catchall(ft) {
      return new aa({
        ...this._def,
        catchall: ft
      });
    }
    pick(ft) {
      const dr = {};
      return zo.objectKeys(ft).forEach((Or) => {
        ft[Or] && this.shape[Or] && (dr[Or] = this.shape[Or]);
      }), new aa({
        ...this._def,
        shape: () => dr
      });
    }
    omit(ft) {
      const dr = {};
      return zo.objectKeys(this.shape).forEach((Or) => {
        ft[Or] || (dr[Or] = this.shape[Or]);
      }), new aa({
        ...this._def,
        shape: () => dr
      });
    }
    /**
     * @deprecated
     */
    deepPartial() {
      return Zf(this);
    }
    partial(ft) {
      const dr = {};
      return zo.objectKeys(this.shape).forEach((Or) => {
        const Zr = this.shape[Or];
        ft && !ft[Or] ? dr[Or] = Zr : dr[Or] = Zr.optional();
      }), new aa({
        ...this._def,
        shape: () => dr
      });
    }
    required(ft) {
      const dr = {};
      return zo.objectKeys(this.shape).forEach((Or) => {
        if (ft && !ft[Or])
          dr[Or] = this.shape[Or];
        else {
          let ni = this.shape[Or];
          for (; ni instanceof Qu; )
            ni = ni._def.innerType;
          dr[Or] = ni;
        }
      }), new aa({
        ...this._def,
        shape: () => dr
      });
    }
    keyof() {
      return xl(zo.objectKeys(this.shape));
    }
  }
  aa.create = (rr, ft) => new aa({
    shape: () => rr,
    unknownKeys: "strip",
    catchall: qu.create(),
    typeName: uo.ZodObject,
    ...vo(ft)
  }), aa.strictCreate = (rr, ft) => new aa({
    shape: () => rr,
    unknownKeys: "strict",
    catchall: qu.create(),
    typeName: uo.ZodObject,
    ...vo(ft)
  }), aa.lazycreate = (rr, ft) => new aa({
    shape: rr,
    unknownKeys: "strip",
    catchall: qu.create(),
    typeName: uo.ZodObject,
    ...vo(ft)
  });
  class hf extends xo {
    _parse(ft) {
      const { ctx: dr } = this._processInputParams(ft), Or = this._def.options;
      function Zr(ni) {
        for (const vi of ni)
          if (vi.result.status === "valid")
            return vi.result;
        for (const vi of ni)
          if (vi.result.status === "dirty")
            return dr.common.issues.push(...vi.ctx.common.issues), vi.result;
        const gi = ni.map((vi) => new Eu(vi.ctx.common.issues));
        return Hs(dr, {
          code: Cs.invalid_union,
          unionErrors: gi
        }), po;
      }
      if (dr.common.async)
        return Promise.all(Or.map(async (ni) => {
          const gi = {
            ...dr,
            common: {
              ...dr.common,
              issues: []
            },
            parent: null
          };
          return {
            result: await ni._parseAsync({
              data: dr.data,
              path: dr.path,
              parent: gi
            }),
            ctx: gi
          };
        })).then(Zr);
      {
        let ni;
        const gi = [];
        for (const Fi of Or) {
          const Gi = {
            ...dr,
            common: {
              ...dr.common,
              issues: []
            },
            parent: null
          }, Pn = Fi._parseSync({
            data: dr.data,
            path: dr.path,
            parent: Gi
          });
          if (Pn.status === "valid")
            return Pn;
          Pn.status === "dirty" && !ni && (ni = { result: Pn, ctx: Gi }), Gi.common.issues.length && gi.push(Gi.common.issues);
        }
        if (ni)
          return dr.common.issues.push(...ni.ctx.common.issues), ni.result;
        const vi = gi.map((Fi) => new Eu(Fi));
        return Hs(dr, {
          code: Cs.invalid_union,
          unionErrors: vi
        }), po;
      }
    }
    get options() {
      return this._def.options;
    }
  }
  hf.create = (rr, ft) => new hf({
    options: rr,
    typeName: uo.ZodUnion,
    ...vo(ft)
  });
  const Rl = (rr) => rr instanceof $f ? Rl(rr.schema) : rr instanceof vu ? Rl(rr.innerType()) : rr instanceof $a ? [rr.value] : rr instanceof Af ? rr.options : rr instanceof ca ? Object.keys(rr.enum) : rr instanceof tc ? Rl(rr._def.innerType) : rr instanceof Lc ? [void 0] : rr instanceof ia ? [null] : null;
  class Hc extends xo {
    _parse(ft) {
      const { ctx: dr } = this._processInputParams(ft);
      if (dr.parsedType !== Ms.object)
        return Hs(dr, {
          code: Cs.invalid_type,
          expected: Ms.object,
          received: dr.parsedType
        }), po;
      const Or = this.discriminator, Zr = dr.data[Or], ni = this.optionsMap.get(Zr);
      return ni ? dr.common.async ? ni._parseAsync({
        data: dr.data,
        path: dr.path,
        parent: dr
      }) : ni._parseSync({
        data: dr.data,
        path: dr.path,
        parent: dr
      }) : (Hs(dr, {
        code: Cs.invalid_union_discriminator,
        options: Array.from(this.optionsMap.keys()),
        path: [Or]
      }), po);
    }
    get discriminator() {
      return this._def.discriminator;
    }
    get options() {
      return this._def.options;
    }
    get optionsMap() {
      return this._def.optionsMap;
    }
    /**
     * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
     * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
     * have a different value for each object in the union.
     * @param discriminator the name of the discriminator property
     * @param types an array of object schemas
     * @param params
     */
    static create(ft, dr, Or) {
      const Zr = /* @__PURE__ */ new Map();
      for (const ni of dr) {
        const gi = Rl(ni.shape[ft]);
        if (!gi)
          throw new Error(`A discriminator value for key \`${ft}\` could not be extracted from all schema options`);
        for (const vi of gi) {
          if (Zr.has(vi))
            throw new Error(`Discriminator property ${String(ft)} has duplicate value ${String(vi)}`);
          Zr.set(vi, ni);
        }
      }
      return new Hc({
        typeName: uo.ZodDiscriminatedUnion,
        discriminator: ft,
        options: dr,
        optionsMap: Zr,
        ...vo(Or)
      });
    }
  }
  function Ld(rr, ft) {
    const dr = cf(rr), Or = cf(ft);
    if (rr === ft)
      return { valid: !0, data: rr };
    if (dr === Ms.object && Or === Ms.object) {
      const Zr = zo.objectKeys(ft), ni = zo.objectKeys(rr).filter((vi) => Zr.indexOf(vi) !== -1), gi = { ...rr, ...ft };
      for (const vi of ni) {
        const Fi = Ld(rr[vi], ft[vi]);
        if (!Fi.valid)
          return { valid: !1 };
        gi[vi] = Fi.data;
      }
      return { valid: !0, data: gi };
    } else if (dr === Ms.array && Or === Ms.array) {
      if (rr.length !== ft.length)
        return { valid: !1 };
      const Zr = [];
      for (let ni = 0; ni < rr.length; ni++) {
        const gi = rr[ni], vi = ft[ni], Fi = Ld(gi, vi);
        if (!Fi.valid)
          return { valid: !1 };
        Zr.push(Fi.data);
      }
      return { valid: !0, data: Zr };
    } else return dr === Ms.date && Or === Ms.date && +rr == +ft ? { valid: !0, data: rr } : { valid: !1 };
  }
  class Kc extends xo {
    _parse(ft) {
      const { status: dr, ctx: Or } = this._processInputParams(ft), Zr = (ni, gi) => {
        if (bu(ni) || bu(gi))
          return po;
        const vi = Ld(ni.value, gi.value);
        return vi.valid ? ((ea(ni) || ea(gi)) && dr.dirty(), { status: dr.value, value: vi.data }) : (Hs(Or, {
          code: Cs.invalid_intersection_types
        }), po);
      };
      return Or.common.async ? Promise.all([
        this._def.left._parseAsync({
          data: Or.data,
          path: Or.path,
          parent: Or
        }),
        this._def.right._parseAsync({
          data: Or.data,
          path: Or.path,
          parent: Or
        })
      ]).then(([ni, gi]) => Zr(ni, gi)) : Zr(this._def.left._parseSync({
        data: Or.data,
        path: Or.path,
        parent: Or
      }), this._def.right._parseSync({
        data: Or.data,
        path: Or.path,
        parent: Or
      }));
    }
  }
  Kc.create = (rr, ft, dr) => new Kc({
    left: rr,
    right: ft,
    typeName: uo.ZodIntersection,
    ...vo(dr)
  });
  class Ou extends xo {
    _parse(ft) {
      const { status: dr, ctx: Or } = this._processInputParams(ft);
      if (Or.parsedType !== Ms.array)
        return Hs(Or, {
          code: Cs.invalid_type,
          expected: Ms.array,
          received: Or.parsedType
        }), po;
      if (Or.data.length < this._def.items.length)
        return Hs(Or, {
          code: Cs.too_small,
          minimum: this._def.items.length,
          inclusive: !0,
          exact: !1,
          type: "array"
        }), po;
      !this._def.rest && Or.data.length > this._def.items.length && (Hs(Or, {
        code: Cs.too_big,
        maximum: this._def.items.length,
        inclusive: !0,
        exact: !1,
        type: "array"
      }), dr.dirty());
      const ni = [...Or.data].map((gi, vi) => {
        const Fi = this._def.items[vi] || this._def.rest;
        return Fi ? Fi._parse(new Qs(Or, gi, Or.path, vi)) : null;
      }).filter((gi) => !!gi);
      return Or.common.async ? Promise.all(ni).then((gi) => La.mergeArray(dr, gi)) : La.mergeArray(dr, ni);
    }
    get items() {
      return this._def.items;
    }
    rest(ft) {
      return new Ou({
        ...this._def,
        rest: ft
      });
    }
  }
  Ou.create = (rr, ft) => {
    if (!Array.isArray(rr))
      throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
    return new Ou({
      items: rr,
      typeName: uo.ZodTuple,
      rest: null,
      ...vo(ft)
    });
  };
  class Vc extends xo {
    get keySchema() {
      return this._def.keyType;
    }
    get valueSchema() {
      return this._def.valueType;
    }
    _parse(ft) {
      const { status: dr, ctx: Or } = this._processInputParams(ft);
      if (Or.parsedType !== Ms.object)
        return Hs(Or, {
          code: Cs.invalid_type,
          expected: Ms.object,
          received: Or.parsedType
        }), po;
      const Zr = [], ni = this._def.keyType, gi = this._def.valueType;
      for (const vi in Or.data)
        Zr.push({
          key: ni._parse(new Qs(Or, vi, Or.path, vi)),
          value: gi._parse(new Qs(Or, Or.data[vi], Or.path, vi))
        });
      return Or.common.async ? La.mergeObjectAsync(dr, Zr) : La.mergeObjectSync(dr, Zr);
    }
    get element() {
      return this._def.valueType;
    }
    static create(ft, dr, Or) {
      return dr instanceof xo ? new Vc({
        keyType: ft,
        valueType: dr,
        typeName: uo.ZodRecord,
        ...vo(Or)
      }) : new Vc({
        keyType: Va.create(),
        valueType: ft,
        typeName: uo.ZodRecord,
        ...vo(dr)
      });
    }
  }
  class Bu extends xo {
    _parse(ft) {
      const { status: dr, ctx: Or } = this._processInputParams(ft);
      if (Or.parsedType !== Ms.map)
        return Hs(Or, {
          code: Cs.invalid_type,
          expected: Ms.map,
          received: Or.parsedType
        }), po;
      const Zr = this._def.keyType, ni = this._def.valueType, gi = [...Or.data.entries()].map(([vi, Fi], Gi) => ({
        key: Zr._parse(new Qs(Or, vi, Or.path, [Gi, "key"])),
        value: ni._parse(new Qs(Or, Fi, Or.path, [Gi, "value"]))
      }));
      if (Or.common.async) {
        const vi = /* @__PURE__ */ new Map();
        return Promise.resolve().then(async () => {
          for (const Fi of gi) {
            const Gi = await Fi.key, Pn = await Fi.value;
            if (Gi.status === "aborted" || Pn.status === "aborted")
              return po;
            (Gi.status === "dirty" || Pn.status === "dirty") && dr.dirty(), vi.set(Gi.value, Pn.value);
          }
          return { status: dr.value, value: vi };
        });
      } else {
        const vi = /* @__PURE__ */ new Map();
        for (const Fi of gi) {
          const Gi = Fi.key, Pn = Fi.value;
          if (Gi.status === "aborted" || Pn.status === "aborted")
            return po;
          (Gi.status === "dirty" || Pn.status === "dirty") && dr.dirty(), vi.set(Gi.value, Pn.value);
        }
        return { status: dr.value, value: vi };
      }
    }
  }
  Bu.create = (rr, ft, dr) => new Bu({
    valueType: ft,
    keyType: rr,
    typeName: uo.ZodMap,
    ...vo(dr)
  });
  class qf extends xo {
    _parse(ft) {
      const { status: dr, ctx: Or } = this._processInputParams(ft);
      if (Or.parsedType !== Ms.set)
        return Hs(Or, {
          code: Cs.invalid_type,
          expected: Ms.set,
          received: Or.parsedType
        }), po;
      const Zr = this._def;
      Zr.minSize !== null && Or.data.size < Zr.minSize.value && (Hs(Or, {
        code: Cs.too_small,
        minimum: Zr.minSize.value,
        type: "set",
        inclusive: !0,
        exact: !1,
        message: Zr.minSize.message
      }), dr.dirty()), Zr.maxSize !== null && Or.data.size > Zr.maxSize.value && (Hs(Or, {
        code: Cs.too_big,
        maximum: Zr.maxSize.value,
        type: "set",
        inclusive: !0,
        exact: !1,
        message: Zr.maxSize.message
      }), dr.dirty());
      const ni = this._def.valueType;
      function gi(Fi) {
        const Gi = /* @__PURE__ */ new Set();
        for (const Pn of Fi) {
          if (Pn.status === "aborted")
            return po;
          Pn.status === "dirty" && dr.dirty(), Gi.add(Pn.value);
        }
        return { status: dr.value, value: Gi };
      }
      const vi = [...Or.data.values()].map((Fi, Gi) => ni._parse(new Qs(Or, Fi, Or.path, Gi)));
      return Or.common.async ? Promise.all(vi).then((Fi) => gi(Fi)) : gi(vi);
    }
    min(ft, dr) {
      return new qf({
        ...this._def,
        minSize: { value: ft, message: $s.toString(dr) }
      });
    }
    max(ft, dr) {
      return new qf({
        ...this._def,
        maxSize: { value: ft, message: $s.toString(dr) }
      });
    }
    size(ft, dr) {
      return this.min(ft, dr).max(ft, dr);
    }
    nonempty(ft) {
      return this.min(1, ft);
    }
  }
  qf.create = (rr, ft) => new qf({
    valueType: rr,
    minSize: null,
    maxSize: null,
    typeName: uo.ZodSet,
    ...vo(ft)
  });
  class du extends xo {
    constructor() {
      super(...arguments), this.validate = this.implement;
    }
    _parse(ft) {
      const { ctx: dr } = this._processInputParams(ft);
      if (dr.parsedType !== Ms.function)
        return Hs(dr, {
          code: Cs.invalid_type,
          expected: Ms.function,
          received: dr.parsedType
        }), po;
      function Or(vi, Fi) {
        return Cl({
          data: vi,
          path: dr.path,
          errorMaps: [
            dr.common.contextualErrorMap,
            dr.schemaErrorMap,
            vl(),
            Qc
          ].filter((Gi) => !!Gi),
          issueData: {
            code: Cs.invalid_arguments,
            argumentsError: Fi
          }
        });
      }
      function Zr(vi, Fi) {
        return Cl({
          data: vi,
          path: dr.path,
          errorMaps: [
            dr.common.contextualErrorMap,
            dr.schemaErrorMap,
            vl(),
            Qc
          ].filter((Gi) => !!Gi),
          issueData: {
            code: Cs.invalid_return_type,
            returnTypeError: Fi
          }
        });
      }
      const ni = { errorMap: dr.common.contextualErrorMap }, gi = dr.data;
      return this._def.returns instanceof gf ? Ha(async (...vi) => {
        const Fi = new Eu([]), Gi = await this._def.args.parseAsync(vi, ni).catch((ds) => {
          throw Fi.addIssue(Or(vi, ds)), Fi;
        }), Pn = await gi(...Gi);
        return await this._def.returns._def.type.parseAsync(Pn, ni).catch((ds) => {
          throw Fi.addIssue(Zr(Pn, ds)), Fi;
        });
      }) : Ha((...vi) => {
        const Fi = this._def.args.safeParse(vi, ni);
        if (!Fi.success)
          throw new Eu([Or(vi, Fi.error)]);
        const Gi = gi(...Fi.data), Pn = this._def.returns.safeParse(Gi, ni);
        if (!Pn.success)
          throw new Eu([Zr(Gi, Pn.error)]);
        return Pn.data;
      });
    }
    parameters() {
      return this._def.args;
    }
    returnType() {
      return this._def.returns;
    }
    args(...ft) {
      return new du({
        ...this._def,
        args: Ou.create(ft).rest(Pf.create())
      });
    }
    returns(ft) {
      return new du({
        ...this._def,
        returns: ft
      });
    }
    implement(ft) {
      return this.parse(ft);
    }
    strictImplement(ft) {
      return this.parse(ft);
    }
    static create(ft, dr, Or) {
      return new du({
        args: ft || Ou.create([]).rest(Pf.create()),
        returns: dr || Pf.create(),
        typeName: uo.ZodFunction,
        ...vo(Or)
      });
    }
  }
  class $f extends xo {
    get schema() {
      return this._def.getter();
    }
    _parse(ft) {
      const { ctx: dr } = this._processInputParams(ft);
      return this._def.getter()._parse({ data: dr.data, path: dr.path, parent: dr });
    }
  }
  $f.create = (rr, ft) => new $f({
    getter: rr,
    typeName: uo.ZodLazy,
    ...vo(ft)
  });
  class $a extends xo {
    _parse(ft) {
      if (ft.data !== this._def.value) {
        const dr = this._getOrReturnCtx(ft);
        return Hs(dr, {
          received: dr.data,
          code: Cs.invalid_literal,
          expected: this._def.value
        }), po;
      }
      return { status: "valid", value: ft.data };
    }
    get value() {
      return this._def.value;
    }
  }
  $a.create = (rr, ft) => new $a({
    value: rr,
    typeName: uo.ZodLiteral,
    ...vo(ft)
  });
  function xl(rr, ft) {
    return new Af({
      values: rr,
      typeName: uo.ZodEnum,
      ...vo(ft)
    });
  }
  class Af extends xo {
    _parse(ft) {
      if (typeof ft.data != "string") {
        const dr = this._getOrReturnCtx(ft), Or = this._def.values;
        return Hs(dr, {
          expected: zo.joinValues(Or),
          received: dr.parsedType,
          code: Cs.invalid_type
        }), po;
      }
      if (this._def.values.indexOf(ft.data) === -1) {
        const dr = this._getOrReturnCtx(ft), Or = this._def.values;
        return Hs(dr, {
          received: dr.data,
          code: Cs.invalid_enum_value,
          options: Or
        }), po;
      }
      return Ha(ft.data);
    }
    get options() {
      return this._def.values;
    }
    get enum() {
      const ft = {};
      for (const dr of this._def.values)
        ft[dr] = dr;
      return ft;
    }
    get Values() {
      const ft = {};
      for (const dr of this._def.values)
        ft[dr] = dr;
      return ft;
    }
    get Enum() {
      const ft = {};
      for (const dr of this._def.values)
        ft[dr] = dr;
      return ft;
    }
    extract(ft) {
      return Af.create(ft);
    }
    exclude(ft) {
      return Af.create(this.options.filter((dr) => !ft.includes(dr)));
    }
  }
  Af.create = xl;
  class ca extends xo {
    _parse(ft) {
      const dr = zo.getValidEnumValues(this._def.values), Or = this._getOrReturnCtx(ft);
      if (Or.parsedType !== Ms.string && Or.parsedType !== Ms.number) {
        const Zr = zo.objectValues(dr);
        return Hs(Or, {
          expected: zo.joinValues(Zr),
          received: Or.parsedType,
          code: Cs.invalid_type
        }), po;
      }
      if (dr.indexOf(ft.data) === -1) {
        const Zr = zo.objectValues(dr);
        return Hs(Or, {
          received: Or.data,
          code: Cs.invalid_enum_value,
          options: Zr
        }), po;
      }
      return Ha(ft.data);
    }
    get enum() {
      return this._def.values;
    }
  }
  ca.create = (rr, ft) => new ca({
    values: rr,
    typeName: uo.ZodNativeEnum,
    ...vo(ft)
  });
  class gf extends xo {
    unwrap() {
      return this._def.type;
    }
    _parse(ft) {
      const { ctx: dr } = this._processInputParams(ft);
      if (dr.parsedType !== Ms.promise && dr.common.async === !1)
        return Hs(dr, {
          code: Cs.invalid_type,
          expected: Ms.promise,
          received: dr.parsedType
        }), po;
      const Or = dr.parsedType === Ms.promise ? dr.data : Promise.resolve(dr.data);
      return Ha(Or.then((Zr) => this._def.type.parseAsync(Zr, {
        path: dr.path,
        errorMap: dr.common.contextualErrorMap
      })));
    }
  }
  gf.create = (rr, ft) => new gf({
    type: rr,
    typeName: uo.ZodPromise,
    ...vo(ft)
  });
  class vu extends xo {
    innerType() {
      return this._def.schema;
    }
    sourceType() {
      return this._def.schema._def.typeName === uo.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
    }
    _parse(ft) {
      const { status: dr, ctx: Or } = this._processInputParams(ft), Zr = this._def.effect || null;
      if (Zr.type === "preprocess") {
        const gi = Zr.transform(Or.data);
        return Or.common.async ? Promise.resolve(gi).then((vi) => this._def.schema._parseAsync({
          data: vi,
          path: Or.path,
          parent: Or
        })) : this._def.schema._parseSync({
          data: gi,
          path: Or.path,
          parent: Or
        });
      }
      const ni = {
        addIssue: (gi) => {
          Hs(Or, gi), gi.fatal ? dr.abort() : dr.dirty();
        },
        get path() {
          return Or.path;
        }
      };
      if (ni.addIssue = ni.addIssue.bind(ni), Zr.type === "refinement") {
        const gi = (vi) => {
          const Fi = Zr.refinement(vi, ni);
          if (Or.common.async)
            return Promise.resolve(Fi);
          if (Fi instanceof Promise)
            throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
          return vi;
        };
        if (Or.common.async === !1) {
          const vi = this._def.schema._parseSync({
            data: Or.data,
            path: Or.path,
            parent: Or
          });
          return vi.status === "aborted" ? po : (vi.status === "dirty" && dr.dirty(), gi(vi.value), { status: dr.value, value: vi.value });
        } else
          return this._def.schema._parseAsync({ data: Or.data, path: Or.path, parent: Or }).then((vi) => vi.status === "aborted" ? po : (vi.status === "dirty" && dr.dirty(), gi(vi.value).then(() => ({ status: dr.value, value: vi.value }))));
      }
      if (Zr.type === "transform")
        if (Or.common.async === !1) {
          const gi = this._def.schema._parseSync({
            data: Or.data,
            path: Or.path,
            parent: Or
          });
          if (!Uc(gi))
            return gi;
          const vi = Zr.transform(gi.value, ni);
          if (vi instanceof Promise)
            throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
          return { status: dr.value, value: vi };
        } else
          return this._def.schema._parseAsync({ data: Or.data, path: Or.path, parent: Or }).then((gi) => Uc(gi) ? Promise.resolve(Zr.transform(gi.value, ni)).then((vi) => ({ status: dr.value, value: vi })) : gi);
      zo.assertNever(Zr);
    }
  }
  vu.create = (rr, ft, dr) => new vu({
    schema: rr,
    typeName: uo.ZodEffects,
    effect: ft,
    ...vo(dr)
  }), vu.createWithPreprocess = (rr, ft, dr) => new vu({
    schema: ft,
    effect: { type: "preprocess", transform: rr },
    typeName: uo.ZodEffects,
    ...vo(dr)
  });
  class Qu extends xo {
    _parse(ft) {
      return this._getType(ft) === Ms.undefined ? Ha(void 0) : this._def.innerType._parse(ft);
    }
    unwrap() {
      return this._def.innerType;
    }
  }
  Qu.create = (rr, ft) => new Qu({
    innerType: rr,
    typeName: uo.ZodOptional,
    ...vo(ft)
  });
  class pf extends xo {
    _parse(ft) {
      return this._getType(ft) === Ms.null ? Ha(null) : this._def.innerType._parse(ft);
    }
    unwrap() {
      return this._def.innerType;
    }
  }
  pf.create = (rr, ft) => new pf({
    innerType: rr,
    typeName: uo.ZodNullable,
    ...vo(ft)
  });
  class tc extends xo {
    _parse(ft) {
      const { ctx: dr } = this._processInputParams(ft);
      let Or = dr.data;
      return dr.parsedType === Ms.undefined && (Or = this._def.defaultValue()), this._def.innerType._parse({
        data: Or,
        path: dr.path,
        parent: dr
      });
    }
    removeDefault() {
      return this._def.innerType;
    }
  }
  tc.create = (rr, ft) => new tc({
    innerType: rr,
    typeName: uo.ZodDefault,
    defaultValue: typeof ft.default == "function" ? ft.default : () => ft.default,
    ...vo(ft)
  });
  class Gc extends xo {
    _parse(ft) {
      const { ctx: dr } = this._processInputParams(ft), Or = {
        ...dr,
        common: {
          ...dr.common,
          issues: []
        }
      }, Zr = this._def.innerType._parse({
        data: Or.data,
        path: Or.path,
        parent: {
          ...Or
        }
      });
      return Mc(Zr) ? Zr.then((ni) => ({
        status: "valid",
        value: ni.status === "valid" ? ni.value : this._def.catchValue({
          get error() {
            return new Eu(Or.common.issues);
          },
          input: Or.data
        })
      })) : {
        status: "valid",
        value: Zr.status === "valid" ? Zr.value : this._def.catchValue({
          get error() {
            return new Eu(Or.common.issues);
          },
          input: Or.data
        })
      };
    }
    removeCatch() {
      return this._def.innerType;
    }
  }
  Gc.create = (rr, ft) => new Gc({
    innerType: rr,
    typeName: uo.ZodCatch,
    catchValue: typeof ft.catch == "function" ? ft.catch : () => ft.catch,
    ...vo(ft)
  });
  class jc extends xo {
    _parse(ft) {
      if (this._getType(ft) !== Ms.nan) {
        const Or = this._getOrReturnCtx(ft);
        return Hs(Or, {
          code: Cs.invalid_type,
          expected: Ms.nan,
          received: Or.parsedType
        }), po;
      }
      return { status: "valid", value: ft.data };
    }
  }
  jc.create = (rr) => new jc({
    typeName: uo.ZodNaN,
    ...vo(rr)
  });
  const h1 = Symbol("zod_brand");
  class rc extends xo {
    _parse(ft) {
      const { ctx: dr } = this._processInputParams(ft), Or = dr.data;
      return this._def.type._parse({
        data: Or,
        path: dr.path,
        parent: dr
      });
    }
    unwrap() {
      return this._def.type;
    }
  }
  class Wc extends xo {
    _parse(ft) {
      const { status: dr, ctx: Or } = this._processInputParams(ft);
      if (Or.common.async)
        return (async () => {
          const ni = await this._def.in._parseAsync({
            data: Or.data,
            path: Or.path,
            parent: Or
          });
          return ni.status === "aborted" ? po : ni.status === "dirty" ? (dr.dirty(), f1(ni.value)) : this._def.out._parseAsync({
            data: ni.value,
            path: Or.path,
            parent: Or
          });
        })();
      {
        const Zr = this._def.in._parseSync({
          data: Or.data,
          path: Or.path,
          parent: Or
        });
        return Zr.status === "aborted" ? po : Zr.status === "dirty" ? (dr.dirty(), {
          status: "dirty",
          value: Zr.value
        }) : this._def.out._parseSync({
          data: Zr.value,
          path: Or.path,
          parent: Or
        });
      }
    }
    static create(ft, dr) {
      return new Wc({
        in: ft,
        out: dr,
        typeName: uo.ZodPipeline
      });
    }
  }
  const A1 = (rr, ft = {}, dr) => rr ? Nf.create().superRefine((Or, Zr) => {
    var ni, gi;
    if (!rr(Or)) {
      const vi = typeof ft == "function" ? ft(Or) : typeof ft == "string" ? { message: ft } : ft, Fi = (gi = (ni = vi.fatal) !== null && ni !== void 0 ? ni : dr) !== null && gi !== void 0 ? gi : !0, Gi = typeof vi == "string" ? { message: vi } : vi;
      Zr.addIssue({ code: "custom", ...Gi, fatal: Fi });
    }
  }) : Nf.create(), u4 = {
    object: aa.lazycreate
  };
  var uo;
  (function(rr) {
    rr.ZodString = "ZodString", rr.ZodNumber = "ZodNumber", rr.ZodNaN = "ZodNaN", rr.ZodBigInt = "ZodBigInt", rr.ZodBoolean = "ZodBoolean", rr.ZodDate = "ZodDate", rr.ZodSymbol = "ZodSymbol", rr.ZodUndefined = "ZodUndefined", rr.ZodNull = "ZodNull", rr.ZodAny = "ZodAny", rr.ZodUnknown = "ZodUnknown", rr.ZodNever = "ZodNever", rr.ZodVoid = "ZodVoid", rr.ZodArray = "ZodArray", rr.ZodObject = "ZodObject", rr.ZodUnion = "ZodUnion", rr.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", rr.ZodIntersection = "ZodIntersection", rr.ZodTuple = "ZodTuple", rr.ZodRecord = "ZodRecord", rr.ZodMap = "ZodMap", rr.ZodSet = "ZodSet", rr.ZodFunction = "ZodFunction", rr.ZodLazy = "ZodLazy", rr.ZodLiteral = "ZodLiteral", rr.ZodEnum = "ZodEnum", rr.ZodEffects = "ZodEffects", rr.ZodNativeEnum = "ZodNativeEnum", rr.ZodOptional = "ZodOptional", rr.ZodNullable = "ZodNullable", rr.ZodDefault = "ZodDefault", rr.ZodCatch = "ZodCatch", rr.ZodPromise = "ZodPromise", rr.ZodBranded = "ZodBranded", rr.ZodPipeline = "ZodPipeline";
  })(uo || (uo = {}));
  const Dl = (rr, ft = {
    message: `Input not instance of ${rr.name}`
  }) => A1((dr) => dr instanceof rr, ft), Nl = Va.create, Hd = lf.create, g1 = jc.create, f4 = df.create, p1 = Fc.create, ys = oa.create, c4 = Sl.create, y1 = Lc.create, I1 = ia.create, Kd = Nf.create, l4 = Pf.create, Lo = qu.create, d4 = Tl.create, m1 = Sa.create, w1 = aa.create, E1 = aa.strictCreate, Vd = hf.create, h4 = Hc.create, b1 = Kc.create, B1 = Ou.create, C1 = Vc.create, Gd = Bu.create, jd = qf.create, Wd = du.create, eu = $f.create, A4 = $a.create, g4 = Af.create, zd = ca.create, k1 = gf.create, Ga = vu.create, S1 = Qu.create, Pl = pf.create, T1 = vu.createWithPreprocess, Jd = Wc.create;
  var ya = /* @__PURE__ */ Object.freeze({
    __proto__: null,
    defaultErrorMap: Qc,
    setErrorMap: $p,
    getErrorMap: vl,
    makeIssue: Cl,
    EMPTY_PATH: e4,
    addIssueToContext: Hs,
    ParseStatus: La,
    INVALID: po,
    DIRTY: f1,
    OK: Ha,
    isAborted: bu,
    isDirty: ea,
    isValid: Uc,
    isAsync: Mc,
    get util() {
      return zo;
    },
    get objectUtil() {
      return Md;
    },
    ZodParsedType: Ms,
    getParsedType: cf,
    ZodType: xo,
    ZodString: Va,
    ZodNumber: lf,
    ZodBigInt: df,
    ZodBoolean: Fc,
    ZodDate: oa,
    ZodSymbol: Sl,
    ZodUndefined: Lc,
    ZodNull: ia,
    ZodAny: Nf,
    ZodUnknown: Pf,
    ZodNever: qu,
    ZodVoid: Tl,
    ZodArray: Sa,
    ZodObject: aa,
    ZodUnion: hf,
    ZodDiscriminatedUnion: Hc,
    ZodIntersection: Kc,
    ZodTuple: Ou,
    ZodRecord: Vc,
    ZodMap: Bu,
    ZodSet: qf,
    ZodFunction: du,
    ZodLazy: $f,
    ZodLiteral: $a,
    ZodEnum: Af,
    ZodNativeEnum: ca,
    ZodPromise: gf,
    ZodEffects: vu,
    ZodTransformer: vu,
    ZodOptional: Qu,
    ZodNullable: pf,
    ZodDefault: tc,
    ZodCatch: Gc,
    ZodNaN: jc,
    BRAND: h1,
    ZodBranded: rc,
    ZodPipeline: Wc,
    custom: A1,
    Schema: xo,
    ZodSchema: xo,
    late: u4,
    get ZodFirstPartyTypeKind() {
      return uo;
    },
    coerce: {
      string: (rr) => Va.create({ ...rr, coerce: !0 }),
      number: (rr) => lf.create({ ...rr, coerce: !0 }),
      boolean: (rr) => Fc.create({
        ...rr,
        coerce: !0
      }),
      bigint: (rr) => df.create({ ...rr, coerce: !0 }),
      date: (rr) => oa.create({ ...rr, coerce: !0 })
    },
    any: Kd,
    array: m1,
    bigint: f4,
    boolean: p1,
    date: ys,
    discriminatedUnion: h4,
    effect: Ga,
    enum: g4,
    function: Wd,
    instanceof: Dl,
    intersection: b1,
    lazy: eu,
    literal: A4,
    map: Gd,
    nan: g1,
    nativeEnum: zd,
    never: Lo,
    null: I1,
    nullable: Pl,
    number: Hd,
    object: w1,
    oboolean: () => p1().optional(),
    onumber: () => Hd().optional(),
    optional: S1,
    ostring: () => Nl().optional(),
    pipeline: Jd,
    preprocess: T1,
    promise: k1,
    record: C1,
    set: jd,
    strictObject: E1,
    string: Nl,
    symbol: c4,
    transformer: Ga,
    tuple: B1,
    undefined: y1,
    union: Vd,
    unknown: l4,
    void: d4,
    NEVER: po,
    ZodIssueCode: Cs,
    quotelessJson: Zp,
    ZodError: Eu
  });
  const R1 = ya.string().regex(/^[a-fA-F0-9]$/), I4 = ya.string().regex(/^[a-fA-F0-9]{64}$/), ic = ya.number().min(0).max(4294967295), x1 = ya.bigint(), Yd = ya.instanceof(Uint8Array), hu = ya.union([R1, ic, ya.string(), Yd]).array(), nc = ya.union([hu, R1, Yd]), ql = ya.array(nc), Xd = ya.object({
    value: ya.union([ic, x1]),
    scriptPubKey: nc
  }), D1 = ya.object({
    txid: I4,
    vout: ic,
    scriptSig: nc,
    sequence: ic,
    prevout: Xd.optional(),
    witness: ql
  }), N1 = {
    TxData: ya.object({
      version: ic,
      vin: ya.array(D1),
      vout: ya.array(Xd),
      locktime: ic
    })
  };
  class yf {
    constructor(ft) {
      typeof ft == "string" && (ft = Ai.hex(ft)), ft instanceof Uint8Array && (ft = Ja.decode(ft));
      const dr = N1.TxData;
      this._data = dr.parse(Ja.create(ft));
    }
    get data() {
      return this._data;
    }
    get version() {
      return this.data.version;
    }
    get vin() {
      return this.data.vin.map((ft, dr) => new u1(this.data, dr));
    }
    get vout() {
      return this.data.vout.map((ft) => new Ud(ft));
    }
    get locktime() {
      return new _p(this.data.locktime);
    }
    get base() {
      return Ja.encode(this.data, !0);
    }
    get buff() {
      return Ja.encode(this.data);
    }
    get raw() {
      return this.buff.raw;
    }
    get hex() {
      return this.buff.hex;
    }
    get size() {
      return this.raw.length;
    }
    get bsize() {
      return this.base.length;
    }
    get weight() {
      return this.bsize * 3 + this.size;
    }
    get vsize() {
      const ft = this.weight % 4 > 0 ? 1 : 0;
      return Math.floor(this.weight / 4) + ft;
    }
    get hash() {
      return zu(this.buff).reverse().hex;
    }
    get txid() {
      return zu(this.base).reverse().hex;
    }
    async export() {
      const { size: ft, weight: dr, vsize: Or, hex: Zr } = this, ni = this.txid, gi = this.hash;
      return { txid: ni, hash: gi, ...this.data, size: ft, weight: dr, vsize: Or, hex: Zr };
    }
  }
  return main$1.Address = ml, main$1.Input = u1, main$1.Output = Ud, main$1.Script = Nr, main$1.Sequence = o1, main$1.Signer = pa, main$1.Tap = zp, main$1.Transaction = yf, main$1.Tx = Ja, main$1.Witness = a1, main$1;
}
var build = {}, ascii = {}, hasRequiredAscii;
function requireAscii() {
  if (hasRequiredAscii) return ascii;
  hasRequiredAscii = 1, Object.defineProperty(ascii, "__esModule", { value: !0 }), ascii.fromAscii = ascii.toAscii = void 0;
  function o(c) {
    const y = (t) => t.split("").map((d) => {
      const E = d.charCodeAt(0);
      if (E < 32 || E > 126)
        throw new Error("Cannot encode character that is out of printable ASCII range: " + E);
      return E;
    });
    return Uint8Array.from(y(c));
  }
  ascii.toAscii = o;
  function g(c) {
    return ((t) => t.map((d) => {
      if (d < 32 || d > 126)
        throw new Error("Cannot decode character that is out of printable ASCII range: " + d);
      return String.fromCharCode(d);
    }))(Array.from(c)).join("");
  }
  return ascii.fromAscii = g, ascii;
}
var base64 = {}, hasRequiredBase64;
function requireBase64() {
  if (hasRequiredBase64) return base64;
  hasRequiredBase64 = 1;
  var o = base64 && base64.__createBinding || (Object.create ? function(E, B, D, x) {
    x === void 0 && (x = D);
    var v = Object.getOwnPropertyDescriptor(B, D);
    (!v || ("get" in v ? !B.__esModule : v.writable || v.configurable)) && (v = { enumerable: !0, get: function() {
      return B[D];
    } }), Object.defineProperty(E, x, v);
  } : function(E, B, D, x) {
    x === void 0 && (x = D), E[x] = B[D];
  }), g = base64 && base64.__setModuleDefault || (Object.create ? function(E, B) {
    Object.defineProperty(E, "default", { enumerable: !0, value: B });
  } : function(E, B) {
    E.default = B;
  }), c = base64 && base64.__importStar || function(E) {
    if (E && E.__esModule) return E;
    var B = {};
    if (E != null) for (var D in E) D !== "default" && Object.prototype.hasOwnProperty.call(E, D) && o(B, E, D);
    return g(B, E), B;
  };
  Object.defineProperty(base64, "__esModule", { value: !0 }), base64.fromBase64 = base64.toBase64 = void 0;
  const y = c(requireBase64Js());
  function t(E) {
    return y.fromByteArray(E);
  }
  base64.toBase64 = t;
  function d(E) {
    if (!E.match(/^[a-zA-Z0-9+/]*={0,2}$/))
      throw new Error("Invalid base64 string format");
    return y.toByteArray(E);
  }
  return base64.fromBase64 = d, base64;
}
var bech32 = {}, hasRequiredBech32;
function requireBech32() {
  if (hasRequiredBech32) return bech32;
  hasRequiredBech32 = 1;
  var o = bech32 && bech32.__createBinding || (Object.create ? function(B, D, x, v) {
    v === void 0 && (v = x);
    var F = Object.getOwnPropertyDescriptor(D, x);
    (!F || ("get" in F ? !D.__esModule : F.writable || F.configurable)) && (F = { enumerable: !0, get: function() {
      return D[x];
    } }), Object.defineProperty(B, v, F);
  } : function(B, D, x, v) {
    v === void 0 && (v = x), B[v] = D[x];
  }), g = bech32 && bech32.__setModuleDefault || (Object.create ? function(B, D) {
    Object.defineProperty(B, "default", { enumerable: !0, value: D });
  } : function(B, D) {
    B.default = D;
  }), c = bech32 && bech32.__importStar || function(B) {
    if (B && B.__esModule) return B;
    var D = {};
    if (B != null) for (var x in B) x !== "default" && Object.prototype.hasOwnProperty.call(B, x) && o(D, B, x);
    return g(D, B), D;
  };
  Object.defineProperty(bech32, "__esModule", { value: !0 }), bech32.normalizeBech32 = bech32.fromBech32 = bech32.toBech32 = void 0;
  const y = c(requireBech32$2());
  function t(B, D, x) {
    return y.encode(B, y.toWords(D), x);
  }
  bech32.toBech32 = t;
  function d(B, D = 1 / 0) {
    const x = y.decode(B, D);
    return {
      prefix: x.prefix,
      data: new Uint8Array(y.fromWords(x.words))
    };
  }
  bech32.fromBech32 = d;
  function E(B) {
    const { prefix: D, data: x } = d(B);
    return t(D, x);
  }
  return bech32.normalizeBech32 = E, bech32;
}
var hex = {}, hasRequiredHex;
function requireHex() {
  if (hasRequiredHex) return hex;
  hasRequiredHex = 1, Object.defineProperty(hex, "__esModule", { value: !0 }), hex.fromHex = hex.toHex = void 0;
  function o(c) {
    let y = "";
    for (const t of c)
      y += ("0" + t.toString(16)).slice(-2);
    return y;
  }
  hex.toHex = o;
  function g(c) {
    if (c.length % 2 !== 0)
      throw new Error("hex string length must be a multiple of 2");
    const y = new Uint8Array(c.length / 2);
    for (let t = 0; t < y.length; t++) {
      const d = 2 * t, E = c.slice(d, d + 2);
      if (!E.match(/[0-9a-f]{2}/i))
        throw new Error("hex string contains invalid characters");
      y[t] = parseInt(E, 16);
    }
    return y;
  }
  return hex.fromHex = g, hex;
}
var rfc3339 = {}, hasRequiredRfc3339;
function requireRfc3339() {
  if (hasRequiredRfc3339) return rfc3339;
  hasRequiredRfc3339 = 1, Object.defineProperty(rfc3339, "__esModule", { value: !0 }), rfc3339.toRfc3339 = rfc3339.fromRfc3339 = void 0;
  const o = /^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2}):(\d{2})(\.\d{1,9})?((?:[+-]\d{2}:\d{2})|Z)$/;
  function g(t, d = 2) {
    return t.toString().padStart(d, "0");
  }
  function c(t) {
    const d = o.exec(t);
    if (!d)
      throw new Error("Date string is not in RFC3339 format");
    const E = +d[1], B = +d[2], D = +d[3], x = +d[4], v = +d[5], F = +d[6], M = d[7] ? Math.floor(+d[7] * 1e3) : 0;
    let U, L, H;
    d[8] === "Z" ? (U = 1, L = 0, H = 0) : (U = d[8].substring(0, 1) === "-" ? -1 : 1, L = +d[8].substring(1, 3), H = +d[8].substring(4, 6));
    const fe = U * (L * 60 + H) * 60, ge = /* @__PURE__ */ new Date();
    return ge.setUTCFullYear(E, B - 1, D), ge.setUTCHours(x, v, F, M), new Date(ge.getTime() - fe * 1e3);
  }
  rfc3339.fromRfc3339 = c;
  function y(t) {
    const d = t.getUTCFullYear(), E = g(t.getUTCMonth() + 1), B = g(t.getUTCDate()), D = g(t.getUTCHours()), x = g(t.getUTCMinutes()), v = g(t.getUTCSeconds()), F = g(t.getUTCMilliseconds(), 3);
    return `${d}-${E}-${B}T${D}:${x}:${v}.${F}Z`;
  }
  return rfc3339.toRfc3339 = y, rfc3339;
}
var utf8 = {}, hasRequiredUtf8;
function requireUtf8() {
  if (hasRequiredUtf8) return utf8;
  hasRequiredUtf8 = 1, Object.defineProperty(utf8, "__esModule", { value: !0 }), utf8.fromUtf8 = utf8.toUtf8 = void 0;
  function o(c) {
    return new TextEncoder().encode(c);
  }
  utf8.toUtf8 = o;
  function g(c, y = !1) {
    const t = !y;
    return new TextDecoder("utf-8", { fatal: t }).decode(c);
  }
  return utf8.fromUtf8 = g, utf8;
}
var hasRequiredBuild;
function requireBuild() {
  return hasRequiredBuild || (hasRequiredBuild = 1, function(o) {
    Object.defineProperty(o, "__esModule", { value: !0 }), o.toUtf8 = o.fromUtf8 = o.toRfc3339 = o.fromRfc3339 = o.toHex = o.fromHex = o.toBech32 = o.normalizeBech32 = o.fromBech32 = o.toBase64 = o.fromBase64 = o.toAscii = o.fromAscii = void 0;
    var g = requireAscii();
    Object.defineProperty(o, "fromAscii", { enumerable: !0, get: function() {
      return g.fromAscii;
    } }), Object.defineProperty(o, "toAscii", { enumerable: !0, get: function() {
      return g.toAscii;
    } });
    var c = requireBase64();
    Object.defineProperty(o, "fromBase64", { enumerable: !0, get: function() {
      return c.fromBase64;
    } }), Object.defineProperty(o, "toBase64", { enumerable: !0, get: function() {
      return c.toBase64;
    } });
    var y = requireBech32();
    Object.defineProperty(o, "fromBech32", { enumerable: !0, get: function() {
      return y.fromBech32;
    } }), Object.defineProperty(o, "normalizeBech32", { enumerable: !0, get: function() {
      return y.normalizeBech32;
    } }), Object.defineProperty(o, "toBech32", { enumerable: !0, get: function() {
      return y.toBech32;
    } });
    var t = requireHex();
    Object.defineProperty(o, "fromHex", { enumerable: !0, get: function() {
      return t.fromHex;
    } }), Object.defineProperty(o, "toHex", { enumerable: !0, get: function() {
      return t.toHex;
    } });
    var d = requireRfc3339();
    Object.defineProperty(o, "fromRfc3339", { enumerable: !0, get: function() {
      return d.fromRfc3339;
    } }), Object.defineProperty(o, "toRfc3339", { enumerable: !0, get: function() {
      return d.toRfc3339;
    } });
    var E = requireUtf8();
    Object.defineProperty(o, "fromUtf8", { enumerable: !0, get: function() {
      return E.fromUtf8;
    } }), Object.defineProperty(o, "toUtf8", { enumerable: !0, get: function() {
      return E.toUtf8;
    } });
  }(build)), build;
}
var lib$1 = {}, hasRequiredLib$1;
function requireLib$1() {
  return hasRequiredLib$1 || (hasRequiredLib$1 = 1, function(o) {
    Object.defineProperty(o, "__esModule", { value: !0 }), o.bytes = o.stringToBytes = o.str = o.bytesToString = o.hex = o.utf8 = o.bech32m = o.bech32 = o.base58check = o.createBase58check = o.base58xmr = o.base58xrp = o.base58flickr = o.base58 = o.base64urlnopad = o.base64url = o.base64nopad = o.base64 = o.base32crockford = o.base32hexnopad = o.base32hex = o.base32nopad = o.base32 = o.base16 = o.utils = void 0, o.assertNumber = g;
    // @__NO_SIDE_EFFECTS__
    function g(Be) {
      if (!Number.isSafeInteger(Be))
        throw new Error(`Wrong integer: ${Be}`);
    }
    function c(Be) {
      return Be instanceof Uint8Array || Be != null && typeof Be == "object" && Be.constructor.name === "Uint8Array";
    }
    // @__NO_SIDE_EFFECTS__
    function y(...Be) {
      const ke = (st) => st, xe = (st, Dt) => (er) => st(Dt(er)), Ne = Be.map((st) => st.encode).reduceRight(xe, ke), Et = Be.map((st) => st.decode).reduce(xe, ke);
      return { encode: Ne, decode: Et };
    }
    // @__NO_SIDE_EFFECTS__
    function t(Be) {
      return {
        encode: (ke) => {
          if (!Array.isArray(ke) || ke.length && typeof ke[0] != "number")
            throw new Error("alphabet.encode input should be an array of numbers");
          return ke.map((xe) => {
            if (xe < 0 || xe >= Be.length)
              throw new Error(`Digit index outside alphabet: ${xe} (alphabet: ${Be.length})`);
            return Be[xe];
          });
        },
        decode: (ke) => {
          if (!Array.isArray(ke) || ke.length && typeof ke[0] != "string")
            throw new Error("alphabet.decode input should be array of strings");
          return ke.map((xe) => {
            if (typeof xe != "string")
              throw new Error(`alphabet.decode: not string element=${xe}`);
            const Ne = Be.indexOf(xe);
            if (Ne === -1)
              throw new Error(`Unknown letter: "${xe}". Allowed: ${Be}`);
            return Ne;
          });
        }
      };
    }
    // @__NO_SIDE_EFFECTS__
    function d(Be = "") {
      if (typeof Be != "string")
        throw new Error("join separator should be string");
      return {
        encode: (ke) => {
          if (!Array.isArray(ke) || ke.length && typeof ke[0] != "string")
            throw new Error("join.encode input should be array of strings");
          for (let xe of ke)
            if (typeof xe != "string")
              throw new Error(`join.encode: non-string input=${xe}`);
          return ke.join(Be);
        },
        decode: (ke) => {
          if (typeof ke != "string")
            throw new Error("join.decode input should be string");
          return ke.split(Be);
        }
      };
    }
    // @__NO_SIDE_EFFECTS__
    function E(Be, ke = "=") {
      if (typeof ke != "string")
        throw new Error("padding chr should be string");
      return {
        encode(xe) {
          if (!Array.isArray(xe) || xe.length && typeof xe[0] != "string")
            throw new Error("padding.encode input should be array of strings");
          for (let Ne of xe)
            if (typeof Ne != "string")
              throw new Error(`padding.encode: non-string input=${Ne}`);
          for (; xe.length * Be % 8; )
            xe.push(ke);
          return xe;
        },
        decode(xe) {
          if (!Array.isArray(xe) || xe.length && typeof xe[0] != "string")
            throw new Error("padding.encode input should be array of strings");
          for (let Et of xe)
            if (typeof Et != "string")
              throw new Error(`padding.decode: non-string input=${Et}`);
          let Ne = xe.length;
          if (Ne * Be % 8)
            throw new Error("Invalid padding: string should have whole number of bytes");
          for (; Ne > 0 && xe[Ne - 1] === ke; Ne--)
            if (!((Ne - 1) * Be % 8))
              throw new Error("Invalid padding: string has too much padding");
          return xe.slice(0, Ne);
        }
      };
    }
    // @__NO_SIDE_EFFECTS__
    function B(Be) {
      if (typeof Be != "function")
        throw new Error("normalize fn should be function");
      return { encode: (ke) => ke, decode: (ke) => Be(ke) };
    }
    // @__NO_SIDE_EFFECTS__
    function D(Be, ke, xe) {
      if (ke < 2)
        throw new Error(`convertRadix: wrong from=${ke}, base cannot be less than 2`);
      if (xe < 2)
        throw new Error(`convertRadix: wrong to=${xe}, base cannot be less than 2`);
      if (!Array.isArray(Be))
        throw new Error("convertRadix: data should be array");
      if (!Be.length)
        return [];
      let Ne = 0;
      const Et = [], st = Array.from(Be);
      for (st.forEach((Dt) => {
        if (Dt < 0 || Dt >= ke)
          throw new Error(`Wrong integer: ${Dt}`);
      }); ; ) {
        let Dt = 0, er = !0;
        for (let xt = Ne; xt < st.length; xt++) {
          const ir = st[xt], sr = ke * Dt + ir;
          if (!Number.isSafeInteger(sr) || ke * Dt / ke !== Dt || sr - ir !== ke * Dt)
            throw new Error("convertRadix: carry overflow");
          Dt = sr % xe;
          const yr = Math.floor(sr / xe);
          if (st[xt] = yr, !Number.isSafeInteger(yr) || yr * xe + Dt !== sr)
            throw new Error("convertRadix: carry overflow");
          if (er)
            yr ? er = !1 : Ne = xt;
          else continue;
        }
        if (Et.push(Dt), er)
          break;
      }
      for (let Dt = 0; Dt < Be.length - 1 && Be[Dt] === 0; Dt++)
        Et.push(0);
      return Et.reverse();
    }
    const x = /* @__NO_SIDE_EFFECTS__ */ (Be, ke) => ke ? /* @__PURE__ */ x(ke, Be % ke) : Be, v = /* @__NO_SIDE_EFFECTS__ */ (Be, ke) => Be + (ke - /* @__PURE__ */ x(Be, ke));
    // @__NO_SIDE_EFFECTS__
    function F(Be, ke, xe, Ne) {
      if (!Array.isArray(Be))
        throw new Error("convertRadix2: data should be array");
      if (ke <= 0 || ke > 32)
        throw new Error(`convertRadix2: wrong from=${ke}`);
      if (xe <= 0 || xe > 32)
        throw new Error(`convertRadix2: wrong to=${xe}`);
      if (/* @__PURE__ */ v(ke, xe) > 32)
        throw new Error(`convertRadix2: carry overflow from=${ke} to=${xe} carryBits=${/* @__PURE__ */ v(ke, xe)}`);
      let Et = 0, st = 0;
      const Dt = 2 ** xe - 1, er = [];
      for (const xt of Be) {
        if (xt >= 2 ** ke)
          throw new Error(`convertRadix2: invalid data word=${xt} from=${ke}`);
        if (Et = Et << ke | xt, st + ke > 32)
          throw new Error(`convertRadix2: carry overflow pos=${st} from=${ke}`);
        for (st += ke; st >= xe; st -= xe)
          er.push((Et >> st - xe & Dt) >>> 0);
        Et &= 2 ** st - 1;
      }
      if (Et = Et << xe - st & Dt, !Ne && st >= ke)
        throw new Error("Excess padding");
      if (!Ne && Et)
        throw new Error(`Non-zero padding: ${Et}`);
      return Ne && st > 0 && er.push(Et >>> 0), er;
    }
    // @__NO_SIDE_EFFECTS__
    function M(Be) {
      return {
        encode: (ke) => {
          if (!c(ke))
            throw new Error("radix.encode input should be Uint8Array");
          return /* @__PURE__ */ D(Array.from(ke), 2 ** 8, Be);
        },
        decode: (ke) => {
          if (!Array.isArray(ke) || ke.length && typeof ke[0] != "number")
            throw new Error("radix.decode input should be array of numbers");
          return Uint8Array.from(/* @__PURE__ */ D(ke, Be, 2 ** 8));
        }
      };
    }
    // @__NO_SIDE_EFFECTS__
    function U(Be, ke = !1) {
      if (Be <= 0 || Be > 32)
        throw new Error("radix2: bits should be in (0..32]");
      if (/* @__PURE__ */ v(8, Be) > 32 || /* @__PURE__ */ v(Be, 8) > 32)
        throw new Error("radix2: carry overflow");
      return {
        encode: (xe) => {
          if (!c(xe))
            throw new Error("radix2.encode input should be Uint8Array");
          return /* @__PURE__ */ F(Array.from(xe), 8, Be, !ke);
        },
        decode: (xe) => {
          if (!Array.isArray(xe) || xe.length && typeof xe[0] != "number")
            throw new Error("radix2.decode input should be array of numbers");
          return Uint8Array.from(/* @__PURE__ */ F(xe, Be, 8, ke));
        }
      };
    }
    // @__NO_SIDE_EFFECTS__
    function L(Be) {
      if (typeof Be != "function")
        throw new Error("unsafeWrapper fn should be function");
      return function(...ke) {
        try {
          return Be.apply(null, ke);
        } catch {
        }
      };
    }
    // @__NO_SIDE_EFFECTS__
    function H(Be, ke) {
      if (typeof ke != "function")
        throw new Error("checksum fn should be function");
      return {
        encode(xe) {
          if (!c(xe))
            throw new Error("checksum.encode: input should be Uint8Array");
          const Ne = ke(xe).slice(0, Be), Et = new Uint8Array(xe.length + Be);
          return Et.set(xe), Et.set(Ne, xe.length), Et;
        },
        decode(xe) {
          if (!c(xe))
            throw new Error("checksum.decode: input should be Uint8Array");
          const Ne = xe.slice(0, -Be), Et = ke(Ne).slice(0, Be), st = xe.slice(-Be);
          for (let Dt = 0; Dt < Be; Dt++)
            if (Et[Dt] !== st[Dt])
              throw new Error("Invalid checksum");
          return Ne;
        }
      };
    }
    o.utils = {
      alphabet: t,
      chain: y,
      checksum: H,
      convertRadix: D,
      convertRadix2: F,
      radix: M,
      radix2: U,
      join: d,
      padding: E
    }, o.base16 = /* @__PURE__ */ y(/* @__PURE__ */ U(4), /* @__PURE__ */ t("0123456789ABCDEF"), /* @__PURE__ */ d("")), o.base32 = /* @__PURE__ */ y(/* @__PURE__ */ U(5), /* @__PURE__ */ t("ABCDEFGHIJKLMNOPQRSTUVWXYZ234567"), /* @__PURE__ */ E(5), /* @__PURE__ */ d("")), o.base32nopad = /* @__PURE__ */ y(/* @__PURE__ */ U(5), /* @__PURE__ */ t("ABCDEFGHIJKLMNOPQRSTUVWXYZ234567"), /* @__PURE__ */ d("")), o.base32hex = /* @__PURE__ */ y(/* @__PURE__ */ U(5), /* @__PURE__ */ t("0123456789ABCDEFGHIJKLMNOPQRSTUV"), /* @__PURE__ */ E(5), /* @__PURE__ */ d("")), o.base32hexnopad = /* @__PURE__ */ y(/* @__PURE__ */ U(5), /* @__PURE__ */ t("0123456789ABCDEFGHIJKLMNOPQRSTUV"), /* @__PURE__ */ d("")), o.base32crockford = /* @__PURE__ */ y(/* @__PURE__ */ U(5), /* @__PURE__ */ t("0123456789ABCDEFGHJKMNPQRSTVWXYZ"), /* @__PURE__ */ d(""), /* @__PURE__ */ B((Be) => Be.toUpperCase().replace(/O/g, "0").replace(/[IL]/g, "1"))), o.base64 = /* @__PURE__ */ y(/* @__PURE__ */ U(6), /* @__PURE__ */ t("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/"), /* @__PURE__ */ E(6), /* @__PURE__ */ d("")), o.base64nopad = /* @__PURE__ */ y(/* @__PURE__ */ U(6), /* @__PURE__ */ t("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/"), /* @__PURE__ */ d("")), o.base64url = /* @__PURE__ */ y(/* @__PURE__ */ U(6), /* @__PURE__ */ t("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_"), /* @__PURE__ */ E(6), /* @__PURE__ */ d("")), o.base64urlnopad = /* @__PURE__ */ y(/* @__PURE__ */ U(6), /* @__PURE__ */ t("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_"), /* @__PURE__ */ d(""));
    const fe = (Be) => /* @__PURE__ */ y(/* @__PURE__ */ M(58), /* @__PURE__ */ t(Be), /* @__PURE__ */ d(""));
    o.base58 = fe("123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz"), o.base58flickr = fe("123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ"), o.base58xrp = fe("rpshnaf39wBUDNEGHJKLM4PQRST7VWXYZ2bcdeCg65jkm8oFqi1tuvAxyz");
    const ge = [0, 2, 3, 5, 6, 7, 9, 10, 11];
    o.base58xmr = {
      encode(Be) {
        let ke = "";
        for (let xe = 0; xe < Be.length; xe += 8) {
          const Ne = Be.subarray(xe, xe + 8);
          ke += o.base58.encode(Ne).padStart(ge[Ne.length], "1");
        }
        return ke;
      },
      decode(Be) {
        let ke = [];
        for (let xe = 0; xe < Be.length; xe += 11) {
          const Ne = Be.slice(xe, xe + 11), Et = ge.indexOf(Ne.length), st = o.base58.decode(Ne);
          for (let Dt = 0; Dt < st.length - Et; Dt++)
            if (st[Dt] !== 0)
              throw new Error("base58xmr: wrong padding");
          ke = ke.concat(Array.from(st.slice(st.length - Et)));
        }
        return Uint8Array.from(ke);
      }
    };
    const Ie = (Be) => /* @__PURE__ */ y(/* @__PURE__ */ H(4, (ke) => Be(Be(ke))), o.base58);
    o.createBase58check = Ie, o.base58check = o.createBase58check;
    const Ee = /* @__PURE__ */ y(/* @__PURE__ */ t("qpzry9x8gf2tvdw0s3jn54khce6mua7l"), /* @__PURE__ */ d("")), Se = [996825010, 642813549, 513874426, 1027748829, 705979059];
    // @__NO_SIDE_EFFECTS__
    function ze(Be) {
      const ke = Be >> 25;
      let xe = (Be & 33554431) << 5;
      for (let Ne = 0; Ne < Se.length; Ne++)
        (ke >> Ne & 1) === 1 && (xe ^= Se[Ne]);
      return xe;
    }
    // @__NO_SIDE_EFFECTS__
    function He(Be, ke, xe = 1) {
      const Ne = Be.length;
      let Et = 1;
      for (let st = 0; st < Ne; st++) {
        const Dt = Be.charCodeAt(st);
        if (Dt < 33 || Dt > 126)
          throw new Error(`Invalid prefix (${Be})`);
        Et = /* @__PURE__ */ ze(Et) ^ Dt >> 5;
      }
      Et = /* @__PURE__ */ ze(Et);
      for (let st = 0; st < Ne; st++)
        Et = /* @__PURE__ */ ze(Et) ^ Be.charCodeAt(st) & 31;
      for (let st of ke)
        Et = /* @__PURE__ */ ze(Et) ^ st;
      for (let st = 0; st < 6; st++)
        Et = /* @__PURE__ */ ze(Et);
      return Et ^= xe, Ee.encode(/* @__PURE__ */ F([Et % 2 ** 30], 30, 5, !1));
    }
    // @__NO_SIDE_EFFECTS__
    function Pe(Be) {
      const ke = Be === "bech32" ? 1 : 734539939, xe = /* @__PURE__ */ U(5), Ne = xe.decode, Et = xe.encode, st = /* @__PURE__ */ L(Ne);
      function Dt(yr, wr, qr = 90) {
        if (typeof yr != "string")
          throw new Error(`bech32.encode prefix should be string, not ${typeof yr}`);
        if (wr instanceof Uint8Array && (wr = Array.from(wr)), !Array.isArray(wr) || wr.length && typeof wr[0] != "number")
          throw new Error(`bech32.encode words should be array of numbers, not ${typeof wr}`);
        if (yr.length === 0)
          throw new TypeError(`Invalid prefix length ${yr.length}`);
        const Mr = yr.length + 7 + wr.length;
        if (qr !== !1 && Mr > qr)
          throw new TypeError(`Length ${Mr} exceeds limit ${qr}`);
        const Dr = yr.toLowerCase(), Qr = /* @__PURE__ */ He(Dr, wr, ke);
        return `${Dr}1${Ee.encode(wr)}${Qr}`;
      }
      function er(yr, wr = 90) {
        if (typeof yr != "string")
          throw new Error(`bech32.decode input should be string, not ${typeof yr}`);
        if (yr.length < 8 || wr !== !1 && yr.length > wr)
          throw new TypeError(`Wrong string length: ${yr.length} (${yr}). Expected (8..${wr})`);
        const qr = yr.toLowerCase();
        if (yr !== qr && yr !== yr.toUpperCase())
          throw new Error("String must be lowercase or uppercase");
        const Mr = qr.lastIndexOf("1");
        if (Mr === 0 || Mr === -1)
          throw new Error('Letter "1" must be present between prefix and data only');
        const Dr = qr.slice(0, Mr), Qr = qr.slice(Mr + 1);
        if (Qr.length < 6)
          throw new Error("Data must be at least 6 characters long");
        const Xr = Ee.decode(Qr).slice(0, -6), Vr = /* @__PURE__ */ He(Dr, Xr, ke);
        if (!Qr.endsWith(Vr))
          throw new Error(`Invalid checksum in ${yr}: expected "${Vr}"`);
        return { prefix: Dr, words: Xr };
      }
      const xt = /* @__PURE__ */ L(er);
      function ir(yr) {
        const { prefix: wr, words: qr } = er(yr, !1);
        return { prefix: wr, words: qr, bytes: Ne(qr) };
      }
      function sr(yr, wr) {
        return Dt(yr, Et(wr));
      }
      return {
        encode: Dt,
        decode: er,
        encodeFromBytes: sr,
        decodeToBytes: ir,
        decodeUnsafe: xt,
        fromWords: Ne,
        fromWordsUnsafe: st,
        toWords: Et
      };
    }
    o.bech32 = /* @__PURE__ */ Pe("bech32"), o.bech32m = /* @__PURE__ */ Pe("bech32m"), o.utf8 = {
      encode: (Be) => new TextDecoder().decode(Be),
      decode: (Be) => new TextEncoder().encode(Be)
    }, o.hex = /* @__PURE__ */ y(/* @__PURE__ */ U(4), /* @__PURE__ */ t("0123456789abcdef"), /* @__PURE__ */ d(""), /* @__PURE__ */ B((Be) => {
      if (typeof Be != "string" || Be.length % 2)
        throw new TypeError(`hex.decode: expected string, got ${typeof Be} with length ${Be.length}`);
      return Be.toLowerCase();
    }));
    const De = {
      utf8: o.utf8,
      hex: o.hex,
      base16: o.base16,
      base32: o.base32,
      base64: o.base64,
      base64url: o.base64url,
      base58: o.base58,
      base58xmr: o.base58xmr
    }, ve = "Invalid encoding type. Available types: utf8, hex, base16, base32, base64, base64url, base58, base58xmr", Fe = (Be, ke) => {
      if (typeof Be != "string" || !De.hasOwnProperty(Be))
        throw new TypeError(ve);
      if (!c(ke))
        throw new TypeError("bytesToString() expects Uint8Array");
      return De[Be].encode(ke);
    };
    o.bytesToString = Fe, o.str = o.bytesToString;
    const be = (Be, ke) => {
      if (!De.hasOwnProperty(Be))
        throw new TypeError(ve);
      if (typeof ke != "string")
        throw new TypeError("stringToBytes() expects string");
      return De[Be].decode(ke);
    };
    o.stringToBytes = be, o.bytes = o.stringToBytes;
  }(lib$1)), lib$1;
}
var btcSigner = {}, utils$1 = {}, lib = {}, hasRequiredLib;
function requireLib() {
  return hasRequiredLib || (hasRequiredLib = 1, function(o) {
    Object.defineProperty(o, "__esModule", { value: !0 }), o._TEST = o.ZeroPad = o.magicBytes = o.flag = o.cstring = o.string = o.hex = o.bytes = o.bool = o.F64LE = o.F64BE = o.F32LE = o.F32BE = o.I8 = o.U8 = o.I16BE = o.I16LE = o.U16BE = o.U16LE = o.I32BE = o.I32LE = o.U32BE = o.U32LE = o.int = o.I64BE = o.I64LE = o.U64BE = o.U64LE = o.I128BE = o.I128LE = o.U128BE = o.U128LE = o.I256BE = o.I256LE = o.U256BE = o.U256LE = o.bigint = o.bits = o.coders = o.wrap = o.utils = o.NULL = o.EMPTY = void 0, o.validate = fe, o.isCoder = Ee, o.prefix = Dt, o.apply = ir, o.lazy = sr, o.flagged = wr, o.optional = qr, o.magic = Mr, o.constant = Qr, o.struct = Vr, o.tuple = Ur, o.array = Sr, o.map = Gr, o.tag = Fr, o.mappedTag = br, o.bitset = Ar, o.padLeft = Wr, o.padRight = fi, o.pointer = Bi;
    const g = /* @__PURE__ */ requireLib$2();
    o.EMPTY = new Uint8Array(), o.NULL = new Uint8Array([0]);
    function c($r, oi) {
      if ($r.length !== oi.length)
        return !1;
      for (let zr = 0; zr < $r.length; zr++)
        if ($r[zr] !== oi[zr])
          return !1;
      return !0;
    }
    function y($r) {
      return $r instanceof Uint8Array || ArrayBuffer.isView($r) && $r.constructor.name === "Uint8Array";
    }
    function t(...$r) {
      let oi = 0;
      for (let ti = 0; ti < $r.length; ti++) {
        const Lr = $r[ti];
        if (!y(Lr))
          throw new Error("Uint8Array expected");
        oi += Lr.length;
      }
      const zr = new Uint8Array(oi);
      for (let ti = 0, Lr = 0; ti < $r.length; ti++) {
        const Rr = $r[ti];
        zr.set(Rr, Lr), Lr += Rr.length;
      }
      return zr;
    }
    const d = ($r) => new DataView($r.buffer, $r.byteOffset, $r.byteLength);
    function E($r) {
      return Object.prototype.toString.call($r) === "[object Object]";
    }
    function B($r) {
      return Number.isSafeInteger($r);
    }
    o.utils = {
      equalBytes: c,
      isBytes: y,
      isCoder: Ee,
      checkBounds: L,
      concatBytes: t,
      createView: d,
      isPlainObject: E
    };
    const D = ($r) => {
      if ($r !== null && typeof $r != "string" && !Ee($r) && !y($r) && !B($r))
        throw new Error(`lengthCoder: expected null | number | Uint8Array | CoderType, got ${$r} (${typeof $r})`);
      return {
        encodeStream(oi, zr) {
          if ($r === null)
            return;
          if (Ee($r))
            return $r.encodeStream(oi, zr);
          let ti;
          if (typeof $r == "number" ? ti = $r : typeof $r == "string" && (ti = v.resolve(oi.stack, $r)), typeof ti == "bigint" && (ti = Number(ti)), ti === void 0 || ti !== zr)
            throw oi.err(`Wrong length: ${ti} len=${$r} exp=${zr} (${typeof zr})`);
        },
        decodeStream(oi) {
          let zr;
          if (Ee($r) ? zr = Number($r.decodeStream(oi)) : typeof $r == "number" ? zr = $r : typeof $r == "string" && (zr = v.resolve(oi.stack, $r)), typeof zr == "bigint" && (zr = Number(zr)), typeof zr != "number")
            throw oi.err(`Wrong length: ${zr}`);
          return zr;
        }
      };
    }, x = {
      BITS: 32,
      FULL_MASK: -1 >>> 0,
      // 1<<32 will overflow
      len: ($r) => Math.ceil($r / 32),
      create: ($r) => new Uint32Array(x.len($r)),
      clean: ($r) => $r.fill(0),
      debug: ($r) => Array.from($r).map((oi) => (oi >>> 0).toString(2).padStart(32, "0")),
      checkLen: ($r, oi) => {
        if (x.len(oi) !== $r.length)
          throw new Error(`wrong length=${$r.length}. Expected: ${x.len(oi)}`);
      },
      chunkLen: ($r, oi, zr) => {
        if (oi < 0)
          throw new Error(`wrong pos=${oi}`);
        if (oi + zr > $r)
          throw new Error(`wrong range=${oi}/${zr} of ${$r}`);
      },
      set: ($r, oi, zr, ti = !0) => !ti && ($r[oi] & zr) !== 0 ? !1 : ($r[oi] |= zr, !0),
      pos: ($r, oi) => ({
        chunk: Math.floor(($r + oi) / 32),
        mask: 1 << 32 - ($r + oi) % 32 - 1
      }),
      indices: ($r, oi, zr = !1) => {
        x.checkLen($r, oi);
        const { FULL_MASK: ti, BITS: Lr } = x, Rr = Lr - oi % Lr, Ir = Rr ? ti >>> Rr << Rr : ti, pr = [];
        for (let Cr = 0; Cr < $r.length; Cr++) {
          let Er = $r[Cr];
          if (zr && (Er = ~Er), Cr === $r.length - 1 && (Er &= Ir), Er !== 0)
            for (let xr = 0; xr < Lr; xr++) {
              const si = 1 << Lr - xr - 1;
              Er & si && pr.push(Cr * Lr + xr);
            }
        }
        return pr;
      },
      range: ($r) => {
        const oi = [];
        let zr;
        for (const ti of $r)
          zr === void 0 || ti !== zr.pos + zr.length ? oi.push(zr = { pos: ti, length: 1 }) : zr.length += 1;
        return oi;
      },
      rangeDebug: ($r, oi, zr = !1) => `[${x.range(x.indices($r, oi, zr)).map((ti) => `(${ti.pos}/${ti.length})`).join(", ")}]`,
      setRange: ($r, oi, zr, ti, Lr = !0) => {
        x.chunkLen(oi, zr, ti);
        const { FULL_MASK: Rr, BITS: Ir } = x, pr = zr % Ir ? Math.floor(zr / Ir) : void 0, Cr = zr + ti, Er = Cr % Ir ? Math.floor(Cr / Ir) : void 0;
        if (pr !== void 0 && pr === Er)
          return x.set($r, pr, Rr >>> Ir - ti << Ir - ti - zr, Lr);
        if (pr !== void 0 && !x.set($r, pr, Rr >>> zr % Ir, Lr))
          return !1;
        const xr = pr !== void 0 ? pr + 1 : zr / Ir, si = Er !== void 0 ? Er : Cr / Ir;
        for (let Ci = xr; Ci < si; Ci++)
          if (!x.set($r, Ci, Rr, Lr))
            return !1;
        return !(Er !== void 0 && pr !== Er && !x.set($r, Er, Rr << Ir - Cr % Ir, Lr));
      }
    }, v = {
      /**
       * Internal method for handling stack of paths (debug, errors, dynamic fields via path)
       * This is looks ugly (callback), but allows us to force stack cleaning by construction (.pop always after function).
       * Also, this makes impossible:
       * - pushing field when stack is empty
       * - pushing field inside of field (real bug)
       * NOTE: we don't want to do '.pop' on error!
       */
      pushObj: ($r, oi, zr) => {
        const ti = { obj: oi };
        $r.push(ti), zr((Lr, Rr) => {
          ti.field = Lr, Rr(), ti.field = void 0;
        }), $r.pop();
      },
      path: ($r) => {
        const oi = [];
        for (const zr of $r)
          zr.field !== void 0 && oi.push(zr.field);
        return oi.join("/");
      },
      err: ($r, oi, zr) => {
        const ti = new Error(`${$r}(${v.path(oi)}): ${typeof zr == "string" ? zr : zr.message}`);
        return zr instanceof Error && zr.stack && (ti.stack = zr.stack), ti;
      },
      resolve: ($r, oi) => {
        const zr = oi.split("/"), ti = $r.map((Ir) => Ir.obj);
        let Lr = 0;
        for (; Lr < zr.length && zr[Lr] === ".."; Lr++)
          ti.pop();
        let Rr = ti.pop();
        for (; Lr < zr.length; Lr++) {
          if (!Rr || Rr[zr[Lr]] === void 0)
            return;
          Rr = Rr[zr[Lr]];
        }
        return Rr;
      }
    };
    class F {
      constructor(oi, zr = {}, ti = [], Lr = void 0, Rr = 0) {
        this.pos = 0, this.bitBuf = 0, this.bitPos = 0, this.data = oi, this.opts = zr, this.stack = ti, this.parent = Lr, this.parentOffset = Rr, this.view = d(oi);
      }
      /** Internal method for pointers. */
      _enablePointers() {
        if (this.parent)
          return this.parent._enablePointers();
        this.bs || (this.bs = x.create(this.data.length), x.setRange(this.bs, this.data.length, 0, this.pos, this.opts.allowMultipleReads));
      }
      markBytesBS(oi, zr) {
        return this.parent ? this.parent.markBytesBS(this.parentOffset + oi, zr) : !zr || !this.bs ? !0 : x.setRange(this.bs, this.data.length, oi, zr, !1);
      }
      markBytes(oi) {
        const zr = this.pos;
        this.pos += oi;
        const ti = this.markBytesBS(zr, oi);
        if (!this.opts.allowMultipleReads && !ti)
          throw this.err(`multiple read pos=${this.pos} len=${oi}`);
        return ti;
      }
      pushObj(oi, zr) {
        return v.pushObj(this.stack, oi, zr);
      }
      readView(oi, zr) {
        if (!Number.isFinite(oi))
          throw this.err(`readView: wrong length=${oi}`);
        if (this.pos + oi > this.data.length)
          throw this.err("readView: Unexpected end of buffer");
        const ti = zr(this.view, this.pos);
        return this.markBytes(oi), ti;
      }
      // read bytes by absolute offset
      absBytes(oi) {
        if (oi > this.data.length)
          throw new Error("Unexpected end of buffer");
        return this.data.subarray(oi);
      }
      finish() {
        if (!this.opts.allowUnreadBytes) {
          if (this.bitPos)
            throw this.err(`${this.bitPos} bits left after unpack: ${g.hex.encode(this.data.slice(this.pos))}`);
          if (this.bs && !this.parent) {
            const oi = x.indices(this.bs, this.data.length, !0);
            if (oi.length) {
              const zr = x.range(oi).map(({ pos: ti, length: Lr }) => `(${ti}/${Lr})[${g.hex.encode(this.data.subarray(ti, ti + Lr))}]`).join(", ");
              throw this.err(`unread byte ranges: ${zr} (total=${this.data.length})`);
            } else
              return;
          }
          if (!this.isEnd())
            throw this.err(`${this.leftBytes} bytes ${this.bitPos} bits left after unpack: ${g.hex.encode(this.data.slice(this.pos))}`);
        }
      }
      // User methods
      err(oi) {
        return v.err("Reader", this.stack, oi);
      }
      offsetReader(oi) {
        if (oi > this.data.length)
          throw this.err("offsetReader: Unexpected end of buffer");
        return new F(this.absBytes(oi), this.opts, this.stack, this, oi);
      }
      bytes(oi, zr = !1) {
        if (this.bitPos)
          throw this.err("readBytes: bitPos not empty");
        if (!Number.isFinite(oi))
          throw this.err(`readBytes: wrong length=${oi}`);
        if (this.pos + oi > this.data.length)
          throw this.err("readBytes: Unexpected end of buffer");
        const ti = this.data.subarray(this.pos, this.pos + oi);
        return zr || this.markBytes(oi), ti;
      }
      byte(oi = !1) {
        if (this.bitPos)
          throw this.err("readByte: bitPos not empty");
        if (this.pos + 1 > this.data.length)
          throw this.err("readBytes: Unexpected end of buffer");
        const zr = this.data[this.pos];
        return oi || this.markBytes(1), zr;
      }
      get leftBytes() {
        return this.data.length - this.pos;
      }
      get totalBytes() {
        return this.data.length;
      }
      isEnd() {
        return this.pos >= this.data.length && !this.bitPos;
      }
      // bits are read in BE mode (left to right): (0b1000_0000).readBits(1) == 1
      bits(oi) {
        if (oi > 32)
          throw this.err("BitReader: cannot read more than 32 bits in single call");
        let zr = 0;
        for (; oi; ) {
          this.bitPos || (this.bitBuf = this.byte(), this.bitPos = 8);
          const ti = Math.min(oi, this.bitPos);
          this.bitPos -= ti, zr = zr << ti | this.bitBuf >> this.bitPos & 2 ** ti - 1, this.bitBuf &= 2 ** this.bitPos - 1, oi -= ti;
        }
        return zr >>> 0;
      }
      find(oi, zr = this.pos) {
        if (!y(oi))
          throw this.err(`find: needle is not bytes! ${oi}`);
        if (this.bitPos)
          throw this.err("findByte: bitPos not empty");
        if (!oi.length)
          throw this.err("find: needle is empty");
        for (let ti = zr; (ti = this.data.indexOf(oi[0], ti)) !== -1; ti++) {
          if (ti === -1 || this.data.length - ti < oi.length)
            return;
          if (c(oi, this.data.subarray(ti, ti + oi.length)))
            return ti;
        }
      }
    }
    class M {
      constructor(oi = []) {
        this.pos = 0, this.buffers = [], this.ptrs = [], this.bitBuf = 0, this.bitPos = 0, this.viewBuf = new Uint8Array(8), this.finished = !1, this.stack = oi, this.view = d(this.viewBuf);
      }
      pushObj(oi, zr) {
        return v.pushObj(this.stack, oi, zr);
      }
      writeView(oi, zr) {
        if (this.finished)
          throw this.err("buffer: finished");
        if (!B(oi) || oi > 8)
          throw new Error(`wrong writeView length=${oi}`);
        zr(this.view), this.bytes(this.viewBuf.slice(0, oi)), this.viewBuf.fill(0);
      }
      // User methods
      err(oi) {
        if (this.finished)
          throw this.err("buffer: finished");
        return v.err("Reader", this.stack, oi);
      }
      bytes(oi) {
        if (this.finished)
          throw this.err("buffer: finished");
        if (this.bitPos)
          throw this.err("writeBytes: ends with non-empty bit buffer");
        this.buffers.push(oi), this.pos += oi.length;
      }
      byte(oi) {
        if (this.finished)
          throw this.err("buffer: finished");
        if (this.bitPos)
          throw this.err("writeByte: ends with non-empty bit buffer");
        this.buffers.push(new Uint8Array([oi])), this.pos++;
      }
      finish(oi = !0) {
        if (this.finished)
          throw this.err("buffer: finished");
        if (this.bitPos)
          throw this.err("buffer: ends with non-empty bit buffer");
        const zr = this.buffers.concat(this.ptrs.map((Rr) => Rr.buffer)), ti = zr.map((Rr) => Rr.length).reduce((Rr, Ir) => Rr + Ir, 0), Lr = new Uint8Array(ti);
        for (let Rr = 0, Ir = 0; Rr < zr.length; Rr++) {
          const pr = zr[Rr];
          Lr.set(pr, Ir), Ir += pr.length;
        }
        for (let Rr = this.pos, Ir = 0; Ir < this.ptrs.length; Ir++) {
          const pr = this.ptrs[Ir];
          Lr.set(pr.ptr.encode(Rr), pr.pos), Rr += pr.buffer.length;
        }
        if (oi) {
          this.buffers = [];
          for (const Rr of this.ptrs)
            Rr.buffer.fill(0);
          this.ptrs = [], this.finished = !0, this.bitBuf = 0;
        }
        return Lr;
      }
      bits(oi, zr) {
        if (zr > 32)
          throw this.err("writeBits: cannot write more than 32 bits in single call");
        if (oi >= 2 ** zr)
          throw this.err(`writeBits: value (${oi}) >= 2**bits (${zr})`);
        for (; zr; ) {
          const ti = Math.min(zr, 8 - this.bitPos);
          this.bitBuf = this.bitBuf << ti | oi >> zr - ti, this.bitPos += ti, zr -= ti, oi &= 2 ** zr - 1, this.bitPos === 8 && (this.bitPos = 0, this.buffers.push(new Uint8Array([this.bitBuf])), this.pos++);
        }
      }
    }
    const U = ($r) => Uint8Array.from($r).reverse();
    function L($r, oi, zr) {
      if (zr) {
        const ti = 2n ** (oi - 1n);
        if ($r < -ti || $r >= ti)
          throw new Error(`value out of signed bounds. Expected ${-ti} <= ${$r} < ${ti}`);
      } else if (0n > $r || $r >= 2n ** oi)
        throw new Error(`value out of unsigned bounds. Expected 0 <= ${$r} < ${2n ** oi}`);
    }
    function H($r) {
      return {
        // NOTE: we cannot export validate here, since it is likely mistake.
        encodeStream: $r.encodeStream,
        decodeStream: $r.decodeStream,
        size: $r.size,
        encode: (oi) => {
          const zr = new M();
          return $r.encodeStream(zr, oi), zr.finish();
        },
        decode: (oi, zr = {}) => {
          const ti = new F(oi, zr), Lr = $r.decodeStream(ti);
          return ti.finish(), Lr;
        }
      };
    }
    function fe($r, oi) {
      if (!Ee($r))
        throw new Error(`validate: invalid inner value ${$r}`);
      if (typeof oi != "function")
        throw new Error("validate: fn should be function");
      return H({
        size: $r.size,
        encodeStream: (zr, ti) => {
          let Lr;
          try {
            Lr = oi(ti);
          } catch (Rr) {
            throw zr.err(Rr);
          }
          $r.encodeStream(zr, Lr);
        },
        decodeStream: (zr) => {
          const ti = $r.decodeStream(zr);
          try {
            return oi(ti);
          } catch (Lr) {
            throw zr.err(Lr);
          }
        }
      });
    }
    const ge = ($r) => {
      const oi = H($r);
      return $r.validate ? fe(oi, $r.validate) : oi;
    };
    o.wrap = ge;
    const Ie = ($r) => E($r) && typeof $r.decode == "function" && typeof $r.encode == "function";
    function Ee($r) {
      return E($r) && Ie($r) && typeof $r.encodeStream == "function" && typeof $r.decodeStream == "function" && ($r.size === void 0 || B($r.size));
    }
    function Se() {
      return {
        encode: ($r) => {
          if (!Array.isArray($r))
            throw new Error("array expected");
          const oi = {};
          for (const zr of $r) {
            if (!Array.isArray(zr) || zr.length !== 2)
              throw new Error("array of two elements expected");
            const ti = zr[0], Lr = zr[1];
            if (oi[ti] !== void 0)
              throw new Error(`key(${ti}) appears twice in struct`);
            oi[ti] = Lr;
          }
          return oi;
        },
        decode: ($r) => {
          if (!E($r))
            throw new Error(`expected plain object, got ${$r}`);
          return Object.entries($r);
        }
      };
    }
    const ze = {
      encode: ($r) => {
        if (typeof $r != "bigint")
          throw new Error(`expected bigint, got ${typeof $r}`);
        if ($r > BigInt(Number.MAX_SAFE_INTEGER))
          throw new Error(`element bigger than MAX_SAFE_INTEGER=${$r}`);
        return Number($r);
      },
      decode: ($r) => {
        if (!B($r))
          throw new Error("element is not a safe integer");
        return BigInt($r);
      }
    };
    function He($r) {
      if (!E($r))
        throw new Error("plain object expected");
      return {
        encode: (oi) => {
          if (!B(oi) || !(oi in $r))
            throw new Error(`wrong value ${oi}`);
          return $r[oi];
        },
        decode: (oi) => {
          if (typeof oi != "string")
            throw new Error(`wrong value ${typeof oi}`);
          return $r[oi];
        }
      };
    }
    function Pe($r, oi = !1) {
      if (!B($r))
        throw new Error(`decimal/precision: wrong value ${$r}`);
      if (typeof oi != "boolean")
        throw new Error(`decimal/round: expected boolean, got ${typeof oi}`);
      const zr = 10n ** BigInt($r);
      return {
        encode: (ti) => {
          if (typeof ti != "bigint")
            throw new Error(`expected bigint, got ${typeof ti}`);
          let Lr = (ti < 0n ? -ti : ti).toString(10), Rr = Lr.length - $r;
          Rr < 0 && (Lr = Lr.padStart(Lr.length - Rr, "0"), Rr = 0);
          let Ir = Lr.length - 1;
          for (; Ir >= Rr && Lr[Ir] === "0"; Ir--)
            ;
          let pr = Lr.slice(0, Rr), Cr = Lr.slice(Rr, Ir + 1);
          return pr || (pr = "0"), ti < 0n && (pr = "-" + pr), Cr ? `${pr}.${Cr}` : pr;
        },
        decode: (ti) => {
          if (typeof ti != "string")
            throw new Error(`expected string, got ${typeof ti}`);
          if (ti === "-0")
            throw new Error("negative zero is not allowed");
          let Lr = !1;
          if (ti.startsWith("-") && (Lr = !0, ti = ti.slice(1)), !/^(0|[1-9]\d*)(\.\d+)?$/.test(ti))
            throw new Error(`wrong string value=${ti}`);
          let Rr = ti.indexOf(".");
          Rr = Rr === -1 ? ti.length : Rr;
          const Ir = ti.slice(0, Rr), pr = ti.slice(Rr + 1).replace(/0+$/, ""), Cr = BigInt(Ir) * zr;
          if (!oi && pr.length > $r)
            throw new Error(`fractional part cannot be represented with this precision (num=${ti}, prec=${$r})`);
          const Er = Math.min(pr.length, $r), xr = BigInt(pr.slice(0, Er)) * 10n ** BigInt($r - Er), si = Cr + xr;
          return Lr ? -si : si;
        }
      };
    }
    function De($r) {
      if (!Array.isArray($r))
        throw new Error(`expected array, got ${typeof $r}`);
      for (const oi of $r)
        if (!Ie(oi))
          throw new Error(`wrong base coder ${oi}`);
      return {
        encode: (oi) => {
          for (const zr of $r) {
            const ti = zr.encode(oi);
            if (ti !== void 0)
              return ti;
          }
          throw new Error(`match/encode: cannot find match in ${oi}`);
        },
        decode: (oi) => {
          for (const zr of $r) {
            const ti = zr.decode(oi);
            if (ti !== void 0)
              return ti;
          }
          throw new Error(`match/decode: cannot find match in ${oi}`);
        }
      };
    }
    const ve = ($r) => {
      if (!Ie($r))
        throw new Error("BaseCoder expected");
      return { encode: $r.decode, decode: $r.encode };
    };
    o.coders = { dict: Se, numberBigint: ze, tsEnum: He, decimal: Pe, match: De, reverse: ve };
    const Fe = ($r) => {
      if (!B($r))
        throw new Error(`bits: wrong length ${$r} (${typeof $r})`);
      return (0, o.wrap)({
        encodeStream: (oi, zr) => oi.bits(zr, $r),
        decodeStream: (oi) => oi.bits($r),
        validate: (oi) => {
          if (!B(oi))
            throw new Error(`bits: wrong value ${oi}`);
          return oi;
        }
      });
    };
    o.bits = Fe;
    const be = ($r, oi = !1, zr = !1, ti = !0) => {
      if (!B($r))
        throw new Error(`bigint/size: wrong value ${$r}`);
      if (typeof oi != "boolean")
        throw new Error(`bigint/le: expected boolean, got ${typeof oi}`);
      if (typeof zr != "boolean")
        throw new Error(`bigint/signed: expected boolean, got ${typeof zr}`);
      if (typeof ti != "boolean")
        throw new Error(`bigint/sized: expected boolean, got ${typeof ti}`);
      const Lr = BigInt($r), Rr = 2n ** (8n * Lr - 1n);
      return (0, o.wrap)({
        size: ti ? $r : void 0,
        encodeStream: (Ir, pr) => {
          zr && pr < 0 && (pr = pr | Rr);
          const Cr = [];
          for (let xr = 0; xr < $r; xr++)
            Cr.push(Number(pr & 255n)), pr >>= 8n;
          let Er = new Uint8Array(Cr).reverse();
          if (!ti) {
            let xr = 0;
            for (xr = 0; xr < Er.length && Er[xr] === 0; xr++)
              ;
            Er = Er.subarray(xr);
          }
          Ir.bytes(oi ? Er.reverse() : Er);
        },
        decodeStream: (Ir) => {
          const pr = Ir.bytes(ti ? $r : Math.min($r, Ir.leftBytes)), Cr = oi ? pr : U(pr);
          let Er = 0n;
          for (let xr = 0; xr < Cr.length; xr++)
            Er |= BigInt(Cr[xr]) << 8n * BigInt(xr);
          return zr && Er & Rr && (Er = (Er ^ Rr) - Rr), Er;
        },
        validate: (Ir) => {
          if (typeof Ir != "bigint")
            throw new Error(`bigint: invalid value: ${Ir}`);
          return L(Ir, 8n * Lr, !!zr), Ir;
        }
      });
    };
    o.bigint = be, o.U256LE = (0, o.bigint)(32, !0), o.U256BE = (0, o.bigint)(32, !1), o.I256LE = (0, o.bigint)(32, !0, !0), o.I256BE = (0, o.bigint)(32, !1, !0), o.U128LE = (0, o.bigint)(16, !0), o.U128BE = (0, o.bigint)(16, !1), o.I128LE = (0, o.bigint)(16, !0, !0), o.I128BE = (0, o.bigint)(16, !1, !0), o.U64LE = (0, o.bigint)(8, !0), o.U64BE = (0, o.bigint)(8, !1), o.I64LE = (0, o.bigint)(8, !0, !0), o.I64BE = (0, o.bigint)(8, !1, !0);
    const Be = ($r, oi = !1, zr = !1, ti = !0) => {
      if (!B($r))
        throw new Error(`int/size: wrong value ${$r}`);
      if (typeof oi != "boolean")
        throw new Error(`int/le: expected boolean, got ${typeof oi}`);
      if (typeof zr != "boolean")
        throw new Error(`int/signed: expected boolean, got ${typeof zr}`);
      if (typeof ti != "boolean")
        throw new Error(`int/sized: expected boolean, got ${typeof ti}`);
      if ($r > 6)
        throw new Error("int supports size up to 6 bytes (48 bits): use bigints instead");
      return ir((0, o.bigint)($r, oi, zr, ti), o.coders.numberBigint);
    };
    o.int = Be;
    const ke = ($r, oi) => (0, o.wrap)({
      size: $r,
      encodeStream: (zr, ti) => zr.writeView($r, (Lr) => oi.write(Lr, ti)),
      decodeStream: (zr) => zr.readView($r, oi.read),
      validate: (zr) => {
        if (typeof zr != "number")
          throw new Error(`viewCoder: expected number, got ${typeof zr}`);
        return oi.validate && oi.validate(zr), zr;
      }
    }), xe = ($r, oi, zr) => {
      const ti = $r * 8, Lr = 2 ** (ti - 1), Rr = (Cr) => {
        if (!B(Cr))
          throw new Error(`sintView: value is not safe integer: ${Cr}`);
        if (Cr < -Lr || Cr >= Lr)
          throw new Error(`sintView: value out of bounds. Expected ${-Lr} <= ${Cr} < ${Lr}`);
      }, Ir = 2 ** ti, pr = (Cr) => {
        if (!B(Cr))
          throw new Error(`uintView: value is not safe integer: ${Cr}`);
        if (0 > Cr || Cr >= Ir)
          throw new Error(`uintView: value out of bounds. Expected 0 <= ${Cr} < ${Ir}`);
      };
      return ke($r, {
        write: zr.write,
        read: zr.read,
        validate: oi ? Rr : pr
      });
    };
    o.U32LE = xe(4, !1, {
      read: ($r, oi) => $r.getUint32(oi, !0),
      write: ($r, oi) => $r.setUint32(0, oi, !0)
    }), o.U32BE = xe(4, !1, {
      read: ($r, oi) => $r.getUint32(oi, !1),
      write: ($r, oi) => $r.setUint32(0, oi, !1)
    }), o.I32LE = xe(4, !0, {
      read: ($r, oi) => $r.getInt32(oi, !0),
      write: ($r, oi) => $r.setInt32(0, oi, !0)
    }), o.I32BE = xe(4, !0, {
      read: ($r, oi) => $r.getInt32(oi, !1),
      write: ($r, oi) => $r.setInt32(0, oi, !1)
    }), o.U16LE = xe(2, !1, {
      read: ($r, oi) => $r.getUint16(oi, !0),
      write: ($r, oi) => $r.setUint16(0, oi, !0)
    }), o.U16BE = xe(2, !1, {
      read: ($r, oi) => $r.getUint16(oi, !1),
      write: ($r, oi) => $r.setUint16(0, oi, !1)
    }), o.I16LE = xe(2, !0, {
      read: ($r, oi) => $r.getInt16(oi, !0),
      write: ($r, oi) => $r.setInt16(0, oi, !0)
    }), o.I16BE = xe(2, !0, {
      read: ($r, oi) => $r.getInt16(oi, !1),
      write: ($r, oi) => $r.setInt16(0, oi, !1)
    }), o.U8 = xe(1, !1, {
      read: ($r, oi) => $r.getUint8(oi),
      write: ($r, oi) => $r.setUint8(0, oi)
    }), o.I8 = xe(1, !0, {
      read: ($r, oi) => $r.getInt8(oi),
      write: ($r, oi) => $r.setInt8(0, oi)
    });
    const Ne = ($r) => ke(4, {
      read: (oi, zr) => oi.getFloat32(zr, $r),
      write: (oi, zr) => oi.setFloat32(0, zr, $r),
      validate: (oi) => {
        if (Math.fround(oi) !== oi && !Number.isNaN(oi))
          throw new Error(`f32: wrong value=${oi}`);
      }
    }), Et = ($r) => ke(8, {
      read: (oi, zr) => oi.getFloat64(zr, $r),
      write: (oi, zr) => oi.setFloat64(0, zr, $r)
    });
    o.F32BE = Ne(!1), o.F32LE = Ne(!0), o.F64BE = Et(!1), o.F64LE = Et(!0), o.bool = (0, o.wrap)({
      size: 1,
      encodeStream: ($r, oi) => $r.byte(oi ? 1 : 0),
      decodeStream: ($r) => {
        const oi = $r.byte();
        if (oi !== 0 && oi !== 1)
          throw $r.err(`bool: invalid value ${oi}`);
        return oi === 1;
      },
      validate: ($r) => {
        if (typeof $r != "boolean")
          throw new Error(`bool: invalid value ${$r}`);
        return $r;
      }
    });
    const st = ($r, oi = !1) => {
      if (typeof oi != "boolean")
        throw new Error(`bytes/le: expected boolean, got ${typeof oi}`);
      const zr = D($r), ti = y($r);
      return (0, o.wrap)({
        size: typeof $r == "number" ? $r : void 0,
        encodeStream: (Lr, Rr) => {
          ti || zr.encodeStream(Lr, Rr.length), Lr.bytes(oi ? U(Rr) : Rr), ti && Lr.bytes($r);
        },
        decodeStream: (Lr) => {
          let Rr;
          if (ti) {
            const Ir = Lr.find($r);
            if (!Ir)
              throw Lr.err("bytes: cannot find terminator");
            Rr = Lr.bytes(Ir - Lr.pos), Lr.bytes($r.length);
          } else
            Rr = Lr.bytes($r === null ? Lr.leftBytes : zr.decodeStream(Lr));
          return oi ? U(Rr) : Rr;
        },
        validate: (Lr) => {
          if (!y(Lr))
            throw new Error(`bytes: invalid value ${Lr}`);
          return Lr;
        }
      });
    };
    o.bytes = st;
    function Dt($r, oi) {
      if (!Ee(oi))
        throw new Error(`prefix: invalid inner value ${oi}`);
      return ir(st($r), ve(oi));
    }
    const er = ($r, oi = !1) => fe(ir(st($r, oi), g.utf8), (zr) => {
      if (typeof zr != "string")
        throw new Error(`expected string, got ${typeof zr}`);
      return zr;
    });
    o.string = er, o.cstring = (0, o.string)(o.NULL);
    const xt = ($r, oi = { isLE: !1, with0x: !1 }) => {
      let zr = ir(st($r, oi.isLE), g.hex);
      const ti = oi.with0x;
      if (typeof ti != "boolean")
        throw new Error(`hex/with0x: expected boolean, got ${typeof ti}`);
      return ti && (zr = ir(zr, {
        encode: (Lr) => `0x${Lr}`,
        decode: (Lr) => {
          if (!Lr.startsWith("0x"))
            throw new Error("hex(with0x=true).encode input should start with 0x");
          return Lr.slice(2);
        }
      })), zr;
    };
    o.hex = xt;
    function ir($r, oi) {
      if (!Ee($r))
        throw new Error(`apply: invalid inner value ${$r}`);
      if (!Ie(oi))
        throw new Error(`apply: invalid base value ${$r}`);
      return (0, o.wrap)({
        size: $r.size,
        encodeStream: (zr, ti) => {
          let Lr;
          try {
            Lr = oi.decode(ti);
          } catch (Rr) {
            throw zr.err("" + Rr);
          }
          return $r.encodeStream(zr, Lr);
        },
        decodeStream: (zr) => {
          const ti = $r.decodeStream(zr);
          try {
            return oi.encode(ti);
          } catch (Lr) {
            throw zr.err("" + Lr);
          }
        }
      });
    }
    function sr($r) {
      if (typeof $r != "function")
        throw new Error(`lazy: expected function, got ${typeof $r}`);
      return (0, o.wrap)({
        encodeStream: (oi, zr) => $r().encodeStream(oi, zr),
        decodeStream: (oi) => $r().decodeStream(oi)
      });
    }
    const yr = ($r, oi = !1) => {
      if (!y($r))
        throw new Error(`flag/flagValue: expected Uint8Array, got ${typeof $r}`);
      if (typeof oi != "boolean")
        throw new Error(`flag/xor: expected boolean, got ${typeof oi}`);
      return (0, o.wrap)({
        size: $r.length,
        encodeStream: (zr, ti) => {
          !!ti !== oi && zr.bytes($r);
        },
        decodeStream: (zr) => {
          let ti = zr.leftBytes >= $r.length;
          return ti && (ti = c(zr.bytes($r.length, !0), $r), ti && zr.bytes($r.length)), ti !== oi;
        },
        validate: (zr) => {
          if (zr !== void 0 && typeof zr != "boolean")
            throw new Error(`flag: expected boolean value or undefined, got ${typeof zr}`);
          return zr;
        }
      });
    };
    o.flag = yr;
    function wr($r, oi, zr) {
      if (!Ee(oi))
        throw new Error(`flagged: invalid inner value ${oi}`);
      if (typeof $r != "string" && !Ee(oi))
        throw new Error(`flagged: wrong path=${$r}`);
      return (0, o.wrap)({
        encodeStream: (ti, Lr) => {
          typeof $r == "string" ? v.resolve(ti.stack, $r) ? oi.encodeStream(ti, Lr) : zr && oi.encodeStream(ti, zr) : ($r.encodeStream(ti, !!Lr), Lr ? oi.encodeStream(ti, Lr) : zr && oi.encodeStream(ti, zr));
        },
        decodeStream: (ti) => {
          let Lr = !1;
          if (typeof $r == "string" ? Lr = !!v.resolve(ti.stack, $r) : Lr = $r.decodeStream(ti), Lr)
            return oi.decodeStream(ti);
          zr && oi.decodeStream(ti);
        }
      });
    }
    function qr($r, oi, zr) {
      if (!Ee($r) || !Ee(oi))
        throw new Error(`optional: invalid flag or inner value flag=${$r} inner=${oi}`);
      return (0, o.wrap)({
        size: zr !== void 0 && $r.size && oi.size ? $r.size + oi.size : void 0,
        encodeStream: (ti, Lr) => {
          $r.encodeStream(ti, !!Lr), Lr ? oi.encodeStream(ti, Lr) : zr !== void 0 && oi.encodeStream(ti, zr);
        },
        decodeStream: (ti) => {
          if ($r.decodeStream(ti))
            return oi.decodeStream(ti);
          zr !== void 0 && oi.decodeStream(ti);
        }
      });
    }
    function Mr($r, oi, zr = !0) {
      if (!Ee($r))
        throw new Error(`magic: invalid inner value ${$r}`);
      if (typeof zr != "boolean")
        throw new Error(`magic: expected boolean, got ${typeof zr}`);
      return (0, o.wrap)({
        size: $r.size,
        encodeStream: (ti, Lr) => $r.encodeStream(ti, oi),
        decodeStream: (ti) => {
          const Lr = $r.decodeStream(ti);
          if (zr && typeof Lr != "object" && Lr !== oi || y(oi) && !c(oi, Lr))
            throw ti.err(`magic: invalid value: ${Lr} !== ${oi}`);
        },
        validate: (ti) => {
          if (ti !== void 0)
            throw new Error(`magic: wrong value=${typeof ti}`);
          return ti;
        }
      });
    }
    const Dr = ($r) => {
      const oi = typeof $r == "string" ? g.utf8.decode($r) : $r;
      return Mr(st(oi.length), oi);
    };
    o.magicBytes = Dr;
    function Qr($r) {
      return (0, o.wrap)({
        encodeStream: (oi, zr) => {
          if (zr !== $r)
            throw new Error(`constant: invalid value ${zr} (exp: ${$r})`);
        },
        decodeStream: (oi) => $r
      });
    }
    function Xr($r) {
      let oi = 0;
      for (const zr of $r) {
        if (zr.size === void 0)
          return;
        if (!B(zr.size))
          throw new Error(`sizeof: wrong element size=${oi}`);
        oi += zr.size;
      }
      return oi;
    }
    function Vr($r) {
      if (!E($r))
        throw new Error(`struct: expected plain object, got ${$r}`);
      for (const oi in $r)
        if (!Ee($r[oi]))
          throw new Error(`struct: field ${oi} is not CoderType`);
      return (0, o.wrap)({
        size: Xr(Object.values($r)),
        encodeStream: (oi, zr) => {
          oi.pushObj(zr, (ti) => {
            for (const Lr in $r)
              ti(Lr, () => $r[Lr].encodeStream(oi, zr[Lr]));
          });
        },
        decodeStream: (oi) => {
          const zr = {};
          return oi.pushObj(zr, (ti) => {
            for (const Lr in $r)
              ti(Lr, () => zr[Lr] = $r[Lr].decodeStream(oi));
          }), zr;
        },
        validate: (oi) => {
          if (typeof oi != "object" || oi === null)
            throw new Error(`struct: invalid value ${oi}`);
          return oi;
        }
      });
    }
    function Ur($r) {
      if (!Array.isArray($r))
        throw new Error(`Packed.Tuple: got ${typeof $r} instead of array`);
      for (let oi = 0; oi < $r.length; oi++)
        if (!Ee($r[oi]))
          throw new Error(`tuple: field ${oi} is not CoderType`);
      return (0, o.wrap)({
        size: Xr($r),
        encodeStream: (oi, zr) => {
          if (!Array.isArray(zr))
            throw oi.err(`tuple: invalid value ${zr}`);
          oi.pushObj(zr, (ti) => {
            for (let Lr = 0; Lr < $r.length; Lr++)
              ti(`${Lr}`, () => $r[Lr].encodeStream(oi, zr[Lr]));
          });
        },
        decodeStream: (oi) => {
          const zr = [];
          return oi.pushObj(zr, (ti) => {
            for (let Lr = 0; Lr < $r.length; Lr++)
              ti(`${Lr}`, () => zr.push($r[Lr].decodeStream(oi)));
          }), zr;
        },
        validate: (oi) => {
          if (!Array.isArray(oi))
            throw new Error(`tuple: invalid value ${oi}`);
          if (oi.length !== $r.length)
            throw new Error(`tuple: wrong length=${oi.length}, expected ${$r.length}`);
          return oi;
        }
      });
    }
    function Sr($r, oi) {
      if (!Ee(oi))
        throw new Error(`array: invalid inner value ${oi}`);
      const zr = D(typeof $r == "string" ? `../${$r}` : $r);
      return (0, o.wrap)({
        size: typeof $r == "number" && oi.size ? $r * oi.size : void 0,
        encodeStream: (ti, Lr) => {
          const Rr = ti;
          Rr.pushObj(Lr, (Ir) => {
            y($r) || zr.encodeStream(ti, Lr.length);
            for (let pr = 0; pr < Lr.length; pr++)
              Ir(`${pr}`, () => {
                const Cr = Lr[pr], Er = ti.pos;
                if (oi.encodeStream(ti, Cr), y($r)) {
                  if ($r.length > Rr.pos - Er)
                    return;
                  const xr = Rr.finish(!1).subarray(Er, Rr.pos);
                  if (c(xr.subarray(0, $r.length), $r))
                    throw Rr.err(`array: inner element encoding same as separator. elm=${Cr} data=${xr}`);
                }
              });
          }), y($r) && ti.bytes($r);
        },
        decodeStream: (ti) => {
          const Lr = [];
          return ti.pushObj(Lr, (Rr) => {
            if ($r === null)
              for (let Ir = 0; !ti.isEnd() && (Rr(`${Ir}`, () => Lr.push(oi.decodeStream(ti))), !(oi.size && ti.leftBytes < oi.size)); Ir++)
                ;
            else if (y($r))
              for (let Ir = 0; ; Ir++) {
                if (c(ti.bytes($r.length, !0), $r)) {
                  ti.bytes($r.length);
                  break;
                }
                Rr(`${Ir}`, () => Lr.push(oi.decodeStream(ti)));
              }
            else {
              let Ir;
              Rr("arrayLen", () => Ir = zr.decodeStream(ti));
              for (let pr = 0; pr < Ir; pr++)
                Rr(`${pr}`, () => Lr.push(oi.decodeStream(ti)));
            }
          }), Lr;
        },
        validate: (ti) => {
          if (!Array.isArray(ti))
            throw new Error(`array: invalid value ${ti}`);
          return ti;
        }
      });
    }
    function Gr($r, oi) {
      if (!Ee($r))
        throw new Error(`map: invalid inner value ${$r}`);
      if (!E(oi))
        throw new Error("map: variants should be plain object");
      const zr = /* @__PURE__ */ new Map();
      for (const ti in oi)
        zr.set(oi[ti], ti);
      return (0, o.wrap)({
        size: $r.size,
        encodeStream: (ti, Lr) => $r.encodeStream(ti, oi[Lr]),
        decodeStream: (ti) => {
          const Lr = $r.decodeStream(ti), Rr = zr.get(Lr);
          if (Rr === void 0)
            throw ti.err(`Enum: unknown value: ${Lr} ${Array.from(zr.keys())}`);
          return Rr;
        },
        validate: (ti) => {
          if (typeof ti != "string")
            throw new Error(`map: invalid value ${ti}`);
          if (!(ti in oi))
            throw new Error(`Map: unknown variant: ${ti}`);
          return ti;
        }
      });
    }
    function Fr($r, oi) {
      if (!Ee($r))
        throw new Error(`tag: invalid tag value ${$r}`);
      if (!E(oi))
        throw new Error("tag: variants should be plain object");
      for (const zr in oi)
        if (!Ee(oi[zr]))
          throw new Error(`tag: variant ${zr} is not CoderType`);
      return (0, o.wrap)({
        size: $r.size,
        encodeStream: (zr, ti) => {
          const { TAG: Lr, data: Rr } = ti, Ir = oi[Lr];
          $r.encodeStream(zr, Lr), Ir.encodeStream(zr, Rr);
        },
        decodeStream: (zr) => {
          const ti = $r.decodeStream(zr), Lr = oi[ti];
          if (!Lr)
            throw zr.err(`Tag: invalid tag ${ti}`);
          return { TAG: ti, data: Lr.decodeStream(zr) };
        },
        validate: (zr) => {
          const { TAG: ti } = zr;
          if (!oi[ti])
            throw new Error(`Tag: invalid tag ${ti.toString()}`);
          return zr;
        }
      });
    }
    function br($r, oi) {
      if (!Ee($r))
        throw new Error(`mappedTag: invalid tag value ${Fr}`);
      if (!E(oi))
        throw new Error("mappedTag: variants should be plain object");
      const zr = {}, ti = {};
      for (const Lr in oi) {
        const Rr = oi[Lr];
        zr[Lr] = Rr[0], ti[Lr] = Rr[1];
      }
      return Fr(Gr($r, zr), ti);
    }
    function Ar($r, oi = !1) {
      if (typeof oi != "boolean")
        throw new Error(`bitset/pad: expected boolean, got ${typeof oi}`);
      if (!Array.isArray($r))
        throw new Error("bitset/names: expected array");
      for (const zr of $r)
        if (typeof zr != "string")
          throw new Error("bitset/names: expected array of strings");
      return (0, o.wrap)({
        encodeStream: (zr, ti) => {
          for (let Lr = 0; Lr < $r.length; Lr++)
            zr.bits(+ti[$r[Lr]], 1);
          oi && $r.length % 8 && zr.bits(0, 8 - $r.length % 8);
        },
        decodeStream: (zr) => {
          const ti = {};
          for (let Lr = 0; Lr < $r.length; Lr++)
            ti[$r[Lr]] = !!zr.bits(1);
          return oi && $r.length % 8 && zr.bits(8 - $r.length % 8), ti;
        },
        validate: (zr) => {
          if (!E(zr))
            throw new Error(`bitset: invalid value ${zr}`);
          for (const ti of Object.values(zr))
            if (typeof ti != "boolean")
              throw new Error("expected boolean");
          return zr;
        }
      });
    }
    const cr = ($r) => 0;
    o.ZeroPad = cr;
    function hr($r, oi) {
      return oi % $r === 0 ? 0 : $r - oi % $r;
    }
    function Wr($r, oi, zr) {
      if (!B($r) || $r <= 0)
        throw new Error(`padLeft: wrong blockSize=${$r}`);
      if (!Ee(oi))
        throw new Error(`padLeft: invalid inner value ${oi}`);
      if (zr !== void 0 && typeof zr != "function")
        throw new Error(`padLeft: wrong padFn=${typeof zr}`);
      const ti = zr || o.ZeroPad;
      if (!oi.size)
        throw new Error("padLeft cannot have dynamic size");
      return (0, o.wrap)({
        size: oi.size + hr($r, oi.size),
        encodeStream: (Lr, Rr) => {
          const Ir = hr($r, oi.size);
          for (let pr = 0; pr < Ir; pr++)
            Lr.byte(ti(pr));
          oi.encodeStream(Lr, Rr);
        },
        decodeStream: (Lr) => (Lr.bytes(hr($r, oi.size)), oi.decodeStream(Lr))
      });
    }
    function fi($r, oi, zr) {
      if (!Ee(oi))
        throw new Error(`padRight: invalid inner value ${oi}`);
      if (!B($r) || $r <= 0)
        throw new Error(`padLeft: wrong blockSize=${$r}`);
      if (zr !== void 0 && typeof zr != "function")
        throw new Error(`padRight: wrong padFn=${typeof zr}`);
      const ti = zr || o.ZeroPad;
      return (0, o.wrap)({
        size: oi.size ? oi.size + hr($r, oi.size) : void 0,
        encodeStream: (Lr, Rr) => {
          const Ir = Lr, pr = Ir.pos;
          oi.encodeStream(Lr, Rr);
          const Cr = hr($r, Ir.pos - pr);
          for (let Er = 0; Er < Cr; Er++)
            Lr.byte(ti(Er));
        },
        decodeStream: (Lr) => {
          const Rr = Lr.pos, Ir = oi.decodeStream(Lr);
          return Lr.bytes(hr($r, Lr.pos - Rr)), Ir;
        }
      });
    }
    function Bi($r, oi, zr = !1) {
      if (!Ee($r))
        throw new Error(`pointer: invalid ptr value ${$r}`);
      if (!Ee(oi))
        throw new Error(`pointer: invalid inner value ${oi}`);
      if (typeof zr != "boolean")
        throw new Error(`pointer/sized: expected boolean, got ${typeof zr}`);
      if (!$r.size)
        throw new Error("unsized pointer");
      return (0, o.wrap)({
        size: zr ? $r.size : void 0,
        encodeStream: (ti, Lr) => {
          const Rr = ti, Ir = Rr.pos;
          $r.encodeStream(ti, 0), Rr.ptrs.push({ pos: Ir, ptr: $r, buffer: oi.encode(Lr) });
        },
        decodeStream: (ti) => {
          const Lr = $r.decodeStream(ti);
          return ti._enablePointers(), oi.decodeStream(ti.offsetReader(Lr));
        }
      });
    }
    o._TEST = { _bitset: x, _Reader: F, _Writer: M, Path: v };
  }(lib)), lib;
}
var hasRequiredUtils$1;
function requireUtils$1() {
  return hasRequiredUtils$1 || (hasRequiredUtils$1 = 1, function(o) {
    Object.defineProperty(o, "__esModule", { value: !0 }), o.TEST_NETWORK = o.NETWORK = o.TAPROOT_UNSPENDABLE_KEY = o.PubT = o.tagSchnorr = o.signSchnorr = o.pubECDSA = o.pubSchnorr = o.randomPrivateKeyBytes = o.sha256x2 = o.hash160 = o.sha256 = o.isBytes = o.equalBytes = o.concatBytes = void 0, o.signECDSA = U, o.validatePubkey = H, o.tapTweak = fe, o.taprootTweakPrivKey = ge, o.taprootTweakPubkey = Ie, o.compareBytes = Ee;
    const g = /* @__PURE__ */ requireSecp256k1$5(), c = /* @__PURE__ */ requireLegacy(), y = /* @__PURE__ */ requireSha2();
    Object.defineProperty(o, "sha256", { enumerable: !0, get: function() {
      return y.sha256;
    } });
    const t = /* @__PURE__ */ requireLib(), d = g.secp256k1.ProjectivePoint, E = g.secp256k1.CURVE.n, B = t.utils.isBytes;
    o.isBytes = B;
    const D = t.utils.concatBytes;
    o.concatBytes = D;
    const x = t.utils.equalBytes;
    o.equalBytes = x;
    const v = (Se) => (0, c.ripemd160)((0, y.sha256)(Se));
    o.hash160 = v;
    const F = (...Se) => (0, y.sha256)((0, y.sha256)(D(...Se)));
    o.sha256x2 = F, o.randomPrivateKeyBytes = g.schnorr.utils.randomPrivateKey, o.pubSchnorr = g.schnorr.getPublicKey, o.pubECDSA = g.secp256k1.getPublicKey;
    const M = (Se) => Se.r < E / 2n;
    function U(Se, ze, He = !1) {
      let Pe = g.secp256k1.sign(Se, ze);
      if (He && !M(Pe)) {
        const De = new Uint8Array(32);
        let ve = 0;
        for (; !M(Pe); )
          if (De.set(t.U32LE.encode(ve++)), Pe = g.secp256k1.sign(Se, ze, { extraEntropy: De }), ve > 4294967295)
            throw new Error("lowR counter overflow: report the error");
      }
      return Pe.toDERRawBytes();
    }
    o.signSchnorr = g.schnorr.sign, o.tagSchnorr = g.schnorr.utils.taggedHash;
    var L;
    (function(Se) {
      Se[Se.ecdsa = 0] = "ecdsa", Se[Se.schnorr = 1] = "schnorr";
    })(L || (o.PubT = L = {}));
    function H(Se, ze) {
      const He = Se.length;
      if (ze === L.ecdsa) {
        if (He === 32)
          throw new Error("Expected non-Schnorr key");
        return d.fromHex(Se), Se;
      } else if (ze === L.schnorr) {
        if (He !== 32)
          throw new Error("Expected 32-byte Schnorr key");
        return g.schnorr.utils.lift_x(g.schnorr.utils.bytesToNumberBE(Se)), Se;
      } else
        throw new Error("Unknown key type");
    }
    function fe(Se, ze) {
      const He = g.schnorr.utils, Pe = He.taggedHash("TapTweak", Se, ze), De = He.bytesToNumberBE(Pe);
      if (De >= E)
        throw new Error("tweak higher than curve order");
      return De;
    }
    function ge(Se, ze = Uint8Array.of()) {
      const He = g.schnorr.utils, Pe = He.bytesToNumberBE(Se), De = d.fromPrivateKey(Pe), ve = De.hasEvenY() ? Pe : He.mod(-Pe, E), Fe = He.pointToBytes(De), be = fe(Fe, ze);
      return He.numberToBytesBE(He.mod(ve + be, E), 32);
    }
    function Ie(Se, ze) {
      const He = g.schnorr.utils, Pe = fe(Se, ze), ve = He.lift_x(He.bytesToNumberBE(Se)).add(d.fromPrivateKey(Pe)), Fe = ve.hasEvenY() ? 0 : 1;
      return [He.pointToBytes(ve), Fe];
    }
    o.TAPROOT_UNSPENDABLE_KEY = (0, y.sha256)(d.BASE.toRawBytes(!1)), o.NETWORK = {
      bech32: "bc",
      pubKeyHash: 0,
      scriptHash: 5,
      wif: 128
    }, o.TEST_NETWORK = {
      bech32: "tb",
      pubKeyHash: 111,
      scriptHash: 196,
      wif: 239
    };
    function Ee(Se, ze) {
      if (!B(Se) || !B(ze))
        throw new Error(`cmp: wrong type a=${typeof Se} b=${typeof ze}`);
      const He = Math.min(Se.length, ze.length);
      for (let Pe = 0; Pe < He; Pe++)
        if (Se[Pe] != ze[Pe])
          return Math.sign(Se[Pe] - ze[Pe]);
      return Math.sign(Se.length - ze.length);
    }
  }(utils$1)), utils$1;
}
var payment = {}, psbt$1 = {}, script = {}, hasRequiredScript;
function requireScript() {
  return hasRequiredScript || (hasRequiredScript = 1, function(o) {
    Object.defineProperty(o, "__esModule", { value: !0 }), o.RawOldTx = o.RawTx = o.RawOutput = o.RawInput = o.BTCArray = o.RawWitness = o.VarBytes = o.CompactSizeLen = o.CompactSize = o.Script = o.OP = o.MAX_SCRIPT_BYTE_LENGTH = void 0, o.ScriptNum = t, o.OpToNum = d;
    const g = /* @__PURE__ */ requireLib(), c = /* @__PURE__ */ requireUtils$1();
    o.MAX_SCRIPT_BYTE_LENGTH = 520;
    var y;
    (function(v) {
      v[v.OP_0 = 0] = "OP_0", v[v.PUSHDATA1 = 76] = "PUSHDATA1", v[v.PUSHDATA2 = 77] = "PUSHDATA2", v[v.PUSHDATA4 = 78] = "PUSHDATA4", v[v["1NEGATE"] = 79] = "1NEGATE", v[v.RESERVED = 80] = "RESERVED", v[v.OP_1 = 81] = "OP_1", v[v.OP_2 = 82] = "OP_2", v[v.OP_3 = 83] = "OP_3", v[v.OP_4 = 84] = "OP_4", v[v.OP_5 = 85] = "OP_5", v[v.OP_6 = 86] = "OP_6", v[v.OP_7 = 87] = "OP_7", v[v.OP_8 = 88] = "OP_8", v[v.OP_9 = 89] = "OP_9", v[v.OP_10 = 90] = "OP_10", v[v.OP_11 = 91] = "OP_11", v[v.OP_12 = 92] = "OP_12", v[v.OP_13 = 93] = "OP_13", v[v.OP_14 = 94] = "OP_14", v[v.OP_15 = 95] = "OP_15", v[v.OP_16 = 96] = "OP_16", v[v.NOP = 97] = "NOP", v[v.VER = 98] = "VER", v[v.IF = 99] = "IF", v[v.NOTIF = 100] = "NOTIF", v[v.VERIF = 101] = "VERIF", v[v.VERNOTIF = 102] = "VERNOTIF", v[v.ELSE = 103] = "ELSE", v[v.ENDIF = 104] = "ENDIF", v[v.VERIFY = 105] = "VERIFY", v[v.RETURN = 106] = "RETURN", v[v.TOALTSTACK = 107] = "TOALTSTACK", v[v.FROMALTSTACK = 108] = "FROMALTSTACK", v[v["2DROP"] = 109] = "2DROP", v[v["2DUP"] = 110] = "2DUP", v[v["3DUP"] = 111] = "3DUP", v[v["2OVER"] = 112] = "2OVER", v[v["2ROT"] = 113] = "2ROT", v[v["2SWAP"] = 114] = "2SWAP", v[v.IFDUP = 115] = "IFDUP", v[v.DEPTH = 116] = "DEPTH", v[v.DROP = 117] = "DROP", v[v.DUP = 118] = "DUP", v[v.NIP = 119] = "NIP", v[v.OVER = 120] = "OVER", v[v.PICK = 121] = "PICK", v[v.ROLL = 122] = "ROLL", v[v.ROT = 123] = "ROT", v[v.SWAP = 124] = "SWAP", v[v.TUCK = 125] = "TUCK", v[v.CAT = 126] = "CAT", v[v.SUBSTR = 127] = "SUBSTR", v[v.LEFT = 128] = "LEFT", v[v.RIGHT = 129] = "RIGHT", v[v.SIZE = 130] = "SIZE", v[v.INVERT = 131] = "INVERT", v[v.AND = 132] = "AND", v[v.OR = 133] = "OR", v[v.XOR = 134] = "XOR", v[v.EQUAL = 135] = "EQUAL", v[v.EQUALVERIFY = 136] = "EQUALVERIFY", v[v.RESERVED1 = 137] = "RESERVED1", v[v.RESERVED2 = 138] = "RESERVED2", v[v["1ADD"] = 139] = "1ADD", v[v["1SUB"] = 140] = "1SUB", v[v["2MUL"] = 141] = "2MUL", v[v["2DIV"] = 142] = "2DIV", v[v.NEGATE = 143] = "NEGATE", v[v.ABS = 144] = "ABS", v[v.NOT = 145] = "NOT", v[v["0NOTEQUAL"] = 146] = "0NOTEQUAL", v[v.ADD = 147] = "ADD", v[v.SUB = 148] = "SUB", v[v.MUL = 149] = "MUL", v[v.DIV = 150] = "DIV", v[v.MOD = 151] = "MOD", v[v.LSHIFT = 152] = "LSHIFT", v[v.RSHIFT = 153] = "RSHIFT", v[v.BOOLAND = 154] = "BOOLAND", v[v.BOOLOR = 155] = "BOOLOR", v[v.NUMEQUAL = 156] = "NUMEQUAL", v[v.NUMEQUALVERIFY = 157] = "NUMEQUALVERIFY", v[v.NUMNOTEQUAL = 158] = "NUMNOTEQUAL", v[v.LESSTHAN = 159] = "LESSTHAN", v[v.GREATERTHAN = 160] = "GREATERTHAN", v[v.LESSTHANOREQUAL = 161] = "LESSTHANOREQUAL", v[v.GREATERTHANOREQUAL = 162] = "GREATERTHANOREQUAL", v[v.MIN = 163] = "MIN", v[v.MAX = 164] = "MAX", v[v.WITHIN = 165] = "WITHIN", v[v.RIPEMD160 = 166] = "RIPEMD160", v[v.SHA1 = 167] = "SHA1", v[v.SHA256 = 168] = "SHA256", v[v.HASH160 = 169] = "HASH160", v[v.HASH256 = 170] = "HASH256", v[v.CODESEPARATOR = 171] = "CODESEPARATOR", v[v.CHECKSIG = 172] = "CHECKSIG", v[v.CHECKSIGVERIFY = 173] = "CHECKSIGVERIFY", v[v.CHECKMULTISIG = 174] = "CHECKMULTISIG", v[v.CHECKMULTISIGVERIFY = 175] = "CHECKMULTISIGVERIFY", v[v.NOP1 = 176] = "NOP1", v[v.CHECKLOCKTIMEVERIFY = 177] = "CHECKLOCKTIMEVERIFY", v[v.CHECKSEQUENCEVERIFY = 178] = "CHECKSEQUENCEVERIFY", v[v.NOP4 = 179] = "NOP4", v[v.NOP5 = 180] = "NOP5", v[v.NOP6 = 181] = "NOP6", v[v.NOP7 = 182] = "NOP7", v[v.NOP8 = 183] = "NOP8", v[v.NOP9 = 184] = "NOP9", v[v.NOP10 = 185] = "NOP10", v[v.CHECKSIGADD = 186] = "CHECKSIGADD", v[v.INVALID = 255] = "INVALID";
    })(y || (o.OP = y = {}));
    function t(v = 6, F = !1) {
      return g.wrap({
        encodeStream: (M, U) => {
          if (U === 0n)
            return;
          const L = U < 0, H = BigInt(U), fe = [];
          for (let ge = L ? -H : H; ge; ge >>= 8n)
            fe.push(Number(ge & 0xffn));
          fe[fe.length - 1] >= 128 ? fe.push(L ? 128 : 0) : L && (fe[fe.length - 1] |= 128), M.bytes(new Uint8Array(fe));
        },
        decodeStream: (M) => {
          const U = M.leftBytes;
          if (U > v)
            throw new Error(`ScriptNum: number (${U}) bigger than limit=${v}`);
          if (U === 0)
            return 0n;
          if (F) {
            const fe = M.bytes(U, !0);
            if ((fe[fe.length - 1] & 127) === 0 && (U <= 1 || (fe[fe.length - 2] & 128) === 0))
              throw new Error("Non-minimally encoded ScriptNum");
          }
          let L = 0, H = 0n;
          for (let fe = 0; fe < U; ++fe)
            L = M.byte(), H |= BigInt(L) << 8n * BigInt(fe);
          return L >= 128 && (H &= 2n ** BigInt(U * 8) - 1n >> 1n, H = -H), H;
        }
      });
    }
    function d(v, F = 4, M = !0) {
      if (typeof v == "number")
        return v;
      if ((0, c.isBytes)(v))
        try {
          const U = t(F, M).decode(v);
          return U > Number.MAX_SAFE_INTEGER ? void 0 : Number(U);
        } catch {
          return;
        }
    }
    o.Script = g.wrap({
      encodeStream: (v, F) => {
        for (let M of F) {
          if (typeof M == "string") {
            if (y[M] === void 0)
              throw new Error(`Unknown opcode=${M}`);
            v.byte(y[M]);
            continue;
          } else if (typeof M == "number") {
            if (M === 0) {
              v.byte(0);
              continue;
            } else if (1 <= M && M <= 16) {
              v.byte(y.OP_1 - 1 + M);
              continue;
            }
          }
          if (typeof M == "number" && (M = t().encode(BigInt(M))), !(0, c.isBytes)(M))
            throw new Error(`Wrong Script OP=${M} (${typeof M})`);
          const U = M.length;
          U < y.PUSHDATA1 ? v.byte(U) : U <= 255 ? (v.byte(y.PUSHDATA1), v.byte(U)) : U <= 65535 ? (v.byte(y.PUSHDATA2), v.bytes(g.U16LE.encode(U))) : (v.byte(y.PUSHDATA4), v.bytes(g.U32LE.encode(U))), v.bytes(M);
        }
      },
      decodeStream: (v) => {
        const F = [];
        for (; !v.isEnd(); ) {
          const M = v.byte();
          if (y.OP_0 < M && M <= y.PUSHDATA4) {
            let U;
            if (M < y.PUSHDATA1)
              U = M;
            else if (M === y.PUSHDATA1)
              U = g.U8.decodeStream(v);
            else if (M === y.PUSHDATA2)
              U = g.U16LE.decodeStream(v);
            else if (M === y.PUSHDATA4)
              U = g.U32LE.decodeStream(v);
            else
              throw new Error("Should be not possible");
            F.push(v.bytes(U));
          } else if (M === 0)
            F.push(0);
          else if (y.OP_1 <= M && M <= y.OP_16)
            F.push(M - (y.OP_1 - 1));
          else {
            const U = y[M];
            if (U === void 0)
              throw new Error(`Unknown opcode=${M.toString(16)}`);
            F.push(U);
          }
        }
        return F;
      }
    });
    const E = {
      253: [253, 2, 253n, 65535n],
      254: [254, 4, 65536n, 4294967295n],
      255: [255, 8, 4294967296n, 18446744073709551615n]
    };
    o.CompactSize = g.wrap({
      encodeStream: (v, F) => {
        if (typeof F == "number" && (F = BigInt(F)), 0n <= F && F <= 252n)
          return v.byte(Number(F));
        for (const [M, U, L, H] of Object.values(E))
          if (!(L > F || F > H)) {
            v.byte(M);
            for (let fe = 0; fe < U; fe++)
              v.byte(Number(F >> 8n * BigInt(fe) & 0xffn));
            return;
          }
        throw v.err(`VarInt too big: ${F}`);
      },
      decodeStream: (v) => {
        const F = v.byte();
        if (F <= 252)
          return BigInt(F);
        const [M, U, L] = E[F];
        let H = 0n;
        for (let fe = 0; fe < U; fe++)
          H |= BigInt(v.byte()) << 8n * BigInt(fe);
        if (H < L)
          throw v.err(`Wrong CompactSize(${8 * U})`);
        return H;
      }
    }), o.CompactSizeLen = g.apply(o.CompactSize, g.coders.numberBigint), o.VarBytes = g.bytes(o.CompactSize), o.RawWitness = g.array(o.CompactSizeLen, o.VarBytes);
    const B = (v) => g.array(o.CompactSize, v);
    o.BTCArray = B, o.RawInput = g.struct({
      txid: g.bytes(32, !0),
      // hash(prev_tx),
      index: g.U32LE,
      // output number of previous tx
      finalScriptSig: o.VarBytes,
      // btc merges input and output script, executes it. If ok = tx passes
      sequence: g.U32LE
      // ?
    }), o.RawOutput = g.struct({ amount: g.U64LE, script: o.VarBytes });
    const D = g.struct({
      version: g.I32LE,
      segwitFlag: g.flag(new Uint8Array([0, 1])),
      inputs: (0, o.BTCArray)(o.RawInput),
      outputs: (0, o.BTCArray)(o.RawOutput),
      witnesses: g.flagged("segwitFlag", g.array("inputs/length", o.RawWitness)),
      // < 500000000	Block number at which this transaction is unlocked
      // >= 500000000	UNIX timestamp at which this transaction is unlocked
      // Handled as part of PSBTv2
      lockTime: g.U32LE
    });
    function x(v) {
      if (v.segwitFlag && v.witnesses && !v.witnesses.length)
        throw new Error("Segwit flag with empty witnesses array");
      return v;
    }
    o.RawTx = g.validate(D, x), o.RawOldTx = g.struct({
      version: g.I32LE,
      inputs: (0, o.BTCArray)(o.RawInput),
      outputs: (0, o.BTCArray)(o.RawOutput),
      lockTime: g.U32LE
    });
  }(script)), script;
}
var hasRequiredPsbt$1;
function requirePsbt$1() {
  return hasRequiredPsbt$1 || (hasRequiredPsbt$1 = 1, function(o) {
    Object.defineProperty(o, "__esModule", { value: !0 }), o.RawPSBTV2 = o.RawPSBTV0 = o._DebugPSBT = o._RawPSBTV2 = o._RawPSBTV0 = o.PSBTOutputCoder = o.PSBTInputCoder = o.PSBTOutputUnsignedKeys = o.PSBTOutput = o.PSBTInputUnsignedKeys = o.PSBTInputFinalKeys = o.PSBTInput = o.PSBTGlobal = o.TaprootControlBlock = void 0, o.cleanPSBTFields = He, o.mergeKeyMap = De;
    const g = /* @__PURE__ */ requireLib$2(), c = /* @__PURE__ */ requireLib(), y = /* @__PURE__ */ requireScript(), t = /* @__PURE__ */ requireUtils$1(), d = c.validate(c.bytes(null), (ve) => (0, t.validatePubkey)(ve, t.PubT.ecdsa)), E = c.validate(c.bytes(32), (ve) => (0, t.validatePubkey)(ve, t.PubT.schnorr)), B = c.validate(c.bytes(null), (ve) => {
      if (ve.length !== 64 && ve.length !== 65)
        throw new Error("Schnorr signature should be 64 or 65 bytes long");
      return ve;
    }), D = c.struct({
      fingerprint: c.U32BE,
      path: c.array(null, c.U32LE)
    }), x = c.struct({
      hashes: c.array(y.CompactSizeLen, c.bytes(32)),
      der: D
    }), v = c.bytes(78), F = c.struct({ pubKey: E, leafHash: c.bytes(32) }), M = c.struct({
      version: c.U8,
      // With parity :(
      internalKey: c.bytes(32),
      merklePath: c.array(null, c.bytes(32))
    });
    o.TaprootControlBlock = c.validate(M, (ve) => {
      if (ve.merklePath.length > 128)
        throw new Error("TaprootControlBlock: merklePath should be of length 0..128 (inclusive)");
      return ve;
    });
    const U = c.array(null, c.struct({
      depth: c.U8,
      version: c.U8,
      script: y.VarBytes
    })), L = c.bytes(null), H = c.bytes(20), fe = c.bytes(32);
    o.PSBTGlobal = {
      unsignedTx: [0, !1, y.RawOldTx, [0], [0], !1],
      xpub: [1, v, D, [], [0, 2], !1],
      txVersion: [2, !1, c.U32LE, [2], [2], !1],
      fallbackLocktime: [3, !1, c.U32LE, [], [2], !1],
      inputCount: [4, !1, y.CompactSizeLen, [2], [2], !1],
      outputCount: [5, !1, y.CompactSizeLen, [2], [2], !1],
      txModifiable: [6, !1, c.U8, [], [2], !1],
      // TODO: bitfield
      version: [251, !1, c.U32LE, [], [0, 2], !1],
      proprietary: [252, L, L, [], [0, 2], !1]
    }, o.PSBTInput = {
      nonWitnessUtxo: [0, !1, y.RawTx, [], [0, 2], !1],
      witnessUtxo: [1, !1, y.RawOutput, [], [0, 2], !1],
      partialSig: [2, d, L, [], [0, 2], !1],
      sighashType: [3, !1, c.U32LE, [], [0, 2], !1],
      redeemScript: [4, !1, L, [], [0, 2], !1],
      witnessScript: [5, !1, L, [], [0, 2], !1],
      bip32Derivation: [6, d, D, [], [0, 2], !1],
      finalScriptSig: [7, !1, L, [], [0, 2], !1],
      finalScriptWitness: [8, !1, y.RawWitness, [], [0, 2], !1],
      porCommitment: [9, !1, L, [], [0, 2], !1],
      ripemd160: [10, H, L, [], [0, 2], !1],
      sha256: [11, fe, L, [], [0, 2], !1],
      hash160: [12, H, L, [], [0, 2], !1],
      hash256: [13, fe, L, [], [0, 2], !1],
      txid: [14, !1, fe, [2], [2], !0],
      index: [15, !1, c.U32LE, [2], [2], !0],
      sequence: [16, !1, c.U32LE, [], [2], !0],
      requiredTimeLocktime: [17, !1, c.U32LE, [], [2], !1],
      requiredHeightLocktime: [18, !1, c.U32LE, [], [2], !1],
      tapKeySig: [19, !1, B, [], [0, 2], !1],
      tapScriptSig: [20, F, B, [], [0, 2], !1],
      tapLeafScript: [21, o.TaprootControlBlock, L, [], [0, 2], !1],
      tapBip32Derivation: [22, fe, x, [], [0, 2], !1],
      tapInternalKey: [23, !1, E, [], [0, 2], !1],
      tapMerkleRoot: [24, !1, fe, [], [0, 2], !1],
      proprietary: [252, L, L, [], [0, 2], !1]
    }, o.PSBTInputFinalKeys = [
      "txid",
      "sequence",
      "index",
      "witnessUtxo",
      "nonWitnessUtxo",
      "finalScriptSig",
      "finalScriptWitness",
      "unknown"
    ], o.PSBTInputUnsignedKeys = [
      "partialSig",
      "finalScriptSig",
      "finalScriptWitness",
      "tapKeySig",
      "tapScriptSig"
    ], o.PSBTOutput = {
      redeemScript: [0, !1, L, [], [0, 2], !1],
      witnessScript: [1, !1, L, [], [0, 2], !1],
      bip32Derivation: [2, d, D, [], [0, 2], !1],
      amount: [3, !1, c.I64LE, [2], [2], !0],
      script: [4, !1, L, [2], [2], !0],
      tapInternalKey: [5, !1, E, [], [0, 2], !1],
      tapTree: [6, !1, U, [], [0, 2], !1],
      tapBip32Derivation: [7, E, x, [], [0, 2], !1],
      proprietary: [252, L, L, [], [0, 2], !1]
    }, o.PSBTOutputUnsignedKeys = [];
    const ge = c.array(c.NULL, c.struct({
      //  <key> := <keylen> <keytype> <keydata> WHERE keylen = len(keytype)+len(keydata)
      key: c.prefix(y.CompactSizeLen, c.struct({ type: y.CompactSizeLen, key: c.bytes(null) })),
      //  <value> := <valuelen> <valuedata>
      value: c.bytes(y.CompactSizeLen)
    }));
    function Ie(ve) {
      const [Fe, be, Be, ke, xe, Ne] = ve;
      return { type: Fe, kc: be, vc: Be, reqInc: ke, allowInc: xe, silentIgnore: Ne };
    }
    c.struct({ type: y.CompactSizeLen, key: c.bytes(null) });
    function Ee(ve) {
      const Fe = {};
      for (const be in ve) {
        const [Be, ke, xe] = ve[be];
        Fe[Be] = [be, ke, xe];
      }
      return c.wrap({
        encodeStream: (be, Be) => {
          let ke = [];
          for (const xe in ve) {
            const Ne = Be[xe];
            if (Ne === void 0)
              continue;
            const [Et, st, Dt] = ve[xe];
            if (!st)
              ke.push({ key: { type: Et, key: c.EMPTY }, value: Dt.encode(Ne) });
            else {
              const er = Ne.map(([xt, ir]) => [
                st.encode(xt),
                Dt.encode(ir)
              ]);
              er.sort((xt, ir) => (0, t.compareBytes)(xt[0], ir[0]));
              for (const [xt, ir] of er)
                ke.push({ key: { key: xt, type: Et }, value: ir });
            }
          }
          if (Be.unknown) {
            Be.unknown.sort((xe, Ne) => (0, t.compareBytes)(xe[0].key, Ne[0].key));
            for (const [xe, Ne] of Be.unknown)
              ke.push({ key: xe, value: Ne });
          }
          ge.encodeStream(be, ke);
        },
        decodeStream: (be) => {
          const Be = ge.decodeStream(be), ke = {}, xe = {};
          for (const Ne of Be) {
            let Et = "unknown", st = Ne.key.key, Dt = Ne.value;
            if (Fe[Ne.key.type]) {
              const [er, xt, ir] = Fe[Ne.key.type];
              if (Et = er, !xt && st.length)
                throw new Error(`PSBT: Non-empty key for ${Et} (key=${g.hex.encode(st)} value=${g.hex.encode(Dt)}`);
              if (st = xt ? xt.decode(st) : void 0, Dt = ir.decode(Dt), !xt) {
                if (ke[Et])
                  throw new Error(`PSBT: Same keys: ${Et} (key=${st} value=${Dt})`);
                ke[Et] = Dt, xe[Et] = !0;
                continue;
              }
            } else
              st = { type: Ne.key.type, key: Ne.key.key };
            if (xe[Et])
              throw new Error(`PSBT: Key type with empty key and no key=${Et} val=${Dt}`);
            ke[Et] || (ke[Et] = []), ke[Et].push([st, Dt]);
          }
          return ke;
        }
      });
    }
    o.PSBTInputCoder = c.validate(Ee(o.PSBTInput), (ve) => {
      if (ve.finalScriptWitness && !ve.finalScriptWitness.length)
        throw new Error("validateInput: empty finalScriptWitness");
      if (ve.partialSig && !ve.partialSig.length)
        throw new Error("Empty partialSig");
      if (ve.partialSig)
        for (const [Fe] of ve.partialSig)
          (0, t.validatePubkey)(Fe, t.PubT.ecdsa);
      if (ve.bip32Derivation)
        for (const [Fe] of ve.bip32Derivation)
          (0, t.validatePubkey)(Fe, t.PubT.ecdsa);
      if (ve.requiredTimeLocktime !== void 0 && ve.requiredTimeLocktime < 5e8)
        throw new Error(`validateInput: wrong timeLocktime=${ve.requiredTimeLocktime}`);
      if (ve.requiredHeightLocktime !== void 0 && (ve.requiredHeightLocktime <= 0 || ve.requiredHeightLocktime >= 5e8))
        throw new Error(`validateInput: wrong heighLocktime=${ve.requiredHeightLocktime}`);
      if (ve.tapLeafScript)
        for (const [Fe, be] of ve.tapLeafScript) {
          if ((Fe.version & 254) !== be[be.length - 1])
            throw new Error("validateInput: tapLeafScript version mimatch");
          if (be[be.length - 1] & 1)
            throw new Error("validateInput: tapLeafScript version has parity bit!");
        }
      return ve;
    }), o.PSBTOutputCoder = c.validate(Ee(o.PSBTOutput), (ve) => {
      if (ve.bip32Derivation)
        for (const [Fe] of ve.bip32Derivation)
          (0, t.validatePubkey)(Fe, t.PubT.ecdsa);
      return ve;
    });
    const Se = c.validate(Ee(o.PSBTGlobal), (ve) => {
      if ((ve.version || 0) === 0) {
        if (!ve.unsignedTx)
          throw new Error("PSBTv0: missing unsignedTx");
        for (const be of ve.unsignedTx.inputs)
          if (be.finalScriptSig && be.finalScriptSig.length)
            throw new Error("PSBTv0: input scriptSig found in unsignedTx");
      }
      return ve;
    });
    o._RawPSBTV0 = c.struct({
      magic: c.magic(c.string(new Uint8Array([255])), "psbt"),
      global: Se,
      inputs: c.array("global/unsignedTx/inputs/length", o.PSBTInputCoder),
      outputs: c.array(null, o.PSBTOutputCoder)
    }), o._RawPSBTV2 = c.struct({
      magic: c.magic(c.string(new Uint8Array([255])), "psbt"),
      global: Se,
      inputs: c.array("global/inputCount", o.PSBTInputCoder),
      outputs: c.array("global/outputCount", o.PSBTOutputCoder)
    }), o._DebugPSBT = c.struct({
      magic: c.magic(c.string(new Uint8Array([255])), "psbt"),
      items: c.array(null, c.apply(c.array(c.NULL, c.tuple([c.hex(y.CompactSizeLen), c.bytes(y.CompactSize)])), c.coders.dict()))
    });
    function ze(ve, Fe, be) {
      for (const Be in be) {
        if (Be === "unknown" || !Fe[Be])
          continue;
        const { allowInc: ke } = Ie(Fe[Be]);
        if (!ke.includes(ve))
          throw new Error(`PSBTv${ve}: field ${Be} is not allowed`);
      }
      for (const Be in Fe) {
        const { reqInc: ke } = Ie(Fe[Be]);
        if (ke.includes(ve) && be[Be] === void 0)
          throw new Error(`PSBTv${ve}: missing required field ${Be}`);
      }
    }
    function He(ve, Fe, be) {
      const Be = {};
      for (const ke in be) {
        const xe = ke;
        if (xe !== "unknown") {
          if (!Fe[xe])
            continue;
          const { allowInc: Ne, silentIgnore: Et } = Ie(Fe[xe]);
          if (!Ne.includes(ve)) {
            if (Et)
              continue;
            throw new Error(`Failed to serialize in PSBTv${ve}: ${xe} but versions allows inclusion=${Ne}`);
          }
        }
        Be[xe] = be[xe];
      }
      return Be;
    }
    function Pe(ve) {
      const Fe = ve && ve.global && ve.global.version || 0;
      ze(Fe, o.PSBTGlobal, ve.global);
      for (const Ne of ve.inputs)
        ze(Fe, o.PSBTInput, Ne);
      for (const Ne of ve.outputs)
        ze(Fe, o.PSBTOutput, Ne);
      const be = Fe ? ve.global.inputCount : ve.global.unsignedTx.inputs.length;
      if (ve.inputs.length < be)
        throw new Error("Not enough inputs");
      const Be = ve.inputs.slice(be);
      if (Be.length > 1 || Be.length && Object.keys(Be[0]).length)
        throw new Error(`Unexpected inputs left in tx=${Be}`);
      const ke = Fe ? ve.global.outputCount : ve.global.unsignedTx.outputs.length;
      if (ve.outputs.length < ke)
        throw new Error("Not outputs inputs");
      const xe = ve.outputs.slice(ke);
      if (xe.length > 1 || xe.length && Object.keys(xe[0]).length)
        throw new Error(`Unexpected outputs left in tx=${xe}`);
      return ve;
    }
    function De(ve, Fe, be, Be, ke) {
      const xe = { ...be, ...Fe };
      for (const Ne in ve) {
        const Et = Ne, [st, Dt, er] = ve[Et], xt = Be && !Be.includes(Ne);
        if (Fe[Ne] === void 0 && Ne in Fe) {
          if (xt)
            throw new Error(`Cannot remove signed field=${Ne}`);
          delete xe[Ne];
        } else if (Dt) {
          const ir = be && be[Ne] ? be[Ne] : [];
          let sr = Fe[Et];
          if (sr) {
            if (!Array.isArray(sr))
              throw new Error(`keyMap(${Ne}): KV pairs should be [k, v][]`);
            sr = sr.map((qr) => {
              if (qr.length !== 2)
                throw new Error(`keyMap(${Ne}): KV pairs should be [k, v][]`);
              return [
                typeof qr[0] == "string" ? Dt.decode(g.hex.decode(qr[0])) : qr[0],
                typeof qr[1] == "string" ? er.decode(g.hex.decode(qr[1])) : qr[1]
              ];
            });
            const yr = {}, wr = (qr, Mr, Dr) => {
              if (yr[qr] === void 0) {
                yr[qr] = [Mr, Dr];
                return;
              }
              const Qr = g.hex.encode(er.encode(yr[qr][1])), Xr = g.hex.encode(er.encode(Dr));
              if (Qr !== Xr)
                throw new Error(`keyMap(${Et}): same key=${qr} oldVal=${Qr} newVal=${Xr}`);
            };
            for (const [qr, Mr] of ir) {
              const Dr = g.hex.encode(Dt.encode(qr));
              wr(Dr, qr, Mr);
            }
            for (const [qr, Mr] of sr) {
              const Dr = g.hex.encode(Dt.encode(qr));
              if (Mr === void 0) {
                if (xt)
                  throw new Error(`Cannot remove signed field=${Et}/${qr}`);
                delete yr[Dr];
              } else
                wr(Dr, qr, Mr);
            }
            xe[Et] = Object.values(yr);
          }
        } else if (typeof xe[Ne] == "string")
          xe[Ne] = er.decode(g.hex.decode(xe[Ne]));
        else if (xt && Ne in Fe && be && be[Ne] !== void 0 && !(0, t.equalBytes)(er.encode(Fe[Ne]), er.encode(be[Ne])))
          throw new Error(`Cannot change signed field=${Ne}`);
      }
      for (const Ne in xe)
        if (!ve[Ne]) {
          if (ke && Ne === "unknown")
            continue;
          delete xe[Ne];
        }
      return xe;
    }
    o.RawPSBTV0 = c.validate(o._RawPSBTV0, Pe), o.RawPSBTV2 = c.validate(o._RawPSBTV2, Pe);
  }(psbt$1)), psbt$1;
}
var hasRequiredPayment;
function requirePayment() {
  return hasRequiredPayment || (hasRequiredPayment = 1, function(o) {
    Object.defineProperty(o, "__esModule", { value: !0 }), o._sortPubkeys = o.p2tr_pk = o.p2tr_ns = o.tapLeafHash = o.TAP_LEAF_VERSION = o.p2ms = o.p2wpkh = o.p2wsh = o.p2sh = o.p2pkh = o.p2pk = o.OutScript = void 0, o.checkScript = He, o.taprootListToTree = Ne, o.p2tr = xt, o.combinations = ir, o.p2tr_ms = wr, o.getAddress = qr, o.multisig = Dr, o.sortedMultisig = Qr, o.WIF = Gr, o.Address = Fr;
    const g = /* @__PURE__ */ requireLib$2(), c = /* @__PURE__ */ requireLib(), y = /* @__PURE__ */ requirePsbt$1(), t = /* @__PURE__ */ requireScript(), d = /* @__PURE__ */ requireUtils$1(), E = /* @__PURE__ */ requireUtils$1(), B = {
      encode(br) {
        if (!(br.length !== 2 || br[0] !== 1 || !d.isBytes(br[1]) || g.hex.encode(br[1]) !== "4e73"))
          return { type: "p2a", script: t.Script.encode(br) };
      },
      decode: (br) => {
        if (br.type === "p2a")
          return [1, g.hex.decode("4e73")];
      }
    };
    function D(br, Ar) {
      try {
        return d.validatePubkey(br, Ar), !0;
      } catch {
        return !1;
      }
    }
    const Ee = [
      B,
      {
        encode(br) {
          if (!(br.length !== 2 || !d.isBytes(br[0]) || !D(br[0], d.PubT.ecdsa) || br[1] !== "CHECKSIG"))
            return { type: "pk", pubkey: br[0] };
        },
        decode: (br) => br.type === "pk" ? [br.pubkey, "CHECKSIG"] : void 0
      },
      {
        encode(br) {
          if (!(br.length !== 5 || br[0] !== "DUP" || br[1] !== "HASH160" || !d.isBytes(br[2])) && !(br[3] !== "EQUALVERIFY" || br[4] !== "CHECKSIG"))
            return { type: "pkh", hash: br[2] };
        },
        decode: (br) => br.type === "pkh" ? ["DUP", "HASH160", br.hash, "EQUALVERIFY", "CHECKSIG"] : void 0
      },
      {
        encode(br) {
          if (!(br.length !== 3 || br[0] !== "HASH160" || !d.isBytes(br[1]) || br[2] !== "EQUAL"))
            return { type: "sh", hash: br[1] };
        },
        decode: (br) => br.type === "sh" ? ["HASH160", br.hash, "EQUAL"] : void 0
      },
      {
        encode(br) {
          if (!(br.length !== 2 || br[0] !== 0 || !d.isBytes(br[1])) && br[1].length === 32)
            return { type: "wsh", hash: br[1] };
        },
        decode: (br) => br.type === "wsh" ? [0, br.hash] : void 0
      },
      {
        encode(br) {
          if (!(br.length !== 2 || br[0] !== 0 || !d.isBytes(br[1])) && br[1].length === 20)
            return { type: "wpkh", hash: br[1] };
        },
        decode: (br) => br.type === "wpkh" ? [0, br.hash] : void 0
      },
      {
        encode(br) {
          const Ar = br.length - 1;
          if (br[Ar] !== "CHECKMULTISIG")
            return;
          const cr = br[0], hr = br[Ar - 1];
          if (typeof cr != "number" || typeof hr != "number")
            return;
          const Wr = br.slice(1, -2);
          if (hr === Wr.length) {
            for (const fi of Wr)
              if (!d.isBytes(fi))
                return;
            return { type: "ms", m: cr, pubkeys: Wr };
          }
        },
        // checkmultisig(n, ..pubkeys, m)
        decode: (br) => br.type === "ms" ? [br.m, ...br.pubkeys, br.pubkeys.length, "CHECKMULTISIG"] : void 0
      },
      {
        encode(br) {
          if (!(br.length !== 2 || br[0] !== 1 || !d.isBytes(br[1])))
            return { type: "tr", pubkey: br[1] };
        },
        decode: (br) => br.type === "tr" ? [1, br.pubkey] : void 0
      },
      {
        encode(br) {
          const Ar = br.length - 1;
          if (br[Ar] !== "CHECKSIG")
            return;
          const cr = [];
          for (let hr = 0; hr < Ar; hr++) {
            const Wr = br[hr];
            if (hr & 1) {
              if (Wr !== "CHECKSIGVERIFY" || hr === Ar - 1)
                return;
              continue;
            }
            if (!d.isBytes(Wr))
              return;
            cr.push(Wr);
          }
          return { type: "tr_ns", pubkeys: cr };
        },
        decode: (br) => {
          if (br.type !== "tr_ns")
            return;
          const Ar = [];
          for (let cr = 0; cr < br.pubkeys.length - 1; cr++)
            Ar.push(br.pubkeys[cr], "CHECKSIGVERIFY");
          return Ar.push(br.pubkeys[br.pubkeys.length - 1], "CHECKSIG"), Ar;
        }
      },
      {
        encode(br) {
          const Ar = br.length - 1;
          if (br[Ar] !== "NUMEQUAL" || br[1] !== "CHECKSIG")
            return;
          const cr = [], hr = (0, t.OpToNum)(br[Ar - 1]);
          if (typeof hr == "number") {
            for (let Wr = 0; Wr < Ar - 1; Wr++) {
              const fi = br[Wr];
              if (Wr & 1) {
                if (fi !== (Wr === 1 ? "CHECKSIG" : "CHECKSIGADD"))
                  throw new Error("OutScript.encode/tr_ms: wrong element");
                continue;
              }
              if (!d.isBytes(fi))
                throw new Error("OutScript.encode/tr_ms: wrong key element");
              cr.push(fi);
            }
            return { type: "tr_ms", pubkeys: cr, m: hr };
          }
        },
        decode: (br) => {
          if (br.type !== "tr_ms")
            return;
          const Ar = [br.pubkeys[0], "CHECKSIG"];
          for (let cr = 1; cr < br.pubkeys.length; cr++)
            Ar.push(br.pubkeys[cr], "CHECKSIGADD");
          return Ar.push(br.m, "NUMEQUAL"), Ar;
        }
      },
      {
        encode(br) {
          return { type: "unknown", script: t.Script.encode(br) };
        },
        decode: (br) => br.type === "unknown" ? t.Script.decode(br.script) : void 0
      }
    ], Se = c.apply(t.Script, c.coders.match(Ee));
    o.OutScript = c.validate(Se, (br) => {
      if (br.type === "pk" && !D(br.pubkey, d.PubT.ecdsa))
        throw new Error("OutScript/pk: wrong key");
      if ((br.type === "pkh" || br.type === "sh" || br.type === "wpkh") && (!d.isBytes(br.hash) || br.hash.length !== 20))
        throw new Error(`OutScript/${br.type}: wrong hash`);
      if (br.type === "wsh" && (!d.isBytes(br.hash) || br.hash.length !== 32))
        throw new Error("OutScript/wsh: wrong hash");
      if (br.type === "tr" && (!d.isBytes(br.pubkey) || !D(br.pubkey, d.PubT.schnorr)))
        throw new Error("OutScript/tr: wrong taproot public key");
      if ((br.type === "ms" || br.type === "tr_ns" || br.type === "tr_ms") && !Array.isArray(br.pubkeys))
        throw new Error("OutScript/multisig: wrong pubkeys array");
      if (br.type === "ms") {
        const Ar = br.pubkeys.length;
        for (const cr of br.pubkeys)
          if (!D(cr, d.PubT.ecdsa))
            throw new Error("OutScript/multisig: wrong pubkey");
        if (br.m <= 0 || Ar > 16 || br.m > Ar)
          throw new Error("OutScript/multisig: invalid params");
      }
      if (br.type === "tr_ns" || br.type === "tr_ms") {
        for (const Ar of br.pubkeys)
          if (!D(Ar, d.PubT.schnorr))
            throw new Error(`OutScript/${br.type}: wrong pubkey`);
      }
      if (br.type === "tr_ms") {
        const Ar = br.pubkeys.length;
        if (br.m <= 0 || Ar > 999 || br.m > Ar)
          throw new Error("OutScript/tr_ms: invalid params");
      }
      return br;
    });
    function ze(br, Ar) {
      if (!d.equalBytes(br.hash, d.sha256(Ar)))
        throw new Error("checkScript: wsh wrong witnessScript hash");
      const cr = o.OutScript.decode(Ar);
      if (cr.type === "tr" || cr.type === "tr_ns" || cr.type === "tr_ms")
        throw new Error(`checkScript: P2${cr.type} cannot be wrapped in P2SH`);
      if (cr.type === "wpkh" || cr.type === "sh")
        throw new Error(`checkScript: P2${cr.type} cannot be wrapped in P2WSH`);
    }
    function He(br, Ar, cr) {
      if (br) {
        const hr = o.OutScript.decode(br);
        if (hr.type === "tr_ns" || hr.type === "tr_ms" || hr.type === "ms" || hr.type == "pk")
          throw new Error(`checkScript: non-wrapped ${hr.type}`);
        if (hr.type === "sh" && Ar) {
          if (!d.equalBytes(hr.hash, d.hash160(Ar)))
            throw new Error("checkScript: sh wrong redeemScript hash");
          const Wr = o.OutScript.decode(Ar);
          if (Wr.type === "tr" || Wr.type === "tr_ns" || Wr.type === "tr_ms")
            throw new Error(`checkScript: P2${Wr.type} cannot be wrapped in P2SH`);
          if (Wr.type === "sh")
            throw new Error("checkScript: P2SH cannot be wrapped in P2SH");
        }
        hr.type === "wsh" && cr && ze(hr, cr);
      }
      if (Ar) {
        const hr = o.OutScript.decode(Ar);
        hr.type === "wsh" && cr && ze(hr, cr);
      }
    }
    function Pe(br) {
      const Ar = {};
      for (const cr of br) {
        const hr = g.hex.encode(cr);
        if (Ar[hr])
          throw new Error(`Multisig: non-uniq pubkey: ${br.map(g.hex.encode)}`);
        Ar[hr] = !0;
      }
    }
    const De = (br, Ar = E.NETWORK) => {
      if (!D(br, d.PubT.ecdsa))
        throw new Error("P2PK: invalid publicKey");
      return { type: "pk", script: o.OutScript.encode({ type: "pk", pubkey: br }) };
    };
    o.p2pk = De;
    const ve = (br, Ar = E.NETWORK) => {
      if (!D(br, d.PubT.ecdsa))
        throw new Error("P2PKH: invalid publicKey");
      const cr = d.hash160(br);
      return {
        type: "pkh",
        script: o.OutScript.encode({ type: "pkh", hash: cr }),
        address: Fr(Ar).encode({ type: "pkh", hash: cr }),
        hash: cr
      };
    };
    o.p2pkh = ve;
    const Fe = (br, Ar = E.NETWORK) => {
      const cr = br.script;
      if (!d.isBytes(cr))
        throw new Error(`Wrong script: ${typeof br.script}, expected Uint8Array`);
      const hr = d.hash160(cr), Wr = o.OutScript.encode({ type: "sh", hash: hr });
      return He(Wr, cr, br.witnessScript), br.witnessScript ? {
        type: "sh",
        redeemScript: cr,
        script: o.OutScript.encode({ type: "sh", hash: hr }),
        address: Fr(Ar).encode({ type: "sh", hash: hr }),
        hash: hr,
        witnessScript: br.witnessScript
      } : {
        type: "sh",
        redeemScript: cr,
        script: o.OutScript.encode({ type: "sh", hash: hr }),
        address: Fr(Ar).encode({ type: "sh", hash: hr }),
        hash: hr
      };
    };
    o.p2sh = Fe;
    const be = (br, Ar = E.NETWORK) => {
      const cr = br.script;
      if (!d.isBytes(cr))
        throw new Error(`Wrong script: ${typeof cr}, expected Uint8Array`);
      const hr = d.sha256(cr), Wr = o.OutScript.encode({ type: "wsh", hash: hr });
      return He(Wr, void 0, cr), {
        type: "wsh",
        witnessScript: cr,
        script: o.OutScript.encode({ type: "wsh", hash: hr }),
        address: Fr(Ar).encode({ type: "wsh", hash: hr }),
        hash: hr
      };
    };
    o.p2wsh = be;
    const Be = (br, Ar = E.NETWORK) => {
      if (!D(br, d.PubT.ecdsa))
        throw new Error("P2WPKH: invalid publicKey");
      if (br.length === 65)
        throw new Error("P2WPKH: uncompressed public key");
      const cr = d.hash160(br);
      return {
        type: "wpkh",
        script: o.OutScript.encode({ type: "wpkh", hash: cr }),
        address: Fr(Ar).encode({ type: "wpkh", hash: cr }),
        hash: cr
      };
    };
    o.p2wpkh = Be;
    const ke = (br, Ar, cr = !1) => (cr || Pe(Ar), {
      type: "ms",
      script: o.OutScript.encode({ type: "ms", pubkeys: Ar, m: br })
    });
    o.p2ms = ke;
    function xe(br, Ar, cr = !1, hr) {
      const Wr = o.OutScript.decode(br);
      if (Wr.type === "unknown") {
        if (hr) {
          const $r = c.apply(t.Script, c.coders.match(hr)).decode(br);
          if ($r !== void 0) {
            if (typeof $r.type != "string" || !$r.type.startsWith("tr_"))
              throw new Error(`P2TR: invalid custom type=${$r.type}`);
            return;
          }
        }
        if (cr)
          return;
      }
      if (!["tr_ns", "tr_ms"].includes(Wr.type))
        throw new Error(`P2TR: invalid leaf script=${Wr.type}`);
      const fi = Wr;
      if (!cr && fi.pubkeys)
        for (const Bi of fi.pubkeys) {
          if (d.equalBytes(Bi, d.TAPROOT_UNSPENDABLE_KEY))
            throw new Error("Unspendable taproot key in leaf script");
          if (d.equalBytes(Bi, Ar))
            throw new Error("Using P2TR with leaf script with same key as internal key is not supported");
        }
    }
    function Ne(br) {
      const Ar = Array.from(br);
      for (; Ar.length >= 2; ) {
        Ar.sort((Bi, $r) => ($r.weight || 1) - (Bi.weight || 1));
        const hr = Ar.pop(), Wr = Ar.pop(), fi = ((Wr == null ? void 0 : Wr.weight) || 1) + ((hr == null ? void 0 : hr.weight) || 1);
        Ar.push({
          weight: fi,
          // Unwrap children array
          // TODO: Very hard to remove any here
          childs: [(Wr == null ? void 0 : Wr.childs) || Wr, (hr == null ? void 0 : hr.childs) || hr]
        });
      }
      const cr = Ar[0];
      return (cr == null ? void 0 : cr.childs) || cr;
    }
    function Et(br, Ar = []) {
      if (!br)
        throw new Error("taprootAddPath: empty tree");
      if (br.type === "leaf")
        return { ...br, path: Ar };
      if (br.type !== "branch")
        throw new Error(`taprootAddPath: wrong type=${br}`);
      return {
        ...br,
        path: Ar,
        // Left element has right hash in path and otherwise
        left: Et(br.left, [br.right.hash, ...Ar]),
        right: Et(br.right, [br.left.hash, ...Ar])
      };
    }
    function st(br) {
      if (!br)
        throw new Error("taprootAddPath: empty tree");
      if (br.type === "leaf")
        return [br];
      if (br.type !== "branch")
        throw new Error(`taprootWalkTree: wrong type=${br}`);
      return [...st(br.left), ...st(br.right)];
    }
    function Dt(br, Ar, cr = !1, hr) {
      if (!br)
        throw new Error("taprootHashTree: empty tree");
      if (Array.isArray(br) && br.length === 1 && (br = br[0]), !Array.isArray(br)) {
        const { leafVersion: oi, script: zr } = br;
        if (br.tapLeafScript || br.tapMerkleRoot && !d.equalBytes(br.tapMerkleRoot, c.EMPTY))
          throw new Error("P2TR: tapRoot leafScript cannot have tree");
        const ti = typeof zr == "string" ? g.hex.decode(zr) : zr;
        if (!d.isBytes(ti))
          throw new Error(`checkScript: wrong script type=${ti}`);
        return xe(ti, Ar, cr, hr), {
          type: "leaf",
          version: oi,
          script: ti,
          hash: (0, o.tapLeafHash)(ti, oi)
        };
      }
      if (br.length !== 2 && (br = Ne(br)), br.length !== 2)
        throw new Error("hashTree: non binary tree!");
      const Wr = Dt(br[0], Ar, cr, hr), fi = Dt(br[1], Ar, cr, hr);
      let [Bi, $r] = [Wr.hash, fi.hash];
      return d.compareBytes($r, Bi) === -1 && ([Bi, $r] = [$r, Bi]), { type: "branch", left: Wr, right: fi, hash: d.tagSchnorr("TapBranch", Bi, $r) };
    }
    o.TAP_LEAF_VERSION = 192;
    const er = (br, Ar = o.TAP_LEAF_VERSION) => d.tagSchnorr("TapLeaf", new Uint8Array([Ar]), t.VarBytes.encode(br));
    o.tapLeafHash = er;
    function xt(br, Ar, cr = E.NETWORK, hr = !1, Wr) {
      if (!br && !Ar)
        throw new Error("p2tr: should have pubKey or scriptTree (or both)");
      const fi = typeof br == "string" ? g.hex.decode(br) : br || d.TAPROOT_UNSPENDABLE_KEY;
      if (!D(fi, d.PubT.schnorr))
        throw new Error("p2tr: non-schnorr pubkey");
      if (Ar) {
        let Bi = Et(Dt(Ar, fi, hr, Wr));
        const $r = Bi.hash, [oi, zr] = d.taprootTweakPubkey(fi, $r), ti = st(Bi).map((Lr) => ({
          ...Lr,
          controlBlock: y.TaprootControlBlock.encode({
            version: (Lr.version || o.TAP_LEAF_VERSION) + zr,
            internalKey: fi,
            merklePath: Lr.path
          })
        }));
        return {
          type: "tr",
          script: o.OutScript.encode({ type: "tr", pubkey: oi }),
          address: Fr(cr).encode({ type: "tr", pubkey: oi }),
          // For tests
          tweakedPubkey: oi,
          // PSBT stuff
          tapInternalKey: fi,
          leaves: ti,
          tapLeafScript: ti.map((Lr) => [
            y.TaprootControlBlock.decode(Lr.controlBlock),
            d.concatBytes(Lr.script, new Uint8Array([Lr.version || o.TAP_LEAF_VERSION]))
          ]),
          tapMerkleRoot: $r
        };
      } else {
        const Bi = d.taprootTweakPubkey(fi, c.EMPTY)[0];
        return {
          type: "tr",
          script: o.OutScript.encode({ type: "tr", pubkey: Bi }),
          address: Fr(cr).encode({ type: "tr", pubkey: Bi }),
          // For tests
          tweakedPubkey: Bi,
          // PSBT stuff
          tapInternalKey: fi
        };
      }
    }
    function ir(br, Ar) {
      const cr = [];
      if (!Array.isArray(Ar))
        throw new Error("combinations: lst arg should be array");
      const hr = Ar.length;
      if (br > hr)
        throw new Error("combinations: m > lst.length, no combinations possible");
      const Wr = Array.from({ length: br }, (Bi, $r) => $r), fi = Wr.length - 1;
      e: for (; ; ) {
        cr.push(Wr.map(($r) => Ar[$r])), Wr[fi] += 1;
        let Bi = fi;
        for (; Bi >= 0 && Wr[Bi] > hr - br + Bi; Bi--) {
          if (Wr[Bi] = 0, Bi === 0)
            break e;
          Wr[Bi - 1] += 1;
        }
        for (Bi += 1; Bi < Wr.length; Bi++)
          Wr[Bi] = Wr[Bi - 1] + 1;
      }
      return cr;
    }
    const sr = (br, Ar, cr = !1) => (cr || Pe(Ar), ir(br, Ar).map((hr) => ({
      type: "tr_ns",
      script: o.OutScript.encode({ type: "tr_ns", pubkeys: hr })
    })));
    o.p2tr_ns = sr;
    const yr = (br) => (0, o.p2tr_ns)(1, [br], void 0)[0];
    o.p2tr_pk = yr;
    function wr(br, Ar, cr = !1) {
      return cr || Pe(Ar), {
        type: "tr_ms",
        script: o.OutScript.encode({ type: "tr_ms", pubkeys: Ar, m: br })
      };
    }
    function qr(br, Ar, cr = E.NETWORK) {
      if (br === "tr")
        return xt(d.pubSchnorr(Ar), void 0, cr).address;
      const hr = d.pubECDSA(Ar);
      if (br === "pkh")
        return (0, o.p2pkh)(hr, cr).address;
      if (br === "wpkh")
        return (0, o.p2wpkh)(hr, cr).address;
      throw new Error(`getAddress: unknown type=${br}`);
    }
    const Mr = (br) => Array.from(br).sort(d.compareBytes);
    o._sortPubkeys = Mr;
    function Dr(br, Ar, cr = !1, hr = !1, Wr = E.NETWORK) {
      const fi = (0, o.p2ms)(br, cr ? (0, o._sortPubkeys)(Ar) : Ar);
      return hr ? (0, o.p2wsh)(fi, Wr) : (0, o.p2sh)(fi, Wr);
    }
    function Qr(br, Ar, cr = !1, hr = E.NETWORK) {
      return Dr(br, Ar, !0, cr, hr);
    }
    const Xr = (0, g.createBase58check)(d.sha256);
    function Vr(br, Ar) {
      if (Ar.length < 2 || Ar.length > 40)
        throw new Error("Witness: invalid length");
      if (br > 16)
        throw new Error("Witness: invalid version");
      if (br === 0 && !(Ar.length === 20 || Ar.length === 32))
        throw new Error("Witness: invalid length for version");
    }
    function Ur(br, Ar, cr = E.NETWORK) {
      Vr(br, Ar);
      const hr = br === 0 ? g.bech32 : g.bech32m;
      return hr.encode(cr.bech32, [br].concat(hr.toWords(Ar)));
    }
    function Sr(br, Ar) {
      return Xr.encode(d.concatBytes(Uint8Array.from(Ar), br));
    }
    function Gr(br = E.NETWORK) {
      return {
        encode(Ar) {
          const cr = d.concatBytes(Ar, new Uint8Array([1]));
          return Sr(cr.subarray(0, 33), [br.wif]);
        },
        decode(Ar) {
          let cr = Xr.decode(Ar);
          if (cr[0] !== br.wif)
            throw new Error("Wrong WIF prefix");
          if (cr = cr.subarray(1), cr.length !== 33)
            throw new Error("Wrong WIF length");
          if (cr[32] !== 1)
            throw new Error("Wrong WIF postfix");
          return cr.subarray(0, -1);
        }
      };
    }
    function Fr(br = E.NETWORK) {
      return {
        encode(Ar) {
          const { type: cr } = Ar;
          if (cr === "wpkh")
            return Ur(0, Ar.hash, br);
          if (cr === "wsh")
            return Ur(0, Ar.hash, br);
          if (cr === "tr")
            return Ur(1, Ar.pubkey, br);
          if (cr === "pkh")
            return Sr(Ar.hash, [br.pubKeyHash]);
          if (cr === "sh")
            return Sr(Ar.hash, [br.scriptHash]);
          throw new Error(`Unknown address type=${cr}`);
        },
        decode(Ar) {
          if (Ar.length < 14 || Ar.length > 74)
            throw new Error("Invalid address length");
          if (br.bech32 && Ar.toLowerCase().startsWith(`${br.bech32}1`)) {
            let hr;
            try {
              if (hr = g.bech32.decode(Ar), hr.words[0] !== 0)
                throw new Error(`bech32: wrong version=${hr.words[0]}`);
            } catch {
              if (hr = g.bech32m.decode(Ar), hr.words[0] === 0)
                throw new Error(`bech32m: wrong version=${hr.words[0]}`);
            }
            if (hr.prefix !== br.bech32)
              throw new Error(`wrong bech32 prefix=${hr.prefix}`);
            const [Wr, ...fi] = hr.words, Bi = g.bech32.fromWords(fi);
            if (Vr(Wr, Bi), Wr === 0 && Bi.length === 32)
              return { type: "wsh", hash: Bi };
            if (Wr === 0 && Bi.length === 20)
              return { type: "wpkh", hash: Bi };
            if (Wr === 1 && Bi.length === 32)
              return { type: "tr", pubkey: Bi };
            throw new Error("Unknown witness program");
          }
          const cr = Xr.decode(Ar);
          if (cr.length !== 21)
            throw new Error("Invalid base58 address");
          if (cr[0] === br.pubKeyHash)
            return { type: "pkh", hash: cr.slice(1) };
          if (cr[0] === br.scriptHash)
            return {
              type: "sh",
              hash: cr.slice(1)
            };
          throw new Error(`Invalid address prefix=${cr[0]}`);
        }
      };
    }
  }(payment)), payment;
}
var transaction = {}, hasRequiredTransaction;
function requireTransaction() {
  return hasRequiredTransaction || (hasRequiredTransaction = 1, function(o) {
    Object.defineProperty(o, "__esModule", { value: !0 }), o.Transaction = o.SigHash = o.SignatureHash = o.def = o.Decimal = o.DEFAULT_SEQUENCE = o.DEFAULT_LOCKTIME = o.DEFAULT_VERSION = o.PRECISION = o.toVsize = void 0, o.cloneDeep = M, o.inputBeforeSign = ge, o.getPrevOut = De, o.normalizeInput = ve, o.getInputType = Fe, o.PSBTCombine = Be, o.bip32Path = xe;
    const g = /* @__PURE__ */ requireLib$2(), c = /* @__PURE__ */ requireLib(), y = /* @__PURE__ */ requirePayment(), t = /* @__PURE__ */ requirePsbt$1(), d = /* @__PURE__ */ requireScript(), E = /* @__PURE__ */ requireUtils$1(), B = /* @__PURE__ */ requireUtils$1(), D = new Uint8Array(32), x = {
      amount: 0xffffffffffffffffn,
      script: c.EMPTY
    }, v = (Ne) => Math.ceil(Ne / 4);
    o.toVsize = v, o.PRECISION = 8, o.DEFAULT_VERSION = 2, o.DEFAULT_LOCKTIME = 0, o.DEFAULT_SEQUENCE = 4294967295, o.Decimal = c.coders.decimal(o.PRECISION);
    const F = (Ne, Et) => Ne === void 0 ? Et : Ne;
    o.def = F;
    function M(Ne) {
      if (Array.isArray(Ne))
        return Ne.map((Et) => M(Et));
      if ((0, B.isBytes)(Ne))
        return Uint8Array.from(Ne);
      if (["number", "bigint", "boolean", "string", "undefined"].includes(typeof Ne))
        return Ne;
      if (Ne === null)
        return Ne;
      if (typeof Ne == "object")
        return Object.fromEntries(Object.entries(Ne).map(([Et, st]) => [Et, M(st)]));
      throw new Error(`cloneDeep: unknown type=${Ne} (${typeof Ne})`);
    }
    var U;
    (function(Ne) {
      Ne[Ne.DEFAULT = 0] = "DEFAULT", Ne[Ne.ALL = 1] = "ALL", Ne[Ne.NONE = 2] = "NONE", Ne[Ne.SINGLE = 3] = "SINGLE", Ne[Ne.ANYONECANPAY = 128] = "ANYONECANPAY";
    })(U || (o.SignatureHash = U = {}));
    var L;
    (function(Ne) {
      Ne[Ne.DEFAULT = 0] = "DEFAULT", Ne[Ne.ALL = 1] = "ALL", Ne[Ne.NONE = 2] = "NONE", Ne[Ne.SINGLE = 3] = "SINGLE", Ne[Ne.DEFAULT_ANYONECANPAY = 128] = "DEFAULT_ANYONECANPAY", Ne[Ne.ALL_ANYONECANPAY = 129] = "ALL_ANYONECANPAY", Ne[Ne.NONE_ANYONECANPAY = 130] = "NONE_ANYONECANPAY", Ne[Ne.SINGLE_ANYONECANPAY = 131] = "SINGLE_ANYONECANPAY";
    })(L || (o.SigHash = L = {}));
    function H(Ne, Et, st, Dt = c.EMPTY) {
      return (0, B.equalBytes)(st, Et) && (Ne = E.taprootTweakPrivKey(Ne, Dt), Et = E.pubSchnorr(Ne)), { privKey: Ne, pubKey: Et };
    }
    function fe(Ne) {
      if (Ne.script === void 0 || Ne.amount === void 0)
        throw new Error("Transaction/output: script and amount required");
      return { script: Ne.script, amount: Ne.amount };
    }
    function ge(Ne) {
      if (Ne.txid === void 0 || Ne.index === void 0)
        throw new Error("Transaction/input: txid and index required");
      return {
        txid: Ne.txid,
        index: Ne.index,
        sequence: (0, o.def)(Ne.sequence, o.DEFAULT_SEQUENCE),
        finalScriptSig: (0, o.def)(Ne.finalScriptSig, c.EMPTY)
      };
    }
    function Ie(Ne) {
      for (const Et in Ne) {
        const st = Et;
        t.PSBTInputFinalKeys.includes(st) || delete Ne[st];
      }
    }
    const Ee = c.struct({ txid: c.bytes(32, !0), index: c.U32LE });
    function Se(Ne) {
      if (typeof Ne != "number" || typeof L[Ne] != "string")
        throw new Error(`Invalid SigHash=${Ne}`);
      return Ne;
    }
    function ze(Ne) {
      const Et = Ne & 31;
      return {
        isAny: !!(Ne & U.ANYONECANPAY),
        isNone: Et === U.NONE,
        isSingle: Et === U.SINGLE
      };
    }
    function He(Ne) {
      if (Ne !== void 0 && {}.toString.call(Ne) !== "[object Object]")
        throw new Error(`Wrong object type for transaction options: ${Ne}`);
      const Et = {
        ...Ne,
        // Defaults
        version: (0, o.def)(Ne.version, o.DEFAULT_VERSION),
        lockTime: (0, o.def)(Ne.lockTime, 0),
        PSBTVersion: (0, o.def)(Ne.PSBTVersion, 0)
      };
      if (typeof Et.allowUnknowInput < "u" && (Ne.allowUnknownInputs = Et.allowUnknowInput), typeof Et.allowUnknowOutput < "u" && (Ne.allowUnknownOutputs = Et.allowUnknowOutput), typeof Et.lockTime != "number")
        throw new Error("Transaction lock time should be number");
      if (c.U32LE.encode(Et.lockTime), Et.PSBTVersion !== 0 && Et.PSBTVersion !== 2)
        throw new Error(`Unknown PSBT version ${Et.PSBTVersion}`);
      for (const st of [
        "allowUnknownVersion",
        "allowUnknownOutputs",
        "allowUnknownInputs",
        "disableScriptCheck",
        "bip174jsCompat",
        "allowLegacyWitnessUtxo",
        "lowR"
      ]) {
        const Dt = Et[st];
        if (Dt !== void 0 && typeof Dt != "boolean")
          throw new Error(`Transation options wrong type: ${st}=${Dt} (${typeof Dt})`);
      }
      if (Et.allowUnknownVersion ? typeof Et.version == "number" : ![-1, 0, 1, 2, 3].includes(Et.version))
        throw new Error(`Unknown version: ${Et.version}`);
      if (Et.customScripts !== void 0) {
        const st = Et.customScripts;
        if (!Array.isArray(st))
          throw new Error(`wrong custom scripts type (expected array): customScripts=${st} (${typeof st})`);
        for (const Dt of st) {
          if (typeof Dt.encode != "function" || typeof Dt.decode != "function")
            throw new Error(`wrong script=${Dt} (${typeof Dt})`);
          if (Dt.finalizeTaproot !== void 0 && typeof Dt.finalizeTaproot != "function")
            throw new Error(`wrong script=${Dt} (${typeof Dt})`);
        }
      }
      return Object.freeze(Et);
    }
    function Pe(Ne) {
      if (Ne.nonWitnessUtxo && Ne.index !== void 0) {
        const Et = Ne.nonWitnessUtxo.outputs.length - 1;
        if (Ne.index > Et)
          throw new Error(`validateInput: index(${Ne.index}) not in nonWitnessUtxo`);
        const st = Ne.nonWitnessUtxo.outputs[Ne.index];
        if (Ne.witnessUtxo && (!(0, B.equalBytes)(Ne.witnessUtxo.script, st.script) || Ne.witnessUtxo.amount !== st.amount))
          throw new Error("validateInput: witnessUtxo different from nonWitnessUtxo");
        if (Ne.txid) {
          if (Ne.nonWitnessUtxo.outputs.length - 1 < Ne.index)
            throw new Error("nonWitnessUtxo: incorect output index");
          const er = be.fromRaw(d.RawTx.encode(Ne.nonWitnessUtxo), {
            allowUnknownOutputs: !0,
            disableScriptCheck: !0,
            allowUnknownInputs: !0
          }), xt = g.hex.encode(Ne.txid);
          if (er.isFinal && er.id !== xt)
            throw new Error(`nonWitnessUtxo: wrong txid, exp=${xt} got=${er.id}`);
        }
      }
      return Ne;
    }
    function De(Ne) {
      if (Ne.nonWitnessUtxo) {
        if (Ne.index === void 0)
          throw new Error("Unknown input index");
        return Ne.nonWitnessUtxo.outputs[Ne.index];
      } else {
        if (Ne.witnessUtxo)
          return Ne.witnessUtxo;
        throw new Error("Cannot find previous output info");
      }
    }
    function ve(Ne, Et, st, Dt = !1, er = !1) {
      let { nonWitnessUtxo: xt, txid: ir } = Ne;
      typeof xt == "string" && (xt = g.hex.decode(xt)), (0, B.isBytes)(xt) && (xt = d.RawTx.decode(xt)), !("nonWitnessUtxo" in Ne) && xt === void 0 && (xt = Et == null ? void 0 : Et.nonWitnessUtxo), typeof ir == "string" && (ir = g.hex.decode(ir)), ir === void 0 && (ir = Et == null ? void 0 : Et.txid);
      let sr = { ...Et, ...Ne, nonWitnessUtxo: xt, txid: ir };
      !("nonWitnessUtxo" in Ne) && sr.nonWitnessUtxo === void 0 && delete sr.nonWitnessUtxo, sr.sequence === void 0 && (sr.sequence = o.DEFAULT_SEQUENCE), sr.tapMerkleRoot === null && delete sr.tapMerkleRoot, sr = t.mergeKeyMap(t.PSBTInput, sr, Et, st, er), t.PSBTInputCoder.encode(sr);
      let yr;
      return sr.nonWitnessUtxo && sr.index !== void 0 ? yr = sr.nonWitnessUtxo.outputs[sr.index] : sr.witnessUtxo && (yr = sr.witnessUtxo), yr && !Dt && (0, y.checkScript)(yr && yr.script, sr.redeemScript, sr.witnessScript), sr;
    }
    function Fe(Ne, Et = !1) {
      let st = "legacy", Dt = U.ALL;
      const er = De(Ne), xt = y.OutScript.decode(er.script);
      let ir = xt.type, sr = xt;
      const yr = [xt];
      if (xt.type === "tr")
        return Dt = U.DEFAULT, {
          txType: "taproot",
          type: "tr",
          last: xt,
          lastScript: er.script,
          defaultSighash: Dt,
          sighash: Ne.sighashType || Dt
        };
      {
        if ((xt.type === "wpkh" || xt.type === "wsh") && (st = "segwit"), xt.type === "sh") {
          if (!Ne.redeemScript)
            throw new Error("inputType: sh without redeemScript");
          let Dr = y.OutScript.decode(Ne.redeemScript);
          (Dr.type === "wpkh" || Dr.type === "wsh") && (st = "segwit"), yr.push(Dr), sr = Dr, ir += `-${Dr.type}`;
        }
        if (sr.type === "wsh") {
          if (!Ne.witnessScript)
            throw new Error("inputType: wsh without witnessScript");
          let Dr = y.OutScript.decode(Ne.witnessScript);
          Dr.type === "wsh" && (st = "segwit"), yr.push(Dr), sr = Dr, ir += `-${Dr.type}`;
        }
        const wr = yr[yr.length - 1];
        if (wr.type === "sh" || wr.type === "wsh")
          throw new Error("inputType: sh/wsh cannot be terminal type");
        const qr = y.OutScript.encode(wr), Mr = {
          type: ir,
          txType: st,
          last: wr,
          lastScript: qr,
          defaultSighash: Dt,
          sighash: Ne.sighashType || Dt
        };
        if (st === "legacy" && !Et && !Ne.nonWitnessUtxo)
          throw new Error("Transaction/sign: legacy input without nonWitnessUtxo, can result in attack that forces paying higher fees. Pass allowLegacyWitnessUtxo=true, if you sure");
        return Mr;
      }
    }
    class be {
      constructor(Et = {}) {
        this.global = {}, this.inputs = [], this.outputs = [];
        const st = this.opts = He(Et);
        st.lockTime !== o.DEFAULT_LOCKTIME && (this.global.fallbackLocktime = st.lockTime), this.global.txVersion = st.version;
      }
      // Import
      static fromRaw(Et, st = {}) {
        const Dt = d.RawTx.decode(Et), er = new be({ ...st, version: Dt.version, lockTime: Dt.lockTime });
        for (const xt of Dt.outputs)
          er.addOutput(xt);
        if (er.outputs = Dt.outputs, er.inputs = Dt.inputs, Dt.witnesses)
          for (let xt = 0; xt < Dt.witnesses.length; xt++)
            er.inputs[xt].finalScriptWitness = Dt.witnesses[xt];
        return er;
      }
      // PSBT
      static fromPSBT(Et, st = {}) {
        let Dt;
        try {
          Dt = t.RawPSBTV0.decode(Et);
        } catch (Mr) {
          try {
            Dt = t.RawPSBTV2.decode(Et);
          } catch {
            throw Mr;
          }
        }
        const er = Dt.global.version || 0;
        if (er !== 0 && er !== 2)
          throw new Error(`Wrong PSBT version=${er}`);
        const xt = Dt.global.unsignedTx, ir = er === 0 ? xt == null ? void 0 : xt.version : Dt.global.txVersion, sr = er === 0 ? xt == null ? void 0 : xt.lockTime : Dt.global.fallbackLocktime, yr = new be({ ...st, version: ir, lockTime: sr, PSBTVersion: er }), wr = er === 0 ? xt == null ? void 0 : xt.inputs.length : Dt.global.inputCount;
        yr.inputs = Dt.inputs.slice(0, wr).map((Mr, Dr) => {
          var Qr;
          return Pe({
            finalScriptSig: c.EMPTY,
            ...(Qr = Dt.global.unsignedTx) == null ? void 0 : Qr.inputs[Dr],
            ...Mr
          });
        });
        const qr = er === 0 ? xt == null ? void 0 : xt.outputs.length : Dt.global.outputCount;
        return yr.outputs = Dt.outputs.slice(0, qr).map((Mr, Dr) => {
          var Qr;
          return {
            ...Mr,
            ...(Qr = Dt.global.unsignedTx) == null ? void 0 : Qr.outputs[Dr]
          };
        }), yr.global = { ...Dt.global, txVersion: ir }, sr !== o.DEFAULT_LOCKTIME && (yr.global.fallbackLocktime = sr), yr;
      }
      toPSBT(Et = this.opts.PSBTVersion) {
        if (Et !== 0 && Et !== 2)
          throw new Error(`Wrong PSBT version=${Et}`);
        const st = this.inputs.map((xt) => Pe(t.cleanPSBTFields(Et, t.PSBTInput, xt)));
        for (const xt of st)
          xt.partialSig && !xt.partialSig.length && delete xt.partialSig, xt.finalScriptSig && !xt.finalScriptSig.length && delete xt.finalScriptSig, xt.finalScriptWitness && !xt.finalScriptWitness.length && delete xt.finalScriptWitness;
        const Dt = this.outputs.map((xt) => t.cleanPSBTFields(Et, t.PSBTOutput, xt)), er = { ...this.global };
        return Et === 0 ? (er.unsignedTx = d.RawOldTx.decode(d.RawOldTx.encode({
          version: this.version,
          lockTime: this.lockTime,
          inputs: this.inputs.map(ge).map((xt) => ({
            ...xt,
            finalScriptSig: c.EMPTY
          })),
          outputs: this.outputs.map(fe)
        })), delete er.fallbackLocktime, delete er.txVersion) : (er.version = Et, er.txVersion = this.version, er.inputCount = this.inputs.length, er.outputCount = this.outputs.length, er.fallbackLocktime && er.fallbackLocktime === o.DEFAULT_LOCKTIME && delete er.fallbackLocktime), this.opts.bip174jsCompat && (st.length || st.push({}), Dt.length || Dt.push({})), (Et === 0 ? t.RawPSBTV0 : t.RawPSBTV2).encode({
          global: er,
          inputs: st,
          outputs: Dt
        });
      }
      // BIP370 lockTime (https://github.com/bitcoin/bips/blob/master/bip-0370.mediawiki#determining-lock-time)
      get lockTime() {
        let Et = o.DEFAULT_LOCKTIME, st = 0, Dt = o.DEFAULT_LOCKTIME, er = 0;
        for (const xt of this.inputs)
          xt.requiredHeightLocktime && (Et = Math.max(Et, xt.requiredHeightLocktime), st++), xt.requiredTimeLocktime && (Dt = Math.max(Dt, xt.requiredTimeLocktime), er++);
        return st && st >= er ? Et : Dt !== o.DEFAULT_LOCKTIME ? Dt : this.global.fallbackLocktime || o.DEFAULT_LOCKTIME;
      }
      get version() {
        if (this.global.txVersion === void 0)
          throw new Error("No global.txVersion");
        return this.global.txVersion;
      }
      inputStatus(Et) {
        this.checkInputIdx(Et);
        const st = this.inputs[Et];
        return st.finalScriptSig && st.finalScriptSig.length || st.finalScriptWitness && st.finalScriptWitness.length ? "finalized" : st.tapKeySig || st.tapScriptSig && st.tapScriptSig.length || st.partialSig && st.partialSig.length ? "signed" : "unsigned";
      }
      // Cannot replace unpackSighash, tests rely on very generic implemenetation with signing inputs outside of range
      // We will lose some vectors -> smaller test coverage of preimages (very important!)
      inputSighash(Et) {
        this.checkInputIdx(Et);
        const st = this.inputs[Et].sighashType, Dt = st === void 0 ? U.DEFAULT : st, er = Dt === U.DEFAULT ? U.ALL : Dt & 3;
        return { sigInputs: Dt & U.ANYONECANPAY, sigOutputs: er };
      }
      // Very nice for debug purposes, but slow. If there is too much inputs/outputs to add, will be quadratic.
      // Some cache will be nice, but there chance to have bugs with cache invalidation
      signStatus() {
        let Et = !0, st = !0, Dt = [], er = [];
        for (let xt = 0; xt < this.inputs.length; xt++) {
          if (this.inputStatus(xt) === "unsigned")
            continue;
          const { sigInputs: sr, sigOutputs: yr } = this.inputSighash(xt);
          if (sr === U.ANYONECANPAY ? Dt.push(xt) : Et = !1, yr === U.ALL)
            st = !1;
          else if (yr === U.SINGLE)
            er.push(xt);
          else if (yr !== U.NONE) throw new Error(`Wrong signature hash output type: ${yr}`);
        }
        return { addInput: Et, addOutput: st, inputs: Dt, outputs: er };
      }
      get isFinal() {
        for (let Et = 0; Et < this.inputs.length; Et++)
          if (this.inputStatus(Et) !== "finalized")
            return !1;
        return !0;
      }
      // Info utils
      get hasWitnesses() {
        let Et = !1;
        for (const st of this.inputs)
          st.finalScriptWitness && st.finalScriptWitness.length && (Et = !0);
        return Et;
      }
      // https://en.bitcoin.it/wiki/Weight_units
      get weight() {
        if (!this.isFinal)
          throw new Error("Transaction is not finalized");
        let Et = 32;
        const st = this.outputs.map(fe);
        Et += 4 * d.CompactSizeLen.encode(this.outputs.length).length;
        for (const Dt of st)
          Et += 32 + 4 * d.VarBytes.encode(Dt.script).length;
        this.hasWitnesses && (Et += 2), Et += 4 * d.CompactSizeLen.encode(this.inputs.length).length;
        for (const Dt of this.inputs)
          Et += 160 + 4 * d.VarBytes.encode(Dt.finalScriptSig || c.EMPTY).length, this.hasWitnesses && Dt.finalScriptWitness && (Et += d.RawWitness.encode(Dt.finalScriptWitness).length);
        return Et;
      }
      get vsize() {
        return (0, o.toVsize)(this.weight);
      }
      toBytes(Et = !1, st = !1) {
        return d.RawTx.encode({
          version: this.version,
          lockTime: this.lockTime,
          inputs: this.inputs.map(ge).map((Dt) => ({
            ...Dt,
            finalScriptSig: Et && Dt.finalScriptSig || c.EMPTY
          })),
          outputs: this.outputs.map(fe),
          witnesses: this.inputs.map((Dt) => Dt.finalScriptWitness || []),
          segwitFlag: st && this.hasWitnesses
        });
      }
      get unsignedTx() {
        return this.toBytes(!1, !1);
      }
      get hex() {
        return g.hex.encode(this.toBytes(!0, this.hasWitnesses));
      }
      get hash() {
        if (!this.isFinal)
          throw new Error("Transaction is not finalized");
        return g.hex.encode(E.sha256x2(this.toBytes(!0)));
      }
      get id() {
        if (!this.isFinal)
          throw new Error("Transaction is not finalized");
        return g.hex.encode(E.sha256x2(this.toBytes(!0)).reverse());
      }
      // Input stuff
      checkInputIdx(Et) {
        if (!Number.isSafeInteger(Et) || 0 > Et || Et >= this.inputs.length)
          throw new Error(`Wrong input index=${Et}`);
      }
      getInput(Et) {
        return this.checkInputIdx(Et), M(this.inputs[Et]);
      }
      get inputsLength() {
        return this.inputs.length;
      }
      // Modification
      addInput(Et, st = !1) {
        if (!st && !this.signStatus().addInput)
          throw new Error("Tx has signed inputs, cannot add new one");
        return this.inputs.push(ve(Et, void 0, void 0, this.opts.disableScriptCheck)), this.inputs.length - 1;
      }
      updateInput(Et, st, Dt = !1) {
        this.checkInputIdx(Et);
        let er;
        if (!Dt) {
          const xt = this.signStatus();
          (!xt.addInput || xt.inputs.includes(Et)) && (er = t.PSBTInputUnsignedKeys);
        }
        this.inputs[Et] = ve(st, this.inputs[Et], er, this.opts.disableScriptCheck, this.opts.allowUnknown);
      }
      // Output stuff
      checkOutputIdx(Et) {
        if (!Number.isSafeInteger(Et) || 0 > Et || Et >= this.outputs.length)
          throw new Error(`Wrong output index=${Et}`);
      }
      getOutput(Et) {
        return this.checkOutputIdx(Et), M(this.outputs[Et]);
      }
      getOutputAddress(Et, st = B.NETWORK) {
        const Dt = this.getOutput(Et);
        if (Dt.script)
          return (0, y.Address)(st).encode(y.OutScript.decode(Dt.script));
      }
      get outputsLength() {
        return this.outputs.length;
      }
      normalizeOutput(Et, st, Dt) {
        let { amount: er, script: xt } = Et;
        if (er === void 0 && (er = st == null ? void 0 : st.amount), typeof er != "bigint")
          throw new Error(`Wrong amount type, should be of type bigint in sats, but got ${er} of type ${typeof er}`);
        typeof xt == "string" && (xt = g.hex.decode(xt)), xt === void 0 && (xt = st == null ? void 0 : st.script);
        let ir = { ...st, ...Et, amount: er, script: xt };
        if (ir.amount === void 0 && delete ir.amount, ir = t.mergeKeyMap(t.PSBTOutput, ir, st, Dt, this.opts.allowUnknown), t.PSBTOutputCoder.encode(ir), ir.script && !this.opts.allowUnknownOutputs && y.OutScript.decode(ir.script).type === "unknown")
          throw new Error("Transaction/output: unknown output script type, there is a chance that input is unspendable. Pass allowUnknownOutputs=true, if you sure");
        return this.opts.disableScriptCheck || (0, y.checkScript)(ir.script, ir.redeemScript, ir.witnessScript), ir;
      }
      addOutput(Et, st = !1) {
        if (!st && !this.signStatus().addOutput)
          throw new Error("Tx has signed outputs, cannot add new one");
        return this.outputs.push(this.normalizeOutput(Et)), this.outputs.length - 1;
      }
      updateOutput(Et, st, Dt = !1) {
        this.checkOutputIdx(Et);
        let er;
        if (!Dt) {
          const xt = this.signStatus();
          (!xt.addOutput || xt.outputs.includes(Et)) && (er = t.PSBTOutputUnsignedKeys);
        }
        this.outputs[Et] = this.normalizeOutput(st, this.outputs[Et], er);
      }
      addOutputAddress(Et, st, Dt = B.NETWORK) {
        return this.addOutput({ script: y.OutScript.encode((0, y.Address)(Dt).decode(Et)), amount: st });
      }
      // Utils
      get fee() {
        let Et = 0n;
        for (const Dt of this.inputs) {
          const er = De(Dt);
          if (!er)
            throw new Error("Empty input amount");
          Et += er.amount;
        }
        const st = this.outputs.map(fe);
        for (const Dt of st)
          Et -= Dt.amount;
        return Et;
      }
      // Signing
      // Based on https://github.com/bitcoin/bitcoin/blob/5871b5b5ab57a0caf9b7514eb162c491c83281d5/test/functional/test_framework/script.py#L624
      // There is optimization opportunity to re-use hashes for multiple inputs for witness v0/v1,
      // but we are trying to be less complicated for audit purpose for now.
      preimageLegacy(Et, st, Dt) {
        const { isAny: er, isNone: xt, isSingle: ir } = ze(Dt);
        if (Et < 0 || !Number.isSafeInteger(Et))
          throw new Error(`Invalid input idx=${Et}`);
        if (ir && Et >= this.outputs.length || Et >= this.inputs.length)
          return c.U256BE.encode(1n);
        st = d.Script.encode(d.Script.decode(st).filter((qr) => qr !== "CODESEPARATOR"));
        let sr = this.inputs.map(ge).map((qr, Mr) => ({
          ...qr,
          finalScriptSig: Mr === Et ? st : c.EMPTY
        }));
        er ? sr = [sr[Et]] : (xt || ir) && (sr = sr.map((qr, Mr) => ({
          ...qr,
          sequence: Mr === Et ? qr.sequence : 0
        })));
        let yr = this.outputs.map(fe);
        xt ? yr = [] : ir && (yr = yr.slice(0, Et).fill(x).concat([yr[Et]]));
        const wr = d.RawTx.encode({
          lockTime: this.lockTime,
          version: this.version,
          segwitFlag: !1,
          inputs: sr,
          outputs: yr
        });
        return E.sha256x2(wr, c.I32LE.encode(Dt));
      }
      preimageWitnessV0(Et, st, Dt, er) {
        const { isAny: xt, isNone: ir, isSingle: sr } = ze(Dt);
        let yr = D, wr = D, qr = D;
        const Mr = this.inputs.map(ge), Dr = this.outputs.map(fe);
        xt || (yr = E.sha256x2(...Mr.map(Ee.encode))), !xt && !sr && !ir && (wr = E.sha256x2(...Mr.map((Xr) => c.U32LE.encode(Xr.sequence)))), !sr && !ir ? qr = E.sha256x2(...Dr.map(d.RawOutput.encode)) : sr && Et < Dr.length && (qr = E.sha256x2(d.RawOutput.encode(Dr[Et])));
        const Qr = Mr[Et];
        return E.sha256x2(c.I32LE.encode(this.version), yr, wr, c.bytes(32, !0).encode(Qr.txid), c.U32LE.encode(Qr.index), d.VarBytes.encode(st), c.U64LE.encode(er), c.U32LE.encode(Qr.sequence), qr, c.U32LE.encode(this.lockTime), c.U32LE.encode(Dt));
      }
      preimageWitnessV1(Et, st, Dt, er, xt = -1, ir, sr = 192, yr) {
        if (!Array.isArray(er) || this.inputs.length !== er.length)
          throw new Error(`Invalid amounts array=${er}`);
        if (!Array.isArray(st) || this.inputs.length !== st.length)
          throw new Error(`Invalid prevOutScript array=${st}`);
        const wr = [
          c.U8.encode(0),
          c.U8.encode(Dt),
          // U8 sigHash
          c.I32LE.encode(this.version),
          c.U32LE.encode(this.lockTime)
        ], qr = Dt === U.DEFAULT ? U.ALL : Dt & 3, Mr = Dt & U.ANYONECANPAY, Dr = this.inputs.map(ge), Qr = this.outputs.map(fe);
        Mr !== U.ANYONECANPAY && wr.push(...[
          Dr.map(Ee.encode),
          er.map(c.U64LE.encode),
          st.map(d.VarBytes.encode),
          Dr.map((Vr) => c.U32LE.encode(Vr.sequence))
        ].map((Vr) => E.sha256((0, B.concatBytes)(...Vr)))), qr === U.ALL && wr.push(E.sha256((0, B.concatBytes)(...Qr.map(d.RawOutput.encode))));
        const Xr = (yr ? 1 : 0) | (ir ? 2 : 0);
        if (wr.push(new Uint8Array([Xr])), Mr === U.ANYONECANPAY) {
          const Vr = Dr[Et];
          wr.push(Ee.encode(Vr), c.U64LE.encode(er[Et]), d.VarBytes.encode(st[Et]), c.U32LE.encode(Vr.sequence));
        } else
          wr.push(c.U32LE.encode(Et));
        return Xr & 1 && wr.push(E.sha256(d.VarBytes.encode(yr || c.EMPTY))), qr === U.SINGLE && wr.push(Et < Qr.length ? E.sha256(d.RawOutput.encode(Qr[Et])) : D), ir && wr.push((0, y.tapLeafHash)(ir, sr), c.U8.encode(0), c.I32LE.encode(xt)), E.tagSchnorr("TapSighash", ...wr);
      }
      // Signer can be privateKey OR instance of bip32 HD stuff
      signIdx(Et, st, Dt, er) {
        this.checkInputIdx(st);
        const xt = this.inputs[st], ir = Fe(xt, this.opts.allowLegacyWitnessUtxo);
        if (!(0, B.isBytes)(Et)) {
          if (!xt.bip32Derivation || !xt.bip32Derivation.length)
            throw new Error("bip32Derivation: empty");
          const qr = xt.bip32Derivation.filter((Dr) => Dr[1].fingerprint == Et.fingerprint).map(([Dr, { path: Qr }]) => {
            let Xr = Et;
            for (const Vr of Qr)
              Xr = Xr.deriveChild(Vr);
            if (!(0, B.equalBytes)(Xr.publicKey, Dr))
              throw new Error("bip32Derivation: wrong pubKey");
            if (!Xr.privateKey)
              throw new Error("bip32Derivation: no privateKey");
            return Xr;
          });
          if (!qr.length)
            throw new Error(`bip32Derivation: no items with fingerprint=${Et.fingerprint}`);
          let Mr = !1;
          for (const Dr of qr)
            this.signIdx(Dr.privateKey, st) && (Mr = !0);
          return Mr;
        }
        Dt ? Dt.forEach(Se) : Dt = [ir.defaultSighash];
        const sr = ir.sighash;
        if (!Dt.includes(sr))
          throw new Error(`Input with not allowed sigHash=${sr}. Allowed: ${Dt.join(", ")}`);
        const { sigOutputs: yr } = this.inputSighash(st);
        if (yr === U.SINGLE && st >= this.outputs.length)
          throw new Error(`Input with sighash SINGLE, but there is no output with corresponding index=${st}`);
        const wr = De(xt);
        if (ir.txType === "taproot") {
          const qr = this.inputs.map(De), Mr = qr.map((Ur) => Ur.script), Dr = qr.map((Ur) => Ur.amount);
          let Qr = !1, Xr = E.pubSchnorr(Et), Vr = xt.tapMerkleRoot || c.EMPTY;
          if (xt.tapInternalKey) {
            const { pubKey: Ur, privKey: Sr } = H(Et, Xr, xt.tapInternalKey, Vr), [Gr, Fr] = E.taprootTweakPubkey(xt.tapInternalKey, Vr);
            if ((0, B.equalBytes)(Gr, Ur)) {
              const br = this.preimageWitnessV1(st, Mr, sr, Dr), Ar = (0, B.concatBytes)(E.signSchnorr(br, Sr, er), sr !== U.DEFAULT ? new Uint8Array([sr]) : c.EMPTY);
              this.updateInput(st, { tapKeySig: Ar }, !0), Qr = !0;
            }
          }
          if (xt.tapLeafScript) {
            xt.tapScriptSig = xt.tapScriptSig || [];
            for (const [Ur, Sr] of xt.tapLeafScript) {
              const Gr = Sr.subarray(0, -1), Fr = d.Script.decode(Gr), br = Sr[Sr.length - 1], Ar = (0, y.tapLeafHash)(Gr, br);
              if (Fr.findIndex((fi) => (0, B.isBytes)(fi) && (0, B.equalBytes)(fi, Xr)) === -1)
                continue;
              const hr = this.preimageWitnessV1(st, Mr, sr, Dr, void 0, Gr, br), Wr = (0, B.concatBytes)(E.signSchnorr(hr, Et, er), sr !== U.DEFAULT ? new Uint8Array([sr]) : c.EMPTY);
              this.updateInput(st, { tapScriptSig: [[{ pubKey: Xr, leafHash: Ar }, Wr]] }, !0), Qr = !0;
            }
          }
          if (!Qr)
            throw new Error("No taproot scripts signed");
          return !0;
        } else {
          const qr = E.pubECDSA(Et);
          let Mr = !1;
          const Dr = E.hash160(qr);
          for (const Vr of d.Script.decode(ir.lastScript))
            (0, B.isBytes)(Vr) && ((0, B.equalBytes)(Vr, qr) || (0, B.equalBytes)(Vr, Dr)) && (Mr = !0);
          if (!Mr)
            throw new Error(`Input script doesn't have pubKey: ${ir.lastScript}`);
          let Qr;
          if (ir.txType === "legacy")
            Qr = this.preimageLegacy(st, ir.lastScript, sr);
          else if (ir.txType === "segwit") {
            let Vr = ir.lastScript;
            ir.last.type === "wpkh" && (Vr = y.OutScript.encode({ type: "pkh", hash: ir.last.hash })), Qr = this.preimageWitnessV0(st, Vr, sr, wr.amount);
          } else
            throw new Error(`Transaction/sign: unknown tx type: ${ir.txType}`);
          const Xr = E.signECDSA(Qr, Et, this.opts.lowR);
          this.updateInput(st, {
            partialSig: [[qr, (0, B.concatBytes)(Xr, new Uint8Array([sr]))]]
          }, !0);
        }
        return !0;
      }
      // This is bad API. Will work if user creates and signs tx, but if
      // there is some complex workflow with exchanging PSBT and signing them,
      // then it is better to validate which output user signs. How could a better API look like?
      // Example: user adds input, sends to another party, then signs received input (mixer etc),
      // another user can add different input for same key and user will sign it.
      // Even worse: another user can add bip32 derivation, and spend money from different address.
      // Better api: signIdx
      sign(Et, st, Dt) {
        let er = 0;
        for (let xt = 0; xt < this.inputs.length; xt++)
          try {
            this.signIdx(Et, xt, st, Dt) && er++;
          } catch {
          }
        if (!er)
          throw new Error("No inputs signed");
        return er;
      }
      finalizeIdx(Et) {
        if (this.checkInputIdx(Et), this.fee < 0n)
          throw new Error("Outputs spends more than inputs amount");
        const st = this.inputs[Et], Dt = Fe(st, this.opts.allowLegacyWitnessUtxo);
        if (Dt.txType === "taproot") {
          if (st.tapKeySig)
            st.finalScriptWitness = [st.tapKeySig];
          else if (st.tapLeafScript && st.tapScriptSig) {
            const yr = st.tapLeafScript.sort((wr, qr) => t.TaprootControlBlock.encode(wr[0]).length - t.TaprootControlBlock.encode(qr[0]).length);
            for (const [wr, qr] of yr) {
              const Mr = qr.slice(0, -1), Dr = qr[qr.length - 1], Qr = y.OutScript.decode(Mr), Xr = (0, y.tapLeafHash)(Mr, Dr), Vr = st.tapScriptSig.filter((Sr) => (0, B.equalBytes)(Sr[0].leafHash, Xr));
              let Ur = [];
              if (Qr.type === "tr_ms") {
                const Sr = Qr.m, Gr = Qr.pubkeys;
                let Fr = 0;
                for (const br of Gr) {
                  const Ar = Vr.findIndex((cr) => (0, B.equalBytes)(cr[0].pubKey, br));
                  if (Fr === Sr || Ar === -1) {
                    Ur.push(c.EMPTY);
                    continue;
                  }
                  Ur.push(Vr[Ar][1]), Fr++;
                }
                if (Fr !== Sr)
                  continue;
              } else if (Qr.type === "tr_ns") {
                for (const Sr of Qr.pubkeys) {
                  const Gr = Vr.findIndex((Fr) => (0, B.equalBytes)(Fr[0].pubKey, Sr));
                  Gr !== -1 && Ur.push(Vr[Gr][1]);
                }
                if (Ur.length !== Qr.pubkeys.length)
                  continue;
              } else if (Qr.type === "unknown" && this.opts.allowUnknownInputs) {
                const Sr = d.Script.decode(Mr);
                if (Ur = Vr.map(([{ pubKey: Gr }, Fr]) => {
                  const br = Sr.findIndex((Ar) => (0, B.isBytes)(Ar) && (0, B.equalBytes)(Ar, Gr));
                  if (br === -1)
                    throw new Error("finalize/taproot: cannot find position of pubkey in script");
                  return { signature: Fr, pos: br };
                }).sort((Gr, Fr) => Gr.pos - Fr.pos).map((Gr) => Gr.signature), !Ur.length)
                  continue;
              } else {
                const Sr = this.opts.customScripts;
                if (Sr)
                  for (const Gr of Sr) {
                    if (!Gr.finalizeTaproot)
                      continue;
                    const Fr = d.Script.decode(Mr), br = Gr.encode(Fr);
                    if (br === void 0)
                      continue;
                    const Ar = Gr.finalizeTaproot(Mr, br, Vr);
                    if (Ar) {
                      st.finalScriptWitness = Ar.concat(t.TaprootControlBlock.encode(wr)), st.finalScriptSig = c.EMPTY, Ie(st);
                      return;
                    }
                  }
                throw new Error("Finalize: Unknown tapLeafScript");
              }
              st.finalScriptWitness = Ur.reverse().concat([Mr, t.TaprootControlBlock.encode(wr)]);
              break;
            }
            if (!st.finalScriptWitness)
              throw new Error("finalize/taproot: empty witness");
          } else
            throw new Error("finalize/taproot: unknown input");
          st.finalScriptSig = c.EMPTY, Ie(st);
          return;
        }
        if (!st.partialSig || !st.partialSig.length)
          throw new Error("Not enough partial sign");
        let er = c.EMPTY, xt = [];
        if (Dt.last.type === "ms") {
          const yr = Dt.last.m, wr = Dt.last.pubkeys;
          let qr = [];
          for (const Mr of wr) {
            const Dr = st.partialSig.find((Qr) => (0, B.equalBytes)(Mr, Qr[0]));
            Dr && qr.push(Dr[1]);
          }
          if (qr = qr.slice(0, yr), qr.length !== yr)
            throw new Error(`Multisig: wrong signatures count, m=${yr} n=${wr.length} signatures=${qr.length}`);
          er = d.Script.encode([0, ...qr]);
        } else if (Dt.last.type === "pk")
          er = d.Script.encode([st.partialSig[0][1]]);
        else if (Dt.last.type === "pkh")
          er = d.Script.encode([st.partialSig[0][1], st.partialSig[0][0]]);
        else if (Dt.last.type === "wpkh")
          er = c.EMPTY, xt = [st.partialSig[0][1], st.partialSig[0][0]];
        else if (Dt.last.type === "unknown" && !this.opts.allowUnknownInputs)
          throw new Error("Unknown inputs not allowed");
        let ir, sr;
        if (Dt.type.includes("wsh-") && (er.length && Dt.lastScript.length && (xt = d.Script.decode(er).map((yr) => {
          if (yr === 0)
            return c.EMPTY;
          if ((0, B.isBytes)(yr))
            return yr;
          throw new Error(`Wrong witness op=${yr}`);
        })), xt = xt.concat(Dt.lastScript)), Dt.txType === "segwit" && (sr = xt), Dt.type.startsWith("sh-wsh-") ? ir = d.Script.encode([d.Script.encode([0, E.sha256(Dt.lastScript)])]) : Dt.type.startsWith("sh-") ? ir = d.Script.encode([...d.Script.decode(er), Dt.lastScript]) : Dt.type.startsWith("wsh-") || Dt.txType !== "segwit" && (ir = er), !ir && !sr)
          throw new Error("Unknown error finalizing input");
        ir && (st.finalScriptSig = ir), sr && (st.finalScriptWitness = sr), Ie(st);
      }
      finalize() {
        for (let Et = 0; Et < this.inputs.length; Et++)
          this.finalizeIdx(Et);
      }
      extract() {
        if (!this.isFinal)
          throw new Error("Transaction has unfinalized inputs");
        if (!this.outputs.length)
          throw new Error("Transaction has no outputs");
        if (this.fee < 0n)
          throw new Error("Outputs spends more than inputs amount");
        return this.toBytes(!0, !0);
      }
      combine(Et) {
        for (const er of ["PSBTVersion", "version", "lockTime"])
          if (this.opts[er] !== Et.opts[er])
            throw new Error(`Transaction/combine: different ${er} this=${this.opts[er]} other=${Et.opts[er]}`);
        for (const er of ["inputs", "outputs"])
          if (this[er].length !== Et[er].length)
            throw new Error(`Transaction/combine: different ${er} length this=${this[er].length} other=${Et[er].length}`);
        const st = this.global.unsignedTx ? d.RawOldTx.encode(this.global.unsignedTx) : c.EMPTY, Dt = Et.global.unsignedTx ? d.RawOldTx.encode(Et.global.unsignedTx) : c.EMPTY;
        if (!(0, B.equalBytes)(st, Dt))
          throw new Error("Transaction/combine: different unsigned tx");
        this.global = t.mergeKeyMap(t.PSBTGlobal, this.global, Et.global, void 0, this.opts.allowUnknown);
        for (let er = 0; er < this.inputs.length; er++)
          this.updateInput(er, Et.inputs[er], !0);
        for (let er = 0; er < this.outputs.length; er++)
          this.updateOutput(er, Et.outputs[er], !0);
        return this;
      }
      clone() {
        return be.fromPSBT(this.toPSBT(this.opts.PSBTVersion), this.opts);
      }
    }
    o.Transaction = be;
    function Be(Ne) {
      if (!Ne || !Array.isArray(Ne) || !Ne.length)
        throw new Error("PSBTCombine: wrong PSBT list");
      const Et = be.fromPSBT(Ne[0]);
      for (let st = 1; st < Ne.length; st++)
        Et.combine(be.fromPSBT(Ne[st]));
      return Et.toPSBT();
    }
    const ke = 2147483648;
    function xe(Ne) {
      const Et = [];
      if (!/^[mM]'?/.test(Ne))
        throw new Error('Path must start with "m" or "M"');
      if (/^[mM]'?$/.test(Ne))
        return Et;
      const st = Ne.replace(/^[mM]'?\//, "").split("/");
      for (const Dt of st) {
        const er = /^(\d+)('?)$/.exec(Dt);
        if (!er || er.length !== 3)
          throw new Error(`Invalid child index: ${Dt}`);
        let xt = +er[1];
        if (!Number.isSafeInteger(xt) || xt >= ke)
          throw new Error("Invalid index");
        er[2] === "'" && (xt += ke), Et.push(xt);
      }
      return Et;
    }
  }(transaction)), transaction;
}
var utxo = {}, hasRequiredUtxo;
function requireUtxo() {
  return hasRequiredUtxo || (hasRequiredUtxo = 1, function(o) {
    Object.defineProperty(o, "__esModule", { value: !0 }), o._Estimator = o._cmpBig = void 0, o.selectUTXO = L;
    const g = /* @__PURE__ */ requireLib$2(), c = /* @__PURE__ */ requireLib(), y = /* @__PURE__ */ requirePayment(), t = /* @__PURE__ */ requirePsbt$1(), d = /* @__PURE__ */ requireScript(), E = /* @__PURE__ */ requireTransaction(), B = /* @__PURE__ */ requireUtils$1(), D = (H) => t.TaprootControlBlock.encode(H);
    function x(H, fe, ge) {
      if (!H || !H.length)
        throw new Error("no leafs");
      const Ie = () => new Uint8Array(fe), Ee = H.sort((Se, ze) => D(Se[0]).length - D(ze[0]).length);
      for (const [Se, ze] of Ee) {
        const He = ze.slice(0, -1), Pe = ze[ze.length - 1], De = y.OutScript.decode(He);
        let ve = [];
        if (De.type === "tr_ms") {
          const Fe = De.m, be = De.pubkeys.length - Fe;
          for (let Be = 0; Be < Fe; Be++)
            ve.push(Ie());
          for (let Be = 0; Be < be; Be++)
            ve.push(c.EMPTY);
        } else if (De.type === "tr_ns")
          for (const Fe of De.pubkeys)
            ve.push(Ie());
        else {
          if (!ge)
            throw new Error("Finalize: Unknown tapLeafScript");
          const Fe = (0, y.tapLeafHash)(He, Pe);
          for (const be of ge) {
            if (!be.finalizeTaproot)
              continue;
            const Be = d.Script.decode(He), ke = be.encode(Be);
            if (ke === void 0)
              continue;
            const xe = Be.filter((Et) => {
              if (!(0, B.isBytes)(Et))
                return !1;
              try {
                return (0, B.validatePubkey)(Et, B.PubT.schnorr), !0;
              } catch {
                return !1;
              }
            }), Ne = be.finalizeTaproot(He, ke, xe.map((Et) => [{ pubKey: Et, leafHash: Fe }, Ie()]));
            if (Ne)
              return Ne.concat(D(Se));
          }
        }
        return ve.reverse().concat([He, D(Se)]);
      }
      throw new Error("there was no witness");
    }
    function v(H, fe, ge) {
      let Ie = c.EMPTY, Ee;
      if (H.txType === "taproot") {
        const He = H.sighash !== E.SignatureHash.DEFAULT ? 65 : 64;
        if (fe.tapInternalKey && !(0, B.equalBytes)(fe.tapInternalKey, B.TAPROOT_UNSPENDABLE_KEY))
          Ee = [new Uint8Array(He)];
        else if (fe.tapLeafScript)
          Ee = x(fe.tapLeafScript, He, ge.customScripts);
        else
          throw new Error("estimateInput/taproot: unknown input");
      } else {
        const He = () => new Uint8Array(72), Pe = () => new Uint8Array(33);
        let De = c.EMPTY, ve = [];
        const Fe = H.last.type;
        if (Fe === "ms") {
          const be = H.last.m, Be = [0];
          for (let ke = 0; ke < be; ke++)
            Be.push(He());
          De = d.Script.encode(Be);
        } else if (Fe === "pk")
          De = d.Script.encode([He()]);
        else if (Fe === "pkh")
          De = d.Script.encode([He(), Pe()]);
        else if (Fe === "wpkh")
          De = c.EMPTY, ve = [He(), Pe()];
        else if (Fe === "unknown" && !ge.allowUnknownInputs)
          throw new Error("Unknown inputs are not allowed");
        H.type.includes("wsh-") && (De.length && H.lastScript.length && (ve = d.Script.decode(De).map((be) => {
          if (be === 0)
            return c.EMPTY;
          if ((0, B.isBytes)(be))
            return be;
          throw new Error(`Wrong witness op=${be}`);
        })), ve = ve.concat(H.lastScript)), H.txType === "segwit" && (Ee = ve), H.type.startsWith("sh-wsh-") ? Ie = d.Script.encode([d.Script.encode([0, new Uint8Array(B.sha256.outputLen)])]) : H.type.startsWith("sh-") ? Ie = d.Script.encode([...d.Script.decode(De), H.lastScript]) : H.type.startsWith("wsh-") || H.txType !== "segwit" && (Ie = De);
      }
      let Se = 160 + 4 * d.VarBytes.encode(Ie).length, ze = !1;
      return Ee && (Se += d.RawWitness.encode(Ee).length, ze = !0), { weight: Se, hasWitnesses: ze };
    }
    const F = (H, fe) => {
      const ge = H - fe;
      return ge < 0n ? -1 : ge > 0n ? 1 : 0;
    };
    o._cmpBig = F;
    function M(H, fe = {}, ge = B.NETWORK) {
      let Ie;
      if ("script" in H && (0, B.isBytes)(H.script) && (Ie = H.script), "address" in H) {
        if (typeof H.address != "string")
          throw new Error(`Estimator: wrong output address=${H.address}`);
        Ie = y.OutScript.encode((0, y.Address)(ge).decode(H.address));
      }
      if (!Ie)
        throw new Error("Estimator: wrong output script");
      if (typeof H.amount != "bigint")
        throw new Error(`Estimator: wrong output amount=${H.amount}, should be of type bigint but got ${typeof H.amount}.`);
      if (Ie && !fe.allowUnknownOutputs && y.OutScript.decode(Ie).type === "unknown")
        throw new Error("Estimator: unknown output script type, there is a chance that input is unspendable. Pass allowUnknownOutputs=true, if you sure");
      return fe.disableScriptCheck || (0, y.checkScript)(Ie), Ie;
    }
    class U {
      constructor(fe, ge, Ie) {
        if (this.requiredIndices = [], this.outputs = ge, this.opts = Ie, typeof Ie.feePerByte != "bigint")
          throw new Error(`Estimator: wrong feePerByte=${Ie.feePerByte}, should be of type bigint but got ${typeof Ie.feePerByte}.`);
        const ze = Ie.dust === void 0 ? BigInt(148 + 34) : Ie.dust;
        if (typeof ze != "bigint")
          throw new Error(`Estimator: wrong dust=${Ie.dust}, should be of type bigint but got ${typeof Ie.dust}.`);
        const He = Ie.dustRelayFeeRate === void 0 ? 3n : Ie.dustRelayFeeRate;
        if (typeof He != "bigint")
          throw new Error(`Estimator: wrong dustRelayFeeRate=${Ie.dustRelayFeeRate}, should be of type bigint but got ${typeof Ie.dustRelayFeeRate}.`);
        if (this.dust = ze * He, Ie.requiredInputs !== void 0 && !Array.isArray(Ie.requiredInputs))
          throw new Error(`Estimator: wrong required inputs=${Ie.requiredInputs}`);
        const Pe = Ie.network || B.NETWORK;
        let De = 0n, ve = 32;
        for (const ke of ge) {
          const xe = M(ke, Ie, Ie.network);
          ve += 32 + 4 * d.VarBytes.encode(xe).length, De += ke.amount;
        }
        if (typeof Ie.changeAddress != "string")
          throw new Error(`Estimator: wrong change address=${Ie.changeAddress}`);
        let Fe = ve + 32 + 4 * d.VarBytes.encode(y.OutScript.encode((0, y.Address)(Pe).decode(Ie.changeAddress))).length;
        ve += 4 * d.CompactSizeLen.encode(ge.length).length, Fe += 4 * d.CompactSizeLen.encode(ge.length + 1).length, this.baseWeight = ve, this.changeWeight = Fe, this.amount = De;
        const be = Array.from(fe);
        if (Ie.requiredInputs)
          for (let ke = 0; ke < Ie.requiredInputs.length; ke++)
            this.requiredIndices.push(be.push(Ie.requiredInputs[ke]) - 1);
        const Be = /* @__PURE__ */ new Set();
        this.normalizedInputs = be.map((ke) => {
          const xe = (0, E.normalizeInput)(ke, void 0, void 0, Ie.disableScriptCheck, Ie.allowUnknown);
          (0, E.inputBeforeSign)(xe);
          const Ne = `${g.hex.encode(xe.txid)}:${xe.index}`;
          if (!Ie.allowSameUtxo && Be.has(Ne))
            throw new Error(`Estimator: same input passed multiple times: ${Ne}`);
          Be.add(Ne);
          const Et = (0, E.getInputType)(xe, Ie.allowLegacyWitnessUtxo), st = (0, E.getPrevOut)(xe), Dt = v(Et, xe, this.opts), er = st.amount - Ie.feePerByte * BigInt((0, E.toVsize)(Dt.weight));
          return { inputType: Et, normalized: xe, amount: st.amount, value: er, estimate: Dt };
        });
      }
      checkInputIdx(fe) {
        if (!Number.isSafeInteger(fe) || 0 > fe || fe >= this.normalizedInputs.length)
          throw new Error(`Wrong input index=${fe}`);
        return fe;
      }
      sortIndices(fe) {
        return fe.slice().sort((ge, Ie) => {
          const Ee = this.normalizedInputs[this.checkInputIdx(ge)], Se = this.normalizedInputs[this.checkInputIdx(Ie)], ze = (0, B.compareBytes)(Ee.normalized.txid, Se.normalized.txid);
          return ze !== 0 ? ze : Ee.normalized.index - Se.normalized.index;
        });
      }
      sortOutputs(fe) {
        const ge = fe.map((Ee) => M(Ee, this.opts, this.opts.network));
        return fe.map((Ee, Se) => Se).sort((Ee, Se) => {
          const ze = fe[Ee].amount, He = fe[Se].amount, Pe = (0, o._cmpBig)(ze, He);
          return Pe !== 0 ? Pe : (0, B.compareBytes)(ge[Ee], ge[Se]);
        });
      }
      getSatoshi(fe) {
        return this.opts.feePerByte * BigInt((0, E.toVsize)(fe));
      }
      // Sort by value instead of amount
      get biggest() {
        return this.normalizedInputs.map((fe, ge) => ge).sort((fe, ge) => (0, o._cmpBig)(this.normalizedInputs[ge].value, this.normalizedInputs[fe].value));
      }
      get smallest() {
        return this.biggest.reverse();
      }
      // These assume that UTXO array has historical order.
      // Otherwise, we have no way to know which tx is oldest
      // Explorers usually give UTXO in this order.
      get oldest() {
        return this.normalizedInputs.map((fe, ge) => ge);
      }
      get newest() {
        return this.oldest.reverse();
      }
      // exact - like blackjack from coinselect.
      // exact(biggest) will select one big utxo which is closer to targetValue+dust, if possible.
      // If not, it will accumulate largest utxo until value is close to targetValue+dust.
      accumulate(fe, ge = !1, Ie = !0, Ee = !1) {
        let Se = this.opts.alwaysChange ? this.changeWeight : this.baseWeight, ze = !1, He = 0, Pe = 0n;
        const De = this.amount, ve = /* @__PURE__ */ new Set();
        let Fe;
        for (const be of this.requiredIndices) {
          if (this.checkInputIdx(be), ve.has(be))
            throw new Error("required input encountered multiple times");
          const { estimate: Be, amount: ke } = this.normalizedInputs[be];
          let xe = Se + Be.weight;
          !ze && Be.hasWitnesses && (xe += 2);
          const Ne = xe + 4 * d.CompactSizeLen.encode(He).length;
          if (Fe = this.getSatoshi(Ne), Se = xe, Be.hasWitnesses && (ze = !0), He++, Pe += ke, ve.add(be), !Ee && De + Fe <= Pe && He >= this.requiredIndices.length)
            return { indices: Array.from(ve), fee: Fe, weight: Ne, total: Pe };
        }
        for (const be of fe) {
          if (this.checkInputIdx(be), ve.has(be))
            continue;
          const { estimate: Be, amount: ke, value: xe } = this.normalizedInputs[be];
          let Ne = Se + Be.weight;
          !ze && Be.hasWitnesses && (Ne += 2);
          const Et = Ne + 4 * d.CompactSizeLen.encode(He).length;
          if (Fe = this.getSatoshi(Et), !(ge && ke + Pe > De + Fe + this.dust) && !(Ie && xe <= 0n) && (Se = Ne, Be.hasWitnesses && (ze = !0), He++, Pe += ke, ve.add(be), !Ee && De + Fe <= Pe))
            return { indices: Array.from(ve), fee: Fe, weight: Et, total: Pe };
        }
        if (Ee) {
          const be = Se + 4 * d.CompactSizeLen.encode(He).length;
          return { indices: Array.from(ve), fee: Fe, weight: be, total: Pe };
        }
      }
      // Works like coinselect default method
      default() {
        const { biggest: fe } = this, ge = this.accumulate(fe, !0, !1);
        return ge || this.accumulate(fe);
      }
      select(fe) {
        if (fe === "all")
          return this.accumulate(this.normalizedInputs.map((Ie, Ee) => Ee), !1, !0, !0);
        if (fe === "default")
          return this.default();
        const ge = {
          Oldest: () => this.oldest,
          Newest: () => this.newest,
          Smallest: () => this.smallest,
          Biggest: () => this.biggest
        };
        if (fe.startsWith("exact")) {
          const [Ie, Ee] = fe.slice(5).split("/");
          if (!ge[Ie])
            throw new Error(`Estimator.select: wrong strategy=${fe}`);
          fe = Ee;
          const Se = this.accumulate(ge[Ie](), !0, !0);
          if (Se)
            return Se;
        }
        if (fe.startsWith("accum")) {
          const Ie = fe.slice(5);
          if (!ge[Ie])
            throw new Error(`Estimator.select: wrong strategy=${fe}`);
          return this.accumulate(ge[Ie]());
        }
        throw new Error(`Estimator.select: wrong strategy=${fe}`);
      }
      result(fe) {
        const ge = this.select(fe);
        if (!ge)
          return;
        const { indices: Ie, weight: Ee, total: Se } = ge;
        let ze = this.opts.alwaysChange;
        const He = this.opts.alwaysChange ? Ee : Ee + (this.changeWeight - this.baseWeight), Pe = this.getSatoshi(He);
        let De = ge.fee;
        const ve = Se - this.amount - Pe;
        ve > this.dust && (ze = !0);
        let Fe = Ie, be = Array.from(this.outputs);
        if (ze) {
          if (De = Pe, ve < 0n)
            throw new Error(`Estimator.result: negative change=${ve}`);
          be.push({ address: this.opts.changeAddress, amount: ve });
        }
        this.opts.bip69 && (Fe = this.sortIndices(Fe), be = this.sortOutputs(be).map((xe) => be[xe]));
        const Be = {
          inputs: Fe.map((xe) => this.normalizedInputs[xe].normalized),
          outputs: be,
          fee: De,
          weight: this.opts.alwaysChange ? ge.weight : He,
          change: !!ze
        };
        let ke;
        if (this.opts.createTx) {
          const { inputs: xe, outputs: Ne } = Be;
          ke = new E.Transaction(this.opts);
          for (const Et of xe)
            ke.addInput(Et);
          for (const Et of Ne)
            ke.addOutput({ ...Et, script: M(Et, this.opts, this.opts.network) });
        }
        return Object.assign(Be, { tx: ke });
      }
    }
    o._Estimator = U;
    function L(H, fe, ge, Ie) {
      const Ee = { createTx: !0, bip69: !0, ...Ie };
      return new U(H, fe, Ee).result(ge);
    }
  }(utxo)), utxo;
}
var hasRequiredBtcSigner;
function requireBtcSigner() {
  return hasRequiredBtcSigner || (hasRequiredBtcSigner = 1, function(o) {
    Object.defineProperty(o, "__esModule", { value: !0 }), o._Estimator = o._cmpBig = o.SigHash = o.PSBTCombine = o.DEFAULT_SEQUENCE = o.Decimal = o.bip32Path = o.TaprootControlBlock = o._DebugPSBT = o.WIF = o.taprootListToTree = o.sortedMultisig = o.OutScript = o.getAddress = o.combinations = o.Address = o._sortPubkeys = o.utils = o.selectUTXO = o.TEST_NETWORK = o.TAPROOT_UNSPENDABLE_KEY = o.NETWORK = o.Transaction = o.getInputType = o.ScriptNum = o.Script = o.RawWitness = o.RawTx = o.OP = o.MAX_SCRIPT_BYTE_LENGTH = o.CompactSize = o.p2wsh = o.p2wpkh = o.p2tr_pk = o.p2tr_ns = o.p2tr_ms = o.p2tr = o.p2sh = o.p2pkh = o.p2pk = o.p2ms = o.multisig = void 0;
    const g = /* @__PURE__ */ requireUtils$1();
    var c = /* @__PURE__ */ requirePayment();
    Object.defineProperty(o, "multisig", { enumerable: !0, get: function() {
      return c.multisig;
    } }), Object.defineProperty(o, "p2ms", { enumerable: !0, get: function() {
      return c.p2ms;
    } }), Object.defineProperty(o, "p2pk", { enumerable: !0, get: function() {
      return c.p2pk;
    } }), Object.defineProperty(o, "p2pkh", { enumerable: !0, get: function() {
      return c.p2pkh;
    } }), Object.defineProperty(o, "p2sh", { enumerable: !0, get: function() {
      return c.p2sh;
    } }), Object.defineProperty(o, "p2tr", { enumerable: !0, get: function() {
      return c.p2tr;
    } }), Object.defineProperty(o, "p2tr_ms", { enumerable: !0, get: function() {
      return c.p2tr_ms;
    } }), Object.defineProperty(o, "p2tr_ns", { enumerable: !0, get: function() {
      return c.p2tr_ns;
    } }), Object.defineProperty(o, "p2tr_pk", { enumerable: !0, get: function() {
      return c.p2tr_pk;
    } }), Object.defineProperty(o, "p2wpkh", { enumerable: !0, get: function() {
      return c.p2wpkh;
    } }), Object.defineProperty(o, "p2wsh", { enumerable: !0, get: function() {
      return c.p2wsh;
    } });
    var y = /* @__PURE__ */ requireScript();
    Object.defineProperty(o, "CompactSize", { enumerable: !0, get: function() {
      return y.CompactSize;
    } }), Object.defineProperty(o, "MAX_SCRIPT_BYTE_LENGTH", { enumerable: !0, get: function() {
      return y.MAX_SCRIPT_BYTE_LENGTH;
    } }), Object.defineProperty(o, "OP", { enumerable: !0, get: function() {
      return y.OP;
    } }), Object.defineProperty(o, "RawTx", { enumerable: !0, get: function() {
      return y.RawTx;
    } }), Object.defineProperty(o, "RawWitness", { enumerable: !0, get: function() {
      return y.RawWitness;
    } }), Object.defineProperty(o, "Script", { enumerable: !0, get: function() {
      return y.Script;
    } }), Object.defineProperty(o, "ScriptNum", { enumerable: !0, get: function() {
      return y.ScriptNum;
    } });
    var t = /* @__PURE__ */ requireTransaction();
    Object.defineProperty(o, "getInputType", { enumerable: !0, get: function() {
      return t.getInputType;
    } }), Object.defineProperty(o, "Transaction", { enumerable: !0, get: function() {
      return t.Transaction;
    } });
    var d = /* @__PURE__ */ requireUtils$1();
    Object.defineProperty(o, "NETWORK", { enumerable: !0, get: function() {
      return d.NETWORK;
    } }), Object.defineProperty(o, "TAPROOT_UNSPENDABLE_KEY", { enumerable: !0, get: function() {
      return d.TAPROOT_UNSPENDABLE_KEY;
    } }), Object.defineProperty(o, "TEST_NETWORK", { enumerable: !0, get: function() {
      return d.TEST_NETWORK;
    } });
    var E = /* @__PURE__ */ requireUtxo();
    Object.defineProperty(o, "selectUTXO", { enumerable: !0, get: function() {
      return E.selectUTXO;
    } }), o.utils = {
      isBytes: g.isBytes,
      concatBytes: g.concatBytes,
      compareBytes: g.compareBytes,
      pubSchnorr: g.pubSchnorr,
      randomPrivateKeyBytes: g.randomPrivateKeyBytes,
      taprootTweakPubkey: g.taprootTweakPubkey
    };
    var B = /* @__PURE__ */ requirePayment();
    Object.defineProperty(o, "_sortPubkeys", { enumerable: !0, get: function() {
      return B._sortPubkeys;
    } }), Object.defineProperty(o, "Address", { enumerable: !0, get: function() {
      return B.Address;
    } }), Object.defineProperty(o, "combinations", { enumerable: !0, get: function() {
      return B.combinations;
    } }), Object.defineProperty(o, "getAddress", { enumerable: !0, get: function() {
      return B.getAddress;
    } }), Object.defineProperty(o, "OutScript", { enumerable: !0, get: function() {
      return B.OutScript;
    } }), Object.defineProperty(o, "sortedMultisig", { enumerable: !0, get: function() {
      return B.sortedMultisig;
    } }), Object.defineProperty(o, "taprootListToTree", { enumerable: !0, get: function() {
      return B.taprootListToTree;
    } }), Object.defineProperty(o, "WIF", { enumerable: !0, get: function() {
      return B.WIF;
    } });
    var D = /* @__PURE__ */ requirePsbt$1();
    Object.defineProperty(o, "_DebugPSBT", { enumerable: !0, get: function() {
      return D._DebugPSBT;
    } }), Object.defineProperty(o, "TaprootControlBlock", { enumerable: !0, get: function() {
      return D.TaprootControlBlock;
    } });
    var x = /* @__PURE__ */ requireTransaction();
    Object.defineProperty(o, "bip32Path", { enumerable: !0, get: function() {
      return x.bip32Path;
    } }), Object.defineProperty(o, "Decimal", { enumerable: !0, get: function() {
      return x.Decimal;
    } }), Object.defineProperty(o, "DEFAULT_SEQUENCE", { enumerable: !0, get: function() {
      return x.DEFAULT_SEQUENCE;
    } }), Object.defineProperty(o, "PSBTCombine", { enumerable: !0, get: function() {
      return x.PSBTCombine;
    } }), Object.defineProperty(o, "SigHash", { enumerable: !0, get: function() {
      return x.SigHash;
    } });
    var v = /* @__PURE__ */ requireUtxo();
    Object.defineProperty(o, "_cmpBig", { enumerable: !0, get: function() {
      return v._cmpBig;
    } }), Object.defineProperty(o, "_Estimator", { enumerable: !0, get: function() {
      return v._Estimator;
    } });
  }(btcSigner)), btcSigner;
}
var bip322$1 = {}, types$1 = {}, hasRequiredTypes$1;
function requireTypes$1() {
  return hasRequiredTypes$1 || (hasRequiredTypes$1 = 1, function(o) {
    Object.defineProperty(o, "__esModule", { value: !0 }), o.MagicCode = o.MessageSigningProtocols = o.AddressType = void 0, function(g) {
      g.p2pkh = "p2pkh", g.p2sh = "p2sh", g.p2wpkh = "p2wpkh", g.p2wsh = "p2wsh", g.p2tr = "p2tr";
    }(o.AddressType || (o.AddressType = {})), function(g) {
      g.ECDSA = "ECDSA", g.BIP322 = "BIP322";
    }(o.MessageSigningProtocols || (o.MessageSigningProtocols = {})), function(g) {
      g.LEAFHASH_DISPLAY_FP = "69846d00", g.LEAFHASH_CHECK_ONLY_FP = "3b9f9680", g.FINALITY_PUB_FP = "ff119473", g.BIP322_MESSAGE_FP = "83871619", g.BIP322_TAP_PUBKEY_FP = "25270417", g.BIP322_HASH_FP = "04040816";
    }(o.MagicCode || (o.MagicCode = {}));
  }(types$1)), types$1;
}
var hasRequiredBip322$1;
function requireBip322$1() {
  if (hasRequiredBip322$1) return bip322$1;
  hasRequiredBip322$1 = 1;
  var o = bip322$1 && bip322$1.__createBinding || (Object.create ? function(De, ve, Fe, be) {
    be === void 0 && (be = Fe);
    var Be = Object.getOwnPropertyDescriptor(ve, Fe);
    (!Be || ("get" in Be ? !ve.__esModule : Be.writable || Be.configurable)) && (Be = { enumerable: !0, get: function() {
      return ve[Fe];
    } }), Object.defineProperty(De, be, Be);
  } : function(De, ve, Fe, be) {
    be === void 0 && (be = Fe), De[be] = ve[Fe];
  }), g = bip322$1 && bip322$1.__setModuleDefault || (Object.create ? function(De, ve) {
    Object.defineProperty(De, "default", { enumerable: !0, value: ve });
  } : function(De, ve) {
    De.default = ve;
  }), c = bip322$1 && bip322$1.__importStar || function(De) {
    if (De && De.__esModule) return De;
    var ve = {};
    if (De != null) for (var Fe in De) Fe !== "default" && Object.prototype.hasOwnProperty.call(De, Fe) && o(ve, De, Fe);
    return g(ve, De), ve;
  };
  Object.defineProperty(bip322$1, "__esModule", { value: !0 }), bip322$1.createTaprootBip322Signature = bip322$1.createSegwitBip322Signature = bip322$1.bip0322Hash = void 0;
  const y = c(requireDist$q()), t = require$$1, d = requireSrc$1(), E = requireVaruintBitcoin(), B = requireMain$1(), D = requireBabylon$1(), x = requireTypes$1(), v = (0, d.BIP32Factory)(y), F = (De) => Buffer.concat([(0, E.encode)(De.byteLength), De]), M = Buffer.from("0000000000000000000000000000000000000000000000000000000000000000", "hex"), U = 4294967295, L = 0;
  function H(De) {
    const { sha256: ve } = t.crypto, be = ve(Buffer.from("BIP0322-signed-message"));
    return ve(Buffer.concat([be, be, Buffer.from(De)])).toString("hex");
  }
  bip322$1.bip0322Hash = H;
  const fe = async (De, ve, Fe, be, Be, ke) => {
    const xe = Buffer.concat([
      Buffer.from("0020", "hex"),
      Buffer.from(H(Fe), "hex")
    ]), Ne = new t.Transaction();
    Ne.version = 0, Ne.addInput(M, U, L, xe), Ne.addOutput(be, 0);
    const Et = new t.Psbt();
    Et.setVersion(0), Et.addInput(Object.assign({ hash: Ne.getHash(), index: 0, sequence: 0, witnessUtxo: {
      script: be,
      value: 0
    } }, Be)), Et.addOutput({ script: Buffer.from("6a", "hex"), value: 0 });
    const st = await De.signPsbt(Et.toBase64(), ve, null);
    for (const sr of st)
      ke ? Et.updateInput(sr[0], {
        partialSig: [sr[1]]
      }) : Et.updateInput(sr[0], {
        tapKeySig: sr[1].signature
      });
    Et.finalizeAllInputs();
    const Dt = Et.extractTransaction(), er = (0, E.encode)(Dt.ins[0].witness.length);
    return {
      signature: Buffer.concat([
        er,
        ...Dt.ins[0].witness.map((sr) => F(sr))
      ]).toString("base64"),
      protocol: x.MessageSigningProtocols.BIP322
    };
  };
  function ge(De, ve, Fe) {
    const be = Fe ? t.networks.testnet : t.networks.bitcoin, { publicKey: Be } = v.fromBase58(De, be).derivePath(`0/${ve}`);
    return Be;
  }
  function Ie(De, ve, Fe = !1) {
    (0, t.initEccLib)(y);
    const be = ge(De, ve, Fe), Be = Fe ? t.networks.testnet : t.networks.bitcoin, ke = t.payments.p2wpkh({ pubkey: be, network: Be }), xe = ke.address;
    if (!xe)
      throw new Error("Address is null");
    if (!ke.output)
      throw new Error("p2wpkh output is null");
    return {
      publicKey: be,
      address: xe,
      witnessScript: ke.output
    };
  }
  async function Ee({ message: De, app: ve, derivationPath: Fe = "m/84'/0'/0'", isTestnet: be = !1 }) {
    const Be = await ve.getMasterFingerprint(), ke = await ve.getExtendedPubkey(Fe), { publicKey: xe, witnessScript: Ne } = Ie(ke, 0, be), Et = {
      path: `${Fe}/0/0`,
      pubkey: xe,
      masterFingerprint: Buffer.from(Be, "hex")
    }, st = new B.WalletPolicy("Sign message", "wpkh(@0/**)", [
      `[${Fe.replace("m/", `${Be}/`)}]${ke}`
    ]);
    return fe(ve, st, De, Ne, {
      bip32Derivation: [Et]
    }, !0);
  }
  bip322$1.createSegwitBip322Signature = Ee;
  function Se(De, ve, Fe = !1) {
    (0, t.initEccLib)(y);
    const be = ge(De, ve, Fe), Be = t.payments.p2tr({
      internalPubkey: be.slice(1),
      network: Fe ? t.networks.testnet : t.networks.bitcoin
    });
    if (!Be.output || !Be.address || !Be.internalPubkey)
      throw new Error("p2tr output, address or internalPubkey is null");
    return {
      publicKey: be,
      address: Be.address,
      internalPubkey: Be.internalPubkey,
      taprootScript: Be.output
    };
  }
  function ze(De, ve) {
    let Be = ve.toString(16).padStart(2, "0") + De;
    const ke = 64 - Be.length;
    return ke > 0 && (Be += "fc".repeat(ke / 2)), Be;
  }
  function He(De, ve) {
    let Fe = "";
    for (let ke = 0; ke < De.length; ke++) {
      const xe = De[ke].toString(16).padStart(2, "0");
      Fe += xe;
    }
    const be = Buffer.from(ve, "ascii"), Be = be.length.toString(16).padStart(2, "0");
    return Fe += Be + be.toString("hex"), ze(Fe, De.length);
  }
  async function Pe({ message: De, app: ve, derivationPath: Fe = "m/86'/0'/0'", isTestnet: be = !1 }) {
    const Be = De;
    let ke, xe;
    De.length > 96 ? (ke = De.slice(0, 64), De = De.slice(64), xe = (0, D.formatKey)(ke, be)) : (ke = Buffer.alloc(32, 255).toString("hex"), xe = (0, D.formatKey)(ke, be));
    const Ne = await ve.getMasterFingerprint(), Et = await ve.getExtendedPubkey(Fe), { internalPubkey: st, taprootScript: Dt } = Se(Et, 0, be), er = {
      path: `${Fe}/0/0`,
      pubkey: st,
      masterFingerprint: Buffer.from(Ne, "hex"),
      leafHashes: []
    }, xt = (0, D.validadteAddress)(De);
    if (!xt || !xt.data)
      throw new Error("The message should be a valid bbn address.");
    const ir = xt.data, sr = new B.WalletPolicy("Sign message", "tr(@0/**,and_v(pk_k(@1/**),and_v(pk_k(@2/**),pk_k(@3/**))))", [
      `[${Fe.replace("m/", `${Ne}/`)}]${Et}`,
      `[${Fe.replace("m/", `${x.MagicCode.BIP322_MESSAGE_FP}/`)}]${(0, D.formatKey)(He(ir, xt.prefix), be)}`,
      `[${Fe.replace("m/", `${x.MagicCode.BIP322_TAP_PUBKEY_FP}/`)}]${(0, D.formatKey)(Dt.slice(2), be)}`,
      `[${Fe.replace("m/", `${x.MagicCode.BIP322_HASH_FP}/`)}]${xe}`
    ]);
    return fe(ve, sr, Be, Dt, {
      tapBip32Derivation: [er],
      tapInternalKey: st
    }, !1);
  }
  return bip322$1.createTaprootBip322Signature = Pe, bip322$1;
}
var psbt = {}, hasRequiredPsbt;
function requirePsbt() {
  if (hasRequiredPsbt) return psbt;
  hasRequiredPsbt = 1;
  var o = psbt && psbt.__createBinding || (Object.create ? function(x, v, F, M) {
    M === void 0 && (M = F);
    var U = Object.getOwnPropertyDescriptor(v, F);
    (!U || ("get" in U ? !v.__esModule : U.writable || U.configurable)) && (U = { enumerable: !0, get: function() {
      return v[F];
    } }), Object.defineProperty(x, M, U);
  } : function(x, v, F, M) {
    M === void 0 && (M = F), x[M] = v[F];
  }), g = psbt && psbt.__setModuleDefault || (Object.create ? function(x, v) {
    Object.defineProperty(x, "default", { enumerable: !0, value: v });
  } : function(x, v) {
    x.default = v;
  }), c = psbt && psbt.__importStar || function(x) {
    if (x && x.__esModule) return x;
    var v = {};
    if (x != null) for (var F in x) F !== "default" && Object.prototype.hasOwnProperty.call(x, F) && o(v, x, F);
    return g(v, x), v;
  };
  Object.defineProperty(psbt, "__esModule", { value: !0 }), psbt.getLeafHash = psbt.getTaprootScript = void 0;
  const y = c(requireCryptoBrowserify()), t = require$$1;
  function d(x) {
    const v = Buffer.from(x, "base64"), F = t.Psbt.fromBuffer(v);
    for (const M of F.data.inputs)
      if (M.tapLeafScript && M.tapLeafScript.length > 0)
        for (const U of M.tapLeafScript)
          return U.script;
  }
  psbt.getTaprootScript = d;
  function E(x, v) {
    const F = y.createHash("sha256").update(x).digest();
    return y.createHash("sha256").update(Buffer.concat([F, F, v])).digest();
  }
  function B(x) {
    if (x < 253)
      return Buffer.from([x]);
    if (x <= 65535) {
      const v = Buffer.alloc(3);
      return v.writeUInt8(253, 0), v.writeUInt16LE(x, 1), v;
    } else if (x <= 4294967295) {
      const v = Buffer.alloc(5);
      return v.writeUInt8(254, 0), v.writeUInt32LE(x, 1), v;
    } else {
      const v = Buffer.alloc(9);
      return v.writeUInt8(255, 0), v.writeUInt32LE(x, 1), v.writeBigUInt64LE(BigInt(x), 5), v;
    }
  }
  function D(x) {
    const v = Buffer.from([192]), F = x.length, M = B(F), U = Buffer.concat([v, M, x]);
    return E(Buffer.from("TapLeaf"), U);
  }
  return psbt.getLeafHash = D, psbt;
}
var xpub = {}, cjs$1 = {}, cjs = {}, hasRequiredCjs$1;
function requireCjs$1() {
  if (hasRequiredCjs$1) return cjs;
  hasRequiredCjs$1 = 1, Object.defineProperty(cjs, "__esModule", { value: !0 });
  function o(g) {
    if (g.length >= 255)
      throw new TypeError("Alphabet too long");
    const c = new Uint8Array(256);
    for (let v = 0; v < c.length; v++)
      c[v] = 255;
    for (let v = 0; v < g.length; v++) {
      const F = g.charAt(v), M = F.charCodeAt(0);
      if (c[M] !== 255)
        throw new TypeError(F + " is ambiguous");
      c[M] = v;
    }
    const y = g.length, t = g.charAt(0), d = Math.log(y) / Math.log(256), E = Math.log(256) / Math.log(y);
    function B(v) {
      if (v instanceof Uint8Array || (ArrayBuffer.isView(v) ? v = new Uint8Array(v.buffer, v.byteOffset, v.byteLength) : Array.isArray(v) && (v = Uint8Array.from(v))), !(v instanceof Uint8Array))
        throw new TypeError("Expected Uint8Array");
      if (v.length === 0)
        return "";
      let F = 0, M = 0, U = 0;
      const L = v.length;
      for (; U !== L && v[U] === 0; )
        U++, F++;
      const H = (L - U) * E + 1 >>> 0, fe = new Uint8Array(H);
      for (; U !== L; ) {
        let Ee = v[U], Se = 0;
        for (let ze = H - 1; (Ee !== 0 || Se < M) && ze !== -1; ze--, Se++)
          Ee += 256 * fe[ze] >>> 0, fe[ze] = Ee % y >>> 0, Ee = Ee / y >>> 0;
        if (Ee !== 0)
          throw new Error("Non-zero carry");
        M = Se, U++;
      }
      let ge = H - M;
      for (; ge !== H && fe[ge] === 0; )
        ge++;
      let Ie = t.repeat(F);
      for (; ge < H; ++ge)
        Ie += g.charAt(fe[ge]);
      return Ie;
    }
    function D(v) {
      if (typeof v != "string")
        throw new TypeError("Expected String");
      if (v.length === 0)
        return new Uint8Array();
      let F = 0, M = 0, U = 0;
      for (; v[F] === t; )
        M++, F++;
      const L = (v.length - F) * d + 1 >>> 0, H = new Uint8Array(L);
      for (; F < v.length; ) {
        const Ee = v.charCodeAt(F);
        if (Ee > 255)
          return;
        let Se = c[Ee];
        if (Se === 255)
          return;
        let ze = 0;
        for (let He = L - 1; (Se !== 0 || ze < U) && He !== -1; He--, ze++)
          Se += y * H[He] >>> 0, H[He] = Se % 256 >>> 0, Se = Se / 256 >>> 0;
        if (Se !== 0)
          throw new Error("Non-zero carry");
        U = ze, F++;
      }
      let fe = L - U;
      for (; fe !== L && H[fe] === 0; )
        fe++;
      const ge = new Uint8Array(M + (L - fe));
      let Ie = M;
      for (; fe !== L; )
        ge[Ie++] = H[fe++];
      return ge;
    }
    function x(v) {
      const F = D(v);
      if (F)
        return F;
      throw new Error("Non-base" + y + " character");
    }
    return {
      encode: B,
      decodeUnsafe: D,
      decode: x
    };
  }
  return cjs.default = o, cjs;
}
var hasRequiredCjs;
function requireCjs() {
  if (hasRequiredCjs) return cjs$1;
  hasRequiredCjs = 1;
  var o = cjs$1 && cjs$1.__importDefault || function(y) {
    return y && y.__esModule ? y : { default: y };
  };
  Object.defineProperty(cjs$1, "__esModule", { value: !0 });
  var g = o(requireCjs$1()), c = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
  return cjs$1.default = (0, g.default)(c), cjs$1;
}
var hasRequiredXpub;
function requireXpub() {
  if (hasRequiredXpub) return xpub;
  hasRequiredXpub = 1;
  var o = xpub && xpub.__createBinding || (Object.create ? function(D, x, v, F) {
    F === void 0 && (F = v);
    var M = Object.getOwnPropertyDescriptor(x, v);
    (!M || ("get" in M ? !x.__esModule : M.writable || M.configurable)) && (M = { enumerable: !0, get: function() {
      return x[v];
    } }), Object.defineProperty(D, F, M);
  } : function(D, x, v, F) {
    F === void 0 && (F = v), D[F] = x[v];
  }), g = xpub && xpub.__setModuleDefault || (Object.create ? function(D, x) {
    Object.defineProperty(D, "default", { enumerable: !0, value: x });
  } : function(D, x) {
    D.default = x;
  }), c = xpub && xpub.__importStar || function(D) {
    if (D && D.__esModule) return D;
    var x = {};
    if (D != null) for (var v in D) v !== "default" && Object.prototype.hasOwnProperty.call(D, v) && o(x, D, v);
    return g(x, D), x;
  }, y = xpub && xpub.__importDefault || function(D) {
    return D && D.__esModule ? D : { default: D };
  };
  Object.defineProperty(xpub, "__esModule", { value: !0 }), xpub.createExtendedPubkey = void 0;
  const t = c(requireCryptoBrowserify()), d = y(requireCjs());
  function E(D) {
    return t.createHash("sha256").update(t.createHash("sha256").update(D).digest()).digest();
  }
  function B(D, x = 0, v = Buffer.from("00000000", "hex"), F = 0, M = Buffer.from("0000000000000000000000000000000000000000000000000000000000000000", "hex"), U) {
    let L;
    if (D === "Mainnet")
      L = Buffer.from("0488b21e", "hex");
    else if (D === "Testnet")
      L = Buffer.from("043587cf", "hex");
    else
      throw new Error("Invalid network. Use 'Mainnet' or 'Testnet'.");
    const H = Buffer.concat([
      L,
      Buffer.from([x]),
      v,
      Buffer.from([
        F >> 24,
        F >> 16 & 255,
        F >> 8 & 255,
        F & 255
      ]),
      M,
      U
      // 33 bytes: compressed public key
    ]), fe = E(H).slice(0, 4);
    return d.default.encode(Buffer.concat([H, fe]));
  }
  return xpub.createExtendedPubkey = B, xpub;
}
var hasRequiredBabylon$1;
function requireBabylon$1() {
  if (hasRequiredBabylon$1) return babylon$1;
  hasRequiredBabylon$1 = 1;
  var o = babylon$1 && babylon$1.__importDefault || function(Et) {
    return Et && Et.__esModule ? Et : { default: Et };
  };
  Object.defineProperty(babylon$1, "__esModule", { value: !0 }), babylon$1.tryParsePsbt = babylon$1.stakingTxPolicy = babylon$1.timelockPathPolicy = babylon$1.unbondingPathPolicy = babylon$1.slashingPathPolicy = babylon$1.formatKey = babylon$1.computeLeafHash = babylon$1.signMessage = babylon$1.validadteAddress = babylon$1.signPsbt = void 0;
  const g = requireCryptoBrowserify(), c = requireMain$2(), y = requireBuild(), t = /* @__PURE__ */ requireLib$1(), d = /* @__PURE__ */ requireBtcSigner(), E = o(requireAppClient$1()), B = requireBuffertools$1(), D = requirePolicy$1(), x = requireBip322$1(), v = requirePsbt(), F = requireTypes$1(), M = requireXpub();
  async function U({ transport: Et, psbt: st, policy: Dt }) {
    const er = new E.default(Et), xt = st instanceof Uint8Array ? t.base64.encode(st) : st, ir = await er.signPsbt(xt, Dt, null), sr = !!(0, v.getTaprootScript)(xt), yr = d.Transaction.fromPSBT(t.base64.decode(xt));
    for (const wr of ir) {
      const qr = wr[0];
      sr ? yr.updateInput(qr, {
        tapScriptSig: [
          [
            {
              pubKey: wr[1].pubkey,
              leafHash: wr[1].tapleafHash
            },
            wr[1].signature
          ]
        ]
      }, !0) : yr.updateInput(qr, {
        tapKeySig: wr[1].signature
      }, !0);
    }
    return yr;
  }
  babylon$1.signPsbt = U;
  function L(Et) {
    try {
      const { prefix: st, data: Dt } = (0, y.fromBech32)(Et);
      if (Dt.length === 20 && st.length <= 10)
        return { prefix: st, data: Dt };
      console.log("Validation FAILED - data.length:", Dt.length, "prefix.length:", st.length);
    } catch (st) {
      console.log("fromBech32 threw error:", st);
    }
  }
  babylon$1.validadteAddress = L;
  async function H(Et) {
    var st;
    const Dt = (st = Et.derivationPath) !== null && st !== void 0 ? st : "m/86'/0'/0'";
    if (Et.type === "bip322-simple") {
      const { transport: ir, message: sr, addressType: yr = F.AddressType.p2tr, isTestnet: wr = !1 } = Et;
      return ge({
        transport: ir,
        message: sr,
        addressType: yr,
        derivationPath: Dt,
        isTestnet: wr
      });
    }
    const { transport: er, message: xt } = Et;
    return fe({
      transport: er,
      message: xt,
      derivationPath: Dt
    });
  }
  babylon$1.signMessage = H;
  async function fe({ transport: Et, message: st, derivationPath: Dt = "m/86'/0'/0'" }) {
    return {
      signature: await new E.default(Et).signMessage(Buffer.from(st), `${Dt}/0/0`),
      protocol: F.MessageSigningProtocols.ECDSA
    };
  }
  async function ge({ transport: Et, message: st, addressType: Dt = F.AddressType.p2tr, derivationPath: er = "m/86'/0'/0'", isTestnet: xt = !1 }) {
    const ir = new E.default(Et);
    return Dt === F.AddressType.p2tr ? (0, x.createTaprootBip322Signature)({
      message: st,
      app: ir,
      derivationPath: er,
      isTestnet: xt
    }) : (0, x.createSegwitBip322Signature)({
      message: st,
      app: ir,
      derivationPath: er,
      isTestnet: xt
    });
  }
  function Ie(Et) {
    const st = Et instanceof Uint8Array ? t.base64.encode(Et) : Et, Dt = (0, v.getTaprootScript)(st);
    if (!Dt)
      throw new Error("The psbt does not contain a taproot script.");
    return (0, v.getLeafHash)(Dt);
  }
  babylon$1.computeLeafHash = Ie;
  function Ee(Et, st) {
    const Dt = Et instanceof Buffer ? Et : Buffer.from(Et, "hex");
    return (0, M.createExtendedPubkey)(st ? "Testnet" : "Mainnet", 0, Buffer.from("00000000", "hex"), 0, (0, g.createHash)("sha256").update(Dt).digest().subarray(0, 32), Buffer.concat([Buffer.from("02", "hex"), Dt]));
  }
  babylon$1.formatKey = Ee;
  async function Se(Et, st) {
    const Dt = new E.default(Et), er = await Dt.getMasterFingerprint(), xt = await Dt.getExtendedPubkey(st);
    return [er, xt];
  }
  function ze(Et) {
    if (!Et || Et.length === 0)
      throw new Error("Must provide at least one finality provider.");
    if (Et.length > 1)
      throw new Error("Currently only a single finality provider is supported.");
    return Et[0];
  }
  function He(Et, st) {
    if (Et < 2)
      throw new Error(`Invalid value for covenantThreshold: ${Et}. It should be greater than or equal to 2.`);
    const Dt = st ? st.length : 0;
    if (Dt < 2)
      throw new Error(`covenantPks must have at least 2 elements. Current length: ${Dt}`);
    if (Dt < Et)
      throw new Error(`The length of covenantPks (${Dt}) is less than the required covenantThreshold (${Et}).`);
    if (new Set(st).size < Dt)
      throw new Error("All covenantPks must be unique");
    return st.map((er) => Buffer.from(er, "hex")).sort(Buffer.compare).map((er) => er.toString("hex"));
  }
  async function Pe({ policyName: Et = "Consent to slashing", transport: st, params: Dt, derivationPath: er, displayLeafHash: xt = !0, isTestnet: ir = !1 }) {
    er = er || `m/86'/${ir ? 1 : 0}'/0'`;
    const { leafHash: sr, timelockBlocks: yr, finalityProviders: wr, covenantThreshold: qr, covenantPks: Mr, slashingPkScriptHex: Dr, slashingFeeSat: Qr } = Dt, [Xr, Vr] = await Se(st, er), Ur = [], Sr = xt ? F.MagicCode.LEAFHASH_DISPLAY_FP : F.MagicCode.LEAFHASH_CHECK_ONLY_FP;
    Ur.push(`[${er.replace("m/", `${Sr}/`)}]${Ee(sr, ir)}`), Ur.push(`[${er.replace("m/", `${Xr}/`)}]${Vr}`);
    const Gr = ze(wr);
    Ur.push(`[${er.replace("m/", `${F.MagicCode.FINALITY_PUB_FP}/`)}]${Ee(Gr, ir)}`);
    const Fr = He(qr, Mr), br = Fr.length;
    for (let cr = 0; cr < br; cr++) {
      const hr = Fr[cr];
      Ur.push(Ee(hr, ir));
    }
    Ur.push(Ee(Dr.padEnd(64, "0"), ir)), Ur.push(Ee((0, B.numberToLE)(Qr), ir));
    const Ar = `tr(@0/**,and_v(and_v(pk_k(@1/**),and_v(pk_k(@2/**),multi_a(${qr},${Array.from({ length: br }, (cr, hr) => hr).map((cr) => `@${3 + cr}/**`).join(",")},@${3 + br}/**,@${3 + br + 1}/**))),older(${yr})))`;
    return new D.WalletPolicy(Et, Ar, Ur);
  }
  babylon$1.slashingPathPolicy = Pe;
  async function De({ policyName: Et = "Unbonding", transport: st, params: Dt, derivationPath: er, displayLeafHash: xt = !0, isTestnet: ir = !1 }) {
    er = er || `m/86'/${ir ? 1 : 0}'/0'`;
    const { leafHash: sr, timelockBlocks: yr, finalityProviders: wr, covenantThreshold: qr, covenantPks: Mr, unbondingFeeSat: Dr } = Dt, [Qr, Xr] = await Se(st, er), Vr = [], Ur = xt ? F.MagicCode.LEAFHASH_DISPLAY_FP : F.MagicCode.LEAFHASH_CHECK_ONLY_FP;
    Vr.push(`[${er.replace("m/", `${Ur}/`)}]${Ee(sr, ir)}`), Vr.push(`[${er.replace("m/", `${Qr}/`)}]${Xr}`);
    const Sr = ze(wr);
    Vr.push(`[${er.replace("m/", `${F.MagicCode.FINALITY_PUB_FP}/`)}]${Ee(Sr, ir)}`);
    const Gr = He(qr, Mr), Fr = Gr.length;
    for (let Ar = 0; Ar < Fr; Ar++) {
      const cr = Gr[Ar];
      Vr.push(Ee(cr, ir));
    }
    Vr.push(Ee((0, B.numberToLE)(Dr), ir));
    const br = `tr(@0/**,and_v(and_v(pk_k(@1/**),and_v(pk_k(@2/**),multi_a(${qr},${Array.from({ length: Fr }, (Ar, cr) => cr).map((Ar) => `@${3 + Ar}/**`).join(",")},@${3 + Fr}/**))),older(${yr})))`;
    return new D.WalletPolicy(Et, br, Vr);
  }
  babylon$1.unbondingPathPolicy = De;
  async function ve({ policyName: Et = "Withdraw", transport: st, params: Dt, derivationPath: er, displayLeafHash: xt = !0, isTestnet: ir = !1 }) {
    er = er || `m/86'/${ir ? 1 : 0}'/0'`;
    const { leafHash: sr, timelockBlocks: yr } = Dt, [wr, qr] = await Se(st, er), Mr = [], Dr = xt ? F.MagicCode.LEAFHASH_DISPLAY_FP : F.MagicCode.LEAFHASH_CHECK_ONLY_FP;
    Mr.push(`[${er.replace("m/", `${Dr}/`)}]${Ee(sr, ir)}`), Mr.push(`[${er.replace("m/", `${wr}/`)}]${qr}`);
    const Qr = `tr(@0/**,and_v(pk_k(@1/**),older(${yr})))`;
    return new D.WalletPolicy(Et, Qr, Mr);
  }
  babylon$1.timelockPathPolicy = ve;
  async function Fe({ policyName: Et = "Staking transaction", transport: st, params: Dt, derivationPath: er, isTestnet: xt = !1 }) {
    er = er || `m/86'/${xt ? 1 : 0}'/0'`;
    const { timelockBlocks: ir, finalityProviders: sr, covenantThreshold: yr, covenantPks: wr } = Dt, [qr, Mr] = await Se(st, er), Dr = [];
    Dr.push("[69846d00/86'/1'/0']tpubD6NzVbkrYhZ4WLczPJWReQycCJdd6YVWXubbVUFnJ5KgU5MDQrD998ZJLSmaB7GVcCnJSDWprxmrGkJ6SvgQC6QAffVpqSvonXmeizXcrkN"), Dr.push(`[${er.replace("m/", `${qr}/`)}]${Mr}`);
    const Qr = ze(sr);
    Dr.push(`[${er.replace("m/", `${F.MagicCode.FINALITY_PUB_FP}/`)}]${Ee(Qr, xt)}`);
    const Xr = He(yr, wr), Vr = Xr.length;
    for (let Sr = 0; Sr < Vr; Sr++) {
      const Gr = Xr[Sr];
      Dr.push(Ee(Gr, xt));
    }
    const Ur = `tr(@0/**,and_v(and_v(pk_k(@1/**),and_v(pk_k(@2/**),multi_a(${yr},${Array.from({ length: Vr }, (Sr, Gr) => Gr).map((Sr) => `@${3 + Sr}/**`).join(",")}))),older(${ir})))`;
    return new D.WalletPolicy(Et, Ur, Dr);
  }
  babylon$1.stakingTxPolicy = Fe;
  const be = /^([a-f0-9]{64}) OP_CHECKSIGVERIFY OP_(0|[1-9]|1[0-6]) OP_CHECKSEQUENCEVERIFY$/, Be = /^([a-f0-9]{64}) OP_CHECKSIGVERIFY ([a-f0-9]{2,6}) OP_CHECKSEQUENCEVERIFY$/;
  function ke(Et) {
    var st, Dt;
    if (Et.length % 2 !== 0)
      throw new Error("Invalid timelock: odd-length hex string");
    return (Dt = (st = Et.match(/.{2}/g)) === null || st === void 0 ? void 0 : st.reverse().join("")) !== null && Dt !== void 0 ? Dt : "";
  }
  function xe(Et) {
    const st = Et.join(" ");
    let Dt = st.match(be);
    if (Dt) {
      const [, sr, yr] = Dt;
      return [sr, Number(yr).toString(16)];
    }
    if (Dt = st.match(Be), !Dt)
      return;
    const [er, xt, ir] = Dt;
    return [xt, ke(ir)];
  }
  async function Ne(Et, st, Dt = !1, er) {
    const xt = `m/86'/${Dt ? 1 : 0}'/0'`, ir = (0, v.getTaprootScript)(st);
    if (!ir)
      throw new Error("No script found in psbt");
    er = er || Ie(st);
    const sr = c.Script.decode(ir), yr = xe(sr);
    if (yr)
      return ve({
        transport: Et,
        params: {
          leafHash: er,
          timelockBlocks: +`0x${yr[yr.length - 1]}`
        },
        derivationPath: xt,
        isTestnet: Dt
      });
  }
  return babylon$1.tryParsePsbt = Ne, babylon$1;
}
var hasRequiredMain$1;
function requireMain$1() {
  return hasRequiredMain$1 || (hasRequiredMain$1 = 1, function(o) {
    var g = main$3 && main$3.__createBinding || (Object.create ? function(D, x, v, F) {
      F === void 0 && (F = v);
      var M = Object.getOwnPropertyDescriptor(x, v);
      (!M || ("get" in M ? !x.__esModule : M.writable || M.configurable)) && (M = { enumerable: !0, get: function() {
        return x[v];
      } }), Object.defineProperty(D, F, M);
    } : function(D, x, v, F) {
      F === void 0 && (F = v), D[F] = x[v];
    }), c = main$3 && main$3.__setModuleDefault || (Object.create ? function(D, x) {
      Object.defineProperty(D, "default", { enumerable: !0, value: x });
    } : function(D, x) {
      D.default = x;
    }), y = main$3 && main$3.__importStar || function(D) {
      if (D && D.__esModule) return D;
      var x = {};
      if (D != null) for (var v in D) v !== "default" && Object.prototype.hasOwnProperty.call(D, v) && g(x, D, v);
      return c(x, D), x;
    };
    Object.defineProperty(o, "__esModule", { value: !0 }), o.tryParsePsbt = o.signPsbt = o.stakingTxPolicy = o.timelockPathPolicy = o.unbondingPathPolicy = o.slashingPathPolicy = o.computeLeafHash = o.signMessage = o.PartialSignature = o.PsbtV2 = o.AppClient = o.WalletPolicy = o.DefaultWalletPolicy = void 0;
    const t = y(requireAppClient$1());
    o.AppClient = t.default, Object.defineProperty(o, "PartialSignature", { enumerable: !0, get: function() {
      return t.PartialSignature;
    } });
    const d = requirePolicy$1();
    Object.defineProperty(o, "DefaultWalletPolicy", { enumerable: !0, get: function() {
      return d.DefaultWalletPolicy;
    } }), Object.defineProperty(o, "WalletPolicy", { enumerable: !0, get: function() {
      return d.WalletPolicy;
    } });
    const E = requireBabylon$1();
    Object.defineProperty(o, "computeLeafHash", { enumerable: !0, get: function() {
      return E.computeLeafHash;
    } }), Object.defineProperty(o, "signMessage", { enumerable: !0, get: function() {
      return E.signMessage;
    } }), Object.defineProperty(o, "tryParsePsbt", { enumerable: !0, get: function() {
      return E.tryParsePsbt;
    } }), Object.defineProperty(o, "signPsbt", { enumerable: !0, get: function() {
      return E.signPsbt;
    } }), Object.defineProperty(o, "slashingPathPolicy", { enumerable: !0, get: function() {
      return E.slashingPathPolicy;
    } }), Object.defineProperty(o, "stakingTxPolicy", { enumerable: !0, get: function() {
      return E.stakingTxPolicy;
    } }), Object.defineProperty(o, "timelockPathPolicy", { enumerable: !0, get: function() {
      return E.timelockPathPolicy;
    } }), Object.defineProperty(o, "unbondingPathPolicy", { enumerable: !0, get: function() {
      return E.unbondingPathPolicy;
    } });
    const B = requirePsbtv2$1();
    Object.defineProperty(o, "PsbtV2", { enumerable: !0, get: function() {
      return B.PsbtV2;
    } }), o.default = t.default;
  }(main$3)), main$3;
}
var mainExports$1 = requireMain$1();
const AppClient$1 = /* @__PURE__ */ getDefaultExportFromCjs(mainExports$1);
var ActionName = /* @__PURE__ */ ((o) => (o.SIGN_BTC_STAKING_TRANSACTION = "sign-btc-staking-transaction", o.SIGN_BTC_STAKING_EXPANSION_TRANSACTION = "sign-btc-staking-expansion-transaction", o.SIGN_BTC_UNBONDING_TRANSACTION = "sign-btc-unbonding-transaction", o.SIGN_BTC_WITHDRAW_TRANSACTION = "sign-btc-withdraw-transaction", o.SIGN_BTC_SLASHING_TRANSACTION = "sign-btc-slashing-transaction", o.SIGN_BTC_UNBONDING_SLASHING_TRANSACTION = "sign-btc-unbonding-slashing-transaction", o))(ActionName || {});
const BABYLON_SIGNING_CONTRACTS = {
  STAKING: "babylon:staking",
  STAKING_EXPANSION: "babylon:staking-expansion",
  UNBONDING: "babylon:unbonding",
  SLASHING: "babylon:slashing",
  SLASHING_BURN: "babylon:slashing-burn",
  WITHDRAW: "babylon:withdraw"
}, sortPkHexes = (o) => o.map((g) => Buffer.from(g, "hex")).sort(Buffer.compare).map((g) => g.toString("hex")), UNBONDING_POLICY = "Unbonding", SLASHING_POLICY = "Consent to slashing", UNBONDING_SLASHING_POLICY = "Consent to unbonding slashing", STAKING_POLICY = "Staking transaction", WITHDRAWAL_POLICY = "Withdraw", getPolicyForTransaction$1 = async (o, g, c, y, {
  contracts: t,
  action: d
}) => {
  const E = g !== Network.MAINNET;
  switch (d.name) {
    case ActionName.SIGN_BTC_STAKING_TRANSACTION:
      return getStakingPolicy$1(t, c, o, E);
    case ActionName.SIGN_BTC_STAKING_EXPANSION_TRANSACTION:
      throw new Error("Staking expansion transactions are not yet supported on Ledger app.");
    case ActionName.SIGN_BTC_UNBONDING_TRANSACTION:
      return getUnbondingPolicy$1(t, c, o, E, y);
    case ActionName.SIGN_BTC_SLASHING_TRANSACTION:
      return getSlashingPolicy$1(t, c, o, E, y);
    case ActionName.SIGN_BTC_UNBONDING_SLASHING_TRANSACTION:
      return getUnbondingSlashingPolicy$1(t, c, o, E, y);
    case ActionName.SIGN_BTC_WITHDRAW_TRANSACTION:
      return getWithdrawPolicy$1(t, c, y, o, E);
    default:
      throw new Error(`Unknown action: ${d.name}`);
  }
}, getStakingPolicy$1 = (o, g, c, y) => {
  const t = o.find((x) => x.id === BABYLON_SIGNING_CONTRACTS.STAKING);
  if (!t)
    throw new Error("Staking contract is required");
  const { finalityProviders: d, covenantThreshold: E, covenantPks: B, stakingDuration: D } = t.params;
  return mainExports$1.stakingTxPolicy({
    policyName: STAKING_POLICY,
    transport: c,
    params: {
      finalityProviders: d,
      covenantThreshold: E,
      covenantPks: sortPkHexes(B),
      timelockBlocks: D
    },
    derivationPath: g,
    isTestnet: y
  });
}, getUnbondingPolicy$1 = (o, g, c, y, t) => {
  const d = o.find((M) => M.id === BABYLON_SIGNING_CONTRACTS.UNBONDING);
  if (!d)
    throw new Error("Unbonding contract is required");
  const E = mainExports$1.computeLeafHash(t);
  if (!E)
    throw new Error("Could not compute leaf hash");
  const { finalityProviders: B, covenantThreshold: D, covenantPks: x, unbondingTimeBlocks: v, unbondingFeeSat: F } = d.params;
  return mainExports$1.unbondingPathPolicy({
    policyName: UNBONDING_POLICY,
    transport: c,
    params: {
      finalityProviders: B,
      covenantThreshold: D,
      covenantPks: sortPkHexes(x),
      leafHash: E,
      timelockBlocks: v,
      unbondingFeeSat: F
    },
    derivationPath: g,
    isTestnet: y
  });
}, getSlashingPolicy$1 = (o, g, c, y, t) => {
  const d = o.find((H) => H.id === BABYLON_SIGNING_CONTRACTS.SLASHING);
  if (!d)
    throw new Error("Slashing contract is required in slashing transaction");
  const E = o.find((H) => H.id === BABYLON_SIGNING_CONTRACTS.STAKING);
  if (!E)
    throw new Error("Staking contract is required in slashing transaction");
  const B = o.find((H) => H.id === BABYLON_SIGNING_CONTRACTS.SLASHING_BURN);
  if (!B)
    throw new Error("Slashing burn contract is required in unbonding slashing transaction");
  const { unbondingTimeBlocks: D, slashingFeeSat: x } = d.params, { covenantPks: v, finalityProviders: F, covenantThreshold: M } = E.params, { slashingPkScriptHex: U } = B.params, L = mainExports$1.computeLeafHash(t);
  if (!L)
    throw new Error("Could not compute leaf hash");
  return mainExports$1.slashingPathPolicy({
    policyName: SLASHING_POLICY,
    transport: c,
    params: {
      leafHash: L,
      timelockBlocks: D,
      finalityProviders: F,
      covenantThreshold: M,
      covenantPks: sortPkHexes(v),
      slashingPkScriptHex: U,
      slashingFeeSat: x
    },
    derivationPath: g,
    isTestnet: y
  });
}, getUnbondingSlashingPolicy$1 = (o, g, c, y, t) => {
  const d = o.find((H) => H.id === BABYLON_SIGNING_CONTRACTS.SLASHING);
  if (!d)
    throw new Error("Slashing contract is required in unbonding slashing transaction");
  const E = o.find((H) => H.id === BABYLON_SIGNING_CONTRACTS.UNBONDING);
  if (!E)
    throw new Error("Unbonding contract is required in unbonding slashing transaction");
  const B = o.find((H) => H.id === BABYLON_SIGNING_CONTRACTS.SLASHING_BURN);
  if (!B)
    throw new Error("Slashing burn contract is required in unbonding slashing transaction");
  const { unbondingTimeBlocks: D, slashingFeeSat: x } = d.params, { covenantPks: v, finalityProviders: F, covenantThreshold: M } = E.params, { slashingPkScriptHex: U } = B.params, L = mainExports$1.computeLeafHash(t);
  if (!L)
    throw new Error("Could not compute leaf hash");
  return mainExports$1.slashingPathPolicy({
    policyName: UNBONDING_SLASHING_POLICY,
    transport: c,
    params: {
      leafHash: L,
      timelockBlocks: D,
      finalityProviders: F,
      covenantThreshold: M,
      covenantPks: sortPkHexes(v),
      slashingPkScriptHex: U,
      slashingFeeSat: x
    },
    derivationPath: g,
    isTestnet: y
  });
}, getWithdrawPolicy$1 = (o, g, c, y, t) => {
  const d = o.find((D) => D.id === BABYLON_SIGNING_CONTRACTS.WITHDRAW);
  if (!d)
    throw new Error("Withdraw timelock expired contract is required");
  const { timelockBlocks: E } = d.params, B = mainExports$1.computeLeafHash(c);
  if (!B)
    throw new Error("Could not compute leaf hash");
  return mainExports$1.timelockPathPolicy({
    policyName: WITHDRAWAL_POLICY,
    transport: y,
    params: {
      leafHash: B,
      timelockBlocks: E
    },
    derivationPath: g,
    isTestnet: t
  });
}, WALLET_PROVIDER_NAME$6 = "Ledger";
class LedgerProvider {
  constructor(g, c) {
    Vi(this, "ledgerWalletInfo");
    Vi(this, "config");
    Vi(this, "connectWallet", async () => {
      const g = await this.createAppClient(), c = await g.getMasterFingerprint(), y = this.getDerivationPath(), t = await g.getExtendedPubkey(y), d = await this.getWalletPolicy(g, c, y);
      if (!d) throw new Error("Could not retrieve the policy");
      const { address: E, publicKeyHex: B } = await this.getTaprootAccount(
        g,
        d,
        t
      );
      this.ledgerWalletInfo = {
        app: g,
        policy: d,
        mfp: c,
        extendedPublicKey: t,
        path: y,
        address: E,
        publicKeyHex: B
      };
    });
    Vi(this, "getAddress", async () => {
      var g;
      if (!((g = this.ledgerWalletInfo) != null && g.address)) throw new Error("Could not retrieve the address");
      return this.ledgerWalletInfo.address;
    });
    Vi(this, "getPublicKeyHex", async () => {
      var g;
      if (!((g = this.ledgerWalletInfo) != null && g.publicKeyHex)) throw new Error("Could not retrieve the BTC public key");
      return this.ledgerWalletInfo.publicKeyHex;
    });
    Vi(this, "signPsbt", async (g, c) => {
      var x, v, F;
      if (!((x = this.ledgerWalletInfo) != null && x.address) || !((v = this.ledgerWalletInfo) != null && v.publicKeyHex))
        throw new Error("Ledger is not connected");
      if (!g) throw new Error("psbt hex is required");
      const y = bufferExports.Buffer.from(g, "hex").toString("base64"), t = this.ledgerWalletInfo.app.transport;
      if (!t || !(t instanceof Transport))
        throw new Error("Transport is required to sign psbt");
      if (!this.ledgerWalletInfo.path)
        throw new Error("Derivation path is required to sign psbt");
      if (!(c != null && c.contracts) || (c == null ? void 0 : c.contracts.length) === 0)
        throw new Error("Contracts are required to sign psbt in ledger");
      if (!((F = c == null ? void 0 : c.action) != null && F.name))
        throw new Error("Action name is required to sign psbt in ledger");
      const d = await getPolicyForTransaction$1(
        t,
        this.config.network,
        this.ledgerWalletInfo.path,
        y,
        {
          contracts: c.contracts,
          action: c.action
        }
      ), E = await mainExports$1.signPsbt({
        transport: t,
        psbt: y,
        policy: d
      }), B = Transaction.fromPSBT(E.toPSBT(), {
        allowUnknownInputs: !0,
        allowUnknownOutputs: !0
      });
      return B.finalize(), bufferExports.Buffer.from(B.toPSBT()).toString("hex");
    });
    Vi(this, "signPsbts", async (g, c) => {
      var t, d, E;
      if (!((t = this.ledgerWalletInfo) != null && t.address) || !((d = this.ledgerWalletInfo) != null && d.publicKeyHex) || !((E = this.ledgerWalletInfo) != null && E.policy))
        throw new Error("Ledger is not connected");
      if (!g || !Array.isArray(g) || g.length === 0)
        throw new Error("psbts hexes are required");
      const y = [];
      for (let B = 0; B < g.length; B++) {
        const D = g[B], x = c ? c[B] : void 0;
        if (!D)
          throw new Error(`psbt hex at index ${B} is required`);
        if (typeof D != "string")
          throw new Error(`psbt hex at index ${B} must be a string`);
        const v = await this.signPsbt(D, x);
        y.push(v);
      }
      return y;
    });
    Vi(this, "getNetwork", async () => this.config.network);
    Vi(this, "signMessage", async (g, c) => {
      var d, E, B;
      if (!((d = this.ledgerWalletInfo) != null && d.app.transport) || !((E = this.ledgerWalletInfo) != null && E.path))
        throw new Error("Ledger is not connected");
      const y = this.config.network !== Network.MAINNET;
      return (await mainExports$1.signMessage({
        transport: (B = this.ledgerWalletInfo) == null ? void 0 : B.app.transport,
        message: g,
        type: c,
        isTestnet: y,
        derivationPath: this.ledgerWalletInfo.path
      })).signature;
    });
    Vi(this, "getInscriptions", async () => {
      throw new Error("Method not implemented.");
    });
    // Not implemented because of the hardware wallet nature
    Vi(this, "on", () => {
    });
    Vi(this, "off", () => {
    });
    Vi(this, "getWalletProviderName", async () => WALLET_PROVIDER_NAME$6);
    Vi(this, "getWalletProviderIcon", async () => logo$5);
    Vi(this, "deriveContextHash", unsupportedDeriveContextHash(WALLET_PROVIDER_NAME$6));
    this.config = c;
  }
  // Create a transport instance for Ledger devices
  // It first tries to create a WebUSB transport
  // and if that fails, it falls back to WebHID
  async createTransport() {
    try {
      return await TransportWebUSB.create();
    } catch (g) {
      try {
        return await TransportWebHID.create();
      } catch (c) {
        throw new Error(
          `Could not connect to Ledger device: ${g.message || g}, ${c.message || c}`
        );
      }
    }
  }
  // Get the network derivation index based on the network
  // 0 for MAINNET, 1 for TESTNET
  getNetworkDerivationIndex() {
    return this.config.network === Network.MAINNET ? 0 : 1;
  }
  getDerivationPath() {
    return `m/86'/${this.getNetworkDerivationIndex()}'/0'`;
  }
  // Create a new AppClient instance using the transport
  async createAppClient() {
    const g = await this.createTransport();
    return new AppClient$1(g);
  }
  async getWalletPolicy(g, c, y) {
    const t = await g.getExtendedPubkey(y);
    if (!t)
      throw new Error("Could not retrieve the extended public key for policy");
    const d = this.getNetworkDerivationIndex(), E = new mainExports$1.DefaultWalletPolicy("tr(@0/**)", `[${c}/86'/${d}'/0']${t}`);
    if (!E)
      throw new Error("Could not create the wallet policy");
    return E;
  }
  async getTaprootAccount(g, c, y) {
    const t = await g.getWalletAddress(
      c,
      null,
      0,
      // 0 - normal, 1 - change
      0,
      // address index
      !0
      // show address on the wallet's screen
    ), d = await this.getNetwork(), E = getPublicKeyFromXpub(y, "M/0/0", toNetwork(d));
    return { address: t, publicKeyHex: E.toString("hex") };
  }
}
const metadata$8 = {
  id: "ledger_btc",
  name: WALLET_PROVIDER_NAME$6,
  icon: logo$5,
  iconBackground: MONOCHROME_MARK_BACKGROUND,
  docs: "https://www.ledger.com/ledger-live",
  createProvider: (o, g) => new LedgerProvider(o, g),
  networks: [Network.SIGNET, Network.MAINNET],
  label: "Hardware wallet",
  hardware: !0
}, logo$4 = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='157'%20height='157'%3e%3cpath%20fill='%23FFFFFF'%20fill-rule='nonzero'%20d='M5%20106.655V143h55.308v-8.06h-47.25v-28.285H5Zm138.98%200v28.285H96.731v8.058h55.308v-36.343h-8.059Zm-83.592-55.31v55.308h36.343v-7.269H68.446V51.345h-8.058ZM5%2015v36.345h8.058V23.058h47.25V15H5Zm91.731%200v8.058h47.249v28.287h8.059V15H96.731Z'/%3e%3c/svg%3e";
var main = {}, appClient = {}, bip32 = {}, hasRequiredBip32;
function requireBip32() {
  if (hasRequiredBip32) return bip32;
  hasRequiredBip32 = 1;
  var o = bip32 && bip32.__importDefault || function(v) {
    return v && v.__esModule ? v : { default: v };
  };
  Object.defineProperty(bip32, "__esModule", { value: !0 }), bip32.hardenedPathOf = bip32.getXpubComponents = bip32.pubkeyFromXpub = bip32.pathStringToArray = bip32.pathArrayToString = bip32.bip32asBuffer = bip32.pathElementsToBuffer = void 0;
  const g = o(requireBip32Path()), c = o(requireBs58check());
  function y(v) {
    const F = Buffer.alloc(1 + v.length * 4);
    return F[0] = v.length, v.forEach((M, U) => {
      F.writeUInt32BE(M, 1 + 4 * U);
    }), F;
  }
  bip32.pathElementsToBuffer = y;
  function t(v) {
    const F = v ? E(v) : [];
    return y(F);
  }
  bip32.bip32asBuffer = t;
  function d(v) {
    return v.length == 0 ? "m" : g.default.fromPathArray(v).toString();
  }
  bip32.pathArrayToString = d;
  function E(v) {
    return v == "m" || v == "" ? [] : g.default.fromString(v).toPathArray();
  }
  bip32.pathStringToArray = E;
  function B(v) {
    const F = Buffer.from(c.default.decode(v));
    return F.slice(F.length - 33);
  }
  bip32.pubkeyFromXpub = B;
  function D(v) {
    const F = Buffer.from(c.default.decode(v));
    return {
      chaincode: F.slice(13, 45),
      pubkey: F.slice(F.length - 33),
      version: F.readUInt32BE(0)
    };
  }
  bip32.getXpubComponents = D;
  function x(v) {
    for (let F = v.length - 1; F >= 0; F--)
      if (v[F] >= 2147483648)
        return v.slice(0, F + 1);
    return [];
  }
  return bip32.hardenedPathOf = x, bip32;
}
var clientCommands = {}, buffertools = {}, varint = {}, hasRequiredVarint;
function requireVarint() {
  if (hasRequiredVarint) return varint;
  hasRequiredVarint = 1, Object.defineProperty(varint, "__esModule", { value: !0 }), varint.createVarint = varint.parseVarint = varint.sanitizeBigintToNumber = void 0;
  function o(E, B, D, x) {
    for (let v = 0; v < B; v++) {
      if (D[v + x] == null)
        throw Error("Buffer too small");
      D[v + x] = Number(E % BigInt(256)), E = E >> BigInt(8);
    }
  }
  function g(E, B, D) {
    let x = BigInt(0);
    for (let v = 0; v < D; v++) {
      if (E[v + B] == null)
        throw Error("Buffer too small");
      x += BigInt(E[v + B]) << BigInt(v * 8);
    }
    return x;
  }
  function c(E) {
    if (E < 0)
      throw RangeError("Negative bigint is not a valid varint");
    if (E > Number.MAX_SAFE_INTEGER)
      throw RangeError("Too large for a Number");
    return Number(E);
  }
  varint.sanitizeBigintToNumber = c;
  function y(E) {
    if (typeof E == "number" && (E = c(E)), E < BigInt(0))
      throw new RangeError("Negative numbers are not supported");
    if (E >= BigInt(1) << BigInt(64))
      throw new RangeError("Too large for a Bitcoin-style varint");
    return E < BigInt(253) ? 1 : E <= BigInt(65535) ? 3 : E <= BigInt(4294967295) ? 5 : 9;
  }
  function t(E, B) {
    if (B < 0)
      throw RangeError("Negative offset is invalid");
    if (E[B] == null)
      throw Error("Buffer too small");
    if (E[B] < 253)
      return [BigInt(E[B]), 1];
    {
      let D;
      return E[B] === 253 ? D = 2 : E[B] === 254 ? D = 4 : D = 8, [g(E, B + 1, D), D + 1];
    }
  }
  varint.parseVarint = t;
  function d(E) {
    typeof E == "number" && (E = c(E));
    const B = y(E);
    E = BigInt(E);
    const D = Buffer.alloc(B);
    return B == 1 ? D[0] = Number(E) : (B == 3 ? D[0] = 253 : B === 5 ? D[0] = 254 : D[0] = 255, o(E, B - 1, D, 1)), D;
  }
  return varint.createVarint = d, varint;
}
var hasRequiredBuffertools;
function requireBuffertools() {
  if (hasRequiredBuffertools) return buffertools;
  hasRequiredBuffertools = 1, Object.defineProperty(buffertools, "__esModule", { value: !0 }), buffertools.BufferReader = buffertools.BufferWriter = buffertools.numberToLE = buffertools.unsafeFrom64bitLE = buffertools.unsafeTo64bitLE = void 0;
  const o = requireVarint();
  function g(E) {
    if (E > Number.MAX_SAFE_INTEGER)
      throw new Error("Can't convert numbers > MAX_SAFE_INT");
    const B = Buffer.alloc(8, 0);
    for (let D = 0; D < B.length; D++) {
      const x = E & 255;
      B[D] = x, E = (E - x) / 256;
    }
    return B;
  }
  buffertools.unsafeTo64bitLE = g;
  function c(E) {
    let B = 0;
    if (E.length != 8)
      throw new Error("Expected Bufffer of lenght 8");
    if (E[7] != 0)
      throw new Error("Can't encode numbers > MAX_SAFE_INT");
    if (E[6] > 31)
      throw new Error("Can't encode numbers > MAX_SAFE_INT");
    for (let D = E.length - 1; D >= 0; D--)
      B = B * 256 + E[D];
    return B;
  }
  buffertools.unsafeFrom64bitLE = c;
  function y(E, B = 32) {
    if (!Number.isInteger(E) || E < 0)
      throw new RangeError("value must be a non-negative integer");
    if (!Number.isInteger(B) || B < 1)
      throw new RangeError("byteLen must be a positive integer");
    const D = Math.pow(256, B);
    if (E >= D)
      throw new RangeError(`value too large to fit in ${B} bytes (max ${D - 1})`);
    const x = Buffer.alloc(B);
    let v = E;
    for (let F = 0; F < B; F++)
      x[F] = v % 256, v = Math.floor(v / 256);
    return x;
  }
  buffertools.numberToLE = y;
  class t {
    constructor() {
      this.bufs = [];
    }
    write(B, D) {
      const x = Buffer.alloc(B);
      D(x), this.bufs.push(x);
    }
    writeUInt8(B) {
      this.write(1, (D) => D.writeUInt8(B, 0));
    }
    writeInt32(B) {
      this.write(4, (D) => D.writeInt32LE(B, 0));
    }
    writeUInt32(B) {
      this.write(4, (D) => D.writeUInt32LE(B, 0));
    }
    writeUInt64(B) {
      const D = g(B);
      this.writeSlice(D);
    }
    writeVarInt(B) {
      this.bufs.push((0, o.createVarint)(B));
    }
    writeSlice(B) {
      this.bufs.push(Buffer.from(B));
    }
    writeVarSlice(B) {
      this.writeVarInt(B.length), this.writeSlice(B);
    }
    buffer() {
      return Buffer.concat(this.bufs);
    }
  }
  buffertools.BufferWriter = t;
  class d {
    constructor(B, D = 0) {
      this.buffer = B, this.offset = D;
    }
    available() {
      return this.buffer.length - this.offset;
    }
    readUInt8() {
      const B = this.buffer.readUInt8(this.offset);
      return this.offset++, B;
    }
    readInt32() {
      const B = this.buffer.readInt32LE(this.offset);
      return this.offset += 4, B;
    }
    readUInt32() {
      const B = this.buffer.readUInt32LE(this.offset);
      return this.offset += 4, B;
    }
    readUInt64() {
      const B = this.readSlice(8);
      return c(B);
    }
    readVarInt() {
      const [B, D] = (0, o.parseVarint)(this.buffer, this.offset);
      return this.offset += D, B;
    }
    readSlice(B) {
      if (this.buffer.length < this.offset + B)
        throw new Error("Cannot read slice out of bounds");
      const D = this.buffer.slice(this.offset, this.offset + B);
      return this.offset += B, D;
    }
    readVarSlice() {
      const B = (0, o.sanitizeBigintToNumber)(this.readVarInt());
      return this.readSlice(B);
    }
    readVector() {
      const B = this.readVarInt(), D = [];
      for (let x = 0; x < B; x++)
        D.push(this.readVarSlice());
      return D;
    }
  }
  return buffertools.BufferReader = d, buffertools;
}
var merkle = {}, hasRequiredMerkle;
function requireMerkle() {
  if (hasRequiredMerkle) return merkle;
  hasRequiredMerkle = 1, Object.defineProperty(merkle, "__esModule", { value: !0 }), merkle.hashLeaf = merkle.Merkle = void 0;
  const o = require$$1;
  class g {
    constructor(x, v = o.crypto.sha256) {
      this.leaves = x, this.h = v;
      const F = this.calculateRoot(x);
      this.rootNode = F.root, this.leafNodes = F.leaves;
    }
    getRoot() {
      return this.rootNode.hash;
    }
    size() {
      return this.leaves.length;
    }
    getLeaves() {
      return this.leaves;
    }
    getLeafHash(x) {
      return this.leafNodes[x].hash;
    }
    getProof(x) {
      if (x >= this.leaves.length)
        throw Error("Index out of bounds");
      return d(this.leafNodes[x]);
    }
    calculateRoot(x) {
      const v = x.length;
      if (v == 0)
        return {
          root: new t(void 0, void 0, Buffer.alloc(32, 0)),
          leaves: []
        };
      if (v == 1) {
        const Ie = new t(void 0, void 0, x[0]);
        return { root: Ie, leaves: [Ie] };
      }
      const F = E(v), M = this.calculateRoot(x.slice(0, F)), U = this.calculateRoot(x.slice(F)), L = M.root, H = U.root, fe = this.hashNode(L.hash, H.hash), ge = new t(L, H, fe);
      return L.parent = ge, H.parent = ge, { root: ge, leaves: M.leaves.concat(U.leaves) };
    }
    hashNode(x, v) {
      return this.h(Buffer.concat([Buffer.from([1]), x, v]));
    }
  }
  merkle.Merkle = g;
  function c(D, x = o.crypto.sha256) {
    return y(Buffer.from([0]), D, x);
  }
  merkle.hashLeaf = c;
  function y(D, x, v) {
    return v(Buffer.concat([D, x]));
  }
  class t {
    constructor(x, v, F) {
      this.leftChild = x, this.rightChild = v, this.hash = F;
    }
    isLeaf() {
      return this.leftChild == null;
    }
  }
  function d(D) {
    if (!D.parent)
      return [];
    if (D.parent.leftChild == D) {
      if (!D.parent.rightChild)
        throw new Error("Expected right child to exist");
      return [D.parent.rightChild.hash, ...d(D.parent)];
    } else {
      if (!D.parent.leftChild)
        throw new Error("Expected left child to exist");
      return [D.parent.leftChild.hash, ...d(D.parent)];
    }
  }
  function E(D) {
    if (D < 2)
      throw Error("Expected n >= 2");
    return B(D) ? D / 2 : 1 << Math.floor(Math.log2(D));
  }
  function B(D) {
    return (D & D - 1) == 0;
  }
  return merkle;
}
var hasRequiredClientCommands;
function requireClientCommands() {
  if (hasRequiredClientCommands) return clientCommands;
  hasRequiredClientCommands = 1, Object.defineProperty(clientCommands, "__esModule", { value: !0 }), clientCommands.ClientCommandInterpreter = clientCommands.GetMoreElementsCommand = clientCommands.GetMerkleLeafIndexCommand = clientCommands.GetMerkleLeafProofCommand = clientCommands.GetPreimageCommand = clientCommands.YieldCommand = void 0;
  const o = require$$1, g = requireBuffertools(), c = requireMerkle(), y = requireVarint();
  var t;
  (function(M) {
    M[M.YIELD = 16] = "YIELD", M[M.GET_PREIMAGE = 64] = "GET_PREIMAGE", M[M.GET_MERKLE_LEAF_PROOF = 65] = "GET_MERKLE_LEAF_PROOF", M[M.GET_MERKLE_LEAF_INDEX = 66] = "GET_MERKLE_LEAF_INDEX", M[M.GET_MORE_ELEMENTS = 160] = "GET_MORE_ELEMENTS";
  })(t || (t = {}));
  class d {
  }
  class E extends d {
    constructor(U, L) {
      super(), this.progressCallback = L, this.code = t.YIELD, this.results = U;
    }
    execute(U) {
      return this.results.push(Buffer.from(U.subarray(1))), this.progressCallback && this.progressCallback(), Buffer.from("");
    }
  }
  clientCommands.YieldCommand = E;
  class B extends d {
    constructor(U, L) {
      super(), this.code = t.GET_PREIMAGE, this.known_preimages = U, this.queue = L;
    }
    execute(U) {
      const L = Buffer.from(U.subarray(1));
      if (L.length != 33)
        throw new Error("Invalid request, unexpected trailing data");
      if (L[0] != 0)
        throw new Error("Unsupported request, the first byte should be 0");
      const H = Buffer.alloc(32);
      for (let Ie = 0; Ie < 32; Ie++)
        H[Ie] = L[1 + Ie];
      const fe = H.toString("hex"), ge = this.known_preimages.get(fe);
      if (ge != null) {
        const Ie = (0, y.createVarint)(ge.length), Ee = 255 - Ie.length - 1, Se = Math.min(Ee, ge.length);
        if (Se < ge.length)
          for (let ze = Se; ze < ge.length; ze++)
            this.queue.push(Buffer.from([ge[ze]]));
        return Buffer.concat([
          Ie,
          Buffer.from([Se]),
          Buffer.from(ge.subarray(0, Se))
        ]);
      }
      throw Error(`Requested unknown preimage for: ${fe}`);
    }
  }
  clientCommands.GetPreimageCommand = B;
  class D extends d {
    constructor(U, L) {
      super(), this.code = t.GET_MERKLE_LEAF_PROOF, this.known_trees = U, this.queue = L;
    }
    execute(U) {
      const L = Buffer.from(U.subarray(1));
      if (L.length < 34)
        throw new Error("Invalid request, expected at least 34 bytes");
      const H = new g.BufferReader(L), ge = H.readSlice(32).toString("hex");
      let Ie, Ee;
      try {
        Ie = (0, y.sanitizeBigintToNumber)(H.readVarInt()), Ee = (0, y.sanitizeBigintToNumber)(H.readVarInt());
      } catch {
        throw new Error("Invalid request, couldn't parse tree_size or leaf_index");
      }
      const Se = this.known_trees.get(ge);
      if (!Se)
        throw Error(`Requested Merkle leaf proof for unknown tree: ${ge}`);
      if (Ee >= Ie || Se.size() != Ie)
        throw Error("Invalid index or tree size.");
      if (this.queue.length != 0)
        throw Error("This command should not execute when the queue is not empty.");
      const ze = Se.getProof(Ee), He = Math.min(Math.floor(221 / 32), ze.length), Pe = ze.length - He;
      return Pe > 0 && this.queue.push(...ze.slice(-Pe)), Buffer.concat([
        Se.getLeafHash(Ee),
        Buffer.from([ze.length]),
        Buffer.from([He]),
        ...ze.slice(0, He)
      ]);
    }
  }
  clientCommands.GetMerkleLeafProofCommand = D;
  class x extends d {
    constructor(U) {
      super(), this.code = t.GET_MERKLE_LEAF_INDEX, this.known_trees = U;
    }
    execute(U) {
      const L = Buffer.from(U.subarray(1));
      if (L.length != 64)
        throw new Error("Invalid request, unexpected trailing data");
      const H = Buffer.alloc(32);
      for (let He = 0; He < 32; He++)
        H[He] = L.readUInt8(He);
      const fe = H.toString("hex"), ge = Buffer.alloc(32);
      for (let He = 0; He < 32; He++)
        ge[He] = L.readUInt8(32 + He);
      const Ie = ge.toString("hex"), Ee = this.known_trees.get(fe);
      if (!Ee)
        throw Error(`Requested Merkle leaf index for unknown root: ${fe}`);
      let Se = 0, ze = 0;
      for (let He = 0; He < Ee.size(); He++)
        if (Ee.getLeafHash(He).toString("hex") == Ie) {
          ze = 1, Se = He;
          break;
        }
      return Buffer.concat([Buffer.from([ze]), (0, y.createVarint)(Se)]);
    }
  }
  clientCommands.GetMerkleLeafIndexCommand = x;
  class v extends d {
    constructor(U) {
      super(), this.code = t.GET_MORE_ELEMENTS, this.queue = U;
    }
    execute(U) {
      if (U.length != 1)
        throw new Error("Invalid request, unexpected trailing data");
      if (this.queue.length === 0)
        throw new Error("No elements to get");
      const L = this.queue[0].length;
      if (this.queue.some((Ie) => Ie.length != L))
        throw new Error("The queue contains elements with different byte length, which is not expected");
      const H = Math.floor(253 / L), fe = Math.min(H, this.queue.length), ge = this.queue.splice(0, fe);
      return Buffer.concat([
        Buffer.from([fe]),
        Buffer.from([L]),
        ...ge
      ]);
    }
  }
  clientCommands.GetMoreElementsCommand = v;
  class F {
    constructor(U) {
      this.roots = /* @__PURE__ */ new Map(), this.preimages = /* @__PURE__ */ new Map(), this.yielded = [], this.queue = [], this.commands = /* @__PURE__ */ new Map();
      const L = [
        new E(this.yielded, U),
        new B(this.preimages, this.queue),
        new x(this.roots),
        new D(this.roots, this.queue),
        new v(this.queue)
      ];
      for (const H of L) {
        if (this.commands.has(H.code))
          throw new Error(`Multiple commands with code ${H.code}`);
        this.commands.set(H.code, H);
      }
    }
    getYielded() {
      return this.yielded;
    }
    addKnownPreimage(U) {
      this.preimages.set(o.crypto.sha256(U).toString("hex"), U);
    }
    addKnownList(U) {
      for (const H of U) {
        const fe = Buffer.concat([Buffer.from([0]), H]);
        this.addKnownPreimage(fe);
      }
      const L = new c.Merkle(U.map((H) => (0, c.hashLeaf)(H)));
      this.roots.set(L.getRoot().toString("hex"), L);
    }
    addKnownMapping(U) {
      this.addKnownList(U.keys), this.addKnownList(U.values);
    }
    addKnownWalletPolicy(U) {
      this.addKnownPreimage(U.serialize()), this.addKnownList(U.keys.map((L) => Buffer.from(L, "ascii"))), this.addKnownPreimage(Buffer.from(U.descriptorTemplate));
    }
    execute(U) {
      if (U.length == 0)
        throw new Error("Unexpected empty command");
      const L = U[0], H = this.commands.get(L);
      if (!H)
        throw new Error(`Unexpected command code ${L}`);
      return H.execute(U);
    }
  }
  return clientCommands.ClientCommandInterpreter = F, clientCommands;
}
var merkelizedPsbt = {}, merkleMap = {}, hasRequiredMerkleMap;
function requireMerkleMap() {
  if (hasRequiredMerkleMap) return merkleMap;
  hasRequiredMerkleMap = 1, Object.defineProperty(merkleMap, "__esModule", { value: !0 }), merkleMap.MerkleMap = void 0;
  const o = requireMerkle(), g = requireVarint();
  class c {
    /**
     * @param keys Sorted list of (unhashed) keys
     * @param values values, in corresponding order as the keys, and of equal length
     */
    constructor(t, d) {
      if (t.length != d.length)
        throw new Error("keys and values should have the same length");
      for (let E = 0; E < t.length - 1; E++)
        if (t[E].toString("hex") >= t[E + 1].toString("hex"))
          throw new Error("keys must be in strictly increasing order");
      this.keys = t, this.keysTree = new o.Merkle(t.map((E) => (0, o.hashLeaf)(E))), this.values = d, this.valuesTree = new o.Merkle(d.map((E) => (0, o.hashLeaf)(E)));
    }
    commitment() {
      return Buffer.concat([
        (0, g.createVarint)(this.keys.length),
        this.keysTree.getRoot(),
        this.valuesTree.getRoot()
      ]);
    }
  }
  return merkleMap.MerkleMap = c, merkleMap;
}
var psbtv2 = {}, hasRequiredPsbtv2;
function requirePsbtv2() {
  return hasRequiredPsbtv2 || (hasRequiredPsbtv2 = 1, function(o) {
    var g = psbtv2 && psbtv2.__createBinding || (Object.create ? function(De, ve, Fe, be) {
      be === void 0 && (be = Fe);
      var Be = Object.getOwnPropertyDescriptor(ve, Fe);
      (!Be || ("get" in Be ? !ve.__esModule : Be.writable || Be.configurable)) && (Be = { enumerable: !0, get: function() {
        return ve[Fe];
      } }), Object.defineProperty(De, be, Be);
    } : function(De, ve, Fe, be) {
      be === void 0 && (be = Fe), De[be] = ve[Fe];
    }), c = psbtv2 && psbtv2.__setModuleDefault || (Object.create ? function(De, ve) {
      Object.defineProperty(De, "default", { enumerable: !0, value: ve });
    } : function(De, ve) {
      De.default = ve;
    }), y = psbtv2 && psbtv2.__importStar || function(De) {
      if (De && De.__esModule) return De;
      var ve = {};
      if (De != null) for (var Fe in De) Fe !== "default" && Object.prototype.hasOwnProperty.call(De, Fe) && g(ve, De, Fe);
      return c(ve, De), ve;
    };
    Object.defineProperty(o, "__esModule", { value: !0 }), o.PsbtV2 = o.NoSuchEntry = o.psbtOut = o.psbtIn = o.psbtGlobal = void 0;
    const t = y(require$$1), d = requireBuffertools(), E = requireVarint();
    var B;
    (function(De) {
      De[De.UNSIGNED_TX = 0] = "UNSIGNED_TX", De[De.XPUB = 1] = "XPUB", De[De.TX_VERSION = 2] = "TX_VERSION", De[De.FALLBACK_LOCKTIME = 3] = "FALLBACK_LOCKTIME", De[De.INPUT_COUNT = 4] = "INPUT_COUNT", De[De.OUTPUT_COUNT = 5] = "OUTPUT_COUNT", De[De.TX_MODIFIABLE = 6] = "TX_MODIFIABLE", De[De.VERSION = 251] = "VERSION";
    })(B = o.psbtGlobal || (o.psbtGlobal = {}));
    var D;
    (function(De) {
      De[De.NON_WITNESS_UTXO = 0] = "NON_WITNESS_UTXO", De[De.WITNESS_UTXO = 1] = "WITNESS_UTXO", De[De.PARTIAL_SIG = 2] = "PARTIAL_SIG", De[De.SIGHASH_TYPE = 3] = "SIGHASH_TYPE", De[De.REDEEM_SCRIPT = 4] = "REDEEM_SCRIPT", De[De.WITNESS_SCRIPT = 5] = "WITNESS_SCRIPT", De[De.BIP32_DERIVATION = 6] = "BIP32_DERIVATION", De[De.FINAL_SCRIPTSIG = 7] = "FINAL_SCRIPTSIG", De[De.FINAL_SCRIPTWITNESS = 8] = "FINAL_SCRIPTWITNESS", De[De.PREVIOUS_TXID = 14] = "PREVIOUS_TXID", De[De.OUTPUT_INDEX = 15] = "OUTPUT_INDEX", De[De.SEQUENCE = 16] = "SEQUENCE", De[De.TAP_KEY_SIG = 19] = "TAP_KEY_SIG", De[De.TAP_BIP32_DERIVATION = 22] = "TAP_BIP32_DERIVATION";
    })(D = o.psbtIn || (o.psbtIn = {}));
    var x;
    (function(De) {
      De[De.REDEEM_SCRIPT = 0] = "REDEEM_SCRIPT", De[De.WITNESS_SCRIPT = 1] = "WITNESS_SCRIPT", De[De.BIP_32_DERIVATION = 2] = "BIP_32_DERIVATION", De[De.AMOUNT = 3] = "AMOUNT", De[De.SCRIPT = 4] = "SCRIPT", De[De.TAP_BIP32_DERIVATION = 7] = "TAP_BIP32_DERIVATION";
    })(x = o.psbtOut || (o.psbtOut = {}));
    const v = Buffer.from([112, 115, 98, 116, 255]);
    class F extends Error {
    }
    o.NoSuchEntry = F;
    class M {
      constructor() {
        this.globalMap = /* @__PURE__ */ new Map(), this.inputMaps = [], this.outputMaps = [];
      }
      setGlobalTxVersion(ve) {
        this.setGlobal(B.TX_VERSION, Se(ve));
      }
      getGlobalTxVersion() {
        return this.getGlobal(B.TX_VERSION).readUInt32LE(0);
      }
      setGlobalFallbackLocktime(ve) {
        this.setGlobal(B.FALLBACK_LOCKTIME, Se(ve));
      }
      getGlobalFallbackLocktime() {
        var ve;
        return (ve = this.getGlobalOptional(B.FALLBACK_LOCKTIME)) === null || ve === void 0 ? void 0 : ve.readUInt32LE(0);
      }
      setGlobalInputCount(ve) {
        this.setGlobal(B.INPUT_COUNT, He(ve));
      }
      getGlobalInputCount() {
        return Pe(this.getGlobal(B.INPUT_COUNT));
      }
      setGlobalOutputCount(ve) {
        this.setGlobal(B.OUTPUT_COUNT, He(ve));
      }
      getGlobalOutputCount() {
        return Pe(this.getGlobal(B.OUTPUT_COUNT));
      }
      setGlobalTxModifiable(ve) {
        this.setGlobal(B.TX_MODIFIABLE, ve);
      }
      getGlobalTxModifiable() {
        return this.getGlobalOptional(B.TX_MODIFIABLE);
      }
      setGlobalPsbtVersion(ve) {
        this.setGlobal(B.VERSION, Se(ve));
      }
      getGlobalPsbtVersion() {
        return this.getGlobal(B.VERSION).readUInt32LE(0);
      }
      setInputNonWitnessUtxo(ve, Fe) {
        this.setInput(ve, D.NON_WITNESS_UTXO, Ie(), Fe);
      }
      getInputNonWitnessUtxo(ve) {
        return this.getInputOptional(ve, D.NON_WITNESS_UTXO, Ie());
      }
      setInputWitnessUtxo(ve, Fe, be) {
        const Be = new d.BufferWriter();
        Be.writeSlice(ze(Fe)), Be.writeVarSlice(be), this.setInput(ve, D.WITNESS_UTXO, Ie(), Be.buffer());
      }
      getInputWitnessUtxo(ve) {
        const Fe = this.getInputOptional(ve, D.WITNESS_UTXO, Ie());
        if (!Fe)
          return;
        const be = new d.BufferReader(Fe);
        return {
          amount: (0, d.unsafeFrom64bitLE)(be.readSlice(8)),
          scriptPubKey: be.readVarSlice()
        };
      }
      setInputPartialSig(ve, Fe, be) {
        this.setInput(ve, D.PARTIAL_SIG, Fe, be);
      }
      getInputPartialSig(ve, Fe) {
        return this.getInputOptional(ve, D.PARTIAL_SIG, Fe);
      }
      setInputSighashType(ve, Fe) {
        this.setInput(ve, D.SIGHASH_TYPE, Ie(), Se(Fe));
      }
      getInputSighashType(ve) {
        const Fe = this.getInputOptional(ve, D.SIGHASH_TYPE, Ie());
        if (Fe)
          return Fe.readUInt32LE(0);
      }
      setInputRedeemScript(ve, Fe) {
        this.setInput(ve, D.REDEEM_SCRIPT, Ie(), Fe);
      }
      getInputRedeemScript(ve) {
        return this.getInputOptional(ve, D.REDEEM_SCRIPT, Ie());
      }
      setInputWitnessScript(ve, Fe) {
        this.setInput(ve, D.WITNESS_SCRIPT, Ie(), Fe);
      }
      getInputWitnessScript(ve) {
        return this.getInputOptional(ve, D.WITNESS_SCRIPT, Ie());
      }
      setInputBip32Derivation(ve, Fe, be, Be) {
        if (Fe.length != 33)
          throw new Error("Invalid pubkey length: " + Fe.length);
        this.setInput(ve, D.BIP32_DERIVATION, Fe, this.encodeBip32Derivation(be, Be));
      }
      getInputBip32Derivation(ve, Fe) {
        const be = this.getInputOptional(ve, D.BIP32_DERIVATION, Fe);
        if (be)
          return this.decodeBip32Derivation(be);
      }
      setInputFinalScriptsig(ve, Fe) {
        this.setInput(ve, D.FINAL_SCRIPTSIG, Ie(), Fe);
      }
      getInputFinalScriptsig(ve) {
        return this.getInputOptional(ve, D.FINAL_SCRIPTSIG, Ie());
      }
      setInputFinalScriptwitness(ve, Fe) {
        this.setInput(ve, D.FINAL_SCRIPTWITNESS, Ie(), Fe);
      }
      getInputFinalScriptwitness(ve) {
        return this.getInput(ve, D.FINAL_SCRIPTWITNESS, Ie());
      }
      setInputPreviousTxId(ve, Fe) {
        this.setInput(ve, D.PREVIOUS_TXID, Ie(), Fe);
      }
      getInputPreviousTxid(ve) {
        return this.getInput(ve, D.PREVIOUS_TXID, Ie());
      }
      setInputOutputIndex(ve, Fe) {
        this.setInput(ve, D.OUTPUT_INDEX, Ie(), Se(Fe));
      }
      getInputOutputIndex(ve) {
        return this.getInput(ve, D.OUTPUT_INDEX, Ie()).readUInt32LE(0);
      }
      setInputSequence(ve, Fe) {
        this.setInput(ve, D.SEQUENCE, Ie(), Se(Fe));
      }
      getInputSequence(ve) {
        var Fe, be;
        return (be = (Fe = this.getInputOptional(ve, D.SEQUENCE, Ie())) === null || Fe === void 0 ? void 0 : Fe.readUInt32LE(0)) !== null && be !== void 0 ? be : 4294967295;
      }
      setInputTapKeySig(ve, Fe) {
        this.setInput(ve, D.TAP_KEY_SIG, Ie(), Fe);
      }
      getInputTapKeySig(ve) {
        return this.getInputOptional(ve, D.TAP_KEY_SIG, Ie());
      }
      setInputTapBip32Derivation(ve, Fe, be, Be, ke) {
        if (Fe.length != 32)
          throw new Error("Invalid pubkey length: " + Fe.length);
        const xe = this.encodeTapBip32Derivation(be, Be, ke);
        this.setInput(ve, D.TAP_BIP32_DERIVATION, Fe, xe);
      }
      getInputTapBip32Derivation(ve, Fe) {
        const be = this.getInput(ve, D.TAP_BIP32_DERIVATION, Fe);
        return this.decodeTapBip32Derivation(be);
      }
      getInputKeyDatas(ve, Fe) {
        return this.getKeyDatas(this.inputMaps[ve], Fe);
      }
      setOutputRedeemScript(ve, Fe) {
        this.setOutput(ve, x.REDEEM_SCRIPT, Ie(), Fe);
      }
      getOutputRedeemScript(ve) {
        return this.getOutput(ve, x.REDEEM_SCRIPT, Ie());
      }
      setOutputBip32Derivation(ve, Fe, be, Be) {
        this.setOutput(ve, x.BIP_32_DERIVATION, Fe, this.encodeBip32Derivation(be, Be));
      }
      getOutputBip32Derivation(ve, Fe) {
        const be = this.getOutput(ve, x.BIP_32_DERIVATION, Fe);
        return this.decodeBip32Derivation(be);
      }
      setOutputAmount(ve, Fe) {
        this.setOutput(ve, x.AMOUNT, Ie(), ze(Fe));
      }
      getOutputAmount(ve) {
        const Fe = this.getOutput(ve, x.AMOUNT, Ie());
        return (0, d.unsafeFrom64bitLE)(Fe);
      }
      setOutputScript(ve, Fe) {
        this.setOutput(ve, x.SCRIPT, Ie(), Fe);
      }
      getOutputScript(ve) {
        return this.getOutput(ve, x.SCRIPT, Ie());
      }
      setOutputTapBip32Derivation(ve, Fe, be, Be, ke) {
        const xe = this.encodeTapBip32Derivation(be, Be, ke);
        this.setOutput(ve, x.TAP_BIP32_DERIVATION, Fe, xe);
      }
      getOutputTapBip32Derivation(ve, Fe) {
        const be = this.getOutput(ve, x.TAP_BIP32_DERIVATION, Fe);
        return this.decodeTapBip32Derivation(be);
      }
      deleteInputEntries(ve, Fe) {
        this.inputMaps[ve].forEach((Be, ke, xe) => {
          this.isKeyType(ke, Fe) && xe.delete(ke);
        });
      }
      copy(ve) {
        this.copyMap(this.globalMap, ve.globalMap), this.copyMaps(this.inputMaps, ve.inputMaps), this.copyMaps(this.outputMaps, ve.outputMaps);
      }
      copyMaps(ve, Fe) {
        ve.forEach((be, Be) => {
          const ke = /* @__PURE__ */ new Map();
          this.copyMap(be, ke), Fe[Be] = ke;
        });
      }
      copyMap(ve, Fe) {
        ve.forEach((be, Be) => Fe.set(Be, Buffer.from(be)));
      }
      serialize() {
        const ve = new d.BufferWriter();
        return ve.writeSlice(v), ge(ve, this.globalMap), this.inputMaps.forEach((Fe) => {
          ge(ve, Fe);
        }), this.outputMaps.forEach((Fe) => {
          ge(ve, Fe);
        }), ve.buffer();
      }
      deserialize(ve) {
        const Fe = new d.BufferReader(ve);
        if (!Fe.readSlice(5).equals(v))
          throw new Error("Invalid magic bytes");
        for (; this.readKeyPair(this.globalMap, Fe); )
          ;
        let be;
        try {
          be = this.getGlobalPsbtVersion();
        } catch {
          be = 0;
        }
        if (be !== 0 && be !== 2)
          throw new Error("Only PSBTs of version 0 or 2 are supported");
        let Be, ke;
        if (be == 0) {
          const xe = this.getGlobal(B.UNSIGNED_TX), Ne = t.Transaction.fromBuffer(xe);
          Be = Ne.ins.length, ke = Ne.outs.length;
        } else
          Be = this.getGlobalInputCount(), ke = this.getGlobalOutputCount();
        for (let xe = 0; xe < Be; xe++)
          for (this.inputMaps[xe] = /* @__PURE__ */ new Map(); this.readKeyPair(this.inputMaps[xe], Fe); )
            ;
        for (let xe = 0; xe < ke; xe++)
          for (this.outputMaps[xe] = /* @__PURE__ */ new Map(); this.readKeyPair(this.outputMaps[xe], Fe); )
            ;
        this.normalizeToV2();
      }
      normalizeToV2() {
        var ve;
        const Fe = (ve = this.getGlobalOptional(B.VERSION)) === null || ve === void 0 ? void 0 : ve.readInt32LE(0);
        if (Fe === 2)
          return;
        if (Fe !== void 0)
          throw new Error("Invalid or unsupported value for PSBT_GLOBAL_VERSION");
        const be = this.getGlobal(B.UNSIGNED_TX), Be = t.Transaction.fromBuffer(be);
        this.setGlobalPsbtVersion(2), this.setGlobalTxVersion(Be.version), this.setGlobalFallbackLocktime(Be.locktime), this.setGlobalInputCount(Be.ins.length), this.setGlobalOutputCount(Be.outs.length);
        for (let ke = 0; ke < Be.ins.length; ke++)
          this.setInputPreviousTxId(ke, Be.ins[ke].hash), this.setInputOutputIndex(ke, Be.ins[ke].index), this.setInputSequence(ke, Be.ins[ke].sequence);
        for (let ke = 0; ke < Be.outs.length; ke++)
          this.setOutputAmount(ke, Be.outs[ke].value), this.setOutputScript(ke, Be.outs[ke].script);
        this.globalMap.delete(B.UNSIGNED_TX.toString(16).padStart(2, "0"));
      }
      /**
       * Imports a BitcoinJS (bitcoinjs-lib) Psbt object.
       * https://github.com/bitcoinjs/bitcoinjs-lib/blob/master/ts_src/psbt.ts
       *
       * Prepares the fields required for signing a Psbt on a Ledger
       * device. It should be used exclusively before calling
       * `appClient.signPsbt()` and not as a general Psbt conversion method.
       *
       * Note: This method supports all the policies that the Ledger is able to
       * sign, with the exception of taproot: tr(@0).
       */
      fromBitcoinJS(ve) {
        function Fe(be) {
          let Be;
          try {
            t.payments.p2tr({ output: be.witnessUtxo.script }), Be = !0;
          } catch {
            Be = !1;
          }
          return be && !!(be.tapInternalKey || be.tapMerkleRoot || be.tapLeafScript && be.tapLeafScript.length || be.tapBip32Derivation && be.tapBip32Derivation.length || Be);
        }
        return this.setGlobalPsbtVersion(2), this.setGlobalTxVersion(ve.version), this.setGlobalInputCount(ve.data.inputs.length), this.setGlobalOutputCount(ve.txOutputs.length), ve.locktime !== void 0 && this.setGlobalFallbackLocktime(ve.locktime), ve.data.inputs.forEach((be, Be) => {
          if (Fe(be))
            throw new Error("Taproot inputs not supported");
          this.setInputPreviousTxId(Be, ve.txInputs[Be].hash), ve.txInputs[Be].sequence !== void 0 && this.setInputSequence(Be, ve.txInputs[Be].sequence), this.setInputOutputIndex(Be, ve.txInputs[Be].index), be.sighashType !== void 0 && this.setInputSighashType(Be, be.sighashType), be.nonWitnessUtxo && this.setInputNonWitnessUtxo(Be, be.nonWitnessUtxo), be.witnessUtxo && this.setInputWitnessUtxo(Be, be.witnessUtxo.value, be.witnessUtxo.script), be.witnessScript && this.setInputWitnessScript(Be, be.witnessScript), be.redeemScript && this.setInputRedeemScript(Be, be.redeemScript), ve.data.inputs[Be].bip32Derivation.forEach((ke) => {
            if (!/^m\//i.test(ke.path))
              throw new Error("Invalid input bip32 derivation");
            const xe = ke.path.replace(/m\//i, "").split("/").map((Ne) => Ne.match(/['h]/i) ? parseInt(Ne) + 2147483648 : Number(Ne));
            this.setInputBip32Derivation(Be, ke.pubkey, ke.masterFingerprint, xe);
          });
        }), ve.txOutputs.forEach((be, Be) => {
          this.setOutputAmount(Be, be.value), this.setOutputScript(Be, be.script);
        }), this;
      }
      readKeyPair(ve, Fe) {
        const be = (0, E.sanitizeBigintToNumber)(Fe.readVarInt());
        if (be == 0)
          return !1;
        const Be = Fe.readUInt8(), ke = Fe.readSlice(be - 1), xe = Fe.readVarSlice();
        return Ee(ve, Be, ke, xe), !0;
      }
      getKeyDatas(ve, Fe) {
        const be = [];
        return ve.forEach((Be, ke) => {
          this.isKeyType(ke, [Fe]) && be.push(Buffer.from(ke.substring(2), "hex"));
        }), be;
      }
      isKeyType(ve, Fe) {
        const be = Buffer.from(ve.substring(0, 2), "hex").readUInt8(0);
        return Fe.some((Be) => Be == be);
      }
      setGlobal(ve, Fe) {
        const be = new L(ve, Buffer.from([]));
        this.globalMap.set(be.toString(), Fe);
      }
      getGlobal(ve) {
        return U(this.globalMap, ve, Ie(), !1);
      }
      getGlobalOptional(ve) {
        return U(this.globalMap, ve, Ie(), !0);
      }
      setInput(ve, Fe, be, Be) {
        Ee(this.getMap(ve, this.inputMaps), Fe, be, Be);
      }
      getInput(ve, Fe, be) {
        return U(this.inputMaps[ve], Fe, be, !1);
      }
      getInputOptional(ve, Fe, be) {
        return U(this.inputMaps[ve], Fe, be, !0);
      }
      setOutput(ve, Fe, be, Be) {
        Ee(this.getMap(ve, this.outputMaps), Fe, be, Be);
      }
      getOutput(ve, Fe, be) {
        return U(this.outputMaps[ve], Fe, be, !1);
      }
      getMap(ve, Fe) {
        return Fe[ve] ? Fe[ve] : Fe[ve] = /* @__PURE__ */ new Map();
      }
      encodeBip32Derivation(ve, Fe) {
        const be = new d.BufferWriter();
        return this.writeBip32Derivation(be, ve, Fe), be.buffer();
      }
      decodeBip32Derivation(ve) {
        const Fe = new d.BufferReader(ve);
        return this.readBip32Derivation(Fe);
      }
      writeBip32Derivation(ve, Fe, be) {
        ve.writeSlice(Fe), be.forEach((Be) => {
          ve.writeUInt32(Be);
        });
      }
      readBip32Derivation(ve) {
        const Fe = ve.readSlice(4), be = [];
        for (; ve.offset < ve.buffer.length; )
          be.push(ve.readUInt32());
        return { masterFingerprint: Fe, path: be };
      }
      encodeTapBip32Derivation(ve, Fe, be) {
        const Be = new d.BufferWriter();
        return Be.writeVarInt(ve.length), ve.forEach((ke) => {
          Be.writeSlice(ke);
        }), this.writeBip32Derivation(Be, Fe, be), Be.buffer();
      }
      decodeTapBip32Derivation(ve) {
        const Fe = new d.BufferReader(ve), be = (0, E.sanitizeBigintToNumber)(Fe.readVarInt()), Be = [];
        for (let xe = 0; xe < be; xe++)
          Be.push(Fe.readSlice(32));
        const ke = this.readBip32Derivation(Fe);
        return Object.assign({ hashes: Be }, ke);
      }
    }
    o.PsbtV2 = M;
    function U(De, ve, Fe, be) {
      if (!De)
        throw Error("No such map");
      const Be = new L(ve, Fe), ke = De.get(Be.toString());
      if (!ke) {
        if (be)
          return;
        throw new F(Be.toString());
      }
      return Buffer.from(ke);
    }
    class L {
      constructor(ve, Fe) {
        this.keyType = ve, this.keyData = Fe;
      }
      toString() {
        const ve = new d.BufferWriter();
        return this.toBuffer(ve), ve.buffer().toString("hex");
      }
      serialize(ve) {
        ve.writeVarInt(1 + this.keyData.length), this.toBuffer(ve);
      }
      toBuffer(ve) {
        ve.writeUInt8(this.keyType), ve.writeSlice(this.keyData);
      }
    }
    class H {
      constructor(ve, Fe) {
        this.key = ve, this.value = Fe;
      }
      serialize(ve) {
        this.key.serialize(ve), ve.writeVarSlice(this.value);
      }
    }
    function fe(De) {
      return new L(De.readUInt8(0), De.slice(1));
    }
    function ge(De, ve) {
      for (let [Fe, be] of [...ve].sort(([Be], [ke]) => Be.localeCompare(ke)))
        new H(fe(Buffer.from(Fe, "hex")), be).serialize(De);
      De.writeUInt8(0);
    }
    function Ie() {
      return Buffer.from([]);
    }
    function Ee(De, ve, Fe, be) {
      const Be = new L(ve, Fe);
      De.set(Be.toString(), be);
    }
    function Se(De) {
      const ve = Buffer.alloc(4);
      return ve.writeUInt32LE(De, 0), ve;
    }
    function ze(De) {
      return (0, d.unsafeTo64bitLE)(De);
    }
    function He(De) {
      const ve = new d.BufferWriter();
      return ve.writeVarInt(De), ve.buffer();
    }
    function Pe(De) {
      return (0, E.sanitizeBigintToNumber)(new d.BufferReader(De).readVarInt());
    }
  }(psbtv2)), psbtv2;
}
var hasRequiredMerkelizedPsbt;
function requireMerkelizedPsbt() {
  if (hasRequiredMerkelizedPsbt) return merkelizedPsbt;
  hasRequiredMerkelizedPsbt = 1, Object.defineProperty(merkelizedPsbt, "__esModule", { value: !0 }), merkelizedPsbt.MerkelizedPsbt = void 0;
  const o = requireMerkleMap(), g = requirePsbtv2();
  class c extends g.PsbtV2 {
    constructor(t) {
      super(), this.inputMerkleMaps = [], this.outputMerkleMaps = [], t.copy(this), this.globalMerkleMap = c.createMerkleMap(this.globalMap);
      for (let d = 0; d < this.getGlobalInputCount(); d++)
        this.inputMerkleMaps.push(c.createMerkleMap(this.inputMaps[d]));
      this.inputMapCommitments = [...this.inputMerkleMaps.values()].map((d) => d.commitment());
      for (let d = 0; d < this.getGlobalOutputCount(); d++)
        this.outputMerkleMaps.push(c.createMerkleMap(this.outputMaps[d]));
      this.outputMapCommitments = [...this.outputMerkleMaps.values()].map((d) => d.commitment());
    }
    // These public functions are for MerkelizedPsbt.
    getGlobalSize() {
      return this.globalMap.size;
    }
    getGlobalKeysValuesRoot() {
      return this.globalMerkleMap.commitment();
    }
    static createMerkleMap(t) {
      const d = [...t.keys()].sort(), E = d.map((D) => {
        const x = t.get(D);
        if (!x)
          throw new Error("No value for key " + D);
        return x;
      }), B = d.map((D) => Buffer.from(D, "hex"));
      return new o.MerkleMap(B, E);
    }
  }
  return merkelizedPsbt.MerkelizedPsbt = c, merkelizedPsbt;
}
var hasRequiredAppClient;
function requireAppClient() {
  if (hasRequiredAppClient) return appClient;
  hasRequiredAppClient = 1;
  var o = appClient && appClient.__createBinding || (Object.create ? function(De, ve, Fe, be) {
    be === void 0 && (be = Fe);
    var Be = Object.getOwnPropertyDescriptor(ve, Fe);
    (!Be || ("get" in Be ? !ve.__esModule : Be.writable || Be.configurable)) && (Be = { enumerable: !0, get: function() {
      return ve[Fe];
    } }), Object.defineProperty(De, be, Be);
  } : function(De, ve, Fe, be) {
    be === void 0 && (be = Fe), De[be] = ve[Fe];
  }), g = appClient && appClient.__setModuleDefault || (Object.create ? function(De, ve) {
    Object.defineProperty(De, "default", { enumerable: !0, value: ve });
  } : function(De, ve) {
    De.default = ve;
  }), c = appClient && appClient.__importStar || function(De) {
    if (De && De.__esModule) return De;
    var ve = {};
    if (De != null) for (var Fe in De) Fe !== "default" && Object.prototype.hasOwnProperty.call(De, Fe) && o(ve, De, Fe);
    return g(ve, De), ve;
  };
  Object.defineProperty(appClient, "__esModule", { value: !0 }), appClient.sendMerkleizedDataWithStatus = appClient.sendMerkleizedData = appClient.AppClient = appClient.PartialSignature = void 0;
  const y = c(requireDist()), t = c(requireDist$q()), { Descriptor: d } = y.DescriptorsFactory(t), E = require$$1, B = requireBip32(), D = requireClientCommands(), x = requireMerkelizedPsbt(), v = requireMerkle(), F = requirePsbtv2(), M = requireVarint(), U = 225, L = 248, H = 187, fe = 1;
  var ge;
  (function(De) {
    De[De.GET_PUBKEY = 0] = "GET_PUBKEY", De[De.REGISTER_WALLET = 2] = "REGISTER_WALLET", De[De.GET_WALLET_ADDRESS = 3] = "GET_WALLET_ADDRESS", De[De.SIGN_PSBT = 4] = "SIGN_PSBT", De[De.GET_MASTER_FINGERPRINT = 5] = "GET_MASTER_FINGERPRINT", De[De.SIGN_MESSAGE = 16] = "SIGN_MESSAGE";
  })(ge || (ge = {}));
  var Ie;
  (function(De) {
    De[De.CONTINUE_INTERRUPTED = 1] = "CONTINUE_INTERRUPTED";
  })(Ie || (Ie = {}));
  class Ee {
    constructor(ve, Fe, be) {
      this.pubkey = ve, this.signature = Fe, this.tapleafHash = be;
    }
  }
  appClient.PartialSignature = Ee;
  function Se(De, ve) {
    if (De.length == 64)
      return new Ee(De.slice(0, 32), ve, De.slice(32, 64));
    if (De.length == 32 || De.length == 33)
      return new Ee(De, ve);
    throw new Error(`Invalid length for pubkeyAugm: ${De.length} bytes.`);
  }
  class ze {
    constructor(ve) {
      this.transport = ve;
    }
    async makeRequest(ve, Fe, be) {
      let Be = await this.transport.send(U, ve, 0, fe, Fe, [36864, 57344]);
      for (; Be.readUInt16BE(Be.length - 2) === 57344; ) {
        if (!be)
          throw new Error("Unexpected SW_INTERRUPTED_EXECUTION");
        const ke = Be.slice(0, -2), xe = be.execute(ke);
        Be = await this.transport.send(L, Ie.CONTINUE_INTERRUPTED, 0, 0, xe, [36864, 57344]);
      }
      return Be.slice(0, -2);
    }
    /**
     * Returns an object containing the currently running app's name, version and the device status flags.
     *
     * @returns an object with app name, version and device status flags.
     */
    async getAppAndVersion() {
      const ve = await this.transport.send(176, 1, 0, 0);
      let Fe = 0;
      if (ve[Fe++] !== 1)
        throw new Error("Unexpected response");
      const Be = ve[Fe++], ke = ve.slice(Fe, Fe += Be).toString("ascii"), xe = ve[Fe++], Ne = ve.slice(Fe, Fe += xe).toString("ascii"), Et = ve[Fe++], st = ve.slice(Fe, Fe += Et);
      return {
        name: ke,
        version: Ne,
        flags: st
      };
    }
    /**
     * Requests the BIP-32 extended pubkey to the hardware wallet.
     * If `display` is `false`, only standard paths will be accepted; an error is returned if an unusual path is
     * requested.
     * If `display` is `true`, the requested path is shown on screen for user verification; unusual paths can be
     * requested, and a warning is shown to the user in that case.
     *
     * @param path the requested BIP-32 path as a string
     * @param display `false` to silently retrieve a pubkey for a standard path, `true` to display the path on screen
     * @returns the base58-encoded serialized extended pubkey (xpub)
     */
    async getExtendedPubkey(ve, Fe = !1) {
      const be = (0, B.pathStringToArray)(ve);
      if (be.length > 6)
        throw new Error("Path too long. At most 6 levels allowed.");
      return (await this.makeRequest(ge.GET_PUBKEY, Buffer.concat([
        Buffer.from(Fe ? [1] : [0]),
        (0, B.pathElementsToBuffer)(be)
      ]))).toString("ascii");
    }
    /**
     * Registers a `WalletPolicy`, after interactive verification from the user.
     * On success, after user's approval, this function returns the id (which is the same that can be computed with
     * `walletPolicy.getid()`), followed by the 32-byte hmac. The client should store the hmac to use it for future
     * requests to `getWalletAddress` or `signPsbt` using this `WalletPolicy`.
     *
     * @param walletPolicy the `WalletPolicy` to register
     * @returns a pair of two 32-byte arrays: the id of the Wallet Policy, followed by the policy hmac
     */
    async registerWallet(ve) {
      const Fe = new D.ClientCommandInterpreter();
      Fe.addKnownWalletPolicy(ve);
      const be = ve.serialize(), Be = await this.makeRequest(ge.REGISTER_WALLET, Buffer.concat([
        (0, M.createVarint)(be.length),
        be
      ]), Fe);
      if (Be.length != 64)
        throw Error(`Invalid response length. Expected 64 bytes, got ${Be.length}`);
      const ke = Be.subarray(0, 32), xe = Be.subarray(32), Ne = await this.getWalletAddress(ve, xe, 0, 0, !1);
      return await this.validateAddress(Ne, ve, 0, 0), [ke, xe];
    }
    /**
     * Returns the address of `walletPolicy` for the given `change` and `addressIndex`.
     *
     * @param walletPolicy the `WalletPolicy` to use
     * @param walletHMAC the 32-byte hmac returned during wallet registration for a registered policy; otherwise
     * `null` for a standard policy
     * @param change `0` for a normal receive address, `1` for a change address
     * @param addressIndex the address index to retrieve
     * @param display `True` to show the address on screen, `False` to retrieve it silently
     * @returns the address, as an ascii string.
     */
    async getWalletAddress(ve, Fe, be, Be, ke) {
      if (be !== 0 && be !== 1)
        throw new Error("Change can only be 0 or 1");
      if (Be < 0 || !Number.isInteger(Be))
        throw new Error("Invalid address index");
      if (Fe != null && Fe.length != 32)
        throw new Error("Invalid HMAC length");
      const xe = new D.ClientCommandInterpreter();
      xe.addKnownWalletPolicy(ve);
      const Ne = Buffer.alloc(4);
      Ne.writeUInt32BE(Be, 0);
      const st = (await this.makeRequest(ge.GET_WALLET_ADDRESS, Buffer.concat([
        Buffer.from(ke ? [1] : [0]),
        ve.getId(),
        Fe || Buffer.alloc(32, 0),
        Buffer.from([be]),
        Ne
      ]), xe)).toString("ascii");
      return await this.validateAddress(st, ve, be, Be), st;
    }
    /**
     * Prepares data for signing by sending it to the device.
     * This method uses a custom instruction to send merkleized data.
     * @param ins the instruction byte to use
     * @param payload the data payload to send
     * @returns the complete response including status word
     */
    async dataPrepare(ve) {
      return await Pe(this, H, ve);
    }
    /**
     * Signs a psbt using a (standard or registered) `WalletPolicy`. This is an interactive command, as user validation
     * is necessary using the device's secure screen.
     * On success, a map of input indexes and signatures is returned.
     * @param psbt a base64-encoded string, or a psbt in a binary Buffer. Using the `PsbtV2` type is deprecated.
     * @param walletPolicy the `WalletPolicy` to use for signing
     * @param walletHMAC the 32-byte hmac obtained during wallet policy registration, or `null` for a standard policy
     * @param progressCallback optionally, a callback that will be called every time a signature is produced during
     * the signing process. The callback does not receive any argument, but can be used to track progress.
     * @returns an array of of tuples with 2 elements containing:
     *    - the index of the input being signed;
     *    - an instance of PartialSignature
     */
    async signPsbt(ve, Fe, be, Be) {
      if (typeof ve == "string" && (ve = Buffer.from(ve, "base64")), Buffer.isBuffer(ve)) {
        const er = new F.PsbtV2();
        er.deserialize(ve), ve = er;
      }
      const ke = new x.MerkelizedPsbt(ve);
      if (be != null && be.length != 32)
        throw new Error("Invalid HMAC length");
      const xe = new D.ClientCommandInterpreter(Be);
      xe.addKnownWalletPolicy(Fe), xe.addKnownMapping(ke.globalMerkleMap);
      for (const er of ke.inputMerkleMaps)
        xe.addKnownMapping(er);
      for (const er of ke.outputMerkleMaps)
        xe.addKnownMapping(er);
      xe.addKnownList(ke.inputMapCommitments);
      const Ne = new v.Merkle(ke.inputMapCommitments.map((er) => (0, v.hashLeaf)(er))).getRoot();
      xe.addKnownList(ke.outputMapCommitments);
      const Et = new v.Merkle(ke.outputMapCommitments.map((er) => (0, v.hashLeaf)(er))).getRoot();
      await this.makeRequest(ge.SIGN_PSBT, Buffer.concat([
        ke.getGlobalKeysValuesRoot(),
        (0, M.createVarint)(ke.getGlobalInputCount()),
        Ne,
        (0, M.createVarint)(ke.getGlobalOutputCount()),
        Et,
        Fe.getId(),
        be || Buffer.alloc(32, 0)
      ]), xe);
      const st = xe.getYielded(), Dt = [];
      for (const er of st) {
        const [xt, ir] = (0, M.parseVarint)(er, 0), sr = er[ir], yr = er.subarray(ir + 1, ir + 1 + sr), wr = er.subarray(ir + 1 + sr), qr = Se(yr, wr);
        Dt.push([Number(xt), qr]);
      }
      return Dt;
    }
    /**
     * Returns the fingerprint of the master public key, as per BIP-32 standard.
     * @returns the master key fingerprint as a string of 8 hexadecimal digits.
     */
    async getMasterFingerprint() {
      return (await this.makeRequest(ge.GET_MASTER_FINGERPRINT, Buffer.from([]))).toString("hex");
    }
    /**
     * Signs a message using the legacy Bitcoin Message Signing standard. The signed message is
     * the double-sha256 hash of the concatenation of:
     * - "\x18Bitcoin Signed Message:\n";
     * - the length of `message`, encoded as a Bitcoin-style variable length integer;
     * - `message`.
     *
     * @param message the serialized message to sign
     * @param path the BIP-32 path of the key used to sign the message
     * @returns base64-encoded signature of the message.
     */
    async signMessage(ve, Fe) {
      const be = (0, B.pathStringToArray)(Fe), Be = new D.ClientCommandInterpreter(), ke = Math.ceil(ve.length / 64), xe = [];
      for (let st = 0; st < ke; st++)
        xe.push(ve.subarray(64 * st, 64 * st + 64));
      Be.addKnownList(xe);
      const Ne = new v.Merkle(xe.map((st) => (0, v.hashLeaf)(st))).getRoot();
      return (await this.makeRequest(ge.SIGN_MESSAGE, Buffer.concat([
        (0, B.pathElementsToBuffer)(be),
        (0, M.createVarint)(ve.length),
        Ne
      ]), Be)).toString("base64");
    }
    /* Performs any additional check on the generated address before returning it.*/
    async validateAddress(ve, Fe, be, Be) {
      if (be !== 0 && be !== 1)
        throw new Error("Change can only be 0 or 1");
      const ke = be === 1;
      if (Be < 0 || !Number.isInteger(Be))
        throw new Error("Invalid address index");
      const xe = await this.getAppAndVersion();
      let Ne;
      if (xe.name === "Babylon BTC Test")
        Ne = E.networks.testnet;
      else if (xe.name === "Babylon BTC Staking")
        Ne = E.networks.bitcoin;
      else
        throw new Error(`Invalid app: ${xe.name}. Expected 'Babylon BTC Test' or 'Babylon BTC Staking'.`);
      let Et = Fe.descriptorTemplate;
      Et = Et.replace(/\/\*\*/g, "/<0;1>/*");
      const st = new RegExp("/<(\\d+);(\\d+)>", "g");
      let Dt;
      for (; (Dt = st.exec(Et)) !== null; ) {
        const [ir, sr] = [parseInt(Dt[1], 10), parseInt(Dt[2], 10)];
        Et = Et.replace(`/<${ir};${sr}>`, `/${ke ? sr : ir}`);
      }
      Et = Et.replace(/\/\*/g, `/${Be}`);
      for (let ir = Fe.keys.length - 1; ir >= 0; ir--)
        Et = Et.replace(new RegExp(`@${ir}`, "g"), Fe.keys[ir]);
      let er = !0, xt;
      try {
        xt = new d({
          expression: Et,
          network: Ne
        }).getAddress();
      } catch {
        er = !1;
      }
      if (er && ve !== xt)
        throw new Error(`Third party address validation mismatch: ${ve} != ${xt}`);
    }
  }
  appClient.AppClient = ze;
  async function He(De, ve, Fe) {
    const be = [];
    for (let Ne = 0; Ne < Fe.length; Ne += 64)
      be.push(Fe.subarray(Ne, Ne + 64));
    const Be = new D.ClientCommandInterpreter();
    Be.addKnownList(be);
    const ke = new v.Merkle(be.map((Ne) => (0, v.hashLeaf)(Ne))).getRoot(), xe = Buffer.concat([
      (0, M.createVarint)(Fe.length),
      ke
    ]);
    return await De.makeRequest(ve, xe, Be);
  }
  appClient.sendMerkleizedData = He;
  async function Pe(De, ve, Fe) {
    const be = [];
    for (let Et = 0; Et < Fe.length; Et += 64)
      be.push(Fe.subarray(Et, Et + 64));
    const Be = new D.ClientCommandInterpreter();
    Be.addKnownList(be);
    const ke = new v.Merkle(be.map((Et) => (0, v.hashLeaf)(Et))).getRoot(), xe = Buffer.concat([
      (0, M.createVarint)(Fe.length),
      ke
    ]);
    let Ne = await De.transport.send(U, ve, 0, fe, xe, [36864, 57344]);
    for (; Ne.readUInt16BE(Ne.length - 2) === 57344; ) {
      const Et = Ne.slice(0, -2), st = Be.execute(Et);
      Ne = await De.transport.send(L, Ie.CONTINUE_INTERRUPTED, 0, 0, st, [36864, 57344]);
    }
    return Ne;
  }
  return appClient.sendMerkleizedDataWithStatus = Pe, appClient.default = ze, appClient;
}
var policy = {}, hasRequiredPolicy;
function requirePolicy() {
  if (hasRequiredPolicy) return policy;
  hasRequiredPolicy = 1, Object.defineProperty(policy, "__esModule", { value: !0 }), policy.DefaultWalletPolicy = policy.WalletPolicy = void 0;
  const o = require$$1, g = requireBuffertools(), c = requireMerkle(), y = 2;
  class t {
    /**
     * Creates and instance of a wallet policy.
     * @param name an ascii string, up to 16 bytes long; it must be an empty string for default wallet policies
     * @param descriptorTemplate the wallet policy template
     * @param keys and array of the keys, with the key derivation information
     */
    constructor(B, D, x) {
      this.name = B, this.descriptorTemplate = D, this.keys = x;
    }
    /**
     * Returns the unique 32-bytes id of this wallet policy.
     */
    getId() {
      return o.crypto.sha256(this.serialize());
    }
    /**
     * Serializes the wallet policy for transmission via the hardware wallet protocol.
     * @returns the serialized wallet policy
     */
    serialize() {
      const B = this.keys.map((v) => Buffer.from(v, "ascii")), D = new c.Merkle(B.map((v) => (0, c.hashLeaf)(v))), x = new g.BufferWriter();
      return x.writeUInt8(y), x.writeVarSlice(Buffer.from(this.name, "ascii")), x.writeVarInt(this.descriptorTemplate.length), x.writeSlice(o.crypto.sha256(Buffer.from(this.descriptorTemplate))), x.writeVarInt(this.keys.length), x.writeSlice(D.getRoot()), x.buffer();
    }
  }
  policy.WalletPolicy = t;
  class d extends t {
    constructor(B, D) {
      super("", B, [D]);
    }
  }
  return policy.DefaultWalletPolicy = d, policy;
}
var babylon = {}, bip322 = {}, types = {}, hasRequiredTypes;
function requireTypes() {
  return hasRequiredTypes || (hasRequiredTypes = 1, function(o) {
    Object.defineProperty(o, "__esModule", { value: !0 }), o.MessageSigningProtocols = o.AddressType = void 0, function(g) {
      g.p2pkh = "p2pkh", g.p2sh = "p2sh", g.p2wpkh = "p2wpkh", g.p2wsh = "p2wsh", g.p2tr = "p2tr";
    }(o.AddressType || (o.AddressType = {})), function(g) {
      g.ECDSA = "ECDSA", g.BIP322 = "BIP322";
    }(o.MessageSigningProtocols || (o.MessageSigningProtocols = {}));
  }(types)), types;
}
var utils = {}, hasRequiredUtils;
function requireUtils() {
  if (hasRequiredUtils) return utils;
  hasRequiredUtils = 1, Object.defineProperty(utils, "__esModule", { value: !0 }), utils.getAddressTypeFromPath = utils.isFullFiveLevelPath = utils.isTestnetPath = void 0;
  const o = requireTypes();
  function g(t) {
    const d = t.split("/");
    return d.length < 3 ? !1 : d[2] === "1'";
  }
  utils.isTestnetPath = g;
  function c(t) {
    const d = t.split("/");
    return d.length === 6 && d[0] === "m";
  }
  utils.isFullFiveLevelPath = c;
  function y(t) {
    const d = t.split("/");
    if (d.length < 2)
      return;
    switch (d[1].replace("'", "")) {
      case "86":
        return o.AddressType.p2tr;
      case "84":
        return o.AddressType.p2wpkh;
      case "49":
        return o.AddressType.p2sh;
      case "44":
      case "45":
        return o.AddressType.p2pkh;
      default:
        return;
    }
  }
  return utils.getAddressTypeFromPath = y, utils;
}
var prepare = {}, data = {}, hasRequiredData;
function requireData() {
  if (hasRequiredData) return data;
  hasRequiredData = 1, Object.defineProperty(data, "__esModule", { value: !0 }), data.encodeGetVersionTLV = data.encodeExpansionPolicyToTLV = data.encodeSignMessagePolicyToTLV = data.encodeWithdrawPolicyToTLV = data.encodeUnbondPolicyToTLV = data.encodeSlashingTxPolicyToTLV = data.encodeStakingTxPolicyToTLV = void 0;
  function o(D) {
    const x = D.split("/");
    if (x[0] !== "m" || x.length !== 6)
      throw new Error("Invalid BIP32 path");
    return x.slice(1).map((v) => v.endsWith("'") ? (parseInt(v.replace("'", ""), 10) | 2147483648) >>> 0 : parseInt(v, 10) >>> 0);
  }
  function g(D, x, v, F, M) {
    const U = [];
    U.push(Buffer.from([119])), U.push(Buffer.from([0, 1])), U.push(Buffer.from([2]));
    const L = o(D), H = Buffer.alloc(4 * L.length);
    L.forEach((Ee, Se) => H.writeUInt32BE(Ee, Se * 4)), U.push(Buffer.from([55])), U.push(Buffer.from([0, H.length])), U.push(H);
    const fe = v.length;
    if (U.push(Buffer.from([249])), U.push(Buffer.from([0, fe])), U.push(Buffer.from([fe])), fe > 0) {
      U.push(Buffer.from([248]));
      const Ee = 32 * fe;
      U.push(Buffer.from([Math.floor(Ee / 256), Ee % 256]));
      for (const Se of v) {
        const ze = Buffer.from(Se, "hex");
        if (ze.length !== 32)
          throw new Error(`Invalid finality provider pubkey length: ${ze.length}, expected 32`);
        U.push(ze);
      }
    }
    const ge = M.length;
    if (U.push(Buffer.from([192])), U.push(Buffer.from([0, 1])), U.push(Buffer.from([ge])), ge > 0) {
      U.push(Buffer.from([193]));
      const Ee = 32 * ge;
      U.push(Buffer.from([Math.floor(Ee / 256), Ee % 256]));
      for (const Se of M) {
        const ze = Buffer.from(Se, "hex");
        if (ze.length !== 32)
          throw new Error(`Invalid covenant pubkey length: ${ze.length}, expected 32`);
        U.push(ze);
      }
    }
    U.push(Buffer.from([1])), U.push(Buffer.from([0, 1])), U.push(Buffer.from([F])), U.push(Buffer.from([113])), U.push(Buffer.from([0, 8]));
    const Ie = Buffer.alloc(8);
    return Ie.writeUInt32BE(Math.floor(x / 4294967296), 0), Ie.writeUInt32BE(x % 4294967296, 4), U.push(Ie), Buffer.concat(U);
  }
  data.encodeStakingTxPolicyToTLV = g;
  function c(D, x, v, F, M, U, L, H = !1) {
    if (!M)
      throw new Error("covenantPks is required");
    const fe = [];
    fe.push(Buffer.from([119])), fe.push(Buffer.from([0, 1])), H ? fe.push(Buffer.from([1])) : fe.push(Buffer.from([0]));
    const ge = o(D), Ie = Buffer.alloc(4 * ge.length);
    ge.forEach((De, ve) => Ie.writeUInt32BE(De, ve * 4)), fe.push(Buffer.from([55])), fe.push(Buffer.from([0, Ie.length])), fe.push(Ie);
    const Ee = v.length;
    if (fe.push(Buffer.from([249])), fe.push(Buffer.from([0, Ee])), fe.push(Buffer.from([Ee])), Ee > 0) {
      fe.push(Buffer.from([248]));
      const De = 32 * Ee;
      fe.push(Buffer.from([Math.floor(De / 256), De % 256]));
      for (const ve of v) {
        const Fe = Buffer.from(ve, "hex");
        if (Fe.length !== 32)
          throw new Error(`Invalid finality provider pubkey length: ${Fe.length}, expected 32`);
        fe.push(Fe);
      }
    }
    const Se = M.length;
    if (fe.push(Buffer.from([192])), fe.push(Buffer.from([0, 1])), fe.push(Buffer.from([Se])), Se > 0) {
      fe.push(Buffer.from([193]));
      const De = 32 * Se;
      fe.push(Buffer.from([Math.floor(De / 256), De % 256]));
      for (const ve of M) {
        const Fe = Buffer.from(ve, "hex");
        if (Fe.length !== 32)
          throw new Error(`Invalid covenant pubkey length: ${Fe.length}, expected 32`);
        fe.push(Fe);
      }
    }
    fe.push(Buffer.from([1])), fe.push(Buffer.from([0, 1])), fe.push(Buffer.from([F])), fe.push(Buffer.from([254])), fe.push(Buffer.from([0, 8]));
    const ze = Buffer.alloc(8);
    ze.writeUInt32BE(Math.floor(L / 4294967296), 0), ze.writeUInt32BE(L % 4294967296, 4), fe.push(ze);
    const He = Buffer.from(U, "hex");
    fe.push(Buffer.from([54])), fe.push(Buffer.from([0, He.length])), fe.push(He), fe.push(Buffer.from([113])), fe.push(Buffer.from([0, 8]));
    const Pe = Buffer.alloc(8);
    return Pe.writeUInt32BE(Math.floor(x / 4294967296), 0), Pe.writeUInt32BE(x % 4294967296, 4), fe.push(Pe), Buffer.concat(fe);
  }
  data.encodeSlashingTxPolicyToTLV = c;
  function y(D, x, v, F, M, U) {
    if (!M)
      throw new Error("covenantPks is required");
    const L = [];
    L.push(Buffer.from([119])), L.push(Buffer.from([0, 1])), L.push(Buffer.from([3]));
    const H = o(D), fe = Buffer.alloc(4 * H.length);
    H.forEach((ze, He) => fe.writeUInt32BE(ze, He * 4)), L.push(Buffer.from([55])), L.push(Buffer.from([0, fe.length])), L.push(fe);
    const ge = v.length;
    if (L.push(Buffer.from([249])), L.push(Buffer.from([0, ge])), L.push(Buffer.from([ge])), ge > 0) {
      L.push(Buffer.from([248]));
      const ze = 32 * ge;
      L.push(Buffer.from([Math.floor(ze / 256), ze % 256]));
      for (const He of v) {
        const Pe = Buffer.from(He, "hex");
        if (Pe.length !== 32)
          throw new Error(`Invalid finality provider pubkey length: ${Pe.length}, expected 32`);
        L.push(Pe);
      }
    }
    const Ie = M.length;
    if (L.push(Buffer.from([192])), L.push(Buffer.from([0, 1])), L.push(Buffer.from([Ie])), Ie > 0) {
      L.push(Buffer.from([193]));
      const ze = 32 * Ie;
      L.push(Buffer.from([Math.floor(ze / 256), ze % 256]));
      for (const He of M) {
        const Pe = Buffer.from(He, "hex");
        if (Pe.length !== 32)
          throw new Error(`Invalid covenant pubkey length: ${Pe.length}, expected 32`);
        L.push(Pe);
      }
    }
    L.push(Buffer.from([1])), L.push(Buffer.from([0, 1])), L.push(Buffer.from([F])), L.push(Buffer.from([255])), L.push(Buffer.from([0, 8]));
    const Ee = Buffer.alloc(8);
    Ee.writeUInt32BE(Math.floor(U / 4294967296), 0), Ee.writeUInt32BE(U % 4294967296, 4), L.push(Ee), L.push(Buffer.from([113])), L.push(Buffer.from([0, 8]));
    const Se = Buffer.alloc(8);
    return Se.writeUInt32BE(Math.floor(x / 4294967296), 0), Se.writeUInt32BE(x % 4294967296, 4), L.push(Se), Buffer.concat(L);
  }
  data.encodeUnbondPolicyToTLV = y;
  function t(D, x) {
    const v = [];
    v.push(Buffer.from([119])), v.push(Buffer.from([0, 1])), v.push(Buffer.from([4]));
    const F = o(D), M = Buffer.alloc(4 * F.length);
    F.forEach((L, H) => M.writeUInt32BE(L, H * 4)), v.push(Buffer.from([55])), v.push(Buffer.from([0, M.length])), v.push(M), v.push(Buffer.from([113])), v.push(Buffer.from([0, 8]));
    const U = Buffer.alloc(8);
    return U.writeUInt32BE(Math.floor(x / 4294967296), 0), U.writeUInt32BE(x % 4294967296, 4), v.push(U), Buffer.concat(v);
  }
  data.encodeWithdrawPolicyToTLV = t;
  function d(D, x, v) {
    const F = [];
    F.push(Buffer.from([119])), F.push(Buffer.from([0, 1])), F.push(Buffer.from([5]));
    const M = o(D), U = Buffer.alloc(4 * M.length);
    return M.forEach((L, H) => U.writeUInt32BE(L, H * 4)), F.push(Buffer.from([55])), F.push(Buffer.from([0, U.length])), F.push(U), console.log("Message Buffer:", x), console.log("Message Length:", x.length), F.push(Buffer.from([51])), F.push(Buffer.from([0, x.length])), F.push(x), v.length == 32 && (F.push(Buffer.from([52])), F.push(Buffer.from([0, 32])), F.push(v)), Buffer.concat(F);
  }
  data.encodeSignMessagePolicyToTLV = d;
  function E(D, x, v, F, M) {
    const U = [];
    U.push(Buffer.from([119])), U.push(Buffer.from([0, 1])), U.push(Buffer.from([6]));
    const L = o(D), H = Buffer.alloc(4 * L.length);
    L.forEach((Ee, Se) => H.writeUInt32BE(Ee, Se * 4)), U.push(Buffer.from([55])), U.push(Buffer.from([0, H.length])), U.push(H);
    const fe = v.length;
    if (U.push(Buffer.from([249])), U.push(Buffer.from([0, fe])), U.push(Buffer.from([fe])), fe > 0) {
      U.push(Buffer.from([248]));
      const Ee = 32 * fe;
      U.push(Buffer.from([Math.floor(Ee / 256), Ee % 256]));
      for (const Se of v) {
        const ze = Buffer.from(Se, "hex");
        if (ze.length !== 32)
          throw new Error(`Invalid finality provider pubkey length: ${ze.length}, expected 32`);
        U.push(ze);
      }
    }
    const ge = M.length;
    if (U.push(Buffer.from([192])), U.push(Buffer.from([0, 1])), U.push(Buffer.from([ge])), ge > 0) {
      U.push(Buffer.from([193]));
      const Ee = 32 * ge;
      U.push(Buffer.from([Math.floor(Ee / 256), Ee % 256]));
      for (const Se of M) {
        const ze = Buffer.from(Se, "hex");
        if (ze.length !== 32)
          throw new Error(`Invalid covenant pubkey length: ${ze.length}, expected 32`);
        U.push(ze);
      }
    }
    U.push(Buffer.from([1])), U.push(Buffer.from([0, 1])), U.push(Buffer.from([F])), U.push(Buffer.from([113])), U.push(Buffer.from([0, 8]));
    const Ie = Buffer.alloc(8);
    return Ie.writeUInt32BE(Math.floor(x / 4294967296), 0), Ie.writeUInt32BE(x % 4294967296, 4), U.push(Ie), Buffer.concat(U);
  }
  data.encodeExpansionPolicyToTLV = E;
  function B() {
    const D = [];
    return D.push(Buffer.from([119])), D.push(Buffer.from([0, 1])), D.push(Buffer.from([16])), Buffer.concat(D);
  }
  return data.encodeGetVersionTLV = B, data;
}
var hasRequiredPrepare;
function requirePrepare() {
  if (hasRequiredPrepare) return prepare;
  hasRequiredPrepare = 1;
  var o = prepare && prepare.__importDefault || function(H) {
    return H && H.__esModule ? H : { default: H };
  };
  Object.defineProperty(prepare, "__esModule", { value: !0 }), prepare.getBbnVersion = prepare.expansionTxPolicy = prepare.signMessagePathPolicy = prepare.withdrawPathPolicy = prepare.unbondingPathPolicy = prepare.stakingTxPolicy = prepare.slashingPathPolicy = void 0;
  const g = requireData(), c = o(requireAppClient()), y = requirePolicy(), t = requireUtils(), d = requireTypes();
  async function E(H, fe) {
    const ge = new c.default(H), Ie = await ge.getMasterFingerprint(), Ee = await ge.getExtendedPubkey(fe);
    return [Ie, Ee];
  }
  async function B({ transport: H, params: fe, derivationPath: ge, isUnbonding: Ie }) {
    const { timelockBlocks: Ee, finalityProviders: Se, covenantThreshold: ze, covenantPks: He, slashingPkScriptHex: Pe, slashingFeeSat: De } = fe;
    if (!(0, t.isFullFiveLevelPath)(ge))
      throw new Error("The derivation path should be a full five-level path.");
    const ve = ge.split("/").slice(0, 4).join("/"), [Fe, be] = await E(H, ve), Be = (0, t.getAddressTypeFromPath)(ge);
    let ke;
    if (Be === d.AddressType.p2wpkh)
      ke = "wpkh(@0/**)";
    else if (Be === d.AddressType.p2tr)
      ke = "tr(@0/**)";
    else
      throw new Error("Only p2tr and segwit address types are supported for slashing transactions.");
    const xe = [];
    xe.push(`[${ve.replace("m/", `${Fe}/`)}]${be}`);
    const Ne = (0, g.encodeSlashingTxPolicyToTLV)(ge, Ee, Se, ze, He, Pe, De, Ie), Et = new c.default(H);
    try {
      await Et.dataPrepare(Ne);
    } catch (st) {
      throw console.error("Error in dataPrepare:", st), st;
    }
    return new y.WalletPolicy("", ke, xe);
  }
  prepare.slashingPathPolicy = B;
  async function D({ transport: H, params: fe, derivationPath: ge }) {
    if (!(0, t.isFullFiveLevelPath)(ge))
      throw new Error("The derivation path should be a full five-level path.");
    const Ie = (0, t.getAddressTypeFromPath)(ge), Ee = ge.split("/").slice(0, 4).join("/"), [Se, ze] = await E(H, Ee), He = [];
    let Pe;
    if (Ie === d.AddressType.p2wpkh)
      Pe = "wpkh(@0/**)";
    else if (Ie === d.AddressType.p2tr)
      Pe = "tr(@0/**)";
    else
      throw new Error("Only p2tr and segwit address types are supported for staking transactions.");
    He.push(`[${Ee.replace("m/", `${Se}/`)}]${ze}`);
    const { timelockBlocks: De, finalityProviders: ve, covenantThreshold: Fe, covenantPks: be } = fe, Be = (0, g.encodeStakingTxPolicyToTLV)(ge, De, ve, Fe, be || []), ke = new c.default(H);
    try {
      await ke.dataPrepare(Be);
    } catch (xe) {
      throw console.error("Error in dataPrepare:", xe), xe;
    }
    return new y.WalletPolicy("", Pe, He);
  }
  prepare.stakingTxPolicy = D;
  async function x({ transport: H, params: fe, derivationPath: ge }) {
    const { timelockBlocks: Ie, finalityProviders: Ee, covenantThreshold: Se, covenantPks: ze, unbondingFeeSat: He } = fe;
    if (!(0, t.isFullFiveLevelPath)(ge))
      throw new Error("The derivation path should be a full five-level path.");
    const Pe = ge.split("/").slice(0, 4).join("/"), [De, ve] = await E(H, Pe), Fe = (0, t.getAddressTypeFromPath)(ge);
    let be;
    if (Fe === d.AddressType.p2wpkh)
      be = "wpkh(@0/**)";
    else if (Fe === d.AddressType.p2tr)
      be = "tr(@0/**)";
    else
      throw new Error("Only p2tr and segwit address types are supported for slashing transactions.");
    const Be = [];
    Be.push(`[${Pe.replace("m/", `${De}/`)}]${ve}`);
    const ke = (0, g.encodeUnbondPolicyToTLV)(ge, Ie, Ee, Se, ze, He), xe = new c.default(H);
    try {
      await xe.dataPrepare(ke);
    } catch (Ne) {
      throw console.error("Error in dataPrepare:", Ne), Ne;
    }
    return new y.WalletPolicy("", be, Be);
  }
  prepare.unbondingPathPolicy = x;
  async function v({ transport: H, params: fe, derivationPath: ge }) {
    const { timelockBlocks: Ie } = fe;
    if (!(0, t.isFullFiveLevelPath)(ge))
      throw new Error("The derivation path should be a full five-level path.");
    const Ee = ge.split("/").slice(0, 4).join("/"), [Se, ze] = await E(H, Ee), He = (0, t.getAddressTypeFromPath)(ge);
    let Pe;
    if (He === d.AddressType.p2wpkh)
      Pe = "wpkh(@0/**)";
    else if (He === d.AddressType.p2tr)
      Pe = "tr(@0/**)";
    else
      throw new Error("Only p2tr and segwit address types are supported for slashing transactions.");
    const De = [];
    De.push(`[${Ee.replace("m/", `${Se}/`)}]${ze}`);
    const ve = (0, g.encodeWithdrawPolicyToTLV)(ge, Ie), Fe = new c.default(H);
    try {
      await Fe.dataPrepare(ve);
    } catch (be) {
      throw console.error("Error in dataPrepare:", be), be;
    }
    return new y.WalletPolicy("", Pe, De);
  }
  prepare.withdrawPathPolicy = v;
  async function F({ transport: H, params: fe, derivationPath: ge }) {
    if (!(0, t.isFullFiveLevelPath)(ge))
      throw new Error("The derivation path should be a full five-level path.");
    const Ie = ge.split("/").slice(0, 4).join("/"), { message: Ee, pubkey: Se } = fe, [ze, He] = await E(H, Ie), Pe = [], De = (0, t.getAddressTypeFromPath)(ge);
    let ve;
    if (De === d.AddressType.p2wpkh)
      ve = "wpkh(@0/**)";
    else if (De === d.AddressType.p2tr)
      ve = "tr(@0/**)";
    else
      throw new Error("Only p2tr and segwit address types are supported for slashing transactions.");
    if (console.log("Derivation Path for Sign Message Policy:", ge), console.log("descriptorTemplate:", ve), Pe.push(`[${Ie.replace("m/", `${ze}/`)}]${He}`), Ee.length == 0 || Ee.length > 128)
      throw new Error("The message should be a non-empty string with a maximum length of 128 characters.");
    console.log("message:", Ee);
    const Fe = (0, g.encodeSignMessagePolicyToTLV)(ge, Buffer.from(Ee), Se), be = new c.default(H);
    try {
      await be.dataPrepare(Fe);
    } catch (Be) {
      throw console.error("Error in dataPrepare:", Be), Be;
    }
    return new y.WalletPolicy("", ve, Pe);
  }
  prepare.signMessagePathPolicy = F;
  async function M({ transport: H, params: fe, derivationPath: ge }) {
    if (!(0, t.isFullFiveLevelPath)(ge))
      throw new Error("The derivation path should be a full five-level path.");
    const Ie = (0, t.getAddressTypeFromPath)(ge), Ee = ge.split("/").slice(0, 4).join("/"), [Se, ze] = await E(H, Ee), He = [];
    let Pe;
    if (Ie === d.AddressType.p2wpkh)
      Pe = "wpkh(@0/**)";
    else if (Ie === d.AddressType.p2tr)
      Pe = "tr(@0/**)";
    else
      throw new Error("Only p2tr and segwit address types are supported for staking transactions.");
    He.push(`[${Ee.replace("m/", `${Se}/`)}]${ze}`);
    const { timelockBlocks: De, finalityProviders: ve, covenantThreshold: Fe, covenantPks: be } = fe, Be = (0, g.encodeExpansionPolicyToTLV)(ge, De, ve, Fe, be || []), ke = new c.default(H);
    try {
      await ke.dataPrepare(Be);
    } catch (xe) {
      throw console.error("Error in dataPrepare:", xe), xe;
    }
    return new y.WalletPolicy("", Pe, He);
  }
  prepare.expansionTxPolicy = M;
  const U = {
    v1: 1,
    v2: 2
  };
  async function L(H) {
    var fe;
    const ge = new c.default(H), Ie = (0, g.encodeGetVersionTLV)();
    try {
      return await ge.dataPrepare(Ie), console.log("[getVersion] Device responded successfully, firmware version: v2"), U.v2;
    } catch (Ee) {
      return (Ee == null ? void 0 : Ee.statusCode) === 27904 || !((fe = Ee == null ? void 0 : Ee.message) === null || fe === void 0) && fe.includes("6d00") ? (console.log("[getVersion] Device returned 0x6d00 (instruction not supported), firmware version: v1"), U.v1) : (console.warn("[getVersion] Error querying version, defaulting to v1:", Ee), U.v1);
    }
  }
  return prepare.getBbnVersion = L, prepare;
}
var hasRequiredBip322;
function requireBip322() {
  if (hasRequiredBip322) return bip322;
  hasRequiredBip322 = 1;
  var o = bip322 && bip322.__createBinding || (Object.create ? function(Fe, be, Be, ke) {
    ke === void 0 && (ke = Be);
    var xe = Object.getOwnPropertyDescriptor(be, Be);
    (!xe || ("get" in xe ? !be.__esModule : xe.writable || xe.configurable)) && (xe = { enumerable: !0, get: function() {
      return be[Be];
    } }), Object.defineProperty(Fe, ke, xe);
  } : function(Fe, be, Be, ke) {
    ke === void 0 && (ke = Be), Fe[ke] = be[Be];
  }), g = bip322 && bip322.__setModuleDefault || (Object.create ? function(Fe, be) {
    Object.defineProperty(Fe, "default", { enumerable: !0, value: be });
  } : function(Fe, be) {
    Fe.default = be;
  }), c = bip322 && bip322.__importStar || function(Fe) {
    if (Fe && Fe.__esModule) return Fe;
    var be = {};
    if (Fe != null) for (var Be in Fe) Be !== "default" && Object.prototype.hasOwnProperty.call(Fe, Be) && o(be, Fe, Be);
    return g(be, Fe), be;
  }, y = bip322 && bip322.__importDefault || function(Fe) {
    return Fe && Fe.__esModule ? Fe : { default: Fe };
  };
  Object.defineProperty(bip322, "__esModule", { value: !0 }), bip322.signMessageBIP322 = bip322.createTaprootBip322Signature = bip322.createSegwitBip322Signature = bip322.bip0322Hash = void 0;
  const t = c(requireDist$q()), d = require$$1, E = requireSrc$1(), B = requireVaruintBitcoin(), D = y(requireMain()), x = requireTypes(), v = requireUtils(), F = requireTypes(), M = requirePrepare(), U = (0, E.BIP32Factory)(t), L = (Fe) => Buffer.concat([(0, B.encode)(Fe.byteLength), Fe]), H = Buffer.from("0000000000000000000000000000000000000000000000000000000000000000", "hex"), fe = 4294967295, ge = 0;
  function Ie(Fe) {
    const { sha256: be } = d.crypto, ke = be(Buffer.from("BIP0322-signed-message"));
    return be(Buffer.concat([ke, ke, Buffer.from(Fe)])).toString("hex");
  }
  bip322.bip0322Hash = Ie;
  const Ee = async (Fe, be, Be, ke, xe, Ne) => {
    const Et = Buffer.concat([
      Buffer.from("0020", "hex"),
      Buffer.from(Ie(Be), "hex")
    ]), st = new d.Transaction();
    st.version = 0, st.addInput(H, fe, ge, Et), st.addOutput(ke, 0);
    const Dt = new d.Psbt();
    Dt.setVersion(0), Dt.addInput(Object.assign({ hash: st.getHash(), index: 0, sequence: 0, witnessUtxo: {
      script: ke,
      value: 0
    } }, xe)), Dt.addOutput({ script: Buffer.from("6a", "hex"), value: 0 });
    const er = await Fe.signPsbt(Dt.toBase64(), be, null);
    for (const wr of er)
      Ne ? Dt.updateInput(wr[0], {
        partialSig: [wr[1]]
      }) : Dt.updateInput(wr[0], {
        tapKeySig: wr[1].signature
      });
    Dt.finalizeAllInputs();
    const xt = Dt.extractTransaction(), ir = (0, B.encode)(xt.ins[0].witness.length);
    return {
      signature: Buffer.concat([
        ir,
        ...xt.ins[0].witness.map((wr) => L(wr))
      ]).toString("base64"),
      protocol: x.MessageSigningProtocols.BIP322
    };
  };
  function Se(Fe, be, Be) {
    const ke = Be ? d.networks.testnet : d.networks.bitcoin, { publicKey: xe } = U.fromBase58(Fe, ke).derivePath(`0/${be}`);
    return xe;
  }
  function ze(Fe, be, Be = !1) {
    (0, d.initEccLib)(t);
    const ke = Se(Fe, be, Be), xe = Be ? d.networks.testnet : d.networks.bitcoin, Ne = d.payments.p2wpkh({ pubkey: ke, network: xe }), Et = Ne.address;
    if (!Et)
      throw new Error("Address is null");
    if (!Ne.output)
      throw new Error("p2wpkh output is null");
    return {
      publicKey: ke,
      address: Et,
      witnessScript: Ne.output
    };
  }
  async function He({ message: Fe, app: be, derivationPath: Be, isTestnet: ke = !1 }) {
    const xe = be.transport, Ne = await be.getMasterFingerprint();
    console.log("Master Fingerprint:", Ne), console.log("Derivation Path:", Be);
    const Et = Be.split("/").slice(0, 4).join("/");
    console.log("Three Level Path:", Et);
    const st = await be.getExtendedPubkey(Et);
    console.log("Extended Public Key:", st), console.log("extendedPublicKey:", st);
    const { publicKey: Dt, witnessScript: er } = ze(st, 0, ke);
    console.log("createSegwitBip322Signature Public Key:", Dt.toString("hex"));
    const xt = {
      path: Be,
      pubkey: Dt,
      masterFingerprint: Buffer.from(Ne, "hex")
    };
    console.log("Input Derivation:", xt);
    const ir = {
      message: Fe,
      pubkey: Buffer.from(er.slice(2))
    }, sr = await (0, M.signMessagePathPolicy)({
      transport: xe,
      params: ir,
      derivationPath: Be,
      isTestnet: ke
    });
    return console.log("Policy created"), console.log("policy:", sr), Ee(be, sr, Fe, er, {
      bip32Derivation: [xt]
    }, !0);
  }
  bip322.createSegwitBip322Signature = He;
  function Pe(Fe, be, Be = !1) {
    (0, d.initEccLib)(t);
    const ke = Se(Fe, be, Be), xe = d.payments.p2tr({
      internalPubkey: ke.slice(1),
      network: Be ? d.networks.testnet : d.networks.bitcoin
    });
    if (!xe.output || !xe.address || !xe.internalPubkey)
      throw new Error("p2tr output, address or internalPubkey is null");
    return {
      publicKey: ke,
      address: xe.address,
      internalPubkey: xe.internalPubkey,
      taprootScript: xe.output
    };
  }
  async function De({ message: Fe, app: be, derivationPath: Be, isTestnet: ke = !1 }) {
    const xe = be.transport, Ne = await be.getMasterFingerprint(), Et = Be.split("/").slice(0, 4).join("/"), st = await be.getExtendedPubkey(Et), { internalPubkey: Dt, taprootScript: er } = Pe(st, 0, ke);
    console.log("createTaprootBip322Signature Internal Public Key:", Dt.toString("hex"));
    const xt = {
      path: Be,
      pubkey: Dt,
      masterFingerprint: Buffer.from(Ne, "hex"),
      leafHashes: []
    }, ir = {
      message: Fe,
      pubkey: Buffer.from(er.slice(2))
    }, sr = await (0, M.signMessagePathPolicy)({
      transport: xe,
      params: ir,
      derivationPath: Be,
      isTestnet: ke
    });
    return Ee(be, sr, Fe, er, {
      tapBip32Derivation: [xt],
      tapInternalKey: Dt
    }, !1);
  }
  bip322.createTaprootBip322Signature = De;
  async function ve({ transport: Fe, message: be, derivationPath: Be, isTestnet: ke = !1 }) {
    console.log("Derivation Path:", Be);
    const xe = (0, v.getAddressTypeFromPath)(Be);
    if (console.log("Address Type:", xe), !xe)
      throw new Error("The derivation path is not valid.");
    const Ne = new D.default(Fe);
    return xe === F.AddressType.p2tr ? (console.log("Creating Taproot BIP322 Signature"), De({
      message: be,
      app: Ne,
      derivationPath: Be,
      isTestnet: ke
    })) : (console.log("12 Creating Segwit BIP322 Signature"), He({
      message: be,
      app: Ne,
      derivationPath: Be,
      isTestnet: ke
    }));
  }
  return bip322.signMessageBIP322 = ve, bip322;
}
var hasRequiredBabylon;
function requireBabylon() {
  return hasRequiredBabylon || (hasRequiredBabylon = 1, function(o) {
    var g = babylon && babylon.__importDefault || function(U) {
      return U && U.__esModule ? U : { default: U };
    };
    Object.defineProperty(o, "__esModule", { value: !0 }), o.getBbnVersion = o.expansionTxPolicy = o.unbondingPathPolicy = o.stakingTxPolicy = o.slashingPathPolicy = o.withdrawPathPolicy = o.signMessage = o.signPsbt = void 0;
    const c = /* @__PURE__ */ requireLib$1(), y = /* @__PURE__ */ requireBtcSigner(), t = g(requireAppClient()), d = requireBip322(), E = requireUtils(), B = requirePsbtv2();
    function D(U, L) {
      try {
        const H = new B.PsbtV2();
        H.deserialize(Buffer.from(c.base64.decode(U)));
        const fe = H.getInputWitnessUtxo(L);
        if (fe) {
          const ge = fe.scriptPubKey;
          if (console.log(`[detectInputAddressType] Input ${L}: scriptPubKey length=${ge.length}, hex=${ge.toString("hex").substring(0, 20)}...`), ge.length === 34 && ge[0] === 81 && ge[1] === 32)
            return console.log(`[detectInputAddressType] Input ${L}: detected as p2tr (Taproot)`), "p2tr";
          if (ge.length === 22 && ge[0] === 0 && ge[1] === 20)
            return console.log(`[detectInputAddressType] Input ${L}: detected as p2wpkh (Native SegWit)`), "p2wpkh";
        }
        console.log(`[detectInputAddressType] Input ${L}: unknown address type`);
      } catch (H) {
        console.warn(`[detectInputAddressType] Input ${L}: Failed to detect address type:`, H);
      }
      return "unknown";
    }
    function x(U, L) {
      try {
        const H = Buffer.from(U, "base64"), Ie = require("bitcoinjs-lib").Psbt.fromBuffer(H).data.inputs[L], Ee = !!(Ie && Ie.tapLeafScript && Ie.tapLeafScript.length > 0);
        return console.log(`[hasInputTaprootScript] Input ${L}: ${Ee ? "HAS" : "NO"} taproot script`), Ee;
      } catch (H) {
        return console.warn(`[hasInputTaprootScript] Input ${L}: Failed to check taproot script:`, H), !1;
      }
    }
    async function v({ transport: U, psbt: L, policy: H }) {
      const fe = new t.default(U), ge = L instanceof Uint8Array ? c.base64.encode(L) : L;
      console.log("[signPsbt] Starting PSBT signing process...");
      const Ie = await fe.signPsbt(ge, H, null);
      console.log(`[signPsbt] Received ${Ie.length} signature(s) from Ledger`);
      const Ee = y.Transaction.fromPSBT(c.base64.decode(ge));
      for (const Se of Ie) {
        const ze = Se[0];
        console.log(`
[signPsbt] === Processing signature for input ${ze} ===`);
        const He = D(ge, ze), Pe = x(ge, ze);
        if (console.log(`[signPsbt] Input ${ze}: addressType=${He}, hasScript=${Pe}`), console.log(`[signPsbt] Input ${ze}: signature length=${Se[1].signature.length} bytes`), console.log(`[signPsbt] Input ${ze}: pubkey length=${Se[1].pubkey.length} bytes`), Se[1].tapleafHash && console.log(`[signPsbt] Input ${ze}: tapleafHash present (${Se[1].tapleafHash.length} bytes)`), Pe) {
          console.log(`[signPsbt] Input ${ze}: Using tapScriptSig (script path)`);
          let De = Se[1].signature;
          if (He === "p2tr" && De.length > 64)
            if (De.length === 65)
              console.log(`[signPsbt] Input ${ze}: Trimming Schnorr signature from 65 to 64 bytes`), De = De.slice(0, 64);
            else
              throw new Error(`Invalid Schnorr signature length: ${De.length} bytes. Expected 64 or 65 bytes.`);
          Ee.updateInput(ze, {
            tapScriptSig: [
              [
                {
                  pubKey: new Uint8Array(Se[1].pubkey),
                  leafHash: new Uint8Array(Se[1].tapleafHash || Buffer.alloc(32))
                },
                new Uint8Array(De)
              ]
            ]
          }, !0), console.log(`[signPsbt] Input ${ze}: tapScriptSig added successfully`);
        } else {
          let De = Se[1].signature;
          if (He === "p2tr") {
            if (console.log(`[signPsbt] Input ${ze}: Using tapKeySig (Taproot key path)`), De.length > 64)
              if (De.length === 65)
                console.log(`[signPsbt] Input ${ze}: Trimming Schnorr signature from 65 to 64 bytes`), De = De.slice(0, 64);
              else
                throw new Error(`Invalid Schnorr signature length: ${De.length} bytes. Expected 64 or 65 bytes.`);
            Ee.updateInput(ze, {
              tapKeySig: new Uint8Array(De)
            }, !0), console.log(`[signPsbt] Input ${ze}: tapKeySig added successfully (${De.length} bytes)`);
          } else He === "p2wpkh" ? (console.log(`[signPsbt] Input ${ze}: Using partialSig (Native SegWit ECDSA)`), Ee.updateInput(ze, {
            partialSig: [
              [new Uint8Array(Se[1].pubkey), new Uint8Array(De)]
            ]
          }, !0), console.log(`[signPsbt] Input ${ze}: partialSig added successfully (${De.length} bytes ECDSA/DER)`)) : (console.warn(`[signPsbt] Input ${ze}: Unknown address type, defaulting to taproot key path`), De.length > 64 && De.length === 65 && (console.log(`[signPsbt] Input ${ze}: Trimming signature from 65 to 64 bytes`), De = De.slice(0, 64)), Ee.updateInput(ze, {
            tapKeySig: new Uint8Array(De)
          }, !0), console.log(`[signPsbt] Input ${ze}: tapKeySig added (fallback)`));
        }
      }
      return console.log(`[signPsbt] All signatures processed successfully
`), Ee;
    }
    o.signPsbt = v;
    async function F(U) {
      const { transport: L, message: H, derivationPath: fe } = U;
      if (!L)
        throw new Error("signMessage: transport is required");
      if (typeof H != "string" || H.length === 0)
        throw new Error("signMessage: message must be a non-empty string");
      if (console.log("Signing message:", H), !(0, E.isFullFiveLevelPath)(fe))
        throw new Error("The derivation path should be a full five-level path.");
      const ge = (0, E.isTestnetPath)(fe);
      return (0, d.signMessageBIP322)({
        transport: L,
        message: H,
        derivationPath: fe,
        isTestnet: ge
      });
    }
    o.signMessage = F;
    var M = requirePrepare();
    Object.defineProperty(o, "withdrawPathPolicy", { enumerable: !0, get: function() {
      return M.withdrawPathPolicy;
    } }), Object.defineProperty(o, "slashingPathPolicy", { enumerable: !0, get: function() {
      return M.slashingPathPolicy;
    } }), Object.defineProperty(o, "stakingTxPolicy", { enumerable: !0, get: function() {
      return M.stakingTxPolicy;
    } }), Object.defineProperty(o, "unbondingPathPolicy", { enumerable: !0, get: function() {
      return M.unbondingPathPolicy;
    } }), Object.defineProperty(o, "expansionTxPolicy", { enumerable: !0, get: function() {
      return M.expansionTxPolicy;
    } }), Object.defineProperty(o, "getBbnVersion", { enumerable: !0, get: function() {
      return M.getBbnVersion;
    } });
  }(babylon)), babylon;
}
var hasRequiredMain;
function requireMain() {
  return hasRequiredMain || (hasRequiredMain = 1, function(o) {
    var g = main && main.__createBinding || (Object.create ? function(x, v, F, M) {
      M === void 0 && (M = F);
      var U = Object.getOwnPropertyDescriptor(v, F);
      (!U || ("get" in U ? !v.__esModule : U.writable || U.configurable)) && (U = { enumerable: !0, get: function() {
        return v[F];
      } }), Object.defineProperty(x, M, U);
    } : function(x, v, F, M) {
      M === void 0 && (M = F), x[M] = v[F];
    }), c = main && main.__setModuleDefault || (Object.create ? function(x, v) {
      Object.defineProperty(x, "default", { enumerable: !0, value: v });
    } : function(x, v) {
      x.default = v;
    }), y = main && main.__importStar || function(x) {
      if (x && x.__esModule) return x;
      var v = {};
      if (x != null) for (var F in x) F !== "default" && Object.prototype.hasOwnProperty.call(x, F) && g(v, x, F);
      return c(v, x), v;
    };
    Object.defineProperty(o, "__esModule", { value: !0 }), o.getBbnVersion = o.signMessage = o.signPsbt = o.expansionTxPolicy = o.stakingTxPolicy = o.withdrawPathPolicy = o.unbondingPathPolicy = o.slashingPathPolicy = o.PartialSignature = o.PsbtV2 = o.AppClient = o.WalletPolicy = o.DefaultWalletPolicy = void 0;
    const t = y(requireAppClient());
    o.AppClient = t.default, Object.defineProperty(o, "PartialSignature", { enumerable: !0, get: function() {
      return t.PartialSignature;
    } });
    const d = requirePolicy();
    Object.defineProperty(o, "DefaultWalletPolicy", { enumerable: !0, get: function() {
      return d.DefaultWalletPolicy;
    } }), Object.defineProperty(o, "WalletPolicy", { enumerable: !0, get: function() {
      return d.WalletPolicy;
    } });
    const E = requireBabylon();
    Object.defineProperty(o, "signMessage", { enumerable: !0, get: function() {
      return E.signMessage;
    } }), Object.defineProperty(o, "signPsbt", { enumerable: !0, get: function() {
      return E.signPsbt;
    } }), Object.defineProperty(o, "slashingPathPolicy", { enumerable: !0, get: function() {
      return E.slashingPathPolicy;
    } }), Object.defineProperty(o, "stakingTxPolicy", { enumerable: !0, get: function() {
      return E.stakingTxPolicy;
    } }), Object.defineProperty(o, "withdrawPathPolicy", { enumerable: !0, get: function() {
      return E.withdrawPathPolicy;
    } }), Object.defineProperty(o, "unbondingPathPolicy", { enumerable: !0, get: function() {
      return E.unbondingPathPolicy;
    } }), Object.defineProperty(o, "expansionTxPolicy", { enumerable: !0, get: function() {
      return E.expansionTxPolicy;
    } });
    const B = requirePrepare();
    Object.defineProperty(o, "getBbnVersion", { enumerable: !0, get: function() {
      return B.getBbnVersion;
    } });
    const D = requirePsbtv2();
    Object.defineProperty(o, "PsbtV2", { enumerable: !0, get: function() {
      return D.PsbtV2;
    } }), o.default = t.default;
  }(main)), main;
}
var mainExports = requireMain();
const AppClient = /* @__PURE__ */ getDefaultExportFromCjs(mainExports), getPolicyForTransaction = async (o, g, {
  contracts: c,
  action: y,
  addressIndex: t
}) => {
  const d = `${g}/0/${t}`;
  switch (y.name) {
    case ActionName.SIGN_BTC_STAKING_TRANSACTION:
      return getStakingPolicy(c, d, o);
    case ActionName.SIGN_BTC_STAKING_EXPANSION_TRANSACTION:
      return getExpansionPolicy(c, d, o);
    case ActionName.SIGN_BTC_UNBONDING_TRANSACTION:
      return getUnbondingPolicy(c, d, o);
    case ActionName.SIGN_BTC_SLASHING_TRANSACTION:
      return getSlashingPolicy(c, d, o);
    case ActionName.SIGN_BTC_UNBONDING_SLASHING_TRANSACTION:
      return getUnbondingSlashingPolicy(c, d, o);
    case ActionName.SIGN_BTC_WITHDRAW_TRANSACTION:
      return getWithdrawPolicy(c, d, o);
    default:
      throw new Error(`Unknown action: ${y.name}`);
  }
}, getStakingPolicy = (o, g, c) => {
  const y = o.find((D) => D.id === BABYLON_SIGNING_CONTRACTS.STAKING);
  if (!y)
    throw new Error("Staking contract is required");
  const { finalityProviders: t, covenantThreshold: d, covenantPks: E, stakingDuration: B } = y.params;
  return mainExports.stakingTxPolicy({
    transport: c,
    params: {
      finalityProviders: t,
      covenantThreshold: d,
      covenantPks: sortPkHexes(E),
      timelockBlocks: B
    },
    derivationPath: g
  });
}, getExpansionPolicy = (o, g, c) => {
  const y = o.find((D) => D.id === BABYLON_SIGNING_CONTRACTS.STAKING_EXPANSION);
  if (!y)
    throw new Error("Expansion contract is required");
  const { finalityProviders: t, covenantThreshold: d, covenantPks: E, stakingDuration: B } = y.params;
  return mainExports.expansionTxPolicy({
    transport: c,
    params: {
      finalityProviders: t,
      covenantThreshold: d,
      covenantPks: sortPkHexes(E),
      timelockBlocks: B
    },
    derivationPath: g
  });
}, getUnbondingPolicy = (o, g, c) => {
  const y = o.find((x) => x.id === BABYLON_SIGNING_CONTRACTS.UNBONDING);
  if (!y)
    throw new Error("Unbonding contract is required");
  const { finalityProviders: t, covenantThreshold: d, covenantPks: E, unbondingTimeBlocks: B, unbondingFeeSat: D } = y.params;
  return mainExports.unbondingPathPolicy({
    transport: c,
    params: {
      finalityProviders: t,
      covenantThreshold: d,
      covenantPks: sortPkHexes(E),
      timelockBlocks: B,
      unbondingFeeSat: D
    },
    derivationPath: g
  });
}, getSlashingPolicy = (o, g, c) => {
  const y = o.find((M) => M.id === BABYLON_SIGNING_CONTRACTS.SLASHING);
  if (!y)
    throw new Error("Slashing contract is required in slashing transaction");
  const t = o.find((M) => M.id === BABYLON_SIGNING_CONTRACTS.STAKING);
  if (!t)
    throw new Error("Staking contract is required in slashing transaction");
  const d = o.find((M) => M.id === BABYLON_SIGNING_CONTRACTS.SLASHING_BURN);
  if (!d)
    throw new Error("Slashing burn contract is required in unbonding slashing transaction");
  const { unbondingTimeBlocks: E, slashingFeeSat: B } = y.params, { covenantPks: D, finalityProviders: x, covenantThreshold: v } = t.params, { slashingPkScriptHex: F } = d.params;
  return mainExports.slashingPathPolicy({
    transport: c,
    params: {
      timelockBlocks: E,
      finalityProviders: x,
      covenantThreshold: v,
      covenantPks: sortPkHexes(D),
      slashingPkScriptHex: F,
      slashingFeeSat: B
    },
    derivationPath: g,
    isUnbonding: !1
  });
}, getUnbondingSlashingPolicy = (o, g, c) => {
  const y = o.find((M) => M.id === BABYLON_SIGNING_CONTRACTS.SLASHING);
  if (!y)
    throw new Error("Slashing contract is required in unbonding slashing transaction");
  const t = o.find((M) => M.id === BABYLON_SIGNING_CONTRACTS.UNBONDING);
  if (!t)
    throw new Error("Unbonding contract is required in unbonding slashing transaction");
  const d = o.find((M) => M.id === BABYLON_SIGNING_CONTRACTS.SLASHING_BURN);
  if (!d)
    throw new Error("Slashing burn contract is required in unbonding slashing transaction");
  const { unbondingTimeBlocks: E, slashingFeeSat: B } = y.params, { covenantPks: D, finalityProviders: x, covenantThreshold: v } = t.params, { slashingPkScriptHex: F } = d.params;
  return mainExports.slashingPathPolicy({
    transport: c,
    params: {
      timelockBlocks: E,
      finalityProviders: x,
      covenantThreshold: v,
      covenantPks: sortPkHexes(D),
      slashingPkScriptHex: F,
      slashingFeeSat: B
    },
    derivationPath: g,
    isUnbonding: !0
  });
}, getWithdrawPolicy = (o, g, c) => {
  const y = o.find((d) => d.id === BABYLON_SIGNING_CONTRACTS.WITHDRAW);
  if (!y)
    throw new Error("Withdraw timelock expired contract is required");
  const { timelockBlocks: t } = y.params;
  return mainExports.withdrawPathPolicy({
    transport: c,
    params: {
      timelockBlocks: t
    },
    derivationPath: g
  });
}, WALLET_PROVIDER_NAME$5 = "Ledger";
class LedgerProviderV2 {
  constructor(g, c) {
    Vi(this, "ledgerWalletInfo");
    Vi(this, "config");
    Vi(this, "derivationConfig");
    Vi(this, "connectWallet", async () => {
      const g = await this.createAppClient(), c = await mainExports.getBbnVersion(g.transport);
      if (c < 2)
        throw new Error(`Ledger firmware version too low. Required: v2 or higher, Found: v${c}`);
      const y = await g.getMasterFingerprint(), t = this.getDerivationPath(), d = await g.getExtendedPubkey(t), E = await this.getWalletPolicy(g, y, t);
      if (!E) throw new Error("Could not retrieve the policy");
      const { address: B, publicKeyHex: D } = await this.getLedgerAccount(g, E, d);
      this.ledgerWalletInfo = {
        app: g,
        policy: E,
        mfp: y,
        extendedPublicKey: d,
        path: t,
        address: B,
        publicKeyHex: D
      };
    });
    Vi(this, "getAddress", async () => {
      var g;
      if (!((g = this.ledgerWalletInfo) != null && g.address)) throw new Error("Could not retrieve the address");
      return this.ledgerWalletInfo.address;
    });
    Vi(this, "getPublicKeyHex", async () => {
      var g;
      if (!((g = this.ledgerWalletInfo) != null && g.publicKeyHex)) throw new Error("Could not retrieve the BTC public key");
      return this.ledgerWalletInfo.publicKeyHex;
    });
    Vi(this, "signPsbt", async (g, c) => {
      var x, v, F;
      if (!((x = this.ledgerWalletInfo) != null && x.address) || !((v = this.ledgerWalletInfo) != null && v.publicKeyHex))
        throw new Error("Ledger is not connected");
      if (!g) throw new Error("psbt hex is required");
      const y = bufferExports.Buffer.from(g, "hex").toString("base64"), t = this.ledgerWalletInfo.app.transport;
      if (!t || !(t instanceof Transport))
        throw new Error("Transport is required to sign psbt");
      if (!this.ledgerWalletInfo.path)
        throw new Error("Derivation path is required to sign psbt");
      if (!(c != null && c.contracts) || (c == null ? void 0 : c.contracts.length) === 0)
        throw new Error("Contracts are required to sign psbt in ledger");
      if (!((F = c == null ? void 0 : c.action) != null && F.name))
        throw new Error("Action name is required to sign psbt in ledger");
      const d = await getPolicyForTransaction(t, this.ledgerWalletInfo.path, {
        contracts: c.contracts,
        action: c.action,
        addressIndex: this.derivationConfig.addressIndex
      }), E = await mainExports.signPsbt({
        transport: t,
        psbt: y,
        policy: d
      }), B = Transaction.fromPSBT(E.toPSBT(), {
        allowUnknownInputs: !0,
        allowUnknownOutputs: !0
      });
      return B.finalize(), bufferExports.Buffer.from(B.toPSBT()).toString("hex");
    });
    Vi(this, "signPsbts", async (g, c) => {
      var t, d, E;
      if (!((t = this.ledgerWalletInfo) != null && t.address) || !((d = this.ledgerWalletInfo) != null && d.publicKeyHex) || !((E = this.ledgerWalletInfo) != null && E.policy))
        throw new Error("Ledger is not connected");
      if (!g || !Array.isArray(g) || g.length === 0)
        throw new Error("psbts hexes are required");
      const y = [];
      for (let B = 0; B < g.length; B++) {
        const D = g[B], x = c ? c[B] : void 0;
        if (!D)
          throw new Error(`psbt hex at index ${B} is required`);
        if (typeof D != "string")
          throw new Error(`psbt hex at index ${B} must be a string`);
        const v = await this.signPsbt(D, x);
        y.push(v);
      }
      return y;
    });
    Vi(this, "getNetwork", async () => this.config.network);
    Vi(this, "signMessage", async (g) => {
      var t, d, E;
      if (!((t = this.ledgerWalletInfo) != null && t.app.transport) || !((d = this.ledgerWalletInfo) != null && d.path))
        throw new Error("Ledger is not connected");
      const c = `${this.ledgerWalletInfo.path}/0/${this.derivationConfig.addressIndex}`;
      return (await mainExports.signMessage({
        transport: (E = this.ledgerWalletInfo) == null ? void 0 : E.app.transport,
        message: g,
        derivationPath: c
      })).signature;
    });
    Vi(this, "getInscriptions", async () => {
      throw new Error("Method not implemented.");
    });
    // Not implemented because of the hardware wallet nature
    Vi(this, "on", () => {
    });
    Vi(this, "off", () => {
    });
    Vi(this, "getWalletProviderName", async () => WALLET_PROVIDER_NAME$5);
    Vi(this, "getWalletProviderIcon", async () => logo$4);
    Vi(this, "deriveContextHash", unsupportedDeriveContextHash(WALLET_PROVIDER_NAME$5));
    this.config = c, this.derivationConfig = {
      purpose: 84,
      addressIndex: 0
    };
  }
  /**
   * Set the derivation configuration for address generation
   * @param config - Partial derivation config to merge with current settings
   */
  setDerivationConfig(g) {
    this.derivationConfig = {
      ...this.derivationConfig,
      ...g
    };
  }
  /**
   * Get the current derivation configuration
   * @returns A copy of the current derivation config
   */
  getDerivationConfig() {
    return { ...this.derivationConfig };
  }
  // Create a transport instance for Ledger devices
  // It first tries to create a WebUSB transport
  // and if that fails, it falls back to WebHID
  async createTransport() {
    try {
      return await TransportWebUSB.create();
    } catch (g) {
      try {
        return await TransportWebHID.create();
      } catch (c) {
        throw new Error(
          `Could not connect to Ledger device: ${g.message || g}, ${c.message || c}`
        );
      }
    }
  }
  // Get the network derivation index based on the network
  // 0 for MAINNET, 1 for TESTNET
  getNetworkDerivationIndex() {
    return this.config.network === Network.MAINNET ? 0 : 1;
  }
  getDerivationPath() {
    const g = this.getNetworkDerivationIndex();
    return `m/${this.derivationConfig.purpose}'/${g}'/0'`;
  }
  // Create a new AppClient instance using the transport
  async createAppClient() {
    const g = await this.createTransport();
    return new AppClient(g);
  }
  async getWalletPolicy(g, c, y) {
    const t = await g.getExtendedPubkey(y);
    if (!t)
      throw new Error("Could not retrieve the extended public key for policy");
    const d = this.getNetworkDerivationIndex(), E = this.derivationConfig.purpose;
    let B;
    if (E === 86)
      B = "tr(@0/**)";
    else if (E === 84)
      B = "wpkh(@0/**)";
    else
      throw new Error(`Unsupported purpose ${E}. Only 84 (wpkh) and 86 (tr) are supported.`);
    const D = `[${c}/${E}'/${d}'/0']${t}`, x = new mainExports.DefaultWalletPolicy(B, D);
    if (!x)
      throw new Error("Could not create the wallet policy");
    return x;
  }
  async getLedgerAccount(g, c, y) {
    const t = await g.getWalletAddress(
      c,
      null,
      0,
      // 0 - normal, 1 - change
      this.derivationConfig.addressIndex,
      !0
      // show address on the wallet's screen
    ), d = await this.getNetwork(), E = getPublicKeyFromXpub(
      y,
      `M/0/${this.derivationConfig.addressIndex}`,
      toNetwork(d)
    );
    return { address: t, publicKeyHex: E.toString("hex") };
  }
}
const metadata$7 = {
  id: "ledger_btc_v2",
  name: `${WALLET_PROVIDER_NAME$5} v2`,
  icon: logo$4,
  iconBackground: MONOCHROME_MARK_BACKGROUND,
  docs: "https://www.ledger.com/ledger-live",
  createProvider: (o, g) => new LedgerProviderV2(o, g),
  networks: [Network.SIGNET, Network.MAINNET],
  label: "Hardware wallet",
  hardware: !0
}, logo$3 = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='157'%20height='157'%3e%3cpath%20fill='%23FFFFFF'%20fill-rule='nonzero'%20d='M5%20106.655V143h55.308v-8.06h-47.25v-28.285H5Zm138.98%200v28.285H96.731v8.058h55.308v-36.343h-8.059Zm-83.592-55.31v55.308h36.343v-7.269H68.446V51.345h-8.058ZM5%2015v36.345h8.058V23.058h47.25V15H5Zm91.731%200v8.058h47.249v28.287h8.059V15H96.731Z'/%3e%3c/svg%3e", SEMVER_RE = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)$/;
function checkMinVersion(o, g) {
  const c = typeof o == "string" ? SEMVER_RE.exec(o) : null;
  if (!c) return "unparseable";
  const [y, t, d] = g.split(".").map(Number);
  return (Number(c[1]) - y || Number(c[2]) - t || Number(c[3]) - d) >= 0 ? "ok" : "below";
}
const WALLET_PROVIDER_NAME$4 = "Ledger Vault", BIP86_PURPOSE = 86, COIN_TYPE_BY_NETWORK = {
  [Network.MAINNET]: 0,
  [Network.TESTNET]: 1,
  [Network.SIGNET]: 1
}, APP_NAME_BY_NETWORK = {
  [Network.MAINNET]: "Babylon Vault",
  [Network.TESTNET]: "Babylon Vault Testnet",
  [Network.SIGNET]: "Babylon Vault Testnet"
}, MIN_APP_VERSION = "0.11.0", FIRST_UNSUPPORTED_APP_VERSION = "0.12.0", APP_WAIT_POLL_INTERVAL_MS = 1e3, APP_OPEN_SETTLE_MS = 2e3, ACCOUNT_INDEX = 0, CHANGE_INDEX = 0, ADDRESS_INDEX = 0, HARDENED = 2147483648, BIP322_P2TR_WITNESS_PREFIX_HEX = "0140", SCHNORR_SIG_BYTES = 64;
function signingRequestKey(o) {
  const g = [...o.table.classifiedByInput.entries()].map(
    ([c, y]) => y.kind === "tapscript" ? [...y.expectedLeafHashHexes].sort().map((t) => `${c}:${t}`).join(",") : `${c}:keypath`
  ).sort().join("|");
  return `${o.unsignedTxid}|${g}`;
}
class LedgerVaultProvider {
  constructor(g = Network.MAINNET) {
    Vi(this, "session");
    Vi(this, "send");
    /** See {@link DeviceIntentState}. Updated pessimistically around device I/O. */
    Vi(this, "deviceState", { phase: "idle" });
    /**
     * Single in-flight pubkey read per connection — `Wallet.connect()` calls
     * `getAddress()` and `getPublicKeyHex()` concurrently and both resolve from
     * this one device read.
     */
    Vi(this, "pubkeyHexPromise");
    /** See {@link PolicyContext}. Single in-flight read per connection, like {@link pubkeyHexPromise}. */
    Vi(this, "policyContextPromise");
    /**
     * In-flight connect, so two overlapping `connectWallet()` calls (a
     * double-click) share one session instead of opening — and leaking — a
     * second HID connection.
     */
    Vi(this, "connectPromise");
    /**
     * Bumped on every session teardown and every successful connect. A ceremony
     * captures it before its device await and refuses to commit host state if
     * the connection changed underneath it (disconnect/reconnect racing a late
     * APDU resolution).
     */
    Vi(this, "connectionGeneration", 0);
    /**
     * Bumped ONLY by the public {@link disconnect} — a user cancellation. An
     * in-flight connect captures it and aborts if it changes, so a disconnect
     * racing the connect can't leave a live session behind a disconnected
     * wallet. Distinct from {@link connectionGeneration}, which the provider's
     * own dead-session cleanup also bumps (that is not a cancellation).
     */
    Vi(this, "disconnectToken", 0);
    /** Non-throwing sender for the SIGN_PSBT loop; recreated per session like {@link send}. */
    Vi(this, "rawSend");
    /** Request-identity keys ({@link signingRequestKey}) signed under the CURRENT loaded intent. */
    Vi(this, "signedFingerprints", /* @__PURE__ */ new Set());
    /**
     * Request-identity keys of every intent-bound SIGN_PSBT sent to the device
     * since its counters last reset (a successful derive or a fresh approval).
     * Unlike {@link signedFingerprints} it survives the pessimistic resets and a
     * teardown, because the device's counters do while its session lives, and it
     * counts a failed attempt too: the firmware reserves the Pre-PegIn slot
     * before signing, "a failed attempt counts as used"
     * (`fw:sign_psbt_validate.c:755-758` @ b89dd580). {@link resumeIntentFromDevice}
     * restores it as the replay guard of a re-adopted intent.
     */
    Vi(this, "dispatchedSinceCounterReset", /* @__PURE__ */ new Set());
    /**
     * True once this instance has seen the device's counters reset, so
     * {@link dispatchedSinceCounterReset} covers every request the device may
     * have counted. A fresh instance (a page reload) cannot know what an earlier
     * one sent, so it never resumes.
     */
    Vi(this, "dispatchRecordComplete", !1);
    /**
     * ONE in-flight device ceremony (derive/approve/sign, plus the app read of
     * a connect re-gate or of the account key read) at a time — a
     * concurrent APDU would be eaten with 0x6A80 and desync the interrupt loop.
     * Token-scoped: teardown clears it SYNCHRONOUSLY so a new connection can
     * operate while a stale call is still settling; that call's finally
     * releases only its own token.
     */
    Vi(this, "activeOperation");
    /** Abort handle into the in-flight signing loop; fired by teardown (B3's only abort source). */
    Vi(this, "signAbortController");
    /** Connection-scoped like the fields above: cleared in teardownSession. */
    Vi(this, "signingProgressListeners", /* @__PURE__ */ new Set());
    /**
     * Provider-scoped, NOT cleared in teardownSession: a view subscribes once,
     * and a wait ended by teardown must still reach it as `ready`.
     */
    Vi(this, "deviceAppStateListeners", /* @__PURE__ */ new Set());
    /** Abort handle into the in-flight app wait; fired by cancelSigning and teardown. */
    Vi(this, "appWaitController");
    /**
     * Pair with the device over WebHID.
     *
     * MUST be called from a user gesture: WebHID is Chromium-only, needs a
     * secure context, and its picker fails silently otherwise.
     */
    Vi(this, "connectWallet", async () => {
      if (!this.connectPromise) {
        const g = this.doConnect().finally(() => {
          this.connectPromise === g && (this.connectPromise = void 0);
        });
        this.connectPromise = g;
      }
      return this.connectPromise;
    });
    Vi(this, "doConnect", async () => {
      var d, E;
      const g = this.disconnectToken, c = this.session;
      if (c && await this.probeSessionAlive(c)) {
        await this.gateUngatedSession(c, g);
        return;
      }
      if (g !== this.disconnectToken) return;
      this.session && await this.teardownSession();
      let y;
      try {
        y = await connectDmkSession();
      } catch (B) {
        const D = B, x = ((d = D == null ? void 0 : D.originalError) == null ? void 0 : d.message) ?? (D == null ? void 0 : D._tag) ?? String(B), v = (D == null ? void 0 : D._tag) === "NoAccessibleDeviceError" && ((E = D.originalError) == null ? void 0 : E.message) === "No selected device";
        throw new WalletError({
          code: v ? ERROR_CODES.CONNECTION_REJECTED : ERROR_CODES.CONNECTION_FAILED,
          message: `Could not connect to ${WALLET_PROVIDER_NAME$4}: ${x}`,
          wallet: WALLET_PROVIDER_NAME$4
        });
      }
      if (g !== this.disconnectToken) {
        await disconnectDmkSession(y);
        return;
      }
      const t = this.refuseUnexpectedApp(y);
      if (t)
        throw await disconnectDmkSession(y), t;
      this.session = y, this.send = withWalletErrorMapping(createDmkApduSender(y)), this.rawSend = createDmkRawApduSender(y), this.connectionGeneration += 1;
    });
    /**
     * Release the device session; the DMK singleton stays up. `closeDmk()` here
     * would leak HID listeners — `dmk.close()` never destroys the transport, and
     * a rebuilt singleton registers a duplicate listener pair.
     */
    Vi(this, "disconnect", async () => {
      this.disconnectToken += 1, await this.teardownSession();
    });
    /**
     * Clear host state and release the transport. State is invalidated
     * SYNCHRONOUSLY — before awaiting transport teardown — so a racing connect
     * or ceremony sees the disconnection immediately and never targets the
     * session being torn down. Used by both {@link disconnect} and doConnect's
     * dead-session cleanup; only the former is a user cancellation.
     */
    Vi(this, "teardownSession", async () => {
      var c, y;
      const g = this.session;
      this.session = void 0, this.send = void 0, this.rawSend = void 0, this.connectionGeneration += 1, this.deviceState = { phase: "idle" }, this.pubkeyHexPromise = void 0, this.policyContextPromise = void 0, this.signedFingerprints = /* @__PURE__ */ new Set(), this.signingProgressListeners.clear(), this.activeOperation = void 0, (c = this.signAbortController) == null || c.abort(), this.signAbortController = void 0, (y = this.appWaitController) == null || y.abort(), g && await disconnectDmkSession(g);
    });
    /**
     * Taproot address derived locally from the device-read pubkey. Safe: the
     * firmware rebuilds every script from its own seed at signing time, so a
     * lied-about address can never receive a valid vault signature.
     */
    Vi(this, "getAddress", async () => getTaprootAddress(await this.getDevicePubkeyHex(), this.network));
    /** x-only public key at the same leaf the intent pins. */
    Vi(this, "getPublicKeyHex", async () => this.getDevicePubkeyHex());
    /**
     * Pre-PegIn change must pay the depositor's own `/0/0` address: the app takes
     * change only as P2TR(depositor) after the 546-sat anchor, and rejects any
     * output on the change branch (`sign_psbt_validate.c:571-661` @ b89dd580).
     */
    Vi(this, "getChangeAddress", async () => this.withDeviceOperation("getChangeAddress", async () => {
      const g = this.connectionGeneration;
      this.deviceState.phase === "idle" && await this.awaitExpectedApp(g);
      const c = await this.getDevicePubkeyHex();
      return this.assertSameConnection(g), getTaprootAddress(c, this.network);
    }));
    /**
     * Derive the 32-byte context root, always with the approval screen — a
     * silent derivation returns no root, and the host needs it.
     */
    Vi(this, "deriveContextHash", async (g, c) => this.withDeviceOperation("deriveContextHash", () => this.doDeriveContextHash(g, c)));
    Vi(this, "doDeriveContextHash", async (g, c) => {
      if (!/^(?:[0-9a-f]{2})+$/.test(c))
        throw new WalletError({
          code: ERROR_CODES.INVALID_PARAMS,
          message: `deriveContextHash context must be even-length lowercase hex without a 0x prefix; got ${c.length} chars.`,
          wallet: WALLET_PROVIDER_NAME$4
        });
      this.deviceState = { phase: "idle" }, this.signedFingerprints = /* @__PURE__ */ new Set();
      const y = this.connectionGeneration;
      await this.awaitExpectedApp(y);
      const t = await deriveContextHash(this.requireSender(), {
        appName: g,
        derivationPath: this.depositorPath,
        context: Uint8Array.from(Buffer.from(c, "hex"))
      });
      return this.assertSameConnection(y), this.deviceState = { phase: "derived" }, this.dispatchedSinceCounterReset = /* @__PURE__ */ new Set(), this.dispatchRecordComplete = !0, Buffer.from(t).toString("hex");
    });
    /**
     * DepositTermsApprover.validateDepositTerms (#2110 T4): the envelope gate
     * alone — no device I/O, no state, callable before the first approval
     * screen. The envelope never reads `prepeginTxid`, so provisional terms
     * with a placeholder txid validate correctly.
     */
    Vi(this, "validateDepositTerms", async (g) => {
      assertDepositTermsDeviceCompatible(g);
    });
    /**
     * Validate the terms against the device envelope, then run the ceremony.
     * The envelope gate runs BEFORE any device I/O — the firmware answers an
     * out-of-range intent with an opaque status word and a dead session.
     */
    Vi(this, "approveDepositTerms", async (g) => this.withDeviceOperation("approveDepositTerms", () => this.doApproveDepositTerms(g)));
    /**
     * DepositTermsApprover.holdsApprovedDepositTerms: never throws, never
     * prompts. Reads the mirror; when the mirror holds nothing (a reconnect, or
     * a signing failure's pessimistic reset), asks the device with the silent
     * GET_VAULT_STATE — see {@link resumeIntentFromDevice}. A stale true fails
     * closed at the signing gate.
     */
    Vi(this, "holdsApprovedDepositTerms", async (g) => {
      if (this.deviceState.phase === "idle" && this.session && !this.activeOperation) {
        let y;
        try {
          y = await this.withDeviceOperation("holdsApprovedDepositTerms", () => this.resumeIntentFromDevice(g));
        } catch {
          return !1;
        }
        if (!y) return !1;
      }
      const c = this.deviceState;
      if (c.phase !== "intent-loaded") return !1;
      try {
        const y = g.prepeginTxid.replace(/^0x/, "").toLowerCase();
        for (const t of this.signedFingerprints)
          if (t.startsWith(`${y}|`)) return !1;
        return c.termsKey === this.fingerprintTerms(g);
      } catch {
        return !1;
      }
    });
    /**
     * Re-adopt an approval the device still holds after the host lost its
     * mirror. The device keeps the vault session through an auto-lock or a USB
     * reconnect while the app stays open, and loses it on an app exit or power
     * cycle (ADR-001). Adopts only an intent whose fingerprint equals the one
     * these terms' APDUs would produce (`fw:docs/apdu.md` §INS 0x82 @ b89dd580),
     * so a different deposit is never resumed. The replay guard comes back as
     * every request sent since the device's counters last reset
     * ({@link dispatchedSinceCounterReset}): a request whose attempt failed is
     * refused too, so the host never resends what the device may have counted.
     * Only an instance whose record is complete ({@link dispatchRecordComplete})
     * resumes. Any failure is "not proven" and returns false — the caller runs
     * the full ceremony. Caller holds the device-operation lock.
     */
    Vi(this, "resumeIntentFromDevice", async (g) => {
      if (this.deviceState.phase !== "idle" || !this.dispatchRecordComplete) return !1;
      const c = this.connectionGeneration, y = this.buildIntentFromTerms(g);
      let t;
      try {
        t = await getVaultState(this.requireSender());
      } catch {
        return !1;
      }
      return c !== this.connectionGeneration || this.deviceState.phase !== "idle" || t.phase !== "intent-loaded" || !Buffer.from(t.intentFingerprint).equals(Buffer.from(intentFingerprint(y))) ? !1 : (this.deviceState = {
        phase: "intent-loaded",
        termsKey: this.fingerprintTerms(g),
        prepeginTxidInternalHex: Buffer.from(y.scalars.prepeginTxidInternal).toString("hex"),
        htlcRefundTimelock: y.scalars.htlcRefundTimelock
      }, this.signedFingerprints = new Set(this.dispatchedSinceCounterReset), !0);
    });
    /** Idempotence key: wire bytes + vaultCoreVersion (the TLV never carries it). */
    Vi(this, "fingerprintTerms", (g) => `${g.vaultCoreVersion}:${fingerprintIntent(this.buildIntentFromTerms(g))}`);
    /** Pure translation of seam terms into the device intent. No I/O, no state. */
    Vi(this, "buildIntentFromTerms", (g) => {
      const c = {
        coinType: COIN_TYPE_BY_NETWORK[this.network],
        baseFeeRate: g.protocolFeeRate,
        peginCsvTimelock: g.timelockPegin,
        payoutTimelock: g.timelockAssert,
        prepeginTxidInternal: displayTxidToInternal(g.prepeginTxid),
        htlcRefundTimelock: g.timelockRefund,
        depositorPath: this.depositorPath,
        keeperCount: g.vaultKeeperBtcPubkeys.length,
        challengerCount: g.universalChallengerBtcPubkeys.length,
        vaultCount: g.vaults.length,
        prepeginMaxFee: g.prepeginMaxFee
      }, y = g.vaults.map((t) => ({
        htlcVout: t.htlcVout,
        vaultProviderPubkey: hexToXOnly(t.vaultProviderBtcPubkey, "vaultProviderBtcPubkey"),
        vaultAmount: t.peginAmount,
        commissionFee: t.commissionFee,
        depositorClaimValue: t.depositorClaimValue,
        peginMaxFee: t.peginMaxFee
      }));
      return {
        scalars: c,
        groups: y,
        keeperPubkeys: g.vaultKeeperBtcPubkeys.map((t) => hexToXOnly(t, "vaultKeeperBtcPubkey")),
        challengerPubkeys: g.universalChallengerBtcPubkeys.map((t) => hexToXOnly(t, "universalChallengerBtcPubkey"))
      };
    });
    Vi(this, "doApproveDepositTerms", async (g) => {
      assertDepositTermsDeviceCompatible(g);
      const c = this.connectionGeneration, y = this.requireSender();
      if (!await this.probeSessionAlive(this.requireSession()))
        throw c === this.connectionGeneration && await this.teardownSession(), disconnectedError();
      this.assertSameConnection(c);
      const t = canonicalPubkey(await this.getDevicePubkeyHex());
      this.assertSameConnection(c);
      const d = (D) => canonicalPubkey(D) === t;
      if (g.vaults.some((D) => d(D.vaultProviderBtcPubkey)) || g.vaultKeeperBtcPubkeys.some(d) || g.universalChallengerBtcPubkeys.some(d))
        throw new DepositTermsRejectedError(
          "A vault provider, keeper, or challenger key equals the depositor's own key; the device requires them to be disjoint."
        );
      const E = this.buildIntentFromTerms(g), B = this.fingerprintTerms(g);
      if (this.deviceState.phase === "intent-loaded") {
        if (this.deviceState.termsKey === B) return;
        throw new WalletError({
          code: ERROR_CODES.DEVICE_CEREMONY_INVALID,
          message: `${WALLET_PROVIDER_NAME$4} already holds a different approved intent on this connection — the device admits one ceremony per DERIVE_CONTEXT_HASH. Restart the flow from derivation.`,
          wallet: WALLET_PROVIDER_NAME$4
        });
      }
      if (this.deviceState.phase === "idle") {
        if (this.dispatchRecordComplete && (await this.awaitExpectedApp(c), this.assertSameConnection(c)), await this.resumeIntentFromDevice(g)) return;
        throw new WalletError({
          code: ERROR_CODES.DEVICE_CEREMONY_INVALID,
          message: `${WALLET_PROVIDER_NAME$4} has no freshly derived context root on this connection — the device requires DERIVE_CONTEXT_HASH before an intent can be approved. Restart the flow from derivation.`,
          wallet: WALLET_PROVIDER_NAME$4
        });
      }
      this.deviceState = { phase: "idle" }, await approveVaultIntent(y, E), this.assertSameConnection(c), this.deviceState = {
        phase: "intent-loaded",
        termsKey: B,
        prepeginTxidInternalHex: Buffer.from(E.scalars.prepeginTxidInternal).toString("hex"),
        htlcRefundTimelock: E.scalars.htlcRefundTimelock
      }, this.signedFingerprints = /* @__PURE__ */ new Set(), this.dispatchedSinceCounterReset = /* @__PURE__ */ new Set(), this.dispatchRecordComplete = !0;
    });
    /**
     * SIGN_PSBT under the loaded intent (#2219 B3). Tapscript PSBTs sign in
     * no-policy mode; all-key-path ones (Pre-PegIn, #2222) sign under the default
     * wallet policy after {@link augmentPsbtForWalletPolicy} adds the derivation
     * fields. A refund (#2371) and a Reclaim (#2714) — classified from the
     * provider's OWN parse, never a caller flag — are the standalone signs: the
     * device accepts them with no loaded intent (`sign_psbt_validate.c:902-916`;
     * Reclaim `:2524-2708` @ b89dd580), so only the intent requirement is waived;
     * every other gate still runs, and {@link augmentPsbtForRefund} /
     * {@link augmentPsbtForReclaim} add the derivation entries the device
     * requires. Never finalizes — the SDK extracts signatures and finalizes
     * itself. Every rejection before the device loop starts leaves the mirror
     * and the loaded intent untouched, except a vault app found closed: the
     * device lost the intent, so the mirror drops it too.
     */
    Vi(this, "signPsbt", async (g, c) => this.withDeviceOperation(
      "signPsbt",
      () => this.withSignAbort(async (y) => {
        const t = classifyRefundPsbt(g);
        if (t !== void 0)
          try {
            assertRefundPsbtSignable(t);
          } catch (v) {
            throw toStagingWalletError(v, "signPsbt rejected before any device I/O");
          }
        const d = t === void 0 ? classifyReclaimPsbt(g) : void 0, E = t !== void 0 || d !== void 0, B = await this.gateSignContext(!E);
        let D = g;
        if (t !== void 0) {
          this.assertRefundSignable(t, B.depositorXOnlyHex);
          const { masterFingerprintHex: v } = await this.getPolicyContext();
          this.assertSameConnection(B.generation);
          try {
            D = augmentPsbtForRefund({
              psbtHex: g,
              depositorXOnlyHex: B.depositorXOnlyHex,
              masterFingerprintHex: v,
              depositorPath: this.depositorPath
            });
          } catch (F) {
            throw toStagingWalletError(F, "signPsbt rejected before the signing ceremony");
          }
        }
        if (d !== void 0) {
          if (d.leafKeyHex !== B.depositorXOnlyHex)
            throw new WalletError({
              code: ERROR_CODES.INVALID_PARAMS,
              message: `${WALLET_PROVIDER_NAME$4}: the reclaim leaf key is not this device's depositor key — this device cannot sign this reclaim.`,
              wallet: WALLET_PROVIDER_NAME$4
            });
          const { masterFingerprintHex: v } = await this.getPolicyContext();
          this.assertSameConnection(B.generation);
          try {
            D = augmentPsbtForReclaim({
              psbtHex: g,
              depositorXOnlyHex: B.depositorXOnlyHex,
              masterFingerprintHex: v,
              depositorPath: this.depositorPath
            });
          } catch (F) {
            throw toStagingWalletError(F, "signPsbt rejected before the signing ceremony");
          }
        }
        const x = await this.stagePsbt(
          D,
          c,
          "signPsbt",
          /* @__PURE__ */ new Set(),
          B.depositorXOnlyHex,
          // A refund or Reclaim routes to the device's standalone sign path in
          // EVERY vault state (dispatch: Reclaim `sign_psbt_validate.c:3781-3783`,
          // refund `:3825` @ b89dd580), and that
          // path consumes no dedup mask or cap (`sign_custom_inputs.c`,
          // standalone section — contrast PegIn `:184` and Payout `:401`), so
          // re-signing one is always a fresh user-approved ceremony.
          E
        );
        return this.assertSameConnection(B.generation), this.signStaged(x, B, y);
      })
    ));
    /**
     * SIGN_PSBT for the depositor-as-claimer ceremony (#2111), kept OUT of
     * {@link signPsbt} so the deposit flow's path stays byte-identical. The kind
     * comes from the provider's OWN parse plus the single requested input
     * (`classifyDelegatedClaimPsbt`), never a caller flag; anything else is
     * refused before any device I/O — this method signs claim PSBTs only.
     *
     * Per kind: the depositor Payout is the deposit-time shape and goes down
     * {@link signPsbt} unchanged (the intent-bound Payout signer takes its path
     * from the intent, `sign_custom_inputs.c:403-412`). The other four need
     * the derivation entry {@link augmentPsbtForDelegatedClaim} writes. The
     * Assert is intent-bound — its signer prefix is pinned to the loaded intent
     * (`sign_psbt_validate.c:3710-3716`) — so it keeps the intent requirement;
     * Claim, WronglyChallenged and the claimer Payout (PayoutFinalize) are
     * standalone, accepted with no intent (`:3654`, `:3677`, `:3681`), so for
     * them only that requirement is waived. The claimer Payout is additionally
     * refused WHILE an intent is loaded: the dispatcher routes any 2-in/2-out
     * PSBT whose input 0 spends a loaded vault's PegIn to the intent-bound
     * Payout validator (`:3600-3634`), whose per-slot dedup — the depositor
     * Payout was already signed under that intent, in ceremony order — WIPES
     * the intent with SW_CAP_EXCEEDED (`:1765-1775`; otherwise SW_INCORRECT_DATA
     * at the input-0 leaf check, `:1863`). Refusing here costs no device I/O
     * and keeps the intent.
     *
     * Nothing else is validated here: every term of these transactions is the
     * device's to check, and a rejection on these paths costs no loaded intent.
     * Never finalizes. Every rejection before the device loop leaves the mirror
     * and the loaded intent untouched, except a vault app found closed: the
     * device lost the intent, so the mirror drops it too.
     */
    Vi(this, "signDelegatedClaimPsbt", async (g, c) => {
      const y = singleRequestedInputIndex(c);
      if (y === void 0)
        throw new WalletError({
          code: ERROR_CODES.INVALID_PARAMS,
          message: `${WALLET_PROVIDER_NAME$4}: signDelegatedClaimPsbt needs exactly one entry in options.signInputs — the input the claim ceremony signs.`,
          wallet: WALLET_PROVIDER_NAME$4
        });
      const t = classifyDelegatedClaimPsbt(g, y);
      if (t === void 0)
        throw new WalletError({
          code: ERROR_CODES.INVALID_PARAMS,
          message: `${WALLET_PROVIDER_NAME$4}: not a delegated-claim PSBT for the requested input — signDelegatedClaimPsbt signs the claim ceremony's shapes only; anything else goes through signPsbt.`,
          wallet: WALLET_PROVIDER_NAME$4
        });
      if (t.kind === "payoutDepositor") return this.signPsbt(g, c);
      const d = `signDelegatedClaimPsbt[${t.kind}@${t.signInputIndex}]`;
      return this.withDeviceOperation(
        "signDelegatedClaimPsbt",
        () => this.withSignAbort(async (E) => {
          if (t.kind === "payoutFinalize" && this.deviceState.phase === "intent-loaded")
            throw new WalletError({
              code: ERROR_CODES.DEVICE_CEREMONY_INVALID,
              message: `${WALLET_PROVIDER_NAME$4} holds an approved intent — under it the device refuses the claimer Payout and wipes the intent. Release the intent with deriveContextHash first.`,
              wallet: WALLET_PROVIDER_NAME$4
            });
          const B = await this.gateSignContext(t.kind === "assert");
          if (t.leafKeyHex !== B.depositorXOnlyHex)
            throw new WalletError({
              code: ERROR_CODES.INVALID_PARAMS,
              message: `${WALLET_PROVIDER_NAME$4}: the ${t.kind} leaf key is not this device's depositor key — this device cannot sign it.`,
              wallet: WALLET_PROVIDER_NAME$4
            });
          const { masterFingerprintHex: D } = await this.getPolicyContext();
          this.assertSameConnection(B.generation);
          let x;
          try {
            x = augmentPsbtForDelegatedClaim({
              kind: t.kind,
              psbtHex: g,
              depositorXOnlyHex: B.depositorXOnlyHex,
              masterFingerprintHex: D,
              depositorPath: this.depositorPath
            });
          } catch (F) {
            throw toStagingWalletError(F, `${d} rejected before the signing ceremony`);
          }
          const v = await this.stagePsbt(x, c, d, /* @__PURE__ */ new Set(), B.depositorXOnlyHex, !0);
          return this.assertSameConnection(B.generation), this.signStaged(v, B, E);
        })
      );
    });
    /**
     * Device ceremonies run strictly sequentially, array order, fail-fast — a
     * concurrent APDU would be eaten with 0x6A80 and desync the loop. The WHOLE
     * batch is staged before the first ceremony, so a host-detectable defect at
     * element k cannot burn k approvals whose signatures the fail-fast reject
     * would discard.
     */
    Vi(this, "signPsbts", async (g, c) => this.withDeviceOperation(
      "signPsbts",
      () => this.withSignAbort(async (y) => {
        if (g.length === 0)
          throw new WalletError({
            code: ERROR_CODES.PSBTS_HEXES_REQUIRED,
            message: `${WALLET_PROVIDER_NAME$4} signPsbts requires at least one PSBT.`,
            wallet: WALLET_PROVIDER_NAME$4
          });
        for (const [D, x] of g.entries())
          if (classifyRefundPsbt(x) !== void 0 || classifyReclaimPsbt(x) !== void 0)
            throw new WalletError({
              code: ERROR_CODES.INVALID_PARAMS,
              message: `signPsbts[${D}]: a refund or reclaim signs standalone via signPsbt — it cannot be part of a batch ceremony.`,
              wallet: WALLET_PROVIDER_NAME$4
            });
        const t = await this.gateSignContext(), d = /* @__PURE__ */ new Set(), E = [];
        for (const [D, x] of g.entries()) {
          const v = await this.stagePsbt(
            x,
            c == null ? void 0 : c[D],
            `signPsbts[${D}]`,
            d,
            t.depositorXOnlyHex
          );
          d.add(v.fingerprintKey), E.push(v);
        }
        const B = [];
        for (const D of E) {
          if (y.signal.aborted) {
            const x = t.generation === this.connectionGeneration;
            throw x && (this.deviceState = { phase: "idle" }, this.signedFingerprints = /* @__PURE__ */ new Set()), new WalletError({
              code: x ? ERROR_CODES.CONNECTION_REJECTED : ERROR_CODES.WALLET_NOT_CONNECTED,
              message: x ? `Signing canceled after ${B.length} of ${g.length} PSBT(s) — the ceremony restarts from the device approval screens on retry.` : `${WALLET_PROVIDER_NAME$4} stopped signing (disconnected) after ${B.length} of ${g.length} PSBT(s).`,
              wallet: WALLET_PROVIDER_NAME$4
            });
          }
          this.assertSameConnection(t.generation), B.push(await this.signStaged(D, t, y)), this.emitSigningProgress({ completed: B.length, total: g.length });
        }
        return B;
      })
    ));
    /**
     * User cancel of the in-flight ceremony: aborts WITHOUT teardown, settling
     * as CONNECTION_REJECTED at the next exchange boundary — possibly only after
     * the user acts on the device, so callers hold a "cancel requested" state
     * until the sign promise settles. Also ends an app wait at once, with the
     * outcome {@link appWaitCanceled} describes (DEVICE_WRONG_APP once a wait
     * was announced). No-op when idle.
     */
    Vi(this, "cancelSigning", () => {
      var g, c;
      (g = this.signAbortController) == null || g.abort(), (c = this.appWaitController) == null || c.abort();
    });
    /** Optional affordance (see `IBTCProvider`): the device-app wait, across reconnects. */
    Vi(this, "subscribeDeviceAppState", (g) => (this.deviceAppStateListeners.add(g), () => {
      this.deviceAppStateListeners.delete(g);
    }));
    /** Optional affordance (see `IBTCProvider`): per-ceremony ticks out of a `signPsbts` batch. */
    Vi(this, "subscribeSigningProgress", (g) => (this.signingProgressListeners.add(g), () => {
      this.signingProgressListeners.delete(g);
    }));
    /**
     * BIP-322 simple proof of possession via SIGN_PSBT tx_version 0 (#2221).
     * State-independent on the device (`sign_psbt_validate.c:3573-3578`): no
     * approved intent is required, and signing it never touches the intent
     * mirror or the signed-fingerprint set — with ONE exception: a user cancel
     * resets both via {@link classifySignFailure}'s uniform post-cancel policy,
     * so a cancelled PoP costs a full derive + re-approve like any other cancel.
     * When an intent IS loaded the device requires the PoP key to equal the
     * intent's depositor key (`:3071-3076`) — both derive from `depositorPath`,
     * so that holds by construction.
     */
    Vi(this, "signMessage", async (g, c) => this.withDeviceOperation(
      "signMessage",
      () => this.withSignAbort(async (y) => {
        if (c !== "bip322-simple")
          throw new WalletError({
            code: ERROR_CODES.WALLET_METHOD_NOT_SUPPORTED,
            message: `${WALLET_PROVIDER_NAME$4} signs BIP-322 (bip322-simple) messages only; ${c} is not supported.`,
            wallet: WALLET_PROVIDER_NAME$4
          });
        const t = await this.gateSignContext(!1), { policy: d, masterFingerprintHex: E } = await this.getPolicyContext();
        this.assertSameConnection(t.generation);
        const B = buildPopPsbtHex({
          message: g,
          depositorXOnlyHex: t.depositorXOnlyHex,
          masterFingerprintHex: E,
          depositorPath: this.depositorPath
        });
        let D;
        try {
          D = prepareSignPsbt({ psbtHex: B, depositorXOnlyHex: t.depositorXOnlyHex, walletPolicy: d });
        } catch (F) {
          throw toStagingWalletError(F, "signMessage rejected before device I/O");
        }
        let x;
        try {
          x = await signPreparedVaultPsbt(t.rawSend, D, {
            signal: y.signal,
            appIdentity: t.session.appName !== void 0 ? { appName: t.session.appName, appVersion: t.session.appVersion } : void 0
          });
        } catch (F) {
          throw this.classifySignFailure(F, t.generation, "signMessage");
        }
        this.assertSameConnection(t.generation);
        const [v] = x.yields;
        if (x.yields.length !== 1 || v.kind !== "taproot-keypath" || v.signature.length !== SCHNORR_SIG_BYTES)
          throw new WalletError({
            code: ERROR_CODES.INVALID_PARAMS,
            message: `${WALLET_PROVIDER_NAME$4} returned no key-path signature for the proof of possession.`,
            wallet: WALLET_PROVIDER_NAME$4
          });
        return `0x${BIP322_P2TR_WITNESS_PREFIX_HEX}${Buffer.from(v.signature).toString("hex")}`;
      })
    ));
    Vi(this, "getNetwork", async () => this.network);
    /** Hardware wallets hold no inscription index. */
    Vi(this, "getInscriptions", async () => []);
    /** A USB device has no account-switch event to subscribe to. */
    Vi(this, "on", () => {
    });
    Vi(this, "off", () => {
    });
    Vi(this, "getWalletProviderName", async () => WALLET_PROVIDER_NAME$4);
    Vi(this, "getWalletProviderIcon", async () => logo$3);
    this.network = g;
  }
  /**
   * See {@link activeOperation}. The busy throw costs zero device I/O. Two
   * overlapping ceremonies are a caller bug; {@link gateUngatedSession} also
   * holds the lock for one GET_APP_AND_VERSION when a connect is retried on a
   * live session, and {@link readDevicePubkeyHex} does the same on a session
   * whose preflight learned no app, so a ceremony started in that window hits
   * this legitimately. The window is one instant exchange: the SDK answers a
   * locked device with 0x5515 before the app's dispatcher sees it
   * (`sdk:io_legacy/src/os_io_legacy.c:414-423` @ v26.6.1), and DMK 1.7.1
   * never holds the read for an unlock (IntentQueueService has no lock gating).
   * An operation held in {@link awaitExpectedApp} keeps the lock for the
   * whole wait; {@link cancelSigning} ends it.
   *
   * A DEVICE_DISCONNECTED failure from any exchange tears the session down
   * here (generation-guarded), so the next `connectWallet()` opens a fresh one
   * instead of reusing a session DMK may still briefly report as alive.
   */
  async withDeviceOperation(g, c) {
    if (this.activeOperation)
      throw new WalletError({
        code: ERROR_CODES.INVALID_PARAMS,
        message: `${WALLET_PROVIDER_NAME$4} is already running a device ceremony; wait for it to finish before calling ${g}.`,
        wallet: WALLET_PROVIDER_NAME$4
      });
    const y = Symbol(g);
    this.activeOperation = y;
    const t = this.connectionGeneration;
    try {
      return await c();
    } catch (d) {
      throw d instanceof WalletError && d.code === ERROR_CODES.DEVICE_DISCONNECTED && this.session && t === this.connectionGeneration && await this.teardownSession(), d;
    } finally {
      this.activeOperation === y && (this.activeOperation = void 0);
    }
  }
  get depositorPath() {
    return [
      BIP86_PURPOSE + HARDENED,
      COIN_TYPE_BY_NETWORK[this.network] + HARDENED,
      ACCOUNT_INDEX + HARDENED,
      CHANGE_INDEX,
      ADDRESS_INDEX
    ];
  }
  /** `m/86'/coin'/0'` — the key-info origin of the default policy (`test_screen7_pop.py:135-142`). */
  get accountPath() {
    return [BIP86_PURPOSE + HARDENED, COIN_TYPE_BY_NETWORK[this.network] + HARDENED, ACCOUNT_INDEX + HARDENED];
  }
  requireSession() {
    if (!this.session) throw notConnectedError();
    return this.session;
  }
  requireSender() {
    if (!this.send) throw notConnectedError();
    return this.send;
  }
  /**
   * A session installed after a failed preflight was never gated, and a
   * retry (unlock, open an app, connect again) reuses it while it lives. Read
   * the app now and gate it. The phase alone is not "no ceremony in flight"
   * (derive, approve, PoP and refund all send at idle), so the read skips a
   * running ceremony and holds the ceremony lock itself.
   */
  async gateUngatedSession(g, c) {
    if (c !== this.disconnectToken || this.session !== g || g.appName !== void 0 || this.activeOperation || this.deviceState.phase !== "idle") return;
    const y = await this.withDeviceOperation("connectWallet", () => refreshSessionApp(g));
    if (c !== this.disconnectToken || this.session !== g) return;
    const t = this.refuseUnexpectedApp(y);
    if (t)
      throw await this.teardownSession(), t;
    this.installSessionApp(y);
  }
  /**
   * Adopt a re-read app identity for the SAME session: keep the generation,
   * rebuild the senders so the app hint names the app. A read that learned
   * nothing new leaves the senders alone.
   */
  installSessionApp(g) {
    const c = this.session;
    g.appName !== void 0 && ((c == null ? void 0 : c.appName) === g.appName && c.appVersion === g.appVersion || (this.session = g, this.send = withWalletErrorMapping(createDmkApduSender(g)), this.rawSend = createDmkRawApduSender(g)));
  }
  /**
   * Hold a device operation until the vault app is open: read the
   * open app, and while it is another app, the dashboard, or unreadable (a
   * locked device answers the read with 0x5515, which leaves no identity),
   * announce `awaiting-app` and re-read every {@link APP_WAIT_POLL_INTERVAL_MS}.
   * Each read starts from a handle with the app identity cleared:
   * `refreshSessionApp` keeps the handle's own fields when the read fails, and
   * the connect-time name would otherwise pass for the vault app. Returns once the
   * expected app answers; the version floor still applies to it. Every tick
   * probes liveness first — a session lost to the app switch's USB
   * re-enumeration surfaces as DEVICE_DISCONNECTED, not as a wait
   * that never ends.
   *
   * GET_APP_AND_VERSION leaves a loaded intent in place. It is answered below
   * the app (it returns a name, which the app's own dispatcher never does for
   * a non-`CLA_APP` class), and the vault context is reset only by the vault
   * handlers and the signing paths (`fw:` `vault_context_invalidate` call
   * sites @ b89dd580). The Speculos e2e pins it on the 0.11.0 ELF (stage 4c).
   * So the read may run under a loaded intent — between the phases of one
   * ceremony it still must not.
   *
   * `onOtherApp` runs on a read that names a different app (the dashboard
   * included), which means the vault app was exited and its RAM-held intent
   * with it; a locked device names none and keeps the plain wait. It may throw
   * to end the wait. Runs inside the caller's {@link withDeviceOperation} lock.
   */
  async awaitExpectedApp(g, c) {
    const y = APP_NAME_BY_NETWORK[this.network], t = new AbortController();
    this.appWaitController = t;
    const d = this.signAbortController ? [t.signal, this.signAbortController.signal] : [t.signal], E = () => d.some((x) => x.aborted);
    let B = !1, D = !1;
    try {
      for (; ; ) {
        const x = this.requireSession();
        if (!await this.probeSessionAlive(x))
          throw g === this.connectionGeneration && await this.teardownSession(), disconnectedError();
        if (this.assertSameConnection(g), E()) throw this.appWaitCanceled(y, g, B);
        const v = await refreshSessionApp(withoutAppIdentity(x));
        if (this.assertSameConnection(g), E()) throw this.appWaitCanceled(y, g, B);
        if (v.appName === y) {
          const F = this.refuseUnexpectedApp(v);
          if (F) throw F;
          if (!B || D) {
            this.installSessionApp(v);
            return;
          }
          if (D = !0, await abortableDelay(APP_OPEN_SETTLE_MS, d), E()) throw this.appWaitCanceled(y, g, B);
          continue;
        }
        if (D = !1, c && v.appName !== void 0 && c(), B || (B = !0, this.emitDeviceAppState({ status: "awaiting-app", expectedAppName: y })), await abortableDelay(APP_WAIT_POLL_INTERVAL_MS, d), E()) throw this.appWaitCanceled(y, g, B);
      }
    } finally {
      this.appWaitController === t && (this.appWaitController = void 0), B && this.emitDeviceAppState({ status: "ready" });
    }
  }
  /**
   * The outcome of a cancel inside {@link awaitExpectedApp}. Teardown aborts
   * the wait too, and that reports the lost connection instead. Otherwise the
   * outcome follows what the user saw:
   * - a wait was announced (another app, the dashboard, or a locked device):
   *   DEVICE_WRONG_APP — nothing was rejected on the device, and the
   *   resumable "open the vault app and try again" is what they need next;
   * - no wait was announced (the cancel landed during the gate's probe or
   *   first read, e.g. Cancel signing on a PoP): CONNECTION_REJECTED, the same
   *   outcome as a cancelled signature, so a caller's cancel copy applies.
   */
  appWaitCanceled(g, c, y) {
    return this.assertSameConnection(c), y ? new WalletError({
      code: ERROR_CODES.DEVICE_WRONG_APP,
      message: `Canceled while waiting for the ${g} app on your Ledger. Open it and try again.`,
      wallet: WALLET_PROVIDER_NAME$4
    }) : new WalletError({
      code: ERROR_CODES.CONNECTION_REJECTED,
      message: `${WALLET_PROVIDER_NAME$4}: canceled before anything was sent to the device.`,
      wallet: WALLET_PROVIDER_NAME$4
    });
  }
  /**
   * After a sign failure that dropped the mirror to idle, tell a device that left the vault app apart from any other
   * failure. The app switch wiped the approved intent, so once the user
   * reopens the app the typed outcome is DEVICE_CEREMONY_INVALID — the
   * signal to re-run derive → approve. With the vault app open, the original
   * failure stands.
   */
  async reclassifyAfterAppSwitch(g, c) {
    const y = this.session;
    if (!y || c !== this.connectionGeneration || this.deviceState.phase !== "idle" || g.code !== ERROR_CODES.DEVICE_WRONG_APP && g.code !== ERROR_CODES.UNKNOWN_ERROR)
      return g;
    if (!await this.probeSessionAlive(y)) return disconnectedError();
    const t = await refreshSessionApp(withoutAppIdentity(y));
    return this.assertSameConnection(c), t.appName === APP_NAME_BY_NETWORK[this.network] ? g : (await this.awaitExpectedApp(c), new WalletError(
      {
        code: ERROR_CODES.DEVICE_CEREMONY_INVALID,
        message: `${WALLET_PROVIDER_NAME$4} left the vault app, which cleared the approved deposit — approve it again from derivation.`,
        wallet: WALLET_PROVIDER_NAME$4
      },
      { cause: g }
    ));
  }
  /**
   * Refuse, before the first vault APDU, an app the connect preflight shows is
   * wrong, too old, or newer than the host encoding supports. A failed
   * preflight (no name) is let through: a connect retry or the account key
   * read re-reads the app before the key is read.
   */
  refuseUnexpectedApp(g) {
    const c = APP_NAME_BY_NETWORK[this.network];
    if (g.appName !== void 0 && g.appName !== c)
      return new WalletError({
        code: ERROR_CODES.DEVICE_WRONG_APP,
        message: `Open the ${c} app on your Ledger and try again.`,
        wallet: WALLET_PROVIDER_NAME$4
      });
    if (g.appVersion === void 0) return;
    const y = checkMinVersion(g.appVersion, MIN_APP_VERSION);
    if (y === "below")
      return new WalletError({
        code: ERROR_CODES.INCOMPATIBLE_WALLET_VERSION,
        message: `Your ${c} app is out of date (${g.appVersion}). Update it to ${MIN_APP_VERSION} and try again.`,
        wallet: WALLET_PROVIDER_NAME$4,
        version: g.appVersion
      });
    if (y === "unparseable")
      return new WalletError({
        code: ERROR_CODES.INCOMPATIBLE_WALLET_VERSION,
        message: `Unable to verify your ${c} app version. Install the official app ${MIN_APP_VERSION} and try again.`,
        wallet: WALLET_PROVIDER_NAME$4
      });
    if (checkMinVersion(g.appVersion, FIRST_UNSUPPORTED_APP_VERSION) === "ok")
      return new WalletError({
        code: ERROR_CODES.INCOMPATIBLE_WALLET_VERSION,
        message: `This site does not support your ${c} app version (${g.appVersion}) yet. Try again after this site is updated.`,
        wallet: WALLET_PROVIDER_NAME$4,
        version: g.appVersion
      });
  }
  /**
   * The one device read, cached per connection. A failure clears the cache
   * (identity-guarded so a stale rejection can't wipe a newer connection's).
   */
  getDevicePubkeyHex() {
    if (!this.pubkeyHexPromise) {
      const g = this.readDevicePubkeyHex().catch((c) => {
        throw this.pubkeyHexPromise === g && (this.pubkeyHexPromise = void 0), c;
      });
      this.pubkeyHexPromise = g;
    }
    return this.pubkeyHexPromise;
  }
  /**
   * Reads the key only once the vault app is confirmed on this session. A
   * session whose connect preflight learned nothing (locked device, failed
   * read) gets one app read here, with no wait, so a flow retried after a
   * reconnect recovers once the user unlocks and opens the app. When that app
   * read runs, a dead session reports as disconnected, not as a wrong app.
   */
  async readDevicePubkeyHex() {
    var t;
    const g = this.requireSession(), c = this.connectionGeneration, y = APP_NAME_BY_NETWORK[this.network];
    if (g.appName === void 0 && !this.activeOperation && this.deviceState.phase === "idle") {
      const d = await this.withDeviceOperation("getPublicKeyHex", async () => {
        if (!await this.probeSessionAlive(g)) throw disconnectedError();
        return refreshSessionApp(g);
      });
      this.assertSameConnection(c);
      const E = this.refuseUnexpectedApp(d);
      if (E) throw E;
      d.appName === y && this.installSessionApp(d);
    }
    if (((t = this.session) == null ? void 0 : t.appName) !== y)
      throw new WalletError({
        code: ERROR_CODES.DEVICE_WRONG_APP,
        message: `Unlock your Ledger, open the ${y} app, and try again.`,
        wallet: WALLET_PROVIDER_NAME$4
      });
    return getXOnlyPublicKeyHex(this.requireSender(), this.depositorPath, toNetwork(this.network).bip32);
  }
  /**
   * Default `tr(@0/**)` policy over the device's master fingerprint and the
   * verbatim account xpub — key-path signing (PoP, Pre-PegIn) needs it.
   * Two silent reads, cached per connection; a failure clears the cache.
   */
  getPolicyContext() {
    if (!this.policyContextPromise) {
      const g = this.requireSender(), c = this.connectionGeneration, y = (async () => {
        const [t, d, E] = await Promise.all([
          getMasterFingerprintHex(g),
          getExtendedPublicKey(g, this.accountPath, toNetwork(this.network).bip32),
          this.getDevicePubkeyHex()
        ]);
        if (this.assertSameConnection(c), deriveReceiveXOnlyHex(d, toNetwork(this.network).bip32, ADDRESS_INDEX) !== E)
          throw new WalletError({
            code: ERROR_CODES.CONNECTION_FAILED,
            message: `${WALLET_PROVIDER_NAME$4} account xpub does not derive the depositor key; the wallet policy would bind a different key than the intent.`,
            wallet: WALLET_PROVIDER_NAME$4
          });
        return { policy: buildDefaultTaprootPolicy({
          masterFingerprintHex: t,
          coinType: COIN_TYPE_BY_NETWORK[this.network],
          accountIndex: ACCOUNT_INDEX,
          accountXpub: d,
          bip32Versions: toNetwork(this.network).bip32
        }), masterFingerprintHex: t };
      })().catch((t) => {
        throw this.policyContextPromise === y && (this.policyContextPromise = void 0), t;
      });
      this.policyContextPromise = y;
    }
    return this.policyContextPromise;
  }
  /**
   * Refuse to commit host state if the connection changed during a device
   * await — a disconnect/reconnect racing a late APDU resolution would
   * otherwise land stale state on the new connection.
   */
  assertSameConnection(g) {
    if (g !== this.connectionGeneration)
      throw new WalletError({
        code: ERROR_CODES.WALLET_NOT_CONNECTED,
        message: `${WALLET_PROVIDER_NAME$4} connection changed during the ceremony; restart from derivation.`,
        wallet: WALLET_PROVIDER_NAME$4
      });
  }
  /**
   * Zero-I/O refund gates (#2371). The key check pre-empts the device's own
   * derive-and-compare (`sign_psbt_validate.c:920-965`); the vault check
   * pre-empts the INTENT_LOADED pins on the leaf CSV (`:906-910`) and input 0's
   * prevout (`:1092-1097`) — both fire pre-approval on-device, but as an opaque
   * SW_INCORRECT_DATA whose failure path would also take {@link signStaged}'s
   * pessimistic mirror reset. Rejecting here keeps the typed error AND the
   * loaded intent. No automatic reset — tearing down a loaded ceremony is
   * never a silent side effect of a refund attempt.
   */
  assertRefundSignable(g, c) {
    if (g.leafKeyHex !== c)
      throw new WalletError({
        code: ERROR_CODES.INVALID_PARAMS,
        message: `${WALLET_PROVIDER_NAME$4}: the refund leaf key is not this device's depositor key — this device cannot sign this refund.`,
        wallet: WALLET_PROVIDER_NAME$4
      });
    const y = this.deviceState;
    if (y.phase === "intent-loaded" && (g.inputTxidInternalHex !== y.prepeginTxidInternalHex || g.csv !== y.htlcRefundTimelock))
      throw new WalletError({
        code: ERROR_CODES.DEVICE_CEREMONY_INVALID,
        message: `${WALLET_PROVIDER_NAME$4} holds an approved intent for a different vault — the device pins a refund's timelock and Pre-PegIn txid to the loaded intent and would reject this one. Reconnect the device (or restart that deposit's flow from derivation) and retry the refund.`,
        wallet: WALLET_PROVIDER_NAME$4
      });
  }
  // Display-only, like emitSigningProgress: a listener bug must not break the
  // operation, so it is reported rather than rethrown.
  emitDeviceAppState(g) {
    for (const c of [...this.deviceAppStateListeners])
      try {
        c(g);
      } catch (y) {
        reportListenerError("device-app state", y);
      }
  }
  // Display-only: a listener bug must not abort a non-idempotent ceremony
  // (same contract as the signer's per-YIELD onProgress).
  emitSigningProgress(g) {
    for (const c of [...this.signingProgressListeners])
      try {
        c(g);
      } catch (y) {
        reportListenerError("signing progress", y);
      }
  }
  /**
   * ONE AbortController per public sign call (plan D1) — it spans a whole
   * batch, so teardown's abort also stops the between-elements window.
   */
  async withSignAbort(g) {
    const c = new AbortController();
    this.signAbortController = c;
    try {
      return await g(c);
    } finally {
      this.signAbortController === c && (this.signAbortController = void 0);
    }
  }
  /**
   * The vault app was exited, so the device lost its RAM-held intent (ADR-001):
   * drop the mirror, and refuse an intent-bound sign before anything is sent.
   */
  dropIntentOnAppExit(g) {
    if (this.deviceState = { phase: "idle" }, !!g)
      throw new WalletError({
        code: ERROR_CODES.DEVICE_CEREMONY_INVALID,
        message: `The ${APP_NAME_BY_NETWORK[this.network]} app was closed, which cleared its approved intent. Restart the flow from derivation.`,
        wallet: WALLET_PROVIDER_NAME$4
      });
  }
  /**
   * Batch-level gates, once per public sign call: live session, loaded
   * intent, cached depositor key. A dead session tears everything down —
   * the device state is gone with it (generation-guarded against a racing
   * reconnect's fresh state). Every sign then waits for the vault app, so a
   * device that locked during a long wait is held until it is unlocked.
   *
   * `requireIntent: false` is for the signs the device itself accepts without
   * an intent — the state-independent PoP, the standalone refund (#2371) and
   * Reclaim (#2714), and
   * the three standalone delegated-claim kinds: Claim, WronglyChallenged and
   * the claimer Payout (#2111); every other caller keeps the default.
   */
  async gateSignContext(g = !0) {
    const c = this.requireSignContext().session, y = this.connectionGeneration;
    if (!await this.probeSessionAlive(c))
      throw y === this.connectionGeneration && await this.teardownSession(), disconnectedError();
    if (this.assertSameConnection(y), g && this.deviceState.phase !== "intent-loaded")
      throw new WalletError({
        code: ERROR_CODES.DEVICE_CEREMONY_INVALID,
        message: `${WALLET_PROVIDER_NAME$4} holds no approved intent on this connection — signing requires DERIVE_CONTEXT_HASH and an approved intent first. Restart the flow from derivation.`,
        wallet: WALLET_PROVIDER_NAME$4
      });
    this.deviceState.phase === "idle" ? await this.awaitExpectedApp(y) : await this.awaitExpectedApp(y, () => this.dropIntentOnAppExit(g));
    const { session: t, rawSend: d } = this.requireSignContext(), E = await this.getDevicePubkeyHex();
    return this.assertSameConnection(y), { session: t, rawSend: d, generation: y, depositorXOnlyHex: E };
  }
  /**
   * Host-only gates for one PSBT, plus the key-path policy routing. The only
   * device reads are the cached silent ones behind {@link getPolicyContext};
   * no ceremony runs, so every throw leaves the mirror and the loaded intent
   * untouched (plan D7).
   */
  async stagePsbt(g, c, y, t, d, E = !1) {
    var F;
    if ((c == null ? void 0 : c.autoFinalized) === !0)
      throw new WalletError({
        code: ERROR_CODES.INVALID_PARAMS,
        message: `${WALLET_PROVIDER_NAME$4} never finalizes; call ${y} with autoFinalized: false and finalize after signature extraction.`,
        wallet: WALLET_PROVIDER_NAME$4
      });
    const B = (F = c == null ? void 0 : c.signInputs) == null ? void 0 : F.map((M) => M.index);
    let D;
    try {
      D = prepareSignPsbt({ psbtHex: g, depositorXOnlyHex: d, signInputIndexes: B });
    } catch (M) {
      throw toStagingWalletError(M, `${y} rejected before device I/O`);
    }
    const x = new Set(Array.from(D.table.classifiedByInput.values(), (M) => M.kind));
    if (x.has("taproot-keypath")) {
      if (x.size > 1)
        throw new WalletError({
          code: ERROR_CODES.INVALID_PARAMS,
          message: `${y}: a vault PSBT is either all key-path (Pre-PegIn) or all tapscript — mixed inputs are not a vault flow.`,
          wallet: WALLET_PROVIDER_NAME$4
        });
      const { policy: M } = await this.getPolicyContext();
      let U;
      try {
        U = augmentPsbtForWalletPolicy({
          psbtHex: g,
          depositorXOnlyHex: d,
          walletPolicy: M,
          depositorPath: this.depositorPath
        });
      } catch (L) {
        throw toStagingWalletError(L, `${y} rejected before device I/O`);
      }
      try {
        D = prepareSignPsbt({ psbtHex: U, depositorXOnlyHex: d, walletPolicy: M });
      } catch (L) {
        throw toStagingWalletError(L, `${y} rejected at policy-mode prepare`);
      }
    }
    const v = signingRequestKey(D);
    if (t.has(v))
      throw new WalletError({
        code: ERROR_CODES.INVALID_PARAMS,
        message: `${y}: this PSBT is duplicated within the batch — the device would sign the same request twice.`,
        wallet: WALLET_PROVIDER_NAME$4
      });
    if (!E && this.signedFingerprints.has(v))
      throw new WalletError({
        code: ERROR_CODES.DEVICE_CEREMONY_INVALID,
        message: `${y}: this PSBT was already signed under the loaded intent — re-signing it would nullify the intent on the device. Restart the flow from derivation to sign it again.`,
        wallet: WALLET_PROVIDER_NAME$4
      });
    return { prepared: D, fingerprintKey: v, label: y, standalone: E };
  }
  /**
   * One device ceremony; every failure is classified against the mirror.
   *
   * Locked-device words on the INITIAL SIGN_PSBT keep the intent because the app
   * never ran it: 0x5515 is sent only by the SDK IO layer before dispatch
   * (`sdk:io_legacy/src/os_io_legacy.c:416`, inside the `io_exchange` receive
   * loop `:245-247` that the base app reads from, `base:src/boilerplate/dispatcher.c:74`);
   * 0x6982 exists in the SDK only under ENABLE_ADDRESS_BOOK
   * (`sdk:Makefile.standard_app:78-82`, unset in both Makefiles) and 0x5303 is not
   * defined at all; neither the app nor `base:` ever sends any of the three
   * (`base:src/boilerplate/sw.h:16-18` is a #define + _Static_assert only). Only the
   * sign loop proves the initial APDU was the refused one (`preDispatch`); a lock on
   * a CONTINUE or any other exchange is unproven — rounds may have run, caps may be
   * committed — and takes the pessimistic reset below.
   */
  async signStaged(g, c, y) {
    const { prepared: t, fingerprintKey: d, label: E, standalone: B } = g, { session: D, rawSend: x, generation: v } = c, F = this.dispatchedSinceCounterReset.has(d);
    B || this.dispatchedSinceCounterReset.add(d);
    try {
      const M = await signPreparedVaultPsbt(x, t, {
        signal: y.signal,
        appIdentity: D.appName !== void 0 ? { appName: D.appName, appVersion: D.appVersion } : void 0
      });
      return this.assertSameConnection(v), B || this.signedFingerprints.add(d), M.signedPsbtHex;
    } catch (M) {
      const U = this.classifySignFailure(M, v, E), L = isLedgerDeviceLockedError(M) && M.preDispatch === !0;
      throw L && !B && !F && v === this.connectionGeneration && this.dispatchedSinceCounterReset.delete(d), v === this.connectionGeneration && !isLedgerSignPsbtAbortedError(M) && !L && // Standalone signs keep the mirror: NOTHING on the device's refund
      // or delegated-claim paths invalidates the vault context — not the
      // validators' rejects (`sign_psbt_validate.c:811-1120` and
      // `:2369-2887`, `:3189-3494` hold none of the file's six invalidate
      // sites, all of which sit at `:742-2162` on the PegIn/Payout/NoPayout
      // paths), not the standalone sign section, not the review screen's
      // SW_DENY, and not the base app's PSBT-phase failures (zero vault
      // references in `base:sign_psbt.c` and its phases).
      // INTENT_LOADED is terminal until an explicit invalidate
      // (`vault_context.c:44-47`). The abort branch above stays uniform.
      !B ? (this.deviceState = { phase: "idle" }, this.signedFingerprints = /* @__PURE__ */ new Set(), await this.reclassifyAfterAppSwitch(U, v)) : U;
    }
  }
  /**
   * Classify one device-ceremony failure, for every SIGN_PSBT caller: a
   * disconnect must surface as a connection error, never as a generic
   * UNKNOWN_ERROR. Mirror resets are the caller's, except the user-cancel
   * branch, which resets here so PoP cancels take the same re-ceremony path.
   */
  classifySignFailure(g, c, y) {
    return c !== this.connectionGeneration ? new WalletError(
      {
        code: ERROR_CODES.WALLET_NOT_CONNECTED,
        message: `${WALLET_PROVIDER_NAME$4} connection changed during signing; restart from derivation.`,
        wallet: WALLET_PROVIDER_NAME$4
      },
      { cause: g instanceof Error ? g : void 0 }
    ) : isLedgerSignPsbtAbortedError(g) ? (this.deviceState = { phase: "idle" }, this.signedFingerprints = /* @__PURE__ */ new Set(), new WalletError(
      {
        code: ERROR_CODES.CONNECTION_REJECTED,
        message: `${y === "signPsbt" ? "" : `${y}: `}Signing canceled — the ceremony restarts from the device approval screens on retry.`,
        wallet: WALLET_PROVIDER_NAME$4
      },
      { cause: g }
    )) : toSignFailureWalletError(g, y);
  }
  /**
   * Liveness probe for the ceremony gates: `isSessionAlive` rethrows DMK's
   * plain `{_tag}` objects, which would otherwise escape unmapped.
   */
  async probeSessionAlive(g) {
    try {
      return await isSessionAlive(g);
    } catch (c) {
      throw toSignerWalletError(c) ?? c;
    }
  }
  /** Session + raw sender travel together (assigned/cleared as a unit in connect/teardown). */
  requireSignContext() {
    const { session: g, rawSend: c } = this;
    if (!g || !c) throw notConnectedError();
    return { session: g, rawSend: c };
  }
}
function singleRequestedInputIndex(o) {
  const g = o == null ? void 0 : o.signInputs;
  return g !== void 0 && g.length === 1 ? g[0].index : void 0;
}
function withoutAppIdentity(o) {
  return { ...o, appName: void 0, appVersion: void 0 };
}
function notConnectedError() {
  return new WalletError({
    code: ERROR_CODES.DEVICE_DISCONNECTED,
    message: `${WALLET_PROVIDER_NAME$4} is not connected; reconnect the device.`,
    wallet: WALLET_PROVIDER_NAME$4
  });
}
function disconnectedError() {
  return new WalletError({
    code: ERROR_CODES.DEVICE_DISCONNECTED,
    message: `${WALLET_PROVIDER_NAME$4} was disconnected; reconnect the device and retry.`,
    wallet: WALLET_PROVIDER_NAME$4
  });
}
const DMK_SESSION_LOST_TAGS = /* @__PURE__ */ new Set([
  "DeviceSessionNotFound",
  "DeviceDisconnectedWhileSendingError",
  "DeviceDisconnectedBeforeSendingApdu",
  "ReconnectionFailedError"
]);
function reportListenerError(o, g) {
  console.error(
    `[LedgerVaultProvider] ${o} listener threw:`,
    g instanceof Error ? g.message : String(g)
  );
}
function abortableDelay(o, g) {
  return new Promise((c) => {
    if (g.some((d) => d.aborted)) {
      c();
      return;
    }
    const y = setTimeout(t, o);
    for (const d of g) d.addEventListener("abort", t, { once: !0 });
    function t() {
      clearTimeout(y);
      for (const d of g) d.removeEventListener("abort", t);
      c();
    }
  });
}
function toStagingWalletError(o, g) {
  return new WalletError(
    {
      code: ERROR_CODES.INVALID_PARAMS,
      message: `${g}: ${o instanceof Error ? o.message : String(o)}`,
      wallet: WALLET_PROVIDER_NAME$4
    },
    { cause: o instanceof Error ? o : void 0 }
  );
}
function toSignFailureWalletError(o, g) {
  const c = g === "signPsbt" ? "" : `${g}: `;
  if (isLedgerDeviceError(o) && (o.statusWord === SW_BAD_STATE || o.statusWord === SW_CAP_EXCEEDED))
    return new WalletError(
      {
        code: ERROR_CODES.DEVICE_CEREMONY_INVALID,
        message: `${c}The device no longer holds the approved intent (${o.message}) — restart the flow from derivation.`,
        wallet: WALLET_PROVIDER_NAME$4
      },
      { cause: o }
    );
  if (isLedgerYieldMismatchError(o) || isLedgerSignPsbtIncompleteError(o) || isLedgerSignPsbtProtocolError(o))
    return new WalletError(
      {
        code: ERROR_CODES.DEVICE_CEREMONY_INVALID,
        message: `${c}${o.message} — restart the flow from derivation.`,
        wallet: WALLET_PROVIDER_NAME$4
      },
      { cause: o }
    );
  const y = toSignerWalletError(o);
  return y ? g === "signPsbt" ? y : new WalletError(
    { code: y.code, message: `${c}${y.message}`, wallet: WALLET_PROVIDER_NAME$4 },
    { cause: o }
  ) : new WalletError(
    {
      code: ERROR_CODES.UNKNOWN_ERROR,
      message: `${g} failed: ${o instanceof Error ? o.message : String(o)}`,
      wallet: WALLET_PROVIDER_NAME$4
    },
    { cause: o instanceof Error ? o : void 0 }
  );
}
function toSignerWalletError(o) {
  var c;
  if (isLedgerUserRefusedError(o))
    return new WalletError(
      { code: ERROR_CODES.CONNECTION_REJECTED, message: o.message, wallet: WALLET_PROVIDER_NAME$4 },
      { cause: o }
    );
  if (isLedgerDeviceLockedError(o))
    return new WalletError(
      { code: ERROR_CODES.DEVICE_LOCKED, message: o.message, wallet: WALLET_PROVIDER_NAME$4 },
      { cause: o }
    );
  if (isLedgerDeviceError(o) && (o.statusWord === SW_CLA_NOT_SUPPORTED || o.statusWord === SW_INS_NOT_SUPPORTED))
    return new WalletError(
      { code: ERROR_CODES.DEVICE_WRONG_APP, message: o.message, wallet: WALLET_PROVIDER_NAME$4 },
      { cause: o }
    );
  if (isLedgerDeviceError(o))
    return new WalletError(
      { code: ERROR_CODES.UNKNOWN_ERROR, message: o.message, wallet: WALLET_PROVIDER_NAME$4 },
      { cause: o }
    );
  const g = o;
  if (g != null && g._tag)
    return new WalletError(
      {
        code: DMK_SESSION_LOST_TAGS.has(g._tag) ? ERROR_CODES.DEVICE_DISCONNECTED : ERROR_CODES.CONNECTION_FAILED,
        message: ((c = g.originalError) == null ? void 0 : c.message) ?? g._tag,
        wallet: WALLET_PROVIDER_NAME$4
      },
      { cause: o }
    );
}
function withWalletErrorMapping(o) {
  return async (g) => {
    try {
      return await o(g);
    } catch (c) {
      throw toSignerWalletError(c) ?? c;
    }
  };
}
function fingerprintIntent(o) {
  const g = [
    encodeIntentScalars(o.scalars),
    ...o.groups.map(encodeIntentGroup),
    ...encodeKeyBatches(o.keeperPubkeys, o.challengerPubkeys)
  ];
  return Buffer.concat(g.map((c) => Buffer.from(c))).toString("hex");
}
function displayTxidToInternal(o) {
  const g = o.replace(/^0x/, "");
  if (!/^[0-9a-fA-F]{64}$/.test(g))
    throw new DepositTermsRejectedError(`prepeginTxid must be 64 hex chars, got "${o}"`);
  return Uint8Array.from(Buffer.from(g, "hex")).reverse();
}
function canonicalPubkey(o) {
  return o.replace(/^0x/, "").toLowerCase();
}
function hexToXOnly(o, g) {
  const c = o.replace(/^0x/, "");
  if (!/^[0-9a-fA-F]{64}$/.test(c))
    throw new DepositTermsRejectedError(`${g} must be a 32-byte x-only key, got "${o}"`);
  return Uint8Array.from(Buffer.from(c, "hex"));
}
const LEDGER_WALLET_APP_PROVIDER = 4, connectGuide = ({ network: o }) => {
  const g = APP_NAME_BY_NETWORK[o];
  return {
    steps: [
      "Plug in your Ledger and unlock it with your PIN.",
      `Open the ${g} app on your Ledger.`,
      "Close Ledger Wallet (formerly Ledger Live) if it is open. It can take over the connection to your Ledger.",
      "Select Connect. If your browser asks, choose your Ledger."
    ],
    installSteps: [
      `In Ledger Wallet, open Settings → Experimental features. Turn on My Ledger provider and set it to ${LEDGER_WALLET_APP_PROVIDER}.`,
      `Go to My Ledger and install the ${g} app.`,
      "Then close Ledger Wallet and follow the steps at the top."
    ]
  };
}, metadata$6 = {
  id: "ledger_btc_vault",
  name: WALLET_PROVIDER_NAME$4,
  icon: logo$3,
  iconBackground: MONOCHROME_MARK_BACKGROUND,
  docs: "https://www.ledger.com",
  createProvider: (o, g) => new LedgerVaultProvider(g.network),
  networks: [Network.MAINNET, Network.SIGNET],
  label: "Hardware wallet",
  hardware: !0,
  connectGuide
};
async function withTimeout(o, g, c) {
  let y;
  const t = new Promise((d, E) => {
    y = setTimeout(() => E(c()), g);
  });
  try {
    return await Promise.race([o, t]);
  } finally {
    y !== void 0 && clearTimeout(y);
  }
}
async function assertDeriveAccountUnchanged(o) {
  var c;
  const g = () => o.currentIdentityVersion() === o.identityVersionAtStart;
  if (g()) {
    const y = await o.readLiveIdentity();
    if (g() && y.address && ((c = y.publicKeyHex) == null ? void 0 : c.toLowerCase()) === o.expectedPublicKeyHex.toLowerCase())
      return;
  }
  throw new WalletError({
    code: ERROR_CODES.WALLET_ACCOUNT_CHANGED,
    message: `${o.walletName} wallet account or network changed while deriving the context hash. Switch back to the connected account and network, then try again.`,
    wallet: o.walletName
  });
}
const MIN_OKX_VERSION = "4.5.0";
function checkOKXVersion(o) {
  return checkMinVersion(o, MIN_OKX_VERSION);
}
const PROVIDER_NAMES = {
  [Network.MAINNET]: "bitcoin",
  [Network.TESTNET]: "bitcoinTestnet",
  [Network.SIGNET]: "bitcoinSignet"
}, WALLET_PROVIDER_NAME$3 = "OKX";
function toOkxSignOptions(o) {
  if (o != null && o.signInputs && o.signInputs.length > 0)
    return {
      autoFinalized: o.autoFinalized ?? !1,
      toSignInputs: mapSignInputsToToSignInputs(o.signInputs)
    };
  if ((o == null ? void 0 : o.autoFinalized) === !1)
    return { autoFinalized: !1, toSignInputs: void 0 };
}
function describeSignPsbtsResponse(o) {
  return Array.isArray(o) ? o.length !== 1 ? `an array of ${o.length}` : typeof o[0] == "string" ? "an array holding an empty string" : `an array holding ${typeof o[0]}` : typeof o;
}
const OKX_RPC_TIMEOUT_MS = 1e4;
class OKXProvider {
  constructor(g, c) {
    Vi(this, "provider");
    // Root `okxwallet` (getVersion lives here); `this.provider` is the per-chain provider.
    Vi(this, "wallet");
    Vi(this, "walletInfo");
    Vi(this, "config");
    Vi(this, "identityVersion", 0);
    Vi(this, "walletInfoIdentityVersion", -1);
    Vi(this, "tracksIdentityChanges", !1);
    Vi(this, "identityEventsTracked", !1);
    Vi(this, "connectWallet", async () => {
      var d;
      await this.ensureSupportedVersion(), this.trackIdentityChanges();
      const g = this.identityVersion;
      let c;
      try {
        c = await this.readLiveIdentity();
      } catch (E) {
        throw (d = E == null ? void 0 : E.message) != null && d.includes("rejected") ? new WalletError({
          code: ERROR_CODES.CONNECTION_REJECTED,
          message: "Connection to OKX Wallet was rejected",
          wallet: WALLET_PROVIDER_NAME$3
        }) : new WalletError({
          code: ERROR_CODES.CONNECTION_FAILED,
          message: (E == null ? void 0 : E.message) || "Failed to connect to OKX Wallet",
          wallet: WALLET_PROVIDER_NAME$3
        });
      }
      const { address: y, publicKeyHex: t } = c;
      if (t && y)
        this.walletInfo = {
          publicKeyHex: t,
          address: y
        }, this.walletInfoIdentityVersion = g;
      else
        throw new WalletError({
          code: ERROR_CODES.CONNECTION_FAILED,
          message: "Could not connect to OKX Wallet",
          wallet: WALLET_PROVIDER_NAME$3
        });
    });
    // `connect()` resolves with the selected account, silently once the site is
    // authorised, and with null when the selected wallet has no account on this
    // chain. Never touches `walletInfo`, so the derive check can compare the two.
    Vi(this, "readLiveIdentity", async () => {
      const g = await this.provider.connect();
      return { address: g == null ? void 0 : g.address, publicKeyHex: g == null ? void 0 : g.compressedPublicKey };
    });
    Vi(this, "isIdentityCurrent", () => this.identityEventsTracked && this.walletInfoIdentityVersion === this.identityVersion);
    Vi(this, "trackIdentityChanges", () => {
      this.tracksIdentityChanges || (this.identityEventsTracked = trackProviderIdentityChanges(this.provider, () => {
        this.identityVersion += 1;
      }), this.tracksIdentityChanges = this.identityEventsTracked);
    });
    Vi(this, "timeoutError", (g) => new WalletError({
      code: ERROR_CODES.CONNECTION_FAILED,
      message: `OKX Wallet did not respond while ${g}. Open the extension to confirm it is unlocked, then try again.`,
      wallet: WALLET_PROVIDER_NAME$3
    }));
    // Gate connect on OKX >= MIN_OKX_VERSION (deriveContextHash support).
    // Fail closed on a missing / unreadable / non-canonical version.
    Vi(this, "ensureSupportedVersion", async () => {
      if (typeof this.wallet.getVersion != "function")
        throw new WalletError({
          code: ERROR_CODES.INCOMPATIBLE_WALLET_VERSION,
          message: `Your OKX Wallet extension is out of date. Please update to version ${MIN_OKX_VERSION} or later and try again.`,
          wallet: WALLET_PROVIDER_NAME$3
        });
      let g;
      try {
        g = await withTimeout(
          this.wallet.getVersion(),
          OKX_RPC_TIMEOUT_MS,
          () => this.timeoutError("reading its version")
        );
      } catch (y) {
        throw new WalletError({
          code: ERROR_CODES.CONNECTION_FAILED,
          message: (y == null ? void 0 : y.message) || "Failed to read OKX Wallet version",
          wallet: WALLET_PROVIDER_NAME$3
        });
      }
      const c = checkOKXVersion(g);
      if (c !== "ok")
        throw c === "below" ? new WalletError({
          code: ERROR_CODES.INCOMPATIBLE_WALLET_VERSION,
          message: `Your OKX Wallet extension is out of date (${g}). Please update to version ${MIN_OKX_VERSION} or later and try again.`,
          wallet: WALLET_PROVIDER_NAME$3,
          version: g
        }) : new WalletError({
          code: ERROR_CODES.INCOMPATIBLE_WALLET_VERSION,
          message: `Unable to verify your OKX Wallet version${typeof g == "string" ? ` (got "${g}")` : ""}. Please install the official OKX Wallet ${MIN_OKX_VERSION} or later and try again.`,
          wallet: WALLET_PROVIDER_NAME$3
        });
    });
    Vi(this, "getAddress", async () => {
      if (!this.walletInfo)
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "OKX Wallet not connected",
          wallet: WALLET_PROVIDER_NAME$3
        });
      return this.walletInfo.address;
    });
    Vi(this, "getPublicKeyHex", async () => {
      if (!this.walletInfo)
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "OKX Wallet not connected",
          wallet: WALLET_PROVIDER_NAME$3
        });
      return this.walletInfo.publicKeyHex;
    });
    // `getAccounts` is intentionally omitted: OKX's BTC provider is closed-source
    // and its locked-wallet behavior for a non-interactive accounts read is
    // unspecified, so an empty-array read can't be trusted as a silent-lock
    // signal. Omitting it makes the lock poll feature-detect OKX out (see
    // BTCWalletProvider) instead of risking a banner that never fires (or one
    // that fires wrongly). Re-add only alongside a verified lock signal.
    Vi(this, "signPsbt", async (g, c) => {
      if (!this.walletInfo)
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "OKX Wallet not connected",
          wallet: WALLET_PROVIDER_NAME$3
        });
      const y = toOkxSignOptions(c);
      if ((y == null ? void 0 : y.autoFinalized) === !1) {
        const t = await this.provider.signPsbts([g], [y]);
        if (!Array.isArray(t) || t.length !== 1 || typeof t[0] != "string" || t[0].length === 0)
          throw new WalletError({
            code: ERROR_CODES.SIGNATURE_EXTRACT_ERROR,
            message: `OKX Wallet returned a malformed response to a single-PSBT batch signing request: expected an array holding exactly one non-empty signed PSBT hex, got ${describeSignPsbtsResponse(t)}`,
            wallet: WALLET_PROVIDER_NAME$3
          });
        return t[0];
      }
      return y ? await this.provider.signPsbt(g, y) : await this.provider.signPsbt(g);
    });
    Vi(this, "signPsbts", async (g, c) => {
      if (!this.walletInfo)
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "OKX Wallet not connected",
          wallet: WALLET_PROVIDER_NAME$3
        });
      return c && c.length > 0 ? await this.provider.signPsbts(
        g,
        c.map((y) => toOkxSignOptions(y))
      ) : await this.provider.signPsbts(g);
    });
    Vi(this, "getNetwork", async () => {
      if (!this.config.network)
        throw new WalletError({
          code: ERROR_CODES.INVALID_PARAMS,
          // Or a new code like CONFIG_ERROR
          message: "Network not set in config",
          wallet: WALLET_PROVIDER_NAME$3
        });
      return this.config.network;
    });
    Vi(this, "signMessage", async (g, c) => {
      if (!this.walletInfo)
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "OKX Wallet not connected",
          wallet: WALLET_PROVIDER_NAME$3
        });
      return await this.provider.signMessage(g, c);
    });
    // Inscriptions are only available on OKX Wallet BTC mainnet (i.e okxWallet.bitcoin)
    Vi(this, "getInscriptions", async () => {
      if (!this.walletInfo)
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "OKX Wallet not connected",
          wallet: WALLET_PROVIDER_NAME$3
        });
      if (this.config.network !== Network.MAINNET)
        throw new WalletError({
          code: ERROR_CODES.INSCRIPTIONS_UNSUPPORTED_NETWORK,
          message: "Inscriptions are only available on OKX Wallet BTC mainnet",
          wallet: WALLET_PROVIDER_NAME$3,
          chainId: this.config.network
        });
      const g = 100, c = 100, y = [];
      let t = 0, d = 0;
      try {
        for (; d < g; ) {
          const { list: E } = await this.provider.getInscriptions(t, c), B = E.map((D) => {
            const [x, v] = D.output.split(":");
            return {
              txid: x,
              vout: v
            };
          });
          if (y.push(...B), E.length < c)
            break;
          if (t += c, d++, d >= g)
            throw new WalletError({
              code: ERROR_CODES.MAX_ITERATION_EXCEEDED,
              message: "Exceeded maximum iterations when fetching inscriptions",
              wallet: WALLET_PROVIDER_NAME$3
            });
        }
      } catch {
        throw new WalletError({
          code: ERROR_CODES.INSCRIPTION_FETCH_ERROR,
          message: "Failed to get inscriptions from OKX Wallet",
          wallet: WALLET_PROVIDER_NAME$3
        });
      }
      return y;
    });
    Vi(this, "on", (g, c) => {
      if (!this.walletInfo)
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "OKX Wallet not connected",
          wallet: WALLET_PROVIDER_NAME$3
        });
      if (isAccountChangeEvent(g))
        return this.provider.on("accountsChanged", c);
      if (g === NETWORK_CHANGE_EVENT)
        return this.provider.on(NETWORK_CHANGE_EVENT, c);
      if (g === DISCONNECT_EVENT)
        return this.provider.on(DISCONNECT_EVENT, c);
    });
    Vi(this, "off", (g, c) => {
      if (!this.walletInfo)
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "OKX Wallet not connected",
          wallet: WALLET_PROVIDER_NAME$3
        });
      if (isAccountChangeEvent(g))
        return removeProviderListener(this.provider, "accountsChanged", c);
      if (g === NETWORK_CHANGE_EVENT)
        return removeProviderListener(this.provider, NETWORK_CHANGE_EVENT, c);
      if (g === DISCONNECT_EVENT)
        return removeProviderListener(this.provider, DISCONNECT_EVENT, c);
    });
    Vi(this, "getWalletProviderName", async () => WALLET_PROVIDER_NAME$3);
    Vi(this, "getWalletProviderIcon", async () => okxLogo);
    Vi(this, "deriveContextHash", async (g, c) => {
      if (!this.walletInfo)
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "OKX Wallet not connected",
          wallet: WALLET_PROVIDER_NAME$3
        });
      if (typeof this.provider.deriveContextHash != "function")
        throw new WalletError({
          code: ERROR_CODES.WALLET_METHOD_NOT_SUPPORTED,
          message: "OKX Wallet version does not support deriveContextHash. Update to a version that implements the deriveContextHash specification.",
          wallet: WALLET_PROVIDER_NAME$3
        });
      const y = this.walletInfo.publicKeyHex, t = this.identityVersion;
      let d;
      try {
        d = await this.provider.deriveContextHash(g, c);
      } catch (E) {
        throw isUserRejectionMessage(E == null ? void 0 : E.message) ? new WalletError({
          code: ERROR_CODES.CONNECTION_REJECTED,
          message: "OKX Wallet rejected the deriveContextHash approval",
          wallet: WALLET_PROVIDER_NAME$3
        }) : E;
      }
      return await assertDeriveAccountUnchanged({
        walletName: WALLET_PROVIDER_NAME$3,
        expectedPublicKeyHex: y,
        identityVersionAtStart: t,
        currentIdentityVersion: () => this.identityVersion,
        readLiveIdentity: () => withTimeout(this.readLiveIdentity(), OKX_RPC_TIMEOUT_MS, () => this.timeoutError("reading the selected account"))
      }), d;
    });
    if (this.config = c, !g)
      throw new WalletError({
        code: ERROR_CODES.EXTENSION_NOT_FOUND,
        message: "OKX Wallet extension not found",
        wallet: WALLET_PROVIDER_NAME$3
      });
    this.wallet = g;
    const y = PROVIDER_NAMES[c.network];
    if (!y)
      throw new WalletError({
        code: ERROR_CODES.UNSUPPORTED_NETWORK,
        message: "Unsupported network",
        wallet: WALLET_PROVIDER_NAME$3
      });
    this.provider = g[y];
  }
}
const metadata$5 = {
  id: "okx",
  name: WALLET_PROVIDER_NAME$3,
  icon: okxLogo,
  iconBackground: MONOCHROME_MARK_BACKGROUND,
  docs: "https://www.okx.com/web3",
  wallet: "okxwallet",
  createProvider: (o, g) => new OKXProvider(o, g),
  networks: [Network.MAINNET, Network.SIGNET]
}, logo$2 = "data:image/svg+xml,%3csvg%20width='288'%20height='288'%20viewBox='72%2072%20144%20144'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M144%20216C193.706%20216%20216%20193.706%20216%20144C216%2094.2944%20193.706%2072%20144%2072C94.2944%2072%2072%2094.2944%2072%20144C72%20193.706%2094.2944%20216%20144%20216ZM130.475%20102.531H150.505V135.538H138.086V113.156H126.961L130.475%20102.531ZM144%20185.469C156.616%20185.469%20166.844%20175.242%20166.844%20162.626C166.844%20150.01%20156.616%20139.783%20144%20139.783C131.384%20139.783%20121.157%20150.01%20121.157%20162.626C121.157%20175.242%20131.384%20185.469%20144%20185.469ZM144%20175.099C150.889%20175.099%20156.473%20169.515%20156.473%20162.626C156.473%20155.738%20150.889%20150.153%20144%20150.153C137.112%20150.153%20131.528%20155.738%20131.528%20162.626C131.528%20169.515%20137.112%20175.099%20144%20175.099Z'%20fill='%23FFFFFF'/%3e%3c/svg%3e", ONEKEY_NETWORK_TO_INTERNAL = {
  livenet: Network.MAINNET,
  testnet: Network.SIGNET,
  signet: Network.SIGNET
};
function mapOneKeyNetwork(o) {
  return typeof o != "string" || !Object.hasOwn(ONEKEY_NETWORK_TO_INTERNAL, o) ? null : ONEKEY_NETWORK_TO_INTERNAL[o];
}
const MIN_ONEKEY_VERSION = "6.3.0";
function checkOneKeyVersion(o) {
  return checkMinVersion(o, MIN_ONEKEY_VERSION);
}
const WALLET_PROVIDER_NAME$2 = "OneKey", ONEKEY_METHOD_NOT_SUPPORTED_CODE = -32004, ONEKEY_RPC_TIMEOUT_MS = 1e4, ONEKEY_PROMPT_TIMEOUT_MS = 6e4;
class OneKeyProvider {
  constructor(g, c) {
    Vi(this, "provider");
    // The `$onekey` injection hub (parent of `btcwallet`); carries `$walletInfo`
    // and `$private`, the only reliable source of the OneKey app version.
    Vi(this, "hub");
    // Set once the app version has been verified >= MIN_ONEKEY_VERSION, so the
    // gate runs on the initial connect only — liveness/reconnect probes reuse it
    // and a transient version-read miss cannot disconnect a verified session.
    Vi(this, "versionChecked", !1);
    Vi(this, "walletInfo");
    Vi(this, "config");
    Vi(this, "identityVersion", 0);
    Vi(this, "walletInfoIdentityVersion", -1);
    Vi(this, "tracksIdentityChanges", !1);
    Vi(this, "identityEventsTracked", !1);
    // Builds the rejection used when a OneKey call exceeds its timeout budget.
    // Surfaced as CONNECTION_FAILED (not a version/network problem) so the user
    // can retry rather than being told to update.
    Vi(this, "timeoutError", (g) => new WalletError({
      code: ERROR_CODES.CONNECTION_FAILED,
      message: `OneKey Wallet did not respond while ${g}. Open the extension to confirm it is unlocked, then try again.`,
      wallet: WALLET_PROVIDER_NAME$2
    }));
    Vi(this, "connectWallet", async () => {
      try {
        await withTimeout(this.provider.connectWallet(), ONEKEY_PROMPT_TIMEOUT_MS, () => this.timeoutError("connecting"));
      } catch (t) {
        if (t instanceof WalletError) throw t;
        const d = (t == null ? void 0 : t.message) || "";
        throw d.includes("single address mode") || d.includes("multiple addresses") ? new WalletError({
          code: ERROR_CODES.WALLET_CONFIG_REQUIRED,
          message: "OneKey Wallet requires single address mode. Please disable multiple addresses in your wallet settings and try again.",
          wallet: WALLET_PROVIDER_NAME$2
        }) : d.includes("rejected") ? new WalletError({
          code: ERROR_CODES.CONNECTION_REJECTED,
          message: "Connection to OneKey Wallet was rejected",
          wallet: WALLET_PROVIDER_NAME$2
        }) : new WalletError({
          code: ERROR_CODES.CONNECTION_FAILED,
          message: d || "Failed to connect to OneKey Wallet",
          wallet: WALLET_PROVIDER_NAME$2
        });
      }
      await this.ensureSupportedVersion(), this.trackIdentityChanges();
      const g = this.identityVersion, { address: c, publicKeyHex: y } = await this.readLiveIdentity();
      if (y && c)
        this.walletInfo = {
          publicKeyHex: y,
          address: c
        }, this.walletInfoIdentityVersion = g;
      else
        throw new WalletError({
          code: ERROR_CODES.CONNECTION_FAILED,
          message: "Could not connect to OneKey Wallet",
          wallet: WALLET_PROVIDER_NAME$2
        });
    });
    // Reads the extension's selected account without prompting and without
    // touching `walletInfo`, so the derive check can compare the two.
    Vi(this, "readLiveIdentity", async () => {
      const g = await withTimeout(
        this.provider.getAddress(),
        ONEKEY_RPC_TIMEOUT_MS,
        () => this.timeoutError("reading the address")
      ), c = await withTimeout(
        this.provider.getPublicKeyHex(),
        ONEKEY_RPC_TIMEOUT_MS,
        () => this.timeoutError("reading the public key")
      );
      return { address: g, publicKeyHex: c };
    });
    Vi(this, "isIdentityCurrent", () => this.identityEventsTracked && this.walletInfoIdentityVersion === this.identityVersion);
    Vi(this, "trackIdentityChanges", () => {
      this.tracksIdentityChanges || (this.identityEventsTracked = trackProviderIdentityChanges(this.provider, () => {
        this.identityVersion += 1;
      }), this.tracksIdentityChanges = this.identityEventsTracked);
    });
    // Reads the OneKey app/extension version from `$onekey.$walletInfo.version`.
    // OneKey populates `$walletInfo` asynchronously on injection; if it isn't
    // ready yet, call OneKey's own `$private.getConnectWalletInfo()` — the same
    // method ProviderPrivate runs on injection — which repopulates `$walletInfo`.
    // The refresh is bounded so a stalled extension can't hang connect; a read
    // failure surfaces as CONNECTION_FAILED (retryable), not a version verdict.
    // Returns `unknown`: external data validated by `checkOneKeyVersion`.
    Vi(this, "readAppVersion", async () => {
      var y, t, d, E, B, D, x, v;
      if (typeof ((t = (y = this.hub) == null ? void 0 : y.$walletInfo) == null ? void 0 : t.version) == "string")
        return this.hub.$walletInfo.version;
      let g;
      try {
        g = await withTimeout(
          Promise.resolve((B = (E = (d = this.hub) == null ? void 0 : d.$private) == null ? void 0 : E.getConnectWalletInfo) == null ? void 0 : B.call(E)),
          ONEKEY_RPC_TIMEOUT_MS,
          () => this.timeoutError("reading its version")
        );
      } catch (F) {
        throw F instanceof WalletError ? F : new WalletError({
          code: ERROR_CODES.CONNECTION_FAILED,
          message: (F == null ? void 0 : F.message) || "Failed to read OneKey Wallet version",
          wallet: WALLET_PROVIDER_NAME$2
        });
      }
      const c = g;
      return (c == null ? void 0 : c.version) ?? ((D = c == null ? void 0 : c.walletInfo) == null ? void 0 : D.version) ?? ((v = (x = this.hub) == null ? void 0 : x.$walletInfo) == null ? void 0 : v.version);
    });
    // Gates connect on OneKey >= MIN_ONEKEY_VERSION (the floor for
    // deriveContextHash). Runs once per provider instance; INCOMPATIBLE_WALLET_VERSION
    // surfaces as the "update wallet" prompt in the connect dialog.
    Vi(this, "ensureSupportedVersion", async () => {
      if (this.versionChecked) return;
      const g = await this.readAppVersion(), c = checkOneKeyVersion(g);
      if (c === "ok") {
        this.versionChecked = !0;
        return;
      }
      throw c === "below" ? new WalletError({
        code: ERROR_CODES.INCOMPATIBLE_WALLET_VERSION,
        message: `Your OneKey Wallet is out of date (${g}). Please update to version ${MIN_ONEKEY_VERSION} or later and try again.`,
        wallet: WALLET_PROVIDER_NAME$2,
        version: g
      }) : new WalletError({
        code: ERROR_CODES.INCOMPATIBLE_WALLET_VERSION,
        message: `Unable to verify your OneKey Wallet version${typeof g == "string" ? ` (got "${g}")` : ""}. Please update to OneKey ${MIN_ONEKEY_VERSION} or later and try again.`,
        wallet: WALLET_PROVIDER_NAME$2
      });
    });
    Vi(this, "getAddress", async () => {
      if (!this.walletInfo)
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "OneKey Wallet not connected",
          wallet: WALLET_PROVIDER_NAME$2
        });
      return this.walletInfo.address;
    });
    Vi(this, "getPublicKeyHex", async () => {
      if (!this.walletInfo)
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "OneKey Wallet not connected",
          wallet: WALLET_PROVIDER_NAME$2
        });
      return this.walletInfo.publicKeyHex;
    });
    // `getAccounts` is intentionally omitted: OneKey's getProviderState reports
    // isUnlocked: true and getAccounts() returns the dApp-authorized address
    // regardless of keyring lock, so an empty-array read is not a reliable
    // silent-lock signal. Omitting it makes the lock poll feature-detect OneKey
    // out (see BTCWalletProvider) instead of showing a banner that never fires.
    // Re-add only alongside a real lock signal.
    Vi(this, "signPsbt", async (g, c) => {
      if (!this.walletInfo)
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "OneKey Wallet not connected",
          wallet: WALLET_PROVIDER_NAME$2
        });
      if (!g)
        throw new WalletError({
          code: ERROR_CODES.PSBT_HEX_REQUIRED,
          message: "psbt hex is required",
          wallet: WALLET_PROVIDER_NAME$2
        });
      if (c != null && c.signInputs && c.signInputs.length > 0) {
        const y = {
          autoFinalized: c.autoFinalized ?? !1,
          toSignInputs: mapSignInputsToToSignInputs(c.signInputs)
        };
        return await this.provider.signPsbt(g, y);
      }
      return this.provider.signPsbt(g);
    });
    Vi(this, "signPsbts", async (g, c) => {
      if (!this.walletInfo)
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "OneKey Wallet not connected",
          wallet: WALLET_PROVIDER_NAME$2
        });
      if (!g || !Array.isArray(g) || g.length === 0)
        throw new WalletError({
          code: ERROR_CODES.PSBTS_HEXES_REQUIRED,
          message: "psbts hexes are required and must be a non-empty array",
          wallet: WALLET_PROVIDER_NAME$2
        });
      if (g.length === 1)
        return [await this.signPsbt(g[0], c == null ? void 0 : c[0])];
      if (c && c.length > 0) {
        const y = c.map((t) => {
          if (t != null && t.signInputs && t.signInputs.length > 0)
            return {
              autoFinalized: t.autoFinalized ?? !1,
              toSignInputs: mapSignInputsToToSignInputs(t.signInputs)
            };
        });
        return this.provider.signPsbts(g, y);
      }
      return this.provider.signPsbts(g);
    });
    Vi(this, "getNetwork", async () => {
      const g = await this.provider.getNetwork(), c = mapOneKeyNetwork(g);
      if (c !== null)
        return c;
      throw new WalletError({
        code: ERROR_CODES.UNSUPPORTED_NETWORK,
        message: `Unsupported network from OneKey Wallet: "${g}"`,
        wallet: WALLET_PROVIDER_NAME$2
      });
    });
    Vi(this, "signMessage", async (g, c) => {
      if (!this.walletInfo)
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "OneKey Wallet not connected",
          wallet: WALLET_PROVIDER_NAME$2
        });
      return await this.provider.signMessage(g, c);
    });
    // Inscriptions are only available on OneKey Wallet BTC mainnet
    Vi(this, "getInscriptions", async () => {
      if (!this.walletInfo)
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "OneKey Wallet not connected",
          wallet: WALLET_PROVIDER_NAME$2
        });
      if (this.config.network !== Network.MAINNET)
        throw new WalletError({
          code: ERROR_CODES.INSCRIPTIONS_UNSUPPORTED_NETWORK,
          message: "Inscriptions are only available on OneKey Wallet BTC Mainnet",
          wallet: WALLET_PROVIDER_NAME$2,
          chainId: this.config.network
        });
      const g = 100, c = 100, y = [];
      let t = 0, d = 0;
      try {
        for (; d < g; ) {
          const { list: E } = await this.provider.getInscriptions(t, c), B = E.map((D) => {
            const [x, v] = D.output.split(":");
            return {
              txid: x,
              vout: v
            };
          });
          if (y.push(...B), E.length < c)
            break;
          if (t += c, d++, d >= g)
            throw new WalletError({
              code: ERROR_CODES.MAX_ITERATION_EXCEEDED,
              message: "Exceeded maximum iterations when fetching inscriptions",
              wallet: WALLET_PROVIDER_NAME$2
            });
        }
      } catch {
        throw new WalletError({
          code: ERROR_CODES.INSCRIPTION_FETCH_ERROR,
          message: "Failed to get inscriptions from OneKey Wallet",
          wallet: WALLET_PROVIDER_NAME$2
        });
      }
      return y;
    });
    Vi(this, "on", (g, c) => {
      if (!this.walletInfo)
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "OneKey Wallet not connected",
          wallet: WALLET_PROVIDER_NAME$2
        });
      if (isAccountChangeEvent(g))
        return this.provider.on("accountsChanged", c);
      if (g === NETWORK_CHANGE_EVENT)
        return this.provider.on(NETWORK_CHANGE_EVENT, c);
      if (g === DISCONNECT_EVENT)
        return this.provider.on(DISCONNECT_EVENT, c);
    });
    Vi(this, "off", (g, c) => {
      if (!this.walletInfo)
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "OneKey Wallet not connected",
          wallet: WALLET_PROVIDER_NAME$2
        });
      if (isAccountChangeEvent(g))
        return removeProviderListener(this.provider, "accountsChanged", c);
      if (g === NETWORK_CHANGE_EVENT)
        return removeProviderListener(this.provider, NETWORK_CHANGE_EVENT, c);
      if (g === DISCONNECT_EVENT)
        return removeProviderListener(this.provider, DISCONNECT_EVENT, c);
    });
    Vi(this, "getWalletProviderName", async () => WALLET_PROVIDER_NAME$2);
    Vi(this, "getWalletProviderIcon", async () => logo$2);
    Vi(this, "deriveContextHash", async (g, c) => {
      if (!this.walletInfo)
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "OneKey Wallet not connected",
          wallet: WALLET_PROVIDER_NAME$2
        });
      if (typeof this.provider.deriveContextHash != "function")
        throw new WalletError({
          code: ERROR_CODES.WALLET_METHOD_NOT_SUPPORTED,
          message: "OneKey Wallet version does not support deriveContextHash. Update to a version that implements the deriveContextHash specification.",
          wallet: WALLET_PROVIDER_NAME$2
        });
      const y = this.walletInfo.publicKeyHex, t = this.identityVersion;
      let d;
      try {
        d = await this.provider.deriveContextHash(g, c);
      } catch (E) {
        throw isUserRejectionMessage(E == null ? void 0 : E.message) ? new WalletError({
          code: ERROR_CODES.CONNECTION_REJECTED,
          message: "OneKey Wallet rejected the deriveContextHash approval",
          wallet: WALLET_PROVIDER_NAME$2
        }) : (E == null ? void 0 : E.code) === ONEKEY_METHOD_NOT_SUPPORTED_CODE ? new WalletError({
          code: ERROR_CODES.WALLET_METHOD_NOT_SUPPORTED,
          message: "This OneKey account does not support deriveContextHash. Connect a OneKey app (HD) wallet account.",
          wallet: WALLET_PROVIDER_NAME$2
        }) : E;
      }
      return await assertDeriveAccountUnchanged({
        walletName: WALLET_PROVIDER_NAME$2,
        expectedPublicKeyHex: y,
        identityVersionAtStart: t,
        currentIdentityVersion: () => this.identityVersion,
        readLiveIdentity: this.readLiveIdentity
      }), d;
    });
    if (this.config = c, !(g != null && g.btcwallet))
      throw new WalletError({
        code: ERROR_CODES.EXTENSION_NOT_FOUND,
        message: "OneKey Wallet extension not found",
        wallet: WALLET_PROVIDER_NAME$2
      });
    this.hub = g, this.provider = g.btcwallet;
  }
}
const metadata$4 = {
  id: "onekey",
  name: WALLET_PROVIDER_NAME$2,
  icon: logo$2,
  iconBackground: ONEKEY_BRAND_GREEN,
  docs: "https://onekey.so/download",
  wallet: "$onekey",
  createProvider: (o, g) => new OneKeyProvider(o, g),
  networks: [Network.MAINNET, Network.SIGNET]
}, logo$1 = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='59'%20height='59'%3e%3cdefs%3e%3clinearGradient%20id='a'%20x1='91.9%25'%20x2='5.127%25'%20y1='28.561%25'%20y2='67.452%25'%3e%3cstop%20offset='0%25'%20stop-color='%23070100'/%3e%3cstop%20offset='36%25'%20stop-color='%2377390D'/%3e%3cstop%20offset='67%25'%20stop-color='%23EA8101'/%3e%3cstop%20offset='100%25'%20stop-color='%23F4B852'/%3e%3c/linearGradient%3e%3clinearGradient%20id='b'%20x1='10.514%25'%20x2='111.046%25'%20y1='63.228%25'%20y2='37.55%25'%3e%3cstop%20offset='0%25'%20stop-color='%23070100'/%3e%3cstop%20offset='37%25'%20stop-color='%2377390D'/%3e%3cstop%20offset='67%25'%20stop-color='%23EA8101'/%3e%3cstop%20offset='100%25'%20stop-color='%23F4FB52'/%3e%3c/linearGradient%3e%3cradialGradient%20id='c'%20cx='49.933%25'%20cy='50.067%25'%20r='50%25'%20fx='49.933%25'%20fy='50.067%25'%3e%3cstop%20offset='0%25'%20stop-color='%23F4B852'/%3e%3cstop%20offset='33%25'%20stop-color='%23EA8101'/%3e%3cstop%20offset='64%25'%20stop-color='%2377390D'/%3e%3cstop%20offset='100%25'%20stop-color='%23070100'/%3e%3c/radialGradient%3e%3c/defs%3e%3cg%20fill='none'%20fill-rule='nonzero'%20transform='translate(7%201)'%3e%3cpath%20fill='url(%23a)'%20d='m31.764%205.2%2011.761%2011.745c1%20.997%201.492%202.006%201.475%203.027-.018%201.014-.446%201.947-1.29%202.787-.879.88-1.827%201.33-2.845%201.347-1.017.018-2.023-.478-3.03-1.475L25.81%2010.617c-1.365-1.364-2.683-2.332-3.955-2.898-1.267-.566-2.602-.653-4.002-.268-1.399.385-2.902%201.382-4.51%202.991-2.22%202.217-3.278%204.298-3.168%206.246.11%201.948%201.208%203.96%203.301%206.054L25.6%2034.854c1.012%201.01%201.51%202.018%201.492%203.021-.017%201.003-.45%201.936-1.307%202.788-.855.851-1.792%201.3-2.821%201.335-1.024.035-2.041-.455-3.053-1.464L8.16%2028.79c-1.913-1.913-3.295-3.72-4.145-5.423-.85-1.703-1.168-3.633-.949-5.785.197-1.843.787-3.628%201.758-5.36.977-1.732%202.37-3.499%204.18-5.313%202.157-2.157%204.216-3.808%206.182-4.957C17.153.803%2019.049.161%2020.882.027c1.833-.134%203.643.233%205.435%201.102%201.787.869%203.603%202.222%205.453%204.07h-.006Z'/%3e%3cpath%20fill='url(%23b)'%20d='M13.234%2051.841%201.474%2040.188c-1-.99-1.49-1.99-1.474-3.003.018-1.012.446-1.932%201.29-2.766.878-.873%201.827-1.319%202.844-1.336%201.018-.017%202.024.469%203.03%201.464l12.025%2011.919c1.37%201.354%202.682%202.314%203.954%202.876%201.272.56%202.602.648%204%20.266%201.4-.382%202.903-1.372%204.51-2.968%202.22-2.2%203.278-4.265%203.169-6.197-.11-1.933-1.209-3.935-3.302-6.006l-6.457-6.347c-1.012-1.001-1.51-2.002-1.492-2.998.017-.995.451-1.92%201.307-2.765.855-.845%201.792-1.29%202.82-1.325%201.024-.035%202.042.451%203.053%201.452l6.088%205.983c1.914%201.898%203.296%203.691%204.145%205.38.85%201.69%201.168%203.605.949%205.74-.197%201.829-.787%203.6-1.758%205.318-.977%201.718-2.37%203.471-4.18%205.27-2.156%202.142-4.214%203.78-6.18%204.919-1.966%201.14-3.862%201.776-5.695%201.91-1.832.132-3.642-.232-5.434-1.094-1.787-.862-3.608-2.205-5.452-4.039Z'/%3e%3ccircle%20cx='20'%20cy='18'%20r='4'%20fill='url(%23c)'/%3e%3c/g%3e%3c/svg%3e", MIN_UNISAT_VERSION = "1.7.14";
function checkUnisatVersion(o) {
  return checkMinVersion(o, MIN_UNISAT_VERSION);
}
const UNISAT_RPC_TIMEOUT_MS = 1e4, UNISAT_PROMPT_TIMEOUT_MS = 6e4, UNISAT_UNSUPPORTED_ACCOUNT_MESSAGE = "Current keyring does not support deriveContextHash", WALLET_PROVIDER_NAME$1 = "Unisat", mapUnisatChainToNetwork = (o) => {
  switch (o) {
    case "BITCOIN_MAINNET":
      return Network.MAINNET;
    case "BITCOIN_SIGNET":
      return Network.SIGNET;
    case "BITCOIN_TESTNET":
      return Network.TESTNET;
    default:
      return null;
  }
}, mapNetworkToUnisatChain = (o) => {
  switch (o) {
    case Network.MAINNET:
      return "BITCOIN_MAINNET";
    case Network.SIGNET:
      return "BITCOIN_SIGNET";
    case Network.TESTNET:
      return "BITCOIN_TESTNET";
  }
};
class UnisatProvider {
  constructor(g, c) {
    Vi(this, "provider");
    Vi(this, "walletInfo");
    Vi(this, "config");
    Vi(this, "identityVersion", 0);
    Vi(this, "walletInfoIdentityVersion", -1);
    Vi(this, "tracksIdentityChanges", !1);
    Vi(this, "identityEventsTracked", !1);
    // Builds the rejection used when a UniSat call exceeds its timeout budget.
    // Surfaced as CONNECTION_FAILED (not a version/network problem) with an
    // actionable recovery instruction.
    Vi(this, "timeoutError", (g) => new WalletError({
      code: ERROR_CODES.CONNECTION_FAILED,
      message: `Unisat Wallet did not respond while ${g}. Open the extension to confirm it is unlocked, then try again.`,
      wallet: WALLET_PROVIDER_NAME$1
    }));
    Vi(this, "connectWallet", async (g) => {
      var E;
      g == null || g("Connecting Unisat", "Approve the connection request in your Unisat extension");
      try {
        await withTimeout(
          this.provider.requestAccounts(),
          UNISAT_PROMPT_TIMEOUT_MS,
          () => this.timeoutError("requesting accounts")
        );
      } catch (B) {
        throw (E = B == null ? void 0 : B.message) != null && E.includes("rejected") ? new WalletError({
          code: ERROR_CODES.CONNECTION_REJECTED,
          message: "Connection to Unisat Wallet was rejected",
          wallet: WALLET_PROVIDER_NAME$1
        }) : new WalletError({
          code: ERROR_CODES.CONNECTION_FAILED,
          message: (B == null ? void 0 : B.message) || "Failed to request accounts from Unisat Wallet",
          wallet: WALLET_PROVIDER_NAME$1
        });
      }
      g == null || g("Checking Unisat version"), await this.ensureSupportedVersion();
      const c = await this.ensureExpectedChain(g);
      g == null || g(
        "Finalizing connection",
        c ? "Approve the connection request in your Unisat extension" : void 0
      ), await withTimeout(
        this.provider.requestAccounts(),
        UNISAT_PROMPT_TIMEOUT_MS,
        () => this.timeoutError("requesting accounts")
      ), this.trackIdentityChanges();
      const y = this.identityVersion, { address: t, publicKeyHex: d } = await this.readLiveIdentity();
      if (d && t)
        this.walletInfo = {
          publicKeyHex: d,
          address: t
        }, this.walletInfoIdentityVersion = y;
      else
        throw new WalletError({
          code: ERROR_CODES.CONNECTION_FAILED,
          message: "Could not connect to Unisat Wallet",
          wallet: WALLET_PROVIDER_NAME$1
        });
    });
    // Reads the extension's selected account without prompting and without
    // touching `walletInfo`, so the derive check can compare the two.
    Vi(this, "readLiveIdentity", async () => {
      const g = await withTimeout(
        this.provider.getAccounts(),
        UNISAT_RPC_TIMEOUT_MS,
        () => this.timeoutError("reading accounts")
      ), c = await withTimeout(
        this.provider.getPublicKey(),
        UNISAT_RPC_TIMEOUT_MS,
        () => this.timeoutError("reading the public key")
      );
      return { address: g[0], publicKeyHex: c };
    });
    Vi(this, "isIdentityCurrent", () => this.identityEventsTracked && this.walletInfoIdentityVersion === this.identityVersion);
    Vi(this, "trackIdentityChanges", () => {
      this.tracksIdentityChanges || (this.identityEventsTracked = trackProviderIdentityChanges(this.provider, () => {
        this.identityVersion += 1;
      }), this.tracksIdentityChanges = this.identityEventsTracked);
    });
    Vi(this, "ensureSupportedVersion", async () => {
      if (typeof this.provider.getVersion != "function")
        throw new WalletError({
          code: ERROR_CODES.INCOMPATIBLE_WALLET_VERSION,
          message: `Your Unisat Wallet extension is out of date. Please update to version ${MIN_UNISAT_VERSION} or later and try again.`,
          wallet: WALLET_PROVIDER_NAME$1
        });
      let g;
      try {
        g = await withTimeout(
          this.provider.getVersion(),
          UNISAT_RPC_TIMEOUT_MS,
          () => this.timeoutError("reading its version")
        );
      } catch (y) {
        throw new WalletError({
          code: ERROR_CODES.CONNECTION_FAILED,
          message: (y == null ? void 0 : y.message) || "Failed to read Unisat Wallet version",
          wallet: WALLET_PROVIDER_NAME$1
        });
      }
      const c = checkUnisatVersion(g);
      if (c !== "ok")
        throw c === "below" ? new WalletError({
          code: ERROR_CODES.INCOMPATIBLE_WALLET_VERSION,
          message: `Your Unisat Wallet extension is out of date (${g}). Please update to version ${MIN_UNISAT_VERSION} or later and try again.`,
          wallet: WALLET_PROVIDER_NAME$1,
          version: g
        }) : new WalletError({
          code: ERROR_CODES.INCOMPATIBLE_WALLET_VERSION,
          message: `Unable to verify your Unisat Wallet version${typeof g == "string" ? ` (got "${g}")` : ""}. Please install the official Unisat Wallet ${MIN_UNISAT_VERSION} or later and try again.`,
          wallet: WALLET_PROVIDER_NAME$1
        });
    });
    Vi(this, "ensureExpectedChain", async (g) => {
      g == null || g("Checking Bitcoin network");
      let c;
      try {
        c = await withTimeout(
          this.provider.getChain(),
          UNISAT_RPC_TIMEOUT_MS,
          () => this.timeoutError("reading its network")
        );
      } catch (d) {
        throw new WalletError({
          code: ERROR_CODES.CONNECTION_FAILED,
          message: (d == null ? void 0 : d.message) || "Failed to read Unisat Wallet network",
          wallet: WALLET_PROVIDER_NAME$1
        });
      }
      if (mapUnisatChainToNetwork(c.enum) === this.config.network) return !1;
      const y = mapNetworkToUnisatChain(this.config.network), t = this.config.networkName || this.config.network;
      if (typeof this.provider.switchChain != "function")
        throw new WalletError({
          code: ERROR_CODES.UNSUPPORTED_NETWORK,
          message: `Unisat Wallet is on ${c.name}, but ${t} is required. Switch networks in your Unisat extension and try again.`,
          wallet: WALLET_PROVIDER_NAME$1
        });
      try {
        g == null || g(`Switching to ${t}`, "Approve the network switch in your Unisat extension"), await withTimeout(
          this.provider.switchChain(y),
          UNISAT_PROMPT_TIMEOUT_MS,
          () => this.timeoutError(`switching to ${t}`)
        );
      } catch (d) {
        const E = (d == null ? void 0 : d.message) || "";
        throw isUserRejectionMessage(E) ? new WalletError({
          code: ERROR_CODES.CONNECTION_REJECTED,
          message: `Switching Unisat Wallet to ${t} was rejected`,
          wallet: WALLET_PROVIDER_NAME$1
        }) : new WalletError({
          code: ERROR_CODES.UNSUPPORTED_NETWORK,
          message: E || `Failed to switch Unisat Wallet to ${t}`,
          wallet: WALLET_PROVIDER_NAME$1
        });
      }
      return !0;
    });
    Vi(this, "getAddress", async () => {
      if (!this.walletInfo)
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "Unisat Wallet not connected",
          wallet: WALLET_PROVIDER_NAME$1
        });
      return this.walletInfo.address;
    });
    Vi(this, "getPublicKeyHex", async () => {
      if (!this.walletInfo)
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "Unisat Wallet not connected",
          wallet: WALLET_PROVIDER_NAME$1
        });
      return this.walletInfo.publicKeyHex;
    });
    Vi(this, "getAccounts", async () => {
      if (!this.walletInfo)
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "Unisat Wallet not connected",
          wallet: WALLET_PROVIDER_NAME$1
        });
      if (typeof this.provider.getAccounts != "function")
        throw new WalletError({
          code: ERROR_CODES.WALLET_METHOD_NOT_SUPPORTED,
          message: "Unisat Wallet does not support getAccounts",
          wallet: WALLET_PROVIDER_NAME$1
        });
      return withTimeout(
        this.provider.getAccounts(),
        UNISAT_RPC_TIMEOUT_MS,
        () => this.timeoutError("reading its accounts")
      );
    });
    Vi(this, "signPsbt", async (g, c) => {
      if (!this.walletInfo)
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "Unisat Wallet not connected",
          wallet: WALLET_PROVIDER_NAME$1
        });
      if (!g)
        throw new WalletError({
          code: ERROR_CODES.PSBT_HEX_REQUIRED,
          message: "psbt hex is required",
          wallet: WALLET_PROVIDER_NAME$1
        });
      const y = await this.getNetwork();
      try {
        let t;
        if (c != null && c.signInputs && c.signInputs.length > 0)
          t = {
            autoFinalized: c.autoFinalized ?? !1,
            toSignInputs: c.signInputs.map((E) => {
              const B = resolveUseTweakedSigner(E);
              return {
                index: E.index,
                publicKey: E.publicKey,
                address: E.address,
                sighashTypes: E.sighashTypes,
                ...B !== void 0 && { useTweakedSigner: B }
              };
            })
          };
        else {
          const E = this.getSignPsbtDefaultOptions(g, y);
          t = {
            ...E,
            autoFinalized: (c == null ? void 0 : c.autoFinalized) ?? E.autoFinalized
          };
        }
        return await this.provider.signPsbt(g, t);
      } catch (t) {
        throw isUserRejectionMessage(t == null ? void 0 : t.message) ? new WalletError({
          code: ERROR_CODES.CONNECTION_REJECTED,
          message: "User rejected the PSBT signing request in Unisat Wallet",
          wallet: WALLET_PROVIDER_NAME$1
        }) : new WalletError({
          code: ERROR_CODES.SIGNATURE_EXTRACT_ERROR,
          message: (t == null ? void 0 : t.message) || "Failed to sign PSBT with Unisat Wallet",
          wallet: WALLET_PROVIDER_NAME$1
        });
      }
    });
    // Order of PSBTs in the array must be the same as the order of options
    Vi(this, "signPsbts", async (g, c) => {
      if (!this.walletInfo)
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "Unisat Wallet not connected",
          wallet: WALLET_PROVIDER_NAME$1
        });
      if (!g || !Array.isArray(g) || g.length === 0)
        throw new WalletError({
          code: ERROR_CODES.PSBTS_HEXES_REQUIRED,
          message: "psbts hexes are required and must be a non-empty array",
          wallet: WALLET_PROVIDER_NAME$1
        });
      const y = await this.getNetwork();
      try {
        const t = g.map((d, E) => {
          const B = c == null ? void 0 : c[E];
          return B != null && B.signInputs && B.signInputs.length > 0 ? {
            autoFinalized: B.autoFinalized ?? !1,
            toSignInputs: B.signInputs.map((D) => {
              const x = resolveUseTweakedSigner(D);
              return {
                index: D.index,
                publicKey: D.publicKey,
                address: D.address,
                sighashTypes: D.sighashTypes,
                ...x !== void 0 && { useTweakedSigner: x }
              };
            })
          } : this.getSignPsbtDefaultOptions(d, y);
        });
        return await this.provider.signPsbts(g, t);
      } catch (t) {
        throw isUserRejectionMessage(t == null ? void 0 : t.message) ? new WalletError({
          code: ERROR_CODES.CONNECTION_REJECTED,
          message: "User rejected the PSBT signing request in Unisat Wallet",
          wallet: WALLET_PROVIDER_NAME$1
        }) : new WalletError({
          code: ERROR_CODES.SIGNATURE_EXTRACT_ERROR,
          message: (t == null ? void 0 : t.message) || "Failed to sign PSBTs with Unisat Wallet",
          wallet: WALLET_PROVIDER_NAME$1
        });
      }
    });
    Vi(this, "getNetwork", async () => {
      switch ((await withTimeout(
        this.provider.getChain(),
        UNISAT_RPC_TIMEOUT_MS,
        () => this.timeoutError("reading its network")
      )).enum) {
        case "BITCOIN_MAINNET":
          return Network.MAINNET;
        case "BITCOIN_SIGNET":
          return Network.SIGNET;
        case "BITCOIN_TESTNET":
          return Network.SIGNET;
        default:
          throw new WalletError({
            code: ERROR_CODES.UNSUPPORTED_NETWORK,
            message: "Unsupported network from Unisat Wallet",
            wallet: WALLET_PROVIDER_NAME$1
          });
      }
    });
    Vi(this, "signMessage", async (g, c) => {
      if (!this.walletInfo)
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "Unisat Wallet not connected",
          wallet: WALLET_PROVIDER_NAME$1
        });
      return await this.provider.signMessage(g, c);
    });
    Vi(this, "getInscriptions", async () => {
      if (!this.walletInfo)
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "Unisat Wallet not connected",
          wallet: WALLET_PROVIDER_NAME$1
        });
      if (this.config.network !== Network.MAINNET)
        throw new WalletError({
          code: ERROR_CODES.INSCRIPTIONS_UNSUPPORTED_NETWORK,
          message: "Inscriptions are only available on Unisat Wallet BTC Mainnet",
          wallet: WALLET_PROVIDER_NAME$1,
          chainId: this.config.network
        });
      const g = 100, c = 100, y = [];
      let t = 0, d = 0;
      try {
        for (; d < g; ) {
          const { list: E } = await this.provider.getInscriptions(t, c), B = E.map((D) => {
            const [x, v] = D.output.split(":");
            return {
              txid: x,
              vout: v
            };
          });
          if (y.push(...B), E.length < c)
            break;
          if (t += c, d++, d >= g)
            throw new WalletError({
              code: ERROR_CODES.MAX_ITERATION_EXCEEDED,
              message: "Exceeded maximum iterations when fetching inscriptions",
              wallet: WALLET_PROVIDER_NAME$1
            });
        }
      } catch {
        throw new WalletError({
          code: ERROR_CODES.INSCRIPTION_FETCH_ERROR,
          message: "Failed to get inscriptions from Unisat Wallet",
          wallet: WALLET_PROVIDER_NAME$1
        });
      }
      return y;
    });
    Vi(this, "on", (g, c) => {
      if (!this.walletInfo)
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "Unisat Wallet not connected",
          wallet: WALLET_PROVIDER_NAME$1
        });
      if (isAccountChangeEvent(g))
        return this.provider.on("accountsChanged", c);
      if (g === NETWORK_CHANGE_EVENT)
        return this.provider.on(NETWORK_CHANGE_EVENT, c);
      if (g === DISCONNECT_EVENT)
        return this.provider.on(DISCONNECT_EVENT, c);
    });
    Vi(this, "off", (g, c) => {
      if (!this.walletInfo)
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "Unisat Wallet not connected",
          wallet: WALLET_PROVIDER_NAME$1
        });
      if (isAccountChangeEvent(g))
        return removeProviderListener(this.provider, "accountsChanged", c);
      if (g === NETWORK_CHANGE_EVENT)
        return removeProviderListener(this.provider, NETWORK_CHANGE_EVENT, c);
      if (g === DISCONNECT_EVENT)
        return removeProviderListener(this.provider, DISCONNECT_EVENT, c);
    });
    Vi(this, "getWalletProviderName", async () => WALLET_PROVIDER_NAME$1);
    Vi(this, "getWalletProviderIcon", async () => logo$1);
    Vi(this, "deriveContextHash", async (g, c) => {
      if (!this.walletInfo)
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "Unisat Wallet not connected",
          wallet: WALLET_PROVIDER_NAME$1
        });
      if (typeof this.provider.deriveContextHash != "function")
        throw new WalletError({
          code: ERROR_CODES.WALLET_METHOD_NOT_SUPPORTED,
          message: "Unisat Wallet version does not support deriveContextHash. Update to a version that implements the deriveContextHash specification.",
          wallet: WALLET_PROVIDER_NAME$1
        });
      const y = this.walletInfo.publicKeyHex, t = this.identityVersion;
      let d;
      try {
        d = await this.provider.deriveContextHash(g, c);
      } catch (E) {
        throw isUserRejectionMessage(E == null ? void 0 : E.message) ? new WalletError({
          code: ERROR_CODES.CONNECTION_REJECTED,
          message: "Unisat Wallet rejected the deriveContextHash approval",
          wallet: WALLET_PROVIDER_NAME$1
        }) : (E == null ? void 0 : E.message) === UNISAT_UNSUPPORTED_ACCOUNT_MESSAGE ? new WalletError({
          code: ERROR_CODES.WALLET_ACCOUNT_NOT_SUPPORTED,
          message: "The selected Unisat account cannot derive the context hash",
          wallet: WALLET_PROVIDER_NAME$1
        }) : E;
      }
      return await assertDeriveAccountUnchanged({
        walletName: WALLET_PROVIDER_NAME$1,
        expectedPublicKeyHex: y,
        identityVersionAtStart: t,
        currentIdentityVersion: () => this.identityVersion,
        readLiveIdentity: this.readLiveIdentity
      }), d;
    });
    if (this.config = c, !g)
      throw new WalletError({
        code: ERROR_CODES.EXTENSION_NOT_FOUND,
        message: "Unisat Wallet extension not found",
        wallet: WALLET_PROVIDER_NAME$1
      });
    this.provider = g;
  }
  getSignPsbtDefaultOptions(g, c) {
    initBTCCurve();
    const y = [];
    return Psbt.fromHex(g).data.inputs.forEach((d, E) => {
      var x, v;
      let B = !1;
      if (d.witnessUtxo && d.witnessUtxo.script) {
        let F = networks$2.bitcoin;
        (c === Network.TESTNET || c === Network.SIGNET) && (F = networks$2.testnet);
        let M;
        try {
          M = address$2.fromOutputScript(d.witnessUtxo.script, F);
        } catch (H) {
          throw new WalletError({
            code: ERROR_CODES.UNKNOWN_ERROR,
            // Or a more specific address generation error
            message: (H == null ? void 0 : H.message) || "Failed to determine address from output script",
            wallet: WALLET_PROVIDER_NAME$1
          });
        }
        const U = M.indexOf("tb1p") === 0 || M.indexOf("bc1p") === 0, L = M === ((x = this.walletInfo) == null ? void 0 : x.address);
        U && L && (B = !0);
      }
      d.finalScriptSig || d.finalScriptWitness || y.push({
        index: E,
        publicKey: (v = this.walletInfo) == null ? void 0 : v.publicKeyHex,
        sighashTypes: void 0,
        useTweakedSigner: B
      });
    }), {
      autoFinalized: !0,
      toSignInputs: y
    };
  }
}
const metadata$3 = {
  id: "unisat",
  name: WALLET_PROVIDER_NAME$1,
  icon: logo$1,
  docs: "https://unisat.io/download",
  wallet: (o) => {
    const g = o.unisat_wallet ?? o.unisat;
    return g && !g.isOneKey ? g : void 0;
  },
  createProvider: (o, g) => new UnisatProvider(o, g),
  networks: [Network.MAINNET, Network.SIGNET]
}, logo = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='128'%20height='128'%20viewBox='0%200%20128%20128'%20fill='none'%3e%3cg%20clip-path='url(%23clip0_410_6315)'%3e%3crect%20width='128'%20height='128'%20rx='10'%20fill='white'/%3e%3cpath%20d='M47.005%2032.7549L59.5992%2045.3491L46.096%2058.8523C39.7086%2065.2398%2039.7086%2075.5959%2046.096%2081.9834C52.0774%2087.9647%2061.5387%2088.345%2067.9626%2083.1243L64.0615%2087.0254C54.6415%2096.4454%2039.3686%2096.4454%2029.9486%2087.0254L28.398%2085.4748C18.978%2076.0548%2018.978%2060.7819%2028.398%2051.3619L47.005%2032.7549Z'%20fill='%23161616'/%3e%3cpath%20d='M80.9943%2095.2514L68.4001%2082.6572L81.9033%2069.154C88.2907%2062.7666%2088.2908%2052.4104%2081.9033%2046.023C75.922%2040.0416%2066.4606%2039.6613%2060.0367%2044.882L63.9378%2040.9809C73.3578%2031.5609%2088.6307%2031.5609%2098.0507%2040.9809L99.6013%2042.5315C109.021%2051.9515%20109.021%2067.2244%2099.6013%2076.6444L80.9943%2095.2514Z'%20fill='%23161616'/%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_410_6315'%3e%3crect%20width='128'%20height='128'%20fill='white'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e", WALLET_PROVIDER_NAME = "Utila", UTILA_RPC_TIMEOUT_MS = 1e4, UTILA_PROMPT_TIMEOUT_MS = 6e4;
class UtilaProvider {
  constructor(g) {
    Vi(this, "provider");
    Vi(this, "walletInfo");
    Vi(this, "identityVersion", 0);
    Vi(this, "walletInfoIdentityVersion", -1);
    Vi(this, "tracksIdentityChanges", !1);
    Vi(this, "identityEventsTracked", !1);
    // Maps a user-cancelled wallet prompt to a typed CONNECTION_REJECTED so
    // callers can treat cancellation as an expected action; already-typed
    // WalletErrors and other errors are rethrown unchanged.
    Vi(this, "mapPromptRejection", (g, c) => {
      throw g instanceof WalletError ? g : isUserRejectionMessage(g == null ? void 0 : g.message) ? new WalletError({
        code: ERROR_CODES.CONNECTION_REJECTED,
        message: `Utila Wallet rejected the ${c}`,
        wallet: WALLET_PROVIDER_NAME
      }) : g;
    });
    // Builds the rejection used when a Utila call exceeds its timeout budget.
    Vi(this, "timeoutError", (g) => new WalletError({
      code: ERROR_CODES.CONNECTION_FAILED,
      message: `Utila Wallet did not respond while ${g}. Open the extension to confirm it is unlocked, then try again.`,
      wallet: WALLET_PROVIDER_NAME
    }));
    Vi(this, "connectWallet", async () => {
      try {
        await withTimeout(this.provider.connectWallet(), UTILA_PROMPT_TIMEOUT_MS, () => this.timeoutError("connecting"));
      } catch (t) {
        throw t instanceof WalletError ? t : isUserRejectionMessage(t == null ? void 0 : t.message) ? new WalletError({
          code: ERROR_CODES.CONNECTION_REJECTED,
          message: "Connection to Utila Wallet was rejected",
          wallet: WALLET_PROVIDER_NAME
        }) : new WalletError({
          code: ERROR_CODES.CONNECTION_FAILED,
          message: (t == null ? void 0 : t.message) || "Failed to connect to Utila Wallet",
          wallet: WALLET_PROVIDER_NAME
        });
      }
      this.trackIdentityChanges();
      const g = this.identityVersion, { address: c, publicKeyHex: y } = await this.readLiveIdentity();
      if (y && c)
        this.walletInfo = {
          publicKeyHex: y,
          address: c
        }, this.walletInfoIdentityVersion = g;
      else
        throw new WalletError({
          code: ERROR_CODES.CONNECTION_FAILED,
          message: "Could not connect to Utila Wallet",
          wallet: WALLET_PROVIDER_NAME
        });
    });
    // Reads the wallet's selected account without prompting and without
    // touching `walletInfo`, so the derive check can compare the two.
    Vi(this, "readLiveIdentity", async () => {
      const g = await withTimeout(
        this.provider.getAddress(),
        UTILA_RPC_TIMEOUT_MS,
        () => this.timeoutError("reading the address")
      ), c = await withTimeout(
        this.provider.getPublicKeyHex(),
        UTILA_RPC_TIMEOUT_MS,
        () => this.timeoutError("reading the public key")
      );
      return { address: g, publicKeyHex: c };
    });
    Vi(this, "isIdentityCurrent", () => this.identityEventsTracked && this.walletInfoIdentityVersion === this.identityVersion);
    Vi(this, "trackIdentityChanges", () => {
      this.tracksIdentityChanges || (this.identityEventsTracked = trackProviderIdentityChanges(this.provider, () => {
        this.identityVersion += 1;
      }), this.tracksIdentityChanges = this.identityEventsTracked);
    });
    Vi(this, "getAddress", async () => {
      if (!this.walletInfo)
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "Utila Wallet not connected",
          wallet: WALLET_PROVIDER_NAME
        });
      return this.walletInfo.address;
    });
    Vi(this, "getPublicKeyHex", async () => {
      if (!this.walletInfo)
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "Utila Wallet not connected",
          wallet: WALLET_PROVIDER_NAME
        });
      return this.walletInfo.publicKeyHex;
    });
    Vi(this, "signPsbt", async (g, c) => {
      if (!this.walletInfo)
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "Utila Wallet not connected",
          wallet: WALLET_PROVIDER_NAME
        });
      if (!g)
        throw new WalletError({
          code: ERROR_CODES.PSBT_HEX_REQUIRED,
          message: "psbt hex is required",
          wallet: WALLET_PROVIDER_NAME
        });
      try {
        return await this.provider.signPsbt(g, c);
      } catch (y) {
        return this.mapPromptRejection(y, "PSBT signing request");
      }
    });
    Vi(this, "signPsbts", async (g, c) => {
      if (!this.walletInfo)
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "Utila Wallet not connected",
          wallet: WALLET_PROVIDER_NAME
        });
      if (!g || !Array.isArray(g) || g.length === 0)
        throw new WalletError({
          code: ERROR_CODES.PSBTS_HEXES_REQUIRED,
          message: "psbts hexes are required and must be a non-empty array",
          wallet: WALLET_PROVIDER_NAME
        });
      if (typeof this.provider.signPsbts != "function") {
        const y = [];
        for (let t = 0; t < g.length; t++)
          y.push(await this.signPsbt(g[t], c == null ? void 0 : c[t]));
        return y;
      }
      try {
        return await this.provider.signPsbts(g, c);
      } catch (y) {
        return this.mapPromptRejection(y, "PSBT signing request");
      }
    });
    Vi(this, "getNetwork", async () => {
      const g = await this.provider.getNetwork();
      if (!Object.values(Network).includes(g))
        throw new WalletError({
          code: ERROR_CODES.UNSUPPORTED_NETWORK,
          message: `Unsupported network from Utila Wallet: "${g}"`,
          wallet: WALLET_PROVIDER_NAME
        });
      return g;
    });
    Vi(this, "signMessage", async (g, c) => {
      if (!this.walletInfo)
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "Utila Wallet not connected",
          wallet: WALLET_PROVIDER_NAME
        });
      try {
        return await this.provider.signMessage(g, c);
      } catch (y) {
        return this.mapPromptRejection(y, "message signing request");
      }
    });
    Vi(this, "getInscriptions", async () => {
      if (!this.walletInfo)
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "Utila Wallet not connected",
          wallet: WALLET_PROVIDER_NAME
        });
      return this.provider.getInscriptions();
    });
    Vi(this, "on", (g, c) => {
      if (!this.walletInfo)
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "Utila Wallet not connected",
          wallet: WALLET_PROVIDER_NAME
        });
      if (isAccountChangeEvent(g))
        return this.provider.on("accountsChanged", c);
      if (g === NETWORK_CHANGE_EVENT)
        return this.provider.on(NETWORK_CHANGE_EVENT, c);
      if (g === DISCONNECT_EVENT)
        return this.provider.on(DISCONNECT_EVENT, c);
    });
    Vi(this, "off", (g, c) => {
      if (!this.walletInfo)
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "Utila Wallet not connected",
          wallet: WALLET_PROVIDER_NAME
        });
      if (isAccountChangeEvent(g))
        return removeProviderListener(this.provider, "accountsChanged", c);
      if (g === NETWORK_CHANGE_EVENT)
        return removeProviderListener(this.provider, NETWORK_CHANGE_EVENT, c);
      if (g === DISCONNECT_EVENT)
        return removeProviderListener(this.provider, DISCONNECT_EVENT, c);
    });
    Vi(this, "getWalletProviderName", async () => WALLET_PROVIDER_NAME);
    Vi(this, "getWalletProviderIcon", async () => logo);
    Vi(this, "deriveContextHash", async (g, c) => {
      if (!this.walletInfo)
        throw new WalletError({
          code: ERROR_CODES.WALLET_NOT_CONNECTED,
          message: "Utila Wallet not connected",
          wallet: WALLET_PROVIDER_NAME
        });
      if (typeof this.provider.deriveContextHash != "function")
        throw new WalletError({
          code: ERROR_CODES.WALLET_METHOD_NOT_SUPPORTED,
          message: "Utila Wallet does not support deriveContextHash. Update Utila to a version that implements the deriveContextHash specification.",
          wallet: WALLET_PROVIDER_NAME
        });
      const y = this.walletInfo.publicKeyHex, t = this.identityVersion;
      let d;
      try {
        d = await this.provider.deriveContextHash(g, c);
      } catch (E) {
        return this.mapPromptRejection(E, "deriveContextHash approval");
      }
      return await assertDeriveAccountUnchanged({
        walletName: WALLET_PROVIDER_NAME,
        expectedPublicKeyHex: y,
        identityVersionAtStart: t,
        currentIdentityVersion: () => this.identityVersion,
        readLiveIdentity: this.readLiveIdentity
      }), d;
    });
    if (!(g != null && g.bitcoin))
      throw new WalletError({
        code: ERROR_CODES.EXTENSION_NOT_FOUND,
        message: "Utila Wallet extension not found",
        wallet: WALLET_PROVIDER_NAME
      });
    this.provider = g.bitcoin;
  }
}
const metadata$2 = {
  id: "utila",
  name: WALLET_PROVIDER_NAME,
  icon: logo,
  docs: "https://utila.io",
  // Utila injects its BTC provider at `window.utila.bitcoin`; the connector
  // resolves `window.utila` and `UtilaProvider` reads `.bitcoin`.
  wallet: "utila",
  createProvider: (o) => new UtilaProvider(o),
  networks: [Network.MAINNET, Network.SIGNET]
}, metadata$1 = {
  chain: "BTC",
  name: "Bitcoin",
  icon,
  // deriveContextHash-capable wallets (UniSat, OneKey, OKX, Utila) lead the list.
  // ledgerVault is registered here; consumers gate it by id via disabledWallets — see #2109.
  wallets: [metadata$3, metadata$4, metadata$2, metadata$5, metadata$a, metadata$b, metadata$8, metadata$7, metadata$6, metadata$9]
}, chainMetadata = { BTC: metadata$1, BBN: metadata$c, ETH: metadata$h }, BITCOIN_MAINNET = "mainnet";
function initializeAppKitModal(o) {
  var M, U, L, H, fe, ge, Ie;
  if (!validateAppKitInitialization(o.projectId)) return null;
  const g = o.projectId, c = o.metadata, y = createAppKitCapabilities({
    projectId: g,
    metadata: c,
    ethChain: (M = o.eth) == null ? void 0 : M.chain,
    btcNetwork: (U = o.btc) == null ? void 0 : U.network
  }), t = getAppKitState();
  if (t)
    return assertAppKitCapabilities(t, y), {
      modal: t.modal,
      wagmiConfig: t.wagmiConfig,
      bitcoinAdapter: ((L = t.btcConfig) == null ? void 0 : L.adapter) ?? null
    };
  modal && failInitialization("Reown AppKit was initialized outside this package. Use only this package to initialize it.");
  const d = [], E = [];
  let B = null, D = null, x;
  if ((H = o.eth) != null && H.chain && (d.push(o.eth.chain), B = createETHWagmiAdapter(o.eth.chain, g), E.push(B)), (fe = o.btc) != null && fe.network) {
    const Ee = o.btc.network === BITCOIN_MAINNET ? bitcoin$2 : bitcoinSignet;
    d.push(Ee), D = new BitcoinAdapter({
      networks: [Ee]
    }), x = new EventTarget(), E.push(D);
  }
  if (d.length === 0)
    return null;
  const v = createAppKit({
    adapters: E,
    networks: d,
    projectId: g,
    metadata: c,
    features: { email: !1, socials: !1 }
  }), F = setAppKitState({
    modal: v,
    ...y,
    wagmiConfig: B == null ? void 0 : B.wagmiConfig,
    btcConfig: D && ((ge = o.btc) != null && ge.network) && x ? {
      modal: v,
      adapter: D,
      network: o.btc.network,
      connectionEvents: x
    } : void 0
  });
  return {
    modal: F.modal,
    wagmiConfig: F.wagmiConfig,
    bitcoinAdapter: ((Ie = F.btcConfig) == null ? void 0 : Ie.adapter) ?? null
  };
}
const createProvider$1 = (o) => ({
  connectWallet: async () => void await o.connectWallet(),
  getAddress: () => o.getAddress(),
  getPublicKeyHex: () => o.getPublicKeyHex(),
  getWalletProviderName: () => o.getWalletProviderName(),
  getWalletProviderIcon: () => o.getWalletProviderIcon(),
  getOfflineSigner: () => o.getOfflineSigner(),
  on: () => {
  },
  off: () => {
  }
}), TomoBBNConnector = memo(({ persistent: o, storage: g }) => {
  const c = qn(), y = Vn("cosmos"), { cosmosProvider: t } = Rn(), d = Zn(), E = fn(), B = useChainConnector("BBN"), D = useMemo(() => {
    const { connected: v, walletId: F } = c.cosmos ?? {};
    return v && F ? y.find((M) => M.id === F) ?? null : null;
  }, [c.cosmos, y]), x = useCallback(
    async (v, F) => {
      if (!B) return;
      const M = createExternalWallet({
        id: `tomo.${v.id}`,
        name: v.name,
        icon: v.img,
        provider: createProvider$1(F)
      });
      await B.connect(M);
    },
    [B]
  );
  return useEffect(() => {
    if (!o) return;
    const v = g.get("BBN");
    if (!v || !v.startsWith("tomo.")) return;
    const F = v.replace("tomo.", ""), M = y.find((U) => U.id === F);
    M && E(M);
  }, [y, o, g]), useEffect(() => {
    D && t && x(D, t);
  }, [D, t, x]), useEffect(() => B ? B.on("disconnect", (F) => {
    F != null && F.id.startsWith("tomo.") && d.disconnect();
  }) : void 0, [B, d]), null;
});
TomoBBNConnector.displayName = "TomoBBNConnector";
const createProvider = (o) => ({
  connectWallet: async () => void await o.connectWallet(),
  getAddress: () => o.getAddress(),
  getPublicKeyHex: () => o.getPublicKeyHex(),
  signPsbt: (g, c) => o.signPsbt(g, c),
  signPsbts: (g, c) => o.signPsbts(g, c),
  getNetwork: () => o.getNetwork(),
  signMessage: (g, c) => o.signMessage(g, c),
  on: (g, c) => o.on(g, c),
  off: (g, c) => o.off(g, c),
  getWalletProviderName: () => o.getWalletProviderName(),
  getWalletProviderIcon: () => o.getWalletProviderIcon(),
  getInscriptions: () => o.getInscriptions().then(
    (g) => (g.list || []).map((c) => ({
      txid: c.inscriptionId,
      vout: c.outputValue
    }))
  ),
  // Tomo's BTCProvider does not expose deriveContextHash.
  deriveContextHash: unsupportedDeriveContextHash("Tomo")
}), TomoBTCConnector = memo(({ persistent: o, storage: g }) => {
  const c = qn(), y = Vn("bitcoin"), { bitcoinProvider: t } = Rn(), d = Zn(), E = fn(), B = useChainConnector("BTC"), D = useMemo(() => {
    const { connected: v, walletId: F } = c.bitcoin ?? {};
    return v && F ? y.find((M) => M.id === F) ?? null : null;
  }, [c.bitcoin, y]), x = useCallback(
    async (v, F) => {
      if (!B) return;
      const M = createExternalWallet({
        id: `tomo.${v.id}`,
        name: v.name,
        icon: v.img,
        provider: createProvider(F)
      });
      await B.connect(M);
    },
    [B]
  );
  return useEffect(() => {
    if (!o) return;
    const v = g.get("BTC");
    if (!v || !v.startsWith("tomo.")) return;
    const F = v.replace("tomo.", ""), M = y.find((U) => U.id === F);
    M && E(M);
  }, [y, o, g]), useEffect(() => {
    D && t && x(D, t);
  }, [D, t, x]), useEffect(() => B ? B.on("disconnect", (F) => {
    F != null && F.id.startsWith("tomo.") && d.disconnect();
  }) : void 0, [B, d]), null;
});
TomoBTCConnector.displayName = "TomoBTCConnector";
function deriveNetworkMap(o) {
  const g = {};
  for (const c of o)
    switch (c.chain) {
      case "BTC":
        g.BTC = c.config.network.toString();
        break;
      case "BBN":
        g.BBN = c.config.chainId;
        break;
      case "ETH":
        g.ETH = c.config.chainId.toString();
        break;
    }
  return g;
}
const metadata = chainMetadata, btcValidation = { validateAddress, validateAddressWithPK };
function WalletProvider({
  ttl: o = ONE_HOUR,
  persistent: g = !1,
  theme: c,
  lifecycleHooks: y,
  children: t,
  config: d,
  context: E = window,
  onError: B,
  disabledWallets: D = [],
  requiredChains: x,
  appKitConfig: v,
  disableTomo: F = !1,
  dialogActions: M,
  dialogCloseButtonClassName: U,
  dialogActionsClassName: L,
  chainDescriptions: H,
  isChainHidden: fe
}) {
  const ge = useMemo(() => deriveNetworkMap(d), [d]), Ie = useMemo(() => createAccountStorage(o, ge), [o, ge]), Ee = useMemo(() => {
    if (!v)
      return null;
    try {
      return initializeAppKitModal(v), null;
    } catch (Pe) {
      return {
        error: Pe instanceof Error ? Pe : new Error("Failed to initialize AppKit modal", { cause: Pe })
      };
    }
  }, [v]), Se = useRef(null), ze = useRef(null);
  useEffect(() => {
    if (!Ee) {
      Se.current = null, ze.current = null;
      return;
    }
    ze.current !== Ee && (ze.current = Ee, console.error("Failed to initialize AppKit modal:", Ee.error.message)), !(!B || Se.current === Ee) && (Se.current = Ee, B(Ee.error));
  }, [Ee, B]), useAppKitOpenListener();
  const He = /* @__PURE__ */ jsx(LifeCycleHooksProvider, { value: y, children: /* @__PURE__ */ jsxs(
    ChainProvider,
    {
      persistent: g,
      storage: Ie,
      context: E,
      config: d,
      onError: B,
      disabledWallets: D,
      requiredChains: x,
      metadata,
      children: [
        t,
        !F && /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx(TomoBTCConnector, { persistent: g, storage: Ie }),
          /* @__PURE__ */ jsx(TomoBBNConnector, { persistent: g, storage: Ie })
        ] }),
        /* @__PURE__ */ jsx(
          WalletDialog,
          {
            btcValidation,
            persistent: g,
            storage: Ie,
            config: d,
            onError: B,
            actions: M,
            closeButtonClassName: U,
            actionsClassName: L,
            chainDescriptions: H,
            isChainHidden: fe
          }
        )
      ]
    }
  ) });
  return F ? He : /* @__PURE__ */ jsx(TomoConnectionProvider, { theme: c, config: d, children: He });
}
function createWalletConfig({
  chains: o,
  networkConfigs: g,
  supportedWallets: c,
  disableTomo: y = !1
}) {
  const t = [];
  return o.includes("BTC") && g.BTC && t.push({
    chain: "BTC",
    ...y ? {} : {
      connectors: [
        {
          id: "tomo-btc-connector",
          widget: ({ onError: d }) => /* @__PURE__ */ jsx(ExternalWallets, { chainName: "bitcoin", onError: d, supportedWallets: c })
        }
      ]
    },
    config: g.BTC
  }), o.includes("BBN") && g.BBN && t.push({
    chain: "BBN",
    ...y ? {} : {
      connectors: [
        {
          id: "tomo-bbn-connector",
          widget: ({ onError: d }) => /* @__PURE__ */ jsx(ExternalWallets, { chainName: "cosmos", onError: d, supportedWallets: c })
        }
      ]
    },
    config: g.BBN
  }), o.includes("ETH") && g.ETH && t.push({
    chain: "ETH",
    config: g.ETH
  }), t;
}
const BTC_WALLET_LOCK_POLL_INTERVAL_MS = 1e4;
function areBtcAccountsLocked(o) {
  return Array.isArray(o) ? !o.some((g) => typeof g == "string" && g.length > 0) : !0;
}
function classifyBtcAccountsProbe(o, g) {
  return areBtcAccountsLocked(o) ? "locked" : o.filter(
    (y) => typeof y == "string"
  ).includes(g) ? "current" : "changed";
}
const BTCWalletContext = createContext({
  loading: !0,
  network: void 0,
  connected: !1,
  locked: !1,
  publicKeyNoCoord: "",
  address: "",
  disconnect: () => {
  },
  open: () => {
  },
  reconnect: async () => {
    throw new Error("BTC Wallet not connected");
  },
  getAddress: async () => "",
  getPublicKeyHex: async () => "",
  signPsbt: async () => "",
  signPsbts: async () => [],
  getNetwork: async () => ({}),
  signMessage: async () => "",
  getInscriptions: async () => [],
  // Fail loud rather than silently returning "" — a 32-byte secret
  // derivation must never produce an invalid value. Outside a
  // BTCWalletProvider this throws like any other unmounted hook.
  deriveContextHash: async () => {
    throw new Error("BTC Wallet not connected");
  }
}), BTCWalletProvider = ({ children: o, callbacks: g }) => {
  var Ne;
  const [c, y] = useState(!0), [t, d] = useState(), [E, B] = useState(), [D, x] = useState(""), [v, F] = useState(""), [M, U] = useState(!1), L = useRef({
    provider: void 0,
    address: ""
  }), H = useChainConnector("BTC"), { open: fe = () => {
  } } = useWalletConnect(), ge = useCallback(async () => {
    var Et;
    L.current = { provider: void 0, address: "" }, d(void 0), B(void 0), x(""), F(""), U(!1);
    try {
      await ((Et = g == null ? void 0 : g.onDisconnect) == null ? void 0 : Et.call(g));
    } catch (st) {
      console.error("Error in onDisconnect callback:", st instanceof Error ? st.message : "Unknown error");
    }
  }, [g]), Ie = useCallback(
    async (Et) => {
      var st, Dt;
      if (Et) {
        y(!0);
        try {
          const er = await Et.getAddress();
          if (!er)
            throw new Error("BTC wallet provider returned an empty address");
          const xt = await Et.getPublicKeyHex();
          if (!xt)
            throw new Error("BTC wallet provider returned an empty public key");
          const ir = toXOnlyPublicKeyHex(xt);
          if (!ir)
            throw new Error("Processed BTC public key (no coordinates) is empty");
          d(Et), F(er), x(ir), U(!1), y(!1), L.current = { provider: Et, address: er }, await ((st = g == null ? void 0 : g.onConnect) == null ? void 0 : st.call(g, er, ir));
        } catch (er) {
          throw y(!1), (Dt = g == null ? void 0 : g.onError) == null || Dt.call(g, er, { address: v, publicKeyNoCoord: D }), er;
        }
      }
    },
    [g, v, D]
  );
  useEffect(() => (y(!1), H ? (H.connectedWallet && Ie(H == null ? void 0 : H.connectedWallet.provider), H == null ? void 0 : H.on("connect", (st) => {
    st.provider && Ie(st.provider);
  })) : void 0), [H, Ie]), useEffect(() => H ? H.on("disconnect", () => {
    ge();
  }) : void 0, [H, ge]), useEffect(() => {
    if (!t) return;
    const Et = async (xt) => {
      var ir, sr;
      try {
        if (Array.isArray(xt) && xt.length === 0) {
          ge();
          return;
        }
        await t.getAddress() === v && await t.connectWallet();
        const wr = await t.getAddress();
        if (!wr) {
          ge();
          return;
        }
        if (wr !== v) {
          const qr = await t.getPublicKeyHex();
          if (!qr)
            throw new Error("BTC wallet provider returned an empty public key after account change");
          const Mr = toXOnlyPublicKeyHex(qr);
          F(wr), x(Mr), U(!1), await ((ir = g == null ? void 0 : g.onAddressChange) == null ? void 0 : ir.call(g, wr, Mr));
        }
      } catch (yr) {
        console.error("Error handling BTC account change:", yr instanceof Error ? yr.message : "Unknown error"), (sr = g == null ? void 0 : g.onError) == null || sr.call(g, yr), ge();
      }
    }, st = () => {
      ge();
    }, Dt = [];
    let er = !1;
    if (typeof t.on == "function") {
      ACCOUNT_CHANGE_EVENTS.forEach((xt) => {
        try {
          t.on(xt, Et), Dt.push(xt);
        } catch {
        }
      });
      try {
        t.on(DISCONNECT_EVENT, st), er = !0;
      } catch {
      }
    }
    return () => {
      typeof t.off == "function" && (Dt.forEach((xt) => {
        t.off(xt, Et);
      }), er && t.off(DISCONNECT_EVENT, st));
    };
  }, [t, v, g, ge]), useEffect(() => {
    L.current = { provider: t, address: v };
  }, [t, v]);
  const Ee = useCallback(async () => {
    var Et, st;
    if (t) {
      if (typeof t.getAccounts == "function") {
        let Dt;
        try {
          Dt = await t.getAccounts();
        } catch {
          Dt = void 0;
        }
        if (Dt !== void 0) {
          const er = L.current;
          if (er.provider !== t || er.address !== v)
            return;
          const xt = classifyBtcAccountsProbe(Dt, v);
          if (xt === "locked") {
            U(!0);
            return;
          }
          if (U(!1), xt === "current") return;
        }
      }
      try {
        await t.connectWallet();
        const Dt = await t.getAddress();
        if (!Dt)
          ge();
        else if (Dt !== v) {
          const er = await t.getPublicKeyHex();
          if (!er) {
            const ir = new Error("BTC wallet returned empty public key after account change");
            console.error(ir.message), (Et = g == null ? void 0 : g.onError) == null || Et.call(g, ir), ge();
            return;
          }
          const xt = toXOnlyPublicKeyHex(er);
          F(Dt), x(xt), await ((st = g == null ? void 0 : g.onAddressChange) == null ? void 0 : st.call(g, Dt, xt));
        }
      } catch (Dt) {
        console.error("BTC wallet connection check failed:", Dt instanceof Error ? Dt.message : "Unknown error"), ge();
      }
    }
  }, [t, v, g, ge]);
  useVisibilityCheck(Ee, {
    enabled: !!(t && v) && !((Ne = H == null ? void 0 : H.connectedWallet) != null && Ne.hardware)
  });
  const Se = useCallback(async () => {
    const Et = t, st = v;
    if (!Et || !st || typeof Et.getAccounts != "function") return;
    let Dt;
    try {
      Dt = await Et.getAccounts();
    } catch {
      return;
    }
    const er = L.current;
    if (er.provider !== Et || er.address !== st)
      return;
    const xt = classifyBtcAccountsProbe(Dt, st);
    xt !== "changed" && U(xt === "locked");
  }, [t, v]);
  useEffect(() => {
    if (!t || !v || typeof window > "u" || typeof document > "u" || typeof t.getAccounts != "function") return;
    let Et;
    const st = () => {
      Et === void 0 && (Se(), Et = setInterval(() => void Se(), BTC_WALLET_LOCK_POLL_INTERVAL_MS));
    }, Dt = () => {
      Et !== void 0 && (clearInterval(Et), Et = void 0);
    }, er = () => {
      document.visibilityState === "visible" ? st() : Dt();
    }, xt = () => {
      document.visibilityState === "visible" && Se();
    };
    return document.visibilityState === "visible" && st(), document.addEventListener("visibilitychange", er), window.addEventListener("focus", xt), () => {
      Dt(), document.removeEventListener("visibilitychange", er), window.removeEventListener("focus", xt);
    };
  }, [t, v, Se]);
  const ze = useCallback(async () => {
    var Et, st;
    if (!t)
      throw new Error("BTC Wallet not connected");
    try {
      await t.connectWallet();
      const Dt = await t.getAddress();
      if (!Dt)
        throw new Error("BTC wallet provider returned an empty address");
      const er = await t.getPublicKeyHex();
      if (!er)
        throw new Error("BTC wallet provider returned an empty public key");
      const xt = toXOnlyPublicKeyHex(er);
      if (!xt)
        throw new Error("Processed BTC public key (no coordinates) is empty");
      F(Dt), x(xt), U(!1), Dt !== v && await ((Et = g == null ? void 0 : g.onAddressChange) == null ? void 0 : Et.call(g, Dt, xt));
    } catch (Dt) {
      const er = Dt instanceof Error ? Dt : new Error(String(Dt));
      throw (st = g == null ? void 0 : g.onError) == null || st.call(g, er, { address: v, publicKeyNoCoord: D }), Dt;
    }
  }, [t, v, D, g]), He = useMemo(
    () => !!(t && v && D),
    [t, v, D]
  ), Pe = useCallback(async () => {
    if (!t) throw new Error("BTC Wallet not connected");
    return t.getAddress();
  }, [t]), De = useCallback(async () => {
    if (!t) throw new Error("BTC Wallet not connected");
    return t.getPublicKeyHex();
  }, [t]), ve = useCallback(
    async (Et, st) => {
      if (!t) throw new Error("BTC Wallet not connected");
      return t.signPsbt(Et, st);
    },
    [t]
  ), Fe = useCallback(
    async (Et, st) => {
      if (!t) throw new Error("BTC Wallet not connected");
      return t.signPsbts(Et, st);
    },
    [t]
  ), be = useCallback(async () => {
    if (!t) throw new Error("BTC Wallet not connected");
    return t.getNetwork();
  }, [t]), Be = useCallback(
    async (Et, st) => {
      if (!t) throw new Error("BTC Wallet not connected");
      return t.signMessage(Et, st);
    },
    [t]
  ), ke = useCallback(async () => {
    if (!t) throw new Error("BTC Wallet not connected");
    return t.getInscriptions();
  }, [t]), xe = useCallback(
    async (Et, st) => {
      if (!t) throw new Error("BTC Wallet not connected");
      return t.deriveContextHash(Et, st);
    },
    [t]
  );
  return /* @__PURE__ */ jsx(
    BTCWalletContext.Provider,
    {
      value: {
        loading: c,
        network: E,
        connected: He,
        locked: M,
        publicKeyNoCoord: D,
        address: v,
        disconnect: ge,
        open: fe,
        reconnect: ze,
        getAddress: Pe,
        getPublicKeyHex: De,
        signPsbt: ve,
        signPsbts: Fe,
        getNetwork: be,
        signMessage: Be,
        getInscriptions: ke,
        deriveContextHash: xe
      },
      children: o
    }
  );
}, useBTCWallet = () => useContext(BTCWalletContext), CosmosWalletContext = createContext({
  loading: !0,
  bech32Address: "",
  connected: !1,
  disconnect: () => {
  },
  open: () => {
  },
  signingStargateClient: void 0,
  walletName: ""
}), CosmosWalletProvider = ({
  children: o,
  config: g,
  callbacks: c
}) => {
  const [y, t] = useState(!0), [d, E] = useState(), [B, D] = useState(""), [x, v] = useState(), [F, M] = useState(""), { open: U = () => {
  } } = useWalletConnect(), L = useChainConnector("BBN"), H = useCallback(async () => {
    var Ie;
    E(void 0), D(""), v(void 0), M("");
    try {
      await ((Ie = c == null ? void 0 : c.onDisconnect) == null ? void 0 : Ie.call(c));
    } catch (Ee) {
      console.error("Error in onDisconnect callback:", Ee instanceof Error ? Ee.message : "Unknown error");
    }
  }, [c]), fe = useCallback(
    async (Ie) => {
      var Ee, Se;
      if (Ie) {
        t(!0);
        try {
          const ze = Ie.getOfflineSignerAuto ? await Ie.getOfflineSignerAuto() : await Ie.getOfflineSigner();
          if (ze.chainId && ze.chainId !== g.chainId)
            throw new Error(
              `Cosmos wallet chain ID does not match configured chain ID (${g.chainId}).`
            );
          const He = await Ie.getAddress();
          if (!He)
            throw new Error("Cosmos wallet provider returned an empty address");
          const Pe = await Ie.getWalletProviderName();
          if (!Pe)
            throw new Error("Cosmos wallet provider returned an empty wallet name");
          const De = {};
          g.registry && (De.registry = g.registry), g.aminoTypes && (De.aminoTypes = g.aminoTypes);
          const ve = await SigningStargateClient.connectWithSigner(
            g.rpc,
            ze,
            De
          );
          v(ve), E(Ie), D(He), M(Pe || "Unknown Wallet"), t(!1), await ((Ee = c == null ? void 0 : c.onConnect) == null ? void 0 : Ee.call(c, He));
        } catch (ze) {
          throw t(!1), (Se = c == null ? void 0 : c.onError) == null || Se.call(c, ze, { address: B, walletName: F }), ze;
        }
      }
    },
    [g, c, B, F]
  );
  useEffect(() => (t(!1), L ? (L.connectedWallet && fe(L == null ? void 0 : L.connectedWallet.provider), L.on("connect", (Ee) => {
    Ee.provider && fe(Ee.provider);
  })) : void 0), [L, fe]), useEffect(() => L ? L.on("disconnect", () => {
    H();
  }) : void 0, [L, H]), useEffect(() => {
    if (!d) return;
    const Ie = async () => {
      var Ee, Se;
      try {
        await d.connectWallet();
        const ze = await d.getAddress();
        if (ze && ze !== B) {
          D(ze);
          const He = d.getOfflineSignerAuto ? await d.getOfflineSignerAuto() : await d.getOfflineSigner(), Pe = {};
          g.registry && (Pe.registry = g.registry), g.aminoTypes && (Pe.aminoTypes = g.aminoTypes);
          const De = await SigningStargateClient.connectWithSigner(
            g.rpc,
            He,
            Pe
          );
          v(De), await ((Ee = c == null ? void 0 : c.onAddressChange) == null ? void 0 : Ee.call(c, ze));
        }
      } catch (ze) {
        (Se = c == null ? void 0 : c.onError) == null || Se.call(c, ze, { address: B, walletName: F });
      }
    };
    return typeof d.on == "function" && d.on("accountChanged", Ie), () => {
      typeof d.off == "function" && d.off("accountChanged", Ie);
    };
  }, [d, B, g, c, F]);
  const ge = !!(d && B && x);
  return /* @__PURE__ */ jsx(
    CosmosWalletContext.Provider,
    {
      value: {
        loading: y,
        bech32Address: B,
        connected: ge,
        disconnect: H,
        open: U,
        signingStargateClient: x,
        walletName: F
      },
      children: o
    }
  );
}, useCosmosWallet = () => useContext(CosmosWalletContext), useAppKitBtcBridge = ({ onError: o } = {}) => {
  const { isConnected: g, address: c, allAccounts: y } = useAppKitAccount({ namespace: "bip122" }), t = useChainConnector("BTC"), d = useRef(null), E = useCallback(
    async (B) => {
      try {
        const { adapter: D, network: x, connectionEvents: v } = getSharedBtcAppKitConfig();
        await D.switchNetwork({
          caipNetwork: getCaipNetworkForNetwork(x)
        });
        let F;
        try {
          const U = y == null ? void 0 : y.find((L) => L.address === B);
          U != null && U.publicKey ? F = U.publicKey : console.warn("[AppKit BTC Bridge] Public key not available in current account");
        } catch (U) {
          console.error(
            "[AppKit BTC Bridge] Error fetching public key:",
            U instanceof Error ? U.message : "Unknown error"
          );
        }
        const M = { address: B, publicKey: F };
        v.dispatchEvent(
          new CustomEvent(APPKIT_BTC_CONNECTED_EVENT, {
            detail: M
          })
        ), d.current = B;
      } catch (D) {
        console.error(
          "[AppKit BTC Bridge] Failed to process connection:",
          D instanceof Error ? D.message : "Unknown error"
        ), o == null || o(D), d.current = B;
      }
    },
    [y, o]
  );
  return useEffect(() => {
    const B = () => {
      d.current = null, g && c && E(c);
    };
    if (typeof window < "u")
      return window.addEventListener(APPKIT_OPEN_EVENT, B), () => window.removeEventListener(APPKIT_OPEN_EVENT, B);
  }, [g, c, y, E]), useEffect(() => {
    var B;
    if (g && c) {
      if (d.current === c)
        return;
      E(c);
    } else !g && ((B = t == null ? void 0 : t.connectedWallet) == null ? void 0 : B.id) === APPKIT_BTC_CONNECTOR_ID && (d.current = null, t.disconnect("local").catch((D) => {
      console.error(
        "Failed to disconnect from babylon-wallet-connector:",
        D instanceof Error ? D.message : "Unknown error"
      );
    }));
  }, [g, c, t, o, E]), {
    isAppKitBtcConnected: g,
    appKitBtcAddress: c
  };
}, LOW_VALUE_UTXO_THRESHOLD = 1e4;
function filterDust(o, g = LOW_VALUE_UTXO_THRESHOLD) {
  return o.filter((c) => c.value > g);
}
function createInscriptionMap(o) {
  return new Map(
    o.map((g) => [
      `${g.txid}:${g.vout}`,
      g
    ])
  );
}
function isInscriptionUtxo(o, g) {
  return g.has(`${o.txid}:${o.vout}`);
}
function filterInscriptionUtxos(o, g) {
  const c = createInscriptionMap(g), y = [], t = [];
  for (const d of o)
    isInscriptionUtxo(d, c) ? t.push(d) : y.push(d);
  return { availableUtxos: y, inscriptionUtxos: t };
}
function getSpendableUtxos(o, g, c = LOW_VALUE_UTXO_THRESHOLD) {
  const y = filterDust(o, c), { availableUtxos: t } = filterInscriptionUtxos(y, g);
  return t;
}
const DEFAULT_TIMEOUT = 2e3, BATCH_SIZE = 30;
function chunkArray(o, g) {
  const c = [];
  for (let y = 0; y < o.length; y += g)
    c.push(o.slice(y, y + g));
  return c;
}
async function verifyUtxoOrdinals(o, g, c, y = DEFAULT_TIMEOUT) {
  if (o.length === 0)
    return [];
  const t = chunkArray(o, BATCH_SIZE);
  return (await Promise.all(
    t.map(async (E) => {
      const B = new AbortController(), D = setTimeout(() => B.abort(), y);
      try {
        const x = await fetch(`${c}/v1/ordinals/verify-utxos`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            address: g,
            utxos: E.map((F) => ({
              txid: F.txid,
              vout: F.vout
            }))
          }),
          signal: B.signal
        });
        if (!x.ok)
          throw new Error(`API error: ${x.status} ${x.statusText}`);
        return (await x.json()).data;
      } finally {
        clearTimeout(D);
      }
    })
  )).flat();
}
function toInscriptionIdentifiers(o) {
  return o.filter((g) => g.inscription).map((g) => ({
    txid: g.txid,
    vout: g.vout
  }));
}
const WALLET_INSCRIPTIONS_TIMEOUT = 3e3, ORDINALS_QUERY_KEY = "ordinals";
class OrdinalsClassifierUnavailableError extends Error {
  constructor() {
    super(
      "Ordinals classifier unavailable: wallet getInscriptions did not return inscriptions and no ordinalsApiUrl is configured"
    ), this.name = "OrdinalsClassifierUnavailableError", Object.setPrototypeOf(this, OrdinalsClassifierUnavailableError.prototype);
  }
}
function wait(o) {
  return o <= 0 ? Promise.resolve(void 0) : new Promise((g) => setTimeout(g, o));
}
async function fetchOrdinals(o) {
  const {
    address: g,
    utxos: c,
    btcProvider: y,
    ordinalsApiUrl: t,
    walletTimeout: d = WALLET_INSCRIPTIONS_TIMEOUT,
    filterDustBeforeApi: E = !0
  } = o;
  if (!g || c.length === 0)
    return [];
  if (y != null && y.getInscriptions)
    try {
      const x = await Promise.race([
        y.getInscriptions().catch(() => null),
        wait(d)
      ]);
      if (x)
        return x;
    } catch {
    }
  if (!t)
    throw new OrdinalsClassifierUnavailableError();
  const B = E ? filterDust(c) : c, D = await verifyUtxoOrdinals(
    B,
    g,
    t
  );
  return toInscriptionIdentifiers(D);
}
function hashString(o) {
  let g = 5381;
  for (let c = 0; c < o.length; c++)
    g = g * 33 ^ o.charCodeAt(c);
  return g >>> 0;
}
function hashUtxosForKey(o) {
  if (o.length === 0) return "empty";
  const g = o.map((c) => `${c.txid}:${c.vout}`).sort().join(",");
  return `${o.length}:${hashString(g)}`;
}
function getOrdinalsQueryKey(o, g) {
  return [ORDINALS_QUERY_KEY, o, hashUtxosForKey(g)];
}
const ORDINALS_REFETCH_INTERVAL = 300 * 1e3;
function useOrdinals(o, g, c, y = {}) {
  const {
    enabled: t = !0,
    refetchInterval: d = ORDINALS_REFETCH_INTERVAL,
    ordinalsApiUrl: E
  } = y, { data: B, isLoading: D, error: x, refetch: v } = useQuery({
    queryKey: getOrdinalsQueryKey(g, o),
    queryFn: () => fetchOrdinals({
      address: g,
      utxos: o,
      btcProvider: c,
      ordinalsApiUrl: E,
      filterDustBeforeApi: !0
    }),
    enabled: !!g && o.length > 0 && t,
    refetchInterval: d,
    // Don't retry on failure - app should work without ordinals
    retry: !1
  });
  return {
    inscriptions: B ?? [],
    isLoading: D,
    error: x,
    refetch: v
  };
}
export {
  APPKIT_BTC_CONNECTOR_ID,
  T3 as APPKIT_ETH_CONNECTOR_ID,
  BTCWalletProvider,
  R3 as COSMOS_KEYSTORE_CHANGE_EVENTS,
  CosmosWalletProvider,
  ERROR_CODES,
  x3 as ETHWalletProvider,
  D3 as ETH_EMPTY_ACCOUNT_GRACE_MS,
  ExternalWallets,
  LOW_VALUE_UTXO_THRESHOLD,
  Network,
  ORDINALS_QUERY_KEY,
  OrdinalsClassifierUnavailableError,
  N3 as StateContext,
  P3 as StateProvider,
  q3 as WALLET_MODAL_OPEN_EVENT,
  WalletError,
  WalletProvider,
  createExternalWallet,
  createInscriptionMap,
  createWalletConfig,
  fetchOrdinals,
  filterDust,
  filterInscriptionUtxos,
  getOrdinalsQueryKey,
  getSharedBtcAppKitConfig,
  O3 as getSharedWagmiConfig,
  getSpendableUtxos,
  hasSharedBtcAppKitConfig,
  Q3 as hasSharedWagmiConfig,
  initializeAppKitModal,
  isInscriptionUtxo,
  U3 as isSharedSessionRefusal,
  isUserRejectionMessage,
  setSharedBtcAppKitConfig,
  M3 as setSharedWagmiConfig,
  toInscriptionIdentifiers,
  useAppKitBtcBridge,
  useAppKitOpenListener,
  useBTCWallet,
  useChainConnector,
  useCosmosWallet,
  F3 as useETHWallet,
  L3 as useInscriptionProvider,
  useOrdinals,
  useVisibilityCheck,
  useWalletConnect,
  H3 as useWidgetState,
  verifyUtxoOrdinals
};
//# sourceMappingURL=index.es.js.map
